// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"kekc3":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "kjAGT": "dumpNodeWorklet.87a47a47.js",
    "4bcep": "worklet.2a8e28c3.js",
    "esP4X": "renderer.worker.f2eb17c0.js",
    "eON9s": "worklet.ddf24328.js",
    "jScul": "worklet.40891493.js",
    "h9Jr9": "renderer.worker.67165bf3.js",
    "5HeqG": "worklet.6f34ffd3.js",
    "8WVNl": "worklet.73373d25.js",
    "eB3HU": "renderer.worker.ad8e8355.js",
    "2SinS": "worklet.16293a3d.js",
    "44l9G": "worklet.56de1b8c.js",
    "b6oD5": "worklet.71b0be5b.js",
    "jVeg1": "phase-vocoder.a650ec6a.js",
    "h4nf1": "worklet.506e2af0.js",
    "dFLHh": "worklet.de3e060c.js",
    "23klZ": "renderer.worker.ef0962a0.js",
    "8lZLA": "worklet.e8bf2bf2.js",
    "a5jIg": "worklet.17b76996.js",
    "2pRAu": "worklet.367cb199.js",
    "7MGN4": "worklet.0b76cb7f.js",
    "1sWlm": "worklet.7a5218fb.js",
    "lkEev": "worklet.0cc7ba7b.js",
    "1Ilh0": "worklet.23f6f9f7.js",
    "cszEK": "worklet.444d6a54.js",
    "9Bo6I": "worklet.96f35bd9.js",
    "6fpUT": "triggerWatcher.worklet.e51bcab3.js",
    "ijpL5": "worklet.fe1bf8a0.js",
    "b9iJm": "worklet.b3cd667e.js",
    "5KIib": "worklet.b338d7ea.js",
    "1MqyC": "worklet.464636bf.js",
    "7BVzX": "worklet.9e6dffc2.js",
    "4EoLb": "worklet.debc341d.js",
    "2ZjHG": "worklet.f265978b.js",
    "aKk9y": "worklet.521803da.js",
    "lL0Sa": "worklet.e57050fa.js",
    "7gTmg": "worklet.a6e49904.js",
    "lbS0N": "web-vitals.29698a44.js"
});

},{}],"lAK0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _client = require("react-dom/client");
var _indexCss = require("./index.css");
var _app = require("./App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _reportWebVitals = require("./reportWebVitals");
var _reportWebVitalsDefault = parcelHelpers.interopDefault(_reportWebVitals);
const container = document.getElementById("root");
const root = (0, _client.createRoot)(container);
root.render((0, _jsxRuntime.jsx)((0, _appDefault.default), {}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, _reportWebVitalsDefault.default)();

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","react-dom/client":"epOS1","./index.css":"csxbf","./App":"9weZU","./reportWebVitals":"dbBYK","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"g1NAx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"dPfkO"}],"dPfkO":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"lXMxO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"jRfIo"}],"jRfIo":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray, ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function noop$1() {}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop$1, noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function noop() {}
exports.Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, void 0, void 0, owner, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, void 0, void 0, null, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, createDeps, update) {
    var dispatcher = ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.1.1";

},{}],"epOS1":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"4RuvY"}],"4RuvY":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionLane = 256, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextTransitionLane() {
    var lane = nextTransitionLane;
    nextTransitionLane <<= 1;
    0 === (nextTransitionLane & 4194048) && (nextTransitionLane = 256);
    return lane;
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node) {
    var valueField = isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    node._valueTracker || (node._valueTracker = trackValueOnNode(node));
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$282;
    if (canUseDOM) {
        var isSupported$jscomp$inline_417 = "oninput" in document;
        if (!isSupported$jscomp$inline_417) {
            var element$jscomp$inline_418 = document.createElement("div");
            element$jscomp$inline_418.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_417 = "function" === typeof element$jscomp$inline_418.oninput;
        }
        JSCompiler_inline_result$jscomp$282 = isSupported$jscomp$inline_417;
    } else JSCompiler_inline_result$jscomp$282 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_PROVIDER_TYPE:
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            track(instance);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children), track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            nextHydratableInstance = getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function noop$3() {}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$3, noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$3, noop$3);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter$1 = 0, thenableState$1 = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter$1 = 0;
    thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState$1 = null);
        thenableIndexCounter$1 = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter$1 = localIdCounter = 0;
    thenableState$1 = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    thenable = trackUsedThenable(thenableState$1, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    var create = subscribeToStore.bind(null, fiber, hook, subscribe);
    updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        onActionError(actionQueue, node, error$38);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, createEffectInstance(), actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, createEffectInstance(), create, createDeps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, createDeps) {
    mountEffectImpl(8390656, 8, create, createDeps);
}
function updateEffect(create, createDeps) {
    updateEffectImpl(2048, 8, create, createDeps);
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function noop$2() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop$2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
    dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$41 = enqueueUpdate(provider, fiber, lane);
                null !== root$41 && (scheduleUpdateOnFiber(root$41, provider, lane), entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
}, HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 124) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, createEffectInstance(), updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
}, thenableState = null, thenableIndexCounter = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    return trackUsedThenable(thenableState, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && (shellBoundary = fiber);
        }
    } else reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            if (isHydrating) {
                var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== treeContextProvider ? {
                            id: treeContextId,
                            overflow: treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = showFallback);
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            "$?" === nextInstance.data || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, nextHydratableInstance = getNextHydratable(nextInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = createWorkInProgress(digest, showFallback) : (showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    push(suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                pushProvider(workInProgress, CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError(init);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[internalInstanceKey] = workInProgress, lazyComponent[internalPropsKey] = current, setInitialProperties(lazyComponent, renderLanes, current), markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (lazyComponent = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, init = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = init, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild)) : nextHydratableInstance = init), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if (init = lazyComponent = nextHydratableInstance) lazyComponent = canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(lazyComponent.firstChild), rootOrSingletonContext = !1, init = !0) : init = !1;
                init || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = init);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, lazyComponent.value), reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return prepareToReadContext(workInProgress), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, prevState = createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, init)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), pushProvider(workInProgress, CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, pushProvider(workInProgress, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        resource = suspenseHandlerStackCursor.current;
        if (null !== resource && ((workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null !== shellBoundary : (workInProgressRootRenderLanes & 62914560) !== workInProgressRootRenderLanes && 0 === (workInProgressRootRenderLanes & 536870912) || resource !== shellBoundary)) throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? (markUpdate(workInProgress), null !== renderLanes ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[internalInstanceKey] = workInProgress;
                    current[internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch(setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - type.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = now(), workInProgress.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
    if (null !== ReactSharedInternals.T) {
        var actionScopeLane = currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
    }
    return resolveUpdatePriority();
}
function requestDeferredLane() {
    0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
    var suspenseHandler = suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if (suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: noop
        }, accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState = null, thenableIndexCounter = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : 1) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        handleThrow(root, thrownValue$169);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState = null;
    thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects(wasDelayedCommit) {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects(wasDelayedCommit);
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$174, root$174 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1528 = 0; i$jscomp$inline_1528 < simpleEventPluginEvents.length; i$jscomp$inline_1528++){
    var eventName$jscomp$inline_1529 = simpleEventPluginEvents[i$jscomp$inline_1528], domEventName$jscomp$inline_1530 = eventName$jscomp$inline_1529.toLowerCase(), capitalizedEvent$jscomp$inline_1531 = eventName$jscomp$inline_1529[0].toUpperCase() + eventName$jscomp$inline_1529.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1530, "on" + capitalizedEvent$jscomp$inline_1531);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = getParent(inCapturePhase);
                                reactEventName = getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function noop$1() {}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            track(domElement);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    retryIfBlockedOn(suspenseInstance);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$244 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$244 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, markNodeAsHoistable(instance$250), instance$250;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$250)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var suspendedState = null;
function noop() {}
function suspendResource(hoistableRoot, resource, props) {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function waitForCommitToBeReady() {
    if (null === suspendedState) throw Error(formatProdErrorMessage(475));
    var state = suspendedState;
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = requestUpdateLane();
                            lane = getBumpedLaneForHydrationByLane(lane);
                            var root = enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && scheduleUpdateOnFiber(root, nearestMounted, lane);
                            markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1785 = React.version;
if ("19.1.1" !== isomorphicReactPackageVersion$jscomp$inline_1785) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2257.isDisabled && hook$jscomp$inline_2257.supportsFiber) try {
        rendererID = hook$jscomp$inline_2257.inject(internals$jscomp$inline_2256), injectedHook = hook$jscomp$inline_2257;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.1.1";

},{"934b50a50c275743":"3CLVv","56d30b16d84cc622":"lXMxO","d42dbe4aacaa6df4":"dgecT"}],"3CLVv":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c2333c22ee790411");

},{"c2333c22ee790411":"6InsC"}],"6InsC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"dgecT":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"g0NOB"}],"g0NOB":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.1.1";

},{"6a05e75e64e4f862":"lXMxO"}],"csxbf":[function() {},{}],"9weZU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _editorWrapper = require("./EditorWrapper");
var _editorWrapperDefault = parcelHelpers.interopDefault(_editorWrapper);
var _appCss = require("./App.css");
function App() {
    return (0, _jsxRuntime.jsx)("div", {
        className: "App",
        children: (0, _jsxRuntime.jsx)("main", {
            className: "Editor",
            children: (0, _jsxRuntime.jsx)((0, _editorWrapperDefault.default), {})
        })
    });
}
exports.default = App;

},{"react/jsx-runtime":"g1NAx","./EditorWrapper":"ifO1a","./App.css":"4T9jk","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ifO1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _baseNodes = require("@web-noise/base-nodes");
var _core = require("@web-noise/core");
var _react = require("react");
// import SharePatch from "./SharePatch";
const EditorWrapper = ()=>{
    const [project, setProject] = (0, _react.useState)();
    const [showSharePatch, setShowSharePatch] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const loc = new URL(window.location.href);
        const fileParam = loc.searchParams.get("file");
        if (fileParam) {
            fetch(fileParam).then((res)=>res.json()).then((fileData)=>{
                if (fileData.files && fileData.files.length) return setProject(fileData);
                const newGraphState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _core.EDITOR_DEFAULTS), fileData), {
                    controlPanel: (0, _objectSpread._)({}, (0, _core.EDITOR_DEFAULTS).controlPanel, fileData.controlPanel)
                });
                setProject({
                    // @ts-ignore
                    files: [
                        {
                            file: newGraphState,
                            id: (+new Date()).toString()
                        }
                    ]
                });
            }).catch((e)=>alert(e));
            return;
        }
    }, [
        setProject
    ]);
    const EditorMemoised = (0, _react.useMemo)(()=>(0, _jsxRuntime.jsx)((0, _core.Editor), {
            projectState: project,
            theme: (0, _core.theme),
            plugins: [
                (0, _baseNodes.webNoiseNodes),
                (0, _baseNodes.webAudioNodes),
                (0, _baseNodes.patchNodes),
                (0, _baseNodes.scriptNodes),
                (0, _baseNodes.logicNodes)
            ],
            editorContextMenu: []
        }), [
        project
    ]);
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: EditorMemoised
    });
};
exports.default = EditorWrapper;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/base-nodes":"khKFm","@web-noise/core":"8EHNf","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"awBF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread);
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"k9ryq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k9ryq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_define_property);
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"avJ36":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"8JkCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_spread_props);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"khKFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webAudioNodes", ()=>(0, _webAudioDefault.default));
parcelHelpers.export(exports, "patchNodes", ()=>(0, _patchNodesDefault.default));
parcelHelpers.export(exports, "webNoiseNodes", ()=>(0, _webNoiseDefault.default));
parcelHelpers.export(exports, "scriptNodes", ()=>(0, _scriptNodesDefault.default));
parcelHelpers.export(exports, "logicNodes", ()=>(0, _logicNodesDefault.default));
var _webAudio = require("./src/webAudio");
var _webAudioDefault = parcelHelpers.interopDefault(_webAudio);
var _patchNodes = require("./src/patchNodes");
var _patchNodesDefault = parcelHelpers.interopDefault(_patchNodes);
var _webNoise = require("./src/webNoise");
var _webNoiseDefault = parcelHelpers.interopDefault(_webNoise);
var _scriptNodes = require("./src/scriptNodes");
var _scriptNodesDefault = parcelHelpers.interopDefault(_scriptNodes);
var _logicNodes = require("./src/logicNodes");
var _logicNodesDefault = parcelHelpers.interopDefault(_logicNodes);

},{"./src/webAudio":"f5M0C","./src/patchNodes":"7dEz1","./src/webNoise":"8xLgt","./src/scriptNodes":"7VS6o","./src/logicNodes":"8gjG3","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f5M0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _channelMerger = require("./ChannelMerger");
var _channelMergerDefault = parcelHelpers.interopDefault(_channelMerger);
var _channelSplitter = require("./ChannelSplitter");
var _channelSplitterDefault = parcelHelpers.interopDefault(_channelSplitter);
var _convolver = require("./Convolver");
var _convolverDefault = parcelHelpers.interopDefault(_convolver);
var _delay = require("./Delay");
var _delayDefault = parcelHelpers.interopDefault(_delay);
var _dynamicsCompressor = require("./DynamicsCompressor");
var _dynamicsCompressorDefault = parcelHelpers.interopDefault(_dynamicsCompressor);
var _filter = require("./Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _oscillator = require("./Oscillator");
var _oscillatorDefault = parcelHelpers.interopDefault(_oscillator);
var _parameter = require("./Parameter");
var _parameterDefault = parcelHelpers.interopDefault(_parameter);
var _stereoPanner = require("./StereoPanner");
var _stereoPannerDefault = parcelHelpers.interopDefault(_stereoPanner);
var _waveShaper = require("./WaveShaper");
var _waveShaperDefault = parcelHelpers.interopDefault(_waveShaper);
var _gain = require("./Gain");
var _gainDefault = parcelHelpers.interopDefault(_gain);
var _destination = require("./Destination");
var _destinationDefault = parcelHelpers.interopDefault(_destination);
const webAudioNodes = {
    components: [
        (0, _destinationDefault.default),
        (0, _gainDefault.default),
        (0, _filterDefault.default),
        (0, _parameterDefault.default),
        (0, _oscillatorDefault.default),
        (0, _stereoPannerDefault.default),
        (0, _delayDefault.default),
        (0, _dynamicsCompressorDefault.default),
        (0, _convolverDefault.default),
        (0, _waveShaperDefault.default),
        (0, _channelSplitterDefault.default),
        (0, _channelMergerDefault.default)
    ],
    name: "Web Audio Api nodes",
    description: "Basic nodes provided by the Web Audio API"
};
exports.default = webAudioNodes;

},{"./ChannelMerger":"46ipM","./ChannelSplitter":"5QSxj","./Convolver":"3C54q","./Delay":"5CV3S","./DynamicsCompressor":"2vRBO","./Filter":"jx65b","./Oscillator":"2pwlA","./Parameter":"i9ehl","./StereoPanner":"is85Q","./WaveShaper":"18lxk","./Gain":"6VLMX","./Destination":"fM4fR","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"46ipM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Channel Merger",
    description: `
  A utility node that combines multiple mono audio channels into a single multi-channel stream.

  Essential for creating stereo or surround sound from separate mono sources,
  spatial audio processing, and managing complex channel configurations.
  `,
    info: `
  # Channel Merger

  Combines multiple mono inputs into a single multi-channel output.

  Use it to create stereo or surround sound from separate mono sources.

  ## Usage
  - Connect mono sources to different input channels
  - Each input becomes a separate channel in the output
  - Typically used with Channel Splitter for channel manipulation
  `,
    tags: [
        "merger",
        "channels",
        "stereo",
        "multichannel"
    ],
    portsDescription: {
        inputs: {
            input0: "First channel input (becomes left in stereo)",
            input1: "Second channel input (becomes right in stereo)"
        },
        outputs: {
            output: "Multi-channel output containing all merged inputs"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"1Gg4X","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8EHNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Editor", ()=>(0, _appDefault.default));
parcelHelpers.export(exports, "EDITOR_DEFAULTS", ()=>(0, _app.EDITOR_DEFAULTS));
parcelHelpers.export(exports, "Wire", ()=>(0, _wireDefault.default));
parcelHelpers.export(exports, "WNNode", ()=>(0, _node.WNNode));
parcelHelpers.export(exports, "TitleBar", ()=>(0, _node.TitleBar));
parcelHelpers.export(exports, "PortsPanel", ()=>(0, _node.PortsPanel));
parcelHelpers.export(exports, "OutputPorts", ()=>(0, _node.OutputPorts));
parcelHelpers.export(exports, "OutputHandle", ()=>(0, _node.OutputHandle));
parcelHelpers.export(exports, "InputPorts", ()=>(0, _node.InputPorts));
parcelHelpers.export(exports, "InputHandle", ()=>(0, _node.InputHandle));
parcelHelpers.export(exports, "Port", ()=>(0, _node.Port));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "EditableLabel", ()=>(0, _editableLabelDefault.default));
parcelHelpers.export(exports, "useAudioNode", ()=>(0, _useAudioNodeDefault.default));
parcelHelpers.export(exports, "useNode", ()=>(0, _useNodeDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useStore", ()=>(0, _storeDefault.default));
parcelHelpers.export(exports, "theme", ()=>(0, _themeDefault.default));
parcelHelpers.export(exports, "isAudio", ()=>(0, _projectFile.isAudio));
parcelHelpers.export(exports, "isPatch", ()=>(0, _projectFile.isPatch));
parcelHelpers.export(exports, "PortType", ()=>(0, _constants.PortType));
var _app = require("./src/components/App");
var _appDefault = parcelHelpers.interopDefault(_app);
var _wire = require("./src/components/Wire");
var _wireDefault = parcelHelpers.interopDefault(_wire);
var _node = require("./src/components/Node");
var _modal = require("./src/components/Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _editableLabel = require("./src/components/EditableLabel");
var _editableLabelDefault = parcelHelpers.interopDefault(_editableLabel);
var _useAudioNode = require("./src/hooks/useAudioNode");
var _useAudioNodeDefault = parcelHelpers.interopDefault(_useAudioNode);
var _useNode = require("./src/hooks/useNode");
var _useNodeDefault = parcelHelpers.interopDefault(_useNode);
var _useTheme = require("./src/hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("./src/store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _theme = require("./src/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _projectFile = require("./src/helpers/projectFile");
var _constants = require("./src/constants");

},{"./src/components/App":"kkswA","./src/components/Wire":"dI0TN","./src/components/Node":"hhQgt","./src/components/Modal":"9rT1D","./src/components/EditableLabel":"jH267","./src/hooks/useAudioNode":"wk4N8","./src/hooks/useNode":"7m9CB","./src/hooks/useTheme":"kxvkQ","./src/store":"eveyc","./src/theme":"1PEzg","./src/helpers/projectFile":"5XyWl","./src/constants":"k5UCO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kkswA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EDITOR_DEFAULTS", ()=>EDITOR_DEFAULTS);
parcelHelpers.export(exports, "AppWrapper", ()=>AppWrapper);
parcelHelpers.export(exports, "FileUploadLayout", ()=>FileUploadLayout);
parcelHelpers.export(exports, "EditorContainerWrapper", ()=>EditorContainerWrapper);
parcelHelpers.export(exports, "AudioTabWrapper", ()=>AudioTabWrapper);
parcelHelpers.export(exports, "EditorLoadingOverlay", ()=>EditorLoadingOverlay);
parcelHelpers.export(exports, "EditorContainer", ()=>EditorContainer);
parcelHelpers.export(exports, "TabsContainer", ()=>TabsContainer);
parcelHelpers.export(exports, "Tab", ()=>Tab);
parcelHelpers.export(exports, "TabIconWrapper", ()=>TabIconWrapper);
parcelHelpers.export(exports, "AddFileIcon", ()=>AddFileIcon);
parcelHelpers.export(exports, "CloseIcon", ()=>CloseIcon);
parcelHelpers.export(exports, "App", ()=>App);
var _extends = require("@swc/helpers/_/_extends");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@emotion/react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _nanoid = require("nanoid");
var _react1 = require("react");
var _fa6 = require("react-icons/fa6");
var _md = require("react-icons/md");
var _styleCss = require("reactflow/dist/style.css");
var _fetch = require("@web-noise/fetch");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _styles = require("../styles");
var _theme = require("../theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _editor = require("./Editor");
var _editableLabel = require("./EditableLabel");
var _editableLabelDefault = parcelHelpers.interopDefault(_editableLabel);
var _projectFile = require("../helpers/projectFile");
var _lib = require("../lib");
let _ = (t)=>t, t, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10;
const EDITOR_DEFAULTS = {
    nodes: [],
    edges: [],
    controlPanel: {
        nodes: [],
        show: false,
        size: {
            width: 200,
            height: 100
        }
    },
    viewport: {
        x: 0,
        y: 0,
        zoom: 1.5
    }
};
const AppWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`)));
const FileUploadLayout = (0, _react.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
`)));
const EditorContainerWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t2 || (t2 = _`
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
`)));
const AudioTabWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t3 || (t3 = _`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: ${0};
`), ({ theme })=>theme.colors.elevation3));
const EditorLoadingOverlay = (0, _react.withTheme)((0, _styledDefault.default).div(t4 || (t4 = _`
  background: ${0};
  opacity: 0.7;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  font-family: var(--leva-fonts-mono);
  color: ${0};
  display: ${0};
  align-items: center;
  justify-content: center;
  font-size: 6rem;
`), ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.whitePrimary, ({ show })=>show ? "flex" : "none"));
const EditorContainer = (props)=>{
    const pullEditorChanges = (0, _storeDefault.default)((store)=>store.pullEditorChanges);
    const currentFileIndex = (0, _storeDefault.default)((store)=>store.currentFileIndex);
    const [showLoader, setShowLoader] = (0, _react1.useState)(true);
    (0, _react1.useEffect)(()=>{
        setShowLoader(true);
        setTimeout(()=>{
            setShowLoader(false);
        }, 1600);
    }, [
        currentFileIndex
    ]);
    const { file } = props;
    if (!file) return null;
    if (file.type === "audio") return (0, _jsxRuntime.jsx)(AudioTabWrapper, {
        children: (0, _jsxRuntime.jsx)("audio", {
            src: file.file,
            controls: true
        })
    });
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _editor.Editor), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                onChange: (state)=>{
                    pullEditorChanges();
                },
                editorState: file.file || EDITOR_DEFAULTS
            })),
            (0, _jsxRuntime.jsx)(EditorLoadingOverlay, {
                show: showLoader,
                children: "Loading..."
            })
        ]
    });
};
const TabsContainer = (0, _react.withTheme)((0, _styledDefault.default).div(t5 || (t5 = _`
  height: 2rem;
  display: flex;
  align-items: center;
  background: ${0};
`), ({ theme })=>theme.colors.elevation2));
const Tab = (0, _react.withTheme)((0, _styledDefault.default).div(t6 || (t6 = _`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
  box-sizing: border-box;
  padding: 0.3rem 0.4rem;

  border-right: 1px solid ${0};

  input {
    color: ${0};

    &:not([readonly]):focus {
      background-color: ${0};
    }
  }
`), ({ theme })=>theme.colors.elevation1, ({ theme, active })=>active ? theme.colors.whitePrimary : theme.colors.highlight1, ({ theme })=>theme.colors.elevation1));
const TabIconWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t7 || (t7 = _`
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 0.5rem;
  cursor: pointer;

  color: ${0};
  &:hover {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight1, ({ theme })=>theme.colors.whitePrimary));
const AddFileIcon = (0, _react.withTheme)((0, _styledDefault.default)((0, _fa6.FaPlus))(t8 || (t8 = _`
  height: 40%;
  width: auto;
`)));
const CloseIcon = (0, _react.withTheme)((0, _styledDefault.default)((0, _md.MdClose))(t9 || (t9 = _`
  height: 70%;
  width: auto;
  cursor: pointer;
  color: ${0};
  &:hover {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight1, ({ theme })=>theme.colors.whitePrimary));
const generateId = ()=>{
    return (0, _nanoid.nanoid)();
};
const generateEmptyFile = ()=>({
        file: EDITOR_DEFAULTS,
        name: "Unnamed",
        type: "patch",
        id: generateId()
    });
const App = (_param)=>{
    var props = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
    const { projectState, theme } = props;
    const currentFileIndex = (0, _storeDefault.default)((store)=>store.currentFileIndex);
    const currentFile = (0, _storeDefault.default)((store)=>store.project.files[store.currentFileIndex]);
    const setCurrentFileIndex = (0, _storeDefault.default)((store)=>store.setCurrentFileIndex);
    const project = (0, _storeDefault.default)((store)=>store.project);
    const setProject = (0, _storeDefault.default)((store)=>store.setProject);
    const getProject = (0, _storeDefault.default)((store)=>store.getProject);
    const updateFileName = (0, _storeDefault.default)((store)=>store.updateFileName);
    const addFile = (0, _storeDefault.default)((store)=>store.addFile);
    const deleteFile = (0, _storeDefault.default)((store)=>store.deleteFile);
    const syncEditorWithCurrentFile = (0, _storeDefault.default)((store)=>store.syncEditorWithCurrentFile);
    const setEditorState = (0, _storeDefault.default)((store)=>store.setEditorState);
    const pullEditorChanges = (0, _storeDefault.default)((store)=>store.pullEditorChanges);
    const [isDragging, setIsDragging] = (0, _react1.useState)(false);
    const handleDragLeave = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };
    const handleDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };
    const handleDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
        const files = Array.from(e.dataTransfer.files);
        files.forEach(async (file)=>{
            if (file.type === "application/json") {
                const fileData = JSON.parse(await file.text());
                if (fileData.files && fileData.files.length) {
                    if (!window.confirm("This action will replace your current project. Continue?")) return;
                    setProject(fileData);
                    setCurrentFileIndex(0);
                    syncEditorWithCurrentFile();
                    return;
                }
                const emptyFile = generateEmptyFile();
                const newGraphState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, emptyFile), {
                    file: (0, _objectSpreadProps._)((0, _objectSpread._)({}, fileData), {
                        controlPanel: (0, _objectSpread._)({}, EDITOR_DEFAULTS.controlPanel, fileData.controlPanel)
                    }),
                    name: file.name
                });
                addFile(newGraphState, file.name);
                return;
            }
            if (file.type.match(/^audio\//)) {
                const base64 = await (0, _lib.fileToBase64)(file);
                addFile({
                    type: "audio",
                    // @TODO: use nanoid here
                    id: `audio-file-${+new Date()}`,
                    name: file.name,
                    file: base64
                });
                return;
            }
            console.error("Unsupported file type", file);
        });
    };
    (0, _react1.useEffect)(()=>{
        setProject(projectState || {
            files: [
                generateEmptyFile()
            ]
        });
        const file = projectState === null || projectState === void 0 ? void 0 : projectState.files[0];
        (file === null || file === void 0 ? void 0 : file.file) && (file === null || file === void 0 ? void 0 : file.type) !== "audio" && setEditorState(file.file);
    }, [
        projectState
    ]);
    // EXPERIMENTAL CODE
    (0, _react1.useEffect)(()=>{
        const fetcher = async (...args)=>{
            const request = new Request(...args);
            const files = getProject().files;
            const index = request.url.replace("project://", "");
            const file = files.find(({ id })=>id === index);
            if (!file) return new Response(`File not found: ${request.url}`, {
                status: 404
            });
            var _file_file;
            if ((0, _projectFile.isPatch)(file)) return new Response(JSON.stringify((_file_file = file.file) !== null && _file_file !== void 0 ? _file_file : null));
            if ((0, _projectFile.isAudio)(file)) return fetch(file.file);
            return new Response(null);
        };
        (0, _fetch.registerFetcher)("project://*", fetcher);
        return ()=>{
        //unregister here
        };
    }, [
        getProject
    ]);
    (0, _react1.useEffect)(()=>{
        syncEditorWithCurrentFile();
    }, [
        currentFileIndex,
        syncEditorWithCurrentFile
    ]);
    return (0, _jsxRuntime.jsxs)((0, _react.ThemeProvider), {
        theme: theme || (0, _themeDefault.default),
        children: [
            (0, _jsxRuntime.jsx)((0, _react.Global), {
                styles: (0, _react.css)(t10 || (t10 = _`
          :root {
            --leva-colors-elevation1: #292d39;
            --leva-colors-elevation2: #181c20;
            --leva-colors-elevation3: #373c4b;
            --leva-colors-accent1: #0066dc;
            --leva-colors-accent2: #007bff;
            --leva-colors-accent3: #3c93ff;
            --leva-colors-highlight1: #535760;
            --leva-colors-highlight2: #8c92a4;
            --leva-colors-highlight3: #fefefe;
            --leva-colors-vivid1: #ffcc00;
            --leva-colors-folderWidgetColor: var(--leva-colors-highlight2);
            --leva-colors-folderTextColor: var(--leva-colors-highlight3);
            --leva-colors-toolTipBackground: var(--leva-colors-highlight3);
            --leva-colors-toolTipText: var(--leva-colors-elevation2);
            --leva-radii-xs: 2px;
            --leva-radii-sm: 3px;
            --leva-radii-lg: 10px;
            --leva-space-xs: 3px;
            --leva-space-sm: 6px;
            --leva-space-md: 10px;
            --leva-space-rowGap: 7px;
            --leva-space-colGap: 7px;
            --leva-fonts-mono:
              ui-monospace, SFMono-Regular, Menlo, "Roboto Mono", monospace;
            --leva-fonts-sans: system-ui, sans-serif;
            --leva-fontSizes-root: 11px;
            --leva-fontSizes-toolTip: var(--leva-fontSizes-root);
            --leva-sizes-rootWidth: 280px;
            --leva-sizes-controlWidth: 160px;
            --leva-sizes-numberInputMinWidth: 38px;
            --leva-sizes-scrubberWidth: 8px;
            --leva-sizes-scrubberHeight: 16px;
            --leva-sizes-rowHeight: 24px;
            --leva-sizes-folderTitleHeight: 20px;
            --leva-sizes-checkboxSize: 16px;
            --leva-sizes-joystickWidth: 100px;
            --leva-sizes-joystickHeight: 100px;
            --leva-sizes-colorPickerWidth: var(--leva-sizes-controlWidth);
            --leva-sizes-colorPickerHeight: 100px;
            --leva-sizes-imagePreviewWidth: var(--leva-sizes-controlWidth);
            --leva-sizes-imagePreviewHeight: 100px;
            --leva-sizes-monitorHeight: 60px;
            --leva-sizes-titleBarHeight: 39px;
            --leva-shadows-level1: 0 0 9px 0 #00000088;
            --leva-shadows-level2: 0 4px 14px #00000033;
            --leva-borderWidths-root: 0px;
            --leva-borderWidths-input: 1px;
            --leva-borderWidths-focus: 1px;
            --leva-borderWidths-hover: 1px;
            --leva-borderWidths-active: 1px;
            --leva-borderWidths-folder: 1px;
            --leva-fontWeights-label: normal;
            --leva-fontWeights-folder: normal;
            --leva-fontWeights-button: normal;
          }
        `))
            }),
            (0, _jsxRuntime.jsxs)(AppWrapper, {
                onDragOver: handleDragOver,
                onDragLeave: handleDragLeave,
                onDrop: handleDrop,
                children: [
                    (0, _jsxRuntime.jsxs)(TabsContainer, {
                        children: [
                            project.files.map((file, index)=>(0, _jsxRuntime.jsxs)(Tab, {
                                    onClick: ()=>{
                                        setCurrentFileIndex(index);
                                    },
                                    active: index === currentFileIndex,
                                    children: [
                                        (0, _jsxRuntime.jsx)((0, _editableLabelDefault.default), {
                                            onChange: (val)=>updateFileName(index, val),
                                            value: file.name || "Unnamed"
                                        }),
                                        (0, _jsxRuntime.jsx)(CloseIcon, {
                                            onClick: (event)=>{
                                                event.stopPropagation();
                                                if (!window.confirm("Do you really want to delete this file?")) return;
                                                deleteFile(index);
                                            }
                                        })
                                    ]
                                }, index)),
                            (0, _jsxRuntime.jsx)(TabIconWrapper, {
                                onClick: ()=>{
                                    addFile(generateEmptyFile());
                                    setCurrentFileIndex(project.files.length);
                                },
                                children: (0, _jsxRuntime.jsx)(AddFileIcon, {})
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)(EditorContainerWrapper, {
                        children: (0, _jsxRuntime.jsx)(EditorContainer, (0, _objectSpread._)({
                            file: currentFile
                        }, props))
                    }),
                    isDragging && (0, _jsxRuntime.jsx)(FileUploadLayout, {
                        children: "Drop file(s) to upload to the project"
                    })
                ]
            })
        ]
    });
};
exports.default = App;

},{"@swc/helpers/_/_extends":"7g5cA","@swc/helpers/_/_object_destructuring_empty":"40DPb","@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/react":"ifT37","@emotion/styled":"2Zr0D","nanoid":"ftaBX","react":"lXMxO","react-icons/fa6":"cNHJW","react-icons/md":"ixP1W","reactflow/dist/style.css":"3T38Z","@web-noise/fetch":"aRn3r","../store":"eveyc","../styles":"kNWlF","../theme":"1PEzg","./Editor":"CLdHS","./EditableLabel":"jH267","../helpers/projectFile":"5XyWl","../lib":"j33ba","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7g5cA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_extends);
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"40DPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_destructuring_empty);
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ifT37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementD59E098FEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementD59E098FEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementD59E098FEsmJs.b));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementD59E098FEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementD59E098FEsmJs.d));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementD59E098FEsmJs = require("./emotion-element-d59e098f.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, _emotionElementD59E098FEsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementD59E098FEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementD59E098FEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})(jsx || (jsx = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementD59E098FEsmJs.T)));
    if (!(0, _emotionElementD59E098FEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, _utils.insertStyles)(cache, serializedArr[i], false);
            if (!(0, _emotionElementD59E098FEsmJs.i) && res !== undefined) rules += res;
        }
        if (!(0, _emotionElementD59E098FEsmJs.i)) return rules;
    });
    if (!(0, _emotionElementD59E098FEsmJs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementD59E098FEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"./emotion-element-d59e098f.esm.js":"lTMlh","react":"lXMxO","@emotion/utils":"gQqrm","@emotion/use-insertion-effect-with-fallbacks":"6ziAw","@emotion/serialize":"2Hw4L","@emotion/cache":"eMGpJ","@babel/runtime/helpers/extends":"ibVpB","@emotion/weak-memoize":"9o28W","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"j9BjW","hoist-non-react-statics":"lKlf6","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lTMlh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>isDevelopment);
parcelHelpers.export(exports, "b", ()=>ThemeProvider);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "d", ()=>withTheme);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _emotionReactIsolatedHnrsEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ _react.forwardRef(function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if (hasOwn.call(props, _key)) newProps[_key] = props[_key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"lXMxO","@emotion/cache":"eMGpJ","@babel/runtime/helpers/esm/extends":"9dRPo","@emotion/weak-memoize":"9o28W","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"j9BjW","@emotion/utils":"gQqrm","@emotion/serialize":"2Hw4L","@emotion/use-insertion-effect-with-fallbacks":"6ziAw","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eMGpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isBrowser = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var getServerStylisCache = isBrowser ? undefined : (0, _weakMemoizeDefault.default)(function() {
    return (0, _memoizeDefault.default)(function() {
        return {};
    });
});
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    if (!getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, _stylis.stringify),
            (0, _stylis.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, _stylis.stringify)
        ];
        var _serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis1 = function _stylis1(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), _serializer);
        };
        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"2kabm","stylis":"lBEHY","@emotion/weak-memoize":"9o28W","@emotion/memoize":"k1VB7","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2kabm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lBEHY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9o28W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k1VB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9dRPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j9BjW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"lKlf6","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lKlf6":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"5eHwl"}],"5eHwl":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("569f914be4368a39");

},{"569f914be4368a39":"7j0ah"}],"7j0ah":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"gQqrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2Hw4L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"2GVN0","@emotion/unitless":"dvgAD","@emotion/memoize":"k1VB7","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2GVN0":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dvgAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6ziAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var isBrowser = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ibVpB":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2Zr0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styled);
var _emotionStyledBaseEsmJs = require("../base/dist/emotion-styled-base.esm.js");
var _emotionStyledBaseEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var styled = (0, _emotionStyledBaseEsmJsDefault.default).bind(null);
tags.forEach(function(tagName) {
    styled[tagName] = styled(tagName);
});

},{"../base/dist/emotion-styled-base.esm.js":"cdhF4","@babel/runtime/helpers/extends":"ibVpB","@emotion/react":"ifT37","@emotion/serialize":"2Hw4L","@emotion/use-insertion-effect-with-fallbacks":"6ziAw","@emotion/utils":"gQqrm","react":"lXMxO","@emotion/is-prop-valid":"6xPXF","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cdhF4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var isBrowser = typeof document !== 'undefined';
var isDevelopment = false;
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, _react.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react1.useContext((0, _react.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ _react1.createElement(_react1.Fragment, null, /*#__PURE__*/ _react1.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ _react1.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"9dRPo","@emotion/react":"ifT37","@emotion/serialize":"2Hw4L","@emotion/use-insertion-effect-with-fallbacks":"6ziAw","@emotion/utils":"gQqrm","react":"lXMxO","@emotion/is-prop-valid":"6xPXF","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6xPXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"k1VB7","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ftaBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "customAlphabet", ()=>customAlphabet);
parcelHelpers.export(exports, "customRandom", ()=>customRandom);
parcelHelpers.export(exports, "urlAlphabet", ()=>(0, _indexJs.urlAlphabet));
parcelHelpers.export(exports, "random", ()=>random);
var _indexJs = require("./url-alphabet/index.js");
let random = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let customRandom = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let customAlphabet = (alphabet, size = 21)=>customRandom(alphabet, size, random);
let nanoid = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');

},{"./url-alphabet/index.js":"8B0qJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8B0qJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "urlAlphabet", ()=>urlAlphabet);
let urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cNHJW":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fa42Group", ()=>Fa42Group);
parcelHelpers.export(exports, "Fa500Px", ()=>Fa500Px);
parcelHelpers.export(exports, "FaAccessibleIcon", ()=>FaAccessibleIcon);
parcelHelpers.export(exports, "FaAccusoft", ()=>FaAccusoft);
parcelHelpers.export(exports, "FaAdn", ()=>FaAdn);
parcelHelpers.export(exports, "FaAdversal", ()=>FaAdversal);
parcelHelpers.export(exports, "FaAffiliatetheme", ()=>FaAffiliatetheme);
parcelHelpers.export(exports, "FaAirbnb", ()=>FaAirbnb);
parcelHelpers.export(exports, "FaAlgolia", ()=>FaAlgolia);
parcelHelpers.export(exports, "FaAlipay", ()=>FaAlipay);
parcelHelpers.export(exports, "FaAmazonPay", ()=>FaAmazonPay);
parcelHelpers.export(exports, "FaAmazon", ()=>FaAmazon);
parcelHelpers.export(exports, "FaAmilia", ()=>FaAmilia);
parcelHelpers.export(exports, "FaAndroid", ()=>FaAndroid);
parcelHelpers.export(exports, "FaAngellist", ()=>FaAngellist);
parcelHelpers.export(exports, "FaAngrycreative", ()=>FaAngrycreative);
parcelHelpers.export(exports, "FaAngular", ()=>FaAngular);
parcelHelpers.export(exports, "FaAppStoreIos", ()=>FaAppStoreIos);
parcelHelpers.export(exports, "FaAppStore", ()=>FaAppStore);
parcelHelpers.export(exports, "FaApper", ()=>FaApper);
parcelHelpers.export(exports, "FaApplePay", ()=>FaApplePay);
parcelHelpers.export(exports, "FaApple", ()=>FaApple);
parcelHelpers.export(exports, "FaArtstation", ()=>FaArtstation);
parcelHelpers.export(exports, "FaAsymmetrik", ()=>FaAsymmetrik);
parcelHelpers.export(exports, "FaAtlassian", ()=>FaAtlassian);
parcelHelpers.export(exports, "FaAudible", ()=>FaAudible);
parcelHelpers.export(exports, "FaAutoprefixer", ()=>FaAutoprefixer);
parcelHelpers.export(exports, "FaAvianex", ()=>FaAvianex);
parcelHelpers.export(exports, "FaAviato", ()=>FaAviato);
parcelHelpers.export(exports, "FaAws", ()=>FaAws);
parcelHelpers.export(exports, "FaBandcamp", ()=>FaBandcamp);
parcelHelpers.export(exports, "FaBattleNet", ()=>FaBattleNet);
parcelHelpers.export(exports, "FaBehance", ()=>FaBehance);
parcelHelpers.export(exports, "FaBilibili", ()=>FaBilibili);
parcelHelpers.export(exports, "FaBimobject", ()=>FaBimobject);
parcelHelpers.export(exports, "FaBitbucket", ()=>FaBitbucket);
parcelHelpers.export(exports, "FaBitcoin", ()=>FaBitcoin);
parcelHelpers.export(exports, "FaBity", ()=>FaBity);
parcelHelpers.export(exports, "FaBlackTie", ()=>FaBlackTie);
parcelHelpers.export(exports, "FaBlackberry", ()=>FaBlackberry);
parcelHelpers.export(exports, "FaBloggerB", ()=>FaBloggerB);
parcelHelpers.export(exports, "FaBlogger", ()=>FaBlogger);
parcelHelpers.export(exports, "FaBluetoothB", ()=>FaBluetoothB);
parcelHelpers.export(exports, "FaBluetooth", ()=>FaBluetooth);
parcelHelpers.export(exports, "FaBootstrap", ()=>FaBootstrap);
parcelHelpers.export(exports, "FaBots", ()=>FaBots);
parcelHelpers.export(exports, "FaBtc", ()=>FaBtc);
parcelHelpers.export(exports, "FaBuffer", ()=>FaBuffer);
parcelHelpers.export(exports, "FaBuromobelexperte", ()=>FaBuromobelexperte);
parcelHelpers.export(exports, "FaBuyNLarge", ()=>FaBuyNLarge);
parcelHelpers.export(exports, "FaBuysellads", ()=>FaBuysellads);
parcelHelpers.export(exports, "FaCanadianMapleLeaf", ()=>FaCanadianMapleLeaf);
parcelHelpers.export(exports, "FaCcAmazonPay", ()=>FaCcAmazonPay);
parcelHelpers.export(exports, "FaCcAmex", ()=>FaCcAmex);
parcelHelpers.export(exports, "FaCcApplePay", ()=>FaCcApplePay);
parcelHelpers.export(exports, "FaCcDinersClub", ()=>FaCcDinersClub);
parcelHelpers.export(exports, "FaCcDiscover", ()=>FaCcDiscover);
parcelHelpers.export(exports, "FaCcJcb", ()=>FaCcJcb);
parcelHelpers.export(exports, "FaCcMastercard", ()=>FaCcMastercard);
parcelHelpers.export(exports, "FaCcPaypal", ()=>FaCcPaypal);
parcelHelpers.export(exports, "FaCcStripe", ()=>FaCcStripe);
parcelHelpers.export(exports, "FaCcVisa", ()=>FaCcVisa);
parcelHelpers.export(exports, "FaCentercode", ()=>FaCentercode);
parcelHelpers.export(exports, "FaCentos", ()=>FaCentos);
parcelHelpers.export(exports, "FaChrome", ()=>FaChrome);
parcelHelpers.export(exports, "FaChromecast", ()=>FaChromecast);
parcelHelpers.export(exports, "FaCloudflare", ()=>FaCloudflare);
parcelHelpers.export(exports, "FaCloudscale", ()=>FaCloudscale);
parcelHelpers.export(exports, "FaCloudsmith", ()=>FaCloudsmith);
parcelHelpers.export(exports, "FaCloudversify", ()=>FaCloudversify);
parcelHelpers.export(exports, "FaCmplid", ()=>FaCmplid);
parcelHelpers.export(exports, "FaCodepen", ()=>FaCodepen);
parcelHelpers.export(exports, "FaCodiepie", ()=>FaCodiepie);
parcelHelpers.export(exports, "FaConfluence", ()=>FaConfluence);
parcelHelpers.export(exports, "FaConnectdevelop", ()=>FaConnectdevelop);
parcelHelpers.export(exports, "FaContao", ()=>FaContao);
parcelHelpers.export(exports, "FaCottonBureau", ()=>FaCottonBureau);
parcelHelpers.export(exports, "FaCpanel", ()=>FaCpanel);
parcelHelpers.export(exports, "FaCreativeCommonsBy", ()=>FaCreativeCommonsBy);
parcelHelpers.export(exports, "FaCreativeCommonsNcEu", ()=>FaCreativeCommonsNcEu);
parcelHelpers.export(exports, "FaCreativeCommonsNcJp", ()=>FaCreativeCommonsNcJp);
parcelHelpers.export(exports, "FaCreativeCommonsNc", ()=>FaCreativeCommonsNc);
parcelHelpers.export(exports, "FaCreativeCommonsNd", ()=>FaCreativeCommonsNd);
parcelHelpers.export(exports, "FaCreativeCommonsPdAlt", ()=>FaCreativeCommonsPdAlt);
parcelHelpers.export(exports, "FaCreativeCommonsPd", ()=>FaCreativeCommonsPd);
parcelHelpers.export(exports, "FaCreativeCommonsRemix", ()=>FaCreativeCommonsRemix);
parcelHelpers.export(exports, "FaCreativeCommonsSa", ()=>FaCreativeCommonsSa);
parcelHelpers.export(exports, "FaCreativeCommonsSamplingPlus", ()=>FaCreativeCommonsSamplingPlus);
parcelHelpers.export(exports, "FaCreativeCommonsSampling", ()=>FaCreativeCommonsSampling);
parcelHelpers.export(exports, "FaCreativeCommonsShare", ()=>FaCreativeCommonsShare);
parcelHelpers.export(exports, "FaCreativeCommonsZero", ()=>FaCreativeCommonsZero);
parcelHelpers.export(exports, "FaCreativeCommons", ()=>FaCreativeCommons);
parcelHelpers.export(exports, "FaCriticalRole", ()=>FaCriticalRole);
parcelHelpers.export(exports, "FaCss3Alt", ()=>FaCss3Alt);
parcelHelpers.export(exports, "FaCss3", ()=>FaCss3);
parcelHelpers.export(exports, "FaCuttlefish", ()=>FaCuttlefish);
parcelHelpers.export(exports, "FaDAndDBeyond", ()=>FaDAndDBeyond);
parcelHelpers.export(exports, "FaDAndD", ()=>FaDAndD);
parcelHelpers.export(exports, "FaDailymotion", ()=>FaDailymotion);
parcelHelpers.export(exports, "FaDashcube", ()=>FaDashcube);
parcelHelpers.export(exports, "FaDebian", ()=>FaDebian);
parcelHelpers.export(exports, "FaDeezer", ()=>FaDeezer);
parcelHelpers.export(exports, "FaDelicious", ()=>FaDelicious);
parcelHelpers.export(exports, "FaDeploydog", ()=>FaDeploydog);
parcelHelpers.export(exports, "FaDeskpro", ()=>FaDeskpro);
parcelHelpers.export(exports, "FaDev", ()=>FaDev);
parcelHelpers.export(exports, "FaDeviantart", ()=>FaDeviantart);
parcelHelpers.export(exports, "FaDhl", ()=>FaDhl);
parcelHelpers.export(exports, "FaDiaspora", ()=>FaDiaspora);
parcelHelpers.export(exports, "FaDigg", ()=>FaDigg);
parcelHelpers.export(exports, "FaDigitalOcean", ()=>FaDigitalOcean);
parcelHelpers.export(exports, "FaDiscord", ()=>FaDiscord);
parcelHelpers.export(exports, "FaDiscourse", ()=>FaDiscourse);
parcelHelpers.export(exports, "FaDochub", ()=>FaDochub);
parcelHelpers.export(exports, "FaDocker", ()=>FaDocker);
parcelHelpers.export(exports, "FaDraft2Digital", ()=>FaDraft2Digital);
parcelHelpers.export(exports, "FaDribbble", ()=>FaDribbble);
parcelHelpers.export(exports, "FaDropbox", ()=>FaDropbox);
parcelHelpers.export(exports, "FaDrupal", ()=>FaDrupal);
parcelHelpers.export(exports, "FaDyalog", ()=>FaDyalog);
parcelHelpers.export(exports, "FaEarlybirds", ()=>FaEarlybirds);
parcelHelpers.export(exports, "FaEbay", ()=>FaEbay);
parcelHelpers.export(exports, "FaEdgeLegacy", ()=>FaEdgeLegacy);
parcelHelpers.export(exports, "FaEdge", ()=>FaEdge);
parcelHelpers.export(exports, "FaElementor", ()=>FaElementor);
parcelHelpers.export(exports, "FaEllo", ()=>FaEllo);
parcelHelpers.export(exports, "FaEmber", ()=>FaEmber);
parcelHelpers.export(exports, "FaEmpire", ()=>FaEmpire);
parcelHelpers.export(exports, "FaEnvira", ()=>FaEnvira);
parcelHelpers.export(exports, "FaErlang", ()=>FaErlang);
parcelHelpers.export(exports, "FaEthereum", ()=>FaEthereum);
parcelHelpers.export(exports, "FaEtsy", ()=>FaEtsy);
parcelHelpers.export(exports, "FaEvernote", ()=>FaEvernote);
parcelHelpers.export(exports, "FaExpeditedssl", ()=>FaExpeditedssl);
parcelHelpers.export(exports, "FaFacebookF", ()=>FaFacebookF);
parcelHelpers.export(exports, "FaFacebookMessenger", ()=>FaFacebookMessenger);
parcelHelpers.export(exports, "FaFacebook", ()=>FaFacebook);
parcelHelpers.export(exports, "FaFantasyFlightGames", ()=>FaFantasyFlightGames);
parcelHelpers.export(exports, "FaFedex", ()=>FaFedex);
parcelHelpers.export(exports, "FaFedora", ()=>FaFedora);
parcelHelpers.export(exports, "FaFigma", ()=>FaFigma);
parcelHelpers.export(exports, "FaFirefoxBrowser", ()=>FaFirefoxBrowser);
parcelHelpers.export(exports, "FaFirefox", ()=>FaFirefox);
parcelHelpers.export(exports, "FaFirstOrderAlt", ()=>FaFirstOrderAlt);
parcelHelpers.export(exports, "FaFirstOrder", ()=>FaFirstOrder);
parcelHelpers.export(exports, "FaFirstdraft", ()=>FaFirstdraft);
parcelHelpers.export(exports, "FaFlickr", ()=>FaFlickr);
parcelHelpers.export(exports, "FaFlipboard", ()=>FaFlipboard);
parcelHelpers.export(exports, "FaFly", ()=>FaFly);
parcelHelpers.export(exports, "FaFontAwesome", ()=>FaFontAwesome);
parcelHelpers.export(exports, "FaFonticonsFi", ()=>FaFonticonsFi);
parcelHelpers.export(exports, "FaFonticons", ()=>FaFonticons);
parcelHelpers.export(exports, "FaFortAwesomeAlt", ()=>FaFortAwesomeAlt);
parcelHelpers.export(exports, "FaFortAwesome", ()=>FaFortAwesome);
parcelHelpers.export(exports, "FaForumbee", ()=>FaForumbee);
parcelHelpers.export(exports, "FaFoursquare", ()=>FaFoursquare);
parcelHelpers.export(exports, "FaFreeCodeCamp", ()=>FaFreeCodeCamp);
parcelHelpers.export(exports, "FaFreebsd", ()=>FaFreebsd);
parcelHelpers.export(exports, "FaFulcrum", ()=>FaFulcrum);
parcelHelpers.export(exports, "FaGalacticRepublic", ()=>FaGalacticRepublic);
parcelHelpers.export(exports, "FaGalacticSenate", ()=>FaGalacticSenate);
parcelHelpers.export(exports, "FaGetPocket", ()=>FaGetPocket);
parcelHelpers.export(exports, "FaGgCircle", ()=>FaGgCircle);
parcelHelpers.export(exports, "FaGg", ()=>FaGg);
parcelHelpers.export(exports, "FaGitAlt", ()=>FaGitAlt);
parcelHelpers.export(exports, "FaGit", ()=>FaGit);
parcelHelpers.export(exports, "FaGithubAlt", ()=>FaGithubAlt);
parcelHelpers.export(exports, "FaGithub", ()=>FaGithub);
parcelHelpers.export(exports, "FaGitkraken", ()=>FaGitkraken);
parcelHelpers.export(exports, "FaGitlab", ()=>FaGitlab);
parcelHelpers.export(exports, "FaGitter", ()=>FaGitter);
parcelHelpers.export(exports, "FaGlideG", ()=>FaGlideG);
parcelHelpers.export(exports, "FaGlide", ()=>FaGlide);
parcelHelpers.export(exports, "FaGofore", ()=>FaGofore);
parcelHelpers.export(exports, "FaGolang", ()=>FaGolang);
parcelHelpers.export(exports, "FaGoodreadsG", ()=>FaGoodreadsG);
parcelHelpers.export(exports, "FaGoodreads", ()=>FaGoodreads);
parcelHelpers.export(exports, "FaGoogleDrive", ()=>FaGoogleDrive);
parcelHelpers.export(exports, "FaGooglePay", ()=>FaGooglePay);
parcelHelpers.export(exports, "FaGooglePlay", ()=>FaGooglePlay);
parcelHelpers.export(exports, "FaGooglePlusG", ()=>FaGooglePlusG);
parcelHelpers.export(exports, "FaGooglePlus", ()=>FaGooglePlus);
parcelHelpers.export(exports, "FaGoogleWallet", ()=>FaGoogleWallet);
parcelHelpers.export(exports, "FaGoogle", ()=>FaGoogle);
parcelHelpers.export(exports, "FaGratipay", ()=>FaGratipay);
parcelHelpers.export(exports, "FaGrav", ()=>FaGrav);
parcelHelpers.export(exports, "FaGripfire", ()=>FaGripfire);
parcelHelpers.export(exports, "FaGrunt", ()=>FaGrunt);
parcelHelpers.export(exports, "FaGuilded", ()=>FaGuilded);
parcelHelpers.export(exports, "FaGulp", ()=>FaGulp);
parcelHelpers.export(exports, "FaHackerNews", ()=>FaHackerNews);
parcelHelpers.export(exports, "FaHackerrank", ()=>FaHackerrank);
parcelHelpers.export(exports, "FaHashnode", ()=>FaHashnode);
parcelHelpers.export(exports, "FaHips", ()=>FaHips);
parcelHelpers.export(exports, "FaHireAHelper", ()=>FaHireAHelper);
parcelHelpers.export(exports, "FaHive", ()=>FaHive);
parcelHelpers.export(exports, "FaHooli", ()=>FaHooli);
parcelHelpers.export(exports, "FaHornbill", ()=>FaHornbill);
parcelHelpers.export(exports, "FaHotjar", ()=>FaHotjar);
parcelHelpers.export(exports, "FaHouzz", ()=>FaHouzz);
parcelHelpers.export(exports, "FaHtml5", ()=>FaHtml5);
parcelHelpers.export(exports, "FaHubspot", ()=>FaHubspot);
parcelHelpers.export(exports, "FaIdeal", ()=>FaIdeal);
parcelHelpers.export(exports, "FaImdb", ()=>FaImdb);
parcelHelpers.export(exports, "FaInstagram", ()=>FaInstagram);
parcelHelpers.export(exports, "FaInstalod", ()=>FaInstalod);
parcelHelpers.export(exports, "FaIntercom", ()=>FaIntercom);
parcelHelpers.export(exports, "FaInternetExplorer", ()=>FaInternetExplorer);
parcelHelpers.export(exports, "FaInvision", ()=>FaInvision);
parcelHelpers.export(exports, "FaIoxhost", ()=>FaIoxhost);
parcelHelpers.export(exports, "FaItchIo", ()=>FaItchIo);
parcelHelpers.export(exports, "FaItunesNote", ()=>FaItunesNote);
parcelHelpers.export(exports, "FaItunes", ()=>FaItunes);
parcelHelpers.export(exports, "FaJava", ()=>FaJava);
parcelHelpers.export(exports, "FaJediOrder", ()=>FaJediOrder);
parcelHelpers.export(exports, "FaJenkins", ()=>FaJenkins);
parcelHelpers.export(exports, "FaJira", ()=>FaJira);
parcelHelpers.export(exports, "FaJoget", ()=>FaJoget);
parcelHelpers.export(exports, "FaJoomla", ()=>FaJoomla);
parcelHelpers.export(exports, "FaJs", ()=>FaJs);
parcelHelpers.export(exports, "FaJsfiddle", ()=>FaJsfiddle);
parcelHelpers.export(exports, "FaKaggle", ()=>FaKaggle);
parcelHelpers.export(exports, "FaKeybase", ()=>FaKeybase);
parcelHelpers.export(exports, "FaKeycdn", ()=>FaKeycdn);
parcelHelpers.export(exports, "FaKickstarterK", ()=>FaKickstarterK);
parcelHelpers.export(exports, "FaKickstarter", ()=>FaKickstarter);
parcelHelpers.export(exports, "FaKorvue", ()=>FaKorvue);
parcelHelpers.export(exports, "FaLaravel", ()=>FaLaravel);
parcelHelpers.export(exports, "FaLastfm", ()=>FaLastfm);
parcelHelpers.export(exports, "FaLeanpub", ()=>FaLeanpub);
parcelHelpers.export(exports, "FaLess", ()=>FaLess);
parcelHelpers.export(exports, "FaLine", ()=>FaLine);
parcelHelpers.export(exports, "FaLinkedinIn", ()=>FaLinkedinIn);
parcelHelpers.export(exports, "FaLinkedin", ()=>FaLinkedin);
parcelHelpers.export(exports, "FaLinode", ()=>FaLinode);
parcelHelpers.export(exports, "FaLinux", ()=>FaLinux);
parcelHelpers.export(exports, "FaLyft", ()=>FaLyft);
parcelHelpers.export(exports, "FaMagento", ()=>FaMagento);
parcelHelpers.export(exports, "FaMailchimp", ()=>FaMailchimp);
parcelHelpers.export(exports, "FaMandalorian", ()=>FaMandalorian);
parcelHelpers.export(exports, "FaMarkdown", ()=>FaMarkdown);
parcelHelpers.export(exports, "FaMastodon", ()=>FaMastodon);
parcelHelpers.export(exports, "FaMaxcdn", ()=>FaMaxcdn);
parcelHelpers.export(exports, "FaMdb", ()=>FaMdb);
parcelHelpers.export(exports, "FaMedapps", ()=>FaMedapps);
parcelHelpers.export(exports, "FaMedium", ()=>FaMedium);
parcelHelpers.export(exports, "FaMedrt", ()=>FaMedrt);
parcelHelpers.export(exports, "FaMeetup", ()=>FaMeetup);
parcelHelpers.export(exports, "FaMegaport", ()=>FaMegaport);
parcelHelpers.export(exports, "FaMendeley", ()=>FaMendeley);
parcelHelpers.export(exports, "FaMeta", ()=>FaMeta);
parcelHelpers.export(exports, "FaMicroblog", ()=>FaMicroblog);
parcelHelpers.export(exports, "FaMicrosoft", ()=>FaMicrosoft);
parcelHelpers.export(exports, "FaMix", ()=>FaMix);
parcelHelpers.export(exports, "FaMixcloud", ()=>FaMixcloud);
parcelHelpers.export(exports, "FaMixer", ()=>FaMixer);
parcelHelpers.export(exports, "FaMizuni", ()=>FaMizuni);
parcelHelpers.export(exports, "FaModx", ()=>FaModx);
parcelHelpers.export(exports, "FaMonero", ()=>FaMonero);
parcelHelpers.export(exports, "FaNapster", ()=>FaNapster);
parcelHelpers.export(exports, "FaNeos", ()=>FaNeos);
parcelHelpers.export(exports, "FaNfcDirectional", ()=>FaNfcDirectional);
parcelHelpers.export(exports, "FaNfcSymbol", ()=>FaNfcSymbol);
parcelHelpers.export(exports, "FaNimblr", ()=>FaNimblr);
parcelHelpers.export(exports, "FaNodeJs", ()=>FaNodeJs);
parcelHelpers.export(exports, "FaNode", ()=>FaNode);
parcelHelpers.export(exports, "FaNpm", ()=>FaNpm);
parcelHelpers.export(exports, "FaNs8", ()=>FaNs8);
parcelHelpers.export(exports, "FaNutritionix", ()=>FaNutritionix);
parcelHelpers.export(exports, "FaOctopusDeploy", ()=>FaOctopusDeploy);
parcelHelpers.export(exports, "FaOdnoklassniki", ()=>FaOdnoklassniki);
parcelHelpers.export(exports, "FaOdysee", ()=>FaOdysee);
parcelHelpers.export(exports, "FaOldRepublic", ()=>FaOldRepublic);
parcelHelpers.export(exports, "FaOpencart", ()=>FaOpencart);
parcelHelpers.export(exports, "FaOpenid", ()=>FaOpenid);
parcelHelpers.export(exports, "FaOpera", ()=>FaOpera);
parcelHelpers.export(exports, "FaOptinMonster", ()=>FaOptinMonster);
parcelHelpers.export(exports, "FaOrcid", ()=>FaOrcid);
parcelHelpers.export(exports, "FaOsi", ()=>FaOsi);
parcelHelpers.export(exports, "FaPadlet", ()=>FaPadlet);
parcelHelpers.export(exports, "FaPage4", ()=>FaPage4);
parcelHelpers.export(exports, "FaPagelines", ()=>FaPagelines);
parcelHelpers.export(exports, "FaPalfed", ()=>FaPalfed);
parcelHelpers.export(exports, "FaPatreon", ()=>FaPatreon);
parcelHelpers.export(exports, "FaPaypal", ()=>FaPaypal);
parcelHelpers.export(exports, "FaPerbyte", ()=>FaPerbyte);
parcelHelpers.export(exports, "FaPeriscope", ()=>FaPeriscope);
parcelHelpers.export(exports, "FaPhabricator", ()=>FaPhabricator);
parcelHelpers.export(exports, "FaPhoenixFramework", ()=>FaPhoenixFramework);
parcelHelpers.export(exports, "FaPhoenixSquadron", ()=>FaPhoenixSquadron);
parcelHelpers.export(exports, "FaPhp", ()=>FaPhp);
parcelHelpers.export(exports, "FaPiedPiperAlt", ()=>FaPiedPiperAlt);
parcelHelpers.export(exports, "FaPiedPiperHat", ()=>FaPiedPiperHat);
parcelHelpers.export(exports, "FaPiedPiperPp", ()=>FaPiedPiperPp);
parcelHelpers.export(exports, "FaPiedPiper", ()=>FaPiedPiper);
parcelHelpers.export(exports, "FaPinterestP", ()=>FaPinterestP);
parcelHelpers.export(exports, "FaPinterest", ()=>FaPinterest);
parcelHelpers.export(exports, "FaPix", ()=>FaPix);
parcelHelpers.export(exports, "FaPlaystation", ()=>FaPlaystation);
parcelHelpers.export(exports, "FaProductHunt", ()=>FaProductHunt);
parcelHelpers.export(exports, "FaPushed", ()=>FaPushed);
parcelHelpers.export(exports, "FaPython", ()=>FaPython);
parcelHelpers.export(exports, "FaQq", ()=>FaQq);
parcelHelpers.export(exports, "FaQuinscape", ()=>FaQuinscape);
parcelHelpers.export(exports, "FaQuora", ()=>FaQuora);
parcelHelpers.export(exports, "FaRProject", ()=>FaRProject);
parcelHelpers.export(exports, "FaRaspberryPi", ()=>FaRaspberryPi);
parcelHelpers.export(exports, "FaRavelry", ()=>FaRavelry);
parcelHelpers.export(exports, "FaReact", ()=>FaReact);
parcelHelpers.export(exports, "FaReacteurope", ()=>FaReacteurope);
parcelHelpers.export(exports, "FaReadme", ()=>FaReadme);
parcelHelpers.export(exports, "FaRebel", ()=>FaRebel);
parcelHelpers.export(exports, "FaRedRiver", ()=>FaRedRiver);
parcelHelpers.export(exports, "FaRedditAlien", ()=>FaRedditAlien);
parcelHelpers.export(exports, "FaReddit", ()=>FaReddit);
parcelHelpers.export(exports, "FaRedhat", ()=>FaRedhat);
parcelHelpers.export(exports, "FaRenren", ()=>FaRenren);
parcelHelpers.export(exports, "FaReplyd", ()=>FaReplyd);
parcelHelpers.export(exports, "FaResearchgate", ()=>FaResearchgate);
parcelHelpers.export(exports, "FaResolving", ()=>FaResolving);
parcelHelpers.export(exports, "FaRev", ()=>FaRev);
parcelHelpers.export(exports, "FaRocketchat", ()=>FaRocketchat);
parcelHelpers.export(exports, "FaRockrms", ()=>FaRockrms);
parcelHelpers.export(exports, "FaRust", ()=>FaRust);
parcelHelpers.export(exports, "FaSafari", ()=>FaSafari);
parcelHelpers.export(exports, "FaSalesforce", ()=>FaSalesforce);
parcelHelpers.export(exports, "FaSass", ()=>FaSass);
parcelHelpers.export(exports, "FaSchlix", ()=>FaSchlix);
parcelHelpers.export(exports, "FaScreenpal", ()=>FaScreenpal);
parcelHelpers.export(exports, "FaScribd", ()=>FaScribd);
parcelHelpers.export(exports, "FaSearchengin", ()=>FaSearchengin);
parcelHelpers.export(exports, "FaSellcast", ()=>FaSellcast);
parcelHelpers.export(exports, "FaSellsy", ()=>FaSellsy);
parcelHelpers.export(exports, "FaServicestack", ()=>FaServicestack);
parcelHelpers.export(exports, "FaShirtsinbulk", ()=>FaShirtsinbulk);
parcelHelpers.export(exports, "FaShopify", ()=>FaShopify);
parcelHelpers.export(exports, "FaShopware", ()=>FaShopware);
parcelHelpers.export(exports, "FaSimplybuilt", ()=>FaSimplybuilt);
parcelHelpers.export(exports, "FaSistrix", ()=>FaSistrix);
parcelHelpers.export(exports, "FaSith", ()=>FaSith);
parcelHelpers.export(exports, "FaSitrox", ()=>FaSitrox);
parcelHelpers.export(exports, "FaSketch", ()=>FaSketch);
parcelHelpers.export(exports, "FaSkyatlas", ()=>FaSkyatlas);
parcelHelpers.export(exports, "FaSkype", ()=>FaSkype);
parcelHelpers.export(exports, "FaSlack", ()=>FaSlack);
parcelHelpers.export(exports, "FaSlideshare", ()=>FaSlideshare);
parcelHelpers.export(exports, "FaSnapchat", ()=>FaSnapchat);
parcelHelpers.export(exports, "FaSoundcloud", ()=>FaSoundcloud);
parcelHelpers.export(exports, "FaSourcetree", ()=>FaSourcetree);
parcelHelpers.export(exports, "FaSpaceAwesome", ()=>FaSpaceAwesome);
parcelHelpers.export(exports, "FaSpeakap", ()=>FaSpeakap);
parcelHelpers.export(exports, "FaSpeakerDeck", ()=>FaSpeakerDeck);
parcelHelpers.export(exports, "FaSpotify", ()=>FaSpotify);
parcelHelpers.export(exports, "FaSquareBehance", ()=>FaSquareBehance);
parcelHelpers.export(exports, "FaSquareDribbble", ()=>FaSquareDribbble);
parcelHelpers.export(exports, "FaSquareFacebook", ()=>FaSquareFacebook);
parcelHelpers.export(exports, "FaSquareFontAwesomeStroke", ()=>FaSquareFontAwesomeStroke);
parcelHelpers.export(exports, "FaSquareFontAwesome", ()=>FaSquareFontAwesome);
parcelHelpers.export(exports, "FaSquareGit", ()=>FaSquareGit);
parcelHelpers.export(exports, "FaSquareGithub", ()=>FaSquareGithub);
parcelHelpers.export(exports, "FaSquareGitlab", ()=>FaSquareGitlab);
parcelHelpers.export(exports, "FaSquareGooglePlus", ()=>FaSquareGooglePlus);
parcelHelpers.export(exports, "FaSquareHackerNews", ()=>FaSquareHackerNews);
parcelHelpers.export(exports, "FaSquareInstagram", ()=>FaSquareInstagram);
parcelHelpers.export(exports, "FaSquareJs", ()=>FaSquareJs);
parcelHelpers.export(exports, "FaSquareLastfm", ()=>FaSquareLastfm);
parcelHelpers.export(exports, "FaSquareOdnoklassniki", ()=>FaSquareOdnoklassniki);
parcelHelpers.export(exports, "FaSquarePiedPiper", ()=>FaSquarePiedPiper);
parcelHelpers.export(exports, "FaSquarePinterest", ()=>FaSquarePinterest);
parcelHelpers.export(exports, "FaSquareReddit", ()=>FaSquareReddit);
parcelHelpers.export(exports, "FaSquareSnapchat", ()=>FaSquareSnapchat);
parcelHelpers.export(exports, "FaSquareSteam", ()=>FaSquareSteam);
parcelHelpers.export(exports, "FaSquareThreads", ()=>FaSquareThreads);
parcelHelpers.export(exports, "FaSquareTumblr", ()=>FaSquareTumblr);
parcelHelpers.export(exports, "FaSquareTwitter", ()=>FaSquareTwitter);
parcelHelpers.export(exports, "FaSquareViadeo", ()=>FaSquareViadeo);
parcelHelpers.export(exports, "FaSquareVimeo", ()=>FaSquareVimeo);
parcelHelpers.export(exports, "FaSquareWhatsapp", ()=>FaSquareWhatsapp);
parcelHelpers.export(exports, "FaSquareXTwitter", ()=>FaSquareXTwitter);
parcelHelpers.export(exports, "FaSquareXing", ()=>FaSquareXing);
parcelHelpers.export(exports, "FaSquareYoutube", ()=>FaSquareYoutube);
parcelHelpers.export(exports, "FaSquarespace", ()=>FaSquarespace);
parcelHelpers.export(exports, "FaStackExchange", ()=>FaStackExchange);
parcelHelpers.export(exports, "FaStackOverflow", ()=>FaStackOverflow);
parcelHelpers.export(exports, "FaStackpath", ()=>FaStackpath);
parcelHelpers.export(exports, "FaStaylinked", ()=>FaStaylinked);
parcelHelpers.export(exports, "FaSteamSymbol", ()=>FaSteamSymbol);
parcelHelpers.export(exports, "FaSteam", ()=>FaSteam);
parcelHelpers.export(exports, "FaStickerMule", ()=>FaStickerMule);
parcelHelpers.export(exports, "FaStrava", ()=>FaStrava);
parcelHelpers.export(exports, "FaStripeS", ()=>FaStripeS);
parcelHelpers.export(exports, "FaStripe", ()=>FaStripe);
parcelHelpers.export(exports, "FaStubber", ()=>FaStubber);
parcelHelpers.export(exports, "FaStudiovinari", ()=>FaStudiovinari);
parcelHelpers.export(exports, "FaStumbleuponCircle", ()=>FaStumbleuponCircle);
parcelHelpers.export(exports, "FaStumbleupon", ()=>FaStumbleupon);
parcelHelpers.export(exports, "FaSuperpowers", ()=>FaSuperpowers);
parcelHelpers.export(exports, "FaSupple", ()=>FaSupple);
parcelHelpers.export(exports, "FaSuse", ()=>FaSuse);
parcelHelpers.export(exports, "FaSwift", ()=>FaSwift);
parcelHelpers.export(exports, "FaSymfony", ()=>FaSymfony);
parcelHelpers.export(exports, "FaTeamspeak", ()=>FaTeamspeak);
parcelHelpers.export(exports, "FaTelegram", ()=>FaTelegram);
parcelHelpers.export(exports, "FaTencentWeibo", ()=>FaTencentWeibo);
parcelHelpers.export(exports, "FaTheRedYeti", ()=>FaTheRedYeti);
parcelHelpers.export(exports, "FaThemeco", ()=>FaThemeco);
parcelHelpers.export(exports, "FaThemeisle", ()=>FaThemeisle);
parcelHelpers.export(exports, "FaThinkPeaks", ()=>FaThinkPeaks);
parcelHelpers.export(exports, "FaThreads", ()=>FaThreads);
parcelHelpers.export(exports, "FaTiktok", ()=>FaTiktok);
parcelHelpers.export(exports, "FaTradeFederation", ()=>FaTradeFederation);
parcelHelpers.export(exports, "FaTrello", ()=>FaTrello);
parcelHelpers.export(exports, "FaTumblr", ()=>FaTumblr);
parcelHelpers.export(exports, "FaTwitch", ()=>FaTwitch);
parcelHelpers.export(exports, "FaTwitter", ()=>FaTwitter);
parcelHelpers.export(exports, "FaTypo3", ()=>FaTypo3);
parcelHelpers.export(exports, "FaUber", ()=>FaUber);
parcelHelpers.export(exports, "FaUbuntu", ()=>FaUbuntu);
parcelHelpers.export(exports, "FaUikit", ()=>FaUikit);
parcelHelpers.export(exports, "FaUmbraco", ()=>FaUmbraco);
parcelHelpers.export(exports, "FaUncharted", ()=>FaUncharted);
parcelHelpers.export(exports, "FaUniregistry", ()=>FaUniregistry);
parcelHelpers.export(exports, "FaUnity", ()=>FaUnity);
parcelHelpers.export(exports, "FaUnsplash", ()=>FaUnsplash);
parcelHelpers.export(exports, "FaUntappd", ()=>FaUntappd);
parcelHelpers.export(exports, "FaUps", ()=>FaUps);
parcelHelpers.export(exports, "FaUsb", ()=>FaUsb);
parcelHelpers.export(exports, "FaUsps", ()=>FaUsps);
parcelHelpers.export(exports, "FaUssunnah", ()=>FaUssunnah);
parcelHelpers.export(exports, "FaVaadin", ()=>FaVaadin);
parcelHelpers.export(exports, "FaViacoin", ()=>FaViacoin);
parcelHelpers.export(exports, "FaViadeo", ()=>FaViadeo);
parcelHelpers.export(exports, "FaViber", ()=>FaViber);
parcelHelpers.export(exports, "FaVimeoV", ()=>FaVimeoV);
parcelHelpers.export(exports, "FaVimeo", ()=>FaVimeo);
parcelHelpers.export(exports, "FaVine", ()=>FaVine);
parcelHelpers.export(exports, "FaVk", ()=>FaVk);
parcelHelpers.export(exports, "FaVnv", ()=>FaVnv);
parcelHelpers.export(exports, "FaVuejs", ()=>FaVuejs);
parcelHelpers.export(exports, "FaWatchmanMonitoring", ()=>FaWatchmanMonitoring);
parcelHelpers.export(exports, "FaWaze", ()=>FaWaze);
parcelHelpers.export(exports, "FaWeebly", ()=>FaWeebly);
parcelHelpers.export(exports, "FaWeibo", ()=>FaWeibo);
parcelHelpers.export(exports, "FaWeixin", ()=>FaWeixin);
parcelHelpers.export(exports, "FaWhatsapp", ()=>FaWhatsapp);
parcelHelpers.export(exports, "FaWhmcs", ()=>FaWhmcs);
parcelHelpers.export(exports, "FaWikipediaW", ()=>FaWikipediaW);
parcelHelpers.export(exports, "FaWindows", ()=>FaWindows);
parcelHelpers.export(exports, "FaWirsindhandwerk", ()=>FaWirsindhandwerk);
parcelHelpers.export(exports, "FaWix", ()=>FaWix);
parcelHelpers.export(exports, "FaWizardsOfTheCoast", ()=>FaWizardsOfTheCoast);
parcelHelpers.export(exports, "FaWodu", ()=>FaWodu);
parcelHelpers.export(exports, "FaWolfPackBattalion", ()=>FaWolfPackBattalion);
parcelHelpers.export(exports, "FaWordpressSimple", ()=>FaWordpressSimple);
parcelHelpers.export(exports, "FaWordpress", ()=>FaWordpress);
parcelHelpers.export(exports, "FaWpbeginner", ()=>FaWpbeginner);
parcelHelpers.export(exports, "FaWpexplorer", ()=>FaWpexplorer);
parcelHelpers.export(exports, "FaWpforms", ()=>FaWpforms);
parcelHelpers.export(exports, "FaWpressr", ()=>FaWpressr);
parcelHelpers.export(exports, "FaXTwitter", ()=>FaXTwitter);
parcelHelpers.export(exports, "FaXbox", ()=>FaXbox);
parcelHelpers.export(exports, "FaXing", ()=>FaXing);
parcelHelpers.export(exports, "FaYCombinator", ()=>FaYCombinator);
parcelHelpers.export(exports, "FaYahoo", ()=>FaYahoo);
parcelHelpers.export(exports, "FaYammer", ()=>FaYammer);
parcelHelpers.export(exports, "FaYandexInternational", ()=>FaYandexInternational);
parcelHelpers.export(exports, "FaYandex", ()=>FaYandex);
parcelHelpers.export(exports, "FaYarn", ()=>FaYarn);
parcelHelpers.export(exports, "FaYelp", ()=>FaYelp);
parcelHelpers.export(exports, "FaYoast", ()=>FaYoast);
parcelHelpers.export(exports, "FaYoutube", ()=>FaYoutube);
parcelHelpers.export(exports, "FaZhihu", ()=>FaZhihu);
parcelHelpers.export(exports, "Fa0", ()=>Fa0);
parcelHelpers.export(exports, "Fa1", ()=>Fa1);
parcelHelpers.export(exports, "Fa2", ()=>Fa2);
parcelHelpers.export(exports, "Fa3", ()=>Fa3);
parcelHelpers.export(exports, "Fa4", ()=>Fa4);
parcelHelpers.export(exports, "Fa5", ()=>Fa5);
parcelHelpers.export(exports, "Fa6", ()=>Fa6);
parcelHelpers.export(exports, "Fa7", ()=>Fa7);
parcelHelpers.export(exports, "Fa8", ()=>Fa8);
parcelHelpers.export(exports, "Fa9", ()=>Fa9);
parcelHelpers.export(exports, "FaA", ()=>FaA);
parcelHelpers.export(exports, "FaAddressBook", ()=>FaAddressBook);
parcelHelpers.export(exports, "FaAddressCard", ()=>FaAddressCard);
parcelHelpers.export(exports, "FaAlignCenter", ()=>FaAlignCenter);
parcelHelpers.export(exports, "FaAlignJustify", ()=>FaAlignJustify);
parcelHelpers.export(exports, "FaAlignLeft", ()=>FaAlignLeft);
parcelHelpers.export(exports, "FaAlignRight", ()=>FaAlignRight);
parcelHelpers.export(exports, "FaAnchorCircleCheck", ()=>FaAnchorCircleCheck);
parcelHelpers.export(exports, "FaAnchorCircleExclamation", ()=>FaAnchorCircleExclamation);
parcelHelpers.export(exports, "FaAnchorCircleXmark", ()=>FaAnchorCircleXmark);
parcelHelpers.export(exports, "FaAnchorLock", ()=>FaAnchorLock);
parcelHelpers.export(exports, "FaAnchor", ()=>FaAnchor);
parcelHelpers.export(exports, "FaAngleDown", ()=>FaAngleDown);
parcelHelpers.export(exports, "FaAngleLeft", ()=>FaAngleLeft);
parcelHelpers.export(exports, "FaAngleRight", ()=>FaAngleRight);
parcelHelpers.export(exports, "FaAngleUp", ()=>FaAngleUp);
parcelHelpers.export(exports, "FaAnglesDown", ()=>FaAnglesDown);
parcelHelpers.export(exports, "FaAnglesLeft", ()=>FaAnglesLeft);
parcelHelpers.export(exports, "FaAnglesRight", ()=>FaAnglesRight);
parcelHelpers.export(exports, "FaAnglesUp", ()=>FaAnglesUp);
parcelHelpers.export(exports, "FaAnkh", ()=>FaAnkh);
parcelHelpers.export(exports, "FaAppleWhole", ()=>FaAppleWhole);
parcelHelpers.export(exports, "FaArchway", ()=>FaArchway);
parcelHelpers.export(exports, "FaArrowDown19", ()=>FaArrowDown19);
parcelHelpers.export(exports, "FaArrowDown91", ()=>FaArrowDown91);
parcelHelpers.export(exports, "FaArrowDownAZ", ()=>FaArrowDownAZ);
parcelHelpers.export(exports, "FaArrowDownLong", ()=>FaArrowDownLong);
parcelHelpers.export(exports, "FaArrowDownShortWide", ()=>FaArrowDownShortWide);
parcelHelpers.export(exports, "FaArrowDownUpAcrossLine", ()=>FaArrowDownUpAcrossLine);
parcelHelpers.export(exports, "FaArrowDownUpLock", ()=>FaArrowDownUpLock);
parcelHelpers.export(exports, "FaArrowDownWideShort", ()=>FaArrowDownWideShort);
parcelHelpers.export(exports, "FaArrowDownZA", ()=>FaArrowDownZA);
parcelHelpers.export(exports, "FaArrowDown", ()=>FaArrowDown);
parcelHelpers.export(exports, "FaArrowLeftLong", ()=>FaArrowLeftLong);
parcelHelpers.export(exports, "FaArrowLeft", ()=>FaArrowLeft);
parcelHelpers.export(exports, "FaArrowPointer", ()=>FaArrowPointer);
parcelHelpers.export(exports, "FaArrowRightArrowLeft", ()=>FaArrowRightArrowLeft);
parcelHelpers.export(exports, "FaArrowRightFromBracket", ()=>FaArrowRightFromBracket);
parcelHelpers.export(exports, "FaArrowRightLong", ()=>FaArrowRightLong);
parcelHelpers.export(exports, "FaArrowRightToBracket", ()=>FaArrowRightToBracket);
parcelHelpers.export(exports, "FaArrowRightToCity", ()=>FaArrowRightToCity);
parcelHelpers.export(exports, "FaArrowRight", ()=>FaArrowRight);
parcelHelpers.export(exports, "FaArrowRotateLeft", ()=>FaArrowRotateLeft);
parcelHelpers.export(exports, "FaArrowRotateRight", ()=>FaArrowRotateRight);
parcelHelpers.export(exports, "FaArrowTrendDown", ()=>FaArrowTrendDown);
parcelHelpers.export(exports, "FaArrowTrendUp", ()=>FaArrowTrendUp);
parcelHelpers.export(exports, "FaArrowTurnDown", ()=>FaArrowTurnDown);
parcelHelpers.export(exports, "FaArrowTurnUp", ()=>FaArrowTurnUp);
parcelHelpers.export(exports, "FaArrowUp19", ()=>FaArrowUp19);
parcelHelpers.export(exports, "FaArrowUp91", ()=>FaArrowUp91);
parcelHelpers.export(exports, "FaArrowUpAZ", ()=>FaArrowUpAZ);
parcelHelpers.export(exports, "FaArrowUpFromBracket", ()=>FaArrowUpFromBracket);
parcelHelpers.export(exports, "FaArrowUpFromGroundWater", ()=>FaArrowUpFromGroundWater);
parcelHelpers.export(exports, "FaArrowUpFromWaterPump", ()=>FaArrowUpFromWaterPump);
parcelHelpers.export(exports, "FaArrowUpLong", ()=>FaArrowUpLong);
parcelHelpers.export(exports, "FaArrowUpRightDots", ()=>FaArrowUpRightDots);
parcelHelpers.export(exports, "FaArrowUpRightFromSquare", ()=>FaArrowUpRightFromSquare);
parcelHelpers.export(exports, "FaArrowUpShortWide", ()=>FaArrowUpShortWide);
parcelHelpers.export(exports, "FaArrowUpWideShort", ()=>FaArrowUpWideShort);
parcelHelpers.export(exports, "FaArrowUpZA", ()=>FaArrowUpZA);
parcelHelpers.export(exports, "FaArrowUp", ()=>FaArrowUp);
parcelHelpers.export(exports, "FaArrowsDownToLine", ()=>FaArrowsDownToLine);
parcelHelpers.export(exports, "FaArrowsDownToPeople", ()=>FaArrowsDownToPeople);
parcelHelpers.export(exports, "FaArrowsLeftRightToLine", ()=>FaArrowsLeftRightToLine);
parcelHelpers.export(exports, "FaArrowsLeftRight", ()=>FaArrowsLeftRight);
parcelHelpers.export(exports, "FaArrowsRotate", ()=>FaArrowsRotate);
parcelHelpers.export(exports, "FaArrowsSpin", ()=>FaArrowsSpin);
parcelHelpers.export(exports, "FaArrowsSplitUpAndLeft", ()=>FaArrowsSplitUpAndLeft);
parcelHelpers.export(exports, "FaArrowsToCircle", ()=>FaArrowsToCircle);
parcelHelpers.export(exports, "FaArrowsToDot", ()=>FaArrowsToDot);
parcelHelpers.export(exports, "FaArrowsToEye", ()=>FaArrowsToEye);
parcelHelpers.export(exports, "FaArrowsTurnRight", ()=>FaArrowsTurnRight);
parcelHelpers.export(exports, "FaArrowsTurnToDots", ()=>FaArrowsTurnToDots);
parcelHelpers.export(exports, "FaArrowsUpDownLeftRight", ()=>FaArrowsUpDownLeftRight);
parcelHelpers.export(exports, "FaArrowsUpDown", ()=>FaArrowsUpDown);
parcelHelpers.export(exports, "FaArrowsUpToLine", ()=>FaArrowsUpToLine);
parcelHelpers.export(exports, "FaAsterisk", ()=>FaAsterisk);
parcelHelpers.export(exports, "FaAt", ()=>FaAt);
parcelHelpers.export(exports, "FaAtom", ()=>FaAtom);
parcelHelpers.export(exports, "FaAudioDescription", ()=>FaAudioDescription);
parcelHelpers.export(exports, "FaAustralSign", ()=>FaAustralSign);
parcelHelpers.export(exports, "FaAward", ()=>FaAward);
parcelHelpers.export(exports, "FaB", ()=>FaB);
parcelHelpers.export(exports, "FaBabyCarriage", ()=>FaBabyCarriage);
parcelHelpers.export(exports, "FaBaby", ()=>FaBaby);
parcelHelpers.export(exports, "FaBackwardFast", ()=>FaBackwardFast);
parcelHelpers.export(exports, "FaBackwardStep", ()=>FaBackwardStep);
parcelHelpers.export(exports, "FaBackward", ()=>FaBackward);
parcelHelpers.export(exports, "FaBacon", ()=>FaBacon);
parcelHelpers.export(exports, "FaBacteria", ()=>FaBacteria);
parcelHelpers.export(exports, "FaBacterium", ()=>FaBacterium);
parcelHelpers.export(exports, "FaBagShopping", ()=>FaBagShopping);
parcelHelpers.export(exports, "FaBahai", ()=>FaBahai);
parcelHelpers.export(exports, "FaBahtSign", ()=>FaBahtSign);
parcelHelpers.export(exports, "FaBanSmoking", ()=>FaBanSmoking);
parcelHelpers.export(exports, "FaBan", ()=>FaBan);
parcelHelpers.export(exports, "FaBandage", ()=>FaBandage);
parcelHelpers.export(exports, "FaBangladeshiTakaSign", ()=>FaBangladeshiTakaSign);
parcelHelpers.export(exports, "FaBarcode", ()=>FaBarcode);
parcelHelpers.export(exports, "FaBarsProgress", ()=>FaBarsProgress);
parcelHelpers.export(exports, "FaBarsStaggered", ()=>FaBarsStaggered);
parcelHelpers.export(exports, "FaBars", ()=>FaBars);
parcelHelpers.export(exports, "FaBaseballBatBall", ()=>FaBaseballBatBall);
parcelHelpers.export(exports, "FaBaseball", ()=>FaBaseball);
parcelHelpers.export(exports, "FaBasketShopping", ()=>FaBasketShopping);
parcelHelpers.export(exports, "FaBasketball", ()=>FaBasketball);
parcelHelpers.export(exports, "FaBath", ()=>FaBath);
parcelHelpers.export(exports, "FaBatteryEmpty", ()=>FaBatteryEmpty);
parcelHelpers.export(exports, "FaBatteryFull", ()=>FaBatteryFull);
parcelHelpers.export(exports, "FaBatteryHalf", ()=>FaBatteryHalf);
parcelHelpers.export(exports, "FaBatteryQuarter", ()=>FaBatteryQuarter);
parcelHelpers.export(exports, "FaBatteryThreeQuarters", ()=>FaBatteryThreeQuarters);
parcelHelpers.export(exports, "FaBedPulse", ()=>FaBedPulse);
parcelHelpers.export(exports, "FaBed", ()=>FaBed);
parcelHelpers.export(exports, "FaBeerMugEmpty", ()=>FaBeerMugEmpty);
parcelHelpers.export(exports, "FaBellConcierge", ()=>FaBellConcierge);
parcelHelpers.export(exports, "FaBellSlash", ()=>FaBellSlash);
parcelHelpers.export(exports, "FaBell", ()=>FaBell);
parcelHelpers.export(exports, "FaBezierCurve", ()=>FaBezierCurve);
parcelHelpers.export(exports, "FaBicycle", ()=>FaBicycle);
parcelHelpers.export(exports, "FaBinoculars", ()=>FaBinoculars);
parcelHelpers.export(exports, "FaBiohazard", ()=>FaBiohazard);
parcelHelpers.export(exports, "FaBitcoinSign", ()=>FaBitcoinSign);
parcelHelpers.export(exports, "FaBlenderPhone", ()=>FaBlenderPhone);
parcelHelpers.export(exports, "FaBlender", ()=>FaBlender);
parcelHelpers.export(exports, "FaBlog", ()=>FaBlog);
parcelHelpers.export(exports, "FaBold", ()=>FaBold);
parcelHelpers.export(exports, "FaBoltLightning", ()=>FaBoltLightning);
parcelHelpers.export(exports, "FaBolt", ()=>FaBolt);
parcelHelpers.export(exports, "FaBomb", ()=>FaBomb);
parcelHelpers.export(exports, "FaBone", ()=>FaBone);
parcelHelpers.export(exports, "FaBong", ()=>FaBong);
parcelHelpers.export(exports, "FaBookAtlas", ()=>FaBookAtlas);
parcelHelpers.export(exports, "FaBookBible", ()=>FaBookBible);
parcelHelpers.export(exports, "FaBookBookmark", ()=>FaBookBookmark);
parcelHelpers.export(exports, "FaBookJournalWhills", ()=>FaBookJournalWhills);
parcelHelpers.export(exports, "FaBookMedical", ()=>FaBookMedical);
parcelHelpers.export(exports, "FaBookOpenReader", ()=>FaBookOpenReader);
parcelHelpers.export(exports, "FaBookOpen", ()=>FaBookOpen);
parcelHelpers.export(exports, "FaBookQuran", ()=>FaBookQuran);
parcelHelpers.export(exports, "FaBookSkull", ()=>FaBookSkull);
parcelHelpers.export(exports, "FaBookTanakh", ()=>FaBookTanakh);
parcelHelpers.export(exports, "FaBook", ()=>FaBook);
parcelHelpers.export(exports, "FaBookmark", ()=>FaBookmark);
parcelHelpers.export(exports, "FaBorderAll", ()=>FaBorderAll);
parcelHelpers.export(exports, "FaBorderNone", ()=>FaBorderNone);
parcelHelpers.export(exports, "FaBorderTopLeft", ()=>FaBorderTopLeft);
parcelHelpers.export(exports, "FaBoreHole", ()=>FaBoreHole);
parcelHelpers.export(exports, "FaBottleDroplet", ()=>FaBottleDroplet);
parcelHelpers.export(exports, "FaBottleWater", ()=>FaBottleWater);
parcelHelpers.export(exports, "FaBowlFood", ()=>FaBowlFood);
parcelHelpers.export(exports, "FaBowlRice", ()=>FaBowlRice);
parcelHelpers.export(exports, "FaBowlingBall", ()=>FaBowlingBall);
parcelHelpers.export(exports, "FaBoxArchive", ()=>FaBoxArchive);
parcelHelpers.export(exports, "FaBoxOpen", ()=>FaBoxOpen);
parcelHelpers.export(exports, "FaBoxTissue", ()=>FaBoxTissue);
parcelHelpers.export(exports, "FaBox", ()=>FaBox);
parcelHelpers.export(exports, "FaBoxesPacking", ()=>FaBoxesPacking);
parcelHelpers.export(exports, "FaBoxesStacked", ()=>FaBoxesStacked);
parcelHelpers.export(exports, "FaBraille", ()=>FaBraille);
parcelHelpers.export(exports, "FaBrain", ()=>FaBrain);
parcelHelpers.export(exports, "FaBrazilianRealSign", ()=>FaBrazilianRealSign);
parcelHelpers.export(exports, "FaBreadSlice", ()=>FaBreadSlice);
parcelHelpers.export(exports, "FaBridgeCircleCheck", ()=>FaBridgeCircleCheck);
parcelHelpers.export(exports, "FaBridgeCircleExclamation", ()=>FaBridgeCircleExclamation);
parcelHelpers.export(exports, "FaBridgeCircleXmark", ()=>FaBridgeCircleXmark);
parcelHelpers.export(exports, "FaBridgeLock", ()=>FaBridgeLock);
parcelHelpers.export(exports, "FaBridgeWater", ()=>FaBridgeWater);
parcelHelpers.export(exports, "FaBridge", ()=>FaBridge);
parcelHelpers.export(exports, "FaBriefcaseMedical", ()=>FaBriefcaseMedical);
parcelHelpers.export(exports, "FaBriefcase", ()=>FaBriefcase);
parcelHelpers.export(exports, "FaBroomBall", ()=>FaBroomBall);
parcelHelpers.export(exports, "FaBroom", ()=>FaBroom);
parcelHelpers.export(exports, "FaBrush", ()=>FaBrush);
parcelHelpers.export(exports, "FaBucket", ()=>FaBucket);
parcelHelpers.export(exports, "FaBugSlash", ()=>FaBugSlash);
parcelHelpers.export(exports, "FaBug", ()=>FaBug);
parcelHelpers.export(exports, "FaBugs", ()=>FaBugs);
parcelHelpers.export(exports, "FaBuildingCircleArrowRight", ()=>FaBuildingCircleArrowRight);
parcelHelpers.export(exports, "FaBuildingCircleCheck", ()=>FaBuildingCircleCheck);
parcelHelpers.export(exports, "FaBuildingCircleExclamation", ()=>FaBuildingCircleExclamation);
parcelHelpers.export(exports, "FaBuildingCircleXmark", ()=>FaBuildingCircleXmark);
parcelHelpers.export(exports, "FaBuildingColumns", ()=>FaBuildingColumns);
parcelHelpers.export(exports, "FaBuildingFlag", ()=>FaBuildingFlag);
parcelHelpers.export(exports, "FaBuildingLock", ()=>FaBuildingLock);
parcelHelpers.export(exports, "FaBuildingNgo", ()=>FaBuildingNgo);
parcelHelpers.export(exports, "FaBuildingShield", ()=>FaBuildingShield);
parcelHelpers.export(exports, "FaBuildingUn", ()=>FaBuildingUn);
parcelHelpers.export(exports, "FaBuildingUser", ()=>FaBuildingUser);
parcelHelpers.export(exports, "FaBuildingWheat", ()=>FaBuildingWheat);
parcelHelpers.export(exports, "FaBuilding", ()=>FaBuilding);
parcelHelpers.export(exports, "FaBullhorn", ()=>FaBullhorn);
parcelHelpers.export(exports, "FaBullseye", ()=>FaBullseye);
parcelHelpers.export(exports, "FaBurger", ()=>FaBurger);
parcelHelpers.export(exports, "FaBurst", ()=>FaBurst);
parcelHelpers.export(exports, "FaBusSimple", ()=>FaBusSimple);
parcelHelpers.export(exports, "FaBus", ()=>FaBus);
parcelHelpers.export(exports, "FaBusinessTime", ()=>FaBusinessTime);
parcelHelpers.export(exports, "FaC", ()=>FaC);
parcelHelpers.export(exports, "FaCableCar", ()=>FaCableCar);
parcelHelpers.export(exports, "FaCakeCandles", ()=>FaCakeCandles);
parcelHelpers.export(exports, "FaCalculator", ()=>FaCalculator);
parcelHelpers.export(exports, "FaCalendarCheck", ()=>FaCalendarCheck);
parcelHelpers.export(exports, "FaCalendarDay", ()=>FaCalendarDay);
parcelHelpers.export(exports, "FaCalendarDays", ()=>FaCalendarDays);
parcelHelpers.export(exports, "FaCalendarMinus", ()=>FaCalendarMinus);
parcelHelpers.export(exports, "FaCalendarPlus", ()=>FaCalendarPlus);
parcelHelpers.export(exports, "FaCalendarWeek", ()=>FaCalendarWeek);
parcelHelpers.export(exports, "FaCalendarXmark", ()=>FaCalendarXmark);
parcelHelpers.export(exports, "FaCalendar", ()=>FaCalendar);
parcelHelpers.export(exports, "FaCameraRetro", ()=>FaCameraRetro);
parcelHelpers.export(exports, "FaCameraRotate", ()=>FaCameraRotate);
parcelHelpers.export(exports, "FaCamera", ()=>FaCamera);
parcelHelpers.export(exports, "FaCampground", ()=>FaCampground);
parcelHelpers.export(exports, "FaCandyCane", ()=>FaCandyCane);
parcelHelpers.export(exports, "FaCannabis", ()=>FaCannabis);
parcelHelpers.export(exports, "FaCapsules", ()=>FaCapsules);
parcelHelpers.export(exports, "FaCarBattery", ()=>FaCarBattery);
parcelHelpers.export(exports, "FaCarBurst", ()=>FaCarBurst);
parcelHelpers.export(exports, "FaCarOn", ()=>FaCarOn);
parcelHelpers.export(exports, "FaCarRear", ()=>FaCarRear);
parcelHelpers.export(exports, "FaCarSide", ()=>FaCarSide);
parcelHelpers.export(exports, "FaCarTunnel", ()=>FaCarTunnel);
parcelHelpers.export(exports, "FaCar", ()=>FaCar);
parcelHelpers.export(exports, "FaCaravan", ()=>FaCaravan);
parcelHelpers.export(exports, "FaCaretDown", ()=>FaCaretDown);
parcelHelpers.export(exports, "FaCaretLeft", ()=>FaCaretLeft);
parcelHelpers.export(exports, "FaCaretRight", ()=>FaCaretRight);
parcelHelpers.export(exports, "FaCaretUp", ()=>FaCaretUp);
parcelHelpers.export(exports, "FaCarrot", ()=>FaCarrot);
parcelHelpers.export(exports, "FaCartArrowDown", ()=>FaCartArrowDown);
parcelHelpers.export(exports, "FaCartFlatbedSuitcase", ()=>FaCartFlatbedSuitcase);
parcelHelpers.export(exports, "FaCartFlatbed", ()=>FaCartFlatbed);
parcelHelpers.export(exports, "FaCartPlus", ()=>FaCartPlus);
parcelHelpers.export(exports, "FaCartShopping", ()=>FaCartShopping);
parcelHelpers.export(exports, "FaCashRegister", ()=>FaCashRegister);
parcelHelpers.export(exports, "FaCat", ()=>FaCat);
parcelHelpers.export(exports, "FaCediSign", ()=>FaCediSign);
parcelHelpers.export(exports, "FaCentSign", ()=>FaCentSign);
parcelHelpers.export(exports, "FaCertificate", ()=>FaCertificate);
parcelHelpers.export(exports, "FaChair", ()=>FaChair);
parcelHelpers.export(exports, "FaChalkboardUser", ()=>FaChalkboardUser);
parcelHelpers.export(exports, "FaChalkboard", ()=>FaChalkboard);
parcelHelpers.export(exports, "FaChampagneGlasses", ()=>FaChampagneGlasses);
parcelHelpers.export(exports, "FaChargingStation", ()=>FaChargingStation);
parcelHelpers.export(exports, "FaChartArea", ()=>FaChartArea);
parcelHelpers.export(exports, "FaChartBar", ()=>FaChartBar);
parcelHelpers.export(exports, "FaChartColumn", ()=>FaChartColumn);
parcelHelpers.export(exports, "FaChartGantt", ()=>FaChartGantt);
parcelHelpers.export(exports, "FaChartLine", ()=>FaChartLine);
parcelHelpers.export(exports, "FaChartPie", ()=>FaChartPie);
parcelHelpers.export(exports, "FaChartSimple", ()=>FaChartSimple);
parcelHelpers.export(exports, "FaCheckDouble", ()=>FaCheckDouble);
parcelHelpers.export(exports, "FaCheckToSlot", ()=>FaCheckToSlot);
parcelHelpers.export(exports, "FaCheck", ()=>FaCheck);
parcelHelpers.export(exports, "FaCheese", ()=>FaCheese);
parcelHelpers.export(exports, "FaChessBishop", ()=>FaChessBishop);
parcelHelpers.export(exports, "FaChessBoard", ()=>FaChessBoard);
parcelHelpers.export(exports, "FaChessKing", ()=>FaChessKing);
parcelHelpers.export(exports, "FaChessKnight", ()=>FaChessKnight);
parcelHelpers.export(exports, "FaChessPawn", ()=>FaChessPawn);
parcelHelpers.export(exports, "FaChessQueen", ()=>FaChessQueen);
parcelHelpers.export(exports, "FaChessRook", ()=>FaChessRook);
parcelHelpers.export(exports, "FaChess", ()=>FaChess);
parcelHelpers.export(exports, "FaChevronDown", ()=>FaChevronDown);
parcelHelpers.export(exports, "FaChevronLeft", ()=>FaChevronLeft);
parcelHelpers.export(exports, "FaChevronRight", ()=>FaChevronRight);
parcelHelpers.export(exports, "FaChevronUp", ()=>FaChevronUp);
parcelHelpers.export(exports, "FaChildCombatant", ()=>FaChildCombatant);
parcelHelpers.export(exports, "FaChildDress", ()=>FaChildDress);
parcelHelpers.export(exports, "FaChildReaching", ()=>FaChildReaching);
parcelHelpers.export(exports, "FaChild", ()=>FaChild);
parcelHelpers.export(exports, "FaChildren", ()=>FaChildren);
parcelHelpers.export(exports, "FaChurch", ()=>FaChurch);
parcelHelpers.export(exports, "FaCircleArrowDown", ()=>FaCircleArrowDown);
parcelHelpers.export(exports, "FaCircleArrowLeft", ()=>FaCircleArrowLeft);
parcelHelpers.export(exports, "FaCircleArrowRight", ()=>FaCircleArrowRight);
parcelHelpers.export(exports, "FaCircleArrowUp", ()=>FaCircleArrowUp);
parcelHelpers.export(exports, "FaCircleCheck", ()=>FaCircleCheck);
parcelHelpers.export(exports, "FaCircleChevronDown", ()=>FaCircleChevronDown);
parcelHelpers.export(exports, "FaCircleChevronLeft", ()=>FaCircleChevronLeft);
parcelHelpers.export(exports, "FaCircleChevronRight", ()=>FaCircleChevronRight);
parcelHelpers.export(exports, "FaCircleChevronUp", ()=>FaCircleChevronUp);
parcelHelpers.export(exports, "FaCircleDollarToSlot", ()=>FaCircleDollarToSlot);
parcelHelpers.export(exports, "FaCircleDot", ()=>FaCircleDot);
parcelHelpers.export(exports, "FaCircleDown", ()=>FaCircleDown);
parcelHelpers.export(exports, "FaCircleExclamation", ()=>FaCircleExclamation);
parcelHelpers.export(exports, "FaCircleH", ()=>FaCircleH);
parcelHelpers.export(exports, "FaCircleHalfStroke", ()=>FaCircleHalfStroke);
parcelHelpers.export(exports, "FaCircleInfo", ()=>FaCircleInfo);
parcelHelpers.export(exports, "FaCircleLeft", ()=>FaCircleLeft);
parcelHelpers.export(exports, "FaCircleMinus", ()=>FaCircleMinus);
parcelHelpers.export(exports, "FaCircleNodes", ()=>FaCircleNodes);
parcelHelpers.export(exports, "FaCircleNotch", ()=>FaCircleNotch);
parcelHelpers.export(exports, "FaCirclePause", ()=>FaCirclePause);
parcelHelpers.export(exports, "FaCirclePlay", ()=>FaCirclePlay);
parcelHelpers.export(exports, "FaCirclePlus", ()=>FaCirclePlus);
parcelHelpers.export(exports, "FaCircleQuestion", ()=>FaCircleQuestion);
parcelHelpers.export(exports, "FaCircleRadiation", ()=>FaCircleRadiation);
parcelHelpers.export(exports, "FaCircleRight", ()=>FaCircleRight);
parcelHelpers.export(exports, "FaCircleStop", ()=>FaCircleStop);
parcelHelpers.export(exports, "FaCircleUp", ()=>FaCircleUp);
parcelHelpers.export(exports, "FaCircleUser", ()=>FaCircleUser);
parcelHelpers.export(exports, "FaCircleXmark", ()=>FaCircleXmark);
parcelHelpers.export(exports, "FaCircle", ()=>FaCircle);
parcelHelpers.export(exports, "FaCity", ()=>FaCity);
parcelHelpers.export(exports, "FaClapperboard", ()=>FaClapperboard);
parcelHelpers.export(exports, "FaClipboardCheck", ()=>FaClipboardCheck);
parcelHelpers.export(exports, "FaClipboardList", ()=>FaClipboardList);
parcelHelpers.export(exports, "FaClipboardQuestion", ()=>FaClipboardQuestion);
parcelHelpers.export(exports, "FaClipboardUser", ()=>FaClipboardUser);
parcelHelpers.export(exports, "FaClipboard", ()=>FaClipboard);
parcelHelpers.export(exports, "FaClockRotateLeft", ()=>FaClockRotateLeft);
parcelHelpers.export(exports, "FaClock", ()=>FaClock);
parcelHelpers.export(exports, "FaClone", ()=>FaClone);
parcelHelpers.export(exports, "FaClosedCaptioning", ()=>FaClosedCaptioning);
parcelHelpers.export(exports, "FaCloudArrowDown", ()=>FaCloudArrowDown);
parcelHelpers.export(exports, "FaCloudArrowUp", ()=>FaCloudArrowUp);
parcelHelpers.export(exports, "FaCloudBolt", ()=>FaCloudBolt);
parcelHelpers.export(exports, "FaCloudMeatball", ()=>FaCloudMeatball);
parcelHelpers.export(exports, "FaCloudMoonRain", ()=>FaCloudMoonRain);
parcelHelpers.export(exports, "FaCloudMoon", ()=>FaCloudMoon);
parcelHelpers.export(exports, "FaCloudRain", ()=>FaCloudRain);
parcelHelpers.export(exports, "FaCloudShowersHeavy", ()=>FaCloudShowersHeavy);
parcelHelpers.export(exports, "FaCloudShowersWater", ()=>FaCloudShowersWater);
parcelHelpers.export(exports, "FaCloudSunRain", ()=>FaCloudSunRain);
parcelHelpers.export(exports, "FaCloudSun", ()=>FaCloudSun);
parcelHelpers.export(exports, "FaCloud", ()=>FaCloud);
parcelHelpers.export(exports, "FaClover", ()=>FaClover);
parcelHelpers.export(exports, "FaCodeBranch", ()=>FaCodeBranch);
parcelHelpers.export(exports, "FaCodeCommit", ()=>FaCodeCommit);
parcelHelpers.export(exports, "FaCodeCompare", ()=>FaCodeCompare);
parcelHelpers.export(exports, "FaCodeFork", ()=>FaCodeFork);
parcelHelpers.export(exports, "FaCodeMerge", ()=>FaCodeMerge);
parcelHelpers.export(exports, "FaCodePullRequest", ()=>FaCodePullRequest);
parcelHelpers.export(exports, "FaCode", ()=>FaCode);
parcelHelpers.export(exports, "FaCoins", ()=>FaCoins);
parcelHelpers.export(exports, "FaColonSign", ()=>FaColonSign);
parcelHelpers.export(exports, "FaCommentDollar", ()=>FaCommentDollar);
parcelHelpers.export(exports, "FaCommentDots", ()=>FaCommentDots);
parcelHelpers.export(exports, "FaCommentMedical", ()=>FaCommentMedical);
parcelHelpers.export(exports, "FaCommentSlash", ()=>FaCommentSlash);
parcelHelpers.export(exports, "FaCommentSms", ()=>FaCommentSms);
parcelHelpers.export(exports, "FaComment", ()=>FaComment);
parcelHelpers.export(exports, "FaCommentsDollar", ()=>FaCommentsDollar);
parcelHelpers.export(exports, "FaComments", ()=>FaComments);
parcelHelpers.export(exports, "FaCompactDisc", ()=>FaCompactDisc);
parcelHelpers.export(exports, "FaCompassDrafting", ()=>FaCompassDrafting);
parcelHelpers.export(exports, "FaCompass", ()=>FaCompass);
parcelHelpers.export(exports, "FaCompress", ()=>FaCompress);
parcelHelpers.export(exports, "FaComputerMouse", ()=>FaComputerMouse);
parcelHelpers.export(exports, "FaComputer", ()=>FaComputer);
parcelHelpers.export(exports, "FaCookieBite", ()=>FaCookieBite);
parcelHelpers.export(exports, "FaCookie", ()=>FaCookie);
parcelHelpers.export(exports, "FaCopy", ()=>FaCopy);
parcelHelpers.export(exports, "FaCopyright", ()=>FaCopyright);
parcelHelpers.export(exports, "FaCouch", ()=>FaCouch);
parcelHelpers.export(exports, "FaCow", ()=>FaCow);
parcelHelpers.export(exports, "FaCreditCard", ()=>FaCreditCard);
parcelHelpers.export(exports, "FaCropSimple", ()=>FaCropSimple);
parcelHelpers.export(exports, "FaCrop", ()=>FaCrop);
parcelHelpers.export(exports, "FaCross", ()=>FaCross);
parcelHelpers.export(exports, "FaCrosshairs", ()=>FaCrosshairs);
parcelHelpers.export(exports, "FaCrow", ()=>FaCrow);
parcelHelpers.export(exports, "FaCrown", ()=>FaCrown);
parcelHelpers.export(exports, "FaCrutch", ()=>FaCrutch);
parcelHelpers.export(exports, "FaCruzeiroSign", ()=>FaCruzeiroSign);
parcelHelpers.export(exports, "FaCube", ()=>FaCube);
parcelHelpers.export(exports, "FaCubesStacked", ()=>FaCubesStacked);
parcelHelpers.export(exports, "FaCubes", ()=>FaCubes);
parcelHelpers.export(exports, "FaD", ()=>FaD);
parcelHelpers.export(exports, "FaDatabase", ()=>FaDatabase);
parcelHelpers.export(exports, "FaDeleteLeft", ()=>FaDeleteLeft);
parcelHelpers.export(exports, "FaDemocrat", ()=>FaDemocrat);
parcelHelpers.export(exports, "FaDesktop", ()=>FaDesktop);
parcelHelpers.export(exports, "FaDharmachakra", ()=>FaDharmachakra);
parcelHelpers.export(exports, "FaDiagramNext", ()=>FaDiagramNext);
parcelHelpers.export(exports, "FaDiagramPredecessor", ()=>FaDiagramPredecessor);
parcelHelpers.export(exports, "FaDiagramProject", ()=>FaDiagramProject);
parcelHelpers.export(exports, "FaDiagramSuccessor", ()=>FaDiagramSuccessor);
parcelHelpers.export(exports, "FaDiamondTurnRight", ()=>FaDiamondTurnRight);
parcelHelpers.export(exports, "FaDiamond", ()=>FaDiamond);
parcelHelpers.export(exports, "FaDiceD20", ()=>FaDiceD20);
parcelHelpers.export(exports, "FaDiceD6", ()=>FaDiceD6);
parcelHelpers.export(exports, "FaDiceFive", ()=>FaDiceFive);
parcelHelpers.export(exports, "FaDiceFour", ()=>FaDiceFour);
parcelHelpers.export(exports, "FaDiceOne", ()=>FaDiceOne);
parcelHelpers.export(exports, "FaDiceSix", ()=>FaDiceSix);
parcelHelpers.export(exports, "FaDiceThree", ()=>FaDiceThree);
parcelHelpers.export(exports, "FaDiceTwo", ()=>FaDiceTwo);
parcelHelpers.export(exports, "FaDice", ()=>FaDice);
parcelHelpers.export(exports, "FaDisease", ()=>FaDisease);
parcelHelpers.export(exports, "FaDisplay", ()=>FaDisplay);
parcelHelpers.export(exports, "FaDivide", ()=>FaDivide);
parcelHelpers.export(exports, "FaDna", ()=>FaDna);
parcelHelpers.export(exports, "FaDog", ()=>FaDog);
parcelHelpers.export(exports, "FaDollarSign", ()=>FaDollarSign);
parcelHelpers.export(exports, "FaDolly", ()=>FaDolly);
parcelHelpers.export(exports, "FaDongSign", ()=>FaDongSign);
parcelHelpers.export(exports, "FaDoorClosed", ()=>FaDoorClosed);
parcelHelpers.export(exports, "FaDoorOpen", ()=>FaDoorOpen);
parcelHelpers.export(exports, "FaDove", ()=>FaDove);
parcelHelpers.export(exports, "FaDownLeftAndUpRightToCenter", ()=>FaDownLeftAndUpRightToCenter);
parcelHelpers.export(exports, "FaDownLong", ()=>FaDownLong);
parcelHelpers.export(exports, "FaDownload", ()=>FaDownload);
parcelHelpers.export(exports, "FaDragon", ()=>FaDragon);
parcelHelpers.export(exports, "FaDrawPolygon", ()=>FaDrawPolygon);
parcelHelpers.export(exports, "FaDropletSlash", ()=>FaDropletSlash);
parcelHelpers.export(exports, "FaDroplet", ()=>FaDroplet);
parcelHelpers.export(exports, "FaDrumSteelpan", ()=>FaDrumSteelpan);
parcelHelpers.export(exports, "FaDrum", ()=>FaDrum);
parcelHelpers.export(exports, "FaDrumstickBite", ()=>FaDrumstickBite);
parcelHelpers.export(exports, "FaDumbbell", ()=>FaDumbbell);
parcelHelpers.export(exports, "FaDumpsterFire", ()=>FaDumpsterFire);
parcelHelpers.export(exports, "FaDumpster", ()=>FaDumpster);
parcelHelpers.export(exports, "FaDungeon", ()=>FaDungeon);
parcelHelpers.export(exports, "FaE", ()=>FaE);
parcelHelpers.export(exports, "FaEarDeaf", ()=>FaEarDeaf);
parcelHelpers.export(exports, "FaEarListen", ()=>FaEarListen);
parcelHelpers.export(exports, "FaEarthAfrica", ()=>FaEarthAfrica);
parcelHelpers.export(exports, "FaEarthAmericas", ()=>FaEarthAmericas);
parcelHelpers.export(exports, "FaEarthAsia", ()=>FaEarthAsia);
parcelHelpers.export(exports, "FaEarthEurope", ()=>FaEarthEurope);
parcelHelpers.export(exports, "FaEarthOceania", ()=>FaEarthOceania);
parcelHelpers.export(exports, "FaEgg", ()=>FaEgg);
parcelHelpers.export(exports, "FaEject", ()=>FaEject);
parcelHelpers.export(exports, "FaElevator", ()=>FaElevator);
parcelHelpers.export(exports, "FaEllipsisVertical", ()=>FaEllipsisVertical);
parcelHelpers.export(exports, "FaEllipsis", ()=>FaEllipsis);
parcelHelpers.export(exports, "FaEnvelopeCircleCheck", ()=>FaEnvelopeCircleCheck);
parcelHelpers.export(exports, "FaEnvelopeOpenText", ()=>FaEnvelopeOpenText);
parcelHelpers.export(exports, "FaEnvelopeOpen", ()=>FaEnvelopeOpen);
parcelHelpers.export(exports, "FaEnvelope", ()=>FaEnvelope);
parcelHelpers.export(exports, "FaEnvelopesBulk", ()=>FaEnvelopesBulk);
parcelHelpers.export(exports, "FaEquals", ()=>FaEquals);
parcelHelpers.export(exports, "FaEraser", ()=>FaEraser);
parcelHelpers.export(exports, "FaEthernet", ()=>FaEthernet);
parcelHelpers.export(exports, "FaEuroSign", ()=>FaEuroSign);
parcelHelpers.export(exports, "FaExclamation", ()=>FaExclamation);
parcelHelpers.export(exports, "FaExpand", ()=>FaExpand);
parcelHelpers.export(exports, "FaExplosion", ()=>FaExplosion);
parcelHelpers.export(exports, "FaEyeDropper", ()=>FaEyeDropper);
parcelHelpers.export(exports, "FaEyeLowVision", ()=>FaEyeLowVision);
parcelHelpers.export(exports, "FaEyeSlash", ()=>FaEyeSlash);
parcelHelpers.export(exports, "FaEye", ()=>FaEye);
parcelHelpers.export(exports, "FaF", ()=>FaF);
parcelHelpers.export(exports, "FaFaceAngry", ()=>FaFaceAngry);
parcelHelpers.export(exports, "FaFaceDizzy", ()=>FaFaceDizzy);
parcelHelpers.export(exports, "FaFaceFlushed", ()=>FaFaceFlushed);
parcelHelpers.export(exports, "FaFaceFrownOpen", ()=>FaFaceFrownOpen);
parcelHelpers.export(exports, "FaFaceFrown", ()=>FaFaceFrown);
parcelHelpers.export(exports, "FaFaceGrimace", ()=>FaFaceGrimace);
parcelHelpers.export(exports, "FaFaceGrinBeamSweat", ()=>FaFaceGrinBeamSweat);
parcelHelpers.export(exports, "FaFaceGrinBeam", ()=>FaFaceGrinBeam);
parcelHelpers.export(exports, "FaFaceGrinHearts", ()=>FaFaceGrinHearts);
parcelHelpers.export(exports, "FaFaceGrinSquintTears", ()=>FaFaceGrinSquintTears);
parcelHelpers.export(exports, "FaFaceGrinSquint", ()=>FaFaceGrinSquint);
parcelHelpers.export(exports, "FaFaceGrinStars", ()=>FaFaceGrinStars);
parcelHelpers.export(exports, "FaFaceGrinTears", ()=>FaFaceGrinTears);
parcelHelpers.export(exports, "FaFaceGrinTongueSquint", ()=>FaFaceGrinTongueSquint);
parcelHelpers.export(exports, "FaFaceGrinTongueWink", ()=>FaFaceGrinTongueWink);
parcelHelpers.export(exports, "FaFaceGrinTongue", ()=>FaFaceGrinTongue);
parcelHelpers.export(exports, "FaFaceGrinWide", ()=>FaFaceGrinWide);
parcelHelpers.export(exports, "FaFaceGrinWink", ()=>FaFaceGrinWink);
parcelHelpers.export(exports, "FaFaceGrin", ()=>FaFaceGrin);
parcelHelpers.export(exports, "FaFaceKissBeam", ()=>FaFaceKissBeam);
parcelHelpers.export(exports, "FaFaceKissWinkHeart", ()=>FaFaceKissWinkHeart);
parcelHelpers.export(exports, "FaFaceKiss", ()=>FaFaceKiss);
parcelHelpers.export(exports, "FaFaceLaughBeam", ()=>FaFaceLaughBeam);
parcelHelpers.export(exports, "FaFaceLaughSquint", ()=>FaFaceLaughSquint);
parcelHelpers.export(exports, "FaFaceLaughWink", ()=>FaFaceLaughWink);
parcelHelpers.export(exports, "FaFaceLaugh", ()=>FaFaceLaugh);
parcelHelpers.export(exports, "FaFaceMehBlank", ()=>FaFaceMehBlank);
parcelHelpers.export(exports, "FaFaceMeh", ()=>FaFaceMeh);
parcelHelpers.export(exports, "FaFaceRollingEyes", ()=>FaFaceRollingEyes);
parcelHelpers.export(exports, "FaFaceSadCry", ()=>FaFaceSadCry);
parcelHelpers.export(exports, "FaFaceSadTear", ()=>FaFaceSadTear);
parcelHelpers.export(exports, "FaFaceSmileBeam", ()=>FaFaceSmileBeam);
parcelHelpers.export(exports, "FaFaceSmileWink", ()=>FaFaceSmileWink);
parcelHelpers.export(exports, "FaFaceSmile", ()=>FaFaceSmile);
parcelHelpers.export(exports, "FaFaceSurprise", ()=>FaFaceSurprise);
parcelHelpers.export(exports, "FaFaceTired", ()=>FaFaceTired);
parcelHelpers.export(exports, "FaFan", ()=>FaFan);
parcelHelpers.export(exports, "FaFaucetDrip", ()=>FaFaucetDrip);
parcelHelpers.export(exports, "FaFaucet", ()=>FaFaucet);
parcelHelpers.export(exports, "FaFax", ()=>FaFax);
parcelHelpers.export(exports, "FaFeatherPointed", ()=>FaFeatherPointed);
parcelHelpers.export(exports, "FaFeather", ()=>FaFeather);
parcelHelpers.export(exports, "FaFerry", ()=>FaFerry);
parcelHelpers.export(exports, "FaFileArrowDown", ()=>FaFileArrowDown);
parcelHelpers.export(exports, "FaFileArrowUp", ()=>FaFileArrowUp);
parcelHelpers.export(exports, "FaFileAudio", ()=>FaFileAudio);
parcelHelpers.export(exports, "FaFileCircleCheck", ()=>FaFileCircleCheck);
parcelHelpers.export(exports, "FaFileCircleExclamation", ()=>FaFileCircleExclamation);
parcelHelpers.export(exports, "FaFileCircleMinus", ()=>FaFileCircleMinus);
parcelHelpers.export(exports, "FaFileCirclePlus", ()=>FaFileCirclePlus);
parcelHelpers.export(exports, "FaFileCircleQuestion", ()=>FaFileCircleQuestion);
parcelHelpers.export(exports, "FaFileCircleXmark", ()=>FaFileCircleXmark);
parcelHelpers.export(exports, "FaFileCode", ()=>FaFileCode);
parcelHelpers.export(exports, "FaFileContract", ()=>FaFileContract);
parcelHelpers.export(exports, "FaFileCsv", ()=>FaFileCsv);
parcelHelpers.export(exports, "FaFileExcel", ()=>FaFileExcel);
parcelHelpers.export(exports, "FaFileExport", ()=>FaFileExport);
parcelHelpers.export(exports, "FaFileImage", ()=>FaFileImage);
parcelHelpers.export(exports, "FaFileImport", ()=>FaFileImport);
parcelHelpers.export(exports, "FaFileInvoiceDollar", ()=>FaFileInvoiceDollar);
parcelHelpers.export(exports, "FaFileInvoice", ()=>FaFileInvoice);
parcelHelpers.export(exports, "FaFileLines", ()=>FaFileLines);
parcelHelpers.export(exports, "FaFileMedical", ()=>FaFileMedical);
parcelHelpers.export(exports, "FaFilePdf", ()=>FaFilePdf);
parcelHelpers.export(exports, "FaFilePen", ()=>FaFilePen);
parcelHelpers.export(exports, "FaFilePowerpoint", ()=>FaFilePowerpoint);
parcelHelpers.export(exports, "FaFilePrescription", ()=>FaFilePrescription);
parcelHelpers.export(exports, "FaFileShield", ()=>FaFileShield);
parcelHelpers.export(exports, "FaFileSignature", ()=>FaFileSignature);
parcelHelpers.export(exports, "FaFileVideo", ()=>FaFileVideo);
parcelHelpers.export(exports, "FaFileWaveform", ()=>FaFileWaveform);
parcelHelpers.export(exports, "FaFileWord", ()=>FaFileWord);
parcelHelpers.export(exports, "FaFileZipper", ()=>FaFileZipper);
parcelHelpers.export(exports, "FaFile", ()=>FaFile);
parcelHelpers.export(exports, "FaFillDrip", ()=>FaFillDrip);
parcelHelpers.export(exports, "FaFill", ()=>FaFill);
parcelHelpers.export(exports, "FaFilm", ()=>FaFilm);
parcelHelpers.export(exports, "FaFilterCircleDollar", ()=>FaFilterCircleDollar);
parcelHelpers.export(exports, "FaFilterCircleXmark", ()=>FaFilterCircleXmark);
parcelHelpers.export(exports, "FaFilter", ()=>FaFilter);
parcelHelpers.export(exports, "FaFingerprint", ()=>FaFingerprint);
parcelHelpers.export(exports, "FaFireBurner", ()=>FaFireBurner);
parcelHelpers.export(exports, "FaFireExtinguisher", ()=>FaFireExtinguisher);
parcelHelpers.export(exports, "FaFireFlameCurved", ()=>FaFireFlameCurved);
parcelHelpers.export(exports, "FaFireFlameSimple", ()=>FaFireFlameSimple);
parcelHelpers.export(exports, "FaFire", ()=>FaFire);
parcelHelpers.export(exports, "FaFishFins", ()=>FaFishFins);
parcelHelpers.export(exports, "FaFish", ()=>FaFish);
parcelHelpers.export(exports, "FaFlagCheckered", ()=>FaFlagCheckered);
parcelHelpers.export(exports, "FaFlagUsa", ()=>FaFlagUsa);
parcelHelpers.export(exports, "FaFlag", ()=>FaFlag);
parcelHelpers.export(exports, "FaFlaskVial", ()=>FaFlaskVial);
parcelHelpers.export(exports, "FaFlask", ()=>FaFlask);
parcelHelpers.export(exports, "FaFloppyDisk", ()=>FaFloppyDisk);
parcelHelpers.export(exports, "FaFlorinSign", ()=>FaFlorinSign);
parcelHelpers.export(exports, "FaFolderClosed", ()=>FaFolderClosed);
parcelHelpers.export(exports, "FaFolderMinus", ()=>FaFolderMinus);
parcelHelpers.export(exports, "FaFolderOpen", ()=>FaFolderOpen);
parcelHelpers.export(exports, "FaFolderPlus", ()=>FaFolderPlus);
parcelHelpers.export(exports, "FaFolderTree", ()=>FaFolderTree);
parcelHelpers.export(exports, "FaFolder", ()=>FaFolder);
parcelHelpers.export(exports, "FaFont", ()=>FaFont);
parcelHelpers.export(exports, "FaFootball", ()=>FaFootball);
parcelHelpers.export(exports, "FaForwardFast", ()=>FaForwardFast);
parcelHelpers.export(exports, "FaForwardStep", ()=>FaForwardStep);
parcelHelpers.export(exports, "FaForward", ()=>FaForward);
parcelHelpers.export(exports, "FaFrancSign", ()=>FaFrancSign);
parcelHelpers.export(exports, "FaFrog", ()=>FaFrog);
parcelHelpers.export(exports, "FaFutbol", ()=>FaFutbol);
parcelHelpers.export(exports, "FaG", ()=>FaG);
parcelHelpers.export(exports, "FaGamepad", ()=>FaGamepad);
parcelHelpers.export(exports, "FaGasPump", ()=>FaGasPump);
parcelHelpers.export(exports, "FaGaugeHigh", ()=>FaGaugeHigh);
parcelHelpers.export(exports, "FaGaugeSimpleHigh", ()=>FaGaugeSimpleHigh);
parcelHelpers.export(exports, "FaGaugeSimple", ()=>FaGaugeSimple);
parcelHelpers.export(exports, "FaGauge", ()=>FaGauge);
parcelHelpers.export(exports, "FaGavel", ()=>FaGavel);
parcelHelpers.export(exports, "FaGear", ()=>FaGear);
parcelHelpers.export(exports, "FaGears", ()=>FaGears);
parcelHelpers.export(exports, "FaGem", ()=>FaGem);
parcelHelpers.export(exports, "FaGenderless", ()=>FaGenderless);
parcelHelpers.export(exports, "FaGhost", ()=>FaGhost);
parcelHelpers.export(exports, "FaGift", ()=>FaGift);
parcelHelpers.export(exports, "FaGifts", ()=>FaGifts);
parcelHelpers.export(exports, "FaGlassWaterDroplet", ()=>FaGlassWaterDroplet);
parcelHelpers.export(exports, "FaGlassWater", ()=>FaGlassWater);
parcelHelpers.export(exports, "FaGlasses", ()=>FaGlasses);
parcelHelpers.export(exports, "FaGlobe", ()=>FaGlobe);
parcelHelpers.export(exports, "FaGolfBallTee", ()=>FaGolfBallTee);
parcelHelpers.export(exports, "FaGopuram", ()=>FaGopuram);
parcelHelpers.export(exports, "FaGraduationCap", ()=>FaGraduationCap);
parcelHelpers.export(exports, "FaGreaterThanEqual", ()=>FaGreaterThanEqual);
parcelHelpers.export(exports, "FaGreaterThan", ()=>FaGreaterThan);
parcelHelpers.export(exports, "FaGripLinesVertical", ()=>FaGripLinesVertical);
parcelHelpers.export(exports, "FaGripLines", ()=>FaGripLines);
parcelHelpers.export(exports, "FaGripVertical", ()=>FaGripVertical);
parcelHelpers.export(exports, "FaGrip", ()=>FaGrip);
parcelHelpers.export(exports, "FaGroupArrowsRotate", ()=>FaGroupArrowsRotate);
parcelHelpers.export(exports, "FaGuaraniSign", ()=>FaGuaraniSign);
parcelHelpers.export(exports, "FaGuitar", ()=>FaGuitar);
parcelHelpers.export(exports, "FaGun", ()=>FaGun);
parcelHelpers.export(exports, "FaH", ()=>FaH);
parcelHelpers.export(exports, "FaHammer", ()=>FaHammer);
parcelHelpers.export(exports, "FaHamsa", ()=>FaHamsa);
parcelHelpers.export(exports, "FaHandBackFist", ()=>FaHandBackFist);
parcelHelpers.export(exports, "FaHandDots", ()=>FaHandDots);
parcelHelpers.export(exports, "FaHandFist", ()=>FaHandFist);
parcelHelpers.export(exports, "FaHandHoldingDollar", ()=>FaHandHoldingDollar);
parcelHelpers.export(exports, "FaHandHoldingDroplet", ()=>FaHandHoldingDroplet);
parcelHelpers.export(exports, "FaHandHoldingHand", ()=>FaHandHoldingHand);
parcelHelpers.export(exports, "FaHandHoldingHeart", ()=>FaHandHoldingHeart);
parcelHelpers.export(exports, "FaHandHoldingMedical", ()=>FaHandHoldingMedical);
parcelHelpers.export(exports, "FaHandHolding", ()=>FaHandHolding);
parcelHelpers.export(exports, "FaHandLizard", ()=>FaHandLizard);
parcelHelpers.export(exports, "FaHandMiddleFinger", ()=>FaHandMiddleFinger);
parcelHelpers.export(exports, "FaHandPeace", ()=>FaHandPeace);
parcelHelpers.export(exports, "FaHandPointDown", ()=>FaHandPointDown);
parcelHelpers.export(exports, "FaHandPointLeft", ()=>FaHandPointLeft);
parcelHelpers.export(exports, "FaHandPointRight", ()=>FaHandPointRight);
parcelHelpers.export(exports, "FaHandPointUp", ()=>FaHandPointUp);
parcelHelpers.export(exports, "FaHandPointer", ()=>FaHandPointer);
parcelHelpers.export(exports, "FaHandScissors", ()=>FaHandScissors);
parcelHelpers.export(exports, "FaHandSparkles", ()=>FaHandSparkles);
parcelHelpers.export(exports, "FaHandSpock", ()=>FaHandSpock);
parcelHelpers.export(exports, "FaHand", ()=>FaHand);
parcelHelpers.export(exports, "FaHandcuffs", ()=>FaHandcuffs);
parcelHelpers.export(exports, "FaHandsAslInterpreting", ()=>FaHandsAslInterpreting);
parcelHelpers.export(exports, "FaHandsBound", ()=>FaHandsBound);
parcelHelpers.export(exports, "FaHandsBubbles", ()=>FaHandsBubbles);
parcelHelpers.export(exports, "FaHandsClapping", ()=>FaHandsClapping);
parcelHelpers.export(exports, "FaHandsHoldingChild", ()=>FaHandsHoldingChild);
parcelHelpers.export(exports, "FaHandsHoldingCircle", ()=>FaHandsHoldingCircle);
parcelHelpers.export(exports, "FaHandsHolding", ()=>FaHandsHolding);
parcelHelpers.export(exports, "FaHandsPraying", ()=>FaHandsPraying);
parcelHelpers.export(exports, "FaHands", ()=>FaHands);
parcelHelpers.export(exports, "FaHandshakeAngle", ()=>FaHandshakeAngle);
parcelHelpers.export(exports, "FaHandshakeSimpleSlash", ()=>FaHandshakeSimpleSlash);
parcelHelpers.export(exports, "FaHandshakeSimple", ()=>FaHandshakeSimple);
parcelHelpers.export(exports, "FaHandshakeSlash", ()=>FaHandshakeSlash);
parcelHelpers.export(exports, "FaHandshake", ()=>FaHandshake);
parcelHelpers.export(exports, "FaHanukiah", ()=>FaHanukiah);
parcelHelpers.export(exports, "FaHardDrive", ()=>FaHardDrive);
parcelHelpers.export(exports, "FaHashtag", ()=>FaHashtag);
parcelHelpers.export(exports, "FaHatCowboySide", ()=>FaHatCowboySide);
parcelHelpers.export(exports, "FaHatCowboy", ()=>FaHatCowboy);
parcelHelpers.export(exports, "FaHatWizard", ()=>FaHatWizard);
parcelHelpers.export(exports, "FaHeadSideCoughSlash", ()=>FaHeadSideCoughSlash);
parcelHelpers.export(exports, "FaHeadSideCough", ()=>FaHeadSideCough);
parcelHelpers.export(exports, "FaHeadSideMask", ()=>FaHeadSideMask);
parcelHelpers.export(exports, "FaHeadSideVirus", ()=>FaHeadSideVirus);
parcelHelpers.export(exports, "FaHeading", ()=>FaHeading);
parcelHelpers.export(exports, "FaHeadphonesSimple", ()=>FaHeadphonesSimple);
parcelHelpers.export(exports, "FaHeadphones", ()=>FaHeadphones);
parcelHelpers.export(exports, "FaHeadset", ()=>FaHeadset);
parcelHelpers.export(exports, "FaHeartCircleBolt", ()=>FaHeartCircleBolt);
parcelHelpers.export(exports, "FaHeartCircleCheck", ()=>FaHeartCircleCheck);
parcelHelpers.export(exports, "FaHeartCircleExclamation", ()=>FaHeartCircleExclamation);
parcelHelpers.export(exports, "FaHeartCircleMinus", ()=>FaHeartCircleMinus);
parcelHelpers.export(exports, "FaHeartCirclePlus", ()=>FaHeartCirclePlus);
parcelHelpers.export(exports, "FaHeartCircleXmark", ()=>FaHeartCircleXmark);
parcelHelpers.export(exports, "FaHeartCrack", ()=>FaHeartCrack);
parcelHelpers.export(exports, "FaHeartPulse", ()=>FaHeartPulse);
parcelHelpers.export(exports, "FaHeart", ()=>FaHeart);
parcelHelpers.export(exports, "FaHelicopterSymbol", ()=>FaHelicopterSymbol);
parcelHelpers.export(exports, "FaHelicopter", ()=>FaHelicopter);
parcelHelpers.export(exports, "FaHelmetSafety", ()=>FaHelmetSafety);
parcelHelpers.export(exports, "FaHelmetUn", ()=>FaHelmetUn);
parcelHelpers.export(exports, "FaHighlighter", ()=>FaHighlighter);
parcelHelpers.export(exports, "FaHillAvalanche", ()=>FaHillAvalanche);
parcelHelpers.export(exports, "FaHillRockslide", ()=>FaHillRockslide);
parcelHelpers.export(exports, "FaHippo", ()=>FaHippo);
parcelHelpers.export(exports, "FaHockeyPuck", ()=>FaHockeyPuck);
parcelHelpers.export(exports, "FaHollyBerry", ()=>FaHollyBerry);
parcelHelpers.export(exports, "FaHorseHead", ()=>FaHorseHead);
parcelHelpers.export(exports, "FaHorse", ()=>FaHorse);
parcelHelpers.export(exports, "FaHospitalUser", ()=>FaHospitalUser);
parcelHelpers.export(exports, "FaHospital", ()=>FaHospital);
parcelHelpers.export(exports, "FaHotTubPerson", ()=>FaHotTubPerson);
parcelHelpers.export(exports, "FaHotdog", ()=>FaHotdog);
parcelHelpers.export(exports, "FaHotel", ()=>FaHotel);
parcelHelpers.export(exports, "FaHourglassEnd", ()=>FaHourglassEnd);
parcelHelpers.export(exports, "FaHourglassHalf", ()=>FaHourglassHalf);
parcelHelpers.export(exports, "FaHourglassStart", ()=>FaHourglassStart);
parcelHelpers.export(exports, "FaHourglass", ()=>FaHourglass);
parcelHelpers.export(exports, "FaHouseChimneyCrack", ()=>FaHouseChimneyCrack);
parcelHelpers.export(exports, "FaHouseChimneyMedical", ()=>FaHouseChimneyMedical);
parcelHelpers.export(exports, "FaHouseChimneyUser", ()=>FaHouseChimneyUser);
parcelHelpers.export(exports, "FaHouseChimneyWindow", ()=>FaHouseChimneyWindow);
parcelHelpers.export(exports, "FaHouseChimney", ()=>FaHouseChimney);
parcelHelpers.export(exports, "FaHouseCircleCheck", ()=>FaHouseCircleCheck);
parcelHelpers.export(exports, "FaHouseCircleExclamation", ()=>FaHouseCircleExclamation);
parcelHelpers.export(exports, "FaHouseCircleXmark", ()=>FaHouseCircleXmark);
parcelHelpers.export(exports, "FaHouseCrack", ()=>FaHouseCrack);
parcelHelpers.export(exports, "FaHouseFire", ()=>FaHouseFire);
parcelHelpers.export(exports, "FaHouseFlag", ()=>FaHouseFlag);
parcelHelpers.export(exports, "FaHouseFloodWaterCircleArrowRight", ()=>FaHouseFloodWaterCircleArrowRight);
parcelHelpers.export(exports, "FaHouseFloodWater", ()=>FaHouseFloodWater);
parcelHelpers.export(exports, "FaHouseLaptop", ()=>FaHouseLaptop);
parcelHelpers.export(exports, "FaHouseLock", ()=>FaHouseLock);
parcelHelpers.export(exports, "FaHouseMedicalCircleCheck", ()=>FaHouseMedicalCircleCheck);
parcelHelpers.export(exports, "FaHouseMedicalCircleExclamation", ()=>FaHouseMedicalCircleExclamation);
parcelHelpers.export(exports, "FaHouseMedicalCircleXmark", ()=>FaHouseMedicalCircleXmark);
parcelHelpers.export(exports, "FaHouseMedicalFlag", ()=>FaHouseMedicalFlag);
parcelHelpers.export(exports, "FaHouseMedical", ()=>FaHouseMedical);
parcelHelpers.export(exports, "FaHouseSignal", ()=>FaHouseSignal);
parcelHelpers.export(exports, "FaHouseTsunami", ()=>FaHouseTsunami);
parcelHelpers.export(exports, "FaHouseUser", ()=>FaHouseUser);
parcelHelpers.export(exports, "FaHouse", ()=>FaHouse);
parcelHelpers.export(exports, "FaHryvniaSign", ()=>FaHryvniaSign);
parcelHelpers.export(exports, "FaHurricane", ()=>FaHurricane);
parcelHelpers.export(exports, "FaICursor", ()=>FaICursor);
parcelHelpers.export(exports, "FaI", ()=>FaI);
parcelHelpers.export(exports, "FaIceCream", ()=>FaIceCream);
parcelHelpers.export(exports, "FaIcicles", ()=>FaIcicles);
parcelHelpers.export(exports, "FaIcons", ()=>FaIcons);
parcelHelpers.export(exports, "FaIdBadge", ()=>FaIdBadge);
parcelHelpers.export(exports, "FaIdCardClip", ()=>FaIdCardClip);
parcelHelpers.export(exports, "FaIdCard", ()=>FaIdCard);
parcelHelpers.export(exports, "FaIgloo", ()=>FaIgloo);
parcelHelpers.export(exports, "FaImagePortrait", ()=>FaImagePortrait);
parcelHelpers.export(exports, "FaImage", ()=>FaImage);
parcelHelpers.export(exports, "FaImages", ()=>FaImages);
parcelHelpers.export(exports, "FaInbox", ()=>FaInbox);
parcelHelpers.export(exports, "FaIndent", ()=>FaIndent);
parcelHelpers.export(exports, "FaIndianRupeeSign", ()=>FaIndianRupeeSign);
parcelHelpers.export(exports, "FaIndustry", ()=>FaIndustry);
parcelHelpers.export(exports, "FaInfinity", ()=>FaInfinity);
parcelHelpers.export(exports, "FaInfo", ()=>FaInfo);
parcelHelpers.export(exports, "FaItalic", ()=>FaItalic);
parcelHelpers.export(exports, "FaJ", ()=>FaJ);
parcelHelpers.export(exports, "FaJarWheat", ()=>FaJarWheat);
parcelHelpers.export(exports, "FaJar", ()=>FaJar);
parcelHelpers.export(exports, "FaJedi", ()=>FaJedi);
parcelHelpers.export(exports, "FaJetFighterUp", ()=>FaJetFighterUp);
parcelHelpers.export(exports, "FaJetFighter", ()=>FaJetFighter);
parcelHelpers.export(exports, "FaJoint", ()=>FaJoint);
parcelHelpers.export(exports, "FaJugDetergent", ()=>FaJugDetergent);
parcelHelpers.export(exports, "FaK", ()=>FaK);
parcelHelpers.export(exports, "FaKaaba", ()=>FaKaaba);
parcelHelpers.export(exports, "FaKey", ()=>FaKey);
parcelHelpers.export(exports, "FaKeyboard", ()=>FaKeyboard);
parcelHelpers.export(exports, "FaKhanda", ()=>FaKhanda);
parcelHelpers.export(exports, "FaKipSign", ()=>FaKipSign);
parcelHelpers.export(exports, "FaKitMedical", ()=>FaKitMedical);
parcelHelpers.export(exports, "FaKitchenSet", ()=>FaKitchenSet);
parcelHelpers.export(exports, "FaKiwiBird", ()=>FaKiwiBird);
parcelHelpers.export(exports, "FaL", ()=>FaL);
parcelHelpers.export(exports, "FaLandMineOn", ()=>FaLandMineOn);
parcelHelpers.export(exports, "FaLandmarkDome", ()=>FaLandmarkDome);
parcelHelpers.export(exports, "FaLandmarkFlag", ()=>FaLandmarkFlag);
parcelHelpers.export(exports, "FaLandmark", ()=>FaLandmark);
parcelHelpers.export(exports, "FaLanguage", ()=>FaLanguage);
parcelHelpers.export(exports, "FaLaptopCode", ()=>FaLaptopCode);
parcelHelpers.export(exports, "FaLaptopFile", ()=>FaLaptopFile);
parcelHelpers.export(exports, "FaLaptopMedical", ()=>FaLaptopMedical);
parcelHelpers.export(exports, "FaLaptop", ()=>FaLaptop);
parcelHelpers.export(exports, "FaLariSign", ()=>FaLariSign);
parcelHelpers.export(exports, "FaLayerGroup", ()=>FaLayerGroup);
parcelHelpers.export(exports, "FaLeaf", ()=>FaLeaf);
parcelHelpers.export(exports, "FaLeftLong", ()=>FaLeftLong);
parcelHelpers.export(exports, "FaLeftRight", ()=>FaLeftRight);
parcelHelpers.export(exports, "FaLemon", ()=>FaLemon);
parcelHelpers.export(exports, "FaLessThanEqual", ()=>FaLessThanEqual);
parcelHelpers.export(exports, "FaLessThan", ()=>FaLessThan);
parcelHelpers.export(exports, "FaLifeRing", ()=>FaLifeRing);
parcelHelpers.export(exports, "FaLightbulb", ()=>FaLightbulb);
parcelHelpers.export(exports, "FaLinesLeaning", ()=>FaLinesLeaning);
parcelHelpers.export(exports, "FaLinkSlash", ()=>FaLinkSlash);
parcelHelpers.export(exports, "FaLink", ()=>FaLink);
parcelHelpers.export(exports, "FaLiraSign", ()=>FaLiraSign);
parcelHelpers.export(exports, "FaListCheck", ()=>FaListCheck);
parcelHelpers.export(exports, "FaListOl", ()=>FaListOl);
parcelHelpers.export(exports, "FaListUl", ()=>FaListUl);
parcelHelpers.export(exports, "FaList", ()=>FaList);
parcelHelpers.export(exports, "FaLitecoinSign", ()=>FaLitecoinSign);
parcelHelpers.export(exports, "FaLocationArrow", ()=>FaLocationArrow);
parcelHelpers.export(exports, "FaLocationCrosshairs", ()=>FaLocationCrosshairs);
parcelHelpers.export(exports, "FaLocationDot", ()=>FaLocationDot);
parcelHelpers.export(exports, "FaLocationPinLock", ()=>FaLocationPinLock);
parcelHelpers.export(exports, "FaLocationPin", ()=>FaLocationPin);
parcelHelpers.export(exports, "FaLockOpen", ()=>FaLockOpen);
parcelHelpers.export(exports, "FaLock", ()=>FaLock);
parcelHelpers.export(exports, "FaLocust", ()=>FaLocust);
parcelHelpers.export(exports, "FaLungsVirus", ()=>FaLungsVirus);
parcelHelpers.export(exports, "FaLungs", ()=>FaLungs);
parcelHelpers.export(exports, "FaM", ()=>FaM);
parcelHelpers.export(exports, "FaMagnet", ()=>FaMagnet);
parcelHelpers.export(exports, "FaMagnifyingGlassArrowRight", ()=>FaMagnifyingGlassArrowRight);
parcelHelpers.export(exports, "FaMagnifyingGlassChart", ()=>FaMagnifyingGlassChart);
parcelHelpers.export(exports, "FaMagnifyingGlassDollar", ()=>FaMagnifyingGlassDollar);
parcelHelpers.export(exports, "FaMagnifyingGlassLocation", ()=>FaMagnifyingGlassLocation);
parcelHelpers.export(exports, "FaMagnifyingGlassMinus", ()=>FaMagnifyingGlassMinus);
parcelHelpers.export(exports, "FaMagnifyingGlassPlus", ()=>FaMagnifyingGlassPlus);
parcelHelpers.export(exports, "FaMagnifyingGlass", ()=>FaMagnifyingGlass);
parcelHelpers.export(exports, "FaManatSign", ()=>FaManatSign);
parcelHelpers.export(exports, "FaMapLocationDot", ()=>FaMapLocationDot);
parcelHelpers.export(exports, "FaMapLocation", ()=>FaMapLocation);
parcelHelpers.export(exports, "FaMapPin", ()=>FaMapPin);
parcelHelpers.export(exports, "FaMap", ()=>FaMap);
parcelHelpers.export(exports, "FaMarker", ()=>FaMarker);
parcelHelpers.export(exports, "FaMarsAndVenusBurst", ()=>FaMarsAndVenusBurst);
parcelHelpers.export(exports, "FaMarsAndVenus", ()=>FaMarsAndVenus);
parcelHelpers.export(exports, "FaMarsDouble", ()=>FaMarsDouble);
parcelHelpers.export(exports, "FaMarsStrokeRight", ()=>FaMarsStrokeRight);
parcelHelpers.export(exports, "FaMarsStrokeUp", ()=>FaMarsStrokeUp);
parcelHelpers.export(exports, "FaMarsStroke", ()=>FaMarsStroke);
parcelHelpers.export(exports, "FaMars", ()=>FaMars);
parcelHelpers.export(exports, "FaMartiniGlassCitrus", ()=>FaMartiniGlassCitrus);
parcelHelpers.export(exports, "FaMartiniGlassEmpty", ()=>FaMartiniGlassEmpty);
parcelHelpers.export(exports, "FaMartiniGlass", ()=>FaMartiniGlass);
parcelHelpers.export(exports, "FaMaskFace", ()=>FaMaskFace);
parcelHelpers.export(exports, "FaMaskVentilator", ()=>FaMaskVentilator);
parcelHelpers.export(exports, "FaMask", ()=>FaMask);
parcelHelpers.export(exports, "FaMasksTheater", ()=>FaMasksTheater);
parcelHelpers.export(exports, "FaMattressPillow", ()=>FaMattressPillow);
parcelHelpers.export(exports, "FaMaximize", ()=>FaMaximize);
parcelHelpers.export(exports, "FaMedal", ()=>FaMedal);
parcelHelpers.export(exports, "FaMemory", ()=>FaMemory);
parcelHelpers.export(exports, "FaMenorah", ()=>FaMenorah);
parcelHelpers.export(exports, "FaMercury", ()=>FaMercury);
parcelHelpers.export(exports, "FaMessage", ()=>FaMessage);
parcelHelpers.export(exports, "FaMeteor", ()=>FaMeteor);
parcelHelpers.export(exports, "FaMicrochip", ()=>FaMicrochip);
parcelHelpers.export(exports, "FaMicrophoneLinesSlash", ()=>FaMicrophoneLinesSlash);
parcelHelpers.export(exports, "FaMicrophoneLines", ()=>FaMicrophoneLines);
parcelHelpers.export(exports, "FaMicrophoneSlash", ()=>FaMicrophoneSlash);
parcelHelpers.export(exports, "FaMicrophone", ()=>FaMicrophone);
parcelHelpers.export(exports, "FaMicroscope", ()=>FaMicroscope);
parcelHelpers.export(exports, "FaMillSign", ()=>FaMillSign);
parcelHelpers.export(exports, "FaMinimize", ()=>FaMinimize);
parcelHelpers.export(exports, "FaMinus", ()=>FaMinus);
parcelHelpers.export(exports, "FaMitten", ()=>FaMitten);
parcelHelpers.export(exports, "FaMobileButton", ()=>FaMobileButton);
parcelHelpers.export(exports, "FaMobileRetro", ()=>FaMobileRetro);
parcelHelpers.export(exports, "FaMobileScreenButton", ()=>FaMobileScreenButton);
parcelHelpers.export(exports, "FaMobileScreen", ()=>FaMobileScreen);
parcelHelpers.export(exports, "FaMobile", ()=>FaMobile);
parcelHelpers.export(exports, "FaMoneyBill1Wave", ()=>FaMoneyBill1Wave);
parcelHelpers.export(exports, "FaMoneyBill1", ()=>FaMoneyBill1);
parcelHelpers.export(exports, "FaMoneyBillTransfer", ()=>FaMoneyBillTransfer);
parcelHelpers.export(exports, "FaMoneyBillTrendUp", ()=>FaMoneyBillTrendUp);
parcelHelpers.export(exports, "FaMoneyBillWave", ()=>FaMoneyBillWave);
parcelHelpers.export(exports, "FaMoneyBillWheat", ()=>FaMoneyBillWheat);
parcelHelpers.export(exports, "FaMoneyBill", ()=>FaMoneyBill);
parcelHelpers.export(exports, "FaMoneyBills", ()=>FaMoneyBills);
parcelHelpers.export(exports, "FaMoneyCheckDollar", ()=>FaMoneyCheckDollar);
parcelHelpers.export(exports, "FaMoneyCheck", ()=>FaMoneyCheck);
parcelHelpers.export(exports, "FaMonument", ()=>FaMonument);
parcelHelpers.export(exports, "FaMoon", ()=>FaMoon);
parcelHelpers.export(exports, "FaMortarPestle", ()=>FaMortarPestle);
parcelHelpers.export(exports, "FaMosque", ()=>FaMosque);
parcelHelpers.export(exports, "FaMosquitoNet", ()=>FaMosquitoNet);
parcelHelpers.export(exports, "FaMosquito", ()=>FaMosquito);
parcelHelpers.export(exports, "FaMotorcycle", ()=>FaMotorcycle);
parcelHelpers.export(exports, "FaMound", ()=>FaMound);
parcelHelpers.export(exports, "FaMountainCity", ()=>FaMountainCity);
parcelHelpers.export(exports, "FaMountainSun", ()=>FaMountainSun);
parcelHelpers.export(exports, "FaMountain", ()=>FaMountain);
parcelHelpers.export(exports, "FaMugHot", ()=>FaMugHot);
parcelHelpers.export(exports, "FaMugSaucer", ()=>FaMugSaucer);
parcelHelpers.export(exports, "FaMusic", ()=>FaMusic);
parcelHelpers.export(exports, "FaN", ()=>FaN);
parcelHelpers.export(exports, "FaNairaSign", ()=>FaNairaSign);
parcelHelpers.export(exports, "FaNetworkWired", ()=>FaNetworkWired);
parcelHelpers.export(exports, "FaNeuter", ()=>FaNeuter);
parcelHelpers.export(exports, "FaNewspaper", ()=>FaNewspaper);
parcelHelpers.export(exports, "FaNotEqual", ()=>FaNotEqual);
parcelHelpers.export(exports, "FaNotdef", ()=>FaNotdef);
parcelHelpers.export(exports, "FaNoteSticky", ()=>FaNoteSticky);
parcelHelpers.export(exports, "FaNotesMedical", ()=>FaNotesMedical);
parcelHelpers.export(exports, "FaO", ()=>FaO);
parcelHelpers.export(exports, "FaObjectGroup", ()=>FaObjectGroup);
parcelHelpers.export(exports, "FaObjectUngroup", ()=>FaObjectUngroup);
parcelHelpers.export(exports, "FaOilCan", ()=>FaOilCan);
parcelHelpers.export(exports, "FaOilWell", ()=>FaOilWell);
parcelHelpers.export(exports, "FaOm", ()=>FaOm);
parcelHelpers.export(exports, "FaOtter", ()=>FaOtter);
parcelHelpers.export(exports, "FaOutdent", ()=>FaOutdent);
parcelHelpers.export(exports, "FaP", ()=>FaP);
parcelHelpers.export(exports, "FaPager", ()=>FaPager);
parcelHelpers.export(exports, "FaPaintRoller", ()=>FaPaintRoller);
parcelHelpers.export(exports, "FaPaintbrush", ()=>FaPaintbrush);
parcelHelpers.export(exports, "FaPalette", ()=>FaPalette);
parcelHelpers.export(exports, "FaPallet", ()=>FaPallet);
parcelHelpers.export(exports, "FaPanorama", ()=>FaPanorama);
parcelHelpers.export(exports, "FaPaperPlane", ()=>FaPaperPlane);
parcelHelpers.export(exports, "FaPaperclip", ()=>FaPaperclip);
parcelHelpers.export(exports, "FaParachuteBox", ()=>FaParachuteBox);
parcelHelpers.export(exports, "FaParagraph", ()=>FaParagraph);
parcelHelpers.export(exports, "FaPassport", ()=>FaPassport);
parcelHelpers.export(exports, "FaPaste", ()=>FaPaste);
parcelHelpers.export(exports, "FaPause", ()=>FaPause);
parcelHelpers.export(exports, "FaPaw", ()=>FaPaw);
parcelHelpers.export(exports, "FaPeace", ()=>FaPeace);
parcelHelpers.export(exports, "FaPenClip", ()=>FaPenClip);
parcelHelpers.export(exports, "FaPenFancy", ()=>FaPenFancy);
parcelHelpers.export(exports, "FaPenNib", ()=>FaPenNib);
parcelHelpers.export(exports, "FaPenRuler", ()=>FaPenRuler);
parcelHelpers.export(exports, "FaPenToSquare", ()=>FaPenToSquare);
parcelHelpers.export(exports, "FaPen", ()=>FaPen);
parcelHelpers.export(exports, "FaPencil", ()=>FaPencil);
parcelHelpers.export(exports, "FaPeopleArrows", ()=>FaPeopleArrows);
parcelHelpers.export(exports, "FaPeopleCarryBox", ()=>FaPeopleCarryBox);
parcelHelpers.export(exports, "FaPeopleGroup", ()=>FaPeopleGroup);
parcelHelpers.export(exports, "FaPeopleLine", ()=>FaPeopleLine);
parcelHelpers.export(exports, "FaPeoplePulling", ()=>FaPeoplePulling);
parcelHelpers.export(exports, "FaPeopleRobbery", ()=>FaPeopleRobbery);
parcelHelpers.export(exports, "FaPeopleRoof", ()=>FaPeopleRoof);
parcelHelpers.export(exports, "FaPepperHot", ()=>FaPepperHot);
parcelHelpers.export(exports, "FaPercent", ()=>FaPercent);
parcelHelpers.export(exports, "FaPersonArrowDownToLine", ()=>FaPersonArrowDownToLine);
parcelHelpers.export(exports, "FaPersonArrowUpFromLine", ()=>FaPersonArrowUpFromLine);
parcelHelpers.export(exports, "FaPersonBiking", ()=>FaPersonBiking);
parcelHelpers.export(exports, "FaPersonBooth", ()=>FaPersonBooth);
parcelHelpers.export(exports, "FaPersonBreastfeeding", ()=>FaPersonBreastfeeding);
parcelHelpers.export(exports, "FaPersonBurst", ()=>FaPersonBurst);
parcelHelpers.export(exports, "FaPersonCane", ()=>FaPersonCane);
parcelHelpers.export(exports, "FaPersonChalkboard", ()=>FaPersonChalkboard);
parcelHelpers.export(exports, "FaPersonCircleCheck", ()=>FaPersonCircleCheck);
parcelHelpers.export(exports, "FaPersonCircleExclamation", ()=>FaPersonCircleExclamation);
parcelHelpers.export(exports, "FaPersonCircleMinus", ()=>FaPersonCircleMinus);
parcelHelpers.export(exports, "FaPersonCirclePlus", ()=>FaPersonCirclePlus);
parcelHelpers.export(exports, "FaPersonCircleQuestion", ()=>FaPersonCircleQuestion);
parcelHelpers.export(exports, "FaPersonCircleXmark", ()=>FaPersonCircleXmark);
parcelHelpers.export(exports, "FaPersonDigging", ()=>FaPersonDigging);
parcelHelpers.export(exports, "FaPersonDotsFromLine", ()=>FaPersonDotsFromLine);
parcelHelpers.export(exports, "FaPersonDressBurst", ()=>FaPersonDressBurst);
parcelHelpers.export(exports, "FaPersonDress", ()=>FaPersonDress);
parcelHelpers.export(exports, "FaPersonDrowning", ()=>FaPersonDrowning);
parcelHelpers.export(exports, "FaPersonFallingBurst", ()=>FaPersonFallingBurst);
parcelHelpers.export(exports, "FaPersonFalling", ()=>FaPersonFalling);
parcelHelpers.export(exports, "FaPersonHalfDress", ()=>FaPersonHalfDress);
parcelHelpers.export(exports, "FaPersonHarassing", ()=>FaPersonHarassing);
parcelHelpers.export(exports, "FaPersonHiking", ()=>FaPersonHiking);
parcelHelpers.export(exports, "FaPersonMilitaryPointing", ()=>FaPersonMilitaryPointing);
parcelHelpers.export(exports, "FaPersonMilitaryRifle", ()=>FaPersonMilitaryRifle);
parcelHelpers.export(exports, "FaPersonMilitaryToPerson", ()=>FaPersonMilitaryToPerson);
parcelHelpers.export(exports, "FaPersonPraying", ()=>FaPersonPraying);
parcelHelpers.export(exports, "FaPersonPregnant", ()=>FaPersonPregnant);
parcelHelpers.export(exports, "FaPersonRays", ()=>FaPersonRays);
parcelHelpers.export(exports, "FaPersonRifle", ()=>FaPersonRifle);
parcelHelpers.export(exports, "FaPersonRunning", ()=>FaPersonRunning);
parcelHelpers.export(exports, "FaPersonShelter", ()=>FaPersonShelter);
parcelHelpers.export(exports, "FaPersonSkating", ()=>FaPersonSkating);
parcelHelpers.export(exports, "FaPersonSkiingNordic", ()=>FaPersonSkiingNordic);
parcelHelpers.export(exports, "FaPersonSkiing", ()=>FaPersonSkiing);
parcelHelpers.export(exports, "FaPersonSnowboarding", ()=>FaPersonSnowboarding);
parcelHelpers.export(exports, "FaPersonSwimming", ()=>FaPersonSwimming);
parcelHelpers.export(exports, "FaPersonThroughWindow", ()=>FaPersonThroughWindow);
parcelHelpers.export(exports, "FaPersonWalkingArrowLoopLeft", ()=>FaPersonWalkingArrowLoopLeft);
parcelHelpers.export(exports, "FaPersonWalkingArrowRight", ()=>FaPersonWalkingArrowRight);
parcelHelpers.export(exports, "FaPersonWalkingDashedLineArrowRight", ()=>FaPersonWalkingDashedLineArrowRight);
parcelHelpers.export(exports, "FaPersonWalkingLuggage", ()=>FaPersonWalkingLuggage);
parcelHelpers.export(exports, "FaPersonWalkingWithCane", ()=>FaPersonWalkingWithCane);
parcelHelpers.export(exports, "FaPersonWalking", ()=>FaPersonWalking);
parcelHelpers.export(exports, "FaPerson", ()=>FaPerson);
parcelHelpers.export(exports, "FaPesetaSign", ()=>FaPesetaSign);
parcelHelpers.export(exports, "FaPesoSign", ()=>FaPesoSign);
parcelHelpers.export(exports, "FaPhoneFlip", ()=>FaPhoneFlip);
parcelHelpers.export(exports, "FaPhoneSlash", ()=>FaPhoneSlash);
parcelHelpers.export(exports, "FaPhoneVolume", ()=>FaPhoneVolume);
parcelHelpers.export(exports, "FaPhone", ()=>FaPhone);
parcelHelpers.export(exports, "FaPhotoFilm", ()=>FaPhotoFilm);
parcelHelpers.export(exports, "FaPiggyBank", ()=>FaPiggyBank);
parcelHelpers.export(exports, "FaPills", ()=>FaPills);
parcelHelpers.export(exports, "FaPizzaSlice", ()=>FaPizzaSlice);
parcelHelpers.export(exports, "FaPlaceOfWorship", ()=>FaPlaceOfWorship);
parcelHelpers.export(exports, "FaPlaneArrival", ()=>FaPlaneArrival);
parcelHelpers.export(exports, "FaPlaneCircleCheck", ()=>FaPlaneCircleCheck);
parcelHelpers.export(exports, "FaPlaneCircleExclamation", ()=>FaPlaneCircleExclamation);
parcelHelpers.export(exports, "FaPlaneCircleXmark", ()=>FaPlaneCircleXmark);
parcelHelpers.export(exports, "FaPlaneDeparture", ()=>FaPlaneDeparture);
parcelHelpers.export(exports, "FaPlaneLock", ()=>FaPlaneLock);
parcelHelpers.export(exports, "FaPlaneSlash", ()=>FaPlaneSlash);
parcelHelpers.export(exports, "FaPlaneUp", ()=>FaPlaneUp);
parcelHelpers.export(exports, "FaPlane", ()=>FaPlane);
parcelHelpers.export(exports, "FaPlantWilt", ()=>FaPlantWilt);
parcelHelpers.export(exports, "FaPlateWheat", ()=>FaPlateWheat);
parcelHelpers.export(exports, "FaPlay", ()=>FaPlay);
parcelHelpers.export(exports, "FaPlugCircleBolt", ()=>FaPlugCircleBolt);
parcelHelpers.export(exports, "FaPlugCircleCheck", ()=>FaPlugCircleCheck);
parcelHelpers.export(exports, "FaPlugCircleExclamation", ()=>FaPlugCircleExclamation);
parcelHelpers.export(exports, "FaPlugCircleMinus", ()=>FaPlugCircleMinus);
parcelHelpers.export(exports, "FaPlugCirclePlus", ()=>FaPlugCirclePlus);
parcelHelpers.export(exports, "FaPlugCircleXmark", ()=>FaPlugCircleXmark);
parcelHelpers.export(exports, "FaPlug", ()=>FaPlug);
parcelHelpers.export(exports, "FaPlusMinus", ()=>FaPlusMinus);
parcelHelpers.export(exports, "FaPlus", ()=>FaPlus);
parcelHelpers.export(exports, "FaPodcast", ()=>FaPodcast);
parcelHelpers.export(exports, "FaPooStorm", ()=>FaPooStorm);
parcelHelpers.export(exports, "FaPoo", ()=>FaPoo);
parcelHelpers.export(exports, "FaPoop", ()=>FaPoop);
parcelHelpers.export(exports, "FaPowerOff", ()=>FaPowerOff);
parcelHelpers.export(exports, "FaPrescriptionBottleMedical", ()=>FaPrescriptionBottleMedical);
parcelHelpers.export(exports, "FaPrescriptionBottle", ()=>FaPrescriptionBottle);
parcelHelpers.export(exports, "FaPrescription", ()=>FaPrescription);
parcelHelpers.export(exports, "FaPrint", ()=>FaPrint);
parcelHelpers.export(exports, "FaPumpMedical", ()=>FaPumpMedical);
parcelHelpers.export(exports, "FaPumpSoap", ()=>FaPumpSoap);
parcelHelpers.export(exports, "FaPuzzlePiece", ()=>FaPuzzlePiece);
parcelHelpers.export(exports, "FaQ", ()=>FaQ);
parcelHelpers.export(exports, "FaQrcode", ()=>FaQrcode);
parcelHelpers.export(exports, "FaQuestion", ()=>FaQuestion);
parcelHelpers.export(exports, "FaQuoteLeft", ()=>FaQuoteLeft);
parcelHelpers.export(exports, "FaQuoteRight", ()=>FaQuoteRight);
parcelHelpers.export(exports, "FaR", ()=>FaR);
parcelHelpers.export(exports, "FaRadiation", ()=>FaRadiation);
parcelHelpers.export(exports, "FaRadio", ()=>FaRadio);
parcelHelpers.export(exports, "FaRainbow", ()=>FaRainbow);
parcelHelpers.export(exports, "FaRankingStar", ()=>FaRankingStar);
parcelHelpers.export(exports, "FaReceipt", ()=>FaReceipt);
parcelHelpers.export(exports, "FaRecordVinyl", ()=>FaRecordVinyl);
parcelHelpers.export(exports, "FaRectangleAd", ()=>FaRectangleAd);
parcelHelpers.export(exports, "FaRectangleList", ()=>FaRectangleList);
parcelHelpers.export(exports, "FaRectangleXmark", ()=>FaRectangleXmark);
parcelHelpers.export(exports, "FaRecycle", ()=>FaRecycle);
parcelHelpers.export(exports, "FaRegistered", ()=>FaRegistered);
parcelHelpers.export(exports, "FaRepeat", ()=>FaRepeat);
parcelHelpers.export(exports, "FaReplyAll", ()=>FaReplyAll);
parcelHelpers.export(exports, "FaReply", ()=>FaReply);
parcelHelpers.export(exports, "FaRepublican", ()=>FaRepublican);
parcelHelpers.export(exports, "FaRestroom", ()=>FaRestroom);
parcelHelpers.export(exports, "FaRetweet", ()=>FaRetweet);
parcelHelpers.export(exports, "FaRibbon", ()=>FaRibbon);
parcelHelpers.export(exports, "FaRightFromBracket", ()=>FaRightFromBracket);
parcelHelpers.export(exports, "FaRightLeft", ()=>FaRightLeft);
parcelHelpers.export(exports, "FaRightLong", ()=>FaRightLong);
parcelHelpers.export(exports, "FaRightToBracket", ()=>FaRightToBracket);
parcelHelpers.export(exports, "FaRing", ()=>FaRing);
parcelHelpers.export(exports, "FaRoadBarrier", ()=>FaRoadBarrier);
parcelHelpers.export(exports, "FaRoadBridge", ()=>FaRoadBridge);
parcelHelpers.export(exports, "FaRoadCircleCheck", ()=>FaRoadCircleCheck);
parcelHelpers.export(exports, "FaRoadCircleExclamation", ()=>FaRoadCircleExclamation);
parcelHelpers.export(exports, "FaRoadCircleXmark", ()=>FaRoadCircleXmark);
parcelHelpers.export(exports, "FaRoadLock", ()=>FaRoadLock);
parcelHelpers.export(exports, "FaRoadSpikes", ()=>FaRoadSpikes);
parcelHelpers.export(exports, "FaRoad", ()=>FaRoad);
parcelHelpers.export(exports, "FaRobot", ()=>FaRobot);
parcelHelpers.export(exports, "FaRocket", ()=>FaRocket);
parcelHelpers.export(exports, "FaRotateLeft", ()=>FaRotateLeft);
parcelHelpers.export(exports, "FaRotateRight", ()=>FaRotateRight);
parcelHelpers.export(exports, "FaRotate", ()=>FaRotate);
parcelHelpers.export(exports, "FaRoute", ()=>FaRoute);
parcelHelpers.export(exports, "FaRss", ()=>FaRss);
parcelHelpers.export(exports, "FaRubleSign", ()=>FaRubleSign);
parcelHelpers.export(exports, "FaRug", ()=>FaRug);
parcelHelpers.export(exports, "FaRulerCombined", ()=>FaRulerCombined);
parcelHelpers.export(exports, "FaRulerHorizontal", ()=>FaRulerHorizontal);
parcelHelpers.export(exports, "FaRulerVertical", ()=>FaRulerVertical);
parcelHelpers.export(exports, "FaRuler", ()=>FaRuler);
parcelHelpers.export(exports, "FaRupeeSign", ()=>FaRupeeSign);
parcelHelpers.export(exports, "FaRupiahSign", ()=>FaRupiahSign);
parcelHelpers.export(exports, "FaS", ()=>FaS);
parcelHelpers.export(exports, "FaSackDollar", ()=>FaSackDollar);
parcelHelpers.export(exports, "FaSackXmark", ()=>FaSackXmark);
parcelHelpers.export(exports, "FaSailboat", ()=>FaSailboat);
parcelHelpers.export(exports, "FaSatelliteDish", ()=>FaSatelliteDish);
parcelHelpers.export(exports, "FaSatellite", ()=>FaSatellite);
parcelHelpers.export(exports, "FaScaleBalanced", ()=>FaScaleBalanced);
parcelHelpers.export(exports, "FaScaleUnbalancedFlip", ()=>FaScaleUnbalancedFlip);
parcelHelpers.export(exports, "FaScaleUnbalanced", ()=>FaScaleUnbalanced);
parcelHelpers.export(exports, "FaSchoolCircleCheck", ()=>FaSchoolCircleCheck);
parcelHelpers.export(exports, "FaSchoolCircleExclamation", ()=>FaSchoolCircleExclamation);
parcelHelpers.export(exports, "FaSchoolCircleXmark", ()=>FaSchoolCircleXmark);
parcelHelpers.export(exports, "FaSchoolFlag", ()=>FaSchoolFlag);
parcelHelpers.export(exports, "FaSchoolLock", ()=>FaSchoolLock);
parcelHelpers.export(exports, "FaSchool", ()=>FaSchool);
parcelHelpers.export(exports, "FaScissors", ()=>FaScissors);
parcelHelpers.export(exports, "FaScrewdriverWrench", ()=>FaScrewdriverWrench);
parcelHelpers.export(exports, "FaScrewdriver", ()=>FaScrewdriver);
parcelHelpers.export(exports, "FaScrollTorah", ()=>FaScrollTorah);
parcelHelpers.export(exports, "FaScroll", ()=>FaScroll);
parcelHelpers.export(exports, "FaSdCard", ()=>FaSdCard);
parcelHelpers.export(exports, "FaSection", ()=>FaSection);
parcelHelpers.export(exports, "FaSeedling", ()=>FaSeedling);
parcelHelpers.export(exports, "FaServer", ()=>FaServer);
parcelHelpers.export(exports, "FaShapes", ()=>FaShapes);
parcelHelpers.export(exports, "FaShareFromSquare", ()=>FaShareFromSquare);
parcelHelpers.export(exports, "FaShareNodes", ()=>FaShareNodes);
parcelHelpers.export(exports, "FaShare", ()=>FaShare);
parcelHelpers.export(exports, "FaSheetPlastic", ()=>FaSheetPlastic);
parcelHelpers.export(exports, "FaShekelSign", ()=>FaShekelSign);
parcelHelpers.export(exports, "FaShieldCat", ()=>FaShieldCat);
parcelHelpers.export(exports, "FaShieldDog", ()=>FaShieldDog);
parcelHelpers.export(exports, "FaShieldHalved", ()=>FaShieldHalved);
parcelHelpers.export(exports, "FaShieldHeart", ()=>FaShieldHeart);
parcelHelpers.export(exports, "FaShieldVirus", ()=>FaShieldVirus);
parcelHelpers.export(exports, "FaShield", ()=>FaShield);
parcelHelpers.export(exports, "FaShip", ()=>FaShip);
parcelHelpers.export(exports, "FaShirt", ()=>FaShirt);
parcelHelpers.export(exports, "FaShoePrints", ()=>FaShoePrints);
parcelHelpers.export(exports, "FaShopLock", ()=>FaShopLock);
parcelHelpers.export(exports, "FaShopSlash", ()=>FaShopSlash);
parcelHelpers.export(exports, "FaShop", ()=>FaShop);
parcelHelpers.export(exports, "FaShower", ()=>FaShower);
parcelHelpers.export(exports, "FaShrimp", ()=>FaShrimp);
parcelHelpers.export(exports, "FaShuffle", ()=>FaShuffle);
parcelHelpers.export(exports, "FaShuttleSpace", ()=>FaShuttleSpace);
parcelHelpers.export(exports, "FaSignHanging", ()=>FaSignHanging);
parcelHelpers.export(exports, "FaSignal", ()=>FaSignal);
parcelHelpers.export(exports, "FaSignature", ()=>FaSignature);
parcelHelpers.export(exports, "FaSignsPost", ()=>FaSignsPost);
parcelHelpers.export(exports, "FaSimCard", ()=>FaSimCard);
parcelHelpers.export(exports, "FaSink", ()=>FaSink);
parcelHelpers.export(exports, "FaSitemap", ()=>FaSitemap);
parcelHelpers.export(exports, "FaSkullCrossbones", ()=>FaSkullCrossbones);
parcelHelpers.export(exports, "FaSkull", ()=>FaSkull);
parcelHelpers.export(exports, "FaSlash", ()=>FaSlash);
parcelHelpers.export(exports, "FaSleigh", ()=>FaSleigh);
parcelHelpers.export(exports, "FaSliders", ()=>FaSliders);
parcelHelpers.export(exports, "FaSmog", ()=>FaSmog);
parcelHelpers.export(exports, "FaSmoking", ()=>FaSmoking);
parcelHelpers.export(exports, "FaSnowflake", ()=>FaSnowflake);
parcelHelpers.export(exports, "FaSnowman", ()=>FaSnowman);
parcelHelpers.export(exports, "FaSnowplow", ()=>FaSnowplow);
parcelHelpers.export(exports, "FaSoap", ()=>FaSoap);
parcelHelpers.export(exports, "FaSocks", ()=>FaSocks);
parcelHelpers.export(exports, "FaSolarPanel", ()=>FaSolarPanel);
parcelHelpers.export(exports, "FaSortDown", ()=>FaSortDown);
parcelHelpers.export(exports, "FaSortUp", ()=>FaSortUp);
parcelHelpers.export(exports, "FaSort", ()=>FaSort);
parcelHelpers.export(exports, "FaSpa", ()=>FaSpa);
parcelHelpers.export(exports, "FaSpaghettiMonsterFlying", ()=>FaSpaghettiMonsterFlying);
parcelHelpers.export(exports, "FaSpellCheck", ()=>FaSpellCheck);
parcelHelpers.export(exports, "FaSpider", ()=>FaSpider);
parcelHelpers.export(exports, "FaSpinner", ()=>FaSpinner);
parcelHelpers.export(exports, "FaSplotch", ()=>FaSplotch);
parcelHelpers.export(exports, "FaSpoon", ()=>FaSpoon);
parcelHelpers.export(exports, "FaSprayCanSparkles", ()=>FaSprayCanSparkles);
parcelHelpers.export(exports, "FaSprayCan", ()=>FaSprayCan);
parcelHelpers.export(exports, "FaSquareArrowUpRight", ()=>FaSquareArrowUpRight);
parcelHelpers.export(exports, "FaSquareCaretDown", ()=>FaSquareCaretDown);
parcelHelpers.export(exports, "FaSquareCaretLeft", ()=>FaSquareCaretLeft);
parcelHelpers.export(exports, "FaSquareCaretRight", ()=>FaSquareCaretRight);
parcelHelpers.export(exports, "FaSquareCaretUp", ()=>FaSquareCaretUp);
parcelHelpers.export(exports, "FaSquareCheck", ()=>FaSquareCheck);
parcelHelpers.export(exports, "FaSquareEnvelope", ()=>FaSquareEnvelope);
parcelHelpers.export(exports, "FaSquareFull", ()=>FaSquareFull);
parcelHelpers.export(exports, "FaSquareH", ()=>FaSquareH);
parcelHelpers.export(exports, "FaSquareMinus", ()=>FaSquareMinus);
parcelHelpers.export(exports, "FaSquareNfi", ()=>FaSquareNfi);
parcelHelpers.export(exports, "FaSquareParking", ()=>FaSquareParking);
parcelHelpers.export(exports, "FaSquarePen", ()=>FaSquarePen);
parcelHelpers.export(exports, "FaSquarePersonConfined", ()=>FaSquarePersonConfined);
parcelHelpers.export(exports, "FaSquarePhoneFlip", ()=>FaSquarePhoneFlip);
parcelHelpers.export(exports, "FaSquarePhone", ()=>FaSquarePhone);
parcelHelpers.export(exports, "FaSquarePlus", ()=>FaSquarePlus);
parcelHelpers.export(exports, "FaSquarePollHorizontal", ()=>FaSquarePollHorizontal);
parcelHelpers.export(exports, "FaSquarePollVertical", ()=>FaSquarePollVertical);
parcelHelpers.export(exports, "FaSquareRootVariable", ()=>FaSquareRootVariable);
parcelHelpers.export(exports, "FaSquareRss", ()=>FaSquareRss);
parcelHelpers.export(exports, "FaSquareShareNodes", ()=>FaSquareShareNodes);
parcelHelpers.export(exports, "FaSquareUpRight", ()=>FaSquareUpRight);
parcelHelpers.export(exports, "FaSquareVirus", ()=>FaSquareVirus);
parcelHelpers.export(exports, "FaSquareXmark", ()=>FaSquareXmark);
parcelHelpers.export(exports, "FaSquare", ()=>FaSquare);
parcelHelpers.export(exports, "FaStaffSnake", ()=>FaStaffSnake);
parcelHelpers.export(exports, "FaStairs", ()=>FaStairs);
parcelHelpers.export(exports, "FaStamp", ()=>FaStamp);
parcelHelpers.export(exports, "FaStapler", ()=>FaStapler);
parcelHelpers.export(exports, "FaStarAndCrescent", ()=>FaStarAndCrescent);
parcelHelpers.export(exports, "FaStarHalfStroke", ()=>FaStarHalfStroke);
parcelHelpers.export(exports, "FaStarHalf", ()=>FaStarHalf);
parcelHelpers.export(exports, "FaStarOfDavid", ()=>FaStarOfDavid);
parcelHelpers.export(exports, "FaStarOfLife", ()=>FaStarOfLife);
parcelHelpers.export(exports, "FaStar", ()=>FaStar);
parcelHelpers.export(exports, "FaSterlingSign", ()=>FaSterlingSign);
parcelHelpers.export(exports, "FaStethoscope", ()=>FaStethoscope);
parcelHelpers.export(exports, "FaStop", ()=>FaStop);
parcelHelpers.export(exports, "FaStopwatch20", ()=>FaStopwatch20);
parcelHelpers.export(exports, "FaStopwatch", ()=>FaStopwatch);
parcelHelpers.export(exports, "FaStoreSlash", ()=>FaStoreSlash);
parcelHelpers.export(exports, "FaStore", ()=>FaStore);
parcelHelpers.export(exports, "FaStreetView", ()=>FaStreetView);
parcelHelpers.export(exports, "FaStrikethrough", ()=>FaStrikethrough);
parcelHelpers.export(exports, "FaStroopwafel", ()=>FaStroopwafel);
parcelHelpers.export(exports, "FaSubscript", ()=>FaSubscript);
parcelHelpers.export(exports, "FaSuitcaseMedical", ()=>FaSuitcaseMedical);
parcelHelpers.export(exports, "FaSuitcaseRolling", ()=>FaSuitcaseRolling);
parcelHelpers.export(exports, "FaSuitcase", ()=>FaSuitcase);
parcelHelpers.export(exports, "FaSunPlantWilt", ()=>FaSunPlantWilt);
parcelHelpers.export(exports, "FaSun", ()=>FaSun);
parcelHelpers.export(exports, "FaSuperscript", ()=>FaSuperscript);
parcelHelpers.export(exports, "FaSwatchbook", ()=>FaSwatchbook);
parcelHelpers.export(exports, "FaSynagogue", ()=>FaSynagogue);
parcelHelpers.export(exports, "FaSyringe", ()=>FaSyringe);
parcelHelpers.export(exports, "FaT", ()=>FaT);
parcelHelpers.export(exports, "FaTableCellsLarge", ()=>FaTableCellsLarge);
parcelHelpers.export(exports, "FaTableCells", ()=>FaTableCells);
parcelHelpers.export(exports, "FaTableColumns", ()=>FaTableColumns);
parcelHelpers.export(exports, "FaTableList", ()=>FaTableList);
parcelHelpers.export(exports, "FaTableTennisPaddleBall", ()=>FaTableTennisPaddleBall);
parcelHelpers.export(exports, "FaTable", ()=>FaTable);
parcelHelpers.export(exports, "FaTabletButton", ()=>FaTabletButton);
parcelHelpers.export(exports, "FaTabletScreenButton", ()=>FaTabletScreenButton);
parcelHelpers.export(exports, "FaTablet", ()=>FaTablet);
parcelHelpers.export(exports, "FaTablets", ()=>FaTablets);
parcelHelpers.export(exports, "FaTachographDigital", ()=>FaTachographDigital);
parcelHelpers.export(exports, "FaTag", ()=>FaTag);
parcelHelpers.export(exports, "FaTags", ()=>FaTags);
parcelHelpers.export(exports, "FaTape", ()=>FaTape);
parcelHelpers.export(exports, "FaTarpDroplet", ()=>FaTarpDroplet);
parcelHelpers.export(exports, "FaTarp", ()=>FaTarp);
parcelHelpers.export(exports, "FaTaxi", ()=>FaTaxi);
parcelHelpers.export(exports, "FaTeethOpen", ()=>FaTeethOpen);
parcelHelpers.export(exports, "FaTeeth", ()=>FaTeeth);
parcelHelpers.export(exports, "FaTemperatureArrowDown", ()=>FaTemperatureArrowDown);
parcelHelpers.export(exports, "FaTemperatureArrowUp", ()=>FaTemperatureArrowUp);
parcelHelpers.export(exports, "FaTemperatureEmpty", ()=>FaTemperatureEmpty);
parcelHelpers.export(exports, "FaTemperatureFull", ()=>FaTemperatureFull);
parcelHelpers.export(exports, "FaTemperatureHalf", ()=>FaTemperatureHalf);
parcelHelpers.export(exports, "FaTemperatureHigh", ()=>FaTemperatureHigh);
parcelHelpers.export(exports, "FaTemperatureLow", ()=>FaTemperatureLow);
parcelHelpers.export(exports, "FaTemperatureQuarter", ()=>FaTemperatureQuarter);
parcelHelpers.export(exports, "FaTemperatureThreeQuarters", ()=>FaTemperatureThreeQuarters);
parcelHelpers.export(exports, "FaTengeSign", ()=>FaTengeSign);
parcelHelpers.export(exports, "FaTentArrowDownToLine", ()=>FaTentArrowDownToLine);
parcelHelpers.export(exports, "FaTentArrowLeftRight", ()=>FaTentArrowLeftRight);
parcelHelpers.export(exports, "FaTentArrowTurnLeft", ()=>FaTentArrowTurnLeft);
parcelHelpers.export(exports, "FaTentArrowsDown", ()=>FaTentArrowsDown);
parcelHelpers.export(exports, "FaTent", ()=>FaTent);
parcelHelpers.export(exports, "FaTents", ()=>FaTents);
parcelHelpers.export(exports, "FaTerminal", ()=>FaTerminal);
parcelHelpers.export(exports, "FaTextHeight", ()=>FaTextHeight);
parcelHelpers.export(exports, "FaTextSlash", ()=>FaTextSlash);
parcelHelpers.export(exports, "FaTextWidth", ()=>FaTextWidth);
parcelHelpers.export(exports, "FaThermometer", ()=>FaThermometer);
parcelHelpers.export(exports, "FaThumbsDown", ()=>FaThumbsDown);
parcelHelpers.export(exports, "FaThumbsUp", ()=>FaThumbsUp);
parcelHelpers.export(exports, "FaThumbtack", ()=>FaThumbtack);
parcelHelpers.export(exports, "FaTicketSimple", ()=>FaTicketSimple);
parcelHelpers.export(exports, "FaTicket", ()=>FaTicket);
parcelHelpers.export(exports, "FaTimeline", ()=>FaTimeline);
parcelHelpers.export(exports, "FaToggleOff", ()=>FaToggleOff);
parcelHelpers.export(exports, "FaToggleOn", ()=>FaToggleOn);
parcelHelpers.export(exports, "FaToiletPaperSlash", ()=>FaToiletPaperSlash);
parcelHelpers.export(exports, "FaToiletPaper", ()=>FaToiletPaper);
parcelHelpers.export(exports, "FaToiletPortable", ()=>FaToiletPortable);
parcelHelpers.export(exports, "FaToilet", ()=>FaToilet);
parcelHelpers.export(exports, "FaToiletsPortable", ()=>FaToiletsPortable);
parcelHelpers.export(exports, "FaToolbox", ()=>FaToolbox);
parcelHelpers.export(exports, "FaTooth", ()=>FaTooth);
parcelHelpers.export(exports, "FaToriiGate", ()=>FaToriiGate);
parcelHelpers.export(exports, "FaTornado", ()=>FaTornado);
parcelHelpers.export(exports, "FaTowerBroadcast", ()=>FaTowerBroadcast);
parcelHelpers.export(exports, "FaTowerCell", ()=>FaTowerCell);
parcelHelpers.export(exports, "FaTowerObservation", ()=>FaTowerObservation);
parcelHelpers.export(exports, "FaTractor", ()=>FaTractor);
parcelHelpers.export(exports, "FaTrademark", ()=>FaTrademark);
parcelHelpers.export(exports, "FaTrafficLight", ()=>FaTrafficLight);
parcelHelpers.export(exports, "FaTrailer", ()=>FaTrailer);
parcelHelpers.export(exports, "FaTrainSubway", ()=>FaTrainSubway);
parcelHelpers.export(exports, "FaTrainTram", ()=>FaTrainTram);
parcelHelpers.export(exports, "FaTrain", ()=>FaTrain);
parcelHelpers.export(exports, "FaTransgender", ()=>FaTransgender);
parcelHelpers.export(exports, "FaTrashArrowUp", ()=>FaTrashArrowUp);
parcelHelpers.export(exports, "FaTrashCanArrowUp", ()=>FaTrashCanArrowUp);
parcelHelpers.export(exports, "FaTrashCan", ()=>FaTrashCan);
parcelHelpers.export(exports, "FaTrash", ()=>FaTrash);
parcelHelpers.export(exports, "FaTreeCity", ()=>FaTreeCity);
parcelHelpers.export(exports, "FaTree", ()=>FaTree);
parcelHelpers.export(exports, "FaTriangleExclamation", ()=>FaTriangleExclamation);
parcelHelpers.export(exports, "FaTrophy", ()=>FaTrophy);
parcelHelpers.export(exports, "FaTrowelBricks", ()=>FaTrowelBricks);
parcelHelpers.export(exports, "FaTrowel", ()=>FaTrowel);
parcelHelpers.export(exports, "FaTruckArrowRight", ()=>FaTruckArrowRight);
parcelHelpers.export(exports, "FaTruckDroplet", ()=>FaTruckDroplet);
parcelHelpers.export(exports, "FaTruckFast", ()=>FaTruckFast);
parcelHelpers.export(exports, "FaTruckFieldUn", ()=>FaTruckFieldUn);
parcelHelpers.export(exports, "FaTruckField", ()=>FaTruckField);
parcelHelpers.export(exports, "FaTruckFront", ()=>FaTruckFront);
parcelHelpers.export(exports, "FaTruckMedical", ()=>FaTruckMedical);
parcelHelpers.export(exports, "FaTruckMonster", ()=>FaTruckMonster);
parcelHelpers.export(exports, "FaTruckMoving", ()=>FaTruckMoving);
parcelHelpers.export(exports, "FaTruckPickup", ()=>FaTruckPickup);
parcelHelpers.export(exports, "FaTruckPlane", ()=>FaTruckPlane);
parcelHelpers.export(exports, "FaTruckRampBox", ()=>FaTruckRampBox);
parcelHelpers.export(exports, "FaTruck", ()=>FaTruck);
parcelHelpers.export(exports, "FaTty", ()=>FaTty);
parcelHelpers.export(exports, "FaTurkishLiraSign", ()=>FaTurkishLiraSign);
parcelHelpers.export(exports, "FaTurnDown", ()=>FaTurnDown);
parcelHelpers.export(exports, "FaTurnUp", ()=>FaTurnUp);
parcelHelpers.export(exports, "FaTv", ()=>FaTv);
parcelHelpers.export(exports, "FaU", ()=>FaU);
parcelHelpers.export(exports, "FaUmbrellaBeach", ()=>FaUmbrellaBeach);
parcelHelpers.export(exports, "FaUmbrella", ()=>FaUmbrella);
parcelHelpers.export(exports, "FaUnderline", ()=>FaUnderline);
parcelHelpers.export(exports, "FaUniversalAccess", ()=>FaUniversalAccess);
parcelHelpers.export(exports, "FaUnlockKeyhole", ()=>FaUnlockKeyhole);
parcelHelpers.export(exports, "FaUnlock", ()=>FaUnlock);
parcelHelpers.export(exports, "FaUpDownLeftRight", ()=>FaUpDownLeftRight);
parcelHelpers.export(exports, "FaUpDown", ()=>FaUpDown);
parcelHelpers.export(exports, "FaUpLong", ()=>FaUpLong);
parcelHelpers.export(exports, "FaUpRightAndDownLeftFromCenter", ()=>FaUpRightAndDownLeftFromCenter);
parcelHelpers.export(exports, "FaUpRightFromSquare", ()=>FaUpRightFromSquare);
parcelHelpers.export(exports, "FaUpload", ()=>FaUpload);
parcelHelpers.export(exports, "FaUserAstronaut", ()=>FaUserAstronaut);
parcelHelpers.export(exports, "FaUserCheck", ()=>FaUserCheck);
parcelHelpers.export(exports, "FaUserClock", ()=>FaUserClock);
parcelHelpers.export(exports, "FaUserDoctor", ()=>FaUserDoctor);
parcelHelpers.export(exports, "FaUserGear", ()=>FaUserGear);
parcelHelpers.export(exports, "FaUserGraduate", ()=>FaUserGraduate);
parcelHelpers.export(exports, "FaUserGroup", ()=>FaUserGroup);
parcelHelpers.export(exports, "FaUserInjured", ()=>FaUserInjured);
parcelHelpers.export(exports, "FaUserLargeSlash", ()=>FaUserLargeSlash);
parcelHelpers.export(exports, "FaUserLarge", ()=>FaUserLarge);
parcelHelpers.export(exports, "FaUserLock", ()=>FaUserLock);
parcelHelpers.export(exports, "FaUserMinus", ()=>FaUserMinus);
parcelHelpers.export(exports, "FaUserNinja", ()=>FaUserNinja);
parcelHelpers.export(exports, "FaUserNurse", ()=>FaUserNurse);
parcelHelpers.export(exports, "FaUserPen", ()=>FaUserPen);
parcelHelpers.export(exports, "FaUserPlus", ()=>FaUserPlus);
parcelHelpers.export(exports, "FaUserSecret", ()=>FaUserSecret);
parcelHelpers.export(exports, "FaUserShield", ()=>FaUserShield);
parcelHelpers.export(exports, "FaUserSlash", ()=>FaUserSlash);
parcelHelpers.export(exports, "FaUserTag", ()=>FaUserTag);
parcelHelpers.export(exports, "FaUserTie", ()=>FaUserTie);
parcelHelpers.export(exports, "FaUserXmark", ()=>FaUserXmark);
parcelHelpers.export(exports, "FaUser", ()=>FaUser);
parcelHelpers.export(exports, "FaUsersBetweenLines", ()=>FaUsersBetweenLines);
parcelHelpers.export(exports, "FaUsersGear", ()=>FaUsersGear);
parcelHelpers.export(exports, "FaUsersLine", ()=>FaUsersLine);
parcelHelpers.export(exports, "FaUsersRays", ()=>FaUsersRays);
parcelHelpers.export(exports, "FaUsersRectangle", ()=>FaUsersRectangle);
parcelHelpers.export(exports, "FaUsersSlash", ()=>FaUsersSlash);
parcelHelpers.export(exports, "FaUsersViewfinder", ()=>FaUsersViewfinder);
parcelHelpers.export(exports, "FaUsers", ()=>FaUsers);
parcelHelpers.export(exports, "FaUtensils", ()=>FaUtensils);
parcelHelpers.export(exports, "FaV", ()=>FaV);
parcelHelpers.export(exports, "FaVanShuttle", ()=>FaVanShuttle);
parcelHelpers.export(exports, "FaVault", ()=>FaVault);
parcelHelpers.export(exports, "FaVectorSquare", ()=>FaVectorSquare);
parcelHelpers.export(exports, "FaVenusDouble", ()=>FaVenusDouble);
parcelHelpers.export(exports, "FaVenusMars", ()=>FaVenusMars);
parcelHelpers.export(exports, "FaVenus", ()=>FaVenus);
parcelHelpers.export(exports, "FaVestPatches", ()=>FaVestPatches);
parcelHelpers.export(exports, "FaVest", ()=>FaVest);
parcelHelpers.export(exports, "FaVialCircleCheck", ()=>FaVialCircleCheck);
parcelHelpers.export(exports, "FaVialVirus", ()=>FaVialVirus);
parcelHelpers.export(exports, "FaVial", ()=>FaVial);
parcelHelpers.export(exports, "FaVials", ()=>FaVials);
parcelHelpers.export(exports, "FaVideoSlash", ()=>FaVideoSlash);
parcelHelpers.export(exports, "FaVideo", ()=>FaVideo);
parcelHelpers.export(exports, "FaVihara", ()=>FaVihara);
parcelHelpers.export(exports, "FaVirusCovidSlash", ()=>FaVirusCovidSlash);
parcelHelpers.export(exports, "FaVirusCovid", ()=>FaVirusCovid);
parcelHelpers.export(exports, "FaVirusSlash", ()=>FaVirusSlash);
parcelHelpers.export(exports, "FaVirus", ()=>FaVirus);
parcelHelpers.export(exports, "FaViruses", ()=>FaViruses);
parcelHelpers.export(exports, "FaVoicemail", ()=>FaVoicemail);
parcelHelpers.export(exports, "FaVolcano", ()=>FaVolcano);
parcelHelpers.export(exports, "FaVolleyball", ()=>FaVolleyball);
parcelHelpers.export(exports, "FaVolumeHigh", ()=>FaVolumeHigh);
parcelHelpers.export(exports, "FaVolumeLow", ()=>FaVolumeLow);
parcelHelpers.export(exports, "FaVolumeOff", ()=>FaVolumeOff);
parcelHelpers.export(exports, "FaVolumeXmark", ()=>FaVolumeXmark);
parcelHelpers.export(exports, "FaVrCardboard", ()=>FaVrCardboard);
parcelHelpers.export(exports, "FaW", ()=>FaW);
parcelHelpers.export(exports, "FaWalkieTalkie", ()=>FaWalkieTalkie);
parcelHelpers.export(exports, "FaWallet", ()=>FaWallet);
parcelHelpers.export(exports, "FaWandMagicSparkles", ()=>FaWandMagicSparkles);
parcelHelpers.export(exports, "FaWandMagic", ()=>FaWandMagic);
parcelHelpers.export(exports, "FaWandSparkles", ()=>FaWandSparkles);
parcelHelpers.export(exports, "FaWarehouse", ()=>FaWarehouse);
parcelHelpers.export(exports, "FaWaterLadder", ()=>FaWaterLadder);
parcelHelpers.export(exports, "FaWater", ()=>FaWater);
parcelHelpers.export(exports, "FaWaveSquare", ()=>FaWaveSquare);
parcelHelpers.export(exports, "FaWeightHanging", ()=>FaWeightHanging);
parcelHelpers.export(exports, "FaWeightScale", ()=>FaWeightScale);
parcelHelpers.export(exports, "FaWheatAwnCircleExclamation", ()=>FaWheatAwnCircleExclamation);
parcelHelpers.export(exports, "FaWheatAwn", ()=>FaWheatAwn);
parcelHelpers.export(exports, "FaWheelchairMove", ()=>FaWheelchairMove);
parcelHelpers.export(exports, "FaWheelchair", ()=>FaWheelchair);
parcelHelpers.export(exports, "FaWhiskeyGlass", ()=>FaWhiskeyGlass);
parcelHelpers.export(exports, "FaWifi", ()=>FaWifi);
parcelHelpers.export(exports, "FaWind", ()=>FaWind);
parcelHelpers.export(exports, "FaWindowMaximize", ()=>FaWindowMaximize);
parcelHelpers.export(exports, "FaWindowMinimize", ()=>FaWindowMinimize);
parcelHelpers.export(exports, "FaWindowRestore", ()=>FaWindowRestore);
parcelHelpers.export(exports, "FaWineBottle", ()=>FaWineBottle);
parcelHelpers.export(exports, "FaWineGlassEmpty", ()=>FaWineGlassEmpty);
parcelHelpers.export(exports, "FaWineGlass", ()=>FaWineGlass);
parcelHelpers.export(exports, "FaWonSign", ()=>FaWonSign);
parcelHelpers.export(exports, "FaWorm", ()=>FaWorm);
parcelHelpers.export(exports, "FaWrench", ()=>FaWrench);
parcelHelpers.export(exports, "FaXRay", ()=>FaXRay);
parcelHelpers.export(exports, "FaX", ()=>FaX);
parcelHelpers.export(exports, "FaXmark", ()=>FaXmark);
parcelHelpers.export(exports, "FaXmarksLines", ()=>FaXmarksLines);
parcelHelpers.export(exports, "FaY", ()=>FaY);
parcelHelpers.export(exports, "FaYenSign", ()=>FaYenSign);
parcelHelpers.export(exports, "FaYinYang", ()=>FaYinYang);
parcelHelpers.export(exports, "FaZ", ()=>FaZ);
parcelHelpers.export(exports, "FaRegAddressBook", ()=>FaRegAddressBook);
parcelHelpers.export(exports, "FaRegAddressCard", ()=>FaRegAddressCard);
parcelHelpers.export(exports, "FaRegBellSlash", ()=>FaRegBellSlash);
parcelHelpers.export(exports, "FaRegBell", ()=>FaRegBell);
parcelHelpers.export(exports, "FaRegBookmark", ()=>FaRegBookmark);
parcelHelpers.export(exports, "FaRegBuilding", ()=>FaRegBuilding);
parcelHelpers.export(exports, "FaRegCalendarCheck", ()=>FaRegCalendarCheck);
parcelHelpers.export(exports, "FaRegCalendarDays", ()=>FaRegCalendarDays);
parcelHelpers.export(exports, "FaRegCalendarMinus", ()=>FaRegCalendarMinus);
parcelHelpers.export(exports, "FaRegCalendarPlus", ()=>FaRegCalendarPlus);
parcelHelpers.export(exports, "FaRegCalendarXmark", ()=>FaRegCalendarXmark);
parcelHelpers.export(exports, "FaRegCalendar", ()=>FaRegCalendar);
parcelHelpers.export(exports, "FaRegChartBar", ()=>FaRegChartBar);
parcelHelpers.export(exports, "FaRegChessBishop", ()=>FaRegChessBishop);
parcelHelpers.export(exports, "FaRegChessKing", ()=>FaRegChessKing);
parcelHelpers.export(exports, "FaRegChessKnight", ()=>FaRegChessKnight);
parcelHelpers.export(exports, "FaRegChessPawn", ()=>FaRegChessPawn);
parcelHelpers.export(exports, "FaRegChessQueen", ()=>FaRegChessQueen);
parcelHelpers.export(exports, "FaRegChessRook", ()=>FaRegChessRook);
parcelHelpers.export(exports, "FaRegCircleCheck", ()=>FaRegCircleCheck);
parcelHelpers.export(exports, "FaRegCircleDot", ()=>FaRegCircleDot);
parcelHelpers.export(exports, "FaRegCircleDown", ()=>FaRegCircleDown);
parcelHelpers.export(exports, "FaRegCircleLeft", ()=>FaRegCircleLeft);
parcelHelpers.export(exports, "FaRegCirclePause", ()=>FaRegCirclePause);
parcelHelpers.export(exports, "FaRegCirclePlay", ()=>FaRegCirclePlay);
parcelHelpers.export(exports, "FaRegCircleQuestion", ()=>FaRegCircleQuestion);
parcelHelpers.export(exports, "FaRegCircleRight", ()=>FaRegCircleRight);
parcelHelpers.export(exports, "FaRegCircleStop", ()=>FaRegCircleStop);
parcelHelpers.export(exports, "FaRegCircleUp", ()=>FaRegCircleUp);
parcelHelpers.export(exports, "FaRegCircleUser", ()=>FaRegCircleUser);
parcelHelpers.export(exports, "FaRegCircleXmark", ()=>FaRegCircleXmark);
parcelHelpers.export(exports, "FaRegCircle", ()=>FaRegCircle);
parcelHelpers.export(exports, "FaRegClipboard", ()=>FaRegClipboard);
parcelHelpers.export(exports, "FaRegClock", ()=>FaRegClock);
parcelHelpers.export(exports, "FaRegClone", ()=>FaRegClone);
parcelHelpers.export(exports, "FaRegClosedCaptioning", ()=>FaRegClosedCaptioning);
parcelHelpers.export(exports, "FaRegCommentDots", ()=>FaRegCommentDots);
parcelHelpers.export(exports, "FaRegComment", ()=>FaRegComment);
parcelHelpers.export(exports, "FaRegComments", ()=>FaRegComments);
parcelHelpers.export(exports, "FaRegCompass", ()=>FaRegCompass);
parcelHelpers.export(exports, "FaRegCopy", ()=>FaRegCopy);
parcelHelpers.export(exports, "FaRegCopyright", ()=>FaRegCopyright);
parcelHelpers.export(exports, "FaRegCreditCard", ()=>FaRegCreditCard);
parcelHelpers.export(exports, "FaRegEnvelopeOpen", ()=>FaRegEnvelopeOpen);
parcelHelpers.export(exports, "FaRegEnvelope", ()=>FaRegEnvelope);
parcelHelpers.export(exports, "FaRegEyeSlash", ()=>FaRegEyeSlash);
parcelHelpers.export(exports, "FaRegEye", ()=>FaRegEye);
parcelHelpers.export(exports, "FaRegFaceAngry", ()=>FaRegFaceAngry);
parcelHelpers.export(exports, "FaRegFaceDizzy", ()=>FaRegFaceDizzy);
parcelHelpers.export(exports, "FaRegFaceFlushed", ()=>FaRegFaceFlushed);
parcelHelpers.export(exports, "FaRegFaceFrownOpen", ()=>FaRegFaceFrownOpen);
parcelHelpers.export(exports, "FaRegFaceFrown", ()=>FaRegFaceFrown);
parcelHelpers.export(exports, "FaRegFaceGrimace", ()=>FaRegFaceGrimace);
parcelHelpers.export(exports, "FaRegFaceGrinBeamSweat", ()=>FaRegFaceGrinBeamSweat);
parcelHelpers.export(exports, "FaRegFaceGrinBeam", ()=>FaRegFaceGrinBeam);
parcelHelpers.export(exports, "FaRegFaceGrinHearts", ()=>FaRegFaceGrinHearts);
parcelHelpers.export(exports, "FaRegFaceGrinSquintTears", ()=>FaRegFaceGrinSquintTears);
parcelHelpers.export(exports, "FaRegFaceGrinSquint", ()=>FaRegFaceGrinSquint);
parcelHelpers.export(exports, "FaRegFaceGrinStars", ()=>FaRegFaceGrinStars);
parcelHelpers.export(exports, "FaRegFaceGrinTears", ()=>FaRegFaceGrinTears);
parcelHelpers.export(exports, "FaRegFaceGrinTongueSquint", ()=>FaRegFaceGrinTongueSquint);
parcelHelpers.export(exports, "FaRegFaceGrinTongueWink", ()=>FaRegFaceGrinTongueWink);
parcelHelpers.export(exports, "FaRegFaceGrinTongue", ()=>FaRegFaceGrinTongue);
parcelHelpers.export(exports, "FaRegFaceGrinWide", ()=>FaRegFaceGrinWide);
parcelHelpers.export(exports, "FaRegFaceGrinWink", ()=>FaRegFaceGrinWink);
parcelHelpers.export(exports, "FaRegFaceGrin", ()=>FaRegFaceGrin);
parcelHelpers.export(exports, "FaRegFaceKissBeam", ()=>FaRegFaceKissBeam);
parcelHelpers.export(exports, "FaRegFaceKissWinkHeart", ()=>FaRegFaceKissWinkHeart);
parcelHelpers.export(exports, "FaRegFaceKiss", ()=>FaRegFaceKiss);
parcelHelpers.export(exports, "FaRegFaceLaughBeam", ()=>FaRegFaceLaughBeam);
parcelHelpers.export(exports, "FaRegFaceLaughSquint", ()=>FaRegFaceLaughSquint);
parcelHelpers.export(exports, "FaRegFaceLaughWink", ()=>FaRegFaceLaughWink);
parcelHelpers.export(exports, "FaRegFaceLaugh", ()=>FaRegFaceLaugh);
parcelHelpers.export(exports, "FaRegFaceMehBlank", ()=>FaRegFaceMehBlank);
parcelHelpers.export(exports, "FaRegFaceMeh", ()=>FaRegFaceMeh);
parcelHelpers.export(exports, "FaRegFaceRollingEyes", ()=>FaRegFaceRollingEyes);
parcelHelpers.export(exports, "FaRegFaceSadCry", ()=>FaRegFaceSadCry);
parcelHelpers.export(exports, "FaRegFaceSadTear", ()=>FaRegFaceSadTear);
parcelHelpers.export(exports, "FaRegFaceSmileBeam", ()=>FaRegFaceSmileBeam);
parcelHelpers.export(exports, "FaRegFaceSmileWink", ()=>FaRegFaceSmileWink);
parcelHelpers.export(exports, "FaRegFaceSmile", ()=>FaRegFaceSmile);
parcelHelpers.export(exports, "FaRegFaceSurprise", ()=>FaRegFaceSurprise);
parcelHelpers.export(exports, "FaRegFaceTired", ()=>FaRegFaceTired);
parcelHelpers.export(exports, "FaRegFileAudio", ()=>FaRegFileAudio);
parcelHelpers.export(exports, "FaRegFileCode", ()=>FaRegFileCode);
parcelHelpers.export(exports, "FaRegFileExcel", ()=>FaRegFileExcel);
parcelHelpers.export(exports, "FaRegFileImage", ()=>FaRegFileImage);
parcelHelpers.export(exports, "FaRegFileLines", ()=>FaRegFileLines);
parcelHelpers.export(exports, "FaRegFilePdf", ()=>FaRegFilePdf);
parcelHelpers.export(exports, "FaRegFilePowerpoint", ()=>FaRegFilePowerpoint);
parcelHelpers.export(exports, "FaRegFileVideo", ()=>FaRegFileVideo);
parcelHelpers.export(exports, "FaRegFileWord", ()=>FaRegFileWord);
parcelHelpers.export(exports, "FaRegFileZipper", ()=>FaRegFileZipper);
parcelHelpers.export(exports, "FaRegFile", ()=>FaRegFile);
parcelHelpers.export(exports, "FaRegFlag", ()=>FaRegFlag);
parcelHelpers.export(exports, "FaRegFloppyDisk", ()=>FaRegFloppyDisk);
parcelHelpers.export(exports, "FaRegFolderClosed", ()=>FaRegFolderClosed);
parcelHelpers.export(exports, "FaRegFolderOpen", ()=>FaRegFolderOpen);
parcelHelpers.export(exports, "FaRegFolder", ()=>FaRegFolder);
parcelHelpers.export(exports, "FaRegFontAwesome", ()=>FaRegFontAwesome);
parcelHelpers.export(exports, "FaRegFutbol", ()=>FaRegFutbol);
parcelHelpers.export(exports, "FaRegGem", ()=>FaRegGem);
parcelHelpers.export(exports, "FaRegHandBackFist", ()=>FaRegHandBackFist);
parcelHelpers.export(exports, "FaRegHandLizard", ()=>FaRegHandLizard);
parcelHelpers.export(exports, "FaRegHandPeace", ()=>FaRegHandPeace);
parcelHelpers.export(exports, "FaRegHandPointDown", ()=>FaRegHandPointDown);
parcelHelpers.export(exports, "FaRegHandPointLeft", ()=>FaRegHandPointLeft);
parcelHelpers.export(exports, "FaRegHandPointRight", ()=>FaRegHandPointRight);
parcelHelpers.export(exports, "FaRegHandPointUp", ()=>FaRegHandPointUp);
parcelHelpers.export(exports, "FaRegHandPointer", ()=>FaRegHandPointer);
parcelHelpers.export(exports, "FaRegHandScissors", ()=>FaRegHandScissors);
parcelHelpers.export(exports, "FaRegHandSpock", ()=>FaRegHandSpock);
parcelHelpers.export(exports, "FaRegHand", ()=>FaRegHand);
parcelHelpers.export(exports, "FaRegHandshake", ()=>FaRegHandshake);
parcelHelpers.export(exports, "FaRegHardDrive", ()=>FaRegHardDrive);
parcelHelpers.export(exports, "FaRegHeart", ()=>FaRegHeart);
parcelHelpers.export(exports, "FaRegHospital", ()=>FaRegHospital);
parcelHelpers.export(exports, "FaRegHourglassHalf", ()=>FaRegHourglassHalf);
parcelHelpers.export(exports, "FaRegHourglass", ()=>FaRegHourglass);
parcelHelpers.export(exports, "FaRegIdBadge", ()=>FaRegIdBadge);
parcelHelpers.export(exports, "FaRegIdCard", ()=>FaRegIdCard);
parcelHelpers.export(exports, "FaRegImage", ()=>FaRegImage);
parcelHelpers.export(exports, "FaRegImages", ()=>FaRegImages);
parcelHelpers.export(exports, "FaRegKeyboard", ()=>FaRegKeyboard);
parcelHelpers.export(exports, "FaRegLemon", ()=>FaRegLemon);
parcelHelpers.export(exports, "FaRegLifeRing", ()=>FaRegLifeRing);
parcelHelpers.export(exports, "FaRegLightbulb", ()=>FaRegLightbulb);
parcelHelpers.export(exports, "FaRegMap", ()=>FaRegMap);
parcelHelpers.export(exports, "FaRegMessage", ()=>FaRegMessage);
parcelHelpers.export(exports, "FaRegMoneyBill1", ()=>FaRegMoneyBill1);
parcelHelpers.export(exports, "FaRegMoon", ()=>FaRegMoon);
parcelHelpers.export(exports, "FaRegNewspaper", ()=>FaRegNewspaper);
parcelHelpers.export(exports, "FaRegNoteSticky", ()=>FaRegNoteSticky);
parcelHelpers.export(exports, "FaRegObjectGroup", ()=>FaRegObjectGroup);
parcelHelpers.export(exports, "FaRegObjectUngroup", ()=>FaRegObjectUngroup);
parcelHelpers.export(exports, "FaRegPaperPlane", ()=>FaRegPaperPlane);
parcelHelpers.export(exports, "FaRegPaste", ()=>FaRegPaste);
parcelHelpers.export(exports, "FaRegPenToSquare", ()=>FaRegPenToSquare);
parcelHelpers.export(exports, "FaRegRectangleList", ()=>FaRegRectangleList);
parcelHelpers.export(exports, "FaRegRectangleXmark", ()=>FaRegRectangleXmark);
parcelHelpers.export(exports, "FaRegRegistered", ()=>FaRegRegistered);
parcelHelpers.export(exports, "FaRegShareFromSquare", ()=>FaRegShareFromSquare);
parcelHelpers.export(exports, "FaRegSnowflake", ()=>FaRegSnowflake);
parcelHelpers.export(exports, "FaRegSquareCaretDown", ()=>FaRegSquareCaretDown);
parcelHelpers.export(exports, "FaRegSquareCaretLeft", ()=>FaRegSquareCaretLeft);
parcelHelpers.export(exports, "FaRegSquareCaretRight", ()=>FaRegSquareCaretRight);
parcelHelpers.export(exports, "FaRegSquareCaretUp", ()=>FaRegSquareCaretUp);
parcelHelpers.export(exports, "FaRegSquareCheck", ()=>FaRegSquareCheck);
parcelHelpers.export(exports, "FaRegSquareFull", ()=>FaRegSquareFull);
parcelHelpers.export(exports, "FaRegSquareMinus", ()=>FaRegSquareMinus);
parcelHelpers.export(exports, "FaRegSquarePlus", ()=>FaRegSquarePlus);
parcelHelpers.export(exports, "FaRegSquare", ()=>FaRegSquare);
parcelHelpers.export(exports, "FaRegStarHalfStroke", ()=>FaRegStarHalfStroke);
parcelHelpers.export(exports, "FaRegStarHalf", ()=>FaRegStarHalf);
parcelHelpers.export(exports, "FaRegStar", ()=>FaRegStar);
parcelHelpers.export(exports, "FaRegSun", ()=>FaRegSun);
parcelHelpers.export(exports, "FaRegThumbsDown", ()=>FaRegThumbsDown);
parcelHelpers.export(exports, "FaRegThumbsUp", ()=>FaRegThumbsUp);
parcelHelpers.export(exports, "FaRegTrashCan", ()=>FaRegTrashCan);
parcelHelpers.export(exports, "FaRegUser", ()=>FaRegUser);
parcelHelpers.export(exports, "FaRegWindowMaximize", ()=>FaRegWindowMaximize);
parcelHelpers.export(exports, "FaRegWindowMinimize", ()=>FaRegWindowMinimize);
parcelHelpers.export(exports, "FaRegWindowRestore", ()=>FaRegWindowRestore);
var _lib = require("../lib");
function Fa42Group(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"
                }
            }
        ]
    })(props);
}
function Fa500Px(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                }
            }
        ]
    })(props);
}
function FaAccessibleIcon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                }
            }
        ]
    })(props);
}
function FaAccusoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                }
            }
        ]
    })(props);
}
function FaAdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                }
            }
        ]
    })(props);
}
function FaAdversal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                }
            }
        ]
    })(props);
}
function FaAffiliatetheme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                }
            }
        ]
    })(props);
}
function FaAirbnb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                }
            }
        ]
    })(props);
}
function FaAlgolia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"
                }
            }
        ]
    })(props);
}
function FaAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                }
            }
        ]
    })(props);
}
function FaAmazonPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                }
            }
        ]
    })(props);
}
function FaAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                }
            }
        ]
    })(props);
}
function FaAmilia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                }
            }
        ]
    })(props);
}
function FaAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                }
            }
        ]
    })(props);
}
function FaAngellist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                }
            }
        ]
    })(props);
}
function FaAngrycreative(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                }
            }
        ]
    })(props);
}
function FaAngular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                }
            }
        ]
    })(props);
}
function FaAppStoreIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                }
            }
        ]
    })(props);
}
function FaAppStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                }
            }
        ]
    })(props);
}
function FaApper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                }
            }
        ]
    })(props);
}
function FaApplePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                }
            }
        ]
    })(props);
}
function FaApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                }
            }
        ]
    })(props);
}
function FaArtstation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                }
            }
        ]
    })(props);
}
function FaAsymmetrik(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                }
            }
        ]
    })(props);
}
function FaAtlassian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                }
            }
        ]
    })(props);
}
function FaAudible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                }
            }
        ]
    })(props);
}
function FaAutoprefixer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                }
            }
        ]
    })(props);
}
function FaAvianex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                }
            }
        ]
    })(props);
}
function FaAviato(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                }
            }
        ]
    })(props);
}
function FaAws(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                }
            }
        ]
    })(props);
}
function FaBandcamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                }
            }
        ]
    })(props);
}
function FaBattleNet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                }
            }
        ]
    })(props);
}
function FaBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                }
            }
        ]
    })(props);
}
function FaBilibili(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"
                }
            }
        ]
    })(props);
}
function FaBimobject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                }
            }
        ]
    })(props);
}
function FaBitbucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                }
            }
        ]
    })(props);
}
function FaBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                }
            }
        ]
    })(props);
}
function FaBity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                }
            }
        ]
    })(props);
}
function FaBlackTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                }
            }
        ]
    })(props);
}
function FaBlackberry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                }
            }
        ]
    })(props);
}
function FaBloggerB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                }
            }
        ]
    })(props);
}
function FaBlogger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                }
            }
        ]
    })(props);
}
function FaBluetoothB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                }
            }
        ]
    })(props);
}
function FaBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                }
            }
        ]
    })(props);
}
function FaBootstrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                }
            }
        ]
    })(props);
}
function FaBots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"
                }
            }
        ]
    })(props);
}
function FaBtc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                }
            }
        ]
    })(props);
}
function FaBuffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                }
            }
        ]
    })(props);
}
function FaBuromobelexperte(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                }
            }
        ]
    })(props);
}
function FaBuyNLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                }
            }
        ]
    })(props);
}
function FaBuysellads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                }
            }
        ]
    })(props);
}
function FaCanadianMapleLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                }
            }
        ]
    })(props);
}
function FaCcAmazonPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                }
            }
        ]
    })(props);
}
function FaCcAmex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z"
                }
            }
        ]
    })(props);
}
function FaCcApplePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                }
            }
        ]
    })(props);
}
function FaCcDinersClub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                }
            }
        ]
    })(props);
}
function FaCcDiscover(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                }
            }
        ]
    })(props);
}
function FaCcJcb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                }
            }
        ]
    })(props);
}
function FaCcMastercard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                }
            }
        ]
    })(props);
}
function FaCcPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                }
            }
        ]
    })(props);
}
function FaCcStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                }
            }
        ]
    })(props);
}
function FaCcVisa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                }
            }
        ]
    })(props);
}
function FaCentercode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                }
            }
        ]
    })(props);
}
function FaCentos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                }
            }
        ]
    })(props);
}
function FaChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"
                }
            }
        ]
    })(props);
}
function FaChromecast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                }
            }
        ]
    })(props);
}
function FaCloudflare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                }
            }
        ]
    })(props);
}
function FaCloudscale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                }
            }
        ]
    })(props);
}
function FaCloudsmith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"
                }
            }
        ]
    })(props);
}
function FaCloudversify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                }
            }
        ]
    })(props);
}
function FaCmplid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"
                }
            }
        ]
    })(props);
}
function FaCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                }
            }
        ]
    })(props);
}
function FaCodiepie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                }
            }
        ]
    })(props);
}
function FaConfluence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                }
            }
        ]
    })(props);
}
function FaConnectdevelop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                }
            }
        ]
    })(props);
}
function FaContao(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                }
            }
        ]
    })(props);
}
function FaCottonBureau(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                }
            }
        ]
    })(props);
}
function FaCpanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsBy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNcEu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNcJp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsPdAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsPd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsRemix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSamplingPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSampling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsZero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                }
            }
        ]
    })(props);
}
function FaCriticalRole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                }
            }
        ]
    })(props);
}
function FaCss3Alt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                }
            }
        ]
    })(props);
}
function FaCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                }
            }
        ]
    })(props);
}
function FaCuttlefish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                }
            }
        ]
    })(props);
}
function FaDAndDBeyond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                }
            }
        ]
    })(props);
}
function FaDAndD(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                }
            }
        ]
    })(props);
}
function FaDailymotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                }
            }
        ]
    })(props);
}
function FaDashcube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                }
            }
        ]
    })(props);
}
function FaDebian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.2 .9c-4 .2-8.1 .4-11.4 1.6l-3.4-.5c5.4-.7 10.9-1.1 16.4-1.5c2.4-.2 4.8-.4 7.2-.6c-2.7 .6-5.7 .8-8.8 .9zm132 244.7c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7c3.4-1 6.3-1.8 4.3-3c-19.2 1.9-24.9 5.5-31.1 9.4c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9c4.1-1.1 7.2-1.9-.1 2.4c-3.6 1-6.7 1.3-9.7 1.6c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.5-.3 5.4-1.4c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.4 5.9-1.2 12.9-2 20.3c-3 27.4-6.8 61.3 3.8 73.6l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c1.2 2.5 2.3 5 3.9 7.4l-3 .2c7 22.2 10.8 22.5 15.1 22.9c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c3.2 5.8 6.1 8.1 8.6 10l0 0c.8 .6 1.5 1.1 2.1 1.7c-11.9-6.5 3.2 13.7 11.9 25.2c2.5 3.4 4.5 6 5.1 7l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7c5.2 5.6 9.9 10.7 19.8 15.4c11.2 3.9 17.1 4.8 23.6 5.9c5.4 .8 11.2 1.8 20.8 4.5c-2.2-.1-4.4-.1-6.7-.2l0 0h0c-16.3-.4-34-.8-46.4-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2 0-.1 0 0 0 0c.4 .4 3.4 3.4 8.8-5.8c1.3-2.9 2.5-5.8 3.8-8.8l0 0c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l0 0c6.1-5.5 11.6-10.4 14.7-14.1l.7 4.4c17.1-16 45-27.7 66.1-36.6c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4c-1.3 .7-2.6 1.4-3.9 2.1l0 0 0 0c-2.7 1.4-5.4 2.8-8 4.6c8.3-2 11.9-1.4 16-.8c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1c5.6-1.1 10.4-2.1 19.5 .9l-1-4.8c7.5 2.7 13.1 4.4 18 5.9c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2c3.6-1.1 7-2.2 15.3 1.2c.5 .8 .7 1.5 1 2.1c1 2.6 1.7 4.6 14.6 12.2c1.8-.7-3.1-5.1-7-8.7l-.2-.1c32.3 17.3 67.5 54.1 78.2 93.6c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9c-3.3-11.8-9.6-34.5-20-49.6c-.4 4.4-2.9 3.9-5.3 3.5c-3.3-.6-6.3-1.2-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1c.5-1.5 .9-2.8 4.7 5.2c.1 4.3 1.1 8.5 2.2 13.3l0 0 0 0 0 0 0 0 0 0 0 0c.7 3 1.5 6.2 2.1 9.8c-1.1-.2-2.3-2.2-3.4-4.2l0 0 0 0c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9l0 0c-2.8 7.1-6 15.4-3.4 26.1c-.8-3.1-2.1-6.3-3.3-9.3l0 0 0 0c-.5-1.3-1.1-2.6-1.5-3.8c-.6 4.8-.3 8.2-.1 11.3c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 11-3.8 20.5-8.1 29.1c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.6 11-7 13.3-6.5 15.6c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5l0 0c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8l0 0c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.2-1.7 3.7-6.2 5.6-11.6c2.9-8.4 6.5-18.9 14.3-23.9c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.5 .7-.7 1-.9c.6-.5 1.2-.9 1.5-3.4c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7c2.2-2.1 4.7-4.5 9-7.4c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5.3-1.4 20.1-14.8 30.2-23.8l0 0 0 0c1.6-1.4 3-2.7 4.3-3.9c2-4.3 1.6-5.7 1.3-7.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c1-2.8 2-5.4 2.9-7.8l0 0zM233.1 321.9a.9 .9 0 1 0 -1.7 0 .9 .9 0 1 0 1.7 0zm-.2 .5l-.2 .4c-.3 .7-.6 1.4-.3 2.4c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.2-11.9-21.7-19.4l0 0 0 0c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8c-6.3-3.2-14.6-9.6-14.9-11.8zM237.5 7c3.8 .6 7.3 1.2 6.7 2.1c5-1.1 6.1-2.1-9-2.5c.8 .1 1.6 .3 2.4 .4zm92.2 208.4c-1 3.9-1.8 1.4-2.7-1.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6zm-6.8 21.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8c-2.9-.8-5.9-1.6 5.6-16.1c-.5 2-2.3 4.9-4 7.7l0 0c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8zM280 276.6c-11.1-1.7-21.2-6-12.7-6.1c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2zM244.2 9.1l-.2 .4-3 .3 3.2-.7zm-69.5 273c3.7 7.2 6.5 11.7 9.1 15.9c2.3 3.7 4.4 7.1 6.8 11.7c-5.2-4.3-8.9-9.8-12.8-15.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9zm7.3-10c1.7 3.4 3.3 6.7 5.9 9.5l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6zm239.1-41.2c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.4 109.6c0 .3 0 .5 .1 .7c0-.2 0-.5-.1-.7zm.1 .7c.3 1.2 1.4 .9 2.4 .6c1.9-.5 3.6-.9-.1 7.6c-2.4 1.7-3.8 2.8-4.6 3.4c-.6 .4-.8 .6-.8 .6c0 0 .1-.2 .3-.5c.8-1.4 3.4-5.5 2.9-11.7zm-10.2 42c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9c-.4-3.4-.8-6.3 4.3-12.9c-.3 1.2-.5 2.5-.7 3.8z"
                }
            }
        ]
    })(props);
}
function FaDeezer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                }
            }
        ]
    })(props);
}
function FaDelicious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                }
            }
        ]
    })(props);
}
function FaDeploydog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaDeskpro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                }
            }
        ]
    })(props);
}
function FaDev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                }
            }
        ]
    })(props);
}
function FaDeviantart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                }
            }
        ]
    })(props);
}
function FaDhl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                }
            }
        ]
    })(props);
}
function FaDiaspora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                }
            }
        ]
    })(props);
}
function FaDigg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                }
            }
        ]
    })(props);
}
function FaDigitalOcean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                }
            }
        ]
    })(props);
}
function FaDiscord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                }
            }
        ]
    })(props);
}
function FaDiscourse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaDochub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                }
            }
        ]
    })(props);
}
function FaDocker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                }
            }
        ]
    })(props);
}
function FaDraft2Digital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                }
            }
        ]
    })(props);
}
function FaDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                }
            }
        ]
    })(props);
}
function FaDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                }
            }
        ]
    })(props);
}
function FaDrupal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"
                }
            }
        ]
    })(props);
}
function FaDyalog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                }
            }
        ]
    })(props);
}
function FaEarlybirds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                }
            }
        ]
    })(props);
}
function FaEbay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                }
            }
        ]
    })(props);
}
function FaEdgeLegacy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                }
            }
        ]
    })(props);
}
function FaEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"
                }
            }
        ]
    })(props);
}
function FaElementor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"
                }
            }
        ]
    })(props);
}
function FaEllo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                }
            }
        ]
    })(props);
}
function FaEmber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                }
            }
        ]
    })(props);
}
function FaEmpire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                }
            }
        ]
    })(props);
}
function FaEnvira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                }
            }
        ]
    })(props);
}
function FaErlang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                }
            }
        ]
    })(props);
}
function FaEthereum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                }
            }
        ]
    })(props);
}
function FaEtsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                }
            }
        ]
    })(props);
}
function FaEvernote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                }
            }
        ]
    })(props);
}
function FaExpeditedssl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                }
            }
        ]
    })(props);
}
function FaFacebookF(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                }
            }
        ]
    })(props);
}
function FaFacebookMessenger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                }
            }
        ]
    })(props);
}
function FaFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                }
            }
        ]
    })(props);
}
function FaFantasyFlightGames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                }
            }
        ]
    })(props);
}
function FaFedex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                }
            }
        ]
    })(props);
}
function FaFedora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"
                }
            }
        ]
    })(props);
}
function FaFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                }
            }
        ]
    })(props);
}
function FaFirefoxBrowser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"
                }
            }
        ]
    })(props);
}
function FaFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                }
            }
        ]
    })(props);
}
function FaFirstOrderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                }
            }
        ]
    })(props);
}
function FaFirstOrder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                }
            }
        ]
    })(props);
}
function FaFirstdraft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                }
            }
        ]
    })(props);
}
function FaFlickr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                }
            }
        ]
    })(props);
}
function FaFlipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                }
            }
        ]
    })(props);
}
function FaFly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                }
            }
        ]
    })(props);
}
function FaFontAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48V384C385 407 366 416 329 416C266 416 242 384 179 384C159 384 143 388 128 392V328C143 324 159 320 179 320C242 320 266 352 329 352C349 352 364 349 384 343V135C364 141 349 144 329 144C266 144 242 112 179 112C128 112 104 133 64 141V448C64 466 50 480 32 480S0 466 0 448V64C0 46 14 32 32 32S64 46 64 64V77C104 69 128 48 179 48C242 48 266 80 329 80C366 80 385 71 448 48Z"
                }
            }
        ]
    })(props);
}
function FaFonticonsFi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                }
            }
        ]
    })(props);
}
function FaFonticons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                }
            }
        ]
    })(props);
}
function FaFortAwesomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                }
            }
        ]
    })(props);
}
function FaFortAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                }
            }
        ]
    })(props);
}
function FaForumbee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                }
            }
        ]
    })(props);
}
function FaFoursquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                }
            }
        ]
    })(props);
}
function FaFreeCodeCamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                }
            }
        ]
    })(props);
}
function FaFreebsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                }
            }
        ]
    })(props);
}
function FaFulcrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                }
            }
        ]
    })(props);
}
function FaGalacticRepublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                }
            }
        ]
    })(props);
}
function FaGalacticSenate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                }
            }
        ]
    })(props);
}
function FaGetPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                }
            }
        ]
    })(props);
}
function FaGgCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                }
            }
        ]
    })(props);
}
function FaGg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                }
            }
        ]
    })(props);
}
function FaGitAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                }
            }
        ]
    })(props);
}
function FaGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                }
            }
        ]
    })(props);
}
function FaGithubAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                }
            }
        ]
    })(props);
}
function FaGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                }
            }
        ]
    })(props);
}
function FaGitkraken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                }
            }
        ]
    })(props);
}
function FaGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"
                }
            }
        ]
    })(props);
}
function FaGitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                }
            }
        ]
    })(props);
}
function FaGlideG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                }
            }
        ]
    })(props);
}
function FaGlide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                }
            }
        ]
    })(props);
}
function FaGofore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                }
            }
        ]
    })(props);
}
function FaGolang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"
                }
            }
        ]
    })(props);
}
function FaGoodreadsG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                }
            }
        ]
    })(props);
}
function FaGoodreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                }
            }
        ]
    })(props);
}
function FaGoogleDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                }
            }
        ]
    })(props);
}
function FaGooglePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                }
            }
        ]
    })(props);
}
function FaGooglePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                }
            }
        ]
    })(props);
}
function FaGooglePlusG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                }
            }
        ]
    })(props);
}
function FaGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                }
            }
        ]
    })(props);
}
function FaGoogleWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                }
            }
        ]
    })(props);
}
function FaGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                }
            }
        ]
    })(props);
}
function FaGratipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                }
            }
        ]
    })(props);
}
function FaGrav(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                }
            }
        ]
    })(props);
}
function FaGripfire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                }
            }
        ]
    })(props);
}
function FaGrunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                }
            }
        ]
    })(props);
}
function FaGuilded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                }
            }
        ]
    })(props);
}
function FaGulp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                }
            }
        ]
    })(props);
}
function FaHackerNews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function FaHackerrank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                }
            }
        ]
    })(props);
}
function FaHashnode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"
                }
            }
        ]
    })(props);
}
function FaHips(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                }
            }
        ]
    })(props);
}
function FaHireAHelper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                }
            }
        ]
    })(props);
}
function FaHive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                }
            }
        ]
    })(props);
}
function FaHooli(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                }
            }
        ]
    })(props);
}
function FaHornbill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                }
            }
        ]
    })(props);
}
function FaHotjar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"
                }
            }
        ]
    })(props);
}
function FaHouzz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                }
            }
        ]
    })(props);
}
function FaHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                }
            }
        ]
    })(props);
}
function FaHubspot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                }
            }
        ]
    })(props);
}
function FaIdeal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                }
            }
        ]
    })(props);
}
function FaImdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"
                }
            }
        ]
    })(props);
}
function FaInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                }
            }
        ]
    })(props);
}
function FaInstalod(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                }
            }
        ]
    })(props);
}
function FaIntercom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                }
            }
        ]
    })(props);
}
function FaInternetExplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                }
            }
        ]
    })(props);
}
function FaInvision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                }
            }
        ]
    })(props);
}
function FaIoxhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaItchIo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                }
            }
        ]
    })(props);
}
function FaItunesNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                }
            }
        ]
    })(props);
}
function FaItunes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                }
            }
        ]
    })(props);
}
function FaJava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                }
            }
        ]
    })(props);
}
function FaJediOrder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                }
            }
        ]
    })(props);
}
function FaJenkins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                }
            }
        ]
    })(props);
}
function FaJira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                }
            }
        ]
    })(props);
}
function FaJoget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                }
            }
        ]
    })(props);
}
function FaJoomla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                }
            }
        ]
    })(props);
}
function FaJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function FaJsfiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                }
            }
        ]
    })(props);
}
function FaKaggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                }
            }
        ]
    })(props);
}
function FaKeybase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                }
            }
        ]
    })(props);
}
function FaKeycdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                }
            }
        ]
    })(props);
}
function FaKickstarterK(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
                }
            }
        ]
    })(props);
}
function FaKickstarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
                }
            }
        ]
    })(props);
}
function FaKorvue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                }
            }
        ]
    })(props);
}
function FaLaravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
                }
            }
        ]
    })(props);
}
function FaLastfm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                }
            }
        ]
    })(props);
}
function FaLeanpub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                }
            }
        ]
    })(props);
}
function FaLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                }
            }
        ]
    })(props);
}
function FaLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"
                }
            }
        ]
    })(props);
}
function FaLinkedinIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                }
            }
        ]
    })(props);
}
function FaLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                }
            }
        ]
    })(props);
}
function FaLinode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"
                }
            }
        ]
    })(props);
}
function FaLinux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                }
            }
        ]
    })(props);
}
function FaLyft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                }
            }
        ]
    })(props);
}
function FaMagento(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                }
            }
        ]
    })(props);
}
function FaMailchimp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                }
            }
        ]
    })(props);
}
function FaMandalorian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                }
            }
        ]
    })(props);
}
function FaMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                }
            }
        ]
    })(props);
}
function FaMastodon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                }
            }
        ]
    })(props);
}
function FaMaxcdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                }
            }
        ]
    })(props);
}
function FaMdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                }
            }
        ]
    })(props);
}
function FaMedapps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                }
            }
        ]
    })(props);
}
function FaMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"
                }
            }
        ]
    })(props);
}
function FaMedrt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                }
            }
        ]
    })(props);
}
function FaMeetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                }
            }
        ]
    })(props);
}
function FaMegaport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                }
            }
        ]
    })(props);
}
function FaMendeley(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                }
            }
        ]
    })(props);
}
function FaMeta(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"
                }
            }
        ]
    })(props);
}
function FaMicroblog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                }
            }
        ]
    })(props);
}
function FaMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                }
            }
        ]
    })(props);
}
function FaMix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                }
            }
        ]
    })(props);
}
function FaMixcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"
                }
            }
        ]
    })(props);
}
function FaMixer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                }
            }
        ]
    })(props);
}
function FaMizuni(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                }
            }
        ]
    })(props);
}
function FaModx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                }
            }
        ]
    })(props);
}
function FaMonero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                }
            }
        ]
    })(props);
}
function FaNapster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                }
            }
        ]
    })(props);
}
function FaNeos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                }
            }
        ]
    })(props);
}
function FaNfcDirectional(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"
                }
            }
        ]
    })(props);
}
function FaNfcSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"
                }
            }
        ]
    })(props);
}
function FaNimblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                }
            }
        ]
    })(props);
}
function FaNodeJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                }
            }
        ]
    })(props);
}
function FaNode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                }
            }
        ]
    })(props);
}
function FaNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                }
            }
        ]
    })(props);
}
function FaNs8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                }
            }
        ]
    })(props);
}
function FaNutritionix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                }
            }
        ]
    })(props);
}
function FaOctopusDeploy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                }
            }
        ]
    })(props);
}
function FaOdnoklassniki(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                }
            }
        ]
    })(props);
}
function FaOdysee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"
                }
            }
        ]
    })(props);
}
function FaOldRepublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                }
            }
        ]
    })(props);
}
function FaOpencart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                }
            }
        ]
    })(props);
}
function FaOpenid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                }
            }
        ]
    })(props);
}
function FaOpera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                }
            }
        ]
    })(props);
}
function FaOptinMonster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                }
            }
        ]
    })(props);
}
function FaOrcid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                }
            }
        ]
    })(props);
}
function FaOsi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                }
            }
        ]
    })(props);
}
function FaPadlet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"
                }
            }
        ]
    })(props);
}
function FaPage4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                }
            }
        ]
    })(props);
}
function FaPagelines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                }
            }
        ]
    })(props);
}
function FaPalfed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                }
            }
        ]
    })(props);
}
function FaPatreon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                }
            }
        ]
    })(props);
}
function FaPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                }
            }
        ]
    })(props);
}
function FaPerbyte(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                }
            }
        ]
    })(props);
}
function FaPeriscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                }
            }
        ]
    })(props);
}
function FaPhabricator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                }
            }
        ]
    })(props);
}
function FaPhoenixFramework(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                }
            }
        ]
    })(props);
}
function FaPhoenixSquadron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                }
            }
        ]
    })(props);
}
function FaPhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperPp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                }
            }
        ]
    })(props);
}
function FaPiedPiper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                }
            }
        ]
    })(props);
}
function FaPinterestP(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                }
            }
        ]
    })(props);
}
function FaPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                }
            }
        ]
    })(props);
}
function FaPix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
                }
            }
        ]
    })(props);
}
function FaPlaystation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                }
            }
        ]
    })(props);
}
function FaProductHunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                }
            }
        ]
    })(props);
}
function FaPushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                }
            }
        ]
    })(props);
}
function FaPython(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                }
            }
        ]
    })(props);
}
function FaQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                }
            }
        ]
    })(props);
}
function FaQuinscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                }
            }
        ]
    })(props);
}
function FaQuora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                }
            }
        ]
    })(props);
}
function FaRProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                }
            }
        ]
    })(props);
}
function FaRaspberryPi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                }
            }
        ]
    })(props);
}
function FaRavelry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                }
            }
        ]
    })(props);
}
function FaReact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                }
            }
        ]
    })(props);
}
function FaReacteurope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                }
            }
        ]
    })(props);
}
function FaReadme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                }
            }
        ]
    })(props);
}
function FaRebel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                }
            }
        ]
    })(props);
}
function FaRedRiver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                }
            }
        ]
    })(props);
}
function FaRedditAlien(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
                }
            }
        ]
    })(props);
}
function FaReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
                }
            }
        ]
    })(props);
}
function FaRedhat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                }
            }
        ]
    })(props);
}
function FaRenren(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                }
            }
        ]
    })(props);
}
function FaReplyd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                }
            }
        ]
    })(props);
}
function FaResearchgate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                }
            }
        ]
    })(props);
}
function FaResolving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                }
            }
        ]
    })(props);
}
function FaRev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                }
            }
        ]
    })(props);
}
function FaRocketchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                }
            }
        ]
    })(props);
}
function FaRockrms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                }
            }
        ]
    })(props);
}
function FaRust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                }
            }
        ]
    })(props);
}
function FaSafari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                }
            }
        ]
    })(props);
}
function FaSalesforce(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                }
            }
        ]
    })(props);
}
function FaSass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                }
            }
        ]
    })(props);
}
function FaSchlix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                }
            }
        ]
    })(props);
}
function FaScreenpal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"
                }
            }
        ]
    })(props);
}
function FaScribd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                }
            }
        ]
    })(props);
}
function FaSearchengin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function FaSellcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                }
            }
        ]
    })(props);
}
function FaSellsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                }
            }
        ]
    })(props);
}
function FaServicestack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                }
            }
        ]
    })(props);
}
function FaShirtsinbulk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                }
            }
        ]
    })(props);
}
function FaShopify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                }
            }
        ]
    })(props);
}
function FaShopware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                }
            }
        ]
    })(props);
}
function FaSimplybuilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                }
            }
        ]
    })(props);
}
function FaSistrix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                }
            }
        ]
    })(props);
}
function FaSith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                }
            }
        ]
    })(props);
}
function FaSitrox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"
                }
            }
        ]
    })(props);
}
function FaSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                }
            }
        ]
    })(props);
}
function FaSkyatlas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                }
            }
        ]
    })(props);
}
function FaSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                }
            }
        ]
    })(props);
}
function FaSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                }
            }
        ]
    })(props);
}
function FaSlideshare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                }
            }
        ]
    })(props);
}
function FaSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"
                }
            }
        ]
    })(props);
}
function FaSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
                }
            }
        ]
    })(props);
}
function FaSourcetree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                }
            }
        ]
    })(props);
}
function FaSpaceAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"
                }
            }
        ]
    })(props);
}
function FaSpeakap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                }
            }
        ]
    })(props);
}
function FaSpeakerDeck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                }
            }
        ]
    })(props);
}
function FaSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                }
            }
        ]
    })(props);
}
function FaSquareBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
                }
            }
        ]
    })(props);
}
function FaSquareDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
                }
            }
        ]
    })(props);
}
function FaSquareFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                }
            }
        ]
    })(props);
}
function FaSquareFontAwesomeStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.6,152c-25.4,0-37.4,10.4-57.6,14.4V160c0-8.8-7.2-16-16-16s-16,7.2-16,16v192c0,0.8,0.1,1.6,0.2,2.4 c0.1,0.4,0.1,0.8,0.2,1.2c1.6,7.1,8,12.4,15.6,12.4s14-5.3,15.6-12.4c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.8,0.2-1.6,0.2-2.4V198.4 c4-0.8,7.7-1.8,11.2-3c14.3-4.7,26-11.4,46.4-11.4c31.4,0,43.2,16,74.6,16c8.9,0,15.9-1.1,24.2-3.5c1.2-0.3,2.4-0.7,3.6-1.1v96 c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.4-16-74.6-16c-10.2,0-18.2,1.8-25.6,4v32c7.4-2.4,15.4-4,25.6-4c31.4,0,43.2,16,74.6,16 c18.6,0,28.2-4.8,59.8-16V152c-31.6,11.2-41.2,16-59.8,16C244.8,168,232.8,152,201.6,152z M384,32H64C28.7,32,0,60.7,0,96v320 c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96C448,60.7,419.3,32,384,32z M416,416c0,17.6-14.4,32-32,32H64 c-17.6,0-32-14.4-32-32V96c0-17.6,14.4-32,32-32h320c17.6,0,32,14.4,32,32V416z"
                }
            }
        ]
    })(props);
}
function FaSquareFontAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.5,32.5h-320c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-320 C448.5,61.2,419.8,32.5,384.5,32.5z M336.5,312.5c-31.6,11.2-41.2,16-59.8,16c-31.4,0-43.2-16-74.6-16c-10.2,0-18.2,1.6-25.6,4v-32 c7.4-2.2,15.4-4,25.6-4c31.2,0,43.2,16,74.6,16c10.2,0,17.8-1.4,27.8-4.6v-96c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.2-16-74.6-16 c-25.4,0-37.4,10.4-57.6,14.4v153.6c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16v-192c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v6.4 c20.2-4,32.2-14.4,57.6-14.4c31.2,0,43.2,16,74.6,16c18.6,0,28.2-4.8,59.8-16V312.5z"
                }
            }
        ]
    })(props);
}
function FaSquareGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
                }
            }
        ]
    })(props);
}
function FaSquareGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
                }
            }
        ]
    })(props);
}
function FaSquareGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32H400C426.5 32 448 53.5 448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32zM382.1 224.9L337.5 108.5C336.6 106.2 334.9 104.2 332.9 102.9C331.3 101.9 329.5 101.3 327.7 101.1C325.9 100.9 324 101.2 322.3 101.8C320.6 102.5 319 103.5 317.8 104.9C316.6 106.3 315.7 107.9 315.2 109.7L285 201.9H162.1L132.9 109.7C132.4 107.9 131.4 106.3 130.2 104.9C128.1 103.6 127.4 102.5 125.7 101.9C123.1 101.2 122.1 100.1 120.3 101.1C118.5 101.3 116.7 101.9 115.1 102.9C113.1 104.2 111.5 106.2 110.6 108.5L65.94 224.9L65.47 226.1C59.05 242.9 58.26 261.3 63.22 278.6C68.18 295.9 78.62 311.1 92.97 321.9L93.14 322L93.52 322.3L161.4 373.2L215.6 414.1C217.1 415.1 220.9 416.9 223.9 416.9C226.9 416.9 229.9 415.1 232.3 414.1L286.4 373.2L354.8 322L355 321.9C369.4 311 379.8 295.8 384.8 278.6C389.7 261.3 388.1 242.9 382.5 226.1L382.1 224.9z"
                }
            }
        ]
    })(props);
}
function FaSquareGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
                }
            }
        ]
    })(props);
}
function FaSquareHackerNews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function FaSquareInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                }
            }
        ]
    })(props);
}
function FaSquareJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function FaSquareLastfm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
                }
            }
        ]
    })(props);
}
function FaSquareOdnoklassniki(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
                }
            }
        ]
    })(props);
}
function FaSquarePiedPiper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                }
            }
        ]
    })(props);
}
function FaSquarePinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function FaSquareReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
                }
            }
        ]
    })(props);
}
function FaSquareSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"
                }
            }
        ]
    })(props);
}
function FaSquareSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
                }
            }
        ]
    })(props);
}
function FaSquareThreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"
                }
            }
        ]
    })(props);
}
function FaSquareTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
                }
            }
        ]
    })(props);
}
function FaSquareTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"
                }
            }
        ]
    })(props);
}
function FaSquareViadeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
                }
            }
        ]
    })(props);
}
function FaSquareVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
                }
            }
        ]
    })(props);
}
function FaSquareWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
                }
            }
        ]
    })(props);
}
function FaSquareXTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
                }
            }
        ]
    })(props);
}
function FaSquareXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
                }
            }
        ]
    })(props);
}
function FaSquareYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                }
            }
        ]
    })(props);
}
function FaSquarespace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                }
            }
        ]
    })(props);
}
function FaStackExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                }
            }
        ]
    })(props);
}
function FaStackOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                }
            }
        ]
    })(props);
}
function FaStackpath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                }
            }
        ]
    })(props);
}
function FaStaylinked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                }
            }
        ]
    })(props);
}
function FaSteamSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                }
            }
        ]
    })(props);
}
function FaSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                }
            }
        ]
    })(props);
}
function FaStickerMule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                }
            }
        ]
    })(props);
}
function FaStrava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                }
            }
        ]
    })(props);
}
function FaStripeS(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                }
            }
        ]
    })(props);
}
function FaStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                }
            }
        ]
    })(props);
}
function FaStubber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"
                }
            }
        ]
    })(props);
}
function FaStudiovinari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                }
            }
        ]
    })(props);
}
function FaStumbleuponCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                }
            }
        ]
    })(props);
}
function FaStumbleupon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                }
            }
        ]
    })(props);
}
function FaSuperpowers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                }
            }
        ]
    })(props);
}
function FaSupple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                }
            }
        ]
    })(props);
}
function FaSuse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
                }
            }
        ]
    })(props);
}
function FaSwift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                }
            }
        ]
    })(props);
}
function FaSymfony(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                }
            }
        ]
    })(props);
}
function FaTeamspeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"
                }
            }
        ]
    })(props);
}
function FaTelegram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
                }
            }
        ]
    })(props);
}
function FaTencentWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                }
            }
        ]
    })(props);
}
function FaTheRedYeti(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                }
            }
        ]
    })(props);
}
function FaThemeco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                }
            }
        ]
    })(props);
}
function FaThemeisle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                }
            }
        ]
    })(props);
}
function FaThinkPeaks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                }
            }
        ]
    })(props);
}
function FaThreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
                }
            }
        ]
    })(props);
}
function FaTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                }
            }
        ]
    })(props);
}
function FaTradeFederation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                }
            }
        ]
    })(props);
}
function FaTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                }
            }
        ]
    })(props);
}
function FaTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                }
            }
        ]
    })(props);
}
function FaTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                }
            }
        ]
    })(props);
}
function FaTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                }
            }
        ]
    })(props);
}
function FaTypo3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                }
            }
        ]
    })(props);
}
function FaUber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                }
            }
        ]
    })(props);
}
function FaUbuntu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
                }
            }
        ]
    })(props);
}
function FaUikit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                }
            }
        ]
    })(props);
}
function FaUmbraco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                }
            }
        ]
    })(props);
}
function FaUncharted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                }
            }
        ]
    })(props);
}
function FaUniregistry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                }
            }
        ]
    })(props);
}
function FaUnity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"
                }
            }
        ]
    })(props);
}
function FaUnsplash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                }
            }
        ]
    })(props);
}
function FaUntappd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                }
            }
        ]
    })(props);
}
function FaUps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                }
            }
        ]
    })(props);
}
function FaUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                }
            }
        ]
    })(props);
}
function FaUsps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                }
            }
        ]
    })(props);
}
function FaUssunnah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 482 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"
                }
            }
        ]
    })(props);
}
function FaVaadin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                }
            }
        ]
    })(props);
}
function FaViacoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                }
            }
        ]
    })(props);
}
function FaViadeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                }
            }
        ]
    })(props);
}
function FaViber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                }
            }
        ]
    })(props);
}
function FaVimeoV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                }
            }
        ]
    })(props);
}
function FaVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                }
            }
        ]
    })(props);
}
function FaVine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                }
            }
        ]
    })(props);
}
function FaVk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"
                }
            }
        ]
    })(props);
}
function FaVnv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                }
            }
        ]
    })(props);
}
function FaVuejs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                }
            }
        ]
    })(props);
}
function FaWatchmanMonitoring(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                }
            }
        ]
    })(props);
}
function FaWaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                }
            }
        ]
    })(props);
}
function FaWeebly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                }
            }
        ]
    })(props);
}
function FaWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                }
            }
        ]
    })(props);
}
function FaWeixin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                }
            }
        ]
    })(props);
}
function FaWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                }
            }
        ]
    })(props);
}
function FaWhmcs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                }
            }
        ]
    })(props);
}
function FaWikipediaW(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                }
            }
        ]
    })(props);
}
function FaWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                }
            }
        ]
    })(props);
}
function FaWirsindhandwerk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"
                }
            }
        ]
    })(props);
}
function FaWix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                }
            }
        ]
    })(props);
}
function FaWizardsOfTheCoast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                }
            }
        ]
    })(props);
}
function FaWodu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                }
            }
        ]
    })(props);
}
function FaWolfPackBattalion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                }
            }
        ]
    })(props);
}
function FaWordpressSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                }
            }
        ]
    })(props);
}
function FaWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                }
            }
        ]
    })(props);
}
function FaWpbeginner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                }
            }
        ]
    })(props);
}
function FaWpexplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                }
            }
        ]
    })(props);
}
function FaWpforms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                }
            }
        ]
    })(props);
}
function FaWpressr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                }
            }
        ]
    })(props);
}
function FaXTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
                }
            }
        ]
    })(props);
}
function FaXbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                }
            }
        ]
    })(props);
}
function FaXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                }
            }
        ]
    })(props);
}
function FaYCombinator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                }
            }
        ]
    })(props);
}
function FaYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                }
            }
        ]
    })(props);
}
function FaYammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"
                }
            }
        ]
    })(props);
}
function FaYandexInternational(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                }
            }
        ]
    })(props);
}
function FaYandex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                }
            }
        ]
    })(props);
}
function FaYarn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                }
            }
        ]
    })(props);
}
function FaYelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                }
            }
        ]
    })(props);
}
function FaYoast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                }
            }
        ]
    })(props);
}
function FaYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                }
            }
        ]
    })(props);
}
function FaZhihu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                }
            }
        ]
    })(props);
}
function Fa0(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160V320c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 96c-53 0-96 43-96 96V320c0 53 43 96 96 96s96-43 96-96V192c0-53-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function Fa1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.8 1.6l-96 64C-.5 111.2-4.4 131 5.4 145.8s29.7 18.7 44.4 8.9L96 123.8V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V64z"
                }
            }
        ]
    })(props);
}
function Fa2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M142.9 96c-21.5 0-42.2 8.5-57.4 23.8L54.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L40.2 74.5C67.5 47.3 104.4 32 142.9 32C223 32 288 97 288 177.1c0 38.5-15.3 75.4-42.5 102.6L109.3 416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L200.2 234.5c15.2-15.2 23.8-35.9 23.8-57.4c0-44.8-36.3-81.1-81.1-81.1z"
                }
            }
        ]
    })(props);
}
function Fa3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H272c13.2 0 25 8.1 29.8 20.4s1.5 26.3-8.2 35.2L162.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H105.4C63 480 24.2 456 5.3 418.1l-1.9-3.8c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l1.9 3.8c8.1 16.3 24.8 26.5 42.9 26.5H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H80c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L189.7 96H32C14.3 96 0 81.7 0 64z"
                }
            }
        ]
    })(props);
}
function Fa4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189 77.6c7.5-16 .7-35.1-15.3-42.6s-35.1-.7-42.6 15.3L3 322.4c-4.7 9.9-3.9 21.5 1.9 30.8S21 368 32 368H256v80c0 17.7 14.3 32 32 32s32-14.3 32-32V368h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320V160c0-17.7-14.3-32-32-32s-32 14.3-32 32V304H82.4L189 77.6z"
                }
            }
        ]
    })(props);
}
function Fa5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.5 58.3C35.3 43.1 48.5 32 64 32H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H90.7L70.3 208H184c75.1 0 136 60.9 136 136s-60.9 136-136 136H100.5c-39.4 0-75.4-22.3-93-57.5l-4.1-8.2c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l4.1 8.2c6.8 13.6 20.6 22.1 35.8 22.1H184c39.8 0 72-32.2 72-72s-32.2-72-72-72H32c-9.5 0-18.5-4.2-24.6-11.5s-8.6-16.9-6.9-26.2l32-176z"
                }
            }
        ]
    })(props);
}
function Fa6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.4 84.7c11.4-13.5 9.7-33.7-3.8-45.1s-33.7-9.7-45.1 3.8L38.6 214.7C14.7 242.9 1.1 278.4 .1 315.2c0 1.4-.1 2.9-.1 4.3c0 .2 0 .3 0 .5c0 88.4 71.6 160 160 160s160-71.6 160-160c0-85.5-67.1-155.4-151.5-159.8l63.9-75.6zM256 320A96 96 0 1 1 64 320a96 96 0 1 1 192 0z"
                }
            }
        ]
    })(props);
}
function Fa7(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H288c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96H32C14.3 96 0 81.7 0 64z"
                }
            }
        ]
    })(props);
}
function Fa8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 34.6 13.7 66 36 89C20.5 272.3 0 309.8 0 352c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128c0-42.2-20.5-79.7-52-103c22.3-23 36-54.4 36-89zM176.1 288H192c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64h15.9c0 0 .1 0 .1 0h32c0 0 .1 0 .1 0zm0-64c0 0 0 0 0 0H144c0 0 0 0 0 0c-35.3 0-64-28.7-64-64c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64c0 35.3-28.6 64-64 64z"
                }
            }
        ]
    })(props);
}
function Fa9(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 192a96 96 0 1 0 192 0A96 96 0 1 0 64 192zm87.5 159.8C67.1 347.4 0 277.5 0 192C0 103.6 71.6 32 160 32s160 71.6 160 160c0 2.6-.1 5.3-.2 7.9c-1.7 35.7-15.2 70-38.4 97.4l-145 171.4c-11.4 13.5-31.6 15.2-45.1 3.8s-15.2-31.6-3.8-45.1l63.9-75.6z"
                }
            }
        ]
    })(props);
}
function FaA(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7l-120 288-40 96c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L93.3 384H290.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-40-96-120-288zM264 320H120l72-172.8L264 320z"
                }
            }
        ]
    })(props);
}
function FaAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM208 288h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
                }
            }
        ]
    })(props);
}
function FaAddressCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 256h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"
                }
            }
        ]
    })(props);
}
function FaAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"
                }
            }
        ]
    })(props);
}
function FaAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaAnchorCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaAnchorCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaAnchorCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8.2 0 16.3-.6 24.2-1.8c-22.2-16.2-40.4-37.5-53-62.2H320V368 240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaAnchorLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c8 0 15.9-.6 23.6-1.7c-4.8-9-7.6-19.3-7.6-30.3V446.7c-5.2 .9-10.5 1.3-16 1.3H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm21.1 80C367 158.8 384 129.4 384 96c0-53-43-96-96-96s-96 43-96 96c0 33.4 17 62.8 42.9 80H224c-17.7 0-32 14.3-32 32s14.3 32 32 32h32V448H208c-53 0-96-43-96-96v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97 263c-9.4-9.4-24.6-9.4-33.9 0L7 319c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 88.4 71.6 160 160 160h80 80c88.4 0 160-71.6 160-160v-6.1l7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0l-56 56c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7V352c0 53-43 96-96 96H320V240h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H341.1z"
                }
            }
        ]
    })(props);
}
function FaAngleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                }
            }
        ]
    })(props);
}
function FaAngleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                }
            }
        ]
    })(props);
}
function FaAngleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                }
            }
        ]
    })(props);
}
function FaAngleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
                }
            }
        ]
    })(props);
}
function FaAnglesDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 402.7 361.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 210.7 361.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
                }
            }
        ]
    })(props);
}
function FaAnglesLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
                }
            }
        ]
    })(props);
}
function FaAnglesRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                }
            }
        ]
    })(props);
}
function FaAnglesUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3 361.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 301.3 361.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaAnkh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1c-5.9 6.2-11.8 11.8-17.4 16.7c-5.6-4.9-11.5-10.5-17.4-16.7C116.7 204.6 96 169.6 96 128zM160 0C89.3 0 32 57.3 32 128c0 52.4 21.5 95.5 46.8 128H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V480c0 17.7 14.3 32 32 32s32-14.3 32-32V320h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H241.2c25.4-32.5 46.8-75.6 46.8-128C288 57.3 230.7 0 160 0z"
                }
            }
        ]
    })(props);
}
function FaAppleWhole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 112c-8.8 0-16-7.2-16-16V80c0-44.2 35.8-80 80-80h16c8.8 0 16 7.2 16 16V32c0 44.2-35.8 80-80 80H224zM0 288c0-76.3 35.7-160 112-160c27.3 0 59.7 10.3 82.7 19.3c18.8 7.3 39.9 7.3 58.7 0c22.9-8.9 55.4-19.3 82.7-19.3c76.3 0 112 83.7 112 160c0 128-80 224-160 224c-16.5 0-38.1-6.6-51.5-11.3c-8.1-2.8-16.9-2.8-25 0c-13.4 4.7-35 11.3-51.5 11.3C80 512 0 416 0 288z"
                }
            }
        ]
    })(props);
}
function FaArchway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H96h64V352c0-53 43-96 96-96s96 43 96 96V480h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32V128H32V416z"
                }
            }
        ]
    })(props);
}
function FaArrowDown19(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V160H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V64c0-10.3-4.9-19.9-13.3-26zM160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM418.3 307a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 307zM405.1 419.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
                }
            }
        ]
    })(props);
}
function FaArrowDown91(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 480c9 0 17.5-3.8 23.6-10.4l88-96c11.9-13 11.1-33.3-2-45.2s-33.3-11.1-45.2 2L192 365.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V365.7L95.6 330.4c-11.9-13-32.2-13.9-45.2-2s-13.9 32.2-2 45.2l88 96C142.5 476.2 151 480 160 480zM450.7 294c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2V416H384c-17.7 0-32 14.3-32 32s14.3 32 32 32h48 48c17.7 0 32-14.3 32-32s-14.3-32-32-32H464V320c0-10.3-4.9-19.9-13.3-26zM418.3 91a32 32 0 1 1 27.4 57.9A32 32 0 1 1 418.3 91zM405.1 203.8l-6.8 9.2c-10.5 14.2-7.5 34.2 6.7 44.8s34.2 7.5 44.8-6.7l48.8-65.8c14-18.9 21.5-41.7 21.5-65.2c0-48.6-39.4-88-88-88s-88 39.4-88 88c0 39.2 25.6 72.4 61.1 83.8z"
                }
            }
        ]
    })(props);
}
function FaArrowDownAZ(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 320c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 416H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 352H352c-17.7 0-32-14.3-32-32zM416 32c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 224H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128C392.8 38.8 403.9 32 416 32zM395.8 176h40.4L416 135.6 395.8 176z"
                }
            }
        ]
    })(props);
}
function FaArrowDownLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7L86.6 329.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
                }
            }
        ]
    })(props);
}
function FaArrowDownShortWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaArrowDownUpAcrossLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M137.4 502.6c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H448V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L384 109.3V224H192 128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96zM128 192h64V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192zM448 320H384V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"
                }
            }
        ]
    })(props);
}
function FaArrowDownUpLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.6 502.6l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7V288H416V272c0-17.2 3.9-33.5 10.8-48H352V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 109.3V224l-128 0H96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32H96V402.7L54.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0zM160 192V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64zM288 320V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H288zm240-80c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaArrowDownWideShort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320z"
                }
            }
        ]
    })(props);
}
function FaArrowDownZA(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 469.6C177.5 476.2 169 480 160 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L128 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 64c0-17.7 14.3-32 32-32H480c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L429.3 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H352c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L402.7 96H352c-17.7 0-32-14.3-32-32zm96 192c12.1 0 23.2 6.8 28.6 17.7l64 128 16 32c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3L460.2 448H371.8l-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l16-32 64-128c5.4-10.8 16.5-17.7 28.6-17.7zM395.8 400h40.4L416 359.6 395.8 400z"
                }
            }
        ]
    })(props);
}
function FaArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                }
            }
        ]
    })(props);
}
function FaArrowLeftLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
                }
            }
        ]
    })(props);
}
function FaArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                }
            }
        ]
    })(props);
}
function FaArrowPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 55.2V426c0 12.2 9.9 22 22 22c6.3 0 12.4-2.7 16.6-7.5L121.2 346l58.1 116.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9L179.8 320H297.9c12.2 0 22.1-9.9 22.1-22.1c0-6.3-2.7-12.3-7.4-16.5L38.6 37.9C34.3 34.1 28.9 32 23.2 32C10.4 32 0 42.4 0 55.2z"
                }
            }
        ]
    })(props);
}
function FaArrowRightArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.6 150.6c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.7 96 32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l306.7 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96zm-333.3 352c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 416 416 416c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96z"
                }
            }
        ]
    })(props);
}
function FaArrowRightFromBracket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
                }
            }
        ]
    })(props);
}
function FaArrowRightLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
                }
            }
        ]
    })(props);
}
function FaArrowRightToBracket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
                }
            }
        ]
    })(props);
}
function FaArrowRightToCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM166.6 153.4l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H146.7l-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0z"
                }
            }
        ]
    })(props);
}
function FaArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                }
            }
        ]
    })(props);
}
function FaArrowRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.7 160H176c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32s32 14.3 32 32v51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
                }
            }
        ]
    })(props);
}
function FaArrowRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
                }
            }
        ]
    })(props);
}
function FaArrowTrendDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v82.7L342.6 137.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352H384z"
                }
            }
        ]
    })(props);
}
function FaArrowTrendUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H544c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32s-32-14.3-32-32V205.3L342.6 374.6c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160H384z"
                }
            }
        ]
    })(props);
}
function FaArrowTurnDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
                }
            }
        ]
    })(props);
}
function FaArrowTurnUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
                }
            }
        ]
    })(props);
}
function FaArrowUp19(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M450.7 38c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V108.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM445.7 364.9A32 32 0 1 0 418.3 307a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 408.4 344 375.2 344 336c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 467c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
                }
            }
        ]
    })(props);
}
function FaArrowUp91(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32c9 0 17.5 3.8 23.6 10.4l88 96c11.9 13 11.1 33.3-2 45.2s-33.3 11.1-45.2-2L192 146.3V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V146.3L95.6 181.6c-11.9 13-32.2 13.9-45.2 2s-13.9-32.2-2-45.2l88-96C142.5 35.8 151 32 160 32zM450.7 294c8.3 6 13.3 15.7 13.3 26v96h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 384c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V364.4l-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zm-5-145.1A32 32 0 1 0 418.3 91a32 32 0 1 0 27.4 57.9zm-40.7 54.9C369.6 192.4 344 159.2 344 120c0-48.6 39.4-88 88-88s88 39.4 88 88c0 23.5-7.5 46.3-21.5 65.2L449.7 251c-10.5 14.2-30.6 17.2-44.8 6.7s-17.2-30.6-6.7-44.8l6.8-9.2z"
                }
            }
        ]
    })(props);
}
function FaArrowUpAZ(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 320c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zM416 32c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 38.8 428.1 32 416 32zM395.8 176L416 135.6 436.2 176H395.8z"
                }
            }
        ]
    })(props);
}
function FaArrowUpFromBracket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3V320c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 53 43 96 96 96H352c53 0 96-43 96-96V352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352z"
                }
            }
        ]
    })(props);
}
function FaArrowUpFromGroundWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 352c17.7 0 32-14.3 32-32V109.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V320c0 17.7 14.3 32 32 32zm-18.5 69.9C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM192 192H48c-26.5 0-48 21.5-48 48V425c5.3-3.1 11.2-5.4 17.5-6.9c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.1 20.3V192zm384 48c0-26.5-21.5-48-48-48H384V416.5h0c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c6.3 1.5 12.1 3.8 17.5 6.9V240z"
                }
            }
        ]
    })(props);
}
function FaArrowUpFromWaterPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0C85.5 0 64 21.5 64 48V256H48c-26.5 0-48 21.5-48 48v96c0 8 2 15.6 5.4 22.2c3.8-1.7 7.8-3.1 12-4.1c13.1-3.1 26.7-9.8 37.3-18.6c22.2-18.7 54.3-20.1 78.1-3.4c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c4.2 1 8.2 2.4 12 4.1C574 415.6 576 408 576 400V304c0-26.5-21.5-48-48-48H480l0-146.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 109.3 416 256H288V48c0-26.5-21.5-48-48-48H112zM306.5 421.9c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448c-27.5 0-55-10.6-77.5-26.1z"
                }
            }
        ]
    })(props);
}
function FaArrowUpLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
                }
            }
        ]
    })(props);
}
function FaArrowUpRightDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L9.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L256 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H160zM576 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM448 208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm128 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM272 384a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM576 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-48-80a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaArrowUpRightFromSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                }
            }
        ]
    })(props);
}
function FaArrowUpShortWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
                }
            }
        ]
    })(props);
}
function FaArrowUpWideShort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.6 42.4C145.5 35.8 137 32 128 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L96 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 480h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaArrowUpZA(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.6 42.4C177.5 35.8 169 32 160 32s-17.5 3.8-23.6 10.4l-88 96c-11.9 13-11.1 33.3 2 45.2s33.3 11.1 45.2-2L128 146.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V146.3l32.4 35.4c11.9 13 32.2 13.9 45.2 2s13.9-32.2 2-45.2l-88-96zM320 64c0 17.7 14.3 32 32 32h50.7l-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H429.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H352c-17.7 0-32 14.3-32 32zm96 192c-12.1 0-23.2 6.8-28.6 17.7l-64 128-16 32c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3h88.4l7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-16-32-64-128C439.2 262.8 428.1 256 416 256zM395.8 400L416 359.6 436.2 400H395.8z"
                }
            }
        ]
    })(props);
}
function FaArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
                }
            }
        ]
    })(props);
}
function FaArrowsDownToLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 416L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32zm22.6-137.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L480 274.7 480 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96zm-320-45.3c-12.5-12.5-32.8-12.5-45.3 0L160 274.7 160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7L54.6 233.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaArrowsDownToPeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0c-13.3 0-24 10.7-24 24V142.1L97 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24zM360 200a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM184 296a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm312 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 345.5V400c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V345.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 468.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 441.5V480c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V441.5zM415 153l64 64c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V142.1l-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaArrowsLeftRightToLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaArrowsLeftRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M406.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224l-293.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288l293.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
                }
            }
        ]
    })(props);
}
function FaArrowsRotate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"
                }
            }
        ]
    })(props);
}
function FaArrowsSpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96c38.4 0 73.7 13.5 101.3 36.1l-32.6 32.6c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H448c8.8 0 16-7.2 16-16V64c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5l-34 34C363.4 52.6 312.1 32 256 32c-10.9 0-21.5 .8-32 2.3V99.2c10.3-2.1 21-3.2 32-3.2zM132.1 154.7l32.6 32.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V64c0-8.8-7.2-16-16-16H64c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l34 34C52.6 148.6 32 199.9 32 256c0 10.9 .8 21.5 2.3 32H99.2c-2.1-10.3-3.2-21-3.2-32c0-38.4 13.5-73.7 36.1-101.3zM477.7 224H412.8c2.1 10.3 3.2 21 3.2 32c0 38.4-13.5 73.7-36.1 101.3l-32.6-32.6c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8V448c0 8.8 7.2 16 16 16H448c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-34-34C459.4 363.4 480 312.1 480 256c0-10.9-.8-21.5-2.3-32zM256 416c-38.4 0-73.7-13.5-101.3-36.1l32.6-32.6c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H64c-8.8 0-16 7.2-16 16l0 112c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l34-34C148.6 459.4 199.9 480 256 480c10.9 0 21.5-.8 32-2.3V412.8c-10.3 2.1-21 3.2-32 3.2z"
                }
            }
        ]
    })(props);
}
function FaArrowsSplitUpAndLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 150.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L352 109.3V384c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c-70.7 0-128-57.3-128-128c0-35.3-28.7-64-64-64H109.3l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 256H224c23.3 0 45.2 6.2 64 17.1V109.3l-41.4 41.4z"
                }
            }
        ]
    })(props);
}
function FaArrowsToCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"
                }
            }
        ]
    })(props);
}
function FaArrowsToDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c17.7 0 32 14.3 32 32V64h32c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8h32V32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H288v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H192c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224H64V192c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6v32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaArrowsToEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15C24.4 5.7 39.6 5.7 49 15l63 63V40c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H78.1L15 49C5.7 39.6 5.7 24.4 15 15zM133.5 243.9C158.6 193.6 222.7 112 320 112s161.4 81.6 186.5 131.9c3.8 7.6 3.8 16.5 0 24.2C481.4 318.4 417.3 400 320 400s-161.4-81.6-186.5-131.9c-3.8-7.6-3.8-16.5 0-24.2zM320 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM591 15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-63 63H600c13.3 0 24 10.7 24 24s-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V40c0-13.3 10.7-24 24-24s24 10.7 24 24V78.1l63-63zM15 497c-9.4-9.4-9.4-24.6 0-33.9l63-63H40c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V433.9L49 497c-9.4 9.4-24.6 9.4-33.9 0zm576 0l-63-63V472c0 13.3-10.7 24-24 24s-24-10.7-24-24V376c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H561.9l63 63c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
                }
            }
        ]
    })(props);
}
function FaArrowsTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 160H128c-35.3 0-64 28.7-64 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V224C0 153.3 57.3 96 128 96H338.7L297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416H96c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96H242.7l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaArrowsTurnToDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.4 25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 96 416 96c53 0 96 43 96 96v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7-14.3-32-32-32l-146.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm13.3 256l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 416 96 416c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM384 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192A64 64 0 1 1 64 64a64 64 0 1 1 0 128z"
                }
            }
        ]
    })(props);
}
function FaArrowsUpDownLeftRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4V224H109.3l9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4H224V402.7l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4V288H402.7l-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4H288V109.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
                }
            }
        ]
    })(props);
}
function FaArrowsUpDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 109.3V402.7L86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 402.7V109.3l41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
                }
            }
        ]
    })(props);
}
function FaArrowsUpToLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96zM9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 237.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96zm320 45.3c12.5 12.5 32.8 12.5 45.3 0L416 237.3 416 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3z"
                }
            }
        ]
    })(props);
}
function FaAsterisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256v32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32v80 32c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                }
            }
        ]
    })(props);
}
function FaAtom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 398.8c-11.8 5.1-23.4 9.7-34.9 13.5c16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM446 256c33 45.2 44.3 90.9 23.6 128c-20.2 36.3-62.5 49.3-115.2 43.2c-22 52.1-55.6 84.8-98.4 84.8s-76.4-32.7-98.4-84.8c-52.7 6.1-95-6.8-115.2-43.2C21.7 346.9 33 301.2 66 256c-33-45.2-44.3-90.9-23.6-128c20.2-36.3 62.5-49.3 115.2-43.2C179.6 32.7 213.2 0 256 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2c20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2c31.8 1.4 38.6-8.7 40.2-11.7c2.3-4.2 7-17.9-11.9-48.1c-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2c7.6 6.1 14.8 12.3 21.6 18.6c18.9-30.2 14.2-44 11.9-48.1c-1.6-2.9-8.4-13-40.2-11.7zM290.9 99.7C274.1 65.9 259.9 64 256 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5c11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2c-31.8-1.4-38.6 8.7-40.2 11.7c-2.3 4.2-7 17.9 11.9 48.1c6.8-6.3 14-12.5 21.6-18.6zM110.2 304.8C91.4 335 96 348.7 98.3 352.9c1.6 2.9 8.4 13 40.2 11.7c-2.8-13.1-5-26.9-6.7-41.2c-7.6-6.1-14.8-12.3-21.6-18.6zM336 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaAudioDescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM213.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7l-9.4-18.9H150.9l-9.4 18.9c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zm-.4 106.6L192 237.7l-21.1 42.2h42.2zM304 184c0-13.3 10.7-24 24-24h56c53 0 96 43 96 96s-43 96-96 96H328c-13.3 0-24-10.7-24-24V184zm48 24v96h32c26.5 0 48-21.5 48-48s-21.5-48-48-48H352z"
                }
            }
        ]
    })(props);
}
function FaAustralSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.5 51.7C248.6 39.8 236.9 32 224 32s-24.6 7.8-29.5 19.7L122.7 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96L82.7 320H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H56L34.5 435.7c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L125.3 384H322.7l31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8L392 384h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H365.3L352 288h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H325.3L253.5 51.7zM256 224H192l32-76.8L256 224zm-90.7 64H282.7L296 320H152l13.3-32z"
                }
            }
        ]
    })(props);
}
function FaAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.8 5.5c11-7.3 25.4-7.3 36.4 0L228 17.2c6 3.9 13 5.8 20.1 5.4l21.3-1.3c13.2-.8 25.6 6.4 31.5 18.2l9.6 19.1c3.2 6.4 8.4 11.5 14.7 14.7L344.5 83c11.8 5.9 19 18.3 18.2 31.5l-1.3 21.3c-.4 7.1 1.5 14.2 5.4 20.1l11.8 17.8c7.3 11 7.3 25.4 0 36.4L366.8 228c-3.9 6-5.8 13-5.4 20.1l1.3 21.3c.8 13.2-6.4 25.6-18.2 31.5l-19.1 9.6c-6.4 3.2-11.5 8.4-14.7 14.7L301 344.5c-5.9 11.8-18.3 19-31.5 18.2l-21.3-1.3c-7.1-.4-14.2 1.5-20.1 5.4l-17.8 11.8c-11 7.3-25.4 7.3-36.4 0L156 366.8c-6-3.9-13-5.8-20.1-5.4l-21.3 1.3c-13.2 .8-25.6-6.4-31.5-18.2l-9.6-19.1c-3.2-6.4-8.4-11.5-14.7-14.7L39.5 301c-11.8-5.9-19-18.3-18.2-31.5l1.3-21.3c.4-7.1-1.5-14.2-5.4-20.1L5.5 210.2c-7.3-11-7.3-25.4 0-36.4L17.2 156c3.9-6 5.8-13 5.4-20.1l-1.3-21.3c-.8-13.2 6.4-25.6 18.2-31.5l19.1-9.6C65 70.2 70.2 65 73.4 58.6L83 39.5c5.9-11.8 18.3-19 31.5-18.2l21.3 1.3c7.1 .4 14.2-1.5 20.1-5.4L173.8 5.5zM272 192a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM1.3 441.8L44.4 339.3c.2 .1 .3 .2 .4 .4l9.6 19.1c11.7 23.2 36 37.3 62 35.8l21.3-1.3c.2 0 .5 0 .7 .2l17.8 11.8c5.1 3.3 10.5 5.9 16.1 7.7l-37.6 89.3c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2L74.4 455.5l-56.1 8.3c-5.7 .8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L211.7 413c5.6-1.8 11-4.3 16.1-7.7l17.8-11.8c.2-.1 .4-.2 .7-.2l21.3 1.3c26 1.5 50.3-12.6 62-35.8l9.6-19.1c.1-.2 .2-.3 .4-.4l43.2 102.5c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
                }
            }
        ]
    })(props);
}
function FaB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H192c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128H64zm96 192H64V96h96c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288h96 32c35.3 0 64 28.7 64 64s-28.7 64-64 64H64V288z"
                }
            }
        ]
    })(props);
}
function FaBabyCarriage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 192H.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192zm128-32c0-35.3 28.7-64 64-64h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0v64c0 25.2-5.8 50.2-17 73.5s-27.8 44.5-48.6 62.3s-45.5 32-72.7 41.6S253.4 416 224 416s-58.5-5-85.7-14.6s-51.9-23.8-72.7-41.6s-37.3-39-48.6-62.3S0 249.2 0 224l224 0 160 0V160zM80 416a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm240 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                }
            }
        ]
    })(props);
}
function FaBaby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 88a72 72 0 1 1 144 0A72 72 0 1 1 152 88zM39.7 144.5c13-17.9 38-21.8 55.9-8.8L131.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25V288H128V251.7c-15.2-6.7-29.7-15.1-43.3-25L48.5 200.3c-17.9-13-21.8-38-8.8-55.9zm89.8 184.8l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C70 438.6 68.1 417 79.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L284 419.4l-26-37.2z"
                }
            }
        ]
    })(props);
}
function FaBackwardFast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.6 445c-11.2 5.3-24.5 3.6-34.1-4.4L288 297.7V416c0 12.4-7.2 23.7-18.4 29s-24.5 3.6-34.1-4.4L64 297.7V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V214.3L235.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S288 83.6 288 96V214.3L459.5 71.4c9.5-7.9 22.8-9.7 34.1-4.4S512 83.6 512 96V416c0 12.4-7.2 23.7-18.4 29z"
                }
            }
        ]
    })(props);
}
function FaBackwardStep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160L64 241V96c0-17.7-14.3-32-32-32S0 78.3 0 96V416c0 17.7 14.3 32 32 32s32-14.3 32-32V271l11.5 9.6 192 160z"
                }
            }
        ]
    })(props);
}
function FaBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3V256v41.7L459.5 440.6zM256 352V256 128 96c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29V352z"
                }
            }
        ]
    })(props);
}
function FaBacon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.2 1.2c11.2-3.2 23.2-.1 31.4 8.1L518 56.7l-26.5 7.9c-58 16.6-98.1 39.6-129.6 67.4c-31.2 27.5-53.2 59.1-75.1 90.9l-2.3 3.3C241.6 288.7 195 356.6 72.8 417.7L37.9 435.2 9.4 406.6c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C136.1 296.2 180.9 231 223.3 169.3l2.3-3.4c21.8-31.8 44.9-64.9 77.7-93.9c33.4-29.5 75.8-53.6 135.9-70.8zM61.8 459l25.4-12.7c129.5-64.7 179.9-138.1 223.8-202l2.2-3.3c22.1-32.1 42.1-60.5 69.9-85.1c27.5-24.3 63.4-45.2 117.3-60.6l0 0 .2-.1 43.1-12.9 23 23c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2c-26.1 23-45.1 49.9-67.3 82.1l-2.2 3.2C327.8 365.9 275.5 442 142.3 508.6c-12.3 6.2-27.2 3.7-36.9-6L61.8 459z"
                }
            }
        ]
    })(props);
}
function FaBacteria(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.9 .7c-9.6-2.7-19.5 2.8-22.3 12.4l-4.3 15.2c-8.3-.6-16.8 0-25.2 1.9c-7.3 1.7-14.3 3.5-21.1 5.5l-5.5-12.7c-3.9-9.1-14.5-13.4-23.6-9.5s-13.4 14.5-9.5 23.6l4.4 10.4c-16.6 6.7-31.7 14.4-45.4 22.8L147 62c-5.5-8.3-16.7-10.5-25-5s-10.5 16.7-5 25l6 9c-13.7 11-25.5 22.8-35.8 34.9l-10-8c-7.8-6.2-19.1-5-25.3 2.8s-5 19.1 2.8 25.3L65.9 155c-1.8 2.8-3.5 5.7-5.1 8.5c-6.6 11.4-11.8 22.6-16 33l-8-3.2c-9.2-3.7-19.7 .8-23.4 10s.8 19.7 10 23.4l10.4 4.2c-.2 .8-.4 1.5-.5 2.3c-2.2 9.3-3.4 17.3-4.1 23.4c-.4 3.1-.6 5.7-.8 7.8c-.1 1.1-.1 2-.2 2.8l-.1 1.1 0 .5 0 .2 0 .1c0 0 0 .1 29.1 1l-.1 0L28 269.3c-.1 3.1 0 6.1 .2 9.1l-15.2 4.3C3.5 285.4-2 295.4 .7 304.9s12.7 15.1 22.3 12.4l15.6-4.5c7.6 13.6 18.9 25 32.6 32.6L66.7 361c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.3-12.4l4.3-15.2c1.2 .1 2.4 .2 3.6 .2c15.6 .5 30.3-3.3 43-10.2l9 9c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-7.2-7.2c9.3-12.6 15.2-27.8 16.3-44.5l7.1 3c9.1 3.9 19.7-.3 23.6-9.5s-.3-19.7-9.5-23.6l-8.6-3.7c6.4-9.9 17.3-22.4 36.9-33.3l1.3 4.4c2.7 9.6 12.7 15.1 22.3 12.4s15.1-12.7 12.4-22.3l-2.3-8.1c3.8-1.1 7.7-2.1 11.9-3.1c11.6-2.7 22.1-7.7 31.1-14.4l7.2 7.2c7 7 18.4 7 25.5 0s7-18.4 0-25.5l-9-9c7.6-13.9 11.3-30.1 10.1-46.6l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3S370.6 64 361 66.7l-15.6 4.5c-7.7-13.9-19.1-25.1-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3zM112 272l-48-1.5 0 0c11.7 .4 27.3 .9 48 1.6zm16-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM322.7 489c-2.7 9.6 2.8 19.5 12.4 22.3s19.5-2.8 22.2-12.4l4.3-15.2c8.3 .6 16.8 0 25.2-1.9c7.3-1.7 14.3-3.5 21.1-5.5l5.5 12.7c3.9 9.1 14.5 13.4 23.6 9.5s13.4-14.5 9.5-23.6l-4.4-10.4c16.6-6.7 31.7-14.4 45.4-22.8L493 450c5.5 8.3 16.7 10.5 25 5s10.5-16.7 5-25l-6-9c13.7-11 25.5-22.8 35.8-34.9l10 8c7.8 6.2 19.1 5 25.3-2.8s5-19.1-2.8-25.3L574.1 357c1.8-2.8 3.5-5.7 5.1-8.5c6.6-11.4 11.8-22.6 16-33l8 3.2c9.2 3.7 19.7-.8 23.4-10s-.8-19.7-10-23.4l-10.4-4.2c.2-.8 .4-1.5 .5-2.3c2.2-9.3 3.4-17.3 4.1-23.4c.4-3.1 .6-5.7 .8-7.8c.1-1.1 .1-2 .2-2.8l.1-1.1 0-.5 0-.2 0-.1c0 0 0-.1-29.1-1l.1 0 29.1 .9c.1-3.1 0-6.1-.2-9.1l15.2-4.3c9.6-2.7 15.1-12.7 12.4-22.3s-12.7-15.1-22.3-12.4l-15.6 4.5c-7.6-13.6-18.9-25-32.6-32.6l4.5-15.6c2.7-9.6-2.8-19.5-12.4-22.3s-19.5 2.8-22.3 12.4l-4.3 15.2c-1.2-.1-2.4-.2-3.6-.2c-15.6-.5-30.3 3.3-43 10.2l-9-9c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l7.2 7.2c-9.3 12.6-15.2 27.8-16.3 44.5l-7.1-3c-9.1-3.9-19.7 .3-23.6 9.5s.3 19.7 9.5 23.6l8.6 3.7c-6.4 9.9-17.3 22.4-36.9 33.3l-1.3-4.4c-2.7-9.6-12.7-15.1-22.3-12.4s-15.1 12.7-12.4 22.3l2.3 8.1c-3.8 1.1-7.7 2.1-11.9 3.1c-11.6 2.7-22.1 7.7-31.1 14.4l-7.2-7.2c-7-7-18.4-7-25.5 0s-7 18.4 0 25.5l9 9c-7.6 13.9-11.3 30.1-10.1 46.6l-15.2 4.3c-9.6 2.7-15.1 12.7-12.4 22.2s12.7 15.1 22.3 12.4l15.6-4.5c7.7 13.9 19.1 25.1 32.6 32.6L322.7 489zM576 241.5l0 0c-11.7-.4-27.3-.9-48-1.6l48 1.5zM448 384a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
                }
            }
        ]
    })(props);
}
function FaBacterium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.1 30.6c3.6-12.7-3.7-26-16.5-29.7s-26 3.7-29.7 16.5l-4.2 14.7c-9.8-.4-19.9 .5-29.9 2.8c-12.1 2.8-23.7 5.9-34.9 9.4l-5.9-13.7c-5.2-12.2-19.3-17.8-31.5-12.6s-17.8 19.3-12.6 31.5l4.9 11.3c-22 9.4-42 20.1-60.2 31.8L196 82.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3l7.8 11.6c-18 15-33.7 30.8-47.3 47.1L103 157.3c-10.4-8.3-25.5-6.6-33.7 3.7s-6.6 25.5 3.7 33.7l15 12c-2.1 3.2-4.1 6.5-6 9.7c-9.4 15.7-17 31-23.2 45.3l-9.9-3.9c-12.3-4.9-26.3 1.1-31.2 13.4s1.1 26.3 13.4 31.2l11.6 4.6c-.3 1.1-.6 2.1-.9 3.1c-3.5 12.5-5.7 23.2-7.1 31.3c-.7 4.1-1.2 7.5-1.6 10.3c-.2 1.4-.3 2.6-.4 3.6l-.1 1.4-.1 .6 0 .3 0 .1c0 0 0 .1 39.2 3.7l0 0-39.2-3.6c-.5 5-.6 10-.4 14.9l-14.7 4.2C4.7 380.6-2.7 393.8 .9 406.6s16.9 20.1 29.7 16.5l13.8-3.9c10.6 20.7 27.6 37.8 48.5 48.5l-3.9 13.7c-3.6 12.7 3.7 26 16.5 29.7s26-3.7 29.7-16.5l4.2-14.7c23.8 1 46.3-5.5 65.1-17.6L215 473c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c9.1-14.1 15.1-30.5 17-48.3l.1-.8c.3-1.7 1-5.1 2.3-9.8l.2-.8 12.6 5.4c12.2 5.2 26.3-.4 31.5-12.6s-.4-26.3-12.6-31.5l-11.3-4.8c9.9-14.9 24.9-31.6 48.6-46l2.1 7.5c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7L371 259.2c6.9-2.2 14.3-4.3 22.2-6.1c12.9-3 24.7-8 35.2-14.8L439 249c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-10.6-10.6c12.2-19 18.6-41.6 17.6-65.1l14.7-4.2c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5l-13.7 3.9c-10.8-21.2-28-38-48.5-48.5l3.9-13.8zM92.1 363.3l0 0L144 368l-51.9-4.7zM112 320a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM240 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaBagShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 112c0-35.3 28.7-64 64-64s64 28.7 64 64v48H160V112zm-48 48H48c-26.5 0-48 21.5-48 48V416c0 53 43 96 96 96H352c53 0 96-43 96-96V208c0-26.5-21.5-48-48-48H336V112C336 50.1 285.9 0 224 0S112 50.1 112 112v48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaBahai(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c14.5 0 27.2 9.7 30.9 23.8l23.9 89.6 75.9-53.3c11.9-8.3 27.8-7.6 39 1.7s14.6 24.9 8.4 38.1l-39.3 84 92.4 8c14.4 1.2 26.2 12 28.8 26.3s-4.9 28.5-18 34.6l-84.1 39.1 65.7 65.5c10.3 10.2 12.4 26.1 5.1 38.7s-22 18.7-36 14.9L391 386.8l8.2 92.4c1.3 14.4-7.3 27.9-20.9 32.9s-28.9 .1-37.2-11.7l-53.1-76-53.1 76c-8.3 11.9-23.6 16.7-37.2 11.7s-22.2-18.5-20.9-32.9l8.2-92.4L95.4 410.9c-14 3.8-28.8-2.3-36-14.9s-5.2-28.4 5.1-38.7l65.7-65.5L46 252.7c-13.1-6.1-20.5-20.3-18-34.6s14.3-25.1 28.8-26.3l92.4-8-39.3-84c-6.1-13.1-2.7-28.8 8.4-38.1s27.1-10 39-1.7l75.9 53.3 23.9-89.6C260.8 9.7 273.5 0 288 0zm0 156.2l-4.8 18c-2.7 10.1-10.2 18.2-20 21.8s-20.8 2.1-29.3-3.9l-15.2-10.7 7.9 16.8c4.4 9.5 4 20.5-1.3 29.6s-14.5 15-25 15.9l-18.5 1.6 16.8 7.8c9.5 4.4 16.2 13.2 18 23.5s-1.5 20.8-8.9 28.2l-13.2 13.1 17.9-4.8c10.1-2.7 20.9-.3 28.9 6.4s12.2 16.9 11.3 27.3l-1.6 18.5 10.6-15.2c6-8.6 15.8-13.7 26.2-13.7s20.2 5.1 26.2 13.7l10.6 15.2-1.6-18.5c-.9-10.4 3.3-20.6 11.3-27.3s18.8-9.1 28.9-6.4l17.9 4.8-13.2-13.1c-7.4-7.4-10.7-17.9-8.9-28.2s8.5-19.1 18-23.5l16.8-7.8-18.5-1.6c-10.4-.9-19.7-6.8-25-15.9s-5.7-20.1-1.3-29.6l7.9-16.8-15.2 10.7c-8.6 6-19.5 7.5-29.3 3.9s-17.3-11.7-20-21.8l-4.8-18z"
                }
            }
        ]
    })(props);
}
function FaBahtSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0c-17.7 0-32 14.3-32 32V64H37.6C16.8 64 0 80.8 0 101.6V224v41.7V288 406.3c0 23 18.7 41.7 41.7 41.7H112v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c61.9 0 112-50.1 112-112c0-40.1-21.1-75.3-52.7-95.1C280.3 222.6 288 200.2 288 176c0-61.9-50.1-112-112-112V32c0-17.7-14.3-32-32-32zM112 128v96H64V128h48zm64 96V128c26.5 0 48 21.5 48 48s-21.5 48-48 48zm-64 64v96H64V288h48zm64 96V288h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H176z"
                }
            }
        ]
    })(props);
}
function FaBanSmoking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99.5 144.8L178.7 224l96 96 92.5 92.5C335.9 434.9 297.5 448 256 448C150 448 64 362 64 256c0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32H384v32H333.3zm32 32H400c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H269.3L144.8 99.5C176.1 77.1 214.5 64 256 64c106 0 192 86 192 192c0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16s16-7.2 16-16c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s-7.2-16-16-16zM229.5 320l-96-96H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H229.5z"
                }
            }
        ]
    })(props);
}
function FaBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                }
            }
        ]
    })(props);
}
function FaBandage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H480V416zM448 96H192V416H448V96zM64 96C28.7 96 0 124.7 0 160V352c0 35.3 28.7 64 64 64h96V96H64zM248 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaBangladeshiTakaSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M36 32.2C18.4 30.1 2.4 42.5 .2 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8V160H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V384c0 53 43 96 96 96h32c106 0 192-86 192-192V256c0-53-43-96-96-96H272c-17.7 0-32 14.3-32 32s14.3 32 32 32h16c17.7 0 32 14.3 32 32v32c0 70.7-57.3 128-128 128H160c-17.7 0-32-14.3-32-32V224h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V128.5c0-48.4-36.1-89.3-84.1-95.3l-7.9-1z"
                }
            }
        ]
    })(props);
}
function FaBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaBarsProgress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 160H320V128H448v32zM48 64C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zM448 352v32H192V352H448zM48 288c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V336c0-26.5-21.5-48-48-48H48z"
                }
            }
        ]
    })(props);
}
function FaBarsStaggered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaBaseballBatBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 0c-12.4 0-24.2 4.9-33 13.7L233.5 171.2c-10.5 10.5-19.8 22.1-27.7 34.6L132.7 321.6c-7.3 11.5-15.8 22.2-25.5 31.9L69.9 390.7l51.3 51.3 37.3-37.3c9.6-9.6 20.3-18.2 31.9-25.5l115.8-73.1c12.5-7.9 24.1-17.2 34.6-27.7L498.3 121c8.7-8.7 13.7-20.6 13.7-33s-4.9-24.2-13.7-33L457 13.7C448.2 4.9 436.4 0 424 0zm88 432a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM15 399c-9.4 9.4-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L49 399c-9.4-9.4-24.6-9.4-33.9 0z"
                }
            }
        ]
    })(props);
}
function FaBaseball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M62.7 223.4c-4.8 .4-9.7 .6-14.7 .6c-15.6 0-30.8-2-45.2-5.9C19.2 107.1 107.1 19.2 218.1 2.8C222 17.2 224 32.4 224 48c0 4.9-.2 9.8-.6 14.7c-.7 8.8 5.8 16.5 14.6 17.3s16.5-5.8 17.3-14.6c.5-5.7 .7-11.5 .7-17.3c0-16.5-1.9-32.6-5.6-47.9c1.8 0 3.7-.1 5.6-.1C397.4 0 512 114.6 512 256c0 1.9 0 3.7-.1 5.6c-15.4-3.6-31.4-5.6-47.9-5.6c-5.8 0-11.6 .2-17.3 .7c-8.8 .7-15.4 8.5-14.6 17.3s8.5 15.4 17.3 14.6c4.8-.4 9.7-.6 14.7-.6c15.6 0 30.8 2 45.2 5.9C492.8 404.9 404.9 492.8 293.9 509.2C290 494.8 288 479.6 288 464c0-4.9 .2-9.8 .6-14.7c.7-8.8-5.8-16.5-14.6-17.3s-16.5 5.8-17.3 14.6c-.5 5.7-.7 11.5-.7 17.3c0 16.5 1.9 32.6 5.6 47.9c-1.8 0-3.7 .1-5.6 .1C114.6 512 0 397.4 0 256c0-1.9 0-3.7 .1-5.6C15.4 254.1 31.5 256 48 256c5.8 0 11.6-.2 17.3-.7c8.8-.7 15.4-8.5 14.6-17.3s-8.5-15.4-17.3-14.6zM121.3 208c-8 3.7-11.6 13.2-7.9 21.2s13.2 11.6 21.2 7.9c45.2-20.8 81.7-57.2 102.5-102.5c3.7-8 .2-17.5-7.9-21.2s-17.5-.2-21.2 7.9c-17.6 38.3-48.5 69.2-86.7 86.7zm277.2 74.7c-3.7-8-13.2-11.6-21.2-7.9c-45.2 20.8-81.7 57.2-102.5 102.5c-3.7 8-.2 17.5 7.9 21.2s17.5 .2 21.2-7.9c17.6-38.3 48.5-69.2 86.7-86.7c8-3.7 11.6-13.2 7.9-21.2z"
                }
            }
        ]
    })(props);
}
function FaBasketShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512H430c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H458.4L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192H171.7L253.3 35.1zM192 304v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaBasketball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.6 64l85.2 85.2C194.5 121.7 208 86.4 208 48c0-14.7-2-28.9-5.7-42.4C158.6 15 119 35.5 86.6 64zM64 86.6C35.5 119 15 158.6 5.6 202.3C19.1 206 33.3 208 48 208c38.4 0 73.7-13.5 101.3-36.1L64 86.6zM256 0c-7.3 0-14.6 .3-21.8 .9C238 16 240 31.8 240 48c0 47.3-17.1 90.5-45.4 124L256 233.4 425.4 64C380.2 24.2 320.9 0 256 0zM48 240c-16.2 0-32-2-47.1-5.8C.3 241.4 0 248.7 0 256c0 64.9 24.2 124.2 64 169.4L233.4 256 172 194.6C138.5 222.9 95.3 240 48 240zm463.1 37.8c.6-7.2 .9-14.5 .9-21.8c0-64.9-24.2-124.2-64-169.4L278.6 256 340 317.4c33.4-28.3 76.7-45.4 124-45.4c16.2 0 32 2 47.1 5.8zm-4.7 31.9C492.9 306 478.7 304 464 304c-38.4 0-73.7 13.5-101.3 36.1L448 425.4c28.5-32.3 49.1-71.9 58.4-115.7zM340.1 362.7C317.5 390.3 304 425.6 304 464c0 14.7 2 28.9 5.7 42.4C353.4 497 393 476.5 425.4 448l-85.2-85.2zM317.4 340L256 278.6 86.6 448c45.1 39.8 104.4 64 169.4 64c7.3 0 14.6-.3 21.8-.9C274 496 272 480.2 272 464c0-47.3 17.1-90.5 45.4-124z"
                }
            }
        ]
    })(props);
}
function FaBath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"
                }
            }
        ]
    })(props);
}
function FaBatteryEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 160c-8.8 0-16 7.2-16 16V336c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H80zM0 176c0-44.2 35.8-80 80-80H464c44.2 0 80 35.8 80 80v16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v16c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176z"
                }
            }
        ]
    })(props);
}
function FaBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm368 96H96V320H448V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm208 96H96V320H288V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm112 96H96V320h96V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryThreeQuarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 160c8.8 0 16 7.2 16 16V336c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16H464zM80 96C35.8 96 0 131.8 0 176V336c0 44.2 35.8 80 80 80H464c44.2 0 80-35.8 80-80V320c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32V176c0-44.2-35.8-80-80-80H80zm272 96H96V320H352V192z"
                }
            }
        ]
    })(props);
}
function FaBedPulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 9.6L524 64h92c13.3 0 24 10.7 24 24s-10.7 24-24 24H512c-7.6 0-14.7-3.6-19.2-9.6L468.7 70.3l-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L339.2 112H216c-13.3 0-24-10.7-24-24s10.7-24 24-24H352c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5C445.9 6.2 453.2 1 461.6 .1s16.6 2.7 21.6 9.5zM320 160h12.7l20.7 31.1c11.2 16.8 30.6 26.3 50.7 24.8s37.9-13.7 46.5-32L461.9 160H544c53 0 96 43 96 96V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64s32 14.3 32 32V352H288V192c0-17.7 14.3-32 32-32zm-144 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                }
            }
        ]
    })(props);
}
function FaBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                }
            }
        ]
    })(props);
}
function FaBeerMugEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V96h51.2c42.4 0 76.8 34.4 76.8 76.8V274.9c0 30.4-17.9 57.9-45.6 70.2L384 381.7V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zM384 311.6l56.4-25.1c4.6-2.1 7.6-6.6 7.6-11.7V172.8c0-7.1-5.7-12.8-12.8-12.8H384V311.6zM160 144c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
                }
            }
        ]
    })(props);
}
function FaBellConcierge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
                }
            }
        ]
    })(props);
}
function FaBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-87.5-68.6c.5-1.7 .7-3.5 .7-5.4c0-27.6-11-54.1-30.5-73.7L512 320c-20.5-20.5-32-48.3-32-77.3V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V51.2c-42.6 8.6-79 34.2-102 69.3L38.8 5.1zM160 242.7c0 29-11.5 56.8-32 77.3l-1.5 1.5C107 341 96 367.5 96 395.2c0 11.5 9.3 20.8 20.8 20.8H406.2L160 222.1v20.7zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
                }
            }
        ]
    })(props);
}
function FaBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"
                }
            }
        ]
    })(props);
}
function FaBezierCurve(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 136V88h48v48H296zM288 32c-26.5 0-48 21.5-48 48v4H121.6C111.2 62.7 89.3 48 64 48C28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36h66.9c-58.9 39.6-98.9 105-104 180H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-3.3c5.9-67 48.5-123.4 107.5-149.1c8.6 12.7 23.2 21.1 39.8 21.1h64c16.6 0 31.1-8.4 39.8-21.1c59 25.7 101.6 82.1 107.5 149.1H496c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-4.5c-5-75-45.1-140.4-104-180h66.9c10.4 21.3 32.3 36 57.6 36c35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36H400V80c0-26.5-21.5-48-48-48H288zM88 376h48v48H88V376zm416 48V376h48v48H504z"
                }
            }
        ]
    })(props);
}
function FaBicycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h25.7l34.6 64H222.9l-27.4-38C191 99.7 183.7 96 176 96H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h43.7l22.1 30.7-26.6 53.1c-10-2.5-20.5-3.8-31.2-3.8C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h49c8.5 0 16.3-4.5 20.7-11.8l84.8-143.5 21.7 40.1C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L375.4 48.8C369.8 38.4 359 32 347.2 32H312zM458.6 303.7l32.3 59.7c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-32.3-59.7c3.6-.6 7.4-.9 11.2-.9c39.8 0 72 32.2 72 72s-32.2 72-72 72s-72-32.2-72-72c0-18.6 7-35.5 18.6-48.3zM133.2 368h65c-7.3 32.1-36 56-70.2 56c-39.8 0-72-32.2-72-72s32.2-72 72-72c1.7 0 3.4 .1 5.1 .2l-24.2 48.5c-9 18.1 4.1 39.4 24.3 39.4zm33.7-48l50.7-101.3 72.9 101.2-.1 .1H166.8zm90.6-128H365.9L317 274.8 257.4 192z"
                }
            }
        ]
    })(props);
}
function FaBinoculars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32h32c17.7 0 32 14.3 32 32V96H96V64c0-17.7 14.3-32 32-32zm64 96V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V388.9c0-34.6 9.4-68.6 27.2-98.3C40.9 267.8 49.7 242.4 53 216L60.5 156c2-16 15.6-28 31.8-28H192zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6c17.8 29.7 27.2 63.7 27.2 98.3V448c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V128h99.8zM320 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V96H320V64zm-32 64V288H224V128h64z"
                }
            }
        ]
    })(props);
}
function FaBiohazard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.2 0c-1.8 0-3.5 .7-4.8 2C138.5 32.3 120 74 120 120c0 26.2 6 50.9 16.6 73c-22 2.4-43.8 9.1-64.2 20.5C37.9 232.8 13.3 262.4 .4 296c-.7 1.7-.5 3.7 .5 5.2c2.2 3.7 7.4 4.3 10.6 1.3C64.2 254.3 158 245.1 205 324s-8.1 153.1-77.6 173.2c-4.2 1.2-6.3 5.9-4.1 9.6c1 1.6 2.6 2.7 4.5 3c36.5 5.9 75.2 .1 109.7-19.2c20.4-11.4 37.4-26.5 50.5-43.8c13.1 17.3 30.1 32.4 50.5 43.8c34.5 19.3 73.3 25.2 109.7 19.2c1.9-.3 3.5-1.4 4.5-3c2.2-3.7 .1-8.4-4.1-9.6C379.1 477.1 324 403 371 324s140.7-69.8 193.5-21.4c3.2 2.9 8.4 2.3 10.6-1.3c1-1.6 1.1-3.5 .5-5.2c-12.9-33.6-37.5-63.2-72.1-82.5c-20.4-11.4-42.2-18.1-64.2-20.5C450 170.9 456 146.2 456 120c0-46-18.5-87.7-48.4-118c-1.3-1.3-3-2-4.8-2c-5 0-8.4 5.2-6.7 9.9C421.7 80.5 385.6 176 288 176S154.3 80.5 179.9 9.9c1.7-4.7-1.6-9.9-6.7-9.9zM240 272a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM181.7 417.6c6.3-11.8 9.8-25.1 8.6-39.8c-19.5-18-34-41.4-41.2-67.8c-12.5-8.1-26.2-11.8-40-12.4c-9-.4-18.1 .6-27.1 2.7c7.8 57.1 38.7 106.8 82.9 139.4c6.8-6.7 12.6-14.1 16.8-22.1zM288 64c-28.8 0-56.3 5.9-81.2 16.5c2 8.3 5 16.2 9 23.5c6.8 12.4 16.7 23.1 30.1 30.3c13.3-4.1 27.5-6.3 42.2-6.3s28.8 2.2 42.2 6.3c13.4-7.2 23.3-17.9 30.1-30.3c4-7.3 7-15.2 9-23.5C344.3 69.9 316.8 64 288 64zM426.9 310c-7.2 26.4-21.7 49.7-41.2 67.8c-1.2 14.7 2.2 28.1 8.6 39.8c4.3 8 10 15.4 16.8 22.1c44.3-32.6 75.2-82.3 82.9-139.4c-9-2.2-18.1-3.1-27.1-2.7c-13.8 .6-27.5 4.4-40 12.4z"
                }
            }
        ]
    })(props);
}
function FaBitcoinSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C48 14.3 62.3 0 80 0s32 14.3 32 32V64h32V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64c0 1.5-.1 3.1-.3 4.5C254.1 82.2 288 125.1 288 176c0 24.2-7.7 46.6-20.7 64.9c31.7 19.8 52.7 55 52.7 95.1c0 61.9-50.1 112-112 112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H41.7C18.7 448 0 429.3 0 406.3V288 265.7 224 101.6C0 80.8 16.8 64 37.6 64H48V32zM64 224H176c26.5 0 48-21.5 48-48s-21.5-48-48-48H64v96zm112 64H64v96H208c26.5 0 48-21.5 48-48s-21.5-48-48-48H176z"
                }
            }
        ]
    })(props);
}
function FaBlenderPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352L196.8 52.3C194.2 24.2 216.3 0 244.6 0H534.1c21.1 0 36.4 20.1 30.9 40.4L558.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H549.8l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16H523.6l-17.5 64H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L480 352H224zm-16 32H496c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM147.5 30.7c10.8 6.7 15.3 21 10.6 33.4l-22 57.8c-4.2 10.9-14.5 17.6-25.3 16.4l-33.3-3.6c-13.6 42.2-13.6 88.4 0 130.7l33.3-3.6c10.9-1.2 21.2 5.5 25.3 16.4l22 57.8c4.7 12.4 .2 26.7-10.6 33.4l-44 27.2c-9.7 6-21.9 4.2-29.8-4.3C-24.6 286-24.6 114 73.7 7.8C81.6-.7 93.8-2.5 103.5 3.5l44 27.2z"
                }
            }
        ]
    })(props);
}
function FaBlender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0h64 32H470.1c21.1 0 36.4 20.1 30.9 40.4L494.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H485.8l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16H459.6l-17.5 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.5L416 352H160l-8.7-96H64c-35.3 0-64-28.7-64-64V64zM145.5 192L133.8 64H64V192h81.5zM144 384H432c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48V432c0-26.5 21.5-48 48-48zm144 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaBlog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c0 17.7 14.3 32 32 32c123.7 0 224 100.3 224 224c0 17.7 14.3 32 32 32s32-14.3 32-32C512 128.9 383.1 0 224 0c-17.7 0-32 14.3-32 32zm0 96c0 17.7 14.3 32 32 32c70.7 0 128 57.3 128 128c0 17.7 14.3 32 32 32s32-14.3 32-32c0-106-86-192-192-192c-17.7 0-32 14.3-32 32zM96 144c0-26.5-21.5-48-48-48S0 117.5 0 144V368c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144H128v96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48s-48-21.5-48-48V144z"
                }
            }
        ]
    })(props);
}
function FaBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
                }
            }
        ]
    })(props);
}
function FaBoltLightning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"
                }
            }
        ]
    })(props);
}
function FaBomb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.1 52.4L442.6 6.5C440.7 2.6 436.5 0 432.1 0s-8.5 2.6-10.4 6.5L405.2 52.4l-46 16.8c-4.3 1.6-7.3 5.9-7.2 10.4c0 4.5 3 8.7 7.2 10.2l45.7 16.8 16.8 45.8c1.5 4.4 5.8 7.5 10.4 7.5s8.9-3.1 10.4-7.5l16.5-45.8 45.7-16.8c4.2-1.5 7.2-5.7 7.2-10.2c0-4.6-3-8.9-7.2-10.4L459.1 52.4zm-132.4 53c-12.5-12.5-32.8-12.5-45.3 0l-2.9 2.9C256.5 100.3 232.7 96 208 96C93.1 96 0 189.1 0 304S93.1 512 208 512s208-93.1 208-208c0-24.7-4.3-48.5-12.2-70.5l2.9-2.9c12.5-12.5 12.5-32.8 0-45.3l-80-80zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
                }
            }
        ]
    })(props);
}
function FaBone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2H384c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80c0 30.4-17 56.9-42 70.4c-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4c0 44.2-35.8 80-80 80c-33.1 0-61.6-20.1-73.7-48.8C415.4 350.9 401.7 336 384 336H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80c0-30.4 17-56.9 42-70.4c3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6C17 232.9 0 206.4 0 176c0-44.2 35.8-80 80-80c33.1 0 61.6 20.1 73.7 48.8z"
                }
            }
        ]
    })(props);
}
function FaBong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 208.5c0 29.1-15.6 53.9-37.2 67.8c-17.2 11.1-31.5 26.1-41.7 43.7H302.9c-10.2-17.6-24.5-32.6-41.7-43.7c-21.6-13.9-37.2-38.7-37.2-67.8V64H160V208.5zM288 64V208.5c0 5.7 3.1 10.9 7.9 14c11.2 7.2 21.5 15.5 30.9 24.8L366.1 208l-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l24 24 24 24c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3C374 314.1 384 347.9 384 384c0 39.4-11.9 76.1-32.2 106.5c-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5c4.8-3.1 7.9-8.3 7.9-14V64C78.3 64 64 49.7 64 32S78.3 0 96 0h16H272h16c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBookAtlas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM247.4 283.8c-3.7 3.7-6.2 4.2-7.4 4.2s-3.7-.5-7.4-4.2c-3.8-3.7-8-10-11.8-18.9c-6.2-14.5-10.8-34.3-12.2-56.9h63c-1.5 22.6-6 42.4-12.2 56.9c-3.8 8.9-8 15.2-11.8 18.9zm42.7-9.9c7.3-18.3 12-41.1 13.4-65.9h31.1c-4.7 27.9-21.4 51.7-44.5 65.9zm0-163.8c23.2 14.2 39.9 38 44.5 65.9H303.5c-1.4-24.7-6.1-47.5-13.4-65.9zM368 192a128 128 0 1 0 -256 0 128 128 0 1 0 256 0zM145.3 208h31.1c1.4 24.7 6.1 47.5 13.4 65.9c-23.2-14.2-39.9-38-44.5-65.9zm31.1-32H145.3c4.7-27.9 21.4-51.7 44.5-65.9c-7.3 18.3-12 41.1-13.4 65.9zm56.1-75.8c3.7-3.7 6.2-4.2 7.4-4.2s3.7 .5 7.4 4.2c3.8 3.7 8 10 11.8 18.9c6.2 14.5 10.8 34.3 12.2 56.9h-63c1.5-22.6 6-42.4 12.2-56.9c3.8-8.9 8-15.2 11.8-18.9z"
                }
            }
        ]
    })(props);
}
function FaBookBible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zM208 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272V304c0 8.8-7.2 16-16 16H224c-8.8 0-16-7.2-16-16V192H160c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h48V80z"
                }
            }
        ]
    })(props);
}
function FaBookBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0h96V190.7c0 13.4 15.5 20.9 26 12.5L272 160l54 43.2c10.5 8.4 26 .9 26-12.5V0h32 32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaBookJournalWhills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zm90.4-234.4l-21.2-21.2c-3 10.1-5.1 20.6-5.1 31.6c0 .2 0 .5 .1 .8s.1 .5 .1 .8L165.2 226c2.5 2.1 3.4 5.8 2.3 8.9c-1.3 3-4.1 5.1-7.5 5.1c-1.9-.1-3.8-.8-5.2-2l-23.6-20.6C142.8 267 186.9 304 240 304s97.3-37 108.9-86.6L325.3 238c-1.4 1.2-3.3 2-5.3 2c-2.2-.1-4.4-1.1-6-2.8c-1.2-1.5-1.9-3.4-2-5.2c.1-2.2 1.1-4.4 2.8-6l37.1-32.5c0-.3 0-.5 .1-.8s.1-.5 .1-.8c0-11-2.1-21.5-5.1-31.6l-21.2 21.2c-3.1 3.1-8.1 3.1-11.3 0s-3.1-8.1 0-11.2l26.4-26.5c-8.2-17-20.5-31.7-35.9-42.6c-2.7-1.9-6.2 1.4-5 4.5c8.5 22.4 3.6 48-13 65.6c-3.2 3.4-3.6 8.9-.9 12.7c9.8 14 12.7 31.9 7.5 48.5c-5.9 19.4-22 34.1-41.9 38.3l-1.4-34.3 12.6 8.6c.6 .4 1.5 .6 2.3 .6c1.5 0 2.7-.8 3.5-2s.6-2.8-.1-4L260 225.4l18-3.6c1.8-.4 3.1-2.1 3.1-4s-1.4-3.5-3.1-3.9l-18-3.7 8.5-14.3c.8-1.2 .9-2.9 .1-4.1s-2-2-3.5-2l-.1 0c-.7 .1-1.5 .3-2.1 .7l-14.1 9.6L244 87.9c-.1-2.2-1.9-3.9-4-3.9s-3.9 1.6-4 3.9l-4.6 110.8-12-8.1c-1.5-1.1-3.6-.9-5 .4s-1.6 3.4-.8 5l8.6 14.3-18 3.7c-1.8 .4-3.1 2-3.1 3.9s1.4 3.6 3.1 4l18 3.8-8.6 14.2c-.2 .6-.5 1.4-.5 2c0 1.1 .5 2.1 1.2 3c.8 .6 1.8 1 2.8 1c.7 0 1.6-.2 2.2-.6l10.4-7.1-1.4 32.8c-19.9-4.1-36-18.9-41.9-38.3c-5.1-16.6-2.2-34.4 7.6-48.5c2.7-3.9 2.3-9.3-.9-12.7c-16.6-17.5-21.6-43.1-13.1-65.5c1.2-3.1-2.3-6.4-5-4.5c-15.3 10.9-27.6 25.6-35.8 42.6l26.4 26.5c3.1 3.1 3.1 8.1 0 11.2s-8.1 3.1-11.2 0z"
                }
            }
        ]
    })(props);
}
function FaBookMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM208 112v48H160c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h48c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaBookOpenReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z"
                }
            }
        ]
    })(props);
}
function FaBookOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.6 471.5c10.8 3.8 22.4-4.1 22.4-15.5V78.6c0-4.2-1.6-8.4-5-11C247.4 52 202.4 32 144 32C93.5 32 46.3 45.3 18.1 56.1C6.8 60.5 0 71.7 0 83.8V454.1c0 11.9 12.8 20.2 24.1 16.5C55.6 460.1 105.5 448 144 448c33.9 0 79 14 105.6 23.5zm76.8 0C353 462 398.1 448 432 448c38.5 0 88.4 12.1 119.9 22.6c11.3 3.8 24.1-4.6 24.1-16.5V83.8c0-12.1-6.8-23.3-18.1-27.6C529.7 45.3 482.5 32 432 32c-58.4 0-103.4 20-123 35.6c-3.3 2.6-5 6.8-5 11V456c0 11.4 11.7 19.3 22.4 15.5z"
                }
            }
        ]
    })(props);
}
function FaBookQuran(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM274.1 150.2l-8.9 21.4-23.1 1.9c-5.7 .5-8 7.5-3.7 11.2L256 199.8l-5.4 22.6c-1.3 5.5 4.7 9.9 9.6 6.9L280 217.2l19.8 12.1c4.9 3 10.9-1.4 9.6-6.9L304 199.8l17.6-15.1c4.3-3.7 2-10.8-3.7-11.2l-23.1-1.9-8.9-21.4c-2.2-5.3-9.6-5.3-11.8 0zM96 192c0 70.7 57.3 128 128 128c25.6 0 49.5-7.5 69.5-20.5c3.2-2.1 4.5-6.2 3.1-9.7s-5.2-5.6-9-4.8c-6.1 1.2-12.5 1.9-19 1.9c-52.4 0-94.9-42.5-94.9-94.9s42.5-94.9 94.9-94.9c6.5 0 12.8 .7 19 1.9c3.8 .8 7.5-1.3 9-4.8s.2-7.6-3.1-9.7C273.5 71.5 249.6 64 224 64C153.3 64 96 121.3 96 192z"
                }
            }
        ]
    })(props);
}
function FaBookSkull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 43 43 0 96 0H384h32c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384 96c-53 0-96-43-96-96V96zM64 416c0 17.7 14.3 32 32 32H352V384H96c-17.7 0-32 14.3-32 32zM320 112c0-35.3-35.8-64-80-64s-80 28.7-80 64c0 20.9 12.6 39.5 32 51.2V176c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V163.2c19.4-11.7 32-30.3 32-51.2zM208 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM134.3 209.3c-8.1-3.5-17.5 .3-21 8.4s.3 17.5 8.4 21L199.4 272l-77.7 33.3c-8.1 3.5-11.9 12.9-8.4 21s12.9 11.9 21 8.4L240 289.4l105.7 45.3c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21L280.6 272l77.7-33.3c8.1-3.5 11.9-12.9 8.4-21s-12.9-11.9-21-8.4L240 254.6 134.3 209.3z"
                }
            }
        ]
    })(props);
}
function FaBookTanakh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0c53 0 96 43 96 96V416c0 53-43 96-96 96H64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V384c-17.7 0-32-14.3-32-32V32C0 14.3 14.3 0 32 0H64 352zm0 384H96v64H352c17.7 0 32-14.3 32-32s-14.3-32-32-32zM138.7 208l13.9 24H124.9l13.9-24zm-13.9-24L97.1 232c-6.2 10.7 1.5 24 13.9 24h55.4l27.7 48c6.2 10.7 21.6 10.7 27.7 0l27.7-48H305c12.3 0 20-13.3 13.9-24l-27.7-48 27.7-48c6.2-10.7-1.5-24-13.9-24H249.6L221.9 64c-6.2-10.7-21.6-10.7-27.7 0l-27.7 48H111c-12.3 0-20 13.3-13.9 24l27.7 48zm27.7 0l27.7-48h55.4l27.7 48-27.7 48H180.3l-27.7-48zm0-48l-13.9 24-13.9-24h27.7zm41.6-24L208 88l13.9 24H194.1zm69.3 24h27.7l-13.9 24-13.9-24zm13.9 72l13.9 24H263.4l13.9-24zm-55.4 48L208 280l-13.9-24h27.7z"
                }
            }
        ]
    })(props);
}
function FaBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48V487.7C0 501.1 10.9 512 24.3 512c5 0 9.9-1.5 14-4.4L192 400 345.7 507.6c4.1 2.9 9 4.4 14 4.4c13.4 0 24.3-10.9 24.3-24.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48z"
                }
            }
        ]
    })(props);
}
function FaBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 96V224H256V96H384zm0 192V416H256V288H384zM192 224H64V96H192V224zM64 288H192V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                }
            }
        ]
    })(props);
}
function FaBorderNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM320 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 480a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-448a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 416a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0-384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM32 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM416 192a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm192 64a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
                }
            }
        ]
    })(props);
}
function FaBorderTopLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336c0-8.8 7.2-16 16-16l336 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32C35.8 32 0 67.8 0 112L0 448zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm192 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaBoreHole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-17.7 0-32 14.3-32 32V296.6c-19.1 11.1-32 31.7-32 55.4c0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4V32c0-17.7-14.3-32-32-32zM48 128c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H384c-17.7 0-32 14.3-32 32V352c0 53-43 96-96 96s-96-43-96-96V160c0-17.7-14.3-32-32-32H48z"
                }
            }
        ]
    })(props);
}
function FaBottleDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C82.7 0 72 10.7 72 24s10.7 24 24 24c4.4 0 8 3.6 8 8v64.9c0 12.2-7.2 23.1-17.2 30.1C53.7 174.1 32 212.5 32 256V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V256c0-43.5-21.7-81.9-54.8-105c-10-7-17.2-17.9-17.2-30.1V56c0-4.4 3.6-8 8-8c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 0 0 0H104l0 0 0 0L96 0zm64 382c-26.5 0-48-20.1-48-45c0-16.8 22.1-48.1 36.3-66.4c6-7.8 17.5-7.8 23.5 0C185.9 288.9 208 320.2 208 337c0 24.9-21.5 45-48 45z"
                }
            }
        ]
    })(props);
}
function FaBottleWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 0h80c13.3 0 24 10.7 24 24V64H96V24c0-13.3 10.7-24 24-24zM32 151.7c0-15.6 9-29.8 23.2-36.5l24.4-11.4c11-5.1 23-7.8 35.1-7.8h90.6c12.1 0 24.1 2.7 35.1 7.8l24.4 11.4c14.1 6.6 23.2 20.8 23.2 36.5c0 14.4-7.5 27-18.9 34.1c11.5 8.8 18.9 22.6 18.9 38.2c0 16.7-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40s-8.5 31.4-21.5 40c12.9 8.6 21.5 23.3 21.5 40c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48c0-16.7 8.5-31.4 21.5-40C40.5 415.4 32 400.7 32 384s8.5-31.4 21.5-40C40.5 335.4 32 320.7 32 304s8.5-31.4 21.5-40C40.5 255.4 32 240.7 32 224c0-15.6 7.4-29.4 18.9-38.2C39.5 178.7 32 166.1 32 151.7zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
                }
            }
        ]
    })(props);
}
function FaBowlFood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192c0-35.3 28.7-64 64-64c.5 0 1.1 0 1.6 0C73 91.5 105.3 64 144 64c15 0 29 4.1 40.9 11.2C198.2 49.6 225.1 32 256 32s57.8 17.6 71.1 43.2C339 68.1 353 64 368 64c38.7 0 71 27.5 78.4 64c.5 0 1.1 0 1.6 0c35.3 0 64 28.7 64 64c0 11.7-3.1 22.6-8.6 32H8.6C3.1 214.6 0 203.7 0 192zm0 91.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
                }
            }
        ]
    })(props);
}
function FaBowlRice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 56c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24zm24 48h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 176H72c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256H484.6c15.1 0 27.4 12.3 27.4 27.4c0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28H140.2c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 200c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H248c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H104c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H344c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H440c-13.3 0-24-10.7-24-24zm-24-96h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 32h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H296c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaBowlingBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaBoxArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaBoxOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58.9 42.1c3-6.1 9.6-9.6 16.3-8.7L320 64 564.8 33.4c6.7-.8 13.3 2.7 16.3 8.7l41.7 83.4c9 17.9-.6 39.6-19.8 45.1L439.6 217.3c-13.9 4-28.8-1.9-36.2-14.3L320 64 236.6 203c-7.4 12.4-22.3 18.3-36.2 14.3L37.1 170.6c-19.3-5.5-28.8-27.2-19.8-45.1L58.9 42.1zM321.1 128l54.9 91.4c14.9 24.8 44.6 36.6 72.5 28.6L576 211.6v167c0 22-15 41.2-36.4 46.6l-204.1 51c-10.2 2.6-20.9 2.6-31 0l-204.1-51C79 419.7 64 400.5 64 378.5v-167L191.6 248c27.8 8 57.6-3.8 72.5-28.6L318.9 128h2.2z"
                }
            }
        ]
    })(props);
}
function FaBoxTissue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M92.5 0H208c40 0 52 24 64 48s24 48 64 48h85.2C436 96 448 108 448 122.8c0 3.4-.7 6.8-1.9 10L409.6 224 384 288H128l-16-64L64.9 35.4c-.6-2.3-.9-4.6-.9-6.9C64 12.8 76.8 0 92.5 0zM79 224l16 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48H384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H418.5l25.6-64H464c26.5 0 48 21.5 48 48V384H0V272c0-26.5 21.5-48 48-48H79zM0 416H512v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V416z"
                }
            }
        ]
    })(props);
}
function FaBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.7 58.5L0 160H208V32H93.7C75.5 32 58.9 42.3 50.7 58.5zM240 160H448L397.3 58.5C389.1 42.3 372.5 32 354.3 32H240V160zm208 32H0V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192z"
                }
            }
        ]
    })(props);
}
function FaBoxesPacking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c0-26.5 21.5-48 48-48H592c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16V253.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H256V48zM571.3 347.3c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 310.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V310.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0zM0 176c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V176zm352 80V480c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256H352zM144 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
                }
            }
        ]
    })(props);
}
function FaBoxesStacked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 0H208c-26.5 0-48 21.5-48 48V160c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V48c0-26.5-21.5-48-48-48H328V80c0 8.8-7.2 16-16 16H264c-8.8 0-16-7.2-16-16V0zM64 256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H224c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H184v80c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V256H64zM352 512H512c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H472v80c0 8.8-7.2 16-16 16H408c-8.8 0-16-7.2-16-16V256H352c-15 0-28.8 5.1-39.7 13.8c4.9 10.4 7.7 22 7.7 34.2V464c0 12.2-2.8 23.8-7.7 34.2C323.2 506.9 337 512 352 512z"
                }
            }
        ]
    })(props);
}
function FaBraille(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96a64 64 0 1 1 128 0A64 64 0 1 1 0 96zM224 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM80 416a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 96a64 64 0 1 1 128 0A64 64 0 1 1 352 96zm240 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0A64 64 0 1 1 512 96zm64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM416 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 0a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                }
            }
        ]
    })(props);
}
function FaBrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9c27.8 7 48.3 32.1 48.3 62.1c0 6-.8 11.9-2.4 17.4c28.8 6.2 50.4 31.9 50.4 62.6c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"
                }
            }
        ]
    })(props);
}
function FaBrazilianRealSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c17.7 0 32 14.3 32 32V50.2c12.5 2.3 24.7 6.4 36.2 12.1l10.1 5.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-10.2-5.1c-9.9-5-20.9-7.5-32-7.5h-1.7c-29.8 0-53.9 24.1-53.9 53.9c0 22 13.4 41.8 33.9 50l52 20.8c44.7 17.9 74.1 61.2 74.1 109.4v3.4c0 51.2-33.6 94.6-80 109.2V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V460.6c-15-3.5-29.4-9.7-42.3-18.3l-23.4-15.6c-14.7-9.8-18.7-29.7-8.9-44.4s29.7-18.7 44.4-8.9L361.2 389c10.8 7.2 23.4 11 36.3 11c27.9 0 50.5-22.6 50.5-50.5v-3.4c0-22-13.4-41.8-33.9-50l-52-20.8C317.3 257.4 288 214.1 288 165.9C288 114 321.5 70 368 54.2V32c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256z"
                }
            }
        ]
    })(props);
}
function FaBreadSlice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C192 32 0 64 0 192c0 35.3 28.7 64 64 64V432c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C512 64 320 32 256 32z"
                }
            }
        ]
    })(props);
}
function FaBridgeCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaBridgeCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaBridgeCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64s14.3 32 32 32h40v64H32V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96c6.3 0 12.4 .6 18.3 1.7C367.1 231.8 426.9 192 496 192c42.5 0 81.6 15.1 112 40.2V160H536V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM488 96v64H408V96h80zM360 96v64H280V96h80zM232 96v64H152V96h80zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaBridgeLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64c0-17.7 14.3-32 32-32H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H536v64h-8c-61.9 0-112 50.1-112 112v24.6c-9.9 5.8-18.2 14.1-23.8 24.1c-17.6-20-43.4-32.7-72.2-32.7c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V384c0-53-43-96-96-96V160h72V96H64C46.3 96 32 81.7 32 64zM408 96v64h80V96H408zm-48 64V96H280v64h80zM152 96v64h80V96H152zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
                }
            }
        ]
    })(props);
}
function FaBridgeWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 78.3 14.3 64 32 64H544c17.7 0 32 14.3 32 32v35.6c0 15.7-12.7 28.4-28.4 28.4c-37.3 0-67.6 30.2-67.6 67.6V352.5c-12.9 0-25.8 3.9-36.8 11.7c-18 12.4-40.1 20.3-59.2 20.3h0l0-.5V256c0-53-43-96-96-96s-96 43-96 96V384l0 .5c-19 0-41.2-7.9-59.1-20.3c-11.1-7.8-24-11.7-36.9-11.7V227.6C96 190.2 65.8 160 28.4 160C12.7 160 0 147.3 0 131.6V96zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaBridge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H72v64H0V288c53 0 96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96s96 43 96 96v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V384c0-53 43-96 96-96V160H504V96h40c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM456 96v64H376V96h80zM328 96v64H248V96h80zM200 96v64H120V96h80z"
                }
            }
        ]
    })(props);
}
function FaBriefcaseMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zm96 152c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
                }
            }
        ]
    })(props);
}
function FaBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 320 512V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM512 288H320v32c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V288z"
                }
            }
        ]
    })(props);
}
function FaBroomBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M566.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-192 192 34.7 34.7c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H364.3L256 211.7V182.6c0-12.5 10.1-22.6 22.6-22.6c6 0 11.8 2.4 16 6.6l34.7 34.7 192-192c12.5-12.5 32.8-12.5 45.3 0zm-344 225.5L341.1 353.4c3.7 42.7-11.7 85.2-42.3 115.8C271.4 496.6 234.2 512 195.5 512L22.1 512C9.9 512 0 502.1 0 489.9c0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2c0-31.5 12.5-61.7 34.8-84l8-8c30.6-30.6 73.1-45.9 115.8-42.3zM464 352a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                }
            }
        ]
    })(props);
}
function FaBroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6c-12.5 0-22.6 10.1-22.6 22.6v29.1L364.3 320h29.1c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8C76.5 307.5 64 337.7 64 369.2c0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9C0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8c30.6-30.6 45.9-73.1 42.3-115.8z"
                }
            }
        ]
    })(props);
}
function FaBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 6c-1.5-3.6-5-6-8.9-6h-19c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6H48C21.5 0 0 21.5 0 48V224v22.4V256H9.6 374.4 384v-9.6V224 48c0-26.5-21.5-48-48-48H230.5c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 288v32c0 35.3 28.7 64 64 64h64v64c0 35.3 28.7 64 64 64s64-28.7 64-64V384h64c35.3 0 64-28.7 64-64V288H0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                }
            }
        ]
    })(props);
}
function FaBucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 152v8H48v-8C48 68.1 116.1 0 200 0h48c83.9 0 152 68.1 152 152v8H352v-8c0-57.4-46.6-104-104-104H200C142.6 48 96 94.6 96 152zM0 224c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32h-5.1L388.5 469c-2.6 24.4-23.2 43-47.7 43H107.2c-24.6 0-45.2-18.5-47.7-43L37.1 256H32c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaBugSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L477.4 348.9c1.7-9.4 2.6-19 2.6-28.9h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H479.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C409.2 164.1 393.1 160 376 160H264c-8.3 0-16.3 1-24 2.8L38.8 5.1zM320 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H387.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zM160.3 256H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V335.5L166.7 227.3c-3.4 9-5.6 18.7-6.4 28.7zM336 479.2c36.6-3.6 69.7-19.6 94.8-43.8L336 360.7V479.2z"
                }
            }
        ]
    })(props);
}
function FaBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaBugs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.5 107.4l33.4-73.5c5.5-12.1 .1-26.3-11.9-31.8s-26.3-.1-31.8 11.9L128 71.7 101.9 14.1C96.4 2 82.1-3.3 70.1 2.1S52.7 21.9 58.1 33.9l33.4 73.5c-10.2 7.1-18.2 17-22.9 28.6h-17l-4.1-20.7c-2.6-13-15.2-21.4-28.2-18.8S-2.1 111.7 .5 124.7l8 40C10.7 175.9 20.6 184 32 184H64v23.3l-37.8 9.5c-9.5 2.4-16.6 10.2-17.9 19.9l-8 56c-1.9 13.1 7.2 25.3 20.4 27.2s25.3-7.2 27.2-20.4l5.7-40 18.4-4.6C82.7 274.6 103.8 288 128 288s45.3-13.4 56.1-33.2l18.4 4.6 5.7 40c1.9 13.1 14 22.2 27.2 20.4s22.2-14 20.4-27.2l-8-56c-1.4-9.7-8.5-17.5-17.9-19.9L192 207.3V184h32c11.4 0 21.3-8.1 23.5-19.3l8-40c2.6-13-5.8-25.6-18.8-28.2s-25.6 5.8-28.2 18.8L204.3 136h-17c-4.7-11.6-12.7-21.5-22.9-28.6zM496 286.5l65.6-47c10.8-7.7 13.3-22.7 5.6-33.5s-22.7-13.3-33.5-5.6l-51.4 36.8 6.1-62.9c1.3-13.2-8.4-24.9-21.6-26.2s-24.9 8.4-26.2 21.6L432.8 250c-12.3 1-24.2 5.6-34.1 13.3L384 254.8l6.8-20c4.2-12.6-2.5-26.2-15-30.4s-26.2 2.5-30.4 15l-13.1 38.6c-3.7 10.8 .8 22.8 10.7 28.5l27.7 16L359 322.7 321.5 312c-9.4-2.7-19.5 .6-25.5 8.3l-34.9 44.5c-8.2 10.4-6.4 25.5 4.1 33.7s25.5 6.4 33.7-4.1l25-31.8 18.2 5.2c-.5 22.6 11 44.7 32 56.8s45.9 11 65.2-.7l13.6 13.2-15.1 37.5c-4.9 12.3 1 26.3 13.3 31.2s26.3-1 31.2-13.3L503.5 440c3.6-9.1 1.4-19.4-5.6-26.2l-28-27.1 11.6-20.1 27.7 16c9.9 5.7 22.5 3.7 30-4.9L566.2 347c8.7-10 7.8-25.1-2.2-33.9s-25.1-7.8-33.9 2.2l-13.9 15.9-14.7-8.5c1.7-12.4-.2-25-5.5-36.2z"
                }
            }
        ]
    })(props);
}
function FaBuildingCircleArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V232.2c-39.1 32.3-64 81.1-64 135.8c0 49.5 20.4 94.2 53.3 126.2C364.5 505.1 351.1 512 336 512H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm96 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6L521.4 352H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
                }
            }
        ]
    })(props);
}
function FaBuildingCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaBuildingCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaBuildingCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c15.1 0 28.5-6.9 37.3-17.8C340.4 462.2 320 417.5 320 368c0-54.7 24.9-103.5 64-135.8V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaBuildingColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaBuildingFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM448 0c-17.7 0-32 14.3-32 32V512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaBuildingLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h88.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-23.7 12.9-44.4 32-55.4V272c0-30.5 12.2-58.2 32-78.4V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM464 240c17.7 0 32 14.3 32 32v48H432V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaBuildingNgo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM168 64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H184v64h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24H176c-13.3 0-24-10.7-24-24V80c0-8.8 7.2-16 16-16zM304 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48V112zM61.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 132.8V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4z"
                }
            }
        ]
    })(props);
}
function FaBuildingShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V207l-42.4 17H304 272c-8.8 0-16 7.2-16 16v32 24.2V304c0 .9 .1 1.7 .2 2.6c2.3 58.1 24.1 144.8 98.7 201.5c-5.8 2.5-12.2 3.9-18.9 3.9H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zM423.1 225.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
                }
            }
        ]
    })(props);
}
function FaBuildingUn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaBuildingUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"
                }
            }
        ]
    })(props);
}
function FaBuildingWheat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H240V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H48c-26.5 0-48-21.5-48-48V48zM80 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm112-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H272zM64 112v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM176 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H176zm80 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16zm384 80v16c0 44.2-35.8 80-80 80H544V272c0-44.2 35.8-80 80-80h16zm0 128c0 44.2-35.8 80-80 80H544V384c0-44.2 35.8-80 80-80h16v16zm0 112c0 44.2-35.8 80-80 80H544V496c0-44.2 35.8-80 80-80h16v16zM512 496v16H496c-44.2 0-80-35.8-80-80V416h16c44.2 0 80 35.8 80 80zm0-96H496c-44.2 0-80-35.8-80-80V304h16c44.2 0 80 35.8 80 80v16zm0-128v16H496c-44.2 0-80-35.8-80-80V192h16c44.2 0 80 35.8 80 80zM528 32c13.3 0 24 10.7 24 24V160c0 13.3-10.7 24-24 24s-24-10.7-24-24V56c0-13.3 10.7-24 24-24zm96 64v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24s24 10.7 24 24zM456 72c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V96c0-13.3 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaBullhorn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9L381.7 53c-48 48-113.1 75-181 75H192 160 64c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64l0 128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352l8.7 0c67.9 0 133 27 181 75l43.6 43.6c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V300.4c18.6-8.8 32-32.5 32-60.4s-13.4-51.6-32-60.4V32zm-64 76.7V240 371.3C357.2 317.8 280.5 288 200.7 288H192V192h8.7c79.8 0 156.5-29.8 215.3-83.3z"
                }
            }
        ]
    })(props);
}
function FaBullseye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaBurger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.1 224C45 224 32 211 32 194.9c0-1.9 .2-3.7 .6-5.6C37.9 168.3 78.8 32 256 32s218.1 136.3 223.4 157.3c.5 1.9 .6 3.7 .6 5.6c0 16.1-13 29.1-29.1 29.1H61.1zM144 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm240 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM272 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM16 304c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48s-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zm16 96c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16v16c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V400z"
                }
            }
        ]
    })(props);
}
function FaBurst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l112 163.3L16.6 233.2C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4L66.8 412.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L392.3 312.2l103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8L388.9 198.7l25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7L278.8 16.6C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-32.3 99.6L37.6 4.2z"
                }
            }
        ]
    })(props);
}
function FaBusSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0C348.8 0 448 35.2 448 80V96 416c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32V96 80C0 35.2 99.2 0 224 0zM64 128V256c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C422.4 0 512 35.2 512 80V96l0 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32l0 160c0 17.7-14.3 32-32 32v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H192v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32l0-32c-17.7 0-32-14.3-32-32l0-160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h0V96h0V80C64 35.2 153.6 0 288 0zM128 160v96c0 17.7 14.3 32 32 32H272V128H160c-17.7 0-32 14.3-32 32zM304 288H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H304V288zM144 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm288 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM384 80c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaBusinessTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96H64C28.7 96 0 124.7 0 160v96H192 352h8.2c32.3-39.1 81.1-64 135.8-64c5.4 0 10.7 .2 16 .7V160c0-35.3-28.7-64-64-64H384V56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM320 352H224c-17.7 0-32-14.3-32-32V288H0V416c0 35.3 28.7 64 64 64H360.2C335.1 449.6 320 410.5 320 368c0-5.4 .2-10.7 .7-16l-.7 0zm320 16a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 288c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaC(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3s155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8s221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
                }
            }
        ]
    })(props);
}
function FaCableCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 56a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64H232V157.5l-203.1 42c-13 2.7-25.7-5.7-28.4-18.6s5.7-25.7 18.6-28.4l232-48 232-48c13-2.7 25.7 5.7 28.4 18.6s-5.7 25.7-18.6 28.4L280 147.5V224H416c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V288zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H96zm112 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H352z"
                }
            }
        ]
    })(props);
}
function FaCakeCandles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.4 5.5L61.8 47.6C58 54.1 56 61.6 56 69.2V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L105.6 5.5C103.6 2.1 100 0 96 0s-7.6 2.1-9.6 5.5zm128 0L189.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L233.6 5.5C231.6 2.1 228 0 224 0s-7.6 2.1-9.6 5.5zM317.8 47.6c-3.8 6.5-5.8 14-5.8 21.6V72c0 22.1 17.9 40 40 40s40-17.9 40-40V69.2c0-7.6-2-15-5.8-21.6L361.6 5.5C359.6 2.1 356 0 352 0s-7.6 2.1-9.6 5.5L317.8 47.6zM128 176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c-35.3 0-64 28.7-64 64v71c8.3 5.2 18.1 9 28.8 9c13.5 0 27.2-6.1 38.4-13.4c5.4-3.5 9.9-7.1 13-9.7c1.5-1.3 2.7-2.4 3.5-3.1c.4-.4 .7-.6 .8-.8l.1-.1 0 0 0 0s0 0 0 0s0 0 0 0c3.1-3.2 7.4-4.9 11.9-4.8s8.6 2.1 11.6 5.4l0 0 0 0 .1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c3-3.5 7.4-5.4 12-5.4s9 2 12 5.4l.1 .1c.1 .1 .4 .4 .7 .7c.7 .7 1.7 1.7 3.1 3c2.8 2.6 6.8 6.1 11.8 9.5c10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c5-3.5 9-6.9 11.8-9.5c1.4-1.3 2.4-2.3 3.1-3c.3-.3 .6-.6 .7-.7l.1-.1c2.9-3.4 7.1-5.3 11.6-5.4s8.7 1.6 11.9 4.8l0 0 0 0 0 0 .1 .1c.2 .2 .4 .4 .8 .8c.8 .7 1.9 1.8 3.5 3.1c3.1 2.6 7.5 6.2 13 9.7c11.2 7.3 24.9 13.4 38.4 13.4c10.7 0 20.5-3.9 28.8-9V288c0-35.3-28.7-64-64-64V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H256V176c0-17.7-14.3-32-32-32s-32 14.3-32 32v48H128V176zM448 394.6c-8.5 3.3-18.2 5.4-28.8 5.4c-22.5 0-42.4-9.9-55.8-18.6c-4.1-2.7-7.8-5.4-10.9-7.8c-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2c-2.7 2.3-5.9 4.7-9.4 7.2C201.8 390 182.6 400 160 400s-41.8-10-54.6-18.9c-3.7-2.6-7-5.2-9.8-7.5c-3.1 2.4-6.8 5.1-10.9 7.8C71.2 390.1 51.3 400 28.8 400c-10.6 0-20.3-2.2-28.8-5.4V480c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V394.6z"
                }
            }
        ]
    })(props);
}
function FaCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 64H288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm32 160a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM96 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM64 416c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM192 256a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm64-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm32 64a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
                }
            }
        ]
    })(props);
}
function FaCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zM329 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329 305z"
                }
            }
        ]
    })(props);
}
function FaCalendarDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
                }
            }
        ]
    })(props);
}
function FaCalendarDays(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM344 376c13.3 0 24-10.7 24-24s-10.7-24-24-24H168c-13.3 0-24 10.7-24 24s10.7 24 24 24H344z"
                }
            }
        ]
    })(props);
}
function FaCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32V64H80c-26.5 0-48 21.5-48 48v48H480V112c0-26.5-21.5-48-48-48H384V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H192V32c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 192H32V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V192zM256 248c13.3 0 24 10.7 24 24v56h56c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V376H176c-13.3 0-24-10.7-24-24s10.7-24 24-24h56V272c0-13.3 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaCalendarWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm80 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H368c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80z"
                }
            }
        ]
    })(props);
}
function FaCalendarXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H32V112c0-26.5 21.5-48 48-48h48V32c0-17.7 14.3-32 32-32zM32 192H480V464c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V192zM337 305c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47z"
                }
            }
        ]
    })(props);
}
function FaCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
                }
            }
        ]
    })(props);
}
function FaCameraRetro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 121.2L271.1 96 448 96v96H333.2c-21.9-15.1-48.5-24-77.2-24s-55.2 8.9-77.2 24H64V128H192c9.9 0 19.7-2.3 28.6-6.8zM0 128V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H271.1c-9.9 0-19.7 2.3-28.6 6.8L192 64H160V48c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16l0 16C28.7 64 0 92.7 0 128zM168 304a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z"
                }
            }
        ]
    })(props);
}
function FaCameraRotate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z"
                }
            }
        ]
    })(props);
}
function FaCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                }
            }
        ]
    })(props);
}
function FaCampground(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 52c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L288 60.8 249 12c-11-13.8-31.2-16-45-5s-16 31.2-5 45l48 60L12.3 405.4C4.3 415.4 0 427.7 0 440.4V464c0 26.5 21.5 48 48 48H288 528c26.5 0 48-21.5 48-48V440.4c0-12.7-4.3-25.1-12.3-35L329 112l48-60zM288 448H168.5L288 291.7 407.5 448H288z"
                }
            }
        ]
    })(props);
}
function FaCandyCane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348.8 131.5c3.7-2.3 7.9-3.5 12.2-3.5c12.7 0 23 10.3 23 23v5.6c0 9.9-5.1 19.1-13.5 24.3L30.1 393.7C.1 412.5-9 451.9 9.7 481.9s58.2 39.1 88.2 20.4L438.4 289.5c45.8-28.6 73.6-78.8 73.6-132.8V151C512 67.6 444.4 0 361 0c-28.3 0-56 8-80.1 23L254.1 39.7c-30 18.7-39.1 58.2-20.4 88.2s58.2 39.1 88.2 20.4l26.8-16.8zM298.4 49.8c9.2-5.7 19.1-10.1 29.4-13.1L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9L298.4 49.8zm88.5 52.7l46.2-46.2c8.5 6.5 16.1 14.1 22.6 22.6l-46.2 46.2c-5.1-9.6-13-17.5-22.6-22.6zm28.9 59.3l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c6.2-8.8 10.1-19.1 11-30.1zm-86.1 82.5l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zm-107.2 67l60.4 37.7-30.2 18.9-60.4-37.7 30.2-18.9zM119.3 375.7l60.4 37.7-30.2 18.9L89.1 394.6l30.2-18.9z"
                }
            }
        ]
    })(props);
}
function FaCannabis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c5.3 0 10.3 2.7 13.3 7.1c15.8 23.5 36.7 63.7 49.2 109c7.2 26.4 11.8 55.2 10.4 84c11.5-8.8 23.7-16.7 35.8-23.6c41-23.3 84.4-36.9 112.2-42.5c5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7c-9.1 15.9-19.9 31.7-32.4 46.3c27.8 6.6 52.4 17.3 67.2 25.5c5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1c-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.1c1.5 6.1-.6 12.4-5.5 16.4s-11.6 4.6-17.2 1.9L280 417.2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V417.2l-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.9s-7-10.3-5.5-16.4l8.3-33.1c-22.2 2.6-45 0-65.2-4.6c-28.9-6.6-54.6-17.6-69.8-26.1c-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14c14.8-8.2 39.4-18.8 67.2-25.5C78.9 296.3 68.1 280.5 59 264.6c-23.4-40.8-37.1-84-42.7-111.7c-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5c12.1 6.9 24.3 14.7 35.8 23.6c-1.4-28.7 3.1-57.6 10.4-84c12.5-45.3 33.4-85.5 49.2-109c3-4.4 8-7.1 13.3-7.1z"
                }
            }
        ]
    })(props);
}
function FaCapsules(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144c0-26.5 21.5-48 48-48s48 21.5 48 48V256H64V144zM0 144V368c0 61.9 50.1 112 112 112s112-50.1 112-112V189.6c1.8 19.1 8.2 38 19.8 54.8L372.3 431.7c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 113.3C391.8 61.5 321.9 49 271.3 85.2c-28 20-44.3 50.8-47.3 83V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm296.6 64.2c-16-23.3-10-55.3 11.9-71c21.2-15.1 50.5-10.3 66 12.2l67 97.6L361.6 303l-65-94.8zM491 407.7c-.8 .6-1.6 1.1-2.4 1.6l4-2.8c-.5 .4-1 .8-1.6 1.2z"
                }
            }
        ]
    })(props);
}
function FaCarBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32h16c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64l16 0zm304 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V192zM80 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaCarBurst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 8c-6.6 0-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6l35.3-32.5 9.5-35.4 10.4-38.6c8-29.9 30.5-52.1 57.9-60.9l41-59.2c11.3-16.3 26.4-28.9 43.5-37.2c-.4-.6-.8-1.2-1.3-1.8c-4.1-5.1-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74C188.4 12 182.6 8 176 8zM367.7 161.5l135.6 36.3c6.5 1.8 11.3 7.4 11.8 14.2l4.6 56.5-201.5-54 32.2-46.6c3.8-5.6 10.8-8.1 17.3-6.4zm-69.9-30l-47.9 69.3c-21.6 3-40.3 18.6-46.3 41l-10.4 38.6-16.6 61.8-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 247.3 66.3-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9L595 388l10.4-38.6c6-22.4-2.5-45.2-19.6-58.7l-6.8-84c-2.7-33.7-26.4-62-59-70.8L384.2 99.7c-32.7-8.8-67.3 4-86.5 31.8zm-17 131a24 24 0 1 1 -12.4 46.4 24 24 0 1 1 12.4-46.4zm217.9 83.2A24 24 0 1 1 545 358.1a24 24 0 1 1 -46.4-12.4z"
                }
            }
        ]
    })(props);
}
function FaCarOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM185.8 224H326.2c6.8 0 12.8 4.3 15.1 10.6L360.3 288H151.7l19.1-53.4c2.3-6.4 8.3-10.6 15.1-10.6zm-75.3-10.9L82.2 292.4C62.1 300.9 48 320.8 48 344v40 64 32c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V448H384v32c0 17.7 14.3 32 32 32h16c17.7 0 32-14.3 32-32V448 384 344c0-23.2-14.1-43.1-34.2-51.6l-28.3-79.3C390.1 181.3 360 160 326.2 160H185.8c-33.8 0-64 21.3-75.3 53.1zM128 344a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm232 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM39 39c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L73 39c-9.4-9.4-24.6-9.4-33.9 0zm400 0L391 87c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
                }
            }
        ]
    })(props);
}
function FaCarRear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.4 96H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 192H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256v80c0 23.7 12.9 44.4 32 55.4V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V400H384v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V391.4c19.1-11.1 32-31.7 32-55.4V256c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32H165.4c-40.8 0-77.1 25.8-90.6 64.3zM208 272h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-13.3 0-24-10.7-24-24zm360-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H408c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaCarSide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.3 96H224v96H111.3l30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192V96h81.2c9.7 0 18.9 4.4 25 12l67.2 84H272zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36H171.3c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256V368c0 17.7 14.3 32 32 32H65.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H385.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32V320c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaCarTunnel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256V448c0 35.3 28.7 64 64 64h42.8c-6.6-5.9-10.8-14.4-10.8-24V376c0-20.8 11.3-38.9 28.1-48.6l21-64.7c7.5-23.1 29-38.7 53.3-38.7H313.6c24.3 0 45.8 15.6 53.3 38.7l21 64.7c16.8 9.7 28.2 27.8 28.2 48.6V488c0 9.6-4.2 18.1-10.8 24H448c35.3 0 64-28.7 64-64V256C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24V448H160v40c0 9.6-4.2 18.1-10.8 24H362.8zM190.8 277.5L177 320H335l-13.8-42.5c-1.1-3.3-4.1-5.5-7.6-5.5H198.4c-3.5 0-6.5 2.2-7.6 5.5zM168 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm200-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                }
            }
        ]
    })(props);
}
function FaCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaCaravan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112C0 67.8 35.8 32 80 32H416c88.4 0 160 71.6 160 160V352h32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0H288c0 53-43 96-96 96s-96-43-96-96H80c-44.2 0-80-35.8-80-80V112zM320 352H448V256H416c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V160c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32V352zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96zm96 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
                }
            }
        ]
    })(props);
}
function FaCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 256c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
                }
            }
        ]
    })(props);
}
function FaCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6l0 256c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l128-128z"
                }
            }
        ]
    })(props);
}
function FaCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
                }
            }
        ]
    })(props);
}
function FaCarrot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M346.7 6C337.6 17 320 42.3 320 72c0 40 15.3 55.3 40 80s40 40 80 40c29.7 0 55-17.6 66-26.7c4-3.3 6-8.2 6-13.3s-2-10-6-13.2c-11.4-9.1-38.3-26.8-74-26.8c-32 0-40 8-40 8s8-8 8-40c0-35.7-17.7-62.6-26.8-74C370 2 365.1 0 360 0s-10 2-13.3 6zM244.6 136c-40 0-77.1 18.1-101.7 48.2l60.5 60.5c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.3-55.3 0 .1L2.2 477.9C-2 487-.1 497.8 7 505s17.9 9 27.1 4.8l134.7-62.4-52.1-52.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L199.7 433l100.2-46.4c46.4-21.5 76.2-68 76.2-119.2C376 194.8 317.2 136 244.6 136z"
                }
            }
        ]
    })(props);
}
function FaCartArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaCartFlatbedSuitcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0H48c44.2 0 80 35.8 80 80V368c0 8.8 7.2 16 16 16H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H541.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H253.3c1.8 5 2.7 10.4 2.7 16c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16H144c-44.2 0-80-35.8-80-80V80c0-8.8-7.2-16-16-16H32C14.3 64 0 49.7 0 32zM432 96V56c0-4.4-3.6-8-8-8H344c-4.4 0-8 3.6-8 8V96h96zM288 96V56c0-30.9 25.1-56 56-56h80c30.9 0 56 25.1 56 56V96 320H288V96zM512 320V96h16c26.5 0 48 21.5 48 48V272c0 26.5-21.5 48-48 48H512zM240 96h16V320H240c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
                }
            }
        ]
    })(props);
}
function FaCartFlatbed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64H48c8.8 0 16 7.2 16 16V368c0 44.2 35.8 80 80 80h18.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H450.7c-1.8 5-2.7 10.4-2.7 16c0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H144c-8.8 0-16-7.2-16-16V80C128 35.8 92.2 0 48 0H32zM192 80V272c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H464V176c0 5.9-3.2 11.3-8.5 14.1s-11.5 2.5-16.4-.8L400 163.2l-39.1 26.1c-4.9 3.3-11.2 3.6-16.4 .8s-8.5-8.2-8.5-14.1V32H240c-26.5 0-48 21.5-48 48z"
                }
            }
        ]
    })(props);
}
function FaCartPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"
                }
            }
        ]
    })(props);
}
function FaCartShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaCashRegister(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
                }
            }
        ]
    })(props);
}
function FaCat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 192h17.1c22.1 38.3 63.5 64 110.9 64c11 0 21.8-1.4 32-4v4 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V339.2L280 448h56c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-53 0-96-43-96-96V192.5c0-16.1-12-29.8-28-31.8l-7.9-1c-17.5-2.2-30-18.2-27.8-35.7s18.2-30 35.7-27.8l7.9 1c48 6 84.1 46.8 84.1 95.3v85.3c34.4-51.7 93.2-85.8 160-85.8zm160 26.5v0c-10 3.5-20.8 5.5-32 5.5c-28.4 0-54-12.4-71.6-32h0c-3.7-4.1-7-8.5-9.9-13.2C357.3 164 352 146.6 352 128v0V32 12 10.7C352 4.8 356.7 .1 362.6 0h.2c3.3 0 6.4 1.6 8.4 4.2l0 .1L384 21.3l27.2 36.3L416 64h64l4.8-6.4L512 21.3 524.8 4.3l0-.1c2-2.6 5.1-4.2 8.4-4.2h.2C539.3 .1 544 4.8 544 10.7V12 32v96c0 17.3-4.6 33.6-12.6 47.6c-11.3 19.8-29.6 35.2-51.4 42.9zM432 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaCediSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V66.7C101.2 81.9 32 160.9 32 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c30.9-5.2 59.2-17.7 83.2-35.8c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-13.2 9.9-28.3 17.3-44.8 21.6V132c16.4 4.2 31.6 11.6 44.8 21.6c14.1 10.6 34.2 7.8 44.8-6.4s7.8-34.2-6.4-44.8c-24-18-52.4-30.6-83.2-35.8V32zM192 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124z"
                }
            }
        ]
    })(props);
}
function FaCentSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32V66.7c30.9 5.2 59.2 17.7 83.2 35.8c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4C279.4 137.5 252.9 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c28.9 0 55.4-9.5 76.8-25.6c14.1-10.6 34.2-7.8 44.8 6.4s7.8 34.2-6.4 44.8c-24 18-52.4 30.6-83.2 35.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C101.2 430.1 32 351.1 32 256s69.2-174.1 160-189.3V32c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"
                }
            }
        ]
    })(props);
}
function FaChair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 48V256h48V58.7c23.9 13.8 40 39.7 40 69.3V256h48V128C384 57.3 326.7 0 256 0H192C121.3 0 64 57.3 64 128V256h48V128c0-29.6 16.1-55.5 40-69.3V256h48V48h48zM48 288c-12.1 0-23.2 6.8-28.6 17.7l-16 32c-5 9.9-4.4 21.7 1.4 31.1S20.9 384 32 384l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32V384H352v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-16-32C423.2 294.8 412.1 288 400 288H48z"
                }
            }
        ]
    })(props);
}
function FaChalkboardUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H336.8c-11.8-25.5-29.9-47.5-52.4-64H384V320c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v32h64V64L224 64v49.1C205.2 102.2 183.3 96 160 96V64zm0 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM133.3 352h53.3C260.3 352 320 411.7 320 485.3c0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3C0 411.7 59.7 352 133.3 352z"
                }
            }
        ]
    })(props);
}
function FaChalkboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C60.7 32 32 60.7 32 96V384H96V96l384 0V384h64V96c0-35.3-28.7-64-64-64H96zM224 384v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H416V384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaChampagneGlasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.6 17.3C163 3 179.9-3.6 195 1.9L320 47.5l125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6L556.1 413l41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41l-71.1 25.9L476.8 510c-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-34-130-95.2L320 188.8l-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6 25.2 24.4 19.1 41s-24.4 25.2-41 19.1L92.2 484.1 21.1 458.2c-16.6-6.1-25.2-24.4-19.1-41s24.4-25.2 41-19.1l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8L261.6 157l13.1-57.9L199.6 71.7zm240.9 0L365.4 99.1 378.5 157l89.2-32.5L440.5 71.7z"
                }
            }
        ]
    })(props);
}
function FaChargingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"
                }
            }
        ]
    })(props);
}
function FaChartArea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm96 288H448c17.7 0 32-14.3 32-32V251.8c0-7.6-2.7-15-7.7-20.8l-65.8-76.8c-12.1-14.2-33.7-15-46.9-1.8l-21 21c-10 10-26.4 9.2-35.4-1.6l-39.2-47c-12.6-15.1-35.7-15.4-48.7-.6L135.9 215c-5.1 5.8-7.9 13.3-7.9 21.1v84c0 17.7 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaChartBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaChartColumn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaChartGantt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaChartLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
                }
            }
        ]
    })(props);
}
function FaChartPie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
                }
            }
        ]
    })(props);
}
function FaChartSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"
                }
            }
        ]
    })(props);
}
function FaCheckDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 402.7 54.6 297.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l256-256z"
                }
            }
        ]
    })(props);
}
function FaCheckToSlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 80c0-26.5 21.5-48 48-48H432c26.5 0 48 21.5 48 48V384H96V80zm313 47c-9.4-9.4-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L409 161c9.4-9.4 9.4-24.6 0-33.9zM0 336c0-26.5 21.5-48 48-48H64V416H512V288h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336z"
                }
            }
        ]
    })(props);
}
function FaCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                }
            }
        ]
    })(props);
}
function FaCheese(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 240.2V256H0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7C418.8 32 512 125.2 512 240.2zm0 47.8V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288H512z"
                }
            }
        ]
    })(props);
}
function FaChessBishop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C110.3 0 96 14.3 96 32c0 16.1 11.9 29.4 27.4 31.7C78.4 106.8 8 190 8 288c0 47.4 30.8 72.3 56 84.7V400H256V372.7c25.2-12.5 56-37.4 56-84.7c0-37.3-10.2-72.4-25.3-104.1l-99.4 99.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L270.8 154.6c-23.2-38.1-51.8-69.5-74.2-90.9C212.1 61.4 224 48.1 224 32c0-17.7-14.3-32-32-32H128zM48 432L6.6 473.4c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512H297.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L272 432H48z"
                }
            }
        ]
    })(props);
}
function FaChessBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 64v64h64V96h64v64h64V96h64v64H320v64h64v64H320v64h64v64H320V352H256v64H192V352H128v64H64V352h64V288H64V224h64V160H64V96h64zm64 128h64V160H192v64zm0 64V224H128v64h64zm64 0H192v64h64V288zm0 0h64V224H256v64z"
                }
            }
        ]
    })(props);
}
function FaChessKing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32V48h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H256v48H408c22.1 0 40 17.9 40 40c0 5.3-1 10.5-3.1 15.4L368 400H80L3.1 215.4C1 210.5 0 205.3 0 200c0-22.1 17.9-40 40-40H192V112H176c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V32c0-17.7 14.3-32 32-32zM38.6 473.4L80 432H368l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H54.6C42.1 512 32 501.9 32 489.4c0-6 2.4-11.8 6.6-16z"
                }
            }
        ]
    })(props);
}
function FaChessKnight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 48L82.7 61.3C70.7 73.3 64 89.5 64 106.5V238.9c0 10.7 5.3 20.7 14.2 26.6l10.6 7c14.3 9.6 32.7 10.7 48.1 3l3.2-1.6c2.6-1.3 5-2.8 7.3-4.5l49.4-37c6.6-5 15.7-5 22.3 0c10.2 7.7 9.9 23.1-.7 30.3L90.4 350C73.9 361.3 64 380 64 400H384l28.9-159c2.1-11.3 3.1-22.8 3.1-34.3V192C416 86 330 0 224 0H83.8C72.9 0 64 8.9 64 19.8c0 7.5 4.2 14.3 10.9 17.7L96 48zm24 68a20 20 0 1 1 40 0 20 20 0 1 1 -40 0zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H409.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L384 432H64L22.6 473.4z"
                }
            }
        ]
    })(props);
}
function FaChessPawn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.5 224c29.2-18.4 48.5-50.9 48.5-88c0-57.4-46.6-104-104-104S56 78.6 56 136c0 37.1 19.4 69.6 48.5 88H96c-17.7 0-32 14.3-32 32c0 16.5 12.5 30 28.5 31.8L80 400H240L227.5 287.8c16-1.8 28.5-15.3 28.5-31.8c0-17.7-14.3-32-32-32h-8.5zM22.6 473.4c-4.2 4.2-6.6 10-6.6 16C16 501.9 26.1 512 38.6 512H281.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L256 432H64L22.6 473.4z"
                }
            }
        ]
    })(props);
}
function FaChessQueen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a56 56 0 1 1 0 112A56 56 0 1 1 256 0zM134.1 143.8c3.3-13 15-23.8 30.2-23.8c12.3 0 22.6 7.2 27.7 17c12 23.2 36.2 39 64 39s52-15.8 64-39c5.1-9.8 15.4-17 27.7-17c15.3 0 27 10.8 30.2 23.8c7 27.8 32.2 48.3 62.1 48.3c10.8 0 21-2.7 29.8-7.4c8.4-4.4 18.9-4.5 27.6 .9c13 8 17.1 25 9.2 38L399.7 400H384 343.6 168.4 128 112.3L5.4 223.6c-7.9-13-3.8-30 9.2-38c8.7-5.3 19.2-5.3 27.6-.9c8.9 4.7 19 7.4 29.8 7.4c29.9 0 55.1-20.5 62.1-48.3zM256 224l0 0 0 0h0zM112 432H400l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H86.6C74.1 512 64 501.9 64 489.4c0-6 2.4-11.8 6.6-16L112 432z"
                }
            }
        ]
    })(props);
}
function FaChessRook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V88c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16V192c0 10.1-4.7 19.6-12.8 25.6L352 256l16 144H80L96 256 44.8 217.6C36.7 211.6 32 202.1 32 192zm176 96h32c8.8 0 16-7.2 16-16V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 8.8 7.2 16 16 16zM22.6 473.4L64 432H384l41.4 41.4c4.2 4.2 6.6 10 6.6 16c0 12.5-10.1 22.6-22.6 22.6H38.6C26.1 512 16 501.9 16 489.4c0-6 2.4-11.8 6.6-16z"
                }
            }
        ]
    })(props);
}
function FaChess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V32H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16V96H60.2C49.1 96 40 105.1 40 116.2c0 2.5 .5 4.9 1.3 7.3L73.8 208H72c-13.3 0-24 10.7-24 24s10.7 24 24 24h4L60 384H196L180 256h4c13.3 0 24-10.7 24-24s-10.7-24-24-24h-1.8l32.5-84.5c.9-2.3 1.3-4.8 1.3-7.3c0-11.2-9.1-20.2-20.2-20.2H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144V16zM48 416L4.8 473.6C1.7 477.8 0 482.8 0 488c0 13.3 10.7 24 24 24H232c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L208 416H48zm288 0l-43.2 57.6c-3.1 4.2-4.8 9.2-4.8 14.4c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24c0-5.2-1.7-10.2-4.8-14.4L464 416H336zM304 208v51.9c0 7.8 2.8 15.3 8 21.1L339.2 312 337 384H462.5l-3.3-72 28.3-30.8c5.4-5.9 8.5-13.6 8.5-21.7V208c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16v16H424V208c0-8.8-7.2-16-16-16H392c-8.8 0-16 7.2-16 16v16H352V208c0-8.8-7.2-16-16-16H320c-8.8 0-16 7.2-16 16zm80 96c0-8.8 7.2-16 16-16s16 7.2 16 16v32H384V304z"
                }
            }
        ]
    })(props);
}
function FaChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                }
            }
        ]
    })(props);
}
function FaChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
                }
            }
        ]
    })(props);
}
function FaChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
                }
            }
        ]
    })(props);
}
function FaChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
                }
            }
        ]
    })(props);
}
function FaChildCombatant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 128A64 64 0 1 0 176 0a64 64 0 1 0 0 128zm-8 352V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V300.5L260.9 321c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-51.7-82.1c-17.6-27.9-48.3-44.9-81.2-44.9H169.8c-33 0-63.7 16.9-81.2 44.9L36.9 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10L104 300.5V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM448 0H432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16V132.3c-9.6 5.5-16 15.9-16 27.7v32c-17.7 0-32 14.3-32 32V368c0 17.7 14.3 32 32 32h16v96c0 8.8 7.2 16 16 16h59.5c10.4 0 18-9.8 15.5-19.9L484 400h44c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H480V325.3l53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16H512c-8.8 0-16 7.2-16 16v56l-16 5.3V160c0-11.8-6.4-22.2-16-27.7V16c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaChildDress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 64A64 64 0 1 0 96 64a64 64 0 1 0 128 0zM88 400v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h16v80c0 17.7 14.3 32 32 32s32-14.3 32-32V400h17.8c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.6 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2l28.7-37.8L55 378.9C51.6 389.3 59.3 400 70.2 400H88z"
                }
            }
        ]
    })(props);
}
function FaChildReaching(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64A64 64 0 1 0 128 64a64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.2 85.4s-18.7 29.7-8.9 44.4L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384h32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V221.6c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6c-12.6 0-24.9-2-36.6-5.8c-.9-.3-1.8-.7-2.7-.9z"
                }
            }
        ]
    })(props);
}
function FaChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64a64 64 0 1 1 128 0A64 64 0 1 1 96 64zm48 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V287.8L59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H144z"
                }
            }
        ]
    })(props);
}
function FaChildren(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0a64 64 0 1 1 0 128A64 64 0 1 1 160 0zM88 480V400H70.2c-10.9 0-18.6-10.7-15.2-21.1l31.1-93.4L57.5 323.3c-10.7 14.1-30.8 16.8-44.8 6.2s-16.8-30.7-6.2-44.8L65.4 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47l58.9 77.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.6-37.8L265 378.9c3.5 10.4-4.3 21.1-15.2 21.1H232v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V400H152v80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480 0a64 64 0 1 1 0 128A64 64 0 1 1 480 0zm-8 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V300.5L395.1 321c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9h12.3c33 0 63.7 16.9 81.2 44.9L619.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L552 300.5V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H472z"
                }
            }
        ]
    })(props);
}
function FaChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V48H264c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v46.4L183.3 210c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V251.2c0-16.9-8.8-32.5-23.3-41.2L344 142.4V96h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V24zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
                }
            }
        ]
    })(props);
}
function FaCircleArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM127 281c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l71 71L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 71-71c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 393c-9.4 9.4-24.6 9.4-33.9 0L127 281z"
                }
            }
        ]
    })(props);
}
function FaCircleArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM231 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L376 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-182.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L119 273c-9.4-9.4-9.4-24.6 0-33.9L231 127z"
                }
            }
        ]
    })(props);
}
function FaCircleArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z"
                }
            }
        ]
    })(props);
}
function FaCircleArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM385 231c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-71-71V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V193.9l-71 71c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 119c9.4-9.4 24.6-9.4 33.9 0L385 231z"
                }
            }
        ]
    })(props);
}
function FaCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaCircleChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
                }
            }
        ]
    })(props);
}
function FaCircleChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
                }
            }
        ]
    })(props);
}
function FaCircleChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
                }
            }
        ]
    })(props);
}
function FaCircleChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
                }
            }
        ]
    })(props);
}
function FaCircleDollarToSlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.7 403.7c-22.1 8-45.9 12.3-70.7 12.3s-48.7-4.4-70.7-12.3c-.3-.1-.5-.2-.8-.3c-30-11-56.8-28.7-78.6-51.4C70 314.6 48 263.9 48 208C48 93.1 141.1 0 256 0S464 93.1 464 208c0 55.9-22 106.6-57.9 144c-1 1-2 2.1-3 3.1c-21.4 21.4-47.4 38.1-76.3 48.6zM256 91.9c-11.1 0-20.1 9-20.1 20.1v6c-5.6 1.2-10.9 2.9-15.9 5.1c-15 6.8-27.9 19.4-31.1 37.7c-1.8 10.2-.8 20 3.4 29c4.2 8.8 10.7 15 17.3 19.5c11.6 7.9 26.9 12.5 38.6 16l2.2 .7c13.9 4.2 23.4 7.4 29.3 11.7c2.5 1.8 3.4 3.2 3.7 4c.3 .8 .9 2.6 .2 6.7c-.6 3.5-2.5 6.4-8 8.8c-6.1 2.6-16 3.9-28.8 1.9c-6-1-16.7-4.6-26.2-7.9l0 0 0 0 0 0c-2.2-.7-4.3-1.5-6.4-2.1c-10.5-3.5-21.8 2.2-25.3 12.7s2.2 21.8 12.7 25.3c1.2 .4 2.7 .9 4.4 1.5c7.9 2.7 20.3 6.9 29.8 9.1V304c0 11.1 9 20.1 20.1 20.1s20.1-9 20.1-20.1v-5.5c5.3-1 10.5-2.5 15.4-4.6c15.7-6.7 28.4-19.7 31.6-38.7c1.8-10.4 1-20.3-3-29.4c-3.9-9-10.2-15.6-16.9-20.5c-12.2-8.8-28.3-13.7-40.4-17.4l-.8-.2c-14.2-4.3-23.8-7.3-29.9-11.4c-2.6-1.8-3.4-3-3.6-3.5c-.2-.3-.7-1.6-.1-5c.3-1.9 1.9-5.2 8.2-8.1c6.4-2.9 16.4-4.5 28.6-2.6c4.3 .7 17.9 3.3 21.7 4.3c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-4.4-1.2-14.4-3.2-21-4.4V112c0-11.1-9-20.1-20.1-20.1zM48 352H64c19.5 25.9 44 47.7 72.2 64H64v32H256 448V416H375.8c28.2-16.3 52.8-38.1 72.2-64h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48z"
                }
            }
        ]
    })(props);
}
function FaCircleDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                }
            }
        ]
    })(props);
}
function FaCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6L269.8 394.5c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5L135.1 294.6c-4.5-4.2-7.1-10.1-7.1-16.3c0-12.3 10-22.3 22.3-22.3l57.7 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 57.7 0c12.3 0 22.3 10 22.3 22.3c0 6.2-2.6 12.1-7.1 16.3z"
                }
            }
        ]
    })(props);
}
function FaCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaCircleH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM368 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H192l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H320V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaCircleHalfStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                }
            }
        ]
    })(props);
}
function FaCircleInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9L117.5 269.8c-3.5-3.8-5.5-8.7-5.5-13.8s2-10.1 5.5-13.8l99.9-107.1c4.2-4.5 10.1-7.1 16.3-7.1c12.3 0 22.3 10 22.3 22.3l0 57.7 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 57.7c0 12.3-10 22.3-22.3 22.3c-6.2 0-12.1-2.6-16.3-7.1z"
                }
            }
        ]
    })(props);
}
function FaCircleMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaCircleNodes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
                }
            }
        ]
    })(props);
}
function FaCircleNotch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
                }
            }
        ]
    })(props);
}
function FaCirclePause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaCirclePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
                }
            }
        ]
    })(props);
}
function FaCirclePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                }
            }
        ]
    })(props);
}
function FaCircleQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaCircleRadiation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM200 256c0-20.7 11.3-38.8 28-48.5l-36-62.3c-8.8-15.3-28.7-20.8-42-9c-25.6 22.6-43.9 53.3-50.9 88.1C95.7 241.5 110.3 256 128 256l72 0zm28 48.5l-36 62.4c-8.8 15.3-3.6 35.2 13.1 40.8c16 5.4 33.1 8.3 50.9 8.3s34.9-2.9 50.9-8.3c16.7-5.6 21.9-25.5 13.1-40.8l-36-62.4c-8.2 4.8-17.8 7.5-28 7.5s-19.8-2.7-28-7.5zM312 256l72 0c17.7 0 32.3-14.5 28.8-31.8c-7-34.8-25.3-65.5-50.9-88.1c-13.2-11.7-33.1-6.3-42 9l-36 62.3c16.7 9.7 28 27.8 28 48.5zm-56 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1l99.9 107.1c3.5 3.8 5.5 8.7 5.5 13.8s-2 10.1-5.5 13.8L294.6 376.9c-4.2 4.5-10.1 7.1-16.3 7.1C266 384 256 374 256 361.7l0-57.7-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-57.7c0-12.3 10-22.3 22.3-22.3c6.2 0 12.1 2.6 16.3 7.1z"
                }
            }
        ]
    })(props);
}
function FaCircleStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4l107.1-99.9c3.8-3.5 8.7-5.5 13.8-5.5s10.1 2 13.8 5.5l107.1 99.9c4.5 4.2 7.1 10.1 7.1 16.3c0 12.3-10 22.3-22.3 22.3H304v96c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V256H150.3C138 256 128 246 128 233.7c0-6.2 2.6-12.1 7.1-16.3z"
                }
            }
        ]
    })(props);
}
function FaCircleUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
                }
            }
        ]
    })(props);
}
function FaCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"
                }
            }
        ]
    })(props);
}
function FaCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48V96H224V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V96H112V24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144v96V464c0 26.5 21.5 48 48 48H304h32 96H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H480V48zm96 320v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM240 416H208c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zM128 400c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM560 256c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zM256 176v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM112 160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32zM256 304c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32zM112 320H80c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16zm304-48v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16zM400 64c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm16 112v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaClapperboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32H361.9l-1 1-127 127h92.1l1-1L453.8 32.3c-1.9-.2-3.8-.3-5.8-.3zm64 128V96c0-15.1-5.3-29.1-14-40l-104 104H512zM294.1 32H201.9l-1 1L73.9 160h92.1l1-1 127-127zM64 32C28.7 32 0 60.7 0 96v64H6.1l1-1 127-127H64zM512 192H0V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192z"
                }
            }
        ]
    })(props);
}
function FaClipboardCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM305 273L177 401c-9.4 9.4-24.6 9.4-33.9 0L79 337c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L271 239c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaClipboardList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaClipboardQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM105.8 229.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L216 328.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V314.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H158.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM160 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaClipboardUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM128 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 432c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaClockRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                }
            }
        ]
    })(props);
}
function FaClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 448H64V224h64V160H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V384H288v64zm-64-96H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64V288c0 35.3 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
                }
            }
        ]
    })(props);
}
function FaCloudArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-167l80 80c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-39 39V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V318.1l-39-39c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaCloudArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 480C64.5 480 0 415.5 0 336c0-62.8 40.2-116.2 96.2-135.9c-.1-2.7-.2-5.4-.2-8.1c0-88.4 71.6-160 160-160c59.3 0 111 32.2 138.7 80.2C409.9 102 428.3 96 448 96c53 0 96 43 96 96c0 12.2-2.3 23.8-6.4 34.6C596 238.4 640 290.1 640 352c0 70.7-57.3 128-128 128H144zm79-217c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V392c0 13.3 10.7 24 24 24s24-10.7 24-24V257.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"
                }
            }
        ]
    })(props);
}
function FaCloudBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224c0 53 43 96 96 96h47.2L290 202.5c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L333.7 320H352h64c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm330.1 3.6c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L177.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H281.9l52.4-104.8c3.4-6.7 1.6-14.9-4.2-19.6z"
                }
            }
        ]
    })(props);
}
function FaCloudMeatball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224c0 53 43 96 96 96h44.7c9.5-23.5 32.5-40 59.3-40c2 0 3.9 .1 5.8 .3C217.6 265.5 235.7 256 256 256s38.4 9.5 50.2 24.3c1.9-.2 3.9-.3 5.8-.3c26.9 0 49.9 16.5 59.3 40H416c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0c1.1-5.2 1.6-10.5 1.6-16c0-44.2-35.8-80-80-80c-24.3 0-46.1 10.9-60.8 28C256.5 24.3 219.1 0 176 0C114.1 0 64 50.1 64 112c0 7.1 .7 14.1 1.9 20.8C27.6 145.4 0 181.5 0 224zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 1 .1 2.1 .1 3.1c-.7-.8-1.4-1.6-2.1-2.3c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c.7 .7 1.5 1.4 2.3 2.1c-1-.1-2.1-.1-3.1-.1c-17.7 0-32 14.3-32 32s14.3 32 32 32c1 0 2.1-.1 3.1-.1c-.8 .7-1.6 1.3-2.3 2.1c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0c.7-.7 1.4-1.5 2.1-2.3c-.1 1-.1 2.1-.1 3.1c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1-.1-2.1-.1-3.1c.7 .8 1.3 1.6 2.1 2.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3c-.7-.7-1.5-1.4-2.3-2.1c1 .1 2.1 .1 3.1 .1c17.7 0 32-14.3 32-32s-14.3-32-32-32c-1 0-2.1 .1-3.1 .1c.8-.7 1.6-1.3 2.3-2.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-.7 .7-1.4 1.5-2.1 2.3c.1-1 .1-2.1 .1-3.1zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaCloudMoonRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 0C417 0 363.5 46.5 353.7 107.6c35.4 17.6 60.2 53.3 62.1 95.1c23.2 11 42 29.7 53.1 52.7c4 .4 8.1 .6 12.3 .6c34.9 0 66.7-13.8 89.9-36.1c5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9 .8-10 1.3-15.2 1.3c-49 0-88.4-39.3-88.4-87.4c0-32.6 18-61.1 44.9-76.1c6.1-3.4 9.3-10.5 7.8-17.4s-7.3-12-14.3-12.6c-3.6-.3-7.3-.5-10.9-.5zM367.9 383.9c44.2 0 80-35.8 80-80c0-39.3-28.4-72.1-65.8-78.7c1.2-5.6 1.9-11.3 1.9-17.2c0-44.2-35.8-80-80-80c-17 0-32.8 5.3-45.8 14.4C241.3 114.6 210.8 96 176 96c-53 0-96 43-96 96l0 1.3c-45.4 7.6-80 47.1-80 94.6c0 53 43 96 96 96H367.9zM85.4 420.1c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3zm96 0c-11-7.4-25.9-4.4-33.3 6.7l-32 48c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c7.4-11 4.4-25.9-6.7-33.3z"
                }
            }
        ]
    })(props);
}
function FaCloudMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495.8 0c5.5 0 10.9 .2 16.3 .7c7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8c0 81 65.5 146.6 146.2 146.6c8.6 0 17-.7 25.1-2.1c6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4c-9.3 0-18.4-.7-27.4-1.9c-11.2-22.6-29.8-40.9-52.6-51.7c-2.7-58.5-50.3-105.3-109.2-106.7c-1.7-10.4-2.6-21-2.6-31.8C304 86.1 389.8 0 495.8 0zM447.9 431.9c0 44.2-35.8 80-80 80H96c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
                }
            }
        ]
    })(props);
}
function FaCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zm-6.8 52c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L89.2 372zm160 0c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3L249.2 372zm124.9 64.6L409.2 372c1.3-2.5 3.9-4 6.8-4s5.4 1.5 6.8 4l35.1 64.6c4.1 7.5 6.2 15.8 6.2 24.3v3c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3c0-8.5 2.1-16.9 6.2-24.3z"
                }
            }
        ]
    })(props);
}
function FaCloudShowersHeavy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 320c-53 0-96-43-96-96c0-42.5 27.6-78.6 65.9-91.2C64.7 126.1 64 119.1 64 112C64 50.1 114.1 0 176 0c43.1 0 80.5 24.3 99.2 60c14.7-17.1 36.5-28 60.8-28c44.2 0 80 35.8 80 80c0 5.5-.6 10.8-1.6 16c.5 0 1.1 0 1.6 0c53 0 96 43 96 96s-43 96-96 96H96zM81.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6S-3.3 490.7 1.9 478.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm120 0c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6zm244.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5zM313.5 353.9c12.2 5.2 17.8 19.3 12.6 31.5l-48 112c-5.2 12.2-19.3 17.8-31.5 12.6s-17.8-19.3-12.6-31.5l48-112c5.2-12.2 19.3-17.8 31.5-12.6z"
                }
            }
        ]
    })(props);
}
function FaCloudShowersWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c38.6 0 71.9 22.8 87.2 55.7C325.7 41.1 345.8 32 368 32c38.7 0 71 27.5 78.4 64H448c35.3 0 64 28.7 64 64s-28.7 64-64 64H128c-35.3 0-64-28.7-64-64s28.7-64 64-64c0-53 43-96 96-96zM140.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm327.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM252.6 292.3l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2s15.1 21.6 8.2 32.9zm103.8-32.9c11.4 6.8 15 21.6 8.2 32.9l-48 80c-6.8 11.4-21.6 15-32.9 8.2s-15.1-21.6-8.2-32.9l48-80c6.8-11.4 21.6-15.1 32.9-8.2zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaCloudSunRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l10.4 62.4c-23.3 10.8-42.9 28.4-56 50.3c-14.6-9-31.8-14.1-50.2-14.1c-53 0-96 43-96 96c0 35.5 19.3 66.6 48 83.2c.8 31.8 13.2 60.7 33.1 82.7l-56 39.2c-4.5 3.1-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM208 144c13.8 0 26.7 4.4 37.1 11.9c-1.2 4.1-2.2 8.3-3 12.6c-37.9 14.6-67.2 46.6-77.8 86.4C151.8 243.1 144 226.5 144 208c0-35.3 28.7-64 64-64zm69.4 276c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm96 0c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7zm74.5-116.1c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
                }
            }
        ]
    })(props);
}
function FaCloudSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 1.2c5.1 2.1 8.7 6.7 9.6 12.1l14.1 84.7 84.7 14.1c5.4 .9 10 4.5 12.1 9.6s1.5 10.9-1.6 15.4l-38.5 55c-2.2-.1-4.4-.2-6.7-.2c-23.3 0-45.1 6.2-64 17.1l0-1.1c0-53-43-96-96-96s-96 43-96 96s43 96 96 96c8.1 0 15.9-1 23.4-2.9c-36.6 18.1-63.3 53.1-69.8 94.9l-24.4 17c-4.5 3.2-10.3 3.8-15.4 1.6s-8.7-6.7-9.6-12.1L98.1 317.9 13.4 303.8c-5.4-.9-10-4.5-12.1-9.6s-1.5-10.9 1.6-15.4L52.5 208 2.9 137.2c-3.2-4.5-3.8-10.3-1.6-15.4s6.7-8.7 12.1-9.6L98.1 98.1l14.1-84.7c.9-5.4 4.5-10 9.6-12.1s10.9-1.5 15.4 1.6L208 52.5 278.8 2.9c4.5-3.2 10.3-3.8 15.4-1.6zM144 208a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM639.9 431.9c0 44.2-35.8 80-80 80H288c-53 0-96-43-96-96c0-47.6 34.6-87 80-94.6l0-1.3c0-53 43-96 96-96c34.9 0 65.4 18.6 82.2 46.4c13-9.1 28.8-14.4 45.8-14.4c44.2 0 80 35.8 80 80c0 5.9-.6 11.7-1.9 17.2c37.4 6.7 65.8 39.4 65.8 78.7z"
                }
            }
        ]
    })(props);
}
function FaCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 336c0 79.5 64.5 144 144 144H512c70.7 0 128-57.3 128-128c0-61.9-44-113.6-102.4-125.4c4.1-10.7 6.4-22.4 6.4-34.6c0-53-43-96-96-96c-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32C167.6 32 96 103.6 96 192c0 2.7 .1 5.4 .2 8.1C40.2 219.8 0 273.2 0 336z"
                }
            }
        ]
    })(props);
}
function FaClover(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.3 32C139.4 32 112 59.4 112 93.3v4.9c0 12 3.3 23.7 9.4 34l18.8 31.3c1.1 1.8 1.2 3.1 1 4.2c-.2 1.2-.8 2.5-2 3.6s-2.4 1.8-3.6 2c-1 .2-2.4 .1-4.2-1l-31.3-18.8c-10.3-6.2-22-9.4-34-9.4H61.3C27.4 144 0 171.4 0 205.3c0 16.2 6.5 31.8 17.9 43.3l1.2 1.2c3.4 3.4 3.4 9 0 12.4l-1.2 1.2C6.5 274.9 0 290.5 0 306.7C0 340.6 27.4 368 61.3 368h4.9c12 0 23.7-3.3 34-9.4l31.3-18.8c1.8-1.1 3.1-1.2 4.2-1c1.2 .2 2.5 .8 3.6 2s1.8 2.4 2 3.6c.2 1 .1 2.4-1 4.2l-18.8 31.3c-6.2 10.3-9.4 22-9.4 34v4.9c0 33.8 27.4 61.3 61.3 61.3c16.2 0 31.8-6.5 43.3-17.9l1.2-1.2c3.4-3.4 9-3.4 12.4 0l1.2 1.2c11.5 11.5 27.1 17.9 43.3 17.9c33.8 0 61.3-27.4 61.3-61.3v-4.9c0-12-3.3-23.7-9.4-34l-18.8-31.3c-1.1-1.8-1.2-3.1-1-4.2c.2-1.2 .8-2.5 2-3.6s2.4-1.8 3.6-2c1-.2 2.4-.1 4.2 1l31.3 18.8c10.3 6.2 22 9.4 34 9.4h4.9c33.8 0 61.3-27.4 61.3-61.3c0-16.2-6.5-31.8-17.9-43.3l-1.2-1.2c-3.4-3.4-3.4-9 0-12.4l1.2-1.2c11.5-11.5 17.9-27.1 17.9-43.3c0-33.8-27.4-61.3-61.3-61.3h-4.9c-12 0-23.7 3.3-34 9.4l-31.3 18.8c-1.8 1.1-3.1 1.2-4.2 1c-1.2-.2-2.5-.8-3.6-2s-1.8-2.4-2-3.6c-.2-1-.1-2.4 1-4.2l18.8-31.3c6.2-10.3 9.4-22 9.4-34V93.3C336 59.4 308.6 32 274.7 32c-16.2 0-31.8 6.5-43.3 17.9l-1.2 1.2c-3.4 3.4-9 3.4-12.4 0l-1.2-1.2C205.1 38.5 189.5 32 173.3 32z"
                }
            }
        ]
    })(props);
}
function FaCodeBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3v87.8c18.8-10.9 40.7-17.1 64-17.1h96c35.3 0 64-28.7 64-64v-6.7C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V160c0 70.7-57.3 128-128 128H176c-35.3 0-64 28.7-64 64v6.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V352 153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaCodeCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C462 361 397.4 416 320 416s-142-55-156.8-128H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H163.2C178 151 242.6 96 320 96s142 55 156.8 128H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H476.8z"
                }
            }
        ]
    })(props);
}
function FaCodeCompare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9v40h16c35.3 0 64-28.7 64-64V153.3C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V320c0 70.7-57.3 128-128 128H320v40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9V128H176c-35.3 0-64 28.7-64 64V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-70.7 57.3-128 128-128h16V24zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
                }
            }
        ]
    })(props);
}
function FaCodeFork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3V192c0 17.7 14.3 32 32 32H304c17.7 0 32-14.3 32-32V153.3C307.7 141 288 112.8 288 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V192c0 53-43 96-96 96H256v70.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V288H144c-53 0-96-43-96-96V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                }
            }
        ]
    })(props);
}
function FaCodeMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2c0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3V358.7C19.7 371 0 399.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V272c26.7 20.1 60 32 96 32h86.7c12.3 28.3 40.5 48 73.3 48c44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48H208c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaCodePullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.8 2.1C314.4 5.9 320 14.5 320 24V64h16c70.7 0 128 57.3 128 128V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V192c0-35.3-28.7-64-64-64H320v40c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1zM104 80A24 24 0 1 0 56 80a24 24 0 1 0 48 0zm8 73.3V358.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3V153.3C19.7 141 0 112.8 0 80C0 35.8 35.8 0 80 0s80 35.8 80 80c0 32.8-19.7 61-48 73.3zM104 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm328 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaCoins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c0 18-14.3 34.6-38.4 48c-29.1 16.1-72.5 27.5-122.3 30.9c-3.7-1.8-7.4-3.5-11.3-5C300.6 137.4 248.2 128 192 128c-8.3 0-16.4 .2-24.5 .6l-1.1-.6C142.3 114.6 128 98 128 80c0-44.2 86-80 192-80S512 35.8 512 80zM160.7 161.1c10.2-.7 20.7-1.1 31.3-1.1c62.2 0 117.4 12.3 152.5 31.4C369.3 204.9 384 221.7 384 240c0 4-.7 7.9-2.1 11.7c-4.6 13.2-17 25.3-35 35.5c0 0 0 0 0 0c-.1 .1-.3 .1-.4 .2l0 0 0 0c-.3 .2-.6 .3-.9 .5c-35 19.4-90.8 32-153.6 32c-59.6 0-112.9-11.3-148.2-29.1c-1.9-.9-3.7-1.9-5.5-2.9C14.3 274.6 0 258 0 240c0-34.8 53.4-64.5 128-75.4c10.5-1.5 21.4-2.7 32.7-3.5zM416 240c0-21.9-10.6-39.9-24.1-53.4c28.3-4.4 54.2-11.4 76.2-20.5c16.3-6.8 31.5-15.2 43.9-25.5V176c0 19.3-16.5 37.1-43.8 50.9c-14.6 7.4-32.4 13.7-52.4 18.5c.1-1.8 .2-3.5 .2-5.3zm-32 96c0 18-14.3 34.6-38.4 48c-1.8 1-3.6 1.9-5.5 2.9C304.9 404.7 251.6 416 192 416c-62.8 0-118.6-12.6-153.6-32C14.3 370.6 0 354 0 336V300.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 342.6 135.8 352 192 352s108.6-9.4 148.1-25.9c7.8-3.2 15.3-6.9 22.4-10.9c6.1-3.4 11.8-7.2 17.2-11.2c1.5-1.1 2.9-2.3 4.3-3.4V304v5.7V336zm32 0V304 278.1c19-4.2 36.5-9.5 52.1-16c16.3-6.8 31.5-15.2 43.9-25.5V272c0 10.5-5 21-14.9 30.9c-16.3 16.3-45 29.7-81.3 38.4c.1-1.7 .2-3.5 .2-5.3zM192 448c56.2 0 108.6-9.4 148.1-25.9c16.3-6.8 31.5-15.2 43.9-25.5V432c0 44.2-86 80-192 80S0 476.2 0 432V396.6c12.5 10.3 27.6 18.7 43.9 25.5C83.4 438.6 135.8 448 192 448z"
                }
            }
        ]
    })(props);
}
function FaColonSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255 39.8c4.3-17.1-6.1-34.5-23.3-38.8S197.2 7.1 193 24.2L181.9 68.6C96.1 87.8 32 164.4 32 256c0 58.1 25.8 110.2 66.7 145.4L81 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l13-52.1c9 3.4 18.4 6.2 28 8.2L177 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l10.4-41.4c33.4-4.4 64.1-17.4 89.8-36.7c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4c-10.2 7.7-21.7 13.9-34 18.3L321 160c9.4-.3 18.5-4.7 24.6-12.8c10.6-14.1 7.8-34.2-6.4-44.8c-1.1-.8-2.2-1.6-3.3-2.4L351 39.8c4.3-17.1-6.1-34.5-23.3-38.8S293.2 7.1 289 24.2L277.2 71.5c-9.3-2.7-18.8-4.6-28.6-5.9L255 39.8zM163.2 143.3L117.3 326.8C103.9 306.5 96 282.2 96 256c0-48.7 27.2-91 67.2-112.7zm8.6 229.5l61.1-244.6c9.9 .7 19.5 2.5 28.7 5.3l-62 248.1c-9.7-1.9-19-4.8-27.8-8.8z"
                }
            }
        ]
    })(props);
}
function FaCommentDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zm20-312v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V344c0 11-9 20-20 20s-20-9-20-20V329.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V136c0-11 9-20 20-20s20 9 20 20z"
                }
            }
        ]
    })(props);
}
function FaCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaCommentMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM224 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V272H176c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
                }
            }
        ]
    })(props);
}
function FaCommentSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L512.9 376.7C552.2 340.2 576 292.3 576 240C576 125.1 461.4 32 320 32c-67.7 0-129.3 21.4-175.1 56.3L38.8 5.1zM64 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c37 0 72.3-6.4 104-17.9L82.9 161.3C70.7 185.6 64 212.2 64 240z"
                }
            }
        ]
    })(props);
}
function FaCommentSms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM202.9 176.8c6.5-2.2 13.7 .1 17.9 5.6L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2zm173.1 38c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.2-.4-23.7-4.4-32.6-7.4l0 0 0 0c-1.4-.5-2.7-.9-4-1.4c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.7 .6 3.3 1.1 4.9 1.6l0 0 0 0c9.1 3.1 15.6 5.3 22.6 5.5c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4c-7.2-2.2-16.7-5-24.3-9.6c-9-5.4-17.7-14.7-17.7-29.4c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c10 .2 19.7 2.3 27.9 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.3-1.9-14.1-3.3-20.1-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9zm-272 0c0 .2 0 .4 0 .4c.1 .1 .6 .8 2.2 1.7c3.9 2.3 9.6 4.1 18.3 6.8l.6 .2c7.4 2.2 17.3 5.2 25.2 10.2c9.1 5.7 17.4 15.2 17.6 29.9c.2 15-7.6 26-17.8 32.3c-9.5 5.9-20.9 7.9-30.7 7.6c-12.3-.4-24.2-4.5-33.2-7.6l0 0 0 0c-1.3-.4-2.5-.8-3.6-1.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.4 .5 2.8 .9 4.1 1.4l0 0 0 0c9.5 3.2 16.5 5.6 23.7 5.8c5.3 .2 10-1 12.8-2.8c1.2-.8 1.8-1.5 2.1-2c.2-.4 .6-1.2 .6-2.7l0-.2c0-.7 0-1.4-2.7-3.1c-3.8-2.4-9.6-4.3-18-6.9l-1.2-.4 0 0c-7.2-2.2-16.7-5-24.3-9.6C80.8 239 72.1 229.7 72 215c-.1-15.2 8.6-25.7 18.5-31.6c9.4-5.5 20.5-7.5 29.7-7.4c9.5 .1 22.2 2.1 31.1 4.4c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-6.6-1.8-16.8-3.3-23.3-3.4c-4.9-.1-9.8 1.1-12.9 2.9c-1.4 .8-2.1 1.6-2.4 2c-.2 .3-.4 .8-.4 1.9z"
                }
            }
        ]
    })(props);
}
function FaComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 240c0 114.9-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4l0 0 0 0 0 0 0 0 .3-.3c.3-.3 .7-.7 1.3-1.4c1.1-1.2 2.8-3.1 4.9-5.7c4.1-5 9.6-12.4 15.2-21.6c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208z"
                }
            }
        ]
    })(props);
}
function FaCommentsDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"
                }
            }
        ]
    })(props);
}
function FaComments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"
                }
            }
        ]
    })(props);
}
function FaCompactDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zM96 240c0-35 17.5-71.1 45.2-98.8S205 96 240 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-45.4 0-89.2 22.3-121.5 54.5S64 194.6 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaCompassDrafting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0 14.3-3.1 27.9-8.8 40.2L396 227.4c-23.7 25.3-54.2 44.1-88.5 53.6L256 192h0 0l-68 117.5c21.5 6.8 44.3 10.5 68.1 10.5c70.7 0 133.8-32.7 174.9-84c11.1-13.8 31.2-16 45-5s16 31.2 5 45C428.1 341.8 347 384 256 384c-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496V440.6c0-8.4 2.2-16.7 6.5-24.1l60-103.7C53.7 301.6 41.8 289.3 31.2 276c-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2c0-53 43-96 96-96s96 43 96 96zm21 297.9c32.6-12.8 62.5-30.8 88.9-52.9l43.7 75.5c4.2 7.3 6.5 15.6 6.5 24.1V496c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9L373 393.9zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V64zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V64zM320 320c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320z"
                }
            }
        ]
    })(props);
}
function FaComputerMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192H176V0H160C71.6 0 0 71.6 0 160v32zm0 32V352c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V224H192 0zm384-32V160C384 71.6 312.4 0 224 0H208V192H384z"
                }
            }
        ]
    })(props);
}
function FaComputer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 96V320H64L64 96H384zM64 32C28.7 32 0 60.7 0 96V320c0 35.3 28.7 64 64 64H181.3l-10.7 32H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H277.3l-10.7-32H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm464 0c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H528zm16 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H544c-8.8 0-16-7.2-16-16zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaCookieBite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9c-.9-5.3-5.3-9.3-10.6-10.1c-51.5-8.2-92.8-47.1-104.5-97.4c-1.8-7.6-8-13.4-15.7-14.6c-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"
                }
            }
        ]
    })(props);
}
function FaCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c31.2 31.2 81.9 31.2 113.1 0c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-50 50-131 50-181 0s-50-131 0-181s131-50 181 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-31.2-31.2-81.9-31.2-113.1 0s-31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function FaCouch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z"
                }
            }
        ]
    })(props);
}
function FaCow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224v32V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V327.8c9.9 6.6 20.6 12 32 16.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16V351.1c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16V343.8c11.4-4 22.1-9.4 32-16.1V416c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256l32 32v49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21c22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5V184c0-13.3-10.7-24-24-24s-24 10.7-24 24v14.4l-52.9-74.1C496 86.5 452.4 64 405.9 64H272 256 192 144C77.7 64 24 117.7 24 184v54C9.4 249.8 0 267.8 0 288v17.6c0 8 6.4 14.4 14.4 14.4C46.2 320 72 294.2 72 262.4V256 224 184c0-24.3 12.1-45.8 30.5-58.9C98.3 135.9 96 147.7 96 160v64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16c0-12.5 10.1-22.6 22.6-22.6H361.4c12.5 0 22.6 10.1 22.6 22.6c0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
                }
            }
        ]
    })(props);
}
function FaCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaCropSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z"
                }
            }
        ]
    })(props);
}
function FaCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 160 64v64l178.7 0L128 338.7V32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H173.3L384 173.3 384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-274.7z"
                }
            }
        ]
    })(props);
}
function FaCross(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c-26.5 0-48 21.5-48 48v80H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H256V48c0-26.5-21.5-48-48-48H176z"
                }
            }
        ]
    })(props);
}
function FaCrosshairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c17.7 0 32 14.3 32 32V42.4c93.7 13.9 167.7 88 181.6 181.6H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H469.6c-13.9 93.7-88 167.7-181.6 181.6V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V469.6C130.3 455.7 56.3 381.7 42.4 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H42.4C56.3 130.3 130.3 56.3 224 42.4V32c0-17.7 14.3-32 32-32zM107.4 288c12.5 58.3 58.4 104.1 116.6 116.6V384c0-17.7 14.3-32 32-32s32 14.3 32 32v20.6c58.3-12.5 104.1-58.4 116.6-116.6H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h20.6C392.1 165.7 346.3 119.9 288 107.4V128c0 17.7-14.3 32-32 32s-32-14.3-32-32V107.4C165.7 119.9 119.9 165.7 107.4 224H128c17.7 0 32 14.3 32 32s-14.3 32-32 32H107.4zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaCrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 0c-48.6 0-88 39.4-88 88v29.2L12.5 390.6c-14 10.8-16.6 30.9-5.9 44.9s30.9 16.6 44.9 5.9L126.1 384H259.2l46.6 113.1c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3L311.1 384H352c1.1 0 2.1 0 3.2 0l46.6 113.2c5 12.3 19.1 18.1 31.3 13.1s18.1-19.1 13.1-31.3l-42-102C484.9 354.1 544 280 544 192V128v-8l80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4C629 52 603.4 32 574 32H523.9C507.7 12.5 483.3 0 456 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"
                }
            }
        ]
    })(props);
}
function FaCrutch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.4 9.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0zm-96 144l-34.8 34.8c-12.9 12.9-21.9 29.2-25.8 47.1L116.8 342.9c-1.3 5.9-4.3 11.4-8.6 15.7L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l98.8-98.8c4.3-4.3 9.7-7.3 15.7-8.6l107.6-23.9c17.8-4 34.1-12.9 47.1-25.8l34.7-34.7c0 0 .1-.1 .1-.1s.1-.1 .1-.1l74.6-74.6-45.3-45.3L336 242.7 269.3 176l52.1-52.1L276.1 78.6l-74.7 74.7zM224 221.3L290.7 288l-12.2 12.2c-4.3 4.3-9.7 7.3-15.7 8.6l-76.7 17 17-76.7c1.3-5.9 4.3-11.4 8.6-15.7L224 221.3z"
                }
            }
        ]
    })(props);
}
function FaCruzeiroSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 256c0-88.4 71.6-160 160-160c41 0 78.3 15.4 106.7 40.7c13.2 11.8 33.4 10.7 45.2-2.5s10.7-33.4-2.5-45.2c-39.6-35.5-92-57-149.3-57C132.3 32 32 132.3 32 256s100.3 224 224 224c57.4 0 109.7-21.6 149.3-57c13.2-11.8 14.3-32 2.5-45.2s-32-14.3-45.2-2.5C334.3 400.6 297 416 256 416V320v-8.7c0-12.8 10.4-23.3 23.3-23.3c4.6 0 9.1 1.4 12.9 3.9l10.1 6.7c14.7 9.8 34.6 5.8 44.4-8.9s5.8-34.6-8.9-44.4l-10.1-6.7c-14.3-9.6-31.2-14.7-48.4-14.7c-12.4 0-24.2 2.6-34.9 7.3c-5.5-4.5-12.6-7.3-20.3-7.3c-17.7 0-32 14.3-32 32v55.3V320v82.7C135.5 378 96 321.6 96 256z"
                }
            }
        ]
    })(props);
}
function FaCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M234.5 5.7c13.9-5 29.1-5 43.1 0l192 68.6C495 83.4 512 107.5 512 134.6V377.4c0 27-17 51.2-42.5 60.3l-192 68.6c-13.9 5-29.1 5-43.1 0l-192-68.6C17 428.6 0 404.5 0 377.4V134.6c0-27 17-51.2 42.5-60.3l192-68.6zM256 66L82.3 128 256 190l173.7-62L256 66zm32 368.6l160-57.1v-188L288 246.6v188z"
                }
            }
        ]
    })(props);
}
function FaCubesStacked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zM82.7 207c-15.3 8.8-20.5 28.4-11.7 43.7l32 55.4c8.8 15.3 28.4 20.5 43.7 11.7l55.4-32c15.3-8.8 20.5-28.4 11.7-43.7l-32-55.4c-8.8-15.3-28.4-20.5-43.7-11.7L82.7 207zM288 192c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H288zm64 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H352zM160 384v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zM32 352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaCubes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.8 48.6l78.4 29.7L288 109.5 206.8 78.3l78.4-29.7c1.8-.7 3.8-.7 5.7 0zM136 92.5V204.7c-1.3 .4-2.6 .8-3.9 1.3l-96 36.4C14.4 250.6 0 271.5 0 294.7V413.9c0 22.2 13.1 42.3 33.5 51.3l96 42.2c14.4 6.3 30.7 6.3 45.1 0L288 457.5l113.5 49.9c14.4 6.3 30.7 6.3 45.1 0l96-42.2c20.3-8.9 33.5-29.1 33.5-51.3V294.7c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-1.3-.5-2.6-.9-3.9-1.3V92.5c0-23.3-14.4-44.1-36.1-52.4l-96-36.4c-12.8-4.8-26.9-4.8-39.7 0l-96 36.4C150.4 48.4 136 69.3 136 92.5zM392 210.6l-82.4 31.2V152.6L392 121v89.6zM154.8 250.9l78.4 29.7L152 311.7 70.8 280.6l78.4-29.7c1.8-.7 3.8-.7 5.7 0zm18.8 204.4V354.8L256 323.2v95.9l-82.4 36.2zM421.2 250.9c1.8-.7 3.8-.7 5.7 0l78.4 29.7L424 311.7l-81.2-31.1 78.4-29.7zM523.2 421.2l-77.6 34.1V354.8L528 323.2v90.7c0 3.2-1.9 6-4.8 7.3z"
                }
            }
        ]
    })(props);
}
function FaD(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32h96c123.7 0 224 100.3 224 224s-100.3 224-224 224H64c-35.3 0-64-28.7-64-64V96zm160 0H64V416h96c88.4 0 160-71.6 160-160s-71.6-160-160-160z"
                }
            }
        ]
    })(props);
}
function FaDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"
                }
            }
        ]
    })(props);
}
function FaDeleteLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaDemocrat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32c0-8.9 3.8-20.9 6.2-27.3C71.2 1.8 74 0 77 0c1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1C175.2 .7 177.1 0 179 0c3 0 5.8 1.8 6.8 4.7c2.4 6.5 6.2 18.4 6.2 27.3c0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8H480l32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17V320H192l-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3h-2C23.9 256 0 232.1 0 202.7c0-12.1 4.1-23.8 11.7-33.3L87.6 74.6C78.1 67.4 64 53.2 64 32zM448 352h96v64 64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V416H288v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416 352h96H448zM260.9 210.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.3-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5zM368.1 208c-2 0-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5c-.9-1.8-2.8-2.9-4.8-2.9zm116.8 2.9c-.9-1.8-2.8-2.9-4.8-2.9s-3.9 1.1-4.8 2.9l-10.5 20.5-23.5 3.3c-2 .3-3.7 1.6-4.3 3.5s-.1 3.9 1.3 5.3l17 16-4 22.6c-.3 1.9 .5 3.9 2.1 5s3.8 1.3 5.6 .4l21-10.7 21 10.7c1.8 .9 4 .8 5.6-.4s2.5-3.1 2.1-5l-4-22.6 17-16c1.5-1.4 2-3.4 1.4-5.3s-2.3-3.2-4.3-3.5l-23.5-3.3-10.5-20.5z"
                }
            }
        ]
    })(props);
}
function FaDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"
                }
            }
        ]
    })(props);
}
function FaDharmachakra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.5 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.5-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaDiagramNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 160c0 35.3-28.7 64-64 64H280v64h46.1c21.4 0 32.1 25.9 17 41L273 399c-9.4 9.4-24.6 9.4-33.9 0L169 329c-15.1-15.1-4.4-41 17-41H232V224H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64v64zM448 416V352H365.3l.4-.4c18.4-18.4 20.4-43.7 11-63.6l71.3 0c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64l71.3 0c-9.4 19.9-7.4 45.2 11 63.6l.4 .4H64v64H210.7l5.7 5.7c21.9 21.9 57.3 21.9 79.2 0l5.7-5.7H448z"
                }
            }
        ]
    })(props);
}
function FaDiagramPredecessor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 416l0-64L64 352l0 64 384 0zm0 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM288 160c0 35.3-28.7 64-64 64L64 224c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l144 0 16 0 144 0c44.2 0 80 35.8 80 80l0 16 38.1 0c21.4 0 32.1 25.9 17 41L433 239c-9.4 9.4-24.6 9.4-33.9 0L329 169c-15.1-15.1-4.4-41 17-41l38.1 0 0-16c0-8.8-7.2-16-16-16l-80 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaDiagramProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48V96H384V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48V160H192v16c0 1.7-.1 3.4-.3 5L272 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V336c0-1.7 .1-3.4 .3-5L144 224H48c-26.5 0-48-21.5-48-48V80z"
                }
            }
        ]
    })(props);
}
function FaDiagramSuccessor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 416l0-64c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64zM64 160l0-64 144 0 16 0 0 64L64 160zm224 0l0-64 80 0c8.8 0 16 7.2 16 16l0 16-38.1 0c-21.4 0-32.1 25.9-17 41L399 239c9.4 9.4 24.6 9.4 33.9 0L503 169c15.1-15.1 4.4-41-17-41L448 128l0-16c0-44.2-35.8-80-80-80L224 32l-16 0L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaDiamondTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm87.6 137c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v56H224c-35.3 0-64 28.7-64 64v48c0 13.3 10.7 24 24 24s24-10.7 24-24V280c0-8.8 7.2-16 16-16h64v56c0 6.5 3.9 12.3 9.9 14.8s12.9 1.1 17.4-3.5l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
                }
            }
        ]
    })(props);
}
function FaDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.3 11.7c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
                }
            }
        ]
    })(props);
}
function FaDiceD20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.7 125.8l53.2 31.9c7.8 4.7 17.8 2 22.2-5.9L201.6 12.1c3-5.4-.9-12.1-7.1-12.1c-1.6 0-3.2 .5-4.6 1.4L47.9 98.8c-9.6 6.6-9.2 20.9 .8 26.9zM16 171.7V295.3c0 8 10.4 11 14.7 4.4l60-92c5-7.6 2.6-17.8-5.2-22.5L40.2 158C29.6 151.6 16 159.3 16 171.7zM310.4 12.1l77.6 139.6c4.4 7.9 14.5 10.6 22.2 5.9l53.2-31.9c10-6 10.4-20.3 .8-26.9L322.1 1.4c-1.4-.9-3-1.4-4.6-1.4c-6.2 0-10.1 6.7-7.1 12.1zM496 171.7c0-12.4-13.6-20.1-24.2-13.7l-45.3 27.2c-7.8 4.7-10.1 14.9-5.2 22.5l60 92c4.3 6.7 14.7 3.6 14.7-4.4V171.7zm-49.3 246L286.1 436.6c-8.1 .9-14.1 7.8-14.1 15.9v52.8c0 3.7 3 6.8 6.8 6.8c.8 0 1.6-.1 2.4-.4l172.7-64c6.1-2.2 10.1-8 10.1-14.5c0-9.3-8.1-16.5-17.3-15.4zM233.2 512c3.7 0 6.8-3 6.8-6.8V452.6c0-8.1-6.1-14.9-14.1-15.9l-160.6-19c-9.2-1.1-17.3 6.1-17.3 15.4c0 6.5 4 12.3 10.1 14.5l172.7 64c.8 .3 1.6 .4 2.4 .4zM41.7 382.9l170.9 20.2c7.8 .9 13.4-7.5 9.5-14.3l-85.7-150c-5.9-10.4-20.7-10.8-27.3-.8L30.2 358.2c-6.5 9.9-.3 23.3 11.5 24.7zm439.6-24.8L402.9 238.1c-6.5-10-21.4-9.6-27.3 .8L290.2 388.5c-3.9 6.8 1.6 15.2 9.5 14.3l170.1-20c11.8-1.4 18-14.7 11.5-24.6zm-216.9 11l78.4-137.2c6.1-10.7-1.6-23.9-13.9-23.9H183.1c-12.3 0-20 13.3-13.9 23.9l78.4 137.2c3.7 6.4 13 6.4 16.7 0zM174.4 176H337.6c12.2 0 19.9-13.1 14-23.8l-80-144c-2.8-5.1-8.2-8.2-14-8.2h-3.2c-5.8 0-11.2 3.2-14 8.2l-80 144c-5.9 10.7 1.8 23.8 14 23.8z"
                }
            }
        ]
    })(props);
}
function FaDiceD6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201 10.3c14.3-7.8 31.6-7.8 46 0L422.3 106c5.1 2.8 8.3 8.2 8.3 14s-3.2 11.2-8.3 14L231.7 238c-4.8 2.6-10.5 2.6-15.3 0L25.7 134c-5.1-2.8-8.3-8.2-8.3-14s3.2-11.2 8.3-14L201 10.3zM23.7 170l176 96c5.1 2.8 8.3 8.2 8.3 14V496c0 5.6-3 10.9-7.8 13.8s-10.9 3-15.8 .3L25 423.1C9.6 414.7 0 398.6 0 381V184c0-5.6 3-10.9 7.8-13.8s10.9-3 15.8-.3zm400.7 0c5-2.7 11-2.6 15.8 .3s7.8 8.1 7.8 13.8V381c0 17.6-9.6 33.7-25 42.1L263.7 510c-5 2.7-11 2.6-15.8-.3s-7.8-8.1-7.8-13.8V280c0-5.9 3.2-11.2 8.3-14l176-96z"
                }
            }
        ]
    })(props);
}
function FaDiceFive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaDiceFour(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaDiceOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaDiceSix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaDiceThree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaDiceTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaDice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.9 34.3c-28.1-28.1-73.7-28.1-101.8 0L34.3 173.1c-28.1 28.1-28.1 73.7 0 101.8L173.1 413.7c28.1 28.1 73.7 28.1 101.8 0L413.7 274.9c28.1-28.1 28.1-73.7 0-101.8L274.9 34.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM352 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 120a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm96 328c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H461.7c11.6 36 3.1 77-25.4 105.5L320 413.8V448zM480 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaDisease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M236.4 61.4L227 75.5c-21.3 32-59.4 48.5-97.3 42.1l-59.6-9.9C33.4 101.6 0 129.9 .1 167.1c0 15.9 6.4 31.2 17.6 42.5l29.2 29.2c11 11 17.2 25.9 17.2 41.5c0 15.8-6.4 30.9-17.7 42L33.3 335.1C22.2 345.9 16 360.7 16 376.2c0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6h10c27.2 0 53.7 9.3 75 26.3L287.8 467c10.5 8.4 23.6 13 37 13c32.7 0 59.3-26.5 59.3-59.3l0-25.2c0-34.9 21.4-66.2 53.9-78.8l36.9-14.3c22.4-8.7 37.2-30.3 37.2-54.3c0-28.1-20.1-52.3-47.8-57.3l-28-5.1c-36.5-6.7-65.4-34.5-73.6-70.7l-7.1-31.5C348.9 53.4 322.1 32 291.3 32c-22 0-42.6 11-54.9 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm0 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaDisplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V352H64V64H512z"
                }
            }
        ]
    })(props);
}
function FaDivide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 320a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM400 288c17.7 0 32-14.3 32-32s-14.3-32-32-32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H400z"
                }
            }
        ]
    })(props);
}
function FaDna(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c17.7 0 32 14.3 32 32c0 59.8-30.3 107.5-69.4 146.6c-28 28-62.5 53.5-97.3 77.4l-2.5 1.7c-11.9 8.1-23.8 16.1-35.5 23.9l0 0 0 0 0 0-1.6 1c-6 4-11.9 7.9-17.8 11.9c-20.9 14-40.8 27.7-59.3 41.5H283.3c-9.8-7.4-20.1-14.7-30.7-22.1l7-4.7 3-2c15.1-10.1 30.9-20.6 46.7-31.6c25 18.1 48.9 37.3 69.4 57.7C417.7 372.5 448 420.2 448 480c0 17.7-14.3 32-32 32s-32-14.3-32-32H64c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-59.8 30.3-107.5 69.4-146.6c28-28 62.5-53.5 97.3-77.4c-34.8-23.9-69.3-49.3-97.3-77.4C30.3 139.5 0 91.8 0 32C0 14.3 14.3 0 32 0S64 14.3 64 32H384c0-17.7 14.3-32 32-32zM338.6 384H109.4c-10.1 10.6-18.6 21.3-25.5 32H364.1c-6.8-10.7-15.3-21.4-25.5-32zM109.4 128H338.6c10.1-10.7 18.6-21.3 25.5-32H83.9c6.8 10.7 15.3 21.3 25.5 32zm55.4 48c18.4 13.8 38.4 27.5 59.3 41.5c20.9-14 40.8-27.7 59.3-41.5H164.7z"
                }
            }
        ]
    })(props);
}
function FaDog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.6 158.5L332.7 19.8C334.6 8.4 344.5 0 356.1 0c7.5 0 14.5 3.5 19 9.5L392 32h52.1c12.7 0 24.9 5.1 33.9 14.1L496 64h56c13.3 0 24 10.7 24 24v24c0 44.2-35.8 80-80 80H464 448 426.7l-5.1 30.5-112-64zM416 256.1L416 480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V364.8c-24 12.3-51.2 19.2-80 19.2s-56-6.9-80-19.2V480c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V249.8c-28.8-10.9-51.4-35.3-59.2-66.5L1 167.8c-4.3-17.1 6.1-34.5 23.3-38.8s34.5 6.1 38.8 23.3l3.9 15.5C70.5 182 83.3 192 98 192h30 16H303.8L416 256.1zM464 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaDollarSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c17.7 0 32 14.3 32 32V67.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.1c-.4-.1-.9-.1-1.3-.2l-.2 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaDolly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0h72.9c27.5 0 52 17.6 60.7 43.8L257.7 320c30.1 .5 56.8 14.9 74 37l202.1-67.4c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L352 417.7c-.9 52.2-43.5 94.3-96 94.3c-53 0-96-43-96-96c0-30.8 14.5-58.2 37-75.8L104.9 64H32C14.3 64 0 49.7 0 32zM244.8 134.5c-5.5-16.8 3.7-34.9 20.5-40.3L311 79.4l19.8 60.9 60.9-19.8L371.8 59.6l45.7-14.8c16.8-5.5 34.9 3.7 40.3 20.5l49.4 152.2c5.5 16.8-3.7 34.9-20.5 40.3L334.5 307.2c-16.8 5.5-34.9-3.7-40.3-20.5L244.8 134.5z"
                }
            }
        ]
    })(props);
}
function FaDongSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c-17.7 0-32 14.3-32 32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v49.1c-18.8-10.9-40.7-17.1-64-17.1c-70.7 0-128 57.3-128 128s57.3 128 128 128c24.5 0 47.4-6.9 66.8-18.8c5 11.1 16.2 18.8 29.2 18.8c17.7 0 32-14.3 32-32V288 128c17.7 0 32-14.3 32-32s-14.3-32-32-32c0-17.7-14.3-32-32-32zM128 288a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaDoorClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V448h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H432 144 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96V64zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaDoorOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 32c0-9.9-4.5-19.2-12.3-25.2S289.8-1.4 280.2 1l-179.9 45C79 51.3 64 70.5 64 92.5V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 288h32V480 32zM256 256c0 17.7-10.7 32-24 32s-24-14.3-24-32s10.7-32 24-32s24 14.3 24 32zm96-128h96V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V128c0-35.3-28.7-64-64-64H352v64z"
                }
            }
        ]
    })(props);
}
function FaDove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160.8 96.5c14 17 31 30.9 49.5 42.2c25.9 15.8 53.7 25.9 77.7 31.6V138.8C265.8 108.5 250 71.5 248.6 28c-.4-11.3-7.5-21.5-18.4-24.4c-7.6-2-15.8-.2-21 5.8c-13.3 15.4-32.7 44.6-48.4 87.2zM320 144v30.6l0 0v1.3l0 0 0 32.1c-60.8-5.1-185-43.8-219.3-157.2C97.4 40 87.9 32 76.6 32c-7.9 0-15.3 3.9-18.8 11C46.8 65.9 32 112.1 32 176c0 116.9 80.1 180.5 118.4 202.8L11.8 416.6C6.7 418 2.6 421.8 .9 426.8s-.8 10.6 2.3 14.8C21.7 466.2 77.3 512 160 512c3.6 0 7.2-1.2 10-3.5L245.6 448H320c88.4 0 160-71.6 160-160V128l29.9-44.9c1.3-2 2.1-4.4 2.1-6.8c0-6.8-5.5-12.3-12.3-12.3H400c-44.2 0-80 35.8-80 80zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                }
            }
        ]
    })(props);
}
function FaDownLeftAndUpRightToCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H296c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39L439 7zM72 272H216c13.3 0 24 10.7 24 24V440c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39L73 505c-9.4 9.4-24.6 9.4-33.9 0L7 473c-9.4-9.4-9.4-24.6 0-33.9l87-87L55 313c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8z"
                }
            }
        ]
    })(props);
}
function FaDownLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 334.5c-3.8 8.8-2 19 4.6 26l136 144c4.5 4.8 10.8 7.5 17.4 7.5s12.9-2.7 17.4-7.5l136-144c6.6-7 8.4-17.2 4.6-26s-12.5-14.5-22-14.5l-72 0 0-288c0-17.7-14.3-32-32-32L128 0C110.3 0 96 14.3 96 32l0 288-72 0c-9.6 0-18.2 5.7-22 14.5z"
                }
            }
        ]
    })(props);
}
function FaDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaDragon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4L294.4 28.8c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0H416h32 16c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8c0 26.5-21.5 48-48 48H538.5c-17 0-33.3-6.7-45.3-18.7L480 160H448v21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1C640 462.9 590.9 512 530.2 512H496 432 32.3c-3.3 0-6.6-.4-9.6-1.4C13.5 507.8 6 501 2.4 492.1C1 488.7 .2 485.2 0 481.4c-.2-3.7 .3-7.3 1.3-10.7c2.8-9.2 9.6-16.7 18.6-20.4c3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1c0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1V181.5v-57zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3v.6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9c0 13.3 10.7 24 24 24c10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87V227c0 32.8 8.4 64.8 24 93H112c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9s-1.5-14.1 3.8-18.8L130.9 116.5z"
                }
            }
        ]
    })(props);
}
function FaDrawPolygon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"
                }
            }
        ]
    })(props);
}
function FaDropletSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 512c53.2 0 101.4-21.6 136.1-56.6l-298.3-235C140 257.1 128 292.3 128 320c0 106 86 192 192 192zM505.2 370.7c4.4-16.1 6.8-33.1 6.8-50.7c0-91.2-130.2-262.3-166.6-308.3C339.4 4.2 330.5 0 320.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C277.8 33 240.7 81.3 205.8 136L38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L505.2 370.7zM224 336c0 44.2 35.8 80 80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16c-61.9 0-112-50.1-112-112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
                }
            }
        ]
    })(props);
}
function FaDrumSteelpan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c159.1 0 288 48 288 128V352c0 80-128.9 128-288 128S0 432 0 352V160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8c-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4c0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5c47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4C56 130.1 48 150.1 48 160s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5c0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8C224.5 87 224 91.5 224 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2C330.8 81 309.8 80 288 80s-42.8 1-62.6 2.8z"
                }
            }
        ]
    })(props);
}
function FaDrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96C114.6 96 0 128 0 208V368c0 31.3 27.4 58.8 72 78.7V344c0-13.3 10.7-24 24-24s24 10.7 24 24V463.4c33 8.9 71.1 14.5 112 16.1V376c0-13.3 10.7-24 24-24s24 10.7 24 24V479.5c40.9-1.6 79-7.2 112-16.1V344c0-13.3 10.7-24 24-24s24 10.7 24 24V446.7c44.6-19.9 72-47.4 72-78.7V208c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5C458.4 181.8 464 197.4 464 208c0 .8-2.7 17.2-46 35.9C379.1 260.7 322 272 256 272s-123.1-11.3-162-28.1C50.7 225.2 48 208.8 48 208c0-10.6 5.6-26.2 44.4-41.3C130.6 151.9 187.8 144 256 144c18 0 35.1 .5 51.4 1.6z"
                }
            }
        ]
    })(props);
}
function FaDrumstickBite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2C69.8 320.6 65 320 60 320c-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12c0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5c-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4H336c6.3 0 12.4-.3 18.5-1c11.9-1.2 16.4-15.5 10.8-26c-8.5-15.8-13.3-33.8-13.3-53c0-61.9 50.1-112 112-112c8 0 15.7 .8 23.2 2.4c11.7 2.5 24.1-5.9 22-17.6C494.5 62.5 422.5 0 336 0C238.8 0 160 78.8 160 176v89.2z"
                }
            }
        ]
    })(props);
}
function FaDumbbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V224v64V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H96V64zm448 0v64h32c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32v64c0 17.7-14.3 32-32 32H544v64c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32V288 224 64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zM416 224v64H224V224H416z"
                }
            }
        ]
    })(props);
}
function FaDumpsterFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0h58c15.1-18.1 32.1-35.7 50.5-52.1c1.5-1.4 3.2-2.6 4.8-3.8L402.9 32H304V160zm209.9-23.7c17.4-15.8 43.9-16.2 61.7-1.2c-.1-.7-.3-1.4-.5-2.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l12.8 64.2c9.6 1 19 4.9 26.6 11.8c11.7 10.6 23 21.6 33.9 33.1c1.6-1.6 3.3-3.2 5-4.8zM325.2 210.7c3.8-6.2 7.9-12.5 12.3-18.7H32l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H337.6c-31-34.7-49.6-80.6-49.6-129.9c0-35.2 16.3-73.6 37.2-107.4zm128.4-78.9c-2.8-2.5-6.3-3.7-9.8-3.8c-3.6 0-7.2 1.2-10 3.7c-33.2 29.7-61.4 63.4-81.4 95.8c-19.7 31.9-32.4 66.2-32.4 92.6C320 407.9 390.3 480 480 480c88.7 0 160-72 160-159.8c0-20.2-9.6-50.9-24.2-79c-14.8-28.5-35.7-58.5-60.4-81.1c-5.6-5.1-14.4-5.2-20 0c-9.6 8.8-18.6 19.6-26.5 29.5c-17.3-20.7-35.8-39.9-55.5-57.7zM530 401c-15 10-31 15-49 15c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96z"
                }
            }
        ]
    })(props);
}
function FaDumpster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M49.7 32c-10.5 0-19.8 6.9-22.9 16.9L.9 133c-.6 2-.9 4.1-.9 6.1C0 150.7 9.3 160 20.9 160h94L140.5 32H49.7zM272 160V32H173.1L147.5 160H272zm32 0H428.5L402.9 32H304V160zm157.1 0h94c11.5 0 20.9-9.3 20.9-20.9c0-2.1-.3-4.1-.9-6.1L549.2 48.9C546.1 38.9 536.8 32 526.3 32H435.5l25.6 128zM32 192l4 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H44L64 448c0 17.7 14.3 32 32 32s32-14.3 32-32H448c0 17.7 14.3 32 32 32s32-14.3 32-32l20-160h12c17.7 0 32-14.3 32-32s-14.3-32-32-32h-4l4-32H32z"
                }
            }
        ]
    })(props);
}
function FaDungeon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.6 156.5c1.3 1.1 2.7 2.2 3.9 3.3c9.3 8.2 23 10.5 33.4 3.6l67.6-45.1c11.4-7.6 14.2-23.2 5.1-33.4C430 66.6 410.9 50.6 389.7 37.6c-11.9-7.3-26.9-1.4-32.1 11.6l-30.5 76.2c-4.5 11.1 .2 23.6 9.5 31.2zM328 36.8c5.1-12.8-1.6-27.4-15-30.5C294.7 2.2 275.6 0 256 0s-38.7 2.2-57 6.4C185.5 9.4 178.8 24 184 36.8l30.3 75.8c4.5 11.3 16.8 17.2 29 16c4.2-.4 8.4-.6 12.7-.6s8.6 .2 12.7 .6c12.1 1.2 24.4-4.7 29-16L328 36.8zM65.5 85c-9.1 10.2-6.3 25.8 5.1 33.4l67.6 45.1c10.3 6.9 24.1 4.6 33.4-3.6c1.3-1.1 2.6-2.3 4-3.3c9.3-7.5 13.9-20.1 9.5-31.2L154.4 49.2c-5.2-12.9-20.3-18.8-32.1-11.6C101.1 50.6 82 66.6 65.5 85zm314 137.1c.9 3.3 1.7 6.6 2.3 10c2.5 13 13 23.9 26.2 23.9h80c13.3 0 24.1-10.8 22.9-24c-2.5-27.2-9.3-53.2-19.7-77.3c-5.5-12.9-21.4-16.6-33.1-8.9l-68.6 45.7c-9.8 6.5-13.2 19.2-10 30.5zM53.9 145.8c-11.6-7.8-27.6-4-33.1 8.9C10.4 178.8 3.6 204.8 1.1 232c-1.2 13.2 9.6 24 22.9 24h80c13.3 0 23.8-10.8 26.2-23.9c.6-3.4 1.4-6.7 2.3-10c3.1-11.4-.2-24-10-30.5L53.9 145.8zM104 288H24c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24zm304 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V312c0-13.3-10.7-24-24-24H408zM24 416c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H24zm384 0c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V440c0-13.3-10.7-24-24-24H408zM272 192c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
                }
            }
        ]
    })(props);
}
function FaE(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V256 416c0 35.3 28.7 64 64 64H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
                }
            }
        ]
    })(props);
}
function FaEarDeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5c-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3C74.8 132.5 149.4 64 240 64c97.2 0 176 78.8 176 176c0 46-17.7 87.9-46.6 119.3c-12 13-17.4 24.8-17.4 34.7V400c0 61.9-50.1 112-112 112c-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48v-6.1c0-32.9 17.4-59.6 34.4-78c18.4-20 29.6-46.6 29.6-75.9c0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaEarListen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.3 3.4c-15.8-7.9-35-1.5-42.9 14.3c-7.9 15.8-1.5 34.9 14.2 42.9l.4 .2c.4 .2 1.1 .6 2.1 1.2c2 1.2 5 3 8.7 5.6c7.5 5.2 17.6 13.2 27.7 24.2C428.5 113.4 448 146 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7C441.6 33.2 427.7 22.2 417.3 15c-5.3-3.7-9.7-6.4-13-8.3c-1.6-1-3-1.7-4-2.2c-.5-.3-.9-.5-1.2-.7l-.4-.2-.2-.1-.1 0 0 0c0 0 0 0-14.3 28.6L398.3 3.4zM128.7 227.5c6.2-56 53.7-99.5 111.3-99.5c61.9 0 112 50.1 112 112c0 29.3-11.2 55.9-29.6 75.9c-17 18.4-34.4 45.1-34.4 78V400c0 26.5-21.5 48-48 48c-17.7 0-32 14.3-32 32s14.3 32 32 32c61.9 0 112-50.1 112-112v-6.1c0-9.8 5.4-21.7 17.4-34.7C398.3 327.9 416 286 416 240c0-97.2-78.8-176-176-176C149.4 64 74.8 132.5 65.1 220.5c-1.9 17.6 10.7 33.4 28.3 35.3s33.4-10.7 35.3-28.3zM32 512a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM192 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0zM208 240c0-17.7 14.3-32 32-32s32 14.3 32 32c0 13.3 10.7 24 24 24s24-10.7 24-24c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 13.3 10.7 24 24 24s24-10.7 24-24z"
                }
            }
        ]
    })(props);
}
function FaEarthAfrica(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177.8 63.2l10 17.4c2.8 4.8 4.2 10.3 4.2 15.9v41.4c0 3.9 1.6 7.7 4.3 10.4c6.2 6.2 16.5 5.7 22-1.2l13.6-17c4.7-5.9 12.9-7.7 19.6-4.3l15.2 7.6c3.4 1.7 7.2 2.6 11 2.6c6.5 0 12.8-2.6 17.4-7.2l3.9-3.9c2.9-2.9 7.3-3.6 11-1.8l29.2 14.6c7.8 3.9 12.6 11.8 12.6 20.5c0 10.5-7.1 19.6-17.3 22.2l-35.4 8.8c-7.4 1.8-15.1 1.5-22.4-.9l-32-10.7c-3.3-1.1-6.7-1.7-10.2-1.7c-7 0-13.8 2.3-19.4 6.5L176 212c-10.1 7.6-16 19.4-16 32v28c0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16v48c0 17.7 14.3 32 32 32c10.1 0 19.6-4.7 25.6-12.8l25.6-34.1c8.3-11.1 12.8-24.6 12.8-38.4V318.6c0-3.9 2.6-7.3 6.4-8.2l5.3-1.3c11.9-3 20.3-13.7 20.3-26c0-7.1-2.8-13.9-7.8-18.9l-33.5-33.5c-3.7-3.7-3.7-9.7 0-13.4c5.7-5.7 14.1-7.7 21.8-5.1l14.1 4.7c12.3 4.1 25.7-1.5 31.5-13c3.5-7 11.2-10.8 18.9-9.2l27.4 5.5C432 112.4 351.5 48 256 48c-27.7 0-54 5.4-78.2 15.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                }
            }
        ]
    })(props);
}
function FaEarthAmericas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M57.7 193l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5v39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9v39c0 15.6 14.9 26.9 29.9 22.6c16.1-4.6 28.6-17.5 32.7-33.8l2.8-11.2c4.2-16.9 15.2-31.4 30.3-40l8.1-4.6c15-8.5 24.2-24.5 24.2-41.7v-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1H257c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c-3.5-.2-6.9-.3-10.4-.3C163.1 48 84.4 108.9 57.7 193zM464 256c0-36.8-9.6-71.4-26.4-101.5L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3c1.2-9 1.8-18.2 1.8-27.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                }
            }
        ]
    })(props);
}
function FaEarthAsia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M51.7 295.1l31.7 6.3c7.9 1.6 16-.9 21.7-6.6l15.4-15.4c11.6-11.6 31.1-8.4 38.4 6.2l9.3 18.5c4.8 9.6 14.6 15.7 25.4 15.7c15.2 0 26.1-14.6 21.7-29.2l-6-19.9c-4.6-15.4 6.9-30.9 23-30.9h2.3c13.4 0 25.9-6.7 33.3-17.8l10.7-16.1c5.6-8.5 5.3-19.6-.8-27.7l-16.1-21.5c-10.3-13.7-3.3-33.5 13.4-37.7l17-4.3c7.5-1.9 13.6-7.2 16.5-14.4l16.4-40.9C303.4 52.1 280.2 48 256 48C141.1 48 48 141.1 48 256c0 13.4 1.3 26.5 3.7 39.1zm407.7 4.6c-3-.3-6-.1-9 .8l-15.8 4.4c-6.7 1.9-13.8-.9-17.5-6.7l-2-3.1c-6-9.4-16.4-15.1-27.6-15.1s-21.6 5.7-27.6 15.1l-6.1 9.5c-1.4 2.2-3.4 4.1-5.7 5.3L312 330.1c-18.1 10.1-25.5 32.4-17 51.3l5.5 12.4c8.6 19.2 30.7 28.5 50.5 21.1l2.6-1c10-3.7 21.3-2.2 29.9 4.1l1.5 1.1c37.2-29.5 64.1-71.4 74.4-119.5zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm144.5 92.1c-2.1 8.6 3.1 17.3 11.6 19.4l32 8c8.6 2.1 17.3-3.1 19.4-11.6s-3.1-17.3-11.6-19.4l-32-8c-8.6-2.1-17.3 3.1-19.4 11.6zm92-20c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l8-32c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-8 32zM343.2 113.7c-7.9-4-17.5-.7-21.5 7.2l-16 32c-4 7.9-.7 17.5 7.2 21.5s17.5 .7 21.5-7.2l16-32c4-7.9 .7-17.5-7.2-21.5z"
                }
            }
        ]
    })(props);
}
function FaEarthEurope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1v9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1h1c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24v4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H379.3c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3h11.3c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16H454c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4H251.4c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3v3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3H248c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaEarthOceania(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208.6 357.3l-39-13.5c-6.5-2.2-13.6-2.3-20.1-.3l-15.3 4.9c-18.5 5.9-38.5-2.4-47.5-19.5l-3.3-6.2c-10.6-20.1-2.3-45 18.2-54.7l35.3-16.8c2.3-1.1 4.4-2.8 5.9-4.8l5.3-7c7.2-9.6 18.6-15.3 30.6-15.3s23.4 5.7 30.6 15.3l4.6 6.1c2 2.6 4.9 4.5 8.1 5.1c7.8 1.6 15.7-1.5 20.4-7.9l10.4-14.2c2-2.8 5.3-4.4 8.7-4.4c4.4 0 8.4 2.7 10 6.8l10.1 25.9c2.8 7.2 6.7 14 11.5 20.2L311 299.8c5.8 7.4 9 16.6 9 26s-3.2 18.6-9 26L299 367.2c-8.3 10.6-21 16.8-34.4 16.8c-8.4 0-16.6-2.4-23.7-7l-25.4-16.4c-2.2-1.4-4.5-2.5-6.9-3.4zm65.2-214.8L296 164.7c10.1 10.1 2.9 27.3-11.3 27.3H254.8c-5.6 0-11.1-1.2-16.2-3.4l-42.8-19c-14.3-6.3-11.9-27.3 3.4-30.3l38.5-7.7c13.1-2.6 26.7 1.5 36.1 10.9zM248 432c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H264c-8.8 0-16-7.2-16-16zM431.2 298.9l8 24c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-8-24c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1zm-19.9 80.4l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496C86 496 0 394 0 288C0 176 64 16 192 16s192 160 192 272c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C69.7 226.1 64 259.7 64 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8c10.1-28.5 25-54.1 43.7-71.2z"
                }
            }
        ]
    })(props);
}
function FaEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48z"
                }
            }
        ]
    })(props);
}
function FaElevator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.7 4.7l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9H208c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H64zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V400zm192 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v16c0 17.7-14.3 32-32 32H304c-17.7 0-32-14.3-32-32V400zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM356.7 91.3c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5 0 432 0H304c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64z"
                }
            }
        ]
    })(props);
}
function FaEllipsisVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 128 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
                }
            }
        ]
    })(props);
}
function FaEllipsis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0l57.4-43c23.9-59.8 79.7-103.3 146.3-109.8l13.9-10.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176V384c0 35.3 28.7 64 64 64H360.2C335.1 417.6 320 378.5 320 336c0-5.6 .3-11.1 .8-16.6l-26.4 19.8zM640 336a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 353.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeOpenText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 208.1L256 65.9 448 208.1v47.4L289.5 373c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64 255.5V208.1zM256 0c-12.1 0-23.8 3.9-33.5 11L25.9 156.7C9.6 168.8 0 187.8 0 208.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V208.1c0-20.3-9.6-39.4-25.9-51.4L289.5 11C279.8 3.9 268.1 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"
                }
            }
        ]
    })(props);
}
function FaEnvelopesBulk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C110.3 0 96 14.3 96 32V224h96V192c0-35.3 28.7-64 64-64H480V32c0-17.7-14.3-32-32-32H128zM256 160c-17.7 0-32 14.3-32 32v32h96c35.3 0 64 28.7 64 64V416H576c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256zm240 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H496c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM64 256c-17.7 0-32 14.3-32 32v13L187.1 415.9c1.4 1 3.1 1.6 4.9 1.6s3.5-.6 4.9-1.6L352 301V288c0-17.7-14.3-32-32-32H64zm288 84.8L216 441.6c-6.9 5.1-15.3 7.9-24 7.9s-17-2.8-24-7.9L32 340.8V480c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V340.8z"
                }
            }
        ]
    })(props);
}
function FaEquals(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 128c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z"
                }
            }
        ]
    })(props);
}
function FaEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H288h9.4H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H387.9L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416H288l-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
                }
            }
        ]
    })(props);
}
function FaEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224V416c0 17.7 14.3 32 32 32H96V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64V336c0-8.8 7.2-16 16-16s16 7.2 16 16V448h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H448V160c0-17.7-14.3-32-32-32H384V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v32H96c-17.7 0-32 14.3-32 32v32H32c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaEuroSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.1 240c-.1 2.7-.1 5.3-.1 8v16c0 2.7 0 5.3 .1 8H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H60.3C89.9 419.9 170 480 264 480h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264c-57.9 0-108.2-32.4-133.9-80H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c-.1-2.6-.2-5.3-.2-8V248c0-2.7 .1-5.4 .2-8H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c25.7-47.6 76-80 133.9-80h24c17.7 0 32-14.3 32-32s-14.3-32-32-32H264C170 32 89.9 92.1 60.3 176H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48.1z"
                }
            }
        ]
    })(props);
}
function FaExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 64 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V64zM32 480a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                }
            }
        ]
    })(props);
}
function FaExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"
                }
            }
        ]
    })(props);
}
function FaExplosion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L404.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87H378.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H117.8L42.3 363.7c-9.7-6.7-13.1-19.6-7.9-30.3s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.7 9.4-11.3L107.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L246 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7s22.7 9.4 23.9 21.7l13.5 141.9L499.6 11.3zM64 448v0H512v0h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64zM288 0c13.3 0 24 10.7 24 24V72c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaEyeDropper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.6 29.2L240.1 130.8l-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4L482.8 170.4c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6v42.4L5.4 462.2c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4L89.7 480h42.4c21.2 0 41.6-8.4 56.6-23.4L309.4 335.9l-45.3-45.3L143.4 411.3c-3 3-7.1 4.7-11.3 4.7H96V379.9c0-4.2 1.7-8.3 4.7-11.3L221.4 247.9l-45.3-45.3L55.4 323.3z"
                }
            }
        ]
    })(props);
}
function FaEyeLowVision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223 149.5c48.6-44.3 123-50.8 179.3-11.7c60.8 42.4 78.9 123.2 44.2 186.9L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3L223 149.5zm223.1 298L83.1 161.5c-11 14.4-20.5 28.7-28.4 42.2l339 265.7c18.7-5.5 36.2-13 52.6-21.8zM34.5 268.3c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c3.1 0 6.1-.1 9.2-.2L33.1 247.8c-1.8 6.8-1.3 14 1.4 20.5z"
                }
            }
        ]
    })(props);
}
function FaEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"
                }
            }
        ]
    })(props);
}
function FaEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"
                }
            }
        ]
    })(props);
}
function FaF(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V256 448c0 17.7 14.3 32 32 32s32-14.3 32-32V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H64z"
                }
            }
        ]
    })(props);
}
function FaFaceAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM338.7 395.9c6.6-5.9 7.1-16 1.2-22.6C323.8 355.4 295.7 336 256 336s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                }
            }
        ]
    })(props);
}
function FaFaceDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-224a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0L160 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L137.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0L352 169.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L329.4 192l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaFaceFlushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM176 384c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm-16-88a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaFaceFrownOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-122 174.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
                }
            }
        ]
    })(props);
}
function FaFaceFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.3 388.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm96-112h-8V360l55.3 0c-3.8 22.7-23.6 40-47.3 40zm47.3-56L344 344V304h8c23.8 0 43.5 17.3 47.3 40zM328 344H264V304h64v40zm0 56H264V360h64v40zm-80-96v40l-64 0V304h64zm0 56v40H184V360l64 0zm-80-16H112.7c3.8-22.7 23.6-40 47.3-40h8v40zm0 56h-8c-23.8 0-43.5-17.3-47.3-40H168v40zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinBeamSweat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 126.3c-4.1 1.1-8.4 1.7-12.8 1.7c-26.5 0-48-21-48-47c0-5 1.8-11.3 4.6-18.1c.3-.7 .6-1.4 .9-2.1c9-20.2 26.5-44.9 36-57.5c3.2-4.4 9.6-4.4 12.8 0C483.4 20.6 512 61 512 81c0 21.7-14.9 39.8-35.2 45.3zM256 0c51.4 0 99.3 15.2 139.4 41.2c-1.5 3.1-3 6.2-4.3 9.3c-3.4 8-7.1 19-7.1 30.5c0 44.3 36.6 79 80 79c9.6 0 18.8-1.7 27.4-4.8c13.3 30.9 20.6 65 20.6 100.8c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0zM383.8 317.8C345.3 329.4 301.9 336 256 336s-89.3-6.6-127.8-18.2c-12.3-3.7-24.3 7-19.2 18.7c24.5 56.9 81.1 96.7 147 96.7s122.5-39.8 147-96.7c5.1-11.8-6.9-22.4-19.2-18.7zm-166.2-89l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0zm160 0l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-170.5-84l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM199.3 129.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm154.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinSquintTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-6.8 6.8-21.4 12.4-37.4 16.7c-16.3 4.4-34.1 7.5-46.3 9.3c-1.6 .2-3.1 .5-4.6 .6c-4.9 .8-9.1-2.8-9.5-7.4c-.1-.7 0-1.4 .1-2.1c1.6-11.2 4.6-29.6 9-47c.3-1.3 .7-2.6 1-3.9c4.3-15.9 9.8-30.5 16.7-37.4zm-44.7 19c-1.5 4.8-2.9 9.6-4.1 14.3c-4.8 18.9-8 38.5-9.7 50.3c-4 26.8 18.9 49.7 45.7 45.8c11.9-1.6 31.5-4.8 50.4-9.7c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c4.8-18.9 8-38.5 9.7-50.3c4-26.8-18.9-49.7-45.7-45.8c-11.9 1.6-31.5 4.8-50.4 9.7c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75C158.2-8.3 284.5-22.2 382.2 33.2zM51.5 410.1c18.5-5 38.8-8.3 50.9-10c.4-.1 .7-.1 1-.1c5.1-.2 9.2 4.3 8.4 9.6c-1.7 12.1-5 32.4-10 50.9C97.6 476.4 92 491 85.2 497.8C66 517 34.5 516.6 14.9 497.1s-20-51-.7-70.3c6.8-6.8 21.4-12.4 37.4-16.7zM416.9 209c-4.7-11.9-20.8-11-26.8 .3c-19 35.5-45 70.8-77.5 103.3S244.8 371.1 209.3 390c-11.3 6-12.2 22.1-.3 26.8c57.6 22.9 125.8 11 172.3-35.5s58.4-114.8 35.5-172.3zM87.1 285.1c2 2 4.6 3.2 7.3 3.4l56.1 5.1 5.1 56.1c.3 2.8 1.5 5.4 3.4 7.3c6.3 6.3 17.2 3.6 19.8-4.9l29.7-97.4c3.5-11.6-7.3-22.5-19-19L92 265.3c-8.6 2.6-11.3 13.4-4.9 19.8zM265.3 92l-29.7 97.4c-3.5 11.6 7.3 22.5 19 19l97.4-29.7c8.6-2.6 11.3-13.4 4.9-19.8c-2-2-4.6-3.2-7.3-3.4l-56.1-5.1-5.1-56.1c-.3-2.8-1.5-5.4-3.4-7.3c-6.3-6.3-17.2-3.6-19.8 4.9z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM133.5 146.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm407.4 75.5c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM160 120c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L160 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L226.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6zm192 0c-3.1 0-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L352 232.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L418.4 178c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7c-1.3-2.8-4.1-4.6-7.2-4.6z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M548.6 371.4C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c3.6-8.8 6.5-18.4 8.8-27.5c4.6-18.2 7.7-37 9.3-48.2c3.9-26.5-18.8-49.2-45.2-45.4c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-26.5-3.9-49.2 18.8-45.2 45.4c1.6 11.3 4.6 30 9.3 48.2c2.3 9.1 5.2 18.8 8.8 27.5c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3zM107 254.1c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9zm454.5 87.1c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zm-90.1-9.7c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.4 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c25 59.1 83.2 100.5 151.1 100.5s126.2-41.4 151.1-100.5zM281.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C190.7 188.4 184 206.1 184 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C350.7 188.4 344 206.1 344 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinTongueSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zM116 141.1c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinTongueWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M174.5 498.8C73.1 464.7 0 368.9 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 112.9-73.1 208.7-174.5 242.8C346.7 484 352 466.6 352 448V401.1c24.3-17.5 43.6-41.6 55.4-69.6c5-11.8-7-22.5-19.3-18.7c-39.7 12.2-84.5 19-131.8 19s-92.1-6.8-131.8-19c-12.3-3.8-24.3 6.9-19.3 18.7c11.7 27.8 30.8 51.7 54.8 69.2V448c0 18.6 5.3 36 14.5 50.8zm20.7-265.2c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zM336 272a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6V448c0 35.3-28.7 64-64 64s-64-28.7-64-64V402.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 368.9 73.1 464.7 174.5 498.8C165.3 484 160 466.6 160 448V400.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V448c0 18.6-5.3 36-14.5 50.8C438.9 464.7 512 368.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 448V402.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V448c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
                }
            }
        ]
    })(props);
}
function FaFaceGrinWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zm-16.9-79.2c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM388.1 312.8c12.3-3.8 24.3 6.9 19.3 18.7C382.4 390.6 324.2 432 256.3 432s-126.2-41.4-151.1-100.5c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceKissBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-84.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaFaceKissWinkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498 339.7c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-22.9-89.3c-10-39 11.8-80.9 51.8-92.1c37.2-10.4 73.8 10.1 87.5 44c12.7-1.6 25.1 .4 36.2 5zM296 332c0 6.9-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C258.7 443.1 241.4 448 224 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.6-.4-.3-.2-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm194.8 57.6c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
                }
            }
        ]
    })(props);
}
function FaFaceKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm48.7-198.3c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 443.1 257.4 448 240 448c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1 .3-.2 .6-.4c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.4-.3-.5-.3-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceLaughBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM217.6 212.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaFaceLaughSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zm36.7-199.4l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 125.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                }
            }
        ]
    })(props);
}
function FaFaceLaughWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
                }
            }
        ]
    })(props);
}
function FaFaceLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM96.8 314.1c-3.8-13.7 7.4-26.1 21.6-26.1H393.6c14.2 0 25.5 12.4 21.6 26.1C396.2 382 332.1 432 256 432s-140.2-50-159.2-117.9zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208.4-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaFaceMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 336H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaFaceRollingEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 368H320c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-144c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C208.5 175.6 224 198 224 224zm128 64c-35.3 0-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4c-3.7 5.2-5.8 11.6-5.8 18.4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4C400.5 175.6 416 198 416 224c0 35.3-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaFaceSadCry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V477.8C51.5 433.5 0 350.8 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256c0 94.8-51.5 177.5-128 221.8V288c0-8.8-7.2-16-16-16s-16 7.2-16 16V493.4zM195.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM208 336v32c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
                }
            }
        ]
    })(props);
}
function FaFaceSadTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zm240 80c0-8.8 7.2-16 16-16c45 0 85.6 20.5 115.7 53.1c6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9c-8.8 0-16-7.2-16-16zm-80 80c-26.5 0-48-21-48-47c0-20 28.6-60.4 41.6-77.7c3.2-4.4 9.6-4.4 12.8 0C179.6 308.6 208 349 208 369c0 26-21.5 47-48 47zM367.6 208a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceSmileBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm53.5-96.7l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaFaceSmileWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm156.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
                }
            }
        ]
    })(props);
}
function FaFaceSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaceSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaFaceTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4c6.2 11.7 10.3 24.4 10.3 35.9c0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3h-3.2c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8s-6.9-7.9-6.9-13.2c0-11.6 4.2-24.2 10.3-35.9c6.3-12 15.3-24.3 26.4-35.4zm-31.2-182l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                }
            }
        ]
    })(props);
}
function FaFan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M258.6 0c-1.7 0-3.4 .1-5.1 .5C168 17 115.6 102.3 130.5 189.3c2.9 17 8.4 32.9 15.9 47.4L32 224H29.4C13.2 224 0 237.2 0 253.4c0 1.7 .1 3.4 .5 5.1C17 344 102.3 396.4 189.3 381.5c17-2.9 32.9-8.4 47.4-15.9L224 480v2.6c0 16.2 13.2 29.4 29.4 29.4c1.7 0 3.4-.1 5.1-.5C344 495 396.4 409.7 381.5 322.7c-2.9-17-8.4-32.9-15.9-47.4L480 288h2.6c16.2 0 29.4-13.2 29.4-29.4c0-1.7-.1-3.4-.5-5.1C495 168 409.7 115.6 322.7 130.5c-17 2.9-32.9 8.4-47.4 15.9L288 32V29.4C288 13.2 274.8 0 258.6 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaFaucetDrip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32V44l96-12c17.7 0 32 14.3 32 32s-14.3 32-32 32L256 84l-31-3.9-1-.1-1 .1L192 84 96 96C78.3 96 64 81.7 64 64s14.3-32 32-32l96 12V32c0-17.7 14.3-32 32-32zM0 224c0-17.7 14.3-32 32-32h96l22.6-22.6c6-6 14.1-9.4 22.6-9.4H192V116.2l32-4 32 4V160h18.7c8.5 0 16.6 3.4 22.6 9.4L320 192h32c88.4 0 160 71.6 160 160c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32s-14.3-32-32-32H315.9c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48H32c-17.7 0-32-14.3-32-32V224zM436.8 423.4c1.9-4.5 6.3-7.4 11.2-7.4s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-1.2c0-4.5 .9-8.9 2.7-13.1l18.2-42.4z"
                }
            }
        ]
    })(props);
}
function FaFaucet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96v12L96 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l96-12 31-3.9 1-.1 1 .1 31 3.9 96 12c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 12V96c0-17.7-14.3-32-32-32s-32 14.3-32 32zM32 256c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H132.1c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48H352c17.7 0 32 14.3 32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32c0-88.4-71.6-160-160-160H320l-22.6-22.6c-6-6-14.1-9.4-22.6-9.4H256V180.2l-32-4-32 4V224H173.3c-8.5 0-16.6 3.4-22.6 9.4L128 256H32z"
                }
            }
        ]
    })(props);
}
function FaFax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64v96h64V64H386.7L416 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L432 18.7C420 6.7 403.7 0 386.7 0H192c-35.3 0-64 28.7-64 64zM0 160V480c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zm480 32H128V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM256 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM224 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaFeatherPointed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.8-74.8c7.4 4.6 15.3 8.2 23.8 10.5C200.3 452.8 270 454.5 338 409.4c12.2-8.1 5.8-25.4-8.8-25.4l-16.1 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l97.7-29.3c3.4-1 6.4-3.1 8.4-6.1c4.4-6.4 8.6-12.9 12.6-19.6c6.2-10.3-1.5-23-13.5-23l-38.6 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l80.9-24.3c4.6-1.4 8.4-4.8 10.2-9.3C494.5 163 507.8 86.1 511.9 36.8c.8-9.9-3-19.6-10-26.6s-16.7-10.8-26.6-10C391.5 7 228.5 40.5 137.4 131.6C57.3 211.7 56.7 302.3 71.3 356.4c2.1 7.9 12 9.6 17.8 3.8L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
                }
            }
        ]
    })(props);
}
function FaFeather(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.5 215.6L23 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57h68c49.7 0 97.9-14.4 139-41c11.1-7.2 5.5-23-7.8-23c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l81-24.3c2.5-.8 4.8-2.1 6.7-4l22.4-22.4c10.1-10.1 2.9-27.3-11.3-27.3l-32.2 0c-5.1 0-9.2-4.1-9.2-9.2c0-4.1 2.7-7.6 6.5-8.8l112-33.6c4-1.2 7.4-3.9 9.3-7.7C506.4 207.6 512 184.1 512 160c0-41-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149C91 197 64 262.1 64 330v55.3L253.6 195.8c6.2-6.2 16.4-6.2 22.6 0c5.4 5.4 6.1 13.6 2.2 19.8z"
                }
            }
        ]
    })(props);
}
function FaFerry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0H352c17.7 0 32 14.3 32 32h75.1c20.6 0 31.6 24.3 18.1 39.8L456 96H120L98.8 71.8C85.3 56.3 96.3 32 116.9 32H192c0-17.7 14.3-32 32-32zM96 128H480c17.7 0 32 14.3 32 32V283.5c0 13.3-4.2 26.3-11.9 37.2l-51.4 71.9c-1.9 1.1-3.7 2.2-5.5 3.5c-15.5 10.7-34 18-51 19.9H375.6c-17.1-1.8-35-9-50.8-19.9c-22.1-15.5-51.6-15.5-73.7 0c-14.8 10.2-32.5 18-50.6 19.9H183.9c-17-1.8-35.6-9.2-51-19.9c-1.8-1.3-3.7-2.4-5.6-3.5L75.9 320.7C68.2 309.8 64 296.8 64 283.5V160c0-17.7 14.3-32 32-32zm32 64v96H448V192H128zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.3-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaFileArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaFileArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24V305.9l-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31V408z"
                }
            }
        ]
    })(props);
}
function FaFileAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zm2 226.3c37.1 22.4 62 63.1 62 109.7s-24.9 87.3-62 109.7c-7.6 4.6-17.4 2.1-22-5.4s-2.1-17.4 5.4-22C269.4 401.5 288 370.9 288 336s-18.6-65.5-46.5-82.3c-7.6-4.6-10-14.4-5.4-22s14.4-10 22-5.4zm-91.9 30.9c6 2.5 9.9 8.3 9.9 14.8V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L113.4 376H80c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h33.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5zm51 34.9c6.6-5.9 16.7-5.3 22.6 1.3C249.8 304.6 256 319.6 256 336s-6.2 31.4-16.3 42.7c-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c5.1-5.7 8.1-13.1 8.1-21.3s-3.1-15.7-8.1-21.3c-5.9-6.6-5.3-16.7 1.3-22.6z"
                }
            }
        ]
    })(props);
}
function FaFileCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaFileCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaFileCircleMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaFileCirclePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
                }
            }
        ]
    })(props);
}
function FaFileCircleQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
                }
            }
        ]
    })(props);
}
function FaFileCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v38.6C310.1 219.5 256 287.4 256 368c0 59.1 29.1 111.3 73.7 143.3c-3.2 .5-6.4 .7-9.7 .7H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm48 96a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
                }
            }
        ]
    })(props);
}
function FaFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM153 289l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L71 337c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM265 255l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
                }
            }
        ]
    })(props);
}
function FaFileContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm54.2 253.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 349l-9.8 32.8z"
                }
            }
        ]
    })(props);
}
function FaFileCsv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"
                }
            }
        ]
    })(props);
}
function FaFileExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V288H216c-13.3 0-24 10.7-24 24s10.7 24 24 24H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM384 336V288H494.1l-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39H384zm0-208H256V0L384 128z"
                }
            }
        ]
    })(props);
}
function FaFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm152 32c5.3 0 10.2 2.6 13.2 6.9l88 128c3.4 4.9 3.7 11.3 1 16.5s-8.2 8.6-14.2 8.6H216 176 128 80c-5.8 0-11.1-3.1-13.9-8.1s-2.8-11.2 .2-16.1l48-80c2.9-4.8 8.1-7.8 13.7-7.8s10.8 2.9 13.7 7.8l12.8 21.4 48.3-70.2c3-4.3 7.9-6.9 13.2-6.9z"
                }
            }
        ]
    })(props);
}
function FaFileImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-35.3 28.7-64 64-64H352V128c0 17.7 14.3 32 32 32H512V448c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V336H302.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H128V64zm0 224v48H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H128zM512 128H384V0L512 128z"
                }
            }
        ]
    })(props);
}
function FaFileInvoiceDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaFileInvoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaFileLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM112 256H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaFileMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM160 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H224v48c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V352H112c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h48V240z"
                }
            }
        ]
    })(props);
}
function FaFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"
                }
            }
        ]
    })(props);
}
function FaFilePen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V285.7l-86.8 86.8c-10.3 10.3-17.5 23.1-21 37.2l-18.7 74.9c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
                }
            }
        ]
    })(props);
}
function FaFilePowerpoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM136 240h68c42 0 76 34 76 76s-34 76-76 76H160v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V368 264c0-13.3 10.7-24 24-24zm68 104c15.5 0 28-12.5 28-28s-12.5-28-28-28H160v56h44z"
                }
            }
        ]
    })(props);
}
function FaFilePrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM104 196h72c33.1 0 60 26.9 60 60c0 25.5-15.9 47.2-38.3 55.9l43 40.3 33.8-31c8.1-7.5 20.8-6.9 28.3 1.2s6.9 20.8-1.2 28.3L270 379.7l31.7 29.7c8.1 7.6 8.5 20.2 .9 28.3s-20.2 8.5-28.3 .9l-33.9-31.8-34.9 32c-8.1 7.5-20.8 6.9-28.3-1.2s-6.9-20.8 1.2-28.3l32.6-29.9-64.8-60.8c-.9-.8-1.6-1.7-2.3-2.6H124v44c0 11-9 20-20 20s-20-9-20-20V296 216c0-11 9-20 20-20zm72 80c11 0 20-9 20-20s-9-20-20-20H124v40h52z"
                }
            }
        ]
    })(props);
}
function FaFileShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z"
                }
            }
        ]
    })(props);
}
function FaFileSignature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V428.7c-2.7 1.1-5.4 2-8.2 2.7l-60.1 15c-3 .7-6 1.2-9 1.4c-.9 .1-1.8 .2-2.7 .2H240c-6.1 0-11.6-3.4-14.3-8.8l-8.8-17.7c-1.7-3.4-5.1-5.5-8.8-5.5s-7.2 2.1-8.8 5.5l-8.8 17.7c-2.9 5.9-9.2 9.4-15.7 8.8s-12.1-5.1-13.9-11.3L144 381l-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.8 25.6 19.1l11.6 38.6c7.4-6.2 16.8-9.7 26.8-9.7c15.9 0 30.4 9 37.5 23.2l4.4 8.8h8.9c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7L384 203.6V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM549.8 139.7c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM311.9 321c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L512.1 262.7l-71-71L311.9 321z"
                }
            }
        ]
    })(props);
}
function FaFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"
                }
            }
        ]
    })(props);
}
function FaFileWaveform(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C60.7 0 32 28.7 32 64V288H144c6.1 0 11.6 3.4 14.3 8.8L176 332.2l49.7-99.4c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8L281.9 288H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-6.1 0-11.6-3.4-14.3-8.8L240 275.8l-49.7 99.4c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8L134.1 320H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V160H288c-17.7 0-32-14.3-32-32V0H96zM288 0V128H416L288 0z"
                }
            }
        ]
    })(props);
}
function FaFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"
                }
            }
        ]
    })(props);
}
function FaFileZipper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM96 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm-6.3 71.8c3.7-14 16.4-23.8 30.9-23.8h14.8c14.5 0 27.2 9.7 30.9 23.8l23.5 88.2c1.4 5.4 2.1 10.9 2.1 16.4c0 35.2-28.8 63.7-64 63.7s-64-28.5-64-63.7c0-5.5 .7-11.1 2.1-16.4l23.5-88.2zM112 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
                }
            }
        ]
    })(props);
}
function FaFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"
                }
            }
        ]
    })(props);
}
function FaFillDrip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41.4 9.4C53.9-3.1 74.1-3.1 86.6 9.4L168 90.7l53.1-53.1c28.1-28.1 73.7-28.1 101.8 0L474.3 189.1c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8L122.7 136 41.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zm176 221.3L168 181.3 75.9 273.4c-4.2 4.2-7 9.3-8.4 14.6H386.7l42.3-42.3c3.1-3.1 3.1-8.2 0-11.3L277.7 82.9c-3.1-3.1-8.2-3.1-11.3 0L213.3 136l49.4 49.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM512 512c-35.3 0-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7c6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448c0 35.3-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.6 9.4C74.1-3.1 53.9-3.1 41.4 9.4s-12.5 32.8 0 45.3L122.7 136 30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8L148.1 481.4c37.5 37.5 98.3 37.5 135.8 0L474.3 290.9c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0L168 90.7 86.6 9.4zM168 181.3l49.4 49.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136l53.1-53.1c3.1-3.1 8.2-3.1 11.3 0L429.1 234.3c3.1 3.1 3.1 8.2 0 11.3L386.7 288H67.5c1.4-5.4 4.2-10.4 8.4-14.6L168 181.3z"
                }
            }
        ]
    })(props);
}
function FaFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM48 368v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H416zM48 240v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm368-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H416zM48 112v32c0 8.8 7.2 16 16 16H96c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM416 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H416zM160 128v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm32 160c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H192z"
                }
            }
        ]
    })(props);
}
function FaFilterCircleDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm120.8-32.6c.6-.9 1.8-2.1 4.2-3.4c5.1-2.7 12.5-4.1 18.7-4c8.2 .1 17.1 1.8 26.4 4.1c8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3c-11.8 6.3-23 18.4-21.8 37.2c1 16 11.7 25.3 21.6 30.7c8.8 4.7 19.7 7.8 28.6 10.3l1.8 .5c10.3 2.9 17.9 5.2 23.2 8.3c4.5 2.7 4.7 4.2 4.7 5.6c.1 2.4-.5 3.7-1 4.5c-.6 1-1.8 2.2-4 3.3c-4.7 2.5-11.8 3.8-18.5 3.6c-9.5-.3-18.5-3.1-29.9-6.8c-1.9-.6-3.8-1.2-5.8-1.8c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6 .5 3.3 1 5 1.6l0 0 0 0c7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16V438.7c6.2-1.1 12.5-3.1 18.3-6.2c12.1-6.5 22.3-18.7 21.7-36.9c-.5-16.2-10.3-26.3-20.5-32.3c-9.4-5.6-21.2-8.9-30.5-11.5l-.2 0c-10.4-2.9-18.3-5.2-23.9-8.2c-4.8-2.6-4.8-4-4.8-4.5l0-.1c-.1-1.9 .3-2.9 .8-3.6z"
                }
            }
        ]
    })(props);
}
function FaFilterCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 22.9C10.5 8.9 24.5 0 40 0H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L396.4 195.6C316.2 212.1 256 283 256 368c0 27.4 6.3 53.4 17.5 76.5c-1.6-.8-3.2-1.8-4.7-2.9l-64-48c-8.1-6-12.8-15.5-12.8-25.6V288.9L9 65.3C-.7 53.4-2.8 36.8 3.9 22.9zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
                }
            }
        ]
    })(props);
}
function FaFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 54.9C10.5 40.9 24.5 32 40 32H472c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9V448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6V320.9L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
                }
            }
        ]
    })(props);
}
function FaFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256C48 141.1 141.1 48 256 48c63.1 0 119.6 28.1 157.8 72.5c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0C114.6 0 0 114.6 0 256v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1v40c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6c-15.2 5-18.7 23.7-8.3 35.9c7.1 8.3 18.8 10.8 29.4 7.9c10.6-2.9 21.8-4.4 33.4-4.4c70.7 0 128 57.3 128 128v24.9c0 25.2-1.5 50.3-4.4 75.3c-1.7 14.6 9.4 27.8 24.2 27.8c11.8 0 21.9-8.6 23.3-20.3c3.3-27.4 5-55 5-82.7V256c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4C93.7 178 80 215.4 80 256v24.9c0 24.2-2.6 48.4-7.8 71.9C68.8 368.4 80.1 384 96.1 384c10.5 0 19.9-7 22.2-17.3c6.4-28.1 9.7-56.8 9.7-85.8V256c0-27.2 8.5-52.4 22.9-73.1c7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96v24.9c0 35.9-4.6 71.5-13.8 106.1c-3.8 14.3 6.7 29 21.5 29c9.5 0 17.9-6.2 20.4-15.4c10.5-39 15.9-79.2 15.9-119.7V256c0-28.7 23.3-52 52-52s52 23.3 52 52v24.9c0 36.3-3.5 72.4-10.4 107.9c-2.7 13.9 7.7 27.2 21.8 27.2c10.2 0 19-7 21-17c7.7-38.8 11.6-78.3 11.6-118.1V256c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24v24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9V256z"
                }
            }
        ]
    })(props);
}
function FaFireBurner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaFireExtinguisher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.3 7.3C507.7 13.3 512 22.4 512 32v96c0 9.6-4.3 18.7-11.7 24.7s-17.2 8.5-26.6 6.6l-160-32C301.5 124.9 292 115.7 289 104H224v34.8c37.8 18 64 56.5 64 101.2V384H64V240c0-44.7 26.2-83.2 64-101.2V110c-36.2 11.1-66 36.9-82.3 70.5c-5.8 11.9-20.2 16.9-32.1 11.1S-3.3 171.4 2.5 159.5C26.7 109.8 72.7 72.6 128 60.4V32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V56h65c3-11.7 12.5-20.9 24.7-23.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM288 416v32c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V416H288zM176 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaFireFlameCurved(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0C198.4 0 208 9.6 208 21.3V43.5c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7C384 434 306 512 209.7 512H192C86 512 0 426 0 320v-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6C85.9 176 96 186.1 96 198.6V288c0 35.3 28.7 64 64 64s64-28.7 64-64v-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7c0-27.7 9-54.8 25.6-76.9z"
                }
            }
        ]
    })(props);
}
function FaFireFlameSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6C0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5c0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
                }
            }
        ]
    })(props);
}
function FaFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.3 5.4c7.8-7.3 19.9-7.2 27.7 .1c27.6 25.9 53.5 53.8 77.7 84c11-14.4 23.5-30.1 37-42.9c7.9-7.4 20.1-7.4 28 .1c34.6 33 63.9 76.6 84.5 118c20.3 40.8 33.8 82.5 33.8 111.9C448 404.2 348.2 512 224 512C98.4 512 0 404.1 0 276.5c0-38.4 17.8-85.3 45.4-131.7C73.3 97.7 112.7 48.6 159.3 5.4zM225.7 416c25.3 0 47.7-7 68.8-21c42.1-29.4 53.4-88.2 28.1-134.4c-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5c-16.5-21-46-58.5-62.8-79.8c-6.3-8-18.3-8.1-24.7-.1c-33.8 42.5-50.8 69.3-50.8 99.4C112 375.4 162.6 416 225.7 416z"
                }
            }
        ]
    })(props);
}
function FaFishFins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5c-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9S-3 163.3 4.2 175.9L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3c15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8c39.2-29.4 67.2-64.7 81.6-89.5c5.8-9.9 5.8-22.2 0-32.1c-14.4-24.8-42.5-60.1-81.6-89.5c-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaFish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8c4.7 9.2 4.7 20.1 0 29.3c-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9S-3 348.7 4.2 336.1L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaFlagCheckered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1V345.8c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 384v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V400 334 64 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9v65.5L64 252.6V318l48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3V238.7l38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9v66.7l-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8v71.4c21.8 1.9 43.3 6.7 64 14.4V244.2l22.7 6.7c13.5 4 27.3 6.4 41.3 7.4V194c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12v-62c-13-3.8-25.8-8.8-38.2-15c-8.2-4.1-16.9-7-25.8-8.8v72.4c-13-.4-26 .8-38.7 3.6L128 173.2V98L64 114v73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2V251.9l-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5v77.4zm64-149.4V115.4c-20.9 6.1-42.4 9.1-64 9.1V194c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
                }
            }
        ]
    })(props);
}
function FaFlagUsa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C49.7 0 64 14.3 64 32V48l69-17.2c38.1-9.5 78.3-5.1 113.5 12.5c46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1v36.1l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9v32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 136.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 203.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 232.3v62l-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3L64 299.1v32.7l70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4L448 328.3v33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4c-37.9-19-81.3-23.7-122.5-13.4L64 400v80c0 17.7-14.3 32-32 32s-32-14.3-32-32V416 345.5 312.8 249.5 216.8 153.5 120.8 64 32C0 14.3 14.3 0 32 0zm80 96A16 16 0 1 0 80 96a16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V64 368 480c0 17.7 14.3 32 32 32s32-14.3 32-32V352l64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48V32z"
                }
            }
        ]
    })(props);
}
function FaFlaskVial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M175 389.4c-9.8 16-15 34.3-15 53.1c-10 3.5-20.8 5.5-32 5.5c-53 0-96-43-96-96V64C14.3 64 0 49.7 0 32S14.3 0 32 0H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V309.9l-49 79.6zM96 64v96h64V64H96zM352 0H480h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V214.9L629.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H261.4c-38.3 0-69.4-31.1-69.4-69.4c0-12.8 3.6-25.4 10.3-36.4L320 214.9V64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32zm32 64V224c0 5.9-1.6 11.7-4.7 16.8L330.5 320h171l-48.8-79.2c-3.1-5-4.7-10.8-4.7-16.8V64H384z"
                }
            }
        ]
    })(props);
}
function FaFlask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0H160 128C110.3 0 96 14.3 96 32s14.3 32 32 32V196.8c0 11.8-3.3 23.5-9.5 33.5L10.3 406.2C3.6 417.2 0 429.7 0 442.6C0 480.9 31.1 512 69.4 512H378.6c38.3 0 69.4-31.1 69.4-69.4c0-12.8-3.6-25.4-10.3-36.4L329.5 230.4c-6.2-10.1-9.5-21.7-9.5-33.5V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288zM192 196.8V64h64V196.8c0 23.7 6.6 46.9 19 67.1L309.5 320h-171L173 263.9c12.4-20.2 19-43.4 19-67.1z"
                }
            }
        ]
    })(props);
}
function FaFloppyDisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaFlorinSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h80L98.9 396.3c-5 11.9-16.6 19.7-29.5 19.7H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H69.3c38.8 0 73.7-23.3 88.6-59.1L213.3 288H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H240l45.1-108.3c5-11.9 16.6-19.7 29.5-19.7H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H314.7z"
                }
            }
        ]
    })(props);
}
function FaFolderClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 480H64c-35.3 0-64-28.7-64-64V192H512V416c0 35.3-28.7 64-64 64zm64-320H0V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64z"
                }
            }
        ]
    })(props);
}
function FaFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64zM184 272c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
                }
            }
        ]
    })(props);
}
function FaFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88.7 223.8L0 375.8V96C0 60.7 28.7 32 64 32H181.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 28.3 18.7 45.3 18.7H416c35.3 0 64 28.7 64 64v32H144c-22.8 0-43.8 12.1-55.3 31.8zm27.6 16.1C122.1 230 132.6 224 144 224H544c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-112 192C453.9 474 443.4 480 432 480H32c-11.5 0-22-6.1-27.7-16.1s-5.7-22.2 .1-32.1l112-192z"
                }
            }
        ]
    })(props);
}
function FaFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H192c20.1 0 39.1 9.5 51.2 25.6l19.2 25.6c6 8.1 15.5 12.8 25.6 12.8H448c35.3 0 64 28.7 64 64V416zM232 376c0 13.3 10.7 24 24 24s24-10.7 24-24V312h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V200c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
                }
            }
        ]
    })(props);
}
function FaFolderTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96V384c0 35.3 28.7 64 64 64H256V384H64V160H256V96H64V32zM288 192c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4L409.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V192zm0 288c0 17.7 14.3 32 32 32H544c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H445.3c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32V480z"
                }
            }
        ]
    })(props);
}
function FaFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z"
                }
            }
        ]
    })(props);
}
function FaFootball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.5 25.4c-13.5 3.3-26.4 7.2-38.6 11.7C142.9 61.6 96.7 103.6 66 153.6c-18.3 29.8-30.9 62.3-39.2 95.4L264.5 486.6c13.5-3.3 26.4-7.2 38.6-11.7c66-24.5 112.2-66.5 142.9-116.5c18.3-29.8 30.9-62.3 39.1-95.3L247.5 25.4zM495.2 205.3c6.1-56.8 1.4-112.2-7.7-156.4c-2.7-12.9-13-22.9-26.1-25.1c-58.2-9.7-109.9-12-155.6-7.9L495.2 205.3zM206.1 496L16.8 306.7c-6.1 56.8-1.4 112.2 7.7 156.4c2.7 12.9 13 22.9 26.1 25.1c58.2 9.7 109.9 12 155.6 7.9zm54.6-331.3c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-48 48c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaForwardFast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 445c11.2 5.3 24.5 3.6 34.1-4.4L224 297.7V416c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4L448 297.7V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V214.3L276.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S224 83.6 224 96V214.3L52.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S0 83.6 0 96V416c0 12.4 7.2 23.7 18.4 29z"
                }
            }
        ]
    })(props);
}
function FaForwardStep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4l192 160L256 241V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V271l-11.5 9.6-192 160z"
                }
            }
        ]
    })(props);
}
function FaForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416V96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3V256v41.7L52.5 440.6zM256 352V256 128 96c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29V352z"
                }
            }
        ]
    })(props);
}
function FaFrancSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 32C62.3 32 48 46.3 48 64V224v96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V96H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                }
            }
        ]
    })(props);
}
function FaFrog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9c0 21.8-11.7 41.9-30.7 52.7L400.8 323.5 493.3 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H480c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7c-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2c27.9-18.5 65.9-15.4 90.5 9.2c24.7 24.7 27.7 62.9 9 90.9c-2.6 3.8-5.6 7.5-9 10.9L261.8 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-35.3 0-64-28.7-64-64C0 249.6 127 112.9 289.3 97.5C296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaFutbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
                }
            }
        ]
    })(props);
}
function FaG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H400c25.8 0 49.6 21.4 47.2 50.6C437.8 389.6 341.4 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57c13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
                }
            }
        ]
    })(props);
}
function FaGamepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64C86 64 0 150 0 256S86 448 192 448H448c106 0 192-86 192-192s-86-192-192-192H192zM496 168a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM392 304a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM168 200c0-13.3 10.7-24 24-24s24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V200z"
                }
            }
        ]
    })(props);
}
function FaGasPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64C32 28.7 60.7 0 96 0H256c35.3 0 64 28.7 64 64V256h8c48.6 0 88 39.4 88 88v32c0 13.3 10.7 24 24 24s24-10.7 24-24V222c-27.6-7.1-48-32.2-48-62V96L384 64c-8.8-8.8-8.8-23.2 0-32s23.2-8.8 32 0l77.3 77.3c12 12 18.7 28.3 18.7 45.3V168v24 32V376c0 39.8-32.2 72-72 72s-72-32.2-72-72V344c0-22.1-17.9-40-40-40h-8V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64zM96 80v96c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaGaugeHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaGaugeSimpleHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-15.9-5.8-30.4-15.3-41.6l76.6-147.4c6.1-11.8 1.5-26.3-10.2-32.4s-26.2-1.5-32.4 10.2L262.1 288.3c-2-.2-4-.3-6.1-.3c-35.3 0-64 28.7-64 64s28.7 64 64 64s64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaGaugeSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaGauge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 96c0-26.9-16.5-49.9-40-59.3V88c0-13.3-10.7-24-24-24s-24 10.7-24 24V292.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaGavel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-120 120c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l4-4L325.4 293.4l-4 4c-12.5 12.5-12.5 32.8 0 45.3l16 16c12.5 12.5 32.8 12.5 45.3 0l120-120c12.5-12.5 12.5-32.8 0-45.3l-16-16c-12.5-12.5-32.8-12.5-45.3 0l-4 4L330.6 74.6l4-4c12.5-12.5 12.5-32.8 0-45.3l-16-16zm-152 288c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l48 48c12.5 12.5 32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-1.4-1.4L272 285.3 226.7 240 168 298.7l-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function FaGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                }
            }
        ]
    })(props);
}
function FaGears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.5 135.3c7.1-6.3 9.9-16.2 6.2-25c-2.3-5.3-4.8-10.5-7.6-15.5L304 89.4c-3-5-6.3-9.9-9.8-14.6c-5.7-7.6-15.7-10.1-24.7-7.1l-28.2 9.3c-10.7-8.8-23-16-36.2-20.9L199 27.1c-1.9-9.3-9.1-16.7-18.5-17.8C173.9 8.4 167.2 8 160.4 8h-.7c-6.8 0-13.5 .4-20.1 1.2c-9.4 1.1-16.6 8.6-18.5 17.8L115 56.1c-13.3 5-25.5 12.1-36.2 20.9L50.5 67.8c-9-3-19-.5-24.7 7.1c-3.5 4.7-6.8 9.6-9.9 14.6l-3 5.3c-2.8 5-5.3 10.2-7.6 15.6c-3.7 8.7-.9 18.6 6.2 25l22.2 19.8C32.6 161.9 32 168.9 32 176s.6 14.1 1.7 20.9L11.5 216.7c-7.1 6.3-9.9 16.2-6.2 25c2.3 5.3 4.8 10.5 7.6 15.6l3 5.2c3 5.1 6.3 9.9 9.9 14.6c5.7 7.6 15.7 10.1 24.7 7.1l28.2-9.3c10.7 8.8 23 16 36.2 20.9l6.1 29.1c1.9 9.3 9.1 16.7 18.5 17.8c6.7 .8 13.5 1.2 20.4 1.2s13.7-.4 20.4-1.2c9.4-1.1 16.6-8.6 18.5-17.8l6.1-29.1c13.3-5 25.5-12.1 36.2-20.9l28.2 9.3c9 3 19 .5 24.7-7.1c3.5-4.7 6.8-9.5 9.8-14.6l3.1-5.4c2.8-5 5.3-10.2 7.6-15.5c3.7-8.7 .9-18.6-6.2-25l-22.2-19.8c1.1-6.8 1.7-13.8 1.7-20.9s-.6-14.1-1.7-20.9l22.2-19.8zM112 176a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM504.7 500.5c6.3 7.1 16.2 9.9 25 6.2c5.3-2.3 10.5-4.8 15.5-7.6l5.4-3.1c5-3 9.9-6.3 14.6-9.8c7.6-5.7 10.1-15.7 7.1-24.7l-9.3-28.2c8.8-10.7 16-23 20.9-36.2l29.1-6.1c9.3-1.9 16.7-9.1 17.8-18.5c.8-6.7 1.2-13.5 1.2-20.4s-.4-13.7-1.2-20.4c-1.1-9.4-8.6-16.6-17.8-18.5L583.9 307c-5-13.3-12.1-25.5-20.9-36.2l9.3-28.2c3-9 .5-19-7.1-24.7c-4.7-3.5-9.6-6.8-14.6-9.9l-5.3-3c-5-2.8-10.2-5.3-15.6-7.6c-8.7-3.7-18.6-.9-25 6.2l-19.8 22.2c-6.8-1.1-13.8-1.7-20.9-1.7s-14.1 .6-20.9 1.7l-19.8-22.2c-6.3-7.1-16.2-9.9-25-6.2c-5.3 2.3-10.5 4.8-15.6 7.6l-5.2 3c-5.1 3-9.9 6.3-14.6 9.9c-7.6 5.7-10.1 15.7-7.1 24.7l9.3 28.2c-8.8 10.7-16 23-20.9 36.2L315.1 313c-9.3 1.9-16.7 9.1-17.8 18.5c-.8 6.7-1.2 13.5-1.2 20.4s.4 13.7 1.2 20.4c1.1 9.4 8.6 16.6 17.8 18.5l29.1 6.1c5 13.3 12.1 25.5 20.9 36.2l-9.3 28.2c-3 9-.5 19 7.1 24.7c4.7 3.5 9.5 6.8 14.6 9.8l5.4 3.1c5 2.8 10.2 5.3 15.5 7.6c8.7 3.7 18.6 .9 25-6.2l19.8-22.2c6.8 1.1 13.8 1.7 20.9 1.7s14.1-.6 20.9-1.7l19.8 22.2zM464 304a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5l57.4 95.6L63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8L301.5 179.8l57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
                }
            }
        ]
    })(props);
}
function FaGenderless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 288a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
                }
            }
        ]
    })(props);
}
function FaGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40.1 467.1l-11.2 9c-3.2 2.5-7.1 3.9-11.1 3.9C8 480 0 472 0 462.2V192C0 86 86 0 192 0S384 86 384 192V462.2c0 9.8-8 17.8-17.8 17.8c-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 68.8L225.3 128H224 152c-22.1 0-40-17.9-40-40s17.9-40 40-40h2.2c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H438.4c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88h-2.2c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0H152C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40H288h-1.3l34.8-59.2C329.1 55.9 342.9 48 357.8 48H360c22.1 0 40 17.9 40 40zM32 288V464c0 26.5 21.5 48 48 48H224V288H32zM288 512H432c26.5 0 48-21.5 48-48V288H288V512z"
                }
            }
        ]
    })(props);
}
function FaGifts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.6 32C205 19.5 198.5 5.8 186 1.4S159.8 3.5 155.4 16L144.7 46.2l-9.9-29.8C130.6 3.8 117-3 104.4 1.2S85 19 89.2 31.6l8.3 25-27.4-20c-10.7-7.8-25.7-5.4-33.5 5.3s-5.4 25.7 5.3 33.5L70.2 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H200.6c-5.4-9.4-8.6-20.3-8.6-32V256c0-29.9 20.5-55 48.2-62c1.8-31 17.1-58.2 40.1-76.1C271.7 104.7 256.9 96 240 96H217.8l28.3-20.6c10.7-7.8 13.1-22.8 5.3-33.5s-22.8-13.1-33.5-5.3L192.5 55.1 200.6 32zM363.5 185.5L393.1 224H344c-13.3 0-24-10.7-24-24c0-13.1 10.8-24 24.2-24c7.6 0 14.7 3.5 19.3 9.5zM272 200c0 8.4 1.4 16.5 4.1 24H272c-26.5 0-48 21.5-48 48v80H416V256h32v96H640V272c0-26.5-21.5-48-48-48h-4.1c2.7-7.5 4.1-15.6 4.1-24c0-39.9-32.5-72-72.2-72c-22.4 0-43.6 10.4-57.3 28.2L432 195.8l-30.5-39.6c-13.7-17.8-35-28.2-57.3-28.2c-39.7 0-72.2 32.1-72.2 72zM224 464c0 26.5 21.5 48 48 48H416V384H224v80zm224 48H592c26.5 0 48-21.5 48-48V384H448V512zm96-312c0 13.3-10.7 24-24 24H470.9l29.6-38.5c4.6-5.9 11.7-9.5 19.3-9.5c13.4 0 24.2 10.9 24.2 24z"
                }
            }
        ]
    })(props);
}
function FaGlassWaterDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM83 297.5L66.4 64H317.6L301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0s-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5c-6.1-7.7-17.5-7.7-23.6 0C161.7 125.9 128 172 128 196c0 33.1 28.7 60 64 60s64-26.9 64-60z"
                }
            }
        ]
    })(props);
}
function FaGlassWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3H275.3c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0H32zM73 156.5L66.4 64H317.6L311 156.5l-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0c-20.9-10.4-45.5-10.4-66.4 0c-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
                }
            }
        ]
    })(props);
}
function FaGlasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.6 80c-11.5 0-21.4 7.9-24 19.1L57 260.3c20.5-6.2 48.3-12.3 78.7-12.3c32.3 0 61.8 6.9 82.8 13.5c10.6 3.3 19.3 6.7 25.4 9.2c3.1 1.3 5.5 2.4 7.3 3.2c.9 .4 1.6 .7 2.1 1l.6 .3 .2 .1 .1 0 0 0 0 0s0 0-6.3 12.7h0l6.3-12.7c5.8 2.9 10.4 7.3 13.5 12.7h40.6c3.1-5.3 7.7-9.8 13.5-12.7l6.3 12.7h0c-6.3-12.7-6.3-12.7-6.3-12.7l0 0 0 0 .1 0 .2-.1 .6-.3c.5-.2 1.2-.6 2.1-1c1.8-.8 4.2-1.9 7.3-3.2c6.1-2.6 14.8-5.9 25.4-9.2c21-6.6 50.4-13.5 82.8-13.5c30.4 0 58.2 6.1 78.7 12.3L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.1c.3 1.9 .5 3.8 .5 5.7v6.7V352v16c0 61.9-50.1 112-112 112H419.7c-59.4 0-108.5-46.4-111.8-105.8L306.6 352H269.4l-1.2 22.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368V352 310.7 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM64 325.4V368c0 26.5 21.5 48 48 48h44.3c25.5 0 46.5-19.9 47.9-45.3l2.5-45.6c-2.3-.8-4.9-1.7-7.5-2.5c-17.2-5.4-39.9-10.5-63.6-10.5c-23.7 0-46.2 5.1-63.2 10.5c-3.1 1-5.9 1.9-8.5 2.9zM512 368V325.4c-2.6-.9-5.5-1.9-8.5-2.9c-17-5.4-39.5-10.5-63.2-10.5c-23.7 0-46.4 5.1-63.6 10.5c-2.7 .8-5.2 1.7-7.5 2.5l2.5 45.6c1.4 25.4 22.5 45.3 47.9 45.3H464c26.5 0 48-21.5 48-48z"
                }
            }
        ]
    })(props);
}
function FaGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 256c0 22.2-1.2 43.6-3.3 64H163.3c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64H348.7c2.2 20.4 3.3 41.8 3.3 64zm28.8-64H503.9c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H380.8c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32H376.7c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0H167.7c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0H18.6C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192H131.2c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64H8.1C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6H344.3c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352H135.3zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6H493.4z"
                }
            }
        ]
    })(props);
}
function FaGolfBallTee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192c0 66.8-34.1 125.6-85.8 160H85.8C34.1 317.6 0 258.8 0 192C0 86 86 0 192 0S384 86 384 192zM242.1 256.6c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zm-52.3-49.3c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4c0 18.5-15 33.5-33.5 33.5zm113.5-17.5c0 18.5-15 33.5-33.5 33.5c-4.9 0-9.1 5.1-5.4 8.4c5.9 5.2 13.7 8.4 22.1 8.4c18.5 0 33.5-15 33.5-33.5c0-8.5-3.2-16.2-8.4-22.1c-3.3-3.7-8.4 .5-8.4 5.4zM96 416c0-17.7 14.3-32 32-32h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H240c-8.8 0-16 7.2-16 16v16c0 17.7-14.3 32-32 32s-32-14.3-32-32V464c0-8.8-7.2-16-16-16H128c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaGopuram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 0c13.3 0 24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h48V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40V24c0-13.3 10.7-24 24-24s24 10.7 24 24v8V64v64c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H416V352H384V224H352V128H320v96h32V352h32V512H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H128V352h32V224h32V128H160v96H128V352H96V512H32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32V256c0-17.7 14.3-32 32-32V160c0-17.7 14.3-32 32-32V64 32 24c0-13.3 10.7-24 24-24zM256 272c-17.7 0-32 14.3-32 32v48h64V304c0-17.7-14.3-32-32-32zm-32-80v32h64V192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaGraduationCap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 32c-8.1 0-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6l57.9 20.9C57.3 229.3 48 259.8 48 291.9v28.1c0 28.4-10.8 57.7-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7C90.3 344.3 86 329.8 80 316.5V291.9c0-30.2 10.2-58.7 27.9-81.5c12.9-15.5 29.6-28 49.2-35.7l157-61.7c8.2-3.2 17.5 .8 20.7 9s-.8 17.5-9 20.7l-157 61.7c-12.4 4.9-23.3 12.4-32.2 21.6l159.6 57.6c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32zM128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6 354.5 314c-11.1 4-22.8 6-34.5 6s-23.5-2-34.5-6L143.3 262.6 128 408z"
                }
            }
        ]
    })(props);
}
function FaGreaterThanEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M52.1 93.7C35.7 87.1 27.7 68.5 34.3 52.1s25.2-24.4 41.6-17.8l320 128C408 167.1 416 178.9 416 192s-8 24.9-20.1 29.7l-320 128c-16.4 6.6-35-1.4-41.6-17.8s1.4-35 17.8-41.6L297.8 192 52.1 93.7zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416z"
                }
            }
        ]
    })(props);
}
function FaGreaterThan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.4 81.7c-7.9 15.8-1.5 35 14.3 42.9L280.5 256 17.7 387.4C1.9 395.3-4.5 414.5 3.4 430.3s27.1 22.2 42.9 14.3l320-160c10.8-5.4 17.7-16.5 17.7-28.6s-6.8-23.2-17.7-28.6l-320-160c-15.8-7.9-35-1.5-42.9 14.3z"
                }
            }
        ]
    })(props);
}
function FaGripLinesVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64z"
                }
            }
        ]
    })(props);
}
function FaGripLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
                }
            }
        ]
    })(props);
}
function FaGripVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
                }
            }
        ]
    })(props);
}
function FaGrip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 136c0-22.1-17.9-40-40-40L40 96C17.9 96 0 113.9 0 136l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM288 328c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328zm32-192v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V136c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM448 328c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V328z"
                }
            }
        ]
    })(props);
}
function FaGroupArrowsRotate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.1 71.9c16.9-5 26.6-22.9 21.5-39.8s-22.9-26.6-39.8-21.5c-21.5 6.4-41.8 15.5-60.6 27C114.3 34 105.4 32 96 32C60.7 32 32 60.7 32 96c0 9.4 2 18.3 5.6 26.3c-11.5 18.7-20.6 39-27 60.6c-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c4.3-14.6 10.4-28.5 17.9-41.4c2 .2 4.1 .3 6.1 .3c35.3 0 64-28.7 64-64c0-2.1-.1-4.1-.3-6.1c12.9-7.5 26.8-13.6 41.4-17.9zm128-61.3c-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c14.6 4.3 28.5 10.4 41.4 17.9c-.2 2-.3 4.1-.3 6.1c0 35.3 28.7 64 64 64c2.1 0 4.1-.1 6.2-.3c7.5 12.9 13.6 26.8 17.9 41.4c5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.6c3.6-8 5.6-16.9 5.6-26.3c0-35.3-28.7-64-64-64c-9.4 0-18.3 2-26.3 5.6c-18.7-11.5-39-20.6-60.6-27zM71.9 310.9c-5-16.9-22.9-26.6-39.8-21.5s-26.6 22.9-21.5 39.8c6.4 21.5 15.5 41.8 27 60.6C34 397.7 32 406.6 32 416c0 35.3 28.7 64 64 64c9.4 0 18.3-2 26.3-5.6c18.7 11.5 39 20.6 60.6 27c16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-14.6-4.3-28.5-10.4-41.4-17.9c.2-2 .3-4.1 .3-6.2c0-35.3-28.7-64-64-64c-2.1 0-4.1 .1-6.2 .3c-7.5-12.9-13.6-26.8-17.9-41.4zm429.4 18.3c5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-4.3 14.6-10.4 28.5-17.9 41.4c-2-.2-4.1-.3-6.2-.3c-35.3 0-64 28.7-64 64c0 2.1 .1 4.1 .3 6.2c-12.9 7.5-26.8 13.6-41.4 17.9c-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.6-27c8 3.6 16.9 5.6 26.3 5.6c35.3 0 64-28.7 64-64c0-9.4-2-18.3-5.6-26.3c11.5-18.7 20.6-39 27-60.6zM192.8 256.8c0-15.6 5.6-29.9 14.9-41.1L223 231c6.6 6.6 17.8 1.9 17.8-7.4V163.2c0-5.7-4.7-10.4-10.4-10.4H169.9c-9.3 0-13.9 11.2-7.4 17.8l11.2 11.2c-17.9 19.8-28.9 46.2-28.9 75.1c0 43.6 24.9 81.3 61.1 99.8c11.8 6 26.3 1.4 32.3-10.4s1.4-26.3-10.4-32.3c-20.8-10.6-34.9-32.2-34.9-57zm93.1-58.6c20.8 10.6 34.9 32.2 34.9 57c0 15.6-5.6 29.9-14.9 41.1L290.6 281c-6.6-6.6-17.8-1.9-17.8 7.4v60.5c0 5.7 4.7 10.4 10.4 10.4h60.5c9.3 0 13.9-11.2 7.4-17.8l-11.2-11.2c17.9-19.8 28.9-46.2 28.9-75.1c0-43.6-24.9-81.3-61.1-99.8c-11.8-6-26.3-1.4-32.3 10.4s-1.4 26.3 10.4 32.3z"
                }
            }
        ]
    })(props);
}
function FaGuaraniSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-17.7 0-32 14.3-32 32V66.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V445.3c90.8-15.2 160-94.2 160-189.3c0-17.7-14.3-32-32-32H224V132c22.1 5.7 41.8 17.1 57.6 32.6c12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C299 92 263.5 73.3 224 66.7V32c0-17.7-14.3-32-32-32zM160 132V380c-55.2-14.2-96-64.3-96-124s40.8-109.8 96-124zM224 380V288h92c-11.6 45-47 80.4-92 92z"
                }
            }
        ]
    })(props);
}
function FaGuitar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6c-11 11-18 24.6-21.4 39.6c-3.7 16.6-19.1 30.7-36.1 31.6c-25.6 1.3-49.3 10.7-67.3 28.6C-16 328.4-7.6 409.4 47.5 464.5s136.1 63.5 180.9 18.7c17.9-17.9 27.4-41.7 28.6-67.3c.9-17 15-32.3 31.6-36.1c15-3.4 28.6-10.5 39.6-21.4c31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaGun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H32C14.3 64 0 78.3 0 96V208c0 17.7 14.3 32 32 32H42c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h96c14.7 0 27.5-10 31-24.2L217 352H321.4c23.7 0 44.8-14.9 52.7-37.2L400.9 240H432c8.5 0 16.6-3.4 22.6-9.4L477.3 208H544c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H528V56zM321.4 304H229l16-64h105l-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 256l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V192L64 192 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192 256 0z"
                }
            }
        ]
    })(props);
}
function FaHammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.5 237.5c-28.2 4.8-58.2-3.6-80-25.4l-38.1-38.1C280.4 159 272 138.8 272 117.6V105.5L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c24.2 22.8 33.2 55.7 26.6 86L503 183l8-8c9.4-9.4 24.6-9.4 33.9 0l24 24c9.4 9.4 9.4 24.6 0 33.9l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-24-24c-9.4-9.4-9.4-24.6 0-33.9l8-8-17.5-17.5zM27.4 377.1L260.9 182.6c3.5 4.9 7.5 9.6 11.8 14l38.1 38.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6c-14.5 17.4-36 27.4-58.6 27.4C34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
                }
            }
        ]
    })(props);
}
function FaHamsa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.6 288H80c8.8 0 16-7.2 16-16V72c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V40c0-22.1 17.9-40 40-40s40 17.9 40 40V204c0 11 9 20 20 20s20-9 20-20V72c0-22.1 17.9-40 40-40s40 17.9 40 40V272c0 8.8 7.2 16 16 16h45.4c19.1 0 34.6 15.5 34.6 34.6c0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71s-119.4-25.8-160.6-71L9 345.9c-5.8-6.4-9-14.7-9-23.3C0 303.5 15.5 288 34.6 288zM256 288c-38.4 0-76.8 35.8-90.6 50.2c-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaHandBackFist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0C117.5 0 96 21.5 96 48V96v28.5V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V149.3l-9 7.5C40.4 169 32 187 32 206V244c0 38 16.9 74 46.1 98.3L128 384v96c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V374.7c46.9-19 80-65 80-118.7V176 160 144c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 83.5 329.3 64 304 64c-12.4 0-23.6 4.7-32.1 12.3C270 51.5 249.3 32 224 32c-12.4 0-23.6 4.7-32.1 12.3C190 19.5 169.3 0 144 0z"
                }
            }
        ]
    })(props);
}
function FaHandDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32zM240 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM240 432a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm-48-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                }
            }
        ]
    })(props);
}
function FaHandFist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c17.7 0 32 14.3 32 32V144H160V32c0-17.7 14.3-32 32-32zM64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v80H64V64zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V64zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V256c0 52.3-25.1 98.8-64 128v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V401.6c-17.3-7.9-33.2-18.8-46.9-32.5L69.5 357.5C45.5 333.5 32 300.9 32 267V240c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H128c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 24V34.5c6.4 1.2 12.6 2.7 18.2 4.2c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17c-10.9-2.9-21.1-4.9-30.2-5c-7.3-.1-14.7 1.7-19.4 4.4c-2.1 1.3-3.1 2.4-3.5 3c-.3 .5-.7 1.2-.7 2.8c0 .3 0 .5 0 .6c.2 .2 .9 1.2 3.3 2.6c5.8 3.5 14.4 6.2 27.4 10.1l.9 .3c11.1 3.3 25.9 7.8 37.9 15.3c13.7 8.6 26.1 22.9 26.4 44.9c.3 22.5-11.4 38.9-26.7 48.5c-6.7 4.1-13.9 7-21.3 8.8V232c0 13.3-10.7 24-24 24s-24-10.7-24-24V220.6c-9.5-2.3-18.2-5.3-25.6-7.8c-2.1-.7-4.1-1.4-6-2c-12.6-4.2-19.4-17.8-15.2-30.4s17.8-19.4 30.4-15.2c2.6 .9 5 1.7 7.3 2.5c13.6 4.6 23.4 7.9 33.9 8.3c8 .3 15.1-1.6 19.2-4.1c1.9-1.2 2.8-2.2 3.2-2.9c.4-.6 .9-1.8 .8-4.1l0-.2c0-1 0-2.1-4-4.6c-5.7-3.6-14.3-6.4-27.1-10.3l-1.9-.6c-10.8-3.2-25-7.5-36.4-14.4c-13.5-8.1-26.5-22-26.6-44.1c-.1-22.9 12.9-38.6 27.7-47.4c6.4-3.8 13.3-6.4 20.2-8.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6L366.8 103C378 119.3 384 138.6 384 158.3V160c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3L275.5 6.6zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 207.7c-13.1-17.8-9.3-42.8 8.5-55.9L142.9 58.5C166.2 41.3 194.5 32 223.5 32H384 544c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H507.2l-44.9 36c-22.7 18.2-50.9 28-80 28H304 288 224c-17.7 0-32-14.3-32-32s14.3-32 32-32h64 16c8.8 0 16-7.2 16-16s-7.2-16-16-16H183.4L63.7 216.2c-17.8 13.1-42.8 9.3-55.9-8.5zM382.4 160l0 0 .9 0c-.3 0-.6 0-.9 0zM568.2 304.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 453.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 352l0 0-.9 0c.3 0 .6 0 .9 0z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M163.9 136.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9zM568.2 336.3c13.1 17.8 9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5H192 32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32H68.8l44.9-36c22.7-18.2 50.9-28 80-28H272h16 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H288 272c-8.8 0-16 7.2-16 16s7.2 16 16 16H392.6l119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5zM193.6 384l0 0-.9 0c.3 0 .6 0 .9 0z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 24V80H168c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h56v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176h56c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H320V24c0-13.3-10.7-24-24-24H248c-13.3 0-24 10.7-24 24zM559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-367-8.2l.9 0 0 0c-.3 0-.6 0-.9 0z"
                }
            }
        ]
    })(props);
}
function FaHandHolding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M559.7 392.2c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H288 272 193.7c-29.1 0-57.3 9.9-80 28L68.8 384H32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H192 352.5c29 0 57.3-9.3 80.7-26.5l126.6-93.3zm-366.1-8.3a.5 .5 0 1 1 -.9 .1 .5 .5 0 1 1 .9-.1z"
                }
            }
        ]
    })(props);
}
function FaHandLizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112C0 85.5 21.5 64 48 64H160h80 46.5c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8v12 16 48c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V402.2L273.9 352H240 160 112c-26.5 0-48-21.5-48-48s21.5-48 48-48h48 80c26.5 0 48-21.5 48-48s-21.5-48-48-48H160 48c-26.5 0-48-21.5-48-48z"
                }
            }
        ]
    })(props);
}
function FaHandMiddleFinger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 0c-22.1 0-40 17.9-40 40V204.2c-8.5-7.6-19.7-12.2-32-12.2c-26.5 0-48 21.5-48 48v7 73c0 8.8-7.2 16-16 16s-16-7.2-16-16V264.3c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334V372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1H304c70.7 0 128-57.3 128-128V320 288c0-26.5-21.5-48-48-48c-12.4 0-23.6 4.7-32.1 12.3C350 227.5 329.3 208 304 208c-12.3 0-23.5 4.6-32 12.2V40c0-22.1-17.9-40-40-40z"
                }
            }
        ]
    })(props);
}
function FaHandPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32V240H192V32c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zM93.3 51.2L175.9 240H106.1L34.7 76.8C27.6 60.6 35 41.8 51.2 34.7s35.1 .3 42.1 16.5zm27 221.3l-.2-.5h69.9H216c22.1 0 40 17.9 40 40s-17.9 40-40 40H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H226.3c-42.4 0-83.1-16.9-113.1-46.9l-11.6-11.6C77.5 429.5 64 396.9 64 363V336c0-32.7 24.6-59.7 56.3-63.5z"
                }
            }
        ]
    })(props);
}
function FaHandPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32V272H32V480zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-64 64c17.7 0 32-14.3 32-32V304c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6c13.2 0 25.4 4 35.6 10.8c8.7-24.9 32.5-42.8 60.4-42.8c11.7 0 22.6 3.1 32 8.6V160C384 71.6 312.4 0 224 0H162.3C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149v27c0 35.3 28.7 64 64 64h88c22.1 0 40-17.9 40-40s-17.9-40-40-40H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c39.8 0 72 32.2 72 72z"
                }
            }
        ]
    })(props);
}
function FaHandPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64L32 96zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32c0 13.2-4 25.4-10.8 35.6c24.9 8.7 42.8 32.5 42.8 60.4c0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
                }
            }
        ]
    })(props);
}
function FaHandPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32c0 13.2 4 25.4 10.8 35.6C177.9 364.3 160 388.1 160 416c0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
                }
            }
        ]
    })(props);
}
function FaHandPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32V240H32V32zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V192zm-64-64c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6c13.2 0 25.4-4 35.6-10.8c8.7 24.9 32.5 42.8 60.4 42.8c11.7 0 22.6-3.1 32-8.6V352c0 88.4-71.6 160-160 160H162.3c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363V336c0-35.3 28.7-64 64-64h88c22.1 0 40 17.9 40 40s-17.9 40-40 40H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c39.8 0 72-32.2 72-72z"
                }
            }
        ]
    })(props);
}
function FaHandPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
                }
            }
        ]
    })(props);
}
function FaHandScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32c0 25.3 19.5 46 44.3 47.9c-7.7 8.5-12.3 19.8-12.3 32.1c0 26.5 21.5 48 48 48l32 0 64 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3C444.8 76.8 413.9 64 381.7 64L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4L288 129.9l0 .1L84 65.8C62.9 59.2 40.5 70.9 33.8 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
                }
            }
        ]
    })(props);
}
function FaHandSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-17.7 14.3-32 32-32s32 14.3 32 32V323.1c-11.9 4.8-21.3 14.9-25 27.8l-8.9 31.2L478.9 391C460.6 396.3 448 413 448 432c0 18.9 12.5 35.6 30.6 40.9C448.4 497.4 409.9 512 368 512H348.8c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V240c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6L288 352l-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7L288 384l7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6L320 384l25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7L320 352l-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456l-13.8 48.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456l-48.3-13.8c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408l13.8-48.3c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
                }
            }
        ]
    })(props);
}
function FaHandSpock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.9 23.7C242.3 6.6 224.8-3.5 207.7 1.1s-27.2 22.1-22.6 39.2L238 237.8c2.5 9.2-4.5 18.2-14 18.2c-6.4 0-12-4.2-13.9-10.3L166.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L99.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L156.8 448c43.1 41.1 100.4 64 160 64h10.9 8.2c.1 0 .1-.1 .1-.1v0c0-.1 .1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L443.5 247.1c-1.6 5.3-6.4 8.9-12 8.9c-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L355.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9c-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
                }
            }
        ]
    })(props);
}
function FaHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V336c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4s-14.6 41.3 1.4 56.6L124.8 448c43.1 41.1 100.4 64 160 64H304c97.2 0 176-78.8 176-176V128c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V32z"
                }
            }
        ]
    })(props);
}
function FaHandcuffs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM192 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 80c17.7 0 32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C280.3 229.6 320 286.2 320 352c0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.8 39.7-122.4 96.5-146.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32zm0 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192-96c0-25.9-5.1-50.5-14.4-73.1c16.9-32.9 44.8-59.1 78.9-73.9c-.4-1.6-.5-3.3-.5-5.1V184c0-13.3 10.7-24 24-24h8c0-17.7 14.3-32 32-32s32 14.3 32 32h8c13.3 0 24 10.7 24 24v16c0 1.7-.2 3.4-.5 5.1C600.3 229.6 640 286.2 640 352c0 88.4-71.6 160-160 160c-62 0-115.8-35.3-142.4-86.9c9.3-22.5 14.4-47.2 14.4-73.1zm224 0a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM368 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm80 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaHandsAslInterpreting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7V256c0 70.7 57.3 128 128 128h72 8v-.3c35.2-2.7 65.4-22.8 82.1-51.7c8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20c-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20c8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5L194.9 124.6l81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4L133.6 92.3l23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2V256c0-70.7-57.3-128-128-128H440h-8v.3c-35.2 2.7-65.4 22.8-82.1 51.7c-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20c22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20c-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.7-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
                }
            }
        ]
    })(props);
}
function FaHandsBound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C96 14.3 81.7 0 64 0S32 14.3 32 32V96v59.1 .7V192v21.9c0 14.2 5.1 27.9 14.3 38.7L131.6 352H128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32H288h64H480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-3.6l85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7V192 155.8v-.7V96 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V96v48.8l-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8c-9.7-5.7-12.1-18.7-5.1-27.5L473 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C361 209.7 352 233.4 352 258.1V320v32H288V320 258.1c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2s-15.2 30.9-4.4 44.5l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5c-8.1 4.8-18.6 2.7-24.2-4.8L96 144.8V96 32zm64 448v32H288V480h64v32H480V480h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H480 352 288 160 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h32z"
                }
            }
        ]
    })(props);
}
function FaHandsBubbles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM32 160l.1 72.6c.1 52.2 24 101 64 133.1c-.1-1.9-.1-3.8-.1-5.7v-8c0-71.8 37-138.6 97.9-176.7l60.2-37.6c8.6-5.4 17.9-8.4 27.3-9.4l45.9-79.5c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-78 135.1c-3.3 5.7-10.7 7.7-16.4 4.4s-7.7-10.7-4.4-16.4l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S214 5 207.4 16.5l-68 117.8 0 0 0 0-43.3 75L96 160c0-17.7-14.4-32-32-32s-32 14.4-32 32zM332.1 88.5L307.5 131c13.9 4.5 26.4 13.7 34.7 27c.9 1.5 1.7 2.9 2.5 4.4l28.9-50c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-26.8 46.4c-.6 6-2.1 11.8-4.3 17.4H352h13.3l0 0H397l23-39.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM315.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C159.3 234.7 128 291.2 128 352v8c0 8.9 .8 17.6 2.2 26.1c35.4 8.2 61.8 40 61.8 77.9c0 6.3-.7 12.5-2.1 18.4C215.1 501 246.3 512 280 512H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H364c-6.6 0-12-5.4-12-12s5.4-12 12-12H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H352l0 0 0 0H258.8L305 219.1c15-9.4 19.5-29.1 10.2-44.1z"
                }
            }
        ]
    })(props);
}
function FaHandsClapping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 16V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-98.7 7.1l32 48c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-32-48c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4c-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1c48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16V192c0-17.7 14.3-32 32-32s32 14.3 32 32V345.6c0 57.1-30 110-78.9 139.4zM424.9 18.7c7.4 4.9 9.3 14.8 4.4 22.2l-32 48c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l32-48c4.9-7.4 14.8-9.3 22.2-4.4z"
                }
            }
        ]
    })(props);
}
function FaHandsHoldingChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm44.7 164.3L375.8 253c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35h-7.6l-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8L255.5 181c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 104.8 295.3 96 320 96s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8l-19.8-16.7zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
                }
            }
        ]
    })(props);
}
function FaHandsHoldingCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0a128 128 0 1 1 0 256A128 128 0 1 1 320 0zM40 64c22.1 0 40 17.9 40 40v40 80 40.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1c12.9-8.6 14.7-26.9 3.7-37.8l-15.2-15.2-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l32 32 15.2 15.2 0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2V464c0 26.5-21.5 48-48 48H173.3c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5V224 160 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40v56 64V325.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7H400c-26.5 0-48-21.5-48-48V385.1c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0 15.2-15.2 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32-15.2 15.2c-11 11-9.2 29.2 3.7 37.8c9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3V224 144 104c0-22.1 17.9-40 40-40z"
                }
            }
        ]
    })(props);
}
function FaHandsHolding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104v56 64V325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7H240c26.5 0 48-21.5 48-48V385.1c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0-15.2-15.2-32-32c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l32 32 15.2 15.2c11 11 9.2 29.2-3.7 37.8c-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3V224 144 104zm480 0v40 80 40.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1c-12.9-8.6-14.7-26.9-3.7-37.8l15.2-15.2 32-32c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-32 32-15.2 15.2 0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2V464c0 26.5 21.5 48 48 48h66.7c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9V224 160 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
                }
            }
        ]
    })(props);
}
function FaHandsPraying(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 4.8c3.2-2 6.6-3.3 10-4.1c4.7-1 9.6-.9 14.1 .1c7.7 1.8 14.8 6.5 19.4 13.6L514.6 194.2c8.8 13.1 13.4 28.6 13.4 44.4v73.5c0 6.9 4.4 13 10.9 15.2l79.2 26.4C631.2 358 640 370.2 640 384v96c0 9.9-4.6 19.3-12.5 25.4s-18.1 8.1-27.7 5.5L431 465.9c-56-14.9-95-65.7-95-123.7V224c0-17.7 14.3-32 32-32s32 14.3 32 32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V219.1c0-7-1.8-13.8-5.3-19.8L340.3 48.1c-1.7-3-2.9-6.1-3.6-9.3c-1-4.7-1-9.6 .1-14.1c1.9-8 6.8-15.2 14.3-19.9zm-62.4 0c7.5 4.6 12.4 11.9 14.3 19.9c1.1 4.6 1.2 9.4 .1 14.1c-.7 3.2-1.9 6.3-3.6 9.3L213.3 199.3c-3.5 6-5.3 12.9-5.3 19.8V304c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32V342.3c0 58-39 108.7-95 123.7l-168.7 45c-9.6 2.6-19.9 .5-27.7-5.5S0 490 0 480V384c0-13.8 8.8-26 21.9-30.4l79.2-26.4c6.5-2.2 10.9-8.3 10.9-15.2V238.5c0-15.8 4.7-31.2 13.4-44.4L245.2 14.5c4.6-7.1 11.7-11.8 19.4-13.6c4.6-1.1 9.4-1.2 14.1-.1c3.5 .8 6.9 2.1 10 4.1z"
                }
            }
        ]
    })(props);
}
function FaHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160l-.1 72.6c-.1 52.2-24 101-64 133.1c.1-1.9 .1-3.8 .1-5.7v-8c0-71.8-37-138.6-97.9-176.7l-60.2-37.6c-8.6-5.4-17.9-8.4-27.3-9.4L248.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l78 135.1c3.3 5.7 10.7 7.7 16.4 4.4s7.7-10.7 4.4-16.4l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S362 5 368.6 16.5l68 117.8 0 0 0 0 43.3 75L480 160c0-17.7 14.4-32 32-32s32 14.4 32 32zM243.9 88.5L268.5 131c-13.9 4.5-26.4 13.7-34.7 27c-.9 1.4-1.7 2.9-2.5 4.4l-28.9-50c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l26.8 46.4c.6 6 2.1 11.8 4.3 17.4H224 210.7l0 0H179l-23-39.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM260.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C416.7 234.7 448 291.2 448 352v8c0 83.9-68.1 152-152 152H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h92c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H56c-13.3 0-24-10.7-24-24s10.7-24 24-24H212c6.6 0 12-5.4 12-12s-5.4-12-12-12H88c-13.3 0-24-10.7-24-24s10.7-24 24-24H224l0 0 0 0h93.2L271 219.1c-15-9.4-19.5-29.1-10.2-44.1z"
                }
            }
        ]
    })(props);
}
function FaHandshakeAngle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 248v3.3l69.7-69.7c21.9-21.9 21.9-57.3 0-79.2L535.6 24.4c-21.9-21.9-57.3-21.9-79.2 0L416.3 64.5c-2.7-.3-5.5-.5-8.3-.5H296c-37.1 0-67.6 28-71.6 64H224V248c0 22.1 17.9 40 40 40s40-17.9 40-40V176c0 0 0-.1 0-.1V160l16 0 136 0c0 0 0 0 .1 0H464c44.2 0 80 35.8 80 80v8zM336 192v56c0 39.8-32.2 72-72 72s-72-32.2-72-72V129.4c-35.9 6.2-65.8 32.3-76 68.2L99.5 255.2 26.3 328.4c-21.9 21.9-21.9 57.3 0 79.2l78.1 78.1c21.9 21.9 57.3 21.9 79.2 0l37.7-37.7c.9 0 1.8 .1 2.7 .1H384c26.5 0 48-21.5 48-48c0-5.6-1-11-2.7-16H432c26.5 0 48-21.5 48-48c0-12.8-5-24.4-13.2-33c25.7-5 45.1-27.6 45.2-54.8v-.4c-.1-30.8-25.1-55.8-56-55.8c0 0 0 0 0 0l-120 0z"
                }
            }
        ]
    })(props);
}
function FaHandshakeSimpleSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L41.2 128.5C17.9 131.8 0 151.8 0 176V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6z"
                }
            }
        ]
    })(props);
}
function FaHandshakeSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L550.2 352H592c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H516h-4-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48H48c-26.5 0-48 21.5-48 48V304c0 26.5 21.5 48 48 48H156.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123z"
                }
            }
        ]
    })(props);
}
function FaHandshakeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-135-105.8c-1.1-11.3-6.3-22.3-15.3-30.7l-134.2-123-23.4 18.2-26-20.3 77.2-60.1c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2l-89.7 72.6-25.8-20.3 81.8-66.2c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-35.5 23.7L38.8 5.1zM413.6 421.9L128 196.8V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c.8-.8 1.5-1.7 2.2-2.6zM96 171.6L40.6 128H16c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V171.6zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                }
            }
        ]
    })(props);
}
function FaHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8V128h-.7l-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48V352h28.2l91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16V352c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V128H16zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128V352c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V144c0-8.8-7.2-16-16-16H544zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                }
            }
        ]
    })(props);
}
function FaHanukiah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.2 3.3C309.1 12.1 296 36.6 296 56c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C324.6 1.2 322.4 0 320 0s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7C36.6 49.2 34.4 48 32 48s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7C165.1 60.1 152 84.6 152 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3C389.1 60.1 376 84.6 376 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7C517.1 60.1 504 84.6 504 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7c-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v96 16h32V272 176c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32V320H96c-17.7 0-32-14.3-32-32V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 53 43 96 96 96H288v64H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H320 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H544c53 0 96-43 96-96V192c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H352V144z"
                }
            }
        ]
    })(props);
}
function FaHardDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V280.4c-17-15.2-39.4-24.4-64-24.4H64c-24.6 0-47 9.2-64 24.4V96zM64 288H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V352c0-35.3 28.7-64 64-64zM320 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaHashtag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
                }
            }
        ]
    })(props);
}
function FaHatCowboySide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.7 135.9l-10.4 57.2c6.8-.7 13.6-1.1 20.5-1.1h10.7c39.4 0 77.8 12.1 110.1 34.7L562.4 421.8l35.1 24.6c24.4-6 42.5-28.1 42.5-54.4c0-75.8-94.7-126.6-134.6-144.7L474 83.9C468.2 53.8 441.8 32 411.1 32h-2.7c-5.6 0-11.1 .7-16.5 2.2L199.2 85.5c-23.9 6.4-42 26-46.5 50.4zM0 384c0 35.3 28.7 64 64 64H544L265.3 252.9c-26.9-18.8-58.9-28.9-91.8-28.9H162.9c-60.6 0-116 34.2-143.1 88.4L13.5 325C4.6 342.7 0 362.3 0 382.2V384z"
                }
            }
        ]
    })(props);
}
function FaHatCowboy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64c14.4 0 22.3-7 30.8-14.4C360.4 41.1 370.7 32 392 32c49.3 0 84.4 152.2 97.9 221.9C447.8 272.1 390.9 288 320 288s-127.8-15.9-169.9-34.1C163.6 184.2 198.7 32 248 32c21.3 0 31.6 9.1 41.2 17.6C297.7 57 305.6 64 320 64zM111.1 270.7c47.2 24.5 117.5 49.3 209 49.3s161.8-24.8 208.9-49.3c24.8-12.9 49.8-28.3 70.1-47.7c7.9-7.9 20.2-9.2 29.6-3.3c9.5 5.9 13.5 17.9 9.9 28.5c-13.5 37.7-38.4 72.3-66.1 100.6C523.7 398.9 443.6 448 320 448s-203.6-49.1-252.5-99.2C39.8 320.4 14.9 285.8 1.4 248.1c-3.6-10.6 .4-22.6 9.9-28.5c9.5-5.9 21.7-4.5 29.6 3.3c20.4 19.4 45.3 34.8 70.1 47.7z"
                }
            }
        ]
    })(props);
}
function FaHatWizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 416L168.6 180.7c15.3-34.4 40.3-63.5 72-83.7l146.9-94c3-1.9 6.5-2.9 10-2.9C407.7 0 416 8.3 416 18.6v1.6c0 2.6-.5 5.1-1.4 7.5L354.8 176.9c-1.9 4.7-2.8 9.7-2.8 14.7c0 5.5 1.2 11 3.4 16.1L448 416H240.9l11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 276.4 230.9 272 224 272s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 339 144 345.1 144 352s4.4 13 10.9 15.2l40.4 13.5L207.1 416H64zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaHeadSideCoughSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 325.8l44 34.5c8.1 1.4 14.8 6.8 18 14.1L552.9 408c10.6 .4 19.5 7.6 22.2 17.4l39.1 30.6c.6 0 1.2-.1 1.8-.1c11.1 0 20.4 7.5 23.2 17.8h-3.9c6.2 8.5 6.4 20.4-.4 29c-8.2 10.4-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L89.6 44.9C127 16.7 173.5 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 5.8zM0 224.2c0-38.7 9.8-75.1 27.1-106.9L341.8 365.3l-2.5 .3c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9l62 3.9 43 33.9C439.3 466.2 421.2 480 400 480H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM616 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-64-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaHeadSideCough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v0 32L339.2 365.6c-11 1.4-19.2 10.7-19.2 21.8c0 11.6 9 21.2 20.6 21.9L448 416v16c0 26.5-21.5 48-48 48H320v8c0 13.3-10.7 24-24 24H256v0H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zm352-.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM464 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM592 480a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 312a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM552 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaHeadSideMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 224.2c0-22.2 3.2-43.6 9.2-63.9L262.2 321c-4 9.5-6.2 20-6.2 31V512H128c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C48.6 322.4 32 274.1 32 224.2zm248.3 70.4L53 129.3C88.7 53 166.2 0 256 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c5.4 6.7 8.6 14.8 9.4 23.2H336c-21.7 0-41.3 8.6-55.7 22.6zM336 304H534l0 0h10l-19.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H514.5l-9.8 32H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H494.8l-.9 2.8c-8.3 26.9-33.1 45.2-61.2 45.2H288V352c0-14 6-26.7 15.6-35.4c0 0 0 0 0 0c8.5-7.8 19.9-12.6 32.4-12.6zm48-80a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaHeadSideVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224.2C0 100.6 100.2 0 224 0h24c95.2 0 181.2 69.3 197.3 160.2c2.3 13 6.8 25.7 15.1 36l42 52.6c6.2 7.8 9.6 17.4 9.6 27.4c0 24.2-19.6 43.8-43.8 43.8H448v64c0 35.3-28.7 64-64 64H320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V407.3c0-16.7-6.9-32.5-17.1-45.8C16.6 322.4 0 274.1 0 224.2zM224 64c-8.8 0-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16zm-24 96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                }
            }
        ]
    })(props);
}
function FaHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H80h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H112V208H336V96H320c-17.7 0-32-14.3-32-32s14.3-32 32-32h48 48c17.7 0 32 14.3 32 32s-14.3 32-32 32H400V240 416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H368 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h16V272H112V416h16c17.7 0 32 14.3 32 32s-14.3 32-32 32H80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V240 96H32C14.3 96 0 81.7 0 64z"
                }
            }
        ]
    })(props);
}
function FaHeadphonesSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 80C141.1 80 48 173.1 48 288V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288C0 146.6 114.6 32 256 32s256 114.6 256 256V392c0 13.3-10.7 24-24 24s-24-10.7-24-24V288c0-114.9-93.1-208-208-208zM80 352c0-35.3 28.7-64 64-64h16c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V352zm288-64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h16z"
                }
            }
        ]
    })(props);
}
function FaHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 80C149.9 80 62.4 159.4 49.6 262c9.4-3.8 19.6-6 30.4-6c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48c-44.2 0-80-35.8-80-80V384 336 288C0 146.6 114.6 32 256 32s256 114.6 256 256v48 48 16c0 44.2-35.8 80-80 80c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48c10.8 0 21 2.1 30.4 6C449.6 159.4 362.1 80 256 80z"
                }
            }
        ]
    })(props);
}
function FaHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48C141.1 48 48 141.1 48 256v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V256C0 114.6 114.6 0 256 0S512 114.6 512 256V400.1c0 48.6-39.4 88-88.1 88L313.6 488c-8.3 14.3-23.8 24-41.6 24H240c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c17.8 0 33.3 9.7 41.6 24l110.4 .1c22.1 0 40-17.9 40-40V256c0-114.9-93.1-208-208-208zM144 208h16c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H144c-35.3 0-64-28.7-64-64V272c0-35.3 28.7-64 64-64zm224 0c35.3 0 64 28.7 64 64v48c0 35.3-28.7 64-64 64H352c-17.7 0-32-14.3-32-32V240c0-17.7 14.3-32 32-32h16z"
                }
            }
        ]
    })(props);
}
function FaHeartCircleBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
                }
            }
        ]
    })(props);
}
function FaHeartCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaHeartCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaHeartCircleMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaHeartCirclePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaHeartCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9l2.6-2.4C267.2 438.6 256 404.6 256 368c0-97.2 78.8-176 176-176c28.3 0 55 6.7 78.7 18.5c.9-6.5 1.3-13 1.3-19.6v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaHeartCrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M119.4 44.1c23.3-3.9 46.8-1.9 68.6 5.3l49.8 77.5-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.8 61.8c28.5-16.7 62.4-23.2 95.7-17.6C461.5 55.6 512 115.2 512 185.1v5.8c0 41.5-17.2 81.2-47.6 109.5L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9L47.6 300.4C17.2 272.1 0 232.4 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141z"
                }
            }
        ]
    })(props);
}
function FaHeartPulse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M228.3 469.1L47.6 300.4c-4.2-3.9-8.2-8.1-11.9-12.4h87c22.6 0 43-13.6 51.7-34.5l10.5-25.2 49.3 109.5c3.8 8.5 12.1 14 21.4 14.1s17.8-5 22-13.3L320 253.7l1.7 3.4c9.5 19 28.9 31 50.1 31H476.3c-3.7 4.3-7.7 8.5-11.9 12.4L283.7 469.1c-7.5 7-17.4 10.9-27.7 10.9s-20.2-3.9-27.7-10.9zM503.7 240h-132c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3s-17.4 5.1-21.5 13.3l-41.4 82.8L205.9 158.2c-3.9-8.7-12.7-14.3-22.2-14.1s-18.1 5.9-21.8 14.8l-31.8 76.3c-1.2 3-4.2 4.9-7.4 4.9H16c-2.6 0-5 .4-7.3 1.1C3 225.2 0 208.2 0 190.9v-5.8c0-69.9 50.5-129.5 119.4-141C165 36.5 211.4 51.4 244 84l12 12 12-12c32.6-32.6 79-47.5 124.6-39.9C461.5 55.6 512 115.2 512 185.1v5.8c0 16.9-2.8 33.5-8.3 49.1z"
                }
            }
        ]
    })(props);
}
function FaHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
                }
            }
        ]
    })(props);
}
function FaHelicopterSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.3 224H510C495.6 108.2 403.8 16.4 288 2V66.7C368.4 80.1 431.9 143.6 445.3 224zM510 288H445.3C431.9 368.4 368.4 431.9 288 445.4V510c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510V445.4C143.6 431.9 80.1 368.4 66.7 288H2zm0-64H66.7C80.1 143.6 143.6 80.1 224 66.7V2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V288h96v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H208V160z"
                }
            }
        ]
    })(props);
}
function FaHelicopter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H384v64h32c88.4 0 160 71.6 160 160v64c0 17.7-14.3 32-32 32H384 320c-20.1 0-39.1-9.5-51.2-25.6l-71.4-95.2c-3.5-4.7-8.3-8.3-13.7-10.5L47.2 198.1c-9.5-3.8-16.7-12-19.2-22L5 83.9C2.4 73.8 10.1 64 20.5 64H48c10.1 0 19.6 4.7 25.6 12.8L112 128H320V64H160c-17.7 0-32-14.3-32-32zM384 320H512V288c0-53-43-96-96-96H384V320zM630.6 425.4c12.5 12.5 12.5 32.8 0 45.3l-3.9 3.9c-24 24-56.6 37.5-90.5 37.5H256c-17.7 0-32-14.3-32-32s14.3-32 32-32H536.2c17 0 33.3-6.7 45.3-18.7l3.9-3.9c12.5-12.5 32.8-12.5 45.3 0z"
                }
            }
        ]
    })(props);
}
function FaHelmetSafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c-17.7 0-32 14.3-32 32v2.3 99.6c0 5.6-4.5 10.1-10.1 10.1c-3.6 0-7-1.9-8.8-5.1L157.1 87C83 123.5 32 199.8 32 288v64H544l0-66.4c-.9-87.2-51.7-162.4-125.1-198.6l-48 83.9c-1.8 3.2-5.2 5.1-8.8 5.1c-5.6 0-10.1-4.5-10.1-10.1V66.3 64c0-17.7-14.3-32-32-32H256zM16.6 384C7.4 384 0 391.4 0 400.6c0 4.7 2 9.2 5.8 11.9C27.5 428.4 111.8 480 288 480s260.5-51.6 282.2-67.5c3.8-2.8 5.8-7.2 5.8-11.9c0-9.2-7.4-16.6-16.6-16.6H16.6z"
                }
            }
        ]
    })(props);
}
function FaHelmetUn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.5 224C471.2 98.9 367.2 0 240 0C107.5 0 0 107.5 0 240v56.3C0 344.8 39.2 384 87.7 384H200h14.9L343.5 505.4c4.5 4.2 10.4 6.6 16.5 6.6h96c13.3 0 24-10.7 24-24s-10.7-24-24-24H369.5l-1.5-1.5V288h80 32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.5zM320 417.2l-78-73.7L274.4 288H320V417.2zM285.3 103.1l34.7 52V112c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaHighlighter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M315 315l158.4-215L444.1 70.6 229 229 315 315zm-187 5l0 0V248.3c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0c11.4 0 22.4 4.5 30.5 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5c0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5H224l-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l63-63 70.6 70.6-31 31c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17z"
                }
            }
        ]
    })(props);
}
function FaHillAvalanche(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.7 401.9c34.2 23.1 81.1 19.5 111.4-10.8c34.4-34.4 34.4-90.1 0-124.4c-27.8-27.8-69.5-33.1-102.6-16c-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7C401.2 261.3 416 236.4 416 208c0-33.9-21.1-62.9-50.9-74.5c1.9-6.8 2.9-14 2.9-21.5c0-44.2-35.8-80-80-80c-27.3 0-51.5 13.7-65.9 34.6C216.3 46.6 197.9 32 176 32c-26.5 0-48 21.5-48 48c0 4 .5 7.9 1.4 11.6L439.7 401.9zM480 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87z"
                }
            }
        ]
    })(props);
}
function FaHillRockslide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2H293.4c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3V432c0 44.2 35.8 80 80 80H396.7c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9V309.4c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9v53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaHippo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2h32c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1c0 10.2 7.4 18.8 16.7 23c27.9 12.5 47.3 40.5 47.3 73c0 26.2-12.6 49.4-32 64v32c0 8.8-7.2 16-16 16H560c-8.8 0-16-7.2-16-16V320H480v16c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V318.4c-11.8-2.4-22.7-7.4-32-14.4c-1.5-1.1-2.9-2.3-4.3-3.5c-17-14.7-27.7-36.4-27.7-60.5c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2V352c0 17.7 14.3 32 32 32h32v64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V372c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12v76c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V329.1L45.9 369.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7C32 155.7 117.2 68 223.8 64.1l.2-.1h7.2H256h32c41.7 0 83.4 12.1 117.2 25.7c1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaHockeyPuck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 256C114.6 256 0 213 0 160s114.6-96 256-96s256 43 256 96s-114.6 96-256 96zm192.3 1.8c24.7-9.3 46.9-21 63.7-35.6V352c0 53-114.6 96-256 96S0 405 0 352V222.3c16.8 14.6 39 26.3 63.7 35.6C114.5 276.9 182.5 288 256 288s141.5-11.1 192.3-30.2z"
                }
            }
        ]
    })(props);
}
function FaHollyBerry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM276.8 383.8c1 .1 2.1 .2 3.2 .2c39.8 0 72 32.2 72 72v22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.6 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6c-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7c4.2 9.7 5.8 20.8 3.7 32.3L275 298.7c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.6 234.5c-15.5-5.2-31.6 6.4-31.6 22.8v32C96 323.9 67.9 352 33.3 352c-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.2 489.4 22.6 505.8 40.5 501L60 495.6c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7c16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5L196 240.4c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaHorseHead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464V316.9c0-108.4 68.3-205.1 170.5-241.3L404.2 15.5C425.6 7.9 448 23.8 448 46.4c0 11-5.5 21.2-14.6 27.3L400 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5c-16 16-37.8 25.1-60.5 25.1h-3.4c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0 0 0c-6.3 0-12.5-.5-18.6-1.5c-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4c0 20.3-16.5 36.8-36.8 36.8H112c-26.5 0-48-21.5-48-48zM392 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaHorse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 238.1V160h16l9.8 19.6c12.5 25.1 42.2 36.4 68.3 26c20.5-8.2 33.9-28 33.9-50.1V80c0-19.1-8.4-36.3-21.7-48H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H480 448C377.3 0 320 57.3 320 128H224 203.2 148.8c-30.7 0-57.6 16.3-72.5 40.8C33.2 174.5 0 211.4 0 256v56c0 13.3 10.7 24 24 24s24-10.7 24-24V256c0-13.4 6.6-25.2 16.7-32.5c1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6c-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9h33.7c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7c0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8V480c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V315.7c19.2-19.2 31.5-45.7 32-75.7h0v-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                }
            }
        ]
    })(props);
}
function FaHospitalUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V256H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v64H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H0v80c0 26.5 21.5 48 48 48H265.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM152 64h16c8.8 0 16 7.2 16 16v24h24c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H184v24c0 8.8-7.2 16-16 16H152c-8.8 0-16-7.2-16-16V152H112c-8.8 0-16-7.2-16-16V120c0-8.8 7.2-16 16-16h24V80c0-8.8 7.2-16 16-16zM512 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM288 477.1c0 19.3 15.6 34.9 34.9 34.9H541.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H381.1c-51.4 0-93.1 41.7-93.1 93.1z"
                }
            }
        ]
    })(props);
}
function FaHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 48c0-26.5 21.5-48 48-48H400c26.5 0 48 21.5 48 48V512H368V432c0-26.5-21.5-48-48-48s-48 21.5-48 48v80H192V48zM48 96H160V512H48c-26.5 0-48-21.5-48-48V320H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V224H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H0V144c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v48H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H560c-8.8 0-16 7.2-16 16s7.2 16 16 16h80V464c0 26.5-21.5 48-48 48H480V96H592zM312 64c-8.8 0-16 7.2-16 16v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V152h24c8.8 0 16-7.2 16-16V120c0-8.8-7.2-16-16-16H344V80c0-8.8-7.2-16-16-16H312z"
                }
            }
        ]
    })(props);
}
function FaHotTubPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"
                }
            }
        ]
    })(props);
}
function FaHotdog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 23.4c31.2 31.2 31.2 81.9 0 113.1l-352 352c-31.2 31.2-81.9 31.2-113.1 0s-31.2-81.9 0-113.1l352-352c31.2-31.2 81.9-31.2 113.1 0zM443.3 92.7c-6.2-6.2-16.4-6.2-22.6 0c-12.5 12.5-23.8 15.1-37.5 17.6l-2.5 .4c-13.8 2.5-31.6 5.6-48 22c-16.7 16.7-20.9 36-24.1 50.9l0 0v0l-.2 1c-3.4 15.6-6 26.4-15.7 36.1s-20.5 12.3-36.1 15.7l-1 .2c-14.9 3.2-34.2 7.4-50.9 24.1s-20.9 36-24.1 50.9l-.2 1c-3.4 15.6-6 26.4-15.7 36.1c-9.2 9.2-18 10.8-32.7 13.4l0 0-.9 .2c-15.6 2.8-34.9 6.9-54.4 26.4c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c12.5-12.5 23.8-15.1 37.5-17.6l2.5-.4c13.8-2.5 31.6-5.6 48-22c16.7-16.7 20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1s20.5-12.3 36.1-15.7l1-.2c14.9-3.2 34.2-7.4 50.9-24.1s20.9-36 24.1-50.9l.2-1c3.4-15.6 6-26.4 15.7-36.1c9.2-9.2 18-10.8 32.7-13.4l.9-.2c15.6-2.8 34.9-6.9 54.4-26.4c6.2-6.2 6.2-16.4 0-22.6zM191.2 479.2l288-288L495 207c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L289 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17l-15.8-15.8zM17 305C6.1 294.1 0 279.4 0 264s6.1-30.1 17-41L223 17C233.9 6.1 248.6 0 264 0s30.1 6.1 41 17l15.8 15.8-288 288L17 305z"
                }
            }
        ]
    })(props);
}
function FaHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V448c17.7 0 32 14.3 32 32s-14.3 32-32 32H304V464c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V64C14.3 64 0 49.7 0 32zm96 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM240 96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H240zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zM112 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H112zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H368zM328 384c13.3 0 24.3-10.9 21-23.8c-10.6-41.5-48.2-72.2-93-72.2s-82.5 30.7-93 72.2c-3.3 12.8 7.8 23.8 21 23.8H328z"
                }
            }
        ]
    })(props);
}
function FaHourglassEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 25.5-10.1 49.9-28.1 67.9L192 210.7l-67.9-67.9C106.1 124.9 96 100.4 96 75z"
                }
            }
        ]
    })(props);
}
function FaHourglassHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM96 75V64H288V75c0 19-5.6 37.4-16 53H112c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9L192 301.3l67.9 67.9c4.6 4.6 8.6 9.6 12.1 14.9H112z"
                }
            }
        ]
    })(props);
}
function FaHourglassStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64V75c0 42.4 16.9 83.1 46.9 113.1L146.7 256 78.9 323.9C48.9 353.9 32 394.6 32 437v11c-17.7 0-32 14.3-32 32s14.3 32 32 32H64 320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V437c0-42.4-16.9-83.1-46.9-113.1L237.3 256l67.9-67.9c30-30 46.9-70.7 46.9-113.1V64c17.7 0 32-14.3 32-32s-14.3-32-32-32H320 64 32zM288 437v11H96V437c0-25.5 10.1-49.9 28.1-67.9L192 301.3l67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
                }
            }
        ]
    })(props);
}
function FaHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0H64 320h32c17.7 0 32 14.3 32 32s-14.3 32-32 32V75c0 42.4-16.9 83.1-46.9 113.1L237.3 256l67.9 67.9c30 30 46.9 70.7 46.9 113.1v11c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 64 32c-17.7 0-32-14.3-32-32s14.3-32 32-32V437c0-42.4 16.9-83.1 46.9-113.1L146.7 256 78.9 188.1C48.9 158.1 32 117.4 32 75V64C14.3 64 0 49.7 0 32zM96 64V75c0 25.5 10.1 49.9 28.1 67.9L192 210.7l67.9-67.9c18-18 28.1-42.4 28.1-67.9V64H96zm0 384H288V437c0-25.5-10.1-49.9-28.1-67.9L192 301.3l-67.9 67.9c-18 18-28.1 42.4-28.1 67.9v11z"
                }
            }
        ]
    })(props);
}
function FaHouseChimneyCrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H326.4L288 448l80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L250.6 263.2c-14.6-11.5-33.8 7-22.8 22L288 368l-85.5 71.2c-6.1 5-7.5 13.8-3.5 20.5L230.4 512H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24z"
                }
            }
        ]
    })(props);
}
function FaHouseChimneyMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM272 192c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H320V208c0-8.8-7.2-16-16-16H272z"
                }
            }
        ]
    })(props);
}
function FaHouseChimneyUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM288 160a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM176 400c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H192c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaHouseChimneyWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L416 100.7V64c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V185l52.8 46.4c8 7 12 15 11 24zM248 192c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V216c0-13.3-10.7-24-24-24H248z"
                }
            }
        ]
    })(props);
}
function FaHouseChimney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L512 185V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32v36.7L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64 24c0 22.1 17.9 40 40 40h24 32.5c1.4 0 2.8 0 4.2-.1c1.1 .1 2.2 .1 3.3 .1h16c22.1 0 40-17.9 40-40V455.8c.3-2.6 .5-5.3 .5-8.1l-.7-160.2h32z"
                }
            }
        ]
    })(props);
}
function FaHouseCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaHouseCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaHouseCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.7 352c8.1-89.7 83.5-160 175.3-160c8.9 0 17.6 .7 26.1 1.9L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32v69.7c-.1 .9-.1 1.8-.1 2.8V472c0 22.1 17.9 40 40 40h16c1.2 0 2.4-.1 3.6-.2c1.5 .1 3 .2 4.5 .2H160h24c22.1 0 40-17.9 40-40V448 384c0-17.7 14.3-32 32-32h64l.7 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaHouseCrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H230.4l-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L288 368l-60.2-82.8c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L288 448l38.4 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32z"
                }
            }
        ]
    })(props);
}
function FaHouseFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 350.1l0 1.9H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L447.3 128.1c-12.3-1-25 3-34.8 11.7c-35.4 31.6-65.6 67.7-87.3 102.8C304.3 276.5 288 314.9 288 350.1zM453.5 163.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM530 433c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15z"
                }
            }
        ]
    })(props);
}
function FaHouseFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 0c-17.7 0-32 14.3-32 32V192 512h64V192H624c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H512c0-17.7-14.3-32-32-32zM416 159L276.8 39.7c-12-10.3-29.7-10.3-41.7 0l-224 192C1 240.4-2.7 254.5 2 267.1S18.6 288 32 288H64V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h64.7l.2 0h-1V159z"
                }
            }
        ]
    })(props);
}
function FaHouseFloodWaterCircleArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144A144 144 0 1 0 0 144a144 144 0 1 0 288 0zM140.7 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 160H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4L140.7 99.3c-6.2-6.2-6.2-16.4 0-22.6zM320 144c0 57.3-27.4 108.2-69.8 140.3c11.8-3.6 23-9.4 33-16.2c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.4 78.1 3.4c2.1 1.7 4.2 3.3 6.5 4.9l-.3-84.4H576c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128C407.6-2 392.4-2 381.2 6.1L301 64.4c12.1 23.9 19 50.9 19 79.6zm18.5 165.9c-11.1-7.9-25.9-7.9-37 0C279 325.4 251.5 336 224 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 389.7 191 400 224 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C471.4 325.2 442.9 336 416 336c-27.5 0-55-10.6-77.5-26.1zm0 112c-11.1-7.9-25.9-7.9-37 0C279 437.4 251.5 448 224 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C158.5 501.7 191 512 224 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.6 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C471.4 437.2 442.9 448 416 448c-27.5 0-55-10.6-77.5-26.1z"
                }
            }
        ]
    })(props);
}
function FaHouseFloodWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M306.8 6.1C295.6-2 280.4-2 269.2 6.1l-176 128c-11.2 8.2-15.9 22.6-11.6 35.8S98.1 192 112 192h16v73c1.7 1 3.3 2 4.9 3.1c18 12.4 40.1 20.3 59.2 20.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.5-1 3-2 4.5-2.9l-.3-73.2H464c13.9 0 26.1-8.9 30.4-22.1s-.4-27.6-11.6-35.8l-176-128zM269.5 309.9C247 325.4 219.5 336 192 336c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 389.7 159 400 192 400c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
                }
            }
        ]
    })(props);
}
function FaHouseLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.3 8.5c12.3-11.3 31.2-11.3 43.4 0l208 192c6.7 6.2 10.3 14.8 10.3 23.5H336c-19.1 0-36.3 8.4-48 21.7V208c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64V416H112c-26.5 0-48-21.5-48-48V256H32c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8.1-35.2l208-192zM352 304V448H544V304H352zm-48-16c0-17.7 14.3-32 32-32H560c17.7 0 32 14.3 32 32V448h32c8.8 0 16 7.2 16 16c0 26.5-21.5 48-48 48H544 352 304c-26.5 0-48-21.5-48-48c0-8.8 7.2-16 16-16h32V288z"
                }
            }
        ]
    })(props);
}
function FaHouseLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480c0 11.7 3.1 22.6 8.6 32H392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L490.7 166.3C447.2 181.7 416 223.2 416 272v24.6c-19.1 11.1-32 31.7-32 55.4V480zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
                }
            }
        ]
    })(props);
}
function FaHouseMedicalCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm32 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaHouseMedicalCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaHouseMedicalCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 368c0 59.5 29.5 112.1 74.8 144H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L522.1 193.9c-8.5-1.3-17.3-1.9-26.1-1.9c-54.7 0-103.5 24.9-135.8 64H320V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
                }
            }
        ]
    })(props);
}
function FaHouseMedicalFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 0c17.7 0 32 14.3 32 32H624c8.8 0 16 7.2 16 16V176c0 8.8-7.2 16-16 16H512V512H448V192 32c0-17.7 14.3-32 32-32zM276.8 39.7L416 159V512h1l-.2 0H96c-17.7 0-32-14.3-32-32V288H32c-13.4 0-25.4-8.3-30-20.9s-1-26.7 9.2-35.4l224-192c12-10.3 29.7-10.3 41.7 0zM224 208v48H176c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h48c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H288V208c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaHouseMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M543.8 287.6c17 0 32-14 32-32.1c1-9-3-17-11-24L309.5 7c-6-5-14-7-21-7s-15 1-22 8L10 231.5c-7 7-10 15-10 24c0 18 14 32.1 32 32.1h32V448c0 35.3 28.7 64 64 64H448.5c35.5 0 64.2-28.8 64-64.3l-.7-160.2h32zM256 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V320H208c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
                }
            }
        ]
    })(props);
}
function FaHouseSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.7 8.5c-12.3-11.3-31.2-11.3-43.4 0l-208 192c-9.4 8.6-12.7 22-8.5 34c87.1 25.3 155.6 94.2 180.3 181.6H464c26.5 0 48-21.5 48-48V256h32c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8.1-35.2l-208-192zM288 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V208zM24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24c101.6 0 184 82.4 184 184c0 13.3 10.7 24 24 24s24-10.7 24-24c0-128.1-103.9-232-232-232zm8 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM0 376c0 13.3 10.7 24 24 24c48.6 0 88 39.4 88 88c0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136c-13.3 0-24 10.7-24 24z"
                }
            }
        ]
    })(props);
}
function FaHouseTsunami(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.8 136.5C104.9 93.8 152.6 64 209 64c16.9 0 33.1 2.7 48.2 7.7c16.8 5.5 34.9-3.6 40.4-20.4s-3.6-34.9-20.4-40.4C255.8 3.8 232.8 0 209 0C95.2 0 0 88 0 200c0 91.6 53.5 172.1 142.2 194.1c13.4 3.8 27.5 5.9 42.2 5.9c.7 0 1.4 0 2.1-.1c1.8 0 3.7 .1 5.5 .1l0 0c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.5-27.3-10.1-39.2-1.7l0 0C439.4 325.2 410.9 336 384 336c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0c-22.4 15.5-49.9 26.1-77.4 26.1c0 0-.1 0-.1 0c-12.4 0-24-1.5-34.9-4.3C121.6 320.2 96 287 96 248c0-48.5 39.5-88 88.4-88c13.5 0 26.1 3 37.5 8.3c16 7.5 35.1 .6 42.5-15.5s.6-35.1-15.5-42.5C229.3 101.1 207.4 96 184.4 96c-40 0-76.4 15.4-103.6 40.5zm252-18.1c-8.1 6-12.8 15.5-12.8 25.6V265c1.6 1 3.3 2 4.8 3.1c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c23.8-16.7 55.8-15.3 78.1 3.4c10.6 8.8 24.2 15.6 37.3 18.6c5.8 1.4 11.2 3.4 16.2 6.2c.7-2.7 1.1-5.5 1.1-8.4l-.4-144c0-10-4.7-19.4-12.7-25.5l-95.5-72c-11.4-8.6-27.1-8.6-38.5 0l-96 72zM384 448c-27.5 0-55-10.6-77.5-26.1c-11.1-7.9-25.9-7.9-37 0C247 437.4 219.5 448 192 448c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 501.7 159 512 192 512c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 437.2 410.9 448 384 448z"
                }
            }
        ]
    })(props);
}
function FaHouseUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c.2 35.5-28.5 64.3-64 64.3H128.1c-35.3 0-64-28.7-64-64V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24zM352 224a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-96 96c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H256z"
                }
            }
        ]
    })(props);
}
function FaHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                }
            }
        ]
    })(props);
}
function FaHryvniaSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.9 116.2C138.3 103.1 158.7 96 179.6 96H223c27.1 0 49 21.9 49 49c0 11.5-4 22.4-11.1 31H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H155.5l-50.6 28.9c-1.7 1-3.4 2-5.1 3.1H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H52.3c-2.8 9.9-4.3 20.4-4.3 31c0 62.4 50.6 113 113 113h43.4c35.5 0 70-12.1 97.7-34.3L308 441c13.8-11 16-31.2 5-45s-31.2-16-45-5l-5.9 4.7c-16.4 13.1-36.7 20.2-57.7 20.2H161c-27.1 0-49-21.9-49-49c0-11.5 4-22.4 11.1-31H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H228.5l50.6-28.9c1.7-1 3.4-2 5.1-3.1H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H331.7c2.8-10 4.3-20.4 4.3-31c0-62.4-50.6-113-113-113H179.6c-35.5 0-70 12.1-97.7 34.3L76 71c-13.8 11-16 31.2-5 45s31.2 16 45 5l5.9-4.7z"
                }
            }
        ]
    })(props);
}
function FaHurricane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 208C0 104.4 75.7 18.5 174.9 2.6C184 1.2 192 8.6 192 17.9V81.2c0 8.4 6.5 15.3 14.7 16.5C307 112.5 384 199 384 303.4c0 103.6-75.7 189.5-174.9 205.4c-9.2 1.5-17.1-5.9-17.1-15.2V430.2c0-8.4-6.5-15.3-14.7-16.5C77 398.9 0 312.4 0 208zm288 48A96 96 0 1 0 96 256a96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaICursor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3V224H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H96v95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7s16.9 30.7 34.5 29.2l8-.7c34.1-2.8 64.2-18.9 85.4-42.9c21.2 24 51.2 40.1 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H160V128.3c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7C179.2 3.6 149.2 19.7 128 43.7c-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
                }
            }
        ]
    })(props);
}
function FaI(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96h96V416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V96h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 32z"
                }
            }
        ]
    })(props);
}
function FaIceCream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.1 160c.6-5.3 .9-10.6 .9-16C368 64.5 303.5 0 224 0S80 64.5 80 144c0 5.4 .3 10.7 .9 16H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h53.5 181H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-.9zM96 288L200.8 497.7c4.4 8.8 13.3 14.3 23.2 14.3s18.8-5.5 23.2-14.3L352 288H96z"
                }
            }
        ]
    })(props);
}
function FaIcicles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M75.8 304.8L1 35.7c-.7-2.5-1-5-1-7.5C0 12.6 12.6 0 28.2 0H482.4C498.8 0 512 13.2 512 29.6c0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9c-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1c-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7c-9.3 0-17.5-6.2-20-15.2z"
                }
            }
        ]
    })(props);
}
function FaIcons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.3 7.3C507.7 13.3 512 22.4 512 32V176c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V71L352 90.2V208c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48V64c0-15.3 10.8-28.4 25.7-31.4l160-32c9.4-1.9 19.1 .6 26.6 6.6zM74.7 304l11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2h61.7c10.7 0 20.7 5.3 26.6 14.2L213.3 304H240c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V352c0-26.5 21.5-48 48-48H74.7zM192 408a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM478.7 278.3L440.3 368H496c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.2-12.4-5.3-19.2L391.7 400H336c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112c5.6-4.9 13.9-5.3 19.9-.9s8.2 12.4 5.3 19.2zm-339-59.2c-6.5 6.5-17 6.5-23 0L19.9 119.2c-28-29-26.5-76.9 5-103.9c27-23.5 68.4-19 93.4 6.5l10 10.5 9.5-10.5c25-25.5 65.9-30 93.9-6.5c31 27 32.5 74.9 4.5 103.9l-96.4 99.9z"
                }
            }
        ]
    })(props);
}
function FaIdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM144 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaIdCardClip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0h64c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM64 64H192v48c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64zM176 437.3c0 5.9 4.8 10.7 10.7 10.7H389.3c5.9 0 10.7-4.8 10.7-10.7c0-29.5-23.9-53.3-53.3-53.3H229.3c-29.5 0-53.3 23.9-53.3 53.3zM288 352a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
                }
            }
        ]
    })(props);
}
function FaIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96l576 0c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm0 32V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128H0zM64 405.3c0-29.5 23.9-53.3 53.3-53.3H234.7c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7H74.7c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaIgloo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.8V160H48.5C100.2 82.8 188.1 32 288 32c10.8 0 21.5 .6 32 1.8zM352 160V39.1C424.9 55.7 487.2 99.8 527.5 160H352zM29.9 192H96V320H0c0-46 10.8-89.4 29.9-128zM192 320H128V192H448V320H384v32H576v80c0 26.5-21.5 48-48 48H352V352c0-35.3-28.7-64-64-64s-64 28.7-64 64V480H48c-26.5 0-48-21.5-48-48V352H192V320zm288 0V192h66.1c19.2 38.6 29.9 82 29.9 128H480z"
                }
            }
        ]
    })(props);
}
function FaImagePortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64l0-384zM128 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM80 356.6c0-37.9 30.7-68.6 68.6-68.6h86.9c37.9 0 68.6 30.7 68.6 68.6c0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6z"
                }
            }
        ]
    })(props);
}
function FaImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320H328 280 200c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120z"
                }
            }
        ]
    })(props);
}
function FaInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"
                }
            }
        ]
    })(props);
}
function FaIndent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
                }
            }
        ]
    })(props);
}
function FaIndianRupeeSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H96h16H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H231.8c9.6 14.4 16.7 30.6 20.7 48H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H252.4c-13.2 58.3-61.9 103.2-122.2 110.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256h80c32.8 0 61-19.7 73.3-48H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H185.3C173 115.7 144.8 96 112 96H96 32C14.3 96 0 81.7 0 64z"
                }
            }
        ]
    })(props);
}
function FaIndustry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64V304v48 80c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V304 152.2c0-18.2-19.4-29.7-35.4-21.1L352 215.4V152.2c0-18.2-19.4-29.7-35.4-21.1L160 215.4V64c0-17.7-14.3-32-32-32H64z"
                }
            }
        ]
    })(props);
}
function FaInfinity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 241.1C0 161 65 96 145.1 96c38.5 0 75.4 15.3 102.6 42.5L320 210.7l72.2-72.2C419.5 111.3 456.4 96 494.9 96C575 96 640 161 640 241.1v29.7C640 351 575 416 494.9 416c-38.5 0-75.4-15.3-102.6-42.5L320 301.3l-72.2 72.2C220.5 400.7 183.6 416 145.1 416C65 416 0 351 0 270.9V241.1zM274.7 256l-72.2-72.2c-15.2-15.2-35.9-23.8-57.4-23.8C100.3 160 64 196.3 64 241.1v29.7c0 44.8 36.3 81.1 81.1 81.1c21.5 0 42.2-8.5 57.4-23.8L274.7 256zm90.5 0l72.2 72.2c15.2 15.2 35.9 23.8 57.4 23.8c44.8 0 81.1-36.3 81.1-81.1V241.1c0-44.8-36.3-81.1-81.1-81.1c-21.5 0-42.2 8.5-57.4 23.8L365.3 256z"
                }
            }
        ]
    })(props);
}
function FaInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 80a48 48 0 1 1 96 0A48 48 0 1 1 48 80zM0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H64V256H32c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaJ(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c17.7 0 32 14.3 32 32V320c0 88.4-71.6 160-160 160S0 408.4 0 320V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32c0 53 43 96 96 96s96-43 96-96V64c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaJarWheat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm112 0H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 198 90 224 122.2 224H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 294 90 320 122.2 320H144h32 21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7zM112 352H69.8c-3.2 0-5.8 2.6-5.8 5.8C64 390 90 416 122.2 416H144v32c0 8.8 7.2 16 16 16s16-7.2 16-16V416h21.8c32.1 0 58.2-26 58.2-58.2c0-3.2-2.6-5.8-5.8-5.8H208c-19.1 0-36.3 8.4-48 21.7c-11.7-13.3-28.9-21.7-48-21.7z"
                }
            }
        ]
    })(props);
}
function FaJar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0H256c17.7 0 32 14.3 32 32s-14.3 32-32 32H64C46.3 64 32 49.7 32 32zM0 160c0-35.3 28.7-64 64-64H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160zm96 64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"
                }
            }
        ]
    })(props);
}
function FaJedi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9 0 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5C370.6 435.2 416 382.9 416 320c0-37-15.7-70.4-40.8-93.7c-7-6.5-6.5-18.6 1-24.4C410.1 175.5 432 134.3 432 88c0-16.8-2.9-33-8.2-48c-4.6-13 10.2-30 21.4-22c53.5 38 92.7 94.8 107.8 160.7c.5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9h26c3.4 0 6.2 2.6 6.3 6c.1 3.3 .2 6.6 .2 10c0 17.5-1.7 34.7-4.8 51.3c-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9H526c4.6 0 7.7 4.8 5.7 9C487.2 450.5 394.8 512 288 512S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9H64.5c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3C17.7 274.7 16 257.5 16 240c0-3.3 .1-6.7 .2-10c.1-3.4 2.9-6 6.3-6h26c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9C38.1 112.8 77.3 56 130.8 18c11.3-8 26 8.9 21.4 22c-5.3 15-8.2 31.2-8.2 48c0 46.3 21.9 87.5 55.8 113.9c7.5 5.8 8 17.9 1 24.4C175.7 249.6 160 283 160 320c0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
                }
            }
        ]
    })(props);
}
function FaJetFighterUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M270.7 9.7C268.2 3.8 262.4 0 256 0s-12.2 3.8-14.7 9.7L197.2 112.6c-3.4 8-5.2 16.5-5.2 25.2v77l-144 84V280c0-13.3-10.7-24-24-24s-24 10.7-24 24v56 32 24c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H192v32.7L133.5 468c-3.5 3-5.5 7.4-5.5 12v16c0 8.8 7.2 16 16 16h96V448c0-8.8 7.2-16 16-16s16 7.2 16 16v64h96c8.8 0 16-7.2 16-16V480c0-4.6-2-9-5.5-12L320 416.7V384H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24V368 336 280c0-13.3-10.7-24-24-24s-24 10.7-24 24v18.8l-144-84v-77c0-8.7-1.8-17.2-5.2-25.2L270.7 9.7z"
                }
            }
        ]
    })(props);
}
function FaJetFighter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 24c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H280L384 192H500.4c7.7 0 15.3 1.4 22.5 4.1L625 234.4c9 3.4 15 12 15 21.6s-6 18.2-15 21.6L522.9 315.9c-7.2 2.7-14.8 4.1-22.5 4.1H384L280 464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V320H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H82.7c8.5 0 16.6 3.4 22.6 9.4L160 192h32V48h-8c-13.3 0-24-10.7-24-24zM80 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
                }
            }
        ]
    })(props);
}
function FaJoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C463.2 117.8 448 81.2 448 43V32zM576 256c0 17.7 14.3 32 32 32s32-14.3 32-32V245c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2c-37.8 5.6-75.2 14.3-106.9 22.8C81.3 388 58.3 395.1 42 400.4c-8.2 2.7-14.7 4.9-19.2 6.5c-2.3 .8-4 1.4-5.2 1.8l-1.3 .5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3 .5c1.2 .4 3 1.1 5.2 1.8c4.5 1.6 11 3.8 19.2 6.5c16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h19 51.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352H336 288c-1.1 0-2.3 0-3.4 0c-4.1 0-6.2 5.1-3.5 8.3L383.5 483.2C398.7 501.5 421.2 512 445 512zm-3.9-151.7L543.5 483.2c14.6 17.5 35.9 27.9 58.6 28.7c21.1-1.1 37.9-18.6 37.9-39.9V392c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
                }
            }
        ]
    })(props);
}
function FaJugDetergent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24V48h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H88C74.7 96 64 85.3 64 72s10.7-24 24-24h8V24zM0 256c0-70.7 57.3-128 128-128H256c70.7 0 128 57.3 128 128V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm256 0v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaK(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7l-155.2 160L64 249V64c0-17.7-14.3-32-32-32S0 46.3 0 64V328 448c0 17.7 14.3 32 32 32s32-14.3 32-32V341l64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
                }
            }
        ]
    })(props);
}
function FaKaaba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M60 120l228 71.2L516 120 288 48.8 60 120zM278.5 1.5c6.2-1.9 12.9-1.9 19.1 0l256 80C566.9 85.6 576 98 576 112v16 0 21.2L292.8 237.7c-3.1 1-6.4 1-9.5 0L0 149.2V128 112C0 98 9.1 85.6 22.5 81.5l256-80zm23.9 266.8L576 182.8v46.5l-52.8 16.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5L576 262.8V400c0 14-9.1 26.4-22.5 30.5l-256 80c-6.2 1.9-12.9 1.9-19.1 0l-256-80C9.1 426.4 0 414 0 400V262.8l43.2 13.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L0 229.2V182.8l273.7 85.5c9.3 2.9 19.3 2.9 28.6 0zm-185.5-2.6c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
                }
            }
        ]
    })(props);
}
function FaKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
                }
            }
        ]
    })(props);
}
function FaKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm16 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V144zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zM160 336c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336zM272 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM256 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM368 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM352 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V240zM464 128h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zM448 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V240zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaKhanda(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 3.7c5.9-4.9 14.6-4.9 20.5 0l48 40c5.9 4.9 7.5 13.2 3.8 19.9l0 0 0 0 0 0 0 0-.1 .1-.3 .6c-.3 .5-.7 1.3-1.2 2.3c-1 2-2.6 5-4.4 8.6c-.5 .9-.9 1.9-1.4 2.9C344.9 97.4 368 134 368 176s-23.1 78.6-57.3 97.8c.5 1 1 2 1.4 2.9c1.8 3.7 3.3 6.6 4.4 8.6c.5 1 .9 1.8 1.2 2.3l.3 .6 .1 .1 0 0 0 0c3.6 6.7 2 15-3.8 19.9L272 343.5v19.8l35.6-24.5 41.1-28.2c42.8-29.4 68.4-78 68.4-130c0-31.1-9.2-61.6-26.5-87.5l-2.8-4.2c-4-6-3.5-14 1.3-19.5s12.7-7 19.2-3.7L401.1 80c7.2-14.3 7.2-14.3 7.2-14.3l0 0 0 0 .1 0 .3 .2 1 .5c.8 .4 2 1.1 3.5 1.9c2.9 1.7 7 4.1 11.8 7.3c9.6 6.4 22.5 16.1 35.4 29c25.7 25.7 52.7 65.6 52.7 119.3c0 53.1-26.4 100.5-51.2 133.6c-12.6 16.7-25.1 30.3-34.5 39.7c-4.7 4.7-8.7 8.4-11.5 10.9c-1.4 1.3-2.5 2.2-3.3 2.9l-.9 .8-.3 .2-.1 .1 0 0 0 0s0 0-10.2-12.3l10.2 12.3c-5.1 4.3-12.4 4.9-18.2 1.6l-75.6-43-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21L272 423.4v28.9c9.6 5.5 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7V424.1l-40.3 27.7C197.8 463.3 187.9 472 176 472c-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-75.6 43c-5.8 3.3-13 2.7-18.2-1.6L112 400c-10.2 12.3-10.2 12.3-10.3 12.3l0 0 0 0-.1-.1-.3-.2-.9-.8c-.8-.7-1.9-1.7-3.3-2.9c-2.8-2.5-6.7-6.2-11.5-10.9c-9.4-9.4-21.9-23-34.5-39.7C26.4 324.5 0 277.1 0 224c0-53.7 26.9-93.6 52.7-119.3c12.9-12.9 25.8-22.6 35.4-29C93 72.5 97 70 99.9 68.4c1.5-.8 2.6-1.5 3.5-1.9l1-.5 .3-.2 .1 0 0 0 0 0s0 0 7.2 14.3l-7.2-14.3c6.5-3.2 14.3-1.7 19.2 3.7s5.3 13.4 1.3 19.5l-2.8 4.2C105.2 119 96 149.5 96 180.6c0 51.9 25.6 100.6 68.4 130l41.1 28.2L240 362.6V343.5l-42.2-35.2c-5.9-4.9-7.5-13.2-3.8-19.9l0 0 0 0 0 0 .1-.1 .3-.6c.3-.5 .7-1.3 1.2-2.3c1-2 2.6-5 4.4-8.6c.5-.9 .9-1.9 1.4-2.9C167.1 254.6 144 218 144 176s23.1-78.6 57.3-97.8c-.5-1-1-2-1.4-2.9c-1.8-3.7-3.3-6.6-4.4-8.6c-.5-1-.9-1.8-1.2-2.3l-.3-.6-.1-.1 0 0 0 0 0 0c-3.6-6.7-2-15 3.8-19.9l48-40zM220.2 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1C227 210.2 232 190.9 232 176s-5-34.2-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1C285 141.8 280 161.1 280 176s5 34.2 11.8 53.1z"
                }
            }
        ]
    })(props);
}
function FaKipSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4V64c0-17.7-14.3-32-32-32S64 46.3 64 64V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V325.6L299.2 472.3c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L182.5 288H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H182.5L340.8 88.3z"
                }
            }
        ]
    })(props);
}
function FaKitMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H96V32H64zm64 0V480H448V32H128zM512 480c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H480V480h32zM256 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H320v48c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V288H208c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h48V176z"
                }
            }
        ]
    })(props);
}
function FaKitchenSet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaKiwiBird(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4H448c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1s11.2-8.3 11.2-15.3V224c0-70.7-57.3-128-128-128H392.3c-36.4 0-69.9-17.6-101.1-36.4C262.3 42.1 228.3 32 192 32C86 32 0 118 0 224c0 71.1 38.6 133.1 96 166.3V456c0 13.3 10.7 24 24 24s24-10.7 24-24V410c15.3 3.9 31.4 6 48 6c5.4 0 10.7-.2 16-.7V456c0 13.3 10.7 24 24 24s24-10.7 24-24V405.1c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32c17.7 0 32 14.3 32 32V416H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaLandMineOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 24V168c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM192 320c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32H192V320zm-77.3 90.5c8.1-16.3 24.8-26.5 42.9-26.5H482.3c18.2 0 34.8 10.3 42.9 26.5l27.6 55.2C563.5 487 548 512 524.2 512H115.8c-23.8 0-39.3-25-28.6-46.3l27.6-55.2zM36.3 138.3c7.5-10.9 22.5-13.6 33.4-6.1l104 72c10.9 7.5 13.6 22.5 6.1 33.4s-22.5 13.6-33.4 6.1l-104-72c-10.9-7.5-13.6-22.5-6.1-33.4zm534.1-6.1c10.9-7.5 25.8-4.8 33.4 6.1s4.8 25.8-6.1 33.4l-104 72c-10.9 7.5-25.8 4.8-33.4-6.1s-4.8-25.8 6.1-33.4l104-72z"
                }
            }
        ]
    })(props);
}
function FaLandmarkDome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 0h16c13.3 0 24 10.7 24 24V34.7C368.4 48.1 431.9 111.6 445.3 192H448c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h2.7C80.1 111.6 143.6 48.1 224 34.7V24c0-13.3 10.7-24 24-24zM64 288h64V416h40V288h64V416h48V288h64V416h40V288h64V420.3c.6 .3 1.2 .7 1.7 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V288z"
                }
            }
        ]
    })(props);
}
function FaLandmarkFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0h80c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H272v32H464c17.7 0 32 14.3 32 32s-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H240V16c0-8.8 7.2-16 16-16h16zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
                }
            }
        ]
    })(props);
}
function FaLandmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 4.2c9.8-5.6 21.9-5.6 31.8 0l171.8 98.1L448 104l0 .9 47.9 27.4c12.6 7.2 18.8 22 15.1 36s-16.4 23.8-30.9 23.8H32c-14.5 0-27.2-9.8-30.9-23.8s2.5-28.8 15.1-36L64 104.9V104l4.4-1.6L240.1 4.2zM64 224h64V416h40V224h64V416h48V224h64V416h40V224h64V420.3c.6 .3 1.2 .7 1.8 1.1l48 32c11.7 7.8 17 22.4 12.9 35.9S494.1 512 480 512H32c-14.1 0-26.5-9.2-30.6-22.7s1.1-28.1 12.9-35.9l48-32c.6-.4 1.2-.7 1.8-1.1V224z"
                }
            }
        ]
    })(props);
}
function FaLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"
                }
            }
        ]
    })(props);
}
function FaLaptopCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
                }
            }
        ]
    })(props);
}
function FaLaptopFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C92.7 0 64 28.7 64 64V288H19.2C8.6 288 0 296.6 0 307.2C0 349.6 34.4 384 76.8 384H320V288H128V64H448V96h64V64c0-35.3-28.7-64-64-64H128zM512 128H400c-26.5 0-48 21.5-48 48V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V256H544c-17.7 0-32-14.3-32-32V128zm32 0v96h96l-96-96z"
                }
            }
        ]
    })(props);
}
function FaLaptopMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H512V96H128V352H64V96zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H352v48c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V272H240c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16h48V160z"
                }
            }
        ]
    })(props);
}
function FaLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"
                }
            }
        ]
    })(props);
}
function FaLariSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 32c17.7 0 32 14.3 32 32V96.7c5.3-.4 10.6-.7 16-.7s10.7 .2 16 .7V64c0-17.7 14.3-32 32-32s32 14.3 32 32v49.4c54.9 25.2 95.8 75.5 108.2 136.2c3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.1-29.9-22.5-55.9-45.4-74.3V256c0 17.7-14.3 32-32 32s-32-14.3-32-32V161c-5.2-.7-10.6-1-16-1s-10.8 .3-16 1v95c0 17.7-14.3 32-32 32s-32-14.3-32-32V188.1C82.7 211.5 64 247.6 64 288c0 70.7 57.3 128 128 128H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H192 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48.9C18.5 382 0 337.2 0 288c0-77.5 45.9-144.3 112-174.6V64c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaLayerGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
                }
            }
        ]
    })(props);
}
function FaLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c-78.6 0-145.1 51.5-167.7 122.5c33.6-17 71.5-26.5 111.7-26.5h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H288 216s0 0 0 0c-16.6 0-32.7 1.9-48.2 5.4c-25.9 5.9-50 16.4-71.4 30.7c0 0 0 0 0 0C38.3 298.8 0 364.9 0 440v16c0 13.3 10.7 24 24 24s24-10.7 24-24V440c0-48.7 20.7-92.5 53.8-123.2C121.6 392.3 190.3 448 272 448l1 0c132.1-.7 239-130.9 239-291.4c0-42.6-7.5-83.1-21.1-119.6c-2.6-6.9-12.7-6.6-16.2-.1C455.9 72.1 418.7 96 376 96L272 96z"
                }
            }
        ]
    })(props);
}
function FaLeftLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177.5 414c-8.8 3.8-19 2-26-4.6l-144-136C2.7 268.9 0 262.6 0 256s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 72 288 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-288 0 0 72c0 9.6-5.7 18.2-14.5 22z"
                }
            }
        ]
    })(props);
}
function FaLeftRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.3 273.6c4.9-4.5 7.7-10.9 7.7-17.6s-2.8-13-7.7-17.6l-112-104c-7-6.5-17.2-8.2-25.9-4.4s-14.4 12.5-14.4 22l0 56-192 0 0-56c0-9.5-5.7-18.2-14.4-22s-18.9-2.1-25.9 4.4l-112 104C2.8 243 0 249.3 0 256s2.8 13 7.7 17.6l112 104c7 6.5 17.2 8.2 25.9 4.4s14.4-12.5 14.4-22l0-56 192 0 0 56c0 9.5 5.7 18.2 14.4 22s18.9 2.1 25.9-4.4l112-104z"
                }
            }
        ]
    })(props);
}
function FaLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64c-6.6 0-13 1-19 2.9c-22.5 7-48.1 14.9-71 9c-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71C1 403 0 409.4 0 416c0 35.3 28.7 64 64 64c6.6 0 13-1 19.1-2.9c22.5-7 48.1-14.9 71-9c75.2 19.1 156.4-11 213.7-68.3s87.5-138.5 68.3-213.7c-5.8-22.9 2-48.4 9-71c1.9-6 2.9-12.4 2.9-19.1zM212.5 127.4c-54.6 16-101.1 62.5-117.1 117.1C92.9 253 84 257.8 75.5 255.4S62.2 244 64.6 235.5c19.1-65.1 73.7-119.8 138.9-138.9c8.5-2.5 17.4 2.4 19.9 10.9s-2.4 17.4-10.9 19.9z"
                }
            }
        ]
    })(props);
}
function FaLessThanEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.9 93.7c16.4-6.6 24.4-25.2 17.8-41.6s-25.2-24.4-41.6-17.8l-320 128C40 167.1 32 178.9 32 192s8 24.9 20.1 29.7l320 128c16.4 6.6 35-1.4 41.6-17.8s-1.4-35-17.8-41.6L150.2 192 395.9 93.7zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaLessThan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.6 81.7c7.9 15.8 1.5 35-14.3 42.9L103.6 256 366.3 387.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-320-160C6.8 279.2 0 268.1 0 256s6.8-23.2 17.7-28.6l320-160c15.8-7.9 35-1.5 42.9 14.3z"
                }
            }
        ]
    })(props);
}
function FaLifeRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3s-20.2-113.9-54-157.3c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256s20.2 113.9 54 157.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                }
            }
        ]
    })(props);
}
function FaLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaLinesLeaning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaLinkSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
                }
            }
        ]
    })(props);
}
function FaLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                }
            }
        ]
    })(props);
}
function FaLiraSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V192H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H46c-2.2 10.5-6.1 20.6-11.7 29.9L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1c11.6-19.3 18.9-40.7 21.6-62.9H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V256H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
                }
            }
        ]
    })(props);
}
function FaListCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaListOl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaListUl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"
                }
            }
        ]
    })(props);
}
function FaLitecoinSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64V213.6L23.2 225.2c-17 4.9-26.8 22.6-22 39.6s22.6 26.8 39.6 22L64 280.1V448c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V261.9l136.8-39.1c17-4.9 26.8-22.6 22-39.6s-22.6-26.8-39.6-22L128 195.3V64z"
                }
            }
        ]
    })(props);
}
function FaLocationArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z"
                }
            }
        ]
    })(props);
}
function FaLocationCrosshairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256a128 128 0 1 0 256 0 128 128 0 1 0 -256 0zm128-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                }
            }
        ]
    })(props);
}
function FaLocationDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaLocationPinLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.7 499.2c11-13.8 25.1-31.7 40.3-52.3V352c0-23.7 12.9-44.4 32-55.4V272c0-55.6 40.5-101.7 93.6-110.5C367 70 287.7 0 192 0C86 0 0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c17.7 0 32 14.3 32 32v48H368V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaLocationPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"
                }
            }
        ]
    })(props);
}
function FaLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"
                }
            }
        ]
    })(props);
}
function FaLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
                }
            }
        ]
    })(props);
}
function FaLocust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h16c98.7 0 180.6 71.4 197 165.4c-9-3.5-18.8-5.4-29-5.4H431.8l-41.8-97.5c-3.4-7.9-10.8-13.4-19.3-14.4s-17 2.7-22.1 9.6l-40.9 55.5-21.7-50.7c-3.3-7.8-10.5-13.2-18.9-14.3s-16.7 2.3-22 8.9l-240 304c-8.2 10.4-6.4 25.5 4 33.7s25.5 6.4 33.7-4l79.4-100.5 43 16.4-40.5 55c-7.9 10.7-5.6 25.7 5.1 33.6s25.7 5.6 33.6-5.1L215.1 400h74.5l-29.3 42.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1L348 400h80.4l38.8 67.9c6.6 11.5 21.2 15.5 32.7 8.9s15.5-21.2 8.9-32.7L483.6 400H496c44.1 0 79.8-35.7 80-79.7c0-.1 0-.2 0-.3V280C576 143 465 32 328 32H312zm50.5 168l17.1 40H333l29.5-40zm-87.7 38.1l-1.4 1.9H225.1l32.7-41.5 16.9 39.5zM88.8 240C57.4 240 32 265.4 32 296.8c0 15.5 6.3 30 16.9 40.4L126.7 240H88.8zM496 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                }
            }
        ]
    })(props);
}
function FaLungsVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32V156.2c-8.5-7.6-19.7-12.2-32-12.2s-23.5 4.6-32 12.2V32c0-17.7 14.3-32 32-32zM444.5 195.5c-16.4-16.4-41.8-18.5-60.5-6.1V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9c14 1.5 28.5-3 39.2-13.8l-22.6-22.6 22.6 22.6c18.7-18.7 18.7-49.1 0-67.9c-1.1-1.1-1.4-2-1.5-2.5c-.1-.8-.1-1.8 .4-2.9s1.2-1.9 1.8-2.3c.5-.3 1.3-.8 2.9-.8c26.5 0 48-21.5 48-48s-21.5-48-48-48c-1.6 0-2.4-.4-2.9-.8c-.6-.4-1.3-1.2-1.8-2.3s-.5-2.2-.4-2.9c.1-.6 .4-1.4 1.5-2.5c18.7-18.7 18.7-49.1 0-67.9zM421.8 421.8c-6.2 6.2-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6zM183.3 491.2l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v24.1c-18.6-12.4-44-10.3-60.5 6.1c-18.7 18.7-18.7 49.1 0 67.9c1.1 1.1 1.4 2 1.5 2.5c.1 .8 .1 1.8-.4 2.9s-1.2 1.9-1.8 2.3c-.5 .3-1.3 .8-2.9 .8c-26.5 0-48 21.5-48 48s21.5 48 48 48c1.6 0 2.4 .4 2.9 .8c.6 .4 1.3 1.2 1.8 2.3s.5 2.2 .4 2.9c-.1 .6-.4 1.4-1.5 2.5c-18.7 18.7-18.7 49.1 0 67.9c10.7 10.7 25.3 15.3 39.2 13.8c-12.8 15.9-30.6 27.7-51.5 32.9zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaLungs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32V164.1c0 16.4 8.4 31.7 22.2 40.5l9.8 6.2V165.3C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8c15.4 22.1 44.3 65.4 71 116.9c26.5 50.9 52.4 112.5 59.6 170.3c.2 1.3 .2 2.6 .2 4v7c0 49.1-39.8 89-89 89c-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398V325l90.5 57.6c7.5 4.7 17.3 2.5 22.1-4.9s2.5-17.3-4.9-22.1L384 287.1v-.4l-44.1-28.1c-7.3-4.6-13.9-10.1-19.9-16.1c-5.9 6-12.6 11.5-19.9 16.1L256 286.7 161.2 347l-13.5 8.6c0 0 0 0-.1 0c-7.4 4.8-9.6 14.6-4.8 22.1c4.7 7.5 14.6 9.7 22.1 4.9l91.1-58V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7c-49.1 0-89-39.8-89-89v-7c0-1.3 .1-2.7 .2-4c7.2-57.9 33.1-119.4 59.6-170.3c26.8-51.5 55.6-94.8 71-116.9c13-18.6 34-28.8 55.8-28.8C225 96 256 127 256 165.3v45.5l9.8-6.2c13.8-8.8 22.2-24.1 22.2-40.5V32c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaM(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.2c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V169.7L250.6 369.8c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 49.9 9.2 37.5 22.7 33.4z"
                }
            }
        ]
    })(props);
}
function FaMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160v96C0 379.7 100.3 480 224 480s224-100.3 224-224V160H320v96c0 53-43 96-96 96s-96-43-96-96V160H0zm0-32H128V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64zm320 0H448V64c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v64z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlassArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM241 119c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H238.1l-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlassChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlassDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM228 104c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V312c0 11 9 20 20 20s20-9 20-20V298.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V104z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlassLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlassMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlassPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"
                }
            }
        ]
    })(props);
}
function FaMagnifyingGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
                }
            }
        ]
    })(props);
}
function FaManatSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c-17.7 0-32 14.3-32 32V98.7C69.2 113.9 0 192.9 0 288V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-59.6 40.8-109.8 96-124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V164c55.2 14.2 96 64.3 96 124V448c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-95.1-69.2-174.1-160-189.3V64c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaMapLocationDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 120c0 54.6-73.1 151.9-105.2 192c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120C168 53.7 221.7 0 288 0s120 53.7 120 120zm8 80.4c3.5-6.9 6.7-13.8 9.6-20.6c.5-1.2 1-2.5 1.5-3.7l116-46.4C558.9 123.4 576 135 576 152V422.8c0 9.8-6 18.6-15.1 22.3L416 503V200.4zM137.6 138.3c2.4 14.1 7.2 28.3 12.8 41.5c2.9 6.8 6.1 13.7 9.6 20.6V451.8L32.9 502.7C17.1 509 0 497.4 0 480.4V209.6c0-9.8 6-18.6 15.1-22.3l122.6-49zM327.8 332c13.9-17.4 35.7-45.7 56.2-77V504.3L192 449.4V255c20.5 31.3 42.3 59.6 56.2 77c20.5 25.6 59.1 25.6 79.6 0zM288 152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                }
            }
        ]
    })(props);
}
function FaMapLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.8 312C334.9 271.9 408 174.6 408 120C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192c7.7 9.6 22 9.6 29.6 0zM416 503l144.9-58c9.1-3.6 15.1-12.5 15.1-22.3V152c0-17-17.1-28.6-32.9-22.3l-116 46.4c-.5 1.2-1 2.5-1.5 3.7c-2.9 6.8-6.1 13.7-9.6 20.6V503zM15.1 187.3C6 191 0 199.8 0 209.6V480.4c0 17 17.1 28.6 32.9 22.3L160 451.8V200.4c-3.5-6.9-6.7-13.8-9.6-20.6c-5.6-13.2-10.4-27.4-12.8-41.5l-122.6 49zM384 255c-20.5 31.3-42.3 59.6-56.2 77c-20.5 25.6-59.1 25.6-79.6 0c-13.9-17.4-35.7-45.7-56.2-77V449.4l192 54.9V255z"
                }
            }
        ]
    })(props);
}
function FaMapPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 144a144 144 0 1 1 288 0A144 144 0 1 1 16 144zM160 80c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64zM128 480V317.1c10.4 1.9 21.1 2.9 32 2.9s21.6-1 32-2.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"
                }
            }
        ]
    })(props);
}
function FaMarker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481 31C445.1-4.8 386.9-4.8 351 31l-15 15L322.9 33C294.8 4.9 249.2 4.9 221.1 33L135 119c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L255 66.9c9.4-9.4 24.6-9.4 33.9 0L302.1 80 186.3 195.7 316.3 325.7 481 161c35.9-35.9 35.9-94.1 0-129.9zM293.7 348.3L163.7 218.3 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9 .9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l64.2-64.2z"
                }
            }
        ]
    })(props);
}
function FaMarsAndVenusBurst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l39 39-22.2 22.2C475.9 78.4 439.6 64 400 64c-88.4 0-160 71.6-160 160c0 80.2 59.1 146.7 136.1 158.2c0 .6-.1 1.2-.1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3H352c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l24 0H376c0 13.3 10.7 24 24 24s24-10.7 24-24H400l24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456h24c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2-.1-1.8c77-11.6 136.1-78 136.1-158.2c0-31.4-9-60.7-24.7-85.4L560 113.9l39 39c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H504zM400 128a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.1 3.8 9.9 5.1 15.2 3.6C223.6 310.8 208 269.2 208 224c0-60.8 28.3-115 72.4-150.2L220.3 92.1l-29.4-74z"
                }
            }
        ]
    })(props);
}
function FaMarsAndVenus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 14.8C341.5 5.8 350.3 0 360 0H472c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-24.7 24.7C407 163.3 416 192.6 416 224c0 80.2-59.1 146.7-136.1 158.2c0 .6 .1 1.2 .1 1.8v.4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .4 .3 .4 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3 .3h24c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 .1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0l-24 0-24 0v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V486 486v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V485 485v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V484v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V483v-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1V481v-.1-.1-.1-.1-.1-.1-.1-.1V480v-.1-.1-.1-.1-.1-.1-.1V479v-.1-.1-.1-.1-.1-.1-.1V478v-.1-.1-.1-.1-.1-.1V477v-.1-.1-.1-.1-.1-.1V476v-.1-.1-.1-.1-.1-.1V475v-.1-.2-.2-.2-.2-.2V474v-.2-.2-.2-.2-.2V473v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V470v-.2-.2-.2-.2-.2V469v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V467v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V463v-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2V459v-.2-.2-.2-.2-.2-.2-.2-.2V457v-.2-.2-.2-.2V456H208c-13.3 0-24-10.7-24-24s10.7-24 24-24h24v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3V403v-.3-.3V402v-.3-.3V401v-.3-.3V400v-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.3-.4-.3-.4-.4-.4-.4V393v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V388v-.4-.4-.4-.4-.4-.4-.4-.4-.4-.4V384c0-.6 0-1.2 .1-1.8C155.1 370.7 96 304.2 96 224c0-88.4 71.6-160 160-160c39.6 0 75.9 14.4 103.8 38.2L382.1 80 343 41c-6.9-6.9-8.9-17.2-5.2-26.2zM448 48l0 0h0v0zM256 488h24c0 13.3-10.7 24-24 24s-24-10.7-24-24h24zm96-264a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
                }
            }
        ]
    })(props);
}
function FaMarsDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 32c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L275.8 159c-28.4-19.5-62.7-31-99.8-31C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L407 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312zm88 48h0v0l0 0zM64 304a112 112 0 1 1 224 0A112 112 0 1 1 64 304zM368 480c97.2 0 176-78.8 176-176c0-37-11.4-71.4-31-99.8l52.6-52.6L599 185c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H504c-9.7 0-18.5 5.8-22.2 14.8c-1.2 2.9-1.8 6-1.8 9l0 .2v.2c0 6.2 2.5 12.2 7 16.8l33.4 33.4L480 146.7V168c0 22.6-13.6 43.1-34.6 51.7c-.8 .3-1.7 .7-2.5 1C465.7 241.2 480 270.9 480 304c0 61.9-50.1 112-112 112c-5.4 0-10.8-.4-16-1.1c-12.9 20.4-29.1 38.3-48.1 53.1c19.8 7.8 41.4 12 64 12z"
                }
            }
        ]
    })(props);
}
function FaMarsStrokeRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm174.4-88C370.7 365.8 297.1 432 208 432c-97.2 0-176-78.8-176-176s78.8-176 176-176c89.1 0 162.7 66.2 174.4 152H416V176c0-13.3 10.7-24 24-24s24 10.7 24 24v56h32V176c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V280H464v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H382.4z"
                }
            }
        ]
    })(props);
}
function FaMarsStrokeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.7 4.7c6.2-6.2 16.4-6.2 22.6 0l64 64c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H184v24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H184v24c0 .6 0 1.2-.1 1.8c77 11.6 136.1 78 136.1 158.2c0 88.4-71.6 160-160 160S0 440.4 0 352c0-80.2 59.1-146.7 136.1-158.2c0-.6-.1-1.2-.1-1.8V168H104c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V96H96c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l64-64zM256 352A96 96 0 1 0 64 352a96 96 0 1 0 192 0z"
                }
            }
        ]
    })(props);
}
function FaMarsStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376 0c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l33.4 33.4L370.3 96.4 345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4L307.8 159c-28.4-19.5-62.7-31-99.8-31c-97.2 0-176 78.8-176 176s78.8 176 176 176s176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V24c0-13.3-10.7-24-24-24H376zm88 48h0v0l0 0zM96 304a112 112 0 1 1 224 0A112 112 0 1 1 96 304z"
                }
            }
        ]
    })(props);
}
function FaMars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
                }
            }
        ]
    })(props);
}
function FaMartiniGlassCitrus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 240c53 0 96-43 96-96s-43-96-96-96c-35.5 0-66.6 19.3-83.2 48H296.2C316 40.1 369.3 0 432 0c79.5 0 144 64.5 144 144s-64.5 144-144 144c-27.7 0-53.5-7.8-75.5-21.3l35.4-35.4c12.2 5.6 25.8 8.7 40.1 8.7zM1.8 142.8C5.5 133.8 14.3 128 24 128H392c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-177 177V464h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H208 120c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V345.9L7 169c-6.9-6.9-8.9-17.2-5.2-26.2z"
                }
            }
        ]
    })(props);
}
function FaMartiniGlassEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM256 210.7L109.3 64H402.7L256 210.7z"
                }
            }
        ]
    })(props);
}
function FaMartiniGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C19.1 0 7.4 7.8 2.4 19.8s-2.2 25.7 6.9 34.9L224 269.3V448H160c-17.7 0-32 14.3-32 32s14.3 32 32 32h96 96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288V269.3L502.6 54.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 0 480 0H32zM173.3 128l-64-64H402.7l-64 64H173.3z"
                }
            }
        ]
    })(props);
}
function FaMaskFace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1H144 128 56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H512 496h-9.2c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H96v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4l-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3V176h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaMaskVentilator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.1 176C139.4 219.2 128 264.7 128 300.8c0 15.9 2.2 31.4 6.3 46l-31.8-7.9C70.5 330.9 48 302.1 48 269V184c0-4.4 3.6-8 8-8H159.1zm26-48H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l71.3 17.8c22.7 30.5 55.4 54.1 93.8 66.6V393.3c-19.7-16.4-32-40.3-32-66.9c0-49.5 43-134.4 96-134.4c52.5 0 96 84.9 96 134.4c0 26.7-12.4 50.4-32 66.8v76.6c38-12.6 70.6-36 93.5-66.4l71.6-17.9C602.5 372.1 640 324.1 640 269V184c0-30.9-25.1-56-56-56H454.5C419.7 73.8 372.1 32 320 32c-52.6 0-100.2 41.8-134.9 96zm295.6 48H584c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9l-31.8 8c4.2-14.7 6.4-30.1 6.4-46.1c0-36.1-11.6-81.6-31.3-124.8zM288 320V512h64V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64C64 64 0 160 0 272S80 448 176 448h8.4c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4H400c96 0 176-64 176-176s-64-208-288-208zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaMasksTheater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74.6 373.2c41.7 36.1 108 82.5 166.1 73.7c6.1-.9 12.1-2.5 18-4.5c-9.2-12.3-17.3-24.4-24.2-35.4c-21.9-35-28.8-75.2-25.9-113.6c-20.6 4.1-39.2 13-54.7 25.4c-6.5 5.2-16.3 1.3-14.8-7c6.4-33.5 33-60.9 68.2-66.3c2.6-.4 5.3-.7 7.9-.8l19.4-131.3c2-13.8 8-32.7 25-45.9C278.2 53.2 310.5 37 363.2 32.2c-.8-.7-1.6-1.4-2.4-2.1C340.6 14.5 288.4-11.5 175.7 5.6S20.5 63 5.7 83.9C0 91.9-.8 102 .6 111.8L24.8 276.1c5.5 37.3 21.5 72.6 49.8 97.2zm87.7-219.6c4.4-3.1 10.8-2 11.8 3.3c.1 .5 .2 1.1 .3 1.6c3.2 21.8-11.6 42-33.1 45.3s-41.5-11.8-44.7-33.5c-.1-.5-.1-1.1-.2-1.6c-.6-5.4 5.2-8.4 10.3-6.7c9 3 18.8 3.9 28.7 2.4s19.1-5.3 26.8-10.8zM261.6 390c29.4 46.9 79.5 110.9 137.6 119.7s124.5-37.5 166.1-73.7c28.3-24.5 44.3-59.8 49.8-97.2l24.2-164.3c1.4-9.8 .6-19.9-5.1-27.9c-14.8-20.9-57.3-61.2-170-78.3S299.4 77.2 279.2 92.8c-7.8 6-11.5 15.4-12.9 25.2L242.1 282.3c-5.5 37.3-.4 75.8 19.6 107.7zM404.5 235.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6c-1 5.3-7.4 6.4-11.8 3.3zm136.2 15.5c-1 5.3-7.4 6.4-11.8 3.3c-7.7-5.5-16.8-9.3-26.8-10.8s-19.8-.6-28.7 2.4c-5.1 1.7-10.9-1.3-10.3-6.7c.1-.5 .1-1.1 .2-1.6c3.2-21.8 23.2-36.8 44.7-33.5s36.3 23.5 33.1 45.3c-.1 .5-.2 1.1-.3 1.6zM530 350.2c-19.6 44.7-66.8 72.5-116.8 64.9s-87.1-48.2-93-96.7c-1-8.3 8.9-12.1 15.2-6.7c23.9 20.8 53.6 35.3 87 40.3s66.1 .1 94.9-12.8c7.6-3.4 16 3.2 12.6 10.9z"
                }
            }
        ]
    })(props);
}
function FaMattressPillow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H256V64zm32 384H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H288V448zM64 160c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160z"
                }
            }
        ]
    })(props);
}
function FaMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 32H56C42.7 32 32 42.7 32 56V200c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l40-40 79 79-79 79L73 295c-6.9-6.9-17.2-8.9-26.2-5.2S32 302.3 32 312V456c0 13.3 10.7 24 24 24H200c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H456c13.3 0 24-10.7 24-24V312c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V56c0-13.3-10.7-24-24-24H312c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S209.7 32 200 32z"
                }
            }
        ]
    })(props);
}
function FaMedal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0H133.9c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0H487.4C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
                }
            }
        ]
    })(props);
}
function FaMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6V320H576V248.6c0-6.8-4.4-12.6-10.1-16.3C552.7 223.7 544 208.9 544 192s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64zM576 352H0v64c0 17.7 14.3 32 32 32H80V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h96V416c0-8.8 7.2-16 16-16s16 7.2 16 16v32h48c17.7 0 32-14.3 32-32V352zM192 160v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaMenorah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32S0 81.7 0 64V62.8c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1V64c0 17.7-14.3 32-32 32s-32-14.3-32-32V62.8c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32V288c0 17.7 14.3 32 32 32H288V160c0-17.7 14.3-32 32-32s32 14.3 32 32V320H544c17.7 0 32-14.3 32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 53-43 96-96 96H352v64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 160c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V384H96c-53 0-96-43-96-96V160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H96V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H192V256 160c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32v96 32H384V256 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96 32H480V256 160c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaMercury(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.1 7C85.8-4 106-1.8 117 12c17.6 22 44.7 36 75 36s57.3-14 75-36c11.1-13.8 31.2-16 45-5s16 31.2 5 45c-7.8 9.7-16.6 18.4-26.4 26.1C337.3 109.7 368 163.3 368 224c0 89.1-66.2 162.7-152 174.4V424h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V472H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V398.4C82.2 386.7 16 313.1 16 224c0-60.7 30.7-114.3 77.5-145.9C83.7 70.5 74.9 61.7 67.1 52c-11.1-13.8-8.8-33.9 5-45zM80 224a112 112 0 1 0 224 0A112 112 0 1 0 80 224z"
                }
            }
        ]
    })(props);
}
function FaMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
                }
            }
        ]
    })(props);
}
function FaMeteor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.7 .9L299.4 75.6l2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309C0 421.1 90.9 512 203 512c72.4 0 139.4-38.6 175.7-101.3L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3L511.1 18.3c.6-1.5 .9-3.2 .9-4.8C512 6 506 0 498.5 0c-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaMicrochip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64c-35.3 0-64 28.7-64 64H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64v56H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H64c0 35.3 28.7 64 64 64v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448h56v40c0 13.3 10.7 24 24 24s24-10.7 24-24V448c35.3 0 64-28.7 64-64h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V280h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448V176h40c13.3 0 24-10.7 24-24s-10.7-24-24-24H448c0-35.3-28.7-64-64-64V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H280V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H176V24zM160 128H352c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zm192 32H160V352H352V160z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneLinesSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24 16c0 21.2-5.1 41.1-14.2 58.7L416 300.8V256H358.9l-34.5-27c2.9-3.1 7-5 11.6-5h80V192H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zm362.5 407l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 96V256c0 53 43 96 96 96s96-43 96-96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V192H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V128H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c0-53-43-96-96-96S96 43 96 96zM320 240v16c0 70.7-57.3 128-128 128s-128-57.3-128-128V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v24z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c15.2-26 23.9-56.3 23.9-88.7V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 21.2-5.1 41.1-14.2 58.7L416 300.8V96c0-53-43-96-96-96s-96 43-96 96v54.3L38.8 5.1zM344 430.4c20.4-2.8 39.7-9.1 57.3-18.2l-43.1-33.9C346.1 382 333.3 384 320 384c-70.7 0-128-57.3-128-128v-8.7L144.7 210c-.5 1.9-.7 3.9-.7 6v40c0 89.1 66.2 162.7 152 174.4V464H248c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4z"
                }
            }
        ]
    })(props);
}
function FaMicrophone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C139 0 96 43 96 96V256c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96zM64 216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 89.1 66.2 162.7 152 174.4V464H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H216V430.4c85.8-11.7 152-85.3 152-174.4V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V216z"
                }
            }
        ]
    })(props);
}
function FaMicroscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32c17.7 0 32 14.3 32 32V288c0 17.7-14.3 32-32 32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM32 448H320c70.7 0 128-57.3 128-128s-57.3-128-128-128V128c106 0 192 86 192 192c0 49.2-18.5 94-48.9 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm80-64H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaMillSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.1 42.8c5.9-16.6-2.7-35-19.4-40.9s-35 2.7-40.9 19.4L208 116.1c-5.7 4-11.1 8.5-16 13.5C171.7 108.9 143.3 96 112 96c-19.5 0-37.8 5-53.7 13.7C52.5 101.4 42.9 96 32 96C14.3 96 0 110.3 0 128v80V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-26.5 21.5-48 48-48s48 21.5 48 48v42.5L81.9 469.2c-5.9 16.6 2.7 35 19.4 40.9s35-2.7 40.9-19.4l21.4-60C168.9 441 179.6 448 192 448c17.7 0 32-14.3 32-32V261.5l35.7-100c3.9-1 8.1-1.6 12.3-1.6c26.5 0 48 21.5 48 48V416c0 17.7 14.3 32 32 32s32-14.3 32-32V208c0-58.2-44.3-106-101.1-111.5l19.2-53.8z"
                }
            }
        ]
    })(props);
}
function FaMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 224H312c-13.3 0-24-10.7-24-24V56c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l40 40L442.3 5.7C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143l40 40c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433l-40 40c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V312c0-13.3 10.7-24 24-24H456zm-256 0c13.3 0 24 10.7 24 24V456c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40L69.7 506.3C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8H200zM56 224c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l40-40L5.7 69.7C2 66 0 61.1 0 56s2-10 5.7-13.7L42.3 5.7C46 2 50.9 0 56 0s10 2 13.7 5.7L143 79l40-40c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V200c0 13.3-10.7 24-24 24H56z"
                }
            }
        ]
    })(props);
}
function FaMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaMitten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384H64L5.4 178.9C1.8 166.4 0 153.4 0 140.3C0 62.8 62.8 0 140.3 0h3.4c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192h2.8c34.9 0 63.3 28.3 63.3 63.3c0 15.9-6 31.2-16.8 42.9L352 384zM32 448c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V448z"
                }
            }
        ]
    })(props);
}
function FaMobileButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zM192 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaMobileRetro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H256c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 96v64c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
                }
            }
        ]
    })(props);
}
function FaMobileScreenButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM224 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM304 64H80V384H304V64z"
                }
            }
        ]
    })(props);
}
function FaMobileScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"
                }
            }
        ]
    })(props);
}
function FaMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 0C44.7 0 16 28.7 16 64V448c0 35.3 28.7 64 64 64H304c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H80zm80 432h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaMoneyBill1Wave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM128 416H64V352c35.3 0 64 28.7 64 64zM64 224V160h64c0 35.3-28.7 64-64 64zM448 352c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM384 256c0 61.9-43 112-96 112s-96-50.1-96-112s43-112 96-112s96 50.1 96 112zM252 208c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
                }
            }
        ]
    })(props);
}
function FaMoneyBill1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm76-48c0 9.7 6.9 17.7 16 19.6V276h-4c-11 0-20 9-20 20s9 20 20 20h24 24c11 0 20-9 20-20s-9-20-20-20h-4V208c0-11-9-20-20-20H272c-11 0-20 9-20 20z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillTransfer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17s-2.5 12.5-7 17l-64 64c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23L384 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l174.1 0L535 41zM105 377l-23 23L256 400c13.3 0 24 10.7 24 24s-10.7 24-24 24L81.9 448l23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 441c-4.5-4.5-7-10.6-7-17s2.5-12.5 7-17l64-64c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM96 64H337.9c-3.7 7.2-5.9 15.3-5.9 24c0 28.7 23.3 52 52 52l117.4 0c-4 17 .6 35.5 13.8 48.8c20.3 20.3 53.2 20.3 73.5 0L608 169.5V384c0 35.3-28.7 64-64 64H302.1c3.7-7.2 5.9-15.3 5.9-24c0-28.7-23.3-52-52-52l-117.4 0c4-17-.6-35.5-13.8-48.8c-20.3-20.3-53.2-20.3-73.5 0L32 342.5V128c0-35.3 28.7-64 64-64zm64 64H96v64c35.3 0 64-28.7 64-64zM544 320c-35.3 0-64 28.7-64 64h64V320zM320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillTrendUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.7 9.4c3 3.1 5.3 6.6 6.9 10.3s2.4 7.8 2.4 12.2l0 .1v0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3L310.6 214.6c-11.8 11.8-30.8 12.6-43.5 1.7L176 138.1 84.8 216.3c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l112-96c12-10.3 29.7-10.3 41.7 0l89.5 76.7L370.7 64H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0c8.8 0 16.8 3.6 22.6 9.3l.1 .1zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillWave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillWheat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zM56 16h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56C42.7 64 32 53.3 32 40s10.7-24 24-24zM24 88H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24S10.7 88 24 88zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 16c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80zM400 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80c0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 128c8.8 0 16 7.2 16 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48H464c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V304zM48 416v48H96c0-26.5-21.5-48-48-48zM96 304H48v48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48h48V416zM416 304c0 26.5 21.5 48 48 48V304H416zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                }
            }
        ]
    })(props);
}
function FaMoneyBill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                }
            }
        ]
    })(props);
}
function FaMoneyBills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 96V320c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm64 160c35.3 0 64 28.7 64 64H160V256zM224 96c0 35.3-28.7 64-64 64V96h64zM576 256v64H512c0-35.3 28.7-64 64-64zM512 96h64v64c-35.3 0-64-28.7-64-64zM288 208a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V360c0 66.3 53.7 120 120 120H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-39.8 0-72-32.2-72-72V120z"
                }
            }
        ]
    })(props);
}
function FaMoneyCheckDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"
                }
            }
        ]
    })(props);
}
function FaMoneyCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm48 160H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM376 160h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaMonument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.1 5.8 4.6 9.3l40.2 322H55.9L96.1 94c.4-3.5 2-6.8 4.6-9.3l80-80zM152 272c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM32 448H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
                }
            }
        ]
    })(props);
}
function FaMortarPestle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160H397.3L502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2c-11.1 13.9-19.4 30.3-23.9 48.1C127.6 497.4 142.3 512 160 512H352c17.7 0 32.4-14.6 28.1-31.7c-4.5-17.8-12.8-34.1-23.9-48.1C436.6 403.7 480 338.5 480 256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaMosque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c5 0 9.8 2.4 12.8 6.4c34.7 46.3 78.1 74.9 133.5 111.5l0 0 0 0c5.2 3.4 10.5 7 16 10.6c28.9 19.2 45.7 51.7 45.7 86.1c0 28.6-11.3 54.5-29.8 73.4H221.8c-18.4-19-29.8-44.9-29.8-73.4c0-34.4 16.7-66.9 45.7-86.1c5.4-3.6 10.8-7.1 16-10.6l0 0 0 0C309.1 81.3 352.5 52.7 387.2 6.4c3-4 7.8-6.4 12.8-6.4zM288 512V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H192c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H560V440c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H448V454c0-19-8.4-37-23-49.2L400 384l-25 20.8C360.4 417 352 435 352 454v58H288zM70.4 5.2c5.7-4.3 13.5-4.3 19.2 0l16 12C139.8 42.9 160 83.2 160 126v2H0v-2C0 83.2 20.2 42.9 54.4 17.2l16-12zM0 160H160V296.6c-19.1 11.1-32 31.7-32 55.4V480c0 9.6 2.1 18.6 5.8 26.8c-6.6 3.4-14 5.2-21.8 5.2H48c-26.5 0-48-21.5-48-48V176 160z"
                }
            }
        ]
    })(props);
}
function FaMosquitoNet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.8 462.3c-7.9-4-11.1-13.6-7.2-21.5L192 380.2l0-44.2c0-4.2 1.7-8.3 4.7-11.3L256 265.4V242.2L139.2 344C87.8 395.3 0 358.9 0 286.3c0-41.1 30.6-75.8 71.4-80.9l159.9-23.9-49.6-41.3c-5.1-4.2-7-11.1-4.9-17.4l13.9-41.7-29-58.1c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l32 64c1.9 3.8 2.2 8.2 .9 12.2l-12.5 37.6L256 160.5V137.9c0-14.9 10.1-27.3 23.8-31V63.7c0-4.5 3.7-8.2 8.2-8.2s8.2 3.7 8.2 8.2V107c13.7 3.6 23.8 16.1 23.8 31v22.6l45.4-37.8L352.8 85.1c-1.3-4-1-8.4 .9-12.2l32-64c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-29 58.1 13.9 41.7c2.1 6.2 .1 13.1-4.9 17.4l-49.6 41.3 159.9 23.9c22.5 2.8 41.8 14.6 54.7 31.4c-2.7 2.6-5.2 5.4-7.3 8.6c-8.6-12.9-23.3-21.5-40-21.5s-31.4 8.5-40 21.5c-8.6-12.9-23.3-21.5-40-21.5c-21.7 0-40 14.3-45.9 34.1c-10.7 3.2-19.8 10.1-25.9 19.2l-40.2-35v23.1l32.4 32.4c-.3 2-.4 4.1-.4 6.2c0 16.7 8.5 31.4 21.5 40c-4 2.6-7.5 5.9-10.6 9.5L320 310.6v50c0 17.7-14.3 32-32 32s-32-14.3-32-32v-50l-32 32 0 41.4c0 2.5-.6 4.9-1.7 7.2l-32 64c-4 7.9-13.6 11.1-21.5 7.2zM512 256c8.8 0 16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H608v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H528v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H448v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V480H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V400H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V320H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v16h48V272c0-8.8 7.2-16 16-16zm16 112h48V320H528v48zm0 80h48V400H528v48zM448 320v48h48V320H448zm0 80v48h48V400H448z"
                }
            }
        ]
    })(props);
}
function FaMosquito(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M463.7 505.9c9.8-8.9 10.7-24.3 2.1-34.3l-42.1-49 0-54.7c0-5.5-1.8-10.8-5.1-15.1L352 266.3l0-.3L485.4 387.8C542.4 447.6 640 405.2 640 320.6c0-47.9-34-88.3-79.4-94.2l-153-23.9 40.8-40.9c7.8-7.8 9.4-20.1 3.9-29.8L428.5 90.1l38.2-50.9c8-10.6 6.1-25.9-4.3-34.1s-25.2-6.3-33.2 4.4l-48 63.9c-5.9 7.9-6.6 18.6-1.7 27.2L402.2 140 352 190.3l0-38.2c0-14.9-10.2-27.4-24-31l0-57.2c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 57.2c-13.8 3.6-24 16.1-24 31l0 38.1L237.8 140l22.6-39.5c4.9-8.6 4.2-19.3-1.7-27.2l-48-63.9c-8-10.6-22.8-12.6-33.2-4.4s-12.2 23.5-4.3 34.1l38.2 50.9-23.9 41.7c-5.5 9.7-3.9 22 3.9 29.8l40.8 40.9-153 23.9C34 232.3 0 272.7 0 320.6c0 84.6 97.6 127 154.6 67.1L288 266l0 .3-66.5 86.4c-3.3 4.3-5.1 9.6-5.1 15.1l0 54.7-42.1 49c-8.6 10.1-7.7 25.5 2.1 34.3s24.7 7.9 33.4-2.1l48-55.9c3.8-4.4 5.9-10.2 5.9-16.1l0-55.4L288 344.7l0 63.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-63.1 24.3 31.6 0 55.4c0 5.9 2.1 11.7 5.9 16.1l48 55.9c8.6 10.1 23.6 11 33.4 2.1z"
                }
            }
        ]
    })(props);
}
function FaMotorcycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 32c-13.3 0-24 10.7-24 24s10.7 24 24 24h57.7l16.4 30.3L256 192l-45.3-45.3c-12-12-28.3-18.7-45.3-18.7H64c-17.7 0-32 14.3-32 32v32h96c88.4 0 160 71.6 160 160c0 11-1.1 21.7-3.2 32h70.4c-2.1-10.3-3.2-21-3.2-32c0-52.2 25-98.6 63.7-127.8l15.4 28.6C402.4 276.3 384 312 384 352c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-13.5 0-26.5 2.1-38.7 6L418.2 128H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H459.6c-7.5 0-14.7 2.6-20.5 7.4L391.7 78.9l-14-26c-7-12.9-20.5-21-35.2-21H280zM462.7 311.2l28.2 52.2c6.3 11.7 20.9 16 32.5 9.7s16-20.9 9.7-32.5l-28.2-52.2c2.3-.3 4.7-.4 7.1-.4c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-15.5 5.5-29.7 14.7-40.8zM187.3 376c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c26.9 0 49.9 16.5 59.3 40h66.4C242.5 268.8 190.5 224 128 224C57.3 224 0 281.3 0 352s57.3 128 128 128c62.5 0 114.5-44.8 125.8-104H187.3zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaMound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.1 179.2C173.8 127.7 228.6 96 288 96s114.2 31.7 143.9 83.2L540.4 368c12.3 21.3-3.1 48-27.7 48H63.3c-24.6 0-40-26.6-27.7-48L144.1 179.2z"
                }
            }
        ]
    })(props);
}
function FaMountainCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0c-26.5 0-48 21.5-48 48v92.1l71.4 118.4c2.5-1.6 5.4-2.5 8.6-2.5h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-3.5l73.8 122.4c12.4 20.6 12.9 46.3 1.2 67.3c-.4 .8-.9 1.6-1.4 2.3H592c26.5 0 48-21.5 48-48V240c0-26.5-21.5-48-48-48H568V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v72H480V48c0-26.5-21.5-48-48-48H336zm32 64h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM352 176c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V176zm160 96c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V272zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zM224 188.9L283.8 288H223l-48 64-24.6-41.2L224 188.9zm29.4-44.2C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512H413.5c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7z"
                }
            }
        ]
    })(props);
}
function FaMountainSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160A80 80 0 1 0 560 0a80 80 0 1 0 0 160zM55.9 512H381.1h75H578.9c33.8 0 61.1-27.4 61.1-61.1c0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 196.1 487.8 192 480 192s-15 4.1-19.1 10.7l-48.2 79L286.8 81c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 426.4C3 435.3 0 445.6 0 456.1C0 487 25 512 55.9 512z"
                }
            }
        ]
    })(props);
}
function FaMountain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c12.5 0 24.1 6.4 30.8 17L503.4 394.4c5.6 8.9 8.6 19.2 8.6 29.7c0 30.9-25 55.9-55.9 55.9H55.9C25 480 0 455 0 424.1c0-10.5 3-20.8 8.6-29.7L225.2 49c6.6-10.6 18.3-17 30.8-17zm65 192L256 120.4 176.9 246.5l18.3 24.4c6.4 8.5 19.2 8.5 25.6 0l25.6-34.1c6-8.1 15.5-12.8 25.6-12.8h49z"
                }
            }
        ]
    })(props);
}
function FaMugHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 0C74.7 0 64 10.7 64 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C120.5 112.3 128 119.9 128 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C119.5 47.7 112 40.1 112 24c0-13.3-10.7-24-24-24zM32 192c-17.7 0-32 14.3-32 32V416c0 53 43 96 96 96H288c53 0 96-43 96-96h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H352 32zm352 64h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H384V256zM224 24c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 38.9 23.4 59.4 39.1 73.1l1.1 1C232.5 112.3 240 119.9 240 136c0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C231.5 47.7 224 40.1 224 24z"
                }
            }
        ]
    })(props);
}
function FaMugSaucer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-17.7 14.3-32 32-32H448h64c70.7 0 128 57.3 128 128s-57.3 128-128 128H480c0 53-43 96-96 96H192c-53 0-96-43-96-96V64zM480 224h32c35.3 0 64-28.7 64-64s-28.7-64-64-64H480V224zM32 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.1 6.3c8.1 6 12.9 15.6 12.9 25.7v72V368c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V147L192 223.8V432c0 44.2-43 80-96 80s-96-35.8-96-80s43-80 96-80c11.2 0 22 1.6 32 4.6V200 128c0-14.1 9.3-26.6 22.8-30.7l320-96c9.7-2.9 20.2-1.1 28.3 5z"
                }
            }
        ]
    })(props);
}
function FaN(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6V64c0-17.7 14.3-32 32-32s32 14.3 32 32V448c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 50.5 8.4 38.5 21.1 33.9z"
                }
            }
        ]
    })(props);
}
function FaNairaSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V320H228.2l97.2 145.8c7.8 11.7 22.4 17 35.9 12.9s22.7-16.5 22.7-30.6V320h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H262.5L122.6 46.3zM305.1 320H320v22.3L305.1 320zM185.5 256H128V169.7L185.5 256z"
                }
            }
        ]
    })(props);
}
function FaNetworkWired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64H384v64H256V64zM240 0c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h48v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96v32H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H240c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H192V288H448v32H400c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48H560c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V192h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240zM96 448V384H224v64H96zm320-64H544v64H416V384z"
                }
            }
        ]
    })(props);
}
function FaNeuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V480c0 17.7 14.3 32 32 32s32-14.3 32-32V349.1z"
                }
            }
        ]
    })(props);
}
function FaNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 96c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H80c-44.2 0-80-35.8-80-80V128c0-17.7 14.3-32 32-32s32 14.3 32 32V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm64 24v80c0 13.3 10.7 24 24 24H296c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm208-8c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16zM160 304c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaNotEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.8 37.4c14.7 9.8 18.7 29.7 8.9 44.4L337.1 144H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H294.5l-64 96H400c17.7 0 32 14.3 32 32s-14.3 32-32 32H187.8l-65.2 97.7c-9.8 14.7-29.7 18.7-44.4 8.9s-18.7-29.7-8.9-44.4L110.9 368H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H153.5l64-96H48c-17.7 0-32-14.3-32-32s14.3-32 32-32H260.2l65.2-97.7c9.8-14.7 29.7-18.7 44.4-8.9z"
                }
            }
        ]
    })(props);
}
function FaNotdef(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 390.3L153.5 256 64 121.7V390.3zM102.5 448H281.5L192 313.7 102.5 448zm128-192L320 390.3V121.7L230.5 256zM281.5 64H102.5L192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0H336c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
                }
            }
        ]
    })(props);
}
function FaNoteSticky(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H288V368c0-26.5 21.5-48 48-48H448V96c0-35.3-28.7-64-64-64H64zM448 352H402.7 336c-8.8 0-16 7.2-16 16v66.7V480l32-32 64-64 32-32z"
                }
            }
        ]
    })(props);
}
function FaNotesMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 352V96c0-35.3 28.7-64 64-64H416c35.3 0 64 28.7 64 64V293.5c0 17-6.7 33.3-18.7 45.3l-58.5 58.5c-12 12-28.3 18.7-45.3 18.7H160c-35.3 0-64-28.7-64-64zM272 128c-8.8 0-16 7.2-16 16v48H208c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256h48c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H320V144c0-8.8-7.2-16-16-16H272zm24 336c13.3 0 24 10.7 24 24s-10.7 24-24 24H136C60.9 512 0 451.1 0 376V152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 224c0 48.6 39.4 88 88 88H296z"
                }
            }
        ]
    })(props);
}
function FaO(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256A224 224 0 1 1 0 256a224 224 0 1 1 448 0z"
                }
            }
        ]
    })(props);
}
function FaObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H456.6C467.6 12.9 488.3 0 512 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM456.6 96H119.4c-5.6 9.7-13.7 17.8-23.4 23.4V392.6c9.7 5.6 17.8 13.7 23.4 23.4H456.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4zM128 160c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
                }
            }
        ]
    })(props);
}
function FaObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 119.4C12.9 108.4 0 87.7 0 64C0 28.7 28.7 0 64 0c23.7 0 44.4 12.9 55.4 32H328.6C339.6 12.9 360.3 0 384 0c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V232.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V119.4zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4V232.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V119.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4zm192 384c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V352h64v40.6c9.7 5.6 17.8 13.7 23.4 23.4H520.6c5.6-9.7 13.7-17.8 23.4-23.4V279.4c-9.7-5.6-17.8-13.7-23.4-23.4h-46c-5.4-15.4-14.6-28.9-26.5-39.6V192h72.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V392.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H311.4z"
                }
            }
        ]
    })(props);
}
function FaOilCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32H144 96 48c-26.5 0-48 21.5-48 48v64.8c0 19 11.2 36.2 28.5 43.9l67.5 30V368c0 26.5 21.5 48 48 48H403.1c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H288V128h32zM96 208v86.1L48 272.8V208H96z"
                }
            }
        ]
    })(props);
}
function FaOilWell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4L308.5 167.5l-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39L96 222.6V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H406.7L340 257.5l-62.2 16.1L305.3 352H238.7L265 277l-74.6 19.3L137.3 448H96V288.8l337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l11.2-32H327.7l11.2 32H205.1z"
                }
            }
        ]
    })(props);
}
function FaOm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M379.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-16 16c-6.2 6.2-6.2 16.4 0 22.6l16 16c6.2 6.2 16.4 6.2 22.6 0l16-16c6.2-6.2 6.2-16.4 0-22.6l-16-16zM115.2 169.6c8-6 17.9-9.6 28.8-9.6c26.5 0 48 21.5 48 48s-21.5 48-48 48H109.8c-7.6 0-13.8 6.2-13.8 13.8c0 1.5 .2 2.9 .7 4.4l8 24c4.4 13.1 16.6 21.9 30.4 21.9H144h16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-50.8 0-82.7-21.5-102.2-42.8c-9.9-10.8-16.6-21.6-20.9-29.7c-2.1-4-3.6-7.3-4.5-9.6c-.5-1.1-.8-2-1-2.5l-.2-.5 0-.1c-2.6-7.8-10.7-12.3-18.7-10.5C4.4 354.2-.9 361.8 .1 370L16 368C.1 370 .1 370 .1 370l0 0 0 0 0 .1 .1 .4c0 .3 .1 .8 .2 1.3c.2 1.1 .4 2.7 .8 4.6c.8 3.9 2 9.4 3.9 15.9c3.8 13 10.3 30.4 21.3 48C48.7 476.2 89.4 512 160 512c70.7 0 128-57.3 128-128c0-23.3-6.2-45.2-17.1-64h22.6c25.5 0 49.9-10.1 67.9-28.1l26.5-26.5c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32c-25.7 0-41.4-12.5-51.2-25.6c-5-6.7-8.4-13.4-10.5-18.6c-1.1-2.5-1.8-4.6-2.2-6c-.2-.7-.4-1.2-.5-1.5l-.1-.3 0 0c0 0 0 0 0 0c-1.9-7.3-8.6-12.4-16.2-12.1c-7.6 .3-13.9 5.9-15.1 13.4L336 368c-15.8-2.6-15.8-2.6-15.8-2.6l0 0 0 0 0 .1-.1 .3c0 .3-.1 .6-.2 1.1c-.1 .9-.3 2.1-.4 3.6c-.3 3-.6 7.3-.6 12.4c0 10.1 1.1 23.9 5.8 38.1c4.8 14.3 13.4 29.3 28.6 40.7C368.7 473.3 389.3 480 416 480c53 0 96-43 96-96V288c0-53-43-96-96-96h-5.5c-25.5 0-49.9 10.1-67.9 28.1l-26.5 26.5c-6 6-14.1 9.4-22.6 9.4H245.2c6.9-14.5 10.8-30.8 10.8-48c0-61.9-50.1-112-112-112c-25.2 0-48.5 8.3-67.2 22.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4zM280.9 66.7c-6-4-14-3.5-19.5 1.3s-7 12.7-3.7 19.2L272 80c-14.3 7.2-14.3 7.2-14.3 7.2l0 0 0 0 0 .1 .1 .2 .4 .7c.3 .6 .8 1.4 1.4 2.4c1.2 2 2.9 4.8 5.1 8.2c4.4 6.7 11.1 15.5 20 24.4C302.4 141.1 330.3 160 368 160c31.2 0 56.6-10.4 73.9-20.2c8.7-5 15.6-9.9 20.4-13.8c2.4-1.9 4.3-3.6 5.7-4.9c.7-.6 1.3-1.2 1.7-1.6l.6-.5 .2-.2 .1-.1 0 0 0 0c0 0 0 0-22.6-22.6l22.6 22.6c12.5-12.5 12.5-32.8 0-45.3c-12.4-12.4-32.6-12.5-45.1-.2c-.1 .1-.2 .2-.5 .4c-.5 .5-1.5 1.3-2.8 2.4c-2.7 2.2-6.8 5.2-12.1 8.2C399.4 90.4 384.8 96 368 96c-20.8 0-42.4-7-59.5-14.6c-8.4-3.7-15.4-7.5-20.3-10.3c-2.4-1.4-4.3-2.5-5.6-3.3c-.6-.4-1.1-.7-1.4-.9l-.3-.2 0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaOtter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5c23.5 0 42.6-19.1 42.6-42.6V144c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v21.4c0 23.5 19.1 42.6 42.6 42.6c6.6 0 13.1-1.5 19.1-4.5l12.9-6.4 8.4-4.2L135.1 185c-4.5-3-7.1-8-7.1-13.3V168c0-13.3 10.7-24 24-24h16c13.3 0 24 10.7 24 24v3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4L160 240l-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6c-3.6 0-7.1-.2-10.6-.6v.6c0 35.3 28.7 64 64 64h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V336 320c0-23.7 12.9-44.4 32-55.4c9.4-5.4 20.3-8.6 32-8.6V240c0-26.5 21.5-48 48-48c8.8 0 16 7.2 16 16v32 16 48c0 8.8 7.2 16 16 16s16-7.2 16-16V204.3c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1h0c0 123.7-100.3 224-224 224h-1.1H256h-.6C132 480 32 380 32 256.6V256 216.8c-10.1-14.6-16-32.3-16-51.4V144l0-1.4C6.7 139.3 0 130.5 0 120c0-13.3 10.7-24 24-24h2.8C44.8 58.2 83.3 32 128 32h64c44.7 0 83.2 26.2 101.2 64H296c13.3 0 24 10.7 24 24c0 10.5-6.7 19.3-16 22.6l0 1.4v21.4c0 1.4 0 2.8-.1 4.3c12-6.2 25.7-9.6 40.1-9.6h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-13.3 0-24 10.7-24 24v8h56.4c-15.2 17-24.4 39.4-24.4 64H320c-42.3 0-78.2-27.4-91-65.3c-5.1 .9-10.3 1.3-15.6 1.3c-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                }
            }
        ]
    })(props);
}
function FaOutdent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM.2 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6V335.3c0 13.3-15.3 20.8-25.8 12.6L.2 268.6z"
                }
            }
        ]
    })(props);
}
function FaP(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32h96c88.4 0 160 71.6 160 160s-71.6 160-160 160H64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V320 96zM64 288h96c53 0 96-43 96-96s-43-96-96-96H64V288z"
                }
            }
        ]
    })(props);
}
function FaPager(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm64 32v64c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM80 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H80zm136 0c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H216z"
                }
            }
        ]
    })(props);
}
function FaPaintRoller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H352c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 352c0-17.7 14.3-32 32-32V304c0-44.2 35.8-80 80-80H416c17.7 0 32-14.3 32-32V160 69.5c37.3 13.2 64 48.7 64 90.5v32c0 53-43 96-96 96H272c-8.8 0-16 7.2-16 16v16c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V352z"
                }
            }
        ]
    })(props);
}
function FaPaintbrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.2-7.5z"
                }
            }
        ]
    })(props);
}
function FaPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3H344c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaPallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96 320 544h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H576V384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H544 320 96 32zm96 64H288v64H128V384zm224 0H512v64H352V384z"
                }
            }
        ]
    })(props);
}
function FaPanorama(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.6 32C20.4 32 0 52.4 0 77.6V434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6V77.6C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
                }
            }
        ]
    })(props);
}
function FaPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
                }
            }
        ]
    })(props);
}
function FaPaperclip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"
                }
            }
        ]
    })(props);
}
function FaParachuteBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.5 192c.3-5.3 .5-10.6 .5-16c0-51-15.9-96-40.2-127.6C319.5 16.9 288.2 0 256 0s-63.5 16.9-87.8 48.4C143.9 80 128 125 128 176c0 5.4 .2 10.7 .5 16H240V320H208c-7 0-13.7 1.5-19.7 4.2L68.2 192H96.5c-.3-5.3-.5-10.6-.5-16c0-64 22.2-121.2 57.1-159.3C62 49.3 18.6 122.6 4.2 173.6C1.5 183.1 9 192 18.9 192h6L165.2 346.3c-3.3 6.5-5.2 13.9-5.2 21.7v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V368c0-7.8-1.9-15.2-5.2-21.7L487.1 192h6c9.9 0 17.4-8.9 14.7-18.4C493.4 122.6 450 49.3 358.9 16.7C393.8 54.8 416 112.1 416 176c0 5.4-.2 10.7-.5 16h28.3L323.7 324.2c-6-2.7-12.7-4.2-19.7-4.2H272V192H383.5z"
                }
            }
        ]
    })(props);
}
function FaParagraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"
                }
            }
        ]
    })(props);
}
function FaPassport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM183 278.8c-27.9-13.2-48.4-39.4-53.7-70.8h39.1c1.6 30.4 7.7 53.8 14.6 70.8zm41.3 9.2l-.3 0-.3 0c-2.4-3.5-5.7-8.9-9.1-16.5c-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5c-3.4 7.6-6.7 13-9.1 16.5zm40.7-9.2c6.8-17.1 12.9-40.4 14.6-70.8h39.1c-5.3 31.4-25.8 57.6-53.7 70.8zM279.6 176c-1.6-30.4-7.7-53.8-14.6-70.8c27.9 13.2 48.4 39.4 53.7 70.8H279.6zM223.7 96l.3 0 .3 0c2.4 3.5 5.7 8.9 9.1 16.5c6 13.6 12.4 34.3 14.2 63.5H200.5c1.8-29.2 8.1-49.9 14.2-63.5c3.4-7.6 6.7-13 9.1-16.5zM183 105.2c-6.8 17.1-12.9 40.4-14.6 70.8H129.3c5.3-31.4 25.8-57.6 53.7-70.8zM352 192A128 128 0 1 0 96 192a128 128 0 1 0 256 0zM112 384c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
                }
            }
        ]
    })(props);
}
function FaPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c-23.7 0-44.4 12.9-55.4 32H48C21.5 32 0 53.5 0 80V400c0 26.5 21.5 48 48 48H192V176c0-44.2 35.8-80 80-80h48V80c0-26.5-21.5-48-48-48H215.4C204.4 12.9 183.7 0 160 0zM272 128c-26.5 0-48 21.5-48 48V448v16c0 26.5 21.5 48 48 48H464c26.5 0 48-21.5 48-48V256H416c-17.7 0-32-14.3-32-32V128H320 272zM160 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm256 88v96h96l-96-96z"
                }
            }
        ]
    })(props);
}
function FaPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z"
                }
            }
        ]
    })(props);
}
function FaPaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
                }
            }
        ]
    })(props);
}
function FaPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 445.3V323.5l-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8V66.7C133.2 81.9 64 160.9 64 256c0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5L288 323.5V445.3c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1c0-95.1-69.2-174.1-160-189.3V240.8L422.8 351.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                }
            }
        ]
    })(props);
}
function FaPenClip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.3 19.3l39.4 39.4c25 25 25 65.5 0 90.5l-52.1 52.1 0 0-1-1 0 0-16-16-96-96-17-17 52.1-52.1c25-25 65.5-25 90.5 0zM241 114.9c-9.4-9.4-24.6-9.4-33.9 0L105 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L173.1 81c28.1-28.1 73.7-28.1 101.8 0L288 94.1l17 17 96 96 16 16 1 1-17 17L229.5 412.5c-48 48-109.2 80.8-175.8 94.1l-25 5c-7.9 1.6-16-.9-21.7-6.6s-8.1-13.8-6.6-21.7l5-25c13.3-66.6 46.1-127.8 94.1-175.8L254.1 128 241 114.9z"
                }
            }
        ]
    })(props);
}
function FaPenFancy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"
                }
            }
        ]
    })(props);
}
function FaPenNib(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.8-9.2L288 94.6z"
                }
            }
        ]
    })(props);
}
function FaPenRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M469.3 19.3l23.4 23.4c25 25 25 65.5 0 90.5l-56.4 56.4L322.3 75.7l56.4-56.4c25-25 65.5-25 90.5 0zM44.9 353.2L299.7 98.3 413.7 212.3 158.8 467.1c-6.7 6.7-15.1 11.6-24.2 14.2l-104 29.7c-8.4 2.4-17.4 .1-23.6-6.1s-8.5-15.2-6.1-23.6l29.7-104c2.6-9.2 7.5-17.5 14.2-24.2zM249.4 103.4L103.4 249.4 16 161.9c-18.7-18.7-18.7-49.1 0-67.9L94.1 16c18.7-18.7 49.1-18.7 67.9 0l19.8 19.8c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1l45.1 45.1zM408.6 262.6l45.1 45.1c-.3 .3-.7 .6-1 .9l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c.3-.3 .6-.7 .9-1L496 350.1c18.7 18.7 18.7 49.1 0 67.9L417.9 496c-18.7 18.7-49.1 18.7-67.9 0l-87.4-87.4L408.6 262.6z"
                }
            }
        ]
    })(props);
}
function FaPenToSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"
                }
            }
        ]
    })(props);
}
function FaPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
                }
            }
        ]
    })(props);
}
function FaPencil(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaPeopleArrows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160h44.8c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V464c0 26.5-21.5 48-48 48H496c-26.5 0-48-21.5-48-48V391.2l47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240v32h96V240c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2V336H272v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"
                }
            }
        ]
    })(props);
}
function FaPeopleCarryBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm64 193.7v65.1l51 51c7.1 7.1 11.8 16.2 13.4 26.1l15.2 90.9c2.9 17.4-8.9 33.9-26.3 36.8s-33.9-8.9-36.8-26.3l-14.3-85.9L66.8 320C54.8 308 48 291.7 48 274.7V186.6c0-32.4 26.2-58.6 58.6-58.6c24.1 0 46.5 12 59.9 32l47.4 71.1 10.1 5V160c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32v76.2l10.1-5L473.5 160c13.3-20 35.8-32 59.9-32c32.4 0 58.6 26.2 58.6 58.6v88.1c0 17-6.7 33.3-18.7 45.3l-79.4 79.4-14.3 85.9c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l15.2-90.9c1.6-9.9 6.3-19 13.4-26.1l51-51V241.7l-19 28.5c-4.6 7-11 12.6-18.5 16.3l-59.6 29.8c-2.4 1.3-4.9 2.2-7.6 2.8c-2.6 .6-5.3 .9-7.9 .8H256.7c-2.5 .1-5-.2-7.5-.7c-2.9-.6-5.6-1.6-8.1-3l-59.5-29.8c-7.5-3.7-13.8-9.4-18.5-16.3l-19-28.5zM2.3 468.1L50.1 348.6l49.2 49.2-37.6 94c-6.6 16.4-25.2 24.4-41.6 17.8S-4.3 484.5 2.3 468.1zM512 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm77.9 348.6l47.8 119.5c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8l-37.6-94 49.2-49.2z"
                }
            }
        ]
    })(props);
}
function FaPeopleGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"
                }
            }
        ]
    })(props);
}
function FaPeopleLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 72a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM144 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM496 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM200 313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-36.3-67.5c1.7-1.7 3.2-3.6 4.3-5.8L264 217.5V272c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V217.5l26.9 49.9c1.2 2.2 2.6 4.1 4.3 5.8l-36.3 67.5c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L440 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H486.2c-16.3 0-31.9 4.5-45.4 12.6l-33.6-62.3c-15.3-28.5-45.1-46.3-77.5-46.3H310.2c-32.4 0-62.1 17.8-77.5 46.3l-33.6 62.3c-13.5-8.1-29.1-12.6-45.4-12.6H134.2c-32.4 0-62.1 17.8-77.5 46.3L18.9 340.6c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L88 313.5V352c0 17.7 14.3 32 32 32h48c17.7 0 32-14.3 32-32V313.5z"
                }
            }
        ]
    })(props);
}
function FaPeoplePulling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64V320c0 17.7 14.3 32 32 32c9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8L123.1 352h15.7l30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7c8.6 3.6 18 3.1 25.9-.7c3.4-1.6 6.6-3.9 9.3-6.7c3.1-3.2 5.5-7 7.1-11.4c.1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L537 232.7l-15.3-36.8C504.5 154.8 464.3 128 419.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128H64zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
                }
            }
        ]
    })(props);
}
function FaPeopleRobbery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V174.3c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96A48 48 0 1 0 80 0a48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64v96l0 .6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352H88V480c0 17.7 14.3 32 32 32s32-14.3 32-32V252.7l13 20.5c5.9 9.2 16.1 14.9 27 14.9h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H209.6l-37.4-58.9C157.6 142 132.1 128 104.7 128H72z"
                }
            }
        ]
    })(props);
}
function FaPeopleRoof(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M335.5 4l288 160c15.4 8.6 21 28.1 12.4 43.5s-28.1 21-43.5 12.4L320 68.6 47.5 220c-15.4 8.6-34.9 3-43.5-12.4s-3-34.9 12.4-43.5L304.5 4c9.7-5.4 21.4-5.4 31.1 0zM320 160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM144 256a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm312 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM226.9 491.4L200 441.5V480c0 17.7-14.3 32-32 32H120c-17.7 0-32-14.3-32-32V441.5L61.1 491.4c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l37.9-70.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c16.3 0 31.9 4.5 45.4 12.6l33.6-62.3c15.3-28.5 45.1-46.3 77.5-46.3h19.5c32.4 0 62.1 17.8 77.5 46.3l33.6 62.3c13.5-8.1 29.1-12.6 45.4-12.6h19.5c32.4 0 62.1 17.8 77.5 46.3l37.9 70.3c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8L552 441.5V480c0 17.7-14.3 32-32 32H472c-17.7 0-32-14.3-32-32V441.5l-26.9 49.9c-6.3 11.7-20.8 16-32.5 9.8s-16-20.8-9.8-32.5l36.3-67.5c-1.7-1.7-3.2-3.6-4.3-5.8L376 345.5V400c0 17.7-14.3 32-32 32H296c-17.7 0-32-14.3-32-32V345.5l-26.9 49.9c-1.2 2.2-2.6 4.1-4.3 5.8l36.3 67.5c6.3 11.7 1.9 26.2-9.8 32.5s-26.2 1.9-32.5-9.8z"
                }
            }
        ]
    })(props);
}
function FaPepperHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.3 3c11.6-6.4 26.2-2.3 32.6 9.3l4.8 8.7c19.3 34.7 19.8 75.7 3.4 110C495.8 159.6 512 197.9 512 240c0 18.5-3.1 36.3-8.9 52.8c-6.1 17.3-28.5 16.3-36.8-.1l-11.7-23.4c-4.1-8.1-12.4-13.3-21.5-13.3H360c-13.3 0-24-10.7-24-24V152c0-13.3-10.7-24-24-24l-17.1 0c-21.3 0-30-23.9-10.8-32.9C304.7 85.4 327.7 80 352 80c28.3 0 54.8 7.3 77.8 20.2c5.5-18.2 3.7-38.4-6-55.8L419 35.7c-6.4-11.6-2.3-26.2 9.3-32.6zM171.2 345.5L264 160l40 0v80c0 26.5 21.5 48 48 48h76.2l23.9 47.8C372.3 443.9 244.3 512 103.2 512H44.4C19.9 512 0 492.1 0 467.6c0-20.8 14.5-38.8 34.8-43.3l49.8-11.1c37.6-8.4 69.5-33.2 86.7-67.7z"
                }
            }
        ]
    })(props);
}
function FaPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                }
            }
        ]
    })(props);
}
function FaPersonArrowDownToLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM464 64V306.7l-25.4-25.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L528 306.7V64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaPersonArrowUpFromLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 352V352h16v96H184zm-64 0H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H152h80H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H264V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V448zM598.6 121.4l-80-80c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L464 141.3 464 384c0 17.7 14.3 32 32 32s32-14.3 32-32V141.3l25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaPersonBiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1V416c0 17.7 14.3 32 32 32s32-14.3 32-32V288c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H427.2zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaPersonBooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V192h64V32zm320 0c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM224 512c17.7 0 32-14.3 32-32V320H192V480c0 17.7 14.3 32 32 32zM320 0c-9.3 0-18.1 4-24.2 11s-8.8 16.3-7.5 25.5l31.2 218.6L288.6 409.7c-3.5 17.3 7.8 34.2 25.1 37.7s34.2-7.8 37.7-25.1l.7-3.6c1.3 16.4 15.1 29.4 31.9 29.4c17.7 0 32-14.3 32-32c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM112 80A48 48 0 1 0 16 80a48 48 0 1 0 96 0zm0 261.3V269.3l4.7 4.7c9 9 21.2 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H157.3l-41.6-41.6c-14.3-14.3-33.8-22.4-54-22.4C27.6 160 0 187.6 0 221.6v55.7l0 .9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V384l32 42.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V421.3c0-10.4-3.4-20.5-9.6-28.8L112 341.3z"
                }
            }
        ]
    })(props);
}
function FaPersonBreastfeeding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5c-17.6-14.1-22.7-38.1-13.5-57.7l-.8-.1c-38.9-5.6-74.3-25.1-99.7-54.8V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7c-4.9-2.8-9.2-6.4-12.6-10.6c-4.6-5.4-7.8-11.7-9.6-18.4c-3.3-12-1.9-25.2 4.8-36.6c.6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1h75.2c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4c2.9 6.7 4.3 13.8 4 20.8c-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
                }
            }
        ]
    })(props);
}
function FaPersonBurst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V256.9l28.6 47.5c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-58.3-97c-17.4-28.9-48.6-46.6-82.3-46.6H465.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L408 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
                }
            }
        ]
    })(props);
}
function FaPersonCane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-8 187.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3zM352 376c0-4.4 3.6-8 8-8s8 3.6 8 8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V376c0-30.9-25.1-56-56-56s-56 25.1-56 56v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8z"
                }
            }
        ]
    })(props);
}
function FaPersonChalkboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 384V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V192h56 64 16c17.7 0 32-14.3 32-32s-14.3-32-32-32H384V64H576V256H384V224H320v48c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H243.1 177.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9L120 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                }
            }
        ]
    })(props);
}
function FaPersonCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaPersonCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaPersonCircleMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zm136 16a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaPersonCirclePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16V384h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V304z"
                }
            }
        ]
    })(props);
}
function FaPersonCircleQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM368 321.6V328c0 8.8 7.2 16 16 16s16-7.2 16-16v-6.4c0-5.3 4.3-9.6 9.6-9.6h40.5c7.7 0 13.9 6.2 13.9 13.9c0 5.2-2.9 9.9-7.4 12.3l-32 16.8c-5.3 2.8-8.6 8.2-8.6 14.2V384c0 8.8 7.2 16 16 16s16-7.2 16-16v-5.1l23.5-12.3c15.1-7.9 24.5-23.6 24.5-40.6c0-25.4-20.6-45.9-45.9-45.9H409.6c-23 0-41.6 18.6-41.6 41.6z"
                }
            }
        ]
    })(props);
}
function FaPersonCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l44.9 74.7c-16.1 17.6-28.6 38.5-36.6 61.5c-1.9-1.8-3.5-3.9-4.9-6.3L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152zM432 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L409.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L432 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
                }
            }
        ]
    })(props);
}
function FaPersonDigging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM9.8 214.8c5.1-12.2 19.1-18 31.4-12.9L60.7 210l22.9-38.1C99.9 144.6 129.3 128 161 128c51.4 0 97 32.9 113.3 81.7l34.6 103.7 79.3 33.1 34.2-45.6c6.4-8.5 16.6-13.3 27.2-12.8s20.3 6.4 25.8 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2s-16.3 16.2-27.8 16.2H288c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l16-32c5.4-10.8 16.5-17.7 28.6-17.7h32l22.5-30L22.8 246.2c-12.2-5.1-18-19.1-12.9-31.4zm82.8 91.8l112 48c11.8 5 19.4 16.6 19.4 29.4v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V405.1l-60.6-26-37 111c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.6 469.9l48-144 11-33 32 13.7z"
                }
            }
        ]
    })(props);
}
function FaPersonDotsFromLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176A88 88 0 1 0 288 0a88 88 0 1 0 0 176zM78.7 372.9c15-12.5 50-34.4 97.3-50.1V432H400V322.7c47.3 15.8 82.3 37.7 97.3 50.1c20.4 17 50.6 14.2 67.6-6.1s14.2-50.6-6.1-67.6c-12-10-30.1-22.5-53.2-35C497.2 278.4 481.7 288 464 288c-26.5 0-48-21.5-48-48c0-4.3 .6-8.4 1.6-12.4C379.1 215.9 335.3 208 288 208c-60.2 0-114.9 12.9-160 29.9c0 .7 0 1.4 0 2.1c0 26.5-21.5 48-48 48c-11.8 0-22.7-4.3-31-11.4c-13.1 8.1-23.7 15.9-31.7 22.5c-20.4 17-23.1 47.2-6.1 67.6s47.2 23.1 67.6 6.1zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM224 280a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 240a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm368 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaPersonDressBurst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM390.2 384H408v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h16v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h17.8c10.9 0 18.6-10.7 15.2-21.1L546.7 248.1l33.9 56.3c9.1 15.1 28.8 20 43.9 10.9s20-28.8 10.9-43.9l-53.6-89.2c-20.2-33.7-56.7-54.3-96-54.3H474.2c-39.3 0-75.7 20.6-96 54.3l-53.6 89.2c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9l33.9-56.3L375 362.9c-3.5 10.4 4.3 21.1 15.2 21.1zM190.9 18.1C188.4 12 182.6 8 176 8s-12.4 4-14.9 10.1l-29.4 74L55.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1L10.9 206.4c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2L90.6 327c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L176 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 50.5-7.8 24.4-40.5-55.2-38L315 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L220.3 92.1l-29.4-74z"
                }
            }
        ]
    })(props);
}
function FaPersonDress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM88 384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2c20.3-33.7 56.7-54.3 96-54.3h11.6c39.3 0 75.7 20.6 96 54.3l53.6 89.2c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9l-33.9-56.3L265 362.9c3.5 10.4-4.3 21.1-15.2 21.1H232v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H152v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
                }
            }
        ]
    })(props);
}
function FaPersonDrowning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64c0-17.7-14.3-32-32-32s-32 14.3-32 32V96.2c0 54.1 23.5 104 62.2 138.3l-21 146.7c7.8 2.1 15.5 3.3 22.8 3.3c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c12.4 8.5 26.1 14.8 39.7 18l17.7-97.6c10.7-1.2 21.3-3.1 31.9-5.5l105-23.9c17.2-3.9 28-21.1 24.1-38.3s-21.1-28-38.3-24.1L400 216.6c-41 9.3-83.7 7.5-123.7-5.2c-50.2-16-84.3-62.6-84.3-115.3V64zM320 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM306.5 389.9c-11.1-7.9-25.9-7.9-37 0C247 405.4 219.5 416 192 416c-26.9 0-55.3-10.8-77.4-26.1l0 0c-11.9-8.5-28.1-7.8-39.2 1.7c-14.4 11.9-32.5 21-50.6 25.2c-17.2 4-27.9 21.2-23.9 38.4s21.2 27.9 38.4 23.9c24.5-5.7 44.9-16.5 58.2-25C126.5 469.7 159 480 192 480c31.9 0 60.6-9.9 80.4-18.9c5.8-2.7 11.1-5.3 15.6-7.7c4.5 2.4 9.7 5.1 15.6 7.7c19.8 9 48.5 18.9 80.4 18.9c33 0 65.5-10.3 94.5-25.8c13.4 8.4 33.7 19.3 58.2 25c17.2 4 34.4-6.7 38.4-23.9s-6.7-34.4-23.9-38.4c-18.1-4.2-36.2-13.3-50.6-25.2c-11.1-9.4-27.3-10.1-39.2-1.7l0 0C439.4 405.2 410.9 416 384 416c-27.5 0-55-10.6-77.5-26.1z"
                }
            }
        ]
    })(props);
}
function FaPersonFallingBurst(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 9.8c0 39-23.7 74-59.9 88.4C71.6 154.5 32 213 32 278.2V352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-73.8c0-10 1.6-19.8 4.5-29L261.1 497.4c9.6 14.8 29.4 19.1 44.3 9.5s19.1-29.4 9.5-44.3L222.6 320H224l80 0 38.4 51.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C341.3 263.1 327.1 256 312 256l-71.5 0-56.8-80.2-.2-.3c44.7-29 72.5-79 72.5-133.6l0-9.8zM96 80A48 48 0 1 0 0 80a48 48 0 1 0 96 0zM464 286.1l58.6 53.9c4.8 4.4 11.9 5.5 17.8 2.6s9.5-9 9-15.5l-5.6-79.4 78.7-12.2c6.5-1 11.7-5.9 13.1-12.2s-1.1-13-6.5-16.7l-65.6-45.1L603 92.2c3.3-5.7 2.7-12.8-1.4-17.9s-10.9-7.2-17.2-5.3L508.3 92.1l-29.4-74C476.4 12 470.6 8 464 8s-12.4 4-14.9 10.1l-29.4 74L343.6 68.9c-6.3-1.9-13.1 .2-17.2 5.3s-4.6 12.2-1.4 17.9l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7c.1 .3 .1 .6 .2 .8l19.4 0c20.1 0 39.2 7.5 53.8 20.8l18.4 2.9L383 265.3l36.2 48.3c2.1 2.8 3.9 5.7 5.5 8.6L464 286.1z"
                }
            }
        ]
    })(props);
}
function FaPersonFalling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c17.7 0 32 14.3 32 32l0 9.8c0 54.6-27.9 104.6-72.5 133.6l.2 .3L304.5 256l87.5 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L384 320l-96 0h-1.4l92.3 142.6c9.6 14.8 5.4 34.6-9.5 44.3s-34.6 5.4-44.3-9.5L164.5 249.2c-2.9 9.2-4.5 19-4.5 29l0 73.8c0 17.7-14.3 32-32 32s-32-14.3-32-32V278.2c0-65.1 39.6-123.7 100.1-147.9C232.3 115.8 256 80.8 256 41.8l0-9.8c0-17.7 14.3-32 32-32zM112 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaPersonHalfDress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm8 352V128h6.9c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352h0zM58.2 182.3c19.9-33.1 55.3-53.5 93.8-54.3V384h0v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H70.2c-10.9 0-18.6-10.7-15.2-21.1L93.3 248.1 59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l53.6-89.2z"
                }
            }
        ]
    })(props);
}
function FaPersonHarassing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352h16V480c0 17.7 14.3 32 32 32s32-14.3 32-32V235.3l47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7H145.1c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344v58.7l-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L408.8 438l54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3c36.4 0 65.9-29.5 65.9-65.9V344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16h56c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
                }
            }
        ]
    })(props);
}
function FaPersonHiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm51.3 182.7L224.2 307l49.7 49.7c9 9 14.1 21.2 14.1 33.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3l-73.9-73.9c-15.8-15.8-22.2-38.6-16.9-60.3l20.4-84c8.3-34.1 42.7-54.9 76.7-46.4c19 4.8 35.6 16.4 46.4 32.7L305.1 208H336V184c0-13.3 10.7-24 24-24s24 10.7 24 24v55.8c0 .1 0 .2 0 .2s0 .2 0 .2V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H296.6c-16 0-31-8-39.9-21.4l-13.3-20zM81.1 471.9L117.3 334c3 4.2 6.4 8.2 10.1 11.9l41.9 41.9L142.9 488.1c-4.5 17.1-22 27.3-39.1 22.8s-27.3-22-22.8-39.1zm55.5-346L101.4 266.5c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8z"
                }
            }
        ]
    })(props);
}
function FaPersonMilitaryPointing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.9 14.1C234 15.2 224 26 224 39c0 13.8 11.2 25 25 25H400c8.8 0 16-7.2 16-16V17.4C416 8 408 .7 398.7 1.4L246.9 14.1zM240 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H241.6c-1 5.2-1.6 10.5-1.6 16zM72 224c-22.1 0-40 17.9-40 40s17.9 40 40 40H224v89.4L386.8 230.5c-13.3-4.3-27.3-6.5-41.6-6.5H240 72zm345.7 20.9L246.6 416H416V369.7l53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L462.3 290.8c-11.2-18.9-26.6-34.5-44.6-45.9zM224 448v32c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V448H224z"
                }
            }
        ]
    })(props);
}
function FaPersonMilitaryRifle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 39c0-13 10-23.8 22.9-24.9L334.7 1.4C344 .7 352 8 352 17.4V48c0 8.8-7.2 16-16 16H185c-13.8 0-25-11.2-25-25zm17.6 57H334.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L352 369.7V480c0 1.3-.1 2.5-.2 3.8L177.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9h50.4c15.9 0 31.3 2.8 45.8 7.9L421.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l13.9 8 13.9 8c7.7 4.4 10.3 14.2 5.9 21.9L416 173.9l1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L392.6 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM320 512H192c-17.7 0-32-14.3-32-32V369.7l-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8l76.1-128.8c9.4-15.8 21.7-29.3 36-40L331.1 510c-3.5 1.3-7.2 2-11.1 2zM296 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaPersonMilitaryToPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71 12.5c-8.6 1-15 8.2-15 16.8c0 9.3 7.5 16.8 16.7 16.9H184.1c8.8-.1 15.9-7.2 15.9-16V16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1H66.5C64.9 83.8 64 89.8 64 96c0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256v32c0 17.7 14.3 32 32 32H192c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5V256c0-35.3-28.7-64-64-64H96c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H352zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376v32l-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0v32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 2.9 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9s14.1-12.4 14.1-21.9l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
                }
            }
        ]
    })(props);
}
function FaPersonPraying(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 64A64 64 0 1 0 224 64a64 64 0 1 0 128 0zM232.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36C253.6 156.7 228.6 144 202 144c-30.9 0-59.2 17.1-73.6 44.4L79.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L158.6 432H72c-22.1 0-40 17.9-40 40s17.9 40 40 40H280c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7L187.7 354l45-90z"
                }
            }
        ]
    })(props);
}
function FaPersonPregnant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120 383c-13.8-3.6-24-16.1-24-31V296.9l-4.6 7.6c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c15-24.9 40.3-41.5 68.7-45.6c4.1-.6 8.2-1 12.5-1h1.1 12.5H192c1.4 0 2.8 .1 4.1 .3c35.7 2.9 65.4 29.3 72.1 65l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32H304 264v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384h-8-8v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V383z"
                }
            }
        ]
    })(props);
}
function FaPersonRays(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9l-28.6 47.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L328 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H248zM7 7C16.4-2.3 31.6-2.3 41 7l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 41C-2.3 31.6-2.3 16.4 7 7zM471 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L471 7zM7 505c-9.4-9.4-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 505c-9.4 9.4-24.6 9.4-33.9 0zm464 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0z"
                }
            }
        ]
    })(props);
}
function FaPersonRifle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M265.2 192c25.4 0 49.8 7.1 70.8 19.9V512H144V337.7L90.4 428.3c-11.2 19-35.8 25.3-54.8 14.1s-25.3-35.8-14.1-54.8L97.7 258.8c24.5-41.4 69-66.8 117.1-66.8h50.4zM160 80a80 80 0 1 1 160 0A80 80 0 1 1 160 80zM448 0c8.8 0 16 7.2 16 16V132.3c9.6 5.5 16 15.9 16 27.7V269.3l16-5.3V208c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2L480 325.3V352h48c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H484l23 92.1c2.5 10.1-5.1 19.9-15.5 19.9H432c-8.8 0-16-7.2-16-16V400H400c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32V160c0-11.8 6.4-22.2 16-27.7V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16 16z"
                }
            }
        ]
    })(props);
}
function FaPersonRunning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM125.7 175.5c9.9-9.9 23.4-15.5 37.5-15.5c1.9 0 3.8 .1 5.6 .3L137.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9-25.4 88.8c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l28.7-100.4c5.9-20.6-2.6-42.6-20.7-53.9L238 299l30.9-82.4 5.1 12.3C289 264.7 323.9 288 362.7 288H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H362.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3L57.4 153.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l23.1-23.1zM91.2 352H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h69.6c19 0 36.2-11.2 43.9-28.5L157 361.6l-9.5-6c-17.5-10.9-30.5-26.8-37.9-44.9L91.2 352z"
                }
            }
        ]
    })(props);
}
function FaPersonShelter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160V480c0 17.7 14.3 32 32 32s32-14.3 32-32V178.6L256 68.9 448 178.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 280V400h16v88c0 13.3 10.7 24 24 24s24-10.7 24-24V313.5l26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-37.9-70.3c-15.3-28.5-45.1-46.3-77.5-46.3H246.2c-32.4 0-62.1 17.8-77.5 46.3l-37.9 70.3c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5V488c0 13.3 10.7 24 24 24s24-10.7 24-24z"
                }
            }
        ]
    })(props);
}
function FaPersonSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM128 128c0-17.7 14.3-32 32-32H319.4c43.6 0 64.6 53.4 32.8 83.1l-74.4 69.4 60.2 60.2c9 9 14.1 21.2 14.1 33.9V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V349.3l-77.9-77.8c-26.6-26.6-24.6-70.3 4.3-94.4l20.4-17H160c-17.7 0-32-14.3-32-32zM81.4 353.4l86.9-86.9c4.6 10 11 19.3 19.3 27.5l21.8 21.8-82.7 82.7c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm322.5 95.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
                }
            }
        ]
    })(props);
}
function FaPersonSkiingNordic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM227.2 160c1.9 0 3.8 .1 5.6 .3L201.6 254c-9.3 28 1.7 58.8 26.8 74.5l86.2 53.9L291.3 464H202.8l41.1-88.1-32.4-20.3c-7.8-4.9-14.7-10.7-20.6-17.3L132.2 464H99.7l54.2-257.6c4.6-1.5 9-4.1 12.7-7.8l23.1-23.1c9.9-9.9 23.4-15.5 37.5-15.5zM121.4 198.6c.4 .4 .8 .8 1.3 1.2L67 464H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H159.3c.4 0 .9 0 1.3 0H319.3c.5 0 1 0 1.4 0H504c39.8 0 72-32.2 72-72v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 13.3-10.7 24-24 24H434.6l27.6-179.3c10.5-5.2 17.8-16.1 17.8-28.7c0-17.7-14.3-32-32-32H426.7c-12.9 0-24.6-7.8-29.5-19.7l-6.3-15c-14.6-35.1-44.1-61.9-80.5-73.1l-48.7-15c-11.1-3.4-22.7-5.2-34.4-5.2c-31 0-60.8 12.3-82.7 34.3l-23.1 23.1c-12.5 12.5-12.5 32.8 0 45.3zm308 89.4L402.3 464H357.8l21.6-75.6c5.9-20.6-2.6-42.6-20.7-53.9L302 299l30.9-82.4 5.1 12.3C353 264.7 387.9 288 426.7 288h2.7z"
                }
            }
        ]
    })(props);
}
function FaPersonSkiing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.7 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM2.7 268.9c6.1-11.8 20.6-16.3 32.4-10.2L232.7 361.3l46.2-69.2-75.1-75.1c-14.6-14.6-20.4-33.9-18.4-52.1l108.8 52 39.3 39.3c16.2 16.2 18.7 41.5 6 60.6L289.8 391l128.7 66.8c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 301.3C1.2 295.2-3.4 280.7 2.7 268.9zM118.9 65.6L137 74.2l8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 16.9 54.7 26.2c1.5-.7 3.1-1.4 4.7-2.1l83.4-33.4c34.2-13.7 72.8 4.2 84.5 39.2l17.1 51.2 52.1 26.1c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3l-58.1-29c-11.4-5.7-20-15.7-24.1-27.8l-5.8-17.3-27.3 12.1-6.8 3-6.7-3.2L151.5 116.7l-9.2 18.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.3-13.4-7.5-21.3s13.4-11.3 21.3-7.5z"
                }
            }
        ]
    })(props);
}
function FaPersonSnowboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.7 3.4c15.8-7.9 35-1.5 42.9 14.3l25 50 42.4 8.5c19.5 3.9 37.8 12.3 53.5 24.5l126.1 98.1c14 10.9 16.5 31 5.6 44.9s-31 16.5-44.9 5.6l-72.1-56.1-71.5 31.8 33.1 27.6c23.2 19.3 33.5 50 26.7 79.4l-17.4 75.2c-2.2 9.4-8.2 16.8-16.1 21l86.5 33.1c4.6 1.8 9.4 2.6 14.3 2.6H472c13.3 0 24 10.7 24 24s-10.7 24-24 24H443.8c-10.8 0-21.4-2-31.5-5.8L60.1 371.3c-11.5-4.4-22-11.2-30.8-20L7 329c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.4 22.4c4 4 8.7 7.1 14 9.1l22.4 8.6c-.8-1.6-1.5-3.2-2.1-4.9c-5.6-16.8 3.5-34.9 20.2-40.5L192 264.9l0-53.2c0-24.2 13.7-46.4 35.4-57.2l45.2-22.6-7.5-1.5c-19.4-3.9-35.9-16.5-44.7-34.1l-25-50c-7.9-15.8-1.5-35 14.3-42.9zM139 350.1l159 60.9c-2.1-5.6-2.6-11.9-1.1-18.2l17.4-75.2c1.4-5.9-.7-12-5.3-15.9l-52.8-44 0 18.8c0 20.7-13.2 39-32.8 45.5L139 350.1zM432 0a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaPersonSwimming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaPersonThroughWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4C167.6 186.5 128 245 128 310.2l0 73.8s0 0 0 0H64V64zm288 0l224 0V384H508.3l-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4c44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320H379.2l42.7 64H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48V400c0 26.5 21.5 48 48 48H308.2l33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4L310.5 336l74.6 0 40 48zm-159.5 0H192s0 0 0 0l0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaPersonWalkingArrowLoopLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zm347.7 119c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L461.3 384H480c88.4 0 160-71.6 160-160s-71.6-160-160-160L352 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c53 0 96 43 96 96s-43 96-96 96H461.3l25.4-25.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3l80 80z"
                }
            }
        ]
    })(props);
}
function FaPersonWalkingArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80z"
                }
            }
        ]
    })(props);
}
function FaPersonWalkingDashedLineArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM123.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L281 232.7l-15.3-36.8C248.5 154.8 208.3 128 163.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1L68.7 398 9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L116.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM550.6 153.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L530.7 224H384c-17.7 0-32 14.3-32 32s14.3 32 32 32H530.7l-25.4 25.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l80-80c12.5-12.5 12.5-32.8 0-45.3l-80-80zM392 0c-13.3 0-24 10.7-24 24V72c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM392 320c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24s24-10.7 24-24V344c0-13.3-10.7-24-24-24zm24 120c0-13.3-10.7-24-24-24s-24 10.7-24 24v48c0 13.3 10.7 24 24 24s24-10.7 24-24V440z"
                }
            }
        ]
    })(props);
}
function FaPersonWalkingLuggage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM347.7 200.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9L505 232.7l-15.3-36.8C472.5 154.8 432.3 128 387.7 128c-22.8 0-45.3 4.8-66.1 14l-8 3.5c-32.9 14.6-58.1 42.4-69.4 76.5l-2.6 7.8c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l2.6-7.8c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5zm-30 135.1l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L340.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6zM256 274.1c-7.7-4.4-17.4-1.8-21.9 5.9l-32 55.4L147.7 304c-15.3-8.8-34.9-3.6-43.7 11.7L40 426.6c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l64-110.9c1.5-2.6 2.6-5.2 3.3-8L261.9 296c4.4-7.7 1.8-17.4-5.9-21.9z"
                }
            }
        ]
    })(props);
}
function FaPersonWalkingWithCane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8.4 32c-36.4 0-69.6 20.5-85.9 53.1L35.4 273.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3L128 231.6v43.2c0 17 6.7 33.3 18.7 45.3L224 397.3V480c0 17.7 14.3 32 32 32s32-14.3 32-32V390.6c0-12.7-5.1-24.9-14.1-33.9L224 306.7V213.3l70.4 93.9c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8L268.8 166.4C250.7 142.2 222.2 128 192 128H167.6zM128.3 346.8L97 472.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l22-88.2-52.8-52.8zM450.8 505.1c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L358.9 316.1c-2.8 3.8-6.1 7.3-10.1 10.3c-5 3.8-10.5 6.4-16.2 7.9L450.8 505.1z"
                }
            }
        ]
    })(props);
}
function FaPersonWalking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM126.5 199.3c-1 .4-1.9 .8-2.9 1.2l-8 3.5c-16.4 7.3-29 21.2-34.7 38.2l-2.6 7.8c-5.6 16.8-23.7 25.8-40.5 20.2s-25.8-23.7-20.2-40.5l2.6-7.8c11.4-34.1 36.6-61.9 69.4-76.5l8-3.5c20.8-9.2 43.3-14 66.1-14c44.6 0 84.8 26.8 101.9 67.9L281 232.7l21.4 10.7c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.8-22.8-24.5l-9.6-23-19.3 65.5 49.5 54c5.4 5.9 9.2 13 11.2 20.8l23 92.1c4.3 17.1-6.1 34.5-23.3 38.8s-34.5-6.1-38.8-23.3l-22-88.1-70.7-77.1c-14.8-16.1-20.3-38.6-14.7-59.7l16.9-63.5zM68.7 398l25-62.4c2.1 3 4.5 5.8 7 8.6l40.7 44.4-14.5 36.2c-2.4 6-6 11.5-10.6 16.1L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L68.7 398z"
                }
            }
        ]
    })(props);
}
function FaPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V256.9L59.4 304.5c-9.1 15.1-28.8 20-43.9 10.9s-20-28.8-10.9-43.9l58.3-97c17.4-28.9 48.6-46.6 82.3-46.6h29.7c33.7 0 64.9 17.7 82.3 46.6l58.3 97c9.1 15.1 4.2 34.8-10.9 43.9s-34.8 4.2-43.9-10.9L232 256.9V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H152z"
                }
            }
        ]
    })(props);
}
function FaPesetaSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64v96c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 96V448c0 17.7 14.3 32 32 32s32-14.3 32-32V352h96c77.4 0 142-55 156.8-128H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-3.2C334 87 269.4 32 192 32H64zM282.5 160H96V96h96c41.8 0 77.4 26.7 90.5 64zM96 224H282.5c-13.2 37.3-48.7 64-90.5 64H96V224z"
                }
            }
        ]
    })(props);
}
function FaPesoSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C46.3 32 32 46.3 32 64v64c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c68.4 0 127.7-39 156.8-96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32h-.7c.5-5.3 .7-10.6 .7-16s-.2-10.7-.7-16h.7c17.7 0 32-14.3 32-32s-14.3-32-32-32H332.8C303.7 71 244.4 32 176 32H64zm190.4 96H96V96h80c30.5 0 58.2 12.2 78.4 32zM96 192H286.9c.7 5.2 1.1 10.6 1.1 16s-.4 10.8-1.1 16H96V192zm158.4 96c-20.2 19.8-47.9 32-78.4 32H96V288H254.4z"
                }
            }
        ]
    })(props);
}
function FaPhoneFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 24.6c7.7-18.6 28-28.5 47.4-23.2l88 24C499.9 30.2 512 46 512 64c0 247.4-200.6 448-448 448c-18 0-33.8-12.1-38.6-29.5l-24-88c-5.3-19.4 4.6-39.7 23.2-47.4l96-40c16.3-6.8 35.2-2.1 46.3 11.6L207.3 368c70.4-33.3 127.4-90.3 160.7-160.7L318.7 167c-13.7-11.2-18.4-30-11.6-46.3l40-96z"
                }
            }
        ]
    })(props);
}
function FaPhoneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M228.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C76.1 30.2 64 46 64 64c0 107.4 37.8 206 100.8 283.1L9.2 469.1c-10.4 8.2-12.3 23.3-4.1 33.7s23.3 12.3 33.7 4.1l592-464c10.4-8.2 12.3-23.3 4.1-33.7s-23.3-12.3-33.7-4.1L253 278c-17.8-21.5-32.9-45.2-45-70.7L257.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96zm96.8 319l-91.3 72C310.7 476 407.1 512 512 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L368.7 368c-15-7.1-29.3-15.2-43-24.3z"
                }
            }
        ]
    })(props);
}
function FaPhoneVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 0C408.1 0 512 103.9 512 232c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-72c0-13.3 10.7-24 24-24c75.1 0 136 60.9 136 136c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88c-13.3 0-24-10.7-24-24zM117.5 1.4c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24z"
                }
            }
        ]
    })(props);
}
function FaPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"
                }
            }
        ]
    })(props);
}
function FaPhotoFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0H576c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64zM476 106.7C471.5 100 464 96 456 96s-15.5 4-20 10.7l-56 84L362.7 169c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h80 48H552c8.9 0 17-4.9 21.2-12.7s3.7-17.3-1.2-24.6l-96-144zM336 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 128h96V384v32c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32V384H512v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm8 64c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V312c0-8.8-7.2-16-16-16H72zm0 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H72zm336 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16H424c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaPiggyBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96l0 .7c-5.3-.4-10.6-.7-16-.7H256c-16.5 0-32.5 2.1-47.8 6c-.1-2-.2-4-.2-6c0-53 43-96 96-96s96 43 96 96zm-16 32c3.5 0 7 .1 10.4 .3c4.2 .3 8.4 .7 12.6 1.3C424.6 109.1 450.8 96 480 96h11.5c10.4 0 18 9.8 15.5 19.9l-13.8 55.2c15.8 14.8 28.7 32.8 37.5 52.9H544c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H512c-9.1 12.1-19.9 22.9-32 32v64c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H256v32c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416c-34.9-26.2-58.7-66.3-63.2-112H68c-37.6 0-68-30.4-68-68s30.4-68 68-68h4c13.3 0 24 10.7 24 24s-10.7 24-24 24H68c-11 0-20 9-20 20s9 20 20 20H99.2c12.1-59.8 57.7-107.5 116.3-122.8c12.9-3.4 26.5-5.2 40.5-5.2H384zm64 136a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                }
            }
        ]
    })(props);
}
function FaPills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 96c-26.5 0-48 21.5-48 48V256h96V144c0-26.5-21.5-48-48-48zM0 144C0 82.1 50.1 32 112 32s112 50.1 112 112V368c0 61.9-50.1 112-112 112S0 429.9 0 368V144zM554.9 399.4c-7.1 12.3-23.7 13.1-33.8 3.1L333.5 214.9c-10-10-9.3-26.7 3.1-33.8C360 167.7 387.1 160 416 160c88.4 0 160 71.6 160 160c0 28.9-7.7 56-21.1 79.4zm-59.5 59.5C472 472.3 444.9 480 416 480c-88.4 0-160-71.6-160-160c0-28.9 7.7-56 21.1-79.4c7.1-12.3 23.7-13.1 33.8-3.1L498.5 425.1c10 10 9.3 26.7-3.1 33.8z"
                }
            }
        ]
    })(props);
}
function FaPizzaSlice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L110.4 80c.5 0 1.1 0 1.6 0c176.7 0 320 143.3 320 320c0 .5 0 1.1 0 1.6l44.4-11.8c20.8-5.5 36.3-24.7 34.7-47.5C498.5 159.5 352.5 13.5 169.7 .9zM399.8 410.2c.1-3.4 .2-6.8 .2-10.2c0-159.1-128.9-288-288-288c-3.4 0-6.8 .1-10.2 .2L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1L399.8 410.2zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaPlaceOfWorship(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 109.3V217.6L183.3 242c-14.5 8.7-23.3 24.3-23.3 41.2V512h96V416c0-35.3 28.7-64 64-64s64 28.7 64 64v96h96V283.2c0-16.9-8.8-32.5-23.3-41.2L416 217.6V109.3c0-8.5-3.4-16.6-9.4-22.6L331.3 11.3c-6.2-6.2-16.4-6.2-22.6 0L233.4 86.6c-6 6-9.4 14.1-9.4 22.6zM24.9 330.3C9.5 338.8 0 354.9 0 372.4V464c0 26.5 21.5 48 48 48h80V273.6L24.9 330.3zM592 512c26.5 0 48-21.5 48-48V372.4c0-17.5-9.5-33.6-24.9-42.1L512 273.6V512h80z"
                }
            }
        ]
    })(props);
}
function FaPlaneArrival(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.3 166.9L0 68C0 57.7 9.5 50.1 19.5 52.3l35.6 7.9c10.6 2.3 19.2 9.9 23 20L96 128l127.3 37.6L181.8 20.4C178.9 10.2 186.6 0 197.2 0h40.1c11.6 0 22.2 6.2 27.9 16.3l109 193.8 107.2 31.7c15.9 4.7 30.8 12.5 43.7 22.8l34.4 27.6c24 19.2 18.1 57.3-10.7 68.2c-41.2 15.6-86.2 18.1-128.8 7L121.7 289.8c-11.1-2.9-21.2-8.7-29.3-16.9L9.5 189.4c-5.9-6-9.3-14-9.3-22.5zM32 448H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaPlaneCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaPlaneCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaPlaneCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-35 0-64 59.5-64 93.7v84.6L8.1 283.4c-5 2.8-8.1 8.2-8.1 13.9v65.5c0 10.6 10.2 18.3 20.4 15.4l171.6-49 0 70.9-57.6 43.2c-4 3-6.4 7.8-6.4 12.8v42c0 7.8 6.3 14 14 14c1.3 0 2.6-.2 3.9-.5L256 480l110.1 31.5c1.3 .4 2.6 .5 3.9 .5c6 0 11.1-3.7 13.1-9C344.5 470.7 320 422.2 320 368c0-60.6 30.6-114 77.1-145.6L320 178.3V93.7C320 59.5 292 0 256 0zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaPlaneDeparture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381 114.9L186.1 41.8c-16.7-6.2-35.2-5.3-51.1 2.7L89.1 67.4C78 73 77.2 88.5 87.6 95.2l146.9 94.5L136 240 77.8 214.1c-8.7-3.9-18.8-3.7-27.3 .6L18.3 230.8c-9.3 4.7-11.8 16.8-5 24.7l73.1 85.3c6.1 7.1 15 11.2 24.3 11.2H248.4c5 0 9.9-1.2 14.3-3.4L535.6 212.2c46.5-23.3 82.5-63.3 100.8-112C645.9 75 627.2 48 600.2 48H542.8c-20.2 0-40.2 4.8-58.2 14L381 114.9zM0 480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaPlaneLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7v84.6l101.8 58.2C418 247.6 416 259.6 416 272v24.6c-17.9 10.4-30.3 29.1-31.8 50.9L320 329.1V400l57.6 43.2c4 3 6.4 7.8 6.4 12.8v24 18c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400l0-70.9-171.6 49C10.2 381.1 0 373.4 0 362.8V297.3c0-5.7 3.1-11 8.1-13.9L192 178.3V93.7zM528 240c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
                }
            }
        ]
    })(props);
}
function FaPlaneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M514.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64H440.6L630.8 469.1c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L238.1 161.3 197.8 20.4C194.9 10.2 202.6 0 213.2 0h56.2c11.5 0 22.1 6.2 27.8 16.1L397.7 192l116.6 0zM41.5 128.7l321 252.9L297.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6H144l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4H46c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L64 256 32.5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-6.2 4-11.4 9.5-13.3z"
                }
            }
        ]
    })(props);
}
function FaPlaneUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 93.7C192 59.5 221 0 256 0c36 0 64 59.5 64 93.7l0 66.3L497.8 278.5c8.9 5.9 14.2 15.9 14.2 26.6v56.7c0 10.9-10.7 18.6-21.1 15.2L320 320v80l57.6 43.2c4 3 6.4 7.8 6.4 12.8v42c0 7.8-6.3 14-14 14c-1.3 0-2.6-.2-3.9-.5L256 480 145.9 511.5c-1.3 .4-2.6 .5-3.9 .5c-7.8 0-14-6.3-14-14V456c0-5 2.4-9.8 6.4-12.8L192 400V320L21.1 377C10.7 380.4 0 372.7 0 361.8V305.1c0-10.7 5.3-20.7 14.2-26.6L192 160V93.7z"
                }
            }
        ]
    })(props);
}
function FaPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
                }
            }
        ]
    })(props);
}
function FaPlantWilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 120c0-30.9 25.1-56 56-56s56 25.1 56 56v13c-29.3 10-48 34.5-48 70.1c0 27.9 25.3 74.8 66 111.6c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V120C464 53.7 410.3 0 344 0S224 53.7 224 120v21.8C207.3 133 188.2 128 168 128c-66.3 0-120 53.7-120 120v13c-29.3 10-48 34.5-48 70.1C0 359 25.3 405.9 66 442.7c3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6c0-35.6-18.7-60.2-48-70.1V248c0-30.9 25.1-56 56-56s56 25.1 56 56v32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V280 248 120z"
                }
            }
        ]
    })(props);
}
function FaPlateWheat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM56 64h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24s10.7-24 24-24zM24 136H136c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48zM400 32c44.2 0 80 35.8 80 80v16c0 8.8-7.2 16-16 16c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm80 160v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80zm-96 16v16c0 44.2-35.8 80-80 80c-8.8 0-16-7.2-16-16V256c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320H484.2c14.8 0 26.2 12.9 24.4 27.6C502.3 397.8 464.2 437 416 446v2c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-2c-48.2-9-86.3-48.2-92.5-98.4z"
                }
            }
        ]
    })(props);
}
function FaPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
                }
            }
        ]
    })(props);
}
function FaPlugCircleBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
                }
            }
        ]
    })(props);
}
function FaPlugCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-76.7-43.3c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L416 385.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
                }
            }
        ]
    })(props);
}
function FaPlugCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaPlugCircleMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM576 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16H496c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaPlugCirclePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V304c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaPlugCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8c12.3-2.5 24.1-6.4 35.1-11.5c-2.1-10.8-3.1-21.9-3.1-33.3c0-80.3 53.8-148 127.3-169.2c.5-2.2 .7-4.5 .7-6.8c0-17.7-14.3-32-32-32H32zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L432 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C78.3 0 64 14.3 64 32v96h64V32c0-17.7-14.3-32-32-32zM288 0c-17.7 0-32 14.3-32 32v96h64V32c0-17.7-14.3-32-32-32zM32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32v32c0 77.4 55 142 128 156.8V480c0 17.7 14.3 32 32 32s32-14.3 32-32V412.8C297 398 352 333.4 352 256V224c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaPlusMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H160V320c0 17.7 14.3 32 32 32s32-14.3 32-32V208H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V32zM0 480c0 17.7 14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
                }
            }
        ]
    })(props);
}
function FaPodcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 372c48.5-31.3 80.6-85.9 80.6-148c0-97.2-78.8-176-176-176S48 126.8 48 224c0 62.1 32.1 116.6 80.6 148c1.2 17.3 4 38 7.2 57.1l.2 1C56 395.8 0 316.5 0 224C0 100.3 100.3 0 224 0S448 100.3 448 224c0 92.5-56 171.9-136 206.1l.2-1.1c3.1-19.2 6-39.8 7.2-57zm-2.3-38.1c-1.6-5.7-3.9-11.1-7-16.2c-5.8-9.7-13.5-17-21.9-22.4c19.5-17.6 31.8-43 31.8-71.3c0-53-43-96-96-96s-96 43-96 96c0 28.3 12.3 53.8 31.8 71.3c-8.4 5.4-16.1 12.7-21.9 22.4c-3.1 5.1-5.4 10.5-7 16.2C99.8 307.5 80 268 80 224c0-79.5 64.5-144 144-144s144 64.5 144 144c0 44-19.8 83.5-50.9 109.9zM224 312c32.9 0 64 8.6 64 43.8c0 33-12.9 104.1-20.6 132.9c-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8c0-35.1 31.1-43.8 64-43.8zm0-144a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
                }
            }
        ]
    })(props);
}
function FaPooStorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M236.9 .2c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1c0 21.7-8.5 37.2-21.9 47.6c-13.8 10.8-34 17-57.8 17H128c-35.3 0-64 28.7-64 64c0 12.2 3.4 23.5 9.3 33.2C31.7 216.2 0 252.4 0 296c0 41 28 75.4 65.8 85.2c-5.3-18.5 1-38.5 16.2-50.7l160-128c17.6-14.1 42.6-14 60.2 .2s22.8 38.6 12.8 58.8L285.7 320H304c20.4 0 38.5 12.9 45.3 32.1c3.7 10.6 3.5 21.8 0 31.9H360c48.6 0 88-39.4 88-88c0-43.6-31.7-79.8-73.3-86.8c5.9-9.7 9.3-21.1 9.3-33.2c0-35.3-28.7-64-64-64h-1.4c.9-5.4 1.4-10.9 1.4-16.6c0-48.7-36.1-88.9-83.1-95.2zm45.1 227.4c-5.8-4.7-14.2-4.7-20.1-.1l-160 128c-5.3 4.2-7.4 11.4-5.1 17.8s8.3 10.7 15.1 10.7h70.1L129.7 488.8c-3.4 6.7-1.6 14.9 4.3 19.6s14.2 4.7 20.1 .1l160-128c5.3-4.2 7.4-11.4 5.1-17.8s-8.3-10.7-15.1-10.7H233.9l52.4-104.8c3.4-6.7 1.6-14.9-4.3-19.6z"
                }
            }
        ]
    })(props);
}
function FaPoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1c0 44.1-35.7 79.9-79.8 80H160c-35.3 0-64 28.7-64 64c0 19.1 8.4 36.3 21.7 48H104c-39.8 0-72 32.2-72 72c0 23.2 11 43.8 28 57c-34.1 5.7-60 35.3-60 71c0 39.8 32.2 72 72 72H440c39.8 0 72-32.2 72-72c0-35.7-25.9-65.3-60-71c17-13.2 28-33.8 28-57c0-39.8-32.2-72-72-72H394.3c13.3-11.7 21.7-28.9 21.7-48c0-35.3-28.7-64-64-64h-5.5c3.5-10 5.5-20.8 5.5-32c0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7c-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7c0-6.8 5.5-12.3 12.3-12.3H339.7c6.8 0 12.3 5.5 12.3 12.3z"
                }
            }
        ]
    })(props);
}
function FaPoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7C315.8 7.2 352 47.4 352 96c0 11.2-1.9 22-5.5 32H352c35.3 0 64 28.7 64 64c0 19.1-8.4 36.3-21.7 48H408c39.8 0 72 32.2 72 72c0 23.2-11 43.8-28 57c34.1 5.7 60 35.3 60 71c0 39.8-32.2 72-72 72H72c-39.8 0-72-32.2-72-72c0-35.7 25.9-65.3 60-71c-17-13.2-28-33.8-28-57c0-39.8 32.2-72 72-72h13.7C104.4 228.3 96 211.1 96 192c0-35.3 28.7-64 64-64h16.2c44.1-.1 79.8-35.9 79.8-80c0-9.2-1.5-17.9-4.3-26.1c-1.8-5.2-.8-11.1 2.8-15.4z"
                }
            }
        ]
    })(props);
}
function FaPowerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V256c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM143.5 120.6c13.6-11.3 15.4-31.5 4.1-45.1s-31.5-15.4-45.1-4.1C49.7 115.4 16 181.8 16 256c0 132.5 107.5 240 240 240s240-107.5 240-240c0-74.2-33.8-140.6-86.6-184.6c-13.6-11.3-33.8-9.4-45.1 4.1s-9.4 33.8 4.1 45.1c38.9 32.3 63.5 81 63.5 135.4c0 97.2-78.8 176-176 176s-176-78.8-176-176c0-54.4 24.7-103.1 63.5-135.4z"
                }
            }
        ]
    })(props);
}
function FaPrescriptionBottleMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zM160 240v48H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V352h48c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H224V240c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaPrescriptionBottle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0H352c17.7 0 32 14.3 32 32V64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64V32zm32 96H352V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V416H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V320H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V224H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V128z"
                }
            }
        ]
    })(props);
}
function FaPrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32V192v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224h50.7l128 128L137.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7l-85.8-85.8C251.4 209.1 288 164.8 288 112C288 50.1 237.9 0 176 0H32zM176 160H64V64H176c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaPumpMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM216 280v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V360H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V280c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaPumpSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 32v96H256V96h60.1c4.2 0 8.3 1.7 11.3 4.7l33.9 33.9c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L372.7 55.4c-15-15-35.4-23.4-56.6-23.4H256c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM117.4 160c-33.3 0-61 25.5-63.8 58.7L35 442.7C31.9 480 61.3 512 98.8 512H285.2c37.4 0 66.9-32 63.8-69.3l-18.7-224c-2.8-33.2-30.5-58.7-63.8-58.7H117.4zM256 360c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9c3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C219 279.1 256 327.5 256 360z"
                }
            }
        ]
    })(props);
}
function FaPuzzlePiece(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8v0c0 12.8 10.4 23.2 23.2 23.2H336c26.5 0 48 21.5 48 48v56.8c0 12.8 10.4 23.2 23.2 23.2v0c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2v0c-12.8 0-23.2 10.4-23.2 23.2V464c0 26.5-21.5 48-48 48H279.2c-12.8 0-23.2-10.4-23.2-23.2v0c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8v0c0 12.8-10.4 23.2-23.2 23.2H48c-26.5 0-48-21.5-48-48V343.2C0 330.4 10.4 320 23.2 320v0c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256v0C10.4 256 0 245.6 0 232.8V176c0-26.5 21.5-48 48-48H168.8c12.8 0 23.2-10.4 23.2-23.2v0z"
                }
            }
        ]
    })(props);
}
function FaQ(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 256c0 88.4 71.6 160 160 160c28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1C371.9 325.8 384 292.3 384 256c0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
                }
            }
        ]
    })(props);
}
function FaQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
                }
            }
        ]
    })(props);
}
function FaQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                }
            }
        ]
    })(props);
}
function FaQuoteLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 216C0 149.7 53.7 96 120 96h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320 288 216zm256 0c0-66.3 53.7-120 120-120h8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-8c-30.9 0-56 25.1-56 56v8h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H320c-35.3 0-64-28.7-64-64V320 288 216z"
                }
            }
        ]
    })(props);
}
function FaQuoteRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z"
                }
            }
        ]
    })(props);
}
function FaR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V288 448c0 17.7 14.3 32 32 32s32-14.3 32-32V320h95.3L261.8 466.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176c0-79.5-64.5-144-144-144H64zM176 256H64V96H176c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaRadiation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 186.7c-23.9 13.8-40 39.7-40 69.3L32 256C14.3 256-.2 241.6 2 224.1C10.7 154 47.8 92.7 101.3 52c14.1-10.7 33.8-5.3 42.7 10l72 124.7zM256 336c14.6 0 28.2-3.9 40-10.7l72 124.8c8.8 15.3 3.7 35.1-12.6 41.9c-30.6 12.9-64.2 20-99.4 20s-68.9-7.1-99.4-20c-16.3-6.9-21.4-26.6-12.6-41.9l72-124.8c11.8 6.8 25.4 10.7 40 10.7zm224-80l-144 0c0-29.6-16.1-55.5-40-69.3L368 62c8.8-15.3 28.6-20.7 42.7-10c53.6 40.7 90.6 102 99.4 172.1c2.2 17.5-12.4 31.9-30 31.9zM256 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.8 47c12.7-3.7 20-17.1 16.3-29.8S494-2.8 481.2 1L51.7 126.9c-9.4 2.7-17.9 7.3-25.1 13.2C10.5 151.7 0 170.6 0 192v4V304 448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H218.5L494.8 47zM368 240a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM80 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM64 320c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 64c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaRainbow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96C178.6 96 64 210.6 64 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C0 175.3 143.3 32 320 32s320 143.3 320 320v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352C576 210.6 461.4 96 320 96zm0 192c-35.3 0-64 28.7-64 64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-70.7 57.3-128 128-128s128 57.3 128 128v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-35.3-28.7-64-64-64zM160 352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-123.7 100.3-224 224-224s224 100.3 224 224v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352c0-88.4-71.6-160-160-160s-160 71.6-160 160z"
                }
            }
        ]
    })(props);
}
function FaRankingStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.8 54.1L330.2 6.3c-3.9-8.3-16.1-8.6-20.4 0L286.2 54.1l-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H256zM32 320c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H32zm416 96v64c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V416c0-17.7-14.3-32-32-32H480c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
                }
            }
        ]
    })(props);
}
function FaRecordVinyl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaRectangleAd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM229.5 173.3l72 144c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L253.2 328H162.8l-5.4 10.7c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l72-144c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3zM208 237.7L186.8 280h42.3L208 237.7zM392 256a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24-43.9V184c0-13.3 10.7-24 24-24s24 10.7 24 24v96 48c0 13.3-10.7 24-24 24c-6.6 0-12.6-2.7-17-7c-9.4 4.5-19.9 7-31 7c-39.8 0-72-32.2-72-72s32.2-72 72-72c8.4 0 16.5 1.4 24 4.1z"
                }
            }
        ]
    })(props);
}
function FaRectangleList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-128a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-248c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H448c13.3 0 24-10.7 24-24s-10.7-24-24-24H224z"
                }
            }
        ]
    })(props);
}
function FaRectangleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaRecycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M174.7 45.1C192.2 17 223 0 256 0s63.8 17 81.3 45.1l38.6 61.7 27-15.6c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3l-23.4 87.4c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l28.4-16.4L283 79c-5.8-9.3-16-15-27-15s-21.2 5.7-27 15l-17.5 28c-9.2 14.8-28.6 19.5-43.6 10.5c-15.3-9.2-20.2-29.2-10.7-44.4l17.5-28zM429.5 251.9c15-9 34.4-4.3 43.6 10.5l24.4 39.1c9.4 15.1 14.4 32.4 14.6 50.2c.3 53.1-42.7 96.4-95.8 96.4L320 448v32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2v32l96.2 0c17.6 0 31.9-14.4 31.8-32c0-5.9-1.7-11.7-4.8-16.7l-24.4-39.1c-9.5-15.2-4.7-35.2 10.7-44.4zm-364.6-31L36 204.2c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20l87.4-23.4c12.8-3.4 26 4.2 29.4 17L182 241.2c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-26.5-15.3L68.8 335.3c-3.1 5-4.8 10.8-4.8 16.7c-.1 17.6 14.2 32 31.8 32l32.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.2 0C42.7 448-.3 404.8 0 351.6c.1-17.8 5.1-35.1 14.6-50.2l50.3-80.5z"
                }
            }
        ]
    })(props);
}
function FaRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152c0-13.3 10.7-24 24-24h88c44.2 0 80 35.8 80 80c0 28-14.4 52.7-36.3 67l34.1 75.1c5.5 12.1 .1 26.3-11.9 31.8s-26.3 .1-31.8-11.9L268.9 288H208v72c0 13.3-10.7 24-24 24s-24-10.7-24-24V264 152zm48 88h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H208v64z"
                }
            }
        ]
    })(props);
}
function FaRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224c0 17.7 14.3 32 32 32s32-14.3 32-32c0-53 43-96 96-96H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S320 19.1 320 32V64H160C71.6 64 0 135.6 0 224zm512 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 53-43 96-96 96H192V352c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V448H352c88.4 0 160-71.6 160-160z"
                }
            }
        ]
    })(props);
}
function FaReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.4 39.5c-9.1-9.6-24.3-10-33.9-.9L33.8 173.2c-19.9 18.9-19.9 50.7 0 69.6L175.5 377.4c9.6 9.1 24.8 8.7 33.9-.9s8.7-24.8-.9-33.9L66.8 208 208.5 73.4c9.6-9.1 10-24.3 .9-33.9zM352 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144c-6.7 6.1-10.6 14.7-10.6 23.8s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V288h32c53 0 96 43 96 96c0 30.4-12.8 47.9-22.2 56.7c-5.5 5.1-9.8 12-9.8 19.5c0 10.9 8.8 19.7 19.7 19.7c2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176H352V64z"
                }
            }
        ]
    })(props);
}
function FaReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"
                }
            }
        ]
    })(props);
}
function FaRepublican(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 192C0 103.6 71.6 32 160 32H384c88.4 0 160 71.6 160 160v64H0V192zm415.9-64c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L466 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm-138.3 3.4c-1.1-2.1-3.3-3.4-5.7-3.4s-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L322 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6zM127.9 128c-2.4 0-4.7 1.3-5.7 3.4l-12.6 24.6-28.2 4c-2.4 .3-4.4 2-5.2 4.2s-.1 4.7 1.6 6.3l20.4 19.2-4.8 27.1c-.4 2.3 .6 4.7 2.5 6s4.6 1.6 6.7 .5l25.2-12.8 25.2 12.8c2.2 1.1 4.8 .9 6.7-.5s3-3.7 2.5-6l-4.8-27.1L178 170.5c1.7-1.6 2.4-4.1 1.6-6.3s-2.8-3.9-5.2-4.2l-28.2-4-12.6-24.6c-1.1-2.1-3.3-3.4-5.7-3.4zm.1 160H320h96 32 64 32v32 80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80s-80-35.8-80-80V352H448v32 64c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V384H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V384 288H128z"
                }
            }
        ]
    })(props);
}
function FaRestroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 48a48 48 0 1 1 96 0A48 48 0 1 1 80 48zm40 304V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V325.2c-8.1 9.2-21.1 13.2-33.5 9.4c-16.9-5.3-26.3-23.2-21-40.1l30.9-99.1C44.9 155.3 82 128 124 128h8c42 0 79.1 27.3 91.6 67.4l30.9 99.1c5.3 16.9-4.1 34.8-21 40.1c-12.4 3.9-25.4-.2-33.5-9.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H120zM320 0c13.3 0 24 10.7 24 24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V24c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480V384H422.2c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5c-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1c-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1H584v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384H504v96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaRetweet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32-14.3-32-32V192h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l32 0 0 128c0 53 43 96 96 96H272zM304 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l112 0c17.7 0 32 14.3 32 32l0 128H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8l-32 0V192c0-53-43-96-96-96L304 96z"
                }
            }
        ]
    })(props);
}
function FaRibbon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.2 322.8l0 0-133.9-146 0 0L146 118.6c7.8-5.1 37-22.6 78-22.6s70.2 17.4 78 22.6L245.7 180l85.6 93.4 27.4-29.8c16.3-17.7 25.3-40.9 25.3-65V149.1c0-19-5.6-37.5-16.1-53.3L327.8 35.6C312.9 13.4 287.9 0 261.2 0h-76c-25.8 0-50.1 12.5-65.1 33.5L81.9 87C70.3 103.2 64 122.8 64 142.8V164c0 23.2 8.4 45.6 23.6 63.1l56 64.2 0 0 83.3 95.6 0 0 91.8 105.3c10 11.5 26.8 14.3 40 6.8l54.5-31.1c17.8-10.2 21.6-34.3 7.7-49.4l-87.7-95.7zM205.2 410.6l-83.3-95.6L27.1 418.5c-13.9 15.1-10.1 39.2 7.7 49.4l55.1 31.5c13 7.4 29.3 4.9 39.4-6.1l75.9-82.6z"
                }
            }
        ]
    })(props);
}
function FaRightFromBracket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaRightLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96l320 0V32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160L32 160c-17.7 0-32-14.3-32-32s14.3-32 32-32zM480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H160v64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6l96-96c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 64H480z"
                }
            }
        ]
    })(props);
}
function FaRightLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M334.5 414c8.8 3.8 19 2 26-4.6l144-136c4.8-4.5 7.5-10.8 7.5-17.4s-2.7-12.9-7.5-17.4l-144-136c-7-6.6-17.2-8.4-26-4.6s-14.5 12.5-14.5 22l0 72L32 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l288 0 0 72c0 9.6 5.7 18.2 14.5 22z"
                }
            }
        ]
    })(props);
}
function FaRightToBracket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 208c0 7.8 4.4 18.7 17.1 30.3C126.5 214.1 188.9 200 256 200s129.5 14.1 174.9 38.3C443.6 226.7 448 215.8 448 208c0-12.3-10.8-32-47.9-50.6C364.9 139.8 314 128 256 128s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7C166.3 280.2 208.8 288 256 288s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208c0-49.6 39.4-85.8 83.3-107.8C129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8v96c0 49.6-39.4 85.8-83.3 107.8C382.9 434.7 321.7 448 256 448s-126.9-13.3-172.7-36.2C39.4 389.8 0 353.6 0 304V208z"
                }
            }
        ]
    })(props);
}
function FaRoadBarrier(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V266.3L149.2 96H64V64c0-17.7-14.3-32-32-32zM405.2 96H330.8l-5.4 10.7L234.8 288h74.3l5.4-10.7L405.2 96zM362.8 288h74.3l5.4-10.7L533.2 96H458.8l-5.4 10.7L362.8 288zM202.8 96l-5.4 10.7L106.8 288h74.3l5.4-10.7L277.2 96H202.8zm288 192H576V448c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v53.7L490.8 288z"
                }
            }
        ]
    })(props);
}
function FaRoadBridge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0H608c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM480 200c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V224c0-13.3-10.7-24-24-24zm24 184c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V384zM480 40c-13.3 0-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V64c0-13.3-10.7-24-24-24zM32 96H288v64H248v64h40v96c-53 0-96 43-96 96v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V416c0-53-43-96-96-96V224H72V160H32c-17.7 0-32-14.3-32-32s14.3-32 32-32zm168 64H120v64h80V160z"
                }
            }
        ]
    })(props);
}
function FaRoadCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaRoadCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-192c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaRoadCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.2 32H288V96c0 17.7 14.3 32 32 32s32-14.3 32-32V32h74.8c27.1 0 51.3 17.1 60.3 42.6l42.7 120.6c-10.9-2.1-22.2-3.2-33.8-3.2c-59.5 0-112.1 29.6-144 74.8V224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32c2.3 0 4.6-.3 6.8-.7c-4.5 15.5-6.8 31.8-6.8 48.7c0 5.4 .2 10.7 .7 16l-.7 0c-17.7 0-32 14.3-32 32v64H86.6C56.5 480 32 455.5 32 425.4c0-6.2 1.1-12.4 3.1-18.2L152.9 74.6C162 49.1 186.1 32 213.2 32zM496 224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm22.6 144l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L473.4 368l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L496 390.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
                }
            }
        ]
    })(props);
}
function FaRoadLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32H213.2c-27.1 0-51.3 17.1-60.3 42.6L35.1 407.2c-2.1 5.9-3.1 12-3.1 18.2C32 455.5 56.5 480 86.6 480H288V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64h32V352c0-23.7 12.9-44.4 32-55.4V272c0-58.3 44.6-106.2 101.5-111.5L487.1 74.6C478 49.1 453.9 32 426.8 32H352V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaRoadSpikes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 116.8c0-15.8 20.5-22 29.3-8.9L192 256V116.8c0-15.8 20.5-22 29.3-8.9L320 256V116.8c0-15.8 20.5-22 29.3-8.9L448 256V116.8c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.7-26.6 49.7H512 448 384 320 256 192 64V116.8zM32 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32H181.2c-27.1 0-51.3 17.1-60.3 42.6L3.1 407.2C1.1 413 0 419.2 0 425.4C0 455.5 24.5 480 54.6 480H256V416c0-17.7 14.3-32 32-32s32 14.3 32 32v64H521.4c30.2 0 54.6-24.5 54.6-54.6c0-6.2-1.1-12.4-3.1-18.2L455.1 74.6C446 49.1 421.9 32 394.8 32H320V96c0 17.7-14.3 32-32 32s-32-14.3-32-32V32zm64 192v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0c17.7 0 32 14.3 32 32V96H472c39.8 0 72 32.2 72 72V440c0 39.8-32.2 72-72 72H168c-39.8 0-72-32.2-72-72V168c0-39.8 32.2-72 72-72H288V32c0-17.7 14.3-32 32-32zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM264 256a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm152 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM48 224H64V416H48c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm544 0c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H576V224h16z"
                }
            }
        ]
    })(props);
}
function FaRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                }
            }
        ]
    })(props);
}
function FaRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"
                }
            }
        ]
    })(props);
}
function FaRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
                }
            }
        ]
    })(props);
}
function FaRotate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"
                }
            }
        ]
    })(props);
}
function FaRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96 43 96 96s-43 96-96 96H139.6c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320c-53 0-96-43-96-96s43-96 96-96h39.8c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaRubleSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C78.3 32 64 46.3 64 64V256H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H128V320H240c79.5 0 144-64.5 144-144s-64.5-144-144-144H96zM240 256H128V96H240c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaRug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 64H56 80V88v88 80 80 88 24H56 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V360H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V280H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V200H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V112H24C10.7 112 0 101.3 0 88S10.7 64 24 64zm88 0H528V448H112V64zM640 88c0 13.3-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v32h8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8v40h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H584 560V424 336 256 176 88 64h24 32c13.3 0 24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaRulerCombined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.2 468.9C2.7 493.1 23.1 512 48 512l96 0 320 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-48c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 368l0 96c0 1.7 .1 3.3 .2 4.9z"
                }
            }
        ]
    })(props);
}
function FaRulerHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 336c0 26.5 21.5 48 48 48l544 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80-64 0c-26.5 0-48 21.5-48 48L0 336z"
                }
            }
        ]
    })(props);
}
function FaRulerVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H208c26.5 0 48 21.5 48 48V96H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
                }
            }
        ]
    })(props);
}
function FaRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177.9 494.1c-18.7 18.7-49.1 18.7-67.9 0L17.9 401.9c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 41.4-41.4 48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48 50.7-50.7c18.7-18.7 49.1-18.7 67.9 0l92.1 92.1c18.7 18.7 18.7 49.1 0 67.9L177.9 494.1z"
                }
            }
        ]
    })(props);
}
function FaRupeeSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256.5 16.4c-.9 6 0 8.7 .4 9.8c.4 1.1 1.4 2.6 4.2 4.9c7.2 5.7 18.7 10 37.9 16.8l1.3 .5c16 5.6 38.7 13.6 55.7 28.1c9.5 8.1 17.9 18.6 23.1 32.3c5.1 13.7 6.1 28.5 3.8 44c-4.2 28.1-20.5 49.3-43.8 60.9c-22.1 11-48.1 12.5-73.2 8l-.2 0 0 0c-9.3-1.8-20.5-5.7-29.3-9c-6-2.3-12.6-4.9-17.7-6.9l0 0c-2.5-1-4.6-1.8-6.3-2.5c-16.5-6.4-24.6-25-18.2-41.4s24.9-24.6 41.4-18.2c2.6 1 5.2 2 7.9 3.1l0 0c4.8 1.9 9.8 3.9 15.4 6c8.8 3.3 15.3 5.4 18.7 6c15.7 2.8 26.7 .8 32.9-2.3c5-2.5 8-6 9.1-13c1-6.9 .2-10.5-.5-12.3c-.6-1.7-1.8-3.6-4.5-5.9c-6.9-5.8-18.2-10.4-36.9-17l-3-1.1c-15.5-5.4-37-13-53.3-25.9c-9.5-7.5-18.3-17.6-23.7-31c-5.5-13.4-6.6-28-4.4-43.2c8.4-57.1 67-78 116.9-68.9c6.9 1.3 27.3 5.8 35.4 8.4c16.9 5.2 26.3 23.2 21.1 40.1s-23.2 26.3-40.1 21.1c-4.7-1.4-22.3-5.5-27.9-6.5c-14.6-2.7-25.8-.4-32.6 3.2c-6.3 3.3-8.9 7.6-9.5 12z"
                }
            }
        ]
    })(props);
}
function FaRupiahSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32h80c79.5 0 144 64.5 144 144c0 58.8-35.2 109.3-85.7 131.7l51.4 128.4c6.6 16.4-1.4 35-17.8 41.6s-35-1.4-41.6-17.8L106.3 320H64V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 64zM64 256h48c44.2 0 80-35.8 80-80s-35.8-80-80-80H64V256zm256-96h80c61.9 0 112 50.1 112 112s-50.1 112-112 112H352v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V352 192c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48H352v96h48z"
                }
            }
        ]
    })(props);
}
function FaS(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99.1 105.4C79 114 68.2 127.2 65.2 144.8c-2.4 14.1-.7 23.2 2 29.4c2.8 6.3 7.9 12.4 16.7 18.6c19.2 13.4 48.3 22.1 84.9 32.5c1 .3 1.9 .6 2.9 .8c32.7 9.3 72 20.6 100.9 40.7c15.7 10.9 29.9 25.5 38.6 45.1c8.8 19.8 10.8 42 6.6 66.3c-7.3 42.5-35.3 71.7-71.8 87.3c-35.4 15.2-79.1 17.9-123.7 10.9l-.2 0 0 0c-24-3.9-62.7-17.1-87.6-25.6c-4.8-1.7-9.2-3.1-12.8-4.3C5.1 440.8-3.9 422.7 1.6 405.9s23.7-25.8 40.5-20.3c4.9 1.6 10.2 3.4 15.9 5.4c25.4 8.6 56.4 19.2 74.4 22.1c36.8 5.7 67.5 2.5 88.5-6.5c20.1-8.6 30.8-21.8 33.9-39.4c2.4-14.1 .7-23.2-2-29.4c-2.8-6.3-7.9-12.4-16.7-18.6c-19.2-13.4-48.3-22.1-84.9-32.5c-1-.3-1.9-.6-2.9-.8c-32.7-9.3-72-20.6-100.9-40.7c-15.7-10.9-29.9-25.5-38.6-45.1c-8.8-19.8-10.8-42-6.6-66.3l31.5 5.5L2.1 133.9C9.4 91.4 37.4 62.2 73.9 46.6c35.4-15.2 79.1-17.9 123.7-10.9c13 2 52.4 9.6 66.6 13.4c17.1 4.5 27.2 22.1 22.7 39.2s-22.1 27.2-39.2 22.7c-11.2-3-48.1-10.2-60.1-12l4.9-31.5-4.9 31.5c-36.9-5.8-67.5-2.5-88.6 6.5z"
                }
            }
        ]
    })(props);
}
function FaSackDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 96H192L144.6 24.9C137.5 14.2 145.1 0 157.9 0H354.1c12.8 0 20.4 14.2 13.3 24.9L320 96zM192 128H320c3.8 2.5 8.1 5.3 13 8.4C389.7 172.7 512 250.9 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96C0 250.9 122.3 172.7 179 136.4l0 0 0 0c4.8-3.1 9.2-5.9 13-8.4zm84 88c0-11-9-20-20-20s-20 9-20 20v14c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V424c0 11 9 20 20 20s20-9 20-20V410.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l0 0-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V216z"
                }
            }
        ]
    })(props);
}
function FaSackXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96H320l47.4-71.1C374.5 14.2 366.9 0 354.1 0H157.9c-12.8 0-20.4 14.2-13.3 24.9L192 96zm128 32H192c-3.8 2.5-8.1 5.3-13 8.4l0 0 0 0C122.3 172.7 0 250.9 0 416c0 53 43 96 96 96H416c53 0 96-43 96-96c0-165.1-122.3-243.3-179-279.6c-4.8-3.1-9.2-5.9-13-8.4zM289.9 336l47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47z"
                }
            }
        ]
    })(props);
}
function FaSailboat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 16c0-7 4.5-13.2 11.2-15.3s13.9 .4 17.9 6.1l224 320c3.4 4.9 3.8 11.3 1.1 16.6s-8.2 8.6-14.2 8.6H272c-8.8 0-16-7.2-16-16V16zM212.1 96.5c7 1.9 11.9 8.2 11.9 15.5V336c0 8.8-7.2 16-16 16H80c-5.7 0-11-3-13.8-8s-2.9-11-.1-16l128-224c3.6-6.3 11-9.4 18-7.5zM5.7 404.3C2.8 394.1 10.5 384 21.1 384H554.9c10.6 0 18.3 10.1 15.4 20.3l-4 14.3C550.7 473.9 500.4 512 443 512H133C75.6 512 25.3 473.9 9.7 418.7l-4-14.3z"
                }
            }
        ]
    })(props);
}
function FaSatelliteDish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSatellite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M233 7c-9.4-9.4-24.6-9.4-33.9 0l-96 96c-9.4 9.4-9.4 24.6 0 33.9l89.4 89.4-15.5 15.5C152.3 230.4 124.9 224 96 224c-31.7 0-61.5 7.7-87.8 21.2c-9 4.7-10.3 16.7-3.1 23.8L112.7 376.7 96.3 393.1c-2.6-.7-5.4-1.1-8.3-1.1c-17.7 0-32 14.3-32 32s14.3 32 32 32s32-14.3 32-32c0-2.9-.4-5.6-1.1-8.3l16.4-16.4L242.9 506.9c7.2 7.2 19.2 5.9 23.8-3.1C280.3 477.5 288 447.7 288 416c0-28.9-6.4-56.3-17.8-80.9l15.5-15.5L375 409c9.4 9.4 24.6 9.4 33.9 0l96-96c9.4-9.4 9.4-24.6 0-33.9l-89.4-89.4 55-55c12.5-12.5 12.5-32.8 0-45.3l-48-48c-12.5-12.5-32.8-12.5-45.3 0l-55 55L233 7zm159 351l-72.4-72.4 62.1-62.1L454.1 296 392 358.1zM226.3 192.4L153.9 120 216 57.9l72.4 72.4-62.1 62.1z"
                }
            }
        ]
    })(props);
}
function FaScaleBalanced(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H398.4c-5.2 25.8-22.9 47.1-46.4 57.3V448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H320 128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-23.5-10.3-41.2-31.6-46.4-57.3H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288H584.4L512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C627.2 382 574.9 416 512 416zM126.8 195.8L54.4 320H199.3L126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C242 382 189.7 416 126.8 416S11.7 382 .9 337.1z"
                }
            }
        ]
    })(props);
}
function FaScaleUnbalancedFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.9 62.4c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l113 37.7C265 15.8 290.7 0 320 0c44.2 0 80 35.8 80 80c0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.4 145.2c-4.5 3.2-9.3 5.9-14.4 8.2V480c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H288V153.3c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.4 288L128 163.8 55.6 288H200.4zM128 384C65.1 384 12.8 350 2 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1C243.2 350 190.9 384 128 384zm382.8-92.2L438.4 416H583.3L510.8 291.8zm126 141.3C626 478 573.7 512 510.8 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
                }
            }
        ]
    })(props);
}
function FaScaleUnbalanced(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M522.1 62.4c16.8-5.6 25.8-23.7 20.2-40.5S518.6-3.9 501.9 1.6l-113 37.7C375 15.8 349.3 0 320 0c-44.2 0-80 35.8-80 80c0 3 .2 5.9 .5 8.8L117.9 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2V480c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V153.3c21-9.2 37.2-27 44.2-49l125.9-42zM439.6 288L512 163.8 584.4 288H439.6zM512 384c62.9 0 115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L536.1 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L392.7 273.1c-5.7 9.8-9.3 21.1-6.7 32.1C396.8 350 449.1 384 512 384zM129.2 291.8L201.6 416H56.7l72.4-124.2zM3.2 433.1C14 478 66.3 512 129.2 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L153.2 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L9.9 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
                }
            }
        ]
    })(props);
}
function FaSchoolCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM640 368a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-99.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L480 385.4l60.7-60.7z"
                }
            }
        ]
    })(props);
}
function FaSchoolCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaSchoolCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H320v0H256V416c0-35.3 28.7-64 64-64l.3 0h.5c3.4-37.7 18.7-72.1 42.2-99.1C350.2 260 335.6 264 320 264c-48.6 0-88-39.4-88-88s39.4-88 88-88s88 39.4 88 88c0 18.3-5.6 35.3-15.1 49.4c29-21 64.6-33.4 103.1-33.4c59.5 0 112.1 29.6 144 74.8V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm0 128h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM320 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
                }
            }
        ]
    })(props);
}
function FaSchoolFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0H400c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H320.7l89.6 64H512c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H336V400c0-26.5-21.5-48-48-48s-48 21.5-48 48V512H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64H165.7L256 95.5V32c0-17.7 14.3-32 32-32zm48 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM80 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H80zm368 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16H464c-8.8 0-16 7.2-16 16zM80 352c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H80zm384 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H464z"
                }
            }
        ]
    })(props);
}
function FaSchoolLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 5.4c10.7-7.2 24.8-7.2 35.5 0L473.7 96H592c26.5 0 48 21.5 48 48V272c0-61.9-50.1-112-112-112s-112 50.1-112 112v24.6c-19.1 11.1-32 31.7-32 55.4H320.3l-.3 0c-35.3 0-64 28.7-64 64v96h64v0H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48H166.3L302.2 5.4zM80 208v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm0 128v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm240-72a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm16-120v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 96c-17.7 0-32 14.3-32 32v48h64V272c0-17.7-14.3-32-32-32zm-80 32c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32V272z"
                }
            }
        ]
    })(props);
}
function FaSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M337.8 5.4C327-1.8 313-1.8 302.2 5.4L166.3 96H48C21.5 96 0 117.5 0 144V464c0 26.5 21.5 48 48 48H592c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H473.7L337.8 5.4zM256 416c0-35.3 28.7-64 64-64s64 28.7 64 64v96H256V416zM96 192h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V208zM96 320h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm400 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H512c-8.8 0-16-7.2-16-16V336zM232 176a88 88 0 1 1 176 0 88 88 0 1 1 -176 0zm88-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H336V144c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 192l-39.5-39.5c4.9-12.6 7.5-26.2 7.5-40.5C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c14.3 0 27.9-2.7 40.5-7.5L192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5C50.1 288 0 338.1 0 400s50.1 112 112 112s112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6c-28.3-28.3-74.1-28.3-102.4 0L256 192zm22.6 150.6L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0c7.1-7.1 7.1-18.5 0-25.6L342.6 278.6l-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaScrewdriverWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h54.1l109 109c-14.7 29-10 65.4 14.3 89.6l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-24.2-24.2-60.6-29-89.6-14.3l-109-109V104c0-7.5-3.5-14.5-9.4-19L78.6 5zM19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L233.7 374.3c-7.8-20.9-9-43.6-3.6-65.1l-61.7-61.7L19.9 396.1zM512 144c0-10.5-1.1-20.7-3.2-30.5c-2.4-11.2-16.1-14.1-24.2-6l-63.9 63.9c-3 3-7.1 4.7-11.3 4.7H352c-8.8 0-16-7.2-16-16V102.6c0-4.2 1.7-8.3 4.7-11.3l63.9-63.9c8.1-8.1 5.2-21.8-6-24.2C388.7 1.1 378.5 0 368 0C288.5 0 224 64.5 224 144l0 .8 85.3 85.3c36-9.1 75.8 .5 104 28.7L429 274.5c49-23 83-72.8 83-130.5zM56 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaScrewdriver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v54.1l-85.6 85.6c6.7 4.2 13 9.3 18.8 15.1s10.9 12.2 15.1 18.8L353.9 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7zM121.4 281.4l-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
                }
            }
        ]
    })(props);
}
function FaScrollTorah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480V32C96 14.3 74.5 0 48 0S0 14.3 0 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32zM512 32H128V480H512V32zM592 0c-26.5 0-48 14.3-48 32V480c0 17.7 21.5 32 48 32s48-14.3 48-32V32c0-17.7-21.5-32-48-32zM196 313.7c0-3.2 .9-6.4 2.5-9.2L226.7 256l-28.3-48.5c-1.6-2.8-2.5-6-2.5-9.2c0-10.1 8.2-18.3 18.3-18.3H271l31.4-53.9c3.6-6.3 10.3-10.1 17.6-10.1s13.9 3.8 17.6 10.1L369 180h56.7c10.1 0 18.3 8.2 18.3 18.3c0 3.2-.9 6.4-2.5 9.2L413.3 256l28.3 48.5c1.6 2.8 2.5 6 2.5 9.2c0 10.1-8.2 18.3-18.3 18.3H369l-31.4 53.9c-3.6 6.3-10.3 10.1-17.6 10.1s-13.9-3.8-17.6-10.1L271 332H214.3c-10.1 0-18.3-8.2-18.3-18.3zm124 54.7L341.2 332H298.8L320 368.4zM254.5 256l30.3 52h70.4l30.3-52-30.3-52H284.8l-30.3 52zm144.9 23.8L383 308h32.8l-16.4-28.2zM415.8 204H383l16.4 28.2L415.8 204zM320 143.6L298.8 180h42.4L320 143.6zM224.2 204l16.4 28.2L257 204H224.2zM257 308l-16.4-28.2L224.2 308H257z"
                }
            }
        ]
    })(props);
}
function FaScroll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v48c0 17.7 14.3 32 32 32H48 96V80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48V384c0 35.3 28.7 64 64 64s64-28.7 64-64v-5.3c0-32.4 26.3-58.7 58.7-58.7H480V128c0-53-43-96-96-96H112zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16H314.7c-14.7 0-26.7 11.9-26.7 26.7V384c0 53-43 96-96 96H368h96z"
                }
            }
        ]
    })(props);
}
function FaSdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0H141.3C124.3 0 108 6.7 96 18.7L18.7 96C6.7 108 0 124.3 0 141.3V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 88v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24zm80 0v48c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaSection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64.9 96C67.1 84.4 73.7 76.2 86 70.6c13.8-6.2 34.8-8.9 61.2-4.5c8.8 1.4 36.1 7.1 44.1 9.3c17 4.8 34.7-5.1 39.5-22.2s-5.1-34.7-22.2-39.5c-11.1-3.1-41-9.2-50.9-10.8C123-2.7 88.3-.6 59.7 12.3C29.9 25.8 7.5 50.9 1.6 86.5c-.1 .5-.2 1.1-.2 1.6c-2.2 19.7 .3 37.9 8.1 54.1c7.7 16.1 19.4 28 32 36.9c.6 .5 1.3 .9 2 1.4C22.3 194.2 6.5 215.1 1.7 243c-.1 .6-.2 1.1-.2 1.7c-2.3 19.3 .4 37.1 8.4 53c7.9 15.6 19.8 27 32.3 35.5c22.4 15.2 51.9 24 75.4 31l0 0 3.7 1.1c27.2 8.2 46.9 14.6 59.4 23.8c5.5 4 8.2 7.6 9.5 10.9c1.3 3.2 2.6 8.6 .9 18.1c-1.7 10.1-7.7 18-20.7 23.5c-14 6-35.4 8.5-62 4.4c-12.8-2.1-35.1-9.7-54.1-16.2l0 0c-4.3-1.5-8.5-2.9-12.3-4.2C25.3 420 7.2 429.1 1.6 445.8s3.5 34.9 20.3 40.5c2.6 .8 5.7 1.9 9.2 3.1c18.6 6.3 48.5 16.6 67.3 19.6l0 0 .2 0c34.5 5.4 68.8 3.4 97.2-8.7c29.4-12.6 52.5-36.5 58.5-71.5c3.3-19.3 1.9-37.4-5-53.9c-6.3-15-16.4-26.4-27.6-35.2c16.5-13.9 28.5-33.2 32.6-58.2c3.2-19.8 1.9-38.3-4.8-55.1c-6.7-16.8-17.8-29.4-30.2-39c-22.8-17.6-53.6-27.4-77.7-35l-1.4-.5c-27.4-8.7-47.8-15.3-61.5-25c-6.1-4.4-9.5-8.5-11.4-12.4c-1.8-3.7-3.2-9.3-2.3-18.5zm76.7 208.5c-.2-.1-.4-.1-.6-.2l-1.4-.4c-27.4-8.2-47.9-14.5-61.7-23.8c-6.2-4.2-9.3-7.9-11-11.3c-1.5-3-2.9-7.7-2.1-15.7c1.9-9.7 7.9-17.3 20.5-22.7c14-6 35.4-8.5 62.1-4.3l16.4 2.6c6.3 2.9 11.7 6 16.2 9.5c5.5 4.2 8.4 8.2 10 12.2c1.6 4 2.8 10.4 1.1 20.9c-2.4 14.7-12.8 26.4-37.1 31l-12.4 2.3z"
                }
            }
        ]
    })(props);
}
function FaSeedling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 32c0 113.6-84.6 207.5-194.2 222c-7.1-53.4-30.6-101.6-65.3-139.3C290.8 46.3 364 0 448 0h32c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64H64c123.7 0 224 100.3 224 224v32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320C100.3 320 0 219.7 0 96z"
                }
            }
        ]
    })(props);
}
function FaServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M315.4 15.5C309.7 5.9 299.2 0 288 0s-21.7 5.9-27.4 15.5l-96 160c-5.9 9.9-6.1 22.2-.4 32.2s16.3 16.2 27.8 16.2H384c11.5 0 22.2-6.2 27.8-16.2s5.5-22.3-.4-32.2l-96-160zM288 312V456c0 22.1 17.9 40 40 40H472c22.1 0 40-17.9 40-40V312c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zM128 512a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
                }
            }
        ]
    })(props);
}
function FaShareFromSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 224H305.5c-45 0-81.5 36.5-81.5 81.5c0 22.3 10.3 34.3 19.2 40.5c6.8 4.7 12.8 12 12.8 20.3c0 9.8-8 17.8-17.8 17.8h-2.5c-2.4 0-4.8-.4-7.1-1.4C210.8 374.8 128 333.4 128 240c0-79.5 64.5-144 144-144h80V34.7C352 15.5 367.5 0 386.7 0c8.6 0 16.8 3.2 23.2 8.9L548.1 133.3c7.6 6.8 11.9 16.5 11.9 26.7s-4.3 19.9-11.9 26.7l-139 125.1c-5.9 5.3-13.5 8.2-21.4 8.2H384c-17.7 0-32-14.3-32-32V224zM80 96c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V384c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112C0 67.8 35.8 32 80 32h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H80z"
                }
            }
        ]
    })(props);
}
function FaShareNodes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                }
            }
        ]
    })(props);
}
function FaShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"
                }
            }
        ]
    })(props);
}
function FaSheetPlastic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 35.3 28.7 64 64 64H224V384c0-17.7 14.3-32 32-32H384V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V448zM171.3 75.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm96 32l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM384 384H256V512L384 384z"
                }
            }
        ]
    })(props);
}
function FaShekelSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H192c35.3 0 64 28.7 64 64V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160c0-70.7-57.3-128-128-128H32zM320 480c70.7 0 128-57.3 128-128V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 35.3-28.7 64-64 64H192V192c0-17.7-14.3-32-32-32s-32 14.3-32 32V448c0 17.7 14.3 32 32 32H320z"
                }
            }
        ]
    })(props);
}
function FaShieldCat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4h.2c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4h48c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3h.2c5.8 0 10.4 4.7 10.4 10.4V272c0 53-43 96-96 96s-96-43-96-96V154.4zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaShieldDog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8c35.3 0 64-28.7 64-64V160h44.2c12.1 0 23.2 6.8 28.6 17.7L320 192h64c8.8 0 16 7.2 16 16v32c0 44.2-35.8 80-80 80H272v50.7c0 7.3-5.9 13.3-13.3 13.3c-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4c0-2.8 .6-5.5 1.9-8l15-30zM160 160h40 8v32 32c0 17.7-14.3 32-32 32s-32-14.3-32-32V176c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaShieldHalved(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0zm0 66.8V444.8C394 378 431.1 230.1 432 141.4L256 66.8l0 0z"
                }
            }
        ]
    })(props);
}
function FaShieldHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM144 221.3c0-33.8 27.4-61.3 61.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9c33.8 0 61.3 27.4 61.3 61.3c0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
                }
            }
        ]
    })(props);
}
function FaShieldVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2c.5 99.2 41.3 280.7 213.6 363.2c16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM256 112c8.8 0 16 7.2 16 16c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C334.5 200.1 351 240 384 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C311.9 334.5 272 351 272 384c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C177.5 311.9 161 272 128 272c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C200.1 177.5 240 161 240 128c0-8.8 7.2-16 16-16zM232 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c4.6 0 9.2 1 13.4 2.9L457.7 82.8c22 9.3 38.4 31 38.3 57.2c-.5 99.2-41.3 280.7-213.6 363.2c-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.8 1 251.4 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaShip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 32c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V64h48c26.5 0 48 21.5 48 48V240l44.4 14.8c23.1 7.7 29.5 37.5 11.5 53.9l-101 92.6c-16.2 9.4-34.7 15.1-50.9 15.1c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-16.2 0-34.7-5.7-50.9-15.1l-101-92.6c-18-16.5-11.6-46.2 11.5-53.9L96 240V112c0-26.5 21.5-48 48-48h48V32zM160 218.7l107.8-35.9c13.1-4.4 27.3-4.4 40.5 0L416 218.7V128H160v90.7zM306.5 421.9C329 437.4 356.5 448 384 448c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 501.7 417 512 384 512c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 437.2 165.1 448 192 448c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaShirt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211.8 0c7.8 0 14.3 5.7 16.7 13.2C240.8 51.9 277.1 80 320 80s79.2-28.1 91.5-66.8C413.9 5.7 420.4 0 428.2 0h12.6c22.5 0 44.2 7.9 61.5 22.3L628.5 127.4c6.6 5.5 10.7 13.5 11.4 22.1s-2.1 17.1-7.8 23.6l-56 64c-11.4 13.1-31.2 14.6-44.6 3.5L480 197.7V448c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V197.7l-51.5 42.9c-13.3 11.1-33.1 9.6-44.6-3.5l-56-64c-5.7-6.5-8.5-15-7.8-23.6s4.8-16.6 11.4-22.1L137.7 22.3C155 7.9 176.7 0 199.2 0h12.6z"
                }
            }
        ]
    })(props);
}
function FaShoePrints(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0C352.3 0 256 32 256 32V160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0zM128 96c0 35.3 28.7 64 64 64h32V32H192c-35.3 0-64 28.7-64 64zM288 512c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32V480s96.3 32 160 32zM0 416c0 35.3 28.7 64 64 64H96V352H64c-35.3 0-64 28.7-64 64z"
                }
            }
        ]
    })(props);
}
function FaShopLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M36.8 192H449.6c20.2-19.8 47.9-32 78.4-32c30.5 0 58.1 12.2 78.3 31.9c18.9-1.6 33.7-17.4 33.7-36.7c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM384 224H320V384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 352 224zm144 16c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaShopSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-54.8-43V224H512V376L384 275.7V224H320v1.5L277.2 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L74.1 32.8 38.8 5.1zM36.8 192h85L21 112.5 6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM320 384H128V224H64V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V398.5l-64-50.4V384z"
                }
            }
        ]
    })(props);
}
function FaShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M36.8 192H603.2c20.3 0 36.8-16.5 36.8-36.8c0-7.3-2.2-14.4-6.2-20.4L558.2 21.4C549.3 8 534.4 0 518.3 0H121.7c-16 0-31 8-39.9 21.4L6.2 134.7c-4 6.1-6.2 13.2-6.2 20.4C0 175.5 16.5 192 36.8 192zM64 224V384v80c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V384 224H320V384H128V224H64zm448 0V480c0 17.7 14.3 32 32 32s32-14.3 32-32V224H512z"
                }
            }
        ]
    })(props);
}
function FaShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaShrimp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96s28.7 64 64 64h1c3.7 88.9 77 160 167 160h56V128H264 88.8 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H464c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zM224 456c0 13.3 10.7 24 24 24h72V407.8l-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3v69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111c0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6c0 4.6-.7 9-1.9 13.1L472.6 415zM336 128H320V320h18.3c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V160H352c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6zM164 282.7L204 336l-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c10.1 0 19.6-4.7 25.6-12.8L164 282.7zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6V416H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8h32V320c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
                }
            }
        ]
    })(props);
}
function FaShuttleSpace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M130 480c40.6 0 80.4-11 115.2-31.9L352 384l-224 0 0 96h2zM352 128L245.2 63.9C210.4 43 170.6 32 130 32h-2v96l224 0zM96 128l0-96H80C53.5 32 32 53.5 32 80v48h8c-22.1 0-40 17.9-40 40v16V328v16c0 22.1 17.9 40 40 40H32v48c0 26.5 21.5 48 48 48H96l0-96h8c26.2 0 49.4-12.6 64-32H456c69.3 0 135-22.7 179.2-81.6c6.4-8.5 6.4-20.3 0-28.8C591 182.7 525.3 160 456 160H168c-14.6-19.4-37.8-32-64-32l-8 0zM512 243.6v24.9c0 19.6-15.9 35.6-35.6 35.6c-2.5 0-4.4-2-4.4-4.4V212.4c0-2.5 2-4.4 4.4-4.4c19.6 0 35.6 15.9 35.6 35.6z"
                }
            }
        ]
    })(props);
}
function FaSignHanging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c17.7 0 32 14.3 32 32V64l352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128H32C14.3 128 0 113.7 0 96S14.3 64 32 64H64V32C64 14.3 78.3 0 96 0zm96 160H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 0c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM448 96c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM352 224V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32s32 14.3 32 32zM192 288c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32zM96 416v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-17.7 14.3-32 32-32s32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaSignature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32v7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92v71.9c0 40 32.5 72.5 72.5 72.5c26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3V128c0-53-43-96-96-96s-96 43-96 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3c-4.7 0-8.5-3.8-8.5-8.5V335.6c0-14.1 9.3-26.6 22.8-30.7zM24 368c-13.3 0-24 10.7-24 24s10.7 24 24 24H64.3c-.2-2.8-.3-5.6-.3-8.5V368H24zm592 48c13.3 0 24-10.7 24-24s-10.7-24-24-24H305.9c-6.7 16.3-14.2 32.3-22.3 48H616z"
                }
            }
        ]
    })(props);
}
function FaSignsPost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32H64C46.3 32 32 46.3 32 64v64c0 17.7 14.3 32 32 32H441.4c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7H288c0-17.7-14.3-32-32-32s-32 14.3-32 32zM480 256c0-17.7-14.3-32-32-32H288V192H224v32H70.6c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7H448c17.7 0 32-14.3 32-32V256zM288 480V384H224v96c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                }
            }
        ]
    })(props);
}
function FaSimCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0H242.7c17 0 33.3 6.7 45.3 18.7L365.3 96c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM96 192c-17.7 0-32 14.3-32 32v32h64V192H96zM64 352h80 96 80V288H240 144 64v64zM320 224c0-17.7-14.3-32-32-32H256v64h64V224zM160 192v64h64V192H160zM288 448c17.7 0 32-14.3 32-32V384H256v64h32zM160 384v64h64V384H160zM64 416c0 17.7 14.3 32 32 32h32V384H64v32z"
                }
            }
        ]
    })(props);
}
function FaSink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32s14.3 32 32 32s32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96V288H160V264c0-30.9-25.1-56-56-56H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c4.4 0 8 3.6 8 8v24H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H400V264c0-4.4 3.6-8 8-8h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H408c-30.9 0-56 25.1-56 56v24H288V96zM480 416V384H32v32c0 53 43 96 96 96H384c53 0 96-43 96-96z"
                }
            }
        ]
    })(props);
}
function FaSitemap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"
                }
            }
        ]
    })(props);
}
function FaSkullCrossbones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32H176c-17.7 0-32-14.3-32-32V234.4c-38.6-23-64-62.1-64-106.4C80 57.3 144.5 0 224 0s144 57.3 144 128zM168 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM3.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L224 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L295.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L224 419.8 46.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L152.4 384 17.7 316.6C1.9 308.7-4.5 289.5 3.4 273.7z"
                }
            }
        ]
    })(props);
}
function FaSkull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 398.9c58.5-41.1 96-104.1 96-174.9C512 100.3 397.4 0 256 0S0 100.3 0 224c0 70.7 37.5 133.8 96 174.9c0 .4 0 .7 0 1.1v64c0 26.5 21.5 48 48 48h48V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V464c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c26.5 0 48-21.5 48-48V400c0-.4 0-.7 0-1.1zM96 256a64 64 0 1 1 128 0A64 64 0 1 1 96 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"
                }
            }
        ]
    })(props);
}
function FaSleigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V256c0 53 43 96 96 96v32h64V352H384v32h64V352c53 0 96-43 96-96V160c17.7 0 32-14.3 32-32s-14.3-32-32-32H512 480c-17.7 0-32 14.3-32 32v41.3c0 30.2-24.5 54.7-54.7 54.7c-75.5 0-145.6-38.9-185.6-102.9l-4.3-6.9C174.2 67.6 125 37.6 70.7 32.7c-2.2-.5-4.4-.7-6.7-.7H55 32zM640 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v8c0 13.3-10.7 24-24 24H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H552c48.6 0 88-39.4 88-88v-8z"
                }
            }
        ]
    })(props);
}
function FaSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
                }
            }
        ]
    })(props);
}
function FaSmog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 144c0 79.5 64.5 144 144 144H299.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112s-50.1-112-112-112c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.6 0-62.4 12.2-85.1 32.3C242.1 12.1 210.5 0 176 0C96.5 0 32 64.5 32 144zM616 368H280c-13.3 0-24 10.7-24 24s10.7 24 24 24H616c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-64 96H440c-13.3 0-24 10.7-24 24s10.7 24 24 24H552c13.3 0 24-10.7 24-24s-10.7-24-24-24zm-192 0H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24zM224 392c0-13.3-10.7-24-24-24H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H200c13.3 0 24-10.7 24-24z"
                }
            }
        ]
    })(props);
}
function FaSmoking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32V43c0 38.2 15.2 74.8 42.2 101.8l21 21c21 21 32.8 49.5 32.8 79.2v11c0 17.7-14.3 32-32 32s-32-14.3-32-32V245c0-12.7-5.1-24.9-14.1-33.9l-21-21C405.9 151.1 384 98.1 384 43V32c0-17.7 14.3-32 32-32s32 14.3 32 32zM576 256V245c0-38.2-15.2-74.8-42.2-101.8l-21-21c-21-21-32.8-49.5-32.8-79.2V32c0-17.7 14.3-32 32-32s32 14.3 32 32V43c0 12.7 5.1 24.9 14.1 33.9l21 21c39 39 60.9 91.9 60.9 147.1v11c0 17.7-14.3 32-32 32s-32-14.3-32-32zM0 416c0-35.3 28.7-64 64-64H416c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V416zm224 0v32H384V416H224zm288-64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSnowflake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c17.7 0 32 14.3 32 32V62.1l15-15c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-49 49v70.3l61.4-35.8 17.7-66.1c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4l-5.2 19.3 23.6-13.8c15.3-8.9 34.9-3.7 43.8 11.5s3.8 34.9-11.5 43.8l-25.3 14.8 21.7 5.8c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-67.7-18.1L287.5 256l60.9 35.5 67.7-18.1c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4l-21.7 5.8 25.3 14.8c15.3 8.9 20.4 28.5 11.5 43.8s-28.5 20.4-43.8 11.5l-23.6-13.8 5.2 19.3c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-17.7-66.1L256 311.7v70.3l49 49c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V449.9l-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l49-49V311.7l-61.4 35.8-17.7 66.1c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4l5.2-19.3L48.1 395.6c-15.3 8.9-34.9 3.7-43.8-11.5s-3.7-34.9 11.5-43.8l25.3-14.8-21.7-5.8c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l67.7 18.1L160.5 256 99.6 220.5 31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4l21.7-5.8L15.9 171.6C.6 162.7-4.5 143.1 4.4 127.9s28.5-20.4 43.8-11.5l23.6 13.8-5.2-19.3c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l17.7 66.1L192 200.3V129.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l15 15V32c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSnowman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.1 140.6c-2 3.9-1.6 8.6 1.2 12c7 8.5 12.9 18.1 17.2 28.4L408 160.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24v19.6l22.5-9.7c12.2-5.2 26.3 .4 31.5 12.6s-.4 26.3-12.6 31.5l-56 24-73.6 31.5c-.5 9.5-2.1 18.6-4.8 27.3c-1.2 3.8-.1 8 2.8 10.8C396.7 296.9 416 338.2 416 384c0 44.7-18.3 85-47.8 114.1c-9.9 9.7-23.7 13.9-37.5 13.9H181.3c-13.9 0-27.7-4.2-37.5-13.9C114.3 469 96 428.7 96 384c0-45.8 19.3-87.1 50.1-116.3c2.9-2.8 4-6.9 2.8-10.8c-2.7-8.7-4.3-17.9-4.8-27.3L70.5 198.1l-56-24C2.4 168.8-3.3 154.7 1.9 142.5s19.3-17.8 31.5-12.6L56 139.6V120c0-13.3 10.7-24 24-24s24 10.7 24 24v40.2L152.6 181c4.3-10.3 10.1-19.9 17.2-28.4c2.8-3.4 3.3-8.1 1.2-12C164 127.2 160 112.1 160 96c0-53 43-96 96-96s96 43 96 96c0 16.1-4 31.2-10.9 44.6zM224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48 128a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM288 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 24v3.2c0 3.2 .8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V120c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaSnowplow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.9 64l68.6 160H256l-64-64V64H298.9zM445.1 242.7l-87.4-204C347.6 15.3 324.5 0 298.9 0H176c-26.5 0-48 21.5-48 48V160H96c-17.7 0-32 14.3-32 32V298.8C26.2 316.8 0 355.3 0 400c0 61.9 50.1 112 112 112H368c61.9 0 112-50.1 112-112c0-17.2-3.9-33.5-10.8-48H512v50.7c0 17 6.7 33.3 18.7 45.3l54.6 54.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L576 402.7V320 235.2L633 164c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-57 71.2c-9.1 11.3-14 25.4-14 40V288H448V256.7c.1-2.4-.2-4.8-.6-7.1s-1.2-4.7-2.2-6.8zM368 352c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48H368zM144 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM200 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM416 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 160c0 27.6-11.7 52.5-30.4 70.1C422.1 275.7 448 310.8 448 352c0 53-43 96-96 96H160c-53 0-96-43-96-96s43-96 96-96h88.4c-15.2-17-24.4-39.4-24.4-64H96c-53 0-96 43-96 96V416c0 53 43 96 96 96H416c53 0 96-43 96-96V288c0-53-43-96-96-96zM160 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H352c35.3 0 64-28.7 64-64s-28.7-64-64-64H320 160z"
                }
            }
        ]
    })(props);
}
function FaSocks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M175.2 476.6c-9.7-18-15.2-38.7-15.2-60.6c0-40.3 19-78.2 51.2-102.4l64-48c8.1-6 12.8-15.5 12.8-25.6V96H128V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l21.6-16.2zM128 64H288V48c0-14.5 3.9-28.2 10.7-39.9C291 3 281.9 0 272 0H176c-26.5 0-48 21.5-48 48V64zM320 96V240c0 20.1-9.5 39.1-25.6 51.2l-64 48C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96c20.8 0 41-6.7 57.6-19.2l115.2-86.4C493 382.2 512 344.3 512 304V96H320zM512 64V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48V64H512z"
                }
            }
        ]
    })(props);
}
function FaSolarPanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M122.2 0C91.7 0 65.5 21.5 59.5 51.4L8.3 307.4C.4 347 30.6 384 71 384H288v64H224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H352V384H569c40.4 0 70.7-36.9 62.8-76.6l-51.2-256C574.5 21.5 548.3 0 517.8 0H122.2zM260.9 64H379.1l10.4 104h-139L260.9 64zM202.3 168H101.4L122.2 64h90.4L202.3 168zM91.8 216H197.5L187.1 320H71L91.8 216zm153.9 0H394.3l10.4 104-169.4 0 10.4-104zm196.8 0H548.2L569 320h-116L442.5 216zm96-48H437.7L427.3 64h90.4l31.4-6.3L517.8 64l20.8 104z"
                }
            }
        ]
    })(props);
}
function FaSortDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"
                }
            }
        ]
    })(props);
}
function FaSortUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
                }
            }
        ]
    })(props);
}
function FaSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"
                }
            }
        ]
    })(props);
}
function FaSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"
                }
            }
        ]
    })(props);
}
function FaSpaghettiMonsterFlying(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3C390 95.1 384 80.2 384 64c0-35.3 28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4c7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4C527.3 262.3 532.7 264 536 264c2.5 0 4.3-.6 7.1-3.3c3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7c9.7-9.3 22.9-16.7 40.4-16.7c13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3c-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7c-9.7 9.3-22.9 16.7-40.4 16.7c-18.5 0-32.9-8.5-44.3-18.6c-3.1 4-6.6 8.3-10.5 12.7c1.4 4.3 2.8 8.5 4 12.5c.9 3 1.8 5.8 2.6 8.6c3 9.8 5.5 18.2 8.6 25.9c3.9 9.8 7.4 15.4 10.8 18.5c2.6 2.4 5.9 4.3 12.8 4.3c8.7 0 16.9-4.2 33.7-13.2c15-8 35.7-18.8 62.3-18.8c13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2c-1 .6-2.1 1.1-3.2 1.7C559.9 414 541.4 424 520 424c-18.4 0-33.6-6.1-45.5-17.2c-11.1-10.3-17.9-23.7-22.7-36c-3.6-9-6.7-19.1-9.5-28.5c-16.4 12.3-36.1 23.6-58.9 31.3c3.6 10.8 8.4 23.5 14.4 36.2c7.5 15.9 16.2 30.4 25.8 40.5C433 460.5 441.2 464 448 464c13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8c-14.5-15.4-25.7-34.9-34.2-53c-8-17-14.1-33.8-18.3-46.9c-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9c-8.5 18.1-19.8 37.6-34.2 53C237 498.5 217.2 512 192 512c-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7c9.5-10.1 18.3-24.6 25.8-40.5c5.9-12.6 10.7-25.4 14.4-36.2c-22.8-7.7-42.5-19-58.9-31.3c-2.9 9.4-6 19.5-9.5 28.5c-4.8 12.2-11.6 25.6-22.7 36C153.6 417.9 138.4 424 120 424c-21.4 0-39.9-10-53.1-17.1l0 0c-1.1-.6-2.2-1.2-3.2-1.7c-15-8-26.3-13.2-39.7-13.2c-13.3 0-24-10.7-24-24s10.7-24 24-24c26.6 0 47.3 10.8 62.3 18.8c16.8 9 25 13.2 33.7 13.2c6.8 0 10.2-1.9 12.8-4.3c3.4-3.2 7-8.8 10.8-18.5c3-7.7 5.6-16.1 8.6-25.9c.8-2.7 1.7-5.6 2.6-8.6c1.2-4 2.6-8.2 4-12.5c-3.9-4.5-7.4-8.8-10.5-12.7C136.9 303.5 122.5 312 104 312c-17.5 0-30.7-7.4-40.4-16.7c-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4c-2.8-2.7-4.6-3.3-7.1-3.3c-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7c8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4c2.8 2.7 4.6 3.3 7.1 3.3c3.3 0 8.7-1.7 19.4-13.4c5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24c13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaSpellCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0C99.1 0 87.4 7.8 82.5 19.7l-66.7 160-13.3 32c-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2L66.7 224h90.7l5.1 12.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8l-13.3-32-66.7-160C136.6 7.8 124.9 0 112 0zm18.7 160H93.3L112 115.2 130.7 160zM256 32v96 96c0 17.7 14.3 32 32 32h80c44.2 0 80-35.8 80-80c0-23.1-9.8-43.8-25.4-58.4c6-11.2 9.4-24 9.4-37.6c0-44.2-35.8-80-80-80H288c-17.7 0-32 14.3-32 32zm96 64H320V64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-32 64h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H320V160zM566.6 310.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L352 434.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l192-192z"
                }
            }
        ]
    })(props);
}
function FaSpider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 32.6c4.8-12.4-1.4-26.3-13.8-31s-26.3 1.4-31 13.8L81.1 100c-7.9 20.7-3 44.1 12.7 59.7l57.4 57.4L70.8 190.3c-2.4-.8-4.3-2.7-5.1-5.1L46.8 128.4C42.6 115.8 29 109 16.4 113.2S-3 131 1.2 143.6l18.9 56.8c5.6 16.7 18.7 29.8 35.4 35.4L116.1 256 55.6 276.2c-16.7 5.6-29.8 18.7-35.4 35.4L1.2 368.4C-3 381 3.8 394.6 16.4 398.8s26.2-2.6 30.4-15.2l18.9-56.8c.8-2.4 2.7-4.3 5.1-5.1l80.4-26.8L93.7 352.3C78.1 368 73.1 391.4 81.1 412l32.5 84.6c4.8 12.4 18.6 18.5 31 13.8s18.5-18.6 13.8-31l-32.5-84.6c-1.1-3-.4-6.3 1.8-8.5L160 353.9c1 52.1 43.6 94.1 96 94.1s95-41.9 96-94.1l32.3 32.3c2.2 2.2 2.9 5.6 1.8 8.5l-32.5 84.6c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8L430.9 412c7.9-20.7 3-44.1-12.7-59.7l-57.4-57.4 80.4 26.8c2.4 .8 4.3 2.7 5.1 5.1l18.9 56.8c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-18.9-56.8c-5.6-16.7-18.7-29.8-35.4-35.4L395.9 256l60.5-20.2c16.7-5.6 29.8-18.7 35.4-35.4l18.9-56.8c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-18.9 56.8c-.8 2.4-2.7 4.3-5.1 5.1l-80.4 26.8 57.4-57.4c15.6-15.6 20.6-39 12.7-59.7L398.4 15.4C393.6 3 379.8-3.2 367.4 1.6s-18.5 18.6-13.8 31l32.5 84.6c1.1 3 .4 6.3-1.8 8.5L336 174.1V160c0-31.8-18.6-59.3-45.5-72.2c-9.1-4.4-18.5 3.3-18.5 13.4V112c0 8.8-7.2 16-16 16s-16-7.2-16-16V101.2c0-10.1-9.4-17.7-18.5-13.4C194.6 100.7 176 128.2 176 160v14.1l-48.3-48.3c-2.2-2.2-2.9-5.6-1.8-8.5l32.5-84.6z"
                }
            }
        ]
    })(props);
}
function FaSpinner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                }
            }
        ]
    })(props);
}
function FaSplotch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0c28.5 0 53.6 18.7 61.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2c0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6c-14.8 0-29.3-5.1-40.8-14.3l-55.4-44.3c-4.5-3.6-9.3-6.7-14.5-9.2c-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9C47.8 458.2 16 431.6 16 396.5c0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1c0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9c0-33.4 30.1-58.8 63-53.2l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
                }
            }
        ]
    })(props);
}
function FaSpoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8C224 80 320 0 416 0c53 0 96 43 96 96c0 96-80 192-160.2 192c-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
                }
            }
        ]
    })(props);
}
function FaSprayCanSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32v96H224V32c0-17.7-14.3-32-32-32H128C110.3 0 96 14.3 96 32zm0 128c-53 0-96 43-96 96V464c0 26.5 21.5 48 48 48H272c26.5 0 48-21.5 48-48V256c0-53-43-96-96-96H96zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM384 48c0-1.4-1-3-2.2-3.6L352 32 339.6 2.2C339 1 337.4 0 336 0s-3 1-3.6 2.2L320 32 290.2 44.4C289 45 288 46.6 288 48c0 1.4 1 3 2.2 3.6L320 64l12.4 29.8C333 95 334.6 96 336 96s3-1 3.6-2.2L352 64l29.8-12.4C383 51 384 49.4 384 48zm76.4 45.8C461 95 462.6 96 464 96s3-1 3.6-2.2L480 64l29.8-12.4C511 51 512 49.4 512 48c0-1.4-1-3-2.2-3.6L480 32 467.6 2.2C467 1 465.4 0 464 0s-3 1-3.6 2.2L448 32 418.2 44.4C417 45 416 46.6 416 48c0 1.4 1 3 2.2 3.6L448 64l12.4 29.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L448 224l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L448 256l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 256l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6c0-1.4-1-3-2.2-3.6L480 224l-12.4-29.8zM448 144c0-1.4-1-3-2.2-3.6L416 128 403.6 98.2C403 97 401.4 96 400 96s-3 1-3.6 2.2L384 128l-29.8 12.4c-1.2 .6-2.2 2.2-2.2 3.6c0 1.4 1 3 2.2 3.6L384 160l12.4 29.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L416 160l29.8-12.4c1.2-.6 2.2-2.2 2.2-3.6z"
                }
            }
        ]
    })(props);
}
function FaSprayCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0h64c17.7 0 32 14.3 32 32v96H96V32c0-17.7 14.3-32 32-32zM0 256c0-53 43-96 96-96H224c53 0 96 43 96 96V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V256zm240 80A80 80 0 1 0 80 336a80 80 0 1 0 160 0zM256 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM448 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM384 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaSquareArrowUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM160 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h94.1L119 327c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135V328c0 13.3 10.7 24 24 24s24-10.7 24-24V168c0-13.3-10.7-24-24-24H160z"
                }
            }
        ]
    })(props);
}
function FaSquareCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
                }
            }
        ]
    })(props);
}
function FaSquareCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
                }
            }
        ]
    })(props);
}
function FaSquareCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
                }
            }
        ]
    })(props);
}
function FaSquareCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H120c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
                }
            }
        ]
    })(props);
}
function FaSquareCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaSquareEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM218 271.7L64.2 172.4C66 156.4 79.5 144 96 144H352c16.5 0 30 12.4 31.8 28.4L230 271.7c-1.8 1.2-3.9 1.8-6 1.8s-4.2-.6-6-1.8zm29.4 26.9L384 210.4V336c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V210.4l136.6 88.2c7 4.5 15.1 6.9 23.4 6.9s16.4-2.4 23.4-6.9z"
                }
            }
        ]
    })(props);
}
function FaSquareFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 0H512V512H0V0z"
                }
            }
        ]
    })(props);
}
function FaSquareH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM336 152V256 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H160l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24s24 10.7 24 24v80H288V152c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaSquareMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 200H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaSquareNfi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm75.7 64.6C68.8 162.5 64 168.8 64 176V336c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16V278.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v64 96c0 8.8 7.2 16 16 16s16-7.2 16-16V256h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16V336c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
                }
            }
        ]
    })(props);
}
function FaSquareParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM192 256h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H192v64zm48 64H192v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function FaSquarePen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-21.4 21.4-71-71 21.4-21.4c15.6-15.6 40.9-15.6 56.6 0zM119.9 289L225.1 183.8l71 71L190.9 359.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
                }
            }
        ]
    })(props);
}
function FaSquarePersonConfined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56V350.1c0 36.4-29.5 65.9-65.9 65.9c-17.5 0-34.3-6.9-46.6-19.3L184.8 342l-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9L240 306.7V248z"
                }
            }
        ]
    })(props);
}
function FaSquarePhoneFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zm-90.7 96.7c-9.7-2.6-19.9 2.3-23.7 11.6l-20 48c-3.4 8.2-1 17.6 5.8 23.2L280 231.7c-16.6 35.2-45.1 63.7-80.3 80.3l-20.2-24.7c-5.6-6.8-15-9.2-23.2-5.8l-48 20c-9.3 3.9-14.2 14-11.6 23.7l12 44C111.1 378 119 384 128 384c123.7 0 224-100.3 224-224c0-9-6-16.9-14.7-19.3l-44-12z"
                }
            }
        ]
    })(props);
}
function FaSquarePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm90.7 96.7c9.7-2.6 19.9 2.3 23.7 11.6l20 48c3.4 8.2 1 17.6-5.8 23.2L168 231.7c16.6 35.2 45.1 63.7 80.3 80.3l20.2-24.7c5.6-6.8 15-9.2 23.2-5.8l48 20c9.3 3.9 14.2 14 11.6 23.7l-12 44C336.9 378 329 384 320 384C196.3 384 96 283.7 96 160c0-9 6-16.9 14.7-19.3l44-12z"
                }
            }
        ]
    })(props);
}
function FaSquarePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                }
            }
        ]
    })(props);
}
function FaSquarePollHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 160c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32zm64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0zM192 352c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32z"
                }
            }
        ]
    })(props);
}
function FaSquarePollVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm64 192c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm64-64c0-17.7 14.3-32 32-32s32 14.3 32 32V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V160zM320 288c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSquareRootVariable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M282.6 78.1c8-27.3 33-46.1 61.4-46.1H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H344L238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H77.6c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8L282.6 78.1zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0L480 274.7l41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 320l41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 365.3l-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 320l-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
                }
            }
        ]
    })(props);
}
function FaSquareRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 136c0-13.3 10.7-24 24-24c137 0 248 111 248 248c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24c83.9 0 152 68.1 152 152c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104c-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaSquareShareNodes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM384 160c0 35.3-28.7 64-64 64c-15.4 0-29.5-5.4-40.6-14.5L194.1 256l85.3 46.5c11-9.1 25.2-14.5 40.6-14.5c35.3 0 64 28.7 64 64s-28.7 64-64 64s-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L174.5 300c-11.7 12.3-28.2 20-46.5 20c-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3c0-35.3 28.7-64 64-64s64 28.7 64 64z"
                }
            }
        ]
    })(props);
}
function FaSquareUpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM320 313.4V176c0-8.8-7.2-16-16-16H166.6c-12.5 0-22.6 10.1-22.6 22.6c0 6 2.4 11.8 6.6 16L184 232l-66.3 66.3C114 302 112 306.9 112 312s2 10 5.7 13.7l36.7 36.7c3.6 3.6 8.5 5.7 13.7 5.7s10-2 13.7-5.7L248 296l33.4 33.4c4.2 4.2 10 6.6 16 6.6c12.5 0 22.6-10.1 22.6-22.6z"
                }
            }
        ]
    })(props);
}
function FaSquareVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM223.8 93.7c13.3 0 24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1c13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1c-13.3 0-24-10.7-24-24s10.7-24 24-24c29.3 0 43.9-35.4 23.2-56.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2c0-13.3 10.7-24 24-24zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm88 32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                }
            }
        ]
    })(props);
}
function FaSquareXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm79 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
                }
            }
        ]
    })(props);
}
function FaStaffSnake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M222.6 43.2l-.1 4.8H288c53 0 96 43 96 96s-43 96-96 96H248V160h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H248 220l-4.5 144H256c53 0 96 43 96 96s-43 96-96 96H240V384h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H213l-3.1 99.5L208.5 495l0 1c-.3 8.9-7.6 16-16.5 16s-16.2-7.1-16.5-16l0-1-1-31H136c-22.1 0-40-17.9-40-40s17.9-40 40-40h36l-1-32H152c-53 0-96-43-96-96c0-47.6 34.6-87.1 80-94.7V256c0 8.8 7.2 16 16 16h16.5L164 128H136 122.6c-9 18.9-28.3 32-50.6 32H56c-30.9 0-56-25.1-56-56S25.1 48 56 48h8 8 89.5l-.1-4.8L161 32c0-.7 0-1.3 0-1.9c.5-16.6 14.1-30 31-30s30.5 13.4 31 30c0 .6 0 1.3 0 1.9l-.4 11.2zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaStairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448v96c0 17.7-14.3 32-32 32H320v96c0 17.7-14.3 32-32 32H192v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V320c0-17.7 14.3-32 32-32h96V192c0-17.7 14.3-32 32-32h96V64z"
                }
            }
        ]
    })(props);
}
function FaStamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 201.8c0-17.4 9.2-33.2 19.9-47C344.5 138.5 352 118.1 352 96c0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8c10.7 13.8 19.9 29.6 19.9 47c0 29.9-24.3 54.2-54.2 54.2H112C50.1 256 0 306.1 0 368c0 20.9 13.4 38.7 32 45.3V464c0 26.5 21.5 48 48 48H432c26.5 0 48-21.5 48-48V413.3c18.6-6.6 32-24.4 32-45.3c0-61.9-50.1-112-112-112H366.2c-29.9 0-54.2-24.3-54.2-54.2zM416 416v32H96V416H416z"
                }
            }
        ]
    })(props);
}
function FaStapler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 299.3V304 432c0 26.5-21.5 48-48 48H512 448 64c-17.7 0-32-14.3-32-32s14.3-32 32-32H448V368H96c-17.7 0-32-14.3-32-32V219.4L33.8 214C14.2 210.5 0 193.5 0 173.7c0-8.9 2.9-17.5 8.2-24.6l35.6-47.5C76.7 57.8 128.2 32 182.9 32c27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304V288L128 230.9V304H448z"
                }
            }
        ]
    })(props);
}
function FaStarAndCrescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256C0 114.6 114.6 0 256 0c33 0 64.6 6.3 93.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5c-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5c7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512C114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
                }
            }
        ]
    })(props);
}
function FaStarHalfStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"
                }
            }
        ]
    })(props);
}
function FaStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8V0zM429.9 512c1.1 .1 2.1 .1 3.2 0h-3.2z"
                }
            }
        ]
    })(props);
}
function FaStarOfDavid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M404.2 309.5L383.1 344h42.3l-21.1-34.5zM371.4 256l-54-88H194.6l-54 88 54 88H317.4l54-88zm65.7 0l53.4 87c3.6 5.9 5.5 12.7 5.5 19.6c0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5C284.8 504.3 270.9 512 256 512s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87L21.5 169c-3.6-5.9-5.5-12.7-5.5-19.6C16 128.8 32.8 112 53.4 112H163.3l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5L348.7 112H458.6c20.7 0 37.4 16.8 37.4 37.4c0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-54-88l21.1 34.5L425.4 168H383.1zM283 112L256 68l-27 44h54zM128.9 168H86.6l21.1 34.5L128.9 168zM107.8 309.5L86.6 344h42.3l-21.1-34.5zM229 400l27 44 27-44H229z"
                }
            }
        ]
    })(props);
}
function FaStarOfLife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32V172.9l122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7L352 256l122 70.4c15.3 8.8 20.5 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7L304 339.1V480c0 17.7-14.3 32-32 32H240c-17.7 0-32-14.3-32-32V339.1L86 409.6c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7L160 256 38 185.6c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7C51.1 98.8 70.7 93.6 86 102.4l122 70.4V32z"
                }
            }
        ]
    })(props);
}
function FaStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
                }
            }
        ]
    })(props);
}
function FaSterlingSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 160.4c0-35.5 28.8-64.4 64.4-64.4c6.9 0 13.8 1.1 20.4 3.3l81.2 27.1c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L217 38.6c-13.1-4.4-26.8-6.6-40.6-6.6C105.5 32 48 89.5 48 160.4V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H48v44.5c0 17.4-4.7 34.5-13.7 49.4L4.6 431.5c-5.9 9.9-6.1 22.2-.4 32.2S20.5 480 32 480H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H88.5l.7-1.1C104.1 390 112 361.5 112 332.5V288H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H112V160.4z"
                }
            }
        ]
    })(props);
}
function FaStethoscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M142.4 21.9c5.6 16.8-3.5 34.9-20.2 40.5L96 71.1V192c0 53 43 96 96 96s96-43 96-96V71.1l-26.1-8.7c-16.8-5.6-25.8-23.7-20.2-40.5s23.7-25.8 40.5-20.2l26.1 8.7C334.4 19.1 352 43.5 352 71.1V192c0 77.2-54.6 141.6-127.3 156.7C231 404.6 278.4 448 336 448c61.9 0 112-50.1 112-112V265.3c-28.3-12.3-48-40.5-48-73.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3V336c0 97.2-78.8 176-176 176c-92.9 0-168.9-71.9-175.5-163.1C87.2 334.2 32 269.6 32 192V71.1c0-27.5 17.6-52 43.8-60.7l26.1-8.7c16.8-5.6 34.9 3.5 40.5 20.2zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
                }
            }
        ]
    })(props);
}
function FaStopwatch20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H176zM288 204c28.7 0 52 23.3 52 52v96c0 28.7-23.3 52-52 52s-52-23.3-52-52V256c0-28.7 23.3-52 52-52zm-12 52v96c0 6.6 5.4 12 12 12s12-5.4 12-12V256c0-6.6-5.4-12-12-12s-12 5.4-12 12zM159.5 244c-5.4 0-10.2 3.5-11.9 8.6l-.6 1.7c-3.5 10.5-14.8 16.1-25.3 12.6s-16.1-14.8-12.6-25.3l.6-1.7c7.2-21.5 27.2-35.9 49.8-35.9c29 0 52.5 23.5 52.5 52.5v2.2c0 13.4-4.9 26.4-13.8 36.4l-39 43.9c-6.2 7-10 15.7-10.9 24.9H192c11 0 20 9 20 20s-9 20-20 20H128c-11 0-20-9-20-20V368.3c0-20.6 7.5-40.4 21.2-55.8l39-43.9c2.4-2.7 3.7-6.2 3.7-9.8v-2.2c0-6.9-5.6-12.5-12.5-12.5z"
                }
            }
        ]
    })(props);
}
function FaStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V98.4C92.3 113.8 16 200 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-41.8-12.3-80.7-33.5-113.2l24.1-24.1c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L355.7 143c-28.1-23-62.2-38.8-99.7-44.6V64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H224 176zm72 192V320c0 13.3-10.7 24-24 24s-24-10.7-24-24V192c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaStoreSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.8-68V384 252.6c-4 1-8 1.8-12.3 2.3l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V350.9L301.2 210.7c7-4.4 13.3-9.7 18.8-15.7c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4L522.3 13.1C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-22.7 36L38.8 5.1zm73.4 218.1c4 .5 8.1 .8 12.1 .8c11 0 21.4-2 31-5.6L48.9 134.5c-6.1 40.6 19.5 82.8 63.3 88.7zM160 384V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H480c12.9 0 24.8-3.8 34.9-10.3L365.5 384H160z"
                }
            }
        ]
    })(props);
}
function FaStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
                }
            }
        ]
    })(props);
}
function FaStreetView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64A64 64 0 1 0 192 64a64 64 0 1 0 128 0zm-96 96c-35.3 0-64 28.7-64 64v48c0 17.7 14.3 32 32 32h1.8l11.1 99.5c1.8 16.2 15.5 28.5 31.8 28.5h38.7c16.3 0 30-12.3 31.8-28.5L318.2 304H320c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H224zM132.3 394.2c13-2.4 21.7-14.9 19.3-27.9s-14.9-21.7-27.9-19.3c-32.4 5.9-60.9 14.2-82 24.8c-10.5 5.3-20.3 11.7-27.8 19.6C6.4 399.5 0 410.5 0 424c0 21.4 15.5 36.1 29.1 45c14.7 9.6 34.3 17.3 56.4 23.4C130.2 504.7 190.4 512 256 512s125.8-7.3 170.4-19.6c22.1-6.1 41.8-13.8 56.4-23.4c13.7-8.9 29.1-23.6 29.1-45c0-13.5-6.4-24.5-14-32.6c-7.5-7.9-17.3-14.3-27.8-19.6c-21-10.6-49.5-18.9-82-24.8c-13-2.4-25.5 6.3-27.9 19.3s6.3 25.5 19.3 27.9c30.2 5.5 53.7 12.8 69 20.5c3.2 1.6 5.8 3.1 7.9 4.5c3.6 2.4 3.6 7.2 0 9.6c-8.8 5.7-23.1 11.8-43 17.3C374.3 457 318.5 464 256 464s-118.3-7-157.7-17.9c-19.9-5.5-34.2-11.6-43-17.3c-3.6-2.4-3.6-7.2 0-9.6c2.1-1.4 4.8-2.9 7.9-4.5c15.3-7.7 38.8-14.9 69-20.5z"
                }
            }
        ]
    })(props);
}
function FaStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
                }
            }
        ]
    })(props);
}
function FaStroopwafel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3L86.3 199.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 414.4l33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L414.4 256l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3L233.4 256l-45.3 45.3L142.9 256zm67.9 67.9L256 278.6l45.3 45.3L256 369.1l-45.3-45.3zM278.6 256l45.3-45.3L369.1 256l-45.3 45.3L278.6 256zm22.6-67.9L256 233.4l-45.3-45.3L256 142.9l45.3 45.3z"
                }
            }
        ]
    })(props);
}
function FaSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32zM480 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 361.5 404.3 368 416 368v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V320z"
                }
            }
        ]
    })(props);
}
function FaSuitcaseMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 48H328c4.4 0 8 3.6 8 8V96H176V56c0-4.4 3.6-8 8-8zm-56 8V96v32V480H384V128 96 56c0-30.9-25.1-56-56-56H184c-30.9 0-56 25.1-56 56zM96 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H96V96zM416 480h32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H416V480zM224 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H288v48c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V320H176c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h48V208z"
                }
            }
        ]
    })(props);
}
function FaSuitcaseRolling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 56c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v72H144V56zm176 72H288V56c0-30.9-25.1-56-56-56H152C121.1 0 96 25.1 96 56v72H64c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64c0 17.7 14.3 32 32 32s32-14.3 32-32H256c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64zM112 224H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaSuitcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96v32V480H128V128 96zM64 96H96V480H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zM448 480H416V96h32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaSunPlantWilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c-6.3 0-12 3.7-14.6 9.5L120.6 64.9 63.9 43.2c-5.9-2.3-12.6-.8-17 3.6s-5.9 11.1-3.6 17l21.7 56.7L9.5 145.4C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8L43.2 256.1c-2.3 5.9-.8 12.6 3.6 17s11.1 5.9 17 3.6l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.7 21.7c5.9 2.3 12.6 .8 17-3.6s5.9-11.1 3.6-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7c2.3-5.9 .8-12.6-3.6-17s-11.1-5.9-17-3.6L199.4 64.9 174.6 9.5C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm312 16c0-17.7 14.3-32 32-32s32 14.3 32 32v53.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C624 318 640 290.7 640 274c0-21.5-9.2-37-24-44.6V176c0-44.2-35.8-80-80-80s-80 35.8-80 80v22.7c-9.8-4.3-20.6-6.7-32-6.7c-44.2 0-80 35.8-80 80v21.4c-14.8 7.7-24 23.1-24 44.6c0 16.8 16 44 37.4 67.2c5.8 6.2 15.5 6.2 21.2 0C400 382 416 354.7 416 338c0-21.5-9.2-37-24-44.6V272c0-17.7 14.3-32 32-32s32 14.3 32 32v8V448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H504V280v-8V176z"
                }
            }
        ]
    })(props);
}
function FaSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9C393 73.5 404.3 80 416 80v80c-17.7 0-32 14.3-32 32s14.3 32 32 32h32 32c17.7 0 32-14.3 32-32s-14.3-32-32-32V32zM32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H47.3l89.6 128L47.3 384H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c10.4 0 20.2-5.1 26.2-13.6L176 311.8l85.8 122.6c6 8.6 15.8 13.6 26.2 13.6h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H304.7L215.1 256l89.6-128H320c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-10.4 0-20.2 5.1-26.2 13.6L176 200.2 90.2 77.6C84.2 69.1 74.4 64 64 64H32z"
                }
            }
        ]
    })(props);
}
function FaSwatchbook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32C0 14.3 14.3 0 32 0H160c17.7 0 32 14.3 32 32V416c0 53-43 96-96 96s-96-43-96-96V32zM223.6 425.9c.3-3.3 .4-6.6 .4-9.9V154l75.4-75.4c12.5-12.5 32.8-12.5 45.3 0l90.5 90.5c12.5 12.5 12.5 32.8 0 45.3L223.6 425.9zM182.8 512l192-192H480c17.7 0 32 14.3 32 32V480c0 17.7-14.3 32-32 32H182.8zM128 64H64v64h64V64zM64 192v64h64V192H64zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaSynagogue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8C469.5 119.7 480 142.2 480 166V280.1 512H464 352V416c0-17.7-14.3-32-32-32s-32 14.3-32 32v96H176 160V280.1 166c0-23.7 10.5-46.3 28.8-61.5L309.8 3.7zM512 512V244.5l28.1-31.2c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3l63.8 70.9c7.9 8.8 12.3 20.3 12.3 32.1V448c0 35.3-28.7 64-64 64H512zM128 244.5V512H64c-35.3 0-64-28.7-64-64V316.3c0-11.9 4.4-23.3 12.3-32.1l63.8-70.9c3-3.4 7.4-5.3 11.9-5.3s8.9 1.9 11.9 5.3L128 244.5zM327 124.3c-3.1-5.4-10.9-5.4-13.9 0l-15.9 28.1-32.3-.3c-6.2-.1-10.1 6.7-7 12.1L274.3 192l-16.4 27.8c-3.2 5.4 .7 12.1 7 12.1l32.3-.3L313 259.7c3.1 5.4 10.9 5.4 13.9 0l15.9-28.1 32.3 .3c6.2 .1 10.1-6.7 7-12.1L365.7 192l16.4-27.8c3.2-5.4-.7-12.1-7-12.1l-32.3 .3L327 124.3z"
                }
            }
        ]
    })(props);
}
function FaSyringe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441 7l32 32 32 32c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-15-15L417.9 128l55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72L295 73c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l55 55L422.1 56 407 41c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0zM210.3 155.7l61.1-61.1c.3 .3 .6 .7 1 1l16 16 56 56 56 56 16 16c.3 .3 .6 .6 1 1l-191 191c-10.5 10.5-24.7 16.4-39.6 16.4H97.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V325.3c0-14.9 5.9-29.1 16.4-39.6l43.3-43.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57z"
                }
            }
        ]
    })(props);
}
function FaT(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H160V448c0 17.7 14.3 32 32 32s32-14.3 32-32V96H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H192 32z"
                }
            }
        ]
    })(props);
}
function FaTableCellsLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96V224H288V96H448zm0 192V416H288V288H448zM224 224H64V96H224V224zM64 288H224V416H64V288zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                }
            }
        ]
    })(props);
}
function FaTableCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"
                }
            }
        ]
    })(props);
}
function FaTableColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 64V416H224V160H64zm384 0H288V416H448V160z"
                }
            }
        ]
    })(props);
}
function FaTableList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
                }
            }
        ]
    })(props);
}
function FaTableTennisPaddleBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 288c-50.1 0-93.6 28.8-114.6 70.8L132.9 126.3l.6-.6 60.1-60.1c87.5-87.5 229.3-87.5 316.8 0c67.1 67.1 82.7 166.3 46.8 248.3C535.8 297.6 509 288 480 288zM113.3 151.9L354.1 392.7c-1.4 7.5-2.1 15.3-2.1 23.3c0 23.2 6.2 44.9 16.9 63.7c-3 .2-6.1 .3-9.2 .3H357c-33.9 0-66.5-13.5-90.5-37.5l-9.8-9.8c-13.1-13.1-34.6-12.4-46.8 1.7L152.2 501c-5.8 6.7-14.2 10.7-23 11s-17.5-3.1-23.8-9.4l-32-32c-6.3-6.3-9.7-14.9-9.4-23.8s4.3-17.2 11-23l66.6-57.7c14-12.2 14.8-33.7 1.7-46.8l-9.8-9.8c-24-24-37.5-56.6-37.5-90.5v-2.7c0-22.8 6.1-44.9 17.3-64.3zM480 320a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                }
            }
        ]
    })(props);
}
function FaTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                }
            }
        ]
    })(props);
}
function FaTabletButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaTabletScreenButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64H64V384H384V64z"
                }
            }
        ]
    })(props);
}
function FaTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 432h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaTablets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M614.3 247c16.3-25 25.7-54.9 25.7-87C640 71.6 568.4 0 480 0c-32.1 0-61.9 9.4-87 25.7c-7.9 5.2-8.5 16.2-1.8 22.9L591.4 248.8c6.7 6.7 17.8 6.2 22.9-1.8zM567 294.3c7.9-5.2 8.5-16.2 1.8-22.9L368.6 71.2c-6.7-6.7-17.8-6.2-22.9 1.8c-16.3 25-25.7 54.9-25.7 87c0 88.4 71.6 160 160 160c32.1 0 61.9-9.4 87-25.7zM301.5 368H18.5c-9.5 0-16.9 8.2-15 17.5C18.9 457.8 83.1 512 160 512s141.1-54.2 156.5-126.5c2-9.3-5.5-17.5-15-17.5zm0-32c9.5 0 16.9-8.2 15-17.5C301.1 246.2 236.9 192 160 192S18.9 246.2 3.5 318.5c-2 9.3 5.5 17.5 15 17.5H301.5z"
                }
            }
        ]
    })(props);
}
function FaTachographDigital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 64H320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32zM64 368c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
                }
            }
        ]
    })(props);
}
function FaTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5V80C0 53.5 21.5 32 48 32H197.5c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaTape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.8 416c41.5-40.7 67.2-97.3 67.2-160C448 132.3 347.7 32 224 32S0 132.3 0 256S100.3 480 224 480H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H380.8zM224 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm64 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                }
            }
        ]
    })(props);
}
function FaTarpDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 160c-35.3 0-64-26.9-64-60c0-24 33.7-70.1 52.2-93.5c6.1-7.7 17.5-7.7 23.6 0C318.3 29.9 352 76 352 100c0 33.1-28.7 60-64 60zM64 128H197.5c13.2 37.3 48.7 64 90.5 64s77.4-26.7 90.5-64H512c35.3 0 64 28.7 64 64V352H448c-17.7 0-32 14.3-32 32l0 128L64 512c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zM448 512l0-128H576L448 512zM96 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaTarp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64l352 0 0-128c0-17.7 14.3-32 32-32H576V128zM448 448L576 320H448l0 128zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c-17.7 0-32 14.3-32 32V64c0 .1 0 .1 0 .2c-38.6 2.2-72.3 27.3-85.2 64.1L39.6 228.8C16.4 238.4 0 261.3 0 288V432v48c0 17.7 14.3 32 32 32H64c17.7 0 32-14.3 32-32V432H416v48c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V432 288c0-26.7-16.4-49.6-39.6-59.2L437.2 128.3c-12.9-36.8-46.6-62-85.2-64.1c0-.1 0-.1 0-.2V32c0-17.7-14.3-32-32-32H192zM165.4 128H346.6c13.6 0 25.7 8.6 30.2 21.4L402.9 224H109.1l26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zM96 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaTeethOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-53-43-96-96-96H96zM224 96c26.5 0 48 21.5 48 48v56c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V144c0-26.5 21.5-48 48-48zm80 48c0-26.5 21.5-48 48-48s48 21.5 48 48v56c0 13.3-10.7 24-24 24H328c-13.3 0-24-10.7-24-24V144zM96 128c26.5 0 48 21.5 48 48v24c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V176c0-26.5 21.5-48 48-48zm336 48c0-26.5 21.5-48 48-48s48 21.5 48 48v24c0 13.3-10.7 24-24 24H456c-13.3 0-24-10.7-24-24V176zM96 480H480c53 0 96-43 96-96V352c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96zm0-64c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48zm176 48c-26.5 0-48-21.5-48-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48zm80-48V344c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v24c0 26.5-21.5 48-48 48s-48-21.5-48-48z"
                }
            }
        ]
    })(props);
}
function FaTeeth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 75 43 32 96 32H480c53 0 96 43 96 96V384c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm176 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48s-48 21.5-48 48zm176-48c-26.5 0-48 21.5-48 48v56c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V176c0-26.5-21.5-48-48-48zM48 208v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zM96 384c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H72c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-48c0 26.5 21.5 48 48 48s48-21.5 48-48V312c0-13.3-10.7-24-24-24H200c-13.3 0-24 10.7-24 24v24zm176 48c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H328c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48zm80-176v24c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V208c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48 176c26.5 0 48-21.5 48-48V312c0-13.3-10.7-24-24-24H456c-13.3 0-24 10.7-24 24v24c0 26.5 21.5 48 48 48z"
                }
            }
        ]
    })(props);
}
function FaTemperatureArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v50.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zm336-64H480V64c0-17.7-14.3-32-32-32s-32 14.3-32 32V352H384c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8z"
                }
            }
        ]
    })(props);
}
function FaTemperatureArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C249.8 332.6 256 349.5 256 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM176 0C114.1 0 64 50.1 64 112V276.4c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C43.2 304.2 32 334.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C288 50.1 237.9 0 176 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48zM480 160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V448c0 17.7 14.3 32 32 32s32-14.3 32-32V160z"
                }
            }
        ]
    })(props);
}
function FaTemperatureEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C233.8 332.6 240 349.5 240 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9c8.2-10.6 15.3-25.2 15.3-42.5V112zM160 0C98.1 0 48 50.2 48 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C27.2 304.2 16 334.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C272 50.2 221.9 0 160 0zm0 416a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaTemperatureFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
                }
            }
        ]
    })(props);
}
function FaTemperatureHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V208c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
                }
            }
        ]
    })(props);
}
function FaTemperatureHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 128A96 96 0 1 0 416 0a96 96 0 1 0 0 192zM96 112c0-26.5 21.5-48 48-48s48 21.5 48 48V276.5c0 17.3 7.1 31.9 15.3 42.5C217.8 332.6 224 349.5 224 368c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18.5 6.2-35.4 16.7-48.9C88.9 308.4 96 293.8 96 276.5V112zM144 0C82.1 0 32 50.2 32 112V276.5c0 .1-.1 .3-.2 .6c-.2 .6-.8 1.6-1.7 2.8C11.2 304.2 0 334.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-33.2-11.2-63.8-30.1-88.1c-.9-1.2-1.5-2.2-1.7-2.8c-.1-.3-.2-.5-.2-.6V112C256 50.2 205.9 0 144 0zm0 416c26.5 0 48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16V322.7c-18.6 6.6-32 24.4-32 45.3c0 26.5 21.5 48 48 48z"
                }
            }
        ]
    })(props);
}
function FaTemperatureLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 96a96 96 0 1 1 192 0A96 96 0 1 1 320 96zM144 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C70.2 332.6 64 349.5 64 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM32 112C32 50.2 82.1 0 144 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S0 447.5 0 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM192 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
                }
            }
        ]
    })(props);
}
function FaTemperatureQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V272c0-8.8 7.2-16 16-16s16 7.2 16 16v50.7c18.6 6.6 32 24.4 32 45.3z"
                }
            }
        ]
    })(props);
}
function FaTemperatureThreeQuarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c-26.5 0-48 21.5-48 48V276.5c0 17.3-7.1 31.9-15.3 42.5C86.2 332.6 80 349.5 80 368c0 44.2 35.8 80 80 80s80-35.8 80-80c0-18.5-6.2-35.4-16.7-48.9c-8.2-10.6-15.3-25.2-15.3-42.5V112c0-26.5-21.5-48-48-48zM48 112C48 50.2 98.1 0 160 0s112 50.1 112 112V276.5c0 .1 .1 .3 .2 .6c.2 .6 .8 1.6 1.7 2.8c18.9 24.4 30.1 55 30.1 88.1c0 79.5-64.5 144-144 144S16 447.5 16 368c0-33.2 11.2-63.8 30.1-88.1c.9-1.2 1.5-2.2 1.7-2.8c.1-.3 .2-.5 .2-.6V112zM208 368c0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V144c0-8.8 7.2-16 16-16s16 7.2 16 16V322.7c18.6 6.6 32 24.4 32 45.3z"
                }
            }
        ]
    })(props);
}
function FaTengeSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM0 192c0-17.7 14.3-32 32-32H192 352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V224H32c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaTentArrowDownToLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M241.8 111.9c8.9 9.9 8.1 25-1.8 33.9l-80 72c-9.1 8.2-23 8.2-32.1 0l-80-72c-9.9-8.9-10.7-24-1.8-33.9s24-10.7 33.9-1.8l39.9 36L120 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 122.1 39.9-36c9.9-8.9 25-8.1 33.9 1.8zm122.8 22.6c11.5-8.7 27.3-8.7 38.8 0l168 128c6.6 5 11 12.5 12.3 20.7l24 160 .7 4.7c17.5 .2 31.6 14.4 31.6 32c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H159.6l.7-4.7 24-160c1.2-8.2 5.6-15.7 12.3-20.7l168-128zM384 448h76.8L384 320V448z"
                }
            }
        ]
    })(props);
}
function FaTentArrowLeftRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 6.2c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9L489.5 72 86.5 72l33.5-30.2c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120l402.9 0-33.5 30.2c-9.9 8.9-10.7 24-1.8 33.9s24 10.7 33.9 1.8l80-72c5.1-4.6 7.9-11 7.9-17.8s-2.9-13.3-7.9-17.8l-80-72zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                }
            }
        ]
    })(props);
}
function FaTentArrowTurnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 41.8c9.9-8.9 10.7-24 1.8-33.9S97.8-2.7 87.9 6.2l-80 72C2.9 82.7 0 89.2 0 96s2.9 13.3 7.9 17.8l80 72c9.9 8.9 25 8.1 33.9-1.8s8.1-25-1.8-33.9L86.5 120 456 120c39.8 0 72 32.2 72 72v40c0 13.3 10.7 24 24 24s24-10.7 24-24V192c0-66.3-53.7-120-120-120L86.5 72l33.5-30.2zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                }
            }
        ]
    })(props);
}
function FaTentArrowsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 111.9c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36L136 24c0-13.3-10.7-24-24-24S88 10.7 88 24l0 122.1-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zm352 0c-8.9-9.9-24-10.7-33.9-1.8l-39.9 36V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V146.1l-39.9-36c-9.9-8.9-25-8.1-33.9 1.8s-8.1 25 1.8 33.9l80 72c9.1 8.2 23 8.2 32.1 0l80-72c9.9-8.9 10.7-24 1.8-33.9zM307.4 166.5c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S86.7 512 96 512H288V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                }
            }
        ]
    })(props);
}
function FaTent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.4 6C280.5-2 295.5-2 306.6 6l224 160c7.4 5.3 12.2 13.5 13.2 22.5l32 288c1 9-1.9 18.1-8 24.9s-14.7 10.7-23.8 10.7H416L288 288V512H32c-9.1 0-17.8-3.9-23.8-10.7s-9-15.8-8-24.9l32-288c1-9 5.8-17.2 13.2-22.5L269.4 6z"
                }
            }
        ]
    })(props);
}
function FaTents(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.6 6.5L235.8 129.1c9.6 1.8 18.9 5.8 27 12l168 128c13.2 10.1 22 24.9 24.5 41.4l6.2 41.5H608c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128c-11.5-8.7-27.3-8.7-38.8 0zm-153.2 160c-11.5-8.7-27.3-8.7-38.8 0l-168 128c-6.6 5-11 12.5-12.3 20.7l-24 160c-1.4 9.2 1.3 18.6 7.4 25.6S22.7 512 32 512H224V352l96 160h96c9.3 0 18.2-4.1 24.2-11.1s8.8-16.4 7.4-25.6l-24-160c-1.2-8.2-5.6-15.7-12.3-20.7l-168-128z"
                }
            }
        ]
    })(props);
}
function FaTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6zM256 416H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaTextHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 128V96h64l0 320H96c-17.7 0-32 14.3-32 32s14.3 32 32 32H224c17.7 0 32-14.3 32-32s-14.3-32-32-32H192l0-320h64v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H160 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM502.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32V352H416c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H512V160h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
                }
            }
        ]
    })(props);
}
function FaTextSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"
                }
            }
        ]
    })(props);
}
function FaTextWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 128V96H192l0 128H176c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H256l0-128H384v32c0 17.7 14.3 32 32 32s32-14.3 32-32V80c0-26.5-21.5-48-48-48H224 48C21.5 32 0 53.5 0 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32zM9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V416H320v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H128V320c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
                }
            }
        ]
    })(props);
}
function FaThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 382.1V293.3c0-14.9 5.9-29.1 16.4-39.6l27.3-27.3 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 41.4-41.4 57 57c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-57-57 45.5-45.5C355.2 10.9 381.4 0 408.8 0C465.8 0 512 46.2 512 103.2c0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4H129.9L41 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l89-89z"
                }
            }
        ]
    })(props);
}
function FaThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaThumbtack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"
                }
            }
        ]
    })(props);
}
function FaTicketSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64v64c0 8.8-7.4 15.7-15.7 18.6C541.5 217.1 528 235 528 256s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320c0-8.8 7.4-15.7 15.7-18.6C34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192V128z"
                }
            }
        ]
    })(props);
}
function FaTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
                }
            }
        ]
    })(props);
}
function FaTimeline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 97.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3V224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H288v54.7c-28.3 12.3-48 40.5-48 73.3c0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3V288H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V169.3c28.3-12.3 48-40.5 48-73.3c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3V224H160V169.3zM488 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM320 392a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H192c-70.7 0-128-57.3-128-128s57.3-128 128-128H384zM576 256c0-106-86-192-192-192H192C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192zM192 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
                }
            }
        ]
    })(props);
}
function FaToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 64C86 64 0 150 0 256S86 448 192 448H384c106 0 192-86 192-192s-86-192-192-192H192zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                }
            }
        ]
    })(props);
}
function FaToiletPaperSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-109.7-86C569.9 374 608 291.9 608 192C608 86 565 0 512 0s-96 86-96 192c0 49.1 9.2 93.9 24.4 127.9l-59-46.2c1.6-24.8 2.6-52 2.6-81.6c0-65.5 13.2-142.4 60.2-192H160c-24.8 0-47.4 18.8-64.4 49.6L38.8 5.1zM367.3 385.4L66.5 148.4C64.9 162.4 64 177 64 192c0 101.5-11.7 170.8-23 213.9c-5.1 19.4-10.7 39.9-20.5 57.7c-5.9 9.9-6.1 22.1-.4 32.2S36.5 512 48 512H285.9c22.3 0 45.4-12.1 55.4-36.1c7.4-17.7 17.5-47.2 26-90.6zM544 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64z"
                }
            }
        ]
    })(props);
}
function FaToiletPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.2 0C397.2 49.6 384 126.5 384 192c0 158.8-27.3 247-42.7 283.9c-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2s-5.6-22.3 .4-32.2c9.8-17.7 15.4-38.2 20.5-57.7C52.3 362.8 64 293.5 64 192C64 86 107 0 160 0H444.2zM512 384c-53 0-96-86-96-192S459 0 512 0s96 86 96 192s-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64s-32 28.7-32 64s14.3 64 32 64zM144 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm64 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
                }
            }
        ]
    })(props);
}
function FaToiletPortable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32V64H320V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zM24 96H0v24V488c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H272v8c0 13.3 10.7 24 24 24s24-10.7 24-24V120 96H296 24zM256 240v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaToilet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaToiletsPortable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0H224c17.7 0 32 14.3 32 32V64H0V32C0 14.3 14.3 0 32 0zM0 96H24 232h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H48v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM192 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zM352 0H544c17.7 0 32 14.3 32 32V64H320V32c0-17.7 14.3-32 32-32zM320 96h24H552h24v24V488c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H368v8c0 13.3-10.7 24-24 24s-24-10.7-24-24V120 96zM512 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaToolbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 88v40H336V88c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zm-48 40V88c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56v40h28.1c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9V304H384V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H192V288c0-17.7-14.3-32-32-32s-32 14.3-32 32v16H0V227.9c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1H128zM0 416V336H128v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H320v16c0 17.7 14.3 32 32 32s32-14.3 32-32V336H512v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64z"
                }
            }
        ]
    })(props);
}
function FaTooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 52.1C169.3 39.1 148.7 32 127.5 32C74.7 32 32 74.7 32 127.5v6.2c0 15.8 3.7 31.3 10.7 45.5l23.5 47.1c4.5 8.9 7.6 18.4 9.4 28.2l36.7 205.8c2 11.2 11.6 19.4 22.9 19.8s21.4-7.4 24-18.4l28.9-121.3C192.2 323.7 207 312 224 312s31.8 11.7 35.8 28.3l28.9 121.3c2.6 11.1 12.7 18.8 24 18.4s20.9-8.6 22.9-19.8l36.7-205.8c1.8-9.8 4.9-19.3 9.4-28.2l23.5-47.1c7.1-14.1 10.7-29.7 10.7-45.5v-2.1c0-55-44.6-99.6-99.6-99.6c-24.1 0-47.4 8.8-65.6 24.6l-3.2 2.8 19.5 15.2c7 5.4 8.2 15.5 2.8 22.5s-15.5 8.2-22.5 2.8l-24.4-19-37-28.8z"
                }
            }
        ]
    })(props);
}
function FaToriiGate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80c0 26.5 21.5 48 48 48H64v64h64V128h96v64h64V128h96v64h64V128h16c26.5 0 48-21.5 48-48V13.4C512 6 506 0 498.6 0c-1.7 0-3.4 .3-5 1l-49 19.6C425.7 28.1 405.5 32 385.2 32H126.8c-20.4 0-40.5-3.9-59.4-11.4L18.4 1c-1.6-.6-3.3-1-5-1C6 0 0 6 0 13.4V80zM64 288V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32V288h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64z"
                }
            }
        ]
    })(props);
}
function FaTornado(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32V45.6C0 62.7 1.7 79.6 5 96H357.8c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16C416 10.1 405.9 0 393.4 0H32C14.3 0 0 14.3 0 32zm352.2 96H13.6c12.2 35.9 32.3 68.7 58.8 96H412l-47.2-62.9c-7.3-9.7-11.6-21.2-12.6-33.1zm-226 138.2l116.4 68.5c8.2 4.8 15.8 10.7 22.5 17.3H445c2-9.8 3-19.9 3-30.1c0-23-5.3-45.5-15.3-65.9H110.2c5.2 3.6 10.5 7 16 10.2zM288 384c10.3 21.4 13.8 45.5 9.9 69l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4c5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c12.8-12.8 23.1-27.7 30.4-43.9H288z"
                }
            }
        ]
    })(props);
}
function FaTowerBroadcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.3 44C69.8 69.9 64 98.2 64 128s5.8 58.1 16.3 84c6.6 16.4-1.3 35-17.7 41.7s-35-1.3-41.7-17.7C7.4 202.6 0 166.1 0 128S7.4 53.4 20.9 20C27.6 3.6 46.2-4.3 62.6 2.3S86.9 27.6 80.3 44zM555.1 20C568.6 53.4 576 89.9 576 128s-7.4 74.6-20.9 108c-6.6 16.4-25.3 24.3-41.7 17.7S489.1 228.4 495.7 212c10.5-25.9 16.3-54.2 16.3-84s-5.8-58.1-16.3-84C489.1 27.6 497 9 513.4 2.3s35 1.3 41.7 17.7zM352 128c0 23.7-12.9 44.4-32 55.4V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V183.4c-19.1-11.1-32-31.7-32-55.4c0-35.3 28.7-64 64-64s64 28.7 64 64zM170.6 76.8C163.8 92.4 160 109.7 160 128s3.8 35.6 10.6 51.2c7.1 16.2-.3 35.1-16.5 42.1s-35.1-.3-42.1-16.5c-10.3-23.6-16-49.6-16-76.8s5.7-53.2 16-76.8c7.1-16.2 25.9-23.6 42.1-16.5s23.6 25.9 16.5 42.1zM464 51.2c10.3 23.6 16 49.6 16 76.8s-5.7 53.2-16 76.8c-7.1 16.2-25.9 23.6-42.1 16.5s-23.6-25.9-16.5-42.1c6.8-15.6 10.6-32.9 10.6-51.2s-3.8-35.6-10.6-51.2c-7.1-16.2 .3-35.1 16.5-42.1s35.1 .3 42.1 16.5z"
                }
            }
        ]
    })(props);
}
function FaTowerCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M62.6 2.3C46.2-4.3 27.6 3.6 20.9 20C7.4 53.4 0 89.9 0 128s7.4 74.6 20.9 108c6.6 16.4 25.3 24.3 41.7 17.7S86.9 228.4 80.3 212C69.8 186.1 64 157.8 64 128s5.8-58.1 16.3-84C86.9 27.6 79 9 62.6 2.3zm450.8 0C497 9 489.1 27.6 495.7 44C506.2 69.9 512 98.2 512 128s-5.8 58.1-16.3 84c-6.6 16.4 1.3 35 17.7 41.7s35-1.3 41.7-17.7c13.5-33.4 20.9-69.9 20.9-108s-7.4-74.6-20.9-108C548.4 3.6 529.8-4.3 513.4 2.3zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2c0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9L177.7 448H398.3l20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM369.2 384H206.8l14.5-32H354.7l14.5 32zM288 205.3L325.6 288H250.4L288 205.3zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
                }
            }
        ]
    })(props);
}
function FaTowerObservation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M241.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9C439 137.5 427.7 144 416 144v80c0 17.7-14.3 32-32 32h-4.9l32 192H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H384.5c-.4 0-.8 0-1.1 0H128.6c-.4 0-.8 0-1.1 0H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l32-192H128c-17.7 0-32-14.3-32-32V144c-11.7 0-23-6.5-28.6-17.7c-7.9-15.8-1.5-35 14.3-42.9l160-80zM314.5 448L256 399.2 197.5 448h117zM197.8 256l-4.7 28.3L256 336.8l62.9-52.5L314.2 256H197.8zm-13.9 83.2l-11.2 67L218.5 368l-34.6-28.8zM293.5 368l45.8 38.1-11.2-67L293.5 368zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
                }
            }
        ]
    })(props);
}
function FaTractor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64c0-35.3 28.7-64 64-64H266.3c26.2 0 49.7 15.9 59.4 40.2L373.7 160H480V126.2c0-24.8 5.8-49.3 16.9-71.6l2.5-5c7.9-15.8 27.1-22.2 42.9-14.3s22.2 27.1 14.3 42.9l-2.5 5c-6.7 13.3-10.1 28-10.1 42.9V160h56c22.1 0 40 17.9 40 40v45.4c0 16.5-8.5 31.9-22.6 40.7l-43.3 27.1c-14.2-5.9-29.8-9.2-46.1-9.2c-39.3 0-74.1 18.9-96 48H352c0 17.7-14.3 32-32 32h-8.2c-1.7 4.8-3.7 9.5-5.8 14.1l5.8 5.8c12.5 12.5 12.5 32.8 0 45.3l-22.6 22.6c-12.5 12.5-32.8 12.5-45.3 0l-5.8-5.8c-4.6 2.2-9.3 4.1-14.1 5.8V480c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32v-8.2c-4.8-1.7-9.5-3.7-14.1-5.8l-5.8 5.8c-12.5 12.5-32.8 12.5-45.3 0L40.2 449.1c-12.5-12.5-12.5-32.8 0-45.3l5.8-5.8c-2.2-4.6-4.1-9.3-5.8-14.1H32c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h8.2c1.7-4.8 3.7-9.5 5.8-14.1l-5.8-5.8c-12.5-12.5-12.5-32.8 0-45.3l22.6-22.6c9-9 21.9-11.5 33.1-7.6V192 160 64zm170.3 0H160v96h32H304.7L266.3 64zM176 256a80 80 0 1 0 0 160 80 80 0 1 0 0-160zM528 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 64c-48.6 0-88-39.4-88-88c0-29.8 14.8-56.1 37.4-72c14.3-10.1 31.8-16 50.6-16c2.7 0 5.3 .1 7.9 .3c44.9 4 80.1 41.7 80.1 87.7c0 48.6-39.4 88-88 88z"
                }
            }
        ]
    })(props);
}
function FaTrademark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M345.6 108.8c-8.3-11-22.7-15.5-35.7-11.2S288 114.2 288 128V384c0 17.7 14.3 32 32 32s32-14.3 32-32V224l86.4 115.2c6 8.1 15.5 12.8 25.6 12.8s19.6-4.7 25.6-12.8L576 224V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128c0-13.8-8.8-26-21.9-30.4s-27.5 .1-35.7 11.2L464 266.7 345.6 108.8zM0 128c0 17.7 14.3 32 32 32H96V384c0 17.7 14.3 32 32 32s32-14.3 32-32V160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 96 0 110.3 0 128z"
                }
            }
        ]
    })(props);
}
function FaTrafficLight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V352c0 88.4 71.6 160 160 160s160-71.6 160-160V64c0-35.3-28.7-64-64-64H64zm96 416a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm48-176a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"
                }
            }
        ]
    })(props);
}
function FaTrailer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80V336c0 26.5 21.5 48 48 48H65.1c7.8-54.3 54.4-96 110.9-96s103.1 41.7 110.9 96H488h8H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H544V80c0-26.5-21.5-48-48-48H48zM80 96c8.8 0 16 7.2 16 16l0 131.2c-11.4 5.9-22.2 12.9-32 21V112c0-8.8 7.2-16 16-16zm96 128c-5.4 0-10.7 .2-16 .7L160 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112.7c-5.3-.5-10.6-.7-16-.7zm80 19.2L256 112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 152.2c-9.8-8.1-20.6-15.2-32-21zM368 96c8.8 0 16 7.2 16 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16zm112 16l0 192c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-192c0-8.8 7.2-16 16-16s16 7.2 16 16zM176 480a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-112a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaTrainSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 128c0-17.7 14.3-32 32-32h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM272 96h80c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zM64 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaTrainTram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M86.8 48c-12.2 0-23.6 5.5-31.2 15L42.7 79C34.5 89.3 19.4 91 9 82.7S-3 59.4 5.3 49L18 33C34.7 12.2 60 0 86.8 0H361.2c26.7 0 52 12.2 68.7 33l12.8 16c8.3 10.4 6.6 25.5-3.8 33.7s-25.5 6.6-33.7-3.7L392.5 63c-7.6-9.5-19.1-15-31.2-15H248V96h40c53 0 96 43 96 96V352c0 30.6-14.3 57.8-36.6 75.4l65.5 65.5c7.1 7.1 2.1 19.1-7.9 19.1H365.3c-8.5 0-16.6-3.4-22.6-9.4L288 448H160l-54.6 54.6c-6 6-14.1 9.4-22.6 9.4H43c-10 0-15-12.1-7.9-19.1l65.5-65.5C78.3 409.8 64 382.6 64 352V192c0-53 43-96 96-96h40V48H86.8zM160 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96V352c0 48 35.2 87.7 81.1 94.9l-46 46C28.1 499.9 33.1 512 43 512H82.7c8.5 0 16.6-3.4 22.6-9.4L160 448H288l54.6 54.6c6 6 14.1 9.4 22.6 9.4H405c10 0 15-12.1 7.9-19.1l-46-46c46-7.1 81.1-46.9 81.1-94.9V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zM224 288a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaTransgender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-31 31L112 78.1l7-7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-7 7 15.2 15.2C187.7 107.6 220.5 96 256 96s68.3 11.6 94.9 31.2l68.8-68.8-31-31c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h96c8.8 0 16 7.2 16 16v96c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-31-31-68.8 68.8C404.4 187.7 416 220.5 416 256c0 80.2-59 146.6-136 158.2V432h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-8H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V414.2C155 402.6 96 336.2 96 256c0-35.5 11.6-68.3 31.2-94.9L112 145.9l-7 7c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l7-7L58.3 92.3l-31 31c-4.6 4.6-11.5 5.9-17.4 3.5S0 118.5 0 112V16C0 7.2 7.2 0 16 0h96zM352 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0z"
                }
            }
        ]
    })(props);
}
function FaTrashArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32 128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
                }
            }
        ]
    })(props);
}
function FaTrashCanArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3C140.6 6.8 151.7 0 163.8 0zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm192 64c-6.4 0-12.5 2.5-17 7l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V408c0 13.3 10.7 24 24 24s24-10.7 24-24V273.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-4.5-4.5-10.6-7-17-7z"
                }
            }
        ]
    })(props);
}
function FaTrashCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"
                }
            }
        ]
    })(props);
}
function FaTreeCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48V192h40V120c0-13.3 10.7-24 24-24s24 10.7 24 24v72h24c26.5 0 48 21.5 48 48V464c0 26.5-21.5 48-48 48H432 336c-26.5 0-48-21.5-48-48V48zm64 32v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H368zM352 272v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm176-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H528zM512 368v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H528c-8.8 0-16 7.2-16 16zM224 160c0 6-1 11-2 16c20 14 34 38 34 64c0 45-36 80-80 80H160V480c0 18-15 32-32 32c-18 0-32-14-32-32V320H80c-45 0-80-35-80-80c0-26 13-50 33-64c-1-5-1-10-1-16c0-53 42-96 96-96c53 0 96 43 96 96z"
                }
            }
        ]
    })(props);
}
function FaTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.6 5.9L62 169.4c-3.9 4.2-6 9.8-6 15.5C56 197.7 66.3 208 79.1 208H104L30.6 281.4c-4.2 4.2-6.6 10-6.6 16C24 309.9 34.1 320 46.6 320H80L5.4 409.5C1.9 413.7 0 419 0 424.5c0 13 10.5 23.5 23.5 23.5H192v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448H424.5c13 0 23.5-10.5 23.5-23.5c0-5.5-1.9-10.8-5.4-15L368 320h33.4c12.5 0 22.6-10.1 22.6-22.6c0-6-2.4-11.8-6.6-16L344 208h24.9c12.7 0 23.1-10.3 23.1-23.1c0-5.7-2.1-11.3-6-15.5L237.4 5.9C234 2.1 229.1 0 224 0s-10 2.1-13.4 5.9z"
                }
            }
        ]
    })(props);
}
function FaTriangleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H176c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8H24C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.9C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24H446.4c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112h84.4c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6h84.4c-5.1 66.3-31.1 111.2-63 142.3z"
                }
            }
        ]
    })(props);
}
function FaTrowelBricks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.8 4.8C250.3 10.6 256 20.9 256 32v72h89c3.6-13.8 16.1-24 31-24h88c26.5 0 48 21.5 48 48s-21.5 48-48 48H376c-14.9 0-27.4-10.2-31-24H256v72c0 11.1-5.7 21.4-15.2 27.2s-21.2 6.4-31.1 1.4l-192-96C6.8 151.2 0 140.1 0 128s6.8-23.2 17.7-28.6l192-96c9.9-5 21.7-4.4 31.1 1.4zM288 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V256zM32 384h96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32zm192 0H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaTrowel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M343.9 213.4L245.3 312l65.4 65.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9S-2.1 481.8 1.5 470.5l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L200 266.7l98.6-98.6c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
                }
            }
        ]
    })(props);
}
function FaTruckArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM257 95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l39 39H96c-13.3 0-24 10.7-24 24s10.7 24 24 24H262.1l-39 39c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9L257 95z"
                }
            }
        ]
    })(props);
}
function FaTruckDroplet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 272c39.8 0 72-29.6 72-66c0-27-39.4-82.9-59.9-110.3c-6.1-8.2-18.1-8.2-24.2 0C175.4 123 136 179 136 206c0 36.5 32.2 66 72 66z"
                }
            }
        ]
    })(props);
}
function FaTruckFast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 0C85.5 0 64 21.5 64 48V96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 272c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 240c8.8 0 16 7.2 16 16s-7.2 16-16 16H64 16c-8.8 0-16 7.2-16 16s7.2 16 16 16H64 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64V416c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H112zM544 237.3V256H416V160h50.7L544 237.3zM160 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                }
            }
        ]
    })(props);
}
function FaTruckFieldUn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32C60.7 32 32 60.7 32 96v32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v32c-17.7 0-32 14.3-32 32s14.3 32 32 32H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288c0-35.3-28.7-64-64-64h-4.2c-.4-1.1-.9-2.1-1.3-3.2L485.7 102c-10.3-23.1-33.2-38-58.5-38H375.4C364.4 44.9 343.7 32 320 32H96zm288 96h43.2l42.7 96H384V128zM112 384a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaTruckField(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 96c0-35.3 28.7-64 64-64H320c23.7 0 44.4 12.9 55.4 32h51.8c25.3 0 48.2 14.9 58.5 38l52.8 118.8c.5 1.1 .9 2.1 1.3 3.2H544c35.3 0 64 28.7 64 64v32c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V288c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32V96zM384 224h85.9l-42.7-96H384v96zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaTruckFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80C0 35.8 35.8 0 80 0H432c44.2 0 80 35.8 80 80V368c0 26.2-12.6 49.4-32 64v48c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V432C12.6 417.4 0 394.2 0 368V80zm129.9 72.2L112 224H400l-17.9-71.8C378.5 138 365.7 128 351 128H161c-14.7 0-27.5 10-31 24.2zM128 320a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaTruckMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0H368c26.5 0 48 21.5 48 48V96h50.7c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3V256v32 64c17.7 0 32 14.3 32 32s-14.3 32-32 32H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V48zM416 256H544V237.3L466.7 160H416v96zM160 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm368-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM176 80v48l-48 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V192h48c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H240V80c0-8.8-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaTruckMonster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64v64H416L368 64H288zM419.2 25.6L496 128h80c17.7 0 32 14.3 32 32v64c17.7 0 32 14.3 32 32s-14.3 32-32 32c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64H288c-29.2-38.9-75.7-64-128-64s-98.8 25.1-128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32V160c0-17.7 14.3-32 32-32H224V48c0-26.5 21.5-48 48-48h96c20.1 0 39.1 9.5 51.2 25.6zM152 256h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.7 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.3 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.3 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.8 3.7-14.1 6.8-21.7 9C190.1 503.1 180.1 512 168 512H152c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2L63.8 468.9c-8.6-8.6-9.3-21.9-2.3-31.3c-3.7-6.9-6.8-14.1-9-21.8C40.9 414.1 32 404.1 32 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.3-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9c1.7-11.6 11.7-20.6 23.8-20.6zm8 176a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM448.2 276.6c1.7-11.6 11.7-20.6 23.8-20.6h16c12.1 0 22.1 8.9 23.8 20.6c7.6 2.2 14.9 5.3 21.8 9c9.4-7 22.8-6.3 31.3 2.3l11.3 11.3c8.6 8.6 9.3 21.9 2.2 31.3c3.7 6.8 6.8 14.1 9 21.7c11.6 1.7 20.6 11.7 20.6 23.8v16c0 12.1-8.9 22.1-20.6 23.8c-2.2 7.6-5.3 14.9-9 21.7c7 9.4 6.3 22.8-2.2 31.3l-11.3 11.3c-8.6 8.6-21.9 9.3-31.3 2.2c-6.9 3.7-14.1 6.8-21.8 9C510.1 503.1 500.1 512 488 512H472c-12.1 0-22.1-8.9-23.8-20.6c-7.6-2.2-14.9-5.3-21.7-9c-9.4 7.1-22.8 6.3-31.3-2.2l-11.3-11.3c-8.6-8.6-9.3-21.9-2.2-31.3c-3.7-6.9-6.8-14.1-9-21.8C360.9 414.1 352 404.1 352 392V376c0-12.1 8.9-22.1 20.6-23.8c2.2-7.6 5.3-14.9 9-21.8c-7-9.4-6.3-22.8 2.2-31.3l11.3-11.3c8.6-8.6 21.9-9.3 31.3-2.3c6.8-3.7 14.1-6.8 21.7-9zM528 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaTruckMoving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V304v80 16c0 44.2 35.8 80 80 80c26.2 0 49.4-12.6 64-32c14.6 19.4 37.8 32 64 32c44.2 0 80-35.8 80-80c0-5.5-.6-10.8-1.6-16H416h33.6c-1 5.2-1.6 10.5-1.6 16c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H608c17.7 0 32-14.3 32-32V288 272 261.7c0-9.2-3.2-18.2-9-25.3l-58.8-71.8c-10.6-13-26.5-20.5-43.3-20.5H480V96c0-35.3-28.7-64-64-64H64zM585 256H480V192h48.8c2.4 0 4.7 1.1 6.2 2.9L585 256zM528 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM176 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM80 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaTruckPickup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.6 96l76.8 96H288V96h80.6zM224 80V192H64c-17.7 0-32 14.3-32 32v64c-17.7 0-32 14.3-32 32s14.3 32 32 32H65.1c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16h66.3c-.7 5.2-1.1 10.6-1.1 16c0 61.9 50.1 112 112 112s112-50.1 112-112c0-5.4-.4-10.8-1.1-16H608c17.7 0 32-14.3 32-32s-14.3-32-32-32V224c0-17.7-14.3-32-32-32H527.4L418.6 56c-12.1-15.2-30.5-24-50-24H272c-26.5 0-48 21.5-48 48zm0 288a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm288 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0z"
                }
            }
        ]
    })(props);
}
function FaTruckPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 0c-30.6 0-56 54.7-56 86.1V192.5L7.8 274.3C2.9 277.2 0 282.4 0 288v64c0 5.1 2.4 9.8 6.4 12.8s9.3 3.9 14.1 2.5l123.4-37v81.2l-50 40c-3.8 3-6 7.6-6 12.5v32c0 5.1 2.5 10 6.6 13s9.5 3.8 14.4 2.2L200 480.9 290.4 511c-1.6-4.7-2.4-9.8-2.4-15V463.4c-18.2-10.5-30.7-29.7-31.9-51.8l-.1-.1V408 325.5 184l0-1.1 0 0V86.1C256 54.7 231.5 0 200 0zm88 176V400c0 20.9 13.4 38.7 32 45.3V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V448H544v40c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V445.3c18.6-6.6 32-24.4 32-45.3V176c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zm79.8 78.7c3.3-8.7 11.2-14.7 20.5-14.7H539.7c9.2 0 17.2 6 20.5 14.7L576 304H352l15.8-49.3zM568 352a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM336 376a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaTruckRampBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 0V400c0 61.9-50.1 112-112 112c-61 0-110.5-48.7-112-109.3L48.4 502.9c-17.1 4.6-34.6-5.4-39.3-22.5s5.4-34.6 22.5-39.3L352 353.8V64c0-35.3 28.7-64 64-64H640zM576 400a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM23.1 207.7c-4.6-17.1 5.6-34.6 22.6-39.2l46.4-12.4 20.7 77.3c2.3 8.5 11.1 13.6 19.6 11.3l30.9-8.3c8.5-2.3 13.6-11.1 11.3-19.6l-20.7-77.3 46.4-12.4c17.1-4.6 34.6 5.6 39.2 22.6l41.4 154.5c4.6 17.1-5.6 34.6-22.6 39.2L103.7 384.9c-17.1 4.6-34.6-5.6-39.2-22.6L23.1 207.7z"
                }
            }
        ]
    })(props);
}
function FaTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                }
            }
        ]
    })(props);
}
function FaTty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.3 241.3L15.1 200.6c-9.2-16.2-8.4-36.5 4.5-50C61.4 106.8 144.7 48 256 48s194.6 58.8 236.4 102.6c12.9 13.5 13.7 33.8 4.5 50l-23.1 40.7c-7.5 13.2-23.3 19.3-37.8 14.6l-81.1-26.6c-13.1-4.3-22-16.6-22-30.4V144c-49.6-18.1-104-18.1-153.6 0v54.8c0 13.8-8.9 26.1-22 30.4L76.1 255.8c-14.5 4.7-30.3-1.4-37.8-14.6zM32 336c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V336zm0 96c0-8.8 7.2-16 16-16H80c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V432zM144 320h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V336zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V336zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16zM128 432c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V432z"
                }
            }
        ]
    })(props);
}
function FaTurkishLiraSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32c17.7 0 32 14.3 32 32V99.3L247.2 65.2c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 165.9v29.4l119.2-34.1c17-4.9 34.7 5 39.6 22s-5 34.7-22 39.6L128 261.9V416h63.8c68.2 0 124.4-53.5 127.8-121.6l.4-8c.9-17.7 15.9-31.2 33.6-30.4s31.2 15.9 30.4 33.6l-.4 8C378.5 399.8 294.1 480 191.8 480H96c-17.7 0-32-14.3-32-32V280.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 213.6V184.1l-23.2 6.6c-17 4.9-34.7-5-39.6-22s5-34.7 22-39.6L64 117.6V64c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaTurnDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350 334.5c3.8 8.8 2 19-4.6 26l-136 144c-4.5 4.8-10.8 7.5-17.4 7.5s-12.9-2.7-17.4-7.5l-136-144c-6.6-7-8.4-17.2-4.6-26s12.5-14.5 22-14.5h88l0-192c0-17.7-14.3-32-32-32H32C14.3 96 0 81.7 0 64V32C0 14.3 14.3 0 32 0l80 0c70.7 0 128 57.3 128 128l0 192h88c9.6 0 18.2 5.7 22 14.5z"
                }
            }
        ]
    })(props);
}
function FaTurnUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"
                }
            }
        ]
    })(props);
}
function FaTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaU(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c17.7 0 32 14.3 32 32V288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7 14.3-32 32-32s32 14.3 32 32V288c0 106-86 192-192 192S0 394 0 288V64C0 46.3 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaUmbrellaBeach(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M346.3 271.8l-60.1-21.9L214 448H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H282.1l64.1-176.2zm121.1-.2l-3.3 9.1 67.7 24.6c18.1 6.6 38-4.2 39.6-23.4c6.5-78.5-23.9-155.5-80.8-208.5c2 8 3.2 16.3 3.4 24.8l.2 6c1.8 57-7.3 113.8-26.8 167.4zM462 99.1c-1.1-34.4-22.5-64.8-54.4-77.4c-.9-.4-1.9-.7-2.8-1.1c-33-11.7-69.8-2.4-93.1 23.8l-4 4.5C272.4 88.3 245 134.2 226.8 184l-3.3 9.1L434 269.7l3.3-9.1c18.1-49.8 26.6-102.5 24.9-155.5l-.2-6zM107.2 112.9c-11.1 15.7-2.8 36.8 15.3 43.4l71 25.8 3.3-9.1c19.5-53.6 49.1-103 87.1-145.5l4-4.5c6.2-6.9 13.1-13 20.5-18.2c-79.6 2.5-154.7 42.2-201.2 108z"
                }
            }
        ]
    })(props);
}
function FaUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c17.7 0 32 14.3 32 32V49.7C451.8 63.4 557.7 161 573.9 285.9c2 15.6-17.3 24.4-27.8 12.7C532.1 283 504.8 272 480 272c-38.7 0-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C359 299.5 326.7 272 288 272s-71 27.5-78.4 64.1c-1.7 8.7-8.7 15.9-17.6 15.9s-15.8-7.2-17.6-15.9C167 299.5 134.7 272 96 272c-24.8 0-52.1 11-66.1 26.7C19.4 310.4 .1 301.5 2.1 285.9C18.3 161 124.2 63.4 256 49.7V32c0-17.7 14.3-32 32-32zm0 304c12.3 0 23.5 4.6 32 12.2V430.6c0 45-36.5 81.4-81.4 81.4c-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6c9.6 0 17.4-7.8 17.4-17.4V316.2c8.5-7.6 19.7-12.2 32-12.2z"
                }
            }
        ]
    })(props);
}
function FaUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
                }
            }
        ]
    })(props);
}
function FaUniversalAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3v50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2s19.4-17.8 15.2-30.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6V235.5c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
                }
            }
        ]
    })(props);
}
function FaUnlockKeyhole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 64c-44.2 0-80 35.8-80 80v48H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80V144C80 64.5 144.5 0 224 0c57.5 0 107 33.7 130.1 82.3c7.6 16 .8 35.1-15.2 42.6s-35.1 .8-42.6-15.2C283.4 82.6 255.9 64 224 64zm32 320c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64z"
                }
            }
        ]
    })(props);
}
function FaUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 144c0-44.2 35.8-80 80-80c31.9 0 59.4 18.6 72.3 45.7c7.6 16 26.7 22.8 42.6 15.2s22.8-26.7 15.2-42.6C331 33.7 281.5 0 224 0C144.5 0 80 64.5 80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H144V144z"
                }
            }
        ]
    })(props);
}
function FaUpDownLeftRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
                }
            }
        ]
    })(props);
}
function FaUpDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"
                }
            }
        ]
    })(props);
}
function FaUpLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318 177.5c3.8-8.8 2-19-4.6-26l-136-144C172.9 2.7 166.6 0 160 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26S14.4 192 24 192H96l0 288c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32l0-288h72c9.6 0 18.2-5.7 22-14.5z"
                }
            }
        ]
    })(props);
}
function FaUpRightAndDownLeftFromCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 0H488c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512H24c-13.3 0-24-10.7-24-24V344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"
                }
            }
        ]
    })(props);
}
function FaUpRightFromSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"
                }
            }
        ]
    })(props);
}
function FaUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaUserAstronaut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128v64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9V128c0-16.8-12.9-30.5-29.3-31.9zM336 144v16c0 53-43 96-96 96H208c-53 0-96-43-96-96V144c0-26.5 21.5-48 48-48H288c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512H128V448c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64l98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16v48h32V464c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM625 177L497 305c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L591 143c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaUserClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c20.6 0 40.4 3.5 58.8 9.9C323 331 320 349.1 320 368c0 59.5 29.5 112.1 74.8 144H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V304c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaUserDoctor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaUserGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8v30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8V454.8c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9V218.2zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"
                }
            }
        ]
    })(props);
}
function FaUserGraduate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.3 .5c3.1-.6 6.3-.6 9.4 0l200 40C439.9 42.7 448 52.6 448 64s-8.1 21.3-19.3 23.5L352 102.9V160c0 70.7-57.3 128-128 128s-128-57.3-128-128V102.9L48 93.3v65.1l15.7 78.4c.9 4.7-.3 9.6-3.3 13.3s-7.6 5.9-12.4 5.9H16c-4.8 0-9.3-2.1-12.4-5.9s-4.3-8.6-3.3-13.3L16 158.4V86.6C6.5 83.3 0 74.3 0 64C0 52.6 8.1 42.7 19.3 40.5l200-40zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6z"
                }
            }
        ]
    })(props);
}
function FaUserGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function FaUserInjured(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 80H342.7c-7.9-19.5-20.4-36.5-36.2-49.9L240 80zm37.7-68.2C261.3 4.2 243.2 0 224 0c-53.7 0-99.7 33.1-118.7 80h81.4l91-68.2zM224 256c70.7 0 128-57.3 128-128c0-5.4-.3-10.8-1-16H97c-.7 5.2-1 10.6-1 16c0 70.7 57.3 128 128 128zM124 312.4c-9.7 3.1-19.1 7-28 11.7V512H243.7L181.5 408.2 124 312.4zm33-7.2L204.3 384H272c44.2 0 80 35.8 80 80c0 18-6 34.6-16 48h82.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3c-7.2 0-14.3 .4-21.3 1.3zM0 482.3C0 498.7 13.3 512 29.7 512H64V345.4C24.9 378.1 0 427.3 0 482.3zM320 464c0-26.5-21.5-48-48-48H223.5l57.1 95.2C303 507.2 320 487.6 320 464z"
                }
            }
        ]
    })(props);
}
function FaUserLargeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L381.9 274c48.5-23.2 82.1-72.7 82.1-130C464 64.5 399.5 0 320 0C250.4 0 192.4 49.3 178.9 114.9L38.8 5.1zM545.5 512H528L284.3 320h-59C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H545.3l.3 0z"
                }
            }
        ]
    })(props);
}
function FaUserLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288A144 144 0 1 0 256 0a144 144 0 1 0 0 288zm-94.7 32C72.2 320 0 392.2 0 481.3c0 17 13.8 30.7 30.7 30.7H481.3c17 0 30.7-13.8 30.7-30.7C512 392.2 439.8 320 350.7 320H161.3z"
                }
            }
        ]
    })(props);
}
function FaUserLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H392.6c-5.4-9.4-8.6-20.3-8.6-32V352c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7H178.3zM528 240c17.7 0 32 14.3 32 32v48H496V272c0-17.7 14.3-32 32-32zm-80 32v48c-17.7 0-32 14.3-32 32V480c0 17.7 14.3 32 32 32H608c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32V272c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
                }
            }
        ]
    })(props);
}
function FaUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM472 200H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H472c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaUserNinja(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c-57.2 0-105.6-37.5-122-89.3c-1.1 1.3-2.2 2.6-3.5 3.8c-15.8 15.8-38.8 20.7-53.6 22.1c-8.1 .8-14.6-5.7-13.8-13.8c1.4-14.7 6.3-37.8 22.1-53.6c5.8-5.8 12.6-10.1 19.6-13.4c-7-3.2-13.8-7.6-19.6-13.4C37.4 82.7 32.6 59.7 31.1 44.9c-.8-8.1 5.7-14.6 13.8-13.8c14.7 1.4 37.8 6.3 53.6 22.1c4.8 4.8 8.7 10.4 11.7 16.1C131.4 28.2 174.4 0 224 0c70.7 0 128 57.3 128 128s-57.3 128-128 128zM0 482.3C0 399.5 56.4 330 132.8 309.9c6-1.6 12.2 .9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
                }
            }
        ]
    })(props);
}
function FaUserNurse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V128h-.3c.2 2.6 .3 5.3 .3 8v40c0 70.7-57.3 128-128 128s-128-57.3-128-128V136c0-2.7 .1-5.4 .3-8H96zm48 48c0 44.2 35.8 80 80 80s80-35.8 80-80V160H144v16zM111.9 327.7c10.5-3.4 21.8 .4 29.4 8.5l71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6zM208 48V64H192c-4.4 0-8 3.6-8 8V88c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V96h16c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H240V48c0-4.4-3.6-8-8-8H216c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function FaUserPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"
                }
            }
        ]
    })(props);
}
function FaUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                }
            }
        ]
    })(props);
}
function FaUserSecret(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 14.3 25 27.1 64.6 35.9c-.4 4-.6 8-.6 12.1c0 17 3.3 33.2 9.3 48H45.4C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4H342.7c6-14.8 9.3-31 9.3-48c0-4.1-.2-8.1-.6-12.1C391 155.1 416 142.3 416 128c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm56 208H267.6c-16.5 0-31.1-10.6-36.3-26.2c-2.3-7-12.2-7-14.5 0c-5.2 15.6-19.9 26.2-36.3 26.2H168c-22.1 0-40-17.9-40-40V169.6c28.2 4.1 61 6.4 96 6.4s67.8-2.3 96-6.4V184c0 22.1-17.9 40-40 40zm-88 96l16 32L176 480 128 288l64 32zm128-32L272 480 240 352l16-32 64-32z"
                }
            }
        ]
    })(props);
}
function FaUserShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c1.8 0 3.5-.2 5.3-.5c-76.3-55.1-99.8-141-103.1-200.2c-16.1-4.8-33.1-7.3-50.7-7.3H178.3zm308.8-78.3l-120 48C358 277.4 352 286.2 352 296c0 63.3 25.9 168.8 134.8 214.2c5.9 2.5 12.6 2.5 18.5 0C614.1 464.8 640 359.3 640 296c0-9.8-6-18.6-15.1-22.3l-120-48c-5.7-2.3-12.1-2.3-17.8 0zM591.4 312c-3.9 50.7-27.2 116.7-95.4 149.7V273.8L591.4 312z"
                }
            }
        ]
    })(props);
}
function FaUserSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L353.3 251.6C407.9 237 448 187.2 448 128C448 57.3 390.7 0 320 0C250.2 0 193.5 55.8 192 125.2L38.8 5.1zM264.3 304.3C170.5 309.4 96 387.2 96 482.3c0 16.4 13.3 29.7 29.7 29.7H514.3c3.9 0 7.6-.7 11-2.1l-261-205.6z"
                }
            }
        ]
    })(props);
}
function FaUserTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c10 0 18.8-4.9 24.2-12.5l-99.2-99.2c-14.9-14.9-23.3-35.1-23.3-56.1v-33c-15.9-4.7-32.8-7.2-50.3-7.2H178.3zM384 224c-17.7 0-32 14.3-32 32v82.7c0 17 6.7 33.3 18.7 45.3L478.1 491.3c18.7 18.7 49.1 18.7 67.9 0l73.4-73.4c18.7-18.7 18.7-49.1 0-67.9L512 242.7c-12-12-28.3-18.7-45.3-18.7H384zm24 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaUserTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 1 224 0a128 128 0 1 1 0 256zM209.1 359.2l-18.6-31c-6.4-10.7 1.3-24.2 13.7-24.2H224h19.7c12.4 0 20.1 13.6 13.7 24.2l-18.6 31 33.4 123.9 36-146.9c2-8.1 9.8-13.4 17.9-11.3c70.1 17.6 121.9 81 121.9 156.4c0 17-13.8 30.7-30.7 30.7H285.5c-2.1 0-4-.4-5.8-1.1l.3 1.1H168l.3-1.1c-1.8 .7-3.8 1.1-5.8 1.1H30.7C13.8 512 0 498.2 0 481.3c0-75.5 51.9-138.9 121.9-156.4c8.1-2 15.9 3.3 17.9 11.3l36 146.9 33.4-123.9z"
                }
            }
        ]
    })(props);
}
function FaUserXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM471 143c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"
                }
            }
        ]
    })(props);
}
function FaUsersBetweenLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 48 0 37.3 0 24zM0 488c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM83.2 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 320c0-35.3 28.7-64 64-64h96c12.2 0 23.7 3.4 33.4 9.4c-37.2 15.1-65.6 47.2-75.8 86.6H64c-17.7 0-32-14.3-32-32zm461.6 32c-10.3-40.1-39.6-72.6-77.7-87.4c9.4-5.5 20.4-8.6 32.1-8.6h96c35.3 0 64 28.7 64 64c0 17.7-14.3 32-32 32H493.6zM391.2 290.4c32.1 7.4 58.1 30.9 68.9 61.6c3.5 10 5.5 20.8 5.5 32c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32c0-11.2 1.9-22 5.5-32c10.5-29.7 35.3-52.8 66.1-60.9c7.8-2.1 16-3.1 24.5-3.1h96c7.4 0 14.7 .8 21.6 2.4zm44-130.4a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM321.6 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                }
            }
        ]
    })(props);
}
function FaUsersGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM320 320c24 0 45.9-8.8 62.7-23.3c2.5-3.7 5.2-7.3 8-10.7c2.7-3.3 5.7-6.1 9-8.3C410 262.3 416 243.9 416 224c0-53-43-96-96-96s-96 43-96 96s43 96 96 96zm65.4 60.2c-10.3-5.9-18.1-16.2-20.8-28.2H261.3C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H455.2c-2.1-5.2-3.2-10.9-3.2-16.4v-3c-1.3-.7-2.7-1.5-4-2.3l-2.6 1.5c-16.8 9.7-40.5 8-54.7-9.7c-4.5-5.6-8.6-11.5-12.4-17.6l-.1-.2-.1-.2-2.4-4.1-.1-.2-.1-.2c-3.4-6.2-6.4-12.6-9-19.3c-8.2-21.2 2.2-42.6 19-52.3l2.7-1.5c0-.8 0-1.5 0-2.3s0-1.5 0-2.3l-2.7-1.5zM533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 17.4-3.5 33.9-9.7 49c2.5 .9 4.9 2 7.1 3.3l2.6 1.5c1.3-.8 2.6-1.6 4-2.3v-3c0-19.4 13.3-39.1 35.8-42.6c7.9-1.2 16-1.9 24.2-1.9s16.3 .6 24.2 1.9c22.5 3.5 35.8 23.2 35.8 42.6v3c1.3 .7 2.7 1.5 4 2.3l2.6-1.5c16.8-9.7 40.5-8 54.7 9.7c2.3 2.8 4.5 5.8 6.6 8.7c-2.1-57.1-49-102.7-106.6-102.7zm91.3 163.9c6.3-3.6 9.5-11.1 6.8-18c-2.1-5.5-4.6-10.8-7.4-15.9l-2.3-4c-3.1-5.1-6.5-9.9-10.2-14.5c-4.6-5.7-12.7-6.7-19-3L574.4 311c-8.9-7.6-19.1-13.6-30.4-17.6v-21c0-7.3-4.9-13.8-12.1-14.9c-6.5-1-13.1-1.5-19.9-1.5s-13.4 .5-19.9 1.5c-7.2 1.1-12.1 7.6-12.1 14.9v21c-11.2 4-21.5 10-30.4 17.6l-18.2-10.5c-6.3-3.6-14.4-2.6-19 3c-3.7 4.6-7.1 9.5-10.2 14.6l-2.3 3.9c-2.8 5.1-5.3 10.4-7.4 15.9c-2.6 6.8 .5 14.3 6.8 17.9l18.2 10.5c-1 5.7-1.6 11.6-1.6 17.6s.6 11.9 1.6 17.5l-18.2 10.5c-6.3 3.6-9.5 11.1-6.8 17.9c2.1 5.5 4.6 10.7 7.4 15.8l2.4 4.1c3 5.1 6.4 9.9 10.1 14.5c4.6 5.7 12.7 6.7 19 3L449.6 457c8.9 7.6 19.2 13.6 30.4 17.6v21c0 7.3 4.9 13.8 12.1 14.9c6.5 1 13.1 1.5 19.9 1.5s13.4-.5 19.9-1.5c7.2-1.1 12.1-7.6 12.1-14.9v-21c11.2-4 21.5-10 30.4-17.6l18.2 10.5c6.3 3.6 14.4 2.6 19-3c3.7-4.6 7.1-9.4 10.1-14.5l2.4-4.2c2.8-5.1 5.3-10.3 7.4-15.8c2.6-6.8-.5-14.3-6.8-17.9l-18.2-10.5c1-5.7 1.6-11.6 1.6-17.5s-.6-11.9-1.6-17.6l18.2-10.5zM472 384a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
                }
            }
        ]
    })(props);
}
function FaUsersLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M211.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM32 256c0 17.7 14.3 32 32 32h85.6c10.1-39.4 38.6-71.5 75.8-86.6c-9.7-6-21.2-9.4-33.4-9.4H96c-35.3 0-64 28.7-64 64zm461.6 32H576c17.7 0 32-14.3 32-32c0-35.3-28.7-64-64-64H448c-11.7 0-22.7 3.1-32.1 8.6c38.1 14.8 67.4 47.3 77.7 87.4zM391.2 226.4c-6.9-1.6-14.2-2.4-21.6-2.4h-96c-8.5 0-16.7 1.1-24.5 3.1c-30.8 8.1-55.6 31.1-66.1 60.9c-3.5 10-5.5 20.8-5.5 32c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32c0-11.2-1.9-22-5.5-32c-10.8-30.7-36.8-54.2-68.9-61.6zM563.2 96a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM321.6 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaUsersRays(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 7C31.6-2.3 16.4-2.3 7 7S-2.3 31.6 7 41l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41 7zM599 7L527 79c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7 505c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 471c-9.4 9.4-9.4 24.6 0 33.9zm592 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM212.1 336c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-.5-1.4-1-2.7-1.6-4c-9.4-22.3-29.8-38.9-54.3-43c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-.8 .1-1.7 .3-2.5 .5c-24.9 5.1-45.1 23-53.4 46.5zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaUsersRectangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H544c53 0 96-43 96-96V96c0-53-43-96-96-96H96zM64 96c0-17.7 14.3-32 32-32H544c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96zm159.8 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3C119.9 256 96 279.9 96 309.3zM461.2 336h56.1c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6zM372 289c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24c-8.6-24.3-29.9-42.6-55.9-47zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
                }
            }
        ]
    })(props);
}
function FaUsersSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L440.6 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 30.2-10.5 58-28 79.9l-25.2-19.7C408.1 267.7 416 246.8 416 224c0-53-43-96-96-96c-31.1 0-58.7 14.8-76.3 37.7l-40.6-31.8c13-14.2 20.9-33.1 20.9-53.9c0-44.2-35.8-80-80-80C116.3 0 91.9 14.1 77.5 35.5L38.8 5.1zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-20.6-18.2-35.2-42.8-40.8-70.8L121.8 192H106.7zM261.3 352C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c10.5 0 19.5-6 23.9-14.8L324.9 352H261.3zM512 160A80 80 0 1 0 512 0a80 80 0 1 0 0 160z"
                }
            }
        ]
    })(props);
}
function FaUsersViewfinder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"
                }
            }
        ]
    })(props);
}
function FaUsers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"
                }
            }
        ]
    })(props);
}
function FaUtensils(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"
                }
            }
        ]
    })(props);
}
function FaV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
                }
            }
        ]
    })(props);
}
function FaVanShuttle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 104v88h96V96H72c-4.4 0-8 3.6-8 8zm482 88L465.1 96H384v96H546zm-226 0V96H224v96h96zM592 384H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48V104C0 64.2 32.2 32 72 32H192 352 465.1c18.9 0 36.8 8.3 49 22.8L625 186.5c9.7 11.5 15 26.1 15 41.2V336c0 26.5-21.5 48-48 48zm-64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM160 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaVault(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C28.7 0 0 28.7 0 64V416c0 35.3 28.7 64 64 64H80l16 32h64l16-32H400l16 32h64l16-32h16c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 320a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-240a160 160 0 1 1 0 320 160 160 0 1 1 0-320zM480 221.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3c0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3z"
                }
            }
        ]
    })(props);
}
function FaVectorSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 80h32v32H368V80zM352 32c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zM96 160c17.7 0 32-14.3 32-32H320c0 17.7 14.3 32 32 32V352c-17.7 0-32 14.3-32 32H128c0-17.7-14.3-32-32-32V160zM48 400H80v32H48V400zm320 32V400h32v32H368zM48 112V80H80v32H48z"
                }
            }
        ]
    })(props);
}
function FaVenusDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H224v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C78.1 334.1 16 262.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176zM344 318c14.6-15.6 26.8-33.4 36-53c18.8 14.4 42.4 23 68 23c61.9 0 112-50.1 112-112s-50.1-112-112-112c-25.6 0-49.1 8.6-68 23c-9.3-19.5-21.5-37.4-36-53C373.1 12.6 409.1 0 448 0c97.2 0 176 78.8 176 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H384c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1c-26.6-4.9-51.1-15.7-72-31.1z"
                }
            }
        ]
    })(props);
}
function FaVenusMars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM352 176c0 86.3-62.1 158.1-144 173.1V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H208v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H112c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V349.1C62.1 334.1 0 262.3 0 176C0 78.8 78.8 0 176 0s176 78.8 176 176zM271.9 360.6c19.3-10.1 36.9-23.1 52.1-38.4c20 18.5 46.7 29.8 76.1 29.8c61.9 0 112-50.1 112-112s-50.1-112-112-112c-7.2 0-14.3 .7-21.1 2c-4.9-21.5-13-41.7-24-60.2C369.3 66 384.4 64 400 64c37 0 71.4 11.4 99.8 31l20.6-20.6L487 41c-6.9-6.9-8.9-17.2-5.2-26.2S494.3 0 504 0H616c13.3 0 24 10.7 24 24V136c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L545 140.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176c-50.5 0-96-21.3-128.1-55.4z"
                }
            }
        ]
    })(props);
}
function FaVenus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"
                }
            }
        ]
    })(props);
}
function FaVestPatches(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.2 69.7l55.9 167.7-11 33.1c-2.7 8.2-4.1 16.7-4.1 25.3V464c0 14.5 3.9 28.2 10.7 39.9C195 509 185.9 512 176 512H48c-26.5 0-48-21.5-48-48V270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6V128 54.3 48C64 21.5 85.5 0 112 0h4.5c.2 0 .4 0 .6 0c.4 0 .8 0 1.2 0c18.8 0 34.1 9.7 44.1 18.8C171.6 27.2 190.8 40 224 40s52.4-12.8 61.7-21.2C295.7 9.7 311 0 329.7 0c.4 0 .8 0 1.2 0c.2 0 .4 0 .6 0H336c26.5 0 48 21.5 48 48v6.3V128v17.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6V464c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V295.8c0-5.2 .8-10.3 2.5-15.2L296.8 69.7C279.4 79.7 255.4 88 224 88s-55.4-8.3-72.8-18.3zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305l15.5 15.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288l15.5-15.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280v8 32c0 8.8 7.2 16 16 16h32 8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                }
            }
        ]
    })(props);
}
function FaVest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.1 237.4L151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3L226.5 280.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6V128 54.3 48c0-26.5-21.5-48-48-48h-4.5c-.2 0-.4 0-.6 0c-.4 0-.8 0-1.2 0C311 0 295.7 9.7 285.7 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0c-.4 0-.8 0-1.2 0c-.2 0-.4 0-.6 0H112C85.5 0 64 21.5 64 48v6.3V128v17.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48H176c9.9 0 19-3 26.7-8.1C195.9 492.2 192 478.5 192 464V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zM347.3 356.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48l48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaVialCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H96h64 64c17.7 0 32 14.3 32 32s-14.3 32-32 32V266.8c-20.2 28.6-32 63.5-32 101.2c0 25.2 5.3 49.1 14.8 70.8C189.5 463.7 160.6 480 128 480c-53 0-96-43-96-96V96C14.3 96 0 81.7 0 64zM96 96v96h64V96H96zM224 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm211.3-43.3c-6.2-6.2-16.4-6.2-22.6 0L352 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
                }
            }
        ]
    })(props);
}
function FaVialVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96V384c0 53 43 96 96 96c28.6 0 54.2-12.5 71.8-32.3c.1-14.2 5.6-28.3 16.4-39.1c.2-.2 .1-.6-.2-.6c-30.9 0-56-25.1-56-56s25.1-56 56-56c.3 0 .4-.4 .2-.6c-21.9-21.9-21.9-57.3 0-79.2c2.4-2.4 5-4.6 7.8-6.5V96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160 96 32zM96 192V96h64v96H96zM216 376c28.8 0 43.2 34.8 22.9 55.2c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9c0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9C444.8 410.8 459.2 376 488 376c13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0C410.8 259.2 376 244.8 376 216c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2c-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-88a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm40 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
                }
            }
        ]
    })(props);
}
function FaVial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4L28.1 342.6C10.1 360.6 0 385 0 410.5V416c0 53 43 96 96 96h5.5c25.5 0 49.9-10.1 67.9-28.1L448 205.3l9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-32-32-96-96-32-32zM205.3 256L352 109.3 402.7 160l-96 96H205.3z"
                }
            }
        ]
    })(props);
}
function FaVials(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H88h48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96C14.3 96 0 81.7 0 64zM136 96H88V256h48V96zM288 64c0-17.7 14.3-32 32-32h56 48 56c17.7 0 32 14.3 32 32s-14.3 32-32 32V400c0 44.2-35.8 80-80 80s-80-35.8-80-80V96c-17.7 0-32-14.3-32-32zM424 96H376V256h48V96z"
                }
            }
        ]
    })(props);
}
function FaVideoSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-86.4-67.7 13.8 9.2c9.8 6.5 22.4 7.2 32.9 1.6s16.9-16.4 16.9-28.2V128c0-11.8-6.5-22.6-16.9-28.2s-23-5-32.9 1.6l-96 64L448 174.9V192 320v5.8l-32-25.1V128c0-35.3-28.7-64-64-64H113.9L38.8 5.1zM407 416.7L32.3 121.5c-.2 2.1-.3 4.3-.3 6.5V384c0 35.3 28.7 64 64 64H352c23.4 0 43.9-12.6 55-31.3z"
                }
            }
        ]
    })(props);
}
function FaVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2V384c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1V320 192 174.9l14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
                }
            }
        ]
    })(props);
}
function FaVihara(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281 22L305.8 4.7c1.3-.9 2.7-1.8 4.1-2.4C313.1 .7 316.6 0 320 0s6.9 .7 10.1 2.2c1.4 .7 2.8 1.5 4.1 2.4L359 22C393 45.8 430.8 63.5 470.8 74.4l23 6.3c1.8 .5 3.6 1.1 5.2 2c3.2 1.7 5.9 4 8.1 6.8c3.8 4.9 5.6 11.3 4.7 17.8c-.4 2.8-1.2 5.4-2.5 7.8c-1.7 3.2-4 5.9-6.8 8.1c-4.3 3.2-9.6 5.1-15.1 4.9H480v56.1l6.4 5.1 5.2 4.1c21.1 16.7 45 29.6 70.5 38.1l28.9 9.6c1.6 .5 3.2 1.2 4.6 2c3.1 1.7 5.8 4.1 7.8 6.9s3.5 6.1 4.1 9.6c.5 2.7 .6 5.5 .1 8.3s-1.4 5.4-2.7 7.8c-1.7 3.1-4.1 5.8-6.9 7.8s-6.1 3.5-9.6 4.1c-1.6 .3-3.3 .4-5 .4H544v65.9c20.5 22.8 47.4 39.2 77.4 46.7C632 403 640 412.6 640 424c0 13.3-10.7 24-24 24H576v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H128v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V448H24c-13.3 0-24-10.7-24-24c0-11.4 8-21 18.6-23.4c30-7.6 56.9-23.9 77.4-46.7V288H56.6c-1.7 0-3.4-.1-5-.4c-3.5-.7-6.8-2.1-9.6-4.1s-5.2-4.7-7-7.8c-1.3-2.4-2.3-5-2.7-7.8s-.4-5.6 .1-8.3c.7-3.5 2.1-6.8 4.1-9.6s4.7-5.2 7.8-6.9c1.4-.8 3-1.5 4.6-2l28.9-9.6c25.5-8.5 49.4-21.4 70.5-38.1l5.2-4.1 6.4-5.1V176 128h-7.5c-5.5 .1-10.8-1.7-15.1-4.9c-2.8-2.1-5.1-4.8-6.8-8.1c-1.2-2.4-2.1-5-2.5-7.8c-.9-6.5 .9-12.8 4.7-17.8c2.1-2.8 4.8-5.1 8.1-6.8c1.6-.8 3.4-1.5 5.2-2l23-6.3C209.2 63.5 247 45.8 281 22zM416 128H320 224v64h72 48 72V128zM160 288v64H296h24 24H480V288H344 320h0H296 160z"
                }
            }
        ]
    })(props);
}
function FaVirusCovidSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L472.1 344.7c11.4-19.5 19.1-41.4 22.3-64.7H528v16c0 13.3 10.7 24 24 24s24-10.7 24-24V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H494.4c-4.2-30.7-16.3-58.8-34.1-82.3L484 125.9l11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L472.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L450.1 92l-23.8 23.8C402.8 97.9 374.7 85.8 344 81.6V48h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h16V81.6c-30.7 4.2-58.8 16.3-82.3 34.1L189.9 92l11.3-11.3c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L134.1 79.8 38.8 5.1zM149.2 213.5c-1.5 6-2.7 12.2-3.5 18.5H112V216c0-13.3-10.7-24-24-24s-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V280h33.6c4.2 30.7 16.3 58.8 34.1 82.3L156 386.1l-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L189.9 420l23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1V464H280c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H344V430.4c20.4-2.8 39.7-9.1 57.3-18.2L149.2 213.5z"
                }
            }
        ]
    })(props);
}
function FaVirusCovid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H280V81.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L420 125.9l-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3H464V216c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V280H430.4c-4.2 30.7-16.3 58.8-34.1 82.3L420 386.1l11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L386.1 420l-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1V464h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h16V430.4c-30.7-4.2-58.8-16.3-82.3-34.1L125.9 420l11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L92 386.1l23.8-23.8C97.9 338.8 85.8 310.7 81.6 280H48v16c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24s24 10.7 24 24v16H81.6c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92l23.8 23.8c23.5-17.9 51.7-29.9 82.3-34.1V48H216c-13.3 0-24-10.7-24-24zm48 200a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm64 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaVirusSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-154.3-121c-2-30.1 20.8-60.1 56-60.1H544c17.7 0 32-14.3 32-32s-14.3-32-32-32H532.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L184.2 75c-12.5-12.5-32.8-12.5-45.3 0c-1.6 1.6-3.1 3.4-4.3 5.3L38.8 5.1zm225.8 177c6.9-3.9 14.9-6.1 23.4-6.1c26.5 0 48 21.5 48 48c0 4.4-.6 8.7-1.7 12.7l-69.7-54.6zM402 412.7L144.7 210c-9.5 8.5-22.2 14-37.2 14H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-31.2 23.6-52.7 50-55.7z"
                }
            }
        ]
    })(props);
}
function FaVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V43.5c0 49.9-60.3 74.9-95.6 39.6L120.2 75C107.7 62.5 87.5 62.5 75 75s-12.5 32.8 0 45.3l8.2 8.2C118.4 163.7 93.4 224 43.5 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H43.5c49.9 0 74.9 60.3 39.6 95.6L75 391.8c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V468.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H468.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32zM176 224a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaViruses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0c13.3 0 24 10.7 24 24V37.5c0 35.6 43.1 53.5 68.3 28.3l9.5-9.5c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-9.5 9.5C293 124.9 310.9 168 346.5 168H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H346.5c-35.6 0-53.5 43.1-28.3 68.3l9.5 9.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-9.5-9.5C259.1 293 216 310.9 216 346.5V360c0 13.3-10.7 24-24 24s-24-10.7-24-24V346.5c0-35.6-43.1-53.5-68.3-28.3l-9.5 9.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l9.5-9.5C91 259.1 73.1 216 37.5 216H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H37.5c35.6 0 53.5-43.1 28.3-68.3l-9.5-9.5c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l9.5 9.5C124.9 91 168 73.1 168 37.5V24c0-13.3 10.7-24 24-24zm48 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 80c0 33 39.9 49.5 63.2 26.2c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C574.5 312.1 591 352 624 352c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C551.9 446.5 512 463 512 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C417.5 423.9 401 384 368 384c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C440.1 289.5 480 273 480 240c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 320a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm119.8 0c15.3-22.9 24.2-50.4 24.2-80c0-79.5-64.5-144-144-144S0 160.5 0 240s64.5 144 144 144H496c79.5 0 144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144c0 29.6 8.9 57.1 24.2 80H263.8zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
                }
            }
        ]
    })(props);
}
function FaVolcano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15C212.4 12.4 232.7 0 256 0s43.6 12.4 54.8 31C322 21.6 336.3 16 352 16c35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8c19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9c11.3 0 21.8-5.6 28-15l9.7-14.6-58.9-66.3c-9.1-10.2-22.2-16.1-35.9-16.1H235.1c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4L144 352zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2h41.8c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7c0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l150.2-169z"
                }
            }
        ]
    })(props);
}
function FaVolleyball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.8 267.4c-26.1 8.7-53.4 13.8-81 15.1c9.2-105.3-31.5-204.2-103.2-272.4C434.1 41.1 512 139.5 512 256c0 3.8-.1 7.6-.2 11.4zm-3.9 34.7c-5.8 32-17.6 62-34.2 88.7c-97.5 48.5-217.7 42.6-311.9-24.5c23.7-36.2 55.4-67.7 94.5-91.8c79.9 43.2 170.1 50.8 251.6 27.6zm-236-55.5c-2.5-90.9-41.1-172.7-101.9-231.7C196.8 5.2 225.8 0 256 0c2.7 0 5.3 0 7.9 .1c90.8 60.2 145.7 167.2 134.7 282.3c-43.1-2.4-86.4-14.1-126.8-35.9zM138 28.8c20.6 18.3 38.7 39.4 53.7 62.6C95.9 136.1 30.6 220.8 7.3 316.9C2.5 297.4 0 277 0 256C0 157.2 56 71.5 138 28.8zm69.6 90.5c19.5 38.6 31 81.9 32.3 127.7C162.5 294.6 110.9 368.9 90.2 451C66 430.4 45.6 405.4 30.4 377.2c6.7-108.7 71.9-209.9 177.1-257.9zM256 512c-50.7 0-98-14.7-137.8-40.2c5.6-27 14.8-53.1 27.4-77.7C232.2 454.6 338.1 468.8 433 441c-46 44-108.3 71-177 71z"
                }
            }
        ]
    })(props);
}
function FaVolumeHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"
                }
            }
        ]
    })(props);
}
function FaVolumeLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"
                }
            }
        ]
    })(props);
}
function FaVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L131.8 160H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h67.8L266.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S320 460.6 320 448V64z"
                }
            }
        ]
    })(props);
}
function FaVolumeXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM425 167l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
                }
            }
        ]
    })(props);
}
function FaVrCardboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H184.4c24.2 0 46.4-13.7 57.2-35.4l32-64c8.8-17.5 26.7-28.6 46.3-28.6s37.5 11.1 46.3 28.6l32 64c10.8 21.7 33 35.4 57.2 35.4H576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM96 240a64 64 0 1 1 128 0A64 64 0 1 1 96 240zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaW(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.8 34c16.5-6.2 35 2.2 41.2 18.7l110.2 294L257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23l85.1 291.7L514 52.8c6.2-16.5 24.6-24.9 41.2-18.7s24.9 24.7 18.7 41.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
                }
            }
        ]
    })(props);
}
function FaWalkieTalkie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 24c0-13.3-10.7-24-24-24S64 10.7 64 24V96H48C21.5 96 0 117.5 0 144V300.1c0 12.7 5.1 24.9 14.1 33.9l3.9 3.9c9 9 14.1 21.2 14.1 33.9V464c0 26.5 21.5 48 48 48H304c26.5 0 48-21.5 48-48V371.9c0-12.7 5.1-24.9 14.1-33.9l3.9-3.9c9-9 14.1-21.2 14.1-33.9V144c0-26.5-21.5-48-48-48H320c0-17.7-14.3-32-32-32s-32 14.3-32 32H224c0-17.7-14.3-32-32-32s-32 14.3-32 32H112V24zm0 136H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaWandMagicSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"
                }
            }
        ]
    })(props);
}
function FaWandMagic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z"
                }
            }
        ]
    })(props);
}
function FaWandSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7V176c0 8.8-7.2 16-16 16H384.2c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9C94.3 508 85.3 512 75.8 512c-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7C3.5 453.4 0 445 0 436.2c0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9V272c0-8.8 7.2-16 16-16h34.6c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8L87.7 218.2c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8L72.3 69.8c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
                }
            }
        ]
    })(props);
}
function FaWarehouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 488V171.3c0-26.2 15.9-49.7 40.2-59.4L308.1 4.8c7.6-3.1 16.1-3.1 23.8 0L599.8 111.9c24.3 9.7 40.2 33.3 40.2 59.4V488c0 13.3-10.7 24-24 24H568c-13.3 0-24-10.7-24-24V224c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32V488c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zm488 24l-336 0c-13.3 0-24-10.7-24-24V432H512l0 56c0 13.3-10.7 24-24 24zM128 400V336H512v64H128zm0-96V224H512l0 80H128z"
                }
            }
        ]
    })(props);
}
function FaWaterLadder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 127.7C128 74.9 170.9 32 223.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V224H384V127.7C384 74.9 426.9 32 479.7 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8c-17.5 0-31.7 14.2-31.7 31.7V361c-1.6 1-3.3 2-4.8 3.1c-18 12.4-40.1 20.3-59.2 20.3h0V288H192v96.5c-19 0-41.2-7.9-59.1-20.3c-1.6-1.1-3.2-2.2-4.9-3.1V127.7zM306.5 389.9C329 405.4 356.5 416 384 416c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 469.7 417 480 384 480c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 405.2 165.1 416 192 416c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M269.5 69.9c11.1-7.9 25.9-7.9 37 0C329 85.4 356.5 96 384 96c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 149.7 417 160 384 160c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4C42.8 92.6 61 83.5 75.3 71.6c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 85.2 165.1 96 192 96c27.5 0 55-10.6 77.5-26.1zm37 288C329 373.4 356.5 384 384 384c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 437.7 417 448 384 448c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 373.2 165.1 384 192 384c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0zm0-144C329 229.4 356.5 240 384 240c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 293.7 417 304 384 304c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.5 27.3-10.1 39.2-1.7l0 0C136.7 229.2 165.1 240 192 240c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"
                }
            }
        ]
    })(props);
}
function FaWaveSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 64c0-17.7 14.3-32 32-32H320c17.7 0 32 14.3 32 32V416h96V256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H512V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V96H192V256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h96V64z"
                }
            }
        ]
    })(props);
}
function FaWeightHanging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32c0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32H120c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512H464c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128H346.5z"
                }
            }
        ]
    })(props);
}
function FaWeightScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 176a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H391.8zM296 224c0-10.6-4.1-20.2-10.9-27.4l33.6-78.3c3.5-8.1-.3-17.5-8.4-21s-17.5 .3-21 8.4L255.7 184c-22 .1-39.7 18-39.7 40c0 22.1 17.9 40 40 40s40-17.9 40-40z"
                }
            }
        ]
    })(props);
}
function FaWheatAwnCircleExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c22.5 22.5 53.3 31.5 82.4 27c0-1 0-2.1 0-3.1c0-33.1 9.1-64.1 25-90.6c-15.5-8.7-32.5-13.8-49.8-15.5l31.9-31.9 12.2 12.2c6 6 12.6 11.1 19.7 15.2c27.5-34 67.3-57.5 112.6-63.8c-4.1-3.8-8.4-7.3-12.9-10.5L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3zM496 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-96a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaWheatAwn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L383 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l88-88zM305.5 27.3c-6.2-6.2-16.4-6.2-22.6 0L271.5 38.6c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4-30.5 30.5c-3.4-27.3-15.5-53.8-36.5-74.8L101.8 231c-6.2-6.2-16.4-6.2-22.6 0L67.9 242.3c-37.5 37.5-37.5 98.3 0 135.8l10.4 10.4L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.9-68.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-21.8-21.8-49.6-34.1-78.1-36.9l31.9-31.9 12.2 12.2c37.5 37.5 98.3 37.5 135.8 0L486.5 231c6.2-6.2 6.2-16.4 0-22.6L475.2 197c-5.2-5.2-10.6-9.8-16.4-13.9L505 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-59.4 59.4c-20.6-4.4-42-3.7-62.3 2.1c6.1-21.3 6.6-43.8 1.4-65.3L409 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L329.1 52.9c-3.7-5-7.8-9.8-12.4-14.3L305.5 27.3z"
                }
            }
        ]
    })(props);
}
function FaWheelchairMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224h97.4c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288H306.7c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
                }
            }
        ]
    })(props);
}
function FaWheelchair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM120.5 247.2c12.4-4.7 18.7-18.5 14-30.9s-18.5-18.7-30.9-14C43.1 225.1 0 283.5 0 352c0 88.4 71.6 160 160 160c61.2 0 114.3-34.3 141.2-84.7c6.2-11.7 1.8-26.2-9.9-32.5s-26.2-1.8-32.5 9.9C240 440 202.8 464 160 464C98.1 464 48 413.9 48 352c0-47.9 30.1-88.8 72.5-104.8zM259.8 176l-1.9-9.7c-4.5-22.3-24-38.3-46.8-38.3c-30.1 0-52.7 27.5-46.8 57l23.1 115.5c6 29.9 32.2 51.4 62.8 51.4h5.1c.4 0 .8 0 1.3 0h94.1c6.7 0 12.6 4.1 15 10.4L402 459.2c6 16.1 23.8 24.6 40.1 19.1l48-16c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-18.7 6.2-25.5-68c-11.7-31.2-41.6-51.9-74.9-51.9H282.2l-9.6-48H336c17.7 0 32-14.3 32-32s-14.3-32-32-32H259.8z"
                }
            }
        ]
    })(props);
}
function FaWhiskeyGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4 .3 68.6l50 342.9c5.7 39.3 39.4 68.5 79.2 68.5h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zM87.7 224L69 96H443L424.3 224H87.7z"
                }
            }
        ]
    })(props);
}
function FaWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
                }
            }
        ]
    })(props);
}
function FaWind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c53 0 96-43 96-96s-43-96-96-96H320c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32 14.3-32 32zM128 512h32c53 0 96-43 96-96s-43-96-96-96H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H160c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaWindowMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM96 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaWindowMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaWindowRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 64H208c-8.8 0-16 7.2-16 16V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V320h16c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM0 192c0-35.3 28.7-64 64-64H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm64 32c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function FaWineBottle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.4 9.4c12.5-12.5 32.8-12.5 45.3 0l64 64c12.5 12.5 12.5 32.8 0 45.3c-11.8 11.8-30.7 12.5-43.2 1.9l-9.5 9.5-48.8 48.8c-9.2 9.2-11.5 22.9-8.6 35.6c9.4 40.9-1.9 85.6-33.8 117.5L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5L180.2 153.3c31.9-31.9 76.6-43.1 117.5-33.8c12.6 2.9 26.4 .5 35.5-8.6l48.8-48.8 9.5-9.5c-10.6-12.6-10-31.4 1.9-43.2zM99.3 347.3l65.4 65.4c6.2 6.2 16.4 6.2 22.6 0l97.4-97.4c6.2-6.2 6.2-16.4 0-22.6l-65.4-65.4c-6.2-6.2-16.4-6.2-22.6 0L99.3 324.7c-6.2 6.2-6.2 16.4 0 22.6z"
                }
            }
        ]
    })(props);
}
function FaWineGlassEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 0C47.4 0 33.5 12.8 32.1 29.3l-14 168.4c-6 72 42.5 135.2 109.9 150.6V448H80c-17.7 0-32 14.3-32 32s14.3 32 32 32h80 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V348.4c67.4-15.4 115.9-78.6 109.9-150.6l-14-168.4C286.5 12.8 272.6 0 256 0H64zM81.9 203.1L93.4 64H226.6l11.6 139.1C242 248.8 205.9 288 160 288s-82-39.2-78.1-84.9z"
                }
            }
        ]
    })(props);
}
function FaWineGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.1 29.3C33.5 12.8 47.4 0 64 0H256c16.6 0 30.5 12.8 31.9 29.3l14 168.4c6 72-42.5 135.2-109.9 150.6V448h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H160 80c-17.7 0-32-14.3-32-32s14.3-32 32-32h48V348.4C60.6 333 12.1 269.8 18.1 197.8l14-168.4zm56 98.7H231.9l-5.3-64H93.4l-5.3 64z"
                }
            }
        ]
    })(props);
}
function FaWonSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M62.4 53.9C56.8 37.1 38.6 28.1 21.9 33.6S-3.9 57.4 1.6 74.1L51.6 224H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H72.9l56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288h46L321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H460.4l50-149.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2L392.9 224H329L287 56.2C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L183 224h-64L62.4 53.9zm78 234.1H167l-11.4 45.6L140.4 288zM249 224l7-28.1 7 28.1H249zm96 64h26.6l-15.2 45.6L345 288z"
                }
            }
        ]
    })(props);
}
function FaWorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96c0-53 43-96 96-96h38.4C439.9 0 480 40.1 480 89.6V176v16V376c0 75.1-60.9 136-136 136s-136-60.9-136-136V296c0-22.1-17.9-40-40-40s-40 17.9-40 40V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V296c0-75.1 60.9-136 136-136s136 60.9 136 136v80c0 22.1 17.9 40 40 40s40-17.9 40-40V192H352c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
                }
            }
        ]
    })(props);
}
function FaWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c88.4 0 160-71.6 160-160c0-15.3-2.2-30.1-6.2-44.2c-3.1-10.8-16.4-13.2-24.3-5.3l-76.8 76.8c-3 3-7.1 4.7-11.3 4.7H336c-8.8 0-16-7.2-16-16V118.6c0-4.2 1.7-8.3 4.7-11.3l76.8-76.8c7.9-7.9 5.4-21.2-5.3-24.3C382.1 2.2 367.3 0 352 0C263.6 0 192 71.6 192 160c0 19.1 3.4 37.5 9.5 54.5L19.9 396.1C7.2 408.8 0 426.1 0 444.1C0 481.6 30.4 512 67.9 512c18 0 35.3-7.2 48-19.9L297.5 310.5c17 6.2 35.4 9.5 54.5 9.5zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaXRay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32V416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32V96C14.3 96 0 81.7 0 64zM256 96c-8.8 0-16 7.2-16 16v32H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v48H128c-8.8 0-16 7.2-16 16s7.2 16 16 16H240v70.6L189.1 307c-5.2-2-10.6-3-16.2-3h-2.1c-23.6 0-42.8 19.2-42.8 42.8c0 9.6 3.2 18.9 9.1 26.4l18.2 23.2c9.7 12.4 24.6 19.6 40.3 19.6H316.4c15.7 0 30.6-7.2 40.3-19.6l18.2-23.2c5.9-7.5 9.1-16.8 9.1-26.4c0-23.6-19.2-42.8-42.8-42.8H339c-5.5 0-11 1-16.2 3L272 326.6V256H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V176h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V112c0-8.8-7.2-16-16-16zM208 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
                }
            }
        ]
    })(props);
}
function FaX(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
                }
            }
        ]
    })(props);
}
function FaXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                }
            }
        ]
    })(props);
}
function FaXmarksLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55L7 311c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55L41 167c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
                }
            }
        ]
    })(props);
}
function FaY(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3V448c0 17.7 14.3 32 32 32s32-14.3 32-32V298.3L378 82.6c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
                }
            }
        ]
    })(props);
}
function FaYenSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M58.6 46.2C48.8 31.5 29 27.6 14.3 37.4S-4.4 67 5.4 81.7L100.2 224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v32H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h80v64c0 17.7 14.3 32 32 32s32-14.3 32-32V384h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H192V288h80c17.7 0 32-14.3 32-32s-14.3-32-32-32H219.8L314.6 81.7c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L160 198.3 58.6 46.2z"
                }
            }
        ]
    })(props);
}
function FaYinYang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64c53 0 96 43 96 96s-43 96-96 96s-96 43-96 96s43 96 96 96C150 448 64 362 64 256S150 64 256 64zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm32-352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaZ(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64C0 46.3 14.3 32 32 32H352c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96H32C14.3 96 0 81.7 0 64z"
                }
            }
        ]
    })(props);
}
function FaRegAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H208zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM496 192c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"
                }
            }
        ]
    })(props);
}
function FaRegAddressCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80H176zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
                }
            }
        ]
    })(props);
}
function FaRegBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6C495.5 322.9 480 278.8 480 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V49.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zM221.7 148.4C239.6 117.1 273.3 96 312 96h8 8c57.4 0 104 46.6 104 104v33.4c0 32.7 6.4 64.8 18.7 94.5L221.7 148.4zM406.2 416l-60.9-48H168.3c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6H406.2zM384 448H320 256c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
                }
            }
        ]
    })(props);
}
function FaRegBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
                }
            }
        ]
    })(props);
}
function FaRegBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 48C0 21.5 21.5 0 48 0l0 48V441.4l130.1-92.9c8.3-6 19.6-6 27.9 0L336 441.4V48H48V0H336c26.5 0 48 21.5 48 48V488c0 9-5 17.2-13 21.3s-17.6 3.4-24.9-1.8L192 397.5 37.9 507.5c-7.3 5.2-16.9 5.9-24.9 1.8S0 497 0 488V48z"
                }
            }
        ]
    })(props);
}
function FaRegBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c13.3 0 24 10.7 24 24V64H296V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 144 128C0 92.7 28.7 64 64 64h40V24c0-13.3 10.7-24 24-24zM400 192H48V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V192zM329 297L217 409c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 95-95c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarDays(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zM328 352H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H96c-35.3 0-64 28.7-64 64v16 48V448c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H376V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H184V24zM80 192H432V448c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V192zm176 40c-13.3 0-24 10.7-24 24v48H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h48v48c0 13.3 10.7 24 24 24s24-10.7 24-24V352h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V256c0-13.3-10.7-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 0c13.3 0 24 10.7 24 24V64H328V24c0-13.3 10.7-24 24-24s24 10.7 24 24V64h40c35.3 0 64 28.7 64 64v16 48V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192 144 128c0-35.3 28.7-64 64-64h40V24c0-13.3 10.7-24 24-24zM432 192H80V448c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V192zm-95 89l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaRegCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"
                }
            }
        ]
    })(props);
}
function FaRegChartBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegChessBishop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 0C90.7 0 80 10.7 80 24c0 11.2 7.6 20.6 18 23.2c-7.8 8-16.1 17-24.4 27C38.2 116.7 0 178.8 0 250.9c0 44.8 24.6 72.2 48 87.8V352H96V325c0-9-5-17.2-13-21.3c-18-9.3-35-24.7-35-52.7c0-55.5 29.8-106.8 62.4-145.9c16-19.2 32.1-34.8 44.2-45.5c1.9-1.7 3.7-3.2 5.3-4.6c1.7 1.4 3.4 3 5.3 4.6c12.1 10.7 28.2 26.3 44.2 45.5c5.3 6.3 10.5 13 15.5 20L159 191c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57.8-57.8c12.8 25.9 21.2 54.3 21.2 83.8c0 28-17 43.4-35 52.7c-8 4.1-13 12.3-13 21.3v27h48V338.7c23.4-15.6 48-42.9 48-87.8c0-72.1-38.2-134.2-73.6-176.7c-8.3-9.9-16.6-19-24.4-27c10.3-2.7 18-12.1 18-23.2c0-13.3-10.7-24-24-24H160 104zM52.7 464l16.6-32H250.8l16.6 32H52.7zm207.9-80H59.5c-12 0-22.9 6.7-28.4 17.3L4.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C0 493.8 18.2 512 40.8 512H279.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3z"
                }
            }
        ]
    })(props);
}
function FaRegChessKing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V56H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h32v40H59.6C26.7 144 0 170.7 0 203.6c0 8.2 1.7 16.3 4.9 23.8L59.1 352h52.3L49 208.2c-.6-1.5-1-3-1-4.6c0-6.4 5.2-11.6 11.6-11.6H224 388.4c6.4 0 11.6 5.2 11.6 11.6c0 1.6-.3 3.2-1 4.6L336.5 352h52.3l54.2-124.6c3.3-7.5 4.9-15.6 4.9-23.8c0-32.9-26.7-59.6-59.6-59.6H248V104h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V24zM101.2 432H346.8l16.6 32H84.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3H91.5c-12 0-22.9 6.7-28.4 17.3L36.6 452.5c-3 5.8-4.6 12.2-4.6 18.7C32 493.8 50.2 512 72.8 512H375.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
                }
            }
        ]
    })(props);
}
function FaRegChessKnight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M226.6 48H117.3l17.1 12.8c6 4.5 9.6 11.6 9.6 19.2s-3.6 14.7-9.6 19.2l-6.5 4.9c-10 7.5-16 19.3-16 31.9l-.3 91c0 10.2 4.9 19.9 13.2 25.8l1.9 1.3c9.9 7.1 23.3 7 33.2-.1l49.9-36.3c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5l-49.9 36.3-53.8 39.1c-7.3 5.3-13 12.2-16.9 20.1H66.8c5.3-22.1 17.8-41.9 35.9-56.3c-1.3-.8-2.6-1.7-3.8-2.6L97 291.8c-21-15-33.4-39.2-33.3-65l.3-91c.1-19.8 6.7-38.7 18.6-53.9l-.4-.3C70.7 73 64 59.6 64 45.3C64 20.3 84.3 0 109.3 0H226.6C331.2 0 416 84.8 416 189.4c0 11.1-1 22.2-2.9 33.2L390.1 352H341.3l24.5-137.8c1.5-8.2 2.2-16.5 2.2-24.8C368 111.3 304.7 48 226.6 48zM85.2 432L68.7 464H379.3l-16.6-32H85.2zm315.7-30.7l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H56.8C34.2 512 16 493.8 16 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C52.5 390.7 63.5 384 75.5 384h297c12 0 22.9 6.7 28.4 17.3zM172 128a20 20 0 1 1 0 40 20 20 0 1 1 0-40z"
                }
            }
        ]
    })(props);
}
function FaRegChessPawn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 152A72 72 0 1 0 88 152a72 72 0 1 0 144 0zm24 120H243.4l10.7 80H205.7L195 272H160 125l-10.7 80H65.9l10.7-80H64c-13.3 0-24-10.7-24-24s10.7-24 24-24c-15.1-20.1-24-45-24-72C40 85.7 93.7 32 160 32s120 53.7 120 120c0 27-8.9 51.9-24 72c13.3 0 24 10.7 24 24s-10.7 24-24 24zM52.7 464H267.3l-16.6-32H69.2L52.7 464zm207.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H40.8C18.2 512 0 493.8 0 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C36.5 390.7 47.5 384 59.5 384h201z"
                }
            }
        ]
    })(props);
}
function FaRegChessQueen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-95.2-8c-18.1 0-31.3 12.8-35.6 26.9c-8 26.2-32.4 45.2-61.2 45.2c-10 0-19.4-2.3-27.7-6.3c-7.6-3.7-16.7-3.3-24 1.2C.7 162.1-3.1 177.1 3.7 188.9L97.6 352H153l-83-144.1c40.5-2.2 75.3-25.9 93.1-59.8c22 26.8 55.4 43.9 92.8 43.9s70.8-17.1 92.8-43.9c17.8 34 52.6 57.7 93.1 59.8L359 352h55.4l93.9-163.1c6.8-11.7 3-26.7-8.6-33.8c-7.3-4.5-16.4-4.9-24-1.2c-8.4 4-17.7 6.3-27.7 6.3c-28.8 0-53.2-19-61.2-45.2C382.5 100.8 369.3 88 351.2 88c-14.5 0-26.3 8.5-32.4 19.3c-12.4 22-35.9 36.7-62.8 36.7s-50.4-14.8-62.8-36.7C187.1 96.5 175.4 88 160.8 88zM133.2 432H378.8l16.6 32H116.7l16.6-32zm283.7-30.7c-5.5-10.6-16.5-17.3-28.4-17.3h-265c-12 0-22.9 6.7-28.4 17.3L68.6 452.5c-3 5.8-4.6 12.2-4.6 18.7c0 22.5 18.2 40.8 40.8 40.8H407.2c22.5 0 40.8-18.2 40.8-40.8c0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2z"
                }
            }
        ]
    })(props);
}
function FaRegChessRook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 80V192c0 2.5 1.2 4.9 3.2 6.4l51.2 38.4c6.8 5.1 10.4 13.4 9.5 21.9L133.5 352H85.2l9.4-85L54.4 236.8C40.3 226.2 32 209.6 32 192V72c0-22.1 17.9-40 40-40H376c22.1 0 40 17.9 40 40V192c0 17.6-8.3 34.2-22.4 44.8L353.4 267l9.4 85H314.5l-10.4-93.3c-.9-8.4 2.7-16.8 9.5-21.9l51.2-38.4c2-1.5 3.2-3.9 3.2-6.4V80H304v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H192v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V80H80zm4.7 384H363.3l-16.6-32H101.2L84.7 464zm271.9-80c12 0 22.9 6.7 28.4 17.3l26.5 51.2c3 5.8 4.6 12.2 4.6 18.7c0 22.5-18.2 40.8-40.8 40.8H72.8C50.2 512 32 493.8 32 471.2c0-6.5 1.6-12.9 4.6-18.7l26.5-51.2C68.5 390.7 79.5 384 91.5 384h265zM208 288c-8.8 0-16-7.2-16-16V224c0-17.7 14.3-32 32-32s32 14.3 32 32v48c0 8.8-7.2 16-16 16H208z"
                }
            }
        ]
    })(props);
}
function FaRegCircleCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                }
            }
        ]
    })(props);
}
function FaRegCircleDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
                }
            }
        ]
    })(props);
}
function FaRegCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 464a208 208 0 1 1 0-416 208 208 0 1 1 0 416zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM376.9 294.6c4.5-4.2 7.1-10.1 7.1-16.3c0-12.3-10-22.3-22.3-22.3H304V160c0-17.7-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32v96H150.3C138 256 128 266 128 278.3c0 6.2 2.6 12.1 7.1 16.3l107.1 99.9c3.8 3.5 8.7 5.5 13.8 5.5s10.1-2 13.8-5.5l107.1-99.9z"
                }
            }
        ]
    })(props);
}
function FaRegCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM217.4 376.9c4.2 4.5 10.1 7.1 16.3 7.1c12.3 0 22.3-10 22.3-22.3V304h96c17.7 0 32-14.3 32-32V240c0-17.7-14.3-32-32-32H256V150.3c0-12.3-10-22.3-22.3-22.3c-6.2 0-12.1 2.6-16.3 7.1L117.5 242.2c-3.5 3.8-5.5 8.7-5.5 13.8s2 10.1 5.5 13.8l99.9 107.1z"
                }
            }
        ]
    })(props);
}
function FaRegCirclePause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm224-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V184c0-13.3 10.7-24 24-24s24 10.7 24 24z"
                }
            }
        ]
    })(props);
}
function FaRegCirclePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9V168c0-8.7 4.7-16.7 12.3-20.9z"
                }
            }
        ]
    })(props);
}
function FaRegCircleQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaRegCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM294.6 135.1c-4.2-4.5-10.1-7.1-16.3-7.1C266 128 256 138 256 150.3V208H160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h96v57.7c0 12.3 10 22.3 22.3 22.3c6.2 0 12.1-2.6 16.3-7.1l99.9-107.1c3.5-3.8 5.5-8.7 5.5-13.8s-2-10.1-5.5-13.8L294.6 135.1z"
                }
            }
        ]
    })(props);
}
function FaRegCircleStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaRegCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM135.1 217.4c-4.5 4.2-7.1 10.1-7.1 16.3c0 12.3 10 22.3 22.3 22.3H208v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V256h57.7c12.3 0 22.3-10 22.3-22.3c0-6.2-2.6-12.1-7.1-16.3L269.8 117.5c-3.8-3.5-8.7-5.5-13.8-5.5s-10.1 2-13.8 5.5L135.1 217.4z"
                }
            }
        ]
    })(props);
}
function FaRegCircleUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
                }
            }
        ]
    })(props);
}
function FaRegCircleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
                }
            }
        ]
    })(props);
}
function FaRegCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                }
            }
        ]
    })(props);
}
function FaRegClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 64h40c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128C0 92.7 28.7 64 64 64h40 9.6C121 27.5 153.3 0 192 0s71 27.5 78.4 64H280zM64 112c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H304v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112H64zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
                }
            }
        ]
    })(props);
}
function FaRegClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
                }
            }
        ]
    })(props);
}
function FaRegClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464H288c8.8 0 16-7.2 16-16V384h48v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM224 304H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H224c-8.8 0-16 7.2-16 16V288c0 8.8 7.2 16 16 16zm-64-16V64c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V288c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"
                }
            }
        ]
    })(props);
}
function FaRegClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM200 208c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48s21.5-48 48-48zm144 48c0-26.5 21.5-48 48-48c14.2 0 27 6.1 35.8 16c8.8 9.9 24 10.7 33.9 1.9s10.7-24 1.9-33.9c-17.5-19.6-43.1-32-71.5-32c-53 0-96 43-96 96s43 96 96 96c28.4 0 54-12.4 71.5-32c8.8-9.9 8-25-1.9-33.9s-25-8-33.9 1.9c-8.8 9.9-21.6 16-35.8 16c-26.5 0-48-21.5-48-48z"
                }
            }
        ]
    })(props);
}
function FaRegCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM144 272a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaRegComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"
                }
            }
        ]
    })(props);
}
function FaRegComments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"
                }
            }
        ]
    })(props);
}
function FaRegCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm306.7 69.1L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaRegCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"
                }
            }
        ]
    })(props);
}
function FaRegCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM199.4 312.6c-31.2-31.2-31.2-81.9 0-113.1s81.9-31.2 113.1 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-50-50-131-50-181 0s-50 131 0 181s131 50 181 0c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-31.2 31.2-81.9 31.2-113.1 0z"
                }
            }
        ]
    })(props);
}
function FaRegCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"
                }
            }
        ]
    })(props);
}
function FaRegEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.4-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaRegEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
                }
            }
        ]
    })(props);
}
function FaRegEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm9.4 130.3C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5l-41.9-33zM192 256c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5z"
                }
            }
        ]
    })(props);
}
function FaRegEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
                }
            }
        ]
    })(props);
}
function FaRegFaceAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.4-118.5c9.7-9 10.2-24.2 1.2-33.9C315.3 344.3 290.6 328 256 328s-59.3 16.3-73.5 31.6c-9 9.7-8.5 24.9 1.2 33.9s24.9 8.5 33.9-1.2c7.4-7.9 20-16.4 38.5-16.4s31.1 8.5 38.5 16.4c9 9.7 24.2 10.2 33.9 1.2zM176.4 272c17.7 0 32-14.3 32-32c0-1.5-.1-3-.3-4.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l30.7 10.2c-5.8 5.8-9.3 13.8-9.3 22.6c0 17.7 14.3 32 32 32zm192-32c0-8.9-3.6-17-9.5-22.8l30.2-10.1c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l11.7-3.9c-.2 1.5-.3 3.1-.3 4.7c0 17.7 14.3 32 32 32s32-14.3 32-32z"
                }
            }
        ]
    })(props);
}
function FaRegFaceDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM103 135c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9zm192 0c9.4-9.4 24.6-9.4 33.9 0l23 23 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-23 23 23 23c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l23-23-23-23c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaRegFaceFlushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM160.4 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 336c-13.3 0-24 10.7-24 24s10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192zM160 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm144-80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceFrownOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4c16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4c-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM174.6 384.1c-4.5 12.5-18.2 18.9-30.7 14.4s-18.9-18.2-14.4-30.7C146.9 319.4 198.9 288 256 288s109.1 31.4 126.6 79.9c4.5 12.5-2 26.2-14.4 30.7s-26.2-2-30.7-14.4C328.2 358.5 297.2 336 256 336s-72.2 22.5-81.4 48.1zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM168 320c-13.3 0-24 10.7-24 24s10.7 24 24 24h8V320h-8zm40 48h32V320H208v48zm96 0V320H272v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zM168 288H344c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-23.6-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinBeamSweat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 126.3C497.1 120.8 512 102.7 512 81c0-20-28.6-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0c-9.5 12.6-27.1 37.2-36 57.5c-.3 .7-.6 1.4-.9 2.1C417.8 69.7 416 76 416 81c0 26 21.5 47 48 47c4.4 0 8.7-.6 12.8-1.7zM395.4 41.2C355.3 15.2 307.4 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-35.8-7.3-69.9-20.6-100.8c-8.6 3.1-17.8 4.8-27.4 4.8c-8.9 0-17.6-1.5-25.7-4.2C454.7 185.5 464 219.7 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c48.7 0 93.4 16.7 128.9 44.7c-.6-3.8-.9-7.7-.9-11.7c0-11.4 3.8-22.4 7.1-30.5c1.3-3.1 2.7-6.2 4.3-9.3zM375 336.5c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5zM217.6 228.8l0 0 0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C126.7 188.4 120 206.1 120 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0zm160 0l0 0 0 0c2.1 2.8 5.7 3.9 8.9 2.8s5.5-4.1 5.5-7.6c0-17.9-6.7-35.6-16.6-48.8c-9.8-13-23.9-23.2-39.4-23.2s-29.6 10.2-39.4 23.2C286.7 188.4 280 206.1 280 224c0 3.4 2.2 6.5 5.5 7.6s6.9 0 8.9-2.8l0 0 0 0 0 0 .2-.2c.2-.2 .4-.5 .7-.9c.6-.8 1.6-2 2.8-3.4c2.5-2.8 6-6.6 10.2-10.3c8.8-7.8 18.8-14 27.7-14s18.9 6.2 27.7 14c4.2 3.7 7.7 7.5 10.2 10.3c1.2 1.4 2.2 2.6 2.8 3.4c.3 .4 .6 .7 .7 .9l.2 .2 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM217.6 228.8l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM215.3 137.1c17.8 4.8 28.4 23.1 23.6 40.8l-17.4 65c-2.3 8.5-11.1 13.6-19.6 11.3l-65.1-17.4c-17.8-4.8-28.4-23.1-23.6-40.8s23.1-28.4 40.8-23.6l16.1 4.3 4.3-16.1c4.8-17.8 23.1-28.4 40.8-23.6zm122.3 23.6l4.3 16.1 16.1-4.3c17.8-4.8 36.1 5.8 40.8 23.6s-5.8 36.1-23.6 40.8l-65.1 17.4c-8.5 2.3-17.3-2.8-19.6-11.3l-17.4-65c-4.8-17.8 5.8-36.1 23.6-40.8s36.1 5.8 40.9 23.6z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinSquintTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M426.8 14.2C446-5 477.5-4.6 497.1 14.9s20 51 .7 70.3c-14.8 14.8-65.7 23.6-88.3 26.7c-5.6 .9-10.3-3.9-9.5-9.5C403.3 79.9 412 29 426.8 14.2zM75 75C158.2-8.3 284.5-22.2 382.2 33.2c-1.5 4.8-2.9 9.6-4.1 14.3c-3.1 12.2-5.5 24.6-7.3 35c-80.8-53.6-190.7-44.8-261.9 26.4C37.7 180.1 28.9 290 82.5 370.8c-10.5 1.8-22.9 4.2-35 7.3c-4.7 1.2-9.5 2.5-14.3 4.1C-22.2 284.5-8.2 158.2 75 75zm389.6 58.9c4.7-1.2 9.5-2.5 14.3-4.1C534.2 227.5 520.2 353.8 437 437c-83.2 83.2-209.5 97.2-307.2 41.8c1.5-4.8 2.8-9.6 4-14.3c3.1-12.2 5.5-24.6 7.3-35c80.8 53.6 190.7 44.8 261.9-26.4c71.2-71.2 80-181.1 26.4-261.9c10.5-1.8 22.9-4.2 35-7.3zm-105.4 93c10.1-16.3 33.9-16.9 37.9 1.9c9.5 44.4-3.7 93.5-39.3 129.1s-84.8 48.8-129.1 39.3c-18.7-4-18.2-27.8-1.9-37.9c25.2-15.7 50.2-35.4 73.6-58.8s43.1-48.4 58.8-73.6zM92 265.3l97.4-29.7c11.6-3.5 22.5 7.3 19 19l-29.7 97.4c-2.6 8.6-13.4 11.3-19.8 4.9c-2-2-3.2-4.6-3.4-7.3l-5.1-56.1-56.1-5.1c-2.8-.3-5.4-1.5-7.3-3.4c-6.3-6.3-3.6-17.2 4.9-19.8zm193-178.2c2 2 3.2 4.6 3.4 7.3l5.1 56.1 56.1 5.1c2.8 .3 5.4 1.5 7.3 3.4c6.3 6.3 3.6 17.2-4.9 19.8l-97.4 29.7c-11.6 3.5-22.5-7.3-19-19L265.3 92c2.6-8.6 13.4-11.3 19.8-4.9zM14.9 497.1c-19.6-19.6-20-51-.7-70.3C29 412 79.8 403.2 102.4 400.1c5.6-.9 10.3 3.9 9.5 9.5c-3.2 22.5-11.9 73.5-26.7 88.3C66 517 34.5 516.6 14.9 497.1z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zm-216-161.7l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM183.2 132.6c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L176 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L242.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm160 0c-1.3-2.8-4.1-4.6-7.2-4.6s-5.9 1.8-7.2 4.6l-16.6 34.7-38.1 5c-3.1 .4-5.6 2.5-6.6 5.5s-.1 6.2 2.1 8.3l27.9 26.5-7 37.8c-.6 3 .7 6.1 3.2 7.9s5.8 2 8.5 .6L336 240.5l33.8 18.3c2.7 1.5 6 1.3 8.5-.6s3.7-4.9 3.2-7.9l-7-37.8L402.4 186c2.2-2.1 3.1-5.3 2.1-8.3s-3.5-5.1-6.6-5.5l-38.1-5-16.6-34.7zm6.3 175.8c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c24.6 38.1 68.7 63.5 119.1 63.5s94.5-25.4 119.1-63.5c10.4-16.1-6.8-32.5-25.5-28.1z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M516.1 325.5c1 3 2.1 6 3.3 8.9c3.3 8.1 8.4 18.5 16.5 26.6c3.9 3.9 8.2 7.4 12.7 10.3C506.4 454.8 419.9 512 320 512s-186.4-57.2-228.6-140.6c4.5-2.9 8.7-6.3 12.7-10.3c8.1-8.1 13.2-18.6 16.5-26.6c1.2-2.9 2.3-5.9 3.3-8.9C152.5 406.2 229.5 464 320 464s167.5-57.8 196.1-138.5zM320 48c-101.4 0-185.8 72.5-204.3 168.5c-6.7-3.1-14.3-4.3-22.3-3.1c-6.8 .9-16.2 2.4-26.6 4.4C85.3 94.5 191.6 0 320 0S554.7 94.5 573.2 217.7c-10.3-2-19.8-3.5-26.6-4.4c-8-1.2-15.7 .1-22.3 3.1C505.8 120.5 421.4 48 320 48zM78.5 341.1C60 356.7 32 355.5 14.3 337.7c-18.7-18.7-19.1-48.8-.7-67.2c8.6-8.6 30.1-15.1 50.5-19.6c13-2.8 25.5-4.8 33.9-6c5.4-.8 9.9 3.7 9 9c-3.1 21.5-11.4 70.2-25.5 84.4c-.9 1-1.9 1.8-2.9 2.7zm483 0c-.8-.6-1.5-1.3-2.3-2c-.2-.2-.5-.4-.7-.7c-14.1-14.1-22.5-62.9-25.5-84.4c-.8-5.4 3.7-9.9 9-9c1 .1 2.2 .3 3.3 .5c8.2 1.2 19.2 3 30.6 5.5c20.4 4.4 41.9 10.9 50.5 19.6c18.4 18.4 18 48.5-.7 67.2c-17.7 17.7-45.7 19-64.2 3.4zM439 336.5C414.4 374.6 370.3 400 319.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1zM281.6 228.8l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0zm160 0l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinTongueSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V392.7c-24-17.5-43.1-41.4-54.8-69.2c-5-11.8 7-22.5 19.3-18.7c39.7 12.2 84.5 19 131.8 19s92.1-6.8 131.8-19c12.3-3.8 24.3 6.9 19.3 18.7c-11.8 28-31.1 52-55.4 69.6V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm116-98.9c0-9 9.6-14.7 17.5-10.5l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6zm262.5-10.5c7.9-4.2 17.5 1.5 17.5 10.5c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinTongueWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348.3 442.4c2.4-8.4 3.7-17.3 3.7-26.4V363.5c8.8-8 16.6-17.1 23-27c10.4-16.1-6.8-32.5-25.5-28.1c-28.9 6.8-60.5 10.5-93.6 10.5s-64.7-3.7-93.6-10.5c-18.7-4.4-35.9 12-25.5 28.1c6.5 10 14.3 19.1 23.1 27.1V416c0 9.2 1.3 18 3.7 26.4C95.1 408.4 48 337.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 81.7-47.1 152.4-115.7 186.4zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm176.7 12a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-.4-72a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM320 416c0 35.3-28.7 64-64 64s-64-28.7-64-64V378.6c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9c2.8 12.6 20.8 12.6 23.6 0c2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 81.7 47.1 152.4 115.7 186.4c-2.4-8.4-3.7-17.3-3.7-26.4V363.6c-8.9-8-16.7-17.1-23.1-27.1c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5c18.7-4.4 35.9 12 25.5 28.1c-6.4 9.9-14.2 19-23 27V416c0 9.2-1.3 18-3.7 26.4C416.9 408.4 464 337.7 464 256zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 416V378.6c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9c-2.8 12.6-20.8 12.6-23.6 0c-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM224 192c0 35.3-14.3 64-32 64s-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64zm96 64c-17.7 0-32-28.7-32-64s14.3-64 32-64s32 28.7 32 64s-14.3 64-32 64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrinWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
                }
            }
        ]
    })(props);
}
function FaRegFaceGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm349.5 52.4c18.7-4.4 35.9 12 25.5 28.1C350.4 374.6 306.3 400 255.9 400s-94.5-25.4-119.1-63.5c-10.4-16.1 6.8-32.5 25.5-28.1c28.9 6.8 60.5 10.5 93.6 10.5s64.7-3.7 93.6-10.5zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceKissBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 41.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 427.1 257.4 432 240 432c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zm-87.1-68.9l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceKissWinkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M338.9 446.8c-25.4 11-53.4 17.2-82.9 17.2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 22.4-3.5 43.9-10.1 64.1c3.1 4.5 5.7 9.4 7.8 14.6c12.7-1.6 25.1 .4 36.2 5c9.1-26.2 14-54.4 14-83.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c35.4 0 69.1-7.2 99.7-20.2c-4.8-5.5-8.5-12.2-10.4-19.7l-6.5-25.3zM296 316c0-6.9-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4C258.7 276.9 241.4 272 224 272c-3.6 0-6.8 2.5-7.7 6s.6 7.2 3.8 9l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0 0 0c-2.5 1.4-4.1 4.1-4.1 7s1.6 5.6 4.1 7l0 0 0 0 0 0 .2 .1c.2 .1 .5 .3 .9 .5c.8 .5 2 1.2 3.4 2.1c2.8 1.9 6.5 4.5 10.2 7.6c3.7 3.1 7.2 6.6 9.6 10.1c2.5 3.5 3.5 6.4 3.5 8.6s-1 5-3.5 8.6c-2.5 3.5-5.9 6.9-9.6 10.1c-3.7 3.1-7.4 5.7-10.2 7.6c-1.4 .9-2.6 1.6-3.4 2.1c-.4 .2-.7 .4-.9 .5l-.2 .1 0 0 0 0 0 0 0 0c-3.2 1.8-4.7 5.5-3.8 9s4.1 6 7.7 6c17.4 0 34.7-4.9 47.9-12.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3s-3.1-13.2-7.3-18.3c-4.3-5.2-10.1-9.7-16.7-13.4c-2.7-1.5-5.7-3-8.7-4.3c3.1-1.3 6-2.7 8.7-4.3c6.6-3.7 12.5-8.2 16.7-13.4c4.3-5.1 7.3-11.4 7.3-18.3zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm159.3-20c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C375.7 186.8 355 180 335.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zM434 352.3c-6-23.2-28.8-37-51.1-30.8s-35.4 30.1-29.5 53.4l22.9 89.3c2.2 8.7 11.2 13.9 19.8 11.4l84.9-23.8c22.2-6.2 35.4-30.1 29.5-53.4s-28.8-37-51.1-30.8l-20.2 5.6-5.4-21z"
                }
            }
        ]
    })(props);
}
function FaRegFaceKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm304.7 25.7c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4c-2.7 1.5-5.7 3-8.7 4.3c3.1 1.3 6 2.7 8.7 4.3c6.6 3.7 12.5 8.2 16.7 13.4c4.3 5.1 7.3 11.4 7.3 18.3s-3.1 13.2-7.3 18.3c-4.3 5.2-10.1 9.7-16.7 13.4C274.7 411.1 257.4 416 240 416c-3.6 0-6.8-2.5-7.7-6s.6-7.2 3.8-9l0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1l-.8-.5-.1-.1-.2-.1 0 0 0 0 0 0c-2.5-1.4-4.1-4.1-4.1-7s1.6-5.6 4.1-7l0 0 0 0 0 0 0 0 0 0 .2-.1c.2-.1 .5-.3 .9-.5c.8-.5 2-1.2 3.4-2.1c2.8-1.9 6.5-4.5 10.2-7.6c3.7-3.1 7.2-6.6 9.6-10.1c2.5-3.5 3.5-6.4 3.5-8.6s-1-5-3.5-8.6c-2.5-3.5-5.9-6.9-9.6-10.1c-3.7-3.1-7.4-5.7-10.2-7.6c-1.4-.9-2.6-1.6-3.4-2.1c-.4-.2-.7-.4-.9-.5l-.2-.1 0 0 0 0 0 0c-3.2-1.8-4.7-5.5-3.8-9s4.1-6 7.7-6c17.4 0 34.7 4.9 47.9 12.3c6.6 3.7 12.5 8.2 16.7 13.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceLaughBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm86.9-85.1l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceLaughSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zm2.8-183.3l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 141.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                }
            }
        ]
    })(props);
}
function FaRegFaceLaughWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
                }
            }
        ]
    })(props);
}
function FaRegFaceLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm130.7 57.9c-4.2-13.6 7.1-25.9 21.3-25.9H364.5c14.2 0 25.5 12.4 21.3 25.9C369 368.4 318.2 408 258.2 408s-110.8-39.6-127.5-94.1zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zM512 256A256 256 0 1 1 0 256a256 256 0 1 1 512 0zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"
                }
            }
        ]
    })(props);
}
function FaRegFaceRollingEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 376c0 13.3 10.7 24 24 24H320c13.3 0 24-10.7 24-24s-10.7-24-24-24H192c-13.3 0-24 10.7-24 24zm-8-104c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm192-32c-26.5 0-48-21.5-48-48c0-14.3 6.3-27.2 16.2-36c-.2 1.3-.2 2.6-.2 4c0 17.7 14.3 32 32 32s32-14.3 32-32c0-1.4-.1-2.7-.2-4c10 8.8 16.2 21.7 16.2 36c0 26.5-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
                }
            }
        ]
    })(props);
}
function FaRegFaceSadCry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 406.1V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V440.6c-28.7 15-61.4 23.4-96 23.4s-67.3-8.5-96-23.4V288c0-13.3-10.7-24-24-24s-24 10.7-24 24V406.1C72.6 368.2 48 315 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 59-24.6 112.2-64 150.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM159.6 220c10.6 0 19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C199.7 186.8 179 180 159.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9c5.5-5.8 14.8-9.7 25.4-9.7zm166.6 9.7c5.5-5.8 14.8-9.7 25.4-9.7s19.9 3.8 25.4 9.7c7.6 8.1 20.2 8.5 28.3 .9s8.5-20.2 .9-28.3C391.7 186.8 371 180 351.6 180s-40.1 6.8-54.6 22.3c-7.6 8.1-7.1 20.7 .9 28.3s20.7 7.1 28.3-.9zM208 320v32c0 26.5 21.5 48 48 48s48-21.5 48-48V320c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
                }
            }
        ]
    })(props);
}
function FaRegFaceSadTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M175.9 448c-35-.1-65.5-22.6-76-54.6C67.6 356.8 48 308.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208s-93.1 208-208 208c-28.4 0-55.5-5.7-80.1-16zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM128 369c0 26 21.5 47 48 47s48-21 48-47c0-20-28.4-60.4-41.6-77.7c-3.2-4.4-9.6-4.4-12.8 0C156.6 308.6 128 349 128 369zm128-65c-13.3 0-24 10.7-24 24s10.7 24 24 24c30.7 0 58.7 11.5 80 30.6c9.9 8.8 25 8 33.9-1.9s8-25-1.9-33.9C338.3 320.2 299 304 256 304zm47.6-96a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm-128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceSmileBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zm40-89.3l0 0 0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0zm160 0l0 0-.2-.2c-.2-.2-.4-.5-.7-.9c-.6-.8-1.6-2-2.8-3.4c-2.5-2.8-6-6.6-10.2-10.3c-8.8-7.8-18.8-14-27.7-14s-18.9 6.2-27.7 14c-4.2 3.7-7.7 7.5-10.2 10.3c-1.2 1.4-2.2 2.6-2.8 3.4c-.3 .4-.6 .7-.7 .9l-.2 .2 0 0 0 0 0 0c-2.1 2.8-5.7 3.9-8.9 2.8s-5.5-4.1-5.5-7.6c0-17.9 6.7-35.6 16.6-48.8c9.8-13 23.9-23.2 39.4-23.2s29.6 10.2 39.4 23.2c9.9 13.2 16.6 30.9 16.6 48.8c0 3.4-2.2 6.5-5.5 7.6s-6.9 0-8.9-2.8l0 0 0 0 0 0z"
                }
            }
        ]
    })(props);
}
function FaRegFaceSmileWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm165.8 21.7c-7.6 8.1-20.2 8.5-28.3 .9s-8.5-20.2-.9-28.3c14.5-15.5 35.2-22.3 54.6-22.3s40.1 6.8 54.6 22.3c7.6 8.1 7.1 20.7-.9 28.3s-20.7 7.1-28.3-.9c-5.5-5.8-14.8-9.7-25.4-9.7s-19.9 3.8-25.4 9.7z"
                }
            }
        ]
    })(props);
}
function FaRegFaceSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
                }
            }
        ]
    })(props);
}
function FaRegFaceSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                }
            }
        ]
    })(props);
}
function FaRegFaceTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.5 64.3C196.1 302.1 223.8 288 256 288s59.9 14.1 79.5 32.3C354.5 338.1 368 362 368 384c0 5.4-2.7 10.4-7.2 13.4s-10.2 3.4-15.2 1.3l-17.2-7.5c-22.8-10-47.5-15.1-72.4-15.1s-49.6 5.2-72.4 15.1l-17.2 7.5c-4.9 2.2-10.7 1.7-15.2-1.3s-7.2-8-7.2-13.4c0-22 13.5-45.9 32.5-63.7zm-43-173.6l89.9 47.9c10.7 5.7 10.7 21.1 0 26.8l-89.9 47.9c-7.9 4.2-17.5-1.5-17.5-10.5c0-2.8 1-5.5 2.8-7.6l36-43.2-36-43.2c-1.8-2.1-2.8-4.8-2.8-7.6c0-9 9.6-14.7 17.5-10.5zM396 157.1c0 2.8-1 5.5-2.8 7.6l-36 43.2 36 43.2c1.8 2.1 2.8 4.8 2.8 7.6c0 9-9.6 14.7-17.5 10.5l-89.9-47.9c-10.7-5.7-10.7-21.1 0-26.8l89.9-47.9c7.9-4.2 17.5 1.5 17.5 10.5z"
                }
            }
        ]
    })(props);
}
function FaRegFileAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 272V400c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L129.4 376H112c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h17.4l35.3-35.3c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8zm85.8-4c11.6 20 18.2 43.3 18.2 68s-6.6 48-18.2 68c-6.6 11.5-21.3 15.4-32.8 8.8s-15.4-21.3-8.8-32.8c7.5-12.9 11.8-27.9 11.8-44s-4.3-31.1-11.8-44c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8z"
                }
            }
        ]
    })(props);
}
function FaRegFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm97 289c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L79 303c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 31-31zM257 255c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48z"
                }
            }
        ]
    })(props);
}
function FaRegFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
                }
            }
        ]
    })(props);
}
function FaRegFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm69.2 46.9c-3-4.3-7.9-6.9-13.2-6.9s-10.2 2.6-13.2 6.9l-41.3 59.7-11.9-19.1c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5l-40 64c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2h48 32 40 72c6 0 11.4-3.3 14.2-8.6s2.4-11.6-1-16.5l-72-104z"
                }
            }
        ]
    })(props);
}
function FaRegFileLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"
                }
            }
        ]
    })(props);
}
function FaRegFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"
                }
            }
        ]
    })(props);
}
function FaRegFilePowerpoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24V336v56c0 13.3 10.7 24 24 24s24-10.7 24-24V360h44c42 0 76-34 76-76s-34-76-76-76H136zm68 104H160V256h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
                }
            }
        ]
    })(props);
}
function FaRegFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"
                }
            }
        ]
    })(props);
}
function FaRegFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
                }
            }
        ]
    })(props);
}
function FaRegFileZipper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16h48v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm48 112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm-6.3 71.8L82.1 335.9c-1.4 5.4-2.1 10.9-2.1 16.4c0 35.2 28.8 63.7 64 63.7s64-28.5 64-63.7c0-5.5-.7-11.1-2.1-16.4l-23.5-88.2c-3.7-14-16.4-23.8-30.9-23.8H136.6c-14.5 0-27.2 9.7-30.9 23.8zM128 336h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaRegFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
                }
            }
        ]
    })(props);
}
function FaRegFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24V64 350.5 400v88c0 13.3 10.7 24 24 24s24-10.7 24-24V388l80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52V24zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8V334.7l-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5v-237z"
                }
            }
        ]
    })(props);
}
function FaRegFloppyDisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                }
            }
        ]
    })(props);
}
function FaRegFolderClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.7 127.6l0 0c10.5 10.5 24.7 16.4 39.6 16.4H448c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H197.5c4.2 0 8.3 1.7 11.3 4.7l33.9-33.9L208.8 84.7l42.9 42.9zM48 240H464V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V240zM285.7 93.7L242.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.3c-2.1 0-4.2-.8-5.7-2.3z"
                }
            }
        ]
    })(props);
}
function FaRegFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480h48c11.4 0 21.9-6 27.6-15.9l112-192c5.8-9.9 5.8-22.1 .1-32.1S555.5 224 544 224H144c-11.4 0-21.9 6-27.6 15.9L48 357.1V96c0-8.8 7.2-16 16-16H181.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c21 21 49.5 32.8 79.2 32.8H416c8.8 0 16 7.2 16 16v32h48V160c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7L226.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H87.7 384z"
                }
            }
        ]
    })(props);
}
function FaRegFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"
                }
            }
        ]
    })(props);
}
function FaRegFontAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V456c0 13.3 10.7 24 24 24s24-10.7 24-24V124.2l12.5-2.4c16.7-3.2 31.5-8.5 44.2-13.1l0 0 0 0c3.7-1.3 7.1-2.6 10.4-3.7c15.2-5.2 30.4-9.1 51.2-9.1c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c32.4 0 53.7-6.8 90.5-19.6V342.9l-9.5 3.3c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-16.8 0-31 2-43.9 5c-12.9 3-20.9 16-17.9 28.9s16 20.9 28.9 17.9c9.6-2.2 20.1-3.7 32.9-3.7c25.6 0 43 6 63.5 13.3l.5 .2c20.9 7.4 44.8 15.9 79.1 15.9c34.4 0 56.4-7.7 97.8-22.2c7.5-2.6 15.5-5.4 24.4-8.5l16.2-5.5V360 72 38.4L416.2 49.3c-9.7 3.3-18.2 6.3-25.7 8.9c-41.5 14.4-55.2 19.2-81 19.2c-25.7 0-43.1-6-63.6-13.3l-.6-.2c-20.8-7.4-44.8-15.8-79-15.8c-27.8 0-48.5 5.5-66.6 11.6c-4.9 1.7-9.3 3.3-13.6 4.8c-11.9 4.3-22 7.9-34.7 10.3L48 75.4V56z"
                }
            }
        ]
    })(props);
}
function FaRegFutbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M435.4 361.3l-89.7-6c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-22 87.2c-14.4 3.2-29.4 4.8-44.8 4.8s-30.3-1.7-44.8-4.8l-22-87.2c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-89.7 6C61.7 335.9 51.9 307 49 276.2L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15L100.4 118c19.9-22.4 44.6-40.5 72.4-52.7l69.1 57.6c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l69.1-57.6c27.8 12.2 52.5 30.3 72.4 52.7l-33.4 83.4c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9L463 276.2c-3 30.8-12.7 59.7-27.6 85.1zM256 48l.9 0h-1.8l.9 0zM56.7 196.2c.9-3 1.9-6.1 2.9-9.1l-2.9 9.1zM132 423l3.8 2.7c-1.3-.9-2.5-1.8-3.8-2.7zm248.1-.1c-1.3 1-2.7 2-4 2.9l4-2.9zm75.2-226.6l-3-9.2c1.1 3 2.1 6.1 3 9.2zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
                }
            }
        ]
    })(props);
}
function FaRegGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.5 72L256 165l87.5-93h-175zM383.9 99.1L311.5 176h129L383.9 99.1zm50 124.9H256 78.1L256 420.3 433.9 224zM71.5 176h129L128.1 99.1 71.5 176zm434.3 40.1l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152c4.5-6.1 11.7-9.8 19.3-9.8H376c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4z"
                }
            }
        ]
    })(props);
}
function FaRegHandBackFist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16c0 9.1 5.1 17.4 13.3 21.5s17.9 3.2 25.1-2.3c2.7-2 6-3.2 9.6-3.2c8.8 0 16 7.2 16 16V264c0 31.3-20 58-48 67.9c-9.6 3.4-16 12.5-16 22.6V488c0 13.3 10.7 24 24 24s24-10.7 24-24V370.2c38-20.1 64-60.1 64-106.2V160c0-35.3-28.7-64-64-64c-2.8 0-5.6 .2-8.3 .5C332.8 77.1 311.9 64 288 64c-2.8 0-5.6 .2-8.3 .5C268.8 45.1 247.9 32 224 32c-2.8 0-5.6 .2-8.3 .5C204.8 13.1 183.9 0 160 0C124.7 0 96 28.7 96 64v64.3c-11.7 7.4-22.5 16.4-32 26.9l17.8 16.1L64 155.2l-9.4 10.5C40 181.8 32 202.8 32 224.6v12.8c0 49.6 24.2 96.1 64.8 124.5l13.8-19.7L96.8 361.9l8.9 6.2c6.9 4.8 14.4 8.6 22.3 11.3V488c0 13.3 10.7 24 24 24s24-10.7 24-24V359.9c0-12.6-9.8-23.1-22.4-23.9c-7.3-.5-14.3-2.9-20.3-7.1l-13.1 18.7 13.1-18.7-8.9-6.2C96.6 303.1 80 271.3 80 237.4V224.6c0-9.9 3.7-19.4 10.3-26.8l9.4-10.5c3.8-4.2 7.9-8.1 12.3-11.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16V142.3 128 64z"
                }
            }
        ]
    })(props);
}
function FaRegHandLizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 112c-13.3 0-24 10.7-24 24s10.7 24 24 24H240c35.3 0 64 28.7 64 64s-28.7 64-64 64H136c-13.3 0-24 10.7-24 24s10.7 24 24 24H288c4.5 0 8.9 1.3 12.7 3.6l64 40c7 4.4 11.3 12.1 11.3 20.4v24c0 13.3-10.7 24-24 24s-24-10.7-24-24V413.3L281.1 384H136c-39.8 0-72-32.2-72-72s32.2-72 72-72H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H72c-39.8 0-72-32.2-72-72S32.2 64 72 64H281.6c46.7 0 90.9 21.5 119.7 58.3l78.4 100.1c20.9 26.7 32.3 59.7 32.3 93.7V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V316.1c0-23.2-7.8-45.8-22.1-64.1L363.5 151.9c-19.7-25.2-49.9-39.9-81.9-39.9H72z"
                }
            }
        ]
    })(props);
}
function FaRegHandPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.8 1.4c-35.2-3.7-66.6 21.8-70.3 57L174 119 156.7 69.6C145 36.3 108.4 18.8 75.1 30.5S24.2 78.8 35.9 112.1L88.7 262.2C73.5 276.7 64 297.3 64 320v0 24c0 92.8 75.2 168 168 168h48c92.8 0 168-75.2 168-168V272 256 224c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4c-10.4-21.3-32.3-36-57.6-36c-.7 0-1.5 0-2.2 0l5.9-56.3c3.7-35.2-21.8-66.6-57-70.3zm-.2 155.4C243.9 166.9 240 179 240 192v48c0 .7 0 1.4 0 2c-5.1-1.3-10.5-2-16-2h-7.4l-5.4-15.3 17-161.3c.9-8.8 8.8-15.2 17.6-14.2s15.2 8.8 14.2 17.6l-9.5 90.1zM111.4 85.6L165.7 240H144c-4 0-8 .3-11.9 .9L81.2 96.2c-2.9-8.3 1.5-17.5 9.8-20.4s17.5 1.5 20.4 9.8zM288 192c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16c0 8.8-7.2 16-16 16s-16-7.2-16-16V192zm38.4 108c10.4 21.3 32.3 36 57.6 36c5.5 0 10.9-.7 16-2v10c0 66.3-53.7 120-120 120H232c-66.3 0-120-53.7-120-120l0-24 0 0c0-17.7 14.3-32 32-32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H184c-13.3 0-24 10.7-24 24s10.7 24 24 24h40c35.3 0 64-28.7 64-64c0-.7 0-1.4 0-2c5.1 1.3 10.5 2 16 2c7.9 0 15.4-1.4 22.4-4zM400 272c0 8.8-7.2 16-16 16s-16-7.2-16-16V240 224c0-8.8 7.2-16 16-16s16 7.2 16 16v32 16z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 448l0-177.6c5.2 1 10.5 1.6 16 1.6l16 0 0 32 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16zM80 224c-17.7 0-32-14.3-32-32c0 0 0 0 0 0l0-24c0-66.3 53.7-120 120-120l48 0c52.5 0 97.1 33.7 113.4 80.7c-3.1-.5-6.2-.7-9.4-.7c-20 0-37.9 9.2-49.7 23.6c-9-4.9-19.4-7.6-30.3-7.6c-15.1 0-29 5.3-40 14c-11-8.8-24.9-14-40-14l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-40 0-40 0zM0 192s0 0 0 0c0 18 6 34.6 16 48l0 208c0 35.3 28.7 64 64 64s64-28.7 64-64l0-82c5.1 1.3 10.5 2 16 2c25.3 0 47.2-14.7 57.6-36c7 2.6 14.5 4 22.4 4c20 0 37.9-9.2 49.7-23.6c9 4.9 19.4 7.6 30.3 7.6c35.3 0 64-28.7 64-64l0-64 0-24C384 75.2 308.8 0 216 0L168 0C75.2 0 0 75.2 0 168l0 24zm336 64c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64zM160 272c5.5 0 10.9-.7 16-2l0 2 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32 16 0zm64-24l0-40c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 0 16c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 128l177.6 0c-1 5.2-1.6 10.5-1.6 16l0 16-32 0L64 160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 16c0-17.7 14.3-32 32-32c0 0 0 0 0 0l24 0c66.3 0 120 53.7 120 120l0 48c0 52.5-33.7 97.1-80.7 113.4c.5-3.1 .7-6.2 .7-9.4c0-20-9.2-37.9-23.6-49.7c4.9-9 7.6-19.4 7.6-30.3c0-15.1-5.3-29-14-40c8.8-11 14-24.9 14-40l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-40 0-40zm32-80s0 0 0 0c-18 0-34.6 6-48 16L64 80C28.7 80 0 108.7 0 144s28.7 64 64 64l82 0c-1.3 5.1-2 10.5-2 16c0 25.3 14.7 47.2 36 57.6c-2.6 7-4 14.5-4 22.4c0 20 9.2 37.9 23.6 49.7c-4.9 9-7.6 19.4-7.6 30.3c0 35.3 28.7 64 64 64l64 0 24 0c92.8 0 168-75.2 168-168l0-48c0-92.8-75.2-168-168-168l-24 0zM256 400c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zM240 224c0 5.5 .7 10.9 2 16l-2 0-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 0 16zm24 64l40 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l24 0z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 128l-177.6 0c1 5.2 1.6 10.5 1.6 16l0 16 32 0 144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16zM224 144c0-17.7-14.3-32-32-32c0 0 0 0 0 0l-24 0c-66.3 0-120 53.7-120 120l0 48c0 52.5 33.7 97.1 80.7 113.4c-.5-3.1-.7-6.2-.7-9.4c0-20 9.2-37.9 23.6-49.7c-4.9-9-7.6-19.4-7.6-30.3c0-15.1 5.3-29 14-40c-8.8-11-14-24.9-14-40l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 0-40zM192 64s0 0 0 0c18 0 34.6 6 48 16l208 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-82 0c1.3 5.1 2 10.5 2 16c0 25.3-14.7 47.2-36 57.6c2.6 7 4 14.5 4 22.4c0 20-9.2 37.9-23.6 49.7c4.9 9 7.6 19.4 7.6 30.3c0 35.3-28.7 64-64 64l-64 0-24 0C75.2 448 0 372.8 0 280l0-48C0 139.2 75.2 64 168 64l24 0zm64 336c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0-16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l64 0zm16-176c0 5.5-.7 10.9-2 16l2 0 32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0 16zm-24 64l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-24 0z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 64V241.6c5.2-1 10.5-1.6 16-1.6H96V208 64c0-8.8-7.2-16-16-16s-16 7.2-16 16zM80 288c-17.7 0-32 14.3-32 32c0 0 0 0 0 0v24c0 66.3 53.7 120 120 120h48c52.5 0 97.1-33.7 113.4-80.7c-3.1 .5-6.2 .7-9.4 .7c-20 0-37.9-9.2-49.7-23.6c-9 4.9-19.4 7.6-30.3 7.6c-15.1 0-29-5.3-40-14c-11 8.8-24.9 14-40 14H120c-13.3 0-24-10.7-24-24s10.7-24 24-24h40c8.8 0 16-7.2 16-16s-7.2-16-16-16H120 80zM0 320s0 0 0 0c0-18 6-34.6 16-48V64C16 28.7 44.7 0 80 0s64 28.7 64 64v82c5.1-1.3 10.5-2 16-2c25.3 0 47.2 14.7 57.6 36c7-2.6 14.5-4 22.4-4c20 0 37.9 9.2 49.7 23.6c9-4.9 19.4-7.6 30.3-7.6c35.3 0 64 28.7 64 64v64 24c0 92.8-75.2 168-168 168H168C75.2 512 0 436.8 0 344V320zm336-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48 16c0 8.8 7.2 16 16 16s16-7.2 16-16V256zM160 240c5.5 0 10.9 .7 16 2v-2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h16zm64 24v40c0 8.8 7.2 16 16 16s16-7.2 16-16V256 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16V200c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16V392c0 39.8-32.2 72-72 72H272 212.3h-.9c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23V320 64zM176 0c-35.3 0-64 28.7-64 64V261.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2h.9H272h56c66.3 0 120-53.7 120-120V288l0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5V64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"
                }
            }
        ]
    })(props);
}
function FaRegHandScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.2 276.3c-1.2-35.3 26.4-65 61.7-66.2l3.3-.1L57 208.1C22.5 200.5 .7 166.3 8.3 131.8S50.2 75.5 84.7 83.2l173 38.3c2.3-2.9 4.7-5.7 7.1-8.5l18.4-20.3C299.9 74.5 323.5 64 348.3 64l10.2 0c54.1 0 104.1 28.7 131.3 75.4l1.5 2.6c13.6 23.2 20.7 49.7 20.7 76.6L512 344c0 66.3-53.7 120-120 120l-8 0-96 0c-35.3 0-64-28.7-64-64c0-2.8 .2-5.6 .5-8.3c-19.4-11-32.5-31.8-32.5-55.7c0-.8 0-1.6 0-2.4L66.4 338c-35.3 1.2-65-26.4-66.2-61.7zm63.4-18.2c-8.8 .3-15.7 7.7-15.4 16.5s7.7 15.7 16.5 15.4l161.5-5.6c9.8-.3 18.7 5.3 22.7 14.2s2.2 19.3-4.5 26.4c-2.8 2.9-4.4 6.7-4.4 11c0 8.8 7.2 16 16 16c9.1 0 17.4 5.1 21.5 13.3s3.2 17.9-2.3 25.1c-2 2.7-3.2 6-3.2 9.6c0 8.8 7.2 16 16 16l96 0 8 0c39.8 0 72-32.2 72-72l0-125.4c0-18.4-4.9-36.5-14.2-52.4l-1.5-2.6c-18.6-32-52.8-51.6-89.8-51.6l-10.2 0c-11.3 0-22 4.8-29.6 13.1l-17.5-15.9 17.5 15.9-18.4 20.3c-.6 .6-1.1 1.3-1.7 1.9l57 13.2c8.6 2 14 10.6 12 19.2s-10.6 14-19.2 12l-85.6-19.7L74.3 130c-8.6-1.9-17.2 3.5-19.1 12.2s3.5 17.2 12.2 19.1l187.5 41.6c10.2 2.3 17.8 10.9 18.7 21.4l.1 1c.6 6.6-1.5 13.1-5.8 18.1s-10.6 7.9-17.2 8.2L63.6 258.1z"
                }
            }
        ]
    })(props);
}
function FaRegHandSpock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.2 80.8C161 47 180.8 12 214.6 2.4c34-9.6 69.4 10.2 79 44.2l30.3 107.1L337.1 84c6.6-34.7 40.1-57.5 74.8-50.9c31.4 6 53 33.9 52 64.9c10-2.6 20.8-2.8 31.5-.1c34.3 8.6 55.1 43.3 46.6 77.6L486.7 397.2C469.8 464.7 409.2 512 339.6 512c-11.2 0-22.5 0-33.7 0c-56.9 0-112.2-19-157.2-53.9l-92-71.6c-27.9-21.7-32.9-61.9-11.2-89.8s61.9-32.9 89.8-11.2l17 13.2L100.5 167.5c-13-32.9 3.2-70.1 36-83c11.1-4.4 22.7-5.4 33.7-3.7zm77.1-21.2c-2.4-8.5-11.2-13.4-19.7-11s-13.4 11.2-11 19.7l54.8 182.4c3.5 12.3-3.3 25.2-15.4 29.3s-25.3-2-30-13.9L174.9 138.1c-3.2-8.2-12.5-12.3-20.8-9s-12.3 12.5-9 20.8l73.3 185.6c12 30.3-23.7 57-49.4 37l-63.1-49.1c-7-5.4-17-4.2-22.5 2.8s-4.2 17 2.8 22.5l92 71.6c36.5 28.4 81.4 43.8 127.7 43.8c11.2 0 22.5 0 33.7 0c47.5 0 89-32.4 100.5-78.5l55.4-221.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-26 104C435.6 271.8 425 280 413 280c-16.5 0-28.9-15-25.8-31.2L415.7 99c1.7-8.7-4-17.1-12.7-18.7s-17.1 4-18.7 12.7L352.5 260c-2.2 11.6-12.4 20-24.2 20c-11 0-20.7-7.3-23.7-17.9L247.4 59.6z"
                }
            }
        ]
    })(props);
}
function FaRegHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z"
                }
            }
        ]
    })(props);
}
function FaRegHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176H96V304c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128H544h40 40c8.8 0 16 7.2 16 16V352c0 17.7-14.3 32-32 32H576c-11.8 0-22.2-6.4-27.7-16H463.4c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384H32c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16H56 96h19.8c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64H259c4.4 0 8.9 .2 13.2 .6zM544 320V176H496c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1H544zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
                }
            }
        ]
    })(props);
}
function FaRegHardDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V258c5.1-1.3 10.5-2 16-2H448c5.5 0 10.9 .7 16 2V96c0-8.8-7.2-16-16-16H64zM48 320v96c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zM0 320V96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V320zm280 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                }
            }
        ]
    })(props);
}
function FaRegHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
                }
            }
        ]
    })(props);
}
function FaRegHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 0c-39.8 0-72 32.2-72 72v8H72C32.2 80 0 112.2 0 152V440c0 39.8 32.2 72 72 72h.2 .2 .2 .2 .2H73h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H75h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H77h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2H79h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H82h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H85h.2 .2 .2 .2H86h.2 .2 .2 .2H87h.2 .2 .2 .2H88h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2H98h.2 .2 .2 .2H99h.2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2 .2v0H456h8v0H568c39.8 0 72-32.2 72-72V152c0-39.8-32.2-72-72-72H480V72c0-39.8-32.2-72-72-72H232zM480 128h88c13.3 0 24 10.7 24 24v40H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56v48H536c-13.3 0-24 10.7-24 24s10.7 24 24 24h56V440c0 13.3-10.7 24-24 24H480V336 128zM72 128h88V464h-.1-.2-.2-.2H159h-.2-.2-.2H158h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H154h-.2-.2-.2H153h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H150h-.2-.2-.2H149h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H146h-.2-.2-.2H145h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H142h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H139h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H136h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H133h-.2-.2-.2-.2-.2-.2-.2-.2H131h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H128h-.2-.2-.2-.2-.2-.2-.2-.2H126h-.2-.2-.2-.2-.2-.2-.2-.2H124h-.2-.2-.2-.2-.2-.2-.2-.2H122h-.2-.2-.2-.2-.2-.2-.2-.2H120h-.2-.2-.2-.2-.2-.2-.2-.2H118h-.2-.2-.2-.2-.2-.2-.2-.2H116h-.2-.2-.2-.2-.2-.2-.2-.2H114h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H111h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H108h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H105h-.2-.2-.2-.2H104h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H100h-.2-.2-.2-.2H99h-.2-.2-.2-.2H98h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H88h-.2-.2-.2-.2H87h-.2-.2-.2-.2H86h-.2-.2-.2-.2H85h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H82h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H79h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H77h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H75h-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2H73h-.2-.2-.2-.2-.2H72c-13.2 0-24-10.7-24-24V336h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V240h56c13.3 0 24-10.7 24-24s-10.7-24-24-24H48V152c0-13.3 10.7-24 24-24zM208 72c0-13.3 10.7-24 24-24H408c13.3 0 24 10.7 24 24V336 464H368V400c0-26.5-21.5-48-48-48s-48 21.5-48 48v64H208V72zm88 24v24H272c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h24v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V168h24c8.8 0 16-7.2 16-16V136c0-8.8-7.2-16-16-16H344V96c0-8.8-7.2-16-16-16H312c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaRegHourglassHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 24C0 10.7 10.7 0 24 0H360c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V67c0 40.3-16 79-44.5 107.5L225.9 256l81.5 81.5C336 366 352 404.7 352 445v19h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V445c0-40.3 16-79 44.5-107.5L158.1 256 76.5 174.5C48 146 32 107.3 32 67V48H24C10.7 48 0 37.3 0 24zM110.5 371.5c-3.9 3.9-7.5 8.1-10.7 12.5H284.2c-3.2-4.4-6.8-8.6-10.7-12.5L192 289.9l-81.5 81.5zM284.2 128C297 110.4 304 89 304 67V48H80V67c0 22.1 7 43.4 19.8 61H284.2z"
                }
            }
        ]
    })(props);
}
function FaRegHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V67c0 40.3 16 79 44.5 107.5L158.1 256 76.5 337.5C48 366 32 404.7 32 445v19H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V445c0-40.3-16-79-44.5-107.5L225.9 256l81.5-81.5C336 146 352 107.3 352 67V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM192 289.9l81.5 81.5C293 391 304 417.4 304 445v19H80V445c0-27.6 11-54 30.5-73.5L192 289.9zm0-67.9l-81.5-81.5C91 121 80 94.6 80 67V48H304V67c0 27.6-11 54-30.5 73.5L192 222.1z"
                }
            }
        ]
    })(props);
}
function FaRegIdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48V64c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H256zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 320h64c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16c0-44.2 35.8-80 80-80zm-32-96a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                }
            }
        ]
    })(props);
}
function FaRegIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 160V416c0 8.8-7.2 16-16 16H320c0-44.2-35.8-80-80-80H176c-44.2 0-80 35.8-80 80H64c-8.8 0-16-7.2-16-16V160H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376z"
                }
            }
        ]
    })(props);
}
function FaRegImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
                }
            }
        ]
    })(props);
}
function FaRegImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                }
            }
        ]
    })(props);
}
function FaRegKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 112c-8.8 0-16 7.2-16 16V384c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 320H400c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm-72-72c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H120c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H200c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H360c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16zm64 96c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V248zm16-96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H440c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaRegLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 80c-3.2 0-6.2 .4-8.9 1.3C340 86.8 313 91.9 284.8 84.6C227.4 69.7 160.2 92 110.1 142.1S37.7 259.4 52.6 316.8c7.3 28.2 2.2 55.2-3.3 74.3c-.8 2.8-1.3 5.8-1.3 8.9c0 17.7 14.3 32 32 32c3.2 0 6.2-.4 8.9-1.3c19.1-5.5 46.1-10.7 74.3-3.3c57.4 14.9 124.6-7.4 174.7-57.5s72.4-117.3 57.5-174.7c-7.3-28.2-2.2-55.2 3.3-74.3c.8-2.8 1.3-5.8 1.3-8.9c0-17.7-14.3-32-32-32zm0-48c44.2 0 80 35.8 80 80c0 7.7-1.1 15.2-3.1 22.3c-4.6 15.8-7.1 32.9-3 48.9c20.1 77.6-10.9 161.5-70 220.7s-143.1 90.2-220.7 70c-16-4.1-33-1.6-48.9 3c-7.1 2-14.6 3.1-22.3 3.1c-44.2 0-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.3c4.6-15.8 7.1-32.9 3-48.9C-14 251.3 17 167.3 76.2 108.2S219.3 18 296.8 38.1c16 4.1 33 1.6 48.9-3c7.1-2 14.6-3.1 22.3-3.1zM246.7 167c-52 15.2-96.5 59.7-111.7 111.7c-3.7 12.7-17.1 20-29.8 16.3s-20-17.1-16.3-29.8c19.8-67.7 76.6-124.5 144.3-144.3c12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
                }
            }
        ]
    })(props);
}
function FaRegLifeRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
                }
            }
        ]
    })(props);
}
function FaRegLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7l0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5H109c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5H226.4c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8l0 0 0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80V416H272v16c0 44.2-35.8 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaRegMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"
                }
            }
        ]
    })(props);
}
function FaRegMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"
                }
            }
        ]
    })(props);
}
function FaRegMoneyBill1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM176 256a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zm80-48c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h24 24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8V208c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"
                }
            }
        ]
    })(props);
}
function FaRegMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.7 98.7c-21 34.1-33.1 74.3-33.1 117.3c0 98 62.8 181.4 150.4 211.7c-12.4 2.8-25.3 4.3-38.6 4.3C126.6 432 48 353.3 48 256c0-68.9 39.4-128.4 96.8-157.3zm62.1-66C91.1 41.2 0 137.9 0 256C0 379.7 100 480 223.5 480c47.8 0 92-15 128.4-40.6c1.9-1.3 3.7-2.7 5.5-4c4.8-3.6 9.4-7.4 13.9-11.4c2.7-2.4 5.3-4.8 7.9-7.3c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-3.7 .6-7.4 1.2-11.1 1.6c-5 .5-10.1 .9-15.3 1c-1.2 0-2.5 0-3.7 0c-.1 0-.2 0-.3 0c-96.8-.2-175.2-78.9-175.2-176c0-54.8 24.9-103.7 64.1-136c1-.9 2.1-1.7 3.2-2.6c4-3.2 8.2-6.2 12.5-9c3.1-2 6.3-4 9.6-5.8c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-3.6-.3-7.1-.5-10.7-.6c-2.7-.1-5.5-.1-8.2-.1c-3.3 0-6.5 .1-9.8 .2c-2.3 .1-4.6 .2-6.9 .4z"
                }
            }
        ]
    })(props);
}
function FaRegNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 80c-13.3 0-24 10.7-24 24V408c0 8.4-1.4 16.5-4.1 24H440c13.3 0 24-10.7 24-24V104c0-13.3-10.7-24-24-24H168zM72 480c-39.8 0-72-32.2-72-72V112C0 98.7 10.7 88 24 88s24 10.7 24 24V408c0 13.3 10.7 24 24 24s24-10.7 24-24V104c0-39.8 32.2-72 72-72H440c39.8 0 72 32.2 72 72V408c0 39.8-32.2 72-72 72H72zM176 136c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V136zm200-24h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24zM200 272H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 80H408c13.3 0 24 10.7 24 24s-10.7 24-24 24H200c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegNoteSticky(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H288V352c0-17.7 14.3-32 32-32h80V96c0-8.8-7.2-16-16-16H64zM288 480H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V320v5.5c0 17-6.7 33.3-18.7 45.3l-90.5 90.5c-12 12-28.3 18.7-45.3 18.7H288z"
                }
            }
        ]
    })(props);
}
function FaRegObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 115.8C38.2 107 32 94.2 32 80c0-26.5 21.5-48 48-48c14.2 0 27 6.2 35.8 16H460.2c8.8-9.8 21.6-16 35.8-16c26.5 0 48 21.5 48 48c0 14.2-6.2 27-16 35.8V396.2c9.8 8.8 16 21.6 16 35.8c0 26.5-21.5 48-48 48c-14.2 0-27-6.2-35.8-16H115.8c-8.8 9.8-21.6 16-35.8 16c-26.5 0-48-21.5-48-48c0-14.2 6.2-27 16-35.8V115.8zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3V386.7c13.6 4.8 24.4 15.6 29.3 29.3H450.7c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zm2.7 64c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160zM256 320h32c35.3 0 64-28.7 64-64V224h64c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V320z"
                }
            }
        ]
    })(props);
}
function FaRegObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48.2 66.8c-.1-.8-.2-1.7-.2-2.5c0-.1 0-.1 0-.2c0-8.8 7.2-16 16-16c.9 0 1.9 .1 2.8 .2C74.3 49.5 80 56.1 80 64c0 8.8-7.2 16-16 16c-7.9 0-14.5-5.7-15.8-13.2zM0 64c0 26.9 16.5 49.9 40 59.3V228.7C16.5 238.1 0 261.1 0 288c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H324.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V123.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H123.3C113.9 16.5 90.9 0 64 0C28.7 0 0 28.7 0 64zm368 0a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM324.7 88c6.5 16 19.3 28.9 35.3 35.3V228.7c-16 6.5-28.9 19.3-35.3 35.3H123.3c-6.5-16-19.3-28.9-35.3-35.3V123.3c16-6.5 28.9-19.3 35.3-35.3H324.7zM384 272a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 288c0 7.9-5.7 14.5-13.2 15.8c-.8 .1-1.7 .2-2.5 .2l-.2 0c-8.8 0-16-7.2-16-16c0-.9 .1-1.9 .2-2.8C49.5 277.7 56.1 272 64 272c8.8 0 16 7.2 16 16zm391.3-40h45.4c6.5 16 19.3 28.9 35.3 35.3V388.7c-16 6.5-28.9 19.3-35.3 35.3H315.3c-6.5-16-19.3-28.9-35.3-35.3V352H232v36.7c-23.5 9.5-40 32.5-40 59.3c0 35.3 28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H516.7c9.5 23.5 32.5 40 59.3 40c35.3 0 64-28.7 64-64c0-26.9-16.5-49.9-40-59.3V283.3c23.5-9.5 40-32.5 40-59.3c0-35.3-28.7-64-64-64c-26.9 0-49.9 16.5-59.3 40H448v16.4c9.8 8.8 17.8 19.5 23.3 31.6zm88.9-26.7a16 16 0 1 1 31.5 5.5 16 16 0 1 1 -31.5-5.5zM271.8 450.7a16 16 0 1 1 -31.5-5.5 16 16 0 1 1 31.5 5.5zm301.5 13c-7.5-1.3-13.2-7.9-13.2-15.8c0-8.8 7.2-16 16-16c7.9 0 14.5 5.7 15.8 13.2l0 .1c.1 .9 .2 1.8 .2 2.7c0 8.8-7.2 16-16 16c-.9 0-1.9-.1-2.8-.2z"
                }
            }
        ]
    })(props);
}
function FaRegPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"
                }
            }
        ]
    })(props);
}
function FaRegPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 96v16c0 17.7 14.3 32 32 32h60.8c16.6-28.7 47.6-48 83.2-48h62c-7.1-27.6-32.2-48-62-48H215.4C211.6 20.9 188.2 0 160 0s-51.6 20.9-55.4 48H64C28.7 48 0 76.7 0 112V384c0 35.3 28.7 64 64 64h96V400H64c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H80zm64-40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM256 464c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H384v48c0 17.7 14.3 32 32 32h48V448c0 8.8-7.2 16-16 16H256zm192 48c35.3 0 64-28.7 64-64V227.9c0-12.7-5.1-24.9-14.1-33.9l-51.9-51.9c-9-9-21.2-14.1-33.9-14.1H256c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H448z"
                }
            }
        ]
    })(props);
}
function FaRegPenToSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"
                }
            }
        ]
    })(props);
}
function FaRegRectangleList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm104 0c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H448c13.3 0 24 10.7 24 24s-10.7 24-24 24H224c-13.3 0-24-10.7-24-24zm-72-64a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
                }
            }
        ]
    })(props);
}
function FaRegRectangleXmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm175 79c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaRegRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 152V264v96c0 13.3 10.7 24 24 24s24-10.7 24-24V288h60.9l37.2 81.9c5.5 12.1 19.7 17.4 31.8 11.9s17.4-19.7 11.9-31.8L315.7 275c21.8-14.3 36.3-39 36.3-67c0-44.2-35.8-80-80-80H184c-13.3 0-24 10.7-24 24zm48 88V176h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H208z"
                }
            }
        ]
    })(props);
}
function FaRegShareFromSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 255.4V240 208c0-8.8-7.2-16-16-16H352 336 289.5c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112h48 16 32c8.8 0 16-7.2 16-16V80 64.6L506 160 400 255.4zM336 240h16v48c0 17.7 14.3 32 32 32h3.7c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7V80H336 304 288c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4h2.5c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5l0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5H304h32zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                }
            }
        ]
    })(props);
}
function FaRegSnowflake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 0c13.3 0 24 10.7 24 24V70.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-57 57v76.5l66.2-38.2 20.9-77.8c3.4-12.8 16.6-20.4 29.4-17s20.4 16.6 17 29.4L373 142.2l37.1-21.4c11.5-6.6 26.2-2.7 32.8 8.8s2.7 26.2-8.8 32.8L397 183.8l31.5 8.4c12.8 3.4 20.4 16.6 17 29.4s-16.6 20.4-29.4 17l-77.8-20.9L272 256l66.2 38.2 77.8-20.9c12.8-3.4 26 4.2 29.4 17s-4.2 26-17 29.4L397 328.2l37.1 21.4c11.5 6.6 15.4 21.3 8.8 32.8s-21.3 15.4-32.8 8.8L373 369.8l8.4 31.5c3.4 12.8-4.2 26-17 29.4s-26-4.2-29.4-17l-20.9-77.8L248 297.6v76.5l57 57c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-23-23V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V441.9l-23 23c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l57-57V297.6l-66.2 38.2-20.9 77.8c-3.4 12.8-16.6 20.4-29.4 17s-20.4-16.6-17-29.4L75 369.8 37.9 391.2c-11.5 6.6-26.2 2.7-32.8-8.8s-2.7-26.2 8.8-32.8L51 328.2l-31.5-8.4c-12.8-3.4-20.4-16.6-17-29.4s16.6-20.4 29.4-17l77.8 20.9L176 256l-66.2-38.2L31.9 238.6c-12.8 3.4-26-4.2-29.4-17s4.2-26 17-29.4L51 183.8 13.9 162.4c-11.5-6.6-15.4-21.3-8.8-32.8s21.3-15.4 32.8-8.8L75 142.2l-8.4-31.5c-3.4-12.8 4.2-26 17-29.4s26 4.2 29.4 17l20.9 77.8L200 214.4V137.9L143 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V24c0-13.3 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegSquareCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 432c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0zm64-16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9s12.5-14.4 22-14.4l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
                }
            }
        ]
    })(props);
}
function FaRegSquareCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320zm16 64c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480zm64-224c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4s14.4 12.5 14.4 22l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
                }
            }
        ]
    })(props);
}
function FaRegSquareCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320zM384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4s-14.4-12.5-14.4-22l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
                }
            }
        ]
    })(props);
}
function FaRegSquareCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 64c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
                }
            }
        ]
    })(props);
}
function FaRegSquareCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
                }
            }
        ]
    })(props);
}
function FaRegSquareFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 48V464H48V48H464zM48 0H0V48 464v48H48 464h48V464 48 0H464 48z"
                }
            }
        ]
    })(props);
}
function FaRegSquareMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM152 232H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegSquarePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM200 344V280H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H248v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 80c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
                }
            }
        ]
    })(props);
}
function FaRegStarHalfStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.5 13.5C337.5 5.2 329.1 0 319.9 0s-17.6 5.2-21.6 13.5L229.7 154.8 76.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L174.2 328.4 148 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L465.6 328.4 576.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L410.1 154.8 341.5 13.5zM320 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L423 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L331.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"
                }
            }
        ]
    })(props);
}
function FaRegStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.3 .6c10.9 2.5 18.6 12.2 18.6 23.4V408.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5c4.9-10.1 16.1-15.4 27-12.9zM263.9 128.4l-28.6 58.8c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l92.5-49.4V128.4z"
                }
            }
        ]
    })(props);
}
function FaRegStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
                }
            }
        ]
    })(props);
}
function FaRegSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M375.7 19.7c-1.5-8-6.9-14.7-14.4-17.8s-16.1-2.2-22.8 2.4L256 61.1 173.5 4.2c-6.7-4.6-15.3-5.5-22.8-2.4s-12.9 9.8-14.4 17.8l-18.1 98.5L19.7 136.3c-8 1.5-14.7 6.9-17.8 14.4s-2.2 16.1 2.4 22.8L61.1 256 4.2 338.5c-4.6 6.7-5.5 15.3-2.4 22.8s9.8 13 17.8 14.4l98.5 18.1 18.1 98.5c1.5 8 6.9 14.7 14.4 17.8s16.1 2.2 22.8-2.4L256 450.9l82.5 56.9c6.7 4.6 15.3 5.5 22.8 2.4s12.9-9.8 14.4-17.8l18.1-98.5 98.5-18.1c8-1.5 14.7-6.9 17.8-14.4s2.2-16.1-2.4-22.8L450.9 256l56.9-82.5c4.6-6.7 5.5-15.3 2.4-22.8s-9.8-12.9-17.8-14.4l-98.5-18.1L375.7 19.7zM269.6 110l65.6-45.2 14.4 78.3c1.8 9.8 9.5 17.5 19.3 19.3l78.3 14.4L402 242.4c-5.7 8.2-5.7 19 0 27.2l45.2 65.6-78.3 14.4c-9.8 1.8-17.5 9.5-19.3 19.3l-14.4 78.3L269.6 402c-8.2-5.7-19-5.7-27.2 0l-65.6 45.2-14.4-78.3c-1.8-9.8-9.5-17.5-19.3-19.3L64.8 335.2 110 269.6c5.7-8.2 5.7-19 0-27.2L64.8 176.8l78.3-14.4c9.8-1.8 17.5-9.5 19.3-19.3l14.4-78.3L242.4 110c8.2 5.7 19 5.7 27.2 0zM256 368a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
                }
            }
        ]
    })(props);
}
function FaRegThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"
                }
            }
        ]
    })(props);
}
function FaRegThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"
                }
            }
        ]
    })(props);
}
function FaRegTrashCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaRegUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"
                }
            }
        ]
    })(props);
}
function FaRegWindowMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.3 89.5C.1 91.6 0 93.8 0 96V224 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64V224 96c0-35.3-28.7-64-64-64H64c-2.2 0-4.4 .1-6.5 .3c-9.2 .9-17.8 3.8-25.5 8.2C21.8 46.5 13.4 55.1 7.7 65.5c-3.9 7.3-6.5 15.4-7.4 24zM48 224H464l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192z"
                }
            }
        ]
    })(props);
}
function FaRegWindowMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"
                }
            }
        ]
    })(props);
}
function FaRegWindowRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 48H208c-17.7 0-32 14.3-32 32V96H128V80c0-44.2 35.8-80 80-80H432c44.2 0 80 35.8 80 80V304c0 44.2-35.8 80-80 80H416V336h16c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM48 448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16V256H48V448zM64 128H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"
                }
            }
        ]
    })(props);
}

},{"../lib":"9iXc2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9iXc2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _iconsManifest = require("./iconsManifest");
parcelHelpers.exportAll(_iconsManifest, exports);
var _iconBase = require("./iconBase");
parcelHelpers.exportAll(_iconBase, exports);
var _iconContext = require("./iconContext");
parcelHelpers.exportAll(_iconContext, exports);

},{"./iconsManifest":"7y6Vx","./iconBase":"3RHk1","./iconContext":"6bn4G","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7y6Vx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconsManifest", ()=>IconsManifest);
var IconsManifest = [
    {
        "id": "ci",
        "name": "Circum Icons",
        "projectUrl": "https://circumicons.com/",
        "license": "MPL-2.0 license",
        "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
    },
    {
        "id": "fa",
        "name": "Font Awesome 5",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "fa6",
        "name": "Font Awesome 6",
        "projectUrl": "https://fontawesome.com/",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "io",
        "name": "Ionicons 4",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "io5",
        "name": "Ionicons 5",
        "projectUrl": "https://ionicons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
    },
    {
        "id": "md",
        "name": "Material Design icons",
        "projectUrl": "http://google.github.io/material-design-icons/",
        "license": "Apache License Version 2.0",
        "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
    },
    {
        "id": "ti",
        "name": "Typicons",
        "projectUrl": "http://s-ings.com/typicons/",
        "license": "CC BY-SA 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
    },
    {
        "id": "go",
        "name": "Github Octicons icons",
        "projectUrl": "https://octicons.github.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
    },
    {
        "id": "fi",
        "name": "Feather",
        "projectUrl": "https://feathericons.com/",
        "license": "MIT",
        "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
    },
    {
        "id": "lu",
        "name": "Lucide",
        "projectUrl": "https://lucide.dev/",
        "license": "ISC",
        "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
    },
    {
        "id": "gi",
        "name": "Game Icons",
        "projectUrl": "https://game-icons.net/",
        "license": "CC BY 3.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
    },
    {
        "id": "wi",
        "name": "Weather Icons",
        "projectUrl": "https://erikflowers.github.io/weather-icons/",
        "license": "SIL OFL 1.1",
        "licenseUrl": "http://scripts.sil.org/OFL"
    },
    {
        "id": "di",
        "name": "Devicons",
        "projectUrl": "https://vorillaz.github.io/devicons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ai",
        "name": "Ant Design Icons",
        "projectUrl": "https://github.com/ant-design/ant-design-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "bs",
        "name": "Bootstrap Icons",
        "projectUrl": "https://github.com/twbs/icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "ri",
        "name": "Remix Icon",
        "projectUrl": "https://github.com/Remix-Design/RemixIcon",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "fc",
        "name": "Flat Color Icons",
        "projectUrl": "https://github.com/icons8/flat-color-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "gr",
        "name": "Grommet-Icons",
        "projectUrl": "https://github.com/grommet/grommet-icons",
        "license": "Apache License Version 2.0",
        "licenseUrl": "http://www.apache.org/licenses/"
    },
    {
        "id": "hi",
        "name": "Heroicons",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "hi2",
        "name": "Heroicons 2",
        "projectUrl": "https://github.com/tailwindlabs/heroicons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "si",
        "name": "Simple Icons",
        "projectUrl": "https://simpleicons.org/",
        "license": "CC0 1.0 Universal",
        "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
    },
    {
        "id": "sl",
        "name": "Simple Line Icons",
        "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "im",
        "name": "IcoMoon Free",
        "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
    },
    {
        "id": "bi",
        "name": "BoxIcons",
        "projectUrl": "https://github.com/atisawd/boxicons",
        "license": "CC BY 4.0 License",
        "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
    },
    {
        "id": "cg",
        "name": "css.gg",
        "projectUrl": "https://github.com/astrit/css.gg",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "vsc",
        "name": "VS Code Icons",
        "projectUrl": "https://github.com/microsoft/vscode-codicons",
        "license": "CC BY 4.0",
        "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
    },
    {
        "id": "tb",
        "name": "Tabler Icons",
        "projectUrl": "https://github.com/tabler/tabler-icons",
        "license": "MIT",
        "licenseUrl": "https://opensource.org/licenses/MIT"
    },
    {
        "id": "tfi",
        "name": "Themify Icons",
        "projectUrl": "https://github.com/lykmapipo/themify-icons",
        "license": "MIT",
        "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
    },
    {
        "id": "rx",
        "name": "Radix Icons",
        "projectUrl": "https://icons.radix-ui.com",
        "license": "MIT",
        "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
    },
    {
        "id": "pi",
        "name": "Phosphor Icons",
        "projectUrl": "https://github.com/phosphor-icons/core",
        "license": "MIT",
        "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
    },
    {
        "id": "lia",
        "name": "Icons8 Line Awesome",
        "projectUrl": "https://icons8.com/line-awesome",
        "license": "MIT",
        "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
    }
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3RHk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GenIcon", ()=>GenIcon);
parcelHelpers.export(exports, "IconBase", ()=>IconBase);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _iconContext = require("./iconContext");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function Tree2Element(tree) {
    return tree && tree.map(function(node, i) {
        return (0, _reactDefault.default).createElement(node.tag, __assign({
            key: i
        }, node.attr), Tree2Element(node.child));
    });
}
function GenIcon(data) {
    // eslint-disable-next-line react/display-name
    return function(props) {
        return (0, _reactDefault.default).createElement(IconBase, __assign({
            attr: __assign({}, data.attr)
        }, props), Tree2Element(data.child));
    };
}
function IconBase(props) {
    var elem = function(conf) {
        var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, [
            "attr",
            "size",
            "title"
        ]);
        var computedSize = size || conf.size || "1em";
        var className;
        if (conf.className) className = conf.className;
        if (props.className) className = (className ? className + " " : "") + props.className;
        return (0, _reactDefault.default).createElement("svg", __assign({
            stroke: "currentColor",
            fill: "currentColor",
            strokeWidth: "0"
        }, conf.attr, attr, svgProps, {
            className: className,
            style: __assign(__assign({
                color: props.color || conf.color
            }, conf.style), props.style),
            height: computedSize,
            width: computedSize,
            xmlns: "http://www.w3.org/2000/svg"
        }), title && (0, _reactDefault.default).createElement("title", null, title), props.children);
    };
    return (0, _iconContext.IconContext) !== undefined ? (0, _reactDefault.default).createElement((0, _iconContext.IconContext).Consumer, null, function(conf) {
        return elem(conf);
    }) : elem((0, _iconContext.DefaultContext));
}

},{"react":"lXMxO","./iconContext":"6bn4G","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6bn4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultContext", ()=>DefaultContext);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var DefaultContext = {
    color: undefined,
    size: undefined,
    className: undefined,
    style: undefined,
    attr: undefined
};
var IconContext = (0, _reactDefault.default).createContext && (0, _reactDefault.default).createContext(DefaultContext);

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ixP1W":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Md123", ()=>Md123);
parcelHelpers.export(exports, "Md3DRotation", ()=>Md3DRotation);
parcelHelpers.export(exports, "MdAbc", ()=>MdAbc);
parcelHelpers.export(exports, "MdAccessibilityNew", ()=>MdAccessibilityNew);
parcelHelpers.export(exports, "MdAccessibility", ()=>MdAccessibility);
parcelHelpers.export(exports, "MdAccessibleForward", ()=>MdAccessibleForward);
parcelHelpers.export(exports, "MdAccessible", ()=>MdAccessible);
parcelHelpers.export(exports, "MdAccountBalanceWallet", ()=>MdAccountBalanceWallet);
parcelHelpers.export(exports, "MdAccountBalance", ()=>MdAccountBalance);
parcelHelpers.export(exports, "MdAccountBox", ()=>MdAccountBox);
parcelHelpers.export(exports, "MdAccountCircle", ()=>MdAccountCircle);
parcelHelpers.export(exports, "MdAddCard", ()=>MdAddCard);
parcelHelpers.export(exports, "MdAddHome", ()=>MdAddHome);
parcelHelpers.export(exports, "MdAddShoppingCart", ()=>MdAddShoppingCart);
parcelHelpers.export(exports, "MdAddTask", ()=>MdAddTask);
parcelHelpers.export(exports, "MdAddToDrive", ()=>MdAddToDrive);
parcelHelpers.export(exports, "MdAddchart", ()=>MdAddchart);
parcelHelpers.export(exports, "MdAdminPanelSettings", ()=>MdAdminPanelSettings);
parcelHelpers.export(exports, "MdAdsClick", ()=>MdAdsClick);
parcelHelpers.export(exports, "MdAlarmAdd", ()=>MdAlarmAdd);
parcelHelpers.export(exports, "MdAlarmOff", ()=>MdAlarmOff);
parcelHelpers.export(exports, "MdAlarmOn", ()=>MdAlarmOn);
parcelHelpers.export(exports, "MdAlarm", ()=>MdAlarm);
parcelHelpers.export(exports, "MdAllInbox", ()=>MdAllInbox);
parcelHelpers.export(exports, "MdAllOut", ()=>MdAllOut);
parcelHelpers.export(exports, "MdAnalytics", ()=>MdAnalytics);
parcelHelpers.export(exports, "MdAnchor", ()=>MdAnchor);
parcelHelpers.export(exports, "MdAndroid", ()=>MdAndroid);
parcelHelpers.export(exports, "MdAnnouncement", ()=>MdAnnouncement);
parcelHelpers.export(exports, "MdApi", ()=>MdApi);
parcelHelpers.export(exports, "MdAppBlocking", ()=>MdAppBlocking);
parcelHelpers.export(exports, "MdAppShortcut", ()=>MdAppShortcut);
parcelHelpers.export(exports, "MdArrowCircleDown", ()=>MdArrowCircleDown);
parcelHelpers.export(exports, "MdArrowCircleLeft", ()=>MdArrowCircleLeft);
parcelHelpers.export(exports, "MdArrowCircleRight", ()=>MdArrowCircleRight);
parcelHelpers.export(exports, "MdArrowCircleUp", ()=>MdArrowCircleUp);
parcelHelpers.export(exports, "MdArrowOutward", ()=>MdArrowOutward);
parcelHelpers.export(exports, "MdArrowRightAlt", ()=>MdArrowRightAlt);
parcelHelpers.export(exports, "MdArticle", ()=>MdArticle);
parcelHelpers.export(exports, "MdAspectRatio", ()=>MdAspectRatio);
parcelHelpers.export(exports, "MdAssessment", ()=>MdAssessment);
parcelHelpers.export(exports, "MdAssignmentAdd", ()=>MdAssignmentAdd);
parcelHelpers.export(exports, "MdAssignmentInd", ()=>MdAssignmentInd);
parcelHelpers.export(exports, "MdAssignmentLate", ()=>MdAssignmentLate);
parcelHelpers.export(exports, "MdAssignmentReturn", ()=>MdAssignmentReturn);
parcelHelpers.export(exports, "MdAssignmentReturned", ()=>MdAssignmentReturned);
parcelHelpers.export(exports, "MdAssignmentTurnedIn", ()=>MdAssignmentTurnedIn);
parcelHelpers.export(exports, "MdAssignment", ()=>MdAssignment);
parcelHelpers.export(exports, "MdAssuredWorkload", ()=>MdAssuredWorkload);
parcelHelpers.export(exports, "MdAutorenew", ()=>MdAutorenew);
parcelHelpers.export(exports, "MdBackupTable", ()=>MdBackupTable);
parcelHelpers.export(exports, "MdBackup", ()=>MdBackup);
parcelHelpers.export(exports, "MdBalance", ()=>MdBalance);
parcelHelpers.export(exports, "MdBarcodeReader", ()=>MdBarcodeReader);
parcelHelpers.export(exports, "MdBatchPrediction", ()=>MdBatchPrediction);
parcelHelpers.export(exports, "MdBookOnline", ()=>MdBookOnline);
parcelHelpers.export(exports, "MdBook", ()=>MdBook);
parcelHelpers.export(exports, "MdBookmarkAdd", ()=>MdBookmarkAdd);
parcelHelpers.export(exports, "MdBookmarkAdded", ()=>MdBookmarkAdded);
parcelHelpers.export(exports, "MdBookmarkBorder", ()=>MdBookmarkBorder);
parcelHelpers.export(exports, "MdBookmarkRemove", ()=>MdBookmarkRemove);
parcelHelpers.export(exports, "MdBookmark", ()=>MdBookmark);
parcelHelpers.export(exports, "MdBookmarks", ()=>MdBookmarks);
parcelHelpers.export(exports, "MdBrowseGallery", ()=>MdBrowseGallery);
parcelHelpers.export(exports, "MdBugReport", ()=>MdBugReport);
parcelHelpers.export(exports, "MdBuildCircle", ()=>MdBuildCircle);
parcelHelpers.export(exports, "MdBuild", ()=>MdBuild);
parcelHelpers.export(exports, "MdCached", ()=>MdCached);
parcelHelpers.export(exports, "MdCalendarMonth", ()=>MdCalendarMonth);
parcelHelpers.export(exports, "MdCalendarToday", ()=>MdCalendarToday);
parcelHelpers.export(exports, "MdCalendarViewDay", ()=>MdCalendarViewDay);
parcelHelpers.export(exports, "MdCalendarViewMonth", ()=>MdCalendarViewMonth);
parcelHelpers.export(exports, "MdCalendarViewWeek", ()=>MdCalendarViewWeek);
parcelHelpers.export(exports, "MdCameraEnhance", ()=>MdCameraEnhance);
parcelHelpers.export(exports, "MdCancelScheduleSend", ()=>MdCancelScheduleSend);
parcelHelpers.export(exports, "MdCardGiftcard", ()=>MdCardGiftcard);
parcelHelpers.export(exports, "MdCardMembership", ()=>MdCardMembership);
parcelHelpers.export(exports, "MdCardTravel", ()=>MdCardTravel);
parcelHelpers.export(exports, "MdChangeHistory", ()=>MdChangeHistory);
parcelHelpers.export(exports, "MdCheckCircleOutline", ()=>MdCheckCircleOutline);
parcelHelpers.export(exports, "MdCheckCircle", ()=>MdCheckCircle);
parcelHelpers.export(exports, "MdChromeReaderMode", ()=>MdChromeReaderMode);
parcelHelpers.export(exports, "MdCircleNotifications", ()=>MdCircleNotifications);
parcelHelpers.export(exports, "MdClass", ()=>MdClass);
parcelHelpers.export(exports, "MdCloseFullscreen", ()=>MdCloseFullscreen);
parcelHelpers.export(exports, "MdCodeOff", ()=>MdCodeOff);
parcelHelpers.export(exports, "MdCode", ()=>MdCode);
parcelHelpers.export(exports, "MdCommentBank", ()=>MdCommentBank);
parcelHelpers.export(exports, "MdCommit", ()=>MdCommit);
parcelHelpers.export(exports, "MdCommute", ()=>MdCommute);
parcelHelpers.export(exports, "MdCompareArrows", ()=>MdCompareArrows);
parcelHelpers.export(exports, "MdCompress", ()=>MdCompress);
parcelHelpers.export(exports, "MdContactPage", ()=>MdContactPage);
parcelHelpers.export(exports, "MdContactSupport", ()=>MdContactSupport);
parcelHelpers.export(exports, "MdContactless", ()=>MdContactless);
parcelHelpers.export(exports, "MdCopyright", ()=>MdCopyright);
parcelHelpers.export(exports, "MdCreditCardOff", ()=>MdCreditCardOff);
parcelHelpers.export(exports, "MdCreditCard", ()=>MdCreditCard);
parcelHelpers.export(exports, "MdCss", ()=>MdCss);
parcelHelpers.export(exports, "MdCurrencyExchange", ()=>MdCurrencyExchange);
parcelHelpers.export(exports, "MdDangerous", ()=>MdDangerous);
parcelHelpers.export(exports, "MdDashboardCustomize", ()=>MdDashboardCustomize);
parcelHelpers.export(exports, "MdDashboard", ()=>MdDashboard);
parcelHelpers.export(exports, "MdDataExploration", ()=>MdDataExploration);
parcelHelpers.export(exports, "MdDataThresholding", ()=>MdDataThresholding);
parcelHelpers.export(exports, "MdDateRange", ()=>MdDateRange);
parcelHelpers.export(exports, "MdDeleteForever", ()=>MdDeleteForever);
parcelHelpers.export(exports, "MdDeleteOutline", ()=>MdDeleteOutline);
parcelHelpers.export(exports, "MdDelete", ()=>MdDelete);
parcelHelpers.export(exports, "MdDensityLarge", ()=>MdDensityLarge);
parcelHelpers.export(exports, "MdDensityMedium", ()=>MdDensityMedium);
parcelHelpers.export(exports, "MdDensitySmall", ()=>MdDensitySmall);
parcelHelpers.export(exports, "MdDescription", ()=>MdDescription);
parcelHelpers.export(exports, "MdDisabledByDefault", ()=>MdDisabledByDefault);
parcelHelpers.export(exports, "MdDisabledVisible", ()=>MdDisabledVisible);
parcelHelpers.export(exports, "MdDisplaySettings", ()=>MdDisplaySettings);
parcelHelpers.export(exports, "MdDns", ()=>MdDns);
parcelHelpers.export(exports, "MdDoneAll", ()=>MdDoneAll);
parcelHelpers.export(exports, "MdDoneOutline", ()=>MdDoneOutline);
parcelHelpers.export(exports, "MdDone", ()=>MdDone);
parcelHelpers.export(exports, "MdDonutLarge", ()=>MdDonutLarge);
parcelHelpers.export(exports, "MdDonutSmall", ()=>MdDonutSmall);
parcelHelpers.export(exports, "MdDragIndicator", ()=>MdDragIndicator);
parcelHelpers.export(exports, "MdDynamicForm", ()=>MdDynamicForm);
parcelHelpers.export(exports, "MdEco", ()=>MdEco);
parcelHelpers.export(exports, "MdEditCalendar", ()=>MdEditCalendar);
parcelHelpers.export(exports, "MdEditDocument", ()=>MdEditDocument);
parcelHelpers.export(exports, "MdEditOff", ()=>MdEditOff);
parcelHelpers.export(exports, "MdEditSquare", ()=>MdEditSquare);
parcelHelpers.export(exports, "MdEject", ()=>MdEject);
parcelHelpers.export(exports, "MdEuroSymbol", ()=>MdEuroSymbol);
parcelHelpers.export(exports, "MdEventRepeat", ()=>MdEventRepeat);
parcelHelpers.export(exports, "MdEventSeat", ()=>MdEventSeat);
parcelHelpers.export(exports, "MdEvent", ()=>MdEvent);
parcelHelpers.export(exports, "MdExitToApp", ()=>MdExitToApp);
parcelHelpers.export(exports, "MdExpand", ()=>MdExpand);
parcelHelpers.export(exports, "MdExploreOff", ()=>MdExploreOff);
parcelHelpers.export(exports, "MdExplore", ()=>MdExplore);
parcelHelpers.export(exports, "MdExtensionOff", ()=>MdExtensionOff);
parcelHelpers.export(exports, "MdExtension", ()=>MdExtension);
parcelHelpers.export(exports, "MdFace", ()=>MdFace);
parcelHelpers.export(exports, "MdFactCheck", ()=>MdFactCheck);
parcelHelpers.export(exports, "MdFavoriteBorder", ()=>MdFavoriteBorder);
parcelHelpers.export(exports, "MdFavorite", ()=>MdFavorite);
parcelHelpers.export(exports, "MdFax", ()=>MdFax);
parcelHelpers.export(exports, "MdFeedback", ()=>MdFeedback);
parcelHelpers.export(exports, "MdFilePresent", ()=>MdFilePresent);
parcelHelpers.export(exports, "MdFilterAltOff", ()=>MdFilterAltOff);
parcelHelpers.export(exports, "MdFilterAlt", ()=>MdFilterAlt);
parcelHelpers.export(exports, "MdFilterListAlt", ()=>MdFilterListAlt);
parcelHelpers.export(exports, "MdFindInPage", ()=>MdFindInPage);
parcelHelpers.export(exports, "MdFindReplace", ()=>MdFindReplace);
parcelHelpers.export(exports, "MdFingerprint", ()=>MdFingerprint);
parcelHelpers.export(exports, "MdFitScreen", ()=>MdFitScreen);
parcelHelpers.export(exports, "MdFlaky", ()=>MdFlaky);
parcelHelpers.export(exports, "MdFlightLand", ()=>MdFlightLand);
parcelHelpers.export(exports, "MdFlightTakeoff", ()=>MdFlightTakeoff);
parcelHelpers.export(exports, "MdFlipToBack", ()=>MdFlipToBack);
parcelHelpers.export(exports, "MdFlipToFront", ()=>MdFlipToFront);
parcelHelpers.export(exports, "MdFlutterDash", ()=>MdFlutterDash);
parcelHelpers.export(exports, "MdFreeCancellation", ()=>MdFreeCancellation);
parcelHelpers.export(exports, "MdGTranslate", ()=>MdGTranslate);
parcelHelpers.export(exports, "MdGavel", ()=>MdGavel);
parcelHelpers.export(exports, "MdGeneratingTokens", ()=>MdGeneratingTokens);
parcelHelpers.export(exports, "MdGetApp", ()=>MdGetApp);
parcelHelpers.export(exports, "MdGifBox", ()=>MdGifBox);
parcelHelpers.export(exports, "MdGif", ()=>MdGif);
parcelHelpers.export(exports, "MdGrade", ()=>MdGrade);
parcelHelpers.export(exports, "MdGrading", ()=>MdGrading);
parcelHelpers.export(exports, "MdGroupWork", ()=>MdGroupWork);
parcelHelpers.export(exports, "MdHelpCenter", ()=>MdHelpCenter);
parcelHelpers.export(exports, "MdHelpOutline", ()=>MdHelpOutline);
parcelHelpers.export(exports, "MdHelp", ()=>MdHelp);
parcelHelpers.export(exports, "MdHideSource", ()=>MdHideSource);
parcelHelpers.export(exports, "MdHighlightAlt", ()=>MdHighlightAlt);
parcelHelpers.export(exports, "MdHighlightOff", ()=>MdHighlightOff);
parcelHelpers.export(exports, "MdHistoryToggleOff", ()=>MdHistoryToggleOff);
parcelHelpers.export(exports, "MdHistory", ()=>MdHistory);
parcelHelpers.export(exports, "MdHlsOff", ()=>MdHlsOff);
parcelHelpers.export(exports, "MdHls", ()=>MdHls);
parcelHelpers.export(exports, "MdHomeFilled", ()=>MdHomeFilled);
parcelHelpers.export(exports, "MdHome", ()=>MdHome);
parcelHelpers.export(exports, "MdHorizontalSplit", ()=>MdHorizontalSplit);
parcelHelpers.export(exports, "MdHotelClass", ()=>MdHotelClass);
parcelHelpers.export(exports, "MdHourglassDisabled", ()=>MdHourglassDisabled);
parcelHelpers.export(exports, "MdHourglassEmpty", ()=>MdHourglassEmpty);
parcelHelpers.export(exports, "MdHourglassFull", ()=>MdHourglassFull);
parcelHelpers.export(exports, "MdHtml", ()=>MdHtml);
parcelHelpers.export(exports, "MdHttp", ()=>MdHttp);
parcelHelpers.export(exports, "MdHttps", ()=>MdHttps);
parcelHelpers.export(exports, "MdImportantDevices", ()=>MdImportantDevices);
parcelHelpers.export(exports, "MdInfoOutline", ()=>MdInfoOutline);
parcelHelpers.export(exports, "MdInfo", ()=>MdInfo);
parcelHelpers.export(exports, "MdInput", ()=>MdInput);
parcelHelpers.export(exports, "MdInstallDesktop", ()=>MdInstallDesktop);
parcelHelpers.export(exports, "MdInstallMobile", ()=>MdInstallMobile);
parcelHelpers.export(exports, "MdIntegrationInstructions", ()=>MdIntegrationInstructions);
parcelHelpers.export(exports, "MdInvertColors", ()=>MdInvertColors);
parcelHelpers.export(exports, "MdJavascript", ()=>MdJavascript);
parcelHelpers.export(exports, "MdJoinFull", ()=>MdJoinFull);
parcelHelpers.export(exports, "MdJoinInner", ()=>MdJoinInner);
parcelHelpers.export(exports, "MdJoinLeft", ()=>MdJoinLeft);
parcelHelpers.export(exports, "MdJoinRight", ()=>MdJoinRight);
parcelHelpers.export(exports, "MdLabelImportantOutline", ()=>MdLabelImportantOutline);
parcelHelpers.export(exports, "MdLabelImportant", ()=>MdLabelImportant);
parcelHelpers.export(exports, "MdLabelOff", ()=>MdLabelOff);
parcelHelpers.export(exports, "MdLabelOutline", ()=>MdLabelOutline);
parcelHelpers.export(exports, "MdLabel", ()=>MdLabel);
parcelHelpers.export(exports, "MdLanguage", ()=>MdLanguage);
parcelHelpers.export(exports, "MdLaunch", ()=>MdLaunch);
parcelHelpers.export(exports, "MdLeaderboard", ()=>MdLeaderboard);
parcelHelpers.export(exports, "MdLightbulbCircle", ()=>MdLightbulbCircle);
parcelHelpers.export(exports, "MdLightbulbOutline", ()=>MdLightbulbOutline);
parcelHelpers.export(exports, "MdLightbulb", ()=>MdLightbulb);
parcelHelpers.export(exports, "MdLineStyle", ()=>MdLineStyle);
parcelHelpers.export(exports, "MdLineWeight", ()=>MdLineWeight);
parcelHelpers.export(exports, "MdList", ()=>MdList);
parcelHelpers.export(exports, "MdLockClock", ()=>MdLockClock);
parcelHelpers.export(exports, "MdLockOpen", ()=>MdLockOpen);
parcelHelpers.export(exports, "MdLockOutline", ()=>MdLockOutline);
parcelHelpers.export(exports, "MdLockPerson", ()=>MdLockPerson);
parcelHelpers.export(exports, "MdLockReset", ()=>MdLockReset);
parcelHelpers.export(exports, "MdLock", ()=>MdLock);
parcelHelpers.export(exports, "MdLogin", ()=>MdLogin);
parcelHelpers.export(exports, "MdLogout", ()=>MdLogout);
parcelHelpers.export(exports, "MdLoyalty", ()=>MdLoyalty);
parcelHelpers.export(exports, "MdManageAccounts", ()=>MdManageAccounts);
parcelHelpers.export(exports, "MdManageHistory", ()=>MdManageHistory);
parcelHelpers.export(exports, "MdMarkAsUnread", ()=>MdMarkAsUnread);
parcelHelpers.export(exports, "MdMarkunreadMailbox", ()=>MdMarkunreadMailbox);
parcelHelpers.export(exports, "MdMaximize", ()=>MdMaximize);
parcelHelpers.export(exports, "MdMediation", ()=>MdMediation);
parcelHelpers.export(exports, "MdMinimize", ()=>MdMinimize);
parcelHelpers.export(exports, "MdModelTraining", ()=>MdModelTraining);
parcelHelpers.export(exports, "MdNetworkPing", ()=>MdNetworkPing);
parcelHelpers.export(exports, "MdNewLabel", ()=>MdNewLabel);
parcelHelpers.export(exports, "MdNextPlan", ()=>MdNextPlan);
parcelHelpers.export(exports, "MdNightlightRound", ()=>MdNightlightRound);
parcelHelpers.export(exports, "MdNoAccounts", ()=>MdNoAccounts);
parcelHelpers.export(exports, "MdNoiseAware", ()=>MdNoiseAware);
parcelHelpers.export(exports, "MdNoiseControlOff", ()=>MdNoiseControlOff);
parcelHelpers.export(exports, "MdNotAccessible", ()=>MdNotAccessible);
parcelHelpers.export(exports, "MdNotStarted", ()=>MdNotStarted);
parcelHelpers.export(exports, "MdNoteAdd", ()=>MdNoteAdd);
parcelHelpers.export(exports, "MdOfflineBolt", ()=>MdOfflineBolt);
parcelHelpers.export(exports, "MdOfflinePin", ()=>MdOfflinePin);
parcelHelpers.export(exports, "MdOnDeviceTraining", ()=>MdOnDeviceTraining);
parcelHelpers.export(exports, "MdOnlinePrediction", ()=>MdOnlinePrediction);
parcelHelpers.export(exports, "MdOpacity", ()=>MdOpacity);
parcelHelpers.export(exports, "MdOpenInBrowser", ()=>MdOpenInBrowser);
parcelHelpers.export(exports, "MdOpenInFull", ()=>MdOpenInFull);
parcelHelpers.export(exports, "MdOpenInNewOff", ()=>MdOpenInNewOff);
parcelHelpers.export(exports, "MdOpenInNew", ()=>MdOpenInNew);
parcelHelpers.export(exports, "MdOpenWith", ()=>MdOpenWith);
parcelHelpers.export(exports, "MdOutbond", ()=>MdOutbond);
parcelHelpers.export(exports, "MdOutbound", ()=>MdOutbound);
parcelHelpers.export(exports, "MdOutbox", ()=>MdOutbox);
parcelHelpers.export(exports, "MdOutgoingMail", ()=>MdOutgoingMail);
parcelHelpers.export(exports, "MdOutlet", ()=>MdOutlet);
parcelHelpers.export(exports, "MdOutput", ()=>MdOutput);
parcelHelpers.export(exports, "MdPageview", ()=>MdPageview);
parcelHelpers.export(exports, "MdPaid", ()=>MdPaid);
parcelHelpers.export(exports, "MdPanToolAlt", ()=>MdPanToolAlt);
parcelHelpers.export(exports, "MdPanTool", ()=>MdPanTool);
parcelHelpers.export(exports, "MdPayment", ()=>MdPayment);
parcelHelpers.export(exports, "MdPendingActions", ()=>MdPendingActions);
parcelHelpers.export(exports, "MdPending", ()=>MdPending);
parcelHelpers.export(exports, "MdPercent", ()=>MdPercent);
parcelHelpers.export(exports, "MdPermCameraMic", ()=>MdPermCameraMic);
parcelHelpers.export(exports, "MdPermContactCalendar", ()=>MdPermContactCalendar);
parcelHelpers.export(exports, "MdPermDataSetting", ()=>MdPermDataSetting);
parcelHelpers.export(exports, "MdPermDeviceInformation", ()=>MdPermDeviceInformation);
parcelHelpers.export(exports, "MdPermIdentity", ()=>MdPermIdentity);
parcelHelpers.export(exports, "MdPermMedia", ()=>MdPermMedia);
parcelHelpers.export(exports, "MdPermPhoneMsg", ()=>MdPermPhoneMsg);
parcelHelpers.export(exports, "MdPermScanWifi", ()=>MdPermScanWifi);
parcelHelpers.export(exports, "MdPets", ()=>MdPets);
parcelHelpers.export(exports, "MdPhp", ()=>MdPhp);
parcelHelpers.export(exports, "MdPictureInPictureAlt", ()=>MdPictureInPictureAlt);
parcelHelpers.export(exports, "MdPictureInPicture", ()=>MdPictureInPicture);
parcelHelpers.export(exports, "MdPinEnd", ()=>MdPinEnd);
parcelHelpers.export(exports, "MdPinInvoke", ()=>MdPinInvoke);
parcelHelpers.export(exports, "MdPinch", ()=>MdPinch);
parcelHelpers.export(exports, "MdPlagiarism", ()=>MdPlagiarism);
parcelHelpers.export(exports, "MdPlayForWork", ()=>MdPlayForWork);
parcelHelpers.export(exports, "MdPolymer", ()=>MdPolymer);
parcelHelpers.export(exports, "MdPowerSettingsNew", ()=>MdPowerSettingsNew);
parcelHelpers.export(exports, "MdPregnantWoman", ()=>MdPregnantWoman);
parcelHelpers.export(exports, "MdPreview", ()=>MdPreview);
parcelHelpers.export(exports, "MdPrint", ()=>MdPrint);
parcelHelpers.export(exports, "MdPrivacyTip", ()=>MdPrivacyTip);
parcelHelpers.export(exports, "MdPrivateConnectivity", ()=>MdPrivateConnectivity);
parcelHelpers.export(exports, "MdProductionQuantityLimits", ()=>MdProductionQuantityLimits);
parcelHelpers.export(exports, "MdPublishedWithChanges", ()=>MdPublishedWithChanges);
parcelHelpers.export(exports, "MdQueryBuilder", ()=>MdQueryBuilder);
parcelHelpers.export(exports, "MdQuestionAnswer", ()=>MdQuestionAnswer);
parcelHelpers.export(exports, "MdQuestionMark", ()=>MdQuestionMark);
parcelHelpers.export(exports, "MdQuickreply", ()=>MdQuickreply);
parcelHelpers.export(exports, "MdRebaseEdit", ()=>MdRebaseEdit);
parcelHelpers.export(exports, "MdReceipt", ()=>MdReceipt);
parcelHelpers.export(exports, "MdRecordVoiceOver", ()=>MdRecordVoiceOver);
parcelHelpers.export(exports, "MdRedeem", ()=>MdRedeem);
parcelHelpers.export(exports, "MdRemoveDone", ()=>MdRemoveDone);
parcelHelpers.export(exports, "MdRemoveShoppingCart", ()=>MdRemoveShoppingCart);
parcelHelpers.export(exports, "MdReorder", ()=>MdReorder);
parcelHelpers.export(exports, "MdRepartition", ()=>MdRepartition);
parcelHelpers.export(exports, "MdReportProblem", ()=>MdReportProblem);
parcelHelpers.export(exports, "MdRequestPage", ()=>MdRequestPage);
parcelHelpers.export(exports, "MdRestoreFromTrash", ()=>MdRestoreFromTrash);
parcelHelpers.export(exports, "MdRestorePage", ()=>MdRestorePage);
parcelHelpers.export(exports, "MdRestore", ()=>MdRestore);
parcelHelpers.export(exports, "MdRocketLaunch", ()=>MdRocketLaunch);
parcelHelpers.export(exports, "MdRocket", ()=>MdRocket);
parcelHelpers.export(exports, "MdRoom", ()=>MdRoom);
parcelHelpers.export(exports, "MdRoundedCorner", ()=>MdRoundedCorner);
parcelHelpers.export(exports, "MdRowing", ()=>MdRowing);
parcelHelpers.export(exports, "MdRule", ()=>MdRule);
parcelHelpers.export(exports, "MdSatelliteAlt", ()=>MdSatelliteAlt);
parcelHelpers.export(exports, "MdSavedSearch", ()=>MdSavedSearch);
parcelHelpers.export(exports, "MdSavings", ()=>MdSavings);
parcelHelpers.export(exports, "MdScheduleSend", ()=>MdScheduleSend);
parcelHelpers.export(exports, "MdSchedule", ()=>MdSchedule);
parcelHelpers.export(exports, "MdSearchOff", ()=>MdSearchOff);
parcelHelpers.export(exports, "MdSearch", ()=>MdSearch);
parcelHelpers.export(exports, "MdSegment", ()=>MdSegment);
parcelHelpers.export(exports, "MdSendAndArchive", ()=>MdSendAndArchive);
parcelHelpers.export(exports, "MdSensorsOff", ()=>MdSensorsOff);
parcelHelpers.export(exports, "MdSensors", ()=>MdSensors);
parcelHelpers.export(exports, "MdSettingsAccessibility", ()=>MdSettingsAccessibility);
parcelHelpers.export(exports, "MdSettingsApplications", ()=>MdSettingsApplications);
parcelHelpers.export(exports, "MdSettingsBackupRestore", ()=>MdSettingsBackupRestore);
parcelHelpers.export(exports, "MdSettingsBluetooth", ()=>MdSettingsBluetooth);
parcelHelpers.export(exports, "MdSettingsBrightness", ()=>MdSettingsBrightness);
parcelHelpers.export(exports, "MdSettingsCell", ()=>MdSettingsCell);
parcelHelpers.export(exports, "MdSettingsEthernet", ()=>MdSettingsEthernet);
parcelHelpers.export(exports, "MdSettingsInputAntenna", ()=>MdSettingsInputAntenna);
parcelHelpers.export(exports, "MdSettingsInputComponent", ()=>MdSettingsInputComponent);
parcelHelpers.export(exports, "MdSettingsInputComposite", ()=>MdSettingsInputComposite);
parcelHelpers.export(exports, "MdSettingsInputHdmi", ()=>MdSettingsInputHdmi);
parcelHelpers.export(exports, "MdSettingsInputSvideo", ()=>MdSettingsInputSvideo);
parcelHelpers.export(exports, "MdSettingsOverscan", ()=>MdSettingsOverscan);
parcelHelpers.export(exports, "MdSettingsPhone", ()=>MdSettingsPhone);
parcelHelpers.export(exports, "MdSettingsPower", ()=>MdSettingsPower);
parcelHelpers.export(exports, "MdSettingsRemote", ()=>MdSettingsRemote);
parcelHelpers.export(exports, "MdSettingsVoice", ()=>MdSettingsVoice);
parcelHelpers.export(exports, "MdSettings", ()=>MdSettings);
parcelHelpers.export(exports, "MdShop2", ()=>MdShop2);
parcelHelpers.export(exports, "MdShopTwo", ()=>MdShopTwo);
parcelHelpers.export(exports, "MdShop", ()=>MdShop);
parcelHelpers.export(exports, "MdShoppingBag", ()=>MdShoppingBag);
parcelHelpers.export(exports, "MdShoppingBasket", ()=>MdShoppingBasket);
parcelHelpers.export(exports, "MdShoppingCartCheckout", ()=>MdShoppingCartCheckout);
parcelHelpers.export(exports, "MdShoppingCart", ()=>MdShoppingCart);
parcelHelpers.export(exports, "MdSmartButton", ()=>MdSmartButton);
parcelHelpers.export(exports, "MdSource", ()=>MdSource);
parcelHelpers.export(exports, "MdSpaceDashboard", ()=>MdSpaceDashboard);
parcelHelpers.export(exports, "MdSpatialAudioOff", ()=>MdSpatialAudioOff);
parcelHelpers.export(exports, "MdSpatialAudio", ()=>MdSpatialAudio);
parcelHelpers.export(exports, "MdSpatialTracking", ()=>MdSpatialTracking);
parcelHelpers.export(exports, "MdSpeakerNotesOff", ()=>MdSpeakerNotesOff);
parcelHelpers.export(exports, "MdSpeakerNotes", ()=>MdSpeakerNotes);
parcelHelpers.export(exports, "MdSpellcheck", ()=>MdSpellcheck);
parcelHelpers.export(exports, "MdStarRate", ()=>MdStarRate);
parcelHelpers.export(exports, "MdStars", ()=>MdStars);
parcelHelpers.export(exports, "MdStickyNote2", ()=>MdStickyNote2);
parcelHelpers.export(exports, "MdStore", ()=>MdStore);
parcelHelpers.export(exports, "MdSubject", ()=>MdSubject);
parcelHelpers.export(exports, "MdSubtitlesOff", ()=>MdSubtitlesOff);
parcelHelpers.export(exports, "MdSupervisedUserCircle", ()=>MdSupervisedUserCircle);
parcelHelpers.export(exports, "MdSupervisorAccount", ()=>MdSupervisorAccount);
parcelHelpers.export(exports, "MdSupport", ()=>MdSupport);
parcelHelpers.export(exports, "MdSwapHoriz", ()=>MdSwapHoriz);
parcelHelpers.export(exports, "MdSwapHorizontalCircle", ()=>MdSwapHorizontalCircle);
parcelHelpers.export(exports, "MdSwapVert", ()=>MdSwapVert);
parcelHelpers.export(exports, "MdSwapVerticalCircle", ()=>MdSwapVerticalCircle);
parcelHelpers.export(exports, "MdSwipeDownAlt", ()=>MdSwipeDownAlt);
parcelHelpers.export(exports, "MdSwipeDown", ()=>MdSwipeDown);
parcelHelpers.export(exports, "MdSwipeLeftAlt", ()=>MdSwipeLeftAlt);
parcelHelpers.export(exports, "MdSwipeLeft", ()=>MdSwipeLeft);
parcelHelpers.export(exports, "MdSwipeRightAlt", ()=>MdSwipeRightAlt);
parcelHelpers.export(exports, "MdSwipeRight", ()=>MdSwipeRight);
parcelHelpers.export(exports, "MdSwipeUpAlt", ()=>MdSwipeUpAlt);
parcelHelpers.export(exports, "MdSwipeUp", ()=>MdSwipeUp);
parcelHelpers.export(exports, "MdSwipeVertical", ()=>MdSwipeVertical);
parcelHelpers.export(exports, "MdSwipe", ()=>MdSwipe);
parcelHelpers.export(exports, "MdSwitchAccessShortcutAdd", ()=>MdSwitchAccessShortcutAdd);
parcelHelpers.export(exports, "MdSwitchAccessShortcut", ()=>MdSwitchAccessShortcut);
parcelHelpers.export(exports, "MdSyncAlt", ()=>MdSyncAlt);
parcelHelpers.export(exports, "MdSystemUpdateAlt", ()=>MdSystemUpdateAlt);
parcelHelpers.export(exports, "MdTabUnselected", ()=>MdTabUnselected);
parcelHelpers.export(exports, "MdTab", ()=>MdTab);
parcelHelpers.export(exports, "MdTableView", ()=>MdTableView);
parcelHelpers.export(exports, "MdTaskAlt", ()=>MdTaskAlt);
parcelHelpers.export(exports, "MdTerminal", ()=>MdTerminal);
parcelHelpers.export(exports, "MdTextRotateUp", ()=>MdTextRotateUp);
parcelHelpers.export(exports, "MdTextRotateVertical", ()=>MdTextRotateVertical);
parcelHelpers.export(exports, "MdTextRotationAngledown", ()=>MdTextRotationAngledown);
parcelHelpers.export(exports, "MdTextRotationAngleup", ()=>MdTextRotationAngleup);
parcelHelpers.export(exports, "MdTextRotationDown", ()=>MdTextRotationDown);
parcelHelpers.export(exports, "MdTextRotationNone", ()=>MdTextRotationNone);
parcelHelpers.export(exports, "MdTheaters", ()=>MdTheaters);
parcelHelpers.export(exports, "MdThumbDownOffAlt", ()=>MdThumbDownOffAlt);
parcelHelpers.export(exports, "MdThumbDown", ()=>MdThumbDown);
parcelHelpers.export(exports, "MdThumbUpOffAlt", ()=>MdThumbUpOffAlt);
parcelHelpers.export(exports, "MdThumbUp", ()=>MdThumbUp);
parcelHelpers.export(exports, "MdThumbsUpDown", ()=>MdThumbsUpDown);
parcelHelpers.export(exports, "MdTimeline", ()=>MdTimeline);
parcelHelpers.export(exports, "MdTipsAndUpdates", ()=>MdTipsAndUpdates);
parcelHelpers.export(exports, "MdToc", ()=>MdToc);
parcelHelpers.export(exports, "MdToday", ()=>MdToday);
parcelHelpers.export(exports, "MdToken", ()=>MdToken);
parcelHelpers.export(exports, "MdToll", ()=>MdToll);
parcelHelpers.export(exports, "MdTouchApp", ()=>MdTouchApp);
parcelHelpers.export(exports, "MdTour", ()=>MdTour);
parcelHelpers.export(exports, "MdTrackChanges", ()=>MdTrackChanges);
parcelHelpers.export(exports, "MdTranscribe", ()=>MdTranscribe);
parcelHelpers.export(exports, "MdTranslate", ()=>MdTranslate);
parcelHelpers.export(exports, "MdTrendingDown", ()=>MdTrendingDown);
parcelHelpers.export(exports, "MdTrendingFlat", ()=>MdTrendingFlat);
parcelHelpers.export(exports, "MdTrendingUp", ()=>MdTrendingUp);
parcelHelpers.export(exports, "MdTroubleshoot", ()=>MdTroubleshoot);
parcelHelpers.export(exports, "MdTry", ()=>MdTry);
parcelHelpers.export(exports, "MdTurnedInNot", ()=>MdTurnedInNot);
parcelHelpers.export(exports, "MdTurnedIn", ()=>MdTurnedIn);
parcelHelpers.export(exports, "MdUnfoldLessDouble", ()=>MdUnfoldLessDouble);
parcelHelpers.export(exports, "MdUnfoldMoreDouble", ()=>MdUnfoldMoreDouble);
parcelHelpers.export(exports, "MdUnpublished", ()=>MdUnpublished);
parcelHelpers.export(exports, "MdUpdateDisabled", ()=>MdUpdateDisabled);
parcelHelpers.export(exports, "MdUpdate", ()=>MdUpdate);
parcelHelpers.export(exports, "MdUpgrade", ()=>MdUpgrade);
parcelHelpers.export(exports, "MdVerifiedUser", ()=>MdVerifiedUser);
parcelHelpers.export(exports, "MdVerified", ()=>MdVerified);
parcelHelpers.export(exports, "MdVerticalSplit", ()=>MdVerticalSplit);
parcelHelpers.export(exports, "MdViewAgenda", ()=>MdViewAgenda);
parcelHelpers.export(exports, "MdViewArray", ()=>MdViewArray);
parcelHelpers.export(exports, "MdViewCarousel", ()=>MdViewCarousel);
parcelHelpers.export(exports, "MdViewColumn", ()=>MdViewColumn);
parcelHelpers.export(exports, "MdViewComfyAlt", ()=>MdViewComfyAlt);
parcelHelpers.export(exports, "MdViewCompactAlt", ()=>MdViewCompactAlt);
parcelHelpers.export(exports, "MdViewCozy", ()=>MdViewCozy);
parcelHelpers.export(exports, "MdViewDay", ()=>MdViewDay);
parcelHelpers.export(exports, "MdViewHeadline", ()=>MdViewHeadline);
parcelHelpers.export(exports, "MdViewInAr", ()=>MdViewInAr);
parcelHelpers.export(exports, "MdViewKanban", ()=>MdViewKanban);
parcelHelpers.export(exports, "MdViewList", ()=>MdViewList);
parcelHelpers.export(exports, "MdViewModule", ()=>MdViewModule);
parcelHelpers.export(exports, "MdViewQuilt", ()=>MdViewQuilt);
parcelHelpers.export(exports, "MdViewSidebar", ()=>MdViewSidebar);
parcelHelpers.export(exports, "MdViewStream", ()=>MdViewStream);
parcelHelpers.export(exports, "MdViewTimeline", ()=>MdViewTimeline);
parcelHelpers.export(exports, "MdViewWeek", ()=>MdViewWeek);
parcelHelpers.export(exports, "MdVisibilityOff", ()=>MdVisibilityOff);
parcelHelpers.export(exports, "MdVisibility", ()=>MdVisibility);
parcelHelpers.export(exports, "MdVoiceOverOff", ()=>MdVoiceOverOff);
parcelHelpers.export(exports, "MdWatchLater", ()=>MdWatchLater);
parcelHelpers.export(exports, "MdWebhook", ()=>MdWebhook);
parcelHelpers.export(exports, "MdWidthFull", ()=>MdWidthFull);
parcelHelpers.export(exports, "MdWidthNormal", ()=>MdWidthNormal);
parcelHelpers.export(exports, "MdWidthWide", ()=>MdWidthWide);
parcelHelpers.export(exports, "MdWifiProtectedSetup", ()=>MdWifiProtectedSetup);
parcelHelpers.export(exports, "MdWorkHistory", ()=>MdWorkHistory);
parcelHelpers.export(exports, "MdWorkOff", ()=>MdWorkOff);
parcelHelpers.export(exports, "MdWorkOutline", ()=>MdWorkOutline);
parcelHelpers.export(exports, "MdWork", ()=>MdWork);
parcelHelpers.export(exports, "MdWysiwyg", ()=>MdWysiwyg);
parcelHelpers.export(exports, "MdYoutubeSearchedFor", ()=>MdYoutubeSearchedFor);
parcelHelpers.export(exports, "MdZoomIn", ()=>MdZoomIn);
parcelHelpers.export(exports, "MdZoomOut", ()=>MdZoomOut);
parcelHelpers.export(exports, "MdAddAlert", ()=>MdAddAlert);
parcelHelpers.export(exports, "MdAutoDelete", ()=>MdAutoDelete);
parcelHelpers.export(exports, "MdErrorOutline", ()=>MdErrorOutline);
parcelHelpers.export(exports, "MdError", ()=>MdError);
parcelHelpers.export(exports, "MdNotificationImportant", ()=>MdNotificationImportant);
parcelHelpers.export(exports, "MdWarningAmber", ()=>MdWarningAmber);
parcelHelpers.export(exports, "MdWarning", ()=>MdWarning);
parcelHelpers.export(exports, "Md10K", ()=>Md10K);
parcelHelpers.export(exports, "Md1KPlus", ()=>Md1KPlus);
parcelHelpers.export(exports, "Md1K", ()=>Md1K);
parcelHelpers.export(exports, "Md2KPlus", ()=>Md2KPlus);
parcelHelpers.export(exports, "Md2K", ()=>Md2K);
parcelHelpers.export(exports, "Md3KPlus", ()=>Md3KPlus);
parcelHelpers.export(exports, "Md3K", ()=>Md3K);
parcelHelpers.export(exports, "Md4KPlus", ()=>Md4KPlus);
parcelHelpers.export(exports, "Md4K", ()=>Md4K);
parcelHelpers.export(exports, "Md5G", ()=>Md5G);
parcelHelpers.export(exports, "Md5KPlus", ()=>Md5KPlus);
parcelHelpers.export(exports, "Md5K", ()=>Md5K);
parcelHelpers.export(exports, "Md6KPlus", ()=>Md6KPlus);
parcelHelpers.export(exports, "Md6K", ()=>Md6K);
parcelHelpers.export(exports, "Md7KPlus", ()=>Md7KPlus);
parcelHelpers.export(exports, "Md7K", ()=>Md7K);
parcelHelpers.export(exports, "Md8KPlus", ()=>Md8KPlus);
parcelHelpers.export(exports, "Md8K", ()=>Md8K);
parcelHelpers.export(exports, "Md9KPlus", ()=>Md9KPlus);
parcelHelpers.export(exports, "Md9K", ()=>Md9K);
parcelHelpers.export(exports, "MdAddToQueue", ()=>MdAddToQueue);
parcelHelpers.export(exports, "MdAirplay", ()=>MdAirplay);
parcelHelpers.export(exports, "MdAlbum", ()=>MdAlbum);
parcelHelpers.export(exports, "MdArtTrack", ()=>MdArtTrack);
parcelHelpers.export(exports, "MdAudioFile", ()=>MdAudioFile);
parcelHelpers.export(exports, "MdAvTimer", ()=>MdAvTimer);
parcelHelpers.export(exports, "MdBrandingWatermark", ()=>MdBrandingWatermark);
parcelHelpers.export(exports, "MdCallToAction", ()=>MdCallToAction);
parcelHelpers.export(exports, "MdClosedCaptionDisabled", ()=>MdClosedCaptionDisabled);
parcelHelpers.export(exports, "MdClosedCaptionOff", ()=>MdClosedCaptionOff);
parcelHelpers.export(exports, "MdClosedCaption", ()=>MdClosedCaption);
parcelHelpers.export(exports, "MdControlCamera", ()=>MdControlCamera);
parcelHelpers.export(exports, "MdEqualizer", ()=>MdEqualizer);
parcelHelpers.export(exports, "MdExplicit", ()=>MdExplicit);
parcelHelpers.export(exports, "MdFastForward", ()=>MdFastForward);
parcelHelpers.export(exports, "MdFastRewind", ()=>MdFastRewind);
parcelHelpers.export(exports, "MdFeaturedPlayList", ()=>MdFeaturedPlayList);
parcelHelpers.export(exports, "MdFeaturedVideo", ()=>MdFeaturedVideo);
parcelHelpers.export(exports, "MdFiberDvr", ()=>MdFiberDvr);
parcelHelpers.export(exports, "MdFiberManualRecord", ()=>MdFiberManualRecord);
parcelHelpers.export(exports, "MdFiberNew", ()=>MdFiberNew);
parcelHelpers.export(exports, "MdFiberPin", ()=>MdFiberPin);
parcelHelpers.export(exports, "MdFiberSmartRecord", ()=>MdFiberSmartRecord);
parcelHelpers.export(exports, "MdForward10", ()=>MdForward10);
parcelHelpers.export(exports, "MdForward30", ()=>MdForward30);
parcelHelpers.export(exports, "MdForward5", ()=>MdForward5);
parcelHelpers.export(exports, "MdGames", ()=>MdGames);
parcelHelpers.export(exports, "MdHd", ()=>MdHd);
parcelHelpers.export(exports, "MdHearingDisabled", ()=>MdHearingDisabled);
parcelHelpers.export(exports, "MdHearing", ()=>MdHearing);
parcelHelpers.export(exports, "MdHighQuality", ()=>MdHighQuality);
parcelHelpers.export(exports, "MdInterpreterMode", ()=>MdInterpreterMode);
parcelHelpers.export(exports, "MdLibraryAddCheck", ()=>MdLibraryAddCheck);
parcelHelpers.export(exports, "MdLibraryAdd", ()=>MdLibraryAdd);
parcelHelpers.export(exports, "MdLibraryBooks", ()=>MdLibraryBooks);
parcelHelpers.export(exports, "MdLibraryMusic", ()=>MdLibraryMusic);
parcelHelpers.export(exports, "MdLoop", ()=>MdLoop);
parcelHelpers.export(exports, "MdLyrics", ()=>MdLyrics);
parcelHelpers.export(exports, "MdMicNone", ()=>MdMicNone);
parcelHelpers.export(exports, "MdMicOff", ()=>MdMicOff);
parcelHelpers.export(exports, "MdMic", ()=>MdMic);
parcelHelpers.export(exports, "MdMissedVideoCall", ()=>MdMissedVideoCall);
parcelHelpers.export(exports, "MdMovieEdit", ()=>MdMovieEdit);
parcelHelpers.export(exports, "MdMovie", ()=>MdMovie);
parcelHelpers.export(exports, "MdMusicVideo", ()=>MdMusicVideo);
parcelHelpers.export(exports, "MdNewReleases", ()=>MdNewReleases);
parcelHelpers.export(exports, "MdNotInterested", ()=>MdNotInterested);
parcelHelpers.export(exports, "MdNote", ()=>MdNote);
parcelHelpers.export(exports, "MdPauseCircleFilled", ()=>MdPauseCircleFilled);
parcelHelpers.export(exports, "MdPauseCircleOutline", ()=>MdPauseCircleOutline);
parcelHelpers.export(exports, "MdPauseCircle", ()=>MdPauseCircle);
parcelHelpers.export(exports, "MdPause", ()=>MdPause);
parcelHelpers.export(exports, "MdPlayArrow", ()=>MdPlayArrow);
parcelHelpers.export(exports, "MdPlayCircleFilled", ()=>MdPlayCircleFilled);
parcelHelpers.export(exports, "MdPlayCircleOutline", ()=>MdPlayCircleOutline);
parcelHelpers.export(exports, "MdPlayCircle", ()=>MdPlayCircle);
parcelHelpers.export(exports, "MdPlayDisabled", ()=>MdPlayDisabled);
parcelHelpers.export(exports, "MdPlaylistAddCheckCircle", ()=>MdPlaylistAddCheckCircle);
parcelHelpers.export(exports, "MdPlaylistAddCheck", ()=>MdPlaylistAddCheck);
parcelHelpers.export(exports, "MdPlaylistAddCircle", ()=>MdPlaylistAddCircle);
parcelHelpers.export(exports, "MdPlaylistAdd", ()=>MdPlaylistAdd);
parcelHelpers.export(exports, "MdPlaylistPlay", ()=>MdPlaylistPlay);
parcelHelpers.export(exports, "MdPlaylistRemove", ()=>MdPlaylistRemove);
parcelHelpers.export(exports, "MdQueueMusic", ()=>MdQueueMusic);
parcelHelpers.export(exports, "MdQueuePlayNext", ()=>MdQueuePlayNext);
parcelHelpers.export(exports, "MdQueue", ()=>MdQueue);
parcelHelpers.export(exports, "MdRadio", ()=>MdRadio);
parcelHelpers.export(exports, "MdRecentActors", ()=>MdRecentActors);
parcelHelpers.export(exports, "MdRemoveFromQueue", ()=>MdRemoveFromQueue);
parcelHelpers.export(exports, "MdRepeatOn", ()=>MdRepeatOn);
parcelHelpers.export(exports, "MdRepeatOneOn", ()=>MdRepeatOneOn);
parcelHelpers.export(exports, "MdRepeatOne", ()=>MdRepeatOne);
parcelHelpers.export(exports, "MdRepeat", ()=>MdRepeat);
parcelHelpers.export(exports, "MdReplay10", ()=>MdReplay10);
parcelHelpers.export(exports, "MdReplay30", ()=>MdReplay30);
parcelHelpers.export(exports, "MdReplay5", ()=>MdReplay5);
parcelHelpers.export(exports, "MdReplayCircleFilled", ()=>MdReplayCircleFilled);
parcelHelpers.export(exports, "MdReplay", ()=>MdReplay);
parcelHelpers.export(exports, "MdSd", ()=>MdSd);
parcelHelpers.export(exports, "MdShuffleOn", ()=>MdShuffleOn);
parcelHelpers.export(exports, "MdShuffle", ()=>MdShuffle);
parcelHelpers.export(exports, "MdSkipNext", ()=>MdSkipNext);
parcelHelpers.export(exports, "MdSkipPrevious", ()=>MdSkipPrevious);
parcelHelpers.export(exports, "MdSlowMotionVideo", ()=>MdSlowMotionVideo);
parcelHelpers.export(exports, "MdSnooze", ()=>MdSnooze);
parcelHelpers.export(exports, "MdSortByAlpha", ()=>MdSortByAlpha);
parcelHelpers.export(exports, "MdSpeed", ()=>MdSpeed);
parcelHelpers.export(exports, "MdStopCircle", ()=>MdStopCircle);
parcelHelpers.export(exports, "MdStop", ()=>MdStop);
parcelHelpers.export(exports, "MdSubscriptions", ()=>MdSubscriptions);
parcelHelpers.export(exports, "MdSubtitles", ()=>MdSubtitles);
parcelHelpers.export(exports, "MdSurroundSound", ()=>MdSurroundSound);
parcelHelpers.export(exports, "MdVideoCall", ()=>MdVideoCall);
parcelHelpers.export(exports, "MdVideoFile", ()=>MdVideoFile);
parcelHelpers.export(exports, "MdVideoLabel", ()=>MdVideoLabel);
parcelHelpers.export(exports, "MdVideoLibrary", ()=>MdVideoLibrary);
parcelHelpers.export(exports, "MdVideoSettings", ()=>MdVideoSettings);
parcelHelpers.export(exports, "MdVideocamOff", ()=>MdVideocamOff);
parcelHelpers.export(exports, "MdVideocam", ()=>MdVideocam);
parcelHelpers.export(exports, "MdVolumeDownAlt", ()=>MdVolumeDownAlt);
parcelHelpers.export(exports, "MdVolumeDown", ()=>MdVolumeDown);
parcelHelpers.export(exports, "MdVolumeMute", ()=>MdVolumeMute);
parcelHelpers.export(exports, "MdVolumeOff", ()=>MdVolumeOff);
parcelHelpers.export(exports, "MdVolumeUp", ()=>MdVolumeUp);
parcelHelpers.export(exports, "MdWebAssetOff", ()=>MdWebAssetOff);
parcelHelpers.export(exports, "MdWebAsset", ()=>MdWebAsset);
parcelHelpers.export(exports, "MdWeb", ()=>MdWeb);
parcelHelpers.export(exports, "Md3P", ()=>Md3P);
parcelHelpers.export(exports, "MdAddIcCall", ()=>MdAddIcCall);
parcelHelpers.export(exports, "MdAlternateEmail", ()=>MdAlternateEmail);
parcelHelpers.export(exports, "MdAppRegistration", ()=>MdAppRegistration);
parcelHelpers.export(exports, "MdBusiness", ()=>MdBusiness);
parcelHelpers.export(exports, "MdCallEnd", ()=>MdCallEnd);
parcelHelpers.export(exports, "MdCallMade", ()=>MdCallMade);
parcelHelpers.export(exports, "MdCallMerge", ()=>MdCallMerge);
parcelHelpers.export(exports, "MdCallMissedOutgoing", ()=>MdCallMissedOutgoing);
parcelHelpers.export(exports, "MdCallMissed", ()=>MdCallMissed);
parcelHelpers.export(exports, "MdCallReceived", ()=>MdCallReceived);
parcelHelpers.export(exports, "MdCallSplit", ()=>MdCallSplit);
parcelHelpers.export(exports, "MdCall", ()=>MdCall);
parcelHelpers.export(exports, "MdCancelPresentation", ()=>MdCancelPresentation);
parcelHelpers.export(exports, "MdCellTower", ()=>MdCellTower);
parcelHelpers.export(exports, "MdCellWifi", ()=>MdCellWifi);
parcelHelpers.export(exports, "MdChatBubbleOutline", ()=>MdChatBubbleOutline);
parcelHelpers.export(exports, "MdChatBubble", ()=>MdChatBubble);
parcelHelpers.export(exports, "MdChat", ()=>MdChat);
parcelHelpers.export(exports, "MdClearAll", ()=>MdClearAll);
parcelHelpers.export(exports, "MdCoPresent", ()=>MdCoPresent);
parcelHelpers.export(exports, "MdComment", ()=>MdComment);
parcelHelpers.export(exports, "MdCommentsDisabled", ()=>MdCommentsDisabled);
parcelHelpers.export(exports, "MdContactEmergency", ()=>MdContactEmergency);
parcelHelpers.export(exports, "MdContactMail", ()=>MdContactMail);
parcelHelpers.export(exports, "MdContactPhone", ()=>MdContactPhone);
parcelHelpers.export(exports, "MdContacts", ()=>MdContacts);
parcelHelpers.export(exports, "MdDesktopAccessDisabled", ()=>MdDesktopAccessDisabled);
parcelHelpers.export(exports, "MdDialerSip", ()=>MdDialerSip);
parcelHelpers.export(exports, "MdDialpad", ()=>MdDialpad);
parcelHelpers.export(exports, "MdDocumentScanner", ()=>MdDocumentScanner);
parcelHelpers.export(exports, "MdDomainDisabled", ()=>MdDomainDisabled);
parcelHelpers.export(exports, "MdDomainVerification", ()=>MdDomainVerification);
parcelHelpers.export(exports, "MdDuo", ()=>MdDuo);
parcelHelpers.export(exports, "MdEmail", ()=>MdEmail);
parcelHelpers.export(exports, "MdForum", ()=>MdForum);
parcelHelpers.export(exports, "MdForwardToInbox", ()=>MdForwardToInbox);
parcelHelpers.export(exports, "MdHourglassBottom", ()=>MdHourglassBottom);
parcelHelpers.export(exports, "MdHourglassTop", ()=>MdHourglassTop);
parcelHelpers.export(exports, "MdHub", ()=>MdHub);
parcelHelpers.export(exports, "MdImportContacts", ()=>MdImportContacts);
parcelHelpers.export(exports, "MdImportExport", ()=>MdImportExport);
parcelHelpers.export(exports, "MdInvertColorsOff", ()=>MdInvertColorsOff);
parcelHelpers.export(exports, "MdKeyOff", ()=>MdKeyOff);
parcelHelpers.export(exports, "MdKey", ()=>MdKey);
parcelHelpers.export(exports, "MdListAlt", ()=>MdListAlt);
parcelHelpers.export(exports, "MdLiveHelp", ()=>MdLiveHelp);
parcelHelpers.export(exports, "MdLocationOff", ()=>MdLocationOff);
parcelHelpers.export(exports, "MdLocationOn", ()=>MdLocationOn);
parcelHelpers.export(exports, "MdMailLock", ()=>MdMailLock);
parcelHelpers.export(exports, "MdMailOutline", ()=>MdMailOutline);
parcelHelpers.export(exports, "MdMarkChatRead", ()=>MdMarkChatRead);
parcelHelpers.export(exports, "MdMarkChatUnread", ()=>MdMarkChatUnread);
parcelHelpers.export(exports, "MdMarkEmailRead", ()=>MdMarkEmailRead);
parcelHelpers.export(exports, "MdMarkEmailUnread", ()=>MdMarkEmailUnread);
parcelHelpers.export(exports, "MdMarkUnreadChatAlt", ()=>MdMarkUnreadChatAlt);
parcelHelpers.export(exports, "MdMessage", ()=>MdMessage);
parcelHelpers.export(exports, "MdMobileScreenShare", ()=>MdMobileScreenShare);
parcelHelpers.export(exports, "MdMoreTime", ()=>MdMoreTime);
parcelHelpers.export(exports, "MdNat", ()=>MdNat);
parcelHelpers.export(exports, "MdNoSim", ()=>MdNoSim);
parcelHelpers.export(exports, "MdPausePresentation", ()=>MdPausePresentation);
parcelHelpers.export(exports, "MdPersonAddDisabled", ()=>MdPersonAddDisabled);
parcelHelpers.export(exports, "MdPersonSearch", ()=>MdPersonSearch);
parcelHelpers.export(exports, "MdPhoneDisabled", ()=>MdPhoneDisabled);
parcelHelpers.export(exports, "MdPhoneEnabled", ()=>MdPhoneEnabled);
parcelHelpers.export(exports, "MdPhone", ()=>MdPhone);
parcelHelpers.export(exports, "MdPhonelinkErase", ()=>MdPhonelinkErase);
parcelHelpers.export(exports, "MdPhonelinkLock", ()=>MdPhonelinkLock);
parcelHelpers.export(exports, "MdPhonelinkRing", ()=>MdPhonelinkRing);
parcelHelpers.export(exports, "MdPhonelinkSetup", ()=>MdPhonelinkSetup);
parcelHelpers.export(exports, "MdPortableWifiOff", ()=>MdPortableWifiOff);
parcelHelpers.export(exports, "MdPresentToAll", ()=>MdPresentToAll);
parcelHelpers.export(exports, "MdPrintDisabled", ()=>MdPrintDisabled);
parcelHelpers.export(exports, "MdQrCode2", ()=>MdQrCode2);
parcelHelpers.export(exports, "MdQrCodeScanner", ()=>MdQrCodeScanner);
parcelHelpers.export(exports, "MdQrCode", ()=>MdQrCode);
parcelHelpers.export(exports, "MdReadMore", ()=>MdReadMore);
parcelHelpers.export(exports, "MdRingVolume", ()=>MdRingVolume);
parcelHelpers.export(exports, "MdRssFeed", ()=>MdRssFeed);
parcelHelpers.export(exports, "MdRtt", ()=>MdRtt);
parcelHelpers.export(exports, "MdScreenShare", ()=>MdScreenShare);
parcelHelpers.export(exports, "MdSendTimeExtension", ()=>MdSendTimeExtension);
parcelHelpers.export(exports, "MdSentimentSatisfiedAlt", ()=>MdSentimentSatisfiedAlt);
parcelHelpers.export(exports, "MdSip", ()=>MdSip);
parcelHelpers.export(exports, "MdSpeakerPhone", ()=>MdSpeakerPhone);
parcelHelpers.export(exports, "MdSpoke", ()=>MdSpoke);
parcelHelpers.export(exports, "MdStayCurrentLandscape", ()=>MdStayCurrentLandscape);
parcelHelpers.export(exports, "MdStayCurrentPortrait", ()=>MdStayCurrentPortrait);
parcelHelpers.export(exports, "MdStayPrimaryLandscape", ()=>MdStayPrimaryLandscape);
parcelHelpers.export(exports, "MdStayPrimaryPortrait", ()=>MdStayPrimaryPortrait);
parcelHelpers.export(exports, "MdStopScreenShare", ()=>MdStopScreenShare);
parcelHelpers.export(exports, "MdSwapCalls", ()=>MdSwapCalls);
parcelHelpers.export(exports, "MdTextsms", ()=>MdTextsms);
parcelHelpers.export(exports, "MdUnsubscribe", ()=>MdUnsubscribe);
parcelHelpers.export(exports, "MdVoicemail", ()=>MdVoicemail);
parcelHelpers.export(exports, "MdVpnKeyOff", ()=>MdVpnKeyOff);
parcelHelpers.export(exports, "MdVpnKey", ()=>MdVpnKey);
parcelHelpers.export(exports, "MdWifiCalling", ()=>MdWifiCalling);
parcelHelpers.export(exports, "MdAddBox", ()=>MdAddBox);
parcelHelpers.export(exports, "MdAddCircleOutline", ()=>MdAddCircleOutline);
parcelHelpers.export(exports, "MdAddCircle", ()=>MdAddCircle);
parcelHelpers.export(exports, "MdAddLink", ()=>MdAddLink);
parcelHelpers.export(exports, "MdAdd", ()=>MdAdd);
parcelHelpers.export(exports, "MdAmpStories", ()=>MdAmpStories);
parcelHelpers.export(exports, "MdArchive", ()=>MdArchive);
parcelHelpers.export(exports, "MdAttribution", ()=>MdAttribution);
parcelHelpers.export(exports, "MdBackspace", ()=>MdBackspace);
parcelHelpers.export(exports, "MdBallot", ()=>MdBallot);
parcelHelpers.export(exports, "MdBiotech", ()=>MdBiotech);
parcelHelpers.export(exports, "MdBlockFlipped", ()=>MdBlockFlipped);
parcelHelpers.export(exports, "MdBlock", ()=>MdBlock);
parcelHelpers.export(exports, "MdBolt", ()=>MdBolt);
parcelHelpers.export(exports, "MdCalculate", ()=>MdCalculate);
parcelHelpers.export(exports, "MdChangeCircle", ()=>MdChangeCircle);
parcelHelpers.export(exports, "MdClear", ()=>MdClear);
parcelHelpers.export(exports, "MdContentCopy", ()=>MdContentCopy);
parcelHelpers.export(exports, "MdContentCut", ()=>MdContentCut);
parcelHelpers.export(exports, "MdContentPasteGo", ()=>MdContentPasteGo);
parcelHelpers.export(exports, "MdContentPasteOff", ()=>MdContentPasteOff);
parcelHelpers.export(exports, "MdContentPasteSearch", ()=>MdContentPasteSearch);
parcelHelpers.export(exports, "MdContentPaste", ()=>MdContentPaste);
parcelHelpers.export(exports, "MdCopyAll", ()=>MdCopyAll);
parcelHelpers.export(exports, "MdCreate", ()=>MdCreate);
parcelHelpers.export(exports, "MdDeleteSweep", ()=>MdDeleteSweep);
parcelHelpers.export(exports, "MdDeselect", ()=>MdDeselect);
parcelHelpers.export(exports, "MdDrafts", ()=>MdDrafts);
parcelHelpers.export(exports, "MdDynamicFeed", ()=>MdDynamicFeed);
parcelHelpers.export(exports, "MdFileCopy", ()=>MdFileCopy);
parcelHelpers.export(exports, "MdFilterListOff", ()=>MdFilterListOff);
parcelHelpers.export(exports, "MdFilterList", ()=>MdFilterList);
parcelHelpers.export(exports, "MdFlagCircle", ()=>MdFlagCircle);
parcelHelpers.export(exports, "MdFlag", ()=>MdFlag);
parcelHelpers.export(exports, "MdFontDownloadOff", ()=>MdFontDownloadOff);
parcelHelpers.export(exports, "MdFontDownload", ()=>MdFontDownload);
parcelHelpers.export(exports, "MdForward", ()=>MdForward);
parcelHelpers.export(exports, "MdGesture", ()=>MdGesture);
parcelHelpers.export(exports, "MdHowToReg", ()=>MdHowToReg);
parcelHelpers.export(exports, "MdHowToVote", ()=>MdHowToVote);
parcelHelpers.export(exports, "MdInbox", ()=>MdInbox);
parcelHelpers.export(exports, "MdInsights", ()=>MdInsights);
parcelHelpers.export(exports, "MdInventory2", ()=>MdInventory2);
parcelHelpers.export(exports, "MdInventory", ()=>MdInventory);
parcelHelpers.export(exports, "MdLinkOff", ()=>MdLinkOff);
parcelHelpers.export(exports, "MdLink", ()=>MdLink);
parcelHelpers.export(exports, "MdLowPriority", ()=>MdLowPriority);
parcelHelpers.export(exports, "MdMail", ()=>MdMail);
parcelHelpers.export(exports, "MdMarkunread", ()=>MdMarkunread);
parcelHelpers.export(exports, "MdMoveToInbox", ()=>MdMoveToInbox);
parcelHelpers.export(exports, "MdNextWeek", ()=>MdNextWeek);
parcelHelpers.export(exports, "MdOutlinedFlag", ()=>MdOutlinedFlag);
parcelHelpers.export(exports, "MdPolicy", ()=>MdPolicy);
parcelHelpers.export(exports, "MdPushPin", ()=>MdPushPin);
parcelHelpers.export(exports, "MdRedo", ()=>MdRedo);
parcelHelpers.export(exports, "MdRemoveCircleOutline", ()=>MdRemoveCircleOutline);
parcelHelpers.export(exports, "MdRemoveCircle", ()=>MdRemoveCircle);
parcelHelpers.export(exports, "MdRemove", ()=>MdRemove);
parcelHelpers.export(exports, "MdReplyAll", ()=>MdReplyAll);
parcelHelpers.export(exports, "MdReply", ()=>MdReply);
parcelHelpers.export(exports, "MdReportGmailerrorred", ()=>MdReportGmailerrorred);
parcelHelpers.export(exports, "MdReportOff", ()=>MdReportOff);
parcelHelpers.export(exports, "MdReport", ()=>MdReport);
parcelHelpers.export(exports, "MdSaveAlt", ()=>MdSaveAlt);
parcelHelpers.export(exports, "MdSaveAs", ()=>MdSaveAs);
parcelHelpers.export(exports, "MdSave", ()=>MdSave);
parcelHelpers.export(exports, "MdSelectAll", ()=>MdSelectAll);
parcelHelpers.export(exports, "MdSend", ()=>MdSend);
parcelHelpers.export(exports, "MdShield", ()=>MdShield);
parcelHelpers.export(exports, "MdSort", ()=>MdSort);
parcelHelpers.export(exports, "MdSquareFoot", ()=>MdSquareFoot);
parcelHelpers.export(exports, "MdStackedBarChart", ()=>MdStackedBarChart);
parcelHelpers.export(exports, "MdStream", ()=>MdStream);
parcelHelpers.export(exports, "MdTag", ()=>MdTag);
parcelHelpers.export(exports, "MdTextFormat", ()=>MdTextFormat);
parcelHelpers.export(exports, "MdUnarchive", ()=>MdUnarchive);
parcelHelpers.export(exports, "MdUndo", ()=>MdUndo);
parcelHelpers.export(exports, "MdUpcoming", ()=>MdUpcoming);
parcelHelpers.export(exports, "MdWaves", ()=>MdWaves);
parcelHelpers.export(exports, "MdWebStories", ()=>MdWebStories);
parcelHelpers.export(exports, "MdWeekend", ()=>MdWeekend);
parcelHelpers.export(exports, "MdWhereToVote", ()=>MdWhereToVote);
parcelHelpers.export(exports, "Md1XMobiledata", ()=>Md1XMobiledata);
parcelHelpers.export(exports, "Md30Fps", ()=>Md30Fps);
parcelHelpers.export(exports, "Md3GMobiledata", ()=>Md3GMobiledata);
parcelHelpers.export(exports, "Md4GMobiledata", ()=>Md4GMobiledata);
parcelHelpers.export(exports, "Md4GPlusMobiledata", ()=>Md4GPlusMobiledata);
parcelHelpers.export(exports, "Md60Fps", ()=>Md60Fps);
parcelHelpers.export(exports, "MdAccessAlarm", ()=>MdAccessAlarm);
parcelHelpers.export(exports, "MdAccessAlarms", ()=>MdAccessAlarms);
parcelHelpers.export(exports, "MdAccessTimeFilled", ()=>MdAccessTimeFilled);
parcelHelpers.export(exports, "MdAccessTime", ()=>MdAccessTime);
parcelHelpers.export(exports, "MdAdUnits", ()=>MdAdUnits);
parcelHelpers.export(exports, "MdAddAlarm", ()=>MdAddAlarm);
parcelHelpers.export(exports, "MdAddToHomeScreen", ()=>MdAddToHomeScreen);
parcelHelpers.export(exports, "MdAir", ()=>MdAir);
parcelHelpers.export(exports, "MdAirplaneTicket", ()=>MdAirplaneTicket);
parcelHelpers.export(exports, "MdAirplanemodeActive", ()=>MdAirplanemodeActive);
parcelHelpers.export(exports, "MdAirplanemodeInactive", ()=>MdAirplanemodeInactive);
parcelHelpers.export(exports, "MdAod", ()=>MdAod);
parcelHelpers.export(exports, "MdBattery0Bar", ()=>MdBattery0Bar);
parcelHelpers.export(exports, "MdBattery1Bar", ()=>MdBattery1Bar);
parcelHelpers.export(exports, "MdBattery2Bar", ()=>MdBattery2Bar);
parcelHelpers.export(exports, "MdBattery3Bar", ()=>MdBattery3Bar);
parcelHelpers.export(exports, "MdBattery4Bar", ()=>MdBattery4Bar);
parcelHelpers.export(exports, "MdBattery5Bar", ()=>MdBattery5Bar);
parcelHelpers.export(exports, "MdBattery6Bar", ()=>MdBattery6Bar);
parcelHelpers.export(exports, "MdBatteryAlert", ()=>MdBatteryAlert);
parcelHelpers.export(exports, "MdBatteryChargingFull", ()=>MdBatteryChargingFull);
parcelHelpers.export(exports, "MdBatteryFull", ()=>MdBatteryFull);
parcelHelpers.export(exports, "MdBatterySaver", ()=>MdBatterySaver);
parcelHelpers.export(exports, "MdBatteryStd", ()=>MdBatteryStd);
parcelHelpers.export(exports, "MdBatteryUnknown", ()=>MdBatteryUnknown);
parcelHelpers.export(exports, "MdBloodtype", ()=>MdBloodtype);
parcelHelpers.export(exports, "MdBluetoothConnected", ()=>MdBluetoothConnected);
parcelHelpers.export(exports, "MdBluetoothDisabled", ()=>MdBluetoothDisabled);
parcelHelpers.export(exports, "MdBluetoothDrive", ()=>MdBluetoothDrive);
parcelHelpers.export(exports, "MdBluetoothSearching", ()=>MdBluetoothSearching);
parcelHelpers.export(exports, "MdBluetooth", ()=>MdBluetooth);
parcelHelpers.export(exports, "MdBrightnessAuto", ()=>MdBrightnessAuto);
parcelHelpers.export(exports, "MdBrightnessHigh", ()=>MdBrightnessHigh);
parcelHelpers.export(exports, "MdBrightnessLow", ()=>MdBrightnessLow);
parcelHelpers.export(exports, "MdBrightnessMedium", ()=>MdBrightnessMedium);
parcelHelpers.export(exports, "MdCable", ()=>MdCable);
parcelHelpers.export(exports, "MdCameraswitch", ()=>MdCameraswitch);
parcelHelpers.export(exports, "MdCreditScore", ()=>MdCreditScore);
parcelHelpers.export(exports, "MdDarkMode", ()=>MdDarkMode);
parcelHelpers.export(exports, "MdDataSaverOff", ()=>MdDataSaverOff);
parcelHelpers.export(exports, "MdDataSaverOn", ()=>MdDataSaverOn);
parcelHelpers.export(exports, "MdDataUsage", ()=>MdDataUsage);
parcelHelpers.export(exports, "MdDatasetLinked", ()=>MdDatasetLinked);
parcelHelpers.export(exports, "MdDataset", ()=>MdDataset);
parcelHelpers.export(exports, "MdDeveloperMode", ()=>MdDeveloperMode);
parcelHelpers.export(exports, "MdDeviceThermostat", ()=>MdDeviceThermostat);
parcelHelpers.export(exports, "MdDevicesFold", ()=>MdDevicesFold);
parcelHelpers.export(exports, "MdDevices", ()=>MdDevices);
parcelHelpers.export(exports, "MdDiscount", ()=>MdDiscount);
parcelHelpers.export(exports, "MdDoNotDisturbOnTotalSilence", ()=>MdDoNotDisturbOnTotalSilence);
parcelHelpers.export(exports, "MdDvr", ()=>MdDvr);
parcelHelpers.export(exports, "MdEMobiledata", ()=>MdEMobiledata);
parcelHelpers.export(exports, "MdEdgesensorHigh", ()=>MdEdgesensorHigh);
parcelHelpers.export(exports, "MdEdgesensorLow", ()=>MdEdgesensorLow);
parcelHelpers.export(exports, "MdFlashlightOff", ()=>MdFlashlightOff);
parcelHelpers.export(exports, "MdFlashlightOn", ()=>MdFlashlightOn);
parcelHelpers.export(exports, "MdFlourescent", ()=>MdFlourescent);
parcelHelpers.export(exports, "MdFluorescent", ()=>MdFluorescent);
parcelHelpers.export(exports, "MdFmdBad", ()=>MdFmdBad);
parcelHelpers.export(exports, "MdFmdGood", ()=>MdFmdGood);
parcelHelpers.export(exports, "MdGMobiledata", ()=>MdGMobiledata);
parcelHelpers.export(exports, "MdGppBad", ()=>MdGppBad);
parcelHelpers.export(exports, "MdGppGood", ()=>MdGppGood);
parcelHelpers.export(exports, "MdGppMaybe", ()=>MdGppMaybe);
parcelHelpers.export(exports, "MdGpsFixed", ()=>MdGpsFixed);
parcelHelpers.export(exports, "MdGpsNotFixed", ()=>MdGpsNotFixed);
parcelHelpers.export(exports, "MdGpsOff", ()=>MdGpsOff);
parcelHelpers.export(exports, "MdGraphicEq", ()=>MdGraphicEq);
parcelHelpers.export(exports, "MdGrid3X3", ()=>MdGrid3X3);
parcelHelpers.export(exports, "MdGrid4X4", ()=>MdGrid4X4);
parcelHelpers.export(exports, "MdGridGoldenratio", ()=>MdGridGoldenratio);
parcelHelpers.export(exports, "MdHMobiledata", ()=>MdHMobiledata);
parcelHelpers.export(exports, "MdHPlusMobiledata", ()=>MdHPlusMobiledata);
parcelHelpers.export(exports, "MdHdrAutoSelect", ()=>MdHdrAutoSelect);
parcelHelpers.export(exports, "MdHdrAuto", ()=>MdHdrAuto);
parcelHelpers.export(exports, "MdHdrOffSelect", ()=>MdHdrOffSelect);
parcelHelpers.export(exports, "MdHdrOnSelect", ()=>MdHdrOnSelect);
parcelHelpers.export(exports, "MdLan", ()=>MdLan);
parcelHelpers.export(exports, "MdLensBlur", ()=>MdLensBlur);
parcelHelpers.export(exports, "MdLightMode", ()=>MdLightMode);
parcelHelpers.export(exports, "MdLocationDisabled", ()=>MdLocationDisabled);
parcelHelpers.export(exports, "MdLocationSearching", ()=>MdLocationSearching);
parcelHelpers.export(exports, "MdLteMobiledata", ()=>MdLteMobiledata);
parcelHelpers.export(exports, "MdLtePlusMobiledata", ()=>MdLtePlusMobiledata);
parcelHelpers.export(exports, "MdMacroOff", ()=>MdMacroOff);
parcelHelpers.export(exports, "MdMediaBluetoothOff", ()=>MdMediaBluetoothOff);
parcelHelpers.export(exports, "MdMediaBluetoothOn", ()=>MdMediaBluetoothOn);
parcelHelpers.export(exports, "MdMedicationLiquid", ()=>MdMedicationLiquid);
parcelHelpers.export(exports, "MdMedication", ()=>MdMedication);
parcelHelpers.export(exports, "MdMobileFriendly", ()=>MdMobileFriendly);
parcelHelpers.export(exports, "MdMobileOff", ()=>MdMobileOff);
parcelHelpers.export(exports, "MdMobiledataOff", ()=>MdMobiledataOff);
parcelHelpers.export(exports, "MdModeNight", ()=>MdModeNight);
parcelHelpers.export(exports, "MdModeStandby", ()=>MdModeStandby);
parcelHelpers.export(exports, "MdMonitorHeart", ()=>MdMonitorHeart);
parcelHelpers.export(exports, "MdMonitorWeight", ()=>MdMonitorWeight);
parcelHelpers.export(exports, "MdNearbyError", ()=>MdNearbyError);
parcelHelpers.export(exports, "MdNearbyOff", ()=>MdNearbyOff);
parcelHelpers.export(exports, "MdNetworkCell", ()=>MdNetworkCell);
parcelHelpers.export(exports, "MdNetworkWifi1Bar", ()=>MdNetworkWifi1Bar);
parcelHelpers.export(exports, "MdNetworkWifi2Bar", ()=>MdNetworkWifi2Bar);
parcelHelpers.export(exports, "MdNetworkWifi3Bar", ()=>MdNetworkWifi3Bar);
parcelHelpers.export(exports, "MdNetworkWifi", ()=>MdNetworkWifi);
parcelHelpers.export(exports, "MdNfc", ()=>MdNfc);
parcelHelpers.export(exports, "MdNightlight", ()=>MdNightlight);
parcelHelpers.export(exports, "MdNoteAlt", ()=>MdNoteAlt);
parcelHelpers.export(exports, "MdPassword", ()=>MdPassword);
parcelHelpers.export(exports, "MdPattern", ()=>MdPattern);
parcelHelpers.export(exports, "MdPhishing", ()=>MdPhishing);
parcelHelpers.export(exports, "MdPin", ()=>MdPin);
parcelHelpers.export(exports, "MdPlayLesson", ()=>MdPlayLesson);
parcelHelpers.export(exports, "MdPriceChange", ()=>MdPriceChange);
parcelHelpers.export(exports, "MdPriceCheck", ()=>MdPriceCheck);
parcelHelpers.export(exports, "MdPunchClock", ()=>MdPunchClock);
parcelHelpers.export(exports, "MdQuiz", ()=>MdQuiz);
parcelHelpers.export(exports, "MdRMobiledata", ()=>MdRMobiledata);
parcelHelpers.export(exports, "MdRadar", ()=>MdRadar);
parcelHelpers.export(exports, "MdRememberMe", ()=>MdRememberMe);
parcelHelpers.export(exports, "MdResetTv", ()=>MdResetTv);
parcelHelpers.export(exports, "MdRestartAlt", ()=>MdRestartAlt);
parcelHelpers.export(exports, "MdReviews", ()=>MdReviews);
parcelHelpers.export(exports, "MdRsvp", ()=>MdRsvp);
parcelHelpers.export(exports, "MdScreenLockLandscape", ()=>MdScreenLockLandscape);
parcelHelpers.export(exports, "MdScreenLockPortrait", ()=>MdScreenLockPortrait);
parcelHelpers.export(exports, "MdScreenLockRotation", ()=>MdScreenLockRotation);
parcelHelpers.export(exports, "MdScreenRotation", ()=>MdScreenRotation);
parcelHelpers.export(exports, "MdScreenSearchDesktop", ()=>MdScreenSearchDesktop);
parcelHelpers.export(exports, "MdScreenshotMonitor", ()=>MdScreenshotMonitor);
parcelHelpers.export(exports, "MdScreenshot", ()=>MdScreenshot);
parcelHelpers.export(exports, "MdSdStorage", ()=>MdSdStorage);
parcelHelpers.export(exports, "MdSecurityUpdateGood", ()=>MdSecurityUpdateGood);
parcelHelpers.export(exports, "MdSecurityUpdateWarning", ()=>MdSecurityUpdateWarning);
parcelHelpers.export(exports, "MdSecurityUpdate", ()=>MdSecurityUpdate);
parcelHelpers.export(exports, "MdSell", ()=>MdSell);
parcelHelpers.export(exports, "MdSendToMobile", ()=>MdSendToMobile);
parcelHelpers.export(exports, "MdSettingsSuggest", ()=>MdSettingsSuggest);
parcelHelpers.export(exports, "MdSettingsSystemDaydream", ()=>MdSettingsSystemDaydream);
parcelHelpers.export(exports, "MdShareLocation", ()=>MdShareLocation);
parcelHelpers.export(exports, "MdShortcut", ()=>MdShortcut);
parcelHelpers.export(exports, "MdSignalCellular0Bar", ()=>MdSignalCellular0Bar);
parcelHelpers.export(exports, "MdSignalCellular4Bar", ()=>MdSignalCellular4Bar);
parcelHelpers.export(exports, "MdSignalCellularAlt1Bar", ()=>MdSignalCellularAlt1Bar);
parcelHelpers.export(exports, "MdSignalCellularAlt2Bar", ()=>MdSignalCellularAlt2Bar);
parcelHelpers.export(exports, "MdSignalCellularAlt", ()=>MdSignalCellularAlt);
parcelHelpers.export(exports, "MdSignalCellularConnectedNoInternet0Bar", ()=>MdSignalCellularConnectedNoInternet0Bar);
parcelHelpers.export(exports, "MdSignalCellularConnectedNoInternet4Bar", ()=>MdSignalCellularConnectedNoInternet4Bar);
parcelHelpers.export(exports, "MdSignalCellularNoSim", ()=>MdSignalCellularNoSim);
parcelHelpers.export(exports, "MdSignalCellularNodata", ()=>MdSignalCellularNodata);
parcelHelpers.export(exports, "MdSignalCellularNull", ()=>MdSignalCellularNull);
parcelHelpers.export(exports, "MdSignalCellularOff", ()=>MdSignalCellularOff);
parcelHelpers.export(exports, "MdSignalWifi0Bar", ()=>MdSignalWifi0Bar);
parcelHelpers.export(exports, "MdSignalWifi4BarLock", ()=>MdSignalWifi4BarLock);
parcelHelpers.export(exports, "MdSignalWifi4Bar", ()=>MdSignalWifi4Bar);
parcelHelpers.export(exports, "MdSignalWifiBad", ()=>MdSignalWifiBad);
parcelHelpers.export(exports, "MdSignalWifiConnectedNoInternet4", ()=>MdSignalWifiConnectedNoInternet4);
parcelHelpers.export(exports, "MdSignalWifiOff", ()=>MdSignalWifiOff);
parcelHelpers.export(exports, "MdSignalWifiStatusbar4Bar", ()=>MdSignalWifiStatusbar4Bar);
parcelHelpers.export(exports, "MdSignalWifiStatusbarConnectedNoInternet4", ()=>MdSignalWifiStatusbarConnectedNoInternet4);
parcelHelpers.export(exports, "MdSignalWifiStatusbarNull", ()=>MdSignalWifiStatusbarNull);
parcelHelpers.export(exports, "MdSimCardDownload", ()=>MdSimCardDownload);
parcelHelpers.export(exports, "MdSplitscreen", ()=>MdSplitscreen);
parcelHelpers.export(exports, "MdSportsScore", ()=>MdSportsScore);
parcelHelpers.export(exports, "MdSsidChart", ()=>MdSsidChart);
parcelHelpers.export(exports, "MdStorage", ()=>MdStorage);
parcelHelpers.export(exports, "MdStorm", ()=>MdStorm);
parcelHelpers.export(exports, "MdSummarize", ()=>MdSummarize);
parcelHelpers.export(exports, "MdSystemSecurityUpdateGood", ()=>MdSystemSecurityUpdateGood);
parcelHelpers.export(exports, "MdSystemSecurityUpdateWarning", ()=>MdSystemSecurityUpdateWarning);
parcelHelpers.export(exports, "MdSystemSecurityUpdate", ()=>MdSystemSecurityUpdate);
parcelHelpers.export(exports, "MdTask", ()=>MdTask);
parcelHelpers.export(exports, "MdThermostat", ()=>MdThermostat);
parcelHelpers.export(exports, "MdTimer10Select", ()=>MdTimer10Select);
parcelHelpers.export(exports, "MdTimer3Select", ()=>MdTimer3Select);
parcelHelpers.export(exports, "MdTungsten", ()=>MdTungsten);
parcelHelpers.export(exports, "MdUsbOff", ()=>MdUsbOff);
parcelHelpers.export(exports, "MdUsb", ()=>MdUsb);
parcelHelpers.export(exports, "MdWallpaper", ()=>MdWallpaper);
parcelHelpers.export(exports, "MdWater", ()=>MdWater);
parcelHelpers.export(exports, "MdWidgets", ()=>MdWidgets);
parcelHelpers.export(exports, "MdWifi1Bar", ()=>MdWifi1Bar);
parcelHelpers.export(exports, "MdWifi2Bar", ()=>MdWifi2Bar);
parcelHelpers.export(exports, "MdWifiCalling3", ()=>MdWifiCalling3);
parcelHelpers.export(exports, "MdWifiChannel", ()=>MdWifiChannel);
parcelHelpers.export(exports, "MdWifiFind", ()=>MdWifiFind);
parcelHelpers.export(exports, "MdWifiLock", ()=>MdWifiLock);
parcelHelpers.export(exports, "MdWifiPassword", ()=>MdWifiPassword);
parcelHelpers.export(exports, "MdWifiTetheringErrorRounded", ()=>MdWifiTetheringErrorRounded);
parcelHelpers.export(exports, "MdWifiTetheringError", ()=>MdWifiTetheringError);
parcelHelpers.export(exports, "MdWifiTetheringOff", ()=>MdWifiTetheringOff);
parcelHelpers.export(exports, "MdWifiTethering", ()=>MdWifiTethering);
parcelHelpers.export(exports, "MdAddChart", ()=>MdAddChart);
parcelHelpers.export(exports, "MdAddComment", ()=>MdAddComment);
parcelHelpers.export(exports, "MdAlignHorizontalCenter", ()=>MdAlignHorizontalCenter);
parcelHelpers.export(exports, "MdAlignHorizontalLeft", ()=>MdAlignHorizontalLeft);
parcelHelpers.export(exports, "MdAlignHorizontalRight", ()=>MdAlignHorizontalRight);
parcelHelpers.export(exports, "MdAlignVerticalBottom", ()=>MdAlignVerticalBottom);
parcelHelpers.export(exports, "MdAlignVerticalCenter", ()=>MdAlignVerticalCenter);
parcelHelpers.export(exports, "MdAlignVerticalTop", ()=>MdAlignVerticalTop);
parcelHelpers.export(exports, "MdAreaChart", ()=>MdAreaChart);
parcelHelpers.export(exports, "MdAttachFile", ()=>MdAttachFile);
parcelHelpers.export(exports, "MdAttachMoney", ()=>MdAttachMoney);
parcelHelpers.export(exports, "MdAutoGraph", ()=>MdAutoGraph);
parcelHelpers.export(exports, "MdBarChart", ()=>MdBarChart);
parcelHelpers.export(exports, "MdBorderAll", ()=>MdBorderAll);
parcelHelpers.export(exports, "MdBorderBottom", ()=>MdBorderBottom);
parcelHelpers.export(exports, "MdBorderClear", ()=>MdBorderClear);
parcelHelpers.export(exports, "MdBorderColor", ()=>MdBorderColor);
parcelHelpers.export(exports, "MdBorderHorizontal", ()=>MdBorderHorizontal);
parcelHelpers.export(exports, "MdBorderInner", ()=>MdBorderInner);
parcelHelpers.export(exports, "MdBorderLeft", ()=>MdBorderLeft);
parcelHelpers.export(exports, "MdBorderOuter", ()=>MdBorderOuter);
parcelHelpers.export(exports, "MdBorderRight", ()=>MdBorderRight);
parcelHelpers.export(exports, "MdBorderStyle", ()=>MdBorderStyle);
parcelHelpers.export(exports, "MdBorderTop", ()=>MdBorderTop);
parcelHelpers.export(exports, "MdBorderVertical", ()=>MdBorderVertical);
parcelHelpers.export(exports, "MdBubbleChart", ()=>MdBubbleChart);
parcelHelpers.export(exports, "MdCandlestickChart", ()=>MdCandlestickChart);
parcelHelpers.export(exports, "MdChecklistRtl", ()=>MdChecklistRtl);
parcelHelpers.export(exports, "MdChecklist", ()=>MdChecklist);
parcelHelpers.export(exports, "MdDataArray", ()=>MdDataArray);
parcelHelpers.export(exports, "MdDataObject", ()=>MdDataObject);
parcelHelpers.export(exports, "MdDragHandle", ()=>MdDragHandle);
parcelHelpers.export(exports, "MdDraw", ()=>MdDraw);
parcelHelpers.export(exports, "MdEditNote", ()=>MdEditNote);
parcelHelpers.export(exports, "MdFormatAlignCenter", ()=>MdFormatAlignCenter);
parcelHelpers.export(exports, "MdFormatAlignJustify", ()=>MdFormatAlignJustify);
parcelHelpers.export(exports, "MdFormatAlignLeft", ()=>MdFormatAlignLeft);
parcelHelpers.export(exports, "MdFormatAlignRight", ()=>MdFormatAlignRight);
parcelHelpers.export(exports, "MdFormatBold", ()=>MdFormatBold);
parcelHelpers.export(exports, "MdFormatClear", ()=>MdFormatClear);
parcelHelpers.export(exports, "MdFormatColorFill", ()=>MdFormatColorFill);
parcelHelpers.export(exports, "MdFormatColorReset", ()=>MdFormatColorReset);
parcelHelpers.export(exports, "MdFormatColorText", ()=>MdFormatColorText);
parcelHelpers.export(exports, "MdFormatIndentDecrease", ()=>MdFormatIndentDecrease);
parcelHelpers.export(exports, "MdFormatIndentIncrease", ()=>MdFormatIndentIncrease);
parcelHelpers.export(exports, "MdFormatItalic", ()=>MdFormatItalic);
parcelHelpers.export(exports, "MdFormatLineSpacing", ()=>MdFormatLineSpacing);
parcelHelpers.export(exports, "MdFormatListBulletedAdd", ()=>MdFormatListBulletedAdd);
parcelHelpers.export(exports, "MdFormatListBulleted", ()=>MdFormatListBulleted);
parcelHelpers.export(exports, "MdFormatListNumberedRtl", ()=>MdFormatListNumberedRtl);
parcelHelpers.export(exports, "MdFormatListNumbered", ()=>MdFormatListNumbered);
parcelHelpers.export(exports, "MdFormatPaint", ()=>MdFormatPaint);
parcelHelpers.export(exports, "MdFormatQuote", ()=>MdFormatQuote);
parcelHelpers.export(exports, "MdFormatShapes", ()=>MdFormatShapes);
parcelHelpers.export(exports, "MdFormatSize", ()=>MdFormatSize);
parcelHelpers.export(exports, "MdFormatStrikethrough", ()=>MdFormatStrikethrough);
parcelHelpers.export(exports, "MdFormatTextdirectionLToR", ()=>MdFormatTextdirectionLToR);
parcelHelpers.export(exports, "MdFormatTextdirectionRToL", ()=>MdFormatTextdirectionRToL);
parcelHelpers.export(exports, "MdFormatUnderlined", ()=>MdFormatUnderlined);
parcelHelpers.export(exports, "MdFunctions", ()=>MdFunctions);
parcelHelpers.export(exports, "MdHeight", ()=>MdHeight);
parcelHelpers.export(exports, "MdHexagon", ()=>MdHexagon);
parcelHelpers.export(exports, "MdHighlight", ()=>MdHighlight);
parcelHelpers.export(exports, "MdHorizontalDistribute", ()=>MdHorizontalDistribute);
parcelHelpers.export(exports, "MdHorizontalRule", ()=>MdHorizontalRule);
parcelHelpers.export(exports, "MdInsertChartOutlined", ()=>MdInsertChartOutlined);
parcelHelpers.export(exports, "MdInsertChart", ()=>MdInsertChart);
parcelHelpers.export(exports, "MdInsertComment", ()=>MdInsertComment);
parcelHelpers.export(exports, "MdInsertDriveFile", ()=>MdInsertDriveFile);
parcelHelpers.export(exports, "MdInsertEmoticon", ()=>MdInsertEmoticon);
parcelHelpers.export(exports, "MdInsertInvitation", ()=>MdInsertInvitation);
parcelHelpers.export(exports, "MdInsertLink", ()=>MdInsertLink);
parcelHelpers.export(exports, "MdInsertPageBreak", ()=>MdInsertPageBreak);
parcelHelpers.export(exports, "MdInsertPhoto", ()=>MdInsertPhoto);
parcelHelpers.export(exports, "MdLineAxis", ()=>MdLineAxis);
parcelHelpers.export(exports, "MdLinearScale", ()=>MdLinearScale);
parcelHelpers.export(exports, "MdMargin", ()=>MdMargin);
parcelHelpers.export(exports, "MdMergeType", ()=>MdMergeType);
parcelHelpers.export(exports, "MdModeComment", ()=>MdModeComment);
parcelHelpers.export(exports, "MdModeEditOutline", ()=>MdModeEditOutline);
parcelHelpers.export(exports, "MdModeEdit", ()=>MdModeEdit);
parcelHelpers.export(exports, "MdMode", ()=>MdMode);
parcelHelpers.export(exports, "MdMonetizationOn", ()=>MdMonetizationOn);
parcelHelpers.export(exports, "MdMoneyOffCsred", ()=>MdMoneyOffCsred);
parcelHelpers.export(exports, "MdMoneyOff", ()=>MdMoneyOff);
parcelHelpers.export(exports, "MdMoveDown", ()=>MdMoveDown);
parcelHelpers.export(exports, "MdMoveUp", ()=>MdMoveUp);
parcelHelpers.export(exports, "MdMultilineChart", ()=>MdMultilineChart);
parcelHelpers.export(exports, "MdNotes", ()=>MdNotes);
parcelHelpers.export(exports, "MdNumbers", ()=>MdNumbers);
parcelHelpers.export(exports, "MdPadding", ()=>MdPadding);
parcelHelpers.export(exports, "MdPentagon", ()=>MdPentagon);
parcelHelpers.export(exports, "MdPieChartOutline", ()=>MdPieChartOutline);
parcelHelpers.export(exports, "MdPieChartOutlined", ()=>MdPieChartOutlined);
parcelHelpers.export(exports, "MdPieChart", ()=>MdPieChart);
parcelHelpers.export(exports, "MdPolyline", ()=>MdPolyline);
parcelHelpers.export(exports, "MdPostAdd", ()=>MdPostAdd);
parcelHelpers.export(exports, "MdPublish", ()=>MdPublish);
parcelHelpers.export(exports, "MdQueryStats", ()=>MdQueryStats);
parcelHelpers.export(exports, "MdRectangle", ()=>MdRectangle);
parcelHelpers.export(exports, "MdScatterPlot", ()=>MdScatterPlot);
parcelHelpers.export(exports, "MdSchema", ()=>MdSchema);
parcelHelpers.export(exports, "MdScore", ()=>MdScore);
parcelHelpers.export(exports, "MdShapeLine", ()=>MdShapeLine);
parcelHelpers.export(exports, "MdShortText", ()=>MdShortText);
parcelHelpers.export(exports, "MdShowChart", ()=>MdShowChart);
parcelHelpers.export(exports, "MdSpaceBar", ()=>MdSpaceBar);
parcelHelpers.export(exports, "MdSquare", ()=>MdSquare);
parcelHelpers.export(exports, "MdStackedLineChart", ()=>MdStackedLineChart);
parcelHelpers.export(exports, "MdStrikethroughS", ()=>MdStrikethroughS);
parcelHelpers.export(exports, "MdSubscript", ()=>MdSubscript);
parcelHelpers.export(exports, "MdSuperscript", ()=>MdSuperscript);
parcelHelpers.export(exports, "MdTableChart", ()=>MdTableChart);
parcelHelpers.export(exports, "MdTableRows", ()=>MdTableRows);
parcelHelpers.export(exports, "MdTextDecrease", ()=>MdTextDecrease);
parcelHelpers.export(exports, "MdTextFields", ()=>MdTextFields);
parcelHelpers.export(exports, "MdTextIncrease", ()=>MdTextIncrease);
parcelHelpers.export(exports, "MdTitle", ()=>MdTitle);
parcelHelpers.export(exports, "MdTypeSpecimen", ()=>MdTypeSpecimen);
parcelHelpers.export(exports, "MdVerticalAlignBottom", ()=>MdVerticalAlignBottom);
parcelHelpers.export(exports, "MdVerticalAlignCenter", ()=>MdVerticalAlignCenter);
parcelHelpers.export(exports, "MdVerticalAlignTop", ()=>MdVerticalAlignTop);
parcelHelpers.export(exports, "MdVerticalDistribute", ()=>MdVerticalDistribute);
parcelHelpers.export(exports, "MdWrapText", ()=>MdWrapText);
parcelHelpers.export(exports, "MdApproval", ()=>MdApproval);
parcelHelpers.export(exports, "MdAttachEmail", ()=>MdAttachEmail);
parcelHelpers.export(exports, "MdAttachment", ()=>MdAttachment);
parcelHelpers.export(exports, "MdCloudCircle", ()=>MdCloudCircle);
parcelHelpers.export(exports, "MdCloudDone", ()=>MdCloudDone);
parcelHelpers.export(exports, "MdCloudDownload", ()=>MdCloudDownload);
parcelHelpers.export(exports, "MdCloudOff", ()=>MdCloudOff);
parcelHelpers.export(exports, "MdCloudQueue", ()=>MdCloudQueue);
parcelHelpers.export(exports, "MdCloudSync", ()=>MdCloudSync);
parcelHelpers.export(exports, "MdCloudUpload", ()=>MdCloudUpload);
parcelHelpers.export(exports, "MdCloud", ()=>MdCloud);
parcelHelpers.export(exports, "MdCreateNewFolder", ()=>MdCreateNewFolder);
parcelHelpers.export(exports, "MdDifference", ()=>MdDifference);
parcelHelpers.export(exports, "MdDownloadDone", ()=>MdDownloadDone);
parcelHelpers.export(exports, "MdDownloadForOffline", ()=>MdDownloadForOffline);
parcelHelpers.export(exports, "MdDownload", ()=>MdDownload);
parcelHelpers.export(exports, "MdDownloading", ()=>MdDownloading);
parcelHelpers.export(exports, "MdDriveFileMoveOutline", ()=>MdDriveFileMoveOutline);
parcelHelpers.export(exports, "MdDriveFileMoveRtl", ()=>MdDriveFileMoveRtl);
parcelHelpers.export(exports, "MdDriveFileMove", ()=>MdDriveFileMove);
parcelHelpers.export(exports, "MdDriveFileRenameOutline", ()=>MdDriveFileRenameOutline);
parcelHelpers.export(exports, "MdDriveFolderUpload", ()=>MdDriveFolderUpload);
parcelHelpers.export(exports, "MdFileDownloadDone", ()=>MdFileDownloadDone);
parcelHelpers.export(exports, "MdFileDownloadOff", ()=>MdFileDownloadOff);
parcelHelpers.export(exports, "MdFileDownload", ()=>MdFileDownload);
parcelHelpers.export(exports, "MdFileOpen", ()=>MdFileOpen);
parcelHelpers.export(exports, "MdFileUploadOff", ()=>MdFileUploadOff);
parcelHelpers.export(exports, "MdFileUpload", ()=>MdFileUpload);
parcelHelpers.export(exports, "MdFolderCopy", ()=>MdFolderCopy);
parcelHelpers.export(exports, "MdFolderDelete", ()=>MdFolderDelete);
parcelHelpers.export(exports, "MdFolderOff", ()=>MdFolderOff);
parcelHelpers.export(exports, "MdFolderOpen", ()=>MdFolderOpen);
parcelHelpers.export(exports, "MdFolderShared", ()=>MdFolderShared);
parcelHelpers.export(exports, "MdFolderZip", ()=>MdFolderZip);
parcelHelpers.export(exports, "MdFolder", ()=>MdFolder);
parcelHelpers.export(exports, "MdFormatOverline", ()=>MdFormatOverline);
parcelHelpers.export(exports, "MdGridView", ()=>MdGridView);
parcelHelpers.export(exports, "MdNewspaper", ()=>MdNewspaper);
parcelHelpers.export(exports, "MdRequestQuote", ()=>MdRequestQuote);
parcelHelpers.export(exports, "MdRuleFolder", ()=>MdRuleFolder);
parcelHelpers.export(exports, "MdSnippetFolder", ()=>MdSnippetFolder);
parcelHelpers.export(exports, "MdTextSnippet", ()=>MdTextSnippet);
parcelHelpers.export(exports, "MdTopic", ()=>MdTopic);
parcelHelpers.export(exports, "MdUploadFile", ()=>MdUploadFile);
parcelHelpers.export(exports, "MdUpload", ()=>MdUpload);
parcelHelpers.export(exports, "MdWorkspacesFilled", ()=>MdWorkspacesFilled);
parcelHelpers.export(exports, "MdWorkspacesOutline", ()=>MdWorkspacesOutline);
parcelHelpers.export(exports, "MdWorkspaces", ()=>MdWorkspaces);
parcelHelpers.export(exports, "MdAdfScanner", ()=>MdAdfScanner);
parcelHelpers.export(exports, "MdBrowserNotSupported", ()=>MdBrowserNotSupported);
parcelHelpers.export(exports, "MdBrowserUpdated", ()=>MdBrowserUpdated);
parcelHelpers.export(exports, "MdCastConnected", ()=>MdCastConnected);
parcelHelpers.export(exports, "MdCastForEducation", ()=>MdCastForEducation);
parcelHelpers.export(exports, "MdCast", ()=>MdCast);
parcelHelpers.export(exports, "MdComputer", ()=>MdComputer);
parcelHelpers.export(exports, "MdConnectedTv", ()=>MdConnectedTv);
parcelHelpers.export(exports, "MdConveyorBelt", ()=>MdConveyorBelt);
parcelHelpers.export(exports, "MdDesktopMac", ()=>MdDesktopMac);
parcelHelpers.export(exports, "MdDesktopWindows", ()=>MdDesktopWindows);
parcelHelpers.export(exports, "MdDeveloperBoardOff", ()=>MdDeveloperBoardOff);
parcelHelpers.export(exports, "MdDeveloperBoard", ()=>MdDeveloperBoard);
parcelHelpers.export(exports, "MdDeviceHub", ()=>MdDeviceHub);
parcelHelpers.export(exports, "MdDeviceUnknown", ()=>MdDeviceUnknown);
parcelHelpers.export(exports, "MdDevicesOther", ()=>MdDevicesOther);
parcelHelpers.export(exports, "MdDock", ()=>MdDock);
parcelHelpers.export(exports, "MdEarbudsBattery", ()=>MdEarbudsBattery);
parcelHelpers.export(exports, "MdEarbuds", ()=>MdEarbuds);
parcelHelpers.export(exports, "MdForklift", ()=>MdForklift);
parcelHelpers.export(exports, "MdFrontLoader", ()=>MdFrontLoader);
parcelHelpers.export(exports, "MdGamepad", ()=>MdGamepad);
parcelHelpers.export(exports, "MdHeadphonesBattery", ()=>MdHeadphonesBattery);
parcelHelpers.export(exports, "MdHeadphones", ()=>MdHeadphones);
parcelHelpers.export(exports, "MdHeadsetMic", ()=>MdHeadsetMic);
parcelHelpers.export(exports, "MdHeadsetOff", ()=>MdHeadsetOff);
parcelHelpers.export(exports, "MdHeadset", ()=>MdHeadset);
parcelHelpers.export(exports, "MdHomeMax", ()=>MdHomeMax);
parcelHelpers.export(exports, "MdHomeMini", ()=>MdHomeMini);
parcelHelpers.export(exports, "MdKeyboardAlt", ()=>MdKeyboardAlt);
parcelHelpers.export(exports, "MdKeyboardArrowDown", ()=>MdKeyboardArrowDown);
parcelHelpers.export(exports, "MdKeyboardArrowLeft", ()=>MdKeyboardArrowLeft);
parcelHelpers.export(exports, "MdKeyboardArrowRight", ()=>MdKeyboardArrowRight);
parcelHelpers.export(exports, "MdKeyboardArrowUp", ()=>MdKeyboardArrowUp);
parcelHelpers.export(exports, "MdKeyboardBackspace", ()=>MdKeyboardBackspace);
parcelHelpers.export(exports, "MdKeyboardCapslock", ()=>MdKeyboardCapslock);
parcelHelpers.export(exports, "MdKeyboardCommandKey", ()=>MdKeyboardCommandKey);
parcelHelpers.export(exports, "MdKeyboardControlKey", ()=>MdKeyboardControlKey);
parcelHelpers.export(exports, "MdKeyboardDoubleArrowDown", ()=>MdKeyboardDoubleArrowDown);
parcelHelpers.export(exports, "MdKeyboardDoubleArrowLeft", ()=>MdKeyboardDoubleArrowLeft);
parcelHelpers.export(exports, "MdKeyboardDoubleArrowRight", ()=>MdKeyboardDoubleArrowRight);
parcelHelpers.export(exports, "MdKeyboardDoubleArrowUp", ()=>MdKeyboardDoubleArrowUp);
parcelHelpers.export(exports, "MdKeyboardHide", ()=>MdKeyboardHide);
parcelHelpers.export(exports, "MdKeyboardOptionKey", ()=>MdKeyboardOptionKey);
parcelHelpers.export(exports, "MdKeyboardReturn", ()=>MdKeyboardReturn);
parcelHelpers.export(exports, "MdKeyboardTab", ()=>MdKeyboardTab);
parcelHelpers.export(exports, "MdKeyboardVoice", ()=>MdKeyboardVoice);
parcelHelpers.export(exports, "MdKeyboard", ()=>MdKeyboard);
parcelHelpers.export(exports, "MdLaptopChromebook", ()=>MdLaptopChromebook);
parcelHelpers.export(exports, "MdLaptopMac", ()=>MdLaptopMac);
parcelHelpers.export(exports, "MdLaptopWindows", ()=>MdLaptopWindows);
parcelHelpers.export(exports, "MdLaptop", ()=>MdLaptop);
parcelHelpers.export(exports, "MdMemory", ()=>MdMemory);
parcelHelpers.export(exports, "MdMonitor", ()=>MdMonitor);
parcelHelpers.export(exports, "MdMouse", ()=>MdMouse);
parcelHelpers.export(exports, "MdPallet", ()=>MdPallet);
parcelHelpers.export(exports, "MdPhoneAndroid", ()=>MdPhoneAndroid);
parcelHelpers.export(exports, "MdPhoneIphone", ()=>MdPhoneIphone);
parcelHelpers.export(exports, "MdPhonelinkOff", ()=>MdPhonelinkOff);
parcelHelpers.export(exports, "MdPhonelink", ()=>MdPhonelink);
parcelHelpers.export(exports, "MdPointOfSale", ()=>MdPointOfSale);
parcelHelpers.export(exports, "MdPowerInput", ()=>MdPowerInput);
parcelHelpers.export(exports, "MdRouter", ()=>MdRouter);
parcelHelpers.export(exports, "MdScanner", ()=>MdScanner);
parcelHelpers.export(exports, "MdSecurity", ()=>MdSecurity);
parcelHelpers.export(exports, "MdSimCard", ()=>MdSimCard);
parcelHelpers.export(exports, "MdSmartDisplay", ()=>MdSmartDisplay);
parcelHelpers.export(exports, "MdSmartScreen", ()=>MdSmartScreen);
parcelHelpers.export(exports, "MdSmartToy", ()=>MdSmartToy);
parcelHelpers.export(exports, "MdSmartphone", ()=>MdSmartphone);
parcelHelpers.export(exports, "MdSpeakerGroup", ()=>MdSpeakerGroup);
parcelHelpers.export(exports, "MdSpeaker", ()=>MdSpeaker);
parcelHelpers.export(exports, "MdStart", ()=>MdStart);
parcelHelpers.export(exports, "MdTabletAndroid", ()=>MdTabletAndroid);
parcelHelpers.export(exports, "MdTabletMac", ()=>MdTabletMac);
parcelHelpers.export(exports, "MdTablet", ()=>MdTablet);
parcelHelpers.export(exports, "MdToys", ()=>MdToys);
parcelHelpers.export(exports, "MdTrolley", ()=>MdTrolley);
parcelHelpers.export(exports, "MdTv", ()=>MdTv);
parcelHelpers.export(exports, "MdVideogameAssetOff", ()=>MdVideogameAssetOff);
parcelHelpers.export(exports, "MdVideogameAsset", ()=>MdVideogameAsset);
parcelHelpers.export(exports, "MdWatchOff", ()=>MdWatchOff);
parcelHelpers.export(exports, "MdWatch", ()=>MdWatch);
parcelHelpers.export(exports, "MdAutoMode", ()=>MdAutoMode);
parcelHelpers.export(exports, "MdBlindsClosed", ()=>MdBlindsClosed);
parcelHelpers.export(exports, "MdBlinds", ()=>MdBlinds);
parcelHelpers.export(exports, "MdBroadcastOnHome", ()=>MdBroadcastOnHome);
parcelHelpers.export(exports, "MdBroadcastOnPersonal", ()=>MdBroadcastOnPersonal);
parcelHelpers.export(exports, "MdCloudySnowing", ()=>MdCloudySnowing);
parcelHelpers.export(exports, "MdCurtainsClosed", ()=>MdCurtainsClosed);
parcelHelpers.export(exports, "MdCurtains", ()=>MdCurtains);
parcelHelpers.export(exports, "MdElectricBolt", ()=>MdElectricBolt);
parcelHelpers.export(exports, "MdElectricMeter", ()=>MdElectricMeter);
parcelHelpers.export(exports, "MdEnergySavingsLeaf", ()=>MdEnergySavingsLeaf);
parcelHelpers.export(exports, "MdFoggy", ()=>MdFoggy);
parcelHelpers.export(exports, "MdGasMeter", ()=>MdGasMeter);
parcelHelpers.export(exports, "MdHeatPump", ()=>MdHeatPump);
parcelHelpers.export(exports, "MdModeFanOff", ()=>MdModeFanOff);
parcelHelpers.export(exports, "MdNestCamWiredStand", ()=>MdNestCamWiredStand);
parcelHelpers.export(exports, "MdOilBarrel", ()=>MdOilBarrel);
parcelHelpers.export(exports, "MdPropaneTank", ()=>MdPropaneTank);
parcelHelpers.export(exports, "MdPropane", ()=>MdPropane);
parcelHelpers.export(exports, "MdRollerShadesClosed", ()=>MdRollerShadesClosed);
parcelHelpers.export(exports, "MdRollerShades", ()=>MdRollerShades);
parcelHelpers.export(exports, "MdSensorDoor", ()=>MdSensorDoor);
parcelHelpers.export(exports, "MdSensorOccupied", ()=>MdSensorOccupied);
parcelHelpers.export(exports, "MdSensorWindow", ()=>MdSensorWindow);
parcelHelpers.export(exports, "MdShelves", ()=>MdShelves);
parcelHelpers.export(exports, "MdShieldMoon", ()=>MdShieldMoon);
parcelHelpers.export(exports, "MdSnowing", ()=>MdSnowing);
parcelHelpers.export(exports, "MdSolarPower", ()=>MdSolarPower);
parcelHelpers.export(exports, "MdSunnySnowing", ()=>MdSunnySnowing);
parcelHelpers.export(exports, "MdSunny", ()=>MdSunny);
parcelHelpers.export(exports, "MdVerticalShadesClosed", ()=>MdVerticalShadesClosed);
parcelHelpers.export(exports, "MdVerticalShades", ()=>MdVerticalShades);
parcelHelpers.export(exports, "MdWindPower", ()=>MdWindPower);
parcelHelpers.export(exports, "Md10Mp", ()=>Md10Mp);
parcelHelpers.export(exports, "Md11Mp", ()=>Md11Mp);
parcelHelpers.export(exports, "Md12Mp", ()=>Md12Mp);
parcelHelpers.export(exports, "Md13Mp", ()=>Md13Mp);
parcelHelpers.export(exports, "Md14Mp", ()=>Md14Mp);
parcelHelpers.export(exports, "Md15Mp", ()=>Md15Mp);
parcelHelpers.export(exports, "Md16Mp", ()=>Md16Mp);
parcelHelpers.export(exports, "Md17Mp", ()=>Md17Mp);
parcelHelpers.export(exports, "Md18Mp", ()=>Md18Mp);
parcelHelpers.export(exports, "Md19Mp", ()=>Md19Mp);
parcelHelpers.export(exports, "Md20Mp", ()=>Md20Mp);
parcelHelpers.export(exports, "Md21Mp", ()=>Md21Mp);
parcelHelpers.export(exports, "Md22Mp", ()=>Md22Mp);
parcelHelpers.export(exports, "Md23Mp", ()=>Md23Mp);
parcelHelpers.export(exports, "Md24Mp", ()=>Md24Mp);
parcelHelpers.export(exports, "Md2Mp", ()=>Md2Mp);
parcelHelpers.export(exports, "Md30FpsSelect", ()=>Md30FpsSelect);
parcelHelpers.export(exports, "Md3Mp", ()=>Md3Mp);
parcelHelpers.export(exports, "Md4Mp", ()=>Md4Mp);
parcelHelpers.export(exports, "Md5Mp", ()=>Md5Mp);
parcelHelpers.export(exports, "Md60FpsSelect", ()=>Md60FpsSelect);
parcelHelpers.export(exports, "Md6Mp", ()=>Md6Mp);
parcelHelpers.export(exports, "Md7Mp", ()=>Md7Mp);
parcelHelpers.export(exports, "Md8Mp", ()=>Md8Mp);
parcelHelpers.export(exports, "Md9Mp", ()=>Md9Mp);
parcelHelpers.export(exports, "MdAddAPhoto", ()=>MdAddAPhoto);
parcelHelpers.export(exports, "MdAddPhotoAlternate", ()=>MdAddPhotoAlternate);
parcelHelpers.export(exports, "MdAddToPhotos", ()=>MdAddToPhotos);
parcelHelpers.export(exports, "MdAdjust", ()=>MdAdjust);
parcelHelpers.export(exports, "MdAnimation", ()=>MdAnimation);
parcelHelpers.export(exports, "MdAssistantPhoto", ()=>MdAssistantPhoto);
parcelHelpers.export(exports, "MdAssistant", ()=>MdAssistant);
parcelHelpers.export(exports, "MdAudiotrack", ()=>MdAudiotrack);
parcelHelpers.export(exports, "MdAutoAwesomeMosaic", ()=>MdAutoAwesomeMosaic);
parcelHelpers.export(exports, "MdAutoAwesomeMotion", ()=>MdAutoAwesomeMotion);
parcelHelpers.export(exports, "MdAutoAwesome", ()=>MdAutoAwesome);
parcelHelpers.export(exports, "MdAutoFixHigh", ()=>MdAutoFixHigh);
parcelHelpers.export(exports, "MdAutoFixNormal", ()=>MdAutoFixNormal);
parcelHelpers.export(exports, "MdAutoFixOff", ()=>MdAutoFixOff);
parcelHelpers.export(exports, "MdAutoStories", ()=>MdAutoStories);
parcelHelpers.export(exports, "MdAutofpsSelect", ()=>MdAutofpsSelect);
parcelHelpers.export(exports, "MdBedtimeOff", ()=>MdBedtimeOff);
parcelHelpers.export(exports, "MdBedtime", ()=>MdBedtime);
parcelHelpers.export(exports, "MdBlurCircular", ()=>MdBlurCircular);
parcelHelpers.export(exports, "MdBlurLinear", ()=>MdBlurLinear);
parcelHelpers.export(exports, "MdBlurOff", ()=>MdBlurOff);
parcelHelpers.export(exports, "MdBlurOn", ()=>MdBlurOn);
parcelHelpers.export(exports, "MdBrightness1", ()=>MdBrightness1);
parcelHelpers.export(exports, "MdBrightness2", ()=>MdBrightness2);
parcelHelpers.export(exports, "MdBrightness3", ()=>MdBrightness3);
parcelHelpers.export(exports, "MdBrightness4", ()=>MdBrightness4);
parcelHelpers.export(exports, "MdBrightness5", ()=>MdBrightness5);
parcelHelpers.export(exports, "MdBrightness6", ()=>MdBrightness6);
parcelHelpers.export(exports, "MdBrightness7", ()=>MdBrightness7);
parcelHelpers.export(exports, "MdBrokenImage", ()=>MdBrokenImage);
parcelHelpers.export(exports, "MdBrush", ()=>MdBrush);
parcelHelpers.export(exports, "MdBurstMode", ()=>MdBurstMode);
parcelHelpers.export(exports, "MdCameraAlt", ()=>MdCameraAlt);
parcelHelpers.export(exports, "MdCameraFront", ()=>MdCameraFront);
parcelHelpers.export(exports, "MdCameraRear", ()=>MdCameraRear);
parcelHelpers.export(exports, "MdCameraRoll", ()=>MdCameraRoll);
parcelHelpers.export(exports, "MdCamera", ()=>MdCamera);
parcelHelpers.export(exports, "MdCases", ()=>MdCases);
parcelHelpers.export(exports, "MdCenterFocusStrong", ()=>MdCenterFocusStrong);
parcelHelpers.export(exports, "MdCenterFocusWeak", ()=>MdCenterFocusWeak);
parcelHelpers.export(exports, "MdCircle", ()=>MdCircle);
parcelHelpers.export(exports, "MdCollectionsBookmark", ()=>MdCollectionsBookmark);
parcelHelpers.export(exports, "MdCollections", ()=>MdCollections);
parcelHelpers.export(exports, "MdColorLens", ()=>MdColorLens);
parcelHelpers.export(exports, "MdColorize", ()=>MdColorize);
parcelHelpers.export(exports, "MdCompare", ()=>MdCompare);
parcelHelpers.export(exports, "MdContrast", ()=>MdContrast);
parcelHelpers.export(exports, "MdControlPointDuplicate", ()=>MdControlPointDuplicate);
parcelHelpers.export(exports, "MdControlPoint", ()=>MdControlPoint);
parcelHelpers.export(exports, "MdCrop169", ()=>MdCrop169);
parcelHelpers.export(exports, "MdCrop32", ()=>MdCrop32);
parcelHelpers.export(exports, "MdCrop54", ()=>MdCrop54);
parcelHelpers.export(exports, "MdCrop75", ()=>MdCrop75);
parcelHelpers.export(exports, "MdCropDin", ()=>MdCropDin);
parcelHelpers.export(exports, "MdCropFree", ()=>MdCropFree);
parcelHelpers.export(exports, "MdCropLandscape", ()=>MdCropLandscape);
parcelHelpers.export(exports, "MdCropOriginal", ()=>MdCropOriginal);
parcelHelpers.export(exports, "MdCropPortrait", ()=>MdCropPortrait);
parcelHelpers.export(exports, "MdCropRotate", ()=>MdCropRotate);
parcelHelpers.export(exports, "MdCropSquare", ()=>MdCropSquare);
parcelHelpers.export(exports, "MdCrop", ()=>MdCrop);
parcelHelpers.export(exports, "MdCurrencyBitcoin", ()=>MdCurrencyBitcoin);
parcelHelpers.export(exports, "MdCurrencyFranc", ()=>MdCurrencyFranc);
parcelHelpers.export(exports, "MdCurrencyLira", ()=>MdCurrencyLira);
parcelHelpers.export(exports, "MdCurrencyPound", ()=>MdCurrencyPound);
parcelHelpers.export(exports, "MdCurrencyRuble", ()=>MdCurrencyRuble);
parcelHelpers.export(exports, "MdCurrencyRupee", ()=>MdCurrencyRupee);
parcelHelpers.export(exports, "MdCurrencyYen", ()=>MdCurrencyYen);
parcelHelpers.export(exports, "MdCurrencyYuan", ()=>MdCurrencyYuan);
parcelHelpers.export(exports, "MdDeblur", ()=>MdDeblur);
parcelHelpers.export(exports, "MdDehaze", ()=>MdDehaze);
parcelHelpers.export(exports, "MdDetails", ()=>MdDetails);
parcelHelpers.export(exports, "MdDirtyLens", ()=>MdDirtyLens);
parcelHelpers.export(exports, "MdEdit", ()=>MdEdit);
parcelHelpers.export(exports, "MdEuro", ()=>MdEuro);
parcelHelpers.export(exports, "MdExposureNeg1", ()=>MdExposureNeg1);
parcelHelpers.export(exports, "MdExposureNeg2", ()=>MdExposureNeg2);
parcelHelpers.export(exports, "MdExposurePlus1", ()=>MdExposurePlus1);
parcelHelpers.export(exports, "MdExposurePlus2", ()=>MdExposurePlus2);
parcelHelpers.export(exports, "MdExposureZero", ()=>MdExposureZero);
parcelHelpers.export(exports, "MdExposure", ()=>MdExposure);
parcelHelpers.export(exports, "MdFaceRetouchingNatural", ()=>MdFaceRetouchingNatural);
parcelHelpers.export(exports, "MdFaceRetouchingOff", ()=>MdFaceRetouchingOff);
parcelHelpers.export(exports, "MdFilter1", ()=>MdFilter1);
parcelHelpers.export(exports, "MdFilter2", ()=>MdFilter2);
parcelHelpers.export(exports, "MdFilter3", ()=>MdFilter3);
parcelHelpers.export(exports, "MdFilter4", ()=>MdFilter4);
parcelHelpers.export(exports, "MdFilter5", ()=>MdFilter5);
parcelHelpers.export(exports, "MdFilter6", ()=>MdFilter6);
parcelHelpers.export(exports, "MdFilter7", ()=>MdFilter7);
parcelHelpers.export(exports, "MdFilter8", ()=>MdFilter8);
parcelHelpers.export(exports, "MdFilter9Plus", ()=>MdFilter9Plus);
parcelHelpers.export(exports, "MdFilter9", ()=>MdFilter9);
parcelHelpers.export(exports, "MdFilterBAndW", ()=>MdFilterBAndW);
parcelHelpers.export(exports, "MdFilterCenterFocus", ()=>MdFilterCenterFocus);
parcelHelpers.export(exports, "MdFilterDrama", ()=>MdFilterDrama);
parcelHelpers.export(exports, "MdFilterFrames", ()=>MdFilterFrames);
parcelHelpers.export(exports, "MdFilterHdr", ()=>MdFilterHdr);
parcelHelpers.export(exports, "MdFilterNone", ()=>MdFilterNone);
parcelHelpers.export(exports, "MdFilterTiltShift", ()=>MdFilterTiltShift);
parcelHelpers.export(exports, "MdFilterVintage", ()=>MdFilterVintage);
parcelHelpers.export(exports, "MdFilter", ()=>MdFilter);
parcelHelpers.export(exports, "MdFlare", ()=>MdFlare);
parcelHelpers.export(exports, "MdFlashAuto", ()=>MdFlashAuto);
parcelHelpers.export(exports, "MdFlashOff", ()=>MdFlashOff);
parcelHelpers.export(exports, "MdFlashOn", ()=>MdFlashOn);
parcelHelpers.export(exports, "MdFlipCameraAndroid", ()=>MdFlipCameraAndroid);
parcelHelpers.export(exports, "MdFlipCameraIos", ()=>MdFlipCameraIos);
parcelHelpers.export(exports, "MdFlip", ()=>MdFlip);
parcelHelpers.export(exports, "MdGradient", ()=>MdGradient);
parcelHelpers.export(exports, "MdGrain", ()=>MdGrain);
parcelHelpers.export(exports, "MdGridOff", ()=>MdGridOff);
parcelHelpers.export(exports, "MdGridOn", ()=>MdGridOn);
parcelHelpers.export(exports, "MdHdrEnhancedSelect", ()=>MdHdrEnhancedSelect);
parcelHelpers.export(exports, "MdHdrOff", ()=>MdHdrOff);
parcelHelpers.export(exports, "MdHdrOn", ()=>MdHdrOn);
parcelHelpers.export(exports, "MdHdrPlus", ()=>MdHdrPlus);
parcelHelpers.export(exports, "MdHdrStrong", ()=>MdHdrStrong);
parcelHelpers.export(exports, "MdHdrWeak", ()=>MdHdrWeak);
parcelHelpers.export(exports, "MdHealing", ()=>MdHealing);
parcelHelpers.export(exports, "MdHevc", ()=>MdHevc);
parcelHelpers.export(exports, "MdHideImage", ()=>MdHideImage);
parcelHelpers.export(exports, "MdImageAspectRatio", ()=>MdImageAspectRatio);
parcelHelpers.export(exports, "MdImageNotSupported", ()=>MdImageNotSupported);
parcelHelpers.export(exports, "MdImageSearch", ()=>MdImageSearch);
parcelHelpers.export(exports, "MdImage", ()=>MdImage);
parcelHelpers.export(exports, "MdIncompleteCircle", ()=>MdIncompleteCircle);
parcelHelpers.export(exports, "MdIso", ()=>MdIso);
parcelHelpers.export(exports, "MdLandscape", ()=>MdLandscape);
parcelHelpers.export(exports, "MdLeakAdd", ()=>MdLeakAdd);
parcelHelpers.export(exports, "MdLeakRemove", ()=>MdLeakRemove);
parcelHelpers.export(exports, "MdLens", ()=>MdLens);
parcelHelpers.export(exports, "MdLinkedCamera", ()=>MdLinkedCamera);
parcelHelpers.export(exports, "MdLogoDev", ()=>MdLogoDev);
parcelHelpers.export(exports, "MdLooks3", ()=>MdLooks3);
parcelHelpers.export(exports, "MdLooks4", ()=>MdLooks4);
parcelHelpers.export(exports, "MdLooks5", ()=>MdLooks5);
parcelHelpers.export(exports, "MdLooks6", ()=>MdLooks6);
parcelHelpers.export(exports, "MdLooksOne", ()=>MdLooksOne);
parcelHelpers.export(exports, "MdLooksTwo", ()=>MdLooksTwo);
parcelHelpers.export(exports, "MdLooks", ()=>MdLooks);
parcelHelpers.export(exports, "MdLoupe", ()=>MdLoupe);
parcelHelpers.export(exports, "MdMicExternalOff", ()=>MdMicExternalOff);
parcelHelpers.export(exports, "MdMicExternalOn", ()=>MdMicExternalOn);
parcelHelpers.export(exports, "MdMonochromePhotos", ()=>MdMonochromePhotos);
parcelHelpers.export(exports, "MdMotionPhotosAuto", ()=>MdMotionPhotosAuto);
parcelHelpers.export(exports, "MdMotionPhotosOff", ()=>MdMotionPhotosOff);
parcelHelpers.export(exports, "MdMotionPhotosOn", ()=>MdMotionPhotosOn);
parcelHelpers.export(exports, "MdMotionPhotosPause", ()=>MdMotionPhotosPause);
parcelHelpers.export(exports, "MdMotionPhotosPaused", ()=>MdMotionPhotosPaused);
parcelHelpers.export(exports, "MdMovieCreation", ()=>MdMovieCreation);
parcelHelpers.export(exports, "MdMovieFilter", ()=>MdMovieFilter);
parcelHelpers.export(exports, "MdMp", ()=>MdMp);
parcelHelpers.export(exports, "MdMusicNote", ()=>MdMusicNote);
parcelHelpers.export(exports, "MdMusicOff", ()=>MdMusicOff);
parcelHelpers.export(exports, "MdNaturePeople", ()=>MdNaturePeople);
parcelHelpers.export(exports, "MdNature", ()=>MdNature);
parcelHelpers.export(exports, "MdNavigateBefore", ()=>MdNavigateBefore);
parcelHelpers.export(exports, "MdNavigateNext", ()=>MdNavigateNext);
parcelHelpers.export(exports, "MdPalette", ()=>MdPalette);
parcelHelpers.export(exports, "MdPanoramaFishEye", ()=>MdPanoramaFishEye);
parcelHelpers.export(exports, "MdPanoramaHorizontalSelect", ()=>MdPanoramaHorizontalSelect);
parcelHelpers.export(exports, "MdPanoramaHorizontal", ()=>MdPanoramaHorizontal);
parcelHelpers.export(exports, "MdPanoramaPhotosphereSelect", ()=>MdPanoramaPhotosphereSelect);
parcelHelpers.export(exports, "MdPanoramaPhotosphere", ()=>MdPanoramaPhotosphere);
parcelHelpers.export(exports, "MdPanoramaVerticalSelect", ()=>MdPanoramaVerticalSelect);
parcelHelpers.export(exports, "MdPanoramaVertical", ()=>MdPanoramaVertical);
parcelHelpers.export(exports, "MdPanoramaWideAngleSelect", ()=>MdPanoramaWideAngleSelect);
parcelHelpers.export(exports, "MdPanoramaWideAngle", ()=>MdPanoramaWideAngle);
parcelHelpers.export(exports, "MdPanorama", ()=>MdPanorama);
parcelHelpers.export(exports, "MdPhotoAlbum", ()=>MdPhotoAlbum);
parcelHelpers.export(exports, "MdPhotoCameraBack", ()=>MdPhotoCameraBack);
parcelHelpers.export(exports, "MdPhotoCameraFront", ()=>MdPhotoCameraFront);
parcelHelpers.export(exports, "MdPhotoCamera", ()=>MdPhotoCamera);
parcelHelpers.export(exports, "MdPhotoFilter", ()=>MdPhotoFilter);
parcelHelpers.export(exports, "MdPhotoLibrary", ()=>MdPhotoLibrary);
parcelHelpers.export(exports, "MdPhotoSizeSelectActual", ()=>MdPhotoSizeSelectActual);
parcelHelpers.export(exports, "MdPhotoSizeSelectLarge", ()=>MdPhotoSizeSelectLarge);
parcelHelpers.export(exports, "MdPhotoSizeSelectSmall", ()=>MdPhotoSizeSelectSmall);
parcelHelpers.export(exports, "MdPhoto", ()=>MdPhoto);
parcelHelpers.export(exports, "MdPictureAsPdf", ()=>MdPictureAsPdf);
parcelHelpers.export(exports, "MdPortrait", ()=>MdPortrait);
parcelHelpers.export(exports, "MdRawOff", ()=>MdRawOff);
parcelHelpers.export(exports, "MdRawOn", ()=>MdRawOn);
parcelHelpers.export(exports, "MdReceiptLong", ()=>MdReceiptLong);
parcelHelpers.export(exports, "MdRemoveRedEye", ()=>MdRemoveRedEye);
parcelHelpers.export(exports, "MdRotate90DegreesCcw", ()=>MdRotate90DegreesCcw);
parcelHelpers.export(exports, "MdRotate90DegreesCw", ()=>MdRotate90DegreesCw);
parcelHelpers.export(exports, "MdRotateLeft", ()=>MdRotateLeft);
parcelHelpers.export(exports, "MdRotateRight", ()=>MdRotateRight);
parcelHelpers.export(exports, "MdShutterSpeed", ()=>MdShutterSpeed);
parcelHelpers.export(exports, "MdSlideshow", ()=>MdSlideshow);
parcelHelpers.export(exports, "MdStraighten", ()=>MdStraighten);
parcelHelpers.export(exports, "MdStyle", ()=>MdStyle);
parcelHelpers.export(exports, "MdSwitchCamera", ()=>MdSwitchCamera);
parcelHelpers.export(exports, "MdSwitchVideo", ()=>MdSwitchVideo);
parcelHelpers.export(exports, "MdTagFaces", ()=>MdTagFaces);
parcelHelpers.export(exports, "MdTexture", ()=>MdTexture);
parcelHelpers.export(exports, "MdThermostatAuto", ()=>MdThermostatAuto);
parcelHelpers.export(exports, "MdTimelapse", ()=>MdTimelapse);
parcelHelpers.export(exports, "MdTimer10", ()=>MdTimer10);
parcelHelpers.export(exports, "MdTimer3", ()=>MdTimer3);
parcelHelpers.export(exports, "MdTimerOff", ()=>MdTimerOff);
parcelHelpers.export(exports, "MdTimer", ()=>MdTimer);
parcelHelpers.export(exports, "MdTonality", ()=>MdTonality);
parcelHelpers.export(exports, "MdTransform", ()=>MdTransform);
parcelHelpers.export(exports, "MdTune", ()=>MdTune);
parcelHelpers.export(exports, "MdVideoCameraBack", ()=>MdVideoCameraBack);
parcelHelpers.export(exports, "MdVideoCameraFront", ()=>MdVideoCameraFront);
parcelHelpers.export(exports, "MdVideoStable", ()=>MdVideoStable);
parcelHelpers.export(exports, "MdViewComfy", ()=>MdViewComfy);
parcelHelpers.export(exports, "MdViewCompact", ()=>MdViewCompact);
parcelHelpers.export(exports, "MdVignette", ()=>MdVignette);
parcelHelpers.export(exports, "MdVrpano", ()=>MdVrpano);
parcelHelpers.export(exports, "MdWbAuto", ()=>MdWbAuto);
parcelHelpers.export(exports, "MdWbCloudy", ()=>MdWbCloudy);
parcelHelpers.export(exports, "MdWbIncandescent", ()=>MdWbIncandescent);
parcelHelpers.export(exports, "MdWbIridescent", ()=>MdWbIridescent);
parcelHelpers.export(exports, "MdWbShade", ()=>MdWbShade);
parcelHelpers.export(exports, "MdWbSunny", ()=>MdWbSunny);
parcelHelpers.export(exports, "MdWbTwighlight", ()=>MdWbTwighlight);
parcelHelpers.export(exports, "MdWbTwilight", ()=>MdWbTwilight);
parcelHelpers.export(exports, "Md360", ()=>Md360);
parcelHelpers.export(exports, "MdAddBusiness", ()=>MdAddBusiness);
parcelHelpers.export(exports, "MdAddLocationAlt", ()=>MdAddLocationAlt);
parcelHelpers.export(exports, "MdAddLocation", ()=>MdAddLocation);
parcelHelpers.export(exports, "MdAddRoad", ()=>MdAddRoad);
parcelHelpers.export(exports, "MdAgriculture", ()=>MdAgriculture);
parcelHelpers.export(exports, "MdAirlineStops", ()=>MdAirlineStops);
parcelHelpers.export(exports, "MdAirlines", ()=>MdAirlines);
parcelHelpers.export(exports, "MdAltRoute", ()=>MdAltRoute);
parcelHelpers.export(exports, "MdAtm", ()=>MdAtm);
parcelHelpers.export(exports, "MdAttractions", ()=>MdAttractions);
parcelHelpers.export(exports, "MdBadge", ()=>MdBadge);
parcelHelpers.export(exports, "MdBakeryDining", ()=>MdBakeryDining);
parcelHelpers.export(exports, "MdBeenhere", ()=>MdBeenhere);
parcelHelpers.export(exports, "MdBikeScooter", ()=>MdBikeScooter);
parcelHelpers.export(exports, "MdBreakfastDining", ()=>MdBreakfastDining);
parcelHelpers.export(exports, "MdBrunchDining", ()=>MdBrunchDining);
parcelHelpers.export(exports, "MdBusAlert", ()=>MdBusAlert);
parcelHelpers.export(exports, "MdCarCrash", ()=>MdCarCrash);
parcelHelpers.export(exports, "MdCarRental", ()=>MdCarRental);
parcelHelpers.export(exports, "MdCarRepair", ()=>MdCarRepair);
parcelHelpers.export(exports, "MdCastle", ()=>MdCastle);
parcelHelpers.export(exports, "MdCategory", ()=>MdCategory);
parcelHelpers.export(exports, "MdCelebration", ()=>MdCelebration);
parcelHelpers.export(exports, "MdChurch", ()=>MdChurch);
parcelHelpers.export(exports, "MdCleaningServices", ()=>MdCleaningServices);
parcelHelpers.export(exports, "MdCompassCalibration", ()=>MdCompassCalibration);
parcelHelpers.export(exports, "MdConnectingAirports", ()=>MdConnectingAirports);
parcelHelpers.export(exports, "MdCrisisAlert", ()=>MdCrisisAlert);
parcelHelpers.export(exports, "MdDeliveryDining", ()=>MdDeliveryDining);
parcelHelpers.export(exports, "MdDepartureBoard", ()=>MdDepartureBoard);
parcelHelpers.export(exports, "MdDesignServices", ()=>MdDesignServices);
parcelHelpers.export(exports, "MdDiamond", ()=>MdDiamond);
parcelHelpers.export(exports, "MdDinnerDining", ()=>MdDinnerDining);
parcelHelpers.export(exports, "MdDirectionsBike", ()=>MdDirectionsBike);
parcelHelpers.export(exports, "MdDirectionsBoatFilled", ()=>MdDirectionsBoatFilled);
parcelHelpers.export(exports, "MdDirectionsBoat", ()=>MdDirectionsBoat);
parcelHelpers.export(exports, "MdDirectionsBusFilled", ()=>MdDirectionsBusFilled);
parcelHelpers.export(exports, "MdDirectionsBus", ()=>MdDirectionsBus);
parcelHelpers.export(exports, "MdDirectionsCarFilled", ()=>MdDirectionsCarFilled);
parcelHelpers.export(exports, "MdDirectionsCar", ()=>MdDirectionsCar);
parcelHelpers.export(exports, "MdDirectionsRailwayFilled", ()=>MdDirectionsRailwayFilled);
parcelHelpers.export(exports, "MdDirectionsRailway", ()=>MdDirectionsRailway);
parcelHelpers.export(exports, "MdDirectionsRun", ()=>MdDirectionsRun);
parcelHelpers.export(exports, "MdDirectionsSubwayFilled", ()=>MdDirectionsSubwayFilled);
parcelHelpers.export(exports, "MdDirectionsSubway", ()=>MdDirectionsSubway);
parcelHelpers.export(exports, "MdDirectionsTransitFilled", ()=>MdDirectionsTransitFilled);
parcelHelpers.export(exports, "MdDirectionsTransit", ()=>MdDirectionsTransit);
parcelHelpers.export(exports, "MdDirectionsWalk", ()=>MdDirectionsWalk);
parcelHelpers.export(exports, "MdDirections", ()=>MdDirections);
parcelHelpers.export(exports, "MdDryCleaning", ()=>MdDryCleaning);
parcelHelpers.export(exports, "MdEditAttributes", ()=>MdEditAttributes);
parcelHelpers.export(exports, "MdEditLocationAlt", ()=>MdEditLocationAlt);
parcelHelpers.export(exports, "MdEditLocation", ()=>MdEditLocation);
parcelHelpers.export(exports, "MdEditRoad", ()=>MdEditRoad);
parcelHelpers.export(exports, "MdEggAlt", ()=>MdEggAlt);
parcelHelpers.export(exports, "MdEgg", ()=>MdEgg);
parcelHelpers.export(exports, "MdElectricBike", ()=>MdElectricBike);
parcelHelpers.export(exports, "MdElectricCar", ()=>MdElectricCar);
parcelHelpers.export(exports, "MdElectricMoped", ()=>MdElectricMoped);
parcelHelpers.export(exports, "MdElectricRickshaw", ()=>MdElectricRickshaw);
parcelHelpers.export(exports, "MdElectricScooter", ()=>MdElectricScooter);
parcelHelpers.export(exports, "MdElectricalServices", ()=>MdElectricalServices);
parcelHelpers.export(exports, "MdEmergencyRecording", ()=>MdEmergencyRecording);
parcelHelpers.export(exports, "MdEmergencyShare", ()=>MdEmergencyShare);
parcelHelpers.export(exports, "MdEmergency", ()=>MdEmergency);
parcelHelpers.export(exports, "MdEvStation", ()=>MdEvStation);
parcelHelpers.export(exports, "MdFactory", ()=>MdFactory);
parcelHelpers.export(exports, "MdFastfood", ()=>MdFastfood);
parcelHelpers.export(exports, "MdFestival", ()=>MdFestival);
parcelHelpers.export(exports, "MdFireHydrantAlt", ()=>MdFireHydrantAlt);
parcelHelpers.export(exports, "MdFireTruck", ()=>MdFireTruck);
parcelHelpers.export(exports, "MdFlightClass", ()=>MdFlightClass);
parcelHelpers.export(exports, "MdFlight", ()=>MdFlight);
parcelHelpers.export(exports, "MdForest", ()=>MdForest);
parcelHelpers.export(exports, "MdForkLeft", ()=>MdForkLeft);
parcelHelpers.export(exports, "MdForkRight", ()=>MdForkRight);
parcelHelpers.export(exports, "MdFort", ()=>MdFort);
parcelHelpers.export(exports, "MdHail", ()=>MdHail);
parcelHelpers.export(exports, "MdHandyman", ()=>MdHandyman);
parcelHelpers.export(exports, "MdHardware", ()=>MdHardware);
parcelHelpers.export(exports, "MdHomeRepairService", ()=>MdHomeRepairService);
parcelHelpers.export(exports, "MdHotel", ()=>MdHotel);
parcelHelpers.export(exports, "MdHvac", ()=>MdHvac);
parcelHelpers.export(exports, "MdIcecream", ()=>MdIcecream);
parcelHelpers.export(exports, "MdKebabDining", ()=>MdKebabDining);
parcelHelpers.export(exports, "MdLayersClear", ()=>MdLayersClear);
parcelHelpers.export(exports, "MdLayers", ()=>MdLayers);
parcelHelpers.export(exports, "MdLiquor", ()=>MdLiquor);
parcelHelpers.export(exports, "MdLocalActivity", ()=>MdLocalActivity);
parcelHelpers.export(exports, "MdLocalAirport", ()=>MdLocalAirport);
parcelHelpers.export(exports, "MdLocalAtm", ()=>MdLocalAtm);
parcelHelpers.export(exports, "MdLocalBar", ()=>MdLocalBar);
parcelHelpers.export(exports, "MdLocalCafe", ()=>MdLocalCafe);
parcelHelpers.export(exports, "MdLocalCarWash", ()=>MdLocalCarWash);
parcelHelpers.export(exports, "MdLocalConvenienceStore", ()=>MdLocalConvenienceStore);
parcelHelpers.export(exports, "MdLocalDining", ()=>MdLocalDining);
parcelHelpers.export(exports, "MdLocalDrink", ()=>MdLocalDrink);
parcelHelpers.export(exports, "MdLocalFireDepartment", ()=>MdLocalFireDepartment);
parcelHelpers.export(exports, "MdLocalFlorist", ()=>MdLocalFlorist);
parcelHelpers.export(exports, "MdLocalGasStation", ()=>MdLocalGasStation);
parcelHelpers.export(exports, "MdLocalGroceryStore", ()=>MdLocalGroceryStore);
parcelHelpers.export(exports, "MdLocalHospital", ()=>MdLocalHospital);
parcelHelpers.export(exports, "MdLocalHotel", ()=>MdLocalHotel);
parcelHelpers.export(exports, "MdLocalLaundryService", ()=>MdLocalLaundryService);
parcelHelpers.export(exports, "MdLocalLibrary", ()=>MdLocalLibrary);
parcelHelpers.export(exports, "MdLocalMall", ()=>MdLocalMall);
parcelHelpers.export(exports, "MdLocalMovies", ()=>MdLocalMovies);
parcelHelpers.export(exports, "MdLocalOffer", ()=>MdLocalOffer);
parcelHelpers.export(exports, "MdLocalParking", ()=>MdLocalParking);
parcelHelpers.export(exports, "MdLocalPharmacy", ()=>MdLocalPharmacy);
parcelHelpers.export(exports, "MdLocalPhone", ()=>MdLocalPhone);
parcelHelpers.export(exports, "MdLocalPizza", ()=>MdLocalPizza);
parcelHelpers.export(exports, "MdLocalPlay", ()=>MdLocalPlay);
parcelHelpers.export(exports, "MdLocalPolice", ()=>MdLocalPolice);
parcelHelpers.export(exports, "MdLocalPostOffice", ()=>MdLocalPostOffice);
parcelHelpers.export(exports, "MdLocalPrintshop", ()=>MdLocalPrintshop);
parcelHelpers.export(exports, "MdLocalSee", ()=>MdLocalSee);
parcelHelpers.export(exports, "MdLocalShipping", ()=>MdLocalShipping);
parcelHelpers.export(exports, "MdLocalTaxi", ()=>MdLocalTaxi);
parcelHelpers.export(exports, "MdLocationPin", ()=>MdLocationPin);
parcelHelpers.export(exports, "MdLunchDining", ()=>MdLunchDining);
parcelHelpers.export(exports, "MdMap", ()=>MdMap);
parcelHelpers.export(exports, "MdMapsUgc", ()=>MdMapsUgc);
parcelHelpers.export(exports, "MdMedicalInformation", ()=>MdMedicalInformation);
parcelHelpers.export(exports, "MdMedicalServices", ()=>MdMedicalServices);
parcelHelpers.export(exports, "MdMenuBook", ()=>MdMenuBook);
parcelHelpers.export(exports, "MdMerge", ()=>MdMerge);
parcelHelpers.export(exports, "MdMinorCrash", ()=>MdMinorCrash);
parcelHelpers.export(exports, "MdMiscellaneousServices", ()=>MdMiscellaneousServices);
parcelHelpers.export(exports, "MdModeOfTravel", ()=>MdModeOfTravel);
parcelHelpers.export(exports, "MdMoney", ()=>MdMoney);
parcelHelpers.export(exports, "MdMoped", ()=>MdMoped);
parcelHelpers.export(exports, "MdMosque", ()=>MdMosque);
parcelHelpers.export(exports, "MdMoving", ()=>MdMoving);
parcelHelpers.export(exports, "MdMultipleStop", ()=>MdMultipleStop);
parcelHelpers.export(exports, "MdMuseum", ()=>MdMuseum);
parcelHelpers.export(exports, "MdMyLocation", ()=>MdMyLocation);
parcelHelpers.export(exports, "MdNavigation", ()=>MdNavigation);
parcelHelpers.export(exports, "MdNearMeDisabled", ()=>MdNearMeDisabled);
parcelHelpers.export(exports, "MdNearMe", ()=>MdNearMe);
parcelHelpers.export(exports, "MdNightlife", ()=>MdNightlife);
parcelHelpers.export(exports, "MdNoCrash", ()=>MdNoCrash);
parcelHelpers.export(exports, "MdNoMealsOuline", ()=>MdNoMealsOuline);
parcelHelpers.export(exports, "MdNoMeals", ()=>MdNoMeals);
parcelHelpers.export(exports, "MdNoTransfer", ()=>MdNoTransfer);
parcelHelpers.export(exports, "MdNotListedLocation", ()=>MdNotListedLocation);
parcelHelpers.export(exports, "MdPark", ()=>MdPark);
parcelHelpers.export(exports, "MdPedalBike", ()=>MdPedalBike);
parcelHelpers.export(exports, "MdPersonPinCircle", ()=>MdPersonPinCircle);
parcelHelpers.export(exports, "MdPersonPin", ()=>MdPersonPin);
parcelHelpers.export(exports, "MdPestControlRodent", ()=>MdPestControlRodent);
parcelHelpers.export(exports, "MdPestControl", ()=>MdPestControl);
parcelHelpers.export(exports, "MdPinDrop", ()=>MdPinDrop);
parcelHelpers.export(exports, "MdPlace", ()=>MdPlace);
parcelHelpers.export(exports, "MdPlumbing", ()=>MdPlumbing);
parcelHelpers.export(exports, "MdRailwayAlert", ()=>MdRailwayAlert);
parcelHelpers.export(exports, "MdRamenDining", ()=>MdRamenDining);
parcelHelpers.export(exports, "MdRampLeft", ()=>MdRampLeft);
parcelHelpers.export(exports, "MdRampRight", ()=>MdRampRight);
parcelHelpers.export(exports, "MdRateReview", ()=>MdRateReview);
parcelHelpers.export(exports, "MdRemoveRoad", ()=>MdRemoveRoad);
parcelHelpers.export(exports, "MdRestaurantMenu", ()=>MdRestaurantMenu);
parcelHelpers.export(exports, "MdRestaurant", ()=>MdRestaurant);
parcelHelpers.export(exports, "MdRoundaboutLeft", ()=>MdRoundaboutLeft);
parcelHelpers.export(exports, "MdRoundaboutRight", ()=>MdRoundaboutRight);
parcelHelpers.export(exports, "MdRoute", ()=>MdRoute);
parcelHelpers.export(exports, "MdRunCircle", ()=>MdRunCircle);
parcelHelpers.export(exports, "MdSafetyCheck", ()=>MdSafetyCheck);
parcelHelpers.export(exports, "MdSailing", ()=>MdSailing);
parcelHelpers.export(exports, "MdSatellite", ()=>MdSatellite);
parcelHelpers.export(exports, "MdScreenRotationAlt", ()=>MdScreenRotationAlt);
parcelHelpers.export(exports, "MdSetMeal", ()=>MdSetMeal);
parcelHelpers.export(exports, "MdSignpost", ()=>MdSignpost);
parcelHelpers.export(exports, "MdSnowmobile", ()=>MdSnowmobile);
parcelHelpers.export(exports, "MdSos", ()=>MdSos);
parcelHelpers.export(exports, "MdSoupKitchen", ()=>MdSoupKitchen);
parcelHelpers.export(exports, "MdStadium", ()=>MdStadium);
parcelHelpers.export(exports, "MdStoreMallDirectory", ()=>MdStoreMallDirectory);
parcelHelpers.export(exports, "MdStraight", ()=>MdStraight);
parcelHelpers.export(exports, "MdStreetview", ()=>MdStreetview);
parcelHelpers.export(exports, "MdSubway", ()=>MdSubway);
parcelHelpers.export(exports, "MdSynagogue", ()=>MdSynagogue);
parcelHelpers.export(exports, "MdTakeoutDining", ()=>MdTakeoutDining);
parcelHelpers.export(exports, "MdTaxiAlert", ()=>MdTaxiAlert);
parcelHelpers.export(exports, "MdTempleBuddhist", ()=>MdTempleBuddhist);
parcelHelpers.export(exports, "MdTempleHindu", ()=>MdTempleHindu);
parcelHelpers.export(exports, "MdTerrain", ()=>MdTerrain);
parcelHelpers.export(exports, "MdTheaterComedy", ()=>MdTheaterComedy);
parcelHelpers.export(exports, "MdTireRepair", ()=>MdTireRepair);
parcelHelpers.export(exports, "MdTraffic", ()=>MdTraffic);
parcelHelpers.export(exports, "MdTrain", ()=>MdTrain);
parcelHelpers.export(exports, "MdTram", ()=>MdTram);
parcelHelpers.export(exports, "MdTransferWithinAStation", ()=>MdTransferWithinAStation);
parcelHelpers.export(exports, "MdTransitEnterexit", ()=>MdTransitEnterexit);
parcelHelpers.export(exports, "MdTripOrigin", ()=>MdTripOrigin);
parcelHelpers.export(exports, "MdTurnLeft", ()=>MdTurnLeft);
parcelHelpers.export(exports, "MdTurnRight", ()=>MdTurnRight);
parcelHelpers.export(exports, "MdTurnSharpLeft", ()=>MdTurnSharpLeft);
parcelHelpers.export(exports, "MdTurnSharpRight", ()=>MdTurnSharpRight);
parcelHelpers.export(exports, "MdTurnSlightLeft", ()=>MdTurnSlightLeft);
parcelHelpers.export(exports, "MdTurnSlightRight", ()=>MdTurnSlightRight);
parcelHelpers.export(exports, "MdTwoWheeler", ()=>MdTwoWheeler);
parcelHelpers.export(exports, "MdUTurnLeft", ()=>MdUTurnLeft);
parcelHelpers.export(exports, "MdUTurnRight", ()=>MdUTurnRight);
parcelHelpers.export(exports, "MdVolunteerActivism", ()=>MdVolunteerActivism);
parcelHelpers.export(exports, "MdWarehouse", ()=>MdWarehouse);
parcelHelpers.export(exports, "MdWineBar", ()=>MdWineBar);
parcelHelpers.export(exports, "MdWrongLocation", ()=>MdWrongLocation);
parcelHelpers.export(exports, "MdZoomInMap", ()=>MdZoomInMap);
parcelHelpers.export(exports, "MdZoomOutMap", ()=>MdZoomOutMap);
parcelHelpers.export(exports, "MdAddHomeWork", ()=>MdAddHomeWork);
parcelHelpers.export(exports, "MdAppSettingsAlt", ()=>MdAppSettingsAlt);
parcelHelpers.export(exports, "MdAppsOutage", ()=>MdAppsOutage);
parcelHelpers.export(exports, "MdApps", ()=>MdApps);
parcelHelpers.export(exports, "MdArrowBackIosNew", ()=>MdArrowBackIosNew);
parcelHelpers.export(exports, "MdArrowBackIos", ()=>MdArrowBackIos);
parcelHelpers.export(exports, "MdArrowBack", ()=>MdArrowBack);
parcelHelpers.export(exports, "MdArrowDownward", ()=>MdArrowDownward);
parcelHelpers.export(exports, "MdArrowDropDownCircle", ()=>MdArrowDropDownCircle);
parcelHelpers.export(exports, "MdArrowDropDown", ()=>MdArrowDropDown);
parcelHelpers.export(exports, "MdArrowDropUp", ()=>MdArrowDropUp);
parcelHelpers.export(exports, "MdArrowForwardIos", ()=>MdArrowForwardIos);
parcelHelpers.export(exports, "MdArrowForward", ()=>MdArrowForward);
parcelHelpers.export(exports, "MdArrowLeft", ()=>MdArrowLeft);
parcelHelpers.export(exports, "MdArrowRight", ()=>MdArrowRight);
parcelHelpers.export(exports, "MdArrowUpward", ()=>MdArrowUpward);
parcelHelpers.export(exports, "MdAssistantDirection", ()=>MdAssistantDirection);
parcelHelpers.export(exports, "MdAssistantNavigation", ()=>MdAssistantNavigation);
parcelHelpers.export(exports, "MdCampaign", ()=>MdCampaign);
parcelHelpers.export(exports, "MdCancel", ()=>MdCancel);
parcelHelpers.export(exports, "MdCheck", ()=>MdCheck);
parcelHelpers.export(exports, "MdChevronLeft", ()=>MdChevronLeft);
parcelHelpers.export(exports, "MdChevronRight", ()=>MdChevronRight);
parcelHelpers.export(exports, "MdClose", ()=>MdClose);
parcelHelpers.export(exports, "MdDoubleArrow", ()=>MdDoubleArrow);
parcelHelpers.export(exports, "MdEast", ()=>MdEast);
parcelHelpers.export(exports, "MdExpandCircleDown", ()=>MdExpandCircleDown);
parcelHelpers.export(exports, "MdExpandLess", ()=>MdExpandLess);
parcelHelpers.export(exports, "MdExpandMore", ()=>MdExpandMore);
parcelHelpers.export(exports, "MdFirstPage", ()=>MdFirstPage);
parcelHelpers.export(exports, "MdFullscreenExit", ()=>MdFullscreenExit);
parcelHelpers.export(exports, "MdFullscreen", ()=>MdFullscreen);
parcelHelpers.export(exports, "MdHomeWork", ()=>MdHomeWork);
parcelHelpers.export(exports, "MdLastPage", ()=>MdLastPage);
parcelHelpers.export(exports, "MdLegendToggle", ()=>MdLegendToggle);
parcelHelpers.export(exports, "MdMapsHomeWork", ()=>MdMapsHomeWork);
parcelHelpers.export(exports, "MdMenuOpen", ()=>MdMenuOpen);
parcelHelpers.export(exports, "MdMenu", ()=>MdMenu);
parcelHelpers.export(exports, "MdMoreHoriz", ()=>MdMoreHoriz);
parcelHelpers.export(exports, "MdMoreVert", ()=>MdMoreVert);
parcelHelpers.export(exports, "MdNorthEast", ()=>MdNorthEast);
parcelHelpers.export(exports, "MdNorthWest", ()=>MdNorthWest);
parcelHelpers.export(exports, "MdNorth", ()=>MdNorth);
parcelHelpers.export(exports, "MdOfflineShare", ()=>MdOfflineShare);
parcelHelpers.export(exports, "MdPayments", ()=>MdPayments);
parcelHelpers.export(exports, "MdPivotTableChart", ()=>MdPivotTableChart);
parcelHelpers.export(exports, "MdRefresh", ()=>MdRefresh);
parcelHelpers.export(exports, "MdSouthEast", ()=>MdSouthEast);
parcelHelpers.export(exports, "MdSouthWest", ()=>MdSouthWest);
parcelHelpers.export(exports, "MdSouth", ()=>MdSouth);
parcelHelpers.export(exports, "MdSubdirectoryArrowLeft", ()=>MdSubdirectoryArrowLeft);
parcelHelpers.export(exports, "MdSubdirectoryArrowRight", ()=>MdSubdirectoryArrowRight);
parcelHelpers.export(exports, "MdSwitchLeft", ()=>MdSwitchLeft);
parcelHelpers.export(exports, "MdSwitchRight", ()=>MdSwitchRight);
parcelHelpers.export(exports, "MdUnfoldLess", ()=>MdUnfoldLess);
parcelHelpers.export(exports, "MdUnfoldMore", ()=>MdUnfoldMore);
parcelHelpers.export(exports, "MdWaterfallChart", ()=>MdWaterfallChart);
parcelHelpers.export(exports, "MdWest", ()=>MdWest);
parcelHelpers.export(exports, "MdAccountTree", ()=>MdAccountTree);
parcelHelpers.export(exports, "MdAdb", ()=>MdAdb);
parcelHelpers.export(exports, "MdAddCall", ()=>MdAddCall);
parcelHelpers.export(exports, "MdAirlineSeatFlatAngled", ()=>MdAirlineSeatFlatAngled);
parcelHelpers.export(exports, "MdAirlineSeatFlat", ()=>MdAirlineSeatFlat);
parcelHelpers.export(exports, "MdAirlineSeatIndividualSuite", ()=>MdAirlineSeatIndividualSuite);
parcelHelpers.export(exports, "MdAirlineSeatLegroomExtra", ()=>MdAirlineSeatLegroomExtra);
parcelHelpers.export(exports, "MdAirlineSeatLegroomNormal", ()=>MdAirlineSeatLegroomNormal);
parcelHelpers.export(exports, "MdAirlineSeatLegroomReduced", ()=>MdAirlineSeatLegroomReduced);
parcelHelpers.export(exports, "MdAirlineSeatReclineExtra", ()=>MdAirlineSeatReclineExtra);
parcelHelpers.export(exports, "MdAirlineSeatReclineNormal", ()=>MdAirlineSeatReclineNormal);
parcelHelpers.export(exports, "MdBluetoothAudio", ()=>MdBluetoothAudio);
parcelHelpers.export(exports, "MdConfirmationNumber", ()=>MdConfirmationNumber);
parcelHelpers.export(exports, "MdDirectionsOff", ()=>MdDirectionsOff);
parcelHelpers.export(exports, "MdDiscFull", ()=>MdDiscFull);
parcelHelpers.export(exports, "MdDoDisturbAlt", ()=>MdDoDisturbAlt);
parcelHelpers.export(exports, "MdDoDisturbOff", ()=>MdDoDisturbOff);
parcelHelpers.export(exports, "MdDoDisturbOn", ()=>MdDoDisturbOn);
parcelHelpers.export(exports, "MdDoDisturb", ()=>MdDoDisturb);
parcelHelpers.export(exports, "MdDoNotDisturbAlt", ()=>MdDoNotDisturbAlt);
parcelHelpers.export(exports, "MdDoNotDisturbOff", ()=>MdDoNotDisturbOff);
parcelHelpers.export(exports, "MdDoNotDisturbOn", ()=>MdDoNotDisturbOn);
parcelHelpers.export(exports, "MdDoNotDisturb", ()=>MdDoNotDisturb);
parcelHelpers.export(exports, "MdDriveEta", ()=>MdDriveEta);
parcelHelpers.export(exports, "MdEnhancedEncryption", ()=>MdEnhancedEncryption);
parcelHelpers.export(exports, "MdEventAvailable", ()=>MdEventAvailable);
parcelHelpers.export(exports, "MdEventBusy", ()=>MdEventBusy);
parcelHelpers.export(exports, "MdEventNote", ()=>MdEventNote);
parcelHelpers.export(exports, "MdFolderSpecial", ()=>MdFolderSpecial);
parcelHelpers.export(exports, "MdImagesearchRoller", ()=>MdImagesearchRoller);
parcelHelpers.export(exports, "MdLiveTv", ()=>MdLiveTv);
parcelHelpers.export(exports, "MdMms", ()=>MdMms);
parcelHelpers.export(exports, "MdMore", ()=>MdMore);
parcelHelpers.export(exports, "MdNetworkCheck", ()=>MdNetworkCheck);
parcelHelpers.export(exports, "MdNetworkLocked", ()=>MdNetworkLocked);
parcelHelpers.export(exports, "MdNoEncryptionGmailerrorred", ()=>MdNoEncryptionGmailerrorred);
parcelHelpers.export(exports, "MdNoEncryption", ()=>MdNoEncryption);
parcelHelpers.export(exports, "MdOndemandVideo", ()=>MdOndemandVideo);
parcelHelpers.export(exports, "MdPersonalVideo", ()=>MdPersonalVideo);
parcelHelpers.export(exports, "MdPhoneBluetoothSpeaker", ()=>MdPhoneBluetoothSpeaker);
parcelHelpers.export(exports, "MdPhoneCallback", ()=>MdPhoneCallback);
parcelHelpers.export(exports, "MdPhoneForwarded", ()=>MdPhoneForwarded);
parcelHelpers.export(exports, "MdPhoneInTalk", ()=>MdPhoneInTalk);
parcelHelpers.export(exports, "MdPhoneLocked", ()=>MdPhoneLocked);
parcelHelpers.export(exports, "MdPhoneMissed", ()=>MdPhoneMissed);
parcelHelpers.export(exports, "MdPhonePaused", ()=>MdPhonePaused);
parcelHelpers.export(exports, "MdPowerOff", ()=>MdPowerOff);
parcelHelpers.export(exports, "MdPower", ()=>MdPower);
parcelHelpers.export(exports, "MdPriorityHigh", ()=>MdPriorityHigh);
parcelHelpers.export(exports, "MdRunningWithErrors", ()=>MdRunningWithErrors);
parcelHelpers.export(exports, "MdSdCardAlert", ()=>MdSdCardAlert);
parcelHelpers.export(exports, "MdSdCard", ()=>MdSdCard);
parcelHelpers.export(exports, "MdSimCardAlert", ()=>MdSimCardAlert);
parcelHelpers.export(exports, "MdSmsFailed", ()=>MdSmsFailed);
parcelHelpers.export(exports, "MdSms", ()=>MdSms);
parcelHelpers.export(exports, "MdSupportAgent", ()=>MdSupportAgent);
parcelHelpers.export(exports, "MdSyncDisabled", ()=>MdSyncDisabled);
parcelHelpers.export(exports, "MdSyncLock", ()=>MdSyncLock);
parcelHelpers.export(exports, "MdSyncProblem", ()=>MdSyncProblem);
parcelHelpers.export(exports, "MdSync", ()=>MdSync);
parcelHelpers.export(exports, "MdSystemUpdate", ()=>MdSystemUpdate);
parcelHelpers.export(exports, "MdTapAndPlay", ()=>MdTapAndPlay);
parcelHelpers.export(exports, "MdTimeToLeave", ()=>MdTimeToLeave);
parcelHelpers.export(exports, "MdTvOff", ()=>MdTvOff);
parcelHelpers.export(exports, "MdVibration", ()=>MdVibration);
parcelHelpers.export(exports, "MdVideoChat", ()=>MdVideoChat);
parcelHelpers.export(exports, "MdVoiceChat", ()=>MdVoiceChat);
parcelHelpers.export(exports, "MdVpnLock", ()=>MdVpnLock);
parcelHelpers.export(exports, "MdWc", ()=>MdWc);
parcelHelpers.export(exports, "MdWifiOff", ()=>MdWifiOff);
parcelHelpers.export(exports, "MdWifi", ()=>MdWifi);
parcelHelpers.export(exports, "MdAcUnit", ()=>MdAcUnit);
parcelHelpers.export(exports, "MdAirportShuttle", ()=>MdAirportShuttle);
parcelHelpers.export(exports, "MdAllInclusive", ()=>MdAllInclusive);
parcelHelpers.export(exports, "MdApartment", ()=>MdApartment);
parcelHelpers.export(exports, "MdBabyChangingStation", ()=>MdBabyChangingStation);
parcelHelpers.export(exports, "MdBackpack", ()=>MdBackpack);
parcelHelpers.export(exports, "MdBalcony", ()=>MdBalcony);
parcelHelpers.export(exports, "MdBathtub", ()=>MdBathtub);
parcelHelpers.export(exports, "MdBeachAccess", ()=>MdBeachAccess);
parcelHelpers.export(exports, "MdBento", ()=>MdBento);
parcelHelpers.export(exports, "MdBungalow", ()=>MdBungalow);
parcelHelpers.export(exports, "MdBusinessCenter", ()=>MdBusinessCenter);
parcelHelpers.export(exports, "MdCabin", ()=>MdCabin);
parcelHelpers.export(exports, "MdCarpenter", ()=>MdCarpenter);
parcelHelpers.export(exports, "MdCasino", ()=>MdCasino);
parcelHelpers.export(exports, "MdChalet", ()=>MdChalet);
parcelHelpers.export(exports, "MdChargingStation", ()=>MdChargingStation);
parcelHelpers.export(exports, "MdCheckroom", ()=>MdCheckroom);
parcelHelpers.export(exports, "MdChildCare", ()=>MdChildCare);
parcelHelpers.export(exports, "MdChildFriendly", ()=>MdChildFriendly);
parcelHelpers.export(exports, "MdCorporateFare", ()=>MdCorporateFare);
parcelHelpers.export(exports, "MdCottage", ()=>MdCottage);
parcelHelpers.export(exports, "MdCountertops", ()=>MdCountertops);
parcelHelpers.export(exports, "MdCrib", ()=>MdCrib);
parcelHelpers.export(exports, "MdDesk", ()=>MdDesk);
parcelHelpers.export(exports, "MdDoNotStep", ()=>MdDoNotStep);
parcelHelpers.export(exports, "MdDoNotTouch", ()=>MdDoNotTouch);
parcelHelpers.export(exports, "MdDry", ()=>MdDry);
parcelHelpers.export(exports, "MdElevator", ()=>MdElevator);
parcelHelpers.export(exports, "MdEscalatorWarning", ()=>MdEscalatorWarning);
parcelHelpers.export(exports, "MdEscalator", ()=>MdEscalator);
parcelHelpers.export(exports, "MdFamilyRestroom", ()=>MdFamilyRestroom);
parcelHelpers.export(exports, "MdFence", ()=>MdFence);
parcelHelpers.export(exports, "MdFireExtinguisher", ()=>MdFireExtinguisher);
parcelHelpers.export(exports, "MdFitnessCenter", ()=>MdFitnessCenter);
parcelHelpers.export(exports, "MdFoodBank", ()=>MdFoodBank);
parcelHelpers.export(exports, "MdFoundation", ()=>MdFoundation);
parcelHelpers.export(exports, "MdFreeBreakfast", ()=>MdFreeBreakfast);
parcelHelpers.export(exports, "MdGite", ()=>MdGite);
parcelHelpers.export(exports, "MdGolfCourse", ()=>MdGolfCourse);
parcelHelpers.export(exports, "MdGrass", ()=>MdGrass);
parcelHelpers.export(exports, "MdHolidayVillage", ()=>MdHolidayVillage);
parcelHelpers.export(exports, "MdHotTub", ()=>MdHotTub);
parcelHelpers.export(exports, "MdHouseSiding", ()=>MdHouseSiding);
parcelHelpers.export(exports, "MdHouse", ()=>MdHouse);
parcelHelpers.export(exports, "MdHouseboat", ()=>MdHouseboat);
parcelHelpers.export(exports, "MdIron", ()=>MdIron);
parcelHelpers.export(exports, "MdKitchen", ()=>MdKitchen);
parcelHelpers.export(exports, "MdMeetingRoom", ()=>MdMeetingRoom);
parcelHelpers.export(exports, "MdMicrowave", ()=>MdMicrowave);
parcelHelpers.export(exports, "MdNightShelter", ()=>MdNightShelter);
parcelHelpers.export(exports, "MdNoBackpack", ()=>MdNoBackpack);
parcelHelpers.export(exports, "MdNoCell", ()=>MdNoCell);
parcelHelpers.export(exports, "MdNoDrinks", ()=>MdNoDrinks);
parcelHelpers.export(exports, "MdNoFlash", ()=>MdNoFlash);
parcelHelpers.export(exports, "MdNoFood", ()=>MdNoFood);
parcelHelpers.export(exports, "MdNoMeetingRoom", ()=>MdNoMeetingRoom);
parcelHelpers.export(exports, "MdNoPhotography", ()=>MdNoPhotography);
parcelHelpers.export(exports, "MdNoStroller", ()=>MdNoStroller);
parcelHelpers.export(exports, "MdOtherHouses", ()=>MdOtherHouses);
parcelHelpers.export(exports, "MdPool", ()=>MdPool);
parcelHelpers.export(exports, "MdRiceBowl", ()=>MdRiceBowl);
parcelHelpers.export(exports, "MdRoofing", ()=>MdRoofing);
parcelHelpers.export(exports, "MdRoomPreferences", ()=>MdRoomPreferences);
parcelHelpers.export(exports, "MdRoomService", ()=>MdRoomService);
parcelHelpers.export(exports, "MdRvHookup", ()=>MdRvHookup);
parcelHelpers.export(exports, "MdSmokeFree", ()=>MdSmokeFree);
parcelHelpers.export(exports, "MdSmokingRooms", ()=>MdSmokingRooms);
parcelHelpers.export(exports, "MdSoap", ()=>MdSoap);
parcelHelpers.export(exports, "MdSpa", ()=>MdSpa);
parcelHelpers.export(exports, "MdSportsBar", ()=>MdSportsBar);
parcelHelpers.export(exports, "MdStairs", ()=>MdStairs);
parcelHelpers.export(exports, "MdStorefront", ()=>MdStorefront);
parcelHelpers.export(exports, "MdStroller", ()=>MdStroller);
parcelHelpers.export(exports, "MdTapas", ()=>MdTapas);
parcelHelpers.export(exports, "MdTty", ()=>MdTty);
parcelHelpers.export(exports, "MdUmbrella", ()=>MdUmbrella);
parcelHelpers.export(exports, "MdVapeFree", ()=>MdVapeFree);
parcelHelpers.export(exports, "MdVapingRooms", ()=>MdVapingRooms);
parcelHelpers.export(exports, "MdVilla", ()=>MdVilla);
parcelHelpers.export(exports, "MdWash", ()=>MdWash);
parcelHelpers.export(exports, "MdWaterDamage", ()=>MdWaterDamage);
parcelHelpers.export(exports, "MdWheelchairPickup", ()=>MdWheelchairPickup);
parcelHelpers.export(exports, "MdBathroom", ()=>MdBathroom);
parcelHelpers.export(exports, "MdBed", ()=>MdBed);
parcelHelpers.export(exports, "MdBedroomBaby", ()=>MdBedroomBaby);
parcelHelpers.export(exports, "MdBedroomChild", ()=>MdBedroomChild);
parcelHelpers.export(exports, "MdBedroomParent", ()=>MdBedroomParent);
parcelHelpers.export(exports, "MdBlender", ()=>MdBlender);
parcelHelpers.export(exports, "MdCameraIndoor", ()=>MdCameraIndoor);
parcelHelpers.export(exports, "MdCameraOutdoor", ()=>MdCameraOutdoor);
parcelHelpers.export(exports, "MdChairAlt", ()=>MdChairAlt);
parcelHelpers.export(exports, "MdChair", ()=>MdChair);
parcelHelpers.export(exports, "MdCoffeeMaker", ()=>MdCoffeeMaker);
parcelHelpers.export(exports, "MdCoffee", ()=>MdCoffee);
parcelHelpers.export(exports, "MdDining", ()=>MdDining);
parcelHelpers.export(exports, "MdDoorBack", ()=>MdDoorBack);
parcelHelpers.export(exports, "MdDoorFront", ()=>MdDoorFront);
parcelHelpers.export(exports, "MdDoorSliding", ()=>MdDoorSliding);
parcelHelpers.export(exports, "MdDoorbell", ()=>MdDoorbell);
parcelHelpers.export(exports, "MdFeed", ()=>MdFeed);
parcelHelpers.export(exports, "MdFlatware", ()=>MdFlatware);
parcelHelpers.export(exports, "MdGarage", ()=>MdGarage);
parcelHelpers.export(exports, "MdLight", ()=>MdLight);
parcelHelpers.export(exports, "MdLiving", ()=>MdLiving);
parcelHelpers.export(exports, "MdManageSearch", ()=>MdManageSearch);
parcelHelpers.export(exports, "MdPodcasts", ()=>MdPodcasts);
parcelHelpers.export(exports, "MdShower", ()=>MdShower);
parcelHelpers.export(exports, "MdTableBar", ()=>MdTableBar);
parcelHelpers.export(exports, "MdTableRestaurant", ()=>MdTableRestaurant);
parcelHelpers.export(exports, "MdWindow", ()=>MdWindow);
parcelHelpers.export(exports, "MdYard", ()=>MdYard);
parcelHelpers.export(exports, "Md18UpRating", ()=>Md18UpRating);
parcelHelpers.export(exports, "Md6FtApart", ()=>Md6FtApart);
parcelHelpers.export(exports, "MdAddModerator", ()=>MdAddModerator);
parcelHelpers.export(exports, "MdAddReaction", ()=>MdAddReaction);
parcelHelpers.export(exports, "MdArchitecture", ()=>MdArchitecture);
parcelHelpers.export(exports, "MdAssistWalker", ()=>MdAssistWalker);
parcelHelpers.export(exports, "MdBackHand", ()=>MdBackHand);
parcelHelpers.export(exports, "MdBlind", ()=>MdBlind);
parcelHelpers.export(exports, "MdBoy", ()=>MdBoy);
parcelHelpers.export(exports, "MdCake", ()=>MdCake);
parcelHelpers.export(exports, "MdCatchingPokemon", ()=>MdCatchingPokemon);
parcelHelpers.export(exports, "MdCleanHands", ()=>MdCleanHands);
parcelHelpers.export(exports, "MdCo2", ()=>MdCo2);
parcelHelpers.export(exports, "MdCompost", ()=>MdCompost);
parcelHelpers.export(exports, "MdConnectWithoutContact", ()=>MdConnectWithoutContact);
parcelHelpers.export(exports, "MdConstruction", ()=>MdConstruction);
parcelHelpers.export(exports, "MdCookie", ()=>MdCookie);
parcelHelpers.export(exports, "MdCoronavirus", ()=>MdCoronavirus);
parcelHelpers.export(exports, "MdCrueltyFree", ()=>MdCrueltyFree);
parcelHelpers.export(exports, "MdCyclone", ()=>MdCyclone);
parcelHelpers.export(exports, "MdDeck", ()=>MdDeck);
parcelHelpers.export(exports, "MdDewPoint", ()=>MdDewPoint);
parcelHelpers.export(exports, "MdDiversity1", ()=>MdDiversity1);
parcelHelpers.export(exports, "MdDiversity2", ()=>MdDiversity2);
parcelHelpers.export(exports, "MdDiversity3", ()=>MdDiversity3);
parcelHelpers.export(exports, "MdDomainAdd", ()=>MdDomainAdd);
parcelHelpers.export(exports, "MdDomain", ()=>MdDomain);
parcelHelpers.export(exports, "MdDownhillSkiing", ()=>MdDownhillSkiing);
parcelHelpers.export(exports, "MdEditNotifications", ()=>MdEditNotifications);
parcelHelpers.export(exports, "MdElderlyWoman", ()=>MdElderlyWoman);
parcelHelpers.export(exports, "MdElderly", ()=>MdElderly);
parcelHelpers.export(exports, "MdEmojiEmotions", ()=>MdEmojiEmotions);
parcelHelpers.export(exports, "MdEmojiEvents", ()=>MdEmojiEvents);
parcelHelpers.export(exports, "MdEmojiFlags", ()=>MdEmojiFlags);
parcelHelpers.export(exports, "MdEmojiFoodBeverage", ()=>MdEmojiFoodBeverage);
parcelHelpers.export(exports, "MdEmojiNature", ()=>MdEmojiNature);
parcelHelpers.export(exports, "MdEmojiObjects", ()=>MdEmojiObjects);
parcelHelpers.export(exports, "MdEmojiPeople", ()=>MdEmojiPeople);
parcelHelpers.export(exports, "MdEmojiSymbols", ()=>MdEmojiSymbols);
parcelHelpers.export(exports, "MdEmojiTransportation", ()=>MdEmojiTransportation);
parcelHelpers.export(exports, "MdEngineering", ()=>MdEngineering);
parcelHelpers.export(exports, "MdFace2", ()=>MdFace2);
parcelHelpers.export(exports, "MdFace3", ()=>MdFace3);
parcelHelpers.export(exports, "MdFace4", ()=>MdFace4);
parcelHelpers.export(exports, "MdFace5", ()=>MdFace5);
parcelHelpers.export(exports, "MdFace6", ()=>MdFace6);
parcelHelpers.export(exports, "MdFacebook", ()=>MdFacebook);
parcelHelpers.export(exports, "MdFemale", ()=>MdFemale);
parcelHelpers.export(exports, "MdFireplace", ()=>MdFireplace);
parcelHelpers.export(exports, "MdFitbit", ()=>MdFitbit);
parcelHelpers.export(exports, "MdFlood", ()=>MdFlood);
parcelHelpers.export(exports, "MdFollowTheSigns", ()=>MdFollowTheSigns);
parcelHelpers.export(exports, "MdFrontHand", ()=>MdFrontHand);
parcelHelpers.export(exports, "MdGirl", ()=>MdGirl);
parcelHelpers.export(exports, "MdGroupAdd", ()=>MdGroupAdd);
parcelHelpers.export(exports, "MdGroupOff", ()=>MdGroupOff);
parcelHelpers.export(exports, "MdGroupRemove", ()=>MdGroupRemove);
parcelHelpers.export(exports, "MdGroup", ()=>MdGroup);
parcelHelpers.export(exports, "MdGroups2", ()=>MdGroups2);
parcelHelpers.export(exports, "MdGroups3", ()=>MdGroups3);
parcelHelpers.export(exports, "MdGroups", ()=>MdGroups);
parcelHelpers.export(exports, "MdHandshake", ()=>MdHandshake);
parcelHelpers.export(exports, "MdHealthAndSafety", ()=>MdHealthAndSafety);
parcelHelpers.export(exports, "MdHeartBroken", ()=>MdHeartBroken);
parcelHelpers.export(exports, "MdHiking", ()=>MdHiking);
parcelHelpers.export(exports, "MdHistoryEdu", ()=>MdHistoryEdu);
parcelHelpers.export(exports, "MdHive", ()=>MdHive);
parcelHelpers.export(exports, "MdIceSkating", ()=>MdIceSkating);
parcelHelpers.export(exports, "MdInterests", ()=>MdInterests);
parcelHelpers.export(exports, "MdIosShare", ()=>MdIosShare);
parcelHelpers.export(exports, "MdKayaking", ()=>MdKayaking);
parcelHelpers.export(exports, "MdKingBed", ()=>MdKingBed);
parcelHelpers.export(exports, "MdKitesurfing", ()=>MdKitesurfing);
parcelHelpers.export(exports, "MdLandslide", ()=>MdLandslide);
parcelHelpers.export(exports, "MdLocationCity", ()=>MdLocationCity);
parcelHelpers.export(exports, "MdLuggage", ()=>MdLuggage);
parcelHelpers.export(exports, "MdMale", ()=>MdMale);
parcelHelpers.export(exports, "MdMan2", ()=>MdMan2);
parcelHelpers.export(exports, "MdMan3", ()=>MdMan3);
parcelHelpers.export(exports, "MdMan4", ()=>MdMan4);
parcelHelpers.export(exports, "MdMan", ()=>MdMan);
parcelHelpers.export(exports, "MdMasks", ()=>MdMasks);
parcelHelpers.export(exports, "MdMilitaryTech", ()=>MdMilitaryTech);
parcelHelpers.export(exports, "MdMoodBad", ()=>MdMoodBad);
parcelHelpers.export(exports, "MdMood", ()=>MdMood);
parcelHelpers.export(exports, "MdNightsStay", ()=>MdNightsStay);
parcelHelpers.export(exports, "MdNoAdultContent", ()=>MdNoAdultContent);
parcelHelpers.export(exports, "MdNoLuggage", ()=>MdNoLuggage);
parcelHelpers.export(exports, "MdNordicWalking", ()=>MdNordicWalking);
parcelHelpers.export(exports, "MdNotificationAdd", ()=>MdNotificationAdd);
parcelHelpers.export(exports, "MdNotificationsActive", ()=>MdNotificationsActive);
parcelHelpers.export(exports, "MdNotificationsNone", ()=>MdNotificationsNone);
parcelHelpers.export(exports, "MdNotificationsOff", ()=>MdNotificationsOff);
parcelHelpers.export(exports, "MdNotificationsPaused", ()=>MdNotificationsPaused);
parcelHelpers.export(exports, "MdNotifications", ()=>MdNotifications);
parcelHelpers.export(exports, "MdOutdoorGrill", ()=>MdOutdoorGrill);
parcelHelpers.export(exports, "MdPages", ()=>MdPages);
parcelHelpers.export(exports, "MdParagliding", ()=>MdParagliding);
parcelHelpers.export(exports, "MdPartyMode", ()=>MdPartyMode);
parcelHelpers.export(exports, "MdPeopleAlt", ()=>MdPeopleAlt);
parcelHelpers.export(exports, "MdPeopleOutline", ()=>MdPeopleOutline);
parcelHelpers.export(exports, "MdPeople", ()=>MdPeople);
parcelHelpers.export(exports, "MdPerson2", ()=>MdPerson2);
parcelHelpers.export(exports, "MdPerson3", ()=>MdPerson3);
parcelHelpers.export(exports, "MdPerson4", ()=>MdPerson4);
parcelHelpers.export(exports, "MdPersonAddAlt1", ()=>MdPersonAddAlt1);
parcelHelpers.export(exports, "MdPersonAddAlt", ()=>MdPersonAddAlt);
parcelHelpers.export(exports, "MdPersonAdd", ()=>MdPersonAdd);
parcelHelpers.export(exports, "MdPersonOff", ()=>MdPersonOff);
parcelHelpers.export(exports, "MdPersonOutline", ()=>MdPersonOutline);
parcelHelpers.export(exports, "MdPersonRemoveAlt1", ()=>MdPersonRemoveAlt1);
parcelHelpers.export(exports, "MdPersonRemove", ()=>MdPersonRemove);
parcelHelpers.export(exports, "MdPerson", ()=>MdPerson);
parcelHelpers.export(exports, "MdPersonalInjury", ()=>MdPersonalInjury);
parcelHelpers.export(exports, "MdPianoOff", ()=>MdPianoOff);
parcelHelpers.export(exports, "MdPiano", ()=>MdPiano);
parcelHelpers.export(exports, "MdPix", ()=>MdPix);
parcelHelpers.export(exports, "MdPlusOne", ()=>MdPlusOne);
parcelHelpers.export(exports, "MdPoll", ()=>MdPoll);
parcelHelpers.export(exports, "MdPrecisionManufacturing", ()=>MdPrecisionManufacturing);
parcelHelpers.export(exports, "MdPsychologyAlt", ()=>MdPsychologyAlt);
parcelHelpers.export(exports, "MdPsychology", ()=>MdPsychology);
parcelHelpers.export(exports, "MdPublicOff", ()=>MdPublicOff);
parcelHelpers.export(exports, "MdPublic", ()=>MdPublic);
parcelHelpers.export(exports, "MdRealEstateAgent", ()=>MdRealEstateAgent);
parcelHelpers.export(exports, "MdRecommend", ()=>MdRecommend);
parcelHelpers.export(exports, "MdRecycling", ()=>MdRecycling);
parcelHelpers.export(exports, "MdReduceCapacity", ()=>MdReduceCapacity);
parcelHelpers.export(exports, "MdRemoveModerator", ()=>MdRemoveModerator);
parcelHelpers.export(exports, "MdRollerSkating", ()=>MdRollerSkating);
parcelHelpers.export(exports, "MdSafetyDivider", ()=>MdSafetyDivider);
parcelHelpers.export(exports, "MdSanitizer", ()=>MdSanitizer);
parcelHelpers.export(exports, "MdScale", ()=>MdScale);
parcelHelpers.export(exports, "MdSchool", ()=>MdSchool);
parcelHelpers.export(exports, "MdScience", ()=>MdScience);
parcelHelpers.export(exports, "MdScoreboard", ()=>MdScoreboard);
parcelHelpers.export(exports, "MdScubaDiving", ()=>MdScubaDiving);
parcelHelpers.export(exports, "MdSelfImprovement", ()=>MdSelfImprovement);
parcelHelpers.export(exports, "MdSentimentDissatisfied", ()=>MdSentimentDissatisfied);
parcelHelpers.export(exports, "MdSentimentNeutral", ()=>MdSentimentNeutral);
parcelHelpers.export(exports, "MdSentimentSatisfied", ()=>MdSentimentSatisfied);
parcelHelpers.export(exports, "MdSentimentVeryDissatisfied", ()=>MdSentimentVeryDissatisfied);
parcelHelpers.export(exports, "MdSentimentVerySatisfied", ()=>MdSentimentVerySatisfied);
parcelHelpers.export(exports, "MdSevereCold", ()=>MdSevereCold);
parcelHelpers.export(exports, "MdShare", ()=>MdShare);
parcelHelpers.export(exports, "MdSick", ()=>MdSick);
parcelHelpers.export(exports, "MdSignLanguage", ()=>MdSignLanguage);
parcelHelpers.export(exports, "MdSingleBed", ()=>MdSingleBed);
parcelHelpers.export(exports, "MdSkateboarding", ()=>MdSkateboarding);
parcelHelpers.export(exports, "MdSledding", ()=>MdSledding);
parcelHelpers.export(exports, "MdSnowboarding", ()=>MdSnowboarding);
parcelHelpers.export(exports, "MdSnowshoeing", ()=>MdSnowshoeing);
parcelHelpers.export(exports, "MdSocialDistance", ()=>MdSocialDistance);
parcelHelpers.export(exports, "MdSouthAmerica", ()=>MdSouthAmerica);
parcelHelpers.export(exports, "MdSportsBaseball", ()=>MdSportsBaseball);
parcelHelpers.export(exports, "MdSportsBasketball", ()=>MdSportsBasketball);
parcelHelpers.export(exports, "MdSportsCricket", ()=>MdSportsCricket);
parcelHelpers.export(exports, "MdSportsEsports", ()=>MdSportsEsports);
parcelHelpers.export(exports, "MdSportsFootball", ()=>MdSportsFootball);
parcelHelpers.export(exports, "MdSportsGolf", ()=>MdSportsGolf);
parcelHelpers.export(exports, "MdSportsGymnastics", ()=>MdSportsGymnastics);
parcelHelpers.export(exports, "MdSportsHandball", ()=>MdSportsHandball);
parcelHelpers.export(exports, "MdSportsHockey", ()=>MdSportsHockey);
parcelHelpers.export(exports, "MdSportsKabaddi", ()=>MdSportsKabaddi);
parcelHelpers.export(exports, "MdSportsMartialArts", ()=>MdSportsMartialArts);
parcelHelpers.export(exports, "MdSportsMma", ()=>MdSportsMma);
parcelHelpers.export(exports, "MdSportsMotorsports", ()=>MdSportsMotorsports);
parcelHelpers.export(exports, "MdSportsRugby", ()=>MdSportsRugby);
parcelHelpers.export(exports, "MdSportsSoccer", ()=>MdSportsSoccer);
parcelHelpers.export(exports, "MdSportsTennis", ()=>MdSportsTennis);
parcelHelpers.export(exports, "MdSportsVolleyball", ()=>MdSportsVolleyball);
parcelHelpers.export(exports, "MdSports", ()=>MdSports);
parcelHelpers.export(exports, "MdSurfing", ()=>MdSurfing);
parcelHelpers.export(exports, "MdSwitchAccount", ()=>MdSwitchAccount);
parcelHelpers.export(exports, "MdThumbDownAlt", ()=>MdThumbDownAlt);
parcelHelpers.export(exports, "MdThumbUpAlt", ()=>MdThumbUpAlt);
parcelHelpers.export(exports, "MdThunderstorm", ()=>MdThunderstorm);
parcelHelpers.export(exports, "MdTornado", ()=>MdTornado);
parcelHelpers.export(exports, "MdTransgender", ()=>MdTransgender);
parcelHelpers.export(exports, "MdTravelExplore", ()=>MdTravelExplore);
parcelHelpers.export(exports, "MdTsunami", ()=>MdTsunami);
parcelHelpers.export(exports, "MdVaccines", ()=>MdVaccines);
parcelHelpers.export(exports, "MdVolcano", ()=>MdVolcano);
parcelHelpers.export(exports, "MdWallet", ()=>MdWallet);
parcelHelpers.export(exports, "MdWaterDrop", ()=>MdWaterDrop);
parcelHelpers.export(exports, "MdWavingHand", ()=>MdWavingHand);
parcelHelpers.export(exports, "MdWhatsapp", ()=>MdWhatsapp);
parcelHelpers.export(exports, "MdWhatshot", ()=>MdWhatshot);
parcelHelpers.export(exports, "MdWoman2", ()=>MdWoman2);
parcelHelpers.export(exports, "MdWoman", ()=>MdWoman);
parcelHelpers.export(exports, "MdWorkspacePremium", ()=>MdWorkspacePremium);
parcelHelpers.export(exports, "MdCheckBoxOutlineBlank", ()=>MdCheckBoxOutlineBlank);
parcelHelpers.export(exports, "MdCheckBox", ()=>MdCheckBox);
parcelHelpers.export(exports, "MdIndeterminateCheckBox", ()=>MdIndeterminateCheckBox);
parcelHelpers.export(exports, "MdRadioButtonChecked", ()=>MdRadioButtonChecked);
parcelHelpers.export(exports, "MdRadioButtonUnchecked", ()=>MdRadioButtonUnchecked);
parcelHelpers.export(exports, "MdStarBorderPurple500", ()=>MdStarBorderPurple500);
parcelHelpers.export(exports, "MdStarBorder", ()=>MdStarBorder);
parcelHelpers.export(exports, "MdStarHalf", ()=>MdStarHalf);
parcelHelpers.export(exports, "MdStarOutline", ()=>MdStarOutline);
parcelHelpers.export(exports, "MdStarPurple500", ()=>MdStarPurple500);
parcelHelpers.export(exports, "MdStar", ()=>MdStar);
parcelHelpers.export(exports, "MdToggleOff", ()=>MdToggleOff);
parcelHelpers.export(exports, "MdToggleOn", ()=>MdToggleOn);
parcelHelpers.export(exports, "MdFaceUnlock", ()=>MdFaceUnlock);
parcelHelpers.export(exports, "MdBattery20", ()=>MdBattery20);
parcelHelpers.export(exports, "MdBattery30", ()=>MdBattery30);
parcelHelpers.export(exports, "MdBattery50", ()=>MdBattery50);
parcelHelpers.export(exports, "MdBattery60", ()=>MdBattery60);
parcelHelpers.export(exports, "MdBattery80", ()=>MdBattery80);
parcelHelpers.export(exports, "MdBattery90", ()=>MdBattery90);
parcelHelpers.export(exports, "MdBatteryCharging20", ()=>MdBatteryCharging20);
parcelHelpers.export(exports, "MdBatteryCharging30", ()=>MdBatteryCharging30);
parcelHelpers.export(exports, "MdBatteryCharging50", ()=>MdBatteryCharging50);
parcelHelpers.export(exports, "MdBatteryCharging60", ()=>MdBatteryCharging60);
parcelHelpers.export(exports, "MdBatteryCharging80", ()=>MdBatteryCharging80);
parcelHelpers.export(exports, "MdBatteryCharging90", ()=>MdBatteryCharging90);
parcelHelpers.export(exports, "MdSignalCellular1Bar", ()=>MdSignalCellular1Bar);
parcelHelpers.export(exports, "MdSignalCellular2Bar", ()=>MdSignalCellular2Bar);
parcelHelpers.export(exports, "MdSignalCellular3Bar", ()=>MdSignalCellular3Bar);
parcelHelpers.export(exports, "MdSignalCellularConnectedNoInternet1Bar", ()=>MdSignalCellularConnectedNoInternet1Bar);
parcelHelpers.export(exports, "MdSignalCellularConnectedNoInternet2Bar", ()=>MdSignalCellularConnectedNoInternet2Bar);
parcelHelpers.export(exports, "MdSignalCellularConnectedNoInternet3Bar", ()=>MdSignalCellularConnectedNoInternet3Bar);
parcelHelpers.export(exports, "MdSignalWifi1BarLock", ()=>MdSignalWifi1BarLock);
parcelHelpers.export(exports, "MdSignalWifi1Bar", ()=>MdSignalWifi1Bar);
parcelHelpers.export(exports, "MdSignalWifi2BarLock", ()=>MdSignalWifi2BarLock);
parcelHelpers.export(exports, "MdSignalWifi2Bar", ()=>MdSignalWifi2Bar);
parcelHelpers.export(exports, "MdSignalWifi3BarLock", ()=>MdSignalWifi3BarLock);
parcelHelpers.export(exports, "MdSignalWifi3Bar", ()=>MdSignalWifi3Bar);
parcelHelpers.export(exports, "MdSignalWifiConnectedNoInternet0", ()=>MdSignalWifiConnectedNoInternet0);
parcelHelpers.export(exports, "MdSignalWifiConnectedNoInternet1", ()=>MdSignalWifiConnectedNoInternet1);
parcelHelpers.export(exports, "MdSignalWifiConnectedNoInternet2", ()=>MdSignalWifiConnectedNoInternet2);
parcelHelpers.export(exports, "MdSignalWifiConnectedNoInternet3", ()=>MdSignalWifiConnectedNoInternet3);
parcelHelpers.export(exports, "MdSignalWifiStatusbar1Bar", ()=>MdSignalWifiStatusbar1Bar);
parcelHelpers.export(exports, "MdSignalWifiStatusbar2Bar", ()=>MdSignalWifiStatusbar2Bar);
parcelHelpers.export(exports, "MdSignalWifiStatusbar3Bar", ()=>MdSignalWifiStatusbar3Bar);
parcelHelpers.export(exports, "MdSignalWifiStatusbarConnectedNoInternet1", ()=>MdSignalWifiStatusbarConnectedNoInternet1);
parcelHelpers.export(exports, "MdSignalWifiStatusbarConnectedNoInternet2", ()=>MdSignalWifiStatusbarConnectedNoInternet2);
parcelHelpers.export(exports, "MdSignalWifiStatusbarConnectedNoInternet3", ()=>MdSignalWifiStatusbarConnectedNoInternet3);
parcelHelpers.export(exports, "MdSignalWifiStatusbarConnectedNoInternet", ()=>MdSignalWifiStatusbarConnectedNoInternet);
parcelHelpers.export(exports, "MdSignalWifiStatusbarNotConnected", ()=>MdSignalWifiStatusbarNotConnected);
parcelHelpers.export(exports, "MdWifiCalling1", ()=>MdWifiCalling1);
parcelHelpers.export(exports, "MdWifiCalling2", ()=>MdWifiCalling2);
parcelHelpers.export(exports, "MdOutline123", ()=>MdOutline123);
parcelHelpers.export(exports, "MdOutline3DRotation", ()=>MdOutline3DRotation);
parcelHelpers.export(exports, "MdOutlineAbc", ()=>MdOutlineAbc);
parcelHelpers.export(exports, "MdOutlineAccessibilityNew", ()=>MdOutlineAccessibilityNew);
parcelHelpers.export(exports, "MdOutlineAccessibility", ()=>MdOutlineAccessibility);
parcelHelpers.export(exports, "MdOutlineAccessibleForward", ()=>MdOutlineAccessibleForward);
parcelHelpers.export(exports, "MdOutlineAccessible", ()=>MdOutlineAccessible);
parcelHelpers.export(exports, "MdOutlineAccountBalanceWallet", ()=>MdOutlineAccountBalanceWallet);
parcelHelpers.export(exports, "MdOutlineAccountBalance", ()=>MdOutlineAccountBalance);
parcelHelpers.export(exports, "MdOutlineAccountBox", ()=>MdOutlineAccountBox);
parcelHelpers.export(exports, "MdOutlineAccountCircle", ()=>MdOutlineAccountCircle);
parcelHelpers.export(exports, "MdOutlineAddCard", ()=>MdOutlineAddCard);
parcelHelpers.export(exports, "MdOutlineAddHome", ()=>MdOutlineAddHome);
parcelHelpers.export(exports, "MdOutlineAddShoppingCart", ()=>MdOutlineAddShoppingCart);
parcelHelpers.export(exports, "MdOutlineAddTask", ()=>MdOutlineAddTask);
parcelHelpers.export(exports, "MdOutlineAddToDrive", ()=>MdOutlineAddToDrive);
parcelHelpers.export(exports, "MdOutlineAddchart", ()=>MdOutlineAddchart);
parcelHelpers.export(exports, "MdOutlineAdminPanelSettings", ()=>MdOutlineAdminPanelSettings);
parcelHelpers.export(exports, "MdOutlineAdsClick", ()=>MdOutlineAdsClick);
parcelHelpers.export(exports, "MdOutlineAlarmAdd", ()=>MdOutlineAlarmAdd);
parcelHelpers.export(exports, "MdOutlineAlarmOff", ()=>MdOutlineAlarmOff);
parcelHelpers.export(exports, "MdOutlineAlarmOn", ()=>MdOutlineAlarmOn);
parcelHelpers.export(exports, "MdOutlineAlarm", ()=>MdOutlineAlarm);
parcelHelpers.export(exports, "MdOutlineAllInbox", ()=>MdOutlineAllInbox);
parcelHelpers.export(exports, "MdOutlineAllOut", ()=>MdOutlineAllOut);
parcelHelpers.export(exports, "MdOutlineAnalytics", ()=>MdOutlineAnalytics);
parcelHelpers.export(exports, "MdOutlineAnchor", ()=>MdOutlineAnchor);
parcelHelpers.export(exports, "MdOutlineAndroid", ()=>MdOutlineAndroid);
parcelHelpers.export(exports, "MdOutlineAnnouncement", ()=>MdOutlineAnnouncement);
parcelHelpers.export(exports, "MdOutlineApi", ()=>MdOutlineApi);
parcelHelpers.export(exports, "MdOutlineAppBlocking", ()=>MdOutlineAppBlocking);
parcelHelpers.export(exports, "MdOutlineAppShortcut", ()=>MdOutlineAppShortcut);
parcelHelpers.export(exports, "MdOutlineArrowCircleDown", ()=>MdOutlineArrowCircleDown);
parcelHelpers.export(exports, "MdOutlineArrowCircleLeft", ()=>MdOutlineArrowCircleLeft);
parcelHelpers.export(exports, "MdOutlineArrowCircleRight", ()=>MdOutlineArrowCircleRight);
parcelHelpers.export(exports, "MdOutlineArrowCircleUp", ()=>MdOutlineArrowCircleUp);
parcelHelpers.export(exports, "MdOutlineArrowOutward", ()=>MdOutlineArrowOutward);
parcelHelpers.export(exports, "MdOutlineArrowRightAlt", ()=>MdOutlineArrowRightAlt);
parcelHelpers.export(exports, "MdOutlineArticle", ()=>MdOutlineArticle);
parcelHelpers.export(exports, "MdOutlineAspectRatio", ()=>MdOutlineAspectRatio);
parcelHelpers.export(exports, "MdOutlineAssessment", ()=>MdOutlineAssessment);
parcelHelpers.export(exports, "MdOutlineAssignmentInd", ()=>MdOutlineAssignmentInd);
parcelHelpers.export(exports, "MdOutlineAssignmentLate", ()=>MdOutlineAssignmentLate);
parcelHelpers.export(exports, "MdOutlineAssignmentReturn", ()=>MdOutlineAssignmentReturn);
parcelHelpers.export(exports, "MdOutlineAssignmentReturned", ()=>MdOutlineAssignmentReturned);
parcelHelpers.export(exports, "MdOutlineAssignmentTurnedIn", ()=>MdOutlineAssignmentTurnedIn);
parcelHelpers.export(exports, "MdOutlineAssignment", ()=>MdOutlineAssignment);
parcelHelpers.export(exports, "MdOutlineAssuredWorkload", ()=>MdOutlineAssuredWorkload);
parcelHelpers.export(exports, "MdOutlineAutorenew", ()=>MdOutlineAutorenew);
parcelHelpers.export(exports, "MdOutlineBackupTable", ()=>MdOutlineBackupTable);
parcelHelpers.export(exports, "MdOutlineBackup", ()=>MdOutlineBackup);
parcelHelpers.export(exports, "MdOutlineBalance", ()=>MdOutlineBalance);
parcelHelpers.export(exports, "MdOutlineBatchPrediction", ()=>MdOutlineBatchPrediction);
parcelHelpers.export(exports, "MdOutlineBookOnline", ()=>MdOutlineBookOnline);
parcelHelpers.export(exports, "MdOutlineBook", ()=>MdOutlineBook);
parcelHelpers.export(exports, "MdOutlineBookmarkAdd", ()=>MdOutlineBookmarkAdd);
parcelHelpers.export(exports, "MdOutlineBookmarkAdded", ()=>MdOutlineBookmarkAdded);
parcelHelpers.export(exports, "MdOutlineBookmarkBorder", ()=>MdOutlineBookmarkBorder);
parcelHelpers.export(exports, "MdOutlineBookmarkRemove", ()=>MdOutlineBookmarkRemove);
parcelHelpers.export(exports, "MdOutlineBookmark", ()=>MdOutlineBookmark);
parcelHelpers.export(exports, "MdOutlineBookmarks", ()=>MdOutlineBookmarks);
parcelHelpers.export(exports, "MdOutlineBrowseGallery", ()=>MdOutlineBrowseGallery);
parcelHelpers.export(exports, "MdOutlineBugReport", ()=>MdOutlineBugReport);
parcelHelpers.export(exports, "MdOutlineBuildCircle", ()=>MdOutlineBuildCircle);
parcelHelpers.export(exports, "MdOutlineBuild", ()=>MdOutlineBuild);
parcelHelpers.export(exports, "MdOutlineCached", ()=>MdOutlineCached);
parcelHelpers.export(exports, "MdOutlineCalendarMonth", ()=>MdOutlineCalendarMonth);
parcelHelpers.export(exports, "MdOutlineCalendarToday", ()=>MdOutlineCalendarToday);
parcelHelpers.export(exports, "MdOutlineCalendarViewDay", ()=>MdOutlineCalendarViewDay);
parcelHelpers.export(exports, "MdOutlineCalendarViewMonth", ()=>MdOutlineCalendarViewMonth);
parcelHelpers.export(exports, "MdOutlineCalendarViewWeek", ()=>MdOutlineCalendarViewWeek);
parcelHelpers.export(exports, "MdOutlineCameraEnhance", ()=>MdOutlineCameraEnhance);
parcelHelpers.export(exports, "MdOutlineCancelScheduleSend", ()=>MdOutlineCancelScheduleSend);
parcelHelpers.export(exports, "MdOutlineCardGiftcard", ()=>MdOutlineCardGiftcard);
parcelHelpers.export(exports, "MdOutlineCardMembership", ()=>MdOutlineCardMembership);
parcelHelpers.export(exports, "MdOutlineCardTravel", ()=>MdOutlineCardTravel);
parcelHelpers.export(exports, "MdOutlineChangeHistory", ()=>MdOutlineChangeHistory);
parcelHelpers.export(exports, "MdOutlineCheckCircleOutline", ()=>MdOutlineCheckCircleOutline);
parcelHelpers.export(exports, "MdOutlineCheckCircle", ()=>MdOutlineCheckCircle);
parcelHelpers.export(exports, "MdOutlineChromeReaderMode", ()=>MdOutlineChromeReaderMode);
parcelHelpers.export(exports, "MdOutlineCircleNotifications", ()=>MdOutlineCircleNotifications);
parcelHelpers.export(exports, "MdOutlineClass", ()=>MdOutlineClass);
parcelHelpers.export(exports, "MdOutlineCloseFullscreen", ()=>MdOutlineCloseFullscreen);
parcelHelpers.export(exports, "MdOutlineCodeOff", ()=>MdOutlineCodeOff);
parcelHelpers.export(exports, "MdOutlineCode", ()=>MdOutlineCode);
parcelHelpers.export(exports, "MdOutlineCommentBank", ()=>MdOutlineCommentBank);
parcelHelpers.export(exports, "MdOutlineCommit", ()=>MdOutlineCommit);
parcelHelpers.export(exports, "MdOutlineCommute", ()=>MdOutlineCommute);
parcelHelpers.export(exports, "MdOutlineCompareArrows", ()=>MdOutlineCompareArrows);
parcelHelpers.export(exports, "MdOutlineCompress", ()=>MdOutlineCompress);
parcelHelpers.export(exports, "MdOutlineContactPage", ()=>MdOutlineContactPage);
parcelHelpers.export(exports, "MdOutlineContactSupport", ()=>MdOutlineContactSupport);
parcelHelpers.export(exports, "MdOutlineContactless", ()=>MdOutlineContactless);
parcelHelpers.export(exports, "MdOutlineCopyright", ()=>MdOutlineCopyright);
parcelHelpers.export(exports, "MdOutlineCreditCardOff", ()=>MdOutlineCreditCardOff);
parcelHelpers.export(exports, "MdOutlineCreditCard", ()=>MdOutlineCreditCard);
parcelHelpers.export(exports, "MdOutlineCss", ()=>MdOutlineCss);
parcelHelpers.export(exports, "MdOutlineCurrencyExchange", ()=>MdOutlineCurrencyExchange);
parcelHelpers.export(exports, "MdOutlineDangerous", ()=>MdOutlineDangerous);
parcelHelpers.export(exports, "MdOutlineDashboardCustomize", ()=>MdOutlineDashboardCustomize);
parcelHelpers.export(exports, "MdOutlineDashboard", ()=>MdOutlineDashboard);
parcelHelpers.export(exports, "MdOutlineDataExploration", ()=>MdOutlineDataExploration);
parcelHelpers.export(exports, "MdOutlineDataThresholding", ()=>MdOutlineDataThresholding);
parcelHelpers.export(exports, "MdOutlineDateRange", ()=>MdOutlineDateRange);
parcelHelpers.export(exports, "MdOutlineDeleteForever", ()=>MdOutlineDeleteForever);
parcelHelpers.export(exports, "MdOutlineDeleteOutline", ()=>MdOutlineDeleteOutline);
parcelHelpers.export(exports, "MdOutlineDelete", ()=>MdOutlineDelete);
parcelHelpers.export(exports, "MdOutlineDensityLarge", ()=>MdOutlineDensityLarge);
parcelHelpers.export(exports, "MdOutlineDensityMedium", ()=>MdOutlineDensityMedium);
parcelHelpers.export(exports, "MdOutlineDensitySmall", ()=>MdOutlineDensitySmall);
parcelHelpers.export(exports, "MdOutlineDescription", ()=>MdOutlineDescription);
parcelHelpers.export(exports, "MdOutlineDisabledByDefault", ()=>MdOutlineDisabledByDefault);
parcelHelpers.export(exports, "MdOutlineDisabledVisible", ()=>MdOutlineDisabledVisible);
parcelHelpers.export(exports, "MdOutlineDisplaySettings", ()=>MdOutlineDisplaySettings);
parcelHelpers.export(exports, "MdOutlineDns", ()=>MdOutlineDns);
parcelHelpers.export(exports, "MdOutlineDoneAll", ()=>MdOutlineDoneAll);
parcelHelpers.export(exports, "MdOutlineDoneOutline", ()=>MdOutlineDoneOutline);
parcelHelpers.export(exports, "MdOutlineDone", ()=>MdOutlineDone);
parcelHelpers.export(exports, "MdOutlineDonutLarge", ()=>MdOutlineDonutLarge);
parcelHelpers.export(exports, "MdOutlineDonutSmall", ()=>MdOutlineDonutSmall);
parcelHelpers.export(exports, "MdOutlineDragIndicator", ()=>MdOutlineDragIndicator);
parcelHelpers.export(exports, "MdOutlineDynamicForm", ()=>MdOutlineDynamicForm);
parcelHelpers.export(exports, "MdOutlineEco", ()=>MdOutlineEco);
parcelHelpers.export(exports, "MdOutlineEditCalendar", ()=>MdOutlineEditCalendar);
parcelHelpers.export(exports, "MdOutlineEditOff", ()=>MdOutlineEditOff);
parcelHelpers.export(exports, "MdOutlineEject", ()=>MdOutlineEject);
parcelHelpers.export(exports, "MdOutlineEuroSymbol", ()=>MdOutlineEuroSymbol);
parcelHelpers.export(exports, "MdOutlineEventRepeat", ()=>MdOutlineEventRepeat);
parcelHelpers.export(exports, "MdOutlineEventSeat", ()=>MdOutlineEventSeat);
parcelHelpers.export(exports, "MdOutlineEvent", ()=>MdOutlineEvent);
parcelHelpers.export(exports, "MdOutlineExitToApp", ()=>MdOutlineExitToApp);
parcelHelpers.export(exports, "MdOutlineExpand", ()=>MdOutlineExpand);
parcelHelpers.export(exports, "MdOutlineExploreOff", ()=>MdOutlineExploreOff);
parcelHelpers.export(exports, "MdOutlineExplore", ()=>MdOutlineExplore);
parcelHelpers.export(exports, "MdOutlineExtensionOff", ()=>MdOutlineExtensionOff);
parcelHelpers.export(exports, "MdOutlineExtension", ()=>MdOutlineExtension);
parcelHelpers.export(exports, "MdOutlineFaceUnlock", ()=>MdOutlineFaceUnlock);
parcelHelpers.export(exports, "MdOutlineFace", ()=>MdOutlineFace);
parcelHelpers.export(exports, "MdOutlineFactCheck", ()=>MdOutlineFactCheck);
parcelHelpers.export(exports, "MdOutlineFavoriteBorder", ()=>MdOutlineFavoriteBorder);
parcelHelpers.export(exports, "MdOutlineFavorite", ()=>MdOutlineFavorite);
parcelHelpers.export(exports, "MdOutlineFax", ()=>MdOutlineFax);
parcelHelpers.export(exports, "MdOutlineFeedback", ()=>MdOutlineFeedback);
parcelHelpers.export(exports, "MdOutlineFilePresent", ()=>MdOutlineFilePresent);
parcelHelpers.export(exports, "MdOutlineFilterAltOff", ()=>MdOutlineFilterAltOff);
parcelHelpers.export(exports, "MdOutlineFilterAlt", ()=>MdOutlineFilterAlt);
parcelHelpers.export(exports, "MdOutlineFindInPage", ()=>MdOutlineFindInPage);
parcelHelpers.export(exports, "MdOutlineFindReplace", ()=>MdOutlineFindReplace);
parcelHelpers.export(exports, "MdOutlineFingerprint", ()=>MdOutlineFingerprint);
parcelHelpers.export(exports, "MdOutlineFitScreen", ()=>MdOutlineFitScreen);
parcelHelpers.export(exports, "MdOutlineFlaky", ()=>MdOutlineFlaky);
parcelHelpers.export(exports, "MdOutlineFlightLand", ()=>MdOutlineFlightLand);
parcelHelpers.export(exports, "MdOutlineFlightTakeoff", ()=>MdOutlineFlightTakeoff);
parcelHelpers.export(exports, "MdOutlineFlipToBack", ()=>MdOutlineFlipToBack);
parcelHelpers.export(exports, "MdOutlineFlipToFront", ()=>MdOutlineFlipToFront);
parcelHelpers.export(exports, "MdOutlineFlutterDash", ()=>MdOutlineFlutterDash);
parcelHelpers.export(exports, "MdOutlineFreeCancellation", ()=>MdOutlineFreeCancellation);
parcelHelpers.export(exports, "MdOutlineGTranslate", ()=>MdOutlineGTranslate);
parcelHelpers.export(exports, "MdOutlineGavel", ()=>MdOutlineGavel);
parcelHelpers.export(exports, "MdOutlineGeneratingTokens", ()=>MdOutlineGeneratingTokens);
parcelHelpers.export(exports, "MdOutlineGetApp", ()=>MdOutlineGetApp);
parcelHelpers.export(exports, "MdOutlineGifBox", ()=>MdOutlineGifBox);
parcelHelpers.export(exports, "MdOutlineGif", ()=>MdOutlineGif);
parcelHelpers.export(exports, "MdOutlineGrade", ()=>MdOutlineGrade);
parcelHelpers.export(exports, "MdOutlineGrading", ()=>MdOutlineGrading);
parcelHelpers.export(exports, "MdOutlineGroupWork", ()=>MdOutlineGroupWork);
parcelHelpers.export(exports, "MdOutlineHelpCenter", ()=>MdOutlineHelpCenter);
parcelHelpers.export(exports, "MdOutlineHelpOutline", ()=>MdOutlineHelpOutline);
parcelHelpers.export(exports, "MdOutlineHelp", ()=>MdOutlineHelp);
parcelHelpers.export(exports, "MdOutlineHideSource", ()=>MdOutlineHideSource);
parcelHelpers.export(exports, "MdOutlineHighlightAlt", ()=>MdOutlineHighlightAlt);
parcelHelpers.export(exports, "MdOutlineHighlightOff", ()=>MdOutlineHighlightOff);
parcelHelpers.export(exports, "MdOutlineHistoryToggleOff", ()=>MdOutlineHistoryToggleOff);
parcelHelpers.export(exports, "MdOutlineHistory", ()=>MdOutlineHistory);
parcelHelpers.export(exports, "MdOutlineHlsOff", ()=>MdOutlineHlsOff);
parcelHelpers.export(exports, "MdOutlineHls", ()=>MdOutlineHls);
parcelHelpers.export(exports, "MdOutlineHome", ()=>MdOutlineHome);
parcelHelpers.export(exports, "MdOutlineHorizontalSplit", ()=>MdOutlineHorizontalSplit);
parcelHelpers.export(exports, "MdOutlineHotelClass", ()=>MdOutlineHotelClass);
parcelHelpers.export(exports, "MdOutlineHourglassDisabled", ()=>MdOutlineHourglassDisabled);
parcelHelpers.export(exports, "MdOutlineHourglassEmpty", ()=>MdOutlineHourglassEmpty);
parcelHelpers.export(exports, "MdOutlineHourglassFull", ()=>MdOutlineHourglassFull);
parcelHelpers.export(exports, "MdOutlineHtml", ()=>MdOutlineHtml);
parcelHelpers.export(exports, "MdOutlineHttp", ()=>MdOutlineHttp);
parcelHelpers.export(exports, "MdOutlineHttps", ()=>MdOutlineHttps);
parcelHelpers.export(exports, "MdOutlineImportantDevices", ()=>MdOutlineImportantDevices);
parcelHelpers.export(exports, "MdOutlineInfo", ()=>MdOutlineInfo);
parcelHelpers.export(exports, "MdOutlineInput", ()=>MdOutlineInput);
parcelHelpers.export(exports, "MdOutlineInstallDesktop", ()=>MdOutlineInstallDesktop);
parcelHelpers.export(exports, "MdOutlineInstallMobile", ()=>MdOutlineInstallMobile);
parcelHelpers.export(exports, "MdOutlineIntegrationInstructions", ()=>MdOutlineIntegrationInstructions);
parcelHelpers.export(exports, "MdOutlineInvertColors", ()=>MdOutlineInvertColors);
parcelHelpers.export(exports, "MdOutlineJavascript", ()=>MdOutlineJavascript);
parcelHelpers.export(exports, "MdOutlineJoinFull", ()=>MdOutlineJoinFull);
parcelHelpers.export(exports, "MdOutlineJoinInner", ()=>MdOutlineJoinInner);
parcelHelpers.export(exports, "MdOutlineJoinLeft", ()=>MdOutlineJoinLeft);
parcelHelpers.export(exports, "MdOutlineJoinRight", ()=>MdOutlineJoinRight);
parcelHelpers.export(exports, "MdOutlineLabelImportant", ()=>MdOutlineLabelImportant);
parcelHelpers.export(exports, "MdOutlineLabelOff", ()=>MdOutlineLabelOff);
parcelHelpers.export(exports, "MdOutlineLabel", ()=>MdOutlineLabel);
parcelHelpers.export(exports, "MdOutlineLanguage", ()=>MdOutlineLanguage);
parcelHelpers.export(exports, "MdOutlineLaunch", ()=>MdOutlineLaunch);
parcelHelpers.export(exports, "MdOutlineLeaderboard", ()=>MdOutlineLeaderboard);
parcelHelpers.export(exports, "MdOutlineLightbulbCircle", ()=>MdOutlineLightbulbCircle);
parcelHelpers.export(exports, "MdOutlineLightbulb", ()=>MdOutlineLightbulb);
parcelHelpers.export(exports, "MdOutlineLineStyle", ()=>MdOutlineLineStyle);
parcelHelpers.export(exports, "MdOutlineLineWeight", ()=>MdOutlineLineWeight);
parcelHelpers.export(exports, "MdOutlineList", ()=>MdOutlineList);
parcelHelpers.export(exports, "MdOutlineLockClock", ()=>MdOutlineLockClock);
parcelHelpers.export(exports, "MdOutlineLockOpen", ()=>MdOutlineLockOpen);
parcelHelpers.export(exports, "MdOutlineLockPerson", ()=>MdOutlineLockPerson);
parcelHelpers.export(exports, "MdOutlineLockReset", ()=>MdOutlineLockReset);
parcelHelpers.export(exports, "MdOutlineLock", ()=>MdOutlineLock);
parcelHelpers.export(exports, "MdOutlineLogin", ()=>MdOutlineLogin);
parcelHelpers.export(exports, "MdOutlineLogout", ()=>MdOutlineLogout);
parcelHelpers.export(exports, "MdOutlineLoyalty", ()=>MdOutlineLoyalty);
parcelHelpers.export(exports, "MdOutlineManageAccounts", ()=>MdOutlineManageAccounts);
parcelHelpers.export(exports, "MdOutlineManageHistory", ()=>MdOutlineManageHistory);
parcelHelpers.export(exports, "MdOutlineMarkAsUnread", ()=>MdOutlineMarkAsUnread);
parcelHelpers.export(exports, "MdOutlineMarkunreadMailbox", ()=>MdOutlineMarkunreadMailbox);
parcelHelpers.export(exports, "MdOutlineMaximize", ()=>MdOutlineMaximize);
parcelHelpers.export(exports, "MdOutlineMediation", ()=>MdOutlineMediation);
parcelHelpers.export(exports, "MdOutlineMinimize", ()=>MdOutlineMinimize);
parcelHelpers.export(exports, "MdOutlineModelTraining", ()=>MdOutlineModelTraining);
parcelHelpers.export(exports, "MdOutlineNetworkPing", ()=>MdOutlineNetworkPing);
parcelHelpers.export(exports, "MdOutlineNewLabel", ()=>MdOutlineNewLabel);
parcelHelpers.export(exports, "MdOutlineNextPlan", ()=>MdOutlineNextPlan);
parcelHelpers.export(exports, "MdOutlineNightlightRound", ()=>MdOutlineNightlightRound);
parcelHelpers.export(exports, "MdOutlineNoAccounts", ()=>MdOutlineNoAccounts);
parcelHelpers.export(exports, "MdOutlineNoiseAware", ()=>MdOutlineNoiseAware);
parcelHelpers.export(exports, "MdOutlineNoiseControlOff", ()=>MdOutlineNoiseControlOff);
parcelHelpers.export(exports, "MdOutlineNotAccessible", ()=>MdOutlineNotAccessible);
parcelHelpers.export(exports, "MdOutlineNotStarted", ()=>MdOutlineNotStarted);
parcelHelpers.export(exports, "MdOutlineNoteAdd", ()=>MdOutlineNoteAdd);
parcelHelpers.export(exports, "MdOutlineOfflineBolt", ()=>MdOutlineOfflineBolt);
parcelHelpers.export(exports, "MdOutlineOfflinePin", ()=>MdOutlineOfflinePin);
parcelHelpers.export(exports, "MdOutlineOnDeviceTraining", ()=>MdOutlineOnDeviceTraining);
parcelHelpers.export(exports, "MdOutlineOnlinePrediction", ()=>MdOutlineOnlinePrediction);
parcelHelpers.export(exports, "MdOutlineOpacity", ()=>MdOutlineOpacity);
parcelHelpers.export(exports, "MdOutlineOpenInBrowser", ()=>MdOutlineOpenInBrowser);
parcelHelpers.export(exports, "MdOutlineOpenInFull", ()=>MdOutlineOpenInFull);
parcelHelpers.export(exports, "MdOutlineOpenInNewOff", ()=>MdOutlineOpenInNewOff);
parcelHelpers.export(exports, "MdOutlineOpenInNew", ()=>MdOutlineOpenInNew);
parcelHelpers.export(exports, "MdOutlineOpenWith", ()=>MdOutlineOpenWith);
parcelHelpers.export(exports, "MdOutlineOutbond", ()=>MdOutlineOutbond);
parcelHelpers.export(exports, "MdOutlineOutbound", ()=>MdOutlineOutbound);
parcelHelpers.export(exports, "MdOutlineOutbox", ()=>MdOutlineOutbox);
parcelHelpers.export(exports, "MdOutlineOutlet", ()=>MdOutlineOutlet);
parcelHelpers.export(exports, "MdOutlineOutput", ()=>MdOutlineOutput);
parcelHelpers.export(exports, "MdOutlinePageview", ()=>MdOutlinePageview);
parcelHelpers.export(exports, "MdOutlinePaid", ()=>MdOutlinePaid);
parcelHelpers.export(exports, "MdOutlinePanToolAlt", ()=>MdOutlinePanToolAlt);
parcelHelpers.export(exports, "MdOutlinePanTool", ()=>MdOutlinePanTool);
parcelHelpers.export(exports, "MdOutlinePayment", ()=>MdOutlinePayment);
parcelHelpers.export(exports, "MdOutlinePendingActions", ()=>MdOutlinePendingActions);
parcelHelpers.export(exports, "MdOutlinePending", ()=>MdOutlinePending);
parcelHelpers.export(exports, "MdOutlinePercent", ()=>MdOutlinePercent);
parcelHelpers.export(exports, "MdOutlinePermCameraMic", ()=>MdOutlinePermCameraMic);
parcelHelpers.export(exports, "MdOutlinePermContactCalendar", ()=>MdOutlinePermContactCalendar);
parcelHelpers.export(exports, "MdOutlinePermDataSetting", ()=>MdOutlinePermDataSetting);
parcelHelpers.export(exports, "MdOutlinePermDeviceInformation", ()=>MdOutlinePermDeviceInformation);
parcelHelpers.export(exports, "MdOutlinePermIdentity", ()=>MdOutlinePermIdentity);
parcelHelpers.export(exports, "MdOutlinePermMedia", ()=>MdOutlinePermMedia);
parcelHelpers.export(exports, "MdOutlinePermPhoneMsg", ()=>MdOutlinePermPhoneMsg);
parcelHelpers.export(exports, "MdOutlinePermScanWifi", ()=>MdOutlinePermScanWifi);
parcelHelpers.export(exports, "MdOutlinePets", ()=>MdOutlinePets);
parcelHelpers.export(exports, "MdOutlinePhp", ()=>MdOutlinePhp);
parcelHelpers.export(exports, "MdOutlinePictureInPictureAlt", ()=>MdOutlinePictureInPictureAlt);
parcelHelpers.export(exports, "MdOutlinePictureInPicture", ()=>MdOutlinePictureInPicture);
parcelHelpers.export(exports, "MdOutlinePinEnd", ()=>MdOutlinePinEnd);
parcelHelpers.export(exports, "MdOutlinePinInvoke", ()=>MdOutlinePinInvoke);
parcelHelpers.export(exports, "MdOutlinePinch", ()=>MdOutlinePinch);
parcelHelpers.export(exports, "MdOutlinePlagiarism", ()=>MdOutlinePlagiarism);
parcelHelpers.export(exports, "MdOutlinePlayForWork", ()=>MdOutlinePlayForWork);
parcelHelpers.export(exports, "MdOutlinePolymer", ()=>MdOutlinePolymer);
parcelHelpers.export(exports, "MdOutlinePowerSettingsNew", ()=>MdOutlinePowerSettingsNew);
parcelHelpers.export(exports, "MdOutlinePregnantWoman", ()=>MdOutlinePregnantWoman);
parcelHelpers.export(exports, "MdOutlinePreview", ()=>MdOutlinePreview);
parcelHelpers.export(exports, "MdOutlinePrint", ()=>MdOutlinePrint);
parcelHelpers.export(exports, "MdOutlinePrivacyTip", ()=>MdOutlinePrivacyTip);
parcelHelpers.export(exports, "MdOutlinePrivateConnectivity", ()=>MdOutlinePrivateConnectivity);
parcelHelpers.export(exports, "MdOutlineProductionQuantityLimits", ()=>MdOutlineProductionQuantityLimits);
parcelHelpers.export(exports, "MdOutlinePublishedWithChanges", ()=>MdOutlinePublishedWithChanges);
parcelHelpers.export(exports, "MdOutlineQueryBuilder", ()=>MdOutlineQueryBuilder);
parcelHelpers.export(exports, "MdOutlineQuestionAnswer", ()=>MdOutlineQuestionAnswer);
parcelHelpers.export(exports, "MdOutlineQuestionMark", ()=>MdOutlineQuestionMark);
parcelHelpers.export(exports, "MdOutlineQuickreply", ()=>MdOutlineQuickreply);
parcelHelpers.export(exports, "MdOutlineReceipt", ()=>MdOutlineReceipt);
parcelHelpers.export(exports, "MdOutlineRecordVoiceOver", ()=>MdOutlineRecordVoiceOver);
parcelHelpers.export(exports, "MdOutlineRedeem", ()=>MdOutlineRedeem);
parcelHelpers.export(exports, "MdOutlineRemoveDone", ()=>MdOutlineRemoveDone);
parcelHelpers.export(exports, "MdOutlineRemoveShoppingCart", ()=>MdOutlineRemoveShoppingCart);
parcelHelpers.export(exports, "MdOutlineReorder", ()=>MdOutlineReorder);
parcelHelpers.export(exports, "MdOutlineRepartition", ()=>MdOutlineRepartition);
parcelHelpers.export(exports, "MdOutlineReportProblem", ()=>MdOutlineReportProblem);
parcelHelpers.export(exports, "MdOutlineRequestPage", ()=>MdOutlineRequestPage);
parcelHelpers.export(exports, "MdOutlineRestoreFromTrash", ()=>MdOutlineRestoreFromTrash);
parcelHelpers.export(exports, "MdOutlineRestorePage", ()=>MdOutlineRestorePage);
parcelHelpers.export(exports, "MdOutlineRestore", ()=>MdOutlineRestore);
parcelHelpers.export(exports, "MdOutlineRocketLaunch", ()=>MdOutlineRocketLaunch);
parcelHelpers.export(exports, "MdOutlineRocket", ()=>MdOutlineRocket);
parcelHelpers.export(exports, "MdOutlineRoom", ()=>MdOutlineRoom);
parcelHelpers.export(exports, "MdOutlineRoundedCorner", ()=>MdOutlineRoundedCorner);
parcelHelpers.export(exports, "MdOutlineRowing", ()=>MdOutlineRowing);
parcelHelpers.export(exports, "MdOutlineRule", ()=>MdOutlineRule);
parcelHelpers.export(exports, "MdOutlineSatelliteAlt", ()=>MdOutlineSatelliteAlt);
parcelHelpers.export(exports, "MdOutlineSavedSearch", ()=>MdOutlineSavedSearch);
parcelHelpers.export(exports, "MdOutlineSavings", ()=>MdOutlineSavings);
parcelHelpers.export(exports, "MdOutlineScheduleSend", ()=>MdOutlineScheduleSend);
parcelHelpers.export(exports, "MdOutlineSchedule", ()=>MdOutlineSchedule);
parcelHelpers.export(exports, "MdOutlineSearchOff", ()=>MdOutlineSearchOff);
parcelHelpers.export(exports, "MdOutlineSearch", ()=>MdOutlineSearch);
parcelHelpers.export(exports, "MdOutlineSegment", ()=>MdOutlineSegment);
parcelHelpers.export(exports, "MdOutlineSendAndArchive", ()=>MdOutlineSendAndArchive);
parcelHelpers.export(exports, "MdOutlineSensorsOff", ()=>MdOutlineSensorsOff);
parcelHelpers.export(exports, "MdOutlineSensors", ()=>MdOutlineSensors);
parcelHelpers.export(exports, "MdOutlineSettingsAccessibility", ()=>MdOutlineSettingsAccessibility);
parcelHelpers.export(exports, "MdOutlineSettingsApplications", ()=>MdOutlineSettingsApplications);
parcelHelpers.export(exports, "MdOutlineSettingsBackupRestore", ()=>MdOutlineSettingsBackupRestore);
parcelHelpers.export(exports, "MdOutlineSettingsBluetooth", ()=>MdOutlineSettingsBluetooth);
parcelHelpers.export(exports, "MdOutlineSettingsBrightness", ()=>MdOutlineSettingsBrightness);
parcelHelpers.export(exports, "MdOutlineSettingsCell", ()=>MdOutlineSettingsCell);
parcelHelpers.export(exports, "MdOutlineSettingsEthernet", ()=>MdOutlineSettingsEthernet);
parcelHelpers.export(exports, "MdOutlineSettingsInputAntenna", ()=>MdOutlineSettingsInputAntenna);
parcelHelpers.export(exports, "MdOutlineSettingsInputComponent", ()=>MdOutlineSettingsInputComponent);
parcelHelpers.export(exports, "MdOutlineSettingsInputComposite", ()=>MdOutlineSettingsInputComposite);
parcelHelpers.export(exports, "MdOutlineSettingsInputHdmi", ()=>MdOutlineSettingsInputHdmi);
parcelHelpers.export(exports, "MdOutlineSettingsInputSvideo", ()=>MdOutlineSettingsInputSvideo);
parcelHelpers.export(exports, "MdOutlineSettingsOverscan", ()=>MdOutlineSettingsOverscan);
parcelHelpers.export(exports, "MdOutlineSettingsPhone", ()=>MdOutlineSettingsPhone);
parcelHelpers.export(exports, "MdOutlineSettingsPower", ()=>MdOutlineSettingsPower);
parcelHelpers.export(exports, "MdOutlineSettingsRemote", ()=>MdOutlineSettingsRemote);
parcelHelpers.export(exports, "MdOutlineSettingsVoice", ()=>MdOutlineSettingsVoice);
parcelHelpers.export(exports, "MdOutlineSettings", ()=>MdOutlineSettings);
parcelHelpers.export(exports, "MdOutlineShop2", ()=>MdOutlineShop2);
parcelHelpers.export(exports, "MdOutlineShopTwo", ()=>MdOutlineShopTwo);
parcelHelpers.export(exports, "MdOutlineShop", ()=>MdOutlineShop);
parcelHelpers.export(exports, "MdOutlineShoppingBag", ()=>MdOutlineShoppingBag);
parcelHelpers.export(exports, "MdOutlineShoppingBasket", ()=>MdOutlineShoppingBasket);
parcelHelpers.export(exports, "MdOutlineShoppingCartCheckout", ()=>MdOutlineShoppingCartCheckout);
parcelHelpers.export(exports, "MdOutlineShoppingCart", ()=>MdOutlineShoppingCart);
parcelHelpers.export(exports, "MdOutlineSmartButton", ()=>MdOutlineSmartButton);
parcelHelpers.export(exports, "MdOutlineSource", ()=>MdOutlineSource);
parcelHelpers.export(exports, "MdOutlineSpaceDashboard", ()=>MdOutlineSpaceDashboard);
parcelHelpers.export(exports, "MdOutlineSpatialAudioOff", ()=>MdOutlineSpatialAudioOff);
parcelHelpers.export(exports, "MdOutlineSpatialAudio", ()=>MdOutlineSpatialAudio);
parcelHelpers.export(exports, "MdOutlineSpatialTracking", ()=>MdOutlineSpatialTracking);
parcelHelpers.export(exports, "MdOutlineSpeakerNotesOff", ()=>MdOutlineSpeakerNotesOff);
parcelHelpers.export(exports, "MdOutlineSpeakerNotes", ()=>MdOutlineSpeakerNotes);
parcelHelpers.export(exports, "MdOutlineSpellcheck", ()=>MdOutlineSpellcheck);
parcelHelpers.export(exports, "MdOutlineStarRate", ()=>MdOutlineStarRate);
parcelHelpers.export(exports, "MdOutlineStars", ()=>MdOutlineStars);
parcelHelpers.export(exports, "MdOutlineStickyNote2", ()=>MdOutlineStickyNote2);
parcelHelpers.export(exports, "MdOutlineStore", ()=>MdOutlineStore);
parcelHelpers.export(exports, "MdOutlineSubject", ()=>MdOutlineSubject);
parcelHelpers.export(exports, "MdOutlineSubtitlesOff", ()=>MdOutlineSubtitlesOff);
parcelHelpers.export(exports, "MdOutlineSupervisedUserCircle", ()=>MdOutlineSupervisedUserCircle);
parcelHelpers.export(exports, "MdOutlineSupervisorAccount", ()=>MdOutlineSupervisorAccount);
parcelHelpers.export(exports, "MdOutlineSupport", ()=>MdOutlineSupport);
parcelHelpers.export(exports, "MdOutlineSwapHoriz", ()=>MdOutlineSwapHoriz);
parcelHelpers.export(exports, "MdOutlineSwapHorizontalCircle", ()=>MdOutlineSwapHorizontalCircle);
parcelHelpers.export(exports, "MdOutlineSwapVert", ()=>MdOutlineSwapVert);
parcelHelpers.export(exports, "MdOutlineSwapVerticalCircle", ()=>MdOutlineSwapVerticalCircle);
parcelHelpers.export(exports, "MdOutlineSwipeDownAlt", ()=>MdOutlineSwipeDownAlt);
parcelHelpers.export(exports, "MdOutlineSwipeDown", ()=>MdOutlineSwipeDown);
parcelHelpers.export(exports, "MdOutlineSwipeLeftAlt", ()=>MdOutlineSwipeLeftAlt);
parcelHelpers.export(exports, "MdOutlineSwipeLeft", ()=>MdOutlineSwipeLeft);
parcelHelpers.export(exports, "MdOutlineSwipeRightAlt", ()=>MdOutlineSwipeRightAlt);
parcelHelpers.export(exports, "MdOutlineSwipeRight", ()=>MdOutlineSwipeRight);
parcelHelpers.export(exports, "MdOutlineSwipeUpAlt", ()=>MdOutlineSwipeUpAlt);
parcelHelpers.export(exports, "MdOutlineSwipeUp", ()=>MdOutlineSwipeUp);
parcelHelpers.export(exports, "MdOutlineSwipeVertical", ()=>MdOutlineSwipeVertical);
parcelHelpers.export(exports, "MdOutlineSwipe", ()=>MdOutlineSwipe);
parcelHelpers.export(exports, "MdOutlineSwitchAccessShortcutAdd", ()=>MdOutlineSwitchAccessShortcutAdd);
parcelHelpers.export(exports, "MdOutlineSwitchAccessShortcut", ()=>MdOutlineSwitchAccessShortcut);
parcelHelpers.export(exports, "MdOutlineSyncAlt", ()=>MdOutlineSyncAlt);
parcelHelpers.export(exports, "MdOutlineSystemUpdateAlt", ()=>MdOutlineSystemUpdateAlt);
parcelHelpers.export(exports, "MdOutlineTabUnselected", ()=>MdOutlineTabUnselected);
parcelHelpers.export(exports, "MdOutlineTab", ()=>MdOutlineTab);
parcelHelpers.export(exports, "MdOutlineTableView", ()=>MdOutlineTableView);
parcelHelpers.export(exports, "MdOutlineTaskAlt", ()=>MdOutlineTaskAlt);
parcelHelpers.export(exports, "MdOutlineTerminal", ()=>MdOutlineTerminal);
parcelHelpers.export(exports, "MdOutlineTextRotateUp", ()=>MdOutlineTextRotateUp);
parcelHelpers.export(exports, "MdOutlineTextRotateVertical", ()=>MdOutlineTextRotateVertical);
parcelHelpers.export(exports, "MdOutlineTextRotationAngledown", ()=>MdOutlineTextRotationAngledown);
parcelHelpers.export(exports, "MdOutlineTextRotationAngleup", ()=>MdOutlineTextRotationAngleup);
parcelHelpers.export(exports, "MdOutlineTextRotationDown", ()=>MdOutlineTextRotationDown);
parcelHelpers.export(exports, "MdOutlineTextRotationNone", ()=>MdOutlineTextRotationNone);
parcelHelpers.export(exports, "MdOutlineTheaters", ()=>MdOutlineTheaters);
parcelHelpers.export(exports, "MdOutlineThumbDownOffAlt", ()=>MdOutlineThumbDownOffAlt);
parcelHelpers.export(exports, "MdOutlineThumbDown", ()=>MdOutlineThumbDown);
parcelHelpers.export(exports, "MdOutlineThumbUpOffAlt", ()=>MdOutlineThumbUpOffAlt);
parcelHelpers.export(exports, "MdOutlineThumbUp", ()=>MdOutlineThumbUp);
parcelHelpers.export(exports, "MdOutlineThumbsUpDown", ()=>MdOutlineThumbsUpDown);
parcelHelpers.export(exports, "MdOutlineTimeline", ()=>MdOutlineTimeline);
parcelHelpers.export(exports, "MdOutlineTipsAndUpdates", ()=>MdOutlineTipsAndUpdates);
parcelHelpers.export(exports, "MdOutlineToc", ()=>MdOutlineToc);
parcelHelpers.export(exports, "MdOutlineToday", ()=>MdOutlineToday);
parcelHelpers.export(exports, "MdOutlineToken", ()=>MdOutlineToken);
parcelHelpers.export(exports, "MdOutlineToll", ()=>MdOutlineToll);
parcelHelpers.export(exports, "MdOutlineTouchApp", ()=>MdOutlineTouchApp);
parcelHelpers.export(exports, "MdOutlineTour", ()=>MdOutlineTour);
parcelHelpers.export(exports, "MdOutlineTrackChanges", ()=>MdOutlineTrackChanges);
parcelHelpers.export(exports, "MdOutlineTranscribe", ()=>MdOutlineTranscribe);
parcelHelpers.export(exports, "MdOutlineTranslate", ()=>MdOutlineTranslate);
parcelHelpers.export(exports, "MdOutlineTrendingDown", ()=>MdOutlineTrendingDown);
parcelHelpers.export(exports, "MdOutlineTrendingFlat", ()=>MdOutlineTrendingFlat);
parcelHelpers.export(exports, "MdOutlineTrendingUp", ()=>MdOutlineTrendingUp);
parcelHelpers.export(exports, "MdOutlineTroubleshoot", ()=>MdOutlineTroubleshoot);
parcelHelpers.export(exports, "MdOutlineTry", ()=>MdOutlineTry);
parcelHelpers.export(exports, "MdOutlineTurnedInNot", ()=>MdOutlineTurnedInNot);
parcelHelpers.export(exports, "MdOutlineTurnedIn", ()=>MdOutlineTurnedIn);
parcelHelpers.export(exports, "MdOutlineUnfoldLessDouble", ()=>MdOutlineUnfoldLessDouble);
parcelHelpers.export(exports, "MdOutlineUnfoldMoreDouble", ()=>MdOutlineUnfoldMoreDouble);
parcelHelpers.export(exports, "MdOutlineUnpublished", ()=>MdOutlineUnpublished);
parcelHelpers.export(exports, "MdOutlineUpdateDisabled", ()=>MdOutlineUpdateDisabled);
parcelHelpers.export(exports, "MdOutlineUpdate", ()=>MdOutlineUpdate);
parcelHelpers.export(exports, "MdOutlineUpgrade", ()=>MdOutlineUpgrade);
parcelHelpers.export(exports, "MdOutlineVerifiedUser", ()=>MdOutlineVerifiedUser);
parcelHelpers.export(exports, "MdOutlineVerified", ()=>MdOutlineVerified);
parcelHelpers.export(exports, "MdOutlineVerticalSplit", ()=>MdOutlineVerticalSplit);
parcelHelpers.export(exports, "MdOutlineViewAgenda", ()=>MdOutlineViewAgenda);
parcelHelpers.export(exports, "MdOutlineViewArray", ()=>MdOutlineViewArray);
parcelHelpers.export(exports, "MdOutlineViewCarousel", ()=>MdOutlineViewCarousel);
parcelHelpers.export(exports, "MdOutlineViewColumn", ()=>MdOutlineViewColumn);
parcelHelpers.export(exports, "MdOutlineViewComfyAlt", ()=>MdOutlineViewComfyAlt);
parcelHelpers.export(exports, "MdOutlineViewCompactAlt", ()=>MdOutlineViewCompactAlt);
parcelHelpers.export(exports, "MdOutlineViewCozy", ()=>MdOutlineViewCozy);
parcelHelpers.export(exports, "MdOutlineViewDay", ()=>MdOutlineViewDay);
parcelHelpers.export(exports, "MdOutlineViewHeadline", ()=>MdOutlineViewHeadline);
parcelHelpers.export(exports, "MdOutlineViewInAr", ()=>MdOutlineViewInAr);
parcelHelpers.export(exports, "MdOutlineViewKanban", ()=>MdOutlineViewKanban);
parcelHelpers.export(exports, "MdOutlineViewList", ()=>MdOutlineViewList);
parcelHelpers.export(exports, "MdOutlineViewModule", ()=>MdOutlineViewModule);
parcelHelpers.export(exports, "MdOutlineViewQuilt", ()=>MdOutlineViewQuilt);
parcelHelpers.export(exports, "MdOutlineViewSidebar", ()=>MdOutlineViewSidebar);
parcelHelpers.export(exports, "MdOutlineViewStream", ()=>MdOutlineViewStream);
parcelHelpers.export(exports, "MdOutlineViewTimeline", ()=>MdOutlineViewTimeline);
parcelHelpers.export(exports, "MdOutlineViewWeek", ()=>MdOutlineViewWeek);
parcelHelpers.export(exports, "MdOutlineVisibilityOff", ()=>MdOutlineVisibilityOff);
parcelHelpers.export(exports, "MdOutlineVisibility", ()=>MdOutlineVisibility);
parcelHelpers.export(exports, "MdOutlineVoiceOverOff", ()=>MdOutlineVoiceOverOff);
parcelHelpers.export(exports, "MdOutlineWatchLater", ()=>MdOutlineWatchLater);
parcelHelpers.export(exports, "MdOutlineWebhook", ()=>MdOutlineWebhook);
parcelHelpers.export(exports, "MdOutlineWidthFull", ()=>MdOutlineWidthFull);
parcelHelpers.export(exports, "MdOutlineWidthNormal", ()=>MdOutlineWidthNormal);
parcelHelpers.export(exports, "MdOutlineWidthWide", ()=>MdOutlineWidthWide);
parcelHelpers.export(exports, "MdOutlineWifiProtectedSetup", ()=>MdOutlineWifiProtectedSetup);
parcelHelpers.export(exports, "MdOutlineWorkHistory", ()=>MdOutlineWorkHistory);
parcelHelpers.export(exports, "MdOutlineWorkOff", ()=>MdOutlineWorkOff);
parcelHelpers.export(exports, "MdOutlineWorkOutline", ()=>MdOutlineWorkOutline);
parcelHelpers.export(exports, "MdOutlineWork", ()=>MdOutlineWork);
parcelHelpers.export(exports, "MdOutlineWysiwyg", ()=>MdOutlineWysiwyg);
parcelHelpers.export(exports, "MdOutlineYoutubeSearchedFor", ()=>MdOutlineYoutubeSearchedFor);
parcelHelpers.export(exports, "MdOutlineZoomIn", ()=>MdOutlineZoomIn);
parcelHelpers.export(exports, "MdOutlineZoomOut", ()=>MdOutlineZoomOut);
parcelHelpers.export(exports, "MdOutlineAddAlert", ()=>MdOutlineAddAlert);
parcelHelpers.export(exports, "MdOutlineAutoDelete", ()=>MdOutlineAutoDelete);
parcelHelpers.export(exports, "MdOutlineErrorOutline", ()=>MdOutlineErrorOutline);
parcelHelpers.export(exports, "MdOutlineError", ()=>MdOutlineError);
parcelHelpers.export(exports, "MdOutlineNotificationImportant", ()=>MdOutlineNotificationImportant);
parcelHelpers.export(exports, "MdOutlineWarningAmber", ()=>MdOutlineWarningAmber);
parcelHelpers.export(exports, "MdOutlineWarning", ()=>MdOutlineWarning);
parcelHelpers.export(exports, "MdOutline10K", ()=>MdOutline10K);
parcelHelpers.export(exports, "MdOutline1KPlus", ()=>MdOutline1KPlus);
parcelHelpers.export(exports, "MdOutline1K", ()=>MdOutline1K);
parcelHelpers.export(exports, "MdOutline2KPlus", ()=>MdOutline2KPlus);
parcelHelpers.export(exports, "MdOutline2K", ()=>MdOutline2K);
parcelHelpers.export(exports, "MdOutline3KPlus", ()=>MdOutline3KPlus);
parcelHelpers.export(exports, "MdOutline3K", ()=>MdOutline3K);
parcelHelpers.export(exports, "MdOutline4KPlus", ()=>MdOutline4KPlus);
parcelHelpers.export(exports, "MdOutline4K", ()=>MdOutline4K);
parcelHelpers.export(exports, "MdOutline5G", ()=>MdOutline5G);
parcelHelpers.export(exports, "MdOutline5KPlus", ()=>MdOutline5KPlus);
parcelHelpers.export(exports, "MdOutline5K", ()=>MdOutline5K);
parcelHelpers.export(exports, "MdOutline6KPlus", ()=>MdOutline6KPlus);
parcelHelpers.export(exports, "MdOutline6K", ()=>MdOutline6K);
parcelHelpers.export(exports, "MdOutline7KPlus", ()=>MdOutline7KPlus);
parcelHelpers.export(exports, "MdOutline7K", ()=>MdOutline7K);
parcelHelpers.export(exports, "MdOutline8KPlus", ()=>MdOutline8KPlus);
parcelHelpers.export(exports, "MdOutline8K", ()=>MdOutline8K);
parcelHelpers.export(exports, "MdOutline9KPlus", ()=>MdOutline9KPlus);
parcelHelpers.export(exports, "MdOutline9K", ()=>MdOutline9K);
parcelHelpers.export(exports, "MdOutlineAddToQueue", ()=>MdOutlineAddToQueue);
parcelHelpers.export(exports, "MdOutlineAirplay", ()=>MdOutlineAirplay);
parcelHelpers.export(exports, "MdOutlineAlbum", ()=>MdOutlineAlbum);
parcelHelpers.export(exports, "MdOutlineArtTrack", ()=>MdOutlineArtTrack);
parcelHelpers.export(exports, "MdOutlineAudioFile", ()=>MdOutlineAudioFile);
parcelHelpers.export(exports, "MdOutlineAvTimer", ()=>MdOutlineAvTimer);
parcelHelpers.export(exports, "MdOutlineBrandingWatermark", ()=>MdOutlineBrandingWatermark);
parcelHelpers.export(exports, "MdOutlineCallToAction", ()=>MdOutlineCallToAction);
parcelHelpers.export(exports, "MdOutlineClosedCaptionDisabled", ()=>MdOutlineClosedCaptionDisabled);
parcelHelpers.export(exports, "MdOutlineClosedCaptionOff", ()=>MdOutlineClosedCaptionOff);
parcelHelpers.export(exports, "MdOutlineClosedCaption", ()=>MdOutlineClosedCaption);
parcelHelpers.export(exports, "MdOutlineControlCamera", ()=>MdOutlineControlCamera);
parcelHelpers.export(exports, "MdOutlineEqualizer", ()=>MdOutlineEqualizer);
parcelHelpers.export(exports, "MdOutlineExplicit", ()=>MdOutlineExplicit);
parcelHelpers.export(exports, "MdOutlineFastForward", ()=>MdOutlineFastForward);
parcelHelpers.export(exports, "MdOutlineFastRewind", ()=>MdOutlineFastRewind);
parcelHelpers.export(exports, "MdOutlineFeaturedPlayList", ()=>MdOutlineFeaturedPlayList);
parcelHelpers.export(exports, "MdOutlineFeaturedVideo", ()=>MdOutlineFeaturedVideo);
parcelHelpers.export(exports, "MdOutlineFiberDvr", ()=>MdOutlineFiberDvr);
parcelHelpers.export(exports, "MdOutlineFiberManualRecord", ()=>MdOutlineFiberManualRecord);
parcelHelpers.export(exports, "MdOutlineFiberNew", ()=>MdOutlineFiberNew);
parcelHelpers.export(exports, "MdOutlineFiberPin", ()=>MdOutlineFiberPin);
parcelHelpers.export(exports, "MdOutlineFiberSmartRecord", ()=>MdOutlineFiberSmartRecord);
parcelHelpers.export(exports, "MdOutlineForward10", ()=>MdOutlineForward10);
parcelHelpers.export(exports, "MdOutlineForward30", ()=>MdOutlineForward30);
parcelHelpers.export(exports, "MdOutlineForward5", ()=>MdOutlineForward5);
parcelHelpers.export(exports, "MdOutlineGames", ()=>MdOutlineGames);
parcelHelpers.export(exports, "MdOutlineHd", ()=>MdOutlineHd);
parcelHelpers.export(exports, "MdOutlineHearingDisabled", ()=>MdOutlineHearingDisabled);
parcelHelpers.export(exports, "MdOutlineHearing", ()=>MdOutlineHearing);
parcelHelpers.export(exports, "MdOutlineHighQuality", ()=>MdOutlineHighQuality);
parcelHelpers.export(exports, "MdOutlineInterpreterMode", ()=>MdOutlineInterpreterMode);
parcelHelpers.export(exports, "MdOutlineLibraryAddCheck", ()=>MdOutlineLibraryAddCheck);
parcelHelpers.export(exports, "MdOutlineLibraryAdd", ()=>MdOutlineLibraryAdd);
parcelHelpers.export(exports, "MdOutlineLibraryBooks", ()=>MdOutlineLibraryBooks);
parcelHelpers.export(exports, "MdOutlineLibraryMusic", ()=>MdOutlineLibraryMusic);
parcelHelpers.export(exports, "MdOutlineLoop", ()=>MdOutlineLoop);
parcelHelpers.export(exports, "MdOutlineLyrics", ()=>MdOutlineLyrics);
parcelHelpers.export(exports, "MdOutlineMicNone", ()=>MdOutlineMicNone);
parcelHelpers.export(exports, "MdOutlineMicOff", ()=>MdOutlineMicOff);
parcelHelpers.export(exports, "MdOutlineMic", ()=>MdOutlineMic);
parcelHelpers.export(exports, "MdOutlineMissedVideoCall", ()=>MdOutlineMissedVideoCall);
parcelHelpers.export(exports, "MdOutlineMovie", ()=>MdOutlineMovie);
parcelHelpers.export(exports, "MdOutlineMusicVideo", ()=>MdOutlineMusicVideo);
parcelHelpers.export(exports, "MdOutlineNewReleases", ()=>MdOutlineNewReleases);
parcelHelpers.export(exports, "MdOutlineNotInterested", ()=>MdOutlineNotInterested);
parcelHelpers.export(exports, "MdOutlineNote", ()=>MdOutlineNote);
parcelHelpers.export(exports, "MdOutlinePauseCircleFilled", ()=>MdOutlinePauseCircleFilled);
parcelHelpers.export(exports, "MdOutlinePauseCircleOutline", ()=>MdOutlinePauseCircleOutline);
parcelHelpers.export(exports, "MdOutlinePauseCircle", ()=>MdOutlinePauseCircle);
parcelHelpers.export(exports, "MdOutlinePause", ()=>MdOutlinePause);
parcelHelpers.export(exports, "MdOutlinePlayArrow", ()=>MdOutlinePlayArrow);
parcelHelpers.export(exports, "MdOutlinePlayCircleFilled", ()=>MdOutlinePlayCircleFilled);
parcelHelpers.export(exports, "MdOutlinePlayCircleOutline", ()=>MdOutlinePlayCircleOutline);
parcelHelpers.export(exports, "MdOutlinePlayCircle", ()=>MdOutlinePlayCircle);
parcelHelpers.export(exports, "MdOutlinePlayDisabled", ()=>MdOutlinePlayDisabled);
parcelHelpers.export(exports, "MdOutlinePlaylistAddCheckCircle", ()=>MdOutlinePlaylistAddCheckCircle);
parcelHelpers.export(exports, "MdOutlinePlaylistAddCheck", ()=>MdOutlinePlaylistAddCheck);
parcelHelpers.export(exports, "MdOutlinePlaylistAddCircle", ()=>MdOutlinePlaylistAddCircle);
parcelHelpers.export(exports, "MdOutlinePlaylistAdd", ()=>MdOutlinePlaylistAdd);
parcelHelpers.export(exports, "MdOutlinePlaylistPlay", ()=>MdOutlinePlaylistPlay);
parcelHelpers.export(exports, "MdOutlinePlaylistRemove", ()=>MdOutlinePlaylistRemove);
parcelHelpers.export(exports, "MdOutlineQueueMusic", ()=>MdOutlineQueueMusic);
parcelHelpers.export(exports, "MdOutlineQueuePlayNext", ()=>MdOutlineQueuePlayNext);
parcelHelpers.export(exports, "MdOutlineQueue", ()=>MdOutlineQueue);
parcelHelpers.export(exports, "MdOutlineRadio", ()=>MdOutlineRadio);
parcelHelpers.export(exports, "MdOutlineRecentActors", ()=>MdOutlineRecentActors);
parcelHelpers.export(exports, "MdOutlineRemoveFromQueue", ()=>MdOutlineRemoveFromQueue);
parcelHelpers.export(exports, "MdOutlineRepeatOn", ()=>MdOutlineRepeatOn);
parcelHelpers.export(exports, "MdOutlineRepeatOneOn", ()=>MdOutlineRepeatOneOn);
parcelHelpers.export(exports, "MdOutlineRepeatOne", ()=>MdOutlineRepeatOne);
parcelHelpers.export(exports, "MdOutlineRepeat", ()=>MdOutlineRepeat);
parcelHelpers.export(exports, "MdOutlineReplay10", ()=>MdOutlineReplay10);
parcelHelpers.export(exports, "MdOutlineReplay30", ()=>MdOutlineReplay30);
parcelHelpers.export(exports, "MdOutlineReplay5", ()=>MdOutlineReplay5);
parcelHelpers.export(exports, "MdOutlineReplayCircleFilled", ()=>MdOutlineReplayCircleFilled);
parcelHelpers.export(exports, "MdOutlineReplay", ()=>MdOutlineReplay);
parcelHelpers.export(exports, "MdOutlineSd", ()=>MdOutlineSd);
parcelHelpers.export(exports, "MdOutlineShuffleOn", ()=>MdOutlineShuffleOn);
parcelHelpers.export(exports, "MdOutlineShuffle", ()=>MdOutlineShuffle);
parcelHelpers.export(exports, "MdOutlineSkipNext", ()=>MdOutlineSkipNext);
parcelHelpers.export(exports, "MdOutlineSkipPrevious", ()=>MdOutlineSkipPrevious);
parcelHelpers.export(exports, "MdOutlineSlowMotionVideo", ()=>MdOutlineSlowMotionVideo);
parcelHelpers.export(exports, "MdOutlineSnooze", ()=>MdOutlineSnooze);
parcelHelpers.export(exports, "MdOutlineSortByAlpha", ()=>MdOutlineSortByAlpha);
parcelHelpers.export(exports, "MdOutlineSpeed", ()=>MdOutlineSpeed);
parcelHelpers.export(exports, "MdOutlineStopCircle", ()=>MdOutlineStopCircle);
parcelHelpers.export(exports, "MdOutlineStop", ()=>MdOutlineStop);
parcelHelpers.export(exports, "MdOutlineSubscriptions", ()=>MdOutlineSubscriptions);
parcelHelpers.export(exports, "MdOutlineSubtitles", ()=>MdOutlineSubtitles);
parcelHelpers.export(exports, "MdOutlineSurroundSound", ()=>MdOutlineSurroundSound);
parcelHelpers.export(exports, "MdOutlineVideoCall", ()=>MdOutlineVideoCall);
parcelHelpers.export(exports, "MdOutlineVideoFile", ()=>MdOutlineVideoFile);
parcelHelpers.export(exports, "MdOutlineVideoLabel", ()=>MdOutlineVideoLabel);
parcelHelpers.export(exports, "MdOutlineVideoLibrary", ()=>MdOutlineVideoLibrary);
parcelHelpers.export(exports, "MdOutlineVideoSettings", ()=>MdOutlineVideoSettings);
parcelHelpers.export(exports, "MdOutlineVideocamOff", ()=>MdOutlineVideocamOff);
parcelHelpers.export(exports, "MdOutlineVideocam", ()=>MdOutlineVideocam);
parcelHelpers.export(exports, "MdOutlineVolumeDown", ()=>MdOutlineVolumeDown);
parcelHelpers.export(exports, "MdOutlineVolumeMute", ()=>MdOutlineVolumeMute);
parcelHelpers.export(exports, "MdOutlineVolumeOff", ()=>MdOutlineVolumeOff);
parcelHelpers.export(exports, "MdOutlineVolumeUp", ()=>MdOutlineVolumeUp);
parcelHelpers.export(exports, "MdOutlineWebAssetOff", ()=>MdOutlineWebAssetOff);
parcelHelpers.export(exports, "MdOutlineWebAsset", ()=>MdOutlineWebAsset);
parcelHelpers.export(exports, "MdOutlineWeb", ()=>MdOutlineWeb);
parcelHelpers.export(exports, "MdOutline3P", ()=>MdOutline3P);
parcelHelpers.export(exports, "MdOutlineAddIcCall", ()=>MdOutlineAddIcCall);
parcelHelpers.export(exports, "MdOutlineAlternateEmail", ()=>MdOutlineAlternateEmail);
parcelHelpers.export(exports, "MdOutlineAppRegistration", ()=>MdOutlineAppRegistration);
parcelHelpers.export(exports, "MdOutlineBusiness", ()=>MdOutlineBusiness);
parcelHelpers.export(exports, "MdOutlineCallEnd", ()=>MdOutlineCallEnd);
parcelHelpers.export(exports, "MdOutlineCallMade", ()=>MdOutlineCallMade);
parcelHelpers.export(exports, "MdOutlineCallMerge", ()=>MdOutlineCallMerge);
parcelHelpers.export(exports, "MdOutlineCallMissedOutgoing", ()=>MdOutlineCallMissedOutgoing);
parcelHelpers.export(exports, "MdOutlineCallMissed", ()=>MdOutlineCallMissed);
parcelHelpers.export(exports, "MdOutlineCallReceived", ()=>MdOutlineCallReceived);
parcelHelpers.export(exports, "MdOutlineCallSplit", ()=>MdOutlineCallSplit);
parcelHelpers.export(exports, "MdOutlineCall", ()=>MdOutlineCall);
parcelHelpers.export(exports, "MdOutlineCancelPresentation", ()=>MdOutlineCancelPresentation);
parcelHelpers.export(exports, "MdOutlineCellTower", ()=>MdOutlineCellTower);
parcelHelpers.export(exports, "MdOutlineCellWifi", ()=>MdOutlineCellWifi);
parcelHelpers.export(exports, "MdOutlineChatBubbleOutline", ()=>MdOutlineChatBubbleOutline);
parcelHelpers.export(exports, "MdOutlineChatBubble", ()=>MdOutlineChatBubble);
parcelHelpers.export(exports, "MdOutlineChat", ()=>MdOutlineChat);
parcelHelpers.export(exports, "MdOutlineClearAll", ()=>MdOutlineClearAll);
parcelHelpers.export(exports, "MdOutlineCoPresent", ()=>MdOutlineCoPresent);
parcelHelpers.export(exports, "MdOutlineComment", ()=>MdOutlineComment);
parcelHelpers.export(exports, "MdOutlineCommentsDisabled", ()=>MdOutlineCommentsDisabled);
parcelHelpers.export(exports, "MdOutlineContactEmergency", ()=>MdOutlineContactEmergency);
parcelHelpers.export(exports, "MdOutlineContactMail", ()=>MdOutlineContactMail);
parcelHelpers.export(exports, "MdOutlineContactPhone", ()=>MdOutlineContactPhone);
parcelHelpers.export(exports, "MdOutlineContacts", ()=>MdOutlineContacts);
parcelHelpers.export(exports, "MdOutlineDesktopAccessDisabled", ()=>MdOutlineDesktopAccessDisabled);
parcelHelpers.export(exports, "MdOutlineDialerSip", ()=>MdOutlineDialerSip);
parcelHelpers.export(exports, "MdOutlineDialpad", ()=>MdOutlineDialpad);
parcelHelpers.export(exports, "MdOutlineDocumentScanner", ()=>MdOutlineDocumentScanner);
parcelHelpers.export(exports, "MdOutlineDomainDisabled", ()=>MdOutlineDomainDisabled);
parcelHelpers.export(exports, "MdOutlineDomainVerification", ()=>MdOutlineDomainVerification);
parcelHelpers.export(exports, "MdOutlineDuo", ()=>MdOutlineDuo);
parcelHelpers.export(exports, "MdOutlineEmail", ()=>MdOutlineEmail);
parcelHelpers.export(exports, "MdOutlineForum", ()=>MdOutlineForum);
parcelHelpers.export(exports, "MdOutlineForwardToInbox", ()=>MdOutlineForwardToInbox);
parcelHelpers.export(exports, "MdOutlineHourglassBottom", ()=>MdOutlineHourglassBottom);
parcelHelpers.export(exports, "MdOutlineHourglassTop", ()=>MdOutlineHourglassTop);
parcelHelpers.export(exports, "MdOutlineHub", ()=>MdOutlineHub);
parcelHelpers.export(exports, "MdOutlineImportContacts", ()=>MdOutlineImportContacts);
parcelHelpers.export(exports, "MdOutlineImportExport", ()=>MdOutlineImportExport);
parcelHelpers.export(exports, "MdOutlineInvertColorsOff", ()=>MdOutlineInvertColorsOff);
parcelHelpers.export(exports, "MdOutlineKeyOff", ()=>MdOutlineKeyOff);
parcelHelpers.export(exports, "MdOutlineKey", ()=>MdOutlineKey);
parcelHelpers.export(exports, "MdOutlineListAlt", ()=>MdOutlineListAlt);
parcelHelpers.export(exports, "MdOutlineLiveHelp", ()=>MdOutlineLiveHelp);
parcelHelpers.export(exports, "MdOutlineLocationOff", ()=>MdOutlineLocationOff);
parcelHelpers.export(exports, "MdOutlineLocationOn", ()=>MdOutlineLocationOn);
parcelHelpers.export(exports, "MdOutlineMailLock", ()=>MdOutlineMailLock);
parcelHelpers.export(exports, "MdOutlineMailOutline", ()=>MdOutlineMailOutline);
parcelHelpers.export(exports, "MdOutlineMarkChatRead", ()=>MdOutlineMarkChatRead);
parcelHelpers.export(exports, "MdOutlineMarkChatUnread", ()=>MdOutlineMarkChatUnread);
parcelHelpers.export(exports, "MdOutlineMarkEmailRead", ()=>MdOutlineMarkEmailRead);
parcelHelpers.export(exports, "MdOutlineMarkEmailUnread", ()=>MdOutlineMarkEmailUnread);
parcelHelpers.export(exports, "MdOutlineMarkUnreadChatAlt", ()=>MdOutlineMarkUnreadChatAlt);
parcelHelpers.export(exports, "MdOutlineMessage", ()=>MdOutlineMessage);
parcelHelpers.export(exports, "MdOutlineMobileScreenShare", ()=>MdOutlineMobileScreenShare);
parcelHelpers.export(exports, "MdOutlineMoreTime", ()=>MdOutlineMoreTime);
parcelHelpers.export(exports, "MdOutlineNat", ()=>MdOutlineNat);
parcelHelpers.export(exports, "MdOutlineNoSim", ()=>MdOutlineNoSim);
parcelHelpers.export(exports, "MdOutlinePausePresentation", ()=>MdOutlinePausePresentation);
parcelHelpers.export(exports, "MdOutlinePersonAddDisabled", ()=>MdOutlinePersonAddDisabled);
parcelHelpers.export(exports, "MdOutlinePersonSearch", ()=>MdOutlinePersonSearch);
parcelHelpers.export(exports, "MdOutlinePhoneDisabled", ()=>MdOutlinePhoneDisabled);
parcelHelpers.export(exports, "MdOutlinePhoneEnabled", ()=>MdOutlinePhoneEnabled);
parcelHelpers.export(exports, "MdOutlinePhone", ()=>MdOutlinePhone);
parcelHelpers.export(exports, "MdOutlinePhonelinkErase", ()=>MdOutlinePhonelinkErase);
parcelHelpers.export(exports, "MdOutlinePhonelinkLock", ()=>MdOutlinePhonelinkLock);
parcelHelpers.export(exports, "MdOutlinePhonelinkRing", ()=>MdOutlinePhonelinkRing);
parcelHelpers.export(exports, "MdOutlinePhonelinkSetup", ()=>MdOutlinePhonelinkSetup);
parcelHelpers.export(exports, "MdOutlinePortableWifiOff", ()=>MdOutlinePortableWifiOff);
parcelHelpers.export(exports, "MdOutlinePresentToAll", ()=>MdOutlinePresentToAll);
parcelHelpers.export(exports, "MdOutlinePrintDisabled", ()=>MdOutlinePrintDisabled);
parcelHelpers.export(exports, "MdOutlineQrCode2", ()=>MdOutlineQrCode2);
parcelHelpers.export(exports, "MdOutlineQrCodeScanner", ()=>MdOutlineQrCodeScanner);
parcelHelpers.export(exports, "MdOutlineQrCode", ()=>MdOutlineQrCode);
parcelHelpers.export(exports, "MdOutlineReadMore", ()=>MdOutlineReadMore);
parcelHelpers.export(exports, "MdOutlineRingVolume", ()=>MdOutlineRingVolume);
parcelHelpers.export(exports, "MdOutlineRssFeed", ()=>MdOutlineRssFeed);
parcelHelpers.export(exports, "MdOutlineRtt", ()=>MdOutlineRtt);
parcelHelpers.export(exports, "MdOutlineScreenShare", ()=>MdOutlineScreenShare);
parcelHelpers.export(exports, "MdOutlineSendTimeExtension", ()=>MdOutlineSendTimeExtension);
parcelHelpers.export(exports, "MdOutlineSentimentSatisfiedAlt", ()=>MdOutlineSentimentSatisfiedAlt);
parcelHelpers.export(exports, "MdOutlineSip", ()=>MdOutlineSip);
parcelHelpers.export(exports, "MdOutlineSpeakerPhone", ()=>MdOutlineSpeakerPhone);
parcelHelpers.export(exports, "MdOutlineSpoke", ()=>MdOutlineSpoke);
parcelHelpers.export(exports, "MdOutlineStayCurrentLandscape", ()=>MdOutlineStayCurrentLandscape);
parcelHelpers.export(exports, "MdOutlineStayCurrentPortrait", ()=>MdOutlineStayCurrentPortrait);
parcelHelpers.export(exports, "MdOutlineStayPrimaryLandscape", ()=>MdOutlineStayPrimaryLandscape);
parcelHelpers.export(exports, "MdOutlineStayPrimaryPortrait", ()=>MdOutlineStayPrimaryPortrait);
parcelHelpers.export(exports, "MdOutlineStopScreenShare", ()=>MdOutlineStopScreenShare);
parcelHelpers.export(exports, "MdOutlineSwapCalls", ()=>MdOutlineSwapCalls);
parcelHelpers.export(exports, "MdOutlineTextsms", ()=>MdOutlineTextsms);
parcelHelpers.export(exports, "MdOutlineUnsubscribe", ()=>MdOutlineUnsubscribe);
parcelHelpers.export(exports, "MdOutlineVoicemail", ()=>MdOutlineVoicemail);
parcelHelpers.export(exports, "MdOutlineVpnKeyOff", ()=>MdOutlineVpnKeyOff);
parcelHelpers.export(exports, "MdOutlineVpnKey", ()=>MdOutlineVpnKey);
parcelHelpers.export(exports, "MdOutlineWifiCalling", ()=>MdOutlineWifiCalling);
parcelHelpers.export(exports, "MdOutlineAddBox", ()=>MdOutlineAddBox);
parcelHelpers.export(exports, "MdOutlineAddCircleOutline", ()=>MdOutlineAddCircleOutline);
parcelHelpers.export(exports, "MdOutlineAddCircle", ()=>MdOutlineAddCircle);
parcelHelpers.export(exports, "MdOutlineAddLink", ()=>MdOutlineAddLink);
parcelHelpers.export(exports, "MdOutlineAdd", ()=>MdOutlineAdd);
parcelHelpers.export(exports, "MdOutlineAmpStories", ()=>MdOutlineAmpStories);
parcelHelpers.export(exports, "MdOutlineArchive", ()=>MdOutlineArchive);
parcelHelpers.export(exports, "MdOutlineAttribution", ()=>MdOutlineAttribution);
parcelHelpers.export(exports, "MdOutlineBackspace", ()=>MdOutlineBackspace);
parcelHelpers.export(exports, "MdOutlineBallot", ()=>MdOutlineBallot);
parcelHelpers.export(exports, "MdOutlineBiotech", ()=>MdOutlineBiotech);
parcelHelpers.export(exports, "MdOutlineBlock", ()=>MdOutlineBlock);
parcelHelpers.export(exports, "MdOutlineBolt", ()=>MdOutlineBolt);
parcelHelpers.export(exports, "MdOutlineCalculate", ()=>MdOutlineCalculate);
parcelHelpers.export(exports, "MdOutlineChangeCircle", ()=>MdOutlineChangeCircle);
parcelHelpers.export(exports, "MdOutlineClear", ()=>MdOutlineClear);
parcelHelpers.export(exports, "MdOutlineContentCopy", ()=>MdOutlineContentCopy);
parcelHelpers.export(exports, "MdOutlineContentCut", ()=>MdOutlineContentCut);
parcelHelpers.export(exports, "MdOutlineContentPasteGo", ()=>MdOutlineContentPasteGo);
parcelHelpers.export(exports, "MdOutlineContentPasteOff", ()=>MdOutlineContentPasteOff);
parcelHelpers.export(exports, "MdOutlineContentPasteSearch", ()=>MdOutlineContentPasteSearch);
parcelHelpers.export(exports, "MdOutlineContentPaste", ()=>MdOutlineContentPaste);
parcelHelpers.export(exports, "MdOutlineCopyAll", ()=>MdOutlineCopyAll);
parcelHelpers.export(exports, "MdOutlineCreate", ()=>MdOutlineCreate);
parcelHelpers.export(exports, "MdOutlineDeleteSweep", ()=>MdOutlineDeleteSweep);
parcelHelpers.export(exports, "MdOutlineDeselect", ()=>MdOutlineDeselect);
parcelHelpers.export(exports, "MdOutlineDrafts", ()=>MdOutlineDrafts);
parcelHelpers.export(exports, "MdOutlineDynamicFeed", ()=>MdOutlineDynamicFeed);
parcelHelpers.export(exports, "MdOutlineFileCopy", ()=>MdOutlineFileCopy);
parcelHelpers.export(exports, "MdOutlineFilterListOff", ()=>MdOutlineFilterListOff);
parcelHelpers.export(exports, "MdOutlineFilterList", ()=>MdOutlineFilterList);
parcelHelpers.export(exports, "MdOutlineFlagCircle", ()=>MdOutlineFlagCircle);
parcelHelpers.export(exports, "MdOutlineFlag", ()=>MdOutlineFlag);
parcelHelpers.export(exports, "MdOutlineFontDownloadOff", ()=>MdOutlineFontDownloadOff);
parcelHelpers.export(exports, "MdOutlineFontDownload", ()=>MdOutlineFontDownload);
parcelHelpers.export(exports, "MdOutlineForward", ()=>MdOutlineForward);
parcelHelpers.export(exports, "MdOutlineGesture", ()=>MdOutlineGesture);
parcelHelpers.export(exports, "MdOutlineHowToReg", ()=>MdOutlineHowToReg);
parcelHelpers.export(exports, "MdOutlineHowToVote", ()=>MdOutlineHowToVote);
parcelHelpers.export(exports, "MdOutlineInbox", ()=>MdOutlineInbox);
parcelHelpers.export(exports, "MdOutlineInsights", ()=>MdOutlineInsights);
parcelHelpers.export(exports, "MdOutlineInventory2", ()=>MdOutlineInventory2);
parcelHelpers.export(exports, "MdOutlineInventory", ()=>MdOutlineInventory);
parcelHelpers.export(exports, "MdOutlineLinkOff", ()=>MdOutlineLinkOff);
parcelHelpers.export(exports, "MdOutlineLink", ()=>MdOutlineLink);
parcelHelpers.export(exports, "MdOutlineLowPriority", ()=>MdOutlineLowPriority);
parcelHelpers.export(exports, "MdOutlineMail", ()=>MdOutlineMail);
parcelHelpers.export(exports, "MdOutlineMarkunread", ()=>MdOutlineMarkunread);
parcelHelpers.export(exports, "MdOutlineMoveToInbox", ()=>MdOutlineMoveToInbox);
parcelHelpers.export(exports, "MdOutlineNextWeek", ()=>MdOutlineNextWeek);
parcelHelpers.export(exports, "MdOutlineOutlinedFlag", ()=>MdOutlineOutlinedFlag);
parcelHelpers.export(exports, "MdOutlinePolicy", ()=>MdOutlinePolicy);
parcelHelpers.export(exports, "MdOutlinePushPin", ()=>MdOutlinePushPin);
parcelHelpers.export(exports, "MdOutlineRedo", ()=>MdOutlineRedo);
parcelHelpers.export(exports, "MdOutlineRemoveCircleOutline", ()=>MdOutlineRemoveCircleOutline);
parcelHelpers.export(exports, "MdOutlineRemoveCircle", ()=>MdOutlineRemoveCircle);
parcelHelpers.export(exports, "MdOutlineRemove", ()=>MdOutlineRemove);
parcelHelpers.export(exports, "MdOutlineReplyAll", ()=>MdOutlineReplyAll);
parcelHelpers.export(exports, "MdOutlineReply", ()=>MdOutlineReply);
parcelHelpers.export(exports, "MdOutlineReportGmailerrorred", ()=>MdOutlineReportGmailerrorred);
parcelHelpers.export(exports, "MdOutlineReportOff", ()=>MdOutlineReportOff);
parcelHelpers.export(exports, "MdOutlineReport", ()=>MdOutlineReport);
parcelHelpers.export(exports, "MdOutlineSaveAlt", ()=>MdOutlineSaveAlt);
parcelHelpers.export(exports, "MdOutlineSaveAs", ()=>MdOutlineSaveAs);
parcelHelpers.export(exports, "MdOutlineSave", ()=>MdOutlineSave);
parcelHelpers.export(exports, "MdOutlineSelectAll", ()=>MdOutlineSelectAll);
parcelHelpers.export(exports, "MdOutlineSend", ()=>MdOutlineSend);
parcelHelpers.export(exports, "MdOutlineShield", ()=>MdOutlineShield);
parcelHelpers.export(exports, "MdOutlineSort", ()=>MdOutlineSort);
parcelHelpers.export(exports, "MdOutlineSquareFoot", ()=>MdOutlineSquareFoot);
parcelHelpers.export(exports, "MdOutlineStackedBarChart", ()=>MdOutlineStackedBarChart);
parcelHelpers.export(exports, "MdOutlineStream", ()=>MdOutlineStream);
parcelHelpers.export(exports, "MdOutlineTag", ()=>MdOutlineTag);
parcelHelpers.export(exports, "MdOutlineTextFormat", ()=>MdOutlineTextFormat);
parcelHelpers.export(exports, "MdOutlineUnarchive", ()=>MdOutlineUnarchive);
parcelHelpers.export(exports, "MdOutlineUndo", ()=>MdOutlineUndo);
parcelHelpers.export(exports, "MdOutlineUpcoming", ()=>MdOutlineUpcoming);
parcelHelpers.export(exports, "MdOutlineWaves", ()=>MdOutlineWaves);
parcelHelpers.export(exports, "MdOutlineWebStories", ()=>MdOutlineWebStories);
parcelHelpers.export(exports, "MdOutlineWeekend", ()=>MdOutlineWeekend);
parcelHelpers.export(exports, "MdOutlineWhereToVote", ()=>MdOutlineWhereToVote);
parcelHelpers.export(exports, "MdOutline1XMobiledata", ()=>MdOutline1XMobiledata);
parcelHelpers.export(exports, "MdOutline30Fps", ()=>MdOutline30Fps);
parcelHelpers.export(exports, "MdOutline3GMobiledata", ()=>MdOutline3GMobiledata);
parcelHelpers.export(exports, "MdOutline4GMobiledata", ()=>MdOutline4GMobiledata);
parcelHelpers.export(exports, "MdOutline4GPlusMobiledata", ()=>MdOutline4GPlusMobiledata);
parcelHelpers.export(exports, "MdOutline60Fps", ()=>MdOutline60Fps);
parcelHelpers.export(exports, "MdOutlineAccessAlarm", ()=>MdOutlineAccessAlarm);
parcelHelpers.export(exports, "MdOutlineAccessAlarms", ()=>MdOutlineAccessAlarms);
parcelHelpers.export(exports, "MdOutlineAccessTimeFilled", ()=>MdOutlineAccessTimeFilled);
parcelHelpers.export(exports, "MdOutlineAccessTime", ()=>MdOutlineAccessTime);
parcelHelpers.export(exports, "MdOutlineAdUnits", ()=>MdOutlineAdUnits);
parcelHelpers.export(exports, "MdOutlineAddAlarm", ()=>MdOutlineAddAlarm);
parcelHelpers.export(exports, "MdOutlineAddToHomeScreen", ()=>MdOutlineAddToHomeScreen);
parcelHelpers.export(exports, "MdOutlineAir", ()=>MdOutlineAir);
parcelHelpers.export(exports, "MdOutlineAirplaneTicket", ()=>MdOutlineAirplaneTicket);
parcelHelpers.export(exports, "MdOutlineAirplanemodeActive", ()=>MdOutlineAirplanemodeActive);
parcelHelpers.export(exports, "MdOutlineAirplanemodeInactive", ()=>MdOutlineAirplanemodeInactive);
parcelHelpers.export(exports, "MdOutlineAod", ()=>MdOutlineAod);
parcelHelpers.export(exports, "MdOutlineBattery0Bar", ()=>MdOutlineBattery0Bar);
parcelHelpers.export(exports, "MdOutlineBattery1Bar", ()=>MdOutlineBattery1Bar);
parcelHelpers.export(exports, "MdOutlineBattery2Bar", ()=>MdOutlineBattery2Bar);
parcelHelpers.export(exports, "MdOutlineBattery3Bar", ()=>MdOutlineBattery3Bar);
parcelHelpers.export(exports, "MdOutlineBattery4Bar", ()=>MdOutlineBattery4Bar);
parcelHelpers.export(exports, "MdOutlineBattery5Bar", ()=>MdOutlineBattery5Bar);
parcelHelpers.export(exports, "MdOutlineBattery6Bar", ()=>MdOutlineBattery6Bar);
parcelHelpers.export(exports, "MdOutlineBatteryAlert", ()=>MdOutlineBatteryAlert);
parcelHelpers.export(exports, "MdOutlineBatteryChargingFull", ()=>MdOutlineBatteryChargingFull);
parcelHelpers.export(exports, "MdOutlineBatteryFull", ()=>MdOutlineBatteryFull);
parcelHelpers.export(exports, "MdOutlineBatterySaver", ()=>MdOutlineBatterySaver);
parcelHelpers.export(exports, "MdOutlineBatteryStd", ()=>MdOutlineBatteryStd);
parcelHelpers.export(exports, "MdOutlineBatteryUnknown", ()=>MdOutlineBatteryUnknown);
parcelHelpers.export(exports, "MdOutlineBloodtype", ()=>MdOutlineBloodtype);
parcelHelpers.export(exports, "MdOutlineBluetoothConnected", ()=>MdOutlineBluetoothConnected);
parcelHelpers.export(exports, "MdOutlineBluetoothDisabled", ()=>MdOutlineBluetoothDisabled);
parcelHelpers.export(exports, "MdOutlineBluetoothDrive", ()=>MdOutlineBluetoothDrive);
parcelHelpers.export(exports, "MdOutlineBluetoothSearching", ()=>MdOutlineBluetoothSearching);
parcelHelpers.export(exports, "MdOutlineBluetooth", ()=>MdOutlineBluetooth);
parcelHelpers.export(exports, "MdOutlineBrightnessAuto", ()=>MdOutlineBrightnessAuto);
parcelHelpers.export(exports, "MdOutlineBrightnessHigh", ()=>MdOutlineBrightnessHigh);
parcelHelpers.export(exports, "MdOutlineBrightnessLow", ()=>MdOutlineBrightnessLow);
parcelHelpers.export(exports, "MdOutlineBrightnessMedium", ()=>MdOutlineBrightnessMedium);
parcelHelpers.export(exports, "MdOutlineCable", ()=>MdOutlineCable);
parcelHelpers.export(exports, "MdOutlineCameraswitch", ()=>MdOutlineCameraswitch);
parcelHelpers.export(exports, "MdOutlineCreditScore", ()=>MdOutlineCreditScore);
parcelHelpers.export(exports, "MdOutlineDarkMode", ()=>MdOutlineDarkMode);
parcelHelpers.export(exports, "MdOutlineDataSaverOff", ()=>MdOutlineDataSaverOff);
parcelHelpers.export(exports, "MdOutlineDataSaverOn", ()=>MdOutlineDataSaverOn);
parcelHelpers.export(exports, "MdOutlineDataUsage", ()=>MdOutlineDataUsage);
parcelHelpers.export(exports, "MdOutlineDatasetLinked", ()=>MdOutlineDatasetLinked);
parcelHelpers.export(exports, "MdOutlineDataset", ()=>MdOutlineDataset);
parcelHelpers.export(exports, "MdOutlineDeveloperMode", ()=>MdOutlineDeveloperMode);
parcelHelpers.export(exports, "MdOutlineDeviceThermostat", ()=>MdOutlineDeviceThermostat);
parcelHelpers.export(exports, "MdOutlineDevicesFold", ()=>MdOutlineDevicesFold);
parcelHelpers.export(exports, "MdOutlineDevices", ()=>MdOutlineDevices);
parcelHelpers.export(exports, "MdOutlineDiscount", ()=>MdOutlineDiscount);
parcelHelpers.export(exports, "MdOutlineDoNotDisturbOnTotalSilence", ()=>MdOutlineDoNotDisturbOnTotalSilence);
parcelHelpers.export(exports, "MdOutlineDvr", ()=>MdOutlineDvr);
parcelHelpers.export(exports, "MdOutlineEMobiledata", ()=>MdOutlineEMobiledata);
parcelHelpers.export(exports, "MdOutlineEdgesensorHigh", ()=>MdOutlineEdgesensorHigh);
parcelHelpers.export(exports, "MdOutlineEdgesensorLow", ()=>MdOutlineEdgesensorLow);
parcelHelpers.export(exports, "MdOutlineFlashlightOff", ()=>MdOutlineFlashlightOff);
parcelHelpers.export(exports, "MdOutlineFlashlightOn", ()=>MdOutlineFlashlightOn);
parcelHelpers.export(exports, "MdOutlineFlourescent", ()=>MdOutlineFlourescent);
parcelHelpers.export(exports, "MdOutlineFluorescent", ()=>MdOutlineFluorescent);
parcelHelpers.export(exports, "MdOutlineFmdBad", ()=>MdOutlineFmdBad);
parcelHelpers.export(exports, "MdOutlineFmdGood", ()=>MdOutlineFmdGood);
parcelHelpers.export(exports, "MdOutlineGMobiledata", ()=>MdOutlineGMobiledata);
parcelHelpers.export(exports, "MdOutlineGppBad", ()=>MdOutlineGppBad);
parcelHelpers.export(exports, "MdOutlineGppGood", ()=>MdOutlineGppGood);
parcelHelpers.export(exports, "MdOutlineGppMaybe", ()=>MdOutlineGppMaybe);
parcelHelpers.export(exports, "MdOutlineGpsFixed", ()=>MdOutlineGpsFixed);
parcelHelpers.export(exports, "MdOutlineGpsNotFixed", ()=>MdOutlineGpsNotFixed);
parcelHelpers.export(exports, "MdOutlineGpsOff", ()=>MdOutlineGpsOff);
parcelHelpers.export(exports, "MdOutlineGraphicEq", ()=>MdOutlineGraphicEq);
parcelHelpers.export(exports, "MdOutlineGrid3X3", ()=>MdOutlineGrid3X3);
parcelHelpers.export(exports, "MdOutlineGrid4X4", ()=>MdOutlineGrid4X4);
parcelHelpers.export(exports, "MdOutlineGridGoldenratio", ()=>MdOutlineGridGoldenratio);
parcelHelpers.export(exports, "MdOutlineHMobiledata", ()=>MdOutlineHMobiledata);
parcelHelpers.export(exports, "MdOutlineHPlusMobiledata", ()=>MdOutlineHPlusMobiledata);
parcelHelpers.export(exports, "MdOutlineHdrAutoSelect", ()=>MdOutlineHdrAutoSelect);
parcelHelpers.export(exports, "MdOutlineHdrAuto", ()=>MdOutlineHdrAuto);
parcelHelpers.export(exports, "MdOutlineHdrOffSelect", ()=>MdOutlineHdrOffSelect);
parcelHelpers.export(exports, "MdOutlineHdrOnSelect", ()=>MdOutlineHdrOnSelect);
parcelHelpers.export(exports, "MdOutlineLan", ()=>MdOutlineLan);
parcelHelpers.export(exports, "MdOutlineLensBlur", ()=>MdOutlineLensBlur);
parcelHelpers.export(exports, "MdOutlineLightMode", ()=>MdOutlineLightMode);
parcelHelpers.export(exports, "MdOutlineLocationDisabled", ()=>MdOutlineLocationDisabled);
parcelHelpers.export(exports, "MdOutlineLocationSearching", ()=>MdOutlineLocationSearching);
parcelHelpers.export(exports, "MdOutlineLteMobiledata", ()=>MdOutlineLteMobiledata);
parcelHelpers.export(exports, "MdOutlineLtePlusMobiledata", ()=>MdOutlineLtePlusMobiledata);
parcelHelpers.export(exports, "MdOutlineMacroOff", ()=>MdOutlineMacroOff);
parcelHelpers.export(exports, "MdOutlineMediaBluetoothOff", ()=>MdOutlineMediaBluetoothOff);
parcelHelpers.export(exports, "MdOutlineMediaBluetoothOn", ()=>MdOutlineMediaBluetoothOn);
parcelHelpers.export(exports, "MdOutlineMedicationLiquid", ()=>MdOutlineMedicationLiquid);
parcelHelpers.export(exports, "MdOutlineMedication", ()=>MdOutlineMedication);
parcelHelpers.export(exports, "MdOutlineMobileFriendly", ()=>MdOutlineMobileFriendly);
parcelHelpers.export(exports, "MdOutlineMobileOff", ()=>MdOutlineMobileOff);
parcelHelpers.export(exports, "MdOutlineMobiledataOff", ()=>MdOutlineMobiledataOff);
parcelHelpers.export(exports, "MdOutlineModeNight", ()=>MdOutlineModeNight);
parcelHelpers.export(exports, "MdOutlineModeStandby", ()=>MdOutlineModeStandby);
parcelHelpers.export(exports, "MdOutlineMonitorHeart", ()=>MdOutlineMonitorHeart);
parcelHelpers.export(exports, "MdOutlineMonitorWeight", ()=>MdOutlineMonitorWeight);
parcelHelpers.export(exports, "MdOutlineNearbyError", ()=>MdOutlineNearbyError);
parcelHelpers.export(exports, "MdOutlineNearbyOff", ()=>MdOutlineNearbyOff);
parcelHelpers.export(exports, "MdOutlineNetworkCell", ()=>MdOutlineNetworkCell);
parcelHelpers.export(exports, "MdOutlineNetworkWifi1Bar", ()=>MdOutlineNetworkWifi1Bar);
parcelHelpers.export(exports, "MdOutlineNetworkWifi2Bar", ()=>MdOutlineNetworkWifi2Bar);
parcelHelpers.export(exports, "MdOutlineNetworkWifi3Bar", ()=>MdOutlineNetworkWifi3Bar);
parcelHelpers.export(exports, "MdOutlineNetworkWifi", ()=>MdOutlineNetworkWifi);
parcelHelpers.export(exports, "MdOutlineNfc", ()=>MdOutlineNfc);
parcelHelpers.export(exports, "MdOutlineNightlight", ()=>MdOutlineNightlight);
parcelHelpers.export(exports, "MdOutlineNoteAlt", ()=>MdOutlineNoteAlt);
parcelHelpers.export(exports, "MdOutlinePassword", ()=>MdOutlinePassword);
parcelHelpers.export(exports, "MdOutlinePattern", ()=>MdOutlinePattern);
parcelHelpers.export(exports, "MdOutlinePhishing", ()=>MdOutlinePhishing);
parcelHelpers.export(exports, "MdOutlinePin", ()=>MdOutlinePin);
parcelHelpers.export(exports, "MdOutlinePlayLesson", ()=>MdOutlinePlayLesson);
parcelHelpers.export(exports, "MdOutlinePriceChange", ()=>MdOutlinePriceChange);
parcelHelpers.export(exports, "MdOutlinePriceCheck", ()=>MdOutlinePriceCheck);
parcelHelpers.export(exports, "MdOutlinePunchClock", ()=>MdOutlinePunchClock);
parcelHelpers.export(exports, "MdOutlineQuiz", ()=>MdOutlineQuiz);
parcelHelpers.export(exports, "MdOutlineRMobiledata", ()=>MdOutlineRMobiledata);
parcelHelpers.export(exports, "MdOutlineRadar", ()=>MdOutlineRadar);
parcelHelpers.export(exports, "MdOutlineRememberMe", ()=>MdOutlineRememberMe);
parcelHelpers.export(exports, "MdOutlineResetTv", ()=>MdOutlineResetTv);
parcelHelpers.export(exports, "MdOutlineRestartAlt", ()=>MdOutlineRestartAlt);
parcelHelpers.export(exports, "MdOutlineReviews", ()=>MdOutlineReviews);
parcelHelpers.export(exports, "MdOutlineRsvp", ()=>MdOutlineRsvp);
parcelHelpers.export(exports, "MdOutlineScreenLockLandscape", ()=>MdOutlineScreenLockLandscape);
parcelHelpers.export(exports, "MdOutlineScreenLockPortrait", ()=>MdOutlineScreenLockPortrait);
parcelHelpers.export(exports, "MdOutlineScreenLockRotation", ()=>MdOutlineScreenLockRotation);
parcelHelpers.export(exports, "MdOutlineScreenRotation", ()=>MdOutlineScreenRotation);
parcelHelpers.export(exports, "MdOutlineScreenSearchDesktop", ()=>MdOutlineScreenSearchDesktop);
parcelHelpers.export(exports, "MdOutlineScreenshotMonitor", ()=>MdOutlineScreenshotMonitor);
parcelHelpers.export(exports, "MdOutlineScreenshot", ()=>MdOutlineScreenshot);
parcelHelpers.export(exports, "MdOutlineSdStorage", ()=>MdOutlineSdStorage);
parcelHelpers.export(exports, "MdOutlineSecurityUpdateGood", ()=>MdOutlineSecurityUpdateGood);
parcelHelpers.export(exports, "MdOutlineSecurityUpdateWarning", ()=>MdOutlineSecurityUpdateWarning);
parcelHelpers.export(exports, "MdOutlineSecurityUpdate", ()=>MdOutlineSecurityUpdate);
parcelHelpers.export(exports, "MdOutlineSell", ()=>MdOutlineSell);
parcelHelpers.export(exports, "MdOutlineSendToMobile", ()=>MdOutlineSendToMobile);
parcelHelpers.export(exports, "MdOutlineSettingsSuggest", ()=>MdOutlineSettingsSuggest);
parcelHelpers.export(exports, "MdOutlineSettingsSystemDaydream", ()=>MdOutlineSettingsSystemDaydream);
parcelHelpers.export(exports, "MdOutlineShareLocation", ()=>MdOutlineShareLocation);
parcelHelpers.export(exports, "MdOutlineShortcut", ()=>MdOutlineShortcut);
parcelHelpers.export(exports, "MdOutlineSignalCellular0Bar", ()=>MdOutlineSignalCellular0Bar);
parcelHelpers.export(exports, "MdOutlineSignalCellular4Bar", ()=>MdOutlineSignalCellular4Bar);
parcelHelpers.export(exports, "MdOutlineSignalCellularAlt1Bar", ()=>MdOutlineSignalCellularAlt1Bar);
parcelHelpers.export(exports, "MdOutlineSignalCellularAlt2Bar", ()=>MdOutlineSignalCellularAlt2Bar);
parcelHelpers.export(exports, "MdOutlineSignalCellularAlt", ()=>MdOutlineSignalCellularAlt);
parcelHelpers.export(exports, "MdOutlineSignalCellularConnectedNoInternet0Bar", ()=>MdOutlineSignalCellularConnectedNoInternet0Bar);
parcelHelpers.export(exports, "MdOutlineSignalCellularConnectedNoInternet4Bar", ()=>MdOutlineSignalCellularConnectedNoInternet4Bar);
parcelHelpers.export(exports, "MdOutlineSignalCellularNoSim", ()=>MdOutlineSignalCellularNoSim);
parcelHelpers.export(exports, "MdOutlineSignalCellularNodata", ()=>MdOutlineSignalCellularNodata);
parcelHelpers.export(exports, "MdOutlineSignalCellularNull", ()=>MdOutlineSignalCellularNull);
parcelHelpers.export(exports, "MdOutlineSignalCellularOff", ()=>MdOutlineSignalCellularOff);
parcelHelpers.export(exports, "MdOutlineSignalWifi0Bar", ()=>MdOutlineSignalWifi0Bar);
parcelHelpers.export(exports, "MdOutlineSignalWifi4BarLock", ()=>MdOutlineSignalWifi4BarLock);
parcelHelpers.export(exports, "MdOutlineSignalWifi4Bar", ()=>MdOutlineSignalWifi4Bar);
parcelHelpers.export(exports, "MdOutlineSignalWifiBad", ()=>MdOutlineSignalWifiBad);
parcelHelpers.export(exports, "MdOutlineSignalWifiConnectedNoInternet4", ()=>MdOutlineSignalWifiConnectedNoInternet4);
parcelHelpers.export(exports, "MdOutlineSignalWifiOff", ()=>MdOutlineSignalWifiOff);
parcelHelpers.export(exports, "MdOutlineSignalWifiStatusbar4Bar", ()=>MdOutlineSignalWifiStatusbar4Bar);
parcelHelpers.export(exports, "MdOutlineSignalWifiStatusbarConnectedNoInternet4", ()=>MdOutlineSignalWifiStatusbarConnectedNoInternet4);
parcelHelpers.export(exports, "MdOutlineSignalWifiStatusbarNull", ()=>MdOutlineSignalWifiStatusbarNull);
parcelHelpers.export(exports, "MdOutlineSimCardDownload", ()=>MdOutlineSimCardDownload);
parcelHelpers.export(exports, "MdOutlineSplitscreen", ()=>MdOutlineSplitscreen);
parcelHelpers.export(exports, "MdOutlineSportsScore", ()=>MdOutlineSportsScore);
parcelHelpers.export(exports, "MdOutlineSsidChart", ()=>MdOutlineSsidChart);
parcelHelpers.export(exports, "MdOutlineStorage", ()=>MdOutlineStorage);
parcelHelpers.export(exports, "MdOutlineStorm", ()=>MdOutlineStorm);
parcelHelpers.export(exports, "MdOutlineSummarize", ()=>MdOutlineSummarize);
parcelHelpers.export(exports, "MdOutlineSystemSecurityUpdateGood", ()=>MdOutlineSystemSecurityUpdateGood);
parcelHelpers.export(exports, "MdOutlineSystemSecurityUpdateWarning", ()=>MdOutlineSystemSecurityUpdateWarning);
parcelHelpers.export(exports, "MdOutlineSystemSecurityUpdate", ()=>MdOutlineSystemSecurityUpdate);
parcelHelpers.export(exports, "MdOutlineTask", ()=>MdOutlineTask);
parcelHelpers.export(exports, "MdOutlineThermostat", ()=>MdOutlineThermostat);
parcelHelpers.export(exports, "MdOutlineTimer10Select", ()=>MdOutlineTimer10Select);
parcelHelpers.export(exports, "MdOutlineTimer3Select", ()=>MdOutlineTimer3Select);
parcelHelpers.export(exports, "MdOutlineTungsten", ()=>MdOutlineTungsten);
parcelHelpers.export(exports, "MdOutlineUsbOff", ()=>MdOutlineUsbOff);
parcelHelpers.export(exports, "MdOutlineUsb", ()=>MdOutlineUsb);
parcelHelpers.export(exports, "MdOutlineWallpaper", ()=>MdOutlineWallpaper);
parcelHelpers.export(exports, "MdOutlineWater", ()=>MdOutlineWater);
parcelHelpers.export(exports, "MdOutlineWidgets", ()=>MdOutlineWidgets);
parcelHelpers.export(exports, "MdOutlineWifi1Bar", ()=>MdOutlineWifi1Bar);
parcelHelpers.export(exports, "MdOutlineWifi2Bar", ()=>MdOutlineWifi2Bar);
parcelHelpers.export(exports, "MdOutlineWifiCalling3", ()=>MdOutlineWifiCalling3);
parcelHelpers.export(exports, "MdOutlineWifiChannel", ()=>MdOutlineWifiChannel);
parcelHelpers.export(exports, "MdOutlineWifiFind", ()=>MdOutlineWifiFind);
parcelHelpers.export(exports, "MdOutlineWifiLock", ()=>MdOutlineWifiLock);
parcelHelpers.export(exports, "MdOutlineWifiPassword", ()=>MdOutlineWifiPassword);
parcelHelpers.export(exports, "MdOutlineWifiTetheringErrorRounded", ()=>MdOutlineWifiTetheringErrorRounded);
parcelHelpers.export(exports, "MdOutlineWifiTetheringError", ()=>MdOutlineWifiTetheringError);
parcelHelpers.export(exports, "MdOutlineWifiTetheringOff", ()=>MdOutlineWifiTetheringOff);
parcelHelpers.export(exports, "MdOutlineWifiTethering", ()=>MdOutlineWifiTethering);
parcelHelpers.export(exports, "MdOutlineAddChart", ()=>MdOutlineAddChart);
parcelHelpers.export(exports, "MdOutlineAddComment", ()=>MdOutlineAddComment);
parcelHelpers.export(exports, "MdOutlineAlignHorizontalCenter", ()=>MdOutlineAlignHorizontalCenter);
parcelHelpers.export(exports, "MdOutlineAlignHorizontalLeft", ()=>MdOutlineAlignHorizontalLeft);
parcelHelpers.export(exports, "MdOutlineAlignHorizontalRight", ()=>MdOutlineAlignHorizontalRight);
parcelHelpers.export(exports, "MdOutlineAlignVerticalBottom", ()=>MdOutlineAlignVerticalBottom);
parcelHelpers.export(exports, "MdOutlineAlignVerticalCenter", ()=>MdOutlineAlignVerticalCenter);
parcelHelpers.export(exports, "MdOutlineAlignVerticalTop", ()=>MdOutlineAlignVerticalTop);
parcelHelpers.export(exports, "MdOutlineAreaChart", ()=>MdOutlineAreaChart);
parcelHelpers.export(exports, "MdOutlineAttachFile", ()=>MdOutlineAttachFile);
parcelHelpers.export(exports, "MdOutlineAttachMoney", ()=>MdOutlineAttachMoney);
parcelHelpers.export(exports, "MdOutlineAutoGraph", ()=>MdOutlineAutoGraph);
parcelHelpers.export(exports, "MdOutlineBarChart", ()=>MdOutlineBarChart);
parcelHelpers.export(exports, "MdOutlineBorderAll", ()=>MdOutlineBorderAll);
parcelHelpers.export(exports, "MdOutlineBorderBottom", ()=>MdOutlineBorderBottom);
parcelHelpers.export(exports, "MdOutlineBorderClear", ()=>MdOutlineBorderClear);
parcelHelpers.export(exports, "MdOutlineBorderColor", ()=>MdOutlineBorderColor);
parcelHelpers.export(exports, "MdOutlineBorderHorizontal", ()=>MdOutlineBorderHorizontal);
parcelHelpers.export(exports, "MdOutlineBorderInner", ()=>MdOutlineBorderInner);
parcelHelpers.export(exports, "MdOutlineBorderLeft", ()=>MdOutlineBorderLeft);
parcelHelpers.export(exports, "MdOutlineBorderOuter", ()=>MdOutlineBorderOuter);
parcelHelpers.export(exports, "MdOutlineBorderRight", ()=>MdOutlineBorderRight);
parcelHelpers.export(exports, "MdOutlineBorderStyle", ()=>MdOutlineBorderStyle);
parcelHelpers.export(exports, "MdOutlineBorderTop", ()=>MdOutlineBorderTop);
parcelHelpers.export(exports, "MdOutlineBorderVertical", ()=>MdOutlineBorderVertical);
parcelHelpers.export(exports, "MdOutlineBubbleChart", ()=>MdOutlineBubbleChart);
parcelHelpers.export(exports, "MdOutlineCandlestickChart", ()=>MdOutlineCandlestickChart);
parcelHelpers.export(exports, "MdOutlineChecklistRtl", ()=>MdOutlineChecklistRtl);
parcelHelpers.export(exports, "MdOutlineChecklist", ()=>MdOutlineChecklist);
parcelHelpers.export(exports, "MdOutlineDataArray", ()=>MdOutlineDataArray);
parcelHelpers.export(exports, "MdOutlineDataObject", ()=>MdOutlineDataObject);
parcelHelpers.export(exports, "MdOutlineDragHandle", ()=>MdOutlineDragHandle);
parcelHelpers.export(exports, "MdOutlineDraw", ()=>MdOutlineDraw);
parcelHelpers.export(exports, "MdOutlineEditNote", ()=>MdOutlineEditNote);
parcelHelpers.export(exports, "MdOutlineFormatAlignCenter", ()=>MdOutlineFormatAlignCenter);
parcelHelpers.export(exports, "MdOutlineFormatAlignJustify", ()=>MdOutlineFormatAlignJustify);
parcelHelpers.export(exports, "MdOutlineFormatAlignLeft", ()=>MdOutlineFormatAlignLeft);
parcelHelpers.export(exports, "MdOutlineFormatAlignRight", ()=>MdOutlineFormatAlignRight);
parcelHelpers.export(exports, "MdOutlineFormatBold", ()=>MdOutlineFormatBold);
parcelHelpers.export(exports, "MdOutlineFormatClear", ()=>MdOutlineFormatClear);
parcelHelpers.export(exports, "MdOutlineFormatColorFill", ()=>MdOutlineFormatColorFill);
parcelHelpers.export(exports, "MdOutlineFormatColorReset", ()=>MdOutlineFormatColorReset);
parcelHelpers.export(exports, "MdOutlineFormatColorText", ()=>MdOutlineFormatColorText);
parcelHelpers.export(exports, "MdOutlineFormatIndentDecrease", ()=>MdOutlineFormatIndentDecrease);
parcelHelpers.export(exports, "MdOutlineFormatIndentIncrease", ()=>MdOutlineFormatIndentIncrease);
parcelHelpers.export(exports, "MdOutlineFormatItalic", ()=>MdOutlineFormatItalic);
parcelHelpers.export(exports, "MdOutlineFormatLineSpacing", ()=>MdOutlineFormatLineSpacing);
parcelHelpers.export(exports, "MdOutlineFormatListBulleted", ()=>MdOutlineFormatListBulleted);
parcelHelpers.export(exports, "MdOutlineFormatListNumberedRtl", ()=>MdOutlineFormatListNumberedRtl);
parcelHelpers.export(exports, "MdOutlineFormatListNumbered", ()=>MdOutlineFormatListNumbered);
parcelHelpers.export(exports, "MdOutlineFormatPaint", ()=>MdOutlineFormatPaint);
parcelHelpers.export(exports, "MdOutlineFormatQuote", ()=>MdOutlineFormatQuote);
parcelHelpers.export(exports, "MdOutlineFormatShapes", ()=>MdOutlineFormatShapes);
parcelHelpers.export(exports, "MdOutlineFormatSize", ()=>MdOutlineFormatSize);
parcelHelpers.export(exports, "MdOutlineFormatStrikethrough", ()=>MdOutlineFormatStrikethrough);
parcelHelpers.export(exports, "MdOutlineFormatTextdirectionLToR", ()=>MdOutlineFormatTextdirectionLToR);
parcelHelpers.export(exports, "MdOutlineFormatTextdirectionRToL", ()=>MdOutlineFormatTextdirectionRToL);
parcelHelpers.export(exports, "MdOutlineFormatUnderlined", ()=>MdOutlineFormatUnderlined);
parcelHelpers.export(exports, "MdOutlineFunctions", ()=>MdOutlineFunctions);
parcelHelpers.export(exports, "MdOutlineHeight", ()=>MdOutlineHeight);
parcelHelpers.export(exports, "MdOutlineHexagon", ()=>MdOutlineHexagon);
parcelHelpers.export(exports, "MdOutlineHighlight", ()=>MdOutlineHighlight);
parcelHelpers.export(exports, "MdOutlineHorizontalDistribute", ()=>MdOutlineHorizontalDistribute);
parcelHelpers.export(exports, "MdOutlineHorizontalRule", ()=>MdOutlineHorizontalRule);
parcelHelpers.export(exports, "MdOutlineInsertChartOutlined", ()=>MdOutlineInsertChartOutlined);
parcelHelpers.export(exports, "MdOutlineInsertChart", ()=>MdOutlineInsertChart);
parcelHelpers.export(exports, "MdOutlineInsertComment", ()=>MdOutlineInsertComment);
parcelHelpers.export(exports, "MdOutlineInsertDriveFile", ()=>MdOutlineInsertDriveFile);
parcelHelpers.export(exports, "MdOutlineInsertEmoticon", ()=>MdOutlineInsertEmoticon);
parcelHelpers.export(exports, "MdOutlineInsertInvitation", ()=>MdOutlineInsertInvitation);
parcelHelpers.export(exports, "MdOutlineInsertLink", ()=>MdOutlineInsertLink);
parcelHelpers.export(exports, "MdOutlineInsertPageBreak", ()=>MdOutlineInsertPageBreak);
parcelHelpers.export(exports, "MdOutlineInsertPhoto", ()=>MdOutlineInsertPhoto);
parcelHelpers.export(exports, "MdOutlineLineAxis", ()=>MdOutlineLineAxis);
parcelHelpers.export(exports, "MdOutlineLinearScale", ()=>MdOutlineLinearScale);
parcelHelpers.export(exports, "MdOutlineMargin", ()=>MdOutlineMargin);
parcelHelpers.export(exports, "MdOutlineMergeType", ()=>MdOutlineMergeType);
parcelHelpers.export(exports, "MdOutlineModeComment", ()=>MdOutlineModeComment);
parcelHelpers.export(exports, "MdOutlineModeEditOutline", ()=>MdOutlineModeEditOutline);
parcelHelpers.export(exports, "MdOutlineModeEdit", ()=>MdOutlineModeEdit);
parcelHelpers.export(exports, "MdOutlineMode", ()=>MdOutlineMode);
parcelHelpers.export(exports, "MdOutlineMonetizationOn", ()=>MdOutlineMonetizationOn);
parcelHelpers.export(exports, "MdOutlineMoneyOffCsred", ()=>MdOutlineMoneyOffCsred);
parcelHelpers.export(exports, "MdOutlineMoneyOff", ()=>MdOutlineMoneyOff);
parcelHelpers.export(exports, "MdOutlineMoveDown", ()=>MdOutlineMoveDown);
parcelHelpers.export(exports, "MdOutlineMoveUp", ()=>MdOutlineMoveUp);
parcelHelpers.export(exports, "MdOutlineMultilineChart", ()=>MdOutlineMultilineChart);
parcelHelpers.export(exports, "MdOutlineNotes", ()=>MdOutlineNotes);
parcelHelpers.export(exports, "MdOutlineNumbers", ()=>MdOutlineNumbers);
parcelHelpers.export(exports, "MdOutlinePadding", ()=>MdOutlinePadding);
parcelHelpers.export(exports, "MdOutlinePentagon", ()=>MdOutlinePentagon);
parcelHelpers.export(exports, "MdOutlinePieChartOutline", ()=>MdOutlinePieChartOutline);
parcelHelpers.export(exports, "MdOutlinePieChart", ()=>MdOutlinePieChart);
parcelHelpers.export(exports, "MdOutlinePolyline", ()=>MdOutlinePolyline);
parcelHelpers.export(exports, "MdOutlinePostAdd", ()=>MdOutlinePostAdd);
parcelHelpers.export(exports, "MdOutlinePublish", ()=>MdOutlinePublish);
parcelHelpers.export(exports, "MdOutlineQueryStats", ()=>MdOutlineQueryStats);
parcelHelpers.export(exports, "MdOutlineRectangle", ()=>MdOutlineRectangle);
parcelHelpers.export(exports, "MdOutlineScatterPlot", ()=>MdOutlineScatterPlot);
parcelHelpers.export(exports, "MdOutlineSchema", ()=>MdOutlineSchema);
parcelHelpers.export(exports, "MdOutlineScore", ()=>MdOutlineScore);
parcelHelpers.export(exports, "MdOutlineShapeLine", ()=>MdOutlineShapeLine);
parcelHelpers.export(exports, "MdOutlineShortText", ()=>MdOutlineShortText);
parcelHelpers.export(exports, "MdOutlineShowChart", ()=>MdOutlineShowChart);
parcelHelpers.export(exports, "MdOutlineSpaceBar", ()=>MdOutlineSpaceBar);
parcelHelpers.export(exports, "MdOutlineSquare", ()=>MdOutlineSquare);
parcelHelpers.export(exports, "MdOutlineStackedLineChart", ()=>MdOutlineStackedLineChart);
parcelHelpers.export(exports, "MdOutlineStrikethroughS", ()=>MdOutlineStrikethroughS);
parcelHelpers.export(exports, "MdOutlineSubscript", ()=>MdOutlineSubscript);
parcelHelpers.export(exports, "MdOutlineSuperscript", ()=>MdOutlineSuperscript);
parcelHelpers.export(exports, "MdOutlineTableChart", ()=>MdOutlineTableChart);
parcelHelpers.export(exports, "MdOutlineTableRows", ()=>MdOutlineTableRows);
parcelHelpers.export(exports, "MdOutlineTextDecrease", ()=>MdOutlineTextDecrease);
parcelHelpers.export(exports, "MdOutlineTextFields", ()=>MdOutlineTextFields);
parcelHelpers.export(exports, "MdOutlineTextIncrease", ()=>MdOutlineTextIncrease);
parcelHelpers.export(exports, "MdOutlineTitle", ()=>MdOutlineTitle);
parcelHelpers.export(exports, "MdOutlineTypeSpecimen", ()=>MdOutlineTypeSpecimen);
parcelHelpers.export(exports, "MdOutlineVerticalAlignBottom", ()=>MdOutlineVerticalAlignBottom);
parcelHelpers.export(exports, "MdOutlineVerticalAlignCenter", ()=>MdOutlineVerticalAlignCenter);
parcelHelpers.export(exports, "MdOutlineVerticalAlignTop", ()=>MdOutlineVerticalAlignTop);
parcelHelpers.export(exports, "MdOutlineVerticalDistribute", ()=>MdOutlineVerticalDistribute);
parcelHelpers.export(exports, "MdOutlineWrapText", ()=>MdOutlineWrapText);
parcelHelpers.export(exports, "MdOutlineApproval", ()=>MdOutlineApproval);
parcelHelpers.export(exports, "MdOutlineAttachEmail", ()=>MdOutlineAttachEmail);
parcelHelpers.export(exports, "MdOutlineAttachment", ()=>MdOutlineAttachment);
parcelHelpers.export(exports, "MdOutlineCloudCircle", ()=>MdOutlineCloudCircle);
parcelHelpers.export(exports, "MdOutlineCloudDone", ()=>MdOutlineCloudDone);
parcelHelpers.export(exports, "MdOutlineCloudDownload", ()=>MdOutlineCloudDownload);
parcelHelpers.export(exports, "MdOutlineCloudOff", ()=>MdOutlineCloudOff);
parcelHelpers.export(exports, "MdOutlineCloudQueue", ()=>MdOutlineCloudQueue);
parcelHelpers.export(exports, "MdOutlineCloudSync", ()=>MdOutlineCloudSync);
parcelHelpers.export(exports, "MdOutlineCloudUpload", ()=>MdOutlineCloudUpload);
parcelHelpers.export(exports, "MdOutlineCloud", ()=>MdOutlineCloud);
parcelHelpers.export(exports, "MdOutlineCreateNewFolder", ()=>MdOutlineCreateNewFolder);
parcelHelpers.export(exports, "MdOutlineDifference", ()=>MdOutlineDifference);
parcelHelpers.export(exports, "MdOutlineDownloadDone", ()=>MdOutlineDownloadDone);
parcelHelpers.export(exports, "MdOutlineDownloadForOffline", ()=>MdOutlineDownloadForOffline);
parcelHelpers.export(exports, "MdOutlineDownload", ()=>MdOutlineDownload);
parcelHelpers.export(exports, "MdOutlineDownloading", ()=>MdOutlineDownloading);
parcelHelpers.export(exports, "MdOutlineDriveFileMoveRtl", ()=>MdOutlineDriveFileMoveRtl);
parcelHelpers.export(exports, "MdOutlineDriveFileMove", ()=>MdOutlineDriveFileMove);
parcelHelpers.export(exports, "MdOutlineDriveFileRenameOutline", ()=>MdOutlineDriveFileRenameOutline);
parcelHelpers.export(exports, "MdOutlineDriveFolderUpload", ()=>MdOutlineDriveFolderUpload);
parcelHelpers.export(exports, "MdOutlineFileDownloadDone", ()=>MdOutlineFileDownloadDone);
parcelHelpers.export(exports, "MdOutlineFileDownloadOff", ()=>MdOutlineFileDownloadOff);
parcelHelpers.export(exports, "MdOutlineFileDownload", ()=>MdOutlineFileDownload);
parcelHelpers.export(exports, "MdOutlineFileOpen", ()=>MdOutlineFileOpen);
parcelHelpers.export(exports, "MdOutlineFileUpload", ()=>MdOutlineFileUpload);
parcelHelpers.export(exports, "MdOutlineFolderCopy", ()=>MdOutlineFolderCopy);
parcelHelpers.export(exports, "MdOutlineFolderDelete", ()=>MdOutlineFolderDelete);
parcelHelpers.export(exports, "MdOutlineFolderOff", ()=>MdOutlineFolderOff);
parcelHelpers.export(exports, "MdOutlineFolderOpen", ()=>MdOutlineFolderOpen);
parcelHelpers.export(exports, "MdOutlineFolderShared", ()=>MdOutlineFolderShared);
parcelHelpers.export(exports, "MdOutlineFolderZip", ()=>MdOutlineFolderZip);
parcelHelpers.export(exports, "MdOutlineFolder", ()=>MdOutlineFolder);
parcelHelpers.export(exports, "MdOutlineFormatOverline", ()=>MdOutlineFormatOverline);
parcelHelpers.export(exports, "MdOutlineGridView", ()=>MdOutlineGridView);
parcelHelpers.export(exports, "MdOutlineNewspaper", ()=>MdOutlineNewspaper);
parcelHelpers.export(exports, "MdOutlineRequestQuote", ()=>MdOutlineRequestQuote);
parcelHelpers.export(exports, "MdOutlineRuleFolder", ()=>MdOutlineRuleFolder);
parcelHelpers.export(exports, "MdOutlineSnippetFolder", ()=>MdOutlineSnippetFolder);
parcelHelpers.export(exports, "MdOutlineTextSnippet", ()=>MdOutlineTextSnippet);
parcelHelpers.export(exports, "MdOutlineTopic", ()=>MdOutlineTopic);
parcelHelpers.export(exports, "MdOutlineUploadFile", ()=>MdOutlineUploadFile);
parcelHelpers.export(exports, "MdOutlineUpload", ()=>MdOutlineUpload);
parcelHelpers.export(exports, "MdOutlineWorkspaces", ()=>MdOutlineWorkspaces);
parcelHelpers.export(exports, "MdOutlineAdfScanner", ()=>MdOutlineAdfScanner);
parcelHelpers.export(exports, "MdOutlineBrowserNotSupported", ()=>MdOutlineBrowserNotSupported);
parcelHelpers.export(exports, "MdOutlineBrowserUpdated", ()=>MdOutlineBrowserUpdated);
parcelHelpers.export(exports, "MdOutlineCastConnected", ()=>MdOutlineCastConnected);
parcelHelpers.export(exports, "MdOutlineCastForEducation", ()=>MdOutlineCastForEducation);
parcelHelpers.export(exports, "MdOutlineCast", ()=>MdOutlineCast);
parcelHelpers.export(exports, "MdOutlineComputer", ()=>MdOutlineComputer);
parcelHelpers.export(exports, "MdOutlineConnectedTv", ()=>MdOutlineConnectedTv);
parcelHelpers.export(exports, "MdOutlineDesktopMac", ()=>MdOutlineDesktopMac);
parcelHelpers.export(exports, "MdOutlineDesktopWindows", ()=>MdOutlineDesktopWindows);
parcelHelpers.export(exports, "MdOutlineDeveloperBoardOff", ()=>MdOutlineDeveloperBoardOff);
parcelHelpers.export(exports, "MdOutlineDeveloperBoard", ()=>MdOutlineDeveloperBoard);
parcelHelpers.export(exports, "MdOutlineDeviceHub", ()=>MdOutlineDeviceHub);
parcelHelpers.export(exports, "MdOutlineDeviceUnknown", ()=>MdOutlineDeviceUnknown);
parcelHelpers.export(exports, "MdOutlineDevicesOther", ()=>MdOutlineDevicesOther);
parcelHelpers.export(exports, "MdOutlineDock", ()=>MdOutlineDock);
parcelHelpers.export(exports, "MdOutlineEarbudsBattery", ()=>MdOutlineEarbudsBattery);
parcelHelpers.export(exports, "MdOutlineEarbuds", ()=>MdOutlineEarbuds);
parcelHelpers.export(exports, "MdOutlineGamepad", ()=>MdOutlineGamepad);
parcelHelpers.export(exports, "MdOutlineHeadphonesBattery", ()=>MdOutlineHeadphonesBattery);
parcelHelpers.export(exports, "MdOutlineHeadphones", ()=>MdOutlineHeadphones);
parcelHelpers.export(exports, "MdOutlineHeadsetMic", ()=>MdOutlineHeadsetMic);
parcelHelpers.export(exports, "MdOutlineHeadsetOff", ()=>MdOutlineHeadsetOff);
parcelHelpers.export(exports, "MdOutlineHeadset", ()=>MdOutlineHeadset);
parcelHelpers.export(exports, "MdOutlineHomeMax", ()=>MdOutlineHomeMax);
parcelHelpers.export(exports, "MdOutlineHomeMini", ()=>MdOutlineHomeMini);
parcelHelpers.export(exports, "MdOutlineKeyboardAlt", ()=>MdOutlineKeyboardAlt);
parcelHelpers.export(exports, "MdOutlineKeyboardArrowDown", ()=>MdOutlineKeyboardArrowDown);
parcelHelpers.export(exports, "MdOutlineKeyboardArrowLeft", ()=>MdOutlineKeyboardArrowLeft);
parcelHelpers.export(exports, "MdOutlineKeyboardArrowRight", ()=>MdOutlineKeyboardArrowRight);
parcelHelpers.export(exports, "MdOutlineKeyboardArrowUp", ()=>MdOutlineKeyboardArrowUp);
parcelHelpers.export(exports, "MdOutlineKeyboardBackspace", ()=>MdOutlineKeyboardBackspace);
parcelHelpers.export(exports, "MdOutlineKeyboardCapslock", ()=>MdOutlineKeyboardCapslock);
parcelHelpers.export(exports, "MdOutlineKeyboardCommandKey", ()=>MdOutlineKeyboardCommandKey);
parcelHelpers.export(exports, "MdOutlineKeyboardControlKey", ()=>MdOutlineKeyboardControlKey);
parcelHelpers.export(exports, "MdOutlineKeyboardDoubleArrowDown", ()=>MdOutlineKeyboardDoubleArrowDown);
parcelHelpers.export(exports, "MdOutlineKeyboardDoubleArrowLeft", ()=>MdOutlineKeyboardDoubleArrowLeft);
parcelHelpers.export(exports, "MdOutlineKeyboardDoubleArrowRight", ()=>MdOutlineKeyboardDoubleArrowRight);
parcelHelpers.export(exports, "MdOutlineKeyboardDoubleArrowUp", ()=>MdOutlineKeyboardDoubleArrowUp);
parcelHelpers.export(exports, "MdOutlineKeyboardHide", ()=>MdOutlineKeyboardHide);
parcelHelpers.export(exports, "MdOutlineKeyboardOptionKey", ()=>MdOutlineKeyboardOptionKey);
parcelHelpers.export(exports, "MdOutlineKeyboardReturn", ()=>MdOutlineKeyboardReturn);
parcelHelpers.export(exports, "MdOutlineKeyboardTab", ()=>MdOutlineKeyboardTab);
parcelHelpers.export(exports, "MdOutlineKeyboardVoice", ()=>MdOutlineKeyboardVoice);
parcelHelpers.export(exports, "MdOutlineKeyboard", ()=>MdOutlineKeyboard);
parcelHelpers.export(exports, "MdOutlineLaptopChromebook", ()=>MdOutlineLaptopChromebook);
parcelHelpers.export(exports, "MdOutlineLaptopMac", ()=>MdOutlineLaptopMac);
parcelHelpers.export(exports, "MdOutlineLaptopWindows", ()=>MdOutlineLaptopWindows);
parcelHelpers.export(exports, "MdOutlineLaptop", ()=>MdOutlineLaptop);
parcelHelpers.export(exports, "MdOutlineMemory", ()=>MdOutlineMemory);
parcelHelpers.export(exports, "MdOutlineMonitor", ()=>MdOutlineMonitor);
parcelHelpers.export(exports, "MdOutlineMouse", ()=>MdOutlineMouse);
parcelHelpers.export(exports, "MdOutlinePhoneAndroid", ()=>MdOutlinePhoneAndroid);
parcelHelpers.export(exports, "MdOutlinePhoneIphone", ()=>MdOutlinePhoneIphone);
parcelHelpers.export(exports, "MdOutlinePhonelinkOff", ()=>MdOutlinePhonelinkOff);
parcelHelpers.export(exports, "MdOutlinePhonelink", ()=>MdOutlinePhonelink);
parcelHelpers.export(exports, "MdOutlinePointOfSale", ()=>MdOutlinePointOfSale);
parcelHelpers.export(exports, "MdOutlinePowerInput", ()=>MdOutlinePowerInput);
parcelHelpers.export(exports, "MdOutlineRouter", ()=>MdOutlineRouter);
parcelHelpers.export(exports, "MdOutlineScanner", ()=>MdOutlineScanner);
parcelHelpers.export(exports, "MdOutlineSecurity", ()=>MdOutlineSecurity);
parcelHelpers.export(exports, "MdOutlineSimCard", ()=>MdOutlineSimCard);
parcelHelpers.export(exports, "MdOutlineSmartDisplay", ()=>MdOutlineSmartDisplay);
parcelHelpers.export(exports, "MdOutlineSmartScreen", ()=>MdOutlineSmartScreen);
parcelHelpers.export(exports, "MdOutlineSmartToy", ()=>MdOutlineSmartToy);
parcelHelpers.export(exports, "MdOutlineSmartphone", ()=>MdOutlineSmartphone);
parcelHelpers.export(exports, "MdOutlineSpeakerGroup", ()=>MdOutlineSpeakerGroup);
parcelHelpers.export(exports, "MdOutlineSpeaker", ()=>MdOutlineSpeaker);
parcelHelpers.export(exports, "MdOutlineStart", ()=>MdOutlineStart);
parcelHelpers.export(exports, "MdOutlineTabletAndroid", ()=>MdOutlineTabletAndroid);
parcelHelpers.export(exports, "MdOutlineTabletMac", ()=>MdOutlineTabletMac);
parcelHelpers.export(exports, "MdOutlineTablet", ()=>MdOutlineTablet);
parcelHelpers.export(exports, "MdOutlineToys", ()=>MdOutlineToys);
parcelHelpers.export(exports, "MdOutlineTv", ()=>MdOutlineTv);
parcelHelpers.export(exports, "MdOutlineVideogameAssetOff", ()=>MdOutlineVideogameAssetOff);
parcelHelpers.export(exports, "MdOutlineVideogameAsset", ()=>MdOutlineVideogameAsset);
parcelHelpers.export(exports, "MdOutlineWatchOff", ()=>MdOutlineWatchOff);
parcelHelpers.export(exports, "MdOutlineWatch", ()=>MdOutlineWatch);
parcelHelpers.export(exports, "MdOutlineAutoMode", ()=>MdOutlineAutoMode);
parcelHelpers.export(exports, "MdOutlineBlindsClosed", ()=>MdOutlineBlindsClosed);
parcelHelpers.export(exports, "MdOutlineBlinds", ()=>MdOutlineBlinds);
parcelHelpers.export(exports, "MdOutlineBroadcastOnHome", ()=>MdOutlineBroadcastOnHome);
parcelHelpers.export(exports, "MdOutlineBroadcastOnPersonal", ()=>MdOutlineBroadcastOnPersonal);
parcelHelpers.export(exports, "MdOutlineCurtainsClosed", ()=>MdOutlineCurtainsClosed);
parcelHelpers.export(exports, "MdOutlineCurtains", ()=>MdOutlineCurtains);
parcelHelpers.export(exports, "MdOutlineElectricBolt", ()=>MdOutlineElectricBolt);
parcelHelpers.export(exports, "MdOutlineElectricMeter", ()=>MdOutlineElectricMeter);
parcelHelpers.export(exports, "MdOutlineEnergySavingsLeaf", ()=>MdOutlineEnergySavingsLeaf);
parcelHelpers.export(exports, "MdOutlineGasMeter", ()=>MdOutlineGasMeter);
parcelHelpers.export(exports, "MdOutlineHeatPump", ()=>MdOutlineHeatPump);
parcelHelpers.export(exports, "MdOutlineModeFanOff", ()=>MdOutlineModeFanOff);
parcelHelpers.export(exports, "MdOutlineNestCamWiredStand", ()=>MdOutlineNestCamWiredStand);
parcelHelpers.export(exports, "MdOutlineOilBarrel", ()=>MdOutlineOilBarrel);
parcelHelpers.export(exports, "MdOutlinePropaneTank", ()=>MdOutlinePropaneTank);
parcelHelpers.export(exports, "MdOutlinePropane", ()=>MdOutlinePropane);
parcelHelpers.export(exports, "MdOutlineRollerShadesClosed", ()=>MdOutlineRollerShadesClosed);
parcelHelpers.export(exports, "MdOutlineRollerShades", ()=>MdOutlineRollerShades);
parcelHelpers.export(exports, "MdOutlineSensorDoor", ()=>MdOutlineSensorDoor);
parcelHelpers.export(exports, "MdOutlineSensorOccupied", ()=>MdOutlineSensorOccupied);
parcelHelpers.export(exports, "MdOutlineSensorWindow", ()=>MdOutlineSensorWindow);
parcelHelpers.export(exports, "MdOutlineShieldMoon", ()=>MdOutlineShieldMoon);
parcelHelpers.export(exports, "MdOutlineSolarPower", ()=>MdOutlineSolarPower);
parcelHelpers.export(exports, "MdOutlineVerticalShadesClosed", ()=>MdOutlineVerticalShadesClosed);
parcelHelpers.export(exports, "MdOutlineVerticalShades", ()=>MdOutlineVerticalShades);
parcelHelpers.export(exports, "MdOutlineWindPower", ()=>MdOutlineWindPower);
parcelHelpers.export(exports, "MdOutline10Mp", ()=>MdOutline10Mp);
parcelHelpers.export(exports, "MdOutline11Mp", ()=>MdOutline11Mp);
parcelHelpers.export(exports, "MdOutline12Mp", ()=>MdOutline12Mp);
parcelHelpers.export(exports, "MdOutline13Mp", ()=>MdOutline13Mp);
parcelHelpers.export(exports, "MdOutline14Mp", ()=>MdOutline14Mp);
parcelHelpers.export(exports, "MdOutline15Mp", ()=>MdOutline15Mp);
parcelHelpers.export(exports, "MdOutline16Mp", ()=>MdOutline16Mp);
parcelHelpers.export(exports, "MdOutline17Mp", ()=>MdOutline17Mp);
parcelHelpers.export(exports, "MdOutline18Mp", ()=>MdOutline18Mp);
parcelHelpers.export(exports, "MdOutline19Mp", ()=>MdOutline19Mp);
parcelHelpers.export(exports, "MdOutline20Mp", ()=>MdOutline20Mp);
parcelHelpers.export(exports, "MdOutline21Mp", ()=>MdOutline21Mp);
parcelHelpers.export(exports, "MdOutline22Mp", ()=>MdOutline22Mp);
parcelHelpers.export(exports, "MdOutline23Mp", ()=>MdOutline23Mp);
parcelHelpers.export(exports, "MdOutline24Mp", ()=>MdOutline24Mp);
parcelHelpers.export(exports, "MdOutline2Mp", ()=>MdOutline2Mp);
parcelHelpers.export(exports, "MdOutline30FpsSelect", ()=>MdOutline30FpsSelect);
parcelHelpers.export(exports, "MdOutline3Mp", ()=>MdOutline3Mp);
parcelHelpers.export(exports, "MdOutline4Mp", ()=>MdOutline4Mp);
parcelHelpers.export(exports, "MdOutline5Mp", ()=>MdOutline5Mp);
parcelHelpers.export(exports, "MdOutline60FpsSelect", ()=>MdOutline60FpsSelect);
parcelHelpers.export(exports, "MdOutline6Mp", ()=>MdOutline6Mp);
parcelHelpers.export(exports, "MdOutline7Mp", ()=>MdOutline7Mp);
parcelHelpers.export(exports, "MdOutline8Mp", ()=>MdOutline8Mp);
parcelHelpers.export(exports, "MdOutline9Mp", ()=>MdOutline9Mp);
parcelHelpers.export(exports, "MdOutlineAddAPhoto", ()=>MdOutlineAddAPhoto);
parcelHelpers.export(exports, "MdOutlineAddPhotoAlternate", ()=>MdOutlineAddPhotoAlternate);
parcelHelpers.export(exports, "MdOutlineAddToPhotos", ()=>MdOutlineAddToPhotos);
parcelHelpers.export(exports, "MdOutlineAdjust", ()=>MdOutlineAdjust);
parcelHelpers.export(exports, "MdOutlineAnimation", ()=>MdOutlineAnimation);
parcelHelpers.export(exports, "MdOutlineAssistantPhoto", ()=>MdOutlineAssistantPhoto);
parcelHelpers.export(exports, "MdOutlineAssistant", ()=>MdOutlineAssistant);
parcelHelpers.export(exports, "MdOutlineAudiotrack", ()=>MdOutlineAudiotrack);
parcelHelpers.export(exports, "MdOutlineAutoAwesomeMosaic", ()=>MdOutlineAutoAwesomeMosaic);
parcelHelpers.export(exports, "MdOutlineAutoAwesomeMotion", ()=>MdOutlineAutoAwesomeMotion);
parcelHelpers.export(exports, "MdOutlineAutoAwesome", ()=>MdOutlineAutoAwesome);
parcelHelpers.export(exports, "MdOutlineAutoFixHigh", ()=>MdOutlineAutoFixHigh);
parcelHelpers.export(exports, "MdOutlineAutoFixNormal", ()=>MdOutlineAutoFixNormal);
parcelHelpers.export(exports, "MdOutlineAutoFixOff", ()=>MdOutlineAutoFixOff);
parcelHelpers.export(exports, "MdOutlineAutoStories", ()=>MdOutlineAutoStories);
parcelHelpers.export(exports, "MdOutlineAutofpsSelect", ()=>MdOutlineAutofpsSelect);
parcelHelpers.export(exports, "MdOutlineBedtimeOff", ()=>MdOutlineBedtimeOff);
parcelHelpers.export(exports, "MdOutlineBedtime", ()=>MdOutlineBedtime);
parcelHelpers.export(exports, "MdOutlineBlurCircular", ()=>MdOutlineBlurCircular);
parcelHelpers.export(exports, "MdOutlineBlurLinear", ()=>MdOutlineBlurLinear);
parcelHelpers.export(exports, "MdOutlineBlurOff", ()=>MdOutlineBlurOff);
parcelHelpers.export(exports, "MdOutlineBlurOn", ()=>MdOutlineBlurOn);
parcelHelpers.export(exports, "MdOutlineBrightness1", ()=>MdOutlineBrightness1);
parcelHelpers.export(exports, "MdOutlineBrightness2", ()=>MdOutlineBrightness2);
parcelHelpers.export(exports, "MdOutlineBrightness3", ()=>MdOutlineBrightness3);
parcelHelpers.export(exports, "MdOutlineBrightness4", ()=>MdOutlineBrightness4);
parcelHelpers.export(exports, "MdOutlineBrightness5", ()=>MdOutlineBrightness5);
parcelHelpers.export(exports, "MdOutlineBrightness6", ()=>MdOutlineBrightness6);
parcelHelpers.export(exports, "MdOutlineBrightness7", ()=>MdOutlineBrightness7);
parcelHelpers.export(exports, "MdOutlineBrokenImage", ()=>MdOutlineBrokenImage);
parcelHelpers.export(exports, "MdOutlineBrush", ()=>MdOutlineBrush);
parcelHelpers.export(exports, "MdOutlineBurstMode", ()=>MdOutlineBurstMode);
parcelHelpers.export(exports, "MdOutlineCameraAlt", ()=>MdOutlineCameraAlt);
parcelHelpers.export(exports, "MdOutlineCameraFront", ()=>MdOutlineCameraFront);
parcelHelpers.export(exports, "MdOutlineCameraRear", ()=>MdOutlineCameraRear);
parcelHelpers.export(exports, "MdOutlineCameraRoll", ()=>MdOutlineCameraRoll);
parcelHelpers.export(exports, "MdOutlineCamera", ()=>MdOutlineCamera);
parcelHelpers.export(exports, "MdOutlineCases", ()=>MdOutlineCases);
parcelHelpers.export(exports, "MdOutlineCenterFocusStrong", ()=>MdOutlineCenterFocusStrong);
parcelHelpers.export(exports, "MdOutlineCenterFocusWeak", ()=>MdOutlineCenterFocusWeak);
parcelHelpers.export(exports, "MdOutlineCircle", ()=>MdOutlineCircle);
parcelHelpers.export(exports, "MdOutlineCollectionsBookmark", ()=>MdOutlineCollectionsBookmark);
parcelHelpers.export(exports, "MdOutlineCollections", ()=>MdOutlineCollections);
parcelHelpers.export(exports, "MdOutlineColorLens", ()=>MdOutlineColorLens);
parcelHelpers.export(exports, "MdOutlineColorize", ()=>MdOutlineColorize);
parcelHelpers.export(exports, "MdOutlineCompare", ()=>MdOutlineCompare);
parcelHelpers.export(exports, "MdOutlineContrast", ()=>MdOutlineContrast);
parcelHelpers.export(exports, "MdOutlineControlPointDuplicate", ()=>MdOutlineControlPointDuplicate);
parcelHelpers.export(exports, "MdOutlineControlPoint", ()=>MdOutlineControlPoint);
parcelHelpers.export(exports, "MdOutlineCrop169", ()=>MdOutlineCrop169);
parcelHelpers.export(exports, "MdOutlineCrop32", ()=>MdOutlineCrop32);
parcelHelpers.export(exports, "MdOutlineCrop54", ()=>MdOutlineCrop54);
parcelHelpers.export(exports, "MdOutlineCrop75", ()=>MdOutlineCrop75);
parcelHelpers.export(exports, "MdOutlineCropDin", ()=>MdOutlineCropDin);
parcelHelpers.export(exports, "MdOutlineCropFree", ()=>MdOutlineCropFree);
parcelHelpers.export(exports, "MdOutlineCropLandscape", ()=>MdOutlineCropLandscape);
parcelHelpers.export(exports, "MdOutlineCropOriginal", ()=>MdOutlineCropOriginal);
parcelHelpers.export(exports, "MdOutlineCropPortrait", ()=>MdOutlineCropPortrait);
parcelHelpers.export(exports, "MdOutlineCropRotate", ()=>MdOutlineCropRotate);
parcelHelpers.export(exports, "MdOutlineCropSquare", ()=>MdOutlineCropSquare);
parcelHelpers.export(exports, "MdOutlineCrop", ()=>MdOutlineCrop);
parcelHelpers.export(exports, "MdOutlineCurrencyBitcoin", ()=>MdOutlineCurrencyBitcoin);
parcelHelpers.export(exports, "MdOutlineCurrencyFranc", ()=>MdOutlineCurrencyFranc);
parcelHelpers.export(exports, "MdOutlineCurrencyLira", ()=>MdOutlineCurrencyLira);
parcelHelpers.export(exports, "MdOutlineCurrencyPound", ()=>MdOutlineCurrencyPound);
parcelHelpers.export(exports, "MdOutlineCurrencyRuble", ()=>MdOutlineCurrencyRuble);
parcelHelpers.export(exports, "MdOutlineCurrencyRupee", ()=>MdOutlineCurrencyRupee);
parcelHelpers.export(exports, "MdOutlineCurrencyYen", ()=>MdOutlineCurrencyYen);
parcelHelpers.export(exports, "MdOutlineCurrencyYuan", ()=>MdOutlineCurrencyYuan);
parcelHelpers.export(exports, "MdOutlineDeblur", ()=>MdOutlineDeblur);
parcelHelpers.export(exports, "MdOutlineDehaze", ()=>MdOutlineDehaze);
parcelHelpers.export(exports, "MdOutlineDetails", ()=>MdOutlineDetails);
parcelHelpers.export(exports, "MdOutlineDirtyLens", ()=>MdOutlineDirtyLens);
parcelHelpers.export(exports, "MdOutlineEdit", ()=>MdOutlineEdit);
parcelHelpers.export(exports, "MdOutlineEuro", ()=>MdOutlineEuro);
parcelHelpers.export(exports, "MdOutlineExposureNeg1", ()=>MdOutlineExposureNeg1);
parcelHelpers.export(exports, "MdOutlineExposureNeg2", ()=>MdOutlineExposureNeg2);
parcelHelpers.export(exports, "MdOutlineExposurePlus1", ()=>MdOutlineExposurePlus1);
parcelHelpers.export(exports, "MdOutlineExposurePlus2", ()=>MdOutlineExposurePlus2);
parcelHelpers.export(exports, "MdOutlineExposureZero", ()=>MdOutlineExposureZero);
parcelHelpers.export(exports, "MdOutlineExposure", ()=>MdOutlineExposure);
parcelHelpers.export(exports, "MdOutlineFaceRetouchingNatural", ()=>MdOutlineFaceRetouchingNatural);
parcelHelpers.export(exports, "MdOutlineFaceRetouchingOff", ()=>MdOutlineFaceRetouchingOff);
parcelHelpers.export(exports, "MdOutlineFilter1", ()=>MdOutlineFilter1);
parcelHelpers.export(exports, "MdOutlineFilter2", ()=>MdOutlineFilter2);
parcelHelpers.export(exports, "MdOutlineFilter3", ()=>MdOutlineFilter3);
parcelHelpers.export(exports, "MdOutlineFilter4", ()=>MdOutlineFilter4);
parcelHelpers.export(exports, "MdOutlineFilter5", ()=>MdOutlineFilter5);
parcelHelpers.export(exports, "MdOutlineFilter6", ()=>MdOutlineFilter6);
parcelHelpers.export(exports, "MdOutlineFilter7", ()=>MdOutlineFilter7);
parcelHelpers.export(exports, "MdOutlineFilter8", ()=>MdOutlineFilter8);
parcelHelpers.export(exports, "MdOutlineFilter9Plus", ()=>MdOutlineFilter9Plus);
parcelHelpers.export(exports, "MdOutlineFilter9", ()=>MdOutlineFilter9);
parcelHelpers.export(exports, "MdOutlineFilterBAndW", ()=>MdOutlineFilterBAndW);
parcelHelpers.export(exports, "MdOutlineFilterCenterFocus", ()=>MdOutlineFilterCenterFocus);
parcelHelpers.export(exports, "MdOutlineFilterDrama", ()=>MdOutlineFilterDrama);
parcelHelpers.export(exports, "MdOutlineFilterFrames", ()=>MdOutlineFilterFrames);
parcelHelpers.export(exports, "MdOutlineFilterHdr", ()=>MdOutlineFilterHdr);
parcelHelpers.export(exports, "MdOutlineFilterNone", ()=>MdOutlineFilterNone);
parcelHelpers.export(exports, "MdOutlineFilterTiltShift", ()=>MdOutlineFilterTiltShift);
parcelHelpers.export(exports, "MdOutlineFilterVintage", ()=>MdOutlineFilterVintage);
parcelHelpers.export(exports, "MdOutlineFilter", ()=>MdOutlineFilter);
parcelHelpers.export(exports, "MdOutlineFlare", ()=>MdOutlineFlare);
parcelHelpers.export(exports, "MdOutlineFlashAuto", ()=>MdOutlineFlashAuto);
parcelHelpers.export(exports, "MdOutlineFlashOff", ()=>MdOutlineFlashOff);
parcelHelpers.export(exports, "MdOutlineFlashOn", ()=>MdOutlineFlashOn);
parcelHelpers.export(exports, "MdOutlineFlipCameraAndroid", ()=>MdOutlineFlipCameraAndroid);
parcelHelpers.export(exports, "MdOutlineFlipCameraIos", ()=>MdOutlineFlipCameraIos);
parcelHelpers.export(exports, "MdOutlineFlip", ()=>MdOutlineFlip);
parcelHelpers.export(exports, "MdOutlineGradient", ()=>MdOutlineGradient);
parcelHelpers.export(exports, "MdOutlineGrain", ()=>MdOutlineGrain);
parcelHelpers.export(exports, "MdOutlineGridOff", ()=>MdOutlineGridOff);
parcelHelpers.export(exports, "MdOutlineGridOn", ()=>MdOutlineGridOn);
parcelHelpers.export(exports, "MdOutlineHdrEnhancedSelect", ()=>MdOutlineHdrEnhancedSelect);
parcelHelpers.export(exports, "MdOutlineHdrOff", ()=>MdOutlineHdrOff);
parcelHelpers.export(exports, "MdOutlineHdrOn", ()=>MdOutlineHdrOn);
parcelHelpers.export(exports, "MdOutlineHdrPlus", ()=>MdOutlineHdrPlus);
parcelHelpers.export(exports, "MdOutlineHdrStrong", ()=>MdOutlineHdrStrong);
parcelHelpers.export(exports, "MdOutlineHdrWeak", ()=>MdOutlineHdrWeak);
parcelHelpers.export(exports, "MdOutlineHealing", ()=>MdOutlineHealing);
parcelHelpers.export(exports, "MdOutlineHevc", ()=>MdOutlineHevc);
parcelHelpers.export(exports, "MdOutlineHideImage", ()=>MdOutlineHideImage);
parcelHelpers.export(exports, "MdOutlineImageAspectRatio", ()=>MdOutlineImageAspectRatio);
parcelHelpers.export(exports, "MdOutlineImageNotSupported", ()=>MdOutlineImageNotSupported);
parcelHelpers.export(exports, "MdOutlineImageSearch", ()=>MdOutlineImageSearch);
parcelHelpers.export(exports, "MdOutlineImage", ()=>MdOutlineImage);
parcelHelpers.export(exports, "MdOutlineIncompleteCircle", ()=>MdOutlineIncompleteCircle);
parcelHelpers.export(exports, "MdOutlineIso", ()=>MdOutlineIso);
parcelHelpers.export(exports, "MdOutlineLandscape", ()=>MdOutlineLandscape);
parcelHelpers.export(exports, "MdOutlineLeakAdd", ()=>MdOutlineLeakAdd);
parcelHelpers.export(exports, "MdOutlineLeakRemove", ()=>MdOutlineLeakRemove);
parcelHelpers.export(exports, "MdOutlineLens", ()=>MdOutlineLens);
parcelHelpers.export(exports, "MdOutlineLinkedCamera", ()=>MdOutlineLinkedCamera);
parcelHelpers.export(exports, "MdOutlineLogoDev", ()=>MdOutlineLogoDev);
parcelHelpers.export(exports, "MdOutlineLooks3", ()=>MdOutlineLooks3);
parcelHelpers.export(exports, "MdOutlineLooks4", ()=>MdOutlineLooks4);
parcelHelpers.export(exports, "MdOutlineLooks5", ()=>MdOutlineLooks5);
parcelHelpers.export(exports, "MdOutlineLooks6", ()=>MdOutlineLooks6);
parcelHelpers.export(exports, "MdOutlineLooksOne", ()=>MdOutlineLooksOne);
parcelHelpers.export(exports, "MdOutlineLooksTwo", ()=>MdOutlineLooksTwo);
parcelHelpers.export(exports, "MdOutlineLooks", ()=>MdOutlineLooks);
parcelHelpers.export(exports, "MdOutlineLoupe", ()=>MdOutlineLoupe);
parcelHelpers.export(exports, "MdOutlineMicExternalOff", ()=>MdOutlineMicExternalOff);
parcelHelpers.export(exports, "MdOutlineMicExternalOn", ()=>MdOutlineMicExternalOn);
parcelHelpers.export(exports, "MdOutlineMonochromePhotos", ()=>MdOutlineMonochromePhotos);
parcelHelpers.export(exports, "MdOutlineMotionPhotosAuto", ()=>MdOutlineMotionPhotosAuto);
parcelHelpers.export(exports, "MdOutlineMotionPhotosOff", ()=>MdOutlineMotionPhotosOff);
parcelHelpers.export(exports, "MdOutlineMotionPhotosOn", ()=>MdOutlineMotionPhotosOn);
parcelHelpers.export(exports, "MdOutlineMotionPhotosPause", ()=>MdOutlineMotionPhotosPause);
parcelHelpers.export(exports, "MdOutlineMotionPhotosPaused", ()=>MdOutlineMotionPhotosPaused);
parcelHelpers.export(exports, "MdOutlineMovieCreation", ()=>MdOutlineMovieCreation);
parcelHelpers.export(exports, "MdOutlineMovieFilter", ()=>MdOutlineMovieFilter);
parcelHelpers.export(exports, "MdOutlineMp", ()=>MdOutlineMp);
parcelHelpers.export(exports, "MdOutlineMusicNote", ()=>MdOutlineMusicNote);
parcelHelpers.export(exports, "MdOutlineMusicOff", ()=>MdOutlineMusicOff);
parcelHelpers.export(exports, "MdOutlineNaturePeople", ()=>MdOutlineNaturePeople);
parcelHelpers.export(exports, "MdOutlineNature", ()=>MdOutlineNature);
parcelHelpers.export(exports, "MdOutlineNavigateBefore", ()=>MdOutlineNavigateBefore);
parcelHelpers.export(exports, "MdOutlineNavigateNext", ()=>MdOutlineNavigateNext);
parcelHelpers.export(exports, "MdOutlinePalette", ()=>MdOutlinePalette);
parcelHelpers.export(exports, "MdOutlinePanoramaFishEye", ()=>MdOutlinePanoramaFishEye);
parcelHelpers.export(exports, "MdOutlinePanoramaHorizontalSelect", ()=>MdOutlinePanoramaHorizontalSelect);
parcelHelpers.export(exports, "MdOutlinePanoramaHorizontal", ()=>MdOutlinePanoramaHorizontal);
parcelHelpers.export(exports, "MdOutlinePanoramaPhotosphereSelect", ()=>MdOutlinePanoramaPhotosphereSelect);
parcelHelpers.export(exports, "MdOutlinePanoramaPhotosphere", ()=>MdOutlinePanoramaPhotosphere);
parcelHelpers.export(exports, "MdOutlinePanoramaVerticalSelect", ()=>MdOutlinePanoramaVerticalSelect);
parcelHelpers.export(exports, "MdOutlinePanoramaVertical", ()=>MdOutlinePanoramaVertical);
parcelHelpers.export(exports, "MdOutlinePanoramaWideAngleSelect", ()=>MdOutlinePanoramaWideAngleSelect);
parcelHelpers.export(exports, "MdOutlinePanoramaWideAngle", ()=>MdOutlinePanoramaWideAngle);
parcelHelpers.export(exports, "MdOutlinePanorama", ()=>MdOutlinePanorama);
parcelHelpers.export(exports, "MdOutlinePhotoAlbum", ()=>MdOutlinePhotoAlbum);
parcelHelpers.export(exports, "MdOutlinePhotoCameraBack", ()=>MdOutlinePhotoCameraBack);
parcelHelpers.export(exports, "MdOutlinePhotoCameraFront", ()=>MdOutlinePhotoCameraFront);
parcelHelpers.export(exports, "MdOutlinePhotoCamera", ()=>MdOutlinePhotoCamera);
parcelHelpers.export(exports, "MdOutlinePhotoFilter", ()=>MdOutlinePhotoFilter);
parcelHelpers.export(exports, "MdOutlinePhotoLibrary", ()=>MdOutlinePhotoLibrary);
parcelHelpers.export(exports, "MdOutlinePhotoSizeSelectActual", ()=>MdOutlinePhotoSizeSelectActual);
parcelHelpers.export(exports, "MdOutlinePhotoSizeSelectLarge", ()=>MdOutlinePhotoSizeSelectLarge);
parcelHelpers.export(exports, "MdOutlinePhotoSizeSelectSmall", ()=>MdOutlinePhotoSizeSelectSmall);
parcelHelpers.export(exports, "MdOutlinePhoto", ()=>MdOutlinePhoto);
parcelHelpers.export(exports, "MdOutlinePictureAsPdf", ()=>MdOutlinePictureAsPdf);
parcelHelpers.export(exports, "MdOutlinePortrait", ()=>MdOutlinePortrait);
parcelHelpers.export(exports, "MdOutlineRawOff", ()=>MdOutlineRawOff);
parcelHelpers.export(exports, "MdOutlineRawOn", ()=>MdOutlineRawOn);
parcelHelpers.export(exports, "MdOutlineReceiptLong", ()=>MdOutlineReceiptLong);
parcelHelpers.export(exports, "MdOutlineRemoveRedEye", ()=>MdOutlineRemoveRedEye);
parcelHelpers.export(exports, "MdOutlineRotate90DegreesCcw", ()=>MdOutlineRotate90DegreesCcw);
parcelHelpers.export(exports, "MdOutlineRotate90DegreesCw", ()=>MdOutlineRotate90DegreesCw);
parcelHelpers.export(exports, "MdOutlineRotateLeft", ()=>MdOutlineRotateLeft);
parcelHelpers.export(exports, "MdOutlineRotateRight", ()=>MdOutlineRotateRight);
parcelHelpers.export(exports, "MdOutlineShutterSpeed", ()=>MdOutlineShutterSpeed);
parcelHelpers.export(exports, "MdOutlineSlideshow", ()=>MdOutlineSlideshow);
parcelHelpers.export(exports, "MdOutlineStraighten", ()=>MdOutlineStraighten);
parcelHelpers.export(exports, "MdOutlineStyle", ()=>MdOutlineStyle);
parcelHelpers.export(exports, "MdOutlineSwitchCamera", ()=>MdOutlineSwitchCamera);
parcelHelpers.export(exports, "MdOutlineSwitchVideo", ()=>MdOutlineSwitchVideo);
parcelHelpers.export(exports, "MdOutlineTagFaces", ()=>MdOutlineTagFaces);
parcelHelpers.export(exports, "MdOutlineTexture", ()=>MdOutlineTexture);
parcelHelpers.export(exports, "MdOutlineThermostatAuto", ()=>MdOutlineThermostatAuto);
parcelHelpers.export(exports, "MdOutlineTimelapse", ()=>MdOutlineTimelapse);
parcelHelpers.export(exports, "MdOutlineTimer10", ()=>MdOutlineTimer10);
parcelHelpers.export(exports, "MdOutlineTimer3", ()=>MdOutlineTimer3);
parcelHelpers.export(exports, "MdOutlineTimerOff", ()=>MdOutlineTimerOff);
parcelHelpers.export(exports, "MdOutlineTimer", ()=>MdOutlineTimer);
parcelHelpers.export(exports, "MdOutlineTonality", ()=>MdOutlineTonality);
parcelHelpers.export(exports, "MdOutlineTransform", ()=>MdOutlineTransform);
parcelHelpers.export(exports, "MdOutlineTune", ()=>MdOutlineTune);
parcelHelpers.export(exports, "MdOutlineVideoCameraBack", ()=>MdOutlineVideoCameraBack);
parcelHelpers.export(exports, "MdOutlineVideoCameraFront", ()=>MdOutlineVideoCameraFront);
parcelHelpers.export(exports, "MdOutlineVideoStable", ()=>MdOutlineVideoStable);
parcelHelpers.export(exports, "MdOutlineViewComfy", ()=>MdOutlineViewComfy);
parcelHelpers.export(exports, "MdOutlineViewCompact", ()=>MdOutlineViewCompact);
parcelHelpers.export(exports, "MdOutlineVignette", ()=>MdOutlineVignette);
parcelHelpers.export(exports, "MdOutlineVrpano", ()=>MdOutlineVrpano);
parcelHelpers.export(exports, "MdOutlineWbAuto", ()=>MdOutlineWbAuto);
parcelHelpers.export(exports, "MdOutlineWbCloudy", ()=>MdOutlineWbCloudy);
parcelHelpers.export(exports, "MdOutlineWbIncandescent", ()=>MdOutlineWbIncandescent);
parcelHelpers.export(exports, "MdOutlineWbIridescent", ()=>MdOutlineWbIridescent);
parcelHelpers.export(exports, "MdOutlineWbShade", ()=>MdOutlineWbShade);
parcelHelpers.export(exports, "MdOutlineWbSunny", ()=>MdOutlineWbSunny);
parcelHelpers.export(exports, "MdOutlineWbTwilight", ()=>MdOutlineWbTwilight);
parcelHelpers.export(exports, "MdOutline360", ()=>MdOutline360);
parcelHelpers.export(exports, "MdOutlineAddBusiness", ()=>MdOutlineAddBusiness);
parcelHelpers.export(exports, "MdOutlineAddLocationAlt", ()=>MdOutlineAddLocationAlt);
parcelHelpers.export(exports, "MdOutlineAddLocation", ()=>MdOutlineAddLocation);
parcelHelpers.export(exports, "MdOutlineAddRoad", ()=>MdOutlineAddRoad);
parcelHelpers.export(exports, "MdOutlineAgriculture", ()=>MdOutlineAgriculture);
parcelHelpers.export(exports, "MdOutlineAirlineStops", ()=>MdOutlineAirlineStops);
parcelHelpers.export(exports, "MdOutlineAirlines", ()=>MdOutlineAirlines);
parcelHelpers.export(exports, "MdOutlineAltRoute", ()=>MdOutlineAltRoute);
parcelHelpers.export(exports, "MdOutlineAtm", ()=>MdOutlineAtm);
parcelHelpers.export(exports, "MdOutlineAttractions", ()=>MdOutlineAttractions);
parcelHelpers.export(exports, "MdOutlineBadge", ()=>MdOutlineBadge);
parcelHelpers.export(exports, "MdOutlineBakeryDining", ()=>MdOutlineBakeryDining);
parcelHelpers.export(exports, "MdOutlineBeenhere", ()=>MdOutlineBeenhere);
parcelHelpers.export(exports, "MdOutlineBikeScooter", ()=>MdOutlineBikeScooter);
parcelHelpers.export(exports, "MdOutlineBreakfastDining", ()=>MdOutlineBreakfastDining);
parcelHelpers.export(exports, "MdOutlineBrunchDining", ()=>MdOutlineBrunchDining);
parcelHelpers.export(exports, "MdOutlineBusAlert", ()=>MdOutlineBusAlert);
parcelHelpers.export(exports, "MdOutlineCarCrash", ()=>MdOutlineCarCrash);
parcelHelpers.export(exports, "MdOutlineCarRental", ()=>MdOutlineCarRental);
parcelHelpers.export(exports, "MdOutlineCarRepair", ()=>MdOutlineCarRepair);
parcelHelpers.export(exports, "MdOutlineCastle", ()=>MdOutlineCastle);
parcelHelpers.export(exports, "MdOutlineCategory", ()=>MdOutlineCategory);
parcelHelpers.export(exports, "MdOutlineCelebration", ()=>MdOutlineCelebration);
parcelHelpers.export(exports, "MdOutlineChurch", ()=>MdOutlineChurch);
parcelHelpers.export(exports, "MdOutlineCleaningServices", ()=>MdOutlineCleaningServices);
parcelHelpers.export(exports, "MdOutlineCompassCalibration", ()=>MdOutlineCompassCalibration);
parcelHelpers.export(exports, "MdOutlineConnectingAirports", ()=>MdOutlineConnectingAirports);
parcelHelpers.export(exports, "MdOutlineCrisisAlert", ()=>MdOutlineCrisisAlert);
parcelHelpers.export(exports, "MdOutlineDeliveryDining", ()=>MdOutlineDeliveryDining);
parcelHelpers.export(exports, "MdOutlineDepartureBoard", ()=>MdOutlineDepartureBoard);
parcelHelpers.export(exports, "MdOutlineDesignServices", ()=>MdOutlineDesignServices);
parcelHelpers.export(exports, "MdOutlineDiamond", ()=>MdOutlineDiamond);
parcelHelpers.export(exports, "MdOutlineDinnerDining", ()=>MdOutlineDinnerDining);
parcelHelpers.export(exports, "MdOutlineDirectionsBike", ()=>MdOutlineDirectionsBike);
parcelHelpers.export(exports, "MdOutlineDirectionsBoatFilled", ()=>MdOutlineDirectionsBoatFilled);
parcelHelpers.export(exports, "MdOutlineDirectionsBoat", ()=>MdOutlineDirectionsBoat);
parcelHelpers.export(exports, "MdOutlineDirectionsBusFilled", ()=>MdOutlineDirectionsBusFilled);
parcelHelpers.export(exports, "MdOutlineDirectionsBus", ()=>MdOutlineDirectionsBus);
parcelHelpers.export(exports, "MdOutlineDirectionsCarFilled", ()=>MdOutlineDirectionsCarFilled);
parcelHelpers.export(exports, "MdOutlineDirectionsCar", ()=>MdOutlineDirectionsCar);
parcelHelpers.export(exports, "MdOutlineDirectionsRailwayFilled", ()=>MdOutlineDirectionsRailwayFilled);
parcelHelpers.export(exports, "MdOutlineDirectionsRailway", ()=>MdOutlineDirectionsRailway);
parcelHelpers.export(exports, "MdOutlineDirectionsRun", ()=>MdOutlineDirectionsRun);
parcelHelpers.export(exports, "MdOutlineDirectionsSubwayFilled", ()=>MdOutlineDirectionsSubwayFilled);
parcelHelpers.export(exports, "MdOutlineDirectionsSubway", ()=>MdOutlineDirectionsSubway);
parcelHelpers.export(exports, "MdOutlineDirectionsTransitFilled", ()=>MdOutlineDirectionsTransitFilled);
parcelHelpers.export(exports, "MdOutlineDirectionsTransit", ()=>MdOutlineDirectionsTransit);
parcelHelpers.export(exports, "MdOutlineDirectionsWalk", ()=>MdOutlineDirectionsWalk);
parcelHelpers.export(exports, "MdOutlineDirections", ()=>MdOutlineDirections);
parcelHelpers.export(exports, "MdOutlineDryCleaning", ()=>MdOutlineDryCleaning);
parcelHelpers.export(exports, "MdOutlineEditAttributes", ()=>MdOutlineEditAttributes);
parcelHelpers.export(exports, "MdOutlineEditLocationAlt", ()=>MdOutlineEditLocationAlt);
parcelHelpers.export(exports, "MdOutlineEditLocation", ()=>MdOutlineEditLocation);
parcelHelpers.export(exports, "MdOutlineEditRoad", ()=>MdOutlineEditRoad);
parcelHelpers.export(exports, "MdOutlineEggAlt", ()=>MdOutlineEggAlt);
parcelHelpers.export(exports, "MdOutlineEgg", ()=>MdOutlineEgg);
parcelHelpers.export(exports, "MdOutlineElectricBike", ()=>MdOutlineElectricBike);
parcelHelpers.export(exports, "MdOutlineElectricCar", ()=>MdOutlineElectricCar);
parcelHelpers.export(exports, "MdOutlineElectricMoped", ()=>MdOutlineElectricMoped);
parcelHelpers.export(exports, "MdOutlineElectricRickshaw", ()=>MdOutlineElectricRickshaw);
parcelHelpers.export(exports, "MdOutlineElectricScooter", ()=>MdOutlineElectricScooter);
parcelHelpers.export(exports, "MdOutlineElectricalServices", ()=>MdOutlineElectricalServices);
parcelHelpers.export(exports, "MdOutlineEmergencyRecording", ()=>MdOutlineEmergencyRecording);
parcelHelpers.export(exports, "MdOutlineEmergencyShare", ()=>MdOutlineEmergencyShare);
parcelHelpers.export(exports, "MdOutlineEmergency", ()=>MdOutlineEmergency);
parcelHelpers.export(exports, "MdOutlineEvStation", ()=>MdOutlineEvStation);
parcelHelpers.export(exports, "MdOutlineFactory", ()=>MdOutlineFactory);
parcelHelpers.export(exports, "MdOutlineFastfood", ()=>MdOutlineFastfood);
parcelHelpers.export(exports, "MdOutlineFestival", ()=>MdOutlineFestival);
parcelHelpers.export(exports, "MdOutlineFireHydrantAlt", ()=>MdOutlineFireHydrantAlt);
parcelHelpers.export(exports, "MdOutlineFireTruck", ()=>MdOutlineFireTruck);
parcelHelpers.export(exports, "MdOutlineFlightClass", ()=>MdOutlineFlightClass);
parcelHelpers.export(exports, "MdOutlineFlight", ()=>MdOutlineFlight);
parcelHelpers.export(exports, "MdOutlineForest", ()=>MdOutlineForest);
parcelHelpers.export(exports, "MdOutlineForkLeft", ()=>MdOutlineForkLeft);
parcelHelpers.export(exports, "MdOutlineForkRight", ()=>MdOutlineForkRight);
parcelHelpers.export(exports, "MdOutlineFort", ()=>MdOutlineFort);
parcelHelpers.export(exports, "MdOutlineHail", ()=>MdOutlineHail);
parcelHelpers.export(exports, "MdOutlineHandyman", ()=>MdOutlineHandyman);
parcelHelpers.export(exports, "MdOutlineHardware", ()=>MdOutlineHardware);
parcelHelpers.export(exports, "MdOutlineHomeRepairService", ()=>MdOutlineHomeRepairService);
parcelHelpers.export(exports, "MdOutlineHotel", ()=>MdOutlineHotel);
parcelHelpers.export(exports, "MdOutlineHvac", ()=>MdOutlineHvac);
parcelHelpers.export(exports, "MdOutlineIcecream", ()=>MdOutlineIcecream);
parcelHelpers.export(exports, "MdOutlineKebabDining", ()=>MdOutlineKebabDining);
parcelHelpers.export(exports, "MdOutlineLayersClear", ()=>MdOutlineLayersClear);
parcelHelpers.export(exports, "MdOutlineLayers", ()=>MdOutlineLayers);
parcelHelpers.export(exports, "MdOutlineLiquor", ()=>MdOutlineLiquor);
parcelHelpers.export(exports, "MdOutlineLocalActivity", ()=>MdOutlineLocalActivity);
parcelHelpers.export(exports, "MdOutlineLocalAirport", ()=>MdOutlineLocalAirport);
parcelHelpers.export(exports, "MdOutlineLocalAtm", ()=>MdOutlineLocalAtm);
parcelHelpers.export(exports, "MdOutlineLocalBar", ()=>MdOutlineLocalBar);
parcelHelpers.export(exports, "MdOutlineLocalCafe", ()=>MdOutlineLocalCafe);
parcelHelpers.export(exports, "MdOutlineLocalCarWash", ()=>MdOutlineLocalCarWash);
parcelHelpers.export(exports, "MdOutlineLocalConvenienceStore", ()=>MdOutlineLocalConvenienceStore);
parcelHelpers.export(exports, "MdOutlineLocalDining", ()=>MdOutlineLocalDining);
parcelHelpers.export(exports, "MdOutlineLocalDrink", ()=>MdOutlineLocalDrink);
parcelHelpers.export(exports, "MdOutlineLocalFireDepartment", ()=>MdOutlineLocalFireDepartment);
parcelHelpers.export(exports, "MdOutlineLocalFlorist", ()=>MdOutlineLocalFlorist);
parcelHelpers.export(exports, "MdOutlineLocalGasStation", ()=>MdOutlineLocalGasStation);
parcelHelpers.export(exports, "MdOutlineLocalGroceryStore", ()=>MdOutlineLocalGroceryStore);
parcelHelpers.export(exports, "MdOutlineLocalHospital", ()=>MdOutlineLocalHospital);
parcelHelpers.export(exports, "MdOutlineLocalHotel", ()=>MdOutlineLocalHotel);
parcelHelpers.export(exports, "MdOutlineLocalLaundryService", ()=>MdOutlineLocalLaundryService);
parcelHelpers.export(exports, "MdOutlineLocalLibrary", ()=>MdOutlineLocalLibrary);
parcelHelpers.export(exports, "MdOutlineLocalMall", ()=>MdOutlineLocalMall);
parcelHelpers.export(exports, "MdOutlineLocalMovies", ()=>MdOutlineLocalMovies);
parcelHelpers.export(exports, "MdOutlineLocalOffer", ()=>MdOutlineLocalOffer);
parcelHelpers.export(exports, "MdOutlineLocalParking", ()=>MdOutlineLocalParking);
parcelHelpers.export(exports, "MdOutlineLocalPharmacy", ()=>MdOutlineLocalPharmacy);
parcelHelpers.export(exports, "MdOutlineLocalPhone", ()=>MdOutlineLocalPhone);
parcelHelpers.export(exports, "MdOutlineLocalPizza", ()=>MdOutlineLocalPizza);
parcelHelpers.export(exports, "MdOutlineLocalPlay", ()=>MdOutlineLocalPlay);
parcelHelpers.export(exports, "MdOutlineLocalPolice", ()=>MdOutlineLocalPolice);
parcelHelpers.export(exports, "MdOutlineLocalPostOffice", ()=>MdOutlineLocalPostOffice);
parcelHelpers.export(exports, "MdOutlineLocalPrintshop", ()=>MdOutlineLocalPrintshop);
parcelHelpers.export(exports, "MdOutlineLocalSee", ()=>MdOutlineLocalSee);
parcelHelpers.export(exports, "MdOutlineLocalShipping", ()=>MdOutlineLocalShipping);
parcelHelpers.export(exports, "MdOutlineLocalTaxi", ()=>MdOutlineLocalTaxi);
parcelHelpers.export(exports, "MdOutlineLunchDining", ()=>MdOutlineLunchDining);
parcelHelpers.export(exports, "MdOutlineMap", ()=>MdOutlineMap);
parcelHelpers.export(exports, "MdOutlineMapsUgc", ()=>MdOutlineMapsUgc);
parcelHelpers.export(exports, "MdOutlineMedicalInformation", ()=>MdOutlineMedicalInformation);
parcelHelpers.export(exports, "MdOutlineMedicalServices", ()=>MdOutlineMedicalServices);
parcelHelpers.export(exports, "MdOutlineMenuBook", ()=>MdOutlineMenuBook);
parcelHelpers.export(exports, "MdOutlineMerge", ()=>MdOutlineMerge);
parcelHelpers.export(exports, "MdOutlineMinorCrash", ()=>MdOutlineMinorCrash);
parcelHelpers.export(exports, "MdOutlineMiscellaneousServices", ()=>MdOutlineMiscellaneousServices);
parcelHelpers.export(exports, "MdOutlineModeOfTravel", ()=>MdOutlineModeOfTravel);
parcelHelpers.export(exports, "MdOutlineMoney", ()=>MdOutlineMoney);
parcelHelpers.export(exports, "MdOutlineMoped", ()=>MdOutlineMoped);
parcelHelpers.export(exports, "MdOutlineMosque", ()=>MdOutlineMosque);
parcelHelpers.export(exports, "MdOutlineMoving", ()=>MdOutlineMoving);
parcelHelpers.export(exports, "MdOutlineMultipleStop", ()=>MdOutlineMultipleStop);
parcelHelpers.export(exports, "MdOutlineMuseum", ()=>MdOutlineMuseum);
parcelHelpers.export(exports, "MdOutlineMyLocation", ()=>MdOutlineMyLocation);
parcelHelpers.export(exports, "MdOutlineNavigation", ()=>MdOutlineNavigation);
parcelHelpers.export(exports, "MdOutlineNearMeDisabled", ()=>MdOutlineNearMeDisabled);
parcelHelpers.export(exports, "MdOutlineNearMe", ()=>MdOutlineNearMe);
parcelHelpers.export(exports, "MdOutlineNightlife", ()=>MdOutlineNightlife);
parcelHelpers.export(exports, "MdOutlineNoCrash", ()=>MdOutlineNoCrash);
parcelHelpers.export(exports, "MdOutlineNoMeals", ()=>MdOutlineNoMeals);
parcelHelpers.export(exports, "MdOutlineNoTransfer", ()=>MdOutlineNoTransfer);
parcelHelpers.export(exports, "MdOutlineNotListedLocation", ()=>MdOutlineNotListedLocation);
parcelHelpers.export(exports, "MdOutlinePark", ()=>MdOutlinePark);
parcelHelpers.export(exports, "MdOutlinePedalBike", ()=>MdOutlinePedalBike);
parcelHelpers.export(exports, "MdOutlinePersonPinCircle", ()=>MdOutlinePersonPinCircle);
parcelHelpers.export(exports, "MdOutlinePersonPin", ()=>MdOutlinePersonPin);
parcelHelpers.export(exports, "MdOutlinePestControlRodent", ()=>MdOutlinePestControlRodent);
parcelHelpers.export(exports, "MdOutlinePestControl", ()=>MdOutlinePestControl);
parcelHelpers.export(exports, "MdOutlinePinDrop", ()=>MdOutlinePinDrop);
parcelHelpers.export(exports, "MdOutlinePlace", ()=>MdOutlinePlace);
parcelHelpers.export(exports, "MdOutlinePlumbing", ()=>MdOutlinePlumbing);
parcelHelpers.export(exports, "MdOutlineRailwayAlert", ()=>MdOutlineRailwayAlert);
parcelHelpers.export(exports, "MdOutlineRamenDining", ()=>MdOutlineRamenDining);
parcelHelpers.export(exports, "MdOutlineRampLeft", ()=>MdOutlineRampLeft);
parcelHelpers.export(exports, "MdOutlineRampRight", ()=>MdOutlineRampRight);
parcelHelpers.export(exports, "MdOutlineRateReview", ()=>MdOutlineRateReview);
parcelHelpers.export(exports, "MdOutlineRemoveRoad", ()=>MdOutlineRemoveRoad);
parcelHelpers.export(exports, "MdOutlineRestaurantMenu", ()=>MdOutlineRestaurantMenu);
parcelHelpers.export(exports, "MdOutlineRestaurant", ()=>MdOutlineRestaurant);
parcelHelpers.export(exports, "MdOutlineRoundaboutLeft", ()=>MdOutlineRoundaboutLeft);
parcelHelpers.export(exports, "MdOutlineRoundaboutRight", ()=>MdOutlineRoundaboutRight);
parcelHelpers.export(exports, "MdOutlineRoute", ()=>MdOutlineRoute);
parcelHelpers.export(exports, "MdOutlineRunCircle", ()=>MdOutlineRunCircle);
parcelHelpers.export(exports, "MdOutlineSafetyCheck", ()=>MdOutlineSafetyCheck);
parcelHelpers.export(exports, "MdOutlineSailing", ()=>MdOutlineSailing);
parcelHelpers.export(exports, "MdOutlineSatellite", ()=>MdOutlineSatellite);
parcelHelpers.export(exports, "MdOutlineScreenRotationAlt", ()=>MdOutlineScreenRotationAlt);
parcelHelpers.export(exports, "MdOutlineSetMeal", ()=>MdOutlineSetMeal);
parcelHelpers.export(exports, "MdOutlineSignpost", ()=>MdOutlineSignpost);
parcelHelpers.export(exports, "MdOutlineSnowmobile", ()=>MdOutlineSnowmobile);
parcelHelpers.export(exports, "MdOutlineSos", ()=>MdOutlineSos);
parcelHelpers.export(exports, "MdOutlineSoupKitchen", ()=>MdOutlineSoupKitchen);
parcelHelpers.export(exports, "MdOutlineStadium", ()=>MdOutlineStadium);
parcelHelpers.export(exports, "MdOutlineStoreMallDirectory", ()=>MdOutlineStoreMallDirectory);
parcelHelpers.export(exports, "MdOutlineStraight", ()=>MdOutlineStraight);
parcelHelpers.export(exports, "MdOutlineStreetview", ()=>MdOutlineStreetview);
parcelHelpers.export(exports, "MdOutlineSubway", ()=>MdOutlineSubway);
parcelHelpers.export(exports, "MdOutlineSynagogue", ()=>MdOutlineSynagogue);
parcelHelpers.export(exports, "MdOutlineTakeoutDining", ()=>MdOutlineTakeoutDining);
parcelHelpers.export(exports, "MdOutlineTaxiAlert", ()=>MdOutlineTaxiAlert);
parcelHelpers.export(exports, "MdOutlineTempleBuddhist", ()=>MdOutlineTempleBuddhist);
parcelHelpers.export(exports, "MdOutlineTempleHindu", ()=>MdOutlineTempleHindu);
parcelHelpers.export(exports, "MdOutlineTerrain", ()=>MdOutlineTerrain);
parcelHelpers.export(exports, "MdOutlineTheaterComedy", ()=>MdOutlineTheaterComedy);
parcelHelpers.export(exports, "MdOutlineTireRepair", ()=>MdOutlineTireRepair);
parcelHelpers.export(exports, "MdOutlineTraffic", ()=>MdOutlineTraffic);
parcelHelpers.export(exports, "MdOutlineTrain", ()=>MdOutlineTrain);
parcelHelpers.export(exports, "MdOutlineTram", ()=>MdOutlineTram);
parcelHelpers.export(exports, "MdOutlineTransferWithinAStation", ()=>MdOutlineTransferWithinAStation);
parcelHelpers.export(exports, "MdOutlineTransitEnterexit", ()=>MdOutlineTransitEnterexit);
parcelHelpers.export(exports, "MdOutlineTripOrigin", ()=>MdOutlineTripOrigin);
parcelHelpers.export(exports, "MdOutlineTurnLeft", ()=>MdOutlineTurnLeft);
parcelHelpers.export(exports, "MdOutlineTurnRight", ()=>MdOutlineTurnRight);
parcelHelpers.export(exports, "MdOutlineTurnSharpLeft", ()=>MdOutlineTurnSharpLeft);
parcelHelpers.export(exports, "MdOutlineTurnSharpRight", ()=>MdOutlineTurnSharpRight);
parcelHelpers.export(exports, "MdOutlineTurnSlightLeft", ()=>MdOutlineTurnSlightLeft);
parcelHelpers.export(exports, "MdOutlineTurnSlightRight", ()=>MdOutlineTurnSlightRight);
parcelHelpers.export(exports, "MdOutlineTwoWheeler", ()=>MdOutlineTwoWheeler);
parcelHelpers.export(exports, "MdOutlineUTurnLeft", ()=>MdOutlineUTurnLeft);
parcelHelpers.export(exports, "MdOutlineUTurnRight", ()=>MdOutlineUTurnRight);
parcelHelpers.export(exports, "MdOutlineVolunteerActivism", ()=>MdOutlineVolunteerActivism);
parcelHelpers.export(exports, "MdOutlineWarehouse", ()=>MdOutlineWarehouse);
parcelHelpers.export(exports, "MdOutlineWineBar", ()=>MdOutlineWineBar);
parcelHelpers.export(exports, "MdOutlineWrongLocation", ()=>MdOutlineWrongLocation);
parcelHelpers.export(exports, "MdOutlineZoomInMap", ()=>MdOutlineZoomInMap);
parcelHelpers.export(exports, "MdOutlineZoomOutMap", ()=>MdOutlineZoomOutMap);
parcelHelpers.export(exports, "MdOutlineAddHomeWork", ()=>MdOutlineAddHomeWork);
parcelHelpers.export(exports, "MdOutlineAppSettingsAlt", ()=>MdOutlineAppSettingsAlt);
parcelHelpers.export(exports, "MdOutlineAppsOutage", ()=>MdOutlineAppsOutage);
parcelHelpers.export(exports, "MdOutlineApps", ()=>MdOutlineApps);
parcelHelpers.export(exports, "MdOutlineArrowBackIosNew", ()=>MdOutlineArrowBackIosNew);
parcelHelpers.export(exports, "MdOutlineArrowBackIos", ()=>MdOutlineArrowBackIos);
parcelHelpers.export(exports, "MdOutlineArrowBack", ()=>MdOutlineArrowBack);
parcelHelpers.export(exports, "MdOutlineArrowDownward", ()=>MdOutlineArrowDownward);
parcelHelpers.export(exports, "MdOutlineArrowDropDownCircle", ()=>MdOutlineArrowDropDownCircle);
parcelHelpers.export(exports, "MdOutlineArrowDropDown", ()=>MdOutlineArrowDropDown);
parcelHelpers.export(exports, "MdOutlineArrowDropUp", ()=>MdOutlineArrowDropUp);
parcelHelpers.export(exports, "MdOutlineArrowForwardIos", ()=>MdOutlineArrowForwardIos);
parcelHelpers.export(exports, "MdOutlineArrowForward", ()=>MdOutlineArrowForward);
parcelHelpers.export(exports, "MdOutlineArrowLeft", ()=>MdOutlineArrowLeft);
parcelHelpers.export(exports, "MdOutlineArrowRight", ()=>MdOutlineArrowRight);
parcelHelpers.export(exports, "MdOutlineArrowUpward", ()=>MdOutlineArrowUpward);
parcelHelpers.export(exports, "MdOutlineAssistantDirection", ()=>MdOutlineAssistantDirection);
parcelHelpers.export(exports, "MdOutlineCampaign", ()=>MdOutlineCampaign);
parcelHelpers.export(exports, "MdOutlineCancel", ()=>MdOutlineCancel);
parcelHelpers.export(exports, "MdOutlineCheck", ()=>MdOutlineCheck);
parcelHelpers.export(exports, "MdOutlineChevronLeft", ()=>MdOutlineChevronLeft);
parcelHelpers.export(exports, "MdOutlineChevronRight", ()=>MdOutlineChevronRight);
parcelHelpers.export(exports, "MdOutlineClose", ()=>MdOutlineClose);
parcelHelpers.export(exports, "MdOutlineDoubleArrow", ()=>MdOutlineDoubleArrow);
parcelHelpers.export(exports, "MdOutlineEast", ()=>MdOutlineEast);
parcelHelpers.export(exports, "MdOutlineExpandCircleDown", ()=>MdOutlineExpandCircleDown);
parcelHelpers.export(exports, "MdOutlineExpandLess", ()=>MdOutlineExpandLess);
parcelHelpers.export(exports, "MdOutlineExpandMore", ()=>MdOutlineExpandMore);
parcelHelpers.export(exports, "MdOutlineFirstPage", ()=>MdOutlineFirstPage);
parcelHelpers.export(exports, "MdOutlineFullscreenExit", ()=>MdOutlineFullscreenExit);
parcelHelpers.export(exports, "MdOutlineFullscreen", ()=>MdOutlineFullscreen);
parcelHelpers.export(exports, "MdOutlineHomeWork", ()=>MdOutlineHomeWork);
parcelHelpers.export(exports, "MdOutlineLastPage", ()=>MdOutlineLastPage);
parcelHelpers.export(exports, "MdOutlineLegendToggle", ()=>MdOutlineLegendToggle);
parcelHelpers.export(exports, "MdOutlineMapsHomeWork", ()=>MdOutlineMapsHomeWork);
parcelHelpers.export(exports, "MdOutlineMenuOpen", ()=>MdOutlineMenuOpen);
parcelHelpers.export(exports, "MdOutlineMenu", ()=>MdOutlineMenu);
parcelHelpers.export(exports, "MdOutlineMoreHoriz", ()=>MdOutlineMoreHoriz);
parcelHelpers.export(exports, "MdOutlineMoreVert", ()=>MdOutlineMoreVert);
parcelHelpers.export(exports, "MdOutlineNorthEast", ()=>MdOutlineNorthEast);
parcelHelpers.export(exports, "MdOutlineNorthWest", ()=>MdOutlineNorthWest);
parcelHelpers.export(exports, "MdOutlineNorth", ()=>MdOutlineNorth);
parcelHelpers.export(exports, "MdOutlineOfflineShare", ()=>MdOutlineOfflineShare);
parcelHelpers.export(exports, "MdOutlinePayments", ()=>MdOutlinePayments);
parcelHelpers.export(exports, "MdOutlinePivotTableChart", ()=>MdOutlinePivotTableChart);
parcelHelpers.export(exports, "MdOutlineRefresh", ()=>MdOutlineRefresh);
parcelHelpers.export(exports, "MdOutlineSouthEast", ()=>MdOutlineSouthEast);
parcelHelpers.export(exports, "MdOutlineSouthWest", ()=>MdOutlineSouthWest);
parcelHelpers.export(exports, "MdOutlineSouth", ()=>MdOutlineSouth);
parcelHelpers.export(exports, "MdOutlineSubdirectoryArrowLeft", ()=>MdOutlineSubdirectoryArrowLeft);
parcelHelpers.export(exports, "MdOutlineSubdirectoryArrowRight", ()=>MdOutlineSubdirectoryArrowRight);
parcelHelpers.export(exports, "MdOutlineSwitchLeft", ()=>MdOutlineSwitchLeft);
parcelHelpers.export(exports, "MdOutlineSwitchRight", ()=>MdOutlineSwitchRight);
parcelHelpers.export(exports, "MdOutlineUnfoldLess", ()=>MdOutlineUnfoldLess);
parcelHelpers.export(exports, "MdOutlineUnfoldMore", ()=>MdOutlineUnfoldMore);
parcelHelpers.export(exports, "MdOutlineWaterfallChart", ()=>MdOutlineWaterfallChart);
parcelHelpers.export(exports, "MdOutlineWest", ()=>MdOutlineWest);
parcelHelpers.export(exports, "MdOutlineAccountTree", ()=>MdOutlineAccountTree);
parcelHelpers.export(exports, "MdOutlineAdb", ()=>MdOutlineAdb);
parcelHelpers.export(exports, "MdOutlineAirlineSeatFlatAngled", ()=>MdOutlineAirlineSeatFlatAngled);
parcelHelpers.export(exports, "MdOutlineAirlineSeatFlat", ()=>MdOutlineAirlineSeatFlat);
parcelHelpers.export(exports, "MdOutlineAirlineSeatIndividualSuite", ()=>MdOutlineAirlineSeatIndividualSuite);
parcelHelpers.export(exports, "MdOutlineAirlineSeatLegroomExtra", ()=>MdOutlineAirlineSeatLegroomExtra);
parcelHelpers.export(exports, "MdOutlineAirlineSeatLegroomNormal", ()=>MdOutlineAirlineSeatLegroomNormal);
parcelHelpers.export(exports, "MdOutlineAirlineSeatLegroomReduced", ()=>MdOutlineAirlineSeatLegroomReduced);
parcelHelpers.export(exports, "MdOutlineAirlineSeatReclineExtra", ()=>MdOutlineAirlineSeatReclineExtra);
parcelHelpers.export(exports, "MdOutlineAirlineSeatReclineNormal", ()=>MdOutlineAirlineSeatReclineNormal);
parcelHelpers.export(exports, "MdOutlineBluetoothAudio", ()=>MdOutlineBluetoothAudio);
parcelHelpers.export(exports, "MdOutlineConfirmationNumber", ()=>MdOutlineConfirmationNumber);
parcelHelpers.export(exports, "MdOutlineDirectionsOff", ()=>MdOutlineDirectionsOff);
parcelHelpers.export(exports, "MdOutlineDiscFull", ()=>MdOutlineDiscFull);
parcelHelpers.export(exports, "MdOutlineDoDisturbAlt", ()=>MdOutlineDoDisturbAlt);
parcelHelpers.export(exports, "MdOutlineDoDisturbOff", ()=>MdOutlineDoDisturbOff);
parcelHelpers.export(exports, "MdOutlineDoDisturbOn", ()=>MdOutlineDoDisturbOn);
parcelHelpers.export(exports, "MdOutlineDoDisturb", ()=>MdOutlineDoDisturb);
parcelHelpers.export(exports, "MdOutlineDoNotDisturbAlt", ()=>MdOutlineDoNotDisturbAlt);
parcelHelpers.export(exports, "MdOutlineDoNotDisturbOff", ()=>MdOutlineDoNotDisturbOff);
parcelHelpers.export(exports, "MdOutlineDoNotDisturbOn", ()=>MdOutlineDoNotDisturbOn);
parcelHelpers.export(exports, "MdOutlineDoNotDisturb", ()=>MdOutlineDoNotDisturb);
parcelHelpers.export(exports, "MdOutlineDriveEta", ()=>MdOutlineDriveEta);
parcelHelpers.export(exports, "MdOutlineEnhancedEncryption", ()=>MdOutlineEnhancedEncryption);
parcelHelpers.export(exports, "MdOutlineEventAvailable", ()=>MdOutlineEventAvailable);
parcelHelpers.export(exports, "MdOutlineEventBusy", ()=>MdOutlineEventBusy);
parcelHelpers.export(exports, "MdOutlineEventNote", ()=>MdOutlineEventNote);
parcelHelpers.export(exports, "MdOutlineFolderSpecial", ()=>MdOutlineFolderSpecial);
parcelHelpers.export(exports, "MdOutlineImagesearchRoller", ()=>MdOutlineImagesearchRoller);
parcelHelpers.export(exports, "MdOutlineLiveTv", ()=>MdOutlineLiveTv);
parcelHelpers.export(exports, "MdOutlineMms", ()=>MdOutlineMms);
parcelHelpers.export(exports, "MdOutlineMore", ()=>MdOutlineMore);
parcelHelpers.export(exports, "MdOutlineNetworkCheck", ()=>MdOutlineNetworkCheck);
parcelHelpers.export(exports, "MdOutlineNetworkLocked", ()=>MdOutlineNetworkLocked);
parcelHelpers.export(exports, "MdOutlineNoEncryptionGmailerrorred", ()=>MdOutlineNoEncryptionGmailerrorred);
parcelHelpers.export(exports, "MdOutlineNoEncryption", ()=>MdOutlineNoEncryption);
parcelHelpers.export(exports, "MdOutlineOndemandVideo", ()=>MdOutlineOndemandVideo);
parcelHelpers.export(exports, "MdOutlinePersonalVideo", ()=>MdOutlinePersonalVideo);
parcelHelpers.export(exports, "MdOutlinePhoneBluetoothSpeaker", ()=>MdOutlinePhoneBluetoothSpeaker);
parcelHelpers.export(exports, "MdOutlinePhoneCallback", ()=>MdOutlinePhoneCallback);
parcelHelpers.export(exports, "MdOutlinePhoneForwarded", ()=>MdOutlinePhoneForwarded);
parcelHelpers.export(exports, "MdOutlinePhoneInTalk", ()=>MdOutlinePhoneInTalk);
parcelHelpers.export(exports, "MdOutlinePhoneLocked", ()=>MdOutlinePhoneLocked);
parcelHelpers.export(exports, "MdOutlinePhoneMissed", ()=>MdOutlinePhoneMissed);
parcelHelpers.export(exports, "MdOutlinePhonePaused", ()=>MdOutlinePhonePaused);
parcelHelpers.export(exports, "MdOutlinePowerOff", ()=>MdOutlinePowerOff);
parcelHelpers.export(exports, "MdOutlinePower", ()=>MdOutlinePower);
parcelHelpers.export(exports, "MdOutlinePriorityHigh", ()=>MdOutlinePriorityHigh);
parcelHelpers.export(exports, "MdOutlineRunningWithErrors", ()=>MdOutlineRunningWithErrors);
parcelHelpers.export(exports, "MdOutlineSdCardAlert", ()=>MdOutlineSdCardAlert);
parcelHelpers.export(exports, "MdOutlineSdCard", ()=>MdOutlineSdCard);
parcelHelpers.export(exports, "MdOutlineSimCardAlert", ()=>MdOutlineSimCardAlert);
parcelHelpers.export(exports, "MdOutlineSmsFailed", ()=>MdOutlineSmsFailed);
parcelHelpers.export(exports, "MdOutlineSms", ()=>MdOutlineSms);
parcelHelpers.export(exports, "MdOutlineSupportAgent", ()=>MdOutlineSupportAgent);
parcelHelpers.export(exports, "MdOutlineSyncDisabled", ()=>MdOutlineSyncDisabled);
parcelHelpers.export(exports, "MdOutlineSyncLock", ()=>MdOutlineSyncLock);
parcelHelpers.export(exports, "MdOutlineSyncProblem", ()=>MdOutlineSyncProblem);
parcelHelpers.export(exports, "MdOutlineSync", ()=>MdOutlineSync);
parcelHelpers.export(exports, "MdOutlineSystemUpdate", ()=>MdOutlineSystemUpdate);
parcelHelpers.export(exports, "MdOutlineTapAndPlay", ()=>MdOutlineTapAndPlay);
parcelHelpers.export(exports, "MdOutlineTimeToLeave", ()=>MdOutlineTimeToLeave);
parcelHelpers.export(exports, "MdOutlineTvOff", ()=>MdOutlineTvOff);
parcelHelpers.export(exports, "MdOutlineVibration", ()=>MdOutlineVibration);
parcelHelpers.export(exports, "MdOutlineVideoChat", ()=>MdOutlineVideoChat);
parcelHelpers.export(exports, "MdOutlineVoiceChat", ()=>MdOutlineVoiceChat);
parcelHelpers.export(exports, "MdOutlineVpnLock", ()=>MdOutlineVpnLock);
parcelHelpers.export(exports, "MdOutlineWc", ()=>MdOutlineWc);
parcelHelpers.export(exports, "MdOutlineWifiOff", ()=>MdOutlineWifiOff);
parcelHelpers.export(exports, "MdOutlineWifi", ()=>MdOutlineWifi);
parcelHelpers.export(exports, "MdOutlineAcUnit", ()=>MdOutlineAcUnit);
parcelHelpers.export(exports, "MdOutlineAirportShuttle", ()=>MdOutlineAirportShuttle);
parcelHelpers.export(exports, "MdOutlineAllInclusive", ()=>MdOutlineAllInclusive);
parcelHelpers.export(exports, "MdOutlineApartment", ()=>MdOutlineApartment);
parcelHelpers.export(exports, "MdOutlineBabyChangingStation", ()=>MdOutlineBabyChangingStation);
parcelHelpers.export(exports, "MdOutlineBackpack", ()=>MdOutlineBackpack);
parcelHelpers.export(exports, "MdOutlineBalcony", ()=>MdOutlineBalcony);
parcelHelpers.export(exports, "MdOutlineBathtub", ()=>MdOutlineBathtub);
parcelHelpers.export(exports, "MdOutlineBeachAccess", ()=>MdOutlineBeachAccess);
parcelHelpers.export(exports, "MdOutlineBento", ()=>MdOutlineBento);
parcelHelpers.export(exports, "MdOutlineBungalow", ()=>MdOutlineBungalow);
parcelHelpers.export(exports, "MdOutlineBusinessCenter", ()=>MdOutlineBusinessCenter);
parcelHelpers.export(exports, "MdOutlineCabin", ()=>MdOutlineCabin);
parcelHelpers.export(exports, "MdOutlineCarpenter", ()=>MdOutlineCarpenter);
parcelHelpers.export(exports, "MdOutlineCasino", ()=>MdOutlineCasino);
parcelHelpers.export(exports, "MdOutlineChalet", ()=>MdOutlineChalet);
parcelHelpers.export(exports, "MdOutlineChargingStation", ()=>MdOutlineChargingStation);
parcelHelpers.export(exports, "MdOutlineCheckroom", ()=>MdOutlineCheckroom);
parcelHelpers.export(exports, "MdOutlineChildCare", ()=>MdOutlineChildCare);
parcelHelpers.export(exports, "MdOutlineChildFriendly", ()=>MdOutlineChildFriendly);
parcelHelpers.export(exports, "MdOutlineCorporateFare", ()=>MdOutlineCorporateFare);
parcelHelpers.export(exports, "MdOutlineCottage", ()=>MdOutlineCottage);
parcelHelpers.export(exports, "MdOutlineCountertops", ()=>MdOutlineCountertops);
parcelHelpers.export(exports, "MdOutlineCrib", ()=>MdOutlineCrib);
parcelHelpers.export(exports, "MdOutlineDesk", ()=>MdOutlineDesk);
parcelHelpers.export(exports, "MdOutlineDoNotStep", ()=>MdOutlineDoNotStep);
parcelHelpers.export(exports, "MdOutlineDoNotTouch", ()=>MdOutlineDoNotTouch);
parcelHelpers.export(exports, "MdOutlineDry", ()=>MdOutlineDry);
parcelHelpers.export(exports, "MdOutlineElevator", ()=>MdOutlineElevator);
parcelHelpers.export(exports, "MdOutlineEscalatorWarning", ()=>MdOutlineEscalatorWarning);
parcelHelpers.export(exports, "MdOutlineEscalator", ()=>MdOutlineEscalator);
parcelHelpers.export(exports, "MdOutlineFamilyRestroom", ()=>MdOutlineFamilyRestroom);
parcelHelpers.export(exports, "MdOutlineFence", ()=>MdOutlineFence);
parcelHelpers.export(exports, "MdOutlineFireExtinguisher", ()=>MdOutlineFireExtinguisher);
parcelHelpers.export(exports, "MdOutlineFitnessCenter", ()=>MdOutlineFitnessCenter);
parcelHelpers.export(exports, "MdOutlineFoodBank", ()=>MdOutlineFoodBank);
parcelHelpers.export(exports, "MdOutlineFoundation", ()=>MdOutlineFoundation);
parcelHelpers.export(exports, "MdOutlineFreeBreakfast", ()=>MdOutlineFreeBreakfast);
parcelHelpers.export(exports, "MdOutlineGite", ()=>MdOutlineGite);
parcelHelpers.export(exports, "MdOutlineGolfCourse", ()=>MdOutlineGolfCourse);
parcelHelpers.export(exports, "MdOutlineGrass", ()=>MdOutlineGrass);
parcelHelpers.export(exports, "MdOutlineHolidayVillage", ()=>MdOutlineHolidayVillage);
parcelHelpers.export(exports, "MdOutlineHotTub", ()=>MdOutlineHotTub);
parcelHelpers.export(exports, "MdOutlineHouseSiding", ()=>MdOutlineHouseSiding);
parcelHelpers.export(exports, "MdOutlineHouse", ()=>MdOutlineHouse);
parcelHelpers.export(exports, "MdOutlineHouseboat", ()=>MdOutlineHouseboat);
parcelHelpers.export(exports, "MdOutlineIron", ()=>MdOutlineIron);
parcelHelpers.export(exports, "MdOutlineKitchen", ()=>MdOutlineKitchen);
parcelHelpers.export(exports, "MdOutlineMeetingRoom", ()=>MdOutlineMeetingRoom);
parcelHelpers.export(exports, "MdOutlineMicrowave", ()=>MdOutlineMicrowave);
parcelHelpers.export(exports, "MdOutlineNightShelter", ()=>MdOutlineNightShelter);
parcelHelpers.export(exports, "MdOutlineNoBackpack", ()=>MdOutlineNoBackpack);
parcelHelpers.export(exports, "MdOutlineNoCell", ()=>MdOutlineNoCell);
parcelHelpers.export(exports, "MdOutlineNoDrinks", ()=>MdOutlineNoDrinks);
parcelHelpers.export(exports, "MdOutlineNoFlash", ()=>MdOutlineNoFlash);
parcelHelpers.export(exports, "MdOutlineNoFood", ()=>MdOutlineNoFood);
parcelHelpers.export(exports, "MdOutlineNoMeetingRoom", ()=>MdOutlineNoMeetingRoom);
parcelHelpers.export(exports, "MdOutlineNoPhotography", ()=>MdOutlineNoPhotography);
parcelHelpers.export(exports, "MdOutlineNoStroller", ()=>MdOutlineNoStroller);
parcelHelpers.export(exports, "MdOutlineOtherHouses", ()=>MdOutlineOtherHouses);
parcelHelpers.export(exports, "MdOutlinePool", ()=>MdOutlinePool);
parcelHelpers.export(exports, "MdOutlineRiceBowl", ()=>MdOutlineRiceBowl);
parcelHelpers.export(exports, "MdOutlineRoofing", ()=>MdOutlineRoofing);
parcelHelpers.export(exports, "MdOutlineRoomPreferences", ()=>MdOutlineRoomPreferences);
parcelHelpers.export(exports, "MdOutlineRoomService", ()=>MdOutlineRoomService);
parcelHelpers.export(exports, "MdOutlineRvHookup", ()=>MdOutlineRvHookup);
parcelHelpers.export(exports, "MdOutlineSmokeFree", ()=>MdOutlineSmokeFree);
parcelHelpers.export(exports, "MdOutlineSmokingRooms", ()=>MdOutlineSmokingRooms);
parcelHelpers.export(exports, "MdOutlineSoap", ()=>MdOutlineSoap);
parcelHelpers.export(exports, "MdOutlineSpa", ()=>MdOutlineSpa);
parcelHelpers.export(exports, "MdOutlineSportsBar", ()=>MdOutlineSportsBar);
parcelHelpers.export(exports, "MdOutlineStairs", ()=>MdOutlineStairs);
parcelHelpers.export(exports, "MdOutlineStorefront", ()=>MdOutlineStorefront);
parcelHelpers.export(exports, "MdOutlineStroller", ()=>MdOutlineStroller);
parcelHelpers.export(exports, "MdOutlineTapas", ()=>MdOutlineTapas);
parcelHelpers.export(exports, "MdOutlineTty", ()=>MdOutlineTty);
parcelHelpers.export(exports, "MdOutlineUmbrella", ()=>MdOutlineUmbrella);
parcelHelpers.export(exports, "MdOutlineVapeFree", ()=>MdOutlineVapeFree);
parcelHelpers.export(exports, "MdOutlineVapingRooms", ()=>MdOutlineVapingRooms);
parcelHelpers.export(exports, "MdOutlineVilla", ()=>MdOutlineVilla);
parcelHelpers.export(exports, "MdOutlineWash", ()=>MdOutlineWash);
parcelHelpers.export(exports, "MdOutlineWaterDamage", ()=>MdOutlineWaterDamage);
parcelHelpers.export(exports, "MdOutlineWheelchairPickup", ()=>MdOutlineWheelchairPickup);
parcelHelpers.export(exports, "MdOutlineBathroom", ()=>MdOutlineBathroom);
parcelHelpers.export(exports, "MdOutlineBed", ()=>MdOutlineBed);
parcelHelpers.export(exports, "MdOutlineBedroomBaby", ()=>MdOutlineBedroomBaby);
parcelHelpers.export(exports, "MdOutlineBedroomChild", ()=>MdOutlineBedroomChild);
parcelHelpers.export(exports, "MdOutlineBedroomParent", ()=>MdOutlineBedroomParent);
parcelHelpers.export(exports, "MdOutlineBlender", ()=>MdOutlineBlender);
parcelHelpers.export(exports, "MdOutlineCameraIndoor", ()=>MdOutlineCameraIndoor);
parcelHelpers.export(exports, "MdOutlineCameraOutdoor", ()=>MdOutlineCameraOutdoor);
parcelHelpers.export(exports, "MdOutlineChairAlt", ()=>MdOutlineChairAlt);
parcelHelpers.export(exports, "MdOutlineChair", ()=>MdOutlineChair);
parcelHelpers.export(exports, "MdOutlineCoffeeMaker", ()=>MdOutlineCoffeeMaker);
parcelHelpers.export(exports, "MdOutlineCoffee", ()=>MdOutlineCoffee);
parcelHelpers.export(exports, "MdOutlineDining", ()=>MdOutlineDining);
parcelHelpers.export(exports, "MdOutlineDoorBack", ()=>MdOutlineDoorBack);
parcelHelpers.export(exports, "MdOutlineDoorFront", ()=>MdOutlineDoorFront);
parcelHelpers.export(exports, "MdOutlineDoorSliding", ()=>MdOutlineDoorSliding);
parcelHelpers.export(exports, "MdOutlineDoorbell", ()=>MdOutlineDoorbell);
parcelHelpers.export(exports, "MdOutlineFeed", ()=>MdOutlineFeed);
parcelHelpers.export(exports, "MdOutlineFlatware", ()=>MdOutlineFlatware);
parcelHelpers.export(exports, "MdOutlineGarage", ()=>MdOutlineGarage);
parcelHelpers.export(exports, "MdOutlineLight", ()=>MdOutlineLight);
parcelHelpers.export(exports, "MdOutlineLiving", ()=>MdOutlineLiving);
parcelHelpers.export(exports, "MdOutlineManageSearch", ()=>MdOutlineManageSearch);
parcelHelpers.export(exports, "MdOutlinePodcasts", ()=>MdOutlinePodcasts);
parcelHelpers.export(exports, "MdOutlineShower", ()=>MdOutlineShower);
parcelHelpers.export(exports, "MdOutlineTableBar", ()=>MdOutlineTableBar);
parcelHelpers.export(exports, "MdOutlineTableRestaurant", ()=>MdOutlineTableRestaurant);
parcelHelpers.export(exports, "MdOutlineWindow", ()=>MdOutlineWindow);
parcelHelpers.export(exports, "MdOutlineYard", ()=>MdOutlineYard);
parcelHelpers.export(exports, "MdOutline18UpRating", ()=>MdOutline18UpRating);
parcelHelpers.export(exports, "MdOutline6FtApart", ()=>MdOutline6FtApart);
parcelHelpers.export(exports, "MdOutlineAddModerator", ()=>MdOutlineAddModerator);
parcelHelpers.export(exports, "MdOutlineAddReaction", ()=>MdOutlineAddReaction);
parcelHelpers.export(exports, "MdOutlineArchitecture", ()=>MdOutlineArchitecture);
parcelHelpers.export(exports, "MdOutlineAssistWalker", ()=>MdOutlineAssistWalker);
parcelHelpers.export(exports, "MdOutlineBackHand", ()=>MdOutlineBackHand);
parcelHelpers.export(exports, "MdOutlineBlind", ()=>MdOutlineBlind);
parcelHelpers.export(exports, "MdOutlineBoy", ()=>MdOutlineBoy);
parcelHelpers.export(exports, "MdOutlineCake", ()=>MdOutlineCake);
parcelHelpers.export(exports, "MdOutlineCatchingPokemon", ()=>MdOutlineCatchingPokemon);
parcelHelpers.export(exports, "MdOutlineCleanHands", ()=>MdOutlineCleanHands);
parcelHelpers.export(exports, "MdOutlineCo2", ()=>MdOutlineCo2);
parcelHelpers.export(exports, "MdOutlineCompost", ()=>MdOutlineCompost);
parcelHelpers.export(exports, "MdOutlineConnectWithoutContact", ()=>MdOutlineConnectWithoutContact);
parcelHelpers.export(exports, "MdOutlineConstruction", ()=>MdOutlineConstruction);
parcelHelpers.export(exports, "MdOutlineCookie", ()=>MdOutlineCookie);
parcelHelpers.export(exports, "MdOutlineCoronavirus", ()=>MdOutlineCoronavirus);
parcelHelpers.export(exports, "MdOutlineCrueltyFree", ()=>MdOutlineCrueltyFree);
parcelHelpers.export(exports, "MdOutlineCyclone", ()=>MdOutlineCyclone);
parcelHelpers.export(exports, "MdOutlineDeck", ()=>MdOutlineDeck);
parcelHelpers.export(exports, "MdOutlineDiversity1", ()=>MdOutlineDiversity1);
parcelHelpers.export(exports, "MdOutlineDiversity2", ()=>MdOutlineDiversity2);
parcelHelpers.export(exports, "MdOutlineDiversity3", ()=>MdOutlineDiversity3);
parcelHelpers.export(exports, "MdOutlineDomainAdd", ()=>MdOutlineDomainAdd);
parcelHelpers.export(exports, "MdOutlineDomain", ()=>MdOutlineDomain);
parcelHelpers.export(exports, "MdOutlineDownhillSkiing", ()=>MdOutlineDownhillSkiing);
parcelHelpers.export(exports, "MdOutlineEditNotifications", ()=>MdOutlineEditNotifications);
parcelHelpers.export(exports, "MdOutlineElderlyWoman", ()=>MdOutlineElderlyWoman);
parcelHelpers.export(exports, "MdOutlineElderly", ()=>MdOutlineElderly);
parcelHelpers.export(exports, "MdOutlineEmojiEmotions", ()=>MdOutlineEmojiEmotions);
parcelHelpers.export(exports, "MdOutlineEmojiEvents", ()=>MdOutlineEmojiEvents);
parcelHelpers.export(exports, "MdOutlineEmojiFlags", ()=>MdOutlineEmojiFlags);
parcelHelpers.export(exports, "MdOutlineEmojiFoodBeverage", ()=>MdOutlineEmojiFoodBeverage);
parcelHelpers.export(exports, "MdOutlineEmojiNature", ()=>MdOutlineEmojiNature);
parcelHelpers.export(exports, "MdOutlineEmojiObjects", ()=>MdOutlineEmojiObjects);
parcelHelpers.export(exports, "MdOutlineEmojiPeople", ()=>MdOutlineEmojiPeople);
parcelHelpers.export(exports, "MdOutlineEmojiSymbols", ()=>MdOutlineEmojiSymbols);
parcelHelpers.export(exports, "MdOutlineEmojiTransportation", ()=>MdOutlineEmojiTransportation);
parcelHelpers.export(exports, "MdOutlineEngineering", ()=>MdOutlineEngineering);
parcelHelpers.export(exports, "MdOutlineFace2", ()=>MdOutlineFace2);
parcelHelpers.export(exports, "MdOutlineFace3", ()=>MdOutlineFace3);
parcelHelpers.export(exports, "MdOutlineFace4", ()=>MdOutlineFace4);
parcelHelpers.export(exports, "MdOutlineFace5", ()=>MdOutlineFace5);
parcelHelpers.export(exports, "MdOutlineFace6", ()=>MdOutlineFace6);
parcelHelpers.export(exports, "MdOutlineFacebook", ()=>MdOutlineFacebook);
parcelHelpers.export(exports, "MdOutlineFemale", ()=>MdOutlineFemale);
parcelHelpers.export(exports, "MdOutlineFireplace", ()=>MdOutlineFireplace);
parcelHelpers.export(exports, "MdOutlineFitbit", ()=>MdOutlineFitbit);
parcelHelpers.export(exports, "MdOutlineFlood", ()=>MdOutlineFlood);
parcelHelpers.export(exports, "MdOutlineFollowTheSigns", ()=>MdOutlineFollowTheSigns);
parcelHelpers.export(exports, "MdOutlineFrontHand", ()=>MdOutlineFrontHand);
parcelHelpers.export(exports, "MdOutlineGirl", ()=>MdOutlineGirl);
parcelHelpers.export(exports, "MdOutlineGroupAdd", ()=>MdOutlineGroupAdd);
parcelHelpers.export(exports, "MdOutlineGroupOff", ()=>MdOutlineGroupOff);
parcelHelpers.export(exports, "MdOutlineGroupRemove", ()=>MdOutlineGroupRemove);
parcelHelpers.export(exports, "MdOutlineGroup", ()=>MdOutlineGroup);
parcelHelpers.export(exports, "MdOutlineGroups2", ()=>MdOutlineGroups2);
parcelHelpers.export(exports, "MdOutlineGroups3", ()=>MdOutlineGroups3);
parcelHelpers.export(exports, "MdOutlineGroups", ()=>MdOutlineGroups);
parcelHelpers.export(exports, "MdOutlineHandshake", ()=>MdOutlineHandshake);
parcelHelpers.export(exports, "MdOutlineHealthAndSafety", ()=>MdOutlineHealthAndSafety);
parcelHelpers.export(exports, "MdOutlineHeartBroken", ()=>MdOutlineHeartBroken);
parcelHelpers.export(exports, "MdOutlineHiking", ()=>MdOutlineHiking);
parcelHelpers.export(exports, "MdOutlineHistoryEdu", ()=>MdOutlineHistoryEdu);
parcelHelpers.export(exports, "MdOutlineHive", ()=>MdOutlineHive);
parcelHelpers.export(exports, "MdOutlineIceSkating", ()=>MdOutlineIceSkating);
parcelHelpers.export(exports, "MdOutlineInterests", ()=>MdOutlineInterests);
parcelHelpers.export(exports, "MdOutlineIosShare", ()=>MdOutlineIosShare);
parcelHelpers.export(exports, "MdOutlineKayaking", ()=>MdOutlineKayaking);
parcelHelpers.export(exports, "MdOutlineKingBed", ()=>MdOutlineKingBed);
parcelHelpers.export(exports, "MdOutlineKitesurfing", ()=>MdOutlineKitesurfing);
parcelHelpers.export(exports, "MdOutlineLandslide", ()=>MdOutlineLandslide);
parcelHelpers.export(exports, "MdOutlineLocationCity", ()=>MdOutlineLocationCity);
parcelHelpers.export(exports, "MdOutlineLuggage", ()=>MdOutlineLuggage);
parcelHelpers.export(exports, "MdOutlineMale", ()=>MdOutlineMale);
parcelHelpers.export(exports, "MdOutlineMan2", ()=>MdOutlineMan2);
parcelHelpers.export(exports, "MdOutlineMan3", ()=>MdOutlineMan3);
parcelHelpers.export(exports, "MdOutlineMan4", ()=>MdOutlineMan4);
parcelHelpers.export(exports, "MdOutlineMan", ()=>MdOutlineMan);
parcelHelpers.export(exports, "MdOutlineMasks", ()=>MdOutlineMasks);
parcelHelpers.export(exports, "MdOutlineMilitaryTech", ()=>MdOutlineMilitaryTech);
parcelHelpers.export(exports, "MdOutlineMoodBad", ()=>MdOutlineMoodBad);
parcelHelpers.export(exports, "MdOutlineMood", ()=>MdOutlineMood);
parcelHelpers.export(exports, "MdOutlineNightsStay", ()=>MdOutlineNightsStay);
parcelHelpers.export(exports, "MdOutlineNoAdultContent", ()=>MdOutlineNoAdultContent);
parcelHelpers.export(exports, "MdOutlineNoLuggage", ()=>MdOutlineNoLuggage);
parcelHelpers.export(exports, "MdOutlineNordicWalking", ()=>MdOutlineNordicWalking);
parcelHelpers.export(exports, "MdOutlineNotificationAdd", ()=>MdOutlineNotificationAdd);
parcelHelpers.export(exports, "MdOutlineNotificationsActive", ()=>MdOutlineNotificationsActive);
parcelHelpers.export(exports, "MdOutlineNotificationsNone", ()=>MdOutlineNotificationsNone);
parcelHelpers.export(exports, "MdOutlineNotificationsOff", ()=>MdOutlineNotificationsOff);
parcelHelpers.export(exports, "MdOutlineNotificationsPaused", ()=>MdOutlineNotificationsPaused);
parcelHelpers.export(exports, "MdOutlineNotifications", ()=>MdOutlineNotifications);
parcelHelpers.export(exports, "MdOutlineOutdoorGrill", ()=>MdOutlineOutdoorGrill);
parcelHelpers.export(exports, "MdOutlinePages", ()=>MdOutlinePages);
parcelHelpers.export(exports, "MdOutlineParagliding", ()=>MdOutlineParagliding);
parcelHelpers.export(exports, "MdOutlinePartyMode", ()=>MdOutlinePartyMode);
parcelHelpers.export(exports, "MdOutlinePeopleAlt", ()=>MdOutlinePeopleAlt);
parcelHelpers.export(exports, "MdOutlinePeopleOutline", ()=>MdOutlinePeopleOutline);
parcelHelpers.export(exports, "MdOutlinePeople", ()=>MdOutlinePeople);
parcelHelpers.export(exports, "MdOutlinePerson2", ()=>MdOutlinePerson2);
parcelHelpers.export(exports, "MdOutlinePerson3", ()=>MdOutlinePerson3);
parcelHelpers.export(exports, "MdOutlinePerson4", ()=>MdOutlinePerson4);
parcelHelpers.export(exports, "MdOutlinePersonAddAlt1", ()=>MdOutlinePersonAddAlt1);
parcelHelpers.export(exports, "MdOutlinePersonAddAlt", ()=>MdOutlinePersonAddAlt);
parcelHelpers.export(exports, "MdOutlinePersonAdd", ()=>MdOutlinePersonAdd);
parcelHelpers.export(exports, "MdOutlinePersonOff", ()=>MdOutlinePersonOff);
parcelHelpers.export(exports, "MdOutlinePersonOutline", ()=>MdOutlinePersonOutline);
parcelHelpers.export(exports, "MdOutlinePersonRemoveAlt1", ()=>MdOutlinePersonRemoveAlt1);
parcelHelpers.export(exports, "MdOutlinePersonRemove", ()=>MdOutlinePersonRemove);
parcelHelpers.export(exports, "MdOutlinePerson", ()=>MdOutlinePerson);
parcelHelpers.export(exports, "MdOutlinePersonalInjury", ()=>MdOutlinePersonalInjury);
parcelHelpers.export(exports, "MdOutlinePianoOff", ()=>MdOutlinePianoOff);
parcelHelpers.export(exports, "MdOutlinePiano", ()=>MdOutlinePiano);
parcelHelpers.export(exports, "MdOutlinePix", ()=>MdOutlinePix);
parcelHelpers.export(exports, "MdOutlinePlusOne", ()=>MdOutlinePlusOne);
parcelHelpers.export(exports, "MdOutlinePoll", ()=>MdOutlinePoll);
parcelHelpers.export(exports, "MdOutlinePrecisionManufacturing", ()=>MdOutlinePrecisionManufacturing);
parcelHelpers.export(exports, "MdOutlinePsychologyAlt", ()=>MdOutlinePsychologyAlt);
parcelHelpers.export(exports, "MdOutlinePsychology", ()=>MdOutlinePsychology);
parcelHelpers.export(exports, "MdOutlinePublicOff", ()=>MdOutlinePublicOff);
parcelHelpers.export(exports, "MdOutlinePublic", ()=>MdOutlinePublic);
parcelHelpers.export(exports, "MdOutlineRealEstateAgent", ()=>MdOutlineRealEstateAgent);
parcelHelpers.export(exports, "MdOutlineRecommend", ()=>MdOutlineRecommend);
parcelHelpers.export(exports, "MdOutlineRecycling", ()=>MdOutlineRecycling);
parcelHelpers.export(exports, "MdOutlineReduceCapacity", ()=>MdOutlineReduceCapacity);
parcelHelpers.export(exports, "MdOutlineRemoveModerator", ()=>MdOutlineRemoveModerator);
parcelHelpers.export(exports, "MdOutlineRollerSkating", ()=>MdOutlineRollerSkating);
parcelHelpers.export(exports, "MdOutlineSafetyDivider", ()=>MdOutlineSafetyDivider);
parcelHelpers.export(exports, "MdOutlineSanitizer", ()=>MdOutlineSanitizer);
parcelHelpers.export(exports, "MdOutlineScale", ()=>MdOutlineScale);
parcelHelpers.export(exports, "MdOutlineSchool", ()=>MdOutlineSchool);
parcelHelpers.export(exports, "MdOutlineScience", ()=>MdOutlineScience);
parcelHelpers.export(exports, "MdOutlineScoreboard", ()=>MdOutlineScoreboard);
parcelHelpers.export(exports, "MdOutlineScubaDiving", ()=>MdOutlineScubaDiving);
parcelHelpers.export(exports, "MdOutlineSelfImprovement", ()=>MdOutlineSelfImprovement);
parcelHelpers.export(exports, "MdOutlineSentimentDissatisfied", ()=>MdOutlineSentimentDissatisfied);
parcelHelpers.export(exports, "MdOutlineSentimentNeutral", ()=>MdOutlineSentimentNeutral);
parcelHelpers.export(exports, "MdOutlineSentimentSatisfied", ()=>MdOutlineSentimentSatisfied);
parcelHelpers.export(exports, "MdOutlineSentimentVeryDissatisfied", ()=>MdOutlineSentimentVeryDissatisfied);
parcelHelpers.export(exports, "MdOutlineSentimentVerySatisfied", ()=>MdOutlineSentimentVerySatisfied);
parcelHelpers.export(exports, "MdOutlineSevereCold", ()=>MdOutlineSevereCold);
parcelHelpers.export(exports, "MdOutlineShare", ()=>MdOutlineShare);
parcelHelpers.export(exports, "MdOutlineSick", ()=>MdOutlineSick);
parcelHelpers.export(exports, "MdOutlineSignLanguage", ()=>MdOutlineSignLanguage);
parcelHelpers.export(exports, "MdOutlineSingleBed", ()=>MdOutlineSingleBed);
parcelHelpers.export(exports, "MdOutlineSkateboarding", ()=>MdOutlineSkateboarding);
parcelHelpers.export(exports, "MdOutlineSledding", ()=>MdOutlineSledding);
parcelHelpers.export(exports, "MdOutlineSnowboarding", ()=>MdOutlineSnowboarding);
parcelHelpers.export(exports, "MdOutlineSnowshoeing", ()=>MdOutlineSnowshoeing);
parcelHelpers.export(exports, "MdOutlineSocialDistance", ()=>MdOutlineSocialDistance);
parcelHelpers.export(exports, "MdOutlineSouthAmerica", ()=>MdOutlineSouthAmerica);
parcelHelpers.export(exports, "MdOutlineSportsBaseball", ()=>MdOutlineSportsBaseball);
parcelHelpers.export(exports, "MdOutlineSportsBasketball", ()=>MdOutlineSportsBasketball);
parcelHelpers.export(exports, "MdOutlineSportsCricket", ()=>MdOutlineSportsCricket);
parcelHelpers.export(exports, "MdOutlineSportsEsports", ()=>MdOutlineSportsEsports);
parcelHelpers.export(exports, "MdOutlineSportsFootball", ()=>MdOutlineSportsFootball);
parcelHelpers.export(exports, "MdOutlineSportsGolf", ()=>MdOutlineSportsGolf);
parcelHelpers.export(exports, "MdOutlineSportsGymnastics", ()=>MdOutlineSportsGymnastics);
parcelHelpers.export(exports, "MdOutlineSportsHandball", ()=>MdOutlineSportsHandball);
parcelHelpers.export(exports, "MdOutlineSportsHockey", ()=>MdOutlineSportsHockey);
parcelHelpers.export(exports, "MdOutlineSportsKabaddi", ()=>MdOutlineSportsKabaddi);
parcelHelpers.export(exports, "MdOutlineSportsMartialArts", ()=>MdOutlineSportsMartialArts);
parcelHelpers.export(exports, "MdOutlineSportsMma", ()=>MdOutlineSportsMma);
parcelHelpers.export(exports, "MdOutlineSportsMotorsports", ()=>MdOutlineSportsMotorsports);
parcelHelpers.export(exports, "MdOutlineSportsRugby", ()=>MdOutlineSportsRugby);
parcelHelpers.export(exports, "MdOutlineSportsSoccer", ()=>MdOutlineSportsSoccer);
parcelHelpers.export(exports, "MdOutlineSportsTennis", ()=>MdOutlineSportsTennis);
parcelHelpers.export(exports, "MdOutlineSportsVolleyball", ()=>MdOutlineSportsVolleyball);
parcelHelpers.export(exports, "MdOutlineSports", ()=>MdOutlineSports);
parcelHelpers.export(exports, "MdOutlineSurfing", ()=>MdOutlineSurfing);
parcelHelpers.export(exports, "MdOutlineSwitchAccount", ()=>MdOutlineSwitchAccount);
parcelHelpers.export(exports, "MdOutlineThumbDownAlt", ()=>MdOutlineThumbDownAlt);
parcelHelpers.export(exports, "MdOutlineThumbUpAlt", ()=>MdOutlineThumbUpAlt);
parcelHelpers.export(exports, "MdOutlineThunderstorm", ()=>MdOutlineThunderstorm);
parcelHelpers.export(exports, "MdOutlineTornado", ()=>MdOutlineTornado);
parcelHelpers.export(exports, "MdOutlineTransgender", ()=>MdOutlineTransgender);
parcelHelpers.export(exports, "MdOutlineTravelExplore", ()=>MdOutlineTravelExplore);
parcelHelpers.export(exports, "MdOutlineTsunami", ()=>MdOutlineTsunami);
parcelHelpers.export(exports, "MdOutlineVaccines", ()=>MdOutlineVaccines);
parcelHelpers.export(exports, "MdOutlineVolcano", ()=>MdOutlineVolcano);
parcelHelpers.export(exports, "MdOutlineWallet", ()=>MdOutlineWallet);
parcelHelpers.export(exports, "MdOutlineWaterDrop", ()=>MdOutlineWaterDrop);
parcelHelpers.export(exports, "MdOutlineWavingHand", ()=>MdOutlineWavingHand);
parcelHelpers.export(exports, "MdOutlineWhatsapp", ()=>MdOutlineWhatsapp);
parcelHelpers.export(exports, "MdOutlineWhatshot", ()=>MdOutlineWhatshot);
parcelHelpers.export(exports, "MdOutlineWoman2", ()=>MdOutlineWoman2);
parcelHelpers.export(exports, "MdOutlineWoman", ()=>MdOutlineWoman);
parcelHelpers.export(exports, "MdOutlineWorkspacePremium", ()=>MdOutlineWorkspacePremium);
parcelHelpers.export(exports, "MdOutlineCheckBoxOutlineBlank", ()=>MdOutlineCheckBoxOutlineBlank);
parcelHelpers.export(exports, "MdOutlineCheckBox", ()=>MdOutlineCheckBox);
parcelHelpers.export(exports, "MdOutlineIndeterminateCheckBox", ()=>MdOutlineIndeterminateCheckBox);
parcelHelpers.export(exports, "MdOutlineRadioButtonChecked", ()=>MdOutlineRadioButtonChecked);
parcelHelpers.export(exports, "MdOutlineRadioButtonUnchecked", ()=>MdOutlineRadioButtonUnchecked);
parcelHelpers.export(exports, "MdOutlineStarBorderPurple500", ()=>MdOutlineStarBorderPurple500);
parcelHelpers.export(exports, "MdOutlineStarBorder", ()=>MdOutlineStarBorder);
parcelHelpers.export(exports, "MdOutlineStarHalf", ()=>MdOutlineStarHalf);
parcelHelpers.export(exports, "MdOutlineStarOutline", ()=>MdOutlineStarOutline);
parcelHelpers.export(exports, "MdOutlineStarPurple500", ()=>MdOutlineStarPurple500);
parcelHelpers.export(exports, "MdOutlineStar", ()=>MdOutlineStar);
parcelHelpers.export(exports, "MdOutlineToggleOff", ()=>MdOutlineToggleOff);
parcelHelpers.export(exports, "MdOutlineToggleOn", ()=>MdOutlineToggleOn);
var _lib = require("../lib");
function Md123(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15H5.5v-4.5H4V9h3v6zm6.5-1.5h-3v-1h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H9v1.5h3v1h-2c-.55 0-1 .45-1 1V15h4.5v-1.5zm6 .5v-4c0-.55-.45-1-1-1H15v1.5h3v1h-2v1h2v1h-3V15h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function Md3DRotation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.52 21.48A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08a1.07 1.07 0 01-.4-.24c-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56a1.67 1.67 0 00-.23-.51c-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31a2.098 2.098 0 00.89-.75c.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96a1.78 1.78 0 00-.51-.69c-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49a.87.87 0 01-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"
                }
            }
        ]
    })(props);
}
function MdAbc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-1.5v-.5h-2v3h2V13H21v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zM8 10v5H6.5v-1.5h-2V15H3v-5c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zm-1.5.5h-2V12h2v-1.5zm7 1.5c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-4V9h4c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM11 10.5v.75h2v-.75h-2zm2 2.25h-2v.75h2v-.75z"
                }
            }
        ]
    })(props);
}
function MdAccessibilityNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
                }
            }
        ]
    })(props);
}
function MdAccessibleForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "4.54",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C17.42 8.5 16.44 7 14.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L7.22 10l1.92.53L9.79 9H12l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H17v5h2v-5.5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdAccessible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07z"
                }
            }
        ]
    })(props);
}
function MdAccountBalanceWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18v1c0 1.1-.9 2-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14c1.1 0 2 .9 2 2v1h-9a2 2 0 00-2 2v8a2 2 0 002 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdAccountBalance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h3v7H4zM10.5 10h3v7h-3zM2 19h20v3H2zM17 10h3v7h-3zM12 1L2 6v2h20V6z"
                }
            }
        ]
    })(props);
}
function MdAccountBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm7 13H5v-.23c0-.62.28-1.2.76-1.58C7.47 15.82 9.64 15 12 15s4.53.82 6.24 2.19c.48.38.76.97.76 1.58V19z"
                }
            }
        ]
    })(props);
}
function MdAccountCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0112.28 0C16.43 19.18 14.03 20 12 20z"
                }
            }
        ]
    })(props);
}
function MdAddCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h10v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm4 9v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
                }
            }
        ]
    })(props);
}
function MdAddHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c.7 0 1.37.1 2 .29V9l-8-6-8 6v12h7.68A6.995 6.995 0 0118 11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1z"
                }
            }
        ]
    })(props);
}
function MdAddShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm18.31 6l-2.76 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"
                }
            }
        ]
    })(props);
}
function MdAddTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45A10.02 10.02 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72zm7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function MdAddToDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21v-3h3v-2h-3v-3h-2v3h-3v2h3v3h2zm-4.97.5H5.66c-.72 0-1.38-.38-1.73-1l-2.36-4.1c-.36-.62-.35-1.38.01-2L7.92 3.49c.36-.61 1.02-.99 1.73-.99h4.7c.71 0 1.37.38 1.73.99l4.48 7.71a6.176 6.176 0 00-2.4-.14L14.35 4.5h-4.7L3.31 15.41l2.35 4.09h7.89c.35.77.85 1.45 1.48 2zM13.34 15c-.22.63-.34 1.3-.34 2H7.25l-.73-1.27 4.58-7.98h1.8l2.53 4.42c-.56.42-1.05.93-1.44 1.51l-2-3.49L9.25 15h4.09z"
                }
            }
        ]
    })(props);
}
function MdAddchart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3zm-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6zm-4-6v4h2v-4h-2zm-4 4h2V9h-2v8zm-2 0v-6H7v6h2z"
                }
            }
        ]
    })(props);
}
function MdAdminPanelSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12zm0 5.37c-.93 0-1.74-.46-2.24-1.17.05-.72 1.51-1.08 2.24-1.08s2.19.36 2.24 1.08c-.5.71-1.31 1.17-2.24 1.17z"
                }
            }
        ]
    })(props);
}
function MdAdsClick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.71 17.99A5.993 5.993 0 016 12c0-3.31 2.69-6 6-6 3.22 0 5.84 2.53 5.99 5.71l-2.1-.63a3.999 3.999 0 10-4.81 4.81l.63 2.1zM22 12c0 .3-.01.6-.04.9l-1.97-.59c.01-.1.01-.21.01-.31 0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c.1 0 .21 0 .31-.01l.59 1.97c-.3.03-.6.04-.9.04-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10zm-3.77 4.26L22 15l-10-3 3 10 1.26-3.77 4.27 4.27 1.98-1.98-4.28-4.26z"
                }
            }
        ]
    })(props);
}
function MdAlarmAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
                }
            }
        ]
    })(props);
}
function MdAlarmOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92a9 9 0 00-9-9c-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8A8.964 8.964 0 003 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"
                }
            }
        ]
    })(props);
}
function MdAlarmOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
                }
            }
        ]
    })(props);
}
function MdAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdAllInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6h-4c0 1.62-1.38 3-3 3s-3-1.38-3-3H5V5h14v4zm-4 7h6v3c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3z"
                }
            }
        ]
    })(props);
}
function MdAllOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.21.16h24v24h-24z"
                }
            }
        ]
    })(props);
}
function MdAnalytics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-5h2v5zm4 0h-2v-3h2v3zm0-5h-2v-2h2v2zm4 5h-2V7h2v10z"
                }
            }
        ]
    })(props);
}
function MdAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15l1.55 1.55c-.96 1.69-3.33 3.04-5.55 3.37V11h3V9h-3V7.82C14.16 7.4 15 6.3 15 5c0-1.65-1.35-3-3-3S9 3.35 9 5c0 1.3.84 2.4 2 2.82V9H8v2h3v8.92c-2.22-.33-4.59-1.68-5.55-3.37L7 15l-4-3v3c0 3.88 4.92 7 9 7s9-3.12 9-7v-3l-4 3zM12 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 00-.83.22l-1.88 3.24a11.463 11.463 0 00-8.94 0L5.65 5.67a.643.643 0 00-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.78 10.78 0 001 18h22a10.78 10.78 0 00-5.4-8.52zM7 15.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm10 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"
                }
            }
        ]
    })(props);
}
function MdAnnouncement(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12l-2 2-2-2 2-2 2 2zm-2-6l2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6l2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0l-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6l-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z"
                }
            }
        ]
    })(props);
}
function MdAppBlocking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-2.5 4A2.5 2.5 0 0118 9.5c.42 0 .8.11 1.15.29l-3.36 3.36c-.18-.35-.29-.73-.29-1.15zm2.5 2.5c-.42 0-.8-.11-1.15-.29l3.36-3.36c.18.35.29.73.29 1.15a2.5 2.5 0 01-2.5 2.5zM17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1z"
                }
            }
        ]
    })(props);
}
function MdAppShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM20.38 9.62L21 11l.62-1.38L23 9l-1.38-.62L21 7l-.62 1.38L19 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8l-1.25 2.75L12 12l2.75 1.25L16 16l1.25-2.75L20 12l-2.75-1.25zM21 13l-.62 1.38L19 15l1.38.62L21 17l.62-1.38L23 15l-1.38-.62z"
                }
            }
        ]
    })(props);
}
function MdArrowCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 10V8h-2v4H8l4 4 4-4h-3z"
                }
            }
        ]
    })(props);
}
function MdArrowCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm10-1h4v2h-4v3l-4-4 4-4v3z"
                }
            }
        ]
    })(props);
}
function MdArrowCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-10 1H8v-2h4V8l4 4-4 4v-3z"
                }
            }
        ]
    })(props);
}
function MdArrowCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0 2c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm-1-10v4h2v-4h3l-4-4-4 4h3z"
                }
            }
        ]
    })(props);
}
function MdArrowOutward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"
                }
            }
        ]
    })(props);
}
function MdArrowRightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
                }
            }
        ]
    })(props);
}
function MdArticle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function MdAspectRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function MdAssessment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdAssignmentAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.69 15c.36-.75.84-1.43 1.43-2H7v-2h11c1.07 0 2.09.25 3 .69V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6.69c-.44-.91-.69-1.93-.69-3 0-.34.03-.67.08-1H7v-2h4.69zM12 2.75c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM7 7h10v2H7V7z"
                }
            }
        ]
    })(props);
}
function MdAssignmentInd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
                }
            }
        ]
    })(props);
}
function MdAssignmentLate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdAssignmentReturn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
                }
            }
        ]
    })(props);
}
function MdAssignmentReturned(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
                }
            }
        ]
    })(props);
}
function MdAssignmentTurnedIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
                }
            }
        ]
    })(props);
}
function MdAssignment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function MdAssuredWorkload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h2v7H5zM11 10h2v7h-2zM22 6L12 1 2 6v2h20zM2 19v2h12.4c-.21-.64-.32-1.31-.36-2H2zM19 12.26V10h-2v3.26zM20 14l-4 2v2.55c0 2.52 1.71 4.88 4 5.45 2.29-.57 4-2.93 4-5.45V16l-4-2zm-.72 7l-2.03-2.03 1.06-1.06.97.97 2.41-2.38 1.06 1.06L19.28 21z"
                }
            }
        ]
    })(props);
}
function MdAutorenew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 016 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
                }
            }
        ]
    })(props);
}
function MdBackupTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 16H4v-5h5v5zm7 0h-5v-5h5v5zm0-7H4V4h12v5z"
                }
            }
        ]
    })(props);
}
function MdBackup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                }
            }
        ]
    })(props);
}
function MdBalance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.83c.85-.3 1.53-.98 1.83-1.83H18l-3 7c0 1.66 1.57 3 3.5 3s3.5-1.34 3.5-3l-3-7h2V4h-6.17c-.41-1.17-1.52-2-2.83-2s-2.42.83-2.83 2H3v2h2l-3 7c0 1.66 1.57 3 3.5 3S9 14.66 9 13L6 6h3.17c.3.85.98 1.53 1.83 1.83V19H2v2h20v-2h-9V7.83zM20.37 13h-3.74l1.87-4.36L20.37 13zm-13 0H3.63L5.5 8.64 7.37 13zM12 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdBarcodeReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8.75h-4v-1.5h4v1.5zm-.38-4.38L22 3l-3.62 1.63L19 6l3.62-1.63zM19 10l-.62 1.37L22 13l.62-1.37L19 10zm-8 3c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H9.64l-.74 2.78A2.999 2.999 0 016 22a2.995 2.995 0 01-2.9-3.77l1.82-6.8A4.028 4.028 0 013 8c0-2.21 1.79-4 4-4h8c1.49 0 2.45 1.56 1.79 2.89l-2 4C14.45 11.57 13.75 12 13 12h-2.02l-.27 1H11z"
                }
            }
        ]
    })(props);
}
function MdBatchPrediction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8H7c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-4 12.5h-2V19h2v1.5zm0-2.5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 2-2.5 3.5-2.5 5zm5-11.5H6C6 5.67 6.67 5 7.5 5h9c.83 0 1.5.67 1.5 1.5zm-1-3H7C7 2.67 7.67 2 8.5 2h7c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdBookOnline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 18V6h10v12H7zm9-7V9.14C16 8.51 15.55 8 15 8H9c-.55 0-1 .51-1 1.14v1.96c.55 0 1 .45 1 1s-.45 1-1 1v1.76c0 .63.45 1.14 1 1.14h6c.55 0 1-.51 1-1.14V13c-.55 0-1-.45-1-1s.45-1 1-1zm-3.5 3.5h-1v-1h1v1zm0-2h-1v-1h1v1zm0-2h-1v-1h1v1z"
                }
            }
        ]
    })(props);
}
function MdBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
                }
            }
        ]
    })(props);
}
function MdBookmarkAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-2v2h-2V7h-2V5h2V3h2v2h2v2zm-2 14l-7-3-7 3V5c0-1.1.9-2 2-2h7a5.002 5.002 0 005 7.9V21z"
                }
            }
        ]
    })(props);
}
function MdBookmarkAdded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 21l-7-3-7 3V5c0-1.1.9-2 2-2h7a5.002 5.002 0 005 7.9V21zM17.83 9L15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L17.83 9z"
                }
            }
        ]
    })(props);
}
function MdBookmarkBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function MdBookmarkRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-6V5h6v2zm-2 3.9A5.002 5.002 0 0114 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V10.9z"
                }
            }
        ]
    })(props);
}
function MdBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18l2 1V3c0-1.1-.9-2-2-2H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13zM15 5H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdBrowseGallery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3a9 9 0 10.001 18.001A9 9 0 009 3zm2.79 13.21L8 12.41V7h2v4.59l3.21 3.21-1.42 1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 3.52v2.16A6.99 6.99 0 0122 12c0 2.79-1.64 5.2-4.01 6.32v2.16C21.48 19.24 24 15.91 24 12s-2.52-7.24-6.01-8.48z"
                }
            }
        ]
    })(props);
}
function MdBugReport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-2.81a5.985 5.985 0 00-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function MdBuildCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.9 13.49l-1.4 1.4c-.2.2-.51.2-.71 0l-3.41-3.41c-1.22.43-2.64.17-3.62-.81a3.468 3.468 0 01-.59-4.1l2.35 2.35 1.41-1.41-2.35-2.34c1.32-.71 2.99-.52 4.1.59.98.98 1.24 2.4.81 3.62l3.41 3.41c.19.19.19.51 0 .7z"
                }
            }
        ]
    })(props);
}
function MdBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "clipRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
                }
            }
        ]
    })(props);
}
function MdCached(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 01-2.8-.7l-1.46 1.46A7.93 7.93 0 0012 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0012 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
                }
            }
        ]
    })(props);
}
function MdCalendarMonth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdCalendarToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z"
                }
            }
        ]
    })(props);
}
function MdCalendarViewDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v2H3zm0-7h18v5H3zm0-4h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdCalendarViewMonth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 11H4V6h4v5zm6 0h-4V6h4v5zm6 0h-4V6h4v5zM8 18H4v-5h4v5zm6 0h-4v-5h4v5zm6 0h-4v-5h4v5z"
                }
            }
        ]
    })(props);
}
function MdCalendarViewWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2h2.5v12H13V6zm-2 12H8.5V6H11v12zM4 6h2.5v12H4V6zm16 12h-2.5V6H20v12z"
                }
            }
        ]
    })(props);
}
function MdCameraEnhance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"
                }
            }
        ]
    })(props);
}
function MdCancelScheduleSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l9 2-9 2 .01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zm0 13c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
                }
            }
        ]
    })(props);
}
function MdCardGiftcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function MdCardMembership(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
                }
            }
        ]
    })(props);
}
function MdCardTravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
                }
            }
        ]
    })(props);
}
function MdChangeHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
                }
            }
        ]
    })(props);
}
function MdCheckCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                }
            }
        ]
    })(props);
}
function MdChromeReaderMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-74 29h48v48h-48V29zM0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
                }
            }
        ]
    })(props);
}
function MdCircleNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 16.5c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5zm5-2.5H7v-1l1-1v-2.61C8 9.27 9.03 7.47 11 7v-.5c0-.57.43-1 1-1s1 .43 1 1V7c1.97.47 3 2.28 3 4.39V14l1 1v1z"
                }
            }
        ]
    })(props);
}
function MdClass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
                }
            }
        ]
    })(props);
}
function MdCloseFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.41L16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"
                }
            }
        ]
    })(props);
}
function MdCodeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 12l-4.58-4.59L16 6l6 6-3.59 3.59L17 14.17 19.17 12zM1.39 4.22l4.19 4.19L2 12l6 6 1.41-1.41L4.83 12 7 9.83l12.78 12.78 1.41-1.41L2.81 2.81 1.39 4.22z"
                }
            }
        ]
    })(props);
}
function MdCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function MdCommentBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 11l-2.5-1.5L14 13V5h5v8z"
                }
            }
        ]
    })(props);
}
function MdCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9 11a5 5 0 00-9.8 0H2v2h5.1a5 5 0 009.8 0H22v-2h-5.1zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdCommute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2.03L9 18v-5H4V5.98L13 6v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 13.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdCompareArrows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
                }
            }
        ]
    })(props);
}
function MdCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3v3h2v-3h3l-4-4-4 4zm8-15h-3V1h-2v3H8l4 4 4-4zM4 9v2h16V9H4zM4 12h16v2H4z"
                }
            }
        ]
    })(props);
}
function MdContactPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 17.43V18z"
                }
            }
        ]
    })(props);
}
function MdContactSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 2C6.81 2 3 5.81 3 10.5S6.81 19 11.5 19h.5v3c4.86-2.34 8-7 8-11.5C20 5.81 16.19 2 11.5 2zm1 14.5h-2v-2h2v2zm0-3.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
                }
            }
        ]
    })(props);
}
function MdContactless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8.46 14.45l-1.36-.62c.28-.61.41-1.24.4-1.86a4.42 4.42 0 00-.4-1.8l1.36-.63c.35.75.53 1.56.54 2.4.01.86-.17 1.7-.54 2.51zm3.07 1.56l-1.3-.74c.52-.92.78-1.98.78-3.15 0-1.19-.27-2.33-.8-3.4l1.34-.67c.64 1.28.96 2.65.96 4.07 0 1.43-.33 2.74-.98 3.89zm3.14 1.32l-1.35-.66c.78-1.6 1.18-3.18 1.18-4.69 0-1.51-.4-3.07-1.18-4.64l1.34-.67c.9 1.78 1.34 3.56 1.34 5.31 0 1.74-.44 3.54-1.33 5.35z"
                }
            }
        ]
    })(props);
}
function MdCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.88 9.14c1.28.06 1.61 1.15 1.63 1.66h1.79c-.08-1.98-1.49-3.19-3.45-3.19C9.64 7.61 8 9 8 12.14c0 1.94.93 4.24 3.84 4.24 2.22 0 3.41-1.65 3.44-2.95h-1.79c-.03.59-.45 1.38-1.63 1.44-1.31-.04-1.86-1.06-1.86-2.73 0-2.89 1.28-2.98 1.88-3zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdCreditCardOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 21.9L2.1 2.1.69 3.51l1.55 1.55c-.15.28-.23.6-.23.94L2 18c0 1.11.89 2 2 2h13.17l3.31 3.31 1.42-1.41zM4 12V8h1.17l4 4H4zm2.83-8H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L14.83 12H20V8h-9.17l-4-4z"
                }
            }
        ]
    })(props);
}
function MdCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function MdCss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14v-1H11v.5h2v-1h-2.5c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H13v-.5h-2v1h2.5c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zm7.5 1h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1h-2.5v-1h2v.5H21v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2.5v1h-2V13H16v1c0 .55.45 1 1 1zm-9-5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1H6.5v.5h-2v-3h2v.5H8v-1z"
                }
            }
        ]
    })(props);
}
function MdCurrencyExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44zM3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4a9 9 0 009-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67V21zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3a9 9 0 00-9 9H1z"
                }
            }
        ]
    })(props);
}
function MdDangerous(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z"
                }
            }
        ]
    })(props);
}
function MdDashboardCustomize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h8v8H3zm10 0h8v8h-8zM3 13h8v8H3zm15 0h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
                }
            }
        ]
    })(props);
}
function MdDataExploration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12c0 1.33.26 2.61.74 3.77L8 10.5l3.3 2.78L14.58 10H13V8h5v5h-2v-1.58L11.41 16l-3.29-2.79-4.4 4.4A9.996 9.996 0 0012 22h8c1.1 0 2-.9 2-2v-8c0-5.52-4.48-10-10-10zm7.5 18.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdDataThresholding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.33 5.17l2 2 3.67-3.67 1.41 1.41L12.67 13l-2-2-3 3-1.41-1.41 4.41-4.42zM5 16h1.72L5 17.72V16zm.84 3l3-3h1.83l-3 3H5.84zm3.96 0l3-3h1.62l-3 3H9.8zm3.73 0l3-3h1.62l-3 3h-1.62zM19 19h-1.73L19 17.27V19z"
                }
            }
        ]
    })(props);
}
function MdDateRange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
                }
            }
        ]
    })(props);
}
function MdDeleteForever(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(props);
}
function MdDeleteOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(props);
}
function MdDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                }
            }
        ]
    })(props);
}
function MdDensityLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdDensityMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3zM3 11h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdDensitySmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h18v2H3zM3 20h18v2H3zM3 14h18v2H3zM3 8h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdDescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function MdDisabledByDefault(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm14 12.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                }
            }
        ]
    })(props);
}
function MdDisabledVisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 12.34c.01-.11.01-.23.01-.34 0-5.52-4.48-10-10-10S2 6.48 2 12c0 5.17 3.93 9.43 8.96 9.95a9.343 9.343 0 01-2.32-2.68A8.01 8.01 0 014 12c0-1.85.63-3.55 1.69-4.9l5.66 5.66c.56-.4 1.17-.73 1.82-1L7.1 5.69A7.902 7.902 0 0112 4c4.24 0 7.7 3.29 7.98 7.45.71.22 1.39.52 2.01.89zM17 13c-3.18 0-5.9 1.87-7 4.5 1.1 2.63 3.82 4.5 7 4.5s5.9-1.87 7-4.5c-1.1-2.63-3.82-4.5-7-4.5zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm1.5-2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdDisplaySettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.25h8v1.5H6zM16.5 9.75H18v-1.5h-1.5V7H15v4h1.5zM10 12.25h8v1.5h-8zM7.5 15H9v-4H7.5v1.25H6v1.5h1.5z"
                }
            }
        ]
    })(props);
}
function MdDns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdDoneAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
                }
            }
        ]
    })(props);
}
function MdDoneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 5.03l1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z"
                }
            }
        ]
    })(props);
}
function MdDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                }
            }
        ]
    })(props);
}
function MdDonutLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"
                }
            }
        ]
    })(props);
}
function MdDonutSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
                }
            }
        ]
    })(props);
}
function MdDragIndicator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdDynamicForm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20v-9h-2V4h7l-2 5h2l-5 11zm-2-7v7H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h11zm-8.75 2.75h-1.5v1.5h1.5v-1.5zM13 4v7H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h9zM6.25 6.75h-1.5v1.5h1.5v-1.5z"
                }
            }
        ]
    })(props);
}
function MdEco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.05 8.05a7.001 7.001 0 00-.02 9.88c1.47-3.4 4.09-6.24 7.36-7.93A15.952 15.952 0 008 19.32c2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
                }
            }
        ]
    })(props);
}
function MdEditCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22H5a2 2 0 01-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2v6h-2v-2H5v10h7v2zm10.13-5.01l.71-.71a.996.996 0 000-1.41l-.71-.71a.996.996 0 00-1.41 0l-.71.71 2.12 2.12zm-.71.71l-5.3 5.3H14v-2.12l5.3-5.3 2.12 2.12z"
                }
            }
        ]
    })(props);
}
function MdEditDocument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 19.88V22h2.12l5.17-5.17-2.12-2.12zM20 8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H12v-2.95l8-8V8zm-7 1V3.5L18.5 9H13zM22.71 14l-.71-.71a.996.996 0 00-1.41 0l-.71.71L22 16.12l.71-.71a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function MdEditOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.126 8.125l1.937-1.937 3.747 3.747-1.937 1.938zM20.71 5.63l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75L20.71 7a1 1 0 000-1.37zM2 5l6.63 6.63L3 17.25V21h3.75l5.63-5.62L18 21l2-2L4 3 2 5z"
                }
            }
        ]
    })(props);
}
function MdEditSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17V9.93L13.93 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8.93L14.07 17H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15h4.24l7.2-7.2-4.24-4.24-7.2 7.2zM22.91 2.49L21.5 1.08c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24 1.06-1.06c.79-.78.79-2.05 0-2.83z"
                }
            }
        ]
    })(props);
}
function MdEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 24V0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17h14v2H5zm7-12L5.33 15h13.34z"
                }
            }
        ]
    })(props);
}
function MdEuroSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06a8.262 8.262 0 000 2H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function MdEventRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V10h14v2h2zm-5.36 8a3.504 3.504 0 006.86-1c0-1.93-1.57-3.5-3.5-3.5-.95 0-1.82.38-2.45 1H18V18h-4v-4h1.5v1.43c.9-.88 2.14-1.43 3.5-1.43 2.76 0 5 2.24 5 5a5.002 5.002 0 01-9.9 1h1.54z"
                }
            }
        ]
    })(props);
}
function MdEventSeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v3h3v-3h10v3h3v-6H4v3zm15-8h3v3h-3v-3zM2 10h3v3H2v-3zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
                }
            }
        ]
    })(props);
}
function MdEvent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function MdExitToApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16v2H4zM4 2h16v2H4zm9 7h3l-4-4-4 4h3v6H8l4 4 4-4h-3z"
                }
            }
        ]
    })(props);
}
function MdExploreOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.19 14.19l-1.41-1.41-1.56-1.56L11 11 9.81 9.81 4.93 4.93 2.27 2.27 1 3.54l2.78 2.78c-.11.16-.21.32-.31.48-.04.07-.09.14-.13.21-.09.15-.17.31-.25.47-.05.1-.1.21-.16.32-.06.14-.13.28-.19.43-.1.24-.19.48-.27.73l-.09.3c-.05.2-.1.39-.14.59-.02.11-.04.22-.07.33-.04.2-.07.4-.09.61-.01.1-.03.2-.03.3-.03.29-.05.6-.05.91 0 5.52 4.48 10 10 10 .31 0 .62-.02.92-.05l.3-.03c.2-.02.41-.06.61-.09.11-.02.22-.04.33-.07.2-.04.39-.09.58-.15.1-.03.2-.05.3-.09.25-.08.49-.17.73-.27.15-.06.29-.13.43-.19.11-.05.22-.1.33-.16.16-.08.31-.16.46-.25.07-.04.14-.09.21-.13.16-.1.32-.2.48-.31L20.46 23l1.27-1.27-2.66-2.66-4.88-4.88zM6 18l3-6.46L12.46 15 6 18zm16-6c0 .31-.02.62-.05.92l-.03.3c-.02.2-.06.41-.09.61-.02.11-.04.22-.07.33-.04.2-.09.39-.15.58-.03.1-.05.21-.09.31-.08.25-.17.49-.27.73-.06.15-.13.29-.19.43-.05.11-.1.22-.16.33-.08.16-.16.31-.25.46-.04.07-.09.14-.13.21-.1.16-.2.32-.31.48L15 12.46 18 6l-6.46 3-5.22-5.22c.16-.11.32-.21.48-.31.07-.04.14-.09.21-.13.15-.09.31-.17.46-.25.11-.05.22-.1.33-.16.14-.06.28-.13.43-.19.24-.1.48-.19.73-.27l.31-.09c.19-.05.38-.11.58-.15.11-.02.22-.04.33-.07.2-.04.4-.07.61-.09.1-.01.2-.03.3-.03.29-.02.6-.04.91-.04 5.52 0 10 4.48 10 10z"
                }
            }
        ]
    })(props);
}
function MdExplore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
                }
            }
        ]
    })(props);
}
function MdExtensionOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.78 22.61l-1.63-1.63c-.05 0-.1.02-.15.02h-3.8c0-2.71-2.16-3-2.7-3s-2.7.29-2.7 3H5c-1.1 0-2-.9-2-2v-3.8c2.71 0 3-2.16 3-2.7s-.3-2.7-2.99-2.7V6c0-.05.02-.09.02-.14L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zm.22-5.44V15a2.5 2.5 0 000-5V6c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-5 0H6.83L20 17.17z"
                }
            }
        ]
    })(props);
}
function MdExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5a2.5 2.5 0 00-5 0V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5a2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function MdFace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm6 0a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37a9.974 9.974 0 0010.41 3.97c.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdFactCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM10 17H5v-2h5v2zm0-4H5v-2h5v2zm0-4H5V7h5v2zm4.82 6L12 12.16l1.41-1.41 1.41 1.42L17.99 9l1.42 1.42L14.82 15z"
                }
            }
        ]
    })(props);
}
function MdFavoriteBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
                }
            }
        ]
    })(props);
}
function MdFavorite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                }
            }
        ]
    })(props);
}
function MdFax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-1V4H8v16h14v-8c0-1.66-1.34-3-3-3zm-9-3h6v3h-6V6zm4 11h-4v-5h4v5zm2 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM4.5 8A2.5 2.5 0 002 10.5v8a2.5 2.5 0 005 0v-8A2.5 2.5 0 004.5 8z"
                }
            }
        ]
    })(props);
}
function MdFeedback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
                }
            }
        ]
    })(props);
}
function MdFilePresent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-5-5zM6 20V4h8v4h4v12H6zm10-10v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V8.5a2.5 2.5 0 012.76-2.49c1.3.13 2.24 1.32 2.24 2.63V15h-2V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V15c0 1.1.9 2 2 2s2-.9 2-2v-5h2z"
                }
            }
        ]
    })(props);
}
function MdFilterAltOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.79 5.61A.998.998 0 0019 4H6.83l7.97 7.97 4.99-6.36zM2.81 2.81L1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdFilterAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24m0 24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0018.95 4H5.04c-.83 0-1.3.95-.79 1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdFilterListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zM0 0h24m0 24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.25 5.66c.1.13 5.74 7.33 5.74 7.33V19c0 .55.45 1 1.01 1h2.01c.55 0 1.01-.45 1.01-1v-6.02s5.49-7.02 5.75-7.34C20.03 5.32 20 5 20 5c0-.55-.45-1-1.01-1H5.01C4.4 4 4 4.48 4 5c0 .2.06.44.25.66z"
                }
            }
        ]
    })(props);
}
function MdFindInPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function MdFindReplace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05A6.976 6.976 0 0011 4c-3.53 0-6.43 2.61-6.92 6H6.1A5 5 0 0111 6zm5.64 9.14A6.89 6.89 0 0017.92 12H15.9a5 5 0 01-4.9 4c-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05A6.976 6.976 0 0011 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
                }
            }
        ]
    })(props);
}
function MdFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 01.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 01-.44.28zM3.5 9.72a.499.499 0 01-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 01-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 00-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 01-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 01-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 01-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
                }
            }
        ]
    })(props);
}
function MdFitScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h3c1.1 0 2 .9 2 2v2h-2V6h-3V4zM4 8V6h3V4H4c-1.1 0-2 .9-2 2v2h2zm16 8v2h-3v2h3c1.1 0 2-.9 2-2v-2h-2zM7 18H4v-2H2v2c0 1.1.9 2 2 2h3v-2zM18 8H6v8h12V8z"
                }
            }
        ]
    })(props);
}
function MdFlaky(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.05 17.58l-.01.01-2.4-2.4 1.06-1.06 1.35 1.35L16.54 13l1.06 1.06-3.54 3.54-.01-.02zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM7.34 6.28l1.41 1.41 1.41-1.41 1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.41-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.41 1.06-1.06zM12 20c-2.2 0-4.2-.9-5.7-2.3L17.7 6.3C19.1 7.8 20 9.8 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdFlightLand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
                }
            }
        ]
    })(props);
}
function MdFlightTakeoff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49s7.12-1.9 16.57-4.43c.81-.23 1.28-1.05 1.07-1.85z"
                }
            }
        ]
    })(props);
}
function MdFlipToBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8a2 2 0 00-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7a2 2 0 002 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12a2 2 0 002 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdFlipToFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 002 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 00-2 2v10a2 2 0 002 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdFlutterDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 11.7c.29-.39.81-.56 1.27-.37.17.07.32.18.43.33.22.28.25.59.22.85-.05.33-.25.63-.54.79 0 0-4.87 2.95-5.07 2.69s3.69-4.29 3.69-4.29zM22 10c0 2.5-1 3-1.5 3-.23 0-.44-.1-.62-.26-.48 3.32-2.36 5.31-5.33 5.99.11.44.48.77.95.77h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.78-.16-1.39-.78-1.55-1.56-.49.06-1 .1-1.54.1-.88 0-1.7-.09-2.45-.25-.02.08-.05.16-.05.25 0 .55.45 1 1 1h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.9-.19-1.59-1-1.59-1.96 0-.18.03-.36.08-.53-2.46-.86-4.03-2.78-4.46-5.74-.18.17-.38.27-.62.27C3 13 2 12.5 2 10c0-2.27 1.7-4.5 3-4.5.43 0 .49.49.5.85a7.989 7.989 0 015.55-3.29c.2-.96 1.08-1.56 1.95-1.56v1s.33-.5 1-.5c.67 0 1 .5 1 .5-.49 0-.85.35-.96.77 1.82.48 3.39 1.59 4.46 3.08.01-.36.07-.85.5-.85 1.3 0 3 2.23 3 4.5zM5 11c0 .81.1 1.53.25 2.21.18-.69.46-1.33.83-1.92a3.77 3.77 0 01-.34-1.54A3.766 3.766 0 019.5 6c.96 0 1.84.37 2.5.97.66-.6 1.54-.97 2.5-.97 2.07 0 3.75 1.68 3.75 3.75 0 .55-.12 1.07-.34 1.54.37.59.66 1.24.84 1.94.15-.68.25-1.41.25-2.23 0-3.86-3.14-7-7-7s-7 3.14-7 7zm12.98 4.29c0-.1.02-.19.02-.29 0-1.01-.26-1.95-.7-2.78-.69.78-1.68 1.28-2.8 1.28-.27 0-.54-.03-.79-.09.14-.23.23-.49.27-.77.01-.07.01-.13.02-.19.17.03.33.05.5.05 1.52 0 2.75-1.23 2.75-2.75S16.02 7 14.5 7c-.67 0-1.32.25-1.83.72l-.67.6-.67-.6C10.82 7.25 10.17 7 9.5 7 7.98 7 6.75 8.23 6.75 9.75c0 1.34.96 2.46 2.23 2.7l-.76.83c-.6-.22-1.12-.59-1.53-1.05A6.01 6.01 0 006 15c0 .08.01.15.01.24C7.13 17.06 9.14 18 12 18c2.88 0 4.88-.91 5.98-2.71zM16 9.75c0 .97-.67 1.75-1.5 1.75S13 10.72 13 9.75 13.67 8 14.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38zM11 9.75c0 .97-.67 1.75-1.5 1.75S8 10.72 8 9.75 8.67 8 9.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38z"
                }
            }
        ]
    })(props);
}
function MdFreeCancellation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.21 20H5V10h14v4.38l2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h8.21l-2-2zm5.33 2.5L13 18.96l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66zM10.41 14L12 15.59 10.59 17 9 15.41 7.41 17 6 15.59 7.59 14 6 12.41 7.41 11 9 12.59 10.59 11 12 12.41 10.41 14z"
                }
            }
        ]
    })(props);
}
function MdGTranslate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H11l-1-3H3c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8l1 3h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 16c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.35 0 2.48.5 3.35 1.3L9.03 8.57c-.38-.36-1.04-.78-2.03-.78-1.74 0-3.15 1.44-3.15 3.21S5.26 14.21 7 14.21c2.01 0 2.84-1.44 2.92-2.41H7v-1.71h4.68c.07.31.12.61.12 1.02C11.8 13.97 9.89 16 7 16zm6.17-5.42h3.7c-.43 1.25-1.11 2.43-2.05 3.47-.31-.35-.6-.72-.86-1.1l-.79-2.37zm8.33 9.92c0 .55-.45 1-1 1H14l2-2.5-1.04-3.1 3.1 3.1.92-.92-3.3-3.25.02-.02c1.13-1.25 1.93-2.69 2.4-4.22H20v-1.3h-4.53V8h-1.29v1.29h-1.44L11.46 5.5h9.04c.55 0 1 .45 1 1v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function MdGavel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.25 8.069l2.83-2.827 14.134 14.15-2.83 2.827zM9.486 3.827L12.314.998l5.657 5.656-2.828 2.83zM.999 12.315l2.828-2.829 5.657 5.657-2.828 2.828zM1 21h12v2H1z"
                }
            }
        ]
    })(props);
}
function MdGeneratingTokens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3 6.5h-2v5H8v-5H6V9h6v1.5zm8.25-6.75L23 5l-2.75 1.25L19 9l-1.25-2.75L15 5l2.75-1.25L19 1l1.25 2.75zm0 14L23 19l-2.75 1.25L19 23l-1.25-2.75L15 19l2.75-1.25L19 15l1.25 2.75z"
                }
            }
        ]
    })(props);
}
function MdGetApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function MdGifBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 13v-1h1v1c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1h1c.55 0 1 .45 1 1h-2v2h1zm3 1h-1v-4h1v4zm4-3h-2v.5H16v1h-1.5V14h-1v-4h3v1z"
                }
            }
        ]
    })(props);
}
function MdGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zM19 10.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"
                }
            }
        ]
    })(props);
}
function MdGrade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                }
            }
        ]
    })(props);
}
function MdGrading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4V7zm0 6h16v-2H4v2zm0 4h7v-2H4v2zm0 4h7v-2H4v2zm11.41-2.83L14 16.75l-1.41 1.41L15.41 21 20 16.42 18.58 15l-3.17 3.17zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function MdGroupWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5zM9.5 8a2.5 2.5 0 015 0 2.5 2.5 0 01-5 0zm6.5 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdHelpCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6.99 15c-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.54 1.25 1.25-.01.69-.54 1.26-1.25 1.26zm3.01-7.4c-.76 1.11-1.48 1.46-1.87 2.17-.16.29-.22.48-.22 1.41h-1.82c0-.49-.08-1.29.31-1.98.49-.87 1.42-1.39 1.96-2.16.57-.81.25-2.33-1.37-2.33-1.06 0-1.58.8-1.8 1.48l-1.65-.7C9.01 7.15 10.22 6 11.99 6c1.48 0 2.49.67 3.01 1.52.44.72.7 2.07.02 3.08z"
                }
            }
        ]
    })(props);
}
function MdHelpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdHelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                }
            }
        ]
    })(props);
}
function MdHideSource(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06l10.94 10.94C14.86 19.59 13.48 20 12 20zM7.94 5.12L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.869 7.869 0 0020 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.12z"
                }
            }
        ]
    })(props);
}
function MdHighlightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5h-2V3h2v2zm-2 16h2v-2.59L19.59 21 21 19.59 18.41 17H21v-2h-6v6zm4-12h2V7h-2v2zm0 4h2v-2h-2v2zm-8 8h2v-2h-2v2zM7 5h2V3H7v2zM3 17h2v-2H3v2zm2 4v-2H3c0 1.1.9 2 2 2zM19 3v2h2c0-1.1-.9-2-2-2zm-8 2h2V3h-2v2zM3 9h2V7H3v2zm4 12h2v-2H7v2zm-4-8h2v-2H3v2zm0-8h2V3c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function MdHighlightOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdHistoryToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1 19.37l1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56zM4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1zM15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56zM19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1zM8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56zM11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56zm7.36 3.1l1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54zM4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1zm15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1h-2.02zm-3.1 5.36l1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54zM7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01a7.7 7.7 0 011.53-1.54zM5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74a7.7 7.7 0 01-1.54-1.53zM13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7V7z"
                }
            }
        ]
    })(props);
}
function MdHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
                }
            }
        ]
    })(props);
}
function MdHlsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.83 15h1.67c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.17l2 2zM8 10.83V15H6.5v-2.5h-2V15H3V9h1.5v2h2V9.33L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-7.6-7.6H10v-2.17l-2-2z"
                }
            }
        ]
    })(props);
}
function MdHls(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H8v6H6.5v-2.5h-2V15H3V9h1.5v2h2V9zm10 6h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.5v1c0 .55.45 1 1 1zM14 15v-1.5h-2.5V9H10v6h4z"
                }
            }
        ]
    })(props);
}
function MdHomeFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h5v-7h6v7h5V9z"
                }
            }
        ]
    })(props);
}
function MdHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
                }
            }
        ]
    })(props);
}
function MdHorizontalSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h18v-6H3v6zm0-8h18V9H3v2zm0-6v2h18V5H3z"
                }
            }
        ]
    })(props);
}
function MdHotelClass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.58 10H1l6.17 4.41L4.83 22 11 17.31 17.18 22l-2.35-7.59L21 10h-7.58L11 2l-2.42 8zm12.78 12l-1.86-6.01L23.68 13h-3.44l-3.08 2.2 1.46 4.72L21.36 22zM17 8l-1.82-6-1.04 3.45.77 2.55H17z"
                }
            }
        ]
    })(props);
}
function MdHourglassDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4h8v3.5l-2.84 2.84 1.25 1.25L18 8.01 17.99 8H18V2H6v1.17l2 2zM2.1 2.1L.69 3.51l8.9 8.9L6 16l.01.01H6V22h12v-1.17l2.49 2.49 1.41-1.41L2.1 2.1zM16 20H8v-3.5l2.84-2.84L16 18.83V20z"
                }
            }
        ]
    })(props);
}
function MdHourglassEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
                }
            }
        ]
    })(props);
}
function MdHourglassFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
                }
            }
        ]
    })(props);
}
function MdHtml(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 9H5v6H3.5v-2.5h-2V15H0V9h1.5v2h2V9zm14 0H13c-.55 0-1 .45-1 1v5h1.5v-4.5h1V14H16v-3.51h1V15h1.5v-5c0-.55-.45-1-1-1zM11 9H6v1.5h1.75V15h1.5v-4.5H11V9zm13 6v-1.5h-2.5V9H20v6h4z"
                }
            }
        ]
    })(props);
}
function MdHttp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            }
        ]
    })(props);
}
function MdHttps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                }
            }
        ]
    })(props);
}
function MdImportantDevices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12a2 2 0 002 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 00-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
                }
            }
        ]
    })(props);
}
function MdInfoOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2V7zm0 4h2v6h-2v-6zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdInput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
                }
            }
        ]
    })(props);
}
function MdInstallDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H4V5h8V3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14l5-5-1.41-1.41L18 10.17V3h-2v7.17l-2.59-2.58L12 9z"
                }
            }
        ]
    })(props);
}
function MdInstallMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h7V1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-5h-2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14l5-5-1.41-1.41L19 10.17V3h-2v7.17l-2.59-2.58L13 9z"
                }
            }
        ]
    })(props);
}
function MdIntegrationInstructions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11.17l-1.41 1.42L6 12l3.59-3.59L11 9.83 8.83 12 11 14.17zm1-9.92c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75zm2.41 11.34L13 14.17 15.17 12 13 9.83l1.41-1.42L18 12l-3.59 3.59z"
                }
            }
        ]
    })(props);
}
function MdInvertColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.81V19c-3.31 0-6-2.63-6-5.87 0-1.56.62-3.03 1.75-4.14L12 4.81M6.35 7.56C4.9 8.99 4 10.96 4 13.13 4 17.48 7.58 21 12 21s8-3.52 8-7.87c0-2.17-.9-4.14-2.35-5.57L12 2 6.35 7.56z"
                }
            }
        ]
    })(props);
}
function MdJavascript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v-1h1.5v.5h2v-1H13c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1H16c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zM9 9v4.5H7.5v-1H6v1c0 .83.67 1.5 1.5 1.5H9c.83 0 1.5-.67 1.5-1.5V9H9z"
                }
            }
        ]
    })(props);
}
function MdJoinFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5 0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdJoinInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.04 16.87c-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdJoinLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdJoinRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12c0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5zM8 19c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7z"
                }
            }
        ]
    })(props);
}
function MdLabelImportantOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19H3l4.5-7L3 5h12c.65 0 1.26.31 1.63.84L21 12l-4.37 6.16c-.37.52-.98.84-1.63.84zm-8.5-2H15l3.5-5L15 7H6.5l3.5 5-3.5 5z"
                }
            }
        ]
    })(props);
}
function MdLabelImportant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 18.99l11 .01c.67 0 1.27-.33 1.63-.84L20.5 12l-4.37-6.16c-.36-.51-.96-.84-1.63-.84l-11 .01L8.34 12 3.5 18.99z"
                }
            }
        ]
    })(props);
}
function MdLabelOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.25 2.75l17 17L19 21l-2-2H5c-1.1 0-2-.9-2-2V7c0-.55.23-1.05.59-1.41L2 4l1.25-1.25zM22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5H8l11 11 3-4z"
                }
            }
        ]
    })(props);
}
function MdLabelOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
                }
            }
        ]
    })(props);
}
function MdLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
                }
            }
        ]
    })(props);
}
function MdLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
                }
            }
        ]
    })(props);
}
function MdLaunch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function MdLeaderboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 21H2V9h5.5v12zm7.25-18h-5.5v18h5.5V3zM22 11h-5.5v10H22V11z"
                }
            }
        ]
    })(props);
}
function MdLightbulbCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 17c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5zm3-2.5H9V15h6v1.5zm-.03-2.5H9.03A4.966 4.966 0 017 10c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.64-.8 3.09-2.03 4z"
                }
            }
        ]
    })(props);
}
function MdLightbulbOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2 11.7V16h-4v-2.3C8.48 12.63 7 11.53 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.49-1.51 3.65-3 4.7z"
                }
            }
        ]
    })(props);
}
function MdLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdLineStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function MdLineWeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function MdList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function MdLockClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 14.2l2.9 1.7-.8 1.3L13 15v-5h1.5v4.2zM22 14c0 4.41-3.59 8-8 8-2.02 0-3.86-.76-5.27-2H4c-1.15 0-2-.85-2-2V9c0-1.12.89-1.96 2-2v-.5C4 4.01 6.01 2 8.5 2c2.34 0 4.24 1.79 4.46 4.08.34-.05.69-.08 1.04-.08 4.41 0 8 3.59 8 8zM6 7h5v-.74A2.509 2.509 0 008.5 4 2.5 2.5 0 006 6.5V7zm14 7c0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6 6-2.69 6-6z"
                }
            }
        ]
    })(props);
}
function MdLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
                }
            }
        ]
    })(props);
}
function MdLockOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
                }
            }
        ]
    })(props);
}
function MdLockPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c.7 0 1.37.1 2 .29V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26A6.995 6.995 0 0118 11zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 2c.83 0 1.5.67 1.5 1.5S18.83 18 18 18s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm0 6c-1.03 0-1.94-.52-2.48-1.32.73-.42 1.57-.68 2.48-.68s1.75.26 2.48.68c-.54.8-1.45 1.32-2.48 1.32z"
                }
            }
        ]
    })(props);
}
function MdLockReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l4 4 4-4H6c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7c-1.9 0-3.62-.76-4.88-1.99L6.7 18.42A8.982 8.982 0 0013 21a9 9 0 000-18zm2 8v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                }
            }
        ]
    })(props);
}
function MdLogin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
                }
            }
        ]
    })(props);
}
function MdLogout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
                }
            }
        ]
    })(props);
}
function MdLoyalty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27A2.5 2.5 0 0110.5 11c.69 0 1.32.28 1.77.74l.73.72.73-.73a2.5 2.5 0 013.54 3.54z"
                }
            }
        ]
    })(props);
}
function MdManageAccounts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26a6.963 6.963 0 01-.59-6.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdManageHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.69 18.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L20 14h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L18 24h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM11 7v5.41l2.36 2.36 1.04-1.79-1.4-1.39V7h-2zm10 5a9 9 0 00-9-9C9.17 3 6.65 4.32 5 6.36V4H3v6h6V8H6.26A7.01 7.01 0 0112 5c3.86 0 7 3.14 7 7h2zm-10.14 6.91c-2.99-.49-5.35-2.9-5.78-5.91H3.06c.5 4.5 4.31 8 8.94 8h.07l-1.21-2.09z"
                }
            }
        ]
    })(props);
}
function MdMarkAsUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.83 7h-2.6L10.5 4 4 7.4V17c-1.1 0-2-.9-2-2V7.17c0-.53.32-1.09.8-1.34L10.5 2l7.54 3.83c.43.23.73.7.79 1.17zM20 8H7c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm0 3.67L13.5 15 7 11.67V10l6.5 3.33L20 10v1.67z"
                }
            }
        ]
    })(props);
}
function MdMarkunreadMailbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-3000H782V600H-618zM0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdMediation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12l-4 4-1.41-1.41L18.17 13h-5.23A8.974 8.974 0 018 20.05 3.005 3.005 0 015 23c-1.66 0-3-1.34-3-3s1.34-3 3-3c.95 0 1.78.45 2.33 1.14A6.969 6.969 0 0010.91 13h-3.1C7.4 14.16 6.3 15 5 15c-1.66 0-3-1.34-3-3s1.34-3 3-3c1.3 0 2.4.84 2.82 2h3.1c-.32-2.23-1.69-4.1-3.59-5.14C6.78 6.55 5.95 7 5 7 3.34 7 2 5.66 2 4s1.34-3 3-3a2.99 2.99 0 012.99 2.95A8.974 8.974 0 0112.93 11h5.23l-1.58-1.59L18 8l4 4z"
                }
            }
        ]
    })(props);
}
function MdMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h12v2H6z"
                }
            }
        ]
    })(props);
}
function MdModelTraining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 13.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5zm-2.5 6h-2V21h2v-1.5zm6-6.5c0 1.68-.59 3.21-1.58 4.42l1.42 1.42a8.978 8.978 0 00-1-12.68l-1.42 1.42A6.993 6.993 0 0119 13zm-3-8l-4-4v3a9 9 0 00-9 9c0 2.23.82 4.27 2.16 5.84l1.42-1.42A6.938 6.938 0 015 13c0-3.86 3.14-7 7-7v3l4-4z"
                }
            }
        ]
    })(props);
}
function MdNetworkPing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.67L3.41 6.09 2 7.5l8.5 8.5H4v2h16v-2h-6.5l5.15-5.15A2.5 2.5 0 1019.5 6 2.5 2.5 0 0017 8.5c0 .35.07.67.2.97l-5.2 5.2z"
                }
            }
        ]
    })(props);
}
function MdNewLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12l-4.37 6.16c-.37.52-.98.84-1.63.84h-3v-6H9v-3H3V7c0-1.1.9-2 2-2h10c.65 0 1.26.31 1.63.84L21 12zm-11 3H7v-3H5v3H2v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function MdNextPlan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 11.97h-5l2.26-2.26a4.94 4.94 0 00-3.76-1.74c-2.37 0-4.35 1.66-4.86 3.88l-.96-.32c.64-2.62 3-4.56 5.82-4.56 1.78 0 3.37.79 4.47 2.03L18 8.97v5z"
                }
            }
        ]
    })(props);
}
function MdNightlightRound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 12c0-3.57 2.2-6.62 5.31-7.87.89-.36.75-1.69-.19-1.9-1.1-.24-2.27-.3-3.48-.14-4.51.6-8.12 4.31-8.59 8.83C4.44 16.93 9.13 22 15.01 22c.73 0 1.43-.08 2.12-.23.95-.21 1.1-1.53.2-1.9A8.46 8.46 0 0112.01 12z"
                }
            }
        ]
    })(props);
}
function MdNoAccounts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.18 10.94c.2-.44.32-.92.32-1.44C15.5 7.57 13.93 6 12 6c-.52 0-1 .12-1.44.32l4.62 4.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13c-2.32 0-4.45.8-6.14 2.12A7.957 7.957 0 014 12c0-1.85.63-3.55 1.69-4.9l2.86 2.86a3.47 3.47 0 002.99 2.99l2.2 2.2c-.57-.1-1.15-.15-1.74-.15zm6.31 1.9L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.54-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdNoiseAware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.6 6.58l1.58 1.26c.35-.57.77-1.1 1.24-1.57L4.85 5.02c-.47.47-.88 1-1.25 1.56zM9.46 4.42l-.87-1.81c-.63.23-1.24.52-1.8.87l.87 1.81c.56-.36 1.16-.65 1.8-.87zM4.49 9.26l-1.96-.45c-.21.63-.36 1.28-.44 1.95l1.96.45a7.9 7.9 0 01.44-1.95zM20.4 6.58a9.4 9.4 0 00-1.25-1.56l-1.58 1.26c.48.47.89.99 1.24 1.57l1.59-1.27zM4.04 12.79l-1.96.45c.08.67.23 1.33.44 1.95l1.97-.45c-.22-.62-.38-1.27-.45-1.95zM17.21 3.48c-.57-.35-1.17-.64-1.8-.87l-.87 1.81c.64.22 1.24.51 1.8.87l.87-1.81zM13 4.07V2.05c-.33-.03-.66-.05-1-.05s-.67.02-1 .05v2.02c.33-.04.66-.07 1-.07s.67.03 1 .07zM11 19.93v2.02c.33.03.66.05 1 .05s.67-.02 1-.05v-2.02c-.33.04-.66.07-1 .07s-.67-.03-1-.07zM19.51 14.74l1.97.45c.21-.63.36-1.28.44-1.95l-1.96-.45c-.07.68-.23 1.33-.45 1.95zM19.96 11.21l1.96-.45a9.69 9.69 0 00-.44-1.95l-1.97.45c.22.62.38 1.27.45 1.95zM17.58 17.73l1.58 1.26c.47-.48.88-1 1.25-1.56l-1.58-1.26a9.4 9.4 0 01-1.25 1.56zM6.79 20.52c.57.35 1.17.64 1.8.87l.87-1.81c-.64-.22-1.24-.51-1.8-.87l-.87 1.81zM14.54 19.58l.87 1.81c.63-.23 1.24-.52 1.8-.87l-.87-1.81c-.56.36-1.16.65-1.8.87zM3.6 17.42a9.4 9.4 0 001.25 1.56l1.58-1.26a7.87 7.87 0 01-1.24-1.57L3.6 17.42z"
                }
            }
        ]
    })(props);
}
function MdNoiseControlOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.44 0 2.79.38 3.95 1.05L17.4 3.6C15.85 2.59 13.99 2 12 2s-3.85.59-5.41 1.59l1.45 1.45A8.034 8.034 0 0112 4zM20 12c0 1.44-.38 2.79-1.05 3.95l1.45 1.45c1.01-1.55 1.6-3.41 1.6-5.4s-.59-3.85-1.59-5.41l-1.45 1.45A8.034 8.034 0 0120 12zM12 20c-1.44 0-2.79-.38-3.95-1.05L6.6 20.4C8.15 21.41 10.01 22 12 22s3.85-.59 5.41-1.59l-1.45-1.45A8.034 8.034 0 0112 20zM4 12c0-1.44.38-2.79 1.05-3.95L3.59 6.59C2.59 8.15 2 10.01 2 12s.59 3.85 1.59 5.41l1.45-1.45A8.034 8.034 0 014 12zM11.5 6C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdNotAccessible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11.05l-3.42-3.42c.32-.34.74-.57 1.23-.61.48-.04.84.07 1.2.26.19.1.39.22.63.46l1.29 1.43c.98 1.08 2.53 1.85 4.07 1.83v2c-1.75-.01-3.71-.88-5-1.95zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2.81 2.81L1.39 4.22 10 12.83V15c0 1.1.9 2 2 2h2.17l5.61 5.61 1.41-1.41L2.81 2.81zM10 20c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2z"
                }
            }
        ]
    })(props);
}
function MdNotStarted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm1 0V8l5 4-5 4z"
                }
            }
        ]
    })(props);
}
function MdNoteAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function MdOfflineBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zM11.48 20v-6.26H8L13 4v6.26h3.35L11.48 20z"
                }
            }
        ]
    })(props);
}
function MdOfflinePin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
                }
            }
        ]
    })(props);
}
function MdOnDeviceTraining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2v1h-2zM12 11c-1.1 0-2 .9-2 2 0 .74.4 1.38 1 1.72v.78h2v-.78c.6-.35 1-.98 1-1.72 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L6 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM18 18H6V6h12v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 15.95c.62-.83.99-1.84.99-2.95s-.37-2.12-.99-2.95l-1.07 1.07c.35.54.56 1.19.56 1.88s-.21 1.34-.56 1.88l1.07 1.07zM9.06 14.88c-.35-.54-.56-1.19-.56-1.88 0-1.93 1.57-3.5 3.5-3.5v1.25l2.25-2-2.25-2V8c-2.76 0-5 2.24-5 5 0 1.11.37 2.12.99 2.95l1.07-1.07z"
                }
            }
        ]
    })(props);
}
function MdOnlinePrediction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5C8.5 9.57 10.07 8 12 8s3.5 1.57 3.5 3.5zm-2.5 6h-2V19h2v-1.5zm9-5.5c0-2.76-1.12-5.26-2.93-7.07l-1.06 1.06A8.481 8.481 0 0120.5 12c0 2.34-.95 4.47-2.49 6.01l1.06 1.06A9.969 9.969 0 0022 12zM3.5 12c0-2.34.95-4.47 2.49-6.01L4.93 4.93A9.969 9.969 0 002 12c0 2.76 1.12 5.26 2.93 7.07l1.06-1.06A8.481 8.481 0 013.5 12zm14 0c0 1.52-.62 2.89-1.61 3.89l1.06 1.06A6.976 6.976 0 0019 12c0-1.93-.78-3.68-2.05-4.95l-1.06 1.06c.99 1 1.61 2.37 1.61 3.89zM7.05 16.95l1.06-1.06c-1-1-1.61-2.37-1.61-3.89s.62-2.89 1.61-3.89L7.05 7.05A6.976 6.976 0 005 12c0 1.93.78 3.68 2.05 4.95z"
                }
            }
        ]
    })(props);
}
function MdOpacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
                }
            }
        ]
    })(props);
}
function MdOpenInBrowser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOpenInFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
                }
            }
        ]
    })(props);
}
function MdOpenInNewOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.79 5.8L14 3h7v7l-2.79-2.8-4.09 4.09-1.41-1.41 4.08-4.08zM19 12v4.17l2 2V12h-2zm.78 10.61L18.17 21H5a2 2 0 01-2-2V5.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM16.17 19l-4.88-4.88-1.59 1.59-1.41-1.41 1.59-1.59L5 7.83V19h11.17zM7.83 5H12V3H5.83l2 2z"
                }
            }
        ]
    })(props);
}
function MdOpenInNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function MdOpenWith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                }
            }
        ]
    })(props);
}
function MdOutbond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutbound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zM8 11h2v3h4v-3h2l-4-4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutgoingMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c.17 0 .34.01.5.03V6.87C19 5.84 18.16 5 17.13 5H3.87C2.84 5 2 5.84 2 6.87v10.26C2 18.16 2.84 19 3.87 19h9.73c-.38-.75-.6-1.6-.6-2.5 0-3.04 2.46-5.5 5.5-5.5zm-8.1 2L4 9.19V7h.23l6.18 3.68L16.74 7H17v2.16L10.4 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13l-1.41 1.41L19.17 16H15v2h4.17l-1.58 1.59L19 21l4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9 12c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1zm5 6h-4v-2c0-1.1.9-2 2-2s2 .9 2 2v2zm2-7c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v3z"
                }
            }
        ]
    })(props);
}
function MdOutput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17l5-5-5-5-1.41 1.41L18.17 11H9v2h9.17l-2.58 2.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v2h2V5a2 2 0 00-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdPageview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9a2.5 2.5 0 000 5 2.5 2.5 0 000-5zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
                }
            }
        ]
    })(props);
}
function MdPaid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.88 15.76V19h-1.75v-1.29c-.74-.18-2.39-.77-3.02-2.96l1.65-.67c.06.22.58 2.09 2.4 2.09.93 0 1.98-.48 1.98-1.61 0-.96-.7-1.46-2.28-2.03-1.1-.39-3.35-1.03-3.35-3.31 0-.1.01-2.4 2.62-2.96V5h1.75v1.24c1.84.32 2.51 1.79 2.66 2.23l-1.58.67c-.11-.35-.59-1.34-1.9-1.34-.7 0-1.81.37-1.81 1.39 0 .95.86 1.31 2.64 1.9 2.4.83 3.01 2.05 3.01 3.45 0 2.63-2.5 3.13-3.02 3.22z"
                }
            }
        ]
    })(props);
}
function MdPanToolAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 14.82l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L5 15.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V4.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07z"
                }
            }
        ]
    })(props);
}
function MdPanTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdPayment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function MdPendingActions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71zM18 3h-3.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h6.11a6.743 6.743 0 01-1.42-2H6V5h2v3h8V5h2v5.08c.71.1 1.38.31 2 .6V5c0-1.1-.9-2-2-2zm-6 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdPending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 11C9.43 11 11 9.43 11 7.5S9.43 4 7.5 4 4 5.57 4 7.5 5.57 11 7.5 11zm0-5C8.33 6 9 6.67 9 7.5S8.33 9 7.5 9 6 8.33 6 7.5 6.67 6 7.5 6zM4.002 18.583L18.59 3.996l1.414 1.414L5.417 19.997zM16.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdPermCameraMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function MdPermContactCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
                }
            }
        ]
    })(props);
}
function MdPermDataSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83a.26.26 0 00.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83a3.908 3.908 0 000 .98l-1.06.83a.26.26 0 00-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73a.26.26 0 00-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdPermDeviceInformation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdPermIdentity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdPermMedia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
                }
            }
        ]
    })(props);
}
function MdPermPhoneMsg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
                }
            }
        ]
    })(props);
}
function MdPermScanWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdPets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
                }
            }
        ]
    })(props);
}
function MdPhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h1.5v6H13v-2.5h-2V15H9.5V9H11v2h2V9zm-5 1.5v1c0 .8-.7 1.5-1.5 1.5h-2v2H3V9h3.5c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1zm15 0v1c0 .8-.7 1.5-1.5 1.5h-2v2h-1.5V9H20c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1z"
                }
            }
        ]
    })(props);
}
function MdPictureInPictureAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"
                }
            }
        ]
    })(props);
}
function MdPictureInPicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
                }
            }
        ]
    })(props);
}
function MdPinEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12V6H4v12h10v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-2zm-1 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-4.34-6H9v5.66l2.12-2.12 2.83 2.83 1.41-1.41-2.83-2.83L14.66 8z"
                }
            }
        ]
    })(props);
}
function MdPinInvoke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10v2H4v12h16v-6h2zm0-5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm-10.53 5.12l-2.83 2.83 1.41 1.41 2.83-2.83L15 15.66V10H9.34l2.13 2.12z"
                }
            }
        ]
    })(props);
}
function MdPinch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.5V1h5v5H9.5V3.56L3.56 9.5H6V11H1V6h1.5v2.44L8.44 2.5H6zm16.98 14.32l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L8 17.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07z"
                }
            }
        ]
    })(props);
}
function MdPlagiarism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm1.04 17.45l-1.88-1.88c-1.33.71-3.01.53-4.13-.59a3.495 3.495 0 010-4.95 3.495 3.495 0 014.95 0 3.48 3.48 0 01.59 4.13l1.88 1.88-1.41 1.41zM13 9V3.5L18.5 9H13z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdPlayForWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
                }
            }
        ]
    })(props);
}
function MdPolymer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"
                }
            }
        ]
    })(props);
}
function MdPowerSettingsNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0119 12c0 3.87-3.13 7-7 7A6.995 6.995 0 017.58 6.58L6.17 5.17A8.932 8.932 0 003 12a9 9 0 0018 0c0-2.74-1.23-5.18-3.17-6.83z"
                }
            }
        ]
    })(props);
}
function MdPregnantWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9a3.285 3.285 0 00-2-3c0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
                }
            }
        ]
    })(props);
}
function MdPreview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-5.5-6c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM12 9c-2.73 0-5.06 1.66-6 4 .94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4zm0 6.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                }
            }
        ]
    })(props);
}
function MdPrivacyTip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function MdPrivateConnectivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.93 11c-.49-3.39-3.4-6-6.93-6s-6.44 2.61-6.93 6H2v2h3.07c.49 3.39 3.4 6 6.93 6s6.44-2.61 6.93-6H22v-2h-3.07zM15 14.5c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1v-1a2 2 0 012.34-1.97c.98.16 1.66 1.08 1.66 2.08v.89c.55 0 1 .45 1 1v3zM12.75 13c0 .41-.34.75-.75.75s-.75-.34-.75-.75.34-.75.75-.75.75.34.75.75zM13 9.5v1h-2v-1c0-.55.45-1 1-1s1 .45 1 1z"
                }
            }
        ]
    })(props);
}
function MdProductionQuantityLimits(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2V8h2v2zm0-4h-2V1h2v5zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
                }
            }
        ]
    })(props);
}
function MdPublishedWithChanges(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 9.53l-7.07 7.07-4.24-4.24 1.41-1.41 2.83 2.83 5.66-5.66 1.41 1.41zM4 12c0-2.33 1.02-4.42 2.62-5.88L9 8.5v-6H3l2.2 2.2C3.24 6.52 2 9.11 2 12c0 5.19 3.95 9.45 9 9.95v-2.02c-3.94-.49-7-3.86-7-7.93zm18 0c0-5.19-3.95-9.45-9-9.95v2.02c3.94.49 7 3.86 7 7.93 0 2.33-1.02 4.42-2.62 5.88L15 15.5v6h6l-2.2-2.2c1.96-1.82 3.2-4.41 3.2-7.3z"
                }
            }
        ]
    })(props);
}
function MdQueryBuilder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function MdQuestionAnswer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdQuestionMark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15zM14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function MdQuickreply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-8h7V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
                }
            }
        ]
    })(props);
}
function MdRebaseEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "5",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.76 9.24L15 5 10.76.76 9.34 2.17 11.17 4H7.82C7.4 2.84 6.3 2 5 2 3.34 2 2 3.34 2 5c0 1.3.84 2.4 2 2.82v8.37C2.84 16.6 2 17.7 2 19c0 1.66 1.34 3 3 3s3-1.34 3-3c0-1.3-.84-2.4-2-2.82V7.82c.85-.31 1.51-.97 1.82-1.82h3.36L9.34 7.83l1.42 1.41zM10 19v3h3l6.26-6.26-3-3zM20.12 10.29a.996.996 0 00-1.41 0l-1.38 1.38 3 3 1.38-1.38a.996.996 0 000-1.41l-1.59-1.59z"
                }
            }
        ]
    })(props);
}
function MdReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
                }
            }
        ]
    })(props);
}
function MdRecordVoiceOver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
                }
            }
        ]
    })(props);
}
function MdRedeem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function MdRemoveDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.79 12l5.58 5.59L5.96 19 .37 13.41 1.79 12zm.45-7.78L12.9 14.89l-1.28 1.28L7.44 12l-1.41 1.41L11.62 19l2.69-2.69 4.89 4.89 1.41-1.41L3.65 2.81 2.24 4.22zm14.9 9.27L23.62 7 22.2 5.59l-6.48 6.48 1.42 1.42zM17.96 7l-1.41-1.41-3.65 3.66 1.41 1.41L17.96 7z"
                }
            }
        ]
    })(props);
}
function MdRemoveShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0017 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdReorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
                }
            }
        ]
    })(props);
}
function MdRepartition(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-6H3v6zm7.33-2v-2h3.33v2h-3.33zM19 19h-3.33v-2H19v2zM5 17h3.33v2H5v-2zM6 10l1.42-1.42L5.83 7H17c1.1 0 2 .9 2 2s-.9 2-2 2H3v2h14c2.21 0 4-1.79 4-4s-1.79-4-4-4H5.83l1.59-1.59L6 2 2 6l4 4z"
                }
            }
        ]
    })(props);
}
function MdReportProblem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdRequestPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm1 9h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V8h2v1h2v2z"
                }
            }
        ]
    })(props);
}
function MdRestoreFromTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-3.5l-1-1h-5l-1 1H5v2h14zM6 7v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zm8 7v4h-4v-4H8l4-4 4 4h-2z"
                }
            }
        ]
    })(props);
}
function MdRestorePage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5a3.5 3.5 0 00-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
                }
            }
        ]
    })(props);
}
function MdRocketLaunch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.19 6.35c-2.04 2.29-3.44 5.58-3.57 5.89L2 10.69l4.05-4.05c.47-.47 1.15-.68 1.81-.55l1.33.26zM11.17 17s3.74-1.55 5.89-3.7c5.4-5.4 4.5-9.62 4.21-10.57-.95-.3-5.17-1.19-10.57 4.21C8.55 9.09 7 12.83 7 12.83L11.17 17zm6.48-2.19c-2.29 2.04-5.58 3.44-5.89 3.57L13.31 22l4.05-4.05c.47-.47.68-1.15.55-1.81l-.26-1.33zM9 18c0 .83-.34 1.58-.88 2.12C6.94 21.3 2 22 2 22s.7-4.94 1.88-6.12A2.996 2.996 0 019 18zm4-9c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function MdRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.5s4.5 2.04 4.5 10.5c0 2.49-1.04 5.57-1.6 7H9.1c-.56-1.43-1.6-4.51-1.6-7C7.5 4.54 12 2.5 12 2.5zm2 8.5c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-6.31 9.52c-.48-1.23-1.52-4.17-1.67-6.87l-1.13.75c-.56.38-.89 1-.89 1.67V22l3.69-1.48zM20 22v-5.93c0-.67-.33-1.29-.89-1.66l-1.13-.75c-.15 2.69-1.2 5.64-1.67 6.87L20 22z"
                }
            }
        ]
    })(props);
}
function MdRoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdRoundedCorner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
                }
            }
        ]
    })(props);
}
function MdRowing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.35-.39.99-.73 1.65-.73h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
                }
            }
        ]
    })(props);
}
function MdRule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z"
                }
            }
        ]
    })(props);
}
function MdSatelliteAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.44.59l-3.18 3.18c-.78.78-.78 2.05 0 2.83l1.24 1.24-.71.71-1.24-1.25c-.78-.78-2.05-.78-2.83 0L7.3 8.72c-.78.78-.78 2.05 0 2.83l1.24 1.24-.71.71-1.23-1.25c-.78-.78-2.05-.78-2.83 0L.59 15.43c-.78.78-.78 2.05 0 2.83l3.54 3.54c.78.78 2.05.78 2.83 0l3.18-3.18c.78-.78.78-2.05 0-2.83L8.9 14.55l.71-.71 1.24 1.24c.78.78 2.05.78 2.83 0l1.41-1.41c.78-.78.78-2.05 0-2.83L13.84 9.6l.71-.71 1.24 1.24c.78.78 2.05.78 2.83 0l3.18-3.18c.78-.78.78-2.05 0-2.83L18.26.58c-.78-.78-2.04-.78-2.82.01zM6.6 19.32l-1.06 1.06L2 16.85l1.06-1.06 3.54 3.53zm2.12-2.12l-1.06 1.06-3.54-3.54 1.06-1.06 3.54 3.54zm9.54-9.54L17.2 8.72l-3.54-3.54 1.06-1.06 3.54 3.54zm2.12-2.12L19.32 6.6l-3.54-3.54L16.85 2l3.53 3.54zM14 21v2a9 9 0 009-9h-2c0 3.87-3.13 7-7 7zm0-4v2c2.76 0 5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdSavedSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm-2.17-1.5l2.14-1.53 2.14 1.53-.83-2.46 2.15-1.5h-2.62L9.47 6l-.84 2.54H6l2.14 1.49z"
                }
            }
        ]
    })(props);
}
function MdSavings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.83 7.5l-2.27-2.27c.07-.42.18-.81.32-1.15A1.498 1.498 0 0016.5 2c-1.64 0-3.09.79-4 2h-5C4.46 4 2 6.46 2 9.5S4.5 21 4.5 21H10v-2h2v2h5.5l1.68-5.59 2.82-.94V7.5h-2.17zM13 9H8V7h5v2zm3 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdScheduleSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12.5H15v4l3 2 .75-1.23-2.25-1.52V12.5zM16 9L2 3v7l9 2-9 2v7l7.27-3.11C10.09 20.83 12.79 23 16 23c3.86 0 7-3.14 7-7s-3.14-7-7-7zm0 12c-2.75 0-4.98-2.22-5-4.97v-.07a5.008 5.008 0 015-4.97c2.76 0 5 2.24 5 5S18.76 21 16 21z"
                }
            }
        ]
    })(props);
}
function MdSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function MdSearchOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 009.5 3C6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.47 10.82L4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
                }
            }
        ]
    })(props);
}
function MdSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            }
        ]
    })(props);
}
function MdSegment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z"
                }
            }
        ]
    })(props);
}
function MdSendAndArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-3L2 3v7l9 2-9 2v7l8-3.5V21c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm0 11h-9v-9h9v9zm-4.5-1L13 16h2v-3h3v3h2l-3.5 4z"
                }
            }
        ]
    })(props);
}
function MdSensorsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.14 10.96c-.09.33-.14.68-.14 1.04 0 1.1.45 2.1 1.17 2.83l-1.42 1.42A6.018 6.018 0 016 12c0-.93.21-1.8.58-2.59L5.11 7.94A7.897 7.897 0 004 12c0 2.21.9 4.21 2.35 5.65l-1.42 1.42A9.969 9.969 0 012 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L8.14 10.96zm9.28 3.63c.37-.79.58-1.66.58-2.59 0-1.66-.67-3.16-1.76-4.24l-1.42 1.42a3.951 3.951 0 011.04 3.86l1.56 1.55zM20 12c0 1.48-.4 2.87-1.11 4.06l1.45 1.45A9.91 9.91 0 0022 12c0-2.76-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12z"
                }
            }
        ]
    })(props);
}
function MdSensors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.76 16.24C6.67 15.16 6 13.66 6 12s.67-3.16 1.76-4.24l1.42 1.42C8.45 9.9 8 10.9 8 12c0 1.1.45 2.1 1.17 2.83l-1.41 1.41zm8.48 0C17.33 15.16 18 13.66 18 12s-.67-3.16-1.76-4.24l-1.42 1.42C15.55 9.9 16 10.9 16 12c0 1.1-.45 2.1-1.17 2.83l1.41 1.41zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8 2c0 2.21-.9 4.21-2.35 5.65l1.42 1.42C20.88 17.26 22 14.76 22 12s-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12zM6.35 6.35L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.42-1.42C4.9 16.21 4 14.21 4 12s.9-4.21 2.35-5.65z"
                }
            }
        ]
    })(props);
}
function MdSettingsAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 4c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 6c1.86.5 4 .83 6 1v12h2v-6h2v6h2V7c2-.17 4.14-.5 6-1l-.5-2zM12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdSettingsApplications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.353.353 0 01.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16a.353.353 0 01-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
                }
            }
        ]
    })(props);
}
function MdSettingsBackupRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9a9 9 0 00-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 01-11.06 5.7l-1.42 1.44A9 9 0 1012 3z"
                }
            }
        ]
    })(props);
}
function MdSettingsBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdSettingsBrightness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
                }
            }
        ]
    })(props);
}
function MdSettingsCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
                }
            }
        ]
    })(props);
}
function MdSettingsEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
                }
            }
        ]
    })(props);
}
function MdSettingsInputAntenna(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 00-5 0c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2a9 9 0 0118 0h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function MdSettingsInputComponent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
                }
            }
        ]
    })(props);
}
function MdSettingsInputComposite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
                }
            }
        ]
    })(props);
}
function MdSettingsInputHdmi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
                }
            }
        ]
    })(props);
}
function MdSettingsInputSvideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdSettingsOverscan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function MdSettingsPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"
                }
            }
        ]
    })(props);
}
function MdSettingsPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45A5.969 5.969 0 0118 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 004 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdSettingsRemote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41a5.022 5.022 0 017.08 0l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
                }
            }
        ]
    })(props);
}
function MdSettingsVoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
                }
            }
        ]
    })(props);
}
function MdSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.488.488 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                }
            }
        ]
    })(props);
}
function MdShop2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h16v-2H3V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3.5L12 15z"
                }
            }
        ]
    })(props);
}
function MdShopTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
                }
            }
        ]
    })(props);
}
function MdShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
                }
            }
        ]
    })(props);
}
function MdShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8 4c0 .55-.45 1-1 1s-1-.45-1-1V8h2v2zm2-6c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm4 6c0 .55-.45 1-1 1s-1-.45-1-1V8h2v2z"
                }
            }
        ]
    })(props);
}
function MdShoppingBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.21 9l-4.38-6.56a.993.993 0 00-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdShoppingCartCheckout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM12 2l4 4-4 4-1.41-1.41L12.17 7H8V5h4.17l-1.59-1.59L12 2z"
                }
            }
        ]
    })(props);
}
function MdShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdSmartButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9v6c0 1.1-.9 2-2 2h-1v-2h1V9H4v6h6v2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-7.5 10l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14zm-2.5 5l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14z"
                }
            }
        ]
    })(props);
}
function MdSource(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"
                }
            }
        ]
    })(props);
}
function MdSpaceDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6v18zm2 0h6c1.1 0 2-.9 2-2v-7h-8v9zm8-11V5c0-1.1-.9-2-2-2h-6v7h8z"
                }
            }
        ]
    })(props);
}
function MdSpatialAudioOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM20.36 1l-1.41 1.41a7.007 7.007 0 010 9.9l1.41 1.41a8.98 8.98 0 000-12.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.54 10.9a5.003 5.003 0 000-7.07l-1.41 1.41a3 3 0 010 4.24l1.41 1.42z"
                }
            }
        ]
    })(props);
}
function MdSpatialAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 1h-2a9 9 0 009 9V8c-3.86 0-7-3.14-7-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1h-2c0 2.76 2.24 5 5 5V4c-1.65 0-3-1.35-3-3z"
                }
            }
        ]
    })(props);
}
function MdSpatialTracking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "9",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM20.05 2.41L18.64 1c-3.51 3.51-3.51 9.21 0 12.73l1.41-1.41c-2.73-2.74-2.73-7.18 0-9.91z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.88 5.24l-1.41-1.41a5.003 5.003 0 000 7.07l1.41-1.41a3.012 3.012 0 010-4.25z"
                }
            }
        ]
    })(props);
}
function MdSpeakerNotesOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdSpeakerNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
                }
            }
        ]
    })(props);
}
function MdSpellcheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdStarRate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.43 10L12 2l-2.43 8H2l6.18 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10z"
                }
            }
        ]
    })(props);
}
function MdStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
                }
            }
        ]
    })(props);
}
function MdStickyNote2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99C3.89 3 3 3.9 3 5l.01 14c0 1.1.89 2 1.99 2h10l6-6V5c0-1.1-.9-2-2-2zM7 8h10v2H7V8zm5 6H7v-2h5v2zm2 5.5V14h5.5L14 19.5z"
                }
            }
        ]
    })(props);
}
function MdStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
                }
            }
        ]
    })(props);
}
function MdSubject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function MdSubtitlesOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6.83l8 8H20v2h-3.17l4.93 4.93c.15-.28.24-.59.24-.93V6c0-1.1-.9-2-2-2zM1.04 3.87l1.2 1.2C2.09 5.35 2 5.66 2 6v12c0 1.1.9 2 2 2h13.17l2.96 2.96 1.41-1.41L2.45 2.45 1.04 3.87zM8 12v2H4v-2h4zm6 4.83V18H4v-2h9.17l.83.83z"
                }
            }
        ]
    })(props);
}
function MdSupervisedUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93zm-6-1.58c1.3 0 2.36 1.06 2.36 2.36 0 1.3-1.06 2.36-2.36 2.36s-2.36-1.06-2.36-2.36c0-1.31 1.05-2.36 2.36-2.36zm0 9.13v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68zM11.99 20c-.27 0-.53-.01-.79-.04v-4.07c0-1.42 2.94-2.13 4.4-2.13 1.07 0 2.92.39 3.84 1.15-1.17 2.97-4.06 5.09-7.45 5.09z"
                }
            }
        ]
    })(props);
}
function MdSupervisorAccount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7a2.5 2.5 0 000 5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
                }
            }
        ]
    })(props);
}
function MdSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12l-2.78 1.15a4.982 4.982 0 00-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 00-2.98 2.97L4.54 9.13a7.984 7.984 0 014.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 002.97 2.96l-1.17 2.78a7.996 7.996 0 01-4.58-4.59zm10.34 4.59l-1.15-2.78a4.978 4.978 0 002.95-2.97l2.78 1.17a8.007 8.007 0 01-4.58 4.58z"
                }
            }
        ]
    })(props);
}
function MdSwapHoriz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
                }
            }
        ]
    })(props);
}
function MdSwapHorizontalCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.5 3.5-3.5 3.5V11h-4V9h4V6.5zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5z"
                }
            }
        ]
    })(props);
}
function MdSwapVert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                }
            }
        ]
    })(props);
}
function MdSwapVerticalCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"
                }
            }
        ]
    })(props);
}
function MdSwipeDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13.9a5 5 0 10-2 0v4.27l-1.59-1.59L8 18l4 4 4-4-1.41-1.41L13 18.17V13.9z"
                }
            }
        ]
    })(props);
}
function MdSwipeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.8 12.18c-.2-.86-.3-1.76-.3-2.68 0-2.84.99-5.45 2.63-7.5L7.2 3.07a10.457 10.457 0 00-1.88 8.99l1.62-1.62L8 11.5 4.5 15 1 11.5l1.06-1.06 1.74 1.74zm10.05-.56l-2.68-5.37a1.498 1.498 0 00-2.01-.67c-.75.38-1.05 1.28-.68 2.02l4.81 9.6-3.24.8c-.33.09-.59.33-.7.66L9 19.78l6.19 2.25c.5.17 1.28.02 1.75-.22l5.51-2.75c.89-.45 1.32-1.48 1-2.42l-1.43-4.27a2 2 0 00-1.9-1.37h-4.56c-.31 0-.62.07-.89.21l-.82.41"
                }
            }
        ]
    })(props);
}
function MdSwipeLeftAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 13a5 5 0 100-2H5.83l1.59-1.59L6 8l-4 4 4 4 1.41-1.41L5.83 13h4.27z"
                }
            }
        ]
    })(props);
}
function MdSwipeLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 16.82l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L5 17.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07zM12 2.5c4.74 0 7.67 2.52 8.43 4.5H22c-.73-2.88-4.51-6-10-6-3.22 0-6.18 1.13-8.5 3.02V2H2v5h5V5.5H4.09c2.12-1.86 4.88-3 7.91-3z"
                }
            }
        ]
    })(props);
}
function MdSwipeRightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 11a5 5 0 100 2h4.27l-1.59 1.59L18 16l4-4-4-4-1.41 1.41L18.17 11H13.9z"
                }
            }
        ]
    })(props);
}
function MdSwipeRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 16.82l-.63 4.46c-.14.99-.99 1.72-1.98 1.72h-6.16c-.53 0-1.29-.21-1.66-.59L5 17.62l.83-.84c.24-.24.58-.35.92-.28l3.25.74V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v6h.91c.31 0 .62.07.89.21l4.09 2.04c.77.39 1.21 1.22 1.09 2.07zM19.91 5.5H17V7h5V2h-1.5v2.02A13.413 13.413 0 0012 1C6.51 1 2.73 4.12 2 7h1.57C4.33 5.02 7.26 2.5 12 2.5c3.03 0 5.79 1.14 7.91 3z"
                }
            }
        ]
    })(props);
}
function MdSwipeUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.59 1.59L16 6l-4-4-4 4 1.41 1.41L11 5.83v4.27a5 5 0 102 0V5.83z"
                }
            }
        ]
    })(props);
}
function MdSwipeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.06 5.56L1 4.5 4.5 1 8 4.5 6.94 5.56 5.32 3.94a10.457 10.457 0 001.88 8.99L6.13 14A11.974 11.974 0 013.5 6.5c0-.92.1-1.82.3-2.68L2.06 5.56zm11.79 6.06l-2.68-5.37a1.498 1.498 0 00-2.01-.67c-.75.38-1.05 1.28-.68 2.02l4.81 9.6-3.24.8c-.33.09-.59.33-.7.66L9 19.78l6.19 2.25c.5.17 1.28.02 1.75-.22l5.51-2.75c.89-.45 1.32-1.48 1-2.42l-1.43-4.27a2 2 0 00-1.9-1.37h-4.56c-.31 0-.62.07-.89.21l-.82.41"
                }
            }
        ]
    })(props);
}
function MdSwipeVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.5h2.02C1.13 5.82 0 8.78 0 12s1.13 6.18 3.02 8.5H1V22h5v-5H4.5v2.91c-1.86-2.11-3-4.88-3-7.91s1.14-5.79 3-7.91V7H6V2H1v1.5zm12.85 8.12l-2.68-5.37a1.498 1.498 0 00-2.01-.67c-.75.38-1.05 1.28-.68 2.02l4.81 9.6-3.24.8c-.33.09-.59.33-.7.66L9 19.78l6.19 2.25c.5.17 1.28.02 1.75-.22l5.51-2.75c.89-.45 1.32-1.48 1-2.42l-1.43-4.27a2 2 0 00-1.9-1.37h-4.56c-.31 0-.62.07-.89.21l-.82.41"
                }
            }
        ]
    })(props);
}
function MdSwipe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 14.75l-4.09-2.04c-.28-.14-.58-.21-.89-.21H13v-6c0-.83-.67-1.5-1.5-1.5S10 5.67 10 6.5v10.74l-3.25-.74a.99.99 0 00-.92.28l-.83.84 4.54 4.79c.38.38 1.14.59 1.67.59h6.16c1 0 1.84-.73 1.98-1.72l.63-4.46c.12-.85-.32-1.68-1.09-2.07z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.13 3.87C18.69 2.17 15.6 1 12 1S5.31 2.17 3.87 3.87L2 2v5h5L4.93 4.93c1-1.29 3.7-2.43 7.07-2.43s6.07 1.14 7.07 2.43L17 7h5V2l-1.87 1.87z"
                }
            }
        ]
    })(props);
}
function MdSwitchAccessShortcutAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 14h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2zM7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-2.73 1.08-5.27 2.75-7.25L12 2h7v7l-2.82-2.82C14.84 7.82 14 9.88 14 12c0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10z"
                }
            }
        ]
    })(props);
}
function MdSwitchAccessShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-2.73 1.08-5.27 2.75-7.25L12 2h7v7l-2.82-2.82C14.84 7.82 14 9.88 14 12c0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10z"
                }
            }
        ]
    })(props);
}
function MdSyncAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12l4-4-4-4v3H3v2h15zM6 12l-4 4 4 4v-3h15v-2H6z"
                }
            }
        ]
    })(props);
}
function MdSystemUpdateAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 .5h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdTabUnselected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
                }
            }
        ]
    })(props);
}
function MdTableView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z"
                }
            }
        ]
    })(props);
}
function MdTaskAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zm-2.21 5.04c.13.57.21 1.17.21 1.78 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.58 0 3.04.46 4.28 1.25l1.44-1.44A9.9 9.9 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.19-.22-2.33-.6-3.39l-1.61 1.61z"
                }
            }
        ]
    })(props);
}
function MdTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zm-2-1h-6v-2h6v2zM7.5 17l-1.41-1.41L8.67 13l-2.59-2.59L7.5 9l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdTextRotateUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12v1.5l11 4.75v-2.1l-2.2-.9v-5l2.2-.9v-2.1L3 12zm7 2.62l-5.02-1.87L10 10.88v3.74zm8-10.37l-3 3h2v12.5h2V7.25h2l-3-3z"
                }
            }
        ]
    })(props);
}
function MdTextRotateVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
                }
            }
        ]
    })(props);
}
function MdTextRotationAngledown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.4 4.91l-1.06-1.06L7.2 8.27l1.48 1.48 2.19-.92 3.54 3.54-.92 2.19 1.48 1.48L19.4 4.91zm-6.81 3.1l4.87-2.23-2.23 4.87-2.64-2.64zM14.27 21v-4.24l-1.41 1.41-8.84-8.84-1.42 1.42 8.84 8.84L10.03 21h4.24z"
                }
            }
        ]
    })(props);
}
function MdTextRotationAngleup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.49 4.21L3.43 5.27 7.85 16.4l1.48-1.48-.92-2.19 3.54-3.54 2.19.92 1.48-1.48L4.49 4.21zm3.09 6.8L5.36 6.14l4.87 2.23-2.65 2.64zm12.99-1.68h-4.24l1.41 1.41-8.84 8.84L10.32 21l8.84-8.84 1.41 1.41V9.33z"
                }
            }
        ]
    })(props);
}
function MdTextRotationDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v-1.5L10 5.75v2.1l2.2.9v5l-2.2.9v2.1L21 12zm-7-2.62l5.02 1.87L14 13.12V9.38zM6 19.75l3-3H7V4.25H5v12.5H3l3 3z"
                }
            }
        ]
    })(props);
}
function MdTextRotationNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 3h-1.5L6.5 14h2.1l.9-2.2h5l.9 2.2h2.1L12.75 3zm-2.62 7L12 4.98 13.87 10h-3.74zm10.37 8l-3-3v2H5v2h12.5v2l3-3z"
                }
            }
        ]
    })(props);
}
function MdTheaters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdThumbDownOffAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.89 18.28l.57-2.89c.12-.59-.04-1.2-.42-1.66-.38-.46-.94-.73-1.54-.73H4v-1.08L6.57 6h8.09c.18 0 .34.16.34.34v7.84l-4.11 4.1M10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22zm10-7h2V4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdThumbDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
                }
            }
        ]
    })(props);
}
function MdThumbUpOffAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.11 5.72l-.57 2.89c-.12.59.04 1.2.42 1.66.38.46.94.73 1.54.73H20v1.08L17.43 18H9.34a.35.35 0 01-.34-.34V9.82l4.11-4.1M14 2L7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.83C7 18.95 8.05 20 9.34 20h8.1c.71 0 1.36-.37 1.72-.97l2.67-6.15c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 00-.88-1.22L14 2zM4 9H2v11h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdThumbUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                }
            }
        ]
    })(props);
}
function MdThumbsUpDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdTimeline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8c0 1.1-.9 2-2 2a1.7 1.7 0 01-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A1.7 1.7 0 0119 8c0-1.1.9-2 2-2s2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function MdTipsAndUpdates(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-2-1h8v-2H5v2zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H5.27c-1.11-.64-3.77-2.68-3.77-6.5C1.5 5.36 4.86 2 9 2s7.5 3.36 7.5 7.5zm4.87-2.13L20 8l1.37.63L22 10l.63-1.37L24 8l-1.37-.63L22 6l-.63 1.37zM19 6l.94-2.06L22 3l-2.06-.94L19 0l-.94 2.06L16 3l2.06.94L19 6z"
                }
            }
        ]
    })(props);
}
function MdToc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
                }
            }
        ]
    })(props);
}
function MdToken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.97 6.43L12 2 4.03 6.43 9.1 9.24C9.83 8.48 10.86 8 12 8s2.17.48 2.9 1.24l5.07-2.81zM10 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm1 9.44L3 17V8.14l5.13 2.85c-.09.32-.13.66-.13 1.01 0 1.86 1.27 3.43 3 3.87v5.57zm2 0v-5.57c1.73-.44 3-2.01 3-3.87 0-.35-.04-.69-.13-1.01L21 8.14V17l-8 4.44z"
                }
            }
        ]
    })(props);
}
function MdToll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12a5.99 5.99 0 014-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09A5.99 5.99 0 013 12z"
                }
            }
        ]
    })(props);
}
function MdTouchApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11.24V7.5a2.5 2.5 0 015 0v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74c-3.6-.76-3.54-.75-3.67-.75-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
                }
            }
        ]
    })(props);
}
function MdTour(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H7V2H5v20h2v-8h14l-2-5 2-5zm-6 5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function MdTrackChanges(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93l-1.41 1.41A8.014 8.014 0 0120 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
                }
            }
        ]
    })(props);
}
function MdTranscribe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.93 16l1.63-1.63c-2.77-3.02-2.77-7.56 0-10.74L17.93 2c-3.9 3.89-3.91 9.95 0 14zm4.99-5.05a3.317 3.317 0 010-3.89l-1.68-1.69c-2.02 2.02-2.02 5.07 0 7.27l1.68-1.69zM9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm6.39 2.56C13.71 14.7 11.53 14 9 14s-4.71.7-6.39 1.56A2.97 2.97 0 001 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66z"
                }
            }
        ]
    })(props);
}
function MdTranslate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0014.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                }
            }
        ]
    })(props);
}
function MdTrendingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
                }
            }
        ]
    })(props);
}
function MdTrendingFlat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12l-4-4v3H3v2h15v3z"
                }
            }
        ]
    })(props);
}
function MdTrendingUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
                }
            }
        ]
    })(props);
}
function MdTroubleshoot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20.59l-4.69-4.69A7.902 7.902 0 0019 11c0-4.42-3.58-8-8-8-4.08 0-7.44 3.05-7.93 7h2.02C5.57 7.17 8.03 5 11 5c3.31 0 6 2.69 6 6s-2.69 6-6 6c-2.42 0-4.5-1.44-5.45-3.5H3.4C4.45 16.69 7.46 19 11 19c1.85 0 3.55-.63 4.9-1.69L20.59 22 22 20.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43 9.69L9.65 15h1.64l1.26-3.78.95 2.28h2V12h-1l-1.25-3h-1.54l-1.12 3.37L9.35 7H7.7l-1.25 4H1v1.5h6.55z"
                }
            }
        ]
    })(props);
}
function MdTry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6.43 9.57L12 15l-1.57-3.43L7 10l3.43-1.57L12 5l1.57 3.43L17 10l-3.43 1.57z"
                }
            }
        ]
    })(props);
}
function MdTurnedInNot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function MdTurnedIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdUnfoldLessDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 1.41L15.16 0l-3.17 3.17L8.82 0 7.41 1.41 11.99 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 6.41L15.16 5l-3.17 3.17L8.82 5 7.41 6.41 11.99 11zM7.42 17.59L8.84 19l3.17-3.17L15.18 19l1.41-1.41L12.01 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.42 22.59L8.84 24l3.17-3.17L15.18 24l1.41-1.41L12.01 18z"
                }
            }
        ]
    })(props);
}
function MdUnfoldMoreDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.83L15.17 11l1.41-1.41L12 5 7.41 9.59 8.83 11 12 7.83zm0-5L15.17 6l1.41-1.41L12 0 7.41 4.59 8.83 6 12 2.83zm0 18.34L8.83 18l-1.41 1.41L12 24l4.59-4.59L15.17 18 12 21.17zm0-5L8.83 13l-1.41 1.41L12 19l4.59-4.59L15.17 13 12 16.17z"
                }
            }
        ]
    })(props);
}
function MdUnpublished(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.42zm-10.6-4.59l-4.24-4.24 1.41-1.41 2.83 2.83.18-.18 1.41 1.41-1.59 1.59zm3-5.84l-7.1-7.1A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51L15 12.17l2.65-2.65-1.41-1.41-2.65 2.65z"
                }
            }
        ]
    })(props);
}
function MdUpdateDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.67 5.84L7.22 4.39A8.86 8.86 0 0112 3c2.74 0 5.19 1.23 6.84 3.16L21 4v6h-6l2.41-2.41C16.12 6.02 14.18 5 12 5c-1.2 0-2.34.31-3.33.84zM13 7h-2v1.17l2 2V7zm6.78 15.61l-3-3A8.973 8.973 0 0112 21a9 9 0 01-9-9c0-1.76.51-3.4 1.39-4.78l-3-3L2.8 2.81l18.38 18.38-1.4 1.42zm-4.46-4.46L5.84 8.67A7.06 7.06 0 005 12c0 3.86 3.14 7 7 7 1.2 0 2.34-.31 3.32-.85zM20.94 13h-2.02c-.12.83-.39 1.61-.77 2.32l1.47 1.47c.7-1.12 1.17-2.41 1.32-3.79z"
                }
            }
        ]
    })(props);
}
function MdUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
                }
            }
        ]
    })(props);
}
function MdUpgrade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18v2H8v-2h8zM11 7.99V16h2V7.99h3L12 4 8 7.99h3z"
                }
            }
        ]
    })(props);
}
function MdVerifiedUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
                }
            }
        ]
    })(props);
}
function MdVerified(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
                }
            }
        ]
    })(props);
}
function MdVerticalSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h8v-2H3v2zm0 4h8v-2H3v2zm0-8h8V9H3v2zm0-6v2h8V5H3zm10 0h8v14h-8V5z"
                }
            }
        ]
    })(props);
}
function MdViewAgenda(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdViewArray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z"
                }
            }
        ]
    })(props);
}
function MdViewCarousel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h4v10H2V7zm5 12h10V5H7v14zM18 7h4v10h-4V7z"
                }
            }
        ]
    })(props);
}
function MdViewColumn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.67 5v14H9.33V5h5.34zm1 14H21V5h-5.33v14zm-7.34 0V5H3v14h5.33z"
                }
            }
        ]
    })(props);
}
function MdViewComfyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-9 13H7v-4h4v4zm0-6H7V7h4v4zm6 6h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function MdViewCompactAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.5 12.5h-4v-4h4v4zm0-5h-4v-4h4v4zm5 5h-4v-4h4v4zm0-5h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdViewCozy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8.75 12.75h-4v-4h4v4zm0-5.5h-4v-4h4v4zm5.5 5.5h-4v-4h4v4zm0-5.5h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdViewDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
                }
            }
        ]
    })(props);
}
function MdViewHeadline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function MdViewInAr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.25 7.6l-5.5-3.18a1.49 1.49 0 00-1.5 0L5.75 7.6c-.46.27-.75.76-.75 1.3v6.35c0 .54.29 1.03.75 1.3l5.5 3.18c.46.27 1.04.27 1.5 0l5.5-3.18c.46-.27.75-.76.75-1.3V8.9c0-.54-.29-1.03-.75-1.3zM7 14.96v-4.62l4 2.32v4.61l-4-2.31zm5-4.03L8 8.61l4-2.31 4 2.31-4 2.32zm1 6.34v-4.61l4-2.32v4.62l-4 2.31zM7 2H3.5C2.67 2 2 2.67 2 3.5V7h2V4h3V2zm10 0h3.5c.83 0 1.5.67 1.5 1.5V7h-2V4h-3V2zM7 22H3.5c-.83 0-1.5-.67-1.5-1.5V17h2v3h3v2zm10 0h3.5c.83 0 1.5-.67 1.5-1.5V17h-2v3h-3v2z"
                }
            }
        ]
    })(props);
}
function MdViewKanban(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7V7h2v10zm4-5h-2V7h2v5zm4 3h-2V7h2v8z"
                }
            }
        ]
    })(props);
}
function MdViewList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h13v-4H8v4zm0 5h13v-4H8v4zM8 5v4h13V5H8z"
                }
            }
        ]
    })(props);
}
function MdViewModule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.67 5v6.5H9.33V5h5.34zm1 6.5H21V5h-5.33v6.5zm-1 7.5v-6.5H9.33V19h5.34zm1-6.5V19H21v-6.5h-5.33zm-7.34 0H3V19h5.33v-6.5zm0-1V5H3v6.5h5.33z"
                }
            }
        ]
    })(props);
}
function MdViewQuilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v6.5H9.33V5H21zm-6.33 14v-6.5H9.33V19h5.34zm1-6.5V19H21v-6.5h-5.33zM8.33 19V5H3v14h5.33z"
                }
            }
        ]
    })(props);
}
function MdViewSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 20H2V4h14v16zm2-12h4V4h-4v4zm0 12h4v-4h-4v4zm0-6h4v-4h-4v4z"
                }
            }
        ]
    })(props);
}
function MdViewStream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17v-2c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2zM3 7v2c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function MdViewTimeline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H6v-2h6v2zm3-4H9v-2h6v2zm3-4h-6V7h6v2z"
                }
            }
        ]
    })(props);
}
function MdViewWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.33 20H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h1.33c1.1 0 2 .9 2 2v12a2 2 0 01-2 2zM22 18V6c0-1.1-.9-2-2-2h-1.33c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2H20a2 2 0 002-2zm-7.33 0V6c0-1.1-.9-2-2-2h-1.33c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h1.33c1.1 0 2-.9 2-2z"
                }
            }
        ]
    })(props);
}
function MdVisibilityOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
                }
            }
        ]
    })(props);
}
function MdVisibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdVoiceOverOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.99 9.18c0-.06.01-.12.01-.18 0-2.21-1.79-4-4-4-.06 0-.12.01-.18.01l4.17 4.17zm-6.1-3.56L4.27 3 3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62L19.73 21 21 19.73l-8.62-8.62-5.49-5.49zM9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
                }
            }
        ]
    })(props);
}
function MdWatchLater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
                }
            }
        ]
    })(props);
}
function MdWebhook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h5.88c.27-.31.67-.5 1.12-.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.44 0-.84-.19-1.12-.5H11.9A5 5 0 116 11.1v2.07c-1.16.41-2 1.53-2 2.83 0 1.65 1.35 3 3 3s3-1.35 3-3v-1zm2.5-11c1.65 0 3 1.35 3 3h2c0-2.76-2.24-5-5-5a5.002 5.002 0 00-3.45 8.62l-2.35 3.9c-.68.14-1.2.75-1.2 1.48 0 .83.67 1.5 1.5 1.5a1.498 1.498 0 001.43-1.95l3.38-5.63A3.003 3.003 0 019.5 7c0-1.65 1.35-3 3-3zm4.5 9c-.64 0-1.23.2-1.72.54l-3.05-5.07C11.53 8.35 11 7.74 11 7c0-.83.67-1.5 1.5-1.5S14 6.17 14 7c0 .15-.02.29-.06.43l2.19 3.65c.28-.05.57-.08.87-.08 2.76 0 5 2.24 5 5s-2.24 5-5 5a5 5 0 01-4.33-2.5h2.67c.48.32 1.05.5 1.66.5 1.65 0 3-1.35 3-3s-1.35-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdWidthFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h1v12H4V6zm16 12h-1V6h1v12z"
                }
            }
        ]
    })(props);
}
function MdWidthNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h4v12H4V6zm16 12h-4V6h4v12z"
                }
            }
        ]
    })(props);
}
function MdWidthWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h2v12H4V6zm16 12h-2V6h2v12z"
                }
            }
        ]
    })(props);
}
function MdWifiProtectedSetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.71 5.29L19 3h-8v8l2.3-2.3c1.97 1.46 3.25 3.78 3.25 6.42 0 1.31-.32 2.54-.88 3.63 2.33-1.52 3.88-4.14 3.88-7.13 0-2.52-1.11-4.77-2.84-6.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.46 8.88c0-1.31.32-2.54.88-3.63a8.479 8.479 0 00-3.88 7.13c0 2.52 1.1 4.77 2.84 6.33L5 21h8v-8l-2.3 2.3c-1.96-1.46-3.24-3.78-3.24-6.42z"
                }
            }
        ]
    })(props);
}
function MdWorkHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c1.49 0 2.87.47 4 1.26V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h7.68A6.995 6.995 0 0118 11zm-8-7h4v2h-4V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function MdWorkOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 21.74l-1.46-1.46L7.21 5.95 3.25 1.99 1.99 3.25l2.7 2.7h-.64c-1.11 0-1.99.89-1.99 2l-.01 11c0 1.11.89 2 2 2h15.64L21.74 23 23 21.74zM22 7.95c.05-1.11-.84-2-1.95-1.95h-4V3.95c0-1.11-.89-2-2-1.95h-4c-1.11-.05-2 .84-2 1.95v.32l13.95 14V7.95zM14.05 6H10V3.95h4.05V6z"
                }
            }
        ]
    })(props);
}
function MdWorkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
                }
            }
        ]
    })(props);
}
function MdWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                }
            }
        ]
    })(props);
}
function MdWysiwyg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2z"
                }
            }
        ]
    })(props);
}
function MdYoutubeSearchedFor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.01 14h-.8l-.27-.27a6.451 6.451 0 001.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51a4.5 4.5 0 019 0 4.507 4.507 0 01-6.32 4.12L7.71 15.1a6.474 6.474 0 007.52-.67l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
                }
            }
        ]
    })(props);
}
function MdZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
                }
            }
        ]
    })(props);
}
function MdZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
                }
            }
        ]
    })(props);
}
function MdAddAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72A6.873 6.873 0 005.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
                }
            }
        ]
    })(props);
}
function MdAutoDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2h-3.5l-1-1h-5l-1 1H1v2h14zM16 9c-.7 0-1.37.1-2 .29V5H2v12c0 1.1.9 2 2 2h5.68A6.999 6.999 0 0023 16c0-3.87-3.13-7-7-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12H15v5l3.6 2.1.8-1.2-2.9-1.7z"
                }
            }
        ]
    })(props);
}
function MdErrorOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function MdNotificationImportant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-5 0h-2v-2h2v2zm0-4h-2V8h2v4zm-1 10c1.1 0 2-.9 2-2h-4a2 2 0 002 2z"
                }
            }
        ]
    })(props);
}
function MdWarningAmber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16h-2v2h2zM13 10h-2v5h2z"
                }
            }
        ]
    })(props);
}
function MdWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function Md10K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.5h1.5v3H10zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 15H6v-4.5H4.5V9h3v6zm5.5-1c0 .55-.45 1-1 1H9.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H12c.55 0 1 .45 1 1v4zm6.5 1h-1.75L16 12.75V15h-1.5V9H16v2.25L17.75 9h1.75l-2.25 3 2.25 3z"
                }
            }
        ]
    })(props);
}
function Md1KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 15H7.5v-4.5H6V9h3v6zm4.75 0L12 12.75V15h-1.5V9H12v2.25L13.75 9h1.75l-2.25 3 2.25 3h-1.75zm5.75-2.5H18V14h-1v-1.5h-1.5v-1H17V10h1v1.5h1.5v1z"
                }
            }
        ]
    })(props);
}
function Md1K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.5 12H9v-4.5H7.5V9h3v6zm7 0h-1.75L14 12.75V15h-1.5V9H14v2.25L15.75 9h1.75l-2.25 3 2.25 3z"
                }
            }
        ]
    })(props);
}
function Md2KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9.5 8.5c0 .55-.45 1-1 1h-2v1h3V15H5v-2.5c0-.55.45-1 1-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v1.5zm4.75 3.5l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15h-1.75zM20 12.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md2K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9.5H8v1h3V15H6.5v-2.5c0-.55.45-1 1-1h2v-1h-3V9H10c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1zm8 2.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md3KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 14c0 .55-.45 1-1 1H5v-1.5h3v-1H6v-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v4zm6.5 1h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md3K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11c0 .55-.45 1-1 1H6.5v-1.5h3v-1h-2v-1h2v-1h-3V9H10c.55 0 1 .45 1 1v4zm7 1h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md4KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.5 10.5h-1V15H8v-1.5H5V9h1.5v3H8V9h1.5v3h1v1.5zM16 15h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md4K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 10.5h-1V15H9.5v-1.5h-3V9H8v3h1.5V9H11v3h1v1.5zm6 1.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md5G(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13h2v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4v2zM3 13h5v2H3v2h5c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H5V9h5V7H3v6z"
                }
            }
        ]
    })(props);
}
function Md5KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9.5 7.5h-3v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H5v-1.5h3v-1H5V9h4.5v1.5zM16 15h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md5K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 7.5H8v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H6.5v-1.5h3v-1h-3V9H11v1.5zm7 4.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md6KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 12.5H8V14H6.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9.5 7.5h-3v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3.5v1.5zM16 15h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md6K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.5h1.5V14H8zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 7.5H8v1h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H11v1.5zm7 4.5h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md7KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8 15H6.25l1.38-4.5H5V9h3.5c.67 0 1.15.65.96 1.29L8 15zm8 0h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md7K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 15H7.75l1.38-4.5H6.5V9H10c.67 0 1.15.65.96 1.29L9.5 15zm8.5 0h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md8KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 12.5H8V14H6.5zm0-2.5H8v1.5H6.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 14c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm6.5 1h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md8K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 12.5h1.5V14H8zM8 10h1.5v1.5H8zm11-7H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11c0 .55-.45 1-1 1H7.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H10c.55 0 1 .45 1 1v4zm7 1h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function Md9KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10H8v1.5H6.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9.5 14c0 .55-.45 1-1 1H5v-1.5h3v-1H6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm6.5 1h-1.75l-1.75-2.25V15H11V9h1.5v2.25L14.25 9H16l-2.25 3L16 15zm4-2.5h-1.5V14h-1v-1.5H16v-1h1.5V10h1v1.5H20v1z"
                }
            }
        ]
    })(props);
}
function Md9K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10h1.5v1.5H8zm11-7H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 11c0 .55-.45 1-1 1H6.5v-1.5h3v-1h-2c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1H10c.55 0 1 .45 1 1v4zm7 1h-1.75l-1.75-2.25V15H13V9h1.5v2.25L16.25 9H18l-2.25 3L18 15z"
                }
            }
        ]
    })(props);
}
function MdAddToQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
                }
            }
        ]
    })(props);
}
function MdAirplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdArtTrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
                }
            }
        ]
    })(props);
}
function MdAudioFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 11h-3v3.75c0 1.24-1.01 2.25-2.25 2.25S8.5 17.99 8.5 16.75s1.01-2.25 2.25-2.25c.46 0 .89.14 1.25.38V11h4v2zm-3-4V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function MdAvTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9a9 9 0 000-18h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
                }
            }
        ]
    })(props);
}
function MdBrandingWatermark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
                }
            }
        ]
    })(props);
}
function MdCallToAction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"
                }
            }
        ]
    })(props);
}
function MdClosedCaptionDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H19c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16l-3.38-3.38c.24-.19.4-.46.4-.78v-1h-1.5v.5h-.17l-1.83-1.83V10.5h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v.17L6.83 4zm12.95 18.61L17.17 20H5a2 2 0 01-2-2V6c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM11 13.83l-.83-.83H9.5v.5h-2v-3h.17L6.4 9.22c-.24.19-.4.46-.4.78v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-.17z"
                }
            }
        ]
    })(props);
}
function MdClosedCaptionOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 5.5v13h-15v-13h15zM19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdClosedCaption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdControlCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.54 5.54L13.77 7.3 12 5.54 10.23 7.3 8.46 5.54 12 2zm2.92 10l-1.76-1.77L18.46 12l-1.76-1.77 1.76-1.77L22 12zm-10 2.92l1.77-1.76L12 18.46l1.77-1.76 1.77 1.76L12 22zm-2.92-10l1.76 1.77L5.54 12l1.76 1.77-1.76 1.77L2 12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function MdEqualizer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
                }
            }
        ]
    })(props);
}
function MdExplicit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
                }
            }
        ]
    })(props);
}
function MdFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
                }
            }
        ]
    })(props);
}
function MdFastRewind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
                }
            }
        ]
    })(props);
}
function MdFeaturedPlayList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"
                }
            }
        ]
    })(props);
}
function MdFeaturedVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"
                }
            }
        ]
    })(props);
}
function MdFiberDvr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5h2v1h-2v-1zm-13 0h2v3h-2v-3zM21 3H3c-1.11 0-2 .89-2 2v14a2 2 0 002 2h18a2 2 0 002-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"
                }
            }
        ]
    })(props);
}
function MdFiberManualRecord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "8"
                }
            }
        ]
    })(props);
}
function MdFiberNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
                }
            }
        ]
    })(props);
}
function MdFiberPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
                }
            }
        ]
    })(props);
}
function MdFiberSmartRecord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "8"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.26v2.09a5.99 5.99 0 010 11.3v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"
                }
            }
        ]
    })(props);
}
function MdForward10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.86 15.94v-4.27h-.09L9 12.3v.69l1.01-.31v3.26zM12.25 13.44v.74c0 1.9 1.31 1.82 1.44 1.82.14 0 1.44.09 1.44-1.82v-.74c0-1.9-1.31-1.82-1.44-1.82-.14 0-1.44-.09-1.44 1.82zm2.04-.12v.97c0 .77-.21 1.03-.59 1.03s-.6-.26-.6-1.03v-.97c0-.75.22-1.01.59-1.01.38-.01.6.26.6 1.01z"
                }
            }
        ]
    })(props);
}
function MdForward30(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.06 15.38c-.29 0-.62-.17-.62-.54h-.85c0 .97.9 1.23 1.45 1.23.87 0 1.51-.46 1.51-1.25 0-.66-.45-.9-.71-1 .11-.05.65-.32.65-.92 0-.21-.05-1.22-1.44-1.22-.62 0-1.4.35-1.4 1.16h.85c0-.34.31-.48.57-.48.59 0 .58.5.58.54 0 .52-.41.59-.63.59h-.46v.66h.45c.65 0 .7.42.7.64 0 .32-.21.59-.65.59zM13.85 11.68c-.14 0-1.44-.08-1.44 1.82v.74c0 1.9 1.31 1.82 1.44 1.82.14 0 1.44.09 1.44-1.82v-.74c.01-1.91-1.3-1.82-1.44-1.82zm.6 2.67c0 .77-.21 1.03-.59 1.03s-.6-.26-.6-1.03v-.97c0-.75.22-1.01.59-1.01.38 0 .6.26.6 1.01v.97z"
                }
            }
        ]
    })(props);
}
function MdForward5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.03 15.38c-.44 0-.58-.31-.6-.56h-.84c.03.85.79 1.25 1.44 1.25.93 0 1.44-.63 1.44-1.43 0-1.33-.97-1.44-1.3-1.44-.2 0-.43.05-.64.16l.11-.92h1.7v-.71h-2.39l-.25 2.17.67.17c.13-.13.28-.23.57-.23.4 0 .69.23.69.75-.01.05.02.79-.6.79z"
                }
            }
        ]
    })(props);
}
function MdGames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
                }
            }
        ]
    })(props);
}
function MdHd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function MdHearingDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.03 3.2C7.15 2.44 8.51 2 10 2c3.93 0 7 3.07 7 7 0 1.26-.38 2.65-1.07 3.9-.02.04-.05.08-.08.13l-1.48-1.48c.4-.86.63-1.75.63-2.55 0-2.8-2.2-5-5-5-.92 0-1.76.26-2.5.67L6.03 3.2zm11.18 11.18l1.43 1.43C20.11 13.93 21 11.57 21 9c0-3.04-1.23-5.79-3.22-7.78l-1.42 1.42A8.937 8.937 0 0119 9c0 2.02-.67 3.88-1.79 5.38zM10 6.5c-.21 0-.4.03-.59.08l3.01 3.01c.05-.19.08-.38.08-.59A2.5 2.5 0 0010 6.5zm11.19 14.69L2.81 2.81 1.39 4.22l2.13 2.13C3.19 7.16 3 8.05 3 9h2c0-.36.05-.71.12-1.05l6.61 6.61c-.88.68-1.78 1.41-2.27 2.9-.5 1.5-1 2.01-1.71 2.38-.19.1-.46.16-.75.16-1.1 0-2-.9-2-2H3a3.999 3.999 0 005.64 3.65c1.36-.71 2.13-1.73 2.73-3.55.32-.98.9-1.43 1.71-2.05.03-.02.05-.04.08-.06l6.62 6.62 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdHearing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0021 18h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z"
                }
            }
        ]
    })(props);
}
function MdHighQuality(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function MdInterpreterMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 16.5c-.83 0-1.5-.67-1.5-1.5v-2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V15c0 .83-.67 1.5-1.5 1.5zM20 20h1v-1.54c1.69-.24 3-1.7 3-3.46h-1a2.5 2.5 0 01-5 0h-1c0 1.76 1.31 3.22 3 3.46V20zM9 12c-2.21 0-4-1.79-4-4a3.999 3.999 0 015.34-3.77A5.938 5.938 0 009 8c0 1.43.5 2.74 1.34 3.77-.42.15-.87.23-1.34.23zm-1.89 1.13A4.965 4.965 0 005 17.22V20H1v-2.78c0-1.12.61-2.15 1.61-2.66 1.24-.64 2.76-1.19 4.5-1.43zM11 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm7.32 12a4.997 4.997 0 01-2.82-4.5c0-.89.23-1.73.64-2.45-.37-.03-.75-.05-1.14-.05-2.53 0-4.71.7-6.39 1.56A2.97 2.97 0 007 17.22V20h11.32z"
                }
            }
        ]
    })(props);
}
function MdLibraryAddCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            }
        ]
    })(props);
}
function MdLibraryAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdLibraryBooks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
                }
            }
        ]
    })(props);
}
function MdLibraryMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5a2.5 2.5 0 01-5 0 2.5 2.5 0 012.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            }
        ]
    })(props);
}
function MdLoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function MdLyrics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9c0-2.04 1.24-3.79 3-4.57V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9c1.1 0 2-.9 2-2v-2.42c-1.76-.78-3-2.53-3-4.58zm-4 5H6v-2h4v2zm3-3H6V9h7v2zm0-3H6V6h7v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V3h2V1h-4v5.18z"
                }
            }
        ]
    })(props);
}
function MdMicNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function MdMicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
                }
            }
        ]
    })(props);
}
function MdMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function MdMissedVideoCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM10 15l-3.89-3.89v2.55H5V9.22h4.44v1.11H6.89l3.11 3.1 4.22-4.22.78.79-5 5z"
                }
            }
        ]
    })(props);
}
function MdMovieEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10h18V6c0-1.1-.9-2-2-2h-3l2 4h-3l-2-4h-2l2 4h-3L9 4H7l2 4H6L4 4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4v-8zM14 18.88V21h2.12l5.17-5.17-2.12-2.12zM22.71 13l-.71-.71a.996.996 0 00-1.41 0l-.71.71L22 15.12l.71-.71a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function MdMovie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
                }
            }
        ]
    })(props);
}
function MdMusicVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0111 18c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function MdNewReleases(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function MdNotInterested(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
                }
            }
        ]
    })(props);
}
function MdPauseCircleFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function MdPauseCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                }
            }
        ]
    })(props);
}
function MdPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function MdPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
                }
            }
        ]
    })(props);
}
function MdPlayArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5v14l11-7z"
                }
            }
        ]
    })(props);
}
function MdPlayCircleFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
                }
            }
        ]
    })(props);
}
function MdPlayCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.5 16.5v-9l7 4.5-7 4.5z"
                }
            }
        ]
    })(props);
}
function MdPlayDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm11.75 11.47l-.11-.11.11.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5.19V5l11 7-2.55 1.63L8 5.19zm12 14.54l-5.11-5.11L8 7.73 4.27 4 3 5.27l5 5V19l5.33-3.4 5.4 5.4L20 19.73z"
                }
            }
        ]
    })(props);
}
function MdPlaylistAddCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 7h7v2H7V7zm0 3h7v2H7v-2zm3 5H7v-2h3v2zm4.05 3.36l-2.83-2.83 1.41-1.41 1.41 1.41L17.59 12 19 13.41l-4.95 4.95z"
                }
            }
        ]
    })(props);
}
function MdPlaylistAddCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM20.59 11.93l-4.25 4.24-2.12-2.12-1.41 1.41L16.34 19 22 13.34z"
                }
            }
        ]
    })(props);
}
function MdPlaylistAddCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 7h7v2H7V7zm3 8H7v-2h3v2zm-3-3v-2h7v2H7zm12 3h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdPlaylistAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdPlaylistPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM16 13v8l6-4z"
                }
            }
        ]
    })(props);
}
function MdPlaylistRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zM3 16h7v-2H3v2zm11.41 6L17 19.41 19.59 22 21 20.59 18.41 18 21 15.41 19.59 14 17 16.59 14.41 14 13 15.41 15.59 18 13 20.59 14.41 22z"
                }
            }
        ]
    })(props);
}
function MdQueueMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
                }
            }
        ]
    })(props);
}
function MdQueuePlayNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 00-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
                }
            }
        ]
    })(props);
}
function MdQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 002 2h16a2 2 0 002-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
                }
            }
        ]
    })(props);
}
function MdRecentActors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
                }
            }
        ]
    })(props);
}
function MdRemoveFromQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
                }
            }
        ]
    })(props);
}
function MdRepeatOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
                }
            }
        ]
    })(props);
}
function MdRepeatOneOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
                }
            }
        ]
    })(props);
}
function MdRepeatOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
                }
            }
        ]
    })(props);
}
function MdRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
                }
            }
        ]
    })(props);
}
function MdReplay10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.89 16h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zM15.17 14.24c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function MdReplay30(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.56 13.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43a.538.538 0 00-.15-.39c-.05-.05-.11-.09-.18-.11s-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85a1.06 1.06 0 01.41-.85c.13-.1.27-.18.44-.23s.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53a.842.842 0 01-.17.52 1.1 1.1 0 01-.48.39c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zM15.3 14.24c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function MdReplay5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.69 13.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15a.49.49 0 00.45-.23c.04-.07.08-.15.11-.25s.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
                }
            }
        ]
    })(props);
}
function MdReplayCircleFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 10c0 3.31-2.69 6-6 6s-6-2.69-6-6h2c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4v3L8 7l4-4v3c3.31 0 6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function MdReplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdSd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm-3.5 4.5v-1H7c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H9.5v-.5h-2v1H10c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-1h1.5v.5h2zm5 0h2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function MdShuffleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
                }
            }
        ]
    })(props);
}
function MdShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
                }
            }
        ]
    })(props);
}
function MdSkipNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
                }
            }
        ]
    })(props);
}
function MdSkipPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v12H6zm3.5 6l8.5 6V6z"
                }
            }
        ]
    })(props);
}
function MdSlowMotionVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zm1.61 6.74A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
                }
            }
        ]
    })(props);
}
function MdSnooze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"
                }
            }
        ]
    })(props);
}
function MdSortByAlpha(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm.75.75h22.5v22.5H.75z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
                }
            }
        ]
    })(props);
}
function MdSpeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44zm-9.79 6.84a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
                }
            }
        ]
    })(props);
}
function MdStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4 14H8V8h8v8z"
                }
            }
        ]
    })(props);
}
function MdStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h12v12H6z"
                }
            }
        ]
    })(props);
}
function MdSubscriptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"
                }
            }
        ]
    })(props);
}
function MdSubtitles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdSurroundSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41A7.909 7.909 0 014 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41A7.909 7.909 0 0120 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdVideoCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdVideoFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6.01a2 2 0 00-2 2L4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zm1 5l2-1.06v4.12L14 16v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdVideoLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
                }
            }
        ]
    })(props);
}
function MdVideoLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
                }
            }
        ]
    })(props);
}
function MdVideoSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12L9 8v8zM22.71 18.43c.03-.29.04-.58.01-.86l1.07-.85c.1-.08.12-.21.06-.32l-1.03-1.79c-.06-.11-.19-.15-.31-.11l-1.28.5a3.44 3.44 0 00-.75-.42l-.2-1.36a.249.249 0 00-.25-.22h-2.07c-.12 0-.23.09-.25.21l-.2 1.36c-.26.11-.51.26-.74.42l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.79c-.06.11-.04.24.06.32l1.07.86c-.03.29-.04.58-.01.86l-1.07.85c-.1.08-.12.21-.06.32l1.03 1.79c.06.11.19.15.31.11l1.27-.5c.23.17.48.31.75.42l.2 1.36c.02.12.12.21.25.21h2.07c.12 0 .23-.09.25-.21l.2-1.36c.26-.11.51-.26.74-.42l1.28.5c.12.05.25 0 .31-.11l1.03-1.79c.06-.11.04-.24-.06-.32l-1.06-.85zM19 19.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdVideocamOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
                }
            }
        ]
    })(props);
}
function MdVideocam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
                }
            }
        ]
    })(props);
}
function MdVolumeDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02S15.48 8.71 14 7.97zM3 9v6h4l5 5V4L7 9H3z"
                }
            }
        ]
    })(props);
}
function MdVolumeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 12A4.5 4.5 0 0016 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
                }
            }
        ]
    })(props);
}
function MdVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v6h4l5 5V4l-5 5H7z"
                }
            }
        ]
    })(props);
}
function MdVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12A4.5 4.5 0 0014 7.97v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0021 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 003.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
                }
            }
        ]
    })(props);
}
function MdVolumeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
                }
            }
        ]
    })(props);
}
function MdWebAssetOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H20a2 2 0 012 2v12c0 .34-.09.66-.23.94L20 17.17V8h-9.17l-4-4zm13.66 19.31L17.17 20H4a2 2 0 01-2-2V6c0-.34.08-.66.23-.94L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM15.17 18l-10-10H4v10h11.17z"
                }
            }
        ]
    })(props);
}
function MdWebAsset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function MdWeb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
                }
            }
        ]
    })(props);
}
function Md3P(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 13.43V14z"
                }
            }
        ]
    })(props);
}
function MdAddIcCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM21 6h-3V3h-2v3h-3v2h3v3h2V8h3z"
                }
            }
        ]
    })(props);
}
function MdAlternateEmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57V12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57V12c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdAppRegistration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4v4h-4zM4 16h4v4H4zM4 10h4v4H4zM4 4h4v4H4zM14 12.42V10h-4v4h2.42zM20.88 11.29l-1.17-1.17a.41.41 0 00-.58 0l-.88.88L20 12.75l.88-.88a.41.41 0 000-.58zM11 18.25V20h1.75l6.67-6.67-1.75-1.75zM16 4h4v4h-4z"
                }
            }
        ]
    })(props);
}
function MdBusiness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdCallEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08a.956.956 0 01-.29-.7c0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28a11.27 11.27 0 00-2.67-1.85.996.996 0 01-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
                }
            }
        ]
    })(props);
}
function MdCallMade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
                }
            }
        ]
    })(props);
}
function MdCallMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function MdCallMissedOutgoing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
                }
            }
        ]
    })(props);
}
function MdCallMissed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
                }
            }
        ]
    })(props);
}
function MdCallReceived(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"
                }
            }
        ]
    })(props);
}
function MdCallSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
                }
            }
        ]
    })(props);
}
function MdCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
                }
            }
        ]
    })(props);
}
function MdCancelPresentation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41z"
                }
            }
        ]
    })(props);
}
function MdCellTower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.3 14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7zM19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9 0 2.1-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1 0-2.6-1-5.1-2.9-7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 4.1L4.9 2.9C3 4.9 2 7.4 2 10c0 2.6 1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9 0-2.1.8-4.3 2.4-5.9zM16.7 14.7c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5l1.2 1.2zM14.5 10a2.5 2.5 0 00-5 0c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88zm-4.17 8L12 13l1.67 5h-3.34z"
                }
            }
        ]
    })(props);
}
function MdCellWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.98L6 22h16V5.97l-4 4.01zM20 20h-2v-7.22l2-2V20zM5.22 7.22L3.93 5.93c3.9-3.91 10.24-3.91 14.15 0l-1.29 1.29c-3.19-3.19-8.38-3.19-11.57 0zm7.71 3.85L11 13l-1.93-1.93a2.74 2.74 0 013.86 0zm1.29-1.28c-1.78-1.77-4.66-1.77-6.43 0L6.5 8.5a6.374 6.374 0 019 0l-1.28 1.29z"
                }
            }
        ]
    })(props);
}
function MdChatBubbleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            }
        ]
    })(props);
}
function MdChatBubble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function MdClearAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function MdCoPresent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v8h2V5h18v16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.39 16.56C13.71 15.7 11.53 15 9 15s-4.71.7-6.39 1.56A2.97 2.97 0 001 19.22V22h16v-2.78c0-1.12-.61-2.15-1.61-2.66z"
                }
            }
        ]
    })(props);
}
function MdComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function MdCommentsDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.83 14H18v-2h-3.17l-1-1H18V9h-6.17l-1-1H18V6H8.83l-4-4H20c1.1 0 2 .9 2 2v15.17L16.83 14zM2.1 2.1L.69 3.51 2 4.83V16c0 1.1.9 2 2 2h11.17l5.31 5.31 1.41-1.41L2.1 2.1zM6 9h.17l2 2H6V9zm0 5v-2h3.17l2 2H6z"
                }
            }
        ]
    })(props);
}
function MdContactEmergency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM9 8c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM2.08 19c1.38-2.39 3.96-4 6.92-4s5.54 1.61 6.92 4H2.08zm18.89-9.15l-.75 1.3-1.47-.85V12h-1.5v-1.7l-1.47.85-.75-1.3L16.5 9l-1.47-.85.75-1.3 1.47.85V6h1.5v1.7l1.47-.85.75 1.3L19.5 9l1.47.85z"
                }
            }
        ]
    })(props);
}
function MdContactMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
                }
            }
        ]
    })(props);
}
function MdContactPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99A7.512 7.512 0 0116.28 14c-.18-.64-.28-1.31-.28-2s.1-1.36.28-2a7.474 7.474 0 012.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
                }
            }
        ]
    })(props);
}
function MdContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
                }
            }
        ]
    })(props);
}
function MdDesktopAccessDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 16c0 1.1-.9 2-2 2h-1l-2-2h3V4H6L4 2h17c1.1 0 2 .9 2 2v12zm-5.5 2l-2-2zm-2.6 0l6 6 1.3-1.3-4.7-4.7-2-2L1.2 1.8 0 3.1l1 1V16c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h.9zM3 16V6.1l9.9 9.9H3z"
                }
            }
        ]
    })(props);
}
function MdDialerSip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57a.998.998 0 00-1.01.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdDialpad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdDocumentScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3H4v3H2V1h5v2zm15 3V1h-5v2h3v3h2zM7 21H4v-3H2v5h5v-2zm13-3v3h-3v2h5v-5h-2zm-1 0c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v12zM15 8H9v2h6V8zm0 3H9v2h6v-2zm0 3H9v2h6v-2z"
                }
            }
        ]
    })(props);
}
function MdDomainDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5h2v2h-.9L12 9.9V9h8v8.9l2 2V7H12V3H5.1L8 5.9zm8 6h2v2h-2zM1.3 1.8L.1 3.1 2 5v16h16l3 3 1.3-1.3-21-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm4 8H8v-2h2v2zm0-4H8v-2h2v2zm2 4v-2h2l2 2h-4z"
                }
            }
        ]
    })(props);
}
function MdDomainVerification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6 10.88l-1.42-1.42-4.24 4.25-2.12-2.13L7.4 13l3.54 3.54z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function MdDuo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
                }
            }
        ]
    })(props);
}
function MdEmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function MdForum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdForwardToInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm7 4l4 4-4 4v-3h-4v-2h4v-3z"
                }
            }
        ]
    })(props);
}
function MdHourglassBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22l-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z"
                }
            }
        ]
    })(props);
}
function MdHourglassTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2l.01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6zm10 14.5V20H8v-3.5l4-4 4 4z"
                }
            }
        ]
    })(props);
}
function MdHub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.4 18.2c.38.5.6 1.12.6 1.8 0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3c.44 0 .85.09 1.23.26l1.41-1.77a4.504 4.504 0 01-1.09-3.69l-2.03-.68A2.997 2.997 0 010 9.5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .07 0 .14-.01.21l2.03.68a4.468 4.468 0 013.22-2.32V5.91A3.018 3.018 0 019 3c0-1.66 1.34-3 3-3s3 1.34 3 3c0 1.4-.96 2.57-2.25 2.91v2.16c1.4.23 2.58 1.11 3.22 2.32L18 9.71V9.5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3c-1.06 0-1.98-.55-2.52-1.37l-2.03.68a4.49 4.49 0 01-1.09 3.69l1.41 1.77c.38-.18.79-.27 1.23-.27 1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3c0-.68.22-1.3.6-1.8l-1.41-1.77c-1.35.75-3.01.76-4.37 0L8.4 18.2z"
                }
            }
        ]
    })(props);
}
function MdImportContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 4.5c-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .65.73.45.75.45C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.41.21.75-.19.75-.45V6c-1.49-1.12-3.63-1.5-5.5-1.5zm3.5 14c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            }
        ]
    })(props);
}
function MdImportExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function MdInvertColorsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l4.2 4.2a7.73 7.73 0 00-1.6 4.7C4 17.48 7.58 21 12 21c1.75 0 3.36-.56 4.67-1.5l3.1 3.1 1.42-1.41zM12 19c-3.31 0-6-2.63-6-5.87 0-1.19.36-2.32 1.02-3.28L12 14.83V19zM8.38 5.56L12 2l5.65 5.56C19.1 8.99 20 10.96 20 13.13c0 1.18-.27 2.29-.74 3.3L12 9.17V4.81L9.8 6.97 8.38 5.56z"
                }
            }
        ]
    })(props);
}
function MdKeyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.91 14.09L17 14l2 2 4-4.04L21 10h-8.17l4.08 4.09zM3.98 6.81A6.012 6.012 0 001 12c0 3.31 2.69 6 6 6 2.21 0 4.15-1.2 5.18-2.99l7.59 7.59 1.41-1.41L2.81 2.81 1.39 4.22l2.59 2.59zm5.93 5.93A3.015 3.015 0 017 15c-1.65 0-3-1.35-3-3 0-1.4.97-2.58 2.26-2.91l3.65 3.65z"
                }
            }
        ]
    })(props);
}
function MdKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-8.35A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"
                }
            }
        ]
    })(props);
}
function MdLiveHelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                }
            }
        ]
    })(props);
}
function MdLocationOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm11.75 11.47l-.11-.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.5A2.5 2.5 0 0114.5 9c0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7a7 7 0 00-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"
                }
            }
        ]
    })(props);
}
function MdLocationOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdMailLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.97V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h12v-5.03c0-2.76 2.24-5 5-5h1zM20 8l-8 5-8-5V6l8 5 8-5v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdMailOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
                }
            }
        ]
    })(props);
}
function MdMarkChatRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 20l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 14.34 17.34 20zM12 17a6.995 6.995 0 0110-6.32V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v18l4-4h6c0-.17.01-.33.03-.5A4.07 4.07 0 0112 17z"
                }
            }
        ]
    })(props);
}
function MdMarkChatUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.98V16c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1A5.002 5.002 0 0019 8c1.13 0 2.16-.39 3-1.02zM16 3c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function MdMarkEmailRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19a6.995 6.995 0 0110-6.32V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h8.08c-.05-.33-.08-.66-.08-1zM4 6l8 5 8-5v2l-8 5-8-5V6zm13.34 16l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34 17.34 22z"
                }
            }
        ]
    })(props);
}
function MdMarkEmailUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10.1c-.06.32-.1.66-.1 1 0 1.48.65 2.79 1.67 3.71L12 11 4 6v2l8 5 5.3-3.32c.54.2 1.1.32 1.7.32 1.13 0 2.16-.39 3-1.02zM16 5c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function MdMarkUnreadChatAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "3",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8V6h9.03a4.906 4.906 0 01-.92-4H4.01a2 2 0 00-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V6.97C21.16 7.61 20.13 8 19 8H6zm8 6H6v-2h8v2zm4-3H6V9h12v2z"
                }
            }
        ]
    })(props);
}
function MdMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function MdMobileScreenShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-4.2-5.78v1.75l3.2-2.99L12.8 9v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
                }
            }
        ]
    })(props);
}
function MdMoreTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v6l4.7 2.9.8-1.2-4-2.4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 12A6.957 6.957 0 0111 20c-3.9 0-7-3.1-7-7s3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9a8.963 8.963 0 008.94-10h-2.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V2h-2v3h-3v2h3v3h2V7h3V5z"
                }
            }
        ]
    })(props);
}
function MdNat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.82 13H11v-2H6.82C6.4 9.84 5.3 9 4 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-4-3v2h-4.05c-.5-5.05-4.76-9-9.95-9v2c4.42 0 8 3.58 8 8s-3.58 8-8 8v2c5.19 0 9.45-3.95 9.95-9H19v2l4-3z"
                }
            }
        ]
    })(props);
}
function MdNoSim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
                }
            }
        ]
    })(props);
}
function MdPausePresentation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M21 19.1H3V5h18v14.1zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8h2v8H9zm4 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function MdPersonAddDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "8",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 20v-2c0-2.3-4.1-3.7-6.9-3.9l6 5.9h.9zm-11.6-5.5C9.2 15.1 7 16.3 7 18v2h9.9l4 4 1.3-1.3-21-20.9L0 3.1l4 4V10H1v2h3v3h2v-3h2.9l2.5 2.5zM6 10v-.9l.9.9H6z"
                }
            }
        ]
    })(props);
}
function MdPersonSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.35 14.01C7.62 13.91 2 15.27 2 18v2h9.54c-2.47-2.76-1.23-5.89-1.19-5.99zM19.43 18.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59l-2.57-2.57zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdPhoneDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81A16.884 16.884 0 014 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26z"
                }
            }
        ]
    })(props);
}
function MdPhoneEnabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.38 10.79l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.35-.12.75-.03 1.02.24l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59z"
                }
            }
        ]
    })(props);
}
function MdPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                }
            }
        ]
    })(props);
}
function MdPhonelinkErase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdPhonelinkLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
                }
            }
        ]
    })(props);
}
function MdPhonelinkRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
                }
            }
        ]
    })(props);
}
function MdPhonelinkSetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.82 12.49c.02-.16.04-.32.04-.49 0-.17-.02-.33-.04-.49l1.08-.82c.1-.07.12-.21.06-.32l-1.03-1.73c-.06-.11-.2-.15-.31-.11l-1.28.5c-.27-.2-.56-.36-.87-.49l-.2-1.33c0-.12-.11-.21-.24-.21H5.98a.26.26 0 00-.26.21l-.2 1.32c-.31.12-.6.3-.87.49l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.73c-.06.12-.03.25.07.33l1.08.82c-.02.16-.03.33-.03.49 0 .17.02.33.04.49l-1.09.83c-.1.07-.12.21-.06.32l1.03 1.73c.06.11.2.15.31.11l1.28-.5c.27.2.56.36.87.49l.2 1.32c.01.12.12.21.25.21h2.06c.13 0 .24-.09.25-.21l.2-1.32c.31-.12.6-.3.87-.49l1.28.5c.12.05.25 0 .31-.11l1.03-1.73c.06-.11.04-.24-.06-.32l-1.1-.83zM7 13.75c-.99 0-1.8-.78-1.8-1.75s.81-1.75 1.8-1.75 1.8.78 1.8 1.75S8 13.75 7 13.75zM18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
                }
            }
        ]
    })(props);
}
function MdPortableWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06a3.999 3.999 0 013.95 4.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47A9.86 9.86 0 0022 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"
                }
            }
        ]
    })(props);
}
function MdPresentToAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function MdPrintDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.1 17H22v-6c0-1.7-1.3-3-3-3h-9l9.1 9zm-.1-7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-1-3V3H6v1.1L9 7zM1.2 1.8L0 3l4.9 5C3.3 8.1 2 9.4 2 11v6h4v4h11.9l3 3 1.3-1.3-21-20.9zM8 19v-5h2.9l5 5H8z"
                }
            }
        ]
    })(props);
}
function MdQrCode2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h-2v-2h2v2zm-2-7h-2v5h2v-5zm8-2h-2v4h2v-4zm-2-2h-2v2h2v-2zM7 12H5v2h2v-2zm-2-2H3v2h2v-2zm7-5h2V3h-2v2zm-7.5-.5v3h3v-3h-3zM9 9H3V3h6v6zm-4.5 7.5v3h3v-3h-3zM9 21H3v-6h6v6zm7.5-16.5v3h3v-3h-3zM21 9h-6V3h6v6zm-2 10v-3h-4v2h2v3h4v-2h-2zm-2-7h-4v2h4v-2zm-4-2H7v2h2v2h2v-2h2v-2zm1-1V7h-2V5h-2v4h4zM6.75 5.25h-1.5v1.5h1.5v-1.5zm0 12h-1.5v1.5h1.5v-1.5zm12-12h-1.5v1.5h1.5v-1.5z"
                }
            }
        ]
    })(props);
}
function MdQrCodeScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z"
                }
            }
        ]
    })(props);
}
function MdQrCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM19 19h2v2h-2zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdReadMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h9v2h-9zM13 15h9v2h-9zM16 11h6v2h-6zM13 12L8 7v4H2v2h6v4z"
                }
            }
        ]
    })(props);
}
function MdRingVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.71 16.67A16.971 16.971 0 0012 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 00-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
                }
            }
        ]
    })(props);
}
function MdRssFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.18",
                    "cy": "17.82",
                    "r": "2.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
                }
            }
        ]
    })(props);
}
function MdRtt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03 3l-1.11 7.07h2.62l.7-4.5h2.58L11.8 18.43H9.47L9.06 21h7.27l.4-2.57h-2.35l2-12.86h2.58l-.71 4.5h2.65L22 3H9.03zM8 5H4l-.31 2h4L8 5zm-.61 4h-4l-.31 2h4l.31-2zm.92 8h-6L2 19h6l.31-2zm.62-4h-6l-.31 2h6.01l.3-2z"
                }
            }
        ]
    })(props);
}
function MdScreenShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
                }
            }
        ]
    })(props);
}
function MdSendTimeExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-5 0H5.01c-1.1 0-2 .9-2 2v3.8C5.7 9.8 6 11.96 6 12.5s-.29 2.7-3 2.7V19c0 1.1.9 2 2 2h3.8c0-2.16 1.37-2.78 2.2-2.94v-9.3l9 4.5V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12v4l4 1-4 1v4l10-5z"
                }
            }
        ]
    })(props);
}
function MdSentimentSatisfiedAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z"
                }
            }
        ]
    })(props);
}
function MdSip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 10.5h2v1h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-10 6.5H6.5v.75H9c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H5v-1.5h3.5v-.75H6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h4v1.5zm3 4.5h-2V9h2v6zm6-3c0 .55-.45 1-1 1h-2.5v2H14V9h4c.55 0 1 .45 1 1v2z"
                }
            }
        ]
    })(props);
}
function MdSpeakerPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41A10.963 10.963 0 0012 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
                }
            }
        ]
    })(props);
}
function MdSpoke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7c0 2.21-1.79 4-4 4S8 9.21 8 7s1.79-4 4-4 4 1.79 4 4zm-9 6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm10 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdStayCurrentLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function MdStayCurrentPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdStayPrimaryLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function MdStayPrimaryPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdStopScreenShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10a2 2 0 00-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10a2 2 0 002 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"
                }
            }
        ]
    })(props);
}
function MdSwapCalls(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
                }
            }
        ]
    })(props);
}
function MdTextsms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
                }
            }
        ]
    })(props);
}
function MdUnsubscribe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm2 4h-4v-1h4v1zm-6.95 0c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5 .92 0 1.76.26 2.5.69V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h8.55zM12 10.5L5 7V5l7 3.5L19 5v2l-7 3.5z"
                }
            }
        ]
    })(props);
}
function MdVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
                }
            }
        ]
    })(props);
}
function MdVpnKeyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.83 18H21v-4h2v-4H12.83l8 8zm-1.05 4.61l1.41-1.41L2.81 2.81 1.39 4.22l2.59 2.59A6.012 6.012 0 001 12c0 3.31 2.69 6 6 6 2.21 0 4.15-1.2 5.18-2.99l7.6 7.6zM8.99 11.82c.01.06.01.12.01.18 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.06 0 .12 0 .18.01l1.81 1.81z"
                }
            }
        ]
    })(props);
}
function MdVpnKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.65 10A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdWifiCalling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4.95C21.79 4.78 19.67 3 16.5 3c-3.18 0-5.29 1.78-5.5 1.95L16.5 12 22 4.95z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.51c-1.24 0-2.45-.2-3.57-.57a.994.994 0 00-1.02.24l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdAddBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdAddCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdAddCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdAddLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1zM3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                }
            }
        ]
    })(props);
}
function MdAmpStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 4h10v15H7zM3 6h2v11H3zM19 6h2v11h-2z"
                }
            }
        ]
    })(props);
}
function MdArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
                }
            }
        ]
    })(props);
}
function MdAttribution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.5c-.91 0-2.75.46-2.75 1.38v4.62h1.5V19h2.5v-4.5h1.5V9.88c0-.91-1.84-1.38-2.75-1.38z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
                }
            }
        ]
    })(props);
}
function MdBallot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z"
                }
            }
        ]
    })(props);
}
function MdBiotech(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19c-1.1 0-2 .9-2 2h14c0-1.1-.9-2-2-2h-4v-2h3c1.1 0 2-.9 2-2h-8c-1.66 0-3-1.34-3-3 0-1.09.59-2.04 1.46-2.56C8.17 9.03 8 8.54 8 8c0-.21.04-.42.09-.62A5.01 5.01 0 005 12c0 2.76 2.24 5 5 5v2H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.56 5.51C11.91 5.54 13 6.64 13 8c0 .75-.33 1.41-.85 1.87l.59 1.62.94-.34.34.94 1.88-.68-.34-.94.94-.34-2.74-7.53-.94.34-.34-.94-1.88.68.34.94-.94.35.56 1.54z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "8",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdBlockFlipped(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.5-4.5-10-10-10S2 6.5 2 12s4.5 10 10 10 10-4.5 10-10zM5.7 7.1l11.2 11.2c-1.3 1.1-3 1.7-4.9 1.7-4.4 0-8-3.6-8-8 0-1.9.6-3.6 1.7-4.9zM20 12c0 1.9-.6 3.6-1.7 4.9L7.1 5.7C8.4 4.6 10.1 4 12 4c4.4 0 8 3.6 8 8z"
                }
            }
        ]
    })(props);
}
function MdBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h-1l1-7H7.5c-.58 0-.57-.32-.38-.66.19-.34.05-.08.07-.12C8.48 10.94 10.42 7.54 13 3h1l-1 7h3.5c.49 0 .56.33.47.51l-.07.15C12.96 17.55 11 21 11 21z"
                }
            }
        ]
    })(props);
}
function MdCalculate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5.97 4.06L14.09 6l1.41 1.41L16.91 6l1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.4-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.42zm-6.78.66h5v1.5h-5v-1.5zM11.5 16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16zm6.5 1.25h-5v-1.5h5v1.5zm0-2.5h-5v-1.5h5v1.5z"
                }
            }
        ]
    })(props);
}
function MdChangeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm.06 17v-2.01H12c-1.28 0-2.56-.49-3.54-1.46a5.006 5.006 0 01-.64-6.29l1.1 1.1c-.71 1.33-.53 3.01.59 4.13.7.7 1.62 1.03 2.54 1.01v-2.14l2.83 2.83L12.06 19zm4.11-4.24l-1.1-1.1c.71-1.33.53-3.01-.59-4.13A3.482 3.482 0 0012 8.5h-.06v2.15L9.11 7.83 11.94 5v2.02c1.3-.02 2.61.45 3.6 1.45 1.7 1.7 1.91 4.35.63 6.29z"
                }
            }
        ]
    })(props);
}
function MdClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                }
            }
        ]
    })(props);
}
function MdContentCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                }
            }
        ]
    })(props);
}
function MdContentCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "2",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": ".5",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "2",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"
                }
            }
        ]
    })(props);
}
function MdContentPasteGo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v6h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.01 13l-1.42 1.41 1.58 1.58H12v2h6.17l-1.58 1.59 1.42 1.41 3.99-4z"
                }
            }
        ]
    })(props);
}
function MdContentPasteOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM5 19V7.83L16.17 19H5zM17 8V5h2v11.17l2 2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5.83l5 5H17zm-5-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdContentPasteSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function MdContentPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
                }
            }
        ]
    })(props);
}
function MdCopyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H9V4h9v12zM3 15v-2h2v2H3zm0-5.5h2v2H3v-2zM10 20h2v2h-2v-2zm-7-1.5v-2h2v2H3zM5 22c-1.1 0-2-.9-2-2h2v2zm3.5 0h-2v-2h2v2zm5 0v-2h2c0 1.1-.9 2-2 2zM5 6v2H3c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function MdCreate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function MdDeleteSweep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"
                }
            }
        ]
    })(props);
}
function MdDeselect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm4 8h2v-2H7v2zm6-18h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zm8 4h2v-2h-2v2zm8-8h2v-2h-2v2zm0-4h2V7h-2v2zm-4-4h2V3h-2v2zM7.83 5L7 4.17V3h2v2H7.83zm12 12l-.83-.83V15h2v2h-1.17zm1.36 4.19L2.81 2.81 1.39 4.22 4.17 7H3v2h2V7.83l2 2V17h7.17l2 2H15v2h2v-1.17l2.78 2.78 1.41-1.42zM9 15v-3.17L12.17 15H9zm6-2.83V9h-3.17l-2-2H17v7.17l-2-2z"
                }
            }
        ]
    })(props);
}
function MdDrafts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
                }
            }
        ]
    })(props);
}
function MdDynamicFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function MdFileCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
                }
            }
        ]
    })(props);
}
function MdFilterListOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 8H21V6H8.83l2 2zm5 5H18v-2h-4.17l2 2zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L14 16.83z"
                }
            }
        ]
    })(props);
}
function MdFilterList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function MdFlagCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6 13h-5l-1-2H9.5v5H8V7h6l1 2h3v6z"
                }
            }
        ]
    })(props);
}
function MdFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
                }
            }
        ]
    })(props);
}
function MdFontDownloadOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.58 9.75l-.87-.87.23-.66h.1l.54 1.53zm-2.23-2.23L10.92 6h2.14l2.55 6.79L22 19.17V4c0-1.1-.9-2-2-2H4.83l5.52 5.52zm10.14 15.79L19.17 22H4c-1.1 0-2-.9-2-2V4.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zm-8.39-8.38l-3.3-3.3L6.41 18h2.08l1.09-3.07h2.52z"
                }
            }
        ]
    })(props);
}
function MdFontDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "baseProfile": "tiny",
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
                }
            }
        ]
    })(props);
}
function MdForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8V4l8 8-8 8v-4H4V8z"
                }
            }
        ]
    })(props);
}
function MdGesture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
                }
            }
        ]
    })(props);
}
function MdHowToReg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M9 17l3-2.94a9.34 9.34 0 00-1-.06c-2.67 0-8 1.34-8 4v2h9l-3-3zm2-5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4M15.47 20.5L12 17l1.4-1.41 2.07 2.08 5.13-5.17 1.4 1.41z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function MdHowToVote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19a2 2 0 002-2v-4l-3-3zm-1-5.05l-4.95 4.95-3.54-3.54 4.95-4.95L17 7.95zm-4.24-5.66L6.39 8.66a.996.996 0 000 1.41l4.95 4.95c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 000-1.41L14.16 2.3a.975.975 0 00-1.4-.01z"
                }
            }
        ]
    })(props);
}
function MdInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
                }
            }
        ]
    })(props);
}
function MdInsights(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9l.94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11L4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
                }
            }
        ]
    })(props);
}
function MdInventory2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4h16v3z"
                }
            }
        ]
    })(props);
}
function MdInventory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-5 12H9v-2h6v2zm5-7H4V4l16-.02V7z"
                }
            }
        ]
    })(props);
}
function MdLinkOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.43-.98 2.63-2.31 2.98l1.46 1.46C20.88 15.61 22 13.95 22 12c0-2.76-2.24-5-5-5zm-1 4h-2.19l2 2H16zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4L20 19.74 3.27 3 2 4.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 24V0"
                }
            }
        ]
    })(props);
}
function MdLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function MdLowPriority(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
                }
            }
        ]
    })(props);
}
function MdMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function MdMarkunread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function MdMoveToInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function MdNextWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlinedFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function MdPolicy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5l-9-4-9 4v6c0 5.55 3.84 10.74 9 12 2.3-.56 4.33-1.9 5.88-3.71l-3.12-3.12a4.994 4.994 0 01-6.29-.64 5.003 5.003 0 010-7.07 5.003 5.003 0 017.07 0 5.006 5.006 0 01.64 6.29l2.9 2.9C20.29 15.69 21 13.38 21 11V5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function MdPushPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16 9V4h1c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function MdRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 017.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
                }
            }
        ]
    })(props);
}
function MdRemoveCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdRemoveCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5v-2h14v2z"
                }
            }
        ]
    })(props);
}
function MdReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function MdReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function MdReportGmailerrorred(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v6h-2zM11 15h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdReportOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2.92l6.91 6.91 1.09-1.1V8.27L15.73 3H8.27L7.18 4.1 11 7.92zm11.27 14.73l-20-20.01L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.63L21 23l1.27-1.27zM12 17.3c-.72 0-1.3-.58-1.3-1.3s.58-1.3 1.3-1.3 1.3.58 1.3 1.3-.58 1.3-1.3 1.3z"
                }
            }
        ]
    })(props);
}
function MdReport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function MdSaveAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
                }
            }
        ]
    })(props);
}
function MdSaveAs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.4V7l-4-4H5a2 2 0 00-2 2v14a2 2 0 002 2h7.4l8.6-8.6zM15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zM6 6h9v4H6V6zm13.99 10.25l1.77 1.77L16.77 23H15v-1.77l4.99-4.98zm3.26.26l-.85.85-1.77-1.77.85-.85c.2-.2.51-.2.71 0l1.06 1.06c.2.2.2.52 0 .71z"
                }
            }
        ]
    })(props);
}
function MdSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
                }
            }
        ]
    })(props);
}
function MdSelectAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
                }
            }
        ]
    })(props);
}
function MdSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
                }
            }
        ]
    })(props);
}
function MdShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
                }
            }
        ]
    })(props);
}
function MdSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdSquareFoot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
                }
            }
        ]
    })(props);
}
function MdStackedBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM4 4h4v4H4zM10 7h4v4h-4zM16 10h4v4h-4zM16 15h4v5h-4zM10 12h4v8h-4z"
                }
            }
        ]
    })(props);
}
function MdStream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.05 8.59L6.03 4.55h-.01l-.31-.32-1.42 1.41 4.02 4.05.01-.01.31.32zm3.893.027l4.405-4.392L19.76 5.64l-4.405 4.393zM10.01 15.36l-1.42-1.41-4.03 4.01-.32.33 1.41 1.41 4.03-4.02zm9.75 2.94l-3.99-4.01-.36-.35L14 15.35l3.99 4.01.35.35z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdTextFormat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
                }
            }
        ]
    })(props);
}
function MdUnarchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.55 5.22l-1.39-1.68A1.51 1.51 0 0018 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 002 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
                }
            }
        ]
    })(props);
}
function MdUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
                }
            }
        ]
    })(props);
}
function MdUpcoming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.16 7.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 3h2v5h-2zM6.4 10.81L7.81 9.4 4.26 5.84 2.84 7.26c.11.03 3.56 3.55 3.56 3.55zM20 12h-5c0 1.66-1.34 3-3 3s-3-1.34-3-3H4c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdWaves(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
                }
            }
        ]
    })(props);
}
function MdWebStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2V4zM2 20c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v16zm19-2c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5v12z"
                }
            }
        ]
    })(props);
}
function MdWeekend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10c-1.1 0-2 .9-2 2v3H5v-3a2 2 0 10-4 0v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.52 2 2.81V14h12v-2.03c0-1.3.84-2.4 2-2.81V7c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdWhereToVote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c3.86 0 7 3.14 7 7 0 5.25-7 13-7 13S5 14.25 5 9c0-3.86 3.14-7 7-7zm-1.53 12L17 7.41 15.6 6l-5.13 5.18L8.4 9.09 7 10.5l3.47 3.5z"
                }
            }
        ]
    })(props);
}
function Md1XMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h4v10H6V9H4V7zm11.83 4.72L18.66 7h-2.33l-1.66 2.77L13 7h-2.33l2.83 4.72L10.33 17h2.33l2-3.34 2 3.34H19l-3.17-5.28z"
                }
            }
        ]
    })(props);
}
function Md30Fps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v3h6v2.5H3v3h5V16H2v3h6c1.66 0 3-1.34 3-3v-1.9A2.1 2.1 0 008.9 12 2.1 2.1 0 0011 9.9V8c0-1.66-1.34-3-3-3H2zm17 3v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function Md3GMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v2h5v2H4v2h4v2H3v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9c0-1.1-.9-2-2-2H3zm18 4v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2h-7v6h5v-2h-2.5v-2H21z"
                }
            }
        ]
    })(props);
}
function Md4GMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v5H5V7H3v7h4v3h2v-3h2v-2H9V7zm8 4v2h2v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function Md4GPlusMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11v2h2v2h-4V9h6c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4h-4zm11 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2zM7 7H5v5H3V7H1v7h4v3h2v-3h1v-2H7V7z"
                }
            }
        ]
    })(props);
}
function Md60Fps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zm-9 3V5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3H5V8h5zm-2 5v3H5v-3h3z"
                }
            }
        ]
    })(props);
}
function MdAccessAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdAccessAlarms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-568H782v3600H-618zM0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdAccessTimeFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.3 14.71L11 12.41V7h2v4.59l3.71 3.71-1.42 1.41z"
                }
            }
        ]
    })(props);
}
function MdAccessTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function MdAdUnits(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM8 6h8v2H8z"
                }
            }
        ]
    })(props);
}
function MdAddAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
                }
            }
        ]
    })(props);
}
function MdAddToHomeScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41z"
                }
            }
        ]
    })(props);
}
function MdAir(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3h2c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1H2v-2h9.5c1.65 0 3 1.35 3 3zM19 6.5C19 4.57 17.43 3 15.5 3S12 4.57 12 6.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S16.33 8 15.5 8H2v2h13.5c1.93 0 3.5-1.57 3.5-3.5zm-.5 4.5H2v2h16.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5v2c1.93 0 3.5-1.57 3.5-3.5S20.43 11 18.5 11z"
                }
            }
        ]
    })(props);
}
function MdAirplaneTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.19 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.81-2-1.81-2zm-2.46 9.3l-8.86 2.36-1.66-2.88.93-.25 1.26.99 2.39-.64-2.4-4.16 1.4-.38 4.01 3.74 2.44-.65a.967.967 0 011.18.68.988.988 0 01-.69 1.19z"
                }
            }
        ]
    })(props);
}
function MdAirplanemodeActive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdAirplanemodeInactive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdAod(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 18H7V6h10v12zm-9-8h8v1.5H8V10zm1 3h6v1.5H9V13z"
                }
            }
        ]
    })(props);
}
function MdBattery0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v14h6V6z"
                }
            }
        ]
    })(props);
}
function MdBattery1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v12h6V6z"
                }
            }
        ]
    })(props);
}
function MdBattery2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v10h6V6z"
                }
            }
        ]
    })(props);
}
function MdBattery3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v8h6V6z"
                }
            }
        ]
    })(props);
}
function MdBattery4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v6h6V6z"
                }
            }
        ]
    })(props);
}
function MdBattery5Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v4h6V6z"
                }
            }
        ]
    })(props);
}
function MdBattery6Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v2h6V6z"
                }
            }
        ]
    })(props);
}
function MdBatteryAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
                }
            }
        ]
    })(props);
}
function MdBatteryChargingFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
                }
            }
        ]
    })(props);
}
function MdBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function MdBatterySaver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2V2h-4v2H8c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10h-2v2h-2v-2H9v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdBatteryStd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function MdBatteryUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94A1.498 1.498 0 0012 9.5c-.83 0-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
                }
            }
        ]
    })(props);
}
function MdBloodtype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm3 16H9v-2h6v2zm0-5h-2v2h-2v-2H9v-2h2V9h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdBluetoothConnected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdBluetoothDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
                }
            }
        ]
    })(props);
}
function MdBluetoothDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10H4.81l1.04-3H15V5H5.5c-.66 0-1.21.42-1.42 1.01L2 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8h-3c-1.1 0-2-.9-2-2zm-8.5 6c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.85L19.15 1h-.5v3.79l-2.3-2.29-.7.7L18.44 6l-2.79 2.79.7.71 2.3-2.3V11h.5L22 8.14 19.85 6 22 3.85zm-2.35-.94l.94.94-.94.94V2.91zm.94 5.23l-.94.94V7.2l.94.94z"
                }
            }
        ]
    })(props);
}
function MdBluetoothSearching(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdBrightnessAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
                }
            }
        ]
    })(props);
}
function MdBrightnessHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdBrightnessLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdBrightnessMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdCable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-2.21-1.79-4-4-4S5 4.79 5 7v7H4c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H7V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4v-7h1c.55 0 1-.45 1-1V5h-1z"
                }
            }
        ]
    })(props);
}
function MdCameraswitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1l-1-1h-4L9 7H8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-4 7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.57.51l4.48 4.48V2.04c4.72.47 8.48 4.23 8.95 8.95h2C23.34 3.02 15.49-1.59 8.57.51zM10.95 21.96c-4.72-.47-8.48-4.23-8.95-8.95H0c.66 7.97 8.51 12.58 15.43 10.48l-4.48-4.48v2.95z"
                }
            }
        ]
    })(props);
}
function MdCreditScore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h5v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm-5.07 11.17l-2.83-2.83-1.41 1.41L14.93 22 22 14.93l-1.41-1.41-5.66 5.65z"
                }
            }
        ]
    })(props);
}
function MdDarkMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 109 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 01-4.4 2.26 5.403 5.403 0 01-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"
                }
            }
        ]
    })(props);
}
function MdDataSaverOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdDataSaverOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v3H8v2h3v3h2v-3h3v-2h-3V8h-2zm2-5.95v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdDataUsage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdDatasetLinked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.09 17H7v-4h3.69c.95-.63 2.09-1 3.31-1h6c.34 0 .67.04 1 .09V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h3.81C8.3 20.12 8 19.09 8 18c0-.34.04-.67.09-1zM13 7h4v4h-4V7zM7 7h4v4H7V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c0-1.1.9-2 2-2h2v-2h-2c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2h-2c-1.1 0-2-.9-2-2zM20 14h-2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2v2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17h6v2h-6z"
                }
            }
        ]
    })(props);
}
function MdDataset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 14H7v-4h4v4zm0-6H7V7h4v4zm6 6h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function MdDeveloperMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
                }
            }
        ]
    })(props);
}
function MdDeviceThermostat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z"
                }
            }
        ]
    })(props);
}
function MdDevicesFold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-3c0-1.43-1.47-2.4-2.79-1.84l-3 1.29C10.48 2.76 10 3.49 10 4.29V19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-5.33l1.12-.48c.73-.32 1.21-1.04 1.21-1.84V5h3v14zM2 3h2v2H2zM2 19h2v2H2zM2 15h2v2H2zM2 11h2v2H2zM2 7h2v2H2zM6 3h2v2H6zM6 19h2v2H6z"
                }
            }
        ]
    })(props);
}
function MdDevices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function MdDiscount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.79 21L3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.79 21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 17.41c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.63.58A2.04 2.04 0 0011.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41l7.79 7.79zM7.25 3a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
                }
            }
        ]
    })(props);
}
function MdDoNotDisturbOnTotalSilence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.6-6-6-6zm3 7H9v-2h6v2z"
                }
            }
        ]
    })(props);
}
function MdDvr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdEMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z"
                }
            }
        ]
    })(props);
}
function MdEdgesensorHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v7H3V7zm-3 3h2v7H0v-7zm22-3h2v7h-2V7zm-3 3h2v7h-2v-7zm-3-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 17H8V7h8v10z"
                }
            }
        ]
    })(props);
}
function MdEdgesensorLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h2v7H2V7zm18 3h2v7h-2v-7zm-4-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 17H8V7h8v10z"
                }
            }
        ]
    })(props);
}
function MdFlashlightOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V2H6v1.17L7.83 5zM16 11l2-3V7H9.83L16 13.17zM2.81 2.81L1.39 4.22 8 10.83V22h8v-3.17l3.78 3.78 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdFlashlightOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2h12v3H6zM6 7v1l2 3v11h8V11l2-3V7H6zm6 8.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdFlourescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9h14v6H5zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function MdFluorescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9h14v6H5zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function MdFmdBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm1 13h-2v-2h2v2zm0-4h-2V6h2v5z"
                }
            }
        ]
    })(props);
}
function MdFmdGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdGMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v2h2v2H9V9h7c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function MdGppBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm3.5 12.09l-1.41 1.41L12 13.42 9.91 15.5 8.5 14.09 10.59 12 8.5 9.91 9.91 8.5 12 10.59l2.09-2.09 1.41 1.41L13.42 12l2.08 2.09z"
                }
            }
        ]
    })(props);
}
function MdGppGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm-1.06 13.54L7.4 12l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66z"
                }
            }
        ]
    })(props);
}
function MdGppMaybe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm1 14h-2v-2h2v2zm0-4h-2V7h2v5z"
                }
            }
        ]
    })(props);
}
function MdGpsFixed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdGpsNotFixed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdGpsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0119 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04A8.914 8.914 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27a6.995 6.995 0 01-9.81-9.81l9.81 9.81z"
                }
            }
        ]
    })(props);
}
function MdGraphicEq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
                }
            }
        ]
    })(props);
}
function MdGrid3X3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdGrid4X4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7V5h-3V2h-2v3h-4V2h-2v3H7V2H5v3H2v2h3v4H2v2h3v4H2v2h3v3h2v-3h4v3h2v-3h4v3h2v-3h3v-2h-3v-4h3v-2h-3V7h3zM7 7h4v4H7V7zm0 10v-4h4v4H7zm10 0h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function MdGridGoldenratio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9h-7V2h-2v7h-2V2H9v7H2v2h7v2H2v2h7v7h2v-7h2v7h2v-7h7v-2h-7v-2h7zm-9 2h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdHMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z"
                }
            }
        ]
    })(props);
}
function MdHPlusMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11H6V7H4v10h2v-4h6v4h2V7h-2v4zm10 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdHdrAutoSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zM16.5 16H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1zM3.5 18h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5zM22 18.5v-2h-1.5v2h-2V20h2v2H22v-2h2v-1.5zM11.97 5.3l-1.02 2.89h2.1L12.03 5.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm2.04 9l-.63-1.79h-2.83L9.96 11H8.74l2.63-7h1.25l2.63 7h-1.21z"
                }
            }
        ]
    })(props);
}
function MdHdrAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.04 8.04h-.09l-1.6 4.55h3.29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.21 15l-.98-2.81H9.78l-1 2.81h-1.9l4.13-11h1.97l4.13 11h-1.9z"
                }
            }
        ]
    })(props);
}
function MdHdrOffSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM10.98 4.15L9.42 2.59c5.1-2.42 10.41 2.89 7.99 7.99l-1.56-1.56c.81-2.96-1.91-5.68-4.87-4.87zM6.34 2.34L4.93 3.76l1.66 1.66c-2.42 5.1 2.89 10.41 7.99 7.99l1.66 1.66 1.41-1.41L6.34 2.34zm1.81 4.64l4.87 4.87c-2.96.81-5.68-1.91-4.87-4.87z"
                }
            }
        ]
    })(props);
}
function MdHdrOnSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4m0-2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdLan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3z"
                }
            }
        ]
    })(props);
}
function MdLensBlur(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdLightMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"
                }
            }
        ]
    })(props);
}
function MdLocationDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5A6.995 6.995 0 0119 12c0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04A8.914 8.914 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27a6.995 6.995 0 01-9.81-9.81l9.81 9.81z"
                }
            }
        ]
    })(props);
}
function MdLocationSearching(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdLteMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h3v2H4V8h2v6zm3-4h2v6h2v-6h2V8H9v2zm12 0V8h-5v8h5v-2h-3v-1h3v-2h-3v-1h3z"
                }
            }
        ]
    })(props);
}
function MdLtePlusMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h3v2H1V8h2v6zm2-4h2v6h2v-6h2V8H5v2zm7 6h5v-2h-3v-1h3v-2h-3v-1h3V8h-5v8zm12-5h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdMacroOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.98 17.15A8.909 8.909 0 0021 13c-1.5 0-2.91.37-4.15 1.02l3.13 3.13zM3 13a9 9 0 009 9 9 9 0 00-9-9zM12 5.5A2.5 2.5 0 0114.5 8c0 .99-.58 1.84-1.42 2.25l2.48 2.48c.11.02.23.03.35.03a2.5 2.5 0 002.5-2.5c0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25a2.5 2.5 0 00-3.92-2.06l.01-.2a2.5 2.5 0 00-5 0l.02.19a2.485 2.485 0 00-2.93.08l3.16 3.16c.41-.85 1.26-1.43 2.25-1.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l4.64 4.64c-.27.4-.43.87-.43 1.39a2.5 2.5 0 002.5 2.5c.52 0 .99-.16 1.4-.43l.02.02-.02.16A2.5 2.5 0 0012 15c.05 0 .1-.01.16-.02l1.64 1.64A8.905 8.905 0 0012 22c2.02 0 3.88-.67 5.38-1.8l2.4 2.4 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdMediaBluetoothOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.17V3h6v4h-4v1.17l-2-2zM19.42 15L22 17.57l-.8.8-6.78-6.78.8-.8 2.75 2.75V9h.6L22 12.43 19.42 15zm-.25-1.45l1.13-1.13-1.13-1.13v2.26zm2.02 7.64l-1.41 1.41-3.98-3.98-.58.58-.85-.85.58-.58L11 13.83V17c0 2.21-1.78 4-3.99 4S3 19.21 3 17s1.79-4 4.01-4c.73 0 1.41.21 2 .55v-1.72L1.39 4.22 2.8 2.81l18.39 18.38z"
                }
            }
        ]
    })(props);
}
function MdMediaBluetoothOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3l.01 10.55c-.6-.34-1.28-.55-2-.55a4.001 4.001 0 100 8C9.23 21 11 19.21 11 17V7h4V3H9zm12 9.43L17.57 9h-.6v4.55l-2.75-2.75-.85.85L16.73 15l-3.35 3.35.85.85 2.75-2.75V21h.6L21 17.57 18.42 15 21 12.43zm-2.83-1.13l1.13 1.13-1.13 1.13V11.3zm1.13 6.27l-1.13 1.13v-2.26l1.13 1.13z"
                }
            }
        ]
    })(props);
}
function MdMedicationLiquid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h12v2H3zM14 6H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 9h-2.5v2.5h-3V15H5v-3h2.5V9.5h3V12H13v3zM20 6c-1.68 0-3 1.76-3 4 0 1.77.83 3.22 2 3.76V20c0 .55.45 1 1 1s1-.45 1-1v-6.24c1.17-.54 2-1.99 2-3.76 0-2.24-1.32-4-3-4z"
                }
            }
        ]
    })(props);
}
function MdMedication(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3h12v2H6zM17 6H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-1 9h-2.5v2.5h-3V15H8v-3h2.5V9.5h3V12H16v3z"
                }
            }
        ]
    })(props);
}
function MdMobileFriendly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27z"
                }
            }
        ]
    })(props);
}
function MdMobileOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.76 2.49L1.49 3.76 5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.27-1.27L2.76 2.49zM7 19V9.27L16.73 19H7zM17 5v9.17l2 2V3c0-1.1-.9-2-2-2H7c-.85 0-1.58.54-1.87 1.3L7.83 5H17z"
                }
            }
        ]
    })(props);
}
function MdMobiledataOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h3l-4-4-4 4h3v4.17l2 2zM2.81 2.81L1.39 4.22 8 10.83v6.18l-3 .01L9 21l4-4-3 .01v-4.18l9.78 9.78 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdModeNight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"
                }
            }
        ]
    })(props);
}
function MdModeStandby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdMonitorHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.11 12.45L14 10.24l-3.11 6.21c-.16.34-.51.55-.89.55s-.73-.21-.89-.55L7.38 13H2v5c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-5h-6c-.38 0-.73-.21-.89-.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v5h6c.38 0 .73.21.89.55L10 13.76l3.11-6.21c.34-.68 1.45-.68 1.79 0L16.62 11H22V6c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdMonitorWeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8.5h1v1h-1zM11.5 8.5h1v1h-1zM13 8.5h1v1h-1z"
                }
            }
        ]
    })(props);
}
function MdNearbyError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.57l4.42 4.42L12 16.41l-4.42-4.42L12 7.57zm0 11.62l-7.2-7.2 7.2-7.2 6 6V7.16l-4.58-4.58c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L18 16.82v-3.63l-6 6zm8 .81h2v2h-2v-2zm2-10h-2v8h2v-8"
                }
            }
        ]
    })(props);
}
function MdNearbyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 13.42L18.83 16l-1.81-1.81L19.2 12 12 4.8 9.81 6.99 8 5.17l2.58-2.58c.78-.78 2.05-.78 2.83 0l8 8c.79.78.79 2.04 0 2.83zm-.22 7.77l-1.41 1.41L16 18.83l-2.58 2.58c-.78.78-2.05.78-2.83 0l-8-8c-.78-.78-.78-2.05 0-2.83L5.17 8 1.39 4.22 2.8 2.81l18.39 18.38zm-7-4.17l-1.39-1.39-.8.8L7.58 12l.8-.8-1.4-1.39L4.8 12l7.2 7.2 2.19-2.18zM16.42 12L12 7.58l-.8.8 4.42 4.42.8-.8z"
                }
            }
        ]
    })(props);
}
function MdNetworkCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z"
                }
            }
        ]
    })(props);
}
function MdNetworkWifi1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm3.32 10.84C14.34 14.3 13.2 14 12 14c-1.2 0-2.34.3-3.32.84L2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-5.76 5.77z"
                }
            }
        ]
    })(props);
}
function MdNetworkWifi2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm4.78 9.38A8.853 8.853 0 0012 12c-1.76 0-3.4.5-4.78 1.38l-4.3-4.3C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-4.3 4.31z"
                }
            }
        ]
    })(props);
}
function MdNetworkWifi3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-2.85 2.86A10.945 10.945 0 0012 10c-2.31 0-4.46.71-6.23 1.93L2.92 9.07z"
                }
            }
        ]
    })(props);
}
function MdNetworkWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98zm-21.08.09C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-1.43 1.43C17.5 8.94 14.86 8 12 8s-5.5.94-7.65 2.51L2.92 9.07z"
                }
            }
        ]
    })(props);
}
function MdNfc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M4 20h16V4H4v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
                }
            }
        ]
    })(props);
}
function MdNightlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2c1.82 0 3.53.5 5 1.35-2.99 1.73-5 4.95-5 8.65s2.01 6.92 5 8.65A9.973 9.973 0 0114 22C8.48 22 4 17.52 4 12S8.48 2 14 2z"
                }
            }
        ]
    })(props);
}
function MdNoteAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM9.1 17H7v-2.14l5.96-5.96 2.12 2.12L9.1 17zm7.75-7.73l-1.06 1.06-2.12-2.12 1.06-1.06c.2-.2.51-.2.71 0l1.41 1.41c.2.2.2.51 0 .71z"
                }
            }
        ]
    })(props);
}
function MdPassword(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zm6.7-.75l1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7l-.85 1.48zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23v-1.5z"
                }
            }
        ]
    })(props);
}
function MdPattern(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.02 6c-.74 0-1.37.4-1.72 1h-2.54a1.98 1.98 0 00-3.44 0H8.41l3.07-3.07c.17.04.34.07.52.07 1.1 0 2-.9 2-2 0-.18-.03-.35-.07-.51l3.56-3.56c.16.04.33.07.51.07 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .18.03.35.07.51l-3.56 3.56c-.16-.04-.33-.07-.51-.07-1.1 0-2 .9-2 2 0 .18.03.35.07.51l-3.56 3.56C6.35 16.03 6.18 16 6 16c-1.1 0-2 .9-2 2s.9 2 2 2c.74 0 1.37-.4 1.72-1h2.57a1.98 1.98 0 003.44 0h2.55c.34.6.98 1 1.72 1 1.1 0 2-.9 2-2-.02-1.1-.92-2-2.02-2z"
                }
            }
        ]
    })(props);
}
function MdPhishing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9c0-1.3-.84-2.4-2-2.82V2h-2v4.18C13.84 6.6 13 7.7 13 9s.84 2.4 2 2.82V15c0 2.21-1.79 4-4 4s-4-1.79-4-4v-1h3L5 9v6c0 3.31 2.69 6 6 6s6-2.69 6-6v-3.18c1.16-.42 2-1.52 2-2.82zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.64 15H6.49v-4.5l-.9.66-.58-.89L6.77 9h.87v6zm5.86 0H9.61v-1.02c1.07-1.07 1.77-1.77 2.13-2.15.4-.42.54-.69.54-1.06 0-.4-.31-.72-.81-.72-.52 0-.8.39-.9.72l-1.01-.42c.01-.02.18-.76 1-1.15.69-.33 1.48-.2 1.95.03.86.44.91 1.24.91 1.48 0 .64-.31 1.26-.92 1.86-.25.25-.72.71-1.4 1.39l.03.05h2.37V15zm5.25-.85c-.08.13-.56.85-1.76.85-.04 0-1.6.08-2.05-1.51l1.03-.41c.03.1.19.86 1.02.86.41 0 .89-.28.89-.77 0-.55-.48-.79-1.04-.79h-.5v-1h.46c.33 0 .88-.14.88-.72 0-.39-.31-.65-.75-.65-.5 0-.74.32-.85.64l-.99-.41C15.2 9.9 15.68 9 16.94 9c1.09 0 1.54.64 1.62.75.33.5.28 1.16.02 1.57-.15.22-.32.38-.52.48v.07c.28.11.51.28.68.52.37.52.33 1.27.01 1.76z"
                }
            }
        ]
    })(props);
}
function MdPlayLesson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11c.34 0 .67.03 1 .08V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.26A6.995 6.995 0 0118 11zM7 11V4h5v7L9.5 9.5 7 11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-1.25 7.5v-5l4 2.5-4 2.5z"
                }
            }
        ]
    })(props);
}
function MdPriceChange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm-8 6H8v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1H8v-1H6v-2h4v-1H7c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1V7h2v1h2v2zm4 6.25l-2-2h4l-2 2zM14 10l2-2 2 2h-4z"
                }
            }
        ]
    })(props);
}
function MdPriceCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V9c0-.55-.45-1-1-1H7V6h5V4H9.5V3h-2v1H6c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4v2H5v2h2.5v1h2v-1H11c.55 0 1-.45 1-1zM19.59 12.52l-5.66 5.65-2.83-2.83-1.41 1.42L13.93 21 21 13.93z"
                }
            }
        ]
    })(props);
}
function MdPunchClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-1V1H6v5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 3h8v3H8V3zm4 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.5h-1v2.71l1.64 1.64.71-.71-1.35-1.35z"
                }
            }
        ]
    })(props);
}
function MdQuiz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.99 13c-.59 0-1.05-.47-1.05-1.05 0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04-.01.58-.45 1.05-1.04 1.05zm2.5-6.17c-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c0-.41-.06-1.08.26-1.65.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C11.51 5.96 12.52 5 13.99 5c1.23 0 2.08.56 2.51 1.26.37.61.58 1.73.01 2.57z"
                }
            }
        ]
    })(props);
}
function MdRMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 7.2L9 10H7L5.87 7.33H4V10H2V2h5c1.13 0 2 .87 2 2v1.33c0 .8-.53 1.54-1.2 1.87zM7 4H4v1.33h3V4z"
                }
            }
        ]
    })(props);
}
function MdRadar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.74 18.33A9.984 9.984 0 0022 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10a9.984 9.984 0 007.11-2.97c.03-.03.05-.06.07-.08.2-.2.39-.41.56-.62zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8c0 1.85-.63 3.54-1.69 4.9l-1.43-1.43c.69-.98 1.1-2.17 1.1-3.46 0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6c1.3 0 2.51-.42 3.49-1.13l1.42 1.42A7.822 7.822 0 0112 20zm1.92-7.49c.17-.66.02-1.38-.49-1.9l-.02-.02c-.77-.77-2-.78-2.78-.04-.01.01-.03.02-.05.04-.78.78-.78 2.05 0 2.83l.02.02c.52.51 1.25.67 1.91.49l1.51 1.51c-.6.36-1.29.58-2.04.58-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .73-.21 1.41-.56 2l-1.5-1.51z"
                }
            }
        ]
    })(props);
}
function MdRememberMe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 14.21c-1.5-.77-3.2-1.21-5-1.21s-3.5.44-5 1.21V6h10v9.21z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function MdResetTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-8.01V7L9 11l3.99 4v-3H21v5H3V5h18v3h2V5c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2v-5H23c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdRestartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8zM6 13c0-1.65.67-3.15 1.76-4.24L6.34 7.34A8.014 8.014 0 004 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91z"
                }
            }
        ]
    })(props);
}
function MdReviews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6.43 9.57L12 15l-1.57-3.43L7 10l3.43-1.57L12 5l1.57 3.43L17 10l-3.43 1.57z"
                }
            }
        ]
    })(props);
}
function MdRsvp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h1.5l-1.75 6h-1.5L12.5 9H14l1 3.43L16 9zM5.1 12.9L6 15H4.5l-.85-2H2.5v2H1V9h3.5c.85 0 1.5.65 1.5 1.5v1c0 .6-.4 1.15-.9 1.4zm-.6-2.4h-2v1h2v-1zm17 2.5h-2v2H18V9h3.5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5zm0-2.5h-2v1h2v-1zM11.5 9v1.5h-3v.75h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7v-1.5h3v-.75H7.75c-.41 0-.75-.34-.75-.75v-2c0-.55.45-1 1-1h3.5z"
                }
            }
        ]
    })(props);
}
function MdScreenLockLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"
                }
            }
        ]
    })(props);
}
function MdScreenLockPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdScreenLockRotation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75a1.49 1.49 0 00-2.12 0L2.75 7.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48A10.487 10.487 0 012.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5a2.5 2.5 0 00-5 0V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"
                }
            }
        ]
    })(props);
}
function MdScreenRotation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77a1.49 1.49 0 00-2.12 0L1.75 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
                }
            }
        ]
    })(props);
}
function MdScreenSearchDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M9.6 16.8h4.8v1.8H9.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4zM4 16V6h16v10.01L4 16zm5.097-6.047c0-1.027.836-1.864 1.864-1.864 1.027 0 1.864.837 1.864 1.864a1.867 1.867 0 01-1.864 1.864 1.867 1.867 0 01-1.864-1.864zm7.032 4.236l-2.482-2.482a3.19 3.19 0 00.527-1.754A3.216 3.216 0 0010.96 6.74a3.217 3.217 0 00-3.214 3.213 3.218 3.218 0 003.214 3.214 3.19 3.19 0 001.724-.51l2.489 2.487.955-.955z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function MdScreenshotMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7.5H9V6H5v4h1.5zM19 12h-1.5v2.5H15V16h4z"
                }
            }
        ]
    })(props);
}
function MdScreenshot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 18H7V6h10v12zM9.5 8.5H12V7H8v4h1.5V8.5zM12 17h4v-4h-1.5v2.5H12V17z"
                }
            }
        ]
    })(props);
}
function MdSdStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
                }
            }
        ]
    })(props);
}
function MdSecurityUpdateGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12zm-1-7.95l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function MdSecurityUpdateWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12z"
                }
            }
        ]
    })(props);
}
function MdSecurityUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2zm12 15H7V6h10v12zm-1-6h-3V8h-2v4H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function MdSell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.41l-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5 7.33 8 6.5 8z"
                }
            }
        ]
    })(props);
}
function MdSendToMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-1.99 2-1.99L17 1c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1zm5-5l-4-4v3h-5v2h5v3l4-4z"
                }
            }
        ]
    })(props);
}
function MdSettingsSuggest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.41 6.59L15 5.5l2.41-1.09L18.5 2l1.09 2.41L22 5.5l-2.41 1.09L18.5 9l-1.09-2.41zm3.87 6.13L20.5 11l-.78 1.72-1.72.78 1.72.78.78 1.72.78-1.72L23 13.5l-1.72-.78zm-5.04 1.65l1.94 1.47-2.5 4.33-2.24-.94c-.2.13-.42.26-.64.37l-.3 2.4h-5l-.3-2.41c-.22-.11-.43-.23-.64-.37l-2.24.94-2.5-4.33 1.94-1.47c-.01-.11-.01-.24-.01-.36s0-.25.01-.37l-1.94-1.47 2.5-4.33 2.24.94c.2-.13.42-.26.64-.37L7.5 6h5l.3 2.41c.22.11.43.23.64.37l2.24-.94 2.5 4.33-1.94 1.47c.01.12.01.24.01.37s0 .24-.01.36zM13 14c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3z"
                }
            }
        ]
    })(props);
}
function MdSettingsSystemDaydream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6.5a2.5 2.5 0 000-5h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16A2.994 2.994 0 006 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function MdShareLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.02 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.42-1.43a7.941 7.941 0 01-3.9 1.62zM4.03 12c0-4.05 3.03-7.41 6.95-7.93V2.05C5.95 2.58 2.03 6.84 2.03 12c0 5.16 3.92 9.42 8.95 9.95v-2.02c-3.92-.52-6.95-3.88-6.95-7.93zM19.95 11h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.43c.86 1.1 1.44 2.43 1.62 3.89zM18.34 4.26a9.981 9.981 0 00-5.32-2.21v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM18.33 16.9l1.43 1.42A9.949 9.949 0 0021.97 13h-2.02a7.941 7.941 0 01-1.62 3.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.1C16 8.61 14.1 7 12 7s-4 1.61-4 4.1c0 1.66 1.33 3.63 4 5.9 2.67-2.27 4-4.24 4-5.9zm-4 .9a1.071 1.071 0 010-2.14A1.071 1.071 0 0112 12z"
                }
            }
        ]
    })(props);
}
function MdShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11l-6-6v5H8c-2.76 0-5 2.24-5 5v4h2v-4c0-1.65 1.35-3 3-3h7v5l6-6z"
                }
            }
        ]
    })(props);
}
function MdSignalCellular0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
                }
            }
        ]
    })(props);
}
function MdSignalCellular4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularAlt1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularAlt2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6zm6-5h3v11h-3V9z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h3v16h-3zM5 14h3v6H5zm6-5h3v11h-3z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularConnectedNoInternet0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20H18z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularConnectedNoInternet4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularNoSim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-2872H782V728H-618zM-1 0h26v24H-1zm1 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularNodata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-9v9H2L22 2v11zm-1 2.41L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularNull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.33 0 6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1C5.51 7.08 8.67 6 12 6m0-2C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi4BarLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiConnectedNoInternet4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbar4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarConnectedNoInternet4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4zM19 18h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarNull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"
                }
            }
        ]
    })(props);
}
function MdSimCardDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 15l-4-4h3V9.02L13 9v4h3l-4 4z"
                }
            }
        ]
    })(props);
}
function MdSplitscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v5H6V4h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 13v5H6v-5h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdSportsScore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9V4h2v2zm4-2h-2v2h2V4zM9 14h2v-2H9v2zm10-4V8h-2v2h2zm0 4v-2h-2v2h2zm-6 0h2v-2h-2v2zm6-10h-2v2h2V4zm-6 4V6h-2v2h2zm-6 2V8h2V6H7V4H5v16h2v-8h2v-2H7zm8 2h2v-2h-2v2zm-4-2v2h2v-2h-2zM9 8v2h2V8H9zm4 2h2V8h-2v2zm2-4v2h2V6h-2z"
                }
            }
        ]
    })(props);
}
function MdSsidChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5.47L12 12 7.62 7.62 3 11V8.52L7.83 5l4.38 4.38L21 3v2.47zM21 15h-4.7l-4.17 3.34L6 12.41l-3 2.13V17l2.8-2 6.2 6 5-4h4v-2z"
                }
            }
        ]
    })(props);
}
function MdStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
                }
            }
        ]
    })(props);
}
function MdStorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.93 8C16.72 4.18 11.82 2.87 8 5.07c-1.41.82-2.48 2-3.16 3.37-.13-2.2.22-4.4 1.02-6.44H3.74C2.2 6.49 2.52 11.58 5.07 16a7.96 7.96 0 004.86 3.72c1.98.53 4.16.31 6.07-.79 1.41-.82 2.48-2 3.16-3.37.13 2.2-.21 4.4-1.01 6.44h2.11c1.53-4.49 1.22-9.58-1.33-14zM15 17.2A6.012 6.012 0 016.8 15c-.11-.2-.21-.4-.3-.6-1.2-2.76-.17-6.06 2.5-7.6 2.86-1.65 6.54-.67 8.2 2.2.11.2.21.4.3.6 1.2 2.76.17 6.06-2.5 7.6zM12 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdSummarize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V9l-6-6zM8 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 1V4.5l5.5 5.5H14z"
                }
            }
        ]
    })(props);
}
function MdSystemSecurityUpdateGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12zm-1-7.95l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function MdSystemSecurityUpdateWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 17H7V6h10v12z"
                }
            }
        ]
    })(props);
}
function MdSystemSecurityUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 3v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2zm12 15H7V6h10v12zm-1-6h-3V8h-2v4H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function MdTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-3.06 16L7.4 14.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L10.94 18zM13 9V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function MdThermostat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1h-1v1h1v2h-1v1h1v1h-2z"
                }
            }
        ]
    })(props);
}
function MdTimer10Select(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h-3V8h3m0-3h-3C8.34 5 7 6.34 7 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zM1 8h2v11h3V5H1v3zm17.5 3c-.83 0-1.5.68-1.5 1.5v2c0 .82.67 1.5 1.5 1.5H21v1h-4v2h4.5c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H19v-1h4v-2h-4.5z"
                }
            }
        ]
    })(props);
}
function MdTimer3Select(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11v2h-4v1h2.5c.83 0 1.5.68 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H15v-2h4v-1h-2.5c-.82 0-1.5-.68-1.5-1.5v-2c0-.82.68-1.5 1.5-1.5H21zM4 5v3h6v2.5H4v3h6V16H4v3h6c1.66 0 3-1.34 3-3v-1.9a2.1 2.1 0 00-2.1-2.1A2.1 2.1 0 0013 9.9V8c0-1.66-1.34-3-3-3H4z"
                }
            }
        ]
    })(props);
}
function MdTungsten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2zM2 11h3v2H2zM19 11h3v2h-3zM15.894 17.801l1.407-1.407 2.122 2.122-1.408 1.407zM4.584 18.509l2.121-2.122 1.408 1.407-2.122 2.122zM15 8.02V3H9v5.02c-1.21.92-2 2.35-2 3.98 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.06-2-3.98zM11 5h2v2.1c-.32-.06-.66-.1-1-.1s-.68.04-1 .1V5z"
                }
            }
        ]
    })(props);
}
function MdUsbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h4v4h-1v2c0 .34-.08.66-.23.94L16 13.17V12h-1V8zm-4 .17l2 2V6h2l-3-4-3 4h2v2.17zM13 16v2.28c.6.34 1 .98 1 1.72 0 1.1-.9 2-2 2s-2-.9-2-2c0-.74.4-1.37 1-1.72V16H8c-1.11 0-2-.89-2-2v-2.28c-.6-.34-1-.98-1-1.72 0-.59.26-1.13.68-1.49L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-6.6-6.6H13zm-2-2v-.17l-2.51-2.51c-.14.16-.31.29-.49.4V14h3z"
                }
            }
        ]
    })(props);
}
function MdUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95a2.2 2.2 0 004.4 0c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
                }
            }
        ]
    })(props);
}
function MdWallpaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function MdWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 14H22h-.02zM5.35 13c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1zm13.32 2c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.19 0 1.42 1 3.33 1 1.94 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM5.35 9c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1V8c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1C3.38 7 3.24 8 2 8v2c1.9 0 2.17-1 3.35-1z"
                }
            }
        ]
    })(props);
}
function MdWidgets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
                }
            }
        ]
    })(props);
}
function MdWifi1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.53 17.46L12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"
                }
            }
        ]
    })(props);
}
function MdWifi2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.03 0 5.78 1.23 7.76 3.22l-2.12 2.12A7.967 7.967 0 0012 13c-2.2 0-4.2.9-5.64 2.35l-2.12-2.12C6.22 11.23 8.97 10 12 10zm0 6c-1.38 0-2.63.56-3.53 1.46L12 21l3.53-3.54A4.98 4.98 0 0012 16z"
                }
            }
        ]
    })(props);
}
function MdWifiCalling3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.47 6.47 0 019.18 0l1.06-1.06A7.932 7.932 0 0016.49 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.03 7.46a5.022 5.022 0 00-7.08 0l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.08-1.06zM15.08 9.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59s-1.05.22-1.41.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.63 14.4l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73a.985.985 0 00-.9.26z"
                }
            }
        ]
    })(props);
}
function MdWifiChannel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3c-2.51 0-3.77 5.61-4.4 10.57C10.79 10.66 9.61 8 8 8 4.43 8 3 21 3 21h2.01c.61-5.27 2-9.82 2.99-10.87.98 1.05 2.38 5.61 2.99 10.87H13c.5-2.53 2-6 3-6s2.5 3.53 3 6h2s-.5-18-5-18zm0 10c-.99 0-1.82.62-2.5 1.5.57-4.77 1.54-8.62 2.5-9.44.97.81 1.91 4.67 2.49 9.43C17.81 13.62 16.98 13 16 13z"
                }
            }
        ]
    })(props);
}
function MdWifiFind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14c0-3.36 2.64-6 6-6 2.2 0 4.08 1.13 5.13 2.86L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21l1.86-1.87C12.14 18.09 11 16.2 11 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-2.24-1.76-4-4-4s-4 1.76-4 4 1.76 4 4 4c.75 0 1.44-.21 2.03-.56L21.59 20 23 18.59l-2.56-2.56c.35-.59.56-1.28.56-2.03zm-6 0c0-1.12.88-2 2-2s2 .88 2 2-.88 2-2 2-2-.88-2-2z"
                }
            }
        ]
    })(props);
}
function MdWifiLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdWifiPassword(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 19v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1zm2-10.02l-2.12 2.13C19.35 8.57 15.85 7 12 7s-7.35 1.57-9.88 4.11L0 8.98C3.07 5.9 7.31 4 12 4s8.93 1.9 12 4.98zM12 10c3.03 0 5.78 1.23 7.76 3.22l-2.12 2.12A7.967 7.967 0 0012 13c-2.2 0-4.2.9-5.64 2.35l-2.12-2.12C6.22 11.23 8.97 10 12 10zm3.53 7.46L12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"
                }
            }
        ]
    })(props);
}
function MdWifiTetheringErrorRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdWifiTetheringError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdWifiTetheringOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.69 2.69A9.958 9.958 0 002 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42a7.957 7.957 0 01-.84-10.31l1.43 1.43a6.003 6.003 0 00.82 7.47l1.42-1.42A3.934 3.934 0 018 13c0-.63.15-1.23.41-1.76l1.61 1.61c0 .05-.02.1-.02.15 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59.05 0 .1-.01.16-.02l7.62 7.62 1.41-1.41L2.81 2.81zM17.7 14.87c.19-.59.3-1.22.3-1.87 0-3.31-2.69-6-6-6-.65 0-1.28.1-1.87.3l1.71 1.71C11.89 9 11.95 9 12 9c2.21 0 4 1.79 4 4 0 .05 0 .11-.01.16l1.71 1.71zM12 5c4.42 0 8 3.58 8 8 0 1.22-.27 2.37-.77 3.4l1.49 1.49A9.953 9.953 0 0022 13c0-5.52-4.48-10-10-10-1.78 0-3.44.46-4.89 1.28l1.48 1.48C9.63 5.27 10.78 5 12 5z"
                }
            }
        ]
    })(props);
}
function MdWifiTethering(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function MdAddChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9.99h2v7H6zm8 3h2v4h-2zm-4-6h2v10h-2zM20 7V4h-2v3h-3v2h3v3h2V9h3V7zm-2 12H4V5h12V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5h-2v5z"
                }
            }
        ]
    })(props);
}
function MdAddComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM17 11h-4v4h-2v-4H7V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdAlignHorizontalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z"
                }
            }
        ]
    })(props);
}
function MdAlignHorizontalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z"
                }
            }
        ]
    })(props);
}
function MdAlignHorizontalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"
                }
            }
        ]
    })(props);
}
function MdAlignVerticalBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z"
                }
            }
        ]
    })(props);
}
function MdAlignVerticalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-5V6h-3v5h-4V3H7v8H1.84v2H7v8h3v-8h4v5h3v-5h5z"
                }
            }
        ]
    })(props);
}
function MdAlignVerticalTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z"
                }
            }
        ]
    })(props);
}
function MdAreaChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13v7h18v-1.5l-9-7L8 17l-5-4zm0-6l4 3 5-7 5 4h4v8.97l-9.4-7.31-3.98 5.48L3 10.44V7z"
                }
            }
        ]
    })(props);
}
function MdAttachFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
                }
            }
        ]
    })(props);
}
function MdAttachMoney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
                }
            }
        ]
    })(props);
}
function MdAutoGraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.94L12 9l2.06-.94L15 6l.94 2.06L18 9l-2.06.94L15 12l-.94-2.06zM4 14l.94-2.06L7 11l-2.06-.94L4 8l-.94 2.06L1 11l2.06.94L4 14zm4.5-5l1.09-2.41L12 5.5 9.59 4.41 8.5 2 7.41 4.41 5 5.5l2.41 1.09L8.5 9zm-4 11.5l6-6.01 4 4L23 8.93l-1.41-1.41-7.09 7.97-4-4L3 19l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"
                }
            }
        ]
    })(props);
}
function MdBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
                }
            }
        ]
    })(props);
}
function MdBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdBorderClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 24H2v-4h20v4zM13.06 5.19l3.75 3.75L7.75 18H4v-3.75l9.06-9.06zm4.82 2.68l-3.75-3.75 1.83-1.83a.996.996 0 011.41 0l2.34 2.34c.39.39.39 1.02 0 1.41l-1.83 1.83z"
                }
            }
        ]
    })(props);
}
function MdBorderHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBorderVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdBubbleChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.2",
                    "cy": "14.4",
                    "r": "3.2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.8",
                    "cy": "18",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.2",
                    "cy": "8.8",
                    "r": "4.8"
                }
            }
        ]
    })(props);
}
function MdCandlestickChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4H7v2H5v12h2v2h2v-2h2V6H9zM19 8h-2V4h-2v4h-2v7h2v5h2v-5h2z"
                }
            }
        ]
    })(props);
}
function MdChecklistRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H2v2h9V7zm0 8H2v2h9v-2zm5.34-4L12.8 7.46l1.41-1.41 2.12 2.12 4.24-4.24L22 5.34 16.34 11zm0 8l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L22 13.34 16.34 19z"
                }
            }
        ]
    })(props);
}
function MdChecklist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"
                }
            }
        ]
    })(props);
}
function MdDataArray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z"
                }
            }
        ]
    })(props);
}
function MdDataObject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7zM21 10c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z"
                }
            }
        ]
    })(props);
}
function MdDragHandle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
                }
            }
        ]
    })(props);
}
function MdDraw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.85 10.39l1.06-1.06c.78-.78.78-2.05 0-2.83L18.5 5.09c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24zm-5.66-2.83L4 16.76V21h4.24l9.19-9.19-4.24-4.25zM19 17.5c0 2.19-2.54 3.5-5 3.5-.55 0-1-.45-1-1s.45-1 1-1c1.54 0 3-.73 3-1.5 0-.47-.48-.87-1.23-1.2l1.48-1.48c1.07.63 1.75 1.47 1.75 2.68zM4.58 13.35C3.61 12.79 3 12.06 3 11c0-1.8 1.89-2.63 3.56-3.36C7.59 7.18 9 6.56 9 6c0-.41-.78-1-2-1-1.26 0-1.8.61-1.83.64-.35.41-.98.46-1.4.12a.992.992 0 01-.15-1.38C3.73 4.24 4.76 3 7 3s4 1.32 4 3c0 1.87-1.93 2.72-3.64 3.47C6.42 9.88 5 10.5 5 11c0 .31.43.6 1.07.86l-1.49 1.49z"
                }
            }
        ]
    })(props);
}
function MdEditNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3v-2zm0-2h11V6H3v2zm0 8h7v-2H3v2zm15.01-3.13l.71-.71a.996.996 0 011.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12zm-.71.71l-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function MdFormatAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdFormatAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdFormatAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdFormatAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdFormatBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdFormatClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
                }
            }
        ]
    })(props);
}
function MdFormatColorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5zM2 20h20v4H2v-4z"
                }
            }
        ]
    })(props);
}
function MdFormatColorReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"
                }
            }
        ]
    })(props);
}
function MdFormatColorText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61l2.03-5.79h.12l2.03 5.79H9.91z"
                }
            }
        ]
    })(props);
}
function MdFormatIndentDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function MdFormatIndentIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function MdFormatItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
                }
            }
        ]
    })(props);
}
function MdFormatLineSpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
                }
            }
        ]
    })(props);
}
function MdFormatListBulletedAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1zM7 5h13v2H7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "18",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11H7v2h6.11c1.26-1.24 2.99-2 4.89-2zM7 17v2h4.08c-.05-.33-.08-.66-.08-1s.03-.67.08-1H7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "6",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3.5",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdFormatListBulleted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
                }
            }
        ]
    })(props);
}
function MdFormatListNumberedRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3zm1-9h1V4h-2v1h1zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3zM2 5h14v2H2zm0 12h14v2H2zm0-6h14v2H2z"
                }
            }
        ]
    })(props);
}
function MdFormatListNumbered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdFormatPaint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"
                }
            }
        ]
    })(props);
}
function MdFormatQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
                }
            }
        ]
    })(props);
}
function MdFormatShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
                }
            }
        ]
    })(props);
}
function MdFormatSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
                }
            }
        ]
    })(props);
}
function MdFormatStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdFormatTextdirectionLToR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
                }
            }
        ]
    })(props);
}
function MdFormatTextdirectionRToL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
                }
            }
        ]
    })(props);
}
function MdFormatUnderlined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function MdFunctions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
                }
            }
        ]
    })(props);
}
function MdHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function MdHexagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9z"
                }
            }
        ]
    })(props);
}
function MdHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14l3 3v5h6v-5l3-3V9H6v5zm5-12h2v3h-2V2zM3.5 5.88l1.41-1.41 2.12 2.12L5.62 8 3.5 5.88zm13.46.71l2.12-2.12 1.41 1.41L18.38 8l-1.42-1.41z"
                }
            }
        ]
    })(props);
}
function MdHorizontalDistribute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 2h-2v20h2V2zm-8.5 5h-3v10h3V7z"
                }
            }
        ]
    })(props);
}
function MdHorizontalRule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 11h16v2H4z"
                }
            }
        ]
    })(props);
}
function MdInsertChartOutlined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.1h-15V5h15v14.1zm0-16.1h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdInsertChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdInsertComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
                }
            }
        ]
    })(props);
}
function MdInsertDriveFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
                }
            }
        ]
    })(props);
}
function MdInsertEmoticon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdInsertInvitation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function MdInsertLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function MdInsertPageBreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2v-3H4v3zM20 8l-6-6H6c-1.1 0-1.99.9-1.99 2v7H20V8zm-7 1V3.5L18.5 9H13zM9 13h6v2H9zM17 13h6v2h-6zM1 13h6v2H1z"
                }
            }
        ]
    })(props);
}
function MdInsertPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function MdLineAxis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.43l-1.41-1.41-4.03 4.53L9.5 4 2 11.51l1.5 1.5 6.14-6.15 5.59 5.18-1.73 1.95-4-4L2 17.5 3.5 19l6-6.01 4 4 3.19-3.59 3.9 3.61L22 15.6l-3.98-3.7z"
                }
            }
        ]
    })(props);
}
function MdLinearScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 000 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function MdMargin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14zM11 7h2v2h-2zM7 7h2v2H7zm8 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdMergeType(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function MdModeComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
                }
            }
        ]
    })(props);
}
function MdModeEditOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function MdModeEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function MdMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function MdMonetizationOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
                }
            }
        ]
    })(props);
}
function MdMoneyOffCsred(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.53 7.43c.42-.31.93-.47 1.54-.47s1.11.16 1.5.49c.39.32.65.7.79 1.12l1.89-.8c-.24-.71-.71-1.35-1.4-1.92-.5-.4-1.12-.65-1.85-.77V3h-2v2.11c-.41.08-.79.21-1.14.39-.35.18-.64.39-.9.63l1.43 1.43c.04-.04.09-.09.14-.13zM2.81 2.81L1.39 4.22l12.35 12.35c-.43.28-.95.43-1.55.43-.71 0-1.32-.23-1.83-.7-.5-.47-.86-1.07-1.06-1.81l-1.98.8c.34 1.17.95 2.08 1.83 2.73.57.42 1.19.68 1.85.83V21h2v-2.08c.44-.07.87-.17 1.29-.35.34-.14.64-.32.92-.53l4.57 4.57 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdMoneyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
                }
            }
        ]
    })(props);
}
function MdMoveDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11c0 2.45 1.76 4.47 4.08 4.91l-1.49-1.49L7 13l4 4.01L7 21l-1.41-1.41 1.58-1.58v-.06A7.007 7.007 0 011 11c0-3.87 3.13-7 7-7h3v2H8c-2.76 0-5 2.24-5 5zM22 11V4h-9v7h9zm-2-2h-5V6h5v3zM13 13h9v7h-9z"
                }
            }
        ]
    })(props);
}
function MdMoveUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13c0-2.45 1.76-4.47 4.08-4.91l-1.49 1.5L7 11l4-4.01L7 3 5.59 4.41l1.58 1.58v.06A7.007 7.007 0 001 13c0 3.87 3.13 7 7 7h3v-2H8c-2.76 0-5-2.24-5-5zM13 13v7h9v-7h-9zm7 5h-5v-3h5v3zM13 4h9v7h-9z"
                }
            }
        ]
    })(props);
}
function MdMultilineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
                }
            }
        ]
    })(props);
}
function MdNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h12v-2H3v2zM3 6v2h18V6H3zm0 7h18v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdNumbers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10l.5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4zm-7 4h-4l1-4h4l-1 4z"
                }
            }
        ]
    })(props);
}
function MdPadding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14zM11 7h2v2h-2zM7 7h2v2H7zm8 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdPentagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9l4 12h12l4-12-10-7z"
                }
            }
        ]
    })(props);
}
function MdPieChartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function MdPieChartOutlined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function MdPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
                }
            }
        ]
    })(props);
}
function MdPolyline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16v1.26l-6-3v-3.17L11.7 8H16V2h-6v4.9L7.3 10H3v6h5l7 3.5V22h6v-6z"
                }
            }
        ]
    })(props);
}
function MdPostAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
                }
            }
        ]
    })(props);
}
function MdPublish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function MdQueryStats(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58l-3.12-3.11zm-3.8.11a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6l2.72 4.08zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18l-4.69 7.4z"
                }
            }
        ]
    })(props);
}
function MdRectangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h20v16H2z"
                }
            }
        ]
    })(props);
}
function MdScatterPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "14",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6",
                    "r": "3"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.6",
                    "cy": "17.6",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function MdSchema(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9v2h-3V9H8.5V7H11V1H4v6h2.5v2H4v6h2.5v2H4v6h7v-6H8.5v-2H11v-2h3v2h7V9h-7z"
                }
            }
        ]
    })(props);
}
function MdScore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 2h1.5v3l2-3h1.7l-2 3 2 3h-1.7l-2-3v3H12V5zM7 7.25h2.5V6.5H7V5h4v3.75H8.5v.75H11V11H7V7.25zM19 13l-6 6-4-4-4 4v-2.5l4-4 4 4 6-6V13z"
                }
            }
        ]
    })(props);
}
function MdShapeLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11c2.76 0 5-2.24 5-5S8.76 1 6 1 1 3.24 1 6s2.24 5 5 5zM21 14h-5c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.7c.4.19.83.3 1.29.3 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .46.11.89.3 1.29L6.29 16.3c-.4-.19-.83-.3-1.29-.3-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.46-.11-.89-.3-1.29L17.71 7.7z"
                }
            }
        ]
    })(props);
}
function MdShortText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
                }
            }
        ]
    })(props);
}
function MdShowChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
                }
            }
        ]
    })(props);
}
function MdSpaceBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v4H6V9H4v6h16V9z"
                }
            }
        ]
    })(props);
}
function MdSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v18H3z"
                }
            }
        ]
    })(props);
}
function MdStackedLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19.99l7.5-7.51 4 4 7.09-7.97L22 9.92l-8.5 9.56-4-4-6 6.01-1.5-1.5zm1.5-4.5l6-6.01 4 4L22 3.92l-1.41-1.41-7.09 7.97-4-4L2 13.99l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdStrikethroughS(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.85 7.08C6.85 4.37 9.45 3 12.24 3c1.64 0 3 .49 3.9 1.28.77.65 1.46 1.73 1.46 3.24h-3.01c0-.31-.05-.59-.15-.85-.29-.86-1.2-1.28-2.25-1.28-1.86 0-2.34 1.02-2.34 1.7 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.21-.34-.54-.89-.54-1.92zM21 12v-2H3v2h9.62c1.15.45 1.96.75 1.96 1.97 0 1-.81 1.67-2.28 1.67-1.54 0-2.93-.54-2.93-2.51H6.4c0 .55.08 1.13.24 1.58.81 2.29 3.29 3.3 5.67 3.3 2.27 0 5.3-.89 5.3-4.05 0-.3-.01-1.16-.48-1.94H21V12z"
                }
            }
        ]
    })(props);
}
function MdSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18h-2v1h3v1h-4v-2c0-.55.45-1 1-1h2v-1h-3v-1h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 18h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 4h-2.68l-3.07 4.99h-.12L8.85 4H6.19l4.32 6.73L5.88 18z"
                }
            }
        ]
    })(props);
}
function MdSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-2v1h3v1h-4V7c0-.55.45-1 1-1h2V5h-3V4h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 20h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 6h-2.68l-3.07 4.99h-.12L8.85 6H6.19l4.32 6.73L5.88 20z"
                }
            }
        ]
    })(props);
}
function MdTableChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10.02h5V21h-5zM17 21h3c1.1 0 2-.9 2-2v-9h-5v11zm3-18H5c-1.1 0-2 .9-2 2v3h19V5c0-1.1-.9-2-2-2zM3 19c0 1.1.9 2 2 2h3V10H3v9z"
                }
            }
        ]
    })(props);
}
function MdTableRows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8H3V4h18v4zm0 2H3v4h18v-4zm0 6H3v4h18v-4z"
                }
            }
        ]
    })(props);
}
function MdTextDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM23 11v2h-8v-2h8z"
                }
            }
        ]
    })(props);
}
function MdTextFields(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
                }
            }
        ]
    })(props);
}
function MdTextIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM20 11h3v2h-3v3h-2v-3h-3v-2h3V8h2v3z"
                }
            }
        ]
    })(props);
}
function MdTitle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h5.5v12h3V7H19V4z"
                }
            }
        ]
    })(props);
}
function MdTypeSpecimen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3.37 12.5l-.8-2.3H12.2l-.82 2.3H9.81l3.38-9h1.61l3.38 9h-1.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.96 7.17l-1.31 3.72h2.69l-1.3-3.72z"
                }
            }
        ]
    })(props);
}
function MdVerticalAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function MdVerticalAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function MdVerticalAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function MdVerticalDistribute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 10.5v3h10v-3H7zM2 20v2h20v-2H2z"
                }
            }
        ]
    })(props);
}
function MdWrapText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdApproval(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2zm14 2H6v-2h12v2zM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5zm0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3l-3 4z"
                }
            }
        ]
    })(props);
}
function MdAttachEmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10V4c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2L1 16c0 1.1.9 2 2 2h11v-5c0-1.66 1.34-3 3-3h4zm-10 1L3 6V4l8 5 8-5v2l-8 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-.28.22-.5.5-.5s.5.22.5.5V18h2v-4.5a2.5 2.5 0 00-5 0V18c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2z"
                }
            }
        ]
    })(props);
}
function MdAttachment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5a2.5 2.5 0 010-5H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
                }
            }
        ]
    })(props);
}
function MdCloudCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01A3.98 3.98 0 0112 7c2.21 0 4 1.79 4 4h.5a2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdCloudDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
                }
            }
        ]
    })(props);
}
function MdCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
                }
            }
        ]
    })(props);
}
function MdCloudOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46a5.497 5.497 0 018.05 4.87v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
                }
            }
        ]
    })(props);
}
function MdCloudQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdCloudSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 14.98c-.02 0-.03 0-.05.01A3.49 3.49 0 0018 12c-1.4 0-2.6.83-3.16 2.02A2.988 2.988 0 0012 17c0 1.66 1.34 3 3 3l6.5-.02a2.5 2.5 0 000-5zM10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 6h-2.73a7.98 7.98 0 012.66 5h-2.02c-.23-1.36-.93-2.55-1.91-3.44V10h-2V4h6v2z"
                }
            }
        ]
    })(props);
}
function MdCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
                }
            }
        ]
    })(props);
}
function MdCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
                }
            }
        ]
    })(props);
}
function MdCreateNewFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdDifference(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 23H4c-1.1 0-2-.9-2-2V7h2v14h14v2zM15 1H8c-1.1 0-1.99.9-1.99 2L6 17c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V7l-6-6zm1.5 14h-6v-2h6v2zm0-6h-2v2h-2V9h-2V7h2V5h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdDownloadDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.13 5.41L18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66zM5 18h14v2H5z"
                }
            }
        ]
    })(props);
}
function MdDownloadForOffline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm-1 8V6h2v4h3l-4 4-4-4h3zm6 7H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
                }
            }
        ]
    })(props);
}
function MdDownloading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 4.26A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zm-1.62 5.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zM13 12V7h-2v5H7l5 5 5-5h-4zm-2 7.93v2.02c-5.05-.5-9-4.76-9-9.95s3.95-9.45 9-9.95v2.02C7.05 4.56 4 7.92 4 12s3.05 7.44 7 7.93z"
                }
            }
        ]
    })(props);
}
function MdDriveFileMoveOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zm-8.01-9l-1.41 1.41L12.16 12H8v2h4.16l-1.59 1.59L11.99 17 16 13.01 11.99 9z"
                }
            }
        ]
    })(props);
}
function MdDriveFileMoveRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-8 11l-4-4 4-4v3h4v2h-4v3z"
                }
            }
        ]
    })(props);
}
function MdDriveFileMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 12v-3h-4v-4h4V8l5 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdDriveFileRenameOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.41 5.8L17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83zM6.21 18H5v-1.21l8.66-8.66 1.21 1.21L6.21 18zM11 20l4-4h6v4H11z"
                }
            }
        ]
    })(props);
}
function MdDriveFolderUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10zM8 13.01l1.41 1.41L11 12.84V17h2v-4.16l1.59 1.59L16 13.01 12.01 9 8 13.01z"
                }
            }
        ]
    })(props);
}
function MdFileDownloadDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5v-2zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3z"
                }
            }
        ]
    })(props);
}
function MdFileDownloadOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.17V3h6v6h4l-3.59 3.59L9 6.17zm12.19 15.02L2.81 2.81 1.39 4.22 6.17 9H5l7 7 .59-.59L15.17 18H5v2h12.17l2.61 2.61 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdFileDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function MdFileOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H15v-8h5V8l-6-6zm-1 7V3.5L18.5 9H13zm4 12.66V16h5.66v2h-2.24l2.95 2.95-1.41 1.41L19 19.41v2.24h-2z"
                }
            }
        ]
    })(props);
}
function MdFileUploadOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l4.7 4.69L5 10h2.17L9 11.83V16h4.17l2 2H5v2h12.17l2.61 2.61zM15 10h4l-7-7-3.09 3.09L15 12.17z"
                }
            }
        ]
    })(props);
}
function MdFileUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
                }
            }
        ]
    })(props);
}
function MdFolderCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6H1v13c0 1.1.9 2 2 2h17v-2H3V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4h-7l-2-2H7c-1.1 0-1.99.9-1.99 2L5 15c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdFolderDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2h8c1.1 0 2 .9 2 2zm-5.5 2V9h-2v1H12v1.5h1v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4h1V10h-2.5zm0 5.5h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdFolderOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H6.83l14.93 14.93c.15-.28.24-.59.24-.93V8c0-1.1-.9-2-2-2zM2.1 2.1L.69 3.51l1.56 1.56c-.15.28-.24.59-.24.93L2 18c0 1.1.9 2 2 2h13.17l3.31 3.31 1.41-1.41L2.1 2.1z"
                }
            }
        ]
    })(props);
}
function MdFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
                }
            }
        ]
    })(props);
}
function MdFolderShared(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
                }
            }
        ]
    })(props);
}
function MdFolderZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2 6h-2v2h2v2h-2v2h-2v-2h2v-2h-2v-2h2v-2h-2V8h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
                }
            }
        ]
    })(props);
}
function MdFormatOverline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3v2H5V3h14zm-7 4c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 11.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 9.5 12 9.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function MdGridView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "fill": "none",
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function MdNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3l-1.67 1.67L18.67 3 17 4.67 15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3 7 4.67 5.33 3 3.67 4.67 2 3v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V3zM11 19H4v-6h7v6zm9 0h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4H4V8h16v3z"
                }
            }
        ]
    })(props);
}
function MdRequestQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm1 10h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V9h2v1h2v2zm-2-4V3.5L17.5 8H13z"
                }
            }
        ]
    })(props);
}
function MdRuleFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM7.83 16L5 13.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L7.83 16zm9.58-3L19 14.59 17.59 16 16 14.41 14.41 16 13 14.59 14.59 13 13 11.41 14.41 10 16 11.59 17.59 10 19 11.41 17.41 13z"
                }
            }
        ]
    })(props);
}
function MdSnippetFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.88 10.5l1.62 1.62v3.38h-3v-5h1.38zM22 8v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h6l2 2h8c1.1 0 2 .9 2 2zm-3 3.5L16.5 9H13v8h6v-5.5z"
                }
            }
        ]
    })(props);
}
function MdTextSnippet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.41 8.41l-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42zM7 7h7v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdTopic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6 10H6v-2h8v2zm4-4H6v-2h12v2z"
                }
            }
        ]
    })(props);
}
function MdUploadFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z"
                }
            }
        ]
    })(props);
}
function MdUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20h14v-2H5v2zm0-10h4v6h6v-6h4l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function MdWorkspacesFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdWorkspacesOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdWorkspaces(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-10C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdAdfScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-1V4H6v8H5c-1.66 0-3 1.34-3 3v5h20v-5c0-1.66-1.34-3-3-3zm-3 0H8V6h8v6zm2 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdBrowserNotSupported(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v10.5l1.95 1.95c.03-.15.05-.3.05-.45V6c0-1.1-.9-2-2-2H6.5l2 2H19zM3.22 3.32L1.95 4.59 3 5.64V18c0 1.1.9 2 2 2h12.36l2.06 2.06 1.27-1.27L3.22 3.32zM15 18H5V7.64L15.36 18H15z"
                }
            }
        ]
    })(props);
}
function MdBrowserUpdated(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13v3c0 1.1-.9 2-2 2h-3l1 1v2H6v-2l1-1H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8v2H4v11h16v-3h2zm-7 2l-5-5h4V3h2v7h4l-5 5z"
                }
            }
        ]
    })(props);
}
function MdCastConnected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdCastForEducation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdCast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function MdComputer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function MdConnectedTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zM4 14v2h2c0-1.11-.89-2-2-2zm0-3v1.43c1.97 0 3.57 1.6 3.57 3.57H9c0-2.76-2.24-5-5-5zm0-3v1.45c3.61 0 6.55 2.93 6.55 6.55H12c0-4.42-3.59-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdConveyorBelt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15H5c-1.66 0-3 1.34-3 3s1.34 3 3 3h14c1.66 0 3-1.34 3-3s-1.34-3-3-3zm0 4H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1zM9 4v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1zm7 4h-4V6.02h4V8zM2 9.02h4.94v1.91H2V9.02zm2.01-3h2.93v1.96H4.01V6.02z"
                }
            }
        ]
    })(props);
}
function MdDesktopMac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h6l-2 2v1h8v-1l-2-2h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
                }
            }
        ]
    })(props);
}
function MdDesktopWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6v2H8v2h8v-2h-2v-2h6c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
                }
            }
        ]
    })(props);
}
function MdDeveloperBoardOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.83 5H18v10.17L19.83 17H22v-2h-2v-2h2v-2h-2V9h2V7h-2V5c0-1.1-.9-2-2-2H5.83l2 2zM12 9.17V7h4v3h-3.17L12 9.17zM9.83 7H11v1.17L9.83 7zm4 4H16v2.17L13.83 11zM18 21c.06 0 .11 0 .16-.01l2.32 2.32 1.41-1.41L2.1 2.1.69 3.51l1.32 1.32C2 4.89 2 4.94 2 5v14c0 1.1.9 2 2 2h14zM4 19V6.83l2 2V12h3.17l1 1H6v4h5v-3.17l1 1V17h2.17l2 2H4z"
                }
            }
        ]
    })(props);
}
function MdDeveloperBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function MdDeviceHub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
                }
            }
        ]
    })(props);
}
function MdDeviceUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zm-.88 8.8h1.76v1.76h-1.76z"
                }
            }
        ]
    })(props);
}
function MdDevicesOther(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
                }
            }
        ]
    })(props);
}
function MdDock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
                }
            }
        ]
    })(props);
}
function MdEarbudsBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM10.62 6C8.76 6 7.25 7.51 7.25 9.38v5.25c0 1.04-.84 1.88-1.88 1.88s-1.87-.85-1.87-1.89v-4.7c.16.05.33.08.5.08 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v6.62C2 16.49 3.51 18 5.38 18s3.38-1.51 3.38-3.38V9.38c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88v4.7c-.18-.05-.35-.08-.52-.08-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2V9.38C14 7.51 12.49 6 10.62 6z"
                }
            }
        ]
    })(props);
}
function MdEarbuds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.2 3.01C4.44 2.89 3 4.42 3 6.19V16c0 2.76 2.24 5 5 5s5-2.24 5-5V8c0-1.66 1.34-3 3-3s3 1.34 3 3v7h-.83c-1.61 0-3.06 1.18-3.17 2.79A3 3 0 0017.8 21c1.76.12 3.2-1.42 3.2-3.18V8c0-2.76-2.24-5-5-5s-5 2.24-5 5v8c0 1.66-1.34 3-3 3s-3-1.34-3-3V9h.83C7.44 9 8.89 7.82 9 6.21c.11-1.68-1.17-3.1-2.8-3.2z"
                }
            }
        ]
    })(props);
}
function MdForklift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 17v2h-5V3h2v14h3zm-6.27-1.85c.17.42.27.87.27 1.35 0 1.93-1.57 3.5-3.5 3.5-1.4 0-2.6-.82-3.16-2H6.83A2.99 2.99 0 014 20c-1.66 0-3-1.34-3-3 0-.89.39-1.69 1-2.24V10h2V4h8l4.73 11.15zM5 17c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm8.65-4l-2.97-7H6v4l2.92 3h4.73zM15 16.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdFrontLoader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6.5l-1.91 1.91c-.38.38-.59.89-.59 1.42V11h-1V7c0-1.66-1.34-3-3-3H8v5H3c-1.1 0-2 .9-2 2v5.85c0 1.58 1.16 3.01 2.74 3.14a2.99 2.99 0 003.07-1.98l4.37-.01a2.979 2.979 0 003.41 1.94 3.013 3.013 0 002.35-2.39c.2-1.11-.22-2.11-.95-2.77V13h1c0 1.1.9 2 2 2h5L19.5 6.5zM4 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6-12h3c.55 0 1 .45 1 1v4h-4V6zm4 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdGamepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
                }
            }
        ]
    })(props);
}
function MdHeadphonesBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zM8 6c-3.31 0-6 2.69-6 6v4c0 1.1.9 2 2 2h2v-5H3.5v-1c0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5v1H10v5h2c1.1 0 2-.9 2-2v-4c0-3.31-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 00-9 9v7c0 1.1.9 2 2 2h4v-8H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-4v8h4c1.1 0 2-.9 2-2v-7a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function MdHeadsetMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function MdHeadsetOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c3.87 0 7 3.13 7 7v2h-2.92L21 17.92V11a9 9 0 00-9-9c-1.95 0-3.76.62-5.23 1.68l1.44 1.44A6.914 6.914 0 0112 4zM2.27 1.72L1 3l3.33 3.32A8.899 8.899 0 003 11v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-1.17.29-2.26.79-3.22L15 17v4h3c.3 0 .59-.06.86-.14L21 23l1.27-1.27-20-20.01z"
                }
            }
        ]
    })(props);
}
function MdHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function MdHomeMax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5C2.79 5 1 6.79 1 9v5c0 2.21 1.79 4 4 4h2v1h10v-1h2c2.21 0 4-1.79 4-4V9c0-2.21-1.79-4-4-4zm2 9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v5z"
                }
            }
        ]
    })(props);
}
function MdHomeMini(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C4.19 5 2 9.48 2 12c0 3.86 3.13 7 6.99 7h6.02C17.7 19 22 16.92 22 12c0 0 0-7-10-7zm0 2c7.64 0 7.99 4.51 8 5H4c0-.2.09-5 8-5zm2.86 10H9.14c-2.1 0-3.92-1.24-4.71-3h15.15c-.8 1.76-2.62 3-4.72 3z"
                }
            }
        ]
    })(props);
}
function MdKeyboardAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 12v2H5v-2h2zm-2-2V8h2v2H5zm6 2v2H9v-2h2zm-2-2V8h2v2H9zm7 6v1H8v-1h8zm-1-4v2h-2v-2h2zm-2-2V8h2v2h-2zm4 4v-2h2v2h-2zm2-4h-2V8h2v2z"
                }
            }
        ]
    })(props);
}
function MdKeyboardArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdKeyboardArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdKeyboardArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdKeyboardArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
                }
            }
        ]
    })(props);
}
function MdKeyboardBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
                }
            }
        ]
    })(props);
}
function MdKeyboardCapslock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function MdKeyboardCommandKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 3C15.57 3 14 4.57 14 6.5V8h-4V6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10H8v4H6.5C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5V16h4v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5H16v-4h1.5c1.93 0 3.5-1.57 3.5-3.5S19.43 3 17.5 3zM16 8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S18.33 8 17.5 8H16zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5V8H6.5zm3.5 6v-4h4v4h-4zm7.5 5c-.83 0-1.5-.67-1.5-1.5V16h1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm-11 0c-.83 0-1.5-.67-1.5-1.5S5.67 16 6.5 16H8v1.5c0 .83-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdKeyboardControlKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12l1.41 1.41L12 7.83l5.59 5.58L19 12l-7-7z"
                }
            }
        ]
    })(props);
}
function MdKeyboardDoubleArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.41L16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
                }
            }
        ]
    })(props);
}
function MdKeyboardDoubleArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.59 18L19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18l1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
                }
            }
        ]
    })(props);
}
function MdKeyboardDoubleArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 6L5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6l-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
                }
            }
        ]
    })(props);
}
function MdKeyboardDoubleArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"
                }
            }
        ]
    })(props);
}
function MdKeyboardHide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
                }
            }
        ]
    })(props);
}
function MdKeyboardOptionKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z"
                }
            }
        ]
    })(props);
}
function MdKeyboardReturn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
                }
            }
        ]
    })(props);
}
function MdKeyboardTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
                }
            }
        ]
    })(props);
}
function MdKeyboardVoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function MdKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function MdLaptopChromebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
                }
            }
        ]
    })(props);
}
function MdLaptopMac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdLaptopWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
                }
            }
        ]
    })(props);
}
function MdLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function MdMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
                }
            }
        ]
    })(props);
}
function MdMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"
                }
            }
        ]
    })(props);
}
function MdMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
                }
            }
        ]
    })(props);
}
function MdPallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 18v4h3v-2h5.5v2h3v-2H19v2h3v-4zM18 2H6c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm-3 6H9V6h6v2z"
                }
            }
        ]
    })(props);
}
function MdPhoneAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
                }
            }
        ]
    })(props);
}
function MdPhoneIphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 1h-8A2.5 2.5 0 005 3.5v17A2.5 2.5 0 007.5 23h8a2.5 2.5 0 002.5-2.5v-17A2.5 2.5 0 0015.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
                }
            }
        ]
    })(props);
}
function MdPhonelinkOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdPhonelink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function MdPointOfSale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 4H7V4h10v2zm3 16H4c-1.1 0-2-.9-2-2v-1h20v1c0 1.1-.9 2-2 2zm-1.47-11.81A2.008 2.008 0 0016.7 9H7.3c-.79 0-1.51.47-1.83 1.19L2 18h20l-3.47-7.81zM9.5 16h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5z"
                }
            }
        ]
    })(props);
}
function MdPowerInput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
                }
            }
        ]
    })(props);
}
function MdRouter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdSecurity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                }
            }
        ]
    })(props);
}
function MdSimCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdSmartDisplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.5 16.5v-9l7 4.5-7 4.5z"
                }
            }
        ]
    })(props);
}
function MdSmartScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-3 12H6V7h12v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.25h1.5v1.5H15zM12.5 11.25H14v1.5h-1.5zM10 11.25h1.5v1.5H10zM7.5 11.25H9v1.5H7.5z"
                }
            }
        ]
    })(props);
}
function MdSmartToy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zM7.5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5zM16 17H8v-2h8v2zm-1-4c-.83 0-1.5-.67-1.5-1.5S14.17 10 15 10s1.5.67 1.5 1.5S15.83 13 15 13z"
                }
            }
        ]
    })(props);
}
function MdSmartphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdSpeakerGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "12.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H4v16a2 2 0 002 2h10v-2H6V5z"
                }
            }
        ]
    })(props);
}
function MdSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2a2 2 0 110-4zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 7.41L18.17 11H6v2h12.17l-3.59 3.59L16 18l6-6-6-6-1.41 1.41zM2 6v12h2V6H2z"
                }
            }
        ]
    })(props);
}
function MdTabletAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
                }
            }
        ]
    })(props);
}
function MdTabletMac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 0h-14A2.5 2.5 0 002 2.5v19A2.5 2.5 0 004.5 24h14a2.5 2.5 0 002.5-2.5v-19A2.5 2.5 0 0018.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
                }
            }
        ]
    })(props);
}
function MdTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function MdToys(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14c0-1.95-1.4-3.57-3.25-3.92L17.4 6.05A2.978 2.978 0 0014.56 4H9.44C8.15 4 7 4.82 6.6 6.05L5.81 8.4 4.41 7l.29-.29A.996.996 0 103.29 5.3l-2 2A.996.996 0 102.7 8.71l.3-.3 1.79 1.79C3.18 10.72 2 12.22 2 14c0 1.5.83 2.79 2.05 3.48A3 3 0 007 20c1.3 0 2.4-.84 2.82-2h4.37c.41 1.16 1.51 2 2.82 2a3 3 0 002.95-2.52C21.17 16.79 22 15.5 22 14zM7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4-8H7.41l-.02-.02 1.1-3.3A1 1 0 019.44 6H11v4zm2-4h1.56a1 1 0 01.95.68l1.1 3.32H13V6zm4 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdTrolley(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v2H4V4H2V2h4v12h15zM5.99 17C4.89 17 4 17.9 4 19s.89 2 1.99 2C7.1 21 8 20.1 8 19s-.9-2-2.01-2zm13 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2S21 20.1 21 19s-.9-2-2.01-2zM13 13H7V7h6v6zm7 0h-6V7h6v6z"
                }
            }
        ]
    })(props);
}
function MdTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function MdVideogameAssetOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3.3 6.13C2.54 6.41 2 7.15 2 8v8c0 1.1.9 2 2 2h11.17l4.61 4.61 1.41-1.42zM9 13v2H7v-2H5v-2h2V9.83L10.17 13H9zm11.7 4.87c.76-.28 1.3-1.02 1.3-1.87V8c0-1.1-.9-2-2-2H8.83L20.7 17.87zM17.5 9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdVideogameAsset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0v24h24V0H0zm23 16c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdWatchOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5 0 .64-.13 1.25-.35 1.82l1.5 1.5a6.963 6.963 0 00-1.79-8.79L15 2H9l-.96 3.21 2.14 2.14C10.75 7.13 11.36 7 12 7zM2.81 2.81L1.39 4.22l4.46 4.46a6.963 6.963 0 001.79 8.79L9 22h6l.96-3.21 3.82 3.82 1.41-1.41L2.81 2.81zM12 17c-2.76 0-5-2.24-5-5 0-.64.13-1.25.35-1.82l6.47 6.47c-.57.22-1.18.35-1.82.35z"
                }
            }
        ]
    })(props);
}
function MdWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z",
                    "opacity": ".1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73A7.976 7.976 0 0020 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
                }
            }
        ]
    })(props);
}
function MdAutoMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.03 3.56c-1.67-1.39-3.74-2.3-6.03-2.51v2.01c1.73.19 3.31.88 4.61 1.92l1.42-1.42zM11 3.06V1.05c-2.29.2-4.36 1.12-6.03 2.51l1.42 1.42A8.928 8.928 0 0111 3.06zM4.98 6.39L3.56 4.97C2.17 6.64 1.26 8.71 1.05 11h2.01c.19-1.73.88-3.31 1.92-4.61zM20.94 11h2.01c-.21-2.29-1.12-4.36-2.51-6.03l-1.42 1.42A8.928 8.928 0 0120.94 11zM7 12l3.44 1.56L12 17l1.56-3.44L17 12l-3.44-1.56L12 7l-1.56 3.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21a8.96 8.96 0 01-7.46-4H7v-2H1v6h2v-2.7c1.99 2.84 5.27 4.7 9 4.7 4.87 0 9-3.17 10.44-7.56l-1.96-.45C19.25 18.48 15.92 21 12 21z"
                }
            }
        ]
    })(props);
}
function MdBlindsClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h11.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zm-2-8h-2V9h2v2zm-4 0H6V9h8v2zm0 2v2H6v-2h8zm2 0h2v2h-2v-2zm2-6h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-2h8v2H6zm10 0v-2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdBlinds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM16 9h2v2h-2V9zm-2 2H6V9h8v2zm4-4h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-6h8v1.82A1.746 1.746 0 0015 18a1.746 1.746 0 001-3.18V13h2v6H6z"
                }
            }
        ]
    })(props);
}
function MdBroadcastOnHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4v2h16v2.59c.73.29 1.4.69 2 1.17V6zM8 9H3c-.5 0-1 .5-1 1v9c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-9c0-.5-.5-1-1-1zm-1 9H4v-7h3v7zM17.75 16.97c.3-.23.5-.57.5-.97a1.25 1.25 0 00-2.5 0c0 .4.2.75.5.97V22h1.5v-5.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13.5a2.5 2.5 0 012.5 2.5c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 0117 13.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function MdBroadcastOnPersonal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8c.7 0 1.38.1 2.02.27L12 3 4 9v12h6.76A7.998 7.998 0 0117 8zM17 14.75c-.69 0-1.25.56-1.25 1.25 0 .4.2.75.5.97V22h1.5v-5.03c.3-.23.5-.57.5-.97 0-.69-.56-1.25-1.25-1.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.21 0-4 1.79-4 4 0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 1119.5 16c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function MdCloudySnowing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm12 0c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm-9 4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm3-4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm3 4c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm3.5-6h-10A5.51 5.51 0 012 10.5c0-2.76 2.09-5.09 4.78-5.44A5.975 5.975 0 0112 2c2.97 0 5.45 2.18 5.92 5.02A4.5 4.5 0 0122 11.5c0 2.48-2.02 4.5-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function MdCurtainsClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM11 5h2v14h-2V5z"
                }
            }
        ]
    })(props);
}
function MdCurtains(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM8.19 12c2.04-1.35 3.5-3.94 3.76-7h.09c.26 3.06 1.72 5.65 3.76 7-2.04 1.35-3.5 3.94-3.76 7h-.09c-.26-3.06-1.72-5.65-3.76-7z"
                }
            }
        ]
    })(props);
}
function MdElectricBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.69 2.21L4.33 11.49c-.64.58-.28 1.65.58 1.73L13 14l-4.85 6.76c-.22.31-.19.74.08 1.01.3.3.77.31 1.08.02l10.36-9.28c.64-.58.28-1.65-.58-1.73L11 10l4.85-6.76c.22-.31.19-.74-.08-1.01a.77.77 0 00-1.08-.02z"
                }
            }
        ]
    })(props);
}
function MdElectricMeter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.96 0-9 4.04-9 9 0 3.91 2.51 7.24 6 8.47V22h2v-2.06a8.262 8.262 0 002 0V22h2v-2.53c3.49-1.24 6-4.57 6-8.47 0-4.96-4.04-9-9-9zm2.25 12l-3 3-1.5-1.5L11 14.25 9.75 13l3-3 1.5 1.5L13 12.75 14.25 14zM16 9H8V7h8v2z"
                }
            }
        ]
    })(props);
}
function MdEnergySavingsLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.8 0-9 3.86-9 9 0 2.12.74 4.07 1.97 5.61L3 19.59 4.41 21l1.97-1.97A9.012 9.012 0 0012 21c2.3 0 4.61-.88 6.36-2.64A8.95 8.95 0 0021 12V3h-9zm3.83 9.26l-5.16 4.63c-.16.15-.41.14-.56-.01a.397.397 0 01-.04-.52l2.44-3.33-4.05-.4a.514.514 0 01-.3-.89l5.16-4.63c.16-.15.41-.14.56.01.14.14.16.36.04.52l-2.44 3.33 4.05.4c.45.04.63.59.3.89z"
                }
            }
        ]
    })(props);
}
function MdFoggy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5a4.5 4.5 0 00-4.08-4.48zm.08 9.99c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-11 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-1-3h9c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1zm4 3h7c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdGasMeter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-4 14c-1.38 0-2.5-1.1-2.5-2.46 0-1.09.43-1.39 2.5-3.79 2.05 2.38 2.5 2.7 2.5 3.79C14.5 16.9 13.38 18 12 18zm4-8H8V8h8v2z"
                }
            }
        ]
    })(props);
}
function MdHeatPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6.25 4.08c.82.12 1.57.44 2.2.91l-2.2 2.2V7.08zm-1.5 0v3.11l-2.2-2.2c.63-.47 1.38-.79 2.2-.91zM7.99 9.05l2.2 2.2H7.08c.12-.82.44-1.57.91-2.2zm-.91 3.7h3.11l-2.2 2.2c-.47-.63-.79-1.38-.91-2.2zm4.17 4.17c-.82-.12-1.57-.44-2.2-.91l2.2-2.2v3.11zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm.75 3.92v-3.11l2.2 2.2c-.63.47-1.38.79-2.2.91zm3.26-1.97l-2.2-2.2h3.11c-.12.82-.44 1.57-.91 2.2zm-2.2-3.7l2.2-2.2c.47.64.79 1.39.91 2.2h-3.11z"
                }
            }
        ]
    })(props);
}
function MdModeFanOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.34 8.36l-2.29.82c-.18-.13-.38-.25-.58-.34.17-.83.63-1.58 1.36-2.06C16.85 5.44 16.18 2 13.39 2c-3.08 0-4.9 1.47-5.3 3.26L18.73 15.9c1.5.39 3.27-.51 3.27-2.51 0-4.39-3.01-6.23-5.66-5.03zM2.81 2.81L1.39 4.22 5.27 8.1C3.77 7.7 2 8.61 2 10.61c0 4.4 3.01 6.24 5.66 5.03l2.29-.82c.18.13.38.25.58.34-.17.83-.63 1.58-1.36 2.06C7.15 18.56 7.82 22 10.61 22c3.08 0 4.9-1.47 5.3-3.26l3.87 3.87 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdNestCamWiredStand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.83 1.01l-4.11.42C8.47 1.75 6 4.48 6 7.75s2.47 6 5.72 6.33l1.9.19-.56.85c-.35-.08-.7-.12-1.06-.12-2.76 0-5 2.24-5 5v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2c0-1.67-.83-3.15-2.09-4.06l.97-1.45c1.14.07 2.12-.83 2.12-1.99V3c0-1.17-1-2.09-2.17-1.99z"
                }
            }
        ]
    })(props);
}
function MdOilBarrel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-1v-6h1zm-8 3c-1.66 0-3-1.32-3-2.95 0-1.3.52-1.67 3-4.55 2.47 2.86 3 3.24 3 4.55 0 1.63-1.34 2.95-3 2.95z"
                }
            }
        ]
    })(props);
}
function MdPropaneTank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15v3c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-3H4zM20 13v-3c0-1.86-1.28-3.41-3-3.86V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v3h16zM9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9V4z"
                }
            }
        ]
    })(props);
}
function MdPropane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm-7-1h4v1h-4V5z"
                }
            }
        ]
    })(props);
}
function MdRollerShadesClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h8.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zM6 19v-2h5v2H6zm7 0v-2h5v2h-5z"
                }
            }
        ]
    })(props);
}
function MdRollerShades(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM6 19v-6h5v1.8c-.4.3-.8.8-.8 1.4 0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8c0-.6-.3-1.1-.8-1.4V13h5v6H6z"
                }
            }
        ]
    })(props);
}
function MdSensorDoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v18h16V4c0-1.1-.9-2-2-2zm-2.5 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdSensorOccupied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM12 12c-1.84 0-3.56.5-5.03 1.37-.61.35-.97 1.02-.97 1.72V17h12v-1.91c0-.7-.36-1.36-.97-1.72A9.844 9.844 0 0012 12zM21.23 8.15l1.85-.77A12.056 12.056 0 0016.62.92l-.77 1.85c2.42 1.02 4.36 2.96 5.38 5.38zM8.15 2.77L7.38.92A12.089 12.089 0 00.92 7.38l1.85.77c1.02-2.42 2.96-4.36 5.38-5.38zM2.77 15.85l-1.85.77c1.22 2.91 3.55 5.25 6.46 6.46l.77-1.85a10.117 10.117 0 01-5.38-5.38zM15.85 21.23l.77 1.85c2.91-1.22 5.25-3.55 6.46-6.46l-1.85-.77a10.117 10.117 0 01-5.38 5.38z"
                }
            }
        ]
    })(props);
}
function MdSensorWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v16H6V4h12m0-2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 19h10v-6H7v6zm3-9h4v1h3V5H7v6h3v-1z"
                }
            }
        ]
    })(props);
}
function MdShelves(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1v2H5V1H3v22h2v-2h14v2h2V1h-2zm0 4v6h-6V7H7v4H5V5h14zm-2 14v-4h-6v4H5v-6h14v6h-2z"
                }
            }
        ]
    })(props);
}
function MdShieldMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm3.97 12.41c-1.84 2.17-5.21 2.1-6.96-.07-2.19-2.72-.65-6.72 2.69-7.33.34-.06.63.27.51.6-.46 1.23-.39 2.64.32 3.86a4.51 4.51 0 003.18 2.2c.34.05.49.47.26.74z"
                }
            }
        ]
    })(props);
}
function MdSnowing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM4.75 6a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm12 8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm-9 12a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3 12a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm0-8a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z"
                }
            }
        ]
    })(props);
}
function MdSolarPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.33 16H11v-3H4zM13 16h7.67L20 13h-7zM21.11 18H13v4h9zM2 22h9v-4H2.89zM11 8h2v3h-2zM15.764 7.205l1.415-1.414L19.3 7.912l-1.414 1.414zM4.705 7.913L6.826 5.79 8.24 7.206 6.12 9.327zM3 2h3v2H3zM18 2h3v2h-3zM12 7c2.76 0 5-2.24 5-5H7c0 2.76 2.24 5 5 5z"
                }
            }
        ]
    })(props);
}
function MdSunnySnowing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5h-2V1h2v4zM1 11h4v2H1v-2zm18 2v-2h4v2h-4zm-1.34-5.24l-1.41-1.41 2.83-2.83 1.41 1.41-2.83 2.83zM3.51 4.93l1.41-1.41 2.83 2.83-1.41 1.41-2.83-2.83zM4.75 17a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm12 0a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm-9 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3-4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm3 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zM17 13v-1c0-2.76-2.24-5-5-5s-5 2.24-5 5v1h10z"
                }
            }
        ]
    })(props);
}
function MdSunny(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4V2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1s-1-.45-1-1zm7.36 3.05l1.41-1.42a.996.996 0 10-1.41-1.41l-1.41 1.42a.996.996 0 101.41 1.41zM22 11h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1zm-10 8c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1zM5.64 7.05L4.22 5.64c-.39-.39-.39-1.03 0-1.41s1.03-.39 1.41 0l1.41 1.41c.39.39.39 1.03 0 1.41s-1.02.39-1.4 0zm11.31 9.9a.996.996 0 000 1.41l1.41 1.41c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.41-1.41a.996.996 0 00-1.41 0zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm3.64 6.78l1.41-1.41c.39-.39.39-1.03 0-1.41s-1.03-.39-1.41 0l-1.41 1.41a.996.996 0 000 1.41c.38.39 1.02.39 1.41 0zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdVerticalShadesClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM13 5h1.5v14H13V5zm-2 14H9.5V5H11v14zM6 5h1.5v14H6V5zm10.5 14V5H18v14h-1.5z"
                }
            }
        ]
    })(props);
}
function MdVerticalShades(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zm-10 0V5h4v14h-4z"
                }
            }
        ]
    })(props);
}
function MdWindPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h6v2H4zM1 7h5v2H1zM3 19h5v2H3zM13.73 10.61c.75.23 1.3.78 1.57 1.46l4.27-7.11a2.28 2.28 0 00-3.51-2.84l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.93c.36-.15.98-.33 1.73-.1zM10.61 12.27c.16-.52.48-.96.89-1.27H3.28a2.279 2.279 0 00-.63 4.47l4.51 1.29c.53.15 1.1.08 1.58-.21l2.69-1.61a2.487 2.487 0 01-.82-2.67zM22.21 18.61l-2.28-4.1a2.05 2.05 0 00-1.26-.97l-3.18-.8c.03.32 0 .66-.1.99A2.478 2.478 0 0113 15.5c-.61 0-.99-.22-1-.22V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.89.89 2.33.89 3.22 0 .72-.72.88-1.83.38-2.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 14.43c.79.24 1.63-.2 1.87-1 .24-.79-.2-1.63-1-1.87-.79-.24-1.63.2-1.87 1-.24.79.21 1.63 1 1.87z"
                }
            }
        ]
    })(props);
}
function Md10Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7H15v3h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm6.5 5c0 .55-.45 1-1 1H13c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm-1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md11Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM11 5.5v6H9.5V7H8V5.5h3zm5 0v6h-1.5V7H13V5.5h3zm-.5 8.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md12Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zM15.5 9h-2v1h3v1.5H12V9c0-.55.45-1 1-1h2V7h-3V5.5h3.5c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm0 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md13Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm6.5 5c0 .55-.45 1-1 1H12V10h3V9h-2V8h2V7h-3V5.5h3.5c.55 0 1 .45 1 1v4zm-1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md14Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm7.5 4.5h-1v1.5H15V10h-3V5.5h1.5v3H15v-3h1.5v3h1V10zm-2 4H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md15Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zM16.5 7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H12V10h3V9h-3V5.5h4.5V7zm-1 7H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md16Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 9H15v1.5h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm3 6c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3.5V7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H13zm2.5 2.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md17Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm5 6h-1.75L14.62 7H12V5.5h3.5c.67 0 1.15.65.96 1.29L15 11.5zm.5 2.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md18Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 5.5v6H8.5V7H7V5.5h3zm6.5 5c0 .55-.45 1-1 1H13c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm-3 0H15V9h-1.5v1.5zm0-2.5H15V6.5h-1.5V8zm2 6H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md19Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 7h3V9h-2c-.55 0-1-.45-1-1V6.5c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1H12V10zm1.5-2H15V6.5h-1.5V8zM7 5.5h3v6H8.5V7H7V5.5zm5 13h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm6.5-2.5c0 .55-.45 1-1 1h-2v1.5H14v-6h3.5c.55 0 1 .45 1 1V16zm-3-2H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md20Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 7H16v3h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm2-8c0 .55-.45 1-1 1H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm5.5 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md21Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM11 9H9v1h3v1.5H7.5V9c0-.55.45-1 1-1h2V7h-3V5.5H11c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm3-3.5h3v6h-1.5V7H14V5.5zm1.5 8.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md22Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm6.5 0h-2v1h3v1.5H13V9c0-.55.45-1 1-1h2V7h-3V5.5h3.5c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm-1 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md23Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm7.5 1.5c0 .55-.45 1-1 1H13V10h3V9h-2V8h2V7h-3V5.5h3.5c.55 0 1 .45 1 1v4zm-2 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md24Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM10 9H8v1h3v1.5H6.5V9c0-.55.45-1 1-1h2V7h-3V5.5H10c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm8.5 1h-1v1.5H16V10h-3V5.5h1.5v3H16v-3h1.5v3h1V10zm-3 4H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md2Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-2-9.5h-2v1h3v1.5H10V9c0-.55.45-1 1-1h2V7h-3V5.5h3.5c.55 0 1 .45 1 1V8c0 .55-.45 1-1 1zm2 5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md30FpsSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v2h5v2H5v2h4v2H4v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.17-1.5-1-1.5.83 0 1-.67 1-1.5V6c0-1.1-.9-2-2-2H4zm14 0c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3zm0 2h-3v6h3V6zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function Md3Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-1-8c0 .55-.45 1-1 1H10V10h3V9h-2V8h2V7h-3V5.5h3.5c.55 0 1 .45 1 1v4zm1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md4Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3-8.5h-1v1.5h-1.5V10h-3V5.5H11v3h1.5v-3H14v3h1V10zm.5 8.5H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm0-4.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md5Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zM14.5 7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H10V10h3V9h-3V5.5h4.5V7zm1 7H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md60FpsSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v6h-3V6h3zm0-2h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2V4H6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H6V6h5zm-2 4v2H6v-2h3zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function Md6Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v1.5h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm-1-7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3.5V7h-3v1h2c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1H11zm4.5 7H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm0-4.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md7Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-2.5-7h-1.75L12.62 7H10V5.5h3.5c.67 0 1.15.65.96 1.29L13 11.5zm2.5 2.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md8Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v1.5h-1.5zm0-2.5H13V8h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-1-8c0 .55-.45 1-1 1H11c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function Md9Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6.5H13V8h-1.5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15.5h-1.5V14h-1v3H8v-3H7v4.5H5.5v-5c0-.55.45-1 1-1H11c.55 0 1 .45 1 1v5zm3.5 0H14v-6h3.5c.55 0 1 .45 1 1V16c0 .55-.45 1-1 1h-2v1.5zm-1-8c0 .55-.45 1-1 1H10V10h3V9h-2c-.55 0-1-.45-1-1V6.5c0-.55.45-1 1-1h2.5c.55 0 1 .45 1 1v4zm1 3.5H17v1.5h-1.5z"
                }
            }
        ]
    })(props);
}
function MdAddAPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function MdAddPhotoAlternate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"
                }
            }
        ]
    })(props);
}
function MdAddToPhotos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdAdjust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdAnimation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2c-2.71 0-5.05 1.54-6.22 3.78a7.062 7.062 0 00-3 3A7.014 7.014 0 002 15c0 3.87 3.13 7 7 7 2.71 0 5.05-1.54 6.22-3.78a7.062 7.062 0 003-3A7.014 7.014 0 0022 9c0-3.87-3.13-7-7-7zM9 20a5.002 5.002 0 01-4-8c0 3.87 3.13 7 7 7-.84.63-1.88 1-3 1zm3-3a5.002 5.002 0 01-4-8c0 3.86 3.13 6.99 7 7-.84.63-1.88 1-3 1zm4.7-3.3c-.53.19-1.1.3-1.7.3-2.76 0-5-2.24-5-5 0-.6.11-1.17.3-1.7.53-.19 1.1-.3 1.7-.3 2.76 0 5 2.24 5 5 0 .6-.11 1.17-.3 1.7zM19 12c0-3.86-3.13-6.99-7-7a5.002 5.002 0 017 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            }
        ]
    })(props);
}
function MdAssistantPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
                }
            }
        ]
    })(props);
}
function MdAssistant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
                }
            }
        ]
    })(props);
}
function MdAudiotrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v9.28a4.39 4.39 0 00-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
                }
            }
        ]
    })(props);
}
function MdAutoAwesomeMosaic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 002 2h6V3H5a2 2 0 00-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"
                }
            }
        ]
    })(props);
}
function MdAutoAwesomeMotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H4a2 2 0 00-2 2v10h2V4h10V2zm4 4H8a2 2 0 00-2 2v10h2V8h10V6zm2 4h-8a2 2 0 00-2 2v8a2 2 0 002 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdAutoAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
                }
            }
        ]
    })(props);
}
function MdAutoFixHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 5.6L10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 00-1.41 0L1.29 18.96a.996.996 0 000 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05a.996.996 0 000-1.41l-2.33-2.35zm-1.03 5.49l-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"
                }
            }
        ]
    })(props);
}
function MdAutoFixNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.996.996 0 00-1.41 0L1.29 18.96a.996.996 0 000 1.41l2.34 2.34c.39.39 1.02.39 1.41 0L16.7 11.05a.996.996 0 000-1.41l-2.33-2.35zm-1.03 5.49l-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z"
                }
            }
        ]
    })(props);
}
function MdAutoFixOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 1l-2.5 1.4L18 1l1.4 2.5L18 6l2.5-1.4L23 6l-1.4-2.5L23 1zm-8.34 6.22l2.12 2.12-2.44 2.44.81.81 2.55-2.55a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0L11.4 8.84l.81.81 2.45-2.43zm-.78 6.65l-3.75-3.75-6.86-6.86L2 4.53l6.86 6.86-6.57 6.57a.996.996 0 000 1.41l2.34 2.34c.39.39 1.02.39 1.41 0l6.57-6.57L19.47 22l1.27-1.27-6.86-6.86z"
                }
            }
        ]
    })(props);
}
function MdAutoStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1l-5 5v11l5-4.5V1zM1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5V6c-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6zm22 13.5V6c-.6-.45-1.25-.75-2-1v13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v2c1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5v-1.1z"
                }
            }
        ]
    })(props);
}
function MdAutofpsSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.03 6.3h-.06l-1.02 2.89h2.1zM3 17h2v5H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.63-10h1.25l2.63 7h-1.21l-.63-1.79h-2.83L9.96 12H8.74l2.63-7zM7 17h2v5H7zM11 17h2v5h-2zM15 17h6v5h-6z"
                }
            }
        ]
    })(props);
}
function MdBedtimeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l2.27 2.27A9.959 9.959 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.62 5.51-1.66l2.27 2.27 1.41-1.42zM12.34 2.02c-2.18-.07-4.19.55-5.85 1.64l4.59 4.59c-.27-2.05.1-4.22 1.26-6.23z"
                }
            }
        ]
    })(props);
}
function MdBedtime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.34 2.02C6.59 1.82 2 6.42 2 12c0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.96z"
                }
            }
        ]
    })(props);
}
function MdBlurCircular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdBlurLinear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdBlurOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0014 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
                }
            }
        ]
    })(props);
}
function MdBlurOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdBrightness1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "10"
                }
            }
        ]
    })(props);
}
function MdBrightness2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
                }
            }
        ]
    })(props);
}
function MdBrightness3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
                }
            }
        ]
    })(props);
}
function MdBrightness4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdBrightness5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdBrightness6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdBrightness7(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdBrokenImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm21 19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
                }
            }
        ]
    })(props);
}
function MdBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34a.996.996 0 00-1.41 0L9 12.25 11.75 15l8.96-8.96a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function MdBurstMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
                }
            }
        ]
    })(props);
}
function MdCameraAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdCameraFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
                }
            }
        ]
    })(props);
}
function MdCameraRear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
                }
            }
        ]
    })(props);
}
function MdCameraRoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 10.5l4.77-8.26a9.984 9.984 0 00-8.49 2.01l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25A9.91 9.91 0 0022 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75A9.958 9.958 0 002.2 14h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76a9.984 9.984 0 008.49-2.01l-3.66-6.35-.93 1.6z"
                }
            }
        ]
    })(props);
}
function MdCases(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4l-2-2h-5L9 4v2H5v11s1 2 2 2h13s2-.98 2-2V6h-4zM4 9H2v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H4V9zm7-4c0-.55.53-1 1-1h3c.46 0 1 .54 1 1v1h-5V5zM5 6h17v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6z"
                }
            }
        ]
    })(props);
}
function MdCenterFocusStrong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function MdCenterFocusWeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdCollectionsBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
                }
            }
        ]
    })(props);
}
function MdCollections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function MdColorLens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 000 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdColorize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.71 5.63l-2.34-2.34a.996.996 0 00-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
                }
            }
        ]
    })(props);
}
function MdCompare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdContrast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93V4.07z"
                }
            }
        ]
    })(props);
}
function MdControlPointDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16A6.99 6.99 0 012 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdControlPoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdCrop169(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
                }
            }
        ]
    })(props);
}
function MdCrop32(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
                }
            }
        ]
    })(props);
}
function MdCrop54(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function MdCrop75(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function MdCropDin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdCropFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdCropLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function MdCropOriginal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
                }
            }
        ]
    })(props);
}
function MdCropPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdCropRotate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8a2 2 0 00-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 002 2h8v2h2v-2h2v-2H8z"
                }
            }
        ]
    })(props);
}
function MdCropSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
                }
            }
        ]
    })(props);
}
function MdCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
                }
            }
        ]
    })(props);
}
function MdCurrencyBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.06 11.57c.59-.69.94-1.59.94-2.57 0-1.86-1.27-3.43-3-3.87V3h-2v2h-2V3H9v2H6v2h2v10H6v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4 0-1.45-.78-2.73-1.94-3.43zM10 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7zm5 10h-5v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdCurrencyFranc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z"
                }
            }
        ]
    })(props);
}
function MdCurrencyLira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.76V3h2v4.51L15 5v2.36l-4 2.51.01 2.35L15 9.72v2.36l-4 2.51V19c2.76 0 5-2.24 5-5h2c0 3.87-3.13 7-7 7H9v-5.16l-3 1.88v-2.36l3-1.88v-2.36L6 13v-2.36l3-1.88z"
                }
            }
        ]
    })(props);
}
function MdCurrencyPound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4 0-.35-.03-.69-.08-1H14v-2H9.82C9 10.42 8 9.6 8 8a3.5 3.5 0 016.78-1.22L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.49 4H6v2h2.47c.08.31.13.64.13 1 0 2.7-2.6 4-2.6 4v2h8z"
                }
            }
        ]
    })(props);
}
function MdCurrencyRuble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H7v9H5v2h2v2H5v2h2v3h2v-3h4v-2H9v-2h4.5c3.04 0 5.5-2.46 5.5-5.5S16.54 3 13.5 3zm0 9H9V5h4.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12z"
                }
            }
        ]
    })(props);
}
function MdCurrencyRupee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"
                }
            }
        ]
    })(props);
}
function MdCurrencyYen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 11H18v2h-5v2h5v2h-5v4h-2v-4H6v-2h5v-2H6v-2h4.08L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function MdCurrencyYuan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.28 12H18v2h-5v7h-2v-7H6v-2h4.72L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function MdDeblur(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v18a9 9 0 000-18z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "10",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "14",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "21",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "3",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "14",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "18",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdDehaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
                }
            }
        ]
    })(props);
}
function MdDetails(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 21h20L12 3zm1 5.92L18.6 19H13V8.92zm-2 0V19H5.4L11 8.92z"
                }
            }
        ]
    })(props);
}
function MdDirtyLens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.95 19H20V7H4v12h7.24c.14-.98.42-2.05-.16-2.43-.89-.59-1.27 2.06-2.8 1.35-1.39-1.12 1.05-1.29.5-3.27-.22-.79-2.28.36-2.4-1.24-.08-1 1.49-.74 1.51-1.49.03-.75-1.03-1.05-.25-1.91.22-.24.71-.26.91-.19.79.27 1.55 1.82 2.51 1.19 1.03-.66-1.88-2.35 0-2.86 1.64-.44 1.31 2.08 2.65 2.44 1.94.52 2.65-4.55 4.41-2.33 1.85 2.33-3.43 2.27-2.85 4.01.34 1.01 2.15-1.2 2.76.53.64 1.83-3.09.82-3.04 1.66.06.83 2.41.55 1.64 2.12-1.14 1.86-3-1.03-3.81.09-.39.57-.09 1.49.13 2.33zM20 5c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17L9 3h6l1.83 2H20zm-1.86 13.01c-.47 0-.86-.38-.86-.86s.38-.86.86-.86c.47 0 .86.38.86.86s-.38.86-.86.86z"
                }
            }
        ]
    })(props);
}
function MdEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function MdEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06a8.262 8.262 0 000 2H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function MdExposureNeg1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function MdExposureNeg2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0016.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
                }
            }
        ]
    })(props);
}
function MdExposurePlus1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function MdExposurePlus2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0017.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
                }
            }
        ]
    })(props);
}
function MdExposureZero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"
                }
            }
        ]
    })(props);
}
function MdExposure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6 7h5v1.5H6V7zm13 12H5L19 5v14zm-4.5-3v2H16v-2h2v-1.5h-2v-2h-1.5v2h-2V16z"
                }
            }
        ]
    })(props);
}
function MdFaceRetouchingNatural(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.77 8.58l-.92 2.01c.09.46.15.93.15 1.41 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-.05.01-.1 0-.14 2.6-.98 4.69-2.99 5.74-5.55A10 10 0 0017.5 10c.45 0 .89-.04 1.33-.1l-.6-1.32-.88-1.93-1.93-.88-2.79-1.27 2.79-1.27.71-.32A9.86 9.86 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.47-.33-2.87-.9-4.13l-.33.71z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.6 5.6L19.5 8l-1.1-2.4L16 4.5l2.4-1.1L19.5 1l1.1 2.4L23 4.5z"
                }
            }
        ]
    })(props);
}
function MdFaceRetouchingOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10c.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 1.22-.28 2.37-.77 3.4l1.49 1.49A9.981 9.981 0 0022 12c0-5.52-4.48-10-10-10-1.78 0-3.44.47-4.89 1.28l5.33 5.33c1.49.88 3.21 1.39 5.06 1.39zM1.89 3.72l2.19 2.19A9.958 9.958 0 002 12c0 5.52 4.48 10 10 10 2.29 0 4.4-.78 6.09-2.08l2.19 2.19 1.41-1.41L3.31 2.31 1.89 3.72zm14.77 14.77A7.91 7.91 0 0112 20c-4.41 0-8-3.59-8-8 0-.05.01-.1 0-.14a9.946 9.946 0 003.64-2.39l9.02 9.02z"
                }
            }
        ]
    })(props);
}
function MdFilter1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdFilter2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2a2 2 0 002-2V7a2 2 0 00-2-2h-4v2h4v2h-2a2 2 0 00-2 2v4h6v-2z"
                }
            }
        ]
    })(props);
}
function MdFilter3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function MdFilter4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdFilter5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2a2 2 0 00-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function MdFilter6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2V7h4V5h-4a2 2 0 00-2 2v6a2 2 0 002 2zm0-4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdFilter7(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
                }
            }
        ]
    })(props);
}
function MdFilter8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13a2 2 0 002 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdFilter9Plus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8a2 2 0 00-2-2h-1a2 2 0 00-2 2v1a2 2 0 002 2h1v1H9v2h3a2 2 0 002-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
                }
            }
        ]
    })(props);
}
function MdFilter9(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2a2 2 0 00-2 2v2a2 2 0 002 2h2v2h-4v2h4a2 2 0 002-2V7a2 2 0 00-2-2zm0 4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdFilterBAndW(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
                }
            }
        ]
    })(props);
}
function MdFilterCenterFocus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdFilterDrama(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4a7.48 7.48 0 00-6.64 4.04A5.996 5.996 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdFilterFrames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
                }
            }
        ]
    })(props);
}
function MdFilterHdr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
                }
            }
        ]
    })(props);
}
function MdFilterNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdFilterTiltShift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zm7.32.19A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43z"
                }
            }
        ]
    })(props);
}
function MdFilterVintage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.7 12.4a6.06 6.06 0 00-.86-.4c.29-.11.58-.24.86-.4a6.012 6.012 0 003-5.19 6.007 6.007 0 00-6 0c-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55a6.008 6.008 0 00-6 0 5.97 5.97 0 003 5.19c.28.16.57.29.86.4-.29.11-.58.24-.86.4a6.012 6.012 0 00-3 5.19 6.007 6.007 0 006 0c.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54a6.008 6.008 0 006 0 6.012 6.012 0 00-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdFlare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
                }
            }
        ]
    })(props);
}
function MdFlashAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
                }
            }
        ]
    })(props);
}
function MdFlashOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"
                }
            }
        ]
    })(props);
}
function MdFlashOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v11h3v9l7-12h-4l4-8z"
                }
            }
        ]
    })(props);
}
function MdFlipCameraAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
                }
            }
        ]
    })(props);
}
function MdFlipCameraIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61zm4.5-2.5L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2l-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function MdFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdGradient(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
                }
            }
        ]
    })(props);
}
function MdGrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdGridOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"
                }
            }
        ]
    })(props);
}
function MdGridOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
                }
            }
        ]
    })(props);
}
function MdHdrEnhancedSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 2C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm1 7h-2V9H9V7h2V5h2v2h2v2h-2v2zm11 9h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zm-6-1.5c0 .6-.4 1.1-.9 1.4L18 22h-1.5l-.9-2h-1.1v2H13v-6h3.5c.8 0 1.5.7 1.5 1.5v1zm-1.5 0v-1h-2v1h2zm-13-.5v-2H5v6H3.5v-2.5h-2V22H0v-6h1.5v2h2zm6.5-2c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5H6.5v-6H10zm0 4.5v-3H8v3h2z"
                }
            }
        ]
    })(props);
}
function MdHdrOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"
                }
            }
        ]
    })(props);
}
function MdHdrOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function MdHdrPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5h2v1h-2zM14.5 7.5H16v3h-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13.5c0 .6-.4 1.1-.9 1.4L12 19h-1.5l-.9-2H8.5v2H7v-6h3.5c.8 0 1.5.7 1.5 1.5v1zm0-3.5h-1.5V9.5h-2V12H7V6h1.5v2h2V6H12v6zm5.5 4H16v1.5h-1.5V16H13v-1.5h1.5V13H16v1.49h1.5V16zm0-5.5c0 .8-.7 1.5-1.5 1.5h-3V6h3c.8 0 1.5.7 1.5 1.5v3z"
                }
            }
        ]
    })(props);
}
function MdHdrStrong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdHdrWeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdHealing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.73 12.02l3.98-3.98a.996.996 0 000-1.41l-4.34-4.34a.996.996 0 00-1.41 0l-3.98 3.98L8 2.29a1.001 1.001 0 00-1.41 0L2.25 6.63a.996.996 0 000 1.41l3.98 3.98L2.25 16a.996.996 0 000 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34a.996.996 0 000-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
                }
            }
        ]
    })(props);
}
function MdHevc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 11h-1V9H3v6h1.5v-2.5h1V15H7V9H5.5zM21 11v-1c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-1.5v.5h-1v-3h1v.5H21zM14.25 13.5L13.5 9H12l1 6h2.5l1-6H15zM8 9v6h3.5v-1.5h-2v-1h2V11h-2v-.5h2V9z"
                }
            }
        ]
    })(props);
}
function MdHideImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.1-.9-2-2-2H5.83L21 18.17V5zM2.81 2.81L1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.41L2.81 2.81zM6 17l3-4 2.25 3 .82-1.1 2.1 2.1H6z"
                }
            }
        ]
    })(props);
}
function MdImageAspectRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdImageNotSupported(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 21.9l-8.49-8.49-9.82-9.82L2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31 1.42-1.41zM5 18l3.5-4.5 2.5 3.01L12.17 15l3 3H5zm16 .17L5.83 3H19c1.1 0 2 .9 2 2v13.17z"
                }
            }
        ]
    })(props);
}
function MdImageSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function MdIncompleteCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-2.76 1.12-5.26 2.93-7.07L12 12V2c5.52 0 10 4.48 10 10z"
                }
            }
        ]
    })(props);
}
function MdIso(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
                }
            }
        ]
    })(props);
}
function MdLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
                }
            }
        ]
    })(props);
}
function MdLeakAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2a9 9 0 01-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2a9 9 0 019-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function MdLeakRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 013 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5A11.044 11.044 0 0010 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43A6.922 6.922 0 0014 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46A8.98 8.98 0 0121 12v-2c-2.06 0-3.98.58-5.62 1.56z"
                }
            }
        ]
    })(props);
}
function MdLens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdLinkedCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "3.2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "5",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0H0v24h24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdLogoDev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.68 14.98H6V9h1.71c1.28 0 1.71 1.03 1.71 1.71v2.56c0 .68-.42 1.71-1.74 1.71zm4.7-3.52v1.07H11.2v1.39h1.93v1.07h-2.25c-.4.01-.74-.31-.75-.71V9.75c-.01-.4.31-.74.71-.75h2.28v1.07H11.2v1.39h1.18zm4.5 2.77c-.48 1.11-1.33.89-1.71 0L13.77 9h1.18l1.07 4.11L17.09 9h1.18l-1.39 5.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 10.12h-.63v3.77h.63c.14 0 .28-.05.42-.16.14-.1.21-.26.21-.47v-2.52c0-.21-.07-.37-.21-.47a.72.72 0 00-.42-.15z"
                }
            }
        ]
    })(props);
}
function MdLooks3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15a2 2 0 01-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4a2 2 0 012 2v1.5z"
                }
            }
        ]
    })(props);
}
function MdLooks4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
                }
            }
        ]
    })(props);
}
function MdLooks5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2a2 2 0 012 2v2a2 2 0 01-2 2H9v-2h4v-2H9V7h6v2z"
                }
            }
        ]
    })(props);
}
function MdLooks6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V9a2 2 0 012-2h4v2z"
                }
            }
        ]
    })(props);
}
function MdLooksOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
                }
            }
        ]
    })(props);
}
function MdLooksTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8a2 2 0 01-2 2h-2v2h4v2H9v-4a2 2 0 012-2h2V9H9V7h4a2 2 0 012 2v2z"
                }
            }
        ]
    })(props);
}
function MdLooks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function MdLoupe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdMicExternalOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 5.17 8H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4v-1.17l5.78 5.78 1.41-1.42zM12 18c0 1.1-.9 2-2 2s-2-.9-2-2h1l.56-5.61L12 14.83V18zm2-12v5.17l-2-2V6c0-2.21 1.79-4 4-4s4 1.79 4 4v11.17l-2-2V6c0-1.1-.9-2-2-2s-2 .9-2 2zm-4-1c0 .62-.2 1.18-.52 1.66L5.33 2.51A2.996 2.996 0 0110 5z"
                }
            }
        ]
    })(props);
}
function MdMicExternalOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.22 7H4.78C4.3 6.47 4 5.77 4 5c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .77-.3 1.47-.78 2zM16 2c2.21 0 4 1.79 4 4v16h-2V6c0-1.1-.9-2-2-2s-2 .9-2 2v12c0 2.21-1.79 4-4 4s-4-1.79-4-4H5L4 8h6L9 18H8c0 1.1.9 2 2 2s2-.9 2-2V6c0-2.21 1.79-4 4-4z"
                }
            }
        ]
    })(props);
}
function MdMonochromePhotos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zM-74 29h48v48h-48V29z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function MdMotionPhotosAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm5.03 3.49h-.07L10.8 12.3h2.39l-1.16-3.31zM12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.71-10.5h1.43l3.01 8h-1.39l-.72-2.04h-3.23l-.73 2.04H8.28l3.01-8z"
                }
            }
        ]
    })(props);
}
function MdMotionPhotosOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 20.84L3.16 3.16 1.89 4.43l1.89 1.89A9.92 9.92 0 002 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.77l1.89 1.89 1.27-1.28zM12 20c-4.41 0-8-3.59-8-8 0-1.55.45-3 1.22-4.23l1.46 1.46C6.25 10.06 6 11 6 12c0 3.31 2.69 6 6 6 1 0 1.94-.25 2.77-.68l1.46 1.46A7.951 7.951 0 0112 20zM6.32 3.77A9.986 9.986 0 0112 2c5.52 0 10 4.48 10 10 0 2.11-.66 4.07-1.77 5.68l-1.45-1.45A7.951 7.951 0 0020 12c0-4.41-3.59-8-8-8-1.55 0-3 .45-4.23 1.22L6.32 3.77zM18 12c0 1-.25 1.94-.68 2.77L9.23 6.68C10.06 6.25 11 6 12 6c3.31 0 6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function MdMotionPhotosOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6zm1-6.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5z"
                }
            }
        ]
    })(props);
}
function MdMotionPhotosPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm5 .5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 9H9V9h2v6zm4 0h-2V9h2v6z"
                }
            }
        ]
    })(props);
}
function MdMotionPhotosPaused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-1.19.22-2.32.6-3.38l1.88.68C4.17 10.14 4 11.05 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.95 0-1.85.17-2.69.48l-.68-1.89C9.69 2.22 10.82 2 12 2c5.52 0 10 4.48 10 10zM5.5 4C4.67 4 4 4.67 4 5.5S4.67 7 5.5 7 7 6.33 7 5.5 6.33 4 5.5 4zM11 16V8H9v8h2zm4 0V8h-2v8h2z"
                }
            }
        ]
    })(props);
}
function MdMovieCreation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
                }
            }
        ]
    })(props);
}
function MdMovieFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
                }
            }
        ]
    })(props);
}
function MdMp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM6.5 9H11c.55 0 1 .45 1 1v5h-1.5v-4.5h-1v3H8v-3H7V15H5.5v-5c0-.55.45-1 1-1zm9 6H14V9h3.5c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1h-2V15zm0-3H17v-1.5h-1.5V12z"
                }
            }
        ]
    })(props);
}
function MdMusicNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
                }
            }
        ]
    })(props);
}
function MdMusicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.27 3L3 4.27l9 9v.28c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4v-1.73L19.73 21 21 19.73 4.27 3zM14 7h4V3h-6v5.18l2 2z"
                }
            }
        ]
    })(props);
}
function MdNaturePeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0014 16.06V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 006.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
                }
            }
        ]
    })(props);
}
function MdNature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.12a7 7 0 006.17-6.95c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0011 16.06V20H5v2h14v-2h-6v-3.88z"
                }
            }
        ]
    })(props);
}
function MdNavigateBefore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                }
            }
        ]
    })(props);
}
function MdNavigateNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                }
            }
        ]
    })(props);
}
function MdPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10a2.5 2.5 0 002.5-2.5c0-.61-.23-1.2-.64-1.67a.528.528 0 01-.13-.33c0-.28.22-.5.5-.5H16c3.31 0 6-2.69 6-6 0-4.96-4.49-9-10-9zm5.5 11c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm-3-4c-.83 0-1.5-.67-1.5-1.5S13.67 6 14.5 6s1.5.67 1.5 1.5S15.33 9 14.5 9zM5 11.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 13 6.5 13 5 12.33 5 11.5zm6-4c0 .83-.67 1.5-1.5 1.5S8 8.33 8 7.5 8.67 6 9.5 6s1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdPanoramaFishEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdPanoramaHorizontalSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64A.94.94 0 002.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
                }
            }
        ]
    })(props);
}
function MdPanoramaHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64A.94.94 0 002.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
                }
            }
        ]
    })(props);
}
function MdPanoramaPhotosphereSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.49 8.51c-.47-.23-.93-.44-1.4-.64C19.52 4.41 16.05 2 12 2S4.47 4.41 2.9 7.88c-.47.2-.93.41-1.4.63-.31.15-.5.48-.5.83v5.32c0 .35.19.68.51.83.47.23.93.44 1.39.64 3.55 7.83 14.65 7.82 18.2 0 .47-.2.93-.41 1.39-.63.31-.17.51-.49.51-.84V9.34a.91.91 0 00-.51-.83zM12 3.8c2.6 0 4.91 1.23 6.41 3.12-4.1-1.19-8.48-1.26-12.83.01C7.08 5.03 9.4 3.8 12 3.8zM5.6 17.08c4.19 1.22 8.57 1.23 12.82-.01a8.136 8.136 0 01-12.82.01z"
                }
            }
        ]
    })(props);
}
function MdPanoramaPhotosphere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.4 11.32v2.93c-.1.05-2.17.85-3.33 1.17-.94.26-3.84.73-6.07.73-3.7 0-7-.7-9.16-1.8-.08-.04-.16-.06-.24-.1V9.76c6.02-2.84 12.6-2.92 18.8 0v1.56zm-9.39 8.88c-2.5 0-4.87-1.15-6.41-3.12 4.19 1.22 8.57 1.23 12.82-.01a8.136 8.136 0 01-6.41 3.13zM12 3.8c2.6 0 4.91 1.23 6.41 3.12-4.1-1.19-8.48-1.26-12.83.01C7.08 5.03 9.4 3.8 12 3.8zm10.49 4.71c-.47-.23-.93-.44-1.4-.64C19.52 4.41 16.05 2 12 2S4.47 4.41 2.9 7.88c-.47.2-.93.41-1.4.63-.31.15-.5.48-.5.83v5.32c0 .35.19.68.51.83.47.23.93.44 1.39.64 3.55 7.83 14.65 7.82 18.2 0 .47-.2.93-.41 1.39-.63.31-.17.51-.49.51-.84V9.34a.91.91 0 00-.51-.83z"
                }
            }
        ]
    })(props);
}
function MdPanoramaVerticalSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 21.12c-1.1-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12c.05-.11.07-.22.07-.31 0-.34-.24-.57-.64-.57H4.62c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.7 8.91 5.7 12s-.55 6.18-1.64 9.12c-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57 0-.1-.02-.2-.07-.31z"
                }
            }
        ]
    })(props);
}
function MdPanoramaVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12a.94.94 0 00.06-.31c0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"
                }
            }
        ]
    })(props);
}
function MdPanoramaWideAngleSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
                }
            }
        ]
    })(props);
}
function MdPanoramaWideAngle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c2.45 0 4.71.2 7.29.64A21 21 0 0120 12a21 21 0 01-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64A21 21 0 014 12a21 21 0 01.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
                }
            }
        ]
    })(props);
}
function MdPanorama(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function MdPhotoAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 2h5v7l-2.5-1.5L11 11V4zM7 18l2.38-3.17L11 17l2.62-3.5L17 18H7z"
                }
            }
        ]
    })(props);
}
function MdPhotoCameraBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h3.17L9 3h6l1.83 2H20zm0 14V7H4v12h16zm-6-7l-3 3.72L9 13l-3 4h12l-4-5z"
                }
            }
        ]
    })(props);
}
function MdPhotoCameraFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48l4-3.98v11l-4-3.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4.48zm-2-.79V6H4v12h12V9.69zM10 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 1c1.34 0 4 .67 4 2v1H6v-1c0-1.33 2.66-2 4-2z"
                }
            }
        ]
    })(props);
}
function MdPhotoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdPhotoFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"
                }
            }
        ]
    })(props);
}
function MdPhotoLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function MdPhotoSizeSelectActual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
                }
            }
        ]
    })(props);
}
function MdPhotoSizeSelectLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
                }
            }
        ]
    })(props);
}
function MdPhotoSizeSelectSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
                }
            }
        ]
    })(props);
}
function MdPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
                }
            }
        ]
    })(props);
}
function MdPictureAsPdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
                }
            }
        ]
    })(props);
}
function MdPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdRawOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.15 14.32l.59-2.36.76 3.04h1.48l1.5-6h-1.5l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l.72 2.9zM1.39 4.22L6.17 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-.67l1.43 1.43L8.75 15h1.5l.38-1.5h.04l9.11 9.11 1.41-1.41L2.81 2.81 1.39 4.22zM6.5 11.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function MdRawOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-1C8 9.7 7.3 9 6.5 9zm0 2.5h-2v-1h2v1zM10.25 9l-1.5 6h1.5l.38-1.5h1.75l.37 1.5h1.5l-1.5-6h-2.5zm.75 3l.25-1h.5l.25 1h-1zM19.98 9l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l1.5 6h1.48l.76-3.04.76 3.04h1.48l1.5-6z"
                }
            }
        ]
    })(props);
}
function MdReceiptLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM19 19c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6v2H9zM16 7h2v2h-2zM9 10h6v2H9zM16 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdRemoveRedEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdRotate90DegreesCcw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26A8.95 8.95 0 0013 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 010 9.9 6.973 6.973 0 01-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 000-12.72z"
                }
            }
        ]
    })(props);
}
function MdRotate90DegreesCw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.64 19.37c3.03 3.03 7.67 3.44 11.15 1.25l-1.46-1.46c-2.66 1.43-6.04 1.03-8.28-1.21a7.007 7.007 0 010-9.9C7.42 6.69 9.21 6.03 11 6.03V9l4-4-4-4v3.01c-2.3 0-4.61.87-6.36 2.63-3.52 3.51-3.52 9.21 0 12.73zM11 13l6 6 6-6-6-6-6 6z"
                }
            }
        ]
    })(props);
}
function MdRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
                }
            }
        ]
    })(props);
}
function MdRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11a7.906 7.906 0 00-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
                }
            }
        ]
    })(props);
}
function MdShutterSpeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35a5.992 5.992 0 003.41 3.56l-.11-.06 2.03-3.5zm5.97-4a6.012 6.012 0 00-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99A5.965 5.965 0 006 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14A5.94 5.94 0 0018 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
                }
            }
        ]
    })(props);
}
function MdSlideshow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdStraighten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
                }
            }
        ]
    })(props);
}
function MdStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 00-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 00-1.08 2.6l4.96 11.97a1.998 1.998 0 002.6 1.08l7.36-3.05a1.994 1.994 0 001.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
                }
            }
        ]
    })(props);
}
function MdSwitchCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdSwitchVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdTagFaces(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdTexture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
                }
            }
        ]
    })(props);
}
function MdThermostatAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V6c0-1.66-1.34-3-3-3S5 4.34 5 6v6c-1.21.91-2 2.37-2 4 0 1.12.38 2.14 1 2.97V19h.02c.91 1.21 2.35 2 3.98 2s3.06-.79 3.98-2H12v-.03c.62-.83 1-1.85 1-2.97 0-1.63-.79-3.09-2-4zm-6 4c0-.94.45-1.84 1.2-2.4L7 13V6c0-.55.45-1 1-1s1 .45 1 1v7l.8.6c.75.57 1.2 1.46 1.2 2.4H5zM18.62 4h-1.61l-3.38 9h1.56l.81-2.3h3.63l.8 2.3H22l-3.38-9zm-2.15 5.39l1.31-3.72h.08l1.31 3.72h-2.7z"
                }
            }
        ]
    })(props);
}
function MdTimelapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.76A5.974 5.974 0 0012 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 00-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdTimer10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23 2.61 2.61 0 01-.55-.25.717.717 0 01-.28-.3.978.978 0 01.01-.8c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 00-.93-1.97c-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"
                }
            }
        ]
    })(props);
}
function MdTimer3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 12.97c-.16-.24-.36-.46-.62-.65a3.38 3.38 0 00-.93-.48c.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23 2.61 2.61 0 01-.55-.25.717.717 0 01-.28-.3c-.05-.11-.08-.24-.08-.39a.946.946 0 01.36-.75c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95a2.517 2.517 0 00-.93-1.97c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
                }
            }
        ]
    })(props);
}
function MdTimerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1h6v2H9zM13 8v2.17l6.98 6.98a8.963 8.963 0 00-.95-9.76l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42a8.962 8.962 0 00-9.77-.96L10.83 8H13zM2.81 2.81L1.39 4.22l3.4 3.4a8.994 8.994 0 0012.59 12.59l2.4 2.4 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1h6v2H9zM19.03 7.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM13 14h-2V8h2v6z"
                }
            }
        ]
    })(props);
}
function MdTonality(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
                }
            }
        ]
    })(props);
}
function MdTransform(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
                }
            }
        ]
    })(props);
}
function MdTune(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
                }
            }
        ]
    })(props);
}
function MdVideoCameraBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM5 16l2.38-3.17L9 15l2.62-3.5L15 16H5z"
                }
            }
        ]
    })(props);
}
function MdVideoCameraFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM10 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8H6v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0114 15.43V16z"
                }
            }
        ]
    })(props);
}
function MdVideoStable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2.95l-2.33 8.73L16.82 18H4zm16 0h-2.95l2.34-8.73L7.18 6H20v12z"
                }
            }
        ]
    })(props);
}
function MdViewComfy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v7h20V4H2zm8 16h12v-7H10v7zm-8 0h6v-7H2v7z"
                }
            }
        ]
    })(props);
}
function MdViewCompact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h2.5v-2.5H4V18zm0-4.75h2.5v-2.5H4v2.5zM4 8.5h2.5V6H4v2.5zM17.5 6v2.5H20V6h-2.5zM13 8.5h2.5V6H13v2.5zm4.5 9.5H20v-2.5h-2.5V18zm0-4.75H20v-2.5h-2.5v2.5zM8.5 18H11v-2.5H8.5V18zm4.5 0h2.5v-2.5H13V18zM8.5 8.5H11V6H8.5v2.5zm4.5 4.75h2.5v-2.5H13v2.5zm-4.5 0H11v-2.5H8.5v2.5z"
                }
            }
        ]
    })(props);
}
function MdVignette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
                }
            }
        ]
    })(props);
}
function MdVrpano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.69 4.05C18.66 4.73 15.86 5.5 12 5.5c-3.89 0-6.95-.84-8.69-1.43A.993.993 0 002 5.02V19c0 .68.66 1.17 1.31.95C5.36 19.26 8.1 18.5 12 18.5c3.87 0 6.66.76 8.69 1.45A.999.999 0 0022 19V5c0-.68-.66-1.16-1.31-.95zM12 15c-2.34 0-4.52.15-6.52.41l3.69-4.42 2 2.4L14 10l4.51 5.4c-1.99-.25-4.21-.4-6.51-.4z"
                }
            }
        ]
    })(props);
}
function MdWbAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
                }
            }
        ]
    })(props);
}
function MdWbCloudy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
                }
            }
        ]
    })(props);
}
function MdWbIncandescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
                }
            }
        ]
    })(props);
}
function MdWbIridescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
                }
            }
        ]
    })(props);
}
function MdWbShade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12v2.5l5.5 5.5H22zm0 8h3l-3-3zM8 4l-6 6h2v10h8V10h2L8 4zm1 10H7v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdWbSunny(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
                }
            }
        ]
    })(props);
}
function MdWbTwighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.954 8.66l2.12-2.12 1.415 1.414-2.13 2.12zM17.9 14c-.5-2.85-2.95-5-5.9-5s-5.45 2.15-5.9 5h11.8zM2 16h20v4H2zm9-12h2v3h-2zM3.54 7.925L4.954 6.51l2.122 2.122-1.415 1.415z"
                }
            }
        ]
    })(props);
}
function MdWbTwilight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.955 8.662l2.12-2.122 1.416 1.414-2.121 2.122zM2 18h20v2H2zM11 4h2v3h-2zM3.543 7.925L4.957 6.51l2.121 2.12-1.414 1.415zM5 16h14c0-3.87-3.13-7-7-7s-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function Md360(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
                }
            }
        ]
    })(props);
}
function MdAddBusiness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4v3zm-6 1H4v-4h5v4zM2 4h15v2H2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function MdAddLocationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1v3h3v2h-3v3h-2V6h-3V4h3V1h2zm-8 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2-9.75V7h3v3h2.92c.05.39.08.79.08 1.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 6.22 7.8 3 12 3c.68 0 1.35.08 2 .25z"
                }
            }
        ]
    })(props);
}
function MdAddLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdAddRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2zM18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdAgriculture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 12c.93 0 1.78.28 2.5.76V8c0-1.1-.9-2-2-2h-6.29l-1.06-1.06 1.41-1.41-.71-.71-3.53 3.53.71.71 1.41-1.41L13 6.71V9c0 1.1-.9 2-2 2h-.54A5.98 5.98 0 0112 15c0 .34-.04.67-.09 1h3.14c.25-2.25 2.14-4 4.45-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM4 9h5c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1zM9.83 13.82l-.18-.47.93-.35a4.92 4.92 0 00-2.31-2.43l-.4.89-.46-.21.4-.9C7.26 10.13 6.64 10 6 10c-.53 0-1.04.11-1.52.26l.34.91-.47.18-.35-.93a4.92 4.92 0 00-2.43 2.31l.89.4-.21.46-.9-.4C1.13 13.74 1 14.36 1 15c0 .53.11 1.04.26 1.52l.91-.34.18.47-.93.35a4.92 4.92 0 002.31 2.43l.4-.89.46.21-.4.9c.55.22 1.17.35 1.81.35.53 0 1.04-.11 1.52-.26l-.34-.91.47-.18.35.93a4.92 4.92 0 002.43-2.31l-.89-.4.21-.46.9.4c.22-.55.35-1.17.35-1.81 0-.53-.11-1.04-.26-1.52l-.91.34zm-2.68 3.95c-1.53.63-3.29-.09-3.92-1.62-.63-1.53.09-3.29 1.62-3.92 1.53-.63 3.29.09 3.92 1.62.64 1.53-.09 3.29-1.62 3.92z"
                }
            }
        ]
    })(props);
}
function MdAirlineStops(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.21 9.21C15.93 10.78 13.45 13.3 13 17h2v2H9v-2h2c-.5-4.5-4.37-8-9-8V7c4.39 0 8.22 2.55 10 6.3 1.13-2.43 2.99-4.25 4.78-5.52L14 5h7v7l-2.79-2.79z"
                }
            }
        ]
    })(props);
}
function MdAirlines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4L2 20h17l3-16h-9zm1.5 10a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdAltRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.78 11.16l-1.42 1.42a7.282 7.282 0 01-1.79-2.94l1.94-.49c.32.89.77 1.5 1.27 2.01zM11 6L7 2 3 6h3.02c.02.81.08 1.54.19 2.17l1.94-.49C8.08 7.2 8.03 6.63 8.02 6H11zm10 0l-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88-.5.44-1.01.92-1.45 1.55-.34-.49-.73-.88-1.13-1.24L9.46 13.6c.93.85 1.54 1.54 1.54 3.4v5h2v-5c0-2.02.71-2.66 1.79-3.63 1.38-1.24 3.08-2.78 3.2-7.37H21z"
                }
            }
        ]
    })(props);
}
function MdAtm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v1.5h2.25V15h1.5v-4.5H14V9zM6 9H3c-.55 0-1 .45-1 1v5h1.5v-1.5h2V15H7v-5c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v5H17v-4.5h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdAttractions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.43 18.75c.37-.46.94-.75 1.57-.75.63 0 1.19.29 1.56.75.39-.09.76-.21 1.12-.36l-1.42-3.18a3.522 3.522 0 01-2.56-.02l-1.43 3.19c.38.16.76.29 1.16.37zM5.15 10a7.06 7.06 0 00.08 4c.63.05 1.22.4 1.56.99.33.57.35 1.23.11 1.79.27.27.56.53.87.76l1.52-3.39c-.47-.58-.75-1.32-.75-2.13 0-1.89 1.55-3.41 3.46-3.41s3.46 1.53 3.46 3.41c0 .82-.29 1.57-.78 2.16l1.5 3.35c.32-.24.62-.5.9-.79-.22-.55-.2-1.2.12-1.75.33-.57.9-.92 1.52-.99a7.025 7.025 0 00.09-4.02c-.64-.04-1.26-.39-1.6-1-.36-.62-.35-1.36-.03-1.95-.91-.98-2.1-1.71-3.44-2.05C13.39 5.6 12.74 6 12 6s-1.39-.41-1.74-1.01a7.053 7.053 0 00-3.44 2.03c.33.6.35 1.35-.02 1.98-.35.62-.99.97-1.65 1zm-1.3-.42c-.78-.6-1.02-1.7-.51-2.58.51-.88 1.58-1.23 2.49-.85a8.53 8.53 0 014.18-2.42C10.15 2.75 10.99 2 12 2s1.85.75 1.98 1.73c1.63.39 3.07 1.24 4.18 2.42a1.99 1.99 0 012.49.85c.51.88.27 1.98-.51 2.58.23.77.35 1.58.35 2.42s-.12 1.65-.35 2.42c.78.6 1.02 1.7.51 2.58-.51.88-1.58 1.23-2.49.85-.4.43-.85.81-1.34 1.15l1.34 3H16.3l-.97-2.17c-.43.18-.88.33-1.34.44-.14.98-.98 1.73-1.99 1.73s-1.85-.75-1.98-1.73c-.48-.12-.94-.27-1.38-.46L7.66 22H5.78l1.36-3.03a8.72 8.72 0 01-1.3-1.12c-.92.38-1.99.03-2.5-.85s-.27-1.98.51-2.58c-.23-.77-.35-1.58-.35-2.42s.12-1.65.35-2.42z"
                }
            }
        ]
    })(props);
}
function MdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM9 12c.83 0 1.5.67 1.5 1.5S9.83 15 9 15s-1.5-.67-1.5-1.5S8.17 12 9 12zm3 6H6v-.75c0-1 2-1.5 3-1.5s3 .5 3 1.5V18zm1-9h-2V4h2v5zm5 7.5h-4V15h4v1.5zm0-3h-4V12h4v1.5z"
                }
            }
        ]
    })(props);
}
function MdBakeryDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M19.28 16.34L17.46 15s.32-.59.96-1.78a.944.944 0 011.6 0l.81 1.26c.19.3.21.68.06 1l-.22.47a.94.94 0 01-1.39.39zm-14.56 0a.946.946 0 01-1.39-.38l-.23-.47c-.15-.32-.13-.7.06-1l.81-1.26a.944.944 0 011.6 0c.65 1.18.97 1.77.97 1.77l-1.82 1.34zm10.64-6.97c.09-.68.73-1.06 1.27-.75l1.59.9c.46.26.63.91.36 1.41L16.5 15h-1.8l.66-5.63zm-6.73 0L9.3 15H7.5l-2.09-4.08c-.27-.5-.1-1.15.36-1.41l1.59-.9c.53-.3 1.18.08 1.27.76zM13.8 15h-3.6l-.74-6.88c-.07-.59.35-1.12.88-1.12h3.3c.53 0 .94.53.88 1.12L13.8 15z"
                }
            }
        ]
    })(props);
}
function MdBeenhere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"
                }
            }
        ]
    })(props);
}
function MdBikeScooter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14h.74L8.82 5.56A2.009 2.009 0 006.87 4H3v2h3.87l1.42 6.25h-.01A6.008 6.008 0 004.09 17H0v2h6v-1c0-2.21 1.79-4 4-4zM19 8h-.82l-1.35-3.69A1.976 1.976 0 0014.96 3H11v2h3.96l1.1 3H10.4l.46 2H15c-.43.58-.75 1.25-.9 2h-2.79l.46 2h2.33c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 10.2 21.8 8 19 8zm0 8c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdBreakfastDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 3H6C3.79 3 2 4.79 2 7c0 1.48.81 2.75 2 3.45V19c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8.55c1.19-.69 2-1.97 2-3.45 0-2.21-1.79-4-4-4zm-4 12h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdBrunchDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M18 8h2V4h-2v4zm-2.49 14H2.49c-.27 0-.49-.22-.49-.5V20h14v1.5c0 .28-.22.5-.49.5zM18 15.89l-.4-.42a5.852 5.852 0 01-1.6-4V2h6v9.51c0 1.46-.54 2.87-1.53 3.94l-.47.52V20h2v2h-4v-6.11zM7 16v-2h4v2h4.5c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5h-13c-.28 0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5H7z"
                }
            }
        ]
    })(props);
}
function MdBusAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1a7 7 0 00-5.78 3.05l.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22a1 1 0 001 1h1a1 1 0 001-1v-1h8v1a1 1 0 001 1h1a1 1 0 001-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08A7 7 0 0016 1zM4.5 19a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm2.5-6a5 5 0 110-10 5 5 0 010 10zm-1-9h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdCarCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 6h-1V3h1v4zm0 1v1h-1V8h1zm-.59 5c.06.16.09.33.09.5 0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5c0-.39.15-.74.39-1.01A7.032 7.032 0 0111.68 9H5.81l1.04-3H11c0-.69.1-1.37.29-2H6.5c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-6.68c-1.05.51-2.16.69-3.09.68zM7.5 15c-.83 0-1.5-.67-1.5-1.5S6.67 12 7.5 12s1.5.67 1.5 1.5S8.33 15 7.5 15z"
                }
            }
        ]
    })(props);
}
function MdCarRental(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.39 9H7.61c-.43 0-.81.28-.95.68l-1.66 5v6.81c0 .29.23.51.5.51h1c.28 0 .5-.22.5-.5V20h10v1.5c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-6.81l-1.66-5a1.01 1.01 0 00-.95-.69zm-8.61 9c-.68 0-1.22-.54-1.22-1.22s.54-1.22 1.22-1.22S9 16.11 9 16.78 8.46 18 7.78 18zm8.44 0c-.67 0-1.22-.54-1.22-1.22s.54-1.22 1.22-1.22 1.22.54 1.22 1.22S16.9 18 16.22 18zm-9.93-4l1.33-4h8.78l1.33 4H6.29zM10.83 3A3.01 3.01 0 008 1C6.34 1 5 2.34 5 4c0 1.65 1.34 3 3 3 1.3 0 2.41-.84 2.83-2H16v2h2V5h1V3h-8.17zM8 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdCarRepair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.22 12c.68 0 1.22-.54 1.22-1.22 0-.67-.54-1.22-1.22-1.22S15 10.11 15 10.78c0 .68.55 1.22 1.22 1.22zm-9.66-1.22c0 .67.54 1.22 1.22 1.22S9 11.46 9 10.78c0-.67-.54-1.22-1.22-1.22s-1.22.55-1.22 1.22zM7.61 4L6.28 8h11.43l-1.33-4H7.61zm8.67-1s.54.01.92.54c.02.02.03.04.05.07.07.11.14.24.19.4.22.65 1.56 4.68 1.56 4.68v6.5c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81V14H7v1.19c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81v-6.5S6.34 4.67 6.55 4c.05-.16.12-.28.19-.4.03-.02.04-.04.06-.06.38-.53.92-.54.92-.54h8.56zM4 17.01h16V19h-7v3h-2v-3H4v-1.99z"
                }
            }
        ]
    })(props);
}
function MdCastle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v2h-2V3h-2v2h-2V3h-2v2h-2V3H9v2H7V3H5v8H3V9H1v12h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9V9h-2zm-10 3H9V9h2v3zm4 0h-2V9h2v3z"
                }
            }
        ]
    })(props);
}
function MdCategory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2l-5.5 9h11z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "17.5",
                    "r": "4.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13.5h8v8H3z"
                }
            }
        ]
    })(props);
}
function MdCelebration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22l14-5-9-9zM14.53 12.53l5.59-5.59a1.25 1.25 0 011.77 0l.59.59 1.06-1.06-.59-.59a2.758 2.758 0 00-3.89 0l-5.59 5.59 1.06 1.06zM10.06 6.88l-.59.59 1.06 1.06.59-.59a2.758 2.758 0 000-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76zM17.06 11.88l-1.59 1.59 1.06 1.06 1.59-1.59a1.25 1.25 0 011.77 0l1.61 1.61 1.06-1.06-1.61-1.61a2.758 2.758 0 00-3.89 0zM15.06 5.88l-3.59 3.59 1.06 1.06 3.59-3.59a2.758 2.758 0 000-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77z"
                }
            }
        ]
    })(props);
}
function MdChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h8v-3c0-1.1.9-2 2-2s2 .9 2 2v3h8v-8l-4-1.78zm-6 1.28c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdCleaningServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5zm3 10h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5z"
                }
            }
        ]
    })(props);
}
function MdCompassCalibration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "4"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.07c1.95 0 3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3S4.56 4.59 2 7.15l5 5a7.06 7.06 0 015-2.08z"
                }
            }
        ]
    })(props);
}
function MdConnectingAirports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4 17l1.3 4.4h-1.1L13 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h3l2.6-4.4h1.1L15.4 15h2.85l.75-1h1l-.6 2 .6 2h-1l-.75-1H15.4zM5.75 7L5 6H4l.6 2-.6 2h1l.75-1H8.6l-1.3 4.4h1.1L11 9h3c.55 0 1-.45 1-1s-.45-1-1-1h-3L8.4 2.6H7.3L8.6 7H5.75z"
                }
            }
        ]
    })(props);
}
function MdCrisisAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2.5c0 1.5-1.5 6-1.5 6h-2S9.5 4 9.5 2.5a2.5 2.5 0 015 0zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4.08-4.89c.18-.75.33-1.47.39-2.06A9.996 9.996 0 0122 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-3.92 2.25-7.31 5.53-8.95.07.59.21 1.32.39 2.06A8.028 8.028 0 004 12c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.93-1.58-5.49-3.92-6.89zM18 12c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2 .98-3.77 2.48-4.86.23.81.65 2.07.65 2.07C8.43 9.93 8 10.92 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.08-.43-2.07-1.13-2.79 0 0 .41-1.22.65-2.07A5.998 5.998 0 0118 12z"
                }
            }
        ]
    })(props);
}
function MdDeliveryDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM7 17c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdDepartureBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c-2.4 0-4.52 1.21-5.78 3.05.01-.01.01-.02.02-.03C9.84 4 9.42 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM4.5 19c-.83 0-1.5-.67-1.5-1.5S3.67 16 4.5 16s1.5.67 1.5 1.5S5.33 19 4.5 19zM3 13V8h6c0 1.96.81 3.73 2.11 5H3zm10.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
                }
            }
        ]
    })(props);
}
function MdDesignServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 11.51l1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89l-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function MdDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.16 3h-.32L9.21 8.25h5.58zM16.46 8.25h5.16L19 3h-5.16zM21.38 9.75h-8.63V20.1zM11.25 20.1V9.75H2.62zM7.54 8.25L10.16 3H5L2.38 8.25z"
                }
            }
        ]
    })(props);
}
function MdDinnerDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19h20l-2 2H4l-2-2zM5 6h1v1H5V6zm0-2h1v1H5V4zm4 0v1H7V4h2zm0 3H7V6h2v1zm-3 8.23c-.36.11-.69.28-1 .47V8h1v7.23zm-2 1.29c-.38.44-.68.93-.84 1.48h16.82c.01-.16.03-.33.03-.5a5.497 5.497 0 00-10.58-2.1c-.59-.25-1.24-.4-1.93-.4-.17 0-.33.02-.5.04V8h2c1.03.06 1.9-.96 2-2h10V5H11c-.1-1.05-.97-1.97-2-2H3v1h1v1H3v1h1v1H3v1h1v8.52z"
                }
            }
        ]
    })(props);
}
function MdDirectionsBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdDirectionsBoatFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99a8.752 8.752 0 008 0c1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.9-6.68c.11-.37.04-1.06-.66-1.28L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.63.19-.81.84-.66 1.28L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
                }
            }
        ]
    })(props);
}
function MdDirectionsBoat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99a8.752 8.752 0 008 0c1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 00-.66 1.28L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
                }
            }
        ]
    })(props);
}
function MdDirectionsBusFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5c0 .95.38 1.81 1 2.44V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-2.06c.62-.63 1-1.49 1-2.44V6c0-3.5-3.58-4-8-4zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm7 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6H6V7h12v3z"
                }
            }
        ]
    })(props);
}
function MdDirectionsBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
                }
            }
        ]
    })(props);
}
function MdDirectionsCarFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM7.5 16c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5.81 10l1.04-3h10.29l1.04 3H5.81z"
                }
            }
        ]
    })(props);
}
function MdDirectionsCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
                }
            }
        ]
    })(props);
}
function MdDirectionsRailwayFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 14c-.83 0-1.5-.67-1.5-1.5S11.17 13 12 13s1.5.67 1.5 1.5S12.83 16 12 16zm6-6H6V7h12v3z"
                }
            }
        ]
    })(props);
}
function MdDirectionsRailway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
                }
            }
        ]
    })(props);
}
function MdDirectionsRun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
                }
            }
        ]
    })(props);
}
function MdDirectionsSubwayFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm2.5-6H6V7h5v3zm4.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function MdDirectionsSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
                }
            }
        ]
    })(props);
}
function MdDirectionsTransitFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM8.5 16c-.83 0-1.5-.67-1.5-1.5S7.67 13 8.5 13s1.5.67 1.5 1.5S9.33 16 8.5 16zm2.5-6H6V7h5v3zm4.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm2.5-6h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function MdDirectionsTransit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
                }
            }
        ]
    })(props);
}
function MdDirectionsWalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
                }
            }
        ]
    })(props);
}
function MdDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 10.59l-7.99-8c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0l7.99-8c.79-.79.79-2.05 0-2.83zM13.5 14.5V12H10v3H8v-4c0-.55.45-1 1-1h4.5V7.5L17 11l-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdDryCleaning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.56 11.36L13 8.44V7c0-.55-.45-1-1-1s-1-.45-1-1 .45-1 1-1 1 .45 1 1h2c0-1.84-1.66-3.3-3.56-2.95-1.18.22-2.15 1.17-2.38 2.35-.3 1.56.6 2.94 1.94 3.42v.63l-6.56 2.92c-.88.38-1.44 1.25-1.44 2.2v.01C3 14.92 4.08 16 5.42 16H7v6h10v-6h1.58c1.34 0 2.42-1.08 2.42-2.42v-.01c0-.95-.56-1.82-1.44-2.21zM18.58 14H17v-1H7v1H5.42c-.23 0-.42-.19-.42-.43 0-.17.1-.32.25-.38l6.75-3 6.75 3a.423.423 0 01-.17.81z"
                }
            }
        ]
    })(props);
}
function MdEditAttributes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zM7.24 14.46l-2.57-2.57.7-.7 1.87 1.87 3.52-3.52.7.7-4.22 4.22z"
                }
            }
        ]
    })(props);
}
function MdEditLocationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.95 13H9V8.05l5.61-5.61A8.17 8.17 0 0012 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-1.01-.16-1.94-.45-2.8l-5.6 5.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2.12l6.16-6.16-2.12-2.12L11 8.88zM20.71 2L20 1.29c-.2-.19-.45-.29-.71-.29-.13 0-.48.07-.71.29l-.72.72 2.12 2.12.72-.72c.4-.39.4-1.02.01-1.41z"
                }
            }
        ]
    })(props);
}
function MdEditLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7a.38.38 0 01.54 0l.9.9c.15.15.15.39 0 .54z"
                }
            }
        ]
    })(props);
}
function MdEditRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h-2v7.9l2-2zM4 4h2v16H4zM10 4h2v4h-2zM10 10h2v4h-2zM10 16h2v4h-2zM22.56 12.59l-1.15-1.15a1.49 1.49 0 00-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45z"
                }
            }
        ]
    })(props);
}
function MdEggAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9c-2-2-3.01-7-9.03-7C4.95 2 1.94 6 2 11.52 2.06 17.04 6.96 19 9.97 19c2.01 0 2.01 3 6.02 3C19 22 22 19 22 15.02 22 12 21.01 11 19 9zm-7 6.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C8.5 3 5 9.33 5 14c0 3.87 3.13 7 7 7s7-3.13 7-7c0-4.67-3.5-11-7-11zm1 15c-3 0-5-1.99-5-5 0-.55.45-1 1-1s1 .45 1 1c0 2.92 2.42 3 3 3 .55 0 1 .45 1 1s-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdElectricBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-.82l-1.7-4.68A2.008 2.008 0 0014.6 1H12v2h2.6l1.46 4h-4.81l-.36-1H12V4H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 6.87 0 9.2 0 12c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 9.2 21.8 7 19 7zM7.82 13c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.02 0 .05-.01.08-.01 1.68 0 3 1.32 3 3s-1.32 3-3 3zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function MdElectricCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 2.01C18.72 1.42 18.16 1 17.5 1h-11c-.66 0-1.21.42-1.42 1.01L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8l-2.08-5.99zM6.5 12c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm11 0c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 7l1.5-4.5h11L19 7H5zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function MdElectricMoped(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 12H10V7H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 8.35V5zM7 15c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h5v2H5zM19 11c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function MdElectricRickshaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.18V9.72c0-.47-.16-.92-.46-1.28L16.6 3.72c-.38-.46-.94-.72-1.54-.72H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h.18C3.6 16.16 4.7 17 6 17s2.4-.84 2.82-2h8.37a2.996 2.996 0 005.82-1c-.01-1.3-.85-2.4-2.01-2.82zM18.4 9H16V6.12L18.4 9zM3 5h4v4H3V5zm3 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3-2v-2h3V9H9V5h5v8H9zm11 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function MdElectricScooter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.82 16H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0015.89 1H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0013.09 14H7.82a2.996 2.996 0 00-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 005 18c1.3 0 2.4-.84 2.82-2zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function MdElectricalServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zM20 17h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zM12 14h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function MdEmergencyRecording(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM12 12l3 1.73-1 1.73-3-1.73V17H9v-3.27l-3 1.73-1-1.73L8 12l-3-1.73 1-1.73 3 1.73V7h2v3.27l3-1.73 1 1.73L12 12z"
                }
            }
        ]
    })(props);
}
function MdEmergencyShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-3.15 0-6 2.41-6 6.15 0 2.49 2 5.44 6 8.85 4-3.41 6-6.36 6-8.85C18 11.41 15.15 9 12 9zm0 7.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41a5.022 5.022 0 00-7.08 0L7.05 6.05A6.976 6.976 0 0112 4zm7.78-.77l-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23z"
                }
            }
        ]
    })(props);
}
function MdEmergency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.79 9.23l-2-3.46L14 8.54V3h-4v5.54L5.21 5.77l-2 3.46L8 12l-4.79 2.77 2 3.46L10 15.46V21h4v-5.54l4.79 2.77 2-3.46L16 12z"
                }
            }
        ]
    })(props);
}
function MdEvStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
                }
            }
        ]
    })(props);
}
function MdFactory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v12H2V10l7-3v2l5-2v3h8zm-4.8-1.5L18 2h3l.8 6.5h-4.6zM11 18h2v-4h-2v4zm-4 0h2v-4H7v4zm10-4h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function MdFastfood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.06 22.99h1.66c.84 0 1.53-.64 1.63-1.46L23 5.05h-5V1h-1.97v4.05h-4.97l.3 2.34c1.71.47 3.31 1.32 4.27 2.26 1.44 1.42 2.43 2.89 2.43 5.29v8.05zM1 21.99V21h15.03v.99c0 .55-.45 1-1.01 1H2.01c-.56 0-1.01-.45-1.01-1zm15.03-7c0-8-15.03-8-15.03 0h15.03zM1.02 17h15v2h-15z"
                }
            }
        ]
    })(props);
}
function MdFestival(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.7V4h3l-1-1.49L16 1h-5v4.7L2 12v10h7v-5l3.03-2L15 17v5h7V12z"
                }
            }
        ]
    })(props);
}
function MdFireHydrantAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-1V8h2V6h-2.35a5.99 5.99 0 00-11.3 0H4v2h2v3H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v3H4v2h16v-2h-2v-3h1c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm-7 6.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdFireTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.9 10.69l-1.44-4.32A2.01 2.01 0 0019.56 5H19V4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-2c-1.1 0-2 .9-2 2v4H1v5c0 1.1.9 2 2 2h1c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h3v-6.68c0-.21-.03-.42-.1-.63zM7 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-3-8V7h5.56l1.33 4H14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.5h-1v-2h1V5H1v1.5h1v2H1V10h10V8.5zm-5.75 0H3.5v-2h1.75v2zm3.25 0H6.75v-2H8.5v2z"
                }
            }
        ]
    })(props);
}
function MdFlightClass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.5 16H18v2H9.49c-.88 0-1.66-.58-1.92-1.43L5 8V4h2v4l2.5 8zM8 19h10v2H8v-2z"
                }
            }
        ]
    })(props);
}
function MdFlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
                }
            }
        ]
    })(props);
}
function MdForest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 12L9 2 2 12h1.86L0 18h7v4h4v-4h7l-3.86-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.14 12H22L15 2l-2.39 3.41L17.92 13h-1.95l3.22 5H24zM13 19h4v3h-4z"
                }
            }
        ]
    })(props);
}
function MdForkLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.41 15.59L8 17l-4-4 4-4 1.41 1.41L7.83 12c1.51-.33 3.73.08 5.17 1.36V6.83l-1.59 1.59L10 7l4-4 4 4-1.41 1.41L15 6.83V21h-2v-4c-.73-2.58-3.07-3.47-5.17-3l1.58 1.59z"
                }
            }
        ]
    })(props);
}
function MdForkRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 15.59L16 17l4-4-4-4-1.41 1.41L16.17 12c-1.51-.33-3.73.08-5.17 1.36V6.83l1.59 1.59L14 7l-4-4-4 4 1.41 1.41L9 6.83V21h2v-4c.73-2.58 3.07-3.47 5.17-3l-1.58 1.59z"
                }
            }
        ]
    })(props);
}
function MdFort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v2h-2V3h-2v2h-2V3h-2v4l2 2v1H9V9l2-2V3H9v2H7V3H5v2H3V3H1v4l2 2v6l-2 2v4h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9v-4l-2-2V9l2-2V3h-2z"
                }
            }
        ]
    })(props);
}
function MdHail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5-4h2v.4c-.1 2.2-.8 3.9-2.3 5.1-.5.4-1.1.7-1.7.9V22h-2v-6h-2v6H9V10.1c-.3.1-.5.2-.6.3-.9.7-1.39 1.6-1.4 3.1v.5H5v-.5c0-2 .71-3.59 2.11-4.79C8.21 7.81 10 7 12 7s2.68-.46 3.48-1.06C16.48 5.14 17 4 17 2.5V2zM4 16h3v6H4v-6z"
                }
            }
        ]
    })(props);
}
function MdHandyman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.67 18.17l-5.3-5.3h-.99l-2.54 2.54v.99l5.3 5.3c.39.39 1.02.39 1.41 0l2.12-2.12a.996.996 0 000-1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 10.19l1.41-1.41 2.12 2.12a3 3 0 000-4.24l-3.54-3.54-1.41 1.41V1.71l-.7-.71-3.54 3.54.71.71h2.83l-1.41 1.41 1.06 1.06-2.89 2.89-4.13-4.13V5.06L4.83 2.04 2 4.87 5.03 7.9h1.41l4.13 4.13-.85.85H7.6l-5.3 5.3a.996.996 0 000 1.41l2.12 2.12c.39.39 1.02.39 1.41 0l5.3-5.3v-2.12l5.15-5.15 1.06 1.05z"
                }
            }
        ]
    })(props);
}
function MdHardware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3l-3 3V3H9C6.24 3 4 5.24 4 8h5v3h6V8l3 3h2V3h-2zM9 13v7c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-7H9z"
                }
            }
        ]
    })(props);
}
function MdHomeRepairService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16h-2v-1H8v1H6v-1H2v5h20v-5h-4zM20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v4h4v-2h2v2h8v-2h2v2h4v-4c0-1.1-.9-2-2-2zm-5 0H9V6h6v2z"
                }
            }
        ]
    })(props);
}
function MdHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdHvac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c1.01 0 1.91-.39 2.62-1H9.38c.71.61 1.61 1 2.62 1zM8.56 14h6.89c.26-.45.44-.96.51-1.5h-7.9c.06.54.23 1.05.5 1.5zM12 8c-1.01 0-1.91.39-2.62 1h5.24c-.71-.61-1.61-1-2.62-1zM8.56 10c-.26.45-.44.96-.51 1.5h7.9c-.07-.54-.24-1.05-.51-1.5H8.56z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 15c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdIcecream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M8.79 12.4l3.26 6.22 3.17-6.21c-.11-.08-.21-.16-.3-.25-.84.53-1.85.84-2.92.84s-2.08-.31-2.92-.84c-.09.09-.19.17-.29.24zm-1.96.59A2.995 2.995 0 014 10a3 3 0 012.52-2.96C6.75 4.22 9.12 2 12 2s5.25 2.22 5.48 5.04A3 3 0 0120 10c0 1.59-1.24 2.9-2.81 2.99L12.07 23 6.83 12.99z"
                }
            }
        ]
    })(props);
}
function MdKebabDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75 8H11v5H7.75v1h.75a2.5 2.5 0 010 5h-.75v4h-1.5v-4H5.5a2.5 2.5 0 010-5h.75v-1H3V8h3.25V7H5.5a2.5 2.5 0 010-5h.75V1h1.5v1h.75a2.5 2.5 0 010 5h-.75v1zm10-1h.75a2.5 2.5 0 000-5h-.75V1h-1.5v1h-.75a2.5 2.5 0 000 5h.75v1H13v5h3.25v1h-.75a2.5 2.5 0 000 5h.75v4h1.5v-4h.75a2.5 2.5 0 000-5h-.75v-1H21V8h-3.25V7z"
                }
            }
        ]
    })(props);
}
function MdLayersClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
                }
            }
        ]
    })(props);
}
function MdLayers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
                }
            }
        ]
    })(props);
}
function MdLiquor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14c0 1.3.84 2.4 2 2.82V20H3v2h6v-2H7v-3.18C8.16 16.4 9 15.3 9 14V6H3v8zm2-6h2v3H5V8zM20.63 8.54l-.95-.32a.991.991 0 01-.68-.94V3c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4.28c0 .43-.28.81-.68.95l-.95.32c-.82.27-1.37 1.03-1.37 1.89V20c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-9.56c0-.86-.55-1.62-1.37-1.9zM16 4h1v1h-1V4zm-3 6.44l.95-.32C15.18 9.72 16 8.57 16 7.28V7h1v.28a3 3 0 002.05 2.85l.95.31V12h-7v-1.56zM20 20h-7v-2h7v2z"
                }
            }
        ]
    })(props);
}
function MdLocalActivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
                }
            }
        ]
    })(props);
}
function MdLocalAirport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdLocalAtm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdLocalBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
                }
            }
        ]
    })(props);
}
function MdLocalCafe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function MdLocalCarWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z"
                }
            }
        ]
    })(props);
}
function MdLocalConvenienceStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
                }
            }
        ]
    })(props);
}
function MdLocalDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function MdLocalDrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
                }
            }
        ]
    })(props);
}
function MdLocalFireDepartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.9l-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07L12 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52z"
                }
            }
        ]
    })(props);
}
function MdLocalFlorist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22a9 9 0 009-9 9 9 0 00-9 9zM5.6 10.25a2.5 2.5 0 003.92 2.06l-.02.19a2.5 2.5 0 005 0l-.02-.19c.4.28.89.44 1.42.44a2.5 2.5 0 002.5-2.5c0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25a2.5 2.5 0 00-3.92-2.06l.02-.19a2.5 2.5 0 00-5 0l.02.19c-.4-.28-.89-.44-1.42-.44a2.5 2.5 0 00-2.5 2.5c0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5a2.5 2.5 0 010 5 2.5 2.5 0 010-5zM3 13a9 9 0 009 9 9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function MdLocalGasStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdLocalGroceryStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1.003 1.003 0 0020 4H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdLocalHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
                }
            }
        ]
    })(props);
}
function MdLocalHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdLocalLaundryService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 16.83a4.008 4.008 0 005.66 0 4.008 4.008 0 000-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdLocalLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
                }
            }
        ]
    })(props);
}
function MdLocalMall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdLocalMovies(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdLocalOffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
                }
            }
        ]
    })(props);
}
function MdLocalParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdLocalPharmacy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdLocalPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
                }
            }
        ]
    })(props);
}
function MdLocalPizza(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdLocalPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
                }
            }
        ]
    })(props);
}
function MdLocalPolice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm2.5 11.59l.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59z"
                }
            }
        ]
    })(props);
}
function MdLocalPostOffice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                }
            }
        ]
    })(props);
}
function MdLocalPrintshop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
                }
            }
        ]
    })(props);
}
function MdLocalSee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdLocalShipping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdLocalTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
                }
            }
        ]
    })(props);
}
function MdLocationPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 1.74.5 3.37 1.41 4.84.95 1.54 2.2 2.86 3.16 4.4.47.75.81 1.45 1.17 2.26.26.55.47 1.5 1.26 1.5s1-.95 1.25-1.5c.37-.81.7-1.51 1.17-2.26.96-1.53 2.21-2.85 3.16-4.4C18.5 12.37 19 10.74 19 9c0-3.87-3.13-7-7-7zm0 9.75a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdLunchDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M22 10c.32-3.28-4.28-6-9.99-6S1.7 6.72 2.02 10H22zM5.35 13.5c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.63 2.17.64v-1.98s-.79-.16-1.16-.38c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.21-.64.37-.23.59-.36 1.14-.36zM2 16v2c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-2H2z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function MdMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
                }
            }
        ]
    })(props);
}
function MdMapsUgc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M12 2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97c1.31.61 2.75.97 4.29.97 5.52 0 10-4.48 10-10S17.52 2 12 2zm4 11h-3v3h-2v-3H8v-2h3V8h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdMedicalInformation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9-3h2v5h-2V4zm0 12H9v2H7v-2H5v-2h2v-2h2v2h2v2zm2-1.5V13h6v1.5h-6zm0 3V16h4v1.5h-4z"
                }
            }
        ]
    })(props);
}
function MdMedicalServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm6 11h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdMenuBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
                }
            }
        ]
    })(props);
}
function MdMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 21L5 19.59l4.83-4.83c.75-.75 1.17-1.77 1.17-2.83v-5.1L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83v5.1c0 1.06.42 2.08 1.17 2.83L19 19.59 17.59 21 12 15.41 6.41 21z"
                }
            }
        ]
    })(props);
}
function MdMinorCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM9.41 5L8 6.41l-3-3L6.41 2l3 3zM16 6.41L14.59 5l3-3L19 3.41l-3 3zM13 5h-2V0h2v5z"
                }
            }
        ]
    })(props);
}
function MdMiscellaneousServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.17 13.71l1.4-2.42c.09-.15.05-.34-.08-.45l-1.48-1.16c.03-.22.05-.45.05-.68s-.02-.46-.05-.69l1.48-1.16c.13-.11.17-.3.08-.45l-1.4-2.42c-.09-.15-.27-.21-.43-.15l-1.74.7c-.36-.28-.75-.51-1.18-.69l-.26-1.85a.364.364 0 00-.35-.29h-2.8c-.17 0-.32.13-.35.3L6.8 4.15c-.42.18-.82.41-1.18.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.42c-.09.15-.05.34.08.45l1.48 1.16c-.03.22-.05.45-.05.68s.02.46.05.69l-1.48 1.16c-.13.11-.17.3-.08.45l1.4 2.42c.09.15.27.21.43.15l1.74-.7c.36.28.75.51 1.18.69l.26 1.85c.03.16.18.29.35.29h2.8c.17 0 .32-.13.35-.3l.26-1.85c.42-.18.82-.41 1.18-.69l1.74.7c.16.06.34 0 .43-.15zM8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM21.92 18.67l-.96-.74c.02-.14.04-.29.04-.44 0-.15-.01-.3-.04-.44l.95-.74c.08-.07.11-.19.05-.29l-.9-1.55c-.05-.1-.17-.13-.28-.1l-1.11.45c-.23-.18-.48-.33-.76-.44l-.17-1.18a.216.216 0 00-.21-.2h-1.79c-.11 0-.21.08-.22.19l-.17 1.18c-.27.12-.53.26-.76.44l-1.11-.45a.23.23 0 00-.28.1l-.9 1.55c-.05.1-.04.22.05.29l.95.74a3.145 3.145 0 000 .88l-.95.74c-.08.07-.11.19-.05.29l.9 1.55c.05.1.17.13.28.1l1.11-.45c.23.18.48.33.76.44l.17 1.18c.02.11.11.19.22.19h1.79c.11 0 .21-.08.22-.19l.17-1.18c.27-.12.53-.26.75-.44l1.12.45c.1.04.22 0 .28-.1l.9-1.55c.06-.09.03-.21-.05-.28zm-4.29.16a1.35 1.35 0 11.001-2.701 1.35 1.35 0 01-.001 2.701z"
                }
            }
        ]
    })(props);
}
function MdModeOfTravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.31 18.9c-.96 1-2.06 2.03-3.31 3.1-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2c4 0 7.64 2.92 7.97 7.5h3.53L19 14l-4.5-4.5h3.47C17.65 6.24 15.13 4 12 4c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14.64-.59 1.23-1.16 1.77-1.71a2.5 2.5 0 01-.27-1.12 2.5 2.5 0 015 0 2.492 2.492 0 01-3.19 2.39z"
                }
            }
        ]
    })(props);
}
function MdMoney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8h2v8H5zm7 0H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4zm7-6h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 6h-1v-4h1v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M4 6h16v12H4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm2 14V6h16v12H4z"
                }
            }
        ]
    })(props);
}
function MdMoped(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM7 17c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdMosque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8h10c.29 0 .57.06.84.13.09-.33.16-.67.16-1.04 0-1.31-.65-2.53-1.74-3.25L12 1 7.74 3.84A3.887 3.887 0 006 7.09c0 .37.07.71.16 1.04.27-.07.55-.13.84-.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 7c0-1.1-2-3-2-3s-2 1.9-2 3c0 .74.4 1.38 1 1.72V13h-2v-2c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v2H3V8.72c.6-.34 1-.98 1-1.72 0-1.1-2-3-2-3S0 5.9 0 7c0 .74.4 1.38 1 1.72V21h9v-4c0-1.1.9-2 2-2s2 .9 2 2v4h9V8.72c.6-.34 1-.98 1-1.72z"
                }
            }
        ]
    })(props);
}
function MdMoving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.71 9.71L22 12V6h-6l2.29 2.29-4.17 4.17a.996.996 0 01-1.41 0l-1.17-1.17a3 3 0 00-4.24 0L2 16.59 3.41 18l5.29-5.29a.996.996 0 011.41 0l1.17 1.17a3 3 0 004.24 0l4.19-4.17z"
                }
            }
        ]
    })(props);
}
function MdMultipleStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4l4 4-4 4V9h-4V7h4V4zm-7 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm1 10h4v-2H7v-3l-4 4 4 4v-3zm7 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdMuseum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-6 7h-2v-4l-2 3-2-3v4H8v-7h2l2 3 2-3h2v7z"
                }
            }
        ]
    })(props);
}
function MdMyLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdNavigation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
                }
            }
        ]
    })(props);
}
function MdNearMeDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.34L21 3l-3.34 9L12 6.34zm10.61 13.44L4.22 1.39 2.81 2.81l5.07 5.07L3 9.69v1.41l7.07 2.83L12.9 21h1.41l1.81-4.88 5.07 5.07 1.42-1.41z"
                }
            }
        ]
    })(props);
}
function MdNearMe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
                }
            }
        ]
    })(props);
}
function MdNightlife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h14l-6 9v4h2v2H5v-2h2v-4L1 5zm9.1 4l1.4-2H4.49l1.4 2h4.21zM17 5h5v3h-3v9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3a3 3 0 011 .17V5z"
                }
            }
        ]
    })(props);
}
function MdNoCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM12 6.36L9.17 3.54l1.41-1.41L12 3.54 15.54 0l1.41 1.41L12 6.36z"
                }
            }
        ]
    })(props);
}
function MdNoMealsOuline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V6c0-1.76 2.24-4 5-4v16.17l-2-2V14h-3zm4.49 9.31L10.02 12.85c-.33.09-.66.15-1.02.15v9H7v-9c-2.21 0-4-1.79-4-4V5.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM6.17 9L5 7.83V9h1.17zM9 2H7v2.17l2 2V2zm4 7V2h-2v6.17l1.85 1.85c.09-.33.15-.66.15-1.02z"
                }
            }
        ]
    })(props);
}
function MdNoMeals(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V6c0-1.76 2.24-4 5-4v16.17l-2-2V14h-3zm4.49 9.31L10.02 12.85c-.33.09-.66.15-1.02.15v9H7v-9c-2.21 0-4-1.79-4-4V5.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM6.17 9L5 7.83V9h1.17zM9 2H7v2.17l2 2V2zm4 7V2h-2v6.17l1.85 1.85c.09-.33.15-.66.15-1.02z"
                }
            }
        ]
    })(props);
}
function MdNoTransfer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 4 6.83V16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.05 0 .09-.02.14-.03l1.64 1.64 1.41-1.42zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zM6 11V8.83L8.17 11H6zm2.83-5L5.78 2.95C7.24 2.16 9.48 2 12 2c4.42 0 8 .5 8 4v10c0 .35-.08.67-.19.98L13.83 11H18V6H8.83z"
                }
            }
        ]
    })(props);
}
function MdNotListedLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm.88 13.75h-1.75V14h1.75v1.75zm0-2.87h-1.75c0-2.84 2.62-2.62 2.62-4.38 0-.96-.79-1.75-1.75-1.75s-1.75.79-1.75 1.75H8.5C8.5 6.57 10.07 5 12 5s3.5 1.57 3.5 3.5c0 2.19-2.62 2.41-2.62 4.38z"
                }
            }
        ]
    })(props);
}
function MdPark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.96v-4H21z"
                }
            }
        ]
    })(props);
}
function MdPedalBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.18 10l-1.7-4.68A2.008 2.008 0 0014.6 4H12v2h2.6l1.46 4h-4.81l-.36-1H12V7H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 9.87 0 12.2 0 15c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5 0-2.8-2.2-5-5-5h-.82zM7.82 16c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            }
        ]
    })(props);
}
function MdPersonPinCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2a2 2 0 11.001 4.001A2 2 0 0112 4zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05A4.783 4.783 0 0112 14z"
                }
            }
        ]
    })(props);
}
function MdPersonPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a9 9 0 00-9 9c0 4.17 2.84 7.67 6.69 8.69L12 22l2.31-2.31C18.16 18.67 21 15.17 21 11a9 9 0 00-9-9zm0 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.3a7.2 7.2 0 01-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 01-6 3.22z"
                }
            }
        ]
    })(props);
}
function MdPestControlRodent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.31 17.38l-2.39-2.13c.52-2.36-1.36-4.25-3.42-4.25-1.16 0-3.5.9-3.5 3.5 0 .97.39 1.84 1.03 2.47l-.71.71A4.457 4.457 0 0111 14.5c0-1.7.96-3.17 2.35-3.93a5 5 0 00-2.28-.57c-2.38 0-4.37 1.65-4.91 3.87A2.997 2.997 0 014 11c0-1.66 1.34-3 3-3h2.5a2.5 2.5 0 000-5H8c-.55 0-1 .45-1 1s.45 1 1 1h1.5c.28 0 .5.22.5.5s-.22.5-.5.5H7a5.002 5.002 0 00-1 9.9v.03C6 18.73 8.27 21 11.07 21h8.86c1.87 0 2.81-2.34 1.38-3.62zM18 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdPestControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v-2h-3.07c-.05-.39-.12-.77-.22-1.14l2.58-1.49-1-1.73L16.92 10c-.28-.48-.62-.91-.99-1.29.04-.23.07-.46.07-.71 0-.8-.24-1.55-.65-2.18L17 4.17l-1.41-1.41-1.72 1.72c-1.68-.89-3.1-.33-3.73 0L8.41 2.76 7 4.17l1.65 1.65A3.99 3.99 0 008 8c0 .25.03.48.07.72-.37.38-.71.81-.99 1.28L4.71 8.63l-1 1.73 2.58 1.49c-.1.37-.17.75-.22 1.14H3v2h3.07c.05.39.12.77.22 1.14l-2.58 1.49 1 1.73L7.08 18c1.08 1.81 2.88 3 4.92 3s3.84-1.19 4.92-3l2.37 1.37 1-1.73-2.58-1.49c.1-.37.17-.75.22-1.14H21zm-8 2h-2v-6h2v6z"
                }
            }
        ]
    })(props);
}
function MdPinDrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 11-4 0zM5 20v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function MdPlace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdPlumbing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.28 4.93l-2.12-2.12c-.78-.78-2.05-.78-2.83 0L11.5 5.64l2.12 2.12 2.12-2.12 3.54 3.54a3.012 3.012 0 000-4.25zM5.49 13.77c.59.59 1.54.59 2.12 0l2.47-2.47-2.12-2.13-2.47 2.47c-.59.59-.59 1.54 0 2.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.04 7.76l-.71.71-.71.71L10.44 6c-.59-.6-1.54-.6-2.12-.01a1.49 1.49 0 000 2.12l3.18 3.18-.71.71-6.36 6.36c-.78.78-.78 2.05 0 2.83.78.78 2.05.78 2.83 0L16.45 12a.996.996 0 101.41-1.41l-2.82-2.83z"
                }
            }
        ]
    })(props);
}
function MdRailwayAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8a7 7 0 00-11.95-4.95A33.8 33.8 0 009 3c-4.42 0-8 .5-8 4v10.5A3.5 3.5 0 004.5 21L3 22.5v.5h12v-.5L13.5 21a3.5 3.5 0 003.5-3.5v-2.58A7 7 0 0023 8zM3 12V7h6.08a6.96 6.96 0 001.18 5H3zm6 7c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm7.71-6.06l-.2.03L16 13l-.47-.02-.16-.02-.29-.04-.2-.04-.22-.06a1.55 1.55 0 01-.23-.07l-.13-.05A4.99 4.99 0 0111.1 7c.04-.19.09-.37.15-.54l.05-.14.15-.38.07-.15.2-.36.07-.12.3-.42.02-.02c.24-.3.52-.57.82-.81l.01-.01.46-.32.03-.02A5.25 5.25 0 0116 3a5 5 0 01.71 9.94zM15 4h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdRamenDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6H8V4.65l1-.12V6zm0 6H8V7h1v5zM6 7h1v5H6V7zm0-2.12l1-.12V6H6V4.88zM22 3V2L5 4v8H2c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25H10V7h12V6H10V4.41L22 3z"
                }
            }
        ]
    })(props);
}
function MdRampLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21h-2V6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V9c0 4.27 4.03 7.13 6 8.27l-1.46 1.46c-1.91-1.16-3.44-2.53-4.54-4.02V21z"
                }
            }
        ]
    })(props);
}
function MdRampRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2V6.83l1.59 1.59L16 7l-4-4-4 4 1.41 1.41L11 6.83V9c0 4.27-4.03 7.13-6 8.27l1.46 1.46C8.37 17.56 9.9 16.19 11 14.7V21z"
                }
            }
        ]
    })(props);
}
function MdRateReview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm15.35 6.41l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l6.88-6.88c.2-.19.2-.51 0-.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
                }
            }
        ]
    })(props);
}
function MdRemoveRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2zM22.5 16.41L21.09 15 19 17.09 16.91 15l-1.41 1.41 2.09 2.09-2.09 2.09L16.91 22 19 19.91 21.09 22l1.41-1.41-2.09-2.09z"
                }
            }
        ]
    })(props);
}
function MdRestaurantMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function MdRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
                }
            }
        ]
    })(props);
}
function MdRoundaboutLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.08 8A6 6 0 0116 3c3.31 0 6 2.69 6 6 0 2.97-2.16 5.44-5 5.92V21h-2v-6.09c0-.98.71-1.8 1.67-1.97a3.999 3.999 0 10-4.61-4.61c-.17.96-.99 1.67-1.97 1.67H5.83l1.59 1.59L6 13 2 9l4-4 1.41 1.41L5.83 8h4.25z"
                }
            }
        ]
    })(props);
}
function MdRoundaboutRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 8C13.44 5.16 10.97 3 8 3 4.69 3 2 5.69 2 9c0 2.97 2.16 5.44 5 5.92V21h2v-6.09c0-.98-.71-1.8-1.67-1.97a3.999 3.999 0 114.61-4.61c.17.96.99 1.67 1.97 1.67h4.26l-1.59 1.59L18 13l4-4-4-4-1.41 1.41L18.17 8h-4.25z"
                }
            }
        ]
    })(props);
}
function MdRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18A2.996 2.996 0 0018 21c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82z"
                }
            }
        ]
    })(props);
}
function MdRunCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.5 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.5 6c-.7 0-2.01-.54-2.91-1.76l-.41 2.35L14 14.03V18h-1v-3.58l-1.11-1.21-.52 2.64-3.77-.77.2-.98 2.78.57.96-4.89-1.54.57V12H9V9.65l3.28-1.21c.49-.18 1.03.06 1.26.53.83 1.7 2.05 2.03 2.46 2.03v1z"
                }
            }
        ]
    })(props);
}
function MdSafetyCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm0 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm1.65-2.65L11.5 12.2V9h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function MdSailing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13.5V2L3 13.5h8zm10 0C21 6.5 14.5 1 12.5 1c0 0 1 3 1 6.5s-1 6-1 6H21zm1 1.5H2a6.233 6.233 0 002.33 3.73c.65-.27 1.22-.72 1.67-1.23.73.84 1.8 1.5 3 1.5s2.27-.66 3-1.5c.73.84 1.8 1.5 3 1.5s2.26-.66 3-1.5c.45.51 1.02.96 1.67 1.23 1.17-.89 2.02-2.2 2.33-3.73zm0 8v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1z"
                }
            }
        ]
    })(props);
}
function MdSatellite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
                }
            }
        ]
    })(props);
}
function MdScreenRotationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7.59l5-5c.78-.78 2.05-.78 2.83 0L20.24 11h-2.83L10.4 4 5.41 9H8v2H2V5h2v2.59zM20 19h2v-6h-6v2h2.59l-4.99 5-7.01-7H3.76l8.41 8.41c.78.78 2.05.78 2.83 0l5-5V19z"
                }
            }
        ]
    })(props);
}
function MdSetMeal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.05 17.56l-17.97.94L3 17l17.98-.94.07 1.5zM21 19.48H3v1.5h18v-1.5zM22 5v7c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-2 1c-1.68 0-3.04.98-3.21 2.23-.64-.73-2.73-2.73-6.54-2.73-4.67 0-6.75 3-6.75 3s2.08 3 6.75 3c3.81 0 5.9-2 6.54-2.73C16.96 10.02 18.32 11 20 11V6z"
                }
            }
        ]
    })(props);
}
function MdSignpost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h5l3-3-3-3h-5V2h-2v2H4v6h7v2H6l-3 3 3 3h5v4h2v-4h7v-6h-7z"
                }
            }
        ]
    })(props);
}
function MdSnowmobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17c0 .55-.45 1-1 1h-.17l-2.2-2.2C20.58 15.37 22 14.4 22 13c0-1-8-8-8-8h-3v2h2.25l1.45 1.3L11 11l-9.5-1L0 13l4.54 1.36-3.49 1.88C-.77 17.22-.07 20 2 20h6c2.21 0 4-1.79 4-4h4l2 2h-3v2h6c1.66 0 3-1.34 3-3h-2zM8 18H2l5.25-2.83L10 16a2 2 0 01-2 2z"
                }
            }
        ]
    })(props);
}
function MdSos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8h-3V9h3v6zM1 15h4v-2H3c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2H3v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H1v-2zm16 0h4v-2h-2c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2h-4v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-4v-2z"
                }
            }
        ]
    })(props);
}
function MdSoupKitchen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.4 7c-.34.55-.4.97-.4 1.38C6 9.15 7 11 7 12c0 .95-.4 1.5-.4 1.5H5.1s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h1.5zm5 0c-.34.55-.4.97-.4 1.38 0 .77 1 2.62 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zM8.15 7c-.34.55-.4.97-.4 1.38 0 .77 1 2.63 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zm13.32-.5s.13-1.06.13-1.5c0-1.65-1.35-3-3-3-1.54 0-2.81 1.16-2.98 2.65L14.53 15H4.01c-.6 0-1.09.53-1 1.13C3.53 19.46 6.39 22 9.75 22c3.48 0 6.34-2.73 6.71-6.23L17.61 4.9c.05-.51.47-.9.99-.9.55 0 1 .45 1 1 0 .3-.1 1.25-.1 1.25l1.97.25z"
                }
            }
        ]
    })(props);
}
function MdStadium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5L3 7V3l4 2zm11-2v4l4-2-4-2zm-7-1v4l4-2-4-2zm-6 8.04c1.38.49 3.77.96 7 .96s5.62-.47 7-.96C19 9.86 16.22 9 12 9s-7 .86-7 1.04zM15 17H9v4.88c-4.06-.39-7-1.54-7-2.88v-9c0-1.66 4.48-3 10-3s10 1.34 10 3v9c0 1.34-2.94 2.48-7 2.87V17z"
                }
            }
        ]
    })(props);
}
function MdStoreMallDirectory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
                }
            }
        ]
    })(props);
}
function MdStraight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z"
                }
            }
        ]
    })(props);
}
function MdStreetview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82A6.435 6.435 0 0111.5 6z"
                }
            }
        ]
    })(props);
}
function MdSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0v24h24V0H0zm22 22H2V8.86C2 6.05 3.53 3.84 6.2 2.8 8 2.09 10.14 2 12 2c1.86 0 4 .09 5.8.8C20.47 3.84 22 6.05 22 8.86V22z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"
                }
            }
        ]
    })(props);
}
function MdSynagogue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8v13h4v-5c0-1.1.9-2 2-2s2 .9 2 2v5h4V8l-6-5-6 5zm7.5 2c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM3 5c-1.1 0-2 .9-2 2v1h4V7c0-1.1-.9-2-2-2zM1 9h4v12H1zM21 5c-1.1 0-2 .9-2 2v1h4V7c0-1.1-.9-2-2-2zM19 9h4v12h-4z"
                }
            }
        ]
    })(props);
}
function MdTakeoutDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M5.26 11h13.48l-.67 9H5.93l-.67-9zm3.76-7h5.95L19 7.38l1.59-1.59L22 7.21 19.21 10H4.79L2 7.21 3.41 5.8 5 7.38 9.02 4z"
                }
            }
        ]
    })(props);
}
function MdTaxiAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8A7 7 0 009.68 5H7v2H4.5a1.5 1.5 0 00-1.42 1.01L1 14v8a1 1 0 001 1h1a1 1 0 001-1v-1h12v1a1 1 0 001 1h1a1 1 0 001-1v-7.68A7.01 7.01 0 0023 8zm-18.5.5h4.53a6.93 6.93 0 002.08 4.5H3l1.5-4.5zm0 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm11 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm2.93-5.63l-.21.11-.18.09a4.97 4.97 0 01-.42.16l-.22.07-.23.06-.2.05a5 5 0 01-5.94-4.41A4.07 4.07 0 0111 8l.02-.47.02-.17.04-.28.04-.21.05-.21.07-.24.05-.13a4.99 4.99 0 019.69 1.7 4.96 4.96 0 01-2.55 4.38zM15 4h2v5h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdTempleBuddhist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9.02c0 1.09-.89 1.98-1.98 1.98H4.98C3.89 11 3 10.11 3 9.02H1c0 1.86 1.28 3.4 3 3.84V22h6v-3c0-1.1.9-2 2-2s2 .9 2 2v3h6v-9.14c.55-.14 3-1.04 3-3.86l-2 .02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.86V10h12V8.86c.55-.14 3-1.04 3-3.86l-2 .02C19 6.11 18.11 7 17.02 7H6.98C5.89 7 5 6.11 5 5.02H3c0 1.85 1.28 3.4 3 3.84z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L8.25 6h7.5z"
                }
            }
        ]
    })(props);
}
function MdTempleHindu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.6 11h10.8l-.9-3h-9zM20 11v2H4v-2H2v11h8v-5h4v5h8V11zM15.9 6L15 3V1h-2v2h-2.03V1h-2v2.12L8.1 6z"
                }
            }
        ]
    })(props);
}
function MdTerrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
                }
            }
        ]
    })(props);
}
function MdTheaterComedy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5C2 19.54 4.46 22 7.5 22s5.5-2.46 5.5-5.5V10H2v6.5zm5.5 2C6.12 18.5 5 17.83 5 17h5c0 .83-1.12 1.5-2.5 1.5zM10 13c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-5 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 3v6h3v2.5c0-.83 1.12-1.5 2.5-1.5s2.5.67 2.5 1.5h-5v2.89c.75.38 1.6.61 2.5.61 3.04 0 5.5-2.46 5.5-5.5V3H11zm3 5.08c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1c0 .56-.45 1-1 1zm5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1c0 .56-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdTireRepair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7a1.003 1.003 0 001.71.71c.4-.4 1.04-2.46 1.04-2.46s-2.06.64-2.46 1.04c-.18.18-.29.43-.29.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2c-2.76 0-5 2.24-5 5 0 2.05 1.23 3.81 3 4.58V13h1v5c0 .55-.45 1-1 1s-1-.45-1-1v-2a3.009 3.009 0 00-4-2.83V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-3c0-.55.45-1 1-1s1 .45 1 1v2c0 1.65 1.35 3 3 3s3-1.35 3-3v-5h1v-1.42c1.77-.77 3-2.53 3-4.58 0-2.76-2.24-5-5-5zM6 19.5l-2-2v-2.83l2 2v2.83zm0-5l-2-2V9.67l2 2v2.83zm0-5l-2-2V4.67l2 2V9.5zm4 8l-2 2v-2.83l2-2v2.83zm0-5l-2 2v-2.83l2-2v2.83zm0-5l-2 2V6.67l2-2V7.5zm9 2.5c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdTraffic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9a2 2 0 11-.001-3.999A2 2 0 0112 19zm0-5a2 2 0 11-.001-3.999A2 2 0 0112 14zm0-5a2 2 0 01-2-2c0-1.11.89-2 2-2a2 2 0 110 4z"
                }
            }
        ]
    })(props);
}
function MdTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdTram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
                }
            }
        ]
    })(props);
}
function MdTransferWithinAStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
                }
            }
        ]
    })(props);
}
function MdTransitEnterexit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
                }
            }
        ]
    })(props);
}
function MdTripOrigin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
                }
            }
        ]
    })(props);
}
function MdTurnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 11l1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9H6.83z"
                }
            }
        ]
    })(props);
}
function MdTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.17 11l-1.59 1.59L17 14l4-4-4-4-1.41 1.41L17.17 9H9c-1.1 0-2 .9-2 2v9h2v-9h8.17z"
                }
            }
        ]
    })(props);
}
function MdTurnSharpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.83L4.41 8.41 3 7l4-4 4 4-1.41 1.41L8 6.83V13h8c1.1 0 2 .9 2 2v6h-2v-6H8c-1.1 0-2-.9-2-2V6.83z"
                }
            }
        ]
    })(props);
}
function MdTurnSharpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.83l1.59 1.59L21 7l-4-4-4 4 1.41 1.41L16 6.83V13H8c-1.1 0-2 .9-2 2v6h2v-6h8c1.1 0 2-.9 2-2V6.83z"
                }
            }
        ]
    })(props);
}
function MdTurnSlightLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-7.58c0-.53-.21-1.04-.59-1.41l-5-5h2.25z"
                }
            }
        ]
    })(props);
}
function MdTurnSlightRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.34 6V4H18v5.66h-2V7.41l-5 5V20H9v-7.58c0-.53.21-1.04.59-1.41l5-5h-2.25z"
                }
            }
        ]
    })(props);
}
function MdTwoWheeler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11c-.18 0-.36.03-.53.05L17.41 9H20V6l-3.72 1.86L13.41 5H9v2h3.59l2 2H11l-4 2-2-2H0v2h4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4l2 2h3l3.49-6.1 1.01 1.01c-.91.73-1.5 1.84-1.5 3.09 0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4zM4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm16 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdUTurnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v12h-2V9c0-2.21-1.79-4-4-4S8 6.79 8 9v4.17l1.59-1.59L11 13l-4 4-4-4 1.41-1.41L6 13.17V9c0-3.31 2.69-6 6-6s6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function MdUTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9v12h2V9c0-2.21 1.79-4 4-4s4 1.79 4 4v4.17l-1.59-1.59L13 13l4 4 4-4-1.41-1.41L18 13.17V9c0-3.31-2.69-6-6-6S6 5.69 6 9z"
                }
            }
        ]
    })(props);
}
function MdVolunteerActivism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11h4v11H1zM16 3.25C16.65 2.49 17.66 2 18.7 2 20.55 2 22 3.45 22 5.3c0 2.27-2.91 4.9-6 7.7-3.09-2.81-6-5.44-6-7.7C10 3.45 11.45 2 13.3 2c1.04 0 2.05.49 2.7 1.25zM20 17h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8.01-3c-.01-1.1-.9-2-2.01-2z"
                }
            }
        ]
    })(props);
}
function MdWarehouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21V7L12 3 2 7v14h5v-9h10v9h5zm-11-2H9v2h2v-2zm2-3h-2v2h2v-2zm2 3h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdWineBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3H6zm10 5H8V5h8v3z"
                }
            }
        ]
    })(props);
}
function MdWrongLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10V3.26c-.65-.17-1.32-.26-2-.26-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-.41-.04-.81-.09-1.2H14zm-2 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 2.88l-1.42-1.42L19 3.59l-2.12-2.13-1.42 1.42L17.59 5l-2.13 2.12 1.42 1.42L19 6.41l2.12 2.13 1.42-1.42L20.41 5z"
                }
            }
        ]
    })(props);
}
function MdZoomInMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9V3H7v2.59L3.91 2.5 2.5 3.91 5.59 7H3v2h6zm12 0V7h-2.59l3.09-3.09-1.41-1.41L17 5.59V3h-2v6h6zM3 15v2h2.59L2.5 20.09l1.41 1.41L7 18.41V21h2v-6H3zm12 0v6h2v-2.59l3.09 3.09 1.41-1.41L18.41 17H21v-2h-6z"
                }
            }
        ]
    })(props);
}
function MdZoomOutMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
                }
            }
        ]
    })(props);
}
function MdAddHomeWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.68V11L8 6l-7 5v10h5v-6h4v6h1.68c-.43-.91-.68-1.92-.68-3 0-2.79 1.64-5.19 4-6.32zM23 13.11V3H10v1.97l7 5v1.11c.33-.05.66-.08 1-.08 1.96 0 3.73.81 5 2.11zM17 7h2v2h-2V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 18c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5.5 3v-2.5H15v-1h2.5V15h1v2.5H21v1h-2.5V21h-1z"
                }
            }
        ]
    })(props);
}
function MdAppSettingsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.81 12.74l-.82-.63v-.22l.8-.63c.16-.12.2-.34.1-.51l-.85-1.48a.395.395 0 00-.35-.2c-.05 0-.1.01-.15.03l-.95.38c-.08-.05-.11-.07-.19-.11l-.15-1.01a.408.408 0 00-.4-.36h-1.71c-.2 0-.37.15-.4.34l-.14 1.01c-.03.02-.07.03-.1.05l-.09.06-.95-.38a.401.401 0 00-.5.17l-.85 1.48c-.1.17-.06.39.1.51l.8.63v.23l-.8.63a.39.39 0 00-.1.51l.85 1.48c.07.13.21.2.35.2.05 0 .1-.01.15-.03l.95-.37c.08.05.12.07.2.11l.15 1.01c.03.2.2.34.4.34h1.71c.2 0 .37-.15.4-.34l.15-1.01c.03-.02.07-.03.1-.05l.09-.06.95.38a.401.401 0 00.5-.17l.85-1.48a.39.39 0 00-.1-.51zM18 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM17 17h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1z"
                }
            }
        ]
    })(props);
}
function MdAppsOutage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6 6h4v-4h-4v4zm3-20c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V7h1v1zm0-2h-1V2h1v4zM16 14h4v-2.07c-.33.05-.66.07-1 .07-1.07 0-2.09-.24-3-.68V14zM10 4v4h2.68c-.44-.91-.68-1.93-.68-3 0-.34.02-.67.07-1H10z"
                }
            }
        ]
    })(props);
}
function MdApps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
                }
            }
        ]
    })(props);
}
function MdArrowBackIosNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"
                }
            }
        ]
    })(props);
}
function MdArrowBackIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
                }
            }
        ]
    })(props);
}
function MdArrowBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
                }
            }
        ]
    })(props);
}
function MdArrowDownward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
                }
            }
        ]
    })(props);
}
function MdArrowDropDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"
                }
            }
        ]
    })(props);
}
function MdArrowDropDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10l5 5 5-5z"
                }
            }
        ]
    })(props);
}
function MdArrowDropUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14l5-5 5 5z"
                }
            }
        ]
    })(props);
}
function MdArrowForwardIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12z"
                }
            }
        ]
    })(props);
}
function MdArrowForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
                }
            }
        ]
    })(props);
}
function MdArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7l-5 5 5 5V7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z"
                }
            }
        ]
    })(props);
}
function MdArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17l5-5-5-5v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 24V0h24v24H0z"
                }
            }
        ]
    })(props);
}
function MdArrowUpward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
                }
            }
        ]
    })(props);
}
function MdAssistantDirection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H9c-.6 0-1 .4-1 1v4h2v-3h4v2.5l3.5-3.5L14 7.5V10zm-2-9C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm7.73 11.58l-7.19 7.22c-.35.27-.79.27-1.15 0L4.2 12.58a.932.932 0 010-1.16l7.19-7.22c.35-.27.79-.27 1.15 0l7.19 7.22c.36.27.36.8 0 1.16z"
                }
            }
        ]
    })(props);
}
function MdAssistantNavigation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm3.57 16L12 15.42 8.43 17l-.37-.37L12 7l3.95 9.63-.38.37z"
                }
            }
        ]
    })(props);
}
function MdCampaign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v2h4v-2h-4zm-2 6.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm11.5 3c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
                }
            }
        ]
    })(props);
}
function MdCancel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                }
            }
        ]
    })(props);
}
function MdCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                }
            }
        ]
    })(props);
}
function MdChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                }
            }
        ]
    })(props);
}
function MdClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                }
            }
        ]
    })(props);
}
function MdDoubleArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5H11l5 7-5 7h4.5l5-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H4l5 7-5 7h4.5l5-7z"
                }
            }
        ]
    })(props);
}
function MdEast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdExpandCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13.5L7.5 11l1.42-1.41L12 12.67l3.08-3.08L16.5 11 12 15.5z"
                }
            }
        ]
    })(props);
}
function MdExpandLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
                }
            }
        ]
    })(props);
}
function MdExpandMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
                }
            }
        ]
    })(props);
}
function MdFirstPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            }
        ]
    })(props);
}
function MdFullscreenExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
                }
            }
        ]
    })(props);
}
function MdFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                }
            }
        ]
    })(props);
}
function MdHomeWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11v10h5v-6h4v6h5V11L8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l7 5V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdLastPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
                }
            }
        ]
    })(props);
}
function MdLegendToggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15H4v-2h16v2zm0 2H4v2h16v-2zm-5-6l5-3.55V5l-5 3.55L10 5 4 8.66V11l5.92-3.61L15 11z"
                }
            }
        ]
    })(props);
}
function MdMapsHomeWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11v10h5v-6h4v6h5V11L8 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l7 5V11h2v2h-2v2h2v2h-2v4h6V3H10zm9 6h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdMenuOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
                }
            }
        ]
    })(props);
}
function MdMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                }
            }
        ]
    })(props);
}
function MdMoreHoriz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdMoreVert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdNorthEast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
                }
            }
        ]
    })(props);
}
function MdNorthWest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z"
                }
            }
        ]
    })(props);
}
function MdNorth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9l1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOfflineShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.6 10.26v1.31L17 9.33 14.6 7.1v1.28c-2.33.32-3.26 1.92-3.6 3.52.83-1.13 1.93-1.64 3.6-1.64zM16 23H6c-1.1 0-2-.9-2-2V5h2v16h10v2zm2-22h-8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 15h-8V4h8v12z"
                }
            }
        ]
    })(props);
}
function MdPayments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
                }
            }
        ]
    })(props);
}
function MdPivotTableChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8h11V5c0-1.1-.9-2-2-2h-9v5zM3 8h5V3H5c-1.1 0-2 .9-2 2v3zm2 13h3V10H3v9c0 1.1.9 2 2 2zm8 1l-4-4 4-4zm1-9l4-4 4 4zM14.58 19H13v-2h1.58c1.33 0 2.42-1.08 2.42-2.42V13h2v1.58c0 2.44-1.98 4.42-4.42 4.42z"
                }
            }
        ]
    })(props);
}
function MdRefresh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                }
            }
        ]
    })(props);
}
function MdSouthEast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z"
                }
            }
        ]
    })(props);
}
function MdSouthWest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z"
                }
            }
        ]
    })(props);
}
function MdSouth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7 7-7z"
                }
            }
        ]
    })(props);
}
function MdSubdirectoryArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
                }
            }
        ]
    })(props);
}
function MdSubdirectoryArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
                }
            }
        ]
    })(props);
}
function MdSwitchLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdSwitchRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function MdUnfoldLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
                }
            }
        ]
    })(props);
}
function MdUnfoldMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
                }
            }
        ]
    })(props);
}
function MdWaterfallChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h3v16h-3zM3 13h3v7H3zm11-9h3v3h-3zm-4 1h3v4h-3zm-3 5h3v4H7z"
                }
            }
        ]
    })(props);
}
function MdWest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19l1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function MdAccountTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3z"
                }
            }
        ]
    })(props);
}
function MdAdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdAddCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM21 6h-3V3h-2v3h-3v2h3v3h2V8h3z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatFlatAngled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09a4 4 0 012.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94a3.01 3.01 0 001.41-4A3.005 3.005 0 004.7 4.8a2.99 2.99 0 00-1.4 4 2.99 2.99 0 004 1.4z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatFlat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9a3 3 0 00-.04-4.24 3 3 0 00-4.24.04 3 3 0 00.04 4.24 3 3 0 004.24-.04z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatIndividualSuite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatLegroomExtra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98a2.01 2.01 0 00-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatLegroomNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatLegroomReduced(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatReclineExtra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76A5.01 5.01 0 008.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 00-.99-.06h-.02a2.268 2.268 0 00-1.84 2.61l1.35 5.92A3.008 3.008 0 009.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
                }
            }
        ]
    })(props);
}
function MdAirlineSeatReclineNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
                }
            }
        ]
    })(props);
}
function MdBluetoothAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdConfirmationNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6a2 2 0 00-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdDirectionsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 10h.67V7.5L17 11l-1.59 1.59L18.83 16l2.59-2.59c.78-.78.78-2.05 0-2.83l-7.99-8c-.78-.78-2.05-.78-2.83 0L8 5.17 12.83 10zM2.81 2.81L1.39 4.22 5.17 8l-2.59 2.59c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L16 18.83l3.78 3.78 1.41-1.41L2.81 2.81zM10 15H8v-4c0-.05.02-.09.03-.14L10 12.83V15z"
                }
            }
        ]
    })(props);
}
function MdDiscFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdDoDisturbAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdDoDisturbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v2h-1.17l4.51 4.51A9.91 9.91 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66L13.83 11H17zM1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81 1.39 4.22zM7 11h1.17l2 2H7v-2z"
                }
            }
        ]
    })(props);
}
function MdDoDisturbOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdDoDisturb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdDoNotDisturbAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M-618-1464H782v3600H-618zM0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdDoNotDisturbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v2h-1.46l4.68 4.68A9.92 9.92 0 0022 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78A9.92 9.92 0 002 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z"
                }
            }
        ]
    })(props);
}
function MdDoNotDisturbOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdDoNotDisturb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdDriveEta(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
                }
            }
        ]
    })(props);
}
function MdEnhancedEncryption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
                }
            }
        ]
    })(props);
}
function MdEventAvailable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function MdEventBusy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
                }
            }
        ]
    })(props);
}
function MdEventNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
                }
            }
        ]
    })(props);
}
function MdFolderSpecial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
                }
            }
        ]
    })(props);
}
function MdImagesearchRoller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2v6H6V6H4v4h10v5h2v8h-6v-8h2v-3H2V4h4V2"
                }
            }
        ]
    })(props);
}
function MdLiveTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3a2 2 0 00-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8a2 2 0 00-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
                }
            }
        ]
    })(props);
}
function MdMms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
                }
            }
        ]
    })(props);
}
function MdMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdNetworkCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2a15.367 15.367 0 00-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2a7.1 7.1 0 014.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
                }
            }
        ]
    })(props);
}
function MdNetworkLocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5a2.5 2.5 0 00-5 0V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
                }
            }
        ]
    })(props);
}
function MdNoEncryptionGmailerrorred(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.27L20 17.17V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.21 0-4.07 1.45-4.73 3.44L8.9 6.07V6zM2.1 2.1L.69 3.51 5.3 8.13C4.55 8.42 4 9.15 4 10v10c0 1.1.9 2 2 2h12c.34 0 .65-.09.93-.24l1.56 1.56 1.41-1.41L2.1 2.1zM12 17c-1.1 0-2-.9-2-2 0-.59.27-1.12.68-1.49l2.81 2.81c-.37.41-.9.68-1.49.68z"
                }
            }
        ]
    })(props);
}
function MdNoEncryption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"
                }
            }
        ]
    })(props);
}
function MdOndemandVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"
                }
            }
        ]
    })(props);
}
function MdPersonalVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function MdPhoneBluetoothSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdPhoneCallback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2zm13.54-7.1l-.71-.7L13 9.29V5h-1v6h6v-1h-4.15z"
                }
            }
        ]
    })(props);
}
function MdPhoneForwarded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdPhoneInTalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2a9 9 0 00-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdPhoneLocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-1.1-.9-2-2-2s-2 .9-2 2v1h-1v5h6V5h-1zm-1 0h-2V4c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.63 14.4l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73a.985.985 0 00-.9.26z"
                }
            }
        ]
    })(props);
}
function MdPhoneMissed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17A16.971 16.971 0 0012 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
                }
            }
        ]
    })(props);
}
function MdPhonePaused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 00-1.02.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z"
                }
            }
        ]
    })(props);
}
function MdPowerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14.49V9c0-1-1.01-2.01-2-2V3h-2v4h-4V3H8v2.48l9.51 9.5.49-.49zm-1.76 1.77L7.2 7.2l-.01.01L3.98 4 2.71 5.25l3.36 3.36C6.04 8.74 6 8.87 6 9v5.48L9.5 18v3h5v-3l.48-.48L19.45 22l1.26-1.28-4.47-4.46z"
                }
            }
        ]
    })(props);
}
function MdPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"
                }
            }
        ]
    })(props);
}
function MdPriorityHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v12h-4z"
                }
            }
        ]
    })(props);
}
function MdRunningWithErrors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v8h-2v-8h2zm-2 10v2h2v-2h-2zm-2-2.71A7.99 7.99 0 0112 20c-4.41 0-8-3.59-8-8s3.59-8 8-8v9l7.55-7.55A9.965 9.965 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c2.25 0 4.33-.74 6-2v-2.71z"
                }
            }
        ]
    })(props);
}
function MdSdCardAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
                }
            }
        ]
    })(props);
}
function MdSdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
                }
            }
        ]
    })(props);
}
function MdSimCardAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
                }
            }
        ]
    })(props);
}
function MdSmsFailed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
                }
            }
        ]
    })(props);
}
function MdSms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
                }
            }
        ]
    })(props);
}
function MdSupportAgent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.03A6.04 6.04 0 0012.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 004.86-5.89c1.31 2.63 4 4.44 7.12 4.47z"
                }
            }
        ]
    })(props);
}
function MdSyncDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36a7.925 7.925 0 001.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 016 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24A6.003 6.003 0 0118 12c0 1-.25 1.94-.68 2.77l1.46 1.46a7.925 7.925 0 00-1.14-9.87L20 4z"
                }
            }
        ]
    })(props);
}
function MdSyncLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 4h-6v6h2V7.56c1.22 1.1 2 2.67 2 4.44h2c0-2.4-1.06-4.54-2.73-6H20V4zm0 13v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdSyncProblem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 015 12a5.99 5.99 0 014-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0119 12a5.99 5.99 0 01-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
                }
            }
        ]
    })(props);
}
function MdSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function MdSystemUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function MdTapAndPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2a9 9 0 019 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
                }
            }
        ]
    })(props);
}
function MdTimeToLeave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
                }
            }
        ]
    })(props);
}
function MdTvOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l2 2 1.26-1.27L2.27 2.27 1 3.54zM3 19V7h1.46l12 12H3zM21 5h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H7.52l2 2H21v11.48l1.65 1.65c.22-.32.35-.71.35-1.13V7c0-1.11-.89-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdVibration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
                }
            }
        ]
    })(props);
}
function MdVideoChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 11l-2-1.99V13c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v1.99L17 7v6z"
                }
            }
        ]
    })(props);
}
function MdVoiceChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 5h1.5v10h-1.5zM8.5 7H10v6H8.5zM6 9h1.5v2H6zM14 7h1.5v6H14zM16.5 9H18v2h-1.5z"
                }
            }
        ]
    })(props);
}
function MdVpnLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4v-.5a2.5 2.5 0 00-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z"
                }
            }
        ]
    })(props);
}
function MdWc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0016.56 7h-.12a2 2 0 00-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 .01c0-.01 0-.01 0 0L0 0v24h24V.01zM0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7l2-2zm-4 4a9.793 9.793 0 00-4.49-2.56l3.53 3.53.96-.97zM2 3.05L5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24A9.684 9.684 0 005 13v.01L6.99 15a7.042 7.042 0 014.92-2.06L18.98 20l1.27-1.26L3.29 1.79 2 3.05zM9 17l3 3 3-3a4.237 4.237 0 00-6 0z"
                }
            }
        ]
    })(props);
}
function MdWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 00-6 0zm-4-4l2 2a7.074 7.074 0 0110 0l2-2C15.14 9.14 8.87 9.14 5 13z"
                }
            }
        ]
    })(props);
}
function MdAcUnit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
                }
            }
        ]
    })(props);
}
function MdAirportShuttle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H3a2 2 0 00-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"
                }
            }
        ]
    })(props);
}
function MdAllInclusive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
                }
            }
        ]
    })(props);
}
function MdApartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdBabyChangingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v2h-3L8.31 8.82 7 12.75V22H3V12l1.58-4.63A2.003 2.003 0 017.3 6.18l4.15 1.83L14 8zM8 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm1 18h12v-2H9v2zm10.5-3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM13 12c0-.55-.45-1-1-1H9v2h2v1c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-3h-2v2h-2v-1z"
                }
            }
        ]
    })(props);
}
function MdBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8c0-1.86 1.28-3.41 3-3.86V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86zM6 12v2h10v2h2v-4H6z"
                }
            }
        ]
    })(props);
}
function MdBalcony(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v2H8v-2h2zm6 2v-2h-2v2h2zm5 2v8H3v-8h1v-4c0-4.42 3.58-8 8-8s8 3.58 8 8v4h1zM7 16H5v4h2v-4zm4 0H9v4h2v-4zm0-11.92C8.16 4.56 6 7.03 6 10v4h5V4.08zM13 14h5v-4c0-2.97-2.16-5.44-5-5.92V14zm2 2h-2v4h2v-4zm4 0h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function MdBathtub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 011.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 005 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2z"
                }
            }
        ]
    })(props);
}
function MdBeachAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
                }
            }
        ]
    })(props);
}
function MdBento(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11V5h4c1.1 0 2 .9 2 2v4h-6zm4 8c1.1 0 2-.9 2-2v-4h-6v6h4zM14 5v14H4c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h10zm-4.5 7c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdBungalow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4.2 15.5l1.7 1.06L7 14.8V21h4v-5h2v5h4v-6.21l1.1 1.77 1.7-1.06L12 3zm1 11h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdBusinessCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm10 5h4v2h-4zm0 0h4v2h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
                }
            }
        ]
    })(props);
}
function MdCabin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2zm2 2L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm1.94 4h-3.89L12 5.52 13.94 7zm-6.5 2h9.12L18 10.1v.9H6v-.9L7.44 9zM18 13v2H6v-2h12zM6 19v-2h12v2H6z"
                }
            }
        ]
    })(props);
}
function MdCarpenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.73 14.23L7 1.5 3.11 5.39l8.13 11.67c-.78.78-.78 2.05 0 2.83l1.41 1.41c.78.78 2.05.78 2.83 0l4.24-4.24c.79-.78.79-2.05.01-2.83zm-5.66 5.65l-1.41-1.41 4.24-4.24 1.41 1.41-4.24 4.24z"
                }
            }
        ]
    })(props);
}
function MdCasino(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0zm21.02 19c0 1.1-.9 2-2 2h-14c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
                }
            }
        ]
    })(props);
}
function MdChalet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7.5l7.5 7.5-1.41 1.41L15 15.33V20h-4v-5H9v5H5v-4.67l-1.09 1.09L2.5 15 10 7.5zm12-1h-1.19l.75-.75-.71-.71-1.46 1.46h-.89v-.89l1.45-1.45-.71-.71-.74.74V3h-1v1.19l-.75-.75-.71.71 1.45 1.45v.9h-.89l-1.45-1.45-.71.71.75.75H14v1h1.19l-.75.75.71.71 1.45-1.45h.89v.89l-1.45 1.45.71.71.75-.75V11h1V9.81l.75.75.71-.71-1.46-1.46V7.5h.89l1.45 1.45.71-.71-.74-.74H22v-1z"
                }
            }
        ]
    })(props);
}
function MdChargingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11l-3 6v-4h-2l3-6v4h2zM7 1h10c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2zm0 5v12h10V6H7z"
                }
            }
        ]
    })(props);
}
function MdCheckroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6 18.2L13 11.75v-.91a3.496 3.496 0 00-.18-6.75A3.51 3.51 0 008.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z"
                }
            }
        ]
    })(props);
}
function MdChildCare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66a4.008 4.008 0 00-2.81-3.17 9.114 9.114 0 00-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91a3.994 3.994 0 00-2.81 3.17c-.04.21-.06.43-.06.66s.02.45.06.66a4.008 4.008 0 002.81 3.17 8.977 8.977 0 002.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89a3.998 3.998 0 002.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
                }
            }
        ]
    })(props);
}
function MdChildFriendly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89A7.948 7.948 0 0021 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
                }
            }
        ]
    })(props);
}
function MdCorporateFare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zm-2 12H4v-2h6v2zm0-4H4v-2h6v2zm0-4H4V9h6v2zm0-4H4V5h6v2zm10 12h-8V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z"
                }
            }
        ]
    })(props);
}
function MdCottage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h7v-6h2v6h7v-9.38l1.79 1.36L23 11.4 12 3zm-2-2c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2z"
                }
            }
        ]
    })(props);
}
function MdCountertops(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10V7c0-1.66-1.34-3-3-3s-3 1.34-3 3h2c0-.55.45-1 1-1s1 .45 1 1v3H8c1.1 0 2-.9 2-2V4H4v4c0 1.1.9 2 2 2H2v2h2v8h16v-8h2v-2h-4zm-5 8h-2v-6h2v6z"
                }
            }
        ]
    })(props);
}
function MdCrib(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h-6V4H8C5.79 4 4 5.79 4 8v6c0 1.1.9 2 2 2h2v2.93c-.61-.35-1.16-.78-1.65-1.27l-1.42 1.42C6.74 20.88 9.24 22 12 22c2.76 0 5.26-1.12 7.07-2.93l-1.42-1.42c-.49.49-1.05.92-1.65 1.27V16h2c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm-4 10.75c-.64.16-1.31.25-2 .25s-1.36-.09-2-.25V16h4v3.75z"
                }
            }
        ]
    })(props);
}
function MdDesk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6v12h2V8h10v10h2v-2h4v2h2V6H2zm18 2v2h-4V8h4zm-4 6v-2h4v2h-4z"
                }
            }
        ]
    })(props);
}
function MdDoNotStep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.39 4.22l7.9 7.9c.18.2.18.5-.01.7a.485.485 0 01-.7 0L6.87 11.1c-.11.4-.26.78-.45 1.12l1.4 1.4c.2.2.2.51 0 .71a.485.485 0 01-.7 0l-1.27-1.27c-.24.29-.5.56-.77.8l1.28 1.28c.2.2.2.51 0 .71-.1.1-.23.15-.36.15s-.26-.05-.35-.15l-1.38-1.38c-.69.46-1.39.79-1.97 1.02-.78.31-1.3 1.04-1.3 1.88V20h9.5l3.33-3.33 5.94 5.94 1.41-1.41L2.81 2.81 1.39 4.22zm17.12 11.46l-1.41-1.41 4.48-4.48L23 11.2l-4.49 4.48zm2.37-6.6l-4.48 4.48-7.1-7.09L13.8 2l7.08 7.08z"
                }
            }
        ]
    })(props);
}
function MdDoNotTouch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10.17l-2.5-2.5V2.25a1.25 1.25 0 012.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 00-2.5 0V11h-1V3.25a1.25 1.25 0 00-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm3.5 5.92l-2.5-2.5V2.25a1.25 1.25 0 012.5 0v7.92zm7 2.58v-7.5a1.25 1.25 0 00-2.5 0V11h-1V3.25a1.25 1.25 0 00-2.5 0v7.92l6 6v-4.42zM9.5 4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67V4.25zm11.69 16.94L2.81 2.81 1.39 4.22l5.63 5.63L7 9.83v4.3c-1.11-.64-2.58-1.47-2.6-1.48-.17-.09-.34-.14-.54-.14-.26 0-.5.09-.7.26-.04.01-1.16 1.11-1.16 1.11l6.8 7.18c.57.6 1.35.94 2.18.94H17c.62 0 1.18-.19 1.65-.52l-.02-.02 1.15 1.15 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdDry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.65 4.86l-.07-.07c-.57-.62-.82-1.41-.67-2.2L15 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L19 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zM9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75a1.25 1.25 0 000-2.5H12v-1h6.75a1.25 1.25 0 000-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 00-.12-1.23C10.22 6.12 9.12 5 9.12 5z"
                }
            }
        ]
    })(props);
}
function MdElevator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM8.5 6a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm2.5 8h-1v4H7v-4H6v-2.5c0-1.1.9-2 2-2h1c1.1 0 2 .9 2 2V14zm4.5 3L13 13h5l-2.5 4zM13 11l2.5-4 2.5 4h-5z"
                }
            }
        ]
    })(props);
}
function MdEscalatorWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S17.83 8 17 8s-1.5.67-1.5 1.5zm3 2.5h-2.84c-.58.01-1.14.32-1.45.86l-.92 1.32L9.72 8a2.02 2.02 0 00-1.71-1H5c-1.1 0-2 .9-2 2v6h1.5v7h5V11.61L12.03 16h2.2l.77-1.1V22h4v-5h1v-3.5c0-.82-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdEscalator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 6h-1.7l-5 9H7c-.83 0-1.5-.67-1.5-1.5S6.17 15 7 15h1.7l5-9H17c.83 0 1.5.67 1.5 1.5S17.83 9 17 9z"
                }
            }
        ]
    })(props);
}
function MdFamilyRestroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.01 2.01 0 0018.06 7h-.12a2 2 0 00-1.9 1.37l-.86 2.58c1.08.6 1.82 1.73 1.82 3.05v8h3zm-7.5-10.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2 16v-7H9V9c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6h1.5v7h4zm6.5 0v-4h1v-4c0-.82-.68-1.5-1.5-1.5h-2c-.82 0-1.5.68-1.5 1.5v4h1v4h3z"
                }
            }
        ]
    })(props);
}
function MdFence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2h2zm-5-5.17l1 1V10h-2V7.83l.41-.41.59-.59zm-4 0l.59.59.41.41V10h-2V7.83l.41-.41.59-.59zM11 14v-2h2v2h-2zm2 2v2h-2v-2h2zM7 7.83l1-1 .59.59.41.41V10H7V7.83zM7 12h2v2H7v-2zm0 4h2v2H7v-2zm10 2h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdFireExtinguisher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10v1c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2v-1zm0-1h10v-5H7v5zM17 3v6l-3.15-.66c-.01 0-.01.01-.02.02 1.55.62 2.72 1.98 3.07 3.64H7.1c.34-1.66 1.52-3.02 3.07-3.64-.33-.26-.6-.58-.8-.95L5 6.5v-1l4.37-.91C9.87 3.65 10.86 3 12 3c.7 0 1.34.25 1.85.66L17 3zm-4 3c-.03-.59-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdFitnessCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
                }
            }
        ]
    })(props);
}
function MdFoodBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm.5 9.5c0 .83-.67 1.5-1.5 1.5v4h-1v-4c-.83 0-1.5-.67-1.5-1.5v-3h1v3h.5v-3h1v3h.5v-3h1v3zM15 18h-1v-3.5h-1v-3c0-1.1.9-2 2-2V18z"
                }
            }
        ]
    })(props);
}
function MdFoundation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v3H3v2h2v3h2v-3h4v3h2v-3h4v3h2v-3h2v-2h-2v-3zM7 15v-4.81l4-3.6V15H7zm6 0V6.59l4 3.6V15h-4z"
                }
            }
        ]
    })(props);
}
function MdFreeBreakfast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function MdGite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6H9V4H7v2H6l-4 4v9h20v-9l-4-4zM4 12h10v5H4v-5zm16 5h-4v-6.17l2-2 2 2V17z"
                }
            }
        ]
    })(props);
}
function MdGolfCourse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
                }
            }
        ]
    })(props);
}
function MdGrass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20H2v-2h5.75A8.032 8.032 0 002 12.26c.64-.16 1.31-.26 2-.26 4.42 0 8 3.58 8 8zm10-7.74c-.64-.16-1.31-.26-2-.26-2.93 0-5.48 1.58-6.88 3.93a9.82 9.82 0 01.87 4.07h8v-2h-5.75A8.061 8.061 0 0122 12.26zm-6.36-1.24a10.03 10.03 0 014.09-5C15.44 6.16 12 9.67 12 14v.02c.95-1.27 2.2-2.3 3.64-3zm-4.22-2.17A8.527 8.527 0 006.7 4C8.14 5.86 9 8.18 9 10.71c0 .21-.03.41-.04.61.43.24.83.52 1.22.82a9.91 9.91 0 011.24-3.29z"
                }
            }
        ]
    })(props);
}
function MdHolidayVillage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20V8.35L13.65 4h-2.83L16 9.18V20h2zm4 0V6.69L19.31 4h-2.83L20 7.52V20h2zM8 4l-6 6v10h5v-5h2v5h5V10L8 4zm1 9H7v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdHotTub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
                }
            }
        ]
    })(props);
}
function MdHouseSiding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v8h2v-2h10v2h2v-8zM7.21 10h9.58l.21.19V12H7v-1.81l.21-.19zm7.36-2H9.43L12 5.69 14.57 8zM7 16v-2h10v2H7z"
                }
            }
        ]
    })(props);
}
function MdHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4z"
                }
            }
        ]
    })(props);
}
function MdHouseboat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.95 0-2.1 1-3.34 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.08-1 3.32-1s1.37 1 3.32 1c1.91 0 2.14-1 3.33-1 1.18 0 1.45 1 3.35 1v-2c-1.24 0-1.38-1-3.33-1-1.91 0-2.14 1-3.33 1-1.24 0-1.39-1-3.34-1zm8.34-4.66l-1.37 1.37c-.19.18-.45.29-.71.29H17V9.65l1.32.97L19.5 9 12 3.5 4.5 9l1.18 1.61L7 9.65V13H5.74c-.27 0-.52-.11-.71-.29l-1.37-1.37-1.41 1.41 1.37 1.37c.56.56 1.33.88 2.12.88h12.51c.8 0 1.56-.32 2.12-.88l1.37-1.37-1.4-1.41zM13 13h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdIron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c-1.66 0-3 1.34-3 3v4c0 .55-.45 1-1 1v-4c0-1.66-1.34-3-3-3h-4c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H6c-2.21 0-4 1.79-4 4v3h15v-2c1.66 0 3-1.34 3-3V9c0-.55.45-1 1-1h1V6h-1z"
                }
            }
        ]
    })(props);
}
function MdKitchen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V4c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v5h16zM8 5h2v3H8V5zm-4 6v9c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-9H4zm6 6H8v-5h2v5z"
                }
            }
        ]
    })(props);
}
function MdMeetingRoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6v15H3v-2h2V3h9v1h5v15h2v2h-4V6h-3zm-4 5v2h2v-2h-2z"
                }
            }
        ]
    })(props);
}
function MdMicrowave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.8 10.61L5.37 9.19C5.73 8.79 6.59 8 7.75 8c.8 0 1.39.39 1.81.67.31.21.51.33.69.33.37 0 .8-.41.95-.61l1.42 1.42c-.36.4-1.22 1.19-2.37 1.19-.79 0-1.37-.38-1.79-.66-.33-.22-.52-.34-.71-.34-.37 0-.8.41-.95.61zM7.75 15c.19 0 .38.12.71.34.42.28 1 .66 1.79.66 1.16 0 2.01-.79 2.37-1.19l-1.42-1.42c-.15.2-.59.61-.95.61-.18 0-.38-.12-.69-.33-.42-.28-1.01-.67-1.81-.67-1.16 0-2.02.79-2.38 1.19l1.42 1.42c.16-.2.59-.61.96-.61zM22 6v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-8 0H4v12h10V6zm5 10c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm0-4c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm0-5h-2v2h2V7z"
                }
            }
        ]
    })(props);
}
function MdNightShelter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm-2.25 9.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zM17 18h-1v-1.5H8V18H7v-7h1v4.5h3.5V12H15c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function MdNoBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l2.76 2.76C4.06 7.31 4 7.64 4 8v12c0 1.1.9 2 2 2h12c.34 0 .65-.09.93-.24l.85.85 1.41-1.42zM6 14v-2h3.17l2 2H6zm8.83-2L6.98 4.15c.01 0 .01-.01.02-.01V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86v9.17l-2-2V12h-3.17z"
                }
            }
        ]
    })(props);
}
function MdNoCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.83 6l-3.7-3.7C5.42 1.55 6.15 1 7 1l10 .01c1.1 0 2 .89 2 1.99v13.17l-2-2V6H8.83zm10.95 16.61l-.91-.91c-.29.75-1.02 1.3-1.87 1.3H7c-1.1 0-2-.9-2-2V7.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM15.17 18L7 9.83V18h8.17z"
                }
            }
        ]
    })(props);
}
function MdNoDrinks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.83 3H21v2l-6.2 6.97L9.83 7h6.74l1.78-2H7.83l-2-2zm13.95 19.61L18 20.83V21H6v-2h5v-5l-1.37-1.54-8.24-8.24L2.8 2.81 3 3l18.19 18.19-1.41 1.42zM16.17 19L13 15.83V19h3.17z"
                }
            }
        ]
    })(props);
}
function MdNoFlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.93 13.93L2.45 2.45 1.04 3.87l5.3 5.3-.2.23H3.6c-.88 0-1.6.72-1.6 1.6v9.4c0 .88.72 1.6 1.6 1.6h12.8c.75 0 1.38-.52 1.55-1.22l2.18 2.18 1.41-1.41L18 18l-4.07-4.07zM10 20c-2.21 0-4-1.79-4-4 0-1.95 1.4-3.57 3.25-3.92l1.57 1.57c-.26-.09-.53-.15-.82-.15a2.5 2.5 0 000 5 2.5 2.5 0 002.5-2.5c0-.29-.06-.56-.15-.82l1.57 1.57A3.993 3.993 0 0110 20zm8-4.83L10.83 8h1.75l1.28 1.4h2.54c.88 0 1.6.72 1.6 1.6v4.17zm2.4-9.57H22L19 11V7h-1V2h4l-1.6 3.6z"
                }
            }
        ]
    })(props);
}
function MdNoFood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.35 8.52L11 5h5V1h2v4h5l-1.38 13.79L11.35 8.52zM1 21v1c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-1H1zm20.9.9L2.1 2.1.69 3.51l5.7 5.7C3.28 9.87 1 11.99 1 15h11.17l2 2H1v2h15v-.17l4.49 4.49 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdNoMeetingRoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h-1v2h2v-1l9.73 9.73L20.46 23 14 16.54V21H3v-2h2V7.54l-4-4 1.27-1.27L11 11zm3 .49L5.51 3H14v1h5v12.49l-2-2V6h-3v5.49z"
                }
            }
        ]
    })(props);
}
function MdNoPhotography(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.94 8.12L7.48 4.66 9 3h6l1.83 2H20c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16l-5.1-5.1c.08-.35.12-.7.12-1.06 0-2.76-2.24-5-5-5-.36 0-.71.04-1.06.12zm9.55 15.19L18.17 21H4c-1.1 0-2-.9-2-2V7c0-.59.27-1.12.68-1.49l-2-2L2.1 2.1l19.8 19.8-1.41 1.41zm-6-5.99l-1.5-1.5c-.32.1-.64.18-.99.18-1.66 0-3-1.34-3-3 0-.35.08-.67.19-.98l-1.5-1.5A4.74 4.74 0 007 13c0 2.76 2.24 5 5 5 .91 0 1.76-.25 2.49-.68z"
                }
            }
        ]
    })(props);
}
function MdNoStroller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-3.5 4.11L17 14.17v-7.9c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2v-.52C22 4.56 20.52 3 18.65 3zm-7.98 7.67L2.81 2.81 1.39 4.22l7.97 7.97-2.66 3.12c-.55.65-.09 1.65.76 1.65h6.66l1.17 1.17C14.54 18.42 14 19.14 14 20c0 1.1.9 2 2 2 .86 0 1.58-.54 1.87-1.3l1.91 1.91 1.41-1.41-4.8-4.8-5.72-5.73zm2.8-5.64c.27-.32.58-.72.98-1.09a9.347 9.347 0 00-7.81-.13l4.25 4.25 2.58-3.03z"
                }
            }
        ]
    })(props);
}
function MdOtherHouses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zM8 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdPool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "5.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function MdRiceBowl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25zm-2 0h-4V5.08c2.39 1.39 4 3.97 4 6.92zm-6-7.74V12h-4V4.26c.64-.16 1.31-.26 2-.26s1.36.1 2 .26zM4 12c0-2.95 1.61-5.53 4-6.92V12H4z"
                }
            }
        ]
    })(props);
}
function MdRoofing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h-2v-2h2v2zm2-4H9v6h6v-6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7z"
                }
            }
        ]
    })(props);
}
function MdRoomPreferences(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11.26V6h3v4h2V4h-5V3H5v16H3v2h9.26A6.963 6.963 0 0111 17c0-2.38 1.19-4.47 3-5.74zM10 11h2v2h-2v-2zm11.69 5.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L19 12h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L17 22h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM18 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdRoomService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20v2H2zm11.84-9.21A2.006 2.006 0 0012 5a2.006 2.006 0 00-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
                }
            }
        ]
    })(props);
}
function MdRvHookup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M14 11h4v3h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z"
                }
            }
        ]
    })(props);
}
function MdSmokeFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2a3.35 3.35 0 000 6.7zm2.5 7.23V13h-2.93z"
                }
            }
        ]
    })(props);
}
function MdSmokingRooms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 000 6.7h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
                }
            }
        ]
    })(props);
}
function MdSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75a1.25 1.25 0 000-2.5H12v-1h6.75a1.25 1.25 0 000-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 00-.12-1.23C10.22 6.12 9.12 5 9.12 5zM14 6.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75m0-1.5c-1.24 0-2.25 1.01-2.25 2.25S12.76 9.25 14 9.25 16.25 8.24 16.25 7 15.24 4.75 14 4.75zm5.75.75c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m0-1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM16.5 1c-.83 0-1.5.67-1.5 1.5S15.67 4 16.5 4 18 3.33 18 2.5 17.33 1 16.5 1z"
                }
            }
        ]
    })(props);
}
function MdSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm13.97 21.49c-.63.23-1.29.4-1.97.51.68-.12 1.33-.29 1.97-.51zM12 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.55 12zm10.43-1.61zM15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63a12.188 12.188 0 00-3.55 7.63c1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
                }
            }
        ]
    })(props);
}
function MdSportsBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-1.56c.35-.59.56-1.27.56-2 0-2.21-1.79-4-4-4-.34 0-.66.05-.98.13A4.707 4.707 0 0010 2.02c-1.89 0-3.51 1.11-4.27 2.71C4.15 5.26 3 6.74 3 8.5c0 1.86 1.28 3.41 3 3.86V21h11v-2h2c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2zM7 10.5c-1.1 0-2-.9-2-2 0-.85.55-1.6 1.37-1.88l.8-.27.36-.76C8 4.62 8.94 4.02 10 4.02c.79 0 1.39.35 1.74.65l.78.65S13.16 5 13.99 5c1.1 0 2 .9 2 2h-3C9.67 7 9.15 10.5 7 10.5zM19 17h-2v-6h2v6z"
                }
            }
        ]
    })(props);
}
function MdStairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 5h-2.42v3.33H13v3.33h-2.58V18H6v-2h2.42v-3.33H11V9.33h2.58V6H18v2z"
                }
            }
        ]
    })(props);
}
function MdStorefront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41a1.42 1.42 0 01-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
                }
            }
        ]
    })(props);
}
function MdStroller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7v-.52C22 4.56 20.52 3 18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-8.8 10.32C6.12 16 6.58 17 7.43 17H15c1.1 0 2-.9 2-2V6.27c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2zM14.3 4.1a8.962 8.962 0 00-9.58.62l4.89 4.89L14.3 4.1z"
                }
            }
        ]
    })(props);
}
function MdTapas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V1h-8v9c0 1.86 1.28 3.41 3 3.86V21h-2v2h6v-2h-2v-7.14c1.72-.45 3-2 3-3.86zm-2-7v3h-4V3h4zm-7.5 8.5A2.5 2.5 0 0110 14H8v9H6v-9H4a2.5 2.5 0 010-5h2V8H4a2.5 2.5 0 010-5h2V1h2v2h2a2.5 2.5 0 010 5H8v1h2a2.5 2.5 0 012.5 2.5z"
                }
            }
        ]
    })(props);
}
function MdTty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4h2v2h-2V4zm-1 3h2v2h-2V7zm-2-3h2v2h-2V4zm7 5h-2V7h2v2zm1-3h-2V4h2v2zm2 3h-2V7h2v2zm1-3h-2V4h2v2zm-7.38 8.38L12.1 16.9c-2.5-1.43-4.57-3.5-6-6l2.52-2.52c.24-.24.34-.58.28-.9L8.16 3.8c-.09-.46-.5-.8-.98-.8H3.03c-.56 0-1.03.47-1 1.03.17 2.89 1.02 5.6 2.4 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.23 7.97 2.4.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73a.99.99 0 00-.91.27zM14 10h2v2h-2v-2zm-3 0h2v2h-2v-2zm8 2h-2v-2h2v2zm3 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.92L13 5.77V3.4c0-.26.22-.48.5-.48s.5.21.5.48V4h2v-.6C16 2.07 14.88 1 13.5 1S11 2.07 11 3.4v2.37L9.5 6.92 6 6.07l5.05 15.25c.15.45.55.68.95.68s.8-.23.95-.69L18 6.07l-3.5.85zM13.28 8.5l.76.58.92-.23L13 14.8V8.29l.28.21zm-3.32.59l.76-.58.28-.22v6.51L9.03 8.86l.93.23z"
                }
            }
        ]
    })(props);
}
function MdVapeFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zM16.17 19H8v-3h5.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-3.6-3.6zm2.66-3H22v3h-.17l-3-3zM11 17.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zM11.15 8.32V8.3c0-1.85 1.5-3.35 3.35-3.35v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05h-1.55l-3.33-3.33z"
                }
            }
        ]
    })(props);
}
function MdVapingRooms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zm20-.5v3H8v-3h14zm-11 1.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zm-2.5.6V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05H14.5a3.35 3.35 0 010-6.7v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16z"
                }
            }
        ]
    })(props);
}
function MdVilla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21H3V8l13-5v7H7v11zm12-11c-1.1 0-2 .9-2 2H9v9h5v-5h2v5h5v-9c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 8A2.5 2.5 0 0021 5.5C21 3.83 18.5 1 18.5 1S16 3.83 16 5.5A2.5 2.5 0 0018.5 8zm-5 1c.83 0 1.5-.67 1.5-1.5 0-.84-1.5-2.5-1.5-2.5S12 6.66 12 7.5c0 .83.67 1.5 1.5 1.5zM9.12 5l-7.18 6.79c-.6.56-.94 1.35-.94 2.18V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75a1.25 1.25 0 000-2.5H12v-1h6.75a1.25 1.25 0 000-2.5H8.86c.64-1.11 1.48-2.58 1.49-2.61a1.065 1.065 0 00-.12-1.23C10.22 6.12 9.12 5 9.12 5z"
                }
            }
        ]
    })(props);
}
function MdWaterDamage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 12h3v8h14v-8h3L12 3zm0 13c-1.1 0-2-.9-2-2s2-4 2-4 2 2.9 2 4-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdWheelchairPickup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm5.5 6.95V9c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v6h2v7h3.5v-.11c-1.24-1.26-2-2.99-2-4.89 0-2.58 1.41-4.84 3.5-6.05zM16.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3c0-1.11.61-2.06 1.5-2.58v-2.16c-2.02.64-3.5 2.51-3.5 4.74 0 2.76 2.24 5 5 5s5-2.24 5-5h-2zm3.04-3H15V8h-2v8h5.46l2.47 3.71 1.66-1.11-3.05-4.6z"
                }
            }
        ]
    })(props);
}
function MdBathroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0-3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-3H7v-1c0-2.76 2.24-5 5-5s5 2.24 5 5v1z"
                }
            }
        ]
    })(props);
}
function MdBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM14 7h4c.55 0 1 .45 1 1v2h-6V8c0-.55.45-1 1-1zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8z"
                }
            }
        ]
    })(props);
}
function MdBedroomBaby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 16c-2.64 0-5.13-1.03-7-2.9l1.06-1.06c.34.34.71.65 1.1.92L8 13.5V9.51l-1.55.99-.95-1L7 7.76 6 7h3.65l1.73 3H17v1h-1v2.5l.84 1.46c.39-.28.76-.58 1.1-.92L19 15.1a9.842 9.842 0 01-7 2.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.69 14.24a7.72 7.72 0 01-5.4 0l-.81 1.41-.03.06c1.1.52 2.28.79 3.53.79s2.45-.28 3.55-.79l-.03-.06-.81-1.41z"
                }
            }
        ]
    })(props);
}
function MdBedroomChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.5h6v2H9zM15.64 12H8.37a.87.87 0 00-.87.87h.01V14h9v-1.13a.87.87 0 00-.87-.87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 15h-1.5v-1.5h-9V17H6v-4.13c0-1 .62-1.85 1.5-2.2V9c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2v1.67c.88.35 1.5 1.2 1.5 2.2V17z"
                }
            }
        ]
    })(props);
}
function MdBedroomParent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12h-9c-.55 0-1 .45-1 1v1h11v-1c0-.55-.45-1-1-1zM7.25 8.5h4v2h-4zM12.75 8.5h4v2h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 15h-1.5v-1.5h-11V17H5v-3.83c0-.66.25-1.26.65-1.72V9c0-1.1.9-2 2-2H11c.37 0 .72.12 1 .32.28-.2.63-.32 1-.32h3.35c1.1 0 2 .9 2 2v2.45c.4.46.65 1.06.65 1.72V17z"
                }
            }
        ]
    })(props);
}
function MdBlender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.13 15.13L18 3h-4V2h-4v1H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2.23l.64 4.13C6.74 16.05 6 17.43 6 19v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1c0-1.57-.74-2.95-1.87-3.87zM5 9V5h1.31l.62 4H5zm7 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.29-5H9.72L8.33 5h7.34l-1.38 9z"
                }
            }
        ]
    })(props);
}
function MdCameraIndoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm4 13.06L14 15v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1l2-1.06v4.12z"
                }
            }
        ]
    })(props);
}
function MdCameraOutdoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L18 14v-1zM12 3L4 9v12h16v-2H6v-9l6-4.5 6 4.5v1h2V9l-8-6z"
                }
            }
        ]
    })(props);
}
function MdChairAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h1v2H7c-1.1 0-2 .9-2 2v7h2v-3h10v3h2v-7c0-1.1-.9-2-2-2h-1v-2h1zM7 8V5h10v3H7zm10 8H7v-2h10v2zm-3-4h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function MdChair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2c0-1.86 1.28-3.41 3-3.86V6c0-1.65-1.35-3-3-3H7C5.35 3 4 4.35 4 6v1.14c1.72.45 3 2 3 3.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9c-1.1 0-2 .9-2 2v4H5v-4c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.65 1.35 3 3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1h12v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.65 0 3-1.35 3-3v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdCoffeeMaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h2V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14v-2h-4.03A4.966 4.966 0 0018 16v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3zM16 5v3H6V5h10zm2.5 3H18V5h.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8zM4 19h16v2H4v-2z"
                }
            }
        ]
    })(props);
}
function MdDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-9 8.3c0 .93-.64 1.71-1.5 1.93V19H8v-6.77c-.86-.22-1.5-1-1.5-1.93V6.5c0-.28.22-.5.5-.5s.5.22.5.5V9h.75V6.5c0-.28.22-.5.5-.5s.5.22.5.5V9H10V6.5c0-.28.23-.5.5-.5.28 0 .5.22.5.5v3.8zm4.58 2.29l-.08.03V19H14v-6.38l-.08-.04c-.97-.47-1.67-1.7-1.67-3.18 0-1.88 1.13-3.4 2.5-3.4 1.38 0 2.5 1.53 2.5 3.41 0 1.48-.7 2.71-1.67 3.18z"
                }
            }
        ]
    })(props);
}
function MdDoorBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-8-6H9v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdDoorFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-4-6h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdDoorSliding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V5c0-1.1-.9-2-2-2h-5.25v16h-1.5V3H6c-1.1 0-2 .9-2 2v14H3v2h18v-2h-1zm-10-6H8v-2h2v2zm6 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdDoorbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L4 9v12h16V9l-8-6zm0 14.5c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1zm4-1.5H8v-1h1v-2.34c0-1.54.82-2.82 2.25-3.16v-.25c0-.41.34-.75.75-.75s.75.34.75.75v.25c1.44.34 2.25 1.62 2.25 3.16V15h1v1z"
                }
            }
        ]
    })(props);
}
function MdFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8l-5-5zM7 7h5v2H7V7zm10 10H7v-2h10v2zm0-4H7v-2h10v2zm-2-4V5l4 4h-4z"
                }
            }
        ]
    })(props);
}
function MdFlatware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.08c0 1.77-.84 3.25-2 3.82V21h-2V10.9c-1.16-.57-2-2.05-2-3.82C10.01 4.83 11.35 3 13 3c1.66 0 3 1.83 3 4.08zM17 3v18h2v-8h2V7c0-1.76-1.24-4-4-4zM8.28 3c-.4 0-.72.32-.72.72V7h-.84V3.72C6.72 3.32 6.4 3 6 3s-.72.32-.72.72V7h-.84V3.72c0-.4-.32-.72-.72-.72S3 3.32 3 3.72V9c0 1.1.9 2 2 2v10h2V11c1.1 0 2-.9 2-2V3.72c0-.4-.32-.72-.72-.72z"
                }
            }
        ]
    })(props);
}
function MdGarage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.33 7.5l-.66 2h8.66l-.66-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 15.69c0 .45-.35.81-.78.81h-.44c-.44 0-.78-.36-.78-.81V16.5H7v1.19c0 .45-.35.81-.78.81h-.44c-.43 0-.78-.36-.78-.81v-6.5c.82-2.47 1.34-4.03 1.56-4.69.05-.16.12-.29.19-.4.02-.02.03-.04.05-.06.38-.53.92-.54.92-.54h8.56s.54.01.92.53c.02.03.03.05.05.07.07.11.14.24.19.4.22.66.74 2.23 1.56 4.69v6.5z"
                }
            }
        ]
    })(props);
}
function MdLight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.06V3h-2v3.06c-4.5.5-8 4.31-8 8.93C3 16.1 3.9 17 5.01 17H8c0 2.21 1.79 4 4 4s4-1.79 4-4h2.99c1.11 0 2.01-.9 2.01-2.01 0-4.62-3.5-8.43-8-8.93zM12 15H5c0-3.86 3.14-7 7-7s7 3.14 7 7h-7z"
                }
            }
        ]
    })(props);
}
function MdLiving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 11.5c-.55 0-1 .45-1 1v2h-7v-2c0-.55-.45-1-1-1s-1 .45-1 1V16c0 .28.22.5.5.5h10c.28 0 .5-.22.5-.5v-3.5c0-.55-.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12.5v.5h4v-.5c0-1.3.99-2.35 2.25-2.47V9c0-.83-.67-1.5-1.5-1.5h-5.5c-.83 0-1.5.67-1.5 1.5v1.03A2.48 2.48 0 0110 12.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 14c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-3.5c0-.92.51-1.72 1.25-2.15V9c0-1.66 1.34-3 3-3h5.5c1.66 0 3 1.34 3 3v1.35c.74.43 1.25 1.23 1.25 2.15V16z"
                }
            }
        ]
    })(props);
}
function MdManageSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9H2V7h5v2zm0 3H2v2h5v-2zm13.59 7l-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L22 17.59 20.59 19zM17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zM2 19h10v-2H2v2z"
                }
            }
        ]
    })(props);
}
function MdPodcasts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.957 3.957 0 018 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0018 12c0-3.31-2.69-6-6-6zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.987 7.987 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function MdShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.08V3h-2v2.08C7.61 5.57 5 8.47 5 12v2h14v-2c0-3.53-2.61-6.43-6-6.92z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "20",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "20",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdTableBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.5C22 5.57 17.52 4 12 4S2 5.57 2 7.5c0 1.81 3.95 3.31 9 3.48V15H9.35c-.82 0-1.55.5-1.86 1.26L6 20h2l1.2-3h5.6l1.2 3h2l-1.5-3.74c-.3-.76-1.04-1.26-1.85-1.26H13v-4.02c5.05-.17 9-1.67 9-3.48z"
                }
            }
        ]
    })(props);
}
function MdTableRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 9.73l-1.43-5a.996.996 0 00-.96-.73H4.43c-.45 0-.84.3-.96.73l-1.43 5c-.18.63.3 1.27.96 1.27h2.2L4 20h2l.67-5h10.67l.66 5h2l-1.2-9H21c.66 0 1.14-.64.96-1.27zM6.93 13l.27-2h9.6l.27 2H6.93z"
                }
            }
        ]
    })(props);
}
function MdWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11V3H5c-1.1 0-2 .9-2 2v6h8zm2 0h8V5c0-1.1-.9-2-2-2h-6v8zm-2 2H3v6c0 1.1.9 2 2 2h6v-8zm2 0v8h6c1.1 0 2-.9 2-2v-6h-8z"
                }
            }
        ]
    })(props);
}
function MdYard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 8.22a1.562 1.562 0 012.45-1.28l-.01-.12c0-.86.7-1.56 1.56-1.56s1.56.7 1.56 1.56l-.01.12A1.562 1.562 0 0116 8.22c0 .62-.37 1.16-.89 1.4.52.25.89.79.89 1.41 0 .86-.7 1.56-1.56 1.56-.33 0-.64-.11-.89-.28l.01.12c0 .86-.7 1.56-1.56 1.56s-1.56-.7-1.56-1.56l.01-.12A1.562 1.562 0 018 11.03c0-.62.37-1.16.89-1.4C8.37 9.38 8 8.84 8 8.22zM12 19c-3.31 0-6-2.69-6-6 3.31 0 6 2.69 6 6 0-3.31 2.69-6 6-6 0 3.31-2.69 6-6 6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9.62",
                    "r": "1.56"
                }
            }
        ]
    })(props);
}
function Md18UpRating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h1.5V14H13zM13 10h1.5v1.5H13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 12H8.5v-4.5H7V9h3v6zm6-1c0 .55-.45 1-1 1h-2.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H15c.55 0 1 .45 1 1v4z"
                }
            }
        ]
    })(props);
}
function Md6FtApart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 9.43V10h8v-.57zM18 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 9.43V10h8v-.57zM19 17v-2.01L5 15v2l-3-3 3-3v2.01L19 13v-2l3 3-3 3zm-9 2v-1H7.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5V20c0-.28-.22-.5-.5-.5H8V19h2zm-1 1.5v.5H8v-.5h1zm8.5-1.5h-1v3h-1v-3h-1v-1h3v1zm-5 0v.5h1v1h-1V22h-1v-4H14v1h-1.5z"
                }
            }
        ]
    })(props);
}
function MdAddModerator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.22 22.61c-.4.15-.8.29-1.22.39-5.16-1.26-9-6.45-9-12V5l9-4 9 4v6c0 .9-.11 1.78-.3 2.65-.81-.41-1.73-.65-2.7-.65-3.31 0-6 2.69-6 6 0 1.36.46 2.61 1.22 3.61zM19 20v2.99s-1.99.01-2 0V20h-3v-2h3v-3h2v3h3v2h-3z"
                }
            }
        ]
    })(props);
}
function MdAddReaction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9V7h-2V2.84A9.929 9.929 0 0011.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12c0-1.05-.17-2.05-.47-3H18zm-2.5-1c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-7 0c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zm3.5 9.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5zM22 3h2v2h-2v2h-2V5h-2V3h2V1h2v2z"
                }
            }
        ]
    })(props);
}
function MdArchitecture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.36 18.78L6.61 21l1.62-1.54 2.77-7.6c-.68-.17-1.28-.51-1.77-.98l-2.87 7.9zM14.77 10.88c-.49.47-1.1.81-1.77.98l2.77 7.6L17.39 21l.26-2.22-2.88-7.9zM15 8c0-1.3-.84-2.4-2-2.82V3h-2v2.18C9.84 5.6 9 6.7 9 8c0 1.66 1.34 3 3 3s3-1.34 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdAssistWalker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "4.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 17.72l-.64-6.37A1.49 1.49 0 0017.64 10H16c-1.5-.02-2.86-.54-3.76-1.44l-2-1.98A1.95 1.95 0 008.83 6c-.51 0-1.02.2-1.41.59L4.08 9.91c-.53.68-.51 1.57-.21 2.13l1.43 2.8-3.15 4.05 1.57 1.24L7.4 15.4l-.17-1.36.77.71V20h2v-6.12l-2.12-2.12 2.36-2.36c.94.94 1.72 1.82 3.59 2.32L13 20h1.5l.41-3.5h3.18l.14 1.22c-.44.26-.73.74-.73 1.28 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.54-.29-1.02-.73-1.28zM15.09 15l.41-3.5h2l.41 3.5h-2.82z"
                }
            }
        ]
    })(props);
}
function MdBackHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 24c-3.26 0-6.19-1.99-7.4-5.02l-3.03-7.61a1 1 0 011.24-1.32l.79.26c.56.18 1.02.61 1.24 1.16L7.25 15H8V3.25a1.25 1.25 0 012.5 0V12h1V1.25a1.25 1.25 0 012.5 0V12h1V2.75a1.25 1.25 0 012.5 0V12h1V5.75a1.25 1.25 0 012.5 0V16c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdBlind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "3.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.13 7.12c-.17-.35-.44-.65-.8-.85a1.98 1.98 0 00-1.93-.03v-.01L4 9.3V14h2v-3.54l1.5-.85C7.18 10.71 7 11.85 7 13v5.33L4.4 21.8 6 23l3-4 .22-3.54L11 18v5h2v-6.5l-1.97-2.81c-.04-.52-.14-1.76.45-3.4.75 1.14 1.88 1.98 3.2 2.41L20.63 23l.87-.5-5.48-9.5H17v-2c-.49 0-2.88.17-4.08-2.21"
                }
            }
        ]
    })(props);
}
function MdBoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zM14 20v-5h1v-4.5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2V15h1v5h4z"
                }
            }
        ]
    })(props);
}
function MdCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a2 2 0 002-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
                }
            }
        ]
    })(props);
}
function MdCatchingPokemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12a2.5 2.5 0 01-5 0 2.5 2.5 0 015 0zm7.5 0c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zm-2 0h-4c0-2.21-1.79-4-4-4s-4 1.79-4 4H4c0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function MdCleanHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.99 5l.63 1.37 1.37.63-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63.63-1.37M11 6.13V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.899 4.899 0 0013 2H7.5v2H9v2.14A5.007 5.007 0 005.26 9.5h3.98L15 11.65v-.62a5 5 0 00-4-4.9zM1 22h4V11H1v11zm19-5h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2zm0-3c1.1 0 2-.9 2-2s-2-4-2-4-2 2.9-2 4 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdCo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5h-2v-3h2v3zM8 13v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H6.5v-.5h-2v3h2V13H8zm12.5 2.5h-2v1h3V18H17v-2.5c0-.55.45-1 1-1h2v-1h-3V12h3.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdCompost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 11.81A2.5 2.5 0 0115 8h1c1.51 0 2-1 2-1s.55 6-3 6c-.49 0-.94-.14-1.32-.38-.24.64-.59 1.76-.76 2.96 1.26.22 2.28.89 2.77 1.77A6.505 6.505 0 0018.5 12h3c0 5.24-4.26 9.5-9.5 9.5S2.5 17.24 2.5 12 6.76 2.5 12 2.5V0l4 4-4 4V5.5c-3.58 0-6.5 2.92-6.5 6.5 0 2.21 1.11 4.17 2.81 5.35.51-.92 1.63-1.62 2.98-1.8-.09-.69-.26-1.42-.49-2.03-.35.3-.8.48-1.3.48-1.1 0-2-.9-2-2v-.99c0-.56-.19-1.09-.5-1.51 0 0 4.45-.23 4.5 2.5 0 .29-.06.56-.17.8-.42-.32-.86-.6-1.33-.8.58.43 1.37 1.37 2 2.6.67-1.62 1.68-3.27 3-4.6-.76.52-1.47 1.12-2.13 1.81z"
                }
            }
        ]
    })(props);
}
function MdConnectWithoutContact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H9a9 9 0 019-9v2c-3.87 0-7 3.13-7 7zm7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3zM7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm4.45.5h-2A2.99 2.99 0 016.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.97 4.97 0 003.45-4.24zM19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1h-3a2.99 2.99 0 01-2.95-2.5h-2A4.97 4.97 0 0016 19.74V22h6v-2.5c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdConstruction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.783 15.172l2.121-2.121 5.996 5.996-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49a3 3 0 00-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z"
                }
            }
        ]
    })(props);
}
function MdCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 10.99c-1.79-.03-3.7-1.95-2.68-4.22-2.98 1-5.77-1.59-5.19-4.56C6.95.71 2 6.58 2 12c0 5.52 4.48 10 10 10 5.89 0 10.54-5.08 9.95-11.01zM8.5 15c-.83 0-1.5-.67-1.5-1.5S7.67 12 8.5 12s1.5.67 1.5 1.5S9.33 15 8.5 15zm2-5C9.67 10 9 9.33 9 8.5S9.67 7 10.5 7s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdCoronavirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.25 10.5c-.41 0-.75.34-.75.75h-1.54a6.978 6.978 0 00-1.52-3.65l1.09-1.09.01.01c.29.29.77.29 1.06 0s.29-.77 0-1.06L18.54 4.4a.754.754 0 00-1.06 0c-.29.29-.29.76-.01 1.05l-1.09 1.09a7.015 7.015 0 00-3.64-1.51V3.5h.01c.41 0 .75-.34.75-.75S13.16 2 12.75 2h-1.5c-.41 0-.75.34-.75.75s.33.74.74.75v1.55c-1.37.14-2.62.69-3.64 1.51L6.51 5.47l.01-.01c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0L4.4 5.46c-.29.29-.29.77 0 1.06.29.29.76.29 1.05.01l1.09 1.09a6.89 6.89 0 00-1.5 3.63H3.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5c0 .41.34.75.75.75s.75-.34.75-.75h1.54c.15 1.37.69 2.61 1.5 3.63l-1.09 1.09a.742.742 0 00-1.05.01c-.29.29-.29.77 0 1.06l1.06 1.06c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.01-.01 1.09-1.09c1.02.82 2.26 1.36 3.63 1.51v1.55c-.41.01-.74.34-.74.75s.34.75.75.75h1.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-.01v-1.54c1.37-.14 2.62-.69 3.64-1.51l1.09 1.09c-.29.29-.28.76.01 1.05.29.29.77.29 1.06 0l1.06-1.06c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0l-.01.01-1.09-1.09a7.025 7.025 0 001.52-3.65h1.54c0 .41.34.75.75.75s.75-.34.75-.75v-1.5c.01-.4-.33-.74-.74-.74zM13.75 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1.75-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM8.5 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1.75 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm3.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm.75-4c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
                }
            }
        ]
    })(props);
}
function MdCrueltyFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.84 14.52c-.26-.19-.62-.63-.79-.84C17.24 12.01 19 8.87 19 5c0-1.95-.74-3-2-3-1.54 0-3.96 2.06-5 5.97C10.96 4.06 8.54 2 7 2 5.74 2 5 3.05 5 5c0 3.87 1.76 7.01 2.95 8.68-.17.21-.53.65-.79.84-.5.41-1.66 1.37-1.66 2.98 0 2.21 1.79 4 4 4 1.55 0 2.5-.56 2.5-.56s.95.56 2.5.56c2.21 0 4-1.79 4-4 0-1.61-1.16-2.57-1.66-2.98zM9.35 12.2C8.34 10.7 7 8.12 7 5c0-.49.06-.8.12-.97.94.31 3.24 2.71 3.38 7.64-.47.12-.84.3-1.15.53zm1.15 4.55c-.28 0-.5-.34-.5-.75s.22-.75.5-.75.5.34.5.75-.22.75-.5.75zM12 19.5c-.55 0-1-.72-1-1s.45-.5 1-.5 1 .22 1 .5-.45 1-1 1zm1.5-2.75c-.28 0-.5-.34-.5-.75s.22-.75.5-.75.5.34.5.75-.22.75-.5.75zm0-5.08c.14-4.93 2.44-7.33 3.38-7.64.06.17.12.48.12.97 0 3.12-1.34 5.7-2.35 7.2-.31-.23-.68-.41-1.15-.53z"
                }
            }
        ]
    })(props);
}
function MdCyclone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.47V5.35C20.05 4.77 16.56 4 12 4c-2.15 0-4.11.86-5.54 2.24.13-.85.4-2.4 1.01-4.24H5.35C4.77 3.95 4 7.44 4 12c0 2.15.86 4.11 2.24 5.54-.85-.14-2.4-.4-4.24-1.01v2.12C3.95 19.23 7.44 20 12 20c2.15 0 4.11-.86 5.54-2.24-.14.85-.4 2.4-1.01 4.24h2.12c.58-1.95 1.35-5.44 1.35-10 0-2.15-.86-4.11-2.24-5.54.85.13 2.4.4 4.24 1.01zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdDeck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9L12 2 2 9h9v13h2V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
                }
            }
        ]
    })(props);
}
function MdDewPoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13V5c0-1.66-1.34-3-3-3S6 3.34 6 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1H9v1h1v2H9v1h1v1H8zm13-4.5c0-.84-1.5-2.5-1.5-2.5S18 5.66 18 6.5c0 .83.67 1.5 1.5 1.5S21 7.33 21 6.5zm-4 3c0-.84-1.5-2.5-1.5-2.5S14 8.66 14 9.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5zm4 3c0-.84-1.5-2.5-1.5-2.5S18 11.66 18 12.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdDiversity1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.22 17.58A2.01 2.01 0 000 19.43V21h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.78 17.58A6.95 6.95 0 0020 17c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V21H24v-1.57c0-.81-.48-1.53-1.22-1.85zM16.24 16.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 19.39V21h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.48 10.86C2.17 10.1 2 9.36 2 8.6 2 6.02 4.02 4 6.6 4c2.68 0 3.82 1.74 5.4 3.59C13.57 5.76 14.7 4 17.4 4 19.98 4 22 6.02 22 8.6c0 .76-.17 1.5-.48 2.26.65.31 1.18.82 1.53 1.44.6-1.2.95-2.42.95-3.7C24 4.9 21.1 2 17.4 2c-2.09 0-4.09.97-5.4 2.51C10.69 2.97 8.69 2 6.6 2 2.9 2 0 4.9 0 8.6c0 1.28.35 2.5.96 3.7.35-.62.88-1.13 1.52-1.44z"
                }
            }
        ]
    })(props);
}
function MdDiversity2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 15.9l1.42-1.42C8.79 12.05 7 10.41 7 8.85 7 7.8 7.8 7 8.85 7c1.11 0 1.54.65 2.68 2h.93c1.12-1.31 1.53-2 2.68-2 .87 0 1.55.54 1.77 1.32.35-.04.68-.06 1-.06.36 0 .7.03 1.03.08C18.7 6.43 17.13 5 15.15 5c-.12 0-.23.03-.35.04.12-.33.2-.67.2-1.04 0-1.66-1.34-3-3-3S9 2.34 9 4c0 .37.08.71.2 1.04-.12-.01-.23-.04-.35-.04C6.69 5 5 6.69 5 8.85c0 2.42 2.04 4.31 5.1 7.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16.24c-.32-.18-.66-.29-1-.35.07-.1.15-.18.21-.28 1.08-1.87.46-4.18-1.41-5.26-2.09-1.21-4.76-.39-8.65.9l.52 1.94c3.47-1.14 5.79-1.88 7.14-1.1.91.53 1.2 1.61.68 2.53-.56.96-1.33 1-3.07 1.32l-.47.81c.58 1.62.97 2.33.39 3.32-.53.91-1.61 1.2-2.53.68-.06-.03-.11-.09-.17-.13-.3.67-.64 1.24-1.03 1.73.07.04.13.09.2.14 1.87 1.08 4.18.46 5.26-1.41.06-.1.09-.21.14-.32.22.27.48.51.8.69 1.43.83 3.27.34 4.1-1.1s.32-3.29-1.11-4.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.32 14.01c-.74 3.58-1.27 5.95-2.62 6.73-.91.53-2 .24-2.53-.68-.56-.96-.2-1.66.39-3.32l-.46-.81c-1.7-.31-2.5-.33-3.07-1.32-.53-.91-.24-2 .68-2.53.09-.05.19-.08.29-.11-.35-.56-.64-1.17-.82-1.85-.16.07-.32.14-.48.23-1.87 1.08-2.49 3.39-1.41 5.26.06.1.14.18.21.28-.34.06-.68.17-1 .35-1.43.83-1.93 2.66-1.1 4.1s2.66 1.93 4.1 1.1c.32-.18.58-.42.8-.69.05.11.08.22.14.32 1.08 1.87 3.39 2.49 5.26 1.41 2.09-1.21 2.71-3.93 3.55-7.94l-1.93-.53z"
                }
            }
        ]
    })(props);
}
function MdDiversity3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.32 13.01c.96.02 1.85.5 2.45 1.34A3.961 3.961 0 0012 16c1.29 0 2.5-.62 3.23-1.66.6-.84 1.49-1.32 2.45-1.34-.72-1.22-3.6-2-5.68-2-2.07 0-4.96.78-5.68 2.01zM4 13c1.66 0 3-1.34 3-3S5.66 7 4 7s-3 1.34-3 3 1.34 3 3 3zM20 13c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM12 10c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h-3.27c-.77 0-1.35.45-1.68.92-.04.06-1.36 2.08-4.05 2.08-1.43 0-3.03-.64-4.05-2.08-.39-.55-1-.92-1.68-.92H3c-1.1 0-2 .9-2 2v4h7v-2.26c1.15.8 2.54 1.26 4 1.26s2.85-.46 4-1.26V20h7v-4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdDomainAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h14v-2h-4v-2h2v-2h-2v-2h2v-2h-2V9h8v6h2V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm14 12v2h-2v2h-2v-2h-2v-2h2v-2h2v2h2zm-6-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdDomain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdDownhillSkiing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2.72 16.4l.76.27a5.933 5.933 0 004.34-.17L22 22.13c-1.05.55-2.24.87-3.5.87-.86 0-1.68-.14-2.45-.41L2 17.47l.5-1.41 6.9 2.51 1.72-4.44-3.57-3.73c-.89-.94-.67-2.47.45-3.12l3.48-2.01c1.1-.64 2.52-.1 2.91 1.11l.33 1.08a5.017 5.017 0 002.83 3.14l.52-1.6 1.43.46-1.12 3.45A7.029 7.029 0 0113 8.59l-2.53 1.45 3.03 3.46-2.22 5.76 3.09 1.12 2.1-6.44c.46.18.94.31 1.44.41l-2.13 6.55z"
                }
            }
        ]
    })(props);
}
function MdEditNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.58 6.25l1.77 1.77L14.37 13H12.6v-1.77l4.98-4.98zm3.27-.44l-1.06-1.06c-.2-.2-.51-.2-.71 0l-.85.85L20 7.37l.85-.85c.2-.2.2-.52 0-.71zM18 12.2V17h2v2H4v-2h2v-7c0-2.79 1.91-5.14 4.5-5.8v-.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.7c.82.21 1.57.59 2.21 1.09L10.6 10.4V15h4.6l2.8-2.8zM10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function MdElderlyWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-1.56 0-2.92-.9-3.58-2.21l-.79-1.67C14.12 7.1 13.63 6 12.34 6 8.72 6 6 16.69 6 19h2.5l-2.1 2.8L8 23l3-4h2v4h2v-4.03L13 13l.49-2.71A6.02 6.02 0 0017 12.81v.69h1v-1c0-.28.22-.5.5-.5s.5.22.5.5V23h1V12.5c0-.83-.67-1.5-1.5-1.5zM11.6 2.91c-.06.19-.1.38-.1.59 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2c-.21 0-.4.04-.59.1-.15-.35-.5-.6-.91-.6-.55 0-1 .45-1 1 0 .41.25.76.6.91z"
                }
            }
        ]
    })(props);
}
function MdElderly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6.5 7V23h-1V12.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v1h-1v-.69a6.02 6.02 0 01-3.51-2.52c-.31.87-.49 1.78-.49 2.71 0 .23.02.46.03.69L15 16.5V23h-2v-5l-1.78-2.54L11 19l-3 4-1.6-1.2L9 18.33V13c0-1.15.18-2.29.5-3.39l-1.5.85V14H6V9.3l5.4-3.07v.01a2 2 0 011.94.03c.36.21.63.51.8.85l.79 1.67A3.987 3.987 0 0018.5 11c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdEmojiEmotions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8zM12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4zm3.5-7c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdEmojiEvents(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-2 2.82V7h2v1z"
                }
            }
        ]
    })(props);
}
function MdEmojiFlags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function MdEmojiFoodBeverage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H9v2.4l1.81 1.45c.12.09.19.24.19.39v4.26c0 .28-.22.5-.5.5h-4c-.28 0-.5-.22-.5-.5V7.24c0-.15.07-.3.19-.39L8 5.4V3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
                }
            }
        ]
    })(props);
}
function MdEmojiNature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.94 4.88A1.32 1.32 0 0020.68 4H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17-.16.16-.3.34-.43.53L6 10.52a3.01 3.01 0 00-3.83 1.82c-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91a3.981 3.981 0 003.91 1c.29.42.68.77 1.16 1 .42.2.85.3 1.29.3.34 0 .68-.06 1.01-.17a3.007 3.007 0 001.82-3.85l-.52-1.37c.18-.13.36-.27.53-.43.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-8.82 3.78c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04a.989.989 0 01-.51-.57c-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12a.673.673 0 00-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6a1.966 1.966 0 012.67.13c.73.73.77 1.88.13 2.67z"
                }
            }
        ]
    })(props);
}
function MdEmojiObjects(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28a1.98 1.98 0 003.44 0H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46A6.956 6.956 0 0019 10c0-3.87-3.13-7-7-7zm2 16h-4v-1h4v1zm0-2h-4v-1h4v1zm-1.5-5.59V14h-1v-2.59L9.67 9.59l.71-.71L12 10.5l1.62-1.62.71.71-1.83 1.82z"
                }
            }
        ]
    })(props);
}
function MdEmojiPeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
                }
            }
        ]
    })(props);
}
function MdEmojiSymbols(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.404 20.182l7.778-7.778 1.414 1.414-7.778 7.778z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11A2.5 2.5 0 0018 8.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 000 5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35a2.499 2.499 0 00-1.77-4.27 2.499 2.499 0 00-1.77 4.27l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36a.501.501 0 010-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15a.513.513 0 010-.71l1.06-1.06.71.71-1.07 1.06z"
                }
            }
        ]
    })(props);
}
function MdEmojiTransportation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
                }
            }
        ]
    })(props);
}
function MdEngineering(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zM22.1 6.84c.01-.11.02-.22.02-.34 0-.12-.01-.23-.03-.34l.74-.58c.07-.05.08-.15.04-.22l-.7-1.21c-.04-.08-.14-.1-.21-.08l-.86.35c-.18-.14-.38-.25-.59-.34l-.13-.93A.182.182 0 0020.2 3h-1.4c-.09 0-.16.06-.17.15l-.13.93c-.21.09-.41.21-.59.34l-.87-.35c-.08-.03-.17 0-.21.08l-.7 1.21c-.04.08-.03.17.04.22l.74.58a1.953 1.953 0 000 .68l-.74.58c-.07.05-.08.15-.04.22l.7 1.21c.04.08.14.1.21.08l.87-.35c.18.14.38.25.59.34l.13.93c.01.09.08.15.17.15h1.4c.09 0 .16-.06.17-.15l.13-.93c.21-.09.41-.21.59-.34l.87.35c.08.03.17 0 .21-.08l.7-1.21c.04-.08.03-.17-.04-.22l-.73-.58zm-2.6.91a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19.92 11.68l-.5-.87c-.03-.06-.1-.08-.15-.06l-.62.25c-.13-.1-.27-.18-.42-.24l-.09-.66A.15.15 0 0018 10h-1c-.06 0-.11.04-.12.11l-.09.66c-.15.06-.29.15-.42.24l-.62-.25c-.06-.02-.12 0-.15.06l-.5.87c-.03.06-.02.12.03.16l.53.41c-.01.08-.02.16-.02.24 0 .08.01.17.02.24l-.53.41c-.05.04-.06.11-.03.16l.5.87c.03.06.1.08.15.06l.62-.25c.13.1.27.18.42.24l.09.66c.01.07.06.11.12.11h1c.06 0 .12-.04.12-.11l.09-.66c.15-.06.29-.15.42-.24l.62.25c.06.02.12 0 .15-.06l.5-.87c.03-.06.02-.12-.03-.16l-.52-.41c.01-.08.02-.16.02-.24 0-.08-.01-.17-.02-.24l.53-.41c.05-.04.06-.11.04-.17zm-2.42 1.65c-.46 0-.83-.38-.83-.83 0-.46.38-.83.83-.83s.83.38.83.83c0 .46-.37.83-.83.83zM4.74 9h8.53c.27 0 .49-.22.49-.49v-.02a.49.49 0 00-.49-.49H13c0-1.48-.81-2.75-2-3.45v.95c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.14C9.68 4.06 9.35 4 9 4s-.68.06-1 .14V5.5c0 .28-.22.5-.5.5S7 5.78 7 5.5v-.95C5.81 5.25 5 6.52 5 8h-.26a.49.49 0 00-.49.49v.03c0 .26.22.48.49.48zM9 13c1.86 0 3.41-1.28 3.86-3H5.14c.45 1.72 2 3 3.86 3z"
                }
            }
        ]
    })(props);
}
function MdFace2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.97 13.52v-.04C23.21 12.38 24 10.78 24 9c0-3.31-2.69-6-6-6-.26 0-.52.02-.78.06a5.98 5.98 0 00-10.44 0C6.52 3.02 6.26 3 6 3 2.69 3 0 5.69 0 9c0 1.78.79 3.38 2.02 4.48v.04A6.008 6.008 0 000 18c0 3.31 2.69 6 6 6 1.39 0 2.67-.48 3.69-1.28.74.18 1.51.28 2.31.28s1.57-.1 2.31-.28c1.02.8 2.3 1.28 3.69 1.28 3.31 0 6-2.69 6-6 0-1.78-.79-3.38-2.03-4.48zM12 21c-4.41 0-8-3.59-8-8 0-3.72 2.56-6.85 6-7.74v.05c0 3.34 2.72 6.06 6.06 6.06 1.26 0 2.45-.39 3.45-1.09.31.86.49 1.77.49 2.72 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "14",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "14",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdFace3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.91 11.96C22.39 6.32 17.66 2 12 2S1.61 6.32 1.09 11.96l-.9 9.86c-.1 1.17.82 2.18 2 2.18h19.62c1.18 0 2.1-1.01 1.99-2.18l-.89-9.86zM4.54 9.13c.87.55 1.89.87 2.96.87 1.86 0 3.5-.93 4.5-2.35C13 9.07 14.64 10 16.5 10c1.07 0 2.09-.32 2.96-.87.34.89.54 1.86.54 2.87 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-1.01.2-1.98.54-2.87z"
                }
            }
        ]
    })(props);
}
function MdFace4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-.96 0-1.88.14-2.75.39A4.986 4.986 0 005 0C2.24 0 0 2.24 0 5c0 1.8.96 3.37 2.39 4.25C2.14 10.12 2 11.04 2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.05.01-.1.01-.15 2.6-.98 4.68-2.99 5.74-5.55a9.942 9.942 0 009.92 3.46c.21.71.33 1.46.33 2.24 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdFace5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-1.12.23-2.18.65-3.15a.495.495 0 00.85-.35c0-.25-.19-.45-.43-.49.15-.26.32-.51.49-.75-.03.08-.06.15-.06.24 0 .28.22.5.5.5s.5-.22.5-.5S6.28 7 6 7c-.13 0-.25.05-.34.13.52-.68 1.15-1.28 1.86-1.76A.495.495 0 008 6a.495.495 0 00.1-.98c.16-.09.32-.17.49-.25.09.14.24.23.41.23.28 0 .5-.22.5-.5 0-.03-.01-.06-.02-.09.39-.13.79-.23 1.21-.3-.11.1-.19.23-.19.39 0 .28.22.5.5.5s.5-.22.5-.5a.51.51 0 00-.3-.46c.26-.03.53-.04.8-.04s.54.01.8.04c-.18.08-.3.25-.3.46 0 .28.22.5.5.5s.5-.22.5-.5c0-.16-.08-.29-.19-.38.41.07.82.17 1.21.3-.01.02-.02.05-.02.08 0 .28.22.5.5.5.17 0 .32-.09.41-.23.17.08.33.16.49.25A.495.495 0 0016 6c.28 0 .5-.22.5-.5 0-.05-.01-.09-.03-.13.71.48 1.34 1.08 1.86 1.76a.495.495 0 00-.83.37c0 .28.22.5.5.5s.5-.22.5-.5c0-.09-.03-.16-.07-.23.18.24.34.49.49.75-.23.03-.42.23-.42.48a.495.495 0 00.85.35c.42.97.65 2.03.65 3.15 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdFace6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8v-.03c2.31-.22 3.43-1.59 4.34-3.41.17-.35.51-.56.9-.56h5.53c.38 0 .72.21.89.55.9 1.8 1.99 3.19 4.34 3.41v.03c0 4.42-3.59 8.01-8 8.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
                }
            }
        ]
    })(props);
}
function MdFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 9.5C17.5 6.46 15.04 4 12 4S6.5 6.46 6.5 9.5c0 2.7 1.94 4.93 4.5 5.4V17H9v2h2v2h2v-2h2v-2h-2v-2.1c2.56-.47 4.5-2.7 4.5-5.4zm-9 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function MdFireplace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v20h20V2H2zm9.86 14.96c.76-.24 1.4-1.04 1.53-1.63.13-.56-.1-1.05-.2-1.6-.08-.46-.07-.85.08-1.28.54 1.21 2.15 1.64 1.98 3.18-.19 1.7-2.11 2.38-3.39 1.33zM20 20h-2v-2h-2.02A4.98 4.98 0 0017 15c0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
                }
            }
        ]
    })(props);
}
function MdFitbit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 13.89c1.04 0 1.89-.85 1.89-1.89s-.85-1.89-1.89-1.89S18 10.96 18 12s.85 1.89 1.89 1.89zm-4.24-.21c.93 0 1.68-.75 1.68-1.68s-.75-1.68-1.68-1.68c-.93 0-1.68.75-1.68 1.68s.75 1.68 1.68 1.68zm0-4.26c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .93.75 1.68 1.68 1.68zm0 8.51c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .92.75 1.68 1.68 1.68zm-4.24-4.46c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0-4.26c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0 8.52c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0 4.27c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0-17.06c.81 0 1.47-.66 1.47-1.47S12.22 2 11.41 2c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm-4.25 8.32c.7 0 1.26-.57 1.26-1.26s-.57-1.26-1.26-1.26a1.261 1.261 0 000 2.52zm0 4.25a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm0-8.49a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm-3.87 4.03a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z"
                }
            }
        ]
    })(props);
}
function MdFlood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 19c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.22 0 1.4 1 3.33 1 1.93 0 2.1-1 3.33-1 1.22 0 1.4 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM8.68 17.5c1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-.63 0-1-.28-1.48-.55l-2.02-7.53 2.09.85.74-1.86L9.78 2 2 11.61l1.57 1.23 1.39-1.78.93 3.48c-.18-.02-.35-.05-.56-.05-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19.01 1.42 1.01 3.33 1.01zm5.36-7.32l1.42 5.31c-1.34.09-1.47-.99-3.47-.99-.36 0-.65.04-.91.1l-.91-3.39 3.87-1.03z"
                }
            }
        ]
    })(props);
}
function MdFollowTheSigns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75M13 2v7h3.75v14h1.5V9H22V2h-9zm5.01 6V6.25H14.5v-1.5h3.51V3l2.49 2.5L18.01 8z"
                }
            }
        ]
    })(props);
}
function MdFrontHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.75 8c-.69 0-1.25.56-1.25 1.25V15H18c-1.65 0-3 1.35-3 3h-1c0-2.04 1.53-3.72 3.5-3.97V3.25a1.25 1.25 0 00-2.5 0V11h-1V1.25a1.25 1.25 0 00-2.5 0V11h-1V2.75a1.25 1.25 0 00-2.5 0V12H7V5.75a1.25 1.25 0 00-2.5 0v10c0 4.56 3.69 8.25 8.25 8.25S21 20.31 21 15.75v-6.5C21 8.56 20.44 8 19.75 8z"
                }
            }
        ]
    })(props);
}
function MdGirl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zm2 8.5v4h-4v-4H8l2.38-6.38a1.733 1.733 0 013.24 0L16 16h-2z"
                }
            }
        ]
    })(props);
}
function MdGroupAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM8 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zM16.53 13.83C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function MdGroupOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4h-.18l-.77-.77c.6-.94.95-2.05.95-3.23zm7.83 12H23v-3c0-2.18-3.58-3.47-6.34-3.87 1.1.75 1.95 1.71 2.23 2.94L22.83 20zM7.24 4.41a3.996 3.996 0 015.35 5.35L7.24 4.41zM9.17 12H9c-2.21 0-4-1.79-4-4v-.17L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41L17 19.83V20H1v-3c0-2.66 5.33-4 8-4 .37 0 .8.03 1.25.08L9.17 12z"
                }
            }
        ]
    })(props);
}
function MdGroupRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 9v2h-6V9h6zM8 4C5.79 4 4 5.79 4 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm4.51-8.95C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zm4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function MdGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                }
            }
        ]
    })(props);
}
function MdGroups2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.27 12h3.46a1.5 1.5 0 001.48-1.75l-.3-1.79a2.951 2.951 0 00-5.82.01l-.3 1.79c-.15.91.55 1.74 1.48 1.74zM1.66 11.11c-.13.26-.18.57-.1.88.16.69.76 1.03 1.53 1h1.95c.83 0 1.51-.58 1.51-1.29 0-.14-.03-.27-.07-.4-.01-.03-.01-.05.01-.08.09-.16.14-.34.14-.53 0-.31-.14-.6-.36-.82-.03-.03-.03-.06-.02-.1.07-.2.07-.43.01-.65a1.12 1.12 0 00-.99-.74.09.09 0 01-.07-.03C5.03 8.14 4.72 8 4.37 8c-.3 0-.57.1-.75.26-.03.03-.06.03-.09.02a1.24 1.24 0 00-1.7 1.03c0 .02-.01.04-.03.06-.29.26-.46.65-.41 1.05.03.22.12.43.25.6.03.02.03.06.02.09zM16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM22 11v-.5c0-1.1-.9-2-2-2h-2c-.42 0-.65.48-.39.81l.7.63c-.19.31-.31.67-.31 1.06 0 1.1.9 2 2 2s2-.9 2-2z"
                }
            }
        ]
    })(props);
}
function MdGroups3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM12 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM1.497 11L4 8.497 6.503 11 4 13.503zM20 9l-2.5 4h5z"
                }
            }
        ]
    })(props);
}
function MdGroups(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"
                }
            }
        ]
    })(props);
}
function MdHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.48 10.41c-.39.39-1.04.39-1.43 0l-4.47-4.46-7.05 7.04-.66-.63a3 3 0 010-4.24l4.24-4.24a3 3 0 014.24 0L16.48 9c.39.39.39 1.02 0 1.41zm.7-2.12c.78.78.78 2.05 0 2.83-1.27 1.27-2.61.22-2.83 0l-3.76-3.76-5.57 5.57a.996.996 0 000 1.41c.39.39 1.02.39 1.42 0l4.62-4.62.71.71-4.62 4.62a.996.996 0 000 1.41c.39.39 1.02.39 1.42 0l4.62-4.62.71.71-4.62 4.62a.996.996 0 101.41 1.41l4.62-4.62.71.71-4.62 4.62a.996.996 0 101.41 1.41l8.32-8.34a3 3 0 000-4.24l-4.24-4.24a3.001 3.001 0 00-4.18-.06l4.47 4.47z"
                }
            }
        ]
    })(props);
}
function MdHealthAndSafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 13H8v-3h2.5V7.5h3V10H16v3h-2.5v2.5h-3V13zM12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3z"
                }
            }
        ]
    })(props);
}
function MdHeartBroken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-.96 0-1.9.25-2.73.69L12 9h3l-3 10 1-9h-3l1.54-5.39C10.47 3.61 9.01 3 7.5 3 4.42 3 2 5.42 2 8.5c0 4.13 4.16 7.18 10 12.5 5.47-4.94 10-8.26 10-12.5C22 5.42 19.58 3 16.5 3z"
                }
            }
        ]
    })(props);
}
function MdHiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 5.28c-1.23-.37-2.22-1.17-2.8-2.18l-1-1.6c-.41-.65-1.11-1-1.84-1-.78 0-1.59.5-1.78 1.44S7 23 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3c1 1.15 2.41 2.01 4 2.34V23H19V9h-1.5v1.78zM7.43 13.13l-2.12-.41a.999.999 0 01-.79-1.17l.76-3.93a2 2 0 012.34-1.58l1.16.23-1.35 6.86z"
                }
            }
        ]
    })(props);
}
function MdHistoryEdu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v1.38c-.83-.33-1.72-.5-2.61-.5-1.79 0-3.58.68-4.95 2.05l3.33 3.33h1.11v1.11c.86.86 1.98 1.31 3.11 1.36V15H6v3c0 1.1.9 2 2 2h10c1.66 0 3-1.34 3-3V4H9zm-1.11 6.41V8.26H5.61L4.57 7.22a5.07 5.07 0 011.82-.34c1.34 0 2.59.52 3.54 1.46l1.41 1.41-.2.2a2.7 2.7 0 01-1.92.8c-.47 0-.93-.12-1.33-.34zM19 17c0 .55-.45 1-1 1s-1-.45-1-1v-2h-6v-2.59c.57-.23 1.1-.57 1.56-1.03l.2-.2L15.59 14H17v-1.41l-6-5.97V6h8v11z"
                }
            }
        ]
    })(props);
}
function MdHive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.79 8l1.8-3-1.8-3h-3.58l-1.8 3 1.8 3zM10.21 9l-1.8 3 1.8 3h3.58l1.8-3-1.8-3zM16.45 11.51h3.59l1.79-3-1.79-3h-3.59l-1.8 3zM20.04 12.51h-3.59l-1.8 3 1.8 3h3.59l1.79-3zM7.55 11.51l1.8-3-1.8-3H3.96l-1.79 3 1.79 3zM7.55 12.51H3.96l-1.79 3 1.79 3h3.59l1.8-3zM10.21 16l-1.8 3 1.8 3h3.58l1.8-3-1.8-3z"
                }
            }
        ]
    })(props);
}
function MdIceSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8.5c0-.28.22-.5.5-.5h2.52L11 7H8.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H11V3H3v15h3v2H2v2h16c2.76 0 5-2.24 5-5h-2c0 1.66-1.34 3-3 3h-2v-2h3v-2.88c0-2.1-1.55-3.53-3.03-3.88l-2.7-.67c-.87-.22-1.57-.81-1.95-1.57H8.5c-.28 0-.5-.22-.5-.5zM14 20H8v-2h6v2z"
                }
            }
        ]
    })(props);
}
function MdInterests(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.02 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zM13 13v8h8v-8h-8zM7 2l-5 9h10L7 2zm12.25.5c-1.06 0-1.81.56-2.25 1.17-.44-.61-1.19-1.17-2.25-1.17C13.19 2.5 12 3.78 12 5.25c0 2 2.42 3.42 5 5.75 2.58-2.33 5-3.75 5-5.75 0-1.47-1.19-2.75-2.75-2.75z"
                }
            }
        ]
    })(props);
}
function MdIosShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6a2 2 0 01-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3a2 2 0 012 2z"
                }
            }
        ]
    })(props);
}
function MdKayaking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM12 5.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 12s-1.52.71-3.93 1.37c-.82-.23-1.53-.75-2.07-1.37-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.54.61-1.25 1.13-2.07 1.37C1.52 18.21 0 17.5 0 17.5s2.93-1.36 7.13-2.08l1.35-4.17c.31-.95 1.32-1.47 2.27-1.16.09.03.19.07.27.11l2.47 1.3 2.84-1.5 1.65-3.71-.51-1.32L18.8 2 22 3.43 20.67 6.4l-1.31.5-3.72 8.34c4.85.63 8.36 2.26 8.36 2.26zm-8.98-4.54l-1.52.8-1.75-.92-.71 2.17c.32 0 .64-.01.96-.01.71 0 1.4.03 2.07.08l.95-2.12z"
                }
            }
        ]
    })(props);
}
function MdKingBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M6 7h5v3H6zM13 7h5v3h-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5c0-1.1-.9-2-2-2zm-9 0H6V7h5v3zm7 0h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function MdKitesurfing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm14.06-2h-2.12L15.5 3.44l1.06 1.06 3.5-3.5zM22 23v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1zm-1-9.72c0 1.44-2.19 3.62-5.04 5.58-.31.09-.63.14-.96.14-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.94 0-1.81-.41-2.49-.99.46-.39.96-.78 1.49-1.17l-1.55-2.97A4.06 4.06 0 016 12V8c0-1.1.9-2 2-2h3c1.38 0 2.63-.56 3.54-1.46l1.41 1.41A7.018 7.018 0 0111 8H9.6v3.5h2.8l1.69 1.88c1.95-.84 3.77-1.38 5.06-1.38.84 0 1.85.25 1.85 1.28zm-8.8.99l-.7-.77-2.5.1.83 2.01c.59-.38 1.81-1.06 2.37-1.34z"
                }
            }
        ]
    })(props);
}
function MdLandslide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.47 13.79l-2.58-1.03L6 15.05l-4-1.54v2.1l4 1.34zM10.57 11.42L8 8H2v3.61l4 1.34zM6 19.05l-4-1.33V22h20l-4.97-6.62zM17 6V1l-5-1-3 2v4l3 2zM18.5 7L16 9v3l2.5 2 4.5-2V8z"
                }
            }
        ]
    })(props);
}
function MdLocationCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdLuggage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zm.75-12h-3V3.5h3V6zM16 18h-1.5V9H16v9z"
                }
            }
        ]
    })(props);
}
function MdMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11c1.93 0 3.5 1.57 3.5 3.5S11.43 18 9.5 18 6 16.43 6 14.5 7.57 11 9.5 11zm0-2C6.46 9 4 11.46 4 14.5S6.46 20 9.5 20s5.5-2.46 5.5-5.5c0-1.16-.36-2.23-.97-3.12L18 7.42V10h2V4h-6v2h2.58l-3.97 3.97C11.73 9.36 10.66 9 9.5 9z"
                }
            }
        ]
    })(props);
}
function MdMan2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2.5v7h3v-7H16V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdMan3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2zM12 1.751L14.248 4 12 6.248 9.75 4z"
                }
            }
        ]
    })(props);
}
function MdMan4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.75 7h-3.5C9.04 7 8.11 8.07 8.27 9.26L10 22h4l1.73-12.74C15.89 8.07 14.96 7 13.75 7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdMasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6A2.5 2.5 0 002 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5A2.5 2.5 0 0019.5 6zm-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9zm17 0c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1V9zm-9.81 1.48c-.44.26-.96.56-1.69.76V10.2c.48-.17.84-.38 1.18-.58C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.34.2.71.42 1.2.59v1.04c-.75-.21-1.26-.51-1.71-.78-.46-.27-.8-.47-1.29-.47s-.84.2-1.31.48z"
                }
            }
        ]
    })(props);
}
function MdMilitaryTech(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-4 1.8l-1 .6-1-.6V3h2v9.23z"
                }
            }
        ]
    })(props);
}
function MdMoodBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
                }
            }
        ]
    })(props);
}
function MdMood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdNightsStay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.1 12.08c-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.62-.27 1.29-.42 2-.42 1.66 0 3.18.83 4.1 2.15A4.01 4.01 0 0111 18c0 1.52-.87 2.83-2.12 3.51.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-2.36.23-6.98-.97-9.26-5.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdNoAdultContent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.85.63-3.54 1.69-4.9L7.59 9h2.83L7.1 5.69A7.924 7.924 0 0112 4c4.41 0 8 3.59 8 8 0 1.85-.63 3.54-1.69 4.9l-1.9-1.9h-2.83l3.31 3.31A7.874 7.874 0 0112 20c-4.41 0-8-3.59-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 14l-1.5-2 1.5-2h-1.5L12 11l-.75-1h-1.5l1.5 2-1.5 2h1.5l.75-1 .75 1zM8 10l-.75 1-.75-1H5l1.5 2L5 14h1.5l.75-1L8 14h1.5L8 12l1.5-2zM16 14l.75-1 .75 1H19l-1.5-2 1.5-2h-1.5l-.75 1-.75-1h-1.5l1.5 2-1.5 2z"
                }
            }
        ]
    })(props);
}
function MdNoLuggage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.75 9v.92l1.75 1.75V9H16v4.17l3 3V8c0-1.1-.9-2-2-2h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3h-.17l3 3h.92zM10.5 3.5h3V6h-3V3.5zm10.69 17.69L2.81 2.81 1.39 4.22l3.63 3.63c0 .05-.02.1-.02.15v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c.34 0 .65-.09.93-.24l1.85 1.85 1.41-1.42zM8 18v-7.17l1.5 1.5V18H8zm4.75 0h-1.5v-3.92l1.5 1.5V18z"
                }
            }
        ]
    })(props);
}
function MdNordicWalking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 23h-1.5v-9H19v9zM7.53 14H6l-2 9h1.53l2-9zm5.97-8.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 00-2.65-.84L6 8.3V13h2V9.6l1.8-.7z"
                }
            }
        ]
    })(props);
}
function MdNotificationAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm4-11c0 2.61 1.67 4.83 4 5.66V17h2v2H4v-2h2v-7c0-2.79 1.91-5.14 4.5-5.8v-.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.7c.71.18 1.36.49 1.95.9A5.902 5.902 0 0014 9zm10-1h-3V5h-2v3h-3v2h3v3h2v-3h3V8z"
                }
            }
        ]
    })(props);
}
function MdNotificationsActive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 013.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 013.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
                }
            }
        ]
    })(props);
}
function MdNotificationsNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                }
            }
        ]
    })(props);
}
function MdNotificationsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
                }
            }
        ]
    })(props);
}
function MdNotificationsPaused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
                }
            }
        ]
    })(props);
}
function MdNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 002 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutdoorGrill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06a6.36 6.36 0 001.74 0l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93A6.992 6.992 0 0019 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08a1 1 0 00.29 1.38 1 1 0 001.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
                }
            }
        ]
    })(props);
}
function MdPages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdParagliding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-3.48.94C8.04 17.55 7 16.76 7 14H5c0 2.7.93 4.41 2.3 5.5.5.4 1.1.7 1.7.9V24h6v-3.6c.6-.2 1.2-.5 1.7-.9 1.37-1.09 2.3-2.8 2.3-5.5h-2c0 2.76-1.04 3.55-1.52 3.94C14.68 18.54 14 19 12 19s-2.68-.46-3.48-1.06zM12 0C5.92 0 1 1.9 1 4.25v3.49c0 .81.88 1.26 1.56.83.14-.09.28-.18.44-.26L5 13h2l1.5-6.28a27.852 27.852 0 017 0L17 13h2l2-4.69c.16.09.3.17.44.26.68.43 1.56-.02 1.56-.83V4.25C23 1.9 18.08 0 12 0zM5.88 11.24L4.37 7.69c.75-.28 1.6-.52 2.53-.71l-1.02 4.26zm12.24 0L17.1 6.98c.93.19 1.78.43 2.53.71l-1.51 3.55z"
                }
            }
        ]
    })(props);
}
function MdPartyMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1A5.002 5.002 0 0112 7zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08a5.002 5.002 0 01-4.9 6z"
                }
            }
        ]
    })(props);
}
function MdPeopleAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "8",
                    "r": "4",
                    "fillRule": "evenodd"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 010 7.52c.42.14.86.24 1.33.24zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdPeopleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
                }
            }
        ]
    })(props);
}
function MdPeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                }
            }
        ]
    })(props);
}
function MdPerson2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM9.78 12h4.44c1.21 0 2.14-1.06 1.98-2.26l-.32-2.45C15.57 5.39 13.92 4 12 4S8.43 5.39 8.12 7.29L7.8 9.74c-.16 1.2.77 2.26 1.98 2.26z"
                }
            }
        ]
    })(props);
}
function MdPerson3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM10 12h4c1.66 0 3-1.34 3-3 0-.73-.27-1.4-.71-1.92.13-.33.21-.7.21-1.08a3 3 0 00-1.86-2.77C14 2.48 13.06 2 12 2s-2 .48-2.64 1.23A3 3 0 007.5 6c0 .38.08.75.21 1.08C7.27 7.6 7 8.27 7 9c0 1.66 1.34 3 3 3z"
                }
            }
        ]
    })(props);
}
function MdPerson4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM12 12c2.21 0 4-1.79 4-4V4.5c0-.83-.67-1.5-1.5-1.5-.52 0-.98.27-1.25.67-.27-.4-.73-.67-1.25-.67s-.98.27-1.25.67c-.27-.4-.73-.67-1.25-.67C8.67 3 8 3.67 8 4.5V8c0 2.21 1.79 4 4 4z"
                }
            }
        ]
    })(props);
}
function MdPersonAddAlt1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm2 2v2h3v3h2v-3h3v-2h-3V7h-2v3h-3zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
                }
            }
        ]
    })(props);
}
function MdPersonAddAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2H3zm17-3v-3h3v-2h-3V7h-2v3h-3v2h3v3h2z"
                }
            }
        ]
    })(props);
}
function MdPersonAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdPersonOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.65 5.82a3.999 3.999 0 115.53 5.53L8.65 5.82zM20 17.17c-.02-1.1-.63-2.11-1.61-2.62-.54-.28-1.13-.54-1.77-.76L20 17.17zm1.19 4.02L2.81 2.81 1.39 4.22l8.89 8.89c-1.81.23-3.39.79-4.67 1.45A2.97 2.97 0 004 17.22V20h13.17l2.61 2.61 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdPersonOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdPersonRemoveAlt1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm3 2v2h6v-2h-6zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
                }
            }
        ]
    })(props);
}
function MdPersonRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm3 2v2h6v-2h-6zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4z"
                }
            }
        ]
    })(props);
}
function MdPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdPersonalInjury(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 6c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm9 16h1c1.1 0 2-.9 2-2v-4.78c0-1.12-.61-2.15-1.61-2.66-.43-.22-.9-.43-1.39-.62V22zm-4.66-5L15 11.33c-.93-.21-1.93-.33-3-.33-2.53 0-4.71.7-6.39 1.56A2.97 2.97 0 004 15.22V22h2.34c-.22-.45-.34-.96-.34-1.5C6 18.57 7.57 17 9.5 17h2.84zM10 22l1.41-3H9.5c-.83 0-1.5.67-1.5 1.5S8.67 22 9.5 22h.5z"
                }
            }
        ]
    })(props);
}
function MdPianoOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM8.25 19H5V7.83l2 2v3.67c0 .55.45 1 1 1h.25V19zm1.5 0v-4.5H10c.46 0 .82-.31.94-.73l3.31 3.31V19h-4.5zM11 8.17L5.83 3H19c1.1 0 2 .9 2 2v13.17l-2-2V5h-2v8.5c0 .19-.07.36-.16.51L13 10.17V5h-2v3.17z"
                }
            }
        ]
    })(props);
}
function MdPiano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 11.5h.25V19h-4.5v-4.5H10c.55 0 1-.45 1-1V5h2v8.5c0 .55.45 1 1 1zM5 5h2v8.5c0 .55.45 1 1 1h.25V19H5V5zm14 14h-3.25v-4.5H16c.55 0 1-.45 1-1V5h2v14z"
                }
            }
        ]
    })(props);
}
function MdPix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.45 16.52l-3.01-3.01c-.11-.11-.24-.13-.31-.13s-.2.02-.31.13L8.8 16.53c-.34.34-.87.89-2.64.89l3.71 3.7a3 3 0 004.24 0l3.72-3.71c-.91 0-1.67-.18-2.38-.89zM8.8 7.47l3.02 3.02c.08.08.2.13.31.13s.23-.05.31-.13l2.99-2.99c.71-.74 1.52-.91 2.43-.91l-3.72-3.71a3 3 0 00-4.24 0l-3.71 3.7c1.76 0 2.3.58 2.61.89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.11 9.85l-2.25-2.26H17.6c-.54 0-1.08.22-1.45.61l-3 3c-.28.28-.65.42-1.02.42a1.5 1.5 0 01-1.02-.42L8.09 8.17c-.38-.38-.9-.6-1.45-.6H5.17l-2.29 2.3a3 3 0 000 4.24l2.29 2.3h1.48c.54 0 1.06-.22 1.45-.6l3.02-3.02c.28-.28.65-.42 1.02-.42s.74.14 1.02.42l3.01 3.01c.38.38.9.6 1.45.6h1.26l2.25-2.26a3.042 3.042 0 00-.02-4.29z"
                }
            }
        ]
    })(props);
}
function MdPlusOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
                }
            }
        ]
    })(props);
}
function MdPoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdPrecisionManufacturing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 8.21l-3.6 1.68L14 7.7V6.3l2.33-2.19 3.6 1.68c.38.18.82.01 1-.36.18-.38.01-.82-.36-1L16.65 2.6a.993.993 0 00-1.13.2l-1.74 1.6A.975.975 0 0013 4c-.55 0-1 .45-1 1v1H8.82C8.34 4.65 6.98 3.73 5.4 4.07c-1.16.25-2.15 1.25-2.36 2.43-.22 1.32.46 2.47 1.48 3.08L7.08 18H4v3h13v-3h-3.62L8.41 8.77c.17-.24.31-.49.41-.77H12v1c0 .55.45 1 1 1 .32 0 .6-.16.78-.4l1.74 1.6c.3.3.75.38 1.13.2l3.92-1.83c.38-.18.54-.62.36-1a.753.753 0 00-1-.36zM6 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdPsychologyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 9.06C19.5 5.73 16.57 3 13 3 9.47 3 6.57 5.61 6.08 9l-1.93 3.48c-.41.66.07 1.52.85 1.52h1v2c0 1.1.9 2 2 2h1v3h7v-4.68a7.016 7.016 0 003.94-7.26zM12.5 14c-.41 0-.74-.33-.74-.74s.33-.73.74-.73.73.32.73.73-.31.74-.73.74zm1.76-4.32c-.44.65-.86.85-1.09 1.27-.09.17-.13.28-.13.82h-1.06c0-.29-.04-.75.18-1.16.28-.51.83-.81 1.14-1.26.33-.47.15-1.36-.8-1.36-.62 0-.92.47-1.05.86l-.96-.4c.27-.78.97-1.45 2.01-1.45.86 0 1.45.39 1.75.88.26.43.41 1.22.01 1.8z"
                }
            }
        ]
    })(props);
}
function MdPsychology(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.57a1.43 1.43 0 100 2.86 1.43 1.43 0 000-2.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3C9.25 3 6.2 5.94 6.02 9.64L4.1 12.2a.5.5 0 00.4.8H6v3c0 1.1.9 2 2 2h1v3h7v-4.68A6.999 6.999 0 0013 3zm3 7c0 .13-.01.26-.02.39l.83.66c.08.06.1.16.05.25l-.8 1.39c-.05.09-.16.12-.24.09l-.99-.4c-.21.16-.43.29-.67.39L14 13.83c-.01.1-.1.17-.2.17h-1.6c-.1 0-.18-.07-.2-.17l-.15-1.06c-.25-.1-.47-.23-.68-.39l-.99.4c-.09.03-.2 0-.25-.09l-.8-1.39a.19.19 0 01.05-.25l.84-.66c-.01-.13-.02-.26-.02-.39s.02-.27.04-.39l-.85-.66c-.08-.06-.1-.16-.05-.26l.8-1.38c.05-.09.15-.12.24-.09l1 .4c.2-.15.43-.29.67-.39L12 6.17c.02-.1.1-.17.2-.17h1.6c.1 0 .18.07.2.17l.15 1.06c.24.1.46.23.67.39l1-.4c.09-.03.2 0 .24.09l.8 1.38a.2.2 0 01-.05.26l-.85.66c.03.12.04.25.04.39z"
                }
            }
        ]
    })(props);
}
function MdPublicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.17L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.842 7.842 0 0020 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2v1.17zm10.19 13.02l-1.41 1.41-2.27-2.27A9.839 9.839 0 0112 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.39 18.38zM11 18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.08 3.05 7.44 7 7.93V18z"
                }
            }
        ]
    })(props);
}
function MdPublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
                }
            }
        ]
    })(props);
}
function MdRealEstateAgent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 22h4V11H1v11zm19-5h-7l-2.09-.73.33-.94L13 16h2.82c.65 0 1.18-.53 1.18-1.18 0-.49-.31-.93-.77-1.11L8.97 11H7v9.02L14 22l8-3c-.01-1.1-.89-2-2-2zM14 1.5l-7 5V9h2l8.14 3.26C18.26 12.71 19 13.79 19 15h2V6.5l-7-5zm-.5 8.5h-1V9h1v1zm0-2h-1V7h1v1zm2 2h-1V9h1v1zm0-2h-1V7h1v1z"
                }
            }
        ]
    })(props);
}
function MdRecommend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2a10 10 0 1010 10A10 10 0 0012 2zm6 9.8a.9.9 0 01-.1.5l-2.1 4.9a1.34 1.34 0 01-1.3.8H9a2 2 0 01-2-2v-5a1.28 1.28 0 01.4-1L12 5l.69.69a1.08 1.08 0 01.3.7v.2L12.41 10H17a1 1 0 011 1z"
                }
            }
        ]
    })(props);
}
function MdRecycling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.77 7.15L7.2 4.78l1.03-1.71c.39-.65 1.33-.65 1.72 0l1.48 2.46-1.23 2.06-1 1.62-3.43-2.06zm15.95 5.82l-1.6-2.66-3.46 2L18.87 16H20a2 2 0 002-2c0-.36-.1-.71-.28-1.03zM16 21h1.5a2 2 0 001.79-1.11L20.74 17H16v-2l-4 4 4 4v-2zm-6-4H5.7l-.84 1.41c-.3.5-.32 1.12-.06 1.65.28.57.87.94 1.52.94H10v-4zm-3.88-2.65l1.73 1.04L6.48 9.9 1 11.27l1.7 1.02-.41.69c-.35.59-.38 1.31-.07 1.92l1.63 3.26 2.27-3.81zm10.9-9.21l-1.3-2.17C15.35 2.37 14.7 2 14 2h-3.53l3.12 5.2-1.72 1.03 5.49 1.37 1.37-5.49-1.71 1.03z"
                }
            }
        ]
    })(props);
}
function MdReduceCapacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58A6.95 6.95 0 0018 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58A2.01 2.01 0 002 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 9.43V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0121 21.43V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0111 21.43V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z"
                }
            }
        ]
    })(props);
}
function MdRemoveModerator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.27 21.73l-3.54-3.55L5.78 5.23 2.27 1.72 1 2.99 3.01 5H3v6c0 5.55 3.84 10.74 9 12 2.16-.53 4.08-1.76 5.6-3.41L21 23l1.27-1.27zM13 9.92l6.67 6.67C20.51 14.87 21 12.96 21 11V5l-9-4-5.48 2.44L11 7.92l2 2z"
                }
            }
        ]
    })(props);
}
function MdRollerSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.5c0-.28.22-.5.5-.5h2.52L12 5H9.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5H12V1H4v15h16v-2.88c0-2.1-1.55-3.53-3.03-3.88l-2.7-.67c-.87-.22-1.57-.81-1.95-1.57H9.5c-.28 0-.5-.22-.5-.5zM5 23c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm14 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm-7 0c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdSafetyDivider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h2v14h-2V5zm-6 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 001 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85zM19 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0015 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85z"
                }
            }
        ]
    })(props);
}
function MdSanitizer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5zm4 8.5a2.5 2.5 0 002.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 002.5 2.5zM13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2zm3-2v10H4V12c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 2.99 1.01l-1.43 1.43C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91z"
                }
            }
        ]
    })(props);
}
function MdScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11V8c4.56-.58 8-3.1 8-6H2c0 2.9 3.44 5.42 8 6v3c-3.68.73-8 3.61-8 11h6v-2H4.13c.93-6.83 6.65-7.2 7.87-7.2s6.94.37 7.87 7.2H16v2h6c0-7.39-4.32-10.27-8-11zm-2 11c-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41C11.39 17.79 16 16 16 16s-1.79 4.61-2.59 5.41c-.36.37-.86.59-1.41.59z"
                }
            }
        ]
    })(props);
}
function MdSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
                }
            }
        ]
    })(props);
}
function MdScience(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 18.4L14 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81H9.04c-.42 0-.65.48-.39.81L10 6.5v4.17L4.2 18.4c-.49.66-.02 1.6.8 1.6h14c.82 0 1.29-.94.8-1.6z"
                }
            }
        ]
    })(props);
}
function MdScoreboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 13.5H16v-3h1.5v3zM20 4h-3V2h-2v2H9V2H7v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.5 11.5c0 .55-.45 1-1 1h-2v1h3V15H5v-2.5c0-.55.45-1 1-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v1.5zm3.25 6.5h-1.5v-1.5h1.5V18zm0-3.5h-1.5V13h1.5v1.5zm0-3.5h-1.5V9.5h1.5V11zm0-3.5h-1.5V6h1.5v1.5zM19 14c0 .55-.45 1-1 1h-2.5c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1H18c.55 0 1 .45 1 1v4z"
                }
            }
        ]
    })(props);
}
function MdScubaDiving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.89-2.89l4.53-1.21-.78-2.9-4.53 1.21c-.8.21-1.28 1.04-1.06 1.84.22.8 1.04 1.28 1.84 1.06zM20.5 5.9L23 3l-1-1-3 3-2 4-9.48 2.87c-.82.2-1.39.89-1.5 1.68L5.24 18 2.4 21.8 4 23l3-4 1.14-3.14L14 14l5-3.5 1.5-4.6z"
                }
            }
        ]
    })(props);
}
function MdSelfImprovement(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2c-2.24 0-4.16-.96-5.6-2.68l-1.34-1.6A1.98 1.98 0 0012.53 9h-1.05c-.59 0-1.15.26-1.53.72l-1.34 1.6C7.16 13.04 5.24 14 3 14v2c2.77 0 5.19-1.17 7-3.25V15l-3.88 1.55c-.67.27-1.12.93-1.12 1.66C5 19.2 5.8 20 6.79 20H9v-.5a2.5 2.5 0 012.5-2.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.83 0-1.5.67-1.5 1.5v.5h7.21c.99 0 1.79-.8 1.79-1.79 0-.73-.45-1.39-1.12-1.66L14 15v-2.25c1.81 2.08 4.23 3.25 7 3.25z"
                }
            }
        ]
    })(props);
}
function MdSentimentDissatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-3.5c.73 0 1.39.19 1.97.53.12-.14.86-.98 1.01-1.14A5.39 5.39 0 0012 15c-1.11 0-2.13.33-2.99.88.97 1.09.01.02 1.01 1.14.59-.33 1.25-.52 1.98-.52z"
                }
            }
        ]
    })(props);
}
function MdSentimentNeutral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15.5h6v1H9v-1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdSentimentSatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15a5.49 5.49 0 005.95-.01c-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53z"
                }
            }
        ]
    })(props);
}
function MdSentimentVeryDissatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
                }
            }
        ]
    })(props);
}
function MdSentimentVerySatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm-5-6c.78 2.34 2.72 4 5 4s4.22-1.66 5-4H7z"
                }
            }
        ]
    })(props);
}
function MdSevereCold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.41l4-4L14.59 5 12 7.59V4h-2v3.59L7.41 5 6 6.41l4 4V12H8.41l-4-4L3 9.41 5.59 12H2v2h3.59L3 16.59 4.41 18l4-4H10v1.59l-4 4L7.41 21 10 18.41V22h2v-3.59L14.59 21 16 19.59l-4-4V14h1.59l4 4L19 16.59 16.41 14H20v-2h-8zM19 2h2v5h-2zM19 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
                }
            }
        ]
    })(props);
}
function MdSick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9c-1.1 0-2-.9-2-2s2-4 2-4 2 2.9 2 4-.9 2-2 2zm-3.5-2c0-.73.41-1.71.92-2.66A9.965 9.965 0 0011.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12c0-.55-.06-1.09-.14-1.62a3.5 3.5 0 01-.86.12c-1.93 0-3.5-1.57-3.5-3.5zm-1.88.38l1.06 1.06-1.06 1.06 1.06 1.06-1.06 1.06L13.5 9.5l2.12-2.12zm-8.3 1.06l1.06-1.06L10.5 9.5l-2.12 2.12-1.06-1.06L8.38 9.5 7.32 8.44zM15.44 17c-.69-1.19-1.97-2-3.44-2s-2.75.81-3.44 2H6.88c.3-.76.76-1.43 1.34-1.99L5.24 13.3c-.45.26-1.01.28-1.49 0a1.501 1.501 0 011.5-2.6c.48.28.74.78.74 1.29l3.58 2.07c.73-.36 1.55-.56 2.43-.56 2.33 0 4.32 1.45 5.12 3.5h-1.68z"
                }
            }
        ]
    })(props);
}
function MdSignLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.49 13l-.93-1.86c-.37-.74-.07-1.64.67-2.01l.26-.13 5.73 5.46c.5.47.78 1.13.78 1.81v5.23a2.5 2.5 0 01-2.5 2.5h-11c-.55 0-1-.45-1-1s.45-1 1-1H10v-1H4c-.55 0-1-.45-1-1s.45-1 1-1h6v-1H3c-.55 0-1-.45-1-1s.45-1 1-1h7v-1H4.5c-.55 0-1-.45-1-1s.45-1 1-1h7.99zm-.71-5.88c-.84.4-1.17.62-1.63 1.19l-2.7-2.85A.996.996 0 118.9 4.09l2.88 3.03zM9.64 9.21a3.46 3.46 0 00-.2 1.79h-.86L6.31 8.61a.987.987 0 01.04-1.41.996.996 0 011.41.04l1.88 1.97zm10.69 4.7l.88-.83c.5-.47.79-1.13.79-1.82V3.35l-.27-.1c-.78-.28-1.64.12-1.92.9l-.71 1.96-5.5-5.8a.996.996 0 10-1.45 1.37l3.79 3.99-.73.69-4.82-5.08a.996.996 0 10-1.45 1.37l3.78 3.98L15.38 9l3.61 3.43.61.58c.29.27.53.57.73.9z"
                }
            }
        ]
    })(props);
}
function MdSingleBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5zm-4-2h-3V7h3v3zM8 7h3v3H8V7zm-2 5h12v3H6v-3z"
                }
            }
        ]
    })(props);
}
function MdSkateboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM7.25 22.5c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm8.5 0c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm3.49-3.5a.72.72 0 00-.59.3c-.55.73-1.42 1.2-2.4 1.2H16v-6l-4.32-2.67 1.8-2.89A6.507 6.507 0 0019 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C14.16 5.64 13.61 5 12.7 5H7L4.5 9l1.7 1.06L8.1 7h2.35l-2.4 3.84c-.31.5-.39 1.11-.21 1.67l1.34 4.15-3.12 3.76c-.7-.16-1.3-.57-1.71-1.12a.749.749 0 10-1.2.9c.82 1.1 2.13 1.8 3.6 1.8h9.5c1.47 0 2.78-.7 3.6-1.8.1-.14.15-.3.15-.45 0-.39-.32-.75-.76-.75zM14 20.5H8.6l2.9-3.5-1-3.3 3.5 2.2v4.6z"
                }
            }
        ]
    })(props);
}
function MdSledding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm8.8 15.74a4.003 4.003 0 01-5.04 2.57L1 17.36l.46-1.43 3.93 1.28.46-1.43-3.92-1.28.46-1.43L4 13.6V9.5l5.47-2.35c.39-.17.84-.21 1.28-.07.95.31 1.46 1.32 1.16 2.27l-1.05 3.24 2.14-.34c.89-.15 1.76.32 2.14 1.14l2.08 4.51 1.93.63-.46 1.43-3.32-1.08-.47 1.42 3.32 1.08c1.31.43 2.72-.29 3.15-1.61.43-1.31-.29-2.72-1.61-3.15l.46-1.43c2.11.69 3.27 2.95 2.58 5.05zM6 14.25l1.01.33c-.22-.42-.28-.92-.12-1.4L7.92 10 6 10.82v3.43zm7.94 4.16l-6.66-2.16-.46 1.43 6.66 2.16.46-1.43zm.69-1.36l-1.18-2.56-3.97.89 5.15 1.67z"
                }
            }
        ]
    })(props);
}
function MdSnowboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.4 17.09a.748.748 0 00-.64.17c-.69.6-1.64.88-2.6.67L17 20.69l-1-6.19-3.32-2.67 1.8-2.89A6.507 6.507 0 0020 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C15.16 5.64 14.61 5 13.7 5H8L5.5 9l1.7 1.06L9.1 7h2.35l-2.51 3.99c-.28.45-.37 1-.25 1.52L9.5 16 6 18.35l-.47-.1c-.96-.2-1.71-.85-2.1-1.67a.744.744 0 00-.51-.42c-.43-.09-.82.2-.9.58-.04.14-.02.31.05.46.58 1.24 1.71 2.2 3.15 2.51l12.63 2.69c1.44.31 2.86-.11 3.9-1.01.13-.11.21-.26.24-.41.07-.38-.16-.8-.59-.89zM8.73 18.93l3.02-2.03-.44-3.32 2.84 2.02.75 4.64-6.17-1.31z"
                }
            }
        ]
    })(props);
}
function MdSnowshoeing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 3.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM6.32 19.03l-1.14-1.47L4 18.5l2.38 3.04c.51.65 1.16 1.15 1.88 1.41.28.1.53.04.72-.11.3-.23.42-.7.12-1.07a.84.84 0 00-.31-.22 2.97 2.97 0 01-1.14-.83l-.08-.1L11 18.2l.89-3.22 2.11 2v4.52h-2V23h3.87c.82 0 1.61-.21 2.26-.61.26-.16.37-.39.37-.64 0-.38-.3-.75-.77-.75-.13 0-.26.04-.37.1-.4.23-.87.37-1.36.4v-6.02l-2.11-2 .6-3C15.79 11.98 17.8 13 20 13v-2c-1.9 0-3.51-1.02-4.31-2.42l-1-1.58c-.4-.6-1-1-1.7-1-.75 0-1.41.34-5.99 2.28V13h2V9.58l1.79-.7L9.2 17l-2.88 2.03z"
                }
            }
        ]
    })(props);
}
function MdSocialDistance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM18 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM22 17l-4-4v3H6v-3l-4 4 4 4v-3h12v3l4-4z"
                }
            }
        ]
    })(props);
}
function MdSouthAmerica(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.95.7-3.74 1.87-5.13L9 10v1c0 1.1.9 2 2 2v5.59c0 .27.11.52.29.71l.71.7c-4.42 0-8-3.58-8-8zm9 7.94V18l3.75-5.62c.16-.25.25-.54.25-.83V10.5c0-.55-.45-1-1-1h-1.5l-1.4-1.75c-.38-.47-.95-.75-1.56-.75H8V5.07A7.971 7.971 0 0112 4c4.41 0 8 3.59 8 8 0 4.07-3.06 7.44-7 7.94z"
                }
            }
        ]
    })(props);
}
function MdSportsBaseball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.81 6.28C2.67 7.9 2 9.87 2 12s.67 4.1 1.81 5.72C6.23 16.95 8 14.68 8 12S6.23 7.05 3.81 6.28zM20.19 6.28C17.77 7.05 16 9.32 16 12s1.77 4.95 4.19 5.72C21.33 16.1 22 14.13 22 12s-.67-4.1-1.81-5.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0-3.28 1.97-6.09 4.79-7.33C17.01 3.02 14.63 2 12 2S6.99 3.02 5.21 4.67C8.03 5.91 10 8.72 10 12s-1.97 6.09-4.79 7.33C6.99 20.98 9.37 22 12 22s5.01-1.02 6.79-2.67A8.002 8.002 0 0114 12z"
                }
            }
        ]
    })(props);
}
function MdSportsBasketball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.09 11h4.86a9.951 9.951 0 00-1.54-4.4 5.987 5.987 0 00-3.32 4.4zM6.91 11a5.987 5.987 0 00-3.32-4.4A9.951 9.951 0 002.05 11h4.86zM15.07 11a7.994 7.994 0 014.06-6A9.969 9.969 0 0013 2.05V11h2.07zM8.93 11H11V2.05A9.943 9.943 0 004.87 5a7.994 7.994 0 014.06 6zM15.07 13H13v8.95A9.943 9.943 0 0019.13 19a7.994 7.994 0 01-4.06-6zM3.59 17.4A6.029 6.029 0 006.91 13H2.05c.16 1.61.71 3.11 1.54 4.4zM17.09 13a5.987 5.987 0 003.32 4.4 9.951 9.951 0 001.54-4.4h-4.86zM8.93 13a7.994 7.994 0 01-4.06 6A9.969 9.969 0 0011 21.95V13H8.93z"
                }
            }
        ]
    })(props);
}
function MdSportsCricket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 12.81L6.56 4.32a.996.996 0 00-1.41 0L2.32 7.15a.996.996 0 000 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83a.996.996 0 000-1.41zM14.341 17.756l1.414-1.414 4.243 4.243-1.414 1.414z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "5.5",
                    "r": "3.5"
                }
            }
        ]
    })(props);
}
function MdSportsEsports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.58 16.09l-1.09-7.66A3.996 3.996 0 0016.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zM11 11H9v2H8v-2H6v-1h2V8h1v2h2v1zm4-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdSportsFootball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.02 15.62c-.08 2.42.32 4.34.67 4.69s2.28.76 4.69.67l-5.36-5.36zM13.08 3.28c-2.33.42-4.79 1.34-6.62 3.18s-2.76 4.29-3.18 6.62l7.63 7.63c2.34-.41 4.79-1.34 6.62-3.18s2.76-4.29 3.18-6.62l-7.63-7.63zM9.9 15.5l-1.4-1.4 5.6-5.6 1.4 1.4-5.6 5.6zM20.98 8.38c.08-2.42-.32-4.34-.67-4.69s-2.28-.76-4.69-.67l5.36 5.36z"
                }
            }
        ]
    })(props);
}
function MdSportsGolf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdSportsGymnastics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM1 9h6l7-5 1.31 1.52-4.17 2.98H14L21.8 4 23 5.4 14.5 12 14 22h-2l-.5-10L8 11H1V9z"
                }
            }
        ]
    })(props);
}
function MdSportsHandball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.84 10.41l-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89a5.002 5.002 0 01.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08zM12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05a1.501 1.501 0 00-1.5 2.6z"
                }
            }
        ]
    })(props);
}
function MdSportsHockey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29A.997.997 0 0021 16h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
                }
            }
        ]
    })(props);
}
function MdSportsKabaddi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "2.38",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26a1.93 1.93 0 00-.72-.28c-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
                }
            }
        ]
    })(props);
}
function MdSportsMartialArts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 2l-8.2 6.7-1.21-1.04 3.6-2.08L9.41 1 8 2.41l2.74 2.74L5 8.46l-1.19 4.29L6.27 17 8 16l-2.03-3.52.35-1.3L9.5 13l.5 9h2l.5-10L21 3.4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdSportsMma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8h10.36c.45 0 .89-.36.98-.8l.8-4c.03-.13.04-.26.04-.39V8c0-.55-.45-1-1-1zm-3 3H7V7h8v3z"
                }
            }
        ]
    })(props);
}
function MdSportsMotorsports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11.39c0-.65-.39-1.23-.98-1.48L5.44 7.55c-1.48 1.68-2.32 3.7-2.8 5.45h7.75c.89 0 1.61-.72 1.61-1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 11.22c-.41-4.41-4.56-7.49-8.98-7.2-2.51.16-4.44.94-5.93 2.04l4.74 2.01c1.33.57 2.2 1.87 2.2 3.32 0 1.99-1.62 3.61-3.61 3.61H2.21C2 16.31 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78z"
                }
            }
        ]
    })(props);
}
function MdSportsRugby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM7.76 7.76c2.64-2.64 6.35-3.12 8.03-3.19-2.05.94-4.46 2.45-6.61 4.61a23.462 23.462 0 00-4.62 6.63c.1-2.48.88-5.74 3.2-8.05zm8.48 8.48c-2.64 2.64-6.35 3.12-8.03 3.19 2.05-.94 4.46-2.45 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
                }
            }
        ]
    })(props);
}
function MdSportsSoccer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95a8.01 8.01 0 014.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34a8.103 8.103 0 014.38-3.34zM7.08 17.11l-1.14.1A7.938 7.938 0 014 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
                }
            }
        ]
    })(props);
}
function MdSportsTennis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2a3.998 3.998 0 00-2.83 6.83c.78.78 1.81 1.17 2.83 1.17a3.998 3.998 0 002.83-6.83A3.998 3.998 0 0018 15z"
                }
            }
        ]
    })(props);
}
function MdSportsVolleyball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 4.01C3.58 5.84 2 8.73 2 12c0 1.46.32 2.85.89 4.11L6 14.31V4.01zM11 11.42V2.05c-1.06.11-2.07.38-3 .79v10.32l3-1.74zM12 13.15l-8.11 4.68c.61.84 1.34 1.59 2.18 2.2L15 14.89l-3-1.74zM13 7.96v3.46l8.11 4.68c.42-.93.7-1.93.82-2.98L13 7.96zM8.07 21.2c1.21.51 2.53.8 3.93.8 3.34 0 6.29-1.65 8.11-4.16L17 16.04 8.07 21.2zM21.92 10.81c-.55-4.63-4.26-8.3-8.92-8.76v3.6l8.92 5.16z"
                }
            }
        ]
    })(props);
}
function MdSports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6a2.5 2.5 0 000 5c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78a6.006 6.006 0 006.68 6.27c2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdSurfing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM17 1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2.57 6.98L12.18 10 16 13v3.84c.53.38 1.03.78 1.49 1.17-.68.58-1.55.99-2.49.99-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.33 0-.65-.05-.96-.14C5.19 16.9 3 14.72 3 13.28 3 12.25 4.01 12 4.85 12c.98 0 2.28.31 3.7.83l-.53-3.1c-.11-.67.18-1.38.78-1.79l2.15-1.45-2-.37-2.82 1.93L5 6.4 8.5 4l5.55 1.03c.45.09.93.37 1.22.89l.88 1.55A5.007 5.007 0 0020.5 10v2a7.01 7.01 0 01-6.07-3.52zM10.3 11.1l.44 2.65c.92.42 2.48 1.27 3.26 1.75V14l-3.7-2.9z"
                }
            }
        ]
    })(props);
}
function MdSwitchAccount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 2c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H8v-1.5c0-1.99 4-3 6-3s6 1.01 6 3V16z"
                }
            }
        ]
    })(props);
}
function MdThumbDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h2V4zM2.17 11.12c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22L10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15z"
                }
            }
        ]
    })(props);
}
function MdThumbUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 00-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84A2.34 2.34 0 009.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z"
                }
            }
        ]
    })(props);
}
function MdThunderstorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5a4.5 4.5 0 00-4.08-4.48zM14.8 17l-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zM8.8 17l-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"
                }
            }
        ]
    })(props);
}
function MdTornado(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.11 8L23 3H1l2.89 5zM7.95 15L12 22l4.05-7zM18.95 10H5.05l1.74 3h10.42z"
                }
            }
        ]
    })(props);
}
function MdTransgender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.93 0 3.5 1.57 3.5 3.5S13.93 15 12 15s-3.5-1.57-3.5-3.5S10.07 8 12 8zm4.53.38l3.97-3.96V7h2V1h-6v2h2.58l-3.97 3.97C14.23 6.36 13.16 6 12 6s-2.23.36-3.11.97l-.65-.65 1.41-1.41-1.41-1.42L6.82 4.9 4.92 3H7.5V1h-6v6h2V4.42l1.91 1.9-1.42 1.42L5.4 9.15l1.41-1.41.65.65c-.6.88-.96 1.95-.96 3.11a5.5 5.5 0 004.5 5.41V19H9v2h2v2h2v-2h2v-2h-2v-2.09a5.5 5.5 0 003.53-8.53z"
                }
            }
        ]
    })(props);
}
function MdTravelExplore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3 16.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S11 12 11 14.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.2 3.2 1.4-1.4-3.2-3.2zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM12 20v2C6.48 22 2 17.52 2 12S6.48 2 12 2c4.84 0 8.87 3.44 9.8 8h-2.07A8 8 0 0015 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h2v3H9l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.41 3.59 8 8 8z"
                }
            }
        ]
    })(props);
}
function MdTsunami(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 17.63c-3.8 2.8-6.12.4-6.67 0-.66.49-2.92 2.76-6.67 0C3.43 19.03 2.65 19 2 19v2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37zM19.33 12H22v-2h-2.67C17.5 10 16 8.5 16 6.67c0-1.02.38-1.74 1.09-3.34-1.37-.21-2-.33-3.09-.33C7.36 3 2.15 8.03 2.01 14.5l-.01 2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37-3.8 2.8-6.12.4-6.67 0-.9.67-.54.41-.91.63-.7-.94-1.09-2.06-1.09-3.26 0-2.58 1.77-4.74 4.21-5.33-.13.51-.21 1.02-.21 1.5C14 9.61 16.39 12 19.33 12z"
                }
            }
        ]
    })(props);
}
function MdVaccines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.5H8V4h.5c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1H6v1.5H3c-.55 0-1 .45-1 1s.45 1 1 1V15c0 1.1.9 2 2 2h1v4l2 1.5V17h1c1.1 0 2-.9 2-2V7.5c.55 0 1-.45 1-1s-.45-1-1-1zM9 9H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V12H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V15H5V7.5h4V9zm10.5 1.5V10c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1v.5c0 .5-1.5 1.16-1.5 3V20c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-6.5c0-1.84-1.5-2.5-1.5-3zm-3 0V10h1v.5c0 1.6 1.5 2 1.5 3v.5h-4v-.5c0-1 1.5-1.4 1.5-3zM15 20v-1.5h4V20h-4z"
                }
            }
        ]
    })(props);
}
function MdVolcano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-7l-2 5H6l-4 9h20zM13 1h2v4h-2zM16.121 5.468L18.95 2.64l1.414 1.414-2.829 2.828zM7.64 4.05l1.414-1.414 2.828 2.828-1.414 1.415z"
                }
            }
        ]
    })(props);
}
function MdWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-1.86 9.77c-.24.2-.57.28-.88.2L4.15 11.25C4.45 10.52 5.16 10 6 10h12c.67 0 1.26.34 1.63.84l-3.49 2.93zM6 6h12c1.1 0 2 .9 2 2v.55c-.59-.34-1.27-.55-2-.55H6c-.73 0-1.41.21-2 .55V8c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function MdWaterDrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zM7.83 14c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12a.75.75 0 01.74-.87z"
                }
            }
        ]
    })(props);
}
function MdWavingHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 17c0 3.31-2.69 6-6 6v-1.5c2.48 0 4.5-2.02 4.5-4.5H23zM1 7c0-3.31 2.69-6 6-6v1.5C4.52 2.5 2.5 4.52 2.5 7H1zm7.01-2.68l-4.6 4.6c-3.22 3.22-3.22 8.45 0 11.67s8.45 3.22 11.67 0l7.07-7.07c.49-.49.49-1.28 0-1.77a1.25 1.25 0 00-1.77 0l-4.42 4.42-.71-.71 6.54-6.54c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-5.83 5.83-.71-.71 6.89-6.89c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-6.89 6.89-.69-.7 5.48-5.48c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-7.62 7.62a4.003 4.003 0 01-.33 5.28l-.71-.71a3 3 0 000-4.24l-.35-.35 4.07-4.07c.49-.49.49-1.28 0-1.77a1.27 1.27 0 00-1.78.01z"
                }
            }
        ]
    })(props);
}
function MdWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.05 4.91A9.816 9.816 0 0012.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 01-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 012.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z"
                }
            }
        ]
    })(props);
}
function MdWhatshot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
                }
            }
        ]
    })(props);
}
function MdWoman2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3.5v6h3v-6H17l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3v6h4v-6h3l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdWorkspacePremium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.68 13.69L12 11.93l2.31 1.76-.88-2.85L15.75 9h-2.84L12 6.19 11.09 9H8.25l2.31 1.84-.88 2.85zM20 10c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 2.03.76 3.87 2 5.28V23l6-2 6 2v-7.72A7.96 7.96 0 0020 10zm-8-6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6z"
                }
            }
        ]
    })(props);
}
function MdCheckBoxOutlineBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdCheckBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                }
            }
        ]
    })(props);
}
function MdIndeterminateCheckBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdRadioButtonChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdRadioButtonUnchecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdStarBorderPurple500(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L12 14.79l-2.42 1.84.93-3.01L8.24 12h2.82L12 8.89M12 2l-2.42 8H2l6.17 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.58L12 2z"
                }
            }
        ]
    })(props);
}
function MdStarBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdStarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdStarPurple500(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L12 14.79l-2.42 1.84.93-3.01L8.24 12h2.82L12 8.89M12 2l-2.42 8H2l6.17 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.58L12 2z"
                }
            }
        ]
    })(props);
}
function MdStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                }
            }
        ]
    })(props);
}
function MdToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zM7 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h10c2.76 0 5-2.24 5-5s-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdFaceUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function MdBattery20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
                }
            }
        ]
    })(props);
}
function MdBattery30(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
                }
            }
        ]
    })(props);
}
function MdBattery50(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
                }
            }
        ]
    })(props);
}
function MdBattery60(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
                }
            }
        ]
    })(props);
}
function MdBattery80(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
                }
            }
        ]
    })(props);
}
function MdBattery90(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
                }
            }
        ]
    })(props);
}
function MdBatteryCharging20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function MdBatteryCharging30(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
                }
            }
        ]
    })(props);
}
function MdBatteryCharging50(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function MdBatteryCharging60(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
                }
            }
        ]
    })(props);
}
function MdBatteryCharging80(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
                }
            }
        ]
    })(props);
}
function MdBatteryCharging90(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
                }
            }
        ]
    })(props);
}
function MdSignalCellular1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M2 22h20V2L2 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12L2 22h10V12z"
                }
            }
        ]
    })(props);
}
function MdSignalCellular2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M2 22h20V2L2 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10L2 22h12V10z"
                }
            }
        ]
    })(props);
}
function MdSignalCellular3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M2 22h20V2L2 22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7L2 22h15V7z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularConnectedNoInternet1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M22 8V2L2 22h16V8h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularConnectedNoInternet2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M22 8V2L2 22h16V8h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdSignalCellularConnectedNoInternet3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M22 8V2L2 22h16V8h4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22V6L2 22h16zm2-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi1BarLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14.5c0-.23.04-.46.07-.68-.92-.43-2.14-.82-3.57-.82-3 0-5.1 1.7-5.3 1.9l5.3 6.6 3.5-4.36V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi2BarLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14.5c0-1.34.51-2.53 1.34-3.42C15.62 10.51 13.98 10 12 10c-4.1 0-6.8 2.2-7.2 2.5l7.2 9 3.5-4.38V14.5zM23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.79 12.52L12 21.5l7.21-8.99C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi3BarLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .36 0 .71.04 1.05.11L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5l3.5-4.36V14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5a4.92 4.92 0 013.27-4.68C17.29 8.98 14.94 8 12 8c-4.81 0-8.04 2.62-8.47 2.95L12 21.5l3.5-4.36V14.5z"
                }
            }
        ]
    })(props);
}
function MdSignalWifi3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7L12 21.5 23.64 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.53 10.95L12 21.5l8.47-10.55C20.04 10.62 16.81 8 12 8s-8.04 2.62-8.47 2.95z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiConnectedNoInternet0(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 14l-2.09 2.09-.3-.3L15.41 14 14 15.41l1.79 1.79.3.3L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiConnectedNoInternet1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M12 12h8.99L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36A7.932 7.932 0 0112 13v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21v-8c-2.21 0-4.2.89-5.65 2.34L12 21zm9-5.59L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiConnectedNoInternet2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M18.31 12h2.67L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l4.23 4.24A10.96 10.96 0 0112 10c2.35 0 4.52.74 6.31 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-3.03 0-5.78 1.23-7.77 3.22L12 21v-9h6.32c-1.8-1.26-3.97-2-6.32-2zm9 5.41L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiConnectedNoInternet3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M21.18 11.8L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l2.82 2.82C5.17 9.45 8.41 8 12 8s6.83 1.45 9.18 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.18 11.8C18.83 9.45 15.59 8 12 8s-6.83 1.45-9.18 3.8L12 21v-9h8.99l.19-.2zM19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbar1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17.65 15.34L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36C7.8 13.89 9.79 13 12 13s4.2.89 5.65 2.34z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.65 15.34C16.2 13.89 14.21 13 12 13s-4.2.89-5.65 2.34L12 21l5.65-5.66z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbar2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M19.77 13.22L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l4.23 4.24C6.22 11.23 8.97 10 12 10s5.78 1.23 7.77 3.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 13.22C17.78 11.23 15.03 10 12 10s-5.78 1.23-7.77 3.22L12 21l7.77-7.78z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbar3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M21.18 11.8L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l2.82 2.82C5.17 9.45 8.41 8 12 8s6.83 1.45 9.18 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.18 11.8C18.83 9.45 15.59 8 12 8s-6.83 1.45-9.18 3.8L12 21l9.18-9.2z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarConnectedNoInternet1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 14.76V8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98l6.35 6.36A7.95 7.95 0 0112 13c1.89 0 3.63.66 5 1.76z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.35 15.34L12 21l5-5.01v-1.23A7.963 7.963 0 0012 13c-2.21 0-4.2.89-5.65 2.34zM19 18h2v2h-2zM19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarConnectedNoInternet2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 11.21V8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98l4.23 4.24A10.96 10.96 0 0117 11.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.23 13.22L12 21l5-5.01v-4.78a10.96 10.96 0 00-12.77 2.01zM19 18h2v2h-2zM19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarConnectedNoInternet3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M17 9V8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98l2.82 2.82A12.93 12.93 0 0112 8c1.77 0 3.46.36 5 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.82 11.8L12 21l5-5.01V9c-1.54-.64-3.23-1-5-1-3.59 0-6.83 1.45-9.18 3.8zM19 18h2v2h-2zM19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarConnectedNoInternet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 18h2v2h-2zM19 10h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8h5.92C19.97 5.51 16.16 4 12 4 7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8z",
                    "opacity": ".3"
                }
            }
        ]
    })(props);
}
function MdSignalWifiStatusbarNotConnected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.52 15.16c.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C16.51 10.96 17.52 10 19 10c1.23 0 2.08.56 2.51 1.26.37.6.58 1.73.01 2.57-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c0-.41-.07-1.08.26-1.66zm-.57 3.79c0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04 0 .58-.44 1.05-1.04 1.05-.58 0-1.05-.47-1.05-1.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M14 13c0-2.76 2.24-5 5-5 1.63 0 3.07.79 3.98 2L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21l4.01-4.02C14.8 16.07 14 14.63 14 13z"
                }
            }
        ]
    })(props);
}
function MdWifiCalling1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M16.49 4.5c1.79 0 3.42.73 4.59 1.91l1.06-1.06A7.94 7.94 0 0016.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.545 6.545 0 014.6-1.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M16.49 6c-1.38 0-2.63.56-3.54 1.46l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.06-1.06A4.94 4.94 0 0016.49 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 9c-.55 0-1.05.22-1.41.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17.83c1.29.54 2.63.89 4 1.07v-2.23l-2.35-.47L15 17.83zM7.33 5H5.1c.18 1.37.53 2.7 1.07 4L7.8 7.35 7.33 5z",
                    "opacity": ".3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function MdWifiCalling2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillOpacity": ".3",
                    "d": "M16.49 4.5c1.79 0 3.42.73 4.59 1.91l1.06-1.06A7.94 7.94 0 0016.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.545 6.545 0 014.6-1.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 6c-1.38 0-2.63.56-3.54 1.46l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.06-1.06A4.94 4.94 0 0016.49 6zM16.49 9c-.55 0-1.05.22-1.41.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17.83c1.29.54 2.63.89 4 1.07v-2.23l-2.35-.47L15 17.83zM7.33 5H5.1c.18 1.37.53 2.7 1.07 4L7.8 7.35 7.33 5z",
                    "opacity": ".3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function MdOutline123(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15H5.5v-4.5H4V9h3v6zm6.5-1.5h-3v-1h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H9v1.5h3v1h-2c-.55 0-1 .45-1 1V15h4.5v-1.5zm6 .5v-4c0-.55-.45-1-1-1H15v1.5h3v1h-2v1h2v1h-3V15h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutline3DRotation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.53 21.48A10.487 10.487 0 011.56 13H.06c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08a1.07 1.07 0 01-.4-.24c-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56a1.67 1.67 0 00-.23-.51c-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31a2.098 2.098 0 00.89-.75c.1-.15.17-.3.22-.46s.07-.32.07-.48c0-.36-.06-.68-.18-.96s-.29-.51-.51-.69c-.2-.19-.47-.33-.77-.43C9.11 8.05 8.77 8 8.4 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37c-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.44-.18-.93-.27-1.47-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76c.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57s-.42-.87-.74-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12.01 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.45 4.84 18.3 0 12.01 0z"
                }
            }
        ]
    })(props);
}
function MdOutlineAbc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11h-1.5v-.5h-2v3h2V13H21v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zM8 10v5H6.5v-1.5h-2V15H3v-5c0-.55.45-1 1-1h3c.55 0 1 .45 1 1zm-1.5.5h-2V12h2v-1.5zm7 1.5c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1h-4V9h4c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM11 10.5v.75h2v-.75h-2zm2 2.25h-2v.75h2v-.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessibilityNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 6c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 8c1.86.5 4 .83 6 1v13h2v-6h2v6h2V9c2-.17 4.14-.5 6-1l-.5-2zM12 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessibleForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "4.54",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 17h-2c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3v-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5zm3-3.5h-1.86l1.67-3.67C18.42 8.5 17.44 7 15.96 7h-5.2c-.81 0-1.54.47-1.87 1.2L8.22 10l1.92.53.65-1.53H13l-1.83 4.1c-.6 1.33.39 2.9 1.85 2.9H18v5h2v-5.5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-9 7c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccountBalanceWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7.28V5c0-1.1-.9-2-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-2.28A2 2 0 0022 15V9a2 2 0 00-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineAccountBalance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 10h-2v7h2v-7zm6 0h-2v7h2v-7zm8.5 9H2v2h19v-2zm-2.5-9h-2v7h2v-7zm-7-6.74L16.71 6H6.29l5.21-2.74m0-2.26L2 6v2h19V6l-9.5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccountBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 16H7v-.24C8.42 17.62 10.16 17 12 17s3.58.62 5 1.76V19zm2-1.14C17.2 16.09 14.73 15 12 15s-5.2 1.09-7 2.86V5h14v12.86zM12 13c1.93 0 3.5-1.57 3.5-3.5S13.93 6 12 6 8.5 7.57 8.5 9.5 10.07 13 12 13zm0-5c.83 0 1.5.67 1.5 1.5S12.83 11 12 11s-1.5-.67-1.5-1.5S11.17 8 12 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccountCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5zm10.79-1.38a9.947 9.947 0 00-12.28 0A7.957 7.957 0 014 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h10v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm4 9v2h-3v3h-2v-3h-3v-2h3v-3h2v3h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5l6 4.5v1c.7 0 1.37.1 2 .29V9l-8-6-8 6v12h7.68c-.3-.62-.5-1.29-.6-2H6v-9l6-4.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V21h-1v-2.5H15v-1h2.5V15h1v2.5H21v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4l-3.87 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8c1.57 0 3.04.46 4.28 1.25l1.45-1.45A10.02 10.02 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c1.73 0 3.36-.44 4.78-1.22l-1.5-1.5c-1 .46-2.11.72-3.28.72zm7-5h-3v2h3v3h2v-3h3v-2h-3v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddToDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11c.17 0 .33.01.49.02L15 3H9l5.68 9.84A5.986 5.986 0 0119 11zM8.15 4.52L2 15.5 5 21l6.33-10.97zM13.2 15.5H9.9L6.73 21h7.81A5.93 5.93 0 0113 17c0-.52.07-1.02.2-1.5zM20 16v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddchart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5v2h-3v3h-2V7h-3V5h3V2h2v3h3zm-3 14H5V5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6zm-4-6v4h2v-4h-2zm-4 4h2V9h-2v8zm-2 0v-6H7v6h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAdminPanelSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "circle",
                        "attr": {
                            "cx": "17",
                            "cy": "15.5",
                            "r": "1.12"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M17 17.5c-.73 0-2.19.36-2.24 1.08.5.71 1.32 1.17 2.24 1.17s1.74-.46 2.24-1.17c-.05-.72-1.51-1.08-2.24-1.08z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M18 11.09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55A5.973 5.973 0 0017 23c3.31 0 6-2.69 6-6 0-2.97-2.16-5.43-5-5.91zM11 17c0 .56.08 1.11.23 1.62-.24.11-.48.22-.73.3-3.17-1-5.5-4.24-5.5-7.74v-3.6l5.5-2.4 5.5 2.4v3.51c-2.84.48-5 2.94-5 5.91zm6 4c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function MdOutlineAdsClick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.71 17.99A5.993 5.993 0 016 12c0-3.31 2.69-6 6-6 3.22 0 5.84 2.53 5.99 5.71l-2.1-.63a3.999 3.999 0 10-4.81 4.81l.63 2.1zM22 12c0 .3-.01.6-.04.9l-1.97-.59c.01-.1.01-.21.01-.31 0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8c.1 0 .21 0 .31-.01l.59 1.97c-.3.03-.6.04-.9.04-5.52 0-10-4.48-10-10S6.48 2 12 2s10 4.48 10 10zm-3.77 4.26L22 15l-10-3 3 10 1.26-3.77 4.27 4.27 1.98-1.98-4.28-4.26z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlarmAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.337 1.81l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 10.001 18.001A9 9 0 0012 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlarmOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.04 6.29C10.66 6.11 11.32 6 12 6c3.86 0 7 3.14 7 7 0 .68-.11 1.34-.29 1.96l1.56 1.56c.47-1.08.73-2.27.73-3.52A9 9 0 008.47 4.72l1.57 1.57zm7.297-4.48l4.607 3.845-1.28 1.535-4.61-3.843zM3.02 2.1L1.61 3.51l1.37 1.37-.92.77 1.28 1.54 1.06-.88.8.8A8.964 8.964 0 003 13a9 9 0 009 9c2.25 0 4.31-.83 5.89-2.2l2.1 2.1 1.41-1.41L3.02 2.1zM12 20c-3.86 0-7-3.14-7-7 0-1.7.61-3.26 1.62-4.47l9.85 9.85A6.956 6.956 0 0112 20zM7.48 3.73l.46-.38-1.28-1.54-.6.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlarmOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.54 14.53L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06zm6.797-12.72l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 10.001 18.001A9 9 0 0012 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 8H11v6l4.75 2.85.75-1.23-4-2.37zm4.837-6.19l4.607 3.845-1.28 1.535-4.61-3.843zm-10.674 0l1.282 1.536L3.337 7.19l-1.28-1.536zM12 4a9 9 0 10.001 18.001A9 9 0 0012 4zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAllInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 10h3.13c.21.78.67 1.47 1.27 2H5v-2zm14 2h-4.4c.6-.53 1.06-1.22 1.27-2H19v2zm0-4h-5v1c0 1.07-.93 2-2 2s-2-.93-2-2V8H5V5h14v3zm-2 7h-3v1c0 .47-.19.9-.48 1.25-.37.45-.92.75-1.52.75s-1.15-.3-1.52-.75c-.29-.35-.48-.78-.48-1.25v-1H3v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4h-4zM5 17h3.13c.02.09.06.17.09.25.24.68.65 1.28 1.18 1.75H5v-2zm14 2h-4.4c.54-.47.95-1.07 1.18-1.75.03-.08.07-.16.09-.25H19v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAllOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v4l4-4zm12 0l4 4V4zm4 16v-4l-4 4zM4 20h4l-4-4zm15-8c0-3.87-3.13-7-7-7s-7 3.13-7 7 3.13 7 7 7 7-3.13 7-7zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAnalytics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12h2v5H7zM15 7h2v10h-2zM11 14h2v3h-2zM11 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15l1.55 1.55c-.96 1.69-3.33 3.04-5.55 3.37V11h3V9h-3V7.82C14.16 7.4 15 6.3 15 5c0-1.65-1.35-3-3-3S9 3.35 9 5c0 1.3.84 2.4 2 2.82V9H8v2h3v8.92c-2.22-.33-4.59-1.68-5.55-3.37L7 15l-4-3v3c0 3.88 4.92 7 9 7s9-3.12 9-7v-3l-4 3zM12 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 00-.83.22l-1.88 3.24a11.463 11.463 0 00-8.94 0L5.65 5.67a.643.643 0 00-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.78 10.78 0 001 18h22a10.78 10.78 0 00-5.4-8.52zM7 15.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm10 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAnnouncement(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM11 5h2v6h-2zm0 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12l-2 2-2-2 2-2 2 2zm-2-6l2.12 2.12 2.5-2.5L12 1 7.38 5.62l2.5 2.5L12 6zm-6 6l2.12-2.12-2.5-2.5L1 12l4.62 4.62 2.5-2.5L6 12zm12 0l-2.12 2.12 2.5 2.5L23 12l-4.62-4.62-2.5 2.5L18 12zm-6 6l-2.12-2.12-2.5 2.5L12 23l4.62-4.62-2.5-2.5L12 18z"
                }
            }
        ]
    })(props);
}
function MdOutlineAppBlocking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-2.5 4A2.5 2.5 0 0118 9.5c.42 0 .8.11 1.15.29l-3.36 3.36c-.18-.35-.29-.73-.29-1.15zm2.5 2.5c-.42 0-.8-.11-1.15-.29l3.36-3.36c.18.35.29.73.29 1.15a2.5 2.5 0 01-2.5 2.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM7 3h10v1H7V3zm10 18H7v-1h10v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAppShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM7 3h10v1H7V3zm10 18H7v-1h10v1zM20.38 9.62L21 11l.62-1.38L23 9l-1.38-.62L21 7l-.62 1.38L19 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8l-1.25 2.75L12 12l2.75 1.25L16 16l1.25-2.75L20 12l-2.75-1.25zM21 13l-.62 1.38L19 15l1.38.62L21 17l.62-1.38L23 15l-1.38-.62z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 10V8h-2v4H8l4 4 4-4h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm18 0c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8zM8 12l4-4 1.41 1.41L11.83 11H16v2h-4.17l1.59 1.59L12 16l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zM4 12c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8zm12 0l-4 4-1.41-1.41L12.17 13H8v-2h4.17l-1.59-1.59L12 8l4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0 2c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm-1-10v4h2v-4h3l-4-4-4 4h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowOutward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6v2h8.59L5 17.59 6.41 19 16 9.41V18h2V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowRightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineArticle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAspectRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssessment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssignmentInd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.22 0 .41.1.55.25.12.13.2.31.2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.19.08-.37.2-.5.14-.15.33-.25.55-.25zM19 19H5V5h14v14zM12 6c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-6 6.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssignmentLate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zm0-8h2v6h-2zm8-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssignmentReturn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14h4v-4h-4V7l-5 5 5 5zm7-11h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssignmentReturned(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h-3V8h-4v4H7l5 5zm2-9h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssignmentTurnedIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9l-1.41-1.42L10 14.17l-2.59-2.58L6 13l4 4zm1-6h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssignment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssuredWorkload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h2v7H5zM11 10h2v7h-2zM22 6L12 1 2 6v2h20V6zM6.47 6L12 3.24 17.53 6H6.47zM2 19v2h12.4c-.21-.64-.32-1.31-.36-2H2zM19 12.26V10h-2v3.26zM20 14l-4 2v2.55c0 2.52 1.71 4.88 4 5.45 2.29-.57 4-2.93 4-5.45V16l-4-2zm-.72 7l-2.03-2.03 1.06-1.06.97.97 2.41-2.38 1.06 1.06L19.28 21z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutorenew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 016 12c0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
                }
            }
        ]
    })(props);
}
function MdOutlineBackupTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 16H4v-5h5v5zm7 0h-5v-5h5v5zm0-7H4V4h12v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBackup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBalance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.83c.85-.3 1.53-.98 1.83-1.83H18l-3 7c0 1.66 1.57 3 3.5 3s3.5-1.34 3.5-3l-3-7h2V4h-6.17c-.41-1.17-1.52-2-2.83-2s-2.42.83-2.83 2H3v2h2l-3 7c0 1.66 1.57 3 3.5 3S9 14.66 9 13L6 6h3.17c.3.85.98 1.53 1.83 1.83V19H2v2h20v-2h-9V7.83zM20.37 13h-3.74l1.87-4.36L20.37 13zm-13 0H3.63L5.5 8.64 7.37 13zM12 6c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatchPrediction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8H7c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-4 12.5h-2V19h2v1.5zm0-2.5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 2-2.5 3.5-2.5 5zm5-11.5H6C6 5.67 6.67 5 7.5 5h9c.83 0 1.5.67 1.5 1.5zm-1-3H7C7 2.67 7.67 2 8.5 2h7c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookOnline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4H7V3h10v1zm0 17H7v-1h10v1zm0-20H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 6h10v12H7V6zm9 5V9.14C16 8.51 15.55 8 15 8H9c-.55 0-1 .51-1 1.14v1.96c.55 0 1 .45 1 1s-.45 1-1 1v1.76c0 .63.45 1.14 1 1.14h6c.55 0 1-.51 1-1.14V13c-.55 0-1-.45-1-1s.45-1 1-1zm-3.5 3.5h-1v-1h1v1zm0-2h-1v-1h1v1zm0-2h-1v-1h1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookmarkAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-2v2h-2V7h-2V5h2V3h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookmarkAdded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm.83-2L15 6.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L17.83 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookmarkBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookmarkRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-6V5h6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBookmarks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v12.97l-4.21-1.81-.79-.34-.79.34L5 19.97V7h10m4-6H8.99C7.89 1 7 1.9 7 3h10c1.1 0 2 .9 2 2v13l2 1V3c0-1.1-.9-2-2-2zm-4 4H5c-1.1 0-2 .9-2 2v16l7-3 7 3V7c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrowseGallery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3a9 9 0 10.001 18.001A9 9 0 009 3zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7H8v5.41l3.79 3.8 1.42-1.42-3.21-3.2zM17.99 3.52v2.16A6.99 6.99 0 0122 12c0 2.79-1.64 5.2-4.01 6.32v2.16C21.48 19.24 24 15.91 24 12s-2.52-7.24-6.01-8.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineBugReport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-2.81a5.985 5.985 0 00-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65A4.27 4.27 0 018 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18a3.787 3.787 0 011.89 0l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBuildCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M13.49 11.38c.43-1.22.17-2.64-.81-3.62a3.468 3.468 0 00-4.1-.59l2.35 2.35-1.41 1.41-2.35-2.35c-.71 1.32-.52 2.99.59 4.1.98.98 2.4 1.24 3.62.81l3.41 3.41c.2.2.51.2.71 0l1.4-1.4c.2-.2.2-.51 0-.71l-3.41-3.41z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function MdOutlineBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.61 18.99l-9.08-9.08c.93-2.34.45-5.1-1.44-7C9.79.61 6.21.4 3.66 2.26L7.5 6.11 6.08 7.52 2.25 3.69C.39 6.23.6 9.82 2.9 12.11c1.86 1.86 4.57 2.35 6.89 1.48l9.11 9.11c.39.39 1.02.39 1.41 0l2.3-2.3c.4-.38.4-1.01 0-1.41zm-3 1.6l-9.46-9.46c-.61.45-1.29.72-2 .82-1.36.2-2.79-.21-3.83-1.25C3.37 9.76 2.93 8.5 3 7.26l3.09 3.09 4.24-4.24-3.09-3.09c1.24-.07 2.49.37 3.44 1.31a4.469 4.469 0 011.24 3.96 4.35 4.35 0 01-.88 1.96l9.45 9.45-.88.89z"
                }
            }
        ]
    })(props);
}
function MdOutlineCached(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8l-4 4h3c0 3.31-2.69 6-6 6a5.87 5.87 0 01-2.8-.7l-1.46 1.46A7.93 7.93 0 0012 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46A7.93 7.93 0 0012 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCalendarMonth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCalendarToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCalendarViewDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v2H3zm16-5v1H5v-1h14m2-2H3v5h18v-5zM3 6h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCalendarViewMonth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 11H4V6h4v5zm6 0h-4V6h4v5zm6 0h-4V6h4v5zM8 18H4v-5h4v5zm6 0h-4v-5h4v5zm6 0h-4v-5h4v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCalendarViewWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2h2.5v12H13V6zm-2 12H8.5V6H11v12zM4 6h2.5v12H4V6zm16 12h-2.5V6H20v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraEnhance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10l-.94 2.06L9 13l2.06.94L12 16l.94-2.06L15 13l-2.06-.94zm8-5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12zM12 8c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCancelScheduleSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 9c-.42 0-.83.04-1.24.11L1.01 3 1 10l10.06 1.34c-.42.44-.78.93-1.09 1.46L1 14l.01 7 8.07-3.46C9.59 21.19 12.71 24 16.5 24c4.14 0 7.5-3.36 7.5-7.5S20.64 9 16.5 9zM3 8.25l.01-2.22 7.51 3.22-7.52-1zm6.1 7.11L3 17.97v-2.22l6.17-.82c-.03.14-.05.28-.07.43zM16.5 22c-3.03 0-5.5-2.47-5.5-5.5s2.47-5.5 5.5-5.5 5.5 2.47 5.5 5.5-2.47 5.5-5.5 5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.27 14.03l-1.77 1.76-1.77-1.76-.7.7 1.76 1.77-1.76 1.77.7.7 1.77-1.76 1.77 1.76.7-.7-1.76-1.77 1.76-1.77z"
                }
            }
        ]
    })(props);
}
function MdOutlineCardGiftcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCardMembership(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCardTravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineChangeHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCheckCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineChromeReaderMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM3 19V6h8v13H3zm18 0h-8V6h8v13zm-7-9.5h6V11h-6zm0 2.5h6v1.5h-6zm0 2.5h6V16h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCircleNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18.5c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4-8.61c0-2.11-1.03-3.92-3-4.39v-.5c0-.57-.43-1-1-1s-1 .43-1 1V7c-1.97.47-3 2.27-3 4.39V14H7v2h10v-2h-1v-2.61zM14 14h-4v-3c0-1.1.9-2 2-2s2 .9 2 2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineClass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 4h2v5l-1-.75L9 9V4zm9 16H6V4h1v9l3-2.25L13 13V4h5v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloseFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.41L16.71 8.7 20 12h-8V4l3.29 3.29L20.59 2 22 3.41zM3.41 22l5.29-5.29L12 20v-8H4l3.29 3.29L2 20.59 3.41 22z"
                }
            }
        ]
    })(props);
}
function MdOutlineCodeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.17 12l-4.58-4.59L16 6l6 6-3.59 3.59L17 14.17 19.17 12zM1.39 4.22l4.19 4.19L2 12l6 6 1.41-1.41L4.83 12 7 9.83l12.78 12.78 1.41-1.41L2.81 2.81 1.39 4.22z"
                }
            }
        ]
    })(props);
}
function MdOutlineCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCommentBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14V6h-5v8l2.5-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.9 11a5 5 0 00-9.8 0H2v2h5.1a5 5 0 009.8 0H22v-2h-5.1zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCommute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4H5C3.34 4 2 5.34 2 7v8c0 1.66 1.34 3 3 3l-1 1v1h1l2-2h2v-5H4V6h9v2h2V7c0-1.66-1.34-3-3-3zM5 14c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm15.57-4.34c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66l-1.42 4.11v5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V18h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCompareArrows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9v2h16V9H4zm12-5l-1.41-1.41L13 4.17V1h-2v3.19L9.39 2.61 8 4l4 4 4-4zM4 14h16v-2H4v2zm4 5l1.39 1.39L11 18.81V22h2v-3.17l1.59 1.59L16 19l-4-4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineContactPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.17 4L18 8.83V20H6V4h7.17M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-2 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 008 17.43V18h8v-.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineContactSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 23.59v-3.6c-5.01-.26-9-4.42-9-9.49C2 5.26 6.26 1 11.5 1S21 5.26 21 10.5c0 4.95-3.44 9.93-8.57 12.4l-1.43.69zM11.5 3C7.36 3 4 6.36 4 10.5S7.36 18 11.5 18H13v2.3c3.64-2.3 6-6.08 6-9.8C19 6.36 15.64 3 11.5 3zm-1 11.5h2v2h-2zm2-1.5h-2c0-3.25 3-3 3-5 0-1.1-.9-2-2-2s-2 .9-2 2h-2c0-2.21 1.79-4 4-4s4 1.79 4 4c0 2.5-3 2.75-3 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineContactless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.1 10.18a4.384 4.384 0 010 3.66l1.37.62c.37-.81.55-1.65.54-2.5-.01-.84-.19-1.65-.54-2.4l-1.37.62zM13.33 7.33c.78 1.57 1.18 3.14 1.18 4.64 0 1.51-.4 3.09-1.18 4.69l1.35.66c.88-1.81 1.33-3.61 1.33-5.35 0-1.74-.45-3.53-1.33-5.31l-1.35.67zM10.2 8.72c.53 1.07.8 2.21.8 3.4 0 1.17-.26 2.23-.78 3.15l1.3.74c.65-1.15.98-2.45.98-3.89 0-1.42-.32-2.79-.96-4.07l-1.34.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91c.48.22 1.05.34 1.7.34.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCreditCardOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H20c1.11 0 2 .89 2 2v12c0 .34-.08.66-.23.94L20 17.17V12h-5.17l-4-4H20V6H8.83l-2-2zm13.66 19.31L17.17 20H4c-1.11 0-2-.89-2-2l.01-12c0-.34.08-.66.23-.93L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM4 6.83V8h1.17L4 6.83zM15.17 18l-6-6H4v6h11.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 14v-1H11v.5h2v-1h-2.5c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H13v-.5h-2v1h2.5c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zm7.5 1h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1h-2.5v-1h2v.5H21v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2.5v1h-2V13H16v1c0 .55.45 1 1 1zm-9-5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-1H6.5v.5h-2v-3h2v.5H8v-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.89 11.1c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.45-.82-1.92-2.54-2.24V5h-2v1.26c-2.48.56-2.49 2.86-2.49 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 2.9 2.96V19h2v-1.24c.4-.09 2.9-.59 2.9-3.22 0-1.39-.61-2.61-3.01-3.44zM3 21H1v-6h6v2H4.52c1.61 2.41 4.36 4 7.48 4a9 9 0 009-9h2c0 6.08-4.92 11-11 11-3.72 0-7.01-1.85-9-4.67V21zm-2-9C1 5.92 5.92 1 12 1c3.72 0 7.01 1.85 9 4.67V3h2v6h-6V7h2.48C17.87 4.59 15.12 3 12 3a9 9 0 00-9 9H1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDangerous(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8zm-4.17-7.14L12 10.59 9.17 7.76 7.76 9.17 10.59 12l-2.83 2.83 1.41 1.41L12 13.41l2.83 2.83 1.41-1.41L13.41 12l2.83-2.83-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineDashboardCustomize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3v8zm2-6h4v4H5V5zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM18 13h-2v3h-3v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v2h-4V5h4M9 5v6H5V5h4m10 8v6h-4v-6h4M9 17v2H5v-2h4M21 3h-8v6h8V3zM11 3H3v10h8V3zm10 8h-8v10h8V11zm-10 4H3v6h8v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataExploration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.52-4.48-10-10-10zm0 18c-2.89 0-5.43-1.54-6.83-3.84l2.95-2.95L11.41 16 16 11.42V13h2V8h-5v2h1.58l-3.28 3.28L8 10.5l-3.69 3.7C4.11 13.5 4 12.76 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm7.5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataThresholding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-1.73L19 17.27V19zm0-3h-.85l-3 3h-1.62l3-3h-2.12l-3 3H9.8l3-3h-2.12l-3 3H5.84l3-3H6.72L5 17.72V5h14v11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.67 11l2 2 5.08-5.09-1.41-1.41-3.67 3.67-2-2-4.42 4.42L7.66 14z"
                }
            }
        ]
    })(props);
}
function MdOutlineDateRange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5a2 2 0 01-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeleteForever(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeleteOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4h-3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineDensityLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDensityMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3zM3 19h18v2H3zM3 11h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDensitySmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h18v2H3zM3 20h18v2H3zM3 14h18v2H3zM3 8h18v2H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineDisabledByDefault(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v14zM3 3v18h18V3H3zm14 12.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineDisabledVisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15c1.95 0 3.76.98 4.75 2.5-.99 1.52-2.8 2.5-4.75 2.5s-3.76-.98-4.75-2.5c.99-1.52 2.8-2.5 4.75-2.5zm0-2c-3.18 0-5.9 1.87-7 4.5 1.1 2.63 3.82 4.5 7 4.5s5.9-1.87 7-4.5c-1.1-2.63-3.82-4.5-7-4.5zm0 6c-.83 0-1.5-.67-1.5-1.5S16.17 16 17 16s1.5.67 1.5 1.5S17.83 19 17 19zm4.99-6.66c.01-.11.01-.23.01-.34 0-5.52-4.48-10-10-10S2 6.48 2 12c0 5.17 3.93 9.43 8.96 9.95a9.343 9.343 0 01-2.32-2.68A8.01 8.01 0 014 12c0-1.85.63-3.55 1.69-4.9l5.66 5.66c.56-.4 1.17-.73 1.82-1L7.1 5.69A7.902 7.902 0 0112 4c4.24 0 7.7 3.29 7.98 7.45.71.22 1.39.52 2.01.89z"
                }
            }
        ]
    })(props);
}
function MdOutlineDisplaySettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 8.25h8v1.5H6zM16.5 9.75H18v-1.5h-1.5V7H15v4h1.5zM10 12.25h8v1.5h-8zM7.5 15H9v-4H7.5v1.25H6v1.5h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v4H5v-4h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 18.5c-.82 0-1.5-.67-1.5-1.5s.68-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM19 5v4H5V5h14m1-2H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 8.5c-.82 0-1.5-.67-1.5-1.5S6.18 5.5 7 5.5s1.5.68 1.5 1.5S7.83 8.5 7 8.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoneAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoneOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 4.93l1.4 1.4L8.43 19.07l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 4.93m0-2.83L8.43 13.44l-4.2-4.2L0 13.47l8.43 8.43L24 6.33 19.77 2.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDonutLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.08A7 7 0 0118.92 11h3.03c-.47-4.72-4.23-8.48-8.95-8.95v3.03zM18.92 13A7 7 0 0113 18.92v3.03c4.72-.47 8.48-4.23 8.95-8.95h-3.03zM11 18.92c-3.39-.49-6-3.4-6-6.92s2.61-6.43 6-6.92V2.05c-5.05.5-9 4.76-9 9.95 0 5.19 3.95 9.45 9 9.95v-3.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineDonutSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.82 11h7.13c-.47-4.72-4.23-8.48-8.95-8.95v7.13c.85.31 1.51.97 1.82 1.82zM15 4.58C17 5.4 18.6 7 19.42 9h-3.43c-.28-.37-.62-.71-.99-.99V4.58zM2 12c0 5.19 3.95 9.45 9 9.95v-7.13C9.84 14.4 9 13.3 9 12c0-1.3.84-2.4 2-2.82V2.05c-5.05.5-9 4.76-9 9.95zm7-7.42v3.44c-1.23.92-2 2.39-2 3.98 0 1.59.77 3.06 2 3.99v3.44C6.04 18.24 4 15.35 4 12c0-3.35 2.04-6.24 5-7.42zm4 10.24v7.13c4.72-.47 8.48-4.23 8.95-8.95h-7.13c-.31.85-.97 1.51-1.82 1.82zm2 1.17c.37-.28.71-.61.99-.99h3.43C18.6 17 17 18.6 15 19.42v-3.43z"
                }
            }
        ]
    })(props);
}
function MdOutlineDragIndicator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDynamicForm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h9v7zM4 9h7V6H4v3zm11 11H4c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h11v7zM4 18h9v-3H4v3zm18-9h-2l2-5h-7v7h2v9l5-11zM4.75 17.25h1.5v-1.5h-1.5v1.5zm0-9h1.5v-1.5h-1.5v1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineEco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.05 8.05a7.007 7.007 0 000 9.9C7.42 19.32 9.21 20 11 20s3.58-.68 4.95-2.05C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05zm8.49 8.49c-.95.94-2.2 1.46-3.54 1.46-.89 0-1.73-.25-2.48-.68.92-2.88 2.62-5.41 4.88-7.32-2.63 1.36-4.84 3.46-6.37 6-1.48-1.96-1.35-4.75.44-6.54C9.21 7.72 14.04 6.65 17.8 6.2c-.45 3.76-1.52 8.59-3.26 10.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 10h14v2h2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h7v-2H5V10zm0-4h14v2H5V6zm17.84 10.28l-.71.71-2.12-2.12.71-.71a.996.996 0 011.41 0l.71.71c.39.39.39 1.02 0 1.41zm-3.54-.7l2.12 2.12-5.3 5.3H14v-2.12l5.3-5.3z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.02l.92.92-1.11 1.11 1.41 1.41 2.52-2.52-3.75-3.75-2.52 2.52 1.41 1.41 1.12-1.1zm6.65-1.98a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83zM2.81 2.81L1.39 4.22l7.32 7.32L3 17.25V21h3.75l5.71-5.71 7.32 7.32 1.41-1.41L2.81 2.81zM5.92 19H5v-.92l5.13-5.13.92.92L5.92 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17h14v2H5zm7-12L5.33 15h13.34L12 5zm0 3.6l2.93 4.4H9.07L12 8.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineEuroSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06a8.262 8.262 0 000 2H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineEventRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V10h14v2h2zm-2-4H5V6h14v2zm-3.36 12a3.504 3.504 0 006.86-1c0-1.93-1.57-3.5-3.5-3.5-.95 0-1.82.38-2.45 1H18V18h-4v-4h1.5v1.43c.9-.88 2.14-1.43 3.5-1.43 2.76 0 5 2.24 5 5a5.002 5.002 0 01-9.9 1h1.54z"
                }
            }
        ]
    })(props);
}
function MdOutlineEventSeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5v7H9V5h6m0-2H9c-1.1 0-2 .9-2 2v9h10V5c0-1.1-.9-2-2-2zm7 7h-3v3h3v-3zM5 10H2v3h3v-3zm15 5H4v6h2v-4h12v4h2v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineEvent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineExitToApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5a2 2 0 00-2 2v4h2V5h14v14H5v-4H3v4a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 20h16v2H4zM4 2h16v2H4zM9.41 13.59L8 15l4 4 4-4-1.41-1.41L13 15.17V8.83l1.59 1.58L16 9l-4-4-4 4 1.41 1.41L11 8.83v6.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineExploreOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.06l1.46 1.46A9.967 9.967 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.46 1.46A7.869 7.869 0 0112 4zm2.91 8.08L17.5 6.5l-5.58 2.59 2.99 2.99zM2.1 4.93l1.56 1.56A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l1.56 1.56 1.41-1.41L3.51 3.51 2.1 4.93zm3.02 3.01l3.98 3.98-2.6 5.58 5.58-2.59 3.98 3.98c-1.2.7-2.58 1.11-4.06 1.11-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineExplore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5.5-2.5l7.51-3.49L17.5 6.5 9.99 9.99 6.5 17.5zm5.5-6.6c.61 0 1.1.49 1.1 1.1s-.49 1.1-1.1 1.1-1.1-.49-1.1-1.1.49-1.1 1.1-1.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineExtensionOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.39 4.22l1.62 1.62c0 .05-.01.1-.01.16v3.8c2.7 0 3 2.16 3 2.7s-.29 2.7-3 2.7V19c0 1.1.9 2 2 2h3.8c0-2.71 2.16-3 2.7-3s2.7.29 2.7 3H18c.06 0 .11 0 .16-.01l1.61 1.61 1.41-1.41L2.81 2.81 1.39 4.22zM11.5 16c-1.5 0-3.57.83-4.37 3H5v-2.13c2.17-.8 3-2.87 3-4.37 0-.69-.18-1.5-.58-2.25l6.33 6.33A4.89 4.89 0 0011.5 16zM8.83 6l-2-2H9a2.5 2.5 0 015 0h4c1.1 0 2 .9 2 2v4a2.5 2.5 0 010 5v2.17l-2-2V13h2c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-2V6h-6V4c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2H8.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 4.5c.28 0 .5.22.5.5v2h6v6h2c.28 0 .5.22.5.5s-.22.5-.5.5h-2v6h-2.12c-.68-1.75-2.39-3-4.38-3s-3.7 1.25-4.38 3H4v-2.12c1.75-.68 3-2.39 3-4.38 0-1.99-1.24-3.7-2.99-4.38L4 7h6V5c0-.28.22-.5.5-.5m0-2A2.5 2.5 0 008 5H4c-1.1 0-1.99.9-1.99 2v3.8h.29c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-.3c0-1.49 1.21-2.7 2.7-2.7s2.7 1.21 2.7 2.7v.3H17c1.1 0 2-.9 2-2v-4a2.5 2.5 0 000-5V7c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-2.5-2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFaceUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFactCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "g",
                "attr": {
                    "fillRule": "evenodd"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H4V5h16v14z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M19.41 10.42L17.99 9l-3.17 3.17-1.41-1.42L12 12.16 14.82 15zM5 7h5v2H5zM5 11h5v2H5zM5 15h5v2H5z"
                        }
                    }
                ]
            }
        ]
    })(props);
}
function MdOutlineFavoriteBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineFavorite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                }
            }
        ]
    })(props);
}
function MdOutlineFax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-1V4H8v5h-.78C6.67 8.39 5.89 8 5 8c-1.66 0-3 1.34-3 3v7c0 1.66 1.34 3 3 3 .89 0 1.67-.39 2.22-1H22v-8c0-1.66-1.34-3-3-3zM6 18c0 .55-.45 1-1 1s-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7zm4-12h6v3h-6V6zm10 12H8v-7h11c.55 0 1 .45 1 1v6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h4v5H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineFeedback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilePresent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h8v4h4v12zm-6-3c-1.1 0-2-.9-2-2V9.5c0-.28.22-.5.5-.5s.5.22.5.5V15h2V9.5a2.5 2.5 0 00-5 0V15c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2v4c0 1.1-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterAltOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.95 6l-3.57 4.55 1.43 1.43c1.03-1.31 4.98-6.37 4.98-6.37A.998.998 0 0019 4H6.83l2 2h8.12zM2.81 2.81L1.39 4.22 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-2.17l5.78 5.78 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24m0 24H0"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 6h10l-5.01 6.3L7 6zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0018.95 4H5.04c-.83 0-1.3.95-.79 1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdOutlineFindInPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 4h7l5 5v8.58l-1.84-1.84a4.992 4.992 0 00-.64-6.28A4.96 4.96 0 0012 8a5 5 0 00-3.53 1.46 4.98 4.98 0 000 7.05 4.982 4.982 0 006.28.63L17.6 20H6V4zm8.11 11.1c-.56.56-1.31.88-2.11.88s-1.55-.31-2.11-.88c-.56-.56-.88-1.31-.88-2.11s.31-1.55.88-2.11c.56-.57 1.31-.88 2.11-.88s1.55.31 2.11.88c.56.56.88 1.31.88 2.11s-.31 1.55-.88 2.11z"
                }
            }
        ]
    })(props);
}
function MdOutlineFindReplace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05A6.976 6.976 0 0011 4c-3.53 0-6.43 2.61-6.92 6H6.1A5 5 0 0111 6zm5.64 9.14A6.89 6.89 0 0017.92 12H15.9a5 5 0 01-4.9 4c-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05A6.976 6.976 0 0011 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 01.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 01-.44.28zM3.5 9.72a.499.499 0 01-.41-.79c.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25a.5.5 0 01-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 00-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07a.47.47 0 01-.35-.15c-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1a7.297 7.297 0 01-2.17-5.22c0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29a11.14 11.14 0 01-.73-3.96c0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
                }
            }
        ]
    })(props);
}
function MdOutlineFitScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 16h12V8H6v8zm2-6h8v4H8v-4zm-4 5H2v3c0 1.1.9 2 2 2h3v-2H4v-3zm0-9h3V4H4c-1.1 0-2 .9-2 2v3h2V6zm16-2h-3v2h3v3h2V6c0-1.1-.9-2-2-2zm0 14h-3v2h3c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlaky(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M14.05 17.58l-.01.01-2.4-2.4 1.06-1.06 1.35 1.35L16.54 13l1.06 1.06-3.54 3.54-.01-.02zM12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM7.34 6.28l1.41 1.41 1.41-1.41 1.06 1.06-1.41 1.41 1.41 1.41-1.06 1.06-1.41-1.41-1.41 1.41-1.06-1.06 1.41-1.41-1.41-1.41 1.06-1.06zM12 20c-2.2 0-4.2-.9-5.7-2.3L17.7 6.3C19.1 7.8 20 9.8 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlightLand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm16.84-3.15c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l16.57 4.44z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlightTakeoff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlipToBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8a2 2 0 00-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7a2 2 0 002 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12a2 2 0 002 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlipToFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3a2 2 0 002 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9a2 2 0 00-2 2v10a2 2 0 002 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlutterDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 11.7c.29-.39.81-.56 1.27-.37.17.07.32.18.43.33.22.28.25.59.22.85-.05.33-.25.63-.54.79 0 0-4.87 2.95-5.07 2.69s3.69-4.29 3.69-4.29zM22 10c0 2.5-1 3-1.5 3-.23 0-.44-.1-.62-.26-.48 3.32-2.36 5.31-5.33 5.99.11.44.48.77.95.77h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.78-.16-1.39-.78-1.55-1.56-.49.06-1 .1-1.54.1-.88 0-1.7-.09-2.45-.25-.02.08-.05.16-.05.25 0 .55.45 1 1 1h.58c.22 0 .41.15.48.36.17.52.66 1.02 1.02 1.32.25.21.24.59-.03.78-.34.24-.9.49-1.79.53a.501.501 0 01-.45-.22c-.13-.2-.31-.56-.31-1.01 0-.3.04-.57.09-.8-.9-.19-1.59-1-1.59-1.96 0-.18.03-.36.08-.53-2.46-.86-4.03-2.78-4.46-5.74-.18.17-.38.27-.62.27C3 13 2 12.5 2 10c0-2.27 1.7-4.5 3-4.5.43 0 .49.49.5.85a7.989 7.989 0 015.55-3.29c.2-.96 1.08-1.56 1.95-1.56v1s.33-.5 1-.5c.67 0 1 .5 1 .5-.49 0-.85.35-.96.77 1.82.48 3.39 1.59 4.46 3.08.01-.36.07-.85.5-.85 1.3 0 3 2.23 3 4.5zM5 11c0 .81.1 1.53.25 2.21.18-.69.46-1.33.83-1.92a3.77 3.77 0 01-.34-1.54A3.766 3.766 0 019.5 6c.96 0 1.84.37 2.5.97.66-.6 1.54-.97 2.5-.97 2.07 0 3.75 1.68 3.75 3.75 0 .55-.12 1.07-.34 1.54.37.59.66 1.24.84 1.94.15-.68.25-1.41.25-2.23 0-3.86-3.14-7-7-7s-7 3.14-7 7zm12.98 4.29c0-.1.02-.19.02-.29 0-1.01-.26-1.95-.7-2.78-.69.78-1.68 1.28-2.8 1.28-.27 0-.54-.03-.79-.09.14-.23.23-.49.27-.77.01-.07.01-.13.02-.19.17.03.33.05.5.05 1.52 0 2.75-1.23 2.75-2.75S16.02 7 14.5 7c-.67 0-1.32.25-1.83.72l-.67.6-.67-.6C10.82 7.25 10.17 7 9.5 7 7.98 7 6.75 8.23 6.75 9.75c0 1.34.96 2.46 2.23 2.7l-.76.83c-.6-.22-1.12-.59-1.53-1.05A6.01 6.01 0 006 15c0 .08.01.15.01.24C7.13 17.06 9.14 18 12 18c2.88 0 4.88-.91 5.98-2.71zM16 9.75c0 .97-.67 1.75-1.5 1.75S13 10.72 13 9.75 13.67 8 14.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38zM11 9.75c0 .97-.67 1.75-1.5 1.75S8 10.72 8 9.75 8.67 8 9.5 8s1.5.78 1.5 1.75zm-.75-.87c0-.21-.17-.38-.38-.38s-.37.17-.37.38.17.38.38.38.37-.18.37-.38z"
                }
            }
        ]
    })(props);
}
function MdOutlineFreeCancellation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.21 20H5V10h14v4.38l2-2V6c0-1.1-.9-2-2-2h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 002 2h8.21l-2-2zM5 6h14v2H5V6zm11.54 16.5L13 18.96l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41-5.64 5.66zM10.41 14L12 15.59 10.59 17 9 15.41 7.41 17 6 15.59 7.59 14 6 12.41 7.41 11 9 12.59 10.59 11 12 12.41 10.41 14z"
                }
            }
        ]
    })(props);
}
function MdOutlineGTranslate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
                }
            }
        ]
    })(props);
}
function MdOutlineGavel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h12v2H1v-2zM5.24 8.07l2.83-2.83 14.14 14.14-2.83 2.83L5.24 8.07zM12.32 1l5.66 5.66-2.83 2.83-5.66-5.66L12.32 1zM3.83 9.48l5.66 5.66-2.83 2.83L1 12.31l2.83-2.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineGeneratingTokens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm3-7.5h-2v5H8v-5H6V9h6v1.5zm8.25-6.75L23 5l-2.75 1.25L19 9l-1.25-2.75L15 5l2.75-1.25L19 1l1.25 2.75zm0 14L23 19l-2.75 1.25L19 23l-1.25-2.75L15 19l2.75-1.25L19 15l1.25 2.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineGetApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5v6h1.17L12 13.17 9.83 11H11V5h2m2-2H9v6H5l7 7 7-7h-4V3zm4 15H5v2h14v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGifBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v14zM5 3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5zm6.5 11h1v-4h-1v4zm2 0h1v-1.5H16v-1h-1.5V11h2v-1h-3v4zm-4-2v1h-1v-2h2c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 9H13v6h-1.5V9zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineGrade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.13l.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGrading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h16v2H4V7zm0 6h16v-2H4v2zm0 4h7v-2H4v2zm0 4h7v-2H4v2zm11.41-2.83L14 16.75l-1.41 1.41L15.41 21 20 16.42 18.58 15l-3.17 3.17zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroupWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "8",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "14",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineHelpCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.25 16.74c0 .69-.53 1.26-1.25 1.26-.7 0-1.26-.56-1.26-1.26 0-.71.56-1.25 1.26-1.25.71 0 1.25.55 1.25 1.25zM11.99 6c-1.77 0-2.98 1.15-3.43 2.49l1.64.69c.22-.67.74-1.48 1.8-1.48 1.62 0 1.94 1.52 1.37 2.33-.54.77-1.47 1.29-1.96 2.16-.39.69-.31 1.49-.31 1.98h1.82c0-.93.07-1.12.22-1.41.39-.72 1.11-1.06 1.87-2.17.68-1 .42-2.36-.02-3.08-.51-.84-1.52-1.51-3-1.51zM19 5H5v14h14V5m0-2c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14z"
                }
            }
        ]
    })(props);
}
function MdOutlineHelpOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineHideSource(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06l10.94 10.94C14.86 19.59 13.48 20 12 20zM7.94 5.12L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.869 7.869 0 0020 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineHighlightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5h-2V3h2v2zm-2 10v6l2.29-2.29 2.3 2.29L21 19.59l-2.29-2.29L21 15h-6zm4-6h2V7h-2v2zm0 4h2v-2h-2v2zm-8 8h2v-2h-2v2zM7 5h2V3H7v2zM3 17h2v-2H3v2zm2 4v-2H3c0 1.1.9 2 2 2zM19 3v2h2c0-1.1-.9-2-2-2zm-8 2h2V3h-2v2zM3 9h2V7H3v2zm4 12h2v-2H7v2zm-4-8h2v-2H3v2zm0-8h2V3c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHighlightOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineHistoryToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.1 19.37l1 1.74c-.96.44-2.01.73-3.1.84v-2.02c.74-.09 1.44-.28 2.1-.56zM4.07 13H2.05c.11 1.1.4 2.14.84 3.1l1.74-1c-.28-.66-.47-1.36-.56-2.1zM15.1 4.63l1-1.74c-.96-.44-2-.73-3.1-.84v2.02c.74.09 1.44.28 2.1.56zM19.93 11h2.02c-.11-1.1-.4-2.14-.84-3.1l-1.74 1c.28.66.47 1.36.56 2.1zM8.9 19.37l-1 1.74c.96.44 2.01.73 3.1.84v-2.02c-.74-.09-1.44-.28-2.1-.56zM11 4.07V2.05c-1.1.11-2.14.4-3.1.84l1 1.74c.66-.28 1.36-.47 2.1-.56zm7.36 3.1l1.74-1.01c-.63-.87-1.4-1.64-2.27-2.27l-1.01 1.74c.59.45 1.1.96 1.54 1.54zM4.63 8.9l-1.74-1c-.44.96-.73 2-.84 3.1h2.02c.09-.74.28-1.44.56-2.1zm15.3 4.1c-.09.74-.28 1.44-.56 2.1l1.74 1c.44-.96.73-2.01.84-3.1h-2.02zm-3.1 5.36l1.01 1.74c.87-.63 1.64-1.4 2.27-2.27l-1.74-1.01c-.45.59-.96 1.1-1.54 1.54zM7.17 5.64l-1-1.75c-.88.64-1.64 1.4-2.27 2.28l1.74 1.01a7.7 7.7 0 011.53-1.54zM5.64 16.83l-1.74 1c.63.87 1.4 1.64 2.27 2.27l1.01-1.74a7.7 7.7 0 01-1.54-1.53zM13 7h-2v5.41l4.29 4.29 1.41-1.41-3.7-3.7V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
                }
            }
        ]
    })(props);
}
function MdOutlineHlsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.83 15h1.67c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.17l2 2zM8 10.83V15H6.5v-2.5h-2V15H3V9h1.5v2h2V9.33L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-7.6-7.6H10v-2.17l-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHls(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H8v6H6.5v-2.5h-2V15H3V9h1.5v2h2V9zm10 6h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H17v-1h2v.5h1.5v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1H19v1h-2V13h-1.5v1c0 .55.45 1 1 1zM14 15v-1.5h-2.5V9H10v6h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHorizontalSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15v2H5v-2h14m2-10H3v2h18V5zm0 4H3v2h18V9zm0 4H3v6h18v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineHotelClass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L11 14.79l-2.42 1.84.93-3.01L7.24 12h2.82L11 8.89zM8.58 10H1l6.17 4.41L4.83 22 11 17.31 17.18 22l-2.35-7.59L21 10h-7.58L11 2l-2.42 8zm12.78 12l-1.86-6.01L23.68 13h-3.44l-3.08 2.2 1.46 4.72L21.36 22zM17 8l-1.82-6-1.04 3.45.77 2.55H17z"
                }
            }
        ]
    })(props);
}
function MdOutlineHourglassDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4h8v3.5l-2.84 2.84 1.25 1.25L18 8.01 17.99 8H18V2H6v1.17l2 2zM2.1 2.1L.69 3.51l8.9 8.9L6 16l.01.01H6V22h12v-1.17l2.49 2.49 1.41-1.41L2.1 2.1zM16 20H8v-3.5l2.84-2.84L16 18.83V20z"
                }
            }
        ]
    })(props);
}
function MdOutlineHourglassEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHourglassFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineHtml(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 9H5v6H3.5v-2.5h-2V15H0V9h1.5v2h2V9zm14 0H13c-.55 0-1 .45-1 1v5h1.5v-4.5h1V14H16v-3.51h1V15h1.5v-5c0-.55-.45-1-1-1zM11 9H6v1.5h1.75V15h1.5v-4.5H11V9zm13 6v-1.5h-2.5V9H20v6h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHttp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineHttps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineImportantDevices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12a2 2 0 002 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4a2 2 0 00-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineInput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z",
                            "opacity": ".87"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3zM21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14a2 2 0 00-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineInstallDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17H4V5h8V3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14l5-5-1.41-1.41L18 10.17V3h-2v7.17l-2.59-2.58L12 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineInstallMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 18H7V6h7V4H7V3h7V1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-5h-2v2zm0 3H7v-1h10v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 14l5-5-1.41-1.41L19 10.17V3h-2v7.17l-2.59-2.58L13 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineIntegrationInstructions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "3.5",
                    "r": ".75",
                    "fill": "none"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M5 15v4h14V5H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14.17L8.83 12 11 9.83 9.59 8.41 6 12l3.59 3.59zM14.41 15.59L18 12l-3.59-3.59L13 9.83 15.17 12 13 14.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 15v4H5V5h14v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineInvertColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.81V19c-3.31 0-6-2.63-6-5.87 0-1.56.62-3.03 1.75-4.14L12 4.81M12 2L6.35 7.56C4.9 8.99 4 10.96 4 13.13 4 17.48 7.58 21 12 21s8-3.52 8-7.87c0-2.17-.9-4.14-2.35-5.57L12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineJavascript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14v-1h1.5v.5h2v-1H13c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1H16c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1zM9 9v4.5H7.5v-1H6v1c0 .83.67 1.5 1.5 1.5H9c.83 0 1.5-.67 1.5-1.5V9H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineJoinFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5 0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineJoinInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.04 16.87c-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineJoinLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 12c0-.97.23-4.16 3.03-6.5C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7c.9 0 1.75-.19 2.53-.5-2.8-2.34-3.03-5.53-3.03-6.5zM16 5c-.9 0-1.75.19-2.53.5.61.51 1.1 1.07 1.49 1.63.33-.08.68-.13 1.04-.13 2.76 0 5 2.24 5 5s-2.24 5-5 5c-.36 0-.71-.05-1.04-.13-.39.56-.88 1.12-1.49 1.63.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineJoinRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "ellipse",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "rx": "3",
                    "ry": "5.74"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12c0 .97-.23 4.16-3.03 6.5.78.31 1.63.5 2.53.5 3.86 0 7-3.14 7-7s-3.14-7-7-7c-.9 0-1.75.19-2.53.5 2.8 2.34 3.03 5.53 3.03 6.5zM8 19c.9 0 1.75-.19 2.53-.5-.61-.51-1.1-1.07-1.49-1.63-.33.08-.68.13-1.04.13-2.76 0-5-2.24-5-5s2.24-5 5-5c.36 0 .71.05 1.04.13.39-.56.88-1.12 1.49-1.63C9.75 5.19 8.9 5 8 5c-3.86 0-7 3.14-7 7s3.14 7 7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLabelImportant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18.99h11c.67 0 1.27-.32 1.63-.83L21 12l-4.37-6.16C16.27 5.33 15.67 5 15 5H4l5 7-5 6.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineLabelOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7l3.55 5-1.63 2.29 1.43 1.43L22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5l-7.37.01 2 1.99H16zM2 4.03l1.58 1.58C3.22 5.96 3 6.46 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.28 0 .55-.07.79-.18L18.97 21l1.41-1.41L3.41 2.62 2 4.03zM14.97 17H5V7.03L14.97 17z"
                }
            }
        ]
    })(props);
}
function MdOutlineLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
                }
            }
        ]
    })(props);
}
function MdOutlineLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.65 15.65 0 008.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
                }
            }
        ]
    })(props);
}
function MdOutlineLaunch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLeaderboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11V3H8v6H2v12h20V11h-6zm-6-6h4v14h-4V5zm-6 6h4v8H4v-8zm16 8h-4v-6h4v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineLightbulbCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c.83 0 1.5-.67 1.5-1.5h-3c0 .83.67 1.5 1.5 1.5zM9 15h6v1.5H9zM12 5c-2.76 0-5 2.24-5 5 0 1.64.8 3.09 2.03 4h5.95A4.985 4.985 0 0017 10c0-2.76-2.24-5-5-5zm2.43 7.5H9.57A3.473 3.473 0 018.5 10c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.39 1.84-1.07 2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6A4.997 4.997 0 017 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLineStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLineWeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z",
                            "opacity": ".87"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7zm-4 6h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLockClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20V10h12v1c.7 0 1.37.1 2 .29V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26c-.42-.6-.75-1.28-.97-2H6zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLockPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20V10h12v1c.7 0 1.37.1 2 .29V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h6.26c-.42-.6-.75-1.28-.97-2H6zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 2c.83 0 1.5.67 1.5 1.5S18.83 18 18 18s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm0 6c-1.03 0-1.94-.52-2.48-1.32.73-.42 1.57-.68 2.48-.68s1.75.26 2.48.68c-.54.8-1.45 1.32-2.48 1.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineLockReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9c0 .06.01.12.01.19l-1.84-1.84-1.41 1.41L5 16l4.24-4.24-1.41-1.41-1.82 1.82c0-.06-.01-.11-.01-.17 0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7c-1.9 0-3.62-.76-4.88-1.99L6.7 18.42A8.982 8.982 0 0013 21a9 9 0 000-18zm2 8v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z",
                            "opacity": ".87"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLogin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7L9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5zm9 12h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8v2h8v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineLogout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 8l-1.41 1.41L17.17 11H9v2h8.17l-1.58 1.58L17 16l4-4-4-4zM5 5h7V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h7v-2H5V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLoyalty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 12.55c0 .57.23 1.07.6 1.45l3.5 3.5 3.5-3.5a2.053 2.053 0 00-2.9-2.9l-.6.6-.6-.59c-.37-.38-.89-.61-1.45-.61-1.13 0-2.05.92-2.05 2.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineManageAccounts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18v-.65c0-.34.16-.66.41-.81C6.1 15.53 8.03 15 10 15c.03 0 .05 0 .08.01.1-.7.3-1.37.59-1.98-.22-.02-.44-.03-.67-.03-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.42-.6-.75-1.28-.97-2H4zM10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineManageHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.69 18.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L20 14h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L18 24h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM11 7v5.41l2.36 2.36 1.04-1.79-1.4-1.39V7h-2zm10 5a9 9 0 00-9-9C9.17 3 6.65 4.32 5 6.36V4H3v6h6V8H6.26A7.01 7.01 0 0112 5c3.86 0 7 3.14 7 7h2zm-10.14 6.91c-2.99-.49-5.35-2.9-5.78-5.91H3.06c.5 4.5 4.31 8 8.94 8h.07l-1.21-2.09z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkAsUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.23 7h2.6c-.06-.47-.36-.94-.79-1.17L10.5 2 2.8 5.83c-.48.26-.8.81-.8 1.34V15c0 1.1.9 2 2 2V7.4L10.5 4l5.73 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8H7c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2zm0 11H7v-7l6.5 3.33L20 12v7zm-6.5-5.67L7 10h13l-6.5 3.33z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkunreadMailbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H10v2h10v12H4V8h2v4h2V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h18v2H3V3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMediation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16l4-4-4-4v3h-5.06A8.974 8.974 0 008 3.95 3.005 3.005 0 005 1C3.34 1 2 2.34 2 4s1.34 3 3 3c.95 0 1.78-.45 2.33-1.14C9.23 6.9 10.6 8.77 10.92 11h-3.1C7.4 9.84 6.3 9 5 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2h3.1c-.32 2.23-1.69 4.1-3.58 5.14C6.78 17.45 5.95 17 5 17c-1.66 0-3 1.34-3 3s1.34 3 3 3a2.99 2.99 0 002.99-2.95A8.974 8.974 0 0012.93 13H18v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h12v2H6v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineModelTraining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 13.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5 0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5zm-2.5 6h-2V21h2v-1.5zm6-6.5c0 1.68-.59 3.21-1.58 4.42l1.42 1.42a8.978 8.978 0 00-1-12.68l-1.42 1.42A6.993 6.993 0 0119 13zm-3-8l-4-4v3a9 9 0 00-9 9c0 2.23.82 4.27 2.16 5.84l1.42-1.42A6.938 6.938 0 015 13c0-3.86 3.14-7 7-7v3l4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkPing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14.67L3.41 6.09 2 7.5l8.5 8.5H4v2h16v-2h-6.5l5.15-5.15A2.5 2.5 0 1019.5 6 2.5 2.5 0 0017 8.5c0 .35.07.67.2.97l-5.2 5.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNewLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12l-4.37 6.16c-.37.52-.98.84-1.63.84h-3v-2h3l3.55-5L15 7H5v3H3V7c0-1.1.9-2 2-2h10c.65 0 1.26.31 1.63.84L21 12zm-11 3H7v-3H5v3H2v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNextPlan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.97 11.03C14.87 9.79 13.28 9 11.5 9c-2.82 0-5.18 1.95-5.82 4.56l.96.32C7.15 11.66 9.13 10 11.5 10c1.51 0 2.85.68 3.76 1.74L13 14h5V9l-2.03 2.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineNightlightRound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 22c1.05 0 2.05-.16 3-.46-4.06-1.27-7-5.06-7-9.54s2.94-8.27 7-9.54c-.95-.3-1.95-.46-3-.46-5.52 0-10 4.48-10 10s4.48 10 10 10z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoAccounts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.18 10.94c.2-.44.32-.92.32-1.44C15.5 7.57 13.93 6 12 6c-.52 0-1 .12-1.44.32l4.62 4.62z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.85.63-3.55 1.69-4.9l2.86 2.86a3.47 3.47 0 002.99 2.99l2.2 2.2c-.57-.1-1.15-.15-1.74-.15-2.32 0-4.45.8-6.14 2.12A7.957 7.957 0 014 12zm8 8c-1.74 0-3.34-.56-4.65-1.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.54-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoiseAware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 15h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.6 6.58l1.58 1.26c.35-.57.77-1.1 1.24-1.57L4.85 5.02c-.47.47-.88 1-1.25 1.56zM9.46 4.42l-.87-1.81c-.63.23-1.24.52-1.8.87l.87 1.81c.56-.36 1.16-.65 1.8-.87zM4.49 9.26l-1.96-.45c-.21.63-.36 1.28-.44 1.95l1.96.45a7.9 7.9 0 01.44-1.95zM20.4 6.58a9.4 9.4 0 00-1.25-1.56l-1.58 1.26c.48.47.89.99 1.24 1.57l1.59-1.27zM4.04 12.79l-1.96.45c.08.67.23 1.33.44 1.95l1.97-.45c-.22-.62-.38-1.27-.45-1.95zM17.21 3.48c-.57-.35-1.17-.64-1.8-.87l-.87 1.81c.64.22 1.24.51 1.8.87l.87-1.81zM13 4.07V2.05c-.33-.03-.66-.05-1-.05s-.67.02-1 .05v2.02c.33-.04.66-.07 1-.07s.67.03 1 .07zM11 19.93v2.02c.33.03.66.05 1 .05s.67-.02 1-.05v-2.02c-.33.04-.66.07-1 .07s-.67-.03-1-.07zM19.51 14.74l1.97.45c.21-.63.36-1.28.44-1.95l-1.96-.45c-.07.68-.23 1.33-.45 1.95zM19.96 11.21l1.96-.45a9.69 9.69 0 00-.44-1.95l-1.97.45c.22.62.38 1.27.45 1.95zM17.58 17.73l1.58 1.26c.47-.48.88-1 1.25-1.56l-1.58-1.26a9.4 9.4 0 01-1.25 1.56zM6.79 20.52c.57.35 1.17.64 1.8.87l.87-1.81c-.64-.22-1.24-.51-1.8-.87l-.87 1.81zM14.54 19.58l.87 1.81c.63-.23 1.24-.52 1.8-.87l-.87-1.81c-.56.36-1.16.65-1.8.87zM3.6 17.42a9.4 9.4 0 001.25 1.56l1.58-1.26a7.87 7.87 0 01-1.24-1.57L3.6 17.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoiseControlOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.44 0 2.79.38 3.95 1.05L17.4 3.6C15.85 2.59 13.99 2 12 2s-3.85.59-5.41 1.59l1.45 1.45A8.034 8.034 0 0112 4zM20 12c0 1.44-.38 2.79-1.05 3.95l1.45 1.45c1.01-1.55 1.6-3.41 1.6-5.4s-.59-3.85-1.59-5.41l-1.45 1.45A8.034 8.034 0 0120 12zM12 20c-1.44 0-2.79-.38-3.95-1.05L6.6 20.4C8.15 21.41 10.01 22 12 22s3.85-.59 5.41-1.59l-1.45-1.45A8.034 8.034 0 0112 20zM4 12c0-1.44.38-2.79 1.05-3.95L3.59 6.59C2.59 8.15 2 10.01 2 12s.59 3.85 1.59 5.41l1.45-1.45A8.034 8.034 0 014 12zM11.5 6C9.02 6 7 8.02 7 10.5c0 1.22.49 2.41 1.35 3.27l1.36 1.36c.17.17.31.44.44.82A3.013 3.013 0 0013 18c1.65 0 3-1.35 3-3h-2a1.003 1.003 0 01-1.95.32c-.15-.44-.4-1.08-.93-1.61l-1.36-1.36C9.28 11.87 9 11.19 9 10.5a2.5 2.5 0 014.95-.5h2.02c-.25-2.25-2.16-4-4.47-4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "12.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineNotAccessible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm9 9v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.24-.24-.44-.36-.63-.46-.36-.19-.72-.3-1.2-.26-.49.04-.91.27-1.23.61L14 11.05c1.29 1.07 3.25 1.94 5 1.95zm-9 7c-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1a5 5 0 105.9 5.9h-2.07c-.41 1.16-1.52 2-2.83 2zM2.81 2.81L1.39 4.22 10 12.83V15c0 1.1.9 2 2 2h2.17l5.61 5.61 1.41-1.41L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotStarted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 6H9v8h2V8zm6 4l-5-4v8l5-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoteAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11h-2v3H8v2h3v3h2v-3h3v-2h-3zm1-9H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineOfflineBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2.02c-5.51 0-9.98 4.47-9.98 9.98s4.47 9.98 9.98 9.98 9.98-4.47 9.98-9.98S17.51 2.02 12 2.02zm0 17.96c-4.4 0-7.98-3.58-7.98-7.98S7.6 4.02 12 4.02 19.98 7.6 19.98 12 16.4 19.98 12 19.98zM12.75 5l-4.5 8.5h3.14V19l4.36-8.5h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineOfflinePin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-5h10v2H7zm3.3-3.8L8.4 9.3 7 10.7l3.3 3.3L17 7.3l-1.4-1.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineOnDeviceTraining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16h2v1h-2zM12 11c-1.1 0-2 .9-2 2 0 .74.4 1.38 1 1.72v.78h2v-.78c.6-.35 1-.98 1-1.72 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L6 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM18 21H6v-1h12v1zm0-3H6V6h12v12zm0-14H6V3h12v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.01 15.95c.62-.83.99-1.84.99-2.95s-.37-2.12-.99-2.95l-1.07 1.07c.35.54.56 1.19.56 1.88s-.21 1.34-.56 1.88l1.07 1.07zM9.06 14.88c-.35-.54-.56-1.19-.56-1.88 0-1.93 1.57-3.5 3.5-3.5v1.25l2.25-2-2.25-2V8c-2.76 0-5 2.24-5 5 0 1.11.37 2.12.99 2.95l1.07-1.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineOnlinePrediction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.5c0 2-2.5 3.5-2.5 5h-2c0-1.5-2.5-3-2.5-5C8.5 9.57 10.07 8 12 8s3.5 1.57 3.5 3.5zm-2.5 6h-2V19h2v-1.5zm9-5.5c0-2.76-1.12-5.26-2.93-7.07l-1.06 1.06A8.481 8.481 0 0120.5 12c0 2.34-.95 4.47-2.49 6.01l1.06 1.06A9.969 9.969 0 0022 12zM3.5 12c0-2.34.95-4.47 2.49-6.01L4.93 4.93A9.969 9.969 0 002 12c0 2.76 1.12 5.26 2.93 7.07l1.06-1.06A8.481 8.481 0 013.5 12zm14 0c0 1.52-.62 2.89-1.61 3.89l1.06 1.06A6.976 6.976 0 0019 12c0-1.93-.78-3.68-2.05-4.95l-1.06 1.06c.99 1 1.61 2.37 1.61 3.89zM7.05 16.95l1.06-1.06c-1-1-1.61-2.37-1.61-3.89s.62-2.89 1.61-3.89L7.05 7.05A6.976 6.976 0 005 12c0 1.93.78 3.68 2.05 4.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineOpacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0H0v24h24V0zm0 0H0v24h24V0zM0 24h24V0H0v24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67S19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineOpenInBrowser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineOpenInFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
                }
            }
        ]
    })(props);
}
function MdOutlineOpenInNewOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.79 5.8L14 3h7v7l-2.79-2.8-4.09 4.09-1.41-1.41 4.08-4.08zM19 12v4.17l2 2V12h-2zm.78 10.61L18.17 21H5a2 2 0 01-2-2V5.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM16.17 19l-4.88-4.88-1.59 1.59-1.41-1.41 1.59-1.59L5 7.83V19h11.17zM7.83 5H12V3H5.83l2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineOpenInNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineOpenWith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutbond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutbound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.88 9.54L8.92 16.5l-1.41-1.41 4.96-4.96L10.34 8l5.65.01.01 5.65-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9.83V14h2V9.83l1.59 1.58L16 10l-4-4-4 4 1.41 1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.02c.91 1.21 2.35 2 3.98 2s3.06-.79 3.98-2H19v3zm0-5h-4.18c-.41 1.16-1.51 2-2.82 2s-2.4-.84-2.82-2H5V5h14v9z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutlet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 9V8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1zm6 0V8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1zm-2 5c0-1.1-.9-2-2-2s-2 .9-2 2v2h4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 17l5-5-5-5-1.41 1.41L18.17 11H9v2h9.17l-2.58 2.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h14v2h2V5a2 2 0 00-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePageview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.49 16c.88 0 1.7-.26 2.39-.7l2.44 2.44 1.42-1.42-2.44-2.43c.44-.7.7-1.51.7-2.39C16 9.01 13.99 7 11.5 7S7 9.01 7 11.5 9.01 16 11.49 16zm.01-7a2.5 2.5 0 010 5 2.5 2.5 0 010-5zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlinePaid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.89-8.9c-1.78-.59-2.64-.96-2.64-1.9 0-1.02 1.11-1.39 1.81-1.39 1.31 0 1.79.99 1.9 1.34l1.58-.67c-.15-.44-.82-1.91-2.66-2.23V5h-1.75v1.26c-2.6.56-2.62 2.85-2.62 2.96 0 2.27 2.25 2.91 3.35 3.31 1.58.56 2.28 1.07 2.28 2.03 0 1.13-1.05 1.61-1.98 1.61-1.82 0-2.34-1.87-2.4-2.09l-1.66.67c.63 2.19 2.28 2.78 3.02 2.96V19h1.75v-1.24c.52-.09 3.02-.59 3.02-3.22.01-1.39-.6-2.61-3-3.44z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanToolAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 11.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V5.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 15.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM17.08 19h-6.55l-3.7-3.78 4.17.89V5.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 13.56 17.08 19z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 24h-6.55c-1.08 0-2.14-.45-2.89-1.23l-7.3-7.61 2.07-1.83c.62-.55 1.53-.66 2.26-.27L8 14.34V4.79a2.5 2.5 0 013.01-2.45C11.1 1.04 12.18.01 13.5.01c.86 0 1.61.43 2.06 1.09.29-.12.61-.18.94-.18a2.5 2.5 0 012.5 2.5v.28a2.5 2.5 0 013 2.45V20c0 2.21-1.79 4-4 4zM4.14 15.28l5.86 6.1c.38.39.9.62 1.44.62H18c1.1 0 2-.9 2-2V6.15c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V3.42c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V2.51c0-.28-.22-.5-.5-.5s-.5.22-.5.5V12h-2V4.79c0-.28-.22-.5-.5-.5s-.5.23-.5.5v12.87l-5.35-2.83-.51.45z"
                }
            }
        ]
    })(props);
}
function MdOutlinePayment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePendingActions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71zM18 3h-3.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H6c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h6.11a6.743 6.743 0 01-1.42-2H6V5h2v3h8V5h2v5.08c.71.1 1.38.31 2 .6V5c0-1.1-.9-2-2-2zm-6 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlinePercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 4C5.57 4 4 5.57 4 7.5S5.57 11 7.5 11 11 9.43 11 7.5 9.43 4 7.5 4zm0 5C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm9 4c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5.41 20L4 18.59 18.59 4 20 5.41 5.41 20z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermCameraMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2s2-.9 2-2V8c0-1.1-.9-2-2-2zm8-1h-3.17l-1.86-2H8.96L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-7v-1.09c2.83-.48 5-2.94 5-5.91h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6c0 2.97 2.17 5.43 5 5.91V19H4V7h4.21l.59-.65L10.04 5h4.24l1.24 1.35.59.65H20v12z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermContactCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.84 4.22c-.05-.12-.11-.23-.18-.34-.14-.21-.33-.4-.54-.54-.11-.07-.22-.13-.34-.18-.24-.1-.5-.16-.78-.16h-1V1h-2v2H8V1H6v2H5c-.42 0-.8.13-1.12.34-.21.14-.4.33-.54.54-.07.11-.13.22-.18.34-.1.24-.16.5-.16.78v14a2 2 0 002 2h14c.28 0 .54-.06.78-.16.12-.05.23-.11.34-.18.21-.14.4-.33.54-.54.21-.32.34-.71.34-1.12V5c0-.28-.06-.54-.16-.78zM5 19V5h14v14H5zm7-6.12c-2.03 0-6 1.08-6 3.58V18h12v-1.53c0-2.51-3.97-3.59-6-3.59zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31zM12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermDataSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.99 11.57H20V0L0 20h11.56v-2H4.83L17.99 4.83v6.74zm5.78 8.75l-1.07-.83c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83a.26.26 0 00.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83a3.908 3.908 0 000 .98l-1.06.83a.26.26 0 00-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73a.26.26 0 00-.06-.32zm-4.78.18c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermDeviceInformation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v2h-2zm0 4h2v6h-2zm6-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermIdentity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 9c2.7 0 5.8 1.29 6 2v1H6v-.99c.2-.72 3.3-2.01 6-2.01m0-11C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermMedia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm5 9h14l-3.5-4.5-2.5 3.01L11.5 9zM22 4h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 12H6V4h5.17l1.41 1.41.59.59H22v10z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermPhoneMsg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM12 3v10l3-3h6V3h-9zm7 5h-5V5h5v3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePermScanWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zM2.92 7.65C5.8 5.85 8.74 5 12 5c3.25 0 6.18.85 9.08 2.67L12 18.83 2.92 7.65zM11 10h2v6h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "5.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "9.5",
                    "r": "2.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9h1.5v6H13v-2.5h-2V15H9.5V9H11v2h2V9zm-5 1.5v1c0 .8-.7 1.5-1.5 1.5h-2v2H3V9h3.5c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1zm15 0v1c0 .8-.7 1.5-1.5 1.5h-2v2h-1.5V9H20c.8 0 1.5.7 1.5 1.5zm-1.5 0h-2v1h2v-1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePictureInPictureAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-8v6h8v-6zm-2 4h-4v-2h4v2zm4-12H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V4.98C23 3.88 22.1 3 21 3zm0 16.02H3V4.97h18v14.05z"
                }
            }
        ]
    })(props);
}
function MdOutlinePictureInPicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-8v6h8V7zm-2 4h-4V9h4v2zm4-8H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
                }
            }
        ]
    })(props);
}
function MdOutlinePinEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12V6H4v12h10v2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v6h-2zm-1 2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-4.34-6H9v5.66h2v-2.24l2.95 2.95 1.41-1.41L12.41 10h2.24V8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePinInvoke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10v2H4v12h16v-6h2zm0-5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zM9.34 12h2.24l-2.95 2.95 1.41 1.41L13 13.42v2.24h2V10H9.34v2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePinch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2.5V1h5v5H9.5V3.56L3.56 9.5H6V11H1V6h1.5v2.44L8.44 2.5H6zm15.89 11.27l-3.8-1.67c-.13-.06-.28-.1-.44-.1H17V7.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L7 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM20.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L21 15.56 20.08 21z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlagiarism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03 11.03a3.495 3.495 0 000 4.95 3.48 3.48 0 004.13.59l1.88 1.88 1.41-1.41-1.88-1.88c.71-1.33.53-3.01-.59-4.13a3.495 3.495 0 00-4.95 0zm3.53 3.53c-.59.59-1.54.59-2.12 0a1.49 1.49 0 010-2.12 1.49 1.49 0 012.12 0c.59.59.59 1.53 0 2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayForWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePolymer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8L19 4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePowerSettingsNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42A6.92 6.92 0 0119 12c0 3.87-3.13 7-7 7A6.995 6.995 0 017.58 6.58L6.17 5.17A8.932 8.932 0 003 12a9 9 0 0018 0c0-2.74-1.23-5.18-3.17-6.83z"
                }
            }
        ]
    })(props);
}
function MdOutlinePregnantWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9a3.285 3.285 0 00-2-3c0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePreview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-7-8.5c1.84 0 3.48.96 4.34 2.5-.86 1.54-2.5 2.5-4.34 2.5s-3.48-.96-4.34-2.5c.86-1.54 2.5-2.5 4.34-2.5M12 9c-2.73 0-5.06 1.66-6 4 .94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4zm0 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 12v2H8v-4h8v2zm2-2v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.5",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlinePrivacyTip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePrivateConnectivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zm-6.93 6c.49 3.39 3.4 6 6.93 6s6.44-2.61 6.93-6H22v-2h-3.07c-.49-3.39-3.4-6-6.93-6s-6.44 2.61-6.93 6H2v2h3.07zM14 10.5v-.89c0-1-.68-1.92-1.66-2.08A2 2 0 0010 9.5v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-2 3.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75.75.34.75.75-.34.75-.75.75zm1-3.25h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineProductionQuantityLimits(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2V8h2v2zm0-4h-2V1h2v5zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePublishedWithChanges(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 19.5H21v2h-6v-6h2v2.73c1.83-1.47 3-3.71 3-6.23 0-4.07-3.06-7.44-7-7.93V2.05c5.05.5 9 4.76 9 9.95 0 2.99-1.32 5.67-3.4 7.5zM4 12c0-2.52 1.17-4.77 3-6.23V8.5h2v-6H3v2h2.4A9.966 9.966 0 002 12c0 5.19 3.95 9.45 9 9.95v-2.02c-3.94-.49-7-3.86-7-7.93zm12.24-3.89l-5.66 5.66-2.83-2.83-1.41 1.41 4.24 4.24 7.07-7.07-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineQueryBuilder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineQuestionAnswer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineQuestionMark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.07 12.85c.77-1.39 2.25-2.21 3.11-3.44.91-1.29.4-3.7-2.18-3.7-1.69 0-2.52 1.28-2.87 2.34L6.54 6.96C7.25 4.83 9.18 3 11.99 3c2.35 0 3.96 1.07 4.78 2.41.7 1.15 1.11 3.3.03 4.9-1.2 1.77-2.35 2.31-2.97 3.45-.25.46-.35.76-.35 2.24h-2.89c-.01-.78-.13-2.05.48-3.15zM14 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineQuickreply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 17.17V4h16v6h2V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9v-2H5.17L4 17.17z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16h-2.2l1.7-4h-5v6h2v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineRecordVoiceOver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zM15.08 7.05c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27l-1.68 1.69zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
                }
            }
        ]
    })(props);
}
function MdOutlineRedeem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 00-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.84 1.98L3.43 3.39l10.38 10.38-1.41 1.41-4.24-4.24-1.41 1.41 5.66 5.66 2.83-2.83 6.6 6.6 1.41-1.41L4.84 1.98zm13.21 10.38L23 7.4 21.57 6l-4.94 4.94 1.42 1.42zm-.71-4.96l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM1.08 12.35l5.66 5.66 1.41-1.41-5.66-5.66-1.41 1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.13L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38A1.997 1.997 0 0017 22c.67 0 1.26-.33 1.62-.84L21.46 24l1.41-1.41L1.41 1.13zM7 15l1.1-2h2.36l2 2H7zM20 4H7.12l2 2h9.19l-2.76 5h-1.44l1.94 1.94c.54-.14.99-.49 1.25-.97l3.58-6.49C21.25 4.82 20.76 4 20 4zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineReorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineRepartition(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-6H3v6zm7.33-2v-2h3.33v2h-3.33zM19 19h-3.33v-2H19v2zM5 17h3.33v2H5v-2zM6 10l1.42-1.42L5.83 7H17c1.1 0 2 .9 2 2s-.9 2-2 2H3v2h14c2.21 0 4-1.79 4-4s-1.79-4-4-4H5.83l1.59-1.59L6 2 2 6l4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineReportProblem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRequestPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.17 4L18 8.83V20H6V4h7.17M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm1 9h-4v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1v1h-2v-1H9v-2h4v-1h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1V8h2v1h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRestoreFromTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2-5V9h8v10H8v-5zm2 4h4v-4h2l-4-4-4 4h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRestorePage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7.17L18 8.83V20zm-9.55-9.43L7.28 9.4V13h3.6l-1.44-1.44a3.15 3.15 0 012.79-1.71 3.15 3.15 0 110 6.3 3.14 3.14 0 01-2.58-1.35H8.1a4.51 4.51 0 004.12 2.7c2.48 0 4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5c-1.59 0-2.97.83-3.77 2.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3a9 9 0 00-9 9H1l4 3.99L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"
                }
            }
        ]
    })(props);
}
function MdOutlineRocketLaunch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15c-.83 0-1.58.34-2.12.88C2.7 17.06 2 22 2 22s4.94-.7 6.12-1.88A2.996 2.996 0 006 15zm.71 3.71c-.28.28-2.17.76-2.17.76s.47-1.88.76-2.17c.17-.19.42-.3.7-.3a1.003 1.003 0 01.71 1.71zm10.71-5.06c6.36-6.36 4.24-11.31 4.24-11.31S16.71.22 10.35 6.58l-2.49-.5a2.03 2.03 0 00-1.81.55L2 10.69l5 2.14L11.17 17l2.14 5 4.05-4.05c.47-.47.68-1.15.55-1.81l-.49-2.49zM7.41 10.83l-1.91-.82 1.97-1.97 1.44.29c-.57.83-1.08 1.7-1.5 2.5zm6.58 7.67l-.82-1.91c.8-.42 1.67-.93 2.49-1.5l.29 1.44-1.96 1.97zM16 12.24c-1.32 1.32-3.38 2.4-4.04 2.73l-2.93-2.93c.32-.65 1.4-2.71 2.73-4.04 4.68-4.68 8.23-3.99 8.23-3.99s.69 3.55-3.99 8.23zM15 11c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-6.02 7.25c-.29-.9-.57-1.94-.76-3L6 16.07v2.98l1.98-.8zM12 2s5 2 5 11l2.11 1.41c.56.37.89 1 .89 1.66V22l-5-2H9l-5 2v-5.93c0-.67.33-1.29.89-1.66L7 13c0-9 5-11 5-11zm0 2.36S9 6.38 9 13c0 2.25 1 5 1 5h4s1-2.75 1-5c0-6.62-3-8.64-3-8.64zm6 14.69v-2.98l-1.22-.81c-.19 1.05-.47 2.1-.76 3l1.98.79z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function MdOutlineRoundedCorner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
                }
            }
        ]
    })(props);
}
function MdOutlineRowing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineRule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.54 11L13 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L16.54 11zM11 7H2v2h9V7zm10 6.41L19.59 12 17 14.59 14.41 12 13 13.41 15.59 16 13 18.59 14.41 20 17 17.41 19.59 20 21 18.59 18.41 16 21 13.41zM11 15H2v2h9v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSatelliteAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h2a9 9 0 01-9 9v-2c3.87 0 7-3.13 7-7zm-7 3v2c2.76 0 5-2.24 5-5h-2c0 1.66-1.34 3-3 3zM18.26.59l3.54 3.54c.78.78.78 2.05 0 2.83l-3.18 3.18c-.78.78-2.05.78-2.83 0L14.55 8.9l-.71.7 1.24 1.24c.78.78.78 2.05 0 2.83l-1.41 1.41c-.78.78-2.05.78-2.83 0L9.6 13.84l-.71.71 1.24 1.24c.78.78.78 2.05 0 2.83L6.95 21.8c-.78.78-2.05.78-2.83 0L.58 18.26c-.78-.78-.78-2.05 0-2.83l3.18-3.18c.78-.78 2.05-.78 2.83 0l1.24 1.24.71-.71-1.24-1.23c-.78-.78-.78-2.05 0-2.83L8.72 7.3c.78-.78 2.05-.78 2.83 0l1.24 1.24.71-.71-1.25-1.23c-.78-.78-.78-2.05 0-2.83L15.43.59c.79-.79 2.05-.79 2.83 0zm-15.2 15.2L2 16.85l3.54 3.54 1.06-1.06-3.54-3.54zm2.12-2.12l-1.06 1.06 3.54 3.54 1.06-1.06-3.54-3.54zm4.95-4.95l-1.41 1.41 3.54 3.54 1.41-1.41-3.54-3.54zm4.6-4.6l-1.06 1.06 3.54 3.54 1.06-1.06-3.54-3.54zM16.85 2l-1.06 1.06 3.54 3.54 1.06-1.06L16.85 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSavedSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.73 13.31A6.388 6.388 0 0016 9.5 6.5 6.5 0 109.5 16c1.43 0 2.74-.48 3.81-1.27L19.59 21 21 19.59l-6.27-6.28zM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.29 8.44L9.5 6l-.79 2.44H6.25l2.01 1.59-.77 2.47 2.01-1.53 2.01 1.53-.77-2.47 2.01-1.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineSavings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 10c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zM8 9h5V7H8v2zm14-1.5v6.97l-2.82.94L17.5 21H12v-2h-2v2H4.5S2 12.54 2 9.5 4.46 4 7.5 4h5c.91-1.21 2.36-2 4-2a1.498 1.498 0 011.38 2.08c-.14.34-.26.73-.32 1.15l2.27 2.27H22zm-2 2h-1L15.5 6c0-.65.09-1.29.26-1.91-.97.25-1.76.97-2.09 1.91H7.5C5.57 6 4 7.57 4 9.5c0 1.88 1.22 6.65 2.01 9.5H8v-2h6v2h2.01l1.55-5.15 2.44-.82V9.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineScheduleSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L16.5 17.2V14h1v2.79l1.85 1.85-.7.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12l-6-1.5V7.01l8.87 3.74c.94-.47 2-.75 3.13-.75.1 0 .19.01.28.01L3 4v16l7-2.95V17c0-.8.14-1.56.39-2.28L5 16.99V13.5l6-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineSearchOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 009.5 3C6.08 3 3.28 5.64 3.03 9h2.02C5.3 6.75 7.18 5 9.5 5 11.99 5 14 7.01 14 9.5S11.99 14 9.5 14c-.17 0-.33-.03-.5-.05v2.02c.17.02.33.03.5.03 1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.47 10.82L4 13.29l-2.47-2.47-.71.71L3.29 14 .82 16.47l.71.71L4 14.71l2.47 2.47.71-.71L4.71 14l2.47-2.47z"
                }
            }
        ]
    })(props);
}
function MdOutlineSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                }
            }
        ]
    })(props);
}
function MdOutlineSegment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 18h12v-2H9v2zM3 6v2h18V6H3zm6 7h12v-2H9v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSendAndArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12l-6-1.5V7.01l8.87 3.73c.94-.47 2-.75 3.13-.75.1 0 .19.01.28.01L3 4v16l7-2.95V17c0-.8.14-1.56.39-2.28L5 16.99V13.5l6-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8l-3-3 .71-.71 1.79 1.79V14h1v4.09l1.79-1.79.71.7-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSensorsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.14 10.96c-.09.33-.14.68-.14 1.04 0 1.1.45 2.1 1.17 2.83l-1.42 1.42A6.018 6.018 0 016 12c0-.93.21-1.8.58-2.59L5.11 7.94A7.897 7.897 0 004 12c0 2.21.9 4.21 2.35 5.65l-1.42 1.42A9.969 9.969 0 012 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L8.14 10.96zm9.28 3.63c.37-.79.58-1.66.58-2.59 0-1.66-.67-3.16-1.76-4.24l-1.42 1.42a3.951 3.951 0 011.04 3.86l1.56 1.55zM20 12c0 1.48-.4 2.87-1.11 4.06l1.45 1.45A9.91 9.91 0 0022 12c0-2.76-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineSensors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.76 16.24C6.67 15.16 6 13.66 6 12s.67-3.16 1.76-4.24l1.42 1.42C8.45 9.9 8 10.9 8 12c0 1.1.45 2.1 1.17 2.83l-1.41 1.41zm8.48 0C17.33 15.16 18 13.66 18 12s-.67-3.16-1.76-4.24l-1.42 1.42C15.55 9.9 16 10.9 16 12c0 1.1-.45 2.1-1.17 2.83l1.41 1.41zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm8 2c0 2.21-.9 4.21-2.35 5.65l1.42 1.42C20.88 17.26 22 14.76 22 12s-1.12-5.26-2.93-7.07l-1.42 1.42A7.94 7.94 0 0120 12zM6.35 6.35L4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.42-1.42C4.9 16.21 4 14.21 4 12s.9-4.21 2.35-5.65z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 4c-2.61.7-5.67 1-8.5 1s-5.89-.3-8.5-1L3 6c1.86.5 4 .83 6 1v12h2v-6h2v6h2V7c2-.17 4.14-.5 6-1l-.5-2zM12 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsApplications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.21 13.97l1.2 2.07c.08.13.23.18.37.13l1.49-.6c.31.24.64.44 1.01.59l.22 1.59c.03.14.15.25.3.25h2.4c.15 0 .27-.11.3-.26l.22-1.59c.36-.15.7-.35 1.01-.59l1.49.6c.14.05.29 0 .37-.13l1.2-2.07c.08-.13.04-.29-.07-.39l-1.27-.99c.03-.19.04-.39.04-.58 0-.2-.02-.39-.04-.59l1.27-.99c.11-.09.15-.26.07-.39l-1.2-2.07a.306.306 0 00-.37-.13l-1.49.6c-.31-.24-.64-.44-1.01-.59l-.22-1.59a.31.31 0 00-.3-.25h-2.4a.31.31 0 00-.3.26l-.22 1.59c-.36.15-.71.34-1.01.58l-1.49-.6c-.14-.05-.29 0-.37.13l-1.2 2.07c-.08.13-.04.29.07.39l1.27.99c-.03.2-.05.39-.05.59 0 .2.02.39.04.59l-1.27.99c-.11.1-.14.26-.06.39zM12 10.29c.94 0 1.71.77 1.71 1.71s-.77 1.71-1.71 1.71-1.71-.77-1.71-1.71.77-1.71 1.71-1.71zM19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsBackupRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9a9 9 0 00-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7a6.995 6.995 0 01-11.06 5.7l-1.42 1.44A9 9 0 1012 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsBrightness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 18H8v-1h8v1zm0-3H8V5h8v10zm0-12H8V2h8v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsInputAntenna(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29a2.5 2.5 0 00-5 0c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2a9 9 0 0118 0h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsInputComponent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zM4 17c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4H3zM13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm-1 15c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2zm10-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm-1 11c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsInputComposite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v10c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16V6H5V2zM4 17c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4H3zM13 2c0-.55-.45-1-1-1s-1 .45-1 1v4H9v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2V2zm-1 15c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2zm10-6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v10c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.42 2-1.52 2-2.82V6h-2zm-1 11c-.55 0-1-.45-1-1v-2h2v2c0 .55-.45 1-1 1zm-1-5V8h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsInputHdmi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2.01V5h-1v2H11V5h-1v2H8V4zm9 8.53l-3 6V20h-4v-1.47l-3-6V9h10v3.53z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsInputSvideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsOverscan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v2h-2zm4 0h2v2h-2zm5 6.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.074 15.074 0 01-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM19 9h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45A5.969 5.969 0 0118 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44A7.961 7.961 0 004 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsRemote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-1 12h-4V11h4v10z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.05 6.05l1.41 1.41a5.022 5.022 0 017.08 0l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsVoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 22h2v2H7zm5-9c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .56-.44 1-1 1-.55 0-1-.45-1-1V4zm0 18h2v2h-2zm4 0h2v2h-2zm4-12h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 00-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineShop2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h16v-2H3V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8v7l5.5-3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineShopTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9zm-9-1l5.5-4L12 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zm10 15H4V8h16v11zM9 18l7.5-5L9 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6h-2c0-2.21-1.79-4-4-4S8 3.79 8 6H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6-2c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2zm6 16H6V8h2v2c0 .55.45 1 1 1s1-.45 1-1V8h4v2c0 .55.45 1 1 1s1-.45 1-1V8h2v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineShoppingBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9h-4.79l-4.38-6.56c-.19-.28-.51-.42-.83-.42s-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1zM12 4.8L14.8 9H9.2L12 4.8zM18.5 19l-12.99.01L3.31 11H20.7l-2.2 8zM12 13c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineShoppingCartCheckout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-8.9-5h7.45c.75 0 1.41-.41 1.75-1.03L21 4.96 19.25 4l-3.7 7H8.53L4.27 2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2zM12 2l4 4-4 4-1.41-1.41L12.17 7H8V5h4.17l-1.59-1.59L12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.55 13c.75 0 1.41-.41 1.75-1.03l3.58-6.49A.996.996 0 0020.01 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmartButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9v6c0 1.1-.9 2-2 2h-1v-2h1V9H4v6h6v2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-7.5 10l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14zm-2.5 5l1.09-2.41L18 15.5l-2.41-1.09L14.5 12l-1.09 2.41L11 15.5l2.41 1.09L14.5 19zm2.5-5l.62-1.38L19 12l-1.38-.62L17 10l-.62 1.38L15 12l1.38.62L17 14z"
                }
            }
        ]
    })(props);
}
function MdOutlineSource(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2-6H6v-2h12v2zm-4 4H6v-2h8v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpaceDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19V5h6v14H5zm14 0h-6v-7h6v7zm0-9h-6V5h6v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpatialAudioOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zM20.36 1l-1.41 1.41a7.007 7.007 0 010 9.9l1.41 1.41a8.98 8.98 0 000-12.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.54 10.9a5.003 5.003 0 000-7.07l-1.41 1.41a3 3 0 010 4.24l1.41 1.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpatialAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zM16 1h-2a9 9 0 009 9V8c-3.86 0-7-3.14-7-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1h-2c0 2.76 2.24 5 5 5V4c-1.65 0-3-1.35-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpatialTracking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16.39 15.56C14.71 14.7 12.53 14 10 14s-4.71.7-6.39 1.56A2.97 2.97 0 002 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM16 19H4v-.78c0-.38.2-.72.52-.88C5.71 16.73 7.63 16 10 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zM20.05 2.41L18.64 1c-3.51 3.51-3.51 9.21 0 12.73l1.41-1.41c-2.73-2.74-2.73-7.18 0-9.91z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.88 5.24l-1.41-1.41a5.003 5.003 0 000 7.07l1.41-1.41a3.012 3.012 0 010-4.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpeakerNotesOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12h-1.34l1.91 1.91A2.01 2.01 0 0022 16V4c0-1.1-.9-2-2-2H4.66l2 2H20zM6 12h2v2H6zm12-3h-6.34l2 2H18zm0-3h-8v1.34l.66.66H18zM1.41 1.59L0 3l2.01 2.01L2 22l4-4h9l5.73 5.73 1.41-1.41L1.41 1.59zM5.17 16L4 17.17V7l2 2v2h2l5 5H5.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpeakerNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zM6 12h2v2H6zm0-3h2v2H6zm0-3h2v2H6zm4 6h5v2h-5zm0-3h8v2h-8zm0-3h8v2h-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpellcheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineStarRate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.89l.94 3.11h2.82l-2.27 1.62.93 3.01L12 14.79l-2.42 1.84.93-3.01L8.24 12h2.82L12 8.89M12 2l-2.42 8H2l6.17 4.41L5.83 22 12 17.31 18.18 22l-2.35-7.59L22 10h-7.58L12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm7.48 7.16l-5.01-.43-2-4.71c3.21.19 5.91 2.27 7.01 5.14zm-5.07 6.26L12 13.98l-2.39 1.44.63-2.72-2.11-1.83 2.78-.24L12 8.06l1.09 2.56 2.78.24-2.11 1.83.64 2.73zm-2.86-11.4l-2 4.72-5.02.43c1.1-2.88 3.8-4.97 7.02-5.15zM4 12c0-.64.08-1.26.23-1.86l3.79 3.28-1.11 4.75A7.982 7.982 0 014 12zm3.84 6.82L12 16.31l4.16 2.5A7.924 7.924 0 0111.99 20c-1.52 0-2.94-.44-4.15-1.18zm9.25-.65l-1.11-4.75 3.79-3.28c.14.59.23 1.22.23 1.86 0 2.48-1.14 4.7-2.91 6.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineStickyNote2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v9h-5v5H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2zm-7 11H7v-2h5v2zm5-4H7V8h10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubtitlesOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H6.83l2 2H20v11.17l1.76 1.76c.15-.28.24-.59.24-.93V6c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10h-5.17l2 2H18zM1.04 3.87l1.2 1.2C2.09 5.35 2 5.66 2 6v12c0 1.1.9 2 2 2h13.17l2.96 2.96 1.41-1.41L2.45 2.45 1.04 3.87zM4 6.83L7.17 10H6v2h2v-1.17L11.17 14H6v2h7.17l2 2H4V6.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineSupervisedUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6.5 2c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2.01.89-2 2 0 1.11.89 2 2 2zM11.99 2.01c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zM5.84 17.12c.68-.54 2.27-1.11 3.66-1.11.07 0 .15.01.23.01.24-.64.67-1.29 1.3-1.86A9.05 9.05 0 009.5 14c-1.3 0-3.39.45-4.73 1.43-.5-1.04-.78-2.2-.78-3.43 0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.2-.27 2.34-.75 3.37-1-.59-2.36-.87-3.24-.87-1.52 0-4.5.81-4.5 2.7v2.78a7.935 7.935 0 01-5.66-2.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineSupervisorAccount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm.05 10H4.77c.99-.5 2.7-1 4.23-1 .11 0 .23.01.34.01.34-.73.93-1.33 1.64-1.81-.73-.13-1.42-.2-1.98-.2-2.34 0-7 1.17-7 3.5V19h7v-1.5c0-.17.02-.34.05-.5zm7.45-2.5c-1.84 0-5.5 1.01-5.5 3V19h11v-1.5c0-1.99-3.66-3-5.5-3zm1.21-1.82c.76-.43 1.29-1.24 1.29-2.18a2.5 2.5 0 00-5 0c0 .94.53 1.75 1.29 2.18.36.2.77.32 1.21.32s.85-.12 1.21-.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineSupport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.46 7.12l-2.78 1.15a4.982 4.982 0 00-2.95-2.94l1.15-2.78c2.1.8 3.77 2.47 4.58 4.57zM12 15c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM9.13 4.54l1.17 2.78a5 5 0 00-2.98 2.97L4.54 9.13a7.984 7.984 0 014.59-4.59zM4.54 14.87l2.78-1.15a4.968 4.968 0 002.97 2.96l-1.17 2.78a7.996 7.996 0 01-4.58-4.59zm10.34 4.59l-1.15-2.78a4.978 4.978 0 002.95-2.97l2.78 1.17a8.007 8.007 0 01-4.58 4.58z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwapHoriz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwapHorizontalCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-13.5V9h-4v2h4v2.5l3.5-3.5zm-6 4L5.5 14 9 17.5V15h4v-2H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwapVert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwapVerticalCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM6.5 9L10 5.5 13.5 9H11v4H9V9zm11 6L14 18.5 10.5 15H13v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 13.9a5 5 0 10-2 0v4.27l-1.59-1.59L8 18l4 4 4-4-1.41-1.41L13 18.17V13.9zM15 9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.22 10l-4.15.01a.975.975 0 00-.45.08l-.59.26-1.83-4.1c-.56-1.26-2.04-1.83-3.3-1.27s-1.83 2.04-1.27 3.3l3.3 7.45-1.87.39c-.19.05-.99.27-1.36 1.21L8 19.19l6.78 2.67c.49.19 1.05.18 1.53-.04l5.99-2.65c.89-.4 1.37-1.38 1.13-2.32l-1.36-5.34c-.22-.86-.97-1.47-1.85-1.51zm1.27 7.34L15.5 20l-4.92-1.96 4.18-.88-4.3-9.7c-.11-.25 0-.55.25-.66.25-.11.55 0 .66.25l2.5 5.65 1.61-.71 4.65.01 1.36 5.34zM3.8 12.18c-.2-.86-.3-1.76-.3-2.68 0-2.84.99-5.45 2.63-7.5L7.2 3.07a10.457 10.457 0 00-1.88 8.99l1.62-1.62L8 11.5 4.5 15 1 11.5l1.06-1.06 1.74 1.74z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeLeftAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 13a5 5 0 100-2H5.83l1.59-1.59L6 8l-4 4 4 4 1.41-1.41L5.83 13h4.27zm4.9 2c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V7.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM17.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 15.56 17.08 21zM4.09 5.5H7V7H2V2h1.5v2.02C5.82 2.13 8.78 1 12 1c5.49 0 9.27 3.12 10 6h-1.57c-.76-1.98-3.69-4.5-8.43-4.5-3.03 0-5.79 1.14-7.91 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeRightAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.9 11a5 5 0 100 2h4.27l-1.59 1.59L18 16l4-4-4-4-1.41 1.41L18.17 11H13.9zM9 9c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V7.5a2.5 2.5 0 00-5 0v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM17.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 15.56 17.08 21zM12 2.5C7.26 2.5 4.33 5.02 3.57 7H2c.73-2.88 4.51-6 10-6 3.22 0 6.18 1.13 8.5 3.02V2H22v5h-5V5.5h2.91c-2.12-1.86-4.88-3-7.91-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.59 1.59L16 6l-4-4-4 4 1.41 1.41L11 5.83v4.27a5 5 0 102 0V5.83zM12 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.22 10l-4.15.01a.975.975 0 00-.45.08l-.59.26-1.83-4.1c-.56-1.26-2.04-1.83-3.3-1.27s-1.83 2.04-1.27 3.3l3.3 7.45-1.87.39c-.19.05-.99.27-1.36 1.21L8 19.19l6.78 2.67c.49.19 1.05.18 1.53-.04l5.99-2.65c.89-.4 1.37-1.38 1.13-2.32l-1.36-5.34c-.22-.86-.97-1.47-1.85-1.51zm1.27 7.34L15.5 20l-4.92-1.96 4.18-.88-4.3-9.7c-.11-.25 0-.55.25-.66.25-.11.55 0 .66.25l2.5 5.65 1.61-.71 4.65.01 1.36 5.34zM2.06 5.56L1 4.5 4.5 1 8 4.5 6.94 5.56 5.32 3.94a10.457 10.457 0 001.88 8.99L6.13 14A11.974 11.974 0 013.5 6.5c0-.92.1-1.82.3-2.68L2.06 5.56z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipeVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 2h5v5H4.5V4.09c-1.86 2.11-3 4.88-3 7.91s1.14 5.79 3 7.91V17H6v5H1v-1.5h2.02C1.13 18.18 0 15.22 0 12s1.13-6.18 3.02-8.5H1V2zm19.22 8l-4.15.01a.975.975 0 00-.45.08l-.59.26-1.83-4.1c-.56-1.26-2.04-1.83-3.3-1.27s-1.83 2.04-1.27 3.3l3.3 7.45-1.87.39c-.19.05-.99.27-1.36 1.21L8 19.19l6.78 2.67c.49.19 1.05.18 1.53-.04l5.99-2.65c.89-.4 1.37-1.38 1.13-2.32l-1.36-5.34c-.22-.86-.97-1.47-1.85-1.51zm1.27 7.34L15.5 20l-4.92-1.96 4.18-.88-4.3-9.7c-.11-.25 0-.55.25-.66.25-.11.55 0 .66.25l2.5 5.65 1.61-.71 4.65.01 1.36 5.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwipe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 2v2.02C18.18 2.13 15.22 1 12 1S5.82 2.13 3.5 4.02V2H2v5h5V5.5H4.09c2.11-1.86 4.88-3 7.91-3s5.79 1.14 7.91 3H17V7h5V2h-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.89 13.77l-3.8-1.67c-.13-.06-.28-.1-.44-.1H14V7.63c0-1.32-.96-2.5-2.27-2.62A2.508 2.508 0 009 7.5v8.15l-1.87-.4c-.19-.03-1.02-.15-1.73.56L4 17.22l5.12 5.19c.37.38.88.59 1.41.59h6.55c.98 0 1.81-.7 1.97-1.67l.92-5.44a2 2 0 00-1.08-2.12zM18 15.56L17.08 21h-6.55l-3.7-3.78 4.17.89V7.5c0-.28.22-.5.5-.5s.5.22.5.5v6.18h1.76L18 15.56z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchAccessShortcutAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-3.09 1.38-5.94 3.44-8H12V2h7v7h-2V5.28c-1.8 1.74-3 4.2-3 6.72 0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10zm12 2h-2v-2h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchAccessShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.06 8.94L5 8l2.06-.94L8 5l.94 2.06L11 8l-2.06.94L8 11l-.94-2.06zM8 21l.94-2.06L11 18l-2.06-.94L8 15l-.94 2.06L5 18l2.06.94L8 21zm-3.63-8.63L3 13l1.37.63L5 15l.63-1.37L7 13l-1.37-.63L5 11l-.63 1.37zM12 12c0-3.09 1.38-5.94 3.44-8H12V2h7v7h-2V5.28c-1.8 1.74-3 4.2-3 6.72 0 3.32 2.1 6.36 5 7.82V22c-4.09-1.59-7-5.65-7-10z"
                }
            }
        ]
    })(props);
}
function MdOutlineSyncAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 13.41L6 12l-4 4 4 4 1.41-1.41L5.83 17H21v-2H5.83zM16.59 10.59L18 12l4-4-4-4-1.41 1.41L18.17 7H3v2h15.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineSystemUpdateAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 13l4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTabUnselected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineTableView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H9c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 2v2H9V9h10zm-6 6v-2h2v2h-2zm2 2v2h-2v-2h2zm-4-2H9v-2h2v2zm6-2h2v2h-2v-2zm-8 4h2v2H9v-2zm8 2v-2h2v2h-2zM6 17H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v1h-2V5H5v10h1v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTaskAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zm-2.21 5.04c.13.57.21 1.17.21 1.78 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.58 0 3.04.46 4.28 1.25l1.44-1.44A9.9 9.9 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.19-.22-2.33-.6-3.39l-1.61 1.61z"
                }
            }
        ]
    })(props);
}
function MdOutlineTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zm-2-1h-6v-2h6v2zM7.5 17l-1.41-1.41L8.67 13l-2.59-2.59L7.5 9l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextRotateUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l-3 3h2v13h2V7h2l-3-3zm-6.2 11.5v-5l2.2-.9V7.5L3 12.25v1.5l11 4.75v-2.1l-2.2-.9zM4.98 13L10 11.13v3.74L4.98 13z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextRotateVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.75 5h-1.5L9.5 16h2.1l.9-2.2h5l.9 2.2h2.1L15.75 5zm-2.62 7L15 6.98 16.87 12h-3.74zM6 20l3-3H7V4H5v13H3l3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextRotationAngledown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21v-4.24l-1.41 1.41-9.2-9.19-1.41 1.41 9.19 9.19L10.76 21H15zM11.25 8.48l3.54 3.54-.92 2.19 1.48 1.48 4.42-11.14-1.06-1.05L7.57 7.92 9.06 9.4l2.19-.92zm6.59-3.05l-2.23 4.87-2.64-2.64 4.87-2.23z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextRotationAngleup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.76 9l1.41 1.41-9.19 9.19 1.41 1.41 9.19-9.19L21 13.24V9h-4.24zm-8.28 3.75l3.54-3.54 2.19.92 1.48-1.48L4.56 4.23 3.5 5.29l4.42 11.14 1.48-1.48-.92-2.2zm-.82-1.72L5.43 6.16l4.87 2.23-2.64 2.64z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextRotationDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 20l3-3H7V4H5v13H3l3 3zm6.2-11.5v5l-2.2.9v2.1l11-4.75v-1.5L10 5.5v2.1l2.2.9zm6.82 2.5L14 12.87V9.13L19.02 11z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextRotationNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18l-3-3v2H5v2h13v2l3-3zM9.5 11.8h5l.9 2.2h2.1L12.75 3h-1.5L6.5 14h2.1l.9-2.2zM12 4.98L13.87 10h-3.74L12 4.98z"
                }
            }
        ]
    })(props);
}
function MdOutlineTheaters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm4-2h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbDownOffAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4V3z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L12 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbUpOffAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 21h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.58 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2zM9 9l4.34-4.34L12 10h9v2l-3 7H9V9zM1 9h4v12H1z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbsUpDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm-2 1.13L7.92 12H2V6.21l1.93-1.93L3.36 7H10v.13zM22.5 10h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5zm-.5 7.79l-1.93 1.93.57-2.72H14v-.13L16.08 12H22v5.79z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimeline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 8c0 1.1-.9 2-2 2a1.7 1.7 0 01-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A1.7 1.7 0 0119 8c0-1.1.9-2 2-2s2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTipsAndUpdates(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-2-1h8v-2H5v2zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H5.27c-1.11-.64-3.77-2.68-3.77-6.5C1.5 5.36 4.86 2 9 2s7.5 3.36 7.5 7.5zm-2 0C14.5 6.47 12.03 4 9 4S3.5 6.47 3.5 9.5c0 2.47 1.49 3.89 2.35 4.5h6.3c.86-.61 2.35-2.03 2.35-4.5zm6.87-2.13L20 8l1.37.63L22 10l.63-1.37L24 8l-1.37-.63L22 6l-.63 1.37zM19 6l.94-2.06L22 3l-2.06-.94L19 0l-.94 2.06L16 3l2.06.94L19 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineToc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineToday(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zM7 11h5v5H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineToken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7l-9-5-9 5v10l9 5 9-5V7zm-9-2.71l5.91 3.28-3.01 1.67C14.17 8.48 13.14 8 12 8s-2.17.48-2.9 1.24L6.09 7.57 12 4.29zm-1 14.87l-6-3.33V9.26L8.13 11c-.09.31-.13.65-.13 1 0 1.86 1.27 3.43 3 3.87v3.29zM10 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm3 7.16v-3.28c1.73-.44 3-2.01 3-3.87 0-.35-.04-.69-.13-1.01L19 9.26v6.57l-6 3.33z"
                }
            }
        ]
    })(props);
}
function MdOutlineToll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12a5.99 5.99 0 014-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09A5.99 5.99 0 013 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineTouchApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.19 12.44l-3.24-1.62c1.29-1 2.12-2.56 2.12-4.32 0-3.03-2.47-5.5-5.5-5.5s-5.5 2.47-5.5 5.5c0 2.13 1.22 3.98 3 4.89v3.26c-2.15-.46-2.02-.44-2.26-.44-.53 0-1.03.21-1.41.59L4 16.22l5.09 5.09c.43.44 1.03.69 1.65.69h6.3c.98 0 1.81-.7 1.97-1.67l.8-4.71c.22-1.3-.43-2.58-1.62-3.18zm-.35 2.85l-.8 4.71h-6.3c-.09 0-.17-.04-.24-.1l-3.68-3.68 4.25.89V6.5c0-.28.22-.5.5-.5s.5.22.5.5v6h1.76l3.46 1.73c.4.2.62.63.55 1.06zM8.07 6.5c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5c0 .95-.38 1.81-1 2.44V6.5a2.5 2.5 0 00-5 0v2.44c-.62-.63-1-1.49-1-2.44z"
                }
            }
        ]
    })(props);
}
function MdOutlineTour(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H7V2H5v20h2v-8h14l-2-5 2-5zm-3.86 5.74l.9 2.26H7V6h11.05l-.9 2.26-.3.74.29.74zM14 9c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTrackChanges(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.07 4.93l-1.41 1.41A8.014 8.014 0 0120 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineTranscribe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C13.71 14.7 11.53 14 9 14s-4.71.7-6.39 1.56A2.97 2.97 0 001 18.22V21h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 19H3v-.78c0-.38.2-.72.52-.88C4.71 16.73 6.63 16 9 16c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V19zm2.93-3l1.63-1.63c-2.77-3.02-2.77-7.56 0-10.74L17.93 2c-3.9 3.89-3.91 9.95 0 14zm4.99-5.05a3.317 3.317 0 010-3.89l-1.68-1.69c-2.02 2.02-2.02 5.07 0 7.27l1.68-1.69z"
                }
            }
        ]
    })(props);
}
function MdOutlineTranslate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 15.07l-2.54-2.51.03-.03A17.52 17.52 0 0014.07 6H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
                }
            }
        ]
    })(props);
}
function MdOutlineTrendingDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineTrendingFlat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12l-4-4v3H3v2h15v3l4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTrendingUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineTroubleshoot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 20.59l-4.69-4.69A7.902 7.902 0 0019 11c0-4.42-3.58-8-8-8-4.08 0-7.44 3.05-7.93 7h2.02C5.57 7.17 8.03 5 11 5c3.31 0 6 2.69 6 6s-2.69 6-6 6c-2.42 0-4.5-1.44-5.45-3.5H3.4C4.45 16.69 7.46 19 11 19c1.85 0 3.55-.63 4.9-1.69L20.59 22 22 20.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.43 9.69L9.65 15h1.64l1.26-3.78.95 2.28h2V12h-1l-1.25-3h-1.54l-1.12 3.37L9.35 7H7.7l-1.25 4H1v1.5h6.55z"
                }
            }
        ]
    })(props);
}
function MdOutlineTry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15l1.57-3.43L17 10l-3.43-1.57L12 5l-1.57 3.43L7 10l3.43 1.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnedInNot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnedIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnfoldLessDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 1.41L15.16 0l-3.17 3.17L8.82 0 7.41 1.41 11.99 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.58 6.41L15.16 5l-3.17 3.17L8.82 5 7.41 6.41 11.99 11zM7.42 17.59L8.84 19l3.17-3.17L15.18 19l1.41-1.41L12.01 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.42 22.59L8.84 24l3.17-3.17L15.18 24l1.41-1.41L12.01 18z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnfoldMoreDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.83L15.17 11l1.41-1.41L12 5 7.41 9.59 8.83 11 12 7.83zm0-5L15.17 6l1.41-1.41L12 0 7.41 4.59 8.83 6 12 2.83zm0 18.34L8.83 18l-1.41 1.41L12 24l4.59-4.59L15.17 18 12 21.17zm0-5L8.83 13l-1.41 1.41L12 19l4.59-4.59L15.17 13 12 16.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnpublished(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.94 5.12L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.869 7.869 0 0020 12c0-4.41-3.59-8-8-8-1.48 0-2.86.41-4.06 1.12zm9.72 4.41l-1.41-1.41-2.65 2.65 1.41 1.41 2.65-2.65zm2.12 13.08l-2.27-2.27A9.91 9.91 0 0112 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zm-3.72-3.73L12.18 15l-1.59 1.59-4.24-4.24 1.41-1.41 2.83 2.83.18-.18-5.65-5.65A7.932 7.932 0 004 12c0 4.41 3.59 8 8 8 1.48 0 2.86-.41 4.06-1.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineUpdateDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 13a8.865 8.865 0 01-1.33 3.79l-1.47-1.47c.38-.71.65-1.49.77-2.32h2.03zM8.67 5.84A7.06 7.06 0 0112 5a7.01 7.01 0 015.74 3H15v2h6V4h-2v2.36C17.35 4.32 14.83 3 12 3c-1.76 0-3.4.51-4.78 1.39l1.45 1.45zM11 7v1.17l2 2V7h-2zm8.78 15.61l-3-3A8.973 8.973 0 0112 21a9 9 0 01-9-9c0-1.76.51-3.4 1.39-4.78l-3-3L2.8 2.81l18.38 18.38-1.4 1.42zm-4.46-4.46L5.84 8.67A7.06 7.06 0 005 12c0 3.86 3.14 7 7 7 1.2 0 2.34-.31 3.32-.85z"
                }
            }
        ]
    })(props);
}
function MdOutlineUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v5l4.25 2.52.77-1.28-3.52-2.09V8H11zm10 2V3l-2.64 2.64A8.937 8.937 0 0012 3a9 9 0 109 9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05L14 10h7z"
                }
            }
        ]
    })(props);
}
function MdOutlineUpgrade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18v2H8v-2h8zM11 7.99V16h2V7.99h3L12 4 8 7.99h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerifiedUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerified(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11.99L20.56 9.2l.34-3.69-3.61-.82L15.4 1.5 12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 11.99l2.44 2.79-.34 3.7 3.61.82 1.89 3.2 3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69 2.44-2.8zm-3.95 1.48l-.56.65.08.85.18 1.95-1.9.43-.84.19-.44.74-.99 1.68-1.78-.77-.8-.34-.79.34-1.78.77-.99-1.67-.44-.74-.84-.19-1.9-.43.18-1.96.08-.85-.56-.65L3.67 12l1.29-1.48.56-.65-.09-.86-.18-1.94 1.9-.43.84-.19.44-.74.99-1.68 1.78.77.8.34.79-.34 1.78-.77.99 1.68.44.74.84.19 1.9.43-.18 1.95-.08.85.56.65 1.29 1.47-1.28 1.48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.09 13.75l-2.32-2.33-1.48 1.49 3.8 3.81 7.34-7.36-1.48-1.49z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h8v2H3zm0 4h8v2H3zm0-8h8v2H3zm0-4h8v2H3zm16 2v10h-4V7h4m2-2h-8v14h8V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewAgenda(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zM19 3H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6H5V5h14v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewArray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v10H9V7h6zm6-2h-3v14h3V5zm-4 0H7v14h10V5zM6 5H3v14h3V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewCarousel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h4v10H2V7zm5 12h10V5H7v14zM9 7h6v10H9V7zm9 0h4v10h-4V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewColumn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm5.33 12H5V7h3.33v10zm5.34 0h-3.33V7h3.33v10zM19 17h-3.33V7H19v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewComfyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zM13 7h4v4h-4zM7 13h4v4H7zM13 13h4v4h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewCompactAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 7.5h4v4h-4zM12.5 7.5h4v4h-4zM7.5 12.5h4v4h-4zM12.5 12.5h4v4h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewCozy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25 7.25h4v4h-4zM12.75 7.25h4v4h-4zM7.25 12.75h4v4h-4zM12.75 12.75h4v4h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 18H2v2h19v-2zm-2-8v4H4v-4h15m1-2H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm1-4H2v2h19V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewHeadline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewInAr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 4c0-.55.45-1 1-1h2V1H4C2.34 1 1 2.34 1 4v2h2V4zM3 20v-2H1v2c0 1.66 1.34 3 3 3h2v-2H4c-.55 0-1-.45-1-1zM20 1h-2v2h2c.55 0 1 .45 1 1v2h2V4c0-1.66-1.34-3-3-3zM21 20c0 .55-.45 1-1 1h-2v2h2c1.66 0 3-1.34 3-3v-2h-2v2zM19 14.87V9.13c0-.72-.38-1.38-1-1.73l-5-2.88c-.31-.18-.65-.27-1-.27s-.69.09-1 .27L6 7.39c-.62.36-1 1.02-1 1.74v5.74c0 .72.38 1.38 1 1.73l5 2.88c.31.18.65.27 1 .27s.69-.09 1-.27l5-2.88c.62-.35 1-1.01 1-1.73zm-8 2.3l-4-2.3v-4.63l4 2.33v4.6zm1-6.33L8.04 8.53 12 6.25l3.96 2.28L12 10.84zm5 4.03l-4 2.3v-4.6l4-2.33v4.63z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewKanban(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h2v10H7zM11 7h2v5h-2zM15 7h2v8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm14 2H9v-2h10v2zm0-4H9v-2h10v2zm0-4H9V7h10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewModule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm16 6h-3.33V7H19v4zm-5.33 0h-3.33V7h3.33v4zM8.33 7v4H5V7h3.33zM5 17v-4h3.33v4H5zm5.33 0v-4h3.33v4h-3.33zm5.34 0v-4H19v4h-3.33z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewQuilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14h18V5H3zm5.33 12H5V7h3.33v10zm5.34 0h-3.33v-4h3.33v4zM19 17h-3.33v-4H19v4zm0-6h-8.67V7H19v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewSidebar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm18 4.67h-2.5V6H20v2.67zm-2.5 2H20v2.67h-2.5v-2.67zM4 6h11.5v12H4V6zm13.5 12v-2.67H20V18h-2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewStream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 10H5v-4h14v4zM5 11V7h14v4H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewTimeline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15h6v2H6zM12 7h6v2h-6zM9 11h6v2H9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 18H4V6h4v12zm6 0h-4V6h4v12zm6 0h-4V6h4v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineVisibilityOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a9.77 9.77 0 018.82 5.5 9.647 9.647 0 01-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68A11.738 11.738 0 001 11.5C2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02a2.5 2.5 0 01-2.5-2.5c0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75a4.6 4.6 0 00-.36 1.78 4.507 4.507 0 006.27 4.14l.98.98c-.88.24-1.8.38-2.75.38a9.77 9.77 0 01-8.82-5.5c.7-1.43 1.72-2.61 2.93-3.53z"
                }
            }
        ]
    })(props);
}
function MdOutlineVisibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a9.77 9.77 0 018.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0112 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineVoiceOverOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.76 5.36l-1.68 1.69c.8 1.13.83 2.58.09 3.74l1.7 1.7c1.9-2.02 1.87-4.98-.11-7.13zM20.07 2l-1.63 1.63c2.72 2.97 2.76 7.39.14 10.56l1.64 1.64c3.74-3.89 3.71-9.84-.15-13.83zM9.43 5.04l3.53 3.53a3.979 3.979 0 00-3.53-3.53zM4.41 2.86L3 4.27l2.62 2.62C5.23 7.5 5 8.22 5 9c0 2.21 1.79 4 4 4 .78 0 1.5-.23 2.11-.62l4.4 4.4C13.74 15.6 10.78 15 9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-.37-.11-.7-.29-1.02L19.73 21l1.41-1.41L4.41 2.86zM3 19c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zm6-8c-1.1 0-2-.9-2-2 0-.22.04-.42.11-.62l2.51 2.51c-.2.07-.4.11-.62.11z"
                }
            }
        ]
    })(props);
}
function MdOutlineWatchLater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineWebhook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15h5.88c.27-.31.67-.5 1.12-.5.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5c-.44 0-.84-.19-1.12-.5H11.9A5 5 0 116 11.1v2.07c-1.16.41-2 1.53-2 2.83 0 1.65 1.35 3 3 3s3-1.35 3-3v-1zm2.5-11c1.65 0 3 1.35 3 3h2c0-2.76-2.24-5-5-5a5.002 5.002 0 00-3.45 8.62l-2.35 3.9c-.68.14-1.2.75-1.2 1.48 0 .83.67 1.5 1.5 1.5a1.498 1.498 0 001.43-1.95l3.38-5.63A3.003 3.003 0 019.5 7c0-1.65 1.35-3 3-3zm4.5 9c-.64 0-1.23.2-1.72.54l-3.05-5.07C11.53 8.35 11 7.74 11 7c0-.83.67-1.5 1.5-1.5S14 6.17 14 7c0 .15-.02.29-.06.43l2.19 3.65c.28-.05.57-.08.87-.08 2.76 0 5 2.24 5 5s-2.24 5-5 5a5 5 0 01-4.33-2.5h2.67c.48.32 1.05.5 1.66.5 1.65 0 3-1.35 3-3s-1.35-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineWidthFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h1v12H4zm3 0V6h10v12H7zm13 0h-1V6h1v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineWidthNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h4v12H4zm6 0V6h4v12h-4zm10 0h-4V6h4v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineWidthWide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2v12H4zm4 0V6h8v12H8zm12 0h-2V6h2v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiProtectedSetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.71 5.29L19 3h-8v8l2.3-2.3c1.97 1.46 3.25 3.78 3.25 6.42 0 1.31-.32 2.54-.88 3.63 2.33-1.52 3.88-4.14 3.88-7.13 0-2.52-1.11-4.77-2.84-6.33z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.46 8.88c0-1.31.32-2.54.88-3.63a8.479 8.479 0 00-3.88 7.13c0 2.52 1.1 4.77 2.84 6.33L5 21h8v-8l-2.3 2.3c-1.96-1.46-3.24-3.78-3.24-6.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineWorkHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19V8h16v3.29c.72.22 1.4.54 2 .97V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h7.68c-.3-.62-.5-1.29-.6-2H4zm6-15h4v2h-4V4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L17.5 18.2V15h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineWorkOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4v2h-3.6l2 2H20v7.6l2 2V8c0-1.11-.89-2-2-2h-4V4c0-1.11-.89-2-2-2h-4c-.99 0-1.8.7-1.96 1.64L10 5.6V4zM3.4 1.84L1.99 3.25 4.74 6H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h15.74l2 2 1.41-1.41L3.4 1.84zM4 19V8h2.74l11 11H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWorkOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWysiwyg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-2-7H7v-2h10v2zm-4 4H7v-2h6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineYoutubeSearchedFor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.01 14h-.8l-.27-.27a6.451 6.451 0 001.57-4.23c0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51a4.5 4.5 0 019 0 4.507 4.507 0 01-6.32 4.12L7.71 15.1a6.474 6.474 0 007.52-.67l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm.5-7H9v2H7v1h2v2h1v-2h2V9h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2h-3.5l-1-1h-5l-1 1H1v2h14zM16 9c-.7 0-1.37.1-2 .29V5H2v12c0 1.1.9 2 2 2h5.68A6.999 6.999 0 0023 16c0-3.87-3.13-7-7-7zm-7 7c0 .34.03.67.08 1H4V7h8v3.26c-1.81 1.27-3 3.36-3 5.74zm7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 12H15v5l3.6 2.1.8-1.2-2.9-1.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineErrorOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotificationImportant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zM12 6c2.76 0 5 2.24 5 5v7H7v-7c0-2.76 2.24-5 5-5zm0-4.5c-.83 0-1.5.67-1.5 1.5v1.17C7.36 4.85 5 7.65 5 11v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V3c0-.83-.67-1.5-1.5-1.5zM11 8h2v4h-2zm0 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWarningAmber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdOutline10K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6v10H5v-8.5h1V15h1.5V9H5V5h14v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11.25V9H14v6h1.5v-2.25L17.25 15H19l-2.25-3L19 9h-1.75zM9.5 15H12c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H9.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5h1.5v3H10v-3z"
                }
            }
        ]
    })(props);
}
function MdOutline1KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 15H9V9H6v1.5h1.5zM12 12.75L13.75 15h1.75l-2.25-3 2.25-3h-1.75L12 11.25V9h-1.5v6H12z"
                }
            }
        ]
    })(props);
}
function MdOutline1K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 15H10V9H7v1.5h1.5zM13.5 12.75L15.25 15H17l-2.25-3L17 9h-1.75l-1.75 2.25V9H12v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline2KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13.5H7.5v-1H9c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H6v1.5h2.5v1H7c-.55 0-1 .45-1 1V15h4v-1.5zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline2K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13.5H8v-1h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1H6.5v1.5h3v1h-2c-.55 0-1 .45-1 1V15H11v-1.5zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline3KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v-4c0-.55-.45-1-1-1H5.5v1.5h3v1h-2v1h2v1h-3V15H9c.55 0 1-.45 1-1zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline3K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14v-4c0-.55-.45-1-1-1H6.5v1.5h3v1h-2v1h2v1h-3V15H10c.55 0 1-.45 1-1zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline4KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 15H10v-1.5h1V12h-1V9H8.5v3H7V9H5.5v4.5h3zM13 12.75L14.75 15h1.75l-2.25-3 2.25-3h-1.75L13 11.25V9h-1.5v6H13z"
                }
            }
        ]
    })(props);
}
function MdOutline4K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V5h14v14zm-9.5-4H11v-1.49h1V12h-1V9H9.5v3H8V9H6.5v4.5h3zm8.7 0l-2-3 2-3h-1.7l-2 3 2 3zm-3.7-3V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline5G(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 13H19v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4.5v2zM3 13h5v2H3v2h5c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H5V9h5V7H3v6z"
                }
            }
        ]
    })(props);
}
function MdOutline5KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v-1.5c0-.55-.45-1-1-1H7.5v-1H10V9H6v3.5h2.5v1H6V15h3c.55 0 1-.45 1-1zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline5K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14v-1.5c0-.55-.45-1-1-1H8v-1h3V9H6.5v3.5h3v1h-3V15H10c.55 0 1-.45 1-1zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline6KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5zM7 15h2c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H7.5v-1H10V9H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5h1V14h-1v-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline6K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5zM7.5 15H10c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H8v-1h3V9H7.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5h1.5V14H8v-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline7KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.75 15H8.5l1.46-4.71C10.15 9.65 9.67 9 9 9H5.5v1.5h2.63L6.75 15zM12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline7K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.75 15H9.5l1.46-4.71C11.15 9.65 10.67 9 10 9H6.5v1.5h2.63L7.75 15zM14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline8KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h2c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5h1v1.5h-1V10zm0 2.5h1V14h-1v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline8K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 15H10c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H7.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5h1.5v1.5H8V10zm0 2.5h1.5V14H8v-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline9KPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14v-4c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h1.5v1H6V15h3c.55 0 1-.45 1-1zm-1.5-2.5h-1V10h1v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8.5h-1.5V10h-1v1.5H15v1h1.5V14h1v-1.5H19V19H5V5h14v6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.75L14.25 15H16l-2.25-3L16 9h-1.75l-1.75 2.25V9H11v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline9K(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14v-4c0-.55-.45-1-1-1H7.5c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2v1h-3V15H10c.55 0 1-.45 1-1zm-1.5-2.5H8V10h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.75L16.25 15H18l-2.25-3L18 9h-1.75l-1.75 2.25V9H13v6h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddToQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v-3h3v-2h-3V7h-2v3H8v2h3zM21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h12l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-12.5c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 5.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineArtTrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAudioFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6zm10-9h-4v3.88a2.247 2.247 0 00-3.5 1.87c0 1.24 1.01 2.25 2.25 2.25S13 17.99 13 16.75V13h3v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAvTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9a9 9 0 000-18h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrandingWatermark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallToAction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 15h14v3H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineClosedCaptionDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1h-1.5v-.5h-2v1L13 10zm3.5 3.5l1.21 1.21c.18-.19.29-.44.29-.71v-1h-1.5v.5zM8.83 6H19v10.17l1.98 1.98c0-.05.02-.1.02-.16V6c0-1.1-.9-2-2-2H6.83l2 2zm10.95 16.61L17.17 20H5a2 2 0 01-2-2V6c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM7.5 13.5h2V13h.67l-2.5-2.5H7.5v3zm7.67 4.5L11 13.83V14c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.32.16-.59.4-.78L5 7.83V18h10.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineClosedCaptionOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zM14 15h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineClosedCaption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12zM7 15h3c.55 0 1-.45 1-1v-1H9.5v.5h-2v-3h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm7 0h3c.55 0 1-.45 1-1v-1h-1.5v.5h-2v-3h2v.5H18v-1c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineControlCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.54 8.46L2 12l3.54 3.54 1.76-1.77L5.54 12l1.76-1.77zm6.46 10l-1.77-1.76-1.77 1.76L12 22l3.54-3.54-1.77-1.76zm6.46-10l-1.76 1.77L18.46 12l-1.76 1.77 1.76 1.77L22 12zm-10-2.92l1.77 1.76L12 5.54l1.77 1.76 1.77-1.76L12 2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3"
                }
            }
        ]
    })(props);
}
function MdOutlineEqualizer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineExplicit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4h-4v-2h4v-2h-4V9h4V7H9v10h6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9.86L18.03 12 15 14.14V9.86m-9 0L9.03 12 6 14.14V9.86M13 6v12l8.5-6L13 6zM4 6v12l8.5-6L4 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFastRewind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9.86v4.28L14.97 12 18 9.86m-9 0v4.28L5.97 12 9 9.86M20 6l-8.5 6 8.5 6V6zm-9 0l-8.5 6 8.5 6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFeaturedPlayList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM5 10h9v2H5zm0-3h9v2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFeaturedVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM4 6h9v7H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFiberDvr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.87 12.43l-1-3.43h-1.5l1.75 6h1.5l1.75-6h-1.5zM21 11.5v-1c0-.85-.65-1.5-1.5-1.5H16v6h1.5v-2h1.15l.85 2H21l-.9-2.1c.5-.25.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zM6.5 9H3v6h3.5c.85 0 1.5-.65 1.5-1.5v-3C8 9.65 7.35 9 6.5 9zm0 4.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFiberManualRecord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6m0-2c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFiberNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.25 12.5L4.75 9H3.5v6h1.25v-3.5L7.3 15h1.2V9H7.25zM9.5 15h4v-1.25H11v-1.11h2.5v-1.26H11v-1.12h2.5V9h-4zm9.75-6v4.5h-1.12V9.99h-1.25v3.52h-1.13V9H14.5v5c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V9h-1.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineFiberPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h1.5V9H11v6zm7.75-6v3.5L16.25 9H15v6h1.25v-3.5L18.8 15H20V9h-1.25zM7.5 9H4v6h1.5v-2h2c.85 0 1.5-.65 1.5-1.5v-1C9 9.65 8.35 9 7.5 9zm0 2.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineFiberSmartRecord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm8-13.74v2.09a5.99 5.99 0 010 11.3v2.09c3.45-.89 6-4.01 6-7.74 0-3.73-2.55-6.85-6-7.74z"
                }
            }
        ]
    })(props);
}
function MdOutlineForward10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.9 16v-4.27h-.09l-1.77.63v.69l1.01-.31V16zM14.32 11.78c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
                }
            }
        ]
    })(props);
}
function MdOutlineForward30(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-7.46 2.22c-.06.05-.12.09-.2.12s-.17.04-.27.04a.69.69 0 01-.45-.15c-.06-.05-.1-.1-.13-.17s-.05-.14-.05-.22h-.85c0 .21.04.39.12.55s.19.28.33.38.29.18.46.23.35.07.53.07c.21 0 .41-.03.6-.08s.34-.14.48-.24.24-.24.32-.39.12-.33.12-.53c0-.23-.06-.44-.18-.61s-.3-.3-.54-.39c.1-.05.2-.1.28-.17s.15-.14.2-.22.1-.16.13-.25.04-.18.04-.27c0-.2-.04-.37-.11-.53s-.17-.28-.3-.38-.28-.18-.46-.23-.37-.08-.59-.08c-.19 0-.38.03-.54.08s-.32.13-.44.23-.23.22-.3.37-.11.3-.11.48h.85a.455.455 0 01.17-.35c.05-.04.11-.07.18-.1s.14-.03.22-.03c.1 0 .18.01.25.04s.13.06.18.11.08.11.11.17.04.14.04.22c0 .18-.05.32-.16.43s-.26.16-.48.16h-.43v.66h.45c.11 0 .2.01.29.04s.16.06.22.11.11.12.14.2.05.18.05.29c0 .09-.01.17-.04.24s-.08.11-.13.17zm3.9-3.44c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.28-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
                }
            }
        ]
    })(props);
}
function MdOutlineForward5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.95 13c0 3.31-2.69 6-6 6s-6-2.69-6-6 2.69-6 6-6v4l5-5-5-5v4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8h-2zm-5.52 2.15c-.05.07-.11.13-.18.17s-.17.06-.27.06c-.17 0-.31-.05-.42-.15s-.17-.24-.19-.41h-.84c.01.2.05.37.13.53s.19.28.32.39.29.19.46.24.35.08.53.08c.24 0 .46-.04.64-.12s.33-.18.45-.31.21-.28.27-.45.09-.35.09-.54c0-.22-.03-.43-.09-.6s-.14-.33-.25-.45-.25-.22-.41-.28-.34-.1-.55-.1c-.07 0-.14.01-.2.02s-.13.02-.18.04-.1.03-.15.05-.08.04-.11.05l.11-.92h1.7v-.71H10.9l-.25 2.17.67.17c.03-.03.06-.06.1-.09s.07-.05.12-.07.1-.04.15-.05.13-.02.2-.02c.12 0 .22.02.3.05s.16.09.21.15.1.14.13.24.04.19.04.31-.01.22-.03.31-.06.17-.11.24z"
                }
            }
        ]
    })(props);
}
function MdOutlineGames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4v2.67l-1 1-1-1V4h2m7 7v2h-2.67l-1-1 1-1H20M6.67 11l1 1-1 1H4v-2h2.67M12 16.33l1 1V20h-2v-2.67l1-1M15 2H9v5.5l3 3 3-3V2zm7 7h-5.5l-3 3 3 3H22V9zM7.5 9H2v6h5.5l3-3-3-3zm4.5 4.5l-3 3V22h6v-5.5l-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7.5 13h2v2H11V9H9.5v2.5h-2V9H6v6h1.5zM18 14v-4c0-.55-.45-1-1-1h-4v6h4c.55 0 1-.45 1-1zm-1.5-.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHearingDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.03 3.2C7.15 2.44 8.51 2 10 2c3.93 0 7 3.07 7 7 0 1.26-.38 2.65-1.07 3.9-.02.04-.05.08-.08.13l-1.48-1.48c.4-.86.63-1.75.63-2.55 0-2.8-2.2-5-5-5-.92 0-1.76.26-2.5.67L6.03 3.2zm11.18 11.18l1.43 1.43C20.11 13.93 21 11.57 21 9c0-3.04-1.23-5.79-3.22-7.78l-1.42 1.42A8.937 8.937 0 0119 9c0 2.02-.67 3.88-1.79 5.38zM10 6.5c-.21 0-.4.03-.59.08l3.01 3.01c.05-.19.08-.38.08-.59A2.5 2.5 0 0010 6.5zm11.19 14.69L2.81 2.81 1.39 4.22l2.13 2.13C3.19 7.16 3 8.05 3 9h2c0-.36.05-.71.12-1.05l6.61 6.61c-.88.68-1.78 1.41-2.27 2.9-.5 1.5-1 2.01-1.71 2.38-.19.1-.46.16-.75.16-1.1 0-2-.9-2-2H3a3.999 3.999 0 005.64 3.65c1.36-.71 2.13-1.73 2.73-3.55.32-.98.9-1.43 1.71-2.05.03-.02.05-.04.08-.06l6.62 6.62 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineHearing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55A3.999 3.999 0 0021 18h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9a2.5 2.5 0 005 0 2.5 2.5 0 00-5 0z"
                }
            }
        ]
    })(props);
}
function MdOutlineHighQuality(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12zM7.5 13h2v2H11V9H9.5v2.5h-2V9H6v6h1.5zm6.5 2h.75v1.5h1.5V15H17c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5h2v3h-2v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineInterpreterMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 16.5c-.83 0-1.5-.67-1.5-1.5v-2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V15c0 .83-.67 1.5-1.5 1.5zM20 20h1v-1.54c1.69-.24 3-1.7 3-3.46h-1a2.5 2.5 0 01-5 0h-1c0 1.76 1.31 3.22 3 3.46V20zM9 12c-2.21 0-4-1.79-4-4a3.999 3.999 0 015.34-3.77A5.938 5.938 0 009 8c0 1.43.5 2.74 1.34 3.77-.42.15-.87.23-1.34.23zm-1.89 1.13A4.965 4.965 0 005 17.22V20H1v-2.78c0-1.12.61-2.15 1.61-2.66 1.24-.64 2.76-1.19 4.5-1.43zM11 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm2 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm2 7c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18h7.17c.5.86 1.25 1.56 2.15 2H7v-2.78c0-1.12.61-2.15 1.61-2.66C10.29 13.7 12.47 13 15 13c.39 0 .77.02 1.14.05-.33.59-.55 1.26-.62 1.96-.17-.01-.34-.01-.52-.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineLibraryAddCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdOutlineLibraryAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-2h2v-3h3V9h-3V6h-2v3h-3v2h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLibraryBooks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM10 9h8v2h-8zm0 3h4v2h-4zm0-6h8v2h-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineLibraryMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7.5-1a2.5 2.5 0 002.5-2.5V7h3V5h-4v5.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 000 5zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineLoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLyrics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h7v2H6zM6 12h4v2H6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11.97V16H6l-2 2V4h11v2.03c.52-.69 1.2-1.25 2-1.6V4c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h9c1.1 0 2-.9 2-2v-2.42a5.16 5.16 0 01-2-1.61z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9h7v2H6zM20 6.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V3h2V1h-4v5.18z"
                }
            }
        ]
    })(props);
}
function MdOutlineMicNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5zm6 6c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.8 4.9c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 3.91L15 10.6V5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65l1.76 1.76V4.9zM19 11h-1.7c0 .58-.1 1.13-.27 1.64l1.27 1.27c.44-.88.7-1.87.7-2.91zM4.41 2.86L3 4.27l6 6V11c0 1.66 1.34 3 3 3 .23 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28a7.13 7.13 0 002.55-.9l4.2 4.2 1.41-1.41L4.41 2.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMissedVideoCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zm-2-1.83V16H5V8h10v.67zm-7.89 2.44L11 15l3.77-3.79-.78-.79L11 13.43l-3.11-3.1h2.55V9.22H6v4.44h1.11z"
                }
            }
        ]
    })(props);
}
function MdOutlineMovie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6.47L5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMusicVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03A3.003 3.003 0 0111 18c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineNewReleases(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-4.51 2.11l.26 2.79-2.74.62-1.43 2.41L12 18.82l-2.58 1.11-1.43-2.41-2.74-.62.26-2.8L3.66 12l1.85-2.12-.26-2.78 2.74-.61 1.43-2.41L12 5.18l2.58-1.11 1.43 2.41 2.74.62-.26 2.79L20.34 12l-1.85 2.11zM11 15h2v2h-2zm0-8h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotInterested(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99h16c1.1 0 2-.9 2-2v-8l-6-6zM4 18.01V6h11v5h5v7.01H4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePauseCircleFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePauseCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayCircleFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16.5l6-4.5-6-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2.5-3.5l7-4.5-7-4.5v9z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.45 13.62L19 12 8 5v.17zM2.81 2.81L1.39 4.22 8 10.83V19l4.99-3.18 6.78 6.78 1.41-1.41L2.81 2.81zM10 15.36v-2.53l1.55 1.55-1.55.98z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlaylistAddCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2 8H7v2h7v-2zm0-3H7v2h7V7zm-7 8h3v-2H7v2zm12-1.59L17.59 12l-3.54 3.54-1.41-1.41-1.41 1.41 2.83 2.83L19 13.41z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlaylistAddCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM20.59 11.93l-4.25 4.24-2.12-2.12-1.41 1.41L16.34 19 22 13.34z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlaylistAddCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2-10H7v2h7v-2zm0-3H7v2h7V7zm-7 8h3v-2H7v2zm12-2v2h-2v2h-2v-2h-2v-2h2v-2h2v2h2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlaylistAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM3 16h7v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlaylistPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3zM3 6h11v2H3zM3 14h7v2H3zM16 13v8l6-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlaylistRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 10H3v2h11v-2zm0-4H3v2h11V6zM3 16h7v-2H3v2zm11.41 6L17 19.41 19.59 22 21 20.59 18.41 18 21 15.41 19.59 14 17 16.59 14.41 14 13 15.41 15.59 18 13 20.59 14.41 22z"
                }
            }
        ]
    })(props);
}
function MdOutlineQueueMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6h-5v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6zm-7 0H3v2h12V6zm0 4H3v2h12v-2zm-4 4H3v2h8v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineQueuePlayNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 00-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
                }
            }
        ]
    })(props);
}
function MdOutlineQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRadio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6H8.3l8.26-3.34L15.88 1 3.24 6.15C2.51 6.43 2 7.17 2 8v12a2 2 0 002 2h16a2 2 0 002-2V8c0-1.11-.89-2-2-2zm0 2v3h-2V9h-2v2H4V8h16zM4 20v-7h16v7H4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "16.48",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function MdOutlineRecentActors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h2v14h-2zm-4 0h2v14h-2zm-3 0H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H3V7h10v10z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "9.94",
                    "r": "1.95"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.89 15.35c0-1.3-2.59-1.95-3.89-1.95s-3.89.65-3.89 1.95V16h7.78v-.65z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveFromQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
                }
            }
        ]
    })(props);
}
function MdOutlineRepeatOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-2 18H6.83l1.58 1.58L7 22l-4-4 4-4 1.41 1.42L6.83 17H17v-4h2v6zm-2-9l-1.41-1.42L17.17 7H7v4H5V5h12.17l-1.58-1.58L17 2l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRepeatOneOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-2 18H6.83l1.58 1.58L7 22l-4-4 4-4 1.41 1.42L6.83 17H17v-4h2v6zm-9-8.5V9h3v6h-1.5v-4.5H10zm7-.5l-1.41-1.42L17.17 7H7v4H5V5h12.17l-1.58-1.58L17 2l4 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRepeatOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
                }
            }
        ]
    })(props);
}
function MdOutlineRepeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineReplay10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function MdOutlineReplay30(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-2.44 8.49h.45c.21 0 .37-.05.48-.16s.16-.25.16-.43a.538.538 0 00-.15-.39c-.05-.05-.11-.09-.18-.11s-.16-.04-.25-.04c-.08 0-.15.01-.22.03s-.13.05-.18.1-.09.09-.12.15-.05.13-.05.2h-.85a1.06 1.06 0 01.41-.85c.13-.1.27-.18.44-.23s.35-.08.54-.08c.21 0 .41.03.59.08s.33.13.46.23.23.23.3.38.11.33.11.53a.842.842 0 01-.17.52 1.1 1.1 0 01-.48.39c.24.09.42.21.54.39s.18.38.18.61c0 .2-.04.38-.12.53s-.18.29-.32.39-.29.19-.48.24-.38.08-.6.08c-.18 0-.36-.02-.53-.07s-.33-.12-.46-.23-.25-.23-.33-.38-.12-.34-.12-.55h.85c0 .08.02.15.05.22s.07.12.13.17.12.09.2.11.16.04.25.04c.1 0 .19-.01.27-.04s.15-.07.2-.12.1-.11.13-.18.04-.15.04-.24c0-.11-.02-.21-.05-.29s-.08-.15-.14-.2-.13-.09-.22-.11-.18-.04-.29-.04h-.47v-.65zm5.74.75c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32c.03-.13.04-.29.04-.48v-.97z"
                }
            }
        ]
    })(props);
}
function MdOutlineReplay5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.31 8.9l.25-2.17h2.39v.71h-1.7l-.11.92c.03-.02.07-.03.11-.05s.09-.04.15-.05.12-.03.18-.04.13-.02.2-.02c.21 0 .39.03.55.1s.3.16.41.28.2.27.25.45.09.38.09.6c0 .19-.03.37-.09.54s-.15.32-.27.45-.27.24-.45.31-.39.12-.64.12c-.18 0-.36-.03-.53-.08s-.32-.14-.46-.24-.24-.24-.32-.39-.13-.33-.13-.53h.84c.02.18.08.32.19.41s.25.15.42.15a.49.49 0 00.45-.23c.04-.07.08-.15.11-.25s.03-.2.03-.31-.01-.21-.04-.31-.07-.17-.13-.24-.13-.12-.21-.15-.19-.05-.3-.05c-.08 0-.15.01-.2.02s-.11.03-.15.05-.08.05-.12.07-.07.06-.1.09l-.67-.16z"
                }
            }
        ]
    })(props);
}
function MdOutlineReplayCircleFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 16.5c-3.31 0-6-2.69-6-6h2c0 2.21 1.79 4 4 4s4-1.79 4-4c0-2.24-1.85-4.09-4.16-3.99l1.57 1.57L12 11.5l-4-4 4-4 1.41 1.41-1.6 1.6C15.28 6.4 18 9.18 18 12.5c0 3.31-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineReplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15h3c.55 0 1-.45 1-1v-1.5c0-.55-.45-1-1-1H7.5v-1h2v.5H11v-1c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1.5c0 .55.45 1 1 1h2.5v1h-2V13H6v1c0 .55.45 1 1 1zM18 14v-4c0-.55-.45-1-1-1h-4v6h4c.55 0 1-.45 1-1zm-1.5-.5h-2v-3h2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineShuffleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H3c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM5.41 4l5.18 5.17-1.41 1.42L4 5.42 5.41 4zM20 20h-6v-2h2.61l-3.2-3.2 1.42-1.42 3.13 3.13.04.04V14h2v6zm0-10h-2V7.42L5.41 20 4 18.59 16.58 6H14V4h6v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
                }
            }
        ]
    })(props);
}
function MdOutlineSkipNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 18l8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSkipPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6h2v12H6zm3.5 6l8.5 6V6l-8.5 6zm6.5 2.14L12.97 12 16 9.86v4.28z"
                }
            }
        ]
    })(props);
}
function MdOutlineSlowMotionVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.05 9.79L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zm0 0L10 7.5v9l3.05-2.29L16 12l-2.95-2.21zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zm1.61 6.74A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineSnooze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2zm7.056-7.654l1.282-1.535 4.607 3.85-1.28 1.54zM3.336 7.19l-1.28-1.536L6.662 1.81l1.28 1.536zM12 6c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-2a9 9 0 10.001 18.001A9 9 0 0012 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineSortByAlpha(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.94 4.66h-4.72l2.36-2.36 2.36 2.36zm-4.69 14.71h4.66l-2.33 2.33-2.33-2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.38 8.57l-1.23 1.85a8 8 0 01-.22 7.58H5.07A8 8 0 0115.58 6.85l1.85-1.23A10 10 0 003.35 19a2 2 0 001.72 1h13.85a2 2 0 001.74-1 10 10 0 00-.27-10.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.59 15.41a2 2 0 002.83 0l5.66-8.49-8.49 5.66a2 2 0 000 2.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4-4H8V8h8v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8v8H8V8h8m2-2H6v12h12V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubscriptions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h16v2H4zm2-4h12v2H6zm14 8H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10H4v-8h16v8zm-10-7.27v6.53L16 16z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubtitles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM6 10h2v2H6zm0 4h8v2H6zm10 0h2v2h-2zm-6-4h8v2h-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSurroundSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.29 15.71A5.233 5.233 0 016.75 12c0-1.35.52-2.69 1.53-3.72L7.05 7.05C5.68 8.41 5 10.21 5 12s.68 3.59 2.06 4.94l1.23-1.23zM12 15.5c1.93 0 3.5-1.57 3.5-3.5S13.93 8.5 12 8.5 8.5 10.07 8.5 12s1.57 3.5 3.5 3.5zm0-5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM15.72 15.72l1.23 1.23C18.32 15.59 19 13.79 19 12s-.68-3.59-2.06-4.94l-1.23 1.23A5.233 5.233 0 0117.25 12c0 1.35-.52 2.69-1.53 3.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM15 16H5V8h10v8zm-6-1h2v-2h2v-2h-2V9H9v2H7v2h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6zm8-6l2-1.06v4.12L14 16v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoLabel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM12 5.5v9l6-4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoSettings(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18v5h2V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H3V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12L9 8v8zM22.71 18.43c.03-.29.04-.58.01-.86l1.07-.85c.1-.08.12-.21.06-.32l-1.03-1.79c-.06-.11-.19-.15-.31-.11l-1.28.5a3.44 3.44 0 00-.75-.42l-.2-1.36a.249.249 0 00-.25-.22h-2.07c-.12 0-.23.09-.25.21l-.2 1.36c-.26.11-.51.26-.74.42l-1.28-.5c-.12-.05-.25 0-.31.11l-1.03 1.79c-.06.11-.04.24.06.32l1.07.86c-.03.29-.04.58-.01.86l-1.07.85c-.1.08-.12.21-.06.32l1.03 1.79c.06.11.19.15.31.11l1.27-.5c.23.17.48.31.75.42l.2 1.36c.02.12.12.21.25.21h2.07c.12 0 .23-.09.25-.21l.2-1.36c.26-.11.51-.26.74-.42l1.28.5c.12.05.25 0 .31-.11l1.03-1.79c.06-.11.04-.24-.06-.32l-1.06-.85zM19 19.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideocamOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideocam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineVolumeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02A4.5 4.5 0 0016 7.97zM5 9v6h4l5 5V4L9 9H5zm7-.17v6.34L9.83 13H7v-2h2.83L12 8.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8.83v6.34L11.83 13H9v-2h2.83L14 8.83M16 4l-5 5H7v6h4l5 5V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.34 2.93L2.93 4.34 7.29 8.7 7 9H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06a8.94 8.94 0 003.61-1.75l2.05 2.05 1.41-1.41L4.34 2.93zM10 15.17L7.83 13H5v-2h2.83l.88-.88L10 11.41v3.76zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-7-8l-1.88 1.88L12 7.76zm4.5 8A4.5 4.5 0 0014 7.97v1.79l2.48 2.48c.01-.08.02-.16.02-.24z"
                }
            }
        ]
    })(props);
}
function MdOutlineVolumeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9v6h4l5 5V4L7 9H3zm7-.17v6.34L7.83 13H5v-2h2.83L10 8.83zM16.5 12A4.5 4.5 0 0014 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77 0-4.28-2.99-7.86-7-8.77z"
                }
            }
        ]
    })(props);
}
function MdOutlineWebAssetOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 4H20a2 2 0 012 2v12c0 .34-.09.66-.23.94L20 17.17V8h-9.17l-4-4zm13.66 19.31L17.17 20H4a2 2 0 01-2-2V6c0-.34.08-.66.23-.94L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM15.17 18l-10-10H4v10h11.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineWebAsset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineWeb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 9h10.5v3.5H4V9zm0 5.5h10.5V18H4v-3.5zM20 18h-3.5V9H20v9z"
                }
            }
        ]
    })(props);
}
function MdOutline3P(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4.01c-1.1 0-2 .9-2 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-8-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 008 13.43V14h8v-.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddIcCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.45c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1 11.36 11.36 0 01-.57-3.57c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 4.95h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.92c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 5.95v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlternateEmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1.95c-5.52 0-10 4.48-10 10s4.48 10 10 10h5v-2h-5c-4.34 0-8-3.66-8-8s3.66-8 8-8 8 3.66 8 8v1.43c0 .79-.71 1.57-1.5 1.57s-1.5-.78-1.5-1.57v-1.43c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5c1.38 0 2.64-.56 3.54-1.47.65.89 1.77 1.47 2.96 1.47 1.97 0 3.5-1.6 3.5-3.57v-1.43c0-5.52-4.48-10-10-10zm0 13c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAppRegistration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4h4v4h-4zM4 16h4v4H4zM4 10h4v4H4zM4 4h4v4H4zM16 4h4v4h-4zM11 17.86V20h2.1l5.98-5.97-2.12-2.12zM14 12.03V10h-4v4h2.03zM20.85 11.56l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06c.2-.2.2-.51 0-.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineBusiness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.59 10.52c1.05.51 2.04 1.15 2.96 1.91l-1.07 1.07c-.58-.47-1.21-.89-1.88-1.27v-1.71m-13.2 0v1.7c-.65.37-1.28.79-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.38 2.94-1.9M12 7C7.46 7 3.34 8.78.29 11.67c-.18.18-.29.43-.29.71s.11.53.29.7l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.1.7-.28.79-.73 1.68-1.36 2.66-1.85.33-.16.56-.51.56-.9v-3.1C8.85 9.25 10.4 9 12 9s3.15.25 4.59.73v3.1c0 .4.23.74.56.9.98.49 1.88 1.11 2.67 1.85.18.17.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.11-.53-.29-.71A16.971 16.971 0 0012 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallMade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallMissedOutgoing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallMissed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9L19.59 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallReceived(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineCallSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4h-6zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3L10 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCancelPresentation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM9.41 15.95L12 13.36l2.59 2.59L16 14.54l-2.59-2.59L16 9.36l-1.41-1.41L12 10.54 9.41 7.95 8 9.36l2.59 2.59L8 14.54z"
                }
            }
        ]
    })(props);
}
function MdOutlineCellTower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.3 14.7l1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7zM19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9 0 2.1-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1 0-2.6-1-5.1-2.9-7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 4.1L4.9 2.9C3 4.9 2 7.4 2 10c0 2.6 1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9 0-2.1.8-4.3 2.4-5.9zM16.7 14.7c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5l1.2 1.2zM14.5 10a2.5 2.5 0 00-5 0c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88zm-4.17 8L12 13l1.67 5h-3.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineCellWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 22h16V5.97L6 22zm14-2h-2v-7.22l2-2V20zM5.22 7.22L3.93 5.93c3.9-3.91 10.24-3.91 14.15 0l-1.29 1.29c-3.19-3.19-8.38-3.19-11.57 0zm7.71 3.85L11 13l-1.93-1.93a2.74 2.74 0 013.86 0zm1.29-1.28c-1.78-1.77-4.66-1.77-6.43 0L6.5 8.5a6.374 6.374 0 019 0l-1.28 1.29z"
                }
            }
        ]
    })(props);
}
function MdOutlineChatBubbleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineChatBubble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h8v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineClearAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineCoPresent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v8h2V5h18v16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10c0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4 4-1.79 4-4zm-6 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM15.39 16.56C13.71 15.7 11.53 15 9 15s-4.71.7-6.39 1.56A2.97 2.97 0 001 19.22V22h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 20H3c0-.72-.1-1.34.52-1.66C4.71 17.73 6.63 17 9 17c2.37 0 4.29.73 5.48 1.34.63.32.52.95.52 1.66z"
                }
            }
        ]
    })(props);
}
function MdOutlineComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM20 4v13.17L18.83 16H4V4h16zM6 12h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCommentsDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.83 16H20V4H6.83l-2-2H20c1.1 0 2 .9 2 2v15.17L18.83 16zM18 6H8.83l2 2H18V6zm0 3h-6.17l2 2H18V9zm0 5v-2h-3.17l2 2H18zm3.9 7.9l-1.41 1.41L15.17 18H4c-1.1 0-2-.9-2-2V4.83L.69 3.51 2.1 2.1l19.8 19.8zM13.17 16l-2-2H6v-2h3.17l-1-1H6V9h.17L4 6.83V16h9.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineContactEmergency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.54 0 1 .46 1 1s-.46 1-1 1-1-.46-1-1 .46-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM4.54 19c1.1-1.22 2.69-2 4.46-2s3.36.78 4.46 2H4.54zM22 19h-6.08c-1.38-2.39-3.96-4-6.92-4s-5.54 1.61-6.92 4H2V5h20v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.78 11.15l1.47-.85V12h1.5v-1.7l1.47.85.75-1.3L19.5 9l1.47-.85-.75-1.3-1.47.85V6h-1.5v1.7l-1.47-.85-.75 1.3L16.5 9l-1.47.85z"
                }
            }
        ]
    })(props);
}
function MdOutlineContactMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zM21 6h-7v5h7V6zm-1 2l-2.5 1.75L15 8V7l2.5 1.75L20 7v1zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineContactPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zm0 16H2V5h20v14zm-2.99-1.01L21 16l-1.51-2h-1.64c-.22-.63-.35-1.3-.35-2s.13-1.37.35-2h1.64L21 8l-1.99-1.99A7.474 7.474 0 0016.28 10c-.18.64-.28 1.31-.28 2s.1 1.36.28 2a7.512 7.512 0 002.73 3.99zM9 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.59c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.41zM5.48 16c.74-.5 2.22-1 3.52-1s2.77.49 3.52 1H5.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12zM4 0h16v2H4zm0 22h16v2H4zm8-10a2.5 2.5 0 000-5 2.5 2.5 0 000 5zm0-3.5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 7.49C17 13.9 13.69 13 12 13s-5 .9-5 2.99V17h10v-1.01zm-8.19-.49c.61-.52 2.03-1 3.19-1 1.17 0 2.59.48 3.2 1H8.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineDesktopAccessDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.69L0 3.1l1 .99V16c0 1.1.89 2 1.99 2H10v2H8v2h8v-2h-2v-2h.9l6 6 1.41-1.41-20.9-20.9zM2.99 16V6.09L12.9 16H2.99zM4.55 2l2 2H21v12h-2.45l2 2h.44c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4.55z"
                }
            }
        ]
    })(props);
}
function MdOutlineDialerSip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3h1v5h-1zm-1 2h-2V4h2V3h-3v3h2v1h-2v1h3zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57a.984.984 0 00-1.01.24l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.46 2.59L5.79 8.8c-.41-1.21-.67-2.48-.76-3.8zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.2-1.2c.85.24 1.71.39 2.59.45v1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDialpad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDocumentScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3H4v3H2V1h5v2zm15 3V1h-5v2h3v3h2zM7 21H4v-3H2v5h5v-2zm13-3v3h-3v2h5v-5h-2zM17 6H7v12h10V6zm2 12c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v12zM15 8H9v2h6V8zm0 3H9v2h6v-2zm0 3H9v2h6v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDomainDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.69L0 3.1l2 2V21h15.9l3 3 1.41-1.41-20.9-20.9zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm-2-4V9h2v2H4zm6 8H8v-2h2v2zm-2-4v-2h2v2H8zm4 4v-2h1.9l2 2H12zM8 5h2v2h-.45L12 9.45V9h8v8.45l2 2V7H12V3H5.55L8 5.45zm8 6h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDomainVerification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.6 10.88l-1.42-1.42-4.24 4.25-2.12-2.13L7.4 13l3.54 3.54z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14c1.1 0 2-.9 2-2V6a2 2 0 00-2-2zm0 14H5V8h14v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineDuo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h-8C6.38 2 2 6.66 2 12.28 2 17.5 6.49 22 11.72 22 17.39 22 22 17.62 22 12V4c0-1.1-.9-2-2-2zm-3 13l-3-2v2H7V9h7v2l3-2v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineForum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v7H5.17L4 12.17V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineForwardToInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm7 4l4 4-4 4v-3h-4v-2h4v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHourglassBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 22l-.01-6L14 12l3.99-4.01L18 2H6v6l4 4-4 3.99V22h12zM8 7.5V4h8v3.5l-4 4-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHourglassTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 2l.01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2H6zm10 14.5V20H8v-3.5l4-4 4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.5a2.996 2.996 0 00-2.99 3.21l-2.03.68a4.468 4.468 0 00-3.22-2.32V5.91A3.018 3.018 0 0015 3c0-1.66-1.34-3-3-3S9 1.34 9 3c0 1.4.96 2.57 2.25 2.91v2.16c-1.4.23-2.58 1.11-3.22 2.32l-2.04-.68C6 9.64 6 9.57 6 9.5c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3c1.06 0 1.98-.55 2.52-1.37l2.03.68c-.2 1.29.17 2.66 1.09 3.69l-1.41 1.77C6.85 17.09 6.44 17 6 17c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3c0-.68-.22-1.3-.6-1.8l1.41-1.77c1.36.76 3.02.75 4.37 0l1.41 1.77c-.37.5-.59 1.12-.59 1.8 0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3c-.44 0-.85.09-1.23.26l-1.41-1.77a4.49 4.49 0 001.09-3.69l2.03-.68c.53.82 1.46 1.37 2.52 1.37 1.66 0 3-1.34 3-3S22.66 6.5 21 6.5zm-18 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM6 21c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5-18c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm1 12a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm6 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3-8.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineImportContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineImportExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineInvertColorsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l4.2 4.2a7.73 7.73 0 00-1.6 4.7C4 17.48 7.58 21 12 21c1.75 0 3.36-.56 4.67-1.5l3.1 3.1 1.42-1.41zM12 19c-3.31 0-6-2.63-6-5.87 0-1.19.36-2.32 1.02-3.28L12 14.83V19zM8.38 5.56L12 2l5.65 5.56C19.1 8.99 20 10.96 20 13.13c0 1.18-.27 2.29-.74 3.3L12 9.17V4.81L9.8 6.97 8.38 5.56z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.7 13.53l-1.71-1.71c.01.06.01.12.01.18 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.06 0 .12 0 .18.01L5.47 8.3C4.02 8.9 3 10.33 3 12c0 2.21 1.79 4 4 4 1.67 0 3.1-1.02 3.7-2.47zm1.49 1.49A6.012 6.012 0 017 18c-3.31 0-6-2.69-6-6 0-2.21 1.2-4.15 2.98-5.19L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-7.58-7.58zm4.07-1.59l1.24-.93 1.81 1.36L21.17 12l-1-1h-6.34l-2-2H21l3 3-4.5 4.5-.69-.51-2.55-2.56z"
                }
            }
        ]
    })(props);
}
function MdOutlineKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10h-8.35A5.99 5.99 0 007 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 005.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM20.1 3H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM19 19H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineLiveHelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-8-3h2v2h-2zm1-8c1.1 0 2 .9 2 2 0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4S8 6.79 8 9h2c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocationOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c2.76 0 5 2.24 5 5 0 1.06-.39 2.32-1 3.62l1.49 1.49C18.37 12.36 19 10.57 19 9c0-3.87-3.13-7-7-7-1.84 0-3.5.71-4.75 1.86l1.43 1.43C9.56 4.5 10.72 4 12 4zm0 2.5c-.59 0-1.13.21-1.56.56l3.5 3.5c.35-.43.56-.97.56-1.56A2.5 2.5 0 0012 6.5zM3.41 2.86L2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21l1.41-1.41L3.41 2.86zM12 18.88c-2.01-2.58-4.8-6.74-4.98-9.59l6.92 6.92c-.65.98-1.33 1.89-1.94 2.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocationOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "9",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function MdOutlineMailLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8l8 5 8-5v2h2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h12v-2H4V8zm16-2l-8 5-8-5h16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-3 0v-1c0-.55.45-1 1-1s1 .45 1 1v1h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMailOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkChatRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18H6l-4 4V4c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v7h-2V4H4v12h8v2zm11-3.66l-1.41-1.41-4.24 4.24-2.12-2.12-1.41 1.41L17.34 20 23 14.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkChatUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.98V16c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h10.1c-.06.32-.1.66-.1 1s.04.68.1 1H4v12h16V7.9c.74-.15 1.42-.48 2-.92zM16 3c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkEmailRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm5.34 11l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34 17.34 22z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkEmailUnread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8.98V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h10.1c-.06.32-.1.66-.1 1s.04.68.1 1H4l8 5 3.67-2.29c.47.43 1.02.76 1.63.98L12 13 4 8v10h16V9.9c.74-.15 1.42-.48 2-.92zM16 5c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkUnreadChatAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 16H4V4h10.1a5 5 0 010-2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V6.98c-.58.44-1.26.77-2 .92V16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "3",
                    "r": "3"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 12h8v2H6zM6 9h12v2H6zM6 8h12v-.1A5.013 5.013 0 0115.03 6H6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16v12H5.17L4 17.17V4m0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2 10h12v2H6v-2zm0-3h12v2H6V9zm0-3h12v2H6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineMobileScreenShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-1.99.85-1.99 1.95v18C5.01 22.05 5.9 23 7 23h10c1.1 0 2-.95 2-2.05v-18C19 1.85 18.1 1 17 1zm0 18H7V5h10v14zm-4.2-5.76v1.75L16 12l-3.2-2.98v1.7c-3.11.43-4.35 2.56-4.8 4.7 1.11-1.5 2.58-2.18 4.8-2.18z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoreTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v6l4.7 2.9.8-1.2-4-2.4V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 12A6.957 6.957 0 0111 20c-3.9 0-7-3.1-7-7s3.1-7 7-7c.7 0 1.37.1 2 .29V4.23c-.64-.15-1.31-.23-2-.23-5 0-9 4-9 9s4 9 9 9a8.963 8.963 0 008.94-10h-2.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V2h-2v3h-3v2h3v3h2V7h3V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.82 13H11v-2H6.82C6.4 9.84 5.3 9 4 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2zM4 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 12l-4-3v2h-4.05c-.5-5.05-4.76-9-9.95-9v2c4.42 0 8 3.58 8 8s-3.58 8-8 8v2c5.19 0 9.45-3.95 9.95-9H19v2l4-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoSim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.26 21.21L3.79 3.74 2.38 5.15l2.74 2.74-.12.12V19c0 1.1.9 2 2 2h10c.35 0 .68-.1.97-.26l1.88 1.88 1.41-1.41zM7 19V9.77L16.23 19H7zm3.84-14H17v9.11l2 2V5c0-1.1-.9-2-2-2h-6.99L7.95 5.06l1.41 1.41L10.84 5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePausePresentation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .85-2 1.95v14c0 1.1.9 2.05 2 2.05h18c1.1 0 2-.95 2-2.05v-14C23 3.85 22.1 3 21 3zm0 16H3V5h18v14zM9 8h2v8H9zm4 0h2v8h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonAddDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 6c1.1 0 2 .9 2 2a2 2 0 01-1.67 1.97l-2.31-2.31C13.19 6.72 14.01 6 15 6m0-2c-2.21 0-4 1.79-4 4 0 .18.03.35.05.52l3.43 3.43c.17.02.34.05.52.05 2.21 0 4-1.79 4-4s-1.79-4-4-4zm1.69 10.16L22.53 20H23v-2c0-2.14-3.56-3.5-6.31-3.84zm-3.68 1.97L14.88 18H9c.08-.24.88-1.01 2.91-1.57l1.1-.3M1.41 1.71L0 3.12l4 4V10H1v2h3v3h2v-3h2.88l2.51 2.51C9.19 15.11 7 16.3 7 18v2h9.88l4 4 1.41-1.41L1.41 1.71zM6 10v-.88l.88.88H6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM4 18c.22-.72 3.31-2 6-2 0-.7.13-1.37.35-1.99C7.62 13.91 2 15.27 2 18v2h9.54c-.52-.58-.93-1.25-1.19-2H4zM19.43 18.02c.36-.59.57-1.28.57-2.02 0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4c.74 0 1.43-.22 2.02-.57L20.59 22 22 20.59c-1.5-1.5-.79-.8-2.57-2.57zM16 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 14.54l-1.43-1.43c.56-.73 1.05-1.5 1.47-2.32l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1H20c.55 0 1 .45 1 1 0 3.98-1.37 7.64-3.66 10.54zm-2.82 2.81A16.884 16.884 0 014 21c-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c.81-.42 1.58-.9 2.3-1.46L1.39 4.22l1.42-1.41L21.19 21.2l-1.41 1.41-5.26-5.26zm-6.92-.33c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneEnabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.46 5c-.06.89-.21 1.76-.45 2.59l1.2 1.2c.41-1.2.67-2.47.76-3.79h-1.51zM7.6 17.02c-.85.24-1.72.39-2.6.45v1.49c1.32-.09 2.59-.35 3.8-.75l-1.2-1.19zM16.5 3H20c.55 0 1 .45 1 1 0 9.39-7.61 17-17 17-.55 0-1-.45-1-1v-3.49c0-.55.45-1 1-1 1.24 0 2.45-.2 3.57-.57.1-.04.21-.05.31-.05.26 0 .51.1.71.29l2.2 2.2c2.83-1.45 5.15-3.76 6.59-6.59l-2.2-2.2c-.28-.28-.36-.67-.25-1.02.37-1.12.57-2.32.57-3.57 0-.55.45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonelinkErase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonelinkLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonelinkRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonelinkSetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 3v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2zm2.5 12.5c.29-.12.55-.29.8-.48l-.02.03 1.01.39c.23.09.49 0 .61-.22l.84-1.46c.12-.21.07-.49-.12-.64l-.85-.68-.02.03c.02-.16.05-.32.05-.48s-.03-.32-.05-.48l.02.03.85-.68c.19-.15.24-.43.12-.64l-.84-1.46a.499.499 0 00-.61-.22l-1.01.39.02.03c-.25-.17-.51-.34-.8-.46l-.17-1.08A.488.488 0 008.84 7H7.16c-.25 0-.46.18-.49.42L6.5 8.5c-.29.12-.55.29-.8.48l.02-.03-1.02-.39c-.23-.09-.49 0-.61.22l-.84 1.46c-.12.21-.07.49.12.64l.85.68.02-.03c-.02.15-.05.31-.05.47s.03.32.05.48l-.02-.03-.85.68c-.19.15-.24.43-.12.64l.84 1.46c.12.21.38.31.61.22l1.01-.39-.01-.04c.25.19.51.36.8.48l.17 1.07c.03.25.24.43.49.43h1.68c.25 0 .46-.18.49-.42l.17-1.08zM6 12c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePortableWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.42 2.36L2.01 3.78 4.1 5.87C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02 7.52 7.52 1.41-1.41L3.42 2.36zm14.29 11.46c.18-.57.29-1.19.29-1.82 0-3.31-2.69-6-6-6-.63 0-1.25.11-1.82.29l1.72 1.72c.03 0 .06-.01.1-.01 2.21 0 4 1.79 4 4 0 .04-.01.07-.01.11l1.72 1.71zM12 4c4.42 0 8 3.58 8 8 0 1.2-.29 2.32-.77 3.35l1.49 1.49A9.82 9.82 0 0022 12c0-5.52-4.48-10-10-10-1.76 0-3.4.48-4.84 1.28l1.48 1.48C9.66 4.28 10.8 4 12 4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePresentToAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePrintDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.41 1.6L0 3.01 5 8c-1.66 0-3 1.34-3 3v6h4v4h12l2.95 2.96 1.41-1.41L1.41 1.6zM6 15H4v-4c0-.55.45-1 1-1h2l3 3H6v2zm2 4v-4h4l4 4H8zM8 5h8v3h-5.34l2 2H19c.55 0 1 .45 1 1v4l-2 .01V13h-2.34l4 4H22v-6c0-1.66-1.34-3-3-3h-1V3H6v.36l2 2V5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.51",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineQrCode2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h-2v-2h2v2zm-2-7h-2v5h2v-5zm8-2h-2v4h2v-4zm-2-2h-2v2h2v-2zM7 12H5v2h2v-2zm-2-2H3v2h2v-2zm7-5h2V3h-2v2zm-7.5-.5v3h3v-3h-3zM9 9H3V3h6v6zm-4.5 7.5v3h3v-3h-3zM9 21H3v-6h6v6zm7.5-16.5v3h3v-3h-3zM21 9h-6V3h6v6zm-2 10v-3h-4v2h2v3h4v-2h-2zm-2-7h-4v2h4v-2zm-4-2H7v2h2v2h2v-2h2v-2zm1-1V7h-2V5h-2v4h4zM6.75 5.25h-1.5v1.5h1.5v-1.5zm0 12h-1.5v1.5h1.5v-1.5zm12-12h-1.5v1.5h1.5v-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineQrCodeScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM22 7h-2V4h-3V2h5v5zm0 15v-5h-2v3h-3v2h5zM2 22h5v-2H4v-3H2v5zM2 2v5h2V4h3V2H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineQrCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11h8V3H3v8zm2-6h4v4H5V5zM3 21h8v-8H3v8zm2-6h4v4H5v-4zM13 3v8h8V3h-8zm6 6h-4V5h4v4zM19 19h2v2h-2zM13 13h2v2h-2zM15 15h2v2h-2zM13 17h2v2h-2zM15 19h2v2h-2zM17 17h2v2h-2zM17 13h2v2h-2zM19 15h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineReadMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h9v2h-9zM13 15h9v2h-9zM16 11h6v2h-6zM13 12L8 7v4H2v2h6v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRingVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.71 16.67A16.971 16.971 0 0012 12C7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71a.99.99 0 00-.29-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zm.69-12.23l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
                }
            }
        ]
    })(props);
}
function MdOutlineRssFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.18",
                    "cy": "17.82",
                    "r": "2.18"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineRtt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.03 3l-1.11 7.07h2.62l.7-4.5h2.58L11.8 18.43H9.47L9.06 21h7.27l.4-2.57h-2.35l2-12.86h2.58l-.71 4.5h2.65L22 3H9.03zM8 5H4l-.31 2h4L8 5zm-.61 4h-4l-.31 2h4l.31-2zm.92 8h-6L2 19h6l.31-2zm.62-4h-6l-.31 2h6.01l.3-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 00-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 002 2H0v2h24v-2h-4zM4 16V6h16v10.01L4 16zm9-6.87c-3.89.54-5.44 3.2-6 5.87 1.39-1.87 3.22-2.72 6-2.72v2.19l4-3.74L13 7v2.13z"
                }
            }
        ]
    })(props);
}
function MdOutlineSendTimeExtension(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v6.26l2 1V6c0-1.1-.9-2-2-2h-4a2.5 2.5 0 00-5 0H5.01c-1.1 0-2 .9-2 2v3.8C5.7 9.8 6 11.96 6 12.5s-.29 2.7-3 2.7V19c0 1.1.9 2 2 2h3.8c0-2.16 1.37-2.78 2.2-2.94v-2.03c-1.43.17-3.15 1.04-3.87 2.97H5v-2.13c2.17-.8 3-2.87 3-4.37 0-1.49-.83-3.56-2.99-4.37V6H11V4c0-.28.22-.5.5-.5s.5.22.5.5v2h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 12v4l4 1-4 1v4l10-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSentimentSatisfiedAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0010.24 0h-1.67c-.69 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zm0 2v12h16V6H4zm7 3h2v6h-2V9zm3 0h4c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2.5v2H14V9zm3.5 1.5h-2v1h2v-1zm-11 .75H9c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H5v-1.5h3.5v-.75H6c-.55 0-1-.45-1-1V10c0-.55.45-1 1-1h4v1.5H6.5v.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpeakerPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41A10.963 10.963 0 0012 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpoke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7c0-2.21-1.79-4-4-4S8 4.79 8 7s1.79 4 4 4 4-1.79 4-4zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm-5 4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm10-6c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStayCurrentLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function MdOutlineStayCurrentPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineStayPrimaryLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
                }
            }
        ]
    })(props);
}
function MdOutlineStayPrimaryPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineStopScreenShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.79 18l2 2H24v-2h-2.21zM1.11 2.98l1.55 1.56c-.41.37-.66.89-.66 1.48V16c0 1.1.9 2 2.01 2H0v2h18.13l2.71 2.71 1.41-1.41L2.52 1.57 1.11 2.98zM4 6.02h.13l4.95 4.93C7.94 12.07 7.31 13.52 7 15c.96-1.29 2.13-2.08 3.67-2.46l3.46 3.48H4v-10zm16 0v10.19l1.3 1.3c.42-.37.7-.89.7-1.49v-10a2 2 0 00-2-2H7.8l2 2H20zm-7.07 3.13l2.79 2.78 1.28-1.2L13 7v2.13l-.07.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwapCalls(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextsms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12zM7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnsubscribe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.99 14.04V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h10.05c.28 1.92 2.1 3.35 4.18 2.93 1.34-.27 2.43-1.37 2.7-2.71.25-1.24-.16-2.39-.94-3.18zm-2-9.04L12 8.5 5 5h13.99zm-3.64 10H5V7l7 3.5L19 7v6.05c-.16-.02-.33-.05-.5-.05-1.39 0-2.59.82-3.15 2zm5.15 2h-4v-1h4v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
                }
            }
        ]
    })(props);
}
function MdOutlineVpnKeyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.59 2.59A6.012 6.012 0 001 12c0 3.31 2.69 6 6 6 2.22 0 4.15-1.21 5.19-3l7.59 7.61 1.41-1.41L2.81 2.81zM7 16c-2.21 0-4-1.79-4-4 0-1.67 1.02-3.1 2.47-3.7l1.71 1.71C7.12 10 7.06 10 7 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2c0-.06 0-.12-.01-.18l1.74 1.74C10.22 14.48 9.14 16 7 16zm10-1.83V13h-1.17L17 14.17zM13.83 11H21v2h-2v3l2 2v-3h2V9H11.83l2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineVpnKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 19h-6v-4h-2.68c-1.14 2.42-3.6 4-6.32 4-3.86 0-7-3.14-7-7s3.14-7 7-7c2.72 0 5.17 1.58 6.32 4H24v6h-2v4zm-4-2h2v-4h2v-2H11.94l-.23-.67C11.01 8.34 9.11 7 7 7c-2.76 0-5 2.24-5 5s2.24 5 5 5c2.11 0 4.01-1.34 4.71-3.33l.23-.67H18v4zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiCalling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.51c-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1zM5.03 5h1.5a13 13 0 00.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.19-1.19c.85.24 1.72.39 2.6.45v1.49z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4.95C21.79 4.78 19.67 3 16.5 3c-3.18 0-5.29 1.78-5.5 1.95L16.5 12 22 4.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h8v2H8v-2zm12.1 1H22c0-2.76-2.24-5-5-5h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1zM3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM19 12h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAmpStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10V4H7v15zM9 6h6v11H9V6zM3 6h2v11H3zM19 6h2v11h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.81.97H5.44l.8-.97zM5 19V8h14v11H5zm8.45-9h-2.9v3H8l4 4 4-4h-2.55z"
                }
            }
        ]
    })(props);
}
function MdOutlineAttribution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.5c-.91 0-2.75.46-2.75 1.38v4.62h1.5V19h2.5v-4.5h1.5V9.88c0-.91-1.84-1.38-2.75-1.38zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14zm-11.59-2L14 13.41 17.59 17 19 15.59 15.41 12 19 8.41 17.59 7 14 10.59 10.41 7 9 8.41 12.59 12 9 15.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineBallot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5h5v2h-5zm0 7h5v2h-5zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM11 6H6v5h5V6zm-1 4H7V7h3v3zm1 3H6v5h5v-5zm-1 4H7v-3h3v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineBiotech(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19c-1.1 0-2 .9-2 2h14c0-1.1-.9-2-2-2h-4v-2h3c1.1 0 2-.9 2-2h-8c-1.66 0-3-1.34-3-3a3 3 0 011.47-2.57c.41.59 1.06 1 1.83 1.06.7.06 1.36-.19 1.85-.62l.59 1.61.94-.34.34.94 1.88-.68-.34-.94.94-.34-2.74-7.52-.94.34-.34-.94-1.88.68.34.94-.94.35.56 1.55c-1.17-.04-2.19.75-2.48 1.86A5.01 5.01 0 005 12c0 2.76 2.24 5 5 5v2H7zm5.86-14.48l1.71 4.7-.94.34-1.71-4.7.94-.34zM10.5 7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 014 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0120 12c0 4.42-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h-1l1-7H7.5c-.88 0-.33-.75-.31-.78C8.48 10.94 10.42 7.54 13.01 3h1l-1 7h3.51c.4 0 .62.19.4.66C12.97 17.55 11 21 11 21z"
                }
            }
        ]
    })(props);
}
function MdOutlineCalculate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.25 7.72h5v1.5h-5zM13 15.75h5v1.5h-5zM13 13.25h5v1.5h-5zM8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2zM14.09 10.95l1.41-1.41 1.41 1.41 1.06-1.06-1.41-1.42 1.41-1.41L16.91 6 15.5 7.41 14.09 6l-1.06 1.06 1.41 1.41-1.41 1.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineChangeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.17-5.24l-1.1-1.1c.71-1.33.53-3.01-.59-4.13A3.482 3.482 0 0012 8.5c-.03 0-.06.01-.09.01L13 9.6l-1.06 1.06-2.83-2.83L11.94 5 13 6.06l-.96.96c1.27.01 2.53.48 3.5 1.44 1.7 1.71 1.91 4.36.63 6.3zm-1.28 1.41L12.06 19 11 17.94l.95-.95a4.97 4.97 0 01-3.48-1.46 5.006 5.006 0 01-.64-6.29l1.1 1.1c-.71 1.33-.53 3.01.59 4.13.7.7 1.63 1.04 2.56 1.01L11 14.4l1.06-1.06 2.83 2.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineContentCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineContentCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineContentPasteGo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v6h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.01 13l-1.42 1.41 1.58 1.58H12v2h6.17l-1.58 1.59 1.42 1.41 3.99-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineContentPasteOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM5 19V7.83L16.17 19H5zM17 8V5h2v11.17l2 2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5.83l5 5H17zm-5-5c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineContentPasteSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.3 18.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S12 14 12 16.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l2.7 2.7 1.4-1.4-2.7-2.7zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineContentPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-4.18C14.4.84 13.3 0 12 0S9.6.84 9.18 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineCopyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H9V4h9v12zM3 15v-2h2v2H3zm0-5.5h2v2H3v-2zM10 20h2v2h-2v-2zm-7-1.5v-2h2v2H3zM5 22c-1.1 0-2-.9-2-2h2v2zm3.5 0h-2v-2h2v2zm5 0v-2h2c0 1.1-.9 2-2 2zM5 6v2H3c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCreate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeleteSweep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zm2-8h6v8H5v-8zm5-6H6L5 5H2v2h12V5h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeselect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13h2v-2H3v2zm4 8h2v-2H7v2zm6-18h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zm8 4h2v-2h-2v2zm8-8h2v-2h-2v2zm0-4h2V7h-2v2zm-4-4h2V3h-2v2zM7.83 5L7 4.17V3h2v2H7.83zm12 12l-.83-.83V15h2v2h-1.17zm1.36 4.19L2.81 2.81 1.39 4.22 4.17 7H3v2h2V7.83l2 2V17h7.17l2 2H15v2h2v-1.17l2.78 2.78 1.41-1.42zM9 15v-3.17L12.17 15H9zm6-2.83V9h-3.17l-2-2H17v7.17l-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDrafts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-2 0v.01L12 13 4 8l8-4.68L19.99 8zM4 18v-7.66l8 5.02 7.99-4.99L20 18H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDynamicFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 8H6v7c0 1.1.9 2 2 2h9v-2H8V8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-8V7h8v4zM4 12H2v7c0 1.1.9 2 2 2h9v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineFileCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterListOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 8H21V6H8.83l2 2zm5 5H18v-2h-4.17l2 2zM14 16.83V18h-4v-2h3.17l-3-3H6v-2h2.17l-3-3H3V6h.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41L14 16.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlagCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9l-1-2H8v11h1.5v-5H12l1 2h5V9h-3zm1.5 4.5h-2.57l-1-2H9.5v-3h3.57l1 2h2.43v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.36 6l.4 2H18v6h-3.36l-.4-2H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFontDownloadOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.83 2H20c1.1 0 2 .9 2 2v15.17l-2-2V4H6.83l-2-2zm6.09 4l-.57 1.52 1.36 1.36.23-.66h.1l.54 1.52 3.04 3.04L13.07 6h-2.15zm9.57 17.31L19.17 22H4c-1.1 0-2-.9-2-2V4.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM17.17 20l-5.07-5.07H9.58L8.49 18H6.41l2.39-6.37L4 6.83V20h13.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineFontDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 15.5h5.64l1.14 3h2.09l-5.11-13h-1.86l-5.11 13h2.09l1.12-3zM12 7.98l2.07 5.52H9.93L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8.83L17.17 12 14 15.17V14H6v-4h8V8.83M12 4v4H4v8h8v4l8-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineGesture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineHowToReg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM5 18c.2-.63 2.57-1.68 4.96-1.94l2.04-2a9.34 9.34 0 00-1-.06c-2.67 0-8 1.34-8 4v2h9l-2-2H5zm15.6-5.5l-5.13 5.17-2.07-2.08L12 17l3.47 3.5L22 13.91z"
                }
            }
        ]
    })(props);
}
function MdOutlineHowToVote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13h-.68l-2 2h1.91L19 17H5l1.78-2h2.05l-2-2H6l-3 3v4c0 1.1.89 2 1.99 2H19a2 2 0 002-2v-4l-3-3zm1 7H5v-1h14v1zm-7.66-4.98c.39.39 1.02.39 1.41 0l6.36-6.36a.996.996 0 000-1.41L14.16 2.3a.975.975 0 00-1.4-.01L6.39 8.66a.996.996 0 000 1.41l4.95 4.95zm2.12-10.61L17 7.95l-4.95 4.95-3.54-3.54 4.95-4.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5V5h14v9z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsights(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9l.94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93zM3.5 11L4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineInventory2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4h16v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12h6v2H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineInventory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 5h2v3h10V5h2v5h2V5c0-1.1-.9-2-2-2h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-2H5V5zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5L15.51 17l-3.01-3-1.5 1.5 4.51 4.5 6.99-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLinkOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.39 11L16 12.61V11zM17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4A4.986 4.986 0 0022 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z"
                }
            }
        ]
    })(props);
}
function MdOutlineLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineLowPriority(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5h8v2h-8V5zm0 5.5h8v2h-8v-2zm0 5.5h8v2h-8v-2zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 4.99L4 6h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineMarkunread(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoveToInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h-2.55V6h-2.9v3H8l4 4zm3-6H4.99C3.88 3 3 3.9 3 5v14c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-3h3.56c.69 1.19 1.97 2 3.45 2s2.75-.81 3.45-2H19v3zm0-5h-4.99c0 1.1-.9 2-2 2s-2-.9-2-2H5l-.01-9H19v9z"
                }
            }
        ]
    })(props);
}
function MdOutlineNextWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18.5l4-4-4-4-1 1 3 3-3 3zM20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm10 15H4V9h16v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutlinedFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-1-2H5v17h2v-7h5l1 2h7V6h-6zm4 8h-4l-1-2H7V6h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePolicy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm7 10c0 1.85-.51 3.65-1.38 5.21l-1.45-1.45a4.994 4.994 0 00-.64-6.29 5.003 5.003 0 00-7.07 0 5.003 5.003 0 000 7.07 5.006 5.006 0 006.29.64l1.72 1.72c-1.19 1.42-2.73 2.51-4.47 3.04-4.02-1.25-7-5.42-7-9.94V6.3l7-3.11 7 3.11V11zm-7 4c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePushPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4v5c0 1.12.37 2.16 1 3H9c.65-.86 1-1.9 1-3V4h4m3-2H7c-.55 0-1 .45-1 1s.45 1 1 1h1v5c0 1.66-1.34 3-3 3v2h5.97v7l1 1 1-1v-7H19v-2c-1.66 0-3-1.34-3-3V4h1c.55 0 1-.45 1-1s-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 017.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveCircleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 13H5v-2h14v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function MdOutlineReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                }
            }
        ]
    })(props);
}
function MdOutlineReportGmailerrorred(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineReportOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.1 5h5.8L19 9.1v5.8l-.22.22 1.42 1.41.8-.8V8.27L15.73 3H8.27l-.8.8 1.41 1.42z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 9.33V7h-2v.33zM2.41 1.58L1 2.99l3.64 3.64L3 8.27v7.46L8.27 21h7.46l1.64-1.64L21.01 23l1.41-1.41L2.41 1.58zM14.9 19H9.1L5 14.9V9.1l1.05-1.05 9.9 9.9L14.9 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineReport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1v5.8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "16",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7h2v7h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSaveAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineSaveAs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.4V7l-4-4H5a2 2 0 00-2 2v14a2 2 0 002 2h7.4l2-2H5V5h11.17L19 7.83v6.57l2-2zM15 15c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zM6 6h9v4H6V6zm13.99 10.25l1.77 1.77L16.77 23H15v-1.77l4.99-4.98zm3.26.26l-.85.85-1.77-1.77.85-.85c.2-.2.51-.2.71 0l1.06 1.06c.2.2.2.52 0 .71z"
                }
            }
        ]
    })(props);
}
function MdOutlineSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V7l-4-4zm2 16H5V5h11.17L19 7.83V19zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zM6 6h9v4H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSelectAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSquareFoot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 17.66l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L9.7 9.7l-1.06 1.06-.71-.71 1.06-1.06-1.94-1.94-1.06 1.06-.71-.71 1.06-1.06L4 4v14c0 1.1.9 2 2 2h14l-2.34-2.34zM7 17v-5.76L12.76 17H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineStackedBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM4 4h4v4H4zM10 7h4v4h-4zM16 10h4v4h-4zM16 15h4v5h-4zM10 12h4v8h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineStream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "20",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.943 8.619l4.404-4.392 1.413 1.416-4.405 4.392zM8.32 9.68l.31.32 1.42-1.41-4.02-4.04h-.01l-.31-.32-1.42 1.41 4.02 4.05zM15.41 13.94L14 15.35l3.99 4.01.35.35 1.42-1.41-3.99-4.01zM8.59 13.95l-4.03 4.01-.32.33 1.41 1.41 4.03-4.02.33-.32z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextFormat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnarchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM6.24 5h11.52l.83 1H5.42l.82-1zM5 19V8h14v11H5zm3-5h2.55v3h2.9v-3H16l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineUpcoming(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.6 10.81L16.19 9.4l3.56-3.55 1.41 1.41c-.11.03-3.56 3.55-3.56 3.55zM13 3h-2v5h2V3zm-6.6 7.81L7.81 9.4 4.26 5.84 2.84 7.26c.11.03 3.56 3.55 3.56 3.55zM20 14h-3.42c-.77 1.76-2.54 3-4.58 3s-3.81-1.24-4.58-3H4v5h16v-5m0-2c1.1 0 2 .9 2 2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-5c0-1.1.9-2 2-2h5c0 1.66 1.34 3 3 3s3-1.34 3-3h5z"
                }
            }
        ]
    })(props);
}
function MdOutlineWaves(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16.99c-1.35 0-2.2.42-2.95.8-.65.33-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.95c1.35 0 2.2-.42 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.42 2.95-.8c.65-.33 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm0-4.45c-1.35 0-2.2.43-2.95.8-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.32-1.17.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.35 1.15-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.58.8 2.95.8v-1.95c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8zm2.95-8.08c-.75-.38-1.58-.8-2.95-.8s-2.2.42-2.95.8c-.65.32-1.18.6-2.05.6-.9 0-1.4-.25-2.05-.6-.75-.37-1.57-.8-2.95-.8s-2.2.42-2.95.8c-.65.33-1.17.6-2.05.6v1.93c1.35 0 2.2-.43 2.95-.8.65-.33 1.17-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V5.04c-.9 0-1.4-.25-2.05-.58zM17 8.09c-1.35 0-2.2.43-2.95.8-.65.35-1.15.6-2.05.6s-1.4-.25-2.05-.6c-.75-.38-1.57-.8-2.95-.8s-2.2.43-2.95.8c-.65.35-1.15.6-2.05.6v1.95c1.35 0 2.2-.43 2.95-.8.65-.32 1.18-.6 2.05-.6s1.4.25 2.05.6c.75.38 1.57.8 2.95.8s2.2-.43 2.95-.8c.65-.32 1.18-.6 2.05-.6.9 0 1.4.25 2.05.6.75.38 1.58.8 2.95.8V9.49c-.9 0-1.4-.25-2.05-.6-.75-.38-1.6-.8-2.95-.8z"
                }
            }
        ]
    })(props);
}
function MdOutlineWebStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4v16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM13 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h9v16zM21 6v12c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineWeekend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3h18c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM5 7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H6v-2c0-.88-.39-1.67-1-2.22V7zm17 10c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h16v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineWhereToVote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C7.59 1 4 4.59 4 9c0 5.57 6.96 13.34 7.26 13.67l.74.82.74-.82C13.04 22.34 20 14.57 20 9c0-4.41-3.59-8-8-8zm0 19.47C9.82 17.86 6 12.54 6 9c0-3.31 2.69-6 6-6s6 2.69 6 6c0 3.83-4.25 9.36-6 11.47zm-1.53-9.3L8.71 9.4l-1.42 1.42L10.47 14l6.01-6.01-1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdOutline1XMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7h4v10H6V9H4V7zm11.83 4.72L18.66 7h-2.33l-1.66 2.77L13 7h-2.33l2.83 4.72L10.33 17h2.33l2-3.34 2 3.34H19l-3.17-5.28z"
                }
            }
        ]
    })(props);
}
function MdOutline30Fps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 5v3h6v2.5H3v3h5V16H2v3h6c1.66 0 3-1.34 3-3v-1.9A2.1 2.1 0 008.9 12 2.1 2.1 0 0011 9.9V8c0-1.66-1.34-3-3-3H2zm17 3v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutline3GMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7v2h5v2H4v2h4v2H3v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9c0-1.1-.9-2-2-2H3zm18 4v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h5c1.1 0 2 .9 2 2h-7v6h5v-2h-2.5v-2H21z"
                }
            }
        ]
    })(props);
}
function MdOutline4GMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7H7v5H5V7H3v7h4v3h2v-3h2v-2H9V7zm8 4v2h2v2h-5V9h7c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function MdOutline4GPlusMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11v2h2v2h-4V9h6c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4h-4zm11 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2zM7 7H5v5H3V7H1v7h4v3h2v-3h1v-2H7V7z"
                }
            }
        ]
    })(props);
}
function MdOutline60Fps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8v8h-4V8h4m0-3h-4c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zm-9 3V5H5C3.34 5 2 6.34 2 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3v-3c0-1.66-1.34-3-3-3H5V8h5zm-2 5v3H5v-3h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessAlarms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessTimeFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm3.3 14.71L11 12.41V7h2v4.59l3.71 3.71-1.42 1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccessTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineAdUnits(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7 4V3h10v1H7zm0 14V6h10v12H7zm0 3v-1h10v1H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7H8v2h8V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddAlarm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 000-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddToHomeScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
                }
            }
        ]
    })(props);
}
function MdOutlineAir(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3h2c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1H2v-2h9.5c1.65 0 3 1.35 3 3zM19 6.5C19 4.57 17.43 3 15.5 3S12 4.57 12 6.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S16.33 8 15.5 8H2v2h13.5c1.93 0 3.5-1.57 3.5-3.5zm-.5 4.5H2v2h16.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5v2c1.93 0 3.5-1.57 3.5-3.5S20.43 11 18.5 11z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirplaneTicket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.19 4H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.81-2-1.81-2zM20 18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v12zM8.87 15.66l-1.66-2.88.93-.25 1.26.99 2.39-.64-2.4-4.16 1.4-.38 4.01 3.74 2.44-.65a.967.967 0 011.18.68.988.988 0 01-.69 1.19l-8.86 2.36z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirplanemodeActive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirplanemodeInactive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 7.67V3.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V9l8.5 5v2l-4.49-1.32-7.01-7.01zm9.28 14.94l1.41-1.41-7.69-7.7-3.94-3.94-6.75-6.75-1.42 1.41 6.38 6.38L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-2.67l6.28 6.28z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdOutlineAod(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zm-9 6h8v1.5H8V10zm1 3h6v1.5H9V13z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v14h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v12h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v10h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v8h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v6h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery5Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v4h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBattery6Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v16c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1h2V2h4v2h2c.55 0 1 .45 1 1zm-2 1H9v2h6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatteryAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatteryChargingFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatterySaver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2V2h-4v2H8c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10h-2v2h-2v-2H9v-2h2v-2h2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatteryStd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBatteryUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm1.3-5.31s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94A1.498 1.498 0 0012 9.5c-.83 0-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
                }
            }
        ]
    })(props);
}
function MdOutlineBloodtype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6v2H9zM13 9h-2v2H9v2h2v2h2v-2h2v-2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm0 18c-3.35 0-6-2.57-6-6.2 0-2.34 1.95-5.44 6-9.14 4.05 3.7 6 6.79 6 9.14 0 3.63-2.65 6.2-6 6.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBluetoothConnected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBluetoothDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineBluetoothDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17H4v-5h11v-2H4.81l1.04-3H15V5H5.5c-.66 0-1.21.42-1.42 1.01L2 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8h-2v5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3.85L19.15 1h-.5v3.79l-2.3-2.29-.7.7L18.44 6l-2.79 2.79.7.71 2.3-2.3V11h.5L22 8.14 19.85 6 22 3.85zm-2.35-.94l.94.94-.94.94V2.91zm.94 5.23l-.94.94V7.2l.94.94z"
                }
            }
        ]
    })(props);
}
function MdOutlineBluetoothSearching(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightnessAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L13 7h-2zm-.15 5.65L12 9l1.15 3.65h-2.3zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightnessHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightnessLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightnessMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6v12c3.31 0 6-2.69 6-6s-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1h-1v4c0 .55.45 1 1 1h1v7c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-2.21-1.79-4-4-4S5 4.79 5 7v7H4c-.55 0-1 .45-1 1v4h1v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h1v-4c0-.55-.45-1-1-1H7V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 2.21 1.79 4 4 4s4-1.79 4-4v-7h1c.55 0 1-.45 1-1V5h-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraswitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7h-1l-1-1h-4L9 7H8c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H8V9h1.83l1-1h2.34l1 1H16v6z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.57.52L13.05 5l1.41-1.41-1.54-1.54C17.7 2.46 21.53 6.24 22 11h2C23.36 3.3 15.79-1.67 8.57.52zM9.54 20.41l1.54 1.54C6.3 21.54 2.47 17.76 2 13H0c.64 7.7 8.21 12.67 15.43 10.48L10.95 19l-1.41 1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineCreditScore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h5v-2H4v-6h18V6c0-1.11-.89-2-2-2zm0 4H4V6h16v2zm-5.07 11.17l-2.83-2.83-1.41 1.41L14.93 22 22 14.93l-1.41-1.41-5.66 5.65z"
                }
            }
        ]
    })(props);
}
function MdOutlineDarkMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.37 5.51A7.35 7.35 0 009.1 7.5c0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27A7.014 7.014 0 0112 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49zM12 3a9 9 0 109 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 01-4.4 2.26 5.403 5.403 0 01-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataSaverOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataSaverOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8v3H8v2h3v3h2v-3h3v-2h-3V8h-2zm2-5.95v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataUsage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53A6.95 6.95 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineDatasetLinked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17h1.09c.28-1.67 1.24-3.1 2.6-4H7v4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 19V5h14v7h1c.34 0 .67.04 1 .09V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h3.81c-.35-.61-.6-1.28-.72-2H5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zM13 7h4v4h-4zM16 20h-2c-1.1 0-2-.9-2-2s.9-2 2-2h2v-2h-2c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2zM20 14h-2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2v2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19v-2h-6v2h5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 13h4v4H7zM13 13h4v4h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7h4v4H7zM13 7h4v4h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeveloperMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeviceThermostat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-2V5c0-.55.45-1 1-1s1 .45 1 1v1h-1v1h1v2h-1v1h1v1h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDevicesFold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3h-3c0-1.44-1.47-2.4-2.79-1.84l-3 1.29C10.48 2.76 10 3.49 10 4.29V19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 13.68l-3 1.29V4.29L15 3v13.68zM20 19h-5.33l1.12-.48c.73-.32 1.21-1.04 1.21-1.84V5h3v14zM2 3h2v2H2zM2 19h2v2H2zM2 15h2v2H2zM2 11h2v2H2zM2 7h2v2H2zM6 3h2v2H6zM6 19h2v2H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineDevices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function MdOutlineDiscount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.79 21L3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.79 21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.38 17.41c.39.39.9.59 1.41.59.51 0 1.02-.2 1.41-.59l6.21-6.21c.78-.78.78-2.05 0-2.83L12.62.58C12.25.21 11.74 0 11.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41l7.79 7.79zM5 2h6.21L19 9.79 12.79 16 5 8.21V2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.25",
                    "cy": "4.25",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotDisturbOnTotalSilence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.6-6-6-6zm3 7H9v-2h6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDvr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineEMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9V7H8v10h8v-2h-6v-2h6v-2h-6V9h6z"
                }
            }
        ]
    })(props);
}
function MdOutlineEdgesensorHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 7h2v7H3V7zm-3 3h2v7H0v-7zm22-3h2v7h-2V7zm-3 3h2v7h-2v-7zm-3-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 20H8v-1h8v1zm0-3H8V7h8v10zM8 5V4h8v1H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineEdgesensorLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 7h2v7H2V7zm18 3h2v7h-2v-7zm-4-7.99L8 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-1.99-2-1.99zM16 20H8v-1h8v1zm0-3H8V7h8v10zM8 5V4h8v1H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlashlightOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22 8 10.83V22h8v-3.17l3.78 3.78 1.41-1.41L2.81 2.81zM14 20h-4v-7.17l4 4V20zM16 4v1H7.83l2 2H16v.39l-2 3.01v.77l2 2V11l2-3V2H6v1.17l.83.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlashlightOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6v6l2 3v11h8V11l2-3V2zm-2 2v1H8V4h8zm-2 6.4V20h-4v-9.61l-2-3V7h8v.39l-2 3.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineFlourescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14V9H5v6zm2-4h10v2H7v-2zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function MdOutlineFluorescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14V9H5v6zm2-4h10v2H7v-2zM11 2h2v3h-2zM17.286 6.399l1.79-1.803 1.42 1.41-1.79 1.802zM11 19h2v3h-2zM17.29 17.71l1.79 1.8 1.42-1.42-1.8-1.79zM3.495 6.01l1.407-1.408L6.69 6.391 5.284 7.798zM3.492 18.076l1.803-1.79 1.409 1.42-1.803 1.79z"
                }
            }
        ]
    })(props);
}
function MdOutlineFmdBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8C20 5.22 16.2 2 12 2zm0 17.33c-4.05-3.7-6-6.79-6-9.14C6 6.57 8.65 4 12 4s6 2.57 6 6.2c0 2.34-1.95 5.44-6 9.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6h2v5h-2zM11 13h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFmdGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11v2h2v2H9V9h7c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-4h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineGppBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7zM9.91 8.5L8.5 9.91 10.59 12 8.5 14.09l1.41 1.41L12 13.42l2.09 2.08 1.41-1.41L13.42 12l2.08-2.09-1.41-1.41L12 10.59 9.91 8.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineGppGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83V6.31l6-2.12 6 2.12v4.78zm-9.18-.5L7.4 12l3.54 3.54 5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineGppMaybe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14h2v2h-2zM11 7h2v5h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGpsFixed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineGpsNotFixed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineGpsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53a6.995 6.995 0 018.87 8.87l1.53 1.53c.4-.86.67-1.79.78-2.77H23v-2h-2.06zM3 4.27l2.04 2.04A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86 3 4.27zm13.27 13.27a6.995 6.995 0 01-9.81-9.81l9.81 9.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineGraphicEq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGrid3X3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineGrid4X4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7V5h-3V2h-2v3h-4V2h-2v3H7V2H5v3H2v2h3v4H2v2h3v4H2v2h3v3h2v-3h4v3h2v-3h4v3h2v-3h3v-2h-3v-4h3v-2h-3V7h3zM7 7h4v4H7V7zm0 10v-4h4v4H7zm10 0h-4v-4h4v4zm0-6h-4V7h4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineGridGoldenratio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9h-7V2h-2v7h-2V2H9v7H2v2h7v2H2v2h7v7h2v-7h2v7h2v-7h7v-2h-7v-2h7zm-9 2h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHPlusMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11H6V7H4v10h2v-4h6v4h2V7h-2v4zm10 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrAutoSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zM3.5 18h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5zM22 18.5v-2h-1.5v2h-2V20h2v2H22v-2h2v-1.5zM16.5 16H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1zM11.97 5.3l-1.02 2.89h2.1L12.03 5.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm2.04 9l-.63-1.79h-2.83L9.96 11H8.74l2.63-7h1.25l2.63 7h-1.21z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.99-14L6.88 17h1.9l1-2.81h4.44l.99 2.81h1.9L12.98 6h-1.97zm-.66 6.59l1.6-4.55h.09l1.6 4.55h-3.29z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrOffSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM10.98 4.15L9.42 2.59c5.1-2.42 10.41 2.89 7.99 7.99l-1.56-1.56c.81-2.96-1.91-5.68-4.87-4.87zM6.34 2.34L4.93 3.76l1.66 1.66c-2.42 5.1 2.89 10.41 7.99 7.99l1.66 1.66 1.41-1.41L6.34 2.34zm1.81 4.64l4.87 4.87c-2.96.81-5.68-1.91-4.87-4.87z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrOnSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 18.5v-1c0-.8-.7-1.5-1.5-1.5H13v6h1.5v-2h1.1l.9 2H18l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2v-2H0v6h1.5v-2.5h2V22H5v-6H3.5v2zm6.5-2H6.5v6H10c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5H8v-3h2v3zm14-.5h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zM12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4m0-2C8.69 2 6 4.69 6 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineLan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3v7zM10 7V4h4v3h-4zM9 17v3H5v-3h4zm10 0v3h-4v-3h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineLensBlur(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLightMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37a.996.996 0 00-1.41 0 .996.996 0 000 1.41l1.06 1.06c.39.39 1.03.39 1.41 0a.996.996 0 000-1.41l-1.06-1.06zm1.06-10.96a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36a.996.996 0 000-1.41.996.996 0 00-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocationDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 13v-2h-2.06A8.994 8.994 0 0013 3.06V1h-2v2.06c-.98.11-1.91.38-2.77.78l1.53 1.53a6.995 6.995 0 018.87 8.87l1.53 1.53c.4-.86.67-1.79.78-2.77H23zM4.41 2.86L3 4.27l2.04 2.04A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21l1.41-1.41L4.41 2.86zM12 19A6.995 6.995 0 016.46 7.73l9.81 9.81A6.972 6.972 0 0112 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocationSearching(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLteMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14h3v2H4V8h2v6zm3-4h2v6h2v-6h2V8H9v2zm12 0V8h-5v8h5v-2h-3v-1h3v-2h-3v-1h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLtePlusMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14h3v2H1V8h2v6zm2-4h2v6h2v-6h2V8H5v2zm7 6h5v-2h-3v-1h3v-2h-3v-1h3V8h-5v8zm12-5h-2V9h-2v2h-2v2h2v2h2v-2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMacroOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66 4.93c.24 0 .46.07.64.2l.81.56c-.29.24-.54.54-.72.87l1.66 1.66C11.03 8.14 11 8.08 11 8c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1c-.08 0-.14-.03-.22-.04l4.06 4.06a3.13 3.13 0 002.63-3.09c0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93a3.145 3.145 0 00-3.57-3.11C14.44 1.81 13.31 1 12 1s-2.44.81-2.91 1.96a3.132 3.132 0 00-2.52.78l1.42 1.42c.2-.13.42-.23.67-.23zm6.68 6.14c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zM19.98 17.15A8.909 8.909 0 0021 13c-1.5 0-2.91.37-4.15 1.02l3.13 3.13zM3 13a9 9 0 009 9 9 9 0 00-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12a7.04 7.04 0 01-4.12-4.12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l4.42 4.42c-.19.4-.3.84-.3 1.29a3.147 3.147 0 003.58 3.11A3.15 3.15 0 0012 15c.05 0 .11-.01.16-.01l1.64 1.64A8.853 8.853 0 0012 22c2.02 0 3.88-.67 5.38-1.8l2.4 2.4 1.41-1.41L2.81 2.81zm11.63 16.75c.2-.54.47-1.04.79-1.5l.72.72c-.47.31-.97.58-1.51.78z"
                }
            }
        ]
    })(props);
}
function MdOutlineMediaBluetoothOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 6.17V3h6v4h-4v1.17l-2-2zM19.42 15L22 17.57l-.8.8-6.78-6.78.8-.8 2.75 2.75V9h.6L22 12.43 19.42 15zm-.25-1.45l1.13-1.13-1.13-1.13v2.26zm2.02 7.64l-1.41 1.41-3.98-3.98-.58.58-.85-.85.58-.58L11 13.83V17c0 2.21-1.78 4-3.99 4S3 19.21 3 17s1.79-4 4.01-4c.73 0 1.41.21 2 .55v-1.72L1.39 4.22 2.8 2.81l18.39 18.38z"
                }
            }
        ]
    })(props);
}
function MdOutlineMediaBluetoothOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 3l.01 10.55c-.6-.34-1.28-.55-2-.55a4.001 4.001 0 100 8C9.23 21 11 19.21 11 17V7h4V3H9zm12 9.43L17.57 9h-.6v4.55l-2.75-2.75-.85.85L16.73 15l-3.35 3.35.85.85 2.75-2.75V21h.6L21 17.57 18.42 15 21 12.43zm-2.83-1.13l1.13 1.13-1.13 1.13V11.3zm1.13 6.27l-1.13 1.13v-2.26l1.13 1.13z"
                }
            }
        ]
    })(props);
}
function MdOutlineMedicationLiquid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3h12v2H3zM2 21h14V6H2v15zm3-9h2.5V9.5h3V12H13v3h-2.5v2.5h-3V15H5v-3zM20 6c-1.68 0-3 1.76-3 4 0 1.77.83 3.22 2 3.76V21h2v-7.24c1.17-.54 2-1.99 2-3.76 0-2.24-1.32-4-3-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMedication(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 15H8v-3h2.5V9.5h3V12H16v3h-2.5v2.5h-3V15zM19 8v11c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2zm-2 0H7v11h10V8zm1-5H6v2h12V3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMobileFriendly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z"
                }
            }
        ]
    })(props);
}
function MdOutlineMobileOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5v8.61l2 2V3c0-1.1-.9-2-2-2H7c-.71 0-1.33.37-1.68.93L8.39 5H17zM1.49 3.76L5 7.27V21c0 1.1.9 2 2 2h10c1.02 0 1.85-.77 1.98-1.75l1.72 1.72 1.41-1.41L2.9 2.35 1.49 3.76zM7 9.27L16.73 19H7V9.27z"
                }
            }
        ]
    })(props);
}
function MdOutlineMobiledataOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6.82l1.59 1.59L19 7l-4-4-4 4 1.41 1.41L14 6.82v4.35l2 2zM1.39 4.22L8 10.83v6.35l-1.59-1.59L5 17l4 4 4-4-1.41-1.41L10 17.18v-4.35l9.78 9.78 1.41-1.42L2.81 2.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeNight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07 1.91-2.16 3.01-4.98 3.01-7.93s-1.1-5.77-3.01-7.93C8.82 4.02 9.16 4 9.5 4m0-2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65c1.47.85 3.18 1.35 5 1.35 5.52 0 10-4.48 10-10S15.02 2 9.5 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeStandby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMonitorHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v3h2V6h16v3h2V6c0-1.1-.9-2-2-2zM20 18H4v-3H2v3c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3h-2v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.89 7.55c-.34-.68-1.45-.68-1.79 0L10 13.76l-1.11-2.21A.988.988 0 008 11H2v2h5.38l1.72 3.45c.18.34.52.55.9.55s.72-.21.89-.55L14 10.24l1.11 2.21c.17.34.51.55.89.55h6v-2h-5.38l-1.73-3.45z"
                }
            }
        ]
    })(props);
}
function MdOutlineMonitorWeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM12 6c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-1 3.5h-1v-1h1v1zm1.5 0h-1v-1h1v1zm1.5 0h-1v-1h1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineNearbyError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.57l4.42 4.42L12 16.41l-4.42-4.42L12 7.57zm0 11.62l-7.2-7.2 7.2-7.2 6 6V7.16l-4.58-4.58c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L18 16.82v-3.63l-6 6zm8 .81h2v2h-2v-2zm2-10h-2v8h2v-8"
                }
            }
        ]
    })(props);
}
function MdOutlineNearbyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 13.42L18.83 16l-1.81-1.81L19.2 12 12 4.8 9.81 6.99 8 5.17l2.58-2.58c.78-.78 2.05-.78 2.83 0l8 8c.79.78.79 2.04 0 2.83zm-.22 7.77l-1.41 1.41L16 18.83l-2.58 2.58c-.78.78-2.05.78-2.83 0l-8-8c-.78-.78-.78-2.05 0-2.83L5.17 8 1.39 4.22 2.8 2.81l18.39 18.38zm-7-4.17l-1.39-1.39-.8.8L7.58 12l.8-.8-1.4-1.39L4.8 12l7.2 7.2 2.19-2.18zM16.42 12L12 7.58l-.8.8 4.42 4.42.8-.8z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22zm18-2h-3V9.83l3-3V20z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkWifi1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm3.32 10.84C14.34 14.3 13.2 14 12 14c-1.2 0-2.34.3-3.32.84L2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-5.76 5.77z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkWifi2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm4.78 9.38A8.853 8.853 0 0012 12c-1.76 0-3.4.5-4.78 1.38l-4.3-4.3C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-4.3 4.31z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkWifi3Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-2.85 2.86A10.945 10.945 0 0012 10c-2.31 0-4.46.71-6.23 1.93L2.92 9.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zm0 4c-2.86 0-5.5.94-7.65 2.51L2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-1.43 1.43A12.99 12.99 0 0012 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineNfc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineNightlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4c.34 0 .68.02 1.01.07C13.1 6.23 12 9.05 12 12s1.1 5.77 3.01 7.93c-.33.05-.67.07-1.01.07-4.41 0-8-3.59-8-8s3.59-8 8-8m0-2C8.48 2 4 6.48 4 12s4.48 10 10 10c1.82 0 3.53-.5 5-1.35-2.99-1.73-5-4.95-5-8.65s2.01-6.92 5-8.65A9.973 9.973 0 0014 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoteAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.08 11.03l-2.12-2.12L7 14.86V17h2.1zM16.85 9.27c.2-.2.2-.51 0-.71l-1.41-1.41c-.2-.2-.51-.2-.71 0l-1.06 1.06 2.12 2.12 1.06-1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlinePassword(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zm6.7-.75l1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7l-.85 1.48zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23v-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePattern(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm2 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-.02 6c-.74 0-1.37.4-1.72 1h-2.54a1.98 1.98 0 00-3.44 0H8.41l3.07-3.07c.17.04.34.07.52.07 1.1 0 2-.9 2-2 0-.18-.03-.35-.07-.51l3.56-3.56c.16.04.33.07.51.07 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2c0 .18.03.35.07.51l-3.56 3.56c-.16-.04-.33-.07-.51-.07-1.1 0-2 .9-2 2 0 .18.03.35.07.51l-3.56 3.56C6.35 16.03 6.18 16 6 16c-1.1 0-2 .9-2 2s.9 2 2 2c.74 0 1.37-.4 1.72-1h2.57a1.98 1.98 0 003.44 0h2.55c.34.6.98 1 1.72 1 1.1 0 2-.9 2-2-.02-1.1-.92-2-2.02-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhishing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6.18V2h-2v4.18C13.84 6.6 13 7.7 13 9s.84 2.4 2 2.82V15c0 2.21-1.79 4-4 4s-4-1.79-4-4v-1.17l1.59 1.59L10 14 5 9v6c0 3.31 2.69 6 6 6s6-2.69 6-6v-3.18c1.16-.41 2-1.51 2-2.82s-.84-2.4-2-2.82zM16 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.49 10.5V15h1.15V9h-.87l-1.76 1.27.58.89zM11.47 10.05c.5 0 .81.32.81.72 0 .37-.14.64-.54 1.06-.36.38-1.06 1.08-2.13 2.15V15h3.89v-.99h-2.37l-.03-.05c.68-.68 1.15-1.14 1.4-1.39.61-.6.92-1.22.92-1.86 0-.24-.05-1.04-.91-1.48-.47-.23-1.26-.36-1.95-.03-.82.39-.99 1.13-1 1.15l1.01.42c.1-.33.38-.72.9-.72zM16.99 13.94c-.83 0-.99-.76-1.02-.86l-1.03.41c.45 1.59 2.01 1.51 2.05 1.51 1.2 0 1.68-.72 1.76-.85.32-.49.36-1.24-.01-1.76-.17-.24-.4-.41-.68-.52v-.07c.2-.1.37-.26.52-.48.26-.41.31-1.07-.02-1.57-.08-.11-.53-.75-1.62-.75-1.26 0-1.74.9-1.85 1.24l.99.41c.11-.32.35-.64.85-.64.44 0 .75.26.75.65 0 .58-.55.72-.88.72h-.46v1h.5c.56 0 1.04.24 1.04.79 0 .49-.48.77-.89.77z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlayLesson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20V4h2v7l2.5-1.5L12 11V4h5v7.08c.33-.05.66-.08 1-.08s.67.03 1 .08V4c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h7.26c-.42-.6-.75-1.28-.97-2H5zm13-7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm-1.25 7.5v-5l4 2.5-4 2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePriceChange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1H8v-1h4V8h-2V7H8v1H7c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H6v2h2v1zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12zm-6-8l2-2 2 2m0 4.25l-2 2-2-2"
                }
            }
        ]
    })(props);
}
function MdOutlinePriceCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13V9c0-.55-.45-1-1-1H6V6h5V4H8.5V3h-2v1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4v2H4v2h2.5v1h2v-1H10c.55 0 1-.45 1-1zM19.59 12.52l-5.66 5.65-2.83-2.83-1.41 1.42L13.93 21 21 13.93z"
                }
            }
        ]
    })(props);
}
function MdOutlinePunchClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-1V1H6v5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 3h8v3H8V3zm11 17H5V8h14v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.5h-1v2.71l1.64 1.64.71-.71-1.35-1.35z"
                }
            }
        ]
    })(props);
}
function MdOutlineQuiz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-6.49-5.84c.41-.73 1.18-1.16 1.63-1.8.48-.68.21-1.94-1.14-1.94-.88 0-1.32.67-1.5 1.23l-1.37-.57C11.51 5.96 12.52 5 13.99 5c1.23 0 2.08.56 2.51 1.26.37.6.58 1.73.01 2.57-.63.93-1.23 1.21-1.56 1.81-.13.24-.18.4-.18 1.18h-1.52c.01-.41-.06-1.08.26-1.66zm-.56 3.79c0-.59.47-1.04 1.05-1.04.59 0 1.04.45 1.04 1.04 0 .58-.44 1.05-1.04 1.05-.58 0-1.05-.47-1.05-1.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineRMobiledata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.8 7.2L9 10H7L5.87 7.33H4V10H2V2h5c1.13 0 2 .87 2 2v1.33c0 .8-.53 1.54-1.2 1.87zM7 4H4v1.33h3V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRadar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.74 18.33A9.984 9.984 0 0022 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10a9.984 9.984 0 007.11-2.97c.03-.03.05-.06.07-.08.2-.2.39-.41.56-.62zM12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8c0 1.85-.63 3.54-1.69 4.9l-1.43-1.43c.69-.98 1.1-2.17 1.1-3.46 0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6c1.3 0 2.51-.42 3.49-1.13l1.42 1.42A7.822 7.822 0 0112 20zm1.92-7.49c.17-.66.02-1.38-.49-1.9l-.02-.02c-.77-.77-2-.78-2.78-.04-.01.01-.03.02-.05.04-.78.78-.78 2.05 0 2.83l.02.02c.52.51 1.25.67 1.91.49l1.51 1.51c-.6.36-1.29.58-2.04.58-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4c0 .73-.21 1.41-.56 2l-1.5-1.51z"
                }
            }
        ]
    })(props);
}
function MdOutlineRememberMe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 20H7v-1h10v1zm0-3H7v-.48c1.47-.99 3.22-1.52 5-1.52s3.53.53 5 1.52V18zm0-2.79c-1.5-.77-3.2-1.21-5-1.21s-3.5.44-5 1.21V6h10v9.21zM17 4H7V3h10v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineResetTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 8V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v2h8v-2h4c1.1 0 1.99-.9 1.99-2v-5H22c0-1.1-.9-2-2-2h-7.17l1.83-1.83-1.41-1.41C9.69 10.31 10.88 9.12 9 11l4.24 4.24 1.41-1.41L12.83 12H20v5H4V5h16v3h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRestartAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c0-1.65.67-3.15 1.76-4.24L6.34 7.34A8.014 8.014 0 004 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91zm14 0c0-4.42-3.58-8-8-8-.06 0-.12.01-.18.01l1.09-1.09L11.5 2.5 8 6l3.5 3.5 1.41-1.41-1.08-1.08c.06 0 .12-.01.17-.01 3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93z"
                }
            }
        ]
    })(props);
}
function MdOutlineReviews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15l1.57-3.43L17 10l-3.43-1.57L12 5l-1.57 3.43L7 10l3.43 1.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineRsvp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9h1.5l-1.75 6h-1.5L12.5 9H14l1 3.43L16 9zM5.1 12.9L6 15H4.5l-.85-2H2.5v2H1V9h3.5c.85 0 1.5.65 1.5 1.5v1c0 .6-.4 1.15-.9 1.4zm-.6-2.4h-2v1h2v-1zm17 2.5h-2v2H18V9h3.5c.83 0 1.5.67 1.5 1.5v1c0 .83-.67 1.5-1.5 1.5zm0-2.5h-2v1h2v-1zM11.5 9v1.5h-3v.75h2c.55 0 1 .45 1 1V14c0 .55-.45 1-1 1H7v-1.5h3v-.75H7.75c-.41 0-.75-.34-.75-.75v-2c0-.55.45-1 1-1h3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenLockLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenLockPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1a2 2 0 10-4 0v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenLockRotation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.3 13.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L3.56 9.17l5.66-5.66 2.1 2.1 1.41-1.41-2.45-2.45a1.49 1.49 0 00-2.12 0L1.8 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM7.52 21.48A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.82-1.33 1.33zM15.05 10h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1v-.5a2.5 2.5 0 00-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4h-3.4v-.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenRotation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77a1.49 1.49 0 00-2.12 0L1.75 8.11a1.49 1.49 0 000 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenSearchDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 18h16c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2zM4 5h16v11H4V5zM1 19h22v2H1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.97 7.53c-1.37-1.37-3.58-1.37-4.95 0s-1.37 3.58 0 4.95c1.18 1.18 3 1.34 4.36.47l2.09 2.09 1.06-1.06-2.09-2.09c.87-1.36.72-3.18-.47-4.36zm-1.06 3.88c-.78.78-2.05.78-2.83 0-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0c.78.79.78 2.05 0 2.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenshotMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h4v2h8v-2h4c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 14H4V5h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 7.5H9V6H5v4h1.5zM19 12h-1.5v2.5H15V16h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenshot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zM9.5 8.5H12V7H8v4h1.5V8.5zM12 17h4v-4h-1.5v2.5H12V17z"
                }
            }
        ]
    })(props);
}
function MdOutlineSdStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v16H6V8.83L10.83 4H18m0-2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSecurityUpdateGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zm-1 6.05l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineSecurityUpdateWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSecurityUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7zm9 8l-4 4-4-4 1.41-1.41L11 12.17V8h2v4.17l1.59-1.59L16 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineSell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.41l-8.83-8.83c-.37-.37-.88-.58-1.41-.58H4c-1.1 0-2 .9-2 2v7.17c0 .53.21 1.04.59 1.41l8.83 8.83c.78.78 2.05.78 2.83 0l7.17-7.17c.78-.78.78-2.04-.01-2.83zM12.83 20L4 11.17V4h7.17L20 12.83 12.83 20z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineSendToMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8l4 4-4 4-1.41-1.41L18.17 13H13v-2h5.17l-1.59-1.59L18 8zM7 1.01L17 1c1.1 0 2 .9 2 2v4h-2V6H7v12h10v-1h2v4c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-1.99 2-1.99zM7 21h10v-1H7v1zM7 4h10V3H7v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsSuggest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm8.5-2l1.09-2.41L22 5.5l-2.41-1.09L18.5 2l-1.09 2.41L15 5.5l2.41 1.09L18.5 9zm2.78 3.72L20.5 11l-.78 1.72-1.72.78 1.72.78.78 1.72.78-1.72L23 13.5l-1.72-.78zM16.25 14c0-.12 0-.25-.01-.37l1.94-1.47-2.5-4.33-2.24.94c-.2-.13-.42-.26-.64-.37L12.5 6h-5l-.3 2.41c-.22.11-.43.24-.64.37l-2.24-.95-2.5 4.33 1.94 1.47c-.01.12-.01.25-.01.37s0 .25.01.37l-1.94 1.47 2.5 4.33 2.24-.94c.2.13.42.26.64.37l.3 2.4h5l.3-2.41c.22-.11.43-.23.64-.37l2.24.94 2.5-4.33-1.94-1.47c.01-.11.01-.24.01-.36zm-1.42 3.64l-1.73-.73c-.56.6-1.3 1.04-2.13 1.23L10.73 20H9.27l-.23-1.86c-.83-.19-1.57-.63-2.13-1.23l-1.73.73-.73-1.27 1.49-1.13c-.12-.39-.18-.8-.18-1.23 0-.43.06-.84.18-1.23l-1.49-1.13.73-1.27 1.73.73c.56-.6 1.3-1.04 2.13-1.23L9.27 8h1.47l.23 1.86c.83.19 1.57.63 2.13 1.23l1.73-.73.73 1.27-1.49 1.13c.12.39.18.8.18 1.23 0 .43-.06.84-.18 1.23l1.49 1.13-.73 1.29z"
                }
            }
        ]
    })(props);
}
function MdOutlineSettingsSystemDaydream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 17H9c-2.21 0-4-1.79-4-4a3.98 3.98 0 013.22-3.92A4.514 4.514 0 0112 7c1.95 0 3.66 1.28 4.26 3.09 1.58.36 2.74 1.75 2.74 3.41 0 1.93-1.57 3.5-3.5 3.5zm-6.76-5.98C7.74 11.15 7 11.99 7 13c0 1.1.9 2 2 2h6.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.87l-.17-.86A2.496 2.496 0 0012 9c-.96 0-1.84.57-2.26 1.45l-.27.57h-.73zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineShareLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.02 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.42-1.43a7.941 7.941 0 01-3.9 1.62zM4.03 12c0-4.05 3.03-7.41 6.95-7.93V2.05C5.95 2.58 2.03 6.84 2.03 12c0 5.16 3.92 9.42 8.95 9.95v-2.02c-3.92-.52-6.95-3.88-6.95-7.93zM19.95 11h2.02c-.2-2.01-1-3.84-2.21-5.32l-1.43 1.43c.86 1.1 1.44 2.43 1.62 3.89zM18.34 4.26a9.981 9.981 0 00-5.32-2.21v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM18.33 16.9l1.43 1.42A9.949 9.949 0 0021.97 13h-2.02a7.941 7.941 0 01-1.62 3.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11.1C16 8.61 14.1 7 12 7s-4 1.61-4 4.1c0 1.66 1.33 3.63 4 5.9 2.67-2.27 4-4.24 4-5.9zm-4 .9a1.071 1.071 0 010-2.14A1.071 1.071 0 0112 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineShortcut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5l-1.41 1.41L15 7.83 17.17 10H8c-2.76 0-5 2.24-5 5v4h2v-4c0-1.65 1.35-3 3-3h9.17L15 14.17l-1.41 1.41L15 17l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellular0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22zm18-2H6.83L20 6.83V20z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellular4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22h20V2L2 22z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularAlt1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularAlt2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 14h3v6H5v-6zm6-5h3v11h-3V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularConnectedNoInternet0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zm-2-2v2H2L22 2v6h-2V6.83L6.83 20H18z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularConnectedNoInternet4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularNoSim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.83 5H17v9.11l2 2V5c0-1.1-.9-2-2-2h-7L7.94 5.06l1.42 1.42L10.83 5zm10.43 16.21L3.79 3.74 2.38 5.15 5 7.77V19a2 2 0 002 2h11.23l1.62 1.62 1.41-1.41zM7 19V9.79L16.23 19H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularNodata(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13h-9v9H2L22 2v11zm-1 2.41L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularNull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalCellularOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1l-8.31 8.31 8.31 8.3zM4.91 4.36L3.5 5.77l6.36 6.37L1 21h17.73l2 2 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifi0Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifi4BarLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifi4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifiBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09-.3-.3L15.41 14 14 15.41l1.79 1.79.3.3L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifiConnectedNoInternet4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21v-9h8.99L24 8.98zM19.59 14l-2.09 2.09-.3-.3L15.41 14 14 15.41l1.79 1.79.3.3L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09L21 15.41 19.59 14z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.64 7c-.45-.34-4.93-4-11.64-4-1.32 0-2.55.14-3.69.38L18.43 13.5 23.64 7zM3.41 1.31L2 2.72l2.05 2.05C1.91 5.76.59 6.82.36 7L12 21.5l3.91-4.87 3.32 3.32 1.41-1.41L3.41 1.31z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifiStatusbar4Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifiStatusbarConnectedNoInternet4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4zM19 18h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignalWifiStatusbarNull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0012 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSimCardDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13l-4 4-4-4 1.41-1.41L11 13.17V9.02L13 9v4.17l1.59-1.59L16 13z"
                }
            }
        ]
    })(props);
}
function MdOutlineSplitscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v5H6V4h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 13v5H6v-5h12m0-2H6c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsScore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6H9V4h2v2zm4-2h-2v2h2V4zM9 14h2v-2H9v2zm10-4V8h-2v2h2zm0 4v-2h-2v2h2zm-6 0h2v-2h-2v2zm6-10h-2v2h2V4zm-6 4V6h-2v2h2zm-6 2V8h2V6H7V4H5v16h2v-8h2v-2H7zm8 2h2v-2h-2v2zm-4-2v2h2v-2h-2zM9 8v2h2V8H9zm4 2h2V8h-2v2zm2-4v2h2V6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSsidChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5.47L12 12 7.62 7.62 3 11V8.52L7.83 5l4.38 4.38L21 3v2.47zM21 15h-4.7l-4.17 3.34L6 12.41l-3 2.13V17l2.8-2 6.2 6 5-4h4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStorage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.93 8C16.72 4.18 11.82 2.87 8 5.07c-1.41.82-2.48 2-3.16 3.37-.13-2.2.22-4.4 1.02-6.44H3.74C2.2 6.49 2.52 11.58 5.07 16a7.96 7.96 0 004.86 3.72c1.98.53 4.16.31 6.07-.79 1.41-.82 2.48-2 3.16-3.37.13 2.2-.21 4.4-1.01 6.44h2.11c1.53-4.49 1.22-9.58-1.33-14zM15 17.2A6.012 6.012 0 016.8 15c-.11-.2-.21-.4-.3-.6-1.2-2.76-.17-6.06 2.5-7.6 2.86-1.65 6.54-.67 8.2 2.2.11.2.21.4.3.6 1.2 2.76.17 6.06-2.5 7.6zM12 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineSummarize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V9l-6-6zM5 19V5h9v5h5v9H5zM9 8c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm0 4c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm0 4c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSystemSecurityUpdateGood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1zm-1 6.05l-1.41-1.41-3.54 3.54-1.41-1.41-1.41 1.41L11.05 15 16 10.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineSystemSecurityUpdateWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 7h2v6h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zm0-14H7V3h10v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSystemSecurityUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 21H7v-1h10v1zm0-3H7V6h10v12zM7 4V3h10v1H7zm9 8l-4 4-4-4 1.41-1.41L11 12.17V8h2v4.17l1.59-1.59L16 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineTask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zm-9.18-6.95L7.4 14.46 10.94 18l5.66-5.66-1.41-1.41-4.24 4.24-2.13-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineThermostat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13V5c0-1.66-1.34-3-3-3S9 3.34 9 5v8c-1.21.91-2 2.37-2 4 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.09-2-4zm-4-8c0-.55.45-1 1-1s1 .45 1 1h-1v1h1v2h-1v1h1v2h-2V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimer10Select(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8v8h-3V8h3m0-3h-3C8.34 5 7 6.34 7 8v8c0 1.66 1.34 3 3 3h3c1.66 0 3-1.34 3-3V8c0-1.66-1.34-3-3-3zM1 8h2v11h3V5H1v3zm17.5 3c-.83 0-1.5.68-1.5 1.5v2c0 .82.67 1.5 1.5 1.5H21v1h-4v2h4.5c.83 0 1.5-.67 1.5-1.5v-2c0-.83-.67-1.5-1.5-1.5H19v-1h4v-2h-4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimer3Select(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11v2h-4v1h2.5c.83 0 1.5.68 1.5 1.5v2c0 .83-.67 1.5-1.5 1.5H15v-2h4v-1h-2.5c-.82 0-1.5-.68-1.5-1.5v-2c0-.82.68-1.5 1.5-1.5H21zM4 5v3h6v2.5H4v3h6V16H4v3h6c1.66 0 3-1.34 3-3v-1.9a2.1 2.1 0 00-2.1-2.1A2.1 2.1 0 0013 9.9V8c0-1.66-1.34-3-3-3H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTungsten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 19h2v3h-2zM2 11h3v2H2zM19 11h3v2h-3zM15.894 17.801l1.407-1.407 2.122 2.122-1.408 1.407zM4.584 18.509l2.121-2.122 1.408 1.407-2.122 2.122zM15 8.02V3H9v5.02c-1.21.92-2 2.35-2 3.98 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.06-2-3.98zM11 5h2v2.1c-.32-.06-.66-.1-1-.1s-.68.04-1 .1V5zm1 10c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineUsbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8h4v4h-1v2c0 .34-.08.66-.23.94L16 13.17V12h-1V8zm-4 .17l2 2V6h2l-3-4-3 4h2v2.17zM13 16v2.28c.6.34 1 .98 1 1.72 0 1.1-.9 2-2 2s-2-.9-2-2c0-.74.4-1.37 1-1.72V16H8c-1.11 0-2-.89-2-2v-2.28c-.6-.34-1-.98-1-1.72 0-.59.26-1.13.68-1.49L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-6.6-6.6H13zm-2-2v-.17l-2.51-2.51c-.14.16-.31.29-.49.4V14h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2S4.8 7.79 4.8 9c0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95a2.2 2.2 0 004.4 0c0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWallpaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 14H22h-.02zM5.35 13c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1zm13.32 2c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.19 0 1.42 1 3.33 1 1.94 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM5.35 9c1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1V8c-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1C3.38 7 3.24 8 2 8v2c1.9 0 2.17-1 3.35-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineWidgets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.66 4.52l2.83 2.83-2.83 2.83-2.83-2.83 2.83-2.83M9 5v4H5V5h4m10 10v4h-4v-4h4M9 15v4H5v-4h4m7.66-13.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65zM11 3H3v8h8V3zm10 10h-8v8h8v-8zm-10 0H3v8h8v-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifi1Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.53 17.46L12 21l-3.53-3.54c.9-.9 2.15-1.46 3.53-1.46s2.63.56 3.53 1.46z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifi2Bar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c3.03 0 5.78 1.23 7.76 3.22l-2.12 2.12A7.967 7.967 0 0012 13c-2.2 0-4.2.9-5.64 2.35l-2.12-2.12C6.22 11.23 8.97 10 12 10zm0 6c-1.38 0-2.63.56-3.53 1.46L12 21l3.53-3.54A4.98 4.98 0 0012 16z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiCalling3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 4.5c1.79 0 3.42.73 4.59 1.91l1.06-1.06A7.94 7.94 0 0016.49 3c-2.21 0-4.21.9-5.66 2.34l1.06 1.06a6.545 6.545 0 014.6-1.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 6c-1.38 0-2.63.56-3.54 1.46l1.06 1.06c.63-.63 1.51-1.03 2.47-1.03s1.84.39 2.47 1.03l1.06-1.06A4.94 4.94 0 0016.49 6zM16.49 9c-.55 0-1.05.22-1.41.59L16.49 11l1.41-1.41c-.36-.37-.86-.59-1.41-.59z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiChannel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3c-2.51 0-3.77 5.61-4.4 10.57C10.79 10.66 9.61 8 8 8 4.43 8 3 21 3 21h2.01c.61-5.27 2-9.82 2.99-10.87.98 1.05 2.38 5.61 2.99 10.87H13c.5-2.53 2-6 3-6s2.5 3.53 3 6h2s-.5-18-5-18zm0 10c-.99 0-1.82.62-2.5 1.5.57-4.77 1.54-8.62 2.5-9.44.97.81 1.91 4.67 2.49 9.43C17.81 13.62 16.98 13 16 13z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiFind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c4.14 0 7.88 1.68 10.59 4.39L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98L12 21l1.41-1.42L2.93 9.08C5.45 7.16 8.59 6 12 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-2.24-1.76-4-4-4s-4 1.76-4 4 1.76 4 4 4c.75 0 1.44-.21 2.03-.56L21.59 20 23 18.59l-2.56-2.56c.35-.59.56-1.28.56-2.03zm-4 2c-1.12 0-2-.88-2-2s.88-2 2-2 2 .88 2 2-.88 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.98 11L24 8.98A16.88 16.88 0 0012 4C7.31 4 3.07 5.9 0 8.98l6.35 6.36L12 21l3.05-3.05V15c0-.45.09-.88.23-1.29.54-1.57 2.01-2.71 3.77-2.71h2.93z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiPassword(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 8.98l-2.12 2.13C19.35 8.57 15.85 7 12 7s-7.35 1.57-9.88 4.11L0 8.98C3.07 5.9 7.31 4 12 4s8.93 1.9 12 4.98zM4.24 13.22l2.12 2.12A7.967 7.967 0 0112 13c2.2 0 4.2.9 5.64 2.35l2.12-2.12C17.78 11.23 15.03 10 12 10c-3.03 0-5.78 1.23-7.76 3.22zM24 20v3c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1v-1c0-1.1.9-2 2-2s2 .9 2 2v1c.55 0 1 .45 1 1zm-2-2c0-.55-.45-1-1-1s-1 .45-1 1v1h2v-1zm-10-2c-1.38 0-2.63.56-3.53 1.46L12 21l3.53-3.54A4.98 4.98 0 0012 16z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiTetheringErrorRounded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiTetheringError(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-3.31 0-6 2.69-6 6 0 1.66.68 3.15 1.76 4.24l1.42-1.42A3.934 3.934 0 018 13c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.11-.45 2.1-1.18 2.82l1.42 1.42A6.003 6.003 0 0018 13c0-3.31-2.69-6-6-6zm0-4C6.48 3 2 7.48 2 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42A7.94 7.94 0 014 13c0-4.42 3.58-8 8-8 2.53 0 4.78 1.17 6.24 3h2.42C18.93 5.01 15.7 3 12 3zm0 8c-1.1 0-2 .9-2 2 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59s1.05-.23 1.41-.59c.36-.36.59-.86.59-1.41 0-1.1-.9-2-2-2zm8-1h2v6h-2v-6zm0 8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiTetheringOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.69 2.69A9.958 9.958 0 002 13c0 2.76 1.12 5.26 2.93 7.07l1.42-1.42a7.957 7.957 0 01-.84-10.31l1.43 1.43a6.003 6.003 0 00.82 7.47l1.42-1.42A3.934 3.934 0 018 13c0-.63.15-1.23.41-1.76l1.61 1.61c0 .05-.02.1-.02.15 0 .55.23 1.05.59 1.41.36.36.86.59 1.41.59.05 0 .1-.01.16-.02l7.62 7.62 1.41-1.41L2.81 2.81zM17.7 14.87c.19-.59.3-1.22.3-1.87 0-3.31-2.69-6-6-6-.65 0-1.28.1-1.87.3l1.71 1.71C11.89 9 11.95 9 12 9c2.21 0 4 1.79 4 4 0 .05 0 .11-.01.16l1.71 1.71zM12 5c4.42 0 8 3.58 8 8 0 1.22-.27 2.37-.77 3.4l1.49 1.49A9.953 9.953 0 0022 13c0-5.52-4.48-10-10-10-1.78 0-3.44.46-4.89 1.28l1.48 1.48C9.63 5.27 10.78 5 12 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiTethering(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19H5V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 13h2v4h-2zM7 10h2v7H7zM11 7h2v10h-2zM19 5V3h-2v2h-2v2h2v2h2V7h2V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-2 13.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlignHorizontalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2h2v5h8v3h-8v4h5v3h-5v5h-2v-5H6v-3h5v-4H3V7h8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlignHorizontalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlignHorizontalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2h2v20h-2V2zM2 10h16V7H2v3zm6 7h10v-3H8v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlignVerticalBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlignVerticalCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-5V6h-3v5h-4V3H7v8H1.84v2H7v8h3v-8h4v5h3v-5h5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAlignVerticalTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineAreaChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7l-5-4-5 7-4-3v13h18V7h-4zm2 9.95l-7-5.45L8 17l-3-2.4V11l2.44 1.83 4.96-6.95L16.3 9H19v7.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineAttachFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5a2.5 2.5 0 015 0v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5a2.5 2.5 0 005 0V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAttachMoney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoGraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.94L12 9l2.06-.94L15 6l.94 2.06L18 9l-2.06.94L15 12l-.94-2.06zM4 14l.94-2.06L7 11l-2.06-.94L4 8l-.94 2.06L1 11l2.06.94L4 14zm4.5-5l1.09-2.41L12 5.5 9.59 4.41 8.5 2 7.41 4.41 5 5.5l2.41 1.09L8.5 9zm-4 11.5l6-6.01 4 4L23 8.93l-1.41-1.41-7.09 7.97-4-4L3 19l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h4v11H4zM16 13h4v7h-4zM10 4h4v16h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderColor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.81 8.94l-3.75-3.75L4 14.25V18h3.75l9.06-9.06zM6 16v-.92l7.06-7.06.92.92L6.92 16H6zM19.71 6.04a.996.996 0 000-1.41l-2.34-2.34a1.001 1.001 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zM2 20h20v4H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBorderVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBubbleChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm8.01-1c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM16.5 3C13.47 3 11 5.47 11 8.5s2.47 5.5 5.5 5.5S22 11.53 22 8.5 19.53 3 16.5 3zm0 9c-1.93 0-3.5-1.57-3.5-3.5S14.57 5 16.5 5 20 6.57 20 8.5 18.43 12 16.5 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCandlestickChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4H7v2H5v12h2v2h2v-2h2V6H9V4zm0 12H7V8h2v8zM19 8h-2V4h-2v4h-2v7h2v5h2v-5h2V8zm-2 5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineChecklistRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 7H2v2h9V7zm0 8H2v2h9v-2zm5.34-4L12.8 7.46l1.41-1.41 2.12 2.12 4.24-4.24L22 5.34 16.34 11zm0 8l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L22 13.34 16.34 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineChecklist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-9v2h9V7zm0 8h-9v2h9v-2zM5.54 11L2 7.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 11zm0 8L2 15.46l1.41-1.41 2.12 2.12 4.24-4.24 1.41 1.41L5.54 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataArray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 4v2h3v12h-3v2h5V4zM4 20h5v-2H6V6h3V4H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDataObject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7zM21 10c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83v.34c-1.16.41-2 1.52-2 2.83v2c0 .55-.45 1-1 1h-3v2h3c1.65 0 3-1.35 3-3v-2c0-.55.45-1 1-1h1v-4h-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDragHandle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDraw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.85 10.39l1.06-1.06c.78-.78.78-2.05 0-2.83L18.5 5.09c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24zm-4.24 1.42L7.41 19H6v-1.41l7.19-7.19 1.42 1.41zm-1.42-4.25L4 16.76V21h4.24l9.19-9.19-4.24-4.25zM19 17.5c0 2.19-2.54 3.5-5 3.5-.55 0-1-.45-1-1s.45-1 1-1c1.54 0 3-.73 3-1.5 0-.47-.48-.87-1.23-1.2l1.48-1.48c1.07.63 1.75 1.47 1.75 2.68zM4.58 13.35C3.61 12.79 3 12.06 3 11c0-1.8 1.89-2.63 3.56-3.36C7.59 7.18 9 6.56 9 6c0-.41-.78-1-2-1-1.26 0-1.8.61-1.83.64-.35.41-.98.46-1.4.12a.992.992 0 01-.15-1.38C3.73 4.24 4.76 3 7 3s4 1.32 4 3c0 1.87-1.93 2.72-3.64 3.47C6.42 9.88 5 10.5 5 11c0 .31.43.6 1.07.86l-1.49 1.49z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 10h11v2H3v-2zm0-2h11V6H3v2zm0 8h7v-2H3v2zm15.01-3.13l.71-.71a.996.996 0 011.41 0l.71.71c.39.39.39 1.02 0 1.41l-.71.71-2.12-2.12zm-.71.71l-5.3 5.3V21h2.12l5.3-5.3-2.12-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8V5H6.39l3 3h1.83l-.55 1.28 2.09 2.1L14.21 8zM3.41 4.86L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21l1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatColorFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15a1.49 1.49 0 000 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5zM2 20h20v4H2v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatColorReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.36c1.53 2 3.08 4.43 3.71 6.24l2.23 2.23c.03-.27.06-.55.06-.83 0-3.98-6-10.8-6-10.8s-1.18 1.35-2.5 3.19l1.44 1.44c.34-.51.7-1 1.06-1.47zM5.41 5.14L4 6.55l3.32 3.32C6.55 11.33 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.95-1.5l2.63 2.63L20 19.72 5.41 5.14zM12 18c-2.21 0-4-1.79-4-4 0-.69.32-1.62.81-2.64l5.72 5.72c-.7.56-1.57.92-2.53.92z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatColorText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 20h20v4H2v-4zm3.49-3h2.42l1.27-3.58h5.65L16.09 17h2.42L13.25 3h-2.5L5.49 17zm4.42-5.61l2.03-5.79h.12l2.03 5.79H9.91z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatIndentDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatIndentIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4h-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatLineSpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatListBulleted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatListNumberedRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 17h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1zm1-9h1V4h-2v1h1v3zm-1 3h1.8L18 13.1v.9h3v-1h-1.8l1.8-2.1V10h-3v1zM2 5h14v2H2V5zm0 12h14v2H2v-2zm0-6h14v2H2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatListNumbered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatPaint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3zm-2 2H6V4h10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.62 18h-5.24l2-4H13V6h8v7.24L18.62 18zm-2-2h.76L19 12.76V8h-4v4h3.62l-2 4zm-8 2H3.38l2-4H3V6h8v7.24L8.62 18zm-2-2h.76L9 12.76V8H5v4h3.62l-2 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatTextdirectionLToR(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2H9C6.79 2 5 3.79 5 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zm0 12v3H5v2h12v3l4-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatTextdirectionRToL(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4v4c-1.1 0-2-.9-2-2s.9-2 2-2m8-2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4v5h2V4h2v11h2V4h2V2zM8 14l-4 4 4 4v-3h12v-2H8v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatUnderlined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFunctions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.99h3L12 3 8 6.99h3v10.02H8L12 21l4-3.99h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHexagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.2 3H6.8l-5.2 9 5.2 9h10.4l5.2-9-5.2-9zm-1.15 16h-8.1l-4.04-7 4.04-7h8.09l4.04 7-4.03 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 14l3 3v5h6v-5l3-3V9H6v5zm2-3h8v2.17l-3 3V20h-2v-3.83l-3-3V11zm3-9h2v3h-2zM3.502 5.874L4.916 4.46l2.122 2.12-1.414 1.415zm13.458.708l2.123-2.12 1.413 1.416-2.123 2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineHorizontalDistribute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 22H2V2h2v20zM22 2h-2v20h2V2zm-8.5 5h-3v10h3V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineHorizontalRule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M4 11h16v2H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertChartOutlined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2 2H5V5h14v14zm0-16H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v13.17L18.83 16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 10H6v2h12v-2zm0-3H6v2h12V9zm0-3H6v2h12V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertDriveFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertEmoticon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertInvitation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-2 5h-5v5h5v-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertPageBreak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2v3zM6 4h7v5h5v2h2V8l-6-6H6c-1.1 0-2 .9-2 2v7h2V4zM9 13h6v2H9zM17 13h6v2h-6zM1 13h6v2H1z"
                }
            }
        ]
    })(props);
}
function MdOutlineInsertPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
                }
            }
        ]
    })(props);
}
function MdOutlineLineAxis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.43l-1.41-1.41-4.03 4.53L9.5 4 2 11.51l1.5 1.5 6.14-6.15 5.59 5.18-1.73 1.95-4-4L2 17.5 3.5 19l6-6.01 4 4 3.19-3.59 3.9 3.61L22 15.6l-3.98-3.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLinearScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5a2.5 2.5 0 000 5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5a2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMargin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14zM11 7h2v2h-2V7zM7 7h2v2H7V7zm8 0h2v2h-2V7zm-8 4h2v2H7v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMergeType(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.17L18.83 16H4V4h16v13.17zM20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeEditOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h3.75L17.81 9.94l-3.75-3.75L3 17.25V21zm2-2.92l9.06-9.06.92.92L5.92 19H5v-.92zM18.37 3.29a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 21h3.75L17.81 9.94l-3.75-3.75L3 17.25V21zm2-2.92l9.06-9.06.92.92L5.92 19H5v-.92zM18.37 3.29a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineMonetizationOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoneyOffCsred(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoneyOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.39.08-.75.21-1.1.36l1.51 1.51c.32-.08.69-.13 1.09-.13zM5.47 3.92L4.06 5.33 7.5 8.77c0 2.08 1.56 3.22 3.91 3.91l3.51 3.51c-.34.49-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.83-.55 2.46-1.12l2.22 2.22 1.41-1.41L5.47 3.92z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoveDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 11c0 2.45 1.76 4.47 4.08 4.91l-1.49-1.49L7 13l4 4.01L7 21l-1.41-1.41 1.58-1.58v-.06A7.007 7.007 0 011 11c0-3.87 3.13-7 7-7h3v2H8c-2.76 0-5 2.24-5 5zM22 11V4h-9v7h9zm-2-2h-5V6h5v3zM13 13h9v7h-9z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoveUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 13c0-2.45 1.76-4.47 4.08-4.91l-1.49 1.5L7 11l4-4.01L7 3 5.59 4.41l1.58 1.58v.06A7.007 7.007 0 001 13c0 3.87 3.13 7 7 7h3v-2H8c-2.76 0-5-2.24-5-5zM13 13v7h9v-7h-9zm7 5h-5v-3h5v3zM13 4h9v7h-9z"
                }
            }
        ]
    })(props);
}
function MdOutlineMultilineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.01L3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineNumbers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10l.5-2h-4l1-4h-2l-1 4h-4l1-4h-2L9 8H5l-.5 2h4l-1 4h-4L3 16h4l-1 4h2l1-4h4l-1 4h2l1-4h4l.5-2h-4l1-4h4zm-7 4h-4l1-4h4l-1 4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePadding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 14H5V5h14v14zM11 7h2v2h-2V7zM7 7h2v2H7V7zm8 0h2v2h-2V7z"
                }
            }
        ]
    })(props);
}
function MdOutlinePentagon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.63 9.78L16.56 19H7.44L4.37 9.78 12 4.44l7.63 5.34zM2 9l4 12h12l4-12-10-7L2 9z"
                }
            }
        ]
    })(props);
}
function MdOutlinePieChartOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function MdOutlinePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9H13V4.07c3.61.45 6.48 3.32 6.93 6.93zM4 12c0-4.07 3.06-7.44 7-7.93v15.86c-3.94-.49-7-3.86-7-7.93zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
                }
            }
        ]
    })(props);
}
function MdOutlinePolyline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16v1.26l-6-3v-3.17L11.7 8H16V2h-6v4.9L7.3 10H3v6h5l7 3.5V22h6v-6h-6zM12 4h2v2h-2V4zM7 14H5v-2h2v2zm12 6h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePostAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z"
                }
            }
        ]
    })(props);
}
function MdOutlinePublish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h14v2H5zm0 10h4v6h6v-6h4l-7-7-7 7zm8-2v6h-2v-6H9.83L12 9.83 14.17 12H13z"
                }
            }
        ]
    })(props);
}
function MdOutlineQueryStats(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58l-3.12-3.11zm-3.8.11a2.5 2.5 0 010-5 2.5 2.5 0 010 5zm-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6l2.72 4.08zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18l-4.69 7.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRectangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm18 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineScatterPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-2c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm5.6 17.6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSchema(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9v2h-3V9H8.5V7H11V1H4v6h2.5v2H4v6h2.5v2H4v6h7v-6H8.5v-2H11v-2h3v2h7V9h-7zM6 3h3v2H6V3zm3 18H6v-2h3v2zm0-8H6v-2h3v2zm10 0h-3v-2h3v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineScore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5l4-4 4 4 6-6v6zm0-8.5l-6 6-4-4-4 4V5h14v5.5zM13.5 9V6H12v6h1.5zm3.7 3l-2-3 2-3h-1.7l-2 3 2 3zM11 10.5H8.5v-.75H11V6H7v1.5h2.5v.75H7V12h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineShapeLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11c2.76 0 5-2.24 5-5S8.76 1 6 1 1 3.24 1 6s2.24 5 5 5zm0-8c1.65 0 3 1.35 3 3S7.65 9 6 9 3 7.65 3 6s1.35-3 3-3zM21 14h-5c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h5c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm0 7h-5v-5h5v5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.71 7.7c.4.19.83.3 1.29.3 1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3c0 .46.11.89.3 1.29L6.29 16.3c-.4-.19-.83-.3-1.29-.3-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3c0-.46-.11-.89-.3-1.29L17.71 7.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineShortText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h16v2H4V9zm0 4h10v2H4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineShowChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpaceBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v4H6V9H4v6h16V9h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v18h18V3H3zm16 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineStackedLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19.99l7.5-7.51 4 4 7.09-7.97L22 9.92l-8.5 9.56-4-4-6 6.01-1.5-1.5zm1.5-4.5l6-6.01 4 4L22 3.92l-1.41-1.41-7.09 7.97-4-4L2 13.99l1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineStrikethroughS(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29a5.73 5.73 0 011.7-.83c.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43s.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13s-.53.21-.72.36c-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51s.35.36.43.57c.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75s-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58s.37.85.65 1.21c.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21V12z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18h-2v1h3v1h-4v-2c0-.55.45-1 1-1h2v-1h-3v-1h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 18h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 4h-2.68l-3.07 4.99h-.12L8.85 4H6.19l4.32 6.73L5.88 18z"
                }
            }
        ]
    })(props);
}
function MdOutlineSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7h-2v1h3v1h-4V7c0-.55.45-1 1-1h2V5h-3V4h3c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1zM5.88 20h2.66l3.4-5.42h.12l3.4 5.42h2.66l-4.65-7.27L17.81 6h-2.68l-3.07 4.99h-.12L8.85 6H6.19l4.32 6.73L5.88 20z"
                }
            }
        ]
    })(props);
}
function MdOutlineTableChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h15zm-5 14h-5v-9h5v9zM5 10h3v9H5v-9zm12 9v-9h3v9h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTableRows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H5V5h14zm0 5v4H5v-4h14zM5 19v-3h14v3H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextDecrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM23 11v2h-8v-2h8z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextFields(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextIncrease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M.99 19h2.42l1.27-3.58h5.65L11.59 19h2.42L8.75 5h-2.5L.99 19zm4.42-5.61L7.44 7.6h.12l2.03 5.79H5.41zM20 11h3v2h-3v3h-2v-3h-3v-2h3V8h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTitle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4v3h5.5v12h3V7H19V4H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTypeSpecimen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.19 12.2h3.63l.8 2.3h1.56l-3.38-9h-1.6l-3.38 9h1.56l.81-2.3zm1.77-5.03h.08l1.31 3.72h-2.69l1.3-3.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalDistribute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 2v2H2V2h20zM7 10.5v3h10v-3H7zM2 20v2h20v-2H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWrapText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineApproval(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 16v6h16v-6c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2zm14 2H6v-2h12v2zM12 2C9.24 2 7 4.24 7 7l5 7 5-7c0-2.76-2.24-5-5-5zm0 9L9 7c0-1.66 1.34-3 3-3s3 1.34 3 3l-3 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAttachEmail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6l8 5 8-5v3h2V4c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2L1 16c0 1.1.9 2 2 2h10v-2H3V6zm16-2l-8 5-8-5h16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14v4c0 1.1-.9 2-2 2s-2-.9-2-2v-4.5c0-.28.22-.5.5-.5s.5.22.5.5V18h2v-4.5a2.5 2.5 0 00-5 0V18c0 2.21 1.79 4 4 4s4-1.79 4-4v-4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAttachment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 16H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h12.5a2.5 2.5 0 010 5H9c-.55 0-1-.45-1-1s.45-1 1-1h9.5V9.5H9a2.5 2.5 0 000 5h10.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H7c-3.04 0-5.5 2.46-5.5 5.5s2.46 5.5 5.5 5.5h11.5V16z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.29-9.81a4.373 4.373 0 00-8.17-1.16A3.483 3.483 0 005 12.5C5 14.43 6.57 16 8.5 16h7.58c1.61 0 2.92-1.31 2.92-2.92 0-1.54-1.2-2.79-2.71-2.89zM16 14H8.5c-.83 0-1.5-.67-1.5-1.5S7.67 11 8.5 11h.9l.49-1.05a2.377 2.377 0 014.44.63l.28 1.42H16c.55 0 1 .45 1 1s-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zm-9-3.82l-2.09-2.09L6.5 13.5 10 17l6.01-6.01-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zm-5.55-8h-2.9v3H8l4 4 4-4h-2.55z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 15c0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0012 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19a2.996 2.996 0 011.79 5.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81zM4.41 3.86L3 5.27l2.77 2.77h-.42A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h11.73l2 2 1.41-1.41L4.41 3.86zM6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudQueue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 14.98c-.02 0-.03 0-.05.01A3.49 3.49 0 0018 12c-1.4 0-2.6.83-3.16 2.02A2.988 2.988 0 0012 17c0 1.66 1.34 3 3 3l6.5-.02a2.5 2.5 0 000-5zm.01 3.02H15c-.55 0-1-.45-1-1s.45-1 1-1h1.25v-.25c0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75V17h1.76c.28 0 .5.22.5.5-.01.27-.23.5-.5.5zM10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 6h-2.73a7.98 7.98 0 012.66 5h-2.02c-.23-1.36-.93-2.55-1.91-3.44V10h-2V4h6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11A2.98 2.98 0 0122 15c0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.469 5.469 0 0112 6m0-2C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96A7.49 7.49 0 0012 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCreateNewFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-8-4h2v2h2v-2h2v-2h-2v-2h-2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDifference(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 23H4c-1.1 0-2-.9-2-2V7h2v14h14v2zM14.5 7V5h-2v2h-2v2h2v2h2V9h2V7h-2zm2 6h-6v2h6v-2zM15 1H8c-1.1 0-1.99.9-1.99 2L6 17c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V7l-6-6zm4 16H8V3h6.17L19 7.83V17z"
                }
            }
        ]
    })(props);
}
function MdOutlineDownloadDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 18h14v2H5v-2zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2-9.4 9.3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDownloadForOffline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2.59-11.41L16 10l-4 4-4-4 1.41-1.41L11 10.17V6h2v4.17l1.59-1.58zM17 17H7v-2h10v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDownloading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 4.26A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zm-1.62 5.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm2.59-9.34L13 13.17V7h-2v6.17l-2.59-2.59L7 12l5 5 5-5-1.41-1.41zM11 19.93v2.02c-5.05-.5-9-4.76-9-9.95s3.95-9.45 9-9.95v2.02C7.05 4.56 4 7.92 4 12s3.05 7.44 7 7.93z"
                }
            }
        ]
    })(props);
}
function MdOutlineDriveFileMoveRtl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.59-2.41L12 17l-4-4 4-4 1.41 1.41L11.83 12H16v2h-4.17l1.58 1.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineDriveFileMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l1.41 1.41.59.59H20v10zm-7.84-6H8v2h4.16l-1.59 1.59L11.99 17 16 13.01 11.99 9l-1.41 1.41L12.16 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineDriveFileRenameOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16l-4 4h10v-4zM12.06 7.19L3 16.25V20h3.75l9.06-9.06-3.75-3.75zM5.92 18H5v-.92l7.06-7.06.92.92L5.92 18zM18.71 8.04a.996.996 0 000-1.41l-2.34-2.34a1.001 1.001 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineDriveFolderUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zM9.41 14.42L11 12.84V17h2v-4.16l1.59 1.59L16 13.01 12.01 9 8 13.01l1.41 1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineFileDownloadDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.13 5.41L18.72 4l-9.19 9.19-4.25-4.24-1.41 1.41 5.66 5.66zM5 18h14v2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFileDownloadOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15.17V15h2v2.17l-2-2zm-2.59-2.58L17 11l-1.41-1.41L14 11.17l1.41 1.42zM13 10.17V4h-2v4.17l2 2zm8.19 11.02l-1.78-1.78-16.6-16.6-1.42 1.41 6.19 6.19L7 11l5 5 .59-.59L15.17 18H6v-3H4v3c0 1.1.9 2 2 2h11.17l2.61 2.61 1.41-1.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineFileDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4l-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFileOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 22H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h8l6 6v6h-2V9h-5V4H6v16h9v2zm4-.34v-2.24l2.95 2.95 1.41-1.41L20.41 18h2.24v-2H17v5.66h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFileUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5-5 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 19h17v2H3c-1.1 0-2-.9-2-2V6h2v13zM23 6v9c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2l.01-11c0-1.1.89-2 1.99-2h5l2 2h7c1.1 0 2 .9 2 2zM7 15h14V6h-7.83l-2-2H7v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 10V9h-2v1H12v1.5h1v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4h1V10h-2.5zm0 5.5h-2v-4h2v4zM20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H7.17l4 4H20v9.17l1.76 1.76c.15-.28.24-.59.24-.93V8c0-1.1-.9-2-2-2zM2.1 2.1L.69 3.51l1.56 1.56c-.15.28-.24.59-.24.93L2 18c0 1.1.9 2 2 2h13.17l3.31 3.31 1.41-1.41L2.1 2.1zM4 18V6.83L15.17 18H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderShared(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-4 10h2v-2h-2v-2h2v-2h-2V8h4v10h-4v-2zm0 0h-2v2H4V6h5.17l2 2H14v2h2v2h-2v2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFormatOverline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3v2H5V3h14zm-7 4c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm0 11.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 9.5 12 9.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineGridView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3l-1.67 1.67L18.67 3 17 4.67 15.33 3l-1.66 1.67L12 3l-1.67 1.67L8.67 3 7 4.67 5.33 3 3.67 4.67 2 3v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V3zM11 19H4v-6h7v6zm9 0h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4H4V8h16v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineRequestQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v4h5v12H6zm5-1h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4v-2h-2V9h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineRuleFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.83 16L5 13.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41L7.83 16zm9.58-3L19 14.59 17.59 16 16 14.41 14.41 16 13 14.59 14.59 13 13 11.41 14.41 10 16 11.59 17.59 10 19 11.41 17.41 13zM20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineSnippetFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2.5-5.88v3.38h-3v-5h1.38l1.62 1.62zM13 9v8h6v-5.5L16.5 9H13z"
                }
            }
        ]
    })(props);
}
function MdOutlineTextSnippet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.17 5L19 9.83V19H5V5h9.17m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.41l-4.83-4.83c-.37-.38-.88-.59-1.41-.59zM7 15h10v2H7v-2zm0-4h10v2H7v-2zm0-4h7v2H7V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineTopic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16.77c.68 0 1.23-.56 1.23-1.23V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-2-6H6v-2h12v2zm-4 4H6v-2h8v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineUploadFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11 8 15.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16h6v-6h4l-7-7-7 7h4v6zm3-10.17L14.17 8H13v6h-2V8H9.83L12 5.83zM5 18h14v2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineWorkspaces(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 15c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6-8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2C9.8 3 8 4.8 8 7s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm6 12c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0-2c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAdfScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h-1V4H6v8H5c-1.66 0-3 1.34-3 3v5h20v-5c0-1.66-1.34-3-3-3zM8 6h8v6H8V6zm12 12H4v-3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "16",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineBrowserNotSupported(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6v10.5l1.95 1.95c.03-.15.05-.3.05-.45V6c0-1.1-.9-2-2-2H6.5l2 2H19zM3.22 3.32L1.95 4.59 3 5.64V18c0 1.1.9 2 2 2h12.36l2.06 2.06 1.27-1.27L3.22 3.32zM15 18H5V7.64L15.36 18H15z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrowserUpdated(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 13v3c0 1.1-.9 2-2 2h-3l1 1v2H6v-2l1-1H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8v2H4v11h16v-3h2zm-7 2l-5-5 1.41-1.41L14 11.17V3h2v8.17l2.59-2.58L20 10l-5 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCastConnected(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 7v2h12v6h-3v2h5V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineCastForEducation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09zM14.5 6L9 9l5.5 3L20 9l-5.5-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2a9 9 0 019 9h2c0-6.08-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function MdOutlineComputer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineConnectedTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v2h8v-2h4c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2zm0 14H4V5h16v12zM5 14v2h2c0-1.11-.89-2-2-2zm0-3v1.43c1.97 0 3.57 1.6 3.57 3.57H10c0-2.76-2.24-5-5-5zm0-3v1.45c3.61 0 6.55 2.93 6.55 6.55H13c0-4.42-3.59-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineDesktopMac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineDesktopWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeveloperBoardOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.83 5H18v10.17L19.83 17H22v-2h-2v-2h2v-2h-2V9h2V7h-2V5c0-1.1-.9-2-2-2H5.83l2 2zM12 9.17V7h4v3h-3.17L12 9.17zM9.83 7H11v1.17L9.83 7zm4 4H16v2.17L13.83 11zM18 21c.06 0 .11 0 .16-.01l2.32 2.32 1.41-1.41L2.1 2.1.69 3.51l1.32 1.32C2 4.89 2 4.94 2 5v14c0 1.1.9 2 2 2h14zM4 19V6.83l2 2V12h3.17l1 1H6v4h5v-3.17l1 1V17h2.17l2 2H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeveloperBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6v-4zm6-6h4v3h-4V7zM6 7h5v5H6V7zm6 4h4v6h-4v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeviceHub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeviceUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14zM12 6.72c-1.96 0-3.5 1.52-3.5 3.47h1.75c0-.93.82-1.75 1.75-1.75s1.75.82 1.75 1.75c0 1.75-2.63 1.57-2.63 4.45h1.76c0-1.96 2.62-2.19 2.62-4.45 0-1.96-1.54-3.47-3.5-3.47zM11 16h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDevicesOther(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineDock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineEarbudsBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 9h-2V9h2v7zm-6-6.62C14 7.51 12.49 6 10.62 6S7.25 7.51 7.25 9.38v5.25c0 1.04-.84 1.88-1.88 1.88s-1.87-.85-1.87-1.89v-4.7c.16.05.33.08.5.08 1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v6.62C2 16.49 3.51 18 5.38 18s3.38-1.51 3.38-3.38V9.38c0-1.04.84-1.88 1.88-1.88s1.88.84 1.88 1.88v4.7c-.18-.05-.35-.08-.52-.08-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2V9.38z"
                }
            }
        ]
    })(props);
}
function MdOutlineEarbuds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3c-2.76 0-5 2.24-5 5v8c0 1.66-1.34 3-3 3s-3-1.34-3-3V9h.83C7.44 9 8.89 7.82 9 6.21A3 3 0 006.2 3C4.44 2.89 3 4.42 3 6.19V16c0 2.76 2.24 5 5 5s5-2.24 5-5V8c0-1.66 1.34-3 3-3s3 1.34 3 3v7h-.83c-1.61 0-3.06 1.18-3.17 2.79A3 3 0 0017.8 21c1.76.12 3.2-1.42 3.2-3.18V8c0-2.76-2.24-5-5-5zM5 6c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1H5V6zm14 12c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1h1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineGamepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 4v2.67l-1 1-1-1V4h2m7 7v2h-2.67l-1-1 1-1H20M6.67 11l1 1-1 1H4v-2h2.67M12 16.33l1 1V20h-2v-2.67l1-1M15 2H9v5.5l3 3 3-3V2zm7 7h-5.5l-3 3 3 3H22V9zM7.5 9H2v6h5.5l3-3-3-3zm4.5 4.5l-3 3V22h6v-5.5l-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeadphonesBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7h-1V6h-2v1h-1c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1zm-1 9h-2V9h2v7zM8 6c-3.31 0-6 2.69-6 6v4c0 1.1.9 2 2 2h2v-5H3.5v-1c0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5v1H10v5h2c1.1 0 2-.9 2-2v-4c0-3.31-2.69-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3a9 9 0 00-9 9v7c0 1.1.9 2 2 2h4v-8H5v-1c0-3.87 3.13-7 7-7s7 3.13 7 7v1h-4v8h4c1.1 0 2-.9 2-2v-7a9 9 0 00-9-9zM7 15v4H5v-4h2zm12 4h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeadsetMic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14v4h-2v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeadsetOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c3.87 0 7 3.13 7 7v1h-4v.17L16.83 14H19v2.17l2 2V11a9 9 0 00-9-9c-2.02 0-3.88.67-5.38 1.8l1.43 1.43A6.878 6.878 0 0112 4zM2.1 2.1L.69 3.51l3.33 3.33A8.98 8.98 0 003 11v7c0 1.1.9 2 2 2h4v-8H5v-1c0-.94.19-1.83.52-2.65L15 17.83V20h2.17l1 1H12v2h7c.34 0 .65-.09.93-.24l.55.55 1.41-1.41L2.1 2.1zM7 14v4H5v-4h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14v3c0 .55-.45 1-1 1h-1v-4h2M7 14v4H6c-.55 0-1-.45-1-1v-3h2m5-13a9 9 0 00-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7a9 9 0 00-9-9z"
                }
            }
        ]
    })(props);
}
function MdOutlineHomeMax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5C2.79 5 1 6.79 1 9v5c0 2.21 1.79 4 4 4h2v1h10v-1h2c2.21 0 4-1.79 4-4V9c0-2.21-1.79-4-4-4zm2 9c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineHomeMini(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5C4.19 5 2 9.48 2 12c0 3.86 3.13 7 6.99 7h6.02C17.7 19 22 16.92 22 12c0 0 0-7-10-7zm0 2c7.64 0 7.99 4.51 8 5H4c0-.2.09-5 8-5zm2.86 10H9.14c-2.1 0-3.92-1.24-4.71-3h15.15c-.8 1.76-2.62 3-4.72 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15H3V6h18v13zM9 8h2v2H9V8zM5 8h2v2H5V8zm3 8h8v1H8v-1zm5-8h2v2h-2V8zm-4 4h2v2H9v-2zm-4 0h2v2H5v-2zm8 0h2v2h-2v-2zm4-4h2v2h-2V8zm0 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardCapslock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardCommandKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 3C15.57 3 14 4.57 14 6.5V8h-4V6.5C10 4.57 8.43 3 6.5 3S3 4.57 3 6.5 4.57 10 6.5 10H8v4H6.5C4.57 14 3 15.57 3 17.5S4.57 21 6.5 21s3.5-1.57 3.5-3.5V16h4v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5H16v-4h1.5c1.93 0 3.5-1.57 3.5-3.5S19.43 3 17.5 3zM16 8V6.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S18.33 8 17.5 8H16zM6.5 8C5.67 8 5 7.33 5 6.5S5.67 5 6.5 5 8 5.67 8 6.5V8H6.5zm3.5 6v-4h4v4h-4zm7.5 5c-.83 0-1.5-.67-1.5-1.5V16h1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm-11 0c-.83 0-1.5-.67-1.5-1.5S5.67 16 6.5 16H8v1.5c0 .83-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardControlKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12l1.41 1.41L12 7.83l5.59 5.58L19 12l-7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardDoubleArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.41L16.59 5 12 9.58 7.41 5 6 6.41l6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13l-1.41-1.41L12 16.17l-4.59-4.58L6 13l6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardDoubleArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.59 18L19 16.59 14.42 12 19 7.41 17.59 6l-6 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 18l1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardDoubleArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 6L5 7.41 9.58 12 5 16.59 6.41 18l6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6l-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardDoubleArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 17.59L7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11l1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardHide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H4V5h16v10zm-9-9h2v2h-2zm0 3h2v2h-2zM8 6h2v2H8zm0 3h2v2H8zM5 9h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2zm-5 17l4-4H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardOptionKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5h6v2h-6zM9 5H3v2h4.85l6.92 12H21v-2h-5.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardReturn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardTab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboardVoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2s-1.2-.54-1.2-1.2V5.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.41 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7v10H4V7h16m0-2H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2zm0 3h2v2h-2zM8 8h2v2H8zm0 3h2v2H8zm-3 0h2v2H5zm0-3h2v2H5zm3 6h8v2H8zm6-3h2v2h-2zm0-3h2v2h-2zm3 3h2v2h-2zm0-3h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLaptopChromebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineLaptopMac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLaptopWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9c-.04-4.39-3.6-7.93-8-7.93S4.04 4.61 4 9v6c0 4.42 3.58 8 8 8s8-3.58 8-8V9zm-2 0h-5V3.16c2.81.47 4.96 2.9 5 5.84zm-7-5.84V9H6a6.005 6.005 0 015-5.84zM18 15c0 3.31-2.69 6-6 6s-6-2.69-6-6v-4h12v4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm1 17H7V4h10v14zm-3 3h-4v-1h4v1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneIphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 1h-8A2.5 2.5 0 005 3.5v17A2.5 2.5 0 007.5 23h8a2.5 2.5 0 002.5-2.5v-17A2.5 2.5 0 0015.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonelinkOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6V4H7.39l2 2zm2 13V9c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v3.61l2 2V10h4v7h-1.61l2.93 2.93c.39-.13.68-.49.68-.93zM2.06 1.51L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.41-1.41L2.06 1.51zM4 17V6.27L14.73 17H4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonelink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
                }
            }
        ]
    })(props);
}
function MdOutlinePointOfSale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 4H7V4h10v2zm3 16H4c-1.1 0-2-.9-2-2v-1h20v1c0 1.1-.9 2-2 2zm-1.47-11.81A2.008 2.008 0 0016.7 9H7.3c-.79 0-1.51.47-1.83 1.19L2 18h20l-3.47-7.81zM9.5 16h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm3 4h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5zm0-2h-1c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1c.28 0 .5.22.5.5s-.22.5-.5.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePowerInput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRouter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4.2c1.5 0 3 .6 4.2 1.7l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2zm-3.3 2.5l.8.8c.7-.7 1.6-1 2.5-1s1.8.3 2.5 1l.8-.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zM6 16h2v2H6zm3.5 0h2v2h-2zm3.5 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineScanner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM19 18H5v-4h14v4zM6 15h2v2H6zm4 0h8v2h-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSecurity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSimCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v16H6V8.83L10.83 4H18zM7 17h2v2H7zm8 0h2v2h-2zm-8-6h2v4H7zm4 4h2v4h-2zm0-4h2v2h-2zm4 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmartDisplay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 7.5v9l7-4.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14.01H4V5.99h16v12.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmartScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.25H14v1.5h-1.5zM15 11.25h1.5v1.5H15zM10 11.25h1.5v1.5H10zM7.5 11.25H9v1.5H7.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM4 17H3V7h1v10zm14 0H6V7h12v10zm3 0h-1V7h1v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmartToy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6V7h12v12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13zm7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM8 15h8v2H8v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmartphone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpeakerGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM18 17l-8-.01V3h8v14zm-4-9c1.1 0 2-.89 2-2s-.9-2-2-2-2 .89-2 2 .9 2 2 2zm0 8c1.93 0 3.5-1.57 3.5-3.5S15.93 9 14 9s-3.5 1.57-3.5 3.5S12.07 16 14 16zm0-5c.83 0 1.5.67 1.5 1.5S14.83 14 14 14s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zM6 5H4v16a2 2 0 002 2h10v-2H6V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 20V4h10v16H7zm5-11c1.1 0 2-.9 2-2s-.9-2-2-2a2 2 0 100 4zm0 2c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 7.41L18.17 11H6v2h12.17l-3.59 3.59L16 18l6-6-6-6-1.41 1.41zM2 6v12h2V6H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTabletAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineTabletMac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 0h-14A2.5 2.5 0 002 2.5v19A2.5 2.5 0 004.5 24h14a2.5 2.5 0 002.5-2.5v-19A2.5 2.5 0 0018.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineToys(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.75 10.08L17.4 6.05A2.978 2.978 0 0014.56 4H9.44C8.15 4 7 4.82 6.6 6.05L5.81 8.4 4.41 7l.29-.29A.996.996 0 103.29 5.3l-2 2A.996.996 0 102.7 8.71l.3-.3 1.79 1.79C3.18 10.72 2 12.22 2 14c0 1.49.83 2.78 2.05 3.47A2.991 2.991 0 007 20c1.3 0 2.4-.84 2.82-2h4.37c.41 1.16 1.51 2 2.82 2 1.49 0 2.73-1.1 2.95-2.53C21.17 16.78 22 15.49 22 14c0-1.95-1.4-3.57-3.25-3.92zM13 6h1.56a1 1 0 01.95.68l1.1 3.32H13V6zm-4.51.68A1 1 0 019.44 6H11v4H7.41l-.02-.02 1.1-3.3zM7 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm10 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.49-2.68A3.028 3.028 0 0017 14c-1.3 0-2.4.84-2.82 2H9.82C9.4 14.84 8.3 14 7 14c-1.03 0-1.95.53-2.49 1.32C4.2 14.97 4 14.51 4 14c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2 0 .51-.2.97-.51 1.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideogameAssetOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm-6.67-1H20v8h-1.17l1.87 1.87c.75-.29 1.3-1.02 1.3-1.87V8c0-1.1-.9-2-2-2H8.83l2 2zm8.95 14.61L15.17 18H4c-1.1 0-2-.9-2-2V8c0-.85.55-1.58 1.3-1.87L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM13.17 16l-3-3H9v2H7v-2H5v-2h2V9.83L5.17 8H4v8h9.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideogameAsset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h18v8zM6 15h2v-2h2v-2H8V9H6v2H4v2h2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineWatchOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c2.76 0 5 2.24 5 5 0 .64-.13 1.25-.35 1.82l1.5 1.5a6.963 6.963 0 00-1.79-8.79L15 2H9l-.96 3.21 2.14 2.14C10.75 7.13 11.36 7 12 7zm-1.51-3h3.02l.38 1.27c-.55-.16-1.97-.51-3.78 0L10.49 4zM2.81 2.81L1.39 4.22l4.46 4.46a6.963 6.963 0 001.79 8.79L9 22h6l.96-3.21 3.82 3.82 1.41-1.41L2.81 2.81zM13.51 20h-3.02l-.38-1.27c.55.15 1.97.51 3.78 0L13.51 20zM12 17c-2.76 0-5-2.24-5-5 0-.64.13-1.25.35-1.82l6.47 6.47c-.57.22-1.18.35-1.82.35z"
                }
            }
        ]
    })(props);
}
function MdOutlineWatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.31 2l.41 2.48C13.87 4.17 12.96 4 12 4c-.95 0-1.87.17-2.71.47L9.7 2h4.61m.41 17.52L14.31 22H9.7l-.41-2.47c.84.3 1.76.47 2.71.47.96 0 1.87-.17 2.72-.48M16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12s-1.19-4.81-3.04-6.27L16 0zm-4 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.03 3.56c-1.67-1.39-3.74-2.3-6.03-2.51v2.01c1.73.19 3.31.88 4.61 1.92l1.42-1.42zM11 3.06V1.05c-2.29.2-4.36 1.12-6.03 2.51l1.42 1.42A8.928 8.928 0 0111 3.06zM4.98 6.39L3.56 4.97C2.17 6.64 1.26 8.71 1.05 11h2.01c.19-1.73.88-3.31 1.92-4.61zM20.94 11h2.01c-.21-2.29-1.12-4.36-2.51-6.03l-1.42 1.42A8.928 8.928 0 0120.94 11zM7 12l3.44 1.56L12 17l1.56-3.44L17 12l-3.44-1.56L12 7l-1.56 3.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 21a8.96 8.96 0 01-7.46-4H7v-2H1v6h2v-2.7c1.99 2.84 5.27 4.7 9 4.7 4.87 0 9-3.17 10.44-7.56l-1.96-.45C19.25 18.48 15.92 21 12 21z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlindsClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h11.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zm-2-8h-2V9h2v2zm-4 0H6V9h8v2zm0 2v2H6v-2h8zm2 0h2v2h-2v-2zm2-6h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-2h8v2H6zm10 0v-2h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlinds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM16 9h2v2h-2V9zm-2 2H6V9h8v2zm4-4h-2V5h2v2zm-4-2v2H6V5h8zM6 19v-6h8v1.82A1.746 1.746 0 0015 18a1.746 1.746 0 001-3.18V13h2v6H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBroadcastOnHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4v2h16v2.59c.73.29 1.4.69 2 1.17V6zM8 9H3c-.5 0-1 .5-1 1v9c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-9c0-.5-.5-1-1-1zm-1 9H4v-7h3v7zM17.75 16.97c.3-.23.5-.57.5-.97a1.25 1.25 0 00-2.5 0c0 .4.2.75.5.97V22h1.5v-5.03z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 13.5a2.5 2.5 0 012.5 2.5c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4s-4 1.79-4 4c0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 0117 13.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBroadcastOnPersonal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19v-9l6-4.5 4.08 3.06c.81-.32 1.69-.51 2.61-.54L10 3 2 9v12h8.76c-.48-.6-.88-1.27-1.17-2H4zM17 14.75c-.69 0-1.25.56-1.25 1.25 0 .4.2.75.5.97V22h1.5v-5.03c.3-.23.5-.57.5-.97 0-.69-.56-1.25-1.25-1.25z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.21 0-4 1.79-4 4 0 1.1.45 2.1 1.17 2.83l1.06-1.06A2.5 2.5 0 1119.5 16c0 .69-.28 1.31-.73 1.76l1.06 1.06C20.55 18.1 21 17.1 21 16c0-2.21-1.79-4-4-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9.5a6.5 6.5 0 00-6.5 6.5c0 1.79.73 3.42 1.9 4.6l1.06-1.06C12.56 18.63 12 17.38 12 16c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.37-.56 2.62-1.46 3.52l1.07 1.06A6.5 6.5 0 0017 9.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurtainsClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM13 5v14h-2V5h2zM6 5h3v14H6V5zm9 14V5h3v14h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurtains(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zm-2-8.14c-2.05-.58-3.64-2.93-3.94-5.86H18v5.86zM15.81 12c-2.04 1.35-3.5 3.94-3.76 7h-.09c-.26-3.06-1.72-5.65-3.76-7 2.04-1.35 3.5-3.94 3.76-7h.09c.26 3.06 1.72 5.65 3.76 7zM9.94 5c-.3 2.93-1.89 5.27-3.94 5.86V5h3.94zM6 13.14c2.05.58 3.64 2.93 3.94 5.86H6v-5.86zM14.06 19c.3-2.93 1.89-5.27 3.94-5.86V19h-3.94z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.69 2.21L4.33 11.49c-.64.58-.28 1.65.58 1.73L13 14l-4.85 6.76c-.22.31-.19.74.08 1.01.3.3.77.31 1.08.02l10.36-9.28c.64-.58.28-1.65-.58-1.73L11 10l4.85-6.76c.22-.31.19-.74-.08-1.01a.77.77 0 00-1.08-.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricMeter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11a9 9 0 00-18 0c0 3.92 2.51 7.24 6 8.48V22h2v-2.06a8.262 8.262 0 002 0V22h2v-2.52c3.49-1.24 6-4.56 6-8.48zm-9 7c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h8v2H8zM12.75 10l-3 3L11 14.25 9.75 15.5l1.5 1.5 3-3L13 12.75l1.25-1.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineEnergySavingsLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-4.8 0-9 3.86-9 9 0 2.12.74 4.07 1.97 5.61L3 19.59 4.41 21l1.97-1.97A9.012 9.012 0 0012 21c2.3 0 4.61-.88 6.36-2.64A8.95 8.95 0 0021 12V3h-9zm7 9c0 1.87-.73 3.63-2.05 4.95A6.96 6.96 0 0112 19c-3.86 0-7-3.14-7-7 0-1.9.74-3.68 2.1-4.99A6.94 6.94 0 0112 5h7v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.46 12.63l4.05.4-2.44 3.33c-.11.16-.1.38.04.52.15.15.4.16.56.01l5.16-4.63c.33-.3.15-.85-.3-.89l-4.05-.4 2.44-3.33c.11-.16.1-.38-.04-.52a.405.405 0 00-.56-.01l-5.16 4.63c-.32.3-.14.85.3.89z"
                }
            }
        ]
    })(props);
}
function MdOutlineGasMeter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-1V2h-2v2h-2V2H9v2H8C5.79 4 4 5.79 4 8v10c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm2 14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 15.54C9.5 16.9 10.62 18 12 18s2.5-1.1 2.5-2.46c0-1.09-.45-1.41-2.5-3.79-2.07 2.4-2.5 2.71-2.5 3.79zM8 8h8v2H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeatPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.75-2.08c-.55-.1-1.05-.32-1.5-.62l1.5-1.5v2.12zm1.5 0v-2.11l1.5 1.5c-.45.3-.95.51-1.5.61zm2.56-1.67l-1.5-1.5h2.11c-.1.55-.31 1.05-.61 1.5zm.61-3h-2.11l1.5-1.5c.3.45.51.95.61 1.5zm-3.17-3.17c.55.1 1.05.32 1.5.62l-1.5 1.5V8.08zM12 11c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-.75-2.92v2.11l-1.5-1.5c.45-.3.95-.51 1.5-.61zM8.69 9.75l1.5 1.5H8.08c.1-.55.31-1.05.61-1.5zm1.5 3l-1.5 1.5c-.3-.44-.51-.95-.62-1.5h2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeFanOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8c-1.06 0-1.64.29-3.91 1.19-.19-.14-.4-.27-.62-.37.25-1.03.61-1.53 1.33-2.04.81-.57 1.2-1.34 1.2-2.28 0-1.22-.95-2.5-2.6-2.5-3.08 0-4.92 1.47-5.32 3.26l2.33 2.33C10.07 6.69 10 6.38 10 6c0-1.18 1.4-2 3.4-2 .57 0 .6.42.6.5 0 .27-.05.43-.35.65-1.27.9-1.83 1.91-2.16 3.39l-.02.1 7.25 7.25c.24.06.5.11.78.11 1.22 0 2.5-.95 2.5-2.6C22 9.91 20.11 8 18 8zm1.5 6c-.27 0-.43-.05-.65-.35-.9-1.27-1.91-1.83-3.39-2.16a3.12 3.12 0 00-.15-.62c1.8-.75 2.18-.87 2.69-.87 1.18 0 2 1.4 2 3.4 0 .57-.42.6-.5.6zM1.39 4.22l3.89 3.89C5.04 8.05 4.78 8 4.5 8 3.28 8 2 8.95 2 10.6 2 14.09 3.89 16 6 16c1.06 0 1.64-.29 3.91-1.19.19.14.4.27.62.37-.25 1.03-.61 1.53-1.33 2.04-.81.57-1.2 1.34-1.2 2.28 0 1.22.95 2.5 2.6 2.5 3.08 0 4.92-1.47 5.32-3.26l3.86 3.86 1.41-1.41L2.81 2.81 1.39 4.22zm11.13 11.24c.03 0 .06-.02.09-.02l.97.97c.35.9.42 1.21.42 1.59 0 1.18-1.4 2-3.4 2-.57 0-.6-.42-.6-.5 0-.27.05-.43.35-.65 1.28-.89 1.83-1.91 2.17-3.39zm-3.98-2.94c.03.22.08.42.15.62-1.8.74-2.18.86-2.69.86-1.18 0-2-1.4-2-3.4 0-.57.42-.6.5-.6.27 0 .43.05.65.35.89 1.28 1.91 1.83 3.39 2.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineNestCamWiredStand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1c-.15 0 .11-.02-4.28.42C8.47 1.75 6 4.48 6 7.75s2.47 6 5.72 6.33l1.9.19-.56.85c-.35-.08-.7-.12-1.06-.12-2.76 0-5 2.24-5 5v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2c0-1.67-.83-3.15-2.09-4.06l.97-1.45c.04 0 .09.01.13.01 1.09 0 2-.89 2-2V3C18 1.89 17.09 1 16 1zm-1 20H9v-1c0-1.65 1.35-3 3-3s3 1.35 3 3v1zM8 7.75c0-2.25 1.69-4.11 3.92-4.34L16 3l.03 9.5-4.11-.42A4.336 4.336 0 018 7.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineOilBarrel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.05C9 14.68 10.34 16 12 16s3-1.32 3-2.95c0-1.31-.53-1.69-3-4.55-2.48 2.88-3 3.25-3 4.55z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13c.55 0 1-.45 1-1s-.45-1-1-1h-1V5h1c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h1v6H4c-.55 0-1 .45-1 1s.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1h-1v-6h1zm-3 6H7v-6c.55 0 1-.45 1-1s-.45-1-1-1V5h10v6c-.55 0-1 .45-1 1s.45 1 1 1v6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePropaneTank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6.14V4c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2.14c-1.72.45-3 2-3 3.86v8c0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4v-8c0-1.86-1.28-3.41-3-3.86zM9 4h6v2h-2c0-.55-.45-1-1-1s-1 .45-1 1H9V4zM8 8h8c1.1 0 2 .9 2 2v3H6v-3c0-1.1.9-2 2-2zm8 12H8c-1.1 0-2-.9-2-2v-3h12v3c0 1.1-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePropane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm-7-1h4v1h-4V5zm7 11H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRollerShadesClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h8.25c0 .97.78 1.75 1.75 1.75s1.75-.78 1.75-1.75H22v-2h-2zM18 5v10H6V5h12zM6 19v-2h5v2H6zm7 0v-2h5v2h-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineRollerShades(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM18 5v6H6V5h12zM6 19v-6h5v1.82A1.746 1.746 0 0012 18a1.746 1.746 0 001-3.18V13h5v6H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSensorDoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4v16H6V4h12m0-2H6c-1.1 0-2 .9-2 2v18h16V4c0-1.1-.9-2-2-2zm-2.5 8.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5S17 12.83 17 12s-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSensorOccupied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM12 12c-1.84 0-3.56.5-5.03 1.37-.61.35-.97 1.02-.97 1.72V17h12v-1.91c0-.7-.36-1.36-.97-1.72A9.844 9.844 0 0012 12zm-3.86 3c1.18-.65 2.51-1 3.86-1s2.68.35 3.85 1H8.14zM21.23 8.15l1.85-.77A12.056 12.056 0 0016.62.92l-.77 1.85c2.42 1.02 4.36 2.96 5.38 5.38zM8.15 2.77L7.38.92A12.089 12.089 0 00.92 7.38l1.85.77c1.02-2.42 2.96-4.36 5.38-5.38zM2.77 15.85l-1.85.77c1.22 2.91 3.55 5.25 6.46 6.46l.77-1.85a10.117 10.117 0 01-5.38-5.38zM15.85 21.23l.77 1.85c2.91-1.22 5.25-3.55 6.46-6.46l-1.85-.77a10.117 10.117 0 01-5.38 5.38z"
                }
            }
        ]
    })(props);
}
function MdOutlineSensorWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v7h-4v-1h-4v1H6V4h12zM6 20v-7h12v7H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineShieldMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.01 14.33c1.75 2.17 5.12 2.24 6.96.07.23-.27.08-.68-.26-.74a4.491 4.491 0 01-3.18-2.2 4.503 4.503 0 01-.32-3.86.453.453 0 00-.51-.6c-3.34.62-4.89 4.61-2.69 7.33z"
                }
            }
        ]
    })(props);
}
function MdOutlineSolarPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12H4L2 22h20l-2-10zm-1.64 2l.4 2H13v-2h5.36zM11 14v2H5.24l.4-2H11zm-6.16 4H11v2H4.44l.4-2zM13 20v-2h6.16l.4 2H13zM11 8h2v3h-2zM15.764 7.205l1.415-1.414L19.3 7.912l-1.414 1.414zM4.705 7.913L6.826 5.79 8.24 7.206 6.12 9.327zM3 2h3v2H3zM18 2h3v2h-3zM12 7c2.76 0 5-2.24 5-5h-2c0 1.65-1.35 3-3 3S9 3.65 9 2H7c0 2.76 2.24 5 5 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalShadesClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM13 5h1.5v14H13V5zm-2 14H9.5V5H11v14zM6 5h1.5v14H6V5zm10.5 14V5H18v14h-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineVerticalShades(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 19V3H4v16H2v2h20v-2h-2zM14 5v14h-4V5h4zM6 5h2v14H6V5zm10 14V5h2v14h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWindPower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 3h6v2H4zM1 7h5v2H1zM3 19h5v2H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.21 18.61l-2.28-4.1a2.05 2.05 0 00-1.26-.97l-2.69-.67a2.95 2.95 0 00-.37-1.33l3.96-6.59c.65-1.08.3-2.48-.78-3.13a2.288 2.288 0 00-2.73.3l-3.43 3.21c-.4.37-.63.9-.63 1.45v3.4c-.47.17-.89.45-1.23.82H3.28a2.279 2.279 0 00-.63 4.47l4.51 1.29c.18.05.37.08.55.08.36 0 .72-.1 1.03-.29l2.24-1.34c.29.26.63.47 1.02.61V21c-1.1 0-2 .9-2 2h6c0-1.1-.9-2-2-2v-4.28l4.61 4.61c.45.45 1.03.67 1.61.67.58 0 1.17-.22 1.61-.67.72-.72.88-1.83.38-2.72zM7.72 14.84L3.2 13.55a.279.279 0 01-.2-.27c0-.15.13-.28.28-.28h6.73c0 .15.01.3.03.44l-2.32 1.4zM13 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-3.86V6.78l3.43-3.21c.05-.05.19-.12.34-.04.13.08.18.25.1.38l-3.74 6.24-.13-.01zm6.42 9.78c-.05.05-.24.16-.4 0l-4.85-4.85c.08-.09.16-.18.24-.28l2.78.69 2.28 4.1c.06.11.04.25-.05.34z"
                }
            }
        ]
    })(props);
}
function MdOutline10Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5H15v3h-1.5V7zM7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM8.5 11.5H10v-6H7V7h1.5zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutline11Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11.5H11v-6H8V7h1.5zM14.5 11.5H16v-6h-3V7h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline12Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10h-3V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H12V7h3v1h-2c-.55 0-1 .45-1 1v2.5h4.5V10z"
                }
            }
        ]
    })(props);
}
function MdOutline13Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10.5v-4c0-.55-.45-1-1-1H12V7h3v1h-2v1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1zM7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutline14Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM15 11.5h1.5V10h1V8.5h-1v-3H15v3h-1.5v-3H12V10h3z"
                }
            }
        ]
    })(props);
}
function MdOutline15Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10.5V9c0-.55-.45-1-1-1h-2V7h3V5.5H12V9h3v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutline16Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.5h2.5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-2V7h3V5.5H13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5H15v1.5h-1.5V9zM8.5 11.5H10v-6H7V7h1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline17Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM13.25 11.5H15l1.46-4.71c.19-.64-.29-1.29-.96-1.29H12V7h2.62l-1.37 4.5z"
                }
            }
        ]
    })(props);
}
function MdOutline18Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM13 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5H15V8h-1.5V6.5zm0 2.5H15v1.5h-1.5V9z"
                }
            }
        ]
    })(props);
}
function MdOutline19Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 11.5H10v-6H7V7h1.5zM16.5 10.5v-4c0-.55-.45-1-1-1H13c-.55 0-1 .45-1 1V8c0 .55.45 1 1 1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1zM15 8h-1.5V6.5H15V8z"
                }
            }
        ]
    })(props);
}
function MdOutline20Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H14c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-4.5H16v3h-1.5V7zM11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10z"
                }
            }
        ]
    })(props);
}
function MdOutline21Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11.5H16v-6h-3V7h1.5zM12 10H9V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H7.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H12V10zM7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM15 17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6H15V17zm0-3h1.5v1.5H15V14z"
                }
            }
        ]
    })(props);
}
function MdOutline22Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10zM17.5 10h-3V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H13V7h3v1h-2c-.55 0-1 .45-1 1v2.5h4.5V10z"
                }
            }
        ]
    })(props);
}
function MdOutline23Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10zM17.5 10.5v-4c0-.55-.45-1-1-1H13V7h3v1h-2v1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutline24Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM17 12.5h-3.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1zm-.5 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 10H8V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H6.5V7h3v1h-2c-.55 0-1 .45-1 1v2.5H11V10zM16 11.5h1.5V10h1V8.5h-1v-3H16v3h-1.5v-3H13V10h3z"
                }
            }
        ]
    })(props);
}
function MdOutline2Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10h-3V9h2c.55 0 1-.45 1-1V6.5c0-.55-.45-1-1-1H10V7h3v1h-2c-.55 0-1 .45-1 1v2.5h4.5V10z"
                }
            }
        ]
    })(props);
}
function MdOutline30FpsSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 4v2h5v2H5v2h4v2H4v2h5c1.1 0 2-.9 2-2v-1.5c0-.83-.17-1.5-1-1.5.83 0 1-.67 1-1.5V6c0-1.1-.9-2-2-2H4zm14 0c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2h-3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3zm0 2h-3v6h3V6zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function MdOutline3Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 12.5v6H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5zm3 3H15V14h1.5v1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10.5v-4c0-.55-.45-1-1-1H10V7h3v1h-2v1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutline4Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 11.5H14V10h1V8.5h-1v-3h-1.5v3H11v-3H9.5V10h3z"
                }
            }
        ]
    })(props);
}
function MdOutline5Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10.5V9c0-.55-.45-1-1-1h-2V7h3V5.5H10V9h3v1h-3v1.5h3.5c.55 0 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutline60FpsSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6v6h-3V6h3zm0-2h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-7 2V4H6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2H6V6h5zm-2 4v2H6v-2h3zM5 22H3v-5h2v5zm4 0H7v-5h2v5zm4 0h-2v-5h2v5zm8 0h-6v-5h6v5z"
                }
            }
        ]
    })(props);
}
function MdOutline6Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.5h2.5c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-2V7h3V5.5H11c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-2.5H13v1.5h-1.5V9z"
                }
            }
        ]
    })(props);
}
function MdOutline7Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 11.5H13l1.46-4.71c.19-.64-.29-1.29-.96-1.29H10V7h2.62l-1.37 4.5z"
                }
            }
        ]
    })(props);
}
function MdOutline8Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11.5h2.5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5H13V8h-1.5V6.5zm0 2.5H13v1.5h-1.5V9z"
                }
            }
        ]
    })(props);
}
function MdOutline9Mp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.5 14h1v3H10v-3h1v4.5h1.5v-5c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v5h1.5V14zM13.5 18.5H15V17h2c.55 0 1-.45 1-1v-2.5c0-.55-.45-1-1-1h-3.5v6zM15 14h1.5v1.5H15V14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 10.5v-4c0-.55-.45-1-1-1H11c-.55 0-1 .45-1 1V8c0 .55.45 1 1 1h2v1h-3v1.5h3.5c.55 0 1-.45 1-1zM13 8h-1.5V6.5H13V8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddAPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6h-3.17L16 4h-6v2h5.12l1.83 2H21v12H5v-9H3v9c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM8 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm5-3c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3zM5 6h3V4H5V1H3v3H0v2h3v3h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddPhotoAlternate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20H4V6h9V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2v9zm-7.79-3.17l-1.96-2.36L5.5 18h11l-3.54-4.71zM20 4V1h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V6h3V4h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddToPhotos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-1h2v-4h4V9h-4V5h-2v4H9v2h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAdjust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAnimation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 2c-2.71 0-5.05 1.54-6.22 3.78a7.062 7.062 0 00-3 3A7.014 7.014 0 002 15c0 3.87 3.13 7 7 7 2.71 0 5.05-1.54 6.22-3.78a7.062 7.062 0 003-3A7.014 7.014 0 0022 9c0-3.87-3.13-7-7-7zM9 20a5.002 5.002 0 01-4-8c0 3.87 3.13 7 7 7-.84.63-1.88 1-3 1zm3-3a5.002 5.002 0 01-4-8c0 3.86 3.13 6.99 7 7-.84.63-1.88 1-3 1zm4.7-3.3c-.53.19-1.1.3-1.7.3-2.76 0-5-2.24-5-5 0-.6.11-1.17.3-1.7.53-.19 1.1-.3 1.7-.3 2.76 0 5 2.24 5 5 0 .6-.11 1.17-.3 1.7zM19 12c0-3.86-3.13-6.99-7-7a5.002 5.002 0 017 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssistantPhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.36 6l.08.39.32 1.61H18v6h-3.36l-.08-.39-.32-1.61H7V6h5.36M14 4H5v17h2v-7h5.6l.4 2h7V6h-5.6L14 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssistant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-1l1.88-4.12L18 11l-4.12-1.88L12 5l-1.88 4.12L6 11l4.12 1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineAudiotrack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6zm-2 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoAwesomeMosaic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v14a2 2 0 002 2h6V3H5a2 2 0 00-2 2zm6 14H5V5h4v14zM19 3h-6v8h8V5c0-1.1-.9-2-2-2zm0 6h-4V5h4v4zM13 21h6c1.1 0 2-.9 2-2v-6h-8v8zm2-6h4v4h-4v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoAwesomeMotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 2H4c-1.1 0-2 .9-2 2v10h2V4h10V2zm4 4H8c-1.1 0-2 .9-2 2v10h2V8h10V6zm2 4h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10h-8v-8h8v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25zM11.5 9.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zm-1.51 3.49L9 15.17l-.99-2.18L5.83 12l2.18-.99L9 8.83l.99 2.18 2.18.99-2.18.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoFixHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7l.94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM8.5 7l.94-2.06L11.5 4l-2.06-.94L8.5 1l-.94 2.06L5.5 4l2.06.94zM20 12.5l-.94 2.06-2.06.94 2.06.94.94 2.06.94-2.06L23 15.5l-2.06-.94zM17.71 9.12l-2.83-2.83c-.2-.19-.45-.29-.71-.29-.26 0-.51.1-.71.29L2.29 17.46a.996.996 0 000 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42zm-3.54-.7l1.41 1.41L14.41 11 13 9.59l1.17-1.17zM5.83 19.59l-1.41-1.41L11.59 11 13 12.41l-7.17 7.18z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoFixNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7l.94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM17.71 9.12l-2.83-2.83c-.2-.19-.45-.29-.71-.29-.26 0-.51.1-.71.29L2.29 17.46a.996.996 0 000 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42zm-3.54-.7l1.41 1.41L14.41 11 13 9.59l1.17-1.17zM5.83 19.59l-1.41-1.41L11.59 11 13 12.41l-7.17 7.18z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoFixOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7l.94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM14.17 8.42l1.41 1.41-1.46 1.46 1.41 1.41 2.17-2.17a.996.996 0 000-1.41l-2.83-2.83a.984.984 0 00-.7-.29c-.26 0-.51.1-.71.29l-2.17 2.17 1.41 1.41 1.47-1.45zM1.39 4.22l7.07 7.07-6.17 6.17a.996.996 0 000 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l6.17-6.17 7.07 7.07 1.41-1.41L2.81 2.81 1.39 4.22zm9.9 9.9l-5.46 5.46-1.41-1.41 5.46-5.46 1.41 1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutoStories(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.47 5.2c-.47-.24-.96-.44-1.47-.61v12.03c-1.14-.41-2.31-.62-3.5-.62-1.9 0-3.78.54-5.5 1.58V5.48C10.38 4.55 8.51 4 6.5 4c-1.79 0-3.48.44-4.97 1.2-.33.16-.53.51-.53.88v12.08c0 .58.47.99 1 .99.16 0 .32-.04.48-.12C3.69 18.4 5.05 18 6.5 18c2.07 0 3.98.82 5.5 2 1.52-1.18 3.43-2 5.5-2 1.45 0 2.81.4 4.02 1.04.16.08.32.12.48.12.52 0 1-.41 1-.99V6.08c0-.37-.2-.72-.53-.88zM10 16.62C8.86 16.21 7.69 16 6.5 16s-2.36.21-3.5.62V6.71C4.11 6.24 5.28 6 6.5 6c1.2 0 2.39.25 3.5.72v9.9zM19 .5l-5 5V15l5-4.5V.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAutofpsSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.03 6.3h-.06l-1.02 2.89h2.1zM3 17h2v5H3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 15c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm-.63-10h1.25l2.63 7h-1.21l-.63-1.79h-2.83L9.96 12H8.74l2.63-7zM7 17h2v5H7zM11 17h2v5h-2zM15 17h6v5h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBedtimeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.27 4.49c-.13.59-.2 1.15-.24 1.71l2.05 2.05c-.27-2.05.1-4.22 1.26-6.23-.12 0-.23-.01-.35-.01a9.9 9.9 0 00-5.5 1.65l1.46 1.46c.42-.24.86-.46 1.32-.63zm-7.88-.27l2.27 2.27A9.934 9.934 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.92-.63 5.5-1.67l2.28 2.28 1.41-1.41L2.81 2.81 1.39 4.22zm3.74 3.74l10.92 10.92C14.84 19.6 13.45 20 12 20c-4.41 0-8-3.59-8-8 0-1.48.42-2.85 1.13-4.04z"
                }
            }
        ]
    })(props);
}
function MdOutlineBedtime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.27 4.49c-1.63 7.54 3.75 12.41 7.66 13.8A7.993 7.993 0 0112 20c-4.41 0-8-3.59-8-8 0-3.45 2.2-6.4 5.27-7.51m2.72-2.48C6.4 2.01 2 6.54 2 12c0 5.52 4.48 10 10 10 3.71 0 6.93-2.02 8.66-5.02-7.51-.25-12.09-8.43-8.32-14.97h-.35z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlurCircular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlurLinear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlurOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.8 11.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 20.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7-7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-18 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 5.27L6 8.77l.28.28L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81A.875.875 0 0014 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78h.01l1.41-1.41L3.91 3.86 2.5 5.27z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlurOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-.34 0-.68-.02-1.01-.07C10.9 17.77 12 14.95 12 12s-1.1-5.77-3.01-7.93C9.32 4.02 9.66 4 10 4m0-2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.7 4.91A8 8 0 0117 12a8 8 0 01-4.3 7.09c1.46-2 2.3-4.46 2.3-7.09s-.84-5.09-2.3-7.09M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54s-2.94 8.27-7 9.54c.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12.29 7c-.74 0-1.45.17-2.08.46 1.72.79 2.92 2.53 2.92 4.54s-1.2 3.75-2.92 4.54c.63.29 1.34.46 2.08.46 2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5v11c3.03 0 5.5-2.47 5.5-5.5S15.03 6.5 12 6.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrightness7(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zm-2 5.79V18h-3.52L12 20.48 9.52 18H6v-3.52L3.52 12 6 9.52V6h3.52L12 3.52 14.48 6H18v3.52L20.48 12 18 14.48zM12 6.5c-3.03 0-5.5 2.47-5.5 5.5s2.47 5.5 5.5 5.5 5.5-2.47 5.5-5.5-2.47-5.5-5.5-5.5zm0 9c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineBrokenImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5v-4.58l.99.99 4-4 4 4 4-3.99L19 12.43V19zm0-9.41l-1.01-1.01-4 4.01-4-4-4 4-.99-1V5h14v4.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96a.996.996 0 000-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineBurstMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-1 12H11V7h10v10zm-3.57-4.38l-2 2.57L14 13.47l-2 2.52h8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l1.83-2h4.24l1.83 2H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zM11.99 8C13.1 8 14 7.1 14 6s-.9-2-2.01-2S10 4.9 10 6s.89 2 1.99 2zM17 0H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7v-2h10v2zm0-3.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2h10v10.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraRear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 20v2h5v2l3-3-3-3v2zm9 0h5v2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 16H7V2h10v14zm-5-9c1.1 0 2-.9 1.99-2 0-1.1-.9-2-2-2S10 3.9 10 5s.89 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraRoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm6 13h-8v2H4V5h3V3h2v2h3v2h8v11zM9 15h2v2H9zm0-7h2v2H9zm4 7h2v2h-2zm0-7h2v2h-2zm4 7h2v2h-2zm0-7h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 2.26l-.08-.04-.01.02C13.46 2.09 12.74 2 12 2 6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-4.75-3.31-8.72-7.75-9.74zM19.41 9h-7.99l2.71-4.7c2.4.66 4.35 2.42 5.28 4.7zM13.1 4.08L10.27 9l-1.15 2L6.4 6.3A7.958 7.958 0 0112 4c.37 0 .74.03 1.1.08zM5.7 7.09L8.54 12l1.15 2H4.26C4.1 13.36 4 12.69 4 12c0-1.85.64-3.55 1.7-4.91zM4.59 15h7.98l-2.71 4.7A8.033 8.033 0 014.59 15zm6.31 4.91L14.89 13l2.72 4.7A8 8 0 0112 20c-.38 0-.74-.04-1.1-.09zm7.4-3l-4-6.91h5.43c.17.64.27 1.31.27 2 0 1.85-.64 3.55-1.7 4.91z"
                }
            }
        ]
    })(props);
}
function MdOutlineCases(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 9H1v11c0 1.11.89 2 2 2h17v-2H3V9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H5v11c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5h-5zm-6-2h4v2h-4V3zm9 13H7V7h14v9z"
                }
            }
        ]
    })(props);
}
function MdOutlineCenterFocusStrong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5 3c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm-7 0H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCenterFocusWeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm7 3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm7-11h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCollectionsBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3 2v5l-1-.75L15 9V4h2zm3 12H8V4h5v9l3-2.25L19 13V4h1v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCollections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineColorLens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0112 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 00-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 012.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineColorize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.66 5.41l.92.92-2.69 2.69-.92-.92 2.69-2.69M17.67 3c-.26 0-.51.1-.71.29l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42l-2.34-2.34c-.2-.19-.45-.29-.7-.29zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineCompare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineContrast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm1-17.93c3.94.49 7 3.85 7 7.93s-3.05 7.44-7 7.93V4.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineControlPointDuplicate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3V8zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16A6.99 6.99 0 012 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineControlPoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrop169(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrop32(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrop54(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrop75(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropDin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropOriginal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropRotate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8a2 2 0 00-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8a2 2 0 002 2h8v2h2v-2h2v-2H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCropSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.06 11.57c.59-.69.94-1.59.94-2.57 0-1.86-1.27-3.43-3-3.87V3h-2v2h-2V3H9v2H6v2h2v10H6v2h3v2h2v-2h2v2h2v-2c2.21 0 4-1.79 4-4 0-1.45-.78-2.73-1.94-3.43zM10 7h4c1.1 0 2 .9 2 2s-.9 2-2 2h-4V7zm5 10h-5v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyFranc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 5V3H7v13H5v2h2v3h2v-3h4v-2H9v-3h8v-2H9V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyLira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8.76V3h2v4.51L15 5v2.36l-4 2.51.01 2.35L15 9.72v2.36l-4 2.51V19c2.76 0 5-2.24 5-5h2c0 3.87-3.13 7-7 7H9v-5.16l-3 1.88v-2.36l3-1.88v-2.36L6 13v-2.36l3-1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyPound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 21c1.93 0 3.62-1.17 4-3l-1.75-.88C16 18.21 15.33 19 14 19H9.1c.83-1 1.5-2.34 1.5-4 0-.35-.03-.69-.08-1H14v-2H9.82C9 10.42 8 9.6 8 8a3.5 3.5 0 016.78-1.22L16.63 6c-.8-2.05-2.79-3.5-5.13-3.5C8.46 2.5 6 4.96 6 8c0 1.78.79 2.9 1.49 4H6v2h2.47c.08.31.13.64.13 1 0 2.7-2.6 4-2.6 4v2h8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyRuble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 3H7v9H5v2h2v2H5v2h2v3h2v-3h4v-2H9v-2h4.5c3.04 0 5.5-2.46 5.5-5.5S16.54 3 13.5 3zm0 9H9V5h4.5C15.43 5 17 6.57 17 8.5S15.43 12 13.5 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyRupee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.66 7c-.56-1.18-1.76-2-3.16-2H6V3h12v2h-3.26c.48.58.84 1.26 1.05 2H18v2h-2.02c-.25 2.8-2.61 5-5.48 5h-.73l6.73 7h-2.77L7 14v-2h3.5c1.76 0 3.22-1.3 3.46-3H6V7h7.66z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyYen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 11H18v2h-5v2h5v2h-5v4h-2v-4H6v-2h5v-2H6v-2h4.08L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function MdOutlineCurrencyYuan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.28 12H18v2h-5v7h-2v-7H6v-2h4.72L5 3h2.37L12 10.29 16.63 3H19z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeblur(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "14",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "10",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "10",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "3",
                    "cy": "14",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "21",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "3",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "14",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "18",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3v2c3.86 0 7 3.14 7 7s-3.14 7-7 7v2c4.96 0 9-4.04 9-9s-4.04-9-9-9z"
                }
            }
        ]
    })(props);
}
function MdOutlineDehaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20V6H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDetails(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 21h20L12 3zm1 5.92L18.6 19H13V8.92zm-2 0V19H5.4L11 8.92z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirtyLens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-7.02c-.22-.84-.52-1.76-.13-2.33.81-1.12 2.67 1.77 3.81-.09.77-1.57-1.58-1.29-1.64-2.12-.05-.84 3.68.17 3.04-1.66-.61-1.73-2.42.48-2.76-.53-.58-1.74 4.7-1.68 2.85-4.01-1.76-2.22-2.47 2.85-4.41 2.33-1.34-.36-1.01-2.88-2.65-2.44-1.88.51 1.03 2.2 0 2.86-.96.63-1.72-.92-2.51-1.19-.2-.07-.69-.05-.91.19-.78.86.28 1.16.25 1.91-.02.75-1.59.49-1.51 1.49.12 1.6 2.18.45 2.4 1.24.55 1.98-1.89 2.15-.5 3.27 1.53.71 1.91-1.94 2.8-1.35.58.38.3 1.45.16 2.43H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.28 17.15c0 .48.39.86.86.86.48 0 .86-.38.86-.86s-.39-.86-.86-.86c-.48 0-.86.38-.86.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 18.5A6.48 6.48 0 019.24 15H15l1-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15l1-2H9.24A6.491 6.491 0 0115 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3A8.955 8.955 0 0015 3c-3.92 0-7.24 2.51-8.48 6H3l-1 2h4.06a8.262 8.262 0 000 2H3l-1 2h4.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineExposureNeg1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function MdOutlineExposureNeg2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0016.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineExposurePlus1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
                }
            }
        ]
    })(props);
}
function MdOutlineExposurePlus2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17s.41-.78.54-1.17c.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46s-.44-.81-.78-1.11c-.34-.31-.77-.54-1.26-.71A5.72 5.72 0 0017.47 5c-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49s.6-.18.96-.18c.31 0 .58.05.81.15s.43.25.59.43.28.4.37.65c.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineExposureZero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.14 12.5c0 1-.1 1.85-.3 2.55s-.48 1.27-.83 1.7c-.36.44-.79.75-1.3.95s-1.07.3-1.7.3c-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95s-.65-1.01-.85-1.7c-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04h-.01zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19s-.61.06-.86.18-.47.31-.64.58-.31.62-.4 1.06-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19.62-.06.87-.19.46-.33.63-.61.3-.64.39-1.09.13-.99.13-1.62v-2.66h-.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineExposure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1.41 2L5 17.59V5h12.59zM6.41 19L19 6.41V19H6.41zM6 7h5v1.5H6zm10 5.5h-1.5v2h-2V16h2v2H16v-2h2v-1.5h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFaceRetouchingNatural(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 10.75c.07.41.11.82.11 1.25 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-.05.01-.1 0-.14 2.6-.98 4.69-2.99 5.74-5.55 3.38 4.14 7.97 3.73 8.99 3.61l-.89-1.93c-.13.01-4.62.38-7.18-3.86 1.01-.16 1.71-.15 2.59-.01 2.52-1.15 1.93-.89 2.76-1.26A9.62 9.62 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.43-.3-2.78-.84-4.01l-1.27 2.76zM8.08 5.03a8.046 8.046 0 01-3.66 4.44 8.046 8.046 0 013.66-4.44z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 4.5l-2.4-1.1L19.5 1l-1.1 2.4L16 4.5l2.4 1.1L19.5 8l1.1-2.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFaceRetouchingOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10c.75 0 1.47-.09 2.17-.24.21.71.33 1.46.33 2.24 0 1.22-.28 2.37-.77 3.4l1.49 1.49A9.981 9.981 0 0022 12c0-5.52-4.48-10-10-10-1.78 0-3.44.47-4.89 1.28l5.33 5.33c1.49.88 3.21 1.39 5.06 1.39zm-6.84-5.88c.43-.07.88-.12 1.34-.12 2.9 0 5.44 1.56 6.84 3.88-.43.07-.88.12-1.34.12-2.9 0-5.44-1.56-6.84-3.88zM1.89 3.72l2.19 2.19A9.958 9.958 0 002 12c0 5.52 4.48 10 10 10 2.29 0 4.4-.78 6.09-2.08l2.19 2.19 1.41-1.41L3.31 2.31 1.89 3.72zm14.77 14.77A7.91 7.91 0 0112 20c-4.41 0-8-3.59-8-8 0-.05.01-.1 0-.14a9.946 9.946 0 003.64-2.39l9.02 9.02zM6.23 8.06c-.53.55-1.14 1.03-1.81 1.41.26-.77.63-1.48 1.09-2.13l.72.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2a2 2 0 002-2V7a2 2 0 00-2-2h-4v2h4v2h-2a2 2 0 00-2 2v4h6v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-4v2h4v2h-2v2h2v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2a2 2 0 00-2-2h-2V7h4V5h-6v6h4v2h-4v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2V7h4V5h-4a2 2 0 00-2 2v6a2 2 0 002 2zm0-4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter7(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2a2 2 0 002-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7a2 2 0 00-2-2h-2a2 2 0 00-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13a2 2 0 002 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter9Plus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8a2 2 0 00-2-2h-1a2 2 0 00-2 2v1a2 2 0 002 2h1v1H9v2h3a2 2 0 002-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter9(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2a2 2 0 00-2 2v2a2 2 0 002 2h2v2h-4v2h4a2 2 0 002-2V7a2 2 0 00-2-2zm0 4h-2V7h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterBAndW(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterCenterFocus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterDrama(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.35 10.04A7.49 7.49 0 0012 4a7.48 7.48 0 00-6.64 4.04A5.996 5.996 0 000 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterFrames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM6 18h12V8H6v10zm2-8h8v6H8v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterHdr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterTiltShift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0111 4.07zm7.32.19A9.949 9.949 0 0013 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1a7.941 7.941 0 011.62 3.9zM5.69 7.1L4.26 5.68A9.949 9.949 0 002.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 014.07 13zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43a9.981 9.981 0 002.21-5.32h-2.02a7.945 7.945 0 01-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19A9.981 9.981 0 0011 21.95v-2.02a7.941 7.941 0 01-3.9-1.62l-1.42 1.43z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilterVintage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.7 12.4a6.06 6.06 0 00-.86-.4c.29-.11.58-.24.86-.4a6.012 6.012 0 003-5.19c-.91-.52-1.95-.8-3.01-.8-1.02 0-2.05.26-2.99.8-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-.94-.54-1.97-.8-2.99-.8-1.05 0-2.1.28-3.01.8a5.97 5.97 0 003 5.19c.28.16.57.29.86.4-.29.11-.58.24-.86.4a6.012 6.012 0 00-3 5.19c.91.52 1.95.8 3.01.8 1.02 0 2.05-.26 2.99-.8.28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54.94.54 1.97.8 2.99.8 1.05 0 2.1-.28 3.01-.8a6.012 6.012 0 00-3-5.19zm-2.54-3.88c.21-.17.38-.29.54-.37.61-.35 1.3-.54 2-.54.27 0 .53.03.79.08-.31.91-.94 1.69-1.78 2.18-.17.1-.36.18-.58.27l-1.38.52c-.17-.46-.41-.87-.72-1.24l1.13-.9zM12 3.37c.63.72 1 1.66 1 2.63 0 .19-.02.41-.05.63l-.23 1.44C12.48 8.03 12.24 8 12 8s-.48.03-.71.07l-.23-1.44C11.02 6.41 11 6.19 11 6c0-.98.37-1.91 1-2.63zM4.51 7.68c.26-.06.53-.08.8-.08.69 0 1.38.18 1.99.54.15.09.32.2.49.35l1.15.96c-.3.36-.53.76-.7 1.2l-1.38-.52c-.21-.09-.4-.18-.56-.27-.87-.5-1.49-1.27-1.79-2.18zm3.33 7.79c-.21.17-.38.29-.54.37-.61.35-1.3.54-2 .54-.27 0-.53-.03-.79-.08.31-.91.94-1.69 1.78-2.18.17-.1.36-.18.58-.27l1.38-.52c.16.46.41.88.72 1.24l-1.13.9zM12 20.63c-.63-.72-1-1.66-1-2.63 0-.2.02-.41.06-.65l.22-1.42c.23.04.47.07.72.07.24 0 .48-.03.71-.07l.23 1.44c.04.22.06.44.06.63 0 .98-.37 1.91-1 2.63zm6.69-4.24a3.916 3.916 0 01-2.48-.88l-1.15-.96c.3-.36.54-.76.7-1.21l1.38.52c.22.08.41.17.57.26.85.49 1.47 1.27 1.78 2.18-.27.07-.54.09-.8.09z"
                }
            }
        ]
    })(props);
}
function MdOutlineFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlashAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlashOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10h-3.61l2.28 2.28zm0-8H7v1.61l6.13 6.13zm-13.59.86L2 4.27l5 5V13h3v9l3.58-6.15L17.73 20l1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlashOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 2v11h3v9l7-12h-4l3-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlipCameraAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 10V8H5.09C6.47 5.61 9.05 4 12 4c3.72 0 6.85 2.56 7.74 6h2.06c-.93-4.56-4.96-8-9.8-8-3.27 0-6.18 1.58-8 4.01V4H2v6h6zM16 14v2h2.91c-1.38 2.39-3.96 4-6.91 4-3.72 0-6.85-2.56-7.74-6H2.2c.93 4.56 4.96 8 9.8 8 3.27 0 6.18-1.58 8-4.01V20h2v-6h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlipCameraIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l.59-.65L9.88 5h4.24l1.24 1.35.59.65H20v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c-2.21 0-4-1.79-4-4h2l-2.5-2.5L5 13h2c0 2.76 2.24 5 5 5 .86 0 1.65-.24 2.36-.62l-.74-.74c-.49.23-1.04.36-1.62.36zM12 8c-.86 0-1.65.24-2.36.62l.74.73C10.87 9.13 11.42 9 12 9c2.21 0 4 1.79 4 4h-2l2.5 2.5L19 13h-2c0-2.76-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGradient(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9h2v2h-2V9zm-2 2h2v2H9v-2zm4 0h2v2h-2v-2zm2-2h2v2h-2V9zM7 9h2v2H7V9zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineGrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGridOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4v.89l2 2V4h4v4h-2.89l2 2H14v.89l2 2V10h4v4h-2.89l2 2H20v.89l2 2V4c0-1.1-.9-2-2-2H5.11l2 2H8zm8 0h4v4h-4V4zM1.41 1.14L0 2.55l2 2V20c0 1.1.9 2 2 2h15.45l2.01 2.01 1.41-1.41L1.41 1.14zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.55V20zm2 0v-1.45L17.45 20H16z"
                }
            }
        ]
    })(props);
}
function MdOutlineGridOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrEnhancedSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 2C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm1 7h-2V9H9V7h2V5h2v2h2v2h-2v2zm11 9h-2v2h-1.5v-2h-2v-1.5h2v-2H22v2h2V20zm-6-1.5c0 .6-.4 1.1-.9 1.4L18 22h-1.5l-.9-2h-1.1v2H13v-6h3.5c.8 0 1.5.7 1.5 1.5v1zm-1.5 0v-1h-2v1h2zm-13-.5v-2H5v6H3.5v-2.5h-2V22H0v-6h1.5v2h2zm6.5-2c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5H6.5v-6H10zm0 4.5v-3H8v3h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.86L17.14 15h.36zm0-4.5h2v1h-2v-1zm-4.5 0v.36l1.5 1.5V10.5c0-.8-.7-1.5-1.5-1.5h-1.86l1.5 1.5H13zM2.51 2.49L1.45 3.55 6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.06-1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.13 19c1.15.64 2.47 1 3.87 1 4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8c0 2.52 1.17 4.77 3 6.24V13h3.5c.8 0 1.5.7 1.5 1.5v1c0 .6-.4 1.1-.9 1.4L12 19h-1.5l-.9-2H8.5v2h-.37zM12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm5.5 14H16v1.5h-1.5V16H13v-1.5h1.5V13H16v1.49h1.5V16zm-7-.5v-1h-2v1h2zm0-7.5V6H12v6h-1.5V9.5h-2V12H7V6h1.5v2h2zM16 6c.8 0 1.5.7 1.5 1.5v3c0 .8-.7 1.5-1.5 1.5h-3V6h3zm0 4.5v-3h-1.5v3H16z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrStrong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHdrWeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHealing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.73 12.02l3.98-3.98a.996.996 0 000-1.41l-4.34-4.34a.996.996 0 00-1.41 0l-3.98 3.98L8 2.29a1.001 1.001 0 00-1.41 0L2.25 6.63a.996.996 0 000 1.41l3.98 3.98L2.25 16a.996.996 0 000 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34a.996.996 0 000-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
                }
            }
        ]
    })(props);
}
function MdOutlineHevc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 11h-1V9H3v6h1.5v-2.5h1V15H7V9H5.5zM21 11v-1c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-1h-1.5v.5h-1v-3h1v.5H21zM14.25 13.5L13.5 9H12l1 6h2.5l1-6H15zM8 9v6h3.5v-1.5h-2v-1h2V11h-2v-.5h2V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineHideImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v11.17l2 2V5c0-1.1-.9-2-2-2H5.83l2 2H19zM2.81 2.81L1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.41L2.81 2.81zM5 19V7.83l7.07 7.07-.82 1.1L9 13l-3 4h8.17l2 2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineImageAspectRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineImageNotSupported(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 21.9l-6.1-6.1-2.69-2.69L5 5 3.59 3.59 2.1 2.1.69 3.51 3 5.83V19c0 1.1.9 2 2 2h13.17l2.31 2.31 1.42-1.41zM5 19V7.83l6.84 6.84-.84 1.05L9 13l-3 4h8.17l2 2H5zM7.83 5l-2-2H19c1.1 0 2 .9 2 2v13.17l-2-2V5H7.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineImageSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v7H4V6h5.02c.05-.71.22-1.38.48-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5l-2-2zm-1.5 5h-11l2.75-3.53 1.96 2.36 2.75-3.54L16.5 18zm2.8-9.11c.44-.7.7-1.51.7-2.39C20 4.01 17.99 2 15.5 2S11 4.01 11 6.5s2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21 13.42 22.42 12 19.3 8.89zM15.5 9a2.5 2.5 0 010-5 2.5 2.5 0 010 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
                }
            }
        ]
    })(props);
}
function MdOutlineIncompleteCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-2.76 1.12-5.26 2.93-7.07L12 12V2c5.52 0 10 4.48 10 10z"
                }
            }
        ]
    })(props);
}
function MdOutlineIso(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLandscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLeakAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2a9 9 0 01-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2a9 9 0 019-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLeakRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3h-2c0 1.35-.31 2.63-.84 3.77l1.49 1.49C13.51 6.7 14 4.91 14 3zm7 9v-2c-1.91 0-3.7.49-5.27 1.35l1.49 1.49c1.15-.53 2.43-.84 3.78-.84zm0 4v-2c-.79 0-1.54.13-2.24.37l1.68 1.68c.19-.01.37-.05.56-.05zM10 3H8c0 .19-.04.37-.06.56l1.68 1.68c.25-.7.38-1.46.38-2.24zm-5.59-.14L3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97A8.99 8.99 0 013 12v2c2.72 0 5.2-.99 7.11-2.62l2.51 2.51C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.7l1.43 1.43A6.972 6.972 0 0014 21h2c0-1.06.33-2.03.89-2.84L19.73 21l1.41-1.41L4.41 2.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineLens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLinkedCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9v11H4V8h4.05l1.83-2H15V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-2zm.67-1.01H22A6.003 6.003 0 0016 2v1.33c2.58 0 4.66 2.08 4.67 4.66zm-2.67 0h1.33A3.327 3.327 0 0016 4.67V6c1.11 0 1.99.89 2 1.99zM7 14c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5zm8 0c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3 3 1.34 3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLogoDev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.68 14.98H6V9h1.71c1.28 0 1.71 1.03 1.71 1.71v2.56c0 .68-.42 1.71-1.74 1.71zm4.7-3.52v1.07H11.2v1.39h1.93v1.07h-2.25c-.4.01-.74-.31-.75-.71V9.75c-.01-.4.31-.74.71-.75h2.28v1.07H11.2v1.39h1.18zm4.5 2.77c-.48 1.11-1.33.89-1.71 0L13.77 9h1.18l1.07 4.11L17.09 9h1.18l-1.39 5.23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.77 10.12h-.63v3.77h.63c.14 0 .28-.05.42-.16.14-.1.21-.26.21-.47v-2.52c0-.21-.07-.37-.21-.47a.72.72 0 00-.42-.15z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooks3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V9a2 2 0 00-2-2H9v2h4v2h-2v2h2v2H9v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooks4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.04 0h24v24h-24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.04 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-14V5h14v14zm-6-2h2V7h-2v4h-2V7h-2v6h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooks5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4v-2a2 2 0 00-2-2h-2V9h4V7H9v6h4v2H9v2h4a2 2 0 002-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooks6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2a2 2 0 002-2v-2a2 2 0 00-2-2h-2V9h4V7h-4a2 2 0 00-2 2v6a2 2 0 002 2zm0-4h2v2h-2v-2zm8-10H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooksOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-7-2h2V7h-4v2h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooksTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-4-4h-4v-2h2a2 2 0 002-2V9a2 2 0 00-2-2H9v2h4v2h-2a2 2 0 00-2 2v4h6v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLooks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
                }
            }
        ]
    })(props);
}
function MdOutlineLoupe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineMicExternalOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 5c0-1.66-1.34-3-3-3-.62 0-1.19.19-1.67.5l4.15 4.15C9.8 6.18 10 5.61 10 5zM14 6c0-1.1.9-2 2-2s2 .9 2 2v9.17l2 2V6c0-2.21-1.79-4-4-4s-4 1.79-4 4v3.17l2 2V6zM2.1 2.1L.69 3.51 5.17 8H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4v-1.17l6.49 6.49 1.41-1.41L2.1 2.1zM7.19 16h-.38l-.6-6h.96l.56.56L7.19 16zM12 18c0 1.1-.9 2-2 2s-2-.9-2-2h1l.56-5.61L12 14.83V18z"
                }
            }
        ]
    })(props);
}
function MdOutlineMicExternalOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.22 7c.48-.53.78-1.23.78-2 0-1.66-1.34-3-3-3S4 3.34 4 5c0 .77.3 1.47.78 2h4.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 2c-2.21 0-4 1.79-4 4v12c0 1.1-.9 2-2 2s-2-.9-2-2h1l1-10H4l1 10h1c0 2.21 1.79 4 4 4s4-1.79 4-4V6c0-1.1.9-2 2-2s2 .9 2 2v16h2V6c0-2.21-1.79-4-4-4zM7.19 16h-.38l-.6-6h1.58l-.6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineMonochromePhotos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMotionPhotosAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm5.03 3.49h-.07L10.8 12.3h2.39l-1.16-3.31zm-.74-1.49h1.43l3.01 8h-1.39l-.72-2.04h-3.23l-.73 2.04H8.28l3.01-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineMotionPhotosOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.42L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06l10.93 10.94A7.869 7.869 0 0112 20zM12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.05l1.45 1.45A9.782 9.782 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.45 1.45C9.14 4.41 10.52 4 12 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMotionPhotosOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMotionPhotosPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.88 7.88l1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12zM7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5zm4 9.5H9V9h2v6zm4 0h-2V9h2v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineMotionPhotosPaused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-1.19.22-2.32.6-3.38l1.88.68C4.17 10.14 4 11.05 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.95 0-1.85.17-2.69.48l-.68-1.89C9.69 2.22 10.82 2 12 2c5.52 0 10 4.48 10 10zM5.5 4C4.67 4 4 4.67 4 5.5S4.67 7 5.5 7 7 6.33 7 5.5 6.33 4 5.5 4zM11 16V8H9v8h2zm4 0V8h-2v8h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMovieCreation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.76 10H20v8H4V6.47M22 4h-4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMovieFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 11l-.94 2.06L7 14l2.06.94L10 17l.94-2.06L13 14l-2.06-.94zm8.01-7l2 4h-3l-2-4h-2l2 4h-3l-2-4h-2l2 4h-3l-2-4h-1c-1.1 0-1.99.9-1.99 2l-.01 12c0 1.1.9 2 2 2h16c1.1 0 1.99-.9 1.99-2V4h-3.99zm2 14h-16V6.47L5.77 10H16l-.63 1.37L14 12l1.37.63L16 14l.63-1.37L18 12l-1.37-.63L16 10h4.01v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineMp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 9h-3.5v6H15v-1.5h2c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-.5 3H15v-1.5h1.5V12zM11.5 9H7c-.55 0-1 .45-1 1v5h1.5v-4.5h1v3H10v-3h1V15h1.5v-5c0-.55-.45-1-1-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 19V5h14v14H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMusicNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3l.01 10.55c-.59-.34-1.27-.55-2-.55a4.001 4.001 0 100 8c2.22 0 3.99-1.79 3.99-4V7h4V3h-6zm-1.99 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMusicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h4V3h-6v4.61l2 2zm-2 3.44L4.41 2.86 3 4.27l9 9v.28c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07a4.007 4.007 0 004.59 4.65c1.96-.31 3.35-2.11 3.35-4.1v-1.58L19.73 21l1.41-1.41L12 10.44zM10 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNaturePeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0014 16.06V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88a7 7 0 006.17-6.95zm-7 5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16.12h-.03c3.49-.4 6.2-3.36 6.2-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7A6.98 6.98 0 0011 16.06V20H5v2h14v-2h-6v-3.88zM7.17 9.17c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNavigateBefore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.61 7.41L14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineNavigateNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0112 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 00-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 012.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17.5",
                    "cy": "11.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaFishEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaHorizontalSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5c-3.89 0-6.95-.84-8.69-1.43A.993.993 0 002 5.02V19c0 .68.66 1.17 1.31.95C5.36 19.26 8.1 18.5 12 18.5c3.87 0 6.66.76 8.69 1.45A.999.999 0 0022 19V5c0-.68-.66-1.17-1.31-.95-2.03.68-4.83 1.45-8.69 1.45z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16s-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7s-6.18-.55-9.12-1.64A.94.94 0 002.57 4c-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64s6.18.55 9.12 1.64c.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaPhotosphereSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 8.15c-.29-.16-.61-.31-.93-.46C19.4 4.33 15.98 2 12 2 8.02 2 4.6 4.33 2.99 7.68c-.33.15-.64.3-.93.46C1.41 8.5 1 9.17 1 9.91v4.18c0 .74.41 1.41 1.05 1.77.29.16.61.31.93.46C4.6 19.67 8.02 22 12 22c3.98 0 7.4-2.33 9.01-5.68.33-.15.64-.3.93-.46.65-.36 1.06-1.03 1.06-1.77V9.91c0-.74-.41-1.41-1.05-1.76zM12 4c2.37 0 4.49 1.04 5.95 2.68C16.17 6.25 14.15 6 12 6c-2.15 0-4.17.25-5.95.68A7.943 7.943 0 0112 4zm0 16c-2.37 0-4.49-1.04-5.95-2.68 1.78.43 3.8.68 5.95.68s4.17-.25 5.95-.68A7.943 7.943 0 0112 20z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaPhotosphere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 8.15c-.29-.16-.61-.31-.93-.46C19.4 4.33 15.98 2 12 2 8.02 2 4.6 4.33 2.99 7.68c-.33.15-.64.3-.93.46C1.41 8.5 1 9.17 1 9.91v4.18c0 .74.41 1.41 1.05 1.77.29.16.61.31.93.46C4.6 19.67 8.02 22 12 22c3.98 0 7.4-2.33 9.01-5.68.33-.15.64-.3.93-.46.65-.36 1.06-1.03 1.06-1.77V9.91c0-.74-.41-1.41-1.05-1.76zM21 9.91v4.19c-2.19 1.21-5.47 1.9-9 1.9-3.53 0-6.81-.7-9-1.91V9.91C5.2 8.69 8.47 8 12 8c3.53 0 6.81.7 9 1.91zM12 4c2.37 0 4.49 1.04 5.95 2.68C16.17 6.25 14.15 6 12 6c-2.15 0-4.17.25-5.95.68A7.943 7.943 0 0112 4zm0 16c-2.37 0-4.49-1.04-5.95-2.68 1.78.43 3.8.68 5.95.68s4.17-.25 5.95-.68A7.943 7.943 0 0112 20z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaVerticalSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 12c0-3.89.84-6.95 1.43-8.69A.993.993 0 0018.98 2H5c-.68 0-1.16.66-.95 1.31C4.74 5.36 5.5 8.1 5.5 12c0 3.87-.76 6.66-1.45 8.69-.21.65.27 1.31.95 1.31h14c.68 0 1.17-.66.95-1.31-.68-2.03-1.45-4.83-1.45-8.69z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12s.55-6.18 1.64-9.12a.94.94 0 00.06-.31c0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12s-.55 6.18-1.64 9.12c-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8s-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8s.39 5.4 1.16 8H6.54z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaWideAngleSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c-3.97 0-6.85.63-9 1-.55 1.97-1 3.92-1 7 0 3.03.45 5.05 1 7 2.15.37 4.98 1 9 1 3.97 0 6.85-.63 9-1 .57-2.02 1-3.99 1-7 0-3.03-.45-5.05-1-7-2.15-.37-4.98-1-9-1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanoramaWideAngle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36s-.24 3.58-.71 5.36c-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12s.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePanorama(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H3V6h18v12zm-6.5-7L11 15.51 8.5 12.5 5 17h14z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoAlbum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V4h5v7l2.5-1.5L16 11V4h2v16zm-4.38-6.5L17 18H7l2.38-3.17L11 17l2.62-3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoCameraBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.25 16L9 13l-3 4h12l-3.75-5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoCameraFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14H4V7h4.05l1.83-2h4.24l1.83 2H20v12z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.78 14.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 008 16.43V17h8v-.57c0-.81-.48-1.53-1.22-1.85z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.12 4l1.83 2H20v12H4V6h4.05l1.83-2h4.24M15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2zm-3 7c1.65 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3 1.35-3 3-3m0-2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10v9H4.98V5h9V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zm-2.94-2.06L17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7zM12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12l-2.75-1.25z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v12H8V4h12m0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoSizeSelectActual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 15.92c-.02.03-.06.06-.08.08H3V5.08L3.08 5h17.83c.03.02.06.06.08.08v13.84zm-10-3.41L8.5 12.5 5 17h14l-4.5-6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoSizeSelectLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhotoSizeSelectSmall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4.86 8.86l-3 3.87L9 13.14 6 17h12l-3.86-5.14z"
                }
            }
        ]
    })(props);
}
function MdOutlinePictureAsPdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm12 6V9c0-.55-.45-1-1-1h-2v5h2c.55 0 1-.45 1-1zm-2-3h1v3h-1V9zm4 2h1v-1h-1V9h1V8h-2v5h1zm-8 0h1c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9v5h1v-2zm0-2h1v1h-1V9z"
                }
            }
        ]
    })(props);
}
function MdOutlinePortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V18h12v-1.42zM8.48 16c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48zM19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineRawOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.15 14.32l.59-2.36.76 3.04h1.48l1.5-6h-1.5l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l.72 2.9zM1.39 4.22L6.17 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-.67l1.43 1.43L8.75 15h1.5l.38-1.5h.04l9.11 9.11 1.41-1.41L2.81 2.81 1.39 4.22zM6.5 11.5h-2v-1h2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineRawOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 9H3v6h1.5v-2h1.1l.9 2H8l-.9-2.1c.5-.3.9-.8.9-1.4v-1C8 9.7 7.3 9 6.5 9zm0 2.5h-2v-1h2v1zM10.25 9l-1.5 6h1.5l.38-1.5h1.75l.37 1.5h1.5l-1.5-6h-2.5zm.75 3l.25-1h.5l.25 1h-1zM19.98 9l-.74 3-.74-3h-1.52l-.74 3-.74-3H14l1.5 6h1.48l.76-3.04.76 3.04h1.48l1.5-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineReceiptLong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2v14H3v3c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V2l-1.5 1.5zM15 20H6c-.55 0-1-.45-1-1v-1h10v2zm4-1c0 .55-.45 1-1 1s-1-.45-1-1v-3H8V5h11v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7h6v2H9zM16 7h2v2h-2zM9 10h6v2H9zM16 10h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveRedEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.5a9.77 9.77 0 018.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0112 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5a2.5 2.5 0 010 5 2.5 2.5 0 010-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineRotate90DegreesCcw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26A8.95 8.95 0 0013 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 010 9.9 6.973 6.973 0 01-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 000-12.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineRotate90DegreesCw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 13a9 9 0 0013.79 7.62l-1.46-1.46c-.99.53-2.13.84-3.33.84-3.86 0-7-3.14-7-7s3.14-7 7-7h.17L9.59 7.59 11 9l4-4-4-4-1.42 1.41L11.17 4H11a9 9 0 00-9 9zm9 0l6 6 6-6-6-6-6 6zm6 3.17L13.83 13 17 9.83 20.17 13 17 16.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
                }
            }
        ]
    })(props);
}
function MdOutlineRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11a7.906 7.906 0 00-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineShutterSpeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1H9v2h6V1zm4.03 6.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-.32-5H6.35a5.992 5.992 0 003.41 3.56l-.11-.06 2.03-3.5zm5.97-4a6.012 6.012 0 00-3.34-3.54L12.26 11h5.39zm-7.04 7.83c.45.11.91.17 1.39.17 1.34 0 2.57-.45 3.57-1.19l-2.11-3.9-2.85 4.92zM7.55 8.99A5.965 5.965 0 006 13c0 .34.04.67.09 1h4.72L7.55 8.99zm8.79 8.14A5.94 5.94 0 0018 13c0-.34-.04-.67-.09-1h-4.34l2.77 5.13zm-3.01-9.98C12.9 7.06 12.46 7 12 7c-1.4 0-2.69.49-3.71 1.29l2.32 3.56 2.72-4.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineSlideshow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineStraighten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
                }
            }
        ]
    })(props);
}
function MdOutlineStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98a2.013 2.013 0 00-1.81-1.23c-.26 0-.53.04-.79.15L7.1 5.95a1.999 1.999 0 00-1.08 2.6l4.96 11.97a1.998 1.998 0 002.6 1.08l7.36-3.05a1.994 1.994 0 001.09-2.6zm-9.2 3.8L7.87 7.79l7.35-3.04h.01l4.95 11.95-7.35 3.05z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "9",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.88 19.75c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM9.88 4h4.24l1.83 2H20v12H4V6h4.05"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11H9V8.5L5.5 12 9 15.5V13h6v2.5l3.5-3.5L15 8.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 13h4v2l3-3-3-3v2H8V9l-3 3 3 3zm10-3.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zM16 17H4V7h12v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineTagFaces(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTexture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
                }
            }
        ]
    })(props);
}
function MdOutlineThermostatAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12V6c0-1.66-1.34-3-3-3S5 4.34 5 6v6c-1.21.91-2 2.37-2 4 0 1.12.38 2.14 1 2.97V19h.02c.91 1.21 2.35 2 3.98 2s3.06-.79 3.98-2H12v-.03c.62-.83 1-1.85 1-2.97 0-1.63-.79-3.09-2-4zm-6 4c0-.94.45-1.84 1.2-2.4L7 13V6c0-.55.45-1 1-1s1 .45 1 1v7l.8.6c.75.57 1.2 1.46 1.2 2.4H5zM18.62 4h-1.61l-3.38 9h1.56l.81-2.3h3.63l.8 2.3H22l-3.38-9zm-2.15 5.39l1.31-3.72h.08l1.31 3.72h-2.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimelapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 7.75A5.974 5.974 0 0012 5.99v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 00-.01-8.48zM12 1.99c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimer10(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M-.01 7.72V9.4l3-1V18h2V6h-.25L-.01 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23c-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3a.978.978 0 01.01-.8c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95A2.517 2.517 0 0023 9.81c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66s.98.25 1.58.25c.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27s-1.11.09-1.59.27c-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89s1.01.28 1.59.28c.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89s.6-.94.78-1.6c.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53s-.2.76-.36 1.02c-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02s-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52s.21-.74.38-1c.16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99s.13.92.13 1.52v2.51h-.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimer3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.61 12.97c-.16-.24-.36-.46-.62-.65a3.38 3.38 0 00-.93-.48c.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33s.46-.12.73-.12c.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57s-.38.28-.63.37-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36s-.3-.34-.39-.56c-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23s.91-.38 1.26-.68c.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38a6.64 6.64 0 01-.87-.23c-.23-.08-.41-.16-.55-.25s-.23-.19-.28-.3c-.05-.11-.08-.24-.08-.39s.03-.28.09-.41.15-.25.27-.34c.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11s.35.17.48.29.22.26.29.42c.06.16.1.32.1.49h1.95a2.517 2.517 0 00-.93-1.97c-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21s-.77.33-1.06.57c-.29.24-.51.52-.67.84s-.23.65-.23 1.01.08.68.23.96.37.52.64.73c.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77s-.66.29-1.17.29c-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24a1.333 1.333 0 01-.59-1.11h-1.89c0 .36.08.71.24 1.05s.39.65.7.93c.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 1h6v2H9zM12 6c3.87 0 7 3.13 7 7 0 .94-.19 1.83-.52 2.65l1.5 1.5a8.963 8.963 0 00-.95-9.76l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42a8.962 8.962 0 00-9.77-.96l1.5 1.5A7.07 7.07 0 0112 6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.17l2 2V8h-2zM2.81 2.81L1.39 4.22l3.4 3.4a8.994 8.994 0 0012.59 12.59l2.4 2.4 1.41-1.41L2.81 2.81zM12 20c-3.87 0-7-3.13-7-7 0-1.47.45-2.83 1.22-3.95l9.73 9.73A6.945 6.945 0 0112 20z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineTonality(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineTransform(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineTune(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoCameraBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM16 18H4V6h12v12zm-4.38-6.5L9 15l-1.62-2.17L5 16h10l-3.38-4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoCameraFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zm-2-.79V18H4V6h12v3.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "10",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 15.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 006 15.43V16h8v-.57z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoStable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 18V6h2.95l-2.33 8.73L16.82 18H4zm11.62-2.39l-8.55-2.29L8.38 8.4l8.56 2.29-1.32 4.92zM20 18h-2.95l2.34-8.73L7.18 6H20v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewComfy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm2 2h16v5H4V6zm0 12v-5h4v5H4zm6 0v-5h10v5H10z"
                }
            }
        ]
    })(props);
}
function MdOutlineViewCompact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4v16h20V4H2zm4.5 14H4v-2.5h2.5V18zm0-4.75H4v-2.5h2.5v2.5zm0-4.75H4V6h2.5v2.5zM11 18H8.5v-2.5H11V18zm0-4.75H8.5v-2.5H11v2.5zm0-4.75H8.5V6H11v2.5zm4.5 9.5H13v-2.5h2.5V18zm0-4.75H13v-2.5h2.5v2.5zm0-4.75H13V6h2.5v2.5zM20 18h-2.5v-2.5H20V18zm0-4.75h-2.5v-2.5H20v2.5zm0-4.75h-2.5V6H20v2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineVignette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5v14H3V5h18m0-2H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 5c3.25 0 6 1.83 6 4s-2.75 4-6 4-6-1.83-6-4 2.75-4 6-4m0-2c-4.42 0-8 2.69-8 6s3.58 6 8 6 8-2.69 8-6-3.58-6-8-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineVrpano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.01 4C20.45 4 17.4 5.5 12 5.5c-5.31 0-8.49-1.49-9.01-1.49-.53 0-.99.44-.99 1.01V19c0 .57.46 1 .99 1 .57 0 3.55-1.5 9.01-1.5 5.42 0 8.44 1.5 9.01 1.5.53 0 .99-.43.99-1V5c0-.57-.46-1-.99-1zM20 17.63c-2.01-.59-4.62-1.13-8-1.13-3.39 0-5.99.54-8 1.13V6.38c2.58.73 5.32 1.12 8 1.12 3.38 0 5.99-.54 8-1.13v11.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.17 10.99l-3.69 4.42c2-.26 4.18-.41 6.52-.41 2.3 0 4.52.15 6.51.4L14 10l-2.83 3.39-2-2.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbAuto(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 7l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L9 7H7zm-.15 5.65L8 9l1.15 3.65h-2.3zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76l-.01.01C12.76 5.18 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c2.96 0 5.55-1.61 6.93-4 .03-.06.05-.12.08-.18.05-.08.09-.17.14-.25l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-8.63 7.67C12.38 16.64 10.35 18 8 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6c0 .96-.23 1.86-.63 2.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbCloudy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 6c2.61 0 4.89 1.86 5.4 4.43l.3 1.5 1.52.11c1.56.11 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3h-13c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95A5.457 5.457 0 0112.01 6m0-2C9.12 4 6.6 5.64 5.35 8.04 2.35 8.36.01 10.91.01 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96C18.68 6.59 15.65 4 12.01 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbIncandescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3.55 19.09l1.41 1.41 1.79-1.8-1.41-1.41zM11 20h2v3h-2zM1 11h3v2H1zm12-6.95v3.96l1 .58c1.24.72 2 2.04 2 3.46 0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.42.77-2.74 2-3.46l1-.58V4.05h2m2-2H9v4.81C7.21 7.9 6 9.83 6 12.05c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19V2.05zM20 11h3v2h-3zm-2.76 7.71l1.79 1.8 1.41-1.41-1.8-1.79z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbIridescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h14V9H5v6zm2-4h10v2H7v-2zm4-10h2v3h-2zm9.46 4.01L19.04 3.6l-1.79 1.79 1.41 1.41zM11 20h2v3h-2zm6.24-1.29l1.79 1.8 1.42-1.42-1.8-1.79zM4.96 3.595l1.788 1.79L5.34 6.79 3.553 5.003zM3.55 19.08l1.41 1.42 1.79-1.8-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbShade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12v2.5l5.5 5.5H22l-8-8zm0 8h3l-3-3v3zM8 4l-6 6h2v10h8V10h2L8 4zm1 10H7v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbSunny(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79zM1 10.5h3v2H1zM11 .55h2V3.5h-2zm8.04 2.495l1.408 1.407-1.79 1.79-1.407-1.408zm-1.8 15.115l1.79 1.8 1.41-1.41-1.8-1.79zM20 10.5h3v2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm-1 4h2v2.95h-2zm-7.45-.96l1.41 1.41 1.79-1.8-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineWbTwilight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.955 8.662l2.12-2.122 1.416 1.414-2.121 2.122zM2 18h20v2H2zM11 4h2v3h-2zM3.543 7.925L4.957 6.51l2.121 2.12-1.414 1.415zM5 16h14c0-3.87-3.13-7-7-7s-7 3.13-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutline360(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddBusiness(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 4h15v2H2zM15 17h2v-3h1v-2l-1-5H2l-1 5v2h1v6h9v-6h4v3zm-6 1H4v-4h5v4zm-5.96-6l.6-3h11.72l.6 3H3.04z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 18h-3v-3h-2v3h-3v2h3v3h2v-3h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddLocationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 1v3h3v2h-3v3h-2V6h-3V4h3V1h2zm-8 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1-9.94v2.02A6.53 6.53 0 0012 5c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.79 6-9.14V11h2v.2c0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 6.22 7.8 3 12 3c.34 0 .67.02 1 .06z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6v3h3v2h-3v3h-2v-3H8V9h3V6h2zm5 4.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 18v-3h-2v3h-3v2h3v3h2v-3h3v-2zM18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAgriculture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9h5c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 14.06V8c0-1.1-.9-2-2-2h-6.29l-1.06-1.06 1.41-1.41-.71-.71-3.53 3.53.71.71 1.41-1.41L13 6.71V9c0 1.1-.9 2-2 2H8.96c-.22-.16-.45-.3-.69-.43l-.4.89-.46-.21.4-.9C7.26 10.13 6.64 10 6 10c-.53 0-1.04.11-1.52.26l.34.91-.47.18-.35-.93a4.92 4.92 0 00-2.43 2.31l.89.4-.21.46-.9-.4C1.13 13.74 1 14.36 1 15c0 .53.11 1.04.26 1.52l.91-.34.18.47-.93.35a4.92 4.92 0 002.31 2.43l.4-.89.46.21-.4.9c.55.22 1.17.35 1.81.35.53 0 1.04-.11 1.52-.26l-.34-.91.47-.18.35.93a4.92 4.92 0 002.43-2.31l-.89-.4.21-.46.9.4c.1-.26.18-.54.24-.82h5.16c-.02.17-.05.34-.05.51 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.95-.38-1.81-1-2.44zM6 18c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm4.87-4c-.04-.18-.08-.35-.13-.52l-.91.34-.18-.47.93-.35H11c2.21 0 4-1.79 4-4V8h5v5.05c-.16-.02-.33-.05-.5-.05-.95 0-1.81.38-2.44 1h-6.19zm8.63 4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineStops(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8.7c-2.46 1.5-5.5 4.17-6 8.3h2v2H9v-2h2c-.5-4.5-4.37-8-9-8V7c4.39 0 8.22 2.55 10 6.3 1.38-2.97 3.86-5.03 5.96-6.31L14 7V5h7v7h-2V8.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 18H5.8l8.25-12h5.54l-2.25 12zM13 4L2 20h17l3-16h-9zm1.5 5a2.5 2.5 0 000 5 2.5 2.5 0 000-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAltRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.78 11.16l-1.42 1.42a7.282 7.282 0 01-1.79-2.94l1.94-.49c.32.89.77 1.5 1.27 2.01zM11 6L7 2 3 6h3.02c.02.81.08 1.54.19 2.17l1.94-.49C8.08 7.2 8.03 6.63 8.02 6H11zm10 0l-4-4-4 4h2.99c-.1 3.68-1.28 4.75-2.54 5.88-.5.44-1.01.92-1.45 1.55-.34-.49-.73-.88-1.13-1.24L9.46 13.6c.93.85 1.54 1.54 1.54 3.4v5h2v-5c0-2.02.71-2.66 1.79-3.63 1.38-1.24 3.08-2.78 3.2-7.37H21z"
                }
            }
        ]
    })(props);
}
function MdOutlineAtm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 9v1.5h2.25V15h1.5v-4.5H14V9H8zM6 9H3c-.55 0-1 .45-1 1v5h1.5v-1.5h2V15H7v-5c0-.55-.45-1-1-1zm-.5 3h-2v-1.5h2V12zM21 9h-4.5c-.55 0-1 .45-1 1v5H17v-4.5h1V14h1.5v-3.51h1V15H22v-5c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAttractions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.15 14.42c.23-.77.35-1.58.35-2.42s-.12-1.65-.35-2.42c.78-.6 1.02-1.7.51-2.58s-1.58-1.23-2.49-.85a8.53 8.53 0 00-4.18-2.42C13.85 2.75 13.01 2 12 2s-1.85.75-1.98 1.73a8.561 8.561 0 00-4.19 2.42c-.91-.38-1.98-.03-2.49.85s-.27 1.98.51 2.58c-.23.77-.35 1.58-.35 2.42s.12 1.65.35 2.42c-.78.6-1.02 1.7-.51 2.58s1.58 1.23 2.49.85c.4.42.83.79 1.3 1.12L5.78 22h1.88l.98-2.19c.44.19.9.34 1.38.46.13.98.97 1.73 1.98 1.73s1.85-.75 1.98-1.73c.46-.11.91-.26 1.34-.44L16.3 22h1.88l-1.34-3c.48-.34.93-.72 1.34-1.15.91.38 1.99.03 2.49-.85.5-.88.26-1.98-.52-2.58zm-6.59 4.33c-.37-.46-.93-.75-1.56-.75s-1.2.29-1.57.75c-.4-.09-.79-.21-1.16-.37l1.43-3.19a3.522 3.522 0 002.56.02l1.42 3.18c-.36.15-.73.27-1.12.36zm-3.08-6.73c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zm8.23 1.99c-.61.07-1.18.41-1.52.99-.32.56-.34 1.2-.12 1.75-.28.29-.58.55-.9.79l-1.5-3.35c.49-.59.78-1.34.78-2.16 0-1.89-1.55-3.41-3.46-3.41s-3.46 1.53-3.46 3.41c0 .8.28 1.54.75 2.13l-1.52 3.39c-.31-.23-.6-.48-.87-.76.26-.56.24-1.22-.09-1.79-.34-.59-.93-.94-1.56-.99-.22-.68-.33-1.4-.33-2.15 0-.64.09-1.26.25-1.85.66-.03 1.3-.38 1.65-1 .37-.63.35-1.38.01-1.98.92-.98 2.11-1.69 3.45-2.03.34.59.99 1 1.73 1s1.39-.4 1.73-1c1.34.34 2.53 1.07 3.44 2.05-.32.59-.33 1.33.03 1.95.35.6.96.95 1.6 1 .16.59.25 1.21.25 1.86 0 .75-.12 1.47-.34 2.15z"
                }
            }
        ]
    })(props);
}
function MdOutlineBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12h4v1.5h-4zM14 15h4v1.5h-4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9 0V4h2v5h-2V7zm9 13H4V9h5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5v11z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.08 16.18c-.64-.28-1.34-.43-2.08-.43s-1.44.15-2.08.43c-.56.24-.92.78-.92 1.39V18h6v-.43c0-.61-.36-1.15-.92-1.39z"
                }
            }
        ]
    })(props);
}
function MdOutlineBakeryDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 10.94c.13-.32.1-.23.15-.39.3-1.21-.34-2.47-1.5-2.93l-2.01-.8c-.46-.18-.95-.21-1.41-.12-.11-.33-.29-.63-.52-.89-.48-.52-1.15-.81-1.85-.81h-2.71c-.71 0-1.38.29-1.85.81-.24.26-.42.56-.53.88-.46-.09-.95-.06-1.41.12l-2.01.8c-1.16.46-1.8 1.72-1.5 2.93l.15.38C1.1 15.55 1 15.55 1 16.38c0 .91.46 1.74 1.24 2.22 1.42.88 2.49.14 4-.61h11.53c1.52.76 1.86 1.01 2.63 1.01 1 0 2.61-.77 2.61-2.61-.01-.85-.13-.88-2.51-5.45zm-.38 5.99l-1.68-.84 1.08-2.7 1.41 2.71c.28.53-.29 1.09-.81.83zm-5.03-.94l.62-6.9c.03-.33.37-.54.68-.42l2.01.8c.22.09.34.31.31.54l-2.4 5.98h-1.22zm-7.41 0l-2.4-5.98c-.03-.23.09-.45.31-.54l2.01-.8c.31-.12.65.08.68.42l.62 6.9H7.68zm-4.61.11l1.41-2.72 1.08 2.71-1.68.84c-.52.26-1.09-.3-.81-.83zm7.08-8.56a.5.5 0 01.5-.54h2.71a.5.5 0 01.5.54l-.77 8.45h-2.17l-.77-8.45z"
                }
            }
        ]
    })(props);
}
function MdOutlineBeenhere(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-7 19.6l-7-4.66V3h14v12.93l-7 4.67zm-2.01-7.42l-2.58-2.59L6 12l4 4 8-8-1.42-1.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineBikeScooter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14h.74L8.82 5.56A2.009 2.009 0 006.87 4H3v2h3.87l1.42 6.25h-.01A6.008 6.008 0 004.09 17H0v2h6v-1c0-2.21 1.79-4 4-4zM19 8h-.82l-1.35-3.69A1.976 1.976 0 0014.96 3H11v2h3.96l1.1 3H10.4l.46 2H15c-.43.58-.75 1.25-.9 2h-2.79l.46 2h2.33c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 10.2 21.8 8 19 8zm0 8c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 15c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBreakfastDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3H6C3.79 3 2 4.79 2 7c0 1.48.81 2.75 2 3.45V19c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8.55c1.19-.69 2-1.97 2-3.45 0-2.21-1.79-4-4-4zm1 5.72l-1 .58V19H6V9.31l-.99-.58C4.38 8.35 4 7.71 4 7c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2 0 .71-.38 1.36-1 1.72z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.71 9.29C12.51 9.1 12.26 9 12 9s-.51.1-.71.29l-3 3a.996.996 0 000 1.41l3 3c.2.2.45.3.71.3s.51-.1.71-.29l3-3a.996.996 0 000-1.41l-3-3.01zM12 14.58L10.41 13 12 11.41 13.59 13 12 14.58z"
                }
            }
        ]
    })(props);
}
function MdOutlineBrunchDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 21.5c0 .28.22.5.49.5h13.02c.27 0 .49-.22.49-.5V20H2v1.5zM15.5 16H11v-2H7v2H2.5c-.28 0-.5.22-.5.5V18h14v-1.5c0-.28-.22-.5-.5-.5zM20.47 15.45A5.796 5.796 0 0022 11.51V2h-6v9.47c0 1.48.58 2.92 1.6 4l.4.42V22h4v-2h-2v-4.03l.47-.52zM18 4h2v4h-2V4zm1.03 10.07a3.893 3.893 0 01-1.03-2.6V10h2v1.51c0 .95-.34 1.85-.97 2.56z"
                }
            }
        ]
    })(props);
}
function MdOutlineBusAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V8h7.29C11.1 7.37 11 6.7 11 6H4.43c.83-.71 2.98-1.09 6.65-.98.1-.7.3-1.37.59-1.99C2.97 2.67 2 5.02 2 7v9.5c0 .95.38 1.81 1 2.44V21c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-2.06c.62-.63 1-1.49 1-2.44V13c-1.91 0-3.63-.76-4.89-2H4zm12 5c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-3h12v3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V8h1v1zm0-2h-1V3h1v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCarCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 6h-1V3h1v4zm0 1v1h-1V8h1zM6 13.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 15 7.5 15 6 14.33 6 13.5zm13-.57a6.72 6.72 0 002-.6V19c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1H6v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-8l2.08-5.99C5.29 4.42 5.84 4 6.5 4h4.79c-.19.63-.29 1.31-.29 2H6.85L5.81 9h5.86c.36.75.84 1.43 1.43 2H5v5h14v-3.07zm-1.09.07a6.92 6.92 0 01-2.53-.51c-.23.27-.38.62-.38 1.01 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.18-.03-.34-.09-.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCarRental(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "16.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "16.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.25 9.6c-.02-.02-.03-.04-.05-.07-.38-.52-.92-.53-.92-.53H7.72s-.54.01-.92.54c-.02.02-.03.04-.05.06-.07.11-.14.24-.19.4-.22.66-.74 2.22-1.56 4.69v6.5c0 .45.35.81.78.81h.44c.43 0 .78-.36.78-.81V20h10v1.19c0 .45.34.81.78.81h.44c.43 0 .78-.36.78-.81v-6.5c-.82-2.46-1.34-4.03-1.56-4.69-.05-.16-.12-.29-.19-.4zM8.33 11h7.34l.23.69.43 1.31H7.67l.66-2zM17 18H7v-3h10v3zM10.83 3A3.01 3.01 0 008 1C6.34 1 5 2.34 5 4c0 1.65 1.34 3 3 3 1.3 0 2.41-.84 2.83-2H16v2h2V5h1V3h-8.17zM8 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCarRepair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "10.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "10.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.78 16h.44c.43 0 .78-.36.78-.81V14h10v1.19c0 .45.34.81.78.81h.44c.43 0 .78-.36.78-.81v-6.5L17.44 4c-.05-.16-.12-.29-.19-.4-.02-.02-.03-.04-.05-.07-.38-.52-.92-.53-.92-.53H7.72s-.54.01-.92.54c-.02.02-.03.04-.05.06-.07.11-.14.24-.19.4L5 8.69v6.5c0 .45.35.81.78.81zM8.33 5h7.34l.23.69.43 1.31H7.67l.66-2zM7 9.01V9h10v3H7V9.01zM4 17.01V19h7v3h2v-3h7v-1.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineCastle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9v2h-2V3h-2v2h-2V3h-2v2h-2V3H9v2H7V3H5v8H3V9H1v12h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9V9h-2zm0 10h-5v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v1H3v-6h4V7h10v6h4v6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9h2v3H9zM13 9h2v3h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCategory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCelebration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 22l14-5-9-9-5 14zm10.35-5.82L5.3 18.7l2.52-7.05 4.53 4.53zM14.53 12.53l5.59-5.59a1.25 1.25 0 011.77 0l.59.59 1.06-1.06-.59-.59a2.758 2.758 0 00-3.89 0l-5.59 5.59 1.06 1.06zM10.06 6.88l-.59.59 1.06 1.06.59-.59a2.758 2.758 0 000-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76zM17.06 11.88l-1.59 1.59 1.06 1.06 1.59-1.59a1.25 1.25 0 011.77 0l1.61 1.61 1.06-1.06-1.61-1.61a2.758 2.758 0 00-3.89 0zM15.06 5.88l-3.59 3.59 1.06 1.06 3.59-3.59a2.758 2.758 0 000-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77z"
                }
            }
        ]
    })(props);
}
function MdOutlineChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 12.22V9l-5-2.5V5h2V3h-2V1h-2v2H9v2h2v1.5L6 9v3.22L2 14v8h9v-4c0-.55.45-1 1-1s1 .45 1 1v4h9v-8l-4-1.78zM20 20h-5v-2.04c0-1.69-1.35-3.06-3-3.06s-3 1.37-3 3.06V20H4v-4.79l4-1.81v-3.35L12 8l4 2.04v3.35l4 1.81V20z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineCleaningServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 11h-1V3c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v8H8c-2.76 0-5 2.24-5 5v7h18v-7c0-2.76-2.24-5-5-5zm-5-8h2v8h-2V3zm8 18h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCompassCalibration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-17C8.1 3 4.56 4.59 2 7.15l5 5a7.06 7.06 0 0110-.01l5-5C19.44 4.59 15.9 3 12 3zm4.84 6.47c-1.44-.91-3.1-1.4-4.84-1.4-1.74 0-3.41.49-4.85 1.41L4.94 7.26C6.99 5.79 9.44 5 12 5c2.56 0 5 .79 7.05 2.26l-2.21 2.21z"
                }
            }
        ]
    })(props);
}
function MdOutlineConnectingAirports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.4 17l1.3 4.4h-1.1L13 17h-3c-.55 0-1-.45-1-1s.45-1 1-1h3l2.6-4.4h1.1L15.4 15h2.85l.75-1h1l-.6 2 .6 2h-1l-.75-1H15.4zM5.75 7L5 6H4l.6 2-.6 2h1l.75-1H8.6l-1.3 4.4h1.1L11 9h3c.55 0 1-.45 1-1s-.45-1-1-1h-3L8.4 2.6H7.3L8.6 7H5.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrisisAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 2.5c0 1.5-1.5 6-1.5 6h-2S9.5 4 9.5 2.5a2.5 2.5 0 015 0zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4.08-4.89c.18-.75.33-1.47.39-2.06A9.996 9.996 0 0122 12c0 5.52-4.48 10-10 10S2 17.52 2 12c0-3.92 2.25-7.31 5.53-8.95.07.59.21 1.32.39 2.06A8.028 8.028 0 004 12c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.93-1.58-5.49-3.92-6.89zM18 12c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2 .98-3.77 2.48-4.86.23.81.65 2.07.65 2.07C8.43 9.93 8 10.92 8 12c0 2.21 1.79 4 4 4s4-1.79 4-4c0-1.08-.43-2.07-1.13-2.79 0 0 .41-1.22.65-2.07A5.998 5.998 0 0118 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeliveryDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM4 14v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDepartureBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 1a6.98 6.98 0 00-5.75 3.02C9.84 4.01 9.43 4 9 4c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V22c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22v-3.08c3.39-.49 6-3.39 6-6.92 0-3.87-3.13-7-7-7zM9 6h.29c-.09.32-.16.66-.21.99H3.34C3.89 6.46 5.31 6 9 6zM3 8.99h6.08c.16 1.11.57 2.13 1.18 3.01H3V8.99zM15 18c0 .37-.21.62-.34.73l-.29.27H3.63l-.29-.27A.968.968 0 013 18v-4h9.41c.78.47 1.65.79 2.59.92V18zm1-5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm.5-9H15v5l3.62 2.16.75-1.23-2.87-1.68z"
                }
            }
        ]
    })(props);
}
function MdOutlineDesignServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.97 7.27a.996.996 0 000-1.41l-2.83-2.83a.996.996 0 00-1.41 0l-4.49 4.49-3.89-3.89c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l3.89 3.89L3 16.76V21h4.24l4.52-4.52 3.89 3.89c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-3.89-3.89 4.48-4.48zM5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.2 1.2-1.9 1.9-3.88-3.88zm11.23 7.44l-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9-3.89-3.89 1.9-1.9 1.21 1.21zM6.41 19H5v-1.41l9.61-9.61 1.3 1.3.11.11L6.41 19zm9.61-12.44l1.41-1.41 1.41 1.41-1.41 1.41-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineDiamond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5L2 9l10 12L22 9l-3-6zM9.62 8l1.5-3h1.76l1.5 3H9.62zM11 10v6.68L5.44 10H11zm2 0h5.56L13 16.68V10zm6.26-2h-2.65l-1.5-3h2.65l1.5 3zM6.24 5h2.65l-1.5 3H4.74l1.5-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDinnerDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19l2 2h16l2-2zM3 18h16.97c.29-3.26-2.28-6-5.48-6-2.35 0-4.35 1.48-5.14 3.55-.41-.23-.87-.38-1.35-.47V9h1.75C10.99 9 12 7.99 12 6.75h9v-1.5h-9C12 4.01 10.99 3 9.75 3H3v1.5h1v.75H3v1.5h1v.75H3V9h1v7.39c-.44.46-.78 1-1 1.61zm11.5-4c.99 0 1.91.4 2.58 1.14.24.26.44.55.58.86h-6.32c.58-1.21 1.81-2 3.16-2zM8 4.5h2v.75H8V4.5zm0 2.25h2v.75H8v-.75zM5.5 4.5h1v.75h-1V4.5zm0 2.25h1v.75h-1v-.75zM5.5 9h1v6.06c-.35.06-.68.17-1 .3V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsBoatFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 12.66l-1.12 3.97c-.78-.43-1.07-.86-2.65-2.67-1.6 1.82-2.43 3.04-4 3.04-1.53 0-2.34-1.15-4-3.04-1.6 1.82-1.87 2.21-2.65 2.65l-1.13-3.96L12 10.11l7.77 2.55zM15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.63.19-.81.84-.66 1.28L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.91-6.68c.11-.37.04-1.06-.66-1.28l-1.3-.42V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsBoat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3v1h-2V3h2m-1 7.11l5.38 1.77 2.39.78-1.12 3.97c-.54-.3-.94-.71-1.14-.94L16 13.96l-1.51 1.72c-.34.4-1.28 1.32-2.49 1.32s-2.15-.92-2.49-1.32L8 13.96l-1.51 1.72c-.2.23-.6.63-1.14.93l-1.13-3.96 2.4-.79L12 10.11M15 1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 00-.66 1.28L3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1zM6 9.97V6h12v3.97L12 8 6 9.97zm10 9.71c-1.22.85-2.61 1.28-4 1.28s-2.78-.43-4-1.28C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.63.97 4 .97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsBusFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5c0 .95.38 1.81 1 2.44V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-2.06c.62-.63 1-1.49 1-2.44V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zm6 11c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-3h12v3zm0-5H6V7h12v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4.42 0-8 .5-8 4v10c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4zm5.66 2.99H6.34C6.89 4.46 8.31 4 12 4s5.11.46 5.66.99zm.34 2V10H6V6.99h12zm-.34 9.74l-.29.27H6.63l-.29-.27A.968.968 0 016 16v-4h12v4c0 .37-.21.62-.34.73z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsCarFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-5h14v5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.08 3.11H5.77L6.85 7zM19 17H5v-5h14v5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsRailwayFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zm6 11.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5H6V7h12v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsRailway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1c-4.42 0-8 .5-8 4v10.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4zm0 2c6 0 6 1.2 6 2H6c0-.8 0-2 6-2zm6 4v3H6V7h12zm-1.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5zM12 12.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsRun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsSubwayFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsTransitFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm0 2c3.71 0 5.13.46 5.67 1H6.43c.6-.52 2.05-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsTransit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zm5.66 3H6.43c.61-.52 2.06-1 5.57-1 3.71 0 5.12.46 5.66 1zM11 7v3H6V7h5zm2 0h5v3h-5V7zm3.5 10h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5c0 .83-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsWalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 00-2.65-.84L6 8.3V13h2V9.6l1.8-.7"
                }
            }
        ]
    })(props);
}
function MdOutlineDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.43 10.59l-9.01-9.01c-.75-.75-2.07-.76-2.83 0l-9 9c-.78.78-.78 2.04 0 2.82l9 9c.39.39.9.58 1.41.58.51 0 1.02-.19 1.41-.58l8.99-8.99c.79-.76.8-2.02.03-2.82zm-10.42 10.4l-9-9 9-9 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineDryCleaning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.56 11.36L13 8.44V7c0-.55-.45-1-1-1s-1-.45-1-1 .45-1 1-1 1 .45 1 1h2c0-1.84-1.66-3.3-3.56-2.95-1.18.22-2.15 1.17-2.38 2.35-.3 1.56.6 2.94 1.94 3.42v.63l-6.56 2.92c-.88.38-1.44 1.25-1.44 2.2v.01C3 14.92 4.08 16 5.42 16H7v6h10v-6h1.58c1.34 0 2.42-1.08 2.42-2.42v-.01c0-.95-.56-1.82-1.44-2.21zM15 20H9v-5h6v5zm3.58-6H17v-1H7v1H5.42c-.46 0-.58-.65-.17-.81l6.75-3 6.75 3c.42.19.28.81-.17.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditAttributes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.63 7H6.37C3.96 7 2 9.24 2 12s1.96 5 4.37 5h11.26c2.41 0 4.37-2.24 4.37-5s-1.96-5-4.37-5zm0 8H6.37C5.09 15 4 13.63 4 12s1.09-3 2.37-3h11.26C18.91 9 20 10.37 20 12s-1.09 3-2.37 3zM7.24 13.06l-1.87-1.87-.7.7 2.57 2.57 4.22-4.22-.7-.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditLocationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2.12l6.16-6.16-2.12-2.12L11 8.88V11zm9.71-9L20 1.29a.996.996 0 00-1.41 0l-.72.72 2.12 2.12.72-.72a.996.996 0 000-1.41zM17.9 9.05c.06.36.1.74.1 1.15 0 1.71-1.08 4.64-6 9.14-4.92-4.49-6-7.43-6-9.14C6 6.17 9.09 4 12 4c.32 0 .65.03.97.08l1.65-1.65A8.56 8.56 0 0012 2c-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8 0-1.01-.16-1.94-.45-2.8L17.9 9.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.17 4.91L17.1 3.84l-5.55 5.55v1.08h1.08l5.54-5.56zM16 2.74l1.29-1.29a1.49 1.49 0 012.12 0l1.15 1.15c.59.59.59 1.54 0 2.12l-.68.68-.02.02-.58.58-6 6H10V8.74l6-6zm-2.28-.55l-.55.55-1.27 1.27c-3.3.05-5.9 2.6-5.9 6.2 0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.79 6-9.14v-.1l1.8-1.8c.13.6.2 1.24.2 1.9 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8 0-4.98 3.8-8.2 8-8.2.58 0 1.16.06 1.72.18z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h-2v7.9l2-2zM4 4h2v16H4zM10 4h2v4h-2zM10 10h2v4h-2zM10 16h2v4h-2zM22.56 12.59l-1.15-1.15a1.49 1.49 0 00-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45z"
                }
            }
        ]
    })(props);
}
function MdOutlineEggAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9c-2-2-3.01-7-9.03-7C4.95 2 1.94 6 2 11.52 2.06 17.04 6.96 19 9.97 19c2.01 0 2.01 3 6.02 3C19 22 22 19 22 15.02 22 12 21.01 11 19 9zm-3.01 11c-1.49 0-1.96-.5-2.68-1.26-.65-.69-1.65-1.74-3.34-1.74-1.64 0-5.92-.99-5.97-5.5-.03-2.51.68-4.62 1.99-5.95C7.01 4.52 8.35 4 9.97 4c3.34 0 4.51 1.86 5.86 4.02.55.88 1.07 1.71 1.76 2.39 1.9 1.89 2.41 2.4 2.41 4.61 0 2.85-2.12 4.98-4.01 4.98z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "3.5"
                }
            }
        ]
    })(props);
}
function MdOutlineEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3C8.5 3 5 9.33 5 14c0 3.87 3.13 7 7 7s7-3.13 7-7c0-4.67-3.5-11-7-11zm0 16c-2.76 0-5-2.24-5-5 0-4.09 3.07-9 5-9s5 4.91 5 9c0 2.76-2.24 5-5 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 16c-.58 0-3-.08-3-3 0-.55-.45-1-1-1s-1 .45-1 1c0 3 1.99 5 5 5 .55 0 1-.45 1-1s-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7h-.82l-1.7-4.68A2.008 2.008 0 0014.6 1H12v2h2.6l1.46 4h-4.81l-.36-1H12V4H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 6.87 0 9.2 0 12c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5C24 9.2 21.8 7 19 7zM7.82 13c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.02 0 .05-.01.08-.01 1.68 0 3 1.32 3 3s-1.32 3-3 3zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 2.01C18.72 1.42 18.16 1 17.5 1h-11c-.66 0-1.21.42-1.42 1.01L3 8v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1V8l-2.08-5.99zM6.85 3h10.29l1.08 3.11H5.77L6.85 3zM19 13H5V8h14v5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "10.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricMoped(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 12H10V7H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 8.35V5zM4 12v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 4h5v2H5zM19 11c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricRickshaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11.18V9.72c0-.47-.16-.92-.46-1.28L16.6 3.72c-.38-.46-.94-.72-1.54-.72H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h.18C3.6 16.16 4.7 17 6 17s2.4-.84 2.82-2h8.37a2.996 2.996 0 005.82-1c-.01-1.3-.85-2.4-2.01-2.82zM6 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-3.83A3.014 3.014 0 003.17 13H3v-3h4v1.17zM7 8H3V5h4v3zm7 5H9v-3h3V8H9V5h5v8zm2-6.88L18.4 9H16V6.12zM17.17 13H16v-2h3v.17c-.85.3-1.53.98-1.83 1.83zM20 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM7 20h4v-2l6 3h-4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricScooter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.82 16H15v-1c0-2.21 1.79-4 4-4h.74l-1.9-8.44A2.009 2.009 0 0015.89 1H12v2h3.89l1.4 6.25h-.01A6.008 6.008 0 0013.09 14H7.82a2.996 2.996 0 00-3.42-1.94c-1.18.23-2.13 1.2-2.35 2.38A3.002 3.002 0 005 18c1.3 0 2.4-.84 2.82-2zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM11 20H7l6 3v-2h4l-6-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineElectricalServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14c0-.55-.45-1-1-1h-2v2h2c.55 0 1-.45 1-1zM20 17h-2v2h2c.55 0 1-.45 1-1s-.45-1-1-1zM12 14h-2v4h2c0 1.1.9 2 2 2h3v-8h-3c-1.1 0-2 .9-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13c0-1.1.9-2 2-2h1.5c1.93 0 3.5-1.57 3.5-3.5S10.43 4 8.5 4H5c-.55 0-1 .45-1 1s.45 1 1 1h3.5c.83 0 1.5.67 1.5 1.5S9.33 9 8.5 9H7c-2.21 0-4 1.79-4 4s1.79 4 4 4h2v-2H7c-1.1 0-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmergencyRecording(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM16 18H4V6h12v12zm-4-6l3 1.73-1 1.73-3-1.73V17H9v-3.27l-3 1.73-1-1.73L8 12l-3-1.73 1-1.73 3 1.73V7h2v3.27l3-1.73 1 1.73L12 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmergencyShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.93 0 3.68.78 4.95 2.05l-1.41 1.41a5.022 5.022 0 00-7.08 0L7.05 6.05A6.976 6.976 0 0112 4zm7.78-.77l-1.41 1.41C16.74 3.01 14.49 2 12.01 2S7.27 3.01 5.64 4.63L4.22 3.22C6.22 1.23 8.97 0 12.01 0s5.78 1.23 7.77 3.23zM12 11c1.94 0 4 1.45 4 4.15 0 .94-.55 2.93-4 6.17-3.45-3.24-4-5.23-4-6.17 0-2.7 2.06-4.15 4-4.15zm0-2c-3.15 0-6 2.41-6 6.15 0 2.49 2 5.44 6 8.85 4-3.41 6-6.36 6-8.85C18 11.41 15.15 9 12 9zm1.5 6c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5.67 1.5 1.5 1.5 1.5-.67 1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmergency(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.29 13.9L18 12l3.29-1.9c.48-.28.64-.89.37-1.37l-2-3.46a1.01 1.01 0 00-1.37-.37L15 6.8V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3.8L5.71 4.9a1.01 1.01 0 00-1.37.37l-2 3.46c-.28.48-.11 1.09.37 1.37L6 12l-3.29 1.9c-.48.28-.64.89-.37 1.37l2 3.46c.28.48.89.64 1.37.37L9 17.2V21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3.8l3.29 1.9c.48.28 1.09.11 1.37-.37l2-3.46c.28-.48.11-1.09-.37-1.37zm-2.86 2.97l-4.68-2.7c-.33-.2-.75.04-.75.43V20h-2v-5.4c0-.38-.42-.63-.75-.43l-4.68 2.7-1-1.73 4.68-2.7c.33-.19.33-.67 0-.87l-4.68-2.7 1-1.73 4.68 2.7c.33.19.75-.05.75-.44V4h2v5.4c0 .38.42.63.75.43l4.68-2.7 1 1.73-4.68 2.7c-.33.19-.33.67 0 .87l4.68 2.7-1 1.74z"
                }
            }
        ]
    })(props);
}
function MdOutlineEvStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 11v8H6V5h6v6zm6-1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-8-4l-4 7.5h2V18l4-7h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFactory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 22H2V10l7-3v2l5-2v3h3l1-8h3l1 8v12zM12 9.95l-5 2V10l-3 1.32V20h16v-8h-8V9.95zM11 18h2v-4h-2v4zm-4 0h2v-4H7v4zm10-4h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFastfood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21.98c0 .56.45 1.01 1.01 1.01H15c.56 0 1.01-.45 1.01-1.01V21H1v.98zM8.5 8.99C4.75 8.99 1 11 1 15h15c0-4-3.75-6.01-7.5-6.01zM3.62 13c1.11-1.55 3.47-2.01 4.88-2.01s3.77.46 4.88 2.01H3.62zM1 17h15v2H1zM18 5V1h-2v4h-5l.23 2h9.56l-1.4 14H18v2h1.72c.84 0 1.53-.65 1.63-1.47L23 5h-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFestival(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 11V9c-6-2-11-7-11-7S7 7 1 9v2c0 1.49.93 2.75 2.24 3.26C3.2 16.76 2.92 19.69 2 22h20c-.92-2.31-1.2-5.24-1.24-7.74A3.496 3.496 0 0023 11zM12 4.71c1.33 1.14 3.49 2.84 6.11 4.29H5.89C8.51 7.55 10.67 5.85 12 4.71zM13 11h3c0 .83-.67 1.5-1.5 1.5S13 11.83 13 11zm-3.5 1.5c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5zM6 11c0 .83-.67 1.5-1.5 1.5S3 11.83 3 11h3zm-1.34 9c.39-1.86.54-3.82.57-5.58.68-.15 1.29-.49 1.76-.98.25.25.54.45.85.62-.1 1.87-.26 4-.52 5.93H4.66zm4.69 0c.24-1.83.39-3.78.48-5.53.84-.08 1.61-.45 2.17-1.02.56.57 1.32.94 2.17 1.02.1 1.75.24 3.7.48 5.53h-5.3zm7.32 0c-.27-1.94-.43-4.07-.52-5.93.31-.17.61-.37.85-.62.47.48 1.08.83 1.76.98.03 1.76.18 3.72.57 5.58h-2.66zm2.83-7.5c-.83 0-1.5-.67-1.5-1.5h3c0 .83-.67 1.5-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFireHydrantAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 11h-1V8h2V6h-2.35a5.99 5.99 0 00-11.3 0H4v2h2v3H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v3H4v2h16v-2h-2v-3h1c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2zm-7-7c1.47 0 2.75.81 3.44 2H8.56c.69-1.19 1.97-2 3.44-2zm7 11h-3v5H8v-5H5v-2h3V8h8v5h3v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFireTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.9 10.69l-1.44-4.32A2.01 2.01 0 0019.56 5H19V4c0-.55-.45-1-1-1h-1c-.55 0-1 .45-1 1v1h-2c-1.1 0-2 .9-2 2v4H1v5c0 1.1.9 2 2 2h1c0 1.66 1.34 3 3 3s3-1.34 3-3h4c0 1.66 1.34 3 3 3s3-1.34 3-3h3v-6.68c0-.21-.03-.42-.1-.63zM14 7h5.56l1.33 4H14V7zM7 19c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5-3H9.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-3h9v3zm5 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H14v-3h7v3h-1.78z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.5h-1v-2h1V5H1v1.5h1v2H1V10h10V8.5zm-2.5 0H6.75v-2H8.5v2zm-5-2h1.75v2H3.5v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlightClass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4h-2c-1.1 0-2 .9-2 2v5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 7h-2V6h2v5zm-6.5 5H18v2H9.49c-.88 0-1.66-.58-1.92-1.43L5 8V4h2v4l2.5 8zM8 19h10v2H8v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineForest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 18l-3.86-6H22L15 2l-3 4.29L9 2 2 12h1.86L0 18h7v4h4v-4h2v4h4v-4h7zM15 5.49L18.16 10h-1.68l3.86 6h-3.62l-2.57-4H16l-2.78-3.97L15 5.49zM3.66 16l3.86-6H5.84L9 5.49 12.16 10h-1.68l3.86 6H3.66z"
                }
            }
        ]
    })(props);
}
function MdOutlineForkLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.41 15.59L8 17l-4-4 4-4 1.41 1.41L7.83 12c1.51-.33 3.73.08 5.17 1.36V6.83l-1.59 1.59L10 7l4-4 4 4-1.41 1.41L15 6.83V21h-2v-4c-.73-2.58-3.07-3.47-5.17-3l1.58 1.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineForkRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.59 15.59L16 17l4-4-4-4-1.41 1.41L16.17 12c-1.51-.33-3.73.08-5.17 1.36V6.83l1.59 1.59L14 7l-4-4-4 4 1.41 1.41L9 6.83V21h2v-4c.73-2.58 3.07-3.47 5.17-3l-1.58 1.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineFort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3v2h-2V3h-2v2h-2V3h-2v4l2 2v1H9V9l2-2V3H9v2H7V3H5v2H3V3H1v4l2 2v6l-2 2v4h9v-3c0-1.1.9-2 2-2s2 .9 2 2v3h9v-4l-2-2V9l2-2V3h-2zm0 16h-5v-1c0-2.21-1.79-4-4-4s-4 1.79-4 4v1H3v-1.17l2-2V8.17L3.83 7h4.34L7 8.17V12h10V8.17L15.83 7h4.34L19 8.17v7.66l2 2V19z"
                }
            }
        ]
    })(props);
}
function MdOutlineHail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm5-4h2c0 2.7-.93 4.41-2.3 5.5-.5.4-1.1.7-1.7.9V22h-2v-6h-2v6H9V10.1c-.3.1-.5.2-.6.3-.53.41-1.4 1.03-1.4 3.6H5c0-2.06.35-3.78 2.11-5.29C8.21 7.81 10 7 12 7s2.68-.46 3.48-1.06C15.96 5.55 17 4.76 17 2zM4 16h3v6H4v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineHandyman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.67 18.17l-5.3-5.3h-.99l-2.54 2.54v.99l5.3 5.3c.39.39 1.02.39 1.41 0l2.12-2.12a.996.996 0 000-1.41zm-2.83 1.42l-4.24-4.24.71-.71 4.24 4.24-.71.71z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.34 10.19l1.41-1.41 2.12 2.12a3 3 0 000-4.24l-3.54-3.54-1.41 1.41V1.71l-.7-.71-3.54 3.54.71.71h2.83l-1.41 1.41 1.06 1.06-2.89 2.89-4.13-4.13V5.06L4.83 2.04 2 4.87 5.03 7.9h1.41l4.13 4.13-.85.85H7.6l-5.3 5.3a.996.996 0 000 1.41l2.12 2.12c.39.39 1.02.39 1.41 0l5.3-5.3v-2.12l5.15-5.15 1.06 1.05zm-7.98 5.15l-4.24 4.24-.71-.71 4.24-4.24.71.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineHardware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 3l-3 3V3H9C6.24 3 4 5.24 4 8h5v12c0 .55.45 1 1 1h4c.55 0 1-.45 1-1V8l3 3h2V3h-2zm-5 16h-2v-6h2v6zm-2-8V6H6.77C7.32 5.39 8.11 5 9 5h4v6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHomeRepairService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10h20V10c0-1.1-.9-2-2-2zM9 6h6v2H9V6zm11 12H4v-3h2v1h2v-1h8v1h2v-1h2v3zm-2-5v-1h-2v1H8v-1H6v1H4v-3h16v3h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineHvac(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6zm3.44-8c.26.45.44.96.51 1.5h-7.9c.07-.54.24-1.05.51-1.5h6.88zm.51 2.5c-.07.54-.24 1.05-.51 1.5H8.56c-.26-.45-.44-.96-.51-1.5h7.9zM9.38 15h5.24c-.7.61-1.61 1-2.62 1s-1.91-.39-2.62-1zm5.24-6H9.38c.7-.61 1.61-1 2.62-1s1.91.39 2.62 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineIcecream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.38 6.24C17.79 3.24 15.14 1 12 1S6.21 3.24 5.62 6.24A4.014 4.014 0 003 10c0 2.21 1.79 4 4 4 .12 0 .23-.02.34-.02L12.07 23l4.61-9.03c.11.01.21.03.32.03 2.21 0 4-1.79 4-4 0-1.71-1.08-3.19-2.62-3.76zm-6.33 12.39l-2.73-5.21a6.468 6.468 0 005.4-.02l-2.67 5.23zM17 12c-.52 0-1.01-.2-1.39-.56l-.56-.54-.66.42a4.52 4.52 0 01-4.78-.01l-.66-.41-.56.54c-.38.35-.87.56-1.39.56a1.999 1.999 0 01-.32-3.97l.77-.13.06-.78C7.71 4.8 9.66 3 12 3s4.29 1.8 4.48 4.12l.06.78.77.12c.97.16 1.69.99 1.69 1.98 0 1.1-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKebabDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.75 7h.75a2.5 2.5 0 000-5h-.75V1h-1.5v1h-.75a2.5 2.5 0 000 5h.75v1H13v5h3.25v1h-.75a2.5 2.5 0 000 5h.75v4h1.5v-4h.75a2.5 2.5 0 000-5h-.75v-1H21V8h-3.25V7zM15.5 5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3zm3 11c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3zm.5-6v1h-4v-1h4zM7.75 7h.75a2.5 2.5 0 000-5h-.75V1h-1.5v1H5.5a2.5 2.5 0 000 5h.75v1H3v5h3.25v1H5.5a2.5 2.5 0 000 5h.75v4h1.5v-4h.75a2.5 2.5 0 000-5h-.75v-1H11V8H7.75V7zM5.5 5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3zm3 11c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h3zm.5-6v1H5v-1h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineLayersClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.53L17.74 9l-1.89 1.47 1.43 1.42L21 9l-9-7-2.59 2.02 1.42 1.42zm9 9.54l-1.63-1.27-.67.52 1.43 1.43zM3.41.86L2 2.27l4.22 4.22L3 9l9 7 2.1-1.63 1.42 1.42-3.53 2.75-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21l1.41-1.41L3.41.86zM12 13.47L6.26 9l1.39-1.08 5.02 5.02-.67.53z"
                }
            }
        ]
    })(props);
}
function MdOutlineLayers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16zm0-11.47L17.74 9 12 13.47 6.26 9 12 4.53z"
                }
            }
        ]
    })(props);
}
function MdOutlineLiquor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 14c0 1.3.84 2.4 2 2.82V20H3v2h6v-2H7v-3.18C8.16 16.4 9 15.3 9 14V6H3v8zm2-6h2v3H5V8zm0 5h2v1c0 .55-.45 1-1 1s-1-.45-1-1v-1zM20.64 8.54l-.96-.32a1 1 0 01-.68-.95V3c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v4.28a1 1 0 01-.68.95l-.96.32c-.81.28-1.36 1.04-1.36 1.9V20c0 1.1.9 2 2 2h7c1.1 0 2-.9 2-2v-9.56c0-.86-.55-1.62-1.36-1.9zM16 4h1v1h-1V4zm4 16h-7v-2h7v2zm0-4h-7v-2h7v2zm0-4h-7v-1.56l.95-.32C15.18 9.72 16 8.57 16 7.28V7h1v.28a3 3 0 002.05 2.85l.95.31V12z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalActivity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalAirport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-2l-8.5-5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalAtm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.77 9L12 12.11 9.23 9h5.54M21 3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9V3zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalCafe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10m4-2H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-2 5V5h2v3h-2zm2 11H2v2h18v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalCarWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 9h10.29l1.04 3H5.81l1.04-3zM19 19H5v-4.66l.12-.34h13.77l.11.34V19z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalConvenienceStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm1 11h-4v-4H8v4H4V9h3V6h10v3h3v9zM8 8h2v1H8v3h3v-1H9v-1h2V7H8zm7 1h-1V7h-1v3h2v2h1V7h-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalDrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm14 18l-10 .01L5.89 10H18.1L17 20zm1.33-12H5.67l-.44-4h13.53l-.43 4zM12 19c1.66 0 3-1.34 3-3 0-2-3-5.4-3-5.4S9 14 9 16c0 1.66 1.34 3 3 3zm0-5.09c.59.91 1 1.73 1 2.09 0 .55-.45 1-1 1s-1-.45-1-1c0-.37.41-1.19 1-2.09z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalFireDepartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6l-.44.55c-.42.52-.98.75-1.54.75C13 7.3 12 6.52 12 5.3V2S4 6 4 13c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.96-1.61-5.62-4-7zm-4 13c-1.1 0-2-.87-2-1.94 0-.51.2-.99.58-1.36L12 14.3l1.43 1.4c.37.37.57.85.57 1.36 0 1.07-.9 1.94-2 1.94zm3.96-1.5c.04-.36.22-1.89-1.13-3.22L12 11.5l-2.83 2.78C7.81 15.62 8 17.16 8.04 17.5A5.982 5.982 0 016 13c0-3.16 2.13-5.65 4.03-7.25a4.024 4.024 0 003.99 3.55c.78 0 1.54-.23 2.18-.66A6.175 6.175 0 0118 13c0 1.79-.79 3.4-2.04 4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalFlorist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.66 13.07c.15 0 .29-.01.43-.03C9.56 14.19 10.69 15 12 15s2.44-.81 2.91-1.96a3.145 3.145 0 003.57-3.11c0-.71-.25-1.39-.67-1.93.43-.54.67-1.22.67-1.93a3.145 3.145 0 00-3.57-3.11C14.44 1.81 13.31 1 12 1s-2.44.81-2.91 1.96a3.145 3.145 0 00-3.57 3.11c0 .71.25 1.39.67 1.93-.43.54-.68 1.22-.68 1.93 0 1.73 1.41 3.14 3.15 3.14zM12 13c-.62 0-1.12-.49-1.14-1.1l.12-1.09c.32.12.66.19 1.02.19s.71-.07 1.03-.19l.11 1.09c-.02.61-.52 1.1-1.14 1.1zm3.34-1.93c-.24 0-.46-.07-.64-.2l-.81-.57c.55-.45.94-1.09 1.06-1.83l.88.42c.4.19.66.59.66 1.03 0 .64-.52 1.15-1.15 1.15zm-.65-5.94c.2-.13.42-.2.65-.2.63 0 1.14.51 1.14 1.14 0 .44-.25.83-.66 1.03l-.88.42c-.12-.74-.51-1.38-1.07-1.83l.82-.56zM12 3c.62 0 1.12.49 1.14 1.1l-.11 1.09C12.71 5.07 12.36 5 12 5s-.7.07-1.02.19l-.12-1.09c.02-.61.52-1.1 1.14-1.1zM8.66 4.93c.24 0 .46.07.64.2l.81.56c-.55.45-.94 1.09-1.06 1.83l-.88-.42c-.4-.2-.66-.59-.66-1.03 0-.63.52-1.14 1.15-1.14zM8.17 8.9l.88-.42c.12.74.51 1.38 1.07 1.83l-.81.55c-.2.13-.42.2-.65.2-.63 0-1.14-.51-1.14-1.14-.01-.43.25-.82.65-1.02zM12 22a9 9 0 009-9 9 9 0 00-9 9zm2.44-2.44c.71-1.9 2.22-3.42 4.12-4.12a7.04 7.04 0 01-4.12 4.12zM3 13a9 9 0 009 9 9 9 0 00-9-9zm2.44 2.44c1.9.71 3.42 2.22 4.12 4.12a7.04 7.04 0 01-4.12-4.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalGasStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33a2.5 2.5 0 002.5 2.5c.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5a2.5 2.5 0 005 0V9c0-.69-.28-1.32-.73-1.77zM12 13.5V19H6v-7h6v1.5zm0-3.5H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalGroceryStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-1.45-5c.75 0 1.41-.41 1.75-1.03l3.58-6.49A.996.996 0 0020.01 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7l1.1-2h7.45zM6.16 6h12.15l-2.76 5H8.53L6.16 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8.5-2h3v-3.5H17v-3h-3.5V7h-3v3.5H7v3h3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalLaundryService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM18 20H6L5.99 4H18v16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 19c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm2.36-7.36c1.3 1.3 1.3 3.42 0 4.72-1.3 1.3-3.42 1.3-4.72 0l4.72-4.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalLibrary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zm7 5.58c-2.53.34-4.93 1.3-7 2.82a15.2 15.2 0 00-7-2.83v-6.95c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27A11.18 11.18 0 0119 10.18v6.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalMall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm7 17H5V8h14v12zm-7-8c-1.66 0-3-1.34-3-3H7c0 2.76 2.24 5 5 5s5-2.24 5-5h-2c0 1.66-1.34 3-3 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalMovies(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 5v14h-4V5h4m6-2h-2v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3zm-4 6V7h2v2h-2zM6 9V7h2v2H6zm10 4v-2h2v2h-2zM6 13v-2h2v2H6zm10 4v-2h2v2h-2zM6 17v-2h2v2H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalOffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPharmacy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-3.9 8.63L18.89 19H5.11l1.79-5.37.21-.63-.21-.63L5.11 7h13.78l-1.79 5.37-.21.63.21.63zM13 9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPizza(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zm0 15.92L5.51 6.36C7.32 4.85 9.62 4 12 4s4.68.85 6.49 2.36L12 17.92zM9 5.5c-.83 0-1.5.67-1.5 1.5S8.17 8.5 9 8.5s1.5-.67 1.5-1.5S9.82 5.5 9 5.5zm1.5 7.5c0 .83.67 1.5 1.5 1.5.82 0 1.5-.67 1.5-1.5s-.68-1.5-1.5-1.5-1.5.67-1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM9.07 16L12 14.12 14.93 16l-.89-3.36 2.69-2.2-3.47-.21L12 7l-1.27 3.22-3.47.21 2.69 2.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPolice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12.59l.9 3.88-3.4-2.05-3.4 2.05.9-3.87-3-2.59 3.96-.34L12 6.02l1.54 3.64 3.96.34-3 2.59zM12 3.19l7 3.11V11c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPostOffice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalPrintshop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8h-1V3H6v5H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zM8 5h8v3H8V5zm8 14H8v-4h8v4zm2-4v-2H6v2H4v-4c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v4h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "11.5",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalSee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8.2c-1.77 0-3.2-1.43-3.2-3.2 0-1.77 1.43-3.2 3.2-3.2s3.2 1.43 3.2 3.2c0 1.77-1.43 3.2-3.2 3.2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalShipping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zm-.5 1.5l1.96 2.5H17V9.5h2.5zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2.22-3c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3V6h12v9H8.22zM18 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocalTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-4.66l.12-.34h13.77l.11.34V17z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineLunchDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-3H2v3zm2-1h16v1H4v-1zM18.66 11.5c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.32 1l-.01-1.98c-1.61-.33-1.62-1.02-3.33-1.02zM22 9c.02-4-4.28-6-10-6C6.29 3 2 5 2 9v1h20V9zM4.18 8C5.01 5.81 8.61 5 12 5c3.31 0 5.93.73 7.19 1.99.3.31.52.64.65 1.01H4.18z"
                }
            }
        ]
    })(props);
}
function MdOutlineMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM10 5.47l4 1.4v11.66l-4-1.4V5.47zm-5 .99l3-1.01v11.7l-3 1.16V6.46zm14 11.08l-3 1.01V6.86l3-1.16v11.84z"
                }
            }
        ]
    })(props);
}
function MdOutlineMapsUgc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-1.18 0-2.34-.26-3.43-.78-.27-.13-.56-.19-.86-.19-.19 0-.38.03-.56.08l-3.2.94.94-3.2c.14-.47.1-.98-.11-1.42A7.925 7.925 0 014 12c0-4.41 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97c1.31.61 2.75.97 4.29.97 5.52 0 10-4.48 10-10S17.52 2 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "d": "M13 8h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMedicalInformation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9-3h2v5h-2V4zm9 16H4V9h5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5v11zm-9-4H9v2H7v-2H5v-2h2v-2h2v2h2v2zm2-1.5V13h6v1.5h-6zm0 3V16h4v1.5h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMedicalServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm10 16H4V8h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMenuBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 10.5c.88 0 1.73.09 2.5.26V9.24c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99zM13 12.49v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26V11.9c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zM17.5 14.33c-1.7 0-3.24.29-4.5.83v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.16-1.64-.24-2.5-.24z"
                }
            }
        ]
    })(props);
}
function MdOutlineMerge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.41 21L5 19.59l4.83-4.83c.75-.75 1.17-1.77 1.17-2.83v-5.1L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83v5.1c0 1.06.42 2.08 1.17 2.83L19 19.59 17.59 21 12 15.41 6.41 21z"
                }
            }
        ]
    })(props);
}
function MdOutlineMinorCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM19 20H5v-5h14v5zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM9.41 5L8 6.41l-3-3L6.41 2l3 3zM16 6.41L14.59 5l3-3L19 3.41l-3 3zM13 5h-2V0h2v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMiscellaneousServices(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.17 13.71l1.4-2.42c.09-.15.05-.34-.08-.45l-1.48-1.16c.03-.22.05-.45.05-.68s-.02-.46-.05-.69l1.48-1.16c.13-.11.17-.3.08-.45l-1.4-2.42c-.09-.15-.27-.21-.43-.15l-1.74.7c-.36-.28-.75-.51-1.18-.69l-.26-1.85a.364.364 0 00-.35-.29h-2.8c-.17 0-.32.13-.35.3L6.8 4.15c-.42.18-.82.41-1.18.69l-1.74-.7c-.16-.06-.34 0-.43.15l-1.4 2.42c-.09.15-.05.34.08.45l1.48 1.16c-.03.22-.05.45-.05.68s.02.46.05.69l-1.48 1.16c-.13.11-.17.3-.08.45l1.4 2.42c.09.15.27.21.43.15l1.74-.7c.36.28.75.51 1.18.69l.26 1.85c.03.16.18.29.35.29h2.8c.17 0 .32-.13.35-.3l.26-1.85c.42-.18.82-.41 1.18-.69l1.74.7c.16.06.34 0 .43-.15zM8.81 11c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM21.92 18.67l-.96-.74c.02-.14.04-.29.04-.44 0-.15-.01-.3-.04-.44l.95-.74c.08-.07.11-.19.05-.29l-.9-1.55c-.05-.1-.17-.13-.28-.1l-1.11.45c-.23-.18-.48-.33-.76-.44l-.17-1.18a.216.216 0 00-.21-.2h-1.79c-.11 0-.21.08-.22.19l-.17 1.18c-.27.12-.53.26-.76.44l-1.11-.45a.23.23 0 00-.28.1l-.9 1.55c-.05.1-.04.22.05.29l.95.74a3.145 3.145 0 000 .88l-.95.74c-.08.07-.11.19-.05.29l.9 1.55c.05.1.17.13.28.1l1.11-.45c.23.18.48.33.76.44l.17 1.18c.02.11.11.19.22.19h1.79c.11 0 .21-.08.22-.19l.17-1.18c.27-.12.53-.26.75-.44l1.12.45c.1.04.22 0 .28-.1l.9-1.55c.06-.09.03-.21-.05-.28zm-4.29.16a1.35 1.35 0 11.001-2.701 1.35 1.35 0 01-.001 2.701z"
                }
            }
        ]
    })(props);
}
function MdOutlineModeOfTravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.31 18.9c-.96 1-2.06 2.03-3.31 3.1-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2c4.19 0 7.99 3.21 8 8.17l2.09-2.09L23.5 9.5 19 14l-4.5-4.5 1.41-1.41L18 10.17C17.99 6.55 15.34 4 12 4c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14.64-.59 1.23-1.16 1.77-1.71a2.5 2.5 0 01-.27-1.12 2.5 2.5 0 015 0 2.492 2.492 0 01-3.19 2.39z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoney(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 16h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zm-7 6h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1zm1-6h1v4h-1v-4zM5 8h2v8H5zM2 4v16h20V4H2zm18 14H4V6h16v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoped(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM4 14v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineMosque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 7c0-1.1-2-3-2-3s-2 1.9-2 3c0 .74.4 1.38 1 1.72V13h-2v-2c0-.95-.66-1.74-1.55-1.94.34-.58.55-1.25.55-1.97 0-1.31-.65-2.53-1.74-3.25L12 1 7.74 3.84A3.887 3.887 0 006 7.09c0 .72.21 1.39.55 1.96C5.66 9.26 5 10.05 5 11v2H3V8.72c.6-.34 1-.98 1-1.72 0-1.1-2-3-2-3S0 5.9 0 7c0 .74.4 1.38 1 1.72V21h10v-4c0-.55.45-1 1-1s1 .45 1 1v4h10V8.72c.6-.34 1-.98 1-1.72zM8.85 5.5L12 3.4l3.15 2.1c.53.36.85.95.85 1.59C16 8.14 15.14 9 14.09 9H9.91C8.86 9 8 8.14 8 7.09c0-.64.32-1.23.85-1.59zM21 19h-6v-2c0-1.65-1.35-3-3-3s-3 1.35-3 3v2H3v-4h4v-4h10v4h4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9.42V12h2V6h-6v2h2.58l-4.46 4.46a.996.996 0 01-1.41 0l-1.17-1.17a3 3 0 00-4.24 0L2 16.59 3.41 18l5.29-5.29a.996.996 0 011.41 0l1.17 1.17a3 3 0 004.24 0L20 9.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineMultipleStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4l4 4-4 4V9h-4V7h4V4zm-7 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM6 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm1 10h4v-2H7v-3l-4 4 4 4v-3zm7 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm4 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineMuseum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9h2zm-4 9H6V9h12v11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 14l2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMyLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineNavigation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.27l4.28 10.43-3.47-1.53-.81-.36-.81.36-3.47 1.53L12 7.27M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNearMeDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6.34L21 3l-3.34 9-1.56-1.56 1.5-4.05-4.05 1.5L12 6.34zm9.19 14.85l-5.07-5.07L14.31 21H12.9l-2.83-7.07L3 11.1V9.69l4.88-1.81-5.07-5.07L4.22 1.4 22.6 19.78l-1.41 1.41zm-6.62-6.62L9.43 9.43l-2.71 1.01 4.89 1.95 1.95 4.89 1.01-2.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineNearMe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.27 6.73l-4.24 10.13-1.32-3.42-.32-.83-.82-.32-3.43-1.33 10.13-4.23M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineNightlife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 5h14l-6 9v4h2v2H5v-2h2v-4L1 5zm9.1 4l1.4-2H4.49l1.4 2h4.21zM17 5h5v3h-3v9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3a3 3 0 011 .17V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 9.01C18.72 8.42 18.16 8 17.5 8h-11c-.66 0-1.21.42-1.42 1.01L3 15v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 10h10.29l1.04 3H5.81l1.04-3zM19 20H5v-5h14v5zM6 17.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S8.33 19 7.5 19 6 18.33 6 17.5zm9 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5zM12 6.36L9.17 3.54l1.41-1.41L12 3.54 15.54 0l1.41 1.41L12 6.36z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoMeals(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14V6c0-1.76 2.24-4 5-4v16.17l-2-2V14h-3zm4.49 9.31L10.02 12.85c-.33.09-.66.15-1.02.15v9H7v-9c-2.21 0-4-1.79-4-4V5.83L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41zM6.17 9L5 7.83V9h1.17zM9 2H7v2.17l2 2V2zm4 7V2h-2v6.17l1.85 1.85c.09-.33.15-.66.15-1.02z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoTransfer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 13c.83 0 1.5.67 1.5 1.5S9.33 16 8.5 16 7 15.33 7 14.5 7.67 13 8.5 13zm11.28 9.61l-1.64-1.64c-.05.01-.09.03-.14.03h-1c-.55 0-1-.45-1-1v-1H8v1c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-1.78c-.61-.55-1-1.34-1-2.22V6.83L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM6 8.83V10h1.17L6 8.83zM14.17 17l-5-5H6v4c0 .37.21.62.34.73l.29.27h7.54zM12 4c3.69 0 5.11.46 5.66.99H7.82l2 2H18V10h-5.17l2 2H18v3.17l1.81 1.81c.11-.31.19-.63.19-.98V6c0-3.5-3.58-4-8-4-2.52 0-4.76.16-6.22.95l1.53 1.53C8.17 4.2 9.6 4 12 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotListedLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 16a.99.99 0 01-.71-.29.95.95 0 01-.29-.71c-.01-.55.43-.99.98-1h.02c.28 0 .51.1.71.29.18.19.28.43.28.7s-.1.51-.29.71-.43.3-.7.3zm-.88-3.66c0-.45.1-.84.29-1.16.19-.33.53-.7 1-1.12.28-.25.48-.47.61-.66s.19-.4.19-.64c0-.29-.11-.53-.32-.74-.21-.2-.5-.3-.85-.3-.37 0-.74.1-.96.3-.21.2-.4.45-.4.98H9c0-1.01.46-1.73.97-2.21C10.53 6.28 11.25 6 12 6c.59 0 1.11.12 1.57.35s.79.55 1.05.96.38.86.38 1.35-.1.9-.31 1.25-.48.71-.89 1.09c-.32.3-.53.56-.65.77s-.18.49-.18.81V13h-1.85v-.66h.01zM18 10.2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12h2L12 2 5.05 12H7l-3.9 6h6.92v4h3.95v-4H21l-4-6zM6.79 16l3.9-6H8.88l3.13-4.5 3.15 4.5h-1.9l4 6H6.79z"
                }
            }
        ]
    })(props);
}
function MdOutlinePedalBike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.18 10l-1.7-4.68A2.008 2.008 0 0014.6 4H12v2h2.6l1.46 4h-4.81l-.36-1H12V7H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 9.87 0 12.2 0 15c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5 0-2.8-2.2-5-5-5h-.82zM7.82 16c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonPinCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 11c1.33 0 4 .67 4 2v.16c-.97 1.12-2.4 1.84-4 1.84s-3.03-.72-4-1.84V13c0-1.33 2.67-2 4-2zm0-1c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6 .2C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 2H5a2 2 0 00-2 2v14a2 2 0 002 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 16h-4.83l-.59.59L12 20.17l-1.59-1.59-.58-.58H5V4h14v14zm-7-7c1.65 0 3-1.35 3-3s-1.35-3-3-3-3 1.35-3 3 1.35 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 8.58c0-2.5-3.97-3.58-6-3.58s-6 1.08-6 3.58V17h12v-1.42zM8.48 15c.74-.51 2.23-1 3.52-1s2.78.49 3.52 1H8.48z"
                }
            }
        ]
    })(props);
}
function MdOutlinePestControlRodent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "17",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.86 14.97l-.93-.84c.48-3.45-2.87-6.04-6.05-4.82A5.79 5.79 0 0012 9c-4.26 0-5.65 3.58-5.89 4.85A2.983 2.983 0 014 11c0-1.66 1.34-3 3-3h2.5a2.5 2.5 0 000-5H8c-.55 0-1 .45-1 1s.45 1 1 1h1.5c.28 0 .5.22.5.5s-.22.5-.5.5H7c-2.76 0-5 2.24-5 5 0 2.44 1.76 4.47 4.07 4.91A5.998 5.998 0 0012 21h6.53c3.11 0 4.7-3.89 2.33-6.03zM18.53 19H12c-1.21 0-2.34-.54-3.11-1.48-.78-.95-1.06-2.16-.8-3.41a3.95 3.95 0 012.99-3.01c.22-.05.45-.06.67-.07-.47.71-.75 1.55-.75 2.47 0 1.24.5 2.37 1.32 3.18l1.41-1.41c-.45-.45-.73-1.08-.73-1.77 0-1.42 1.2-2.5 2.5-2.5a2.5 2.5 0 012.5 2.5c0 .46-.13.88-.35 1.25l1.87 1.7c.31.28.48.67.48 1.09 0 .8-.66 1.46-1.47 1.46z"
                }
            }
        ]
    })(props);
}
function MdOutlinePestControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 15v-2h-3.07c-.05-.39-.12-.77-.22-1.14l2.58-1.49-1-1.73L16.92 10c-.28-.48-.62-.91-.99-1.29.1-.56.2-1.69-.58-2.89L17 4.17l-1.41-1.41-1.72 1.72c-1.68-.89-3.1-.33-3.73 0L8.41 2.76 7 4.17l1.65 1.65c-.78 1.2-.68 2.34-.58 2.89-.37.39-.71.82-.99 1.29L4.71 8.63l-1 1.73 2.58 1.49c-.1.37-.17.75-.22 1.14H3v2h3.07c.05.39.12.77.22 1.14l-2.58 1.49 1 1.73L7.08 18c1.08 1.81 2.88 3 4.92 3s3.84-1.19 4.92-3l2.37 1.37 1-1.73-2.58-1.49c.1-.37.17-.75.22-1.14H21zm-9-9c.88 0 1.62.57 1.88 1.36C13.29 7.13 12.66 7 12 7s-1.29.13-1.88.36C10.38 6.57 11.12 6 12 6zm0 13c-2.21 0-4-2.24-4-5s1.79-5 4-5 4 2.24 4 5-1.79 5-4 5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 11h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePinDrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c1.93 0 5 1.4 5 5.15 0 2.16-1.72 4.67-5 7.32-3.28-2.65-5-5.17-5-7.32C7 5.4 10.07 4 12 4m0-2C8.73 2 5 4.46 5 9.15c0 3.12 2.33 6.41 7 9.85 4.67-3.44 7-6.73 7-9.85C19 4.46 15.27 2 12 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7c-1.1 0-2 .9-2 2s.9 2 2 2a2 2 0 100-4zM5 20h14v2H5v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlumbing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.28 4.93l-2.12-2.12c-.78-.78-2.05-.78-2.83 0L11.5 5.64l2.12 2.12 2.12-2.12 3.54 3.54a3.012 3.012 0 000-4.25zM5.49 13.77c.59.59 1.54.59 2.12 0l2.47-2.47-2.12-2.13-2.47 2.47c-.59.59-.59 1.54 0 2.13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.04 7.76l-.71.71-.71.71L10.44 6c-.59-.6-1.54-.6-2.12-.01a1.49 1.49 0 000 2.12l3.18 3.18-.71.71-6.36 6.36c-.78.78-.78 2.05 0 2.83.78.78 2.05.78 2.83 0L16.45 12a.996.996 0 101.41-1.41l-2.82-2.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineRailwayAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 11V8h7.29C11.1 7.37 11 6.7 11 6H4.43c.9-.77 3.28-1.08 6.65-.98.1-.7.3-1.37.59-1.99C2.97 2.67 2 5.02 2 7v9.5C2 18.43 3.57 20 5.5 20L4 21v1h12v-1l-1.5-1c1.93 0 3.5-1.57 3.5-3.5V13c-1.91 0-3.63-.76-4.89-2H4zm12 5.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V13h12v3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V8h1v1zm0-2h-1V3h1v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRamenDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 14c-.66 1.92-2.24 3.54-4.4 4.39l-1.26.5V20h-4v-1.11l-1.27-.5c-2.16-.85-3.74-2.47-4.4-4.39h15.33M22 2L4 3.99V12H2c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25H10.5V8H22V6.5H10.5V4.78L22 3.51V2zM8 6.5V5.06l1-.11V6.5H8zm-2.5 0V5.34l1-.11V6.5h-1zM8 12V8h1v4H8zm-2.5 0V8h1v4h-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineRampLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 21h-2V6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V9c0 4.27 4.03 7.13 6 8.27l-1.46 1.46c-1.91-1.16-3.44-2.53-4.54-4.02V21z"
                }
            }
        ]
    })(props);
}
function MdOutlineRampRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 21h2V6.83l1.59 1.59L16 7l-4-4-4 4 1.41 1.41L11 6.83V9c0 4.27-4.03 7.13-6 8.27l1.46 1.46C8.37 17.56 9.9 16.19 11 14.7V21z"
                }
            }
        ]
    })(props);
}
function MdOutlineRateReview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9.5-2H18v-2h-5.5zm3.86-5.87c.2-.2.2-.51 0-.71l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l5.89-5.87z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h2v9h-2zM4 4h2v16H4zM11 4h2v4h-2zM11 10h2v4h-2zM11 16h2v4h-2zM22.5 16.41L21.09 15 19 17.09 16.91 15l-1.41 1.41 2.09 2.09-2.09 2.09L16.91 22 19 19.91 21.09 22l1.41-1.41-2.09-2.09z"
                }
            }
        ]
    })(props);
}
function MdOutlineRestaurantMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
                }
            }
        ]
    })(props);
}
function MdOutlineRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4zm-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2v7z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoundaboutLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.08 8A6 6 0 0116 3c3.31 0 6 2.69 6 6 0 2.97-2.16 5.44-5 5.92V21h-2v-6.09c0-.98.71-1.8 1.67-1.97a3.999 3.999 0 10-4.61-4.61c-.17.96-.99 1.67-1.97 1.67H5.83l1.59 1.59L6 13 2 9l4-4 1.41 1.41L5.83 8h4.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoundaboutRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.92 8C13.44 5.16 10.97 3 8 3 4.69 3 2 5.69 2 9c0 2.97 2.16 5.44 5 5.92V21h2v-6.09c0-.98-.71-1.8-1.67-1.97a3.999 3.999 0 114.61-4.61c.17.96.99 1.67 1.97 1.67h4.26l-1.59 1.59L18 13l4-4-4-4-1.41 1.41L18.17 8h-4.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15.18V7c0-2.21-1.79-4-4-4s-4 1.79-4 4v10c0 1.1-.9 2-2 2s-2-.9-2-2V8.82C8.16 8.4 9 7.3 9 6c0-1.66-1.34-3-3-3S3 4.34 3 6c0 1.3.84 2.4 2 2.82V17c0 2.21 1.79 4 4 4s4-1.79 4-4V7c0-1.1.9-2 2-2s2 .9 2 2v8.18A2.996 2.996 0 0018 21c1.66 0 3-1.34 3-3 0-1.3-.84-2.4-2-2.82zM6 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 12c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineRunCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.54 8.97c-.23-.47-.76-.71-1.26-.53L9 9.65V12h1v-1.65l1.54-.57-.96 4.89-2.78-.57-.2.98 3.76.77.52-2.64L13 14.42V18h1v-3.97l-1.32-1.44.41-2.35C13.99 11.46 15.3 12 16 12v-1c-.41 0-1.63-.33-2.46-2.03z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13.5",
                    "cy": "7",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineSafetyCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm1.65 7.35L11.5 12.2V9h1v2.79l1.85 1.85-.7.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineSailing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 13.5V2L3 13.5h8zm-2-2H6.83L9 8.38v3.12zm12 2C21 6.5 14.5 1 12.5 1c0 0 1 3 1 6.5s-1 6-1 6H21zm-5.62-8.26c1.42 1.52 2.88 3.72 3.41 6.26h-3.68c.21-1.1.39-2.46.39-4 0-.79-.05-1.55-.12-2.26zM22 15H2a6.233 6.233 0 002.33 3.73c.65-.27 1.22-.72 1.67-1.23.73.84 1.8 1.5 3 1.5s2.27-.66 3-1.5c.73.84 1.8 1.5 3 1.5s2.26-.66 3-1.5c.45.51 1.02.96 1.67 1.23 1.17-.89 2.02-2.2 2.33-3.73zm0 8v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSatellite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM8.57 6H6v2.58c1.42 0 2.57-1.16 2.57-2.58zM12 6h-1.71c0 2.36-1.92 4.29-4.29 4.29V12c3.32 0 6-2.69 6-6zm2.14 5.86l-3 3.87L9 13.15 6 17h12z"
                }
            }
        ]
    })(props);
}
function MdOutlineScreenRotationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 7.59l5-5c.78-.78 2.05-.78 2.83 0L20.24 11h-2.83L10.4 4 5.41 9H8v2H2V5h2v2.59zM20 19h2v-6h-6v2h2.59l-4.99 5-7.01-7H3.76l8.41 8.41c.78.78 2.05.78 2.83 0l5-5V19z"
                }
            }
        ]
    })(props);
}
function MdOutlineSetMeal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.05 17.56l-17.97.94L3 17l17.98-.94.07 1.5zM21 19.48H3v1.5h18v-1.5zM23 13V4c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 0H3V4h18v9zm-1-7c-1.68 0-3.04.98-3.21 2.23-.64-.73-2.73-2.73-6.54-2.73-4.67 0-6.75 3-6.75 3s2.08 3 6.75 3c3.81 0 5.9-2 6.54-2.73C16.96 10.02 18.32 11 20 11V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignpost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 10h5l3-3-3-3h-5V2h-2v2H4v6h7v2H6l-3 3 3 3h5v4h2v-4h7v-6h-7v-2zM6 6h11.17l1 1-1 1H6V6zm12 10H6.83l-1-1 1-1H18v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSnowmobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 17c0 .55-.45 1-1 1h-.17l-2.2-2.2C20.58 15.37 22 14.4 22 13c0-1-8-8-8-8h-3v2h2.25l.8.72L11 10 2 9l-2 4 4.54 1.36-3.49 1.88C-.77 17.22-.07 20 2 20h6c2.21 0 4-1.79 4-4h4l2 2h-3v2h6c1.66 0 3-1.34 3-3h-2zM8 18H2l5.25-2.83L10 16a2 2 0 01-2 2zm9-4h-6.7l-7.45-2.23.31-.62 8.44.85 3.93-2.94s3.77 3.44 4.27 4.14c0 0-1.1.8-2.8.8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 7h-3c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8h-3V9h3v6zM1 15h4v-2H3c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2H3v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H1v-2zm16 0h4v-2h-2c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h4v2h-4v2h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSoupKitchen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.4 7c-.34.55-.4.97-.4 1.38C6 9.15 7 11 7 12c0 .95-.4 1.5-.4 1.5H5.1s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h1.5zm5 0c-.34.55-.4.97-.4 1.38 0 .77 1 2.62 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zM8.15 7c-.34.55-.4.97-.4 1.38 0 .77 1 2.63 1 3.62 0 .95-.4 1.5-.4 1.5h1.5s.4-.55.4-1.5c0-1-1-2.85-1-3.62 0-.41.06-.83.4-1.38h-1.5zM18.6 2c-1.54 0-2.81 1.16-2.98 2.65L14.53 15H4.01c-.6 0-1.09.53-1 1.13C3.53 19.46 6.39 22 9.75 22c3.48 0 6.34-2.73 6.71-6.23L17.61 4.9c.05-.51.47-.9.99-.9.55 0 1 .45 1 1 0 .3-.1 1.25-.1 1.25l1.97.25s.13-1.06.13-1.5c0-1.65-1.35-3-3-3zM9.75 20c-1.94 0-3.67-1.23-4.43-3h8.79c-.72 1.78-2.42 3-4.36 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineStadium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 5L3 7V3l4 2zm11-2v4l4-2-4-2zm-7-1v4l4-2-4-2zm2 16h-2v4c-5.05-.15-9-1.44-9-3v-9c0-1.66 4.48-3 10-3s10 1.34 10 3v9c0 1.56-3.95 2.85-9 3v-4zm-8-7.96c1.38.49 3.77.96 7 .96s5.62-.47 7-.96C19 9.86 16.22 9 12 9s-7 .86-7 1.04zm15 1.76c-1.82.73-4.73 1.2-8 1.2s-6.18-.47-8-1.2v6.78c.61.41 2.36 1.01 5 1.28V16h6v3.86c2.64-.27 4.39-.87 5-1.28V11.8z"
                }
            }
        ]
    })(props);
}
function MdOutlineStoreMallDirectory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.36 9l.6 3H5.04l.6-3h12.72M20 4H4v2h16V4zm0 3H4l-1 5v2h1v6h10v-6h4v6h2v-6h1v-2l-1-5zM6 18v-4h6v4H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineStraight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 6.83L9.41 8.41 8 7l4-4 4 4-1.41 1.41L13 6.83V21h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStreetview(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "18",
                    "cy": "6",
                    "r": "5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82A6.435 6.435 0 0111.5 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.8 2.8C16 2.09 13.86 2 12 2s-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zM9.17 20l1.5-1.5h2.66l1.5 1.5H9.17zm-2.16-6V9h10v5h-10zm9.49 2c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm-8-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM20 20h-3.5v-.38l-1.15-1.16A2.979 2.979 0 0018 15.5V9c0-2.63-3-3-6-3s-6 .37-6 3v6.5c0 1.54 1.16 2.79 2.65 2.96L7.5 19.62V20H4V8.86c0-2 1.01-3.45 2.93-4.2C8.41 4.08 10.32 4 12 4s3.59.08 5.07.66c1.92.75 2.93 2.2 2.93 4.2V20z"
                }
            }
        ]
    })(props);
}
function MdOutlineSynagogue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4c-1.66 0-3 1.34-3 3v.29L12 3 7 7.29V7c0-1.66-1.34-3-3-3S1 5.34 1 7v14h10v-5c0-.55.45-1 1-1s1 .45 1 1v5h10V7c0-1.66-1.34-3-3-3zm0 2c.55 0 1 .45 1 1v1h-2V7c0-.55.45-1 1-1zM4 6c.55 0 1 .45 1 1v1H3V7c0-.55.45-1 1-1zM3 19v-9h2v9H3zm14 0h-2v-3c0-1.65-1.35-3-3-3s-3 1.35-3 3v3H7V9.92l5-4.29 5 4.29V19zm2 0v-9h2v9h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "10",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineTakeoutDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.79 18l-.51-7h9.46l-.51 7H7.79zM9.83 5h4.33l2.8 2.73L16.87 9H7.12l-.09-1.27L9.83 5zM22 7.46l-1.41-1.41L19 7.63l.03-.56L14.98 3H9.02L4.97 7.07l.03.5-1.59-1.56L2 7.44l3.23 3.11.7 9.45h12.14l.7-9.44L22 7.46z"
                }
            }
        ]
    })(props);
}
function MdOutlineTaxiAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "15.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13v5H4v-5h14c-1.91 0-3.63-.76-4.89-2h-8.3l1.04-3h5.44C11.1 7.37 11 6.7 11 6s.1-1.37.29-2H8v2H5.5c-.66 0-1.21.42-1.42 1.01L2 13v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-.09-.27c-.61.17-1.25.27-1.91.27z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V8h1v1zm0-2h-1V3h1v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTempleBuddhist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 9.02c0 1.09-.89 1.98-1.98 1.98H18V8.86c1.72-.44 3-1.99 3-3.84V5l-2 .02C19 6.11 18.11 7 17.02 7h-.52L12 1 7.5 7h-.52C5.89 7 5 6.11 5 5.02H3c0 1.86 1.28 3.4 3 3.84V11H4.98C3.89 11 3 10.11 3 9.02H1c0 1.86 1.28 3.4 3 3.84V22h7v-4c0-.55.45-1 1-1s1 .45 1 1v4h7v-9.14c1.72-.44 3-1.99 3-3.84V9l-2 .02zm-9-4.69L14 7h-4l2-2.67zM8 9h8v2H8V9zm10 11h-3v-2c0-1.65-1.35-3-3-3s-3 1.35-3 3v2H6v-7h12v7z"
                }
            }
        ]
    })(props);
}
function MdOutlineTempleHindu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11v2h-2L15 3V1h-2v2h-2.03V1h-2v2.12L6 13H4v-2H2v11h9v-5h2v5h9V11h-2zm-4.69 0H8.69l.6-2h5.42l.6 2zm-1.2-4H9.89l.6-2h3.02l.6 2zM20 20h-5v-5H9v5H4v-5h3.49l.6-2h7.82l.6 2H20v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTerrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 6l-4.22 5.63 1.25 1.67L14 9.33 19 16h-8.46l-4.01-5.37L1 18h22L14 6zM5 16l1.52-2.03L8.04 16H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTheaterComedy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "6.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "6.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.99 9c-1.38 0-2.5.84-2.5 1.88h5c0-1.04-1.12-1.88-2.5-1.88zM1 16c0 3.31 2.69 6 6 6s6-2.69 6-6V9H1v7zm2-5h8v5c0 2.21-1.79 4-4 4s-4-1.79-4-4v-5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 2v5.5h2V4h8v5c0 2.21-1.79 4-4 4-.95 0-1.81-.35-2.5-.9v2.35c.76.35 1.61.55 2.5.55 3.31 0 6-2.69 6-6V2H11z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "13.5",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13.5",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 17.88c1.38 0 2.5-.84 2.5-1.88h-5c0 1.04 1.12 1.88 2.5 1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineTireRepair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 8a1.003 1.003 0 01-.71-1.71c.4-.4 2.46-1.04 2.46-1.04s-.64 2.06-1.04 2.46c-.18.18-.43.29-.71.29zm1 5v5c0 1.65-1.35 3-3 3s-3-1.35-3-3v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8.17A3.009 3.009 0 0116 16v2c0 .55.45 1 1 1s1-.45 1-1v-5h-1v-1.42c-1.77-.77-3-2.53-3-4.58 0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.05-1.23 3.81-3 4.58V13h-1zm2-6c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zM10 7L8 9V6.17L9.17 5H4.83L6 6.17V9L4 7v2.17l2 2V14l-2-2v2.17l2 2V19l-2-2v2h6v-2l-2 2v-2.83l2-2V12l-2 2v-2.83l2-2V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineTraffic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-5 9H9V5h6v14zm-3-1c.83 0 1.5-.67 1.5-1.5S12.83 15 12 15s-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm0-4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM12 9c.83 0 1.5-.67 1.5-1.5S12.83 6 12 6s-1.5.67-1.5 1.5S11.17 9 12 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2l2-2h4l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-4-4-8-4zm0 2c3.51 0 4.96.48 5.57 1H6.43c.61-.52 2.06-1 5.57-1zM6 7h5v3H6V7zm12 8.5c0 .83-.67 1.5-1.5 1.5h-9c-.83 0-1.5-.67-1.5-1.5V12h12v3.5zm0-5.5h-5V7h5v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 5l.75-1.5H17V2H7v1.5h4.75L11 5c-3.13.09-6 .73-6 3.5V17c0 1.5 1.11 2.73 2.55 2.95L6 21.5v.5h2l2-2h4l2 2h2v-.5l-1.55-1.55h-.01.01C17.89 19.73 19 18.5 19 17V8.5c0-2.77-2.87-3.41-6-3.5zm-1.97 2h1.94c2.75.08 3.62.58 3.9 1H7.13c.28-.42 1.15-.92 3.9-1zm-.18 10.95H7.74A.974.974 0 017 17v-1h3.89c-.24.27-.39.61-.39 1 0 .36.13.69.35.95zM17 17c0 .45-.3.84-.74.95h-3.11c.22-.26.35-.59.35-.95 0-.39-.15-.73-.39-1H17v1zm0-3H7v-4h10v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTransferWithinAStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18v1.75zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
                }
            }
        ]
    })(props);
}
function MdOutlineTransitEnterexit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTripOrigin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12zm10 6c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.83 11l1.59 1.59L7 14l-4-4 4-4 1.41 1.41L6.83 9H15c1.1 0 2 .9 2 2v9h-2v-9H6.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.17 11l-1.59 1.59L17 14l4-4-4-4-1.41 1.41L17.17 9H9c-1.1 0-2 .9-2 2v9h2v-9h8.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnSharpLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.83L4.41 8.41 3 7l4-4 4 4-1.41 1.41L8 6.83V13h8c1.1 0 2 .9 2 2v6h-2v-6H8c-1.1 0-2-.9-2-2V6.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnSharpRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6.83l1.59 1.59L21 7l-4-4-4 4 1.41 1.41L16 6.83V13H8c-1.1 0-2 .9-2 2v6h2v-6h8c1.1 0 2-.9 2-2V6.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnSlightLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-7.58c0-.53-.21-1.04-.59-1.41l-5-5h2.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineTurnSlightRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.34 6V4H18v5.66h-2V7.41l-5 5V20H9v-7.58c0-.53.21-1.04.59-1.41l5-5h-2.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineTwoWheeler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.17 11H4h.17m9.24-6H9v2h3.59l2 2H11l-4 2-2-2H0v2h4c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4l2 2h3l3.49-6.1 1.01 1.01c-.91.73-1.5 1.84-1.5 3.09 0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4c-.18 0-.36.03-.53.05L17.41 9H20V6l-3.72 1.86L13.41 5zM20 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM4 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineUTurnLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9v12h-2V9c0-2.21-1.79-4-4-4S8 6.79 8 9v4.17l1.59-1.59L11 13l-4 4-4-4 1.41-1.41L6 13.17V9c0-3.31 2.69-6 6-6s6 2.69 6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineUTurnRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 9v12h2V9c0-2.21 1.79-4 4-4s4 1.79 4 4v4.17l-1.59-1.59L13 13l4 4 4-4-1.41-1.41L18 13.17V9c0-3.31-2.69-6-6-6S6 5.69 6 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineVolunteerActivism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13c3.09-2.81 6-5.44 6-7.7C22 3.45 20.55 2 18.7 2c-1.04 0-2.05.49-2.7 1.25C15.34 2.49 14.34 2 13.3 2 11.45 2 10 3.45 10 5.3c0 2.26 2.91 4.89 6 7.7zm-2.7-9c.44 0 .89.21 1.18.55L16 6.34l1.52-1.79c.29-.34.74-.55 1.18-.55.74 0 1.3.56 1.3 1.3 0 1.12-2.04 3.17-4 4.99-1.96-1.82-4-3.88-4-4.99 0-.74.56-1.3 1.3-1.3zM19 16h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3zM3 20v-7h2v7H3zm10.97.41L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-1.99-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19c.39 0 .74.23.9.56l-5.93 1.84z"
                }
            }
        ]
    })(props);
}
function MdOutlineWarehouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8.35V19h-2v-8H6v8H4V8.35l8-3.2 8 3.2zM22 21V7L12 3 2 7v14h6v-8h8v8h6zm-11-2H9v2h2v-2zm2-3h-2v2h2v-2zm2 3h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWineBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3v6c0 2.97 2.16 5.43 5 5.91V19H8v2h8v-2h-3v-4.09c2.84-.48 5-2.94 5-5.91V3H6zm6 10c-1.86 0-3.41-1.28-3.86-3h7.72c-.45 1.72-2 3-3.86 3zm4-5H8V5h8v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineWrongLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v.2c0 2.34-1.95 5.44-6 9.14-4.05-3.7-6-6.79-6-9.14C6 7.57 8.65 5 12 5c.34 0 .68.03 1 .08V3.06c-.33-.04-.66-.06-1-.06-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8V11h-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "11",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.54 2.88l-1.42-1.42L19 3.59l-2.12-2.13-1.42 1.42L17.59 5l-2.13 2.12 1.42 1.42L19 6.41l2.12 2.13 1.42-1.42L20.41 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineZoomInMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 9V3H7v2.59L3.91 2.5 2.5 3.91 5.59 7H3v2h6zm12 0V7h-2.59l3.09-3.09-1.41-1.41L17 5.59V3h-2v6h6zM3 15v2h2.59L2.5 20.09l1.41 1.41L7 18.41V21h2v-6H3zm12 0v6h2v-2.59l3.09 3.09 1.41-1.41L18.41 17H21v-2h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineZoomOutMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3h-6zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3v6zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6h6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6v-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddHomeWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H5v5H3v-6.97l5-3.57 5 3.57v1.08c.57-.59 1.25-1.07 2-1.42V11L8 6l-7 5v10h6v-5h2v5h2.68c-.43-.91-.68-1.92-.68-3v-4zM17 7h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 13.11V3H10v1.97l2 1.43V5h9v6.68c.75.36 1.43.84 2 1.43zM23 18c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5.5 3v-2.5H15v-1h2.5V15h1v2.5H21v1h-2.5V21h-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAppSettingsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M7 20h10v1H7zM7 3h10v1H7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.81 12.74l-.82-.63v-.22l.8-.63c.16-.12.2-.34.1-.51l-.85-1.48a.395.395 0 00-.35-.2c-.05 0-.1.01-.15.03l-.95.38c-.08-.05-.11-.07-.19-.11l-.15-1.01a.408.408 0 00-.4-.36h-1.71c-.2 0-.37.15-.4.34l-.14 1.01c-.03.02-.07.03-.1.05l-.09.06-.95-.38a.401.401 0 00-.5.17l-.85 1.48c-.1.17-.06.39.1.51l.8.63v.23l-.8.63a.39.39 0 00-.1.51l.85 1.48c.07.13.21.2.35.2.05 0 .1-.01.15-.03l.95-.37c.08.05.12.07.2.11l.15 1.01c.03.2.2.34.4.34h1.71c.2 0 .37-.15.4-.34l.15-1.01c.03-.02.07-.03.1-.05l.09-.06.95.38a.401.401 0 00.5-.17l.85-1.48a.39.39 0 00-.1-.51zM18 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM17 18H7V6h10v1h2V3c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v1zM7 3h10v1H7V3zm10 18H7v-1h10v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAppsOutage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6 6h4v-4h-4v4zm3-20c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm.5 8h-1V7h1v1zm0-2h-1V2h1v4zM16 14h4v-2.07c-.33.05-.66.07-1 .07-1.07 0-2.09-.24-3-.68V14zM10 4v4h2.68c-.44-.91-.68-1.93-.68-3 0-.34.02-.67.07-1H10z"
                }
            }
        ]
    })(props);
}
function MdOutlineApps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowBackIosNew(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.77 3.77L16 2 6 12l10 10 1.77-1.77L9.54 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowBackIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowDownward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowDropDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 13l-4-4h8z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowDropDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 10l5 5 5-5H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowDropUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14l5-5 5 5H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowForwardIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.23 20.23L8 22l10-10L8 2 6.23 3.77 14.46 12z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7l-5 5 5 5V7z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 17l5-5-5-5v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineArrowUpward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssistantDirection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-4.99 0-9-4.01-9-9s4.01-9 9-9 9 4.01 9 9-4.01 9-9 9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.73 11.42L12.54 4.2c-.36-.27-.8-.27-1.15 0L4.2 11.42c-.27.36-.27.8 0 1.16l7.19 7.22c.36.27.8.27 1.15 0l7.19-7.22c.36-.36.36-.89 0-1.16zM13.5 14.5l-1.41-1.41L13.17 12H10v3H8v-4c0-.6.4-1 1-1h4.17l-1.09-1.09L13.5 7.5 17 11l-3.5 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCampaign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11v2h4v-2h-4zM16 17.61c.96.71 2.21 1.65 3.2 2.39.4-.53.8-1.07 1.2-1.6-.99-.74-2.24-1.68-3.2-2.4-.4.54-.8 1.08-1.2 1.61zM20.4 5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24 1.68-3.2 2.4.4.53.8 1.07 1.2 1.6.96-.72 2.21-1.65 3.2-2.4zM4 9c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h1v4h2v-4h1l5 3V6L8 9H4zm5.03 1.71L11 9.53v4.94l-1.97-1.18-.48-.29H4v-2h4.55l.48-.29zM15.5 12c0-1.33-.58-2.53-1.5-3.35v6.69c.92-.81 1.5-2.01 1.5-3.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineCancel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoubleArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 5H11l5 7-5 7h4.5l5-7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 5H4l5 7-5 7h4.5l5-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineEast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 5l-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineExpandCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.08 9.59L12 12.67 8.92 9.59 7.5 11l4.5 4.5 4.5-4.5-1.42-1.41zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineExpandLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineExpandMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineFirstPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFullscreenExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineHomeWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 11v10h6v-5h2v5h6V11L8 6l-7 5zm12 8h-2v-5H5v5H3v-6.97l5-3.57 5 3.57V19zM17 7h2v2h-2zM17 11h2v2h-2zM17 15h2v2h-2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z"
                }
            }
        ]
    })(props);
}
function MdOutlineLastPage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineLegendToggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15H4v-2h16v2zm0 2H4v2h16v-2zm-5-6l5-3.55V5l-5 3.55L10 5 4 8.66V11l5.92-3.61L15 11z"
                }
            }
        ]
    })(props);
}
function MdOutlineMapsHomeWork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 7h2v2h-2zM17 11h2v2h-2zM17 15h2v2h-2zM1 11v10h6v-5h2v5h6V11L8 6l-7 5zm12 8h-2v-5H5v5H3v-7l5-3.5 5 3.5v7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3v1.97l2 1.43V5h9v14h-4v2h6V3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMenuOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoreHoriz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoreVert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNorthEast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineNorthWest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z"
                }
            }
        ]
    })(props);
}
function MdOutlineNorth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 9l1.41 1.41L11 5.83V22h2V5.83l4.59 4.59L19 9l-7-7-7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineOfflineShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 5H4v16c0 1.1.9 2 2 2h10v-2H6V5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 1h-8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16h-8v-1h8v1zm0-3h-8V6h8v8zm0-10h-8V3h8v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 10.25h1.63l-.69.69L14.5 12 17 9.5 14.5 7l-1.06 1.06.69.69H12c-.55 0-1 .45-1 1V12h1.5v-1.75z"
                }
            }
        ]
    })(props);
}
function MdOutlinePayments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-2 0H3V6h14v8zm-7-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm13 0v11c0 1.1-.9 2-2 2H4v-2h17V7h2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePivotTableChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 5c0-1.1-.9-2-2-2h-9v5h11V5zM3 19c0 1.1.9 2 2 2h3V10H3v9zM3 5v3h5V3H5c-1.1 0-2 .9-2 2zm15 3.99L14 13l1.41 1.41 1.59-1.6V15c0 1.1-.9 2-2 2h-2.17l1.59-1.59L13 14l-4 4 4 4 1.41-1.41L12.83 19H15c2.21 0 4-1.79 4-4v-2.18l1.59 1.6L22 13l-4-4.01z"
                }
            }
        ]
    })(props);
}
function MdOutlineRefresh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.65 6.35A7.958 7.958 0 0012 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
                }
            }
        ]
    })(props);
}
function MdOutlineSouthEast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSouthWest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19v-2H8.41L20 5.41 18.59 4 7 15.59V9H5v10h10z"
                }
            }
        ]
    })(props);
}
function MdOutlineSouth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-1.41-1.41L13 18.17V2h-2v16.17l-4.59-4.59L5 15l7 7 7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubdirectoryArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSubdirectoryArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24v24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 8.62v6.76L5.12 12 8.5 8.62M10 5l-7 7 7 7V5zm4 0v14l7-7-7-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 24H0V0h24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnfoldLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M24 0v24H0V0h24z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineUnfoldMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineWaterfallChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4h3v16h-3V4zM3 13h3v7H3v-7zm11-9h3v3h-3V4zm-4 1h3v4h-3V5zm-3 5h3v4H7v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 19l1.41-1.41L5.83 13H22v-2H5.83l4.59-4.59L9 5l-7 7 7 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineAccountTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11V3h-7v3H9V3H2v8h7V8h2v10h4v3h7v-8h-7v3h-2V8h2v3h7zM7 9H4V5h3v4zm10 6h3v4h-3v-4zm0-10h3v4h-3V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatFlatAngled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6.5c.31 0 .7.15.9.56.24.5.02 1.1-.47 1.34a.979.979 0 01-1.32-.46.986.986 0 01.46-1.34c.14-.06.28-.1.43-.1m6.47 2.11l6.69 2.41c.52.19.93.56 1.15 1.05.22.48.25 1.03.06 1.53l-.01.02-8.59-3.11.7-1.9M10 15.19l4 1.44V17h-4v-1.81M6 4.5c-.44 0-.88.1-1.3.3a2.99 2.99 0 00-1.4 4 2.988 2.988 0 004 1.4 3.01 3.01 0 001.41-4A3.013 3.013 0 006 4.5zm5.28 1.55L9.2 11.71l12.36 4.47.69-1.89a4 4 0 00-2.41-5.15l-8.56-3.09zm-9.09 4.2l-.69 1.89L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatFlat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 13a3 3 0 002.1-5.14C6.51 7.29 5.75 7 5 7a3 3 0 00-2.1 5.14c.59.57 1.35.86 2.1.86zm-.71-3.7a1 1 0 011.41-.02c.4.39.4 1.01.02 1.41-.2.2-.45.31-.72.31-.26 0-.51-.1-.7-.28-.4-.4-.4-1.02-.01-1.42zM18 7H9v6h13v-2c0-2.21-1.79-4-4-4zm-7 4V9h7c1.1 0 2 .9 2 2h-9zm-9 5h6v2h8v-2h6v-2H2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatIndividualSuite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 14c1.66 0 3-1.34 3-3S8.66 8 7 8s-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm12-3h-8v8H3V7H1v10h22v-6c0-2.21-1.79-4-4-4zm2 8h-8V9h6c1.1 0 2 .9 2 2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatLegroomExtra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98A2.019 2.019 0 0014.51 9H11V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatLegroomNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatLegroomReduced(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatReclineExtra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76A5.01 5.01 0 008.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38a2.21 2.21 0 00-.99-.06h-.02a2.268 2.268 0 00-1.84 2.61l1.35 5.92A3.008 3.008 0 009.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirlineSeatReclineNormal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.59 5.41c-.78-.78-.78-2.05 0-2.83s2.05-.78 2.83 0 .78 2.05 0 2.83c-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineBluetoothAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33s-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2a9.936 9.936 0 001.54-5.31c-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineConfirmationNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V6a2 2 0 00-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54zM11 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDirectionsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.71 11.29l-9-9a.996.996 0 00-1.41 0L8.21 5.38l1.41 1.41L12 4.42 19.58 12l-2.38 2.38 1.41 1.41 3.09-3.09c.4-.37.4-1 .01-1.41z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 7.5v2.67l2.17 2.17L16.5 11zM1.39 4.22l3.99 3.99-3.09 3.09a.996.996 0 000 1.41l9 9c.39.39 1.02.39 1.41 0l3.09-3.09 3.99 3.99 1.41-1.41L2.81 2.81 1.39 4.22zm6.64 6.63c-.01.05-.04.1-.04.15v4h2v-2.18l4.38 4.38L12 19.58 4.42 12 6.8 9.62l1.23 1.23z"
                }
            }
        ]
    })(props);
}
function MdOutlineDiscFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h2v5h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm10-4h2v2h-2zm-10-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoDisturbAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoDisturbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4c4.41 0 8 3.59 8 8 0 1.41-.37 2.73-1.01 3.88l1.46 1.46A9.96 9.96 0 0022 12c0-5.52-4.48-10-10-10a9.9 9.9 0 00-5.33 1.55l1.46 1.46A7.883 7.883 0 0112 4zm5 7h-2.88l2 2H17zM2.41 2.13L1 3.54l2.78 2.78A9.92 9.92 0 002 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.41-1.41L2.41 2.13zM12 20c-4.41 0-8-3.59-8-8 0-1.56.45-3 1.23-4.23L8.46 11H7v2h3.46l5.77 5.77A7.846 7.846 0 0112 20z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoDisturbOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-5-9h10v2H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoDisturb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotDisturbAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotDisturbOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.94 5.12C9.14 4.41 10.52 4 12 4c4.41 0 8 3.59 8 8 0 1.48-.41 2.86-1.12 4.06l1.46 1.46A9.967 9.967 0 0022 12c0-5.52-4.48-10-10-10-2.04 0-3.93.61-5.51 1.66l1.45 1.46zM2.81 2.81L1.39 4.22l2.27 2.27A9.91 9.91 0 002 12c0 5.52 4.48 10 10 10 2.04 0 3.93-.61 5.51-1.66l2.27 2.27 1.41-1.41L2.81 2.81zM12 20c-4.41 0-8-3.59-8-8 0-1.48.41-2.86 1.12-4.06L8.17 11H7v2h3.17l5.88 5.88A7.869 7.869 0 0112 20z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.83 11l2 2H17v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotDisturbOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotDisturb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31A7.902 7.902 0 0112 20zm6.31-3.1L7.1 5.69A7.902 7.902 0 0112 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineDriveEta(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineEnhancedEncryption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10zm-5-9h-2v3H8v2h3v3h2v-3h3v-2h-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineEventAvailable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm5.56 10.46l5.93-5.93-1.06-1.06-4.87 4.87-2.11-2.11-1.06 1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineEventBusy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm3.23 9.41l1.06 1.06 2.44-2.44 2.44 2.44 1.06-1.06-2.44-2.44 2.44-2.44-1.06-1.06-2.44 2.44-2.44-2.44-1.06 1.06 2.44 2.44z"
                }
            }
        ]
    })(props);
}
function MdOutlineEventNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zM5 7V5h14v2H5zm2 4h10v2H7zm0 4h7v2H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineFolderSpecial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"
                }
            }
        ]
    })(props);
}
function MdOutlineImagesearchRoller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7V3c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h8v3h-1c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1h-1v-3c0-1.1-.9-2-2-2H4V6h2v1c0 .55.45 1 1 1h12c.55 0 1-.45 1-1zM8 4h10v2H8V4zm6 17h-2v-4h2v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineLiveTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 10v8l7-4zm12-4h-7.58l3.29-3.29L16 2l-4 4h-.03l-4-4-.69.71L10.56 6H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 14H3V8h18v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineMms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-5.5-8L11 12.51 8.5 9.5 5 14h14z"
                }
            }
        ]
    })(props);
}
function MdOutlineMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7.07L2.4 12l4.66-7H22v14z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19",
                    "cy": "12",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2a15.367 15.367 0 00-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2a7.1 7.1 0 014.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
                }
            }
        ]
    })(props);
}
function MdOutlineNetworkLocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 16v-.5a2.5 2.5 0 00-5 0v.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5zM18 5.83v5.43c.47-.16.97-.26 1.5-.26.17 0 .33.03.5.05V1L1 20h13v-2H5.83L18 5.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoEncryptionGmailerrorred(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66l2 2H18v5.56l2 2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zM4.41 4.81L3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l1 1 1.41-1.41L4.41 4.81zM6 20V10h.78l10 10H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoEncryption(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2h-4.66l2 2H18v5.56l2 2V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.32 0-4.26 1.59-4.82 3.74L8.9 6.46V6zM4.41 4.81L3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12.78l1 1 1.41-1.41L4.41 4.81zM6 20V10h.78l10 10H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineOndemandVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 7v8l7-4zm12-4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonalVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 002 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 00-2-2zm0 14H3V5h18v12z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneBluetoothSpeaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneCallback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.51c-1.24 0-2.45-.2-3.57-.57a.84.84 0 00-.31-.05c-.26 0-.51.1-.71.29l-2.2 2.2a15.149 15.149 0 01-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1zM5.03 5h1.5a13 13 0 00.46 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79zM19 18.97c-1.32-.09-2.59-.35-3.8-.75l1.19-1.19c.85.24 1.72.39 2.6.45v1.49zM18 9h-2.59l5.02-5.02-1.41-1.41L14 7.59V5h-2v6h6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneForwarded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51zM18 11l5-5-5-5v3h-4v4h4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneInTalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3zm4 0h2a9 9 0 00-9-9v2c3.87 0 7 3.13 7 7zm1 3.5c-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM5.03 5h1.5c.07.88.22 1.75.45 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79zM19 18.97c-1.32-.09-2.6-.35-3.8-.76l1.2-1.2c.85.24 1.72.39 2.6.45v1.51z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneLocked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5V4c0-1.1-.9-2-2-2s-2 .9-2 2v1h-1v5h6V5h-1zm-1 0h-2V4c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.2 14.87l-3.67-.73c-.5-.1-.83.2-.9.27l-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.55.03 1.03-.43 1.03-1v-4.15c0-.48-.34-.89-.8-.98zM5.1 5h2.23l.47 2.35L6.17 9c-.54-1.3-.9-2.63-1.07-4zM19 18.9c-1.37-.18-2.7-.53-4-1.07l1.65-1.63 2.35.47v2.23z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhoneMissed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23.71 16.67C20.66 13.78 16.54 12 12 12S3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.28-.12-.52-.3-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.08 1.26c-.6-.48-1.22-.9-1.88-1.27v-1.7c1.05.51 2.03 1.15 2.95 1.9l-1.07 1.07zM7 6.43l4.94 4.94 7.07-7.07-1.41-1.42-5.66 5.66L8.4 5H11V3H5v6h2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePhonePaused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.54 5c.06.88.21 1.75.44 2.58l-1.2 1.21c-.4-1.21-.66-2.47-.75-3.79h1.51m9.86 12.01c.85.24 1.72.39 2.6.45v1.5c-1.32-.09-2.6-.35-3.8-.76l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1-1.25 0-2.45-.2-3.57-.57-.1-.03-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2a15.045 15.045 0 01-6.59-6.59l2.2-2.21a.96.96 0 00.25-1A11.36 11.36 0 018.5 4c0-.55-.45-1-1-1zM15 3h2v7h-2zm4 0h2v7h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePowerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3H8v1.88l2 2zm6 6v3.88l1.8 1.8.2-.2V9c0-1.1-.9-2-2-2V3h-2v4h-3.88l2 2H16zM4.12 3.84L2.71 5.25 6 8.54v5.96L9.5 18v3h5v-3l.48-.48 4.47 4.47 1.41-1.41L4.12 3.84zm8.38 13.33V19h-1v-1.83L8 13.65v-3.11l5.57 5.57-1.07 1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlinePower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 9v4.66l-3.5 3.51V19h-1v-1.83L8 13.65V9h8m0-6h-2v4h-4V3H8v4h-.01C6.9 6.99 6 7.89 6 8.98v5.52L9.5 18v3h5v-3l3.5-3.51V9c0-1.1-.9-2-2-2V3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePriorityHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "19",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 3h4v12h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRunningWithErrors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10v8h-2v-8h2zm-2 10v2h2v-2h-2zm-2-2.71A7.99 7.99 0 0112 20c-4.41 0-8-3.59-8-8s3.59-8 8-8v9l7.55-7.55A9.965 9.965 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10c2.25 0 4.33-.74 6-2v-2.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineSdCardAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zm-7-5h2v2h-2zm0-7h2v5h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4 8v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16zM9 7h2v4H9zm3 0h2v4h-2zm3 0h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSimCardAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H6V8.83L10.83 4H18v16z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 15h2v2h-2zM11 8h2v5h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmsFailed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7zm8 0h2v2h-2zm-4 0h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSupportAgent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12.22C21 6.73 16.74 3 12 3c-4.69 0-9 3.65-9 9.28-.6.34-1 .98-1 1.72v2c0 1.1.9 2 2 2h1v-6.1c0-3.87 3.13-7 7-7s7 3.13 7 7V19h-8v2h8c1.1 0 2-.9 2-2v-1.22c.59-.31 1-.92 1-1.64v-2.3c0-.7-.41-1.31-1-1.62z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 11.03A6.04 6.04 0 0012.05 6c-3.03 0-6.29 2.51-6.03 6.45a8.075 8.075 0 004.86-5.89c1.31 2.63 4 4.44 7.12 4.47z"
                }
            }
        ]
    })(props);
}
function MdOutlineSyncDisabled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 6.35V4.26c-.66.17-1.29.43-1.88.75l1.5 1.5c.13-.05.25-.11.38-.16zM20 12c0-2.21-.91-4.2-2.36-5.64L20 4h-6v6l2.24-2.24A6.003 6.003 0 0118 12c0 .85-.19 1.65-.51 2.38l1.5 1.5A7.921 7.921 0 0020 12zM4.27 4L2.86 5.41l2.36 2.36a7.925 7.925 0 001.14 9.87L4 20h6v-6l-2.24 2.24A6.003 6.003 0 016 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.24-.76.34v2.09c.8-.21 1.55-.54 2.23-.96l2.58 2.58 1.41-1.41L4.27 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineSyncLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 4.26v2.09C7.67 7.18 6 9.39 6 12c0 1.77.78 3.34 2 4.44V14h2v6H4v-2h2.73A7.942 7.942 0 014 12c0-3.73 2.55-6.85 6-7.74zM20 4h-6v6h2V7.56c1.22 1.1 2 2.67 2 4.44h2c0-2.4-1.06-4.54-2.73-6H20V4zm0 13v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1zm-1 0h-2v-1c0-.55.45-1 1-1s1 .45 1 1v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSyncProblem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24A6.003 6.003 0 015 12a5.99 5.99 0 014-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24A6.003 6.003 0 0119 12a5.99 5.99 0 01-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0020 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74A7.93 7.93 0 004 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSystemUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineTapAndPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2a9 9 0 019 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineTimeToLeave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 6h10.29l1.04 3H5.81l1.04-3zM19 16H5v-4.66l.12-.34h13.77l.11.34V16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineTvOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7v10.88l1.85 1.85c.09-.23.15-.47.15-.73V7c0-1.11-.89-2-2-2h-7.58l3.29-3.3L16 1l-4 4-4-4-.7.7L10.58 5H8.12l2 2H21zm-.54 16l1.26-1.27-1.26 1.26zM2.41 2.13l-.14.14L1 3.54l1.53 1.53C1.65 5.28 1 6.06 1 7v12c0 1.1.9 2 2 2h15.46l1.99 1.99 1.26-1.26.15-.15L2.41 2.13zM3 19V7h1.46l12 12H3z"
                }
            }
        ]
    })(props);
}
function MdOutlineVibration(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
                }
            }
        ]
    })(props);
}
function MdOutlineVideoChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14h6c.55 0 1-.45 1-1v-1.99L17 13V7l-2 1.99V7c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineVoiceChat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zm-6-5.4l3 2.4V7l-3 2.4V7H7v6h7z"
                }
            }
        ]
    })(props);
}
function MdOutlineVpnLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.92 12c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93zM22 4v-.5a2.5 2.5 0 00-5 0V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 0h-3v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M.01 0h24v24h-24V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63A2.01 2.01 0 0016.56 7h-.12a2 2 0 00-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifiOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 11l2-2c-3.73-3.73-8.87-5.15-13.7-4.31l2.58 2.58c3.3-.02 6.61 1.22 9.12 3.73zm-2 2a9.895 9.895 0 00-3.72-2.33l3.02 3.02.7-.69zM9 17l3 3 3-3a4.237 4.237 0 00-6 0zM3.41 1.64L2 3.05 5.05 6.1C3.59 6.83 2.22 7.79 1 9l2 2c1.23-1.23 2.65-2.16 4.17-2.78l2.24 2.24A9.823 9.823 0 005 13l2 2a6.999 6.999 0 014.89-2.06l7.08 7.08 1.41-1.41L3.41 1.64z"
                }
            }
        ]
    })(props);
}
function MdOutlineWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0zm0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3a4.237 4.237 0 00-6 0zm-4-4l2 2a7.074 7.074 0 0110 0l2-2C15.14 9.14 8.87 9.14 5 13z"
                }
            }
        ]
    })(props);
}
function MdOutlineAcUnit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAirportShuttle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5H3a2 2 0 00-2 2v9h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-6-6zm-2 2h1l3 3h-4V7zM9 7h4v3H9V7zM3 7h4v3H3V7zm3 10.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm12 0a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM21 14h-.78c-.55-.61-1.34-1-2.22-1s-1.67.39-2.22 1H8.22c-.55-.61-1.33-1-2.22-1s-1.67.39-2.22 1H3v-2h18v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineAllInclusive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2A5.37 5.37 0 005.4 6.62C2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l7.03-6.24c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12a5.386 5.386 0 003.82 1.57c2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
                }
            }
        ]
    })(props);
}
function MdOutlineApartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 11V3H7v4H3v14h8v-4h2v4h8V11h-4zM7 19H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm4 4H9v-2h2v2zm0-4H9V9h2v2zm0-4H9V5h2v2zm4 8h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm4 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBabyChangingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8v2h-3L8.31 8.82 7 12.75V22H3V12l1.58-4.63A2.003 2.003 0 017.3 6.18l4.15 1.83L14 8zM8 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm1 18h12v-2H9v2zm10.5-3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM13 12c0-.55-.45-1-1-1H9v2h2v1c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-3h-2v2h-2v-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17 4.14V2h-3v2h-4V2H7v2.14c-1.72.45-3 2-3 3.86v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8c0-1.86-1.28-3.41-3-3.86zM18 20H6V8c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v12zm-1.5-8v4h-2v-2h-7v-2h9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0v24h24V0H0z"
                }
            }
        ]
    })(props);
}
function MdOutlineBalcony(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10v2H8v-2h2zm6 2v-2h-2v2h2zm5 2v8H3v-8h1v-4c0-4.42 3.58-8 8-8s8 3.58 8 8v4h1zM7 16H5v4h2v-4zm4 0H9v4h2v-4zm0-11.92C8.16 4.56 6 7.03 6 10v4h5V4.08zM13 14h5v-4c0-2.97-2.16-5.44-5-5.92V14zm2 2h-2v4h2v-4zm4 0h-2v4h2v-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBathtub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "7",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 13V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 011.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 005 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2zm0 6H4v-4h16v4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBeachAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 19.57l-1.427 1.428-6.442-6.442 1.43-1.428zM13.12 3c-2.58 0-5.16.98-7.14 2.95l-.01.01c-3.95 3.95-3.95 10.36 0 14.31l14.3-14.31A10.086 10.086 0 0013.12 3zM6.14 17.27a8.063 8.063 0 01-.68-6.82c.19 1.91.89 3.79 2.07 5.44l-1.39 1.38zm2.84-2.84C7.63 12.38 7.12 9.93 7.6 7.6c.58-.12 1.16-.18 1.75-.18 1.8 0 3.55.55 5.08 1.56l-5.45 5.45zm1.47-8.97a8.063 8.063 0 016.82.68l-1.39 1.39a11.25 11.25 0 00-5.43-2.07z"
                }
            }
        ]
    })(props);
}
function MdOutlineBento(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 5H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 6h-6V7h6v4zM4 7h8v10H4V7zm10 10v-4h6v4h-6zm-4.5-5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBungalow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 14h-2v-2h2v2zm5.1 2.56L17 14.79V21H7v-6.2l-1.1 1.76-1.7-1.06L12 3l7.8 12.5-1.7 1.06zM15 11.59l-3-4.8-3 4.8V19h2v-3h2v3h2v-7.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineBusinessCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zM4 9h16v5h-5v-3H9v3H4V9zm9 6h-2v-2h2v2zm6 4H5v-3h4v1h6v-1h4v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineCabin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2zm2 2L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm1.94 4h-3.89L12 5.52 13.94 7zm-6.5 2h9.12L18 10.1v.9H6v-.9L7.44 9zM18 13v2H6v-2h12zM6 19v-2h12v2H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCarpenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.73 14.23L7 1.5 3.11 5.39l8.13 11.67c-.78.78-.78 2.05 0 2.83l1.41 1.41c.78.78 2.05.78 2.83 0l4.24-4.24c.79-.78.79-2.05.01-2.83zM5.71 5.62L7 4.33l8.49 8.49-2.81 2.81L5.71 5.62zm8.36 14.26l-1.41-1.41 4.24-4.24 1.41 1.41-4.24 4.24z"
                }
            }
        ]
    })(props);
}
function MdOutlineCasino(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "16.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "7.5",
                    "r": "1.5"
                }
            }
        ]
    })(props);
}
function MdOutlineChalet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 15L10 7.5 2.5 15l1.41 1.41L5 15.33V20h10v-4.67l1.09 1.09L17.5 15zM13 18h-2v-3H9v3H7v-4.67l3-3 3 3V18zm9-10.5h-1.19l.75.75-.71.71-1.46-1.46h-.89v.89l1.45 1.45-.71.71-.74-.74V11h-1V9.81l-.75.75-.71-.71 1.45-1.45v-.9h-.89l-1.45 1.45-.71-.71.75-.75H14v-1h1.19l-.75-.75.71-.71 1.45 1.45h.89v-.87l-1.45-1.45.71-.71.75.75V3h1v1.19l.75-.75.71.71-1.46 1.46v.89h.89l1.45-1.45.71.71-.74.74H22v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineChargingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 11l-3 6v-4h-2l3-6v4h2zM17 3H7v1h10V3m0 17H7v1h10v-1m0-19c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10zM7 18h10V6H7v12z"
                }
            }
        ]
    })(props);
}
function MdOutlineCheckroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.6 18.2L13 11.75v-.91a3.496 3.496 0 00-.18-6.75A3.51 3.51 0 008.5 7.5h2c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5c0 .84-.69 1.52-1.53 1.5-.54-.01-.97.45-.97.99v1.76L2.4 18.2c-.77.58-.36 1.8.6 1.8h18c.96 0 1.37-1.22.6-1.8zM6 18l6-4.5 6 4.5H6z"
                }
            }
        ]
    })(props);
}
function MdOutlineChildCare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9.5",
                    "cy": "10.5",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.94 11.34a4.008 4.008 0 00-2.81-3.17 9.114 9.114 0 00-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91a3.994 3.994 0 00-2.81 3.17c-.04.21-.06.43-.06.66 0 .23.02.45.06.66a4.008 4.008 0 002.81 3.17 8.977 8.977 0 002.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89a3.998 3.998 0 002.8-3.17c.04-.21.06-.43.06-.66 0-.23-.02-.45-.06-.66zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zm-7 3c2.01 0 3.74-1.23 4.5-3h-9c.76 1.77 2.49 3 4.5 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineChildFriendly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 2v8h8c0-4.42-3.58-8-8-8zm2 6V4.34c1.7.6 3.05 1.95 3.66 3.66H15zm-8.56 3l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61A7.948 7.948 0 0021 11H6.44zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20zm.74-5.34l-.29.37A3.505 3.505 0 0013.84 17h-2.68c-.5-1.04-1.5-1.8-2.68-1.97l-.44-.67c-.1-.17-.34-.69-.67-1.36h11.29c-.21.59-.52 1.15-.92 1.66z"
                }
            }
        ]
    })(props);
}
function MdOutlineCorporateFare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zm-2 12H4v-2h6v2zm0-4H4v-2h6v2zm0-4H4V9h6v2zm0-4H4V5h6v2zm10 12h-8V9h8v10zm-2-8h-4v2h4v-2zm0 4h-4v2h4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCottage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L6 7.58V6H4v3.11L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm6 16h-5v-4h-2v4H6v-8.9l6-4.58 6 4.58V19zM10 1c0 1.66-1.34 3-3 3-.55 0-1 .45-1 1H4c0-1.66 1.34-3 3-3 .55 0 1-.45 1-1h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCountertops(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10h-4V7c0-1.66-1.34-3-3-3s-3 1.34-3 3h2c0-.55.45-1 1-1s1 .45 1 1v3H8c1.1 0 2-.9 2-2V4H4v4c0 1.1.9 2 2 2H2v2h2v8h16v-8h2v-2zM6 6h2v2H6V6zm0 12v-6h5v6H6zm12 0h-5v-6h5v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrib(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h-6V4H8C5.79 4 4 5.79 4 8v6c0 1.1.9 2 2 2h2v2.93c-.61-.35-1.16-.78-1.65-1.27l-1.42 1.42C6.74 20.88 9.24 22 12 22c2.76 0 5.26-1.12 7.07-2.93l-1.42-1.42c-.49.49-1.05.92-1.65 1.27V16h2c1.1 0 2-.9 2-2v-3c0-1.1-.9-2-2-2zm-4 10.75c-.64.16-1.31.25-2 .25s-1.36-.09-2-.25V16h4v3.75zM18 14H6V8c0-1.1.9-2 2-2h2v5h8v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineDesk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 6v12h2V8h10v10h2v-2h4v2h2V6H2zm18 2v2h-4V8h4zm-4 6v-2h4v2h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotStep(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.51 15.68l-1.41-1.41 4.48-4.48L23 11.2l-4.49 4.48zm-3.53-3.53l3.07-3.07-4.25-4.26-3.08 3.07L9.3 6.47 13.8 2l7.08 7.08-4.48 4.48-1.42-1.41zm6.2 9.05l-1.41 1.41-5.94-5.94L10.5 20H1v-2.63c0-.84.52-1.57 1.3-1.88.58-.23 1.28-.56 1.97-1.02l1.38 1.38c.09.1.22.15.35.15s.26-.05.36-.15c.2-.2.2-.51 0-.71l-1.28-1.28c.27-.24.53-.51.77-.8l1.27 1.27a.485.485 0 00.7 0c.2-.2.2-.51 0-.71l-1.4-1.4c.19-.34.34-.72.45-1.12l1.71 1.72a.485.485 0 00.7 0c.19-.2.19-.5.01-.7l-7.9-7.9 1.42-1.41L21.18 21.2zm-8.76-5.94l-1.67-1.68-3.33 3.32c-.78.78-2.05.78-2.83-.01l-.19-.17-.47.24c-.29.14-.59.27-.89.39l-.01.65h6.64l2.75-2.74z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoNotTouch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.81 2.81L1.39 4.22 7 9.83v4.3l-2.6-1.48c-.17-.09-.34-.14-.54-.14-.26 0-.5.09-.7.26L2 13.88l6.8 7.18c.57.6 1.35.94 2.18.94H17c.62 0 1.18-.19 1.66-.52l1.12 1.12 1.41-1.41L2.81 2.81zM17 20h-6c-.39 0-.64-.23-.75-.36L6.87 16H9v-4.17l8.14 8.14c-.05.01-.09.03-.14.03zm-3.17-9H14V3.25a1.25 1.25 0 012.5 0V11h1V5.25a1.25 1.25 0 012.5 0v11.92l-2-2V13h-2.17l-2-2zm-.83-.83V2.25a1.25 1.25 0 00-2.5 0v5.42l2.5 2.5zm-3.5-3.5V4.25C9.5 3.56 8.94 3 8.25 3c-.67 0-1.2.53-1.24 1.18L9.5 6.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineDry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.75 16a1.25 1.25 0 000-2.5H12v-1h6.75c.69 0 1.25-.56 1.25-1.25 0-.67-.53-1.2-1.18-1.24L8.87 10l1.48-2.6c.09-.17.14-.34.14-.54 0-.26-.09-.5-.26-.7L9.12 5l-7.18 6.8c-.6.56-.94 1.35-.94 2.17V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75zM10 21H4c-.55 0-1-.45-1-1v-6c0-.39.23-.64.36-.75L7 9.87V12h3v9zm5.65-16.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L15 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L19 2h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
                }
            }
        ]
    })(props);
}
function MdOutlineElevator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15v-4h1v-2.5c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2V14h1v4h3zM8.5 8.5a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM18 11l-2.5-4-2.5 4h5zm-5 2l2.5 4 2.5-4h-5z"
                }
            }
        ]
    })(props);
}
function MdOutlineEscalatorWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.5 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S17.83 8 17 8s-1.5.67-1.5 1.5zm3 2.5h-2.84c-.58.01-1.14.32-1.45.86l-.92 1.32L9.72 8a2.02 2.02 0 00-1.71-1H5c-1.1 0-2 .9-2 2v6h1.5v7h5V11.61L12.03 16h2.2l.77-1.1V22h4v-5h1v-3.5c0-.82-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineEscalator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 3h-3.3l-5 9H7c-.83 0-1.5.67-1.5 1.5S6.17 18 7 18h3.3l5-9H17c.83 0 1.5-.67 1.5-1.5S17.83 6 17 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFamilyRestroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A2.01 2.01 0 0018.06 7h-.12a2 2 0 00-1.9 1.37l-.86 2.58c1.08.6 1.82 1.73 1.82 3.05v8h3zm-7.5-10.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5zM5.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm2 16v-7H9V9c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v6h1.5v7h4zm6.5 0v-4h1v-4c0-.82-.68-1.5-1.5-1.5h-2c-.82 0-1.5.68-1.5 1.5v4h1v4h3z"
                }
            }
        ]
    })(props);
}
function MdOutlineFence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2h2zm-5-5.17l1 1V10h-2V7.83l.41-.41.59-.59zm-4 0l.59.59.41.41V10h-2V7.83l.41-.41.59-.59zM11 14v-2h2v2h-2zm2 2v2h-2v-2h2zM7 7.83l1-1 .59.59.41.41V10H7V7.83zM7 12h2v2H7v-2zm0 4h2v2H7v-2zm10 2h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFireExtinguisher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h10v1c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2v-1zm0-1h10v-5H7v5zM17 3v6l-3.15-.66c-.01 0-.01.01-.02.02 1.55.62 2.72 1.98 3.07 3.64H7.1c.34-1.66 1.52-3.02 3.07-3.64-.33-.26-.6-.58-.8-.95L5 6.5v-1l4.37-.91C9.87 3.65 10.86 3 12 3c.7 0 1.34.25 1.85.66L17 3zm-4 3c-.03-.59-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineFitnessCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"
                }
            }
        ]
    })(props);
}
function MdOutlineFoodBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6zm-.5 6.5v3H11v-3h-1v3h-.5v-3h-1v3c0 .83.67 1.5 1.5 1.5v4h1v-4c.83 0 1.5-.67 1.5-1.5v-3h-1zm1.5 2v3h1V18h1V9.5c-1.1 0-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFoundation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v3H3v2h2v3h2v-3h4v3h2v-3h4v3h2v-3h2v-2h-2v-3zM7 15v-4.81l4-3.6V15H7zm6 0V6.59l4 3.6V15h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineFreeBreakfast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 19h16v2H4zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2a2 2 0 002-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h10v8zm4-5h-2V5h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineGite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6H9V4H7v2H6l-4 4v9h20v-9l-4-4zM4 12h10v5H4v-5zm16 5h-4v-6.17l2-2 2 2V17z"
                }
            }
        ]
    })(props);
}
function MdOutlineGolfCourse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineGrass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 20H2v-2h5.75A8.032 8.032 0 002 12.26c.64-.16 1.31-.26 2-.26 4.42 0 8 3.58 8 8zm10-7.74c-.64-.16-1.31-.26-2-.26-2.93 0-5.48 1.58-6.88 3.93a9.82 9.82 0 01.87 4.07h8v-2h-5.75A8.061 8.061 0 0122 12.26zm-6.36-1.24a10.03 10.03 0 014.09-5C15.44 6.16 12 9.67 12 14v.02c.95-1.27 2.2-2.3 3.64-3zm-4.22-2.17A8.527 8.527 0 006.7 4C8.14 5.86 9 8.18 9 10.71c0 .21-.03.41-.04.61.43.24.83.52 1.22.82a9.91 9.91 0 011.24-3.29z"
                }
            }
        ]
    })(props);
}
function MdOutlineHolidayVillage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 4l-6 6v10h12V10L8 4zm4 14H9v-3H7v3H4v-7.17l4-4 4 4V18zm-3-5H7v-2h2v2zm9 7V8.35L13.65 4h-2.83L16 9.18V20h2zm4 0V6.69L19.31 4h-2.83L20 7.52V20h2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHotTub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zM17.42 7.21c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06zm-4 0c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineHouseSiding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 12h3L12 3 2 12h3v8h2v-2h10v2h2v-8zM7.21 10h9.58l.21.19V12H7v-1.81l.21-.19zm7.36-2H9.43L12 5.69 14.57 8zM7 16v-2h10v2H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 9.3V4h-3v2.6L12 3 2 12h3v8h6v-6h2v6h6v-8h3l-3-2.7zM17 18h-2v-6H9v6H7v-7.81l5-4.5 5 4.5V18z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 10h4c0-1.1-.9-2-2-2s-2 .9-2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineHouseboat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.95 0-2.1 1-3.34 1-1.19 0-1.42-1-3.33-1-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19 0 1.42 1 3.33 1 1.95 0 2.08-1 3.32-1s1.37 1 3.32 1c1.91 0 2.14-1 3.33-1 1.18 0 1.45 1 3.35 1v-2c-1.24 0-1.38-1-3.33-1-1.91 0-2.14 1-3.33 1-1.24 0-1.39-1-3.34-1zm8.34-4.66l-1.37 1.37c-.19.18-.45.29-.71.29H17V9.65l1.32.97L19.5 9 12 3.5 4.5 9l1.18 1.61L7 9.65V13H5.74c-.27 0-.52-.11-.71-.29l-1.37-1.37-1.41 1.41 1.37 1.37c.56.56 1.33.88 2.12.88h12.51c.8 0 1.56-.32 2.12-.88l1.37-1.37-1.4-1.41zM13 13v-2h-2v2H9V8.18l3-2.2 3 2.2V13h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineIron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6c-1.66 0-3 1.34-3 3v4c0 .55-.45 1-1 1v-4c0-1.66-1.34-3-3-3h-4c-1.66 0-3 1.34-3 3h2c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1H6c-2.21 0-4 1.79-4 4v3h15v-2c1.66 0 3-1.34 3-3V9c0-.55.45-1 1-1h1V6h-1zm-6 10H4v-1c0-1.1.9-2 2-2h9v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineKitchen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 5h2v3H8zm0 7h2v5H8zm10-9.99L6 2a2 2 0 00-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMeetingRoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V4h-4V3H5v16H3v2h12V6h2v15h4v-2h-2zm-6 0H7V5h6v14zm-3-8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineMicrowave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 6h10v12H4V6zm16 12h-4V6h4v12zm-1-9h-2V7h2v2zm-1 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-7.75-1c-.79 0-1.37-.38-1.79-.66-.33-.22-.52-.34-.71-.34-.37 0-.8.41-.95.61l-1.42-1.42c.35-.4 1.21-1.19 2.37-1.19.8 0 1.39.39 1.81.67.31.21.51.33.69.33.37 0 .8-.41.95-.61l1.42 1.42c-.36.4-1.21 1.19-2.37 1.19zm0-5c-.79 0-1.37-.38-1.79-.66-.33-.22-.52-.34-.71-.34-.37 0-.8.41-.95.61L5.37 9.19C5.73 8.79 6.59 8 7.75 8c.8 0 1.39.39 1.81.67.31.21.51.33.69.33.37 0 .8-.41.95-.61l1.42 1.42c-.36.4-1.21 1.19-2.37 1.19z"
                }
            }
        ]
    })(props);
}
function MdOutlineNightShelter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6zm3 9h-3.5v3.5H8V11H7v7h1v-1.5h8V18h1v-4c0-1.1-.9-2-2-2zm-5.25.5a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.98 4.15c.01 0 .01-.01.02-.01V2h3v2h4V2h3v2.14c1.72.45 3 2 3 3.86v9.17l-2-2V8c0-1.1-.9-2-2-2H8.83L6.98 4.15zM14.83 12l1.67 1.67V12h-1.67zm4.95 10.61l-.85-.85c-.28.15-.59.24-.93.24H6c-1.1 0-2-.9-2-2V8c0-.36.06-.69.15-1.02L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM17.17 20l-6-6H7.5v-2h1.67L6 8.83V20h11.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoCell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6v8.17l2 2V3c0-1.1-.9-1.99-2-1.99L7 1c-.85 0-1.58.55-1.87 1.3L8.83 6H17zM7 3h10v1H7V3zm14.19 18.19L19 19l-2-2L7 7 5 5 2.81 2.81 1.39 4.22 5 7.83V21c0 1.1.9 2 2 2h10c.85 0 1.58-.55 1.87-1.3l.91.91 1.41-1.42zM17 21H7v-1h10v1zM7 18V9.83L15.17 18H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoDrinks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22l8.23 8.23L11 14v5H6v2h12v-.17l1.78 1.78 1.41-1.42zM13 19v-3.17L16.17 19H13zM7.83 5l-2-2H21v2l-6.2 6.97-1.42-1.42L14.77 9h-2.94l-2-2h6.74l1.78-2H7.83z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoFlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20.4 5.6H22L19 11V7h-1V2h4l-1.6 3.6zM16 11.4v1.77l2 2V11c0-.88-.72-1.6-1.6-1.6h-2.54L12.58 8h-1.75l3.4 3.4H16zM2.1 2.1L.69 3.51l5.66 5.66-.21.23H3.6c-.88 0-1.6.72-1.6 1.6v9.4c0 .88.72 1.6 1.6 1.6h12.8c.75 0 1.38-.52 1.55-1.22l2.54 2.54 1.41-1.41L2.1 2.1zm9.4 13.4c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5S9.17 14 10 14s1.5.67 1.5 1.5zm4.46 4.5H4v-8.6h3.02l.59-.65.15-.16 1.5 1.5A3.486 3.486 0 006.5 15.5c0 1.93 1.57 3.5 3.5 3.5 1.68 0 3.07-1.18 3.42-2.76l2.55 2.55-.01 1.21z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoFood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 21h15.01v.98c0 .56-.45 1.01-1.01 1.01H2.01c-.56 0-1.01-.45-1.01-1.01V21zm19.49 2.31L16 18.83V19H1v-2h13.17l-2-2H1c0-3.24 2.46-5.17 5.38-5.79l-5.7-5.7L2.1 2.1 13 13l2 2 6.9 6.9-1.41 1.41zM10.17 13l-2-2c-1.42.06-3.52.56-4.55 2h6.55zM23 5h-5V1h-2v4h-5l.23 2h9.56l-1 9.97 1.83 1.83L23 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoMeetingRoom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5v3.88l2 2V6h3v7.88l2 2V4h-5V3H6.12l2 2zM2.41 2.13L1 3.54l4 4V19H3v2h11v-4.46L20.46 23l1.41-1.41L2.41 2.13zM12 19H7V9.54l5 5V19z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoPhotography(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.9 6.07L7.48 4.66 9 3h6l1.83 2H20c1.1 0 2 .9 2 2v12c0 .05-.01.1-.02.16L20 17.17V7h-4.05l-1.83-2H9.88L8.9 6.07zm11.59 17.24L18.17 21H4c-1.1 0-2-.9-2-2V7c0-.59.27-1.12.68-1.49l-2-2L2.1 2.1l19.8 19.8-1.41 1.41zM9.19 12.02c-.11.31-.19.63-.19.98 0 1.66 1.34 3 3 3 .35 0 .67-.08.98-.19l-3.79-3.79zM16.17 19l-1.68-1.68c-.73.43-1.58.68-2.49.68-2.76 0-5-2.24-5-5 0-.91.25-1.76.68-2.49L4.17 7H4v12h12.17zm-1.36-7.02l2.07 2.07c.08-.34.12-.69.12-1.05 0-2.76-2.24-5-5-5-.36 0-.71.04-1.06.12l2.07 2.07c.84.3 1.5.96 1.8 1.79z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoStroller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm7-11.34v3.51l2 2v-7.9c.58-.68.97-1.27 1.65-1.27.77 0 1.35.66 1.35 1.48V7h2v-.52C22 4.56 20.52 3 18.65 3c-1.66 0-2.54 1.27-3.18 2.03l-3.5 4.11 1.42 1.42L15 8.66zm4.78 13.95l-1.91-1.91c-.29.76-1.01 1.3-1.87 1.3-1.1 0-2-.9-2-2 0-.86.54-1.58 1.3-1.87L14.17 17H7.43c-.85 0-1.31-1-.76-1.65l2.69-3.16-7.97-7.97L2.8 2.81l7.86 7.86 1.42 1.42 9.11 9.11-1.41 1.41zM12.17 15l-1.39-1.39L9.6 15h2.57zM10 5c.29 0 .58.02.86.05L9.49 6.67l1.42 1.42L14.3 4.1C13.03 3.4 11.56 3 10 3c-1.23 0-2.4.25-3.47.7L8.1 5.27A7.09 7.09 0 0110 5z"
                }
            }
        ]
    })(props);
}
function MdOutlineOtherHouses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L1 11.4l1.21 1.59L4 11.62V21h16v-9.38l1.79 1.36L23 11.4 12 3zm6 16H6v-8.9l6-4.58 6 4.58V19zm-9-5c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm3-1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3 1c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8l-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36s.78-.13 1.15-.36c.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.55 0 .78-.13 1.15-.36.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1zm12 8.5h-.02.02zm-16.65-1c.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.06.63 2.16.64v-2c-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.6.36-1.15.36s-.78-.14-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.18.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.2-.64.37-.23.6-.36 1.15-.36zM18.67 18c-1.11 0-1.73.37-2.18.64-.37.23-.6.36-1.15.36-.55 0-.78-.14-1.15-.36-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36s-.78-.13-1.15-.36c-.45-.27-1.07-.64-2.18-.64s-1.73.37-2.19.64c-.37.23-.59.36-1.15.36v2c1.11 0 1.73-.37 2.19-.64.37-.23.6-.36 1.15-.36.55 0 .78.13 1.15.36.45.27 1.07.64 2.18.64s1.73-.37 2.19-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64s1.72-.37 2.18-.64c.37-.23.59-.36 1.15-.36.55 0 .78.14 1.15.36.45.27 1.07.64 2.18.64v-2c-.56 0-.78-.13-1.15-.36-.45-.27-1.07-.64-2.18-.64z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "5.5",
                    "r": "2.5"
                }
            }
        ]
    })(props);
}
function MdOutlineRiceBowl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.66 14c-.66 1.92-2.24 3.54-4.4 4.39l-1.26.49V20h-4v-1.12l-1.27-.5c-2.16-.85-3.74-2.47-4.4-4.39h15.33M12 2C6.48 2 2 6.48 2 12c0 3.69 2.47 6.86 6 8.25V22h8v-1.75c3.53-1.39 6-4.56 6-8.25 0-5.52-4.48-10-10-10zm-2 10V4.26c.64-.16 1.31-.26 2-.26s1.36.1 2 .26V12h-4zm6 0V5.08c2.39 1.39 4 3.96 4 6.92h-4zM4 12c0-2.95 1.61-5.53 4-6.92V12H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoofing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 18h-2v-2h2v2zm2-4H9v6h6v-6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoomPreferences(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.69 16.37l1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L19 12h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L17 22h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM18 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1-15v6h-2V6h-2v6h-2V5H7v14h5v2H3v-2h2V3h10v1h4zm-7 9h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineRoomService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.98 17H2v2h20v-2zM21 16c-.27-4.07-3.25-7.4-7.16-8.21A2.006 2.006 0 0012 5a2.006 2.006 0 00-1.84 2.79C6.25 8.6 3.27 11.93 3 16h18zm-9-6.42c2.95 0 5.47 1.83 6.5 4.41h-13A7.002 7.002 0 0112 9.58z"
                }
            }
        ]
    })(props);
}
function MdOutlineRvHookup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmokeFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.5 13H22v3h-1.5zM18 13h1.5v3H18zm-1 0h-2.34L17 15.34zm-2.5-4.35h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 000 6.7zm4.35-3.92c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.76c0-2.22-1.28-4.14-3.15-5.03zM3.41 4.59L2 6l7 7H2v3h10l7 7 1.41-1.41z"
                }
            }
        ]
    })(props);
}
function MdOutlineSmokingRooms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16h1.5v3H18zM2 16h15v3H2zm14.03-5.8H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5a3.35 3.35 0 000 6.7h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16zM20.5 16H22v3h-1.5zm-1.65-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 6c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75m0-1.5C13.01 4.5 12 5.51 12 6.75S13.01 9 14.25 9s2.25-1.01 2.25-2.25-1.01-2.25-2.25-2.25zm5.75 1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5M20 4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-3.5-3c-.83 0-1.5.67-1.5 1.5S15.67 4 16.5 4 18 3.33 18 2.5 17.33 1 16.5 1zm4.25 15a1.25 1.25 0 000-2.5H12v-1h6.75c.69 0 1.25-.56 1.25-1.25 0-.67-.53-1.2-1.18-1.24L8.87 10l1.48-2.6c.09-.17.14-.34.14-.54 0-.26-.09-.5-.26-.7L9.12 5l-7.18 6.8c-.6.56-.94 1.35-.94 2.17V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75zM10 21H4c-.55 0-1-.45-1-1v-6c0-.39.23-.64.36-.75L7 9.87V12h3v9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63a12.188 12.188 0 00-3.55 7.63c1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-3.44-4.44c.63 1.03 1.07 2.18 1.3 3.38-.47.3-.91.63-1.34.98-.42-.34-.87-.67-1.33-.97.25-1.2.71-2.35 1.37-3.39zM12 15.45a12.11 12.11 0 00-3.06-3.2c-.13-.09-.27-.16-.4-.26.13.09.27.17.39.25A11.777 11.777 0 002 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45zm1.32 4.15c-.44.15-.88.27-1.33.37-.44-.09-.87-.21-1.28-.36-3.29-1.18-5.7-3.99-6.45-7.35 1.1.26 2.15.71 3.12 1.33l-.02.01c.13.09.26.18.39.25l.07.04c.99.72 1.84 1.61 2.51 2.65L12 19.1l1.67-2.55a10.19 10.19 0 012.53-2.66l.07-.05c.09-.05.18-.11.27-.17l-.01-.02c.98-.65 2.07-1.13 3.21-1.4-.75 3.37-3.15 6.18-6.42 7.35zm-4.33-7.32c-.02-.01-.04-.03-.05-.04 0 0 .01 0 .01.01.01.01.02.02.04.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 19H8v-6.63c1.26-.34 2.11-1.27 2.77-1.99C11.6 9.47 12.08 9 13 9h2v10zM10 2.02c-1.89 0-3.51 1.11-4.27 2.71C4.15 5.26 3 6.74 3 8.5c0 1.86 1.28 3.41 3 3.86V21h11v-2h2c1.1 0 2-.9 2-2v-6c0-1.1-.9-2-2-2h-1.56c.35-.59.56-1.27.56-2 0-2.21-1.79-4-4-4-.34 0-.66.05-.98.13A4.707 4.707 0 0010 2.02zM7 10.5c-1.1 0-2-.9-2-2 0-.85.55-1.6 1.37-1.88l.8-.27.36-.76C8 4.62 8.94 4.02 10 4.02c.79 0 1.39.35 1.74.65l.78.65S13.16 5 13.99 5c1.1 0 2 .9 2 2h-3C9.67 7 9.15 10.5 7 10.5zM17 17v-6h2v6h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineStairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 3h-4.42v3.33H11v3.33H8.42V16H6v2h4.42v-3.33H13v-3.33h2.58V8H18V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineStorefront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.9 8.89l-1.05-4.37c-.22-.9-1-1.52-1.91-1.52H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zm-2.99-3.9l1.05 4.37c.1.42.01.84-.25 1.17-.14.18-.44.47-.94.47-.61 0-1.14-.49-1.21-1.14L16.98 5l1.93-.01zM13 5h1.96l.54 4.52c.05.39-.07.78-.33 1.07-.22.26-.54.41-.95.41-.67 0-1.22-.59-1.22-1.31V5zM8.49 9.52L9.04 5H11v4.69c0 .72-.55 1.31-1.29 1.31-.34 0-.65-.15-.89-.41a1.42 1.42 0 01-.33-1.07zm-4.45-.16L5.05 5h1.97l-.58 4.86c-.08.65-.6 1.14-1.21 1.14-.49 0-.8-.29-.93-.47-.27-.32-.36-.75-.26-1.17zM5 19v-6.03c.08.01.15.03.23.03.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.08 0 .15-.02.23-.03V19H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineStroller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 20c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM6 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm9-9.34L9.6 15H15V8.66M18.65 3C20.52 3 22 4.56 22 6.48V7h-2v-.52C20 5.66 19.42 5 18.65 5c-.68 0-1.07.59-1.65 1.27V15c0 1.1-.9 2-2 2H7.43c-.85 0-1.31-1-.76-1.65l8.8-10.32C16.11 4.27 16.99 3 18.65 3zM10 5c-.65 0-1.29.09-1.91.27l1.4 1.4 1.37-1.61A6.11 6.11 0 0010 5m0-2c1.56 0 3.03.4 4.3 1.1L9.6 9.61 4.72 4.72A8.962 8.962 0 0110 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTapas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 10V1h-8v9c0 1.86 1.28 3.41 3 3.86V21h-2v2h6v-2h-2v-7.14c1.72-.45 3-2 3-3.86zm-2-7v3h-4V3h4zm-4 7V8h4v2c0 1.1-.9 2-2 2s-2-.9-2-2zm-6-1H8V8h2a2.5 2.5 0 000-5H8V1H6v2H4a2.5 2.5 0 000 5h2v1H4a2.5 2.5 0 000 5h2v9h2v-9h2a2.5 2.5 0 000-5zM4 6c-.28 0-.5-.22-.5-.5S3.72 5 4 5h6c.28 0 .5.22.5.5s-.22.5-.5.5H4zm6 6H4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h6c.28 0 .5.22.5.5s-.22.5-.5.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineTty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 6h-2V4h2v2zm2 1h-2v2h2V7zm1 2h2V7h-2v2zm0-5h-2v2h2V4zm-4 3h-2v2h2V7zm4 3h-2v2h2v-2zm-3 0h-2v2h2v-2zm-3-6h-2v2h2V4zm7 11.82v4.15c0 .56-.47 1.03-1.03 1-2.89-.17-5.6-1.03-7.97-2.4A17.999 17.999 0 014.43 12a17.89 17.89 0 01-2.4-7.97C2 3.47 2.47 3 3.03 3h4.15c.48 0 .89.34.98.8l.74 3.68a.99.99 0 01-.27.9L6.1 10.9c1.43 2.5 3.5 4.57 6 6l2.52-2.52a.98.98 0 01.9-.27l3.67.73c.47.09.81.5.81.98zM5.18 8.99l1.65-1.65L6.36 5H4.13c.17 1.37.53 2.71 1.05 3.99zM18 16.64l-2.34-.47-1.65 1.65c1.28.52 2.63.87 3.99 1.05v-2.23zM20 4v2h2V4h-2zm0 8h2v-2h-2v2zm-7-2h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 6.92L13 5.77V3.4c0-.26.22-.48.5-.48s.5.21.5.48V4h2v-.6C16 2.07 14.88 1 13.5 1S11 2.07 11 3.4v2.37L9.5 6.92 6 6.07l5.05 15.25c.15.45.55.68.95.68s.8-.23.95-.69L18 6.07l-3.5.85zM13.28 8.5l.76.58.92-.23L13 14.8V8.29l.28.21zm-3.32.59l.76-.58.28-.22v6.51L9.03 8.86l.93.23z"
                }
            }
        ]
    })(props);
}
function MdOutlineVapeFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zM16.17 19H8v-3h5.17L1.39 4.22 2.8 2.81l18.38 18.38-1.41 1.41-3.6-3.6zm2.66-3H22v3h-.17l-3-3zM11 17.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zM11.15 8.32V8.3c0-1.85 1.5-3.35 3.35-3.35v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05h-1.55l-3.33-3.33z"
                }
            }
        ]
    })(props);
}
function MdOutlineVapingRooms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 16.5h1c1.33 0 2.71-.18 4-.5v3c-1.29-.32-2.67-.5-4-.5H2v-2zm20-.5v3H8v-3h14zm-11 1.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5.22.5.5.5.5-.22.5-.5zm11-4.74V15h-1.5v-2.23c0-2.24-1.76-4.07-4-4.07V7.2c1.02 0 1.85-.83 1.85-1.85S17.52 3.5 16.5 3.5V2c1.85 0 3.35 1.5 3.35 3.35 0 .93-.38 1.77-1 2.38 1.87.89 3.15 2.81 3.15 5.03zm-2.5.6V15H18v-1.3c0-1.31-.92-2.05-1.97-2.05H14.5a3.35 3.35 0 010-6.7v1.5c-1.02 0-1.85.73-1.85 1.75s.83 2 1.85 2h1.53c1.87 0 3.47 1.35 3.47 3.16z"
                }
            }
        ]
    })(props);
}
function MdOutlineVilla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 10c-1.1 0-2 .9-2 2h-1V3L3 8v13h18v-9c0-1.1-.9-2-2-2zM5 9.37l9-3.46V12H9v7H5V9.37zM19 19h-3v-3h-2v3h-3v-5h8v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.75 16a1.25 1.25 0 000-2.5H12v-1h6.75c.69 0 1.25-.56 1.25-1.25 0-.67-.53-1.2-1.18-1.24L8.87 10l1.48-2.6c.09-.17.14-.34.14-.54 0-.26-.09-.5-.26-.7L9.12 5l-7.18 6.8c-.6.56-.94 1.35-.94 2.17V20c0 1.66 1.34 3 3 3h13.75a1.25 1.25 0 000-2.5H12v-1h7.75a1.25 1.25 0 000-2.5H12v-1h8.75zM10 21H4c-.55 0-1-.45-1-1v-6c0-.39.23-.64.36-.75L7 9.87V12h3v9zm3.5-12c.83 0 1.5-.67 1.5-1.5 0-.84-1.5-2.5-1.5-2.5S12 6.66 12 7.5c0 .83.67 1.5 1.5 1.5zm5-8S16 3.83 16 5.5a2.5 2.5 0 005 0C21 3.83 18.5 1 18.5 1zm0 5.5c-.55 0-1-.45-1-1 0-.4.43-1.22 1-2.05.57.83 1 1.65 1 2.05 0 .55-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineWaterDamage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L2 12h3v8h14v-8h3L12 3zM7 18v-7.81l5-4.5 5 4.5V18H7zm7-4c0 1.1-.9 2-2 2s-2-.9-2-2 2-4 2-4 2 2.9 2 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineWheelchairPickup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.5 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm5.5 6.95V9c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v6h2v7h3.5v-.11c-1.24-1.26-2-2.99-2-4.89 0-2.58 1.41-4.84 3.5-6.05zM16.5 17c0 1.65-1.35 3-3 3s-3-1.35-3-3c0-1.11.61-2.06 1.5-2.58v-2.16c-2.02.64-3.5 2.51-3.5 4.74 0 2.76 2.24 5 5 5s5-2.24 5-5h-2zm3.04-3H15V8h-2v8h5.46l2.47 3.71 1.66-1.11-3.05-4.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineBathroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 14c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm4 1c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3-7.5c-1.76 0-3.22 1.31-3.46 3h6.93a3.52 3.52 0 00-3.47-3M12 6c2.76 0 5 2.24 5 5v1H7v-1c0-2.76 2.24-5 5-5zM9 18c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm3 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm5-14H4v16h16V4m0-2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16z"
                }
            }
        ]
    })(props);
}
function MdOutlineBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM14 7h4c.55 0 1 .45 1 1v2h-6V8c0-.55.45-1 1-1zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8zm-1 7v-2c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v2H4z"
                }
            }
        ]
    })(props);
}
function MdOutlineBedroomBaby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.94 14.04c-.34.34-.71.64-1.1.92L16 13.5V11h1v-1h-5.62L9.65 7H6l1 .76L5.5 9.5l.95 1L8 9.51v3.99l-.84 1.46c-.39-.27-.76-.58-1.1-.92L5 15.1c1.87 1.87 4.36 2.9 7 2.9s5.13-1.03 7-2.9l-1.06-1.06zm-9.49 1.67l.03-.06.81-1.41c1.74.65 3.66.65 5.4 0l.81 1.41.03.06c-1.1.51-2.3.79-3.55.79s-2.43-.27-3.53-.79zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBedroomChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-3.5 8.67V9c0-1.1-.9-2-2-2h-5c-1.1 0-2 .9-2 2v1.67c-.88.35-1.5 1.2-1.5 2.2V17h1.5v-1.5h9V17H18v-4.13c0-1-.62-1.85-1.5-2.2zM15 8.5v2H9v-2h6zm-7.5 4.37c0-.48.39-.87.87-.87h7.27c.48 0 .87.39.87.87V14h-9v-1.13H7.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineBedroomParent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.35 11.45V9c0-1.1-.9-2-2-2H13c-.37 0-.72.12-1 .32-.28-.2-.63-.32-1-.32H7.65c-1.1 0-2 .9-2 2v2.45c-.4.46-.65 1.06-.65 1.72V17h1.5v-1.5h11V17H19v-3.83c0-.66-.25-1.26-.65-1.72zm-1.6-.95h-4v-2h4v2zm-9.5-2h4v2h-4v-2zM17.5 14h-11v-1c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v1zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.13 15.13L18 3h-4V2h-4v1H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h2.23l.64 4.13C6.74 16.05 6 17.43 6 19v1c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-1c0-1.57-.74-2.95-1.87-3.87zM5 9V5h1.31l.62 4H5zm10.67-4l-1.38 9H9.72L8.33 5h7.34zM16 20H8v-1c0-1.65 1.35-3 3-3h2c1.65 0 3 1.35 3 3v1z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "18",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraIndoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 13v-1c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L14 13zm-2-7.5l6 4.5v9H6v-9l6-4.5M12 3L4 9v12h16V9l-8-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineCameraOutdoor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1l2 1.06v-4.12L18 14v-1zM12 3L4 9v12h16v-2H6v-9l6-4.5 6 4.5v1h2V9l-8-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineChairAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h1v2H7c-1.1 0-2 .9-2 2v7h2v-3h10v3h2v-7c0-1.1-.9-2-2-2h-1v-2h1zM7 8V5h10v3H7zm10 8H7v-2h10v2zm-3-4h-4v-2h4v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineChair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 8V6c0-1.65-1.35-3-3-3H7C5.35 3 4 4.35 4 6v2c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1h12v1c0 .55.45 1 1 1s1-.45 1-1v-1c1.65 0 3-1.35 3-3v-5c0-1.65-1.35-3-3-3zM6 6c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2H7v-2c0-.88-.39-1.67-1-2.22V6zm15 10c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v4h14v-4c0-.55.45-1 1-1s1 .45 1 1v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCoffeeMaker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 6V4h2V2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14v-2h-4.03A4.966 4.966 0 0018 16v-5H8v5c0 1.64.81 3.09 2.03 4H6V4h2v2c0 .55.45 1 1 1h8c.55 0 1-.45 1-1zm-8 10v-3h6v3c0 1.65-1.35 3-3 3s-3-1.35-3-3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 3H6c-1.1 0-2 .9-2 2v5.71c0 3.83 2.95 7.18 6.78 7.29 3.96.12 7.22-3.06 7.22-7v-1h.5c1.93 0 3.5-1.57 3.5-3.5S20.43 3 18.5 3zM16 5v3H6V5h10zm0 5v1c0 2.76-2.24 5-5 5s-5-2.24-5-5v-1m12.5-2H18V5h.5c.83 0 1.5.67 1.5 1.5S19.33 8 18.5 8zM4 19h16v2H4v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDining(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.75 6c-1.37 0-2.5 1.52-2.5 3.4 0 1.48.7 2.71 1.67 3.18l.08.04V19h1.5v-6.38l.08-.03c.97-.47 1.67-1.7 1.67-3.18 0-1.88-1.12-3.41-2.5-3.41M10.5 6c-.27 0-.5.22-.5.5V9h-.75V6.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V9H7.5V6.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v3.8c0 .93.64 1.71 1.5 1.93V19h1.5v-6.77c.86-.22 1.5-1 1.5-1.93V6.5c0-.28-.22-.5-.5-.5zM20 4H4v16h16V4m0-2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h16z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoorBack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 11h2v2H9z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoorFront(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 19V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v14H3v2h18v-2h-2zm-2 0H7V5h10v14zm-4-8h2v2h-2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoorSliding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 13H8v-2h2v2zm6-2h-2v2h2v-2zm5 8v2H3v-2h1V5c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v14h1zM11 5H6v14h5V5zm7 0h-5v14h5V5z"
                }
            }
        ]
    })(props);
}
function MdOutlineDoorbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 16.5h2c0 .55-.45 1-1 1s-1-.45-1-1zm4-1.5v-2.34c0-1.54-.81-2.82-2.25-3.16v-.25c0-.41-.34-.75-.75-.75s-.75.34-.75.75v.25C9.82 9.84 9 11.12 9 12.66V15H8v1h8v-1h-1zm-3-9.5L6 10v9h12v-9l-6-4.5M12 3l8 6v12H4V9l8-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineFeed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8l-5-5zm3 16H5V5h10v4h4v10zM7 17h10v-2H7v2zm5-10H7v2h5V7zm-5 6h10v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlatware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 7.08c0 1.77-.84 3.25-2 3.82V21h-2V10.9c-1.16-.57-2-2.05-2-3.82C10.01 4.83 11.35 3 13 3c1.66 0 3 1.83 3 4.08zM17 3v18h2v-8h2V7c0-1.76-1.24-4-4-4zM8.28 3c-.4 0-.72.32-.72.72V7h-.84V3.72C6.72 3.32 6.4 3 6 3s-.72.32-.72.72V7h-.84V3.72c0-.4-.32-.72-.72-.72S3 3.32 3 3.72V9c0 1.1.9 2 2 2v10h2V11c1.1 0 2-.9 2-2V3.72c0-.4-.32-.72-.72-.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineGarage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.78 18.5h.44c.43 0 .78-.36.78-.81V16.5h10v1.19c0 .45.34.81.78.81h.44c.43 0 .78-.36.78-.81v-6.5c-.82-2.46-1.34-4.03-1.56-4.69-.05-.16-.12-.29-.19-.4-.02-.02-.03-.04-.05-.07-.38-.52-.92-.53-.92-.53H7.72s-.54.01-.92.54c-.02.02-.03.04-.05.06-.07.11-.14.24-.19.4-.22.66-.74 2.22-1.56 4.69v6.5c0 .45.35.81.78.81zm2.55-11h7.34l.23.69.43 1.31H7.67l.66-2zM7 11.51v-.01h10v3H7v-2.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineLight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 6.06V3h-2v3.06c-4.5.5-8 4.31-8 8.93C3 16.1 3.9 17 5.01 17H8c0 2.21 1.79 4 4 4s4-1.79 4-4h2.99c1.11 0 2.01-.9 2.01-2.01 0-4.62-3.5-8.43-8-8.93zM12 19c-1.1 0-2-.9-2-2h4c0 1.1-.9 2-2 2zm0-4H5c0-3.86 3.14-7 7-7s7 3.14 7 7h-7z"
                }
            }
        ]
    })(props);
}
function MdOutlineLiving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.75 10.35V9c0-1.66-1.34-3-3-3h-5.5c-1.66 0-3 1.34-3 3v1.35C5.51 10.78 5 11.58 5 12.5V16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-3.5c0-.92-.51-1.72-1.25-2.15zM9.25 7.5h5.5c.83 0 1.5.67 1.5 1.5v1.03A2.48 2.48 0 0014 12.5v.5h-4v-.5c0-1.3-.99-2.35-2.25-2.47V9c0-.83.67-1.5 1.5-1.5zM17.5 16c0 .28-.22.5-.5.5H7c-.28 0-.5-.22-.5-.5v-3.5c0-.55.45-1 1-1s1 .45 1 1v2h7v-2c0-.55.45-1 1-1s1 .45 1 1V16zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineManageSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9H2V7h5v2zm0 3H2v2h5v-2zm13.59 7l-3.83-3.83c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L22 17.59 20.59 19zM17 11c0-1.65-1.35-3-3-3s-3 1.35-3 3 1.35 3 3 3 3-1.35 3-3zM2 19h10v-2H2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePodcasts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 12c0 .74-.4 1.38-1 1.72V22h-2v-8.28c-.6-.35-1-.98-1-1.72 0-1.1.9-2 2-2s2 .9 2 2zm-2-6c-3.31 0-6 2.69-6 6 0 1.74.75 3.31 1.94 4.4l1.42-1.42A3.957 3.957 0 018 12c0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.19-.53 2.25-1.36 2.98l1.42 1.42A5.957 5.957 0 0018 12c0-3.31-2.69-6-6-6zm0-4C6.48 2 2 6.48 2 12c0 2.85 1.2 5.41 3.11 7.24l1.42-1.42A7.987 7.987 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 2.29-.98 4.36-2.53 5.82l1.42 1.42C20.8 17.41 22 14.85 22 12c0-5.52-4.48-10-10-10z"
                }
            }
        ]
    })(props);
}
function MdOutlineShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm3-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3-4v2H5v-2c0-3.53 2.61-6.43 6-6.92V3h2v2.08c3.39.49 6 3.39 6 6.92zm-2 0c0-2.76-2.24-5-5-5s-5 2.24-5 5h10zm-9 7c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineTableBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.5C22 5.57 17.52 4 12 4S2 5.57 2 7.5c0 1.81 3.95 3.31 9 3.48V15H9.35c-.82 0-1.55.5-1.86 1.26L6 20h2l1.2-3h5.6l1.2 3h2l-1.5-3.74c-.3-.76-1.04-1.26-1.85-1.26H13v-4.02c5.05-.17 9-1.67 9-3.48zM12 6c4.05 0 6.74.86 7.72 1.5C18.74 8.14 16.05 9 12 9s-6.74-.86-7.72-1.5C5.26 6.86 7.95 6 12 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineTableRestaurant(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 9.73l-1.43-5a.996.996 0 00-.96-.73H4.43c-.45 0-.84.3-.96.73l-1.43 5c-.18.63.3 1.27.96 1.27h2.2L4 20h2l.67-5h10.67l.66 5h2l-1.2-9H21c.66 0 1.14-.64.96-1.27zM6.93 13l.27-2h9.6l.27 2H6.93zm-2.6-4l.86-3h13.63l.86 3H4.33z"
                }
            }
        ]
    })(props);
}
function MdOutlineWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 8h-6V5h6v6zm-8-6v6H5V5h6zm-6 8h6v6H5v-6zm8 6v-6h6v6h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlineYard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 13c-3.31 0-6 2.69-6 6 3.31 0 6-2.69 6-6zM6 13c0 3.31 2.69 6 6 6 0-3.31-2.69-6-6-6zm2-1.97a1.562 1.562 0 002.45 1.28l-.01.12c0 .86.7 1.56 1.56 1.56s1.56-.7 1.56-1.56l-.01-.12c.25.17.56.28.89.28.86 0 1.56-.7 1.56-1.56 0-.62-.37-1.16-.89-1.41.52-.24.89-.78.89-1.4a1.562 1.562 0 00-2.45-1.28l.01-.12c0-.86-.7-1.56-1.56-1.56s-1.56.7-1.56 1.56l.01.12A1.562 1.562 0 008 8.22c0 .62.37 1.16.89 1.41-.52.24-.89.78-.89 1.4zm4-2.97c.86 0 1.56.7 1.56 1.56s-.7 1.56-1.56 1.56-1.56-.7-1.56-1.56.7-1.56 1.56-1.56zM20 4v16H4V4h16m0-2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutline18UpRating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 15H10V9H7v1.5h1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 15H15c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1h-2.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.5-5h1.5v1.5H13V10zm0 2.5h1.5V14H13v-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutline6FtApart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 9.43V10h8v-.57zM18 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 9.43V10h8v-.57zM19 17v-2.01L5 15v2l-3-3 3-3v2.01L19 13v-2l3 3-3 3zm-9 2v-1H7.5c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h2c.28 0 .5-.22.5-.5V20c0-.28-.22-.5-.5-.5H8V19h2zm-1 1.5v.5H8v-.5h1zm8.5-1.5h-1v3h-1v-3h-1v-1h3v1zm-5 0v.5h1v1h-1V22h-1v-4H14v1h-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddModerator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11.09v-4.7l6-2.25 6 2.25v3.69c.71.1 1.38.31 2 .6V5l-8-3-8 3v6.09c0 5.05 3.41 9.76 8 10.91.03-.01.05-.02.08-.02-.79-.78-1.4-1.76-1.75-2.84C7.76 17.53 6 14.42 6 11.09z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm3 5.5h-2.5V20h-1v-2.5H14v-1h2.5V14h1v2.5H20v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAddReaction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 9.5C7 8.67 7.67 8 8.5 8s1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5zm5 8c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5zm3.5-6.5c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zM22 1h-2v2h-2v2h2v2h2V5h2V3h-2V1zm-2 11c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.46 0 2.82.4 4 1.08V2.84A9.929 9.929 0 0011.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12c0-1.05-.17-2.05-.47-3H19.4c.38.93.6 1.94.6 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineArchitecture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.36 18.78L6.61 21l1.62-1.54 2.77-7.6c-.68-.17-1.28-.51-1.77-.98l-2.87 7.9zM14.77 10.88c-.49.47-1.1.81-1.77.98l2.77 7.6L17.39 21l.26-2.22-2.88-7.9zM15 8c0-1.3-.84-2.4-2-2.82V3h-2v2.18C9.84 5.6 9 6.7 9 8c0 1.66 1.34 3 3 3s3-1.34 3-3zm-3 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineAssistWalker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12.5",
                    "cy": "4.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.77 17.72l-.64-6.37A1.49 1.49 0 0017.64 10H16c-1.5-.02-2.86-.54-3.76-1.44l-2-1.98A1.95 1.95 0 008.83 6c-.51 0-1.02.2-1.41.59L4.08 9.91c-.53.68-.51 1.57-.21 2.13l1.43 2.8-3.15 4.05 1.57 1.24L7.4 15.4l-.17-1.36.77.71V20h2v-6.12l-2.12-2.12 2.36-2.36c.94.94 1.72 1.82 3.59 2.32L13 20h1.5l.41-3.5h3.18l.14 1.22c-.44.26-.73.74-.73 1.28 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.54-.29-1.02-.73-1.28zM15.09 15l.41-3.5h2l.41 3.5h-2.82z"
                }
            }
        ]
    })(props);
}
function MdOutlineBackHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 7a2.5 2.5 0 00-3-2.45V4a2.5 2.5 0 00-3.17-2.41A2.509 2.509 0 0012.5 0c-1.23 0-2.25.89-2.46 2.06A2.5 2.5 0 007 4.5v5.89c-.34-.31-.76-.54-1.22-.66l-.77-.21c-.83-.23-1.7.09-2.19.83-.38.57-.4 1.31-.15 1.95l2.56 6.43A8.354 8.354 0 0013 24c4.42 0 8-3.58 8-8V7zm-2 9c0 3.31-2.69 6-6 6-2.61 0-4.95-1.59-5.91-4.01l-2.6-6.54.53.14c.46.12.83.46 1 .9L7 15h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V12h2V4c0-.28.22-.5.5-.5s.5.22.5.5v8h2V7c0-.28.22-.5.5-.5s.5.22.5.5v9z"
                }
            }
        ]
    })(props);
}
function MdOutlineBlind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11.5",
                    "cy": "3.5",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.13 7.12c-.17-.35-.44-.65-.8-.85a1.98 1.98 0 00-1.93-.03v-.01L4 9.3V14h2v-3.54l1.5-.85C7.18 10.71 7 11.85 7 13v5.33L4.4 21.8 6 23l3-4 .22-3.54L11 18v5h2v-6.5l-1.97-2.81c-.04-.52-.14-1.76.45-3.4.75 1.14 1.88 1.98 3.2 2.41L20.63 23l.87-.5-5.48-9.5H17v-2c-.49 0-2.88.17-4.08-2.21"
                }
            }
        ]
    })(props);
}
function MdOutlineBoy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zM14 20v-5h1v-4.5c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2V15h1v5h4z"
                }
            }
        ]
    })(props);
}
function MdOutlineCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6a2 2 0 002-2c0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm6 3h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v9c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-9c0-1.66-1.34-3-3-3zm1 11H5v-3c.9-.01 1.76-.37 2.4-1.01l1.09-1.07 1.07 1.07c1.31 1.31 3.59 1.3 4.89 0l1.08-1.07 1.07 1.07c.64.64 1.5 1 2.4 1.01v3zm0-4.5c-.51-.01-.99-.2-1.35-.57l-2.13-2.13-2.14 2.13c-.74.74-2.03.74-2.77 0L8.48 12.8l-2.14 2.13c-.35.36-.83.56-1.34.57V12c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineCatchingPokemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.5 12a2.5 2.5 0 01-5 0 2.5 2.5 0 015 0zm7.5 0c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zm-2 0h-4c0-2.21-1.79-4-4-4s-4 1.79-4 4H4c0 4.41 3.59 8 8 8s8-3.59 8-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineCleanHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.99 5l.63 1.37 1.37.63-1.37.63L16.99 9l-.63-1.37L14.99 7l1.37-.63.63-1.37M20 14c1.1 0 2-.9 2-2s-2-4-2-4-2 2.9-2 4 .9 2 2 2zm-9-7.9V4h2c.57 0 1.1.17 1.55.45l1.43-1.43A4.899 4.899 0 0013 2H7.5v2H9v2.11c-1.78.37-3.2 1.68-3.75 3.39h2.16C7.94 8.61 8.89 8 10 8c1.62 0 2.94 1.29 2.99 2.9l2.01.75V11a5 5 0 00-4-4.9zM22 19v1l-8 2.5-7-1.94V22H1V11h7.97l6.16 2.3A2.89 2.89 0 0117 16h2c1.66 0 3 1.34 3 3zM5 20v-7H3v7h2zm14.9-1.43c-.16-.33-.51-.56-.9-.56h-5.35c-.54 0-1.07-.09-1.58-.26l-2.38-.79.63-1.9 2.38.79c.31.1 2.3.15 2.3.15 0-.37-.23-.7-.57-.83L8.61 13H7v5.48l6.97 1.93 5.93-1.84z"
                }
            }
        ]
    })(props);
}
function MdOutlineCo2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h-3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5h-2v-3h2v3zM8 13v1c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1H6.5v-.5h-2v3h2V13H8zm12.5 2.5h-2v1h3V18H17v-2.5c0-.55.45-1 1-1h2v-1h-3V12h3.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCompost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.87 11.81A2.5 2.5 0 0115 8h1c1.51 0 2-1 2-1s.55 6-3 6c-.49 0-.94-.14-1.32-.38-.24.64-.59 1.76-.76 2.96 1.26.22 2.28.89 2.77 1.77A6.505 6.505 0 0018.5 12h3c0 5.24-4.26 9.5-9.5 9.5S2.5 17.24 2.5 12 6.76 2.5 12 2.5V0l4 4-4 4V5.5c-3.58 0-6.5 2.92-6.5 6.5 0 2.21 1.11 4.17 2.81 5.35.51-.92 1.63-1.62 2.98-1.8-.09-.69-.26-1.42-.49-2.03-.35.3-.8.48-1.3.48-1.1 0-2-.9-2-2v-.99c0-.56-.19-1.09-.5-1.51 0 0 4.45-.23 4.5 2.5 0 .29-.06.56-.17.8-.42-.32-.86-.6-1.33-.8.58.43 1.37 1.37 2 2.6.67-1.62 1.68-3.27 3-4.6-.76.52-1.47 1.12-2.13 1.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineConnectWithoutContact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 14H9a9 9 0 019-9v2c-3.87 0-7 3.13-7 7zm7-3V9c-2.76 0-5 2.24-5 5h2c0-1.66 1.34-3 3-3zM7 4c0-1.11-.89-2-2-2s-2 .89-2 2 .89 2 2 2 2-.89 2-2zm4.45.5h-2A2.99 2.99 0 016.5 7h-3C2.67 7 2 7.67 2 8.5V11h6V8.74a4.97 4.97 0 003.45-4.24zM19 17c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm1.5 1h-3a2.99 2.99 0 01-2.95-2.5h-2A4.97 4.97 0 0016 19.74V22h6v-2.5c0-.83-.67-1.5-1.5-1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineConstruction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.783 15.172l2.121-2.121 5.996 5.996-2.121 2.121zM17.5 10c1.93 0 3.5-1.57 3.5-3.5 0-.58-.16-1.12-.41-1.6l-2.7 2.7-1.49-1.49 2.7-2.7c-.48-.25-1.02-.41-1.6-.41C15.57 3 14 4.57 14 6.5c0 .41.08.8.21 1.16l-1.85 1.85-1.78-1.78.71-.71-1.41-1.41L12 3.49a3 3 0 00-4.24 0L4.22 7.03l1.41 1.41H2.81l-.71.71 3.54 3.54.71-.71V9.15l1.41 1.41.71-.71 1.78 1.78-7.41 7.41 2.12 2.12L16.34 9.79c.36.13.75.21 1.16.21z"
                }
            }
        ]
    })(props);
}
function MdOutlineCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.5",
                    "cy": "8.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "13.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "15",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.95 10.99c-1.79-.03-3.7-1.95-2.68-4.22-2.97 1-5.78-1.59-5.19-4.56C7.11.74 2 6.41 2 12c0 5.52 4.48 10 10 10 5.89 0 10.54-5.08 9.95-11.01zM12 20c-4.41 0-8-3.59-8-8 0-3.31 2.73-8.18 8.08-8.02.42 2.54 2.44 4.56 4.99 4.94.07.36.52 2.55 2.92 3.63C19.7 16.86 16.06 20 12 20z"
                }
            }
        ]
    })(props);
}
function MdOutlineCoronavirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 12c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm4.25-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3.5 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM22 11.25v1.5c0 .41-.34.75-.75.75s-.75-.34-.75-.75h-1.54a6.978 6.978 0 01-1.52 3.65l1.09 1.09.01-.01c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-1.06 1.06c-.29.29-.77.29-1.06 0a.752.752 0 01-.01-1.05l-1.09-1.09a7.015 7.015 0 01-3.64 1.51v1.54h.01c.41 0 .75.34.75.75s-.34.75-.75.75h-1.5c-.41 0-.75-.34-.75-.75s.33-.74.74-.75v-1.55a6.948 6.948 0 01-3.63-1.51l-1.09 1.09.01.01c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0L4.4 18.54a.754.754 0 010-1.06c.29-.29.76-.29 1.05-.01l1.09-1.09a6.89 6.89 0 01-1.5-3.63H3.5c0 .41-.34.75-.75.75S2 13.16 2 12.75v-1.5c0-.41.34-.75.75-.75s.75.34.75.75h1.54c.15-1.37.69-2.61 1.5-3.63L5.45 6.53c-.29.28-.76.28-1.05-.01a.754.754 0 010-1.06L5.46 4.4c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.01.01L7.6 6.56a6.982 6.982 0 013.63-1.51V3.5a.753.753 0 01-.74-.75.77.77 0 01.76-.75h1.5c.41 0 .75.34.75.75s-.34.75-.75.75h-.01v1.54c1.37.14 2.62.69 3.64 1.51l1.09-1.09a.742.742 0 01.01-1.05c.29-.29.77-.29 1.06 0l1.06 1.06c.29.29.29.77 0 1.06s-.77.29-1.06 0l-.01-.01-1.09 1.08a7.025 7.025 0 011.52 3.65h1.54c0-.41.34-.75.75-.75s.75.34.75.75zM17 12c0-2.76-2.24-5-5-5s-5 2.24-5 5 2.24 5 5 5 5-2.24 5-5zm-5-1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3.5 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-1.75 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineCrueltyFree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 14c-.24-.24-.44-.49-.65-.75C17.51 11.5 19 8.56 19 5c0-1.95-.74-3-2-3-1.54 0-3.96 2.06-5 5.97C10.96 4.06 8.54 2 7 2 5.74 2 5 3.05 5 5c0 3.56 1.49 6.5 2.65 8.25-.21.26-.41.51-.65.75-.25.25-2 1.39-2 3.5C5 19.98 7.02 22 9.5 22c1.5 0 2.5-.5 2.5-.5s1 .5 2.5.5c2.48 0 4.5-2.02 4.5-4.5 0-2.11-1.75-3.25-2-3.5zm-.12-9.97c.06.17.12.48.12.97 0 2.84-1.11 5.24-2.07 6.78-.38-.26-.83-.48-1.4-.62.24-4.52 2.44-6.83 3.35-7.13zM7 5c0-.49.06-.8.12-.97.91.3 3.11 2.61 3.36 7.13-.58.14-1.03.35-1.4.62C8.11 10.24 7 7.84 7 5zm7.5 15c-1 0-1.8-.33-2.22-.56.42-.18.72-.71.72-.94 0-.28-.45-.5-1-.5s-1 .22-1 .5c0 .23.3.76.72.94-.42.23-1.22.56-2.22.56A2.5 2.5 0 017 17.5c0-.7.43-1.24 1-1.73.44-.36.61-.52 1.3-1.37.76-.95 1.09-1.4 2.7-1.4s1.94.45 2.7 1.4c.69.85.86 1.01 1.3 1.37.57.49 1 1.03 1 1.73a2.5 2.5 0 01-2.5 2.5zm-.5-4c0 .41-.22.75-.5.75s-.5-.34-.5-.75.22-.75.5-.75.5.34.5.75zm-3 0c0 .41-.22.75-.5.75s-.5-.34-.5-.75.22-.75.5-.75.5.34.5.75z"
                }
            }
        ]
    })(props);
}
function MdOutlineCyclone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 7.47V5.35C20.05 4.77 16.56 4 12 4c-2.15 0-4.11.86-5.54 2.24.13-.85.4-2.4 1.01-4.24H5.35C4.77 3.95 4 7.44 4 12c0 2.15.86 4.11 2.24 5.54-.85-.14-2.4-.4-4.24-1.01v2.12C3.95 19.23 7.44 20 12 20c2.15 0 4.11-.86 5.54-2.24-.14.85-.4 2.4-1.01 4.24h2.12c.58-1.95 1.35-5.44 1.35-10 0-2.15-.86-4.11-2.24-5.54.85.13 2.4.4 4.24 1.01zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineDeck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9L12 2 2 9h9v13h2V9h9zM12 4.44L15.66 7H8.34L12 4.44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4.14 12l-1.96.37.82 4.37V22h2l.02-4H7v4h2v-6H4.9zM19.1 16H15v6h2v-4h1.98l.02 4h2v-5.26l.82-4.37-1.96-.37z"
                }
            }
        ]
    })(props);
}
function MdOutlineDiversity1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1.22 17.58A2.01 2.01 0 000 19.43V21h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "20",
                    "cy": "14",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.78 17.58A6.95 6.95 0 0020 17c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V21H24v-1.57c0-.81-.48-1.53-1.22-1.85zM16.24 16.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 19.39V21h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 19a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.07zM9 12c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3zm4 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.48 10.86C2.17 10.1 2 9.36 2 8.6 2 6.02 4.02 4 6.6 4c2.68 0 3.82 1.74 5.4 3.59C13.57 5.76 14.7 4 17.4 4 19.98 4 22 6.02 22 8.6c0 .76-.17 1.5-.48 2.26.65.31 1.18.82 1.53 1.44.6-1.2.95-2.42.95-3.7C24 4.9 21.1 2 17.4 2c-2.09 0-4.09.97-5.4 2.51C10.69 2.97 8.69 2 6.6 2 2.9 2 0 4.9 0 8.6c0 1.28.35 2.5.96 3.7.35-.62.88-1.13 1.52-1.44z"
                }
            }
        ]
    })(props);
}
function MdOutlineDiversity2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.1 15.9l1.42-1.42C8.79 12.05 7 10.41 7 8.85 7 7.8 7.8 7 8.85 7c1.11 0 1.54.65 2.68 2h.93c1.12-1.31 1.53-2 2.68-2 .87 0 1.55.54 1.77 1.32.35-.04.68-.06 1-.06.36 0 .7.03 1.03.08C18.7 6.43 17.13 5 15.15 5c-.12 0-.23.03-.35.04.12-.33.2-.67.2-1.04 0-1.66-1.34-3-3-3S9 2.34 9 4c0 .37.08.71.2 1.04-.12-.01-.23-.04-.35-.04C6.69 5 5 6.69 5 8.85c0 2.42 2.04 4.31 5.1 7.05z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.5 16.24c-.32-.18-.66-.29-1-.35.07-.1.15-.18.21-.28 1.08-1.87.46-4.18-1.41-5.26-2.09-1.21-4.76-.39-8.65.9l.52 1.94c3.47-1.14 5.79-1.88 7.14-1.1.91.53 1.2 1.61.68 2.53-.56.96-1.33 1-3.07 1.32l-.47.81c.58 1.62.97 2.33.39 3.32-.53.91-1.61 1.2-2.53.68-.06-.03-.11-.09-.17-.13-.3.67-.64 1.24-1.03 1.73.07.04.13.09.2.14 1.87 1.08 4.18.46 5.26-1.41.06-.1.09-.21.14-.32.22.27.48.51.8.69 1.43.83 3.27.34 4.1-1.1s.32-3.29-1.11-4.11z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.32 14.01c-.74 3.58-1.27 5.95-2.62 6.73-.91.53-2 .24-2.53-.68-.56-.96-.2-1.66.39-3.32l-.46-.81c-1.7-.31-2.5-.33-3.07-1.32-.53-.91-.24-2 .68-2.53.09-.05.19-.08.29-.11-.35-.56-.64-1.17-.82-1.85-.16.07-.32.14-.48.23-1.87 1.08-2.49 3.39-1.41 5.26.06.1.14.18.21.28-.34.06-.68.17-1 .35-1.43.83-1.93 2.66-1.1 4.1s2.66 1.93 4.1 1.1c.32-.18.58-.42.8-.69.05.11.08.22.14.32 1.08 1.87 3.39 2.49 5.26 1.41 2.09-1.21 2.71-3.93 3.55-7.94l-1.93-.53z"
                }
            }
        ]
    })(props);
}
function MdOutlineDiversity3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6.32 13.01c.96.02 1.85.5 2.45 1.34A3.961 3.961 0 0012 16c1.29 0 2.5-.62 3.23-1.66.6-.84 1.49-1.32 2.45-1.34-.72-1.22-3.6-2-5.68-2-2.07 0-4.96.78-5.68 2.01zM4 13c1.66 0 3-1.34 3-3S5.66 7 4 7s-3 1.34-3 3 1.34 3 3 3zM20 13c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zM12 10c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 14h-3.27c-.77 0-1.35.45-1.68.92-.04.06-1.36 2.08-4.05 2.08-1.43 0-3.03-.64-4.05-2.08-.39-.55-1-.92-1.68-.92H3c-1.1 0-2 .9-2 2v4h7v-2.26c1.15.8 2.54 1.26 4 1.26s2.85-.46 4-1.26V20h7v-4c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDomainAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h14v-2h-4v-2h2v-2h-2v-2h2v-2h-2V9h8v6h2V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm14 12v2h-2v2h-2v-2h-2v-2h2v-2h2v2h2zm-6-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDomain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineDownhillSkiing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2.72 16.4l.76.27a5.933 5.933 0 004.34-.17L22 22.13c-1.05.55-2.24.87-3.5.87-.86 0-1.68-.14-2.45-.41L2 17.47l.5-1.41 6.9 2.51 1.72-4.44-3.57-3.73c-.89-.94-.67-2.47.45-3.12l3.48-2.01c1.1-.64 2.52-.1 2.91 1.11l.33 1.08a5.017 5.017 0 002.83 3.14l.52-1.6 1.43.46-1.12 3.45A7.029 7.029 0 0113 8.59l-2.53 1.45 3.03 3.46-2.22 5.76 3.09 1.12 2.1-6.44c.46.18.94.31 1.44.41l-2.13 6.55z"
                }
            }
        ]
    })(props);
}
function MdOutlineEditNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.58 6.25l1.77 1.77L14.37 13H12.6v-1.77l4.98-4.98zm3.27-.44l-1.06-1.06c-.2-.2-.51-.2-.71 0l-.85.85L20 7.37l.85-.85c.2-.2.2-.52 0-.71zM18 12.2V17h2v2H4v-2h2v-7c0-2.79 1.91-5.14 4.5-5.8v-.7c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.7c.82.21 1.57.59 2.21 1.09l-1.43 1.43A3.89 3.89 0 0012 6c-2.21 0-4 1.79-4 4v7h8v-2.8l2-2zM10 20h4c0 1.1-.9 2-2 2s-2-.9-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineElderlyWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 11c-1.56 0-2.92-.9-3.58-2.21l-.79-1.67C14.12 7.1 13.63 6 12.34 6 8.72 6 6 16.69 6 19h2.5l-2.1 2.8L8 23l3-4h2v4h2v-4.03L13 13l.49-2.71A6.02 6.02 0 0017 12.81v.69h1v-1c0-.28.22-.5.5-.5s.5.22.5.5V23h1V12.5c0-.83-.67-1.5-1.5-1.5zM11.6 2.91c-.06.19-.1.38-.1.59 0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2c-.21 0-.4.04-.59.1-.15-.35-.5-.6-.91-.6-.55 0-1 .45-1 1 0 .41.25.76.6.91z"
                }
            }
        ]
    })(props);
}
function MdOutlineElderly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6.5 7V23h-1V12.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v1h-1v-.69a6.02 6.02 0 01-3.51-2.52c-.31.87-.49 1.78-.49 2.71 0 .23.02.46.03.69L15 16.5V23h-2v-5l-1.78-2.54L11 19l-3 4-1.6-1.2L9 18.33V13c0-1.15.18-2.29.5-3.39l-1.5.85V14H6V9.3l5.4-3.07v.01a2 2 0 011.94.03c.36.21.63.51.8.85l.79 1.67A3.987 3.987 0 0018.5 11c.83 0 1.5.67 1.5 1.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiEmotions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 18c2.28 0 4.22-1.66 5-4H7c.78 2.34 2.72 4 5 4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiEvents(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm7 6c-1.65 0-3-1.35-3-3V5h6v6c0 1.65-1.35 3-3 3zm7-6c0 1.3-.84 2.4-2 2.82V7h2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiFlags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9l-1-2H7V5.72c.6-.34 1-.98 1-1.72 0-1.1-.9-2-2-2s-2 .9-2 2c0 .74.4 1.38 1 1.72V21h2v-4h5l1 2h7V9h-6zm4 8h-4l-1-2H7V9h5l1 2h5v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiFoodBeverage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 19h18v2H2zM20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm-4 10c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V5h3v1.4L7.19 7.85c-.12.09-.19.24-.19.39v4.26c0 .28.22.5.5.5h4c.28 0 .5-.22.5-.5V8.24c0-.15-.07-.3-.19-.39L10 6.4V5h6v8zM9.5 7.28l1.5 1.2V12H8V8.48l1.5-1.2zM20 8h-2V5h2v3z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiNature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.94 4.88A1.32 1.32 0 0020.68 4H19.6l-.31-.97C19.15 2.43 18.61 2 18 2s-1.15.43-1.29 1.04L16.4 4h-1.07c-.57 0-1.08.35-1.26.88-.19.56.04 1.17.56 1.48l.87.52-.4 1.24c-.23.58-.04 1.25.45 1.62.23.17.51.26.78.26.31 0 .61-.11.86-.32l.81-.7.81.7c.25.21.55.32.86.32.27 0 .55-.09.78-.26.5-.37.68-1.04.45-1.62l-.39-1.24.87-.52c.51-.31.74-.92.56-1.48zM18 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM13.49 10.51c-.43-.43-.94-.73-1.49-.93V8h-1v1.38c-.11-.01-.23-.03-.34-.03-1.02 0-2.05.39-2.83 1.17l-.5.5-1.33-.5a3.01 3.01 0 00-3.83 1.82c-.27.75-.23 1.57.12 2.29.23.48.58.87 1 1.16-.38 1.35-.06 2.85 1 3.91.78.78 1.8 1.17 2.83 1.17.37 0 .73-.07 1.09-.17.29.42.68.77 1.16 1 .41.2.84.3 1.28.3.34 0 .68-.06 1.01-.17a3.007 3.007 0 001.82-3.85l-.49-1.3.5-.5c.87-.87 1.24-2.04 1.14-3.17H16v-1h-1.59c-.19-.55-.49-1.06-.92-1.5zm-5.91 8.31c-.15.04-.3.06-.46.06-.53 0-1.04-.21-1.41-.59-.38-.38-.59-.88-.59-1.41 0-.16.03-.32.06-.47.14.01.28.03.42.03.85 0 1.68-.2 2.44-.48-.32.89-.54 1.87-.46 2.86zm-2.91-4.53c-.25-.09-.45-.27-.57-.51s-.13-.51-.04-.76c.19-.52.76-.79 1.26-.61l3.16 1.19c-1.15.6-2.63 1.11-3.81.69zm6.32 5.65c-.25.09-.52.08-.76-.04a.989.989 0 01-.51-.57c-.42-1.18.09-2.65.7-3.8l1.18 3.13c.18.52-.09 1.1-.61 1.28zm1.21-5.34l-.61-1.61c0-.01-.01-.02-.02-.03l-.06-.12a.673.673 0 00-.07-.11l-.09-.09-.09-.09c-.03-.03-.07-.05-.11-.07-.04-.02-.07-.05-.12-.06-.01 0-.02-.01-.03-.02l-1.6-.6a1.966 1.966 0 012.67.13c.73.73.77 1.88.13 2.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiObjects(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3c-.46 0-.93.04-1.4.14-2.76.53-4.96 2.76-5.48 5.52-.48 2.61.48 5.01 2.22 6.56.43.38.66.91.66 1.47V19c0 1.1.9 2 2 2h.28a1.98 1.98 0 003.44 0H14c1.1 0 2-.9 2-2v-2.31c0-.55.22-1.09.64-1.46A6.956 6.956 0 0019 10c0-3.87-3.13-7-7-7zm2 14h-4v-1h4v1zm-4 2v-1h4v1h-4zm5.31-5.26c-.09.08-.16.18-.24.26H8.92c-.08-.09-.15-.19-.24-.27-1.32-1.18-1.91-2.94-1.59-4.7.36-1.94 1.96-3.55 3.89-3.93.34-.07.68-.1 1.02-.1 2.76 0 5 2.24 5 5 0 1.43-.61 2.79-1.69 3.74z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 11h1v3h-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.672 9.58l.707-.706 2.122 2.121-.707.707z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.208 11.712l-.707-.707 2.121-2.121.707.707z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiPeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.89 8.11C15.5 7.72 14.83 7 13.53 7h-2.54C8.24 6.99 6 4.75 6 2H4c0 3.16 2.11 5.84 5 6.71V22h2v-6h2v6h2V10.05L18.95 14l1.41-1.41-4.47-4.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiSymbols(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M3 2h8v2H3zM6 11h2V7h3V5H3v2h3zM12.404 20.182l7.778-7.778 1.414 1.414-7.778 7.778z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14.5",
                    "cy": "14.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "19.5",
                    "cy": "19.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 11A2.5 2.5 0 0018 8.5V4h3V2h-4v4.51c-.42-.32-.93-.51-1.5-.51a2.5 2.5 0 000 5zM9.74 15.96l-1.41 1.41-.71-.71.35-.35a2.499 2.499 0 00-1.77-4.27 2.499 2.499 0 00-1.77 4.27l.35.35-1.06 1.06c-.98.98-.98 2.56 0 3.54.5.5 1.14.74 1.78.74s1.28-.24 1.77-.73l1.06-1.06 1.41 1.41 1.41-1.41-1.41-1.41 1.41-1.41-1.41-1.43zM5.85 14.2c.12-.12.26-.15.35-.15s.23.03.35.15c.19.2.19.51 0 .71l-.35.35-.35-.36a.501.501 0 010-.7zm0 5.65c-.12.12-.26.15-.35.15s-.23-.03-.35-.15a.513.513 0 010-.71l1.06-1.06.71.71-1.07 1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineEmojiTransportation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.57 10.66c-.14-.4-.52-.66-.97-.66h-7.19c-.46 0-.83.26-.98.66L10 14.77l.01 5.51c0 .38.31.72.69.72h.62c.38 0 .68-.38.68-.76V19h8v1.24c0 .38.31.76.69.76h.61c.38 0 .69-.34.69-.72l.01-1.37v-4.14l-1.43-4.11zm-8.16.34h7.19l1.03 3h-9.25l1.03-3zM12 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 9h1V3H7v5H2v13h1V9h5V4h6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5 11h2v2H5zM10 5h2v2h-2zM5 15h2v2H5zM5 19h2v2H5z"
                }
            }
        ]
    })(props);
}
function MdOutlineEngineering(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H3zM4.74 9H5c0 2.21 1.79 4 4 4s4-1.79 4-4h.26c.27 0 .49-.22.49-.49v-.02a.49.49 0 00-.49-.49H13c0-1.48-.81-2.75-2-3.45v.95c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.14C9.68 4.06 9.35 4 9 4s-.68.06-1 .14V5.5c0 .28-.22.5-.5.5S7 5.78 7 5.5v-.95C5.81 5.25 5 6.52 5 8h-.26a.49.49 0 00-.49.49v.03c0 .26.22.48.49.48zM11 9c0 1.1-.9 2-2 2s-2-.9-2-2h4zM21.98 6.23l.93-.83-.75-1.3-1.19.39c-.14-.11-.3-.2-.47-.27L20.25 3h-1.5l-.25 1.22c-.17.07-.33.16-.48.27l-1.18-.39-.75 1.3.93.83c-.02.17-.02.35 0 .52l-.93.85.75 1.3 1.2-.38c.13.1.28.18.43.25l.28 1.23h1.5l.27-1.22c.16-.07.3-.15.44-.25l1.19.38.75-1.3-.93-.85c.03-.19.02-.36.01-.53zM19.5 7.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM19.4 10.79l-.85.28c-.1-.08-.21-.14-.33-.19l-.18-.88h-1.07l-.18.87c-.12.05-.24.12-.34.19l-.84-.28-.54.93.66.59c-.01.13-.01.25 0 .37l-.66.61.54.93.86-.27c.1.07.2.13.31.18l.18.88h1.07l.19-.87c.11-.05.22-.11.32-.18l.85.27.54-.93-.66-.61c.01-.13.01-.25 0-.37l.66-.59-.53-.93zm-1.9 2.6c-.49 0-.89-.4-.89-.89s.4-.89.89-.89.89.4.89.89-.4.89-.89.89z"
                }
            }
        ]
    })(props);
}
function MdOutlineFace2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.97 13.52v-.04C23.21 12.38 24 10.78 24 9c0-3.31-2.69-6-6-6-.26 0-.52.02-.78.06a5.98 5.98 0 00-10.44 0C6.52 3.02 6.26 3 6 3 2.69 3 0 5.69 0 9c0 1.78.79 3.38 2.02 4.48v.04A6.008 6.008 0 000 18c0 3.31 2.69 6 6 6 1.39 0 2.67-.48 3.69-1.28.74.18 1.51.28 2.31.28s1.57-.1 2.31-.28c1.02.8 2.3 1.28 3.69 1.28 3.31 0 6-2.69 6-6 0-1.78-.79-3.38-2.03-4.48zM22 9c0 .55-.12 1.07-.32 1.54A10 10 0 0017.98 5H18c2.21 0 4 1.79 4 4zm-9.97-4c2.73.01 5.13 1.39 6.57 3.48-.71.57-1.6.89-2.53.89A4.059 4.059 0 0112 5.31c0-.1.02-.2.03-.31zM12 2c1.25 0 2.36.59 3.1 1.5-.98-.32-2.02-.5-3.1-.5s-2.12.18-3.1.5C9.64 2.59 10.75 2 12 2zM6 5h.02a10 10 0 00-3.7 5.54C2.12 10.07 2 9.55 2 9c0-2.21 1.79-4 4-4zm0 17c-2.21 0-4-1.79-4-4 0-.69.19-1.32.5-1.88.8 2.44 2.52 4.47 4.74 5.68-.39.13-.8.2-1.24.2zm-2-9c0-3.72 2.56-6.85 6-7.74v.05c0 3.34 2.72 6.06 6.06 6.06 1.26 0 2.45-.39 3.45-1.09.31.86.49 1.77.49 2.72 0 4.41-3.59 8-8 8s-8-3.59-8-8zm14 9c-.44 0-.85-.07-1.25-.2 2.23-1.21 3.94-3.24 4.74-5.68.31.56.5 1.2.5 1.88.01 2.21-1.78 4-3.99 4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "14",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "14",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdOutlineFace3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22.91 11.96C22.39 6.32 17.66 2 12 2S1.61 6.32 1.09 11.96l-.9 9.86c-.1 1.17.82 2.18 2 2.18h19.62c1.18 0 2.1-1.01 1.99-2.18l-.89-9.86zM13 4.07c2.26.28 4.22 1.51 5.49 3.28-.58.4-1.26.65-1.99.65C14.57 8 13 6.43 13 4.5v-.43zm-2 0v.43C11 6.43 9.43 8 7.5 8c-.73 0-1.41-.25-1.99-.65 1.27-1.77 3.23-3 5.49-3.28zM4.54 9.13c.87.55 1.89.87 2.96.87 1.86 0 3.5-.93 4.5-2.35C13 9.07 14.64 10 16.5 10c1.07 0 2.09-.32 2.96-.87.34.89.54 1.86.54 2.87 0 4.41-3.59 8-8 8s-8-3.59-8-8c0-1.01.2-1.98.54-2.87zM12 22H2.19l.56-6.2C4.25 19.44 7.82 22 12 22s7.75-2.56 9.25-6.2l.56 6.2H12z"
                }
            }
        ]
    })(props);
}
function MdOutlineFace4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-.96 0-1.88.14-2.75.39A4.986 4.986 0 005 0C2.24 0 0 2.24 0 5c0 1.8.96 3.37 2.39 4.25C2.14 10.12 2 11.04 2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 2c2.9 0 5.44 1.56 6.84 3.88-.43.07-.88.12-1.34.12-2.9 0-5.44-1.56-6.84-3.88.43-.07.88-.12 1.34-.12zM4.42 9.47a8.046 8.046 0 013.66-4.44 8.046 8.046 0 01-3.66 4.44zM2 5c0-1.65 1.35-3 3-3 .95 0 1.8.46 2.35 1.15-1.79.94-3.26 2.41-4.2 4.2C2.46 6.8 2 5.95 2 5zm10 15c-4.41 0-8-3.59-8-8 0-.05.01-.1.01-.15 2.6-.98 4.68-2.99 5.74-5.55a9.942 9.942 0 009.92 3.46c.21.71.33 1.46.33 2.24 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdOutlineFace5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-1.12.23-2.18.65-3.15a.495.495 0 00.85-.35c0-.25-.19-.45-.43-.49.15-.26.32-.51.49-.75-.03.08-.06.15-.06.24 0 .28.22.5.5.5s.5-.22.5-.5S6.28 7 6 7c-.13 0-.25.05-.34.13.52-.68 1.15-1.28 1.86-1.76A.495.495 0 008 6a.495.495 0 00.1-.98c.16-.09.32-.17.49-.25.09.14.24.23.41.23.28 0 .5-.22.5-.5 0-.03-.01-.06-.02-.09.39-.13.79-.23 1.21-.3-.11.1-.19.23-.19.39 0 .28.22.5.5.5s.5-.22.5-.5a.51.51 0 00-.3-.46c.26-.03.53-.04.8-.04s.54.01.8.04c-.18.08-.3.25-.3.46 0 .28.22.5.5.5s.5-.22.5-.5c0-.16-.08-.29-.19-.38.41.07.82.17 1.21.3-.01.02-.02.05-.02.08 0 .28.22.5.5.5.17 0 .32-.09.41-.23.17.08.33.16.49.25A.495.495 0 0016 6c.28 0 .5-.22.5-.5 0-.05-.01-.09-.03-.13.71.48 1.34 1.08 1.86 1.76a.495.495 0 00-.83.37c0 .28.22.5.5.5s.5-.22.5-.5c0-.09-.03-.16-.07-.23.18.24.34.49.49.75-.23.03-.42.23-.42.48a.495.495 0 00.85.35c.42.97.65 2.03.65 3.15 0 4.41-3.59 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "5.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "6.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8",
                    "cy": "7.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "7",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "13",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "8.5",
                    "r": ".5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdOutlineFace6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 2c3.68 0 6.78 2.51 7.71 5.9-.6-.16-1.33-.37-2.26-2.24A2.992 2.992 0 0014.76 6H9.24c-1.15 0-2.18.64-2.69 1.66-.93 1.86-1.58 2.06-2.26 2.24C5.22 6.51 8.32 4 12 4zm0 16c-4.41 0-8-3.59-8-8v-.03c2.31-.22 3.43-1.59 4.34-3.41.17-.35.51-.56.9-.56h5.53c.38 0 .72.21.89.55.9 1.8 1.99 3.19 4.34 3.41v.03c0 4.42-3.59 8.01-8 8.01z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "9",
                    "cy": "13",
                    "r": "1.25"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "13",
                    "r": "1.25"
                }
            }
        ]
    })(props);
}
function MdOutlineFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.5 9.5C17.5 6.46 15.04 4 12 4S6.5 6.46 6.5 9.5c0 2.7 1.94 4.93 4.5 5.4V17H9v2h2v2h2v-2h2v-2h-2v-2.1c2.56-.47 4.5-2.7 4.5-5.4zm-9 0C8.5 7.57 10.07 6 12 6s3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineFireplace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.01 12.46c-.15.42-.15.82-.08 1.28.1.55.33 1.04.2 1.6-.13.59-.77 1.38-1.53 1.63 1.28 1.05 3.2.37 3.39-1.32.17-1.54-1.44-1.98-1.98-3.19z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 2v20h20V2H2zm10 16c-1.58 0-2.97-1.88-3-3.06 0-.05-.01-.13-.01-.22-.13-1.73 1-3.2 2.47-4.37.47 1.01 1.27 2.03 2.57 2.92.58.42.97.86.97 1.73 0 1.65-1.35 3-3 3zm8 2h-2v-2h-2.02A4.98 4.98 0 0017 15c0-1.89-1.09-2.85-1.85-3.37C12.2 9.61 13 7 13 7c-6.73 3.57-6.02 7.47-6 8 .03.96.49 2.07 1.23 3H6v2H4V4h16v16z"
                }
            }
        ]
    })(props);
}
function MdOutlineFitbit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.89 13.89c1.04 0 1.89-.85 1.89-1.89s-.85-1.89-1.89-1.89S18 10.96 18 12s.85 1.89 1.89 1.89zm-4.24-.21c.93 0 1.68-.75 1.68-1.68s-.75-1.68-1.68-1.68c-.93 0-1.68.75-1.68 1.68s.75 1.68 1.68 1.68zm0-4.26c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .93.75 1.68 1.68 1.68zm0 8.51c.93 0 1.68-.75 1.68-1.68 0-.93-.75-1.68-1.68-1.68-.93 0-1.68.75-1.68 1.68 0 .92.75 1.68 1.68 1.68zm-4.24-4.46c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0-4.26c.81 0 1.47-.66 1.47-1.47s-.66-1.47-1.47-1.47c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm0 8.52c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0 4.27c.81 0 1.47-.66 1.47-1.47 0-.81-.66-1.47-1.47-1.47-.81 0-1.47.66-1.47 1.47-.01.81.65 1.47 1.47 1.47zm0-17.06c.81 0 1.47-.66 1.47-1.47S12.22 2 11.41 2c-.81 0-1.47.66-1.47 1.47s.65 1.47 1.47 1.47zm-4.25 8.32c.7 0 1.26-.57 1.26-1.26s-.57-1.26-1.26-1.26a1.261 1.261 0 000 2.52zm0 4.25a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm0-8.49a1.261 1.261 0 000-2.52 1.261 1.261 0 000 2.52zm-3.87 4.03a1.05 1.05 0 100-2.1 1.05 1.05 0 000 2.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineFlood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 19c-1.95 0-2.09 1-3.33 1-1.19 0-1.42-1-3.33-1-1.95 0-2.1 1-3.34 1-1.24 0-1.38-1-3.33-1-1.95 0-2.1 1-3.34 1v2c1.95 0 2.11-1 3.34-1 1.24 0 1.38 1 3.33 1 1.95 0 2.1-1 3.34-1 1.22 0 1.4 1 3.33 1 1.93 0 2.1-1 3.33-1 1.22 0 1.4 1 3.33 1v-2c-1.24 0-1.38-1-3.33-1zM8.68 17.5c1.95 0 2.09-1 3.33-1 1.19 0 1.42 1 3.33 1 1.95 0 2.09-1 3.33-1 1.19 0 1.4.98 3.31 1v-2c-.63 0-1-.28-1.48-.55l-2.02-7.53 2.09.85.74-1.86L9.78 2 2 11.61l1.57 1.23 1.39-1.78.93 3.48c-.18-.02-.35-.05-.56-.05-1.95 0-2.09 1-3.33 1v2c1.9 0 2.17-1 3.35-1 1.19.01 1.42 1.01 3.33 1.01zm1.74-13.09l5.74 2.09 2.15 8.02c-1.54.11-1.82.89-2.85.96l-1.42-5.31-3.86 1.04.91 3.39c-1.12.25-1.41.9-2.42.9-.18 0-.33-.02-.45-.05L6.5 9.09l3.92-4.68z"
                }
            }
        ]
    })(props);
}
function MdOutlineFollowTheSigns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75M13 2v7h3.75v14h1.5V9H22V2h-9zm5.01 6V6.25H14.5v-1.5h3.51V3l2.49 2.5L18.01 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineFrontHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.5 8c-.17 0-.34.02-.5.05V4.5a2.5 2.5 0 00-3.04-2.44A2.502 2.502 0 0012.5 0c-1.06 0-1.96.66-2.33 1.59A2.5 2.5 0 007 4v.55A2.5 2.5 0 004 7v8.5c0 4.69 3.81 8.5 8.5 8.5s8.5-3.81 8.5-8.5v-5A2.5 2.5 0 0018.5 8zm.5 7.5a6.5 6.5 0 11-13 0V7c0-.28.22-.5.5-.5s.5.22.5.5v5h2V4c0-.28.22-.5.5-.5s.5.22.5.5v7h2V2.5c0-.28.22-.5.5-.5s.5.22.5.5V11h2V4.5c0-.28.22-.5.5-.5s.5.22.5.5v8.92c-1.77.77-3 2.53-3 4.58h2c0-1.66 1.34-3 3-3v-4.5c0-.28.22-.5.5-.5s.5.22.5.5v5z"
                }
            }
        ]
    })(props);
}
function MdOutlineGirl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 7.5c.97 0 1.75-.78 1.75-1.75S12.97 4 12 4s-1.75.78-1.75 1.75S11.03 7.5 12 7.5zm2 8.5v4h-4v-4H8l2.38-6.38a1.733 1.733 0 013.24 0L16 16h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroupAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9V7h-2v2h-2v2h2v2h2v-2h2V9zM8 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM8 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H2v-.99C2.2 16.29 5.3 15 8 15s5.8 1.29 6 2v1zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zM16.53 13.83C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroupOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4h-.18l-.77-.77c.6-.94.95-2.05.95-3.23zm7.83 12H23v-3c0-2.18-3.58-3.47-6.34-3.87 1.1.75 1.95 1.71 2.23 2.94L22.83 20zM9 6c-.06 0-.11 0-.16.01l-1.6-1.6a3.996 3.996 0 015.35 5.35l-1.6-1.6c.01-.05.01-.1.01-.16 0-1.1-.9-2-2-2zm.17 6H9c-2.21 0-4-1.79-4-4v-.17L.69 3.51 2.1 2.1l19.8 19.8-1.41 1.41L17 19.83V20H1v-3c0-2.66 5.33-4 8-4 .37 0 .8.03 1.25.08L9.17 12zM9 15c-2.7 0-5.8 1.29-6 2.01V18h12v-.17l-2.11-2.11C11.76 15.31 10.33 15 9 15z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroupRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 9v2h-6V9h6zM8 4C5.79 4 4 5.79 4 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0 3c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H2v-.99C2.2 16.29 5.3 15 8 15s5.8 1.29 6 2v1zM12.51 4.05C13.43 5.11 14 6.49 14 8s-.57 2.89-1.49 3.95C14.47 11.7 16 10.04 16 8s-1.53-3.7-3.49-3.95zm4.02 9.78C17.42 14.66 18 15.7 18 17v3h2v-3c0-1.45-1.59-2.51-3.47-3.17z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroups2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.27 12h3.46a1.5 1.5 0 001.48-1.75l-.3-1.79a2.951 2.951 0 00-5.82.01l-.3 1.79c-.15.91.55 1.74 1.48 1.74zm.79-3.21c.08-.46.47-.79.94-.79s.86.33.94.79l.2 1.21h-2.28l.2-1.21zM1.66 11.11c-.13.26-.18.57-.1.88.16.69.76 1.03 1.53 1h1.95c.83 0 1.51-.58 1.51-1.29 0-.14-.03-.27-.07-.4-.01-.03-.01-.05.01-.08.09-.16.14-.34.14-.53 0-.31-.14-.6-.36-.82-.03-.03-.03-.06-.02-.1.07-.2.07-.43.01-.65a1.12 1.12 0 00-.99-.74.09.09 0 01-.07-.03C5.03 8.14 4.72 8 4.37 8c-.3 0-.57.1-.75.26-.03.03-.06.03-.09.02a1.24 1.24 0 00-1.7 1.03c0 .02-.01.04-.03.06-.29.26-.46.65-.41 1.05.03.22.12.43.25.6.03.02.03.06.02.09zM16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.07zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM22 11v-.5c0-1.1-.9-2-2-2h-2c-.42 0-.65.48-.39.81l.7.63c-.19.31-.31.67-.31 1.06 0 1.1.9 2 2 2s2-.9 2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroups3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.24 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.07zM1.22 14.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM22.78 14.58A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57c0-.81-.48-1.53-1.22-1.85zM12 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM1.497 11L4 8.497 6.503 11 4 13.503zM20 9l-2.5 4h5z"
                }
            }
        ]
    })(props);
}
function MdOutlineGroups(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zm-7.76-2.78c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16c.09-.23.13-.39.91-.69.97-.38 1.99-.56 3.02-.56s2.05.18 3.02.56c.77.3.81.46.91.69H8.07zM12 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.22 19.85c-.18.18-.5.21-.71 0a.504.504 0 010-.71l3.39-3.39-1.41-1.41-3.39 3.39c-.19.2-.51.19-.71 0a.504.504 0 010-.71l3.39-3.39-1.41-1.41-3.39 3.39c-.18.18-.5.21-.71 0a.513.513 0 010-.71l3.39-3.39-1.42-1.41-3.39 3.39c-.18.18-.5.21-.71 0a.513.513 0 010-.71L9.52 8.4l1.87 1.86c.95.95 2.59.94 3.54 0 .98-.98.98-2.56 0-3.54l-1.86-1.86.28-.28c.78-.78 2.05-.78 2.83 0l4.24 4.24c.78.78.78 2.05 0 2.83l-8.2 8.2zm9.61-6.78a4.008 4.008 0 000-5.66l-4.24-4.24a4.008 4.008 0 00-5.66 0l-.28.28-.28-.28a4.008 4.008 0 00-5.66 0L2.17 6.71a3.992 3.992 0 00-.4 5.19l1.45-1.45a2 2 0 01.37-2.33l3.54-3.54c.78-.78 2.05-.78 2.83 0l3.56 3.56c.18.18.21.5 0 .71-.21.21-.53.18-.71 0L9.52 5.57l-5.8 5.79c-.98.97-.98 2.56 0 3.54.39.39.89.63 1.42.7a2.458 2.458 0 002.12 2.12 2.458 2.458 0 002.12 2.12c.07.54.31 1.03.7 1.42.47.47 1.1.73 1.77.73.67 0 1.3-.26 1.77-.73l8.21-8.19z"
                }
            }
        ]
    })(props);
}
function MdOutlineHealthAndSafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10.5 13H8v-3h2.5V7.5h3V10H16v3h-2.5v2.5h-3V13zM12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm6 9.09c0 4-2.55 7.7-6 8.83-3.45-1.13-6-4.82-6-8.83v-4.7l6-2.25 6 2.25v4.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineHeartBroken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.5 3c-.96 0-1.9.25-2.73.69L12 9h3l-3 10 1-9h-3l1.54-5.39C10.47 3.61 9.01 3 7.5 3 4.42 3 2 5.42 2 8.5c0 4.13 4.16 7.18 10 12.5 5.47-4.94 10-8.26 10-12.5C22 5.42 19.58 3 16.5 3zm-6.26 13.73C6.45 13.34 4 11 4 8.5 4 6.54 5.54 5 7.5 5c.59 0 1.19.15 1.73.42L7.35 12h3.42l-.53 4.73zm4.89-1.2L17.69 7h-2.91l.61-1.82c.36-.12.74-.18 1.11-.18C18.46 5 20 6.54 20 8.5c0 2.21-2.02 4.43-4.87 7.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineHiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 5.28c-1.23-.37-2.22-1.17-2.8-2.18l-1-1.6c-.41-.65-1.11-1-1.84-1-.78 0-1.59.5-1.78 1.44S7 23 7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3c1 1.15 2.41 2.01 4 2.34V23H19V9h-1.5v1.78zM7.43 13.13l-2.12-.41a.999.999 0 01-.79-1.17l.76-3.93a2 2 0 012.34-1.58l1.16.23-1.35 6.86z"
                }
            }
        ]
    })(props);
}
function MdOutlineHistoryEdu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4v1.38c-.83-.33-1.72-.5-2.61-.5-1.79 0-3.58.68-4.95 2.05l3.33 3.33h1.11v1.11c.86.86 1.98 1.31 3.11 1.36V15H6v3c0 1.1.9 2 2 2h10c1.66 0 3-1.34 3-3V4H9zm-1.11 6.41V8.26H5.61L4.57 7.22a5.07 5.07 0 011.82-.34c1.34 0 2.59.52 3.54 1.46l1.41 1.41-.2.2a2.7 2.7 0 01-1.92.8c-.47 0-.93-.12-1.33-.34zM19 17c0 .55-.45 1-1 1s-1-.45-1-1v-2h-6v-2.59c.57-.23 1.1-.57 1.56-1.03l.2-.2L15.59 14H17v-1.41l-6-5.97V6h8v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineHive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.5 9l-2.25-4h-3.31l-1.69-3h-4.5L8.06 5H4.75L2.5 9l1.69 3-1.69 3 2.25 4h3.31l1.69 3h4.5l1.69-3h3.31l2.25-4-1.69-3 1.69-3zm-2.29 0l-1.12 2h-2.14l-1.12-2 1.12-2h2.14l1.12 2zm-8.27 5l-1.12-2 1.12-2h2.12l1.12 2-1.12 2h-2.12zm2.14-10l1.12 1.98L13.06 8h-2.12L9.8 5.98 10.92 4h2.16zM5.92 7h2.14l1.12 2-1.12 2H5.92L4.79 9l1.13-2zm-1.13 8l1.12-2h2.14l1.12 2-1.12 2H5.92l-1.13-2zm6.13 5L9.8 18.02 10.94 16h2.12l1.13 2.02L13.08 20h-2.16zm7.16-3h-2.14l-1.12-2 1.12-2h2.14l1.12 2-1.12 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineIceSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 17c0 1.66-1.34 3-3 3h-2v-2h3v-4a3.96 3.96 0 00-2.91-3.82l-2.62-.74C12.62 9.19 12 8.39 12 7.5V3H3v15h3v2H2v2h16c2.76 0 5-2.24 5-5h-2zM5 16V5h5v1H8.5c-.28 0-.5.22-.5.5s.22.5.5.5H10l.1 1H8.5c-.28 0-.5.22-.5.5s.22.5.5.5h1.81c.45 1.12 1.4 2.01 2.6 2.36l2.62.73C16.4 12.33 17 13.1 17 14v2H5zm9 4H8v-2h6v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineInterests(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.02 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM13 13v8h8v-8h-8zm6 6h-4v-4h4v4zM7 2l-5 9h10L7 2zm0 4.12L8.6 9H5.4L7 6.12zM19.25 2.5c-1.06 0-1.81.56-2.25 1.17-.44-.61-1.19-1.17-2.25-1.17C13.19 2.5 12 3.78 12 5.25c0 2 2.42 3.42 5 5.75 2.58-2.33 5-3.75 5-5.75 0-1.47-1.19-2.75-2.75-2.75zM17 8.35c-1.45-1.22-3-2.4-3-3.1 0-.43.35-.75.75-.75.31 0 .52.17.73.37L17 6.3l1.52-1.43c.21-.2.42-.37.73-.37.4 0 .75.32.75.75 0 .7-1.55 1.88-3 3.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineIosShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 5l-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4 4 4zm4 5v11c0 1.1-.9 2-2 2H6a2 2 0 01-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3a2 2 0 012 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineKayaking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM12 5.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 12s-1.52.71-3.93 1.37c-.82-.23-1.53-.75-2.07-1.37-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.73.84-1.8 1.5-3 1.5s-2.27-.66-3-1.5c-.54.61-1.25 1.13-2.07 1.37C1.52 18.21 0 17.5 0 17.5s2.93-1.36 7.13-2.08l1.35-4.17c.31-.95 1.32-1.47 2.27-1.16.09.03.19.07.27.11l2.47 1.3 2.84-1.5 1.65-3.71-.51-1.32L18.8 2 22 3.43 20.67 6.4l-1.31.5-3.72 8.34c4.85.63 8.36 2.26 8.36 2.26zm-8.98-4.54l-1.52.8-1.75-.92-.71 2.17c.32 0 .64-.01.96-.01.71 0 1.4.03 2.07.08l.95-2.12z"
                }
            }
        ]
    })(props);
}
function MdOutlineKingBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L4 19h1l.67-2h12.67l.66 2h1l.67-2H22v-5zm-4-2h-5V7h5v3zM6 7h5v3H6V7zm-2 5h16v3H4v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineKitesurfing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M6 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm14.06-2h-2.12L15.5 3.44l1.06 1.06 3.5-3.5zM22 23v-2h-1c-1.04 0-2.08-.35-3-1-1.83 1.3-4.17 1.3-6 0-1.83 1.3-4.17 1.3-6 0-.91.65-1.96 1-3 1H2v2h1c1.03 0 2.05-.25 3-.75 1.89 1 4.11 1 6 0 1.89 1 4.11 1 6 0 .95.5 1.97.75 3 .75h1zm-1-9.72c0 1.44-2.19 3.62-5.04 5.58-.31.09-.63.14-.96.14-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.94 0-1.81-.41-2.49-.99.46-.39.96-.78 1.49-1.17l-1.55-2.97A4.06 4.06 0 016 12V8c0-1.1.9-2 2-2h3c1.38 0 2.63-.56 3.54-1.46l1.41 1.41A7.018 7.018 0 0111 8H9.6v3.5h2.8l1.69 1.88c1.95-.84 3.77-1.38 5.06-1.38.84 0 1.85.25 1.85 1.28zm-8.8.99l-.7-.77-2.5.1.83 2.01c.59-.38 1.81-1.06 2.37-1.34z"
                }
            }
        ]
    })(props);
}
function MdOutlineLandslide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 12L8 8H2v14h20l-6-8-5-2zm1.53 2.77L6 16.95l-2-.67v-1.89l2 .67 3.95-1.32 2.58 1.03zM7 10l1.57 2.09-2.57.86-2-.67V10h3zM4 20v-1.61l2 .67 9.03-3.01L18 20H4zM17 6V1l-5-1-3 2v4l3 2 5-2zm-6-2.93l1.42-.95 2.58.52v2.01l-2.77 1.11L11 4.93V3.07zM18.5 7L16 9v3l2.5 2 4.5-2V8l-4.5-1zm2.5 3.7l-2.2.98-.8-.64V9.96l1-.8 2 .44v1.1z"
                }
            }
        ]
    })(props);
}
function MdOutlineLocationCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineLuggage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zM16 18h-1.5V9H16v9zm1-12h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-6.5-2.5h3V6h-3V3.5zM17 19H7V8h10v11z"
                }
            }
        ]
    })(props);
}
function MdOutlineMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 11c1.93 0 3.5 1.57 3.5 3.5S11.43 18 9.5 18 6 16.43 6 14.5 7.57 11 9.5 11zm0-2C6.46 9 4 11.46 4 14.5S6.46 20 9.5 20s5.5-2.46 5.5-5.5c0-1.16-.36-2.23-.97-3.12L18 7.42V10h2V4h-6v2h2.58l-3.97 3.97C11.73 9.36 10.66 9 9.5 9z"
                }
            }
        ]
    })(props);
}
function MdOutlineMan2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2.5v7h3v-7H16V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineMan3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2zM12 1.751L14.248 4 12 6.248 9.75 4z"
                }
            }
        ]
    })(props);
}
function MdOutlineMan4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.75 7h-3.5C9.04 7 8.11 8.07 8.27 9.26L10 22h4l1.73-12.74C15.89 8.07 14.96 7 13.75 7z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 7h-4c-1.1 0-2 .9-2 2v6h2v7h4v-7h2V9c0-1.1-.9-2-2-2z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineMasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.5 6c-1.31 0-2.37 1.01-2.48 2.3-1.88-.5-2.84-1.8-5.02-1.8-2.19 0-3.14 1.3-5.02 1.8C6.87 7.02 5.81 6 4.5 6A2.5 2.5 0 002 8.5V9c0 6 3.6 7.81 6.52 7.98C9.53 17.62 10.72 18 12 18s2.47-.38 3.48-1.02C18.4 16.81 22 15 22 9v-.5A2.5 2.5 0 0019.5 6zm-16 3v-.5c0-.55.45-1 1-1s1 .45 1 1v3c0 1.28.38 2.47 1.01 3.48C4.99 14.27 3.5 12.65 3.5 9zM7 11.5V9.85c1.12-.23 1.95-.69 2.66-1.08C10.48 8.33 11.07 8 12 8c.93 0 1.52.33 2.34.78.71.39 1.54.84 2.66 1.08v1.65c0 2.76-2.24 5-5 5s-5-2.25-5-5.01zM20.5 9c0 3.65-1.49 5.27-3.01 5.98.64-1.01 1.01-2.2 1.01-3.48v-3c0-.55.45-1 1-1s1 .45 1 1V9zm-9.81 1.48c-.44.26-.96.56-1.69.76V10.2c.48-.17.84-.38 1.18-.58C10.72 9.3 11.23 9 12 9s1.27.3 1.8.62c.34.2.71.42 1.2.59v1.04c-.75-.21-1.26-.51-1.71-.78-.46-.27-.8-.47-1.29-.47s-.84.2-1.31.48z"
                }
            }
        ]
    })(props);
}
function MdOutlineMilitaryTech(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10.43V2H7v8.43c0 .35.18.68.49.86l4.18 2.51-.99 2.34-3.41.29 2.59 2.24L9.07 22 12 20.23 14.93 22l-.78-3.33 2.59-2.24-3.41-.29-.99-2.34 4.18-2.51c.3-.18.48-.5.48-.86zm-6 .64l-2-1.2V4h2v7.07zm4-1.2l-2 1.2V4h2v5.87z"
                }
            }
        ]
    })(props);
}
function MdOutlineMoodBad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 2.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineMood(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineNightsStay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.78 17.51c-2.47 0-6.57-1.33-8.68-5.43-2.33-4.51-.5-8.48.53-10.07C6.27 2.2 1.98 6.59 1.98 12c0 .14.02.28.02.42.61-.26 1.28-.42 1.98-.42 0-3.09 1.73-5.77 4.3-7.1-.5 2.19-.54 5.04 1.04 8.1 1.57 3.04 4.18 4.95 6.8 5.86a8 8 0 01-5.61 1.01c-.37.7-.94 1.27-1.64 1.64.98.32 2.03.5 3.11.5 3.5 0 6.58-1.8 8.37-4.52-.17.01-.37.02-.57.02z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 16h-.18C6.4 14.84 5.3 14 4 14c-1.66 0-3 1.34-3 3s1.34 3 3 3h3c1.1 0 2-.9 2-2s-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoAdultContent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.85.63-3.54 1.69-4.9L7.59 9h2.83L7.1 5.69A7.924 7.924 0 0112 4c4.41 0 8 3.59 8 8 0 1.85-.63 3.54-1.69 4.9l-1.9-1.9h-2.83l3.31 3.31A7.874 7.874 0 0112 20c-4.41 0-8-3.59-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.25 14l-1.5-2 1.5-2h-1.5L12 11l-.75-1h-1.5l1.5 2-1.5 2h1.5l.75-1 .75 1zM8 10l-.75 1-.75-1H5l1.5 2L5 14h1.5l.75-1L8 14h1.5L8 12l1.5-2zM16 14l.75-1 .75 1H19l-1.5-2 1.5-2h-1.5l-.75 1-.75-1h-1.5l1.5 2-1.5 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNoLuggage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 13.17l-1.5-1.5V9H16v4.17zm3.78 9.44l-1.85-1.85c-.28.15-.59.24-.93.24 0 .55-.45 1-1 1s-1-.45-1-1H9c0 .55-.45 1-1 1s-1-.45-1-1c-1.1 0-2-.9-2-2V8c0-.05.02-.1.02-.15L1.39 4.22 2.8 2.81l18.38 18.38-1.4 1.42zM16.17 19l-3.42-3.42V18h-1.5v-3.92L9.5 12.33V18H8v-7.17l-1-1V19h9.17zM12.75 9h-.92l.92.92V9zM19 8v8.17l-2-2V8h-6.17l-.99-.99L9 6.17V3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v3h2c1.1 0 2 .9 2 2zm-8.5-2h3V3.5h-3V6z"
                }
            }
        ]
    })(props);
}
function MdOutlineNordicWalking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 23h-1.5v-9H19v9zM7.53 14H6l-2 9h1.53l2-9zm5.97-8.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6a2.145 2.145 0 00-2.65-.84L6 8.3V13h2V9.6l1.8-.7z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotificationAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 14v3H8v-7c0-2.21 1.79-4 4-4 .85 0 1.64.26 2.28.72l1.43-1.43A5.87 5.87 0 0013.5 4.2v-.7c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.7C7.91 4.86 6 7.21 6 10v7H4v2h16v-2h-2v-3h-2zm-4 8c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zM24 8h-3V5h-2v3h-3v2h3v3h2v-3h3V8z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotificationsActive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zM7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2a8.445 8.445 0 013.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43a8.495 8.495 0 013.54 6.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotificationsNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotificationsOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm0-15.5c2.49 0 4 2.02 4 4.5v.1l2 2V11c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.24.06-.47.15-.69.23l1.64 1.64c.18-.02.36-.05.55-.05zM5.41 3.35L4 4.76l2.81 2.81C6.29 8.57 6 9.74 6 11v5l-2 2v1h14.24l1.74 1.74 1.41-1.41L5.41 3.35zM16 17H8v-6c0-.68.12-1.32.34-1.9L16 16.76V17z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotificationsPaused(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.5 9.8h2.8l-2.8 3.4V15h5v-1.8h-2.8l2.8-3.4V8h-5zM18 16v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"
                }
            }
        ]
    })(props);
}
function MdOutlineNotifications(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
                }
            }
        ]
    })(props);
}
function MdOutlineOutdoorGrill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 22c1.66 0 3-1.34 3-3s-1.34-3-3-3c-1.3 0-2.4.84-2.82 2H9.14l1.99-3.06a6.36 6.36 0 001.74 0l1.02 1.57c.42-.53.96-.95 1.6-1.21l-.6-.93A6.992 6.992 0 0019 8H5c0 2.84 1.69 5.27 4.12 6.37l-3.95 6.08a1 1 0 00.29 1.38 1 1 0 001.38-.29l1-1.55h6.34C14.6 21.16 15.7 22 17 22zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-9.58-8h9.16c-.77 1.76-2.54 3-4.58 3s-3.81-1.24-4.58-3zM9.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04zM11.89 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.78-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.23.24.8.67.45 2.04zM14.41 7h1c.15-1.15.23-1.64-.89-2.96-.42-.5-.68-.77-.46-2.04h-.99c-.21 1.11.03 2.05.89 2.96.22.24.79.67.45 2.04z"
                }
            }
        ]
    })(props);
}
function MdOutlinePages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 2h6v6h-3l1-4-4 1V5zM5 5h6v3L7 7l1 4H5V5zm6 14H5v-6h3l-1 4 4-1v3zm8 0h-6v-3l4 1-1-4h3v6zm-4.37-4.37L12 13.72l-2.63.91.91-2.63-.91-2.63 2.63.91 2.63-.91-.91 2.63.91 2.63z"
                }
            }
        ]
    })(props);
}
function MdOutlineParagliding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.48.94C14.68 18.54 14 19 12 19s-2.68-.46-3.48-1.06C8.04 17.55 7 16.76 7 14H5c0 2.7.93 4.41 2.3 5.5.5.4 1.1.7 1.7.9V24h6v-3.6c.6-.2 1.2-.5 1.7-.9 1.37-1.09 2.3-2.8 2.3-5.5h-2c0 2.76-1.04 3.55-1.52 3.94zM23 4.25v3.49c0 .8-.88 1.26-1.56.83-.14-.09-.28-.18-.44-.26L19 13h-2l-1.5-6.28a27.852 27.852 0 00-7 0L7 13H5L3 8.31c-.16.08-.3.17-.44.26C1.88 9 1 8.55 1 7.74V4.25C1 1.9 5.92 0 12 0s11 1.9 11 4.25zM6.9 6.98c-.93.19-1.78.43-2.53.71l1.51 3.55L6.9 6.98zm12.73.71c-.75-.28-1.6-.52-2.53-.71l1.02 4.25 1.51-3.54zM21 4.31C20.65 3.63 17.57 2 12 2S3.35 3.63 3 4.31v1.77C5.34 5.07 8.56 4.5 12 4.5s6.66.57 9 1.58V4.31z"
                }
            }
        ]
    })(props);
}
function MdOutlinePartyMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h4.05l.59-.65L9.88 4h4.24l1.24 1.35.59.65H20v12zM9 12c0-1.66 1.34-3 3-3h3.98c-.92-1.21-2.35-2-3.98-2a5.002 5.002 0 00-4.9 6h2.08c-.11-.31-.18-.65-.18-1zm6 0c0 1.66-1.34 3-3 3H8.02c.92 1.21 2.35 2 3.98 2a5.002 5.002 0 004.9-6h-2.08c.11.31.18.65.18 1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePeopleAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16.67 13.13C18.04 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.57-3.47-6.33-3.87zM15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4c-.47 0-.91.1-1.33.24a5.98 5.98 0 010 7.52c.42.14.86.24 1.33.24zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM9 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4zm6 5H3v-.99C3.2 16.29 6.3 15 9 15s5.8 1.29 6 2v1z"
                }
            }
        ]
    })(props);
}
function MdOutlinePeopleOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
                }
            }
        ]
    })(props);
}
function MdOutlinePeople(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 13.75c-2.34 0-7 1.17-7 3.5V19h14v-1.75c0-2.33-4.66-3.5-7-3.5zM4.34 17c.84-.58 2.87-1.25 4.66-1.25s3.82.67 4.66 1.25H4.34zM9 12c1.93 0 3.5-1.57 3.5-3.5S10.93 5 9 5 5.5 6.57 5.5 8.5 7.07 12 9 12zm0-5c.83 0 1.5.67 1.5 1.5S9.83 10 9 10s-1.5-.67-1.5-1.5S8.17 7 9 7zm7.04 6.81c1.16.84 1.96 1.96 1.96 3.44V19h4v-1.75c0-2.02-3.5-3.17-5.96-3.44zM15 12c1.93 0 3.5-1.57 3.5-3.5S16.93 5 15 5c-.54 0-1.04.13-1.5.35.63.89 1 1.98 1 3.15s-.37 2.26-1 3.15c.46.22.96.35 1.5.35z"
                }
            }
        ]
    })(props);
}
function MdOutlinePerson2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18zM9.78 12h4.44c1.21 0 2.14-1.06 1.98-2.26l-.32-2.45C15.57 5.39 13.92 4 12 4S8.43 5.39 8.12 7.29L7.8 9.74c-.16 1.2.77 2.26 1.98 2.26zm.32-4.41C10.26 6.67 11.06 6 12 6s1.74.67 1.9 1.59l.32 2.41H9.78l.32-2.41z"
                }
            }
        ]
    })(props);
}
function MdOutlinePerson3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18zM10 12h4c1.66 0 3-1.34 3-3 0-.73-.27-1.4-.71-1.92.13-.33.21-.7.21-1.08a3 3 0 00-1.86-2.77C14 2.48 13.06 2 12 2s-2 .48-2.64 1.23A3 3 0 007.5 6c0 .38.08.75.21 1.08C7.27 7.6 7 8.27 7 9c0 1.66 1.34 3 3 3zm-.76-3.63c.87-1.04.26-2 .26-2.37 0-.41.24-.77.62-.92.29-.12.55-.31.75-.54.17-.21.55-.54 1.13-.54s.96.33 1.13.53c.2.24.46.42.75.54a1 1 0 01.62.93c0 .37-.61 1.33.26 2.37.58.69.04 1.63-.76 1.63h-4c-.8 0-1.34-.94-.76-1.63z"
                }
            }
        ]
    })(props);
}
function MdOutlinePerson4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.39 14.56C16.71 13.7 14.53 13 12 13s-4.71.7-6.39 1.56A2.97 2.97 0 004 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM18 18H6v-.78c0-.38.2-.72.52-.88C7.71 15.73 9.63 15 12 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18zM12 12c2.21 0 4-1.79 4-4V4.5c0-.83-.67-1.5-1.5-1.5-.52 0-.98.27-1.25.67-.27-.4-.73-.67-1.25-.67s-.98.27-1.25.67c-.27-.4-.73-.67-1.25-.67C8.67 3 8 3.67 8 4.5V8c0 2.21 1.79 4 4 4zm-2-6.5h4V8c0 1.1-.9 2-2 2s-2-.9-2-2V5.5z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonAddAlt1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 8c0-2.21-1.79-4-4-4S5 5.79 5 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM1 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.78 1.28 6 2H3zm17-3v-3h3v-2h-3V7h-2v3h-3v2h3v3h2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonAddAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 9V6h-2v3h-3v2h3v3h2v-3h3V9h-3zM9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C13.71 13.7 11.53 13 9 13s-4.71.7-6.39 1.56A2.97 2.97 0 001 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 18H3v-.78c0-.38.2-.72.52-.88C4.71 15.73 6.63 15 9 15c2.37 0 4.29.73 5.48 1.34.32.16.52.5.52.88V18z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H9zm-3-3v-3h3v-2H6V7H4v3H1v2h3v3z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 17.17l-3.37-3.38c.64.22 1.23.48 1.77.76.97.51 1.58 1.52 1.6 2.62zm1.19 4.02l-1.41 1.41-2.61-2.6H4v-2.78c0-1.12.61-2.15 1.61-2.66 1.29-.66 2.87-1.22 4.67-1.45L1.39 4.22 2.8 2.81l18.39 18.38zM15.17 18l-3-3H12c-2.37 0-4.29.73-5.48 1.34-.32.16-.52.5-.52.88V18h9.17zM12 6c1.1 0 2 .9 2 2 0 .86-.54 1.59-1.3 1.87l1.48 1.48a3.999 3.999 0 10-5.53-5.53l1.48 1.48A1.99 1.99 0 0112 6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 5.9a2.1 2.1 0 110 4.2 2.1 2.1 0 010-4.2m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonRemoveAlt1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.77 1.28 6 2H4zM17 10h6v2h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonRemove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4 4-1.79 4-4zm-2 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zM2 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4zm2 0c.2-.71 3.3-2 6-2 2.69 0 5.77 1.28 6 2H4zM17 10h6v2h-6z"
                }
            }
        ]
    })(props);
}
function MdOutlinePerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
            }
        ]
    })(props);
}
function MdOutlinePersonalInjury(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm6.39 8.56C16.71 11.7 14.53 11 12 11s-4.71.7-6.39 1.56A2.97 2.97 0 004 15.22V22h2v-6.78c0-.38.2-.72.52-.88C7.71 13.73 9.63 13 12 13c.76 0 1.47.07 2.13.2l-1.55 3.3H9.75C8.23 16.5 7 17.73 7 19.25S8.23 22 9.75 22H18c1.1 0 2-.9 2-2v-4.78c0-1.12-.61-2.15-1.61-2.66zM10.94 20H9.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.89l-.7 1.5zM18 20h-4.85l2.94-6.27c.54.2 1.01.41 1.4.61.31.16.51.5.51.88V20z"
                }
            }
        ]
    })(props);
}
function MdOutlinePianoOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.19 21.19L2.81 2.81 1.39 4.22 3 5.83V19c0 1.1.9 2 2 2h13.17l1.61 1.61 1.41-1.42zM8.25 19H5V7.83l2 2v3.67c0 .55.45 1 1 1h.25V19zm1.5 0v-4.5H10c.46 0 .82-.31.94-.73l3.31 3.31V19h-4.5zM11 8.17L5.83 3H19c1.1 0 2 .9 2 2v13.17l-2-2V5h-2v8.5c0 .19-.07.36-.16.51L13 10.17V5h-2v3.17z"
                }
            }
        ]
    })(props);
}
function MdOutlinePiano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 11.5h.25V19h-4.5v-4.5H10c.55 0 1-.45 1-1V5h2v8.5c0 .55.45 1 1 1zM5 5h2v8.5c0 .55.45 1 1 1h.25V19H5V5zm14 14h-3.25v-4.5H16c.55 0 1-.45 1-1V5h2v14z"
                }
            }
        ]
    })(props);
}
function MdOutlinePix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.45 16.52l-3.01-3.01c-.11-.11-.24-.13-.31-.13s-.2.02-.31.13L8.8 16.53c-.34.34-.87.89-2.64.89l3.71 3.7a3 3 0 004.24 0l3.72-3.71c-.91 0-1.67-.18-2.38-.89zM8.8 7.47l3.02 3.02c.08.08.2.13.31.13s.23-.05.31-.13l2.99-2.99c.71-.74 1.52-.91 2.43-.91l-3.72-3.71a3 3 0 00-4.24 0l-3.71 3.7c1.76 0 2.3.58 2.61.89z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.11 9.85l-2.25-2.26H17.6c-.54 0-1.08.22-1.45.61l-3 3c-.28.28-.65.42-1.02.42a1.5 1.5 0 01-1.02-.42L8.09 8.17c-.38-.38-.9-.6-1.45-.6H5.17l-2.29 2.3a3 3 0 000 4.24l2.29 2.3h1.48c.54 0 1.06-.22 1.45-.6l3.02-3.02c.28-.28.65-.42 1.02-.42s.74.14 1.02.42l3.01 3.01c.38.38.9.6 1.45.6h1.26l2.25-2.26a3.042 3.042 0 00-.02-4.29z"
                }
            }
        ]
    })(props);
}
function MdOutlinePlusOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4V8zm4.5-1.92V7.9l2.5-.5V18h2V5l-4.5 1.08z"
                }
            }
        ]
    })(props);
}
function MdOutlinePoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 10h2v7H7zm4-3h2v10h-2zm4 6h2v4h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlinePrecisionManufacturing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.93 8.35l-3.6 1.68L14 7.7V6.3l2.33-2.33 3.6 1.68c.38.18.82.01 1-.36.18-.38.01-.82-.36-1l-3.92-1.83a.993.993 0 00-1.13.2L13.78 4.4A.975.975 0 0013 4c-.55 0-1 .45-1 1v1H8.82C8.4 4.84 7.3 4 6 4 4.34 4 3 5.34 3 7c0 1.1.6 2.05 1.48 2.58L7.08 18H6c-1.1 0-2 .9-2 2v1h13v-1c0-1.1-.9-2-2-2h-1.62L8.41 8.77c.17-.24.31-.49.41-.77H12v1c0 .55.45 1 1 1 .32 0 .6-.16.78-.4l1.74 1.74c.3.3.75.38 1.13.2l3.92-1.83c.38-.18.54-.62.36-1a.753.753 0 00-1-.36zM6 8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5.11 10H9.17l-2.46-8h.1l4.3 8z"
                }
            }
        ]
    })(props);
}
function MdOutlinePsychologyAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 9.06C19.5 5.73 16.57 3 13 3 9.47 3 6.57 5.61 6.08 9l-1.93 3.48c-.41.66.07 1.52.85 1.52h1v2c0 1.1.9 2 2 2h1v3h7v-4.68a7.016 7.016 0 003.94-7.26zm-5.05 5.57l-.89.42V19h-3v-3H8v-4H6.7l1.33-2.33C8.21 7.06 10.35 5 13 5c2.76 0 5 2.24 5 5 0 2.09-1.29 3.88-3.11 4.63z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 12.54c-.41 0-.74.31-.74.73 0 .41.33.74.74.74.42 0 .73-.33.73-.74a.71.71 0 00-.73-.73zM12.5 7c-1.03 0-1.74.67-2 1.45l.96.4c.13-.39.43-.86 1.05-.86.95 0 1.13.89.8 1.36-.32.45-.86.75-1.14 1.26-.23.4-.18.87-.18 1.16h1.06c0-.55.04-.65.13-.82.23-.42.65-.62 1.09-1.27.4-.59.25-1.38-.01-1.8-.31-.49-.9-.88-1.76-.88z"
                }
            }
        ]
    })(props);
}
function MdOutlinePsychology(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.82 7.22l-1 .4c-.21-.16-.43-.29-.67-.39L14 6.17c-.02-.1-.1-.17-.2-.17h-1.6c-.1 0-.18.07-.19.17l-.15 1.06c-.24.1-.47.23-.67.39l-1-.4c-.09-.03-.2 0-.24.09l-.8 1.38a.2.2 0 00.05.26l.85.66c-.03.12-.05.26-.05.39s.01.26.03.39l-.84.66a.19.19 0 00-.05.25l.8 1.39c.05.09.15.12.25.09l.99-.4c.21.16.43.29.68.39l.14 1.06c.02.1.1.17.2.17h1.6c.1 0 .18-.07.2-.17l.15-1.06c.24-.1.47-.23.67-.39l.99.4c.09.04.2 0 .24-.09l.8-1.39c.05-.09.03-.19-.05-.25l-.83-.66a2.561 2.561 0 000-.78l.85-.66a.2.2 0 00.05-.26l-.8-1.38c-.05-.09-.16-.12-.25-.09zM13 11.43a1.43 1.43 0 110-2.86 1.43 1.43 0 010 2.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.94 9.06c-.43-3.27-3.23-5.86-6.53-6.05C13.27 3 13.14 3 13 3 9.47 3 6.57 5.61 6.08 9l-1.93 3.48c-.41.66.07 1.52.85 1.52h1v2c0 1.1.9 2 2 2h1v3h7v-4.68a7.016 7.016 0 003.94-7.26zm-5.05 5.57l-.89.42V19h-3v-3H8v-4H6.7l1.33-2.33C8.21 7.06 10.35 5 13 5c2.76 0 5 2.24 5 5 0 2.09-1.29 3.88-3.11 4.63z"
                }
            }
        ]
    })(props);
}
function MdOutlinePublicOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 8.17L6.49 3.66A9.91 9.91 0 0112 2c5.52 0 10 4.48 10 10 0 2.04-.61 3.93-1.66 5.51l-1.46-1.46A7.842 7.842 0 0020 12c0-3.35-2.07-6.22-5-7.41V5c0 1.1-.9 2-2 2h-2v1.17zm10.19 13.02l-1.41 1.41-2.27-2.27A9.839 9.839 0 0112 22C6.48 22 2 17.52 2 12c0-2.04.61-3.93 1.66-5.51L1.39 4.22 2.8 2.81l18.39 18.38zM11 18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.08 3.05 7.44 7 7.93V18z"
                }
            }
        ]
    })(props);
}
function MdOutlinePublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-.61.08-1.21.21-1.78L8.99 15v1c0 1.1.9 2 2 2v1.93C7.06 19.43 4 16.07 4 12zm13.89 5.4c-.26-.81-1-1.4-1.9-1.4h-1v-3c0-.55-.45-1-1-1h-6v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41C17.92 5.77 20 8.65 20 12c0 2.08-.81 3.98-2.11 5.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineRealEstateAgent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 6.5V14h-2V7.5L14 4 9 7.5V9H7V6.5l7-5 7 5zm-5.5.5h-1v1h1V7zm-2 0h-1v1h1V7zm2 2h-1v1h1V9zm-2 0h-1v1h1V9zm5.5 7h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3zM3 20v-7h2v7H3zm10.97.41L7 18.48V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-1.99-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.26 1.58.26H19c.39 0 .74.23.9.56l-5.93 1.84z"
                }
            }
        ]
    })(props);
}
function MdOutlineRecommend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 10h-4.59l.58-3.41v-.2c-.01-.26-.12-.51-.3-.7L12 5l-4.6 5c-.27.26-.42.62-.4 1v5c0 1.1.9 2 2 2h5.5c.56.03 1.08-.29 1.3-.8l2.1-4.9c.08-.15.12-.33.1-.5V11c0-.55-.45-1-1-1z"
                }
            }
        ]
    })(props);
}
function MdOutlineRecycling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M5.77 7.15L7.2 4.78l1.03-1.71c.39-.65 1.33-.65 1.72 0l1.48 2.46-1.23 2.06-1 1.62-3.43-2.06zm15.95 5.82l-1.6-2.66-3.46 2L18.87 16H20a2 2 0 002-2c0-.36-.1-.71-.28-1.03zM16 21h1.5a2 2 0 001.79-1.11L20.74 17H16v-2l-4 4 4 4v-2zm-6-4H5.7l-.84 1.41c-.3.5-.32 1.12-.06 1.65.28.57.87.94 1.52.94H10v-4zm-3.88-2.65l1.73 1.04L6.48 9.9 1 11.27l1.7 1.02-.41.69c-.35.59-.38 1.31-.07 1.92l1.63 3.26 2.27-3.81zm10.9-9.21l-1.3-2.17C15.35 2.37 14.7 2 14 2h-3.53l3.12 5.2-1.72 1.03 5.49 1.37 1.37-5.49-1.71 1.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineReduceCapacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M16 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58A6.95 6.95 0 0018 7c-.67 0-1.31.1-1.92.28.58.55.92 1.32.92 2.15V10h5v-.57c0-.81-.48-1.53-1.22-1.85zM6 6c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.92 1.28C7.31 7.1 6.67 7 6 7c-.99 0-1.93.21-2.78.58A2.01 2.01 0 002 9.43V10h5v-.57c0-.83.34-1.6.92-2.15zM10 4c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0116 9.43V10zm-1 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6h-8v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0121 21.43V22zM5 16c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm6 6H3v-.57c0-.81.48-1.53 1.22-1.85a6.95 6.95 0 015.56 0A2.01 2.01 0 0111 21.43V22zm1.75-9v-2h-1.5v2H9l3 3 3-3h-2.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineRemoveModerator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 4.14l6 2.25v4.7c0 1.19-.23 2.36-.64 3.44l1.51 1.51c.72-1.53 1.13-3.22 1.13-4.95V5l-8-3-5.22 1.96 1.55 1.55L12 4.14zM2.81 2.81L1.39 4.22 4 6.83v4.26c0 5.05 3.41 9.76 8 10.91 1.72-.43 3.28-1.36 4.55-2.62l3.23 3.23 1.41-1.41L2.81 2.81zM12 19.92c-3.45-1.13-6-4.82-6-8.83V8.83l9.14 9.14c-.9.88-1.97 1.57-3.14 1.95z"
                }
            }
        ]
    })(props);
}
function MdOutlineRollerSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12a3.96 3.96 0 00-2.91-3.82l-2.62-.74C13.62 7.19 13 6.39 13 5.5V1H4v15h16v-4zm-2 2H6V3h5v1H9.5c-.28 0-.5.22-.5.5s.22.5.5.5H11l.1 1H9.5c-.28 0-.5.22-.5.5s.22.5.5.5h1.81c.45 1.12 1.4 2.01 2.6 2.36l2.62.73C17.4 10.33 18 11.1 18 12v2zM5 17c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm14-4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-7-4c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSafetyDivider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5h2v14h-2V5zm-6 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 001 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85zM19 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0015 15.43V16h8v-.57c0-.81-.48-1.53-1.22-1.85z"
                }
            }
        ]
    })(props);
}
function MdOutlineSanitizer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.5 6.5C15.5 5.66 17 4 17 4s1.5 1.66 1.5 2.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5zm4 8.5a2.5 2.5 0 002.5-2.5c0-1.67-2.5-4.5-2.5-4.5S17 10.83 17 12.5a2.5 2.5 0 002.5 2.5zM13 14h-2v-2H9v2H7v2h2v2h2v-2h2v-2zm3-2v8c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-8c0-2.97 2.16-5.43 5-5.91V4H7V2h6c1.13 0 2.15.39 2.99 1.01l-1.43 1.43C14.1 4.17 13.57 4 13 4h-2v2.09c2.84.48 5 2.94 5 5.91zm-2 0c0-2.21-1.79-4-4-4s-4 1.79-4 4v8h8v-8z"
                }
            }
        ]
    })(props);
}
function MdOutlineScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 11V8c4.56-.58 8-3.1 8-6H2c0 2.9 3.44 5.42 8 6v3c-3.68.73-8 3.61-8 11h6v-2H4.13c.93-6.83 6.65-7.2 7.87-7.2s6.94.37 7.87 7.2H16v2h6c0-7.39-4.32-10.27-8-11zm4.87-7C17.5 5.19 15 6.12 12 6.12S6.5 5.19 5.13 4h13.74zM12 22c-1.1 0-2-.9-2-2 0-.55.22-1.05.59-1.41C11.39 17.79 16 16 16 16s-1.79 4.61-2.59 5.41c-.36.37-.86.59-1.41.59z"
                }
            }
        ]
    })(props);
}
function MdOutlineSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"
                }
            }
        ]
    })(props);
}
function MdOutlineScience(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 11.33L18 18H6l5-6.67V6h2m2.96-2H8.04c-.42 0-.65.48-.39.81L9 6.5v4.17L3.2 18.4c-.49.66-.02 1.6.8 1.6h16c.82 0 1.29-.94.8-1.6L15 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81z"
                }
            }
        ]
    })(props);
}
function MdOutlineScoreboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 9h-2.5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1H18c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-.5 4.5H16v-3h1.5v3zm-8 1.5H5v-2.5c0-.55.45-1 1-1h2v-1H5V9h3.5c.55 0 1 .45 1 1v1.5c0 .55-.45 1-1 1h-2v1h3V15zm3.25-4h-1.5V9.5h1.5V11zm0 3.5h-1.5V13h1.5v1.5zM22 6v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3V2h2v2h6V2h2v2h3c1.1 0 2 .9 2 2zm-2 12V6h-7.25v1.5h-1.5V6H4v12h7.25v-1.5h1.5V18H20z"
                }
            }
        ]
    })(props);
}
function MdOutlineScubaDiving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M1 13c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.89-2.89l4.53-1.21-.78-2.9-4.53 1.21c-.8.21-1.28 1.04-1.06 1.84.22.8 1.04 1.28 1.84 1.06zM20.5 5.9L23 3l-1-1-3 3-2 4-9.48 2.87c-.82.2-1.39.89-1.5 1.68L5.24 18 2.4 21.8 4 23l3-4 1.14-3.14L14 14l5-3.5 1.5-4.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSelfImprovement(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 16v-2c-2.24 0-4.16-.96-5.6-2.68l-1.34-1.6A1.98 1.98 0 0012.53 9h-1.05c-.59 0-1.15.26-1.53.72l-1.34 1.6C7.16 13.04 5.24 14 3 14v2c2.77 0 5.19-1.17 7-3.25V15l-3.88 1.55c-.67.27-1.12.93-1.12 1.66C5 19.2 5.8 20 6.79 20H9v-.5a2.5 2.5 0 012.5-2.5h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.83 0-1.5.67-1.5 1.5v.5h7.21c.99 0 1.79-.8 1.79-1.79 0-.73-.45-1.39-1.12-1.66L14 15v-2.25c1.81 2.08 4.23 3.25 7 3.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineSentimentDissatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 14c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5zm-.01-12C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSentimentNeutral(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 14h6v1.5H9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSentimentSatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.5",
                    "cy": "9.5",
                    "r": "1.5"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c-1.48 0-2.75-.81-3.45-2H6.88a5.495 5.495 0 0010.24 0h-1.67c-.7 1.19-1.97 2-3.45 2zm-.01-14C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSentimentVeryDissatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 13.5c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zm4.17-10C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06z"
                }
            }
        ]
    })(props);
}
function MdOutlineSentimentVerySatisfied(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12L13 9.94zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11l1.06-1.06zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                }
            }
        ]
    })(props);
}
function MdOutlineSevereCold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 10.41l4-4L14.59 5 12 7.59V4h-2v3.59L7.41 5 6 6.41l4 4V12H8.41l-4-4L3 9.41 5.59 12H2v2h3.59L3 16.59 4.41 18l4-4H10v1.59l-4 4L7.41 21 10 18.41V22h2v-3.59L14.59 21 16 19.59l-4-4V14h1.59l4 4L19 16.59 16.41 14H20v-2h-8zM19 2h2v5h-2zM19 8h2v2h-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
                }
            }
        ]
    })(props);
}
function MdOutlineSick(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.32 10.56L8.38 9.5 7.32 8.44l1.06-1.06L10.5 9.5l-2.12 2.12-1.06-1.06zM4.5 9c.03 0 .05.01.08.01A8.002 8.002 0 0112 4c2.19 0 4.16.88 5.61 2.3.15-.6.45-1.29.81-1.96A9.965 9.965 0 0011.99 2c-4.88 0-8.94 3.51-9.81 8.14C2.74 9.44 3.59 9 4.5 9zM21 10.5c-.42 0-.82-.09-1.19-.22.12.55.19 1.13.19 1.72 0 4.42-3.58 8-8 8-3.36 0-6.23-2.07-7.42-5.01-.03 0-.05.01-.08.01-.52 0-1.04-.14-1.5-.4-.32-.18-.59-.42-.82-.7.89 4.61 4.93 8.1 9.8 8.1C17.52 22 22 17.52 22 12c0-.55-.06-1.09-.14-1.62a3.5 3.5 0 01-.86.12zM21 3s-2 2.9-2 4 .9 2 2 2 2-.9 2-2-2-4-2-4zm-5.38 4.38L13.5 9.5l2.12 2.12 1.06-1.06-1.06-1.06 1.06-1.06-1.06-1.06zM8.56 17c.69-1.19 1.97-2 3.44-2s2.75.81 3.44 2h1.68c-.8-2.05-2.79-3.5-5.12-3.5-.87 0-1.7.2-2.43.57L5.99 12c0-.52-.26-1.02-.74-1.29-.72-.41-1.63-.17-2.05.55-.41.72-.17 1.63.55 2.05.48.28 1.05.25 1.49 0l2.97 1.72c-.57.53-1.03 1.21-1.33 1.97h1.68z"
                }
            }
        ]
    })(props);
}
function MdOutlineSignLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.49 13l-.93-1.86c-.37-.74-.07-1.64.67-2.01l.26-.13 5.73 5.46c.5.47.78 1.13.78 1.81v5.23a2.5 2.5 0 01-2.5 2.5h-11c-.55 0-1-.45-1-1s.45-1 1-1H10v-1H4c-.55 0-1-.45-1-1s.45-1 1-1h6v-1H3c-.55 0-1-.45-1-1s.45-1 1-1h7v-1H4.5c-.55 0-1-.45-1-1s.45-1 1-1h7.99zm1.51.2V15h-2v7h4c.55 0 1-.45 1-1v-4.53c0-.27-.11-.54-.31-.73L14 13.2zm-2.22-6.08c-.84.4-1.17.62-1.63 1.19l-2.7-2.85A.996.996 0 118.9 4.09l2.88 3.03zM9.64 9.21a3.46 3.46 0 00-.2 1.79h-.86L6.31 8.61a.987.987 0 01.04-1.41.996.996 0 011.41.04l1.88 1.97zm10.69 4.7l.88-.83c.5-.47.79-1.13.79-1.82V3.35l-.27-.1c-.78-.28-1.64.12-1.92.9l-.71 1.96-5.5-5.8a.996.996 0 10-1.45 1.37l3.79 3.99-.73.69-4.82-5.08a.996.996 0 10-1.45 1.37l3.78 3.98L15.38 9l1.93-1.87 1.38 1.45L20 7.34v3.7c0 .28-.11.54-.31.73l-.7.66.61.58c.29.27.53.57.73.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSingleBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20 12c0-1.1-.9-2-2-2V7c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c-1.1 0-2 .9-2 2v5h1.33L6 19h1l.67-2h8.67l.66 2h1l.67-2H20v-5zm-4-2h-3V7h3v3zM8 7h3v3H8V7zm-2 5h12v3H6v-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineSkateboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM7.25 22.5c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm8.5 0c-.41 0-.75.34-.75.75s.34.75.75.75.75-.34.75-.75-.34-.75-.75-.75zm3.49-3.5a.72.72 0 00-.59.3c-.55.73-1.42 1.2-2.4 1.2H16v-6l-4.32-2.67 1.8-2.89A6.507 6.507 0 0019 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C14.16 5.64 13.61 5 12.7 5H7L4.5 9l1.7 1.06L8.1 7h2.35l-2.4 3.84c-.31.5-.39 1.11-.21 1.67l1.34 4.15-3.12 3.76c-.7-.16-1.3-.57-1.71-1.12a.749.749 0 10-1.2.9c.82 1.1 2.13 1.8 3.6 1.8h9.5c1.47 0 2.78-.7 3.6-1.8.1-.14.15-.3.15-.45 0-.39-.32-.75-.76-.75zM14 20.5H8.6l2.9-3.5-1-3.3 3.5 2.2v4.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSledding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 4.5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm8.8 15.74a4.003 4.003 0 01-5.04 2.57L1 17.36l.46-1.43 3.93 1.28.46-1.43-3.92-1.28.46-1.43L4 13.6V9.5l5.47-2.35c.39-.17.84-.21 1.28-.07.95.31 1.46 1.32 1.16 2.27l-1.05 3.24 2.14-.34c.89-.15 1.76.32 2.14 1.14l2.08 4.51 1.93.63-.46 1.43-3.32-1.08-.47 1.42 3.32 1.08c1.31.43 2.72-.29 3.15-1.61.43-1.31-.29-2.72-1.61-3.15l.46-1.43c2.11.69 3.27 2.95 2.58 5.05zM6 14.25l1.01.33c-.22-.42-.28-.92-.12-1.4L7.92 10 6 10.82v3.43zm7.94 4.16l-6.66-2.16-.46 1.43 6.66 2.16.46-1.43zm.69-1.36l-1.18-2.56-3.97.89 5.15 1.67z"
                }
            }
        ]
    })(props);
}
function MdOutlineSnowboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14 3c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm7.4 17.09a.748.748 0 00-.64.17c-.69.6-1.64.88-2.6.67L17 20.69l-1-6.19-3.32-2.67 1.8-2.89A6.507 6.507 0 0020 12v-2c-1.85 0-3.44-1.12-4.13-2.72l-.52-1.21C15.16 5.64 14.61 5 13.7 5H8L5.5 9l1.7 1.06L9.1 7h2.35l-2.51 3.99c-.28.45-.37 1-.25 1.52L9.5 16 6 18.35l-.47-.1c-.96-.2-1.71-.85-2.1-1.67a.744.744 0 00-.51-.42c-.43-.09-.82.2-.9.58-.04.14-.02.31.05.46.58 1.24 1.71 2.2 3.15 2.51l12.63 2.69c1.44.31 2.86-.11 3.9-1.01.13-.11.21-.26.24-.41.07-.38-.16-.8-.59-.89zM8.73 18.93l3.02-2.03-.44-3.32 2.84 2.02.75 4.64-6.17-1.31z"
                }
            }
        ]
    })(props);
}
function MdOutlineSnowshoeing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12.5 3.5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM6.32 19.03l-1.14-1.47L4 18.5l2.38 3.04c.51.65 1.16 1.15 1.88 1.41.28.1.53.04.72-.11.3-.23.42-.7.12-1.07a.84.84 0 00-.31-.22 2.97 2.97 0 01-1.14-.83l-.08-.1L11 18.2l.89-3.22 2.11 2v4.52h-2V23h3.87c.82 0 1.61-.21 2.26-.61.26-.16.37-.39.37-.64 0-.38-.3-.75-.77-.75-.13 0-.26.04-.37.1-.4.23-.87.37-1.36.4v-6.02l-2.11-2 .6-3C15.79 11.98 17.8 13 20 13v-2c-1.9 0-3.51-1.02-4.31-2.42l-1-1.58c-.4-.6-1-1-1.7-1-.75 0-1.41.34-5.99 2.28V13h2V9.58l1.79-.7L9.2 17l-2.88 2.03z"
                }
            }
        ]
    })(props);
}
function MdOutlineSocialDistance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 5c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm4.78 3.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 002 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zM18 7c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm2.78 1.58a6.95 6.95 0 00-5.56 0A2.01 2.01 0 0014 10.43V11h8v-.57c0-.81-.48-1.53-1.22-1.85zm-2.77 4.43l-1.41 1.41L18.17 16H5.83l1.58-1.59L6 13l-4 4 3.99 3.99 1.41-1.41L5.83 18h12.34l-1.58 1.58L18 20.99 22 17l-3.99-3.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineSouthAmerica(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-1.95.7-3.74 1.87-5.13L9 10v1c0 1.1.9 2 2 2v5.59c0 .27.11.52.29.71l.71.7c-4.42 0-8-3.58-8-8zm9 7.94V18l3.75-5.62c.16-.25.25-.54.25-.83V10.5c0-.55-.45-1-1-1h-1.5l-1.4-1.75c-.38-.47-.95-.75-1.56-.75H8V5.07A7.971 7.971 0 0112 4c4.41 0 8 3.59 8 8 0 4.07-3.06 7.44-7 7.94z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsBaseball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.61 16.78C4.6 15.45 4 13.8 4 12s.6-3.45 1.61-4.78a5.975 5.975 0 010 9.56zM12 20c-1.89 0-3.63-.66-5-1.76 1.83-1.47 3-3.71 3-6.24S8.83 7.23 7 5.76C8.37 4.66 10.11 4 12 4s3.63.66 5 1.76c-1.83 1.47-3 3.71-3 6.24s1.17 4.77 3 6.24A7.963 7.963 0 0112 20zm6.39-3.22a5.975 5.975 0 010-9.56C19.4 8.55 20 10.2 20 12s-.6 3.45-1.61 4.78z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsBasketball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07a8.12 8.12 0 011.16-3.25zM4.07 13h2.84a5.972 5.972 0 01-1.68 3.25A8.12 8.12 0 014.07 13zM11 19.93c-1.73-.22-3.29-1-4.49-2.14A7.952 7.952 0 008.93 13H11v6.93zM11 11H8.93A7.99 7.99 0 006.5 6.2 8.035 8.035 0 0111 4.07V11zm8.93 0h-2.84c.21-1.26.81-2.38 1.68-3.25.6.97 1.01 2.07 1.16 3.25zM13 4.07c1.73.22 3.29.99 4.5 2.13a7.99 7.99 0 00-2.43 4.8H13V4.07zm0 15.86V13h2.07a8.006 8.006 0 002.42 4.79A7.988 7.988 0 0113 19.93zm5.77-3.68A6.004 6.004 0 0117.09 13h2.84a8.12 8.12 0 01-1.16 3.25z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsCricket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.04 12.79l-8.5-8.5C6.35 4.1 6.09 4 5.83 4s-.51.1-.7.29L2.29 7.13c-.39.39-.39 1.03 0 1.42l8.5 8.5c.2.2.45.29.71.29.26 0 .51-.1.71-.29l2.83-2.83c.39-.4.39-1.04 0-1.43zm-3.54 2.13L4.41 7.83l1.42-1.42 7.09 7.09-1.42 1.42zM14.341 17.756l1.414-1.414 4.243 4.243-1.414 1.414zM18.5 2C16.57 2 15 3.57 15 5.5S16.57 9 18.5 9 22 7.43 22 5.5 20.43 2 18.5 2zm0 5c-.83 0-1.5-.67-1.5-1.5S17.67 4 18.5 4s1.5.67 1.5 1.5S19.33 7 18.5 7z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsEsports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.58 16.09l-1.09-7.66A3.996 3.996 0 0016.53 5H7.47C5.48 5 3.79 6.46 3.51 8.43l-1.09 7.66C2.2 17.63 3.39 19 4.94 19c.68 0 1.32-.27 1.8-.75L9 16h6l2.25 2.25c.48.48 1.13.75 1.8.75 1.56 0 2.75-1.37 2.53-2.91zm-2.1.72a.54.54 0 01-.42.19c-.15 0-.29-.06-.39-.16L15.83 14H8.17l-2.84 2.84c-.1.1-.24.16-.39.16a.54.54 0 01-.42-.19.52.52 0 01-.13-.44l1.09-7.66C5.63 7.74 6.48 7 7.47 7h9.06c.99 0 1.84.74 1.98 1.72l1.09 7.66c.03.2-.05.34-.12.43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9 8H8v2H6v1h2v2h1v-2h2v-1H9z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "17",
                    "cy": "12",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "15",
                    "cy": "9",
                    "r": "1"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsFootball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.31 3.69c-.32-.33-1.94-.69-4.05-.69-3.03 0-7.09.75-9.8 3.46-4.59 4.59-3.56 13.06-2.77 13.85.32.33 1.94.69 4.05.69 3.03 0 7.09-.75 9.8-3.46 4.59-4.59 3.56-13.06 2.77-13.85zM7.74 19c-1.14 0-2.02-.12-2.53-.23-.18-.79-.3-2.21-.17-3.83l4.01 4.01c-.52.04-.97.05-1.31.05zm8.39-2.87c-1.33 1.33-3.06 2.05-4.66 2.44l-6.04-6.04c.42-1.68 1.16-3.37 2.45-4.65 1.32-1.32 3.05-2.04 4.64-2.43l6.05 6.05c-.42 1.67-1.17 3.35-2.44 4.63zm2.83-7.04l-4.03-4.03c.52-.05.98-.06 1.33-.06 1.14 0 2.02.12 2.53.23.18.79.3 2.22.17 3.86z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8.5 14.1l5.6-5.6 1.4 1.4-5.6 5.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsGolf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 16c3.87 0 7-3.13 7-7s-3.13-7-7-7-7 3.13-7 7 3.13 7 7 7zm0-12c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "14",
                    "cy": "8",
                    "r": "1"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "6",
                    "r": "1"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 19h2c1.1 0 2 .9 2 2v1h2v-1c0-1.1.9-2 2-2h2v-2H7v2z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsGymnastics(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zM1 9h6l7-5 1.31 1.52-4.17 2.98H14L21.8 4 23 5.4 14.5 12 14 22h-2l-.5-10L8 11H1V9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsHandball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M14.27 6c-.55.95-.22 2.18.73 2.73.95.55 2.18.22 2.73-.73.55-.95.22-2.18-.73-2.73-.95-.55-2.18-.22-2.73.73z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15.84 10.41l-2.6-1.5c-2.38-1.38-3.2-4.44-1.82-6.82l-1.73-1C8.1 3.83 8.6 7.21 10.66 9.4l-5.15 8.92 1.73 1 1.5-2.6 1.73 1-3 5.2 1.73 1 6.29-10.89a5.002 5.002 0 01.31 5.46l1.73 1c1.6-2.75 1.28-6.58-1.69-9.08zM12.75 3.8c.72.41 1.63.17 2.05-.55.41-.72.17-1.63-.55-2.05a1.501 1.501 0 00-1.5 2.6z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsHockey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2 17v3h2v-4H3c-.55 0-1 .45-1 1zM9 16H5v4l4.69-.01c.38 0 .72-.21.89-.55l.87-1.9-1.59-3.48L9 16zM21.71 16.29A.997.997 0 0021 16h-1v4h2v-3c0-.28-.11-.53-.29-.71zM13.6 12.84L17.65 4H14.3l-1.76 3.97-.49 1.1-.05.14L9.7 4H6.35l4.05 8.84 1.52 3.32.08.18 1.42 3.1c.17.34.51.55.89.55L19 20v-4h-4l-1.4-3.16z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsKabaddi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "16.5",
                    "cy": "2.38",
                    "r": "2"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M24 11.88v-4.7l-5.05-2.14c-.97-.41-2.09-.06-2.65.84l-1 1.6c-.67 1.18-1.91 2.06-3.41 2.32l.06.06c.69.69 1.52 1.07 2.46 1.17.8-.42 1.52-.98 2.09-1.64l.6 3-1.16 1.1-.94.89v7.5h2v-6l2.1-2 1.8 8H23l-2.18-11-.62-3.1 1.8.7v3.4h2zM10.29 8.09c.22.15.47.24.72.29.13.02.25.04.38.04s.26-.01.38-.04c.13-.02.25-.06.37-.11.24-.1.47-.24.66-.44.49-.49.67-1.17.55-1.8-.07-.37-.25-.74-.55-1.03-.19-.19-.42-.34-.66-.44-.12-.05-.24-.09-.37-.11s-.25-.04-.38-.04c-.12 0-.23.01-.35.03-.14.02-.28.06-.41.11-.23.11-.46.26-.65.45-.3.29-.48.66-.55 1.03-.12.63.06 1.31.55 1.8.09.1.2.18.31.26z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.24 10.56l-2-2c-.1-.1-.2-.18-.31-.26a1.93 1.93 0 00-.72-.28c-.13-.03-.25-.04-.38-.04-.51 0-1.02.2-1.41.59l-3.34 3.34c-.41.41-.62.98-.58 1.54 0 .18.04.37.11.55l1.07 2.95-3.63 3.63L1.46 22l4.24-4.24v-2.22L7 16.75v5.13h2v-6l-2.12-2.12 2.36-2.36.71.71c1.29 1.26 2.97 2.04 5.03 2.04l-.14-2.07c-1.5-.02-2.7-.62-3.6-1.52z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsMartialArts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.8 2l-8.2 6.7-1.21-1.04 3.6-2.08L9.41 1 8 2.41l2.74 2.74L5 8.46l-1.19 4.29L6.27 17 8 16l-2.03-3.52.35-1.3L9.5 13l.5 9h2l.5-10L21 3.4z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "5",
                    "cy": "5",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsMma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7 20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3H7v3zM18 7c-.55 0-1 .45-1 1V5c0-1.1-.9-2-2-2H7c-1.1 0-2 .9-2 2v5.8c0 .13.01.26.04.39l.8 4c.09.47.5.8.98.8H17c.55 0 1.09-.44 1.2-.98l.77-3.83c.02-.12.03-.25.03-.38V8c0-.55-.45-1-1-1zm-1 3.6c0 .13-.64 3.4-.64 3.4H7.64S7 10.74 7 10.6V5h8v5h2v.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M8 7h6v3H8z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsMotorsports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21.96 11.22C21.57 7.01 17.76 4 13.56 4c-.19 0-.38.01-.57.02C2 4.74 2 17.2 2 17.2v.8c0 1.1.9 2 2 2h10c4.67 0 8.41-4.01 7.96-8.78zm-16.7.34c.57-1.29 1.28-2.35 2.14-3.19l3.62 1.53c.6.25.98.83.98 1.48 0 .89-.72 1.61-1.61 1.61H4.72c.15-.46.32-.94.54-1.43zm13.18 4.48A6.022 6.022 0 0114 18H4v-.8c0-.02.01-.92.24-2.2h6.15c1.99 0 3.61-1.62 3.61-3.61 0-1.45-.87-2.76-2.2-3.32L9.3 7.01c1.1-.57 2.37-.9 3.82-.99.15-.02.3-.02.44-.02 3.31 0 6.13 2.37 6.41 5.41.16 1.72-.38 3.36-1.53 4.63z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsRugby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M20.49 3.51c-.56-.56-2.15-.97-4.16-.97-3.08 0-7.15.96-9.98 3.79-4.69 4.7-4.25 12.74-2.84 14.16.56.56 2.15.97 4.16.97 3.08 0 7.15-.96 9.98-3.79 4.69-4.7 4.25-12.74 2.84-14.16zM5.71 18.29c.63-1.89 2.16-4.99 4.87-7.7 2.68-2.68 5.78-4.23 7.7-4.88-.63 1.89-2.16 4.99-4.88 7.7-2.66 2.68-5.76 4.23-7.69 4.88zM7.76 7.76c2.64-2.64 6.34-3.12 8.03-3.19-2.05.94-4.46 2.46-6.61 4.61a23.206 23.206 0 00-4.61 6.63c.09-2.48.87-5.74 3.19-8.05zm8.48 8.48c-2.64 2.64-6.34 3.12-8.03 3.19 2.05-.94 4.46-2.46 6.61-4.61 2.16-2.16 3.67-4.58 4.62-6.63-.1 2.48-.88 5.74-3.2 8.05z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsSoccer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 3.3l1.35-.95a8.01 8.01 0 014.38 3.34l-.39 1.34-1.35.46L13 6.7V5.3zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34a8.103 8.103 0 014.38-3.34zM7.08 17.11l-1.14.1A7.938 7.938 0 014 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34-.78 1.37zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11-.7 1.48zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54L14.27 15zm3.79 2.21l-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsTennis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.52 2.49C17.18.15 12.9.62 9.97 3.55c-1.6 1.6-2.52 3.87-2.54 5.46-.02 1.58.26 3.89-1.35 5.5l-4.24 4.24 1.42 1.42 4.24-4.24c1.61-1.61 3.92-1.33 5.5-1.35s3.86-.94 5.46-2.54c2.92-2.93 3.4-7.21 1.06-9.55zm-9.2 9.19c-1.53-1.53-1.05-4.61 1.06-6.72s5.18-2.59 6.72-1.06c1.53 1.53 1.05 4.61-1.06 6.72s-5.18 2.59-6.72 1.06zM18 17c.53 0 1.04.21 1.41.59.78.78.78 2.05 0 2.83-.37.37-.88.58-1.41.58s-1.04-.21-1.41-.59c-.78-.78-.78-2.05 0-2.83.37-.37.88-.58 1.41-.58m0-2a3.998 3.998 0 00-2.83 6.83c.78.78 1.81 1.17 2.83 1.17a3.998 3.998 0 002.83-6.83A3.998 3.998 0 0018 15z"
                }
            }
        ]
    })(props);
}
function MdOutlineSportsVolleyball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 2.07c3.07.38 5.57 2.52 6.54 5.36L13 5.65V4.07zM8 5.08c1.18-.69 3.33-1.06 3-1.02v7.35l-3 1.73V5.08zM4.63 15.1c-.4-.96-.63-2-.63-3.1 0-2.02.76-3.86 2-5.27v7.58l-1.37.79zm1.01 1.73L12 13.15l3 1.73-6.98 4.03a7.794 7.794 0 01-2.38-2.08zM12 20c-.54 0-1.07-.06-1.58-.16l6.58-3.8 1.36.78C16.9 18.75 14.6 20 12 20zm1-8.58V7.96l7 4.05c0 1.1-.23 2.14-.63 3.09L13 11.42z"
                }
            }
        ]
    })(props);
}
function MdOutlineSports(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.23 6c-1.66 0-3.22.66-4.36 1.73C6.54 6.73 5.61 6 4.5 6a2.5 2.5 0 000 5c.21 0 .41-.03.61-.08-.05.25-.09.51-.1.78a6.006 6.006 0 006.68 6.27c2.55-.28 4.68-2.26 5.19-4.77.15-.71.15-1.4.06-2.06-.09-.6.38-1.13.99-1.13H22V6H11.23zM4.5 9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zm6.5 6c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "11",
                    "cy": "12",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineSurfing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 23c-1.03 0-2.06-.25-3-.75-1.89 1-4.11 1-6 0-1.89 1-4.11 1-6 0-.95.5-1.97.75-3 .75H2v-2h1c1.04 0 2.08-.35 3-1 1.83 1.3 4.17 1.3 6 0 1.83 1.3 4.17 1.3 6 0 .91.65 1.96 1 3 1h1v2h-1zM17 1.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-2.57 6.98L12.18 10 16 13v3.84c.53.38 1.03.78 1.49 1.17-.68.58-1.55.99-2.49.99-1.2 0-2.27-.66-3-1.5-.73.84-1.8 1.5-3 1.5-.33 0-.65-.05-.96-.14C5.19 16.9 3 14.72 3 13.28 3 12.25 4.01 12 4.85 12c.98 0 2.28.31 3.7.83l-.53-3.1c-.11-.67.18-1.38.78-1.79l2.15-1.45-2-.37-2.82 1.93L5 6.4 8.5 4l5.55 1.03c.45.09.93.37 1.22.89l.88 1.55A5.007 5.007 0 0020.5 10v2a7.01 7.01 0 01-6.07-3.52zM10.3 11.1l.44 2.65c.92.42 2.48 1.27 3.26 1.75V14l-3.7-2.9z"
                }
            }
        ]
    })(props);
}
function MdOutlineSwitchAccount(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6-5H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-9.31 14a5.977 5.977 0 016.62 0h-6.62zm9.31-.27C18.53 14.06 16.4 13 14 13s-4.53 1.06-6 2.73V4h12v11.73z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L11.77 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineThumbUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z",
                    "opacity": ".87"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M21 8h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2zm0 4l-3 7H9V9l4.34-4.34L12.23 10H21v2zM1 9h4v12H1z"
                }
            }
        ]
    })(props);
}
function MdOutlineThunderstorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17.92 7.02C17.45 4.18 14.97 2 12 2 9.82 2 7.83 3.18 6.78 5.06 4.09 5.41 2 7.74 2 10.5 2 13.53 4.47 16 7.5 16h10c2.48 0 4.5-2.02 4.5-4.5a4.5 4.5 0 00-4.08-4.48zM17.5 14h-10C5.57 14 4 12.43 4 10.5a3.51 3.51 0 013.04-3.46l.99-.13.49-.87A3.998 3.998 0 0112 4c1.94 0 3.63 1.44 3.95 3.35l.25 1.52 1.54.14c1.27.12 2.26 1.21 2.26 2.49a2.5 2.5 0 01-2.5 2.5zM14.8 17l-2.9 3.32 2 1L11.55 24h2.65l2.9-3.32-2-1L17.45 17zM8.8 17l-2.9 3.32 2 1L5.55 24H8.2l2.9-3.32-2-1L11.45 17z"
                }
            }
        ]
    })(props);
}
function MdOutlineTornado(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M23 3H1l11 19L23 3zm-3.47 2l-1.74 3H6.21L4.47 5h15.06zm-9.27 10h3.48L12 18.01 10.26 15zm4.64-2H9.1l-1.74-3h9.27l-1.73 3z"
                }
            }
        ]
    })(props);
}
function MdOutlineTransgender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 8c1.93 0 3.5 1.57 3.5 3.5S13.93 15 12 15s-3.5-1.57-3.5-3.5S10.07 8 12 8zm4.53.38l3.97-3.96V7h2V1h-6v2h2.58l-3.97 3.97C14.23 6.36 13.16 6 12 6s-2.23.36-3.11.97l-.65-.65 1.41-1.41-1.41-1.42L6.82 4.9 4.92 3H7.5V1h-6v6h2V4.42l1.91 1.9-1.42 1.42L5.4 9.15l1.41-1.41.65.65c-.6.88-.96 1.95-.96 3.11a5.5 5.5 0 004.5 5.41V19H9v2h2v2h2v-2h2v-2h-2v-2.09a5.5 5.5 0 003.53-8.53z"
                }
            }
        ]
    })(props);
}
function MdOutlineTravelExplore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.3 16.9c.4-.7.7-1.5.7-2.4 0-2.5-2-4.5-4.5-4.5S11 12 11 14.5s2 4.5 4.5 4.5c.9 0 1.7-.3 2.4-.7l3.2 3.2 1.4-1.4-3.2-3.2zm-3.8.1c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5zM12 20v2C6.48 22 2 17.52 2 12S6.48 2 12 2c4.84 0 8.87 3.44 9.8 8h-2.07A8 8 0 0015 4.59V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h2v3H9l-4.79-4.79C4.08 10.79 4 11.38 4 12c0 4.41 3.59 8 8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineTsunami(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18.67 17.63c-3.8 2.8-6.12.4-6.67 0-.66.49-2.92 2.76-6.67 0C3.43 19.03 2.65 19 2 19v2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37zM19.33 12H22v-2h-2.67C17.5 10 16 8.5 16 6.67c0-1.02.38-1.74 1.09-3.34-1.37-.21-2-.33-3.09-.33C7.36 3 2.15 8.03 2.01 14.5l-.01 2c1.16 0 2.3-.32 3.33-.93a6.535 6.535 0 006.67 0 6.535 6.535 0 006.67 0c1.03.61 2.17.93 3.33.93v-2c-.66 0-1.5-.02-3.33-1.37-3.8 2.8-6.12.4-6.67 0-.9.67-.54.41-.91.63-.7-.94-1.09-2.06-1.09-3.26 0-2.58 1.77-4.74 4.21-5.33-.13.51-.21 1.02-.21 1.5C14 9.61 16.39 12 19.33 12zm-14 1.13c-.62.46-.82.63-1.3.87.27-3.53 2.38-6.48 5.43-7.96A7.49 7.49 0 008 10.5c0 1.42.4 2.77 1.13 3.95-.72.07-1.79.15-3.8-1.32z"
                }
            }
        ]
    })(props);
}
function MdOutlineVaccines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11 5.5H8V4h.5c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1H6v1.5H3c-.55 0-1 .45-1 1s.45 1 1 1V15c0 1.1.9 2 2 2h1v4l2 1.5V17h1c1.1 0 2-.9 2-2V7.5c.55 0 1-.45 1-1s-.45-1-1-1zM9 9H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V12H7.25c-.41 0-.75.34-.75.75s.34.75.75.75H9V15H5V7.5h4V9zm10.5 1.5V10c.55 0 1-.45 1-1s-.45-1-1-1h-5c-.55 0-1 .45-1 1s.45 1 1 1v.5c0 .5-1.5 1.16-1.5 3V20c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-6.5c0-1.84-1.5-2.5-1.5-3zm-3 0V10h1v.5c0 1.6 1.5 2 1.5 3v.5h-4v-.5c0-1 1.5-1.4 1.5-3zm2.5 5V17h-4v-1.5h4zM15 20v-1.5h4V20h-4z"
                }
            }
        ]
    })(props);
}
function MdOutlineVolcano(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 8h-7l-2 5H6l-4 9h20L18 8zM7.3 15h3.05l.5-1.26 1.5-3.74h4.14l2.86 10H5.08l2.22-5zM13 1h2v4h-2zM16.121 5.468L18.95 2.64l1.414 1.414-2.829 2.828zM7.64 4.05l1.414-1.414 2.828 2.828-1.414 1.415z"
                }
            }
        ]
    })(props);
}
function MdOutlineWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M18 4H6C3.79 4 2 5.79 2 8v8c0 2.21 1.79 4 4 4h12c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-1.86 9.77c-.24.2-.57.28-.88.2L4.15 11.25C4.45 10.52 5.16 10 6 10h12c.67 0 1.26.34 1.63.84l-3.49 2.93zM6 6h12c1.1 0 2 .9 2 2v.55c-.59-.34-1.27-.55-2-.55H6c-.73 0-1.41.21-2 .55V8c0-1.1.9-2 2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineWaterDrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2c-5.33 4.55-8 8.48-8 11.8 0 4.98 3.8 8.2 8 8.2s8-3.22 8-8.2c0-3.32-2.67-7.25-8-11.8zm0 18c-3.35 0-6-2.57-6-6.2 0-2.34 1.95-5.44 6-9.14 4.05 3.7 6 6.79 6 9.14 0 3.63-2.65 6.2-6 6.2zm-4.17-6c.37 0 .67.26.74.62.41 2.22 2.28 2.98 3.64 2.87.43-.02.79.32.79.75 0 .4-.32.73-.72.75-2.13.13-4.62-1.09-5.19-4.12a.75.75 0 01.74-.87z"
                }
            }
        ]
    })(props);
}
function MdOutlineWavingHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M7.03 4.95L3.49 8.49c-3.32 3.32-3.32 8.7 0 12.02s8.7 3.32 12.02 0l6.01-6.01a2.517 2.517 0 00-.39-3.86l.39-.39c.97-.97.97-2.56 0-3.54-.16-.16-.35-.3-.54-.41a2.497 2.497 0 00-3.72-3.05 2.517 2.517 0 00-3.88-.42l-2.51 2.51a2.493 2.493 0 00-3.84-.39zm1.41 1.42c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-3.18 3.18a3 3 0 010 4.24l1.41 1.41a5.004 5.004 0 001.12-5.36l6.3-6.3c.2-.2.51-.2.71 0s.2.51 0 .71l-4.6 4.6 1.41 1.41 6.01-6.01c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-6.01 6.01 1.41 1.41 4.95-4.95c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-5.66 5.66 1.41 1.41 3.54-3.54c.2-.2.51-.2.71 0 .2.2.2.51 0 .71l-6 6.01c-2.54 2.54-6.65 2.54-9.19 0s-2.54-6.65 0-9.19l3.53-3.54zM23 17c0 3.31-2.69 6-6 6v-1.5c2.48 0 4.5-2.02 4.5-4.5H23zM1 7c0-3.31 2.69-6 6-6v1.5C4.52 2.5 2.5 4.52 2.5 7H1z"
                }
            }
        ]
    })(props);
}
function MdOutlineWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19.05 4.91A9.816 9.816 0 0012.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01zm-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.264 8.264 0 01-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24 2.2 0 4.27.86 5.82 2.42a8.183 8.183 0 012.41 5.83c.02 4.54-3.68 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28z"
                }
            }
        ]
    })(props);
}
function MdOutlineWhatshot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M11.57 13.16c-1.36.28-2.17 1.16-2.17 2.41 0 1.34 1.11 2.42 2.49 2.42 2.05 0 3.71-1.66 3.71-3.71 0-1.07-.15-2.12-.46-3.12-.79 1.07-2.2 1.72-3.57 2zM13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM12 20c-3.31 0-6-2.69-6-6 0-1.53.3-3.04.86-4.43a5.582 5.582 0 003.97 1.63c2.66 0 4.75-1.83 5.28-4.43A14.77 14.77 0 0118 14c0 3.31-2.69 6-6 6z"
                }
            }
        ]
    })(props);
}
function MdOutlineWoman2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3.5v6h3v-6H17l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3v6h4v-6h3l-3.06-7.69z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "4",
                    "r": "2"
                }
            }
        ]
    })(props);
}
function MdOutlineWorkspacePremium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M9.68 13.69L12 11.93l2.31 1.76-.88-2.85L15.75 9h-2.84L12 6.19 11.09 9H8.25l2.31 1.84-.88 2.85zM20 10c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 2.03.76 3.87 2 5.28V23l6-2 6 2v-7.72A7.96 7.96 0 0020 10zm-8-6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 15l-4 1.02v-3.1c1.18.68 2.54 1.08 4 1.08s2.82-.4 4-1.08v3.1L12 19z"
                }
            }
        ]
    })(props);
}
function MdOutlineCheckBoxOutlineBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                }
            }
        ]
    })(props);
}
function MdOutlineCheckBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM17.99 9l-1.41-1.42-6.59 6.59-2.58-2.57-1.42 1.41 4 3.99z"
                }
            }
        ]
    })(props);
}
function MdOutlineIndeterminateCheckBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zM7 11h10v2H7z"
                }
            }
        ]
    })(props);
}
function MdOutlineRadioButtonChecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "12",
                    "cy": "12",
                    "r": "5"
                }
            }
        ]
    })(props);
}
function MdOutlineRadioButtonUnchecked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                }
            }
        ]
    })(props);
}
function MdOutlineStarBorderPurple500(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineStarBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineStarOutline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
                }
            }
        ]
    })(props);
}
function MdOutlineStarPurple500(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
                }
            }
        ]
    })(props);
}
function MdOutlineStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "g",
                "attr": {
                    "fill": "none"
                },
                "child": [
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    },
                    {
                        "tag": "path",
                        "attr": {
                            "d": "M0 0h24v24H0V0z"
                        }
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
                }
            }
        ]
    })(props);
}
function MdOutlineToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0V0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zM7 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}
function MdOutlineToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 24 24"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "none",
                    "d": "M0 0h24v24H0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M17 6H7c-3.31 0-6 2.69-6 6s2.69 6 6 6h10c3.31 0 6-2.69 6-6s-2.69-6-6-6zm0 10H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4zm0-7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
                }
            }
        ]
    })(props);
}

},{"../lib":"9iXc2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3T38Z":[function() {},{}],"aRn3r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerFetcher", ()=>registerFetcher);
var _lib = require("./lib");
const customFetchers = [];
const registerFetcher = (matcher, fetcher)=>{
    customFetchers.push([
        matcher,
        fetcher
    ]);
    return ()=>{
    //delete fetcher
    };
};
const getFetcher = (url)=>{
    var _reverse_find;
    return (_reverse_find = [
        ...customFetchers
    ].reverse().find(([matcher])=>{
        return (0, _lib.match)(url, matcher);
    })) === null || _reverse_find === void 0 ? void 0 : _reverse_find[1];
};
const webNoiseFetch = (...args)=>{
    const request = new Request(...args);
    const fetcher = getFetcher(request.url);
    if (fetcher) return fetcher(...args);
    return fetch(...args);
};
exports.default = webNoiseFetch;

},{"./lib":"gf1Iz","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gf1Iz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
const match = (url, pattern)=>{
    // Escape special characters in the pattern, except for '*'
    const escapedPattern = pattern.replace(/([.+?^=!:${}()|\[\]\/\\])/g, '\\$1');
    // Replace '*' with '.*' to match any sequence of characters
    const regexPattern = escapedPattern.replace(/\*/g, '.*');
    // Create a regular expression from the pattern, ensuring it matches the entire URL
    const regex = new RegExp(`^${regexPattern}$`);
    // Test if the URL matches the pattern
    return regex.test(url);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eveyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stateCreator", ()=>stateCreator);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _reactflow = require("reactflow");
var _zustand = require("zustand");
var _patch = require("@web-noise/patch");
var _constants = require("../constants");
var _generateNodeId = require("../helpers/generateNodeId");
var _generateNodeIdDefault = parcelHelpers.interopDefault(_generateNodeId);
var _nodesStore = require("./nodesStore");
var _nodesStoreDefault = parcelHelpers.interopDefault(_nodesStore);
var _history = require("./history");
var _historyDefault = parcelHelpers.interopDefault(_history);
var _audioPatch = require("./audioPatch");
var _audioPatchDefault = parcelHelpers.interopDefault(_audioPatch);
var _projectStore = require("./projectStore");
var _projectStoreDefault = parcelHelpers.interopDefault(_projectStore);
const stateCreator = (...args)=>{
    const [set, get] = args;
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _nodesStoreDefault.default)(...args), (0, _history.historyStateCreator)(...args), (0, _audioPatch.audioPatchStateCreator)(...args), (0, _projectStoreDefault.default)(...args)), {
        setGraph: async ({ nodes, edges })=>{
            const { patch, createNodes, createEdges, setNodesAndEdges, nodes: activeNodes, edges: activeEdges } = get();
            setNodesAndEdges({
                nodes: [],
                edges: []
            });
            await createNodes(nodes);
            createEdges(edges);
        },
        clearGraph: ()=>{
            const { setGraph } = get();
            setGraph({
                nodes: [],
                edges: []
            });
        },
        createNodes: async (nodes)=>{
            const { createNode } = get();
            await Promise.all(nodes.map((node)=>createNode(node)));
        },
        createNode: (nodeData)=>{
            var _nodesConfiguration_type;
            const { addNode, nodesConfiguration } = get();
            const { type, id, data } = nodeData;
            if (typeof type === "undefined") throw new Error(`node type is not defined for node: ${id}`);
            const node = (0, _objectSpreadProps._)((0, _objectSpread._)({}, nodeData), {
                data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                    config: (0, _objectSpread._)({}, (_nodesConfiguration_type = nodesConfiguration[type]) === null || _nodesConfiguration_type === void 0 ? void 0 : _nodesConfiguration_type.defaultConfig, data === null || data === void 0 ? void 0 : data.config)
                })
            });
            addNode(node);
        },
        removeNode: (node)=>get().removeNodes([
                node
            ]),
        removeNodes: (nodes)=>{
            const { edges, nodes: currentNodes, onNodesDelete, removeEdges, removeNodesFromControlPanel } = get();
            const parentNodeIds = nodes.map(({ id })=>id);
            const children = currentNodes.filter(({ parentNode })=>parentNode && parentNodeIds.includes(parentNode));
            const resultingNodes = [
                ...nodes,
                ...children
            ];
            removeNodesFromControlPanel(resultingNodes);
            const connectedEdges = (0, _reactflow.getConnectedEdges)(resultingNodes, edges);
            removeEdges(connectedEdges);
            onNodesDelete(resultingNodes);
            const nodeIds = resultingNodes.map(({ id })=>id);
            set({
                nodes: currentNodes.filter(({ id })=>!nodeIds.includes(id))
            });
        },
        removeEdges: (edges)=>{
            const { edges: currentEdges, onEdgesDelete } = get();
            const edgeIds = edges.map(({ id })=>id);
            onEdgesDelete(edges);
            set({
                edges: currentEdges.filter(({ id })=>!edgeIds.includes(id))
            });
        },
        createEdges: (newEdges)=>{
            const { patch, edges, setEdges } = get();
            setEdges(newEdges);
        },
        onConnect: async (connection)=>{
            const { edges, createEdges } = get();
            const newEdges = (0, _reactflow.addEdge)(connection, edges);
            createEdges(newEdges);
        },
        onEdgesDelete: (edges)=>{
            const { patch } = get();
        },
        onNodesDelete: async (nodes)=>{
            const { removeNodesFromControlPanel, patch } = get();
            removeNodesFromControlPanel(nodes);
        },
        plugins: [],
        setPlugins: async (plugins)=>{
            const { setNodeTypes } = get();
            set({
                plugins
            });
            const nodesConf = plugins.reduce((acc, plugin)=>{
                return (0, _objectSpread._)({}, acc, plugin.components.reduce((subAcc, item)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, subAcc), {
                        [item.type]: item
                    }), {}));
            }, {});
            const nodeTypes = Object.keys(nodesConf).reduce((acc, type)=>{
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                    [type]: nodesConf[type].node
                });
            }, {});
            const audioNodeTypes = Object.keys(nodesConf).reduce((acc, type)=>{
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                    [type]: nodesConf[type].audioNode
                });
            }, {});
            (0, _patch.setAudioNodeTypes)(audioNodeTypes);
            setNodeTypes(nodeTypes);
            set(({ nodesConfiguration })=>({
                    nodesConfiguration: (0, _objectSpread._)({}, nodesConfiguration, nodesConf)
                }));
        },
        nodesConfiguration: {},
        config: {
            showMinimap: false
        },
        setConfig: (changes)=>{
            set(({ config })=>({
                    config: (0, _objectSpread._)({}, config, changes)
                }));
        },
        getEditorState: ()=>{
            const { getNodesAndEdges, controlPanel, viewport } = get();
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getNodesAndEdges()), {
                controlPanel,
                viewport
            });
        },
        setEditorState: async ({ nodes, edges, controlPanel, viewport })=>{
            const { setGraph } = get();
            await setGraph({
                nodes,
                edges
            });
            // @TODO: remove this line once audio patch initialisation is reworked
            await new Promise((r)=>setTimeout(r, 1000));
            set({
                controlPanel,
                viewport
            });
        },
        isHelpShown: false,
        toggleHelp: ()=>{
            const { isHelpShown: showHelp } = get();
            set({
                isHelpShown: !showHelp
            });
        },
        copyBuffer: {
            nodes: [],
            edges: []
        },
        copy: (elements)=>{
            set({
                copyBuffer: elements
            });
        },
        copySelectedItems: ()=>{
            const { nodes: currentNodes, edges: currentEdges, copy } = get();
            const nodes = currentNodes.filter(({ selected })=>selected);
            const edges = currentEdges.filter(({ selected })=>selected);
            if (!nodes.length) return;
            copy({
                nodes,
                edges
            });
        },
        pasteBuffer: (x = 0, y = 0)=>{
            const { copyBuffer, createNodes, setEdges, nodes, edges } = get();
            const { nodes: nodesToCopy, edges: edgesToCopy } = copyBuffer;
            if (!nodesToCopy.length) return;
            set({
                nodes: nodes.map((node)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
                        selected: false
                    }))
            });
            const topLeftNode = nodesToCopy.reduce((acc, node)=>{
                if (!acc) return node;
                if (node.position.x < acc.position.x && node.position.y < acc.position.y) return node;
                return acc;
            });
            const xDelta = topLeftNode.position.x - x;
            const yDelta = topLeftNode.position.y - y;
            const { nodes: newNodes, mapping } = nodesToCopy.reduce((acc, node)=>{
                const newNodeId = (0, _generateNodeIdDefault.default)(node);
                return {
                    nodes: [
                        ...acc.nodes,
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
                            id: newNodeId,
                            position: {
                                x: node.position.x - xDelta,
                                y: node.position.y - yDelta
                            },
                            selected: true
                        })
                    ],
                    mapping: (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc.mapping), {
                        [node.id]: newNodeId
                    })
                };
            }, {
                nodes: [],
                mapping: {}
            });
            createNodes(newNodes);
            const newEdges = edgesToCopy.map((edge)=>{
                const source = mapping[edge.source] || edge.source;
                const target = mapping[edge.target] || edge.target;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, edge), {
                    id: edge.id.replace(edge.source, source).replace(edge.target, target),
                    source,
                    target,
                    selected: true
                });
            });
            setEdges([
                ...edges.map((edge)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, edge), {
                        selected: false
                    })),
                ...newEdges
            ]);
        },
        getControlPanelNode: (node)=>{
            var _nodesConfiguration_type;
            const { nodesConfiguration } = get();
            const { type } = node;
            if (!type) return null;
            const controlPanelNode = (_nodesConfiguration_type = nodesConfiguration[type]) === null || _nodesConfiguration_type === void 0 ? void 0 : _nodesConfiguration_type.controlPanelNode;
            if (!controlPanelNode) {
                console.error(`could not find node for type ${type}`);
                return null;
            }
            return controlPanelNode;
        },
        controlPanel: {
            show: true,
            nodes: [],
            size: {
                width: 200,
                height: 100
            }
        },
        showControlPanel: ()=>set(({ controlPanel })=>({
                    controlPanel: (0, _objectSpreadProps._)((0, _objectSpread._)({}, controlPanel), {
                        show: true
                    })
                })),
        hideControlPanel: ()=>set(({ controlPanel })=>({
                    controlPanel: (0, _objectSpreadProps._)((0, _objectSpread._)({}, controlPanel), {
                        show: false
                    })
                })),
        addNodeToControlPanel: (node)=>{
            var _nodesConfiguration_node_type;
            const { nodesConfiguration } = get();
            const defaultConfig = node.type ? (_nodesConfiguration_node_type = nodesConfiguration[node.type]) === null || _nodesConfiguration_node_type === void 0 ? void 0 : _nodesConfiguration_node_type.defaultConfig : {};
            const { height } = (defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.size) || {};
            const newNode = (0, _objectSpread._)({
                id: node.id
            }, height ? {
                height: height / (0, _constants.CONTROL_PANEL_GRID_CONFIG).rowHeight
            } : {});
            set(({ controlPanel })=>({
                    controlPanel: (0, _objectSpreadProps._)((0, _objectSpread._)({}, controlPanel), {
                        nodes: [
                            ...controlPanel.nodes,
                            newNode
                        ]
                    })
                }));
        },
        removeNodeFromControlPanel: (node)=>get().removeNodesFromControlPanel([
                node
            ]),
        removeNodesFromControlPanel: (nodes)=>{
            const nodeIds = nodes.map(({ id })=>id);
            set(({ controlPanel })=>{
                const nodes = controlPanel.nodes.filter(({ id })=>!nodeIds.includes(id));
                return {
                    controlPanel: (0, _objectSpreadProps._)((0, _objectSpread._)({}, controlPanel), {
                        nodes
                    })
                };
            });
        },
        setControlPanelNodes: (nodes)=>{
            set(({ controlPanel })=>{
                return {
                    controlPanel: (0, _objectSpreadProps._)((0, _objectSpread._)({}, controlPanel), {
                        nodes
                    })
                };
            });
        },
        setControlPanelSize: (size)=>{
            set(({ controlPanel })=>{
                return {
                    controlPanel: (0, _objectSpreadProps._)((0, _objectSpread._)({}, controlPanel), {
                        size
                    })
                };
            });
        },
        viewport: {
            x: 0,
            y: 0,
            zoom: 1
        },
        setViewport: (viewport)=>set({
                viewport
            })
    });
};
const useStore = (0, _zustand.create)((0, _audioPatchDefault.default)((0, _historyDefault.default)(stateCreator)));
exports.default = useStore;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","reactflow":"eL4zf","zustand":"hmElE","@web-noise/patch":"8lm4y","../constants":"k5UCO","../helpers/generateNodeId":"4rbM7","./nodesStore":"6bwzA","./history":"kfBk8","./audioPatch":"kReks","./projectStore":"baxEl","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eL4zf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _core.ReactFlow));
var _core = require("@reactflow/core");
parcelHelpers.exportAll(_core, exports);
var _minimap = require("@reactflow/minimap");
parcelHelpers.exportAll(_minimap, exports);
var _controls = require("@reactflow/controls");
parcelHelpers.exportAll(_controls, exports);
var _background = require("@reactflow/background");
parcelHelpers.exportAll(_background, exports);
var _nodeToolbar = require("@reactflow/node-toolbar");
parcelHelpers.exportAll(_nodeToolbar, exports);
var _nodeResizer = require("@reactflow/node-resizer");
parcelHelpers.exportAll(_nodeResizer, exports);

},{"@reactflow/core":"bQune","@reactflow/minimap":"b09Pw","@reactflow/controls":"bGWK8","@reactflow/background":"k1yh7","@reactflow/node-toolbar":"876dU","@reactflow/node-resizer":false,"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bQune":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseEdge", ()=>BaseEdge);
parcelHelpers.export(exports, "BezierEdge", ()=>BezierEdge);
parcelHelpers.export(exports, "ConnectionLineType", ()=>ConnectionLineType);
parcelHelpers.export(exports, "ConnectionMode", ()=>ConnectionMode);
parcelHelpers.export(exports, "EdgeLabelRenderer", ()=>EdgeLabelRenderer);
parcelHelpers.export(exports, "EdgeText", ()=>EdgeText$1);
parcelHelpers.export(exports, "Handle", ()=>Handle$1);
parcelHelpers.export(exports, "MarkerType", ()=>MarkerType);
parcelHelpers.export(exports, "PanOnScrollMode", ()=>PanOnScrollMode);
parcelHelpers.export(exports, "Panel", ()=>Panel);
parcelHelpers.export(exports, "Position", ()=>Position);
parcelHelpers.export(exports, "ReactFlow", ()=>ReactFlow);
parcelHelpers.export(exports, "ReactFlowProvider", ()=>ReactFlowProvider);
parcelHelpers.export(exports, "SelectionMode", ()=>SelectionMode);
parcelHelpers.export(exports, "SimpleBezierEdge", ()=>SimpleBezierEdge);
parcelHelpers.export(exports, "SmoothStepEdge", ()=>SmoothStepEdge);
parcelHelpers.export(exports, "StepEdge", ()=>StepEdge);
parcelHelpers.export(exports, "StraightEdge", ()=>StraightEdge);
parcelHelpers.export(exports, "addEdge", ()=>addEdge);
parcelHelpers.export(exports, "applyEdgeChanges", ()=>applyEdgeChanges);
parcelHelpers.export(exports, "applyNodeChanges", ()=>applyNodeChanges);
parcelHelpers.export(exports, "boxToRect", ()=>boxToRect);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "getBezierPath", ()=>getBezierPath);
parcelHelpers.export(exports, "getBoundsOfRects", ()=>getBoundsOfRects);
parcelHelpers.export(exports, "getConnectedEdges", ()=>getConnectedEdges);
parcelHelpers.export(exports, "getIncomers", ()=>getIncomers);
parcelHelpers.export(exports, "getMarkerEnd", ()=>getMarkerEnd);
parcelHelpers.export(exports, "getNodePositionWithOrigin", ()=>getNodePositionWithOrigin);
parcelHelpers.export(exports, "getNodesBounds", ()=>getNodesBounds);
parcelHelpers.export(exports, "getOutgoers", ()=>getOutgoers);
parcelHelpers.export(exports, "getRectOfNodes", ()=>getRectOfNodes);
parcelHelpers.export(exports, "getSimpleBezierPath", ()=>getSimpleBezierPath);
parcelHelpers.export(exports, "getSmoothStepPath", ()=>getSmoothStepPath);
parcelHelpers.export(exports, "getStraightPath", ()=>getStraightPath);
parcelHelpers.export(exports, "getTransformForBounds", ()=>getTransformForBounds);
parcelHelpers.export(exports, "getViewportForBounds", ()=>getViewportForBounds);
parcelHelpers.export(exports, "handleParentExpand", ()=>handleParentExpand);
parcelHelpers.export(exports, "internalsSymbol", ()=>internalsSymbol);
parcelHelpers.export(exports, "isEdge", ()=>isEdge);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "reconnectEdge", ()=>reconnectEdge);
parcelHelpers.export(exports, "rectToBox", ()=>rectToBox);
parcelHelpers.export(exports, "updateEdge", ()=>updateEdge);
parcelHelpers.export(exports, "useEdges", ()=>useEdges);
parcelHelpers.export(exports, "useEdgesState", ()=>useEdgesState);
parcelHelpers.export(exports, "useGetPointerPosition", ()=>useGetPointerPosition);
parcelHelpers.export(exports, "useKeyPress", ()=>useKeyPress);
parcelHelpers.export(exports, "useNodeId", ()=>useNodeId);
parcelHelpers.export(exports, "useNodes", ()=>useNodes);
parcelHelpers.export(exports, "useNodesInitialized", ()=>useNodesInitialized);
parcelHelpers.export(exports, "useNodesState", ()=>useNodesState);
parcelHelpers.export(exports, "useOnSelectionChange", ()=>useOnSelectionChange);
parcelHelpers.export(exports, "useOnViewportChange", ()=>useOnViewportChange);
parcelHelpers.export(exports, "useReactFlow", ()=>useReactFlow);
parcelHelpers.export(exports, "useStore", ()=>useStore);
parcelHelpers.export(exports, "useStoreApi", ()=>useStoreApi);
parcelHelpers.export(exports, "useUpdateNodeInternals", ()=>useUpdateNodeInternals);
parcelHelpers.export(exports, "useViewport", ()=>useViewport);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _traditional = require("zustand/traditional");
var _shallow = require("zustand/shallow");
var _d3Zoom = require("d3-zoom");
var _d3Selection = require("d3-selection");
var _d3Drag = require("d3-drag");
var _reactDom = require("react-dom");
const StoreContext = (0, _react.createContext)(null);
const Provider$1 = StoreContext.Provider;
const errorMessages = {
    error001: ()=>'[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001',
    error002: ()=>"It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
    error003: (nodeType)=>`Node type "${nodeType}" not found. Using fallback type "default".`,
    error004: ()=>'The React Flow parent container needs a width and a height to render the graph.',
    error005: ()=>'Only child nodes can use a parent extent.',
    error006: ()=>"Can't create edge. An edge needs a source and a target.",
    error007: (id)=>`The old edge with id=${id} does not exist.`,
    error009: (type)=>`Marker type "${type}" doesn't exist.`,
    error008: (sourceHandle, edge)=>`Couldn't create edge for ${!sourceHandle ? 'source' : 'target'} handle id: "${!sourceHandle ? edge.sourceHandle : edge.targetHandle}", edge id: ${edge.id}.`,
    error010: ()=>'Handle: No node id found. Make sure to only use a Handle inside a custom Node.',
    error011: (edgeType)=>`Edge type "${edgeType}" not found. Using fallback type "default".`,
    error012: (id)=>`Node with id "${id}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`
};
const zustandErrorMessage = errorMessages['error001']();
function useStore(selector, equalityFn) {
    const store = (0, _react.useContext)(StoreContext);
    if (store === null) throw new Error(zustandErrorMessage);
    return (0, _traditional.useStoreWithEqualityFn)(store, selector, equalityFn);
}
const useStoreApi = ()=>{
    const store = (0, _react.useContext)(StoreContext);
    if (store === null) throw new Error(zustandErrorMessage);
    return (0, _react.useMemo)(()=>({
            getState: store.getState,
            setState: store.setState,
            subscribe: store.subscribe,
            destroy: store.destroy
        }), [
        store
    ]);
};
const selector$g = (s)=>s.userSelectionActive ? 'none' : 'all';
function Panel(_param) {
    var { position, children, className, style } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "position",
        "children",
        "className",
        "style"
    ]);
    const pointerEvents = useStore(selector$g);
    const positionClasses = `${position}`.split('-');
    return (0, _reactDefault.default).createElement("div", (0, _objectSpread._)({
        className: (0, _classcatDefault.default)([
            'react-flow__panel',
            className,
            ...positionClasses
        ]),
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            pointerEvents
        })
    }, rest), children);
}
function Attribution({ proOptions, position = 'bottom-right' }) {
    if (proOptions === null || proOptions === void 0 ? void 0 : proOptions.hideAttribution) return null;
    return (0, _reactDefault.default).createElement(Panel, {
        position: position,
        className: "react-flow__attribution",
        "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://reactflow.dev/pro"
    }, (0, _reactDefault.default).createElement("a", {
        href: "https://reactflow.dev",
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "React Flow attribution"
    }, "React Flow"));
}
const EdgeText = (_param)=>{
    var { x, y, label, labelStyle = {}, labelShowBg = true, labelBgStyle = {}, labelBgPadding = [
        2,
        4
    ], labelBgBorderRadius = 2, children, className } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "x",
        "y",
        "label",
        "labelStyle",
        "labelShowBg",
        "labelBgStyle",
        "labelBgPadding",
        "labelBgBorderRadius",
        "children",
        "className"
    ]);
    const edgeRef = (0, _react.useRef)(null);
    const [edgeTextBbox, setEdgeTextBbox] = (0, _react.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    const edgeTextClasses = (0, _classcatDefault.default)([
        'react-flow__edge-textwrapper',
        className
    ]);
    (0, _react.useEffect)(()=>{
        if (edgeRef.current) {
            const textBbox = edgeRef.current.getBBox();
            setEdgeTextBbox({
                x: textBbox.x,
                y: textBbox.y,
                width: textBbox.width,
                height: textBbox.height
            });
        }
    }, [
        label
    ]);
    if (typeof label === 'undefined' || !label) return null;
    return (0, _reactDefault.default).createElement("g", (0, _objectSpread._)({
        transform: `translate(${x - edgeTextBbox.width / 2} ${y - edgeTextBbox.height / 2})`,
        className: edgeTextClasses,
        visibility: edgeTextBbox.width ? 'visible' : 'hidden'
    }, rest), labelShowBg && (0, _reactDefault.default).createElement("rect", {
        width: edgeTextBbox.width + 2 * labelBgPadding[0],
        x: -labelBgPadding[0],
        y: -labelBgPadding[1],
        height: edgeTextBbox.height + 2 * labelBgPadding[1],
        className: "react-flow__edge-textbg",
        style: labelBgStyle,
        rx: labelBgBorderRadius,
        ry: labelBgBorderRadius
    }), (0, _reactDefault.default).createElement("text", {
        className: "react-flow__edge-text",
        y: edgeTextBbox.height / 2,
        dy: "0.3em",
        ref: edgeRef,
        style: labelStyle
    }, label), children);
};
var EdgeText$1 = (0, _react.memo)(EdgeText);
const getDimensions = (node)=>({
        width: node.offsetWidth,
        height: node.offsetHeight
    });
const clamp = (val, min = 0, max = 1)=>Math.min(Math.max(val, min), max);
const clampPosition = (position = {
    x: 0,
    y: 0
}, extent)=>({
        x: clamp(position.x, extent[0][0], extent[1][0]),
        y: clamp(position.y, extent[0][1], extent[1][1])
    });
// returns a number between 0 and 1 that represents the velocity of the movement
// when the mouse is close to the edge of the canvas
const calcAutoPanVelocity = (value, min, max)=>{
    if (value < min) return clamp(Math.abs(value - min), 1, 50) / 50;
    else if (value > max) return -clamp(Math.abs(value - max), 1, 50) / 50;
    return 0;
};
const calcAutoPan = (pos, bounds)=>{
    const xMovement = calcAutoPanVelocity(pos.x, 35, bounds.width - 35) * 20;
    const yMovement = calcAutoPanVelocity(pos.y, 35, bounds.height - 35) * 20;
    return [
        xMovement,
        yMovement
    ];
};
const getHostForElement = (element)=>{
    var _element_getRootNode, _window;
    return ((_element_getRootNode = element.getRootNode) === null || _element_getRootNode === void 0 ? void 0 : _element_getRootNode.call(element)) || ((_window = window) === null || _window === void 0 ? void 0 : _window.document);
};
const getBoundsOfBoxes = (box1, box2)=>({
        x: Math.min(box1.x, box2.x),
        y: Math.min(box1.y, box2.y),
        x2: Math.max(box1.x2, box2.x2),
        y2: Math.max(box1.y2, box2.y2)
    });
const rectToBox = ({ x, y, width, height })=>({
        x,
        y,
        x2: x + width,
        y2: y + height
    });
const boxToRect = ({ x, y, x2, y2 })=>({
        x,
        y,
        width: x2 - x,
        height: y2 - y
    });
const nodeToRect = (node)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, node.positionAbsolute || {
        x: 0,
        y: 0
    }), {
        width: node.width || 0,
        height: node.height || 0
    });
const getBoundsOfRects = (rect1, rect2)=>boxToRect(getBoundsOfBoxes(rectToBox(rect1), rectToBox(rect2)));
const getOverlappingArea = (rectA, rectB)=>{
    const xOverlap = Math.max(0, Math.min(rectA.x + rectA.width, rectB.x + rectB.width) - Math.max(rectA.x, rectB.x));
    const yOverlap = Math.max(0, Math.min(rectA.y + rectA.height, rectB.y + rectB.height) - Math.max(rectA.y, rectB.y));
    return Math.ceil(xOverlap * yOverlap);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isRectObject = (obj)=>isNumeric(obj.width) && isNumeric(obj.height) && isNumeric(obj.x) && isNumeric(obj.y);
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ const isNumeric = (n)=>!isNaN(n) && isFinite(n);
const internalsSymbol = Symbol.for('internals');
// used for a11y key board controls for nodes and edges
const elementSelectionKeys = [
    'Enter',
    ' ',
    'Escape'
];
const devWarn = (id, message)=>{};
const isReactKeyboardEvent = (event)=>'nativeEvent' in event;
function isInputDOMNode(event) {
    var _kbEvent_composedPath, _kbEvent_composedPath1;
    const kbEvent = isReactKeyboardEvent(event) ? event.nativeEvent : event;
    // using composed path for handling shadow dom
    const target = ((_kbEvent_composedPath1 = kbEvent.composedPath) === null || _kbEvent_composedPath1 === void 0 ? void 0 : (_kbEvent_composedPath = _kbEvent_composedPath1.call(kbEvent)) === null || _kbEvent_composedPath === void 0 ? void 0 : _kbEvent_composedPath[0]) || event.target;
    const isInput = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ].includes(target === null || target === void 0 ? void 0 : target.nodeName) || (target === null || target === void 0 ? void 0 : target.hasAttribute('contenteditable'));
    // when an input field is focused we don't want to trigger deletion or movement of nodes
    return isInput || !!(target === null || target === void 0 ? void 0 : target.closest('.nokey'));
}
const isMouseEvent = (event)=>'clientX' in event;
const getEventPosition = (event, bounds)=>{
    var _event_touches, _event_touches1;
    const isMouseTriggered = isMouseEvent(event);
    const evtX = isMouseTriggered ? event.clientX : (_event_touches = event.touches) === null || _event_touches === void 0 ? void 0 : _event_touches[0].clientX;
    const evtY = isMouseTriggered ? event.clientY : (_event_touches1 = event.touches) === null || _event_touches1 === void 0 ? void 0 : _event_touches1[0].clientY;
    var _bounds_left, _bounds_top;
    return {
        x: evtX - ((_bounds_left = bounds === null || bounds === void 0 ? void 0 : bounds.left) !== null && _bounds_left !== void 0 ? _bounds_left : 0),
        y: evtY - ((_bounds_top = bounds === null || bounds === void 0 ? void 0 : bounds.top) !== null && _bounds_top !== void 0 ? _bounds_top : 0)
    };
};
const isMacOs = ()=>{
    var _navigator_userAgent, _navigator;
    return typeof navigator !== 'undefined' && ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator_userAgent = _navigator.userAgent) === null || _navigator_userAgent === void 0 ? void 0 : _navigator_userAgent.indexOf('Mac')) >= 0;
};
const BaseEdge = ({ id, path, labelX, labelY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth = 20 })=>{
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        id: id,
        style: style,
        d: path,
        fill: "none",
        className: "react-flow__edge-path",
        markerEnd: markerEnd,
        markerStart: markerStart
    }), interactionWidth && (0, _reactDefault.default).createElement("path", {
        d: path,
        fill: "none",
        strokeOpacity: 0,
        strokeWidth: interactionWidth,
        className: "react-flow__edge-interaction"
    }), label && isNumeric(labelX) && isNumeric(labelY) ? (0, _reactDefault.default).createElement(EdgeText$1, {
        x: labelX,
        y: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius
    }) : null);
};
BaseEdge.displayName = 'BaseEdge';
const getMarkerEnd = (markerType, markerEndId)=>{
    if (typeof markerEndId !== 'undefined' && markerEndId) return `url(#${markerEndId})`;
    return typeof markerType !== 'undefined' ? `url(#react-flow__${markerType})` : 'none';
};
function getMouseHandler$1(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const edge = getState().edges.find((e)=>e.id === id);
        if (edge) handler(event, (0, _objectSpread._)({}, edge));
    };
}
// this is used for straight edges and simple smoothstep edges (LTR, RTL, BTT, TTB)
function getEdgeCenter({ sourceX, sourceY, targetX, targetY }) {
    const xOffset = Math.abs(targetX - sourceX) / 2;
    const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;
    const yOffset = Math.abs(targetY - sourceY) / 2;
    const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;
    return [
        centerX,
        centerY,
        xOffset,
        yOffset
    ];
}
function getBezierEdgeCenter({ sourceX, sourceY, targetX, targetY, sourceControlX, sourceControlY, targetControlX, targetControlY }) {
    // cubic bezier t=0.5 mid point, not the actual mid point, but easy to calculate
    // https://stackoverflow.com/questions/67516101/how-to-find-distance-mid-point-of-bezier-curve
    const centerX = sourceX * 0.125 + sourceControlX * 0.375 + targetControlX * 0.375 + targetX * 0.125;
    const centerY = sourceY * 0.125 + sourceControlY * 0.375 + targetControlY * 0.375 + targetY * 0.125;
    const offsetX = Math.abs(centerX - sourceX);
    const offsetY = Math.abs(centerY - sourceY);
    return [
        centerX,
        centerY,
        offsetX,
        offsetY
    ];
}
var ConnectionMode;
(function(ConnectionMode) {
    ConnectionMode["Strict"] = "strict";
    ConnectionMode["Loose"] = "loose";
})(ConnectionMode || (ConnectionMode = {}));
var PanOnScrollMode;
(function(PanOnScrollMode) {
    PanOnScrollMode["Free"] = "free";
    PanOnScrollMode["Vertical"] = "vertical";
    PanOnScrollMode["Horizontal"] = "horizontal";
})(PanOnScrollMode || (PanOnScrollMode = {}));
var SelectionMode;
(function(SelectionMode) {
    SelectionMode["Partial"] = "partial";
    SelectionMode["Full"] = "full";
})(SelectionMode || (SelectionMode = {}));
var ConnectionLineType;
(function(ConnectionLineType) {
    ConnectionLineType["Bezier"] = "default";
    ConnectionLineType["Straight"] = "straight";
    ConnectionLineType["Step"] = "step";
    ConnectionLineType["SmoothStep"] = "smoothstep";
    ConnectionLineType["SimpleBezier"] = "simplebezier";
})(ConnectionLineType || (ConnectionLineType = {}));
var MarkerType;
(function(MarkerType) {
    MarkerType["Arrow"] = "arrow";
    MarkerType["ArrowClosed"] = "arrowclosed";
})(MarkerType || (MarkerType = {}));
var Position;
(function(Position) {
    Position["Left"] = "left";
    Position["Top"] = "top";
    Position["Right"] = "right";
    Position["Bottom"] = "bottom";
})(Position || (Position = {}));
function getControl({ pos, x1, y1, x2, y2 }) {
    if (pos === Position.Left || pos === Position.Right) return [
        0.5 * (x1 + x2),
        y1
    ];
    return [
        x1,
        0.5 * (y1 + y2)
    ];
}
function getSimpleBezierPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top }) {
    const [sourceControlX, sourceControlY] = getControl({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY
    });
    const [targetControlX, targetControlY] = getControl({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY
    });
    const [labelX, labelY, offsetX, offsetY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourceControlX,
        sourceControlY,
        targetControlX,
        targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const SimpleBezierEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth })=>{
    const [path, labelX, labelY] = getSimpleBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
SimpleBezierEdge.displayName = 'SimpleBezierEdge';
const handleDirections = {
    [Position.Left]: {
        x: -1,
        y: 0
    },
    [Position.Right]: {
        x: 1,
        y: 0
    },
    [Position.Top]: {
        x: 0,
        y: -1
    },
    [Position.Bottom]: {
        x: 0,
        y: 1
    }
};
const getDirection = ({ source, sourcePosition = Position.Bottom, target })=>{
    if (sourcePosition === Position.Left || sourcePosition === Position.Right) return source.x < target.x ? {
        x: 1,
        y: 0
    } : {
        x: -1,
        y: 0
    };
    return source.y < target.y ? {
        x: 0,
        y: 1
    } : {
        x: 0,
        y: -1
    };
};
const distance = (a, b)=>Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
// ith this function we try to mimic a orthogonal edge routing behaviour
// It's not as good as a real orthogonal edge routing but it's faster and good enough as a default for step and smooth step edges
function getPoints({ source, sourcePosition = Position.Bottom, target, targetPosition = Position.Top, center, offset }) {
    const sourceDir = handleDirections[sourcePosition];
    const targetDir = handleDirections[targetPosition];
    const sourceGapped = {
        x: source.x + sourceDir.x * offset,
        y: source.y + sourceDir.y * offset
    };
    const targetGapped = {
        x: target.x + targetDir.x * offset,
        y: target.y + targetDir.y * offset
    };
    const dir = getDirection({
        source: sourceGapped,
        sourcePosition,
        target: targetGapped
    });
    const dirAccessor = dir.x !== 0 ? 'x' : 'y';
    const currDir = dir[dirAccessor];
    let points = [];
    let centerX, centerY;
    const sourceGapOffset = {
        x: 0,
        y: 0
    };
    const targetGapOffset = {
        x: 0,
        y: 0
    };
    const [defaultCenterX, defaultCenterY, defaultOffsetX, defaultOffsetY] = getEdgeCenter({
        sourceX: source.x,
        sourceY: source.y,
        targetX: target.x,
        targetY: target.y
    });
    // opposite handle positions, default case
    if (sourceDir[dirAccessor] * targetDir[dirAccessor] === -1) {
        var _center_x;
        centerX = (_center_x = center.x) !== null && _center_x !== void 0 ? _center_x : defaultCenterX;
        var _center_y;
        centerY = (_center_y = center.y) !== null && _center_y !== void 0 ? _center_y : defaultCenterY;
        //    --->
        //    |
        // >---
        const verticalSplit = [
            {
                x: centerX,
                y: sourceGapped.y
            },
            {
                x: centerX,
                y: targetGapped.y
            }
        ];
        //    |
        //  ---
        //  |
        const horizontalSplit = [
            {
                x: sourceGapped.x,
                y: centerY
            },
            {
                x: targetGapped.x,
                y: centerY
            }
        ];
        if (sourceDir[dirAccessor] === currDir) points = dirAccessor === 'x' ? verticalSplit : horizontalSplit;
        else points = dirAccessor === 'x' ? horizontalSplit : verticalSplit;
    } else {
        // sourceTarget means we take x from source and y from target, targetSource is the opposite
        const sourceTarget = [
            {
                x: sourceGapped.x,
                y: targetGapped.y
            }
        ];
        const targetSource = [
            {
                x: targetGapped.x,
                y: sourceGapped.y
            }
        ];
        // this handles edges with same handle positions
        if (dirAccessor === 'x') points = sourceDir.x === currDir ? targetSource : sourceTarget;
        else points = sourceDir.y === currDir ? sourceTarget : targetSource;
        if (sourcePosition === targetPosition) {
            const diff = Math.abs(source[dirAccessor] - target[dirAccessor]);
            // if an edge goes from right to right for example (sourcePosition === targetPosition) and the distance between source.x and target.x is less than the offset, the added point and the gapped source/target will overlap. This leads to a weird edge path. To avoid this we add a gapOffset to the source/target
            if (diff <= offset) {
                const gapOffset = Math.min(offset - 1, offset - diff);
                if (sourceDir[dirAccessor] === currDir) sourceGapOffset[dirAccessor] = (sourceGapped[dirAccessor] > source[dirAccessor] ? -1 : 1) * gapOffset;
                else targetGapOffset[dirAccessor] = (targetGapped[dirAccessor] > target[dirAccessor] ? -1 : 1) * gapOffset;
            }
        }
        // these are conditions for handling mixed handle positions like Right -> Bottom for example
        if (sourcePosition !== targetPosition) {
            const dirAccessorOpposite = dirAccessor === 'x' ? 'y' : 'x';
            const isSameDir = sourceDir[dirAccessor] === targetDir[dirAccessorOpposite];
            const sourceGtTargetOppo = sourceGapped[dirAccessorOpposite] > targetGapped[dirAccessorOpposite];
            const sourceLtTargetOppo = sourceGapped[dirAccessorOpposite] < targetGapped[dirAccessorOpposite];
            const flipSourceTarget = sourceDir[dirAccessor] === 1 && (!isSameDir && sourceGtTargetOppo || isSameDir && sourceLtTargetOppo) || sourceDir[dirAccessor] !== 1 && (!isSameDir && sourceLtTargetOppo || isSameDir && sourceGtTargetOppo);
            if (flipSourceTarget) points = dirAccessor === 'x' ? sourceTarget : targetSource;
        }
        const sourceGapPoint = {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        };
        const targetGapPoint = {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        };
        const maxXDistance = Math.max(Math.abs(sourceGapPoint.x - points[0].x), Math.abs(targetGapPoint.x - points[0].x));
        const maxYDistance = Math.max(Math.abs(sourceGapPoint.y - points[0].y), Math.abs(targetGapPoint.y - points[0].y));
        // we want to place the label on the longest segment of the edge
        if (maxXDistance >= maxYDistance) {
            centerX = (sourceGapPoint.x + targetGapPoint.x) / 2;
            centerY = points[0].y;
        } else {
            centerX = points[0].x;
            centerY = (sourceGapPoint.y + targetGapPoint.y) / 2;
        }
    }
    const pathPoints = [
        source,
        {
            x: sourceGapped.x + sourceGapOffset.x,
            y: sourceGapped.y + sourceGapOffset.y
        },
        ...points,
        {
            x: targetGapped.x + targetGapOffset.x,
            y: targetGapped.y + targetGapOffset.y
        },
        target
    ];
    return [
        pathPoints,
        centerX,
        centerY,
        defaultOffsetX,
        defaultOffsetY
    ];
}
function getBend(a, b, c, size) {
    const bendSize = Math.min(distance(a, b) / 2, distance(b, c) / 2, size);
    const { x, y } = b;
    // no bend
    if (a.x === x && x === c.x || a.y === y && y === c.y) return `L${x} ${y}`;
    // first segment is horizontal
    if (a.y === y) {
        const xDir = a.x < c.x ? -1 : 1;
        const yDir = a.y < c.y ? 1 : -1;
        return `L ${x + bendSize * xDir},${y}Q ${x},${y} ${x},${y + bendSize * yDir}`;
    }
    const xDir = a.x < c.x ? 1 : -1;
    const yDir = a.y < c.y ? -1 : 1;
    return `L ${x},${y + bendSize * yDir}Q ${x},${y} ${x + bendSize * xDir},${y}`;
}
function getSmoothStepPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top, borderRadius = 5, centerX, centerY, offset = 20 }) {
    const [points, labelX, labelY, offsetX, offsetY] = getPoints({
        source: {
            x: sourceX,
            y: sourceY
        },
        sourcePosition,
        target: {
            x: targetX,
            y: targetY
        },
        targetPosition,
        center: {
            x: centerX,
            y: centerY
        },
        offset
    });
    const path = points.reduce((res, p, i)=>{
        let segment = '';
        if (i > 0 && i < points.length - 1) segment = getBend(points[i - 1], p, points[i + 1], borderRadius);
        else segment = `${i === 0 ? 'M' : 'L'}${p.x} ${p.y}`;
        res += segment;
        return res;
    }, '');
    return [
        path,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const SmoothStepEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, sourcePosition = Position.Bottom, targetPosition = Position.Top, markerEnd, markerStart, pathOptions, interactionWidth })=>{
    const [path, labelX, labelY] = getSmoothStepPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        borderRadius: pathOptions === null || pathOptions === void 0 ? void 0 : pathOptions.borderRadius,
        offset: pathOptions === null || pathOptions === void 0 ? void 0 : pathOptions.offset
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
SmoothStepEdge.displayName = 'SmoothStepEdge';
const StepEdge = (0, _react.memo)((props)=>{
    var _props_pathOptions;
    return (0, _reactDefault.default).createElement(SmoothStepEdge, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        pathOptions: (0, _react.useMemo)(()=>{
            var _props_pathOptions;
            return {
                borderRadius: 0,
                offset: (_props_pathOptions = props.pathOptions) === null || _props_pathOptions === void 0 ? void 0 : _props_pathOptions.offset
            };
        }, [
            (_props_pathOptions = props.pathOptions) === null || _props_pathOptions === void 0 ? void 0 : _props_pathOptions.offset
        ])
    }));
});
StepEdge.displayName = 'StepEdge';
function getStraightPath({ sourceX, sourceY, targetX, targetY }) {
    const [labelX, labelY, offsetX, offsetY] = getEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY
    });
    return [
        `M ${sourceX},${sourceY}L ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const StraightEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, interactionWidth })=>{
    const [path, labelX, labelY] = getStraightPath({
        sourceX,
        sourceY,
        targetX,
        targetY
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
StraightEdge.displayName = 'StraightEdge';
function calculateControlOffset(distance, curvature) {
    if (distance >= 0) return 0.5 * distance;
    return curvature * 25 * Math.sqrt(-distance);
}
function getControlWithCurvature({ pos, x1, y1, x2, y2, c }) {
    switch(pos){
        case Position.Left:
            return [
                x1 - calculateControlOffset(x1 - x2, c),
                y1
            ];
        case Position.Right:
            return [
                x1 + calculateControlOffset(x2 - x1, c),
                y1
            ];
        case Position.Top:
            return [
                x1,
                y1 - calculateControlOffset(y1 - y2, c)
            ];
        case Position.Bottom:
            return [
                x1,
                y1 + calculateControlOffset(y2 - y1, c)
            ];
    }
}
function getBezierPath({ sourceX, sourceY, sourcePosition = Position.Bottom, targetX, targetY, targetPosition = Position.Top, curvature = 0.25 }) {
    const [sourceControlX, sourceControlY] = getControlWithCurvature({
        pos: sourcePosition,
        x1: sourceX,
        y1: sourceY,
        x2: targetX,
        y2: targetY,
        c: curvature
    });
    const [targetControlX, targetControlY] = getControlWithCurvature({
        pos: targetPosition,
        x1: targetX,
        y1: targetY,
        x2: sourceX,
        y2: sourceY,
        c: curvature
    });
    const [labelX, labelY, offsetX, offsetY] = getBezierEdgeCenter({
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourceControlX,
        sourceControlY,
        targetControlX,
        targetControlY
    });
    return [
        `M${sourceX},${sourceY} C${sourceControlX},${sourceControlY} ${targetControlX},${targetControlY} ${targetX},${targetY}`,
        labelX,
        labelY,
        offsetX,
        offsetY
    ];
}
const BezierEdge = (0, _react.memo)(({ sourceX, sourceY, targetX, targetY, sourcePosition = Position.Bottom, targetPosition = Position.Top, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, markerEnd, markerStart, pathOptions, interactionWidth })=>{
    const [path, labelX, labelY] = getBezierPath({
        sourceX,
        sourceY,
        sourcePosition,
        targetX,
        targetY,
        targetPosition,
        curvature: pathOptions === null || pathOptions === void 0 ? void 0 : pathOptions.curvature
    });
    return (0, _reactDefault.default).createElement(BaseEdge, {
        path: path,
        labelX: labelX,
        labelY: labelY,
        label: label,
        labelStyle: labelStyle,
        labelShowBg: labelShowBg,
        labelBgStyle: labelBgStyle,
        labelBgPadding: labelBgPadding,
        labelBgBorderRadius: labelBgBorderRadius,
        style: style,
        markerEnd: markerEnd,
        markerStart: markerStart,
        interactionWidth: interactionWidth
    });
});
BezierEdge.displayName = 'BezierEdge';
const NodeIdContext = (0, _react.createContext)(null);
const Provider = NodeIdContext.Provider;
NodeIdContext.Consumer;
const useNodeId = ()=>{
    const nodeId = (0, _react.useContext)(NodeIdContext);
    return nodeId;
};
const isEdge = (element)=>'id' in element && 'source' in element && 'target' in element;
const isNode = (element)=>'id' in element && !('source' in element) && !('target' in element);
const getOutgoers = (node, nodes, edges)=>{
    if (!isNode(node)) return [];
    const outgoerIds = edges.filter((e)=>e.source === node.id).map((e)=>e.target);
    return nodes.filter((n)=>outgoerIds.includes(n.id));
};
const getIncomers = (node, nodes, edges)=>{
    if (!isNode(node)) return [];
    const incomersIds = edges.filter((e)=>e.target === node.id).map((e)=>e.source);
    return nodes.filter((n)=>incomersIds.includes(n.id));
};
const getEdgeId = ({ source, sourceHandle, target, targetHandle })=>`reactflow__edge-${source}${sourceHandle || ''}-${target}${targetHandle || ''}`;
const getMarkerId = (marker, rfId)=>{
    if (typeof marker === 'undefined') return '';
    if (typeof marker === 'string') return marker;
    const idPrefix = rfId ? `${rfId}__` : '';
    return `${idPrefix}${Object.keys(marker).sort().map((key)=>`${key}=${marker[key]}`).join('&')}`;
};
const connectionExists = (edge, edges)=>{
    return edges.some((el)=>el.source === edge.source && el.target === edge.target && (el.sourceHandle === edge.sourceHandle || !el.sourceHandle && !edge.sourceHandle) && (el.targetHandle === edge.targetHandle || !el.targetHandle && !edge.targetHandle));
};
const addEdge = (edgeParams, edges)=>{
    if (!edgeParams.source || !edgeParams.target) {
        devWarn('006', errorMessages['error006']());
        return edges;
    }
    let edge;
    if (isEdge(edgeParams)) edge = (0, _objectSpread._)({}, edgeParams);
    else edge = (0, _objectSpreadProps._)((0, _objectSpread._)({}, edgeParams), {
        id: getEdgeId(edgeParams)
    });
    if (connectionExists(edge, edges)) return edges;
    return edges.concat(edge);
};
const reconnectEdge = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    const { id: oldEdgeId } = oldEdge, rest = (0, _objectWithoutProperties._)(oldEdge, [
        "id"
    ]);
    if (!newConnection.source || !newConnection.target) {
        devWarn('006', errorMessages['error006']());
        return edges;
    }
    const foundEdge = edges.find((e)=>e.id === oldEdgeId);
    if (!foundEdge) {
        devWarn('007', errorMessages['error007'](oldEdgeId));
        return edges;
    }
    // Remove old edge and create the new edge with parameters of old edge.
    const edge = (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        id: options.shouldReplaceId ? getEdgeId(newConnection) : oldEdgeId,
        source: newConnection.source,
        target: newConnection.target,
        sourceHandle: newConnection.sourceHandle,
        targetHandle: newConnection.targetHandle
    });
    return edges.filter((e)=>e.id !== oldEdgeId).concat(edge);
};
/**
 *
 * @deprecated Use `reconnectEdge` instead.
 */ const updateEdge = (oldEdge, newConnection, edges, options = {
    shouldReplaceId: true
})=>{
    console.warn('[DEPRECATED] `updateEdge` is deprecated. Instead use `reconnectEdge` https://reactflow.dev/api-reference/utils/reconnect-edge');
    return reconnectEdge(oldEdge, newConnection, edges, options);
};
const pointToRendererPoint = ({ x, y }, [tx, ty, tScale], snapToGrid, [snapX, snapY])=>{
    const position = {
        x: (x - tx) / tScale,
        y: (y - ty) / tScale
    };
    if (snapToGrid) return {
        x: snapX * Math.round(position.x / snapX),
        y: snapY * Math.round(position.y / snapY)
    };
    return position;
};
const rendererPointToPoint = ({ x, y }, [tx, ty, tScale])=>{
    return {
        x: x * tScale + tx,
        y: y * tScale + ty
    };
};
const getNodePositionWithOrigin = (node, nodeOrigin = [
    0,
    0
])=>{
    if (!node) return {
        x: 0,
        y: 0,
        positionAbsolute: {
            x: 0,
            y: 0
        }
    };
    var _node_width;
    const offsetX = ((_node_width = node.width) !== null && _node_width !== void 0 ? _node_width : 0) * nodeOrigin[0];
    var _node_height;
    const offsetY = ((_node_height = node.height) !== null && _node_height !== void 0 ? _node_height : 0) * nodeOrigin[1];
    const position = {
        x: node.position.x - offsetX,
        y: node.position.y - offsetY
    };
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, position), {
        positionAbsolute: node.positionAbsolute ? {
            x: node.positionAbsolute.x - offsetX,
            y: node.positionAbsolute.y - offsetY
        } : position
    });
};
const getNodesBounds = (nodes, nodeOrigin = [
    0,
    0
])=>{
    if (nodes.length === 0) return {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    const box = nodes.reduce((currBox, node)=>{
        const { x, y } = getNodePositionWithOrigin(node, nodeOrigin).positionAbsolute;
        return getBoundsOfBoxes(currBox, rectToBox({
            x,
            y,
            width: node.width || 0,
            height: node.height || 0
        }));
    }, {
        x: Infinity,
        y: Infinity,
        x2: -Infinity,
        y2: -Infinity
    });
    return boxToRect(box);
};
// @deprecated Use `getNodesBounds`.
const getRectOfNodes = (nodes, nodeOrigin = [
    0,
    0
])=>{
    console.warn('[DEPRECATED] `getRectOfNodes` is deprecated. Instead use `getNodesBounds` https://reactflow.dev/api-reference/utils/get-nodes-bounds.');
    return getNodesBounds(nodes, nodeOrigin);
};
const getNodesInside = (nodeInternals, rect, [tx, ty, tScale] = [
    0,
    0,
    1
], partially = false, // set excludeNonSelectableNodes if you want to pay attention to the nodes "selectable" attribute
excludeNonSelectableNodes = false, nodeOrigin = [
    0,
    0
])=>{
    const paneRect = {
        x: (rect.x - tx) / tScale,
        y: (rect.y - ty) / tScale,
        width: rect.width / tScale,
        height: rect.height / tScale
    };
    const visibleNodes = [];
    nodeInternals.forEach((node)=>{
        const { width, height, selectable = true, hidden = false } = node;
        if (excludeNonSelectableNodes && !selectable || hidden) return false;
        const { positionAbsolute } = getNodePositionWithOrigin(node, nodeOrigin);
        const nodeRect = {
            x: positionAbsolute.x,
            y: positionAbsolute.y,
            width: width || 0,
            height: height || 0
        };
        const overlappingArea = getOverlappingArea(paneRect, nodeRect);
        const notInitialized = typeof width === 'undefined' || typeof height === 'undefined' || width === null || height === null;
        const partiallyVisible = partially && overlappingArea > 0;
        const area = (width || 0) * (height || 0);
        const isVisible = notInitialized || partiallyVisible || overlappingArea >= area;
        if (isVisible || node.dragging) visibleNodes.push(node);
    });
    return visibleNodes;
};
const getConnectedEdges = (nodes, edges)=>{
    const nodeIds = nodes.map((node)=>node.id);
    return edges.filter((edge)=>nodeIds.includes(edge.source) || nodeIds.includes(edge.target));
};
// @deprecated Use `getViewportForBounds`.
const getTransformForBounds = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const { x, y, zoom } = getViewportForBounds(bounds, width, height, minZoom, maxZoom, padding);
    console.warn('[DEPRECATED] `getTransformForBounds` is deprecated. Instead use `getViewportForBounds`. Beware that the return value is type Viewport (`{ x: number, y: number, zoom: number }`) instead of Transform (`[number, number, number]`). https://reactflow.dev/api-reference/utils/get-viewport-for-bounds');
    return [
        x,
        y,
        zoom
    ];
};
const getViewportForBounds = (bounds, width, height, minZoom, maxZoom, padding = 0.1)=>{
    const xZoom = width / (bounds.width * (1 + padding));
    const yZoom = height / (bounds.height * (1 + padding));
    const zoom = Math.min(xZoom, yZoom);
    const clampedZoom = clamp(zoom, minZoom, maxZoom);
    const boundsCenterX = bounds.x + bounds.width / 2;
    const boundsCenterY = bounds.y + bounds.height / 2;
    const x = width / 2 - boundsCenterX * clampedZoom;
    const y = height / 2 - boundsCenterY * clampedZoom;
    return {
        x,
        y,
        zoom: clampedZoom
    };
};
const getD3Transition = (selection, duration = 0)=>{
    return selection.transition().duration(duration);
};
// this functions collects all handles and adds an absolute position
// so that we can later find the closest handle to the mouse position
function getHandles(node, handleBounds, type, currentHandle) {
    return (handleBounds[type] || []).reduce((res, h)=>{
        var _node_positionAbsolute, _node_positionAbsolute1;
        var _node_positionAbsolute_x, _node_positionAbsolute_y;
        if (`${node.id}-${h.id}-${type}` !== currentHandle) res.push({
            id: h.id || null,
            type,
            nodeId: node.id,
            x: ((_node_positionAbsolute_x = (_node_positionAbsolute = node.positionAbsolute) === null || _node_positionAbsolute === void 0 ? void 0 : _node_positionAbsolute.x) !== null && _node_positionAbsolute_x !== void 0 ? _node_positionAbsolute_x : 0) + h.x + h.width / 2,
            y: ((_node_positionAbsolute_y = (_node_positionAbsolute1 = node.positionAbsolute) === null || _node_positionAbsolute1 === void 0 ? void 0 : _node_positionAbsolute1.y) !== null && _node_positionAbsolute_y !== void 0 ? _node_positionAbsolute_y : 0) + h.y + h.height / 2
        });
        return res;
    }, []);
}
function getClosestHandle(event, doc, pos, connectionRadius, handles, validator) {
    // we always want to prioritize the handle below the mouse cursor over the closest distance handle,
    // because it could be that the center of another handle is closer to the mouse pointer than the handle below the cursor
    const { x, y } = getEventPosition(event);
    const domNodes = doc.elementsFromPoint(x, y);
    const handleBelow = domNodes.find((el)=>el.classList.contains('react-flow__handle'));
    if (handleBelow) {
        const handleNodeId = handleBelow.getAttribute('data-nodeid');
        if (handleNodeId) {
            const handleType = getHandleType(undefined, handleBelow);
            const handleId = handleBelow.getAttribute('data-handleid');
            const validHandleResult = validator({
                nodeId: handleNodeId,
                id: handleId,
                type: handleType
            });
            if (validHandleResult) {
                const handle = handles.find((h)=>h.nodeId === handleNodeId && h.type === handleType && h.id === handleId);
                return {
                    handle: {
                        id: handleId,
                        type: handleType,
                        nodeId: handleNodeId,
                        x: (handle === null || handle === void 0 ? void 0 : handle.x) || pos.x,
                        y: (handle === null || handle === void 0 ? void 0 : handle.y) || pos.y
                    },
                    validHandleResult
                };
            }
        }
    }
    // if we couldn't find a handle below the mouse cursor we look for the closest distance based on the connectionRadius
    let closestHandles = [];
    let minDistance = Infinity;
    handles.forEach((handle)=>{
        const distance = Math.sqrt((handle.x - pos.x) ** 2 + (handle.y - pos.y) ** 2);
        if (distance <= connectionRadius) {
            const validHandleResult = validator(handle);
            if (distance <= minDistance) {
                if (distance < minDistance) closestHandles = [
                    {
                        handle,
                        validHandleResult
                    }
                ];
                else if (distance === minDistance) // when multiple handles are on the same distance we collect all of them
                closestHandles.push({
                    handle,
                    validHandleResult
                });
                minDistance = distance;
            }
        }
    });
    if (!closestHandles.length) return {
        handle: null,
        validHandleResult: defaultResult()
    };
    if (closestHandles.length === 1) return closestHandles[0];
    const hasValidHandle = closestHandles.some(({ validHandleResult })=>validHandleResult.isValid);
    const hasTargetHandle = closestHandles.some(({ handle })=>handle.type === 'target');
    // if multiple handles are layouted on top of each other we prefer the one with type = target and the one that is valid
    return closestHandles.find(({ handle, validHandleResult })=>hasTargetHandle ? handle.type === 'target' : hasValidHandle ? validHandleResult.isValid : true) || closestHandles[0];
}
const nullConnection = {
    source: null,
    target: null,
    sourceHandle: null,
    targetHandle: null
};
const defaultResult = ()=>({
        handleDomNode: null,
        isValid: false,
        connection: nullConnection,
        endHandle: null
    });
// checks if  and returns connection in fom of an object { source: 123, target: 312 }
function isValidHandle(handle, connectionMode, fromNodeId, fromHandleId, fromType, isValidConnection, doc) {
    const isTarget = fromType === 'target';
    const handleToCheck = doc.querySelector(`.react-flow__handle[data-id="${handle === null || handle === void 0 ? void 0 : handle.nodeId}-${handle === null || handle === void 0 ? void 0 : handle.id}-${handle === null || handle === void 0 ? void 0 : handle.type}"]`);
    const result = (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultResult()), {
        handleDomNode: handleToCheck
    });
    if (handleToCheck) {
        const handleType = getHandleType(undefined, handleToCheck);
        const handleNodeId = handleToCheck.getAttribute('data-nodeid');
        const handleId = handleToCheck.getAttribute('data-handleid');
        const connectable = handleToCheck.classList.contains('connectable');
        const connectableEnd = handleToCheck.classList.contains('connectableend');
        const connection = {
            source: isTarget ? handleNodeId : fromNodeId,
            sourceHandle: isTarget ? handleId : fromHandleId,
            target: isTarget ? fromNodeId : handleNodeId,
            targetHandle: isTarget ? fromHandleId : handleId
        };
        result.connection = connection;
        const isConnectable = connectable && connectableEnd;
        // in strict mode we don't allow target to target or source to source connections
        const isValid = isConnectable && (connectionMode === ConnectionMode.Strict ? isTarget && handleType === 'source' || !isTarget && handleType === 'target' : handleNodeId !== fromNodeId || handleId !== fromHandleId);
        if (isValid) {
            result.endHandle = {
                nodeId: handleNodeId,
                handleId,
                type: handleType
            };
            result.isValid = isValidConnection(connection);
        }
    }
    return result;
}
function getHandleLookup({ nodes, nodeId, handleId, handleType }) {
    return nodes.reduce((res, node)=>{
        if (node[internalsSymbol]) {
            const { handleBounds } = node[internalsSymbol];
            let sourceHandles = [];
            let targetHandles = [];
            if (handleBounds) {
                sourceHandles = getHandles(node, handleBounds, 'source', `${nodeId}-${handleId}-${handleType}`);
                targetHandles = getHandles(node, handleBounds, 'target', `${nodeId}-${handleId}-${handleType}`);
            }
            res.push(...sourceHandles, ...targetHandles);
        }
        return res;
    }, []);
}
function getHandleType(edgeUpdaterType, handleDomNode) {
    if (edgeUpdaterType) return edgeUpdaterType;
    else if (handleDomNode === null || handleDomNode === void 0 ? void 0 : handleDomNode.classList.contains('target')) return 'target';
    else if (handleDomNode === null || handleDomNode === void 0 ? void 0 : handleDomNode.classList.contains('source')) return 'source';
    return null;
}
function resetRecentHandle(handleDomNode) {
    handleDomNode === null || handleDomNode === void 0 ? void 0 : handleDomNode.classList.remove('valid', 'connecting', 'react-flow__handle-valid', 'react-flow__handle-connecting');
}
function getConnectionStatus(isInsideConnectionRadius, isHandleValid) {
    let connectionStatus = null;
    if (isHandleValid) connectionStatus = 'valid';
    else if (isInsideConnectionRadius && !isHandleValid) connectionStatus = 'invalid';
    return connectionStatus;
}
function handlePointerDown({ event, handleId, nodeId, onConnect, isTarget, getState, setState, isValidConnection, edgeUpdaterType, onReconnectEnd }) {
    // when react-flow is used inside a shadow root we can't use document
    const doc = getHostForElement(event.target);
    const { connectionMode, domNode, autoPanOnConnect, connectionRadius, onConnectStart, panBy, getNodes, cancelConnection } = getState();
    let autoPanId = 0;
    let closestHandle;
    const { x, y } = getEventPosition(event);
    const clickedHandle = doc === null || doc === void 0 ? void 0 : doc.elementFromPoint(x, y);
    const handleType = getHandleType(edgeUpdaterType, clickedHandle);
    const containerBounds = domNode === null || domNode === void 0 ? void 0 : domNode.getBoundingClientRect();
    if (!containerBounds || !handleType) return;
    let prevActiveHandle;
    let connectionPosition = getEventPosition(event, containerBounds);
    let autoPanStarted = false;
    let connection = null;
    let isValid = false;
    let handleDomNode = null;
    const handleLookup = getHandleLookup({
        nodes: getNodes(),
        nodeId,
        handleId,
        handleType
    });
    // when the user is moving the mouse close to the edge of the canvas while connecting we move the canvas
    const autoPan = ()=>{
        if (!autoPanOnConnect) return;
        const [xMovement, yMovement] = calcAutoPan(connectionPosition, containerBounds);
        panBy({
            x: xMovement,
            y: yMovement
        });
        autoPanId = requestAnimationFrame(autoPan);
    };
    setState({
        connectionPosition,
        connectionStatus: null,
        // connectionNodeId etc will be removed in the next major in favor of connectionStartHandle
        connectionNodeId: nodeId,
        connectionHandleId: handleId,
        connectionHandleType: handleType,
        connectionStartHandle: {
            nodeId,
            handleId,
            type: handleType
        },
        connectionEndHandle: null
    });
    onConnectStart === null || onConnectStart === void 0 ? void 0 : onConnectStart(event, {
        nodeId,
        handleId,
        handleType
    });
    function onPointerMove(event) {
        const { transform } = getState();
        connectionPosition = getEventPosition(event, containerBounds);
        const { handle, validHandleResult } = getClosestHandle(event, doc, pointToRendererPoint(connectionPosition, transform, false, [
            1,
            1
        ]), connectionRadius, handleLookup, (handle)=>isValidHandle(handle, connectionMode, nodeId, handleId, isTarget ? 'target' : 'source', isValidConnection, doc));
        closestHandle = handle;
        if (!autoPanStarted) {
            autoPan();
            autoPanStarted = true;
        }
        handleDomNode = validHandleResult.handleDomNode;
        connection = validHandleResult.connection;
        isValid = validHandleResult.isValid;
        setState({
            connectionPosition: closestHandle && isValid ? rendererPointToPoint({
                x: closestHandle.x,
                y: closestHandle.y
            }, transform) : connectionPosition,
            connectionStatus: getConnectionStatus(!!closestHandle, isValid),
            connectionEndHandle: validHandleResult.endHandle
        });
        if (!closestHandle && !isValid && !handleDomNode) return resetRecentHandle(prevActiveHandle);
        if (connection.source !== connection.target && handleDomNode) {
            resetRecentHandle(prevActiveHandle);
            prevActiveHandle = handleDomNode;
            // @todo: remove the old class names "react-flow__handle-" in the next major version
            handleDomNode.classList.add('connecting', 'react-flow__handle-connecting');
            handleDomNode.classList.toggle('valid', isValid);
            handleDomNode.classList.toggle('react-flow__handle-valid', isValid);
        }
    }
    function onPointerUp(event) {
        var // it's important to get a fresh reference from the store here
        // in order to get the latest state of onConnectEnd
        _getState_onConnectEnd, _getState;
        if ((closestHandle || handleDomNode) && connection && isValid) onConnect === null || onConnect === void 0 ? void 0 : onConnect(connection);
        (_getState_onConnectEnd = (_getState = getState()).onConnectEnd) === null || _getState_onConnectEnd === void 0 ? void 0 : _getState_onConnectEnd.call(_getState, event);
        if (edgeUpdaterType) onReconnectEnd === null || onReconnectEnd === void 0 ? void 0 : onReconnectEnd(event);
        resetRecentHandle(prevActiveHandle);
        cancelConnection();
        cancelAnimationFrame(autoPanId);
        autoPanStarted = false;
        isValid = false;
        connection = null;
        handleDomNode = null;
        doc.removeEventListener('mousemove', onPointerMove);
        doc.removeEventListener('mouseup', onPointerUp);
        doc.removeEventListener('touchmove', onPointerMove);
        doc.removeEventListener('touchend', onPointerUp);
    }
    doc.addEventListener('mousemove', onPointerMove);
    doc.addEventListener('mouseup', onPointerUp);
    doc.addEventListener('touchmove', onPointerMove);
    doc.addEventListener('touchend', onPointerUp);
}
const alwaysValid = ()=>true;
const selector$f = (s)=>({
        connectionStartHandle: s.connectionStartHandle,
        connectOnClick: s.connectOnClick,
        noPanClassName: s.noPanClassName
    });
const connectingSelector = (nodeId, handleId, type)=>(state)=>{
        const { connectionStartHandle: startHandle, connectionEndHandle: endHandle, connectionClickStartHandle: clickHandle } = state;
        return {
            connecting: (startHandle === null || startHandle === void 0 ? void 0 : startHandle.nodeId) === nodeId && (startHandle === null || startHandle === void 0 ? void 0 : startHandle.handleId) === handleId && (startHandle === null || startHandle === void 0 ? void 0 : startHandle.type) === type || (endHandle === null || endHandle === void 0 ? void 0 : endHandle.nodeId) === nodeId && (endHandle === null || endHandle === void 0 ? void 0 : endHandle.handleId) === handleId && (endHandle === null || endHandle === void 0 ? void 0 : endHandle.type) === type,
            clickConnecting: (clickHandle === null || clickHandle === void 0 ? void 0 : clickHandle.nodeId) === nodeId && (clickHandle === null || clickHandle === void 0 ? void 0 : clickHandle.handleId) === handleId && (clickHandle === null || clickHandle === void 0 ? void 0 : clickHandle.type) === type
        };
    };
const Handle = (0, _react.forwardRef)((_param, ref)=>{
    var { type = 'source', position = Position.Top, isValidConnection, isConnectable = true, isConnectableStart = true, isConnectableEnd = true, id, onConnect, children, className, onMouseDown, onTouchStart } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "type",
        "position",
        "isValidConnection",
        "isConnectable",
        "isConnectableStart",
        "isConnectableEnd",
        "id",
        "onConnect",
        "children",
        "className",
        "onMouseDown",
        "onTouchStart"
    ]);
    var _store_getState_onError, _store_getState;
    const handleId = id || null;
    const isTarget = type === 'target';
    const store = useStoreApi();
    const nodeId = useNodeId();
    const { connectOnClick, noPanClassName } = useStore(selector$f, (0, _shallow.shallow));
    const { connecting, clickConnecting } = useStore(connectingSelector(nodeId, handleId, type), (0, _shallow.shallow));
    if (!nodeId) (_store_getState_onError = (_store_getState = store.getState()).onError) === null || _store_getState_onError === void 0 ? void 0 : _store_getState_onError.call(_store_getState, '010', errorMessages['error010']());
    const onConnectExtended = (params)=>{
        const { defaultEdgeOptions, onConnect: onConnectAction, hasDefaultEdges } = store.getState();
        const edgeParams = (0, _objectSpread._)({}, defaultEdgeOptions, params);
        if (hasDefaultEdges) {
            const { edges, setEdges } = store.getState();
            setEdges(addEdge(edgeParams, edges));
        }
        onConnectAction === null || onConnectAction === void 0 ? void 0 : onConnectAction(edgeParams);
        onConnect === null || onConnect === void 0 ? void 0 : onConnect(edgeParams);
    };
    const onPointerDown = (event)=>{
        if (!nodeId) return;
        const isMouseTriggered = isMouseEvent(event);
        if (isConnectableStart && (isMouseTriggered && event.button === 0 || !isMouseTriggered)) handlePointerDown({
            event,
            handleId,
            nodeId,
            onConnect: onConnectExtended,
            isTarget,
            getState: store.getState,
            setState: store.setState,
            isValidConnection: isValidConnection || store.getState().isValidConnection || alwaysValid
        });
        if (isMouseTriggered) onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(event);
        else onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(event);
    };
    const onClick = (event)=>{
        const { onClickConnectStart, onClickConnectEnd, connectionClickStartHandle, connectionMode, isValidConnection: isValidConnectionStore } = store.getState();
        if (!nodeId || !connectionClickStartHandle && !isConnectableStart) return;
        if (!connectionClickStartHandle) {
            onClickConnectStart === null || onClickConnectStart === void 0 ? void 0 : onClickConnectStart(event, {
                nodeId,
                handleId,
                handleType: type
            });
            store.setState({
                connectionClickStartHandle: {
                    nodeId,
                    type,
                    handleId
                }
            });
            return;
        }
        const doc = getHostForElement(event.target);
        const isValidConnectionHandler = isValidConnection || isValidConnectionStore || alwaysValid;
        const { connection, isValid } = isValidHandle({
            nodeId,
            id: handleId,
            type
        }, connectionMode, connectionClickStartHandle.nodeId, connectionClickStartHandle.handleId || null, connectionClickStartHandle.type, isValidConnectionHandler, doc);
        if (isValid) onConnectExtended(connection);
        onClickConnectEnd === null || onClickConnectEnd === void 0 ? void 0 : onClickConnectEnd(event);
        store.setState({
            connectionClickStartHandle: null
        });
    };
    return (0, _reactDefault.default).createElement("div", (0, _objectSpread._)({
        "data-handleid": handleId,
        "data-nodeid": nodeId,
        "data-handlepos": position,
        "data-id": `${nodeId}-${handleId}-${type}`,
        className: (0, _classcatDefault.default)([
            'react-flow__handle',
            `react-flow__handle-${position}`,
            'nodrag',
            noPanClassName,
            className,
            {
                source: !isTarget,
                target: isTarget,
                connectable: isConnectable,
                connectablestart: isConnectableStart,
                connectableend: isConnectableEnd,
                connecting: clickConnecting,
                // this class is used to style the handle when the user is connecting
                connectionindicator: isConnectable && (isConnectableStart && !connecting || isConnectableEnd && connecting)
            }
        ]),
        onMouseDown: onPointerDown,
        onTouchStart: onPointerDown,
        onClick: connectOnClick ? onClick : undefined,
        ref: ref
    }, rest), children);
});
Handle.displayName = 'Handle';
var Handle$1 = (0, _react.memo)(Handle);
const DefaultNode = ({ data, isConnectable, targetPosition = Position.Top, sourcePosition = Position.Bottom })=>{
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Handle$1, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data === null || data === void 0 ? void 0 : data.label, (0, _reactDefault.default).createElement(Handle$1, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
};
DefaultNode.displayName = 'DefaultNode';
var DefaultNode$1 = (0, _react.memo)(DefaultNode);
const InputNode = ({ data, isConnectable, sourcePosition = Position.Bottom })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, data === null || data === void 0 ? void 0 : data.label, (0, _reactDefault.default).createElement(Handle$1, {
        type: "source",
        position: sourcePosition,
        isConnectable: isConnectable
    }));
InputNode.displayName = 'InputNode';
var InputNode$1 = (0, _react.memo)(InputNode);
const OutputNode = ({ data, isConnectable, targetPosition = Position.Top })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Handle$1, {
        type: "target",
        position: targetPosition,
        isConnectable: isConnectable
    }), data === null || data === void 0 ? void 0 : data.label);
OutputNode.displayName = 'OutputNode';
var OutputNode$1 = (0, _react.memo)(OutputNode);
const GroupNode = ()=>null;
GroupNode.displayName = 'GroupNode';
const selector$e = (s)=>({
        selectedNodes: s.getNodes().filter((n)=>n.selected),
        selectedEdges: s.edges.filter((e)=>e.selected).map((e)=>(0, _objectSpread._)({}, e))
    });
const selectId = (obj)=>obj.id;
function areEqual(a, b) {
    return (0, _shallow.shallow)(a.selectedNodes.map(selectId), b.selectedNodes.map(selectId)) && (0, _shallow.shallow)(a.selectedEdges.map(selectId), b.selectedEdges.map(selectId));
}
// This is just a helper component for calling the onSelectionChange listener.
// @TODO: Now that we have the onNodesChange and on EdgesChange listeners, do we still need this component?
const SelectionListener = (0, _react.memo)(({ onSelectionChange })=>{
    const store = useStoreApi();
    const { selectedNodes, selectedEdges } = useStore(selector$e, areEqual);
    (0, _react.useEffect)(()=>{
        const params = {
            nodes: selectedNodes,
            edges: selectedEdges
        };
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(params);
        store.getState().onSelectionChange.forEach((fn)=>fn(params));
    }, [
        selectedNodes,
        selectedEdges,
        onSelectionChange
    ]);
    return null;
});
SelectionListener.displayName = 'SelectionListener';
const changeSelector = (s)=>!!s.onSelectionChange;
function Wrapper$1({ onSelectionChange }) {
    const storeHasSelectionChange = useStore(changeSelector);
    if (onSelectionChange || storeHasSelectionChange) return (0, _reactDefault.default).createElement(SelectionListener, {
        onSelectionChange: onSelectionChange
    });
    return null;
}
const selector$d = (s)=>({
        setNodes: s.setNodes,
        setEdges: s.setEdges,
        setDefaultNodesAndEdges: s.setDefaultNodesAndEdges,
        setMinZoom: s.setMinZoom,
        setMaxZoom: s.setMaxZoom,
        setTranslateExtent: s.setTranslateExtent,
        setNodeExtent: s.setNodeExtent,
        reset: s.reset
    });
function useStoreUpdater(value, setStoreState) {
    (0, _react.useEffect)(()=>{
        if (typeof value !== 'undefined') setStoreState(value);
    }, [
        value
    ]);
}
// updates with values in store that don't have a dedicated setter function
function useDirectStoreUpdater(key, value, setState) {
    (0, _react.useEffect)(()=>{
        if (typeof value !== 'undefined') setState({
            [key]: value
        });
    }, [
        value
    ]);
}
const StoreUpdater = ({ nodes, edges, defaultNodes, defaultEdges, onConnect, onConnectStart, onConnectEnd, onClickConnectStart, onClickConnectEnd, nodesDraggable, nodesConnectable, nodesFocusable, edgesFocusable, edgesUpdatable, elevateNodesOnSelect, minZoom, maxZoom, nodeExtent, onNodesChange, onEdgesChange, elementsSelectable, connectionMode, snapGrid, snapToGrid, translateExtent, connectOnClick, defaultEdgeOptions, fitView, fitViewOptions, onNodesDelete, onEdgesDelete, onNodeDrag, onNodeDragStart, onNodeDragStop, onSelectionDrag, onSelectionDragStart, onSelectionDragStop, noPanClassName, nodeOrigin, rfId, autoPanOnConnect, autoPanOnNodeDrag, onError, connectionRadius, isValidConnection, nodeDragThreshold })=>{
    const { setNodes, setEdges, setDefaultNodesAndEdges, setMinZoom, setMaxZoom, setTranslateExtent, setNodeExtent, reset } = useStore(selector$d, (0, _shallow.shallow));
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        const edgesWithDefaults = defaultEdges === null || defaultEdges === void 0 ? void 0 : defaultEdges.map((e)=>(0, _objectSpread._)({}, e, defaultEdgeOptions));
        setDefaultNodesAndEdges(defaultNodes, edgesWithDefaults);
        return ()=>{
            reset();
        };
    }, []);
    useDirectStoreUpdater('defaultEdgeOptions', defaultEdgeOptions, store.setState);
    useDirectStoreUpdater('connectionMode', connectionMode, store.setState);
    useDirectStoreUpdater('onConnect', onConnect, store.setState);
    useDirectStoreUpdater('onConnectStart', onConnectStart, store.setState);
    useDirectStoreUpdater('onConnectEnd', onConnectEnd, store.setState);
    useDirectStoreUpdater('onClickConnectStart', onClickConnectStart, store.setState);
    useDirectStoreUpdater('onClickConnectEnd', onClickConnectEnd, store.setState);
    useDirectStoreUpdater('nodesDraggable', nodesDraggable, store.setState);
    useDirectStoreUpdater('nodesConnectable', nodesConnectable, store.setState);
    useDirectStoreUpdater('nodesFocusable', nodesFocusable, store.setState);
    useDirectStoreUpdater('edgesFocusable', edgesFocusable, store.setState);
    useDirectStoreUpdater('edgesUpdatable', edgesUpdatable, store.setState);
    useDirectStoreUpdater('elementsSelectable', elementsSelectable, store.setState);
    useDirectStoreUpdater('elevateNodesOnSelect', elevateNodesOnSelect, store.setState);
    useDirectStoreUpdater('snapToGrid', snapToGrid, store.setState);
    useDirectStoreUpdater('snapGrid', snapGrid, store.setState);
    useDirectStoreUpdater('onNodesChange', onNodesChange, store.setState);
    useDirectStoreUpdater('onEdgesChange', onEdgesChange, store.setState);
    useDirectStoreUpdater('connectOnClick', connectOnClick, store.setState);
    useDirectStoreUpdater('fitViewOnInit', fitView, store.setState);
    useDirectStoreUpdater('fitViewOnInitOptions', fitViewOptions, store.setState);
    useDirectStoreUpdater('onNodesDelete', onNodesDelete, store.setState);
    useDirectStoreUpdater('onEdgesDelete', onEdgesDelete, store.setState);
    useDirectStoreUpdater('onNodeDrag', onNodeDrag, store.setState);
    useDirectStoreUpdater('onNodeDragStart', onNodeDragStart, store.setState);
    useDirectStoreUpdater('onNodeDragStop', onNodeDragStop, store.setState);
    useDirectStoreUpdater('onSelectionDrag', onSelectionDrag, store.setState);
    useDirectStoreUpdater('onSelectionDragStart', onSelectionDragStart, store.setState);
    useDirectStoreUpdater('onSelectionDragStop', onSelectionDragStop, store.setState);
    useDirectStoreUpdater('noPanClassName', noPanClassName, store.setState);
    useDirectStoreUpdater('nodeOrigin', nodeOrigin, store.setState);
    useDirectStoreUpdater('rfId', rfId, store.setState);
    useDirectStoreUpdater('autoPanOnConnect', autoPanOnConnect, store.setState);
    useDirectStoreUpdater('autoPanOnNodeDrag', autoPanOnNodeDrag, store.setState);
    useDirectStoreUpdater('onError', onError, store.setState);
    useDirectStoreUpdater('connectionRadius', connectionRadius, store.setState);
    useDirectStoreUpdater('isValidConnection', isValidConnection, store.setState);
    useDirectStoreUpdater('nodeDragThreshold', nodeDragThreshold, store.setState);
    useStoreUpdater(nodes, setNodes);
    useStoreUpdater(edges, setEdges);
    useStoreUpdater(minZoom, setMinZoom);
    useStoreUpdater(maxZoom, setMaxZoom);
    useStoreUpdater(translateExtent, setTranslateExtent);
    useStoreUpdater(nodeExtent, setNodeExtent);
    return null;
};
const style = {
    display: 'none'
};
const ariaLiveStyle = {
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0px, 0px, 0px, 0px)',
    clipPath: 'inset(100%)'
};
const ARIA_NODE_DESC_KEY = 'react-flow__node-desc';
const ARIA_EDGE_DESC_KEY = 'react-flow__edge-desc';
const ARIA_LIVE_MESSAGE = 'react-flow__aria-live';
const selector$c = (s)=>s.ariaLiveMessage;
function AriaLiveMessage({ rfId }) {
    const ariaLiveMessage = useStore(selector$c);
    return (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_LIVE_MESSAGE}-${rfId}`,
        "aria-live": "assertive",
        "aria-atomic": "true",
        style: ariaLiveStyle
    }, ariaLiveMessage);
}
function A11yDescriptions({ rfId, disableKeyboardA11y }) {
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_NODE_DESC_KEY}-${rfId}`,
        style: style
    }, "Press enter or space to select a node.", !disableKeyboardA11y && 'You can then use the arrow keys to move the node around.', " Press delete to remove it and escape to cancel.", ' '), (0, _reactDefault.default).createElement("div", {
        id: `${ARIA_EDGE_DESC_KEY}-${rfId}`,
        style: style
    }, "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel."), !disableKeyboardA11y && (0, _reactDefault.default).createElement(AriaLiveMessage, {
        rfId: rfId
    }));
}
// the keycode can be a string 'a' or an array of strings ['a', 'a+d']
// a string means a single key 'a' or a combination when '+' is used 'a+d'
// an array means different possibilities. Explainer: ['a', 'd+s'] here the
// user can use the single key 'a' or the combination 'd' + 's'
var useKeyPress = (keyCode = null, options = {
    actInsideInputWithModifier: true
})=>{
    const [keyPressed, setKeyPressed] = (0, _react.useState)(false);
    // we need to remember if a modifier key is pressed in order to track it
    const modifierPressed = (0, _react.useRef)(false);
    // we need to remember the pressed keys in order to support combinations
    const pressedKeys = (0, _react.useRef)(new Set([]));
    // keyCodes = array with single keys [['a']] or key combinations [['a', 's']]
    // keysToWatch = array with all keys flattened ['a', 'd', 'ShiftLeft']
    // used to check if we store event.code or event.key. When the code is in the list of keysToWatch
    // we use the code otherwise the key. Explainer: When you press the left "command" key, the code is "MetaLeft"
    // and the key is "Meta". We want users to be able to pass keys and codes so we assume that the key is meant when
    // we can't find it in the list of keysToWatch.
    const [keyCodes, keysToWatch] = (0, _react.useMemo)(()=>{
        if (keyCode !== null) {
            const keyCodeArr = Array.isArray(keyCode) ? keyCode : [
                keyCode
            ];
            const keys = keyCodeArr.filter((kc)=>typeof kc === 'string').map((kc)=>kc.split('+'));
            const keysFlat = keys.reduce((res, item)=>res.concat(...item), []);
            return [
                keys,
                keysFlat
            ];
        }
        return [
            [],
            []
        ];
    }, [
        keyCode
    ]);
    (0, _react.useEffect)(()=>{
        const doc = typeof document !== 'undefined' ? document : null;
        const target = (options === null || options === void 0 ? void 0 : options.target) || doc;
        if (keyCode !== null) {
            const downHandler = (event)=>{
                modifierPressed.current = event.ctrlKey || event.metaKey || event.shiftKey;
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = useKeyOrCode(event.code, keysToWatch);
                pressedKeys.current.add(event[keyOrCode]);
                if (isMatchingKey(keyCodes, pressedKeys.current, false)) {
                    event.preventDefault();
                    setKeyPressed(true);
                }
            };
            const upHandler = (event)=>{
                const preventAction = (!modifierPressed.current || modifierPressed.current && !options.actInsideInputWithModifier) && isInputDOMNode(event);
                if (preventAction) return false;
                const keyOrCode = useKeyOrCode(event.code, keysToWatch);
                if (isMatchingKey(keyCodes, pressedKeys.current, true)) {
                    setKeyPressed(false);
                    pressedKeys.current.clear();
                } else pressedKeys.current.delete(event[keyOrCode]);
                // fix for Mac: when cmd key is pressed, keyup is not triggered for any other key, see: https://stackoverflow.com/questions/27380018/when-cmd-key-is-kept-pressed-keyup-is-not-triggered-for-any-other-key
                if (event.key === 'Meta') pressedKeys.current.clear();
                modifierPressed.current = false;
            };
            const resetHandler = ()=>{
                pressedKeys.current.clear();
                setKeyPressed(false);
            };
            target === null || target === void 0 ? void 0 : target.addEventListener('keydown', downHandler);
            target === null || target === void 0 ? void 0 : target.addEventListener('keyup', upHandler);
            window.addEventListener('blur', resetHandler);
            return ()=>{
                target === null || target === void 0 ? void 0 : target.removeEventListener('keydown', downHandler);
                target === null || target === void 0 ? void 0 : target.removeEventListener('keyup', upHandler);
                window.removeEventListener('blur', resetHandler);
            };
        }
    }, [
        keyCode,
        setKeyPressed
    ]);
    return keyPressed;
};
// utils
function isMatchingKey(keyCodes, pressedKeys, isUp) {
    return keyCodes// we only want to compare same sizes of keyCode definitions
    // and pressed keys. When the user specified 'Meta' as a key somewhere
    // this would also be truthy without this filter when user presses 'Meta' + 'r'
    .filter((keys)=>isUp || keys.length === pressedKeys.size)// since we want to support multiple possibilities only one of the
    // combinations need to be part of the pressed keys
    .some((keys)=>keys.every((k)=>pressedKeys.has(k)));
}
function useKeyOrCode(eventCode, keysToWatch) {
    return keysToWatch.includes(eventCode) ? 'code' : 'key';
}
function calculateXYZPosition(node, nodeInternals, result, nodeOrigin) {
    var _parentNode_internalsSymbol, _parentNode_internalsSymbol1;
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return result;
    const parentNode = nodeInternals.get(parentId);
    const parentNodePosition = getNodePositionWithOrigin(parentNode, nodeOrigin);
    var _result_x, _result_y, _parentNode_internalsSymbol_z, _result_z, _parentNode_internalsSymbol_z1, _result_z1;
    return calculateXYZPosition(parentNode, nodeInternals, {
        x: ((_result_x = result.x) !== null && _result_x !== void 0 ? _result_x : 0) + parentNodePosition.x,
        y: ((_result_y = result.y) !== null && _result_y !== void 0 ? _result_y : 0) + parentNodePosition.y,
        z: ((_parentNode_internalsSymbol_z = (_parentNode_internalsSymbol = parentNode[internalsSymbol]) === null || _parentNode_internalsSymbol === void 0 ? void 0 : _parentNode_internalsSymbol.z) !== null && _parentNode_internalsSymbol_z !== void 0 ? _parentNode_internalsSymbol_z : 0) > ((_result_z = result.z) !== null && _result_z !== void 0 ? _result_z : 0) ? (_parentNode_internalsSymbol_z1 = (_parentNode_internalsSymbol1 = parentNode[internalsSymbol]) === null || _parentNode_internalsSymbol1 === void 0 ? void 0 : _parentNode_internalsSymbol1.z) !== null && _parentNode_internalsSymbol_z1 !== void 0 ? _parentNode_internalsSymbol_z1 : 0 : (_result_z1 = result.z) !== null && _result_z1 !== void 0 ? _result_z1 : 0
    }, nodeOrigin);
}
function updateAbsoluteNodePositions(nodeInternals, nodeOrigin, parentNodes) {
    nodeInternals.forEach((node)=>{
        const parentId = node.parentNode || node.parentId;
        if (parentId && !nodeInternals.has(parentId)) throw new Error(`Parent node ${parentId} not found`);
        if (parentId || (parentNodes === null || parentNodes === void 0 ? void 0 : parentNodes[node.id])) {
            var _node_internalsSymbol;
            var _node_internalsSymbol_z;
            const { x, y, z } = calculateXYZPosition(node, nodeInternals, (0, _objectSpreadProps._)((0, _objectSpread._)({}, node.position), {
                z: (_node_internalsSymbol_z = (_node_internalsSymbol = node[internalsSymbol]) === null || _node_internalsSymbol === void 0 ? void 0 : _node_internalsSymbol.z) !== null && _node_internalsSymbol_z !== void 0 ? _node_internalsSymbol_z : 0
            }), nodeOrigin);
            node.positionAbsolute = {
                x,
                y
            };
            node[internalsSymbol].z = z;
            if (parentNodes === null || parentNodes === void 0 ? void 0 : parentNodes[node.id]) node[internalsSymbol].isParent = true;
        }
    });
}
function createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect) {
    const nextNodeInternals = new Map();
    const parentNodes = {};
    const selectedNodeZ = elevateNodesOnSelect ? 1000 : 0;
    nodes.forEach((node)=>{
        var _currInternals_internalsSymbol;
        const z = (isNumeric(node.zIndex) ? node.zIndex : 0) + (node.selected ? selectedNodeZ : 0);
        const currInternals = nodeInternals.get(node.id);
        const internals = (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
            positionAbsolute: {
                x: node.position.x,
                y: node.position.y
            }
        });
        const parentId = node.parentNode || node.parentId;
        if (parentId) parentNodes[parentId] = true;
        const resetHandleBounds = (currInternals === null || currInternals === void 0 ? void 0 : currInternals.type) && (currInternals === null || currInternals === void 0 ? void 0 : currInternals.type) !== node.type;
        Object.defineProperty(internals, internalsSymbol, {
            enumerable: false,
            value: {
                handleBounds: resetHandleBounds ? undefined : currInternals === null || currInternals === void 0 ? void 0 : (_currInternals_internalsSymbol = currInternals[internalsSymbol]) === null || _currInternals_internalsSymbol === void 0 ? void 0 : _currInternals_internalsSymbol.handleBounds,
                z
            }
        });
        nextNodeInternals.set(node.id, internals);
    });
    updateAbsoluteNodePositions(nextNodeInternals, nodeOrigin, parentNodes);
    return nextNodeInternals;
}
function fitView(get, options = {}) {
    const { getNodes, width, height, minZoom, maxZoom, d3Zoom, d3Selection, fitViewOnInitDone, fitViewOnInit, nodeOrigin } = get();
    const isInitialFitView = options.initial && !fitViewOnInitDone && fitViewOnInit;
    const d3initialized = d3Zoom && d3Selection;
    if (d3initialized && (isInitialFitView || !options.initial)) {
        const nodes = getNodes().filter((n)=>{
            var _options_nodes;
            const isVisible = options.includeHiddenNodes ? n.width && n.height : !n.hidden;
            if ((_options_nodes = options.nodes) === null || _options_nodes === void 0 ? void 0 : _options_nodes.length) return isVisible && options.nodes.some((optionNode)=>optionNode.id === n.id);
            return isVisible;
        });
        const nodesInitialized = nodes.every((n)=>n.width && n.height);
        if (nodes.length > 0 && nodesInitialized) {
            const bounds = getNodesBounds(nodes, nodeOrigin);
            var _options_minZoom, _options_maxZoom, _options_padding;
            const { x, y, zoom } = getViewportForBounds(bounds, width, height, (_options_minZoom = options.minZoom) !== null && _options_minZoom !== void 0 ? _options_minZoom : minZoom, (_options_maxZoom = options.maxZoom) !== null && _options_maxZoom !== void 0 ? _options_maxZoom : maxZoom, (_options_padding = options.padding) !== null && _options_padding !== void 0 ? _options_padding : 0.1);
            const nextTransform = (0, _d3Zoom.zoomIdentity).translate(x, y).scale(zoom);
            if (typeof options.duration === 'number' && options.duration > 0) d3Zoom.transform(getD3Transition(d3Selection, options.duration), nextTransform);
            else d3Zoom.transform(d3Selection, nextTransform);
            return true;
        }
    }
    return false;
}
function handleControlledNodeSelectionChange(nodeChanges, nodeInternals) {
    nodeChanges.forEach((change)=>{
        const node = nodeInternals.get(change.id);
        if (node) nodeInternals.set(node.id, (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
            [internalsSymbol]: node[internalsSymbol],
            selected: change.selected
        }));
    });
    return new Map(nodeInternals);
}
function handleControlledEdgeSelectionChange(edgeChanges, edges) {
    return edges.map((e)=>{
        const change = edgeChanges.find((change)=>change.id === e.id);
        if (change) e.selected = change.selected;
        return e;
    });
}
function updateNodesAndEdgesSelections({ changedNodes, changedEdges, get, set }) {
    const { nodeInternals, edges, onNodesChange, onEdgesChange, hasDefaultNodes, hasDefaultEdges } = get();
    if (changedNodes === null || changedNodes === void 0 ? void 0 : changedNodes.length) {
        if (hasDefaultNodes) set({
            nodeInternals: handleControlledNodeSelectionChange(changedNodes, nodeInternals)
        });
        onNodesChange === null || onNodesChange === void 0 ? void 0 : onNodesChange(changedNodes);
    }
    if (changedEdges === null || changedEdges === void 0 ? void 0 : changedEdges.length) {
        if (hasDefaultEdges) set({
            edges: handleControlledEdgeSelectionChange(changedEdges, edges)
        });
        onEdgesChange === null || onEdgesChange === void 0 ? void 0 : onEdgesChange(changedEdges);
    }
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const initialViewportHelper = {
    zoomIn: noop,
    zoomOut: noop,
    zoomTo: noop,
    getZoom: ()=>1,
    setViewport: noop,
    getViewport: ()=>({
            x: 0,
            y: 0,
            zoom: 1
        }),
    fitView: ()=>false,
    setCenter: noop,
    fitBounds: noop,
    project: (position)=>position,
    screenToFlowPosition: (position)=>position,
    flowToScreenPosition: (position)=>position,
    viewportInitialized: false
};
const selector$b = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection
    });
const useViewportHelper = ()=>{
    const store = useStoreApi();
    const { d3Zoom, d3Selection } = useStore(selector$b, (0, _shallow.shallow));
    const viewportHelperFunctions = (0, _react.useMemo)(()=>{
        if (d3Selection && d3Zoom) return {
            zoomIn: (options)=>d3Zoom.scaleBy(getD3Transition(d3Selection, options === null || options === void 0 ? void 0 : options.duration), 1.2),
            zoomOut: (options)=>d3Zoom.scaleBy(getD3Transition(d3Selection, options === null || options === void 0 ? void 0 : options.duration), 1 / 1.2),
            zoomTo: (zoomLevel, options)=>d3Zoom.scaleTo(getD3Transition(d3Selection, options === null || options === void 0 ? void 0 : options.duration), zoomLevel),
            getZoom: ()=>store.getState().transform[2],
            setViewport: (transform, options)=>{
                const [x, y, zoom] = store.getState().transform;
                var _transform_x, _transform_y, _transform_zoom;
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate((_transform_x = transform.x) !== null && _transform_x !== void 0 ? _transform_x : x, (_transform_y = transform.y) !== null && _transform_y !== void 0 ? _transform_y : y).scale((_transform_zoom = transform.zoom) !== null && _transform_zoom !== void 0 ? _transform_zoom : zoom);
                d3Zoom.transform(getD3Transition(d3Selection, options === null || options === void 0 ? void 0 : options.duration), nextTransform);
            },
            getViewport: ()=>{
                const [x, y, zoom] = store.getState().transform;
                return {
                    x,
                    y,
                    zoom
                };
            },
            fitView: (options)=>fitView(store.getState, options),
            setCenter: (x, y, options)=>{
                const { width, height, maxZoom } = store.getState();
                const nextZoom = typeof (options === null || options === void 0 ? void 0 : options.zoom) !== 'undefined' ? options.zoom : maxZoom;
                const centerX = width / 2 - x * nextZoom;
                const centerY = height / 2 - y * nextZoom;
                const transform = (0, _d3Zoom.zoomIdentity).translate(centerX, centerY).scale(nextZoom);
                d3Zoom.transform(getD3Transition(d3Selection, options === null || options === void 0 ? void 0 : options.duration), transform);
            },
            fitBounds: (bounds, options)=>{
                const { width, height, minZoom, maxZoom } = store.getState();
                var _options_padding;
                const { x, y, zoom } = getViewportForBounds(bounds, width, height, minZoom, maxZoom, (_options_padding = options === null || options === void 0 ? void 0 : options.padding) !== null && _options_padding !== void 0 ? _options_padding : 0.1);
                const transform = (0, _d3Zoom.zoomIdentity).translate(x, y).scale(zoom);
                d3Zoom.transform(getD3Transition(d3Selection, options === null || options === void 0 ? void 0 : options.duration), transform);
            },
            // @deprecated Use `screenToFlowPosition`.
            project: (position)=>{
                const { transform, snapToGrid, snapGrid } = store.getState();
                console.warn('[DEPRECATED] `project` is deprecated. Instead use `screenToFlowPosition`. There is no need to subtract the react flow bounds anymore! https://reactflow.dev/api-reference/types/react-flow-instance#screen-to-flow-position');
                return pointToRendererPoint(position, transform, snapToGrid, snapGrid);
            },
            screenToFlowPosition: (position)=>{
                const { transform, snapToGrid, snapGrid, domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const relativePosition = {
                    x: position.x - domX,
                    y: position.y - domY
                };
                return pointToRendererPoint(relativePosition, transform, snapToGrid, snapGrid);
            },
            flowToScreenPosition: (position)=>{
                const { transform, domNode } = store.getState();
                if (!domNode) return position;
                const { x: domX, y: domY } = domNode.getBoundingClientRect();
                const rendererPosition = rendererPointToPoint(position, transform);
                return {
                    x: rendererPosition.x + domX,
                    y: rendererPosition.y + domY
                };
            },
            viewportInitialized: true
        };
        return initialViewportHelper;
    }, [
        d3Zoom,
        d3Selection
    ]);
    return viewportHelperFunctions;
};
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */ function useReactFlow() {
    const viewportHelper = useViewportHelper();
    const store = useStoreApi();
    const getNodes = (0, _react.useCallback)(()=>{
        return store.getState().getNodes().map((n)=>(0, _objectSpread._)({}, n));
    }, []);
    const getNode = (0, _react.useCallback)((id)=>{
        return store.getState().nodeInternals.get(id);
    }, []);
    const getEdges = (0, _react.useCallback)(()=>{
        const { edges = [] } = store.getState();
        return edges.map((e)=>(0, _objectSpread._)({}, e));
    }, []);
    const getEdge = (0, _react.useCallback)((id)=>{
        const { edges = [] } = store.getState();
        return edges.find((e)=>e.id === id);
    }, []);
    const setNodes = (0, _react.useCallback)((payload)=>{
        const { getNodes, setNodes, hasDefaultNodes, onNodesChange } = store.getState();
        const nodes = getNodes();
        const nextNodes = typeof payload === 'function' ? payload(nodes) : payload;
        if (hasDefaultNodes) setNodes(nextNodes);
        else if (onNodesChange) {
            const changes = nextNodes.length === 0 ? nodes.map((node)=>({
                    type: 'remove',
                    id: node.id
                })) : nextNodes.map((node)=>({
                    item: node,
                    type: 'reset'
                }));
            onNodesChange(changes);
        }
    }, []);
    const setEdges = (0, _react.useCallback)((payload)=>{
        const { edges = [], setEdges, hasDefaultEdges, onEdgesChange } = store.getState();
        const nextEdges = typeof payload === 'function' ? payload(edges) : payload;
        if (hasDefaultEdges) setEdges(nextEdges);
        else if (onEdgesChange) {
            const changes = nextEdges.length === 0 ? edges.map((edge)=>({
                    type: 'remove',
                    id: edge.id
                })) : nextEdges.map((edge)=>({
                    item: edge,
                    type: 'reset'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const addNodes = (0, _react.useCallback)((payload)=>{
        const nodes = Array.isArray(payload) ? payload : [
            payload
        ];
        const { getNodes, setNodes, hasDefaultNodes, onNodesChange } = store.getState();
        if (hasDefaultNodes) {
            const currentNodes = getNodes();
            const nextNodes = [
                ...currentNodes,
                ...nodes
            ];
            setNodes(nextNodes);
        } else if (onNodesChange) {
            const changes = nodes.map((node)=>({
                    item: node,
                    type: 'add'
                }));
            onNodesChange(changes);
        }
    }, []);
    const addEdges = (0, _react.useCallback)((payload)=>{
        const nextEdges = Array.isArray(payload) ? payload : [
            payload
        ];
        const { edges = [], setEdges, hasDefaultEdges, onEdgesChange } = store.getState();
        if (hasDefaultEdges) setEdges([
            ...edges,
            ...nextEdges
        ]);
        else if (onEdgesChange) {
            const changes = nextEdges.map((edge)=>({
                    item: edge,
                    type: 'add'
                }));
            onEdgesChange(changes);
        }
    }, []);
    const toObject = (0, _react.useCallback)(()=>{
        const { getNodes, edges = [], transform } = store.getState();
        const [x, y, zoom] = transform;
        return {
            nodes: getNodes().map((n)=>(0, _objectSpread._)({}, n)),
            edges: edges.map((e)=>(0, _objectSpread._)({}, e)),
            viewport: {
                x,
                y,
                zoom
            }
        };
    }, []);
    const deleteElements = (0, _react.useCallback)(({ nodes: nodesDeleted, edges: edgesDeleted })=>{
        const { nodeInternals, getNodes, edges, hasDefaultNodes, hasDefaultEdges, onNodesDelete, onEdgesDelete, onNodesChange, onEdgesChange } = store.getState();
        const nodeIds = (nodesDeleted || []).map((node)=>node.id);
        const edgeIds = (edgesDeleted || []).map((edge)=>edge.id);
        const nodesToRemove = getNodes().reduce((res, node)=>{
            const parentId = node.parentNode || node.parentId;
            const parentHit = !nodeIds.includes(node.id) && parentId && res.find((n)=>n.id === parentId);
            const deletable = typeof node.deletable === 'boolean' ? node.deletable : true;
            if (deletable && (nodeIds.includes(node.id) || parentHit)) res.push(node);
            return res;
        }, []);
        const deletableEdges = edges.filter((e)=>typeof e.deletable === 'boolean' ? e.deletable : true);
        const initialHitEdges = deletableEdges.filter((e)=>edgeIds.includes(e.id));
        if (nodesToRemove || initialHitEdges) {
            const connectedEdges = getConnectedEdges(nodesToRemove, deletableEdges);
            const edgesToRemove = [
                ...initialHitEdges,
                ...connectedEdges
            ];
            const edgeIdsToRemove = edgesToRemove.reduce((res, edge)=>{
                if (!res.includes(edge.id)) res.push(edge.id);
                return res;
            }, []);
            if (hasDefaultEdges || hasDefaultNodes) {
                if (hasDefaultEdges) store.setState({
                    edges: edges.filter((e)=>!edgeIdsToRemove.includes(e.id))
                });
                if (hasDefaultNodes) {
                    nodesToRemove.forEach((node)=>{
                        nodeInternals.delete(node.id);
                    });
                    store.setState({
                        nodeInternals: new Map(nodeInternals)
                    });
                }
            }
            if (edgeIdsToRemove.length > 0) {
                onEdgesDelete === null || onEdgesDelete === void 0 ? void 0 : onEdgesDelete(edgesToRemove);
                if (onEdgesChange) onEdgesChange(edgeIdsToRemove.map((id)=>({
                        id,
                        type: 'remove'
                    })));
            }
            if (nodesToRemove.length > 0) {
                onNodesDelete === null || onNodesDelete === void 0 ? void 0 : onNodesDelete(nodesToRemove);
                if (onNodesChange) {
                    const nodeChanges = nodesToRemove.map((n)=>({
                            id: n.id,
                            type: 'remove'
                        }));
                    onNodesChange(nodeChanges);
                }
            }
        }
    }, []);
    const getNodeRect = (0, _react.useCallback)((nodeOrRect)=>{
        const isRect = isRectObject(nodeOrRect);
        const node = isRect ? null : store.getState().nodeInternals.get(nodeOrRect.id);
        if (!isRect && !node) return [
            null,
            null,
            isRect
        ];
        const nodeRect = isRect ? nodeOrRect : nodeToRect(node);
        return [
            nodeRect,
            node,
            isRect
        ];
    }, []);
    const getIntersectingNodes = (0, _react.useCallback)((nodeOrRect, partially = true, nodes)=>{
        const [nodeRect, node, isRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return [];
        return (nodes || store.getState().getNodes()).filter((n)=>{
            if (!isRect && (n.id === node.id || !n.positionAbsolute)) return false;
            const currNodeRect = nodeToRect(n);
            const overlappingArea = getOverlappingArea(currNodeRect, nodeRect);
            const partiallyVisible = partially && overlappingArea > 0;
            return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
        });
    }, []);
    const isNodeIntersecting = (0, _react.useCallback)((nodeOrRect, area, partially = true)=>{
        const [nodeRect] = getNodeRect(nodeOrRect);
        if (!nodeRect) return false;
        const overlappingArea = getOverlappingArea(nodeRect, area);
        const partiallyVisible = partially && overlappingArea > 0;
        return partiallyVisible || overlappingArea >= nodeRect.width * nodeRect.height;
    }, []);
    return (0, _react.useMemo)(()=>{
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, viewportHelper), {
            getNodes,
            getNode,
            getEdges,
            getEdge,
            setNodes,
            setEdges,
            addNodes,
            addEdges,
            toObject,
            deleteElements,
            getIntersectingNodes,
            isNodeIntersecting
        });
    }, [
        viewportHelper,
        getNodes,
        getNode,
        getEdges,
        getEdge,
        setNodes,
        setEdges,
        addNodes,
        addEdges,
        toObject,
        deleteElements,
        getIntersectingNodes,
        isNodeIntersecting
    ]);
}
const deleteKeyOptions = {
    actInsideInputWithModifier: false
};
var useGlobalKeyHandler = ({ deleteKeyCode, multiSelectionKeyCode })=>{
    const store = useStoreApi();
    const { deleteElements } = useReactFlow();
    const deleteKeyPressed = useKeyPress(deleteKeyCode, deleteKeyOptions);
    const multiSelectionKeyPressed = useKeyPress(multiSelectionKeyCode);
    (0, _react.useEffect)(()=>{
        if (deleteKeyPressed) {
            const { edges, getNodes } = store.getState();
            const selectedNodes = getNodes().filter((node)=>node.selected);
            const selectedEdges = edges.filter((edge)=>edge.selected);
            deleteElements({
                nodes: selectedNodes,
                edges: selectedEdges
            });
            store.setState({
                nodesSelectionActive: false
            });
        }
    }, [
        deleteKeyPressed
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            multiSelectionActive: multiSelectionKeyPressed
        });
    }, [
        multiSelectionKeyPressed
    ]);
};
function useResizeHandler(rendererNode) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        let resizeObserver;
        const updateDimensions = ()=>{
            var _store_getState_onError, _store_getState;
            if (!rendererNode.current) return;
            const size = getDimensions(rendererNode.current);
            if (size.height === 0 || size.width === 0) (_store_getState_onError = (_store_getState = store.getState()).onError) === null || _store_getState_onError === void 0 ? void 0 : _store_getState_onError.call(_store_getState, '004', errorMessages['error004']());
            store.setState({
                width: size.width || 500,
                height: size.height || 500
            });
        };
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        if (rendererNode.current) {
            resizeObserver = new ResizeObserver(()=>updateDimensions());
            resizeObserver.observe(rendererNode.current);
        }
        return ()=>{
            window.removeEventListener('resize', updateDimensions);
            if (resizeObserver && rendererNode.current) resizeObserver.unobserve(rendererNode.current);
        };
    }, []);
}
const containerStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0
};
/* eslint-disable @typescript-eslint/ban-ts-comment */ const viewChanged = (prevViewport, eventTransform)=>prevViewport.x !== eventTransform.x || prevViewport.y !== eventTransform.y || prevViewport.zoom !== eventTransform.k;
const eventToFlowTransform = (eventTransform)=>({
        x: eventTransform.x,
        y: eventTransform.y,
        zoom: eventTransform.k
    });
const isWrappedWithClass = (event, className)=>event.target.closest(`.${className}`);
const isRightClickPan = (panOnDrag, usedButton)=>usedButton === 2 && Array.isArray(panOnDrag) && panOnDrag.includes(2);
const wheelDelta = (event)=>{
    const factor = event.ctrlKey && isMacOs() ? 10 : 1;
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * factor;
};
const selector$a = (s)=>({
        d3Zoom: s.d3Zoom,
        d3Selection: s.d3Selection,
        d3ZoomHandler: s.d3ZoomHandler,
        userSelectionActive: s.userSelectionActive
    });
const ZoomPane = ({ onMove, onMoveStart, onMoveEnd, onPaneContextMenu, zoomOnScroll = true, zoomOnPinch = true, panOnScroll = false, panOnScrollSpeed = 0.5, panOnScrollMode = PanOnScrollMode.Free, zoomOnDoubleClick = true, elementsSelectable, panOnDrag = true, defaultViewport, translateExtent, minZoom, maxZoom, zoomActivationKeyCode, preventScrolling = true, children, noWheelClassName, noPanClassName })=>{
    const timerId = (0, _react.useRef)();
    const store = useStoreApi();
    const isZoomingOrPanning = (0, _react.useRef)(false);
    const zoomedWithRightMouseButton = (0, _react.useRef)(false);
    const zoomPane = (0, _react.useRef)(null);
    const prevTransform = (0, _react.useRef)({
        x: 0,
        y: 0,
        zoom: 0
    });
    const { d3Zoom, d3Selection, d3ZoomHandler, userSelectionActive } = useStore(selector$a, (0, _shallow.shallow));
    const zoomActivationKeyPressed = useKeyPress(zoomActivationKeyCode);
    const mouseButton = (0, _react.useRef)(0);
    const isPanScrolling = (0, _react.useRef)(false);
    const panScrollTimeout = (0, _react.useRef)();
    useResizeHandler(zoomPane);
    (0, _react.useEffect)(()=>{
        if (zoomPane.current) {
            const bbox = zoomPane.current.getBoundingClientRect();
            const d3ZoomInstance = (0, _d3Zoom.zoom)().scaleExtent([
                minZoom,
                maxZoom
            ]).translateExtent(translateExtent);
            const selection = (0, _d3Selection.select)(zoomPane.current).call(d3ZoomInstance);
            const updatedTransform = (0, _d3Zoom.zoomIdentity).translate(defaultViewport.x, defaultViewport.y).scale(clamp(defaultViewport.zoom, minZoom, maxZoom));
            const extent = [
                [
                    0,
                    0
                ],
                [
                    bbox.width,
                    bbox.height
                ]
            ];
            const constrainedTransform = d3ZoomInstance.constrain()(updatedTransform, extent, translateExtent);
            d3ZoomInstance.transform(selection, constrainedTransform);
            d3ZoomInstance.wheelDelta(wheelDelta);
            store.setState({
                d3Zoom: d3ZoomInstance,
                d3Selection: selection,
                d3ZoomHandler: selection.on('wheel.zoom'),
                // we need to pass transform because zoom handler is not registered when we set the initial transform
                transform: [
                    constrainedTransform.x,
                    constrainedTransform.y,
                    constrainedTransform.k
                ],
                domNode: zoomPane.current.closest('.react-flow')
            });
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (d3Selection && d3Zoom) {
            if (panOnScroll && !zoomActivationKeyPressed && !userSelectionActive) d3Selection.on('wheel.zoom', (event)=>{
                if (isWrappedWithClass(event, noWheelClassName)) return false;
                event.preventDefault();
                event.stopImmediatePropagation();
                const currentZoom = d3Selection.property('__zoom').k || 1;
                // macos and win set ctrlKey=true for pinch gesture on a trackpad
                if (event.ctrlKey && zoomOnPinch) {
                    const point = (0, _d3Selection.pointer)(event);
                    const pinchDelta = wheelDelta(event);
                    const zoom = currentZoom * Math.pow(2, pinchDelta);
                    // @ts-ignore
                    d3Zoom.scaleTo(d3Selection, zoom, point, event);
                    return;
                }
                // increase scroll speed in firefox
                // firefox: deltaMode === 1; chrome: deltaMode === 0
                const deltaNormalize = event.deltaMode === 1 ? 20 : 1;
                let deltaX = panOnScrollMode === PanOnScrollMode.Vertical ? 0 : event.deltaX * deltaNormalize;
                let deltaY = panOnScrollMode === PanOnScrollMode.Horizontal ? 0 : event.deltaY * deltaNormalize;
                // this enables vertical scrolling with shift + scroll on windows
                if (!isMacOs() && event.shiftKey && panOnScrollMode !== PanOnScrollMode.Vertical) {
                    deltaX = event.deltaY * deltaNormalize;
                    deltaY = 0;
                }
                d3Zoom.translateBy(d3Selection, -(deltaX / currentZoom) * panOnScrollSpeed, -(deltaY / currentZoom) * panOnScrollSpeed, // @ts-ignore
                {
                    internal: true
                });
                const nextViewport = eventToFlowTransform(d3Selection.property('__zoom'));
                const { onViewportChangeStart, onViewportChange, onViewportChangeEnd } = store.getState();
                clearTimeout(panScrollTimeout.current);
                // for pan on scroll we need to handle the event calls on our own
                // we can't use the start, zoom and end events from d3-zoom
                // because start and move gets called on every scroll event and not once at the beginning
                if (!isPanScrolling.current) {
                    isPanScrolling.current = true;
                    onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart(event, nextViewport);
                    onViewportChangeStart === null || onViewportChangeStart === void 0 ? void 0 : onViewportChangeStart(nextViewport);
                }
                if (isPanScrolling.current) {
                    onMove === null || onMove === void 0 ? void 0 : onMove(event, nextViewport);
                    onViewportChange === null || onViewportChange === void 0 ? void 0 : onViewportChange(nextViewport);
                    panScrollTimeout.current = setTimeout(()=>{
                        onMoveEnd === null || onMoveEnd === void 0 ? void 0 : onMoveEnd(event, nextViewport);
                        onViewportChangeEnd === null || onViewportChangeEnd === void 0 ? void 0 : onViewportChangeEnd(nextViewport);
                        isPanScrolling.current = false;
                    }, 150);
                }
            }, {
                passive: false
            });
            else if (typeof d3ZoomHandler !== 'undefined') d3Selection.on('wheel.zoom', function(event, d) {
                // we still want to enable pinch zooming even if preventScrolling is set to false
                const invalidEvent = !preventScrolling && event.type === 'wheel' && !event.ctrlKey;
                if (invalidEvent || isWrappedWithClass(event, noWheelClassName)) return null;
                event.preventDefault();
                d3ZoomHandler.call(this, event, d);
            }, {
                passive: false
            });
        }
    }, [
        userSelectionActive,
        panOnScroll,
        panOnScrollMode,
        d3Selection,
        d3Zoom,
        d3ZoomHandler,
        zoomActivationKeyPressed,
        zoomOnPinch,
        preventScrolling,
        noWheelClassName,
        onMoveStart,
        onMove,
        onMoveEnd
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('start', (event)=>{
            var _event_sourceEvent, _event_sourceEvent1;
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            // we need to remember it here, because it's always 0 in the "zoom" event
            mouseButton.current = (_event_sourceEvent = event.sourceEvent) === null || _event_sourceEvent === void 0 ? void 0 : _event_sourceEvent.button;
            const { onViewportChangeStart } = store.getState();
            const flowTransform = eventToFlowTransform(event.transform);
            isZoomingOrPanning.current = true;
            prevTransform.current = flowTransform;
            if (((_event_sourceEvent1 = event.sourceEvent) === null || _event_sourceEvent1 === void 0 ? void 0 : _event_sourceEvent1.type) === 'mousedown') store.setState({
                paneDragging: true
            });
            onViewportChangeStart === null || onViewportChangeStart === void 0 ? void 0 : onViewportChangeStart(flowTransform);
            onMoveStart === null || onMoveStart === void 0 ? void 0 : onMoveStart(event.sourceEvent, flowTransform);
        });
    }, [
        d3Zoom,
        onMoveStart
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) {
            if (userSelectionActive && !isZoomingOrPanning.current) d3Zoom.on('zoom', null);
            else if (!userSelectionActive) d3Zoom.on('zoom', (event)=>{
                var _event_sourceEvent;
                const { onViewportChange } = store.getState();
                store.setState({
                    transform: [
                        event.transform.x,
                        event.transform.y,
                        event.transform.k
                    ]
                });
                var _mouseButton_current;
                zoomedWithRightMouseButton.current = !!(onPaneContextMenu && isRightClickPan(panOnDrag, (_mouseButton_current = mouseButton.current) !== null && _mouseButton_current !== void 0 ? _mouseButton_current : 0));
                if ((onMove || onViewportChange) && !((_event_sourceEvent = event.sourceEvent) === null || _event_sourceEvent === void 0 ? void 0 : _event_sourceEvent.internal)) {
                    const flowTransform = eventToFlowTransform(event.transform);
                    onViewportChange === null || onViewportChange === void 0 ? void 0 : onViewportChange(flowTransform);
                    onMove === null || onMove === void 0 ? void 0 : onMove(event.sourceEvent, flowTransform);
                }
            });
        }
    }, [
        userSelectionActive,
        d3Zoom,
        onMove,
        panOnDrag,
        onPaneContextMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.on('end', (event)=>{
            if (!event.sourceEvent || event.sourceEvent.internal) return null;
            const { onViewportChangeEnd } = store.getState();
            isZoomingOrPanning.current = false;
            store.setState({
                paneDragging: false
            });
            var _mouseButton_current;
            if (onPaneContextMenu && isRightClickPan(panOnDrag, (_mouseButton_current = mouseButton.current) !== null && _mouseButton_current !== void 0 ? _mouseButton_current : 0) && !zoomedWithRightMouseButton.current) onPaneContextMenu(event.sourceEvent);
            zoomedWithRightMouseButton.current = false;
            if ((onMoveEnd || onViewportChangeEnd) && viewChanged(prevTransform.current, event.transform)) {
                const flowTransform = eventToFlowTransform(event.transform);
                prevTransform.current = flowTransform;
                clearTimeout(timerId.current);
                timerId.current = setTimeout(()=>{
                    onViewportChangeEnd === null || onViewportChangeEnd === void 0 ? void 0 : onViewportChangeEnd(flowTransform);
                    onMoveEnd === null || onMoveEnd === void 0 ? void 0 : onMoveEnd(event.sourceEvent, flowTransform);
                }, panOnScroll ? 150 : 0);
            }
        });
    }, [
        d3Zoom,
        panOnScroll,
        panOnDrag,
        onMoveEnd,
        onPaneContextMenu
    ]);
    (0, _react.useEffect)(()=>{
        if (d3Zoom) d3Zoom.filter((event)=>{
            const zoomScroll = zoomActivationKeyPressed || zoomOnScroll;
            const pinchZoom = zoomOnPinch && event.ctrlKey;
            if ((panOnDrag === true || Array.isArray(panOnDrag) && panOnDrag.includes(1)) && event.button === 1 && event.type === 'mousedown' && (isWrappedWithClass(event, 'react-flow__node') || isWrappedWithClass(event, 'react-flow__edge'))) return true;
            // if all interactions are disabled, we prevent all zoom events
            if (!panOnDrag && !zoomScroll && !panOnScroll && !zoomOnDoubleClick && !zoomOnPinch) return false;
            // during a selection we prevent all other interactions
            if (userSelectionActive) return false;
            // if zoom on double click is disabled, we prevent the double click event
            if (!zoomOnDoubleClick && event.type === 'dblclick') return false;
            // if the target element is inside an element with the nowheel class, we prevent zooming
            if (isWrappedWithClass(event, noWheelClassName) && event.type === 'wheel') return false;
            // if the target element is inside an element with the nopan class, we prevent panning
            if (isWrappedWithClass(event, noPanClassName) && (event.type !== 'wheel' || panOnScroll && event.type === 'wheel' && !zoomActivationKeyPressed)) return false;
            if (!zoomOnPinch && event.ctrlKey && event.type === 'wheel') return false;
            // when there is no scroll handling enabled, we prevent all wheel events
            if (!zoomScroll && !panOnScroll && !pinchZoom && event.type === 'wheel') return false;
            // if the pane is not movable, we prevent dragging it with mousestart or touchstart
            if (!panOnDrag && (event.type === 'mousedown' || event.type === 'touchstart')) return false;
            // if the pane is only movable using allowed clicks
            if (Array.isArray(panOnDrag) && !panOnDrag.includes(event.button) && event.type === 'mousedown') return false;
            // We only allow right clicks if pan on drag is set to right click
            const buttonAllowed = Array.isArray(panOnDrag) && panOnDrag.includes(event.button) || !event.button || event.button <= 1;
            // default filter for d3-zoom
            return (!event.ctrlKey || event.type === 'wheel') && buttonAllowed;
        });
    }, [
        userSelectionActive,
        d3Zoom,
        zoomOnScroll,
        zoomOnPinch,
        panOnScroll,
        zoomOnDoubleClick,
        panOnDrag,
        elementsSelectable,
        zoomActivationKeyPressed
    ]);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__renderer",
        ref: zoomPane,
        style: containerStyle
    }, children);
};
const selector$9 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        userSelectionRect: s.userSelectionRect
    });
function UserSelection() {
    const { userSelectionActive, userSelectionRect } = useStore(selector$9, (0, _shallow.shallow));
    const isActive = userSelectionActive && userSelectionRect;
    if (!isActive) return null;
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__selection react-flow__container",
        style: {
            width: userSelectionRect.width,
            height: userSelectionRect.height,
            transform: `translate(${userSelectionRect.x}px, ${userSelectionRect.y}px)`
        }
    });
}
function handleParentExpand(res, updateItem) {
    const parentId = updateItem.parentNode || updateItem.parentId;
    const parent = res.find((e)=>e.id === parentId);
    if (parent) {
        const extendWidth = updateItem.position.x + updateItem.width - parent.width;
        const extendHeight = updateItem.position.y + updateItem.height - parent.height;
        if (extendWidth > 0 || extendHeight > 0 || updateItem.position.x < 0 || updateItem.position.y < 0) {
            parent.style = (0, _objectSpread._)({}, parent.style);
            var _parent_style_width;
            parent.style.width = (_parent_style_width = parent.style.width) !== null && _parent_style_width !== void 0 ? _parent_style_width : parent.width;
            var _parent_style_height;
            parent.style.height = (_parent_style_height = parent.style.height) !== null && _parent_style_height !== void 0 ? _parent_style_height : parent.height;
            if (extendWidth > 0) parent.style.width += extendWidth;
            if (extendHeight > 0) parent.style.height += extendHeight;
            if (updateItem.position.x < 0) {
                const xDiff = Math.abs(updateItem.position.x);
                parent.position.x = parent.position.x - xDiff;
                parent.style.width += xDiff;
                updateItem.position.x = 0;
            }
            if (updateItem.position.y < 0) {
                const yDiff = Math.abs(updateItem.position.y);
                parent.position.y = parent.position.y - yDiff;
                parent.style.height += yDiff;
                updateItem.position.y = 0;
            }
            parent.width = parent.style.width;
            parent.height = parent.style.height;
        }
    }
}
function applyChanges(changes, elements) {
    // we need this hack to handle the setNodes and setEdges function of the useReactFlow hook for controlled flows
    if (changes.some((c)=>c.type === 'reset')) return changes.filter((c)=>c.type === 'reset').map((c)=>c.item);
    const initElements = changes.filter((c)=>c.type === 'add').map((c)=>c.item);
    return elements.reduce((res, item)=>{
        const currentChanges = changes.filter((c)=>c.id === item.id);
        if (currentChanges.length === 0) {
            res.push(item);
            return res;
        }
        const updateItem = (0, _objectSpread._)({}, item);
        for (const currentChange of currentChanges)if (currentChange) switch(currentChange.type){
            case 'select':
                updateItem.selected = currentChange.selected;
                break;
            case 'position':
                if (typeof currentChange.position !== 'undefined') updateItem.position = currentChange.position;
                if (typeof currentChange.positionAbsolute !== 'undefined') updateItem.positionAbsolute = currentChange.positionAbsolute;
                if (typeof currentChange.dragging !== 'undefined') updateItem.dragging = currentChange.dragging;
                if (updateItem.expandParent) handleParentExpand(res, updateItem);
                break;
            case 'dimensions':
                if (typeof currentChange.dimensions !== 'undefined') {
                    updateItem.width = currentChange.dimensions.width;
                    updateItem.height = currentChange.dimensions.height;
                }
                if (typeof currentChange.updateStyle !== 'undefined') updateItem.style = (0, _objectSpread._)({}, updateItem.style || {}, currentChange.dimensions);
                if (typeof currentChange.resizing === 'boolean') updateItem.resizing = currentChange.resizing;
                if (updateItem.expandParent) handleParentExpand(res, updateItem);
                break;
            case 'remove':
                return res;
        }
        res.push(updateItem);
        return res;
    }, initElements);
}
function applyNodeChanges(changes, nodes) {
    return applyChanges(changes, nodes);
}
function applyEdgeChanges(changes, edges) {
    return applyChanges(changes, edges);
}
const createSelectionChange = (id, selected)=>({
        id,
        type: 'select',
        selected
    });
function getSelectionChanges(items, selectedIds) {
    return items.reduce((res, item)=>{
        const willBeSelected = selectedIds.includes(item.id);
        if (!item.selected && willBeSelected) {
            item.selected = true;
            res.push(createSelectionChange(item.id, true));
        } else if (item.selected && !willBeSelected) {
            item.selected = false;
            res.push(createSelectionChange(item.id, false));
        }
        return res;
    }, []);
}
/**
 * The user selection rectangle gets displayed when a user drags the mouse while pressing shift
 */ const wrapHandler = (handler, containerRef)=>{
    return (event)=>{
        if (event.target !== containerRef.current) return;
        handler === null || handler === void 0 ? void 0 : handler(event);
    };
};
const selector$8 = (s)=>({
        userSelectionActive: s.userSelectionActive,
        elementsSelectable: s.elementsSelectable,
        dragging: s.paneDragging
    });
const Pane = (0, _react.memo)(({ isSelecting, selectionMode = SelectionMode.Full, panOnDrag, onSelectionStart, onSelectionEnd, onPaneClick, onPaneContextMenu, onPaneScroll, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, children })=>{
    const container = (0, _react.useRef)(null);
    const store = useStoreApi();
    const prevSelectedNodesCount = (0, _react.useRef)(0);
    const prevSelectedEdgesCount = (0, _react.useRef)(0);
    const containerBounds = (0, _react.useRef)();
    const { userSelectionActive, elementsSelectable, dragging } = useStore(selector$8, (0, _shallow.shallow));
    const resetUserSelection = ()=>{
        store.setState({
            userSelectionActive: false,
            userSelectionRect: null
        });
        prevSelectedNodesCount.current = 0;
        prevSelectedEdgesCount.current = 0;
    };
    const onClick = (event)=>{
        onPaneClick === null || onPaneClick === void 0 ? void 0 : onPaneClick(event);
        store.getState().resetSelectedElements();
        store.setState({
            nodesSelectionActive: false
        });
    };
    const onContextMenu = (event)=>{
        if (Array.isArray(panOnDrag) && (panOnDrag === null || panOnDrag === void 0 ? void 0 : panOnDrag.includes(2))) {
            event.preventDefault();
            return;
        }
        onPaneContextMenu === null || onPaneContextMenu === void 0 ? void 0 : onPaneContextMenu(event);
    };
    const onWheel = onPaneScroll ? (event)=>onPaneScroll(event) : undefined;
    const onMouseDown = (event)=>{
        const { resetSelectedElements, domNode } = store.getState();
        containerBounds.current = domNode === null || domNode === void 0 ? void 0 : domNode.getBoundingClientRect();
        if (!elementsSelectable || !isSelecting || event.button !== 0 || event.target !== container.current || !containerBounds.current) return;
        const { x, y } = getEventPosition(event, containerBounds.current);
        resetSelectedElements();
        store.setState({
            userSelectionRect: {
                width: 0,
                height: 0,
                startX: x,
                startY: y,
                x,
                y
            }
        });
        onSelectionStart === null || onSelectionStart === void 0 ? void 0 : onSelectionStart(event);
    };
    const onMouseMove = (event)=>{
        const { userSelectionRect, nodeInternals, edges, transform, onNodesChange, onEdgesChange, nodeOrigin, getNodes } = store.getState();
        if (!isSelecting || !containerBounds.current || !userSelectionRect) return;
        store.setState({
            userSelectionActive: true,
            nodesSelectionActive: false
        });
        const mousePos = getEventPosition(event, containerBounds.current);
        var _userSelectionRect_startX;
        const startX = (_userSelectionRect_startX = userSelectionRect.startX) !== null && _userSelectionRect_startX !== void 0 ? _userSelectionRect_startX : 0;
        var _userSelectionRect_startY;
        const startY = (_userSelectionRect_startY = userSelectionRect.startY) !== null && _userSelectionRect_startY !== void 0 ? _userSelectionRect_startY : 0;
        const nextUserSelectRect = (0, _objectSpreadProps._)((0, _objectSpread._)({}, userSelectionRect), {
            x: mousePos.x < startX ? mousePos.x : startX,
            y: mousePos.y < startY ? mousePos.y : startY,
            width: Math.abs(mousePos.x - startX),
            height: Math.abs(mousePos.y - startY)
        });
        const nodes = getNodes();
        const selectedNodes = getNodesInside(nodeInternals, nextUserSelectRect, transform, selectionMode === SelectionMode.Partial, true, nodeOrigin);
        const selectedEdgeIds = getConnectedEdges(selectedNodes, edges).map((e)=>e.id);
        const selectedNodeIds = selectedNodes.map((n)=>n.id);
        if (prevSelectedNodesCount.current !== selectedNodeIds.length) {
            prevSelectedNodesCount.current = selectedNodeIds.length;
            const changes = getSelectionChanges(nodes, selectedNodeIds);
            if (changes.length) onNodesChange === null || onNodesChange === void 0 ? void 0 : onNodesChange(changes);
        }
        if (prevSelectedEdgesCount.current !== selectedEdgeIds.length) {
            prevSelectedEdgesCount.current = selectedEdgeIds.length;
            const changes = getSelectionChanges(edges, selectedEdgeIds);
            if (changes.length) onEdgesChange === null || onEdgesChange === void 0 ? void 0 : onEdgesChange(changes);
        }
        store.setState({
            userSelectionRect: nextUserSelectRect
        });
    };
    const onMouseUp = (event)=>{
        if (event.button !== 0) return;
        const { userSelectionRect } = store.getState();
        // We only want to trigger click functions when in selection mode if
        // the user did not move the mouse.
        if (!userSelectionActive && userSelectionRect && event.target === container.current) onClick === null || onClick === void 0 ? void 0 : onClick(event);
        store.setState({
            nodesSelectionActive: prevSelectedNodesCount.current > 0
        });
        resetUserSelection();
        onSelectionEnd === null || onSelectionEnd === void 0 ? void 0 : onSelectionEnd(event);
    };
    const onMouseLeave = (event)=>{
        if (userSelectionActive) {
            store.setState({
                nodesSelectionActive: prevSelectedNodesCount.current > 0
            });
            onSelectionEnd === null || onSelectionEnd === void 0 ? void 0 : onSelectionEnd(event);
        }
        resetUserSelection();
    };
    const hasActiveSelection = elementsSelectable && (isSelecting || userSelectionActive);
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__pane',
            {
                dragging,
                selection: isSelecting
            }
        ]),
        onClick: hasActiveSelection ? undefined : wrapHandler(onClick, container),
        onContextMenu: wrapHandler(onContextMenu, container),
        onWheel: wrapHandler(onWheel, container),
        onMouseEnter: hasActiveSelection ? undefined : onPaneMouseEnter,
        onMouseDown: hasActiveSelection ? onMouseDown : undefined,
        onMouseMove: hasActiveSelection ? onMouseMove : onPaneMouseMove,
        onMouseUp: hasActiveSelection ? onMouseUp : undefined,
        onMouseLeave: hasActiveSelection ? onMouseLeave : onPaneMouseLeave,
        ref: container,
        style: containerStyle
    }, children, (0, _reactDefault.default).createElement(UserSelection, null));
});
Pane.displayName = 'Pane';
function isParentSelected(node, nodeInternals) {
    const parentId = node.parentNode || node.parentId;
    if (!parentId) return false;
    const parentNode = nodeInternals.get(parentId);
    if (!parentNode) return false;
    if (parentNode.selected) return true;
    return isParentSelected(parentNode, nodeInternals);
}
function hasSelector(target, selector, nodeRef) {
    let current = target;
    do {
        if (current === null || current === void 0 ? void 0 : current.matches(selector)) return true;
        if (current === nodeRef.current) return false;
        current = current.parentElement;
    }while (current);
    return false;
}
// looks for all selected nodes and created a NodeDragItem for each of them
function getDragItems(nodeInternals, nodesDraggable, mousePos, nodeId) {
    return Array.from(nodeInternals.values()).filter((n)=>(n.selected || n.id === nodeId) && (!n.parentNode || n.parentId || !isParentSelected(n, nodeInternals)) && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined')).map((n)=>{
        var _n_positionAbsolute, _n_positionAbsolute1;
        var _n_positionAbsolute_x, _n_positionAbsolute_y;
        return {
            id: n.id,
            position: n.position || {
                x: 0,
                y: 0
            },
            positionAbsolute: n.positionAbsolute || {
                x: 0,
                y: 0
            },
            distance: {
                x: mousePos.x - ((_n_positionAbsolute_x = (_n_positionAbsolute = n.positionAbsolute) === null || _n_positionAbsolute === void 0 ? void 0 : _n_positionAbsolute.x) !== null && _n_positionAbsolute_x !== void 0 ? _n_positionAbsolute_x : 0),
                y: mousePos.y - ((_n_positionAbsolute_y = (_n_positionAbsolute1 = n.positionAbsolute) === null || _n_positionAbsolute1 === void 0 ? void 0 : _n_positionAbsolute1.y) !== null && _n_positionAbsolute_y !== void 0 ? _n_positionAbsolute_y : 0)
            },
            delta: {
                x: 0,
                y: 0
            },
            extent: n.extent,
            parentNode: n.parentNode || n.parentId,
            parentId: n.parentNode || n.parentId,
            width: n.width,
            height: n.height,
            expandParent: n.expandParent
        };
    });
}
function clampNodeExtent(node, extent) {
    if (!extent || extent === 'parent') return extent;
    return [
        extent[0],
        [
            extent[1][0] - (node.width || 0),
            extent[1][1] - (node.height || 0)
        ]
    ];
}
function calcNextPosition(node, nextPosition, nodeInternals, nodeExtent, nodeOrigin = [
    0,
    0
], onError) {
    const clampedNodeExtent = clampNodeExtent(node, node.extent || nodeExtent);
    let currentExtent = clampedNodeExtent;
    const parentId = node.parentNode || node.parentId;
    if (node.extent === 'parent' && !node.expandParent) {
        if (parentId && node.width && node.height) {
            const parent = nodeInternals.get(parentId);
            const { x: parentX, y: parentY } = getNodePositionWithOrigin(parent, nodeOrigin).positionAbsolute;
            currentExtent = parent && isNumeric(parentX) && isNumeric(parentY) && isNumeric(parent.width) && isNumeric(parent.height) ? [
                [
                    parentX + node.width * nodeOrigin[0],
                    parentY + node.height * nodeOrigin[1]
                ],
                [
                    parentX + parent.width - node.width + node.width * nodeOrigin[0],
                    parentY + parent.height - node.height + node.height * nodeOrigin[1]
                ]
            ] : currentExtent;
        } else {
            onError === null || onError === void 0 ? void 0 : onError('005', errorMessages['error005']());
            currentExtent = clampedNodeExtent;
        }
    } else if (node.extent && parentId && node.extent !== 'parent') {
        const parent = nodeInternals.get(parentId);
        const { x: parentX, y: parentY } = getNodePositionWithOrigin(parent, nodeOrigin).positionAbsolute;
        currentExtent = [
            [
                node.extent[0][0] + parentX,
                node.extent[0][1] + parentY
            ],
            [
                node.extent[1][0] + parentX,
                node.extent[1][1] + parentY
            ]
        ];
    }
    let parentPosition = {
        x: 0,
        y: 0
    };
    if (parentId) {
        const parentNode = nodeInternals.get(parentId);
        parentPosition = getNodePositionWithOrigin(parentNode, nodeOrigin).positionAbsolute;
    }
    const positionAbsolute = currentExtent && currentExtent !== 'parent' ? clampPosition(nextPosition, currentExtent) : nextPosition;
    return {
        position: {
            x: positionAbsolute.x - parentPosition.x,
            y: positionAbsolute.y - parentPosition.y
        },
        positionAbsolute
    };
}
// returns two params:
// 1. the dragged node (or the first of the list, if we are dragging a node selection)
// 2. array of selected nodes (for multi selections)
function getEventHandlerParams({ nodeId, dragItems, nodeInternals }) {
    const extentedDragItems = dragItems.map((n)=>{
        const node = nodeInternals.get(n.id);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
            position: n.position,
            positionAbsolute: n.positionAbsolute
        });
    });
    return [
        nodeId ? extentedDragItems.find((n)=>n.id === nodeId) : extentedDragItems[0],
        extentedDragItems
    ];
}
const getHandleBounds = (selector, nodeElement, zoom, nodeOrigin)=>{
    const handles = nodeElement.querySelectorAll(selector);
    if (!handles || !handles.length) return null;
    const handlesArray = Array.from(handles);
    const nodeBounds = nodeElement.getBoundingClientRect();
    const nodeOffset = {
        x: nodeBounds.width * nodeOrigin[0],
        y: nodeBounds.height * nodeOrigin[1]
    };
    return handlesArray.map((handle)=>{
        const handleBounds = handle.getBoundingClientRect();
        return (0, _objectSpread._)({
            id: handle.getAttribute('data-handleid'),
            position: handle.getAttribute('data-handlepos'),
            x: (handleBounds.left - nodeBounds.left - nodeOffset.x) / zoom,
            y: (handleBounds.top - nodeBounds.top - nodeOffset.y) / zoom
        }, getDimensions(handle));
    });
};
function getMouseHandler(id, getState, handler) {
    return handler === undefined ? handler : (event)=>{
        const node = getState().nodeInternals.get(id);
        if (node) handler(event, (0, _objectSpread._)({}, node));
    };
}
// this handler is called by
// 1. the click handler when node is not draggable or selectNodesOnDrag = false
// or
// 2. the on drag start handler when node is draggable and selectNodesOnDrag = true
function handleNodeClick({ id, store, unselect = false, nodeRef }) {
    const { addSelectedNodes, unselectNodesAndEdges, multiSelectionActive, nodeInternals, onError } = store.getState();
    const node = nodeInternals.get(id);
    if (!node) {
        onError === null || onError === void 0 ? void 0 : onError('012', errorMessages['error012'](id));
        return;
    }
    store.setState({
        nodesSelectionActive: false
    });
    if (!node.selected) addSelectedNodes([
        id
    ]);
    else if (unselect || node.selected && multiSelectionActive) {
        unselectNodesAndEdges({
            nodes: [
                node
            ],
            edges: []
        });
        requestAnimationFrame(()=>{
            var _nodeRef_current;
            return nodeRef === null || nodeRef === void 0 ? void 0 : (_nodeRef_current = nodeRef.current) === null || _nodeRef_current === void 0 ? void 0 : _nodeRef_current.blur();
        });
    }
}
function useGetPointerPosition() {
    const store = useStoreApi();
    // returns the pointer position projected to the RF coordinate system
    const getPointerPosition = (0, _react.useCallback)(({ sourceEvent })=>{
        const { transform, snapGrid, snapToGrid } = store.getState();
        const x = sourceEvent.touches ? sourceEvent.touches[0].clientX : sourceEvent.clientX;
        const y = sourceEvent.touches ? sourceEvent.touches[0].clientY : sourceEvent.clientY;
        const pointerPos = {
            x: (x - transform[0]) / transform[2],
            y: (y - transform[1]) / transform[2]
        };
        // we need the snapped position in order to be able to skip unnecessary drag events
        return (0, _objectSpread._)({
            xSnapped: snapToGrid ? snapGrid[0] * Math.round(pointerPos.x / snapGrid[0]) : pointerPos.x,
            ySnapped: snapToGrid ? snapGrid[1] * Math.round(pointerPos.y / snapGrid[1]) : pointerPos.y
        }, pointerPos);
    }, []);
    return getPointerPosition;
}
function wrapSelectionDragFunc(selectionFunc) {
    return (event, _, nodes)=>selectionFunc === null || selectionFunc === void 0 ? void 0 : selectionFunc(event, nodes);
}
function useDrag({ nodeRef, disabled = false, noDragClassName, handleSelector, nodeId, isSelectable, selectNodesOnDrag }) {
    const store = useStoreApi();
    const [dragging, setDragging] = (0, _react.useState)(false);
    const dragItems = (0, _react.useRef)([]);
    const lastPos = (0, _react.useRef)({
        x: null,
        y: null
    });
    const autoPanId = (0, _react.useRef)(0);
    const containerBounds = (0, _react.useRef)(null);
    const mousePosition = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const dragEvent = (0, _react.useRef)(null);
    const autoPanStarted = (0, _react.useRef)(false);
    const dragStarted = (0, _react.useRef)(false);
    const abortDrag = (0, _react.useRef)(false);
    const getPointerPosition = useGetPointerPosition();
    (0, _react.useEffect)(()=>{
        if (nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current) {
            const selection = (0, _d3Selection.select)(nodeRef.current);
            const updateNodes = ({ x, y })=>{
                const { nodeInternals, onNodeDrag, onSelectionDrag, updateNodePositions, nodeExtent, snapGrid, snapToGrid, nodeOrigin, onError } = store.getState();
                lastPos.current = {
                    x,
                    y
                };
                let hasChange = false;
                let nodesBox = {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 0
                };
                if (dragItems.current.length > 1 && nodeExtent) {
                    const rect = getNodesBounds(dragItems.current, nodeOrigin);
                    nodesBox = rectToBox(rect);
                }
                dragItems.current = dragItems.current.map((n)=>{
                    const nextPosition = {
                        x: x - n.distance.x,
                        y: y - n.distance.y
                    };
                    if (snapToGrid) {
                        nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                        nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                    }
                    // if there is selection with multiple nodes and a node extent is set, we need to adjust the node extent for each node
                    // based on its position so that the node stays at it's position relative to the selection.
                    const adjustedNodeExtent = [
                        [
                            nodeExtent[0][0],
                            nodeExtent[0][1]
                        ],
                        [
                            nodeExtent[1][0],
                            nodeExtent[1][1]
                        ]
                    ];
                    if (dragItems.current.length > 1 && nodeExtent && !n.extent) {
                        adjustedNodeExtent[0][0] = n.positionAbsolute.x - nodesBox.x + nodeExtent[0][0];
                        var _n_width;
                        adjustedNodeExtent[1][0] = n.positionAbsolute.x + ((_n_width = n.width) !== null && _n_width !== void 0 ? _n_width : 0) - nodesBox.x2 + nodeExtent[1][0];
                        adjustedNodeExtent[0][1] = n.positionAbsolute.y - nodesBox.y + nodeExtent[0][1];
                        var _n_height;
                        adjustedNodeExtent[1][1] = n.positionAbsolute.y + ((_n_height = n.height) !== null && _n_height !== void 0 ? _n_height : 0) - nodesBox.y2 + nodeExtent[1][1];
                    }
                    const updatedPos = calcNextPosition(n, nextPosition, nodeInternals, adjustedNodeExtent, nodeOrigin, onError);
                    // we want to make sure that we only fire a change event when there is a change
                    hasChange = hasChange || n.position.x !== updatedPos.position.x || n.position.y !== updatedPos.position.y;
                    n.position = updatedPos.position;
                    n.positionAbsolute = updatedPos.positionAbsolute;
                    return n;
                });
                if (!hasChange) return;
                updateNodePositions(dragItems.current, true, true);
                setDragging(true);
                const onDrag = nodeId ? onNodeDrag : wrapSelectionDragFunc(onSelectionDrag);
                if (onDrag && dragEvent.current) {
                    const [currentNode, nodes] = getEventHandlerParams({
                        nodeId,
                        dragItems: dragItems.current,
                        nodeInternals
                    });
                    onDrag(dragEvent.current, currentNode, nodes);
                }
            };
            const autoPan = ()=>{
                if (!containerBounds.current) return;
                const [xMovement, yMovement] = calcAutoPan(mousePosition.current, containerBounds.current);
                if (xMovement !== 0 || yMovement !== 0) {
                    const { transform, panBy } = store.getState();
                    var _lastPos_current_x;
                    lastPos.current.x = ((_lastPos_current_x = lastPos.current.x) !== null && _lastPos_current_x !== void 0 ? _lastPos_current_x : 0) - xMovement / transform[2];
                    var _lastPos_current_y;
                    lastPos.current.y = ((_lastPos_current_y = lastPos.current.y) !== null && _lastPos_current_y !== void 0 ? _lastPos_current_y : 0) - yMovement / transform[2];
                    if (panBy({
                        x: xMovement,
                        y: yMovement
                    })) updateNodes(lastPos.current);
                }
                autoPanId.current = requestAnimationFrame(autoPan);
            };
            const startDrag = (event)=>{
                var _nodeInternals_get;
                const { nodeInternals, multiSelectionActive, nodesDraggable, unselectNodesAndEdges, onNodeDragStart, onSelectionDragStart } = store.getState();
                dragStarted.current = true;
                const onStart = nodeId ? onNodeDragStart : wrapSelectionDragFunc(onSelectionDragStart);
                if ((!selectNodesOnDrag || !isSelectable) && !multiSelectionActive && nodeId) {
                    if (!((_nodeInternals_get = nodeInternals.get(nodeId)) === null || _nodeInternals_get === void 0 ? void 0 : _nodeInternals_get.selected)) // we need to reset selected nodes when selectNodesOnDrag=false
                    unselectNodesAndEdges();
                }
                if (nodeId && isSelectable && selectNodesOnDrag) handleNodeClick({
                    id: nodeId,
                    store,
                    nodeRef: nodeRef
                });
                const pointerPos = getPointerPosition(event);
                lastPos.current = pointerPos;
                dragItems.current = getDragItems(nodeInternals, nodesDraggable, pointerPos, nodeId);
                if (onStart && dragItems.current) {
                    const [currentNode, nodes] = getEventHandlerParams({
                        nodeId,
                        dragItems: dragItems.current,
                        nodeInternals
                    });
                    onStart(event.sourceEvent, currentNode, nodes);
                }
            };
            if (disabled) selection.on('.drag', null);
            else {
                const dragHandler = (0, _d3Drag.drag)().on('start', (event)=>{
                    const { domNode, nodeDragThreshold } = store.getState();
                    if (nodeDragThreshold === 0) startDrag(event);
                    abortDrag.current = false;
                    const pointerPos = getPointerPosition(event);
                    lastPos.current = pointerPos;
                    containerBounds.current = (domNode === null || domNode === void 0 ? void 0 : domNode.getBoundingClientRect()) || null;
                    mousePosition.current = getEventPosition(event.sourceEvent, containerBounds.current);
                }).on('drag', (event)=>{
                    const pointerPos = getPointerPosition(event);
                    const { autoPanOnNodeDrag, nodeDragThreshold } = store.getState();
                    if (event.sourceEvent.type === 'touchmove' && event.sourceEvent.touches.length > 1) abortDrag.current = true;
                    if (abortDrag.current) return;
                    if (!autoPanStarted.current && dragStarted.current && autoPanOnNodeDrag) {
                        autoPanStarted.current = true;
                        autoPan();
                    }
                    if (!dragStarted.current) {
                        var _lastPos_current, _lastPos_current1;
                        var _lastPos_current_x;
                        const x = pointerPos.xSnapped - ((_lastPos_current_x = lastPos === null || lastPos === void 0 ? void 0 : (_lastPos_current = lastPos.current) === null || _lastPos_current === void 0 ? void 0 : _lastPos_current.x) !== null && _lastPos_current_x !== void 0 ? _lastPos_current_x : 0);
                        var _lastPos_current_y;
                        const y = pointerPos.ySnapped - ((_lastPos_current_y = lastPos === null || lastPos === void 0 ? void 0 : (_lastPos_current1 = lastPos.current) === null || _lastPos_current1 === void 0 ? void 0 : _lastPos_current1.y) !== null && _lastPos_current_y !== void 0 ? _lastPos_current_y : 0);
                        const distance = Math.sqrt(x * x + y * y);
                        if (distance > nodeDragThreshold) startDrag(event);
                    }
                    // skip events without movement
                    if ((lastPos.current.x !== pointerPos.xSnapped || lastPos.current.y !== pointerPos.ySnapped) && dragItems.current && dragStarted.current) {
                        dragEvent.current = event.sourceEvent;
                        mousePosition.current = getEventPosition(event.sourceEvent, containerBounds.current);
                        updateNodes(pointerPos);
                    }
                }).on('end', (event)=>{
                    if (!dragStarted.current || abortDrag.current) return;
                    setDragging(false);
                    autoPanStarted.current = false;
                    dragStarted.current = false;
                    cancelAnimationFrame(autoPanId.current);
                    if (dragItems.current) {
                        const { updateNodePositions, nodeInternals, onNodeDragStop, onSelectionDragStop } = store.getState();
                        const onStop = nodeId ? onNodeDragStop : wrapSelectionDragFunc(onSelectionDragStop);
                        updateNodePositions(dragItems.current, false, false);
                        if (onStop) {
                            const [currentNode, nodes] = getEventHandlerParams({
                                nodeId,
                                dragItems: dragItems.current,
                                nodeInternals
                            });
                            onStop(event.sourceEvent, currentNode, nodes);
                        }
                    }
                }).filter((event)=>{
                    const target = event.target;
                    const isDraggable = !event.button && (!noDragClassName || !hasSelector(target, `.${noDragClassName}`, nodeRef)) && (!handleSelector || hasSelector(target, handleSelector, nodeRef));
                    return isDraggable;
                });
                selection.call(dragHandler);
                return ()=>{
                    selection.on('.drag', null);
                };
            }
        }
    }, [
        nodeRef,
        disabled,
        noDragClassName,
        handleSelector,
        isSelectable,
        store,
        nodeId,
        selectNodesOnDrag,
        getPointerPosition
    ]);
    return dragging;
}
function useUpdateNodePositions() {
    const store = useStoreApi();
    const updatePositions = (0, _react.useCallback)((params)=>{
        const { nodeInternals, nodeExtent, updateNodePositions, getNodes, snapToGrid, snapGrid, onError, nodesDraggable } = store.getState();
        const selectedNodes = getNodes().filter((n)=>n.selected && (n.draggable || nodesDraggable && typeof n.draggable === 'undefined'));
        // by default a node moves 5px on each key press, or 20px if shift is pressed
        // if snap grid is enabled, we use that for the velocity.
        const xVelo = snapToGrid ? snapGrid[0] : 5;
        const yVelo = snapToGrid ? snapGrid[1] : 5;
        const factor = params.isShiftPressed ? 4 : 1;
        const positionDiffX = params.x * xVelo * factor;
        const positionDiffY = params.y * yVelo * factor;
        const nodeUpdates = selectedNodes.map((n)=>{
            if (n.positionAbsolute) {
                const nextPosition = {
                    x: n.positionAbsolute.x + positionDiffX,
                    y: n.positionAbsolute.y + positionDiffY
                };
                if (snapToGrid) {
                    nextPosition.x = snapGrid[0] * Math.round(nextPosition.x / snapGrid[0]);
                    nextPosition.y = snapGrid[1] * Math.round(nextPosition.y / snapGrid[1]);
                }
                const { positionAbsolute, position } = calcNextPosition(n, nextPosition, nodeInternals, nodeExtent, undefined, onError);
                n.position = position;
                n.positionAbsolute = positionAbsolute;
            }
            return n;
        });
        updateNodePositions(nodeUpdates, true, false);
    }, []);
    return updatePositions;
}
const arrowKeyDiffs = {
    ArrowUp: {
        x: 0,
        y: -1
    },
    ArrowDown: {
        x: 0,
        y: 1
    },
    ArrowLeft: {
        x: -1,
        y: 0
    },
    ArrowRight: {
        x: 1,
        y: 0
    }
};
var wrapNode = (NodeComponent)=>{
    const NodeWrapper = ({ id, type, data, xPos, yPos, xPosOrigin, yPosOrigin, selected, onClick, onMouseEnter, onMouseMove, onMouseLeave, onContextMenu, onDoubleClick, style, className, isDraggable, isSelectable, isConnectable, isFocusable, selectNodesOnDrag, sourcePosition, targetPosition, hidden, resizeObserver, dragHandle, zIndex, isParent, noDragClassName, noPanClassName, initialized, disableKeyboardA11y, ariaLabel, rfId, hasHandleBounds })=>{
        const store = useStoreApi();
        const nodeRef = (0, _react.useRef)(null);
        const prevNodeRef = (0, _react.useRef)(null);
        const prevSourcePosition = (0, _react.useRef)(sourcePosition);
        const prevTargetPosition = (0, _react.useRef)(targetPosition);
        const prevType = (0, _react.useRef)(type);
        const hasPointerEvents = isSelectable || isDraggable || onClick || onMouseEnter || onMouseMove || onMouseLeave;
        const updatePositions = useUpdateNodePositions();
        const onMouseEnterHandler = getMouseHandler(id, store.getState, onMouseEnter);
        const onMouseMoveHandler = getMouseHandler(id, store.getState, onMouseMove);
        const onMouseLeaveHandler = getMouseHandler(id, store.getState, onMouseLeave);
        const onContextMenuHandler = getMouseHandler(id, store.getState, onContextMenu);
        const onDoubleClickHandler = getMouseHandler(id, store.getState, onDoubleClick);
        const onSelectNodeHandler = (event)=>{
            const { nodeDragThreshold } = store.getState();
            if (isSelectable && (!selectNodesOnDrag || !isDraggable || nodeDragThreshold > 0)) // this handler gets called within the drag start event when selectNodesOnDrag=true
            handleNodeClick({
                id,
                store,
                nodeRef
            });
            if (onClick) {
                const node = store.getState().nodeInternals.get(id);
                if (node) onClick(event, (0, _objectSpread._)({}, node));
            }
        };
        const onKeyDown = (event)=>{
            if (isInputDOMNode(event)) return;
            if (disableKeyboardA11y) return;
            if (elementSelectionKeys.includes(event.key) && isSelectable) {
                const unselect = event.key === 'Escape';
                handleNodeClick({
                    id,
                    store,
                    unselect,
                    nodeRef
                });
            } else if (isDraggable && selected && Object.prototype.hasOwnProperty.call(arrowKeyDiffs, event.key)) {
                store.setState({
                    ariaLiveMessage: `Moved selected node ${event.key.replace('Arrow', '').toLowerCase()}. New position, x: ${~~xPos}, y: ${~~yPos}`
                });
                updatePositions({
                    x: arrowKeyDiffs[event.key].x,
                    y: arrowKeyDiffs[event.key].y,
                    isShiftPressed: event.shiftKey
                });
            }
        };
        (0, _react.useEffect)(()=>{
            return ()=>{
                if (prevNodeRef.current) {
                    resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.unobserve(prevNodeRef.current);
                    prevNodeRef.current = null;
                }
            };
        }, []);
        (0, _react.useEffect)(()=>{
            if (nodeRef.current && !hidden) {
                const currNode = nodeRef.current;
                if (!initialized || !hasHandleBounds || prevNodeRef.current !== currNode) {
                    // At this point we always want to make sure that the node gets re-measured / re-initialized.
                    // We need to unobserve it first in case it is still observed
                    if (prevNodeRef.current) resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.unobserve(prevNodeRef.current);
                    resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.observe(currNode);
                    prevNodeRef.current = currNode;
                }
            }
        }, [
            hidden,
            initialized,
            hasHandleBounds
        ]);
        (0, _react.useEffect)(()=>{
            // when the user programmatically changes the source or handle position, we re-initialize the node
            const typeChanged = prevType.current !== type;
            const sourcePosChanged = prevSourcePosition.current !== sourcePosition;
            const targetPosChanged = prevTargetPosition.current !== targetPosition;
            if (nodeRef.current && (typeChanged || sourcePosChanged || targetPosChanged)) {
                if (typeChanged) prevType.current = type;
                if (sourcePosChanged) prevSourcePosition.current = sourcePosition;
                if (targetPosChanged) prevTargetPosition.current = targetPosition;
                store.getState().updateNodeDimensions([
                    {
                        id,
                        nodeElement: nodeRef.current,
                        forceUpdate: true
                    }
                ]);
            }
        }, [
            id,
            type,
            sourcePosition,
            targetPosition
        ]);
        const dragging = useDrag({
            nodeRef,
            disabled: hidden || !isDraggable,
            noDragClassName,
            handleSelector: dragHandle,
            nodeId: id,
            isSelectable,
            selectNodesOnDrag
        });
        if (hidden) return null;
        return (0, _reactDefault.default).createElement("div", {
            className: (0, _classcatDefault.default)([
                'react-flow__node',
                `react-flow__node-${type}`,
                {
                    // this is overwritable by passing `nopan` as a class name
                    [noPanClassName]: isDraggable
                },
                className,
                {
                    selected,
                    selectable: isSelectable,
                    parent: isParent,
                    dragging
                }
            ]),
            ref: nodeRef,
            style: (0, _objectSpread._)({
                zIndex,
                transform: `translate(${xPosOrigin}px,${yPosOrigin}px)`,
                pointerEvents: hasPointerEvents ? 'all' : 'none',
                visibility: initialized ? 'visible' : 'hidden'
            }, style),
            "data-id": id,
            "data-testid": `rf__node-${id}`,
            onMouseEnter: onMouseEnterHandler,
            onMouseMove: onMouseMoveHandler,
            onMouseLeave: onMouseLeaveHandler,
            onContextMenu: onContextMenuHandler,
            onClick: onSelectNodeHandler,
            onDoubleClick: onDoubleClickHandler,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : undefined,
            "aria-describedby": disableKeyboardA11y ? undefined : `${ARIA_NODE_DESC_KEY}-${rfId}`,
            "aria-label": ariaLabel
        }, (0, _reactDefault.default).createElement(Provider, {
            value: id
        }, (0, _reactDefault.default).createElement(NodeComponent, {
            id: id,
            data: data,
            type: type,
            xPos: xPos,
            yPos: yPos,
            selected: selected,
            isConnectable: isConnectable,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            dragging: dragging,
            dragHandle: dragHandle,
            zIndex: zIndex
        })));
    };
    NodeWrapper.displayName = 'NodeWrapper';
    return (0, _react.memo)(NodeWrapper);
};
/**
 * The nodes selection rectangle gets displayed when a user
 * made a selection with on or several nodes
 */ const selector$7 = (s)=>{
    const selectedNodes = s.getNodes().filter((n)=>n.selected);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getNodesBounds(selectedNodes, s.nodeOrigin)), {
        transformString: `translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`,
        userSelectionActive: s.userSelectionActive
    });
};
function NodesSelection({ onSelectionContextMenu, noPanClassName, disableKeyboardA11y }) {
    const store = useStoreApi();
    const { width, height, x: left, y: top, transformString, userSelectionActive } = useStore(selector$7, (0, _shallow.shallow));
    const updatePositions = useUpdateNodePositions();
    const nodeRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        var _nodeRef_current;
        if (!disableKeyboardA11y) (_nodeRef_current = nodeRef.current) === null || _nodeRef_current === void 0 ? void 0 : _nodeRef_current.focus({
            preventScroll: true
        });
    }, [
        disableKeyboardA11y
    ]);
    useDrag({
        nodeRef
    });
    if (userSelectionActive || !width || !height) return null;
    const onContextMenu = onSelectionContextMenu ? (event)=>{
        const selectedNodes = store.getState().getNodes().filter((n)=>n.selected);
        onSelectionContextMenu(event, selectedNodes);
    } : undefined;
    const onKeyDown = (event)=>{
        if (Object.prototype.hasOwnProperty.call(arrowKeyDiffs, event.key)) updatePositions({
            x: arrowKeyDiffs[event.key].x,
            y: arrowKeyDiffs[event.key].y,
            isShiftPressed: event.shiftKey
        });
    };
    return (0, _reactDefault.default).createElement("div", {
        className: (0, _classcatDefault.default)([
            'react-flow__nodesselection',
            'react-flow__container',
            noPanClassName
        ]),
        style: {
            transform: transformString
        }
    }, (0, _reactDefault.default).createElement("div", {
        ref: nodeRef,
        className: "react-flow__nodesselection-rect",
        onContextMenu: onContextMenu,
        tabIndex: disableKeyboardA11y ? undefined : -1,
        onKeyDown: disableKeyboardA11y ? undefined : onKeyDown,
        style: {
            width,
            height,
            top,
            left
        }
    }));
}
var NodesSelection$1 = (0, _react.memo)(NodesSelection);
const selector$6 = (s)=>s.nodesSelectionActive;
const FlowRenderer = ({ children, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneContextMenu, onPaneScroll, deleteKeyCode, onMove, onMoveStart, onMoveEnd, selectionKeyCode, selectionOnDrag, selectionMode, onSelectionStart, onSelectionEnd, multiSelectionKeyCode, panActivationKeyCode, zoomActivationKeyCode, elementsSelectable, zoomOnScroll, zoomOnPinch, panOnScroll: _panOnScroll, panOnScrollSpeed, panOnScrollMode, zoomOnDoubleClick, panOnDrag: _panOnDrag, defaultViewport, translateExtent, minZoom, maxZoom, preventScrolling, onSelectionContextMenu, noWheelClassName, noPanClassName, disableKeyboardA11y })=>{
    const nodesSelectionActive = useStore(selector$6);
    const selectionKeyPressed = useKeyPress(selectionKeyCode);
    const panActivationKeyPressed = useKeyPress(panActivationKeyCode);
    const panOnDrag = panActivationKeyPressed || _panOnDrag;
    const panOnScroll = panActivationKeyPressed || _panOnScroll;
    const isSelecting = selectionKeyPressed || selectionOnDrag && panOnDrag !== true;
    useGlobalKeyHandler({
        deleteKeyCode,
        multiSelectionKeyCode
    });
    return (0, _reactDefault.default).createElement(ZoomPane, {
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onPaneContextMenu: onPaneContextMenu,
        elementsSelectable: elementsSelectable,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnDrag: !selectionKeyPressed && panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        zoomActivationKeyCode: zoomActivationKeyCode,
        preventScrolling: preventScrolling,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName
    }, (0, _reactDefault.default).createElement(Pane, {
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        panOnDrag: panOnDrag,
        isSelecting: !!isSelecting,
        selectionMode: selectionMode
    }, children, nodesSelectionActive && (0, _reactDefault.default).createElement(NodesSelection$1, {
        onSelectionContextMenu: onSelectionContextMenu,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    })));
};
FlowRenderer.displayName = 'FlowRenderer';
var FlowRenderer$1 = (0, _react.memo)(FlowRenderer);
function useVisibleNodes(onlyRenderVisible) {
    const nodes = useStore((0, _react.useCallback)((s)=>onlyRenderVisible ? getNodesInside(s.nodeInternals, {
            x: 0,
            y: 0,
            width: s.width,
            height: s.height
        }, s.transform, true) : s.getNodes(), [
        onlyRenderVisible
    ]));
    return nodes;
}
function createNodeTypes(nodeTypes) {
    const standardTypes = {
        input: wrapNode(nodeTypes.input || InputNode$1),
        default: wrapNode(nodeTypes.default || DefaultNode$1),
        output: wrapNode(nodeTypes.output || OutputNode$1),
        group: wrapNode(nodeTypes.group || GroupNode)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(nodeTypes).filter((k)=>![
            'input',
            'default',
            'output',
            'group'
        ].includes(k)).reduce((res, key)=>{
        res[key] = wrapNode(nodeTypes[key] || DefaultNode$1);
        return res;
    }, wrappedTypes);
    return (0, _objectSpread._)({}, standardTypes, specialTypes);
}
const getPositionWithOrigin = ({ x, y, width, height, origin })=>{
    if (!width || !height) return {
        x,
        y
    };
    if (origin[0] < 0 || origin[1] < 0 || origin[0] > 1 || origin[1] > 1) return {
        x,
        y
    };
    return {
        x: x - width * origin[0],
        y: y - height * origin[1]
    };
};
const selector$5 = (s)=>({
        nodesDraggable: s.nodesDraggable,
        nodesConnectable: s.nodesConnectable,
        nodesFocusable: s.nodesFocusable,
        elementsSelectable: s.elementsSelectable,
        updateNodeDimensions: s.updateNodeDimensions,
        onError: s.onError
    });
const NodeRenderer = (props)=>{
    const { nodesDraggable, nodesConnectable, nodesFocusable, elementsSelectable, updateNodeDimensions, onError } = useStore(selector$5, (0, _shallow.shallow));
    const nodes = useVisibleNodes(props.onlyRenderVisibleElements);
    const resizeObserverRef = (0, _react.useRef)();
    const resizeObserver = (0, _react.useMemo)(()=>{
        if (typeof ResizeObserver === 'undefined') return null;
        const observer = new ResizeObserver((entries)=>{
            const updates = entries.map((entry)=>({
                    id: entry.target.getAttribute('data-id'),
                    nodeElement: entry.target,
                    forceUpdate: true
                }));
            updateNodeDimensions(updates);
        });
        resizeObserverRef.current = observer;
        return observer;
    }, []);
    (0, _react.useEffect)(()=>{
        return ()=>{
            var _resizeObserverRef_current;
            resizeObserverRef === null || resizeObserverRef === void 0 ? void 0 : (_resizeObserverRef_current = resizeObserverRef.current) === null || _resizeObserverRef_current === void 0 ? void 0 : _resizeObserverRef_current.disconnect();
        };
    }, []);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__nodes",
        style: containerStyle
    }, nodes.map((node)=>{
        var _node_internalsSymbol, _node_internalsSymbol1, _node_internalsSymbol2;
        let nodeType = node.type || 'default';
        if (!props.nodeTypes[nodeType]) {
            onError === null || onError === void 0 ? void 0 : onError('003', errorMessages['error003'](nodeType));
            nodeType = 'default';
        }
        const NodeComponent = props.nodeTypes[nodeType] || props.nodeTypes.default;
        const isDraggable = !!(node.draggable || nodesDraggable && typeof node.draggable === 'undefined');
        const isSelectable = !!(node.selectable || elementsSelectable && typeof node.selectable === 'undefined');
        const isConnectable = !!(node.connectable || nodesConnectable && typeof node.connectable === 'undefined');
        const isFocusable = !!(node.focusable || nodesFocusable && typeof node.focusable === 'undefined');
        const clampedPosition = props.nodeExtent ? clampPosition(node.positionAbsolute, props.nodeExtent) : node.positionAbsolute;
        var _clampedPosition_x;
        const posX = (_clampedPosition_x = clampedPosition === null || clampedPosition === void 0 ? void 0 : clampedPosition.x) !== null && _clampedPosition_x !== void 0 ? _clampedPosition_x : 0;
        var _clampedPosition_y;
        const posY = (_clampedPosition_y = clampedPosition === null || clampedPosition === void 0 ? void 0 : clampedPosition.y) !== null && _clampedPosition_y !== void 0 ? _clampedPosition_y : 0;
        var _node_width, _node_height;
        const posOrigin = getPositionWithOrigin({
            x: posX,
            y: posY,
            width: (_node_width = node.width) !== null && _node_width !== void 0 ? _node_width : 0,
            height: (_node_height = node.height) !== null && _node_height !== void 0 ? _node_height : 0,
            origin: props.nodeOrigin
        });
        var _node_internalsSymbol_z;
        return (0, _reactDefault.default).createElement(NodeComponent, {
            key: node.id,
            id: node.id,
            className: node.className,
            style: node.style,
            type: nodeType,
            data: node.data,
            sourcePosition: node.sourcePosition || Position.Bottom,
            targetPosition: node.targetPosition || Position.Top,
            hidden: node.hidden,
            xPos: posX,
            yPos: posY,
            xPosOrigin: posOrigin.x,
            yPosOrigin: posOrigin.y,
            selectNodesOnDrag: props.selectNodesOnDrag,
            onClick: props.onNodeClick,
            onMouseEnter: props.onNodeMouseEnter,
            onMouseMove: props.onNodeMouseMove,
            onMouseLeave: props.onNodeMouseLeave,
            onContextMenu: props.onNodeContextMenu,
            onDoubleClick: props.onNodeDoubleClick,
            selected: !!node.selected,
            isDraggable: isDraggable,
            isSelectable: isSelectable,
            isConnectable: isConnectable,
            isFocusable: isFocusable,
            resizeObserver: resizeObserver,
            dragHandle: node.dragHandle,
            zIndex: (_node_internalsSymbol_z = (_node_internalsSymbol = node[internalsSymbol]) === null || _node_internalsSymbol === void 0 ? void 0 : _node_internalsSymbol.z) !== null && _node_internalsSymbol_z !== void 0 ? _node_internalsSymbol_z : 0,
            isParent: !!((_node_internalsSymbol1 = node[internalsSymbol]) === null || _node_internalsSymbol1 === void 0 ? void 0 : _node_internalsSymbol1.isParent),
            noDragClassName: props.noDragClassName,
            noPanClassName: props.noPanClassName,
            initialized: !!node.width && !!node.height,
            rfId: props.rfId,
            disableKeyboardA11y: props.disableKeyboardA11y,
            ariaLabel: node.ariaLabel,
            hasHandleBounds: !!((_node_internalsSymbol2 = node[internalsSymbol]) === null || _node_internalsSymbol2 === void 0 ? void 0 : _node_internalsSymbol2.handleBounds)
        });
    }));
};
NodeRenderer.displayName = 'NodeRenderer';
var NodeRenderer$1 = (0, _react.memo)(NodeRenderer);
const shiftX = (x, shift, position)=>{
    if (position === Position.Left) return x - shift;
    if (position === Position.Right) return x + shift;
    return x;
};
const shiftY = (y, shift, position)=>{
    if (position === Position.Top) return y - shift;
    if (position === Position.Bottom) return y + shift;
    return y;
};
const EdgeUpdaterClassName = 'react-flow__edgeupdater';
const EdgeAnchor = ({ position, centerX, centerY, radius = 10, onMouseDown, onMouseEnter, onMouseOut, type })=>(0, _reactDefault.default).createElement("circle", {
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        className: (0, _classcatDefault.default)([
            EdgeUpdaterClassName,
            `${EdgeUpdaterClassName}-${type}`
        ]),
        cx: shiftX(centerX, radius, position),
        cy: shiftY(centerY, radius, position),
        r: radius,
        stroke: "transparent",
        fill: "transparent"
    });
const alwaysValidConnection = ()=>true;
var wrapEdge = (EdgeComponent)=>{
    const EdgeWrapper = ({ id, className, type, data, onClick, onEdgeDoubleClick, selected, animated, label, labelStyle, labelShowBg, labelBgStyle, labelBgPadding, labelBgBorderRadius, style, source, target, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, elementsSelectable, hidden, sourceHandleId, targetHandleId, onContextMenu, onMouseEnter, onMouseMove, onMouseLeave, reconnectRadius, onReconnect, onReconnectStart, onReconnectEnd, markerEnd, markerStart, rfId, ariaLabel, isFocusable, isReconnectable, pathOptions, interactionWidth, disableKeyboardA11y })=>{
        const edgeRef = (0, _react.useRef)(null);
        const [updateHover, setUpdateHover] = (0, _react.useState)(false);
        const [updating, setUpdating] = (0, _react.useState)(false);
        const store = useStoreApi();
        const markerStartUrl = (0, _react.useMemo)(()=>`url('#${getMarkerId(markerStart, rfId)}')`, [
            markerStart,
            rfId
        ]);
        const markerEndUrl = (0, _react.useMemo)(()=>`url('#${getMarkerId(markerEnd, rfId)}')`, [
            markerEnd,
            rfId
        ]);
        if (hidden) return null;
        const onEdgeClick = (event)=>{
            const { edges, addSelectedEdges, unselectNodesAndEdges, multiSelectionActive } = store.getState();
            const edge = edges.find((e)=>e.id === id);
            if (!edge) return;
            if (elementsSelectable) {
                store.setState({
                    nodesSelectionActive: false
                });
                if (edge.selected && multiSelectionActive) {
                    var _edgeRef_current;
                    unselectNodesAndEdges({
                        nodes: [],
                        edges: [
                            edge
                        ]
                    });
                    (_edgeRef_current = edgeRef.current) === null || _edgeRef_current === void 0 ? void 0 : _edgeRef_current.blur();
                } else addSelectedEdges([
                    id
                ]);
            }
            if (onClick) onClick(event, edge);
        };
        const onEdgeDoubleClickHandler = getMouseHandler$1(id, store.getState, onEdgeDoubleClick);
        const onEdgeContextMenu = getMouseHandler$1(id, store.getState, onContextMenu);
        const onEdgeMouseEnter = getMouseHandler$1(id, store.getState, onMouseEnter);
        const onEdgeMouseMove = getMouseHandler$1(id, store.getState, onMouseMove);
        const onEdgeMouseLeave = getMouseHandler$1(id, store.getState, onMouseLeave);
        const handleEdgeUpdater = (event, isSourceHandle)=>{
            // avoid triggering edge updater if mouse btn is not left
            if (event.button !== 0) return;
            const { edges, isValidConnection: isValidConnectionStore } = store.getState();
            const nodeId = isSourceHandle ? target : source;
            const handleId = (isSourceHandle ? targetHandleId : sourceHandleId) || null;
            const handleType = isSourceHandle ? 'target' : 'source';
            const isValidConnection = isValidConnectionStore || alwaysValidConnection;
            const isTarget = isSourceHandle;
            const edge = edges.find((e)=>e.id === id);
            setUpdating(true);
            onReconnectStart === null || onReconnectStart === void 0 ? void 0 : onReconnectStart(event, edge, handleType);
            const _onReconnectEnd = (evt)=>{
                setUpdating(false);
                onReconnectEnd === null || onReconnectEnd === void 0 ? void 0 : onReconnectEnd(evt, edge, handleType);
            };
            const onConnectEdge = (connection)=>onReconnect === null || onReconnect === void 0 ? void 0 : onReconnect(edge, connection);
            handlePointerDown({
                event,
                handleId,
                nodeId,
                onConnect: onConnectEdge,
                isTarget,
                getState: store.getState,
                setState: store.setState,
                isValidConnection,
                edgeUpdaterType: handleType,
                onReconnectEnd: _onReconnectEnd
            });
        };
        const onEdgeUpdaterSourceMouseDown = (event)=>handleEdgeUpdater(event, true);
        const onEdgeUpdaterTargetMouseDown = (event)=>handleEdgeUpdater(event, false);
        const onEdgeUpdaterMouseEnter = ()=>setUpdateHover(true);
        const onEdgeUpdaterMouseOut = ()=>setUpdateHover(false);
        const inactive = !elementsSelectable && !onClick;
        const onKeyDown = (event)=>{
            if (!disableKeyboardA11y && elementSelectionKeys.includes(event.key) && elementsSelectable) {
                const { unselectNodesAndEdges, addSelectedEdges, edges } = store.getState();
                const unselect = event.key === 'Escape';
                if (unselect) {
                    var _edgeRef_current;
                    (_edgeRef_current = edgeRef.current) === null || _edgeRef_current === void 0 ? void 0 : _edgeRef_current.blur();
                    unselectNodesAndEdges({
                        edges: [
                            edges.find((e)=>e.id === id)
                        ]
                    });
                } else addSelectedEdges([
                    id
                ]);
            }
        };
        return (0, _reactDefault.default).createElement("g", {
            className: (0, _classcatDefault.default)([
                'react-flow__edge',
                `react-flow__edge-${type}`,
                className,
                {
                    selected,
                    animated,
                    inactive,
                    updating: updateHover
                }
            ]),
            onClick: onEdgeClick,
            onDoubleClick: onEdgeDoubleClickHandler,
            onContextMenu: onEdgeContextMenu,
            onMouseEnter: onEdgeMouseEnter,
            onMouseMove: onEdgeMouseMove,
            onMouseLeave: onEdgeMouseLeave,
            onKeyDown: isFocusable ? onKeyDown : undefined,
            tabIndex: isFocusable ? 0 : undefined,
            role: isFocusable ? 'button' : 'img',
            "data-testid": `rf__edge-${id}`,
            "aria-label": ariaLabel === null ? undefined : ariaLabel ? ariaLabel : `Edge from ${source} to ${target}`,
            "aria-describedby": isFocusable ? `${ARIA_EDGE_DESC_KEY}-${rfId}` : undefined,
            ref: edgeRef
        }, !updating && (0, _reactDefault.default).createElement(EdgeComponent, {
            id: id,
            source: source,
            target: target,
            selected: selected,
            animated: animated,
            label: label,
            labelStyle: labelStyle,
            labelShowBg: labelShowBg,
            labelBgStyle: labelBgStyle,
            labelBgPadding: labelBgPadding,
            labelBgBorderRadius: labelBgBorderRadius,
            data: data,
            style: style,
            sourceX: sourceX,
            sourceY: sourceY,
            targetX: targetX,
            targetY: targetY,
            sourcePosition: sourcePosition,
            targetPosition: targetPosition,
            sourceHandleId: sourceHandleId,
            targetHandleId: targetHandleId,
            markerStart: markerStartUrl,
            markerEnd: markerEndUrl,
            pathOptions: pathOptions,
            interactionWidth: interactionWidth
        }), isReconnectable && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (isReconnectable === 'source' || isReconnectable === true) && (0, _reactDefault.default).createElement(EdgeAnchor, {
            position: sourcePosition,
            centerX: sourceX,
            centerY: sourceY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterSourceMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "source"
        }), (isReconnectable === 'target' || isReconnectable === true) && (0, _reactDefault.default).createElement(EdgeAnchor, {
            position: targetPosition,
            centerX: targetX,
            centerY: targetY,
            radius: reconnectRadius,
            onMouseDown: onEdgeUpdaterTargetMouseDown,
            onMouseEnter: onEdgeUpdaterMouseEnter,
            onMouseOut: onEdgeUpdaterMouseOut,
            type: "target"
        })));
    };
    EdgeWrapper.displayName = 'EdgeWrapper';
    return (0, _react.memo)(EdgeWrapper);
};
function createEdgeTypes(edgeTypes) {
    const standardTypes = {
        default: wrapEdge(edgeTypes.default || BezierEdge),
        straight: wrapEdge(edgeTypes.bezier || StraightEdge),
        step: wrapEdge(edgeTypes.step || StepEdge),
        smoothstep: wrapEdge(edgeTypes.step || SmoothStepEdge),
        simplebezier: wrapEdge(edgeTypes.simplebezier || SimpleBezierEdge)
    };
    const wrappedTypes = {};
    const specialTypes = Object.keys(edgeTypes).filter((k)=>![
            'default',
            'bezier'
        ].includes(k)).reduce((res, key)=>{
        res[key] = wrapEdge(edgeTypes[key] || BezierEdge);
        return res;
    }, wrappedTypes);
    return (0, _objectSpread._)({}, standardTypes, specialTypes);
}
function getHandlePosition(position, nodeRect, handle = null) {
    const x = ((handle === null || handle === void 0 ? void 0 : handle.x) || 0) + nodeRect.x;
    const y = ((handle === null || handle === void 0 ? void 0 : handle.y) || 0) + nodeRect.y;
    const width = (handle === null || handle === void 0 ? void 0 : handle.width) || nodeRect.width;
    const height = (handle === null || handle === void 0 ? void 0 : handle.height) || nodeRect.height;
    switch(position){
        case Position.Top:
            return {
                x: x + width / 2,
                y
            };
        case Position.Right:
            return {
                x: x + width,
                y: y + height / 2
            };
        case Position.Bottom:
            return {
                x: x + width / 2,
                y: y + height
            };
        case Position.Left:
            return {
                x,
                y: y + height / 2
            };
    }
}
function getHandle(bounds, handleId) {
    if (!bounds) return null;
    if (bounds.length === 1 || !handleId) return bounds[0];
    else if (handleId) return bounds.find((d)=>d.id === handleId) || null;
    return null;
}
const getEdgePositions = (sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition)=>{
    const sourceHandlePos = getHandlePosition(sourcePosition, sourceNodeRect, sourceHandle);
    const targetHandlePos = getHandlePosition(targetPosition, targetNodeRect, targetHandle);
    return {
        sourceX: sourceHandlePos.x,
        sourceY: sourceHandlePos.y,
        targetX: targetHandlePos.x,
        targetY: targetHandlePos.y
    };
};
function isEdgeVisible({ sourcePos, targetPos, sourceWidth, sourceHeight, targetWidth, targetHeight, width, height, transform }) {
    const edgeBox = {
        x: Math.min(sourcePos.x, targetPos.x),
        y: Math.min(sourcePos.y, targetPos.y),
        x2: Math.max(sourcePos.x + sourceWidth, targetPos.x + targetWidth),
        y2: Math.max(sourcePos.y + sourceHeight, targetPos.y + targetHeight)
    };
    if (edgeBox.x === edgeBox.x2) edgeBox.x2 += 1;
    if (edgeBox.y === edgeBox.y2) edgeBox.y2 += 1;
    const viewBox = rectToBox({
        x: (0 - transform[0]) / transform[2],
        y: (0 - transform[1]) / transform[2],
        width: width / transform[2],
        height: height / transform[2]
    });
    const xOverlap = Math.max(0, Math.min(viewBox.x2, edgeBox.x2) - Math.max(viewBox.x, edgeBox.x));
    const yOverlap = Math.max(0, Math.min(viewBox.y2, edgeBox.y2) - Math.max(viewBox.y, edgeBox.y));
    const overlappingArea = Math.ceil(xOverlap * yOverlap);
    return overlappingArea > 0;
}
function getNodeData(node) {
    var _node_internalsSymbol, _node_positionAbsolute, _node_positionAbsolute1, _node_positionAbsolute2, _node_positionAbsolute3;
    const handleBounds = (node === null || node === void 0 ? void 0 : (_node_internalsSymbol = node[internalsSymbol]) === null || _node_internalsSymbol === void 0 ? void 0 : _node_internalsSymbol.handleBounds) || null;
    const isValid = handleBounds && (node === null || node === void 0 ? void 0 : node.width) && (node === null || node === void 0 ? void 0 : node.height) && typeof (node === null || node === void 0 ? void 0 : (_node_positionAbsolute = node.positionAbsolute) === null || _node_positionAbsolute === void 0 ? void 0 : _node_positionAbsolute.x) !== 'undefined' && typeof (node === null || node === void 0 ? void 0 : (_node_positionAbsolute1 = node.positionAbsolute) === null || _node_positionAbsolute1 === void 0 ? void 0 : _node_positionAbsolute1.y) !== 'undefined';
    return [
        {
            x: (node === null || node === void 0 ? void 0 : (_node_positionAbsolute2 = node.positionAbsolute) === null || _node_positionAbsolute2 === void 0 ? void 0 : _node_positionAbsolute2.x) || 0,
            y: (node === null || node === void 0 ? void 0 : (_node_positionAbsolute3 = node.positionAbsolute) === null || _node_positionAbsolute3 === void 0 ? void 0 : _node_positionAbsolute3.y) || 0,
            width: (node === null || node === void 0 ? void 0 : node.width) || 0,
            height: (node === null || node === void 0 ? void 0 : node.height) || 0
        },
        handleBounds,
        !!isValid
    ];
}
const defaultEdgeTree = [
    {
        level: 0,
        isMaxLevel: true,
        edges: []
    }
];
function groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect = false) {
    let maxLevel = -1;
    const levelLookup = edges.reduce((tree, edge)=>{
        const hasZIndex = isNumeric(edge.zIndex);
        let z = hasZIndex ? edge.zIndex : 0;
        if (elevateEdgesOnSelect) {
            var _sourceNode_internalsSymbol, _targetNode_internalsSymbol;
            const targetNode = nodeInternals.get(edge.target);
            const sourceNode = nodeInternals.get(edge.source);
            const edgeOrConnectedNodeSelected = edge.selected || (targetNode === null || targetNode === void 0 ? void 0 : targetNode.selected) || (sourceNode === null || sourceNode === void 0 ? void 0 : sourceNode.selected);
            const selectedZIndex = Math.max((sourceNode === null || sourceNode === void 0 ? void 0 : (_sourceNode_internalsSymbol = sourceNode[internalsSymbol]) === null || _sourceNode_internalsSymbol === void 0 ? void 0 : _sourceNode_internalsSymbol.z) || 0, (targetNode === null || targetNode === void 0 ? void 0 : (_targetNode_internalsSymbol = targetNode[internalsSymbol]) === null || _targetNode_internalsSymbol === void 0 ? void 0 : _targetNode_internalsSymbol.z) || 0, 1000);
            z = (hasZIndex ? edge.zIndex : 0) + (edgeOrConnectedNodeSelected ? selectedZIndex : 0);
        }
        if (tree[z]) tree[z].push(edge);
        else tree[z] = [
            edge
        ];
        maxLevel = z > maxLevel ? z : maxLevel;
        return tree;
    }, {});
    const edgeTree = Object.entries(levelLookup).map(([key, edges])=>{
        const level = +key;
        return {
            edges,
            level,
            isMaxLevel: level === maxLevel
        };
    });
    if (edgeTree.length === 0) return defaultEdgeTree;
    return edgeTree;
}
function useVisibleEdges(onlyRenderVisible, nodeInternals, elevateEdgesOnSelect) {
    const edges = useStore((0, _react.useCallback)((s)=>{
        if (!onlyRenderVisible) return s.edges;
        return s.edges.filter((e)=>{
            const sourceNode = nodeInternals.get(e.source);
            const targetNode = nodeInternals.get(e.target);
            return (sourceNode === null || sourceNode === void 0 ? void 0 : sourceNode.width) && (sourceNode === null || sourceNode === void 0 ? void 0 : sourceNode.height) && (targetNode === null || targetNode === void 0 ? void 0 : targetNode.width) && (targetNode === null || targetNode === void 0 ? void 0 : targetNode.height) && isEdgeVisible({
                sourcePos: sourceNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                targetPos: targetNode.positionAbsolute || {
                    x: 0,
                    y: 0
                },
                sourceWidth: sourceNode.width,
                sourceHeight: sourceNode.height,
                targetWidth: targetNode.width,
                targetHeight: targetNode.height,
                width: s.width,
                height: s.height,
                transform: s.transform
            });
        });
    }, [
        onlyRenderVisible,
        nodeInternals
    ]));
    return groupEdgesByZLevel(edges, nodeInternals, elevateEdgesOnSelect);
}
const ArrowSymbol = ({ color = 'none', strokeWidth = 1 })=>{
    return (0, _reactDefault.default).createElement("polyline", {
        style: {
            stroke: color,
            strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        points: "-5,-4 0,0 -5,4"
    });
};
const ArrowClosedSymbol = ({ color = 'none', strokeWidth = 1 })=>{
    return (0, _reactDefault.default).createElement("polyline", {
        style: {
            stroke: color,
            fill: color,
            strokeWidth
        },
        strokeLinecap: "round",
        strokeLinejoin: "round",
        points: "-5,-4 0,0 -5,4 -5,-4"
    });
};
const MarkerSymbols = {
    [MarkerType.Arrow]: ArrowSymbol,
    [MarkerType.ArrowClosed]: ArrowClosedSymbol
};
function useMarkerSymbol(type) {
    const store = useStoreApi();
    const symbol = (0, _react.useMemo)(()=>{
        const symbolExists = Object.prototype.hasOwnProperty.call(MarkerSymbols, type);
        if (!symbolExists) {
            var _store_getState_onError, _store_getState;
            (_store_getState_onError = (_store_getState = store.getState()).onError) === null || _store_getState_onError === void 0 ? void 0 : _store_getState_onError.call(_store_getState, '009', errorMessages['error009'](type));
            return null;
        }
        return MarkerSymbols[type];
    }, [
        type
    ]);
    return symbol;
}
const Marker = ({ id, type, color, width = 12.5, height = 12.5, markerUnits = 'strokeWidth', strokeWidth, orient = 'auto-start-reverse' })=>{
    const Symbol1 = useMarkerSymbol(type);
    if (!Symbol1) return null;
    return (0, _reactDefault.default).createElement("marker", {
        className: "react-flow__arrowhead",
        id: id,
        markerWidth: `${width}`,
        markerHeight: `${height}`,
        viewBox: "-10 -10 20 20",
        markerUnits: markerUnits,
        orient: orient,
        refX: "0",
        refY: "0"
    }, (0, _reactDefault.default).createElement(Symbol1, {
        color: color,
        strokeWidth: strokeWidth
    }));
};
const markerSelector = ({ defaultColor, rfId })=>(s)=>{
        const ids = [];
        return s.edges.reduce((markers, edge)=>{
            [
                edge.markerStart,
                edge.markerEnd
            ].forEach((marker)=>{
                if (marker && typeof marker === 'object') {
                    const markerId = getMarkerId(marker, rfId);
                    if (!ids.includes(markerId)) {
                        markers.push((0, _objectSpread._)({
                            id: markerId,
                            color: marker.color || defaultColor
                        }, marker));
                        ids.push(markerId);
                    }
                }
            });
            return markers;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
    };
// when you have multiple flows on a page and you hide the first one, the other ones have no markers anymore
// when they do have markers with the same ids. To prevent this the user can pass a unique id to the react flow wrapper
// that we can then use for creating our unique marker ids
const MarkerDefinitions = ({ defaultColor, rfId })=>{
    const markers = useStore((0, _react.useCallback)(markerSelector({
        defaultColor,
        rfId
    }), [
        defaultColor,
        rfId
    ]), // the id includes all marker options, so we just need to look at that part of the marker
    (a, b)=>!(a.length !== b.length || a.some((m, i)=>m.id !== b[i].id)));
    return (0, _reactDefault.default).createElement("defs", null, markers.map((marker)=>(0, _reactDefault.default).createElement(Marker, {
            id: marker.id,
            key: marker.id,
            type: marker.type,
            color: marker.color,
            width: marker.width,
            height: marker.height,
            markerUnits: marker.markerUnits,
            strokeWidth: marker.strokeWidth,
            orient: marker.orient
        })));
};
MarkerDefinitions.displayName = 'MarkerDefinitions';
var MarkerDefinitions$1 = (0, _react.memo)(MarkerDefinitions);
const selector$4 = (s)=>({
        nodesConnectable: s.nodesConnectable,
        edgesFocusable: s.edgesFocusable,
        edgesUpdatable: s.edgesUpdatable,
        elementsSelectable: s.elementsSelectable,
        width: s.width,
        height: s.height,
        connectionMode: s.connectionMode,
        nodeInternals: s.nodeInternals,
        onError: s.onError
    });
const EdgeRenderer = ({ defaultMarkerColor, onlyRenderVisibleElements, elevateEdgesOnSelect, rfId, edgeTypes, noPanClassName, onEdgeContextMenu, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onEdgeClick, onEdgeDoubleClick, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius, children, disableKeyboardA11y })=>{
    const { edgesFocusable, edgesUpdatable, elementsSelectable, width, height, connectionMode, nodeInternals, onError } = useStore(selector$4, (0, _shallow.shallow));
    const edgeTree = useVisibleEdges(onlyRenderVisibleElements, nodeInternals, elevateEdgesOnSelect);
    if (!width) return null;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, edgeTree.map(({ level, edges, isMaxLevel })=>(0, _reactDefault.default).createElement("svg", {
            key: level,
            style: {
                zIndex: level
            },
            width: width,
            height: height,
            className: "react-flow__edges react-flow__container"
        }, isMaxLevel && (0, _reactDefault.default).createElement(MarkerDefinitions$1, {
            defaultColor: defaultMarkerColor,
            rfId: rfId
        }), (0, _reactDefault.default).createElement("g", null, edges.map((edge)=>{
            const [sourceNodeRect, sourceHandleBounds, sourceIsValid] = getNodeData(nodeInternals.get(edge.source));
            const [targetNodeRect, targetHandleBounds, targetIsValid] = getNodeData(nodeInternals.get(edge.target));
            if (!sourceIsValid || !targetIsValid) return null;
            let edgeType = edge.type || 'default';
            if (!edgeTypes[edgeType]) {
                onError === null || onError === void 0 ? void 0 : onError('011', errorMessages['error011'](edgeType));
                edgeType = 'default';
            }
            const EdgeComponent = edgeTypes[edgeType] || edgeTypes.default;
            var _targetHandleBounds_target, _targetHandleBounds_source;
            // when connection type is loose we can define all handles as sources and connect source -> source
            const targetNodeHandles = connectionMode === ConnectionMode.Strict ? targetHandleBounds.target : ((_targetHandleBounds_target = targetHandleBounds.target) !== null && _targetHandleBounds_target !== void 0 ? _targetHandleBounds_target : []).concat((_targetHandleBounds_source = targetHandleBounds.source) !== null && _targetHandleBounds_source !== void 0 ? _targetHandleBounds_source : []);
            const sourceHandle = getHandle(sourceHandleBounds.source, edge.sourceHandle);
            const targetHandle = getHandle(targetNodeHandles, edge.targetHandle);
            const sourcePosition = (sourceHandle === null || sourceHandle === void 0 ? void 0 : sourceHandle.position) || Position.Bottom;
            const targetPosition = (targetHandle === null || targetHandle === void 0 ? void 0 : targetHandle.position) || Position.Top;
            const isFocusable = !!(edge.focusable || edgesFocusable && typeof edge.focusable === 'undefined');
            const edgeReconnectable = edge.reconnectable || edge.updatable;
            const isReconnectable = typeof onReconnect !== 'undefined' && (edgeReconnectable || edgesUpdatable && typeof edgeReconnectable === 'undefined');
            if (!sourceHandle || !targetHandle) {
                onError === null || onError === void 0 ? void 0 : onError('008', errorMessages['error008'](sourceHandle, edge));
                return null;
            }
            const { sourceX, sourceY, targetX, targetY } = getEdgePositions(sourceNodeRect, sourceHandle, sourcePosition, targetNodeRect, targetHandle, targetPosition);
            return (0, _reactDefault.default).createElement(EdgeComponent, {
                key: edge.id,
                id: edge.id,
                className: (0, _classcatDefault.default)([
                    edge.className,
                    noPanClassName
                ]),
                type: edgeType,
                data: edge.data,
                selected: !!edge.selected,
                animated: !!edge.animated,
                hidden: !!edge.hidden,
                label: edge.label,
                labelStyle: edge.labelStyle,
                labelShowBg: edge.labelShowBg,
                labelBgStyle: edge.labelBgStyle,
                labelBgPadding: edge.labelBgPadding,
                labelBgBorderRadius: edge.labelBgBorderRadius,
                style: edge.style,
                source: edge.source,
                target: edge.target,
                sourceHandleId: edge.sourceHandle,
                targetHandleId: edge.targetHandle,
                markerEnd: edge.markerEnd,
                markerStart: edge.markerStart,
                sourceX: sourceX,
                sourceY: sourceY,
                targetX: targetX,
                targetY: targetY,
                sourcePosition: sourcePosition,
                targetPosition: targetPosition,
                elementsSelectable: elementsSelectable,
                onContextMenu: onEdgeContextMenu,
                onMouseEnter: onEdgeMouseEnter,
                onMouseMove: onEdgeMouseMove,
                onMouseLeave: onEdgeMouseLeave,
                onClick: onEdgeClick,
                onEdgeDoubleClick: onEdgeDoubleClick,
                onReconnect: onReconnect,
                onReconnectStart: onReconnectStart,
                onReconnectEnd: onReconnectEnd,
                reconnectRadius: reconnectRadius,
                rfId: rfId,
                ariaLabel: edge.ariaLabel,
                isFocusable: isFocusable,
                isReconnectable: isReconnectable,
                pathOptions: 'pathOptions' in edge ? edge.pathOptions : undefined,
                interactionWidth: edge.interactionWidth,
                disableKeyboardA11y: disableKeyboardA11y
            });
        })))), children);
};
EdgeRenderer.displayName = 'EdgeRenderer';
var EdgeRenderer$1 = (0, _react.memo)(EdgeRenderer);
const selector$3 = (s)=>`translate(${s.transform[0]}px,${s.transform[1]}px) scale(${s.transform[2]})`;
function Viewport({ children }) {
    const transform = useStore(selector$3);
    return (0, _reactDefault.default).createElement("div", {
        className: "react-flow__viewport react-flow__container",
        style: {
            transform
        }
    }, children);
}
function useOnInitHandler(onInit) {
    const rfInstance = useReactFlow();
    const isInitialized = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        if (!isInitialized.current && rfInstance.viewportInitialized && onInit) {
            setTimeout(()=>onInit(rfInstance), 1);
            isInitialized.current = true;
        }
    }, [
        onInit,
        rfInstance.viewportInitialized
    ]);
}
const oppositePosition = {
    [Position.Left]: Position.Right,
    [Position.Right]: Position.Left,
    [Position.Top]: Position.Bottom,
    [Position.Bottom]: Position.Top
};
const ConnectionLine = ({ nodeId, handleType, style, type = ConnectionLineType.Bezier, CustomComponent, connectionStatus })=>{
    var _fromNode_internalsSymbol, _fromNode_positionAbsolute, _fromNode_positionAbsolute1;
    const { fromNode, handleId, toX, toY, connectionMode } = useStore((0, _react.useCallback)((s)=>({
            fromNode: s.nodeInternals.get(nodeId),
            handleId: s.connectionHandleId,
            toX: (s.connectionPosition.x - s.transform[0]) / s.transform[2],
            toY: (s.connectionPosition.y - s.transform[1]) / s.transform[2],
            connectionMode: s.connectionMode
        }), [
        nodeId
    ]), (0, _shallow.shallow));
    const fromHandleBounds = fromNode === null || fromNode === void 0 ? void 0 : (_fromNode_internalsSymbol = fromNode[internalsSymbol]) === null || _fromNode_internalsSymbol === void 0 ? void 0 : _fromNode_internalsSymbol.handleBounds;
    let handleBounds = fromHandleBounds === null || fromHandleBounds === void 0 ? void 0 : fromHandleBounds[handleType];
    if (connectionMode === ConnectionMode.Loose) handleBounds = handleBounds ? handleBounds : fromHandleBounds === null || fromHandleBounds === void 0 ? void 0 : fromHandleBounds[handleType === 'source' ? 'target' : 'source'];
    if (!fromNode || !handleBounds) return null;
    const fromHandle = handleId ? handleBounds.find((d)=>d.id === handleId) : handleBounds[0];
    var _fromNode_width;
    const fromHandleX = fromHandle ? fromHandle.x + fromHandle.width / 2 : ((_fromNode_width = fromNode.width) !== null && _fromNode_width !== void 0 ? _fromNode_width : 0) / 2;
    var _fromNode_height;
    const fromHandleY = fromHandle ? fromHandle.y + fromHandle.height / 2 : (_fromNode_height = fromNode.height) !== null && _fromNode_height !== void 0 ? _fromNode_height : 0;
    var _fromNode_positionAbsolute_x;
    const fromX = ((_fromNode_positionAbsolute_x = (_fromNode_positionAbsolute = fromNode.positionAbsolute) === null || _fromNode_positionAbsolute === void 0 ? void 0 : _fromNode_positionAbsolute.x) !== null && _fromNode_positionAbsolute_x !== void 0 ? _fromNode_positionAbsolute_x : 0) + fromHandleX;
    var _fromNode_positionAbsolute_y;
    const fromY = ((_fromNode_positionAbsolute_y = (_fromNode_positionAbsolute1 = fromNode.positionAbsolute) === null || _fromNode_positionAbsolute1 === void 0 ? void 0 : _fromNode_positionAbsolute1.y) !== null && _fromNode_positionAbsolute_y !== void 0 ? _fromNode_positionAbsolute_y : 0) + fromHandleY;
    const fromPosition = fromHandle === null || fromHandle === void 0 ? void 0 : fromHandle.position;
    const toPosition = fromPosition ? oppositePosition[fromPosition] : null;
    if (!fromPosition || !toPosition) return null;
    if (CustomComponent) return (0, _reactDefault.default).createElement(CustomComponent, {
        connectionLineType: type,
        connectionLineStyle: style,
        fromNode: fromNode,
        fromHandle: fromHandle,
        fromX: fromX,
        fromY: fromY,
        toX: toX,
        toY: toY,
        fromPosition: fromPosition,
        toPosition: toPosition,
        connectionStatus: connectionStatus
    });
    let dAttr = '';
    const pathParams = {
        sourceX: fromX,
        sourceY: fromY,
        sourcePosition: fromPosition,
        targetX: toX,
        targetY: toY,
        targetPosition: toPosition
    };
    if (type === ConnectionLineType.Bezier) // we assume the destination position is opposite to the source position
    [dAttr] = getBezierPath(pathParams);
    else if (type === ConnectionLineType.Step) [dAttr] = getSmoothStepPath((0, _objectSpreadProps._)((0, _objectSpread._)({}, pathParams), {
        borderRadius: 0
    }));
    else if (type === ConnectionLineType.SmoothStep) [dAttr] = getSmoothStepPath(pathParams);
    else if (type === ConnectionLineType.SimpleBezier) [dAttr] = getSimpleBezierPath(pathParams);
    else dAttr = `M${fromX},${fromY} ${toX},${toY}`;
    return (0, _reactDefault.default).createElement("path", {
        d: dAttr,
        fill: "none",
        className: "react-flow__connection-path",
        style: style
    });
};
ConnectionLine.displayName = 'ConnectionLine';
const selector$2 = (s)=>({
        nodeId: s.connectionNodeId,
        handleType: s.connectionHandleType,
        nodesConnectable: s.nodesConnectable,
        connectionStatus: s.connectionStatus,
        width: s.width,
        height: s.height
    });
function ConnectionLineWrapper({ containerStyle, style, type, component }) {
    const { nodeId, handleType, nodesConnectable, width, height, connectionStatus } = useStore(selector$2, (0, _shallow.shallow));
    const isValid = !!(nodeId && handleType && width && nodesConnectable);
    if (!isValid) return null;
    return (0, _reactDefault.default).createElement("svg", {
        style: containerStyle,
        width: width,
        height: height,
        className: "react-flow__edges react-flow__connectionline react-flow__container"
    }, (0, _reactDefault.default).createElement("g", {
        className: (0, _classcatDefault.default)([
            'react-flow__connection',
            connectionStatus
        ])
    }, (0, _reactDefault.default).createElement(ConnectionLine, {
        nodeId: nodeId,
        handleType: handleType,
        style: style,
        type: type,
        CustomComponent: component,
        connectionStatus: connectionStatus
    })));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function useNodeOrEdgeTypes(nodeOrEdgeTypes, createTypes) {
    const typesKeysRef = (0, _react.useRef)(null);
    const store = useStoreApi();
    const typesParsed = (0, _react.useMemo)(()=>{
        return createTypes(nodeOrEdgeTypes);
    }, [
        nodeOrEdgeTypes
    ]);
    return typesParsed;
}
const GraphView = ({ nodeTypes, edgeTypes, onMove, onMoveStart, onMoveEnd, onInit, onNodeClick, onEdgeClick, onNodeDoubleClick, onEdgeDoubleClick, onNodeMouseEnter, onNodeMouseMove, onNodeMouseLeave, onNodeContextMenu, onSelectionContextMenu, onSelectionStart, onSelectionEnd, connectionLineType, connectionLineStyle, connectionLineComponent, connectionLineContainerStyle, selectionKeyCode, selectionOnDrag, selectionMode, multiSelectionKeyCode, panActivationKeyCode, zoomActivationKeyCode, deleteKeyCode, onlyRenderVisibleElements, elementsSelectable, selectNodesOnDrag, defaultViewport, translateExtent, minZoom, maxZoom, preventScrolling, defaultMarkerColor, zoomOnScroll, zoomOnPinch, panOnScroll, panOnScrollSpeed, panOnScrollMode, zoomOnDoubleClick, panOnDrag, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneScroll, onPaneContextMenu, onEdgeContextMenu, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius, noDragClassName, noWheelClassName, noPanClassName, elevateEdgesOnSelect, disableKeyboardA11y, nodeOrigin, nodeExtent, rfId })=>{
    const nodeTypesWrapped = useNodeOrEdgeTypes(nodeTypes, createNodeTypes);
    const edgeTypesWrapped = useNodeOrEdgeTypes(edgeTypes, createEdgeTypes);
    useOnInitHandler(onInit);
    return (0, _reactDefault.default).createElement(FlowRenderer$1, {
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneContextMenu: onPaneContextMenu,
        onPaneScroll: onPaneScroll,
        deleteKeyCode: deleteKeyCode,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        elementsSelectable: elementsSelectable,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        onSelectionContextMenu: onSelectionContextMenu,
        preventScrolling: preventScrolling,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        disableKeyboardA11y: disableKeyboardA11y
    }, (0, _reactDefault.default).createElement(Viewport, null, (0, _reactDefault.default).createElement(EdgeRenderer$1, {
        edgeTypes: edgeTypesWrapped,
        onEdgeClick: onEdgeClick,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect,
        onReconnectStart: onReconnectStart,
        onReconnectEnd: onReconnectEnd,
        reconnectRadius: reconnectRadius,
        defaultMarkerColor: defaultMarkerColor,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: !!elevateEdgesOnSelect,
        disableKeyboardA11y: disableKeyboardA11y,
        rfId: rfId
    }, (0, _reactDefault.default).createElement(ConnectionLineWrapper, {
        style: connectionLineStyle,
        type: connectionLineType,
        component: connectionLineComponent,
        containerStyle: connectionLineContainerStyle
    })), (0, _reactDefault.default).createElement("div", {
        className: "react-flow__edgelabel-renderer"
    }), (0, _reactDefault.default).createElement(NodeRenderer$1, {
        nodeTypes: nodeTypesWrapped,
        onNodeClick: onNodeClick,
        onNodeDoubleClick: onNodeDoubleClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        selectNodesOnDrag: selectNodesOnDrag,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        noPanClassName: noPanClassName,
        noDragClassName: noDragClassName,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent,
        rfId: rfId
    })));
};
GraphView.displayName = 'GraphView';
var GraphView$1 = (0, _react.memo)(GraphView);
const infiniteExtent = [
    [
        Number.NEGATIVE_INFINITY,
        Number.NEGATIVE_INFINITY
    ],
    [
        Number.POSITIVE_INFINITY,
        Number.POSITIVE_INFINITY
    ]
];
const initialState = {
    rfId: '1',
    width: 0,
    height: 0,
    transform: [
        0,
        0,
        1
    ],
    nodeInternals: new Map(),
    edges: [],
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: false,
    hasDefaultEdges: false,
    d3Zoom: null,
    d3Selection: null,
    d3ZoomHandler: undefined,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: infiniteExtent,
    nodeExtent: infiniteExtent,
    nodesSelectionActive: false,
    userSelectionActive: false,
    userSelectionRect: null,
    connectionNodeId: null,
    connectionHandleId: null,
    connectionHandleType: 'source',
    connectionPosition: {
        x: 0,
        y: 0
    },
    connectionStatus: null,
    connectionMode: ConnectionMode.Strict,
    domNode: null,
    paneDragging: false,
    noPanClassName: 'nopan',
    nodeOrigin: [
        0,
        0
    ],
    nodeDragThreshold: 0,
    snapGrid: [
        15,
        15
    ],
    snapToGrid: false,
    nodesDraggable: true,
    nodesConnectable: true,
    nodesFocusable: true,
    edgesFocusable: true,
    edgesUpdatable: true,
    elementsSelectable: true,
    elevateNodesOnSelect: true,
    fitViewOnInit: false,
    fitViewOnInitDone: false,
    fitViewOnInitOptions: undefined,
    onSelectionChange: [],
    multiSelectionActive: false,
    connectionStartHandle: null,
    connectionEndHandle: null,
    connectionClickStartHandle: null,
    connectOnClick: true,
    ariaLiveMessage: '',
    autoPanOnConnect: true,
    autoPanOnNodeDrag: true,
    connectionRadius: 20,
    onError: devWarn,
    isValidConnection: undefined
};
const createRFStore = ()=>(0, _traditional.createWithEqualityFn)((set, get)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, initialState), {
            setNodes: (nodes)=>{
                const { nodeInternals, nodeOrigin, elevateNodesOnSelect } = get();
                set({
                    nodeInternals: createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect)
                });
            },
            getNodes: ()=>{
                return Array.from(get().nodeInternals.values());
            },
            setEdges: (edges)=>{
                const { defaultEdgeOptions = {} } = get();
                set({
                    edges: edges.map((e)=>(0, _objectSpread._)({}, defaultEdgeOptions, e))
                });
            },
            setDefaultNodesAndEdges: (nodes, edges)=>{
                const hasDefaultNodes = typeof nodes !== 'undefined';
                const hasDefaultEdges = typeof edges !== 'undefined';
                const nodeInternals = hasDefaultNodes ? createNodeInternals(nodes, new Map(), get().nodeOrigin, get().elevateNodesOnSelect) : new Map();
                const nextEdges = hasDefaultEdges ? edges : [];
                set({
                    nodeInternals,
                    edges: nextEdges,
                    hasDefaultNodes,
                    hasDefaultEdges
                });
            },
            updateNodeDimensions: (updates)=>{
                const { onNodesChange, nodeInternals, fitViewOnInit, fitViewOnInitDone, fitViewOnInitOptions, domNode, nodeOrigin } = get();
                const viewportNode = domNode === null || domNode === void 0 ? void 0 : domNode.querySelector('.react-flow__viewport');
                if (!viewportNode) return;
                const style = window.getComputedStyle(viewportNode);
                const { m22: zoom } = new window.DOMMatrixReadOnly(style.transform);
                const changes = updates.reduce((res, update)=>{
                    const node = nodeInternals.get(update.id);
                    if (node === null || node === void 0 ? void 0 : node.hidden) nodeInternals.set(node.id, (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
                        [internalsSymbol]: (0, _objectSpreadProps._)((0, _objectSpread._)({}, node[internalsSymbol]), {
                            // we need to reset the handle bounds when the node is hidden
                            // in order to force a new observation when the node is shown again
                            handleBounds: undefined
                        })
                    }));
                    else if (node) {
                        const dimensions = getDimensions(update.nodeElement);
                        const doUpdate = !!(dimensions.width && dimensions.height && (node.width !== dimensions.width || node.height !== dimensions.height || update.forceUpdate));
                        if (doUpdate) {
                            nodeInternals.set(node.id, (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
                                [internalsSymbol]: (0, _objectSpreadProps._)((0, _objectSpread._)({}, node[internalsSymbol]), {
                                    handleBounds: {
                                        source: getHandleBounds('.source', update.nodeElement, zoom, nodeOrigin),
                                        target: getHandleBounds('.target', update.nodeElement, zoom, nodeOrigin)
                                    }
                                })
                            }), dimensions));
                            res.push({
                                id: node.id,
                                type: 'dimensions',
                                dimensions
                            });
                        }
                    }
                    return res;
                }, []);
                updateAbsoluteNodePositions(nodeInternals, nodeOrigin);
                const nextFitViewOnInitDone = fitViewOnInitDone || fitViewOnInit && !fitViewOnInitDone && fitView(get, (0, _objectSpread._)({
                    initial: true
                }, fitViewOnInitOptions));
                set({
                    nodeInternals: new Map(nodeInternals),
                    fitViewOnInitDone: nextFitViewOnInitDone
                });
                if ((changes === null || changes === void 0 ? void 0 : changes.length) > 0) onNodesChange === null || onNodesChange === void 0 ? void 0 : onNodesChange(changes);
            },
            updateNodePositions: (nodeDragItems, positionChanged = true, dragging = false)=>{
                const { triggerNodeChanges } = get();
                const changes = nodeDragItems.map((node)=>{
                    const change = {
                        id: node.id,
                        type: 'position',
                        dragging
                    };
                    if (positionChanged) {
                        change.positionAbsolute = node.positionAbsolute;
                        change.position = node.position;
                    }
                    return change;
                });
                triggerNodeChanges(changes);
            },
            triggerNodeChanges: (changes)=>{
                const { onNodesChange, nodeInternals, hasDefaultNodes, nodeOrigin, getNodes, elevateNodesOnSelect } = get();
                if (changes === null || changes === void 0 ? void 0 : changes.length) {
                    if (hasDefaultNodes) {
                        const nodes = applyNodeChanges(changes, getNodes());
                        const nextNodeInternals = createNodeInternals(nodes, nodeInternals, nodeOrigin, elevateNodesOnSelect);
                        set({
                            nodeInternals: nextNodeInternals
                        });
                    }
                    onNodesChange === null || onNodesChange === void 0 ? void 0 : onNodesChange(changes);
                }
            },
            addSelectedNodes: (selectedNodeIds)=>{
                const { multiSelectionActive, edges, getNodes } = get();
                let changedNodes;
                let changedEdges = null;
                if (multiSelectionActive) changedNodes = selectedNodeIds.map((nodeId)=>createSelectionChange(nodeId, true));
                else {
                    changedNodes = getSelectionChanges(getNodes(), selectedNodeIds);
                    changedEdges = getSelectionChanges(edges, []);
                }
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            addSelectedEdges: (selectedEdgeIds)=>{
                const { multiSelectionActive, edges, getNodes } = get();
                let changedEdges;
                let changedNodes = null;
                if (multiSelectionActive) changedEdges = selectedEdgeIds.map((edgeId)=>createSelectionChange(edgeId, true));
                else {
                    changedEdges = getSelectionChanges(edges, selectedEdgeIds);
                    changedNodes = getSelectionChanges(getNodes(), []);
                }
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            unselectNodesAndEdges: ({ nodes, edges } = {})=>{
                const { edges: storeEdges, getNodes } = get();
                const nodesToUnselect = nodes ? nodes : getNodes();
                const edgesToUnselect = edges ? edges : storeEdges;
                const changedNodes = nodesToUnselect.map((n)=>{
                    n.selected = false;
                    return createSelectionChange(n.id, false);
                });
                const changedEdges = edgesToUnselect.map((edge)=>createSelectionChange(edge.id, false));
                updateNodesAndEdgesSelections({
                    changedNodes,
                    changedEdges,
                    get,
                    set
                });
            },
            setMinZoom: (minZoom)=>{
                const { d3Zoom, maxZoom } = get();
                d3Zoom === null || d3Zoom === void 0 ? void 0 : d3Zoom.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    minZoom
                });
            },
            setMaxZoom: (maxZoom)=>{
                const { d3Zoom, minZoom } = get();
                d3Zoom === null || d3Zoom === void 0 ? void 0 : d3Zoom.scaleExtent([
                    minZoom,
                    maxZoom
                ]);
                set({
                    maxZoom
                });
            },
            setTranslateExtent: (translateExtent)=>{
                var _get_d3Zoom;
                (_get_d3Zoom = get().d3Zoom) === null || _get_d3Zoom === void 0 ? void 0 : _get_d3Zoom.translateExtent(translateExtent);
                set({
                    translateExtent
                });
            },
            resetSelectedElements: ()=>{
                const { edges, getNodes } = get();
                const nodes = getNodes();
                const nodesToUnselect = nodes.filter((e)=>e.selected).map((n)=>createSelectionChange(n.id, false));
                const edgesToUnselect = edges.filter((e)=>e.selected).map((e)=>createSelectionChange(e.id, false));
                updateNodesAndEdgesSelections({
                    changedNodes: nodesToUnselect,
                    changedEdges: edgesToUnselect,
                    get,
                    set
                });
            },
            setNodeExtent: (nodeExtent)=>{
                const { nodeInternals } = get();
                nodeInternals.forEach((node)=>{
                    node.positionAbsolute = clampPosition(node.position, nodeExtent);
                });
                set({
                    nodeExtent,
                    nodeInternals: new Map(nodeInternals)
                });
            },
            panBy: (delta)=>{
                const { transform, width, height, d3Zoom, d3Selection, translateExtent } = get();
                if (!d3Zoom || !d3Selection || !delta.x && !delta.y) return false;
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(transform[0] + delta.x, transform[1] + delta.y).scale(transform[2]);
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const constrainedTransform = d3Zoom === null || d3Zoom === void 0 ? void 0 : d3Zoom.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
                const transformChanged = transform[0] !== constrainedTransform.x || transform[1] !== constrainedTransform.y || transform[2] !== constrainedTransform.k;
                return transformChanged;
            },
            cancelConnection: ()=>set({
                    connectionNodeId: initialState.connectionNodeId,
                    connectionHandleId: initialState.connectionHandleId,
                    connectionHandleType: initialState.connectionHandleType,
                    connectionStatus: initialState.connectionStatus,
                    connectionStartHandle: initialState.connectionStartHandle,
                    connectionEndHandle: initialState.connectionEndHandle
                }),
            reset: ()=>set((0, _objectSpread._)({}, initialState))
        }), Object.is);
const ReactFlowProvider = ({ children })=>{
    const storeRef = (0, _react.useRef)(null);
    if (!storeRef.current) storeRef.current = createRFStore();
    return (0, _reactDefault.default).createElement(Provider$1, {
        value: storeRef.current
    }, children);
};
ReactFlowProvider.displayName = 'ReactFlowProvider';
const Wrapper = ({ children })=>{
    const isWrapped = (0, _react.useContext)(StoreContext);
    if (isWrapped) // we need to wrap it with a fragment because it's not allowed for children to be a ReactNode
    // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    return (0, _reactDefault.default).createElement(ReactFlowProvider, null, children);
};
Wrapper.displayName = 'ReactFlowWrapper';
const defaultNodeTypes = {
    input: InputNode$1,
    default: DefaultNode$1,
    output: OutputNode$1,
    group: GroupNode
};
const defaultEdgeTypes = {
    default: BezierEdge,
    straight: StraightEdge,
    step: StepEdge,
    smoothstep: SmoothStepEdge,
    simplebezier: SimpleBezierEdge
};
const initNodeOrigin = [
    0,
    0
];
const initSnapGrid = [
    15,
    15
];
const initDefaultViewport = {
    x: 0,
    y: 0,
    zoom: 1
};
const wrapperStyle = {
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 0
};
const ReactFlow = (0, _react.forwardRef)((_param, ref)=>{
    var { nodes, edges, defaultNodes, defaultEdges, className, nodeTypes = defaultNodeTypes, edgeTypes = defaultEdgeTypes, onNodeClick, onEdgeClick, onInit, onMove, onMoveStart, onMoveEnd, onConnect, onConnectStart, onConnectEnd, onClickConnectStart, onClickConnectEnd, onNodeMouseEnter, onNodeMouseMove, onNodeMouseLeave, onNodeContextMenu, onNodeDoubleClick, onNodeDragStart, onNodeDrag, onNodeDragStop, onNodesDelete, onEdgesDelete, onSelectionChange, onSelectionDragStart, onSelectionDrag, onSelectionDragStop, onSelectionContextMenu, onSelectionStart, onSelectionEnd, connectionMode = ConnectionMode.Strict, connectionLineType = ConnectionLineType.Bezier, connectionLineStyle, connectionLineComponent, connectionLineContainerStyle, deleteKeyCode = 'Backspace', selectionKeyCode = 'Shift', selectionOnDrag = false, selectionMode = SelectionMode.Full, panActivationKeyCode = 'Space', multiSelectionKeyCode = isMacOs() ? 'Meta' : 'Control', zoomActivationKeyCode = isMacOs() ? 'Meta' : 'Control', snapToGrid = false, snapGrid = initSnapGrid, onlyRenderVisibleElements = false, selectNodesOnDrag = true, nodesDraggable, nodesConnectable, nodesFocusable, nodeOrigin = initNodeOrigin, edgesFocusable, edgesUpdatable, elementsSelectable, defaultViewport = initDefaultViewport, minZoom = 0.5, maxZoom = 2, translateExtent = infiniteExtent, preventScrolling = true, nodeExtent, defaultMarkerColor = '#b1b1b7', zoomOnScroll = true, zoomOnPinch = true, panOnScroll = false, panOnScrollSpeed = 0.5, panOnScrollMode = PanOnScrollMode.Free, zoomOnDoubleClick = true, panOnDrag = true, onPaneClick, onPaneMouseEnter, onPaneMouseMove, onPaneMouseLeave, onPaneScroll, onPaneContextMenu, children, onEdgeContextMenu, onEdgeDoubleClick, onEdgeMouseEnter, onEdgeMouseMove, onEdgeMouseLeave, onEdgeUpdate, onEdgeUpdateStart, onEdgeUpdateEnd, onReconnect, onReconnectStart, onReconnectEnd, reconnectRadius = 10, edgeUpdaterRadius = 10, onNodesChange, onEdgesChange, noDragClassName = 'nodrag', noWheelClassName = 'nowheel', noPanClassName = 'nopan', fitView = false, fitViewOptions, connectOnClick = true, attributionPosition, proOptions, defaultEdgeOptions, elevateNodesOnSelect = true, elevateEdgesOnSelect = false, disableKeyboardA11y = false, autoPanOnConnect = true, autoPanOnNodeDrag = true, connectionRadius = 20, isValidConnection, onError, style, id, nodeDragThreshold } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "nodes",
        "edges",
        "defaultNodes",
        "defaultEdges",
        "className",
        "nodeTypes",
        "edgeTypes",
        "onNodeClick",
        "onEdgeClick",
        "onInit",
        "onMove",
        "onMoveStart",
        "onMoveEnd",
        "onConnect",
        "onConnectStart",
        "onConnectEnd",
        "onClickConnectStart",
        "onClickConnectEnd",
        "onNodeMouseEnter",
        "onNodeMouseMove",
        "onNodeMouseLeave",
        "onNodeContextMenu",
        "onNodeDoubleClick",
        "onNodeDragStart",
        "onNodeDrag",
        "onNodeDragStop",
        "onNodesDelete",
        "onEdgesDelete",
        "onSelectionChange",
        "onSelectionDragStart",
        "onSelectionDrag",
        "onSelectionDragStop",
        "onSelectionContextMenu",
        "onSelectionStart",
        "onSelectionEnd",
        "connectionMode",
        "connectionLineType",
        "connectionLineStyle",
        "connectionLineComponent",
        "connectionLineContainerStyle",
        "deleteKeyCode",
        "selectionKeyCode",
        "selectionOnDrag",
        "selectionMode",
        "panActivationKeyCode",
        "multiSelectionKeyCode",
        "zoomActivationKeyCode",
        "snapToGrid",
        "snapGrid",
        "onlyRenderVisibleElements",
        "selectNodesOnDrag",
        "nodesDraggable",
        "nodesConnectable",
        "nodesFocusable",
        "nodeOrigin",
        "edgesFocusable",
        "edgesUpdatable",
        "elementsSelectable",
        "defaultViewport",
        "minZoom",
        "maxZoom",
        "translateExtent",
        "preventScrolling",
        "nodeExtent",
        "defaultMarkerColor",
        "zoomOnScroll",
        "zoomOnPinch",
        "panOnScroll",
        "panOnScrollSpeed",
        "panOnScrollMode",
        "zoomOnDoubleClick",
        "panOnDrag",
        "onPaneClick",
        "onPaneMouseEnter",
        "onPaneMouseMove",
        "onPaneMouseLeave",
        "onPaneScroll",
        "onPaneContextMenu",
        "children",
        "onEdgeContextMenu",
        "onEdgeDoubleClick",
        "onEdgeMouseEnter",
        "onEdgeMouseMove",
        "onEdgeMouseLeave",
        "onEdgeUpdate",
        "onEdgeUpdateStart",
        "onEdgeUpdateEnd",
        "onReconnect",
        "onReconnectStart",
        "onReconnectEnd",
        "reconnectRadius",
        "edgeUpdaterRadius",
        "onNodesChange",
        "onEdgesChange",
        "noDragClassName",
        "noWheelClassName",
        "noPanClassName",
        "fitView",
        "fitViewOptions",
        "connectOnClick",
        "attributionPosition",
        "proOptions",
        "defaultEdgeOptions",
        "elevateNodesOnSelect",
        "elevateEdgesOnSelect",
        "disableKeyboardA11y",
        "autoPanOnConnect",
        "autoPanOnNodeDrag",
        "connectionRadius",
        "isValidConnection",
        "onError",
        "style",
        "id",
        "nodeDragThreshold"
    ]);
    const rfId = id || '1';
    return (0, _reactDefault.default).createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, rest), {
        style: (0, _objectSpread._)({}, style, wrapperStyle),
        ref: ref,
        className: (0, _classcatDefault.default)([
            'react-flow',
            className
        ]),
        "data-testid": "rf__wrapper",
        id: id
    }), (0, _reactDefault.default).createElement(Wrapper, null, (0, _reactDefault.default).createElement(GraphView$1, {
        onInit: onInit,
        onMove: onMove,
        onMoveStart: onMoveStart,
        onMoveEnd: onMoveEnd,
        onNodeClick: onNodeClick,
        onEdgeClick: onEdgeClick,
        onNodeMouseEnter: onNodeMouseEnter,
        onNodeMouseMove: onNodeMouseMove,
        onNodeMouseLeave: onNodeMouseLeave,
        onNodeContextMenu: onNodeContextMenu,
        onNodeDoubleClick: onNodeDoubleClick,
        nodeTypes: nodeTypes,
        edgeTypes: edgeTypes,
        connectionLineType: connectionLineType,
        connectionLineStyle: connectionLineStyle,
        connectionLineComponent: connectionLineComponent,
        connectionLineContainerStyle: connectionLineContainerStyle,
        selectionKeyCode: selectionKeyCode,
        selectionOnDrag: selectionOnDrag,
        selectionMode: selectionMode,
        deleteKeyCode: deleteKeyCode,
        multiSelectionKeyCode: multiSelectionKeyCode,
        panActivationKeyCode: panActivationKeyCode,
        zoomActivationKeyCode: zoomActivationKeyCode,
        onlyRenderVisibleElements: onlyRenderVisibleElements,
        selectNodesOnDrag: selectNodesOnDrag,
        defaultViewport: defaultViewport,
        translateExtent: translateExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        preventScrolling: preventScrolling,
        zoomOnScroll: zoomOnScroll,
        zoomOnPinch: zoomOnPinch,
        zoomOnDoubleClick: zoomOnDoubleClick,
        panOnScroll: panOnScroll,
        panOnScrollSpeed: panOnScrollSpeed,
        panOnScrollMode: panOnScrollMode,
        panOnDrag: panOnDrag,
        onPaneClick: onPaneClick,
        onPaneMouseEnter: onPaneMouseEnter,
        onPaneMouseMove: onPaneMouseMove,
        onPaneMouseLeave: onPaneMouseLeave,
        onPaneScroll: onPaneScroll,
        onPaneContextMenu: onPaneContextMenu,
        onSelectionContextMenu: onSelectionContextMenu,
        onSelectionStart: onSelectionStart,
        onSelectionEnd: onSelectionEnd,
        onEdgeContextMenu: onEdgeContextMenu,
        onEdgeDoubleClick: onEdgeDoubleClick,
        onEdgeMouseEnter: onEdgeMouseEnter,
        onEdgeMouseMove: onEdgeMouseMove,
        onEdgeMouseLeave: onEdgeMouseLeave,
        onReconnect: onReconnect !== null && onReconnect !== void 0 ? onReconnect : onEdgeUpdate,
        onReconnectStart: onReconnectStart !== null && onReconnectStart !== void 0 ? onReconnectStart : onEdgeUpdateStart,
        onReconnectEnd: onReconnectEnd !== null && onReconnectEnd !== void 0 ? onReconnectEnd : onEdgeUpdateEnd,
        reconnectRadius: reconnectRadius !== null && reconnectRadius !== void 0 ? reconnectRadius : edgeUpdaterRadius,
        defaultMarkerColor: defaultMarkerColor,
        noDragClassName: noDragClassName,
        noWheelClassName: noWheelClassName,
        noPanClassName: noPanClassName,
        elevateEdgesOnSelect: elevateEdgesOnSelect,
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y,
        nodeOrigin: nodeOrigin,
        nodeExtent: nodeExtent
    }), (0, _reactDefault.default).createElement(StoreUpdater, {
        nodes: nodes,
        edges: edges,
        defaultNodes: defaultNodes,
        defaultEdges: defaultEdges,
        onConnect: onConnect,
        onConnectStart: onConnectStart,
        onConnectEnd: onConnectEnd,
        onClickConnectStart: onClickConnectStart,
        onClickConnectEnd: onClickConnectEnd,
        nodesDraggable: nodesDraggable,
        nodesConnectable: nodesConnectable,
        nodesFocusable: nodesFocusable,
        edgesFocusable: edgesFocusable,
        edgesUpdatable: edgesUpdatable,
        elementsSelectable: elementsSelectable,
        elevateNodesOnSelect: elevateNodesOnSelect,
        minZoom: minZoom,
        maxZoom: maxZoom,
        nodeExtent: nodeExtent,
        onNodesChange: onNodesChange,
        onEdgesChange: onEdgesChange,
        snapToGrid: snapToGrid,
        snapGrid: snapGrid,
        connectionMode: connectionMode,
        translateExtent: translateExtent,
        connectOnClick: connectOnClick,
        defaultEdgeOptions: defaultEdgeOptions,
        fitView: fitView,
        fitViewOptions: fitViewOptions,
        onNodesDelete: onNodesDelete,
        onEdgesDelete: onEdgesDelete,
        onNodeDragStart: onNodeDragStart,
        onNodeDrag: onNodeDrag,
        onNodeDragStop: onNodeDragStop,
        onSelectionDrag: onSelectionDrag,
        onSelectionDragStart: onSelectionDragStart,
        onSelectionDragStop: onSelectionDragStop,
        noPanClassName: noPanClassName,
        nodeOrigin: nodeOrigin,
        rfId: rfId,
        autoPanOnConnect: autoPanOnConnect,
        autoPanOnNodeDrag: autoPanOnNodeDrag,
        onError: onError,
        connectionRadius: connectionRadius,
        isValidConnection: isValidConnection,
        nodeDragThreshold: nodeDragThreshold
    }), (0, _reactDefault.default).createElement(Wrapper$1, {
        onSelectionChange: onSelectionChange
    }), children, (0, _reactDefault.default).createElement(Attribution, {
        proOptions: proOptions,
        position: attributionPosition
    }), (0, _reactDefault.default).createElement(A11yDescriptions, {
        rfId: rfId,
        disableKeyboardA11y: disableKeyboardA11y
    })));
});
ReactFlow.displayName = 'ReactFlow';
const selector$1 = (s)=>{
    var _s_domNode;
    return (_s_domNode = s.domNode) === null || _s_domNode === void 0 ? void 0 : _s_domNode.querySelector('.react-flow__edgelabel-renderer');
};
function EdgeLabelRenderer({ children }) {
    const edgeLabelRenderer = useStore(selector$1);
    if (!edgeLabelRenderer) return null;
    return (0, _reactDom.createPortal)(children, edgeLabelRenderer);
}
function useUpdateNodeInternals() {
    const store = useStoreApi();
    return (0, _react.useCallback)((id)=>{
        const { domNode, updateNodeDimensions } = store.getState();
        const updateIds = Array.isArray(id) ? id : [
            id
        ];
        const updates = updateIds.reduce((res, updateId)=>{
            const nodeElement = domNode === null || domNode === void 0 ? void 0 : domNode.querySelector(`.react-flow__node[data-id="${updateId}"]`);
            if (nodeElement) res.push({
                id: updateId,
                nodeElement,
                forceUpdate: true
            });
            return res;
        }, []);
        requestAnimationFrame(()=>updateNodeDimensions(updates));
    }, []);
}
const nodesSelector = (state)=>state.getNodes();
function useNodes() {
    const nodes = useStore(nodesSelector, (0, _shallow.shallow));
    return nodes;
}
const edgesSelector = (state)=>state.edges;
function useEdges() {
    const edges = useStore(edgesSelector, (0, _shallow.shallow));
    return edges;
}
const viewportSelector = (state)=>({
        x: state.transform[0],
        y: state.transform[1],
        zoom: state.transform[2]
    });
function useViewport() {
    const viewport = useStore(viewportSelector, (0, _shallow.shallow));
    return viewport;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ function createUseItemsState(applyChanges) {
    return (initialItems)=>{
        const [items, setItems] = (0, _react.useState)(initialItems);
        const onItemsChange = (0, _react.useCallback)((changes)=>setItems((items)=>applyChanges(changes, items)), []);
        return [
            items,
            setItems,
            onItemsChange
        ];
    };
}
const useNodesState = createUseItemsState(applyNodeChanges);
const useEdgesState = createUseItemsState(applyEdgeChanges);
function useOnViewportChange({ onStart, onChange, onEnd }) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChangeStart: onStart
        });
    }, [
        onStart
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChange: onChange
        });
    }, [
        onChange
    ]);
    (0, _react.useEffect)(()=>{
        store.setState({
            onViewportChangeEnd: onEnd
        });
    }, [
        onEnd
    ]);
}
function useOnSelectionChange({ onChange }) {
    const store = useStoreApi();
    (0, _react.useEffect)(()=>{
        const nextSelectionChangeHandlers = [
            ...store.getState().onSelectionChange,
            onChange
        ];
        store.setState({
            onSelectionChange: nextSelectionChangeHandlers
        });
        return ()=>{
            const nextHandlers = store.getState().onSelectionChange.filter((fn)=>fn !== onChange);
            store.setState({
                onSelectionChange: nextHandlers
            });
        };
    }, [
        onChange
    ]);
}
const selector = (options)=>(s)=>{
        if (s.nodeInternals.size === 0) return false;
        return s.getNodes().filter((n)=>options.includeHiddenNodes ? true : !n.hidden).every((n)=>{
            var _n_internalsSymbol;
            return ((_n_internalsSymbol = n[internalsSymbol]) === null || _n_internalsSymbol === void 0 ? void 0 : _n_internalsSymbol.handleBounds) !== undefined;
        });
    };
const defaultOptions = {
    includeHiddenNodes: false
};
function useNodesInitialized(options = defaultOptions) {
    const initialized = useStore(selector(options));
    return initialized;
}

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react":"lXMxO","classcat":"aUX38","zustand/traditional":"iq0Sk","zustand/shallow":"gLHka","d3-zoom":"5GcoX","d3-selection":"aRcZV","d3-drag":"fIjTj","react-dom":"dgecT","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7R2qf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties);
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"eCqIr","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eCqIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_object_without_properties_loose);
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aUX38":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cc);
function cc(names) {
    if (typeof names === "string" || typeof names === "number") return "" + names;
    let out = "";
    if (Array.isArray(names)) {
        for(let i = 0, tmp; i < names.length; i++)if ((tmp = cc(names[i])) !== "") out += (out && " ") + tmp;
    } else {
        for(let k in names)if (names[k]) out += (out && " ") + k;
    }
    return out;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iq0Sk":[function(require,module,exports,__globalThis) {
'use strict';
var ReactExports = require("55fe33b72be7f997");
var useSyncExternalStoreExports = require("bfacb3376c7259e5");
var vanilla = require("93e7584e5ac2a823");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var identity = function identity(arg) {
    return arg;
};
function useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = vanilla.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? createWithEqualityFnImpl(createState, defaultEqualityFn) : createWithEqualityFnImpl;
};
exports.createWithEqualityFn = createWithEqualityFn;
exports.useStoreWithEqualityFn = useStoreWithEqualityFn;

},{"55fe33b72be7f997":"lXMxO","bfacb3376c7259e5":"coZLe","93e7584e5ac2a823":"5q3l0"}],"coZLe":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d1848724d1e53763");

},{"d1848724d1e53763":"gu2C2"}],"gu2C2":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d57a74df6bca20fd"), shim = require("5be634d856d1f9fa");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d57a74df6bca20fd":"lXMxO","5be634d856d1f9fa":"fONF4"}],"fONF4":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"7WEPI"}],"7WEPI":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"lXMxO"}],"5q3l0":[function(require,module,exports,__globalThis) {
'use strict';
var createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var createStore = function createStore(createState) {
    return createState ? createStoreImpl(createState) : createStoreImpl;
};
var vanilla = function(createState) {
    return createStore(createState);
};
exports.createStore = createStore;
exports.default = vanilla;
module.exports = vanilla;
module.exports.createStore = createStore;
exports.default = module.exports;

},{}],"gLHka":[function(require,module,exports,__globalThis) {
'use strict';
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = _createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = _createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var shallow = function(objA, objB) {
    return shallow$1(objA, objB);
};
exports.default = shallow;
exports.shallow = shallow$1;
module.exports = shallow;
module.exports.shallow = shallow$1;
exports.default = module.exports;

},{}],"5GcoX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
parcelHelpers.export(exports, "ZoomTransform", ()=>(0, _transformJs.Transform));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"eoNIz","./transform.js":"iwfTt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eoNIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchfirst, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0, tapDistance = 10;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled, {
                passive: false
            }).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point, event) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point, event);
            else selection.interrupt().each(function() {
                gesture(this, arguments).event(event).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p, event) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p, event);
        };
        zoom.scaleTo = function(selection, k, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p, event);
        };
        zoom.translateBy = function(selection, x, y, event) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            }, null, event);
        };
        zoom.translateTo = function(selection, x, y, p, event) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p, event);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point, event) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).event(event).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).event(event).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args).event(event), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.sourceEvent = null;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            event: function(event) {
                if (event) this.sourceEvent = event;
                return this;
            },
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                var d = (0, _d3Selection.select)(this.that).datum();
                listeners.call(type, this.that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: this.sourceEvent,
                    target: zoom,
                    type,
                    transform: this.that.__zoom,
                    dispatch: listeners
                }), d);
            }
        };
        function wheeled(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, args).event(event), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.pointer)(event);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)(event);
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned(event, ...args) {
            if (touchending || !filter.apply(this, arguments)) return;
            var currentTarget = event.currentTarget, g = gesture(this, args, true).event(event), v = (0, _d3Selection.select)(event.view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.pointer)(event, currentTarget), x0 = event.clientX, y0 = event.clientY;
            (0, _d3Drag.dragDisable)(event.view);
            (0, _noeventJs.nopropagation)(event);
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved(event) {
                (0, _noeventJsDefault.default)(event);
                if (!g.moved) {
                    var dx = event.clientX - x0, dy = event.clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.event(event).zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.pointer)(event, currentTarget), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped(event) {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)(event.view, g.moved);
                (0, _noeventJsDefault.default)(event);
                g.event(event).end();
            }
        }
        function dblclicked(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.pointer)(event.changedTouches ? event.changedTouches[0] : event, this), p1 = t0.invert(p0), k1 = t0.k * (event.shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, args), translateExtent);
            (0, _noeventJsDefault.default)(event);
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0, event);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1, p0, event);
        }
        function touchstarted(event, ...args) {
            if (!filter.apply(this, arguments)) return;
            var touches = event.touches, n = touches.length, g = gesture(this, args, event.changedTouches.length === n).event(event), started, i, t, p;
            (0, _noeventJs.nopropagation)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchfirst = p[0], touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)(event);
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.pointer)(t, this);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended(event, ...args) {
            if (!this.__zooming) return;
            var g = gesture(this, args).event(event), touches = event.changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)(event);
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    t = (0, _d3Selection.pointer)(t, this);
                    if (Math.hypot(touchfirst[0] - t[0], touchfirst[1] - t[1]) < tapDistance) {
                        var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                        if (p) p.apply(this, arguments);
                    }
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        zoom.tapDistance = function(_) {
            return arguments.length ? (tapDistance = +_, zoom) : tapDistance;
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
// except for pinch-to-zoom, which is sent as a wheel+ctrlKey event
function defaultFilter(event) {
    return (!event.ctrlKey || event.type === 'wheel') && !event.button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta(event) {
    return -event.deltaY * (event.deltaMode === 1 ? 0.05 : event.deltaMode ? 1 : 0.002) * (event.ctrlKey ? 10 : 1);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":"gT3u0","d3-drag":"fIjTj","d3-interpolate":"evSeJ","d3-selection":"aRcZV","d3-transition":"fjbTP","./constant.js":"baltF","./event.js":"8pBQD","./transform.js":"iwfTt","./noevent.js":"3DuSR","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gT3u0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"jTEVt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jTEVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: ()=>{}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fIjTj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"aaOwP","./nodrag.js":"9ozJ0","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aaOwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved, (0, _noeventJs.nonpassive)).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned(event, d) {
            if (touchending || !filter.call(this, event, d)) return;
            var gesture = beforestart(this, container.call(this, event, d), event, d, "mouse");
            if (!gesture) return;
            (0, _d3Selection.select)(event.view).on("mousemove.drag", mousemoved, (0, _noeventJs.nonpassivecapture)).on("mouseup.drag", mouseupped, (0, _noeventJs.nonpassivecapture));
            (0, _nodragJsDefault.default)(event.view);
            (0, _noeventJs.nopropagation)(event);
            mousemoving = false;
            mousedownx = event.clientX;
            mousedowny = event.clientY;
            gesture("start", event);
        }
        function mousemoved(event) {
            (0, _noeventJsDefault.default)(event);
            if (!mousemoving) {
                var dx = event.clientX - mousedownx, dy = event.clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag", event);
        }
        function mouseupped(event) {
            (0, _d3Selection.select)(event.view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)(event.view, mousemoving);
            (0, _noeventJsDefault.default)(event);
            gestures.mouse("end", event);
        }
        function touchstarted(event, d) {
            if (!filter.call(this, event, d)) return;
            var touches = event.changedTouches, c = container.call(this, event, d), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(this, c, event, d, touches[i].identifier, touches[i])) {
                (0, _noeventJs.nopropagation)(event);
                gesture("start", event, touches[i]);
            }
        }
        function touchmoved(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)(event);
                gesture("drag", event, touches[i]);
            }
        }
        function touchended(event) {
            var touches = event.changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)(event);
                gesture("end", event, touches[i]);
            }
        }
        function beforestart(that, container, event, d, identifier, touch) {
            var dispatch = listeners.copy(), p = (0, _d3Selection.pointer)(touch || event, container), dx, dy, s;
            if ((s = subject.call(that, new (0, _eventJsDefault.default)("beforestart", {
                sourceEvent: event,
                target: drag,
                identifier,
                active,
                x: p[0],
                y: p[1],
                dx: 0,
                dy: 0,
                dispatch
            }), d)) == null) return;
            dx = s.x - p[0] || 0;
            dy = s.y - p[1] || 0;
            return function gesture(type, event, touch) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[identifier] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[identifier], --active; // falls through
                    case "drag":
                        p = (0, _d3Selection.pointer)(touch || event, container), n = active;
                        break;
                }
                dispatch.call(type, that, new (0, _eventJsDefault.default)(type, {
                    sourceEvent: event,
                    subject: s,
                    target: drag,
                    identifier,
                    active: n,
                    x: p[0] + dx,
                    y: p[1] + dy,
                    dx: p[0] - p0[0],
                    dy: p[1] - p0[1],
                    dispatch
                }), d);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter(event) {
    return !event.ctrlKey && !event.button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(event, d) {
    return d == null ? {
        x: event.x,
        y: event.y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":"gT3u0","d3-selection":"aRcZV","./nodrag.js":"9ozJ0","./noevent.js":"15Cya","./constant.js":"4NpkK","./event.js":"bo1wD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aRcZV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createJsDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorJsDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localJsDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherJsDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceJsDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesJsDefault.default));
parcelHelpers.export(exports, "pointer", ()=>(0, _pointerJsDefault.default));
parcelHelpers.export(exports, "pointers", ()=>(0, _pointersJsDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllJsDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorJsDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllJsDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleJs.styleValue));
parcelHelpers.export(exports, "window", ()=>(0, _windowJsDefault.default));
var _createJs = require("./create.js");
var _createJsDefault = parcelHelpers.interopDefault(_createJs);
var _creatorJs = require("./creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _localJs = require("./local.js");
var _localJsDefault = parcelHelpers.interopDefault(_localJs);
var _matcherJs = require("./matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);
var _pointerJs = require("./pointer.js");
var _pointerJsDefault = parcelHelpers.interopDefault(_pointerJs);
var _pointersJs = require("./pointers.js");
var _pointersJsDefault = parcelHelpers.interopDefault(_pointersJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _indexJs = require("./selection/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _selectorJs = require("./selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
var _selectorAllJs = require("./selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
var _styleJs = require("./selection/style.js");
var _windowJs = require("./window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);

},{"./create.js":false,"./creator.js":false,"./local.js":false,"./matcher.js":"cSfBC","./namespace.js":"aC1gR","./namespaces.js":false,"./pointer.js":"k40Dj","./pointers.js":false,"./select.js":"C87UQ","./selectAll.js":false,"./selection/index.js":"4cK4N","./selector.js":"iCStq","./selectorAll.js":"cZxOB","./selection/style.js":"3rFq2","./window.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cTpk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespaceJs = require("./namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
var _namespacesJs = require("./namespaces.js");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespacesJs.xhtml) && document.documentElement.namespaceURI === (0, _namespacesJs.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace.js":"aC1gR","./namespaces.js":"cafwr","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aC1gR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesJsDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesJsDefault.default)[prefix],
            local: name
        } : name; // eslint-disable-line no-prototype-builtins
    });
var _namespacesJs = require("./namespaces.js");
var _namespacesJsDefault = parcelHelpers.interopDefault(_namespacesJs);

},{"./namespaces.js":"cafwr","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cafwr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cSfBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });
parcelHelpers.export(exports, "childMatcher", ()=>childMatcher);
function childMatcher(selector) {
    return function(node) {
        return node.matches(selector);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k40Dj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event, node) {
        event = (0, _sourceEventJsDefault.default)(event);
        if (node === undefined) node = event.currentTarget;
        if (node) {
            var svg = node.ownerSVGElement || node;
            if (svg.createSVGPoint) {
                var point = svg.createSVGPoint();
                point.x = event.clientX, point.y = event.clientY;
                point = point.matrixTransform(node.getScreenCTM().inverse());
                return [
                    point.x,
                    point.y
                ];
            }
            if (node.getBoundingClientRect) {
                var rect = node.getBoundingClientRect();
                return [
                    event.clientX - rect.left - node.clientLeft,
                    event.clientY - rect.top - node.clientTop
                ];
            }
        }
        return [
            event.pageX,
            event.pageY
        ];
    });
var _sourceEventJs = require("./sourceEvent.js");
var _sourceEventJsDefault = parcelHelpers.interopDefault(_sourceEventJs);

},{"./sourceEvent.js":"6V6bV","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6V6bV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(event) {
        let sourceEvent;
        while(sourceEvent = event.sourceEvent)event = sourceEvent;
        return event;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"C87UQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _indexJs.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _indexJs.Selection)([
            [
                selector
            ]
        ], (0, _indexJs.root));
    });
var _indexJs = require("./selection/index.js");

},{"./selection/index.js":"4cK4N","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4cK4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectChildJs = require("./selectChild.js");
var _selectChildJsDefault = parcelHelpers.interopDefault(_selectChildJs);
var _selectChildrenJs = require("./selectChildren.js");
var _selectChildrenJsDefault = parcelHelpers.interopDefault(_selectChildrenJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _enterJs = require("./enter.js");
var _enterJsDefault = parcelHelpers.interopDefault(_enterJs);
var _exitJs = require("./exit.js");
var _exitJsDefault = parcelHelpers.interopDefault(_exitJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _orderJs = require("./order.js");
var _orderJsDefault = parcelHelpers.interopDefault(_orderJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _nodesJs = require("./nodes.js");
var _nodesJsDefault = parcelHelpers.interopDefault(_nodesJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _propertyJs = require("./property.js");
var _propertyJsDefault = parcelHelpers.interopDefault(_propertyJs);
var _classedJs = require("./classed.js");
var _classedJsDefault = parcelHelpers.interopDefault(_classedJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _htmlJs = require("./html.js");
var _htmlJsDefault = parcelHelpers.interopDefault(_htmlJs);
var _raiseJs = require("./raise.js");
var _raiseJsDefault = parcelHelpers.interopDefault(_raiseJs);
var _lowerJs = require("./lower.js");
var _lowerJsDefault = parcelHelpers.interopDefault(_lowerJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _datumJs = require("./datum.js");
var _datumJsDefault = parcelHelpers.interopDefault(_datumJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);
var _iteratorJs = require("./iterator.js");
var _iteratorJsDefault = parcelHelpers.interopDefault(_iteratorJs);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
function selection_selection() {
    return this;
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: (0, _selectChildJsDefault.default),
    selectChildren: (0, _selectChildrenJsDefault.default),
    filter: (0, _filterJsDefault.default),
    data: (0, _dataJsDefault.default),
    enter: (0, _enterJsDefault.default),
    exit: (0, _exitJsDefault.default),
    join: (0, _joinJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: selection_selection,
    order: (0, _orderJsDefault.default),
    sort: (0, _sortJsDefault.default),
    call: (0, _callJsDefault.default),
    nodes: (0, _nodesJsDefault.default),
    node: (0, _nodeJsDefault.default),
    size: (0, _sizeJsDefault.default),
    empty: (0, _emptyJsDefault.default),
    each: (0, _eachJsDefault.default),
    attr: (0, _attrJsDefault.default),
    style: (0, _styleJsDefault.default),
    property: (0, _propertyJsDefault.default),
    classed: (0, _classedJsDefault.default),
    text: (0, _textJsDefault.default),
    html: (0, _htmlJsDefault.default),
    raise: (0, _raiseJsDefault.default),
    lower: (0, _lowerJsDefault.default),
    append: (0, _appendJsDefault.default),
    insert: (0, _insertJsDefault.default),
    remove: (0, _removeJsDefault.default),
    clone: (0, _cloneJsDefault.default),
    datum: (0, _datumJsDefault.default),
    on: (0, _onJsDefault.default),
    dispatch: (0, _dispatchJsDefault.default),
    [Symbol.iterator]: (0, _iteratorJsDefault.default)
};
exports.default = selection;

},{"./select.js":"e6jic","./selectAll.js":"2Vg2v","./selectChild.js":"fCHly","./selectChildren.js":"1nbhT","./filter.js":"aUems","./data.js":"6BAjG","./enter.js":"7oNeK","./exit.js":"30tJm","./join.js":"bdNx5","./merge.js":"gmJRC","./order.js":"bqHtl","./sort.js":"iXYkQ","./call.js":"847ax","./nodes.js":"iRktY","./node.js":"hM7sk","./size.js":"kxSXI","./empty.js":"1M9Ze","./each.js":"2dZFx","./attr.js":"7ZFMi","./style.js":"3rFq2","./property.js":"lEB7a","./classed.js":"bUH9H","./text.js":"59ucj","./html.js":"2PCe5","./raise.js":"jVd7H","./lower.js":"gMm2P","./append.js":"k3Hj8","./insert.js":"fERPq","./remove.js":"fKk1I","./clone.js":"l0xcc","./datum.js":"2q1Rk","./on.js":"jmVfL","./dispatch.js":"gu1ND","./iterator.js":"4l1pa","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"e6jic":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);

},{"./index.js":"4cK4N","../selector.js":"iCStq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iCStq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2Vg2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select === "function") select = arrayAll(select);
        else select = (0, _selectorAllJsDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _indexJs.Selection)(subgroups, parents);
    });
var _indexJs = require("./index.js");
var _arrayJs = require("../array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _selectorAllJs = require("../selectorAll.js");
var _selectorAllJsDefault = parcelHelpers.interopDefault(_selectorAllJs);
function arrayAll(select) {
    return function() {
        return (0, _arrayJsDefault.default)(select.apply(this, arguments));
    };
}

},{"./index.js":"4cK4N","../array.js":"24bps","../selectorAll.js":"cZxOB","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"24bps":[function(require,module,exports,__globalThis) {
// Given something array like (or null), returns something that is strictly an
// array. This is used to ensure that array-like objects passed to d3.selectAll
// or selection.selectAll are converted into proper arrays when creating a
// selection; we don’t ever want to create a selection backed by a live
// HTMLCollection or NodeList. However, note that selection.selectAll will use a
// static NodeList as a group, since it safely derived from querySelectorAll.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>array);
function array(x) {
    return x == null ? [] : Array.isArray(x) ? x : Array.from(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cZxOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fCHly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.select(match == null ? childFirst : childFind(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var find = Array.prototype.find;
function childFind(match) {
    return function() {
        return find.call(this.children, match);
    };
}
function childFirst() {
    return this.firstElementChild;
}

},{"../matcher.js":"cSfBC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1nbhT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        return this.selectAll(match == null ? children : childrenFilter(typeof match === "function" ? match : (0, _matcherJs.childMatcher)(match)));
    });
var _matcherJs = require("../matcher.js");
var filter = Array.prototype.filter;
function children() {
    return Array.from(this.children);
}
function childrenFilter(match) {
    return function() {
        return filter.call(this.children, match);
    };
}

},{"../matcher.js":"cSfBC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aUems":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherJsDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Selection)(subgroups, this._parents);
    });
var _indexJs = require("./index.js");
var _matcherJs = require("../matcher.js");
var _matcherJsDefault = parcelHelpers.interopDefault(_matcherJs);

},{"./index.js":"4cK4N","../matcher.js":"cSfBC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6BAjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!arguments.length) return Array.from(this, datum);
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantJsDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = arraylike(value.call(parent, parent && parent.__data__, j, parents)), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _indexJs.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _indexJs = require("./index.js");
var _enterJs = require("./enter.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = new Map, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
        if (nodeByKeyValue.has(keyValue)) exit[i] = node;
        else nodeByKeyValue.set(keyValue, node);
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = key.call(parent, data[i], i, data) + "";
        if (node = nodeByKeyValue.get(keyValue)) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue.delete(keyValue);
        } else enter[i] = new (0, _enterJs.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) exit[i] = node;
}
function datum(node) {
    return node.__data__;
}
// Given some data, this returns an array-like view of it: an object that
// exposes a length property and allows numeric indexing. Note that unlike
// selectAll, this isn’t worried about “live” collections because the resulting
// array will only be used briefly while data is being bound. (It is possible to
// cause the data to change while iterating by using a key function, but please
// don’t; we’d rather avoid a gratuitous copy.)
function arraylike(data) {
    return typeof data === "object" && "length" in data ? data // Array, TypedArray, NodeList, array-like
     : Array.from(data); // Map, Set, iterable, string, or anything else
}

},{"./index.js":"4cK4N","./enter.js":"7oNeK","../constant.js":"h9RMP","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7oNeK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._enter || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse.js":"faJq8","./index.js":"4cK4N","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"faJq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"h9RMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"30tJm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _indexJs.Selection)(this._exit || this._groups.map((0, _sparseJsDefault.default)), this._parents);
    });
var _sparseJs = require("./sparse.js");
var _sparseJsDefault = parcelHelpers.interopDefault(_sparseJs);
var _indexJs = require("./index.js");

},{"./sparse.js":"faJq8","./index.js":"4cK4N","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bdNx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        if (typeof onenter === "function") {
            enter = onenter(enter);
            if (enter) enter = enter.selection();
        } else enter = enter.append(onenter + "");
        if (onupdate != null) {
            update = onupdate(update);
            if (update) update = update.selection();
        }
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gmJRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        var selection = context.selection ? context.selection() : context;
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Selection)(merges, this._parents);
    });
var _indexJs = require("./index.js");

},{"./index.js":"4cK4N","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bqHtl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iXYkQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _indexJs.Selection)(sortgroups, this._parents).order();
    });
var _indexJs = require("./index.js");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index.js":"4cK4N","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"847ax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iRktY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Array.from(this);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hM7sk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kxSXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        let size = 0;
        for (const node of this)++size; // eslint-disable-line no-unused-vars
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1M9Ze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2dZFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7ZFMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceJsDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespaceJs = require("../namespace.js");
var _namespaceJsDefault = parcelHelpers.interopDefault(_namespaceJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace.js":"aC1gR","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3rFq2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowJsDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window.js":"agXe9","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"agXe9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lEB7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bUH9H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"59ucj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2PCe5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jVd7H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gMm2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k3Hj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);

},{"../creator.js":"cTpk1","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fERPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorJsDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorJsDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creatorJs = require("../creator.js");
var _creatorJsDefault = parcelHelpers.interopDefault(_creatorJs);
var _selectorJs = require("../selector.js");
var _selectorJsDefault = parcelHelpers.interopDefault(_selectorJs);
function constantNull() {
    return null;
}

},{"../creator.js":"cTpk1","../selector.js":"iCStq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fKk1I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"l0xcc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2q1Rk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jmVfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(typename, value, options) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, options));
        return this;
    });
function contextListener(listener) {
    return function(event) {
        listener.call(this, event, this.__data__);
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.options);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, options) {
    return function() {
        var on = this.__on, o, listener = contextListener(value);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.options);
                this.addEventListener(o.type, o.listener = listener, o.options = options);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, options);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            options: options
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gu1ND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _windowJs = require("../window.js");
var _windowJsDefault = parcelHelpers.interopDefault(_windowJs);
function dispatchEvent(node, type, params) {
    var window = (0, _windowJsDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window.js":"agXe9","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4l1pa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function*() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) yield node;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9ozJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), (0, _noeventJs.nonpassivecapture));
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":"aRcZV","./noevent.js":"15Cya","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"15Cya":[function(require,module,exports,__globalThis) {
// These are typically used in conjunction with noevent to ensure that we can
// preventDefault on the event.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nonpassive", ()=>nonpassive);
parcelHelpers.export(exports, "nonpassivecapture", ()=>nonpassivecapture);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
const nonpassive = {
    passive: false
};
const nonpassivecapture = {
    capture: true,
    passive: false
};
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4NpkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bo1wD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(type, { sourceEvent, subject, target, identifier, active, x, y, dx, dy, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        subject: {
            value: subject,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        identifier: {
            value: identifier,
            enumerable: true,
            configurable: true
        },
        active: {
            value: active,
            enumerable: true,
            configurable: true
        },
        x: {
            value: x,
            enumerable: true,
            configurable: true
        },
        y: {
            value: y,
            enumerable: true,
            configurable: true
        },
        dx: {
            value: dx,
            enumerable: true,
            configurable: true
        },
        dy: {
            value: dy,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"evSeJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":false,"./array.js":false,"./basis.js":false,"./basisClosed.js":false,"./date.js":false,"./discrete.js":false,"./hue.js":false,"./number.js":"kSKiT","./numberArray.js":false,"./object.js":false,"./round.js":false,"./string.js":"gStgs","./transform/index.js":"4Mveu","./zoom.js":"9LR3k","./rgb.js":"if4g2","./hsl.js":false,"./lab.js":false,"./hcl.js":false,"./cubehelix.js":false,"./piecewise.js":false,"./quantize.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9ctvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"l50UW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"9ctvu","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kSKiT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gStgs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"kSKiT","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4Mveu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"kSKiT","./parse.js":"da0lY","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"da0lY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable no-undef */ parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var svgNode;
function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? (0, _decomposeJs.identity) : (0, _decomposeJsDefault.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"kKAyr","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kKAyr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9LR3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"if4g2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"hxNG2","./basis.js":"9ctvu","./basisClosed.js":"l50UW","./color.js":"fyoAh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hxNG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"kMAh6","./lab.js":false,"./cubehelix.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kMAh6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"jnajB","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jnajB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fyoAh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"65PpW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"65PpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fjbTP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"fku8R","./transition/index.js":false,"./active.js":false,"./interrupt.js":"cchuJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fku8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":"aRcZV","./interrupt.js":"fpP3R","./transition.js":"1VURS","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fpP3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"cchuJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cchuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ih0L8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":"gT3u0","d3-timer":"c6Wd0","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"c6Wd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"5rQH2","./timeout.js":"1PbOG","./interval.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5rQH2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1PbOG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart((elapsed)=>{
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"5rQH2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1VURS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) throw new Error(`transition ${id} not found`);
    }
    return timing;
}

},{"../transition/index.js":"kvTaw","../transition/schedule.js":"ih0L8","d3-ease":"ectgZ","d3-timer":"c6Wd0","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kvTaw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _easeVaryingJs = require("./easeVarying.js");
var _easeVaryingJsDefault = parcelHelpers.interopDefault(_easeVaryingJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    selectChild: selection_prototype.selectChild,
    selectChildren: selection_prototype.selectChildren,
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    easeVarying: (0, _easeVaryingJsDefault.default),
    end: (0, _endJsDefault.default),
    [Symbol.iterator]: selection_prototype[Symbol.iterator]
};

},{"d3-selection":"aRcZV","./attr.js":"gv8Fw","./attrTween.js":"hNrf5","./delay.js":"8uR9m","./duration.js":"71nth","./ease.js":"eQdVI","./easeVarying.js":"3fOCx","./filter.js":"f8ovM","./merge.js":"fAELv","./on.js":"hyenp","./remove.js":"iaLXs","./select.js":"vwr45","./selectAll.js":"cgmpV","./selection.js":"3eioV","./style.js":"fHM0Z","./styleTween.js":"2N8hJ","./text.js":"8YrmG","./textTween.js":"jDsMF","./transition.js":"e32Jq","./tween.js":"6hKKs","./end.js":"gvutN","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gv8Fw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"evSeJ","d3-selection":"aRcZV","./tween.js":"6hKKs","./interpolate.js":"4bnMb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6hKKs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4bnMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":"hxNG2","d3-interpolate":"evSeJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hNrf5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":"aRcZV","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8uR9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"71nth":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eQdVI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3fOCx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        if (typeof value !== "function") throw new Error;
        return this.each(easeVarying(this._id, value));
    });
var _scheduleJs = require("./schedule.js");
function easeVarying(id, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (typeof v !== "function") throw new Error;
        (0, _scheduleJs.set)(this, id).ease = v;
    };
}

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f8ovM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":"aRcZV","./index.js":"kvTaw","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fAELv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"kvTaw","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hyenp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iaLXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"vwr45":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"aRcZV","./index.js":"kvTaw","./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cgmpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"aRcZV","./index.js":"kvTaw","./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3eioV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":"aRcZV","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fHM0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"evSeJ","d3-selection":"aRcZV","./schedule.js":"ih0L8","./tween.js":"6hKKs","./interpolate.js":"4bnMb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2N8hJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8YrmG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"6hKKs","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jDsMF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"e32Jq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"kvTaw","./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gvutN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
            // The selection was empty, resolve end immediately
            if (size === 0) resolve();
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"ih0L8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ectgZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", ()=>(0, _linearJs.linear));
parcelHelpers.export(exports, "easeQuad", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeQuadIn", ()=>(0, _quadJs.quadIn));
parcelHelpers.export(exports, "easeQuadOut", ()=>(0, _quadJs.quadOut));
parcelHelpers.export(exports, "easeQuadInOut", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeCubic", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easeCubicIn", ()=>(0, _cubicJs.cubicIn));
parcelHelpers.export(exports, "easeCubicOut", ()=>(0, _cubicJs.cubicOut));
parcelHelpers.export(exports, "easeCubicInOut", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easePoly", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easePolyIn", ()=>(0, _polyJs.polyIn));
parcelHelpers.export(exports, "easePolyOut", ()=>(0, _polyJs.polyOut));
parcelHelpers.export(exports, "easePolyInOut", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easeSin", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeSinIn", ()=>(0, _sinJs.sinIn));
parcelHelpers.export(exports, "easeSinOut", ()=>(0, _sinJs.sinOut));
parcelHelpers.export(exports, "easeSinInOut", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeExp", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeExpIn", ()=>(0, _expJs.expIn));
parcelHelpers.export(exports, "easeExpOut", ()=>(0, _expJs.expOut));
parcelHelpers.export(exports, "easeExpInOut", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeCircle", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeCircleIn", ()=>(0, _circleJs.circleIn));
parcelHelpers.export(exports, "easeCircleOut", ()=>(0, _circleJs.circleOut));
parcelHelpers.export(exports, "easeCircleInOut", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeBounce", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceIn", ()=>(0, _bounceJs.bounceIn));
parcelHelpers.export(exports, "easeBounceOut", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceInOut", ()=>(0, _bounceJs.bounceInOut));
parcelHelpers.export(exports, "easeBack", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeBackIn", ()=>(0, _backJs.backIn));
parcelHelpers.export(exports, "easeBackOut", ()=>(0, _backJs.backOut));
parcelHelpers.export(exports, "easeBackInOut", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeElastic", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticIn", ()=>(0, _elasticJs.elasticIn));
parcelHelpers.export(exports, "easeElasticOut", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticInOut", ()=>(0, _elasticJs.elasticInOut));
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":false,"./quad.js":false,"./cubic.js":"5Qzgg","./poly.js":false,"./sin.js":false,"./exp.js":false,"./circle.js":false,"./bounce.js":false,"./back.js":false,"./elastic.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5Qzgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"baltF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (x)=>()=>x;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8pBQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(type, { sourceEvent, target, transform, dispatch }) {
    Object.defineProperties(this, {
        type: {
            value: type,
            enumerable: true,
            configurable: true
        },
        sourceEvent: {
            value: sourceEvent,
            enumerable: true,
            configurable: true
        },
        target: {
            value: target,
            enumerable: true,
            configurable: true
        },
        transform: {
            value: transform,
            enumerable: true,
            configurable: true
        },
        _: {
            value: dispatch
        }
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iwfTt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3DuSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    });
function nopropagation(event) {
    event.stopImmediatePropagation();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"b09Pw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MiniMap", ()=>MiniMap$1);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _d3Zoom = require("d3-zoom");
var _d3Selection = require("d3-selection");
var _core = require("@reactflow/core");
const MiniMapNode = ({ id, x, y, width, height, style, color, strokeColor, strokeWidth, className, borderRadius, shapeRendering, onClick, selected })=>{
    const { background, backgroundColor } = style || {};
    const fill = color || background || backgroundColor;
    return (0, _reactDefault.default).createElement("rect", {
        className: (0, _classcatDefault.default)([
            'react-flow__minimap-node',
            {
                selected
            },
            className
        ]),
        x: x,
        y: y,
        rx: borderRadius,
        ry: borderRadius,
        width: width,
        height: height,
        fill: fill,
        stroke: strokeColor,
        strokeWidth: strokeWidth,
        shapeRendering: shapeRendering,
        onClick: onClick ? (event)=>onClick(event, id) : undefined
    });
};
MiniMapNode.displayName = 'MiniMapNode';
var MiniMapNode$1 = (0, _react.memo)(MiniMapNode);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const selector$1 = (s)=>s.nodeOrigin;
const selectorNodes = (s)=>s.getNodes().filter((node)=>!node.hidden && node.width && node.height);
const getAttrFunction = (func)=>func instanceof Function ? func : ()=>func;
function MiniMapNodes({ nodeStrokeColor = 'transparent', nodeColor = '#e2e2e2', nodeClassName = '', nodeBorderRadius = 5, nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent: NodeComponent = MiniMapNode$1, onClick }) {
    const nodes = (0, _core.useStore)(selectorNodes, (0, _shallow.shallow));
    const nodeOrigin = (0, _core.useStore)(selector$1);
    const nodeColorFunc = getAttrFunction(nodeColor);
    const nodeStrokeColorFunc = getAttrFunction(nodeStrokeColor);
    const nodeClassNameFunc = getAttrFunction(nodeClassName);
    const shapeRendering = typeof window === 'undefined' || !!window.chrome ? 'crispEdges' : 'geometricPrecision';
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, nodes.map((node)=>{
        const { x, y } = (0, _core.getNodePositionWithOrigin)(node, nodeOrigin).positionAbsolute;
        return (0, _reactDefault.default).createElement(NodeComponent, {
            key: node.id,
            x: x,
            y: y,
            width: node.width,
            height: node.height,
            style: node.style,
            selected: node.selected,
            className: nodeClassNameFunc(node),
            color: nodeColorFunc(node),
            borderRadius: nodeBorderRadius,
            strokeColor: nodeStrokeColorFunc(node),
            strokeWidth: nodeStrokeWidth,
            shapeRendering: shapeRendering,
            onClick: onClick,
            id: node.id
        });
    }));
}
var MiniMapNodes$1 = (0, _react.memo)(MiniMapNodes);
/* eslint-disable @typescript-eslint/ban-ts-comment */ const defaultWidth = 200;
const defaultHeight = 150;
const selector = (s)=>{
    const nodes = s.getNodes();
    const viewBB = {
        x: -s.transform[0] / s.transform[2],
        y: -s.transform[1] / s.transform[2],
        width: s.width / s.transform[2],
        height: s.height / s.transform[2]
    };
    return {
        viewBB,
        boundingRect: nodes.length > 0 ? (0, _core.getBoundsOfRects)((0, _core.getNodesBounds)(nodes, s.nodeOrigin), viewBB) : viewBB,
        rfId: s.rfId
    };
};
const ARIA_LABEL_KEY = 'react-flow__minimap-desc';
function MiniMap({ style, className, nodeStrokeColor = 'transparent', nodeColor = '#e2e2e2', nodeClassName = '', nodeBorderRadius = 5, nodeStrokeWidth = 2, // We need to rename the prop to be `CapitalCase` so that JSX will render it as
// a component properly.
nodeComponent, maskColor = 'rgb(240, 240, 240, 0.6)', maskStrokeColor = 'none', maskStrokeWidth = 1, position = 'bottom-right', onClick, onNodeClick, pannable = false, zoomable = false, ariaLabel = 'React Flow mini map', inversePan = false, zoomStep = 10, offsetScale = 5 }) {
    const store = (0, _core.useStoreApi)();
    const svg = (0, _react.useRef)(null);
    const { boundingRect, viewBB, rfId } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    var _style_width;
    const elementWidth = (_style_width = style === null || style === void 0 ? void 0 : style.width) !== null && _style_width !== void 0 ? _style_width : defaultWidth;
    var _style_height;
    const elementHeight = (_style_height = style === null || style === void 0 ? void 0 : style.height) !== null && _style_height !== void 0 ? _style_height : defaultHeight;
    const scaledWidth = boundingRect.width / elementWidth;
    const scaledHeight = boundingRect.height / elementHeight;
    const viewScale = Math.max(scaledWidth, scaledHeight);
    const viewWidth = viewScale * elementWidth;
    const viewHeight = viewScale * elementHeight;
    const offset = offsetScale * viewScale;
    const x = boundingRect.x - (viewWidth - boundingRect.width) / 2 - offset;
    const y = boundingRect.y - (viewHeight - boundingRect.height) / 2 - offset;
    const width = viewWidth + offset * 2;
    const height = viewHeight + offset * 2;
    const labelledBy = `${ARIA_LABEL_KEY}-${rfId}`;
    const viewScaleRef = (0, _react.useRef)(0);
    viewScaleRef.current = viewScale;
    (0, _react.useEffect)(()=>{
        if (svg.current) {
            const selection = (0, _d3Selection.select)(svg.current);
            const zoomHandler = (event)=>{
                const { transform, d3Selection, d3Zoom } = store.getState();
                if (event.sourceEvent.type !== 'wheel' || !d3Selection || !d3Zoom) return;
                const pinchDelta = -event.sourceEvent.deltaY * (event.sourceEvent.deltaMode === 1 ? 0.05 : event.sourceEvent.deltaMode ? 1 : 0.002) * zoomStep;
                const zoom = transform[2] * Math.pow(2, pinchDelta);
                d3Zoom.scaleTo(d3Selection, zoom);
            };
            const panHandler = (event)=>{
                const { transform, d3Selection, d3Zoom, translateExtent, width, height } = store.getState();
                if (event.sourceEvent.type !== 'mousemove' || !d3Selection || !d3Zoom) return;
                // @TODO: how to calculate the correct next position? Math.max(1, transform[2]) is a workaround.
                const moveScale = viewScaleRef.current * Math.max(1, transform[2]) * (inversePan ? -1 : 1);
                const position = {
                    x: transform[0] - event.sourceEvent.movementX * moveScale,
                    y: transform[1] - event.sourceEvent.movementY * moveScale
                };
                const extent = [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        height
                    ]
                ];
                const nextTransform = (0, _d3Zoom.zoomIdentity).translate(position.x, position.y).scale(transform[2]);
                const constrainedTransform = d3Zoom.constrain()(nextTransform, extent, translateExtent);
                d3Zoom.transform(d3Selection, constrainedTransform);
            };
            const zoomAndPanHandler = (0, _d3Zoom.zoom)()// @ts-ignore
            .on('zoom', pannable ? panHandler : null)// @ts-ignore
            .on('zoom.wheel', zoomable ? zoomHandler : null);
            selection.call(zoomAndPanHandler);
            return ()=>{
                selection.on('zoom', null);
            };
        }
    }, [
        pannable,
        zoomable,
        inversePan,
        zoomStep
    ]);
    const onSvgClick = onClick ? (event)=>{
        const rfCoord = (0, _d3Selection.pointer)(event);
        onClick(event, {
            x: rfCoord[0],
            y: rfCoord[1]
        });
    } : undefined;
    const onSvgNodeClick = onNodeClick ? (event, nodeId)=>{
        const node = store.getState().nodeInternals.get(nodeId);
        onNodeClick(event, node);
    } : undefined;
    return (0, _reactDefault.default).createElement((0, _core.Panel), {
        position: position,
        style: style,
        className: (0, _classcatDefault.default)([
            'react-flow__minimap',
            className
        ]),
        "data-testid": "rf__minimap"
    }, (0, _reactDefault.default).createElement("svg", {
        width: elementWidth,
        height: elementHeight,
        viewBox: `${x} ${y} ${width} ${height}`,
        role: "img",
        "aria-labelledby": labelledBy,
        ref: svg,
        onClick: onSvgClick
    }, ariaLabel && (0, _reactDefault.default).createElement("title", {
        id: labelledBy
    }, ariaLabel), (0, _reactDefault.default).createElement(MiniMapNodes$1, {
        onClick: onSvgNodeClick,
        nodeColor: nodeColor,
        nodeStrokeColor: nodeStrokeColor,
        nodeBorderRadius: nodeBorderRadius,
        nodeClassName: nodeClassName,
        nodeStrokeWidth: nodeStrokeWidth,
        nodeComponent: nodeComponent
    }), (0, _reactDefault.default).createElement("path", {
        className: "react-flow__minimap-mask",
        d: `M${x - offset},${y - offset}h${width + offset * 2}v${height + offset * 2}h${-width - offset * 2}z
        M${viewBB.x},${viewBB.y}h${viewBB.width}v${viewBB.height}h${-viewBB.width}z`,
        fill: maskColor,
        fillRule: "evenodd",
        stroke: maskStrokeColor,
        strokeWidth: maskStrokeWidth,
        pointerEvents: "none"
    })));
}
MiniMap.displayName = 'MiniMap';
var MiniMap$1 = (0, _react.memo)(MiniMap);

},{"react":"lXMxO","classcat":"aUX38","zustand/shallow":"gLHka","d3-zoom":"5GcoX","d3-selection":"aRcZV","@reactflow/core":"bQune","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bGWK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlButton", ()=>ControlButton);
parcelHelpers.export(exports, "Controls", ()=>Controls$1);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _core = require("@reactflow/core");
function PlusIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z"
    }));
}
function MinusIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 5"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M0 0h32v4.2H0z"
    }));
}
function FitViewIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 30"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z"
    }));
}
function LockIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z"
    }));
}
function UnlockIcon() {
    return (0, _reactDefault.default).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 25 32"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z"
    }));
}
const ControlButton = (_param)=>{
    var { children, className } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "children",
        "className"
    ]);
    return (0, _reactDefault.default).createElement("button", (0, _objectSpread._)({
        type: "button",
        className: (0, _classcatDefault.default)([
            'react-flow__controls-button',
            className
        ])
    }, rest), children);
};
ControlButton.displayName = 'ControlButton';
const selector = (s)=>({
        isInteractive: s.nodesDraggable || s.nodesConnectable || s.elementsSelectable,
        minZoomReached: s.transform[2] <= s.minZoom,
        maxZoomReached: s.transform[2] >= s.maxZoom
    });
const Controls = ({ style, showZoom = true, showFitView = true, showInteractive = true, fitViewOptions, onZoomIn, onZoomOut, onFitView, onInteractiveChange, className, children, position = 'bottom-left' })=>{
    const store = (0, _core.useStoreApi)();
    const [isVisible, setIsVisible] = (0, _react.useState)(false);
    const { isInteractive, minZoomReached, maxZoomReached } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const { zoomIn, zoomOut, fitView } = (0, _core.useReactFlow)();
    (0, _react.useEffect)(()=>{
        setIsVisible(true);
    }, []);
    if (!isVisible) return null;
    const onZoomInHandler = ()=>{
        zoomIn();
        onZoomIn === null || onZoomIn === void 0 ? void 0 : onZoomIn();
    };
    const onZoomOutHandler = ()=>{
        zoomOut();
        onZoomOut === null || onZoomOut === void 0 ? void 0 : onZoomOut();
    };
    const onFitViewHandler = ()=>{
        fitView(fitViewOptions);
        onFitView === null || onFitView === void 0 ? void 0 : onFitView();
    };
    const onToggleInteractivity = ()=>{
        store.setState({
            nodesDraggable: !isInteractive,
            nodesConnectable: !isInteractive,
            elementsSelectable: !isInteractive
        });
        onInteractiveChange === null || onInteractiveChange === void 0 ? void 0 : onInteractiveChange(!isInteractive);
    };
    return (0, _reactDefault.default).createElement((0, _core.Panel), {
        className: (0, _classcatDefault.default)([
            'react-flow__controls',
            className
        ]),
        position: position,
        style: style,
        "data-testid": "rf__controls"
    }, showZoom && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(ControlButton, {
        onClick: onZoomInHandler,
        className: "react-flow__controls-zoomin",
        title: "zoom in",
        "aria-label": "zoom in",
        disabled: maxZoomReached
    }, (0, _reactDefault.default).createElement(PlusIcon, null)), (0, _reactDefault.default).createElement(ControlButton, {
        onClick: onZoomOutHandler,
        className: "react-flow__controls-zoomout",
        title: "zoom out",
        "aria-label": "zoom out",
        disabled: minZoomReached
    }, (0, _reactDefault.default).createElement(MinusIcon, null))), showFitView && (0, _reactDefault.default).createElement(ControlButton, {
        className: "react-flow__controls-fitview",
        onClick: onFitViewHandler,
        title: "fit view",
        "aria-label": "fit view"
    }, (0, _reactDefault.default).createElement(FitViewIcon, null)), showInteractive && (0, _reactDefault.default).createElement(ControlButton, {
        className: "react-flow__controls-interactive",
        onClick: onToggleInteractivity,
        title: "toggle interactivity",
        "aria-label": "toggle interactivity"
    }, isInteractive ? (0, _reactDefault.default).createElement(UnlockIcon, null) : (0, _reactDefault.default).createElement(LockIcon, null)), children);
};
Controls.displayName = 'Controls';
var Controls$1 = (0, _react.memo)(Controls);

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_without_properties":"7R2qf","react":"lXMxO","classcat":"aUX38","zustand/shallow":"gLHka","@reactflow/core":"bQune","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k1yh7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Background", ()=>Background$1);
parcelHelpers.export(exports, "BackgroundVariant", ()=>BackgroundVariant);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _core = require("@reactflow/core");
var _shallow = require("zustand/shallow");
var BackgroundVariant;
(function(BackgroundVariant) {
    BackgroundVariant["Lines"] = "lines";
    BackgroundVariant["Dots"] = "dots";
    BackgroundVariant["Cross"] = "cross";
})(BackgroundVariant || (BackgroundVariant = {}));
function LinePattern({ color, dimensions, lineWidth }) {
    return (0, _reactDefault.default).createElement("path", {
        stroke: color,
        strokeWidth: lineWidth,
        d: `M${dimensions[0] / 2} 0 V${dimensions[1]} M0 ${dimensions[1] / 2} H${dimensions[0]}`
    });
}
function DotPattern({ color, radius }) {
    return (0, _reactDefault.default).createElement("circle", {
        cx: radius,
        cy: radius,
        r: radius,
        fill: color
    });
}
const defaultColor = {
    [BackgroundVariant.Dots]: '#91919a',
    [BackgroundVariant.Lines]: '#eee',
    [BackgroundVariant.Cross]: '#e2e2e2'
};
const defaultSize = {
    [BackgroundVariant.Dots]: 1,
    [BackgroundVariant.Lines]: 1,
    [BackgroundVariant.Cross]: 6
};
const selector = (s)=>({
        transform: s.transform,
        patternId: `pattern-${s.rfId}`
    });
function Background({ id, variant = BackgroundVariant.Dots, // only used for dots and cross
gap = 20, // only used for lines and cross
size, lineWidth = 1, offset = 2, color, style, className }) {
    const ref = (0, _react.useRef)(null);
    const { transform, patternId } = (0, _core.useStore)(selector, (0, _shallow.shallow));
    const patternColor = color || defaultColor[variant];
    const patternSize = size || defaultSize[variant];
    const isDots = variant === BackgroundVariant.Dots;
    const isCross = variant === BackgroundVariant.Cross;
    const gapXY = Array.isArray(gap) ? gap : [
        gap,
        gap
    ];
    const scaledGap = [
        gapXY[0] * transform[2] || 1,
        gapXY[1] * transform[2] || 1
    ];
    const scaledSize = patternSize * transform[2];
    const patternDimensions = isCross ? [
        scaledSize,
        scaledSize
    ] : scaledGap;
    const patternOffset = isDots ? [
        scaledSize / offset,
        scaledSize / offset
    ] : [
        patternDimensions[0] / offset,
        patternDimensions[1] / offset
    ];
    return (0, _reactDefault.default).createElement("svg", {
        className: (0, _classcatDefault.default)([
            'react-flow__background',
            className
        ]),
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0
        }),
        ref: ref,
        "data-testid": "rf__background"
    }, (0, _reactDefault.default).createElement("pattern", {
        id: patternId + id,
        x: transform[0] % scaledGap[0],
        y: transform[1] % scaledGap[1],
        width: scaledGap[0],
        height: scaledGap[1],
        patternUnits: "userSpaceOnUse",
        patternTransform: `translate(-${patternOffset[0]},-${patternOffset[1]})`
    }, isDots ? (0, _reactDefault.default).createElement(DotPattern, {
        color: patternColor,
        radius: scaledSize / offset
    }) : (0, _reactDefault.default).createElement(LinePattern, {
        dimensions: patternDimensions,
        color: patternColor,
        lineWidth: lineWidth
    })), (0, _reactDefault.default).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: `url(#${patternId + id})`
    }));
}
Background.displayName = 'Background';
var Background$1 = (0, _react.memo)(Background);

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react":"lXMxO","classcat":"aUX38","@reactflow/core":"bQune","zustand/shallow":"gLHka","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"876dU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeToolbar", ()=>NodeToolbar);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@reactflow/core");
var _classcat = require("classcat");
var _classcatDefault = parcelHelpers.interopDefault(_classcat);
var _shallow = require("zustand/shallow");
var _reactDom = require("react-dom");
const selector = (state)=>{
    var _state_domNode;
    return (_state_domNode = state.domNode) === null || _state_domNode === void 0 ? void 0 : _state_domNode.querySelector('.react-flow__renderer');
};
function NodeToolbarPortal({ children }) {
    const wrapperRef = (0, _core.useStore)(selector);
    if (!wrapperRef) return null;
    return (0, _reactDom.createPortal)(children, wrapperRef);
}
const nodeEqualityFn = (a, b)=>{
    var _a_positionAbsolute, _b_positionAbsolute, _a_positionAbsolute1, _b_positionAbsolute1, _a_internalsSymbol, _b_internalsSymbol;
    return (a === null || a === void 0 ? void 0 : (_a_positionAbsolute = a.positionAbsolute) === null || _a_positionAbsolute === void 0 ? void 0 : _a_positionAbsolute.x) === (b === null || b === void 0 ? void 0 : (_b_positionAbsolute = b.positionAbsolute) === null || _b_positionAbsolute === void 0 ? void 0 : _b_positionAbsolute.x) && (a === null || a === void 0 ? void 0 : (_a_positionAbsolute1 = a.positionAbsolute) === null || _a_positionAbsolute1 === void 0 ? void 0 : _a_positionAbsolute1.y) === (b === null || b === void 0 ? void 0 : (_b_positionAbsolute1 = b.positionAbsolute) === null || _b_positionAbsolute1 === void 0 ? void 0 : _b_positionAbsolute1.y) && (a === null || a === void 0 ? void 0 : a.width) === (b === null || b === void 0 ? void 0 : b.width) && (a === null || a === void 0 ? void 0 : a.height) === (b === null || b === void 0 ? void 0 : b.height) && (a === null || a === void 0 ? void 0 : a.selected) === (b === null || b === void 0 ? void 0 : b.selected) && (a === null || a === void 0 ? void 0 : (_a_internalsSymbol = a[0, _core.internalsSymbol]) === null || _a_internalsSymbol === void 0 ? void 0 : _a_internalsSymbol.z) === (b === null || b === void 0 ? void 0 : (_b_internalsSymbol = b[0, _core.internalsSymbol]) === null || _b_internalsSymbol === void 0 ? void 0 : _b_internalsSymbol.z);
};
const nodesEqualityFn = (a, b)=>{
    return a.length === b.length && a.every((node, i)=>nodeEqualityFn(node, b[i]));
};
const storeSelector = (state)=>({
        transform: state.transform,
        nodeOrigin: state.nodeOrigin,
        selectedNodesCount: state.getNodes().filter((node)=>node.selected).length
    });
function getTransform(nodeRect, transform, position, offset, align) {
    let alignmentOffset = 0.5;
    if (align === 'start') alignmentOffset = 0;
    else if (align === 'end') alignmentOffset = 1;
    // position === Position.Top
    // we set the x any y position of the toolbar based on the nodes position
    let pos = [
        (nodeRect.x + nodeRect.width * alignmentOffset) * transform[2] + transform[0],
        nodeRect.y * transform[2] + transform[1] - offset
    ];
    // and than shift it based on the alignment. The shift values are in %.
    let shift = [
        -100 * alignmentOffset,
        -100
    ];
    switch(position){
        case (0, _core.Position).Right:
            pos = [
                (nodeRect.x + nodeRect.width) * transform[2] + transform[0] + offset,
                (nodeRect.y + nodeRect.height * alignmentOffset) * transform[2] + transform[1]
            ];
            shift = [
                0,
                -100 * alignmentOffset
            ];
            break;
        case (0, _core.Position).Bottom:
            pos[1] = (nodeRect.y + nodeRect.height) * transform[2] + transform[1] + offset;
            shift[1] = 0;
            break;
        case (0, _core.Position).Left:
            pos = [
                nodeRect.x * transform[2] + transform[0] - offset,
                (nodeRect.y + nodeRect.height * alignmentOffset) * transform[2] + transform[1]
            ];
            shift = [
                -100,
                -100 * alignmentOffset
            ];
            break;
    }
    return `translate(${pos[0]}px, ${pos[1]}px) translate(${shift[0]}%, ${shift[1]}%)`;
}
function NodeToolbar(_param) {
    var { nodeId, children, className, style, isVisible, position = (0, _core.Position).Top, offset = 10, align = 'center' } = _param, rest = (0, _objectWithoutProperties._)(_param, [
        "nodeId",
        "children",
        "className",
        "style",
        "isVisible",
        "position",
        "offset",
        "align"
    ]);
    const contextNodeId = (0, _core.useNodeId)();
    const nodesSelector = (0, _react.useCallback)((state)=>{
        const nodeIds = Array.isArray(nodeId) ? nodeId : [
            nodeId || contextNodeId || ''
        ];
        return nodeIds.reduce((acc, id)=>{
            const node = state.nodeInternals.get(id);
            if (node) acc.push(node);
            return acc;
        }, []);
    }, [
        nodeId,
        contextNodeId
    ]);
    const nodes = (0, _core.useStore)(nodesSelector, nodesEqualityFn);
    const { transform, nodeOrigin, selectedNodesCount } = (0, _core.useStore)(storeSelector, (0, _shallow.shallow));
    const isActive = typeof isVisible === 'boolean' ? isVisible : nodes.length === 1 && nodes[0].selected && selectedNodesCount === 1;
    if (!isActive || !nodes.length) return null;
    const nodeRect = (0, _core.getNodesBounds)(nodes, nodeOrigin);
    const zIndex = Math.max(...nodes.map((node)=>{
        var _node_internalsSymbol;
        return (((_node_internalsSymbol = node[0, _core.internalsSymbol]) === null || _node_internalsSymbol === void 0 ? void 0 : _node_internalsSymbol.z) || 1) + 1;
    }));
    const wrapperStyle = (0, _objectSpread._)({
        position: 'absolute',
        transform: getTransform(nodeRect, transform, position, offset, align),
        zIndex
    }, style);
    return (0, _reactDefault.default).createElement(NodeToolbarPortal, null, (0, _reactDefault.default).createElement("div", (0, _objectSpread._)({
        style: wrapperStyle,
        className: (0, _classcatDefault.default)([
            'react-flow__node-toolbar',
            className
        ])
    }, rest), children));
}

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_without_properties":"7R2qf","react":"lXMxO","@reactflow/core":"bQune","classcat":"aUX38","zustand/shallow":"gLHka","react-dom":"dgecT","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hmElE":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("a19f4edd89926025");
var ReactExports = require("e3cb921f47249eac");
var useSyncExternalStoreExports = require("1e8ad8cf8d3b3c90");
var useDebugValue = ReactExports.useDebugValue;
var useSyncExternalStoreWithSelector = useSyncExternalStoreExports.useSyncExternalStoreWithSelector;
var didWarnAboutEqualityFn = false;
var identity = function identity(arg) {
    return arg;
};
function useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = identity;
    var slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    useDebugValue(slice);
    return slice;
}
var createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? vanilla.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var create = function create(createState) {
    return createState ? createImpl(createState) : createImpl;
};
var react = function(createState) {
    return create(createState);
};
exports.create = create;
exports.default = react;
exports.useStore = useStore;
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
module.exports = react;
module.exports.create = create;
module.exports.useStore = useStore;
module.exports.createStore = vanilla.createStore;
exports.default = module.exports;

},{"a19f4edd89926025":"5q3l0","e3cb921f47249eac":"lXMxO","1e8ad8cf8d3b3c90":"coZLe"}],"8lm4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPatch", ()=>(0, _createPatchDefault.default));
parcelHelpers.export(exports, "setAudioNodeTypes", ()=>(0, _audioNodeTypes.setAudioNodeTypes));
parcelHelpers.export(exports, "getAudioNodeType", ()=>(0, _audioNodeTypes.getAudioNodeType));
var _createPatch = require("./src/createPatch");
var _createPatchDefault = parcelHelpers.interopDefault(_createPatch);
var _audioNodeTypes = require("./src/audioNodeTypes");

},{"./src/createPatch":"cSXIQ","./src/audioNodeTypes":"jPjqC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cSXIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNodeTypes = require("./audioNodeTypes");
//@ts-ignore
var _dumpNodeWorkletTs = require("worklet:./dumpNodeWorklet.ts");
var _dumpNodeWorkletTsDefault = parcelHelpers.interopDefault(_dumpNodeWorkletTs);
const dumpNodeWorklet = new URL((0, _dumpNodeWorkletTsDefault.default), "file:///packages/patch/src/createPatch.ts");
const createPatch = (audioContext = new AudioContext())=>{
    /*
     * due to bug in chrome we need to kickstart worklet outputs
     * by connecting it to an input
     * */ const dumpNodePromise = audioContext.audioWorklet.addModule(dumpNodeWorklet).then(()=>{
        return new AudioWorkletNode(audioContext, "dump-node-processor");
    });
    const audioNodes = new Map();
    const audioConnections = new Map();
    const registerAudioNode = async (node)=>{
        const { id, type, data } = node;
        if (!type) {
            audioNodes.set(id, {
                loading: false,
                error: new Error(`Node: ${id} has no type`),
                node: null
            });
            return;
        }
        const nodeCreator = (0, _audioNodeTypes.getAudioNodeType)(type);
        if (nodeCreator === false) return;
        const createNode = nodeCreator;
        if (!createNode) {
            audioNodes.set(id, {
                loading: false,
                error: new Error(`Could not find handler for audio type ${type}`),
                node: null
            });
            return;
        }
        audioNodes.set(id, {
            loading: true,
            error: null,
            node: null
        });
        try {
            const audioNode = await createNode(audioContext, data);
            const dumpNode = await dumpNodePromise;
            audioNodes.set(id, {
                loading: false,
                error: null,
                node: audioNode
            });
            // Kickstart worklet outputs
            Object.values(audioNode.outputs || []).forEach(({ port })=>{
                if (!dumpNode) return;
                if (port instanceof AudioWorkletNode) port.connect(dumpNode);
                if (Array.isArray(port) && port[0] instanceof AudioWorkletNode) port[0].connect(dumpNode, port[1]);
            });
        } catch (error) {
            audioNodes.set(id, {
                loading: false,
                error: error,
                node: null
            });
        }
    };
    const registerAudioNodes = async (nodes)=>{
        return Promise.all(nodes.map(registerAudioNode));
    };
    const unregisterAudioNode = (props)=>{
        const { id, data } = props;
        const audioNode = audioNodes.get(id);
        if (!audioNode) {
            console.error(`Audio node #${id} does not exist`);
            return;
        }
        const { loading, error, node } = audioNode;
        if (loading) {
            console.error(`Audio node #${id} is yet not loaded`);
            return;
        }
        if (error) {
            console.error(`Audio node #${id} is in error state: ${error.toString()}`);
            return;
        }
        node.destroy && node.destroy();
        //disconnect all ports
        Object.values(node.inputs || {}).forEach(({ port })=>port instanceof AudioNode && port.disconnect && port.disconnect());
        Object.values(node.outputs || {}).forEach(({ port })=>port instanceof AudioNode && port.disconnect && port.disconnect());
        audioNodes.delete(id);
    };
    const unregisterAudioNodes = (nodes)=>{
        return nodes.map(unregisterAudioNode);
    };
    const registerAudioConnection = (edge)=>{
        var _sourceNode_outputs, _targetNode_inputs;
        const { source, sourceHandle, target, targetHandle, id } = edge;
        const { node: sourceNode } = audioNodes.get(source) || {};
        if (!sourceNode) {
            console.error(`can't find source node ${source}`);
            return;
        }
        if (!sourceHandle) {
            console.error(`source handle is not defined in node ${source}`);
            return;
        }
        const outputNode = (_sourceNode_outputs = sourceNode.outputs) === null || _sourceNode_outputs === void 0 ? void 0 : _sourceNode_outputs[sourceHandle];
        const outputNodePort = outputNode === null || outputNode === void 0 ? void 0 : outputNode.port;
        const { node: targetNode } = audioNodes.get(target) || {};
        if (!targetNode) {
            console.error(`can't find target node ${targetNode}`);
            return;
        }
        if (!targetHandle) {
            console.error(`source handle is not defined in node ${sourceNode}`);
            return;
        }
        const inputNode = (_targetNode_inputs = targetNode.inputs) === null || _targetNode_inputs === void 0 ? void 0 : _targetNode_inputs[targetHandle];
        const inputNodePort = inputNode === null || inputNode === void 0 ? void 0 : inputNode.port;
        if (!outputNodePort) {
            console.error(`Can't find output port: ${source}:${sourceHandle}`);
            return;
        }
        if (!inputNodePort) {
            console.error(`Can't find input port: ${target}:${targetHandle}`);
            return;
        }
        const isInputNode = inputNodePort instanceof AudioNode;
        const isInputParam = inputNodePort instanceof AudioParam;
        const isInputArray = inputNodePort instanceof Array;
        const isInputSimple = isInputNode || isInputParam;
        const isOutputNode = outputNodePort instanceof AudioNode;
        const isOutputArray = outputNodePort instanceof Array;
        if (isOutputNode && isInputSimple) //@ts-ignore inputNode can actually be AudioParam
        outputNodePort.connect(inputNodePort);
        else if (isOutputNode && isInputArray) outputNodePort.connect(inputNodePort[0], 0, inputNodePort[1]);
        else if (isOutputArray && isInputSimple) //@ts-ignore inputNode can actually be AudioParam
        outputNodePort[0].connect(inputNodePort, outputNodePort[1]);
        else if (isOutputArray && isInputArray) outputNodePort[0].connect(inputNodePort[0], outputNodePort[1], inputNodePort[1]);
        else {
            console.log(outputNodePort, inputNodePort);
            console.error(`ports can be only AudioNode or AudioNodeChannel`);
        }
        audioConnections.set(id, {
            output: outputNode,
            input: inputNode
        });
    };
    const registerAudioConnections = (edges)=>{
        return edges.map(registerAudioConnection);
    };
    const unregisterAudioConnection = (edge)=>{
        const { id, data } = edge;
        const audioConnection = audioConnections.get(id);
        if (!audioConnection) {
            console.error(`can't find connection with id: ${id}`);
            return;
        }
        const { input: { port: inputNodePort }, output: { port: outputNodePort } } = audioConnection;
        const isInputNode = inputNodePort instanceof AudioNode;
        const isInputParam = inputNodePort instanceof AudioParam;
        const isInputArray = inputNodePort instanceof Array;
        const isInputSimple = isInputNode || isInputParam;
        const isOutputNode = outputNodePort instanceof AudioNode;
        const isOutputArray = outputNodePort instanceof Array;
        if (isOutputNode && isInputSimple) //@ts-ignore inputNode can actually be AudioParam
        outputNodePort.disconnect(inputNodePort);
        else if (isOutputNode && isInputArray) outputNodePort.disconnect(inputNodePort[0], 0, inputNodePort[1]);
        else if (isOutputArray && isInputSimple) //@ts-ignore inputNode can actually be AudioParam
        outputNodePort[0].disconnect(inputNodePort, outputNodePort[1]);
        else if (isOutputArray && isInputArray) outputNodePort[0].disconnect(inputNodePort[0], outputNodePort[1], inputNodePort[1]);
        else {
            console.log(outputNodePort, inputNodePort);
            throw new Error(`output port can not be only AudioNode or AudioNodeChannel`);
        }
        audioConnections.delete(id);
    };
    const unregisterAudioConnections = (edges)=>{
        return edges.map(unregisterAudioConnection);
    };
    return {
        audioContext,
        audioNodes,
        registerAudioNode,
        registerAudioNodes,
        unregisterAudioNode,
        unregisterAudioNodes,
        audioConnections,
        registerAudioConnection,
        registerAudioConnections,
        unregisterAudioConnection,
        unregisterAudioConnections
    };
};
exports.default = createPatch;

},{"./audioNodeTypes":"jPjqC","worklet:./dumpNodeWorklet.ts":"6MAeD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jPjqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audioNodeTypes", ()=>audioNodeTypes);
parcelHelpers.export(exports, "setAudioNodeTypes", ()=>setAudioNodeTypes);
parcelHelpers.export(exports, "getAudioNodeType", ()=>getAudioNodeType);
const audioNodeTypes = {};
const setAudioNodeTypes = (newAudioNodeTypes)=>{
    Object.assign(audioNodeTypes, newAudioNodeTypes);
};
const getAudioNodeType = (type)=>audioNodeTypes[type];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6MAeD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("kjAGT");

},{}],"k5UCO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DRAG_HANDLE_CLASS", ()=>DRAG_HANDLE_CLASS);
parcelHelpers.export(exports, "DRAG_HANDLE_SELECTOR", ()=>DRAG_HANDLE_SELECTOR);
parcelHelpers.export(exports, "CONTROL_PANEL_GRID_CONFIG", ()=>CONTROL_PANEL_GRID_CONFIG);
parcelHelpers.export(exports, "PortType", ()=>PortType);
const DRAG_HANDLE_CLASS = "web-noise-drag-handle";
const DRAG_HANDLE_SELECTOR = `.${DRAG_HANDLE_CLASS}`;
const CONTROL_PANEL_GRID_CONFIG = {
    rowHeight: 10,
    cols: 4
};
var PortType;
(function(PortType) {
    PortType["Gate"] = "gate";
    PortType["Number"] = "number";
    PortType["Audio"] = "audio";
    PortType["Any"] = "any";
})(PortType || (PortType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4rbM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const generateNodeId = (node)=>{
    const random = +new Date() + Math.floor(Math.random() * 1000);
    if (!(node === null || node === void 0 ? void 0 : node.type)) return random.toString();
    return `${node.type}-${random}`;
};
exports.default = generateNodeId;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6bwzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _reactflow = require("reactflow");
var _constants = require("../constants");
const nodesStateCreator = (set, get)=>({
        nodes: [],
        edges: [],
        onNodesChange: (changes)=>{
            set(({ nodes })=>({
                    nodes: (0, _reactflow.applyNodeChanges)(changes, nodes).map((node)=>(0, _objectSpread._)({
                            dragHandle: (0, _constants.DRAG_HANDLE_SELECTOR)
                        }, node))
                }));
        },
        onEdgesChange: (changes)=>{
            set(({ edges })=>({
                    edges: (0, _reactflow.applyEdgeChanges)(changes, edges)
                }));
        },
        onConnect: (connection)=>{
            set(({ edges })=>({
                    edges: (0, _reactflow.addEdge)(connection, edges)
                }));
        },
        addNode: (node)=>{
            set(({ nodes })=>({
                    nodes: nodes.concat(node)
                }));
        },
        setNodes: (nodes)=>{
            set({
                nodes
            });
        },
        setEdges: (edges)=>{
            set({
                edges
            });
        },
        setNodesAndEdges: ({ nodes, edges })=>{
            set({
                nodes,
                edges
            });
        },
        getNodesAndEdges: ()=>{
            const { nodes, edges } = get();
            return {
                nodes,
                edges
            };
        },
        clearElements: ()=>{
            set({
                nodes: [],
                edges: []
            });
        },
        getNode: (id)=>{
            const { nodes } = get();
            const node = nodes.find((node)=>node.id === id);
            return node || null;
        },
        updateNodeData: (id, data)=>{
            set(({ nodes })=>{
                return {
                    nodes: nodes.map((node)=>{
                        if (node.id === id) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
                            data: (0, _objectSpread._)({}, node.data, data)
                        });
                        return node;
                    })
                };
            });
        },
        nodeTypes: {},
        setNodeTypes: (nodeTypes)=>set({
                nodeTypes
            })
    });
exports.default = nodesStateCreator;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","reactflow":"eL4zf","../constants":"k5UCO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kfBk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "historyStateCreator", ()=>historyStateCreator);
parcelHelpers.export(exports, "createChangesCollector", ()=>createChangesCollector);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsondiffpatch = require("jsondiffpatch");
const cloneObject = (input)=>{
    return JSON.parse(JSON.stringify(input));
};
const historyStateCreator = (set, get)=>({
        history: {
            maxHistoryLength: 5,
            buffer: [],
            pointer: 0,
            skipCollect: false,
            push: (changes)=>{
                const { history } = get();
                const { maxHistoryLength, skipCollect } = history;
                if (skipCollect) {
                    set({
                        history: (0, _objectSpreadProps._)((0, _objectSpread._)({}, history), {
                            skipCollect: false
                        })
                    });
                    return;
                }
                set(({ history })=>{
                    if (!history) return {};
                    const { buffer, pointer } = history;
                    const newBuffer = buffer.slice(Math.max(pointer - maxHistoryLength + 1, 0), pointer);
                    return {
                        history: (0, _objectSpreadProps._)((0, _objectSpread._)({}, history), {
                            buffer: [
                                ...newBuffer,
                                changes
                            ],
                            pointer: Math.min(pointer + 1, maxHistoryLength)
                        })
                    };
                });
            },
            back: ()=>{
                const { nodes, edges, controlPanel, history } = get();
                const { buffer, pointer } = history;
                const patchData = buffer[pointer - 1];
                if (!patchData) return;
                const reversedPatchData = _jsondiffpatch.reverse(patchData);
                if (!reversedPatchData) return;
                const updates = cloneObject({
                    nodes,
                    edges,
                    controlPanel
                });
                const patch = _jsondiffpatch.patch(updates, reversedPatchData);
                set((0, _objectSpreadProps._)((0, _objectSpread._)({}, patch), {
                    history: (0, _objectSpreadProps._)((0, _objectSpread._)({}, history), {
                        pointer: pointer - 1,
                        skipCollect: true
                    })
                }));
            },
            forward: ()=>{
                const { nodes, edges, controlPanel, history } = get();
                const { buffer, pointer } = history;
                const patchData = buffer[pointer];
                if (!patchData) return;
                const updates = cloneObject({
                    nodes,
                    edges,
                    controlPanel
                });
                const patch = _jsondiffpatch.patch(updates, patchData);
                set((0, _objectSpreadProps._)((0, _objectSpread._)({}, patch), {
                    history: (0, _objectSpreadProps._)((0, _objectSpread._)({}, history), {
                        pointer: pointer + 1,
                        skipCollect: true
                    })
                }));
            },
            // @TODO: remove this method and store history per file
            clear: ()=>{
                const { history } = get();
                set({
                    history: (0, _objectSpreadProps._)((0, _objectSpread._)({}, history), {
                        buffer: [],
                        pointer: 0,
                        skipCollect: true
                    })
                });
            }
        }
    });
const COLLECT_CHANGES_DEBOUNCE_TIME = 500;
const createChangesCollector = (set, get)=>{
    const jsondiffpatchInstance = _jsondiffpatch.create({
        propertyFilter: (name, context)=>{
            var _context_parent_parent, _context_parent, _context_parent1;
            //@TODO: rework this function, find better solution
            if (((_context_parent = context.parent) === null || _context_parent === void 0 ? void 0 : (_context_parent_parent = _context_parent.parent) === null || _context_parent_parent === void 0 ? void 0 : _context_parent_parent.childName) === "controlPanel") return true;
            if (// @ts-ignore
            [
                "data",
                "position",
                "controlPanel"
            ].includes((_context_parent1 = context.parent) === null || _context_parent1 === void 0 ? void 0 : _context_parent1.childName)) return true;
            return [
                "controlPanel",
                "size",
                "edges",
                "nodes",
                "data",
                "label",
                "config",
                "values",
                "position",
                "x",
                "y"
            ].includes(name);
        }
    });
    let oldState = get();
    let timer;
    return (state, prevState)=>{
        if (state.currentFileIndex !== prevState.currentFileIndex) get().history.clear();
        clearTimeout(timer);
        if (!oldState) oldState = prevState;
        timer = setTimeout(()=>{
            const changes = jsondiffpatchInstance.diff(oldState, state);
            oldState = null;
            if (changes) get().history.push(changes);
        }, COLLECT_CHANGES_DEBOUNCE_TIME);
    };
};
const history = (config)=>(set, get, api)=>{
        const collectChanges = createChangesCollector(set, get);
        api.subscribe(collectChanges);
        return config((...args)=>set(...args), get, api);
    };
exports.default = history;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","jsondiffpatch":"jwYMX","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jwYMX":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("b49006919fb380e0"));
})(this, function(exports1, chalk) {
    'use strict';
    class Processor {
        options(options) {
            if (options) this.selfOptions = options;
            return this.selfOptions;
        }
        pipe(name, pipeArg) {
            let pipe = pipeArg;
            if (typeof name === 'string') {
                if (typeof pipe === 'undefined') return this.pipes[name];
                else this.pipes[name] = pipe;
            }
            if (name && name.name) {
                pipe = name;
                if (pipe.processor === this) return pipe;
                this.pipes[pipe.name] = pipe;
            }
            pipe.processor = this;
            return pipe;
        }
        process(input, pipe) {
            let context = input;
            context.options = this.options();
            let nextPipe = pipe || input.pipe || 'default';
            let lastPipe;
            let lastContext;
            while(nextPipe){
                if (typeof context.nextAfterChildren !== 'undefined') {
                    // children processed and coming back to parent
                    context.next = context.nextAfterChildren;
                    context.nextAfterChildren = null;
                }
                if (typeof nextPipe === 'string') nextPipe = this.pipe(nextPipe);
                nextPipe.process(context);
                lastContext = context;
                lastPipe = nextPipe;
                nextPipe = null;
                if (context) {
                    if (context.next) {
                        context = context.next;
                        nextPipe = lastContext.nextPipe || context.pipe || lastPipe;
                    }
                }
            }
            return context.hasResult ? context.result : undefined;
        }
        constructor(options){
            this.selfOptions = options || {};
            this.pipes = {};
        }
    }
    class Pipe {
        process(input) {
            if (!this.processor) throw new Error('add this pipe to a processor before using it');
            const debug = this.debug;
            const length = this.filters.length;
            const context = input;
            for(let index = 0; index < length; index++){
                const filter = this.filters[index];
                if (debug) this.log(`filter: ${filter.filterName}`);
                filter(context);
                if (typeof context === 'object' && context.exiting) {
                    context.exiting = false;
                    break;
                }
            }
            if (!context.next && this.resultCheck) this.resultCheck(context);
        }
        log(msg) {
            console.log(`[jsondiffpatch] ${this.name} pipe, ${msg}`);
        }
        append() {
            this.filters.push(...arguments);
            return this;
        }
        prepend() {
            this.filters.unshift(...arguments);
            return this;
        }
        indexOf(filterName) {
            if (!filterName) throw new Error('a filter name is required');
            for(let index = 0; index < this.filters.length; index++){
                const filter = this.filters[index];
                if (filter.filterName === filterName) return index;
            }
            throw new Error(`filter not found: ${filterName}`);
        }
        list() {
            return this.filters.map((f)=>f.filterName);
        }
        after(filterName) {
            const index = this.indexOf(filterName);
            const params = Array.prototype.slice.call(arguments, 1);
            if (!params.length) throw new Error('a filter is required');
            params.unshift(index + 1, 0);
            Array.prototype.splice.apply(this.filters, params);
            return this;
        }
        before(filterName) {
            const index = this.indexOf(filterName);
            const params = Array.prototype.slice.call(arguments, 1);
            if (!params.length) throw new Error('a filter is required');
            params.unshift(index, 0);
            Array.prototype.splice.apply(this.filters, params);
            return this;
        }
        replace(filterName) {
            const index = this.indexOf(filterName);
            const params = Array.prototype.slice.call(arguments, 1);
            if (!params.length) throw new Error('a filter is required');
            params.unshift(index, 1);
            Array.prototype.splice.apply(this.filters, params);
            return this;
        }
        remove(filterName) {
            const index = this.indexOf(filterName);
            this.filters.splice(index, 1);
            return this;
        }
        clear() {
            this.filters.length = 0;
            return this;
        }
        shouldHaveResult(should) {
            if (should === false) {
                this.resultCheck = null;
                return;
            }
            if (this.resultCheck) return;
            const pipe = this;
            this.resultCheck = (context)=>{
                if (!context.hasResult) {
                    console.log(context);
                    const error = new Error(`${pipe.name} failed`);
                    error.noResult = true;
                    throw error;
                }
            };
            return this;
        }
        constructor(name){
            this.name = name;
            this.filters = [];
        }
    }
    class Context {
        setResult(result) {
            this.result = result;
            this.hasResult = true;
            return this;
        }
        exit() {
            this.exiting = true;
            return this;
        }
        switchTo(next, pipe) {
            if (typeof next === 'string' || next instanceof Pipe) this.nextPipe = next;
            else {
                this.next = next;
                if (pipe) this.nextPipe = pipe;
            }
            return this;
        }
        push(child, name) {
            child.parent = this;
            if (typeof name !== 'undefined') child.childName = name;
            child.root = this.root || this;
            child.options = child.options || this.options;
            if (!this.children) {
                this.children = [
                    child
                ];
                this.nextAfterChildren = this.next || null;
                this.next = child;
            } else {
                this.children[this.children.length - 1].next = child;
                this.children.push(child);
            }
            child.next = this;
            return this;
        }
    }
    const isArray$3 = typeof Array.isArray === 'function' ? Array.isArray : (a)=>a instanceof Array;
    function cloneRegExp(re) {
        const regexMatch = /^\/(.*)\/([gimyu]*)$/.exec(re.toString());
        return new RegExp(regexMatch[1], regexMatch[2]);
    }
    function clone$1(arg) {
        if (typeof arg !== 'object') return arg;
        if (arg === null) return null;
        if (isArray$3(arg)) return arg.map(clone$1);
        if (arg instanceof Date) return new Date(arg.getTime());
        if (arg instanceof RegExp) return cloneRegExp(arg);
        const cloned = {};
        for(const name in arg)if (Object.prototype.hasOwnProperty.call(arg, name)) cloned[name] = clone$1(arg[name]);
        return cloned;
    }
    class DiffContext extends Context {
        setResult(result) {
            if (this.options.cloneDiffValues && typeof result === 'object') {
                const clone = typeof this.options.cloneDiffValues === 'function' ? this.options.cloneDiffValues : clone$1;
                if (typeof result[0] === 'object') result[0] = clone(result[0]);
                if (typeof result[1] === 'object') result[1] = clone(result[1]);
            }
            return Context.prototype.setResult.apply(this, arguments);
        }
        constructor(left, right){
            super();
            this.left = left;
            this.right = right;
            this.pipe = 'diff';
        }
    }
    class PatchContext extends Context {
        constructor(left, delta){
            super();
            this.left = left;
            this.delta = delta;
            this.pipe = 'patch';
        }
    }
    class ReverseContext extends Context {
        constructor(delta){
            super();
            this.delta = delta;
            this.pipe = 'reverse';
        }
    }
    const isArray$2 = typeof Array.isArray === 'function' ? Array.isArray : function(a) {
        return a instanceof Array;
    };
    const diffFilter$3 = function trivialMatchesDiffFilter(context) {
        if (context.left === context.right) {
            context.setResult(undefined).exit();
            return;
        }
        if (typeof context.left === 'undefined') {
            if (typeof context.right === 'function') throw new Error('functions are not supported');
            context.setResult([
                context.right
            ]).exit();
            return;
        }
        if (typeof context.right === 'undefined') {
            context.setResult([
                context.left,
                0,
                0
            ]).exit();
            return;
        }
        if (typeof context.left === 'function' || typeof context.right === 'function') throw new Error('functions are not supported');
        context.leftType = context.left === null ? 'null' : typeof context.left;
        context.rightType = context.right === null ? 'null' : typeof context.right;
        if (context.leftType !== context.rightType) {
            context.setResult([
                context.left,
                context.right
            ]).exit();
            return;
        }
        if (context.leftType === 'boolean' || context.leftType === 'number') {
            context.setResult([
                context.left,
                context.right
            ]).exit();
            return;
        }
        if (context.leftType === 'object') context.leftIsArray = isArray$2(context.left);
        if (context.rightType === 'object') context.rightIsArray = isArray$2(context.right);
        if (context.leftIsArray !== context.rightIsArray) {
            context.setResult([
                context.left,
                context.right
            ]).exit();
            return;
        }
        if (context.left instanceof RegExp) {
            if (context.right instanceof RegExp) context.setResult([
                context.left.toString(),
                context.right.toString()
            ]).exit();
            else context.setResult([
                context.left,
                context.right
            ]).exit();
        }
    };
    diffFilter$3.filterName = 'trivial';
    const patchFilter$3 = function trivialMatchesPatchFilter(context) {
        if (typeof context.delta === 'undefined') {
            context.setResult(context.left).exit();
            return;
        }
        context.nested = !isArray$2(context.delta);
        if (context.nested) return;
        if (context.delta.length === 1) {
            context.setResult(context.delta[0]).exit();
            return;
        }
        if (context.delta.length === 2) {
            if (context.left instanceof RegExp) {
                const regexArgs = /^\/(.*)\/([gimyu]+)$/.exec(context.delta[1]);
                if (regexArgs) {
                    context.setResult(new RegExp(regexArgs[1], regexArgs[2])).exit();
                    return;
                }
            }
            context.setResult(context.delta[1]).exit();
            return;
        }
        if (context.delta.length === 3 && context.delta[2] === 0) context.setResult(undefined).exit();
    };
    patchFilter$3.filterName = 'trivial';
    const reverseFilter$3 = function trivialReferseFilter(context) {
        if (typeof context.delta === 'undefined') {
            context.setResult(context.delta).exit();
            return;
        }
        context.nested = !isArray$2(context.delta);
        if (context.nested) return;
        if (context.delta.length === 1) {
            context.setResult([
                context.delta[0],
                0,
                0
            ]).exit();
            return;
        }
        if (context.delta.length === 2) {
            context.setResult([
                context.delta[1],
                context.delta[0]
            ]).exit();
            return;
        }
        if (context.delta.length === 3 && context.delta[2] === 0) context.setResult([
            context.delta[0]
        ]).exit();
    };
    reverseFilter$3.filterName = 'trivial';
    function collectChildrenDiffFilter(context) {
        if (!context || !context.children) return;
        const length = context.children.length;
        let child;
        let result = context.result;
        for(let index = 0; index < length; index++){
            child = context.children[index];
            if (typeof child.result === 'undefined') continue;
            result = result || {};
            result[child.childName] = child.result;
        }
        if (result && context.leftIsArray) result._t = 'a';
        context.setResult(result).exit();
    }
    collectChildrenDiffFilter.filterName = 'collectChildren';
    function objectsDiffFilter(context) {
        if (context.leftIsArray || context.leftType !== 'object') return;
        let name;
        let child;
        const propertyFilter = context.options.propertyFilter;
        for(name in context.left){
            if (!Object.prototype.hasOwnProperty.call(context.left, name)) continue;
            if (propertyFilter && !propertyFilter(name, context)) continue;
            child = new DiffContext(context.left[name], context.right[name]);
            context.push(child, name);
        }
        for(name in context.right){
            if (!Object.prototype.hasOwnProperty.call(context.right, name)) continue;
            if (propertyFilter && !propertyFilter(name, context)) continue;
            if (typeof context.left[name] === 'undefined') {
                child = new DiffContext(undefined, context.right[name]);
                context.push(child, name);
            }
        }
        if (!context.children || context.children.length === 0) {
            context.setResult(undefined).exit();
            return;
        }
        context.exit();
    }
    objectsDiffFilter.filterName = 'objects';
    const patchFilter$2 = function nestedPatchFilter(context) {
        if (!context.nested) return;
        if (context.delta._t) return;
        let name;
        let child;
        for(name in context.delta){
            child = new PatchContext(context.left[name], context.delta[name]);
            context.push(child, name);
        }
        context.exit();
    };
    patchFilter$2.filterName = 'objects';
    const collectChildrenPatchFilter$1 = function collectChildrenPatchFilter(context) {
        if (!context || !context.children) return;
        if (context.delta._t) return;
        const length = context.children.length;
        let child;
        for(let index = 0; index < length; index++){
            child = context.children[index];
            if (Object.prototype.hasOwnProperty.call(context.left, child.childName) && child.result === undefined) delete context.left[child.childName];
            else if (context.left[child.childName] !== child.result) context.left[child.childName] = child.result;
        }
        context.setResult(context.left).exit();
    };
    collectChildrenPatchFilter$1.filterName = 'collectChildren';
    const reverseFilter$2 = function nestedReverseFilter(context) {
        if (!context.nested) return;
        if (context.delta._t) return;
        let name;
        let child;
        for(name in context.delta){
            child = new ReverseContext(context.delta[name]);
            context.push(child, name);
        }
        context.exit();
    };
    reverseFilter$2.filterName = 'objects';
    function collectChildrenReverseFilter$1(context) {
        if (!context || !context.children) return;
        if (context.delta._t) return;
        const length = context.children.length;
        let child;
        const delta = {};
        for(let index = 0; index < length; index++){
            child = context.children[index];
            if (delta[child.childName] !== child.result) delta[child.childName] = child.result;
        }
        context.setResult(delta).exit();
    }
    collectChildrenReverseFilter$1.filterName = 'collectChildren';
    /*

  LCS implementation that supports arrays or strings

  reference: http://en.wikipedia.org/wiki/Longest_common_subsequence_problem

  */ const defaultMatch = function(array1, array2, index1, index2) {
        return array1[index1] === array2[index2];
    };
    const lengthMatrix = function(array1, array2, match, context) {
        const len1 = array1.length;
        const len2 = array2.length;
        let x, y;
        // initialize empty matrix of len1+1 x len2+1
        const matrix = [
            len1 + 1
        ];
        for(x = 0; x < len1 + 1; x++){
            matrix[x] = [
                len2 + 1
            ];
            for(y = 0; y < len2 + 1; y++)matrix[x][y] = 0;
        }
        matrix.match = match;
        // save sequence lengths for each coordinate
        for(x = 1; x < len1 + 1; x++){
            for(y = 1; y < len2 + 1; y++)if (match(array1, array2, x - 1, y - 1, context)) matrix[x][y] = matrix[x - 1][y - 1] + 1;
            else matrix[x][y] = Math.max(matrix[x - 1][y], matrix[x][y - 1]);
        }
        return matrix;
    };
    const backtrack = function(matrix, array1, array2, context) {
        let index1 = array1.length;
        let index2 = array2.length;
        const subsequence = {
            sequence: [],
            indices1: [],
            indices2: []
        };
        while(index1 !== 0 && index2 !== 0){
            const sameLetter = matrix.match(array1, array2, index1 - 1, index2 - 1, context);
            if (sameLetter) {
                subsequence.sequence.unshift(array1[index1 - 1]);
                subsequence.indices1.unshift(index1 - 1);
                subsequence.indices2.unshift(index2 - 1);
                --index1;
                --index2;
            } else {
                const valueAtMatrixAbove = matrix[index1][index2 - 1];
                const valueAtMatrixLeft = matrix[index1 - 1][index2];
                if (valueAtMatrixAbove > valueAtMatrixLeft) --index2;
                else --index1;
            }
        }
        return subsequence;
    };
    const get = function(array1, array2, match, context) {
        const innerContext = context || {};
        const matrix = lengthMatrix(array1, array2, match || defaultMatch, innerContext);
        const result = backtrack(matrix, array1, array2, innerContext);
        if (typeof array1 === 'string' && typeof array2 === 'string') result.sequence = result.sequence.join('');
        return result;
    };
    var lcs = {
        get
    };
    const ARRAY_MOVE = 3;
    const isArray$1 = typeof Array.isArray === 'function' ? Array.isArray : (a)=>a instanceof Array;
    const arrayIndexOf = typeof Array.prototype.indexOf === 'function' ? (array, item)=>array.indexOf(item) : (array, item)=>{
        const length = array.length;
        for(let i = 0; i < length; i++){
            if (array[i] === item) return i;
        }
        return -1;
    };
    function arraysHaveMatchByRef(array1, array2, len1, len2) {
        for(let index1 = 0; index1 < len1; index1++){
            const val1 = array1[index1];
            for(let index2 = 0; index2 < len2; index2++){
                const val2 = array2[index2];
                if (index1 !== index2 && val1 === val2) return true;
            }
        }
    }
    function matchItems(array1, array2, index1, index2, context) {
        const value1 = array1[index1];
        const value2 = array2[index2];
        if (value1 === value2) return true;
        if (typeof value1 !== 'object' || typeof value2 !== 'object') return false;
        const objectHash = context.objectHash;
        if (!objectHash) // no way to match objects was provided, try match by position
        return context.matchByPosition && index1 === index2;
        let hash1;
        let hash2;
        if (typeof index1 === 'number') {
            context.hashCache1 = context.hashCache1 || [];
            hash1 = context.hashCache1[index1];
            if (typeof hash1 === 'undefined') context.hashCache1[index1] = hash1 = objectHash(value1, index1);
        } else hash1 = objectHash(value1);
        if (typeof hash1 === 'undefined') return false;
        if (typeof index2 === 'number') {
            context.hashCache2 = context.hashCache2 || [];
            hash2 = context.hashCache2[index2];
            if (typeof hash2 === 'undefined') context.hashCache2[index2] = hash2 = objectHash(value2, index2);
        } else hash2 = objectHash(value2);
        if (typeof hash2 === 'undefined') return false;
        return hash1 === hash2;
    }
    const diffFilter$2 = function arraysDiffFilter(context) {
        if (!context.leftIsArray) return;
        const matchContext = {
            objectHash: context.options && context.options.objectHash,
            matchByPosition: context.options && context.options.matchByPosition
        };
        let commonHead = 0;
        let commonTail = 0;
        let index;
        let index1;
        let index2;
        const array1 = context.left;
        const array2 = context.right;
        const len1 = array1.length;
        const len2 = array2.length;
        let child;
        if (len1 > 0 && len2 > 0 && !matchContext.objectHash && typeof matchContext.matchByPosition !== 'boolean') matchContext.matchByPosition = !arraysHaveMatchByRef(array1, array2, len1, len2);
        // separate common head
        while(commonHead < len1 && commonHead < len2 && matchItems(array1, array2, commonHead, commonHead, matchContext)){
            index = commonHead;
            child = new DiffContext(context.left[index], context.right[index]);
            context.push(child, index);
            commonHead++;
        }
        // separate common tail
        while(commonTail + commonHead < len1 && commonTail + commonHead < len2 && matchItems(array1, array2, len1 - 1 - commonTail, len2 - 1 - commonTail, matchContext)){
            index1 = len1 - 1 - commonTail;
            index2 = len2 - 1 - commonTail;
            child = new DiffContext(context.left[index1], context.right[index2]);
            context.push(child, index2);
            commonTail++;
        }
        let result;
        if (commonHead + commonTail === len1) {
            if (len1 === len2) {
                // arrays are identical
                context.setResult(undefined).exit();
                return;
            }
            // trivial case, a block (1 or more consecutive items) was added
            result = result || {
                _t: 'a'
            };
            for(index = commonHead; index < len2 - commonTail; index++)result[index] = [
                array2[index]
            ];
            context.setResult(result).exit();
            return;
        }
        if (commonHead + commonTail === len2) {
            // trivial case, a block (1 or more consecutive items) was removed
            result = result || {
                _t: 'a'
            };
            for(index = commonHead; index < len1 - commonTail; index++)result[`_${index}`] = [
                array1[index],
                0,
                0
            ];
            context.setResult(result).exit();
            return;
        }
        // reset hash cache
        delete matchContext.hashCache1;
        delete matchContext.hashCache2;
        // diff is not trivial, find the LCS (Longest Common Subsequence)
        const trimmed1 = array1.slice(commonHead, len1 - commonTail);
        const trimmed2 = array2.slice(commonHead, len2 - commonTail);
        const seq = lcs.get(trimmed1, trimmed2, matchItems, matchContext);
        const removedItems = [];
        result = result || {
            _t: 'a'
        };
        for(index = commonHead; index < len1 - commonTail; index++)if (arrayIndexOf(seq.indices1, index - commonHead) < 0) {
            // removed
            result[`_${index}`] = [
                array1[index],
                0,
                0
            ];
            removedItems.push(index);
        }
        let detectMove = true;
        if (context.options && context.options.arrays && context.options.arrays.detectMove === false) detectMove = false;
        let includeValueOnMove = false;
        if (context.options && context.options.arrays && context.options.arrays.includeValueOnMove) includeValueOnMove = true;
        const removedItemsLength = removedItems.length;
        for(index = commonHead; index < len2 - commonTail; index++){
            const indexOnArray2 = arrayIndexOf(seq.indices2, index - commonHead);
            if (indexOnArray2 < 0) {
                // added, try to match with a removed item and register as position move
                let isMove = false;
                if (detectMove && removedItemsLength > 0) for(let removeItemIndex1 = 0; removeItemIndex1 < removedItemsLength; removeItemIndex1++){
                    index1 = removedItems[removeItemIndex1];
                    if (matchItems(trimmed1, trimmed2, index1 - commonHead, index - commonHead, matchContext)) {
                        // store position move as: [originalValue, newPosition, ARRAY_MOVE]
                        result[`_${index1}`].splice(1, 2, index, ARRAY_MOVE);
                        if (!includeValueOnMove) // don't include moved value on diff, to save bytes
                        result[`_${index1}`][0] = '';
                        index2 = index;
                        child = new DiffContext(context.left[index1], context.right[index2]);
                        context.push(child, index2);
                        removedItems.splice(removeItemIndex1, 1);
                        isMove = true;
                        break;
                    }
                }
                if (!isMove) // added
                result[index] = [
                    array2[index]
                ];
            } else {
                // match, do inner diff
                index1 = seq.indices1[indexOnArray2] + commonHead;
                index2 = seq.indices2[indexOnArray2] + commonHead;
                child = new DiffContext(context.left[index1], context.right[index2]);
                context.push(child, index2);
            }
        }
        context.setResult(result).exit();
    };
    diffFilter$2.filterName = 'arrays';
    const compare = {
        numerically (a, b) {
            return a - b;
        },
        numericallyBy (name) {
            return (a, b)=>a[name] - b[name];
        }
    };
    const patchFilter$1 = function nestedPatchFilter(context) {
        if (!context.nested) return;
        if (context.delta._t !== 'a') return;
        let index;
        let index1;
        const delta = context.delta;
        const array = context.left;
        // first, separate removals, insertions and modifications
        let toRemove = [];
        let toInsert = [];
        const toModify = [];
        for(index in delta)if (index !== '_t') {
            if (index[0] === '_') {
                // removed item from original array
                if (delta[index][2] === 0 || delta[index][2] === ARRAY_MOVE) toRemove.push(parseInt(index.slice(1), 10));
                else throw new Error('only removal or move can be applied at original array indices,' + ` invalid diff type: ${delta[index][2]}`);
            } else if (delta[index].length === 1) // added item at new array
            toInsert.push({
                index: parseInt(index, 10),
                value: delta[index][0]
            });
            else // modified item at new array
            toModify.push({
                index: parseInt(index, 10),
                delta: delta[index]
            });
        }
        // remove items, in reverse order to avoid sawing our own floor
        toRemove = toRemove.sort(compare.numerically);
        for(index = toRemove.length - 1; index >= 0; index--){
            index1 = toRemove[index];
            const indexDiff = delta[`_${index1}`];
            const removedValue = array.splice(index1, 1)[0];
            if (indexDiff[2] === ARRAY_MOVE) // reinsert later
            toInsert.push({
                index: indexDiff[1],
                value: removedValue
            });
        }
        // insert items, in reverse order to avoid moving our own floor
        toInsert = toInsert.sort(compare.numericallyBy('index'));
        const toInsertLength = toInsert.length;
        for(index = 0; index < toInsertLength; index++){
            const insertion = toInsert[index];
            array.splice(insertion.index, 0, insertion.value);
        }
        // apply modifications
        const toModifyLength = toModify.length;
        let child;
        if (toModifyLength > 0) for(index = 0; index < toModifyLength; index++){
            const modification = toModify[index];
            child = new PatchContext(context.left[modification.index], modification.delta);
            context.push(child, modification.index);
        }
        if (!context.children) {
            context.setResult(context.left).exit();
            return;
        }
        context.exit();
    };
    patchFilter$1.filterName = 'arrays';
    const collectChildrenPatchFilter = function collectChildrenPatchFilter(context) {
        if (!context || !context.children) return;
        if (context.delta._t !== 'a') return;
        const length = context.children.length;
        let child;
        for(let index = 0; index < length; index++){
            child = context.children[index];
            context.left[child.childName] = child.result;
        }
        context.setResult(context.left).exit();
    };
    collectChildrenPatchFilter.filterName = 'arraysCollectChildren';
    const reverseFilter$1 = function arraysReverseFilter(context) {
        if (!context.nested) {
            if (context.delta[2] === ARRAY_MOVE) {
                context.newName = `_${context.delta[1]}`;
                context.setResult([
                    context.delta[0],
                    parseInt(context.childName.substr(1), 10),
                    ARRAY_MOVE
                ]).exit();
            }
            return;
        }
        if (context.delta._t !== 'a') return;
        let name;
        let child;
        for(name in context.delta){
            if (name === '_t') continue;
            child = new ReverseContext(context.delta[name]);
            context.push(child, name);
        }
        context.exit();
    };
    reverseFilter$1.filterName = 'arrays';
    const reverseArrayDeltaIndex = (delta, index, itemDelta)=>{
        if (typeof index === 'string' && index[0] === '_') return parseInt(index.substr(1), 10);
        else if (isArray$1(itemDelta) && itemDelta[2] === 0) return `_${index}`;
        let reverseIndex = +index;
        for(const deltaIndex in delta){
            const deltaItem = delta[deltaIndex];
            if (isArray$1(deltaItem)) {
                if (deltaItem[2] === ARRAY_MOVE) {
                    const moveFromIndex = parseInt(deltaIndex.substr(1), 10);
                    const moveToIndex = deltaItem[1];
                    if (moveToIndex === +index) return moveFromIndex;
                    if (moveFromIndex <= reverseIndex && moveToIndex > reverseIndex) reverseIndex++;
                    else if (moveFromIndex >= reverseIndex && moveToIndex < reverseIndex) reverseIndex--;
                } else if (deltaItem[2] === 0) {
                    const deleteIndex = parseInt(deltaIndex.substr(1), 10);
                    if (deleteIndex <= reverseIndex) reverseIndex++;
                } else if (deltaItem.length === 1 && deltaIndex <= reverseIndex) reverseIndex--;
            }
        }
        return reverseIndex;
    };
    function collectChildrenReverseFilter(context) {
        if (!context || !context.children) return;
        if (context.delta._t !== 'a') return;
        const length = context.children.length;
        let child;
        const delta = {
            _t: 'a'
        };
        for(let index = 0; index < length; index++){
            child = context.children[index];
            let name = child.newName;
            if (typeof name === 'undefined') name = reverseArrayDeltaIndex(context.delta, child.childName, child.result);
            if (delta[name] !== child.result) delta[name] = child.result;
        }
        context.setResult(delta).exit();
    }
    collectChildrenReverseFilter.filterName = 'arraysCollectChildren';
    const diffFilter$1 = function datesDiffFilter(context) {
        if (context.left instanceof Date) {
            if (context.right instanceof Date) {
                if (context.left.getTime() !== context.right.getTime()) context.setResult([
                    context.left,
                    context.right
                ]);
                else context.setResult(undefined);
            } else context.setResult([
                context.left,
                context.right
            ]);
            context.exit();
        } else if (context.right instanceof Date) context.setResult([
            context.left,
            context.right
        ]).exit();
    };
    diffFilter$1.filterName = 'dates';
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var diffMatchPatch = {
        exports: {}
    };
    /**
   * Diff Match and Patch
   * Copyright 2018 The diff-match-patch Authors.
   * https://github.com/google/diff-match-patch
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *   http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */ (function(module) {
        /**
  	 * @fileoverview Computes the difference between two texts to create a patch.
  	 * Applies the patch onto another text, allowing for errors.
  	 * @author fraser@google.com (Neil Fraser)
  	 */ /**
  	 * Class containing the diff, match and patch methods.
  	 * @constructor
  	 */ var diff_match_patch1 = function() {
            // Defaults.
            // Redefine these in your program to override the defaults.
            // Number of seconds to map a diff before giving up (0 for infinity).
            this.Diff_Timeout = 1.0;
            // Cost of an empty edit operation in terms of edit characters.
            this.Diff_EditCost = 4;
            // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
            this.Match_Threshold = 0.5;
            // How far to search for a match (0 = exact location, 1000+ = broad match).
            // A match this many characters away from the expected location will add
            // 1.0 to the score (0.0 is a perfect match).
            this.Match_Distance = 1000;
            // When deleting a large block of text (over ~64 characters), how close do
            // the contents have to be to match the expected contents. (0.0 = perfection,
            // 1.0 = very loose).  Note that Match_Threshold controls how closely the
            // end points of a delete need to match.
            this.Patch_DeleteThreshold = 0.5;
            // Chunk size for context length.
            this.Patch_Margin = 4;
            // The number of bits in an int.
            this.Match_MaxBits = 32;
        };
        //  DIFF FUNCTIONS
        /**
  	 * The data structure representing a diff is an array of tuples:
  	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
  	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
  	 */ var DIFF_DELETE = -1;
        var DIFF_INSERT = 1;
        var DIFF_EQUAL = 0;
        /**
  	 * Class representing one diff tuple.
  	 * ~Attempts to look like a two-element array (which is what this used to be).~
  	 * Constructor returns an actual two-element array, to allow destructing @JackuB
  	 * See https://github.com/JackuB/diff-match-patch/issues/14 for details
  	 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
  	 * @param {string} text Text to be deleted, inserted, or retained.
  	 * @constructor
  	 */ diff_match_patch1.Diff = function(op, text) {
            return [
                op,
                text
            ];
        };
        /**
  	 * Find the differences between two texts.  Simplifies the problem by stripping
  	 * any common prefix or suffix off the texts before diffing.
  	 * @param {string} text1 Old string to be diffed.
  	 * @param {string} text2 New string to be diffed.
  	 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
  	 *     then don't run a line-level diff first to identify the changed areas.
  	 *     Defaults to true, which does a faster, slightly less optimal diff.
  	 * @param {number=} opt_deadline Optional time when the diff should be complete
  	 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
  	 *     instead.
  	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
  	 */ diff_match_patch1.prototype.diff_main = function(text1, text2, opt_checklines, opt_deadline) {
            // Set a deadline by which time the diff must be complete.
            if (typeof opt_deadline == 'undefined') {
                if (this.Diff_Timeout <= 0) opt_deadline = Number.MAX_VALUE;
                else opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
            }
            var deadline = opt_deadline;
            // Check for null inputs.
            if (text1 == null || text2 == null) throw new Error('Null input. (diff_main)');
            // Check for equality (speedup).
            if (text1 == text2) {
                if (text1) return [
                    new diff_match_patch1.Diff(DIFF_EQUAL, text1)
                ];
                return [];
            }
            if (typeof opt_checklines == 'undefined') opt_checklines = true;
            var checklines = opt_checklines;
            // Trim off common prefix (speedup).
            var commonlength = this.diff_commonPrefix(text1, text2);
            var commonprefix = text1.substring(0, commonlength);
            text1 = text1.substring(commonlength);
            text2 = text2.substring(commonlength);
            // Trim off common suffix (speedup).
            commonlength = this.diff_commonSuffix(text1, text2);
            var commonsuffix = text1.substring(text1.length - commonlength);
            text1 = text1.substring(0, text1.length - commonlength);
            text2 = text2.substring(0, text2.length - commonlength);
            // Compute the diff on the middle block.
            var diffs = this.diff_compute_(text1, text2, checklines, deadline);
            // Restore the prefix and suffix.
            if (commonprefix) diffs.unshift(new diff_match_patch1.Diff(DIFF_EQUAL, commonprefix));
            if (commonsuffix) diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, commonsuffix));
            this.diff_cleanupMerge(diffs);
            return diffs;
        };
        /**
  	 * Find the differences between two texts.  Assumes that the texts do not
  	 * have any common prefix or suffix.
  	 * @param {string} text1 Old string to be diffed.
  	 * @param {string} text2 New string to be diffed.
  	 * @param {boolean} checklines Speedup flag.  If false, then don't run a
  	 *     line-level diff first to identify the changed areas.
  	 *     If true, then run a faster, slightly less optimal diff.
  	 * @param {number} deadline Time when the diff should be complete by.
  	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_compute_ = function(text1, text2, checklines, deadline) {
            var diffs;
            if (!text1) // Just add some text (speedup).
            return [
                new diff_match_patch1.Diff(DIFF_INSERT, text2)
            ];
            if (!text2) // Just delete some text (speedup).
            return [
                new diff_match_patch1.Diff(DIFF_DELETE, text1)
            ];
            var longtext = text1.length > text2.length ? text1 : text2;
            var shorttext = text1.length > text2.length ? text2 : text1;
            var i = longtext.indexOf(shorttext);
            if (i != -1) {
                // Shorter text is inside the longer text (speedup).
                diffs = [
                    new diff_match_patch1.Diff(DIFF_INSERT, longtext.substring(0, i)),
                    new diff_match_patch1.Diff(DIFF_EQUAL, shorttext),
                    new diff_match_patch1.Diff(DIFF_INSERT, longtext.substring(i + shorttext.length))
                ];
                // Swap insertions for deletions if diff is reversed.
                if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = DIFF_DELETE;
                return diffs;
            }
            if (shorttext.length == 1) // Single character string.
            // After the previous speedup, the character can't be an equality.
            return [
                new diff_match_patch1.Diff(DIFF_DELETE, text1),
                new diff_match_patch1.Diff(DIFF_INSERT, text2)
            ];
            // Check to see if the problem can be split in two.
            var hm = this.diff_halfMatch_(text1, text2);
            if (hm) {
                // A half-match was found, sort out the return data.
                var text1_a = hm[0];
                var text1_b = hm[1];
                var text2_a = hm[2];
                var text2_b = hm[3];
                var mid_common = hm[4];
                // Send both pairs off for separate processing.
                var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
                var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
                // Merge the results.
                return diffs_a.concat([
                    new diff_match_patch1.Diff(DIFF_EQUAL, mid_common)
                ], diffs_b);
            }
            if (checklines && text1.length > 100 && text2.length > 100) return this.diff_lineMode_(text1, text2, deadline);
            return this.diff_bisect_(text1, text2, deadline);
        };
        /**
  	 * Do a quick line-level diff on both strings, then rediff the parts for
  	 * greater accuracy.
  	 * This speedup can produce non-minimal diffs.
  	 * @param {string} text1 Old string to be diffed.
  	 * @param {string} text2 New string to be diffed.
  	 * @param {number} deadline Time when the diff should be complete by.
  	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_lineMode_ = function(text1, text2, deadline) {
            // Scan the text on a line-by-line basis first.
            var a = this.diff_linesToChars_(text1, text2);
            text1 = a.chars1;
            text2 = a.chars2;
            var linearray = a.lineArray;
            var diffs = this.diff_main(text1, text2, false, deadline);
            // Convert the diff back to original text.
            this.diff_charsToLines_(diffs, linearray);
            // Eliminate freak matches (e.g. blank lines)
            this.diff_cleanupSemantic(diffs);
            // Rediff any replacement blocks, this time character-by-character.
            // Add a dummy entry at the end.
            diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, ''));
            var pointer = 0;
            var count_delete = 0;
            var count_insert = 0;
            var text_delete = '';
            var text_insert = '';
            while(pointer < diffs.length){
                switch(diffs[pointer][0]){
                    case DIFF_INSERT:
                        count_insert++;
                        text_insert += diffs[pointer][1];
                        break;
                    case DIFF_DELETE:
                        count_delete++;
                        text_delete += diffs[pointer][1];
                        break;
                    case DIFF_EQUAL:
                        // Upon reaching an equality, check for prior redundancies.
                        if (count_delete >= 1 && count_insert >= 1) {
                            // Delete the offending records and add the merged ones.
                            diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
                            pointer = pointer - count_delete - count_insert;
                            var subDiff = this.diff_main(text_delete, text_insert, false, deadline);
                            for(var j = subDiff.length - 1; j >= 0; j--)diffs.splice(pointer, 0, subDiff[j]);
                            pointer = pointer + subDiff.length;
                        }
                        count_insert = 0;
                        count_delete = 0;
                        text_delete = '';
                        text_insert = '';
                        break;
                }
                pointer++;
            }
            diffs.pop(); // Remove the dummy entry at the end.
            return diffs;
        };
        /**
  	 * Find the 'middle snake' of a diff, split the problem in two
  	 * and return the recursively constructed diff.
  	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
  	 * @param {string} text1 Old string to be diffed.
  	 * @param {string} text2 New string to be diffed.
  	 * @param {number} deadline Time at which to bail if not yet complete.
  	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_bisect_ = function(text1, text2, deadline) {
            // Cache the text lengths to prevent multiple calls.
            var text1_length = text1.length;
            var text2_length = text2.length;
            var max_d = Math.ceil((text1_length + text2_length) / 2);
            var v_offset = max_d;
            var v_length = 2 * max_d;
            var v1 = new Array(v_length);
            var v2 = new Array(v_length);
            // Setting all elements to -1 is faster in Chrome & Firefox than mixing
            // integers and undefined.
            for(var x = 0; x < v_length; x++){
                v1[x] = -1;
                v2[x] = -1;
            }
            v1[v_offset + 1] = 0;
            v2[v_offset + 1] = 0;
            var delta = text1_length - text2_length;
            // If the total number of characters is odd, then the front path will collide
            // with the reverse path.
            var front = delta % 2 != 0;
            // Offsets for start and end of k loop.
            // Prevents mapping of space beyond the grid.
            var k1start = 0;
            var k1end = 0;
            var k2start = 0;
            var k2end = 0;
            for(var d = 0; d < max_d; d++){
                // Bail out if deadline is reached.
                if (new Date().getTime() > deadline) break;
                // Walk the front path one step.
                for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                    var k1_offset = v_offset + k1;
                    var x1;
                    if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                    else x1 = v1[k1_offset - 1] + 1;
                    var y1 = x1 - k1;
                    while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                        x1++;
                        y1++;
                    }
                    v1[k1_offset] = x1;
                    if (x1 > text1_length) // Ran off the right of the graph.
                    k1end += 2;
                    else if (y1 > text2_length) // Ran off the bottom of the graph.
                    k1start += 2;
                    else if (front) {
                        var k2_offset = v_offset + delta - k1;
                        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                            // Mirror x2 onto top-left coordinate system.
                            var x2 = text1_length - v2[k2_offset];
                            if (x1 >= x2) // Overlap detected.
                            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                        }
                    }
                }
                // Walk the reverse path one step.
                for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                    var k2_offset = v_offset + k2;
                    var x2;
                    if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                    else x2 = v2[k2_offset - 1] + 1;
                    var y2 = x2 - k2;
                    while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                        x2++;
                        y2++;
                    }
                    v2[k2_offset] = x2;
                    if (x2 > text1_length) // Ran off the left of the graph.
                    k2end += 2;
                    else if (y2 > text2_length) // Ran off the top of the graph.
                    k2start += 2;
                    else if (!front) {
                        var k1_offset = v_offset + delta - k2;
                        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                            var x1 = v1[k1_offset];
                            var y1 = v_offset + x1 - k1_offset;
                            // Mirror x2 onto top-left coordinate system.
                            x2 = text1_length - x2;
                            if (x1 >= x2) // Overlap detected.
                            return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                        }
                    }
                }
            }
            // Diff took too long and hit the deadline or
            // number of diffs equals number of characters, no commonality at all.
            return [
                new diff_match_patch1.Diff(DIFF_DELETE, text1),
                new diff_match_patch1.Diff(DIFF_INSERT, text2)
            ];
        };
        /**
  	 * Given the location of the 'middle snake', split the diff in two parts
  	 * and recurse.
  	 * @param {string} text1 Old string to be diffed.
  	 * @param {string} text2 New string to be diffed.
  	 * @param {number} x Index of split point in text1.
  	 * @param {number} y Index of split point in text2.
  	 * @param {number} deadline Time at which to bail if not yet complete.
  	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_bisectSplit_ = function(text1, text2, x, y, deadline) {
            var text1a = text1.substring(0, x);
            var text2a = text2.substring(0, y);
            var text1b = text1.substring(x);
            var text2b = text2.substring(y);
            // Compute both diffs serially.
            var diffs = this.diff_main(text1a, text2a, false, deadline);
            var diffsb = this.diff_main(text1b, text2b, false, deadline);
            return diffs.concat(diffsb);
        };
        /**
  	 * Split two texts into an array of strings.  Reduce the texts to a string of
  	 * hashes where each Unicode character represents one line.
  	 * @param {string} text1 First string.
  	 * @param {string} text2 Second string.
  	 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
  	 *     An object containing the encoded text1, the encoded text2 and
  	 *     the array of unique strings.
  	 *     The zeroth element of the array of unique strings is intentionally blank.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_linesToChars_ = function(text1, text2) {
            var lineArray = []; // e.g. lineArray[4] == 'Hello\n'
            var lineHash = {}; // e.g. lineHash['Hello\n'] == 4
            // '\x00' is a valid character, but various debuggers don't like it.
            // So we'll insert a junk entry to avoid generating a null character.
            lineArray[0] = '';
            /**
  	   * Split a text into an array of strings.  Reduce the texts to a string of
  	   * hashes where each Unicode character represents one line.
  	   * Modifies linearray and linehash through being a closure.
  	   * @param {string} text String to encode.
  	   * @return {string} Encoded string.
  	   * @private
  	   */ function diff_linesToCharsMunge_(text) {
                var chars = '';
                // Walk the text, pulling out a substring for each line.
                // text.split('\n') would would temporarily double our memory footprint.
                // Modifying text would create many large strings to garbage collect.
                var lineStart = 0;
                var lineEnd = -1;
                // Keeping our own length variable is faster than looking it up.
                var lineArrayLength = lineArray.length;
                while(lineEnd < text.length - 1){
                    lineEnd = text.indexOf('\n', lineStart);
                    if (lineEnd == -1) lineEnd = text.length - 1;
                    var line = text.substring(lineStart, lineEnd + 1);
                    if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
                    else {
                        if (lineArrayLength == maxLines) {
                            // Bail out at 65535 because
                            // String.fromCharCode(65536) == String.fromCharCode(0)
                            line = text.substring(lineStart);
                            lineEnd = text.length;
                        }
                        chars += String.fromCharCode(lineArrayLength);
                        lineHash[line] = lineArrayLength;
                        lineArray[lineArrayLength++] = line;
                    }
                    lineStart = lineEnd + 1;
                }
                return chars;
            }
            // Allocate 2/3rds of the space for text1, the rest for text2.
            var maxLines = 40000;
            var chars1 = diff_linesToCharsMunge_(text1);
            maxLines = 65535;
            var chars2 = diff_linesToCharsMunge_(text2);
            return {
                chars1: chars1,
                chars2: chars2,
                lineArray: lineArray
            };
        };
        /**
  	 * Rehydrate the text in a diff from a string of line hashes to real lines of
  	 * text.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @param {!Array.<string>} lineArray Array of unique strings.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_charsToLines_ = function(diffs, lineArray) {
            for(var i = 0; i < diffs.length; i++){
                var chars = diffs[i][1];
                var text = [];
                for(var j = 0; j < chars.length; j++)text[j] = lineArray[chars.charCodeAt(j)];
                diffs[i][1] = text.join('');
            }
        };
        /**
  	 * Determine the common prefix of two strings.
  	 * @param {string} text1 First string.
  	 * @param {string} text2 Second string.
  	 * @return {number} The number of characters common to the start of each
  	 *     string.
  	 */ diff_match_patch1.prototype.diff_commonPrefix = function(text1, text2) {
            // Quick check for common null cases.
            if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
            // Binary search.
            // Performance analysis: https://neil.fraser.name/news/2007/10/09/
            var pointermin = 0;
            var pointermax = Math.min(text1.length, text2.length);
            var pointermid = pointermax;
            var pointerstart = 0;
            while(pointermin < pointermid){
                if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                    pointermin = pointermid;
                    pointerstart = pointermin;
                } else pointermax = pointermid;
                pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
            }
            return pointermid;
        };
        /**
  	 * Determine the common suffix of two strings.
  	 * @param {string} text1 First string.
  	 * @param {string} text2 Second string.
  	 * @return {number} The number of characters common to the end of each string.
  	 */ diff_match_patch1.prototype.diff_commonSuffix = function(text1, text2) {
            // Quick check for common null cases.
            if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
            // Binary search.
            // Performance analysis: https://neil.fraser.name/news/2007/10/09/
            var pointermin = 0;
            var pointermax = Math.min(text1.length, text2.length);
            var pointermid = pointermax;
            var pointerend = 0;
            while(pointermin < pointermid){
                if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                    pointermin = pointermid;
                    pointerend = pointermin;
                } else pointermax = pointermid;
                pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
            }
            return pointermid;
        };
        /**
  	 * Determine if the suffix of one string is the prefix of another.
  	 * @param {string} text1 First string.
  	 * @param {string} text2 Second string.
  	 * @return {number} The number of characters common to the end of the first
  	 *     string and the start of the second string.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_commonOverlap_ = function(text1, text2) {
            // Cache the text lengths to prevent multiple calls.
            var text1_length = text1.length;
            var text2_length = text2.length;
            // Eliminate the null case.
            if (text1_length == 0 || text2_length == 0) return 0;
            // Truncate the longer string.
            if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
            else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
            var text_length = Math.min(text1_length, text2_length);
            // Quick check for the worst case.
            if (text1 == text2) return text_length;
            // Start by looking for a single character match
            // and increase length until no match is found.
            // Performance analysis: https://neil.fraser.name/news/2010/11/04/
            var best = 0;
            var length = 1;
            while(true){
                var pattern = text1.substring(text_length - length);
                var found = text2.indexOf(pattern);
                if (found == -1) return best;
                length += found;
                if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
                    best = length;
                    length++;
                }
            }
        };
        /**
  	 * Do the two texts share a substring which is at least half the length of the
  	 * longer text?
  	 * This speedup can produce non-minimal diffs.
  	 * @param {string} text1 First string.
  	 * @param {string} text2 Second string.
  	 * @return {Array.<string>} Five element Array, containing the prefix of
  	 *     text1, the suffix of text1, the prefix of text2, the suffix of
  	 *     text2 and the common middle.  Or null if there was no match.
  	 * @private
  	 */ diff_match_patch1.prototype.diff_halfMatch_ = function(text1, text2) {
            if (this.Diff_Timeout <= 0) // Don't risk returning a non-optimal diff if we have unlimited time.
            return null;
            var longtext = text1.length > text2.length ? text1 : text2;
            var shorttext = text1.length > text2.length ? text2 : text1;
            if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
            var dmp = this; // 'this' becomes 'window' in a closure.
            /**
  	   * Does a substring of shorttext exist within longtext such that the substring
  	   * is at least half the length of longtext?
  	   * Closure, but does not reference any external variables.
  	   * @param {string} longtext Longer string.
  	   * @param {string} shorttext Shorter string.
  	   * @param {number} i Start index of quarter length substring within longtext.
  	   * @return {Array.<string>} Five element Array, containing the prefix of
  	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
  	   *     of shorttext and the common middle.  Or null if there was no match.
  	   * @private
  	   */ function diff_halfMatchI_(longtext, shorttext, i) {
                // Start with a 1/4 length substring at position i as a seed.
                var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
                var j = -1;
                var best_common = '';
                var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
                while((j = shorttext.indexOf(seed, j + 1)) != -1){
                    var prefixLength = dmp.diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                    var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                    if (best_common.length < suffixLength + prefixLength) {
                        best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                        best_longtext_a = longtext.substring(0, i - suffixLength);
                        best_longtext_b = longtext.substring(i + prefixLength);
                        best_shorttext_a = shorttext.substring(0, j - suffixLength);
                        best_shorttext_b = shorttext.substring(j + prefixLength);
                    }
                }
                if (best_common.length * 2 >= longtext.length) return [
                    best_longtext_a,
                    best_longtext_b,
                    best_shorttext_a,
                    best_shorttext_b,
                    best_common
                ];
                else return null;
            }
            // First check if the second quarter is the seed for a half-match.
            var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
            // Check again based on the third quarter.
            var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
            var hm;
            if (!hm1 && !hm2) return null;
            else if (!hm2) hm = hm1;
            else if (!hm1) hm = hm2;
            else // Both matched.  Select the longest.
            hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
            // A half-match was found, sort out the return data.
            var text1_a, text1_b, text2_a, text2_b;
            if (text1.length > text2.length) {
                text1_a = hm[0];
                text1_b = hm[1];
                text2_a = hm[2];
                text2_b = hm[3];
            } else {
                text2_a = hm[0];
                text2_b = hm[1];
                text1_a = hm[2];
                text1_b = hm[3];
            }
            var mid_common = hm[4];
            return [
                text1_a,
                text1_b,
                text2_a,
                text2_b,
                mid_common
            ];
        };
        /**
  	 * Reduce the number of edits by eliminating semantically trivial equalities.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 */ diff_match_patch1.prototype.diff_cleanupSemantic = function(diffs) {
            var changes = false;
            var equalities = []; // Stack of indices where equalities are found.
            var equalitiesLength = 0; // Keeping our own length var is faster in JS.
            /** @type {?string} */ var lastEquality = null;
            // Always equal to diffs[equalities[equalitiesLength - 1]][1]
            var pointer = 0; // Index of current position.
            // Number of characters that changed prior to the equality.
            var length_insertions1 = 0;
            var length_deletions1 = 0;
            // Number of characters that changed after the equality.
            var length_insertions2 = 0;
            var length_deletions2 = 0;
            while(pointer < diffs.length){
                if (diffs[pointer][0] == DIFF_EQUAL) {
                    equalities[equalitiesLength++] = pointer;
                    length_insertions1 = length_insertions2;
                    length_deletions1 = length_deletions2;
                    length_insertions2 = 0;
                    length_deletions2 = 0;
                    lastEquality = diffs[pointer][1];
                } else {
                    if (diffs[pointer][0] == DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
                    else length_deletions2 += diffs[pointer][1].length;
                    // Eliminate an equality that is smaller or equal to the edits on both
                    // sides of it.
                    if (lastEquality && lastEquality.length <= Math.max(length_insertions1, length_deletions1) && lastEquality.length <= Math.max(length_insertions2, length_deletions2)) {
                        // Duplicate record.
                        diffs.splice(equalities[equalitiesLength - 1], 0, new diff_match_patch1.Diff(DIFF_DELETE, lastEquality));
                        // Change second copy to insert.
                        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
                        // Throw away the equality we just deleted.
                        equalitiesLength--;
                        // Throw away the previous equality (it needs to be reevaluated).
                        equalitiesLength--;
                        pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                        length_insertions1 = 0; // Reset the counters.
                        length_deletions1 = 0;
                        length_insertions2 = 0;
                        length_deletions2 = 0;
                        lastEquality = null;
                        changes = true;
                    }
                }
                pointer++;
            }
            // Normalize the diff.
            if (changes) this.diff_cleanupMerge(diffs);
            this.diff_cleanupSemanticLossless(diffs);
            // Find any overlaps between deletions and insertions.
            // e.g: <del>abcxxx</del><ins>xxxdef</ins>
            //   -> <del>abc</del>xxx<ins>def</ins>
            // e.g: <del>xxxabc</del><ins>defxxx</ins>
            //   -> <ins>def</ins>xxx<del>abc</del>
            // Only extract an overlap if it is as big as the edit ahead or behind it.
            pointer = 1;
            while(pointer < diffs.length){
                if (diffs[pointer - 1][0] == DIFF_DELETE && diffs[pointer][0] == DIFF_INSERT) {
                    var deletion = diffs[pointer - 1][1];
                    var insertion = diffs[pointer][1];
                    var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
                    var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
                    if (overlap_length1 >= overlap_length2) {
                        if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                            // Overlap found.  Insert an equality and trim the surrounding edits.
                            diffs.splice(pointer, 0, new diff_match_patch1.Diff(DIFF_EQUAL, insertion.substring(0, overlap_length1)));
                            diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                            diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                            pointer++;
                        }
                    } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                        // Reverse overlap found.
                        // Insert an equality and swap and trim the surrounding edits.
                        diffs.splice(pointer, 0, new diff_match_patch1.Diff(DIFF_EQUAL, deletion.substring(0, overlap_length2)));
                        diffs[pointer - 1][0] = DIFF_INSERT;
                        diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                        diffs[pointer + 1][0] = DIFF_DELETE;
                        diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                        pointer++;
                    }
                    pointer++;
                }
                pointer++;
            }
        };
        /**
  	 * Look for single edits surrounded on both sides by equalities
  	 * which can be shifted sideways to align the edit to a word boundary.
  	 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 */ diff_match_patch1.prototype.diff_cleanupSemanticLossless = function(diffs) {
            /**
  	   * Given two strings, compute a score representing whether the internal
  	   * boundary falls on logical boundaries.
  	   * Scores range from 6 (best) to 0 (worst).
  	   * Closure, but does not reference any external variables.
  	   * @param {string} one First string.
  	   * @param {string} two Second string.
  	   * @return {number} The score.
  	   * @private
  	   */ function diff_cleanupSemanticScore_(one, two) {
                if (!one || !two) // Edges are the best.
                return 6;
                // Each port of this function behaves slightly differently due to
                // subtle differences in each language's definition of things like
                // 'whitespace'.  Since this function's purpose is largely cosmetic,
                // the choice has been made to use each language's native features
                // rather than force total conformity.
                var char1 = one.charAt(one.length - 1);
                var char2 = two.charAt(0);
                var nonAlphaNumeric1 = char1.match(diff_match_patch1.nonAlphaNumericRegex_);
                var nonAlphaNumeric2 = char2.match(diff_match_patch1.nonAlphaNumericRegex_);
                var whitespace1 = nonAlphaNumeric1 && char1.match(diff_match_patch1.whitespaceRegex_);
                var whitespace2 = nonAlphaNumeric2 && char2.match(diff_match_patch1.whitespaceRegex_);
                var lineBreak1 = whitespace1 && char1.match(diff_match_patch1.linebreakRegex_);
                var lineBreak2 = whitespace2 && char2.match(diff_match_patch1.linebreakRegex_);
                var blankLine1 = lineBreak1 && one.match(diff_match_patch1.blanklineEndRegex_);
                var blankLine2 = lineBreak2 && two.match(diff_match_patch1.blanklineStartRegex_);
                if (blankLine1 || blankLine2) // Five points for blank lines.
                return 5;
                else if (lineBreak1 || lineBreak2) // Four points for line breaks.
                return 4;
                else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
                return 3;
                else if (whitespace1 || whitespace2) // Two points for whitespace.
                return 2;
                else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
                return 1;
                return 0;
            }
            var pointer = 1;
            // Intentionally ignore the first and last element (don't need checking).
            while(pointer < diffs.length - 1){
                if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                    // This is a single edit surrounded by equalities.
                    var equality1 = diffs[pointer - 1][1];
                    var edit = diffs[pointer][1];
                    var equality2 = diffs[pointer + 1][1];
                    // First, shift the edit as far left as possible.
                    var commonOffset = this.diff_commonSuffix(equality1, edit);
                    if (commonOffset) {
                        var commonString = edit.substring(edit.length - commonOffset);
                        equality1 = equality1.substring(0, equality1.length - commonOffset);
                        edit = commonString + edit.substring(0, edit.length - commonOffset);
                        equality2 = commonString + equality2;
                    }
                    // Second, step character by character right, looking for the best fit.
                    var bestEquality1 = equality1;
                    var bestEdit = edit;
                    var bestEquality2 = equality2;
                    var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                    while(edit.charAt(0) === equality2.charAt(0)){
                        equality1 += edit.charAt(0);
                        edit = edit.substring(1) + equality2.charAt(0);
                        equality2 = equality2.substring(1);
                        var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                        // The >= encourages trailing rather than leading whitespace on edits.
                        if (score >= bestScore) {
                            bestScore = score;
                            bestEquality1 = equality1;
                            bestEdit = edit;
                            bestEquality2 = equality2;
                        }
                    }
                    if (diffs[pointer - 1][1] != bestEquality1) {
                        // We have an improvement, save it back to the diff.
                        if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                        else {
                            diffs.splice(pointer - 1, 1);
                            pointer--;
                        }
                        diffs[pointer][1] = bestEdit;
                        if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                        else {
                            diffs.splice(pointer + 1, 1);
                            pointer--;
                        }
                    }
                }
                pointer++;
            }
        };
        // Define some regex patterns for matching boundaries.
        diff_match_patch1.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
        diff_match_patch1.whitespaceRegex_ = /\s/;
        diff_match_patch1.linebreakRegex_ = /[\r\n]/;
        diff_match_patch1.blanklineEndRegex_ = /\n\r?\n$/;
        diff_match_patch1.blanklineStartRegex_ = /^\r?\n\r?\n/;
        /**
  	 * Reduce the number of edits by eliminating operationally trivial equalities.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 */ diff_match_patch1.prototype.diff_cleanupEfficiency = function(diffs) {
            var changes = false;
            var equalities = []; // Stack of indices where equalities are found.
            var equalitiesLength = 0; // Keeping our own length var is faster in JS.
            /** @type {?string} */ var lastEquality = null;
            // Always equal to diffs[equalities[equalitiesLength - 1]][1]
            var pointer = 0; // Index of current position.
            // Is there an insertion operation before the last equality.
            var pre_ins = false;
            // Is there a deletion operation before the last equality.
            var pre_del = false;
            // Is there an insertion operation after the last equality.
            var post_ins = false;
            // Is there a deletion operation after the last equality.
            var post_del = false;
            while(pointer < diffs.length){
                if (diffs[pointer][0] == DIFF_EQUAL) {
                    if (diffs[pointer][1].length < this.Diff_EditCost && (post_ins || post_del)) {
                        // Candidate found.
                        equalities[equalitiesLength++] = pointer;
                        pre_ins = post_ins;
                        pre_del = post_del;
                        lastEquality = diffs[pointer][1];
                    } else {
                        // Not a candidate, and can never become one.
                        equalitiesLength = 0;
                        lastEquality = null;
                    }
                    post_ins = post_del = false;
                } else {
                    if (diffs[pointer][0] == DIFF_DELETE) post_del = true;
                    else post_ins = true;
                    /*
  	       * Five types to be split:
  	       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
  	       * <ins>A</ins>X<ins>C</ins><del>D</del>
  	       * <ins>A</ins><del>B</del>X<ins>C</ins>
  	       * <ins>A</del>X<ins>C</ins><del>D</del>
  	       * <ins>A</ins><del>B</del>X<del>C</del>
  	       */ if (lastEquality && (pre_ins && pre_del && post_ins && post_del || lastEquality.length < this.Diff_EditCost / 2 && pre_ins + pre_del + post_ins + post_del == 3)) {
                        // Duplicate record.
                        diffs.splice(equalities[equalitiesLength - 1], 0, new diff_match_patch1.Diff(DIFF_DELETE, lastEquality));
                        // Change second copy to insert.
                        diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
                        equalitiesLength--; // Throw away the equality we just deleted;
                        lastEquality = null;
                        if (pre_ins && pre_del) {
                            // No changes made which could affect previous entry, keep going.
                            post_ins = post_del = true;
                            equalitiesLength = 0;
                        } else {
                            equalitiesLength--; // Throw away the previous equality.
                            pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                            post_ins = post_del = false;
                        }
                        changes = true;
                    }
                }
                pointer++;
            }
            if (changes) this.diff_cleanupMerge(diffs);
        };
        /**
  	 * Reorder and merge like edit sections.  Merge equalities.
  	 * Any edit section can move as long as it doesn't cross an equality.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 */ diff_match_patch1.prototype.diff_cleanupMerge = function(diffs) {
            // Add a dummy entry at the end.
            diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, ''));
            var pointer = 0;
            var count_delete = 0;
            var count_insert = 0;
            var text_delete = '';
            var text_insert = '';
            var commonlength;
            while(pointer < diffs.length)switch(diffs[pointer][0]){
                case DIFF_INSERT:
                    count_insert++;
                    text_insert += diffs[pointer][1];
                    pointer++;
                    break;
                case DIFF_DELETE:
                    count_delete++;
                    text_delete += diffs[pointer][1];
                    pointer++;
                    break;
                case DIFF_EQUAL:
                    // Upon reaching an equality, check for prior redundancies.
                    if (count_delete + count_insert > 1) {
                        if (count_delete !== 0 && count_insert !== 0) {
                            // Factor out any common prefixies.
                            commonlength = this.diff_commonPrefix(text_insert, text_delete);
                            if (commonlength !== 0) {
                                if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                                else {
                                    diffs.splice(0, 0, new diff_match_patch1.Diff(DIFF_EQUAL, text_insert.substring(0, commonlength)));
                                    pointer++;
                                }
                                text_insert = text_insert.substring(commonlength);
                                text_delete = text_delete.substring(commonlength);
                            }
                            // Factor out any common suffixies.
                            commonlength = this.diff_commonSuffix(text_insert, text_delete);
                            if (commonlength !== 0) {
                                diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                                text_insert = text_insert.substring(0, text_insert.length - commonlength);
                                text_delete = text_delete.substring(0, text_delete.length - commonlength);
                            }
                        }
                        // Delete the offending records and add the merged ones.
                        pointer -= count_delete + count_insert;
                        diffs.splice(pointer, count_delete + count_insert);
                        if (text_delete.length) {
                            diffs.splice(pointer, 0, new diff_match_patch1.Diff(DIFF_DELETE, text_delete));
                            pointer++;
                        }
                        if (text_insert.length) {
                            diffs.splice(pointer, 0, new diff_match_patch1.Diff(DIFF_INSERT, text_insert));
                            pointer++;
                        }
                        pointer++;
                    } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                        // Merge this equality with the previous one.
                        diffs[pointer - 1][1] += diffs[pointer][1];
                        diffs.splice(pointer, 1);
                    } else pointer++;
                    count_insert = 0;
                    count_delete = 0;
                    text_delete = '';
                    text_insert = '';
                    break;
            }
            if (diffs[diffs.length - 1][1] === '') diffs.pop(); // Remove the dummy entry at the end.
            // Second pass: look for single edits surrounded on both sides by equalities
            // which can be shifted sideways to eliminate an equality.
            // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
            var changes = false;
            pointer = 1;
            // Intentionally ignore the first and last element (don't need checking).
            while(pointer < diffs.length - 1){
                if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                    // This is a single edit surrounded by equalities.
                    if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                        // Shift the edit over the previous equality.
                        diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                        diffs.splice(pointer - 1, 1);
                        changes = true;
                    } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                        // Shift the edit over the next equality.
                        diffs[pointer - 1][1] += diffs[pointer + 1][1];
                        diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                        diffs.splice(pointer + 1, 1);
                        changes = true;
                    }
                }
                pointer++;
            }
            // If shifts were made, the diff needs reordering and another shift sweep.
            if (changes) this.diff_cleanupMerge(diffs);
        };
        /**
  	 * loc is a location in text1, compute and return the equivalent location in
  	 * text2.
  	 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @param {number} loc Location within text1.
  	 * @return {number} Location within text2.
  	 */ diff_match_patch1.prototype.diff_xIndex = function(diffs, loc) {
            var chars1 = 0;
            var chars2 = 0;
            var last_chars1 = 0;
            var last_chars2 = 0;
            var x;
            for(x = 0; x < diffs.length; x++){
                if (diffs[x][0] !== DIFF_INSERT) chars1 += diffs[x][1].length;
                if (diffs[x][0] !== DIFF_DELETE) chars2 += diffs[x][1].length;
                if (chars1 > loc) break;
                last_chars1 = chars1;
                last_chars2 = chars2;
            }
            // Was the location was deleted?
            if (diffs.length != x && diffs[x][0] === DIFF_DELETE) return last_chars2;
            // Add the remaining character length.
            return last_chars2 + (loc - last_chars1);
        };
        /**
  	 * Convert a diff array into a pretty HTML report.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @return {string} HTML representation.
  	 */ diff_match_patch1.prototype.diff_prettyHtml = function(diffs) {
            var html = [];
            var pattern_amp = /&/g;
            var pattern_lt = /</g;
            var pattern_gt = />/g;
            var pattern_para = /\n/g;
            for(var x = 0; x < diffs.length; x++){
                var op = diffs[x][0]; // Operation (insert, delete, equal)
                var data = diffs[x][1]; // Text of change.
                var text = data.replace(pattern_amp, '&amp;').replace(pattern_lt, '&lt;').replace(pattern_gt, '&gt;').replace(pattern_para, '&para;<br>');
                switch(op){
                    case DIFF_INSERT:
                        html[x] = '<ins style="background:#e6ffe6;">' + text + '</ins>';
                        break;
                    case DIFF_DELETE:
                        html[x] = '<del style="background:#ffe6e6;">' + text + '</del>';
                        break;
                    case DIFF_EQUAL:
                        html[x] = '<span>' + text + '</span>';
                        break;
                }
            }
            return html.join('');
        };
        /**
  	 * Compute and return the source text (all equalities and deletions).
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @return {string} Source text.
  	 */ diff_match_patch1.prototype.diff_text1 = function(diffs) {
            var text = [];
            for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== DIFF_INSERT) text[x] = diffs[x][1];
            return text.join('');
        };
        /**
  	 * Compute and return the destination text (all equalities and insertions).
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @return {string} Destination text.
  	 */ diff_match_patch1.prototype.diff_text2 = function(diffs) {
            var text = [];
            for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== DIFF_DELETE) text[x] = diffs[x][1];
            return text.join('');
        };
        /**
  	 * Compute the Levenshtein distance; the number of inserted, deleted or
  	 * substituted characters.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @return {number} Number of changes.
  	 */ diff_match_patch1.prototype.diff_levenshtein = function(diffs) {
            var levenshtein = 0;
            var insertions = 0;
            var deletions = 0;
            for(var x = 0; x < diffs.length; x++){
                var op = diffs[x][0];
                var data = diffs[x][1];
                switch(op){
                    case DIFF_INSERT:
                        insertions += data.length;
                        break;
                    case DIFF_DELETE:
                        deletions += data.length;
                        break;
                    case DIFF_EQUAL:
                        // A deletion and an insertion is one substitution.
                        levenshtein += Math.max(insertions, deletions);
                        insertions = 0;
                        deletions = 0;
                        break;
                }
            }
            levenshtein += Math.max(insertions, deletions);
            return levenshtein;
        };
        /**
  	 * Crush the diff into an encoded string which describes the operations
  	 * required to transform text1 into text2.
  	 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
  	 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
  	 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
  	 * @return {string} Delta text.
  	 */ diff_match_patch1.prototype.diff_toDelta = function(diffs) {
            var text = [];
            for(var x = 0; x < diffs.length; x++)switch(diffs[x][0]){
                case DIFF_INSERT:
                    text[x] = '+' + encodeURI(diffs[x][1]);
                    break;
                case DIFF_DELETE:
                    text[x] = '-' + diffs[x][1].length;
                    break;
                case DIFF_EQUAL:
                    text[x] = '=' + diffs[x][1].length;
                    break;
            }
            return text.join('\t').replace(/%20/g, ' ');
        };
        /**
  	 * Given the original text1, and an encoded string which describes the
  	 * operations required to transform text1 into text2, compute the full diff.
  	 * @param {string} text1 Source string for the diff.
  	 * @param {string} delta Delta text.
  	 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
  	 * @throws {!Error} If invalid input.
  	 */ diff_match_patch1.prototype.diff_fromDelta = function(text1, delta) {
            var diffs = [];
            var diffsLength = 0; // Keeping our own length var is faster in JS.
            var pointer = 0; // Cursor in text1
            var tokens = delta.split(/\t/g);
            for(var x = 0; x < tokens.length; x++){
                // Each token begins with a one character parameter which specifies the
                // operation of this token (delete, insert, equality).
                var param = tokens[x].substring(1);
                switch(tokens[x].charAt(0)){
                    case '+':
                        try {
                            diffs[diffsLength++] = new diff_match_patch1.Diff(DIFF_INSERT, decodeURI(param));
                        } catch (ex) {
                            // Malformed URI sequence.
                            throw new Error('Illegal escape in diff_fromDelta: ' + param);
                        }
                        break;
                    case '-':
                    // Fall through.
                    case '=':
                        var n = parseInt(param, 10);
                        if (isNaN(n) || n < 0) throw new Error('Invalid number in diff_fromDelta: ' + param);
                        var text = text1.substring(pointer, pointer += n);
                        if (tokens[x].charAt(0) == '=') diffs[diffsLength++] = new diff_match_patch1.Diff(DIFF_EQUAL, text);
                        else diffs[diffsLength++] = new diff_match_patch1.Diff(DIFF_DELETE, text);
                        break;
                    default:
                        // Blank tokens are ok (from a trailing \t).
                        // Anything else is an error.
                        if (tokens[x]) throw new Error('Invalid diff operation in diff_fromDelta: ' + tokens[x]);
                }
            }
            if (pointer != text1.length) throw new Error('Delta length (' + pointer + ') does not equal source text length (' + text1.length + ').');
            return diffs;
        };
        //  MATCH FUNCTIONS
        /**
  	 * Locate the best instance of 'pattern' in 'text' near 'loc'.
  	 * @param {string} text The text to search.
  	 * @param {string} pattern The pattern to search for.
  	 * @param {number} loc The location to search around.
  	 * @return {number} Best match index or -1.
  	 */ diff_match_patch1.prototype.match_main = function(text, pattern, loc) {
            // Check for null inputs.
            if (text == null || pattern == null || loc == null) throw new Error('Null input. (match_main)');
            loc = Math.max(0, Math.min(loc, text.length));
            if (text == pattern) // Shortcut (potentially not guaranteed by the algorithm)
            return 0;
            else if (!text.length) // Nothing to match.
            return -1;
            else if (text.substring(loc, loc + pattern.length) == pattern) // Perfect match at the perfect spot!  (Includes case of null pattern)
            return loc;
            else // Do a fuzzy compare.
            return this.match_bitap_(text, pattern, loc);
        };
        /**
  	 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
  	 * Bitap algorithm.
  	 * @param {string} text The text to search.
  	 * @param {string} pattern The pattern to search for.
  	 * @param {number} loc The location to search around.
  	 * @return {number} Best match index or -1.
  	 * @private
  	 */ diff_match_patch1.prototype.match_bitap_ = function(text, pattern, loc) {
            if (pattern.length > this.Match_MaxBits) throw new Error('Pattern too long for this browser.');
            // Initialise the alphabet.
            var s = this.match_alphabet_(pattern);
            var dmp = this; // 'this' becomes 'window' in a closure.
            /**
  	   * Compute and return the score for a match with e errors and x location.
  	   * Accesses loc and pattern through being a closure.
  	   * @param {number} e Number of errors in match.
  	   * @param {number} x Location of match.
  	   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
  	   * @private
  	   */ function match_bitapScore_(e, x) {
                var accuracy = e / pattern.length;
                var proximity = Math.abs(loc - x);
                if (!dmp.Match_Distance) // Dodge divide by zero error.
                return proximity ? 1.0 : accuracy;
                return accuracy + proximity / dmp.Match_Distance;
            }
            // Highest score beyond which we give up.
            var score_threshold = this.Match_Threshold;
            // Is there a nearby exact match? (speedup)
            var best_loc = text.indexOf(pattern, loc);
            if (best_loc != -1) {
                score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
                // What about in the other direction? (speedup)
                best_loc = text.lastIndexOf(pattern, loc + pattern.length);
                if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
            }
            // Initialise the bit arrays.
            var matchmask = 1 << pattern.length - 1;
            best_loc = -1;
            var bin_min, bin_mid;
            var bin_max = pattern.length + text.length;
            var last_rd;
            for(var d = 0; d < pattern.length; d++){
                // Scan for the best match; each iteration allows for one more error.
                // Run a binary search to determine how far from 'loc' we can stray at this
                // error level.
                bin_min = 0;
                bin_mid = bin_max;
                while(bin_min < bin_mid){
                    if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
                    else bin_max = bin_mid;
                    bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
                }
                // Use the result from this iteration as the maximum for the next.
                bin_max = bin_mid;
                var start = Math.max(1, loc - bin_mid + 1);
                var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
                var rd = Array(finish + 2);
                rd[finish + 1] = (1 << d) - 1;
                for(var j = finish; j >= start; j--){
                    // The alphabet (s) is a sparse hash, so the following line generates
                    // warnings.
                    var charMatch = s[text.charAt(j - 1)];
                    if (d === 0) rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
                    else rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
                    if (rd[j] & matchmask) {
                        var score = match_bitapScore_(d, j - 1);
                        // This match will almost certainly be better than any existing match.
                        // But check anyway.
                        if (score <= score_threshold) {
                            // Told you so.
                            score_threshold = score;
                            best_loc = j - 1;
                            if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                            start = Math.max(1, 2 * loc - best_loc);
                            else break;
                        }
                    }
                }
                // No hope for a (better) match at greater error levels.
                if (match_bitapScore_(d + 1, loc) > score_threshold) break;
                last_rd = rd;
            }
            return best_loc;
        };
        /**
  	 * Initialise the alphabet for the Bitap algorithm.
  	 * @param {string} pattern The text to encode.
  	 * @return {!Object} Hash of character locations.
  	 * @private
  	 */ diff_match_patch1.prototype.match_alphabet_ = function(pattern) {
            var s = {};
            for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] = 0;
            for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
            return s;
        };
        //  PATCH FUNCTIONS
        /**
  	 * Increase the context until it is unique,
  	 * but don't let the pattern expand beyond Match_MaxBits.
  	 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
  	 * @param {string} text Source text.
  	 * @private
  	 */ diff_match_patch1.prototype.patch_addContext_ = function(patch, text) {
            if (text.length == 0) return;
            if (patch.start2 === null) throw Error('patch not initialized');
            var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
            var padding = 0;
            // Look for the first and last matches of pattern in text.  If two different
            // matches are found, increase the pattern length.
            while(text.indexOf(pattern) != text.lastIndexOf(pattern) && pattern.length < this.Match_MaxBits - this.Patch_Margin - this.Patch_Margin){
                padding += this.Patch_Margin;
                pattern = text.substring(patch.start2 - padding, patch.start2 + patch.length1 + padding);
            }
            // Add one chunk for good luck.
            padding += this.Patch_Margin;
            // Add the prefix.
            var prefix = text.substring(patch.start2 - padding, patch.start2);
            if (prefix) patch.diffs.unshift(new diff_match_patch1.Diff(DIFF_EQUAL, prefix));
            // Add the suffix.
            var suffix = text.substring(patch.start2 + patch.length1, patch.start2 + patch.length1 + padding);
            if (suffix) patch.diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, suffix));
            // Roll back the start points.
            patch.start1 -= prefix.length;
            patch.start2 -= prefix.length;
            // Extend the lengths.
            patch.length1 += prefix.length + suffix.length;
            patch.length2 += prefix.length + suffix.length;
        };
        /**
  	 * Compute a list of patches to turn text1 into text2.
  	 * Use diffs if provided, otherwise compute it ourselves.
  	 * There are four ways to call this function, depending on what data is
  	 * available to the caller:
  	 * Method 1:
  	 * a = text1, b = text2
  	 * Method 2:
  	 * a = diffs
  	 * Method 3 (optimal):
  	 * a = text1, b = diffs
  	 * Method 4 (deprecated, use method 3):
  	 * a = text1, b = text2, c = diffs
  	 *
  	 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
  	 * Array of diff tuples for text1 to text2 (method 2).
  	 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_b text2 (methods 1,4) or
  	 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
  	 * @param {string|!Array.<!diff_match_patch.Diff>=} opt_c Array of diff tuples
  	 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
  	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
  	 */ diff_match_patch1.prototype.patch_make = function(a, opt_b, opt_c) {
            var text1, diffs;
            if (typeof a == 'string' && typeof opt_b == 'string' && typeof opt_c == 'undefined') {
                // Method 1: text1, text2
                // Compute diffs from text1 and text2.
                text1 = /** @type {string} */ a;
                diffs = this.diff_main(text1, /** @type {string} */ opt_b, true);
                if (diffs.length > 2) {
                    this.diff_cleanupSemantic(diffs);
                    this.diff_cleanupEfficiency(diffs);
                }
            } else if (a && typeof a == 'object' && typeof opt_b == 'undefined' && typeof opt_c == 'undefined') {
                // Method 2: diffs
                // Compute text1 from diffs.
                diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ a;
                text1 = this.diff_text1(diffs);
            } else if (typeof a == 'string' && opt_b && typeof opt_b == 'object' && typeof opt_c == 'undefined') {
                // Method 3: text1, diffs
                text1 = /** @type {string} */ a;
                diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_b;
            } else if (typeof a == 'string' && typeof opt_b == 'string' && opt_c && typeof opt_c == 'object') {
                // Method 4: text1, text2, diffs
                // text2 is not used.
                text1 = /** @type {string} */ a;
                diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_c;
            } else throw new Error('Unknown call format to patch_make.');
            if (diffs.length === 0) return []; // Get rid of the null case.
            var patches = [];
            var patch = new diff_match_patch1.patch_obj();
            var patchDiffLength = 0; // Keeping our own length var is faster in JS.
            var char_count1 = 0; // Number of characters into the text1 string.
            var char_count2 = 0; // Number of characters into the text2 string.
            // Start with text1 (prepatch_text) and apply the diffs until we arrive at
            // text2 (postpatch_text).  We recreate the patches one by one to determine
            // context info.
            var prepatch_text = text1;
            var postpatch_text = text1;
            for(var x = 0; x < diffs.length; x++){
                var diff_type = diffs[x][0];
                var diff_text = diffs[x][1];
                if (!patchDiffLength && diff_type !== DIFF_EQUAL) {
                    // A new patch starts here.
                    patch.start1 = char_count1;
                    patch.start2 = char_count2;
                }
                switch(diff_type){
                    case DIFF_INSERT:
                        patch.diffs[patchDiffLength++] = diffs[x];
                        patch.length2 += diff_text.length;
                        postpatch_text = postpatch_text.substring(0, char_count2) + diff_text + postpatch_text.substring(char_count2);
                        break;
                    case DIFF_DELETE:
                        patch.length1 += diff_text.length;
                        patch.diffs[patchDiffLength++] = diffs[x];
                        postpatch_text = postpatch_text.substring(0, char_count2) + postpatch_text.substring(char_count2 + diff_text.length);
                        break;
                    case DIFF_EQUAL:
                        if (diff_text.length <= 2 * this.Patch_Margin && patchDiffLength && diffs.length != x + 1) {
                            // Small equality inside a patch.
                            patch.diffs[patchDiffLength++] = diffs[x];
                            patch.length1 += diff_text.length;
                            patch.length2 += diff_text.length;
                        } else if (diff_text.length >= 2 * this.Patch_Margin) // Time for a new patch.
                        {
                            if (patchDiffLength) {
                                this.patch_addContext_(patch, prepatch_text);
                                patches.push(patch);
                                patch = new diff_match_patch1.patch_obj();
                                patchDiffLength = 0;
                                // Unlike Unidiff, our patch lists have a rolling context.
                                // https://github.com/google/diff-match-patch/wiki/Unidiff
                                // Update prepatch text & pos to reflect the application of the
                                // just completed patch.
                                prepatch_text = postpatch_text;
                                char_count1 = char_count2;
                            }
                        }
                        break;
                }
                // Update the current character count.
                if (diff_type !== DIFF_INSERT) char_count1 += diff_text.length;
                if (diff_type !== DIFF_DELETE) char_count2 += diff_text.length;
            }
            // Pick up the leftover patch if not empty.
            if (patchDiffLength) {
                this.patch_addContext_(patch, prepatch_text);
                patches.push(patch);
            }
            return patches;
        };
        /**
  	 * Given an array of patches, return another array that is identical.
  	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
  	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
  	 */ diff_match_patch1.prototype.patch_deepCopy = function(patches) {
            // Making deep copies is hard in JavaScript.
            var patchesCopy = [];
            for(var x = 0; x < patches.length; x++){
                var patch = patches[x];
                var patchCopy = new diff_match_patch1.patch_obj();
                patchCopy.diffs = [];
                for(var y = 0; y < patch.diffs.length; y++)patchCopy.diffs[y] = new diff_match_patch1.Diff(patch.diffs[y][0], patch.diffs[y][1]);
                patchCopy.start1 = patch.start1;
                patchCopy.start2 = patch.start2;
                patchCopy.length1 = patch.length1;
                patchCopy.length2 = patch.length2;
                patchesCopy[x] = patchCopy;
            }
            return patchesCopy;
        };
        /**
  	 * Merge a set of patches onto the text.  Return a patched text, as well
  	 * as a list of true/false values indicating which patches were applied.
  	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
  	 * @param {string} text Old text.
  	 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
  	 *      new text and an array of boolean values.
  	 */ diff_match_patch1.prototype.patch_apply = function(patches, text) {
            if (patches.length == 0) return [
                text,
                []
            ];
            // Deep copy the patches so that no changes are made to originals.
            patches = this.patch_deepCopy(patches);
            var nullPadding = this.patch_addPadding(patches);
            text = nullPadding + text + nullPadding;
            this.patch_splitMax(patches);
            // delta keeps track of the offset between the expected and actual location
            // of the previous patch.  If there are patches expected at positions 10 and
            // 20, but the first patch was found at 12, delta is 2 and the second patch
            // has an effective expected position of 22.
            var delta = 0;
            var results = [];
            for(var x = 0; x < patches.length; x++){
                var expected_loc = patches[x].start2 + delta;
                var text1 = this.diff_text1(patches[x].diffs);
                var start_loc;
                var end_loc = -1;
                if (text1.length > this.Match_MaxBits) {
                    // patch_splitMax will only provide an oversized pattern in the case of
                    // a monster delete.
                    start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits), expected_loc);
                    if (start_loc != -1) {
                        end_loc = this.match_main(text, text1.substring(text1.length - this.Match_MaxBits), expected_loc + text1.length - this.Match_MaxBits);
                        if (end_loc == -1 || start_loc >= end_loc) // Can't find valid trailing context.  Drop this patch.
                        start_loc = -1;
                    }
                } else start_loc = this.match_main(text, text1, expected_loc);
                if (start_loc == -1) {
                    // No match found.  :(
                    results[x] = false;
                    // Subtract the delta for this failed patch from subsequent patches.
                    delta -= patches[x].length2 - patches[x].length1;
                } else {
                    // Found a match.  :)
                    results[x] = true;
                    delta = start_loc - expected_loc;
                    var text2;
                    if (end_loc == -1) text2 = text.substring(start_loc, start_loc + text1.length);
                    else text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
                    if (text1 == text2) // Perfect match, just shove the replacement text in.
                    text = text.substring(0, start_loc) + this.diff_text2(patches[x].diffs) + text.substring(start_loc + text1.length);
                    else {
                        // Imperfect match.  Run a diff to get a framework of equivalent
                        // indices.
                        var diffs = this.diff_main(text1, text2, false);
                        if (text1.length > this.Match_MaxBits && this.diff_levenshtein(diffs) / text1.length > this.Patch_DeleteThreshold) // The end points match, but the content is unacceptably bad.
                        results[x] = false;
                        else {
                            this.diff_cleanupSemanticLossless(diffs);
                            var index1 = 0;
                            var index2;
                            for(var y = 0; y < patches[x].diffs.length; y++){
                                var mod = patches[x].diffs[y];
                                if (mod[0] !== DIFF_EQUAL) index2 = this.diff_xIndex(diffs, index1);
                                if (mod[0] === DIFF_INSERT) text = text.substring(0, start_loc + index2) + mod[1] + text.substring(start_loc + index2);
                                else if (mod[0] === DIFF_DELETE) text = text.substring(0, start_loc + index2) + text.substring(start_loc + this.diff_xIndex(diffs, index1 + mod[1].length));
                                if (mod[0] !== DIFF_DELETE) index1 += mod[1].length;
                            }
                        }
                    }
                }
            }
            // Strip the padding off.
            text = text.substring(nullPadding.length, text.length - nullPadding.length);
            return [
                text,
                results
            ];
        };
        /**
  	 * Add some padding on text start and end so that edges can match something.
  	 * Intended to be called only from within patch_apply.
  	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
  	 * @return {string} The padding string added to each side.
  	 */ diff_match_patch1.prototype.patch_addPadding = function(patches) {
            var paddingLength = this.Patch_Margin;
            var nullPadding = '';
            for(var x = 1; x <= paddingLength; x++)nullPadding += String.fromCharCode(x);
            // Bump all the patches forward.
            for(var x = 0; x < patches.length; x++){
                patches[x].start1 += paddingLength;
                patches[x].start2 += paddingLength;
            }
            // Add some padding on start of first diff.
            var patch = patches[0];
            var diffs = patch.diffs;
            if (diffs.length == 0 || diffs[0][0] != DIFF_EQUAL) {
                // Add nullPadding equality.
                diffs.unshift(new diff_match_patch1.Diff(DIFF_EQUAL, nullPadding));
                patch.start1 -= paddingLength; // Should be 0.
                patch.start2 -= paddingLength; // Should be 0.
                patch.length1 += paddingLength;
                patch.length2 += paddingLength;
            } else if (paddingLength > diffs[0][1].length) {
                // Grow first equality.
                var extraLength = paddingLength - diffs[0][1].length;
                diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
                patch.start1 -= extraLength;
                patch.start2 -= extraLength;
                patch.length1 += extraLength;
                patch.length2 += extraLength;
            }
            // Add some padding on end of last diff.
            patch = patches[patches.length - 1];
            diffs = patch.diffs;
            if (diffs.length == 0 || diffs[diffs.length - 1][0] != DIFF_EQUAL) {
                // Add nullPadding equality.
                diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, nullPadding));
                patch.length1 += paddingLength;
                patch.length2 += paddingLength;
            } else if (paddingLength > diffs[diffs.length - 1][1].length) {
                // Grow last equality.
                var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
                diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
                patch.length1 += extraLength;
                patch.length2 += extraLength;
            }
            return nullPadding;
        };
        /**
  	 * Look through the patches and break up any which are longer than the maximum
  	 * limit of the match algorithm.
  	 * Intended to be called only from within patch_apply.
  	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
  	 */ diff_match_patch1.prototype.patch_splitMax = function(patches) {
            var patch_size = this.Match_MaxBits;
            for(var x = 0; x < patches.length; x++){
                if (patches[x].length1 <= patch_size) continue;
                var bigpatch = patches[x];
                // Remove the big old patch.
                patches.splice(x--, 1);
                var start1 = bigpatch.start1;
                var start2 = bigpatch.start2;
                var precontext = '';
                while(bigpatch.diffs.length !== 0){
                    // Create one of several smaller patches.
                    var patch = new diff_match_patch1.patch_obj();
                    var empty = true;
                    patch.start1 = start1 - precontext.length;
                    patch.start2 = start2 - precontext.length;
                    if (precontext !== '') {
                        patch.length1 = patch.length2 = precontext.length;
                        patch.diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, precontext));
                    }
                    while(bigpatch.diffs.length !== 0 && patch.length1 < patch_size - this.Patch_Margin){
                        var diff_type = bigpatch.diffs[0][0];
                        var diff_text = bigpatch.diffs[0][1];
                        if (diff_type === DIFF_INSERT) {
                            // Insertions are harmless.
                            patch.length2 += diff_text.length;
                            start2 += diff_text.length;
                            patch.diffs.push(bigpatch.diffs.shift());
                            empty = false;
                        } else if (diff_type === DIFF_DELETE && patch.diffs.length == 1 && patch.diffs[0][0] == DIFF_EQUAL && diff_text.length > 2 * patch_size) {
                            // This is a large deletion.  Let it pass in one chunk.
                            patch.length1 += diff_text.length;
                            start1 += diff_text.length;
                            empty = false;
                            patch.diffs.push(new diff_match_patch1.Diff(diff_type, diff_text));
                            bigpatch.diffs.shift();
                        } else {
                            // Deletion or equality.  Only take as much as we can stomach.
                            diff_text = diff_text.substring(0, patch_size - patch.length1 - this.Patch_Margin);
                            patch.length1 += diff_text.length;
                            start1 += diff_text.length;
                            if (diff_type === DIFF_EQUAL) {
                                patch.length2 += diff_text.length;
                                start2 += diff_text.length;
                            } else empty = false;
                            patch.diffs.push(new diff_match_patch1.Diff(diff_type, diff_text));
                            if (diff_text == bigpatch.diffs[0][1]) bigpatch.diffs.shift();
                            else bigpatch.diffs[0][1] = bigpatch.diffs[0][1].substring(diff_text.length);
                        }
                    }
                    // Compute the head context for the next patch.
                    precontext = this.diff_text2(patch.diffs);
                    precontext = precontext.substring(precontext.length - this.Patch_Margin);
                    // Append the end context for this patch.
                    var postcontext = this.diff_text1(bigpatch.diffs).substring(0, this.Patch_Margin);
                    if (postcontext !== '') {
                        patch.length1 += postcontext.length;
                        patch.length2 += postcontext.length;
                        if (patch.diffs.length !== 0 && patch.diffs[patch.diffs.length - 1][0] === DIFF_EQUAL) patch.diffs[patch.diffs.length - 1][1] += postcontext;
                        else patch.diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, postcontext));
                    }
                    if (!empty) patches.splice(++x, 0, patch);
                }
            }
        };
        /**
  	 * Take a list of patches and return a textual representation.
  	 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
  	 * @return {string} Text representation of patches.
  	 */ diff_match_patch1.prototype.patch_toText = function(patches) {
            var text = [];
            for(var x = 0; x < patches.length; x++)text[x] = patches[x];
            return text.join('');
        };
        /**
  	 * Parse a textual representation of patches and return a list of Patch objects.
  	 * @param {string} textline Text representation of patches.
  	 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
  	 * @throws {!Error} If invalid input.
  	 */ diff_match_patch1.prototype.patch_fromText = function(textline) {
            var patches = [];
            if (!textline) return patches;
            var text = textline.split('\n');
            var textPointer = 0;
            var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
            while(textPointer < text.length){
                var m = text[textPointer].match(patchHeader);
                if (!m) throw new Error('Invalid patch string: ' + text[textPointer]);
                var patch = new diff_match_patch1.patch_obj();
                patches.push(patch);
                patch.start1 = parseInt(m[1], 10);
                if (m[2] === '') {
                    patch.start1--;
                    patch.length1 = 1;
                } else if (m[2] == '0') patch.length1 = 0;
                else {
                    patch.start1--;
                    patch.length1 = parseInt(m[2], 10);
                }
                patch.start2 = parseInt(m[3], 10);
                if (m[4] === '') {
                    patch.start2--;
                    patch.length2 = 1;
                } else if (m[4] == '0') patch.length2 = 0;
                else {
                    patch.start2--;
                    patch.length2 = parseInt(m[4], 10);
                }
                textPointer++;
                while(textPointer < text.length){
                    var sign = text[textPointer].charAt(0);
                    try {
                        var line = decodeURI(text[textPointer].substring(1));
                    } catch (ex) {
                        // Malformed URI sequence.
                        throw new Error('Illegal escape in patch_fromText: ' + line);
                    }
                    if (sign == '-') // Deletion.
                    patch.diffs.push(new diff_match_patch1.Diff(DIFF_DELETE, line));
                    else if (sign == '+') // Insertion.
                    patch.diffs.push(new diff_match_patch1.Diff(DIFF_INSERT, line));
                    else if (sign == ' ') // Minor equality.
                    patch.diffs.push(new diff_match_patch1.Diff(DIFF_EQUAL, line));
                    else if (sign == '@') break;
                    else if (sign === '') ;
                    else // WTF?
                    throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
                    textPointer++;
                }
            }
            return patches;
        };
        /**
  	 * Class representing one patch operation.
  	 * @constructor
  	 */ diff_match_patch1.patch_obj = function() {
            /** @type {!Array.<!diff_match_patch.Diff>} */ this.diffs = [];
            /** @type {?number} */ this.start1 = null;
            /** @type {?number} */ this.start2 = null;
            /** @type {number} */ this.length1 = 0;
            /** @type {number} */ this.length2 = 0;
        };
        /**
  	 * Emulate GNU diff's format.
  	 * Header: @@ -382,8 +481,9 @@
  	 * Indices are printed as 1-based, not 0-based.
  	 * @return {string} The GNU diff string.
  	 */ diff_match_patch1.patch_obj.prototype.toString = function() {
            var coords1, coords2;
            if (this.length1 === 0) coords1 = this.start1 + ',0';
            else if (this.length1 == 1) coords1 = this.start1 + 1;
            else coords1 = this.start1 + 1 + ',' + this.length1;
            if (this.length2 === 0) coords2 = this.start2 + ',0';
            else if (this.length2 == 1) coords2 = this.start2 + 1;
            else coords2 = this.start2 + 1 + ',' + this.length2;
            var text = [
                '@@ -' + coords1 + ' +' + coords2 + ' @@\n'
            ];
            var op;
            // Escape the body of the patch with %xx notation.
            for(var x = 0; x < this.diffs.length; x++){
                switch(this.diffs[x][0]){
                    case DIFF_INSERT:
                        op = '+';
                        break;
                    case DIFF_DELETE:
                        op = '-';
                        break;
                    case DIFF_EQUAL:
                        op = ' ';
                        break;
                }
                text[x + 1] = op + encodeURI(this.diffs[x][1]) + '\n';
            }
            return text.join('').replace(/%20/g, ' ');
        };
        // The following export code was added by @ForbesLindesay
        module.exports = diff_match_patch1;
        module.exports['diff_match_patch'] = diff_match_patch1;
        module.exports['DIFF_DELETE'] = DIFF_DELETE;
        module.exports['DIFF_INSERT'] = DIFF_INSERT;
        module.exports['DIFF_EQUAL'] = DIFF_EQUAL;
    })(diffMatchPatch);
    var diffMatchPatchExports = diffMatchPatch.exports;
    var dmp = /*@__PURE__*/ getDefaultExportFromCjs(diffMatchPatchExports);
    /* global diff_match_patch */ const TEXT_DIFF = 2;
    const DEFAULT_MIN_LENGTH = 60;
    let cachedDiffPatch = null;
    const getDiffMatchPatch = function(required) {
        /* jshint camelcase: false */ if (!cachedDiffPatch) {
            let instance;
            /* eslint-disable camelcase, new-cap */ if (typeof diff_match_patch !== 'undefined') // already loaded, probably a browser
            instance = typeof diff_match_patch === 'function' ? new diff_match_patch() : new diff_match_patch.diff_match_patch();
            else if (dmp) try {
                instance = dmp && new dmp();
            } catch (err) {
                instance = null;
            }
            /* eslint-enable camelcase, new-cap */ if (!instance) {
                if (!required) return null;
                const error = new Error('text diff_match_patch library not found');
                // eslint-disable-next-line camelcase
                error.diff_match_patch_not_found = true;
                throw error;
            }
            cachedDiffPatch = {
                diff: function(txt1, txt2) {
                    return instance.patch_toText(instance.patch_make(txt1, txt2));
                },
                patch: function(txt1, patch) {
                    const results = instance.patch_apply(instance.patch_fromText(patch), txt1);
                    for(let i = 0; i < results[1].length; i++)if (!results[1][i]) {
                        const error = new Error('text patch failed');
                        error.textPatchFailed = true;
                    }
                    return results[0];
                }
            };
        }
        return cachedDiffPatch;
    };
    const diffFilter = function textsDiffFilter(context) {
        if (context.leftType !== 'string') return;
        const minLength = context.options && context.options.textDiff && context.options.textDiff.minLength || DEFAULT_MIN_LENGTH;
        if (context.left.length < minLength || context.right.length < minLength) {
            context.setResult([
                context.left,
                context.right
            ]).exit();
            return;
        }
        // large text, try to use a text-diff algorithm
        const diffMatchPatch = getDiffMatchPatch();
        if (!diffMatchPatch) {
            // diff-match-patch library not available,
            // fallback to regular string replace
            context.setResult([
                context.left,
                context.right
            ]).exit();
            return;
        }
        const diff = diffMatchPatch.diff;
        context.setResult([
            diff(context.left, context.right),
            0,
            TEXT_DIFF
        ]).exit();
    };
    diffFilter.filterName = 'texts';
    const patchFilter = function textsPatchFilter(context) {
        if (context.nested) return;
        if (context.delta[2] !== TEXT_DIFF) return;
        // text-diff, use a text-patch algorithm
        const patch = getDiffMatchPatch(true).patch;
        context.setResult(patch(context.left, context.delta[0])).exit();
    };
    patchFilter.filterName = 'texts';
    const textDeltaReverse = function(delta) {
        let i;
        let l;
        let line;
        let lineTmp;
        let header = null;
        const headerRegex = /^@@ +-(\d+),(\d+) +\+(\d+),(\d+) +@@$/;
        let lineHeader;
        const lines = delta.split('\n');
        for(i = 0, l = lines.length; i < l; i++){
            line = lines[i];
            const lineStart = line.slice(0, 1);
            if (lineStart === '@') {
                header = headerRegex.exec(line);
                lineHeader = i;
                // fix header
                lines[lineHeader] = '@@ -' + header[3] + ',' + header[4] + ' +' + header[1] + ',' + header[2] + ' @@';
            } else if (lineStart === '+') {
                lines[i] = '-' + lines[i].slice(1);
                if (lines[i - 1].slice(0, 1) === '+') {
                    // swap lines to keep default order (-+)
                    lineTmp = lines[i];
                    lines[i] = lines[i - 1];
                    lines[i - 1] = lineTmp;
                }
            } else if (lineStart === '-') lines[i] = '+' + lines[i].slice(1);
        }
        return lines.join('\n');
    };
    const reverseFilter = function textsReverseFilter(context) {
        if (context.nested) return;
        if (context.delta[2] !== TEXT_DIFF) return;
        // text-diff, use a text-diff algorithm
        context.setResult([
            textDeltaReverse(context.delta[0]),
            0,
            TEXT_DIFF
        ]).exit();
    };
    reverseFilter.filterName = 'texts';
    class DiffPatcher {
        options() {
            return this.processor.options(...arguments);
        }
        diff(left, right) {
            return this.processor.process(new DiffContext(left, right));
        }
        patch(left, delta) {
            return this.processor.process(new PatchContext(left, delta));
        }
        reverse(delta) {
            return this.processor.process(new ReverseContext(delta));
        }
        unpatch(right, delta) {
            return this.patch(right, this.reverse(delta));
        }
        clone(value) {
            return clone$1(value);
        }
        constructor(options){
            this.processor = new Processor(options);
            this.processor.pipe(new Pipe('diff').append(collectChildrenDiffFilter, diffFilter$3, diffFilter$1, diffFilter, objectsDiffFilter, diffFilter$2).shouldHaveResult());
            this.processor.pipe(new Pipe('patch').append(collectChildrenPatchFilter$1, collectChildrenPatchFilter, patchFilter$3, patchFilter, patchFilter$2, patchFilter$1).shouldHaveResult());
            this.processor.pipe(new Pipe('reverse').append(collectChildrenReverseFilter$1, collectChildrenReverseFilter, reverseFilter$3, reverseFilter, reverseFilter$2, reverseFilter$1).shouldHaveResult());
        }
    }
    const isArray = typeof Array.isArray === 'function' ? Array.isArray : (a)=>a instanceof Array;
    const getObjectKeys = typeof Object.keys === 'function' ? (obj)=>Object.keys(obj) : (obj)=>{
        const names = [];
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) names.push(property);
        return names;
    };
    const trimUnderscore = (str)=>{
        if (str.substr(0, 1) === '_') return str.slice(1);
        return str;
    };
    const arrayKeyToSortNumber = (key)=>{
        if (key === '_t') return -1;
        else {
            if (key.substr(0, 1) === '_') return parseInt(key.slice(1), 10);
            else return parseInt(key, 10) + 0.1;
        }
    };
    const arrayKeyComparer = (key1, key2)=>arrayKeyToSortNumber(key1) - arrayKeyToSortNumber(key2);
    class BaseFormatter {
        format(delta, left) {
            const context = {};
            this.prepareContext(context);
            this.recurse(context, delta, left);
            return this.finalize(context);
        }
        prepareContext(context) {
            context.buffer = [];
            context.out = function() {
                this.buffer.push(...arguments);
            };
        }
        typeFormattterNotFound(context, deltaType) {
            throw new Error(`cannot format delta type: ${deltaType}`);
        }
        typeFormattterErrorFormatter(context, err) {
            return err.toString();
        }
        finalize(_ref) {
            let { buffer } = _ref;
            if (isArray(buffer)) return buffer.join('');
        }
        recurse(context, delta, left, key, leftKey, movedFrom, isLast) {
            const useMoveOriginHere = delta && movedFrom;
            const leftValue = useMoveOriginHere ? movedFrom.value : left;
            if (typeof delta === 'undefined' && typeof key === 'undefined') return undefined;
            const type = this.getDeltaType(delta, movedFrom);
            const nodeType = type === 'node' ? delta._t === 'a' ? 'array' : 'object' : '';
            if (typeof key !== 'undefined') this.nodeBegin(context, key, leftKey, type, nodeType, isLast);
            else this.rootBegin(context, type, nodeType);
            let typeFormattter;
            try {
                typeFormattter = this[`format_${type}`] || this.typeFormattterNotFound(context, type);
                typeFormattter.call(this, context, delta, leftValue, key, leftKey, movedFrom);
            } catch (err) {
                this.typeFormattterErrorFormatter(context, err, delta, leftValue, key, leftKey, movedFrom);
                if (typeof console !== 'undefined' && console.error) console.error(err.stack);
            }
            if (typeof key !== 'undefined') this.nodeEnd(context, key, leftKey, type, nodeType, isLast);
            else this.rootEnd(context, type, nodeType);
        }
        formatDeltaChildren(context, delta, left) {
            const self = this;
            this.forEachDeltaKey(delta, left, (key, leftKey, movedFrom, isLast)=>{
                self.recurse(context, delta[key], left ? left[leftKey] : undefined, key, leftKey, movedFrom, isLast);
            });
        }
        forEachDeltaKey(delta, left, fn) {
            const keys = getObjectKeys(delta);
            const arrayKeys = delta._t === 'a';
            const moveDestinations = {};
            let name;
            if (typeof left !== 'undefined') for(name in left){
                if (Object.prototype.hasOwnProperty.call(left, name)) {
                    if (typeof delta[name] === 'undefined' && (!arrayKeys || typeof delta[`_${name}`] === 'undefined')) keys.push(name);
                }
            }
            // look for move destinations
            for(name in delta)if (Object.prototype.hasOwnProperty.call(delta, name)) {
                const value = delta[name];
                if (isArray(value) && value[2] === 3) {
                    moveDestinations[value[1].toString()] = {
                        key: name,
                        value: left && left[parseInt(name.substr(1))]
                    };
                    if (this.includeMoveDestinations !== false) {
                        if (typeof left === 'undefined' && typeof delta[value[1]] === 'undefined') keys.push(value[1].toString());
                    }
                }
            }
            if (arrayKeys) keys.sort(arrayKeyComparer);
            else keys.sort();
            for(let index = 0, length = keys.length; index < length; index++){
                const key = keys[index];
                if (arrayKeys && key === '_t') continue;
                const leftKey = arrayKeys ? typeof key === 'number' ? key : parseInt(trimUnderscore(key), 10) : key;
                const isLast = index === length - 1;
                fn(key, leftKey, moveDestinations[leftKey], isLast);
            }
        }
        getDeltaType(delta, movedFrom) {
            if (typeof delta === 'undefined') {
                if (typeof movedFrom !== 'undefined') return 'movedestination';
                return 'unchanged';
            }
            if (isArray(delta)) {
                if (delta.length === 1) return 'added';
                if (delta.length === 2) return 'modified';
                if (delta.length === 3 && delta[2] === 0) return 'deleted';
                if (delta.length === 3 && delta[2] === 2) return 'textdiff';
                if (delta.length === 3 && delta[2] === 3) return 'moved';
            } else if (typeof delta === 'object') return 'node';
            return 'unknown';
        }
        parseTextDiff(value) {
            const output = [];
            const lines = value.split('\n@@ ');
            for(let i = 0, l = lines.length; i < l; i++){
                const line = lines[i];
                const lineOutput = {
                    pieces: []
                };
                const location = /^(?:@@ )?[-+]?(\d+),(\d+)/.exec(line).slice(1);
                lineOutput.location = {
                    line: location[0],
                    chr: location[1]
                };
                const pieces = line.split('\n').slice(1);
                for(let pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++){
                    const piece = pieces[pieceIndex];
                    if (!piece.length) continue;
                    const pieceOutput = {
                        type: 'context'
                    };
                    if (piece.substr(0, 1) === '+') pieceOutput.type = 'added';
                    else if (piece.substr(0, 1) === '-') pieceOutput.type = 'deleted';
                    pieceOutput.text = piece.slice(1);
                    lineOutput.pieces.push(pieceOutput);
                }
                output.push(lineOutput);
            }
            return output;
        }
    }
    var base = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        default: BaseFormatter
    });
    class HtmlFormatter extends BaseFormatter {
        typeFormattterErrorFormatter(context, err) {
            context.out(`<pre class="jsondiffpatch-error">${err}</pre>`);
        }
        formatValue(context, value) {
            context.out(`<pre>${htmlEscape(JSON.stringify(value, null, 2))}</pre>`);
        }
        formatTextDiffString(context, value) {
            const lines = this.parseTextDiff(value);
            context.out('<ul class="jsondiffpatch-textdiff">');
            for(let i = 0, l = lines.length; i < l; i++){
                const line = lines[i];
                context.out('<li><div class="jsondiffpatch-textdiff-location">' + `<span class="jsondiffpatch-textdiff-line-number">${line.location.line}</span><span class="jsondiffpatch-textdiff-char">${line.location.chr}</span></div><div class="jsondiffpatch-textdiff-line">`);
                const pieces = line.pieces;
                for(let pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++){
                    /* global decodeURI */ const piece = pieces[pieceIndex];
                    context.out(`<span class="jsondiffpatch-textdiff-${piece.type}">${htmlEscape(decodeURI(piece.text))}</span>`);
                }
                context.out('</div></li>');
            }
            context.out('</ul>');
        }
        rootBegin(context, type, nodeType) {
            const nodeClass = `jsondiffpatch-${type}${nodeType ? ` jsondiffpatch-child-node-type-${nodeType}` : ''}`;
            context.out(`<div class="jsondiffpatch-delta ${nodeClass}">`);
        }
        rootEnd(context) {
            context.out(`</div>${context.hasArrows ? '<script type="text/javascript">setTimeout(' + `${adjustArrows.toString()},10);</script>` : ''}`);
        }
        nodeBegin(context, key, leftKey, type, nodeType) {
            const nodeClass = `jsondiffpatch-${type}${nodeType ? ` jsondiffpatch-child-node-type-${nodeType}` : ''}`;
            context.out(`<li class="${nodeClass}" data-key="${leftKey}">` + `<div class="jsondiffpatch-property-name">${leftKey}</div>`);
        }
        nodeEnd(context) {
            context.out('</li>');
        }
        /* jshint camelcase: false */ /* eslint-disable camelcase */ format_unchanged(context, delta, left) {
            if (typeof left === 'undefined') return;
            context.out('<div class="jsondiffpatch-value">');
            this.formatValue(context, left);
            context.out('</div>');
        }
        format_movedestination(context, delta, left) {
            if (typeof left === 'undefined') return;
            context.out('<div class="jsondiffpatch-value">');
            this.formatValue(context, left);
            context.out('</div>');
        }
        format_node(context, delta, left) {
            // recurse
            const nodeType = delta._t === 'a' ? 'array' : 'object';
            context.out(`<ul class="jsondiffpatch-node jsondiffpatch-node-type-${nodeType}">`);
            this.formatDeltaChildren(context, delta, left);
            context.out('</ul>');
        }
        format_added(context, delta) {
            context.out('<div class="jsondiffpatch-value">');
            this.formatValue(context, delta[0]);
            context.out('</div>');
        }
        format_modified(context, delta) {
            context.out('<div class="jsondiffpatch-value jsondiffpatch-left-value">');
            this.formatValue(context, delta[0]);
            context.out('</div><div class="jsondiffpatch-value jsondiffpatch-right-value">');
            this.formatValue(context, delta[1]);
            context.out('</div>');
        }
        format_deleted(context, delta) {
            context.out('<div class="jsondiffpatch-value">');
            this.formatValue(context, delta[0]);
            context.out('</div>');
        }
        format_moved(context, delta) {
            context.out('<div class="jsondiffpatch-value">');
            this.formatValue(context, delta[0]);
            context.out(`</div><div class="jsondiffpatch-moved-destination">${delta[1]}</div>`);
            // draw an SVG arrow from here to move destination
            context.out(/* jshint multistr: true */ '<div class="jsondiffpatch-arrow" ' + `style="position: relative; left: -34px;">
          <svg width="30" height="60" ` + `style="position: absolute; display: none;">
          <defs>
              <marker id="markerArrow" markerWidth="8" markerHeight="8"
                 refx="2" refy="4"
                     orient="auto" markerUnits="userSpaceOnUse">
                  <path d="M1,1 L1,7 L7,4 L1,1" style="fill: #339;" />
              </marker>
          </defs>
          <path d="M30,0 Q-10,25 26,50"
            style="stroke: #88f; stroke-width: 2px; fill: none; ` + `stroke-opacity: 0.5; marker-end: url(#markerArrow);"
          ></path>
          </svg>
      </div>`);
            context.hasArrows = true;
        }
        format_textdiff(context, delta) {
            context.out('<div class="jsondiffpatch-value">');
            this.formatTextDiffString(context, delta[0]);
            context.out('</div>');
        }
    }
    function htmlEscape(text) {
        let html = text;
        const replacements = [
            [
                /&/g,
                '&amp;'
            ],
            [
                /</g,
                '&lt;'
            ],
            [
                />/g,
                '&gt;'
            ],
            [
                /'/g,
                '&apos;'
            ],
            [
                /"/g,
                '&quot;'
            ]
        ];
        for(let i = 0; i < replacements.length; i++)html = html.replace(replacements[i][0], replacements[i][1]);
        return html;
    }
    const adjustArrows = function jsondiffpatchHtmlFormatterAdjustArrows(nodeArg) {
        const node = nodeArg || document;
        const getElementText = (_ref)=>{
            let { textContent, innerText } = _ref;
            return textContent || innerText;
        };
        const eachByQuery = (el, query, fn)=>{
            const elems = el.querySelectorAll(query);
            for(let i = 0, l = elems.length; i < l; i++)fn(elems[i]);
        };
        const eachChildren = (_ref2, fn)=>{
            let { children } = _ref2;
            for(let i = 0, l = children.length; i < l; i++)fn(children[i], i);
        };
        eachByQuery(node, '.jsondiffpatch-arrow', (_ref3)=>{
            let { parentNode, children, style } = _ref3;
            const arrowParent = parentNode;
            const svg = children[0];
            const path = svg.children[1];
            svg.style.display = 'none';
            const destination = getElementText(arrowParent.querySelector('.jsondiffpatch-moved-destination'));
            const container = arrowParent.parentNode;
            let destinationElem;
            eachChildren(container, (child)=>{
                if (child.getAttribute('data-key') === destination) destinationElem = child;
            });
            if (!destinationElem) return;
            try {
                const distance = destinationElem.offsetTop - arrowParent.offsetTop;
                svg.setAttribute('height', Math.abs(distance) + 6);
                style.top = `${-8 + (distance > 0 ? 0 : distance)}px`;
                const curve = distance > 0 ? `M30,0 Q-10,${Math.round(distance / 2)} 26,${distance - 4}` : `M30,${-distance} Q-10,${Math.round(-distance / 2)} 26,4`;
                path.setAttribute('d', curve);
                svg.style.display = '';
            } catch (err) {}
        });
    };
    /* jshint camelcase: true */ /* eslint-enable camelcase */ const showUnchanged = (show, node, delay)=>{
        const el = node || document.body;
        const prefix = 'jsondiffpatch-unchanged-';
        const classes = {
            showing: `${prefix}showing`,
            hiding: `${prefix}hiding`,
            visible: `${prefix}visible`,
            hidden: `${prefix}hidden`
        };
        const list = el.classList;
        if (!list) return;
        if (!delay) {
            list.remove(classes.showing);
            list.remove(classes.hiding);
            list.remove(classes.visible);
            list.remove(classes.hidden);
            if (show === false) list.add(classes.hidden);
            return;
        }
        if (show === false) {
            list.remove(classes.showing);
            list.add(classes.visible);
            setTimeout(()=>{
                list.add(classes.hiding);
            }, 10);
        } else {
            list.remove(classes.hiding);
            list.add(classes.showing);
            list.remove(classes.hidden);
        }
        const intervalId = setInterval(()=>{
            adjustArrows(el);
        }, 100);
        setTimeout(()=>{
            list.remove(classes.showing);
            list.remove(classes.hiding);
            if (show === false) {
                list.add(classes.hidden);
                list.remove(classes.visible);
            } else {
                list.add(classes.visible);
                list.remove(classes.hidden);
            }
            setTimeout(()=>{
                list.remove(classes.visible);
                clearInterval(intervalId);
            }, delay + 400);
        }, delay);
    };
    const hideUnchanged = (node, delay)=>showUnchanged(false, node, delay);
    let defaultInstance$4;
    function format$3(delta, left) {
        if (!defaultInstance$4) defaultInstance$4 = new HtmlFormatter();
        return defaultInstance$4.format(delta, left);
    }
    var html = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        default: HtmlFormatter,
        format: format$3,
        hideUnchanged: hideUnchanged,
        showUnchanged: showUnchanged
    });
    class AnnotatedFormatter extends BaseFormatter {
        prepareContext(context) {
            super.prepareContext(context);
            context.indent = function(levels) {
                this.indentLevel = (this.indentLevel || 0) + (typeof levels === 'undefined' ? 1 : levels);
                this.indentPad = new Array(this.indentLevel + 1).join('&nbsp;&nbsp;');
            };
            context.row = (json, htmlNote)=>{
                context.out('<tr><td style="white-space: nowrap;"><pre class="jsondiffpatch-annotated-indent" style="display: inline-block">');
                context.out(context.indentPad);
                context.out('</pre><pre style="display: inline-block">');
                context.out(json);
                context.out('</pre></td><td class="jsondiffpatch-delta-note"><div>');
                context.out(htmlNote);
                context.out('</div></td></tr>');
            };
        }
        typeFormattterErrorFormatter(context, err) {
            context.row('', `<pre class="jsondiffpatch-error">${err}</pre>`);
        }
        formatTextDiffString(context, value) {
            const lines = this.parseTextDiff(value);
            context.out('<ul class="jsondiffpatch-textdiff">');
            for(let i = 0, l = lines.length; i < l; i++){
                const line = lines[i];
                context.out('<li><div class="jsondiffpatch-textdiff-location">' + `<span class="jsondiffpatch-textdiff-line-number">${line.location.line}</span><span class="jsondiffpatch-textdiff-char">${line.location.chr}</span></div><div class="jsondiffpatch-textdiff-line">`);
                const pieces = line.pieces;
                for(let pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++){
                    const piece = pieces[pieceIndex];
                    context.out(`<span class="jsondiffpatch-textdiff-${piece.type}">${piece.text}</span>`);
                }
                context.out('</div></li>');
            }
            context.out('</ul>');
        }
        rootBegin(context, type, nodeType) {
            context.out('<table class="jsondiffpatch-annotated-delta">');
            if (type === 'node') {
                context.row('{');
                context.indent();
            }
            if (nodeType === 'array') context.row('"_t": "a",', 'Array delta (member names indicate array indices)');
        }
        rootEnd(context, type) {
            if (type === 'node') {
                context.indent(-1);
                context.row('}');
            }
            context.out('</table>');
        }
        nodeBegin(context, key, leftKey, type, nodeType) {
            context.row(`&quot;${key}&quot;: {`);
            if (type === 'node') context.indent();
            if (nodeType === 'array') context.row('"_t": "a",', 'Array delta (member names indicate array indices)');
        }
        nodeEnd(context, key, leftKey, type, nodeType, isLast) {
            if (type === 'node') context.indent(-1);
            context.row(`}${isLast ? '' : ','}`);
        }
        /* jshint camelcase: false */ /* eslint-disable camelcase */ format_unchanged() {}
        format_movedestination() {}
        format_node(context, delta, left) {
            // recurse
            this.formatDeltaChildren(context, delta, left);
        }
        constructor(){
            super();
            this.includeMoveDestinations = false;
        }
    }
    /* eslint-enable camelcase */ const wrapPropertyName = (name)=>`<pre style="display:inline-block">&quot;${name}&quot;</pre>`;
    const deltaAnnotations = {
        added (delta, left, key, leftKey) {
            const formatLegend = ' <pre>([newValue])</pre>';
            if (typeof leftKey === 'undefined') return `new value${formatLegend}`;
            if (typeof leftKey === 'number') return `insert at index ${leftKey}${formatLegend}`;
            return `add property ${wrapPropertyName(leftKey)}${formatLegend}`;
        },
        modified (delta, left, key, leftKey) {
            const formatLegend = ' <pre>([previousValue, newValue])</pre>';
            if (typeof leftKey === 'undefined') return `modify value${formatLegend}`;
            if (typeof leftKey === 'number') return `modify at index ${leftKey}${formatLegend}`;
            return `modify property ${wrapPropertyName(leftKey)}${formatLegend}`;
        },
        deleted (delta, left, key, leftKey) {
            const formatLegend = ' <pre>([previousValue, 0, 0])</pre>';
            if (typeof leftKey === 'undefined') return `delete value${formatLegend}`;
            if (typeof leftKey === 'number') return `remove index ${leftKey}${formatLegend}`;
            return `delete property ${wrapPropertyName(leftKey)}${formatLegend}`;
        },
        moved (delta, left, key, leftKey) {
            return 'move from <span title="(position to remove at original state)">' + `index ${leftKey}</span> to <span title="(position to insert at final` + ` state)">index ${delta[1]}</span>`;
        },
        textdiff (delta, left, key, leftKey) {
            const location = typeof leftKey === 'undefined' ? '' : typeof leftKey === 'number' ? ` at index ${leftKey}` : ` at property ${wrapPropertyName(leftKey)}`;
            return `text diff${location}, format is <a href="https://code.google.com/` + 'p/google-diff-match-patch/wiki/Unidiff">a variation of Unidiff</a>';
        }
    };
    const formatAnyChange = function(context, delta) {
        const deltaType = this.getDeltaType(delta);
        const annotator = deltaAnnotations[deltaType];
        const htmlNote = annotator && annotator.apply(annotator, Array.prototype.slice.call(arguments, 1));
        let json = JSON.stringify(delta, null, 2);
        if (deltaType === 'textdiff') // split text diffs lines
        json = json.split('\\n').join('\\n"+\n   "');
        context.indent();
        context.row(json, htmlNote);
        context.indent(-1);
    };
    /* eslint-disable camelcase */ AnnotatedFormatter.prototype.format_added = formatAnyChange;
    AnnotatedFormatter.prototype.format_modified = formatAnyChange;
    AnnotatedFormatter.prototype.format_deleted = formatAnyChange;
    AnnotatedFormatter.prototype.format_moved = formatAnyChange;
    AnnotatedFormatter.prototype.format_textdiff = formatAnyChange;
    let defaultInstance$3;
    function format$2(delta, left) {
        if (!defaultInstance$3) defaultInstance$3 = new AnnotatedFormatter();
        return defaultInstance$3.format(delta, left);
    }
    var annotated = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        default: AnnotatedFormatter,
        format: format$2
    });
    const OPERATIONS = {
        add: 'add',
        remove: 'remove',
        replace: 'replace',
        move: 'move'
    };
    class JSONFormatter extends BaseFormatter {
        prepareContext(context) {
            super.prepareContext(context);
            context.result = [];
            context.path = [];
            context.pushCurrentOp = function(obj) {
                const { op, value } = obj;
                const val = {
                    op,
                    path: this.currentPath()
                };
                if (typeof value !== 'undefined') val.value = value;
                this.result.push(val);
            };
            context.pushMoveOp = function(to) {
                const from = this.currentPath();
                this.result.push({
                    op: OPERATIONS.move,
                    from,
                    path: this.toPath(to)
                });
            };
            context.currentPath = function() {
                return `/${this.path.join('/')}`;
            };
            context.toPath = function(toPath) {
                const to = this.path.slice();
                to[to.length - 1] = toPath;
                return `/${to.join('/')}`;
            };
        }
        typeFormattterErrorFormatter(context, err) {
            context.out(`[ERROR] ${err}`);
        }
        rootBegin() {}
        rootEnd() {}
        nodeBegin(_ref, key, leftKey) {
            let { path } = _ref;
            path.push(leftKey);
        }
        nodeEnd(_ref2) {
            let { path } = _ref2;
            path.pop();
        }
        /* jshint camelcase: false */ /* eslint-disable camelcase */ format_unchanged() {}
        format_movedestination() {}
        format_node(context, delta, left) {
            this.formatDeltaChildren(context, delta, left);
        }
        format_added(context, delta) {
            context.pushCurrentOp({
                op: OPERATIONS.add,
                value: delta[0]
            });
        }
        format_modified(context, delta) {
            context.pushCurrentOp({
                op: OPERATIONS.replace,
                value: delta[1]
            });
        }
        format_deleted(context) {
            context.pushCurrentOp({
                op: OPERATIONS.remove
            });
        }
        format_moved(context, delta) {
            const to = delta[1];
            context.pushMoveOp(to);
        }
        format_textdiff() {
            throw new Error('Not implemented');
        }
        format(delta, left) {
            const context = {};
            this.prepareContext(context);
            this.recurse(context, delta, left);
            return context.result;
        }
        constructor(){
            super();
            this.includeMoveDestinations = true;
        }
    }
    const last = (arr)=>arr[arr.length - 1];
    const sortBy = (arr, pred)=>{
        arr.sort(pred);
        return arr;
    };
    const compareByIndexDesc = (indexA, indexB)=>{
        const lastA = parseInt(indexA, 10);
        const lastB = parseInt(indexB, 10);
        if (!(isNaN(lastA) || isNaN(lastB))) return lastB - lastA;
        else return 0;
    };
    const opsByDescendingOrder = (removeOps)=>sortBy(removeOps, (a, b)=>{
            const splitA = a.path.split('/');
            const splitB = b.path.split('/');
            if (splitA.length !== splitB.length) return splitA.length - splitB.length;
            else return compareByIndexDesc(last(splitA), last(splitB));
        });
    const partitionOps = (arr, fns)=>{
        const initArr = Array(fns.length + 1).fill().map(()=>[]);
        return arr.map((item)=>{
            let position = fns.map((fn)=>fn(item)).indexOf(true);
            if (position < 0) position = fns.length;
            return {
                item,
                position
            };
        }).reduce((acc, item)=>{
            acc[item.position].push(item.item);
            return acc;
        }, initArr);
    };
    const isMoveOp = (_ref3)=>{
        let { op } = _ref3;
        return op === 'move';
    };
    const isRemoveOp = (_ref4)=>{
        let { op } = _ref4;
        return op === 'remove';
    };
    const reorderOps = (diff)=>{
        const [moveOps, removedOps, restOps] = partitionOps(diff, [
            isMoveOp,
            isRemoveOp
        ]);
        const removeOpsReverse = opsByDescendingOrder(removedOps);
        return [
            ...removeOpsReverse,
            ...moveOps,
            ...restOps
        ];
    };
    let defaultInstance$2;
    const format$1 = (delta, left)=>{
        if (!defaultInstance$2) defaultInstance$2 = new JSONFormatter();
        return reorderOps(defaultInstance$2.format(delta, left));
    };
    const log$1 = (delta, left)=>{
        console.log(format$1(delta, left));
    };
    var jsonpatch = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        default: JSONFormatter,
        format: format$1,
        log: log$1,
        partitionOps: partitionOps
    });
    function chalkColor(name) {
        return chalk && chalk[name] || function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return args;
        };
    }
    const colors = {
        added: chalkColor('green'),
        deleted: chalkColor('red'),
        movedestination: chalkColor('gray'),
        moved: chalkColor('yellow'),
        unchanged: chalkColor('gray'),
        error: chalkColor('white.bgRed'),
        textDiffLine: chalkColor('gray')
    };
    class ConsoleFormatter extends BaseFormatter {
        prepareContext(context) {
            super.prepareContext(context);
            context.indent = function(levels) {
                this.indentLevel = (this.indentLevel || 0) + (typeof levels === 'undefined' ? 1 : levels);
                this.indentPad = new Array(this.indentLevel + 1).join('  ');
                this.outLine();
            };
            context.outLine = function() {
                this.buffer.push(`\n${this.indentPad || ''}`);
            };
            context.out = function() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                for(let i = 0, l = args.length; i < l; i++){
                    const lines = args[i].split('\n');
                    let text = lines.join(`\n${this.indentPad || ''}`);
                    if (this.color && this.color[0]) text = this.color[0](text);
                    this.buffer.push(text);
                }
            };
            context.pushColor = function(color) {
                this.color = this.color || [];
                this.color.unshift(color);
            };
            context.popColor = function() {
                this.color = this.color || [];
                this.color.shift();
            };
        }
        typeFormattterErrorFormatter(context, err) {
            context.pushColor(colors.error);
            context.out(`[ERROR]${err}`);
            context.popColor();
        }
        formatValue(context, value) {
            context.out(JSON.stringify(value, null, 2));
        }
        formatTextDiffString(context, value) {
            const lines = this.parseTextDiff(value);
            context.indent();
            for(let i = 0, l = lines.length; i < l; i++){
                const line = lines[i];
                context.pushColor(colors.textDiffLine);
                context.out(`${line.location.line},${line.location.chr} `);
                context.popColor();
                const pieces = line.pieces;
                for(let pieceIndex = 0, piecesLength = pieces.length; pieceIndex < piecesLength; pieceIndex++){
                    const piece = pieces[pieceIndex];
                    context.pushColor(colors[piece.type]);
                    context.out(piece.text);
                    context.popColor();
                }
                if (i < l - 1) context.outLine();
            }
            context.indent(-1);
        }
        rootBegin(context, type, nodeType) {
            context.pushColor(colors[type]);
            if (type === 'node') {
                context.out(nodeType === 'array' ? '[' : '{');
                context.indent();
            }
        }
        rootEnd(context, type, nodeType) {
            if (type === 'node') {
                context.indent(-1);
                context.out(nodeType === 'array' ? ']' : '}');
            }
            context.popColor();
        }
        nodeBegin(context, key, leftKey, type, nodeType) {
            context.pushColor(colors[type]);
            context.out(`${leftKey}: `);
            if (type === 'node') {
                context.out(nodeType === 'array' ? '[' : '{');
                context.indent();
            }
        }
        nodeEnd(context, key, leftKey, type, nodeType, isLast) {
            if (type === 'node') {
                context.indent(-1);
                context.out(nodeType === 'array' ? ']' : `}${isLast ? '' : ','}`);
            }
            if (!isLast) context.outLine();
            context.popColor();
        }
        /* jshint camelcase: false */ /* eslint-disable camelcase */ format_unchanged(context, delta, left) {
            if (typeof left === 'undefined') return;
            this.formatValue(context, left);
        }
        format_movedestination(context, delta, left) {
            if (typeof left === 'undefined') return;
            this.formatValue(context, left);
        }
        format_node(context, delta, left) {
            // recurse
            this.formatDeltaChildren(context, delta, left);
        }
        format_added(context, delta) {
            this.formatValue(context, delta[0]);
        }
        format_modified(context, delta) {
            context.pushColor(colors.deleted);
            this.formatValue(context, delta[0]);
            context.popColor();
            context.out(' => ');
            context.pushColor(colors.added);
            this.formatValue(context, delta[1]);
            context.popColor();
        }
        format_deleted(context, delta) {
            this.formatValue(context, delta[0]);
        }
        format_moved(context, delta) {
            context.out(`==> ${delta[1]}`);
        }
        format_textdiff(context, delta) {
            this.formatTextDiffString(context, delta[0]);
        }
        constructor(){
            super();
            this.includeMoveDestinations = false;
        }
    }
    let defaultInstance$1;
    const format = (delta, left)=>{
        if (!defaultInstance$1) defaultInstance$1 = new ConsoleFormatter();
        return defaultInstance$1.format(delta, left);
    };
    function log(delta, left) {
        console.log(format(delta, left));
    }
    var console$1 = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        default: ConsoleFormatter,
        format: format,
        log: log
    });
    var index = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        annotated: annotated,
        base: base,
        console: console$1,
        html: html,
        jsonpatch: jsonpatch
    });
    // use as 2nd parameter for JSON.parse to revive Date instances
    function dateReviver(key, value) {
        let parts;
        if (typeof value === 'string') {
            // eslint-disable-next-line max-len
            parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d*))?(Z|([+-])(\d{2}):(\d{2}))$/.exec(value);
            if (parts) return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +(parts[7] || 0)));
        }
        return value;
    }
    function create(options) {
        return new DiffPatcher(options);
    }
    let defaultInstance;
    function diff() {
        if (!defaultInstance) defaultInstance = new DiffPatcher();
        return defaultInstance.diff.apply(defaultInstance, arguments);
    }
    function patch() {
        if (!defaultInstance) defaultInstance = new DiffPatcher();
        return defaultInstance.patch.apply(defaultInstance, arguments);
    }
    function unpatch() {
        if (!defaultInstance) defaultInstance = new DiffPatcher();
        return defaultInstance.unpatch.apply(defaultInstance, arguments);
    }
    function reverse() {
        if (!defaultInstance) defaultInstance = new DiffPatcher();
        return defaultInstance.reverse.apply(defaultInstance, arguments);
    }
    function clone() {
        if (!defaultInstance) defaultInstance = new DiffPatcher();
        return defaultInstance.clone.apply(defaultInstance, arguments);
    }
    exports1.DiffPatcher = DiffPatcher;
    exports1.clone = clone;
    exports1.console = console$1;
    exports1.create = create;
    exports1.dateReviver = dateReviver;
    exports1.diff = diff;
    exports1.formatters = index;
    exports1.patch = patch;
    exports1.reverse = reverse;
    exports1.unpatch = unpatch;
});

},{"b49006919fb380e0":"hbA2n"}],"hbA2n":[function(require,module,exports,__globalThis) {

},{}],"kReks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audioPatchStateCreator", ()=>audioPatchStateCreator);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _patch = require("@web-noise/patch");
var _compareGraphs = require("./compareGraphs");
const audioPatchStateCreator = (set, get)=>({
        patch: (0, _patch.createPatch)(),
        nodesState: {}
    });
const audioPatch = (config)=>(set, get, api)=>{
        api.subscribe(async (state, prevState)=>{});
        const promises = new Set();
        let currentState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, get()), {
            nodes: [],
            edges: []
        });
        return config(async (...args)=>{
            const oldState = get();
            const [storeChanges] = args;
            //@ts-ignore
            const newState = (0, _objectSpread._)({}, currentState, typeof storeChanges === "function" ? storeChanges((0, _objectSpread._)({}, currentState)) : storeChanges);
            const nodeChanges = (0, _compareGraphs.compareGraphs)(currentState.nodes, newState.nodes);
            const edgeChanges = (0, _compareGraphs.compareGraphs)(currentState.edges, newState.edges);
            //@ts-ignore
            currentState = newState;
            const newNodes = nodeChanges.added;
            const newEdges = edgeChanges.added;
            const removedEdges = edgeChanges.removed;
            const removedNodes = nodeChanges.removed;
            const { patch } = oldState;
            if (newNodes.length) {
                const promise = patch.registerAudioNodes(//@ts-ignore
                newNodes);
                promises.add(promise);
                await promise;
                promises.delete(promise);
            }
            if (!(newEdges.length || removedEdges.length || removedNodes.length)) {
                set(...args);
                return;
            }
            if (promises.size) try {
                await Promise.all([
                    ...promises.values()
                ]);
            } catch (e) {
                console.log("some error", e);
            }
            if (newEdges.length) patch.registerAudioConnections(//@ts-ignore
            newEdges);
            if (removedEdges.length) //@ts-ignore
            patch.unregisterAudioConnections(removedEdges);
            if (removedNodes.length) //@ts-ignore
            patch.unregisterAudioNodes(removedNodes);
            set(...args);
        }, get, api);
    };
exports.default = audioPatch;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/patch":"8lm4y","./compareGraphs":"619FZ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"619FZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareGraphs", ()=>compareGraphs);
const compareGraphs = (left, right)=>{
    const setLeft = new Set(left.map((item)=>item.id));
    const setRight = new Set(right.map((item)=>item.id));
    const added = right.filter((item)=>!setLeft.has(item.id));
    const removed = left.filter((item)=>!setRight.has(item.id));
    return {
        added,
        removed
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"baxEl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _projectFile = require("../helpers/projectFile");
const projectStateCreator = (set, get)=>({
        project: {
            files: []
        },
        setProject (project) {
            set({
                project,
                currentFileIndex: 0
            });
        },
        getProject () {
            return get().project;
        },
        pullEditorChanges () {
            const { getEditorState, currentFileIndex, updateFileContent, project } = get();
            const currentFile = project.files[currentFileIndex];
            if ((0, _projectFile.isAudio)(currentFile)) return;
            updateFileContent(currentFileIndex, (0, _objectSpreadProps._)((0, _objectSpread._)({}, currentFile), {
                file: getEditorState()
            }));
        },
        syncEditorWithCurrentFile: ()=>{
            const { currentFileIndex, setEditorState, project } = get();
            const currentFile = project.files[currentFileIndex];
            if (currentFile.type === "audio") {
                console.log("audio file. skipping");
                return;
            }
            setEditorState(currentFile.file);
        },
        currentFileIndex: 0,
        setCurrentFileIndex (newFileIndex) {
            const { currentFileIndex } = get();
            if (newFileIndex === currentFileIndex) return;
            set({
                currentFileIndex: newFileIndex
            });
        },
        updateFileContent (index, file) {
            const { project } = get();
            set({
                project: (0, _objectSpreadProps._)((0, _objectSpread._)({}, project), {
                    files: project.files.map((f, i)=>{
                        if (i === index) return (0, _objectSpread._)({}, f, file);
                        return f;
                    })
                })
            });
        },
        updateFileName (index, fileName) {
            const { project } = get();
            set({
                project: (0, _objectSpreadProps._)((0, _objectSpread._)({}, project), {
                    files: project.files.map((f, i)=>{
                        if (i === index) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, f), {
                            name: fileName
                        });
                        return f;
                    })
                })
            });
        },
        addFile (file) {
            const { project } = get();
            const files = [
                ...project.files,
                file
            ];
            set({
                project: (0, _objectSpreadProps._)((0, _objectSpread._)({}, project), {
                    files
                })
            });
        },
        deleteFile: (fileIndex)=>{
            const { project, currentFileIndex } = get();
            set({
                project: (0, _objectSpreadProps._)((0, _objectSpread._)({}, project), {
                    files: project.files.filter((_, index)=>fileIndex !== index)
                })
            });
            if (fileIndex <= currentFileIndex) set({
                currentFileIndex: currentFileIndex - 1
            });
        }
    });
exports.default = projectStateCreator;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","../helpers/projectFile":"5XyWl","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5XyWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPatch", ()=>isPatch);
parcelHelpers.export(exports, "isAudio", ()=>isAudio);
const isPatch = (file)=>!("type" in file) || file.type === "patch";
const isAudio = (file)=>file.type === "audio";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kNWlF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _css = require("@emotion/css");
var _theme = require("./theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
let _ = (t)=>t, t;
(0, _css.injectGlobal)(t || (t = _`
  .react-flow {
    .react-flow__pane {
    /* background: rgb(106 106 106); */
    /* background: "white"; */
    // background: #292d39;
      background: ${0};
    }

    .react-flow__background {
      /* background: #efefef; */
      stroke: white;
    }

    .react-flow__node-default {
      background: #292d39;
      color: white;
      border: none;
      /* background: transparent; */
    }

    .react-flow__node {
      padding: 0;
      width: auto;
    }

    .react-flow__edge-path {
      stroke:  ${0};
    }

    .react-flow__node.selected {
      border: 1px solid ${0};
      box-shadow: 0 0 0 0.5px #${0};
    }

    .react-flow__node-default.selected, .react-flow__node-default.selected:hover {
      box-shadow: 0 0 0 0.5px #${0};
    }

    /* .react-flow__minimap-mask {
      fill: ${0}
    }

    .react-flow__minimap-node {
      fill:${0}
    } */
  }

`), (0, _themeDefault.default).colors.elevation3, (0, _themeDefault.default).colors.accent2, (0, _themeDefault.default).colors.accent2, (0, _themeDefault.default).colors.accent2, (0, _themeDefault.default).colors.accent2, (0, _themeDefault.default).colors.elevation1, (0, _themeDefault.default).colors.accent2);

},{"@emotion/css":"60PCP","./theme":"1PEzg","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"60PCP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cache", ()=>cache);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "cx", ()=>cx);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "injectGlobal", ()=>injectGlobal);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "sheet", ()=>sheet);
var _emotionCssCreateInstanceEsmJs = require("../create-instance/dist/emotion-css-create-instance.esm.js");
var _emotionCssCreateInstanceEsmJsDefault = parcelHelpers.interopDefault(_emotionCssCreateInstanceEsmJs);
var _cache = require("@emotion/cache");
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
var _createEmotion = (0, _emotionCssCreateInstanceEsmJsDefault.default)({
    key: 'css'
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

},{"../create-instance/dist/emotion-css-create-instance.esm.js":"asCM9","@emotion/cache":"eMGpJ","@emotion/serialize":"2Hw4L","@emotion/utils":"gQqrm","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"asCM9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createEmotion);
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _serialize = require("@emotion/serialize");
var _utils = require("@emotion/utils");
function insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var createEmotion = function createEmotion(options) {
    var cache = (0, _cacheDefault.default)(options);
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered, undefined);
        (0, _utils.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return merge(cache.registered, css, classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, _utils.getRegisteredStyles).bind(null, cache.registered),
        merge: merge.bind(null, cache.registered, css)
    };
};
var classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};

},{"@emotion/cache":"eMGpJ","@emotion/serialize":"2Hw4L","@emotion/utils":"gQqrm","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1PEzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const LEVA_COLOR_ACCENT2_BLUE = "#007bff";
const COLOR_GREEN_PRIMARY = "#14df42";
const COLOR_WHITE_PRIMARY = "#ffffff";
const colors = {
    elevation1: "#292d39",
    elevation2: "#181c20",
    elevation3: "#373c4b",
    accent1: "#0066dc",
    accent2: LEVA_COLOR_ACCENT2_BLUE,
    accent3: "#3c93ff",
    highlight1: "#535760",
    highlight2: "#8c92a4",
    highlight3: "#fefefe",
    vivid1: COLOR_GREEN_PRIMARY,
    whitePrimary: COLOR_WHITE_PRIMARY,
    error: "#db5353"
};
const zIndex = {
    modal: 9998,
    controlPanel: 9999,
    resumeContextLayout: 10003
};
const theme = {
    colors,
    zIndex
};
exports.default = theme;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"CLdHS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditorPane", ()=>EditorPane);
parcelHelpers.export(exports, "Editor", ()=>Editor);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactflow = require("reactflow");
var _reactflowDefault = parcelHelpers.interopDefault(_reactflow);
var _styleCss = require("reactflow/dist/style.css");
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _edgeContextMenu = require("../contextMenu/EdgeContextMenu");
var _edgeContextMenuDefault = parcelHelpers.interopDefault(_edgeContextMenu);
var _editorContextMenu = require("../contextMenu/EditorContextMenu");
var _editorContextMenuDefault = parcelHelpers.interopDefault(_editorContextMenu);
var _nodeContextMenu = require("../contextMenu/NodeContextMenu");
var _nodeContextMenuDefault = parcelHelpers.interopDefault(_nodeContextMenu);
var _controlPanel = require("../ControlPanel");
var _controlPanelDefault = parcelHelpers.interopDefault(_controlPanel);
var _help = require("../Help");
var _resumeContext = require("../ResumeContext");
var _resumeContextDefault = parcelHelpers.interopDefault(_resumeContext);
var _toggleMinimap = require("../ToggleMinimap");
var _toggleMinimapDefault = parcelHelpers.interopDefault(_toggleMinimap);
var _wire = require("../Wire");
var _wireDefault = parcelHelpers.interopDefault(_wire);
const onNodeDragStop = (_event, node)=>console.log("drag stop", node);
const onNodeClick = (_event, element)=>console.log("click", element);
const snapGrid = [
    20,
    20
];
const EditorPane = (_param)=>{
    var { editorState, plugins = [], editorContextMenu = [], onChange = ()=>{} } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "editorState",
        "plugins",
        "editorContextMenu",
        "onChange"
    ]);
    const edgeTypes = (0, _react.useMemo)(()=>({
            wire: (0, _wireDefault.default)
        }), []);
    const { nodes, edges, controlPanel, onNodesChange, onNodesDelete, onEdgesChange, onEdgesDelete, onConnect, setPlugins, setViewport, viewport } = (0, _storeDefault.default)();
    const editorConfig = (0, _storeDefault.default)(({ config })=>config);
    const nodeTypes = (0, _storeDefault.default)(({ nodeTypes })=>nodeTypes);
    (0, _react.useEffect)(()=>{
        setPlugins(plugins);
    }, [
        plugins
    ]);
    const [reactflowInstance, setReactflowInstance] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (!reactflowInstance) return;
        onChange({
            nodes,
            edges,
            controlPanel,
            viewport
        });
    }, [
        nodes,
        edges,
        controlPanel,
        viewport
    ]);
    const onInit = (0, _react.useCallback)((rfi)=>{
        if (!reactflowInstance) {
            setReactflowInstance(rfi);
            console.log("flow loaded:", rfi);
        }
    }, [
        reactflowInstance
    ]);
    const { onContextMenu: onEditorContextMenu } = (0, _editorContextMenu.useEditorContextMenu)();
    const { onContextMenu: onNodeContextMenu } = (0, _nodeContextMenu.useNodeContextMenu)();
    const { onContextMenu: onEdgeContextMenu } = (0, _edgeContextMenu.useEdgeContextMenu)();
    (0, _react.useEffect)(()=>{
        if (!viewport) return;
        reactflowInstance === null || reactflowInstance === void 0 ? void 0 : reactflowInstance.setViewport(viewport);
    }, [
        viewport,
        reactflowInstance
    ]);
    (0, _reactflow.useOnViewportChange)({
        onEnd: setViewport
    });
    return (0, _jsxRuntime.jsxs)((0, _reactflowDefault.default), {
        nodes: nodes,
        edges: edges,
        onNodesChange: onNodesChange,
        onNodesDelete: onNodesDelete,
        onEdgesChange: onEdgesChange,
        onConnect: onConnect,
        onNodeDragStop: onNodeDragStop,
        onEdgesDelete: onEdgesDelete,
        onInit: onInit,
        onNodeClick: onNodeClick,
        onContextMenu: onEditorContextMenu,
        onNodeContextMenu: onNodeContextMenu,
        onEdgeContextMenu: onEdgeContextMenu,
        nodeTypes: nodeTypes,
        edgeTypes: edgeTypes,
        snapGrid: snapGrid,
        defaultViewport: editorState === null || editorState === void 0 ? void 0 : editorState.viewport,
        defaultEdgeOptions: {
            type: "wire"
        },
        snapToGrid: true,
        fitView: true,
        disableKeyboardA11y: true,
        children: [
            (0, _jsxRuntime.jsx)((0, _reactflow.Background), {
                variant: (0, _reactflow.BackgroundVariant).Dots,
                gap: 12
            }),
            editorConfig.showMinimap ? (0, _jsxRuntime.jsx)((0, _reactflow.MiniMap), {}) : null,
            (0, _jsxRuntime.jsxs)((0, _reactflow.Controls), {
                style: {
                    right: "1rem",
                    left: "initial",
                    bottom: "40%",
                    top: "initial"
                },
                showInteractive: false,
                children: [
                    (0, _jsxRuntime.jsx)((0, _toggleMinimapDefault.default), {}),
                    (0, _jsxRuntime.jsx)((0, _help.HelpButton), {})
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _resumeContextDefault.default), {}),
            (0, _jsxRuntime.jsx)((0, _controlPanelDefault.default), {}),
            (0, _jsxRuntime.jsx)((0, _help.HelpModal), {}),
            (0, _jsxRuntime.jsx)((0, _editorContextMenuDefault.default), {
                editorContextMenu: editorContextMenu
            }),
            (0, _jsxRuntime.jsx)((0, _nodeContextMenuDefault.default), {}),
            (0, _jsxRuntime.jsx)((0, _edgeContextMenuDefault.default), {})
        ]
    });
};
const Editor = (props)=>(0, _jsxRuntime.jsx)((0, _reactflow.ReactFlowProvider), {
        children: (0, _jsxRuntime.jsx)(EditorPane, (0, _objectSpread._)({}, props))
    });
exports.default = Editor;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","react":"lXMxO","reactflow":"eL4zf","reactflow/dist/style.css":"3T38Z","../../store":"eveyc","../contextMenu/EdgeContextMenu":"eU6Aj","../contextMenu/EditorContextMenu":"8JCPh","../contextMenu/NodeContextMenu":"2DY4o","../ControlPanel":"jZAKX","../Help":"1wM0n","../ResumeContext":"7zlhJ","../ToggleMinimap":"6eT7I","../Wire":"dI0TN","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3T38Z":[function() {},{}],"eU6Aj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MENU_ID", ()=>MENU_ID);
parcelHelpers.export(exports, "useEdgeContextMenu", ()=>useEdgeContextMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactContexify = require("react-contexify");
var _reactContexifyCss = require("react-contexify/dist/ReactContexify.css");
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _styles = require("./styles");
const MENU_ID = "editor-edge-menu";
const useEdgeContextMenu = ()=>{
    const { show } = (0, _reactContexify.useContextMenu)({
        id: MENU_ID
    });
    const onContextMenu = (0, _react.useCallback)((event, edge)=>{
        event.stopPropagation();
        show(event, {
            props: {
                edge
            }
        });
    }, [
        show
    ]);
    return {
        onContextMenu
    };
};
const EdgeContextMenu = ()=>{
    const theme = (0, _useThemeDefault.default)();
    const removeEdges = (0, _storeDefault.default)((store)=>store.removeEdges);
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _jsxRuntime.jsx)((0, _styles.MenuWrapper), {
            id: MENU_ID,
            animation: false,
            colors: theme.colors,
            children: (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                onClick: (event)=>removeEdges([
                        event.props.edge
                    ]),
                children: "Delete Edge (DEL)"
            })
        })
    });
};
exports.default = EdgeContextMenu;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","react-contexify":"cYVur","react-contexify/dist/ReactContexify.css":"3Ta3m","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","./styles":"ifkCY","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cYVur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", ()=>Item);
parcelHelpers.export(exports, "Menu", ()=>Menu);
parcelHelpers.export(exports, "Separator", ()=>Separator);
parcelHelpers.export(exports, "Submenu", ()=>Submenu);
parcelHelpers.export(exports, "animation", ()=>animation);
parcelHelpers.export(exports, "contextMenu", ()=>contextMenu);
parcelHelpers.export(exports, "theme", ()=>theme);
parcelHelpers.export(exports, "useContextMenu", ()=>useContextMenu);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Context = /*#__PURE__*/ (0, _react.createContext)({});
/**
 * Access parent ref tracker.
 */ function useRefTrackerContext() {
    return (0, _react.useContext)(Context);
}
var RefTrackerProvider = function RefTrackerProvider(props) {
    return (0, _reactDefault.default).createElement(Context.Provider, {
        value: props.refTracker
    }, props.children);
};
function createEventManager() {
    var eventList = new Map();
    return {
        on: function on(event, handler) {
            var _eventList$get;
            //eslint-disable-next-line @typescript-eslint/no-unused-expressions
            eventList.has(event) ? (_eventList$get = eventList.get(event)) == null || _eventList$get.add(handler) : eventList.set(event, new Set([
                handler
            ]));
            return this;
        },
        off: function off(event, handler) {
            handler ? eventList.get(event)["delete"](handler) : eventList["delete"](event);
            return this;
        },
        emit: function emit(event, args) {
            var currentEv = event;
            if (!eventList.has(event) && currentEv !== 0) console.error("It seems that the menu you are trying to display is not renderer or you have a menu id mismatch.", "You used the menu id: " + event);
            eventList.has(event) && eventList.get(event).forEach(function(handler) {
                handler(args);
            });
            return this;
        }
    };
}
var eventManager = /*#__PURE__*/ createEventManager();
function usePrevious(value) {
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
/**
 * Used to store children refs
 */ function useRefTracker() {
    return (0, _react.useRef)(new Map()).current;
}
var contextMenu = {
    show: function show(_ref) {
        var id = _ref.id, event = _ref.event, props = _ref.props, position = _ref.position;
        if (event.preventDefault) event.preventDefault();
        eventManager.emit(0).emit(id, {
            event: event.nativeEvent || event,
            props: props,
            position: position
        });
    },
    hideAll: function hideAll() {
        eventManager.emit(0);
    }
};
function useContextMenu(props) {
    return {
        show: function show(event, params) {
            contextMenu.show({
                id: (params == null ? void 0 : params.id) || (props == null ? void 0 : props.id),
                props: (params == null ? void 0 : params.props) || (props == null ? void 0 : props.props),
                event: event,
                position: params == null ? void 0 : params.position
            });
        },
        hideAll: function hideAll() {
            contextMenu.hideAll();
        }
    };
}
/**
 * Used to control keyboard navigation
 */ function createMenuController() {
    var menuList = new Map();
    var focusedIndex;
    var parentNode;
    var isAtRoot;
    var currentItems;
    var forceCloseSubmenu = false;
    function init(rootMenu) {
        currentItems = rootMenu;
        focusedIndex = -1;
        isAtRoot = true;
    }
    function focusSelectedItem() {
        currentItems[focusedIndex].node.focus();
    }
    function isSubmenuFocused() {
        return focusedIndex >= 0 && currentItems[focusedIndex].isSubmenu;
    }
    function getSubmenuItems() {
        return Array.from(currentItems[focusedIndex].submenuRefTracker.values());
    }
    function isFocused() {
        if (focusedIndex === -1) {
            // focus first item
            moveDown();
            return false;
        }
        return true;
    }
    function moveDown() {
        if (focusedIndex + 1 < currentItems.length) focusedIndex++;
        else if (focusedIndex + 1 === currentItems.length) focusedIndex = 0;
        if (forceCloseSubmenu) closeSubmenu();
        focusSelectedItem();
    }
    function moveUp() {
        if (focusedIndex === -1 || focusedIndex === 0) focusedIndex = currentItems.length - 1;
        else if (focusedIndex - 1 < currentItems.length) focusedIndex--;
        if (forceCloseSubmenu) closeSubmenu();
        focusSelectedItem();
    }
    function openSubmenu() {
        if (isFocused() && isSubmenuFocused()) {
            var submenuItems = getSubmenuItems();
            var currentNode = currentItems[focusedIndex].node;
            menuList.set(currentNode, {
                isRoot: isAtRoot,
                focusedIndex: focusedIndex,
                parentNode: parentNode || currentNode,
                items: currentItems
            });
            currentNode.classList.add("react-contexify__submenu--is-open");
            parentNode = currentNode;
            if (submenuItems.length > 0) {
                focusedIndex = 0;
                currentItems = submenuItems;
            } else forceCloseSubmenu = true;
            isAtRoot = false;
            focusSelectedItem();
            return true;
        }
        return false;
    }
    function closeSubmenu() {
        if (isFocused() && !isAtRoot) {
            var _menuList$get = menuList.get(parentNode), isRoot = _menuList$get.isRoot, items = _menuList$get.items, parentFocusedIndex = _menuList$get.focusedIndex, menuParentNode = _menuList$get.parentNode;
            parentNode.classList.remove("react-contexify__submenu--is-open");
            currentItems = items;
            parentNode = menuParentNode;
            if (isRoot) {
                isAtRoot = true;
                menuList.clear();
            }
            if (!forceCloseSubmenu) {
                focusedIndex = parentFocusedIndex;
                focusSelectedItem();
            }
        }
    }
    return {
        init: init,
        moveDown: moveDown,
        moveUp: moveUp,
        openSubmenu: openSubmenu,
        closeSubmenu: closeSubmenu
    };
}
var theme = {
    light: 'light',
    dark: 'dark'
};
var animation = {
    fade: 'fade',
    flip: 'flip',
    scale: 'scale',
    slide: 'slide'
};
var NOOP = function NOOP() {};
function isFn(v) {
    return typeof v === 'function';
}
function isStr(v) {
    return typeof v === 'string';
}
function isTouchEvent(e) {
    return e.type === 'touchend';
}
function cloneItems(children, props) {
    return (0, _react.Children).map((0, _react.Children).toArray(children).filter(Boolean), function(item) {
        return (0, _react.cloneElement)(item, props);
    });
}
function getMousePosition(e) {
    var pos = {
        x: 0,
        y: 0
    };
    if (isTouchEvent(e) && e.changedTouches && e.changedTouches.length > 0) {
        pos.x = e.changedTouches[0].clientX;
        pos.y = e.changedTouches[0].clientY;
    } else {
        pos.x = e.clientX;
        pos.y = e.clientY;
    }
    if (!pos.x || pos.x < 0) pos.x = 0;
    if (!pos.y || pos.y < 0) pos.y = 0;
    return pos;
}
function getPredicateValue(predicate, payload) {
    return isFn(predicate) ? predicate(payload) : predicate;
}
function hasExitAnimation(animation) {
    return !!(animation && (isStr(animation) || 'exit' in animation && animation.exit));
}
function reducer(state, payload) {
    return isFn(payload) ? _extends({}, state, payload(state)) : _extends({}, state, payload);
}
var Menu = function Menu(_ref) {
    var _cx3;
    var id = _ref.id, theme = _ref.theme, style = _ref.style, className = _ref.className, children = _ref.children, _ref$animation = _ref.animation, animation = _ref$animation === void 0 ? 'scale' : _ref$animation, _ref$onHidden = _ref.onHidden, onHidden = _ref$onHidden === void 0 ? NOOP : _ref$onHidden, _ref$onShown = _ref.onShown, onShown = _ref$onShown === void 0 ? NOOP : _ref$onShown, rest = _objectWithoutPropertiesLoose(_ref, [
        "id",
        "theme",
        "style",
        "className",
        "children",
        "animation",
        "onHidden",
        "onShown"
    ]);
    var _useReducer = (0, _react.useReducer)(reducer, {
        x: 0,
        y: 0,
        visible: false,
        triggerEvent: {},
        propsFromTrigger: null,
        willLeave: false
    }), state = _useReducer[0], setState = _useReducer[1];
    var nodeRef = (0, _react.useRef)(null);
    var didMount = (0, _react.useRef)(false);
    var wasVisible = usePrevious(state.visible);
    var refTracker = useRefTracker();
    var _useState = (0, _react.useState)(function() {
        return createMenuController();
    }), menuController = _useState[0]; // subscribe event manager
    (0, _react.useEffect)(function() {
        didMount.current = true;
        eventManager.on(id, show).on(0, hide);
        return function() {
            eventManager.off(id, show).off(0, hide);
        }; // hide rely on setState(dispatch), which is guaranted to be the same across render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]); // handle show/ hide callback
    (0, _react.useEffect)(function() {
        if (didMount.current && state.visible !== wasVisible) state.visible ? onShown() : onHidden();
         // wasWisible is a ref
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.visible,
        onHidden,
        onShown
    ]); // collect menu items for keyboard navigation
    (0, _react.useEffect)(function() {
        if (!state.visible) refTracker.clear();
        else menuController.init(Array.from(refTracker.values()));
    }, [
        state.visible,
        menuController,
        refTracker
    ]); // compute menu position
    (0, _react.useEffect)(function() {
        if (state.visible) {
            var _window = window, windowWidth = _window.innerWidth, windowHeight = _window.innerHeight;
            var _nodeRef$current = nodeRef.current, menuWidth = _nodeRef$current.offsetWidth, menuHeight = _nodeRef$current.offsetHeight;
            var _x = state.x, _y = state.y;
            if (_x + menuWidth > windowWidth) _x -= _x + menuWidth - windowWidth;
            if (_y + menuHeight > windowHeight) _y -= _y + menuHeight - windowHeight;
            setState({
                x: _x,
                y: _y
            });
        } // state.visible and state{x,y} are updated together
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.visible
    ]); // subscribe dom events
    (0, _react.useEffect)(function() {
        function handleKeyboard(e) {
            e.preventDefault();
            switch(e.key){
                case 'Enter':
                    if (!menuController.openSubmenu()) hide();
                    break;
                case 'Escape':
                    hide();
                    break;
                case 'ArrowUp':
                    menuController.moveUp();
                    break;
                case 'ArrowDown':
                    menuController.moveDown();
                    break;
                case 'ArrowRight':
                    menuController.openSubmenu();
                    break;
                case 'ArrowLeft':
                    menuController.closeSubmenu();
                    break;
            }
        }
        if (state.visible) {
            window.addEventListener('resize', hide);
            window.addEventListener('contextmenu', hide);
            window.addEventListener('click', hide);
            window.addEventListener('scroll', hide);
            window.addEventListener('keydown', handleKeyboard); // This let us debug the menu in the console in dev mode
            window.addEventListener('blur', hide);
        }
        return function() {
            window.removeEventListener('resize', hide);
            window.removeEventListener('contextmenu', hide);
            window.removeEventListener('click', hide);
            window.removeEventListener('scroll', hide);
            window.removeEventListener('keydown', handleKeyboard);
            window.removeEventListener('blur', hide);
        }; // state.visible will let us get the right reference to `hide`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.visible,
        menuController
    ]);
    function show(_ref2) {
        var event = _ref2.event, props = _ref2.props, position = _ref2.position;
        event.stopPropagation();
        var _ref3 = position || getMousePosition(event), x = _ref3.x, y = _ref3.y; // prevent react from batching the state update
        // if the menu is already visible we have to recompute bounding rect based on position
        setTimeout(function() {
            setState({
                visible: true,
                willLeave: false,
                x: x,
                y: y,
                triggerEvent: event,
                propsFromTrigger: props
            });
        }, 0);
    }
    function hide(event) {
        // Safari trigger a click event when you ctrl + trackpad
        // Firefox:  trigger a click event when right click occur
        var e = event;
        if (typeof e !== 'undefined' && (e.button === 2 || e.ctrlKey === true) && e.type !== 'contextmenu') return;
        hasExitAnimation(animation) ? setState(function(state) {
            return {
                willLeave: state.visible
            };
        }) : setState(function(state) {
            return {
                visible: state.visible ? false : state.visible
            };
        });
    }
    function handleAnimationEnd() {
        if (state.willLeave && state.visible) setState({
            visible: false,
            willLeave: false
        });
    }
    function computeAnimationClasses() {
        if (!animation) return null;
        if (isStr(animation)) {
            var _cx;
            return (0, _clsxDefault.default)((_cx = {}, _cx["react-contexify__will-enter--" + animation] = animation && visible && !willLeave, _cx["react-contexify__will-leave--" + animation + " " + "react-contexify__will-leave--" + "'disabled'"] = animation && visible && willLeave, _cx));
        } else if ('enter' in animation && 'exit' in animation) {
            var _cx2;
            return (0, _clsxDefault.default)((_cx2 = {}, _cx2["react-contexify__will-enter--" + animation.enter] = animation.enter && visible && !willLeave, _cx2["react-contexify__will-leave--" + animation.exit + " " + "react-contexify__will-leave--" + "'disabled'"] = animation.exit && visible && willLeave, _cx2));
        }
        return null;
    }
    var visible = state.visible, triggerEvent = state.triggerEvent, propsFromTrigger = state.propsFromTrigger, x = state.x, y = state.y, willLeave = state.willLeave;
    var cssClasses = (0, _clsxDefault.default)("react-contexify", className, (_cx3 = {}, _cx3["react-contexify__theme--" + theme] = theme, _cx3), computeAnimationClasses());
    var menuStyle = _extends({}, style, {
        left: x,
        top: y,
        opacity: 1
    });
    return (0, _reactDefault.default).createElement(RefTrackerProvider, {
        refTracker: refTracker
    }, visible && (0, _reactDefault.default).createElement("div", Object.assign({}, rest, {
        className: cssClasses,
        onAnimationEnd: handleAnimationEnd,
        style: menuStyle,
        ref: nodeRef,
        role: "menu"
    }), cloneItems(children, {
        propsFromTrigger: propsFromTrigger,
        triggerEvent: triggerEvent
    })));
};
var Item = function Item(_ref) {
    var _cx;
    var children = _ref.children, className = _ref.className, style = _ref.style, triggerEvent = _ref.triggerEvent, data = _ref.data, propsFromTrigger = _ref.propsFromTrigger, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? NOOP : _ref$onClick, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, rest = _objectWithoutPropertiesLoose(_ref, [
        "children",
        "className",
        "style",
        "triggerEvent",
        "data",
        "propsFromTrigger",
        "onClick",
        "disabled",
        "hidden"
    ]);
    var refTracker = useRefTrackerContext();
    var handlerParams = {
        data: data,
        triggerEvent: triggerEvent,
        props: propsFromTrigger
    };
    var isDisabled = getPredicateValue(disabled, handlerParams);
    var isHidden = getPredicateValue(hidden, handlerParams);
    function handleClick(e) {
        handlerParams.event = e;
        isDisabled ? e.stopPropagation() : onClick(handlerParams);
    }
    function trackRef(node) {
        if (node && !isDisabled) refTracker.set(node, {
            node: node,
            isSubmenu: false
        });
    }
    function handleKeyDown(e) {
        if (e.key === 'Enter') {
            handlerParams.event = e;
            onClick(handlerParams);
        }
    }
    if (isHidden) return null;
    var cssClasses = (0, _clsxDefault.default)("react-contexify__item", className, (_cx = {}, _cx["react-contexify__item--disabled"] = isDisabled, _cx));
    return (0, _reactDefault.default).createElement("div", Object.assign({}, rest, {
        className: cssClasses,
        style: style,
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        ref: trackRef,
        tabIndex: -1,
        role: "menuitem",
        "aria-disabled": isDisabled
    }), (0, _reactDefault.default).createElement("div", {
        className: "react-contexify__item__content"
    }, children));
};
function Separator() {
    return (0, _reactDefault.default).createElement("div", {
        className: "react-contexify__separator"
    });
}
var Submenu = function Submenu(_ref) {
    var _cx;
    var _ref$arrow = _ref.arrow, arrow = _ref$arrow === void 0 ? "\u25B6" : _ref$arrow, children = _ref.children, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, label = _ref.label, className = _ref.className, triggerEvent = _ref.triggerEvent, propsFromTrigger = _ref.propsFromTrigger, style = _ref.style, rest = _objectWithoutPropertiesLoose(_ref, [
        "arrow",
        "children",
        "disabled",
        "hidden",
        "label",
        "className",
        "triggerEvent",
        "propsFromTrigger",
        "style"
    ]);
    var menuRefTracker = useRefTrackerContext();
    var refTracker = useRefTracker();
    var nodeRef = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)({
        left: '100%',
        top: 0,
        bottom: 'initial'
    }), position = _useState[0], setPosition = _useState[1];
    var handlerParams = {
        triggerEvent: triggerEvent,
        props: propsFromTrigger
    };
    var isDisabled = getPredicateValue(disabled, handlerParams);
    var isHidden = getPredicateValue(hidden, handlerParams);
    (0, _react.useEffect)(function() {
        if (nodeRef.current) {
            var _window = window, innerWidth = _window.innerWidth, innerHeight = _window.innerHeight;
            var rect = nodeRef.current.getBoundingClientRect();
            var _style = {};
            if (rect.right < innerWidth) {
                _style.left = '100%';
                _style.right = undefined;
            } else {
                _style.right = '100%';
                _style.left = undefined;
            }
            if (rect.bottom > innerHeight) {
                _style.bottom = 0;
                _style.top = 'initial';
            } else _style.bottom = 'initial';
            setPosition(_style);
        }
    }, []);
    function handleClick(e) {
        e.stopPropagation();
    }
    function trackRef(node) {
        if (node && !isDisabled) menuRefTracker.set(node, {
            node: node,
            isSubmenu: true,
            submenuRefTracker: refTracker
        });
    }
    if (isHidden) return null;
    var cssClasses = (0, _clsxDefault.default)("react-contexify__item", className, (_cx = {}, _cx["react-contexify__item--disabled"] = isDisabled, _cx));
    var submenuStyle = _extends({}, style, position);
    return (0, _reactDefault.default).createElement(RefTrackerProvider, {
        refTracker: refTracker
    }, (0, _reactDefault.default).createElement("div", Object.assign({}, rest, {
        className: cssClasses,
        ref: trackRef,
        tabIndex: -1,
        role: "menuitem",
        "aria-haspopup": true,
        "aria-disabled": isDisabled
    }), (0, _reactDefault.default).createElement("div", {
        className: "react-contexify__item__content",
        onClick: handleClick
    }, label, (0, _reactDefault.default).createElement("span", {
        className: "react-contexify__submenu-arrow"
    }, arrow)), (0, _reactDefault.default).createElement("div", {
        className: "react-contexify react-contexify__submenu",
        ref: nodeRef,
        style: submenuStyle
    }, cloneItems(children, {
        propsFromTrigger: propsFromTrigger,
        // injected by the parent
        triggerEvent: triggerEvent
    }))));
};

},{"react":"lXMxO","clsx":"jz84V","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jz84V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3Ta3m":[function() {},{}],"kxvkQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("@emotion/react");
const useTheme = ()=>{
    return (0, _react.useTheme)();
};
exports.default = useTheme;

},{"@emotion/react":"ifT37","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ifkCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemWrapper", ()=>ItemWrapper);
parcelHelpers.export(exports, "MenuWrapper", ()=>MenuWrapper);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _reactContexify = require("react-contexify");
var _reactContexifyCss = require("react-contexify/dist/ReactContexify.css");
let _ = (t)=>t, t, t1;
const ItemWrapper = (0, _styledDefault.default)((0, _reactContexify.Item))(t || (t = _``));
const MenuWrapper = (0, _styledDefault.default)((0, _reactContexify.Menu))(t1 || (t1 = _`
  background: ${0};
  padding: 0;
  border-radius: 0;

  .react-contexify__item__content {
    color: ${0};
  }

  .react-contexify__separator {
    background-color: ${0};
    margin: 0;
  }
`), ({ colors })=>colors.elevation2, ({ colors })=>colors.whitePrimary, ({ colors })=>colors.elevation1);

},{"@emotion/styled":"2Zr0D","react-contexify":"cYVur","react-contexify/dist/ReactContexify.css":"3Ta3m","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3Ta3m":[function() {},{}],"8JCPh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MENU_ID", ()=>MENU_ID);
parcelHelpers.export(exports, "useEditorContextMenu", ()=>useEditorContextMenu);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _jsFileDownload = require("js-file-download");
var _jsFileDownloadDefault = parcelHelpers.interopDefault(_jsFileDownload);
var _react = require("react");
var _reactContexify = require("react-contexify");
var _reactContexifyCss = require("react-contexify/dist/ReactContexify.css");
var _reactflow = require("reactflow");
var _hotkeysJs = require("hotkeys-js");
var _hotkeysJsDefault = parcelHelpers.interopDefault(_hotkeysJs);
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _addNode = require("../AddNode");
var _addNodeDefault = parcelHelpers.interopDefault(_addNode);
var _uploadPatch = require("../UploadPatch");
var _uploadPatchDefault = parcelHelpers.interopDefault(_uploadPatch);
var _uploadProject = require("../UploadProject");
var _uploadProjectDefault = parcelHelpers.interopDefault(_uploadProject);
var _styles = require("./styles");
var _uploadAudio = require("../UploadAudio");
var _uploadAudioDefault = parcelHelpers.interopDefault(_uploadAudio);
const MENU_ID = "editor-menu";
const useEditorContextMenu = ()=>{
    const { show } = (0, _reactContexify.useContextMenu)({
        id: MENU_ID
    });
    return {
        onContextMenu: show
    };
};
const EditorContextMenu = ({ editorContextMenu = [] })=>{
    const theme = (0, _useThemeDefault.default)();
    const [mousePosition, setMousePosition] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const [showAddNode, setShowAddNode] = (0, _react.useState)(false);
    const [showUploadPatch, setShowUploadPatch] = (0, _react.useState)(false);
    const [showUploadProject, setShowUploadProject] = (0, _react.useState)(false);
    const [showUploadAudio, setShowUploadAudio] = (0, _react.useState)(false);
    const addNodeHandler = (0, _react.useCallback)((x, y)=>{
        setMousePosition({
            x,
            y
        });
        setShowAddNode(true);
    }, [
        setShowAddNode
    ]);
    const pasteBuffer = (0, _storeDefault.default)((store)=>store.pasteBuffer);
    const { screenToFlowPosition } = (0, _reactflow.useReactFlow)();
    const pasteBufferHandler = (0, _react.useCallback)((mousePosition)=>{
        const { x, y } = screenToFlowPosition(mousePosition);
        pasteBuffer(x, y);
    }, [
        setShowAddNode,
        screenToFlowPosition
    ]);
    const clearGraph = (0, _storeDefault.default)(({ clearGraph })=>clearGraph);
    const getEditorState = (0, _storeDefault.default)((store)=>store.getEditorState);
    const getProject = (0, _storeDefault.default)((store)=>store.getProject);
    const deleteAllHandler = (0, _react.useCallback)(()=>{
        clearGraph();
    }, [
        clearGraph
    ]);
    const toggleHelp = (0, _storeDefault.default)((store)=>store.toggleHelp);
    const historyBack = (0, _storeDefault.default)((store)=>store.history.back);
    const historyForward = (0, _storeDefault.default)((store)=>store.history.forward);
    const historyPointer = (0, _storeDefault.default)((store)=>store.history.pointer);
    const historyBuffer = (0, _storeDefault.default)((store)=>store.history.buffer);
    const copySelectedItems = (0, _storeDefault.default)((store)=>store.copySelectedItems);
    const nodes = (0, _storeDefault.default)((store)=>store.nodes);
    const selectedNodes = (0, _react.useMemo)(()=>nodes.filter(({ selected })=>selected), [
        nodes
    ]);
    const currentCopyBuffer = (0, _storeDefault.default)((store)=>store.copyBuffer);
    const reactFlowInstance = (0, _reactflow.useReactFlow)();
    const downloadPatchHandler = (0, _react.useCallback)(()=>{
        const fileName = "web-noise-patch.json";
        const editorState = getEditorState();
        const data = (0, _objectSpread._)({}, editorState);
        (0, _jsFileDownloadDefault.default)(JSON.stringify(data, null, 2), fileName);
    }, [
        getEditorState,
        reactFlowInstance
    ]);
    const downloadProjectHandler = (0, _react.useCallback)(()=>{
        const fileName = "web-noise-project.json";
        const projectState = getProject();
        const data = (0, _objectSpread._)({}, projectState);
        (0, _jsFileDownloadDefault.default)(JSON.stringify(data, null, 2), fileName);
    }, [
        getEditorState,
        reactFlowInstance
    ]);
    (0, _react.useEffect)(()=>{
        (0, _hotkeysJsDefault.default)("command+shift+a", ()=>{
            addNodeHandler(200, 50);
            return false;
        });
        //@TODO: find more elegant way to handle ?
        (0, _hotkeysJsDefault.default)("shift+/", ()=>{
            toggleHelp();
            return false;
        });
        (0, _hotkeysJsDefault.default)("command+z", ()=>{
            historyBack();
            return false;
        });
        (0, _hotkeysJsDefault.default)("command+shift+z", ()=>{
            historyForward();
            return false;
        });
        (0, _hotkeysJsDefault.default)("command+c", ()=>{
            copySelectedItems();
            return false;
        });
        (0, _hotkeysJsDefault.default)("command+v", ()=>{
            pasteBufferHandler({
                x: 200,
                y: 50
            });
            return false;
        });
        return ()=>{
            (0, _hotkeysJsDefault.default).unbind();
        };
    }, [
        addNodeHandler,
        pasteBufferHandler
    ]);
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)((0, _addNodeDefault.default), {
                isOpen: showAddNode,
                closeMenu: ()=>setShowAddNode(false),
                mousePosition: mousePosition
            }),
            (0, _jsxRuntime.jsx)((0, _uploadPatchDefault.default), {
                isOpen: showUploadPatch,
                closeMenu: ()=>setShowUploadPatch(false)
            }),
            (0, _jsxRuntime.jsx)((0, _uploadProjectDefault.default), {
                isOpen: showUploadProject,
                closeMenu: ()=>setShowUploadProject(false)
            }),
            (0, _jsxRuntime.jsx)((0, _uploadAudioDefault.default), {
                isOpen: showUploadAudio,
                closeMenu: ()=>setShowUploadAudio(false)
            }),
            (0, _jsxRuntime.jsxs)((0, _styles.MenuWrapper), {
                id: MENU_ID,
                animation: false,
                colors: theme.colors,
                children: [
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: ({ triggerEvent: { clientX, clientY } })=>addNodeHandler(clientX, clientY),
                        children: "Add Node (\u2318+\u21E7+A)"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: deleteAllHandler,
                        children: "Delete All"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: downloadPatchHandler,
                        children: "Download patch"
                    }),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: ()=>setShowUploadPatch(true),
                        children: "Upload patch"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: downloadProjectHandler,
                        children: "Download project"
                    }),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: ()=>setShowUploadProject(true),
                        children: "Upload project"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: ()=>setShowUploadAudio(true),
                        children: "Upload Audio File"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        disabled: historyPointer === 0,
                        onClick: historyBack,
                        children: "Undo (\u2318+z)"
                    }),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        disabled: historyPointer === historyBuffer.length,
                        onClick: historyForward,
                        children: "Redo (\u2318+\u21E7+Z)"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        disabled: !selectedNodes.length,
                        onClick: copySelectedItems,
                        children: "Copy Selected (\u2318+c)"
                    }),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        disabled: !currentCopyBuffer.nodes.length,
                        onClick: ({ triggerEvent: { clientX: x, clientY: y } })=>pasteBufferHandler({
                                x,
                                y
                            }),
                        children: "Paste (\u2318+v)"
                    }),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    editorContextMenu.map((item, index)=>(0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                            children: item
                        }, index)),
                    (0, _jsxRuntime.jsx)((0, _reactContexify.Separator), {}),
                    (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                        onClick: toggleHelp,
                        children: "Help (\u21E7+?)"
                    })
                ]
            })
        ]
    });
};
exports.default = EditorContextMenu;

},{"@swc/helpers/_/_object_spread":"awBF9","react/jsx-runtime":"g1NAx","js-file-download":"3XznK","react":"lXMxO","react-contexify":"cYVur","react-contexify/dist/ReactContexify.css":"3Ta3m","reactflow":"eL4zf","hotkeys-js":"eXEY4","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","../AddNode":"5ptQ3","../UploadPatch":"diSu2","../UploadProject":"i5Our","./styles":"ifkCY","../UploadAudio":"4u0JL","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3XznK":[function(require,module,exports,__globalThis) {
module.exports = function(data, filename, mime, bom) {
    var blobData = typeof bom !== 'undefined' ? [
        bom,
        data
    ] : [
        data
    ];
    var blob = new Blob(blobData, {
        type: mime || 'application/octet-stream'
    });
    if (typeof window.navigator.msSaveBlob !== 'undefined') // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
    else {
        var blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') tempLink.setAttribute('target', '_blank');
        document.body.appendChild(tempLink);
        tempLink.click();
        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
};

},{}],"3Ta3m":[function() {},{}],"eXEY4":[function(require,module,exports,__globalThis) {
/**! 
 * hotkeys-js v3.13.15 
 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies. 
 * 
 * Copyright (c) 2025 kenny wong <wowohoo@qq.com> 
 * https://github.com/jaywcjlove/hotkeys-js.git 
 * 
 * @website: https://jaywcjlove.github.io/hotkeys-js
 
 * Licensed under the MIT license 
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hotkeys);
const isff = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0 : false;
/** Bind event */ function addEvent(object, event, method, useCapture) {
    if (object.addEventListener) object.addEventListener(event, method, useCapture);
    else if (object.attachEvent) object.attachEvent("on".concat(event), method);
}
function removeEvent(object, event, method, useCapture) {
    if (object.removeEventListener) object.removeEventListener(event, method, useCapture);
    else if (object.detachEvent) object.detachEvent("on".concat(event), method);
}
/** Convert modifier keys to their corresponding key codes */ function getMods(modifier, key) {
    const mods = key.slice(0, key.length - 1);
    for(let i = 0; i < mods.length; i++)mods[i] = modifier[mods[i].toLowerCase()];
    return mods;
}
/** Process the input key string and convert it to an array */ function getKeys(key) {
    if (typeof key !== 'string') key = '';
    key = key.replace(/\s/g, ''); // Match any whitespace character, including spaces, tabs, form feeds, etc.
    const keys = key.split(','); // Allow multiple shortcuts separated by ','
    let index = keys.lastIndexOf('');
    // Shortcut may include ',' — special handling needed
    for(; index >= 0;){
        keys[index - 1] += ',';
        keys.splice(index, 1);
        index = keys.lastIndexOf('');
    }
    return keys;
}
/** Compare arrays of modifier keys */ function compareArray(a1, a2) {
    const arr1 = a1.length >= a2.length ? a1 : a2;
    const arr2 = a1.length >= a2.length ? a2 : a1;
    let isIndex = true;
    for(let i = 0; i < arr1.length; i++)if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
    return isIndex;
}
// Special Keys
const _keyMap = {
    backspace: 8,
    "\u232B": 8,
    tab: 9,
    clear: 12,
    enter: 13,
    "\u21A9": 13,
    return: 13,
    esc: 27,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    /// https://w3c.github.io/uievents/#events-keyboard-key-location
    arrowup: 38,
    arrowdown: 40,
    arrowleft: 37,
    arrowright: 39,
    del: 46,
    delete: 46,
    ins: 45,
    insert: 45,
    home: 36,
    end: 35,
    pageup: 33,
    pagedown: 34,
    capslock: 20,
    num_0: 96,
    num_1: 97,
    num_2: 98,
    num_3: 99,
    num_4: 100,
    num_5: 101,
    num_6: 102,
    num_7: 103,
    num_8: 104,
    num_9: 105,
    num_multiply: 106,
    num_add: 107,
    num_enter: 108,
    num_subtract: 109,
    num_decimal: 110,
    num_divide: 111,
    "\u21EA": 20,
    ',': 188,
    '.': 190,
    '/': 191,
    '`': 192,
    '-': isff ? 173 : 189,
    '=': isff ? 61 : 187,
    ';': isff ? 59 : 186,
    '\'': 222,
    '{': 219,
    '}': 221,
    '[': 219,
    ']': 221,
    '\\': 220
};
// Modifier Keys
const _modifier = {
    // shiftKey
    "\u21E7": 16,
    shift: 16,
    // altKey
    "\u2325": 18,
    alt: 18,
    option: 18,
    // ctrlKey
    "\u2303": 17,
    ctrl: 17,
    control: 17,
    // metaKey
    "\u2318": 91,
    cmd: 91,
    meta: 91,
    command: 91
};
const modifierMap = {
    16: 'shiftKey',
    18: 'altKey',
    17: 'ctrlKey',
    91: 'metaKey',
    shiftKey: 16,
    ctrlKey: 17,
    altKey: 18,
    metaKey: 91
};
const _mods = {
    16: false,
    18: false,
    17: false,
    91: false
};
const _handlers = {};
// F1~F12 special key
for(let k = 1; k < 20; k++)_keyMap["f".concat(k)] = 111 + k;
/** Record the pressed keys */ let _downKeys = [];
/** Whether the window has already listened to the focus event */ let winListendFocus = null;
/** Default hotkey scope */ let _scope = 'all';
/** Map to record elements with bound events */ const elementEventMap = new Map();
/** Return key code */ const code = (x)=>_keyMap[x.toLowerCase()] || _modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
const getKey = (x)=>Object.keys(_keyMap).find((k)=>_keyMap[k] === x);
const getModifier = (x)=>Object.keys(_modifier).find((k)=>_modifier[k] === x);
/** Set or get the current scope (defaults to 'all') */ function setScope(scope) {
    _scope = scope || 'all';
}
/** Get the current scope */ function getScope() {
    return _scope || 'all';
}
/** Get the key codes of the currently pressed keys */ function getPressedKeyCodes() {
    return _downKeys.slice(0);
}
function getPressedKeyString() {
    return _downKeys.map((c)=>getKey(c) || getModifier(c) || String.fromCharCode(c));
}
function getAllKeyCodes() {
    const result = [];
    Object.keys(_handlers).forEach((k)=>{
        _handlers[k].forEach((_ref)=>{
            let { key, scope, mods, shortcut } = _ref;
            result.push({
                scope,
                shortcut,
                mods,
                keys: key.split('+').map((v)=>code(v))
            });
        });
    });
    return result;
}
/** hotkey is effective only when filter return true */ function filter(event) {
    const target = event.target || event.srcElement;
    const { tagName } = target;
    let flag = true;
    const isInput = tagName === 'INPUT' && ![
        'checkbox',
        'radio',
        'range',
        'button',
        'file',
        'reset',
        'submit',
        'color'
    ].includes(target.type);
    // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>
    if (target.isContentEditable || (isInput || tagName === 'TEXTAREA' || tagName === 'SELECT') && !target.readOnly) flag = false;
    return flag;
}
/** Determine whether the pressed key matches a specific key, returns true or false */ function isPressed(keyCode) {
    if (typeof keyCode === 'string') keyCode = code(keyCode); // Convert to key code
    return _downKeys.indexOf(keyCode) !== -1;
}
/** Loop through and delete all handlers with the specified scope */ function deleteScope(scope, newScope) {
    let handlers;
    let i;
    // If no scope is specified, get the current scope
    if (!scope) scope = getScope();
    for(const key in _handlers)if (Object.prototype.hasOwnProperty.call(_handlers, key)) {
        handlers = _handlers[key];
        for(i = 0; i < handlers.length;)if (handlers[i].scope === scope) {
            const deleteItems = handlers.splice(i, 1);
            deleteItems.forEach((_ref2)=>{
                let { element } = _ref2;
                return removeKeyEvent(element);
            });
        } else i++;
    }
    // If the current scope has been deleted, reset the scope to 'all'
    if (getScope() === scope) setScope(newScope || 'all');
}
/** Clear modifier keys */ function clearModifier(event) {
    let key = event.keyCode || event.which || event.charCode;
    if (event.key && event.key.toLowerCase() === 'capslock') // Ensure that when capturing keystrokes in modern browsers,
    // uppercase and lowercase letters (such as R and r) return the same key value.
    // https://github.com/jaywcjlove/hotkeys-js/pull/514
    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
    key = code(event.key);
    const i = _downKeys.indexOf(key);
    // Remove the pressed key from the list
    if (i >= 0) _downKeys.splice(i, 1);
    // Special handling for the command key: fix the issue where keyup only triggers once for command combos
    if (event.key && event.key.toLowerCase() === 'meta') _downKeys.splice(0, _downKeys.length);
    // Clear modifier keys: shiftKey, altKey, ctrlKey, (command || metaKey)
    if (key === 93 || key === 224) key = 91;
    if (key in _mods) {
        _mods[key] = false;
        // Reset the modifier key status to false
        for(const k in _modifier)if (_modifier[k] === key) hotkeys[k] = false;
    }
}
function unbind(keysInfo) {
    // unbind(), unbind all keys
    if (typeof keysInfo === 'undefined') {
        Object.keys(_handlers).forEach((key)=>{
            Array.isArray(_handlers[key]) && _handlers[key].forEach((info)=>eachUnbind(info));
            delete _handlers[key];
        });
        removeKeyEvent(null);
    } else if (Array.isArray(keysInfo)) // support like : unbind([{key: 'ctrl+a', scope: 's1'}, {key: 'ctrl-a', scope: 's2', splitKey: '-'}])
    keysInfo.forEach((info)=>{
        if (info.key) eachUnbind(info);
    });
    else if (typeof keysInfo === 'object') // support like unbind({key: 'ctrl+a, ctrl+b', scope:'abc'})
    {
        if (keysInfo.key) eachUnbind(keysInfo);
    } else if (typeof keysInfo === 'string') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        // support old method
        // eslint-disable-line
        let [scope, method] = args;
        if (typeof scope === 'function') {
            method = scope;
            scope = '';
        }
        eachUnbind({
            key: keysInfo,
            scope,
            method,
            splitKey: '+'
        });
    }
}
/** Unbind hotkeys for a specific scope */ const eachUnbind = (_ref3)=>{
    let { key, scope, method, splitKey = '+' } = _ref3;
    const multipleKeys = getKeys(key);
    multipleKeys.forEach((originKey)=>{
        const unbindKeys = originKey.split(splitKey);
        const len = unbindKeys.length;
        const lastKey = unbindKeys[len - 1];
        const keyCode = lastKey === '*' ? '*' : code(lastKey);
        if (!_handlers[keyCode]) return;
        // If scope is not provided, get the current scope
        if (!scope) scope = getScope();
        const mods = len > 1 ? getMods(_modifier, unbindKeys) : [];
        const unbindElements = [];
        _handlers[keyCode] = _handlers[keyCode].filter((record)=>{
            // Check if the method matches; if method is provided, must be equal to unbind
            const isMatchingMethod = method ? record.method === method : true;
            const isUnbind = isMatchingMethod && record.scope === scope && compareArray(record.mods, mods);
            if (isUnbind) unbindElements.push(record.element);
            return !isUnbind;
        });
        unbindElements.forEach((element)=>removeKeyEvent(element));
    });
};
/** Handle the callback function for the corresponding hotkey */ function eventHandler(event, handler, scope, element) {
    if (handler.element !== element) return;
    let modifiersMatch;
    // Check if it is within the current scope
    if (handler.scope === scope || handler.scope === 'all') {
        // Check whether modifier keys match (returns true if they do)
        modifiersMatch = handler.mods.length > 0;
        for(const y in _mods){
            if (Object.prototype.hasOwnProperty.call(_mods, y)) {
                if (!_mods[y] && handler.mods.indexOf(+y) > -1 || _mods[y] && handler.mods.indexOf(+y) === -1) modifiersMatch = false;
            }
        }
        // Call the handler function; ignore if it's only a modifier key
        if (handler.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || modifiersMatch || handler.shortcut === '*') {
            handler.keys = [];
            handler.keys = handler.keys.concat(_downKeys);
            if (handler.method(event, handler) === false) {
                if (event.preventDefault) event.preventDefault();
                else event.returnValue = false;
                if (event.stopPropagation) event.stopPropagation();
                if (event.cancelBubble) event.cancelBubble = true;
            }
        }
    }
}
/** Handle the keydown event */ function dispatch(event, element) {
    const asterisk = _handlers['*'];
    let key = event.keyCode || event.which || event.charCode;
    // Ensure that when capturing keystrokes in modern browsers,
    // uppercase and lowercase letters (such as R and r) return the same key value.
    // https://github.com/jaywcjlove/hotkeys-js/pull/514
    // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
    // CapsLock key
    // There's an issue where `keydown` and `keyup` events are not triggered after CapsLock is enabled to activate uppercase.
    if (event.key && event.key.toLowerCase() === 'capslock') return;
    // Form control filter: by default, shortcut keys are not triggered in form elements
    if (!hotkeys.filter.call(this, event)) return;
    // In Gecko (Firefox), the command key code is 224; unify it with WebKit (Chrome)
    // In WebKit, left and right command keys have different codes
    if (key === 93 || key === 224) key = 91;
    /**
   * Collect bound keys
   * If an Input Method Editor is processing key input and the event is keydown, return 229.
   * https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
   * http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
   */ if (_downKeys.indexOf(key) === -1 && key !== 229) _downKeys.push(key);
    /**
   * Jest test cases are required.
   * ===============================
   */ [
        'metaKey',
        'ctrlKey',
        'altKey',
        'shiftKey'
    ].forEach((keyName)=>{
        const keyNum = modifierMap[keyName];
        if (event[keyName] && _downKeys.indexOf(keyNum) === -1) _downKeys.push(keyNum);
        else if (!event[keyName] && _downKeys.indexOf(keyNum) > -1) _downKeys.splice(_downKeys.indexOf(keyNum), 1);
        else if (keyName === 'metaKey' && event[keyName]) // If the command key is pressed, clear all non-modifier keys except the current event key.
        // This is because keyup for non-modifier keys will NEVER be triggered when command is pressed.
        // This is a known browser limitation.
        _downKeys = _downKeys.filter((k)=>k in modifierMap || k === key);
    });
    /**
   * -------------------------------
   */ if (key in _mods) {
        _mods[key] = true;
        // Register special modifier keys to the `hotkeys` object
        for(const k in _modifier)if (Object.prototype.hasOwnProperty.call(_modifier, k)) {
            const eventKey = modifierMap[_modifier[k]];
            hotkeys[k] = event[eventKey];
        }
        if (!asterisk) return;
    }
    // Bind the modifier keys in modifierMap to the event
    for(const e in _mods)if (Object.prototype.hasOwnProperty.call(_mods, e)) _mods[e] = event[modifierMap[e]];
    /**
   * https://github.com/jaywcjlove/hotkeys/pull/129
   * This solves the issue in Firefox on Windows where hotkeys corresponding to special characters would not trigger.
   * An example of this is ctrl+alt+m on a Swedish keyboard which is used to type μ.
   * Browser support: https://caniuse.com/#feat=keyboardevent-getmodifierstate
   */ if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState('AltGraph')) {
        if (_downKeys.indexOf(17) === -1) _downKeys.push(17);
        if (_downKeys.indexOf(18) === -1) _downKeys.push(18);
        _mods[17] = true;
        _mods[18] = true;
    }
    // Get the current scope (defaults to 'all')
    const scope = getScope();
    // Handle any hotkeys registered as '*'
    if (asterisk) {
        for(let i = 0; i < asterisk.length; i++)if (asterisk[i].scope === scope && (event.type === 'keydown' && asterisk[i].keydown || event.type === 'keyup' && asterisk[i].keyup)) eventHandler(event, asterisk[i], scope, element);
    }
    // If the key is not registered, return
    if (!(key in _handlers)) return;
    const handlerKey = _handlers[key];
    const keyLen = handlerKey.length;
    for(let i = 0; i < keyLen; i++){
        if (event.type === 'keydown' && handlerKey[i].keydown || event.type === 'keyup' && handlerKey[i].keyup) {
            if (handlerKey[i].key) {
                const record = handlerKey[i];
                const { splitKey } = record;
                const keyShortcut = record.key.split(splitKey);
                const _downKeysCurrent = []; // Store the current key codes
                for(let a = 0; a < keyShortcut.length; a++)_downKeysCurrent.push(code(keyShortcut[a]));
                if (_downKeysCurrent.sort().join('') === _downKeys.sort().join('')) // Match found, call the handler
                eventHandler(event, record, scope, element);
            }
        }
    }
}
function hotkeys(key, option, method) {
    _downKeys = [];
    /** List of hotkeys to handle */ const keys = getKeys(key);
    let mods = [];
    /** Default scope is 'all', meaning effective in all scopes */ let scope = 'all';
    /** Element to which the hotkey events are bound */ let element = document;
    let i = 0;
    let keyup = false;
    let keydown = true;
    let splitKey = '+';
    let capture = false;
    /** Allow only a single callback */ let single = false;
    // Determine if the second argument is a function (no options provided)
    if (method === undefined && typeof option === 'function') method = option;
    // Parse options object
    if (Object.prototype.toString.call(option) === '[object Object]') {
        if (option.scope) scope = option.scope; // Set scope
        if (option.element) element = option.element; // Set binding element
        if (option.keyup) keyup = option.keyup;
        if (option.keydown !== undefined) keydown = option.keydown;
        if (option.capture !== undefined) capture = option.capture;
        if (typeof option.splitKey === 'string') splitKey = option.splitKey;
        if (option.single === true) single = true;
    }
    if (typeof option === 'string') scope = option;
    // If only one callback is allowed, unbind the existing one first
    if (single) unbind(key, scope);
    // Handle each hotkey
    for(; i < keys.length; i++){
        key = keys[i].split(splitKey); // Split into individual keys
        mods = [];
        // If it's a combination, extract modifier keys
        if (key.length > 1) mods = getMods(_modifier, key);
        // Convert non-modifier key to key code
        key = key[key.length - 1];
        key = key === '*' ? '*' : code(key); // '*' means match all hotkeys
        // Initialize handler array if this key has no handlers yet
        if (!(key in _handlers)) _handlers[key] = [];
        _handlers[key].push({
            keyup,
            keydown,
            scope,
            mods,
            shortcut: keys[i],
            method,
            key: keys[i],
            splitKey,
            element
        });
    }
    // Register hotkey event listeners on the global document
    if (typeof element !== 'undefined' && window) {
        if (!elementEventMap.has(element)) {
            const keydownListener = function() {
                let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
                return dispatch(event, element);
            };
            const keyupListenr = function() {
                let event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
                dispatch(event, element);
                clearModifier(event);
            };
            elementEventMap.set(element, {
                keydownListener,
                keyupListenr,
                capture
            });
            addEvent(element, 'keydown', keydownListener, capture);
            addEvent(element, 'keyup', keyupListenr, capture);
        }
        // Register focus event listener once to clear pressed keys on window focus
        if (!winListendFocus) {
            const listener = ()=>{
                _downKeys = [];
            };
            winListendFocus = {
                listener,
                capture
            };
            addEvent(window, 'focus', listener, capture);
        }
    }
}
function trigger(shortcut) {
    let scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
    Object.keys(_handlers).forEach((key)=>{
        const dataList = _handlers[key].filter((item)=>item.scope === scope && item.shortcut === shortcut);
        dataList.forEach((data)=>{
            if (data && data.method) data.method();
        });
    });
}
/** Clean up event listeners. After unbinding, check whether the element still has any hotkeys bound. If not, remove its event listeners. */ function removeKeyEvent(element) {
    const values = Object.values(_handlers).flat();
    const findindex = values.findIndex((_ref4)=>{
        let { element: el } = _ref4;
        return el === element;
    });
    if (findindex < 0) {
        const { keydownListener, keyupListenr, capture } = elementEventMap.get(element) || {};
        if (keydownListener && keyupListenr) {
            removeEvent(element, 'keyup', keyupListenr, capture);
            removeEvent(element, 'keydown', keydownListener, capture);
            elementEventMap.delete(element);
        }
    }
    if (values.length <= 0 || elementEventMap.size <= 0) {
        // Remove all event listeners from all elements
        const eventKeys = Object.keys(elementEventMap);
        eventKeys.forEach((el)=>{
            const { keydownListener, keyupListenr, capture } = elementEventMap.get(el) || {};
            if (keydownListener && keyupListenr) {
                removeEvent(el, 'keyup', keyupListenr, capture);
                removeEvent(el, 'keydown', keydownListener, capture);
                elementEventMap.delete(el);
            }
        });
        // Clear the elementEventMap
        elementEventMap.clear();
        // Clear all handlers
        Object.keys(_handlers).forEach((key)=>delete _handlers[key]);
        // Remove the global window focus event listener
        if (winListendFocus) {
            const { listener, capture } = winListendFocus;
            removeEvent(window, 'focus', listener, capture);
            winListendFocus = null;
        }
    }
}
const _api = {
    getPressedKeyString,
    setScope,
    getScope,
    deleteScope,
    getPressedKeyCodes,
    getAllKeyCodes,
    isPressed,
    filter,
    trigger,
    unbind,
    keyMap: _keyMap,
    modifier: _modifier,
    modifierMap
};
for(const a in _api)if (Object.prototype.hasOwnProperty.call(_api, a)) hotkeys[a] = _api[a];
if (typeof window !== 'undefined') {
    const _hotkeys = window.hotkeys;
    hotkeys.noConflict = (deep)=>{
        if (deep && window.hotkeys === hotkeys) window.hotkeys = _hotkeys;
        return hotkeys;
    };
    window.hotkeys = hotkeys;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5ptQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _reactflow = require("reactflow");
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _filters = require("./Filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _plugins = require("./Plugins");
var _pluginsDefault = parcelHelpers.interopDefault(_plugins);
let _ = (t)=>t, t, t1;
const AddNodeWrapper = (0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
  display: flex;
  gap: 1rem;
`));
const PluginsPanel = (0, _styledDefault.default).div(t1 || (t1 = _`
  flex-grow: 1;
  height: 100%;
  overflow-y: scroll;
`));
const AddNode = ({ isOpen, closeMenu, mousePosition })=>{
    const theme = (0, _useThemeDefault.default)();
    const { screenToFlowPosition } = (0, _reactflow.useReactFlow)();
    const { createNode } = (0, _storeDefault.default)(({ createNode })=>({
            createNode
        }));
    const [filtersState, setFiltersState] = (0, _react.useState)({});
    const onComponentClick = (0, _react.useCallback)(({ type })=>{
        const { x, y } = screenToFlowPosition(mousePosition);
        const newNode = {
            //@TODO: generate node id in `createNode` function
            id: `${type}-${+new Date()}`,
            type,
            data: {
                label: type
            },
            position: {
                x,
                y
            },
            targetPosition: (0, _reactflow.Position).Left,
            sourcePosition: (0, _reactflow.Position).Right
        };
        createNode(newNode);
        closeMenu();
    }, [
        mousePosition,
        screenToFlowPosition,
        createNode,
        closeMenu,
        mousePosition
    ]);
    return isOpen ? (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        onClose: ()=>{
            closeMenu();
            setFiltersState({});
        },
        children: (0, _jsxRuntime.jsxs)(AddNodeWrapper, {
            theme: theme,
            children: [
                (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {
                    onChange: setFiltersState,
                    value: filtersState
                }),
                (0, _jsxRuntime.jsx)(PluginsPanel, {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _pluginsDefault.default), {
                        filters: filtersState,
                        onTagClick: (tag)=>{
                            setFiltersState((state)=>{
                                var _state_tags;
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                                    tags: ((_state_tags = state.tags) === null || _state_tags === void 0 ? void 0 : _state_tags.includes(tag)) ? state.tags.filter((t)=>t !== tag) : [
                                        ...state.tags || [],
                                        tag
                                    ]
                                });
                            });
                        },
                        onComponentClick: (component)=>{
                            onComponentClick(component);
                            setFiltersState({});
                        }
                    })
                })
            ]
        })
    }) : null;
};
exports.default = AddNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","reactflow":"eL4zf","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","../Modal":"9rT1D","./Filters":"38Pye","./Plugins":"52Vyc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9rT1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _reactDom = require("react-dom");
var _md = require("react-icons/md");
var _useTheme = require("../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
let _ = (t)=>t, t, t1, t2;
const ModalOuter = (0, _styledDefault.default).div(t || (t = _`
  position: fixed;
  z-index: ${0};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${0}cc;
  display: flex;
  align-items: center;
  justify-content: center;
`), ({ theme })=>theme.zIndex.modal, ({ theme })=>theme.colors.elevation3);
const ModalInner = (0, _styledDefault.default).div(t1 || (t1 = _`
  background: ${0};
  box-shadow: 1px 1px 1px 1px ${0};
  color: white;
  width: 70%;
  height: 80%;
  overflow-y: scroll;
  position: relative;
`), ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.elevation1);
const ModalCloser = (0, _styledDefault.default)((0, _md.MdClose))(t2 || (t2 = _`
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
  cursor: pointer;
`));
const Modal = (_param)=>{
    var { children, onClose } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "children",
        "onClose"
    ]);
    const theme = (0, _useThemeDefault.default)();
    (0, _react.useEffect)(()=>{
        const escHandler = (event)=>{
            if (event.key === "Escape") onClose === null || onClose === void 0 ? void 0 : onClose();
        };
        document.addEventListener("keydown", escHandler);
        return ()=>{
            document.removeEventListener("keydown", escHandler);
        };
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, _reactDom.createPortal)((0, _jsxRuntime.jsx)(ModalOuter, {
        theme: theme,
        onClick: onClose,
        children: (0, _jsxRuntime.jsxs)(ModalInner, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
            onClick: (e)=>{
                e.stopPropagation();
            },
            theme: theme,
            children: [
                children,
                (0, _jsxRuntime.jsx)(ModalCloser, {
                    theme: theme,
                    onClick: onClose
                })
            ]
        }))
    }), document.body);
};
exports.default = Modal;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","react-dom":"dgecT","react-icons/md":"ixP1W","../hooks/useTheme":"kxvkQ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"38Pye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _react1 = require("react");
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _plugins = require("./Plugins");
let _ = (t)=>t, t, t1, t2, t3, t4;
const InputWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  position: relative;
`));
const InputInner = (0, _styledDefault.default).input(t1 || (t1 = _`
  padding-right: 2rem;
  padding-left: 0.3rem;
  width: 100%;
  appearance: textfield;
  font-size: inherit;
  background: none;
  border: none;
  color: var(--leva-colors-highlight1);
  font-family: var(--leva-fonts-mono);
  cursor: inherit;
  text-overflow: ellipsis;
  outline: none;
  appearance: textfield;
  cursor: auto;
  background-color: ${0};
  border-radius: 0.1rem;
  height: 2rem;
  color: ${0};

  &:focus,
  &:hover {
    box-shadow: 0 0 0 var(--leva-borderWidths-focus)
      ${0};
    color: ${0};
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin-right: 1rem;
  }
`), ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.accent2, ({ theme })=>theme.colors.whitePrimary);
const FiltersWrapper = (0, _styledDefault.default).div(t2 || (t2 = _`
  display: flex;
  flex-direction: column;
  padding: 0.6rem;
  gap: 0.6rem;
  border-right: 1px solid ${0};
  min-width: 14rem;
`), ({ theme })=>theme.colors.elevation3);
const PluginName = (0, _styledDefault.default).label(t3 || (t3 = _`
  user-select: none;
  input {
    display: none;
  }
  input:checked + span {
    color: ${0};
  }
  &:hover {
    color: ${0};
    cursor: pointer;
  }
`), ({ theme })=>theme.colors.accent2, ({ theme })=>theme.colors.accent3);
const StyledPluginTag = (0, _react.withTheme)((0, _styledDefault.default)((0, _plugins.PluginTag))(t4 || (t4 = _`
  font-size: 12px;
  padding: 0.2rem 0.4rem;
  &:hover {
  }
  &::after {
    content: "×";
    margin-left: 0.4rem;
  }
`)));
const Filters = ({ onChange, value })=>{
    var _value_tags;
    const theme = (0, _useThemeDefault.default)();
    const plugins = (0, _storeDefault.default)(({ plugins })=>plugins);
    const inputRef = (0, _react1.useRef)(null);
    (0, _react1.useEffect)(()=>{
        if (!inputRef.current) return;
        inputRef.current.focus();
    }, [
        inputRef
    ]);
    return (0, _jsxRuntime.jsxs)(FiltersWrapper, {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsx)(InputWrapper, {
                children: (0, _jsxRuntime.jsx)(InputInner, {
                    ref: inputRef,
                    theme: theme,
                    value: value.search || "",
                    placeholder: "search...",
                    onChange: (event)=>onChange((0, _objectSpreadProps._)((0, _objectSpread._)({}, value), {
                            search: event.target.value
                        }))
                })
            }),
            (0, _jsxRuntime.jsx)((0, _plugins.TagsList), {
                children: (_value_tags = value.tags) === null || _value_tags === void 0 ? void 0 : _value_tags.map((tag, index)=>(0, _jsxRuntime.jsx)(StyledPluginTag, {
                        isActive: true,
                        onClick: ()=>{
                            var _value_tags;
                            const newTags = ((_value_tags = value.tags) === null || _value_tags === void 0 ? void 0 : _value_tags.filter((t)=>t !== tag)) || [];
                            onChange((0, _objectSpreadProps._)((0, _objectSpread._)({}, value), {
                                tags: newTags
                            }));
                        },
                        children: tag
                    }, index))
            }),
            plugins.map(({ name, components }, index)=>{
                if (!name) return null;
                return (0, _jsxRuntime.jsxs)(PluginName, {
                    theme: theme,
                    children: [
                        (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            name: "plugin",
                            value: name,
                            checked: name === value.plugin,
                            onChange: ()=>{
                                onChange((0, _objectSpreadProps._)((0, _objectSpread._)({}, value), {
                                    plugin: name === value.plugin ? null : name
                                }));
                            }
                        }),
                        (0, _jsxRuntime.jsx)("span", {
                            children: name
                        })
                    ]
                }, index);
            })
        ]
    });
};
exports.default = Filters;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","react":"lXMxO","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","./Plugins":"52Vyc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"52Vyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagsList", ()=>TagsList);
parcelHelpers.export(exports, "PluginTag", ()=>PluginTag);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _react1 = require("@emotion/react");
let _ = (t)=>t, t, t1, t2, t3, t4, t5, t6, t7, t8, t9;
const PluginsWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  width: 100%;
`)));
const PluginWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`)));
const NodesList = (0, _react1.withTheme)((0, _styledDefault.default).ul(t2 || (t2 = _`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom: 10px;
  columns: 2;

  li {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px;
    overflow: hidden;
    border: 1px solid ${0};
    border-radius: 4px;
    margin-bottom: 0.5rem;
    &:hover {
      border-color: ${0};
      cursor: pointer;
    }
  }
`), ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.accent2));
const NodeTitle = (0, _react1.withTheme)((0, _styledDefault.default).div(t3 || (t3 = _`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`)));
const NodeDescription = (0, _react1.withTheme)((0, _styledDefault.default).div(t4 || (t4 = _`
  color: ${0};
  font-size: 12px;
`), ({ theme })=>theme.colors.highlight2));
const TagsList = (0, _react1.withTheme)((0, _styledDefault.default).div(t5 || (t5 = _`
  display: flex;
  gap: 0.2rem;
  flex-wrap: wrap;
`)));
const PluginTag = (0, _react1.withTheme)((0, _styledDefault.default).span(t6 || (t6 = _`
  cursor: pointer;
  font-size: 10px;
  background: ${0};
  border-radius: 2px;
  padding: 0.1rem 0.2rem;
  border: 1px solid;
  border-color: ${0};
  &:hover {
    border-color: ${0};
  }
`), ({ theme, isActive })=>isActive ? theme.colors.highlight1 : theme.colors.elevation3, ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.accent2));
const PluginHeader = (0, _react1.withTheme)((0, _styledDefault.default).div(t7 || (t7 = _``)));
const PluginTitle = (0, _react1.withTheme)((0, _styledDefault.default).div(t8 || (t8 = _`
  font-size: 1.1rem;
  padding: 0.25rem 0;
  color: ${0};
`), ({ theme })=>theme.colors.highlight3));
const PluginDescription = (0, _react1.withTheme)((0, _styledDefault.default).div(t9 || (t9 = _`
  color: ${0};
  font-size: 12px;
`), ({ theme })=>theme.colors.highlight2));
const Plugins = ({ onComponentClick, filters: { plugin, search = "", tags }, onTagClick })=>{
    const plugins = (0, _storeDefault.default)(({ plugins })=>plugins);
    const pluginsGroup = (0, _react.useMemo)(()=>{
        if (!plugin) return plugins;
        return plugins.filter(({ name })=>name === plugin);
    }, [
        plugins,
        plugin
    ]);
    const filteredPlugins = (0, _react.useMemo)(()=>{
        if (!search && !(tags === null || tags === void 0 ? void 0 : tags.length)) return pluginsGroup;
        const filteredByTags = pluginsGroup.map((plugin)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, plugin), {
                components: (tags === null || tags === void 0 ? void 0 : tags.length) ? plugin.components.filter((component)=>tags === null || tags === void 0 ? void 0 : tags.every((tag)=>{
                        var _component_tags;
                        return (_component_tags = component.tags) === null || _component_tags === void 0 ? void 0 : _component_tags.includes(tag);
                    })) : plugin.components
            }));
        return filteredByTags.map((plugin)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, plugin), {
                components: plugin.components.filter(({ type, name })=>type.toLocaleLowerCase().includes(search.toLocaleLowerCase()) || (name === null || name === void 0 ? void 0 : name.toLocaleLowerCase().includes(search.toLocaleLowerCase())))
            }));
    }, [
        pluginsGroup,
        search,
        tags
    ]);
    return (0, _jsxRuntime.jsx)(PluginsWrapper, {
        children: filteredPlugins.map(({ name, description, components }, index)=>{
            if (!components.length) return null;
            return (0, _jsxRuntime.jsxs)(PluginWrapper, {
                children: [
                    (0, _jsxRuntime.jsxs)(PluginHeader, {
                        children: [
                            (0, _jsxRuntime.jsx)(PluginTitle, {
                                children: name
                            }),
                            (0, _jsxRuntime.jsx)(PluginDescription, {
                                children: description
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)(NodesList, {
                        children: components.sort((a, b)=>a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1).map((component, idx)=>{
                            var _component_tags;
                            return (0, _jsxRuntime.jsxs)("li", {
                                onClick: ()=>onComponentClick(component),
                                children: [
                                    (0, _jsxRuntime.jsx)(NodeTitle, {
                                        children: component.name || component.type
                                    }),
                                    component.description && (0, _jsxRuntime.jsx)(NodeDescription, {
                                        children: component.description
                                    }),
                                    (0, _jsxRuntime.jsx)(TagsList, {
                                        children: (_component_tags = component.tags) === null || _component_tags === void 0 ? void 0 : _component_tags.map((tag, tagIdx)=>(0, _jsxRuntime.jsx)(PluginTag, {
                                                isActive: tags === null || tags === void 0 ? void 0 : tags.includes(tag),
                                                onClickCapture: (event)=>{
                                                    event.stopPropagation();
                                                    onTagClick(tag);
                                                },
                                                children: tag
                                            }, tagIdx))
                                    })
                                ]
                            }, idx);
                        })
                    })
                ]
            }, index);
        })
    });
};
exports.default = Plugins;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","../../store":"eveyc","@emotion/react":"ifT37","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"diSu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _reactFileDrop = require("react-file-drop");
var _fa = require("react-icons/fa");
var _useTheme = require("../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
let _ = (t)=>t, t, t1, t2, t3;
const UploadPatchWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .drop-zone-wrapper {
    width: 80%;
    height: 80%;
  }

  .drop-zone {
    height: 100%;
    width: 100%;
    border-style: dashed;
    border-width: 2px;
    border-color: ${0};
    opacity: 0.5;
    cursor: pointer;
  }

  .drop-zone:hover,
  .drop-zone-drag-over {
    opacity: 1;
  }
`), ({ theme })=>theme.colors.highlight2);
const DropZoneInner = (0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`));
const FileUploadIcon = (0, _styledDefault.default)((0, _fa.FaFileUpload))(t2 || (t2 = _`
  width: 100%;
  height: 8rem;
`));
const FileUploadMessage = (0, _styledDefault.default).div(t3 || (t3 = _`
  font-size: 2rem;
`));
const UploadPatch = ({ isOpen, closeMenu })=>{
    const theme = (0, _useThemeDefault.default)();
    const setGraph = (0, _storeDefault.default)(({ setGraph })=>setGraph);
    const setEditorState = (0, _storeDefault.default)((store)=>store.setEditorState);
    const fileInputRef = (0, _react.useRef)(null);
    const uploadFile = (0, _react.useCallback)((files)=>{
        const [file] = files || [];
        file.text().then(JSON.parse).then((editorState)=>{
            setEditorState(editorState);
            closeMenu();
        }).catch(console.error);
    }, [
        setGraph,
        closeMenu
    ]);
    const onTargetClick = ()=>{
        var _fileInputRef_current;
        (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    return isOpen ? (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        onClose: closeMenu,
        children: (0, _jsxRuntime.jsxs)(UploadPatchWrapper, {
            theme: theme,
            children: [
                (0, _jsxRuntime.jsx)("input", {
                    onChange: ({ target: { files } })=>uploadFile(files),
                    ref: fileInputRef,
                    type: "file",
                    className: "hidden",
                    style: {
                        display: "none"
                    },
                    accept: ".json"
                }),
                (0, _jsxRuntime.jsx)((0, _reactFileDrop.FileDrop), {
                    className: "drop-zone-wrapper",
                    targetClassName: "drop-zone",
                    draggingOverTargetClassName: "drop-zone-drag-over",
                    onTargetClick: onTargetClick,
                    onDrop: (files)=>uploadFile(files),
                    children: (0, _jsxRuntime.jsxs)(DropZoneInner, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)(FileUploadIcon, {}),
                            (0, _jsxRuntime.jsx)(FileUploadMessage, {
                                children: "click or drop file here"
                            })
                        ]
                    })
                })
            ]
        })
    }) : null;
};
exports.default = UploadPatch;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","react-file-drop":"hybf4","react-icons/fa":"lut99","../hooks/useTheme":"kxvkQ","../store":"eveyc","./Modal":"9rT1D","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hybf4":[function(require,module,exports,__globalThis) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var prop_types_1 = __importDefault(require("73f083f5fc2d995d"));
var react_1 = __importDefault(require("2f17f104354398d4"));
var FileDrop = /** @class */ function(_super) {
    __extends(FileDrop, _super);
    function FileDrop(props) {
        var _this = _super.call(this, props) || this;
        _this.resetDragging = function() {
            _this.frameDragCounter = 0;
            _this.setState({
                draggingOverFrame: false,
                draggingOverTarget: false
            });
        };
        _this.handleWindowDragOverOrDrop = function(event) {
            // This prevents the browser from trying to load whatever file the user dropped on the window
            event.preventDefault();
        };
        _this.handleFrameDrag = function(event) {
            // Only allow dragging of files
            if (!FileDrop.eventHasFiles(event)) return;
            // We are listening for events on the 'frame', so every time the user drags over any element in the frame's tree,
            // the event bubbles up to the frame. By keeping count of how many "dragenters" we get, we can tell if they are still
            // "draggingOverFrame" (b/c you get one "dragenter" initially, and one "dragenter"/one "dragleave" for every bubble)
            // This is far better than a "dragover" handler, which would be calling `setState` continuously.
            _this.frameDragCounter += event.type === 'dragenter' ? 1 : -1;
            if (_this.frameDragCounter === 1) {
                _this.setState({
                    draggingOverFrame: true
                });
                if (_this.props.onFrameDragEnter) _this.props.onFrameDragEnter(event);
                return;
            }
            if (_this.frameDragCounter === 0) {
                _this.setState({
                    draggingOverFrame: false
                });
                if (_this.props.onFrameDragLeave) _this.props.onFrameDragLeave(event);
                return;
            }
        };
        _this.handleFrameDrop = function(event) {
            if (!_this.state.draggingOverTarget) {
                _this.resetDragging();
                if (_this.props.onFrameDrop) _this.props.onFrameDrop(event);
            }
        };
        _this.handleDragOver = function(event) {
            if (FileDrop.eventHasFiles(event)) {
                _this.setState({
                    draggingOverTarget: true
                });
                if (!FileDrop.isIE() && _this.props.dropEffect) event.dataTransfer.dropEffect = _this.props.dropEffect;
                if (_this.props.onDragOver) _this.props.onDragOver(event);
            }
        };
        _this.handleDragLeave = function(event) {
            _this.setState({
                draggingOverTarget: false
            });
            if (_this.props.onDragLeave) _this.props.onDragLeave(event);
        };
        _this.handleDrop = function(event) {
            if (_this.props.onDrop && FileDrop.eventHasFiles(event)) {
                var files = event.dataTransfer ? event.dataTransfer.files : null;
                _this.props.onDrop(files, event);
            }
            _this.resetDragging();
        };
        _this.handleTargetClick = function(event) {
            if (_this.props.onTargetClick) _this.props.onTargetClick(event);
            _this.resetDragging();
        };
        _this.stopFrameListeners = function(frame) {
            if (frame) {
                frame.removeEventListener('dragenter', _this.handleFrameDrag);
                frame.removeEventListener('dragleave', _this.handleFrameDrag);
                frame.removeEventListener('drop', _this.handleFrameDrop);
            }
        };
        _this.startFrameListeners = function(frame) {
            if (frame) {
                frame.addEventListener('dragenter', _this.handleFrameDrag);
                frame.addEventListener('dragleave', _this.handleFrameDrag);
                frame.addEventListener('drop', _this.handleFrameDrop);
            }
        };
        _this.frameDragCounter = 0;
        _this.state = {
            draggingOverFrame: false,
            draggingOverTarget: false
        };
        return _this;
    }
    FileDrop.prototype.componentDidMount = function() {
        this.startFrameListeners(this.props.frame);
        this.resetDragging();
        window.addEventListener('dragover', this.handleWindowDragOverOrDrop);
        window.addEventListener('drop', this.handleWindowDragOverOrDrop);
    };
    FileDrop.prototype.componentDidUpdate = function(prevProps) {
        if (prevProps.frame !== this.props.frame) {
            this.resetDragging();
            this.stopFrameListeners(prevProps.frame);
            this.startFrameListeners(this.props.frame);
        }
    };
    FileDrop.prototype.componentWillUnmount = function() {
        this.stopFrameListeners(this.props.frame);
        window.removeEventListener('dragover', this.handleWindowDragOverOrDrop);
        window.removeEventListener('drop', this.handleWindowDragOverOrDrop);
    };
    FileDrop.prototype.render = function() {
        var _a = this.props, children = _a.children, className = _a.className, targetClassName = _a.targetClassName, draggingOverFrameClassName = _a.draggingOverFrameClassName, draggingOverTargetClassName = _a.draggingOverTargetClassName;
        var _b = this.state, draggingOverTarget = _b.draggingOverTarget, draggingOverFrame = _b.draggingOverFrame;
        var fileDropTargetClassName = targetClassName;
        if (draggingOverFrame) fileDropTargetClassName += " " + draggingOverFrameClassName;
        if (draggingOverTarget) fileDropTargetClassName += " " + draggingOverTargetClassName;
        return react_1.default.createElement("div", {
            className: className,
            onDragOver: this.handleDragOver,
            onDragLeave: this.handleDragLeave,
            onDrop: this.handleDrop
        }, react_1.default.createElement("div", {
            className: fileDropTargetClassName,
            onClick: this.handleTargetClick
        }, children));
    };
    FileDrop.isIE = function() {
        return typeof window !== 'undefined' && (window.navigator.userAgent.indexOf('MSIE') !== -1 || window.navigator.appVersion.indexOf('Trident/') > 0);
    };
    FileDrop.eventHasFiles = function(event) {
        // In most browsers this is an array, but in IE11 it's an Object :(
        var hasFiles = false;
        if (event.dataTransfer) {
            var types = event.dataTransfer.types;
            for(var keyOrIndex in types)if (types[keyOrIndex] === 'Files') {
                hasFiles = true;
                break;
            }
        }
        return hasFiles;
    };
    FileDrop.propTypes = {
        className: prop_types_1.default.string,
        targetClassName: prop_types_1.default.string,
        draggingOverFrameClassName: prop_types_1.default.string,
        draggingOverTargetClassName: prop_types_1.default.string,
        onDragOver: prop_types_1.default.func,
        onDragLeave: prop_types_1.default.func,
        onDrop: prop_types_1.default.func,
        onTargetClick: prop_types_1.default.func,
        dropEffect: prop_types_1.default.oneOf([
            'copy',
            'move',
            'link',
            'none'
        ]),
        frame: function(props, propName, componentName) {
            var prop = props[propName];
            if (prop == null) return new Error('Warning: Required prop `' + propName + '` was not specified in `' + componentName + '`');
            if (prop !== document && !(prop instanceof HTMLElement)) return new Error('Warning: Prop `' + propName + '` must be one of the following: document, HTMLElement!');
        },
        onFrameDragEnter: prop_types_1.default.func,
        onFrameDragLeave: prop_types_1.default.func,
        onFrameDrop: prop_types_1.default.func
    };
    FileDrop.defaultProps = {
        dropEffect: 'copy',
        frame: typeof window === 'undefined' ? undefined : window.document,
        className: 'file-drop',
        targetClassName: 'file-drop-target',
        draggingOverFrameClassName: 'file-drop-dragging-over-frame',
        draggingOverTargetClassName: 'file-drop-dragging-over-target'
    };
    return FileDrop;
}(react_1.default.PureComponent);
exports.FileDrop = FileDrop;

},{"73f083f5fc2d995d":"esp3E","2f17f104354398d4":"lXMxO"}],"esp3E":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"iXqrb"}],"iXqrb":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"9pMSc"}],"9pMSc":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"lut99":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fa500Px", ()=>Fa500Px);
parcelHelpers.export(exports, "FaAccessibleIcon", ()=>FaAccessibleIcon);
parcelHelpers.export(exports, "FaAccusoft", ()=>FaAccusoft);
parcelHelpers.export(exports, "FaAcquisitionsIncorporated", ()=>FaAcquisitionsIncorporated);
parcelHelpers.export(exports, "FaAdn", ()=>FaAdn);
parcelHelpers.export(exports, "FaAdversal", ()=>FaAdversal);
parcelHelpers.export(exports, "FaAffiliatetheme", ()=>FaAffiliatetheme);
parcelHelpers.export(exports, "FaAirbnb", ()=>FaAirbnb);
parcelHelpers.export(exports, "FaAlgolia", ()=>FaAlgolia);
parcelHelpers.export(exports, "FaAlipay", ()=>FaAlipay);
parcelHelpers.export(exports, "FaAmazonPay", ()=>FaAmazonPay);
parcelHelpers.export(exports, "FaAmazon", ()=>FaAmazon);
parcelHelpers.export(exports, "FaAmilia", ()=>FaAmilia);
parcelHelpers.export(exports, "FaAndroid", ()=>FaAndroid);
parcelHelpers.export(exports, "FaAngellist", ()=>FaAngellist);
parcelHelpers.export(exports, "FaAngrycreative", ()=>FaAngrycreative);
parcelHelpers.export(exports, "FaAngular", ()=>FaAngular);
parcelHelpers.export(exports, "FaAppStoreIos", ()=>FaAppStoreIos);
parcelHelpers.export(exports, "FaAppStore", ()=>FaAppStore);
parcelHelpers.export(exports, "FaApper", ()=>FaApper);
parcelHelpers.export(exports, "FaApplePay", ()=>FaApplePay);
parcelHelpers.export(exports, "FaApple", ()=>FaApple);
parcelHelpers.export(exports, "FaArtstation", ()=>FaArtstation);
parcelHelpers.export(exports, "FaAsymmetrik", ()=>FaAsymmetrik);
parcelHelpers.export(exports, "FaAtlassian", ()=>FaAtlassian);
parcelHelpers.export(exports, "FaAudible", ()=>FaAudible);
parcelHelpers.export(exports, "FaAutoprefixer", ()=>FaAutoprefixer);
parcelHelpers.export(exports, "FaAvianex", ()=>FaAvianex);
parcelHelpers.export(exports, "FaAviato", ()=>FaAviato);
parcelHelpers.export(exports, "FaAws", ()=>FaAws);
parcelHelpers.export(exports, "FaBandcamp", ()=>FaBandcamp);
parcelHelpers.export(exports, "FaBattleNet", ()=>FaBattleNet);
parcelHelpers.export(exports, "FaBehanceSquare", ()=>FaBehanceSquare);
parcelHelpers.export(exports, "FaBehance", ()=>FaBehance);
parcelHelpers.export(exports, "FaBimobject", ()=>FaBimobject);
parcelHelpers.export(exports, "FaBitbucket", ()=>FaBitbucket);
parcelHelpers.export(exports, "FaBitcoin", ()=>FaBitcoin);
parcelHelpers.export(exports, "FaBity", ()=>FaBity);
parcelHelpers.export(exports, "FaBlackTie", ()=>FaBlackTie);
parcelHelpers.export(exports, "FaBlackberry", ()=>FaBlackberry);
parcelHelpers.export(exports, "FaBloggerB", ()=>FaBloggerB);
parcelHelpers.export(exports, "FaBlogger", ()=>FaBlogger);
parcelHelpers.export(exports, "FaBluetoothB", ()=>FaBluetoothB);
parcelHelpers.export(exports, "FaBluetooth", ()=>FaBluetooth);
parcelHelpers.export(exports, "FaBootstrap", ()=>FaBootstrap);
parcelHelpers.export(exports, "FaBtc", ()=>FaBtc);
parcelHelpers.export(exports, "FaBuffer", ()=>FaBuffer);
parcelHelpers.export(exports, "FaBuromobelexperte", ()=>FaBuromobelexperte);
parcelHelpers.export(exports, "FaBuyNLarge", ()=>FaBuyNLarge);
parcelHelpers.export(exports, "FaBuysellads", ()=>FaBuysellads);
parcelHelpers.export(exports, "FaCanadianMapleLeaf", ()=>FaCanadianMapleLeaf);
parcelHelpers.export(exports, "FaCcAmazonPay", ()=>FaCcAmazonPay);
parcelHelpers.export(exports, "FaCcAmex", ()=>FaCcAmex);
parcelHelpers.export(exports, "FaCcApplePay", ()=>FaCcApplePay);
parcelHelpers.export(exports, "FaCcDinersClub", ()=>FaCcDinersClub);
parcelHelpers.export(exports, "FaCcDiscover", ()=>FaCcDiscover);
parcelHelpers.export(exports, "FaCcJcb", ()=>FaCcJcb);
parcelHelpers.export(exports, "FaCcMastercard", ()=>FaCcMastercard);
parcelHelpers.export(exports, "FaCcPaypal", ()=>FaCcPaypal);
parcelHelpers.export(exports, "FaCcStripe", ()=>FaCcStripe);
parcelHelpers.export(exports, "FaCcVisa", ()=>FaCcVisa);
parcelHelpers.export(exports, "FaCentercode", ()=>FaCentercode);
parcelHelpers.export(exports, "FaCentos", ()=>FaCentos);
parcelHelpers.export(exports, "FaChrome", ()=>FaChrome);
parcelHelpers.export(exports, "FaChromecast", ()=>FaChromecast);
parcelHelpers.export(exports, "FaCloudflare", ()=>FaCloudflare);
parcelHelpers.export(exports, "FaCloudscale", ()=>FaCloudscale);
parcelHelpers.export(exports, "FaCloudsmith", ()=>FaCloudsmith);
parcelHelpers.export(exports, "FaCloudversify", ()=>FaCloudversify);
parcelHelpers.export(exports, "FaCodepen", ()=>FaCodepen);
parcelHelpers.export(exports, "FaCodiepie", ()=>FaCodiepie);
parcelHelpers.export(exports, "FaConfluence", ()=>FaConfluence);
parcelHelpers.export(exports, "FaConnectdevelop", ()=>FaConnectdevelop);
parcelHelpers.export(exports, "FaContao", ()=>FaContao);
parcelHelpers.export(exports, "FaCottonBureau", ()=>FaCottonBureau);
parcelHelpers.export(exports, "FaCpanel", ()=>FaCpanel);
parcelHelpers.export(exports, "FaCreativeCommonsBy", ()=>FaCreativeCommonsBy);
parcelHelpers.export(exports, "FaCreativeCommonsNcEu", ()=>FaCreativeCommonsNcEu);
parcelHelpers.export(exports, "FaCreativeCommonsNcJp", ()=>FaCreativeCommonsNcJp);
parcelHelpers.export(exports, "FaCreativeCommonsNc", ()=>FaCreativeCommonsNc);
parcelHelpers.export(exports, "FaCreativeCommonsNd", ()=>FaCreativeCommonsNd);
parcelHelpers.export(exports, "FaCreativeCommonsPdAlt", ()=>FaCreativeCommonsPdAlt);
parcelHelpers.export(exports, "FaCreativeCommonsPd", ()=>FaCreativeCommonsPd);
parcelHelpers.export(exports, "FaCreativeCommonsRemix", ()=>FaCreativeCommonsRemix);
parcelHelpers.export(exports, "FaCreativeCommonsSa", ()=>FaCreativeCommonsSa);
parcelHelpers.export(exports, "FaCreativeCommonsSamplingPlus", ()=>FaCreativeCommonsSamplingPlus);
parcelHelpers.export(exports, "FaCreativeCommonsSampling", ()=>FaCreativeCommonsSampling);
parcelHelpers.export(exports, "FaCreativeCommonsShare", ()=>FaCreativeCommonsShare);
parcelHelpers.export(exports, "FaCreativeCommonsZero", ()=>FaCreativeCommonsZero);
parcelHelpers.export(exports, "FaCreativeCommons", ()=>FaCreativeCommons);
parcelHelpers.export(exports, "FaCriticalRole", ()=>FaCriticalRole);
parcelHelpers.export(exports, "FaCss3Alt", ()=>FaCss3Alt);
parcelHelpers.export(exports, "FaCss3", ()=>FaCss3);
parcelHelpers.export(exports, "FaCuttlefish", ()=>FaCuttlefish);
parcelHelpers.export(exports, "FaDAndDBeyond", ()=>FaDAndDBeyond);
parcelHelpers.export(exports, "FaDAndD", ()=>FaDAndD);
parcelHelpers.export(exports, "FaDailymotion", ()=>FaDailymotion);
parcelHelpers.export(exports, "FaDashcube", ()=>FaDashcube);
parcelHelpers.export(exports, "FaDeezer", ()=>FaDeezer);
parcelHelpers.export(exports, "FaDelicious", ()=>FaDelicious);
parcelHelpers.export(exports, "FaDeploydog", ()=>FaDeploydog);
parcelHelpers.export(exports, "FaDeskpro", ()=>FaDeskpro);
parcelHelpers.export(exports, "FaDev", ()=>FaDev);
parcelHelpers.export(exports, "FaDeviantart", ()=>FaDeviantart);
parcelHelpers.export(exports, "FaDhl", ()=>FaDhl);
parcelHelpers.export(exports, "FaDiaspora", ()=>FaDiaspora);
parcelHelpers.export(exports, "FaDigg", ()=>FaDigg);
parcelHelpers.export(exports, "FaDigitalOcean", ()=>FaDigitalOcean);
parcelHelpers.export(exports, "FaDiscord", ()=>FaDiscord);
parcelHelpers.export(exports, "FaDiscourse", ()=>FaDiscourse);
parcelHelpers.export(exports, "FaDochub", ()=>FaDochub);
parcelHelpers.export(exports, "FaDocker", ()=>FaDocker);
parcelHelpers.export(exports, "FaDraft2Digital", ()=>FaDraft2Digital);
parcelHelpers.export(exports, "FaDribbbleSquare", ()=>FaDribbbleSquare);
parcelHelpers.export(exports, "FaDribbble", ()=>FaDribbble);
parcelHelpers.export(exports, "FaDropbox", ()=>FaDropbox);
parcelHelpers.export(exports, "FaDrupal", ()=>FaDrupal);
parcelHelpers.export(exports, "FaDyalog", ()=>FaDyalog);
parcelHelpers.export(exports, "FaEarlybirds", ()=>FaEarlybirds);
parcelHelpers.export(exports, "FaEbay", ()=>FaEbay);
parcelHelpers.export(exports, "FaEdgeLegacy", ()=>FaEdgeLegacy);
parcelHelpers.export(exports, "FaEdge", ()=>FaEdge);
parcelHelpers.export(exports, "FaElementor", ()=>FaElementor);
parcelHelpers.export(exports, "FaEllo", ()=>FaEllo);
parcelHelpers.export(exports, "FaEmber", ()=>FaEmber);
parcelHelpers.export(exports, "FaEmpire", ()=>FaEmpire);
parcelHelpers.export(exports, "FaEnvira", ()=>FaEnvira);
parcelHelpers.export(exports, "FaErlang", ()=>FaErlang);
parcelHelpers.export(exports, "FaEthereum", ()=>FaEthereum);
parcelHelpers.export(exports, "FaEtsy", ()=>FaEtsy);
parcelHelpers.export(exports, "FaEvernote", ()=>FaEvernote);
parcelHelpers.export(exports, "FaExpeditedssl", ()=>FaExpeditedssl);
parcelHelpers.export(exports, "FaFacebookF", ()=>FaFacebookF);
parcelHelpers.export(exports, "FaFacebookMessenger", ()=>FaFacebookMessenger);
parcelHelpers.export(exports, "FaFacebookSquare", ()=>FaFacebookSquare);
parcelHelpers.export(exports, "FaFacebook", ()=>FaFacebook);
parcelHelpers.export(exports, "FaFantasyFlightGames", ()=>FaFantasyFlightGames);
parcelHelpers.export(exports, "FaFedex", ()=>FaFedex);
parcelHelpers.export(exports, "FaFedora", ()=>FaFedora);
parcelHelpers.export(exports, "FaFigma", ()=>FaFigma);
parcelHelpers.export(exports, "FaFirefoxBrowser", ()=>FaFirefoxBrowser);
parcelHelpers.export(exports, "FaFirefox", ()=>FaFirefox);
parcelHelpers.export(exports, "FaFirstOrderAlt", ()=>FaFirstOrderAlt);
parcelHelpers.export(exports, "FaFirstOrder", ()=>FaFirstOrder);
parcelHelpers.export(exports, "FaFirstdraft", ()=>FaFirstdraft);
parcelHelpers.export(exports, "FaFlickr", ()=>FaFlickr);
parcelHelpers.export(exports, "FaFlipboard", ()=>FaFlipboard);
parcelHelpers.export(exports, "FaFly", ()=>FaFly);
parcelHelpers.export(exports, "FaFontAwesomeAlt", ()=>FaFontAwesomeAlt);
parcelHelpers.export(exports, "FaFontAwesomeFlag", ()=>FaFontAwesomeFlag);
parcelHelpers.export(exports, "FaFontAwesomeLogoFull", ()=>FaFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaFontAwesome", ()=>FaFontAwesome);
parcelHelpers.export(exports, "FaFonticonsFi", ()=>FaFonticonsFi);
parcelHelpers.export(exports, "FaFonticons", ()=>FaFonticons);
parcelHelpers.export(exports, "FaFortAwesomeAlt", ()=>FaFortAwesomeAlt);
parcelHelpers.export(exports, "FaFortAwesome", ()=>FaFortAwesome);
parcelHelpers.export(exports, "FaForumbee", ()=>FaForumbee);
parcelHelpers.export(exports, "FaFoursquare", ()=>FaFoursquare);
parcelHelpers.export(exports, "FaFreeCodeCamp", ()=>FaFreeCodeCamp);
parcelHelpers.export(exports, "FaFreebsd", ()=>FaFreebsd);
parcelHelpers.export(exports, "FaFulcrum", ()=>FaFulcrum);
parcelHelpers.export(exports, "FaGalacticRepublic", ()=>FaGalacticRepublic);
parcelHelpers.export(exports, "FaGalacticSenate", ()=>FaGalacticSenate);
parcelHelpers.export(exports, "FaGetPocket", ()=>FaGetPocket);
parcelHelpers.export(exports, "FaGgCircle", ()=>FaGgCircle);
parcelHelpers.export(exports, "FaGg", ()=>FaGg);
parcelHelpers.export(exports, "FaGitAlt", ()=>FaGitAlt);
parcelHelpers.export(exports, "FaGitSquare", ()=>FaGitSquare);
parcelHelpers.export(exports, "FaGit", ()=>FaGit);
parcelHelpers.export(exports, "FaGithubAlt", ()=>FaGithubAlt);
parcelHelpers.export(exports, "FaGithubSquare", ()=>FaGithubSquare);
parcelHelpers.export(exports, "FaGithub", ()=>FaGithub);
parcelHelpers.export(exports, "FaGitkraken", ()=>FaGitkraken);
parcelHelpers.export(exports, "FaGitlab", ()=>FaGitlab);
parcelHelpers.export(exports, "FaGitter", ()=>FaGitter);
parcelHelpers.export(exports, "FaGlideG", ()=>FaGlideG);
parcelHelpers.export(exports, "FaGlide", ()=>FaGlide);
parcelHelpers.export(exports, "FaGofore", ()=>FaGofore);
parcelHelpers.export(exports, "FaGoodreadsG", ()=>FaGoodreadsG);
parcelHelpers.export(exports, "FaGoodreads", ()=>FaGoodreads);
parcelHelpers.export(exports, "FaGoogleDrive", ()=>FaGoogleDrive);
parcelHelpers.export(exports, "FaGooglePay", ()=>FaGooglePay);
parcelHelpers.export(exports, "FaGooglePlay", ()=>FaGooglePlay);
parcelHelpers.export(exports, "FaGooglePlusG", ()=>FaGooglePlusG);
parcelHelpers.export(exports, "FaGooglePlusSquare", ()=>FaGooglePlusSquare);
parcelHelpers.export(exports, "FaGooglePlus", ()=>FaGooglePlus);
parcelHelpers.export(exports, "FaGoogleWallet", ()=>FaGoogleWallet);
parcelHelpers.export(exports, "FaGoogle", ()=>FaGoogle);
parcelHelpers.export(exports, "FaGratipay", ()=>FaGratipay);
parcelHelpers.export(exports, "FaGrav", ()=>FaGrav);
parcelHelpers.export(exports, "FaGripfire", ()=>FaGripfire);
parcelHelpers.export(exports, "FaGrunt", ()=>FaGrunt);
parcelHelpers.export(exports, "FaGuilded", ()=>FaGuilded);
parcelHelpers.export(exports, "FaGulp", ()=>FaGulp);
parcelHelpers.export(exports, "FaHackerNewsSquare", ()=>FaHackerNewsSquare);
parcelHelpers.export(exports, "FaHackerNews", ()=>FaHackerNews);
parcelHelpers.export(exports, "FaHackerrank", ()=>FaHackerrank);
parcelHelpers.export(exports, "FaHips", ()=>FaHips);
parcelHelpers.export(exports, "FaHireAHelper", ()=>FaHireAHelper);
parcelHelpers.export(exports, "FaHive", ()=>FaHive);
parcelHelpers.export(exports, "FaHooli", ()=>FaHooli);
parcelHelpers.export(exports, "FaHornbill", ()=>FaHornbill);
parcelHelpers.export(exports, "FaHotjar", ()=>FaHotjar);
parcelHelpers.export(exports, "FaHouzz", ()=>FaHouzz);
parcelHelpers.export(exports, "FaHtml5", ()=>FaHtml5);
parcelHelpers.export(exports, "FaHubspot", ()=>FaHubspot);
parcelHelpers.export(exports, "FaIdeal", ()=>FaIdeal);
parcelHelpers.export(exports, "FaImdb", ()=>FaImdb);
parcelHelpers.export(exports, "FaInnosoft", ()=>FaInnosoft);
parcelHelpers.export(exports, "FaInstagramSquare", ()=>FaInstagramSquare);
parcelHelpers.export(exports, "FaInstagram", ()=>FaInstagram);
parcelHelpers.export(exports, "FaInstalod", ()=>FaInstalod);
parcelHelpers.export(exports, "FaIntercom", ()=>FaIntercom);
parcelHelpers.export(exports, "FaInternetExplorer", ()=>FaInternetExplorer);
parcelHelpers.export(exports, "FaInvision", ()=>FaInvision);
parcelHelpers.export(exports, "FaIoxhost", ()=>FaIoxhost);
parcelHelpers.export(exports, "FaItchIo", ()=>FaItchIo);
parcelHelpers.export(exports, "FaItunesNote", ()=>FaItunesNote);
parcelHelpers.export(exports, "FaItunes", ()=>FaItunes);
parcelHelpers.export(exports, "FaJava", ()=>FaJava);
parcelHelpers.export(exports, "FaJediOrder", ()=>FaJediOrder);
parcelHelpers.export(exports, "FaJenkins", ()=>FaJenkins);
parcelHelpers.export(exports, "FaJira", ()=>FaJira);
parcelHelpers.export(exports, "FaJoget", ()=>FaJoget);
parcelHelpers.export(exports, "FaJoomla", ()=>FaJoomla);
parcelHelpers.export(exports, "FaJsSquare", ()=>FaJsSquare);
parcelHelpers.export(exports, "FaJs", ()=>FaJs);
parcelHelpers.export(exports, "FaJsfiddle", ()=>FaJsfiddle);
parcelHelpers.export(exports, "FaKaggle", ()=>FaKaggle);
parcelHelpers.export(exports, "FaKeybase", ()=>FaKeybase);
parcelHelpers.export(exports, "FaKeycdn", ()=>FaKeycdn);
parcelHelpers.export(exports, "FaKickstarterK", ()=>FaKickstarterK);
parcelHelpers.export(exports, "FaKickstarter", ()=>FaKickstarter);
parcelHelpers.export(exports, "FaKorvue", ()=>FaKorvue);
parcelHelpers.export(exports, "FaLaravel", ()=>FaLaravel);
parcelHelpers.export(exports, "FaLastfmSquare", ()=>FaLastfmSquare);
parcelHelpers.export(exports, "FaLastfm", ()=>FaLastfm);
parcelHelpers.export(exports, "FaLeanpub", ()=>FaLeanpub);
parcelHelpers.export(exports, "FaLess", ()=>FaLess);
parcelHelpers.export(exports, "FaLine", ()=>FaLine);
parcelHelpers.export(exports, "FaLinkedinIn", ()=>FaLinkedinIn);
parcelHelpers.export(exports, "FaLinkedin", ()=>FaLinkedin);
parcelHelpers.export(exports, "FaLinode", ()=>FaLinode);
parcelHelpers.export(exports, "FaLinux", ()=>FaLinux);
parcelHelpers.export(exports, "FaLyft", ()=>FaLyft);
parcelHelpers.export(exports, "FaMagento", ()=>FaMagento);
parcelHelpers.export(exports, "FaMailchimp", ()=>FaMailchimp);
parcelHelpers.export(exports, "FaMandalorian", ()=>FaMandalorian);
parcelHelpers.export(exports, "FaMarkdown", ()=>FaMarkdown);
parcelHelpers.export(exports, "FaMastodon", ()=>FaMastodon);
parcelHelpers.export(exports, "FaMaxcdn", ()=>FaMaxcdn);
parcelHelpers.export(exports, "FaMdb", ()=>FaMdb);
parcelHelpers.export(exports, "FaMedapps", ()=>FaMedapps);
parcelHelpers.export(exports, "FaMediumM", ()=>FaMediumM);
parcelHelpers.export(exports, "FaMedium", ()=>FaMedium);
parcelHelpers.export(exports, "FaMedrt", ()=>FaMedrt);
parcelHelpers.export(exports, "FaMeetup", ()=>FaMeetup);
parcelHelpers.export(exports, "FaMegaport", ()=>FaMegaport);
parcelHelpers.export(exports, "FaMendeley", ()=>FaMendeley);
parcelHelpers.export(exports, "FaMicroblog", ()=>FaMicroblog);
parcelHelpers.export(exports, "FaMicrosoft", ()=>FaMicrosoft);
parcelHelpers.export(exports, "FaMix", ()=>FaMix);
parcelHelpers.export(exports, "FaMixcloud", ()=>FaMixcloud);
parcelHelpers.export(exports, "FaMixer", ()=>FaMixer);
parcelHelpers.export(exports, "FaMizuni", ()=>FaMizuni);
parcelHelpers.export(exports, "FaModx", ()=>FaModx);
parcelHelpers.export(exports, "FaMonero", ()=>FaMonero);
parcelHelpers.export(exports, "FaNapster", ()=>FaNapster);
parcelHelpers.export(exports, "FaNeos", ()=>FaNeos);
parcelHelpers.export(exports, "FaNimblr", ()=>FaNimblr);
parcelHelpers.export(exports, "FaNodeJs", ()=>FaNodeJs);
parcelHelpers.export(exports, "FaNode", ()=>FaNode);
parcelHelpers.export(exports, "FaNpm", ()=>FaNpm);
parcelHelpers.export(exports, "FaNs8", ()=>FaNs8);
parcelHelpers.export(exports, "FaNutritionix", ()=>FaNutritionix);
parcelHelpers.export(exports, "FaOctopusDeploy", ()=>FaOctopusDeploy);
parcelHelpers.export(exports, "FaOdnoklassnikiSquare", ()=>FaOdnoklassnikiSquare);
parcelHelpers.export(exports, "FaOdnoklassniki", ()=>FaOdnoklassniki);
parcelHelpers.export(exports, "FaOldRepublic", ()=>FaOldRepublic);
parcelHelpers.export(exports, "FaOpencart", ()=>FaOpencart);
parcelHelpers.export(exports, "FaOpenid", ()=>FaOpenid);
parcelHelpers.export(exports, "FaOpera", ()=>FaOpera);
parcelHelpers.export(exports, "FaOptinMonster", ()=>FaOptinMonster);
parcelHelpers.export(exports, "FaOrcid", ()=>FaOrcid);
parcelHelpers.export(exports, "FaOsi", ()=>FaOsi);
parcelHelpers.export(exports, "FaPage4", ()=>FaPage4);
parcelHelpers.export(exports, "FaPagelines", ()=>FaPagelines);
parcelHelpers.export(exports, "FaPalfed", ()=>FaPalfed);
parcelHelpers.export(exports, "FaPatreon", ()=>FaPatreon);
parcelHelpers.export(exports, "FaPaypal", ()=>FaPaypal);
parcelHelpers.export(exports, "FaPennyArcade", ()=>FaPennyArcade);
parcelHelpers.export(exports, "FaPerbyte", ()=>FaPerbyte);
parcelHelpers.export(exports, "FaPeriscope", ()=>FaPeriscope);
parcelHelpers.export(exports, "FaPhabricator", ()=>FaPhabricator);
parcelHelpers.export(exports, "FaPhoenixFramework", ()=>FaPhoenixFramework);
parcelHelpers.export(exports, "FaPhoenixSquadron", ()=>FaPhoenixSquadron);
parcelHelpers.export(exports, "FaPhp", ()=>FaPhp);
parcelHelpers.export(exports, "FaPiedPiperAlt", ()=>FaPiedPiperAlt);
parcelHelpers.export(exports, "FaPiedPiperHat", ()=>FaPiedPiperHat);
parcelHelpers.export(exports, "FaPiedPiperPp", ()=>FaPiedPiperPp);
parcelHelpers.export(exports, "FaPiedPiperSquare", ()=>FaPiedPiperSquare);
parcelHelpers.export(exports, "FaPiedPiper", ()=>FaPiedPiper);
parcelHelpers.export(exports, "FaPinterestP", ()=>FaPinterestP);
parcelHelpers.export(exports, "FaPinterestSquare", ()=>FaPinterestSquare);
parcelHelpers.export(exports, "FaPinterest", ()=>FaPinterest);
parcelHelpers.export(exports, "FaPlaystation", ()=>FaPlaystation);
parcelHelpers.export(exports, "FaProductHunt", ()=>FaProductHunt);
parcelHelpers.export(exports, "FaPushed", ()=>FaPushed);
parcelHelpers.export(exports, "FaPython", ()=>FaPython);
parcelHelpers.export(exports, "FaQq", ()=>FaQq);
parcelHelpers.export(exports, "FaQuinscape", ()=>FaQuinscape);
parcelHelpers.export(exports, "FaQuora", ()=>FaQuora);
parcelHelpers.export(exports, "FaRProject", ()=>FaRProject);
parcelHelpers.export(exports, "FaRaspberryPi", ()=>FaRaspberryPi);
parcelHelpers.export(exports, "FaRavelry", ()=>FaRavelry);
parcelHelpers.export(exports, "FaReact", ()=>FaReact);
parcelHelpers.export(exports, "FaReacteurope", ()=>FaReacteurope);
parcelHelpers.export(exports, "FaReadme", ()=>FaReadme);
parcelHelpers.export(exports, "FaRebel", ()=>FaRebel);
parcelHelpers.export(exports, "FaRedRiver", ()=>FaRedRiver);
parcelHelpers.export(exports, "FaRedditAlien", ()=>FaRedditAlien);
parcelHelpers.export(exports, "FaRedditSquare", ()=>FaRedditSquare);
parcelHelpers.export(exports, "FaReddit", ()=>FaReddit);
parcelHelpers.export(exports, "FaRedhat", ()=>FaRedhat);
parcelHelpers.export(exports, "FaRenren", ()=>FaRenren);
parcelHelpers.export(exports, "FaReplyd", ()=>FaReplyd);
parcelHelpers.export(exports, "FaResearchgate", ()=>FaResearchgate);
parcelHelpers.export(exports, "FaResolving", ()=>FaResolving);
parcelHelpers.export(exports, "FaRev", ()=>FaRev);
parcelHelpers.export(exports, "FaRocketchat", ()=>FaRocketchat);
parcelHelpers.export(exports, "FaRockrms", ()=>FaRockrms);
parcelHelpers.export(exports, "FaRust", ()=>FaRust);
parcelHelpers.export(exports, "FaSafari", ()=>FaSafari);
parcelHelpers.export(exports, "FaSalesforce", ()=>FaSalesforce);
parcelHelpers.export(exports, "FaSass", ()=>FaSass);
parcelHelpers.export(exports, "FaSchlix", ()=>FaSchlix);
parcelHelpers.export(exports, "FaScribd", ()=>FaScribd);
parcelHelpers.export(exports, "FaSearchengin", ()=>FaSearchengin);
parcelHelpers.export(exports, "FaSellcast", ()=>FaSellcast);
parcelHelpers.export(exports, "FaSellsy", ()=>FaSellsy);
parcelHelpers.export(exports, "FaServicestack", ()=>FaServicestack);
parcelHelpers.export(exports, "FaShirtsinbulk", ()=>FaShirtsinbulk);
parcelHelpers.export(exports, "FaShopify", ()=>FaShopify);
parcelHelpers.export(exports, "FaShopware", ()=>FaShopware);
parcelHelpers.export(exports, "FaSimplybuilt", ()=>FaSimplybuilt);
parcelHelpers.export(exports, "FaSistrix", ()=>FaSistrix);
parcelHelpers.export(exports, "FaSith", ()=>FaSith);
parcelHelpers.export(exports, "FaSketch", ()=>FaSketch);
parcelHelpers.export(exports, "FaSkyatlas", ()=>FaSkyatlas);
parcelHelpers.export(exports, "FaSkype", ()=>FaSkype);
parcelHelpers.export(exports, "FaSlackHash", ()=>FaSlackHash);
parcelHelpers.export(exports, "FaSlack", ()=>FaSlack);
parcelHelpers.export(exports, "FaSlideshare", ()=>FaSlideshare);
parcelHelpers.export(exports, "FaSnapchatGhost", ()=>FaSnapchatGhost);
parcelHelpers.export(exports, "FaSnapchatSquare", ()=>FaSnapchatSquare);
parcelHelpers.export(exports, "FaSnapchat", ()=>FaSnapchat);
parcelHelpers.export(exports, "FaSoundcloud", ()=>FaSoundcloud);
parcelHelpers.export(exports, "FaSourcetree", ()=>FaSourcetree);
parcelHelpers.export(exports, "FaSpeakap", ()=>FaSpeakap);
parcelHelpers.export(exports, "FaSpeakerDeck", ()=>FaSpeakerDeck);
parcelHelpers.export(exports, "FaSpotify", ()=>FaSpotify);
parcelHelpers.export(exports, "FaSquarespace", ()=>FaSquarespace);
parcelHelpers.export(exports, "FaStackExchange", ()=>FaStackExchange);
parcelHelpers.export(exports, "FaStackOverflow", ()=>FaStackOverflow);
parcelHelpers.export(exports, "FaStackpath", ()=>FaStackpath);
parcelHelpers.export(exports, "FaStaylinked", ()=>FaStaylinked);
parcelHelpers.export(exports, "FaSteamSquare", ()=>FaSteamSquare);
parcelHelpers.export(exports, "FaSteamSymbol", ()=>FaSteamSymbol);
parcelHelpers.export(exports, "FaSteam", ()=>FaSteam);
parcelHelpers.export(exports, "FaStickerMule", ()=>FaStickerMule);
parcelHelpers.export(exports, "FaStrava", ()=>FaStrava);
parcelHelpers.export(exports, "FaStripeS", ()=>FaStripeS);
parcelHelpers.export(exports, "FaStripe", ()=>FaStripe);
parcelHelpers.export(exports, "FaStudiovinari", ()=>FaStudiovinari);
parcelHelpers.export(exports, "FaStumbleuponCircle", ()=>FaStumbleuponCircle);
parcelHelpers.export(exports, "FaStumbleupon", ()=>FaStumbleupon);
parcelHelpers.export(exports, "FaSuperpowers", ()=>FaSuperpowers);
parcelHelpers.export(exports, "FaSupple", ()=>FaSupple);
parcelHelpers.export(exports, "FaSuse", ()=>FaSuse);
parcelHelpers.export(exports, "FaSwift", ()=>FaSwift);
parcelHelpers.export(exports, "FaSymfony", ()=>FaSymfony);
parcelHelpers.export(exports, "FaTeamspeak", ()=>FaTeamspeak);
parcelHelpers.export(exports, "FaTelegramPlane", ()=>FaTelegramPlane);
parcelHelpers.export(exports, "FaTelegram", ()=>FaTelegram);
parcelHelpers.export(exports, "FaTencentWeibo", ()=>FaTencentWeibo);
parcelHelpers.export(exports, "FaTheRedYeti", ()=>FaTheRedYeti);
parcelHelpers.export(exports, "FaThemeco", ()=>FaThemeco);
parcelHelpers.export(exports, "FaThemeisle", ()=>FaThemeisle);
parcelHelpers.export(exports, "FaThinkPeaks", ()=>FaThinkPeaks);
parcelHelpers.export(exports, "FaTiktok", ()=>FaTiktok);
parcelHelpers.export(exports, "FaTradeFederation", ()=>FaTradeFederation);
parcelHelpers.export(exports, "FaTrello", ()=>FaTrello);
parcelHelpers.export(exports, "FaTripadvisor", ()=>FaTripadvisor);
parcelHelpers.export(exports, "FaTumblrSquare", ()=>FaTumblrSquare);
parcelHelpers.export(exports, "FaTumblr", ()=>FaTumblr);
parcelHelpers.export(exports, "FaTwitch", ()=>FaTwitch);
parcelHelpers.export(exports, "FaTwitterSquare", ()=>FaTwitterSquare);
parcelHelpers.export(exports, "FaTwitter", ()=>FaTwitter);
parcelHelpers.export(exports, "FaTypo3", ()=>FaTypo3);
parcelHelpers.export(exports, "FaUber", ()=>FaUber);
parcelHelpers.export(exports, "FaUbuntu", ()=>FaUbuntu);
parcelHelpers.export(exports, "FaUikit", ()=>FaUikit);
parcelHelpers.export(exports, "FaUmbraco", ()=>FaUmbraco);
parcelHelpers.export(exports, "FaUncharted", ()=>FaUncharted);
parcelHelpers.export(exports, "FaUniregistry", ()=>FaUniregistry);
parcelHelpers.export(exports, "FaUnity", ()=>FaUnity);
parcelHelpers.export(exports, "FaUnsplash", ()=>FaUnsplash);
parcelHelpers.export(exports, "FaUntappd", ()=>FaUntappd);
parcelHelpers.export(exports, "FaUps", ()=>FaUps);
parcelHelpers.export(exports, "FaUsb", ()=>FaUsb);
parcelHelpers.export(exports, "FaUsps", ()=>FaUsps);
parcelHelpers.export(exports, "FaUssunnah", ()=>FaUssunnah);
parcelHelpers.export(exports, "FaVaadin", ()=>FaVaadin);
parcelHelpers.export(exports, "FaViacoin", ()=>FaViacoin);
parcelHelpers.export(exports, "FaViadeoSquare", ()=>FaViadeoSquare);
parcelHelpers.export(exports, "FaViadeo", ()=>FaViadeo);
parcelHelpers.export(exports, "FaViber", ()=>FaViber);
parcelHelpers.export(exports, "FaVimeoSquare", ()=>FaVimeoSquare);
parcelHelpers.export(exports, "FaVimeoV", ()=>FaVimeoV);
parcelHelpers.export(exports, "FaVimeo", ()=>FaVimeo);
parcelHelpers.export(exports, "FaVine", ()=>FaVine);
parcelHelpers.export(exports, "FaVk", ()=>FaVk);
parcelHelpers.export(exports, "FaVnv", ()=>FaVnv);
parcelHelpers.export(exports, "FaVuejs", ()=>FaVuejs);
parcelHelpers.export(exports, "FaWatchmanMonitoring", ()=>FaWatchmanMonitoring);
parcelHelpers.export(exports, "FaWaze", ()=>FaWaze);
parcelHelpers.export(exports, "FaWeebly", ()=>FaWeebly);
parcelHelpers.export(exports, "FaWeibo", ()=>FaWeibo);
parcelHelpers.export(exports, "FaWeixin", ()=>FaWeixin);
parcelHelpers.export(exports, "FaWhatsappSquare", ()=>FaWhatsappSquare);
parcelHelpers.export(exports, "FaWhatsapp", ()=>FaWhatsapp);
parcelHelpers.export(exports, "FaWhmcs", ()=>FaWhmcs);
parcelHelpers.export(exports, "FaWikipediaW", ()=>FaWikipediaW);
parcelHelpers.export(exports, "FaWindows", ()=>FaWindows);
parcelHelpers.export(exports, "FaWix", ()=>FaWix);
parcelHelpers.export(exports, "FaWizardsOfTheCoast", ()=>FaWizardsOfTheCoast);
parcelHelpers.export(exports, "FaWodu", ()=>FaWodu);
parcelHelpers.export(exports, "FaWolfPackBattalion", ()=>FaWolfPackBattalion);
parcelHelpers.export(exports, "FaWordpressSimple", ()=>FaWordpressSimple);
parcelHelpers.export(exports, "FaWordpress", ()=>FaWordpress);
parcelHelpers.export(exports, "FaWpbeginner", ()=>FaWpbeginner);
parcelHelpers.export(exports, "FaWpexplorer", ()=>FaWpexplorer);
parcelHelpers.export(exports, "FaWpforms", ()=>FaWpforms);
parcelHelpers.export(exports, "FaWpressr", ()=>FaWpressr);
parcelHelpers.export(exports, "FaXbox", ()=>FaXbox);
parcelHelpers.export(exports, "FaXingSquare", ()=>FaXingSquare);
parcelHelpers.export(exports, "FaXing", ()=>FaXing);
parcelHelpers.export(exports, "FaYCombinator", ()=>FaYCombinator);
parcelHelpers.export(exports, "FaYahoo", ()=>FaYahoo);
parcelHelpers.export(exports, "FaYammer", ()=>FaYammer);
parcelHelpers.export(exports, "FaYandexInternational", ()=>FaYandexInternational);
parcelHelpers.export(exports, "FaYandex", ()=>FaYandex);
parcelHelpers.export(exports, "FaYarn", ()=>FaYarn);
parcelHelpers.export(exports, "FaYelp", ()=>FaYelp);
parcelHelpers.export(exports, "FaYoast", ()=>FaYoast);
parcelHelpers.export(exports, "FaYoutubeSquare", ()=>FaYoutubeSquare);
parcelHelpers.export(exports, "FaYoutube", ()=>FaYoutube);
parcelHelpers.export(exports, "FaZhihu", ()=>FaZhihu);
parcelHelpers.export(exports, "FaAd", ()=>FaAd);
parcelHelpers.export(exports, "FaAddressBook", ()=>FaAddressBook);
parcelHelpers.export(exports, "FaAddressCard", ()=>FaAddressCard);
parcelHelpers.export(exports, "FaAdjust", ()=>FaAdjust);
parcelHelpers.export(exports, "FaAirFreshener", ()=>FaAirFreshener);
parcelHelpers.export(exports, "FaAlignCenter", ()=>FaAlignCenter);
parcelHelpers.export(exports, "FaAlignJustify", ()=>FaAlignJustify);
parcelHelpers.export(exports, "FaAlignLeft", ()=>FaAlignLeft);
parcelHelpers.export(exports, "FaAlignRight", ()=>FaAlignRight);
parcelHelpers.export(exports, "FaAllergies", ()=>FaAllergies);
parcelHelpers.export(exports, "FaAmbulance", ()=>FaAmbulance);
parcelHelpers.export(exports, "FaAmericanSignLanguageInterpreting", ()=>FaAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "FaAnchor", ()=>FaAnchor);
parcelHelpers.export(exports, "FaAngleDoubleDown", ()=>FaAngleDoubleDown);
parcelHelpers.export(exports, "FaAngleDoubleLeft", ()=>FaAngleDoubleLeft);
parcelHelpers.export(exports, "FaAngleDoubleRight", ()=>FaAngleDoubleRight);
parcelHelpers.export(exports, "FaAngleDoubleUp", ()=>FaAngleDoubleUp);
parcelHelpers.export(exports, "FaAngleDown", ()=>FaAngleDown);
parcelHelpers.export(exports, "FaAngleLeft", ()=>FaAngleLeft);
parcelHelpers.export(exports, "FaAngleRight", ()=>FaAngleRight);
parcelHelpers.export(exports, "FaAngleUp", ()=>FaAngleUp);
parcelHelpers.export(exports, "FaAngry", ()=>FaAngry);
parcelHelpers.export(exports, "FaAnkh", ()=>FaAnkh);
parcelHelpers.export(exports, "FaAppleAlt", ()=>FaAppleAlt);
parcelHelpers.export(exports, "FaArchive", ()=>FaArchive);
parcelHelpers.export(exports, "FaArchway", ()=>FaArchway);
parcelHelpers.export(exports, "FaArrowAltCircleDown", ()=>FaArrowAltCircleDown);
parcelHelpers.export(exports, "FaArrowAltCircleLeft", ()=>FaArrowAltCircleLeft);
parcelHelpers.export(exports, "FaArrowAltCircleRight", ()=>FaArrowAltCircleRight);
parcelHelpers.export(exports, "FaArrowAltCircleUp", ()=>FaArrowAltCircleUp);
parcelHelpers.export(exports, "FaArrowCircleDown", ()=>FaArrowCircleDown);
parcelHelpers.export(exports, "FaArrowCircleLeft", ()=>FaArrowCircleLeft);
parcelHelpers.export(exports, "FaArrowCircleRight", ()=>FaArrowCircleRight);
parcelHelpers.export(exports, "FaArrowCircleUp", ()=>FaArrowCircleUp);
parcelHelpers.export(exports, "FaArrowDown", ()=>FaArrowDown);
parcelHelpers.export(exports, "FaArrowLeft", ()=>FaArrowLeft);
parcelHelpers.export(exports, "FaArrowRight", ()=>FaArrowRight);
parcelHelpers.export(exports, "FaArrowUp", ()=>FaArrowUp);
parcelHelpers.export(exports, "FaArrowsAltH", ()=>FaArrowsAltH);
parcelHelpers.export(exports, "FaArrowsAltV", ()=>FaArrowsAltV);
parcelHelpers.export(exports, "FaArrowsAlt", ()=>FaArrowsAlt);
parcelHelpers.export(exports, "FaAssistiveListeningSystems", ()=>FaAssistiveListeningSystems);
parcelHelpers.export(exports, "FaAsterisk", ()=>FaAsterisk);
parcelHelpers.export(exports, "FaAt", ()=>FaAt);
parcelHelpers.export(exports, "FaAtlas", ()=>FaAtlas);
parcelHelpers.export(exports, "FaAtom", ()=>FaAtom);
parcelHelpers.export(exports, "FaAudioDescription", ()=>FaAudioDescription);
parcelHelpers.export(exports, "FaAward", ()=>FaAward);
parcelHelpers.export(exports, "FaBabyCarriage", ()=>FaBabyCarriage);
parcelHelpers.export(exports, "FaBaby", ()=>FaBaby);
parcelHelpers.export(exports, "FaBackspace", ()=>FaBackspace);
parcelHelpers.export(exports, "FaBackward", ()=>FaBackward);
parcelHelpers.export(exports, "FaBacon", ()=>FaBacon);
parcelHelpers.export(exports, "FaBacteria", ()=>FaBacteria);
parcelHelpers.export(exports, "FaBacterium", ()=>FaBacterium);
parcelHelpers.export(exports, "FaBahai", ()=>FaBahai);
parcelHelpers.export(exports, "FaBalanceScaleLeft", ()=>FaBalanceScaleLeft);
parcelHelpers.export(exports, "FaBalanceScaleRight", ()=>FaBalanceScaleRight);
parcelHelpers.export(exports, "FaBalanceScale", ()=>FaBalanceScale);
parcelHelpers.export(exports, "FaBan", ()=>FaBan);
parcelHelpers.export(exports, "FaBandAid", ()=>FaBandAid);
parcelHelpers.export(exports, "FaBarcode", ()=>FaBarcode);
parcelHelpers.export(exports, "FaBars", ()=>FaBars);
parcelHelpers.export(exports, "FaBaseballBall", ()=>FaBaseballBall);
parcelHelpers.export(exports, "FaBasketballBall", ()=>FaBasketballBall);
parcelHelpers.export(exports, "FaBath", ()=>FaBath);
parcelHelpers.export(exports, "FaBatteryEmpty", ()=>FaBatteryEmpty);
parcelHelpers.export(exports, "FaBatteryFull", ()=>FaBatteryFull);
parcelHelpers.export(exports, "FaBatteryHalf", ()=>FaBatteryHalf);
parcelHelpers.export(exports, "FaBatteryQuarter", ()=>FaBatteryQuarter);
parcelHelpers.export(exports, "FaBatteryThreeQuarters", ()=>FaBatteryThreeQuarters);
parcelHelpers.export(exports, "FaBed", ()=>FaBed);
parcelHelpers.export(exports, "FaBeer", ()=>FaBeer);
parcelHelpers.export(exports, "FaBellSlash", ()=>FaBellSlash);
parcelHelpers.export(exports, "FaBell", ()=>FaBell);
parcelHelpers.export(exports, "FaBezierCurve", ()=>FaBezierCurve);
parcelHelpers.export(exports, "FaBible", ()=>FaBible);
parcelHelpers.export(exports, "FaBicycle", ()=>FaBicycle);
parcelHelpers.export(exports, "FaBiking", ()=>FaBiking);
parcelHelpers.export(exports, "FaBinoculars", ()=>FaBinoculars);
parcelHelpers.export(exports, "FaBiohazard", ()=>FaBiohazard);
parcelHelpers.export(exports, "FaBirthdayCake", ()=>FaBirthdayCake);
parcelHelpers.export(exports, "FaBlenderPhone", ()=>FaBlenderPhone);
parcelHelpers.export(exports, "FaBlender", ()=>FaBlender);
parcelHelpers.export(exports, "FaBlind", ()=>FaBlind);
parcelHelpers.export(exports, "FaBlog", ()=>FaBlog);
parcelHelpers.export(exports, "FaBold", ()=>FaBold);
parcelHelpers.export(exports, "FaBolt", ()=>FaBolt);
parcelHelpers.export(exports, "FaBomb", ()=>FaBomb);
parcelHelpers.export(exports, "FaBone", ()=>FaBone);
parcelHelpers.export(exports, "FaBong", ()=>FaBong);
parcelHelpers.export(exports, "FaBookDead", ()=>FaBookDead);
parcelHelpers.export(exports, "FaBookMedical", ()=>FaBookMedical);
parcelHelpers.export(exports, "FaBookOpen", ()=>FaBookOpen);
parcelHelpers.export(exports, "FaBookReader", ()=>FaBookReader);
parcelHelpers.export(exports, "FaBook", ()=>FaBook);
parcelHelpers.export(exports, "FaBookmark", ()=>FaBookmark);
parcelHelpers.export(exports, "FaBorderAll", ()=>FaBorderAll);
parcelHelpers.export(exports, "FaBorderNone", ()=>FaBorderNone);
parcelHelpers.export(exports, "FaBorderStyle", ()=>FaBorderStyle);
parcelHelpers.export(exports, "FaBowlingBall", ()=>FaBowlingBall);
parcelHelpers.export(exports, "FaBoxOpen", ()=>FaBoxOpen);
parcelHelpers.export(exports, "FaBoxTissue", ()=>FaBoxTissue);
parcelHelpers.export(exports, "FaBox", ()=>FaBox);
parcelHelpers.export(exports, "FaBoxes", ()=>FaBoxes);
parcelHelpers.export(exports, "FaBraille", ()=>FaBraille);
parcelHelpers.export(exports, "FaBrain", ()=>FaBrain);
parcelHelpers.export(exports, "FaBreadSlice", ()=>FaBreadSlice);
parcelHelpers.export(exports, "FaBriefcaseMedical", ()=>FaBriefcaseMedical);
parcelHelpers.export(exports, "FaBriefcase", ()=>FaBriefcase);
parcelHelpers.export(exports, "FaBroadcastTower", ()=>FaBroadcastTower);
parcelHelpers.export(exports, "FaBroom", ()=>FaBroom);
parcelHelpers.export(exports, "FaBrush", ()=>FaBrush);
parcelHelpers.export(exports, "FaBug", ()=>FaBug);
parcelHelpers.export(exports, "FaBuilding", ()=>FaBuilding);
parcelHelpers.export(exports, "FaBullhorn", ()=>FaBullhorn);
parcelHelpers.export(exports, "FaBullseye", ()=>FaBullseye);
parcelHelpers.export(exports, "FaBurn", ()=>FaBurn);
parcelHelpers.export(exports, "FaBusAlt", ()=>FaBusAlt);
parcelHelpers.export(exports, "FaBus", ()=>FaBus);
parcelHelpers.export(exports, "FaBusinessTime", ()=>FaBusinessTime);
parcelHelpers.export(exports, "FaCalculator", ()=>FaCalculator);
parcelHelpers.export(exports, "FaCalendarAlt", ()=>FaCalendarAlt);
parcelHelpers.export(exports, "FaCalendarCheck", ()=>FaCalendarCheck);
parcelHelpers.export(exports, "FaCalendarDay", ()=>FaCalendarDay);
parcelHelpers.export(exports, "FaCalendarMinus", ()=>FaCalendarMinus);
parcelHelpers.export(exports, "FaCalendarPlus", ()=>FaCalendarPlus);
parcelHelpers.export(exports, "FaCalendarTimes", ()=>FaCalendarTimes);
parcelHelpers.export(exports, "FaCalendarWeek", ()=>FaCalendarWeek);
parcelHelpers.export(exports, "FaCalendar", ()=>FaCalendar);
parcelHelpers.export(exports, "FaCameraRetro", ()=>FaCameraRetro);
parcelHelpers.export(exports, "FaCamera", ()=>FaCamera);
parcelHelpers.export(exports, "FaCampground", ()=>FaCampground);
parcelHelpers.export(exports, "FaCandyCane", ()=>FaCandyCane);
parcelHelpers.export(exports, "FaCannabis", ()=>FaCannabis);
parcelHelpers.export(exports, "FaCapsules", ()=>FaCapsules);
parcelHelpers.export(exports, "FaCarAlt", ()=>FaCarAlt);
parcelHelpers.export(exports, "FaCarBattery", ()=>FaCarBattery);
parcelHelpers.export(exports, "FaCarCrash", ()=>FaCarCrash);
parcelHelpers.export(exports, "FaCarSide", ()=>FaCarSide);
parcelHelpers.export(exports, "FaCar", ()=>FaCar);
parcelHelpers.export(exports, "FaCaravan", ()=>FaCaravan);
parcelHelpers.export(exports, "FaCaretDown", ()=>FaCaretDown);
parcelHelpers.export(exports, "FaCaretLeft", ()=>FaCaretLeft);
parcelHelpers.export(exports, "FaCaretRight", ()=>FaCaretRight);
parcelHelpers.export(exports, "FaCaretSquareDown", ()=>FaCaretSquareDown);
parcelHelpers.export(exports, "FaCaretSquareLeft", ()=>FaCaretSquareLeft);
parcelHelpers.export(exports, "FaCaretSquareRight", ()=>FaCaretSquareRight);
parcelHelpers.export(exports, "FaCaretSquareUp", ()=>FaCaretSquareUp);
parcelHelpers.export(exports, "FaCaretUp", ()=>FaCaretUp);
parcelHelpers.export(exports, "FaCarrot", ()=>FaCarrot);
parcelHelpers.export(exports, "FaCartArrowDown", ()=>FaCartArrowDown);
parcelHelpers.export(exports, "FaCartPlus", ()=>FaCartPlus);
parcelHelpers.export(exports, "FaCashRegister", ()=>FaCashRegister);
parcelHelpers.export(exports, "FaCat", ()=>FaCat);
parcelHelpers.export(exports, "FaCertificate", ()=>FaCertificate);
parcelHelpers.export(exports, "FaChair", ()=>FaChair);
parcelHelpers.export(exports, "FaChalkboardTeacher", ()=>FaChalkboardTeacher);
parcelHelpers.export(exports, "FaChalkboard", ()=>FaChalkboard);
parcelHelpers.export(exports, "FaChargingStation", ()=>FaChargingStation);
parcelHelpers.export(exports, "FaChartArea", ()=>FaChartArea);
parcelHelpers.export(exports, "FaChartBar", ()=>FaChartBar);
parcelHelpers.export(exports, "FaChartLine", ()=>FaChartLine);
parcelHelpers.export(exports, "FaChartPie", ()=>FaChartPie);
parcelHelpers.export(exports, "FaCheckCircle", ()=>FaCheckCircle);
parcelHelpers.export(exports, "FaCheckDouble", ()=>FaCheckDouble);
parcelHelpers.export(exports, "FaCheckSquare", ()=>FaCheckSquare);
parcelHelpers.export(exports, "FaCheck", ()=>FaCheck);
parcelHelpers.export(exports, "FaCheese", ()=>FaCheese);
parcelHelpers.export(exports, "FaChessBishop", ()=>FaChessBishop);
parcelHelpers.export(exports, "FaChessBoard", ()=>FaChessBoard);
parcelHelpers.export(exports, "FaChessKing", ()=>FaChessKing);
parcelHelpers.export(exports, "FaChessKnight", ()=>FaChessKnight);
parcelHelpers.export(exports, "FaChessPawn", ()=>FaChessPawn);
parcelHelpers.export(exports, "FaChessQueen", ()=>FaChessQueen);
parcelHelpers.export(exports, "FaChessRook", ()=>FaChessRook);
parcelHelpers.export(exports, "FaChess", ()=>FaChess);
parcelHelpers.export(exports, "FaChevronCircleDown", ()=>FaChevronCircleDown);
parcelHelpers.export(exports, "FaChevronCircleLeft", ()=>FaChevronCircleLeft);
parcelHelpers.export(exports, "FaChevronCircleRight", ()=>FaChevronCircleRight);
parcelHelpers.export(exports, "FaChevronCircleUp", ()=>FaChevronCircleUp);
parcelHelpers.export(exports, "FaChevronDown", ()=>FaChevronDown);
parcelHelpers.export(exports, "FaChevronLeft", ()=>FaChevronLeft);
parcelHelpers.export(exports, "FaChevronRight", ()=>FaChevronRight);
parcelHelpers.export(exports, "FaChevronUp", ()=>FaChevronUp);
parcelHelpers.export(exports, "FaChild", ()=>FaChild);
parcelHelpers.export(exports, "FaChurch", ()=>FaChurch);
parcelHelpers.export(exports, "FaCircleNotch", ()=>FaCircleNotch);
parcelHelpers.export(exports, "FaCircle", ()=>FaCircle);
parcelHelpers.export(exports, "FaCity", ()=>FaCity);
parcelHelpers.export(exports, "FaClinicMedical", ()=>FaClinicMedical);
parcelHelpers.export(exports, "FaClipboardCheck", ()=>FaClipboardCheck);
parcelHelpers.export(exports, "FaClipboardList", ()=>FaClipboardList);
parcelHelpers.export(exports, "FaClipboard", ()=>FaClipboard);
parcelHelpers.export(exports, "FaClock", ()=>FaClock);
parcelHelpers.export(exports, "FaClone", ()=>FaClone);
parcelHelpers.export(exports, "FaClosedCaptioning", ()=>FaClosedCaptioning);
parcelHelpers.export(exports, "FaCloudDownloadAlt", ()=>FaCloudDownloadAlt);
parcelHelpers.export(exports, "FaCloudMeatball", ()=>FaCloudMeatball);
parcelHelpers.export(exports, "FaCloudMoonRain", ()=>FaCloudMoonRain);
parcelHelpers.export(exports, "FaCloudMoon", ()=>FaCloudMoon);
parcelHelpers.export(exports, "FaCloudRain", ()=>FaCloudRain);
parcelHelpers.export(exports, "FaCloudShowersHeavy", ()=>FaCloudShowersHeavy);
parcelHelpers.export(exports, "FaCloudSunRain", ()=>FaCloudSunRain);
parcelHelpers.export(exports, "FaCloudSun", ()=>FaCloudSun);
parcelHelpers.export(exports, "FaCloudUploadAlt", ()=>FaCloudUploadAlt);
parcelHelpers.export(exports, "FaCloud", ()=>FaCloud);
parcelHelpers.export(exports, "FaCocktail", ()=>FaCocktail);
parcelHelpers.export(exports, "FaCodeBranch", ()=>FaCodeBranch);
parcelHelpers.export(exports, "FaCode", ()=>FaCode);
parcelHelpers.export(exports, "FaCoffee", ()=>FaCoffee);
parcelHelpers.export(exports, "FaCog", ()=>FaCog);
parcelHelpers.export(exports, "FaCogs", ()=>FaCogs);
parcelHelpers.export(exports, "FaCoins", ()=>FaCoins);
parcelHelpers.export(exports, "FaColumns", ()=>FaColumns);
parcelHelpers.export(exports, "FaCommentAlt", ()=>FaCommentAlt);
parcelHelpers.export(exports, "FaCommentDollar", ()=>FaCommentDollar);
parcelHelpers.export(exports, "FaCommentDots", ()=>FaCommentDots);
parcelHelpers.export(exports, "FaCommentMedical", ()=>FaCommentMedical);
parcelHelpers.export(exports, "FaCommentSlash", ()=>FaCommentSlash);
parcelHelpers.export(exports, "FaComment", ()=>FaComment);
parcelHelpers.export(exports, "FaCommentsDollar", ()=>FaCommentsDollar);
parcelHelpers.export(exports, "FaComments", ()=>FaComments);
parcelHelpers.export(exports, "FaCompactDisc", ()=>FaCompactDisc);
parcelHelpers.export(exports, "FaCompass", ()=>FaCompass);
parcelHelpers.export(exports, "FaCompressAlt", ()=>FaCompressAlt);
parcelHelpers.export(exports, "FaCompressArrowsAlt", ()=>FaCompressArrowsAlt);
parcelHelpers.export(exports, "FaCompress", ()=>FaCompress);
parcelHelpers.export(exports, "FaConciergeBell", ()=>FaConciergeBell);
parcelHelpers.export(exports, "FaCookieBite", ()=>FaCookieBite);
parcelHelpers.export(exports, "FaCookie", ()=>FaCookie);
parcelHelpers.export(exports, "FaCopy", ()=>FaCopy);
parcelHelpers.export(exports, "FaCopyright", ()=>FaCopyright);
parcelHelpers.export(exports, "FaCouch", ()=>FaCouch);
parcelHelpers.export(exports, "FaCreditCard", ()=>FaCreditCard);
parcelHelpers.export(exports, "FaCropAlt", ()=>FaCropAlt);
parcelHelpers.export(exports, "FaCrop", ()=>FaCrop);
parcelHelpers.export(exports, "FaCross", ()=>FaCross);
parcelHelpers.export(exports, "FaCrosshairs", ()=>FaCrosshairs);
parcelHelpers.export(exports, "FaCrow", ()=>FaCrow);
parcelHelpers.export(exports, "FaCrown", ()=>FaCrown);
parcelHelpers.export(exports, "FaCrutch", ()=>FaCrutch);
parcelHelpers.export(exports, "FaCube", ()=>FaCube);
parcelHelpers.export(exports, "FaCubes", ()=>FaCubes);
parcelHelpers.export(exports, "FaCut", ()=>FaCut);
parcelHelpers.export(exports, "FaDatabase", ()=>FaDatabase);
parcelHelpers.export(exports, "FaDeaf", ()=>FaDeaf);
parcelHelpers.export(exports, "FaDemocrat", ()=>FaDemocrat);
parcelHelpers.export(exports, "FaDesktop", ()=>FaDesktop);
parcelHelpers.export(exports, "FaDharmachakra", ()=>FaDharmachakra);
parcelHelpers.export(exports, "FaDiagnoses", ()=>FaDiagnoses);
parcelHelpers.export(exports, "FaDiceD20", ()=>FaDiceD20);
parcelHelpers.export(exports, "FaDiceD6", ()=>FaDiceD6);
parcelHelpers.export(exports, "FaDiceFive", ()=>FaDiceFive);
parcelHelpers.export(exports, "FaDiceFour", ()=>FaDiceFour);
parcelHelpers.export(exports, "FaDiceOne", ()=>FaDiceOne);
parcelHelpers.export(exports, "FaDiceSix", ()=>FaDiceSix);
parcelHelpers.export(exports, "FaDiceThree", ()=>FaDiceThree);
parcelHelpers.export(exports, "FaDiceTwo", ()=>FaDiceTwo);
parcelHelpers.export(exports, "FaDice", ()=>FaDice);
parcelHelpers.export(exports, "FaDigitalTachograph", ()=>FaDigitalTachograph);
parcelHelpers.export(exports, "FaDirections", ()=>FaDirections);
parcelHelpers.export(exports, "FaDisease", ()=>FaDisease);
parcelHelpers.export(exports, "FaDivide", ()=>FaDivide);
parcelHelpers.export(exports, "FaDizzy", ()=>FaDizzy);
parcelHelpers.export(exports, "FaDna", ()=>FaDna);
parcelHelpers.export(exports, "FaDog", ()=>FaDog);
parcelHelpers.export(exports, "FaDollarSign", ()=>FaDollarSign);
parcelHelpers.export(exports, "FaDollyFlatbed", ()=>FaDollyFlatbed);
parcelHelpers.export(exports, "FaDolly", ()=>FaDolly);
parcelHelpers.export(exports, "FaDonate", ()=>FaDonate);
parcelHelpers.export(exports, "FaDoorClosed", ()=>FaDoorClosed);
parcelHelpers.export(exports, "FaDoorOpen", ()=>FaDoorOpen);
parcelHelpers.export(exports, "FaDotCircle", ()=>FaDotCircle);
parcelHelpers.export(exports, "FaDove", ()=>FaDove);
parcelHelpers.export(exports, "FaDownload", ()=>FaDownload);
parcelHelpers.export(exports, "FaDraftingCompass", ()=>FaDraftingCompass);
parcelHelpers.export(exports, "FaDragon", ()=>FaDragon);
parcelHelpers.export(exports, "FaDrawPolygon", ()=>FaDrawPolygon);
parcelHelpers.export(exports, "FaDrumSteelpan", ()=>FaDrumSteelpan);
parcelHelpers.export(exports, "FaDrum", ()=>FaDrum);
parcelHelpers.export(exports, "FaDrumstickBite", ()=>FaDrumstickBite);
parcelHelpers.export(exports, "FaDumbbell", ()=>FaDumbbell);
parcelHelpers.export(exports, "FaDumpsterFire", ()=>FaDumpsterFire);
parcelHelpers.export(exports, "FaDumpster", ()=>FaDumpster);
parcelHelpers.export(exports, "FaDungeon", ()=>FaDungeon);
parcelHelpers.export(exports, "FaEdit", ()=>FaEdit);
parcelHelpers.export(exports, "FaEgg", ()=>FaEgg);
parcelHelpers.export(exports, "FaEject", ()=>FaEject);
parcelHelpers.export(exports, "FaEllipsisH", ()=>FaEllipsisH);
parcelHelpers.export(exports, "FaEllipsisV", ()=>FaEllipsisV);
parcelHelpers.export(exports, "FaEnvelopeOpenText", ()=>FaEnvelopeOpenText);
parcelHelpers.export(exports, "FaEnvelopeOpen", ()=>FaEnvelopeOpen);
parcelHelpers.export(exports, "FaEnvelopeSquare", ()=>FaEnvelopeSquare);
parcelHelpers.export(exports, "FaEnvelope", ()=>FaEnvelope);
parcelHelpers.export(exports, "FaEquals", ()=>FaEquals);
parcelHelpers.export(exports, "FaEraser", ()=>FaEraser);
parcelHelpers.export(exports, "FaEthernet", ()=>FaEthernet);
parcelHelpers.export(exports, "FaEuroSign", ()=>FaEuroSign);
parcelHelpers.export(exports, "FaExchangeAlt", ()=>FaExchangeAlt);
parcelHelpers.export(exports, "FaExclamationCircle", ()=>FaExclamationCircle);
parcelHelpers.export(exports, "FaExclamationTriangle", ()=>FaExclamationTriangle);
parcelHelpers.export(exports, "FaExclamation", ()=>FaExclamation);
parcelHelpers.export(exports, "FaExpandAlt", ()=>FaExpandAlt);
parcelHelpers.export(exports, "FaExpandArrowsAlt", ()=>FaExpandArrowsAlt);
parcelHelpers.export(exports, "FaExpand", ()=>FaExpand);
parcelHelpers.export(exports, "FaExternalLinkAlt", ()=>FaExternalLinkAlt);
parcelHelpers.export(exports, "FaExternalLinkSquareAlt", ()=>FaExternalLinkSquareAlt);
parcelHelpers.export(exports, "FaEyeDropper", ()=>FaEyeDropper);
parcelHelpers.export(exports, "FaEyeSlash", ()=>FaEyeSlash);
parcelHelpers.export(exports, "FaEye", ()=>FaEye);
parcelHelpers.export(exports, "FaFan", ()=>FaFan);
parcelHelpers.export(exports, "FaFastBackward", ()=>FaFastBackward);
parcelHelpers.export(exports, "FaFastForward", ()=>FaFastForward);
parcelHelpers.export(exports, "FaFaucet", ()=>FaFaucet);
parcelHelpers.export(exports, "FaFax", ()=>FaFax);
parcelHelpers.export(exports, "FaFeatherAlt", ()=>FaFeatherAlt);
parcelHelpers.export(exports, "FaFeather", ()=>FaFeather);
parcelHelpers.export(exports, "FaFemale", ()=>FaFemale);
parcelHelpers.export(exports, "FaFighterJet", ()=>FaFighterJet);
parcelHelpers.export(exports, "FaFileAlt", ()=>FaFileAlt);
parcelHelpers.export(exports, "FaFileArchive", ()=>FaFileArchive);
parcelHelpers.export(exports, "FaFileAudio", ()=>FaFileAudio);
parcelHelpers.export(exports, "FaFileCode", ()=>FaFileCode);
parcelHelpers.export(exports, "FaFileContract", ()=>FaFileContract);
parcelHelpers.export(exports, "FaFileCsv", ()=>FaFileCsv);
parcelHelpers.export(exports, "FaFileDownload", ()=>FaFileDownload);
parcelHelpers.export(exports, "FaFileExcel", ()=>FaFileExcel);
parcelHelpers.export(exports, "FaFileExport", ()=>FaFileExport);
parcelHelpers.export(exports, "FaFileImage", ()=>FaFileImage);
parcelHelpers.export(exports, "FaFileImport", ()=>FaFileImport);
parcelHelpers.export(exports, "FaFileInvoiceDollar", ()=>FaFileInvoiceDollar);
parcelHelpers.export(exports, "FaFileInvoice", ()=>FaFileInvoice);
parcelHelpers.export(exports, "FaFileMedicalAlt", ()=>FaFileMedicalAlt);
parcelHelpers.export(exports, "FaFileMedical", ()=>FaFileMedical);
parcelHelpers.export(exports, "FaFilePdf", ()=>FaFilePdf);
parcelHelpers.export(exports, "FaFilePowerpoint", ()=>FaFilePowerpoint);
parcelHelpers.export(exports, "FaFilePrescription", ()=>FaFilePrescription);
parcelHelpers.export(exports, "FaFileSignature", ()=>FaFileSignature);
parcelHelpers.export(exports, "FaFileUpload", ()=>FaFileUpload);
parcelHelpers.export(exports, "FaFileVideo", ()=>FaFileVideo);
parcelHelpers.export(exports, "FaFileWord", ()=>FaFileWord);
parcelHelpers.export(exports, "FaFile", ()=>FaFile);
parcelHelpers.export(exports, "FaFillDrip", ()=>FaFillDrip);
parcelHelpers.export(exports, "FaFill", ()=>FaFill);
parcelHelpers.export(exports, "FaFilm", ()=>FaFilm);
parcelHelpers.export(exports, "FaFilter", ()=>FaFilter);
parcelHelpers.export(exports, "FaFingerprint", ()=>FaFingerprint);
parcelHelpers.export(exports, "FaFireAlt", ()=>FaFireAlt);
parcelHelpers.export(exports, "FaFireExtinguisher", ()=>FaFireExtinguisher);
parcelHelpers.export(exports, "FaFire", ()=>FaFire);
parcelHelpers.export(exports, "FaFirstAid", ()=>FaFirstAid);
parcelHelpers.export(exports, "FaFish", ()=>FaFish);
parcelHelpers.export(exports, "FaFistRaised", ()=>FaFistRaised);
parcelHelpers.export(exports, "FaFlagCheckered", ()=>FaFlagCheckered);
parcelHelpers.export(exports, "FaFlagUsa", ()=>FaFlagUsa);
parcelHelpers.export(exports, "FaFlag", ()=>FaFlag);
parcelHelpers.export(exports, "FaFlask", ()=>FaFlask);
parcelHelpers.export(exports, "FaFlushed", ()=>FaFlushed);
parcelHelpers.export(exports, "FaFolderMinus", ()=>FaFolderMinus);
parcelHelpers.export(exports, "FaFolderOpen", ()=>FaFolderOpen);
parcelHelpers.export(exports, "FaFolderPlus", ()=>FaFolderPlus);
parcelHelpers.export(exports, "FaFolder", ()=>FaFolder);
parcelHelpers.export(exports, "FaFont", ()=>FaFont);
parcelHelpers.export(exports, "FaFootballBall", ()=>FaFootballBall);
parcelHelpers.export(exports, "FaForward", ()=>FaForward);
parcelHelpers.export(exports, "FaFrog", ()=>FaFrog);
parcelHelpers.export(exports, "FaFrownOpen", ()=>FaFrownOpen);
parcelHelpers.export(exports, "FaFrown", ()=>FaFrown);
parcelHelpers.export(exports, "FaFunnelDollar", ()=>FaFunnelDollar);
parcelHelpers.export(exports, "FaFutbol", ()=>FaFutbol);
parcelHelpers.export(exports, "FaGamepad", ()=>FaGamepad);
parcelHelpers.export(exports, "FaGasPump", ()=>FaGasPump);
parcelHelpers.export(exports, "FaGavel", ()=>FaGavel);
parcelHelpers.export(exports, "FaGem", ()=>FaGem);
parcelHelpers.export(exports, "FaGenderless", ()=>FaGenderless);
parcelHelpers.export(exports, "FaGhost", ()=>FaGhost);
parcelHelpers.export(exports, "FaGift", ()=>FaGift);
parcelHelpers.export(exports, "FaGifts", ()=>FaGifts);
parcelHelpers.export(exports, "FaGlassCheers", ()=>FaGlassCheers);
parcelHelpers.export(exports, "FaGlassMartiniAlt", ()=>FaGlassMartiniAlt);
parcelHelpers.export(exports, "FaGlassMartini", ()=>FaGlassMartini);
parcelHelpers.export(exports, "FaGlassWhiskey", ()=>FaGlassWhiskey);
parcelHelpers.export(exports, "FaGlasses", ()=>FaGlasses);
parcelHelpers.export(exports, "FaGlobeAfrica", ()=>FaGlobeAfrica);
parcelHelpers.export(exports, "FaGlobeAmericas", ()=>FaGlobeAmericas);
parcelHelpers.export(exports, "FaGlobeAsia", ()=>FaGlobeAsia);
parcelHelpers.export(exports, "FaGlobeEurope", ()=>FaGlobeEurope);
parcelHelpers.export(exports, "FaGlobe", ()=>FaGlobe);
parcelHelpers.export(exports, "FaGolfBall", ()=>FaGolfBall);
parcelHelpers.export(exports, "FaGopuram", ()=>FaGopuram);
parcelHelpers.export(exports, "FaGraduationCap", ()=>FaGraduationCap);
parcelHelpers.export(exports, "FaGreaterThanEqual", ()=>FaGreaterThanEqual);
parcelHelpers.export(exports, "FaGreaterThan", ()=>FaGreaterThan);
parcelHelpers.export(exports, "FaGrimace", ()=>FaGrimace);
parcelHelpers.export(exports, "FaGrinAlt", ()=>FaGrinAlt);
parcelHelpers.export(exports, "FaGrinBeamSweat", ()=>FaGrinBeamSweat);
parcelHelpers.export(exports, "FaGrinBeam", ()=>FaGrinBeam);
parcelHelpers.export(exports, "FaGrinHearts", ()=>FaGrinHearts);
parcelHelpers.export(exports, "FaGrinSquintTears", ()=>FaGrinSquintTears);
parcelHelpers.export(exports, "FaGrinSquint", ()=>FaGrinSquint);
parcelHelpers.export(exports, "FaGrinStars", ()=>FaGrinStars);
parcelHelpers.export(exports, "FaGrinTears", ()=>FaGrinTears);
parcelHelpers.export(exports, "FaGrinTongueSquint", ()=>FaGrinTongueSquint);
parcelHelpers.export(exports, "FaGrinTongueWink", ()=>FaGrinTongueWink);
parcelHelpers.export(exports, "FaGrinTongue", ()=>FaGrinTongue);
parcelHelpers.export(exports, "FaGrinWink", ()=>FaGrinWink);
parcelHelpers.export(exports, "FaGrin", ()=>FaGrin);
parcelHelpers.export(exports, "FaGripHorizontal", ()=>FaGripHorizontal);
parcelHelpers.export(exports, "FaGripLinesVertical", ()=>FaGripLinesVertical);
parcelHelpers.export(exports, "FaGripLines", ()=>FaGripLines);
parcelHelpers.export(exports, "FaGripVertical", ()=>FaGripVertical);
parcelHelpers.export(exports, "FaGuitar", ()=>FaGuitar);
parcelHelpers.export(exports, "FaHSquare", ()=>FaHSquare);
parcelHelpers.export(exports, "FaHamburger", ()=>FaHamburger);
parcelHelpers.export(exports, "FaHammer", ()=>FaHammer);
parcelHelpers.export(exports, "FaHamsa", ()=>FaHamsa);
parcelHelpers.export(exports, "FaHandHoldingHeart", ()=>FaHandHoldingHeart);
parcelHelpers.export(exports, "FaHandHoldingMedical", ()=>FaHandHoldingMedical);
parcelHelpers.export(exports, "FaHandHoldingUsd", ()=>FaHandHoldingUsd);
parcelHelpers.export(exports, "FaHandHoldingWater", ()=>FaHandHoldingWater);
parcelHelpers.export(exports, "FaHandHolding", ()=>FaHandHolding);
parcelHelpers.export(exports, "FaHandLizard", ()=>FaHandLizard);
parcelHelpers.export(exports, "FaHandMiddleFinger", ()=>FaHandMiddleFinger);
parcelHelpers.export(exports, "FaHandPaper", ()=>FaHandPaper);
parcelHelpers.export(exports, "FaHandPeace", ()=>FaHandPeace);
parcelHelpers.export(exports, "FaHandPointDown", ()=>FaHandPointDown);
parcelHelpers.export(exports, "FaHandPointLeft", ()=>FaHandPointLeft);
parcelHelpers.export(exports, "FaHandPointRight", ()=>FaHandPointRight);
parcelHelpers.export(exports, "FaHandPointUp", ()=>FaHandPointUp);
parcelHelpers.export(exports, "FaHandPointer", ()=>FaHandPointer);
parcelHelpers.export(exports, "FaHandRock", ()=>FaHandRock);
parcelHelpers.export(exports, "FaHandScissors", ()=>FaHandScissors);
parcelHelpers.export(exports, "FaHandSparkles", ()=>FaHandSparkles);
parcelHelpers.export(exports, "FaHandSpock", ()=>FaHandSpock);
parcelHelpers.export(exports, "FaHandsHelping", ()=>FaHandsHelping);
parcelHelpers.export(exports, "FaHandsWash", ()=>FaHandsWash);
parcelHelpers.export(exports, "FaHands", ()=>FaHands);
parcelHelpers.export(exports, "FaHandshakeAltSlash", ()=>FaHandshakeAltSlash);
parcelHelpers.export(exports, "FaHandshakeSlash", ()=>FaHandshakeSlash);
parcelHelpers.export(exports, "FaHandshake", ()=>FaHandshake);
parcelHelpers.export(exports, "FaHanukiah", ()=>FaHanukiah);
parcelHelpers.export(exports, "FaHardHat", ()=>FaHardHat);
parcelHelpers.export(exports, "FaHashtag", ()=>FaHashtag);
parcelHelpers.export(exports, "FaHatCowboySide", ()=>FaHatCowboySide);
parcelHelpers.export(exports, "FaHatCowboy", ()=>FaHatCowboy);
parcelHelpers.export(exports, "FaHatWizard", ()=>FaHatWizard);
parcelHelpers.export(exports, "FaHdd", ()=>FaHdd);
parcelHelpers.export(exports, "FaHeadSideCoughSlash", ()=>FaHeadSideCoughSlash);
parcelHelpers.export(exports, "FaHeadSideCough", ()=>FaHeadSideCough);
parcelHelpers.export(exports, "FaHeadSideMask", ()=>FaHeadSideMask);
parcelHelpers.export(exports, "FaHeadSideVirus", ()=>FaHeadSideVirus);
parcelHelpers.export(exports, "FaHeading", ()=>FaHeading);
parcelHelpers.export(exports, "FaHeadphonesAlt", ()=>FaHeadphonesAlt);
parcelHelpers.export(exports, "FaHeadphones", ()=>FaHeadphones);
parcelHelpers.export(exports, "FaHeadset", ()=>FaHeadset);
parcelHelpers.export(exports, "FaHeartBroken", ()=>FaHeartBroken);
parcelHelpers.export(exports, "FaHeart", ()=>FaHeart);
parcelHelpers.export(exports, "FaHeartbeat", ()=>FaHeartbeat);
parcelHelpers.export(exports, "FaHelicopter", ()=>FaHelicopter);
parcelHelpers.export(exports, "FaHighlighter", ()=>FaHighlighter);
parcelHelpers.export(exports, "FaHiking", ()=>FaHiking);
parcelHelpers.export(exports, "FaHippo", ()=>FaHippo);
parcelHelpers.export(exports, "FaHistory", ()=>FaHistory);
parcelHelpers.export(exports, "FaHockeyPuck", ()=>FaHockeyPuck);
parcelHelpers.export(exports, "FaHollyBerry", ()=>FaHollyBerry);
parcelHelpers.export(exports, "FaHome", ()=>FaHome);
parcelHelpers.export(exports, "FaHorseHead", ()=>FaHorseHead);
parcelHelpers.export(exports, "FaHorse", ()=>FaHorse);
parcelHelpers.export(exports, "FaHospitalAlt", ()=>FaHospitalAlt);
parcelHelpers.export(exports, "FaHospitalSymbol", ()=>FaHospitalSymbol);
parcelHelpers.export(exports, "FaHospitalUser", ()=>FaHospitalUser);
parcelHelpers.export(exports, "FaHospital", ()=>FaHospital);
parcelHelpers.export(exports, "FaHotTub", ()=>FaHotTub);
parcelHelpers.export(exports, "FaHotdog", ()=>FaHotdog);
parcelHelpers.export(exports, "FaHotel", ()=>FaHotel);
parcelHelpers.export(exports, "FaHourglassEnd", ()=>FaHourglassEnd);
parcelHelpers.export(exports, "FaHourglassHalf", ()=>FaHourglassHalf);
parcelHelpers.export(exports, "FaHourglassStart", ()=>FaHourglassStart);
parcelHelpers.export(exports, "FaHourglass", ()=>FaHourglass);
parcelHelpers.export(exports, "FaHouseDamage", ()=>FaHouseDamage);
parcelHelpers.export(exports, "FaHouseUser", ()=>FaHouseUser);
parcelHelpers.export(exports, "FaHryvnia", ()=>FaHryvnia);
parcelHelpers.export(exports, "FaICursor", ()=>FaICursor);
parcelHelpers.export(exports, "FaIceCream", ()=>FaIceCream);
parcelHelpers.export(exports, "FaIcicles", ()=>FaIcicles);
parcelHelpers.export(exports, "FaIcons", ()=>FaIcons);
parcelHelpers.export(exports, "FaIdBadge", ()=>FaIdBadge);
parcelHelpers.export(exports, "FaIdCardAlt", ()=>FaIdCardAlt);
parcelHelpers.export(exports, "FaIdCard", ()=>FaIdCard);
parcelHelpers.export(exports, "FaIgloo", ()=>FaIgloo);
parcelHelpers.export(exports, "FaImage", ()=>FaImage);
parcelHelpers.export(exports, "FaImages", ()=>FaImages);
parcelHelpers.export(exports, "FaInbox", ()=>FaInbox);
parcelHelpers.export(exports, "FaIndent", ()=>FaIndent);
parcelHelpers.export(exports, "FaIndustry", ()=>FaIndustry);
parcelHelpers.export(exports, "FaInfinity", ()=>FaInfinity);
parcelHelpers.export(exports, "FaInfoCircle", ()=>FaInfoCircle);
parcelHelpers.export(exports, "FaInfo", ()=>FaInfo);
parcelHelpers.export(exports, "FaItalic", ()=>FaItalic);
parcelHelpers.export(exports, "FaJedi", ()=>FaJedi);
parcelHelpers.export(exports, "FaJoint", ()=>FaJoint);
parcelHelpers.export(exports, "FaJournalWhills", ()=>FaJournalWhills);
parcelHelpers.export(exports, "FaKaaba", ()=>FaKaaba);
parcelHelpers.export(exports, "FaKey", ()=>FaKey);
parcelHelpers.export(exports, "FaKeyboard", ()=>FaKeyboard);
parcelHelpers.export(exports, "FaKhanda", ()=>FaKhanda);
parcelHelpers.export(exports, "FaKissBeam", ()=>FaKissBeam);
parcelHelpers.export(exports, "FaKissWinkHeart", ()=>FaKissWinkHeart);
parcelHelpers.export(exports, "FaKiss", ()=>FaKiss);
parcelHelpers.export(exports, "FaKiwiBird", ()=>FaKiwiBird);
parcelHelpers.export(exports, "FaLandmark", ()=>FaLandmark);
parcelHelpers.export(exports, "FaLanguage", ()=>FaLanguage);
parcelHelpers.export(exports, "FaLaptopCode", ()=>FaLaptopCode);
parcelHelpers.export(exports, "FaLaptopHouse", ()=>FaLaptopHouse);
parcelHelpers.export(exports, "FaLaptopMedical", ()=>FaLaptopMedical);
parcelHelpers.export(exports, "FaLaptop", ()=>FaLaptop);
parcelHelpers.export(exports, "FaLaughBeam", ()=>FaLaughBeam);
parcelHelpers.export(exports, "FaLaughSquint", ()=>FaLaughSquint);
parcelHelpers.export(exports, "FaLaughWink", ()=>FaLaughWink);
parcelHelpers.export(exports, "FaLaugh", ()=>FaLaugh);
parcelHelpers.export(exports, "FaLayerGroup", ()=>FaLayerGroup);
parcelHelpers.export(exports, "FaLeaf", ()=>FaLeaf);
parcelHelpers.export(exports, "FaLemon", ()=>FaLemon);
parcelHelpers.export(exports, "FaLessThanEqual", ()=>FaLessThanEqual);
parcelHelpers.export(exports, "FaLessThan", ()=>FaLessThan);
parcelHelpers.export(exports, "FaLevelDownAlt", ()=>FaLevelDownAlt);
parcelHelpers.export(exports, "FaLevelUpAlt", ()=>FaLevelUpAlt);
parcelHelpers.export(exports, "FaLifeRing", ()=>FaLifeRing);
parcelHelpers.export(exports, "FaLightbulb", ()=>FaLightbulb);
parcelHelpers.export(exports, "FaLink", ()=>FaLink);
parcelHelpers.export(exports, "FaLiraSign", ()=>FaLiraSign);
parcelHelpers.export(exports, "FaListAlt", ()=>FaListAlt);
parcelHelpers.export(exports, "FaListOl", ()=>FaListOl);
parcelHelpers.export(exports, "FaListUl", ()=>FaListUl);
parcelHelpers.export(exports, "FaList", ()=>FaList);
parcelHelpers.export(exports, "FaLocationArrow", ()=>FaLocationArrow);
parcelHelpers.export(exports, "FaLockOpen", ()=>FaLockOpen);
parcelHelpers.export(exports, "FaLock", ()=>FaLock);
parcelHelpers.export(exports, "FaLongArrowAltDown", ()=>FaLongArrowAltDown);
parcelHelpers.export(exports, "FaLongArrowAltLeft", ()=>FaLongArrowAltLeft);
parcelHelpers.export(exports, "FaLongArrowAltRight", ()=>FaLongArrowAltRight);
parcelHelpers.export(exports, "FaLongArrowAltUp", ()=>FaLongArrowAltUp);
parcelHelpers.export(exports, "FaLowVision", ()=>FaLowVision);
parcelHelpers.export(exports, "FaLuggageCart", ()=>FaLuggageCart);
parcelHelpers.export(exports, "FaLungsVirus", ()=>FaLungsVirus);
parcelHelpers.export(exports, "FaLungs", ()=>FaLungs);
parcelHelpers.export(exports, "FaMagic", ()=>FaMagic);
parcelHelpers.export(exports, "FaMagnet", ()=>FaMagnet);
parcelHelpers.export(exports, "FaMailBulk", ()=>FaMailBulk);
parcelHelpers.export(exports, "FaMale", ()=>FaMale);
parcelHelpers.export(exports, "FaMapMarkedAlt", ()=>FaMapMarkedAlt);
parcelHelpers.export(exports, "FaMapMarked", ()=>FaMapMarked);
parcelHelpers.export(exports, "FaMapMarkerAlt", ()=>FaMapMarkerAlt);
parcelHelpers.export(exports, "FaMapMarker", ()=>FaMapMarker);
parcelHelpers.export(exports, "FaMapPin", ()=>FaMapPin);
parcelHelpers.export(exports, "FaMapSigns", ()=>FaMapSigns);
parcelHelpers.export(exports, "FaMap", ()=>FaMap);
parcelHelpers.export(exports, "FaMarker", ()=>FaMarker);
parcelHelpers.export(exports, "FaMarsDouble", ()=>FaMarsDouble);
parcelHelpers.export(exports, "FaMarsStrokeH", ()=>FaMarsStrokeH);
parcelHelpers.export(exports, "FaMarsStrokeV", ()=>FaMarsStrokeV);
parcelHelpers.export(exports, "FaMarsStroke", ()=>FaMarsStroke);
parcelHelpers.export(exports, "FaMars", ()=>FaMars);
parcelHelpers.export(exports, "FaMask", ()=>FaMask);
parcelHelpers.export(exports, "FaMedal", ()=>FaMedal);
parcelHelpers.export(exports, "FaMedkit", ()=>FaMedkit);
parcelHelpers.export(exports, "FaMehBlank", ()=>FaMehBlank);
parcelHelpers.export(exports, "FaMehRollingEyes", ()=>FaMehRollingEyes);
parcelHelpers.export(exports, "FaMeh", ()=>FaMeh);
parcelHelpers.export(exports, "FaMemory", ()=>FaMemory);
parcelHelpers.export(exports, "FaMenorah", ()=>FaMenorah);
parcelHelpers.export(exports, "FaMercury", ()=>FaMercury);
parcelHelpers.export(exports, "FaMeteor", ()=>FaMeteor);
parcelHelpers.export(exports, "FaMicrochip", ()=>FaMicrochip);
parcelHelpers.export(exports, "FaMicrophoneAltSlash", ()=>FaMicrophoneAltSlash);
parcelHelpers.export(exports, "FaMicrophoneAlt", ()=>FaMicrophoneAlt);
parcelHelpers.export(exports, "FaMicrophoneSlash", ()=>FaMicrophoneSlash);
parcelHelpers.export(exports, "FaMicrophone", ()=>FaMicrophone);
parcelHelpers.export(exports, "FaMicroscope", ()=>FaMicroscope);
parcelHelpers.export(exports, "FaMinusCircle", ()=>FaMinusCircle);
parcelHelpers.export(exports, "FaMinusSquare", ()=>FaMinusSquare);
parcelHelpers.export(exports, "FaMinus", ()=>FaMinus);
parcelHelpers.export(exports, "FaMitten", ()=>FaMitten);
parcelHelpers.export(exports, "FaMobileAlt", ()=>FaMobileAlt);
parcelHelpers.export(exports, "FaMobile", ()=>FaMobile);
parcelHelpers.export(exports, "FaMoneyBillAlt", ()=>FaMoneyBillAlt);
parcelHelpers.export(exports, "FaMoneyBillWaveAlt", ()=>FaMoneyBillWaveAlt);
parcelHelpers.export(exports, "FaMoneyBillWave", ()=>FaMoneyBillWave);
parcelHelpers.export(exports, "FaMoneyBill", ()=>FaMoneyBill);
parcelHelpers.export(exports, "FaMoneyCheckAlt", ()=>FaMoneyCheckAlt);
parcelHelpers.export(exports, "FaMoneyCheck", ()=>FaMoneyCheck);
parcelHelpers.export(exports, "FaMonument", ()=>FaMonument);
parcelHelpers.export(exports, "FaMoon", ()=>FaMoon);
parcelHelpers.export(exports, "FaMortarPestle", ()=>FaMortarPestle);
parcelHelpers.export(exports, "FaMosque", ()=>FaMosque);
parcelHelpers.export(exports, "FaMotorcycle", ()=>FaMotorcycle);
parcelHelpers.export(exports, "FaMountain", ()=>FaMountain);
parcelHelpers.export(exports, "FaMousePointer", ()=>FaMousePointer);
parcelHelpers.export(exports, "FaMouse", ()=>FaMouse);
parcelHelpers.export(exports, "FaMugHot", ()=>FaMugHot);
parcelHelpers.export(exports, "FaMusic", ()=>FaMusic);
parcelHelpers.export(exports, "FaNetworkWired", ()=>FaNetworkWired);
parcelHelpers.export(exports, "FaNeuter", ()=>FaNeuter);
parcelHelpers.export(exports, "FaNewspaper", ()=>FaNewspaper);
parcelHelpers.export(exports, "FaNotEqual", ()=>FaNotEqual);
parcelHelpers.export(exports, "FaNotesMedical", ()=>FaNotesMedical);
parcelHelpers.export(exports, "FaObjectGroup", ()=>FaObjectGroup);
parcelHelpers.export(exports, "FaObjectUngroup", ()=>FaObjectUngroup);
parcelHelpers.export(exports, "FaOilCan", ()=>FaOilCan);
parcelHelpers.export(exports, "FaOm", ()=>FaOm);
parcelHelpers.export(exports, "FaOtter", ()=>FaOtter);
parcelHelpers.export(exports, "FaOutdent", ()=>FaOutdent);
parcelHelpers.export(exports, "FaPager", ()=>FaPager);
parcelHelpers.export(exports, "FaPaintBrush", ()=>FaPaintBrush);
parcelHelpers.export(exports, "FaPaintRoller", ()=>FaPaintRoller);
parcelHelpers.export(exports, "FaPalette", ()=>FaPalette);
parcelHelpers.export(exports, "FaPallet", ()=>FaPallet);
parcelHelpers.export(exports, "FaPaperPlane", ()=>FaPaperPlane);
parcelHelpers.export(exports, "FaPaperclip", ()=>FaPaperclip);
parcelHelpers.export(exports, "FaParachuteBox", ()=>FaParachuteBox);
parcelHelpers.export(exports, "FaParagraph", ()=>FaParagraph);
parcelHelpers.export(exports, "FaParking", ()=>FaParking);
parcelHelpers.export(exports, "FaPassport", ()=>FaPassport);
parcelHelpers.export(exports, "FaPastafarianism", ()=>FaPastafarianism);
parcelHelpers.export(exports, "FaPaste", ()=>FaPaste);
parcelHelpers.export(exports, "FaPauseCircle", ()=>FaPauseCircle);
parcelHelpers.export(exports, "FaPause", ()=>FaPause);
parcelHelpers.export(exports, "FaPaw", ()=>FaPaw);
parcelHelpers.export(exports, "FaPeace", ()=>FaPeace);
parcelHelpers.export(exports, "FaPenAlt", ()=>FaPenAlt);
parcelHelpers.export(exports, "FaPenFancy", ()=>FaPenFancy);
parcelHelpers.export(exports, "FaPenNib", ()=>FaPenNib);
parcelHelpers.export(exports, "FaPenSquare", ()=>FaPenSquare);
parcelHelpers.export(exports, "FaPen", ()=>FaPen);
parcelHelpers.export(exports, "FaPencilAlt", ()=>FaPencilAlt);
parcelHelpers.export(exports, "FaPencilRuler", ()=>FaPencilRuler);
parcelHelpers.export(exports, "FaPeopleArrows", ()=>FaPeopleArrows);
parcelHelpers.export(exports, "FaPeopleCarry", ()=>FaPeopleCarry);
parcelHelpers.export(exports, "FaPepperHot", ()=>FaPepperHot);
parcelHelpers.export(exports, "FaPercent", ()=>FaPercent);
parcelHelpers.export(exports, "FaPercentage", ()=>FaPercentage);
parcelHelpers.export(exports, "FaPersonBooth", ()=>FaPersonBooth);
parcelHelpers.export(exports, "FaPhoneAlt", ()=>FaPhoneAlt);
parcelHelpers.export(exports, "FaPhoneSlash", ()=>FaPhoneSlash);
parcelHelpers.export(exports, "FaPhoneSquareAlt", ()=>FaPhoneSquareAlt);
parcelHelpers.export(exports, "FaPhoneSquare", ()=>FaPhoneSquare);
parcelHelpers.export(exports, "FaPhoneVolume", ()=>FaPhoneVolume);
parcelHelpers.export(exports, "FaPhone", ()=>FaPhone);
parcelHelpers.export(exports, "FaPhotoVideo", ()=>FaPhotoVideo);
parcelHelpers.export(exports, "FaPiggyBank", ()=>FaPiggyBank);
parcelHelpers.export(exports, "FaPills", ()=>FaPills);
parcelHelpers.export(exports, "FaPizzaSlice", ()=>FaPizzaSlice);
parcelHelpers.export(exports, "FaPlaceOfWorship", ()=>FaPlaceOfWorship);
parcelHelpers.export(exports, "FaPlaneArrival", ()=>FaPlaneArrival);
parcelHelpers.export(exports, "FaPlaneDeparture", ()=>FaPlaneDeparture);
parcelHelpers.export(exports, "FaPlaneSlash", ()=>FaPlaneSlash);
parcelHelpers.export(exports, "FaPlane", ()=>FaPlane);
parcelHelpers.export(exports, "FaPlayCircle", ()=>FaPlayCircle);
parcelHelpers.export(exports, "FaPlay", ()=>FaPlay);
parcelHelpers.export(exports, "FaPlug", ()=>FaPlug);
parcelHelpers.export(exports, "FaPlusCircle", ()=>FaPlusCircle);
parcelHelpers.export(exports, "FaPlusSquare", ()=>FaPlusSquare);
parcelHelpers.export(exports, "FaPlus", ()=>FaPlus);
parcelHelpers.export(exports, "FaPodcast", ()=>FaPodcast);
parcelHelpers.export(exports, "FaPollH", ()=>FaPollH);
parcelHelpers.export(exports, "FaPoll", ()=>FaPoll);
parcelHelpers.export(exports, "FaPooStorm", ()=>FaPooStorm);
parcelHelpers.export(exports, "FaPoo", ()=>FaPoo);
parcelHelpers.export(exports, "FaPoop", ()=>FaPoop);
parcelHelpers.export(exports, "FaPortrait", ()=>FaPortrait);
parcelHelpers.export(exports, "FaPoundSign", ()=>FaPoundSign);
parcelHelpers.export(exports, "FaPowerOff", ()=>FaPowerOff);
parcelHelpers.export(exports, "FaPray", ()=>FaPray);
parcelHelpers.export(exports, "FaPrayingHands", ()=>FaPrayingHands);
parcelHelpers.export(exports, "FaPrescriptionBottleAlt", ()=>FaPrescriptionBottleAlt);
parcelHelpers.export(exports, "FaPrescriptionBottle", ()=>FaPrescriptionBottle);
parcelHelpers.export(exports, "FaPrescription", ()=>FaPrescription);
parcelHelpers.export(exports, "FaPrint", ()=>FaPrint);
parcelHelpers.export(exports, "FaProcedures", ()=>FaProcedures);
parcelHelpers.export(exports, "FaProjectDiagram", ()=>FaProjectDiagram);
parcelHelpers.export(exports, "FaPumpMedical", ()=>FaPumpMedical);
parcelHelpers.export(exports, "FaPumpSoap", ()=>FaPumpSoap);
parcelHelpers.export(exports, "FaPuzzlePiece", ()=>FaPuzzlePiece);
parcelHelpers.export(exports, "FaQrcode", ()=>FaQrcode);
parcelHelpers.export(exports, "FaQuestionCircle", ()=>FaQuestionCircle);
parcelHelpers.export(exports, "FaQuestion", ()=>FaQuestion);
parcelHelpers.export(exports, "FaQuidditch", ()=>FaQuidditch);
parcelHelpers.export(exports, "FaQuoteLeft", ()=>FaQuoteLeft);
parcelHelpers.export(exports, "FaQuoteRight", ()=>FaQuoteRight);
parcelHelpers.export(exports, "FaQuran", ()=>FaQuran);
parcelHelpers.export(exports, "FaRadiationAlt", ()=>FaRadiationAlt);
parcelHelpers.export(exports, "FaRadiation", ()=>FaRadiation);
parcelHelpers.export(exports, "FaRainbow", ()=>FaRainbow);
parcelHelpers.export(exports, "FaRandom", ()=>FaRandom);
parcelHelpers.export(exports, "FaReceipt", ()=>FaReceipt);
parcelHelpers.export(exports, "FaRecordVinyl", ()=>FaRecordVinyl);
parcelHelpers.export(exports, "FaRecycle", ()=>FaRecycle);
parcelHelpers.export(exports, "FaRedoAlt", ()=>FaRedoAlt);
parcelHelpers.export(exports, "FaRedo", ()=>FaRedo);
parcelHelpers.export(exports, "FaRegistered", ()=>FaRegistered);
parcelHelpers.export(exports, "FaRemoveFormat", ()=>FaRemoveFormat);
parcelHelpers.export(exports, "FaReplyAll", ()=>FaReplyAll);
parcelHelpers.export(exports, "FaReply", ()=>FaReply);
parcelHelpers.export(exports, "FaRepublican", ()=>FaRepublican);
parcelHelpers.export(exports, "FaRestroom", ()=>FaRestroom);
parcelHelpers.export(exports, "FaRetweet", ()=>FaRetweet);
parcelHelpers.export(exports, "FaRibbon", ()=>FaRibbon);
parcelHelpers.export(exports, "FaRing", ()=>FaRing);
parcelHelpers.export(exports, "FaRoad", ()=>FaRoad);
parcelHelpers.export(exports, "FaRobot", ()=>FaRobot);
parcelHelpers.export(exports, "FaRocket", ()=>FaRocket);
parcelHelpers.export(exports, "FaRoute", ()=>FaRoute);
parcelHelpers.export(exports, "FaRssSquare", ()=>FaRssSquare);
parcelHelpers.export(exports, "FaRss", ()=>FaRss);
parcelHelpers.export(exports, "FaRubleSign", ()=>FaRubleSign);
parcelHelpers.export(exports, "FaRulerCombined", ()=>FaRulerCombined);
parcelHelpers.export(exports, "FaRulerHorizontal", ()=>FaRulerHorizontal);
parcelHelpers.export(exports, "FaRulerVertical", ()=>FaRulerVertical);
parcelHelpers.export(exports, "FaRuler", ()=>FaRuler);
parcelHelpers.export(exports, "FaRunning", ()=>FaRunning);
parcelHelpers.export(exports, "FaRupeeSign", ()=>FaRupeeSign);
parcelHelpers.export(exports, "FaSadCry", ()=>FaSadCry);
parcelHelpers.export(exports, "FaSadTear", ()=>FaSadTear);
parcelHelpers.export(exports, "FaSatelliteDish", ()=>FaSatelliteDish);
parcelHelpers.export(exports, "FaSatellite", ()=>FaSatellite);
parcelHelpers.export(exports, "FaSave", ()=>FaSave);
parcelHelpers.export(exports, "FaSchool", ()=>FaSchool);
parcelHelpers.export(exports, "FaScrewdriver", ()=>FaScrewdriver);
parcelHelpers.export(exports, "FaScroll", ()=>FaScroll);
parcelHelpers.export(exports, "FaSdCard", ()=>FaSdCard);
parcelHelpers.export(exports, "FaSearchDollar", ()=>FaSearchDollar);
parcelHelpers.export(exports, "FaSearchLocation", ()=>FaSearchLocation);
parcelHelpers.export(exports, "FaSearchMinus", ()=>FaSearchMinus);
parcelHelpers.export(exports, "FaSearchPlus", ()=>FaSearchPlus);
parcelHelpers.export(exports, "FaSearch", ()=>FaSearch);
parcelHelpers.export(exports, "FaSeedling", ()=>FaSeedling);
parcelHelpers.export(exports, "FaServer", ()=>FaServer);
parcelHelpers.export(exports, "FaShapes", ()=>FaShapes);
parcelHelpers.export(exports, "FaShareAltSquare", ()=>FaShareAltSquare);
parcelHelpers.export(exports, "FaShareAlt", ()=>FaShareAlt);
parcelHelpers.export(exports, "FaShareSquare", ()=>FaShareSquare);
parcelHelpers.export(exports, "FaShare", ()=>FaShare);
parcelHelpers.export(exports, "FaShekelSign", ()=>FaShekelSign);
parcelHelpers.export(exports, "FaShieldAlt", ()=>FaShieldAlt);
parcelHelpers.export(exports, "FaShieldVirus", ()=>FaShieldVirus);
parcelHelpers.export(exports, "FaShip", ()=>FaShip);
parcelHelpers.export(exports, "FaShippingFast", ()=>FaShippingFast);
parcelHelpers.export(exports, "FaShoePrints", ()=>FaShoePrints);
parcelHelpers.export(exports, "FaShoppingBag", ()=>FaShoppingBag);
parcelHelpers.export(exports, "FaShoppingBasket", ()=>FaShoppingBasket);
parcelHelpers.export(exports, "FaShoppingCart", ()=>FaShoppingCart);
parcelHelpers.export(exports, "FaShower", ()=>FaShower);
parcelHelpers.export(exports, "FaShuttleVan", ()=>FaShuttleVan);
parcelHelpers.export(exports, "FaSignInAlt", ()=>FaSignInAlt);
parcelHelpers.export(exports, "FaSignLanguage", ()=>FaSignLanguage);
parcelHelpers.export(exports, "FaSignOutAlt", ()=>FaSignOutAlt);
parcelHelpers.export(exports, "FaSign", ()=>FaSign);
parcelHelpers.export(exports, "FaSignal", ()=>FaSignal);
parcelHelpers.export(exports, "FaSignature", ()=>FaSignature);
parcelHelpers.export(exports, "FaSimCard", ()=>FaSimCard);
parcelHelpers.export(exports, "FaSink", ()=>FaSink);
parcelHelpers.export(exports, "FaSitemap", ()=>FaSitemap);
parcelHelpers.export(exports, "FaSkating", ()=>FaSkating);
parcelHelpers.export(exports, "FaSkiingNordic", ()=>FaSkiingNordic);
parcelHelpers.export(exports, "FaSkiing", ()=>FaSkiing);
parcelHelpers.export(exports, "FaSkullCrossbones", ()=>FaSkullCrossbones);
parcelHelpers.export(exports, "FaSkull", ()=>FaSkull);
parcelHelpers.export(exports, "FaSlash", ()=>FaSlash);
parcelHelpers.export(exports, "FaSleigh", ()=>FaSleigh);
parcelHelpers.export(exports, "FaSlidersH", ()=>FaSlidersH);
parcelHelpers.export(exports, "FaSmileBeam", ()=>FaSmileBeam);
parcelHelpers.export(exports, "FaSmileWink", ()=>FaSmileWink);
parcelHelpers.export(exports, "FaSmile", ()=>FaSmile);
parcelHelpers.export(exports, "FaSmog", ()=>FaSmog);
parcelHelpers.export(exports, "FaSmokingBan", ()=>FaSmokingBan);
parcelHelpers.export(exports, "FaSmoking", ()=>FaSmoking);
parcelHelpers.export(exports, "FaSms", ()=>FaSms);
parcelHelpers.export(exports, "FaSnowboarding", ()=>FaSnowboarding);
parcelHelpers.export(exports, "FaSnowflake", ()=>FaSnowflake);
parcelHelpers.export(exports, "FaSnowman", ()=>FaSnowman);
parcelHelpers.export(exports, "FaSnowplow", ()=>FaSnowplow);
parcelHelpers.export(exports, "FaSoap", ()=>FaSoap);
parcelHelpers.export(exports, "FaSocks", ()=>FaSocks);
parcelHelpers.export(exports, "FaSolarPanel", ()=>FaSolarPanel);
parcelHelpers.export(exports, "FaSortAlphaDownAlt", ()=>FaSortAlphaDownAlt);
parcelHelpers.export(exports, "FaSortAlphaDown", ()=>FaSortAlphaDown);
parcelHelpers.export(exports, "FaSortAlphaUpAlt", ()=>FaSortAlphaUpAlt);
parcelHelpers.export(exports, "FaSortAlphaUp", ()=>FaSortAlphaUp);
parcelHelpers.export(exports, "FaSortAmountDownAlt", ()=>FaSortAmountDownAlt);
parcelHelpers.export(exports, "FaSortAmountDown", ()=>FaSortAmountDown);
parcelHelpers.export(exports, "FaSortAmountUpAlt", ()=>FaSortAmountUpAlt);
parcelHelpers.export(exports, "FaSortAmountUp", ()=>FaSortAmountUp);
parcelHelpers.export(exports, "FaSortDown", ()=>FaSortDown);
parcelHelpers.export(exports, "FaSortNumericDownAlt", ()=>FaSortNumericDownAlt);
parcelHelpers.export(exports, "FaSortNumericDown", ()=>FaSortNumericDown);
parcelHelpers.export(exports, "FaSortNumericUpAlt", ()=>FaSortNumericUpAlt);
parcelHelpers.export(exports, "FaSortNumericUp", ()=>FaSortNumericUp);
parcelHelpers.export(exports, "FaSortUp", ()=>FaSortUp);
parcelHelpers.export(exports, "FaSort", ()=>FaSort);
parcelHelpers.export(exports, "FaSpa", ()=>FaSpa);
parcelHelpers.export(exports, "FaSpaceShuttle", ()=>FaSpaceShuttle);
parcelHelpers.export(exports, "FaSpellCheck", ()=>FaSpellCheck);
parcelHelpers.export(exports, "FaSpider", ()=>FaSpider);
parcelHelpers.export(exports, "FaSpinner", ()=>FaSpinner);
parcelHelpers.export(exports, "FaSplotch", ()=>FaSplotch);
parcelHelpers.export(exports, "FaSprayCan", ()=>FaSprayCan);
parcelHelpers.export(exports, "FaSquareFull", ()=>FaSquareFull);
parcelHelpers.export(exports, "FaSquareRootAlt", ()=>FaSquareRootAlt);
parcelHelpers.export(exports, "FaSquare", ()=>FaSquare);
parcelHelpers.export(exports, "FaStamp", ()=>FaStamp);
parcelHelpers.export(exports, "FaStarAndCrescent", ()=>FaStarAndCrescent);
parcelHelpers.export(exports, "FaStarHalfAlt", ()=>FaStarHalfAlt);
parcelHelpers.export(exports, "FaStarHalf", ()=>FaStarHalf);
parcelHelpers.export(exports, "FaStarOfDavid", ()=>FaStarOfDavid);
parcelHelpers.export(exports, "FaStarOfLife", ()=>FaStarOfLife);
parcelHelpers.export(exports, "FaStar", ()=>FaStar);
parcelHelpers.export(exports, "FaStepBackward", ()=>FaStepBackward);
parcelHelpers.export(exports, "FaStepForward", ()=>FaStepForward);
parcelHelpers.export(exports, "FaStethoscope", ()=>FaStethoscope);
parcelHelpers.export(exports, "FaStickyNote", ()=>FaStickyNote);
parcelHelpers.export(exports, "FaStopCircle", ()=>FaStopCircle);
parcelHelpers.export(exports, "FaStop", ()=>FaStop);
parcelHelpers.export(exports, "FaStopwatch20", ()=>FaStopwatch20);
parcelHelpers.export(exports, "FaStopwatch", ()=>FaStopwatch);
parcelHelpers.export(exports, "FaStoreAltSlash", ()=>FaStoreAltSlash);
parcelHelpers.export(exports, "FaStoreAlt", ()=>FaStoreAlt);
parcelHelpers.export(exports, "FaStoreSlash", ()=>FaStoreSlash);
parcelHelpers.export(exports, "FaStore", ()=>FaStore);
parcelHelpers.export(exports, "FaStream", ()=>FaStream);
parcelHelpers.export(exports, "FaStreetView", ()=>FaStreetView);
parcelHelpers.export(exports, "FaStrikethrough", ()=>FaStrikethrough);
parcelHelpers.export(exports, "FaStroopwafel", ()=>FaStroopwafel);
parcelHelpers.export(exports, "FaSubscript", ()=>FaSubscript);
parcelHelpers.export(exports, "FaSubway", ()=>FaSubway);
parcelHelpers.export(exports, "FaSuitcaseRolling", ()=>FaSuitcaseRolling);
parcelHelpers.export(exports, "FaSuitcase", ()=>FaSuitcase);
parcelHelpers.export(exports, "FaSun", ()=>FaSun);
parcelHelpers.export(exports, "FaSuperscript", ()=>FaSuperscript);
parcelHelpers.export(exports, "FaSurprise", ()=>FaSurprise);
parcelHelpers.export(exports, "FaSwatchbook", ()=>FaSwatchbook);
parcelHelpers.export(exports, "FaSwimmer", ()=>FaSwimmer);
parcelHelpers.export(exports, "FaSwimmingPool", ()=>FaSwimmingPool);
parcelHelpers.export(exports, "FaSynagogue", ()=>FaSynagogue);
parcelHelpers.export(exports, "FaSyncAlt", ()=>FaSyncAlt);
parcelHelpers.export(exports, "FaSync", ()=>FaSync);
parcelHelpers.export(exports, "FaSyringe", ()=>FaSyringe);
parcelHelpers.export(exports, "FaTableTennis", ()=>FaTableTennis);
parcelHelpers.export(exports, "FaTable", ()=>FaTable);
parcelHelpers.export(exports, "FaTabletAlt", ()=>FaTabletAlt);
parcelHelpers.export(exports, "FaTablet", ()=>FaTablet);
parcelHelpers.export(exports, "FaTablets", ()=>FaTablets);
parcelHelpers.export(exports, "FaTachometerAlt", ()=>FaTachometerAlt);
parcelHelpers.export(exports, "FaTag", ()=>FaTag);
parcelHelpers.export(exports, "FaTags", ()=>FaTags);
parcelHelpers.export(exports, "FaTape", ()=>FaTape);
parcelHelpers.export(exports, "FaTasks", ()=>FaTasks);
parcelHelpers.export(exports, "FaTaxi", ()=>FaTaxi);
parcelHelpers.export(exports, "FaTeethOpen", ()=>FaTeethOpen);
parcelHelpers.export(exports, "FaTeeth", ()=>FaTeeth);
parcelHelpers.export(exports, "FaTemperatureHigh", ()=>FaTemperatureHigh);
parcelHelpers.export(exports, "FaTemperatureLow", ()=>FaTemperatureLow);
parcelHelpers.export(exports, "FaTenge", ()=>FaTenge);
parcelHelpers.export(exports, "FaTerminal", ()=>FaTerminal);
parcelHelpers.export(exports, "FaTextHeight", ()=>FaTextHeight);
parcelHelpers.export(exports, "FaTextWidth", ()=>FaTextWidth);
parcelHelpers.export(exports, "FaThLarge", ()=>FaThLarge);
parcelHelpers.export(exports, "FaThList", ()=>FaThList);
parcelHelpers.export(exports, "FaTh", ()=>FaTh);
parcelHelpers.export(exports, "FaTheaterMasks", ()=>FaTheaterMasks);
parcelHelpers.export(exports, "FaThermometerEmpty", ()=>FaThermometerEmpty);
parcelHelpers.export(exports, "FaThermometerFull", ()=>FaThermometerFull);
parcelHelpers.export(exports, "FaThermometerHalf", ()=>FaThermometerHalf);
parcelHelpers.export(exports, "FaThermometerQuarter", ()=>FaThermometerQuarter);
parcelHelpers.export(exports, "FaThermometerThreeQuarters", ()=>FaThermometerThreeQuarters);
parcelHelpers.export(exports, "FaThermometer", ()=>FaThermometer);
parcelHelpers.export(exports, "FaThumbsDown", ()=>FaThumbsDown);
parcelHelpers.export(exports, "FaThumbsUp", ()=>FaThumbsUp);
parcelHelpers.export(exports, "FaThumbtack", ()=>FaThumbtack);
parcelHelpers.export(exports, "FaTicketAlt", ()=>FaTicketAlt);
parcelHelpers.export(exports, "FaTimesCircle", ()=>FaTimesCircle);
parcelHelpers.export(exports, "FaTimes", ()=>FaTimes);
parcelHelpers.export(exports, "FaTintSlash", ()=>FaTintSlash);
parcelHelpers.export(exports, "FaTint", ()=>FaTint);
parcelHelpers.export(exports, "FaTired", ()=>FaTired);
parcelHelpers.export(exports, "FaToggleOff", ()=>FaToggleOff);
parcelHelpers.export(exports, "FaToggleOn", ()=>FaToggleOn);
parcelHelpers.export(exports, "FaToiletPaperSlash", ()=>FaToiletPaperSlash);
parcelHelpers.export(exports, "FaToiletPaper", ()=>FaToiletPaper);
parcelHelpers.export(exports, "FaToilet", ()=>FaToilet);
parcelHelpers.export(exports, "FaToolbox", ()=>FaToolbox);
parcelHelpers.export(exports, "FaTools", ()=>FaTools);
parcelHelpers.export(exports, "FaTooth", ()=>FaTooth);
parcelHelpers.export(exports, "FaTorah", ()=>FaTorah);
parcelHelpers.export(exports, "FaToriiGate", ()=>FaToriiGate);
parcelHelpers.export(exports, "FaTractor", ()=>FaTractor);
parcelHelpers.export(exports, "FaTrademark", ()=>FaTrademark);
parcelHelpers.export(exports, "FaTrafficLight", ()=>FaTrafficLight);
parcelHelpers.export(exports, "FaTrailer", ()=>FaTrailer);
parcelHelpers.export(exports, "FaTrain", ()=>FaTrain);
parcelHelpers.export(exports, "FaTram", ()=>FaTram);
parcelHelpers.export(exports, "FaTransgenderAlt", ()=>FaTransgenderAlt);
parcelHelpers.export(exports, "FaTransgender", ()=>FaTransgender);
parcelHelpers.export(exports, "FaTrashAlt", ()=>FaTrashAlt);
parcelHelpers.export(exports, "FaTrashRestoreAlt", ()=>FaTrashRestoreAlt);
parcelHelpers.export(exports, "FaTrashRestore", ()=>FaTrashRestore);
parcelHelpers.export(exports, "FaTrash", ()=>FaTrash);
parcelHelpers.export(exports, "FaTree", ()=>FaTree);
parcelHelpers.export(exports, "FaTrophy", ()=>FaTrophy);
parcelHelpers.export(exports, "FaTruckLoading", ()=>FaTruckLoading);
parcelHelpers.export(exports, "FaTruckMonster", ()=>FaTruckMonster);
parcelHelpers.export(exports, "FaTruckMoving", ()=>FaTruckMoving);
parcelHelpers.export(exports, "FaTruckPickup", ()=>FaTruckPickup);
parcelHelpers.export(exports, "FaTruck", ()=>FaTruck);
parcelHelpers.export(exports, "FaTshirt", ()=>FaTshirt);
parcelHelpers.export(exports, "FaTty", ()=>FaTty);
parcelHelpers.export(exports, "FaTv", ()=>FaTv);
parcelHelpers.export(exports, "FaUmbrellaBeach", ()=>FaUmbrellaBeach);
parcelHelpers.export(exports, "FaUmbrella", ()=>FaUmbrella);
parcelHelpers.export(exports, "FaUnderline", ()=>FaUnderline);
parcelHelpers.export(exports, "FaUndoAlt", ()=>FaUndoAlt);
parcelHelpers.export(exports, "FaUndo", ()=>FaUndo);
parcelHelpers.export(exports, "FaUniversalAccess", ()=>FaUniversalAccess);
parcelHelpers.export(exports, "FaUniversity", ()=>FaUniversity);
parcelHelpers.export(exports, "FaUnlink", ()=>FaUnlink);
parcelHelpers.export(exports, "FaUnlockAlt", ()=>FaUnlockAlt);
parcelHelpers.export(exports, "FaUnlock", ()=>FaUnlock);
parcelHelpers.export(exports, "FaUpload", ()=>FaUpload);
parcelHelpers.export(exports, "FaUserAltSlash", ()=>FaUserAltSlash);
parcelHelpers.export(exports, "FaUserAlt", ()=>FaUserAlt);
parcelHelpers.export(exports, "FaUserAstronaut", ()=>FaUserAstronaut);
parcelHelpers.export(exports, "FaUserCheck", ()=>FaUserCheck);
parcelHelpers.export(exports, "FaUserCircle", ()=>FaUserCircle);
parcelHelpers.export(exports, "FaUserClock", ()=>FaUserClock);
parcelHelpers.export(exports, "FaUserCog", ()=>FaUserCog);
parcelHelpers.export(exports, "FaUserEdit", ()=>FaUserEdit);
parcelHelpers.export(exports, "FaUserFriends", ()=>FaUserFriends);
parcelHelpers.export(exports, "FaUserGraduate", ()=>FaUserGraduate);
parcelHelpers.export(exports, "FaUserInjured", ()=>FaUserInjured);
parcelHelpers.export(exports, "FaUserLock", ()=>FaUserLock);
parcelHelpers.export(exports, "FaUserMd", ()=>FaUserMd);
parcelHelpers.export(exports, "FaUserMinus", ()=>FaUserMinus);
parcelHelpers.export(exports, "FaUserNinja", ()=>FaUserNinja);
parcelHelpers.export(exports, "FaUserNurse", ()=>FaUserNurse);
parcelHelpers.export(exports, "FaUserPlus", ()=>FaUserPlus);
parcelHelpers.export(exports, "FaUserSecret", ()=>FaUserSecret);
parcelHelpers.export(exports, "FaUserShield", ()=>FaUserShield);
parcelHelpers.export(exports, "FaUserSlash", ()=>FaUserSlash);
parcelHelpers.export(exports, "FaUserTag", ()=>FaUserTag);
parcelHelpers.export(exports, "FaUserTie", ()=>FaUserTie);
parcelHelpers.export(exports, "FaUserTimes", ()=>FaUserTimes);
parcelHelpers.export(exports, "FaUser", ()=>FaUser);
parcelHelpers.export(exports, "FaUsersCog", ()=>FaUsersCog);
parcelHelpers.export(exports, "FaUsersSlash", ()=>FaUsersSlash);
parcelHelpers.export(exports, "FaUsers", ()=>FaUsers);
parcelHelpers.export(exports, "FaUtensilSpoon", ()=>FaUtensilSpoon);
parcelHelpers.export(exports, "FaUtensils", ()=>FaUtensils);
parcelHelpers.export(exports, "FaVectorSquare", ()=>FaVectorSquare);
parcelHelpers.export(exports, "FaVenusDouble", ()=>FaVenusDouble);
parcelHelpers.export(exports, "FaVenusMars", ()=>FaVenusMars);
parcelHelpers.export(exports, "FaVenus", ()=>FaVenus);
parcelHelpers.export(exports, "FaVestPatches", ()=>FaVestPatches);
parcelHelpers.export(exports, "FaVest", ()=>FaVest);
parcelHelpers.export(exports, "FaVial", ()=>FaVial);
parcelHelpers.export(exports, "FaVials", ()=>FaVials);
parcelHelpers.export(exports, "FaVideoSlash", ()=>FaVideoSlash);
parcelHelpers.export(exports, "FaVideo", ()=>FaVideo);
parcelHelpers.export(exports, "FaVihara", ()=>FaVihara);
parcelHelpers.export(exports, "FaVirusSlash", ()=>FaVirusSlash);
parcelHelpers.export(exports, "FaVirus", ()=>FaVirus);
parcelHelpers.export(exports, "FaViruses", ()=>FaViruses);
parcelHelpers.export(exports, "FaVoicemail", ()=>FaVoicemail);
parcelHelpers.export(exports, "FaVolleyballBall", ()=>FaVolleyballBall);
parcelHelpers.export(exports, "FaVolumeDown", ()=>FaVolumeDown);
parcelHelpers.export(exports, "FaVolumeMute", ()=>FaVolumeMute);
parcelHelpers.export(exports, "FaVolumeOff", ()=>FaVolumeOff);
parcelHelpers.export(exports, "FaVolumeUp", ()=>FaVolumeUp);
parcelHelpers.export(exports, "FaVoteYea", ()=>FaVoteYea);
parcelHelpers.export(exports, "FaVrCardboard", ()=>FaVrCardboard);
parcelHelpers.export(exports, "FaWalking", ()=>FaWalking);
parcelHelpers.export(exports, "FaWallet", ()=>FaWallet);
parcelHelpers.export(exports, "FaWarehouse", ()=>FaWarehouse);
parcelHelpers.export(exports, "FaWater", ()=>FaWater);
parcelHelpers.export(exports, "FaWaveSquare", ()=>FaWaveSquare);
parcelHelpers.export(exports, "FaWeightHanging", ()=>FaWeightHanging);
parcelHelpers.export(exports, "FaWeight", ()=>FaWeight);
parcelHelpers.export(exports, "FaWheelchair", ()=>FaWheelchair);
parcelHelpers.export(exports, "FaWifi", ()=>FaWifi);
parcelHelpers.export(exports, "FaWind", ()=>FaWind);
parcelHelpers.export(exports, "FaWindowClose", ()=>FaWindowClose);
parcelHelpers.export(exports, "FaWindowMaximize", ()=>FaWindowMaximize);
parcelHelpers.export(exports, "FaWindowMinimize", ()=>FaWindowMinimize);
parcelHelpers.export(exports, "FaWindowRestore", ()=>FaWindowRestore);
parcelHelpers.export(exports, "FaWineBottle", ()=>FaWineBottle);
parcelHelpers.export(exports, "FaWineGlassAlt", ()=>FaWineGlassAlt);
parcelHelpers.export(exports, "FaWineGlass", ()=>FaWineGlass);
parcelHelpers.export(exports, "FaWonSign", ()=>FaWonSign);
parcelHelpers.export(exports, "FaWrench", ()=>FaWrench);
parcelHelpers.export(exports, "FaXRay", ()=>FaXRay);
parcelHelpers.export(exports, "FaYenSign", ()=>FaYenSign);
parcelHelpers.export(exports, "FaYinYang", ()=>FaYinYang);
parcelHelpers.export(exports, "FaRegAddressBook", ()=>FaRegAddressBook);
parcelHelpers.export(exports, "FaRegAddressCard", ()=>FaRegAddressCard);
parcelHelpers.export(exports, "FaRegAngry", ()=>FaRegAngry);
parcelHelpers.export(exports, "FaRegArrowAltCircleDown", ()=>FaRegArrowAltCircleDown);
parcelHelpers.export(exports, "FaRegArrowAltCircleLeft", ()=>FaRegArrowAltCircleLeft);
parcelHelpers.export(exports, "FaRegArrowAltCircleRight", ()=>FaRegArrowAltCircleRight);
parcelHelpers.export(exports, "FaRegArrowAltCircleUp", ()=>FaRegArrowAltCircleUp);
parcelHelpers.export(exports, "FaRegBellSlash", ()=>FaRegBellSlash);
parcelHelpers.export(exports, "FaRegBell", ()=>FaRegBell);
parcelHelpers.export(exports, "FaRegBookmark", ()=>FaRegBookmark);
parcelHelpers.export(exports, "FaRegBuilding", ()=>FaRegBuilding);
parcelHelpers.export(exports, "FaRegCalendarAlt", ()=>FaRegCalendarAlt);
parcelHelpers.export(exports, "FaRegCalendarCheck", ()=>FaRegCalendarCheck);
parcelHelpers.export(exports, "FaRegCalendarMinus", ()=>FaRegCalendarMinus);
parcelHelpers.export(exports, "FaRegCalendarPlus", ()=>FaRegCalendarPlus);
parcelHelpers.export(exports, "FaRegCalendarTimes", ()=>FaRegCalendarTimes);
parcelHelpers.export(exports, "FaRegCalendar", ()=>FaRegCalendar);
parcelHelpers.export(exports, "FaRegCaretSquareDown", ()=>FaRegCaretSquareDown);
parcelHelpers.export(exports, "FaRegCaretSquareLeft", ()=>FaRegCaretSquareLeft);
parcelHelpers.export(exports, "FaRegCaretSquareRight", ()=>FaRegCaretSquareRight);
parcelHelpers.export(exports, "FaRegCaretSquareUp", ()=>FaRegCaretSquareUp);
parcelHelpers.export(exports, "FaRegChartBar", ()=>FaRegChartBar);
parcelHelpers.export(exports, "FaRegCheckCircle", ()=>FaRegCheckCircle);
parcelHelpers.export(exports, "FaRegCheckSquare", ()=>FaRegCheckSquare);
parcelHelpers.export(exports, "FaRegCircle", ()=>FaRegCircle);
parcelHelpers.export(exports, "FaRegClipboard", ()=>FaRegClipboard);
parcelHelpers.export(exports, "FaRegClock", ()=>FaRegClock);
parcelHelpers.export(exports, "FaRegClone", ()=>FaRegClone);
parcelHelpers.export(exports, "FaRegClosedCaptioning", ()=>FaRegClosedCaptioning);
parcelHelpers.export(exports, "FaRegCommentAlt", ()=>FaRegCommentAlt);
parcelHelpers.export(exports, "FaRegCommentDots", ()=>FaRegCommentDots);
parcelHelpers.export(exports, "FaRegComment", ()=>FaRegComment);
parcelHelpers.export(exports, "FaRegComments", ()=>FaRegComments);
parcelHelpers.export(exports, "FaRegCompass", ()=>FaRegCompass);
parcelHelpers.export(exports, "FaRegCopy", ()=>FaRegCopy);
parcelHelpers.export(exports, "FaRegCopyright", ()=>FaRegCopyright);
parcelHelpers.export(exports, "FaRegCreditCard", ()=>FaRegCreditCard);
parcelHelpers.export(exports, "FaRegDizzy", ()=>FaRegDizzy);
parcelHelpers.export(exports, "FaRegDotCircle", ()=>FaRegDotCircle);
parcelHelpers.export(exports, "FaRegEdit", ()=>FaRegEdit);
parcelHelpers.export(exports, "FaRegEnvelopeOpen", ()=>FaRegEnvelopeOpen);
parcelHelpers.export(exports, "FaRegEnvelope", ()=>FaRegEnvelope);
parcelHelpers.export(exports, "FaRegEyeSlash", ()=>FaRegEyeSlash);
parcelHelpers.export(exports, "FaRegEye", ()=>FaRegEye);
parcelHelpers.export(exports, "FaRegFileAlt", ()=>FaRegFileAlt);
parcelHelpers.export(exports, "FaRegFileArchive", ()=>FaRegFileArchive);
parcelHelpers.export(exports, "FaRegFileAudio", ()=>FaRegFileAudio);
parcelHelpers.export(exports, "FaRegFileCode", ()=>FaRegFileCode);
parcelHelpers.export(exports, "FaRegFileExcel", ()=>FaRegFileExcel);
parcelHelpers.export(exports, "FaRegFileImage", ()=>FaRegFileImage);
parcelHelpers.export(exports, "FaRegFilePdf", ()=>FaRegFilePdf);
parcelHelpers.export(exports, "FaRegFilePowerpoint", ()=>FaRegFilePowerpoint);
parcelHelpers.export(exports, "FaRegFileVideo", ()=>FaRegFileVideo);
parcelHelpers.export(exports, "FaRegFileWord", ()=>FaRegFileWord);
parcelHelpers.export(exports, "FaRegFile", ()=>FaRegFile);
parcelHelpers.export(exports, "FaRegFlag", ()=>FaRegFlag);
parcelHelpers.export(exports, "FaRegFlushed", ()=>FaRegFlushed);
parcelHelpers.export(exports, "FaRegFolderOpen", ()=>FaRegFolderOpen);
parcelHelpers.export(exports, "FaRegFolder", ()=>FaRegFolder);
parcelHelpers.export(exports, "FaRegFontAwesomeLogoFull", ()=>FaRegFontAwesomeLogoFull);
parcelHelpers.export(exports, "FaRegFrownOpen", ()=>FaRegFrownOpen);
parcelHelpers.export(exports, "FaRegFrown", ()=>FaRegFrown);
parcelHelpers.export(exports, "FaRegFutbol", ()=>FaRegFutbol);
parcelHelpers.export(exports, "FaRegGem", ()=>FaRegGem);
parcelHelpers.export(exports, "FaRegGrimace", ()=>FaRegGrimace);
parcelHelpers.export(exports, "FaRegGrinAlt", ()=>FaRegGrinAlt);
parcelHelpers.export(exports, "FaRegGrinBeamSweat", ()=>FaRegGrinBeamSweat);
parcelHelpers.export(exports, "FaRegGrinBeam", ()=>FaRegGrinBeam);
parcelHelpers.export(exports, "FaRegGrinHearts", ()=>FaRegGrinHearts);
parcelHelpers.export(exports, "FaRegGrinSquintTears", ()=>FaRegGrinSquintTears);
parcelHelpers.export(exports, "FaRegGrinSquint", ()=>FaRegGrinSquint);
parcelHelpers.export(exports, "FaRegGrinStars", ()=>FaRegGrinStars);
parcelHelpers.export(exports, "FaRegGrinTears", ()=>FaRegGrinTears);
parcelHelpers.export(exports, "FaRegGrinTongueSquint", ()=>FaRegGrinTongueSquint);
parcelHelpers.export(exports, "FaRegGrinTongueWink", ()=>FaRegGrinTongueWink);
parcelHelpers.export(exports, "FaRegGrinTongue", ()=>FaRegGrinTongue);
parcelHelpers.export(exports, "FaRegGrinWink", ()=>FaRegGrinWink);
parcelHelpers.export(exports, "FaRegGrin", ()=>FaRegGrin);
parcelHelpers.export(exports, "FaRegHandLizard", ()=>FaRegHandLizard);
parcelHelpers.export(exports, "FaRegHandPaper", ()=>FaRegHandPaper);
parcelHelpers.export(exports, "FaRegHandPeace", ()=>FaRegHandPeace);
parcelHelpers.export(exports, "FaRegHandPointDown", ()=>FaRegHandPointDown);
parcelHelpers.export(exports, "FaRegHandPointLeft", ()=>FaRegHandPointLeft);
parcelHelpers.export(exports, "FaRegHandPointRight", ()=>FaRegHandPointRight);
parcelHelpers.export(exports, "FaRegHandPointUp", ()=>FaRegHandPointUp);
parcelHelpers.export(exports, "FaRegHandPointer", ()=>FaRegHandPointer);
parcelHelpers.export(exports, "FaRegHandRock", ()=>FaRegHandRock);
parcelHelpers.export(exports, "FaRegHandScissors", ()=>FaRegHandScissors);
parcelHelpers.export(exports, "FaRegHandSpock", ()=>FaRegHandSpock);
parcelHelpers.export(exports, "FaRegHandshake", ()=>FaRegHandshake);
parcelHelpers.export(exports, "FaRegHdd", ()=>FaRegHdd);
parcelHelpers.export(exports, "FaRegHeart", ()=>FaRegHeart);
parcelHelpers.export(exports, "FaRegHospital", ()=>FaRegHospital);
parcelHelpers.export(exports, "FaRegHourglass", ()=>FaRegHourglass);
parcelHelpers.export(exports, "FaRegIdBadge", ()=>FaRegIdBadge);
parcelHelpers.export(exports, "FaRegIdCard", ()=>FaRegIdCard);
parcelHelpers.export(exports, "FaRegImage", ()=>FaRegImage);
parcelHelpers.export(exports, "FaRegImages", ()=>FaRegImages);
parcelHelpers.export(exports, "FaRegKeyboard", ()=>FaRegKeyboard);
parcelHelpers.export(exports, "FaRegKissBeam", ()=>FaRegKissBeam);
parcelHelpers.export(exports, "FaRegKissWinkHeart", ()=>FaRegKissWinkHeart);
parcelHelpers.export(exports, "FaRegKiss", ()=>FaRegKiss);
parcelHelpers.export(exports, "FaRegLaughBeam", ()=>FaRegLaughBeam);
parcelHelpers.export(exports, "FaRegLaughSquint", ()=>FaRegLaughSquint);
parcelHelpers.export(exports, "FaRegLaughWink", ()=>FaRegLaughWink);
parcelHelpers.export(exports, "FaRegLaugh", ()=>FaRegLaugh);
parcelHelpers.export(exports, "FaRegLemon", ()=>FaRegLemon);
parcelHelpers.export(exports, "FaRegLifeRing", ()=>FaRegLifeRing);
parcelHelpers.export(exports, "FaRegLightbulb", ()=>FaRegLightbulb);
parcelHelpers.export(exports, "FaRegListAlt", ()=>FaRegListAlt);
parcelHelpers.export(exports, "FaRegMap", ()=>FaRegMap);
parcelHelpers.export(exports, "FaRegMehBlank", ()=>FaRegMehBlank);
parcelHelpers.export(exports, "FaRegMehRollingEyes", ()=>FaRegMehRollingEyes);
parcelHelpers.export(exports, "FaRegMeh", ()=>FaRegMeh);
parcelHelpers.export(exports, "FaRegMinusSquare", ()=>FaRegMinusSquare);
parcelHelpers.export(exports, "FaRegMoneyBillAlt", ()=>FaRegMoneyBillAlt);
parcelHelpers.export(exports, "FaRegMoon", ()=>FaRegMoon);
parcelHelpers.export(exports, "FaRegNewspaper", ()=>FaRegNewspaper);
parcelHelpers.export(exports, "FaRegObjectGroup", ()=>FaRegObjectGroup);
parcelHelpers.export(exports, "FaRegObjectUngroup", ()=>FaRegObjectUngroup);
parcelHelpers.export(exports, "FaRegPaperPlane", ()=>FaRegPaperPlane);
parcelHelpers.export(exports, "FaRegPauseCircle", ()=>FaRegPauseCircle);
parcelHelpers.export(exports, "FaRegPlayCircle", ()=>FaRegPlayCircle);
parcelHelpers.export(exports, "FaRegPlusSquare", ()=>FaRegPlusSquare);
parcelHelpers.export(exports, "FaRegQuestionCircle", ()=>FaRegQuestionCircle);
parcelHelpers.export(exports, "FaRegRegistered", ()=>FaRegRegistered);
parcelHelpers.export(exports, "FaRegSadCry", ()=>FaRegSadCry);
parcelHelpers.export(exports, "FaRegSadTear", ()=>FaRegSadTear);
parcelHelpers.export(exports, "FaRegSave", ()=>FaRegSave);
parcelHelpers.export(exports, "FaRegShareSquare", ()=>FaRegShareSquare);
parcelHelpers.export(exports, "FaRegSmileBeam", ()=>FaRegSmileBeam);
parcelHelpers.export(exports, "FaRegSmileWink", ()=>FaRegSmileWink);
parcelHelpers.export(exports, "FaRegSmile", ()=>FaRegSmile);
parcelHelpers.export(exports, "FaRegSnowflake", ()=>FaRegSnowflake);
parcelHelpers.export(exports, "FaRegSquare", ()=>FaRegSquare);
parcelHelpers.export(exports, "FaRegStarHalf", ()=>FaRegStarHalf);
parcelHelpers.export(exports, "FaRegStar", ()=>FaRegStar);
parcelHelpers.export(exports, "FaRegStickyNote", ()=>FaRegStickyNote);
parcelHelpers.export(exports, "FaRegStopCircle", ()=>FaRegStopCircle);
parcelHelpers.export(exports, "FaRegSun", ()=>FaRegSun);
parcelHelpers.export(exports, "FaRegSurprise", ()=>FaRegSurprise);
parcelHelpers.export(exports, "FaRegThumbsDown", ()=>FaRegThumbsDown);
parcelHelpers.export(exports, "FaRegThumbsUp", ()=>FaRegThumbsUp);
parcelHelpers.export(exports, "FaRegTimesCircle", ()=>FaRegTimesCircle);
parcelHelpers.export(exports, "FaRegTired", ()=>FaRegTired);
parcelHelpers.export(exports, "FaRegTrashAlt", ()=>FaRegTrashAlt);
parcelHelpers.export(exports, "FaRegUserCircle", ()=>FaRegUserCircle);
parcelHelpers.export(exports, "FaRegUser", ()=>FaRegUser);
parcelHelpers.export(exports, "FaRegWindowClose", ()=>FaRegWindowClose);
parcelHelpers.export(exports, "FaRegWindowMaximize", ()=>FaRegWindowMaximize);
parcelHelpers.export(exports, "FaRegWindowMinimize", ()=>FaRegWindowMinimize);
parcelHelpers.export(exports, "FaRegWindowRestore", ()=>FaRegWindowRestore);
var _lib = require("../lib");
function Fa500Px(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
                }
            }
        ]
    })(props);
}
function FaAccessibleIcon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
                }
            }
        ]
    })(props);
}
function FaAccusoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
                }
            }
        ]
    })(props);
}
function FaAcquisitionsIncorporated(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"
                }
            }
        ]
    })(props);
}
function FaAdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
                }
            }
        ]
    })(props);
}
function FaAdversal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
                }
            }
        ]
    })(props);
}
function FaAffiliatetheme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
                }
            }
        ]
    })(props);
}
function FaAirbnb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
                }
            }
        ]
    })(props);
}
function FaAlgolia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"
                }
            }
        ]
    })(props);
}
function FaAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
                }
            }
        ]
    })(props);
}
function FaAmazonPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
                }
            }
        ]
    })(props);
}
function FaAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
                }
            }
        ]
    })(props);
}
function FaAmilia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
                }
            }
        ]
    })(props);
}
function FaAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
                }
            }
        ]
    })(props);
}
function FaAngellist(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
                }
            }
        ]
    })(props);
}
function FaAngrycreative(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
                }
            }
        ]
    })(props);
}
function FaAngular(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
                }
            }
        ]
    })(props);
}
function FaAppStoreIos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
                }
            }
        ]
    })(props);
}
function FaAppStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
                }
            }
        ]
    })(props);
}
function FaApper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
                }
            }
        ]
    })(props);
}
function FaApplePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
                }
            }
        ]
    })(props);
}
function FaApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
                }
            }
        ]
    })(props);
}
function FaArtstation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
                }
            }
        ]
    })(props);
}
function FaAsymmetrik(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
                }
            }
        ]
    })(props);
}
function FaAtlassian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
                }
            }
        ]
    })(props);
}
function FaAudible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
                }
            }
        ]
    })(props);
}
function FaAutoprefixer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
                }
            }
        ]
    })(props);
}
function FaAvianex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
                }
            }
        ]
    })(props);
}
function FaAviato(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
                }
            }
        ]
    })(props);
}
function FaAws(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
                }
            }
        ]
    })(props);
}
function FaBandcamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
                }
            }
        ]
    })(props);
}
function FaBattleNet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
                }
            }
        ]
    })(props);
}
function FaBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
                }
            }
        ]
    })(props);
}
function FaBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
                }
            }
        ]
    })(props);
}
function FaBimobject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
                }
            }
        ]
    })(props);
}
function FaBitbucket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
                }
            }
        ]
    })(props);
}
function FaBitcoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
                }
            }
        ]
    })(props);
}
function FaBity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
                }
            }
        ]
    })(props);
}
function FaBlackTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
                }
            }
        ]
    })(props);
}
function FaBlackberry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
                }
            }
        ]
    })(props);
}
function FaBloggerB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
                }
            }
        ]
    })(props);
}
function FaBlogger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
                }
            }
        ]
    })(props);
}
function FaBluetoothB(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
                }
            }
        ]
    })(props);
}
function FaBluetooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
                }
            }
        ]
    })(props);
}
function FaBootstrap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
                }
            }
        ]
    })(props);
}
function FaBtc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
                }
            }
        ]
    })(props);
}
function FaBuffer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
                }
            }
        ]
    })(props);
}
function FaBuromobelexperte(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
                }
            }
        ]
    })(props);
}
function FaBuyNLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
                }
            }
        ]
    })(props);
}
function FaBuysellads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
                }
            }
        ]
    })(props);
}
function FaCanadianMapleLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
                }
            }
        ]
    })(props);
}
function FaCcAmazonPay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
                }
            }
        ]
    })(props);
}
function FaCcAmex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
                }
            }
        ]
    })(props);
}
function FaCcApplePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
                }
            }
        ]
    })(props);
}
function FaCcDinersClub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
                }
            }
        ]
    })(props);
}
function FaCcDiscover(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
                }
            }
        ]
    })(props);
}
function FaCcJcb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
                }
            }
        ]
    })(props);
}
function FaCcMastercard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
                }
            }
        ]
    })(props);
}
function FaCcPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
                }
            }
        ]
    })(props);
}
function FaCcStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
                }
            }
        ]
    })(props);
}
function FaCcVisa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
                }
            }
        ]
    })(props);
}
function FaCentercode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
                }
            }
        ]
    })(props);
}
function FaCentos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
                }
            }
        ]
    })(props);
}
function FaChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
                }
            }
        ]
    })(props);
}
function FaChromecast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
                }
            }
        ]
    })(props);
}
function FaCloudflare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
                }
            }
        ]
    })(props);
}
function FaCloudscale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
                }
            }
        ]
    })(props);
}
function FaCloudsmith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 332 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"
                }
            }
        ]
    })(props);
}
function FaCloudversify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
                }
            }
        ]
    })(props);
}
function FaCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
                }
            }
        ]
    })(props);
}
function FaCodiepie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 472 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
                }
            }
        ]
    })(props);
}
function FaConfluence(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
                }
            }
        ]
    })(props);
}
function FaConnectdevelop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
                }
            }
        ]
    })(props);
}
function FaContao(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
                }
            }
        ]
    })(props);
}
function FaCottonBureau(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
                }
            }
        ]
    })(props);
}
function FaCpanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsBy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNcEu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNcJp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsNd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsPdAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsPd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsRemix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSamplingPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsSampling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommonsZero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
                }
            }
        ]
    })(props);
}
function FaCreativeCommons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
                }
            }
        ]
    })(props);
}
function FaCriticalRole(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
                }
            }
        ]
    })(props);
}
function FaCss3Alt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
                }
            }
        ]
    })(props);
}
function FaCss3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
                }
            }
        ]
    })(props);
}
function FaCuttlefish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
                }
            }
        ]
    })(props);
}
function FaDAndDBeyond(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
                }
            }
        ]
    })(props);
}
function FaDAndD(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
                }
            }
        ]
    })(props);
}
function FaDailymotion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
                }
            }
        ]
    })(props);
}
function FaDashcube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
                }
            }
        ]
    })(props);
}
function FaDeezer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
                }
            }
        ]
    })(props);
}
function FaDelicious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
                }
            }
        ]
    })(props);
}
function FaDeploydog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaDeskpro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
                }
            }
        ]
    })(props);
}
function FaDev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
                }
            }
        ]
    })(props);
}
function FaDeviantart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
                }
            }
        ]
    })(props);
}
function FaDhl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
                }
            }
        ]
    })(props);
}
function FaDiaspora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
                }
            }
        ]
    })(props);
}
function FaDigg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
                }
            }
        ]
    })(props);
}
function FaDigitalOcean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
                }
            }
        ]
    })(props);
}
function FaDiscord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
                }
            }
        ]
    })(props);
}
function FaDiscourse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaDochub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
                }
            }
        ]
    })(props);
}
function FaDocker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
                }
            }
        ]
    })(props);
}
function FaDraft2Digital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
                }
            }
        ]
    })(props);
}
function FaDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
                }
            }
        ]
    })(props);
}
function FaDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
                }
            }
        ]
    })(props);
}
function FaDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 528 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
                }
            }
        ]
    })(props);
}
function FaDrupal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"
                }
            }
        ]
    })(props);
}
function FaDyalog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
                }
            }
        ]
    })(props);
}
function FaEarlybirds(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
                }
            }
        ]
    })(props);
}
function FaEbay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
                }
            }
        ]
    })(props);
}
function FaEdgeLegacy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
                }
            }
        ]
    })(props);
}
function FaEdge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"
                }
            }
        ]
    })(props);
}
function FaElementor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"
                }
            }
        ]
    })(props);
}
function FaEllo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
                }
            }
        ]
    })(props);
}
function FaEmber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
                }
            }
        ]
    })(props);
}
function FaEmpire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
                }
            }
        ]
    })(props);
}
function FaEnvira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
                }
            }
        ]
    })(props);
}
function FaErlang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
                }
            }
        ]
    })(props);
}
function FaEthereum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
                }
            }
        ]
    })(props);
}
function FaEtsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
                }
            }
        ]
    })(props);
}
function FaEvernote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
                }
            }
        ]
    })(props);
}
function FaExpeditedssl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
                }
            }
        ]
    })(props);
}
function FaFacebookF(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                }
            }
        ]
    })(props);
}
function FaFacebookMessenger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
                }
            }
        ]
    })(props);
}
function FaFacebookSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                }
            }
        ]
    })(props);
}
function FaFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
                }
            }
        ]
    })(props);
}
function FaFantasyFlightGames(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
                }
            }
        ]
    })(props);
}
function FaFedex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
                }
            }
        ]
    })(props);
}
function FaFedora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"
                }
            }
        ]
    })(props);
}
function FaFigma(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
                }
            }
        ]
    })(props);
}
function FaFirefoxBrowser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"
                }
            }
        ]
    })(props);
}
function FaFirefox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
                }
            }
        ]
    })(props);
}
function FaFirstOrderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
                }
            }
        ]
    })(props);
}
function FaFirstOrder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
                }
            }
        ]
    })(props);
}
function FaFirstdraft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
                }
            }
        ]
    })(props);
}
function FaFlickr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
                }
            }
        ]
    })(props);
}
function FaFlipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
                }
            }
        ]
    })(props);
}
function FaFly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
                }
            }
        ]
    })(props);
}
function FaFontAwesomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"
                }
            }
        ]
    })(props);
}
function FaFontAwesomeFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"
                }
            }
        ]
    })(props);
}
function FaFontAwesomeLogoFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"
                }
            }
        ]
    })(props);
}
function FaFontAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"
                }
            }
        ]
    })(props);
}
function FaFonticonsFi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
                }
            }
        ]
    })(props);
}
function FaFonticons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
                }
            }
        ]
    })(props);
}
function FaFortAwesomeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
                }
            }
        ]
    })(props);
}
function FaFortAwesome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
                }
            }
        ]
    })(props);
}
function FaForumbee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
                }
            }
        ]
    })(props);
}
function FaFoursquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 368 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
                }
            }
        ]
    })(props);
}
function FaFreeCodeCamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
                }
            }
        ]
    })(props);
}
function FaFreebsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
                }
            }
        ]
    })(props);
}
function FaFulcrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
                }
            }
        ]
    })(props);
}
function FaGalacticRepublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
                }
            }
        ]
    })(props);
}
function FaGalacticSenate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
                }
            }
        ]
    })(props);
}
function FaGetPocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
                }
            }
        ]
    })(props);
}
function FaGgCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
                }
            }
        ]
    })(props);
}
function FaGg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
                }
            }
        ]
    })(props);
}
function FaGitAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
                }
            }
        ]
    })(props);
}
function FaGitSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
                }
            }
        ]
    })(props);
}
function FaGit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
                }
            }
        ]
    })(props);
}
function FaGithubAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
                }
            }
        ]
    })(props);
}
function FaGithubSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
                }
            }
        ]
    })(props);
}
function FaGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
                }
            }
        ]
    })(props);
}
function FaGitkraken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 592 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
                }
            }
        ]
    })(props);
}
function FaGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"
                }
            }
        ]
    })(props);
}
function FaGitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
                }
            }
        ]
    })(props);
}
function FaGlideG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
                }
            }
        ]
    })(props);
}
function FaGlide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
                }
            }
        ]
    })(props);
}
function FaGofore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
                }
            }
        ]
    })(props);
}
function FaGoodreadsG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
                }
            }
        ]
    })(props);
}
function FaGoodreads(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
                }
            }
        ]
    })(props);
}
function FaGoogleDrive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
                }
            }
        ]
    })(props);
}
function FaGooglePay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
                }
            }
        ]
    })(props);
}
function FaGooglePlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
                }
            }
        ]
    })(props);
}
function FaGooglePlusG(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
                }
            }
        ]
    })(props);
}
function FaGooglePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
                }
            }
        ]
    })(props);
}
function FaGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
                }
            }
        ]
    })(props);
}
function FaGoogleWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
                }
            }
        ]
    })(props);
}
function FaGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 488 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                }
            }
        ]
    })(props);
}
function FaGratipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
                }
            }
        ]
    })(props);
}
function FaGrav(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
                }
            }
        ]
    })(props);
}
function FaGripfire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
                }
            }
        ]
    })(props);
}
function FaGrunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
                }
            }
        ]
    })(props);
}
function FaGuilded(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
                }
            }
        ]
    })(props);
}
function FaGulp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
                }
            }
        ]
    })(props);
}
function FaHackerNewsSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function FaHackerNews(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
                }
            }
        ]
    })(props);
}
function FaHackerrank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
                }
            }
        ]
    })(props);
}
function FaHips(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
                }
            }
        ]
    })(props);
}
function FaHireAHelper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
                }
            }
        ]
    })(props);
}
function FaHive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
                }
            }
        ]
    })(props);
}
function FaHooli(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
                }
            }
        ]
    })(props);
}
function FaHornbill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
                }
            }
        ]
    })(props);
}
function FaHotjar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"
                }
            }
        ]
    })(props);
}
function FaHouzz(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
                }
            }
        ]
    })(props);
}
function FaHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
                }
            }
        ]
    })(props);
}
function FaHubspot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
                }
            }
        ]
    })(props);
}
function FaIdeal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
                }
            }
        ]
    })(props);
}
function FaImdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"
                }
            }
        ]
    })(props);
}
function FaInnosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"
                }
            }
        ]
    })(props);
}
function FaInstagramSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                }
            }
        ]
    })(props);
}
function FaInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                }
            }
        ]
    })(props);
}
function FaInstalod(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
                }
            }
        ]
    })(props);
}
function FaIntercom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
                }
            }
        ]
    })(props);
}
function FaInternetExplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
                }
            }
        ]
    })(props);
}
function FaInvision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
                }
            }
        ]
    })(props);
}
function FaIoxhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaItchIo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
                }
            }
        ]
    })(props);
}
function FaItunesNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
                }
            }
        ]
    })(props);
}
function FaItunes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
                }
            }
        ]
    })(props);
}
function FaJava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
                }
            }
        ]
    })(props);
}
function FaJediOrder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
                }
            }
        ]
    })(props);
}
function FaJenkins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
                }
            }
        ]
    })(props);
}
function FaJira(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
                }
            }
        ]
    })(props);
}
function FaJoget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
                }
            }
        ]
    })(props);
}
function FaJoomla(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
                }
            }
        ]
    })(props);
}
function FaJsSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function FaJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
                }
            }
        ]
    })(props);
}
function FaJsfiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
                }
            }
        ]
    })(props);
}
function FaKaggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
                }
            }
        ]
    })(props);
}
function FaKeybase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
                }
            }
        ]
    })(props);
}
function FaKeycdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
                }
            }
        ]
    })(props);
}
function FaKickstarterK(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
                }
            }
        ]
    })(props);
}
function FaKickstarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
                }
            }
        ]
    })(props);
}
function FaKorvue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 446 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
                }
            }
        ]
    })(props);
}
function FaLaravel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
                }
            }
        ]
    })(props);
}
function FaLastfmSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
                }
            }
        ]
    })(props);
}
function FaLastfm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
                }
            }
        ]
    })(props);
}
function FaLeanpub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
                }
            }
        ]
    })(props);
}
function FaLess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
                }
            }
        ]
    })(props);
}
function FaLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"
                }
            }
        ]
    })(props);
}
function FaLinkedinIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
                }
            }
        ]
    })(props);
}
function FaLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                }
            }
        ]
    })(props);
}
function FaLinode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"
                }
            }
        ]
    })(props);
}
function FaLinux(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
                }
            }
        ]
    })(props);
}
function FaLyft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
                }
            }
        ]
    })(props);
}
function FaMagento(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
                }
            }
        ]
    })(props);
}
function FaMailchimp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
                }
            }
        ]
    })(props);
}
function FaMandalorian(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
                }
            }
        ]
    })(props);
}
function FaMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
                }
            }
        ]
    })(props);
}
function FaMastodon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
                }
            }
        ]
    })(props);
}
function FaMaxcdn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
                }
            }
        ]
    })(props);
}
function FaMdb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
                }
            }
        ]
    })(props);
}
function FaMedapps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
                }
            }
        ]
    })(props);
}
function FaMediumM(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"
                }
            }
        ]
    })(props);
}
function FaMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
                }
            }
        ]
    })(props);
}
function FaMedrt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
                }
            }
        ]
    })(props);
}
function FaMeetup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
                }
            }
        ]
    })(props);
}
function FaMegaport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
                }
            }
        ]
    })(props);
}
function FaMendeley(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
                }
            }
        ]
    })(props);
}
function FaMicroblog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
                }
            }
        ]
    })(props);
}
function FaMicrosoft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
                }
            }
        ]
    })(props);
}
function FaMix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
                }
            }
        ]
    })(props);
}
function FaMixcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"
                }
            }
        ]
    })(props);
}
function FaMixer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
                }
            }
        ]
    })(props);
}
function FaMizuni(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
                }
            }
        ]
    })(props);
}
function FaModx(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
                }
            }
        ]
    })(props);
}
function FaMonero(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
                }
            }
        ]
    })(props);
}
function FaNapster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
                }
            }
        ]
    })(props);
}
function FaNeos(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
                }
            }
        ]
    })(props);
}
function FaNimblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
                }
            }
        ]
    })(props);
}
function FaNodeJs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
                }
            }
        ]
    })(props);
}
function FaNode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
                }
            }
        ]
    })(props);
}
function FaNpm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
                }
            }
        ]
    })(props);
}
function FaNs8(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
                }
            }
        ]
    })(props);
}
function FaNutritionix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 400 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
                }
            }
        ]
    })(props);
}
function FaOctopusDeploy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
                }
            }
        ]
    })(props);
}
function FaOdnoklassnikiSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
                }
            }
        ]
    })(props);
}
function FaOdnoklassniki(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
                }
            }
        ]
    })(props);
}
function FaOldRepublic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
                }
            }
        ]
    })(props);
}
function FaOpencart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
                }
            }
        ]
    })(props);
}
function FaOpenid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
                }
            }
        ]
    })(props);
}
function FaOpera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
                }
            }
        ]
    })(props);
}
function FaOptinMonster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
                }
            }
        ]
    })(props);
}
function FaOrcid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
                }
            }
        ]
    })(props);
}
function FaOsi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
                }
            }
        ]
    })(props);
}
function FaPage4(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
                }
            }
        ]
    })(props);
}
function FaPagelines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
                }
            }
        ]
    })(props);
}
function FaPalfed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
                }
            }
        ]
    })(props);
}
function FaPatreon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
                }
            }
        ]
    })(props);
}
function FaPaypal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
                }
            }
        ]
    })(props);
}
function FaPennyArcade(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"
                }
            }
        ]
    })(props);
}
function FaPerbyte(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
                }
            }
        ]
    })(props);
}
function FaPeriscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
                }
            }
        ]
    })(props);
}
function FaPhabricator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
                }
            }
        ]
    })(props);
}
function FaPhoenixFramework(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
                }
            }
        ]
    })(props);
}
function FaPhoenixSquadron(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
                }
            }
        ]
    })(props);
}
function FaPhp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperPp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
                }
            }
        ]
    })(props);
}
function FaPiedPiperSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
                }
            }
        ]
    })(props);
}
function FaPiedPiper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
                }
            }
        ]
    })(props);
}
function FaPinterestP(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
                }
            }
        ]
    })(props);
}
function FaPinterestSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function FaPinterest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
                }
            }
        ]
    })(props);
}
function FaPlaystation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
                }
            }
        ]
    })(props);
}
function FaProductHunt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
                }
            }
        ]
    })(props);
}
function FaPushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 432 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
                }
            }
        ]
    })(props);
}
function FaPython(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
                }
            }
        ]
    })(props);
}
function FaQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
                }
            }
        ]
    })(props);
}
function FaQuinscape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
                }
            }
        ]
    })(props);
}
function FaQuora(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
                }
            }
        ]
    })(props);
}
function FaRProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 581 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
                }
            }
        ]
    })(props);
}
function FaRaspberryPi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 407 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
                }
            }
        ]
    })(props);
}
function FaRavelry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
                }
            }
        ]
    })(props);
}
function FaReact(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
                }
            }
        ]
    })(props);
}
function FaReacteurope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
                }
            }
        ]
    })(props);
}
function FaReadme(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
                }
            }
        ]
    })(props);
}
function FaRebel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
                }
            }
        ]
    })(props);
}
function FaRedRiver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
                }
            }
        ]
    })(props);
}
function FaRedditAlien(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
                }
            }
        ]
    })(props);
}
function FaRedditSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
                }
            }
        ]
    })(props);
}
function FaReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
                }
            }
        ]
    })(props);
}
function FaRedhat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
                }
            }
        ]
    })(props);
}
function FaRenren(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
                }
            }
        ]
    })(props);
}
function FaReplyd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
                }
            }
        ]
    })(props);
}
function FaResearchgate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
                }
            }
        ]
    })(props);
}
function FaResolving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
                }
            }
        ]
    })(props);
}
function FaRev(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
                }
            }
        ]
    })(props);
}
function FaRocketchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
                }
            }
        ]
    })(props);
}
function FaRockrms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
                }
            }
        ]
    })(props);
}
function FaRust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
                }
            }
        ]
    })(props);
}
function FaSafari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
                }
            }
        ]
    })(props);
}
function FaSalesforce(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
                }
            }
        ]
    })(props);
}
function FaSass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
                }
            }
        ]
    })(props);
}
function FaSchlix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
                }
            }
        ]
    })(props);
}
function FaScribd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
                }
            }
        ]
    })(props);
}
function FaSearchengin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 460 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function FaSellcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
                }
            }
        ]
    })(props);
}
function FaSellsy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
                }
            }
        ]
    })(props);
}
function FaServicestack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
                }
            }
        ]
    })(props);
}
function FaShirtsinbulk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
                }
            }
        ]
    })(props);
}
function FaShopify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
                }
            }
        ]
    })(props);
}
function FaShopware(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
                }
            }
        ]
    })(props);
}
function FaSimplybuilt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
                }
            }
        ]
    })(props);
}
function FaSistrix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
                }
            }
        ]
    })(props);
}
function FaSith(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
                }
            }
        ]
    })(props);
}
function FaSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
                }
            }
        ]
    })(props);
}
function FaSkyatlas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
                }
            }
        ]
    })(props);
}
function FaSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
                }
            }
        ]
    })(props);
}
function FaSlackHash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"
                }
            }
        ]
    })(props);
}
function FaSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
                }
            }
        ]
    })(props);
}
function FaSlideshare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
                }
            }
        ]
    })(props);
}
function FaSnapchatGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"
                }
            }
        ]
    })(props);
}
function FaSnapchatSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                }
            }
        ]
    })(props);
}
function FaSnapchat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
                }
            }
        ]
    })(props);
}
function FaSoundcloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
                }
            }
        ]
    })(props);
}
function FaSourcetree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
                }
            }
        ]
    })(props);
}
function FaSpeakap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
                }
            }
        ]
    })(props);
}
function FaSpeakerDeck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
                }
            }
        ]
    })(props);
}
function FaSpotify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
                }
            }
        ]
    })(props);
}
function FaSquarespace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
                }
            }
        ]
    })(props);
}
function FaStackExchange(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
                }
            }
        ]
    })(props);
}
function FaStackOverflow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
                }
            }
        ]
    })(props);
}
function FaStackpath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
                }
            }
        ]
    })(props);
}
function FaStaylinked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 440 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
                }
            }
        ]
    })(props);
}
function FaSteamSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
                }
            }
        ]
    })(props);
}
function FaSteamSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
                }
            }
        ]
    })(props);
}
function FaSteam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
                }
            }
        ]
    })(props);
}
function FaStickerMule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
                }
            }
        ]
    })(props);
}
function FaStrava(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
                }
            }
        ]
    })(props);
}
function FaStripeS(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
                }
            }
        ]
    })(props);
}
function FaStripe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
                }
            }
        ]
    })(props);
}
function FaStudiovinari(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
                }
            }
        ]
    })(props);
}
function FaStumbleuponCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
                }
            }
        ]
    })(props);
}
function FaStumbleupon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
                }
            }
        ]
    })(props);
}
function FaSuperpowers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
                }
            }
        ]
    })(props);
}
function FaSupple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
                }
            }
        ]
    })(props);
}
function FaSuse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
                }
            }
        ]
    })(props);
}
function FaSwift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
                }
            }
        ]
    })(props);
}
function FaSymfony(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
                }
            }
        ]
    })(props);
}
function FaTeamspeak(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"
                }
            }
        ]
    })(props);
}
function FaTelegramPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
                }
            }
        ]
    })(props);
}
function FaTelegram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
                }
            }
        ]
    })(props);
}
function FaTencentWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
                }
            }
        ]
    })(props);
}
function FaTheRedYeti(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
                }
            }
        ]
    })(props);
}
function FaThemeco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
                }
            }
        ]
    })(props);
}
function FaThemeisle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
                }
            }
        ]
    })(props);
}
function FaThinkPeaks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
                }
            }
        ]
    })(props);
}
function FaTiktok(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
                }
            }
        ]
    })(props);
}
function FaTradeFederation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
                }
            }
        ]
    })(props);
}
function FaTrello(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
                }
            }
        ]
    })(props);
}
function FaTripadvisor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.91,178.82,576,127.58H471.66a326.11,326.11,0,0,0-367,0H0l47.09,51.24A143.911,143.911,0,0,0,241.86,390.73L288,440.93l46.11-50.17A143.94,143.94,0,0,0,575.88,285.18h-.03A143.56,143.56,0,0,0,528.91,178.82ZM144.06,382.57a97.39,97.39,0,1,1,97.39-97.39A97.39,97.39,0,0,1,144.06,382.57ZM288,282.37c0-64.09-46.62-119.08-108.09-142.59a281,281,0,0,1,216.17,0C334.61,163.3,288,218.29,288,282.37Zm143.88,100.2h-.01a97.405,97.405,0,1,1,.01,0ZM144.06,234.12h-.01a51.06,51.06,0,1,0,51.06,51.06v-.11A51,51,0,0,0,144.06,234.12Zm287.82,0a51.06,51.06,0,1,0,51.06,51.06A51.06,51.06,0,0,0,431.88,234.12Z"
                }
            }
        ]
    })(props);
}
function FaTumblrSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
                }
            }
        ]
    })(props);
}
function FaTumblr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
                }
            }
        ]
    })(props);
}
function FaTwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
                }
            }
        ]
    })(props);
}
function FaTwitterSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
                }
            }
        ]
    })(props);
}
function FaTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                }
            }
        ]
    })(props);
}
function FaTypo3(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
                }
            }
        ]
    })(props);
}
function FaUber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
                }
            }
        ]
    })(props);
}
function FaUbuntu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
                }
            }
        ]
    })(props);
}
function FaUikit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
                }
            }
        ]
    })(props);
}
function FaUmbraco(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 510 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
                }
            }
        ]
    })(props);
}
function FaUncharted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
                }
            }
        ]
    })(props);
}
function FaUniregistry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
                }
            }
        ]
    })(props);
}
function FaUnity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"
                }
            }
        ]
    })(props);
}
function FaUnsplash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
                }
            }
        ]
    })(props);
}
function FaUntappd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
                }
            }
        ]
    })(props);
}
function FaUps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
                }
            }
        ]
    })(props);
}
function FaUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
                }
            }
        ]
    })(props);
}
function FaUsps(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
                }
            }
        ]
    })(props);
}
function FaUssunnah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"
                }
            }
        ]
    })(props);
}
function FaVaadin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
                }
            }
        ]
    })(props);
}
function FaViacoin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
                }
            }
        ]
    })(props);
}
function FaViadeoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
                }
            }
        ]
    })(props);
}
function FaViadeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
                }
            }
        ]
    })(props);
}
function FaViber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
                }
            }
        ]
    })(props);
}
function FaVimeoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
                }
            }
        ]
    })(props);
}
function FaVimeoV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
                }
            }
        ]
    })(props);
}
function FaVimeo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
                }
            }
        ]
    })(props);
}
function FaVine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
                }
            }
        ]
    })(props);
}
function FaVk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"
                }
            }
        ]
    })(props);
}
function FaVnv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
                }
            }
        ]
    })(props);
}
function FaVuejs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
                }
            }
        ]
    })(props);
}
function FaWatchmanMonitoring(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
                }
            }
        ]
    })(props);
}
function FaWaze(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
                }
            }
        ]
    })(props);
}
function FaWeebly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
                }
            }
        ]
    })(props);
}
function FaWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
                }
            }
        ]
    })(props);
}
function FaWeixin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
                }
            }
        ]
    })(props);
}
function FaWhatsappSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
                }
            }
        ]
    })(props);
}
function FaWhatsapp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                }
            }
        ]
    })(props);
}
function FaWhmcs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
                }
            }
        ]
    })(props);
}
function FaWikipediaW(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
                }
            }
        ]
    })(props);
}
function FaWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
                }
            }
        ]
    })(props);
}
function FaWix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
                }
            }
        ]
    })(props);
}
function FaWizardsOfTheCoast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
                }
            }
        ]
    })(props);
}
function FaWodu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
                }
            }
        ]
    })(props);
}
function FaWolfPackBattalion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
                }
            }
        ]
    })(props);
}
function FaWordpressSimple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
                }
            }
        ]
    })(props);
}
function FaWordpress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
                }
            }
        ]
    })(props);
}
function FaWpbeginner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
                }
            }
        ]
    })(props);
}
function FaWpexplorer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
                }
            }
        ]
    })(props);
}
function FaWpforms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
                }
            }
        ]
    })(props);
}
function FaWpressr(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
                }
            }
        ]
    })(props);
}
function FaXbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
                }
            }
        ]
    })(props);
}
function FaXingSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
                }
            }
        ]
    })(props);
}
function FaXing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
                }
            }
        ]
    })(props);
}
function FaYCombinator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
                }
            }
        ]
    })(props);
}
function FaYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
                }
            }
        ]
    })(props);
}
function FaYammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"
                }
            }
        ]
    })(props);
}
function FaYandexInternational(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
                }
            }
        ]
    })(props);
}
function FaYandex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
                }
            }
        ]
    })(props);
}
function FaYarn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
                }
            }
        ]
    })(props);
}
function FaYelp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
                }
            }
        ]
    })(props);
}
function FaYoast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
                }
            }
        ]
    })(props);
}
function FaYoutubeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                }
            }
        ]
    })(props);
}
function FaYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
                }
            }
        ]
    })(props);
}
function FaZhihu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
                }
            }
        ]
    })(props);
}
function FaAd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
                }
            }
        ]
    })(props);
}
function FaAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function FaAddressCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaAdjust(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
                }
            }
        ]
    })(props);
}
function FaAirFreshener(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
                }
            }
        ]
    })(props);
}
function FaAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
                }
            }
        ]
    })(props);
}
function FaAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
                }
            }
        ]
    })(props);
}
function FaAllergies(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaAmbulance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function FaAmericanSignLanguageInterpreting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
                }
            }
        ]
    })(props);
}
function FaAnchor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
                }
            }
        ]
    })(props);
}
function FaAngleDoubleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
                }
            }
        ]
    })(props);
}
function FaAngleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
                }
            }
        ]
    })(props);
}
function FaAngleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
                }
            }
        ]
    })(props);
}
function FaAngleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
                }
            }
        ]
    })(props);
}
function FaAngleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
                }
            }
        ]
    })(props);
}
function FaAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
                }
            }
        ]
    })(props);
}
function FaAnkh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
                }
            }
        ]
    })(props);
}
function FaAppleAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
                }
            }
        ]
    })(props);
}
function FaArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaArchway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
                }
            }
        ]
    })(props);
}
function FaArrowAltCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
                }
            }
        ]
    })(props);
}
function FaArrowCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
                }
            }
        ]
    })(props);
}
function FaArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
                }
            }
        ]
    })(props);
}
function FaArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
                }
            }
        ]
    })(props);
}
function FaArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                }
            }
        ]
    })(props);
}
function FaArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
                }
            }
        ]
    })(props);
}
function FaArrowsAltH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
                }
            }
        ]
    })(props);
}
function FaArrowsAltV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
                }
            }
        ]
    })(props);
}
function FaArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
                }
            }
        ]
    })(props);
}
function FaAssistiveListeningSystems(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
                }
            }
        ]
    })(props);
}
function FaAsterisk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
                }
            }
        ]
    })(props);
}
function FaAt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
                }
            }
        ]
    })(props);
}
function FaAtlas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
                }
            }
        ]
    })(props);
}
function FaAtom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
                }
            }
        ]
    })(props);
}
function FaAudioDescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
                }
            }
        ]
    })(props);
}
function FaAward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
                }
            }
        ]
    })(props);
}
function FaBabyCarriage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
                }
            }
        ]
    })(props);
}
function FaBaby(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
                }
            }
        ]
    })(props);
}
function FaBackspace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
                }
            }
        ]
    })(props);
}
function FaBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
                }
            }
        ]
    })(props);
}
function FaBacon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
                }
            }
        ]
    })(props);
}
function FaBacteria(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
                }
            }
        ]
    })(props);
}
function FaBacterium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
                }
            }
        ]
    })(props);
}
function FaBahai(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
                }
            }
        ]
    })(props);
}
function FaBalanceScaleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
                }
            }
        ]
    })(props);
}
function FaBalanceScaleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
                }
            }
        ]
    })(props);
}
function FaBalanceScale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
                }
            }
        ]
    })(props);
}
function FaBandAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
                }
            }
        ]
    })(props);
}
function FaBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                }
            }
        ]
    })(props);
}
function FaBaseballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
                }
            }
        ]
    })(props);
}
function FaBasketballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
                }
            }
        ]
    })(props);
}
function FaBath(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
                }
            }
        ]
    })(props);
}
function FaBatteryEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaBatteryFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
                }
            }
        ]
    })(props);
}
function FaBatteryThreeQuarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
                }
            }
        ]
    })(props);
}
function FaBed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
                }
            }
        ]
    })(props);
}
function FaBeer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function FaBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
                }
            }
        ]
    })(props);
}
function FaBezierCurve(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaBible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                }
            }
        ]
    })(props);
}
function FaBicycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
                }
            }
        ]
    })(props);
}
function FaBiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
                }
            }
        ]
    })(props);
}
function FaBinoculars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
                }
            }
        ]
    })(props);
}
function FaBiohazard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaBirthdayCake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
                }
            }
        ]
    })(props);
}
function FaBlenderPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBlender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
                }
            }
        ]
    })(props);
}
function FaBlind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
                }
            }
        ]
    })(props);
}
function FaBlog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
                }
            }
        ]
    })(props);
}
function FaBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
                }
            }
        ]
    })(props);
}
function FaBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
                }
            }
        ]
    })(props);
}
function FaBomb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaBone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
                }
            }
        ]
    })(props);
}
function FaBong(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
                }
            }
        ]
    })(props);
}
function FaBookDead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
                }
            }
        ]
    })(props);
}
function FaBookMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
                }
            }
        ]
    })(props);
}
function FaBookOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
                }
            }
        ]
    })(props);
}
function FaBookReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
                }
            }
        ]
    })(props);
}
function FaBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
                }
            }
        ]
    })(props);
}
function FaBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
                }
            }
        ]
    })(props);
}
function FaBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
                }
            }
        ]
    })(props);
}
function FaBorderNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaBorderStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaBowlingBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBoxOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
                }
            }
        ]
    })(props);
}
function FaBoxTissue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
                }
            }
        ]
    })(props);
}
function FaBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
                }
            }
        ]
    })(props);
}
function FaBoxes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaBraille(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaBrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
                }
            }
        ]
    })(props);
}
function FaBreadSlice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
                }
            }
        ]
    })(props);
}
function FaBriefcaseMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function FaBriefcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
                }
            }
        ]
    })(props);
}
function FaBroadcastTower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
                }
            }
        ]
    })(props);
}
function FaBroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
                }
            }
        ]
    })(props);
}
function FaBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
                }
            }
        ]
    })(props);
}
function FaBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaBullhorn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
                }
            }
        ]
    })(props);
}
function FaBullseye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaBurn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
                }
            }
        ]
    })(props);
}
function FaBusAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaBusinessTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
                }
            }
        ]
    })(props);
}
function FaCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
                }
            }
        ]
    })(props);
}
function FaCalendarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
                }
            }
        ]
    })(props);
}
function FaCalendarDay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
                }
            }
        ]
    })(props);
}
function FaCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
                }
            }
        ]
    })(props);
}
function FaCalendarTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
                }
            }
        ]
    })(props);
}
function FaCalendarWeek(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaCameraRetro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
                }
            }
        ]
    })(props);
}
function FaCampground(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
                }
            }
        ]
    })(props);
}
function FaCandyCane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
                }
            }
        ]
    })(props);
}
function FaCannabis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
                }
            }
        ]
    })(props);
}
function FaCapsules(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
                }
            }
        ]
    })(props);
}
function FaCarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                }
            }
        ]
    })(props);
}
function FaCarBattery(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaCarCrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
                }
            }
        ]
    })(props);
}
function FaCarSide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
                }
            }
        ]
    })(props);
}
function FaCaravan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
                }
            }
        ]
    })(props);
}
function FaCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                }
            }
        ]
    })(props);
}
function FaCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
                }
            }
        ]
    })(props);
}
function FaCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
                }
            }
        ]
    })(props);
}
function FaCaretSquareUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
                }
            }
        ]
    })(props);
}
function FaCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
                }
            }
        ]
    })(props);
}
function FaCarrot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
                }
            }
        ]
    })(props);
}
function FaCartArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
                }
            }
        ]
    })(props);
}
function FaCartPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaCashRegister(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
                }
            }
        ]
    })(props);
}
function FaCat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
                }
            }
        ]
    })(props);
}
function FaChair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
                }
            }
        ]
    })(props);
}
function FaChalkboardTeacher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
                }
            }
        ]
    })(props);
}
function FaChalkboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaChargingStation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
                }
            }
        ]
    })(props);
}
function FaChartArea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
                }
            }
        ]
    })(props);
}
function FaChartBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaChartLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
                }
            }
        ]
    })(props);
}
function FaChartPie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
                }
            }
        ]
    })(props);
}
function FaCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
                }
            }
        ]
    })(props);
}
function FaCheckDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
                }
            }
        ]
    })(props);
}
function FaCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                }
            }
        ]
    })(props);
}
function FaCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                }
            }
        ]
    })(props);
}
function FaCheese(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
                }
            }
        ]
    })(props);
}
function FaChessBishop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChessBoard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
                }
            }
        ]
    })(props);
}
function FaChessKing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
                }
            }
        ]
    })(props);
}
function FaChessKnight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChessPawn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChessQueen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
                }
            }
        ]
    })(props);
}
function FaChessRook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaChess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
                }
            }
        ]
    })(props);
}
function FaChevronCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
                }
            }
        ]
    })(props);
}
function FaChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
                }
            }
        ]
    })(props);
}
function FaChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                }
            }
        ]
    })(props);
}
function FaChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                }
            }
        ]
    })(props);
}
function FaChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
                }
            }
        ]
    })(props);
}
function FaChild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
                }
            }
        ]
    })(props);
}
function FaChurch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
                }
            }
        ]
    })(props);
}
function FaCircleNotch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
                }
            }
        ]
    })(props);
}
function FaCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
                }
            }
        ]
    })(props);
}
function FaCity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaClinicMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
                }
            }
        ]
    })(props);
}
function FaClipboardCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
                }
            }
        ]
    })(props);
}
function FaClipboardList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
                }
            }
        ]
    })(props);
}
function FaClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
                }
            }
        ]
    })(props);
}
function FaClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
                }
            }
        ]
    })(props);
}
function FaClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
                }
            }
        ]
    })(props);
}
function FaCloudDownloadAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
                }
            }
        ]
    })(props);
}
function FaCloudMeatball(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
                }
            }
        ]
    })(props);
}
function FaCloudMoonRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                }
            }
        ]
    })(props);
}
function FaCloudMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
                }
            }
        ]
    })(props);
}
function FaCloudRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
                }
            }
        ]
    })(props);
}
function FaCloudShowersHeavy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaCloudSunRain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
                }
            }
        ]
    })(props);
}
function FaCloudSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
                }
            }
        ]
    })(props);
}
function FaCloudUploadAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
                }
            }
        ]
    })(props);
}
function FaCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
                }
            }
        ]
    })(props);
}
function FaCocktail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
                }
            }
        ]
    })(props);
}
function FaCodeBranch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
                }
            }
        ]
    })(props);
}
function FaCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
                }
            }
        ]
    })(props);
}
function FaCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaCogs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
                }
            }
        ]
    })(props);
}
function FaCoins(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
                }
            }
        ]
    })(props);
}
function FaColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
                }
            }
        ]
    })(props);
}
function FaCommentAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaCommentDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
                }
            }
        ]
    })(props);
}
function FaCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaCommentMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
                }
            }
        ]
    })(props);
}
function FaCommentSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                }
            }
        ]
    })(props);
}
function FaComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
                }
            }
        ]
    })(props);
}
function FaCommentsDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
                }
            }
        ]
    })(props);
}
function FaComments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
                }
            }
        ]
    })(props);
}
function FaCompactDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
                }
            }
        ]
    })(props);
}
function FaCompressAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
                }
            }
        ]
    })(props);
}
function FaCompressArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
                }
            }
        ]
    })(props);
}
function FaCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaConciergeBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaCookieBite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
                }
            }
        ]
    })(props);
}
function FaCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
                }
            }
        ]
    })(props);
}
function FaCouch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
                }
            }
        ]
    })(props);
}
function FaCropAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
                }
            }
        ]
    })(props);
}
function FaCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaCross(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaCrosshairs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
                }
            }
        ]
    })(props);
}
function FaCrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaCrutch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
                }
            }
        ]
    })(props);
}
function FaCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
                }
            }
        ]
    })(props);
}
function FaCubes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
                }
            }
        ]
    })(props);
}
function FaCut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
                }
            }
        ]
    })(props);
}
function FaDeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
                }
            }
        ]
    })(props);
}
function FaDemocrat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
                }
            }
        ]
    })(props);
}
function FaDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
                }
            }
        ]
    })(props);
}
function FaDharmachakra(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
                }
            }
        ]
    })(props);
}
function FaDiagnoses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaDiceD20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
                }
            }
        ]
    })(props);
}
function FaDiceD6(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
                }
            }
        ]
    })(props);
}
function FaDiceFive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceFour(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceSix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceThree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDiceTwo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaDigitalTachograph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
                }
            }
        ]
    })(props);
}
function FaDirections(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
                }
            }
        ]
    })(props);
}
function FaDisease(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                }
            }
        ]
    })(props);
}
function FaDivide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
                }
            }
        ]
    })(props);
}
function FaDna(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
                }
            }
        ]
    })(props);
}
function FaDog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
                }
            }
        ]
    })(props);
}
function FaDollarSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
                }
            }
        ]
    })(props);
}
function FaDollyFlatbed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaDolly(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaDonate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaDoorClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaDoorOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
                }
            }
        ]
    })(props);
}
function FaDotCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
                }
            }
        ]
    })(props);
}
function FaDove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                }
            }
        ]
    })(props);
}
function FaDraftingCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaDragon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
                }
            }
        ]
    })(props);
}
function FaDrawPolygon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaDrumSteelpan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
                }
            }
        ]
    })(props);
}
function FaDrum(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
                }
            }
        ]
    })(props);
}
function FaDrumstickBite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
                }
            }
        ]
    })(props);
}
function FaDumbbell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaDumpsterFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
                }
            }
        ]
    })(props);
}
function FaDumpster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaDungeon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
                }
            }
        ]
    })(props);
}
function FaEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
                }
            }
        ]
    })(props);
}
function FaEgg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
                }
            }
        ]
    })(props);
}
function FaEject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
                }
            }
        ]
    })(props);
}
function FaEllipsisH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
                }
            }
        ]
    })(props);
}
function FaEllipsisV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeOpenText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
                }
            }
        ]
    })(props);
}
function FaEnvelopeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
                }
            }
        ]
    })(props);
}
function FaEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                }
            }
        ]
    })(props);
}
function FaEquals(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
                }
            }
        ]
    })(props);
}
function FaEthernet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaEuroSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
                }
            }
        ]
    })(props);
}
function FaExchangeAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(props);
}
function FaExclamationTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
                }
            }
        ]
    })(props);
}
function FaExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
                }
            }
        ]
    })(props);
}
function FaExpandAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
                }
            }
        ]
    })(props);
}
function FaExpandArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
                }
            }
        ]
    })(props);
}
function FaExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaExternalLinkAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
                }
            }
        ]
    })(props);
}
function FaExternalLinkSquareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaEyeDropper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
                }
            }
        ]
    })(props);
}
function FaEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
                }
            }
        ]
    })(props);
}
function FaEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                }
            }
        ]
    })(props);
}
function FaFan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                }
            }
        ]
    })(props);
}
function FaFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function FaFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaFaucet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
                }
            }
        ]
    })(props);
}
function FaFax(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
                }
            }
        ]
    })(props);
}
function FaFeatherAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
                }
            }
        ]
    })(props);
}
function FaFeather(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
                }
            }
        ]
    })(props);
}
function FaFemale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
                }
            }
        ]
    })(props);
}
function FaFighterJet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
                }
            }
        ]
    })(props);
}
function FaFileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
                }
            }
        ]
    })(props);
}
function FaFileAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
                }
            }
        ]
    })(props);
}
function FaFileContract(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileCsv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
                }
            }
        ]
    })(props);
}
function FaFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
                }
            }
        ]
    })(props);
}
function FaFileImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
                }
            }
        ]
    })(props);
}
function FaFileInvoiceDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
                }
            }
        ]
    })(props);
}
function FaFileInvoice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
                }
            }
        ]
    })(props);
}
function FaFileMedicalAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
                }
            }
        ]
    })(props);
}
function FaFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
                }
            }
        ]
    })(props);
}
function FaFilePowerpoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
                }
            }
        ]
    })(props);
}
function FaFilePrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFileSignature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
                }
            }
        ]
    })(props);
}
function FaFileUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
                }
            }
        ]
    })(props);
}
function FaFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
                }
            }
        ]
    })(props);
}
function FaFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                }
            }
        ]
    })(props);
}
function FaFillDrip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
                }
            }
        ]
    })(props);
}
function FaFill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
                }
            }
        ]
    })(props);
}
function FaFilm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
                }
            }
        ]
    })(props);
}
function FaFingerprint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
                }
            }
        ]
    })(props);
}
function FaFireAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
                }
            }
        ]
    })(props);
}
function FaFireExtinguisher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
                }
            }
        ]
    })(props);
}
function FaFirstAid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaFish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaFistRaised(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
                }
            }
        ]
    })(props);
}
function FaFlagCheckered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
                }
            }
        ]
    })(props);
}
function FaFlagUsa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
                }
            }
        ]
    })(props);
}
function FaFlask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
                }
            }
        ]
    })(props);
}
function FaFlushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
                }
            }
        ]
    })(props);
}
function FaFolderMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
                }
            }
        ]
    })(props);
}
function FaFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
                }
            }
        ]
    })(props);
}
function FaFolderPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
                }
            }
        ]
    })(props);
}
function FaFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaFont(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
                }
            }
        ]
    })(props);
}
function FaFootballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
                }
            }
        ]
    })(props);
}
function FaForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
                }
            }
        ]
    })(props);
}
function FaFrog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaFrownOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
                }
            }
        ]
    })(props);
}
function FaFunnelDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
                }
            }
        ]
    })(props);
}
function FaFutbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
                }
            }
        ]
    })(props);
}
function FaGamepad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
                }
            }
        ]
    })(props);
}
function FaGasPump(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
                }
            }
        ]
    })(props);
}
function FaGavel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
                }
            }
        ]
    })(props);
}
function FaGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
                }
            }
        ]
    })(props);
}
function FaGenderless(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
                }
            }
        ]
    })(props);
}
function FaGhost(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function FaGifts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
                }
            }
        ]
    })(props);
}
function FaGlassCheers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
                }
            }
        ]
    })(props);
}
function FaGlassMartiniAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
                }
            }
        ]
    })(props);
}
function FaGlassMartini(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
                }
            }
        ]
    })(props);
}
function FaGlassWhiskey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
                }
            }
        ]
    })(props);
}
function FaGlasses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
                }
            }
        ]
    })(props);
}
function FaGlobeAfrica(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
                }
            }
        ]
    })(props);
}
function FaGlobeAmericas(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
                }
            }
        ]
    })(props);
}
function FaGlobeAsia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
                }
            }
        ]
    })(props);
}
function FaGlobeEurope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
                }
            }
        ]
    })(props);
}
function FaGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
                }
            }
        ]
    })(props);
}
function FaGolfBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
                }
            }
        ]
    })(props);
}
function FaGopuram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaGraduationCap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
                }
            }
        ]
    })(props);
}
function FaGreaterThanEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaGreaterThan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
                }
            }
        ]
    })(props);
}
function FaGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
                }
            }
        ]
    })(props);
}
function FaGrinAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinBeamSweat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
                }
            }
        ]
    })(props);
}
function FaGrinSquintTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
                }
            }
        ]
    })(props);
}
function FaGrinSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
                }
            }
        ]
    })(props);
}
function FaGrinTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGrinTongueSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
                }
            }
        ]
    })(props);
}
function FaGrinTongueWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                }
            }
        ]
    })(props);
}
function FaGrinTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
                }
            }
        ]
    })(props);
}
function FaGrinWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
                }
            }
        ]
    })(props);
}
function FaGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
                }
            }
        ]
    })(props);
}
function FaGripHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaGripLinesVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
                }
            }
        ]
    })(props);
}
function FaGripLines(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaGripVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaGuitar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
                }
            }
        ]
    })(props);
}
function FaHSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaHamburger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
                }
            }
        ]
    })(props);
}
function FaHammer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
                }
            }
        ]
    })(props);
}
function FaHamsa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingUsd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
                }
            }
        ]
    })(props);
}
function FaHandHoldingWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function FaHandHolding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
                }
            }
        ]
    })(props);
}
function FaHandLizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
                }
            }
        ]
    })(props);
}
function FaHandMiddleFinger(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
                }
            }
        ]
    })(props);
}
function FaHandPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
                }
            }
        ]
    })(props);
}
function FaHandPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
                }
            }
        ]
    })(props);
}
function FaHandPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                }
            }
        ]
    })(props);
}
function FaHandPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
                }
            }
        ]
    })(props);
}
function FaHandPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
                }
            }
        ]
    })(props);
}
function FaHandPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
                }
            }
        ]
    })(props);
}
function FaHandPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
                }
            }
        ]
    })(props);
}
function FaHandRock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
                }
            }
        ]
    })(props);
}
function FaHandScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
                }
            }
        ]
    })(props);
}
function FaHandSparkles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
                }
            }
        ]
    })(props);
}
function FaHandSpock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
                }
            }
        ]
    })(props);
}
function FaHandsHelping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
                }
            }
        ]
    })(props);
}
function FaHandsWash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
                }
            }
        ]
    })(props);
}
function FaHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaHandshakeAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
                }
            }
        ]
    })(props);
}
function FaHandshakeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
                }
            }
        ]
    })(props);
}
function FaHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
                }
            }
        ]
    })(props);
}
function FaHanukiah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
                }
            }
        ]
    })(props);
}
function FaHardHat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaHashtag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
                }
            }
        ]
    })(props);
}
function FaHatCowboySide(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
                }
            }
        ]
    })(props);
}
function FaHatCowboy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
                }
            }
        ]
    })(props);
}
function FaHatWizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
                }
            }
        ]
    })(props);
}
function FaHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaHeadSideCoughSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
                }
            }
        ]
    })(props);
}
function FaHeadSideCough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
                }
            }
        ]
    })(props);
}
function FaHeadSideMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
                }
            }
        ]
    })(props);
}
function FaHeadSideVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
                }
            }
        ]
    })(props);
}
function FaHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
                }
            }
        ]
    })(props);
}
function FaHeadphonesAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
                }
            }
        ]
    })(props);
}
function FaHeadphones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
                }
            }
        ]
    })(props);
}
function FaHeadset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
                }
            }
        ]
    })(props);
}
function FaHeartBroken(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
                }
            }
        ]
    })(props);
}
function FaHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
                }
            }
        ]
    })(props);
}
function FaHeartbeat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
                }
            }
        ]
    })(props);
}
function FaHelicopter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
                }
            }
        ]
    })(props);
}
function FaHighlighter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 544 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
                }
            }
        ]
    })(props);
}
function FaHiking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
                }
            }
        ]
    })(props);
}
function FaHippo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                }
            }
        ]
    })(props);
}
function FaHockeyPuck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
                }
            }
        ]
    })(props);
}
function FaHollyBerry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
                }
            }
        ]
    })(props);
}
function FaHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                }
            }
        ]
    })(props);
}
function FaHorseHead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaHorse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaHospitalAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
                }
            }
        ]
    })(props);
}
function FaHospitalSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
                }
            }
        ]
    })(props);
}
function FaHospitalUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
                }
            }
        ]
    })(props);
}
function FaHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
                }
            }
        ]
    })(props);
}
function FaHotTub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaHotdog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
                }
            }
        ]
    })(props);
}
function FaHotel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                }
            }
        ]
    })(props);
}
function FaHourglassEnd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
                }
            }
        ]
    })(props);
}
function FaHourglassHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
                }
            }
        ]
    })(props);
}
function FaHourglassStart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
                }
            }
        ]
    })(props);
}
function FaHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
                }
            }
        ]
    })(props);
}
function FaHouseDamage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
                }
            }
        ]
    })(props);
}
function FaHouseUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
                }
            }
        ]
    })(props);
}
function FaHryvnia(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
                }
            }
        ]
    })(props);
}
function FaICursor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
                }
            }
        ]
    })(props);
}
function FaIceCream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
                }
            }
        ]
    })(props);
}
function FaIcicles(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
                }
            }
        ]
    })(props);
}
function FaIcons(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
                }
            }
        ]
    })(props);
}
function FaIdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function FaIdCardAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
                }
            }
        ]
    })(props);
}
function FaIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
                }
            }
        ]
    })(props);
}
function FaIgloo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                }
            }
        ]
    })(props);
}
function FaImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
                }
            }
        ]
    })(props);
}
function FaInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
                }
            }
        ]
    })(props);
}
function FaIndent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaIndustry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
                }
            }
        ]
    })(props);
}
function FaInfinity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
                }
            }
        ]
    })(props);
}
function FaInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                }
            }
        ]
    })(props);
}
function FaInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                }
            }
        ]
    })(props);
}
function FaItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
                }
            }
        ]
    })(props);
}
function FaJedi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
                }
            }
        ]
    })(props);
}
function FaJoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaJournalWhills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
                }
            }
        ]
    })(props);
}
function FaKaaba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
                }
            }
        ]
    })(props);
}
function FaKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
                }
            }
        ]
    })(props);
}
function FaKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaKhanda(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
                }
            }
        ]
    })(props);
}
function FaKissBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
                }
            }
        ]
    })(props);
}
function FaKissWinkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
                }
            }
        ]
    })(props);
}
function FaKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaKiwiBird(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
                }
            }
        ]
    })(props);
}
function FaLandmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
                }
            }
        ]
    })(props);
}
function FaLaptopCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                }
            }
        ]
    })(props);
}
function FaLaptopHouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
                }
            }
        ]
    })(props);
}
function FaLaptopMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
                }
            }
        ]
    })(props);
}
function FaLaughBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function FaLaughSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function FaLaughWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
                }
            }
        ]
    })(props);
}
function FaLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
                }
            }
        ]
    })(props);
}
function FaLayerGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
                }
            }
        ]
    })(props);
}
function FaLeaf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
                }
            }
        ]
    })(props);
}
function FaLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
                }
            }
        ]
    })(props);
}
function FaLessThanEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaLessThan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
                }
            }
        ]
    })(props);
}
function FaLevelDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
                }
            }
        ]
    })(props);
}
function FaLevelUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
                }
            }
        ]
    })(props);
}
function FaLifeRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
                }
            }
        ]
    })(props);
}
function FaLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
                }
            }
        ]
    })(props);
}
function FaLiraSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
                }
            }
        ]
    })(props);
}
function FaListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaListOl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
                }
            }
        ]
    })(props);
}
function FaListUl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaLocationArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
                }
            }
        ]
    })(props);
}
function FaLockOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
                }
            }
        ]
    })(props);
}
function FaLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
                }
            }
        ]
    })(props);
}
function FaLongArrowAltUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
                }
            }
        ]
    })(props);
}
function FaLowVision(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
                }
            }
        ]
    })(props);
}
function FaLuggageCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
                }
            }
        ]
    })(props);
}
function FaLungsVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
                }
            }
        ]
    })(props);
}
function FaLungs(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
                }
            }
        ]
    })(props);
}
function FaMagic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
                }
            }
        ]
    })(props);
}
function FaMagnet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
                }
            }
        ]
    })(props);
}
function FaMailBulk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
                }
            }
        ]
    })(props);
}
function FaMale(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 192 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaMapMarkedAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function FaMapMarked(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function FaMapMarkerAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
                }
            }
        ]
    })(props);
}
function FaMapMarker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
                }
            }
        ]
    })(props);
}
function FaMapPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaMapSigns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
                }
            }
        ]
    })(props);
}
function FaMarker(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
                }
            }
        ]
    })(props);
}
function FaMarsDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
                }
            }
        ]
    })(props);
}
function FaMarsStrokeH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function FaMarsStrokeV(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
                }
            }
        ]
    })(props);
}
function FaMarsStroke(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaMars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaMask(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
                }
            }
        ]
    })(props);
}
function FaMedal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
                }
            }
        ]
    })(props);
}
function FaMedkit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
                }
            }
        ]
    })(props);
}
function FaMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaMehRollingEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaMemory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
                }
            }
        ]
    })(props);
}
function FaMenorah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
                }
            }
        ]
    })(props);
}
function FaMercury(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                }
            }
        ]
    })(props);
}
function FaMeteor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
                }
            }
        ]
    })(props);
}
function FaMicrochip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
                }
            }
        ]
    })(props);
}
function FaMicrophoneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMicrophone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMicroscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
                }
            }
        ]
    })(props);
}
function FaMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
                }
            }
        ]
    })(props);
}
function FaMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
                }
            }
        ]
    })(props);
}
function FaMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaMitten(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
                }
            }
        ]
    })(props);
}
function FaMobileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                }
            }
        ]
    })(props);
}
function FaMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillWaveAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
                }
            }
        ]
    })(props);
}
function FaMoneyBillWave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
                }
            }
        ]
    })(props);
}
function FaMoneyBill(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
                }
            }
        ]
    })(props);
}
function FaMoneyCheckAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaMoneyCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMonument(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
                }
            }
        ]
    })(props);
}
function FaMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
                }
            }
        ]
    })(props);
}
function FaMortarPestle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaMosque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
                }
            }
        ]
    })(props);
}
function FaMotorcycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
                }
            }
        ]
    })(props);
}
function FaMountain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
                }
            }
        ]
    })(props);
}
function FaMousePointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
                }
            }
        ]
    })(props);
}
function FaMouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
                }
            }
        ]
    })(props);
}
function FaMugHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaMusic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
                }
            }
        ]
    })(props);
}
function FaNetworkWired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
                }
            }
        ]
    })(props);
}
function FaNeuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaNotEqual(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
                }
            }
        ]
    })(props);
}
function FaNotesMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
                }
            }
        ]
    })(props);
}
function FaObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
                }
            }
        ]
    })(props);
}
function FaOilCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
                }
            }
        ]
    })(props);
}
function FaOm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
                }
            }
        ]
    })(props);
}
function FaOtter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
                }
            }
        ]
    })(props);
}
function FaOutdent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaPager(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
                }
            }
        ]
    })(props);
}
function FaPaintBrush(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
                }
            }
        ]
    })(props);
}
function FaPaintRoller(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaPalette(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaPallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
                }
            }
        ]
    })(props);
}
function FaPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                }
            }
        ]
    })(props);
}
function FaPaperclip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
                }
            }
        ]
    })(props);
}
function FaParachuteBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
                }
            }
        ]
    })(props);
}
function FaParagraph(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
                }
            }
        ]
    })(props);
}
function FaParking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPassport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
                }
            }
        ]
    })(props);
}
function FaPastafarianism(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
                }
            }
        ]
    })(props);
}
function FaPaste(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
                }
            }
        ]
    })(props);
}
function FaPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
                }
            }
        ]
    })(props);
}
function FaPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
                }
            }
        ]
    })(props);
}
function FaPaw(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
                }
            }
        ]
    })(props);
}
function FaPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
                }
            }
        ]
    })(props);
}
function FaPenAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
                }
            }
        ]
    })(props);
}
function FaPenFancy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
                }
            }
        ]
    })(props);
}
function FaPenNib(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
                }
            }
        ]
    })(props);
}
function FaPenSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaPen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
                }
            }
        ]
    })(props);
}
function FaPencilAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
                }
            }
        ]
    })(props);
}
function FaPencilRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
                }
            }
        ]
    })(props);
}
function FaPeopleArrows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
                }
            }
        ]
    })(props);
}
function FaPeopleCarry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
                }
            }
        ]
    })(props);
}
function FaPepperHot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
                }
            }
        ]
    })(props);
}
function FaPercent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
                }
            }
        ]
    })(props);
}
function FaPercentage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
                }
            }
        ]
    })(props);
}
function FaPersonBooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPhoneAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
                }
            }
        ]
    })(props);
}
function FaPhoneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
                }
            }
        ]
    })(props);
}
function FaPhoneSquareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
                }
            }
        ]
    })(props);
}
function FaPhoneSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
                }
            }
        ]
    })(props);
}
function FaPhoneVolume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
                }
            }
        ]
    })(props);
}
function FaPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                }
            }
        ]
    })(props);
}
function FaPhotoVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
                }
            }
        ]
    })(props);
}
function FaPiggyBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
                }
            }
        ]
    })(props);
}
function FaPills(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
                }
            }
        ]
    })(props);
}
function FaPizzaSlice(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
                }
            }
        ]
    })(props);
}
function FaPlaceOfWorship(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
                }
            }
        ]
    })(props);
}
function FaPlaneArrival(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
                }
            }
        ]
    })(props);
}
function FaPlaneDeparture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
                }
            }
        ]
    })(props);
}
function FaPlaneSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
                }
            }
        ]
    })(props);
}
function FaPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
                }
            }
        ]
    })(props);
}
function FaPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
                }
            }
        ]
    })(props);
}
function FaPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
                }
            }
        ]
    })(props);
}
function FaPlug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
                }
            }
        ]
    })(props);
}
function FaPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                }
            }
        ]
    })(props);
}
function FaPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
                }
            }
        ]
    })(props);
}
function FaPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPodcast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaPollH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
                }
            }
        ]
    })(props);
}
function FaPoll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
                }
            }
        ]
    })(props);
}
function FaPooStorm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
                }
            }
        ]
    })(props);
}
function FaPoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaPoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
                }
            }
        ]
    })(props);
}
function FaPortrait(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
                }
            }
        ]
    })(props);
}
function FaPoundSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
                }
            }
        ]
    })(props);
}
function FaPowerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
                }
            }
        ]
    })(props);
}
function FaPray(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
                }
            }
        ]
    })(props);
}
function FaPrayingHands(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
                }
            }
        ]
    })(props);
}
function FaPrescriptionBottleAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
                }
            }
        ]
    })(props);
}
function FaPrescriptionBottle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaPrescription(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
                }
            }
        ]
    })(props);
}
function FaPrint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaProcedures(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaProjectDiagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaPumpMedical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
                }
            }
        ]
    })(props);
}
function FaPumpSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
                }
            }
        ]
    })(props);
}
function FaPuzzlePiece(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
                }
            }
        ]
    })(props);
}
function FaQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
                }
            }
        ]
    })(props);
}
function FaQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
                }
            }
        ]
    })(props);
}
function FaQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
                }
            }
        ]
    })(props);
}
function FaQuidditch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
                }
            }
        ]
    })(props);
}
function FaQuoteLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaQuoteRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaQuran(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
                }
            }
        ]
    })(props);
}
function FaRadiationAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaRadiation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
                }
            }
        ]
    })(props);
}
function FaRainbow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
                }
            }
        ]
    })(props);
}
function FaRandom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
                }
            }
        ]
    })(props);
}
function FaReceipt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaRecordVinyl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
                }
            }
        ]
    })(props);
}
function FaRecycle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
                }
            }
        ]
    })(props);
}
function FaRedoAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
                }
            }
        ]
    })(props);
}
function FaRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
                }
            }
        ]
    })(props);
}
function FaRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
                }
            }
        ]
    })(props);
}
function FaRemoveFormat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
                }
            }
        ]
    })(props);
}
function FaReplyAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
                }
            }
        ]
    })(props);
}
function FaReply(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
                }
            }
        ]
    })(props);
}
function FaRepublican(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaRestroom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
                }
            }
        ]
    })(props);
}
function FaRetweet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
                }
            }
        ]
    })(props);
}
function FaRibbon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
                }
            }
        ]
    })(props);
}
function FaRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
                }
            }
        ]
    })(props);
}
function FaRoad(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
                }
            }
        ]
    })(props);
}
function FaRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
                }
            }
        ]
    })(props);
}
function FaRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
                }
            }
        ]
    })(props);
}
function FaRoute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaRssSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
                }
            }
        ]
    })(props);
}
function FaRss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
                }
            }
        ]
    })(props);
}
function FaRubleSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
                }
            }
        ]
    })(props);
}
function FaRulerCombined(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRulerHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRulerVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
                }
            }
        ]
    })(props);
}
function FaRuler(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
                }
            }
        ]
    })(props);
}
function FaRunning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
                }
            }
        ]
    })(props);
}
function FaRupeeSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
                }
            }
        ]
    })(props);
}
function FaSadCry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
                }
            }
        ]
    })(props);
}
function FaSadTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
                }
            }
        ]
    })(props);
}
function FaSatelliteDish(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
                }
            }
        ]
    })(props);
}
function FaSatellite(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
                }
            }
        ]
    })(props);
}
function FaSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
                }
            }
        ]
    })(props);
}
function FaSchool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaScrewdriver(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
                }
            }
        ]
    })(props);
}
function FaScroll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
                }
            }
        ]
    })(props);
}
function FaSdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
                }
            }
        ]
    })(props);
}
function FaSearchDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
                }
            }
        ]
    })(props);
}
function FaSearchLocation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaSearchMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                }
            }
        ]
    })(props);
}
function FaSearchPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
                }
            }
        ]
    })(props);
}
function FaSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaSeedling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
                }
            }
        ]
    })(props);
}
function FaServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaShapes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
                }
            }
        ]
    })(props);
}
function FaShareAltSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
                }
            }
        ]
    })(props);
}
function FaShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaShareSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
                }
            }
        ]
    })(props);
}
function FaShare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
                }
            }
        ]
    })(props);
}
function FaShekelSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaShieldAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
                }
            }
        ]
    })(props);
}
function FaShieldVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
                }
            }
        ]
    })(props);
}
function FaShip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
                }
            }
        ]
    })(props);
}
function FaShippingFast(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function FaShoePrints(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
                }
            }
        ]
    })(props);
}
function FaShoppingBag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaShoppingBasket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
                }
            }
        ]
    })(props);
}
function FaShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
                }
            }
        ]
    })(props);
}
function FaShower(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
                }
            }
        ]
    })(props);
}
function FaShuttleVan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
                }
            }
        ]
    })(props);
}
function FaSignInAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                }
            }
        ]
    })(props);
}
function FaSignLanguage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
                }
            }
        ]
    })(props);
}
function FaSignOutAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
                }
            }
        ]
    })(props);
}
function FaSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaSignature(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
                }
            }
        ]
    })(props);
}
function FaSimCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
                }
            }
        ]
    })(props);
}
function FaSink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
                }
            }
        ]
    })(props);
}
function FaSitemap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaSkating(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaSkiingNordic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
                }
            }
        ]
    })(props);
}
function FaSkiing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
                }
            }
        ]
    })(props);
}
function FaSkullCrossbones(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaSkull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
                }
            }
        ]
    })(props);
}
function FaSleigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
                }
            }
        ]
    })(props);
}
function FaSlidersH(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaSmileBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
                }
            }
        ]
    })(props);
}
function FaSmileWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
                }
            }
        ]
    })(props);
}
function FaSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
                }
            }
        ]
    })(props);
}
function FaSmog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
                }
            }
        ]
    })(props);
}
function FaSmokingBan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
                }
            }
        ]
    })(props);
}
function FaSmoking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function FaSms(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
                }
            }
        ]
    })(props);
}
function FaSnowboarding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
                }
            }
        ]
    })(props);
}
function FaSnowflake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
                }
            }
        ]
    })(props);
}
function FaSnowman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaSnowplow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaSoap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
                }
            }
        ]
    })(props);
}
function FaSocks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
                }
            }
        ]
    })(props);
}
function FaSolarPanel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAlphaUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
                }
            }
        ]
    })(props);
}
function FaSortAmountDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                }
            }
        ]
    })(props);
}
function FaSortAmountDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSortAmountUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
                }
            }
        ]
    })(props);
}
function FaSortAmountUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSortDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
                }
            }
        ]
    })(props);
}
function FaSortNumericDownAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                }
            }
        ]
    })(props);
}
function FaSortNumericDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
                }
            }
        ]
    })(props);
}
function FaSortNumericUpAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
                }
            }
        ]
    })(props);
}
function FaSortNumericUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
                }
            }
        ]
    })(props);
}
function FaSortUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
                }
            }
        ]
    })(props);
}
function FaSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
                }
            }
        ]
    })(props);
}
function FaSpa(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
                }
            }
        ]
    })(props);
}
function FaSpaceShuttle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
                }
            }
        ]
    })(props);
}
function FaSpellCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
                }
            }
        ]
    })(props);
}
function FaSpider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
                }
            }
        ]
    })(props);
}
function FaSpinner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaSplotch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
                }
            }
        ]
    })(props);
}
function FaSprayCan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaSquareFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 512H0V0h512v512z"
                }
            }
        ]
    })(props);
}
function FaSquareRootAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaStamp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaStarAndCrescent(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
                }
            }
        ]
    })(props);
}
function FaStarHalfAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 536 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
                }
            }
        ]
    })(props);
}
function FaStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
                }
            }
        ]
    })(props);
}
function FaStarOfDavid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 464 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
                }
            }
        ]
    })(props);
}
function FaStarOfLife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
                }
            }
        ]
    })(props);
}
function FaStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
                }
            }
        ]
    })(props);
}
function FaStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function FaStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaStethoscope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaStickyNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
                }
            }
        ]
    })(props);
}
function FaStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
                }
            }
        ]
    })(props);
}
function FaStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaStopwatch20(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
                }
            }
        ]
    })(props);
}
function FaStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
                }
            }
        ]
    })(props);
}
function FaStoreAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
                }
            }
        ]
    })(props);
}
function FaStoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
                }
            }
        ]
    })(props);
}
function FaStoreSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
                }
            }
        ]
    })(props);
}
function FaStore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 616 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
                }
            }
        ]
    })(props);
}
function FaStream(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaStreetView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
                }
            }
        ]
    })(props);
}
function FaStroopwafel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
                }
            }
        ]
    })(props);
}
function FaSubscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSubway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaSuitcaseRolling(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
                }
            }
        ]
    })(props);
}
function FaSuitcase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
                }
            }
        ]
    })(props);
}
function FaSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
                }
            }
        ]
    })(props);
}
function FaSuperscript(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaSwatchbook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
                }
            }
        ]
    })(props);
}
function FaSwimmer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
                }
            }
        ]
    })(props);
}
function FaSwimmingPool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
                }
            }
        ]
    })(props);
}
function FaSynagogue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
                }
            }
        ]
    })(props);
}
function FaSyncAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
                }
            }
        ]
    })(props);
}
function FaSyringe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
                }
            }
        ]
    })(props);
}
function FaTableTennis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
                }
            }
        ]
    })(props);
}
function FaTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
                }
            }
        ]
    })(props);
}
function FaTabletAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
                }
            }
        ]
    })(props);
}
function FaTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTablets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
                }
            }
        ]
    })(props);
}
function FaTachometerAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
                }
            }
        ]
    })(props);
}
function FaTape(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function FaTasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTaxi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTeethOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
                }
            }
        ]
    })(props);
}
function FaTeeth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
                }
            }
        ]
    })(props);
}
function FaTemperatureHigh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                }
            }
        ]
    })(props);
}
function FaTemperatureLow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
                }
            }
        ]
    })(props);
}
function FaTenge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
                }
            }
        ]
    })(props);
}
function FaTerminal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
                }
            }
        ]
    })(props);
}
function FaTextHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
                }
            }
        ]
    })(props);
}
function FaTextWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
                }
            }
        ]
    })(props);
}
function FaThLarge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
                }
            }
        ]
    })(props);
}
function FaThList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
                }
            }
        ]
    })(props);
}
function FaTh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
                }
            }
        ]
    })(props);
}
function FaTheaterMasks(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
                }
            }
        ]
    })(props);
}
function FaThermometerEmpty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometerFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
                }
            }
        ]
    })(props);
}
function FaThermometerHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometerQuarter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometerThreeQuarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
                }
            }
        ]
    })(props);
}
function FaThermometer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
                }
            }
        ]
    })(props);
}
function FaThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
                }
            }
        ]
    })(props);
}
function FaThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
                }
            }
        ]
    })(props);
}
function FaThumbtack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
                }
            }
        ]
    })(props);
}
function FaTicketAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
                }
            }
        ]
    })(props);
}
function FaTimesCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
                }
            }
        ]
    })(props);
}
function FaTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                }
            }
        ]
    })(props);
}
function FaTintSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
                }
            }
        ]
    })(props);
}
function FaTint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
                }
            }
        ]
    })(props);
}
function FaToggleOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaToggleOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
                }
            }
        ]
    })(props);
}
function FaToiletPaperSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
                }
            }
        ]
    })(props);
}
function FaToiletPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
                }
            }
        ]
    })(props);
}
function FaToilet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
                }
            }
        ]
    })(props);
}
function FaToolbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
                }
            }
        ]
    })(props);
}
function FaTools(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaTooth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
                }
            }
        ]
    })(props);
}
function FaTorah(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
                }
            }
        ]
    })(props);
}
function FaToriiGate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
                }
            }
        ]
    })(props);
}
function FaTractor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
                }
            }
        ]
    })(props);
}
function FaTrademark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
                }
            }
        ]
    })(props);
}
function FaTrafficLight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTrailer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
                }
            }
        ]
    })(props);
}
function FaTrain(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
                }
            }
        ]
    })(props);
}
function FaTram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaTransgenderAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaTransgender(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaTrashAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrashRestoreAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrashRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                }
            }
        ]
    })(props);
}
function FaTree(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
                }
            }
        ]
    })(props);
}
function FaTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
                }
            }
        ]
    })(props);
}
function FaTruckLoading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTruckMonster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTruckMoving(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaTruckPickup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
                }
            }
        ]
    })(props);
}
function FaTruck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
                }
            }
        ]
    })(props);
}
function FaTshirt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
                }
            }
        ]
    })(props);
}
function FaTty(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaTv(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
                }
            }
        ]
    })(props);
}
function FaUmbrellaBeach(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaUmbrella(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
                }
            }
        ]
    })(props);
}
function FaUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
                }
            }
        ]
    })(props);
}
function FaUndoAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
                }
            }
        ]
    })(props);
}
function FaUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaUniversalAccess(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
                }
            }
        ]
    })(props);
}
function FaUniversity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
                }
            }
        ]
    })(props);
}
function FaUnlink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
                }
            }
        ]
    })(props);
}
function FaUnlockAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
                }
            }
        ]
    })(props);
}
function FaUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                }
            }
        ]
    })(props);
}
function FaUserAltSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
                }
            }
        ]
    })(props);
}
function FaUserAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
                }
            }
        ]
    })(props);
}
function FaUserAstronaut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function FaUserCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
                }
            }
        ]
    })(props);
}
function FaUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                }
            }
        ]
    })(props);
}
function FaUserClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
                }
            }
        ]
    })(props);
}
function FaUserCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
                }
            }
        ]
    })(props);
}
function FaUserEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
                }
            }
        ]
    })(props);
}
function FaUserFriends(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
                }
            }
        ]
    })(props);
}
function FaUserGraduate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
                }
            }
        ]
    })(props);
}
function FaUserInjured(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUserLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
                }
            }
        ]
    })(props);
}
function FaUserMd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
                }
            }
        ]
    })(props);
}
function FaUserMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUserNinja(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
                }
            }
        ]
    })(props);
}
function FaUserNurse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
                }
            }
        ]
    })(props);
}
function FaUserPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUserSecret(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
                }
            }
        ]
    })(props);
}
function FaUserShield(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                }
            }
        ]
    })(props);
}
function FaUserSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
                }
            }
        ]
    })(props);
}
function FaUserTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
                }
            }
        ]
    })(props);
}
function FaUserTie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
                }
            }
        ]
    })(props);
}
function FaUserTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
                }
            }
        ]
    })(props);
}
function FaUsersCog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                }
            }
        ]
    })(props);
}
function FaUsersSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
                }
            }
        ]
    })(props);
}
function FaUsers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
                }
            }
        ]
    })(props);
}
function FaUtensilSpoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
                }
            }
        ]
    })(props);
}
function FaUtensils(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 416 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
                }
            }
        ]
    })(props);
}
function FaVectorSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
                }
            }
        ]
    })(props);
}
function FaVenusDouble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
                }
            }
        ]
    })(props);
}
function FaVenusMars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function FaVenus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
                }
            }
        ]
    })(props);
}
function FaVestPatches(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
                }
            }
        ]
    })(props);
}
function FaVest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
                }
            }
        ]
    })(props);
}
function FaVial(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 480 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
                }
            }
        ]
    })(props);
}
function FaVials(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
                }
            }
        ]
    })(props);
}
function FaVideoSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
                }
            }
        ]
    })(props);
}
function FaVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
                }
            }
        ]
    })(props);
}
function FaVihara(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
                }
            }
        ]
    })(props);
}
function FaVirusSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
                }
            }
        ]
    })(props);
}
function FaVirus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
                }
            }
        ]
    })(props);
}
function FaViruses(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
                }
            }
        ]
    })(props);
}
function FaVoicemail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
                }
            }
        ]
    })(props);
}
function FaVolleyballBall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
                }
            }
        ]
    })(props);
}
function FaVolumeDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
                }
            }
        ]
    })(props);
}
function FaVolumeMute(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
                }
            }
        ]
    })(props);
}
function FaVolumeOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 256 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
                }
            }
        ]
    })(props);
}
function FaVolumeUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
                }
            }
        ]
    })(props);
}
function FaVoteYea(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
                }
            }
        ]
    })(props);
}
function FaVrCardboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
                }
            }
        ]
    })(props);
}
function FaWalking(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 320 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
                }
            }
        ]
    })(props);
}
function FaWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaWarehouse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
                }
            }
        ]
    })(props);
}
function FaWater(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
                }
            }
        ]
    })(props);
}
function FaWaveSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
                }
            }
        ]
    })(props);
}
function FaWeightHanging(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaWeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
                }
            }
        ]
    })(props);
}
function FaWheelchair(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
                }
            }
        ]
    })(props);
}
function FaWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
                }
            }
        ]
    })(props);
}
function FaWind(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
                }
            }
        ]
    })(props);
}
function FaWindowClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
                }
            }
        ]
    })(props);
}
function FaWindowMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
                }
            }
        ]
    })(props);
}
function FaWindowMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaWindowRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
                }
            }
        ]
    })(props);
}
function FaWineBottle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
                }
            }
        ]
    })(props);
}
function FaWineGlassAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
                }
            }
        ]
    })(props);
}
function FaWineGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 288 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
                }
            }
        ]
    })(props);
}
function FaWonSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
                }
            }
        ]
    })(props);
}
function FaWrench(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
                }
            }
        ]
    })(props);
}
function FaXRay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
                }
            }
        ]
    })(props);
}
function FaYenSign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
                }
            }
        ]
    })(props);
}
function FaYinYang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegAddressBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                }
            }
        ]
    })(props);
}
function FaRegAddressCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function FaRegAngry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
                }
            }
        ]
    })(props);
}
function FaRegArrowAltCircleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
                }
            }
        ]
    })(props);
}
function FaRegBellSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function FaRegBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
                }
            }
        ]
    })(props);
}
function FaRegBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
                }
            }
        ]
    })(props);
}
function FaRegBuilding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendarTimes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegCaretSquareUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegChartBar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
                }
            }
        ]
    })(props);
}
function FaRegCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
                }
            }
        ]
    })(props);
}
function FaRegCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
                }
            }
        ]
    })(props);
}
function FaRegCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
                }
            }
        ]
    })(props);
}
function FaRegClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
                }
            }
        ]
    })(props);
}
function FaRegClone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
                }
            }
        ]
    })(props);
}
function FaRegClosedCaptioning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
                }
            }
        ]
    })(props);
}
function FaRegCommentAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
                }
            }
        ]
    })(props);
}
function FaRegCommentDots(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                }
            }
        ]
    })(props);
}
function FaRegComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
                }
            }
        ]
    })(props);
}
function FaRegComments(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
                }
            }
        ]
    })(props);
}
function FaRegCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
                }
            }
        ]
    })(props);
}
function FaRegCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
                }
            }
        ]
    })(props);
}
function FaRegCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
                }
            }
        ]
    })(props);
}
function FaRegDizzy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function FaRegDotCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
                }
            }
        ]
    })(props);
}
function FaRegEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
                }
            }
        ]
    })(props);
}
function FaRegEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
                }
            }
        ]
    })(props);
}
function FaRegEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                }
            }
        ]
    })(props);
}
function FaRegEyeSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
                }
            }
        ]
    })(props);
}
function FaRegEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
                }
            }
        ]
    })(props);
}
function FaRegFileAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
                }
            }
        ]
    })(props);
}
function FaRegFileArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
                }
            }
        ]
    })(props);
}
function FaRegFileAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
                }
            }
        ]
    })(props);
}
function FaRegFileCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
                }
            }
        ]
    })(props);
}
function FaRegFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
                }
            }
        ]
    })(props);
}
function FaRegFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
                }
            }
        ]
    })(props);
}
function FaRegFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
                }
            }
        ]
    })(props);
}
function FaRegFilePowerpoint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
                }
            }
        ]
    })(props);
}
function FaRegFileVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
                }
            }
        ]
    })(props);
}
function FaRegFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
                }
            }
        ]
    })(props);
}
function FaRegFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
                }
            }
        ]
    })(props);
}
function FaRegFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
                }
            }
        ]
    })(props);
}
function FaRegFlushed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
                }
            }
        ]
    })(props);
}
function FaRegFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
                }
            }
        ]
    })(props);
}
function FaRegFontAwesomeLogoFull(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 3992 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
                }
            }
        ]
    })(props);
}
function FaRegFrownOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
                }
            }
        ]
    })(props);
}
function FaRegFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
                }
            }
        ]
    })(props);
}
function FaRegFutbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
                }
            }
        ]
    })(props);
}
function FaRegGem(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
                }
            }
        ]
    })(props);
}
function FaRegGrimace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
                }
            }
        ]
    })(props);
}
function FaRegGrinAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinBeamSweat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                }
            }
        ]
    })(props);
}
function FaRegGrinBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinHearts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegGrinSquintTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
                }
            }
        ]
    })(props);
}
function FaRegGrinSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
                }
            }
        ]
    })(props);
}
function FaRegGrinStars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTears(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTongueSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTongueWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
                }
            }
        ]
    })(props);
}
function FaRegGrinTongue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegGrinWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
                }
            }
        ]
    })(props);
}
function FaRegGrin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
                }
            }
        ]
    })(props);
}
function FaRegHandLizard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
                }
            }
        ]
    })(props);
}
function FaRegHandPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
                }
            }
        ]
    })(props);
}
function FaRegHandPeace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
                }
            }
        ]
    })(props);
}
function FaRegHandPointer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
                }
            }
        ]
    })(props);
}
function FaRegHandRock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
                }
            }
        ]
    })(props);
}
function FaRegHandScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
                }
            }
        ]
    })(props);
}
function FaRegHandSpock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
                }
            }
        ]
    })(props);
}
function FaRegHandshake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
                }
            }
        ]
    })(props);
}
function FaRegHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
                }
            }
        ]
    })(props);
}
function FaRegHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
                }
            }
        ]
    })(props);
}
function FaRegHospital(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
                }
            }
        ]
    })(props);
}
function FaRegHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
                }
            }
        ]
    })(props);
}
function FaRegIdBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 384 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
                }
            }
        ]
    })(props);
}
function FaRegIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
                }
            }
        ]
    })(props);
}
function FaRegImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
                }
            }
        ]
    })(props);
}
function FaRegImages(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
                }
            }
        ]
    })(props);
}
function FaRegKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
                }
            }
        ]
    })(props);
}
function FaRegKissBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
                }
            }
        ]
    })(props);
}
function FaRegKissWinkHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 504 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
                }
            }
        ]
    })(props);
}
function FaRegKiss(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegLaughBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLaughSquint(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLaughWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLaugh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
                }
            }
        ]
    })(props);
}
function FaRegLemon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
                }
            }
        ]
    })(props);
}
function FaRegLifeRing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
                }
            }
        ]
    })(props);
}
function FaRegLightbulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 352 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
                }
            }
        ]
    })(props);
}
function FaRegListAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
                }
            }
        ]
    })(props);
}
function FaRegMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
                }
            }
        ]
    })(props);
}
function FaRegMehBlank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegMehRollingEyes(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
                }
            }
        ]
    })(props);
}
function FaRegMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegMoneyBillAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 640 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
                }
            }
        ]
    })(props);
}
function FaRegMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
                }
            }
        ]
    })(props);
}
function FaRegNewspaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
                }
            }
        ]
    })(props);
}
function FaRegObjectGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
                }
            }
        ]
    })(props);
}
function FaRegObjectUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
                }
            }
        ]
    })(props);
}
function FaRegPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
                }
            }
        ]
    })(props);
}
function FaRegPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaRegPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
                }
            }
        ]
    })(props);
}
function FaRegPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                }
            }
        ]
    })(props);
}
function FaRegQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
                }
            }
        ]
    })(props);
}
function FaRegRegistered(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
                }
            }
        ]
    })(props);
}
function FaRegSadCry(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
                }
            }
        ]
    })(props);
}
function FaRegSadTear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
                }
            }
        ]
    })(props);
}
function FaRegSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
                }
            }
        ]
    })(props);
}
function FaRegShareSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
                }
            }
        ]
    })(props);
}
function FaRegSmileBeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
                }
            }
        ]
    })(props);
}
function FaRegSmileWink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
                }
            }
        ]
    })(props);
}
function FaRegSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
                }
            }
        ]
    })(props);
}
function FaRegSnowflake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
                }
            }
        ]
    })(props);
}
function FaRegSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                }
            }
        ]
    })(props);
}
function FaRegStarHalf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
                }
            }
        ]
    })(props);
}
function FaRegStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 576 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
                }
            }
        ]
    })(props);
}
function FaRegStickyNote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
                }
            }
        ]
    })(props);
}
function FaRegStopCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
                }
            }
        ]
    })(props);
}
function FaRegSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
                }
            }
        ]
    })(props);
}
function FaRegSurprise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function FaRegThumbsDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
                }
            }
        ]
    })(props);
}
function FaRegThumbsUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
                }
            }
        ]
    })(props);
}
function FaRegTimesCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
                }
            }
        ]
    })(props);
}
function FaRegTired(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
                }
            }
        ]
    })(props);
}
function FaRegTrashAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
                }
            }
        ]
    })(props);
}
function FaRegUserCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 496 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
                }
            }
        ]
    })(props);
}
function FaRegUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 448 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
                }
            }
        ]
    })(props);
}
function FaRegWindowClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
                }
            }
        ]
    })(props);
}
function FaRegWindowMaximize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
                }
            }
        ]
    })(props);
}
function FaRegWindowMinimize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function FaRegWindowRestore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 512 512"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
                }
            }
        ]
    })(props);
}

},{"../lib":"9iXc2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"i5Our":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _reactFileDrop = require("react-file-drop");
var _fa = require("react-icons/fa");
var _useTheme = require("../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
let _ = (t)=>t, t, t1, t2, t3;
const UploadProjectWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .drop-zone-wrapper {
    width: 80%;
    height: 80%;
  }

  .drop-zone {
    height: 100%;
    width: 100%;
    border-style: dashed;
    border-width: 2px;
    border-color: ${0};
    opacity: 0.5;
    cursor: pointer;
  }

  .drop-zone:hover,
  .drop-zone-drag-over {
    opacity: 1;
  }
`), ({ theme })=>theme.colors.highlight2);
const DropZoneInner = (0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`));
const FileUploadIcon = (0, _styledDefault.default)((0, _fa.FaFileUpload))(t2 || (t2 = _`
  width: 100%;
  height: 8rem;
`));
const FileUploadMessage = (0, _styledDefault.default).div(t3 || (t3 = _`
  font-size: 2rem;
`));
// @TODO: unify with upload file
const UploadProject = ({ isOpen, closeMenu })=>{
    const theme = (0, _useThemeDefault.default)();
    const setProject = (0, _storeDefault.default)((store)=>store.setProject);
    const fileInputRef = (0, _react.useRef)(null);
    const uploadFile = (0, _react.useCallback)((files)=>{
        const [file] = files || [];
        file.text().then(JSON.parse).then((projectState)=>{
            setProject(projectState);
            closeMenu();
        }).catch(console.error);
    }, [
        setProject,
        closeMenu
    ]);
    const onTargetClick = ()=>{
        var _fileInputRef_current;
        (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    return isOpen ? (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        onClose: closeMenu,
        children: (0, _jsxRuntime.jsxs)(UploadProjectWrapper, {
            theme: theme,
            children: [
                (0, _jsxRuntime.jsx)("input", {
                    onChange: ({ target: { files } })=>uploadFile(files),
                    ref: fileInputRef,
                    type: "file",
                    className: "hidden",
                    style: {
                        display: "none"
                    },
                    accept: ".json"
                }),
                (0, _jsxRuntime.jsx)((0, _reactFileDrop.FileDrop), {
                    className: "drop-zone-wrapper",
                    targetClassName: "drop-zone",
                    draggingOverTargetClassName: "drop-zone-drag-over",
                    onTargetClick: onTargetClick,
                    onDrop: (files)=>uploadFile(files),
                    children: (0, _jsxRuntime.jsxs)(DropZoneInner, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)(FileUploadIcon, {}),
                            (0, _jsxRuntime.jsx)(FileUploadMessage, {
                                children: "click or drop file here"
                            })
                        ]
                    })
                })
            ]
        })
    }) : null;
};
exports.default = UploadProject;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","react-file-drop":"hybf4","react-icons/fa":"lut99","../hooks/useTheme":"kxvkQ","../store":"eveyc","./Modal":"9rT1D","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4u0JL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _reactFileDrop = require("react-file-drop");
var _fa = require("react-icons/fa");
var _useTheme = require("../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _lib = require("../lib");
let _ = (t)=>t, t, t1, t2, t3;
const UploadAudioWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .drop-zone-wrapper {
    width: 80%;
    height: 80%;
  }

  .drop-zone {
    height: 100%;
    width: 100%;
    border-style: dashed;
    border-width: 2px;
    border-color: ${0};
    opacity: 0.5;
    cursor: pointer;
  }

  .drop-zone:hover,
  .drop-zone-drag-over {
    opacity: 1;
  }
`), ({ theme })=>theme.colors.highlight2);
const DropZoneInner = (0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`));
const FileUploadIcon = (0, _styledDefault.default)((0, _fa.FaFileUpload))(t2 || (t2 = _`
  width: 100%;
  height: 8rem;
`));
const FileUploadMessage = (0, _styledDefault.default).div(t3 || (t3 = _`
  font-size: 2rem;
`));
const UploadAudio = ({ isOpen, closeMenu })=>{
    const theme = (0, _useThemeDefault.default)();
    const setGraph = (0, _storeDefault.default)(({ setGraph })=>setGraph);
    const setEditorState = (0, _storeDefault.default)((store)=>store.setEditorState);
    const addFile = (0, _storeDefault.default)((store)=>store.addFile);
    const fileInputRef = (0, _react.useRef)(null);
    const uploadFile = (0, _react.useCallback)(async (files)=>{
        const [file] = files || [];
        const base64 = await (0, _lib.fileToBase64)(file);
        addFile({
            type: "audio",
            // @TODO: use nanoid here
            id: `audio-file-${+new Date()}`,
            name: file.name,
            file: base64
        });
        closeMenu();
    }, [
        addFile,
        closeMenu
    ]);
    const onTargetClick = ()=>{
        var _fileInputRef_current;
        (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
    };
    return isOpen ? (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        onClose: closeMenu,
        children: (0, _jsxRuntime.jsxs)(UploadAudioWrapper, {
            theme: theme,
            children: [
                (0, _jsxRuntime.jsx)("input", {
                    onChange: ({ target: { files } })=>uploadFile(files),
                    ref: fileInputRef,
                    type: "file",
                    className: "hidden",
                    style: {
                        display: "none"
                    },
                    accept: ".wav,.mp3,.ogg"
                }),
                (0, _jsxRuntime.jsx)((0, _reactFileDrop.FileDrop), {
                    className: "drop-zone-wrapper",
                    targetClassName: "drop-zone",
                    draggingOverTargetClassName: "drop-zone-drag-over",
                    onTargetClick: onTargetClick,
                    onDrop: (files)=>uploadFile(files),
                    children: (0, _jsxRuntime.jsxs)(DropZoneInner, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)(FileUploadIcon, {}),
                            (0, _jsxRuntime.jsx)(FileUploadMessage, {
                                children: "click or drop file here"
                            })
                        ]
                    })
                })
            ]
        })
    }) : null;
};
exports.default = UploadAudio;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","react-file-drop":"hybf4","react-icons/fa":"lut99","../hooks/useTheme":"kxvkQ","../store":"eveyc","./Modal":"9rT1D","../lib":"j33ba","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j33ba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useWorker", ()=>(0, _useWorkerDefault.default));
parcelHelpers.export(exports, "useMessageChannel", ()=>(0, _useMessageChannelDefault.default));
var _useWorker = require("./hooks/useWorker");
var _useWorkerDefault = parcelHelpers.interopDefault(_useWorker);
var _useMessageChannel = require("./hooks/useMessageChannel");
var _useMessageChannelDefault = parcelHelpers.interopDefault(_useMessageChannel);
var _helpers = require("./helpers");
parcelHelpers.exportAll(_helpers, exports);

},{"./hooks/useWorker":"djeQv","./hooks/useMessageChannel":"235Ph","./helpers":"f4CVE","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"djeQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useWorker = (url)=>{
    const [worker, setWorker] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        const newWorker = new Worker(url);
        setWorker(newWorker);
        return ()=>{
            newWorker === null || newWorker === void 0 ? void 0 : newWorker.terminate();
            setWorker(null);
        };
    }, []);
    return worker;
};
exports.default = useWorker;

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"235Ph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const useMessageChannel = ()=>{
    const [channel, setChannel] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        const newChannel = new MessageChannel();
        newChannel.port2.start();
        setChannel(newChannel);
        return ()=>{
            setChannel(null);
            newChannel.port2.close();
        };
    }, []);
    return channel;
};
exports.default = useMessageChannel;

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f4CVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setParameterValue", ()=>setParameterValue);
parcelHelpers.export(exports, "fileToBase64", ()=>fileToBase64);
const setParameterValue = (param, value, audioContext)=>{
    if (typeof value === "undefined") return;
    param.setValueAtTime(value, audioContext.currentTime);
};
const fileToBase64 = (file)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>{
            var _reader_result;
            return resolve(((_reader_result = reader.result) === null || _reader_result === void 0 ? void 0 : _reader_result.toString()) || "");
        };
        reader.onerror = (error)=>reject(error);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2DY4o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MENU_ID", ()=>MENU_ID);
parcelHelpers.export(exports, "useNodeContextMenu", ()=>useNodeContextMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactContexify = require("react-contexify");
var _reactContexifyCss = require("react-contexify/dist/ReactContexify.css");
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _styles = require("./styles");
const MENU_ID = "editor-node-menu";
const useNodeContextMenu = ()=>{
    const { show } = (0, _reactContexify.useContextMenu)({
        id: MENU_ID
    });
    const onContextMenu = (0, _react.useCallback)((event, node)=>{
        event.stopPropagation();
        show(event, {
            props: {
                node
            }
        });
    }, []);
    return {
        onContextMenu
    };
};
const NodeContextMenu = (args)=>{
    const theme = (0, _useThemeDefault.default)();
    const removeNodes = (0, _storeDefault.default)((store)=>store.removeNodes);
    const addNodeToControlPanel = (0, _storeDefault.default)((store)=>store.addNodeToControlPanel);
    const removeNodeFromControlPanel = (0, _storeDefault.default)((store)=>store.removeNodeFromControlPanel);
    const copy = (0, _storeDefault.default)((store)=>store.copy);
    const nodesConfiguration = (0, _storeDefault.default)((store)=>store.nodesConfiguration);
    const controlPanelNodes = (0, _storeDefault.default)((store)=>store.controlPanel.nodes);
    const isOnControlPanel = (0, _react.useCallback)(({ props })=>{
        if (!(props === null || props === void 0 ? void 0 : props.node.type)) return false;
        return !!controlPanelNodes.find(({ id })=>id === props.node.id);
    }, [
        controlPanelNodes
    ]);
    const hasControlPanelNode = (0, _react.useCallback)(({ props })=>{
        if (!(props === null || props === void 0 ? void 0 : props.node.type)) return false;
        const nodeConfiguration = nodesConfiguration[props.node.type];
        return !!(nodeConfiguration === null || nodeConfiguration === void 0 ? void 0 : nodeConfiguration.controlPanelNode);
    }, [
        nodesConfiguration
    ]);
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _jsxRuntime.jsxs)((0, _styles.MenuWrapper), {
            id: MENU_ID,
            animation: false,
            colors: theme.colors,
            children: [
                (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                    onClick: (event)=>removeNodes([
                            event.props.node
                        ]),
                    children: "Delete Node (DEL)"
                }),
                (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                    hidden: (...args)=>!hasControlPanelNode(...args) || isOnControlPanel(...args),
                    onClick: (event)=>addNodeToControlPanel(event.props.node),
                    children: "Add To Control Panel"
                }),
                (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                    hidden: (...args)=>!hasControlPanelNode(...args) || !isOnControlPanel(...args),
                    onClick: (event)=>removeNodeFromControlPanel(event.props.node),
                    children: "Remove From Control Panel"
                }),
                (0, _jsxRuntime.jsx)((0, _styles.ItemWrapper), {
                    onClick: (event)=>copy({
                            nodes: [
                                event.props.node
                            ],
                            edges: []
                        }),
                    children: "Copy (\u2318+c)"
                })
            ]
        })
    });
};
exports.default = NodeContextMenu;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","react-contexify":"cYVur","react-contexify/dist/ReactContexify.css":"3Ta3m","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","./styles":"ifkCY","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3Ta3m":[function() {},{}],"jZAKX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _reResizable = require("re-resizable");
var _react = require("react");
var _reactGridLayout = require("react-grid-layout");
var _reactGridLayoutDefault = parcelHelpers.interopDefault(_reactGridLayout);
var _stylesCss = require("react-grid-layout/css/styles.css");
var _ai = require("react-icons/ai");
var _md = require("react-icons/md");
var _rx = require("react-icons/rx");
var _reactModernDrawer = require("react-modern-drawer");
var _reactModernDrawerDefault = parcelHelpers.interopDefault(_reactModernDrawer);
var _indexCss = require("react-modern-drawer/dist/index.css");
var _constants = require("../../constants");
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _controlPanelItem = require("./ControlPanelItem");
var _controlPanelItemDefault = parcelHelpers.interopDefault(_controlPanelItem);
var _styles = require("./styles");
let _ = (t)=>t, t, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10;
const ControlPanelIconWrapper = (0, _styledDefault.default).div(t || (t = _`
  position: fixed;
  z-index: 5;
  box-shadow: 0px 1px 2px ${0};
  left: 1rem;
  top: 4rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${0};
  color: ${0};

  :hover {
    color: ${0};
    cursor: pointer;
  }
`), ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.elevation1, ({ theme })=>theme.colors.highlight1, ({ theme })=>theme.colors.highlight2);
const ControlPanelIconsBar = (0, _styledDefault.default)((0, _styles.IconsBar))(t1 || (t1 = _`
  height: 80%;
`));
const CloseIconWrapper = (0, _styledDefault.default)((0, _styles.IconWrapper))(t2 || (t2 = _`
  font-size: 1rem;
  display: flex;
  align-items: center;
`));
const ControlPanelHeader = (0, _styledDefault.default)((0, _styles.TitleBarWrapper))(t3 || (t3 = _`
  grid-template-columns: 1fr auto;
  border-bottom: 1px solid ${0};
  font-size: 0.7rem;
`), ({ theme })=>theme.colors.elevation3);
const ControlPanelTitle = (0, _styledDefault.default)((0, _styles.PanelTitle))(t4 || (t4 = _`
  text-align: center;
`));
const ControlPanelWrapper = (0, _styledDefault.default).div(t5 || (t5 = _`
  height: 100%;
  width: 100%;
  padding: 0.3rem 0.4rem;
  box-sizing: border-box;
`));
const ControlPanelBody = (0, _styledDefault.default).div(t6 || (t6 = _`
  height: auto;
  padding: 0;
  max-height: 95vh;
  overflow-y: scroll;
  border: 1px solid ${0};
`), ({ theme })=>theme.colors.elevation3);
const ControlPanelSettings = (0, _styledDefault.default).div(t7 || (t7 = _`
  padding: 1rem 0;
  font-family: var(--leva-fonts-mono);
  font-size: 0.8rem;
`));
const LockGridWrapper = (0, _styledDefault.default).div(t8 || (t8 = _`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: ${0};
  &:hover {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight1, ({ theme })=>theme.colors.highlight2);
const GridResizeHandle = (0, _styledDefault.default).div(t9 || (t9 = _`
  position: absolute;
  height: 1rem;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 0.5rem;
  border-right: 1px solid ${0};
`), ({ theme })=>theme.colors.whitePrimary);
const ControlPanelItemWrapper = (0, _styledDefault.default).div(t10 || (t10 = _`
  box-sizing: border-box;
  overflow: hidden;
  .react-resizable-handle:after {
    border-color: ${0};
    border-width: 1px;
  }
`), ({ theme })=>theme.colors.whitePrimary);
const ControlPanel = ()=>{
    const theme = (0, _useThemeDefault.default)();
    const nodeRef = (0, _react.useRef)(null);
    const nodes = (0, _storeDefault.default)((store)=>store.nodes);
    const { show, nodes: controlPanelNodes, size } = (0, _storeDefault.default)((store)=>store.controlPanel);
    const { width = 200, height } = size;
    const filteredNodes = (0, _react.useMemo)(()=>{
        const nodeIds = controlPanelNodes.map(({ id })=>id);
        return nodes.filter(({ id })=>nodeIds.includes(id));
    }, [
        nodes,
        controlPanelNodes
    ]);
    const showControlPanel = (0, _storeDefault.default)((store)=>store.showControlPanel);
    const hideControlPanel = (0, _storeDefault.default)((store)=>store.hideControlPanel);
    const setControlPanelNodes = (0, _storeDefault.default)((store)=>store.setControlPanelNodes);
    const setControlPanelSize = (0, _storeDefault.default)((store)=>store.setControlPanelSize);
    const removeNodeFromControlPanel = (0, _storeDefault.default)((store)=>store.removeNodeFromControlPanel);
    const [isGridLocked, setGridLocked] = (0, _react.useState)(true);
    const layout = (0, _react.useMemo)(()=>{
        const fallbackY = controlPanelNodes.reduce((acc, { height = (0, _constants.CONTROL_PANEL_GRID_CONFIG).rowHeight, x, y = 0 })=>{
            const Y = y + height;
            return Y > acc ? Y : acc;
        }, 0);
        return controlPanelNodes.map(({ id: i, width, height, x, y })=>{
            return {
                i,
                w: width || (0, _constants.CONTROL_PANEL_GRID_CONFIG).cols,
                h: height || 6,
                x: x !== null && x !== void 0 ? x : 0,
                y: y !== null && y !== void 0 ? y : fallbackY
            };
        });
    }, [
        controlPanelNodes
    ]);
    if (!filteredNodes.length) return null;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)(ControlPanelIconWrapper, {
                theme: theme,
                ref: nodeRef,
                onClick: showControlPanel,
                children: (0, _jsxRuntime.jsx)((0, _rx.RxDashboard), {})
            }),
            (0, _jsxRuntime.jsxs)((0, _reactModernDrawerDefault.default), {
                open: show,
                onClose: hideControlPanel,
                direction: "left",
                className: "",
                size: "auto",
                enableOverlay: false,
                style: {
                    background: theme.colors.elevation1,
                    position: "absolute"
                },
                children: [
                    (0, _jsxRuntime.jsxs)(ControlPanelHeader, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)(ControlPanelTitle, {
                                children: "Control Panel"
                            }),
                            (0, _jsxRuntime.jsx)(ControlPanelIconsBar, {
                                children: (0, _jsxRuntime.jsx)(CloseIconWrapper, {
                                    onClick: hideControlPanel,
                                    theme: theme,
                                    children: (0, _jsxRuntime.jsx)((0, _md.MdClose), {})
                                })
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)(ControlPanelWrapper, {
                        children: [
                            (0, _jsxRuntime.jsx)(ControlPanelSettings, {
                                children: isGridLocked ? (0, _jsxRuntime.jsxs)(LockGridWrapper, {
                                    theme: theme,
                                    onClick: ()=>setGridLocked(false),
                                    children: [
                                        (0, _jsxRuntime.jsx)((0, _ai.AiFillLock), {}),
                                        "Unlock grid"
                                    ]
                                }) : (0, _jsxRuntime.jsxs)(LockGridWrapper, {
                                    theme: theme,
                                    onClick: ()=>setGridLocked(true),
                                    children: [
                                        (0, _jsxRuntime.jsx)((0, _ai.AiFillUnlock), {}),
                                        "Lock grid"
                                    ]
                                })
                            }),
                            (0, _jsxRuntime.jsx)((0, _reResizable.Resizable), {
                                enable: {
                                    top: false,
                                    right: !isGridLocked,
                                    bottom: false,
                                    left: false,
                                    topRight: false,
                                    bottomRight: false,
                                    bottomLeft: false,
                                    topLeft: false
                                },
                                handleComponent: {
                                    right: (0, _jsxRuntime.jsx)(GridResizeHandle, {
                                        theme: theme
                                    })
                                },
                                minWidth: 120,
                                size: {
                                    width,
                                    height: "auto"
                                },
                                onResizeStop: (e, direction, ref, d)=>{
                                    setControlPanelSize({
                                        width: width + d.width,
                                        height: height + d.height
                                    });
                                },
                                children: (0, _jsxRuntime.jsx)(ControlPanelBody, {
                                    theme: theme,
                                    children: (0, _jsxRuntime.jsx)((0, _reactGridLayoutDefault.default), {
                                        layout: layout,
                                        className: "layout",
                                        cols: (0, _constants.CONTROL_PANEL_GRID_CONFIG).cols,
                                        rowHeight: (0, _constants.CONTROL_PANEL_GRID_CONFIG).rowHeight,
                                        width: width,
                                        margin: [
                                            0,
                                            0
                                        ],
                                        isResizable: !isGridLocked,
                                        draggableHandle: ".grid-item-handle",
                                        onLayoutChange: (nodes)=>{
                                            requestAnimationFrame(()=>{
                                                setControlPanelNodes(nodes.map(({ i, w, h, x, y })=>({
                                                        id: i,
                                                        width: w,
                                                        height: h,
                                                        x,
                                                        y
                                                    })));
                                            });
                                        },
                                        children: filteredNodes.map((node)=>{
                                            return (0, _jsxRuntime.jsx)(ControlPanelItemWrapper, {
                                                theme: theme,
                                                children: (0, _jsxRuntime.jsx)((0, _controlPanelItemDefault.default), {
                                                    node: node,
                                                    showControls: !isGridLocked,
                                                    onDelete: removeNodeFromControlPanel
                                                })
                                            }, node.id);
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = ControlPanel;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","re-resizable":"7k9Hb","react":"lXMxO","react-grid-layout":"5Kdnk","react-grid-layout/css/styles.css":"coJMT","react-icons/ai":"dcPAU","react-icons/md":"ixP1W","react-icons/rx":"dImxq","react-modern-drawer":"1XNhU","react-modern-drawer/dist/index.css":"4HHR2","../../constants":"k5UCO","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","./ControlPanelItem":"iBYyK","./styles":"bZthZ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7k9Hb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resizable", ()=>Resizable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDom = require("react-dom");
var _resizer = require("./resizer");
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var clamp = function(n, min, max) {
    return Math.max(Math.min(n, max), min);
};
var snap = function(n, size, gridGap) {
    var v = Math.round(n / size);
    return v * size + gridGap * (v - 1);
};
var hasDirection = function(dir, target) {
    return new RegExp(dir, 'i').test(target);
};
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var isTouchEvent = function(event) {
    return Boolean(event.touches && event.touches.length);
};
var isMouseEvent = function(event) {
    return Boolean((event.clientX || event.clientX === 0) && (event.clientY || event.clientY === 0));
};
var findClosestSnap = function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
};
var getStringSize = function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if (n.endsWith('px')) return n;
    if (n.endsWith('%')) return n;
    if (n.endsWith('vh')) return n;
    if (n.endsWith('vw')) return n;
    if (n.endsWith('vmax')) return n;
    if (n.endsWith('vmin')) return n;
    return "".concat(n, "px");
};
var getPixelSize = function(size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === 'string') {
        if (size.endsWith('px')) return Number(size.replace('px', ''));
        if (size.endsWith('%')) {
            var ratio = Number(size.replace('%', '')) / 100;
            return parentSize * ratio;
        }
        if (size.endsWith('vw')) {
            var ratio = Number(size.replace('vw', '')) / 100;
            return innerWidth * ratio;
        }
        if (size.endsWith('vh')) {
            var ratio = Number(size.replace('vh', '')) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var calculateNewMax = function(parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
};
/**
 * transform T | [T, T] to [T, T]
 * @param val
 * @returns
 */ // tslint:disable-next-line
var normalizeToPair = function(val) {
    return Array.isArray(val) ? val : [
        val,
        val
    ];
};
var definedProps = [
    'as',
    'ref',
    'style',
    'className',
    'grid',
    'gridGap',
    'snap',
    'bounds',
    'boundsByDirection',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var baseClassName = '__resizable_base__';
var Resizable = /** @class */ function(_super) {
    __extends(Resizable, _super);
    function Resizable(props) {
        var _a, _b, _c, _d;
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.delta = {
            width: 0,
            height: 0
        };
        _this.appendBase = function() {
            if (!_this.resizable || !_this.window) return null;
            var parent = _this.parentNode;
            if (!parent) return null;
            var element = _this.window.document.createElement('div');
            element.style.width = '100%';
            element.style.height = '100%';
            element.style.position = 'absolute';
            element.style.transform = 'scale(0, 0)';
            element.style.left = '0';
            element.style.flex = '0 0 100%';
            if (element.classList) element.classList.add(baseClassName);
            else element.className += baseClassName;
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function(base) {
            var parent = _this.parentNode;
            if (!parent) return;
            parent.removeChild(base);
        };
        _this.state = {
            isResizing: false,
            width: (_b = (_a = _this.propsSize) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 'auto',
            height: (_d = (_c = _this.propsSize) === null || _c === void 0 ? void 0 : _c.height) !== null && _d !== void 0 ? _d : 'auto',
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            backgroundStyle: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: 'auto',
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            },
            flexBasis: undefined
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function() {
            if (!this.resizable) return null;
            if (!this.resizable.ownerDocument) return null;
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                var _a;
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && ((_a = _this.propsSize[key]) === null || _a === void 0 ? void 0 : _a.toString().endsWith('%'))) {
                    if (_this.state[key].toString().endsWith('%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return "".concat(percent, "%");
                }
                return getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.parentNode) {
            if (!this.window) return {
                width: 0,
                height: 0
            };
            return {
                width: this.window.innerWidth,
                height: this.window.innerHeight
            };
        }
        var base = this.appendBase();
        if (!base) return {
            width: 0,
            height: 0
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        base.style.position = 'relative';
        base.style.minWidth = '100%';
        base.style.minHeight = '100%';
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight
        };
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function() {
        if (this.window) {
            this.window.addEventListener('mouseup', this.onMouseUp);
            this.window.addEventListener('mousemove', this.onMouseMove);
            this.window.addEventListener('mouseleave', this.onMouseUp);
            this.window.addEventListener('touchmove', this.onMouseMove, {
                capture: true,
                passive: false
            });
            this.window.addEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function() {
        if (this.window) {
            this.window.removeEventListener('mouseup', this.onMouseUp);
            this.window.removeEventListener('mousemove', this.onMouseMove);
            this.window.removeEventListener('mouseleave', this.onMouseUp);
            this.window.removeEventListener('touchmove', this.onMouseMove, true);
            this.window.removeEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function() {
        if (!this.resizable || !this.window) return;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined
        });
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (this.window) this.unbindEvents();
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && hasDirection('left', direction);
        var heightByDirection = boundsByDirection && hasDirection('top', direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === 'parent') {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection ? this.resizableRight - this.parentLeft : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection ? this.resizableBottom - this.parentTop : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        } else if (this.props.bounds === 'window') {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        } else if (this.props.bounds) {
            boundWidth = widthByDirection ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        if (boundHeight && Number.isFinite(boundHeight)) maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var _a = normalizeToPair(this.props.resizeRatio || 1), resizeRatioX = _a[0], resizeRatioY = _a[1];
        var _b = this.state, direction = _b.direction, original = _b.original;
        var _c = this.props, lockAspectRatio = _c.lockAspectRatio, lockAspectRatioExtraHeight = _c.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _c.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatioX / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if (hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatioX / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if (hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatioY / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if (hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatioY / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        var adjustedScale = 1 / (this.props.scale || 1);
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left * adjustedScale;
                this.parentTop = parentRect.top * adjustedScale;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== 'string') {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left * adjustedScale;
            this.targetTop = targetRect.top * adjustedScale;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left * adjustedScale;
            this.resizableRight = right * adjustedScale;
            this.resizableTop = top_1 * adjustedScale;
            this.resizableBottom = bottom * adjustedScale;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        if (!this.resizable || !this.window) return;
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        } else if (event.nativeEvent && isTouchEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== 'auto') {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith('row') ? 'row' : 'column';
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), {
                cursor: this.window.getComputedStyle(event.target).cursor || 'auto'
            }),
            direction: direction,
            flexBasis: flexBasis
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function(event) {
        var _this = this;
        if (!this.state.isResizing || !this.resizable || !this.window) return;
        if (this.window.TouchEvent && isTouchEvent(event)) try {
            event.preventDefault();
            event.stopPropagation();
        } catch (e) {
        // Ignore on fail
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = isTouchEvent(event) ? event.touches[0].clientX : event.clientX;
        var clientY = isTouchEvent(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        if (this.props.snap && this.props.snap.x) newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = snap(newWidth, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0);
            var newGridHeight = snap(newHeight, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0);
            var gap = this.props.snapGap || 0;
            var w = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            var h = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
            newWidth = w;
            newHeight = h;
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        this.delta = delta;
        if (width && typeof width === 'string') {
            if (width.endsWith('%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = "".concat(percent, "%");
            } else if (width.endsWith('vw')) {
                var vw = newWidth / this.window.innerWidth * 100;
                newWidth = "".concat(vw, "vw");
            } else if (width.endsWith('vh')) {
                var vh = newWidth / this.window.innerHeight * 100;
                newWidth = "".concat(vh, "vh");
            }
        }
        if (height && typeof height === 'string') {
            if (height.endsWith('%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = "".concat(percent, "%");
            } else if (height.endsWith('vw')) {
                var vw = newHeight / this.window.innerWidth * 100;
                newHeight = "".concat(vw, "vw");
            } else if (height.endsWith('vh')) {
                var vh = newHeight / this.window.innerHeight * 100;
                newHeight = "".concat(vh, "vh");
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        };
        if (this.flexDir === 'row') newState.flexBasis = newState.width;
        else if (this.flexDir === 'column') newState.flexBasis = newState.height;
        var widthChanged = this.state.width !== newState.width;
        var heightChanged = this.state.height !== newState.height;
        var flexBaseChanged = this.state.flexBasis !== newState.flexBasis;
        var changed = widthChanged || heightChanged || flexBaseChanged;
        if (changed) // For v18, update state sync
        (0, _reactDom.flushSync)(function() {
            _this.setState(newState);
        });
        if (this.props.onResize) {
            if (changed) this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a, _b;
        var _c = this.state, isResizing = _c.isResizing, direction = _c.direction, original = _c.original;
        if (!isResizing || !this.resizable) return;
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, this.delta);
        if (this.props.size) this.setState({
            width: (_a = this.props.size.width) !== null && _a !== void 0 ? _a : 'auto',
            height: (_b = this.props.size.height) !== null && _b !== void 0 ? _b : 'auto'
        });
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), {
                cursor: 'auto'
            })
        });
    };
    Resizable.prototype.updateSize = function(size) {
        var _a, _b;
        this.setState({
            width: (_a = size.width) !== null && _a !== void 0 ? _a : 'auto',
            height: (_b = size.height) !== null && _b !== void 0 ? _b : 'auto'
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return (0, _jsxRuntime.jsx)((0, _resizer.Resizer), {
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir],
                children: handleComponent && handleComponent[dir] ? handleComponent[dir] : null
            }, dir);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return (0, _jsxRuntime.jsx)("div", {
            className: handleWrapperClass,
            style: handleWrapperStyle,
            children: resizers
        });
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if (definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = __assign(__assign(__assign({
            position: 'relative',
            userSelect: this.state.isResizing ? 'none' : 'auto'
        }, this.props.style), this.sizeStyle), {
            maxWidth: this.props.maxWidth,
            maxHeight: this.props.maxHeight,
            minWidth: this.props.minWidth,
            minHeight: this.props.minHeight,
            boxSizing: 'border-box',
            flexShrink: 0
        });
        if (this.state.flexBasis) style.flexBasis = this.state.flexBasis;
        var Wrapper = this.props.as || 'div';
        return (0, _jsxRuntime.jsxs)(Wrapper, __assign({
            style: style,
            className: this.props.className
        }, extendsProps, {
            // `ref` is after `extendsProps` to ensure this one wins over a version
            // passed in
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            children: [
                this.state.isResizing && (0, _jsxRuntime.jsx)("div", {
                    style: this.state.backgroundStyle
                }),
                this.props.children,
                this.renderResizer()
            ]
        }));
    };
    Resizable.defaultProps = {
        as: 'div',
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        gridGap: [
            0,
            0
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}((0, _react.PureComponent));

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","react-dom":"dgecT","./resizer":"5p01D","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5p01D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Resizer", ()=>Resizer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var rowSizeBase = {
    width: '100%',
    height: '10px',
    top: '0px',
    left: '0px',
    cursor: 'row-resize'
};
var colSizeBase = {
    width: '10px',
    height: '100%',
    top: '0px',
    left: '0px',
    cursor: 'col-resize'
};
var edgeBase = {
    width: '20px',
    height: '20px',
    position: 'absolute',
    zIndex: 1
};
var styles = {
    top: __assign(__assign({}, rowSizeBase), {
        top: '-5px'
    }),
    right: __assign(__assign({}, colSizeBase), {
        left: undefined,
        right: '-5px'
    }),
    bottom: __assign(__assign({}, rowSizeBase), {
        top: undefined,
        bottom: '-5px'
    }),
    left: __assign(__assign({}, colSizeBase), {
        left: '-5px'
    }),
    topRight: __assign(__assign({}, edgeBase), {
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    }),
    bottomRight: __assign(__assign({}, edgeBase), {
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    }),
    bottomLeft: __assign(__assign({}, edgeBase), {
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    }),
    topLeft: __assign(__assign({}, edgeBase), {
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    })
};
var Resizer = (0, _react.memo)(function(props) {
    var onResizeStart = props.onResizeStart, direction = props.direction, children = props.children, replaceStyles = props.replaceStyles, className = props.className;
    var onMouseDown = (0, _react.useCallback)(function(e) {
        onResizeStart(e, direction);
    }, [
        onResizeStart,
        direction
    ]);
    var onTouchStart = (0, _react.useCallback)(function(e) {
        onResizeStart(e, direction);
    }, [
        onResizeStart,
        direction
    ]);
    var style = (0, _react.useMemo)(function() {
        return __assign(__assign({
            position: 'absolute',
            userSelect: 'none'
        }, styles[direction]), replaceStyles !== null && replaceStyles !== void 0 ? replaceStyles : {});
    }, [
        replaceStyles,
        direction
    ]);
    return (0, _jsxRuntime.jsx)("div", {
        className: className || undefined,
        style: style,
        onMouseDown: onMouseDown,
        onTouchStart: onTouchStart,
        children: children
    });
});

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5Kdnk":[function(require,module,exports,__globalThis) {
module.exports = require("6f263ff4f450f748").default;
module.exports.utils = require("e6314e18256c1382");
module.exports.calculateUtils = require("50180d2ecfb2f7b1");
module.exports.Responsive = require("c42febc4fc3c99e2").default;
module.exports.Responsive.utils = require("9dd34df1a5567ffa");
module.exports.WidthProvider = require("9eb2c2318bc2e9e2").default;

},{"6f263ff4f450f748":"i3q1Z","e6314e18256c1382":"bIMEY","50180d2ecfb2f7b1":"aorXe","c42febc4fc3c99e2":"8Tx1h","9dd34df1a5567ffa":"5yHOz","9eb2c2318bc2e9e2":"keTKy"}],"i3q1Z":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("409273444d54d2e6"));
var _fastEquals = require("4eb1319583de9d22");
var _clsx = _interopRequireDefault(require("4773afa329a201de"));
var _utils = require("b76a978504eb07e");
var _calculateUtils = require("febfe73b7c2bfcfb");
var _GridItem = _interopRequireDefault(require("6250ac3f7be359ba"));
var _ReactGridLayoutPropTypes = _interopRequireDefault(require("fb2346cfe785b8c2"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  CompactType,
  GridResizeEvent,
  GridDragEvent,
  DragOverEvent,
  Layout,
  DroppingPosition,
  LayoutItem
} from "./utils";*/ // Types
/*:: import type { PositionParams } from "./calculateUtils";*/ /*:: type State = {
  activeDrag: ?LayoutItem,
  layout: Layout,
  mounted: boolean,
  oldDragItem: ?LayoutItem,
  oldLayout: ?Layout,
  oldResizeItem: ?LayoutItem,
  resizing: boolean,
  droppingDOMNode: ?ReactElement<any>,
  droppingPosition?: DroppingPosition,
  // Mirrored props
  children: ReactChildrenArray<ReactElement<any>>,
  compactType?: CompactType,
  propsLayout?: Layout
};*/ /*:: import type { Props, DefaultProps } from "./ReactGridLayoutPropTypes";*/ // End Types
const layoutClassName = "react-grid-layout";
let isFirefox = false;
// Try...catch will protect from navigator not existing (e.g. node) or a bad implementation of navigator
try {
    isFirefox = /firefox/i.test(navigator.userAgent);
} catch (e) {
/* Ignore */ }
/**
 * A reactive, fluid grid layout with draggable, resizable components.
 */ class ReactGridLayout extends React.Component /*:: <Props, State>*/  {
    componentDidMount() {
        this.setState({
            mounted: true
        });
        // Possibly call back with layout on mount. This should be done after correcting the layout width
        // to ensure we don't rerender with the wrong width.
        this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State> | null*/ {
        let newLayoutBase;
        if (prevState.activeDrag) return null;
        // Legacy support for compactType
        // Allow parent to set layout directly.
        if (!(0, _fastEquals.deepEqual)(nextProps.layout, prevState.propsLayout) || nextProps.compactType !== prevState.compactType) newLayoutBase = nextProps.layout;
        else if (!(0, _utils.childrenEqual)(nextProps.children, prevState.children)) // If children change, also regenerate the layout. Use our state
        // as the base in case because it may be more up to date than
        // what is in props.
        newLayoutBase = prevState.layout;
        // We need to regenerate the layout.
        if (newLayoutBase) {
            const newLayout = (0, _utils.synchronizeLayoutWithChildren)(newLayoutBase, nextProps.children, nextProps.cols, (0, _utils.compactType)(nextProps), nextProps.allowOverlap);
            return {
                layout: newLayout,
                // We need to save these props to state for using
                // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
                compactType: nextProps.compactType,
                children: nextProps.children,
                propsLayout: nextProps.layout
            };
        }
        return null;
    }
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        return(// NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== nextProps.children || !(0, _utils.fastRGLPropsEqual)(this.props, nextProps, _fastEquals.deepEqual) || this.state.activeDrag !== nextState.activeDrag || this.state.mounted !== nextState.mounted || this.state.droppingPosition !== nextState.droppingPosition);
    }
    componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
        if (!this.state.activeDrag) {
            const newLayout = this.state.layout;
            const oldLayout = prevState.layout;
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        }
    }
    /**
   * Calculates a pixel value for the container.
   * @return {String} Container height in pixels.
   */ containerHeight() /*: ?string*/ {
        if (!this.props.autoSize) return;
        const nbRow = (0, _utils.bottom)(this.state.layout);
        const containerPaddingY = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
        return nbRow * this.props.rowHeight + (nbRow - 1) * this.props.margin[1] + containerPaddingY * 2 + "px";
    }
    onLayoutMaybeChanged(newLayout /*: Layout*/ , oldLayout /*: ?Layout*/ ) {
        if (!oldLayout) oldLayout = this.state.layout;
        if (!(0, _fastEquals.deepEqual)(oldLayout, newLayout)) this.props.onLayoutChange(newLayout);
    }
    /**
   * Create a placeholder object.
   * @return {Element} Placeholder div.
   */ placeholder() /*: ?ReactElement<any>*/ {
        const { activeDrag } = this.state;
        if (!activeDrag) return null;
        const { width, cols, margin, containerPadding, rowHeight, maxRows, useCSSTransforms, transformScale } = this.props;
        // {...this.state.activeDrag} is pretty slow, actually
        return /*#__PURE__*/ React.createElement(_GridItem.default, {
            w: activeDrag.w,
            h: activeDrag.h,
            x: activeDrag.x,
            y: activeDrag.y,
            i: activeDrag.i,
            className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            isDraggable: false,
            isResizable: false,
            isBounded: false,
            useCSSTransforms: useCSSTransforms,
            transformScale: transformScale
        }, /*#__PURE__*/ React.createElement("div", null));
    }
    /**
   * Given a grid item, set its style attributes & surround in a <Draggable>.
   * @param  {Element} child React element.
   * @return {Element}       Element wrapped in draggable and properly placed.
   */ processGridItem(child /*: ReactElement<any>*/ , isDroppingItem /*: boolean*/ ) /*: ?ReactElement<any>*/ {
        if (!child || !child.key) return;
        const l = (0, _utils.getLayoutItem)(this.state.layout, String(child.key));
        if (!l) return null;
        const { width, cols, margin, containerPadding, rowHeight, maxRows, isDraggable, isResizable, isBounded, useCSSTransforms, transformScale, draggableCancel, draggableHandle, resizeHandles, resizeHandle } = this.props;
        const { mounted, droppingPosition } = this.state;
        // Determine user manipulations possible.
        // If an item is static, it can't be manipulated by default.
        // Any properties defined directly on the grid item will take precedence.
        const draggable = typeof l.isDraggable === "boolean" ? l.isDraggable : !l.static && isDraggable;
        const resizable = typeof l.isResizable === "boolean" ? l.isResizable : !l.static && isResizable;
        const resizeHandlesOptions = l.resizeHandles || resizeHandles;
        // isBounded set on child if set on parent, and child is not explicitly false
        const bounded = draggable && isBounded && l.isBounded !== false;
        return /*#__PURE__*/ React.createElement(_GridItem.default, {
            containerWidth: width,
            cols: cols,
            margin: margin,
            containerPadding: containerPadding || margin,
            maxRows: maxRows,
            rowHeight: rowHeight,
            cancel: draggableCancel,
            handle: draggableHandle,
            onDragStop: this.onDragStop,
            onDragStart: this.onDragStart,
            onDrag: this.onDrag,
            onResizeStart: this.onResizeStart,
            onResize: this.onResize,
            onResizeStop: this.onResizeStop,
            isDraggable: draggable,
            isResizable: resizable,
            isBounded: bounded,
            useCSSTransforms: useCSSTransforms && mounted,
            usePercentages: !mounted,
            transformScale: transformScale,
            w: l.w,
            h: l.h,
            x: l.x,
            y: l.y,
            i: l.i,
            minH: l.minH,
            minW: l.minW,
            maxH: l.maxH,
            maxW: l.maxW,
            static: l.static,
            droppingPosition: isDroppingItem ? droppingPosition : undefined,
            resizeHandles: resizeHandlesOptions,
            resizeHandle: resizeHandle
        }, child);
    }
    render() /*: React.Element<"div">*/ {
        const { className, style, isDroppable, innerRef } = this.props;
        const mergedClassName = (0, _clsx.default)(layoutClassName, className);
        const mergedStyle = (0, _objectSpread._)({
            height: this.containerHeight()
        }, style);
        return /*#__PURE__*/ React.createElement("div", {
            ref: innerRef,
            className: mergedClassName,
            style: mergedStyle,
            onDrop: isDroppable ? this.onDrop : _utils.noop,
            onDragLeave: isDroppable ? this.onDragLeave : _utils.noop,
            onDragEnter: isDroppable ? this.onDragEnter : _utils.noop,
            onDragOver: isDroppable ? this.onDragOver : _utils.noop
        }, React.Children.map(this.props.children, (child)=>this.processGridItem(child)), isDroppable && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, true), this.placeholder());
    }
    constructor(){
        super(...arguments);
        _defineProperty(this, "state", {
            activeDrag: null,
            layout: (0, _utils.synchronizeLayoutWithChildren)(this.props.layout, this.props.children, this.props.cols, // Legacy support for verticalCompact: false
            (0, _utils.compactType)(this.props), this.props.allowOverlap),
            mounted: false,
            oldDragItem: null,
            oldLayout: null,
            oldResizeItem: null,
            resizing: false,
            droppingDOMNode: null,
            children: []
        });
        _defineProperty(this, "dragEnterCounter", 0);
        /**
     * When dragging starts
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ _defineProperty(this, "onDragStart", (i /*: string*/ , x /*: number*/ , y /*: number*/ , _ref /*:: */ )=>{
            let { e, node } /*: GridDragEvent*/  = _ref /*: GridDragEvent*/ ;
            const { layout } = this.state;
            const l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            this.setState({
                oldDragItem: (0, _utils.cloneLayoutItem)(l),
                oldLayout: layout,
                activeDrag: placeholder
            });
            return this.props.onDragStart(layout, l, l, null, e, node);
        });
        /**
     * Each drag movement create a new dragelement and move the element to the dragged location
     * @param {String} i Id of the child
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ _defineProperty(this, "onDrag", (i, x, y, _ref2)=>{
            let { e, node } = _ref2;
            const { oldDragItem } = this.state;
            let { layout } = this.state;
            const { cols, allowOverlap, preventCollision } = this.props;
            const l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return;
            // Create placeholder (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                placeholder: true,
                i: i
            };
            // Move the element to the dragged location.
            const isUserAction = true;
            layout = (0, _utils.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, _utils.compactType)(this.props), cols, allowOverlap);
            this.props.onDrag(layout, oldDragItem, l, placeholder, e, node);
            this.setState({
                layout: allowOverlap ? layout : (0, _utils.compact)(layout, (0, _utils.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        /**
     * When dragging stops, figure out which position the element is closest to and update its x and y.
     * @param  {String} i Index of the child.
     * @param {Number} x X position of the move
     * @param {Number} y Y position of the move
     * @param {Event} e The mousedown event
     * @param {Element} node The current dragging DOM element
     */ _defineProperty(this, "onDragStop", (i, x, y, _ref3)=>{
            let { e, node } = _ref3;
            if (!this.state.activeDrag) return;
            const { oldDragItem } = this.state;
            let { layout } = this.state;
            const { cols, preventCollision, allowOverlap } = this.props;
            const l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return;
            // Move the element here
            const isUserAction = true;
            layout = (0, _utils.moveElement)(layout, l, x, y, isUserAction, preventCollision, (0, _utils.compactType)(this.props), cols, allowOverlap);
            // Set state
            const newLayout = allowOverlap ? layout : (0, _utils.compact)(layout, (0, _utils.compactType)(this.props), cols);
            this.props.onDragStop(newLayout, oldDragItem, l, null, e, node);
            const { oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldDragItem: null,
                oldLayout: null
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        _defineProperty(this, "onResizeStart", (i, w, h, _ref4)=>{
            let { e, node } = _ref4;
            const { layout } = this.state;
            const l = (0, _utils.getLayoutItem)(layout, i);
            if (!l) return;
            this.setState({
                oldResizeItem: (0, _utils.cloneLayoutItem)(l),
                oldLayout: this.state.layout,
                resizing: true
            });
            this.props.onResizeStart(layout, l, l, null, e, node);
        });
        _defineProperty(this, "onResize", (i, w, h, _ref5)=>{
            let { e, node, size, handle } = _ref5;
            const { oldResizeItem } = this.state;
            const { layout } = this.state;
            const { cols, preventCollision, allowOverlap } = this.props;
            let shouldMoveItem = false;
            let finalLayout;
            let x;
            let y;
            const [newLayout, l] = (0, _utils.withLayoutItem)(layout, i, (l)=>{
                let hasCollisions;
                x = l.x;
                y = l.y;
                if ([
                    "sw",
                    "w",
                    "nw",
                    "n",
                    "ne"
                ].indexOf(handle) !== -1) {
                    if ([
                        "sw",
                        "nw",
                        "w"
                    ].indexOf(handle) !== -1) {
                        x = l.x + (l.w - w);
                        w = l.x !== x && x < 0 ? l.w : w;
                        x = x < 0 ? 0 : x;
                    }
                    if ([
                        "ne",
                        "n",
                        "nw"
                    ].indexOf(handle) !== -1) {
                        y = l.y + (l.h - h);
                        h = l.y !== y && y < 0 ? l.h : h;
                        y = y < 0 ? 0 : y;
                    }
                    shouldMoveItem = true;
                }
                // Something like quad tree should be used
                // to find collisions faster
                if (preventCollision && !allowOverlap) {
                    const collisions = (0, _utils.getAllCollisions)(layout, (0, _objectSpreadProps._)((0, _objectSpread._)({}, l), {
                        w,
                        h,
                        x,
                        y
                    })).filter((layoutItem)=>layoutItem.i !== l.i);
                    hasCollisions = collisions.length > 0;
                    // If we're colliding, we need adjust the placeholder.
                    if (hasCollisions) {
                        // Reset layoutItem dimensions if there were collisions
                        y = l.y;
                        h = l.h;
                        x = l.x;
                        w = l.w;
                        shouldMoveItem = false;
                    }
                }
                l.w = w;
                l.h = h;
                return l;
            });
            // Shouldn't ever happen, but typechecking makes it necessary
            if (!l) return;
            finalLayout = newLayout;
            if (shouldMoveItem) {
                // Move the element to the new position.
                const isUserAction = true;
                finalLayout = (0, _utils.moveElement)(newLayout, l, x, y, isUserAction, this.props.preventCollision, (0, _utils.compactType)(this.props), cols, allowOverlap);
            }
            // Create placeholder element (display only)
            const placeholder = {
                w: l.w,
                h: l.h,
                x: l.x,
                y: l.y,
                static: true,
                i: i
            };
            this.props.onResize(finalLayout, oldResizeItem, l, placeholder, e, node);
            // Re-compact the newLayout and set the drag placeholder.
            this.setState({
                layout: allowOverlap ? finalLayout : (0, _utils.compact)(finalLayout, (0, _utils.compactType)(this.props), cols),
                activeDrag: placeholder
            });
        });
        _defineProperty(this, "onResizeStop", (i, w, h, _ref6)=>{
            let { e, node } = _ref6;
            const { layout, oldResizeItem } = this.state;
            const { cols, allowOverlap } = this.props;
            const l = (0, _utils.getLayoutItem)(layout, i);
            // Set state
            const newLayout = allowOverlap ? layout : (0, _utils.compact)(layout, (0, _utils.compactType)(this.props), cols);
            this.props.onResizeStop(newLayout, oldResizeItem, l, null, e, node);
            const { oldLayout } = this.state;
            this.setState({
                activeDrag: null,
                layout: newLayout,
                oldResizeItem: null,
                oldLayout: null,
                resizing: false
            });
            this.onLayoutMaybeChanged(newLayout, oldLayout);
        });
        // Called while dragging an element. Part of browser native drag/drop API.
        // Native event target might be the layout itself, or an element within the layout.
        _defineProperty(this, "onDragOver", (e)=>{
            var _e_nativeEvent_target;
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            // we should ignore events from layout's children in Firefox
            // to avoid unpredictable jumping of a dropping placeholder
            // FIXME remove this hack
            if (isFirefox && // $FlowIgnore can't figure this out
            !((_e_nativeEvent_target = e.nativeEvent.target) === null || _e_nativeEvent_target === void 0 ? void 0 : _e_nativeEvent_target.classList.contains(layoutClassName))) return false;
            const { droppingItem, onDropDragOver, margin, cols, rowHeight, maxRows, width, containerPadding, transformScale } = this.props;
            // Allow user to customize the dropping item or short-circuit the drop based on the results
            // of the `onDragOver(e: Event)` callback.
            const onDragOverResult = onDropDragOver === null || onDropDragOver === void 0 ? void 0 : onDropDragOver(e);
            if (onDragOverResult === false) {
                if (this.state.droppingDOMNode) this.removeDroppingPlaceholder();
                return false;
            }
            const finalDroppingItem = (0, _objectSpread._)({}, droppingItem, onDragOverResult);
            const { layout } = this.state;
            // $FlowIgnore missing def
            const gridRect = e.currentTarget.getBoundingClientRect(); // The grid's position in the viewport
            // Calculate the mouse position relative to the grid
            const layerX = e.clientX - gridRect.left;
            const layerY = e.clientY - gridRect.top;
            const droppingPosition = {
                left: layerX / transformScale,
                top: layerY / transformScale,
                e
            };
            if (!this.state.droppingDOMNode) {
                const positionParams /*: PositionParams*/  = {
                    cols,
                    margin,
                    maxRows,
                    rowHeight,
                    containerWidth: width,
                    containerPadding: containerPadding || margin
                };
                const calculatedPosition = (0, _calculateUtils.calcXY)(positionParams, layerY, layerX, finalDroppingItem.w, finalDroppingItem.h);
                this.setState({
                    droppingDOMNode: /*#__PURE__*/ React.createElement("div", {
                        key: finalDroppingItem.i
                    }),
                    droppingPosition,
                    layout: [
                        ...layout,
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, finalDroppingItem), {
                            x: calculatedPosition.x,
                            y: calculatedPosition.y,
                            static: false,
                            isDraggable: true
                        })
                    ]
                });
            } else if (this.state.droppingPosition) {
                const { left, top } = this.state.droppingPosition;
                const shouldUpdatePosition = left != layerX || top != layerY;
                if (shouldUpdatePosition) this.setState({
                    droppingPosition
                });
            }
        });
        _defineProperty(this, "removeDroppingPlaceholder", ()=>{
            const { droppingItem, cols } = this.props;
            const { layout } = this.state;
            const newLayout = (0, _utils.compact)(layout.filter((l)=>l.i !== droppingItem.i), (0, _utils.compactType)(this.props), cols, this.props.allowOverlap);
            this.setState({
                layout: newLayout,
                droppingDOMNode: null,
                activeDrag: null,
                droppingPosition: undefined
            });
        });
        _defineProperty(this, "onDragLeave", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter--;
            // onDragLeave can be triggered on each layout's child.
            // But we know that count of dragEnter and dragLeave events
            // will be balanced after leaving the layout's container
            // so we can increase and decrease count of dragEnter and
            // when it'll be equal to 0 we'll remove the placeholder
            if (this.dragEnterCounter === 0) this.removeDroppingPlaceholder();
        });
        _defineProperty(this, "onDragEnter", (e)=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            this.dragEnterCounter++;
        });
        _defineProperty(this, "onDrop", (e /*: Event*/ )=>{
            e.preventDefault(); // Prevent any browser native action
            e.stopPropagation();
            const { droppingItem } = this.props;
            const { layout } = this.state;
            const item = layout.find((l)=>l.i === droppingItem.i);
            // reset dragEnter counter on drop
            this.dragEnterCounter = 0;
            this.removeDroppingPlaceholder();
            this.props.onDrop(layout, item, e);
        });
    }
}
exports.default = ReactGridLayout;
// TODO publish internal ReactClass displayName transform
_defineProperty(ReactGridLayout, "displayName", "ReactGridLayout");
// Refactored to another module to make way for preval
_defineProperty(ReactGridLayout, "propTypes", _ReactGridLayoutPropTypes.default);
_defineProperty(ReactGridLayout, "defaultProps", {
    autoSize: true,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: Infinity,
    // infinite vertical growth
    layout: [],
    margin: [
        10,
        10
    ],
    isBounded: false,
    isDraggable: true,
    isResizable: true,
    allowOverlap: false,
    isDroppable: false,
    useCSSTransforms: true,
    transformScale: 1,
    verticalCompact: true,
    compactType: "vertical",
    preventCollision: false,
    droppingItem: {
        i: "__dropping-elem__",
        h: 1,
        w: 1
    },
    resizeHandles: [
        "se"
    ],
    onLayoutChange: _utils.noop,
    onDragStart: _utils.noop,
    onDrag: _utils.noop,
    onDragStop: _utils.noop,
    onResizeStart: _utils.noop,
    onResize: _utils.noop,
    onResizeStop: _utils.noop,
    onDrop: _utils.noop,
    onDropDragOver: _utils.noop
});

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","409273444d54d2e6":"lXMxO","4eb1319583de9d22":"4BLH0","4773afa329a201de":"9GKTi","b76a978504eb07e":"bIMEY","febfe73b7c2bfcfb":"aorXe","6250ac3f7be359ba":"aQoDr","fb2346cfe785b8c2":"5n8qa"}],"4BLH0":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    /**
   * Default equality comparator pass-through, used as the standard `isEqual` creator for
   * use inside the built comparator.
   */ function createDefaultIsNestedEqual(comparator) {
        return function isEqual(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, meta) {
            return comparator(a, b, meta);
        };
    }
    /**
   * Wrap the provided `areItemsEqual` method to manage the circular cache, allowing
   * for circular references to be safely included in the comparison without creating
   * stack overflows.
   */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, isEqual, cache) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, isEqual, cache);
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, isEqual, cache);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
   * Targeted shallow merge of two objects.
   *
   * @NOTE
   * This exists as a tinier compiled version of the `__assign` helper that
   * `tsc` injects in case of `Object.assign` not being present.
   */ function merge(a, b) {
        var merged = {};
        for(var key in a)merged[key] = a[key];
        for(var key in b)merged[key] = b[key];
        return merged;
    }
    /**
   * Whether the value is a plain object.
   *
   * @NOTE
   * This is a same-realm compariosn only.
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * When the value is `Promise`-like, aka "then-able".
   */ function isPromiseLike(value) {
        return typeof value.then === 'function';
    }
    /**
   * Whether the values passed are strictly equal or both NaN.
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var REG_EXP_TAG = '[object RegExp]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var toString = Object.prototype.toString;
    function createComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, createIsNestedEqual = _a.createIsNestedEqual;
        var isEqual = createIsNestedEqual(comparator);
        /**
       * compare the value of the two objects and return true if they are equivalent in values
       */ function comparator(a, b, meta) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return a !== a && b !== b;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid the `toString.call()` cost unless necessary.
            if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
            // `isArray()` works on subclasses and is cross-realm, so we can again avoid
            // the `toString.call()` cost unless necessary by just checking if either
            // and then both are arrays.
            var aArray = Array.isArray(a);
            var bArray = Array.isArray(b);
            if (aArray || bArray) return aArray === bArray && areArraysEqual(a, b, isEqual, meta);
            // Since this is a custom object, use the classic `toString.call()` to get its
            // type. This is reasonably performant in modern environments like v8 and
            // SpiderMonkey, and allows for cross-realm comparison when other checks like
            // `instanceof` do not.
            var aTag = toString.call(a);
            if (aTag !== toString.call(b)) return false;
            if (aTag === DATE_TAG) // `getTime()` showed better results compared to alternatives like `valueOf()`
            // or the unary `+` operator.
            return areDatesEqual(a, b, isEqual, meta);
            if (aTag === REG_EXP_TAG) return areRegExpsEqual(a, b, isEqual, meta);
            if (aTag === MAP_TAG) return areMapsEqual(a, b, isEqual, meta);
            if (aTag === SET_TAG) return areSetsEqual(a, b, isEqual, meta);
            // If a simple object tag, then we can prioritize a simple object comparison because
            // it is likely a custom class. If an arguments tag, it should be treated as a standard
            // object.
            if (aTag === OBJECT_TAG || aTag === ARGUMENTS_TAG) // The exception for value comparison is `Promise`-like contracts. These should be
            // treated the same as standard `Promise` objects, which means strict equality.
            return isPromiseLike(a) || isPromiseLike(b) ? false : areObjectsEqual(a, b, isEqual, meta);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (aTag === BOOLEAN_TAG || aTag === NUMBER_TAG || aTag === STRING_TAG) return sameValueZeroEqual(a.valueOf(), b.valueOf());
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        }
        return comparator;
    }
    /**
   * Whether the arrays are equal in value.
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isEqual(a[index], b[index], index, index, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the arrays are equal in value, including circular references.
   */ var areArraysEqualCircular = createIsCircular(areArraysEqual);
    /**
   * Whether the dates passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides.
   */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
   * Whether the `Map`s are equal in value.
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        var indexA = 0;
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndexB = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndexB] && (hasMatch = isEqual(aKey, bKey, indexA, matchIndexB, a, b, meta) && isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndexB] = true;
                matchIndexB++;
            });
            indexA++;
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Map`s are equal in value, including circular references.
   */ var areMapsEqualCircular = createIsCircular(areMapsEqual);
    var OWNER = '_owner';
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Whether the objects are equal in value.
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = Object.keys(a);
        var index = keysA.length;
        if (Object.keys(b).length !== index) return false;
        var key;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            key = keysA[index];
            if (key === OWNER) {
                var reactElementA = !!a.$$typeof;
                var reactElementB = !!b.$$typeof;
                if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
            }
            if (!hasOwnProperty.call(b, key) || !isEqual(a[key], b[key], key, key, a, b, meta)) return false;
        }
        return true;
    }
    /**
   * Whether the objects are equal in value, including circular references.
   */ var areObjectsEqualCircular = createIsCircular(areObjectsEqual);
    /**
   * Whether the regexps passed are equal in value.
   *
   * @NOTE
   * This is a standalone function instead of done inline in the comparator
   * to allow for overrides. An example of this would be supporting a
   * pre-ES2015 environment where the `flags` property is not available.
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
   * Whether the `Set`s are equal in value.
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (!isValueEqual) return false;
        if (!a.size) return true;
        // The use of `forEach()` is to avoid the transpilation cost of `for...of` comparisons, and
        // the inability to control the performance of the resulting code. It also avoids excessive
        // iteration compared to doing comparisons of `keys()` and `values()`. As a result, though,
        // we cannot short-circuit the iterations; bookkeeping must be done to short-circuit the
        // equality checks themselves.
        var matchedIndices = {};
        a.forEach(function(aValue, aKey) {
            if (!isValueEqual) return;
            var hasMatch = false;
            var matchIndex = 0;
            b.forEach(function(bValue, bKey) {
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = isEqual(aValue, bValue, aKey, bKey, a, b, meta))) matchedIndices[matchIndex] = true;
                matchIndex++;
            });
            isValueEqual = hasMatch;
        });
        return isValueEqual;
    }
    /**
   * Whether the `Set`s are equal in value, including circular references.
   */ var areSetsEqualCircular = createIsCircular(areSetsEqual);
    var DEFAULT_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqual,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqual,
        areObjectsEqual: areObjectsEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqual,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var DEFAULT_CIRCULAR_CONFIG = Object.freeze({
        areArraysEqual: areArraysEqualCircular,
        areDatesEqual: areDatesEqual,
        areMapsEqual: areMapsEqualCircular,
        areObjectsEqual: areObjectsEqualCircular,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: areSetsEqualCircular,
        createIsNestedEqual: createDefaultIsNestedEqual
    });
    var isDeepEqual = createComparator(DEFAULT_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value.
   */ function deepEqual(a, b) {
        return isDeepEqual(a, b, undefined);
    }
    var isShallowEqual = createComparator(merge(DEFAULT_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value.
   */ function shallowEqual(a, b) {
        return isShallowEqual(a, b, undefined);
    }
    var isCircularDeepEqual = createComparator(DEFAULT_CIRCULAR_CONFIG);
    /**
   * Whether the items passed are deeply-equal in value, including circular references.
   */ function circularDeepEqual(a, b) {
        return isCircularDeepEqual(a, b, new WeakMap());
    }
    var isCircularShallowEqual = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, {
        createIsNestedEqual: function() {
            return sameValueZeroEqual;
        }
    }));
    /**
   * Whether the items passed are shallowly-equal in value, including circular references.
   */ function circularShallowEqual(a, b) {
        return isCircularShallowEqual(a, b, new WeakMap());
    }
    /**
   * Create a custom equality comparison method.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `RegExp.prototype.flags` out of the box.
   */ function createCustomEqual(getComparatorOptions) {
        return createComparator(merge(DEFAULT_CONFIG, getComparatorOptions(DEFAULT_CONFIG)));
    }
    /**
   * Create a custom equality comparison method that handles circular references. This is very
   * similar to `createCustomEqual`, with the only difference being that `meta` expects to be
   * populated with a `WeakMap`-like contract.
   *
   * This can be done to create very targeted comparisons in extreme hot-path scenarios
   * where the standard methods are not performant enough, but can also be used to provide
   * support for legacy environments that do not support expected features like
   * `WeakMap` out of the box.
   */ function createCustomCircularEqual(getComparatorOptions) {
        var comparator = createComparator(merge(DEFAULT_CIRCULAR_CONFIG, getComparatorOptions(DEFAULT_CIRCULAR_CONFIG)));
        return function(a, b, meta) {
            if (meta === void 0) meta = new WeakMap();
            return comparator(a, b, meta);
        };
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomCircularEqual = createCustomCircularEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"9GKTi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bIMEY":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bottom = bottom;
exports.childrenEqual = childrenEqual;
exports.cloneLayout = cloneLayout;
exports.cloneLayoutItem = cloneLayoutItem;
exports.collides = collides;
exports.compact = compact;
exports.compactItem = compactItem;
exports.compactType = compactType;
exports.correctBounds = correctBounds;
exports.fastPositionEqual = fastPositionEqual;
exports.fastRGLPropsEqual = void 0;
exports.getAllCollisions = getAllCollisions;
exports.getFirstCollision = getFirstCollision;
exports.getLayoutItem = getLayoutItem;
exports.getStatics = getStatics;
exports.modifyLayout = modifyLayout;
exports.moveElement = moveElement;
exports.moveElementAwayFromCollision = moveElementAwayFromCollision;
exports.noop = void 0;
exports.perc = perc;
exports.resizeItemInDirection = resizeItemInDirection;
exports.setTopLeft = setTopLeft;
exports.setTransform = setTransform;
exports.sortLayoutItems = sortLayoutItems;
exports.sortLayoutItemsByColRow = sortLayoutItemsByColRow;
exports.sortLayoutItemsByRowCol = sortLayoutItemsByRowCol;
exports.synchronizeLayoutWithChildren = synchronizeLayoutWithChildren;
exports.validateLayout = validateLayout;
exports.withLayoutItem = withLayoutItem;
var _fastEquals = require("919e91bc67a6b104");
var _react = _interopRequireDefault(require("93eb75e331e65467"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/*:: import type {
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: export type ResizeHandleAxis =
  | "s"
  | "w"
  | "e"
  | "n"
  | "sw"
  | "nw"
  | "se"
  | "ne";*/ /*:: export type LayoutItem = {
  w: number,
  h: number,
  x: number,
  y: number,
  i: string,
  minW?: number,
  minH?: number,
  maxW?: number,
  maxH?: number,
  moved?: boolean,
  static?: boolean,
  isDraggable?: ?boolean,
  isResizable?: ?boolean,
  resizeHandles?: Array<ResizeHandleAxis>,
  isBounded?: ?boolean
};*/ /*:: export type Layout = $ReadOnlyArray<LayoutItem>;*/ /*:: export type Position = {
  left: number,
  top: number,
  width: number,
  height: number
};*/ /*:: export type ReactDraggableCallbackData = {
  node: HTMLElement,
  x?: number,
  y?: number,
  deltaX: number,
  deltaY: number,
  lastX?: number,
  lastY?: number
};*/ /*:: export type PartialPosition = { left: number, top: number };*/ /*:: export type DroppingPosition = { left: number, top: number, e: Event };*/ /*:: export type Size = { width: number, height: number };*/ /*:: export type GridDragEvent = {
  e: Event,
  node: HTMLElement,
  newPosition: PartialPosition
};*/ /*:: export type GridResizeEvent = {
  e: Event,
  node: HTMLElement,
  size: Size,
  handle: string
};*/ /*:: export type DragOverEvent = MouseEvent & {
  nativeEvent: {
    layerX: number,
    layerY: number,
    ...Event
  }
};*/ /*:: export type Pick<FromType, Properties: { [string]: 0 }> = $Exact<
  $ObjMapi<Properties, <K, V>(k: K, v: V) => $ElementType<FromType, K>>
>;*/ // Helpful port from TS
/*:: type REl = ReactElement<any>;*/ /*:: export type ReactChildren = ReactChildrenArray<REl>;*/ /*:: export type EventCallback = (
  Layout,
  oldItem: ?LayoutItem,
  newItem: ?LayoutItem,
  placeholder: ?LayoutItem,
  Event,
  ?HTMLElement
) => void;*/ // All callbacks are of the signature (layout, oldItem, newItem, placeholder, e).
/*:: export type CompactType = ?("horizontal" | "vertical");*/ const isProduction = true;
const DEBUG = false;
/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */ function bottom(layout /*: Layout*/ ) /*: number*/ {
    let max = 0, bottomY;
    for(let i = 0, len = layout.length; i < len; i++){
        bottomY = layout[i].y + layout[i].h;
        if (bottomY > max) max = bottomY;
    }
    return max;
}
function cloneLayout(layout /*: Layout*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)newLayout[i] = cloneLayoutItem(layout[i]);
    return newLayout;
}
// Modify a layoutItem inside a layout. Returns a new Layout,
// does not mutate. Carries over all other LayoutItems unmodified.
function modifyLayout(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Layout*/ {
    const newLayout = Array(layout.length);
    for(let i = 0, len = layout.length; i < len; i++)if (layoutItem.i === layout[i].i) newLayout[i] = layoutItem;
    else newLayout[i] = layout[i];
    return newLayout;
}
// Function to be called to modify a layout item.
// Does defensive clones to ensure the layout is not modified.
function withLayoutItem(layout /*: Layout*/ , itemKey /*: string*/ , cb /*: LayoutItem => LayoutItem*/ ) /*: [Layout, ?LayoutItem]*/ {
    let item = getLayoutItem(layout, itemKey);
    if (!item) return [
        layout,
        null
    ];
    item = cb(cloneLayoutItem(item)); // defensive clone then modify
    // FIXME could do this faster if we already knew the index
    layout = modifyLayout(layout, item);
    return [
        layout,
        item
    ];
}
// Fast path to cloning, since this is monomorphic
function cloneLayoutItem(layoutItem /*: LayoutItem*/ ) /*: LayoutItem*/ {
    return {
        w: layoutItem.w,
        h: layoutItem.h,
        x: layoutItem.x,
        y: layoutItem.y,
        i: layoutItem.i,
        minW: layoutItem.minW,
        maxW: layoutItem.maxW,
        minH: layoutItem.minH,
        maxH: layoutItem.maxH,
        moved: Boolean(layoutItem.moved),
        static: Boolean(layoutItem.static),
        // These can be null/undefined
        isDraggable: layoutItem.isDraggable,
        isResizable: layoutItem.isResizable,
        resizeHandles: layoutItem.resizeHandles,
        isBounded: layoutItem.isBounded
    };
}
/**
 * Comparing React `children` is a bit difficult. This is a good way to compare them.
 * This will catch differences in keys, order, and length.
 */ function childrenEqual(a /*: ReactChildren*/ , b /*: ReactChildren*/ ) /*: boolean*/ {
    return (0, _fastEquals.deepEqual)(_react.default.Children.map(a, (c)=>c === null || c === void 0 ? void 0 : c.key), _react.default.Children.map(b, (c)=>c === null || c === void 0 ? void 0 : c.key)) && (0, _fastEquals.deepEqual)(_react.default.Children.map(a, (c)=>c === null || c === void 0 ? void 0 : c.props["data-grid"]), _react.default.Children.map(b, (c)=>c === null || c === void 0 ? void 0 : c.props["data-grid"]));
}
/**
 * See `fastRGLPropsEqual.js`.
 * We want this to run as fast as possible - it is called often - and to be
 * resilient to new props that we add. So rather than call lodash.isEqual,
 * which isn't suited to comparing props very well, we use this specialized
 * function in conjunction with preval to generate the fastest possible comparison
 * function, tuned for exactly our props.
 */ /*:: type FastRGLPropsEqual = (Object, Object, Function) => boolean;*/ const fastRGLPropsEqual /*: FastRGLPropsEqual*/  = exports.fastRGLPropsEqual = require("b5171ea604fb430f");
// Like the above, but a lot simpler.
function fastPositionEqual(a /*: Position*/ , b /*: Position*/ ) /*: boolean*/ {
    return a.left === b.left && a.top === b.top && a.width === b.width && a.height === b.height;
}
/**
 * Given two layoutitems, check if they collide.
 */ function collides(l1 /*: LayoutItem*/ , l2 /*: LayoutItem*/ ) /*: boolean*/ {
    if (l1.i === l2.i) return false; // same element
    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
    return true; // boxes overlap
}
/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * Does not modify layout items (clones). Creates a new layout array.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @param  {Boolean} allowOverlap When `true`, allows overlapping grid items.
 * @return {Array}       Compacted Layout.
 */ function compact(layout /*: Layout*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // Statics go in the compareWith array right away so items flow around them.
    const compareWith = getStatics(layout);
    // We go through the items by row and column.
    const sorted = sortLayoutItems(layout, compactType);
    // Holding for new items.
    const out = Array(layout.length);
    for(let i = 0, len = sorted.length; i < len; i++){
        let l = cloneLayoutItem(sorted[i]);
        // Don't move static elements
        if (!l.static) {
            l = compactItem(compareWith, l, compactType, cols, sorted, allowOverlap);
            // Add to comparison array. We only collide with items before this one.
            // Statics are already in this array.
            compareWith.push(l);
        }
        // Add to output array to make sure they still come out in the right order.
        out[layout.indexOf(sorted[i])] = l;
        // Clear moved flag, if it exists.
        l.moved = false;
    }
    return out;
}
const heightWidth = {
    x: "w",
    y: "h"
};
/**
 * Before moving item down, it will check if the movement will cause collisions and move those items down before.
 */ function resolveCompactionCollision(layout /*: Layout*/ , item /*: LayoutItem*/ , moveToCoord /*: number*/ , axis /*: "x" | "y"*/ ) {
    const sizeProp = heightWidth[axis];
    item[axis] += 1;
    const itemIndex = layout.map((layoutItem)=>{
        return layoutItem.i;
    }).indexOf(item.i);
    // Go through each item we collide with.
    for(let i = itemIndex + 1; i < layout.length; i++){
        const otherItem = layout[i];
        // Ignore static items
        if (otherItem.static) continue;
        // Optimization: we can break early if we know we're past this el
        // We can do this b/c it's a sorted layout
        if (otherItem.y > item.y + item.h) break;
        if (collides(item, otherItem)) resolveCompactionCollision(layout, otherItem, moveToCoord + item[sizeProp], axis);
    }
    item[axis] = moveToCoord;
}
/**
 * Compact an item in the layout.
 *
 * Modifies item.
 *
 */ function compactItem(compareWith /*: Layout*/ , l /*: LayoutItem*/ , compactType /*: CompactType*/ , cols /*: number*/ , fullLayout /*: Layout*/ , allowOverlap /*: ?boolean*/ ) /*: LayoutItem*/ {
    const compactV = compactType === "vertical";
    const compactH = compactType === "horizontal";
    if (compactV) {
        // Bottom 'y' possible is the bottom of the layout.
        // This allows you to do nice stuff like specify {y: Infinity}
        // This is here because the layout must be sorted in order to get the correct bottom `y`.
        l.y = Math.min(bottom(compareWith), l.y);
        // Move the element up as far as it can go without colliding.
        while(l.y > 0 && !getFirstCollision(compareWith, l))l.y--;
    } else if (compactH) // Move the element left as far as it can go without colliding.
    while(l.x > 0 && !getFirstCollision(compareWith, l))l.x--;
    // Move it down, and keep moving it down if it's colliding.
    let collides;
    // Checking the compactType null value to avoid breaking the layout when overlapping is allowed.
    while((collides = getFirstCollision(compareWith, l)) && !(compactType === null && allowOverlap)){
        if (compactH) resolveCompactionCollision(fullLayout, l, collides.x + collides.w, "x");
        else resolveCompactionCollision(fullLayout, l, collides.y + collides.h, "y");
        // Since we can't grow without bounds horizontally, if we've overflown, let's move it down and try again.
        if (compactH && l.x + l.w > cols) {
            l.x = cols - l.w;
            l.y++;
            // ALso move element as left as we can
            while(l.x > 0 && !getFirstCollision(compareWith, l))l.x--;
        }
    }
    // Ensure that there are no negative positions
    l.y = Math.max(l.y, 0);
    l.x = Math.max(l.x, 0);
    return l;
}
/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * Modifies layout items.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */ function correctBounds(layout /*: Layout*/ , bounds /*: { cols: number }*/ ) /*: Layout*/ {
    const collidesWith = getStatics(layout);
    for(let i = 0, len = layout.length; i < len; i++){
        const l = layout[i];
        // Overflows right
        if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
        // Overflows left
        if (l.x < 0) {
            l.x = 0;
            l.w = bounds.cols;
        }
        if (!l.static) collidesWith.push(l);
        else // If this is static and collides with other statics, we must move it down.
        // We have to do something nicer than just letting them overlap.
        while(getFirstCollision(collidesWith, l))l.y++;
    }
    return layout;
}
/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */ function getLayoutItem(layout /*: Layout*/ , id /*: string*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (layout[i].i === id) return layout[i];
    }
}
/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */ function getFirstCollision(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: ?LayoutItem*/ {
    for(let i = 0, len = layout.length; i < len; i++){
        if (collides(layout[i], layoutItem)) return layout[i];
    }
}
function getAllCollisions(layout /*: Layout*/ , layoutItem /*: LayoutItem*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>collides(l, layoutItem));
}
/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */ function getStatics(layout /*: Layout*/ ) /*: Array<LayoutItem>*/ {
    return layout.filter((l)=>l.static);
}
/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * Modifies layout items.
 *
 * @param  {Array}      layout            Full layout to modify.
 * @param  {LayoutItem} l                 element to move.
 * @param  {Number}     [x]               X position in grid units.
 * @param  {Number}     [y]               Y position in grid units.
 */ function moveElement(layout /*: Layout*/ , l /*: LayoutItem*/ , x /*: ?number*/ , y /*: ?number*/ , isUserAction /*: ?boolean*/ , preventCollision /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    // If this is static and not explicitly enabled as draggable,
    // no move is possible, so we can short-circuit this immediately.
    if (l.static && l.isDraggable !== true) return layout;
    // Short-circuit if nothing to do.
    if (l.y === y && l.x === x) return layout;
    log(`Moving element ${l.i} to [${String(x)},${String(y)}] from [${l.x},${l.y}]`);
    const oldX = l.x;
    const oldY = l.y;
    // This is quite a bit faster than extending the object
    if (typeof x === "number") l.x = x;
    if (typeof y === "number") l.y = y;
    l.moved = true;
    // If this collides with anything, move it.
    // When doing this comparison, we have to sort the items we compare with
    // to ensure, in the case of multiple collisions, that we're getting the
    // nearest collision.
    let sorted = sortLayoutItems(layout, compactType);
    const movingUp = compactType === "vertical" && typeof y === "number" ? oldY >= y : compactType === "horizontal" && typeof x === "number" ? oldX >= x : false;
    // $FlowIgnore acceptable modification of read-only array as it was recently cloned
    if (movingUp) sorted = sorted.reverse();
    const collisions = getAllCollisions(sorted, l);
    const hasCollisions = collisions.length > 0;
    // We may have collisions. We can short-circuit if we've turned off collisions or
    // allowed overlap.
    if (hasCollisions && allowOverlap) // Easy, we don't need to resolve collisions. But we *did* change the layout,
    // so clone it on the way out.
    return cloneLayout(layout);
    else if (hasCollisions && preventCollision) {
        // If we are preventing collision but not allowing overlap, we need to
        // revert the position of this element so it goes to where it came from, rather
        // than the user's desired location.
        log(`Collision prevented on ${l.i}, reverting.`);
        l.x = oldX;
        l.y = oldY;
        l.moved = false;
        return layout; // did not change so don't clone
    }
    // Move each item that collides away from this element.
    for(let i = 0, len = collisions.length; i < len; i++){
        const collision = collisions[i];
        log(`Resolving collision between ${l.i} at [${l.x},${l.y}] and ${collision.i} at [${collision.x},${collision.y}]`);
        // Short circuit so we can't infinite loop
        if (collision.moved) continue;
        // Don't move static items - we have to move *this* element away
        if (collision.static) layout = moveElementAwayFromCollision(layout, collision, l, isUserAction, compactType, cols);
        else layout = moveElementAwayFromCollision(layout, l, collision, isUserAction, compactType, cols);
    }
    return layout;
}
/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 */ function moveElementAwayFromCollision(layout /*: Layout*/ , collidesWith /*: LayoutItem*/ , itemToMove /*: LayoutItem*/ , isUserAction /*: ?boolean*/ , compactType /*: CompactType*/ , cols /*: number*/ ) /*: Layout*/ {
    const compactH = compactType === "horizontal";
    // Compact vertically if not set to horizontal
    const compactV = compactType === "vertical";
    const preventCollision = collidesWith.static; // we're already colliding (not for static items)
    // If there is enough space above the collision to put this element, move it there.
    // We only do this on the main collision as this can get funky in cascades and cause
    // unwanted swapping behavior.
    if (isUserAction) {
        // Reset isUserAction flag because we're not in the main collision anymore.
        isUserAction = false;
        // Make a mock item so we don't modify the item here, only modify in moveElement.
        const fakeItem /*: LayoutItem*/  = {
            x: compactH ? Math.max(collidesWith.x - itemToMove.w, 0) : itemToMove.x,
            y: compactV ? Math.max(collidesWith.y - itemToMove.h, 0) : itemToMove.y,
            w: itemToMove.w,
            h: itemToMove.h,
            i: "-1"
        };
        const firstCollision = getFirstCollision(layout, fakeItem);
        const collisionNorth = firstCollision && firstCollision.y + firstCollision.h > collidesWith.y;
        const collisionWest = firstCollision && collidesWith.x + collidesWith.w > firstCollision.x;
        // No collision? If so, we can go up there; otherwise, we'll end up moving down as normal
        if (!firstCollision) {
            log(`Doing reverse collision on ${itemToMove.i} up to [${fakeItem.x},${fakeItem.y}].`);
            return moveElement(layout, itemToMove, compactH ? fakeItem.x : undefined, compactV ? fakeItem.y : undefined, isUserAction, preventCollision, compactType, cols);
        } else if (collisionNorth && compactV) return moveElement(layout, itemToMove, undefined, collidesWith.y + 1, isUserAction, preventCollision, compactType, cols);
        else if (collisionNorth && compactType == null) {
            collidesWith.y = itemToMove.y;
            itemToMove.y = itemToMove.y + itemToMove.h;
            return layout;
        } else if (collisionWest && compactH) return moveElement(layout, collidesWith, itemToMove.x, undefined, isUserAction, preventCollision, compactType, cols);
    }
    const newX = compactH ? itemToMove.x + 1 : undefined;
    const newY = compactV ? itemToMove.y + 1 : undefined;
    if (newX == null && newY == null) return layout;
    return moveElement(layout, itemToMove, compactH ? itemToMove.x + 1 : undefined, compactV ? itemToMove.y + 1 : undefined, isUserAction, preventCollision, compactType, cols);
}
/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */ function perc(num /*: number*/ ) /*: string*/ {
    return num * 100 + "%";
}
/**
 * Helper functions to constrain dimensions of a GridItem
 */ const constrainWidth = (left /*: number*/ , currentWidth /*: number*/ , newWidth /*: number*/ , containerWidth /*: number*/ )=>{
    return left + newWidth > containerWidth ? currentWidth : newWidth;
};
const constrainHeight = (top /*: number*/ , currentHeight /*: number*/ , newHeight /*: number*/ )=>{
    return top < 0 ? currentHeight : newHeight;
};
const constrainLeft = (left /*: number*/ )=>Math.max(0, left);
const constrainTop = (top /*: number*/ )=>Math.max(0, top);
const resizeNorth = (currentSize, _ref, _containerWidth)=>{
    let { left, height, width } = _ref;
    const top = currentSize.top - (height - currentSize.height);
    return {
        left,
        width,
        height: constrainHeight(top, currentSize.height, height),
        top: constrainTop(top)
    };
};
const resizeEast = (currentSize, _ref2, containerWidth)=>{
    let { top, left, height, width } = _ref2;
    return {
        top,
        height,
        width: constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        left: constrainLeft(left)
    };
};
const resizeWest = (currentSize, _ref3, containerWidth)=>{
    let { top, height, width } = _ref3;
    const left = currentSize.left - (width - currentSize.width);
    return {
        height,
        width: left < 0 ? currentSize.width : constrainWidth(currentSize.left, currentSize.width, width, containerWidth),
        top: constrainTop(top),
        left: constrainLeft(left)
    };
};
const resizeSouth = (currentSize, _ref4, containerWidth)=>{
    let { top, left, height, width } = _ref4;
    return {
        width,
        left,
        height: constrainHeight(top, currentSize.height, height),
        top: constrainTop(top)
    };
};
const resizeNorthEast = function() {
    return resizeNorth(arguments.length <= 0 ? undefined : arguments[0], resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const resizeNorthWest = function() {
    return resizeNorth(arguments.length <= 0 ? undefined : arguments[0], resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const resizeSouthEast = function() {
    return resizeSouth(arguments.length <= 0 ? undefined : arguments[0], resizeEast(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const resizeSouthWest = function() {
    return resizeSouth(arguments.length <= 0 ? undefined : arguments[0], resizeWest(...arguments), arguments.length <= 2 ? undefined : arguments[2]);
};
const ordinalResizeHandlerMap = {
    n: resizeNorth,
    ne: resizeNorthEast,
    e: resizeEast,
    se: resizeSouthEast,
    s: resizeSouth,
    sw: resizeSouthWest,
    w: resizeWest,
    nw: resizeNorthWest
};
/**
 * Helper for clamping width and position when resizing an item.
 */ function resizeItemInDirection(direction /*: ResizeHandleAxis*/ , currentSize /*: Position*/ , newSize /*: Position*/ , containerWidth /*: number*/ ) /*: Position*/ {
    const ordinalHandler = ordinalResizeHandlerMap[direction];
    // Shouldn't be possible given types; that said, don't fail hard
    if (!ordinalHandler) return newSize;
    return ordinalHandler(currentSize, (0, _objectSpread._)({}, currentSize, newSize), containerWidth);
}
function setTransform(_ref5 /*:: */ ) /*: Object*/ {
    let { top, left, width, height } /*: Position*/  = _ref5 /*: Position*/ ;
    // Replace unitless items with px
    const translate = `translate(${left}px,${top}px)`;
    return {
        transform: translate,
        WebkitTransform: translate,
        MozTransform: translate,
        msTransform: translate,
        OTransform: translate,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
function setTopLeft(_ref6 /*:: */ ) /*: Object*/ {
    let { top, left, width, height } /*: Position*/  = _ref6 /*: Position*/ ;
    return {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute"
    };
}
/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */ function sortLayoutItems(layout /*: Layout*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    if (compactType === "horizontal") return sortLayoutItemsByColRow(layout);
    if (compactType === "vertical") return sortLayoutItemsByRowCol(layout);
    else return layout;
}
/**
 * Sort layout items by row ascending and column ascending.
 *
 * Does not modify Layout.
 */ function sortLayoutItemsByRowCol(layout /*: Layout*/ ) /*: Layout*/ {
    // Slice to clone array as sort modifies
    return layout.slice(0).sort(function(a, b) {
        if (a.y > b.y || a.y === b.y && a.x > b.x) return 1;
        else if (a.y === b.y && a.x === b.x) // Without this, we can get different sort results in IE vs. Chrome/FF
        return 0;
        return -1;
    });
}
/**
 * Sort layout items by column ascending then row ascending.
 *
 * Does not modify Layout.
 */ function sortLayoutItemsByColRow(layout /*: Layout*/ ) /*: Layout*/ {
    return layout.slice(0).sort(function(a, b) {
        if (a.x > b.x || a.x === b.x && a.y > b.y) return 1;
        return -1;
    });
}
/**
 * Generate a layout using the initialLayout and children as a template.
 * Missing entries will be added, extraneous ones will be truncated.
 *
 * Does not modify initialLayout.
 *
 * @param  {Array}  initialLayout Layout passed in through props.
 * @param  {String} breakpoint    Current responsive breakpoint.
 * @param  {?String} compact      Compaction option.
 * @return {Array}                Working layout.
 */ function synchronizeLayoutWithChildren(initialLayout /*: Layout*/ , children /*: ReactChildren*/ , cols /*: number*/ , compactType /*: CompactType*/ , allowOverlap /*: ?boolean*/ ) /*: Layout*/ {
    initialLayout = initialLayout || [];
    // Generate one layout item per child.
    const layout /*: LayoutItem[]*/  = [];
    _react.default.Children.forEach(children, (child /*: ReactElement<any>*/ )=>{
        // Child may not exist
        if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
        const exists = getLayoutItem(initialLayout, String(child.key));
        const g = child.props["data-grid"];
        // Don't overwrite the layout item if it's already in the initial layout.
        // If it has a `data-grid` property, prefer that over what's in the layout.
        if (exists && g == null) layout.push(cloneLayoutItem(exists));
        else // Hey, this item has a data-grid property, use it.
        if (g) {
            if (!isProduction) validateLayout([
                g
            ], "ReactGridLayout.children");
            // FIXME clone not really necessary here
            layout.push(cloneLayoutItem((0, _objectSpreadProps._)((0, _objectSpread._)({}, g), {
                i: child.key
            })));
        } else // Nothing provided: ensure this is added to the bottom
        // FIXME clone not really necessary here
        layout.push(cloneLayoutItem({
            w: 1,
            h: 1,
            x: 0,
            y: bottom(layout),
            i: String(child.key)
        }));
    });
    // Correct the layout.
    const correctedLayout = correctBounds(layout, {
        cols: cols
    });
    return allowOverlap ? correctedLayout : compact(correctedLayout, compactType, cols);
}
/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */ function validateLayout(layout /*: Layout*/ ) /*: void*/ {
    let contextName /*: string*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Layout";
    const subProps = [
        "x",
        "y",
        "w",
        "h"
    ];
    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
    for(let i = 0, len = layout.length; i < len; i++){
        const item = layout[i];
        for(let j = 0; j < subProps.length; j++){
            const key = subProps[j];
            const value = item[key];
            if (typeof value !== "number" || Number.isNaN(value)) throw new Error(`ReactGridLayout: ${contextName}[${i}].${key} must be a number! Received: ${value} (${typeof value})`);
        }
        if (typeof item.i !== "undefined" && typeof item.i !== "string") throw new Error(`ReactGridLayout: ${contextName}[${i}].i must be a string! Received: ${item.i} (${typeof item.i})`);
    }
}
// Legacy support for verticalCompact: false
function compactType(props /*: ?{ verticalCompact: boolean, compactType: CompactType }*/ ) /*: CompactType*/ {
    const { verticalCompact, compactType } = props || {};
    return verticalCompact === false ? null : compactType;
}
function log() {
    if (!DEBUG) return;
    // eslint-disable-next-line no-console
    console.log(...arguments);
}
const noop = ()=>{};
exports.noop = noop;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","919e91bc67a6b104":"4BLH0","93eb75e331e65467":"lXMxO","b5171ea604fb430f":"gNx3E"}],"gNx3E":[function(require,module,exports,__globalThis) {
// this file was prevaled
module.exports = function fastRGLPropsEqual(a, b, isEqualImpl) {
    if (a === b) return true;
    return a.className === b.className && isEqualImpl(a.style, b.style) && a.width === b.width && a.autoSize === b.autoSize && a.cols === b.cols && a.draggableCancel === b.draggableCancel && a.draggableHandle === b.draggableHandle && isEqualImpl(a.verticalCompact, b.verticalCompact) && isEqualImpl(a.compactType, b.compactType) && isEqualImpl(a.layout, b.layout) && isEqualImpl(a.margin, b.margin) && isEqualImpl(a.containerPadding, b.containerPadding) && a.rowHeight === b.rowHeight && a.maxRows === b.maxRows && a.isBounded === b.isBounded && a.isDraggable === b.isDraggable && a.isResizable === b.isResizable && a.allowOverlap === b.allowOverlap && a.preventCollision === b.preventCollision && a.useCSSTransforms === b.useCSSTransforms && a.transformScale === b.transformScale && a.isDroppable === b.isDroppable && isEqualImpl(a.resizeHandles, b.resizeHandles) && isEqualImpl(a.resizeHandle, b.resizeHandle) && a.onLayoutChange === b.onLayoutChange && a.onDragStart === b.onDragStart && a.onDrag === b.onDrag && a.onDragStop === b.onDragStop && a.onResizeStart === b.onResizeStart && a.onResize === b.onResize && a.onResizeStop === b.onResizeStop && a.onDrop === b.onDrop && isEqualImpl(a.droppingItem, b.droppingItem) && isEqualImpl(a.innerRef, b.innerRef);
};

},{}],"aorXe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calcGridColWidth = calcGridColWidth;
exports.calcGridItemPosition = calcGridItemPosition;
exports.calcGridItemWHPx = calcGridItemWHPx;
exports.calcWH = calcWH;
exports.calcXY = calcXY;
exports.clamp = clamp;
/*:: import type { Position } from "./utils";*/ /*:: export type PositionParams = {
  margin: [number, number],
  containerPadding: [number, number],
  containerWidth: number,
  cols: number,
  rowHeight: number,
  maxRows: number
};*/ // Helper for generating column width
function calcGridColWidth(positionParams /*: PositionParams*/ ) /*: number*/ {
    const { margin, containerPadding, containerWidth, cols } = positionParams;
    return (containerWidth - margin[0] * (cols - 1) - containerPadding[0] * 2) / cols;
}
// This can either be called:
// calcGridItemWHPx(w, colWidth, margin[0])
// or
// calcGridItemWHPx(h, rowHeight, margin[1])
function calcGridItemWHPx(gridUnits /*: number*/ , colOrRowSize /*: number*/ , marginPx /*: number*/ ) /*: number*/ {
    // 0 * Infinity === NaN, which causes problems with resize contraints
    if (!Number.isFinite(gridUnits)) return gridUnits;
    return Math.round(colOrRowSize * gridUnits + Math.max(0, gridUnits - 1) * marginPx);
}
/**
 * Return position on the page given an x, y, w, h.
 * left, top, width, height are all in pixels.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number}  x                      X coordinate in grid units.
 * @param  {Number}  y                      Y coordinate in grid units.
 * @param  {Number}  w                      W coordinate in grid units.
 * @param  {Number}  h                      H coordinate in grid units.
 * @return {Position}                       Object containing coords.
 */ function calcGridItemPosition(positionParams /*: PositionParams*/ , x /*: number*/ , y /*: number*/ , w /*: number*/ , h /*: number*/ , state /*: ?Object*/ ) /*: Position*/ {
    const { margin, containerPadding, rowHeight } = positionParams;
    const colWidth = calcGridColWidth(positionParams);
    const out = {};
    // If resizing, use the exact width and height as returned from resizing callbacks.
    if (state && state.resizing) {
        out.width = Math.round(state.resizing.width);
        out.height = Math.round(state.resizing.height);
    } else {
        out.width = calcGridItemWHPx(w, colWidth, margin[0]);
        out.height = calcGridItemWHPx(h, rowHeight, margin[1]);
    }
    // If dragging, use the exact width and height as returned from dragging callbacks.
    if (state && state.dragging) {
        out.top = Math.round(state.dragging.top);
        out.left = Math.round(state.dragging.left);
    } else if (state && state.resizing && typeof state.resizing.top === "number" && typeof state.resizing.left === "number") {
        out.top = Math.round(state.resizing.top);
        out.left = Math.round(state.resizing.left);
    } else {
        out.top = Math.round((rowHeight + margin[1]) * y + containerPadding[1]);
        out.left = Math.round((colWidth + margin[0]) * x + containerPadding[0]);
    }
    return out;
}
/**
 * Translate x and y coordinates from pixels to grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calculations.
 * @param  {Number} top                     Top position (relative to parent) in pixels.
 * @param  {Number} left                    Left position (relative to parent) in pixels.
 * @param  {Number} w                       W coordinate in grid units.
 * @param  {Number} h                       H coordinate in grid units.
 * @return {Object}                         x and y in grid units.
 */ function calcXY(positionParams /*: PositionParams*/ , top /*: number*/ , left /*: number*/ , w /*: number*/ , h /*: number*/ ) /*: { x: number, y: number }*/ {
    const { margin, containerPadding, cols, rowHeight, maxRows } = positionParams;
    const colWidth = calcGridColWidth(positionParams);
    // left = containerPaddingX + x * (colWidth + marginX)
    // x * (colWidth + marginX) = left - containerPaddingX
    // x = (left - containerPaddingX) / (colWidth + marginX)
    let x = Math.round((left - containerPadding[0]) / (colWidth + margin[0]));
    let y = Math.round((top - containerPadding[1]) / (rowHeight + margin[1]));
    // Capping
    x = clamp(x, 0, cols - w);
    y = clamp(y, 0, maxRows - h);
    return {
        x,
        y
    };
}
/**
 * Given a height and width in pixel values, calculate grid units.
 * @param  {PositionParams} positionParams  Parameters of grid needed for coordinates calcluations.
 * @param  {Number} height                  Height in pixels.
 * @param  {Number} width                   Width in pixels.
 * @param  {Number} x                       X coordinate in grid units.
 * @param  {Number} y                       Y coordinate in grid units.
 * @param {String} handle Resize Handle.
 * @return {Object}                         w, h as grid units.
 */ function calcWH(positionParams /*: PositionParams*/ , width /*: number*/ , height /*: number*/ , x /*: number*/ , y /*: number*/ , handle /*: string*/ ) /*: { w: number, h: number }*/ {
    const { margin, maxRows, cols, rowHeight } = positionParams;
    const colWidth = calcGridColWidth(positionParams);
    // width = colWidth * w - (margin * (w - 1))
    // ...
    // w = (width + margin) / (colWidth + margin)
    let w = Math.round((width + margin[0]) / (colWidth + margin[0]));
    let h = Math.round((height + margin[1]) / (rowHeight + margin[1]));
    // Capping
    let _w = clamp(w, 0, cols - x);
    let _h = clamp(h, 0, maxRows - y);
    if ([
        "sw",
        "w",
        "nw"
    ].indexOf(handle) !== -1) _w = clamp(w, 0, cols);
    if ([
        "nw",
        "n",
        "ne"
    ].indexOf(handle) !== -1) _h = clamp(h, 0, maxRows);
    return {
        w: _w,
        h: _h
    };
}
// Similar to _.clamp
function clamp(num /*: number*/ , lowerBound /*: number*/ , upperBound /*: number*/ ) /*: number*/ {
    return Math.max(Math.min(num, upperBound), lowerBound);
}

},{}],"aQoDr":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("e6c023845ec8e836"));
var _reactDom = require("8921cc2fafd2191e");
var _propTypes = _interopRequireDefault(require("9d4ca7bf8b09c0ba"));
var _reactDraggable = require("c759770490f68107");
var _reactResizable = require("1626b4c369c9848e");
var _utils = require("7d607e9dede9bbd7");
var _calculateUtils = require("690df644bca08ce0");
var _ReactGridLayoutPropTypes = require("e8cbc2ae1b33bf31");
var _clsx = _interopRequireDefault(require("f16d20165e3cc81"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type { Element as ReactElement, Node as ReactNode } from "react";*/ /*:: import type {
  ReactDraggableCallbackData,
  GridDragEvent,
  GridResizeEvent,
  DroppingPosition,
  Position,
  ResizeHandleAxis
} from "./utils";*/ /*:: import type { PositionParams } from "./calculateUtils";*/ /*:: import type { ResizeHandle, ReactRef } from "./ReactGridLayoutPropTypes";*/ /*:: type PartialPosition = { top: number, left: number };*/ /*:: type GridItemCallback<Data: GridDragEvent | GridResizeEvent> = (
  i: string,
  w: number,
  h: number,
  Data
) => void;*/ /*:: type ResizeCallbackData = {
  node: HTMLElement,
  size: Position,
  handle: ResizeHandleAxis
};*/ /*:: type GridItemResizeCallback = (
  e: Event,
  data: ResizeCallbackData,
  position: Position
) => void;*/ /*:: type State = {
  resizing: ?{ top: number, left: number, width: number, height: number },
  dragging: ?{ top: number, left: number },
  className: string
};*/ /*:: type Props = {
  children: ReactElement<any>,
  cols: number,
  containerWidth: number,
  margin: [number, number],
  containerPadding: [number, number],
  rowHeight: number,
  maxRows: number,
  isDraggable: boolean,
  isResizable: boolean,
  isBounded: boolean,
  static?: boolean,
  useCSSTransforms?: boolean,
  usePercentages?: boolean,
  transformScale: number,
  droppingPosition?: DroppingPosition,

  className: string,
  style?: Object,
  // Draggability
  cancel: string,
  handle: string,

  x: number,
  y: number,
  w: number,
  h: number,

  minW: number,
  maxW: number,
  minH: number,
  maxH: number,
  i: string,

  resizeHandles?: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,

  onDrag?: GridItemCallback<GridDragEvent>,
  onDragStart?: GridItemCallback<GridDragEvent>,
  onDragStop?: GridItemCallback<GridDragEvent>,
  onResize?: GridItemCallback<GridResizeEvent>,
  onResizeStart?: GridItemCallback<GridResizeEvent>,
  onResizeStop?: GridItemCallback<GridResizeEvent>
};*/ /*:: type DefaultProps = {
  className: string,
  cancel: string,
  handle: string,
  minH: number,
  minW: number,
  maxH: number,
  maxW: number,
  transformScale: number
};*/ /**
 * An individual item within a ReactGridLayout.
 */ class GridItem extends _react.default.Component /*:: <Props, State>*/  {
    shouldComponentUpdate(nextProps /*: Props*/ , nextState /*: State*/ ) /*: boolean*/ {
        // We can't deeply compare children. If the developer memoizes them, we can
        // use this optimization.
        if (this.props.children !== nextProps.children) return true;
        if (this.props.droppingPosition !== nextProps.droppingPosition) return true;
        // TODO memoize these calculations so they don't take so long?
        const oldPosition = (0, _calculateUtils.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state);
        const newPosition = (0, _calculateUtils.calcGridItemPosition)(this.getPositionParams(nextProps), nextProps.x, nextProps.y, nextProps.w, nextProps.h, nextState);
        return !(0, _utils.fastPositionEqual)(oldPosition, newPosition) || this.props.useCSSTransforms !== nextProps.useCSSTransforms;
    }
    componentDidMount() {
        this.moveDroppingItem({});
    }
    componentDidUpdate(prevProps /*: Props*/ ) {
        this.moveDroppingItem(prevProps);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(prevProps /*: Props*/ ) {
        const { droppingPosition } = this.props;
        if (!droppingPosition) return;
        const node = this.elementRef.current;
        // Can't find DOM node (are we unmounted?)
        if (!node) return;
        const prevDroppingPosition = prevProps.droppingPosition || {
            left: 0,
            top: 0
        };
        const { dragging } = this.state;
        const shouldDrag = dragging && droppingPosition.left !== prevDroppingPosition.left || droppingPosition.top !== prevDroppingPosition.top;
        if (!dragging) this.onDragStart(droppingPosition.e, {
            node,
            deltaX: droppingPosition.left,
            deltaY: droppingPosition.top
        });
        else if (shouldDrag) {
            const deltaX = droppingPosition.left - dragging.left;
            const deltaY = droppingPosition.top - dragging.top;
            this.onDrag(droppingPosition.e, {
                node,
                deltaX,
                deltaY
            }, true // dontFLush: avoid flushSync to temper warnings
            );
        }
    }
    getPositionParams() /*: PositionParams*/ {
        let props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        return {
            cols: props.cols,
            containerPadding: props.containerPadding,
            containerWidth: props.containerWidth,
            margin: props.margin,
            maxRows: props.maxRows,
            rowHeight: props.rowHeight
        };
    }
    /**
   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
   * well when server rendering, and the only way to do that properly is to use percentage width/left because
   * we don't know exactly what the browser viewport is.
   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
   *
   * @param  {Object} pos Position object with width, height, left, top.
   * @return {Object}     Style object.
   */ createStyle(pos /*: Position*/ ) /*: { [key: string]: ?string }*/ {
        const { usePercentages, containerWidth, useCSSTransforms } = this.props;
        let style;
        // CSS Transforms support (default)
        if (useCSSTransforms) style = (0, _utils.setTransform)(pos);
        else {
            // top,left (slow)
            style = (0, _utils.setTopLeft)(pos);
            // This is used for server rendering.
            if (usePercentages) {
                style.left = (0, _utils.perc)(pos.left / containerWidth);
                style.width = (0, _utils.perc)(pos.width / containerWidth);
            }
        }
        return style;
    }
    /**
   * Mix a Draggable instance into a child.
   * @param  {Element} child    Child element.
   * @return {Element}          Child wrapped in Draggable.
   */ mixinDraggable(child /*: ReactElement<any>*/ , isDraggable /*: boolean*/ ) /*: ReactElement<any>*/ {
        return /*#__PURE__*/ _react.default.createElement(_reactDraggable.DraggableCore, {
            disabled: !isDraggable,
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop,
            handle: this.props.handle,
            cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
            scale: this.props.transformScale,
            nodeRef: this.elementRef
        }, child);
    }
    /**
   * Utility function to setup callback handler definitions for
   * similarily structured resize events.
   */ curryResizeHandler(position /*: Position*/ , handler /*: Function*/ ) /*: Function*/ {
        return (e /*: Event*/ , data /*: ResizeCallbackData*/ )=>/*: Function*/ handler(e, data, position);
    }
    /**
   * Mix a Resizable instance into a child.
   * @param  {Element} child    Child element.
   * @param  {Object} position  Position object (pixel values)
   * @return {Element}          Child wrapped in Resizable.
   */ mixinResizable(child /*: ReactElement<any>*/ , position /*: Position*/ , isResizable /*: boolean*/ ) /*: ReactElement<any>*/ {
        const { cols, minW, minH, maxW, maxH, transformScale, resizeHandles, resizeHandle } = this.props;
        const positionParams = this.getPositionParams();
        // This is the max possible width - doesn't go to infinity because of the width of the window
        const maxWidth = (0, _calculateUtils.calcGridItemPosition)(positionParams, 0, 0, cols, 0).width;
        // Calculate min/max constraints using our min & maxes
        const mins = (0, _calculateUtils.calcGridItemPosition)(positionParams, 0, 0, minW, minH);
        const maxes = (0, _calculateUtils.calcGridItemPosition)(positionParams, 0, 0, maxW, maxH);
        const minConstraints = [
            mins.width,
            mins.height
        ];
        const maxConstraints = [
            Math.min(maxes.width, maxWidth),
            Math.min(maxes.height, Infinity)
        ];
        return /*#__PURE__*/ _react.default.createElement(_reactResizable.Resizable, {
            draggableOpts: {
                disabled: !isResizable
            },
            className: isResizable ? undefined : "react-resizable-hide",
            width: position.width,
            height: position.height,
            minConstraints: minConstraints,
            maxConstraints: maxConstraints,
            onResizeStop: this.curryResizeHandler(position, this.onResizeStop),
            onResizeStart: this.curryResizeHandler(position, this.onResizeStart),
            onResize: this.curryResizeHandler(position, this.onResize),
            transformScale: transformScale,
            resizeHandles: resizeHandles,
            handle: resizeHandle
        }, child);
    }
    /**
   * Wrapper around resize events to provide more useful data.
   */ onResizeHandler(e /*: Event*/ , _ref4 /*:: */ , // 'size' is updated position
    position /*: Position*/ , // existing position
    handlerName /*: string*/ ) /*: void*/ {
        let { node, size, handle } /*: ResizeCallbackData*/  = _ref4 /*: ResizeCallbackData*/ ;
        const handler = this.props[handlerName];
        if (!handler) return;
        const { x, y, i, maxH, minH, containerWidth } = this.props;
        const { minW, maxW } = this.props;
        // Clamping of dimensions based on resize direction
        let updatedSize = size;
        if (node) {
            updatedSize = (0, _utils.resizeItemInDirection)(handle, position, size, containerWidth);
            (0, _reactDom.flushSync)(()=>{
                this.setState({
                    resizing: handlerName === "onResizeStop" ? null : updatedSize
                });
            });
        }
        // Get new XY based on pixel size
        let { w, h } = (0, _calculateUtils.calcWH)(this.getPositionParams(), updatedSize.width, updatedSize.height, x, y, handle);
        // Min/max capping.
        // minW should be at least 1 (TODO propTypes validation?)
        w = (0, _calculateUtils.clamp)(w, Math.max(minW, 1), maxW);
        h = (0, _calculateUtils.clamp)(h, minH, maxH);
        handler.call(this, i, w, h, {
            e,
            node,
            size: updatedSize,
            handle
        });
    }
    render() /*: ReactNode*/ {
        const { x, y, w, h, isDraggable, isResizable, droppingPosition, useCSSTransforms } = this.props;
        const pos = (0, _calculateUtils.calcGridItemPosition)(this.getPositionParams(), x, y, w, h, this.state);
        const child = _react.default.Children.only(this.props.children);
        // Create the child element. We clone the existing element but modify its className and style.
        let newChild = /*#__PURE__*/ _react.default.cloneElement(child, {
            ref: this.elementRef,
            className: (0, _clsx.default)("react-grid-item", child.props.className, this.props.className, {
                static: this.props.static,
                resizing: Boolean(this.state.resizing),
                "react-draggable": isDraggable,
                "react-draggable-dragging": Boolean(this.state.dragging),
                dropping: Boolean(droppingPosition),
                cssTransforms: useCSSTransforms
            }),
            // We can set the width and height on the child, but unfortunately we can't set the position.
            style: (0, _objectSpread._)({}, this.props.style, child.props.style, this.createStyle(pos))
        });
        // Resizable support. This is usually on but the user can toggle it off.
        newChild = this.mixinResizable(newChild, pos, isResizable);
        // Draggable support. This is always on, except for with placeholders.
        newChild = this.mixinDraggable(newChild, isDraggable);
        return newChild;
    }
    constructor(){
        super(...arguments);
        _defineProperty(this, "state", {
            resizing: null,
            dragging: null,
            className: ""
        });
        _defineProperty(this, "elementRef", /*#__PURE__*/ _react.default.createRef());
        /**
     * onDragStart event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ _defineProperty(this, "onDragStart", (e, _ref)=>{
            let { node } = _ref;
            const { onDragStart, transformScale } = this.props;
            if (!onDragStart) return;
            const newPosition /*: PartialPosition*/  = {
                top: 0,
                left: 0
            };
            // TODO: this wont work on nested parents
            const { offsetParent } = node;
            if (!offsetParent) return;
            const parentRect = offsetParent.getBoundingClientRect();
            const clientRect = node.getBoundingClientRect();
            const cLeft = clientRect.left / transformScale;
            const pLeft = parentRect.left / transformScale;
            const cTop = clientRect.top / transformScale;
            const pTop = parentRect.top / transformScale;
            newPosition.left = cLeft - pLeft + offsetParent.scrollLeft;
            newPosition.top = cTop - pTop + offsetParent.scrollTop;
            this.setState({
                dragging: newPosition
            });
            // Call callback with this data
            const { x, y } = (0, _calculateUtils.calcXY)(this.getPositionParams(), newPosition.top, newPosition.left, this.props.w, this.props.h);
            return onDragStart.call(this, this.props.i, x, y, {
                e,
                node,
                newPosition
            });
        });
        /**
     * onDrag event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     * @param  {boolean} dontFlush    if true, will not call flushSync
     */ _defineProperty(this, "onDrag", (e, _ref2, dontFlush)=>{
            let { node, deltaX, deltaY } = _ref2;
            const { onDrag } = this.props;
            if (!onDrag) return;
            if (!this.state.dragging) throw new Error("onDrag called before onDragStart.");
            let top = this.state.dragging.top + deltaY;
            let left = this.state.dragging.left + deltaX;
            const { isBounded, i, w, h, containerWidth } = this.props;
            const positionParams = this.getPositionParams();
            // Boundary calculations; keeps items within the grid
            if (isBounded) {
                const { offsetParent } = node;
                if (offsetParent) {
                    const { margin, rowHeight } = this.props;
                    const bottomBoundary = offsetParent.clientHeight - (0, _calculateUtils.calcGridItemWHPx)(h, rowHeight, margin[1]);
                    top = (0, _calculateUtils.clamp)(top, 0, bottomBoundary);
                    const colWidth = (0, _calculateUtils.calcGridColWidth)(positionParams);
                    const rightBoundary = containerWidth - (0, _calculateUtils.calcGridItemWHPx)(w, colWidth, margin[0]);
                    left = (0, _calculateUtils.clamp)(left, 0, rightBoundary);
                }
            }
            const newPosition /*: PartialPosition*/  = {
                top,
                left
            };
            // dontFlush is set if we're calling from inside
            if (dontFlush) this.setState({
                dragging: newPosition
            });
            else (0, _reactDom.flushSync)(()=>{
                this.setState({
                    dragging: newPosition
                });
            });
            // Call callback with this data
            const { x, y } = (0, _calculateUtils.calcXY)(positionParams, top, left, w, h);
            return onDrag.call(this, i, x, y, {
                e,
                node,
                newPosition
            });
        });
        /**
     * onDragStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node, delta and position information
     */ _defineProperty(this, "onDragStop", (e, _ref3)=>{
            let { node } = _ref3;
            const { onDragStop } = this.props;
            if (!onDragStop) return;
            if (!this.state.dragging) throw new Error("onDragEnd called before onDragStart.");
            const { w, h, i } = this.props;
            const { left, top } = this.state.dragging;
            const newPosition /*: PartialPosition*/  = {
                top,
                left
            };
            this.setState({
                dragging: null
            });
            const { x, y } = (0, _calculateUtils.calcXY)(this.getPositionParams(), top, left, w, h);
            return onDragStop.call(this, i, x, y, {
                e,
                node,
                newPosition
            });
        });
        /**
     * onResizeStop event handler
     * @param  {Event}  e             event data
     * @param  {Object} callbackData  an object with node and size information
     */ _defineProperty(this, "onResizeStop", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStop"));
        // onResizeStart event handler
        _defineProperty(this, "onResizeStart", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResizeStart"));
        // onResize event handler
        _defineProperty(this, "onResize", (e, callbackData, position)=>this.onResizeHandler(e, callbackData, position, "onResize"));
    }
}
exports.default = GridItem;
_defineProperty(GridItem, "propTypes", {
    // Children must be only a single element
    children: _propTypes.default.element,
    // General grid attributes
    cols: _propTypes.default.number.isRequired,
    containerWidth: _propTypes.default.number.isRequired,
    rowHeight: _propTypes.default.number.isRequired,
    margin: _propTypes.default.array.isRequired,
    maxRows: _propTypes.default.number.isRequired,
    containerPadding: _propTypes.default.array.isRequired,
    // These are all in grid units
    x: _propTypes.default.number.isRequired,
    y: _propTypes.default.number.isRequired,
    w: _propTypes.default.number.isRequired,
    h: _propTypes.default.number.isRequired,
    // All optional
    minW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minWidth not Number");
        if (value > props.w || value > props.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxWidth not Number");
        if (value < props.w || value < props.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("minHeight not Number");
        if (value > props.h || value > props.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(props /*: Props*/ , propName /*: string*/ ) {
        const value = props[propName];
        if (typeof value !== "number") return new Error("maxHeight not Number");
        if (value < props.h || value < props.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: _propTypes.default.string.isRequired,
    // Resize handle options
    resizeHandles: _ReactGridLayoutPropTypes.resizeHandleAxesType,
    resizeHandle: _ReactGridLayoutPropTypes.resizeHandleType,
    // Functions
    onDragStop: _propTypes.default.func,
    onDragStart: _propTypes.default.func,
    onDrag: _propTypes.default.func,
    onResizeStop: _propTypes.default.func,
    onResizeStart: _propTypes.default.func,
    onResize: _propTypes.default.func,
    // Flags
    isDraggable: _propTypes.default.bool.isRequired,
    isResizable: _propTypes.default.bool.isRequired,
    isBounded: _propTypes.default.bool.isRequired,
    static: _propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: _propTypes.default.bool.isRequired,
    transformScale: _propTypes.default.number,
    // Others
    className: _propTypes.default.string,
    // Selector for draggable handle
    handle: _propTypes.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: _propTypes.default.string,
    // Current position of a dropping element
    droppingPosition: _propTypes.default.shape({
        e: _propTypes.default.object.isRequired,
        left: _propTypes.default.number.isRequired,
        top: _propTypes.default.number.isRequired
    })
});
_defineProperty(GridItem, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: Infinity,
    maxW: Infinity,
    transformScale: 1
});

},{"@swc/helpers/_/_object_spread":"awBF9","e6c023845ec8e836":"lXMxO","8921cc2fafd2191e":"dgecT","9d4ca7bf8b09c0ba":"esp3E","c759770490f68107":"lG3PO","1626b4c369c9848e":"6ZhvE","7d607e9dede9bbd7":"bIMEY","690df644bca08ce0":"aorXe","e8cbc2ae1b33bf31":"5n8qa","f16d20165e3cc81":"9GKTi"}],"lG3PO":[function(require,module,exports,__globalThis) {
"use strict";
const { default: Draggable, DraggableCore } = require("39b5312b4b7f8b31");
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = DraggableCore;

},{"39b5312b4b7f8b31":"4onoN"}],"4onoN":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return _DraggableCore.default;
    }
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f06ad358256d46ae"));
var _propTypes = _interopRequireDefault(require("9f8816d66633a995"));
var _reactDom = _interopRequireDefault(require("fd97d82c5bf54e9d"));
var _clsx = require("26060e24796bfa96");
var _domFns = require("4e40e768124450c6");
var _positionFns = require("6ac2262d9826d85d");
var _shims = require("2838a27078c4cbed");
var _DraggableCore = _interopRequireDefault(require("2ae804dc0d7f535c"));
var _log = _interopRequireDefault(require("6e73015298a24ef9"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class Draggable extends React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, _log.default)('Draggable: getDerivedStateFromProps %j', {
                position,
                prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: (0, _objectSpread._)({}, position)
            };
        }
        return null;
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        if (this.state.dragging) this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this_props_nodeRef, _this_props;
        var _this_props_nodeRef_current;
        return (_this_props_nodeRef_current = (_this_props = this.props) === null || _this_props === void 0 ? void 0 : (_this_props_nodeRef = _this_props.nodeRef) === null || _this_props_nodeRef === void 0 ? void 0 : _this_props_nodeRef.current) !== null && _this_props_nodeRef_current !== void 0 ? _this_props_nodeRef_current : _reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const _this_props = this.props, { axis, bounds, children, defaultPosition, defaultClassName, defaultClassNameDragging, defaultClassNameDragged, position, positionOffset, scale } = _this_props, draggableCoreProps = (0, _objectWithoutProperties._)(_this_props, [
            "axis",
            "bounds",
            "children",
            "defaultPosition",
            "defaultClassName",
            "defaultClassNameDragging",
            "defaultClassNameDragged",
            "position",
            "positionOffset",
            "scale"
        ]);
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, _domFns.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, _clsx.clsx)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ React.createElement(_DraggableCore.default, _extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ React.cloneElement(React.Children.only(children), {
            className: className,
            style: (0, _objectSpread._)({}, children.props.style, style),
            transform: svgTransform
        }));
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        _defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, _log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, _positionFns.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        _defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, _log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, _positionFns.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x, y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, _positionFns.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        _defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, _positionFns.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, _log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x, y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: (0, _objectSpread._)({}, props.position),
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
}
exports.default = Draggable;
_defineProperty(Draggable, "displayName", 'Draggable');
_defineProperty(Draggable, "propTypes", (0, _objectSpreadProps._)((0, _objectSpread._)({}, _DraggableCore.default.propTypes), {
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: _propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: _propTypes.default.oneOfType([
        _propTypes.default.shape({
            left: _propTypes.default.number,
            right: _propTypes.default.number,
            top: _propTypes.default.number,
            bottom: _propTypes.default.number
        }),
        _propTypes.default.string,
        _propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: _propTypes.default.string,
    defaultClassNameDragging: _propTypes.default.string,
    defaultClassNameDragged: _propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
    }),
    positionOffset: _propTypes.default.shape({
        x: _propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ]),
        y: _propTypes.default.oneOfType([
            _propTypes.default.number,
            _propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: _propTypes.default.shape({
        x: _propTypes.default.number,
        y: _propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
}));
_defineProperty(Draggable, "defaultProps", (0, _objectSpreadProps._)((0, _objectSpread._)({}, _DraggableCore.default.defaultProps), {
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
}));

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","f06ad358256d46ae":"lXMxO","9f8816d66633a995":"esp3E","fd97d82c5bf54e9d":"dgecT","26060e24796bfa96":"9GKTi","4e40e768124450c6":"6C7R9","6ac2262d9826d85d":"5S6ER","2838a27078c4cbed":"8DkBq","2ae804dc0d7f535c":"22KHY","6e73015298a24ef9":"9HTLp"}],"6C7R9":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addClassName = addClassName;
exports.addEvent = addEvent;
exports.addUserSelectStyles = addUserSelectStyles;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.getTranslation = getTranslation;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.offsetXYFromParent = offsetXYFromParent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.removeClassName = removeClassName;
exports.removeEvent = removeEvent;
exports.scheduleRemoveUserSelectStyles = scheduleRemoveUserSelectStyles;
var _shims = require("af60d0462ec484c0");
var _getPrefix = _interopRequireWildcard(require("25bee73a12bb5ee8"));
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!matchesSelectorFunc) matchesSelectorFunc = (0, _shims.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, _shims.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if (matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = (0, _objectSpread._)({
        capture: true
    }, inputOptions);
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = (0, _objectSpread._)({
        capture: true
    }, inputOptions);
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, _shims.int)(computedStyle.borderTopWidth);
    height += (0, _shims.int)(computedStyle.borderBottomWidth);
    return height;
}
function outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, _shims.int)(computedStyle.borderLeftWidth);
    width += (0, _shims.int)(computedStyle.borderRightWidth);
    return width;
}
function innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, _shims.int)(computedStyle.paddingTop);
    height -= (0, _shims.int)(computedStyle.paddingBottom);
    return height;
}
function innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, _shims.int)(computedStyle.paddingLeft);
    width -= (0, _shims.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x,
        y
    };
}
function createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, _getPrefix.browserPrefixToKey)('transform', _getPrefix.default)]: translation
    };
}
function createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = getTranslation(controlPos, positionOffset, '');
    return translation;
}
function getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x, y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = `translate(${x}${unitSuffix},${y}${unitSuffix})`;
    if (positionOffset) {
        const defaultX = `${typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix}`;
        const defaultY = `${typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix}`;
        translation = `translate(${defaultX}, ${defaultY})` + translation;
    }
    return translation;
}
function getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}
function scheduleRemoveUserSelectStyles(doc /*: ?Document*/ ) {
    // Prevent a possible "forced reflow"
    if (window.requestAnimationFrame) window.requestAnimationFrame(()=>{
        removeUserSelectStyles(doc);
    });
    else removeUserSelectStyles(doc);
}
function removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp(`(?:^|\\s)${className}(?!\\S)`))) el.className += ` ${className}`;
}
function removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp(`(?:^|\\s)${className}(?!\\S)`, 'g'), '');
}

},{"@swc/helpers/_/_object_spread":"awBF9","af60d0462ec484c0":"8DkBq","25bee73a12bb5ee8":"bXXfr"}],"8DkBq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dontSetMe = dontSetMe;
exports.findInArray = findInArray;
exports.int = int;
exports.isFunction = isFunction;
exports.isNum = isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error(`Invalid prop ${propName} passed to ${componentName} - do not set this, set it on the child.`);
}

},{}],"bXXfr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
exports.default = void 0;
exports.getPrefix = getPrefix;
const prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function getPrefix() /*: string*/ {
    var _window_document_documentElement, _window_document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window_document = window.document) === null || _window_document === void 0 ? void 0 : (_window_document_documentElement = _window_document.documentElement) === null || _window_document_documentElement === void 0 ? void 0 : _window_document_documentElement.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < prefixes.length; i++){
        if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
    }
    return '';
}
function browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `${prefix}${kebabToTitleCase(prop)}` : prop;
}
function browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? `-${prefix.toLowerCase()}-${prop}` : prop;
}
function kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var _default = exports.default = getPrefix();

},{}],"5S6ER":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;
exports.getBoundPosition = getBoundPosition;
exports.getControlPosition = getControlPosition;
exports.snapToGrid = snapToGrid;
var _shims = require("44bb88b39f2262ab");
var _domFns = require("6d8383fdeb613c7c");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
    const node = findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else {
            // Flow assigns the wrong return type (Node) for getRootNode(),
            // so we cast it to one of the correct types (Element).
            // The others are Document and ShadowRoot.
            // All three implement querySelector() so it's safe to call.
            const rootNode = node.getRootNode();
            boundNode = rootNode.querySelector(bounds);
        }
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
            right: (0, _domFns.innerWidth)(boundNodeEl) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
            bottom: (0, _domFns.innerHeight)(boundNodeEl) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, _shims.isNum)(draggable.lastX);
    const node = findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x,
        y
    };
    else // Otherwise calculate proper values.
    return {
        node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x,
        y
    };
}
// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

},{"44bb88b39f2262ab":"8DkBq","6d8383fdeb613c7c":"6C7R9"}],"22KHY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d830172ba8d01674"));
var _propTypes = _interopRequireDefault(require("936051a0e8f63cef"));
var _reactDom = _interopRequireDefault(require("51e89cac1fd8612a"));
var _domFns = require("a60a19bd70f37cbe");
var _positionFns = require("32cd453cf02f7977");
var _shims = require("b3ef123d6f743aa4");
var _log = _interopRequireDefault(require("71bc142b940fef0c"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let dragEventFor = eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  allowMobileScroll: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class DraggableCore extends React.Component /*:: <DraggableCoreProps>*/  {
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, _domFns.addEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument } = thisNode;
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
            (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
            (0, _domFns.removeEvent)(thisNode, eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, _domFns.scheduleRemoveUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this_props, _this_props_nodeRef, _this_props1;
        return ((_this_props = this.props) === null || _this_props === void 0 ? void 0 : _this_props.nodeRef) ? (_this_props1 = this.props) === null || _this_props1 === void 0 ? void 0 : (_this_props_nodeRef = _this_props1.nodeRef) === null || _this_props_nodeRef === void 0 ? void 0 : _this_props_nodeRef.current : _reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ React.cloneElement(React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
    constructor(){
        super(...arguments);
        _defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        _defineProperty(this, "lastX", NaN);
        _defineProperty(this, "lastY", NaN);
        _defineProperty(this, "touchIdentifier", null);
        _defineProperty(this, "mounted", false);
        _defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart' && !this.props.allowMobileScroll) e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, _positionFns.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x, y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
            (0, _log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, _log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, this.handleDrag);
            (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, this.handleDragStop);
        });
        _defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x, y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
            (0, _log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        _defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, _positionFns.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x, y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, _positionFns.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, _positionFns.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, _domFns.scheduleRemoveUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, _log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, _log.default)('DraggableCore: Removing handlers');
                (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, this.handleDrag);
                (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, this.handleDragStop);
            }
        });
        _defineProperty(this, "onMouseDown", (e)=>{
            dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        _defineProperty(this, "onMouseUp", (e)=>{
            dragEventFor = eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        _defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            dragEventFor = eventsFor.touch;
            return this.handleDragStart(e);
        });
        _defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            dragEventFor = eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
}
exports.default = DraggableCore;
_defineProperty(DraggableCore, "displayName", 'DraggableCore');
_defineProperty(DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: _propTypes.default.bool,
    /**
   * `allowMobileScroll` turns off cancellation of the 'touchstart' event
   * on mobile devices. Only enable this if you are having trouble with click
   * events. Prefer using 'handle' / 'cancel' instead.
   *
   * Defaults to `false`.
   */ allowMobileScroll: _propTypes.default.bool,
    children: _propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: _propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: _propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: _propTypes.default.arrayOf(_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: _propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: _propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: _propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: _propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: _propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: _propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: _propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: _propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: _shims.dontSetMe,
    style: _shims.dontSetMe,
    transform: _shims.dontSetMe
});
_defineProperty(DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    allowMobileScroll: false,
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

},{"d830172ba8d01674":"lXMxO","936051a0e8f63cef":"esp3E","51e89cac1fd8612a":"dgecT","a60a19bd70f37cbe":"6C7R9","32cd453cf02f7977":"5S6ER","b3ef123d6f743aa4":"8DkBq","71bc142b940fef0c":"9HTLp"}],"9HTLp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
/*eslint no-console:0*/ function log() {}

},{}],"6ZhvE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
module.exports.Resizable = require("b0fa7aaa97d8ef04").default;
module.exports.ResizableBox = require("3d6fd9d31ed5b9c8").default;

},{"b0fa7aaa97d8ef04":"6pxaS","3d6fd9d31ed5b9c8":"bQeIi"}],"6pxaS":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("3cbdee721f241241"));
var _reactDraggable = require("e9f39e09282da14c");
var _utils = require("fd058e0f9ce7dc70");
var _propTypes = require("aec0c8dfc1b80a4f");
var _excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var Resizable = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    };
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === 'onResizeStart') _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === 'both' || _this2.props.axis === 'x') && axis !== 'n' && axis !== 's';
            var canDragY = (_this2.props.axis === 'both' || _this2.props.axis === 'y') && axis !== 'e' && axis !== 'w';
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === 'w') {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === 'n') {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === 'w') deltaX = -deltaX;
            if (axisV === 'n') deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === 'function' ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === 'onResize' && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === 'onResizeStop') _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === 'function') return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === 'string';
        var props = _objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = _objectWithoutPropertiesLoose(_this$props2, _excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, _utils.cloneElement)(children, _objectSpread(_objectSpread({}, p), {}, {
            className: (className ? className + " " : '') + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ React.createRef();
                return /*#__PURE__*/ React.createElement(_reactDraggable.DraggableCore, _extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler('onResizeStop', handleAxis),
                    onStart: _this3.resizeHandler('onResizeStart', handleAxis),
                    onDrag: _this3.resizeHandler('onResize', handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}(React.Component);
exports.default = Resizable;
Resizable.propTypes = _propTypes.resizableProps;
Resizable.defaultProps = {
    axis: 'both',
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        'se'
    ],
    transformScale: 1
};

},{"3cbdee721f241241":"lXMxO","e9f39e09282da14c":"lG3PO","fd058e0f9ce7dc70":"7z47r","aec0c8dfc1b80a4f":"jo3LX"}],"7z47r":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.cloneElement = cloneElement;
var _react = _interopRequireDefault(require("afa18fb69f62be75"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function cloneElement(element, props) {
    if (props.style && element.props.style) props.style = _objectSpread(_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ _react.default.cloneElement(element, props);
}

},{"afa18fb69f62be75":"lXMxO"}],"jo3LX":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.resizableProps = void 0;
var _propTypes = _interopRequireDefault(require("40a30ea6afe62634"));
var _reactDraggable = require("5e54b5c5bc137992");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: _propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    className: _propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: _propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: _propTypes.default.shape({
        allowAnyClick: _propTypes.default.bool,
        cancel: _propTypes.default.string,
        children: _propTypes.default.node,
        disabled: _propTypes.default.bool,
        enableUserSelectHack: _propTypes.default.bool,
        offsetParent: _propTypes.default.node,
        grid: _propTypes.default.arrayOf(_propTypes.default.number),
        handle: _propTypes.default.string,
        nodeRef: _propTypes.default.object,
        onStart: _propTypes.default.func,
        onDrag: _propTypes.default.func,
        onStop: _propTypes.default.func,
        onMouseDown: _propTypes.default.func,
        scale: _propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === 'both' || props.axis === 'y') {
            var _PropTypes$number;
            return (_PropTypes$number = _propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return _propTypes.default.number.apply(_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: _propTypes.default.oneOfType([
        _propTypes.default.node,
        _propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: _propTypes.default.arrayOf(_propTypes.default.number),
    lockAspectRatio: _propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: _propTypes.default.arrayOf(_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: _propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: _propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: _propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: _propTypes.default.arrayOf(_propTypes.default.oneOf([
        's',
        'w',
        'e',
        'n',
        'sw',
        'nw',
        'se',
        'ne'
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: _propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === 'both' || props.axis === 'x') {
            var _PropTypes$number2;
            return (_PropTypes$number2 = _propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return _propTypes.default.number.apply(_propTypes.default, args);
    }
};
exports.resizableProps = resizableProps;

},{"40a30ea6afe62634":"esp3E","5e54b5c5bc137992":"lG3PO"}],"bQeIi":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("732ff3f6b965ac42"));
var _propTypes = _interopRequireDefault(require("ac46386b62a76a93"));
var _Resizable = _interopRequireDefault(require("cb18bf27b4a8b12"));
var _propTypes2 = require("3d4c280e5b389282");
var _excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var ResizableBox = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = _objectWithoutPropertiesLoose(_this$props, _excluded);
        return /*#__PURE__*/ React.createElement(_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ React.createElement("div", _extends({}, props, {
            style: _objectSpread(_objectSpread({}, style), {}, {
                width: this.state.width + 'px',
                height: this.state.height + 'px'
            })
        })));
    };
    return ResizableBox;
}(React.Component);
exports.default = ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
ResizableBox.propTypes = _objectSpread(_objectSpread({}, _propTypes2.resizableProps), {}, {
    children: _propTypes.default.element
});

},{"732ff3f6b965ac42":"lXMxO","ac46386b62a76a93":"esp3E","cb18bf27b4a8b12":"6pxaS","3d4c280e5b389282":"jo3LX"}],"5n8qa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resizeHandleType = exports.resizeHandleAxesType = exports.default = void 0;
var _propTypes = _interopRequireDefault(require("541a8d56a0c85011"));
var _react = _interopRequireDefault(require("90303995d3461de8"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/*:: import type {
  Ref,
  ChildrenArray as ReactChildrenArray,
  Element as ReactElement
} from "react";*/ /*:: import type {
  DragOverEvent,
  EventCallback,
  CompactType,
  Layout,
  LayoutItem,
  ResizeHandleAxis
} from "./utils";*/ /*:: export type ReactRef<T: HTMLElement> = {|
  +current: T | null
|};*/ // util
/*:: export type ResizeHandle =
  | ReactElement<any>
  | ((
      resizeHandleAxis: ResizeHandleAxis,
      ref: ReactRef<HTMLElement>
    ) => ReactElement<any>);*/ // Defines which resize handles should be rendered (default: 'se')
// Allows for any combination of:
// 's' - South handle (bottom-center)
// 'w' - West handle (left-center)
// 'e' - East handle (right-center)
// 'n' - North handle (top-center)
// 'sw' - Southwest handle (bottom-left)
// 'nw' - Northwest handle (top-left)
// 'se' - Southeast handle (bottom-right)
// 'ne' - Northeast handle (top-right)
const resizeHandleAxesType /*: ReactPropsChainableTypeChecker*/  = exports.resizeHandleAxesType = _propTypes.default.arrayOf(_propTypes.default.oneOf([
    "s",
    "w",
    "e",
    "n",
    "sw",
    "nw",
    "se",
    "ne"
]));
// Custom component for resize handles
const resizeHandleType /*: ReactPropsChainableTypeChecker*/  = exports.resizeHandleType = _propTypes.default.oneOfType([
    _propTypes.default.node,
    _propTypes.default.func
]);
/*:: export type Props = {|
  className: string,
  style: Object,
  width: number,
  autoSize: boolean,
  cols: number,
  draggableCancel: string,
  draggableHandle: string,
  verticalCompact: boolean,
  compactType: CompactType,
  layout: Layout,
  margin: [number, number],
  containerPadding: ?[number, number],
  rowHeight: number,
  maxRows: number,
  isBounded: boolean,
  isDraggable: boolean,
  isResizable: boolean,
  isDroppable: boolean,
  preventCollision: boolean,
  useCSSTransforms: boolean,
  transformScale: number,
  droppingItem: $Shape<LayoutItem>,
  resizeHandles: ResizeHandleAxis[],
  resizeHandle?: ResizeHandle,
  allowOverlap: boolean,

  // Callbacks
  onLayoutChange: Layout => void,
  onDrag: EventCallback,
  onDragStart: EventCallback,
  onDragStop: EventCallback,
  onResize: EventCallback,
  onResizeStart: EventCallback,
  onResizeStop: EventCallback,
  onDropDragOver: (e: DragOverEvent) => ?({| w?: number, h?: number |} | false),
  onDrop: (layout: Layout, item: ?LayoutItem, e: Event) => void,
  children: ReactChildrenArray<ReactElement<any>>,
  innerRef?: Ref<"div">
|};*/ /*:: export type DefaultProps = $Diff<
  Props,
  {
    children: ReactChildrenArray<ReactElement<any>>,
    width: number
  }
>;*/ var _default = exports.default = {
    //
    // Basic props
    //
    className: _propTypes.default.string,
    style: _propTypes.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: _propTypes.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: _propTypes.default.bool,
    // # of cols.
    cols: _propTypes.default.number,
    // A selector that will not be draggable.
    draggableCancel: _propTypes.default.string,
    // A selector for the draggable handler
    draggableHandle: _propTypes.default.string,
    // Deprecated
    verticalCompact: function(props /*: Props*/ ) {
        props.verticalCompact;
    },
    // Choose vertical or hotizontal compaction
    compactType: _propTypes.default.oneOf([
        "vertical",
        "horizontal"
    ]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(props /*: Props*/ ) {
        var layout = props.layout;
        // I hope you're setting the data-grid property on the grid items
        if (layout === undefined) return;
        require("90e010a11fe8429").validateLayout(layout, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: _propTypes.default.arrayOf(_propTypes.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: _propTypes.default.arrayOf(_propTypes.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: _propTypes.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: _propTypes.default.number,
    //
    // Flags
    //
    isBounded: _propTypes.default.bool,
    isDraggable: _propTypes.default.bool,
    isResizable: _propTypes.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: _propTypes.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: _propTypes.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: _propTypes.default.bool,
    // parent layout transform scale
    transformScale: _propTypes.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: _propTypes.default.bool,
    // Resize handle options
    resizeHandles: resizeHandleAxesType,
    resizeHandle: resizeHandleType,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: _propTypes.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: _propTypes.default.func,
    // Calls on each drag movement.
    onDrag: _propTypes.default.func,
    // Calls when drag is complete.
    onDragStop: _propTypes.default.func,
    //Calls when resize starts.
    onResizeStart: _propTypes.default.func,
    // Calls when resize movement happens.
    onResize: _propTypes.default.func,
    // Calls when resize is complete.
    onResizeStop: _propTypes.default.func,
    // Calls when some element is dropped.
    onDrop: _propTypes.default.func,
    //
    // Other validations
    //
    droppingItem: _propTypes.default.shape({
        i: _propTypes.default.string.isRequired,
        w: _propTypes.default.number.isRequired,
        h: _propTypes.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(props /*: Props*/ , propName /*: string*/ ) {
        const children = props[propName];
        // Check children keys for duplicates. Throw if found.
        const keys = {};
        _react.default.Children.forEach(children, function(child) {
            if ((child === null || child === void 0 ? void 0 : child.key) == null) return;
            if (keys[child.key]) throw new Error('Duplicate child key "' + child.key + '" found! This will cause problems in ReactGridLayout.');
            keys[child.key] = true;
        });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: _propTypes.default.any
};

},{"541a8d56a0c85011":"esp3E","90303995d3461de8":"lXMxO","90e010a11fe8429":"bIMEY"}],"8Tx1h":[function(require,module,exports,__globalThis) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("c62eb11db86f83d7"));
var _propTypes = _interopRequireDefault(require("6f7e566320038446"));
var _fastEquals = require("ed4138aabbf0d6e5");
var _utils = require("db2321e68f3438af");
var _responsiveUtils = require("71b865f319bbc8a9");
var _ReactGridLayout = _interopRequireDefault(require("b9efa97f3d60f705"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
} /*:: import { type Layout, type Pick } from "./utils";*/  /*:: import { type ResponsiveLayout, type OnLayoutChangeCallback, type Breakpoints } from "./responsiveUtils";*/ 
// $FlowFixMe[method-unbinding]
const type = (obj)=>Object.prototype.toString.call(obj);
/**
 * Get a value of margin or containerPadding.
 *
 * @param  {Array | Object} param Margin | containerPadding, e.g. [10, 10] | {lg: [10, 10], ...}.
 * @param  {String} breakpoint   Breakpoint: lg, md, sm, xs and etc.
 * @return {Array}
 */ function getIndentationValue(param /*: { [key: string]: T } | T*/ , breakpoint /*: string*/ ) /*: T*/ {
    // $FlowIgnore TODO fix this typedef
    if (param == null) return null;
    // $FlowIgnore TODO fix this typedef
    return Array.isArray(param) ? param : param[breakpoint];
}
/*:: type State = {
  layout: Layout,
  breakpoint: string,
  cols: number,
  layouts?: ResponsiveLayout<string>
};*/ /*:: type Props<Breakpoint: string = string> = {|
  ...React.ElementConfig<typeof ReactGridLayout>,

  // Responsive config
  breakpoint?: ?Breakpoint,
  breakpoints: Breakpoints<Breakpoint>,
  cols: { [key: Breakpoint]: number },
  layouts: ResponsiveLayout<Breakpoint>,
  width: number,
  margin: { [key: Breakpoint]: [number, number] } | [number, number],
  /* prettier-ignore *-/
  containerPadding: { [key: Breakpoint]: ?[number, number] } | ?[number, number],

  // Callbacks
  onBreakpointChange: (Breakpoint, cols: number) => void,
  onLayoutChange: OnLayoutChangeCallback,
  onWidthChange: (
    containerWidth: number,
    margin: [number, number],
    cols: number,
    containerPadding: ?[number, number]
  ) => void
|};*/ /*:: type DefaultProps = Pick<
  Props<>,
  {|
    allowOverlap: 0,
    breakpoints: 0,
    cols: 0,
    containerPadding: 0,
    layouts: 0,
    margin: 0,
    onBreakpointChange: 0,
    onLayoutChange: 0,
    onWidthChange: 0
  |}
>;*/ class ResponsiveReactGridLayout extends React.Component {
    generateInitialState() /*: State*/ {
        const { width, breakpoints, layouts, cols } = this.props;
        const breakpoint = (0, _responsiveUtils.getBreakpointFromWidth)(breakpoints, width);
        const colNo = (0, _responsiveUtils.getColsFromBreakpoint)(breakpoint, cols);
        // verticalCompact compatibility, now deprecated
        const compactType = this.props.verticalCompact === false ? null : this.props.compactType;
        // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
        // for this layout.
        const initialLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(layouts, breakpoints, breakpoint, breakpoint, colNo, compactType);
        return {
            layout: initialLayout,
            breakpoint: breakpoint,
            cols: colNo
        };
    }
    static getDerivedStateFromProps(nextProps /*: Props<*>*/ , prevState /*: State*/ ) /*: ?$Shape<State>*/ {
        if (!(0, _fastEquals.deepEqual)(nextProps.layouts, prevState.layouts)) {
            // Allow parent to set layouts directly.
            const { breakpoint, cols } = prevState;
            // Since we're setting an entirely new layout object, we must generate a new responsive layout
            // if one does not exist.
            const newLayout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(nextProps.layouts, nextProps.breakpoints, breakpoint, breakpoint, cols, nextProps.compactType);
            return {
                layout: newLayout,
                layouts: nextProps.layouts
            };
        }
        return null;
    }
    componentDidUpdate(prevProps /*: Props<*>*/ ) {
        // Allow parent to set width or breakpoint directly.
        if (this.props.width != prevProps.width || this.props.breakpoint !== prevProps.breakpoint || !(0, _fastEquals.deepEqual)(this.props.breakpoints, prevProps.breakpoints) || !(0, _fastEquals.deepEqual)(this.props.cols, prevProps.cols)) this.onWidthChange(prevProps);
    }
    /**
   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
   * Width changes are necessary to figure out the widget widths.
   */ onWidthChange(prevProps /*: Props<*>*/ ) {
        const { breakpoints, cols, layouts, compactType } = this.props;
        const newBreakpoint = this.props.breakpoint || (0, _responsiveUtils.getBreakpointFromWidth)(this.props.breakpoints, this.props.width);
        const lastBreakpoint = this.state.breakpoint;
        const newCols /*: number*/  = (0, _responsiveUtils.getColsFromBreakpoint)(newBreakpoint, cols);
        const newLayouts = (0, _objectSpread._)({}, layouts);
        // Breakpoint change
        if (lastBreakpoint !== newBreakpoint || prevProps.breakpoints !== breakpoints || prevProps.cols !== cols) {
            // Preserve the current layout if the current breakpoint is not present in the next layouts.
            if (!(lastBreakpoint in newLayouts)) newLayouts[lastBreakpoint] = (0, _utils.cloneLayout)(this.state.layout);
            // Find or generate a new layout.
            let layout = (0, _responsiveUtils.findOrGenerateResponsiveLayout)(newLayouts, breakpoints, newBreakpoint, lastBreakpoint, newCols, compactType);
            // This adds missing items.
            layout = (0, _utils.synchronizeLayoutWithChildren)(layout, this.props.children, newCols, compactType, this.props.allowOverlap);
            // Store the new layout.
            newLayouts[newBreakpoint] = layout;
            // callbacks
            this.props.onBreakpointChange(newBreakpoint, newCols);
            this.props.onLayoutChange(layout, newLayouts);
            this.setState({
                breakpoint: newBreakpoint,
                layout: layout,
                cols: newCols
            });
        }
        const margin = getIndentationValue(this.props.margin, newBreakpoint);
        const containerPadding = getIndentationValue(this.props.containerPadding, newBreakpoint);
        //call onWidthChange on every change of width, not only on breakpoint changes
        this.props.onWidthChange(this.props.width, margin, newCols, containerPadding);
    }
    render() /*: React.Element<typeof ReactGridLayout>*/ {
        /* eslint-disable no-unused-vars */ const _this_props = this.props, { breakpoint, breakpoints, cols, layouts, margin, containerPadding, onBreakpointChange, onLayoutChange, onWidthChange } = _this_props, other = (0, _objectWithoutProperties._)(_this_props, [
            "breakpoint",
            "breakpoints",
            "cols",
            "layouts",
            "margin",
            "containerPadding",
            "onBreakpointChange",
            "onLayoutChange",
            "onWidthChange"
        ]);
        /* eslint-enable no-unused-vars */ return /*#__PURE__*/ React.createElement(_ReactGridLayout.default, _extends({}, other, {
            // $FlowIgnore should allow nullable here due to DefaultProps
            margin: getIndentationValue(margin, this.state.breakpoint),
            containerPadding: getIndentationValue(containerPadding, this.state.breakpoint),
            onLayoutChange: this.onLayoutChange,
            layout: this.state.layout,
            cols: this.state.cols
        }));
    }
    constructor(){
        super(...arguments);
        _defineProperty(this, "state", this.generateInitialState());
        // wrap layouts so we do not need to pass layouts to child
        _defineProperty(this, "onLayoutChange", (layout /*: Layout*/ )=>{
            this.props.onLayoutChange(layout, (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.props.layouts), {
                [this.state.breakpoint]: layout
            }));
        });
    }
}
exports.default = ResponsiveReactGridLayout;
// This should only include propTypes needed in this code; RGL itself
// will do validation of the rest props passed to it.
_defineProperty(ResponsiveReactGridLayout, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: _propTypes.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: _propTypes.default.object,
    allowOverlap: _propTypes.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: _propTypes.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: _propTypes.default.oneOfType([
        _propTypes.default.array,
        _propTypes.default.object
    ]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: _propTypes.default.oneOfType([
        _propTypes.default.array,
        _propTypes.default.object
    ]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts (props /*: Props<>*/ , propName /*: string*/ ) {
        if (type(props[propName]) !== "[object Object]") throw new Error("Layout property must be an object. Received: " + type(props[propName]));
        Object.keys(props[propName]).forEach((key)=>{
            if (!(key in props.breakpoints)) throw new Error("Each key in layouts must align with a key in breakpoints.");
            (0, _utils.validateLayout)(props.layouts[key], "layouts." + key);
        });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: _propTypes.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: _propTypes.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: _propTypes.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: _propTypes.default.func
});
_defineProperty(ResponsiveReactGridLayout, "defaultProps", {
    breakpoints: {
        lg: 1200,
        md: 996,
        sm: 768,
        xs: 480,
        xxs: 0
    },
    cols: {
        lg: 12,
        md: 10,
        sm: 6,
        xs: 4,
        xxs: 2
    },
    containerPadding: {
        lg: null,
        md: null,
        sm: null,
        xs: null,
        xxs: null
    },
    layouts: {},
    margin: [
        10,
        10
    ],
    allowOverlap: false,
    onBreakpointChange: _utils.noop,
    onLayoutChange: _utils.noop,
    onWidthChange: _utils.noop
});

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","c62eb11db86f83d7":"lXMxO","6f7e566320038446":"esp3E","ed4138aabbf0d6e5":"4BLH0","db2321e68f3438af":"bIMEY","71b865f319bbc8a9":"5yHOz","b9efa97f3d60f705":"i3q1Z"}],"5yHOz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findOrGenerateResponsiveLayout = findOrGenerateResponsiveLayout;
exports.getBreakpointFromWidth = getBreakpointFromWidth;
exports.getColsFromBreakpoint = getColsFromBreakpoint;
exports.sortBreakpoints = sortBreakpoints;
var _utils = require("f14931bd44e22b3");
/*:: import type { CompactType, Layout } from "./utils";*/ /*:: export type Breakpoint = string;*/ /*:: export type DefaultBreakpoints = "lg" | "md" | "sm" | "xs" | "xxs";*/ /*:: export type ResponsiveLayout<T: Breakpoint> = {
  +[breakpoint: T]: Layout
};*/ // + indicates read-only
/*:: export type Breakpoints<T: Breakpoint> = {
  +[breakpoint: T]: number
};*/ /*:: export type OnLayoutChangeCallback = (
  Layout,
  { [key: Breakpoint]: Layout }
) => void;*/ /**
 * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
 *
 * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
 * @param  {Number} width Screen width.
 * @return {String}       Highest breakpoint that is less than width.
 */ function getBreakpointFromWidth(breakpoints /*: Breakpoints<Breakpoint>*/ , width /*: number*/ ) /*: Breakpoint*/ {
    const sorted = sortBreakpoints(breakpoints);
    let matching = sorted[0];
    for(let i = 1, len = sorted.length; i < len; i++){
        const breakpointName = sorted[i];
        if (width > breakpoints[breakpointName]) matching = breakpointName;
    }
    return matching;
}
/**
 * Given a breakpoint, get the # of cols set for it.
 * @param  {String} breakpoint Breakpoint name.
 * @param  {Object} cols       Map of breakpoints to cols.
 * @return {Number}            Number of cols.
 */ function getColsFromBreakpoint(breakpoint /*: Breakpoint*/ , cols /*: Breakpoints<Breakpoint>*/ ) /*: number*/ {
    if (!cols[breakpoint]) throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
    return cols[breakpoint];
}
/**
 * Given existing layouts and a new breakpoint, find or generate a new layout.
 *
 * This finds the layout above the new one and generates from it, if it exists.
 *
 * @param  {Object} layouts     Existing layouts.
 * @param  {Array} breakpoints All breakpoints.
 * @param  {String} breakpoint New breakpoint.
 * @param  {String} breakpoint Last breakpoint (for fallback).
 * @param  {Number} cols       Column count at new breakpoint.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}             New layout.
 */ function findOrGenerateResponsiveLayout(layouts /*: ResponsiveLayout<Breakpoint>*/ , breakpoints /*: Breakpoints<Breakpoint>*/ , breakpoint /*: Breakpoint*/ , lastBreakpoint /*: Breakpoint*/ , cols /*: number*/ , compactType /*: CompactType*/ ) /*: Layout*/ {
    // If it already exists, just return it.
    if (layouts[breakpoint]) return (0, _utils.cloneLayout)(layouts[breakpoint]);
    // Find or generate the next layout
    let layout = layouts[lastBreakpoint];
    const breakpointsSorted = sortBreakpoints(breakpoints);
    const breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
    for(let i = 0, len = breakpointsAbove.length; i < len; i++){
        const b = breakpointsAbove[i];
        if (layouts[b]) {
            layout = layouts[b];
            break;
        }
    }
    layout = (0, _utils.cloneLayout)(layout || []); // clone layout so we don't modify existing items
    return (0, _utils.compact)((0, _utils.correctBounds)(layout, {
        cols: cols
    }), compactType, cols);
}
/**
 * Given breakpoints, return an array of breakpoints sorted by width. This is usually
 * e.g. ['xxs', 'xs', 'sm', ...]
 *
 * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
 * @return {Array}              Sorted breakpoints.
 */ function sortBreakpoints(breakpoints /*: Breakpoints<Breakpoint>*/ ) /*: Array<Breakpoint>*/ {
    const keys /*: Array<string>*/  = Object.keys(breakpoints);
    return keys.sort(function(a, b) {
        return breakpoints[a] - breakpoints[b];
    });
}

},{"f14931bd44e22b3":"bIMEY"}],"keTKy":[function(require,module,exports,__globalThis) {
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = WidthProvideRGL;
var React = _interopRequireWildcard(require("c94a10d52a7721d7"));
var _propTypes = _interopRequireDefault(require("8e644f2a56dcf21f"));
var _resizeObserverPolyfill = _interopRequireDefault(require("cb1b9085aecb48d5"));
var _clsx = _interopRequireDefault(require("c7463e11bcf1c801"));
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/*:: import type { ReactRef } from "../ReactGridLayoutPropTypes";*/ /*:: type WPDefaultProps = {|
  measureBeforeMount: boolean
|};*/ /*:: type WPProps = {|
  className?: string,
  style?: Object,
  ...WPDefaultProps
|};*/ // eslint-disable-next-line no-unused-vars
/*:: type WPState = {|
  width: number
|};*/ /*:: type ComposedProps<Config> = {|
  ...Config,
  measureBeforeMount?: boolean,
  className?: string,
  style?: Object,
  width?: number
|};*/ const layoutClassName = "react-grid-layout";
/*
 * A simple HOC that provides facility for listening to container resizes.
 *
 * The Flow type is pretty janky here. I can't just spread `WPProps` into this returned object - I wish I could - but it triggers
 * a flow bug of some sort that causes it to stop typechecking.
 */ function WidthProvideRGL(ComposedComponent /*: React.AbstractComponent<Config>*/ ) /*: React.AbstractComponent<ComposedProps<Config>>*/ {
    var _WidthProvider;
    return _WidthProvider = class WidthProvider extends React.Component {
        componentDidMount() {
            this.mounted = true;
            this.resizeObserver = new _resizeObserverPolyfill.default((entries)=>{
                const node = this.elementRef.current;
                if (node instanceof HTMLElement) {
                    const width = entries[0].contentRect.width;
                    this.setState({
                        width
                    });
                }
            });
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.observe(node);
        }
        componentWillUnmount() {
            this.mounted = false;
            const node = this.elementRef.current;
            if (node instanceof HTMLElement) this.resizeObserver.unobserve(node);
            this.resizeObserver.disconnect();
        }
        render() {
            const _this_props = this.props, { measureBeforeMount } = _this_props, rest = (0, _objectWithoutProperties._)(_this_props, [
                "measureBeforeMount"
            ]);
            if (measureBeforeMount && !this.mounted) return /*#__PURE__*/ React.createElement("div", {
                className: (0, _clsx.default)(this.props.className, layoutClassName),
                style: this.props.style,
                ref: this.elementRef
            });
            return /*#__PURE__*/ React.createElement(ComposedComponent, _extends({
                innerRef: this.elementRef
            }, rest, this.state));
        }
        constructor(){
            super(...arguments);
            _defineProperty(this, "state", {
                width: 1280
            });
            _defineProperty(this, "elementRef", /*#__PURE__*/ React.createRef());
            _defineProperty(this, "mounted", false);
            _defineProperty(this, "resizeObserver", void 0);
        }
    }, _defineProperty(_WidthProvider, "defaultProps", {
        measureBeforeMount: false
    }), _defineProperty(_WidthProvider, "propTypes", {
        // If true, will not render children until mounted. Useful for getting the exact width before
        // rendering, to prevent any unsightly resizing.
        measureBeforeMount: _propTypes.default.bool
    }), _WidthProvider;
}

},{"@swc/helpers/_/_object_without_properties":"7R2qf","c94a10d52a7721d7":"lXMxO","8e644f2a56dcf21f":"esp3E","cb1b9085aecb48d5":"a2Mlo","c7463e11bcf1c801":"9GKTi"}],"a2Mlo":[function(require,module,exports,__globalThis) {
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var global$1 = function() {
    if (typeof global !== 'undefined' && global.Math === Math) return global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};
// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return emptyRect;
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function getContentRect(target) {
    if (!isBrowser) return emptyRect;
    if (isSVGGraphicsElement(target)) return getSVGContentRect(target);
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});
var index = function() {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') return global$1.ResizeObserver;
    return ResizeObserver;
}();
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"coJMT":[function() {},{}],"dcPAU":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AiFillAccountBook", ()=>AiFillAccountBook);
parcelHelpers.export(exports, "AiFillAlert", ()=>AiFillAlert);
parcelHelpers.export(exports, "AiFillAlipayCircle", ()=>AiFillAlipayCircle);
parcelHelpers.export(exports, "AiFillAlipaySquare", ()=>AiFillAlipaySquare);
parcelHelpers.export(exports, "AiFillAliwangwang", ()=>AiFillAliwangwang);
parcelHelpers.export(exports, "AiFillAmazonCircle", ()=>AiFillAmazonCircle);
parcelHelpers.export(exports, "AiFillAmazonSquare", ()=>AiFillAmazonSquare);
parcelHelpers.export(exports, "AiFillAndroid", ()=>AiFillAndroid);
parcelHelpers.export(exports, "AiFillApi", ()=>AiFillApi);
parcelHelpers.export(exports, "AiFillApple", ()=>AiFillApple);
parcelHelpers.export(exports, "AiFillAppstore", ()=>AiFillAppstore);
parcelHelpers.export(exports, "AiFillAudio", ()=>AiFillAudio);
parcelHelpers.export(exports, "AiFillBackward", ()=>AiFillBackward);
parcelHelpers.export(exports, "AiFillBank", ()=>AiFillBank);
parcelHelpers.export(exports, "AiFillBehanceCircle", ()=>AiFillBehanceCircle);
parcelHelpers.export(exports, "AiFillBehanceSquare", ()=>AiFillBehanceSquare);
parcelHelpers.export(exports, "AiFillBell", ()=>AiFillBell);
parcelHelpers.export(exports, "AiFillBook", ()=>AiFillBook);
parcelHelpers.export(exports, "AiFillBoxPlot", ()=>AiFillBoxPlot);
parcelHelpers.export(exports, "AiFillBug", ()=>AiFillBug);
parcelHelpers.export(exports, "AiFillBuild", ()=>AiFillBuild);
parcelHelpers.export(exports, "AiFillBulb", ()=>AiFillBulb);
parcelHelpers.export(exports, "AiFillCalculator", ()=>AiFillCalculator);
parcelHelpers.export(exports, "AiFillCalendar", ()=>AiFillCalendar);
parcelHelpers.export(exports, "AiFillCamera", ()=>AiFillCamera);
parcelHelpers.export(exports, "AiFillCar", ()=>AiFillCar);
parcelHelpers.export(exports, "AiFillCaretDown", ()=>AiFillCaretDown);
parcelHelpers.export(exports, "AiFillCaretLeft", ()=>AiFillCaretLeft);
parcelHelpers.export(exports, "AiFillCaretRight", ()=>AiFillCaretRight);
parcelHelpers.export(exports, "AiFillCaretUp", ()=>AiFillCaretUp);
parcelHelpers.export(exports, "AiFillCarryOut", ()=>AiFillCarryOut);
parcelHelpers.export(exports, "AiFillCheckCircle", ()=>AiFillCheckCircle);
parcelHelpers.export(exports, "AiFillCheckSquare", ()=>AiFillCheckSquare);
parcelHelpers.export(exports, "AiFillChrome", ()=>AiFillChrome);
parcelHelpers.export(exports, "AiFillCiCircle", ()=>AiFillCiCircle);
parcelHelpers.export(exports, "AiFillClockCircle", ()=>AiFillClockCircle);
parcelHelpers.export(exports, "AiFillCloseCircle", ()=>AiFillCloseCircle);
parcelHelpers.export(exports, "AiFillCloseSquare", ()=>AiFillCloseSquare);
parcelHelpers.export(exports, "AiFillCloud", ()=>AiFillCloud);
parcelHelpers.export(exports, "AiFillCodeSandboxCircle", ()=>AiFillCodeSandboxCircle);
parcelHelpers.export(exports, "AiFillCodeSandboxSquare", ()=>AiFillCodeSandboxSquare);
parcelHelpers.export(exports, "AiFillCode", ()=>AiFillCode);
parcelHelpers.export(exports, "AiFillCodepenCircle", ()=>AiFillCodepenCircle);
parcelHelpers.export(exports, "AiFillCodepenSquare", ()=>AiFillCodepenSquare);
parcelHelpers.export(exports, "AiFillCompass", ()=>AiFillCompass);
parcelHelpers.export(exports, "AiFillContacts", ()=>AiFillContacts);
parcelHelpers.export(exports, "AiFillContainer", ()=>AiFillContainer);
parcelHelpers.export(exports, "AiFillControl", ()=>AiFillControl);
parcelHelpers.export(exports, "AiFillCopy", ()=>AiFillCopy);
parcelHelpers.export(exports, "AiFillCopyrightCircle", ()=>AiFillCopyrightCircle);
parcelHelpers.export(exports, "AiFillCreditCard", ()=>AiFillCreditCard);
parcelHelpers.export(exports, "AiFillCrown", ()=>AiFillCrown);
parcelHelpers.export(exports, "AiFillCustomerService", ()=>AiFillCustomerService);
parcelHelpers.export(exports, "AiFillDashboard", ()=>AiFillDashboard);
parcelHelpers.export(exports, "AiFillDatabase", ()=>AiFillDatabase);
parcelHelpers.export(exports, "AiFillDelete", ()=>AiFillDelete);
parcelHelpers.export(exports, "AiFillDiff", ()=>AiFillDiff);
parcelHelpers.export(exports, "AiFillDingtalkCircle", ()=>AiFillDingtalkCircle);
parcelHelpers.export(exports, "AiFillDingtalkSquare", ()=>AiFillDingtalkSquare);
parcelHelpers.export(exports, "AiFillDislike", ()=>AiFillDislike);
parcelHelpers.export(exports, "AiFillDollarCircle", ()=>AiFillDollarCircle);
parcelHelpers.export(exports, "AiFillDownCircle", ()=>AiFillDownCircle);
parcelHelpers.export(exports, "AiFillDownSquare", ()=>AiFillDownSquare);
parcelHelpers.export(exports, "AiFillDribbbleCircle", ()=>AiFillDribbbleCircle);
parcelHelpers.export(exports, "AiFillDribbbleSquare", ()=>AiFillDribbbleSquare);
parcelHelpers.export(exports, "AiFillDropboxCircle", ()=>AiFillDropboxCircle);
parcelHelpers.export(exports, "AiFillDropboxSquare", ()=>AiFillDropboxSquare);
parcelHelpers.export(exports, "AiFillEdit", ()=>AiFillEdit);
parcelHelpers.export(exports, "AiFillEnvironment", ()=>AiFillEnvironment);
parcelHelpers.export(exports, "AiFillEuroCircle", ()=>AiFillEuroCircle);
parcelHelpers.export(exports, "AiFillExclamationCircle", ()=>AiFillExclamationCircle);
parcelHelpers.export(exports, "AiFillExperiment", ()=>AiFillExperiment);
parcelHelpers.export(exports, "AiFillEyeInvisible", ()=>AiFillEyeInvisible);
parcelHelpers.export(exports, "AiFillEye", ()=>AiFillEye);
parcelHelpers.export(exports, "AiFillFacebook", ()=>AiFillFacebook);
parcelHelpers.export(exports, "AiFillFastBackward", ()=>AiFillFastBackward);
parcelHelpers.export(exports, "AiFillFastForward", ()=>AiFillFastForward);
parcelHelpers.export(exports, "AiFillFileAdd", ()=>AiFillFileAdd);
parcelHelpers.export(exports, "AiFillFileExcel", ()=>AiFillFileExcel);
parcelHelpers.export(exports, "AiFillFileExclamation", ()=>AiFillFileExclamation);
parcelHelpers.export(exports, "AiFillFileImage", ()=>AiFillFileImage);
parcelHelpers.export(exports, "AiFillFileMarkdown", ()=>AiFillFileMarkdown);
parcelHelpers.export(exports, "AiFillFilePdf", ()=>AiFillFilePdf);
parcelHelpers.export(exports, "AiFillFilePpt", ()=>AiFillFilePpt);
parcelHelpers.export(exports, "AiFillFileText", ()=>AiFillFileText);
parcelHelpers.export(exports, "AiFillFileUnknown", ()=>AiFillFileUnknown);
parcelHelpers.export(exports, "AiFillFileWord", ()=>AiFillFileWord);
parcelHelpers.export(exports, "AiFillFileZip", ()=>AiFillFileZip);
parcelHelpers.export(exports, "AiFillFile", ()=>AiFillFile);
parcelHelpers.export(exports, "AiFillFilter", ()=>AiFillFilter);
parcelHelpers.export(exports, "AiFillFire", ()=>AiFillFire);
parcelHelpers.export(exports, "AiFillFlag", ()=>AiFillFlag);
parcelHelpers.export(exports, "AiFillFolderAdd", ()=>AiFillFolderAdd);
parcelHelpers.export(exports, "AiFillFolderOpen", ()=>AiFillFolderOpen);
parcelHelpers.export(exports, "AiFillFolder", ()=>AiFillFolder);
parcelHelpers.export(exports, "AiFillFormatPainter", ()=>AiFillFormatPainter);
parcelHelpers.export(exports, "AiFillForward", ()=>AiFillForward);
parcelHelpers.export(exports, "AiFillFrown", ()=>AiFillFrown);
parcelHelpers.export(exports, "AiFillFund", ()=>AiFillFund);
parcelHelpers.export(exports, "AiFillFunnelPlot", ()=>AiFillFunnelPlot);
parcelHelpers.export(exports, "AiFillGift", ()=>AiFillGift);
parcelHelpers.export(exports, "AiFillGithub", ()=>AiFillGithub);
parcelHelpers.export(exports, "AiFillGitlab", ()=>AiFillGitlab);
parcelHelpers.export(exports, "AiFillGold", ()=>AiFillGold);
parcelHelpers.export(exports, "AiFillGolden", ()=>AiFillGolden);
parcelHelpers.export(exports, "AiFillGoogleCircle", ()=>AiFillGoogleCircle);
parcelHelpers.export(exports, "AiFillGooglePlusCircle", ()=>AiFillGooglePlusCircle);
parcelHelpers.export(exports, "AiFillGooglePlusSquare", ()=>AiFillGooglePlusSquare);
parcelHelpers.export(exports, "AiFillGoogleSquare", ()=>AiFillGoogleSquare);
parcelHelpers.export(exports, "AiFillHdd", ()=>AiFillHdd);
parcelHelpers.export(exports, "AiFillHeart", ()=>AiFillHeart);
parcelHelpers.export(exports, "AiFillHighlight", ()=>AiFillHighlight);
parcelHelpers.export(exports, "AiFillHome", ()=>AiFillHome);
parcelHelpers.export(exports, "AiFillHourglass", ()=>AiFillHourglass);
parcelHelpers.export(exports, "AiFillHtml5", ()=>AiFillHtml5);
parcelHelpers.export(exports, "AiFillIdcard", ()=>AiFillIdcard);
parcelHelpers.export(exports, "AiFillIeCircle", ()=>AiFillIeCircle);
parcelHelpers.export(exports, "AiFillIeSquare", ()=>AiFillIeSquare);
parcelHelpers.export(exports, "AiFillInfoCircle", ()=>AiFillInfoCircle);
parcelHelpers.export(exports, "AiFillInstagram", ()=>AiFillInstagram);
parcelHelpers.export(exports, "AiFillInsurance", ()=>AiFillInsurance);
parcelHelpers.export(exports, "AiFillInteraction", ()=>AiFillInteraction);
parcelHelpers.export(exports, "AiFillLayout", ()=>AiFillLayout);
parcelHelpers.export(exports, "AiFillLeftCircle", ()=>AiFillLeftCircle);
parcelHelpers.export(exports, "AiFillLeftSquare", ()=>AiFillLeftSquare);
parcelHelpers.export(exports, "AiFillLike", ()=>AiFillLike);
parcelHelpers.export(exports, "AiFillLinkedin", ()=>AiFillLinkedin);
parcelHelpers.export(exports, "AiFillLock", ()=>AiFillLock);
parcelHelpers.export(exports, "AiFillMacCommand", ()=>AiFillMacCommand);
parcelHelpers.export(exports, "AiFillMail", ()=>AiFillMail);
parcelHelpers.export(exports, "AiFillMedicineBox", ()=>AiFillMedicineBox);
parcelHelpers.export(exports, "AiFillMediumCircle", ()=>AiFillMediumCircle);
parcelHelpers.export(exports, "AiFillMediumSquare", ()=>AiFillMediumSquare);
parcelHelpers.export(exports, "AiFillMeh", ()=>AiFillMeh);
parcelHelpers.export(exports, "AiFillMessage", ()=>AiFillMessage);
parcelHelpers.export(exports, "AiFillMinusCircle", ()=>AiFillMinusCircle);
parcelHelpers.export(exports, "AiFillMinusSquare", ()=>AiFillMinusSquare);
parcelHelpers.export(exports, "AiFillMobile", ()=>AiFillMobile);
parcelHelpers.export(exports, "AiFillMoneyCollect", ()=>AiFillMoneyCollect);
parcelHelpers.export(exports, "AiFillNotification", ()=>AiFillNotification);
parcelHelpers.export(exports, "AiFillPauseCircle", ()=>AiFillPauseCircle);
parcelHelpers.export(exports, "AiFillPayCircle", ()=>AiFillPayCircle);
parcelHelpers.export(exports, "AiFillPhone", ()=>AiFillPhone);
parcelHelpers.export(exports, "AiFillPicture", ()=>AiFillPicture);
parcelHelpers.export(exports, "AiFillPieChart", ()=>AiFillPieChart);
parcelHelpers.export(exports, "AiFillPlayCircle", ()=>AiFillPlayCircle);
parcelHelpers.export(exports, "AiFillPlaySquare", ()=>AiFillPlaySquare);
parcelHelpers.export(exports, "AiFillPlusCircle", ()=>AiFillPlusCircle);
parcelHelpers.export(exports, "AiFillPlusSquare", ()=>AiFillPlusSquare);
parcelHelpers.export(exports, "AiFillPoundCircle", ()=>AiFillPoundCircle);
parcelHelpers.export(exports, "AiFillPrinter", ()=>AiFillPrinter);
parcelHelpers.export(exports, "AiFillProfile", ()=>AiFillProfile);
parcelHelpers.export(exports, "AiFillProject", ()=>AiFillProject);
parcelHelpers.export(exports, "AiFillPropertySafety", ()=>AiFillPropertySafety);
parcelHelpers.export(exports, "AiFillPushpin", ()=>AiFillPushpin);
parcelHelpers.export(exports, "AiFillQqCircle", ()=>AiFillQqCircle);
parcelHelpers.export(exports, "AiFillQqSquare", ()=>AiFillQqSquare);
parcelHelpers.export(exports, "AiFillQuestionCircle", ()=>AiFillQuestionCircle);
parcelHelpers.export(exports, "AiFillRead", ()=>AiFillRead);
parcelHelpers.export(exports, "AiFillReconciliation", ()=>AiFillReconciliation);
parcelHelpers.export(exports, "AiFillRedEnvelope", ()=>AiFillRedEnvelope);
parcelHelpers.export(exports, "AiFillRedditCircle", ()=>AiFillRedditCircle);
parcelHelpers.export(exports, "AiFillRedditSquare", ()=>AiFillRedditSquare);
parcelHelpers.export(exports, "AiFillRest", ()=>AiFillRest);
parcelHelpers.export(exports, "AiFillRightCircle", ()=>AiFillRightCircle);
parcelHelpers.export(exports, "AiFillRightSquare", ()=>AiFillRightSquare);
parcelHelpers.export(exports, "AiFillRobot", ()=>AiFillRobot);
parcelHelpers.export(exports, "AiFillRocket", ()=>AiFillRocket);
parcelHelpers.export(exports, "AiFillSafetyCertificate", ()=>AiFillSafetyCertificate);
parcelHelpers.export(exports, "AiFillSave", ()=>AiFillSave);
parcelHelpers.export(exports, "AiFillSchedule", ()=>AiFillSchedule);
parcelHelpers.export(exports, "AiFillSecurityScan", ()=>AiFillSecurityScan);
parcelHelpers.export(exports, "AiFillSetting", ()=>AiFillSetting);
parcelHelpers.export(exports, "AiFillShop", ()=>AiFillShop);
parcelHelpers.export(exports, "AiFillShopping", ()=>AiFillShopping);
parcelHelpers.export(exports, "AiFillSignal", ()=>AiFillSignal);
parcelHelpers.export(exports, "AiFillSketchCircle", ()=>AiFillSketchCircle);
parcelHelpers.export(exports, "AiFillSketchSquare", ()=>AiFillSketchSquare);
parcelHelpers.export(exports, "AiFillSkin", ()=>AiFillSkin);
parcelHelpers.export(exports, "AiFillSkype", ()=>AiFillSkype);
parcelHelpers.export(exports, "AiFillSlackCircle", ()=>AiFillSlackCircle);
parcelHelpers.export(exports, "AiFillSlackSquare", ()=>AiFillSlackSquare);
parcelHelpers.export(exports, "AiFillSliders", ()=>AiFillSliders);
parcelHelpers.export(exports, "AiFillSmile", ()=>AiFillSmile);
parcelHelpers.export(exports, "AiFillSnippets", ()=>AiFillSnippets);
parcelHelpers.export(exports, "AiFillSound", ()=>AiFillSound);
parcelHelpers.export(exports, "AiFillStar", ()=>AiFillStar);
parcelHelpers.export(exports, "AiFillStepBackward", ()=>AiFillStepBackward);
parcelHelpers.export(exports, "AiFillStepForward", ()=>AiFillStepForward);
parcelHelpers.export(exports, "AiFillStop", ()=>AiFillStop);
parcelHelpers.export(exports, "AiFillSwitcher", ()=>AiFillSwitcher);
parcelHelpers.export(exports, "AiFillTablet", ()=>AiFillTablet);
parcelHelpers.export(exports, "AiFillTag", ()=>AiFillTag);
parcelHelpers.export(exports, "AiFillTags", ()=>AiFillTags);
parcelHelpers.export(exports, "AiFillTaobaoCircle", ()=>AiFillTaobaoCircle);
parcelHelpers.export(exports, "AiFillTaobaoSquare", ()=>AiFillTaobaoSquare);
parcelHelpers.export(exports, "AiFillThunderbolt", ()=>AiFillThunderbolt);
parcelHelpers.export(exports, "AiFillTool", ()=>AiFillTool);
parcelHelpers.export(exports, "AiFillTrademarkCircle", ()=>AiFillTrademarkCircle);
parcelHelpers.export(exports, "AiFillTrophy", ()=>AiFillTrophy);
parcelHelpers.export(exports, "AiFillTwitterCircle", ()=>AiFillTwitterCircle);
parcelHelpers.export(exports, "AiFillTwitterSquare", ()=>AiFillTwitterSquare);
parcelHelpers.export(exports, "AiFillUnlock", ()=>AiFillUnlock);
parcelHelpers.export(exports, "AiFillUpCircle", ()=>AiFillUpCircle);
parcelHelpers.export(exports, "AiFillUpSquare", ()=>AiFillUpSquare);
parcelHelpers.export(exports, "AiFillUsb", ()=>AiFillUsb);
parcelHelpers.export(exports, "AiFillVideoCamera", ()=>AiFillVideoCamera);
parcelHelpers.export(exports, "AiFillWallet", ()=>AiFillWallet);
parcelHelpers.export(exports, "AiFillWarning", ()=>AiFillWarning);
parcelHelpers.export(exports, "AiFillWechat", ()=>AiFillWechat);
parcelHelpers.export(exports, "AiFillWeiboCircle", ()=>AiFillWeiboCircle);
parcelHelpers.export(exports, "AiFillWeiboSquare", ()=>AiFillWeiboSquare);
parcelHelpers.export(exports, "AiFillWindows", ()=>AiFillWindows);
parcelHelpers.export(exports, "AiFillYahoo", ()=>AiFillYahoo);
parcelHelpers.export(exports, "AiFillYoutube", ()=>AiFillYoutube);
parcelHelpers.export(exports, "AiFillYuque", ()=>AiFillYuque);
parcelHelpers.export(exports, "AiFillZhihuCircle", ()=>AiFillZhihuCircle);
parcelHelpers.export(exports, "AiFillZhihuSquare", ()=>AiFillZhihuSquare);
parcelHelpers.export(exports, "AiOutlineAccountBook", ()=>AiOutlineAccountBook);
parcelHelpers.export(exports, "AiOutlineAim", ()=>AiOutlineAim);
parcelHelpers.export(exports, "AiOutlineAlert", ()=>AiOutlineAlert);
parcelHelpers.export(exports, "AiOutlineAlibaba", ()=>AiOutlineAlibaba);
parcelHelpers.export(exports, "AiOutlineAlignCenter", ()=>AiOutlineAlignCenter);
parcelHelpers.export(exports, "AiOutlineAlignLeft", ()=>AiOutlineAlignLeft);
parcelHelpers.export(exports, "AiOutlineAlignRight", ()=>AiOutlineAlignRight);
parcelHelpers.export(exports, "AiOutlineAlipayCircle", ()=>AiOutlineAlipayCircle);
parcelHelpers.export(exports, "AiOutlineAlipay", ()=>AiOutlineAlipay);
parcelHelpers.export(exports, "AiOutlineAliwangwang", ()=>AiOutlineAliwangwang);
parcelHelpers.export(exports, "AiOutlineAliyun", ()=>AiOutlineAliyun);
parcelHelpers.export(exports, "AiOutlineAmazon", ()=>AiOutlineAmazon);
parcelHelpers.export(exports, "AiOutlineAndroid", ()=>AiOutlineAndroid);
parcelHelpers.export(exports, "AiOutlineAntCloud", ()=>AiOutlineAntCloud);
parcelHelpers.export(exports, "AiOutlineAntDesign", ()=>AiOutlineAntDesign);
parcelHelpers.export(exports, "AiOutlineApartment", ()=>AiOutlineApartment);
parcelHelpers.export(exports, "AiOutlineApi", ()=>AiOutlineApi);
parcelHelpers.export(exports, "AiOutlineApple", ()=>AiOutlineApple);
parcelHelpers.export(exports, "AiOutlineAppstoreAdd", ()=>AiOutlineAppstoreAdd);
parcelHelpers.export(exports, "AiOutlineAppstore", ()=>AiOutlineAppstore);
parcelHelpers.export(exports, "AiOutlineAreaChart", ()=>AiOutlineAreaChart);
parcelHelpers.export(exports, "AiOutlineArrowDown", ()=>AiOutlineArrowDown);
parcelHelpers.export(exports, "AiOutlineArrowLeft", ()=>AiOutlineArrowLeft);
parcelHelpers.export(exports, "AiOutlineArrowRight", ()=>AiOutlineArrowRight);
parcelHelpers.export(exports, "AiOutlineArrowUp", ()=>AiOutlineArrowUp);
parcelHelpers.export(exports, "AiOutlineArrowsAlt", ()=>AiOutlineArrowsAlt);
parcelHelpers.export(exports, "AiOutlineAudioMuted", ()=>AiOutlineAudioMuted);
parcelHelpers.export(exports, "AiOutlineAudio", ()=>AiOutlineAudio);
parcelHelpers.export(exports, "AiOutlineAudit", ()=>AiOutlineAudit);
parcelHelpers.export(exports, "AiOutlineBackward", ()=>AiOutlineBackward);
parcelHelpers.export(exports, "AiOutlineBank", ()=>AiOutlineBank);
parcelHelpers.export(exports, "AiOutlineBarChart", ()=>AiOutlineBarChart);
parcelHelpers.export(exports, "AiOutlineBarcode", ()=>AiOutlineBarcode);
parcelHelpers.export(exports, "AiOutlineBars", ()=>AiOutlineBars);
parcelHelpers.export(exports, "AiOutlineBehanceSquare", ()=>AiOutlineBehanceSquare);
parcelHelpers.export(exports, "AiOutlineBehance", ()=>AiOutlineBehance);
parcelHelpers.export(exports, "AiOutlineBell", ()=>AiOutlineBell);
parcelHelpers.export(exports, "AiOutlineBgColors", ()=>AiOutlineBgColors);
parcelHelpers.export(exports, "AiOutlineBlock", ()=>AiOutlineBlock);
parcelHelpers.export(exports, "AiOutlineBold", ()=>AiOutlineBold);
parcelHelpers.export(exports, "AiOutlineBook", ()=>AiOutlineBook);
parcelHelpers.export(exports, "AiOutlineBorderBottom", ()=>AiOutlineBorderBottom);
parcelHelpers.export(exports, "AiOutlineBorderHorizontal", ()=>AiOutlineBorderHorizontal);
parcelHelpers.export(exports, "AiOutlineBorderInner", ()=>AiOutlineBorderInner);
parcelHelpers.export(exports, "AiOutlineBorderLeft", ()=>AiOutlineBorderLeft);
parcelHelpers.export(exports, "AiOutlineBorderOuter", ()=>AiOutlineBorderOuter);
parcelHelpers.export(exports, "AiOutlineBorderRight", ()=>AiOutlineBorderRight);
parcelHelpers.export(exports, "AiOutlineBorderTop", ()=>AiOutlineBorderTop);
parcelHelpers.export(exports, "AiOutlineBorderVerticle", ()=>AiOutlineBorderVerticle);
parcelHelpers.export(exports, "AiOutlineBorder", ()=>AiOutlineBorder);
parcelHelpers.export(exports, "AiOutlineBorderlessTable", ()=>AiOutlineBorderlessTable);
parcelHelpers.export(exports, "AiOutlineBoxPlot", ()=>AiOutlineBoxPlot);
parcelHelpers.export(exports, "AiOutlineBranches", ()=>AiOutlineBranches);
parcelHelpers.export(exports, "AiOutlineBug", ()=>AiOutlineBug);
parcelHelpers.export(exports, "AiOutlineBuild", ()=>AiOutlineBuild);
parcelHelpers.export(exports, "AiOutlineBulb", ()=>AiOutlineBulb);
parcelHelpers.export(exports, "AiOutlineCalculator", ()=>AiOutlineCalculator);
parcelHelpers.export(exports, "AiOutlineCalendar", ()=>AiOutlineCalendar);
parcelHelpers.export(exports, "AiOutlineCamera", ()=>AiOutlineCamera);
parcelHelpers.export(exports, "AiOutlineCar", ()=>AiOutlineCar);
parcelHelpers.export(exports, "AiOutlineCaretDown", ()=>AiOutlineCaretDown);
parcelHelpers.export(exports, "AiOutlineCaretLeft", ()=>AiOutlineCaretLeft);
parcelHelpers.export(exports, "AiOutlineCaretRight", ()=>AiOutlineCaretRight);
parcelHelpers.export(exports, "AiOutlineCaretUp", ()=>AiOutlineCaretUp);
parcelHelpers.export(exports, "AiOutlineCarryOut", ()=>AiOutlineCarryOut);
parcelHelpers.export(exports, "AiOutlineCheckCircle", ()=>AiOutlineCheckCircle);
parcelHelpers.export(exports, "AiOutlineCheckSquare", ()=>AiOutlineCheckSquare);
parcelHelpers.export(exports, "AiOutlineCheck", ()=>AiOutlineCheck);
parcelHelpers.export(exports, "AiOutlineChrome", ()=>AiOutlineChrome);
parcelHelpers.export(exports, "AiOutlineCiCircle", ()=>AiOutlineCiCircle);
parcelHelpers.export(exports, "AiOutlineCi", ()=>AiOutlineCi);
parcelHelpers.export(exports, "AiOutlineClear", ()=>AiOutlineClear);
parcelHelpers.export(exports, "AiOutlineClockCircle", ()=>AiOutlineClockCircle);
parcelHelpers.export(exports, "AiOutlineCloseCircle", ()=>AiOutlineCloseCircle);
parcelHelpers.export(exports, "AiOutlineCloseSquare", ()=>AiOutlineCloseSquare);
parcelHelpers.export(exports, "AiOutlineClose", ()=>AiOutlineClose);
parcelHelpers.export(exports, "AiOutlineCloudDownload", ()=>AiOutlineCloudDownload);
parcelHelpers.export(exports, "AiOutlineCloudServer", ()=>AiOutlineCloudServer);
parcelHelpers.export(exports, "AiOutlineCloudSync", ()=>AiOutlineCloudSync);
parcelHelpers.export(exports, "AiOutlineCloudUpload", ()=>AiOutlineCloudUpload);
parcelHelpers.export(exports, "AiOutlineCloud", ()=>AiOutlineCloud);
parcelHelpers.export(exports, "AiOutlineCluster", ()=>AiOutlineCluster);
parcelHelpers.export(exports, "AiOutlineCodeSandbox", ()=>AiOutlineCodeSandbox);
parcelHelpers.export(exports, "AiOutlineCode", ()=>AiOutlineCode);
parcelHelpers.export(exports, "AiOutlineCodepenCircle", ()=>AiOutlineCodepenCircle);
parcelHelpers.export(exports, "AiOutlineCodepen", ()=>AiOutlineCodepen);
parcelHelpers.export(exports, "AiOutlineCoffee", ()=>AiOutlineCoffee);
parcelHelpers.export(exports, "AiOutlineColumnHeight", ()=>AiOutlineColumnHeight);
parcelHelpers.export(exports, "AiOutlineColumnWidth", ()=>AiOutlineColumnWidth);
parcelHelpers.export(exports, "AiOutlineComment", ()=>AiOutlineComment);
parcelHelpers.export(exports, "AiOutlineCompass", ()=>AiOutlineCompass);
parcelHelpers.export(exports, "AiOutlineCompress", ()=>AiOutlineCompress);
parcelHelpers.export(exports, "AiOutlineConsoleSql", ()=>AiOutlineConsoleSql);
parcelHelpers.export(exports, "AiOutlineContacts", ()=>AiOutlineContacts);
parcelHelpers.export(exports, "AiOutlineContainer", ()=>AiOutlineContainer);
parcelHelpers.export(exports, "AiOutlineControl", ()=>AiOutlineControl);
parcelHelpers.export(exports, "AiOutlineCopy", ()=>AiOutlineCopy);
parcelHelpers.export(exports, "AiOutlineCopyrightCircle", ()=>AiOutlineCopyrightCircle);
parcelHelpers.export(exports, "AiOutlineCopyright", ()=>AiOutlineCopyright);
parcelHelpers.export(exports, "AiOutlineCreditCard", ()=>AiOutlineCreditCard);
parcelHelpers.export(exports, "AiOutlineCrown", ()=>AiOutlineCrown);
parcelHelpers.export(exports, "AiOutlineCustomerService", ()=>AiOutlineCustomerService);
parcelHelpers.export(exports, "AiOutlineDash", ()=>AiOutlineDash);
parcelHelpers.export(exports, "AiOutlineDashboard", ()=>AiOutlineDashboard);
parcelHelpers.export(exports, "AiOutlineDatabase", ()=>AiOutlineDatabase);
parcelHelpers.export(exports, "AiOutlineDeleteColumn", ()=>AiOutlineDeleteColumn);
parcelHelpers.export(exports, "AiOutlineDeleteRow", ()=>AiOutlineDeleteRow);
parcelHelpers.export(exports, "AiOutlineDelete", ()=>AiOutlineDelete);
parcelHelpers.export(exports, "AiOutlineDeliveredProcedure", ()=>AiOutlineDeliveredProcedure);
parcelHelpers.export(exports, "AiOutlineDeploymentUnit", ()=>AiOutlineDeploymentUnit);
parcelHelpers.export(exports, "AiOutlineDesktop", ()=>AiOutlineDesktop);
parcelHelpers.export(exports, "AiOutlineDiff", ()=>AiOutlineDiff);
parcelHelpers.export(exports, "AiOutlineDingding", ()=>AiOutlineDingding);
parcelHelpers.export(exports, "AiOutlineDingtalk", ()=>AiOutlineDingtalk);
parcelHelpers.export(exports, "AiOutlineDisconnect", ()=>AiOutlineDisconnect);
parcelHelpers.export(exports, "AiOutlineDislike", ()=>AiOutlineDislike);
parcelHelpers.export(exports, "AiOutlineDollarCircle", ()=>AiOutlineDollarCircle);
parcelHelpers.export(exports, "AiOutlineDollar", ()=>AiOutlineDollar);
parcelHelpers.export(exports, "AiOutlineDotChart", ()=>AiOutlineDotChart);
parcelHelpers.export(exports, "AiOutlineDoubleLeft", ()=>AiOutlineDoubleLeft);
parcelHelpers.export(exports, "AiOutlineDoubleRight", ()=>AiOutlineDoubleRight);
parcelHelpers.export(exports, "AiOutlineDownCircle", ()=>AiOutlineDownCircle);
parcelHelpers.export(exports, "AiOutlineDownSquare", ()=>AiOutlineDownSquare);
parcelHelpers.export(exports, "AiOutlineDown", ()=>AiOutlineDown);
parcelHelpers.export(exports, "AiOutlineDownload", ()=>AiOutlineDownload);
parcelHelpers.export(exports, "AiOutlineDrag", ()=>AiOutlineDrag);
parcelHelpers.export(exports, "AiOutlineDribbbleSquare", ()=>AiOutlineDribbbleSquare);
parcelHelpers.export(exports, "AiOutlineDribbble", ()=>AiOutlineDribbble);
parcelHelpers.export(exports, "AiOutlineDropbox", ()=>AiOutlineDropbox);
parcelHelpers.export(exports, "AiOutlineEdit", ()=>AiOutlineEdit);
parcelHelpers.export(exports, "AiOutlineEllipsis", ()=>AiOutlineEllipsis);
parcelHelpers.export(exports, "AiOutlineEnter", ()=>AiOutlineEnter);
parcelHelpers.export(exports, "AiOutlineEnvironment", ()=>AiOutlineEnvironment);
parcelHelpers.export(exports, "AiOutlineEuroCircle", ()=>AiOutlineEuroCircle);
parcelHelpers.export(exports, "AiOutlineEuro", ()=>AiOutlineEuro);
parcelHelpers.export(exports, "AiOutlineException", ()=>AiOutlineException);
parcelHelpers.export(exports, "AiOutlineExclamationCircle", ()=>AiOutlineExclamationCircle);
parcelHelpers.export(exports, "AiOutlineExclamation", ()=>AiOutlineExclamation);
parcelHelpers.export(exports, "AiOutlineExpandAlt", ()=>AiOutlineExpandAlt);
parcelHelpers.export(exports, "AiOutlineExpand", ()=>AiOutlineExpand);
parcelHelpers.export(exports, "AiOutlineExperiment", ()=>AiOutlineExperiment);
parcelHelpers.export(exports, "AiOutlineExport", ()=>AiOutlineExport);
parcelHelpers.export(exports, "AiOutlineEyeInvisible", ()=>AiOutlineEyeInvisible);
parcelHelpers.export(exports, "AiOutlineEye", ()=>AiOutlineEye);
parcelHelpers.export(exports, "AiOutlineFacebook", ()=>AiOutlineFacebook);
parcelHelpers.export(exports, "AiOutlineFall", ()=>AiOutlineFall);
parcelHelpers.export(exports, "AiOutlineFastBackward", ()=>AiOutlineFastBackward);
parcelHelpers.export(exports, "AiOutlineFastForward", ()=>AiOutlineFastForward);
parcelHelpers.export(exports, "AiOutlineFieldBinary", ()=>AiOutlineFieldBinary);
parcelHelpers.export(exports, "AiOutlineFieldNumber", ()=>AiOutlineFieldNumber);
parcelHelpers.export(exports, "AiOutlineFieldString", ()=>AiOutlineFieldString);
parcelHelpers.export(exports, "AiOutlineFieldTime", ()=>AiOutlineFieldTime);
parcelHelpers.export(exports, "AiOutlineFileAdd", ()=>AiOutlineFileAdd);
parcelHelpers.export(exports, "AiOutlineFileDone", ()=>AiOutlineFileDone);
parcelHelpers.export(exports, "AiOutlineFileExcel", ()=>AiOutlineFileExcel);
parcelHelpers.export(exports, "AiOutlineFileExclamation", ()=>AiOutlineFileExclamation);
parcelHelpers.export(exports, "AiOutlineFileGif", ()=>AiOutlineFileGif);
parcelHelpers.export(exports, "AiOutlineFileImage", ()=>AiOutlineFileImage);
parcelHelpers.export(exports, "AiOutlineFileJpg", ()=>AiOutlineFileJpg);
parcelHelpers.export(exports, "AiOutlineFileMarkdown", ()=>AiOutlineFileMarkdown);
parcelHelpers.export(exports, "AiOutlineFilePdf", ()=>AiOutlineFilePdf);
parcelHelpers.export(exports, "AiOutlineFilePpt", ()=>AiOutlineFilePpt);
parcelHelpers.export(exports, "AiOutlineFileProtect", ()=>AiOutlineFileProtect);
parcelHelpers.export(exports, "AiOutlineFileSearch", ()=>AiOutlineFileSearch);
parcelHelpers.export(exports, "AiOutlineFileSync", ()=>AiOutlineFileSync);
parcelHelpers.export(exports, "AiOutlineFileText", ()=>AiOutlineFileText);
parcelHelpers.export(exports, "AiOutlineFileUnknown", ()=>AiOutlineFileUnknown);
parcelHelpers.export(exports, "AiOutlineFileWord", ()=>AiOutlineFileWord);
parcelHelpers.export(exports, "AiOutlineFileZip", ()=>AiOutlineFileZip);
parcelHelpers.export(exports, "AiOutlineFile", ()=>AiOutlineFile);
parcelHelpers.export(exports, "AiOutlineFilter", ()=>AiOutlineFilter);
parcelHelpers.export(exports, "AiOutlineFire", ()=>AiOutlineFire);
parcelHelpers.export(exports, "AiOutlineFlag", ()=>AiOutlineFlag);
parcelHelpers.export(exports, "AiOutlineFolderAdd", ()=>AiOutlineFolderAdd);
parcelHelpers.export(exports, "AiOutlineFolderOpen", ()=>AiOutlineFolderOpen);
parcelHelpers.export(exports, "AiOutlineFolderView", ()=>AiOutlineFolderView);
parcelHelpers.export(exports, "AiOutlineFolder", ()=>AiOutlineFolder);
parcelHelpers.export(exports, "AiOutlineFontColors", ()=>AiOutlineFontColors);
parcelHelpers.export(exports, "AiOutlineFontSize", ()=>AiOutlineFontSize);
parcelHelpers.export(exports, "AiOutlineFork", ()=>AiOutlineFork);
parcelHelpers.export(exports, "AiOutlineForm", ()=>AiOutlineForm);
parcelHelpers.export(exports, "AiOutlineFormatPainter", ()=>AiOutlineFormatPainter);
parcelHelpers.export(exports, "AiOutlineForward", ()=>AiOutlineForward);
parcelHelpers.export(exports, "AiOutlineFrown", ()=>AiOutlineFrown);
parcelHelpers.export(exports, "AiOutlineFullscreenExit", ()=>AiOutlineFullscreenExit);
parcelHelpers.export(exports, "AiOutlineFullscreen", ()=>AiOutlineFullscreen);
parcelHelpers.export(exports, "AiOutlineFunction", ()=>AiOutlineFunction);
parcelHelpers.export(exports, "AiOutlineFundProjectionScreen", ()=>AiOutlineFundProjectionScreen);
parcelHelpers.export(exports, "AiOutlineFundView", ()=>AiOutlineFundView);
parcelHelpers.export(exports, "AiOutlineFund", ()=>AiOutlineFund);
parcelHelpers.export(exports, "AiOutlineFunnelPlot", ()=>AiOutlineFunnelPlot);
parcelHelpers.export(exports, "AiOutlineGateway", ()=>AiOutlineGateway);
parcelHelpers.export(exports, "AiOutlineGif", ()=>AiOutlineGif);
parcelHelpers.export(exports, "AiOutlineGift", ()=>AiOutlineGift);
parcelHelpers.export(exports, "AiOutlineGithub", ()=>AiOutlineGithub);
parcelHelpers.export(exports, "AiOutlineGitlab", ()=>AiOutlineGitlab);
parcelHelpers.export(exports, "AiOutlineGlobal", ()=>AiOutlineGlobal);
parcelHelpers.export(exports, "AiOutlineGold", ()=>AiOutlineGold);
parcelHelpers.export(exports, "AiOutlineGooglePlus", ()=>AiOutlineGooglePlus);
parcelHelpers.export(exports, "AiOutlineGoogle", ()=>AiOutlineGoogle);
parcelHelpers.export(exports, "AiOutlineGroup", ()=>AiOutlineGroup);
parcelHelpers.export(exports, "AiOutlineHdd", ()=>AiOutlineHdd);
parcelHelpers.export(exports, "AiOutlineHeart", ()=>AiOutlineHeart);
parcelHelpers.export(exports, "AiOutlineHeatMap", ()=>AiOutlineHeatMap);
parcelHelpers.export(exports, "AiOutlineHighlight", ()=>AiOutlineHighlight);
parcelHelpers.export(exports, "AiOutlineHistory", ()=>AiOutlineHistory);
parcelHelpers.export(exports, "AiOutlineHolder", ()=>AiOutlineHolder);
parcelHelpers.export(exports, "AiOutlineHome", ()=>AiOutlineHome);
parcelHelpers.export(exports, "AiOutlineHourglass", ()=>AiOutlineHourglass);
parcelHelpers.export(exports, "AiOutlineHtml5", ()=>AiOutlineHtml5);
parcelHelpers.export(exports, "AiOutlineIdcard", ()=>AiOutlineIdcard);
parcelHelpers.export(exports, "AiOutlineIe", ()=>AiOutlineIe);
parcelHelpers.export(exports, "AiOutlineImport", ()=>AiOutlineImport);
parcelHelpers.export(exports, "AiOutlineInbox", ()=>AiOutlineInbox);
parcelHelpers.export(exports, "AiOutlineInfoCircle", ()=>AiOutlineInfoCircle);
parcelHelpers.export(exports, "AiOutlineInfo", ()=>AiOutlineInfo);
parcelHelpers.export(exports, "AiOutlineInsertRowAbove", ()=>AiOutlineInsertRowAbove);
parcelHelpers.export(exports, "AiOutlineInsertRowBelow", ()=>AiOutlineInsertRowBelow);
parcelHelpers.export(exports, "AiOutlineInsertRowLeft", ()=>AiOutlineInsertRowLeft);
parcelHelpers.export(exports, "AiOutlineInsertRowRight", ()=>AiOutlineInsertRowRight);
parcelHelpers.export(exports, "AiOutlineInstagram", ()=>AiOutlineInstagram);
parcelHelpers.export(exports, "AiOutlineInsurance", ()=>AiOutlineInsurance);
parcelHelpers.export(exports, "AiOutlineInteraction", ()=>AiOutlineInteraction);
parcelHelpers.export(exports, "AiOutlineIssuesClose", ()=>AiOutlineIssuesClose);
parcelHelpers.export(exports, "AiOutlineItalic", ()=>AiOutlineItalic);
parcelHelpers.export(exports, "AiOutlineKey", ()=>AiOutlineKey);
parcelHelpers.export(exports, "AiOutlineLaptop", ()=>AiOutlineLaptop);
parcelHelpers.export(exports, "AiOutlineLayout", ()=>AiOutlineLayout);
parcelHelpers.export(exports, "AiOutlineLeftCircle", ()=>AiOutlineLeftCircle);
parcelHelpers.export(exports, "AiOutlineLeftSquare", ()=>AiOutlineLeftSquare);
parcelHelpers.export(exports, "AiOutlineLeft", ()=>AiOutlineLeft);
parcelHelpers.export(exports, "AiOutlineLike", ()=>AiOutlineLike);
parcelHelpers.export(exports, "AiOutlineLineChart", ()=>AiOutlineLineChart);
parcelHelpers.export(exports, "AiOutlineLineHeight", ()=>AiOutlineLineHeight);
parcelHelpers.export(exports, "AiOutlineLine", ()=>AiOutlineLine);
parcelHelpers.export(exports, "AiOutlineLink", ()=>AiOutlineLink);
parcelHelpers.export(exports, "AiOutlineLinkedin", ()=>AiOutlineLinkedin);
parcelHelpers.export(exports, "AiOutlineLoading3Quarters", ()=>AiOutlineLoading3Quarters);
parcelHelpers.export(exports, "AiOutlineLoading", ()=>AiOutlineLoading);
parcelHelpers.export(exports, "AiOutlineLock", ()=>AiOutlineLock);
parcelHelpers.export(exports, "AiOutlineLogin", ()=>AiOutlineLogin);
parcelHelpers.export(exports, "AiOutlineLogout", ()=>AiOutlineLogout);
parcelHelpers.export(exports, "AiOutlineMacCommand", ()=>AiOutlineMacCommand);
parcelHelpers.export(exports, "AiOutlineMail", ()=>AiOutlineMail);
parcelHelpers.export(exports, "AiOutlineMan", ()=>AiOutlineMan);
parcelHelpers.export(exports, "AiOutlineMedicineBox", ()=>AiOutlineMedicineBox);
parcelHelpers.export(exports, "AiOutlineMediumWorkmark", ()=>AiOutlineMediumWorkmark);
parcelHelpers.export(exports, "AiOutlineMedium", ()=>AiOutlineMedium);
parcelHelpers.export(exports, "AiOutlineMeh", ()=>AiOutlineMeh);
parcelHelpers.export(exports, "AiOutlineMenuFold", ()=>AiOutlineMenuFold);
parcelHelpers.export(exports, "AiOutlineMenuUnfold", ()=>AiOutlineMenuUnfold);
parcelHelpers.export(exports, "AiOutlineMenu", ()=>AiOutlineMenu);
parcelHelpers.export(exports, "AiOutlineMergeCells", ()=>AiOutlineMergeCells);
parcelHelpers.export(exports, "AiOutlineMessage", ()=>AiOutlineMessage);
parcelHelpers.export(exports, "AiOutlineMinusCircle", ()=>AiOutlineMinusCircle);
parcelHelpers.export(exports, "AiOutlineMinusSquare", ()=>AiOutlineMinusSquare);
parcelHelpers.export(exports, "AiOutlineMinus", ()=>AiOutlineMinus);
parcelHelpers.export(exports, "AiOutlineMobile", ()=>AiOutlineMobile);
parcelHelpers.export(exports, "AiOutlineMoneyCollect", ()=>AiOutlineMoneyCollect);
parcelHelpers.export(exports, "AiOutlineMonitor", ()=>AiOutlineMonitor);
parcelHelpers.export(exports, "AiOutlineMore", ()=>AiOutlineMore);
parcelHelpers.export(exports, "AiOutlineNodeCollapse", ()=>AiOutlineNodeCollapse);
parcelHelpers.export(exports, "AiOutlineNodeExpand", ()=>AiOutlineNodeExpand);
parcelHelpers.export(exports, "AiOutlineNodeIndex", ()=>AiOutlineNodeIndex);
parcelHelpers.export(exports, "AiOutlineNotification", ()=>AiOutlineNotification);
parcelHelpers.export(exports, "AiOutlineNumber", ()=>AiOutlineNumber);
parcelHelpers.export(exports, "AiOutlineOneToOne", ()=>AiOutlineOneToOne);
parcelHelpers.export(exports, "AiOutlineOrderedList", ()=>AiOutlineOrderedList);
parcelHelpers.export(exports, "AiOutlinePaperClip", ()=>AiOutlinePaperClip);
parcelHelpers.export(exports, "AiOutlinePartition", ()=>AiOutlinePartition);
parcelHelpers.export(exports, "AiOutlinePauseCircle", ()=>AiOutlinePauseCircle);
parcelHelpers.export(exports, "AiOutlinePause", ()=>AiOutlinePause);
parcelHelpers.export(exports, "AiOutlinePayCircle", ()=>AiOutlinePayCircle);
parcelHelpers.export(exports, "AiOutlinePercentage", ()=>AiOutlinePercentage);
parcelHelpers.export(exports, "AiOutlinePhone", ()=>AiOutlinePhone);
parcelHelpers.export(exports, "AiOutlinePicCenter", ()=>AiOutlinePicCenter);
parcelHelpers.export(exports, "AiOutlinePicLeft", ()=>AiOutlinePicLeft);
parcelHelpers.export(exports, "AiOutlinePicRight", ()=>AiOutlinePicRight);
parcelHelpers.export(exports, "AiOutlinePicture", ()=>AiOutlinePicture);
parcelHelpers.export(exports, "AiOutlinePieChart", ()=>AiOutlinePieChart);
parcelHelpers.export(exports, "AiOutlinePlayCircle", ()=>AiOutlinePlayCircle);
parcelHelpers.export(exports, "AiOutlinePlaySquare", ()=>AiOutlinePlaySquare);
parcelHelpers.export(exports, "AiOutlinePlusCircle", ()=>AiOutlinePlusCircle);
parcelHelpers.export(exports, "AiOutlinePlusSquare", ()=>AiOutlinePlusSquare);
parcelHelpers.export(exports, "AiOutlinePlus", ()=>AiOutlinePlus);
parcelHelpers.export(exports, "AiOutlinePoundCircle", ()=>AiOutlinePoundCircle);
parcelHelpers.export(exports, "AiOutlinePound", ()=>AiOutlinePound);
parcelHelpers.export(exports, "AiOutlinePoweroff", ()=>AiOutlinePoweroff);
parcelHelpers.export(exports, "AiOutlinePrinter", ()=>AiOutlinePrinter);
parcelHelpers.export(exports, "AiOutlineProfile", ()=>AiOutlineProfile);
parcelHelpers.export(exports, "AiOutlineProject", ()=>AiOutlineProject);
parcelHelpers.export(exports, "AiOutlinePropertySafety", ()=>AiOutlinePropertySafety);
parcelHelpers.export(exports, "AiOutlinePullRequest", ()=>AiOutlinePullRequest);
parcelHelpers.export(exports, "AiOutlinePushpin", ()=>AiOutlinePushpin);
parcelHelpers.export(exports, "AiOutlineQq", ()=>AiOutlineQq);
parcelHelpers.export(exports, "AiOutlineQrcode", ()=>AiOutlineQrcode);
parcelHelpers.export(exports, "AiOutlineQuestionCircle", ()=>AiOutlineQuestionCircle);
parcelHelpers.export(exports, "AiOutlineQuestion", ()=>AiOutlineQuestion);
parcelHelpers.export(exports, "AiOutlineRadarChart", ()=>AiOutlineRadarChart);
parcelHelpers.export(exports, "AiOutlineRadiusBottomleft", ()=>AiOutlineRadiusBottomleft);
parcelHelpers.export(exports, "AiOutlineRadiusBottomright", ()=>AiOutlineRadiusBottomright);
parcelHelpers.export(exports, "AiOutlineRadiusSetting", ()=>AiOutlineRadiusSetting);
parcelHelpers.export(exports, "AiOutlineRadiusUpleft", ()=>AiOutlineRadiusUpleft);
parcelHelpers.export(exports, "AiOutlineRadiusUpright", ()=>AiOutlineRadiusUpright);
parcelHelpers.export(exports, "AiOutlineRead", ()=>AiOutlineRead);
parcelHelpers.export(exports, "AiOutlineReconciliation", ()=>AiOutlineReconciliation);
parcelHelpers.export(exports, "AiOutlineRedEnvelope", ()=>AiOutlineRedEnvelope);
parcelHelpers.export(exports, "AiOutlineReddit", ()=>AiOutlineReddit);
parcelHelpers.export(exports, "AiOutlineRedo", ()=>AiOutlineRedo);
parcelHelpers.export(exports, "AiOutlineReload", ()=>AiOutlineReload);
parcelHelpers.export(exports, "AiOutlineRest", ()=>AiOutlineRest);
parcelHelpers.export(exports, "AiOutlineRetweet", ()=>AiOutlineRetweet);
parcelHelpers.export(exports, "AiOutlineRightCircle", ()=>AiOutlineRightCircle);
parcelHelpers.export(exports, "AiOutlineRightSquare", ()=>AiOutlineRightSquare);
parcelHelpers.export(exports, "AiOutlineRight", ()=>AiOutlineRight);
parcelHelpers.export(exports, "AiOutlineRise", ()=>AiOutlineRise);
parcelHelpers.export(exports, "AiOutlineRobot", ()=>AiOutlineRobot);
parcelHelpers.export(exports, "AiOutlineRocket", ()=>AiOutlineRocket);
parcelHelpers.export(exports, "AiOutlineRollback", ()=>AiOutlineRollback);
parcelHelpers.export(exports, "AiOutlineRotateLeft", ()=>AiOutlineRotateLeft);
parcelHelpers.export(exports, "AiOutlineRotateRight", ()=>AiOutlineRotateRight);
parcelHelpers.export(exports, "AiOutlineSafetyCertificate", ()=>AiOutlineSafetyCertificate);
parcelHelpers.export(exports, "AiOutlineSafety", ()=>AiOutlineSafety);
parcelHelpers.export(exports, "AiOutlineSave", ()=>AiOutlineSave);
parcelHelpers.export(exports, "AiOutlineScan", ()=>AiOutlineScan);
parcelHelpers.export(exports, "AiOutlineSchedule", ()=>AiOutlineSchedule);
parcelHelpers.export(exports, "AiOutlineScissor", ()=>AiOutlineScissor);
parcelHelpers.export(exports, "AiOutlineSearch", ()=>AiOutlineSearch);
parcelHelpers.export(exports, "AiOutlineSecurityScan", ()=>AiOutlineSecurityScan);
parcelHelpers.export(exports, "AiOutlineSelect", ()=>AiOutlineSelect);
parcelHelpers.export(exports, "AiOutlineSend", ()=>AiOutlineSend);
parcelHelpers.export(exports, "AiOutlineSetting", ()=>AiOutlineSetting);
parcelHelpers.export(exports, "AiOutlineShake", ()=>AiOutlineShake);
parcelHelpers.export(exports, "AiOutlineShareAlt", ()=>AiOutlineShareAlt);
parcelHelpers.export(exports, "AiOutlineShop", ()=>AiOutlineShop);
parcelHelpers.export(exports, "AiOutlineShoppingCart", ()=>AiOutlineShoppingCart);
parcelHelpers.export(exports, "AiOutlineShopping", ()=>AiOutlineShopping);
parcelHelpers.export(exports, "AiOutlineShrink", ()=>AiOutlineShrink);
parcelHelpers.export(exports, "AiOutlineSisternode", ()=>AiOutlineSisternode);
parcelHelpers.export(exports, "AiOutlineSketch", ()=>AiOutlineSketch);
parcelHelpers.export(exports, "AiOutlineSkin", ()=>AiOutlineSkin);
parcelHelpers.export(exports, "AiOutlineSkype", ()=>AiOutlineSkype);
parcelHelpers.export(exports, "AiOutlineSlackSquare", ()=>AiOutlineSlackSquare);
parcelHelpers.export(exports, "AiOutlineSlack", ()=>AiOutlineSlack);
parcelHelpers.export(exports, "AiOutlineSliders", ()=>AiOutlineSliders);
parcelHelpers.export(exports, "AiOutlineSmallDash", ()=>AiOutlineSmallDash);
parcelHelpers.export(exports, "AiOutlineSmile", ()=>AiOutlineSmile);
parcelHelpers.export(exports, "AiOutlineSnippets", ()=>AiOutlineSnippets);
parcelHelpers.export(exports, "AiOutlineSolution", ()=>AiOutlineSolution);
parcelHelpers.export(exports, "AiOutlineSortAscending", ()=>AiOutlineSortAscending);
parcelHelpers.export(exports, "AiOutlineSortDescending", ()=>AiOutlineSortDescending);
parcelHelpers.export(exports, "AiOutlineSound", ()=>AiOutlineSound);
parcelHelpers.export(exports, "AiOutlineSplitCells", ()=>AiOutlineSplitCells);
parcelHelpers.export(exports, "AiOutlineStar", ()=>AiOutlineStar);
parcelHelpers.export(exports, "AiOutlineStepBackward", ()=>AiOutlineStepBackward);
parcelHelpers.export(exports, "AiOutlineStepForward", ()=>AiOutlineStepForward);
parcelHelpers.export(exports, "AiOutlineStock", ()=>AiOutlineStock);
parcelHelpers.export(exports, "AiOutlineStop", ()=>AiOutlineStop);
parcelHelpers.export(exports, "AiOutlineStrikethrough", ()=>AiOutlineStrikethrough);
parcelHelpers.export(exports, "AiOutlineSubnode", ()=>AiOutlineSubnode);
parcelHelpers.export(exports, "AiOutlineSwapLeft", ()=>AiOutlineSwapLeft);
parcelHelpers.export(exports, "AiOutlineSwapRight", ()=>AiOutlineSwapRight);
parcelHelpers.export(exports, "AiOutlineSwap", ()=>AiOutlineSwap);
parcelHelpers.export(exports, "AiOutlineSwitcher", ()=>AiOutlineSwitcher);
parcelHelpers.export(exports, "AiOutlineSync", ()=>AiOutlineSync);
parcelHelpers.export(exports, "AiOutlineTable", ()=>AiOutlineTable);
parcelHelpers.export(exports, "AiOutlineTablet", ()=>AiOutlineTablet);
parcelHelpers.export(exports, "AiOutlineTag", ()=>AiOutlineTag);
parcelHelpers.export(exports, "AiOutlineTags", ()=>AiOutlineTags);
parcelHelpers.export(exports, "AiOutlineTaobaoCircle", ()=>AiOutlineTaobaoCircle);
parcelHelpers.export(exports, "AiOutlineTaobao", ()=>AiOutlineTaobao);
parcelHelpers.export(exports, "AiOutlineTeam", ()=>AiOutlineTeam);
parcelHelpers.export(exports, "AiOutlineThunderbolt", ()=>AiOutlineThunderbolt);
parcelHelpers.export(exports, "AiOutlineToTop", ()=>AiOutlineToTop);
parcelHelpers.export(exports, "AiOutlineTool", ()=>AiOutlineTool);
parcelHelpers.export(exports, "AiOutlineTrademarkCircle", ()=>AiOutlineTrademarkCircle);
parcelHelpers.export(exports, "AiOutlineTrademark", ()=>AiOutlineTrademark);
parcelHelpers.export(exports, "AiOutlineTransaction", ()=>AiOutlineTransaction);
parcelHelpers.export(exports, "AiOutlineTranslation", ()=>AiOutlineTranslation);
parcelHelpers.export(exports, "AiOutlineTrophy", ()=>AiOutlineTrophy);
parcelHelpers.export(exports, "AiOutlineTwitter", ()=>AiOutlineTwitter);
parcelHelpers.export(exports, "AiOutlineUnderline", ()=>AiOutlineUnderline);
parcelHelpers.export(exports, "AiOutlineUndo", ()=>AiOutlineUndo);
parcelHelpers.export(exports, "AiOutlineUngroup", ()=>AiOutlineUngroup);
parcelHelpers.export(exports, "AiOutlineUnlock", ()=>AiOutlineUnlock);
parcelHelpers.export(exports, "AiOutlineUnorderedList", ()=>AiOutlineUnorderedList);
parcelHelpers.export(exports, "AiOutlineUpCircle", ()=>AiOutlineUpCircle);
parcelHelpers.export(exports, "AiOutlineUpSquare", ()=>AiOutlineUpSquare);
parcelHelpers.export(exports, "AiOutlineUp", ()=>AiOutlineUp);
parcelHelpers.export(exports, "AiOutlineUpload", ()=>AiOutlineUpload);
parcelHelpers.export(exports, "AiOutlineUsb", ()=>AiOutlineUsb);
parcelHelpers.export(exports, "AiOutlineUserAdd", ()=>AiOutlineUserAdd);
parcelHelpers.export(exports, "AiOutlineUserDelete", ()=>AiOutlineUserDelete);
parcelHelpers.export(exports, "AiOutlineUserSwitch", ()=>AiOutlineUserSwitch);
parcelHelpers.export(exports, "AiOutlineUser", ()=>AiOutlineUser);
parcelHelpers.export(exports, "AiOutlineUsergroupAdd", ()=>AiOutlineUsergroupAdd);
parcelHelpers.export(exports, "AiOutlineUsergroupDelete", ()=>AiOutlineUsergroupDelete);
parcelHelpers.export(exports, "AiOutlineVerified", ()=>AiOutlineVerified);
parcelHelpers.export(exports, "AiOutlineVerticalAlignBottom", ()=>AiOutlineVerticalAlignBottom);
parcelHelpers.export(exports, "AiOutlineVerticalAlignMiddle", ()=>AiOutlineVerticalAlignMiddle);
parcelHelpers.export(exports, "AiOutlineVerticalAlignTop", ()=>AiOutlineVerticalAlignTop);
parcelHelpers.export(exports, "AiOutlineVerticalLeft", ()=>AiOutlineVerticalLeft);
parcelHelpers.export(exports, "AiOutlineVerticalRight", ()=>AiOutlineVerticalRight);
parcelHelpers.export(exports, "AiOutlineVideoCameraAdd", ()=>AiOutlineVideoCameraAdd);
parcelHelpers.export(exports, "AiOutlineVideoCamera", ()=>AiOutlineVideoCamera);
parcelHelpers.export(exports, "AiOutlineWallet", ()=>AiOutlineWallet);
parcelHelpers.export(exports, "AiOutlineWarning", ()=>AiOutlineWarning);
parcelHelpers.export(exports, "AiOutlineWechat", ()=>AiOutlineWechat);
parcelHelpers.export(exports, "AiOutlineWeiboCircle", ()=>AiOutlineWeiboCircle);
parcelHelpers.export(exports, "AiOutlineWeiboSquare", ()=>AiOutlineWeiboSquare);
parcelHelpers.export(exports, "AiOutlineWeibo", ()=>AiOutlineWeibo);
parcelHelpers.export(exports, "AiOutlineWhatsApp", ()=>AiOutlineWhatsApp);
parcelHelpers.export(exports, "AiOutlineWifi", ()=>AiOutlineWifi);
parcelHelpers.export(exports, "AiOutlineWindows", ()=>AiOutlineWindows);
parcelHelpers.export(exports, "AiOutlineWoman", ()=>AiOutlineWoman);
parcelHelpers.export(exports, "AiOutlineYahoo", ()=>AiOutlineYahoo);
parcelHelpers.export(exports, "AiOutlineYoutube", ()=>AiOutlineYoutube);
parcelHelpers.export(exports, "AiOutlineYuque", ()=>AiOutlineYuque);
parcelHelpers.export(exports, "AiOutlineZhihu", ()=>AiOutlineZhihu);
parcelHelpers.export(exports, "AiOutlineZoomIn", ()=>AiOutlineZoomIn);
parcelHelpers.export(exports, "AiOutlineZoomOut", ()=>AiOutlineZoomOut);
parcelHelpers.export(exports, "AiTwotoneAccountBook", ()=>AiTwotoneAccountBook);
parcelHelpers.export(exports, "AiTwotoneAlert", ()=>AiTwotoneAlert);
parcelHelpers.export(exports, "AiTwotoneApi", ()=>AiTwotoneApi);
parcelHelpers.export(exports, "AiTwotoneAppstore", ()=>AiTwotoneAppstore);
parcelHelpers.export(exports, "AiTwotoneAudio", ()=>AiTwotoneAudio);
parcelHelpers.export(exports, "AiTwotoneBank", ()=>AiTwotoneBank);
parcelHelpers.export(exports, "AiTwotoneBell", ()=>AiTwotoneBell);
parcelHelpers.export(exports, "AiTwotoneBook", ()=>AiTwotoneBook);
parcelHelpers.export(exports, "AiTwotoneBoxPlot", ()=>AiTwotoneBoxPlot);
parcelHelpers.export(exports, "AiTwotoneBug", ()=>AiTwotoneBug);
parcelHelpers.export(exports, "AiTwotoneBuild", ()=>AiTwotoneBuild);
parcelHelpers.export(exports, "AiTwotoneBulb", ()=>AiTwotoneBulb);
parcelHelpers.export(exports, "AiTwotoneCalculator", ()=>AiTwotoneCalculator);
parcelHelpers.export(exports, "AiTwotoneCalendar", ()=>AiTwotoneCalendar);
parcelHelpers.export(exports, "AiTwotoneCamera", ()=>AiTwotoneCamera);
parcelHelpers.export(exports, "AiTwotoneCar", ()=>AiTwotoneCar);
parcelHelpers.export(exports, "AiTwotoneCarryOut", ()=>AiTwotoneCarryOut);
parcelHelpers.export(exports, "AiTwotoneCheckCircle", ()=>AiTwotoneCheckCircle);
parcelHelpers.export(exports, "AiTwotoneCheckSquare", ()=>AiTwotoneCheckSquare);
parcelHelpers.export(exports, "AiTwotoneCiCircle", ()=>AiTwotoneCiCircle);
parcelHelpers.export(exports, "AiTwotoneCi", ()=>AiTwotoneCi);
parcelHelpers.export(exports, "AiTwotoneClockCircle", ()=>AiTwotoneClockCircle);
parcelHelpers.export(exports, "AiTwotoneCloseCircle", ()=>AiTwotoneCloseCircle);
parcelHelpers.export(exports, "AiTwotoneCloseSquare", ()=>AiTwotoneCloseSquare);
parcelHelpers.export(exports, "AiTwotoneCloud", ()=>AiTwotoneCloud);
parcelHelpers.export(exports, "AiTwotoneCode", ()=>AiTwotoneCode);
parcelHelpers.export(exports, "AiTwotoneCompass", ()=>AiTwotoneCompass);
parcelHelpers.export(exports, "AiTwotoneContacts", ()=>AiTwotoneContacts);
parcelHelpers.export(exports, "AiTwotoneContainer", ()=>AiTwotoneContainer);
parcelHelpers.export(exports, "AiTwotoneControl", ()=>AiTwotoneControl);
parcelHelpers.export(exports, "AiTwotoneCopy", ()=>AiTwotoneCopy);
parcelHelpers.export(exports, "AiTwotoneCopyrightCircle", ()=>AiTwotoneCopyrightCircle);
parcelHelpers.export(exports, "AiTwotoneCopyright", ()=>AiTwotoneCopyright);
parcelHelpers.export(exports, "AiTwotoneCreditCard", ()=>AiTwotoneCreditCard);
parcelHelpers.export(exports, "AiTwotoneCrown", ()=>AiTwotoneCrown);
parcelHelpers.export(exports, "AiTwotoneCustomerService", ()=>AiTwotoneCustomerService);
parcelHelpers.export(exports, "AiTwotoneDashboard", ()=>AiTwotoneDashboard);
parcelHelpers.export(exports, "AiTwotoneDatabase", ()=>AiTwotoneDatabase);
parcelHelpers.export(exports, "AiTwotoneDelete", ()=>AiTwotoneDelete);
parcelHelpers.export(exports, "AiTwotoneDiff", ()=>AiTwotoneDiff);
parcelHelpers.export(exports, "AiTwotoneDislike", ()=>AiTwotoneDislike);
parcelHelpers.export(exports, "AiTwotoneDollarCircle", ()=>AiTwotoneDollarCircle);
parcelHelpers.export(exports, "AiTwotoneDollar", ()=>AiTwotoneDollar);
parcelHelpers.export(exports, "AiTwotoneDownCircle", ()=>AiTwotoneDownCircle);
parcelHelpers.export(exports, "AiTwotoneDownSquare", ()=>AiTwotoneDownSquare);
parcelHelpers.export(exports, "AiTwotoneEdit", ()=>AiTwotoneEdit);
parcelHelpers.export(exports, "AiTwotoneEnvironment", ()=>AiTwotoneEnvironment);
parcelHelpers.export(exports, "AiTwotoneEuroCircle", ()=>AiTwotoneEuroCircle);
parcelHelpers.export(exports, "AiTwotoneEuro", ()=>AiTwotoneEuro);
parcelHelpers.export(exports, "AiTwotoneExclamationCircle", ()=>AiTwotoneExclamationCircle);
parcelHelpers.export(exports, "AiTwotoneExperiment", ()=>AiTwotoneExperiment);
parcelHelpers.export(exports, "AiTwotoneEyeInvisible", ()=>AiTwotoneEyeInvisible);
parcelHelpers.export(exports, "AiTwotoneEye", ()=>AiTwotoneEye);
parcelHelpers.export(exports, "AiTwotoneFileAdd", ()=>AiTwotoneFileAdd);
parcelHelpers.export(exports, "AiTwotoneFileExcel", ()=>AiTwotoneFileExcel);
parcelHelpers.export(exports, "AiTwotoneFileExclamation", ()=>AiTwotoneFileExclamation);
parcelHelpers.export(exports, "AiTwotoneFileImage", ()=>AiTwotoneFileImage);
parcelHelpers.export(exports, "AiTwotoneFileMarkdown", ()=>AiTwotoneFileMarkdown);
parcelHelpers.export(exports, "AiTwotoneFilePdf", ()=>AiTwotoneFilePdf);
parcelHelpers.export(exports, "AiTwotoneFilePpt", ()=>AiTwotoneFilePpt);
parcelHelpers.export(exports, "AiTwotoneFileText", ()=>AiTwotoneFileText);
parcelHelpers.export(exports, "AiTwotoneFileUnknown", ()=>AiTwotoneFileUnknown);
parcelHelpers.export(exports, "AiTwotoneFileWord", ()=>AiTwotoneFileWord);
parcelHelpers.export(exports, "AiTwotoneFileZip", ()=>AiTwotoneFileZip);
parcelHelpers.export(exports, "AiTwotoneFile", ()=>AiTwotoneFile);
parcelHelpers.export(exports, "AiTwotoneFilter", ()=>AiTwotoneFilter);
parcelHelpers.export(exports, "AiTwotoneFire", ()=>AiTwotoneFire);
parcelHelpers.export(exports, "AiTwotoneFlag", ()=>AiTwotoneFlag);
parcelHelpers.export(exports, "AiTwotoneFolderAdd", ()=>AiTwotoneFolderAdd);
parcelHelpers.export(exports, "AiTwotoneFolderOpen", ()=>AiTwotoneFolderOpen);
parcelHelpers.export(exports, "AiTwotoneFolder", ()=>AiTwotoneFolder);
parcelHelpers.export(exports, "AiTwotoneFrown", ()=>AiTwotoneFrown);
parcelHelpers.export(exports, "AiTwotoneFund", ()=>AiTwotoneFund);
parcelHelpers.export(exports, "AiTwotoneFunnelPlot", ()=>AiTwotoneFunnelPlot);
parcelHelpers.export(exports, "AiTwotoneGift", ()=>AiTwotoneGift);
parcelHelpers.export(exports, "AiTwotoneGold", ()=>AiTwotoneGold);
parcelHelpers.export(exports, "AiTwotoneHdd", ()=>AiTwotoneHdd);
parcelHelpers.export(exports, "AiTwotoneHeart", ()=>AiTwotoneHeart);
parcelHelpers.export(exports, "AiTwotoneHighlight", ()=>AiTwotoneHighlight);
parcelHelpers.export(exports, "AiTwotoneHome", ()=>AiTwotoneHome);
parcelHelpers.export(exports, "AiTwotoneHourglass", ()=>AiTwotoneHourglass);
parcelHelpers.export(exports, "AiTwotoneHtml5", ()=>AiTwotoneHtml5);
parcelHelpers.export(exports, "AiTwotoneIdcard", ()=>AiTwotoneIdcard);
parcelHelpers.export(exports, "AiTwotoneInfoCircle", ()=>AiTwotoneInfoCircle);
parcelHelpers.export(exports, "AiTwotoneInsurance", ()=>AiTwotoneInsurance);
parcelHelpers.export(exports, "AiTwotoneInteraction", ()=>AiTwotoneInteraction);
parcelHelpers.export(exports, "AiTwotoneLayout", ()=>AiTwotoneLayout);
parcelHelpers.export(exports, "AiTwotoneLeftCircle", ()=>AiTwotoneLeftCircle);
parcelHelpers.export(exports, "AiTwotoneLeftSquare", ()=>AiTwotoneLeftSquare);
parcelHelpers.export(exports, "AiTwotoneLike", ()=>AiTwotoneLike);
parcelHelpers.export(exports, "AiTwotoneLock", ()=>AiTwotoneLock);
parcelHelpers.export(exports, "AiTwotoneMail", ()=>AiTwotoneMail);
parcelHelpers.export(exports, "AiTwotoneMedicineBox", ()=>AiTwotoneMedicineBox);
parcelHelpers.export(exports, "AiTwotoneMeh", ()=>AiTwotoneMeh);
parcelHelpers.export(exports, "AiTwotoneMessage", ()=>AiTwotoneMessage);
parcelHelpers.export(exports, "AiTwotoneMinusCircle", ()=>AiTwotoneMinusCircle);
parcelHelpers.export(exports, "AiTwotoneMinusSquare", ()=>AiTwotoneMinusSquare);
parcelHelpers.export(exports, "AiTwotoneMobile", ()=>AiTwotoneMobile);
parcelHelpers.export(exports, "AiTwotoneMoneyCollect", ()=>AiTwotoneMoneyCollect);
parcelHelpers.export(exports, "AiTwotoneNotification", ()=>AiTwotoneNotification);
parcelHelpers.export(exports, "AiTwotonePauseCircle", ()=>AiTwotonePauseCircle);
parcelHelpers.export(exports, "AiTwotonePhone", ()=>AiTwotonePhone);
parcelHelpers.export(exports, "AiTwotonePicture", ()=>AiTwotonePicture);
parcelHelpers.export(exports, "AiTwotonePieChart", ()=>AiTwotonePieChart);
parcelHelpers.export(exports, "AiTwotonePlayCircle", ()=>AiTwotonePlayCircle);
parcelHelpers.export(exports, "AiTwotonePlaySquare", ()=>AiTwotonePlaySquare);
parcelHelpers.export(exports, "AiTwotonePlusCircle", ()=>AiTwotonePlusCircle);
parcelHelpers.export(exports, "AiTwotonePlusSquare", ()=>AiTwotonePlusSquare);
parcelHelpers.export(exports, "AiTwotonePoundCircle", ()=>AiTwotonePoundCircle);
parcelHelpers.export(exports, "AiTwotonePrinter", ()=>AiTwotonePrinter);
parcelHelpers.export(exports, "AiTwotoneProfile", ()=>AiTwotoneProfile);
parcelHelpers.export(exports, "AiTwotoneProject", ()=>AiTwotoneProject);
parcelHelpers.export(exports, "AiTwotonePropertySafety", ()=>AiTwotonePropertySafety);
parcelHelpers.export(exports, "AiTwotonePushpin", ()=>AiTwotonePushpin);
parcelHelpers.export(exports, "AiTwotoneQuestionCircle", ()=>AiTwotoneQuestionCircle);
parcelHelpers.export(exports, "AiTwotoneReconciliation", ()=>AiTwotoneReconciliation);
parcelHelpers.export(exports, "AiTwotoneRedEnvelope", ()=>AiTwotoneRedEnvelope);
parcelHelpers.export(exports, "AiTwotoneRest", ()=>AiTwotoneRest);
parcelHelpers.export(exports, "AiTwotoneRightCircle", ()=>AiTwotoneRightCircle);
parcelHelpers.export(exports, "AiTwotoneRightSquare", ()=>AiTwotoneRightSquare);
parcelHelpers.export(exports, "AiTwotoneRocket", ()=>AiTwotoneRocket);
parcelHelpers.export(exports, "AiTwotoneSafetyCertificate", ()=>AiTwotoneSafetyCertificate);
parcelHelpers.export(exports, "AiTwotoneSave", ()=>AiTwotoneSave);
parcelHelpers.export(exports, "AiTwotoneSchedule", ()=>AiTwotoneSchedule);
parcelHelpers.export(exports, "AiTwotoneSecurityScan", ()=>AiTwotoneSecurityScan);
parcelHelpers.export(exports, "AiTwotoneSetting", ()=>AiTwotoneSetting);
parcelHelpers.export(exports, "AiTwotoneShop", ()=>AiTwotoneShop);
parcelHelpers.export(exports, "AiTwotoneShopping", ()=>AiTwotoneShopping);
parcelHelpers.export(exports, "AiTwotoneSkin", ()=>AiTwotoneSkin);
parcelHelpers.export(exports, "AiTwotoneSliders", ()=>AiTwotoneSliders);
parcelHelpers.export(exports, "AiTwotoneSmile", ()=>AiTwotoneSmile);
parcelHelpers.export(exports, "AiTwotoneSnippets", ()=>AiTwotoneSnippets);
parcelHelpers.export(exports, "AiTwotoneSound", ()=>AiTwotoneSound);
parcelHelpers.export(exports, "AiTwotoneStar", ()=>AiTwotoneStar);
parcelHelpers.export(exports, "AiTwotoneStop", ()=>AiTwotoneStop);
parcelHelpers.export(exports, "AiTwotoneSwitcher", ()=>AiTwotoneSwitcher);
parcelHelpers.export(exports, "AiTwotoneTablet", ()=>AiTwotoneTablet);
parcelHelpers.export(exports, "AiTwotoneTag", ()=>AiTwotoneTag);
parcelHelpers.export(exports, "AiTwotoneTags", ()=>AiTwotoneTags);
parcelHelpers.export(exports, "AiTwotoneThunderbolt", ()=>AiTwotoneThunderbolt);
parcelHelpers.export(exports, "AiTwotoneTool", ()=>AiTwotoneTool);
parcelHelpers.export(exports, "AiTwotoneTrademarkCircle", ()=>AiTwotoneTrademarkCircle);
parcelHelpers.export(exports, "AiTwotoneTrophy", ()=>AiTwotoneTrophy);
parcelHelpers.export(exports, "AiTwotoneUnlock", ()=>AiTwotoneUnlock);
parcelHelpers.export(exports, "AiTwotoneUpCircle", ()=>AiTwotoneUpCircle);
parcelHelpers.export(exports, "AiTwotoneUpSquare", ()=>AiTwotoneUpSquare);
parcelHelpers.export(exports, "AiTwotoneUsb", ()=>AiTwotoneUsb);
parcelHelpers.export(exports, "AiTwotoneVideoCamera", ()=>AiTwotoneVideoCamera);
parcelHelpers.export(exports, "AiTwotoneWallet", ()=>AiTwotoneWallet);
parcelHelpers.export(exports, "AiTwotoneWarning", ()=>AiTwotoneWarning);
var _lib = require("../lib");
function AiFillAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z"
                }
            }
        ]
    })(props);
}
function AiFillAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z"
                }
            }
        ]
    })(props);
}
function AiFillAlipayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z"
                }
            }
        ]
    })(props);
}
function AiFillAlipaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z"
                }
            }
        ]
    })(props);
}
function AiFillAliwangwang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z"
                }
            }
        ]
    })(props);
}
function AiFillAmazonCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z"
                }
            }
        ]
    })(props);
}
function AiFillAmazonSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z"
                }
            }
        ]
    })(props);
}
function AiFillAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z"
                }
            }
        ]
    })(props);
}
function AiFillApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z"
                }
            }
        ]
    })(props);
}
function AiFillApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    })(props);
}
function AiFillAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function AiFillAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            }
        ]
    })(props);
}
function AiFillBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"
                }
            }
        ]
    })(props);
}
function AiFillBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z"
                }
            }
        ]
    })(props);
}
function AiFillBehanceCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z"
                }
            }
        ]
    })(props);
}
function AiFillBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z"
                }
            }
        ]
    })(props);
}
function AiFillBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z"
                }
            }
        ]
    })(props);
}
function AiFillBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z"
                }
            }
        ]
    })(props);
}
function AiFillBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiFillBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1-17.2-31.5-42.5-56.8-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9-31.5 17.2-56.8 42.5-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 34.8-28.2 63-63 63H232c-34.8 0-63-28.2-63-63 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7 6 17.2 13.6 33.6 22.7 49 24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5 41.5-24.3 76.2-59 100.5-100.5 9.1-15.5 16.7-31.9 22.7-49C812.1 793.1 836 831.8 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiFillBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiFillBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z"
                }
            }
        ]
    })(props);
}
function AiFillCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z"
                }
            }
        ]
    })(props);
}
function AiFillCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z"
                }
            }
        ]
    })(props);
}
function AiFillCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z"
                }
            }
        ]
    })(props);
}
function AiFillCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    })(props);
}
function AiFillCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"
                }
            }
        ]
    })(props);
}
function AiFillCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    })(props);
}
function AiFillCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    })(props);
}
function AiFillCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z"
                }
            }
        ]
    })(props);
}
function AiFillCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            }
        ]
    })(props);
}
function AiFillClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"
                }
            }
        ]
    })(props);
}
function AiFillCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm127.978 274.82-.034.006c-.023.007-.042.018-.083.059L512 466.745l-127.86-127.86c-.042-.041-.06-.052-.084-.059a.118.118 0 0 0-.07 0c-.022.007-.041.018-.082.059l-45.02 45.019c-.04.04-.05.06-.058.083a.118.118 0 0 0 0 .07l.01.022a.268.268 0 0 0 .049.06L466.745 512l-127.86 127.862c-.041.04-.052.06-.059.083a.118.118 0 0 0 0 .07c.007.022.018.041.059.082l45.019 45.02c.04.04.06.05.083.058a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059L512 557.254l127.862 127.861c.04.041.06.052.083.059a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059l45.02-45.019c.04-.04.05-.06.058-.083a.118.118 0 0 0 0-.07l-.01-.022a.268.268 0 0 0-.049-.06L557.254 512l127.861-127.86c.041-.042.052-.06.059-.084a.118.118 0 0 0 0-.07c-.007-.022-.018-.041-.059-.082l-45.019-45.02c-.04-.04-.06-.05-.083-.058a.118.118 0 0 0-.07 0Z"
                }
            }
        ]
    })(props);
}
function AiFillCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32ZM639.978 338.82l-.034.006c-.023.007-.042.018-.083.059L512 466.745l-127.86-127.86c-.042-.041-.06-.052-.084-.059a.118.118 0 0 0-.07 0c-.022.007-.041.018-.082.059l-45.02 45.019c-.04.04-.05.06-.058.083a.118.118 0 0 0 0 .07l.01.022a.268.268 0 0 0 .049.06L466.745 512l-127.86 127.862c-.041.04-.052.06-.059.083a.118.118 0 0 0 0 .07c.007.022.018.041.059.082l45.019 45.02c.04.04.06.05.083.058a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059L512 557.254l127.862 127.861c.04.041.06.052.083.059a.118.118 0 0 0 .07 0c.022-.007.041-.018.082-.059l45.02-45.019c.04-.04.05-.06.058-.083a.118.118 0 0 0 0-.07l-.01-.022a.268.268 0 0 0-.049-.06L557.254 512l127.861-127.86c.041-.042.052-.06.059-.084a.118.118 0 0 0 0-.07c-.007-.022-.018-.041-.059-.082l-45.019-45.02c-.04-.04-.06-.05-.083-.058a.118.118 0 0 0-.07 0Z"
                }
            }
        ]
    })(props);
}
function AiFillCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiFillCodeSandboxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z"
                }
            }
        ]
    })(props);
}
function AiFillCodeSandboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z"
                }
            }
        ]
    })(props);
}
function AiFillCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillCodepenCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z"
                }
            }
        ]
    })(props);
}
function AiFillCodepenSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z"
                }
            }
        ]
    })(props);
}
function AiFillCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z"
                }
            }
        ]
    })(props);
}
function AiFillContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z"
                }
            }
        ]
    })(props);
}
function AiFillContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z"
                }
            }
        ]
    })(props);
}
function AiFillControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z"
                }
            }
        ]
    })(props);
}
function AiFillCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z"
                }
            }
        ]
    })(props);
}
function AiFillCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z"
                }
            }
        ]
    })(props);
}
function AiFillCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z"
                }
            }
        ]
    })(props);
}
function AiFillCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z"
                }
            }
        ]
    })(props);
}
function AiFillCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z"
                }
            }
        ]
    })(props);
}
function AiFillDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z"
                }
            }
        ]
    })(props);
}
function AiFillDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            }
        ]
    })(props);
}
function AiFillDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z"
                }
            }
        ]
    })(props);
}
function AiFillDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z"
                }
            }
        ]
    })(props);
}
function AiFillDingtalkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z"
                }
            }
        ]
    })(props);
}
function AiFillDingtalkSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z"
                }
            }
        ]
    })(props);
}
function AiFillDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            }
        ]
    })(props);
}
function AiFillDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillDribbbleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z"
                }
            }
        ]
    })(props);
}
function AiFillDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z"
                }
            }
        ]
    })(props);
}
function AiFillDropboxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z"
                }
            }
        ]
    })(props);
}
function AiFillDropboxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z"
                }
            }
        ]
    })(props);
}
function AiFillEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z"
                }
            }
        ]
    })(props);
}
function AiFillEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            }
        ]
    })(props);
}
function AiFillEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z"
                }
            }
        ]
    })(props);
}
function AiFillExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z"
                }
            }
        ]
    })(props);
}
function AiFillEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": [
                    {
                        "tag": "clipPath",
                        "attr": {},
                        "child": [
                            {
                                "tag": "path",
                                "attr": {
                                    "fill": "none",
                                    "d": "M124-288l388-672 388 672H124z",
                                    "clipRule": "evenodd"
                                }
                            }
                        ]
                    }
                ]
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z"
                }
            }
        ]
    })(props);
}
function AiFillEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            }
        ]
    })(props);
}
function AiFillFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z"
                }
            }
        ]
    })(props);
}
function AiFillFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiFillFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiFillFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"
                }
            }
        ]
    })(props);
}
function AiFillFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z"
                }
            }
        ]
    })(props);
}
function AiFillFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z"
                }
            }
        ]
    })(props);
}
function AiFillFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z"
                }
            }
        ]
    })(props);
}
function AiFillFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z"
                }
            }
        ]
    })(props);
}
function AiFillFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z"
                }
            }
        ]
    })(props);
}
function AiFillFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z"
                }
            }
        ]
    })(props);
}
function AiFillFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z"
                }
            }
        ]
    })(props);
}
function AiFillFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z"
                }
            }
        ]
    })(props);
}
function AiFillFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z"
                }
            }
        ]
    })(props);
}
function AiFillFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z"
                }
            }
        ]
    })(props);
}
function AiFillFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z"
                }
            }
        ]
    })(props);
}
function AiFillFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    })(props);
}
function AiFillFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z"
                }
            }
        ]
    })(props);
}
function AiFillFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z"
                }
            }
        ]
    })(props);
}
function AiFillFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z"
                }
            }
        ]
    })(props);
}
function AiFillFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillFormatPainter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683558243",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 1.1 0.2 2.2 0.6 3.1-0.4 1.6-0.6 3.2-0.6 4.9 0 46.4 37.6 84 84 84s84-37.6 84-84c0-1.7-0.2-3.3-0.6-4.9 0.4-1 0.6-2 0.6-3.1V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40z"
                }
            }
        ]
    })(props);
}
function AiFillForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z"
                }
            }
        ]
    })(props);
}
function AiFillFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z"
                }
            }
        ]
    })(props);
}
function AiFillFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z"
                }
            }
        ]
    })(props);
}
function AiFillGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z"
                }
            }
        ]
    })(props);
}
function AiFillGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                }
            }
        ]
    })(props);
}
function AiFillGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z"
                }
            }
        ]
    })(props);
}
function AiFillGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillGolden(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillGoogleCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    })(props);
}
function AiFillGooglePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z"
                }
            }
        ]
    })(props);
}
function AiFillGooglePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z"
                }
            }
        ]
    })(props);
}
function AiFillGoogleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z"
                }
            }
        ]
    })(props);
}
function AiFillHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z"
                }
            }
        ]
    })(props);
}
function AiFillHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"
                }
            }
        ]
    })(props);
}
function AiFillHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z"
                }
            }
        ]
    })(props);
}
function AiFillHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z"
                }
            }
        ]
    })(props);
}
function AiFillHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z"
                }
            }
        ]
    })(props);
}
function AiFillHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z"
                }
            }
        ]
    })(props);
}
function AiFillIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z"
                }
            }
        ]
    })(props);
}
function AiFillIeCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z"
                }
            }
        ]
    })(props);
}
function AiFillIeSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z"
                }
            }
        ]
    })(props);
}
function AiFillInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z"
                }
            }
        ]
    })(props);
}
function AiFillInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z"
                }
            }
        ]
    })(props);
}
function AiFillInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z"
                }
            }
        ]
    })(props);
}
function AiFillLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z"
                }
            }
        ]
    })(props);
}
function AiFillLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z"
                }
            }
        ]
    })(props);
}
function AiFillLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z"
                }
            }
        ]
    })(props);
}
function AiFillLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z"
                }
            }
        ]
    })(props);
}
function AiFillLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z"
                }
            }
        ]
    })(props);
}
function AiFillMacCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569747879816",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M624 672c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48h-48v48zM720 352c0-26.5-21.5-48-48-48s-48 21.5-48 48v48h48c26.5 0 48-21.5 48-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 64H96c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM672 560c61.9 0 112 50.1 112 112s-50.1 112-112 112-112-50.1-112-112v-48h-96v48c0 61.9-50.1 112-112 112s-112-50.1-112-112 50.1-112 112-112h48v-96h-48c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112v48h96v-48c0-61.9 50.1-112 112-112s112 50.1 112 112-50.1 112-112 112h-48v96h48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 464h96v96h-96zM352 304c-26.5 0-48 21.5-48 48s21.5 48 48 48h48v-48c0-26.5-21.5-48-48-48zM304 672c0 26.5 21.5 48 48 48s48-21.5 48-48v-48h-48c-26.5 0-48 21.5-48 48z"
                }
            }
        ]
    })(props);
}
function AiFillMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z"
                }
            }
        ]
    })(props);
}
function AiFillMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z"
                }
            }
        ]
    })(props);
}
function AiFillMediumCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z"
                }
            }
        ]
    })(props);
}
function AiFillMediumSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z"
                }
            }
        ]
    })(props);
}
function AiFillMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z"
                }
            }
        ]
    })(props);
}
function AiFillMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function AiFillMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z"
                }
            }
        ]
    })(props);
}
function AiFillNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z"
                }
            }
        ]
    })(props);
}
function AiFillPauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            }
        ]
    })(props);
}
function AiFillPayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z"
                }
            }
        ]
    })(props);
}
function AiFillPhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z"
                }
            }
        ]
    })(props);
}
function AiFillPicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z"
                }
            }
        ]
    })(props);
}
function AiFillPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z"
                }
            }
        ]
    })(props);
}
function AiFillPlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z"
                }
            }
        ]
    })(props);
}
function AiFillPlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z"
                }
            }
        ]
    })(props);
}
function AiFillPlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillPlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillPoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z"
                }
            }
        ]
    })(props);
}
function AiFillPrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z"
                }
            }
        ]
    })(props);
}
function AiFillProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z"
                }
            }
        ]
    })(props);
}
function AiFillProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z"
                }
            }
        ]
    })(props);
}
function AiFillPropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z"
                }
            }
        ]
    })(props);
}
function AiFillPushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z"
                }
            }
        ]
    })(props);
}
function AiFillQqCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z"
                }
            }
        ]
    })(props);
}
function AiFillQqSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z"
                }
            }
        ]
    })(props);
}
function AiFillQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"
                }
            }
        ]
    })(props);
}
function AiFillRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z"
                }
            }
        ]
    })(props);
}
function AiFillReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z"
                }
            }
        ]
    })(props);
}
function AiFillRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z"
                }
            }
        ]
    })(props);
}
function AiFillRedditCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z"
                }
            }
        ]
    })(props);
}
function AiFillRedditSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z"
                }
            }
        ]
    })(props);
}
function AiFillRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z"
                }
            }
        ]
    })(props);
}
function AiFillRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"
                }
            }
        ]
    })(props);
}
function AiFillRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z"
                }
            }
        ]
    })(props);
}
function AiFillRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682613478",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM300 328c0-33.1 26.9-60 60-60s60 26.9 60 60-26.9 60-60 60-60-26.9-60-60z m372 248c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-60c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v60z m-8-188c-33.1 0-60-26.9-60-60s26.9-60 60-60 60 26.9 60 60-26.9 60-60 60zM799 864H225c-13.8 0-25 14.3-25 32v56c0 4.4 2.8 8 6.2 8h611.5c3.4 0 6.2-3.6 6.2-8v-56c0.1-17.7-11.1-32-24.9-32z"
                }
            }
        ]
    })(props);
}
function AiFillRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z"
                }
            }
        ]
    })(props);
}
function AiFillSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z"
                }
            }
        ]
    })(props);
}
function AiFillSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z"
                }
            }
        ]
    })(props);
}
function AiFillSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z"
                }
            }
        ]
    })(props);
}
function AiFillSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z"
                }
            }
        ]
    })(props);
}
function AiFillShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z"
                }
            }
        ]
    })(props);
}
function AiFillShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z"
                }
            }
        ]
    })(props);
}
function AiFillSignal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682885975",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M584 352H440c-17.7 0-32 14.3-32 32v544c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32zM892 64H748c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM276 640H132c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h144c17.7 0 32-14.3 32-32V672c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillSketchCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z"
                }
            }
        ]
    })(props);
}
function AiFillSketchSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z"
                }
            }
        ]
    })(props);
}
function AiFillSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z"
                }
            }
        ]
    })(props);
}
function AiFillSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z"
                }
            }
        ]
    })(props);
}
function AiFillSlackCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiFillSlackSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiFillSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiFillSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiFillSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z"
                }
            }
        ]
    })(props);
}
function AiFillStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"
                }
            }
        ]
    })(props);
}
function AiFillStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8"
                }
            }
        ]
    })(props);
}
function AiFillStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8"
                }
            }
        ]
    })(props);
}
function AiFillStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z"
                }
            }
        ]
    })(props);
}
function AiFillSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiFillTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            }
        ]
    })(props);
}
function AiFillTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
                }
            }
        ]
    })(props);
}
function AiFillTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiFillTaobaoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiFillTaobaoSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiFillThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z"
                }
            }
        ]
    })(props);
}
function AiFillTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z"
                }
            }
        ]
    })(props);
}
function AiFillTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z"
                }
            }
        ]
    })(props);
}
function AiFillTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiFillTwitterCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                }
            }
        ]
    })(props);
}
function AiFillTwitterSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z"
                }
            }
        ]
    })(props);
}
function AiFillUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z"
                }
            }
        ]
    })(props);
}
function AiFillUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            }
        ]
    })(props);
}
function AiFillUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiFillVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z"
                }
            }
        ]
    })(props);
}
function AiFillWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiFillWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiFillWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"
                }
            }
        ]
    })(props);
}
function AiFillWeiboCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiFillWeiboSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiFillWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z"
                }
            }
        ]
    })(props);
}
function AiFillYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z"
                }
            }
        ]
    })(props);
}
function AiFillYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z"
                }
            }
        ]
    })(props);
}
function AiFillYuque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z"
                }
            }
        ]
    })(props);
}
function AiFillZhihuCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z"
                }
            }
        ]
    })(props);
}
function AiFillZhihuSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAim(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683657482",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8C574.1 404.4 544.1 392 512 392z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlibaba(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlipayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineAlipay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineAliwangwang(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineAliyun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z"
                }
            }
        ]
    })(props);
}
function AiOutlineAmazon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z"
                }
            }
        ]
    })(props);
}
function AiOutlineAndroid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAntCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineAntDesign(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineApartment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    })(props);
}
function AiOutlineApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineApple(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineAppstoreAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683928793",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H212V212h200v200zM864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H612V212h200v200zM864 544H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z m-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            }
        ]
    })(props);
}
function AiOutlineAreaChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineArrowsAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudioMuted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682811064",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M682 455V311l-76 76v68c-0.1 50.7-42 92.1-94 92-19.1 0.1-36.8-5.4-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54c48.9 43.2 110.8 72.3 179 81v102H326c-13.9 0-24.9 14.3-25 32v36c0.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zM846.1 68.3l-43.5-41.9c-3.1-3-8.1-3-11.2 0.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7 0.4 13.3 1.2 19.8l-68 68c-10.5-27.9-16.3-58.2-16.2-89.8-0.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137c-3.1 3.1-3.1 8.2 0 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l0.1-0.1c3.1-3.2 3-8.3-0.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z"
                }
            }
        ]
    })(props);
}
function AiOutlineAudit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z"
                }
            }
        ]
    })(props);
}
function AiOutlineBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z"
                }
            }
        ]
    })(props);
}
function AiOutlineBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBarcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBars(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineBehanceSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBehance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z"
                }
            }
        ]
    })(props);
}
function AiOutlineBgColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z"
                }
            }
        ]
    })(props);
}
function AiOutlineBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderVerticle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineBorderlessTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683537953",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M117 368h231v64H117zM676 368h241v64H676zM412 368h200v64H412zM412 592h200v64H412zM676 592h241v64H676zM117 592h231v64H117zM412 432V179h-64v666h64V592zM676 368V179h-64v666h64V432z"
                }
            }
        ]
    })(props);
}
function AiOutlineBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z"
                }
            }
        ]
    })(props);
}
function AiOutlineBranches(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1-17.2-31.5-42.5-56.8-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9-31.5 17.2-56.8 42.5-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 34.8-28.2 63-63 63H232c-34.8 0-63-28.2-63-63 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7 6 17.2 13.6 33.6 22.7 49 24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2c41.5-24.3 76.2-59 100.5-100.5 9.1-15.5 16.7-31.9 22.7-49C812.1 793.1 836 831.8 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3C317.7 752 308 716.8 308 680V412h408v268z"
                }
            }
        ]
    })(props);
}
function AiOutlineBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiOutlineBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z"
                }
            }
        ]
    })(props);
}
function AiOutlineCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    })(props);
}
function AiOutlineCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    })(props);
}
function AiOutlineCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    })(props);
}
function AiOutlineCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineChrome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineClear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683368540",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6c-0.3 1.5-0.4 3-0.4 4.4 0 14.4 11.6 26 26 26h723c1.5 0 3-0.1 4.4-0.4 14.2-2.4 23.7-15.9 21.2-30zM204 390h272V182h72v208h272v104H204V390z m468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z"
                }
            }
        ]
    })(props);
}
function AiOutlineClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64Zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372Zm128.013 198.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c17.7 0 32 14.3 32 32v736c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32Zm-40 72H184v656h656V184ZM640.013 338.826c.023.007.042.018.083.059l45.02 45.019c.04.04.05.06.058.083a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082L557.254 512l127.861 127.862a.268.268 0 0 1 .05.06l.009.023a.118.118 0 0 1 0 .07c-.007.022-.018.041-.059.082l-45.019 45.02c-.04.04-.06.05-.083.058a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059L512 557.254 384.14 685.115c-.042.041-.06.052-.084.059a.118.118 0 0 1-.07 0c-.022-.007-.041-.018-.082-.059l-45.02-45.019c-.04-.04-.05-.06-.058-.083a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082L466.745 512l-127.86-127.86a.268.268 0 0 1-.05-.061l-.009-.023a.118.118 0 0 1 0-.07c.007-.022.018-.041.059-.082l45.019-45.02c.04-.04.06-.05.083-.058a.118.118 0 0 1 .07 0c.022.007.041.018.082.059L512 466.745l127.862-127.86c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M799.855 166.312c.023.007.043.018.084.059l57.69 57.69c.041.041.052.06.059.084a.118.118 0 0 1 0 .069c-.007.023-.018.042-.059.083L569.926 512l287.703 287.703c.041.04.052.06.059.083a.118.118 0 0 1 0 .07c-.007.022-.018.042-.059.083l-57.69 57.69c-.041.041-.06.052-.084.059a.118.118 0 0 1-.069 0c-.023-.007-.042-.018-.083-.059L512 569.926 224.297 857.629c-.04.041-.06.052-.083.059a.118.118 0 0 1-.07 0c-.022-.007-.042-.018-.083-.059l-57.69-57.69c-.041-.041-.052-.06-.059-.084a.118.118 0 0 1 0-.069c.007-.023.018-.042.059-.083L454.073 512 166.371 224.297c-.041-.04-.052-.06-.059-.083a.118.118 0 0 1 0-.07c.007-.022.018-.042.059-.083l57.69-57.69c.041-.041.06-.052.084-.059a.118.118 0 0 1 .069 0c.023.007.042.018.083.059L512 454.073l287.703-287.702c.04-.041.06-.052.083-.059a.118.118 0 0 1 .07 0Z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudServer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloudUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineCluster(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodeSandbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodepenCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineCodepen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z"
                }
            }
        ]
    })(props);
}
function AiOutlineCoffee(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z"
                }
            }
        ]
    })(props);
}
function AiOutlineColumnHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineColumnWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineComment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569682881658",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M573 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40zM293 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M894 345c-48.1-66-115.3-110.1-189-130v0.1c-17.1-19-36.4-36.5-58-52.1-163.7-119-393.5-82.7-513 81-96.3 133-92.2 311.9 6 439l0.8 132.6c0 3.2 0.5 6.4 1.5 9.4 5.3 16.9 23.3 26.2 40.1 20.9L309 806c33.5 11.9 68.1 18.7 102.5 20.6l-0.5 0.4c89.1 64.9 205.9 84.4 313 49l127.1 41.4c3.2 1 6.5 1.6 9.9 1.6 17.7 0 32-14.3 32-32V753c88.1-119.6 90.4-284.9 1-408zM323 735l-12-5-99 31-1-104-8-9c-84.6-103.2-90.2-251.9-11-361 96.4-132.2 281.2-161.4 413-66 132.2 96.1 161.5 280.6 66 412-80.1 109.9-223.5 150.5-348 102z m505-17l-8 10 1 104-98-33-12 5c-56 20.8-115.7 22.5-171 7l-0.2-0.1C613.7 788.2 680.7 742.2 729 676c76.4-105.3 88.8-237.6 44.4-350.4l0.6 0.4c23 16.5 44.1 37.1 62 62 72.6 99.6 68.5 235.2-8 330z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M433 421c-23.1 0-41 17.9-41 40s17.9 40 41 40c21.1 0 39-17.9 39-40s-17.9-40-39-40z"
                }
            }
        ]
    })(props);
}
function AiOutlineCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineCompress(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683667781",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zM342 88h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zM920 664H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM920 280H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    })(props);
}
function AiOutlineConsoleSql(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683650778",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M301.3 496.7c-23.8 0-40.2-10.5-41.6-26.9H205c0.9 43.4 36.9 70.3 93.9 70.3 59.1 0 95-28.4 95-75.5 0-35.8-20-55.9-64.5-64.5l-29.1-5.6c-23.8-4.7-33.8-11.9-33.8-24.2 0-15 13.3-24.5 33.4-24.5 20.1 0 35.3 11.1 36.6 27h53c-0.9-41.7-37.5-70.3-90.3-70.3-54.4 0-89.7 28.9-89.7 73 0 35.5 21.2 58 62.5 65.8l29.7 5.9c25.8 5.2 35.6 11.9 35.6 24.4 0.1 14.7-14.5 25.1-36 25.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32z m-40 488H136V212h752v416z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M828.5 486.7h-95.8V308.5h-57.4V534h153.2zM529.9 540.1c14.1 0 27.2-2 39.1-5.8l13.3 20.3h53.3L607.9 511c21.1-20 33-51.1 33-89.8 0-73.3-43.3-118.8-110.9-118.8s-111.2 45.3-111.2 118.8c-0.1 73.7 43 118.9 111.1 118.9z m0-190c31.6 0 52.7 27.7 52.7 71.1 0 16.7-3.6 30.6-10 40.5l-5.2-6.9h-48.8L542 491c-3.9 0.9-8 1.4-12.2 1.4-31.7 0-52.8-27.5-52.8-71.2 0.1-43.6 21.2-71.1 52.9-71.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            }
        ]
    })(props);
}
function AiOutlineContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z"
                }
            }
        ]
    })(props);
}
function AiOutlineDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z"
                }
            }
        ]
    })(props);
}
function AiOutlineDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeleteColumn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683386799",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M651.1 641.9c-1.4-1.2-3.2-1.9-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L512 730.7l-73.1-87.8c-1.5-1.8-3.8-2.9-6.1-2.9H378c-1.9 0-3.7 0.7-5.1 1.9-3.4 2.8-3.9 7.9-1 11.3L474.2 776 371.8 898.9c-2.8 3.4-2.4 8.4 1 11.3 1.4 1.2 3.2 1.9 5.1 1.9h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8c1.5 1.8 3.8 2.9 6.1 2.9h55c1.9 0 3.7-0.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L549.8 776l102.4-122.9c2.8-3.4 2.3-8.4-1.1-11.2zM472 544h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8zM350 386H184V136c0-3.3-2.7-6-6-6h-60c-3.3 0-6 2.7-6 6v292c0 16.6 13.4 30 30 30h208c3.3 0 6-2.7 6-6v-60c0-3.3-2.7-6-6-6zM906 130h-60c-3.3 0-6 2.7-6 6v250H674c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h208c16.6 0 30-13.4 30-30V136c0-3.3-2.7-6-6-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeleteRow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683582196",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M819.8 512l102.4-122.9c2.8-3.4 2.4-8.4-1-11.3-1.4-1.2-3.2-1.9-5.1-1.9h-54.7c-2.4 0-4.6 1.1-6.1 2.9L782 466.7l-73.1-87.8c-1.5-1.8-3.8-2.9-6.1-2.9H648c-1.9 0-3.7 0.7-5.1 1.9-3.4 2.8-3.9 7.9-1 11.3L744.2 512 641.8 634.9c-2.8 3.4-2.4 8.4 1 11.3 1.4 1.2 3.2 1.9 5.1 1.9h54.7c2.4 0 4.6-1.1 6.1-2.9l73.1-87.8 73.1 87.8c1.5 1.8 3.8 2.9 6.1 2.9h55c1.9 0 3.7-0.7 5.1-1.9 3.4-2.8 3.9-7.9 1-11.3L819.8 512zM536 464H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h416c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM452 668h-60c-3.3 0-6 2.7-6 6v166H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6h292c16.6 0 30-13.4 30-30V674c0-3.3-2.7-6-6-6zM136 184h250v166c0 3.3 2.7 6 6 6h60c3.3 0 6-2.7 6-6V142c0-16.6-13.4-30-30-30H136c-3.3 0-6 2.7-6 6v60c0 3.3 2.7 6 6 6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeliveredProcedure(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683642448",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M632 698.3l141.9-112c4.1-3.2 4.1-9.4 0-12.6L632 461.7c-5.3-4.2-13-0.4-13 6.3v76H295c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v76c0 6.7 7.8 10.4 13 6.3zM893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v278c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V422c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-83.5c0-17-6.7-33.2-18.7-45.2zM640 288H384V184h256v104zM904 724h-56c-4.4 0-8 3.6-8 8v108H184V732c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v148c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V732c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDeploymentUnit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z"
                }
            }
        ]
    })(props);
}
function AiOutlineDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z"
                }
            }
        ]
    })(props);
}
function AiOutlineDingding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDingtalk(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDisconnect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDotChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineDoubleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    })(props);
}
function AiOutlineDoubleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineDrag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineDribbbleSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineDribbble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineDropbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineEllipsis(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineException(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineExpandAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z"
                }
            }
        ]
    })(props);
}
function AiOutlineExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683683230",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM920 664h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z"
                }
            }
        ]
    })(props);
}
function AiOutlineExport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32ZM770.87 824.869l-52.2 52.2c-4.7 4.7-1.9 12.8 4.7 13.6l179.4 21c5.1.6 9.5-3.7 8.9-8.9l-21-179.4c-.8-6.6-8.9-9.4-13.6-4.7l-52.4 52.4-256.2-256.2c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.4c-3.1 3.1-3.1 8.2 0 11.3l256.1 256.3Z",
                    "transform": "matrix(1 0 0 -1 0 1024)"
                }
            }
        ]
    })(props);
}
function AiOutlineEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineFacebook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z"
                }
            }
        ]
    })(props);
}
function AiOutlineFall(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineFastBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineFastForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldBinary(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683645783",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M600 395.4h91V649h79V267c0-4.4-3.6-8-8-8h-48.2c-3.7 0-7 2.6-7.7 6.3-2.6 12.1-6.9 22.3-12.9 30.9-7.2 10.1-15.9 18.2-26.3 24.4-10.3 6.2-22 10.5-35 12.9-10.4 1.9-21 3-32 3.1-4.4 0.1-7.9 3.6-7.9 8v42.8c0 4.4 3.6 8 8 8zM871 702H567c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM443.9 312.7c-16.1-19-34.4-32.4-55.2-40.4-21.3-8.2-44.1-12.3-68.4-12.3-23.9 0-46.4 4.1-67.7 12.3-20.8 8-39 21.4-54.8 40.3-15.9 19.1-28.7 44.7-38.3 77-9.6 32.5-14.5 73-14.5 121.5 0 49.9 4.9 91.4 14.5 124.4 9.6 32.8 22.4 58.7 38.3 77.7 15.8 18.9 34 32.3 54.8 40.3 21.3 8.2 43.8 12.3 67.7 12.3 24.4 0 47.2-4.1 68.4-12.3 20.8-8 39.2-21.4 55.2-40.4 16.1-19 29-44.9 38.6-77.7 9.6-33 14.5-74.5 14.5-124.4 0-48.4-4.9-88.9-14.5-121.5-9.5-32.1-22.4-57.7-38.6-76.8z m-29.5 251.7c-1 21.4-4.2 42-9.5 61.9-5.5 20.7-14.5 38.5-27 53.4-13.6 16.3-33.2 24.3-57.6 24.3-24 0-43.2-8.1-56.7-24.4-12.2-14.8-21.1-32.6-26.6-53.3-5.3-19.9-8.5-40.6-9.5-61.9-1-20.8-1.5-38.5-1.5-53.2 0-8.8 0.1-19.4 0.4-31.8 0.2-12.7 1.1-25.8 2.6-39.2 1.5-13.6 4-27.1 7.6-40.5 3.7-13.8 8.8-26.3 15.4-37.4 6.9-11.6 15.8-21.1 26.7-28.3 11.4-7.6 25.3-11.3 41.5-11.3 16.1 0 30.1 3.7 41.7 11.2 11.1 7.2 20.3 16.6 27.4 28.2 6.9 11.2 12.1 23.8 15.6 37.7 3.3 13.2 5.8 26.6 7.5 40.1 1.8 13.5 2.8 26.6 3 39.4 0.2 12.4 0.4 23 0.4 31.8 0.1 14.8-0.4 32.5-1.4 53.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683604581",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zM886 693H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM733.8 630c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2z m-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6 0.1-35.8 8.2-63 24.5-83.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldString(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683607277",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M875.6 515.9c2.1 0.8 4.4-0.3 5.2-2.4 0.2-0.4 0.2-0.9 0.2-1.4v-58.3c0-1.8-1.1-3.3-2.8-3.8-6-1.8-17.2-3-27.2-3-32.9 0-61.7 16.7-73.5 41.2v-28.6c0-4.4-3.6-8-8-8H717c-4.4 0-8 3.6-8 8V729c0 4.4 3.6 8 8 8h54.8c4.4 0 8-3.6 8-8V572.7c0-36.2 26.1-60.2 65.1-60.2 10.4 0.1 26.6 1.8 30.7 3.4zM338.6 475.4l-54.7-12.6c-61.2-14.2-87.7-34.8-87.7-70.7 0-44.6 39.1-73.5 96.9-73.5 52.8 0 91.4 26.5 99.9 68.9h70C455.9 311.6 387.6 259 293.4 259c-103.3 0-171 55.5-171 139 0 68.6 38.6 109.5 122.2 128.5l61.6 14.3c63.6 14.9 91.6 37.1 91.6 75.1 0 44.1-43.5 75.2-102.5 75.2-60.6 0-104.5-27.2-112.8-70.5H111c7.2 79.9 75.6 130.4 179.1 130.4C402.3 751 471 695.2 471 605.3c0-70.2-38.6-108.5-132.4-129.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M877 729m-36 0a36 36 0 1 0 72 0 36 36 0 1 0-72 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M653 457.8h-51.4V396c0-4.4-3.6-8-8-8h-54.7c-4.4 0-8 3.6-8 8v61.8H495c-4.4 0-8 3.6-8 8v42.3c0 4.4 3.6 8 8 8h35.9v147.5c0 56.2 27.4 79.4 93.1 79.4 11.7 0 23.6-1.2 33.8-3.1 1.9-0.3 3.2-2 3.2-3.9v-49.3c0-2.2-1.8-4-4-4h-0.4c-4.9 0.5-6.2 0.6-8.3 0.8-4.1 0.3-7.8 0.5-12.6 0.5-24.1 0-34.1-10.3-34.1-35.6V516.1H653c4.4 0 8-3.6 8-8v-42.3c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFieldTime(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683618210",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-0.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c0.1-6.2-5-11.2-11.1-11.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7-12.7 20.1-27.5 38.7-44.5 55.7-29.3 29.3-63.4 52.3-101.3 68.3-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3 17 17 31.8 35.6 44.5 55.7 3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8 3.1-6.1-1.4-13.3-8.2-13.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileDone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683725598",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M551.5 490.5H521c-4.6 0-8.4 3.7-8.4 8.4V720c0 4.6 3.7 8.4 8.4 8.4h30.5c4.6 0 8.4-3.7 8.4-8.4V498.9c-0.1-4.6-3.8-8.4-8.4-8.4zM477.3 600h-88.1c-4.6 0-8.4 3.7-8.4 8.4v23.8c0 4.6 3.7 8.4 8.4 8.4h47.6v0.7c-0.6 29.9-23 49.8-56.5 49.8-39.2 0-63.6-30.7-63.6-81.4 0-50.1 23.9-80.6 62.3-80.6 28.1 0 47.5 13.5 55.4 38.3l0.9 2.8h49.2l-0.7-4.6C475.9 515.9 434.7 484 379 484c-68.8 0-113 49.4-113 125.9 0 77.5 43.7 126.1 113.6 126.1 64.4 0 106-40.3 106-102.9v-24.8c0-4.6-3.7-8.3-8.3-8.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216c0 23.2 18.8 42 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M608.2 727.8h32.3c4.6 0 8.4-3.7 8.4-8.4v-84.8h87.8c4.6 0 8.4-3.7 8.4-8.4v-25.5c0-4.6-3.7-8.4-8.4-8.4h-87.8v-58.9h96.8c4.6 0 8.4-3.7 8.4-8.4v-26.8c0-4.6-3.7-8.4-8.4-8.4H608.2c-4.6 0-8.4 3.7-8.4 8.4v221.1c0 4.8 3.8 8.5 8.4 8.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileJpg(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileProtect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiOutlineFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolderView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683698855",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M309.1 554.3c-5.4 11.6-5.4 24.9 0 36.4C353.3 684 421.6 732 512.5 732s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8 0.1-36.3l-0.1-0.1-0.1-0.1C671.7 461 603.4 413 512.5 413s-159.2 48.1-203.4 141.3zM512.5 477c62.1 0 107.4 30 141.1 95.5C620 638 574.6 668 512.5 668s-107.4-30-141.1-95.5c33.7-65.5 79-95.5 141.1-95.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M513 573m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2c-1.5-1.4-3.5-2.2-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    })(props);
}
function AiOutlineFontColors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFontSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineFork(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            }
        ]
    })(props);
}
function AiOutlineForm(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFormatPainter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683552617",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M840 192h-56v-72c0-13.3-10.7-24-24-24H168c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h592c13.3 0 24-10.7 24-24V256h32v200H465c-22.1 0-40 17.9-40 40v136h-44c-4.4 0-8 3.6-8 8v228c0 0.6 0.1 1.3 0.2 1.9-0.1 2-0.2 4.1-0.2 6.1 0 46.4 37.6 84 84 84s84-37.6 84-84c0-2.1-0.1-4.1-0.2-6.1 0.1-0.6 0.2-1.2 0.2-1.9V640c0-4.4-3.6-8-8-8h-44V520h351c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40zM720 352H208V160h512v192zM477 876c0 11-9 20-20 20s-20-9-20-20V696h40v180z"
                }
            }
        ]
    })(props);
}
function AiOutlineForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z"
                }
            }
        ]
    })(props);
}
function AiOutlineFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z"
                }
            }
        ]
    })(props);
}
function AiOutlineFullscreenExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFullscreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineFunction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683610100",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M841 370c3-3.3 2.7-8.3-0.6-11.3-1.5-1.3-3.4-2.1-5.3-2.1h-72.6c-2.4 0-4.6 1-6.1 2.8L633.5 504.6c-2.9 3.4-7.9 3.8-11.3 0.9-0.9-0.8-1.6-1.7-2.1-2.8l-63.5-141.3c-1.3-2.9-4.1-4.7-7.3-4.7H380.7l0.9-4.7 8-42.3c10.5-55.4 38-81.4 85.8-81.4 18.6 0 35.5 1.7 48.8 4.7l14.1-66.8c-22.6-4.7-35.2-6.1-54.9-6.1-103.3 0-156.4 44.3-175.9 147.3l-9.4 49.4h-97.6c-3.8 0-7.1 2.7-7.8 6.4L181.9 415c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H284l-89 429.9c-0.9 4.3 1.9 8.6 6.2 9.5 0.5 0.1 1.1 0.2 1.6 0.2H269c3.8 0 7.1-2.7 7.8-6.4l89.7-433.1h135.8l68.2 139.1c1.4 2.9 1 6.4-1.2 8.8l-180.6 203c-2.9 3.3-2.6 8.4 0.7 11.3 1.5 1.3 3.4 2 5.3 2h72.7c2.4 0 4.6-1 6.1-2.8l123.7-146.7c2.8-3.4 7.9-3.8 11.3-1 0.9 0.8 1.6 1.7 2.1 2.8L676.4 784c1.3 2.8 4.1 4.7 7.3 4.7h64.6c4.4 0 8-3.6 8-8 0-1.2-0.3-2.4-0.8-3.5l-95.2-198.9c-1.4-2.9-0.9-6.4 1.3-8.8L841 370z"
                }
            }
        ]
    })(props);
}
function AiOutlineFundProjectionScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683753031",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312.1 591.5c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L517 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L275.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 160H548V96c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H120c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h356.4v32L311.6 884.1c-3.7 2.4-4.7 7.3-2.3 11l30.3 47.2v0.1c2.4 3.7 7.4 4.7 11.1 2.3L512 838.9l161.3 105.8c3.7 2.4 8.7 1.4 11.1-2.3v-0.1l30.3-47.2c2.4-3.7 1.3-8.6-2.3-11L548 776.3V744h356c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32z m-40 512H160V232h704v440z"
                }
            }
        ]
    })(props);
}
function AiOutlineFundView(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683816874",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M956 686.5l-0.1-0.1-0.1-0.1C911.7 593 843.4 545 752.5 545s-159.2 48.1-203.4 141.3v0.1c-5.4 11.5-5.4 24.9 0 36.4C593.3 816 661.6 864 752.5 864s159.2-48.1 203.4-141.3c5.4-11.5 5.4-24.8 0.1-36.2zM752.5 800c-62.1 0-107.4-30-141.1-95.5C645 639 690.4 609 752.5 609c62.1 0 107.4 30 141.1 95.5C860 770 814.6 800 752.5 800z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M753 705m-56 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M136 232h704v253h72V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v520c0 17.7 14.3 32 32 32h352v-72H136V232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M724.9 338.1l-36.8-36.8c-3.1-3.1-8.2-3.1-11.3 0L493 485.3l-86.1-86.2c-3.1-3.1-8.2-3.1-11.3 0L251.3 543.4c-3.1 3.1-3.1 8.2 0 11.3l36.8 36.8c3.1 3.1 8.2 3.1 11.3 0l101.8-101.8 86.1 86.2c3.1 3.1 8.2 3.1 11.3 0l226.3-226.5c3.2-3.1 3.2-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z"
                }
            }
        ]
    })(props);
}
function AiOutlineGateway(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z"
                }
            }
        ]
    })(props);
}
function AiOutlineGif(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683621237",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M944 299H692c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h59.2c4.4 0 8-3.6 8-8V549.9h168.2c4.4 0 8-3.6 8-8V495c0-4.4-3.6-8-8-8H759.2V364.2H944c4.4 0 8-3.6 8-8V307c0-4.4-3.6-8-8-8zM588 300h-56c-4.4 0-8 3.6-8 8v406c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V308c0-4.4-3.6-8-8-8zM452 500.9H290.5c-4.4 0-8 3.6-8 8v43.7c0 4.4 3.6 8 8 8h94.9l-0.3 8.9c-1.2 58.8-45.6 98.5-110.9 98.5-76.2 0-123.9-59.7-123.9-156.7 0-95.8 46.8-155.2 121.5-155.2 54.8 0 93.1 26.9 108.5 75.4h76.2c-13.6-87.2-86-143.4-184.7-143.4C150 288 72 375.2 72 511.9 72 650.2 149.1 736 273 736c114.1 0 187-70.7 187-181.6v-45.5c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z"
                }
            }
        ]
    })(props);
}
function AiOutlineGithub(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineGitlab(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGlobal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGooglePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineGoogle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683739097",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z m704 680H184V184h656v656z m48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64zM288 758h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16z m56-136h336v64H344v-64z"
                }
            }
        ]
    })(props);
}
function AiOutlineHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineHeatMap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z"
                }
            }
        ]
    })(props);
}
function AiOutlineHistory(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineHolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M300,276.497424 C317.32646,286.500861 338.67354,286.500861 356,276.497424 C373.326461,266.493987 384,248.006874 384,228 C384,207.993128 373.326461,189.506014 356,179.502578 C338.67354,169.499141 317.32646,169.499141 300,179.502578 C282.673539,189.506014 272,207.993128 272,228 C272,248.006874 282.673539,266.493987 300,276.497424 Z M300,560.497426 C317.32646,570.500863 338.67354,570.500863 356,560.497426 C373.326461,550.493989 384,532.006876 384,512.000002 C384,491.993129 373.326461,473.506016 356,463.502579 C338.67354,453.499142 317.32646,453.499142 300,463.502579 C282.673539,473.506016 272,491.993129 272,512.000002 C272,532.006876 282.673539,550.493989 300,560.497426 Z M640,228 C640,248.006874 650.673539,266.493987 668,276.497424 C685.32646,286.500861 706.67354,286.500861 724,276.497424 C741.326461,266.493987 752,248.006874 752,228 C752,207.993128 741.326461,189.506014 724,179.502578 C706.67354,169.499141 685.32646,169.499141 668,179.502578 C650.673539,189.506014 640,207.993128 640,228 L640,228 Z M640,512.000002 C640,532.006876 650.673539,550.493989 668,560.497426 C685.32646,570.500863 706.67354,570.500863 724,560.497426 C741.326461,550.493989 752,532.006876 752,512.000002 C752,491.993129 741.326461,473.506016 724,463.502579 C706.67354,453.499142 685.32646,453.499142 668,463.502579 C650.673539,473.506016 640,491.993129 640,512.000002 L640,512.000002 Z M300,844.497427 C317.32646,854.500864 338.67354,854.500864 356,844.497427 C373.326461,834.493991 384,816.006877 384,796.000003 C384,775.993131 373.326461,757.506018 356,747.502581 C338.67354,737.499144 317.32646,737.499144 300,747.502581 C282.673539,757.506018 272,775.993131 272,796.000003 C272,816.006877 282.673539,834.493991 300,844.497427 Z M640,796.000003 C640,816.006877 650.673539,834.493991 668,844.497427 C685.32646,854.500864 706.67354,854.500864 724,844.497427 C741.326461,834.493991 752,816.006877 752,796.000003 C752,775.993131 741.326461,757.506018 724,747.502581 C706.67354,737.499144 685.32646,737.499144 668,747.502581 C650.673539,757.506018 640,775.993131 640,796.000003 L640,796.000003 Z"
                }
            }
        ]
    })(props);
}
function AiOutlineHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z"
                }
            }
        ]
    })(props);
}
function AiOutlineHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"
                }
            }
        ]
    })(props);
}
function AiOutlineIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    })(props);
}
function AiOutlineIe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineImport(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024",
            "fill": "currentColor",
            "fillRule": "evenodd"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32ZM653.3 599.4l52.2-52.2c4.7-4.7 1.9-12.8-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4Z",
                    "transform": "matrix(1 0 0 -1 0 1024)"
                }
            }
        ]
    })(props);
}
function AiOutlineInbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInfo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowAbove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683507961",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.7 336H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V368c0.1-17.7-14.8-32-33.2-32zM360 792H184V632h176v160z m0-224H184V408h176v160z m240 224H424V632h176v160z m0-224H424V408h176v160z m240 224H664V632h176v160z m0-224H664V408h176v160zM904 160H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowBelow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683503597",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 768H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zM878.7 160H145.3c-18.4 0-33.3 14.3-33.3 32v464c0 17.7 14.9 32 33.3 32h733.3c18.4 0 33.3-14.3 33.3-32V192c0.1-17.7-14.8-32-33.2-32zM360 616H184V456h176v160z m0-224H184V232h176v160z m240 224H424V456h176v160z m0-224H424V232h176v160z m240 224H664V456h176v160z m0-224H664V232h176v160z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683561749",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM832 112H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176z m0-240H408V424h160v176z m0-240H408V184h160v176z m224 480H632V664h160v176z m0-240H632V424h160v176z m0-240H632V184h160v176z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsertRowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683555439",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M856 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zM656 112H192c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM392 840H232V664h160v176z m0-240H232V424h160v176z m0-240H232V184h160v176z m224 480H456V664h160v176z m0-240H456V424h160v176z m0-240H456V184h160v176z"
                }
            }
        ]
    })(props);
}
function AiOutlineInstagram(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineIssuesClose(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z"
                }
            }
        ]
    })(props);
}
function AiOutlineItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineKey(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z"
                }
            }
        ]
    })(props);
}
function AiOutlineLineChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLineHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineLine(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineLinkedin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineLoading3Quarters(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineLoading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    })(props);
}
function AiOutlineLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineLogin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineLogout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineMacCommand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683819749",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M370.8 554.4c-54.6 0-98.8 44.2-98.8 98.8s44.2 98.8 98.8 98.8 98.8-44.2 98.8-98.8v-42.4h84.7v42.4c0 54.6 44.2 98.8 98.8 98.8s98.8-44.2 98.8-98.8-44.2-98.8-98.8-98.8h-42.4v-84.7h42.4c54.6 0 98.8-44.2 98.8-98.8 0-54.6-44.2-98.8-98.8-98.8s-98.8 44.2-98.8 98.8v42.4h-84.7v-42.4c0-54.6-44.2-98.8-98.8-98.8S272 316.2 272 370.8s44.2 98.8 98.8 98.8h42.4v84.7h-42.4z m42.4 98.8c0 23.4-19 42.4-42.4 42.4s-42.4-19-42.4-42.4 19-42.4 42.4-42.4h42.4v42.4z m197.6-282.4c0-23.4 19-42.4 42.4-42.4s42.4 19 42.4 42.4-19 42.4-42.4 42.4h-42.4v-42.4z m0 240h42.4c23.4 0 42.4 19 42.4 42.4s-19 42.4-42.4 42.4-42.4-19-42.4-42.4v-42.4zM469.6 469.6h84.7v84.7h-84.7v-84.7z m-98.8-56.4c-23.4 0-42.4-19-42.4-42.4s19-42.4 42.4-42.4 42.4 19 42.4 42.4v42.4h-42.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z"
                }
            }
        ]
    })(props);
}
function AiOutlineMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMediumWorkmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z"
                }
            }
        ]
    })(props);
}
function AiOutlineMedium(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenuFold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenuUnfold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"
                }
            }
        ]
    })(props);
}
function AiOutlineMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMergeCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683404098",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M482.2 508.4L331.3 389c-3-2.4-7.3-0.2-7.3 3.6V478H184V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H144c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H184V546h140v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM880 116H596c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H700v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3 0.2 7.3-3.6V546h140v294H636V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlineMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineMonitor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineMore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeCollapse(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683371420",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM451.7 313.7l172.5 136.2c6.3 5.1 15.8 0.5 15.8-7.7V344h264c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H640v-98.2c0-8.1-9.4-12.8-15.8-7.7L451.7 298.3c-4.9 3.9-4.9 11.5 0 15.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeExpand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683374330",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 612c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H298c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h150.3v152c0 55.2 44.8 100 100 100H952c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H548.3c-15.5 0-28-12.5-28-28V612H952zM456 344h264v98.2c0 8.1 9.5 12.8 15.8 7.7l172.5-136.2c5-3.9 5-11.4 0-15.3L735.8 162.1c-6.4-5.1-15.8-0.5-15.8 7.7V268H456c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineNodeIndex(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683635191",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7 0.2 3.5 0.3 5.2 0.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-0.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-0.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-0.8-6.6-1.5-7.8-1.8l-3.1-0.6c-2.2-0.3-5.9-0.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2c-46 0-83.3-37.3-83.3-83.3s37.3-83.3 83.3-83.3 83.3 37.3 83.3 83.3-37.3 83.3-83.3 83.3zM695.6 845c-46 0-83.3-37.3-83.3-83.3s37.3-83.3 83.3-83.3 83.3 37.3 83.3 83.3-37.3 83.3-83.3 83.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineNumber(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z"
                }
            }
        ]
    })(props);
}
function AiOutlineOneToOne(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683653709",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M316 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8zM512 622c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39zM512 482c22.1 0 40-17.9 40-39 0-23.1-17.9-41-40-41s-40 17.9-40 41c0 21.1 17.9 39 40 39z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M648 672h60c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineOrderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z"
                }
            }
        ]
    })(props);
}
function AiOutlinePaperClip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    })(props);
}
function AiOutlinePartition(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683632175",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M640.6 429.8h257.1c7.9 0 14.3-6.4 14.3-14.3V158.3c0-7.9-6.4-14.3-14.3-14.3H640.6c-7.9 0-14.3 6.4-14.3 14.3v92.9H490.6c-3.9 0-7.1 3.2-7.1 7.1v221.5h-85.7v-96.5c0-7.9-6.4-14.3-14.3-14.3H126.3c-7.9 0-14.3 6.4-14.3 14.3v257.2c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3V544h85.7v221.5c0 3.9 3.2 7.1 7.1 7.1h135.7v92.9c0 7.9 6.4 14.3 14.3 14.3h257.1c7.9 0 14.3-6.4 14.3-14.3v-257c0-7.9-6.4-14.3-14.3-14.3h-257c-7.9 0-14.3 6.4-14.3 14.3v100h-78.6v-393h78.6v100c0 7.9 6.4 14.3 14.3 14.3z m53.5-217.9h150V362h-150V211.9zM329.9 587h-150V437h150v150z m364.2 75.1h150v150.1h-150V662.1z"
                }
            }
        ]
    })(props);
}
function AiOutlinePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePercentage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z"
                }
            }
        ]
    })(props);
}
function AiOutlinePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlinePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z"
                }
            }
        ]
    })(props);
}
function AiOutlinePoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePoweroff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlinePrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            }
        ]
    })(props);
}
function AiOutlineProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlinePropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z"
                }
            }
        ]
    })(props);
}
function AiOutlinePullRequest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z"
                }
            }
        ]
    })(props);
}
function AiOutlinePushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineQq(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineQrcode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineQuestion(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusBottomleft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusBottomright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusUpleft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRadiusUpright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z"
                }
            }
        ]
    })(props);
}
function AiOutlineRead(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineReddit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineRedo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineReload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z"
                }
            }
        ]
    })(props);
}
function AiOutlineRetweet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineRise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRobot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineRollback(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z"
                }
            }
        ]
    })(props);
}
function AiOutlineRotateLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683455503",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-0.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7 0.4 12.6-6.1v-63.9c12.9 0.1 25.9 0.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8 11 40.7 14 82.7 8.9 124.8-0.7 5.4-1.4 10.8-2.4 16.1h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineRotateRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683458761",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-0.4-12.6 6.1l-0.2 64c-118.6 0.5-235.8 53.4-314.6 154.2-69.6 89.2-95.7 198.6-81.1 302.4h74.9c-0.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32z m-44 402H396V494h440v326z"
                }
            }
        ]
    })(props);
}
function AiOutlineSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    })(props);
}
function AiOutlineScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineScissor(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                }
            }
        ]
    })(props);
}
function AiOutlineSearch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSelect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSend(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683742680",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2-8.5 2.1-13.8 10.7-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-0.9 3.7-0.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 0.7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-0.8 4.2-2.6 5-5 1.4-4.2-0.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineShake(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineShareAlt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z"
                }
            }
        ]
    })(props);
}
function AiOutlineShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineShoppingCart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z"
                }
            }
        ]
    })(props);
}
function AiOutlineShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"
                }
            }
        ]
    })(props);
}
function AiOutlineShrink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSisternode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683586275",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M672 432c-120.3 0-219.9 88.5-237.3 204H320c-15.5 0-28-12.5-28-28V244h291c14.2 35.2 48.7 60 89 60 53 0 96-43 96-96s-43-96-96-96c-40.3 0-74.8 24.8-89 60H112v72h108v364c0 55.2 44.8 100 100 100h114.7c17.4 115.5 117 204 237.3 204 132.5 0 240-107.5 240-240S804.5 432 672 432z m128 266c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"
                }
            }
        ]
    })(props);
}
function AiOutlineSketch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z"
                }
            }
        ]
    })(props);
}
function AiOutlineSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z"
                }
            }
        ]
    })(props);
}
function AiOutlineSkype(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineSlackSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4 13.3 0 26.1 5.3 35.6 14.8s14.7 22.3 14.7 35.6v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8-9.4-9.5-14.7-22.3-14.7-35.6 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSlack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3-14.4-14.4-34-22.5-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3 14.4 14.4 33.9 22.5 54.3 22.5 42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z"
                }
            }
        ]
    })(props);
}
function AiOutlineSmallDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z"
                }
            }
        ]
    })(props);
}
function AiOutlineSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiOutlineSolution(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            }
        ]
    })(props);
}
function AiOutlineSortAscending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z"
                }
            }
        ]
    })(props);
}
function AiOutlineSortDescending(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z"
                }
            }
        ]
    })(props);
}
function AiOutlineSplitCells(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683545621",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M938.2 508.4L787.3 389c-3-2.4-7.3-0.2-7.3 3.6V478H636V184h204v128c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V144c0-15.5-12.5-28-28-28H596c-15.5 0-28 12.5-28 28v736c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v128H636V546h144v85.4c0 3.8 4.4 6 7.3 3.6l150.9-119.4c2.4-1.8 2.4-5.4 0-7.2zM428 116H144c-15.5 0-28 12.5-28 28v168c0 2.2 1.8 4 4 4h60c2.2 0 4-1.8 4-4V184h204v294H244v-85.4c0-3.8-4.3-6-7.3-3.6l-151 119.4c-2.3 1.8-2.3 5.3 0 7.1l151 119.5c2.9 2.3 7.3 0.2 7.3-3.6V546h144v294H184V712c0-2.2-1.8-4-4-4h-60c-2.2 0-4 1.8-4 4v168c0 15.5 12.5 28 28 28h284c15.5 0 28-12.5 28-28V144c0-15.5-12.5-28-28-28z"
                }
            }
        ]
    })(props);
}
function AiOutlineStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineStepBackward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8"
                }
            }
        ]
    })(props);
}
function AiOutlineStepForward(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8"
                }
            }
        ]
    })(props);
}
function AiOutlineStock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineSubnode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683432252",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M688 240c-138 0-252 102.8-269.6 236H249c-14.2-35.2-48.7-60-89-60-53 0-96 43-96 96s43 96 96 96c40.3 0 74.8-24.8 89-60h169.3C436 681.2 550 784 688 784c150.2 0 272-121.8 272-272S838.2 240 688 240z m128 298c0 4.4-3.6 8-8 8h-86v86c0 4.4-3.6 8-8 8h-52c-4.4 0-8-3.6-8-8v-86h-86c-4.4 0-8-3.6-8-8v-52c0-4.4 3.6-8 8-8h86v-86c0-4.4 3.6-8 8-8h52c4.4 0 8 3.6 8 8v86h86c4.4 0 8 3.6 8 8v52z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwapLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwapRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwap(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z"
                }
            }
        ]
    })(props);
}
function AiOutlineSync(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z"
                }
            }
        ]
    })(props);
}
function AiOutlineTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    })(props);
}
function AiOutlineTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    })(props);
}
function AiOutlineTaobaoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineTaobao(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z"
                }
            }
        ]
    })(props);
}
function AiOutlineTeam(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineToTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z"
                }
            }
        ]
    })(props);
}
function AiOutlineTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrademark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineTransaction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineTranslation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683569194",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-0.3 0.8-0.4 1.7-0.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4c-1.3-3.2-4.3-5.4-7.7-5.4z m12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80z m160 0h-88v-80h88v80z"
                }
            }
        ]
    })(props);
}
function AiOutlineTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiOutlineTwitter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z"
                }
            }
        ]
    })(props);
}
function AiOutlineUndo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineUngroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683823033",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M736 550H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16z m-56 136H344v-64h336v64zM888 816c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM736 266H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16z m-56 136H344v-64h336v64zM888 208c39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72 32.2 72 72 72z m0-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 64c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zM136 816c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z m0 96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineUnorderedList(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    })(props);
}
function AiOutlineUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiOutlineUserSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683921137",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M759 335c0-137-111-248-248-248S263 198 263 335c0 82.8 40.6 156.2 103 201.2-0.4 0.2-0.7 0.3-0.9 0.4-44.7 18.9-84.8 46-119.3 80.6-34.5 34.5-61.5 74.7-80.4 119.5C146.9 780.5 137 827 136 874.8c-0.1 4.5 3.5 8.2 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C356 614.2 431 583 511 583c137 0 248-111 248-248zM511 507c-95 0-172-77-172-172s77-172 172-172 172 77 172 172-77 172-172 172zM616 728h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H703.5l47.2-60.1c1.1-1.4 1.7-3.2 1.7-4.9 0-4.4-3.6-8-8-8h-72.6c-4.9 0-9.5 2.3-12.6 6.1l-68.5 87.1c-4.4 5.6-6.8 12.6-6.8 19.8 0.1 17.7 14.4 32 32.1 32zM856 792H592c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h176.5l-47.2 60.1c-1.1 1.4-1.7 3.2-1.7 4.9 0 4.4 3.6 8 8 8h72.6c4.9 0 9.5-2.3 12.6-6.1l68.5-87.1c4.4-5.6 6.8-12.6 6.8-19.8-0.1-17.7-14.4-32-32.1-32z"
                }
            }
        ]
    })(props);
}
function AiOutlineUser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsergroupAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineUsergroupDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerified(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683899926",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M447.8 588.8l-7.3-32.5c-0.2-1-0.6-1.9-1.1-2.7-2.5-3.7-7.4-4.7-11.1-2.2L405 567V411c0-4.4-3.6-8-8-8h-81c-4.4 0-8 3.6-8 8v36c0 4.4 3.6 8 8 8h37v192.4c0 1.7 0.5 3.3 1.5 4.7 2.6 3.6 7.6 4.4 11.2 1.8l79-56.8c2.6-1.9 3.8-5.1 3.1-8.3zM391.1 372.2l0.2 0.2c3.2 3 8.3 2.8 11.3-0.5l24.1-26.2c2.9-3.2 2.8-8.1-0.3-11.2l-53.7-52.1c-3.1-3-8.1-3-11.2 0.1l-24.7 24.7c-3.1 3.1-3.1 8.2 0.1 11.3l54.2 53.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 0.7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c0.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M452 297v36c0 4.4 3.6 8 8 8h108v274h-38V405c0-4.4-3.6-8-8-8h-35c-4.4 0-8 3.6-8 8v210h-31c-4.4 0-8 3.6-8 8v37c0 4.4 3.6 8 8 8h244c4.4 0 8-3.6 8-8v-37c0-4.4-3.6-8-8-8h-72V493h58c4.4 0 8-3.6 8-8v-35c0-4.4-3.6-8-8-8h-58V341h63c4.4 0 8-3.6 8-8v-36c0-4.4-3.6-8-8-8H460c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z"
                }
            }
        ]
    })(props);
}
function AiOutlineVerticalRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z"
                }
            }
        ]
    })(props);
}
function AiOutlineVideoCameraAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683915274",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M368 724H252V608c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v116H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h116v116c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V788h116c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v352h72V232h576v560H448v72h272c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM888 625l-104-59.8V458.9L888 399v226z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 360c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112z"
                }
            }
        ]
    })(props);
}
function AiOutlineVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            }
        ]
    })(props);
}
function AiOutlineWechat(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeiboCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeiboSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWeibo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z"
                }
            }
        ]
    })(props);
}
function AiOutlineWhatsApp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "t": "1569683925316",
            "viewBox": "0 0 1024 1024",
            "version": "1.1"
        },
        "child": [
            {
                "tag": "defs",
                "attr": {},
                "child": []
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M713.5 599.9c-10.9-5.6-65.2-32.2-75.3-35.8-10.1-3.8-17.5-5.6-24.8 5.6-7.4 11.1-28.4 35.8-35 43.3-6.4 7.4-12.9 8.3-23.8 2.8-64.8-32.4-107.3-57.8-150-131.1-11.3-19.5 11.3-18.1 32.4-60.2 3.6-7.4 1.8-13.7-1-19.3-2.8-5.6-24.8-59.8-34-81.9-8.9-21.5-18.1-18.5-24.8-18.9-6.4-0.4-13.7-0.4-21.1-0.4-7.4 0-19.3 2.8-29.4 13.7-10.1 11.1-38.6 37.8-38.6 92s39.5 106.7 44.9 114.1c5.6 7.4 77.7 118.6 188.4 166.5 70 30.2 97.4 32.8 132.4 27.6 21.3-3.2 65.2-26.6 74.3-52.5 9.1-25.8 9.1-47.9 6.4-52.5-2.7-4.9-10.1-7.7-21-13z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3-41.3-41.3-89.5-73.8-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6 0.3-119.3 12.3-174.5 35.9-53.3 22.8-101.1 55.2-142 96.5-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9 0.3 69.4 16.9 138.3 48 199.9v152c0 25.4 20.6 46 46 46h152.1c61.6 31.1 130.5 47.7 199.9 48h2.1c59.9 0 118-11.6 172.7-34.3 53.5-22.3 101.6-54.3 142.8-95.2 41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5 0.3-60.9-11.5-120-34.8-175.6z m-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-0.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-0.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-0.6 99.6-39.7 192.9-110.1 262.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineWifi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
                }
            }
        ]
    })(props);
}
function AiOutlineWindows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z"
                }
            }
        ]
    })(props);
}
function AiOutlineWoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z"
                }
            }
        ]
    })(props);
}
function AiOutlineYahoo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z"
                }
            }
        ]
    })(props);
}
function AiOutlineYoutube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z"
                }
            }
        ]
    })(props);
}
function AiOutlineYuque(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z"
                }
            }
        ]
    })(props);
}
function AiOutlineZhihu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z"
                }
            }
        ]
    })(props);
}
function AiOutlineZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    })(props);
}
function AiOutlineZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAccountBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAlert(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z"
                }
            }
        ]
    })(props);
}
function AiTwotoneApi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAppstore(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z"
                }
            }
        ]
    })(props);
}
function AiTwotoneAudio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBank(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M240.9 393.9h542.2L512 196.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBook(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M668 345.9V136h-96v211.4l49.5-35.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBoxPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M296 368h88v288h-88zm152 0h280v288H448z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBug(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M308 412v268c0 36.779 9.678 71.962 27.805 102.907a205.39 205.39 0 0 0 73.288 73.288C440.038 874.322 475.22 884 512 884c36.779 0 71.962-9.678 102.907-27.805a205.39 205.39 0 0 0 73.288-73.288C706.322 751.962 716 716.78 716 680V412H308zm484 172v96c0 6.503-.222 12.954-.658 19.346C859.931 728.636 908 796.705 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.888-59.57-103.697a278.635 278.635 0 0 1-22.658 49.018 281.39 281.39 0 0 1-100.45 100.45C611.84 946.072 563.546 960 512 960s-99.84-13.929-141.321-38.228a281.39 281.39 0 0 1-100.45-100.45 278.635 278.635 0 0 1-22.658-49.019C211.94 793.113 188 831.76 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.295 48.07-147.363 116.658-176.654A284.122 284.122 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.768 0-139-62.232-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 34.794 28.206 63 63 63h560c34.794 0 63-28.206 63-63a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.768-62.232 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.039 8.779-76.746 25.9-108.068 17.235-31.526 42.506-56.797 74.032-74.031C427.254 72.779 463.962 64 504 64h16c40.039 0 76.746 8.779 108.068 25.9 31.526 17.235 56.797 42.506 74.031 74.032C719.221 195.254 728 231.962 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.326-5.938-53.154-17.077-73.531-10.625-19.437-25.955-34.767-45.392-45.392C573.154 141.937 548.326 136 520 136h-16c-28.326 0-53.154 5.938-73.531 17.077-19.437 10.625-34.767 25.955-45.392 45.392C373.937 218.846 368 243.674 368 272z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M308 412v268c0 36.779 9.678 71.962 27.805 102.907a205.39 205.39 0 0 0 73.288 73.288C440.038 874.322 475.22 884 512 884c36.779 0 71.962-9.678 102.907-27.805a205.39 205.39 0 0 0 73.288-73.288C706.322 751.962 716 716.78 716 680V412H308z",
                    "fill": "#E6E6E6"
                }
            }
        ]
    })(props);
}
function AiTwotoneBuild(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M144 546h200v200H144zm268-268h200v200H412z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z"
                }
            }
        ]
    })(props);
}
function AiTwotoneBulb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCalculator(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCarryOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCheckCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCheckSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCiCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCi(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneClockCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloseSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCloud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCompass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    })(props);
}
function AiTwotoneContacts(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            }
        ]
    })(props);
}
function AiTwotoneContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneControl(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopyrightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCopyright(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCreditCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneCustomerService(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M696 632h128v192H696zm-496 0h128v192H200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDatabase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D8D8D8",
                    "d": "M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDelete(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M292.7 840h438.6l24.2-512h-487z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDiff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDislike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDollarCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDollar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDownCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneDownSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEdit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEnvironment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEuroCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEuro(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneExclamationCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneExperiment(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEyeInvisible(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M254.89,758.85,380.46,633.28A176,176,0,0,1,629.28,384.46L757,256.72Q651.69,186.07,512,186,223.7,186,81.8,486.3a60.3,60.3,0,0,0,0,51.5Q151.07,683.71,254.89,758.85Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M942.2,486.2Q889.46,375.11,816.7,305L672.48,449.27A176.09,176.09,0,0,1,445.26,676.48L323,798.75Q408,838,512,838q288.3,0,430.2-300.3A60.29,60.29,0,0,0,942.2,486.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2,486.2Q889.47,375.11,816.7,305l-50.88,50.88C807.31,395.53,843.45,447.4,874.7,512,791.5,684.2,673.4,766,512,766q-72.67,0-133.87-22.38L323,798.75Q408,838,512,838q288.3,0,430.2-300.3A60.29,60.29,0,0,0,942.2,486.2Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.63,165.56,836,122.88a8,8,0,0,0-11.32,0L715.31,232.2Q624.86,186,512,186,223.7,186,81.8,486.3a60.3,60.3,0,0,0,0,51.5q56.69,119.4,136.5,191.41L112.48,835a8,8,0,0,0,0,11.31L155.17,889a8,8,0,0,0,11.31,0L878.63,176.88A8,8,0,0,0,878.63,165.56ZM149.3,512C232.6,339.8,350.7,258,512,258c54.54,0,104.13,9.36,149.12,28.39l-70.3,70.3A176,176,0,0,0,352.69,594.82l-83.42,83.42C223.1,637.49,183.3,582.28,149.3,512ZM396,512A112.11,112.11,0,0,1,542.2,405.31L401.31,546.2A112,112,0,0,1,396,512Z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508,624c-3.46,0-6.87-.16-10.25-.47l-52.82,52.82A176.09,176.09,0,0,0,672.35,448.93l-52.82,52.82c.31,3.38.47,6.79.47,10.25A111.94,111.94,0,0,1,508,624Z"
                }
            }
        ]
    })(props);
}
function AiTwotoneEye(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileExcel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileExclamation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileMarkdown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilePdf(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilePpt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileUnknown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileWord(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFileZip(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M344 630h32v2h-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFilter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFire(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFlag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M184 232h368v336H184z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolderAdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolderOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M159 768h612.3l103.4-256H262.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFolder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M372.5 256H184v512h656V370.4H492.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFrown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFund(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneFunnelPlot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z"
                }
            }
        ]
    })(props);
}
function AiTwotoneGift(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z"
                }
            }
        ]
    })(props);
}
function AiTwotoneGold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHdd(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHighlight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHourglass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z"
                }
            }
        ]
    })(props);
}
function AiTwotoneHtml5(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z"
                }
            }
        ]
    })(props);
}
function AiTwotoneIdcard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInfoCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInsurance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M521.9 358.8h97.9v41.6h-97.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z"
                }
            }
        ]
    })(props);
}
function AiTwotoneInteraction(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLeftCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLeftSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLike(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z"
                }
            }
        ]
    })(props);
}
function AiTwotoneLock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMail(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMedicineBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMeh(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMessage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D8D8D8",
                    "d": "M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMinusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMinusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneMoneyCollect(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z"
                }
            }
        ]
    })(props);
}
function AiTwotoneNotification(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z"
                }
            }
        ]
    })(props);
}
function AiTwotonePauseCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePhone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePicture(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    })(props);
}
function AiTwotonePieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlayCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlaySquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlusCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePlusSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePoundCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePrinter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneProfile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneProject(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotonePropertySafety(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z"
                }
            }
        ]
    })(props);
}
function AiTwotonePushpin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneQuestionCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneReconciliation(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRedEnvelope(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRest(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRightCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRightSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSafetyCertificate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSave(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSchedule(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSecurityScan(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSetting(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z"
                }
            }
        ]
    })(props);
}
function AiTwotoneShop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    })(props);
}
function AiTwotoneShopping(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSkin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSliders(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSmile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSnippets(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSound(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z"
                }
            }
        ]
    })(props);
}
function AiTwotoneStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z"
                }
            }
        ]
    })(props);
}
function AiTwotoneSwitcher(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M184 840h528V312H184v528zm116-290h296v64H300v-64z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M300 550h296v64H300z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTablet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTag(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTags(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneThunderbolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTool(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTrademarkCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z"
                }
            }
        ]
    })(props);
}
function AiTwotoneTrophy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUnlock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUpCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUpSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z"
                }
            }
        ]
    })(props);
}
function AiTwotoneUsb(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z"
                }
            }
        ]
    })(props);
}
function AiTwotoneVideoCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#D9D9D9",
                    "d": "M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    })(props);
}
function AiTwotoneWallet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z"
                }
            }
        ]
    })(props);
}
function AiTwotoneWarning(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 1024 1024"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#E6E6E6",
                    "d": "M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fill": "#333",
                    "d": "M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    })(props);
}

},{"../lib":"9iXc2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dImxq":[function(require,module,exports,__globalThis) {
// THIS FILE IS AUTO GENERATED
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RxAccessibility", ()=>RxAccessibility);
parcelHelpers.export(exports, "RxActivityLog", ()=>RxActivityLog);
parcelHelpers.export(exports, "RxAlignBaseline", ()=>RxAlignBaseline);
parcelHelpers.export(exports, "RxAlignBottom", ()=>RxAlignBottom);
parcelHelpers.export(exports, "RxAlignCenterHorizontally", ()=>RxAlignCenterHorizontally);
parcelHelpers.export(exports, "RxAlignCenterVertically", ()=>RxAlignCenterVertically);
parcelHelpers.export(exports, "RxAlignLeft", ()=>RxAlignLeft);
parcelHelpers.export(exports, "RxAlignRight", ()=>RxAlignRight);
parcelHelpers.export(exports, "RxAlignTop", ()=>RxAlignTop);
parcelHelpers.export(exports, "RxAllSides", ()=>RxAllSides);
parcelHelpers.export(exports, "RxAngle", ()=>RxAngle);
parcelHelpers.export(exports, "RxArchive", ()=>RxArchive);
parcelHelpers.export(exports, "RxArrowBottomLeft", ()=>RxArrowBottomLeft);
parcelHelpers.export(exports, "RxArrowBottomRight", ()=>RxArrowBottomRight);
parcelHelpers.export(exports, "RxArrowDown", ()=>RxArrowDown);
parcelHelpers.export(exports, "RxArrowLeft", ()=>RxArrowLeft);
parcelHelpers.export(exports, "RxArrowRight", ()=>RxArrowRight);
parcelHelpers.export(exports, "RxArrowTopLeft", ()=>RxArrowTopLeft);
parcelHelpers.export(exports, "RxArrowTopRight", ()=>RxArrowTopRight);
parcelHelpers.export(exports, "RxArrowUp", ()=>RxArrowUp);
parcelHelpers.export(exports, "RxAspectRatio", ()=>RxAspectRatio);
parcelHelpers.export(exports, "RxAvatar", ()=>RxAvatar);
parcelHelpers.export(exports, "RxBackpack", ()=>RxBackpack);
parcelHelpers.export(exports, "RxBadge", ()=>RxBadge);
parcelHelpers.export(exports, "RxBarChart", ()=>RxBarChart);
parcelHelpers.export(exports, "RxBell", ()=>RxBell);
parcelHelpers.export(exports, "RxBlendingMode", ()=>RxBlendingMode);
parcelHelpers.export(exports, "RxBookmarkFilled", ()=>RxBookmarkFilled);
parcelHelpers.export(exports, "RxBookmark", ()=>RxBookmark);
parcelHelpers.export(exports, "RxBorderAll", ()=>RxBorderAll);
parcelHelpers.export(exports, "RxBorderBottom", ()=>RxBorderBottom);
parcelHelpers.export(exports, "RxBorderDashed", ()=>RxBorderDashed);
parcelHelpers.export(exports, "RxBorderDotted", ()=>RxBorderDotted);
parcelHelpers.export(exports, "RxBorderLeft", ()=>RxBorderLeft);
parcelHelpers.export(exports, "RxBorderNone", ()=>RxBorderNone);
parcelHelpers.export(exports, "RxBorderRight", ()=>RxBorderRight);
parcelHelpers.export(exports, "RxBorderSolid", ()=>RxBorderSolid);
parcelHelpers.export(exports, "RxBorderSplit", ()=>RxBorderSplit);
parcelHelpers.export(exports, "RxBorderStyle", ()=>RxBorderStyle);
parcelHelpers.export(exports, "RxBorderTop", ()=>RxBorderTop);
parcelHelpers.export(exports, "RxBorderWidth", ()=>RxBorderWidth);
parcelHelpers.export(exports, "RxBoxModel", ()=>RxBoxModel);
parcelHelpers.export(exports, "RxBox", ()=>RxBox);
parcelHelpers.export(exports, "RxButton", ()=>RxButton);
parcelHelpers.export(exports, "RxCalendar", ()=>RxCalendar);
parcelHelpers.export(exports, "RxCamera", ()=>RxCamera);
parcelHelpers.export(exports, "RxCardStackMinus", ()=>RxCardStackMinus);
parcelHelpers.export(exports, "RxCardStackPlus", ()=>RxCardStackPlus);
parcelHelpers.export(exports, "RxCardStack", ()=>RxCardStack);
parcelHelpers.export(exports, "RxCaretDown", ()=>RxCaretDown);
parcelHelpers.export(exports, "RxCaretLeft", ()=>RxCaretLeft);
parcelHelpers.export(exports, "RxCaretRight", ()=>RxCaretRight);
parcelHelpers.export(exports, "RxCaretSort", ()=>RxCaretSort);
parcelHelpers.export(exports, "RxCaretUp", ()=>RxCaretUp);
parcelHelpers.export(exports, "RxChatBubble", ()=>RxChatBubble);
parcelHelpers.export(exports, "RxCheckCircled", ()=>RxCheckCircled);
parcelHelpers.export(exports, "RxCheck", ()=>RxCheck);
parcelHelpers.export(exports, "RxCheckbox", ()=>RxCheckbox);
parcelHelpers.export(exports, "RxChevronDown", ()=>RxChevronDown);
parcelHelpers.export(exports, "RxChevronLeft", ()=>RxChevronLeft);
parcelHelpers.export(exports, "RxChevronRight", ()=>RxChevronRight);
parcelHelpers.export(exports, "RxChevronUp", ()=>RxChevronUp);
parcelHelpers.export(exports, "RxCircleBackslash", ()=>RxCircleBackslash);
parcelHelpers.export(exports, "RxCircle", ()=>RxCircle);
parcelHelpers.export(exports, "RxClipboardCopy", ()=>RxClipboardCopy);
parcelHelpers.export(exports, "RxClipboard", ()=>RxClipboard);
parcelHelpers.export(exports, "RxClock", ()=>RxClock);
parcelHelpers.export(exports, "RxCode", ()=>RxCode);
parcelHelpers.export(exports, "RxCodesandboxLogo", ()=>RxCodesandboxLogo);
parcelHelpers.export(exports, "RxColorWheel", ()=>RxColorWheel);
parcelHelpers.export(exports, "RxColumnSpacing", ()=>RxColumnSpacing);
parcelHelpers.export(exports, "RxColumns", ()=>RxColumns);
parcelHelpers.export(exports, "RxCommit", ()=>RxCommit);
parcelHelpers.export(exports, "RxComponent1", ()=>RxComponent1);
parcelHelpers.export(exports, "RxComponent2", ()=>RxComponent2);
parcelHelpers.export(exports, "RxComponentBoolean", ()=>RxComponentBoolean);
parcelHelpers.export(exports, "RxComponentInstance", ()=>RxComponentInstance);
parcelHelpers.export(exports, "RxComponentNone", ()=>RxComponentNone);
parcelHelpers.export(exports, "RxComponentPlaceholder", ()=>RxComponentPlaceholder);
parcelHelpers.export(exports, "RxContainer", ()=>RxContainer);
parcelHelpers.export(exports, "RxCookie", ()=>RxCookie);
parcelHelpers.export(exports, "RxCopy", ()=>RxCopy);
parcelHelpers.export(exports, "RxCornerBottomLeft", ()=>RxCornerBottomLeft);
parcelHelpers.export(exports, "RxCornerBottomRight", ()=>RxCornerBottomRight);
parcelHelpers.export(exports, "RxCornerTopLeft", ()=>RxCornerTopLeft);
parcelHelpers.export(exports, "RxCornerTopRight", ()=>RxCornerTopRight);
parcelHelpers.export(exports, "RxCorners", ()=>RxCorners);
parcelHelpers.export(exports, "RxCountdownTimer", ()=>RxCountdownTimer);
parcelHelpers.export(exports, "RxCounterClockwiseClock", ()=>RxCounterClockwiseClock);
parcelHelpers.export(exports, "RxCrop", ()=>RxCrop);
parcelHelpers.export(exports, "RxCross1", ()=>RxCross1);
parcelHelpers.export(exports, "RxCross2", ()=>RxCross2);
parcelHelpers.export(exports, "RxCrossCircled", ()=>RxCrossCircled);
parcelHelpers.export(exports, "RxCrosshair1", ()=>RxCrosshair1);
parcelHelpers.export(exports, "RxCrosshair2", ()=>RxCrosshair2);
parcelHelpers.export(exports, "RxCrumpledPaper", ()=>RxCrumpledPaper);
parcelHelpers.export(exports, "RxCube", ()=>RxCube);
parcelHelpers.export(exports, "RxCursorArrow", ()=>RxCursorArrow);
parcelHelpers.export(exports, "RxCursorText", ()=>RxCursorText);
parcelHelpers.export(exports, "RxDash", ()=>RxDash);
parcelHelpers.export(exports, "RxDashboard", ()=>RxDashboard);
parcelHelpers.export(exports, "RxDesktop", ()=>RxDesktop);
parcelHelpers.export(exports, "RxDimensions", ()=>RxDimensions);
parcelHelpers.export(exports, "RxDisc", ()=>RxDisc);
parcelHelpers.export(exports, "RxDiscordLogo", ()=>RxDiscordLogo);
parcelHelpers.export(exports, "RxDividerHorizontal", ()=>RxDividerHorizontal);
parcelHelpers.export(exports, "RxDividerVertical", ()=>RxDividerVertical);
parcelHelpers.export(exports, "RxDotFilled", ()=>RxDotFilled);
parcelHelpers.export(exports, "RxDot", ()=>RxDot);
parcelHelpers.export(exports, "RxDotsHorizontal", ()=>RxDotsHorizontal);
parcelHelpers.export(exports, "RxDotsVertical", ()=>RxDotsVertical);
parcelHelpers.export(exports, "RxDoubleArrowDown", ()=>RxDoubleArrowDown);
parcelHelpers.export(exports, "RxDoubleArrowLeft", ()=>RxDoubleArrowLeft);
parcelHelpers.export(exports, "RxDoubleArrowRight", ()=>RxDoubleArrowRight);
parcelHelpers.export(exports, "RxDoubleArrowUp", ()=>RxDoubleArrowUp);
parcelHelpers.export(exports, "RxDownload", ()=>RxDownload);
parcelHelpers.export(exports, "RxDragHandleDots1", ()=>RxDragHandleDots1);
parcelHelpers.export(exports, "RxDragHandleDots2", ()=>RxDragHandleDots2);
parcelHelpers.export(exports, "RxDragHandleHorizontal", ()=>RxDragHandleHorizontal);
parcelHelpers.export(exports, "RxDragHandleVertical", ()=>RxDragHandleVertical);
parcelHelpers.export(exports, "RxDrawingPinFilled", ()=>RxDrawingPinFilled);
parcelHelpers.export(exports, "RxDrawingPin", ()=>RxDrawingPin);
parcelHelpers.export(exports, "RxDropdownMenu", ()=>RxDropdownMenu);
parcelHelpers.export(exports, "RxEnterFullScreen", ()=>RxEnterFullScreen);
parcelHelpers.export(exports, "RxEnter", ()=>RxEnter);
parcelHelpers.export(exports, "RxEnvelopeClosed", ()=>RxEnvelopeClosed);
parcelHelpers.export(exports, "RxEnvelopeOpen", ()=>RxEnvelopeOpen);
parcelHelpers.export(exports, "RxEraser", ()=>RxEraser);
parcelHelpers.export(exports, "RxExclamationTriangle", ()=>RxExclamationTriangle);
parcelHelpers.export(exports, "RxExitFullScreen", ()=>RxExitFullScreen);
parcelHelpers.export(exports, "RxExit", ()=>RxExit);
parcelHelpers.export(exports, "RxExternalLink", ()=>RxExternalLink);
parcelHelpers.export(exports, "RxEyeClosed", ()=>RxEyeClosed);
parcelHelpers.export(exports, "RxEyeNone", ()=>RxEyeNone);
parcelHelpers.export(exports, "RxEyeOpen", ()=>RxEyeOpen);
parcelHelpers.export(exports, "RxFace", ()=>RxFace);
parcelHelpers.export(exports, "RxFigmaLogo", ()=>RxFigmaLogo);
parcelHelpers.export(exports, "RxFileMinus", ()=>RxFileMinus);
parcelHelpers.export(exports, "RxFilePlus", ()=>RxFilePlus);
parcelHelpers.export(exports, "RxFileText", ()=>RxFileText);
parcelHelpers.export(exports, "RxFile", ()=>RxFile);
parcelHelpers.export(exports, "RxFontBold", ()=>RxFontBold);
parcelHelpers.export(exports, "RxFontFamily", ()=>RxFontFamily);
parcelHelpers.export(exports, "RxFontItalic", ()=>RxFontItalic);
parcelHelpers.export(exports, "RxFontRoman", ()=>RxFontRoman);
parcelHelpers.export(exports, "RxFontSize", ()=>RxFontSize);
parcelHelpers.export(exports, "RxFontStyle", ()=>RxFontStyle);
parcelHelpers.export(exports, "RxFrame", ()=>RxFrame);
parcelHelpers.export(exports, "RxFramerLogo", ()=>RxFramerLogo);
parcelHelpers.export(exports, "RxGear", ()=>RxGear);
parcelHelpers.export(exports, "RxGithubLogo", ()=>RxGithubLogo);
parcelHelpers.export(exports, "RxGlobe", ()=>RxGlobe);
parcelHelpers.export(exports, "RxGrid", ()=>RxGrid);
parcelHelpers.export(exports, "RxGroup", ()=>RxGroup);
parcelHelpers.export(exports, "RxHalf1", ()=>RxHalf1);
parcelHelpers.export(exports, "RxHalf2", ()=>RxHalf2);
parcelHelpers.export(exports, "RxHamburgerMenu", ()=>RxHamburgerMenu);
parcelHelpers.export(exports, "RxHand", ()=>RxHand);
parcelHelpers.export(exports, "RxHeading", ()=>RxHeading);
parcelHelpers.export(exports, "RxHeartFilled", ()=>RxHeartFilled);
parcelHelpers.export(exports, "RxHeart", ()=>RxHeart);
parcelHelpers.export(exports, "RxHeight", ()=>RxHeight);
parcelHelpers.export(exports, "RxHobbyKnife", ()=>RxHobbyKnife);
parcelHelpers.export(exports, "RxHome", ()=>RxHome);
parcelHelpers.export(exports, "RxIconjarLogo", ()=>RxIconjarLogo);
parcelHelpers.export(exports, "RxIdCard", ()=>RxIdCard);
parcelHelpers.export(exports, "RxImage", ()=>RxImage);
parcelHelpers.export(exports, "RxInfoCircled", ()=>RxInfoCircled);
parcelHelpers.export(exports, "RxInput", ()=>RxInput);
parcelHelpers.export(exports, "RxInstagramLogo", ()=>RxInstagramLogo);
parcelHelpers.export(exports, "RxKeyboard", ()=>RxKeyboard);
parcelHelpers.export(exports, "RxLapTimer", ()=>RxLapTimer);
parcelHelpers.export(exports, "RxLaptop", ()=>RxLaptop);
parcelHelpers.export(exports, "RxLayers", ()=>RxLayers);
parcelHelpers.export(exports, "RxLayout", ()=>RxLayout);
parcelHelpers.export(exports, "RxLetterCaseCapitalize", ()=>RxLetterCaseCapitalize);
parcelHelpers.export(exports, "RxLetterCaseLowercase", ()=>RxLetterCaseLowercase);
parcelHelpers.export(exports, "RxLetterCaseToggle", ()=>RxLetterCaseToggle);
parcelHelpers.export(exports, "RxLetterCaseUppercase", ()=>RxLetterCaseUppercase);
parcelHelpers.export(exports, "RxLetterSpacing", ()=>RxLetterSpacing);
parcelHelpers.export(exports, "RxLightningBolt", ()=>RxLightningBolt);
parcelHelpers.export(exports, "RxLineHeight", ()=>RxLineHeight);
parcelHelpers.export(exports, "RxLink1", ()=>RxLink1);
parcelHelpers.export(exports, "RxLink2", ()=>RxLink2);
parcelHelpers.export(exports, "RxLinkBreak1", ()=>RxLinkBreak1);
parcelHelpers.export(exports, "RxLinkBreak2", ()=>RxLinkBreak2);
parcelHelpers.export(exports, "RxLinkNone1", ()=>RxLinkNone1);
parcelHelpers.export(exports, "RxLinkNone2", ()=>RxLinkNone2);
parcelHelpers.export(exports, "RxLinkedinLogo", ()=>RxLinkedinLogo);
parcelHelpers.export(exports, "RxListBullet", ()=>RxListBullet);
parcelHelpers.export(exports, "RxLockClosed", ()=>RxLockClosed);
parcelHelpers.export(exports, "RxLockOpen1", ()=>RxLockOpen1);
parcelHelpers.export(exports, "RxLockOpen2", ()=>RxLockOpen2);
parcelHelpers.export(exports, "RxLoop", ()=>RxLoop);
parcelHelpers.export(exports, "RxMagicWand", ()=>RxMagicWand);
parcelHelpers.export(exports, "RxMagnifyingGlass", ()=>RxMagnifyingGlass);
parcelHelpers.export(exports, "RxMargin", ()=>RxMargin);
parcelHelpers.export(exports, "RxMaskOff", ()=>RxMaskOff);
parcelHelpers.export(exports, "RxMaskOn", ()=>RxMaskOn);
parcelHelpers.export(exports, "RxMinusCircled", ()=>RxMinusCircled);
parcelHelpers.export(exports, "RxMinus", ()=>RxMinus);
parcelHelpers.export(exports, "RxMix", ()=>RxMix);
parcelHelpers.export(exports, "RxMixerHorizontal", ()=>RxMixerHorizontal);
parcelHelpers.export(exports, "RxMixerVertical", ()=>RxMixerVertical);
parcelHelpers.export(exports, "RxMobile", ()=>RxMobile);
parcelHelpers.export(exports, "RxModulzLogo", ()=>RxModulzLogo);
parcelHelpers.export(exports, "RxMoon", ()=>RxMoon);
parcelHelpers.export(exports, "RxMove", ()=>RxMove);
parcelHelpers.export(exports, "RxNotionLogo", ()=>RxNotionLogo);
parcelHelpers.export(exports, "RxOpacity", ()=>RxOpacity);
parcelHelpers.export(exports, "RxOpenInNewWindow", ()=>RxOpenInNewWindow);
parcelHelpers.export(exports, "RxOverline", ()=>RxOverline);
parcelHelpers.export(exports, "RxPadding", ()=>RxPadding);
parcelHelpers.export(exports, "RxPaperPlane", ()=>RxPaperPlane);
parcelHelpers.export(exports, "RxPause", ()=>RxPause);
parcelHelpers.export(exports, "RxPencil1", ()=>RxPencil1);
parcelHelpers.export(exports, "RxPencil2", ()=>RxPencil2);
parcelHelpers.export(exports, "RxPerson", ()=>RxPerson);
parcelHelpers.export(exports, "RxPieChart", ()=>RxPieChart);
parcelHelpers.export(exports, "RxPilcrow", ()=>RxPilcrow);
parcelHelpers.export(exports, "RxPinBottom", ()=>RxPinBottom);
parcelHelpers.export(exports, "RxPinLeft", ()=>RxPinLeft);
parcelHelpers.export(exports, "RxPinRight", ()=>RxPinRight);
parcelHelpers.export(exports, "RxPinTop", ()=>RxPinTop);
parcelHelpers.export(exports, "RxPlay", ()=>RxPlay);
parcelHelpers.export(exports, "RxPlusCircled", ()=>RxPlusCircled);
parcelHelpers.export(exports, "RxPlus", ()=>RxPlus);
parcelHelpers.export(exports, "RxQuestionMarkCircled", ()=>RxQuestionMarkCircled);
parcelHelpers.export(exports, "RxQuestionMark", ()=>RxQuestionMark);
parcelHelpers.export(exports, "RxQuote", ()=>RxQuote);
parcelHelpers.export(exports, "RxRadiobutton", ()=>RxRadiobutton);
parcelHelpers.export(exports, "RxReader", ()=>RxReader);
parcelHelpers.export(exports, "RxReload", ()=>RxReload);
parcelHelpers.export(exports, "RxReset", ()=>RxReset);
parcelHelpers.export(exports, "RxResume", ()=>RxResume);
parcelHelpers.export(exports, "RxRocket", ()=>RxRocket);
parcelHelpers.export(exports, "RxRotateCounterClockwise", ()=>RxRotateCounterClockwise);
parcelHelpers.export(exports, "RxRowSpacing", ()=>RxRowSpacing);
parcelHelpers.export(exports, "RxRows", ()=>RxRows);
parcelHelpers.export(exports, "RxRulerHorizontal", ()=>RxRulerHorizontal);
parcelHelpers.export(exports, "RxRulerSquare", ()=>RxRulerSquare);
parcelHelpers.export(exports, "RxScissors", ()=>RxScissors);
parcelHelpers.export(exports, "RxSection", ()=>RxSection);
parcelHelpers.export(exports, "RxSewingPinFilled", ()=>RxSewingPinFilled);
parcelHelpers.export(exports, "RxSewingPin", ()=>RxSewingPin);
parcelHelpers.export(exports, "RxShadowInner", ()=>RxShadowInner);
parcelHelpers.export(exports, "RxShadowNone", ()=>RxShadowNone);
parcelHelpers.export(exports, "RxShadowOuter", ()=>RxShadowOuter);
parcelHelpers.export(exports, "RxShadow", ()=>RxShadow);
parcelHelpers.export(exports, "RxShare1", ()=>RxShare1);
parcelHelpers.export(exports, "RxShare2", ()=>RxShare2);
parcelHelpers.export(exports, "RxShuffle", ()=>RxShuffle);
parcelHelpers.export(exports, "RxSize", ()=>RxSize);
parcelHelpers.export(exports, "RxSketchLogo", ()=>RxSketchLogo);
parcelHelpers.export(exports, "RxSlash", ()=>RxSlash);
parcelHelpers.export(exports, "RxSlider", ()=>RxSlider);
parcelHelpers.export(exports, "RxSpaceBetweenHorizontally", ()=>RxSpaceBetweenHorizontally);
parcelHelpers.export(exports, "RxSpaceBetweenVertically", ()=>RxSpaceBetweenVertically);
parcelHelpers.export(exports, "RxSpaceEvenlyHorizontally", ()=>RxSpaceEvenlyHorizontally);
parcelHelpers.export(exports, "RxSpaceEvenlyVertically", ()=>RxSpaceEvenlyVertically);
parcelHelpers.export(exports, "RxSpeakerLoud", ()=>RxSpeakerLoud);
parcelHelpers.export(exports, "RxSpeakerModerate", ()=>RxSpeakerModerate);
parcelHelpers.export(exports, "RxSpeakerOff", ()=>RxSpeakerOff);
parcelHelpers.export(exports, "RxSpeakerQuiet", ()=>RxSpeakerQuiet);
parcelHelpers.export(exports, "RxSquare", ()=>RxSquare);
parcelHelpers.export(exports, "RxStack", ()=>RxStack);
parcelHelpers.export(exports, "RxStarFilled", ()=>RxStarFilled);
parcelHelpers.export(exports, "RxStar", ()=>RxStar);
parcelHelpers.export(exports, "RxStitchesLogo", ()=>RxStitchesLogo);
parcelHelpers.export(exports, "RxStop", ()=>RxStop);
parcelHelpers.export(exports, "RxStopwatch", ()=>RxStopwatch);
parcelHelpers.export(exports, "RxStretchHorizontally", ()=>RxStretchHorizontally);
parcelHelpers.export(exports, "RxStretchVertically", ()=>RxStretchVertically);
parcelHelpers.export(exports, "RxStrikethrough", ()=>RxStrikethrough);
parcelHelpers.export(exports, "RxSun", ()=>RxSun);
parcelHelpers.export(exports, "RxSwitch", ()=>RxSwitch);
parcelHelpers.export(exports, "RxSymbol", ()=>RxSymbol);
parcelHelpers.export(exports, "RxTable", ()=>RxTable);
parcelHelpers.export(exports, "RxTarget", ()=>RxTarget);
parcelHelpers.export(exports, "RxTextAlignBottom", ()=>RxTextAlignBottom);
parcelHelpers.export(exports, "RxTextAlignCenter", ()=>RxTextAlignCenter);
parcelHelpers.export(exports, "RxTextAlignJustify", ()=>RxTextAlignJustify);
parcelHelpers.export(exports, "RxTextAlignLeft", ()=>RxTextAlignLeft);
parcelHelpers.export(exports, "RxTextAlignMiddle", ()=>RxTextAlignMiddle);
parcelHelpers.export(exports, "RxTextAlignRight", ()=>RxTextAlignRight);
parcelHelpers.export(exports, "RxTextAlignTop", ()=>RxTextAlignTop);
parcelHelpers.export(exports, "RxTextNone", ()=>RxTextNone);
parcelHelpers.export(exports, "RxText", ()=>RxText);
parcelHelpers.export(exports, "RxThickArrowDown", ()=>RxThickArrowDown);
parcelHelpers.export(exports, "RxThickArrowLeft", ()=>RxThickArrowLeft);
parcelHelpers.export(exports, "RxThickArrowRight", ()=>RxThickArrowRight);
parcelHelpers.export(exports, "RxThickArrowUp", ()=>RxThickArrowUp);
parcelHelpers.export(exports, "RxTimer", ()=>RxTimer);
parcelHelpers.export(exports, "RxTokens", ()=>RxTokens);
parcelHelpers.export(exports, "RxTrackNext", ()=>RxTrackNext);
parcelHelpers.export(exports, "RxTrackPrevious", ()=>RxTrackPrevious);
parcelHelpers.export(exports, "RxTransform", ()=>RxTransform);
parcelHelpers.export(exports, "RxTransparencyGrid", ()=>RxTransparencyGrid);
parcelHelpers.export(exports, "RxTrash", ()=>RxTrash);
parcelHelpers.export(exports, "RxTriangleDown", ()=>RxTriangleDown);
parcelHelpers.export(exports, "RxTriangleLeft", ()=>RxTriangleLeft);
parcelHelpers.export(exports, "RxTriangleRight", ()=>RxTriangleRight);
parcelHelpers.export(exports, "RxTriangleUp", ()=>RxTriangleUp);
parcelHelpers.export(exports, "RxTwitterLogo", ()=>RxTwitterLogo);
parcelHelpers.export(exports, "RxUnderline", ()=>RxUnderline);
parcelHelpers.export(exports, "RxUpdate", ()=>RxUpdate);
parcelHelpers.export(exports, "RxUpload", ()=>RxUpload);
parcelHelpers.export(exports, "RxValueNone", ()=>RxValueNone);
parcelHelpers.export(exports, "RxValue", ()=>RxValue);
parcelHelpers.export(exports, "RxVercelLogo", ()=>RxVercelLogo);
parcelHelpers.export(exports, "RxVideo", ()=>RxVideo);
parcelHelpers.export(exports, "RxViewGrid", ()=>RxViewGrid);
parcelHelpers.export(exports, "RxViewHorizontal", ()=>RxViewHorizontal);
parcelHelpers.export(exports, "RxViewNone", ()=>RxViewNone);
parcelHelpers.export(exports, "RxViewVertical", ()=>RxViewVertical);
parcelHelpers.export(exports, "RxWidth", ()=>RxWidth);
parcelHelpers.export(exports, "RxZoomIn", ()=>RxZoomIn);
parcelHelpers.export(exports, "RxZoomOut", ()=>RxZoomOut);
var _lib = require("../lib");
function RxAccessibility(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877197 7.49984C0.877197 3.84216 3.84234 0.877014 7.50003 0.877014C11.1577 0.877014 14.1229 3.84216 14.1229 7.49984C14.1229 11.1575 11.1577 14.1227 7.50003 14.1227C3.84234 14.1227 0.877197 11.1575 0.877197 7.49984ZM7.50003 1.82701C4.36702 1.82701 1.8272 4.36683 1.8272 7.49984C1.8272 10.6328 4.36702 13.1727 7.50003 13.1727C10.633 13.1727 13.1729 10.6328 13.1729 7.49984C13.1729 4.36683 10.633 1.82701 7.50003 1.82701ZM7.12457 9.00001C7.06994 9.12735 6.33165 11.9592 6.33165 11.9592C6.26018 12.226 5.98601 12.3843 5.71928 12.3128C5.45255 12.2413 5.29425 11.9672 5.36573 11.7004C5.36573 11.7004 6.24661 8.87268 6.24661 8.27007V6.80099L4.28763 6.27608C4.0209 6.20461 3.86261 5.93045 3.93408 5.66371C4.00555 5.39698 4.27972 5.23869 4.54645 5.31016C4.54645 5.31016 6.20042 5.87268 6.84579 5.87268H8.15505C8.80042 5.87268 10.4534 5.31042 10.4534 5.31042C10.7202 5.23895 10.9943 5.39724 11.0658 5.66397C11.1373 5.93071 10.979 6.20487 10.7122 6.27635L8.74661 6.80303V8.27007C8.74661 8.87268 9.62663 11.6971 9.62663 11.6971C9.6981 11.9639 9.5398 12.238 9.27307 12.3095C9.00634 12.381 8.73217 12.2227 8.6607 11.956C8.6607 11.956 7.91994 9.12735 7.86866 9.00001C7.81994 8.87268 7.65006 8.87268 7.65006 8.87268H7.34317C7.34317 8.87268 7.16994 8.87268 7.12457 9.00001ZM7.50043 5.12007C8.12175 5.12007 8.62543 4.61639 8.62543 3.99507C8.62543 3.37375 8.12175 2.87007 7.50043 2.87007C6.87911 2.87007 6.37543 3.37375 6.37543 3.99507C6.37543 4.61639 6.87911 5.12007 7.50043 5.12007Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxActivityLog(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 1.5C0 1.22386 0.223858 1 0.5 1H2.5C2.77614 1 3 1.22386 3 1.5C3 1.77614 2.77614 2 2.5 2H0.5C0.223858 2 0 1.77614 0 1.5ZM4 1.5C4 1.22386 4.22386 1 4.5 1H14.5C14.7761 1 15 1.22386 15 1.5C15 1.77614 14.7761 2 14.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM4 4.5C4 4.22386 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5C12 4.77614 11.7761 5 11.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM0 7.5C0 7.22386 0.223858 7 0.5 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H0.5C0.223858 8 0 7.77614 0 7.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H4.5C4.22386 11 4 10.7761 4 10.5ZM0 13.5C0 13.2239 0.223858 13 0.5 13H2.5C2.77614 13 3 13.2239 3 13.5C3 13.7761 2.77614 14 2.5 14H0.5C0.223858 14 0 13.7761 0 13.5ZM4 13.5C4 13.2239 4.22386 13 4.5 13H14.5C14.7761 13 15 13.2239 15 13.5C15 13.7761 14.7761 14 14.5 14H4.5C4.22386 14 4 13.7761 4 13.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignBaseline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.5 1.75003C10.7107 1.75003 10.8988 1.88217 10.9703 2.08042L13.9703 10.4C14.064 10.6598 13.9293 10.9463 13.6696 11.04C13.4098 11.1336 13.1233 10.999 13.0296 10.7392L12.0477 8.01606H8.95227L7.97031 10.7392C7.87664 10.999 7.59012 11.1336 7.33035 11.04C7.07058 10.9463 6.93593 10.6598 7.0296 10.4L10.0296 2.08042C10.1011 1.88217 10.2892 1.75003 10.5 1.75003ZM10.5 3.72402L11.7411 7.16606H9.25877L10.5 3.72402ZM2.49949 2.09997C2.7204 2.09997 2.89949 2.27906 2.89949 2.49997L2.89949 9.53428L4.21664 8.21713C4.37285 8.06092 4.62612 8.06092 4.78233 8.21713C4.93854 8.37334 4.93854 8.6266 4.78233 8.78281L2.78233 10.7828C2.70732 10.8578 2.60557 10.9 2.49949 10.9C2.3934 10.9 2.29166 10.8578 2.21664 10.7828L0.216645 8.78281C0.0604349 8.6266 0.0604349 8.37334 0.216645 8.21713C0.372854 8.06092 0.62612 8.06092 0.78233 8.21713L2.09949 9.53428L2.09949 2.49997C2.09949 2.27906 2.27857 2.09997 2.49949 2.09997ZM0.0999695 13.5001C0.0999695 13.2791 0.279056 13.1001 0.499969 13.1001H14.5C14.7209 13.1001 14.9 13.2791 14.9 13.5001C14.9 13.721 14.7209 13.9001 14.5 13.9001H0.499969C0.279056 13.9001 0.0999695 13.721 0.0999695 13.5001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 3C9 2.44772 8.55229 2 8 2H7C6.44772 2 6 2.44772 6 3L6 14H1.5C1.22386 14 1 14.2239 1 14.5C1 14.7761 1.22386 15 1.5 15L6 15H9H13.5C13.7761 15 14 14.7761 14 14.5C14 14.2239 13.7761 14 13.5 14H9V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignCenterHorizontally(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.99988 6C1.44759 6 0.999877 6.44772 0.999877 7L0.999877 8C0.999877 8.55228 1.44759 9 1.99988 9L6.99988 9L6.99988 13.5C6.99988 13.7761 7.22374 14 7.49988 14C7.77602 14 7.99988 13.7761 7.99988 13.5L7.99988 9L12.9999 9C13.5522 9 13.9999 8.55228 13.9999 8L13.9999 7C13.9999 6.44772 13.5522 6 12.9999 6L7.99988 6L7.99988 1.5C7.99988 1.22386 7.77602 1 7.49988 1C7.22373 1 6.99988 1.22386 6.99988 1.5L6.99988 6L1.99988 6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignCenterVertically(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.99988 1C6.44759 1 5.99988 1.44772 5.99988 2V7H1.49988C1.22374 7 0.999878 7.22386 0.999878 7.5C0.999878 7.77614 1.22374 8 1.49988 8H5.99988V13C5.99988 13.5523 6.44759 14 6.99988 14H7.99988C8.55216 14 8.99988 13.5523 8.99988 13V8H13.4999C13.776 8 13.9999 7.77614 13.9999 7.5C13.9999 7.22386 13.776 7 13.4999 7H8.99988V2C8.99988 1.44772 8.55216 1 7.99988 1L6.99988 1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.499995 0.999995C0.223855 0.999995 -5.58458e-07 1.22385 -5.46388e-07 1.49999L-2.18554e-08 13.4999C-9.78492e-09 13.776 0.223855 13.9999 0.499995 13.9999C0.776136 13.9999 0.999991 13.776 0.999991 13.4999L0.999991 8.99993L12 8.99993C12.5523 8.99993 13 8.55222 13 7.99993L13 6.99994C13 6.44766 12.5523 5.99995 12 5.99995L0.999991 5.99995L0.999991 1.49999C0.999991 1.22385 0.776135 0.999995 0.499995 0.999995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.4999 1C14.2237 1 13.9999 1.22386 13.9999 1.5L13.9999 6L2.99988 6C2.44759 6 1.99988 6.44772 1.99988 7L1.99988 8C1.99988 8.55228 2.44759 9 2.99988 9L13.9999 9L13.9999 13.5C13.9999 13.7761 14.2237 14 14.4999 14C14.776 14 14.9999 13.7761 14.9999 13.5L14.9999 9L14.9999 6L14.9999 1.5C14.9999 1.22386 14.776 1 14.4999 1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 0C1.22386 0 1 0.223858 1 0.5C1 0.776142 1.22386 1 1.5 1H6V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V1H13.5C13.7761 1 14 0.776142 14 0.5C14 0.223858 13.7761 0 13.5 0H9H6H1.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAllSides(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 0.75L9.75 3H5.25L7.5 0.75ZM7.5 14.25L9.75 12H5.25L7.5 14.25ZM3 5.25L0.75 7.5L3 9.75V5.25ZM14.25 7.5L12 5.25V9.75L14.25 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAngle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.8914 2.1937C9.1158 2.35464 9.16725 2.66701 9.00631 2.89141L2.47388 12H13.5C13.7761 12 14 12.2239 14 12.5C14 12.7762 13.7761 13 13.5 13H1.5C1.31254 13 1.14082 12.8952 1.0552 12.7284C0.969578 12.5616 0.984438 12.361 1.09369 12.2086L8.19369 2.30862C8.35462 2.08422 8.667 2.03277 8.8914 2.1937ZM11.1 6.50001C11.1 6.22387 11.3238 6.00001 11.6 6.00001C11.8761 6.00001 12.1 6.22387 12.1 6.50001C12.1 6.77615 11.8761 7.00001 11.6 7.00001C11.3238 7.00001 11.1 6.77615 11.1 6.50001ZM10.4 4.00001C10.1239 4.00001 9.90003 4.22387 9.90003 4.50001C9.90003 4.77615 10.1239 5.00001 10.4 5.00001C10.6762 5.00001 10.9 4.77615 10.9 4.50001C10.9 4.22387 10.6762 4.00001 10.4 4.00001ZM12.1 8.50001C12.1 8.22387 12.3238 8.00001 12.6 8.00001C12.8761 8.00001 13.1 8.22387 13.1 8.50001C13.1 8.77615 12.8761 9.00001 12.6 9.00001C12.3238 9.00001 12.1 8.77615 12.1 8.50001ZM13.4 10C13.1239 10 12.9 10.2239 12.9 10.5C12.9 10.7761 13.1239 11 13.4 11C13.6762 11 13.9 10.7761 13.9 10.5C13.9 10.2239 13.6762 10 13.4 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArchive(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.30902 1C2.93025 1 2.58398 1.214 2.41459 1.55279L1.05279 4.27639C1.01807 4.34582 1 4.42238 1 4.5V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V4.5C14 4.42238 13.9819 4.34582 13.9472 4.27639L12.5854 1.55281C12.416 1.21403 12.0698 1.00003 11.691 1.00003L7.5 1.00001L3.30902 1ZM3.30902 2L7 2.00001V4H2.30902L3.30902 2ZM8 4V2.00002L11.691 2.00003L12.691 4H8ZM7.5 5H13V13H2V5H7.5ZM5.5 7C5.22386 7 5 7.22386 5 7.5C5 7.77614 5.22386 8 5.5 8H9.5C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7H5.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowBottomLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.3536 3.64644C11.5488 3.8417 11.5488 4.15828 11.3536 4.35354L4.70711 11L9 11C9.27614 11 9.5 11.2239 9.5 11.5C9.5 11.7761 9.27614 12 9 12L3.5 12C3.36739 12 3.24021 11.9473 3.14645 11.8536C3.05268 11.7598 3 11.6326 3 11.5L3 5.99999C3 5.72385 3.22386 5.49999 3.5 5.49999C3.77614 5.49999 4 5.72385 4 5.99999V10.2929L10.6464 3.64643C10.8417 3.45117 11.1583 3.45117 11.3536 3.64644Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowBottomRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.64645 3.64644C3.45118 3.8417 3.45118 4.15828 3.64645 4.35354L10.2929 11L6 11C5.72386 11 5.5 11.2239 5.5 11.5C5.5 11.7761 5.72386 12 6 12L11.5 12C11.6326 12 11.7598 11.9473 11.8536 11.8536C11.9473 11.7598 12 11.6326 12 11.5L12 5.99999C12 5.72385 11.7761 5.49999 11.5 5.49999C11.2239 5.49999 11 5.72385 11 5.99999V10.2929L4.35355 3.64643C4.15829 3.45117 3.84171 3.45117 3.64645 3.64644Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 11.2929L11.1464 8.14645C11.3417 7.95118 11.6583 7.95118 11.8536 8.14645C12.0488 8.34171 12.0488 8.65829 11.8536 8.85355L7.85355 12.8536C7.75979 12.9473 7.63261 13 7.5 13C7.36739 13 7.24021 12.9473 7.14645 12.8536L3.14645 8.85355C2.95118 8.65829 2.95118 8.34171 3.14645 8.14645C3.34171 7.95118 3.65829 7.95118 3.85355 8.14645L7 11.2929L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowTopLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6465L4.70711 4L9 4C9.27614 4 9.5 3.77614 9.5 3.5C9.5 3.22386 9.27614 3 9 3L3.5 3C3.36739 3 3.24021 3.05268 3.14645 3.14645C3.05268 3.24022 3 3.36739 3 3.5L3 9.00001C3 9.27615 3.22386 9.50001 3.5 9.50001C3.77614 9.50001 4 9.27615 4 9.00001V4.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowTopRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.6326 3 11.7598 3.05268 11.8536 3.14645C11.9473 3.24022 12 3.36739 12 3.5L12 9.00001C12 9.27615 11.7761 9.50001 11.5 9.50001C11.2239 9.50001 11 9.27615 11 9.00001V4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.14645 2.14645C7.34171 1.95118 7.65829 1.95118 7.85355 2.14645L11.8536 6.14645C12.0488 6.34171 12.0488 6.65829 11.8536 6.85355C11.6583 7.04882 11.3417 7.04882 11.1464 6.85355L8 3.70711L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 3.70711L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355C2.95118 6.65829 2.95118 6.34171 3.14645 6.14645L7.14645 2.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAspectRatio(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.5 2H12.5C12.7761 2 13 2.22386 13 2.5V12.5C13 12.7761 12.7761 13 12.5 13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5ZM7.5 4C7.77614 4 8 3.77614 8 3.5C8 3.22386 7.77614 3 7.5 3C7.22386 3 7 3.22386 7 3.5C7 3.77614 7.22386 4 7.5 4ZM8 5.5C8 5.77614 7.77614 6 7.5 6C7.22386 6 7 5.77614 7 5.5C7 5.22386 7.22386 5 7.5 5C7.77614 5 8 5.22386 8 5.5ZM7.5 8C7.77614 8 8 7.77614 8 7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8ZM10 7.5C10 7.77614 9.77614 8 9.5 8C9.22386 8 9 7.77614 9 7.5C9 7.22386 9.22386 7 9.5 7C9.77614 7 10 7.22386 10 7.5ZM11.5 8C11.7761 8 12 7.77614 12 7.5C12 7.22386 11.7761 7 11.5 7C11.2239 7 11 7.22386 11 7.5C11 7.77614 11.2239 8 11.5 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxAvatar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBackpack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 1C5 0.447715 5.44772 0 6 0H9C9.55228 0 10 0.447715 10 1V2H14C14.5523 2 15 2.44772 15 3V6C15 6.8888 14.6131 7.68734 14 8.23608V11.5C14 12.3284 13.3284 13 12.5 13H2.5C1.67157 13 1 12.3284 1 11.5V8.2359C0.38697 7.68721 0 6.88883 0 6V3C0 2.44772 0.447716 2 1 2H5V1ZM9 1V2H6V1H9ZM1 3H5H5.5H9.5H10H14V6C14 6.654 13.6866 7.23467 13.1997 7.6004C12.8655 7.85144 12.4508 8 12 8H8V7.5C8 7.22386 7.77614 7 7.5 7C7.22386 7 7 7.22386 7 7.5V8H3C2.5493 8 2.1346 7.85133 1.80029 7.60022C1.31335 7.23446 1 6.65396 1 6V3ZM7 9H3C2.64961 9 2.31292 8.93972 2 8.82905V11.5C2 11.7761 2.22386 12 2.5 12H12.5C12.7761 12 13 11.7761 13 11.5V8.82915C12.6871 8.93978 12.3504 9 12 9H8V9.5C8 9.77614 7.77614 10 7.5 10C7.22386 10 7 9.77614 7 9.5V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBadge(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 6H11.5C12.3284 6 13 6.67157 13 7.5C13 8.32843 12.3284 9 11.5 9H3.5C2.67157 9 2 8.32843 2 7.5C2 6.67157 2.67157 6 3.5 6ZM1 7.5C1 6.11929 2.11929 5 3.5 5H11.5C12.8807 5 14 6.11929 14 7.5C14 8.88071 12.8807 10 11.5 10H3.5C2.11929 10 1 8.88071 1 7.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBarChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.5 1C11.7761 1 12 1.22386 12 1.5V13.5C12 13.7761 11.7761 14 11.5 14C11.2239 14 11 13.7761 11 13.5V1.5C11 1.22386 11.2239 1 11.5 1ZM9.5 3C9.77614 3 10 3.22386 10 3.5V13.5C10 13.7761 9.77614 14 9.5 14C9.22386 14 9 13.7761 9 13.5V3.5C9 3.22386 9.22386 3 9.5 3ZM13.5 3C13.7761 3 14 3.22386 14 3.5V13.5C14 13.7761 13.7761 14 13.5 14C13.2239 14 13 13.7761 13 13.5V3.5C13 3.22386 13.2239 3 13.5 3ZM5.5 4C5.77614 4 6 4.22386 6 4.5V13.5C6 13.7761 5.77614 14 5.5 14C5.22386 14 5 13.7761 5 13.5V4.5C5 4.22386 5.22386 4 5.5 4ZM1.5 5C1.77614 5 2 5.22386 2 5.5V13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5V5.5C1 5.22386 1.22386 5 1.5 5ZM7.5 5C7.77614 5 8 5.22386 8 5.5V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.5C7 5.22386 7.22386 5 7.5 5ZM3.5 7C3.77614 7 4 7.22386 4 7.5V13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V7.5C3 7.22386 3.22386 7 3.5 7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBell(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.60124 1.25086C8.60124 1.75459 8.26278 2.17927 7.80087 2.30989C10.1459 2.4647 12 4.41582 12 6.79999V10.25C12 11.0563 12.0329 11.7074 12.7236 12.0528C12.931 12.1565 13.0399 12.3892 12.9866 12.6149C12.9333 12.8406 12.7319 13 12.5 13H8.16144C8.36904 13.1832 8.49997 13.4513 8.49997 13.75C8.49997 14.3023 8.05226 14.75 7.49997 14.75C6.94769 14.75 6.49997 14.3023 6.49997 13.75C6.49997 13.4513 6.63091 13.1832 6.83851 13H2.49999C2.2681 13 2.06664 12.8406 2.01336 12.6149C1.96009 12.3892 2.06897 12.1565 2.27638 12.0528C2.96708 11.7074 2.99999 11.0563 2.99999 10.25V6.79999C2.99999 4.41537 4.85481 2.46396 7.20042 2.3098C6.73867 2.17908 6.40036 1.75448 6.40036 1.25086C6.40036 0.643104 6.89304 0.150421 7.5008 0.150421C8.10855 0.150421 8.60124 0.643104 8.60124 1.25086ZM7.49999 3.29999C5.56699 3.29999 3.99999 4.86699 3.99999 6.79999V10.25L4.00002 10.3009C4.0005 10.7463 4.00121 11.4084 3.69929 12H11.3007C10.9988 11.4084 10.9995 10.7463 11 10.3009L11 10.25V6.79999C11 4.86699 9.43299 3.29999 7.49999 3.29999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBlendingMode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 9C3 6.5 4.5 4.25 7.5 1.5C10.5 4.25 12 6.5 12 9C12 11.4853 9.98528 13.5 7.5 13.5C5.01472 13.5 3 11.4853 3 9ZM10.9524 8.30307C9.67347 7.82121 8.2879 8.46208 6.98956 9.06259C5.9327 9.55142 4.93365 10.0135 4.09695 9.82153C4.03357 9.55804 4 9.28294 4 9C4 7.11203 5.02686 5.27195 7.5 2.87357C9.66837 4.97639 10.725 6.65004 10.9524 8.30307Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBookmarkFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 2C3.22386 2 3 2.22386 3 2.5V13.5C3 13.6818 3.09864 13.8492 3.25762 13.9373C3.41659 14.0254 3.61087 14.0203 3.765 13.924L7.5 11.5896L11.235 13.924C11.3891 14.0203 11.5834 14.0254 11.7424 13.9373C11.9014 13.8492 12 13.6818 12 13.5V2.5C12 2.22386 11.7761 2 11.5 2H3.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBookmark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 2.5C3 2.22386 3.22386 2 3.5 2H11.5C11.7761 2 12 2.22386 12 2.5V13.5C12 13.6818 11.9014 13.8492 11.7424 13.9373C11.5834 14.0254 11.3891 14.0203 11.235 13.924L7.5 11.5896L3.765 13.924C3.61087 14.0203 3.41659 14.0254 3.25762 13.9373C3.09864 13.8492 3 13.6818 3 13.5V2.5ZM4 3V12.5979L6.97 10.7416C7.29427 10.539 7.70573 10.539 8.03 10.7416L11 12.5979V3H4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderAll(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H14C14.4142 0.25 14.75 0.585786 14.75 1V14C14.75 14.4142 14.4142 14.75 14 14.75H1C0.585786 14.75 0.25 14.4142 0.25 14V1ZM1.75 1.75V13.25H13.25V1.75H1.75Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "5",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "3",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "9",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "11",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 13.25L14 13.25V14.75L1 14.75V13.25Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "5",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "5",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "3",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "3",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "9",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "9",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "11",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "11",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "9",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "11",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderDashed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 7.5C0 7.22386 0.223858 7 0.5 7H3C3.27614 7 3.5 7.22386 3.5 7.5C3.5 7.77614 3.27614 8 3 8H0.5C0.223858 8 0 7.77614 0 7.5ZM5.75 7.5C5.75 7.22386 5.97386 7 6.25 7H8.75C9.02614 7 9.25 7.22386 9.25 7.5C9.25 7.77614 9.02614 8 8.75 8H6.25C5.97386 8 5.75 7.77614 5.75 7.5ZM12 7C11.7239 7 11.5 7.22386 11.5 7.5C11.5 7.77614 11.7239 8 12 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderDotted(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 6.625C1.01675 6.625 0.625 7.01675 0.625 7.5C0.625 7.98325 1.01675 8.375 1.5 8.375C1.98325 8.375 2.375 7.98325 2.375 7.5C2.375 7.01675 1.98325 6.625 1.5 6.625ZM5.5 6.625C5.01675 6.625 4.625 7.01675 4.625 7.5C4.625 7.98325 5.01675 8.375 5.5 8.375C5.98325 8.375 6.375 7.98325 6.375 7.5C6.375 7.01675 5.98325 6.625 5.5 6.625ZM9.5 6.625C9.01675 6.625 8.625 7.01675 8.625 7.5C8.625 7.98325 9.01675 8.375 9.5 8.375C9.98325 8.375 10.375 7.98325 10.375 7.5C10.375 7.01675 9.98325 6.625 9.5 6.625ZM12.625 7.5C12.625 7.01675 13.0168 6.625 13.5 6.625C13.9832 6.625 14.375 7.01675 14.375 7.5C14.375 7.98325 13.9832 8.375 13.5 8.375C13.0168 8.375 12.625 7.98325 12.625 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.75 1L1.75 14L0.249999 14L0.25 1L1.75 1Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "10",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 10 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "10",
                    "y": "13",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 10 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "12",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 12 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "12",
                    "y": "13",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 12 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "13",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "13",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "5",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 5)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "5",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 5)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "3",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 3)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "3",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 3)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "9",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 9)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "9",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 9)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "11",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 11)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "11",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 11)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 6 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "13",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 6 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "7",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 4 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "13",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 4 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "10",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 10 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "12",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 12 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 8 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 14 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 6 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "1",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(90 4 1)",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "5.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "5.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "3.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "3.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "9.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "9.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "11.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "11.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "5.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "3.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "9.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "11.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.25 1L13.25 14L14.75 14L14.75 1L13.25 1Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 5 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 5 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 3 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 3 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 5)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 5)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 3)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 3)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 9)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 9)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 11)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 11)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 9 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 9 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 11 7)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 11 13)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 5 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 3 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 7 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 1 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 9 1)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "matrix(0 1 1 0 11 1)",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderSolid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.25 7.5C1.25 7.22386 1.47386 7 1.75 7H13.25C13.5261 7 13.75 7.22386 13.75 7.5C13.75 7.77614 13.5261 8 13.25 8H1.75C1.47386 8 1.25 7.77614 1.25 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderSplit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "5.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "3.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "13.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "1.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "13",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "5",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "3",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "9",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "11",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "9.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "7",
                    "y": "11.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "1",
                    "y": "7.025",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 1.49994C1 1.2238 1.22386 0.999939 1.5 0.999939H6V1.99994H2V5.99994H1V1.49994ZM13 1.99994H9V0.999939H13.5C13.7761 0.999939 14 1.2238 14 1.49994V5.99994H13V1.99994ZM1 13.4999V8.99994H2V12.9999H6V13.9999H1.5C1.22386 13.9999 1 13.7761 1 13.4999ZM13 12.9999V8.99994H14V13.4999C14 13.7761 13.7761 13.9999 13.5 13.9999H9.5V12.9999H13Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H3.5C3.77614 7 4 7.22386 4 7.5C4 7.77614 3.77614 8 3.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5C12 11.7761 11.7761 12 11.5 12C11.2239 12 11 11.7761 11 11.5ZM13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11ZM6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H8.5C8.77614 8 9 7.77614 9 7.5C9 7.22386 8.77614 7 8.5 7H6.5ZM11 7.5C11 7.22386 11.2239 7 11.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H11.5C11.2239 8 11 7.77614 11 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 1.75L1 1.75L1 0.249999L14 0.25L14 1.75Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "10",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 8 10)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "10",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 2 10)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "12",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 8 12)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "12",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 2 12)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 8 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 8 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 2 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 2 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "10",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 10 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "10",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 10 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "12",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 12 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "12",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 12 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 6 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "6",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 6 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 4 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "4",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 4 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "6",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 8 6)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "6",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 2 6)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "8",
                    "y": "4",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 8 4)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "2",
                    "y": "4",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 2 4)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "10",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 14 10)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "12",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 14 12)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "8",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 14 8)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "14",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 14 14)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "6",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 14 6)",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "rect",
                "attr": {
                    "x": "14",
                    "y": "4",
                    "width": "1",
                    "height": "1",
                    "rx": ".5",
                    "transform": "rotate(-180 14 4)",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBorderWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 3H14V4H1V3ZM1 6H14V8H1V6ZM14 10.25H1V12.75H14V10.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBoxModel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.99998 0.999976C1.44769 0.999976 0.999976 1.44769 0.999976 1.99998V13C0.999976 13.5523 1.44769 14 1.99998 14H13C13.5523 14 14 13.5523 14 13V1.99998C14 1.44769 13.5523 0.999976 13 0.999976H1.99998ZM1.99998 1.99998L13 1.99998V13H1.99998V1.99998ZM4.49996 3.99996C4.22382 3.99996 3.99996 4.22382 3.99996 4.49996V10.5C3.99996 10.7761 4.22382 11 4.49996 11H10.5C10.7761 11 11 10.7761 11 10.5V4.49996C11 4.22382 10.7761 3.99996 10.5 3.99996H4.49996ZM4.99996 9.99996V4.99996H9.99996V9.99996H4.99996Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxBox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.5 2H2.5C2.22386 2 2 2.22386 2 2.5V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxButton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H2C1.44772 10 1 9.55228 1 9V6C1 5.44772 1.44772 5 2 5ZM0 6C0 4.89543 0.895431 4 2 4H13C14.1046 4 15 4.89543 15 6V9C15 10.1046 14.1046 11 13 11H2C0.89543 11 0 10.1046 0 9V6ZM4.5 6.75C4.08579 6.75 3.75 7.08579 3.75 7.5C3.75 7.91421 4.08579 8.25 4.5 8.25C4.91421 8.25 5.25 7.91421 5.25 7.5C5.25 7.08579 4.91421 6.75 4.5 6.75ZM6.75 7.5C6.75 7.08579 7.08579 6.75 7.5 6.75C7.91421 6.75 8.25 7.08579 8.25 7.5C8.25 7.91421 7.91421 8.25 7.5 8.25C7.08579 8.25 6.75 7.91421 6.75 7.5ZM10.5 6.75C10.0858 6.75 9.75 7.08579 9.75 7.5C9.75 7.91421 10.0858 8.25 10.5 8.25C10.9142 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 10.9142 6.75 10.5 6.75Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCalendar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.5 1C4.77614 1 5 1.22386 5 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12.5C13.3284 2 14 2.67157 14 3.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H4V1.5C4 1.22386 4.22386 1 4.5 1ZM10 3V3.5C10 3.77614 10.2239 4 10.5 4C10.7761 4 11 3.77614 11 3.5V3H12.5C12.7761 3 13 3.22386 13 3.5V5H2V3.5C2 3.22386 2.22386 3 2.5 3H4V3.5C4 3.77614 4.22386 4 4.5 4C4.77614 4 5 3.77614 5 3.5V3H10ZM2 6V12.5C2 12.7761 2.22386 13 2.5 13H12.5C12.7761 13 13 12.7761 13 12.5V6H2ZM7 7.5C7 7.22386 7.22386 7 7.5 7C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8C7.22386 8 7 7.77614 7 7.5ZM9.5 7C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8C9.77614 8 10 7.77614 10 7.5C10 7.22386 9.77614 7 9.5 7ZM11 7.5C11 7.22386 11.2239 7 11.5 7C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8C11.2239 8 11 7.77614 11 7.5ZM11.5 9C11.2239 9 11 9.22386 11 9.5C11 9.77614 11.2239 10 11.5 10C11.7761 10 12 9.77614 12 9.5C12 9.22386 11.7761 9 11.5 9ZM9 9.5C9 9.22386 9.22386 9 9.5 9C9.77614 9 10 9.22386 10 9.5C10 9.77614 9.77614 10 9.5 10C9.22386 10 9 9.77614 9 9.5ZM7.5 9C7.22386 9 7 9.22386 7 9.5C7 9.77614 7.22386 10 7.5 10C7.77614 10 8 9.77614 8 9.5C8 9.22386 7.77614 9 7.5 9ZM5 9.5C5 9.22386 5.22386 9 5.5 9C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10C5.22386 10 5 9.77614 5 9.5ZM3.5 9C3.22386 9 3 9.22386 3 9.5C3 9.77614 3.22386 10 3.5 10C3.77614 10 4 9.77614 4 9.5C4 9.22386 3.77614 9 3.5 9ZM3 11.5C3 11.2239 3.22386 11 3.5 11C3.77614 11 4 11.2239 4 11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5ZM5.5 11C5.22386 11 5 11.2239 5 11.5C5 11.7761 5.22386 12 5.5 12C5.77614 12 6 11.7761 6 11.5C6 11.2239 5.77614 11 5.5 11ZM7 11.5C7 11.2239 7.22386 11 7.5 11C7.77614 11 8 11.2239 8 11.5C8 11.7761 7.77614 12 7.5 12C7.22386 12 7 11.7761 7 11.5ZM9.5 11C9.22386 11 9 11.2239 9 11.5C9 11.7761 9.22386 12 9.5 12C9.77614 12 10 11.7761 10 11.5C10 11.2239 9.77614 11 9.5 11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCamera(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 3C1.44772 3 1 3.44772 1 4V11C1 11.5523 1.44772 12 2 12H13C13.5523 12 14 11.5523 14 11V4C14 3.44772 13.5523 3 13 3H2ZM0 4C0 2.89543 0.895431 2 2 2H13C14.1046 2 15 2.89543 15 4V11C15 12.1046 14.1046 13 13 13H2C0.895431 13 0 12.1046 0 11V4ZM2 4.25C2 4.11193 2.11193 4 2.25 4H4.75C4.88807 4 5 4.11193 5 4.25V5.75454C5 5.89261 4.88807 6.00454 4.75 6.00454H2.25C2.11193 6.00454 2 5.89261 2 5.75454V4.25ZM12.101 7.58421C12.101 9.02073 10.9365 10.1853 9.49998 10.1853C8.06346 10.1853 6.89893 9.02073 6.89893 7.58421C6.89893 6.14769 8.06346 4.98315 9.49998 4.98315C10.9365 4.98315 12.101 6.14769 12.101 7.58421ZM13.101 7.58421C13.101 9.57302 11.4888 11.1853 9.49998 11.1853C7.51117 11.1853 5.89893 9.57302 5.89893 7.58421C5.89893 5.5954 7.51117 3.98315 9.49998 3.98315C11.4888 3.98315 13.101 5.5954 13.101 7.58421Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCardStackMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.5 3C2.22386 3 2 3.22386 2 3.5V9.5C2 9.77614 2.22386 10 2.5 10H12.5C12.7761 10 13 9.77614 13 9.5V3.5C13 3.22386 12.7761 3 12.5 3H2.5ZM1 9.5C1 10.1531 1.4174 10.7087 2 10.9146V11.5C2 12.3284 2.67157 13 3.5 13H11.5C12.3284 13 13 12.3284 13 11.5V10.9146C13.5826 10.7087 14 10.1531 14 9.5V3.5C14 2.67157 13.3284 2 12.5 2H2.5C1.67157 2 1 2.67157 1 3.5V9.5ZM12 11.5V11H3V11.5C3 11.7761 3.22386 12 3.5 12H11.5C11.7761 12 12 11.7761 12 11.5ZM5.5 6C5.22386 6 5 6.22386 5 6.5C5 6.77614 5.22386 7 5.5 7H9.5C9.77614 7 10 6.77614 10 6.5C10 6.22386 9.77614 6 9.5 6H5.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCardStackPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12ZM5 6.5C5 6.22386 5.22386 6 5.5 6H7V4.5C7 4.22386 7.22386 4 7.5 4C7.77614 4 8 4.22386 8 4.5V6H9.5C9.77614 6 10 6.22386 10 6.5C10 6.77614 9.77614 7 9.5 7H8V8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5V7H5.5C5.22386 7 5 6.77614 5 6.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCardStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 3.5C2 3.22386 2.22386 3 2.5 3H12.5C12.7761 3 13 3.22386 13 3.5V9.5C13 9.77614 12.7761 10 12.5 10H2.5C2.22386 10 2 9.77614 2 9.5V3.5ZM2 10.9146C1.4174 10.7087 1 10.1531 1 9.5V3.5C1 2.67157 1.67157 2 2.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.1531 13.5826 10.7087 13 10.9146V11.5C13 12.3284 12.3284 13 11.5 13H3.5C2.67157 13 2 12.3284 2 11.5V10.9146ZM12 11V11.5C12 11.7761 11.7761 12 11.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11H12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCaretDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCaretLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.81809 4.18179C8.99383 4.35753 8.99383 4.64245 8.81809 4.81819L6.13629 7.49999L8.81809 10.1818C8.99383 10.3575 8.99383 10.6424 8.81809 10.8182C8.64236 10.9939 8.35743 10.9939 8.1817 10.8182L5.1817 7.81819C5.09731 7.73379 5.0499 7.61933 5.0499 7.49999C5.0499 7.38064 5.09731 7.26618 5.1817 7.18179L8.1817 4.18179C8.35743 4.00605 8.64236 4.00605 8.81809 4.18179Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCaretRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.18194 4.18185C6.35767 4.00611 6.6426 4.00611 6.81833 4.18185L9.81833 7.18185C9.90272 7.26624 9.95013 7.3807 9.95013 7.50005C9.95013 7.6194 9.90272 7.73386 9.81833 7.81825L6.81833 10.8182C6.6426 10.994 6.35767 10.994 6.18194 10.8182C6.0062 10.6425 6.0062 10.3576 6.18194 10.1819L8.86374 7.50005L6.18194 4.81825C6.0062 4.64251 6.0062 4.35759 6.18194 4.18185Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCaretSort(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.93179 5.43179C4.75605 5.60753 4.75605 5.89245 4.93179 6.06819C5.10753 6.24392 5.39245 6.24392 5.56819 6.06819L7.49999 4.13638L9.43179 6.06819C9.60753 6.24392 9.89245 6.24392 10.0682 6.06819C10.2439 5.89245 10.2439 5.60753 10.0682 5.43179L7.81819 3.18179C7.73379 3.0974 7.61933 3.04999 7.49999 3.04999C7.38064 3.04999 7.26618 3.0974 7.18179 3.18179L4.93179 5.43179ZM10.0682 9.56819C10.2439 9.39245 10.2439 9.10753 10.0682 8.93179C9.89245 8.75606 9.60753 8.75606 9.43179 8.93179L7.49999 10.8636L5.56819 8.93179C5.39245 8.75606 5.10753 8.75606 4.93179 8.93179C4.75605 9.10753 4.75605 9.39245 4.93179 9.56819L7.18179 11.8182C7.35753 11.9939 7.64245 11.9939 7.81819 11.8182L10.0682 9.56819Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCaretUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.18179 8.81819C4.00605 8.64245 4.00605 8.35753 4.18179 8.18179L7.18179 5.18179C7.26618 5.0974 7.38064 5.04999 7.49999 5.04999C7.61933 5.04999 7.73379 5.0974 7.81819 5.18179L10.8182 8.18179C10.9939 8.35753 10.9939 8.64245 10.8182 8.81819C10.6424 8.99392 10.3575 8.99392 10.1818 8.81819L7.49999 6.13638L4.81819 8.81819C4.64245 8.99392 4.35753 8.99392 4.18179 8.81819Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxChatBubble(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.5 3L2.5 3.00002C1.67157 3.00002 1 3.6716 1 4.50002V9.50003C1 10.3285 1.67157 11 2.5 11H7.50003C7.63264 11 7.75982 11.0527 7.85358 11.1465L10 13.2929V11.5C10 11.2239 10.2239 11 10.5 11H12.5C13.3284 11 14 10.3285 14 9.50003V4.5C14 3.67157 13.3284 3 12.5 3ZM2.49999 2.00002L12.5 2C13.8807 2 15 3.11929 15 4.5V9.50003C15 10.8807 13.8807 12 12.5 12H11V14.5C11 14.7022 10.8782 14.8845 10.6913 14.9619C10.5045 15.0393 10.2894 14.9965 10.1464 14.8536L7.29292 12H2.5C1.11929 12 0 10.8807 0 9.50003V4.50002C0 3.11931 1.11928 2.00003 2.49999 2.00002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCheckCircled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 11.1575 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1576 0.877045 7.49991 0.877045ZM1.82708 7.49988C1.82708 4.36686 4.36689 1.82704 7.49991 1.82704C10.6329 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49988ZM10.1589 5.53774C10.3178 5.31191 10.2636 5.00001 10.0378 4.84109C9.81194 4.68217 9.50004 4.73642 9.34112 4.96225L6.51977 8.97154L5.35681 7.78706C5.16334 7.59002 4.84677 7.58711 4.64973 7.78058C4.45268 7.97404 4.44978 8.29061 4.64325 8.48765L6.22658 10.1003C6.33054 10.2062 6.47617 10.2604 6.62407 10.2483C6.77197 10.2363 6.90686 10.1591 6.99226 10.0377L10.1589 5.53774Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCheck(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCheckbox(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 3H12V12H3L3 3ZM2 3C2 2.44771 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44771 13 2 12.5523 2 12V3ZM10.3498 5.51105C10.506 5.28337 10.4481 4.97212 10.2204 4.81587C9.99275 4.65961 9.6815 4.71751 9.52525 4.94519L6.64048 9.14857L5.19733 7.40889C5.02102 7.19635 4.7058 7.16699 4.49327 7.34329C4.28073 7.5196 4.25137 7.83482 4.42767 8.04735L6.2934 10.2964C6.39348 10.4171 6.54437 10.4838 6.70097 10.4767C6.85757 10.4695 7.00177 10.3894 7.09047 10.2601L10.3498 5.51105Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxChevronDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxChevronLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.84182 3.13514C9.04327 3.32401 9.05348 3.64042 8.86462 3.84188L5.43521 7.49991L8.86462 11.1579C9.05348 11.3594 9.04327 11.6758 8.84182 11.8647C8.64036 12.0535 8.32394 12.0433 8.13508 11.8419L4.38508 7.84188C4.20477 7.64955 4.20477 7.35027 4.38508 7.15794L8.13508 3.15794C8.32394 2.95648 8.64036 2.94628 8.84182 3.13514Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxChevronRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.1584 3.13508C6.35985 2.94621 6.67627 2.95642 6.86514 3.15788L10.6151 7.15788C10.7954 7.3502 10.7954 7.64949 10.6151 7.84182L6.86514 11.8418C6.67627 12.0433 6.35985 12.0535 6.1584 11.8646C5.95694 11.6757 5.94673 11.3593 6.1356 11.1579L9.565 7.49985L6.1356 3.84182C5.94673 3.64036 5.95694 3.32394 6.1584 3.13508Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxChevronUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.13523 8.84197C3.3241 9.04343 3.64052 9.05363 3.84197 8.86477L7.5 5.43536L11.158 8.86477C11.3595 9.05363 11.6759 9.04343 11.8648 8.84197C12.0536 8.64051 12.0434 8.32409 11.842 8.13523L7.84197 4.38523C7.64964 4.20492 7.35036 4.20492 7.15803 4.38523L3.15803 8.13523C2.95657 8.32409 2.94637 8.64051 3.13523 8.84197Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCircleBackslash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM3.85768 3.15057C4.84311 2.32448 6.11342 1.82708 7.49991 1.82708C10.6329 1.82708 13.1727 4.36689 13.1727 7.49991C13.1727 8.88638 12.6753 10.1567 11.8492 11.1421L3.85768 3.15057ZM3.15057 3.85768C2.32448 4.84311 1.82708 6.11342 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C8.88638 13.1727 10.1567 12.6753 11.1421 11.8492L3.15057 3.85768Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCircle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49991C0.877075 3.84222 3.84222 0.877075 7.49991 0.877075C11.1576 0.877075 14.1227 3.84222 14.1227 7.49991C14.1227 11.1576 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1576 0.877075 7.49991ZM7.49991 1.82708C4.36689 1.82708 1.82708 4.36689 1.82708 7.49991C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49991C13.1727 4.36689 10.6329 1.82708 7.49991 1.82708Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxClipboardCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxClipboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM11 2V2.25C11 2.66421 10.6642 3 10.25 3H4.75C4.33579 3 4 2.66421 4 2.25V2H3.5C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V2.5C12 2.22386 11.7761 2 11.5 2H11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.50009 0.877014C3.84241 0.877014 0.877258 3.84216 0.877258 7.49984C0.877258 11.1575 3.8424 14.1227 7.50009 14.1227C11.1578 14.1227 14.1229 11.1575 14.1229 7.49984C14.1229 3.84216 11.1577 0.877014 7.50009 0.877014ZM1.82726 7.49984C1.82726 4.36683 4.36708 1.82701 7.50009 1.82701C10.6331 1.82701 13.1729 4.36683 13.1729 7.49984C13.1729 10.6328 10.6331 13.1727 7.50009 13.1727C4.36708 13.1727 1.82726 10.6328 1.82726 7.49984ZM8 4.50001C8 4.22387 7.77614 4.00001 7.5 4.00001C7.22386 4.00001 7 4.22387 7 4.50001V7.50001C7 7.63262 7.05268 7.7598 7.14645 7.85357L9.14645 9.85357C9.34171 10.0488 9.65829 10.0488 9.85355 9.85357C10.0488 9.65831 10.0488 9.34172 9.85355 9.14646L8 7.29291V4.50001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCode(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCodesandboxLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.71144 0.796902C7.57741 0.734357 7.42257 0.734357 7.28855 0.796902L1.28855 3.5969C1.11251 3.67905 0.999993 3.85573 0.999993 4.04999V10.95C0.999993 11.1443 1.11251 11.3209 1.28855 11.4031L7.28855 14.2031C7.42257 14.2656 7.57741 14.2656 7.71144 14.2031L13.7114 11.4031C13.8875 11.3209 14 11.1443 14 10.95V4.04999C14 3.85573 13.8875 3.67905 13.7114 3.5969L7.71144 0.796902ZM7.49999 3.15674L5.98039 2.51091L7.49999 1.80176L9.01959 2.51091L7.49999 3.15674ZM7.69556 4.16018L10.2382 3.07958L12.2719 4.02865L7.49999 6.05671L2.72808 4.02865L4.76181 3.07958L7.30442 4.16018C7.42939 4.2133 7.57059 4.2133 7.69556 4.16018ZM7.99999 6.93078L13 4.80578V7.92966L11.0821 8.8119C10.7273 8.97509 10.5 9.32988 10.5 9.72039V11.7982L7.99999 12.9649V6.93078ZM11.5 11.3316L13 10.6316V9.03039L11.5 9.72039V11.3316ZM6.99999 6.93078V12.9649L4.50231 11.7993V9.72036C4.50231 9.32985 4.27499 8.97506 3.92022 8.81187L1.99999 7.92856V4.80578L6.99999 6.93078ZM1.99999 10.6316L3.50231 11.3326L3.50231 9.72036L1.99999 9.02929V10.6316Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxColorWheel(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49985C0.877075 3.84216 3.84222 0.877014 7.49991 0.877014C11.1576 0.877014 14.1227 3.84216 14.1227 7.49985C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49985ZM3.78135 3.21565C4.68298 2.43239 5.83429 1.92904 7.09998 1.84089V6.53429L3.78135 3.21565ZM3.21567 3.78134C2.43242 4.68298 1.92909 5.83428 1.84095 7.09997H6.5343L3.21567 3.78134ZM6.5343 7.89997H1.84097C1.92916 9.16562 2.43253 10.3169 3.21579 11.2185L6.5343 7.89997ZM3.78149 11.7842C4.6831 12.5673 5.83435 13.0707 7.09998 13.1588V8.46566L3.78149 11.7842ZM7.89998 8.46566V13.1588C9.16559 13.0706 10.3168 12.5673 11.2184 11.7841L7.89998 8.46566ZM11.7841 11.2184C12.5673 10.3168 13.0707 9.16558 13.1588 7.89997H8.46567L11.7841 11.2184ZM8.46567 7.09997H13.1589C13.0707 5.83432 12.5674 4.68305 11.7842 3.78143L8.46567 7.09997ZM11.2185 3.21573C10.3169 2.43246 9.16565 1.92909 7.89998 1.8409V6.53429L11.2185 3.21573Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxColumnSpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.00012 1.5C8.00012 1.22386 7.77626 1 7.50012 1C7.22398 1 7.00012 1.22386 7.00012 1.5V13.5C7.00012 13.7761 7.22398 14 7.50012 14C7.77626 14 8.00012 13.7761 8.00012 13.5V1.5ZM3.31812 5.818C3.49386 5.64227 3.49386 5.35734 3.31812 5.18161C3.14239 5.00587 2.85746 5.00587 2.68173 5.18161L0.681729 7.18161C0.505993 7.35734 0.505993 7.64227 0.681729 7.818L2.68173 9.818C2.85746 9.99374 3.14239 9.99374 3.31812 9.818C3.49386 9.64227 3.49386 9.35734 3.31812 9.18161L2.08632 7.9498H5.50017C5.7487 7.9498 5.95017 7.74833 5.95017 7.4998C5.95017 7.25128 5.7487 7.0498 5.50017 7.0498H2.08632L3.31812 5.818ZM12.3181 5.18161C12.1424 5.00587 11.8575 5.00587 11.6817 5.18161C11.506 5.35734 11.506 5.64227 11.6817 5.818L12.9135 7.0498H9.50017C9.25164 7.0498 9.05017 7.25128 9.05017 7.4998C9.05017 7.74833 9.25164 7.9498 9.50017 7.9498H12.9135L11.6817 9.18161C11.506 9.35734 11.506 9.64227 11.6817 9.818C11.8575 9.99374 12.1424 9.99374 12.3181 9.818L14.3181 7.818C14.4939 7.64227 14.4939 7.35734 14.3181 7.18161L12.3181 5.18161Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxColumns(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.14998 14V1H0.849976V14H2.14998ZM6.14998 14V1H4.84998V14H6.14998ZM10.15 1V14H8.84998V1H10.15ZM14.15 14V1H12.85V14H14.15Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCommit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.94969 7.49989C9.94969 8.85288 8.85288 9.94969 7.49989 9.94969C6.14691 9.94969 5.0501 8.85288 5.0501 7.49989C5.0501 6.14691 6.14691 5.0501 7.49989 5.0501C8.85288 5.0501 9.94969 6.14691 9.94969 7.49989ZM10.8632 8C10.6213 9.64055 9.20764 10.8997 7.49989 10.8997C5.79214 10.8997 4.37847 9.64055 4.13662 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H4.13659C4.37835 5.35935 5.79206 4.1001 7.49989 4.1001C9.20772 4.1001 10.6214 5.35935 10.8632 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H10.8632Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxComponent1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.67129 3.14634C4.47603 3.34161 4.47603 3.65819 4.67129 3.85345L7.14616 6.32833C7.34142 6.52359 7.65801 6.52359 7.85327 6.32833L10.3281 3.85345C10.5234 3.65819 10.5234 3.34161 10.3281 3.14634L7.85327 0.671471C7.65801 0.476209 7.34142 0.476209 7.14616 0.671471L4.67129 3.14634ZM7.49971 5.26766L5.73195 3.4999L7.49971 1.73213L9.26748 3.4999L7.49971 5.26766ZM8.67129 7.14634C8.47603 7.34161 8.47603 7.65819 8.67129 7.85345L11.1462 10.3283C11.3414 10.5236 11.658 10.5236 11.8533 10.3283L14.3281 7.85345C14.5234 7.65819 14.5234 7.34161 14.3281 7.14634L11.8533 4.67147C11.658 4.47621 11.3414 4.47621 11.1462 4.67147L8.67129 7.14634ZM11.4997 9.26766L9.73195 7.4999L11.4997 5.73213L13.2675 7.4999L11.4997 9.26766ZM4.67129 11.8535C4.47603 11.6582 4.47603 11.3416 4.67129 11.1463L7.14616 8.67147C7.34142 8.47621 7.65801 8.47621 7.85327 8.67147L10.3281 11.1463C10.5234 11.3416 10.5234 11.6582 10.3281 11.8535L7.85327 14.3283C7.65801 14.5236 7.34142 14.5236 7.14616 14.3283L4.67129 11.8535ZM5.73195 11.4999L7.49971 13.2677L9.26748 11.4999L7.49971 9.73213L5.73195 11.4999ZM0.671288 7.14649C0.476026 7.34175 0.476026 7.65834 0.671288 7.8536L3.14616 10.3285C3.34142 10.5237 3.65801 10.5237 3.85327 10.3285L6.32814 7.8536C6.5234 7.65834 6.5234 7.34175 6.32814 7.14649L3.85327 4.67162C3.65801 4.47636 3.34142 4.47636 3.14616 4.67162L0.671288 7.14649ZM3.49972 9.26781L1.73195 7.50005L3.49972 5.73228L5.26748 7.50005L3.49972 9.26781Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxComponent2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.87935 1H3.9H11.1H11.1207C11.5231 0.999994 11.8553 0.999989 12.1259 1.0221C12.407 1.04506 12.6653 1.09434 12.908 1.21799C13.2843 1.40973 13.5903 1.7157 13.782 2.09202C13.9057 2.33469 13.9549 2.59304 13.9779 2.87409C14 3.14468 14 3.47686 14 3.87934V3.9V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H3.9H3.87934C3.47686 14 3.14468 14 2.87409 13.9779C2.59304 13.9549 2.33469 13.9057 2.09202 13.782C1.7157 13.5903 1.40973 13.2843 1.21799 12.908C1.09434 12.6653 1.04506 12.407 1.0221 12.1259C0.999989 11.8553 0.999994 11.5231 1 11.1207V11.1207V11.1V3.9V3.87935V3.87934C0.999994 3.47686 0.999989 3.14468 1.0221 2.87409C1.04506 2.59304 1.09434 2.33469 1.21799 2.09202C1.40973 1.7157 1.7157 1.40973 2.09202 1.21799C2.33469 1.09434 2.59304 1.04506 2.87409 1.0221C3.14469 0.999989 3.47687 0.999994 3.87935 1ZM2.95552 2.01878C2.73631 2.03669 2.62421 2.06915 2.54601 2.10899C2.35785 2.20487 2.20487 2.35785 2.10899 2.54601C2.06915 2.62421 2.03669 2.73631 2.01878 2.95552C2.00039 3.18056 2 3.47171 2 3.9V7H7V2H3.9C3.47171 2 3.18056 2.00039 2.95552 2.01878ZM7 8H2V11.1C2 11.5283 2.00039 11.8194 2.01878 12.0445C2.03669 12.2637 2.06915 12.3758 2.10899 12.454C2.20487 12.6422 2.35785 12.7951 2.54601 12.891C2.62421 12.9309 2.73631 12.9633 2.95552 12.9812C3.18056 12.9996 3.47171 13 3.9 13H7V8ZM8 8H13V11.1C13 11.5283 12.9996 11.8194 12.9812 12.0445C12.9633 12.2637 12.9309 12.3758 12.891 12.454C12.7951 12.6422 12.6422 12.7951 12.454 12.891C12.3758 12.9309 12.2637 12.9633 12.0445 12.9812C11.8194 12.9996 11.5283 13 11.1 13H8V8ZM13 7H8V2H11.1C11.5283 2 11.8194 2.00039 12.0445 2.01878C12.2637 2.03669 12.3758 2.06915 12.454 2.10899C12.6422 2.20487 12.7951 2.35785 12.891 2.54601C12.9309 2.62421 12.9633 2.73631 12.9812 2.95552C12.9996 3.18056 13 3.47171 13 3.9V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxComponentBoolean(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.85367 1.48956C7.65841 1.29429 7.34182 1.29429 7.14656 1.48956L1.48971 7.14641C1.29445 7.34167 1.29445 7.65825 1.48971 7.85352L7.14656 13.5104C7.34182 13.7056 7.65841 13.7056 7.85367 13.5104L13.5105 7.85352C13.7058 7.65825 13.7058 7.34167 13.5105 7.14641L7.85367 1.48956ZM7.5 2.55033L2.55037 7.49996L7.5 12.4496V2.55033Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxComponentInstance(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.1465 1.48959C7.34176 1.29432 7.65835 1.29432 7.85361 1.48959L13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355L7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104L1.48965 7.85355C1.29439 7.65829 1.29439 7.3417 1.48965 7.14644L7.1465 1.48959ZM7.50005 2.55025L2.55031 7.49999L7.50005 12.4497L12.4498 7.49999L7.50005 2.55025Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxComponentNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959L1.48965 7.14644C1.29439 7.3417 1.29439 7.65829 1.48965 7.85355L3.9645 10.3284L1.64644 12.6464C1.45118 12.8417 1.45118 13.1583 1.64644 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.6716 11.0355L7.1465 13.5104C7.34176 13.7057 7.65835 13.7057 7.85361 13.5104L13.5105 7.85355C13.7057 7.65829 13.7057 7.3417 13.5105 7.14644L11.0356 4.67154L13.3535 2.35355C13.5488 2.15829 13.5488 1.84171 13.3535 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.3285 3.96443L7.85361 1.48959ZM9.62135 4.67154L7.50005 2.55025L2.55031 7.49999L4.6716 9.62129L9.62135 4.67154ZM5.37871 10.3284L7.50005 12.4497L12.4498 7.49999L10.3285 5.37865L5.37871 10.3284Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxComponentPlaceholder(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.8034 7.14644C12.9986 6.95118 13.3152 6.95118 13.5105 7.14644C13.7057 7.3417 13.7057 7.65829 13.5105 7.85355C13.3152 8.04881 12.9986 8.04881 12.8034 7.85355C12.6081 7.65828 12.6081 7.3417 12.8034 7.14644ZM12.0962 8.56065C12.2915 8.75592 12.2915 9.0725 12.0962 9.26776C11.901 9.46302 11.5844 9.46302 11.3891 9.26776C11.1939 9.0725 11.1939 8.75592 11.3891 8.56065C11.5844 8.36539 11.901 8.36539 12.0962 8.56065ZM10.682 9.97487C10.8773 10.1701 10.8773 10.4867 10.682 10.682C10.4868 10.8772 10.1702 10.8772 9.97493 10.682C9.77967 10.4867 9.77967 10.1701 9.97493 9.97487C10.1702 9.7796 10.4868 9.7796 10.682 9.97487ZM9.26782 11.3891C9.46308 11.5843 9.46308 11.9009 9.26782 12.0962C9.07256 12.2915 8.75598 12.2915 8.56071 12.0962C8.36545 11.9009 8.36545 11.5843 8.56072 11.3891C8.75598 11.1938 9.07256 11.1938 9.26782 11.3891ZM7.1465 13.5104C6.95124 13.3151 6.95124 12.9986 7.1465 12.8033C7.17091 12.7789 7.19721 12.7575 7.22494 12.7392C7.41901 12.6111 7.68275 12.6324 7.85361 12.8033C8.04887 12.9986 8.04887 13.3151 7.85361 13.5104C7.65835 13.7057 7.34176 13.7057 7.1465 13.5104Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "d": "M2.90386 8.56065C2.7086 8.75592 2.7086 9.0725 2.90386 9.26776 3.09912 9.46302 3.41571 9.46302 3.61097 9.26776 3.80623 9.0725 3.80623 8.75592 3.61097 8.56065 3.41571 8.36539 3.09912 8.36539 2.90386 8.56065zM4.31807 9.97487C4.12281 10.1701 4.12281 10.4867 4.31807 10.682 4.51334 10.8772 4.82992 10.8772 5.02518 10.682 5.22044 10.4867 5.22044 10.1701 5.02518 9.97487 4.82992 9.7796 4.51334 9.7796 4.31807 9.97487zM5.73229 11.3891C5.53703 11.5843 5.53703 11.9009 5.73229 12.0962 5.92755 12.2914 6.24413 12.2915 6.43939 12.0962 6.63466 11.9009 6.63466 11.5843 6.43939 11.3891 6.24413 11.1938 5.92755 11.1938 5.73229 11.3891zM2.19675 7.85355C2.36761 7.68269 2.38897 7.41895 2.26082 7.22488 2.09046 6.96684 1.71063 6.92546 1.48965 7.14644 1.29439 7.3417 1.29439 7.65829 1.48965 7.85355 1.68491 8.04881 2.00149 8.04881 2.19675 7.85355zM3.61097 5.73223C3.41571 5.53696 3.09912 5.53696 2.90386 5.73223 2.7086 5.92749 2.7086 6.24407 2.90386 6.43933 3.09912 6.6346 3.41571 6.6346 3.61097 6.43933 3.80623 6.24407 3.80623 5.92749 3.61097 5.73223zM5.02518 4.31801C4.82992 4.12275 4.51334 4.12275 4.31807 4.31801 4.12281 4.51328 4.12281 4.82986 4.31807 5.02512 4.51334 5.22038 4.82992 5.22038 5.02518 5.02512 5.22044 4.82986 5.22044 4.51328 5.02518 4.31801zM6.43939 2.9038C6.24413 2.70854 5.92755 2.70854 5.73229 2.9038 5.53703 3.09906 5.53703 3.41564 5.73229 3.61091 5.92755 3.80617 6.24413 3.80617 6.43939 3.61091 6.63466 3.41564 6.63466 3.09906 6.43939 2.9038zM7.85361 1.48959C7.65835 1.29432 7.34176 1.29432 7.1465 1.48959 6.95124 1.68485 6.95124 2.00143 7.1465 2.19669 7.34176 2.39196 7.65835 2.39196 7.85361 2.19669 8.04887 2.00143 8.04887 1.68485 7.85361 1.48959zM9.26782 2.9038C9.07256 2.70854 8.75598 2.70854 8.56071 2.9038 8.36545 3.09906 8.36545 3.41564 8.56071 3.61091 8.75598 3.80617 9.07256 3.80617 9.26782 3.61091 9.46308 3.41564 9.46308 3.09906 9.26782 2.9038zM10.682 4.31801C10.4868 4.12275 10.1702 4.12275 9.97493 4.31801 9.77967 4.51328 9.77967 4.82986 9.97493 5.02512 10.1702 5.22038 10.4868 5.22038 10.682 5.02512 10.8773 4.82986 10.8773 4.51328 10.682 4.31801zM12.0962 5.73223C11.901 5.53696 11.5844 5.53696 11.3891 5.73223 11.1939 5.92749 11.1939 6.24407 11.3891 6.43933 11.5844 6.6346 11.901 6.6346 12.0962 6.43933 12.2915 6.24407 12.2915 5.92749 12.0962 5.73223z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxContainer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM5 13H10V2L5 2L5 13ZM4 13C4 13.5523 4.44772 14 5 14H10C10.5523 14 11 13.5523 11 13V2C11 1.44772 10.5523 1 10 1H5C4.44772 1 4 1.44771 4 2V13ZM13.5 2C13.7761 2 14 1.77614 14 1.5C14 1.22386 13.7761 1 13.5 1C13.2239 1 13 1.22386 13 1.5C13 1.77614 13.2239 2 13.5 2ZM2 3.5C2 3.77614 1.77614 4 1.5 4C1.22386 4 1 3.77614 1 3.5C1 3.22386 1.22386 3 1.5 3C1.77614 3 2 3.22386 2 3.5ZM13.5 4C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3C13.2239 3 13 3.22386 13 3.5C13 3.77614 13.2239 4 13.5 4ZM2 5.5C2 5.77614 1.77614 6 1.5 6C1.22386 6 1 5.77614 1 5.5C1 5.22386 1.22386 5 1.5 5C1.77614 5 2 5.22386 2 5.5ZM13.5 6C13.7761 6 14 5.77614 14 5.5C14 5.22386 13.7761 5 13.5 5C13.2239 5 13 5.22386 13 5.5C13 5.77614 13.2239 6 13.5 6ZM2 7.5C2 7.77614 1.77614 8 1.5 8C1.22386 8 1 7.77614 1 7.5C1 7.22386 1.22386 7 1.5 7C1.77614 7 2 7.22386 2 7.5ZM13.5 8C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8ZM2 9.5C2 9.77614 1.77614 10 1.5 10C1.22386 10 1 9.77614 1 9.5C1 9.22386 1.22386 9 1.5 9C1.77614 9 2 9.22386 2 9.5ZM13.5 10C13.7761 10 14 9.77614 14 9.5C14 9.22386 13.7761 9 13.5 9C13.2239 9 13 9.22386 13 9.5C13 9.77614 13.2239 10 13.5 10ZM2 11.5C2 11.7761 1.77614 12 1.5 12C1.22386 12 1 11.7761 1 11.5C1 11.2239 1.22386 11 1.5 11C1.77614 11 2 11.2239 2 11.5ZM13.5 12C13.7761 12 14 11.7761 14 11.5C14 11.2239 13.7761 11 13.5 11C13.2239 11 13 11.2239 13 11.5C13 11.7761 13.2239 12 13.5 12ZM2 13.5C2 13.7761 1.77614 14 1.5 14C1.22386 14 1 13.7761 1 13.5C1 13.2239 1.22386 13 1.5 13C1.77614 13 2 13.2239 2 13.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCookie(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.0697 1.76746C12.4807 1.21947 11.4605 0.454311 11.0495 1.0023C10.6385 1.55028 11.6588 2.31544 12.0697 1.76746ZM8.39263 1.07811C7.15585 0.950602 5.7823 1.16348 4.58433 1.70937C3.38552 2.25563 2.32735 3.15309 1.78844 4.41832C1.37574 5.38724 1.01715 6.28113 1.00088 7.44354C0.984724 8.59844 1.30522 9.96898 2.13174 11.928C2.61142 13.0649 4.03963 13.5446 5.13895 13.8079C6.40836 14.1119 7.80857 14.1914 8.6644 14.0742C9.36515 13.9782 10.1448 13.8284 10.7987 13.297C11.8977 12.4039 12.9009 11.3955 13.4994 10.3393C14.104 9.27221 14.3256 8.09207 13.7216 6.95324C13.5628 6.65373 13.316 6.57734 13.0412 6.4923C12.9374 6.46016 12.8295 6.42678 12.7209 6.37966C11.6211 5.90234 10.9646 5.34963 10.9135 5.02876C10.8656 4.72808 10.9221 4.51463 10.9811 4.29181C11.0129 4.17199 11.0453 4.04947 11.0626 3.90922C11.0838 3.73737 11.0814 3.33319 10.6996 3.12761C10.4048 2.96888 10.2164 2.65843 10.0407 2.36904C9.99742 2.29775 9.95492 2.22773 9.9118 2.16158C9.62634 1.72367 9.20769 1.16213 8.39263 1.07811ZM4.99899 2.61935C3.96483 3.09058 3.12554 3.83097 2.70846 4.81018C2.29808 5.77368 2.01406 6.50873 2.00079 7.45753C1.98741 8.41385 2.25043 9.6368 3.0531 11.5393C3.39181 12.3421 4.62167 12.6557 5.37186 12.8354C6.5493 13.1174 7.822 13.1802 8.52868 13.0834C9.21271 12.9897 9.74568 12.8642 10.1681 12.5209C11.229 11.6587 12.121 10.7435 12.6293 9.84635C12.9349 9.30709 13.5141 7.7028 12.6292 7.3873C10.7539 6.71875 10.262 6.06669 9.99011 5.41268C9.80915 4.97744 9.82868 4.52282 9.95741 4.07885L9.95741 4.07884C9.97662 4.0126 9.99538 3.94791 10.0334 3.88882C9.81857 3.73676 9.6515 3.55195 9.51464 3.3715C9.42876 3.25828 9.3469 3.12099 9.26197 2.97856C9.01866 2.57052 8.75018 2.12027 8.29008 2.07283C7.22889 1.96343 6.03398 2.14772 4.99899 2.61935ZM13.2081 3.77471C13.441 3.22671 12.4547 2.63606 12.0822 3.10163C11.5817 3.72732 12.9029 4.49281 13.2081 3.77471ZM14.3672 2.26031C14.9668 2.27493 15.1551 1.11603 14.5718 0.949371C13.8076 0.731026 13.5918 2.24139 14.3672 2.26031ZM14.2857 5.09098C14.8644 5.10004 15.0462 4.38222 14.4832 4.27899C13.7455 4.14375 13.5373 5.07927 14.2857 5.09098ZM6.9075 4.28672C6.46898 4.66754 6.0522 4.15185 5.97983 3.7365C5.86848 3.09744 6.33696 2.56856 6.94823 2.91156C7.43344 3.18382 7.26678 3.97471 6.9075 4.28672ZM4.94455 5.88184C5.40885 5.41754 4.59567 4.57013 4.11425 5.05154C3.83338 5.33242 4.00936 5.65376 4.23744 5.88184C4.43271 6.0771 4.74929 6.0771 4.94455 5.88184ZM6.97716 6.71984C7.31181 7.38914 8.48804 6.79159 7.99413 6.14788C7.86519 5.97983 7.68657 5.9494 7.62145 5.94207C7.21217 5.89601 6.76349 6.2925 6.97716 6.71984ZM6.98798 8.72461C7.14066 9.1188 7.51122 9.3187 7.91915 9.1633C8.27434 9.02799 8.33186 8.39689 8.17175 8.07427C8.02331 7.77514 7.63956 7.67793 7.33747 7.79417C6.98512 7.92976 6.85672 8.38708 6.98576 8.71889L6.98798 8.72461ZM10.3885 8.84081C10.7575 8.6566 11.4617 8.82771 11.4617 9.31199C11.4617 9.71286 10.9587 10.2165 10.5634 10.2826C10.1813 10.3465 9.70515 9.97581 9.76648 9.57718C9.81445 9.26539 10.1217 8.97401 10.3885 8.84081ZM7.56704 10.8432C7.33461 10.7502 7.14353 10.8601 7.11437 10.8769L7.11279 10.8778C6.90782 10.9949 6.71383 11.2439 6.6747 11.4842C6.59018 12.0034 7.13199 12.1239 7.52661 12.0987C8.2074 12.0553 8.06547 11.0426 7.56704 10.8432ZM4.8805 10.8932C5.0674 10.7723 5.15658 10.5363 5.08293 10.3153C4.93046 9.79687 4.3246 9.71252 3.96561 10.1297C3.79336 10.3299 3.80749 10.6274 3.99214 10.8105L3.99495 10.814L3.9979 10.8176C4.22025 11.0942 4.63624 11.1857 4.8805 10.8932ZM3.04695 7.81318C3.33147 8.0977 3.60077 8.15067 3.98443 8.05859C4.60826 7.90887 4.13814 6.24299 3.047 6.87296C2.70939 7.06788 2.86716 7.63339 3.04695 7.81318Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCopy(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCornerBottomLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.87737 12H9.9H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H9.9C8.77164 11 7.95545 10.9996 7.31352 10.9472C6.67744 10.8952 6.25662 10.7946 5.91103 10.6185C5.25247 10.283 4.71703 9.74753 4.38148 9.08897C4.20539 8.74338 4.10481 8.32256 4.05284 7.68648C4.00039 7.04455 4 6.22836 4 5.1V3.5C4 3.22386 3.77614 3 3.5 3C3.22386 3 3 3.22386 3 3.5V5.1V5.12263C3 6.22359 3 7.08052 3.05616 7.76791C3.11318 8.46584 3.23058 9.0329 3.49047 9.54296C3.9219 10.3897 4.61031 11.0781 5.45704 11.5095C5.9671 11.7694 6.53416 11.8868 7.23209 11.9438C7.91948 12 8.77641 12 9.87737 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCornerBottomRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.12263 12H5.1H3.5C3.22386 12 3 11.7761 3 11.5C3 11.2239 3.22386 11 3.5 11H5.1C6.22836 11 7.04455 10.9996 7.68648 10.9472C8.32256 10.8952 8.74338 10.7946 9.08897 10.6185C9.74753 10.283 10.283 9.74753 10.6185 9.08897C10.7946 8.74338 10.8952 8.32256 10.9472 7.68648C10.9996 7.04455 11 6.22836 11 5.1V3.5C11 3.22386 11.2239 3 11.5 3C11.7761 3 12 3.22386 12 3.5V5.1V5.12263C12 6.22359 12 7.08052 11.9438 7.76791C11.8868 8.46584 11.7694 9.0329 11.5095 9.54296C11.0781 10.3897 10.3897 11.0781 9.54296 11.5095C9.0329 11.7694 8.46584 11.8868 7.76791 11.9438C7.08052 12 6.22359 12 5.12263 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCornerTopLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.87737 3H9.9H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H9.9C8.77164 4 7.95545 4.00039 7.31352 4.05284C6.67744 4.10481 6.25662 4.20539 5.91103 4.38148C5.25247 4.71703 4.71703 5.25247 4.38148 5.91103C4.20539 6.25662 4.10481 6.67744 4.05284 7.31352C4.00039 7.95545 4 8.77164 4 9.9V11.5C4 11.7761 3.77614 12 3.5 12C3.22386 12 3 11.7761 3 11.5V9.9V9.87737C3 8.77641 3 7.91948 3.05616 7.23209C3.11318 6.53416 3.23058 5.9671 3.49047 5.45704C3.9219 4.61031 4.61031 3.9219 5.45704 3.49047C5.9671 3.23058 6.53416 3.11318 7.23209 3.05616C7.91948 3 8.77641 3 9.87737 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCornerTopRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.12263 3H5.1H3.5C3.22386 3 3 3.22386 3 3.5C3 3.77614 3.22386 4 3.5 4H5.1C6.22836 4 7.04455 4.00039 7.68648 4.05284C8.32256 4.10481 8.74338 4.20539 9.08897 4.38148C9.74753 4.71703 10.283 5.25247 10.6185 5.91103C10.7946 6.25662 10.8952 6.67744 10.9472 7.31352C10.9996 7.95545 11 8.77164 11 9.9V11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5V9.9V9.87737C12 8.77641 12 7.91948 11.9438 7.23209C11.8868 6.53416 11.7694 5.9671 11.5095 5.45704C11.0781 4.61031 10.3897 3.9219 9.54296 3.49047C9.0329 3.23058 8.46584 3.11318 7.76791 3.05616C7.08052 3 6.22359 3 5.12263 3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCorners(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.5 2L4.87935 2C4.47687 1.99999 4.14469 1.99999 3.87409 2.0221C3.59304 2.04506 3.33469 2.09434 3.09202 2.21799C2.7157 2.40973 2.40973 2.7157 2.21799 3.09202C2.09434 3.33469 2.04506 3.59304 2.0221 3.87409C1.99999 4.14468 1.99999 4.47686 2 4.87933V4.87935V5.5C2 5.77614 2.22386 6 2.5 6C2.77614 6 3 5.77614 3 5.5V4.9C3 4.47171 3.00039 4.18056 3.01878 3.95552C3.03669 3.73631 3.06915 3.62421 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.62421 3.06915 3.73631 3.03669 3.95552 3.01878C4.18056 3.00039 4.47171 3 4.9 3H5.5C5.77614 3 6 2.77614 6 2.5C6 2.22386 5.77614 2 5.5 2ZM13 9.5C13 9.22386 12.7761 9 12.5 9C12.2239 9 12 9.22386 12 9.5V10.1C12 10.5283 11.9996 10.8194 11.9812 11.0445C11.9633 11.2637 11.9309 11.3758 11.891 11.454C11.7951 11.6422 11.6422 11.7951 11.454 11.891C11.3758 11.9309 11.2637 11.9633 11.0445 11.9812C10.8194 11.9996 10.5283 12 10.1 12H9.5C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13H10.1206C10.5231 13 10.8553 13 11.1259 12.9779C11.407 12.9549 11.6653 12.9057 11.908 12.782C12.2843 12.5903 12.5903 12.2843 12.782 11.908C12.9057 11.6653 12.9549 11.407 12.9779 11.1259C13 10.8553 13 10.5232 13 10.1207V10.1207V10.1207V10.1206V9.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V10.1C3 10.5283 3.00039 10.8194 3.01878 11.0445C3.03669 11.2637 3.06915 11.3758 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.62421 11.9309 3.73631 11.9633 3.95552 11.9812C4.18056 11.9996 4.47171 12 4.9 12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H4.87935C4.47687 13 4.14469 13 3.87409 12.9779C3.59304 12.9549 3.33469 12.9057 3.09202 12.782C2.7157 12.5903 2.40973 12.2843 2.21799 11.908C2.09434 11.6653 2.04506 11.407 2.0221 11.1259C1.99999 10.8553 1.99999 10.5231 2 10.1207V10.1206V10.1V9.5C2 9.22386 2.22386 9 2.5 9ZM10.1 3C10.5283 3 10.8194 3.00039 11.0445 3.01878C11.2637 3.03669 11.3758 3.06915 11.454 3.10899C11.6422 3.20487 11.7951 3.35785 11.891 3.54601C11.9309 3.62421 11.9633 3.73631 11.9812 3.95552C11.9996 4.18056 12 4.47171 12 4.9V5.5C12 5.77614 12.2239 6 12.5 6C12.7761 6 13 5.77614 13 5.5V4.87935V4.87934C13 4.47686 13 4.14468 12.9779 3.87409C12.9549 3.59304 12.9057 3.33469 12.782 3.09202C12.5903 2.7157 12.2843 2.40973 11.908 2.21799C11.6653 2.09434 11.407 2.04506 11.1259 2.0221C10.8553 1.99999 10.5231 1.99999 10.1206 2L10.1 2H9.5C9.22386 2 9 2.22386 9 2.5C9 2.77614 9.22386 3 9.5 3H10.1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCountdownTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.7217 1.84998 3.34851 3.90636 2.76336 4.99997H4.5C4.77614 4.99997 5 5.22383 5 5.49997C5 5.77611 4.77614 5.99997 4.5 5.99997H1.5C1.22386 5.99997 1 5.77611 1 5.49997V2.49997C1 2.22383 1.22386 1.99997 1.5 1.99997C1.77614 1.99997 2 2.22383 2 2.49997V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7 10V5.00001H8V10H7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCounterClockwiseClock(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.15 7.49998C13.15 4.66458 10.9402 1.84998 7.50002 1.84998C4.72167 1.84998 3.34849 3.9064 2.76335 5H4.5C4.77614 5 5 5.22386 5 5.5C5 5.77614 4.77614 6 4.5 6H1.5C1.22386 6 1 5.77614 1 5.5V2.5C1 2.22386 1.22386 2 1.5 2C1.77614 2 2 2.22386 2 2.5V4.31318C2.70453 3.07126 4.33406 0.849976 7.50002 0.849976C11.5628 0.849976 14.15 4.18537 14.15 7.49998C14.15 10.8146 11.5628 14.15 7.50002 14.15C5.55618 14.15 3.93778 13.3808 2.78548 12.2084C2.16852 11.5806 1.68668 10.839 1.35816 10.0407C1.25306 9.78536 1.37488 9.49315 1.63024 9.38806C1.8856 9.28296 2.17781 9.40478 2.2829 9.66014C2.56374 10.3425 2.97495 10.9745 3.4987 11.5074C4.47052 12.4963 5.83496 13.15 7.50002 13.15C10.9402 13.15 13.15 10.3354 13.15 7.49998ZM7.5 4.00001C7.77614 4.00001 8 4.22387 8 4.50001V7.29291L9.85355 9.14646C10.0488 9.34172 10.0488 9.65831 9.85355 9.85357C9.65829 10.0488 9.34171 10.0488 9.14645 9.85357L7.14645 7.85357C7.05268 7.7598 7 7.63262 7 7.50001V4.50001C7 4.22387 7.22386 4.00001 7.5 4.00001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCrop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 8.00684e-07C3.77614 7.88614e-07 4 0.223859 4 0.500001L4 3.00006L11.5 3.00006C11.7761 3.00006 12 3.22392 12 3.50006L12 11.0001L14.5 11C14.7761 11 15 11.2238 15 11.5C15 11.7761 14.7762 12 14.5 12L12 12.0001L12 14.5C12 14.7761 11.7761 15 11.5 15C11.2239 15 11 14.7761 11 14.5L11 12.0001L3.5 12.0001C3.22386 12.0001 3 11.7762 3 11.5001L3 4.00005L0.499989 4C0.223847 4 -6.10541e-06 3.77613 -5.02576e-07 3.49999C5.13006e-06 3.22385 0.223867 3 0.50001 3L3 3.00005L3 0.500001C3 0.223859 3.22386 8.12755e-07 3.5 8.00684e-07ZM4 4.00006L4 11.0001L11 11.0001L11 4.00006L4 4.00006Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCross1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.8536 2.85355C13.0488 2.65829 13.0488 2.34171 12.8536 2.14645C12.6583 1.95118 12.3417 1.95118 12.1464 2.14645L7.5 6.79289L2.85355 2.14645C2.65829 1.95118 2.34171 1.95118 2.14645 2.14645C1.95118 2.34171 1.95118 2.65829 2.14645 2.85355L6.79289 7.5L2.14645 12.1464C1.95118 12.3417 1.95118 12.6583 2.14645 12.8536C2.34171 13.0488 2.65829 13.0488 2.85355 12.8536L7.5 8.20711L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L8.20711 7.5L12.8536 2.85355Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCross2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCrossCircled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704ZM9.85358 5.14644C10.0488 5.3417 10.0488 5.65829 9.85358 5.85355L8.20713 7.49999L9.85358 9.14644C10.0488 9.3417 10.0488 9.65829 9.85358 9.85355C9.65832 10.0488 9.34173 10.0488 9.14647 9.85355L7.50002 8.2071L5.85358 9.85355C5.65832 10.0488 5.34173 10.0488 5.14647 9.85355C4.95121 9.65829 4.95121 9.3417 5.14647 9.14644L6.79292 7.49999L5.14647 5.85355C4.95121 5.65829 4.95121 5.3417 5.14647 5.14644C5.34173 4.95118 5.65832 4.95118 5.85358 5.14644L7.50002 6.79289L9.14647 5.14644C9.34173 4.95118 9.65832 4.95118 9.85358 5.14644Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCrosshair1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.50207C0.877075 3.84319 3.84319 0.877075 7.50208 0.877075C11.1609 0.877075 14.1271 3.84319 14.1271 7.50207C14.1271 11.1609 11.1609 14.1271 7.50208 14.1271C3.84319 14.1271 0.877075 11.1609 0.877075 7.50207ZM1.84898 7.00003C2.0886 4.26639 4.26639 2.0886 7.00003 1.84898V4.50003C7.00003 4.77617 7.22388 5.00003 7.50003 5.00003C7.77617 5.00003 8.00003 4.77617 8.00003 4.50003V1.84862C10.7356 2.08643 12.9154 4.26502 13.1552 7.00003H10.5C10.2239 7.00003 10 7.22388 10 7.50003C10 7.77617 10.2239 8.00003 10.5 8.00003H13.1555C12.9176 10.7369 10.7369 12.9176 8.00003 13.1555V10.5C8.00003 10.2239 7.77617 10 7.50003 10C7.22388 10 7.00003 10.2239 7.00003 10.5V13.1552C4.26502 12.9154 2.08643 10.7356 1.84862 8.00003H4.50003C4.77617 8.00003 5.00003 7.77617 5.00003 7.50003C5.00003 7.22388 4.77617 7.00003 4.50003 7.00003H1.84898Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCrosshair2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 0C7.77614 0 8 0.223858 8 0.5V1.80687C10.6922 2.0935 12.8167 4.28012 13.0068 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H12.9888C12.7094 10.6244 10.6244 12.7094 8 12.9888V14.5C8 14.7761 7.77614 15 7.5 15C7.22386 15 7 14.7761 7 14.5V13.0068C4.28012 12.8167 2.0935 10.6922 1.80687 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H1.78886C1.98376 4.21166 4.21166 1.98376 7 1.78886V0.5C7 0.223858 7.22386 0 7.5 0ZM8 12.0322V9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V12.054C4.80517 11.8689 3.04222 10.1668 2.76344 8H5.5C5.77614 8 6 7.77614 6 7.5C6 7.22386 5.77614 7 5.5 7H2.7417C2.93252 4.73662 4.73662 2.93252 7 2.7417V5.5C7 5.77614 7.22386 6 7.5 6C7.77614 6 8 5.77614 8 5.5V2.76344C10.1668 3.04222 11.8689 4.80517 12.054 7H9.5C9.22386 7 9 7.22386 9 7.5C9 7.77614 9.22386 8 9.5 8H12.0322C11.7621 10.0991 10.0991 11.7621 8 12.0322Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCrumpledPaper(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.60913 0.0634287C4.39082 0.0088505 4.16575 0.12393 4.08218 0.332867L3.1538 2.6538L0.832866 3.58218C0.702884 3.63417 0.604504 3.7437 0.566705 3.87849C0.528906 4.01329 0.555994 4.158 0.639992 4.26999L2.01148 6.09864L1.06343 9.89085C1.00944 10.1068 1.12145 10.3298 1.32691 10.4154L4.20115 11.613L5.62557 13.7496C5.73412 13.9124 5.93545 13.9864 6.12362 13.9327L9.62362 12.9327C9.62988 12.9309 9.63611 12.929 9.64229 12.9269L12.6423 11.9269C12.7923 11.8769 12.905 11.7519 12.9393 11.5976L13.9393 7.09761C13.9776 6.92506 13.9114 6.74605 13.77 6.63999L11.95 5.27499V2.99999C11.95 2.82955 11.8537 2.67373 11.7012 2.5975L8.70124 1.0975C8.67187 1.08282 8.64098 1.07139 8.60913 1.06343L4.60913 0.0634287ZM11.4323 6.01173L12.7748 7.01858L10.2119 9.15429C10.1476 9.20786 10.0995 9.2783 10.0731 9.35769L9.25382 11.8155L7.73849 10.8684C7.52774 10.7367 7.25011 10.8007 7.11839 11.0115C6.98667 11.2222 7.05074 11.4999 7.26149 11.6316L8.40341 12.3453L6.19221 12.9771L4.87441 11.0004C4.82513 10.9265 4.75508 10.8688 4.67307 10.8346L2.03046 9.73352L2.85134 6.44999H4.99999C5.24852 6.44999 5.44999 6.24852 5.44999 5.99999C5.44999 5.75146 5.24852 5.54999 4.99999 5.54999H2.72499L1.7123 4.19974L3.51407 3.47903L6.35769 4.4269C6.53655 4.48652 6.73361 4.42832 6.85138 4.28111L8.62413 2.06518L11.05 3.27811V5.19533L8.83287 6.08218C8.70996 6.13134 8.61494 6.23212 8.57308 6.35769L8.07308 7.85769C7.99449 8.09346 8.12191 8.34831 8.35769 8.4269C8.59346 8.50549 8.84831 8.37807 8.9269 8.14229L9.3609 6.84029L11.4323 6.01173ZM7.71052 1.76648L6.34462 3.47386L4.09505 2.724L4.77192 1.03183L7.71052 1.76648ZM10.2115 11.7885L12.116 11.1537L12.7745 8.19034L10.8864 9.76374L10.2115 11.7885Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCube(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.28856 0.796908C7.42258 0.734364 7.57742 0.734364 7.71144 0.796908L13.7114 3.59691C13.8875 3.67906 14 3.85574 14 4.05V10.95C14 11.1443 13.8875 11.3209 13.7114 11.4031L7.71144 14.2031C7.57742 14.2656 7.42258 14.2656 7.28856 14.2031L1.28856 11.4031C1.11252 11.3209 1 11.1443 1 10.95V4.05C1 3.85574 1.11252 3.67906 1.28856 3.59691L7.28856 0.796908ZM2 4.80578L7 6.93078V12.9649L2 10.6316V4.80578ZM8 12.9649L13 10.6316V4.80578L8 6.93078V12.9649ZM7.5 6.05672L12.2719 4.02866L7.5 1.80176L2.72809 4.02866L7.5 6.05672Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCursorArrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxCursorText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2C5.42215 2 6.0399 2.23054 6.42075 2.56379C6.79286 2.88939 7 3.36626 7 4V7H5.75C5.47386 7 5.25 7.22386 5.25 7.5C5.25 7.77614 5.47386 8 5.75 8H7V11C7 11.6337 6.79286 12.1106 6.42075 12.4362C6.0399 12.7695 5.42215 13 4.5 13C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14C5.57785 14 6.4601 13.7305 7.07925 13.1888C7.24168 13.0467 7.38169 12.8896 7.5 12.7198C7.61832 12.8896 7.75832 13.0467 7.92075 13.1888C8.5399 13.7305 9.42215 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.57785 13 8.9601 12.7695 8.57925 12.4362C8.20714 12.1106 8 11.6337 8 11V8H9.25C9.52614 8 9.75 7.77614 9.75 7.5C9.75 7.22386 9.52614 7 9.25 7H8V4C8 3.36626 8.20714 2.88939 8.57925 2.56379C8.9601 2.23054 9.57785 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.42215 1 8.5399 1.26946 7.92075 1.81121C7.75832 1.95333 7.61832 2.11043 7.5 2.28023C7.38168 2.11043 7.24168 1.95333 7.07925 1.81121C6.4601 1.26946 5.57785 1 4.5 1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 7.5C5 7.22386 5.22386 7 5.5 7H9.5C9.77614 7 10 7.22386 10 7.5C10 7.77614 9.77614 8 9.5 8H5.5C5.22386 8 5 7.77614 5 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDashboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.8 1L2.74967 0.99997C2.52122 0.999752 2.32429 0.999564 2.14983 1.04145C1.60136 1.17312 1.17312 1.60136 1.04145 2.14983C0.999564 2.32429 0.999752 2.52122 0.99997 2.74967L1 2.8V5.2L0.99997 5.25033C0.999752 5.47878 0.999564 5.67572 1.04145 5.85017C1.17312 6.39864 1.60136 6.82688 2.14983 6.95856C2.32429 7.00044 2.52122 7.00025 2.74967 7.00003L2.8 7H5.2L5.25033 7.00003C5.47878 7.00025 5.67572 7.00044 5.85017 6.95856C6.39864 6.82688 6.82688 6.39864 6.95856 5.85017C7.00044 5.67572 7.00025 5.47878 7.00003 5.25033L7 5.2V2.8L7.00003 2.74967C7.00025 2.52122 7.00044 2.32429 6.95856 2.14983C6.82688 1.60136 6.39864 1.17312 5.85017 1.04145C5.67572 0.999564 5.47878 0.999752 5.25033 0.99997L5.2 1H2.8ZM2.38328 2.01382C2.42632 2.00348 2.49222 2 2.8 2H5.2C5.50779 2 5.57369 2.00348 5.61672 2.01382C5.79955 2.05771 5.94229 2.20045 5.98619 2.38328C5.99652 2.42632 6 2.49222 6 2.8V5.2C6 5.50779 5.99652 5.57369 5.98619 5.61672C5.94229 5.79955 5.79955 5.94229 5.61672 5.98619C5.57369 5.99652 5.50779 6 5.2 6H2.8C2.49222 6 2.42632 5.99652 2.38328 5.98619C2.20045 5.94229 2.05771 5.79955 2.01382 5.61672C2.00348 5.57369 2 5.50779 2 5.2V2.8C2 2.49222 2.00348 2.42632 2.01382 2.38328C2.05771 2.20045 2.20045 2.05771 2.38328 2.01382ZM9.8 1L9.74967 0.99997C9.52122 0.999752 9.32429 0.999564 9.14983 1.04145C8.60136 1.17312 8.17312 1.60136 8.04145 2.14983C7.99956 2.32429 7.99975 2.52122 7.99997 2.74967L8 2.8V5.2L7.99997 5.25033C7.99975 5.47878 7.99956 5.67572 8.04145 5.85017C8.17312 6.39864 8.60136 6.82688 9.14983 6.95856C9.32429 7.00044 9.52122 7.00025 9.74967 7.00003L9.8 7H12.2L12.2503 7.00003C12.4788 7.00025 12.6757 7.00044 12.8502 6.95856C13.3986 6.82688 13.8269 6.39864 13.9586 5.85017C14.0004 5.67572 14.0003 5.47878 14 5.25033L14 5.2V2.8L14 2.74967C14.0003 2.52122 14.0004 2.32429 13.9586 2.14983C13.8269 1.60136 13.3986 1.17312 12.8502 1.04145C12.6757 0.999564 12.4788 0.999752 12.2503 0.99997L12.2 1H9.8ZM9.38328 2.01382C9.42632 2.00348 9.49222 2 9.8 2H12.2C12.5078 2 12.5737 2.00348 12.6167 2.01382C12.7995 2.05771 12.9423 2.20045 12.9862 2.38328C12.9965 2.42632 13 2.49222 13 2.8V5.2C13 5.50779 12.9965 5.57369 12.9862 5.61672C12.9423 5.79955 12.7995 5.94229 12.6167 5.98619C12.5737 5.99652 12.5078 6 12.2 6H9.8C9.49222 6 9.42632 5.99652 9.38328 5.98619C9.20045 5.94229 9.05771 5.79955 9.01382 5.61672C9.00348 5.57369 9 5.50779 9 5.2V2.8C9 2.49222 9.00348 2.42632 9.01382 2.38328C9.05771 2.20045 9.20045 2.05771 9.38328 2.01382ZM2.74967 7.99997L2.8 8H5.2L5.25033 7.99997C5.47878 7.99975 5.67572 7.99956 5.85017 8.04145C6.39864 8.17312 6.82688 8.60136 6.95856 9.14983C7.00044 9.32429 7.00025 9.52122 7.00003 9.74967L7 9.8V12.2L7.00003 12.2503C7.00025 12.4788 7.00044 12.6757 6.95856 12.8502C6.82688 13.3986 6.39864 13.8269 5.85017 13.9586C5.67572 14.0004 5.47878 14.0003 5.25033 14L5.2 14H2.8L2.74967 14C2.52122 14.0003 2.32429 14.0004 2.14983 13.9586C1.60136 13.8269 1.17312 13.3986 1.04145 12.8502C0.999564 12.6757 0.999752 12.4788 0.99997 12.2503L1 12.2V9.8L0.99997 9.74967C0.999752 9.52122 0.999564 9.32429 1.04145 9.14983C1.17312 8.60136 1.60136 8.17312 2.14983 8.04145C2.32429 7.99956 2.52122 7.99975 2.74967 7.99997ZM2.8 9C2.49222 9 2.42632 9.00348 2.38328 9.01382C2.20045 9.05771 2.05771 9.20045 2.01382 9.38328C2.00348 9.42632 2 9.49222 2 9.8V12.2C2 12.5078 2.00348 12.5737 2.01382 12.6167C2.05771 12.7995 2.20045 12.9423 2.38328 12.9862C2.42632 12.9965 2.49222 13 2.8 13H5.2C5.50779 13 5.57369 12.9965 5.61672 12.9862C5.79955 12.9423 5.94229 12.7995 5.98619 12.6167C5.99652 12.5737 6 12.5078 6 12.2V9.8C6 9.49222 5.99652 9.42632 5.98619 9.38328C5.94229 9.20045 5.79955 9.05771 5.61672 9.01382C5.57369 9.00348 5.50779 9 5.2 9H2.8ZM9.8 8L9.74967 7.99997C9.52122 7.99975 9.32429 7.99956 9.14983 8.04145C8.60136 8.17312 8.17312 8.60136 8.04145 9.14983C7.99956 9.32429 7.99975 9.52122 7.99997 9.74967L8 9.8V12.2L7.99997 12.2503C7.99975 12.4788 7.99956 12.6757 8.04145 12.8502C8.17312 13.3986 8.60136 13.8269 9.14983 13.9586C9.32429 14.0004 9.52122 14.0003 9.74967 14L9.8 14H12.2L12.2503 14C12.4788 14.0003 12.6757 14.0004 12.8502 13.9586C13.3986 13.8269 13.8269 13.3986 13.9586 12.8502C14.0004 12.6757 14.0003 12.4788 14 12.2503L14 12.2V9.8L14 9.74967C14.0003 9.52122 14.0004 9.32429 13.9586 9.14983C13.8269 8.60136 13.3986 8.17312 12.8502 8.04145C12.6757 7.99956 12.4788 7.99975 12.2503 7.99997L12.2 8H9.8ZM9.38328 9.01382C9.42632 9.00348 9.49222 9 9.8 9H12.2C12.5078 9 12.5737 9.00348 12.6167 9.01382C12.7995 9.05771 12.9423 9.20045 12.9862 9.38328C12.9965 9.42632 13 9.49222 13 9.8V12.2C13 12.5078 12.9965 12.5737 12.9862 12.6167C12.9423 12.7995 12.7995 12.9423 12.6167 12.9862C12.5737 12.9965 12.5078 13 12.2 13H9.8C9.49222 13 9.42632 12.9965 9.38328 12.9862C9.20045 12.9423 9.05771 12.7995 9.01382 12.6167C9.00348 12.5737 9 12.5078 9 12.2V9.8C9 9.49222 9.00348 9.42632 9.01382 9.38328C9.05771 9.20045 9.20045 9.05771 9.38328 9.01382Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDesktop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 3.25C1 3.11193 1.11193 3 1.25 3H13.75C13.8881 3 14 3.11193 14 3.25V10.75C14 10.8881 13.8881 11 13.75 11H1.25C1.11193 11 1 10.8881 1 10.75V3.25ZM1.25 2C0.559643 2 0 2.55964 0 3.25V10.75C0 11.4404 0.559644 12 1.25 12H5.07341L4.82991 13.2986C4.76645 13.6371 5.02612 13.95 5.37049 13.95H9.62951C9.97389 13.95 10.2336 13.6371 10.1701 13.2986L9.92659 12H13.75C14.4404 12 15 11.4404 15 10.75V3.25C15 2.55964 14.4404 2 13.75 2H1.25ZM9.01091 12H5.98909L5.79222 13.05H9.20778L9.01091 12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDimensions(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.00014 2.73895C3.00014 2.94698 2.76087 3.06401 2.59666 2.93628L1.00386 1.69744C0.875177 1.59735 0.875177 1.40286 1.00386 1.30277L2.59666 0.063928C2.76087 -0.0637944 3.00014 0.0532293 3.00014 0.261266V1.00012H9.00009V0.261296C9.00009 0.0532591 9.23936 -0.0637646 9.40358 0.0639578L10.9964 1.3028C11.1251 1.40289 11.1251 1.59738 10.9964 1.69747L9.40358 2.93631C9.23936 3.06404 9.00009 2.94701 9.00009 2.73898V2.00012H3.00014V2.73895ZM9.50002 4.99998H2.50002C2.22388 4.99998 2.00002 5.22384 2.00002 5.49998V12.5C2.00002 12.7761 2.22388 13 2.50002 13H9.50002C9.77616 13 10 12.7761 10 12.5V5.49998C10 5.22384 9.77616 4.99998 9.50002 4.99998ZM2.50002 3.99998C1.67159 3.99998 1.00002 4.67156 1.00002 5.49998V12.5C1.00002 13.3284 1.67159 14 2.50002 14H9.50002C10.3284 14 11 13.3284 11 12.5V5.49998C11 4.67156 10.3284 3.99998 9.50002 3.99998H2.50002ZM14.7389 6.00001H14V12H14.7389C14.9469 12 15.064 12.2393 14.9362 12.4035L13.6974 13.9963C13.5973 14.125 13.4028 14.125 13.3027 13.9963L12.0639 12.4035C11.9362 12.2393 12.0532 12 12.2612 12H13V6.00001H12.2612C12.0532 6.00001 11.9361 5.76074 12.0639 5.59653L13.3027 4.00373C13.4028 3.87505 13.5973 3.87505 13.6974 4.00374L14.9362 5.59653C15.0639 5.76074 14.9469 6.00001 14.7389 6.00001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDisc(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.877075C3.84222 0.877075 0.877075 3.84222 0.877075 7.49991C0.877075 11.1576 3.84222 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1576 14.1227 7.49991C14.1227 3.84222 11.1576 0.877075 7.49991 0.877075ZM1.82708 7.49991C1.82708 4.36689 4.36689 1.82707 7.49991 1.82707C10.6329 1.82707 13.1727 4.36689 13.1727 7.49991C13.1727 10.6329 10.6329 13.1727 7.49991 13.1727C4.36689 13.1727 1.82708 10.6329 1.82708 7.49991ZM8.37287 7.50006C8.37287 7.98196 7.98221 8.37263 7.5003 8.37263C7.01839 8.37263 6.62773 7.98196 6.62773 7.50006C6.62773 7.01815 7.01839 6.62748 7.5003 6.62748C7.98221 6.62748 8.37287 7.01815 8.37287 7.50006ZM9.32287 7.50006C9.32287 8.50664 8.50688 9.32263 7.5003 9.32263C6.49372 9.32263 5.67773 8.50664 5.67773 7.50006C5.67773 6.49348 6.49372 5.67748 7.5003 5.67748C8.50688 5.67748 9.32287 6.49348 9.32287 7.50006Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDiscordLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.07451 1.82584C5.03267 1.81926 4.99014 1.81825 4.94803 1.82284C4.10683 1.91446 2.82673 2.36828 2.07115 2.77808C2.02106 2.80525 1.97621 2.84112 1.93869 2.88402C1.62502 3.24266 1.34046 3.82836 1.11706 4.38186C0.887447 4.95076 0.697293 5.55032 0.588937 5.98354C0.236232 7.39369 0.042502 9.08728 0.0174948 10.6925C0.0162429 10.7729 0.0351883 10.8523 0.0725931 10.9234C0.373679 11.496 1.02015 12.027 1.66809 12.4152C2.32332 12.8078 3.08732 13.1182 3.70385 13.1778C3.85335 13.1922 4.00098 13.1358 4.10282 13.0255C4.2572 12.8581 4.5193 12.4676 4.71745 12.1643C4.80739 12.0267 4.89157 11.8953 4.95845 11.7901C5.62023 11.9106 6.45043 11.9801 7.50002 11.9801C8.54844 11.9801 9.37796 11.9107 10.0394 11.7905C10.1062 11.8957 10.1903 12.0269 10.2801 12.1643C10.4783 12.4676 10.7404 12.8581 10.8947 13.0255C10.9966 13.1358 11.1442 13.1922 11.2937 13.1778C11.9102 13.1182 12.6742 12.8078 13.3295 12.4152C13.9774 12.027 14.6239 11.496 14.925 10.9234C14.9624 10.8523 14.9813 10.7729 14.9801 10.6925C14.9551 9.08728 14.7613 7.39369 14.4086 5.98354C14.3003 5.55032 14.1101 4.95076 13.8805 4.38186C13.6571 3.82836 13.3725 3.24266 13.0589 2.88402C13.0214 2.84112 12.9765 2.80525 12.9264 2.77808C12.1708 2.36828 10.8907 1.91446 10.0495 1.82284C10.0074 1.81825 9.96489 1.81926 9.92305 1.82584C9.71676 1.85825 9.5391 1.96458 9.40809 2.06355C9.26977 2.16804 9.1413 2.29668 9.0304 2.42682C8.86968 2.61544 8.71437 2.84488 8.61428 3.06225C8.27237 3.03501 7.90138 3.02 7.5 3.02C7.0977 3.02 6.72593 3.03508 6.38337 3.06244C6.28328 2.84501 6.12792 2.61549 5.96716 2.42682C5.85626 2.29668 5.72778 2.16804 5.58947 2.06355C5.45846 1.96458 5.2808 1.85825 5.07451 1.82584ZM11.0181 11.5382C11.0395 11.5713 11.0615 11.6051 11.0838 11.6392C11.2169 11.843 11.3487 12.0385 11.4508 12.1809C11.8475 12.0916 12.352 11.8818 12.8361 11.5917C13.3795 11.2661 13.8098 10.8918 14.0177 10.5739C13.9852 9.06758 13.7993 7.50369 13.4773 6.21648C13.38 5.82759 13.2038 5.27021 12.9903 4.74117C12.7893 4.24326 12.5753 3.82162 12.388 3.5792C11.7376 3.24219 10.7129 2.88582 10.0454 2.78987C10.0308 2.79839 10.0113 2.81102 9.98675 2.82955C9.91863 2.881 9.84018 2.95666 9.76111 3.04945C9.71959 3.09817 9.68166 3.1471 9.64768 3.19449C9.953 3.25031 10.2253 3.3171 10.4662 3.39123C11.1499 3.6016 11.6428 3.89039 11.884 4.212C12.0431 4.42408 12.0001 4.72494 11.788 4.884C11.5759 5.04306 11.2751 5.00008 11.116 4.788C11.0572 4.70961 10.8001 4.4984 10.1838 4.30877C9.58933 4.12585 8.71356 3.98 7.5 3.98C6.28644 3.98 5.41067 4.12585 4.81616 4.30877C4.19988 4.4984 3.94279 4.70961 3.884 4.788C3.72494 5.00008 3.42408 5.04306 3.212 4.884C2.99992 4.72494 2.95694 4.42408 3.116 4.212C3.35721 3.89039 3.85011 3.6016 4.53383 3.39123C4.77418 3.31727 5.04571 3.25062 5.35016 3.19488C5.31611 3.14738 5.27808 3.09831 5.23645 3.04945C5.15738 2.95666 5.07893 2.881 5.01081 2.82955C4.98628 2.81102 4.96674 2.79839 4.95217 2.78987C4.28464 2.88582 3.25999 3.24219 2.60954 3.5792C2.42226 3.82162 2.20825 4.24326 2.00729 4.74117C1.79376 5.27021 1.61752 5.82759 1.52025 6.21648C1.19829 7.50369 1.01236 9.06758 0.97986 10.5739C1.18772 10.8918 1.61807 11.2661 2.16148 11.5917C2.64557 11.8818 3.15003 12.0916 3.5468 12.1809C3.64885 12.0385 3.78065 11.843 3.9138 11.6392C3.93626 11.6048 3.95838 11.5708 3.97996 11.5375C3.19521 11.2591 2.77361 10.8758 2.50064 10.4664C2.35359 10.2458 2.4132 9.94778 2.63377 9.80074C2.85435 9.65369 3.15236 9.71329 3.29941 9.93387C3.56077 10.3259 4.24355 11.0201 7.50002 11.0201C10.7565 11.0201 11.4392 10.326 11.7006 9.93386C11.8477 9.71329 12.1457 9.65369 12.3663 9.80074C12.5869 9.94779 12.6465 10.2458 12.4994 10.4664C12.2262 10.8762 11.8041 11.2598 11.0181 11.5382ZM4.08049 7.01221C4.32412 6.74984 4.65476 6.60162 5.00007 6.59998C5.34538 6.60162 5.67603 6.74984 5.91966 7.01221C6.16329 7.27459 6.30007 7.62974 6.30007 7.99998C6.30007 8.37021 6.16329 8.72536 5.91966 8.98774C5.67603 9.25011 5.34538 9.39833 5.00007 9.39998C4.65476 9.39833 4.32412 9.25011 4.08049 8.98774C3.83685 8.72536 3.70007 8.37021 3.70007 7.99998C3.70007 7.62974 3.83685 7.27459 4.08049 7.01221ZM9.99885 6.59998C9.65354 6.60162 9.3229 6.74984 9.07926 7.01221C8.83563 7.27459 8.69885 7.62974 8.69885 7.99998C8.69885 8.37021 8.83563 8.72536 9.07926 8.98774C9.3229 9.25011 9.65354 9.39833 9.99885 9.39998C10.3442 9.39833 10.6748 9.25011 10.9184 8.98774C11.1621 8.72536 11.2989 8.37021 11.2989 7.99998C11.2989 7.62974 11.1621 7.27459 10.9184 7.01221C10.6748 6.74984 10.3442 6.60162 9.99885 6.59998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDividerHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDividerVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 2C7.77614 2 8 2.22386 8 2.5L8 12.5C8 12.7761 7.77614 13 7.5 13C7.22386 13 7 12.7761 7 12.5L7 2.5C7 2.22386 7.22386 2 7.5 2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDotFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9.875 7.5C9.875 8.81168 8.81168 9.875 7.5 9.875C6.18832 9.875 5.125 8.81168 5.125 7.5C5.125 6.18832 6.18832 5.125 7.5 5.125C8.81168 5.125 9.875 6.18832 9.875 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDot(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 9.125C8.39746 9.125 9.125 8.39746 9.125 7.5C9.125 6.60254 8.39746 5.875 7.5 5.875C6.60254 5.875 5.875 6.60254 5.875 7.5C5.875 8.39746 6.60254 9.125 7.5 9.125ZM7.5 10.125C8.94975 10.125 10.125 8.94975 10.125 7.5C10.125 6.05025 8.94975 4.875 7.5 4.875C6.05025 4.875 4.875 6.05025 4.875 7.5C4.875 8.94975 6.05025 10.125 7.5 10.125Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDotsHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDotsVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.625 2.5C8.625 3.12132 8.12132 3.625 7.5 3.625C6.87868 3.625 6.375 3.12132 6.375 2.5C6.375 1.87868 6.87868 1.375 7.5 1.375C8.12132 1.375 8.625 1.87868 8.625 2.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM7.5 13.625C8.12132 13.625 8.625 13.1213 8.625 12.5C8.625 11.8787 8.12132 11.375 7.5 11.375C6.87868 11.375 6.375 11.8787 6.375 12.5C6.375 13.1213 6.87868 13.625 7.5 13.625Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDoubleArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.85355 2.14645C3.65829 1.95118 3.34171 1.95118 3.14645 2.14645C2.95118 2.34171 2.95118 2.65829 3.14645 2.85355L7.14645 6.85355C7.34171 7.04882 7.65829 7.04882 7.85355 6.85355L11.8536 2.85355C12.0488 2.65829 12.0488 2.34171 11.8536 2.14645C11.6583 1.95118 11.3417 1.95118 11.1464 2.14645L7.5 5.79289L3.85355 2.14645ZM3.85355 8.14645C3.65829 7.95118 3.34171 7.95118 3.14645 8.14645C2.95118 8.34171 2.95118 8.65829 3.14645 8.85355L7.14645 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L11.8536 8.85355C12.0488 8.65829 12.0488 8.34171 11.8536 8.14645C11.6583 7.95118 11.3417 7.95118 11.1464 8.14645L7.5 11.7929L3.85355 8.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDoubleArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDoubleArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDoubleArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.1464 6.85355C11.3417 7.04882 11.6583 7.04882 11.8536 6.85355C12.0488 6.65829 12.0488 6.34171 11.8536 6.14645L7.85355 2.14645C7.65829 1.95118 7.34171 1.95118 7.14645 2.14645L3.14645 6.14645C2.95118 6.34171 2.95118 6.65829 3.14645 6.85355C3.34171 7.04882 3.65829 7.04882 3.85355 6.85355L7.5 3.20711L11.1464 6.85355ZM11.1464 12.8536C11.3417 13.0488 11.6583 13.0488 11.8536 12.8536C12.0488 12.6583 12.0488 12.3417 11.8536 12.1464L7.85355 8.14645C7.65829 7.95118 7.34171 7.95118 7.14645 8.14645L3.14645 12.1464C2.95118 12.3417 2.95118 12.6583 3.14645 12.8536C3.34171 13.0488 3.65829 13.0488 3.85355 12.8536L7.5 9.20711L11.1464 12.8536Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDownload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDragHandleDots1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "2.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "4.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "6.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "8.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "10.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "4.5",
                    "cy": "12.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "2.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "4.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "6.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "8.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "10.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "6.5",
                    "cy": "12.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.499",
                    "cy": "2.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.499",
                    "cy": "4.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.499",
                    "cy": "6.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.499",
                    "cy": "8.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.499",
                    "cy": "10.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "8.499",
                    "cy": "12.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.499",
                    "cy": "2.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.499",
                    "cy": "4.5",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.499",
                    "cy": "6.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.499",
                    "cy": "8.499",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.499",
                    "cy": "10.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "circle",
                "attr": {
                    "cx": "10.499",
                    "cy": "12.498",
                    "r": ".6",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDragHandleDots2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.5 4.625C6.12132 4.625 6.625 4.12132 6.625 3.5C6.625 2.87868 6.12132 2.375 5.5 2.375C4.87868 2.375 4.375 2.87868 4.375 3.5C4.375 4.12132 4.87868 4.625 5.5 4.625ZM9.5 4.625C10.1213 4.625 10.625 4.12132 10.625 3.5C10.625 2.87868 10.1213 2.375 9.5 2.375C8.87868 2.375 8.375 2.87868 8.375 3.5C8.375 4.12132 8.87868 4.625 9.5 4.625ZM10.625 7.5C10.625 8.12132 10.1213 8.625 9.5 8.625C8.87868 8.625 8.375 8.12132 8.375 7.5C8.375 6.87868 8.87868 6.375 9.5 6.375C10.1213 6.375 10.625 6.87868 10.625 7.5ZM5.5 8.625C6.12132 8.625 6.625 8.12132 6.625 7.5C6.625 6.87868 6.12132 6.375 5.5 6.375C4.87868 6.375 4.375 6.87868 4.375 7.5C4.375 8.12132 4.87868 8.625 5.5 8.625ZM10.625 11.5C10.625 12.1213 10.1213 12.625 9.5 12.625C8.87868 12.625 8.375 12.1213 8.375 11.5C8.375 10.8787 8.87868 10.375 9.5 10.375C10.1213 10.375 10.625 10.8787 10.625 11.5ZM5.5 12.625C6.12132 12.625 6.625 12.1213 6.625 11.5C6.625 10.8787 6.12132 10.375 5.5 10.375C4.87868 10.375 4.375 10.8787 4.375 11.5C4.375 12.1213 4.87868 12.625 5.5 12.625Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDragHandleHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.49998 4.09998C2.27906 4.09998 2.09998 4.27906 2.09998 4.49998C2.09998 4.72089 2.27906 4.89998 2.49998 4.89998H12.5C12.7209 4.89998 12.9 4.72089 12.9 4.49998C12.9 4.27906 12.7209 4.09998 12.5 4.09998H2.49998ZM2.49998 6.09998C2.27906 6.09998 2.09998 6.27906 2.09998 6.49998C2.09998 6.72089 2.27906 6.89998 2.49998 6.89998H12.5C12.7209 6.89998 12.9 6.72089 12.9 6.49998C12.9 6.27906 12.7209 6.09998 12.5 6.09998H2.49998ZM2.09998 8.49998C2.09998 8.27906 2.27906 8.09998 2.49998 8.09998H12.5C12.7209 8.09998 12.9 8.27906 12.9 8.49998C12.9 8.72089 12.7209 8.89998 12.5 8.89998H2.49998C2.27906 8.89998 2.09998 8.72089 2.09998 8.49998ZM2.49998 10.1C2.27906 10.1 2.09998 10.2791 2.09998 10.5C2.09998 10.7209 2.27906 10.9 2.49998 10.9H12.5C12.7209 10.9 12.9 10.7209 12.9 10.5C12.9 10.2791 12.7209 10.1 12.5 10.1H2.49998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDragHandleVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.09998 12.5C4.09998 12.7209 4.27906 12.9 4.49998 12.9C4.72089 12.9 4.89998 12.7209 4.89998 12.5L4.89998 2.50002C4.89998 2.27911 4.72089 2.10003 4.49998 2.10003C4.27906 2.10003 4.09998 2.27911 4.09998 2.50002L4.09998 12.5ZM6.09998 12.5C6.09998 12.7209 6.27906 12.9 6.49998 12.9C6.72089 12.9 6.89998 12.7209 6.89998 12.5L6.89998 2.50002C6.89998 2.27911 6.72089 2.10003 6.49998 2.10003C6.27906 2.10003 6.09998 2.27911 6.09998 2.50002L6.09998 12.5ZM8.49998 12.9C8.27906 12.9 8.09998 12.7209 8.09998 12.5L8.09998 2.50002C8.09998 2.27911 8.27906 2.10002 8.49998 2.10002C8.72089 2.10002 8.89998 2.27911 8.89998 2.50002L8.89998 12.5C8.89998 12.7209 8.72089 12.9 8.49998 12.9ZM10.1 12.5C10.1 12.7209 10.2791 12.9 10.5 12.9C10.7209 12.9 10.9 12.7209 10.9 12.5L10.9 2.50002C10.9 2.27911 10.7209 2.10002 10.5 2.10002C10.2791 2.10002 10.1 2.27911 10.1 2.50002L10.1 12.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDrawingPinFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.62129 1.13607C9.81656 0.940808 10.1331 0.940809 10.3284 1.13607L11.3891 2.19673L12.8033 3.61094L13.8639 4.6716C14.0592 4.86687 14.0592 5.18345 13.8639 5.37871C13.6687 5.57397 13.3521 5.57397 13.1568 5.37871L12.5038 4.7257L8.86727 9.57443L9.97485 10.682C10.1701 10.8773 10.1701 11.1939 9.97485 11.3891C9.77959 11.5844 9.463 11.5844 9.26774 11.3891L7.85353 9.97491L6.79287 8.91425L3.5225 12.1846C3.32724 12.3799 3.01065 12.3799 2.81539 12.1846C2.62013 11.9894 2.62013 11.6728 2.81539 11.4775L6.08576 8.20714L5.0251 7.14648L3.61089 5.73226C3.41563 5.537 3.41562 5.22042 3.61089 5.02516C3.80615 4.8299 4.12273 4.8299 4.31799 5.02516L5.42557 6.13274L10.2743 2.49619L9.62129 1.84318C9.42603 1.64792 9.42603 1.33133 9.62129 1.13607Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDrawingPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.3285 1.13607C10.1332 0.940809 9.81662 0.940808 9.62136 1.13607C9.42609 1.33133 9.42609 1.64792 9.62136 1.84318L10.2744 2.49619L5.42563 6.13274L4.31805 5.02516C4.12279 4.8299 3.80621 4.8299 3.61095 5.02516C3.41569 5.22042 3.41569 5.537 3.61095 5.73226L5.02516 7.14648L6.08582 8.20714L2.81545 11.4775C2.62019 11.6728 2.62019 11.9894 2.81545 12.1846C3.01072 12.3799 3.3273 12.3799 3.52256 12.1846L6.79293 8.91425L7.85359 9.97491L9.2678 11.3891C9.46306 11.5844 9.77965 11.5844 9.97491 11.3891C10.1702 11.1939 10.1702 10.8773 9.97491 10.682L8.86733 9.57443L12.5039 4.7257L13.1569 5.37871C13.3522 5.57397 13.6687 5.57397 13.864 5.37871C14.0593 5.18345 14.0593 4.86687 13.864 4.6716L12.8033 3.61094L11.3891 2.19673L10.3285 1.13607ZM6.13992 6.84702L10.9887 3.21047L11.7896 4.01142L8.15305 8.86015L6.13992 6.84702Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxDropdownMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49999 3.09998C7.27907 3.09998 7.09999 3.27906 7.09999 3.49998C7.09999 3.72089 7.27907 3.89998 7.49999 3.89998H14.5C14.7209 3.89998 14.9 3.72089 14.9 3.49998C14.9 3.27906 14.7209 3.09998 14.5 3.09998H7.49999ZM7.49998 5.1C7.27907 5.1 7.09998 5.27908 7.09998 5.5C7.09998 5.72091 7.27907 5.9 7.49998 5.9H14.5C14.7209 5.9 14.9 5.72091 14.9 5.5C14.9 5.27908 14.7209 5.1 14.5 5.1H7.49998ZM7.1 7.5C7.1 7.27908 7.27909 7.1 7.5 7.1H14.5C14.7209 7.1 14.9 7.27908 14.9 7.5C14.9 7.72091 14.7209 7.9 14.5 7.9H7.5C7.27909 7.9 7.1 7.72091 7.1 7.5ZM7.49998 9.1C7.27907 9.1 7.09998 9.27908 7.09998 9.5C7.09998 9.72091 7.27907 9.9 7.49998 9.9H14.5C14.7209 9.9 14.9 9.72091 14.9 9.5C14.9 9.27908 14.7209 9.1 14.5 9.1H7.49998ZM7.09998 11.5C7.09998 11.2791 7.27907 11.1 7.49998 11.1H14.5C14.7209 11.1 14.9 11.2791 14.9 11.5C14.9 11.7209 14.7209 11.9 14.5 11.9H7.49998C7.27907 11.9 7.09998 11.7209 7.09998 11.5ZM2.5 9.25003L5 6.00003H0L2.5 9.25003Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEnterFullScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H3V5.5C3 5.77614 2.77614 6 2.5 6C2.22386 6 2 5.77614 2 5.5V2.5ZM9 2.5C9 2.22386 9.22386 2 9.5 2H12.5C12.7761 2 13 2.22386 13 2.5V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3H9.5C9.22386 3 9 2.77614 9 2.5ZM2.5 9C2.77614 9 3 9.22386 3 9.5V12H5.5C5.77614 12 6 12.2239 6 12.5C6 12.7761 5.77614 13 5.5 13H2.5C2.22386 13 2 12.7761 2 12.5V9.5C2 9.22386 2.22386 9 2.5 9ZM12.5 9C12.7761 9 13 9.22386 13 9.5V12.5C13 12.7761 12.7761 13 12.5 13H9.5C9.22386 13 9 12.7761 9 12.5C9 12.2239 9.22386 12 9.5 12H12V9.5C12 9.22386 12.2239 9 12.5 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEnter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.5 1C4.22386 1 4 1.22386 4 1.5C4 1.77614 4.22386 2 4.5 2H12V13H4.5C4.22386 13 4 13.2239 4 13.5C4 13.7761 4.22386 14 4.5 14H12C12.5523 14 13 13.5523 13 13V2C13 1.44772 12.5523 1 12 1H4.5ZM6.60355 4.89645C6.40829 4.70118 6.09171 4.70118 5.89645 4.89645C5.70118 5.09171 5.70118 5.40829 5.89645 5.60355L7.29289 7H0.5C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H7.29289L5.89645 9.39645C5.70118 9.59171 5.70118 9.90829 5.89645 10.1036C6.09171 10.2988 6.40829 10.2988 6.60355 10.1036L8.85355 7.85355C9.04882 7.65829 9.04882 7.34171 8.85355 7.14645L6.60355 4.89645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEnvelopeClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 2C0.447715 2 0 2.44772 0 3V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V3C15 2.44772 14.5523 2 14 2H1ZM1 3L14 3V3.92494C13.9174 3.92486 13.8338 3.94751 13.7589 3.99505L7.5 7.96703L1.24112 3.99505C1.16621 3.94751 1.0826 3.92486 1 3.92494V3ZM1 4.90797V12H14V4.90797L7.74112 8.87995C7.59394 8.97335 7.40606 8.97335 7.25888 8.87995L1 4.90797Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEnvelopeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.94721 0.164594C7.66569 0.0238299 7.33431 0.0238302 7.05279 0.164594L0.552786 3.41459C0.214002 3.58399 0 3.93025 0 4.30902V12C0 12.5523 0.447715 13 1 13H14C14.5523 13 15 12.5523 15 12V4.30902C15 3.93025 14.786 3.58399 14.4472 3.41459L7.94721 0.164594ZM13.5689 4.09349L7.5 1.05902L1.43105 4.09349L7.5 7.29136L13.5689 4.09349ZM1 4.88366V12H14V4.88366L7.70977 8.19813C7.57848 8.26731 7.42152 8.26731 7.29023 8.19813L1 4.88366Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEraser(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.36052 0.72921C8.55578 0.533948 8.87236 0.533948 9.06763 0.72921L14.2708 5.93235C14.466 6.12761 14.466 6.4442 14.2708 6.63946L8.95513 11.9551L7.3466 13.5636C6.76081 14.1494 5.81106 14.1494 5.22528 13.5636L1.43635 9.7747C0.850563 9.18891 0.850563 8.23917 1.43635 7.65338L3.04488 6.04485L8.36052 0.72921ZM8.71407 1.78987L4.10554 6.3984L8.60157 10.8944L13.2101 6.28591L8.71407 1.78987ZM7.89447 11.6015L3.39843 7.10551L2.14346 8.36049C1.94819 8.55575 1.94819 8.87233 2.14346 9.06759L5.93238 12.8565C6.12765 13.0518 6.44423 13.0518 6.63949 12.8565L7.89447 11.6015Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxExclamationTriangle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.4449 0.608765C8.0183 -0.107015 6.9817 -0.107015 6.55509 0.608766L0.161178 11.3368C-0.275824 12.07 0.252503 13 1.10608 13H13.8939C14.7475 13 15.2758 12.07 14.8388 11.3368L8.4449 0.608765ZM7.4141 1.12073C7.45288 1.05566 7.54712 1.05566 7.5859 1.12073L13.9798 11.8488C14.0196 11.9154 13.9715 12 13.8939 12H1.10608C1.02849 12 0.980454 11.9154 1.02018 11.8488L7.4141 1.12073ZM6.8269 4.48611C6.81221 4.10423 7.11783 3.78663 7.5 3.78663C7.88217 3.78663 8.18778 4.10423 8.1731 4.48612L8.01921 8.48701C8.00848 8.766 7.7792 8.98664 7.5 8.98664C7.2208 8.98664 6.99151 8.766 6.98078 8.48701L6.8269 4.48611ZM8.24989 10.476C8.24989 10.8902 7.9141 11.226 7.49989 11.226C7.08567 11.226 6.74989 10.8902 6.74989 10.476C6.74989 10.0618 7.08567 9.72599 7.49989 9.72599C7.9141 9.72599 8.24989 10.0618 8.24989 10.476Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxExitFullScreen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.5 2C5.77614 2 6 2.22386 6 2.5V5.5C6 5.77614 5.77614 6 5.5 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5V2.5C5 2.22386 5.22386 2 5.5 2ZM9.5 2C9.77614 2 10 2.22386 10 2.5V5H12.5C12.7761 5 13 5.22386 13 5.5C13 5.77614 12.7761 6 12.5 6H9.5C9.22386 6 9 5.77614 9 5.5V2.5C9 2.22386 9.22386 2 9.5 2ZM2 9.5C2 9.22386 2.22386 9 2.5 9H5.5C5.77614 9 6 9.22386 6 9.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5V10H2.5C2.22386 10 2 9.77614 2 9.5ZM9 9.5C9 9.22386 9.22386 9 9.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H10V12.5C10 12.7761 9.77614 13 9.5 13C9.22386 13 9 12.7761 9 12.5V9.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxExit(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 1C2.44771 1 2 1.44772 2 2V13C2 13.5523 2.44772 14 3 14H10.5C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13H3V2L10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1H3ZM12.6036 4.89645C12.4083 4.70118 12.0917 4.70118 11.8964 4.89645C11.7012 5.09171 11.7012 5.40829 11.8964 5.60355L13.2929 7H6.5C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8H13.2929L11.8964 9.39645C11.7012 9.59171 11.7012 9.90829 11.8964 10.1036C12.0917 10.2988 12.4083 10.2988 12.6036 10.1036L14.8536 7.85355C15.0488 7.65829 15.0488 7.34171 14.8536 7.14645L12.6036 4.89645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxExternalLink(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEyeClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEyeNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L10.6828 3.61012C9.70652 3.21671 8.63759 3 7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C0.902945 9.08812 2.02314 10.1861 3.36061 10.9323L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L4.31723 11.3899C5.29348 11.7833 6.36241 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C14.0971 5.9119 12.9769 4.81391 11.6394 4.06771L13.3536 2.35355ZM9.90428 4.38861C9.15332 4.1361 8.34759 4 7.5 4C4.80285 4 2.52952 5.37816 1.09622 7.50001C1.87284 8.6497 2.89609 9.58106 4.09974 10.1931L9.90428 4.38861ZM5.09572 10.6114L10.9003 4.80685C12.1039 5.41894 13.1272 6.35031 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11C6.65241 11 5.84668 10.8639 5.09572 10.6114Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxEyeOpen(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFace(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82708 7.49972C1.82708 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82708 10.6327 1.82708 7.49972ZM5.03747 9.21395C4.87949 8.98746 4.56782 8.93193 4.34133 9.08991C4.11484 9.24789 4.05931 9.55956 4.21729 9.78605C4.93926 10.8211 6.14033 11.5 7.50004 11.5C8.85974 11.5 10.0608 10.8211 10.7828 9.78605C10.9408 9.55956 10.8852 9.24789 10.6587 9.08991C10.4323 8.93193 10.1206 8.98746 9.9626 9.21395C9.41963 9.99238 8.51907 10.5 7.50004 10.5C6.481 10.5 5.58044 9.99238 5.03747 9.21395ZM5.37503 6.84998C5.85828 6.84998 6.25003 6.45815 6.25003 5.97498C6.25003 5.4918 5.85828 5.09998 5.37503 5.09998C4.89179 5.09998 4.50003 5.4918 4.50003 5.97498C4.50003 6.45815 4.89179 6.84998 5.37503 6.84998ZM10.5 5.97498C10.5 6.45815 10.1083 6.84998 9.62503 6.84998C9.14179 6.84998 8.75003 6.45815 8.75003 5.97498C8.75003 5.4918 9.14179 5.09998 9.62503 5.09998C10.1083 5.09998 10.5 5.4918 10.5 5.97498Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFigmaLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFileMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.29289L12 4.70711V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.60355C13 4.40464 12.921 4.21388 12.7803 4.07322L9.85355 1.14645C9.75979 1.05268 9.63261 1 9.5 1H3.5ZM5.25 7C4.97386 7 4.75 7.22386 4.75 7.5C4.75 7.77614 4.97386 8 5.25 8H9.75C10.0261 8 10.25 7.77614 10.25 7.5C10.25 7.22386 10.0261 7 9.75 7H5.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFilePlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V4.70711L9.29289 2H3.5ZM2 2.5C2 1.67157 2.67157 1 3.5 1H9.5C9.63261 1 9.75979 1.05268 9.85355 1.14645L12.7803 4.07322C12.921 4.21388 13 4.40464 13 4.60355V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5ZM4.75 7.5C4.75 7.22386 4.97386 7 5.25 7H7V5.25C7 4.97386 7.22386 4.75 7.5 4.75C7.77614 4.75 8 4.97386 8 5.25V7H9.75C10.0261 7 10.25 7.22386 10.25 7.5C10.25 7.77614 10.0261 8 9.75 8H8V9.75C8 10.0261 7.77614 10.25 7.5 10.25C7.22386 10.25 7 10.0261 7 9.75V8H5.25C4.97386 8 4.75 7.77614 4.75 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFileText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 2.5C3 2.22386 3.22386 2 3.5 2H9.08579C9.21839 2 9.34557 2.05268 9.43934 2.14645L11.8536 4.56066C11.9473 4.65443 12 4.78161 12 4.91421V12.5C12 12.7761 11.7761 13 11.5 13H3.5C3.22386 13 3 12.7761 3 12.5V2.5ZM3.5 1C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H11.5C12.3284 14 13 13.3284 13 12.5V4.91421C13 4.51639 12.842 4.13486 12.5607 3.85355L10.1464 1.43934C9.86514 1.15804 9.48361 1 9.08579 1H3.5ZM4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5H7.5C7.77614 5 8 4.77614 8 4.5C8 4.22386 7.77614 4 7.5 4H4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 2C3.22386 2 3 2.22386 3 2.5V12.5C3 12.7761 3.22386 13 3.5 13H11.5C11.7761 13 12 12.7761 12 12.5V6H8.5C8.22386 6 8 5.77614 8 5.5V2H3.5ZM9 2.70711L11.2929 5H9V2.70711ZM2 2.5C2 1.67157 2.67157 1 3.5 1H8.5C8.63261 1 8.75979 1.05268 8.85355 1.14645L12.8536 5.14645C12.9473 5.24021 13 5.36739 13 5.5V12.5C13 13.3284 12.3284 14 11.5 14H3.5C2.67157 14 2 13.3284 2 12.5V2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFontBold(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFontFamily(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M2.5 4.5C2.5 3.09886 3.59886 2 5 2H12.499C12.7752 2 13 2.22386 13 2.5C13 2.77614 12.7761 3 12.5 3H8.69244L8.40509 3.85458C8.18869 4.49752 7.89401 5.37197 7.58091 6.29794C7.50259 6.52956 7.42308 6.76453 7.34332 7H8.5C8.77614 7 9 7.22386 9 7.5C9 7.77614 8.77614 8 8.5 8H7.00407C6.56724 9.28543 6.16435 10.4613 5.95799 11.0386C5.63627 11.9386 5.20712 12.4857 4.66741 12.7778C4.16335 13.0507 3.64154 13.0503 3.28378 13.05L3.25 13.05C2.94624 13.05 2.7 12.8037 2.7 12.5C2.7 12.1962 2.94624 11.95 3.25 11.95C3.64182 11.95 3.9035 11.9405 4.14374 11.8105C4.36443 11.691 4.65532 11.4148 4.92217 10.6683C5.10695 10.1514 5.45375 9.14134 5.8422 8H4.5C4.22386 8 4 7.77614 4 7.5C4 7.22386 4.22386 7 4.5 7H6.18187C6.30127 6.64785 6.42132 6.29323 6.53887 5.94559C6.85175 5.02025 7.14627 4.14631 7.36256 3.50368L7.53192 3H5C4.15114 3 3.5 3.65114 3.5 4.5C3.5 4.77614 3.27614 5 3 5C2.72386 5 2.5 4.77614 2.5 4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFontItalic(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFontRoman(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.79993 3.50017C4.79993 3.25164 5.0014 3.05017 5.24993 3.05017H9.74993C9.99845 3.05017 10.1999 3.25164 10.1999 3.50017C10.1999 3.7487 9.99845 3.95017 9.74993 3.95017H8.09993V11.05H9.74994C9.99847 11.05 10.1999 11.2515 10.1999 11.5C10.1999 11.7486 9.99847 11.95 9.74994 11.95H5.24994C5.00141 11.95 4.79994 11.7486 4.79994 11.5C4.79994 11.2515 5.00141 11.05 5.24994 11.05H6.89993V3.95017H5.24993C5.0014 3.95017 4.79993 3.7487 4.79993 3.50017Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFontSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.78233 2.21707C2.70732 2.14206 2.60557 2.09991 2.49949 2.09991C2.3934 2.09991 2.29166 2.14206 2.21664 2.21707L0.216645 4.21707C0.0604351 4.37328 0.0604351 4.62655 0.216645 4.78276C0.372855 4.93897 0.626121 4.93897 0.78233 4.78276L2.09949 3.4656L2.09949 11.5342L0.78233 10.2171C0.62612 10.0609 0.372854 10.0609 0.216645 10.2171C0.0604349 10.3733 0.0604349 10.6265 0.216645 10.7828L2.21664 12.7828C2.29166 12.8578 2.3934 12.8999 2.49949 12.8999C2.60557 12.8999 2.70731 12.8578 2.78233 12.7828L4.78233 10.7828C4.93854 10.6265 4.93854 10.3733 4.78233 10.2171C4.62612 10.0609 4.37285 10.0609 4.21664 10.2171L2.89949 11.5342L2.89949 3.4656L4.21664 4.78276C4.37285 4.93897 4.62612 4.93897 4.78233 4.78276C4.93854 4.62655 4.93854 4.37328 4.78233 4.21707L2.78233 2.21707ZM10.5 2.74997C10.7107 2.74997 10.8988 2.88211 10.9703 3.08036L13.9703 11.3999C14.064 11.6597 13.9293 11.9462 13.6696 12.0399C13.4098 12.1336 13.1233 11.9989 13.0296 11.7392L12.0477 9.016H8.95228L7.97033 11.7392C7.87666 11.9989 7.59013 12.1336 7.33036 12.0399C7.07059 11.9462 6.93595 11.6597 7.02962 11.3999L10.0296 3.08036C10.1011 2.88211 10.2892 2.74997 10.5 2.74997ZM10.5 4.72396L11.7412 8.166H9.25879L10.5 4.72396Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFontStyle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.03791 9.98075C0.934777 9.6583 1.11603 9.37719 1.40005 9.24871C1.68408 9.12022 2.09463 9.13412 2.27071 9.45426C2.85393 10.5147 3.64599 10.7282 4.48665 10.7282C5.52721 10.7282 6.29659 10.2615 6.29659 9.45426C6.29659 8.8047 5.9119 8.46416 4.87134 8.14253L4.15872 7.92181C2.64518 7.44883 1.88842 6.69206 1.88842 5.45601C1.88842 3.79743 3.27583 2.6875 5.24342 2.6875C6.91733 2.6875 7.97409 3.33536 8.43833 4.31065C8.57087 4.58909 8.57614 4.91294 8.22794 5.19114C7.87974 5.46934 7.52351 5.34799 7.23327 5.03839C6.47215 4.22653 5.99545 4.04968 5.25604 4.04968C4.1398 4.04968 3.547 4.63618 3.547 5.27943C3.547 5.86592 3.96322 6.23169 4.94702 6.5344L5.67856 6.76143C7.22994 7.23441 7.97409 7.95964 7.97409 9.17047C7.97409 10.7723 6.69389 12.0903 4.46143 12.0903C2.86612 12.0903 1.40005 11.1131 1.03791 9.98075ZM11.8491 8.77985C10.661 8.39543 10.1649 7.86114 10.1649 6.98805C10.1649 5.86736 11.1636 5.04639 12.6128 5.04639C13.8546 5.04639 14.6629 5.63345 14.9778 6.6346C15.0443 6.84599 14.9593 6.98006 14.7475 7.0491C14.5394 7.11697 14.3176 7.09974 14.238 6.89611C13.9356 6.12273 13.352 5.76311 12.5998 5.76311C11.6467 5.76311 11.0135 6.25178 11.0135 6.91638C11.0135 7.45066 11.3464 7.75038 12.2473 8.04358L12.8348 8.23254C14.062 8.62999 14.5516 9.13821 14.5516 10.0178C14.5516 11.1972 13.481 12.0442 11.9927 12.0442C10.6439 12.0442 9.65644 11.2809 9.41979 10.3361C9.36535 10.1188 9.41192 10.0287 9.70039 9.96184C9.98886 9.89499 10.0714 9.89918 10.1715 10.1369C10.4555 10.8114 11.1531 11.3275 12.0318 11.3275C12.9914 11.3275 13.6834 10.7802 13.6834 10.0634C13.6834 9.53567 13.3961 9.28807 12.4366 8.97532L11.8491 8.77985Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFrame(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V4H5V1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5V4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H4V10H1.5C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H4V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V11H10V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H11V5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H11V1.5ZM10 10V5H5V10H10Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxFramerLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.3825 1.29567C3.46241 1.11432 3.64188 0.997284 3.84005 0.997284H11.5C11.7761 0.997284 12 1.22114 12 1.49728V5.5C12 5.77614 11.7761 6 11.5 6H8.63521L11.5288 9.16247C11.6626 9.3087 11.6974 9.52015 11.6175 9.70154C11.5376 9.88293 11.3582 10 11.16 10H8V13.5C8 13.7022 7.87818 13.8845 7.69134 13.9619C7.5045 14.0393 7.28945 13.9966 7.14645 13.8536L3.14645 9.85355C3.05268 9.75979 3 9.63261 3 9.5V5.5C3 5.22386 3.22386 5 3.5 5H6.36531L3.47105 1.83468C3.33732 1.68844 3.30259 1.47701 3.3825 1.29567ZM7.72032 5L4.97474 1.99728H11V5H7.72032ZM7.27978 6H4V9H7.5H10.0247L7.27978 6ZM4.70711 10L7 12.2929V10H4.70711Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxGear(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.07095 0.650238C6.67391 0.650238 6.32977 0.925096 6.24198 1.31231L6.0039 2.36247C5.6249 2.47269 5.26335 2.62363 4.92436 2.81013L4.01335 2.23585C3.67748 2.02413 3.23978 2.07312 2.95903 2.35386L2.35294 2.95996C2.0722 3.2407 2.0232 3.6784 2.23493 4.01427L2.80942 4.92561C2.62307 5.2645 2.47227 5.62594 2.36216 6.00481L1.31209 6.24287C0.924883 6.33065 0.650024 6.6748 0.650024 7.07183V7.92897C0.650024 8.32601 0.924883 8.67015 1.31209 8.75794L2.36228 8.99603C2.47246 9.375 2.62335 9.73652 2.80979 10.0755L2.2354 10.9867C2.02367 11.3225 2.07267 11.7602 2.35341 12.041L2.95951 12.6471C3.24025 12.9278 3.67795 12.9768 4.01382 12.7651L4.92506 12.1907C5.26384 12.377 5.62516 12.5278 6.0039 12.6379L6.24198 13.6881C6.32977 14.0753 6.67391 14.3502 7.07095 14.3502H7.92809C8.32512 14.3502 8.66927 14.0753 8.75705 13.6881L8.99505 12.6383C9.37411 12.5282 9.73573 12.3773 10.0748 12.1909L10.986 12.7653C11.3218 12.977 11.7595 12.928 12.0403 12.6473L12.6464 12.0412C12.9271 11.7604 12.9761 11.3227 12.7644 10.9869L12.1902 10.076C12.3768 9.73688 12.5278 9.37515 12.638 8.99596L13.6879 8.75794C14.0751 8.67015 14.35 8.32601 14.35 7.92897V7.07183C14.35 6.6748 14.0751 6.33065 13.6879 6.24287L12.6381 6.00488C12.528 5.62578 12.3771 5.26414 12.1906 4.92507L12.7648 4.01407C12.9766 3.6782 12.9276 3.2405 12.6468 2.95975L12.0407 2.35366C11.76 2.07292 11.3223 2.02392 10.9864 2.23565L10.0755 2.80989C9.73622 2.62328 9.37437 2.47229 8.99505 2.36209L8.75705 1.31231C8.66927 0.925096 8.32512 0.650238 7.92809 0.650238H7.07095ZM4.92053 3.81251C5.44724 3.44339 6.05665 3.18424 6.71543 3.06839L7.07095 1.50024H7.92809L8.28355 3.06816C8.94267 3.18387 9.5524 3.44302 10.0794 3.81224L11.4397 2.9547L12.0458 3.56079L11.1882 4.92117C11.5573 5.44798 11.8164 6.0575 11.9321 6.71638L13.5 7.07183V7.92897L11.932 8.28444C11.8162 8.94342 11.557 9.55301 11.1878 10.0798L12.0453 11.4402L11.4392 12.0462L10.0787 11.1886C9.55192 11.5576 8.94241 11.8166 8.28355 11.9323L7.92809 13.5002H7.07095L6.71543 11.932C6.0569 11.8162 5.44772 11.5572 4.92116 11.1883L3.56055 12.046L2.95445 11.4399L3.81213 10.0794C3.4431 9.55266 3.18403 8.94326 3.06825 8.2845L1.50002 7.92897V7.07183L3.06818 6.71632C3.18388 6.05765 3.44283 5.44833 3.81171 4.92165L2.95398 3.561L3.56008 2.95491L4.92053 3.81251ZM9.02496 7.50008C9.02496 8.34226 8.34223 9.02499 7.50005 9.02499C6.65786 9.02499 5.97513 8.34226 5.97513 7.50008C5.97513 6.65789 6.65786 5.97516 7.50005 5.97516C8.34223 5.97516 9.02496 6.65789 9.02496 7.50008ZM9.92496 7.50008C9.92496 8.83932 8.83929 9.92499 7.50005 9.92499C6.1608 9.92499 5.07513 8.83932 5.07513 7.50008C5.07513 6.16084 6.1608 5.07516 7.50005 5.07516C8.83929 5.07516 9.92496 6.16084 9.92496 7.50008Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxGithubLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49933 0.25C3.49635 0.25 0.25 3.49593 0.25 7.50024C0.25 10.703 2.32715 13.4206 5.2081 14.3797C5.57084 14.446 5.70302 14.2222 5.70302 14.0299C5.70302 13.8576 5.69679 13.4019 5.69323 12.797C3.67661 13.235 3.25112 11.825 3.25112 11.825C2.92132 10.9874 2.44599 10.7644 2.44599 10.7644C1.78773 10.3149 2.49584 10.3238 2.49584 10.3238C3.22353 10.375 3.60629 11.0711 3.60629 11.0711C4.25298 12.1788 5.30335 11.8588 5.71638 11.6732C5.78225 11.205 5.96962 10.8854 6.17658 10.7043C4.56675 10.5209 2.87415 9.89918 2.87415 7.12104C2.87415 6.32925 3.15677 5.68257 3.62053 5.17563C3.54576 4.99226 3.29697 4.25521 3.69174 3.25691C3.69174 3.25691 4.30015 3.06196 5.68522 3.99973C6.26337 3.83906 6.8838 3.75895 7.50022 3.75583C8.1162 3.75895 8.73619 3.83906 9.31523 3.99973C10.6994 3.06196 11.3069 3.25691 11.3069 3.25691C11.7026 4.25521 11.4538 4.99226 11.3795 5.17563C11.8441 5.68257 12.1245 6.32925 12.1245 7.12104C12.1245 9.9063 10.4292 10.5192 8.81452 10.6985C9.07444 10.9224 9.30633 11.3648 9.30633 12.0413C9.30633 13.0102 9.29742 13.7922 9.29742 14.0299C9.29742 14.2239 9.42828 14.4496 9.79591 14.3788C12.6746 13.4179 14.75 10.7025 14.75 7.50024C14.75 3.49593 11.5036 0.25 7.49933 0.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxGlobe(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49996 1.80002C4.35194 1.80002 1.79996 4.352 1.79996 7.50002C1.79996 10.648 4.35194 13.2 7.49996 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.352 10.648 1.80002 7.49996 1.80002ZM0.899963 7.50002C0.899963 3.85494 3.85488 0.900024 7.49996 0.900024C11.145 0.900024 14.1 3.85494 14.1 7.50002C14.1 11.1451 11.145 14.1 7.49996 14.1C3.85488 14.1 0.899963 11.1451 0.899963 7.50002Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.4999 7.89998H1.49994V7.09998H13.4999V7.89998Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.09991 13.5V1.5H7.89991V13.5H7.09991zM10.375 7.49998C10.375 5.32724 9.59364 3.17778 8.06183 1.75656L8.53793 1.24341C10.2396 2.82218 11.075 5.17273 11.075 7.49998 11.075 9.82724 10.2396 12.1778 8.53793 13.7566L8.06183 13.2434C9.59364 11.8222 10.375 9.67273 10.375 7.49998zM3.99969 7.5C3.99969 5.17611 4.80786 2.82678 6.45768 1.24719L6.94177 1.75281C5.4582 3.17323 4.69969 5.32389 4.69969 7.5 4.6997 9.67611 5.45822 11.8268 6.94179 13.2472L6.45769 13.7528C4.80788 12.1732 3.9997 9.8239 3.99969 7.5z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49996 3.95801C9.66928 3.95801 11.8753 4.35915 13.3706 5.19448 13.5394 5.28875 13.5998 5.50197 13.5055 5.67073 13.4113 5.83948 13.198 5.89987 13.0293 5.8056 11.6794 5.05155 9.60799 4.65801 7.49996 4.65801 5.39192 4.65801 3.32052 5.05155 1.97064 5.8056 1.80188 5.89987 1.58866 5.83948 1.49439 5.67073 1.40013 5.50197 1.46051 5.28875 1.62927 5.19448 3.12466 4.35915 5.33063 3.95801 7.49996 3.95801zM7.49996 10.85C9.66928 10.85 11.8753 10.4488 13.3706 9.6135 13.5394 9.51924 13.5998 9.30601 13.5055 9.13726 13.4113 8.9685 13.198 8.90812 13.0293 9.00238 11.6794 9.75643 9.60799 10.15 7.49996 10.15 5.39192 10.15 3.32052 9.75643 1.97064 9.00239 1.80188 8.90812 1.58866 8.9685 1.49439 9.13726 1.40013 9.30601 1.46051 9.51924 1.62927 9.6135 3.12466 10.4488 5.33063 10.85 7.49996 10.85z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.5 2H8V7H13V2.5C13 2.22386 12.7761 2 12.5 2ZM13 8H8V13H12.5C12.7761 13 13 12.7761 13 12.5V8ZM7 7V2H2.5C2.22386 2 2 2.22386 2 2.5V7H7ZM2 8V12.5C2 12.7761 2.22386 13 2.5 13H7V8H2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxGroup(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.44995 0.949951C1.31734 0.949951 1.19016 1.00263 1.0964 1.0964C1.00263 1.19017 0.949951 1.31735 0.949951 1.44995L0.949966 3.44995C0.949969 3.7261 1.17383 3.94995 1.44997 3.94995C1.72611 3.94995 1.94997 3.72609 1.94997 3.44995L1.94995 1.94995H3.44997C3.72611 1.94995 3.94997 1.72609 3.94997 1.44995C3.94997 1.17381 3.72611 0.949951 3.44997 0.949951H1.44995ZM5.94995 0.949951C5.67381 0.949951 5.44995 1.17381 5.44995 1.44995C5.44995 1.72609 5.67381 1.94995 5.94995 1.94995H8.94995C9.22609 1.94995 9.44995 1.72609 9.44995 1.44995C9.44995 1.17381 9.22609 0.949951 8.94995 0.949951H5.94995ZM5.44995 13.45C5.44995 13.1738 5.67381 12.95 5.94995 12.95H8.94995C9.22609 12.95 9.44995 13.1738 9.44995 13.45C9.44995 13.7261 9.22609 13.95 8.94995 13.95H5.94995C5.67381 13.95 5.44995 13.7261 5.44995 13.45ZM1.94995 5.94995C1.94995 5.67381 1.72609 5.44995 1.44995 5.44995C1.17381 5.44995 0.949951 5.67381 0.949951 5.94995V8.94995C0.949951 9.22609 1.17381 9.44995 1.44995 9.44995C1.72609 9.44995 1.94995 9.22609 1.94995 8.94995V5.94995ZM13.45 5.44995C13.7261 5.44995 13.95 5.67381 13.95 5.94995V8.94995C13.95 9.22609 13.7261 9.44995 13.45 9.44995C13.1738 9.44995 12.95 9.22609 12.95 8.94995V5.94995C12.95 5.67381 13.1738 5.44995 13.45 5.44995ZM11.45 0.949951C11.1738 0.949951 10.95 1.17381 10.95 1.44995C10.95 1.72609 11.1738 1.94995 11.45 1.94995H12.9499V3.44995C12.9499 3.72609 13.1738 3.94995 13.4499 3.94995C13.7261 3.94995 13.9499 3.72609 13.9499 3.44995V1.44995C13.9499 1.17381 13.7252 0.949951 13.449 0.949951H11.45ZM1.44995 10.95C1.72609 10.95 1.94995 11.1738 1.94995 11.45V12.95H3.44997C3.72611 12.95 3.94997 13.1738 3.94997 13.45C3.94997 13.7261 3.72611 13.95 3.44997 13.95H1.44995C1.17381 13.95 0.949951 13.7261 0.949951 13.45V11.45C0.949951 11.1738 1.17381 10.95 1.44995 10.95ZM13.95 11.45C13.95 11.1738 13.7261 10.95 13.45 10.95C13.1738 10.9499 12.95 11.1738 12.95 11.4499L12.9491 12.95H11.45C11.1738 12.95 10.95 13.1738 10.95 13.45C10.95 13.7261 11.1738 13.95 11.45 13.95H13.4499C13.7261 13.95 13.9499 13.7261 13.9499 13.45L13.95 11.45Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHalf1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.00003 1.84861C4.10114 2.1017 1.82707 4.53515 1.82707 7.49972C1.82707 10.4643 4.10114 12.8977 7.00003 13.1508V1.84861ZM8.00003 13.1508C10.8988 12.8976 13.1727 10.4642 13.1727 7.49972C13.1727 4.53524 10.8988 2.10185 8.00003 1.84864V13.1508Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHalf2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM7.49988 1.82689C4.36688 1.8269 1.82707 4.36672 1.82707 7.49972C1.82707 10.6327 4.36688 13.1725 7.49988 13.1726V1.82689Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHamburgerMenu(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 3C1.22386 3 1 3.22386 1 3.5C1 3.77614 1.22386 4 1.5 4H13.5C13.7761 4 14 3.77614 14 3.5C14 3.22386 13.7761 3 13.5 3H1.5ZM1 7.5C1 7.22386 1.22386 7 1.5 7H13.5C13.7761 7 14 7.22386 14 7.5C14 7.77614 13.7761 8 13.5 8H1.5C1.22386 8 1 7.77614 1 7.5ZM1 11.5C1 11.2239 1.22386 11 1.5 11H13.5C13.7761 11 14 11.2239 14 11.5C14 11.7761 13.7761 12 13.5 12H1.5C1.22386 12 1 11.7761 1 11.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.8113 1.64706C6.62188 2.87918 6.68268 3.88523 6.76848 5.30499C6.78415 5.56426 6.80065 5.83732 6.81661 6.12808C6.83111 6.39208 6.63758 6.62172 6.37495 6.65217C6.11232 6.68262 5.87138 6.50334 5.82509 6.24304L5.74754 5.80698C5.64402 5.16529 5.48355 4.25481 5.17807 3.44741C4.86241 2.61312 4.4486 2.04121 3.93436 1.86044C3.64994 1.76104 3.41901 1.84279 3.25868 2.01052C3.08746 2.18962 2.9976 2.47065 3.0627 2.75399C3.2146 3.34424 3.44627 3.9167 3.69836 4.51802C3.72082 4.57158 3.74346 4.62543 3.76621 4.67954C3.9954 5.22457 4.23619 5.7972 4.41644 6.39081L4.41691 6.39238C4.562 6.87586 4.65646 7.2595 4.73086 7.56165C4.76034 7.68138 4.78667 7.78831 4.81175 7.88359C4.86768 8.09606 4.77836 8.32014 4.59161 8.43588C4.40486 8.55161 4.16445 8.53188 3.99907 8.38725C3.73749 8.15848 3.515 7.92784 3.31817 7.71802C3.27627 7.67335 3.23602 7.63018 3.19705 7.58838C3.04777 7.42826 2.91712 7.28812 2.78334 7.16029C2.45989 6.85122 2.18398 6.68004 1.80585 6.64369L1.80324 6.64343C1.56117 6.61888 1.41402 6.66441 1.31756 6.72627C1.21899 6.78947 1.11988 6.90414 1.03784 7.1123C0.976576 7.28492 1.01515 7.62987 1.1929 7.96911L1.19728 7.97747C1.40086 8.38452 1.74475 8.81587 2.18141 9.29299C2.39739 9.52898 2.62872 9.76849 2.86934 10.0174L2.87966 10.0281C3.11546 10.2721 3.35962 10.5247 3.59713 10.7827C4.4288 11.6863 5.27706 12.7538 5.4627 14H11.5087C11.5636 12.4353 11.8756 11.268 12.2875 10.1346C12.4454 9.70041 12.6121 9.28412 12.7826 8.85829C13.1097 8.04139 13.4509 7.18937 13.7705 6.10824C14.0989 4.99737 14.0097 4.37033 13.8613 4.03984C13.717 3.71858 13.4914 3.61786 13.3816 3.59606C13.1381 3.54774 13.0384 3.60947 12.9698 3.67901C12.867 3.78316 12.7698 3.98273 12.6921 4.30269C12.6166 4.61345 12.5752 4.96517 12.533 5.32501L12.5298 5.35285C12.4924 5.67242 12.4505 6.03016 12.3665 6.30098C12.3383 6.40699 12.2819 6.50407 12.1979 6.57539C12.1382 6.6261 12.0104 6.70818 11.8309 6.69312C11.5424 6.66891 11.3712 6.42143 11.365 6.14783C11.356 5.75454 11.3883 5.35864 11.4074 4.96608C11.4428 4.23646 11.477 3.5337 11.4245 2.8342L11.4242 2.82934C11.3916 2.32997 11.0493 2.00228 10.7007 1.9228C10.5305 1.88401 10.369 1.90601 10.2347 1.9835C10.103 2.05946 9.95535 2.21318 9.8574 2.51394L9.85631 2.51726C9.81525 2.6404 9.77298 2.87753 9.73606 3.2124C9.70044 3.53542 9.67337 3.91279 9.65156 4.29418C9.6329 4.62033 9.61785 4.9584 9.60434 5.26194C9.58728 5.64529 9.57267 5.97357 9.55633 6.1532C9.54983 6.22459 9.52939 6.29493 9.49501 6.35785C9.47356 6.39711 9.36115 6.60947 9.07106 6.61843C8.77917 6.62744 8.63975 6.40057 8.61698 6.35919C8.55634 6.24899 8.55066 6.11807 8.54754 5.99283C8.54474 5.88064 8.54294 5.71798 8.54174 5.54767C8.53935 5.20582 8.53935 4.81919 8.53935 4.70952C8.53935 3.6657 8.53838 2.65372 8.44714 1.64372C8.39183 1.24127 8.06278 1.00455 7.6436 1.00005C7.22399 0.995552 6.87918 1.22704 6.8113 1.64706ZM9.41219 1.3617C9.21469 0.448484 8.39913 0.00810324 7.65433 0.00011154C6.86452 -0.00836308 5.98761 0.465881 5.82365 1.49037L5.82318 1.49334C5.78239 1.7584 5.75229 2.01481 5.7309 2.26652C5.39423 1.67364 4.92622 1.14894 4.2655 0.916859C3.58661 0.679312 2.9492 0.887087 2.53582 1.31952C2.13415 1.73971 1.94438 2.36742 2.09031 2.98746L2.09269 2.99713C2.26478 3.66808 2.52396 4.30316 2.77613 4.90465C2.79814 4.95717 2.8201 5.00941 2.84194 5.06139C3.02139 5.48842 3.19378 5.89866 3.33871 6.31256C2.96404 5.98142 2.51925 5.70796 1.90276 5.6484C1.48865 5.60663 1.10391 5.67536 0.777805 5.88444C0.454239 6.0919 0.240671 6.40405 0.104187 6.75406L0.100868 6.76281C-0.10184 7.31286 0.0663312 7.97157 0.304895 8.42897C0.573704 8.96474 0.996104 9.47904 1.44372 9.96813C1.67046 10.2159 1.91136 10.4652 2.15033 10.7124L2.15682 10.7191C2.39524 10.9658 2.63217 11.2109 2.86134 11.4599C3.80937 12.49 4.50002 13.4632 4.50002 14.5C4.50002 14.7761 4.72388 15 5.00002 15H12C12.2762 15 12.5 14.7761 12.5 14.5C12.5 12.8212 12.8021 11.6462 13.2274 10.4762C13.3653 10.0968 13.5216 9.70579 13.6868 9.29247C14.0238 8.44922 14.398 7.51298 14.7295 6.39175C15.0956 5.15324 15.0559 4.25904 14.7735 3.63017C14.487 2.99208 13.9798 2.6953 13.5763 2.6152C13.1276 2.52614 12.7367 2.60475 12.4268 2.83081C12.4253 2.80773 12.4236 2.78468 12.4219 2.76167C12.3587 1.8105 11.6907 1.12285 10.923 0.947821C10.5346 0.859287 10.1111 0.900393 9.73509 1.11724C9.61852 1.18446 9.51055 1.26623 9.41219 1.3617Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHeading(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.75432 2.0502C8.50579 2.0502 8.30432 2.25167 8.30432 2.5002C8.30432 2.74873 8.50579 2.9502 8.75432 2.9502H9.94997V7.05004H5.04997V2.9502H6.25432C6.50285 2.9502 6.70432 2.74873 6.70432 2.5002C6.70432 2.25167 6.50285 2.0502 6.25432 2.0502H2.75432C2.50579 2.0502 2.30432 2.25167 2.30432 2.5002C2.30432 2.74873 2.50579 2.9502 2.75432 2.9502H3.94997V12.0502H2.75432C2.50579 12.0502 2.30432 12.2517 2.30432 12.5002C2.30432 12.7487 2.50579 12.9502 2.75432 12.9502H6.25432C6.50285 12.9502 6.70432 12.7487 6.70432 12.5002C6.70432 12.2517 6.50285 12.0502 6.25432 12.0502H5.04997V7.95004H9.94997V12.0502H8.75432C8.50579 12.0502 8.30432 12.2517 8.30432 12.5002C8.30432 12.7487 8.50579 12.9502 8.75432 12.9502H12.2543C12.5028 12.9502 12.7043 12.7487 12.7043 12.5002C12.7043 12.2517 12.5028 12.0502 12.2543 12.0502H11.05V2.9502H12.2543C12.5028 2.9502 12.7043 2.74873 12.7043 2.5002C12.7043 2.25167 12.5028 2.0502 12.2543 2.0502H8.75432Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHeartFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.25769 1.35248 6.86058 1.92336 7.50002 2.93545C8.13946 1.92336 8.74235 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHeart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.89346 2.35248C3.49195 2.35248 2.35248 3.49359 2.35248 4.90532C2.35248 6.38164 3.20954 7.9168 4.37255 9.33522C5.39396 10.581 6.59464 11.6702 7.50002 12.4778C8.4054 11.6702 9.60608 10.581 10.6275 9.33522C11.7905 7.9168 12.6476 6.38164 12.6476 4.90532C12.6476 3.49359 11.5081 2.35248 10.1066 2.35248C9.27059 2.35248 8.81894 2.64323 8.5397 2.95843C8.27877 3.25295 8.14623 3.58566 8.02501 3.88993C8.00391 3.9429 7.98315 3.99501 7.96211 4.04591C7.88482 4.23294 7.7024 4.35494 7.50002 4.35494C7.29765 4.35494 7.11523 4.23295 7.03793 4.04592C7.01689 3.99501 6.99612 3.94289 6.97502 3.8899C6.8538 3.58564 6.72126 3.25294 6.46034 2.95843C6.18109 2.64323 5.72945 2.35248 4.89346 2.35248ZM1.35248 4.90532C1.35248 2.94498 2.936 1.35248 4.89346 1.35248C6.0084 1.35248 6.73504 1.76049 7.20884 2.2953C7.32062 2.42147 7.41686 2.55382 7.50002 2.68545C7.58318 2.55382 7.67941 2.42147 7.79119 2.2953C8.265 1.76049 8.99164 1.35248 10.1066 1.35248C12.064 1.35248 13.6476 2.94498 13.6476 4.90532C13.6476 6.74041 12.6013 8.50508 11.4008 9.96927C10.2636 11.3562 8.92194 12.5508 8.00601 13.3664C7.94645 13.4194 7.88869 13.4709 7.83291 13.5206C7.64324 13.6899 7.3568 13.6899 7.16713 13.5206C7.11135 13.4709 7.05359 13.4194 6.99403 13.3664C6.0781 12.5508 4.73641 11.3562 3.59926 9.96927C2.39872 8.50508 1.35248 6.74041 1.35248 4.90532Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.1813 1.68179C7.35704 1.50605 7.64196 1.50605 7.8177 1.68179L10.3177 4.18179C10.4934 4.35753 10.4934 4.64245 10.3177 4.81819C10.142 4.99392 9.85704 4.99392 9.6813 4.81819L7.9495 3.08638L7.9495 11.9136L9.6813 10.1818C9.85704 10.0061 10.142 10.0061 10.3177 10.1818C10.4934 10.3575 10.4934 10.6424 10.3177 10.8182L7.8177 13.3182C7.73331 13.4026 7.61885 13.45 7.4995 13.45C7.38015 13.45 7.26569 13.4026 7.1813 13.3182L4.6813 10.8182C4.50557 10.6424 4.50557 10.3575 4.6813 10.1818C4.85704 10.0061 5.14196 10.0061 5.3177 10.1818L7.0495 11.9136L7.0495 3.08638L5.3177 4.81819C5.14196 4.99392 4.85704 4.99392 4.6813 4.81819C4.50557 4.64245 4.50557 4.35753 4.6813 4.18179L7.1813 1.68179Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHobbyKnife(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.3536 13.3536C12.1583 13.5488 11.8417 13.5488 11.6465 13.3536L6.39645 8.10355C6.36478 8.07188 6.33824 8.03702 6.31685 8H5.00002C4.78719 8 4.59769 7.86528 4.52777 7.66426L2.12777 0.764277C2.05268 0.548387 2.13355 0.309061 2.3242 0.182972C2.51486 0.0568819 2.76674 0.0761337 2.93602 0.229734L8.336 5.12972C8.44044 5.22449 8.50001 5.35897 8.50001 5.5V5.81684C8.53702 5.83824 8.57189 5.86478 8.60356 5.89645L13.8536 11.1464C14.0488 11.3417 14.0488 11.6583 13.8536 11.8536L12.3536 13.3536ZM8.25 6.95711L7.45711 7.75L12 12.2929L12.7929 11.5L8.25 6.95711ZM3.71669 2.28845L5.35549 7H6.2929L7.50001 5.79289V5.72146L3.71669 2.28845Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxHome(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.07926 0.222253C7.31275 -0.007434 7.6873 -0.007434 7.92079 0.222253L14.6708 6.86227C14.907 7.09465 14.9101 7.47453 14.6778 7.71076C14.4454 7.947 14.0655 7.95012 13.8293 7.71773L13 6.90201V12.5C13 12.7761 12.7762 13 12.5 13H2.50002C2.22388 13 2.00002 12.7761 2.00002 12.5V6.90201L1.17079 7.71773C0.934558 7.95012 0.554672 7.947 0.32229 7.71076C0.0899079 7.47453 0.0930283 7.09465 0.32926 6.86227L7.07926 0.222253ZM7.50002 1.49163L12 5.91831V12H10V8.49999C10 8.22385 9.77617 7.99999 9.50002 7.99999H6.50002C6.22388 7.99999 6.00002 8.22385 6.00002 8.49999V12H3.00002V5.91831L7.50002 1.49163ZM7.00002 12H9.00002V8.99999H7.00002V12Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxIconjarLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 0.0032959C6.80473 0.0032959 6.24953 0.281106 6.25 0.749995C6.25 0.997258 6.42446 1.12014 6.57687 1.22749C6.69507 1.31074 6.8 1.38465 6.8 1.5C6.8 1.7071 6.06224 1.74264 5.19789 1.78427C3.97553 1.84314 2.5 1.91421 2.5 2.5C2.5 2.77614 2.72386 3 3 3H12C12.2761 3 12.5 2.77614 12.5 2.5C12.5 1.91421 11.0245 1.84314 9.80211 1.78427C8.93776 1.74264 8.2 1.7071 8.2 1.5C8.2 1.38465 8.30493 1.31074 8.42313 1.22749C8.57554 1.12014 8.75 0.997258 8.75 0.749995C8.75047 0.281106 8.19527 0.0032959 7.5 0.0032959ZM2.89451 6.12266C2.25806 6.52471 1.90417 7.31118 2.02473 8.0556L2.83588 12.4772C3.00993 13.3562 3.7629 14 4.66061 14H10.3373C11.2354 14 11.9884 13.3562 12.1625 12.4772L12.9736 8.05607C13.089 7.32358 12.8284 6.53276 12.1331 6.09373C11.7283 5.83013 11.6412 5.33231 12.1331 5.12796C12.8284 4.86435 12.6948 4 12 4H10.3001H6.80005H2.99996C2.30469 4 2.19878 4.89328 2.89451 5.15689C3.38642 5.33231 3.29939 5.83013 2.89451 6.12266ZM8.20006 6.25C8.20006 5.81769 8.08572 5.37615 7.90635 5L4.11093 5C4.20626 5.21312 4.2419 5.43889 4.22904 5.65521C4.19522 6.22412 3.84587 6.66899 3.48016 6.93322L3.45492 6.95146L3.42858 6.9681C3.13407 7.15414 2.95801 7.53989 3.01058 7.88749L3.81797 12.2886C3.90513 12.7154 4.26148 13 4.66061 13H10.3373C10.737 13 11.0932 12.7153 11.1804 12.2886L11.9874 7.8898C12.048 7.48247 11.8954 7.12631 11.5992 6.93927L11.5875 6.93184L11.5875 6.93176C11.1947 6.67602 10.8331 6.22785 10.7986 5.64798C10.7846 5.412 10.8264 5.19397 10.9112 5H9.05517C9.01987 5.14611 9.00006 5.31201 9.00006 5.5C9.00006 5.9745 9.21679 6.37127 9.44367 6.78662C9.69284 7.24278 9.95425 7.72136 9.95425 8.34993C9.95425 9.2698 9.49868 9.84205 8.62189 9.84205C8.13206 9.84205 7.57818 9.46097 7.57818 8.75781C7.57818 8.35279 7.71558 8.01646 7.86121 7.65998C8.0254 7.25806 8.20006 6.83051 8.20006 6.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxIdCard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 11.0001V4.00006L1 4.00006L1 11.0001H14ZM15 4.00006V11.0001C15 11.5523 14.5523 12.0001 14 12.0001H1C0.447715 12.0001 0 11.5523 0 11.0001V4.00006C0 3.44778 0.447715 3.00006 1 3.00006H14C14.5523 3.00006 15 3.44778 15 4.00006ZM2 5.25C2 5.11193 2.11193 5 2.25 5H5.75C5.88807 5 6 5.11193 6 5.25V9.75C6 9.88807 5.88807 10 5.75 10H2.25C2.11193 10 2 9.88807 2 9.75V5.25ZM7.5 7C7.22386 7 7 7.22386 7 7.5C7 7.77614 7.22386 8 7.5 8H10.5C10.7761 8 11 7.77614 11 7.5C11 7.22386 10.7761 7 10.5 7H7.5ZM7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5ZM7.5 5C7.22386 5 7 5.22386 7 5.5C7 5.77614 7.22386 6 7.5 6H11.5C11.7761 6 12 5.77614 12 5.5C12 5.22386 11.7761 5 11.5 5H7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxImage(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxInfoCircled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxInput(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.5 1C6.22386 1 6 1.22386 6 1.5C6 1.77614 6.22386 2 6.5 2C7.12671 2 7.45718 2.20028 7.65563 2.47812C7.8781 2.78957 8 3.28837 8 4V11C8 11.7116 7.8781 12.2104 7.65563 12.5219C7.45718 12.7997 7.12671 13 6.5 13C6.22386 13 6 13.2239 6 13.5C6 13.7761 6.22386 14 6.5 14C7.37329 14 8.04282 13.7003 8.46937 13.1031C8.47976 13.0886 8.48997 13.0739 8.5 13.0591C8.51003 13.0739 8.52024 13.0886 8.53063 13.1031C8.95718 13.7003 9.62671 14 10.5 14C10.7761 14 11 13.7761 11 13.5C11 13.2239 10.7761 13 10.5 13C9.87329 13 9.54282 12.7997 9.34437 12.5219C9.1219 12.2104 9 11.7116 9 11V4C9 3.28837 9.1219 2.78957 9.34437 2.47812C9.54282 2.20028 9.87329 2 10.5 2C10.7761 2 11 1.77614 11 1.5C11 1.22386 10.7761 1 10.5 1C9.62671 1 8.95718 1.29972 8.53063 1.89688C8.52024 1.91143 8.51003 1.92611 8.5 1.9409C8.48997 1.92611 8.47976 1.91143 8.46937 1.89688C8.04282 1.29972 7.37329 1 6.5 1ZM14 5H11V4H14C14.5523 4 15 4.44772 15 5V10C15 10.5523 14.5523 11 14 11H11V10H14V5ZM6 4V5H1L1 10H6V11H1C0.447715 11 0 10.5523 0 10V5C0 4.44772 0.447715 4 1 4H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxInstagramLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.9091 12.909C13.2365 12.5817 13.4918 12.1895 13.6588 11.7577C13.8195 11.3443 13.9294 10.8718 13.961 10.1799C13.9926 9.48665 14.0001 9.26529 14.0001 7.50001C14.0001 5.73473 13.9926 5.51328 13.961 4.82008C13.9294 4.12821 13.8195 3.65573 13.6588 3.24228C13.4956 2.80857 13.2398 2.41567 12.9091 2.091C12.5844 1.76028 12.1915 1.50437 11.7578 1.34113C11.3443 1.18056 10.8718 1.0707 10.1799 1.03924C9.48675 1.00748 9.26537 1 7.50006 1C5.73476 1 5.51333 1.00748 4.82014 1.03912C4.12826 1.0707 3.65578 1.18056 3.24233 1.34125C2.80862 1.50447 2.41573 1.76032 2.09105 2.09098C1.76032 2.41563 1.5044 2.80852 1.34113 3.24225C1.18056 3.65573 1.0707 4.12821 1.03924 4.82008C1.00748 5.51328 1 5.73471 1 7.50001C1 9.26532 1.00748 9.48675 1.03924 10.1799C1.07083 10.8718 1.18069 11.3443 1.34138 11.7577C1.5046 12.1915 1.76045 12.5843 2.09111 12.909C2.41578 13.2397 2.80867 13.4955 3.24238 13.6587C3.65586 13.8194 4.12834 13.9293 4.82019 13.9609C5.51348 13.9925 5.73483 14 7.50012 14C9.2654 14 9.48685 13.9925 10.18 13.9609C10.8719 13.9293 11.3444 13.8194 11.7578 13.6587C12.1896 13.4917 12.5818 13.2364 12.9091 12.909ZM1.99949 6.73496C1.99974 6.94524 2.00005 7.19543 2.00005 7.50002C2.00005 7.80461 1.99974 8.0548 1.99949 8.26507C1.99849 9.08596 1.99824 9.29856 2.01963 9.7655C2.04625 10.3509 2.07823 10.7811 2.17588 11.1053C2.26976 11.417 2.37505 11.7342 2.7188 12.1171C3.06255 12.4999 3.39411 12.6733 3.81645 12.8007C4.23879 12.928 4.7696 12.9554 5.23052 12.9764C5.75332 13.0003 5.96052 13.0002 7.05714 12.9999L7.50006 12.9999C7.79304 12.9999 8.03569 13.0001 8.2409 13.0004C9.08195 13.0013 9.29425 13.0015 9.76575 12.9799C10.3512 12.9533 10.7814 12.9213 11.1056 12.8237C11.4173 12.7298 11.7345 12.6245 12.1173 12.2807C12.5001 11.937 12.6735 11.6054 12.8009 11.1831C12.9283 10.7607 12.9557 10.2299 12.9767 9.76902C13.0005 9.24689 13.0004 9.04027 13.0002 7.94749V7.94738L13.0001 7.50039L13.0001 7.05747C13.0004 5.96085 13.0005 5.75365 12.9766 5.23085C12.9556 4.76993 12.9282 4.23912 12.8009 3.81678C12.6735 3.39445 12.5001 3.06288 12.1173 2.71913C11.7345 2.37538 11.4172 2.27009 11.1056 2.17621C10.7813 2.07856 10.3511 2.04658 9.76571 2.01996C9.29421 1.99836 9.08194 1.99859 8.24092 1.99951H8.24092C8.0357 1.99974 7.79305 2.00001 7.50006 2.00001L7.05704 1.99993C5.96051 1.99964 5.75331 1.99958 5.23052 2.02343C4.7696 2.04446 4.23879 2.07183 3.81645 2.19921C3.39411 2.32659 3.06255 2.49999 2.7188 2.88281C2.37505 3.26562 2.26976 3.58286 2.17588 3.89453C2.07823 4.21874 2.04625 4.64894 2.01963 5.23437C1.99824 5.70131 1.99849 5.91401 1.99949 6.73496ZM7.49996 5.25015C6.25741 5.25015 5.25012 6.25744 5.25012 7.49999C5.25012 8.74254 6.25741 9.74983 7.49996 9.74983C8.74251 9.74983 9.7498 8.74254 9.7498 7.49999C9.7498 6.25744 8.74251 5.25015 7.49996 5.25015ZM4.25012 7.49999C4.25012 5.70515 5.70512 4.25015 7.49996 4.25015C9.2948 4.25015 10.7498 5.70515 10.7498 7.49999C10.7498 9.29483 9.2948 10.7498 7.49996 10.7498C5.70512 10.7498 4.25012 9.29483 4.25012 7.49999ZM10.9697 4.7803C11.3839 4.7803 11.7197 4.44452 11.7197 4.0303C11.7197 3.61609 11.3839 3.2803 10.9697 3.2803C10.5555 3.2803 10.2197 3.61609 10.2197 4.0303C10.2197 4.44452 10.5555 4.7803 10.9697 4.7803Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxKeyboard(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.5 4H1.5C1.22386 4 1 4.22386 1 4.5V10.5C1 10.7761 1.22386 11 1.5 11H13.5C13.7761 11 14 10.7761 14 10.5V4.5C14 4.22386 13.7761 4 13.5 4ZM1.5 3C0.671573 3 0 3.67157 0 4.5V10.5C0 11.3284 0.671573 12 1.5 12H13.5C14.3284 12 15 11.3284 15 10.5V4.5C15 3.67157 14.3284 3 13.5 3H1.5ZM2 5H3V6H2V5ZM5 5H4V6H5V5ZM6 5H7V6H6V5ZM9 5H8V6H9V5ZM10 5H11V6H10V5ZM13 5H12V6H13V5ZM11 7H12V8H11V7ZM13 9H12V10H13V9ZM9 7H10V8H9V7ZM8 7H7V8H8V7ZM5 7H6V8H5V7ZM4 7H3V8H4V7ZM2 9H3V10H2V9ZM11 9H4V10H11V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLapTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L12.058 2.05806C12.3021 1.81398 12.6978 1.81398 12.9419 2.05806C13.186 2.30214 13.186 2.69786 12.9419 2.94194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13361 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.49998 8.49998V4.09998C5.06992 4.09998 3.09998 6.06992 3.09998 8.49998C3.09998 10.93 5.06992 12.9 7.49998 12.9C8.715 12.9 9.815 12.4075 10.6112 11.6112L7.49998 8.49998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLaptop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4.25C2 4.11193 2.11193 4 2.25 4H12.75C12.8881 4 13 4.11193 13 4.25V11.5H2V4.25ZM2.25 3C1.55964 3 1 3.55964 1 4.25V12H0V12.5C0 12.7761 0.223858 13 0.5 13H14.5C14.7761 13 15 12.7761 15 12.5V12H14V4.25C14 3.55964 13.4404 3 12.75 3H2.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLayers(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.75432 0.819537C7.59742 0.726821 7.4025 0.726821 7.24559 0.819537L1.74559 4.06954C1.59336 4.15949 1.49996 4.32317 1.49996 4.5C1.49996 4.67683 1.59336 4.84051 1.74559 4.93046L7.24559 8.18046C7.4025 8.27318 7.59742 8.27318 7.75432 8.18046L13.2543 4.93046C13.4066 4.84051 13.5 4.67683 13.5 4.5C13.5 4.32317 13.4066 4.15949 13.2543 4.06954L7.75432 0.819537ZM7.49996 7.16923L2.9828 4.5L7.49996 1.83077L12.0171 4.5L7.49996 7.16923ZM1.5695 7.49564C1.70998 7.2579 2.01659 7.17906 2.25432 7.31954L7.49996 10.4192L12.7456 7.31954C12.9833 7.17906 13.2899 7.2579 13.4304 7.49564C13.5709 7.73337 13.4921 8.03998 13.2543 8.18046L7.75432 11.4305C7.59742 11.5232 7.4025 11.5232 7.24559 11.4305L1.74559 8.18046C1.50786 8.03998 1.42901 7.73337 1.5695 7.49564ZM1.56949 10.4956C1.70998 10.2579 2.01658 10.1791 2.25432 10.3195L7.49996 13.4192L12.7456 10.3195C12.9833 10.1791 13.2899 10.2579 13.4304 10.4956C13.5709 10.7334 13.4921 11.04 13.2543 11.1805L7.75432 14.4305C7.59742 14.5232 7.4025 14.5232 7.24559 14.4305L1.74559 11.1805C1.50785 11.04 1.42901 10.7334 1.56949 10.4956Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLayout(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 2H6V13H9V2ZM10 2V13H12.5C12.7761 13 13 12.7761 13 12.5V2.5C13 2.22386 12.7761 2 12.5 2H10ZM2.5 2H5V13H2.5C2.22386 13 2 12.7761 2 12.5V2.5C2 2.22386 2.22386 2 2.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V12.5C1 13.3284 1.67157 14 2.5 14H12.5C13.3284 14 14 13.3284 14 12.5V2.5C14 1.67157 13.3284 1 12.5 1H2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLetterCaseCapitalize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLetterCaseLowercase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.69899 5.20703C2.05823 5.20703 0.809204 6.68569 0.809204 8.60972C0.809204 10.6337 2.15823 12.0124 3.69899 12.0124C4.52126 12.0124 5.37402 11.6693 5.9539 11.0223V11.53C5.9539 11.7785 6.15537 11.98 6.4039 11.98C6.65243 11.98 6.8539 11.7785 6.8539 11.53V5.72001C6.8539 5.47149 6.65243 5.27001 6.4039 5.27001C6.15537 5.27001 5.9539 5.47149 5.9539 5.72001V6.22269C5.40506 5.60075 4.59218 5.20703 3.69899 5.20703ZM5.9539 9.799V7.30117C5.56339 6.58064 4.74118 6.05757 3.8868 6.05757C2.9089 6.05757 1.83508 6.96581 1.83508 8.60955C1.83508 10.1533 2.80889 11.1615 3.8868 11.1615C4.76984 11.1615 5.57141 10.4957 5.9539 9.799ZM10.799 5.20703C9.15823 5.20703 7.9092 6.68569 7.9092 8.60972C7.9092 10.6337 9.25823 12.0124 10.799 12.0124C11.6215 12.0124 12.4744 11.6692 13.0543 11.0218V11.53C13.0543 11.7785 13.2558 11.98 13.5043 11.98C13.7529 11.98 13.9543 11.7785 13.9543 11.53V5.72C13.9543 5.47147 13.7529 5.27 13.5043 5.27C13.2558 5.27 13.0543 5.47147 13.0543 5.72V6.22318C12.5055 5.60095 11.6924 5.20703 10.799 5.20703ZM13.0543 9.79822V7.30196C12.664 6.58102 11.8415 6.05757 10.9868 6.05757C10.0089 6.05757 8.93508 6.96581 8.93508 8.60955C8.93508 10.1533 9.90889 11.1615 10.9868 11.1615C11.8702 11.1615 12.672 10.4952 13.0543 9.79822Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLetterCaseToggle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.2895 2.75C11.4964 2.74979 11.6821 2.87701 11.7565 3.07003L14.9664 11.39C15.0657 11.6477 14.9375 11.9371 14.6798 12.0365C14.4222 12.1359 14.1328 12.0076 14.0334 11.75L12.9822 9.02537H9.61106L8.56672 11.749C8.46786 12.0068 8.1787 12.1357 7.92086 12.0369C7.66302 11.938 7.53415 11.6488 7.63301 11.391L10.8232 3.07099C10.8972 2.87782 11.0826 2.75021 11.2895 2.75ZM11.2915 4.64284L12.6543 8.17537H9.93698L11.2915 4.64284ZM2.89895 5.20703C1.25818 5.20703 0.00915527 6.68569 0.00915527 8.60972C0.00915527 10.6337 1.35818 12.0124 2.89895 12.0124C3.72141 12.0124 4.57438 11.6692 5.15427 11.0219V11.53C5.15427 11.7785 5.35574 11.98 5.60427 11.98C5.8528 11.98 6.05427 11.7785 6.05427 11.53V5.72C6.05427 5.47147 5.8528 5.27 5.60427 5.27C5.35574 5.27 5.15427 5.47147 5.15427 5.72V6.22317C4.60543 5.60095 3.79236 5.20703 2.89895 5.20703ZM5.15427 9.79823V7.30195C4.76393 6.58101 3.94144 6.05757 3.08675 6.05757C2.10885 6.05757 1.03503 6.96581 1.03503 8.60955C1.03503 10.1533 2.00885 11.1615 3.08675 11.1615C3.97011 11.1615 4.77195 10.4952 5.15427 9.79823Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLetterCaseUppercase(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.6255 2.75C3.83478 2.75 4.02192 2.88034 4.09448 3.07664L7.16985 11.3962C7.2656 11.6552 7.13324 11.9428 6.87423 12.0386C6.61522 12.1343 6.32763 12.002 6.23188 11.7429L5.22387 9.01603H2.02712L1.01911 11.7429C0.923362 12.002 0.635774 12.1343 0.376762 12.0386C0.117749 11.9428 -0.0146052 11.6552 0.0811401 11.3962L3.15651 3.07664C3.22908 2.88034 3.41621 2.75 3.6255 2.75ZM3.6255 4.69207L4.90966 8.16603H2.34133L3.6255 4.69207ZM11.3719 2.75C11.5811 2.75 11.7683 2.88034 11.8408 3.07664L14.9162 11.3962C15.012 11.6552 14.8796 11.9428 14.6206 12.0386C14.3616 12.1343 14.074 12.002 13.9782 11.7429L12.9702 9.01603H9.77348L8.76547 11.7429C8.66972 12.002 8.38213 12.1343 8.12312 12.0386C7.86411 11.9428 7.73175 11.6552 7.8275 11.3962L10.9029 3.07664C10.9754 2.88034 11.1626 2.75 11.3719 2.75ZM11.3719 4.69207L12.656 8.16603H10.0877L11.3719 4.69207Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLetterSpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.55293 0.999969C4.75295 0.999969 4.93372 1.11917 5.0125 1.30301L8.01106 8.29982C8.11984 8.55363 8.00226 8.84757 7.74844 8.95635C7.49463 9.06512 7.20069 8.94754 7.09191 8.69373L6.11613 6.41685H2.98973L2.01395 8.69373C1.90517 8.94754 1.61123 9.06512 1.35742 8.95635C1.1036 8.84757 0.986023 8.55363 1.0948 8.29982L4.09336 1.30301C4.17214 1.11917 4.35291 0.999969 4.55293 0.999969ZM4.55293 2.76929L5.75186 5.56685H3.354L4.55293 2.76929ZM11.0562 9.00214C11.2617 9.00214 11.4463 8.87633 11.5215 8.68502L14.2733 1.68299C14.3743 1.42598 14.2478 1.13575 13.9908 1.03475C13.7338 0.933747 13.4436 1.06021 13.3426 1.31722L11.0562 7.13514L8.76973 1.31722C8.66873 1.06021 8.3785 0.933747 8.1215 1.03475C7.86449 1.13575 7.73802 1.42598 7.83902 1.68299L10.5908 8.68502C10.666 8.87633 10.8506 9.00214 11.0562 9.00214ZM14.9537 12.4999C14.9537 12.606 14.9115 12.7077 14.8365 12.7828L12.8365 14.7828C12.6803 14.939 12.4271 14.939 12.2708 14.7828C12.1146 14.6265 12.1146 14.3733 12.2708 14.2171L13.588 12.8999H1.51937L2.83653 14.2171C2.99274 14.3733 2.99274 14.6265 2.83653 14.7828C2.68032 14.939 2.42705 14.939 2.27084 14.7828L0.270843 12.7828C0.195828 12.7077 0.153687 12.606 0.153687 12.4999C0.153687 12.3938 0.195828 12.2921 0.270843 12.2171L2.27084 10.2171C2.42705 10.0609 2.68032 10.0609 2.83653 10.2171C2.99274 10.3733 2.99274 10.6265 2.83653 10.7828L1.51937 12.0999L13.588 12.0999L12.2708 10.7828C12.1146 10.6265 12.1146 10.3733 12.2708 10.2171C12.4271 10.0609 12.6803 10.0609 12.8365 10.2171L14.8365 12.2171C14.9115 12.2921 14.9537 12.3938 14.9537 12.4999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLightningBolt(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.69667 0.0403541C8.90859 0.131038 9.03106 0.354857 8.99316 0.582235L8.0902 6.00001H12.5C12.6893 6.00001 12.8625 6.10701 12.9472 6.27641C13.0319 6.4458 13.0136 6.6485 12.8999 6.80001L6.89997 14.8C6.76167 14.9844 6.51521 15.0503 6.30328 14.9597C6.09135 14.869 5.96888 14.6452 6.00678 14.4178L6.90974 9H2.49999C2.31061 9 2.13748 8.893 2.05278 8.72361C1.96809 8.55422 1.98636 8.35151 2.09999 8.2L8.09997 0.200038C8.23828 0.0156255 8.48474 -0.0503301 8.69667 0.0403541ZM3.49999 8.00001H7.49997C7.64695 8.00001 7.78648 8.06467 7.88148 8.17682C7.97648 8.28896 8.01733 8.43723 7.99317 8.5822L7.33027 12.5596L11.5 7.00001H7.49997C7.353 7.00001 7.21347 6.93534 7.11846 6.8232C7.02346 6.71105 6.98261 6.56279 7.00678 6.41781L7.66968 2.44042L3.49999 8.00001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLineHeight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.78233 2.21713C3.70732 2.14212 3.60557 2.09998 3.49949 2.09998C3.3934 2.09998 3.29166 2.14212 3.21664 2.21713L1.21664 4.21713C1.06044 4.37334 1.06044 4.62661 1.21664 4.78282C1.37285 4.93903 1.62612 4.93903 1.78233 4.78282L3.09949 3.46566L3.09949 11.5343L1.78233 10.2171C1.62612 10.0609 1.37285 10.0609 1.21664 10.2171C1.06043 10.3733 1.06043 10.6266 1.21664 10.7828L3.21664 12.7828C3.29166 12.8578 3.3934 12.9 3.49949 12.9C3.60557 12.9 3.70731 12.8578 3.78233 12.7828L5.78233 10.7828C5.93854 10.6266 5.93854 10.3733 5.78233 10.2171C5.62612 10.0609 5.37285 10.0609 5.21664 10.2171L3.89949 11.5343L3.89949 3.46566L5.21664 4.78282C5.37285 4.93903 5.62612 4.93903 5.78233 4.78282C5.93854 4.62661 5.93854 4.37334 5.78233 4.21713L3.78233 2.21713ZM8.49998 3.99997C8.22383 3.99997 7.99998 4.22382 7.99998 4.49997C7.99998 4.77611 8.22383 4.99997 8.49998 4.99997H14.5C14.7761 4.99997 15 4.77611 15 4.49997C15 4.22382 14.7761 3.99997 14.5 3.99997H8.49998ZM7.99998 7.49997C7.99998 7.22382 8.22383 6.99997 8.49998 6.99997H14.5C14.7761 6.99997 15 7.22382 15 7.49997C15 7.77611 14.7761 7.99997 14.5 7.99997H8.49998C8.22383 7.99997 7.99998 7.77611 7.99998 7.49997ZM8.49998 9.99997C8.22383 9.99997 7.99998 10.2238 7.99998 10.5C7.99998 10.7761 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2238 14.7761 9.99997 14.5 9.99997H8.49998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLink1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.62471 4.00001L4.56402 4.00001C4.04134 3.99993 3.70687 3.99988 3.4182 4.055C2.2379 4.28039 1.29846 5.17053 1.05815 6.33035C0.999538 6.61321 0.999604 6.93998 0.999703 7.43689L0.999711 7.50001L0.999703 7.56313C0.999604 8.06004 0.999538 8.38681 1.05815 8.66967C1.29846 9.8295 2.2379 10.7196 3.4182 10.945C3.70688 11.0001 4.04135 11.0001 4.56403 11L4.62471 11H5.49971C5.77585 11 5.99971 10.7762 5.99971 10.5C5.99971 10.2239 5.77585 10 5.49971 10H4.62471C4.02084 10 3.78907 9.99777 3.60577 9.96277C2.80262 9.8094 2.19157 9.21108 2.03735 8.46678C2.00233 8.29778 1.99971 8.08251 1.99971 7.50001C1.99971 6.91752 2.00233 6.70225 2.03735 6.53324C2.19157 5.78895 2.80262 5.19062 3.60577 5.03725C3.78907 5.00225 4.02084 5.00001 4.62471 5.00001H5.49971C5.77585 5.00001 5.99971 4.77615 5.99971 4.50001C5.99971 4.22387 5.77585 4.00001 5.49971 4.00001H4.62471ZM10.3747 5.00001C10.9786 5.00001 11.2104 5.00225 11.3937 5.03725C12.1968 5.19062 12.8079 5.78895 12.9621 6.53324C12.9971 6.70225 12.9997 6.91752 12.9997 7.50001C12.9997 8.08251 12.9971 8.29778 12.9621 8.46678C12.8079 9.21108 12.1968 9.8094 11.3937 9.96277C11.2104 9.99777 10.9786 10 10.3747 10H9.49971C9.22357 10 8.99971 10.2239 8.99971 10.5C8.99971 10.7762 9.22357 11 9.49971 11H10.3747L10.4354 11C10.9581 11.0001 11.2925 11.0001 11.5812 10.945C12.7615 10.7196 13.701 9.8295 13.9413 8.66967C13.9999 8.38681 13.9998 8.06005 13.9997 7.56314L13.9997 7.50001L13.9997 7.43688C13.9998 6.93998 13.9999 6.61321 13.9413 6.33035C13.701 5.17053 12.7615 4.28039 11.5812 4.055C11.2925 3.99988 10.9581 3.99993 10.4354 4.00001L10.3747 4.00001H9.49971C9.22357 4.00001 8.99971 4.22387 8.99971 4.50001C8.99971 4.77615 9.22357 5.00001 9.49971 5.00001H10.3747ZM5.00038 7C4.72424 7 4.50038 7.22386 4.50038 7.5C4.50038 7.77614 4.72424 8 5.00038 8H10.0004C10.2765 8 10.5004 7.77614 10.5004 7.5C10.5004 7.22386 10.2765 7 10.0004 7H5.00038Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLink2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLinkBreak1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L13.3536 2.35355ZM2.03735 8.46678C2.17398 9.12619 2.66918 9.67103 3.33886 9.89338L2.57833 10.6539C1.80843 10.2534 1.23784 9.53693 1.05815 8.66967C0.999538 8.38681 0.999604 8.06004 0.999703 7.56313L0.999711 7.50001L0.999703 7.43689C0.999604 6.93998 0.999538 6.61321 1.05815 6.33035C1.29846 5.17053 2.2379 4.28039 3.4182 4.055C3.70687 3.99988 4.04134 3.99993 4.56402 4.00001L4.62471 4.00001H5.49971C5.77585 4.00001 5.99971 4.22387 5.99971 4.50001C5.99971 4.77615 5.77585 5.00001 5.49971 5.00001H4.62471C4.02084 5.00001 3.78907 5.00225 3.60577 5.03725C2.80262 5.19062 2.19157 5.78895 2.03735 6.53324C2.00233 6.70225 1.99971 6.91752 1.99971 7.50001C1.99971 8.08251 2.00233 8.29778 2.03735 8.46678ZM12.9621 6.53324C12.8255 5.87397 12.3304 5.32922 11.661 5.10679L12.4215 4.34631C13.1912 4.74686 13.7616 5.46323 13.9413 6.33035C13.9999 6.61321 13.9998 6.93998 13.9997 7.43688L13.9997 7.50001L13.9997 7.56314C13.9998 8.06005 13.9999 8.38681 13.9413 8.66967C13.701 9.8295 12.7615 10.7196 11.5812 10.945C11.2925 11.0001 10.9581 11.0001 10.4354 11L10.3747 11H9.49971C9.22357 11 8.99971 10.7762 8.99971 10.5C8.99971 10.2239 9.22357 10 9.49971 10H10.3747C10.9786 10 11.2104 9.99777 11.3937 9.96277C12.1968 9.8094 12.8079 9.21108 12.9621 8.46678C12.9971 8.29778 12.9997 8.08251 12.9997 7.50001C12.9997 6.91752 12.9971 6.70225 12.9621 6.53324Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLinkBreak2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLinkNone1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.56427 3.99988C4.58422 3.99989 4.60445 3.99989 4.62496 3.99989H5.49996C5.7761 3.99989 5.99996 4.22375 5.99996 4.49989C5.99996 4.77603 5.7761 4.99989 5.49996 4.99989H4.62496C4.02108 4.99989 3.78932 5.00213 3.60601 5.03713C2.80287 5.1905 2.19181 5.78883 2.03759 6.53312C2.00257 6.70212 1.99996 6.91739 1.99996 7.49989C1.99996 8.08239 2.00257 8.29766 2.03759 8.46666C2.19181 9.21095 2.80287 9.80928 3.60601 9.96265C3.78932 9.99765 4.02108 9.99989 4.62496 9.99989H5.49996C5.7761 9.99989 5.99996 10.2237 5.99996 10.4999C5.99996 10.776 5.7761 10.9999 5.49996 10.9999H4.62496C4.60445 10.9999 4.58422 10.9999 4.56427 10.9999C4.04159 11 3.70712 11 3.41845 10.9449C2.23814 10.7195 1.29871 9.82937 1.05839 8.66955C0.999782 8.38669 0.999848 8.05992 0.999947 7.56301C0.999951 7.54227 0.999955 7.52123 0.999955 7.49989C0.999955 7.47855 0.999951 7.45751 0.999947 7.43677C0.999848 6.93986 0.999782 6.61309 1.05839 6.33023C1.29871 5.17041 2.23814 4.28027 3.41845 4.05488C3.70712 3.99976 4.04159 3.99981 4.56427 3.99988ZM11.3939 5.03713C11.2106 5.00213 10.9788 4.99989 10.375 4.99989H9.49996C9.22381 4.99989 8.99996 4.77603 8.99996 4.49989C8.99996 4.22375 9.22381 3.99989 9.49996 3.99989H10.375C10.3955 3.99989 10.4157 3.99989 10.4356 3.99988C10.9583 3.99981 11.2928 3.99976 11.5815 4.05488C12.7618 4.28027 13.7012 5.17041 13.9415 6.33023C14.0001 6.61309 14.0001 6.93985 14 7.43676C14 7.4575 14 7.47854 14 7.49989C14 7.52124 14 7.54228 14 7.56302C14.0001 8.05992 14.0001 8.38669 13.9415 8.66955C13.7012 9.82937 12.7618 10.7195 11.5815 10.9449C11.2928 11 10.9583 11 10.4356 10.9999C10.4157 10.9999 10.3955 10.9999 10.375 10.9999H9.49996C9.22381 10.9999 8.99996 10.776 8.99996 10.4999C8.99996 10.2237 9.22381 9.99989 9.49996 9.99989H10.375C10.9788 9.99989 11.2106 9.99765 11.3939 9.96265C12.197 9.80928 12.8081 9.21095 12.9623 8.46666C12.9973 8.29766 13 8.08239 13 7.49989C13 6.91739 12.9973 6.70212 12.9623 6.53312C12.8081 5.78883 12.197 5.1905 11.3939 5.03713Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLinkNone2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.6788 2.95419C10.0435 2.53694 9.18829 2.54594 8.51194 3.00541C8.35757 3.11027 8.1921 3.27257 7.7651 3.69957L7.14638 4.31829C6.95112 4.51355 6.63454 4.51355 6.43928 4.31829C6.24401 4.12303 6.24401 3.80645 6.43928 3.61119L7.058 2.99247C7.0725 2.97797 7.08679 2.96366 7.1009 2.94955C7.47044 2.57991 7.70691 2.34336 7.95001 2.17822C8.94398 1.50299 10.2377 1.46813 11.2277 2.11832C11.4692 2.27689 11.7002 2.508 12.0515 2.85942C12.0662 2.8741 12.081 2.88898 12.0961 2.90408C12.1112 2.91917 12.1261 2.93405 12.1408 2.94871C12.4922 3.30001 12.7233 3.53102 12.8819 3.77248C13.5321 4.76252 13.4972 6.05623 12.822 7.0502C12.6568 7.2933 12.4203 7.52976 12.0507 7.89929C12.0366 7.9134 12.0222 7.92771 12.0077 7.94221L11.389 8.56093C11.1938 8.7562 10.8772 8.7562 10.6819 8.56093C10.4867 8.36567 10.4867 8.04909 10.6819 7.85383L11.3006 7.23511C11.7276 6.80811 11.8899 6.64264 11.9948 6.48827C12.4543 5.81192 12.4633 4.95675 12.046 4.32141C11.9513 4.17714 11.8009 4.02307 11.389 3.61119C10.9771 3.1993 10.8231 3.04893 10.6788 2.95419ZM4.31796 6.43961C4.51322 6.63487 4.51322 6.95146 4.31796 7.14672L3.69924 7.76544C3.27224 8.19244 3.10993 8.35791 3.00507 8.51227C2.54561 9.18863 2.53661 10.0438 2.95385 10.6791C3.0486 10.8234 3.19896 10.9775 3.61085 11.3894C4.02274 11.8012 4.17681 11.9516 4.32107 12.0464C4.95642 12.4636 5.81158 12.4546 6.48794 11.9951C6.6423 11.8903 6.80777 11.728 7.23477 11.301L7.85349 10.6823C8.04875 10.487 8.36533 10.487 8.5606 10.6823C8.75586 10.8775 8.75586 11.1941 8.5606 11.3894L7.94188 12.0081C7.92738 12.0226 7.91307 12.0369 7.89897 12.051C7.52943 12.4206 7.29296 12.6572 7.04986 12.8223C6.05589 13.4976 4.76219 13.5324 3.77214 12.8822C3.53068 12.7237 3.29967 12.4925 2.94837 12.1411C2.93371 12.1264 2.91883 12.1116 2.90374 12.0965C2.88865 12.0814 2.87377 12.0665 2.8591 12.0518C2.50766 11.7005 2.27656 11.4695 2.11799 11.2281C1.4678 10.238 1.50265 8.94432 2.17788 7.95035C2.34303 7.70724 2.57957 7.47077 2.94922 7.10124C2.96333 7.08713 2.97763 7.07283 2.99213 7.05833L3.61085 6.43961C3.80611 6.24435 4.12269 6.24435 4.31796 6.43961Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLinkedinLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 1C1.44772 1 1 1.44772 1 2V13C1 13.5523 1.44772 14 2 14H13C13.5523 14 14 13.5523 14 13V2C14 1.44772 13.5523 1 13 1H2ZM3.05 6H4.95V12H3.05V6ZM5.075 4.005C5.075 4.59871 4.59371 5.08 4 5.08C3.4063 5.08 2.925 4.59871 2.925 4.005C2.925 3.41129 3.4063 2.93 4 2.93C4.59371 2.93 5.075 3.41129 5.075 4.005ZM12 8.35713C12 6.55208 10.8334 5.85033 9.67449 5.85033C9.29502 5.83163 8.91721 5.91119 8.57874 6.08107C8.32172 6.21007 8.05265 6.50523 7.84516 7.01853H7.79179V6.00044H6V12.0047H7.90616V8.8112C7.8786 8.48413 7.98327 8.06142 8.19741 7.80987C8.41156 7.55832 8.71789 7.49825 8.95015 7.46774H9.02258C9.62874 7.46774 10.0786 7.84301 10.0786 8.78868V12.0047H11.9847L12 8.35713Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxListBullet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLockClosed(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLockOpen1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.4986 0C6.3257 0 5.36107 0.38943 4.73753 1.19361C4.23745 1.83856 4 2.68242 4 3.63325H5C5 2.84313 5.19691 2.23312 5.5278 1.80636C5.91615 1.30552 6.55152 1 7.4986 1C8.35683 1 8.96336 1.26502 9.35846 1.68623C9.75793 2.11211 10 2.76044 10 3.63601V6H3C2.44772 6 2 6.44772 2 7V13C2 13.5523 2.44772 14 3 14H12C12.5523 14 13 13.5523 13 13V7C13 6.44771 12.5523 6 12 6H11V3.63601C11 2.58135 10.7065 1.66167 10.0878 1.0021C9.46477 0.337871 8.57061 0 7.4986 0ZM3 7H12V13H3V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLockOpen2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9 3.63601C9 2.76044 9.24207 2.11211 9.64154 1.68623C10.0366 1.26502 10.6432 1 11.5014 1C12.4485 1 13.0839 1.30552 13.4722 1.80636C13.8031 2.23312 14 2.84313 14 3.63325H15C15 2.68242 14.7626 1.83856 14.2625 1.19361C13.6389 0.38943 12.6743 0 11.5014 0C10.4294 0 9.53523 0.337871 8.91218 1.0021C8.29351 1.66167 8 2.58135 8 3.63601V6H1C0.447715 6 0 6.44772 0 7V13C0 13.5523 0.447715 14 1 14H10C10.5523 14 11 13.5523 11 13V7C11 6.44772 10.5523 6 10 6H9V3.63601ZM1 7H10V13H1V7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxLoop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.35355 1.85355C3.54882 1.65829 3.54882 1.34171 3.35355 1.14645C3.15829 0.951184 2.84171 0.951184 2.64645 1.14645L0.646447 3.14645C0.451184 3.34171 0.451184 3.65829 0.646447 3.85355L2.64645 5.85355C2.84171 6.04882 3.15829 6.04882 3.35355 5.85355C3.54882 5.65829 3.54882 5.34171 3.35355 5.14645L2.20711 4H9.5C11.433 4 13 5.567 13 7.5C13 7.77614 13.2239 8 13.5 8C13.7761 8 14 7.77614 14 7.5C14 5.01472 11.9853 3 9.5 3H2.20711L3.35355 1.85355ZM2 7.5C2 7.22386 1.77614 7 1.5 7C1.22386 7 1 7.22386 1 7.5C1 9.98528 3.01472 12 5.5 12H12.7929L11.6464 13.1464C11.4512 13.3417 11.4512 13.6583 11.6464 13.8536C11.8417 14.0488 12.1583 14.0488 12.3536 13.8536L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464L12.3536 9.14645C12.1583 8.95118 11.8417 8.95118 11.6464 9.14645C11.4512 9.34171 11.4512 9.65829 11.6464 9.85355L12.7929 11H5.5C3.567 11 2 9.433 2 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMagicWand(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.9 0.499976C13.9 0.279062 13.7209 0.0999756 13.5 0.0999756C13.2791 0.0999756 13.1 0.279062 13.1 0.499976V1.09998H12.5C12.2791 1.09998 12.1 1.27906 12.1 1.49998C12.1 1.72089 12.2791 1.89998 12.5 1.89998H13.1V2.49998C13.1 2.72089 13.2791 2.89998 13.5 2.89998C13.7209 2.89998 13.9 2.72089 13.9 2.49998V1.89998H14.5C14.7209 1.89998 14.9 1.72089 14.9 1.49998C14.9 1.27906 14.7209 1.09998 14.5 1.09998H13.9V0.499976ZM11.8536 3.14642C12.0488 3.34168 12.0488 3.65826 11.8536 3.85353L10.8536 4.85353C10.6583 5.04879 10.3417 5.04879 10.1465 4.85353C9.9512 4.65827 9.9512 4.34169 10.1465 4.14642L11.1464 3.14643C11.3417 2.95116 11.6583 2.95116 11.8536 3.14642ZM9.85357 5.14642C10.0488 5.34168 10.0488 5.65827 9.85357 5.85353L2.85355 12.8535C2.65829 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L9.14646 5.14642C9.34172 4.95116 9.65831 4.95116 9.85357 5.14642ZM13.5 5.09998C13.7209 5.09998 13.9 5.27906 13.9 5.49998V6.09998H14.5C14.7209 6.09998 14.9 6.27906 14.9 6.49998C14.9 6.72089 14.7209 6.89998 14.5 6.89998H13.9V7.49998C13.9 7.72089 13.7209 7.89998 13.5 7.89998C13.2791 7.89998 13.1 7.72089 13.1 7.49998V6.89998H12.5C12.2791 6.89998 12.1 6.72089 12.1 6.49998C12.1 6.27906 12.2791 6.09998 12.5 6.09998H13.1V5.49998C13.1 5.27906 13.2791 5.09998 13.5 5.09998ZM8.90002 0.499976C8.90002 0.279062 8.72093 0.0999756 8.50002 0.0999756C8.2791 0.0999756 8.10002 0.279062 8.10002 0.499976V1.09998H7.50002C7.2791 1.09998 7.10002 1.27906 7.10002 1.49998C7.10002 1.72089 7.2791 1.89998 7.50002 1.89998H8.10002V2.49998C8.10002 2.72089 8.2791 2.89998 8.50002 2.89998C8.72093 2.89998 8.90002 2.72089 8.90002 2.49998V1.89998H9.50002C9.72093 1.89998 9.90002 1.72089 9.90002 1.49998C9.90002 1.27906 9.72093 1.09998 9.50002 1.09998H8.90002V0.499976Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMagnifyingGlass(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMargin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.49988 2.00012C1.77602 2.00012 1.99988 1.77626 1.99988 1.50012C1.99988 1.22398 1.77602 1.00012 1.49988 1.00012C1.22374 1.00012 0.999878 1.22398 0.999878 1.50012C0.999878 1.77626 1.22374 2.00012 1.49988 2.00012ZM4.49988 2.00012C4.77602 2.00012 4.99988 1.77626 4.99988 1.50012C4.99988 1.22398 4.77602 1.00012 4.49988 1.00012C4.22374 1.00012 3.99988 1.22398 3.99988 1.50012C3.99988 1.77626 4.22374 2.00012 4.49988 2.00012ZM7.99988 1.50012C7.99988 1.77626 7.77602 2.00012 7.49988 2.00012C7.22374 2.00012 6.99988 1.77626 6.99988 1.50012C6.99988 1.22398 7.22374 1.00012 7.49988 1.00012C7.77602 1.00012 7.99988 1.22398 7.99988 1.50012ZM10.4999 2.00012C10.776 2.00012 10.9999 1.77626 10.9999 1.50012C10.9999 1.22398 10.776 1.00012 10.4999 1.00012C10.2237 1.00012 9.99988 1.22398 9.99988 1.50012C9.99988 1.77626 10.2237 2.00012 10.4999 2.00012ZM13.9999 1.50012C13.9999 1.77626 13.776 2.00012 13.4999 2.00012C13.2237 2.00012 12.9999 1.77626 12.9999 1.50012C12.9999 1.22398 13.2237 1.00012 13.4999 1.00012C13.776 1.00012 13.9999 1.22398 13.9999 1.50012ZM1.49988 14.0001C1.77602 14.0001 1.99988 13.7763 1.99988 13.5001C1.99988 13.224 1.77602 13.0001 1.49988 13.0001C1.22374 13.0001 0.999878 13.224 0.999878 13.5001C0.999878 13.7763 1.22374 14.0001 1.49988 14.0001ZM1.99988 10.5001C1.99988 10.7763 1.77602 11.0001 1.49988 11.0001C1.22374 11.0001 0.999878 10.7763 0.999878 10.5001C0.999878 10.224 1.22374 10.0001 1.49988 10.0001C1.77602 10.0001 1.99988 10.224 1.99988 10.5001ZM1.49988 8.00012C1.77602 8.00012 1.99988 7.77626 1.99988 7.50012C1.99988 7.22398 1.77602 7.00012 1.49988 7.00012C1.22374 7.00012 0.999878 7.22398 0.999878 7.50012C0.999878 7.77626 1.22374 8.00012 1.49988 8.00012ZM1.99988 4.50012C1.99988 4.77626 1.77602 5.00012 1.49988 5.00012C1.22374 5.00012 0.999878 4.77626 0.999878 4.50012C0.999878 4.22398 1.22374 4.00012 1.49988 4.00012C1.77602 4.00012 1.99988 4.22398 1.99988 4.50012ZM13.4999 11.0001C13.776 11.0001 13.9999 10.7763 13.9999 10.5001C13.9999 10.224 13.776 10.0001 13.4999 10.0001C13.2237 10.0001 12.9999 10.224 12.9999 10.5001C12.9999 10.7763 13.2237 11.0001 13.4999 11.0001ZM13.9999 7.50012C13.9999 7.77626 13.776 8.00012 13.4999 8.00012C13.2237 8.00012 12.9999 7.77626 12.9999 7.50012C12.9999 7.22398 13.2237 7.00012 13.4999 7.00012C13.776 7.00012 13.9999 7.22398 13.9999 7.50012ZM13.4999 5.00012C13.776 5.00012 13.9999 4.77626 13.9999 4.50012C13.9999 4.22398 13.776 4.00012 13.4999 4.00012C13.2237 4.00012 12.9999 4.22398 12.9999 4.50012C12.9999 4.77626 13.2237 5.00012 13.4999 5.00012ZM4.99988 13.5001C4.99988 13.7763 4.77602 14.0001 4.49988 14.0001C4.22374 14.0001 3.99988 13.7763 3.99988 13.5001C3.99988 13.224 4.22374 13.0001 4.49988 13.0001C4.77602 13.0001 4.99988 13.224 4.99988 13.5001ZM7.49988 14.0001C7.77602 14.0001 7.99988 13.7763 7.99988 13.5001C7.99988 13.224 7.77602 13.0001 7.49988 13.0001C7.22374 13.0001 6.99988 13.224 6.99988 13.5001C6.99988 13.7763 7.22374 14.0001 7.49988 14.0001ZM10.9999 13.5001C10.9999 13.7763 10.776 14.0001 10.4999 14.0001C10.2237 14.0001 9.99988 13.7763 9.99988 13.5001C9.99988 13.224 10.2237 13.0001 10.4999 13.0001C10.776 13.0001 10.9999 13.224 10.9999 13.5001ZM13.4999 14.0001C13.776 14.0001 13.9999 13.7763 13.9999 13.5001C13.9999 13.224 13.776 13.0001 13.4999 13.0001C13.2237 13.0001 12.9999 13.224 12.9999 13.5001C12.9999 13.7763 13.2237 14.0001 13.4999 14.0001ZM3.99988 5.00012C3.99988 4.44784 4.44759 4.00012 4.99988 4.00012H9.99988C10.5522 4.00012 10.9999 4.44784 10.9999 5.00012V10.0001C10.9999 10.5524 10.5522 11.0001 9.99988 11.0001H4.99988C4.44759 11.0001 3.99988 10.5524 3.99988 10.0001V5.00012ZM4.99988 5.00012H9.99988V10.0001H4.99988V5.00012Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMaskOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 2H14V13H1L1 2ZM0 2C0 1.44772 0.447715 1 1 1H14C14.5523 1 15 1.44772 15 2V13C15 13.5523 14.5523 14 14 14H1C0.447715 14 0 13.5523 0 13V2ZM4.875 7.5C4.875 6.05025 6.05025 4.875 7.5 4.875C8.94975 4.875 10.125 6.05025 10.125 7.5C10.125 8.94975 8.94975 10.125 7.5 10.125C6.05025 10.125 4.875 8.94975 4.875 7.5ZM7.5 3.875C5.49797 3.875 3.875 5.49797 3.875 7.5C3.875 9.50203 5.49797 11.125 7.5 11.125C9.50203 11.125 11.125 9.50203 11.125 7.5C11.125 5.49797 9.50203 3.875 7.5 3.875Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMaskOn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 1C0.447715 1 0 1.44772 0 2V13C0 13.5523 0.447715 14 1 14H14C14.5523 14 15 13.5523 15 13V2C15 1.44772 14.5523 1 14 1H1ZM7.5 10.625C9.22589 10.625 10.625 9.22589 10.625 7.5C10.625 5.77411 9.22589 4.375 7.5 4.375C5.77411 4.375 4.375 5.77411 4.375 7.5C4.375 9.22589 5.77411 10.625 7.5 10.625Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMinusCircled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM4.50003 7C4.22389 7 4.00003 7.22386 4.00003 7.5C4.00003 7.77614 4.22389 8 4.50003 8H10.5C10.7762 8 11 7.77614 11 7.5C11 7.22386 10.7762 7 10.5 7H4.50003Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMinus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.25 7.5C2.25 7.22386 2.47386 7 2.75 7H12.25C12.5261 7 12.75 7.22386 12.75 7.5C12.75 7.77614 12.5261 8 12.25 8H2.75C2.47386 8 2.25 7.77614 2.25 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMix(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.14921 3.99996C2.14921 2.97778 2.97784 2.14915 4.00002 2.14915C5.02219 2.14915 5.85083 2.97778 5.85083 3.99996C5.85083 5.02213 5.02219 5.85077 4.00002 5.85077C2.97784 5.85077 2.14921 5.02213 2.14921 3.99996ZM4.00002 1.24915C2.48079 1.24915 1.24921 2.48073 1.24921 3.99996C1.24921 5.51919 2.48079 6.75077 4.00002 6.75077C5.51925 6.75077 6.75083 5.51919 6.75083 3.99996C6.75083 2.48073 5.51925 1.24915 4.00002 1.24915ZM5.82034 11.0001L2.49998 12.8369V9.16331L5.82034 11.0001ZM2.63883 8.21159C2.17228 7.9535 1.59998 8.29093 1.59998 8.82411V13.1761C1.59998 13.7093 2.17228 14.0467 2.63883 13.7886L6.57235 11.6126C7.05389 11.3462 7.05389 10.654 6.57235 10.3876L2.63883 8.21159ZM8.30001 9.00003C8.30001 8.61343 8.61341 8.30003 9.00001 8.30003H13C13.3866 8.30003 13.7 8.61343 13.7 9.00003V13C13.7 13.3866 13.3866 13.7 13 13.7H9.00001C8.61341 13.7 8.30001 13.3866 8.30001 13V9.00003ZM9.20001 9.20003V12.8H12.8V9.20003H9.20001ZM13.4432 2.19311C13.6189 2.01737 13.6189 1.73245 13.4432 1.55671C13.2675 1.38098 12.9826 1.38098 12.8068 1.55671L11 3.36353L9.19321 1.55674C9.01748 1.381 8.73255 1.381 8.55682 1.55674C8.38108 1.73247 8.38108 2.0174 8.55682 2.19313L10.3636 3.99992L8.55682 5.80671C8.38108 5.98245 8.38108 6.26737 8.55682 6.44311C8.73255 6.61885 9.01748 6.61885 9.19321 6.44311L11 4.63632L12.8068 6.44314C12.9826 6.61887 13.2675 6.61887 13.4432 6.44314C13.6189 6.2674 13.6189 5.98247 13.4432 5.80674L11.6364 3.99992L13.4432 2.19311Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMixerHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.5 3C4.67157 3 4 3.67157 4 4.5C4 5.32843 4.67157 6 5.5 6C6.32843 6 7 5.32843 7 4.5C7 3.67157 6.32843 3 5.5 3ZM3 5C3.01671 5 3.03323 4.99918 3.04952 4.99758C3.28022 6.1399 4.28967 7 5.5 7C6.71033 7 7.71978 6.1399 7.95048 4.99758C7.96677 4.99918 7.98329 5 8 5H13.5C13.7761 5 14 4.77614 14 4.5C14 4.22386 13.7761 4 13.5 4H8C7.98329 4 7.96677 4.00082 7.95048 4.00242C7.71978 2.86009 6.71033 2 5.5 2C4.28967 2 3.28022 2.86009 3.04952 4.00242C3.03323 4.00082 3.01671 4 3 4H1.5C1.22386 4 1 4.22386 1 4.5C1 4.77614 1.22386 5 1.5 5H3ZM11.9505 10.9976C11.7198 12.1399 10.7103 13 9.5 13C8.28967 13 7.28022 12.1399 7.04952 10.9976C7.03323 10.9992 7.01671 11 7 11H1.5C1.22386 11 1 10.7761 1 10.5C1 10.2239 1.22386 10 1.5 10H7C7.01671 10 7.03323 10.0008 7.04952 10.0024C7.28022 8.8601 8.28967 8 9.5 8C10.7103 8 11.7198 8.8601 11.9505 10.0024C11.9668 10.0008 11.9833 10 12 10H13.5C13.7761 10 14 10.2239 14 10.5C14 10.7761 13.7761 11 13.5 11H12C11.9833 11 11.9668 10.9992 11.9505 10.9976ZM8 10.5C8 9.67157 8.67157 9 9.5 9C10.3284 9 11 9.67157 11 10.5C11 11.3284 10.3284 12 9.5 12C8.67157 12 8 11.3284 8 10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMixerVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 1.5C5 1.22386 4.77614 1 4.5 1C4.22386 1 4 1.22386 4 1.5L4 7C4 7.01671 4.00082 7.03323 4.00242 7.04952C2.86009 7.28022 2 8.28967 2 9.5C2 10.7103 2.86009 11.7198 4.00242 11.9505C4.00082 11.9668 4 11.9833 4 12V13.5C4 13.7761 4.22386 14 4.5 14C4.77614 14 5 13.7761 5 13.5V12C5 11.9833 4.99918 11.9668 4.99758 11.9505C6.1399 11.7198 7 10.7103 7 9.5C7 8.28967 6.1399 7.28022 4.99758 7.04952C4.99918 7.03323 5 7.01671 5 7L5 1.5ZM11 1.5C11 1.22386 10.7761 1 10.5 1C10.2239 1 10 1.22386 10 1.5V3C10 3.01671 10.0008 3.03323 10.0024 3.04952C8.8601 3.28022 8 4.28967 8 5.5C8 6.71033 8.8601 7.71978 10.0024 7.95048C10.0008 7.96677 10 7.98329 10 8V13.5C10 13.7761 10.2239 14 10.5 14C10.7761 14 11 13.7761 11 13.5V8C11 7.98329 10.9992 7.96677 10.9976 7.95048C12.1399 7.71978 13 6.71033 13 5.5C13 4.28967 12.1399 3.28022 10.9976 3.04952C10.9992 3.03323 11 3.01671 11 3V1.5ZM4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8ZM9 5.5C9 4.67157 9.67157 4 10.5 4C11.3284 4 12 4.67157 12 5.5C12 6.32843 11.3284 7 10.5 7C9.67157 7 9 6.32843 9 5.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMobile(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4 2.5C4 2.22386 4.22386 2 4.5 2H10.5C10.7761 2 11 2.22386 11 2.5V12.5C11 12.7761 10.7761 13 10.5 13H4.5C4.22386 13 4 12.7761 4 12.5V2.5ZM4.5 1C3.67157 1 3 1.67157 3 2.5V12.5C3 13.3284 3.67157 14 4.5 14H10.5C11.3284 14 12 13.3284 12 12.5V2.5C12 1.67157 11.3284 1 10.5 1H4.5ZM6 11.65C5.8067 11.65 5.65 11.8067 5.65 12C5.65 12.1933 5.8067 12.35 6 12.35H9C9.1933 12.35 9.35 12.1933 9.35 12C9.35 11.8067 9.1933 11.65 9 11.65H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxModulzLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.25925 3.16667L4.37036 5.33333V1L7.25925 3.16667ZM1 8.22222L3.88889 6.05555L1 3.88889V8.22222ZM1 14L3.88889 11.8333L1 9.66666V14ZM7.74072 8.22222L10.6296 6.05555L7.74072 3.88889V8.22222ZM14 3.16667L11.1111 5.33333V1L14 3.16667ZM11.1111 11.1111L14 8.94444L11.1111 6.77777V11.1111ZM3.88889 11.1111L1 8.94444L3.88889 6.77777V11.1111ZM4.37036 6.05555L7.25925 8.22222V3.88889L4.37036 6.05555ZM3.88889 5.33333L1 3.16667L3.88889 1V5.33333ZM7.74072 3.16667L10.6296 5.33333V1L7.74072 3.16667ZM14 8.22222L11.1111 6.05555L14 3.88889V8.22222ZM11.1111 11.8333L14 14V9.66666L11.1111 11.8333Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMoon(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxMove(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.81819 0.93179C7.64245 0.756054 7.35753 0.756054 7.18179 0.93179L5.43179 2.68179C5.25605 2.85753 5.25605 3.14245 5.43179 3.31819C5.60753 3.49392 5.89245 3.49392 6.06819 3.31819L6.99999 2.38638V5.49999C6.99999 5.77613 7.22385 5.99999 7.49999 5.99999C7.77613 5.99999 7.99999 5.77613 7.99999 5.49999V2.38638L8.93179 3.31819C9.10753 3.49392 9.39245 3.49392 9.56819 3.31819C9.74392 3.14245 9.74392 2.85753 9.56819 2.68179L7.81819 0.93179ZM7.99999 9.49999C7.99999 9.22385 7.77613 8.99999 7.49999 8.99999C7.22385 8.99999 6.99999 9.22385 6.99999 9.49999V12.6136L6.06819 11.6818C5.89245 11.5061 5.60753 11.5061 5.43179 11.6818C5.25605 11.8575 5.25605 12.1424 5.43179 12.3182L7.18179 14.0682C7.35753 14.2439 7.64245 14.2439 7.81819 14.0682L9.56819 12.3182C9.74392 12.1424 9.74392 11.8575 9.56819 11.6818C9.39245 11.5061 9.10753 11.5061 8.93179 11.6818L7.99999 12.6136V9.49999ZM8.99999 7.49999C8.99999 7.22385 9.22385 6.99999 9.49999 6.99999H12.6136L11.6818 6.06819C11.5061 5.89245 11.5061 5.60753 11.6818 5.43179C11.8575 5.25605 12.1424 5.25605 12.3182 5.43179L14.0682 7.18179C14.2439 7.35753 14.2439 7.64245 14.0682 7.81819L12.3182 9.56819C12.1424 9.74392 11.8575 9.74392 11.6818 9.56819C11.5061 9.39245 11.5061 9.10753 11.6818 8.93179L12.6136 7.99999H9.49999C9.22385 7.99999 8.99999 7.77613 8.99999 7.49999ZM3.31819 6.06819L2.38638 6.99999H5.49999C5.77613 6.99999 5.99999 7.22385 5.99999 7.49999C5.99999 7.77613 5.77613 7.99999 5.49999 7.99999H2.38638L3.31819 8.93179C3.49392 9.10753 3.49392 9.39245 3.31819 9.56819C3.14245 9.74392 2.85753 9.74392 2.68179 9.56819L0.93179 7.81819C0.756054 7.64245 0.756054 7.35753 0.93179 7.18179L2.68179 5.43179C2.85753 5.25605 3.14245 5.25605 3.31819 5.43179C3.49392 5.60753 3.49392 5.89245 3.31819 6.06819Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxNotionLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M3.25781 3.11684C3.67771 3.45796 3.83523 3.43193 4.62369 3.37933L12.0571 2.93299C12.2147 2.93299 12.0836 2.77571 12.0311 2.74957L10.7965 1.85711C10.56 1.67347 10.2448 1.46315 9.64083 1.51576L2.44308 2.04074C2.18059 2.06677 2.12815 2.19801 2.2327 2.30322L3.25781 3.11684ZM3.7041 4.84917V12.6704C3.7041 13.0907 3.91415 13.248 4.38693 13.222L12.5562 12.7493C13.0292 12.7233 13.0819 12.4341 13.0819 12.0927V4.32397C13.0819 3.98306 12.9508 3.79921 12.6612 3.82545L4.12422 4.32397C3.80918 4.35044 3.7041 4.50803 3.7041 4.84917ZM11.7688 5.26872C11.8212 5.50518 11.7688 5.74142 11.5319 5.76799L11.1383 5.84641V11.6205C10.7965 11.8042 10.4814 11.9092 10.2188 11.9092C9.79835 11.9092 9.69305 11.7779 9.37812 11.3844L6.80345 7.34249V11.2532L7.61816 11.437C7.61816 11.437 7.61816 11.9092 6.96086 11.9092L5.14879 12.0143C5.09615 11.9092 5.14879 11.647 5.33259 11.5944L5.80546 11.4634V6.29276L5.1489 6.24015C5.09625 6.00369 5.22739 5.66278 5.5954 5.63631L7.53935 5.50528L10.2188 9.5998V5.97765L9.53564 5.89924C9.4832 5.61018 9.69305 5.40028 9.95576 5.37425L11.7688 5.26872ZM1.83874 1.33212L9.32557 0.780787C10.245 0.701932 10.4815 0.754753 11.0594 1.17452L13.4492 2.85424C13.8436 3.14309 13.975 3.22173 13.975 3.53661V12.7493C13.975 13.3266 13.7647 13.6681 13.0293 13.7203L4.33492 14.2454C3.78291 14.2717 3.52019 14.193 3.23111 13.8253L1.47116 11.5419C1.1558 11.1216 1.02466 10.8071 1.02466 10.4392V2.25041C1.02466 1.77825 1.23504 1.38441 1.83874 1.33212Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxOpacity(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 1.5C4.5 4.25 3 6.5 3 9C3 11.4853 5.01472 13.5 7.5 13.5C9.98528 13.5 12 11.4853 12 9C12 6.5 10.5 4.25 7.5 1.5ZM11 9C11 7.11203 9.97315 5.27195 7.5 2.87357C5.02686 5.27195 4 7.11203 4 9C4 10.933 5.567 12.5 7.5 12.5C9.433 12.5 11 10.933 11 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxOpenInNewWindow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12 13C12.5523 13 13 12.5523 13 12V3C13 2.44771 12.5523 2 12 2H3C2.44771 2 2 2.44771 2 3V6.5C2 6.77614 2.22386 7 2.5 7C2.77614 7 3 6.77614 3 6.5V3H12V12H8.5C8.22386 12 8 12.2239 8 12.5C8 12.7761 8.22386 13 8.5 13H12ZM9 6.5C9 6.5001 9 6.50021 9 6.50031V6.50035V9.5C9 9.77614 8.77614 10 8.5 10C8.22386 10 8 9.77614 8 9.5V7.70711L2.85355 12.8536C2.65829 13.0488 2.34171 13.0488 2.14645 12.8536C1.95118 12.6583 1.95118 12.3417 2.14645 12.1464L7.29289 7H5.5C5.22386 7 5 6.77614 5 6.5C5 6.22386 5.22386 6 5.5 6H8.5C8.56779 6 8.63244 6.01349 8.69139 6.03794C8.74949 6.06198 8.80398 6.09744 8.85143 6.14433C8.94251 6.23434 8.9992 6.35909 8.99999 6.49708L8.99999 6.49738",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxOverline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.49985 1.10001C3.27894 1.10001 3.09985 1.27909 3.09985 1.50001C3.09985 1.72092 3.27894 1.90001 3.49985 1.90001H11.4999C11.7208 1.90001 11.8999 1.72092 11.8999 1.50001C11.8999 1.27909 11.7208 1.10001 11.4999 1.10001H3.49985ZM4.99995 4.25001C4.99995 3.97387 4.77609 3.75001 4.49995 3.75001C4.22381 3.75001 3.99995 3.97387 3.99995 4.25001V9.55001C3.99995 11.483 5.56695 13.05 7.49995 13.05C9.43295 13.05 11 11.483 11 9.55001V4.25001C11 3.97387 10.7761 3.75001 10.5 3.75001C10.2238 3.75001 9.99995 3.97387 9.99995 4.25001V9.55001C9.99995 10.9307 8.88066 12.05 7.49995 12.05C6.11924 12.05 4.99995 10.9307 4.99995 9.55001V4.25001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPadding(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.85714 2H12.1429C12.6162 2 13 2.38376 13 2.85714V12.1429C13 12.6162 12.6162 13 12.1429 13H2.85714C2.38376 13 2 12.6162 2 12.1429V2.85714C2 2.38376 2.38376 2 2.85714 2ZM1 2.85714C1 1.83147 1.83147 1 2.85714 1H12.1429C13.1685 1 14 1.83147 14 2.85714V12.1429C14 13.1685 13.1685 14 12.1429 14H2.85714C1.83147 14 1 13.1685 1 12.1429V2.85714ZM7.49988 5.00012C7.77602 5.00012 7.99988 4.77626 7.99988 4.50012C7.99988 4.22398 7.77602 4.00012 7.49988 4.00012C7.22374 4.00012 6.99988 4.22398 6.99988 4.50012C6.99988 4.77626 7.22374 5.00012 7.49988 5.00012ZM4.49988 11.0001C4.77602 11.0001 4.99988 10.7763 4.99988 10.5001C4.99988 10.224 4.77602 10.0001 4.49988 10.0001C4.22374 10.0001 3.99988 10.224 3.99988 10.5001C3.99988 10.7763 4.22374 11.0001 4.49988 11.0001ZM4.99988 7.50012C4.99988 7.77626 4.77602 8.00012 4.49988 8.00012C4.22374 8.00012 3.99988 7.77626 3.99988 7.50012C3.99988 7.22398 4.22374 7.00012 4.49988 7.00012C4.77602 7.00012 4.99988 7.22398 4.99988 7.50012ZM4.49988 5.00012C4.77602 5.00012 4.99988 4.77626 4.99988 4.50012C4.99988 4.22398 4.77602 4.00012 4.49988 4.00012C4.22374 4.00012 3.99988 4.22398 3.99988 4.50012C3.99988 4.77626 4.22374 5.00012 4.49988 5.00012ZM10.9999 10.5001C10.9999 10.7763 10.776 11.0001 10.4999 11.0001C10.2237 11.0001 9.99988 10.7763 9.99988 10.5001C9.99988 10.224 10.2237 10.0001 10.4999 10.0001C10.776 10.0001 10.9999 10.224 10.9999 10.5001ZM10.4999 8.00012C10.776 8.00012 10.9999 7.77626 10.9999 7.50012C10.9999 7.22398 10.776 7.00012 10.4999 7.00012C10.2237 7.00012 9.99988 7.22398 9.99988 7.50012C9.99988 7.77626 10.2237 8.00012 10.4999 8.00012ZM10.9999 4.50012C10.9999 4.77626 10.776 5.00012 10.4999 5.00012C10.2237 5.00012 9.99988 4.77626 9.99988 4.50012C9.99988 4.22398 10.2237 4.00012 10.4999 4.00012C10.776 4.00012 10.9999 4.22398 10.9999 4.50012ZM7.49988 11.0001C7.77602 11.0001 7.99988 10.7763 7.99988 10.5001C7.99988 10.224 7.77602 10.0001 7.49988 10.0001C7.22374 10.0001 6.99988 10.224 6.99988 10.5001C6.99988 10.7763 7.22374 11.0001 7.49988 11.0001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPaperPlane(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.20308 1.04312C1.00481 0.954998 0.772341 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568117 1.75196L3.92115 7.50002L0.568117 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.772341 13.9952 1.00481 14.045 1.20308 13.9569L14.7031 7.95693C14.8836 7.87668 15 7.69762 15 7.50002C15 7.30243 14.8836 7.12337 14.7031 7.04312L1.20308 1.04312ZM4.84553 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22092 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22092 7.10002 9 7.10002H4.84553Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPause(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.04995 2.74998C6.04995 2.44623 5.80371 2.19998 5.49995 2.19998C5.19619 2.19998 4.94995 2.44623 4.94995 2.74998V12.25C4.94995 12.5537 5.19619 12.8 5.49995 12.8C5.80371 12.8 6.04995 12.5537 6.04995 12.25V2.74998ZM10.05 2.74998C10.05 2.44623 9.80371 2.19998 9.49995 2.19998C9.19619 2.19998 8.94995 2.44623 8.94995 2.74998V12.25C8.94995 12.5537 9.19619 12.8 9.49995 12.8C9.80371 12.8 10.05 12.5537 10.05 12.25V2.74998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPencil1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1465 1.14645L3.71455 8.57836C3.62459 8.66832 3.55263 8.77461 3.50251 8.89155L2.04044 12.303C1.9599 12.491 2.00189 12.709 2.14646 12.8536C2.29103 12.9981 2.50905 13.0401 2.69697 12.9596L6.10847 11.4975C6.2254 11.4474 6.3317 11.3754 6.42166 11.2855L13.8536 3.85355C14.0488 3.65829 14.0488 3.34171 13.8536 3.14645L11.8536 1.14645ZM4.42166 9.28547L11.5 2.20711L12.7929 3.5L5.71455 10.5784L4.21924 11.2192L3.78081 10.7808L4.42166 9.28547Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPencil2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.1464 1.14645C12.3417 0.951184 12.6583 0.951184 12.8535 1.14645L14.8535 3.14645C15.0488 3.34171 15.0488 3.65829 14.8535 3.85355L10.9109 7.79618C10.8349 7.87218 10.7471 7.93543 10.651 7.9835L6.72359 9.94721C6.53109 10.0435 6.29861 10.0057 6.14643 9.85355C5.99425 9.70137 5.95652 9.46889 6.05277 9.27639L8.01648 5.34897C8.06455 5.25283 8.1278 5.16507 8.2038 5.08907L12.1464 1.14645ZM12.5 2.20711L8.91091 5.79618L7.87266 7.87267L8.12731 8.12732L10.2038 7.08907L13.7929 3.5L12.5 2.20711ZM9.99998 2L8.99998 3H4.9C4.47171 3 4.18056 3.00039 3.95552 3.01877C3.73631 3.03668 3.62421 3.06915 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3.06915 3.62421 3.03669 3.73631 3.01878 3.95552C3.00039 4.18056 3 4.47171 3 4.9V11.1C3 11.5283 3.00039 11.8194 3.01878 12.0445C3.03669 12.2637 3.06915 12.3758 3.10899 12.454C3.20487 12.6422 3.35785 12.7951 3.54601 12.891C3.62421 12.9309 3.73631 12.9633 3.95552 12.9812C4.18056 12.9996 4.47171 13 4.9 13H11.1C11.5283 13 11.8194 12.9996 12.0445 12.9812C12.2637 12.9633 12.3758 12.9309 12.454 12.891C12.6422 12.7951 12.7951 12.6422 12.891 12.454C12.9309 12.3758 12.9633 12.2637 12.9812 12.0445C12.9996 11.8194 13 11.5283 13 11.1V6.99998L14 5.99998V11.1V11.1207C14 11.5231 14 11.8553 13.9779 12.1259C13.9549 12.407 13.9057 12.6653 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.6653 13.9057 12.407 13.9549 12.1259 13.9779C11.8553 14 11.5231 14 11.1207 14H11.1H4.9H4.87934C4.47686 14 4.14468 14 3.87409 13.9779C3.59304 13.9549 3.33469 13.9057 3.09202 13.782C2.7157 13.5903 2.40973 13.2843 2.21799 12.908C2.09434 12.6653 2.04506 12.407 2.0221 12.1259C1.99999 11.8553 1.99999 11.5231 2 11.1207V11.1206V11.1V4.9V4.87935V4.87932V4.87931C1.99999 4.47685 1.99999 4.14468 2.0221 3.87409C2.04506 3.59304 2.09434 3.33469 2.21799 3.09202C2.40973 2.71569 2.7157 2.40973 3.09202 2.21799C3.33469 2.09434 3.59304 2.04506 3.87409 2.0221C4.14468 1.99999 4.47685 1.99999 4.87932 2H4.87935H4.9H9.99998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPerson(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 0.875C5.49797 0.875 3.875 2.49797 3.875 4.5C3.875 6.15288 4.98124 7.54738 6.49373 7.98351C5.2997 8.12901 4.27557 8.55134 3.50407 9.31167C2.52216 10.2794 2.02502 11.72 2.02502 13.5999C2.02502 13.8623 2.23769 14.0749 2.50002 14.0749C2.76236 14.0749 2.97502 13.8623 2.97502 13.5999C2.97502 11.8799 3.42786 10.7206 4.17091 9.9883C4.91536 9.25463 6.02674 8.87499 7.49995 8.87499C8.97317 8.87499 10.0846 9.25463 10.8291 9.98831C11.5721 10.7206 12.025 11.8799 12.025 13.5999C12.025 13.8623 12.2376 14.0749 12.5 14.0749C12.7623 14.075 12.975 13.8623 12.975 13.6C12.975 11.72 12.4778 10.2794 11.4959 9.31166C10.7244 8.55135 9.70025 8.12903 8.50625 7.98352C10.0187 7.5474 11.125 6.15289 11.125 4.5C11.125 2.49797 9.50203 0.875 7.5 0.875ZM4.825 4.5C4.825 3.02264 6.02264 1.825 7.5 1.825C8.97736 1.825 10.175 3.02264 10.175 4.5C10.175 5.97736 8.97736 7.175 7.5 7.175C6.02264 7.175 4.825 5.97736 4.825 4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPieChart(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.85001 7.50043C1.85001 4.37975 4.37963 1.85001 7.50001 1.85001C10.6204 1.85001 13.15 4.37975 13.15 7.50043C13.15 10.6211 10.6204 13.1509 7.50001 13.1509C4.37963 13.1509 1.85001 10.6211 1.85001 7.50043ZM7.50001 0.850006C3.82728 0.850006 0.850006 3.82753 0.850006 7.50043C0.850006 11.1733 3.82728 14.1509 7.50001 14.1509C11.1727 14.1509 14.15 11.1733 14.15 7.50043C14.15 3.82753 11.1727 0.850006 7.50001 0.850006ZM7.00001 8.00001V3.12811C7.16411 3.10954 7.33094 3.10001 7.50001 3.10001C9.93006 3.10001 11.9 5.07014 11.9 7.50043C11.9 7.66935 11.8905 7.83604 11.872 8.00001H7.00001Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPilcrow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3 5.5C3 7.983 4.99169 9 7 9V12.5C7 12.7761 7.22386 13 7.5 13C7.77614 13 8 12.7761 8 12.5V9V3.1H9V12.5C9 12.7761 9.22386 13 9.5 13C9.77614 13 10 12.7761 10 12.5V3.1H11.5C11.8038 3.1 12.05 2.85376 12.05 2.55C12.05 2.24624 11.8038 2 11.5 2H9.5H8H7.5H7C4.99169 2 3 3.017 3 5.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPinBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.5 13.95C13.7485 13.95 13.95 13.7485 13.95 13.5C13.95 13.2514 13.7485 13.05 13.5 13.05L1.49995 13.05C1.25142 13.05 1.04995 13.2514 1.04995 13.5C1.04995 13.7485 1.25142 13.95 1.49995 13.95L13.5 13.95ZM11.0681 7.5683C11.2439 7.39257 11.2439 7.10764 11.0681 6.93191C10.8924 6.75617 10.6075 6.75617 10.4317 6.93191L7.94993 9.41371L7.94993 1.49998C7.94993 1.25146 7.74846 1.04998 7.49993 1.04998C7.2514 1.04998 7.04993 1.25146 7.04993 1.49998L7.04993 9.41371L4.56813 6.93191C4.39239 6.75617 4.10746 6.75617 3.93173 6.93191C3.75599 7.10764 3.75599 7.39257 3.93173 7.5683L7.18173 10.8183C7.35746 10.994 7.64239 10.994 7.81812 10.8183L11.0681 7.5683Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPinLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.05005 13.5C2.05005 13.7485 2.25152 13.95 2.50005 13.95C2.74858 13.95 2.95005 13.7485 2.95005 13.5L2.95005 1.49995C2.95005 1.25142 2.74858 1.04995 2.50005 1.04995C2.25152 1.04995 2.05005 1.25142 2.05005 1.49995L2.05005 13.5ZM8.4317 11.0681C8.60743 11.2439 8.89236 11.2439 9.06809 11.0681C9.24383 10.8924 9.24383 10.6075 9.06809 10.4317L6.58629 7.94993L14.5 7.94993C14.7485 7.94993 14.95 7.74846 14.95 7.49993C14.95 7.2514 14.7485 7.04993 14.5 7.04993L6.58629 7.04993L9.06809 4.56813C9.24383 4.39239 9.24383 4.10746 9.06809 3.93173C8.89236 3.75599 8.60743 3.75599 8.4317 3.93173L5.1817 7.18173C5.00596 7.35746 5.00596 7.64239 5.1817 7.81812L8.4317 11.0681Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPinRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.95 1.50005C12.95 1.25152 12.7485 1.05005 12.5 1.05005C12.2514 1.05005 12.05 1.25152 12.05 1.50005L12.05 13.5C12.05 13.7486 12.2514 13.95 12.5 13.95C12.7485 13.95 12.95 13.7486 12.95 13.5L12.95 1.50005ZM6.5683 3.93188C6.39257 3.75614 6.10764 3.75614 5.93191 3.93188C5.75617 4.10761 5.75617 4.39254 5.93191 4.56827L8.41371 7.05007L0.499984 7.05007C0.251456 7.05007 0.0499847 7.25155 0.0499847 7.50007C0.0499846 7.7486 0.251457 7.95007 0.499984 7.95007L8.41371 7.95007L5.93191 10.4319C5.75617 10.6076 5.75617 10.8925 5.93191 11.0683C6.10764 11.244 6.39257 11.244 6.56831 11.0683L9.8183 7.81827C9.99404 7.64254 9.99404 7.35761 9.8183 7.18188L6.5683 3.93188Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPinTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.50005 1.05005C1.25152 1.05005 1.05005 1.25152 1.05005 1.50005C1.05005 1.74858 1.25152 1.95005 1.50005 1.95005L13.5 1.95005C13.7486 1.95005 13.95 1.74858 13.95 1.50005C13.95 1.25152 13.7486 1.05005 13.5 1.05005H1.50005ZM3.93188 7.43169C3.75614 7.60743 3.75614 7.89236 3.93188 8.06809C4.10761 8.24383 4.39254 8.24383 4.56827 8.06809L7.05007 5.58629V13.5C7.05007 13.7485 7.25155 13.95 7.50007 13.95C7.7486 13.95 7.95007 13.7485 7.95007 13.5L7.95007 5.58629L10.4319 8.06809C10.6076 8.24383 10.8925 8.24383 11.0683 8.06809C11.244 7.89235 11.244 7.60743 11.0683 7.43169L7.81827 4.18169C7.64254 4.00596 7.35761 4.00596 7.18188 4.18169L3.93188 7.43169Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPlay(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.24182 2.32181C3.3919 2.23132 3.5784 2.22601 3.73338 2.30781L12.7334 7.05781C12.8974 7.14436 13 7.31457 13 7.5C13 7.68543 12.8974 7.85564 12.7334 7.94219L3.73338 12.6922C3.5784 12.774 3.3919 12.7687 3.24182 12.6782C3.09175 12.5877 3 12.4252 3 12.25V2.75C3 2.57476 3.09175 2.4123 3.24182 2.32181ZM4 3.57925V11.4207L11.4288 7.5L4 3.57925Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPlusCircled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM7.50003 4C7.77617 4 8.00003 4.22386 8.00003 4.5V7H10.5C10.7762 7 11 7.22386 11 7.5C11 7.77614 10.7762 8 10.5 8H8.00003V10.5C8.00003 10.7761 7.77617 11 7.50003 11C7.22389 11 7.00003 10.7761 7.00003 10.5V8H4.50003C4.22389 8 4.00003 7.77614 4.00003 7.5C4.00003 7.22386 4.22389 7 4.50003 7H7.00003V4.5C7.00003 4.22386 7.22389 4 7.50003 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxPlus(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxQuestionMarkCircled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49972C0.877075 3.84204 3.84222 0.876892 7.49991 0.876892C11.1576 0.876892 14.1227 3.84204 14.1227 7.49972C14.1227 11.1574 11.1576 14.1226 7.49991 14.1226C3.84222 14.1226 0.877075 11.1574 0.877075 7.49972ZM7.49991 1.82689C4.36689 1.82689 1.82708 4.36671 1.82708 7.49972C1.82708 10.6327 4.36689 13.1726 7.49991 13.1726C10.6329 13.1726 13.1727 10.6327 13.1727 7.49972C13.1727 4.36671 10.6329 1.82689 7.49991 1.82689ZM8.24993 10.5C8.24993 10.9142 7.91414 11.25 7.49993 11.25C7.08571 11.25 6.74993 10.9142 6.74993 10.5C6.74993 10.0858 7.08571 9.75 7.49993 9.75C7.91414 9.75 8.24993 10.0858 8.24993 10.5ZM6.05003 6.25C6.05003 5.57211 6.63511 4.925 7.50003 4.925C8.36496 4.925 8.95003 5.57211 8.95003 6.25C8.95003 6.74118 8.68002 6.99212 8.21447 7.27494C8.16251 7.30651 8.10258 7.34131 8.03847 7.37854L8.03841 7.37858C7.85521 7.48497 7.63788 7.61119 7.47449 7.73849C7.23214 7.92732 6.95003 8.23198 6.95003 8.7C6.95004 9.00376 7.19628 9.25 7.50004 9.25C7.8024 9.25 8.04778 9.00601 8.05002 8.70417L8.05056 8.7033C8.05924 8.6896 8.08493 8.65735 8.15058 8.6062C8.25207 8.52712 8.36508 8.46163 8.51567 8.37436L8.51571 8.37433C8.59422 8.32883 8.68296 8.27741 8.78559 8.21506C9.32004 7.89038 10.05 7.35382 10.05 6.25C10.05 4.92789 8.93511 3.825 7.50003 3.825C6.06496 3.825 4.95003 4.92789 4.95003 6.25C4.95003 6.55376 5.19628 6.8 5.50003 6.8C5.80379 6.8 6.05003 6.55376 6.05003 6.25Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxQuestionMark(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.07505 4.10001C5.07505 2.91103 6.25727 1.92502 7.50005 1.92502C8.74283 1.92502 9.92505 2.91103 9.92505 4.10001C9.92505 5.19861 9.36782 5.71436 8.61854 6.37884L8.58757 6.4063C7.84481 7.06467 6.92505 7.87995 6.92505 9.5C6.92505 9.81757 7.18248 10.075 7.50005 10.075C7.81761 10.075 8.07505 9.81757 8.07505 9.5C8.07505 8.41517 8.62945 7.90623 9.38156 7.23925L9.40238 7.22079C10.1496 6.55829 11.075 5.73775 11.075 4.10001C11.075 2.12757 9.21869 0.775024 7.50005 0.775024C5.7814 0.775024 3.92505 2.12757 3.92505 4.10001C3.92505 4.41758 4.18249 4.67501 4.50005 4.67501C4.81761 4.67501 5.07505 4.41758 5.07505 4.10001ZM7.50005 13.3575C7.9833 13.3575 8.37505 12.9657 8.37505 12.4825C8.37505 11.9992 7.9833 11.6075 7.50005 11.6075C7.0168 11.6075 6.62505 11.9992 6.62505 12.4825C6.62505 12.9657 7.0168 13.3575 7.50005 13.3575Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxQuote(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRadiobutton(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 11.1575 3.84216 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 3.84219 11.1575 0.877045 7.49985 0.877045ZM1.82701 7.49988C1.82701 4.36686 4.36683 1.82704 7.49985 1.82704C10.6328 1.82704 13.1727 4.36686 13.1727 7.49988C13.1727 10.6329 10.6328 13.1727 7.49985 13.1727C4.36683 13.1727 1.82701 10.6329 1.82701 7.49988ZM7.49999 9.49999C8.60456 9.49999 9.49999 8.60456 9.49999 7.49999C9.49999 6.39542 8.60456 5.49999 7.49999 5.49999C6.39542 5.49999 5.49999 6.39542 5.49999 7.49999C5.49999 8.60456 6.39542 9.49999 7.49999 9.49999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxReader(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.2 1H4.17741H4.1774C3.86936 0.999988 3.60368 0.999978 3.38609 1.02067C3.15576 1.04257 2.92825 1.09113 2.71625 1.22104C2.51442 1.34472 2.34473 1.51442 2.22104 1.71625C2.09113 1.92825 2.04257 2.15576 2.02067 2.38609C1.99998 2.60367 1.99999 2.86935 2 3.17738V3.1774V3.2V11.8V11.8226V11.8226C1.99999 12.1307 1.99998 12.3963 2.02067 12.6139C2.04257 12.8442 2.09113 13.0717 2.22104 13.2837C2.34473 13.4856 2.51442 13.6553 2.71625 13.779C2.92825 13.9089 3.15576 13.9574 3.38609 13.9793C3.60368 14 3.86937 14 4.17741 14H4.2H10.8H10.8226C11.1306 14 11.3963 14 11.6139 13.9793C11.8442 13.9574 12.0717 13.9089 12.2837 13.779C12.4856 13.6553 12.6553 13.4856 12.779 13.2837C12.9089 13.0717 12.9574 12.8442 12.9793 12.6139C13 12.3963 13 12.1306 13 11.8226V11.8V3.2V3.17741C13 2.86936 13 2.60368 12.9793 2.38609C12.9574 2.15576 12.9089 1.92825 12.779 1.71625C12.6553 1.51442 12.4856 1.34472 12.2837 1.22104C12.0717 1.09113 11.8442 1.04257 11.6139 1.02067C11.3963 0.999978 11.1306 0.999988 10.8226 1H10.8H4.2ZM3.23875 2.07368C3.26722 2.05623 3.32362 2.03112 3.48075 2.01618C3.64532 2.00053 3.86298 2 4.2 2H10.8C11.137 2 11.3547 2.00053 11.5193 2.01618C11.6764 2.03112 11.7328 2.05623 11.7613 2.07368C11.8285 2.11491 11.8851 2.17147 11.9263 2.23875C11.9438 2.26722 11.9689 2.32362 11.9838 2.48075C11.9995 2.64532 12 2.86298 12 3.2V11.8C12 12.137 11.9995 12.3547 11.9838 12.5193C11.9689 12.6764 11.9438 12.7328 11.9263 12.7613C11.8851 12.8285 11.8285 12.8851 11.7613 12.9263C11.7328 12.9438 11.6764 12.9689 11.5193 12.9838C11.3547 12.9995 11.137 13 10.8 13H4.2C3.86298 13 3.64532 12.9995 3.48075 12.9838C3.32362 12.9689 3.26722 12.9438 3.23875 12.9263C3.17147 12.8851 3.11491 12.8285 3.07368 12.7613C3.05624 12.7328 3.03112 12.6764 3.01618 12.5193C3.00053 12.3547 3 12.137 3 11.8V3.2C3 2.86298 3.00053 2.64532 3.01618 2.48075C3.03112 2.32362 3.05624 2.26722 3.07368 2.23875C3.11491 2.17147 3.17147 2.11491 3.23875 2.07368ZM5 10C4.72386 10 4.5 10.2239 4.5 10.5C4.5 10.7761 4.72386 11 5 11H8C8.27614 11 8.5 10.7761 8.5 10.5C8.5 10.2239 8.27614 10 8 10H5ZM4.5 7.5C4.5 7.22386 4.72386 7 5 7H10C10.2761 7 10.5 7.22386 10.5 7.5C10.5 7.77614 10.2761 8 10 8H5C4.72386 8 4.5 7.77614 4.5 7.5ZM5 4C4.72386 4 4.5 4.22386 4.5 4.5C4.5 4.77614 4.72386 5 5 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxReload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.84998 7.49998C1.84998 4.66458 4.05979 1.84998 7.49998 1.84998C10.2783 1.84998 11.6515 3.9064 12.2367 5H10.5C10.2239 5 10 5.22386 10 5.5C10 5.77614 10.2239 6 10.5 6H13.5C13.7761 6 14 5.77614 14 5.5V2.5C14 2.22386 13.7761 2 13.5 2C13.2239 2 13 2.22386 13 2.5V4.31318C12.2955 3.07126 10.6659 0.849976 7.49998 0.849976C3.43716 0.849976 0.849976 4.18537 0.849976 7.49998C0.849976 10.8146 3.43716 14.15 7.49998 14.15C9.44382 14.15 11.0622 13.3808 12.2145 12.2084C12.8315 11.5806 13.3133 10.839 13.6418 10.0407C13.7469 9.78536 13.6251 9.49315 13.3698 9.38806C13.1144 9.28296 12.8222 9.40478 12.7171 9.66014C12.4363 10.3425 12.0251 10.9745 11.5013 11.5074C10.5295 12.4963 9.16504 13.15 7.49998 13.15C4.05979 13.15 1.84998 10.3354 1.84998 7.49998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxReset(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.85355 2.14645C5.04882 2.34171 5.04882 2.65829 4.85355 2.85355L3.70711 4H9C11.4853 4 13.5 6.01472 13.5 8.5C13.5 10.9853 11.4853 13 9 13H5C4.72386 13 4.5 12.7761 4.5 12.5C4.5 12.2239 4.72386 12 5 12H9C10.933 12 12.5 10.433 12.5 8.5C12.5 6.567 10.933 5 9 5H3.70711L4.85355 6.14645C5.04882 6.34171 5.04882 6.65829 4.85355 6.85355C4.65829 7.04882 4.34171 7.04882 4.14645 6.85355L2.14645 4.85355C1.95118 4.65829 1.95118 4.34171 2.14645 4.14645L4.14645 2.14645C4.34171 1.95118 4.65829 1.95118 4.85355 2.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxResume(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.04995 2.74995C3.04995 2.44619 2.80371 2.19995 2.49995 2.19995C2.19619 2.19995 1.94995 2.44619 1.94995 2.74995V12.25C1.94995 12.5537 2.19619 12.8 2.49995 12.8C2.80371 12.8 3.04995 12.5537 3.04995 12.25V2.74995ZM5.73333 2.30776C5.57835 2.22596 5.39185 2.23127 5.24177 2.32176C5.0917 2.41225 4.99995 2.57471 4.99995 2.74995V12.25C4.99995 12.4252 5.0917 12.5877 5.24177 12.6781C5.39185 12.7686 5.57835 12.7739 5.73333 12.6921L14.7333 7.94214C14.8973 7.85559 15 7.68539 15 7.49995C15 7.31452 14.8973 7.14431 14.7333 7.05776L5.73333 2.30776ZM5.99995 11.4207V3.5792L13.4287 7.49995L5.99995 11.4207Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRocket(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.85357 3.85355L7.65355 3.05353C8.2981 2.40901 9.42858 1.96172 10.552 1.80125C11.1056 1.72217 11.6291 1.71725 12.0564 1.78124C12.4987 1.84748 12.7698 1.97696 12.8965 2.10357C13.0231 2.23018 13.1526 2.50125 13.2188 2.94357C13.2828 3.37086 13.2779 3.89439 13.1988 4.44801C13.0383 5.57139 12.591 6.70188 11.9464 7.34645L7.49999 11.7929L6.35354 10.6465C6.15827 10.4512 5.84169 10.4512 5.64643 10.6465C5.45117 10.8417 5.45117 11.1583 5.64643 11.3536L7.14644 12.8536C7.34171 13.0488 7.65829 13.0488 7.85355 12.8536L8.40073 12.3064L9.57124 14.2572C9.65046 14.3893 9.78608 14.4774 9.9389 14.4963C10.0917 14.5151 10.2447 14.4624 10.3535 14.3536L12.3535 12.3536C12.4648 12.2423 12.5172 12.0851 12.495 11.9293L12.0303 8.67679L12.6536 8.05355C13.509 7.19808 14.0117 5.82855 14.1887 4.58943C14.2784 3.9618 14.2891 3.33847 14.2078 2.79546C14.1287 2.26748 13.9519 1.74482 13.6035 1.39645C13.2552 1.04809 12.7325 0.871332 12.2045 0.792264C11.6615 0.710945 11.0382 0.721644 10.4105 0.8113C9.17143 0.988306 7.80189 1.491 6.94644 2.34642L6.32322 2.96968L3.07071 2.50504C2.91492 2.48278 2.75773 2.53517 2.64645 2.64646L0.646451 4.64645C0.537579 4.75533 0.484938 4.90829 0.50375 5.0611C0.522563 5.21391 0.61073 5.34954 0.742757 5.42876L2.69364 6.59928L2.14646 7.14645C2.0527 7.24022 2.00002 7.3674 2.00002 7.50001C2.00002 7.63261 2.0527 7.75979 2.14646 7.85356L3.64647 9.35356C3.84173 9.54883 4.15831 9.54883 4.35357 9.35356C4.54884 9.1583 4.54884 8.84172 4.35357 8.64646L3.20712 7.50001L3.85357 6.85356L6.85357 3.85355ZM10.0993 13.1936L9.12959 11.5775L11.1464 9.56067L11.4697 11.8232L10.0993 13.1936ZM3.42251 5.87041L5.43935 3.85356L3.17678 3.53034L1.80638 4.90074L3.42251 5.87041ZM2.35356 10.3535C2.54882 10.1583 2.54882 9.8417 2.35356 9.64644C2.1583 9.45118 1.84171 9.45118 1.64645 9.64644L0.646451 10.6464C0.451188 10.8417 0.451188 11.1583 0.646451 11.3535C0.841713 11.5488 1.1583 11.5488 1.35356 11.3535L2.35356 10.3535ZM3.85358 11.8536C4.04884 11.6583 4.04885 11.3417 3.85359 11.1465C3.65833 10.9512 3.34175 10.9512 3.14648 11.1465L1.14645 13.1464C0.95119 13.3417 0.951187 13.6583 1.14645 13.8535C1.34171 14.0488 1.65829 14.0488 1.85355 13.8536L3.85358 11.8536ZM5.35356 13.3535C5.54882 13.1583 5.54882 12.8417 5.35356 12.6464C5.1583 12.4512 4.84171 12.4512 4.64645 12.6464L3.64645 13.6464C3.45119 13.8417 3.45119 14.1583 3.64645 14.3535C3.84171 14.5488 4.1583 14.5488 4.35356 14.3535L5.35356 13.3535ZM9.49997 6.74881C10.1897 6.74881 10.7488 6.1897 10.7488 5.5C10.7488 4.8103 10.1897 4.25118 9.49997 4.25118C8.81026 4.25118 8.25115 4.8103 8.25115 5.5C8.25115 6.1897 8.81026 6.74881 9.49997 6.74881Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRotateCounterClockwise(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.59664 2.93628C7.76085 3.06401 8.00012 2.94698 8.00012 2.73895V1.99998C9.98143 2 11.1848 2.3637 11.9105 3.08945C12.6363 3.81522 13 5.0186 13 6.99998C13 7.27613 13.2239 7.49998 13.5 7.49998C13.7761 7.49998 14 7.27613 14 6.99998C14 4.9438 13.6325 3.39719 12.6176 2.38234C11.6028 1.36752 10.0562 0.999999 8.00012 0.999984V0.261266C8.00012 0.0532293 7.76085 -0.0637944 7.59664 0.063928L6.00384 1.30277C5.87516 1.40286 5.87516 1.59735 6.00384 1.69744L7.59664 2.93628ZM9.5 5H2.5C2.22386 5 2 5.22386 2 5.5V12.5C2 12.7761 2.22386 13 2.5 13H9.5C9.77614 13 10 12.7761 10 12.5V5.5C10 5.22386 9.77614 5 9.5 5ZM2.5 4C1.67157 4 1 4.67157 1 5.5V12.5C1 13.3284 1.67157 14 2.5 14H9.5C10.3284 14 11 13.3284 11 12.5V5.5C11 4.67157 10.3284 4 9.5 4H2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRowSpacing(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.81832 0.68179C7.64258 0.506054 7.35766 0.506054 7.18192 0.68179L5.18192 2.68179C5.00619 2.85753 5.00619 3.14245 5.18192 3.31819C5.35766 3.49392 5.64258 3.49392 5.81832 3.31819L7.05012 2.08638L7.05012 5.50023C7.05012 5.74876 7.25159 5.95023 7.50012 5.95023C7.74865 5.95023 7.95012 5.74876 7.95012 5.50023L7.95012 2.08638L9.18192 3.31819C9.35766 3.49392 9.64258 3.49392 9.81832 3.31819C9.99406 3.14245 9.99406 2.85753 9.81832 2.68179L7.81832 0.68179ZM7.95012 12.9136V9.50023C7.95012 9.2517 7.74865 9.05023 7.50012 9.05023C7.25159 9.05023 7.05012 9.2517 7.05012 9.50023V12.9136L5.81832 11.6818C5.64258 11.5061 5.35766 11.5061 5.18192 11.6818C5.00619 11.8575 5.00619 12.1424 5.18192 12.3182L7.18192 14.3182C7.26632 14.4026 7.38077 14.45 7.50012 14.45C7.61947 14.45 7.73393 14.4026 7.81832 14.3182L9.81832 12.3182C9.99406 12.1424 9.99406 11.8575 9.81832 11.6818C9.64258 11.5061 9.35766 11.5061 9.18192 11.6818L7.95012 12.9136ZM1.49994 7.00017C1.2238 7.00017 0.999939 7.22403 0.999939 7.50017C0.999939 7.77631 1.2238 8.00017 1.49994 8.00017L13.4999 8.00017C13.7761 8.00017 13.9999 7.77631 13.9999 7.50017C13.9999 7.22403 13.7761 7.00017 13.4999 7.00017L1.49994 7.00017Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRows(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 12.85L1 12.85L1 14.15L14 14.15L14 12.85ZM14 8.85002L1 8.85002L1 10.15L14 10.15L14 8.85002ZM1 4.85003L14 4.85003L14 6.15003L1 6.15002L1 4.85003ZM14 0.850025L1 0.850025L1 2.15002L14 2.15002L14 0.850025Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRulerHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.5 4C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H14.5C14.7761 11 15 10.7761 15 10.5V4.5C15 4.22386 14.7761 4 14.5 4H0.5ZM1 10V5H2.075V7.5C2.075 7.73472 2.26528 7.925 2.5 7.925C2.73472 7.925 2.925 7.73472 2.925 7.5V5H4.075V6.5C4.075 6.73472 4.26528 6.925 4.5 6.925C4.73472 6.925 4.925 6.73472 4.925 6.5V5H6.075V6.5C6.075 6.73472 6.26528 6.925 6.5 6.925C6.73472 6.925 6.925 6.73472 6.925 6.5V5H8.075V7.5C8.075 7.73472 8.26528 7.925 8.5 7.925C8.73472 7.925 8.925 7.73472 8.925 7.5V5H10.075V6.5C10.075 6.73472 10.2653 6.925 10.5 6.925C10.7347 6.925 10.925 6.73472 10.925 6.5V5H12.075V6.5C12.075 6.73472 12.2653 6.925 12.5 6.925C12.7347 6.925 12.925 6.73472 12.925 6.5V5H14V10H1Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxRulerSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.5 0C0.223858 0 0 0.223858 0 0.5V14.5C0 14.7761 0.223858 15 0.5 15H4.5C4.77614 15 5 14.7761 5 14.5V5H14.5C14.7761 5 15 4.77614 15 4.5V0.5C15 0.223858 14.7761 0 14.5 0H0.5ZM1 4.07505L1 1H4.07502C4.07502 1 4.07502 1 4.07502 1L4.07505 4.07507L1 4.07505ZM0.999997 4.92505L1 14H4V12.925H2.75002C2.5153 12.925 2.32502 12.7348 2.32502 12.5C2.32502 12.2653 2.5153 12.075 2.75002 12.075H4V10.925H2.25002C2.0153 10.925 1.82502 10.7347 1.82502 10.5C1.82502 10.2653 2.0153 10.075 2.25002 10.075H4V8.92504L2.75002 8.92502C2.5153 8.92502 2.32502 8.73474 2.32502 8.50002C2.32503 8.26529 2.51531 8.07502 2.75003 8.07502L4 8.07504V6.92502L2.74999 6.925C2.51527 6.925 2.325 6.73472 2.325 6.5C2.325 6.26528 2.51529 6.075 2.75001 6.075L4 6.07502V4.92507L0.999997 4.92505ZM4.92505 4H6.075V2.75006C6.075 2.51534 6.26528 2.32506 6.5 2.32506C6.73472 2.32506 6.925 2.51534 6.925 2.75006V4H8.07502V2.75005C8.07502 2.51533 8.2653 2.32505 8.50002 2.32505C8.73474 2.32505 8.92502 2.51533 8.92502 2.75005V4H10.0751V2.25005C10.0751 2.01533 10.2653 1.82505 10.5001 1.82505C10.7348 1.82505 10.9251 2.01533 10.9251 2.25005V4H12.0751V2.75005C12.0751 2.51533 12.2654 2.32505 12.5001 2.32505C12.7348 2.32505 12.9251 2.51533 12.9251 2.75005V4H14V1H4.92502L4.92505 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxScissors(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.949988 4.48455C0.949988 5.34059 1.64395 6.03455 2.49999 6.03455C3.35603 6.03455 4.04999 5.34059 4.04999 4.48455C4.04999 3.6285 3.35603 2.93455 2.49999 2.93455C1.64395 2.93455 0.949988 3.6285 0.949988 4.48455ZM2.49999 6.93455C1.14689 6.93455 0.0499878 5.83764 0.0499878 4.48455C0.0499878 3.13145 1.14689 2.03455 2.49999 2.03455C3.85309 2.03455 4.94999 3.13145 4.94999 4.48455C4.94999 4.80813 4.88726 5.11707 4.77329 5.39985L5.73655 6.04413C5.72943 6.06656 5.72269 6.08914 5.71635 6.11188L5.56288 6.66186L5.21005 6.89773L4.21554 6.23366C3.77357 6.6672 3.168 6.93455 2.49999 6.93455ZM0.949991 10.5C0.949991 9.64394 1.64395 8.94998 2.49999 8.94998C3.35603 8.94998 4.04999 9.64394 4.04999 10.5C4.04999 11.356 3.35603 12.05 2.49999 12.05C1.64395 12.05 0.949991 11.356 0.949991 10.5ZM2.49999 8.04998C1.14689 8.04998 0.0499908 9.14688 0.0499908 10.5C0.0499908 11.8531 1.14689 12.95 2.49999 12.95C3.85309 12.95 4.94999 11.8531 4.94999 10.5C4.94999 10.1803 4.88877 9.87497 4.77743 9.595L15 2.75737L14.0486 2.85737C12.7077 2.9983 11.4091 3.40895 10.231 4.06461L7.15646 5.77564C6.92307 5.90553 6.75134 6.12339 6.67955 6.38066L6.42653 7.28737L4.22437 8.75957C3.78166 8.32091 3.17246 8.04998 2.49999 8.04998ZM7.14435 9.2149L7.15646 9.22176L10.231 10.9328C11.4091 11.5884 12.7077 11.9991 14.0486 12.14L15 12.24L8.81072 8.1003L7.14435 9.2149Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSection(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 1.5C2 1.77614 1.77614 2 1.5 2C1.22386 2 1 1.77614 1 1.5C1 1.22386 1.22386 1 1.5 1C1.77614 1 2 1.22386 2 1.5ZM2 5L2 10H13V5H2ZM2 4C1.44772 4 1 4.44772 1 5V10C1 10.5523 1.44772 11 2 11H13C13.5523 11 14 10.5523 14 10V5C14 4.44772 13.5523 4 13 4H2ZM1.5 14C1.77614 14 2 13.7761 2 13.5C2 13.2239 1.77614 13 1.5 13C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14ZM4 1.5C4 1.77614 3.77614 2 3.5 2C3.22386 2 3 1.77614 3 1.5C3 1.22386 3.22386 1 3.5 1C3.77614 1 4 1.22386 4 1.5ZM3.5 14C3.77614 14 4 13.7761 4 13.5C4 13.2239 3.77614 13 3.5 13C3.22386 13 3 13.2239 3 13.5C3 13.7761 3.22386 14 3.5 14ZM6 1.5C6 1.77614 5.77614 2 5.5 2C5.22386 2 5 1.77614 5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5ZM5.5 14C5.77614 14 6 13.7761 6 13.5C6 13.2239 5.77614 13 5.5 13C5.22386 13 5 13.2239 5 13.5C5 13.7761 5.22386 14 5.5 14ZM8 1.5C8 1.77614 7.77614 2 7.5 2C7.22386 2 7 1.77614 7 1.5C7 1.22386 7.22386 1 7.5 1C7.77614 1 8 1.22386 8 1.5ZM7.5 14C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5C7 13.7761 7.22386 14 7.5 14ZM10 1.5C10 1.77614 9.77614 2 9.5 2C9.22386 2 9 1.77614 9 1.5C9 1.22386 9.22386 1 9.5 1C9.77614 1 10 1.22386 10 1.5ZM9.5 14C9.77614 14 10 13.7761 10 13.5C10 13.2239 9.77614 13 9.5 13C9.22386 13 9 13.2239 9 13.5C9 13.7761 9.22386 14 9.5 14ZM12 1.5C12 1.77614 11.7761 2 11.5 2C11.2239 2 11 1.77614 11 1.5C11 1.22386 11.2239 1 11.5 1C11.7761 1 12 1.22386 12 1.5ZM11.5 14C11.7761 14 12 13.7761 12 13.5C12 13.2239 11.7761 13 11.5 13C11.2239 13 11 13.2239 11 13.5C11 13.7761 11.2239 14 11.5 14ZM14 1.5C14 1.77614 13.7761 2 13.5 2C13.2239 2 13 1.77614 13 1.5C13 1.22386 13.2239 1 13.5 1C13.7761 1 14 1.22386 14 1.5ZM13.5 14C13.7761 14 14 13.7761 14 13.5C14 13.2239 13.7761 13 13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSewingPinFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10 3.5C10 4.70948 9.14112 5.71836 8 5.94999V13.5C8 13.7761 7.77614 14 7.5 14C7.22386 14 7 13.7761 7 13.5V5.94999C5.85888 5.71836 5 4.70948 5 3.5C5 2.11929 6.11929 1 7.5 1C8.88071 1 10 2.11929 10 3.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSewingPin(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6 3.5C6 2.67157 6.67157 2 7.5 2C8.32843 2 9 2.67157 9 3.5C9 4.32843 8.32843 5 7.5 5C6.67157 5 6 4.32843 6 3.5ZM8 5.94999C9.14112 5.71836 10 4.70948 10 3.5C10 2.11929 8.88071 1 7.5 1C6.11929 1 5 2.11929 5 3.5C5 4.70948 5.85888 5.71836 7 5.94999V13.5C7 13.7761 7.22386 14 7.5 14C7.77614 14 8 13.7761 8 13.5V5.94999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShadowInner(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": ".05",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.1619 3.85182C8.35817 4.88918 4.88936 8.358 3.85199 12.1617L3.3696 12.0301C4.45356 8.05564 8.05581 4.45339 12.0303 3.36943L12.1619 3.85182Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".1",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.8807 3.42707C8.03441 4.50542 4.50561 8.03422 3.42726 11.8805L2.94582 11.7456C4.07129 7.73121 7.7314 4.0711 11.7458 2.94563L11.8807 3.42707Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".15",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.5201 3.02556C7.69092 4.16199 4.16779 7.68323 3.02805 11.512L2.54883 11.3694C3.73676 7.37869 7.38659 3.73076 11.3778 2.54623L11.5201 3.02556Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".2",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.0468 2.66169C7.31117 3.87664 3.87918 7.3079 2.66298 11.0434L2.18754 10.8886C3.45324 7.00109 7.00445 3.45062 10.8921 2.18621L11.0468 2.66169Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".25",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.5201 2.32365C6.92091 3.61447 3.62391 6.90876 2.32845 10.5073L1.858 10.338C3.20398 6.59909 6.61155 3.19424 10.3513 1.85301L10.5201 2.32365Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".3",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.90222 2.03122C6.50003 3.39465 3.39968 6.49367 2.03399 9.89551L1.56998 9.70924C2.98651 6.18076 6.18728 2.98133 9.71622 1.5671L9.90222 2.03122Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".35",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.20727 1.78873C6.06136 3.20349 3.21103 6.05203 1.79331 9.19738L1.33747 8.99192C2.80536 5.73528 5.74485 2.7976 9.0022 1.33272L9.20727 1.78873Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".4",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.40713 1.62085C5.59323 3.05117 3.05794 5.58509 1.62544 8.39847L1.17987 8.1716C2.66036 5.26397 5.27232 2.6534 8.18057 1.17513L8.40713 1.62085Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".45",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.46207 1.56747C5.08689 2.94695 2.95362 5.07912 1.57249 7.45379L1.14028 7.20241C2.56503 4.75273 4.7607 2.55818 7.21096 1.1351L7.46207 1.56747Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".5",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.30407 1.70487C4.51964 2.91063 2.90983 4.52061 1.7043 6.30513L1.28998 6.02524C2.5313 4.18773 4.18673 2.53214 6.02413 1.29059L6.30407 1.70487Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShadowNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": ".05",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".1",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".15",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".2",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".25",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".3",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".35",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".4",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".45",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".5",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49991 0.877045C3.84222 0.877045 0.877075 3.84219 0.877075 7.49988C0.877075 9.1488 1.47969 10.657 2.4767 11.8162L1.64647 12.6464C1.45121 12.8417 1.45121 13.1583 1.64647 13.3535C1.84173 13.5488 2.15832 13.5488 2.35358 13.3535L3.18383 12.5233C4.34302 13.5202 5.8511 14.1227 7.49991 14.1227C11.1576 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34298 12.5233 3.1838L13.3536 2.35355C13.5488 2.15829 13.5488 1.8417 13.3536 1.64644C13.1583 1.45118 12.8417 1.45118 12.6465 1.64644L11.8162 2.47667C10.657 1.47966 9.14883 0.877045 7.49991 0.877045ZM11.1423 3.15065C10.1568 2.32449 8.88644 1.82704 7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 8.88641 2.32452 10.1568 3.15069 11.1422L11.1423 3.15065ZM3.85781 11.8493C4.84322 12.6753 6.11348 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11345 12.6754 4.84319 11.8493 3.85778L3.85781 11.8493Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShadowOuter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": ".05",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.1398 3.88617C13.8553 4.94159 15 6.83701 15 9.00001C15 12.3137 12.3137 15 9.00002 15C6.84351 15 4.95296 13.8621 3.89569 12.1552L4.32076 11.8919C5.29069 13.4578 7.02376 14.5 9.00002 14.5C12.0376 14.5 14.5 12.0375 14.5 9.00001C14.5 7.01781 13.4516 5.28027 11.8778 4.31203L12.1398 3.88617Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".2",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.851 5.07321C13.8684 6.07106 14.5 7.46199 14.5 9C14.5 12.0375 12.0376 14.5 9.00004 14.5C7.46215 14.5 6.07132 13.8685 5.07349 12.8513L5.43043 12.5011C6.3381 13.4264 7.60186 14 9.00004 14C11.7614 14 14 11.7614 14 9C14 7.60171 13.4264 6.33786 12.5009 5.43017L12.851 5.07321Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".35",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.3022 6.45071C13.7455 7.19737 14 8.06935 14 9.00001C14 11.7614 11.7614 14 9.00002 14C8.04868 14 7.15868 13.7341 6.40118 13.2724L6.66142 12.8454C7.34275 13.2607 8.14306 13.5 9.00002 13.5C11.4853 13.5 13.5 11.4853 13.5 9.00001C13.5 8.16165 13.271 7.37754 12.8722 6.70599L13.3022 6.45071Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".5",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.3745 7.94022C13.4566 8.28031 13.5 8.63525 13.5 9.00001C13.5 11.4853 11.4853 13.5 9.00003 13.5C8.61104 13.5 8.23323 13.4506 7.87268 13.3576L7.99759 12.8734C8.31768 12.956 8.65353 13 9.00003 13C11.2091 13 13 11.2091 13 9.00001C13 8.67509 12.9613 8.35953 12.8884 8.05757L13.3745 7.94022Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".65",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.9155 9.82133C12.5898 11.3813 11.3562 12.6072 9.79205 12.9215L9.69354 12.4313C11.0613 12.1565 12.1413 11.0834 12.4261 9.71915L12.9155 9.82133Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.2771 7.50253C1.2771 4.06456 4.06413 1.27753 7.5021 1.27753C10.94 1.27753 13.7271 4.06456 13.7271 7.50253C13.7271 10.9405 10.94 13.7275 7.5021 13.7275C4.06413 13.7275 1.2771 10.9405 1.2771 7.50253ZM7.5021 2.22753C4.5888 2.22753 2.2271 4.58923 2.2271 7.50253C2.2271 10.4158 4.5888 12.7775 7.5021 12.7775C10.4154 12.7775 12.7771 10.4158 12.7771 7.50253C12.7771 4.58923 10.4154 2.22753 7.5021 2.22753Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShadow(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": ".05",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".1",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".15",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".2",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".25",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".3",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".35",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".4",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".45",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "opacity": ".5",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
                    "fill": "currentColor"
                }
            },
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShare1(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 7.50003C5 8.32845 4.32843 9.00003 3.5 9.00003C2.67157 9.00003 2 8.32845 2 7.50003C2 6.6716 2.67157 6.00003 3.5 6.00003C4.32843 6.00003 5 6.6716 5 7.50003ZM5.71313 8.66388C5.29445 9.45838 4.46048 10 3.5 10C2.11929 10 1 8.88074 1 7.50003C1 6.11931 2.11929 5.00003 3.5 5.00003C4.46048 5.00003 5.29445 5.54167 5.71313 6.33616L9.10424 4.21671C9.03643 3.98968 9 3.74911 9 3.50003C9 2.11932 10.1193 1.00003 11.5 1.00003C12.8807 1.00003 14 2.11932 14 3.50003C14 4.88074 12.8807 6.00003 11.5 6.00003C10.6915 6.00003 9.97264 5.61624 9.51566 5.0209L5.9853 7.22738C5.99502 7.31692 6 7.40789 6 7.50003C6 7.59216 5.99502 7.68312 5.9853 7.77267L9.51567 9.97915C9.97265 9.38382 10.6915 9.00003 11.5 9.00003C12.8807 9.00003 14 10.1193 14 11.5C14 12.8807 12.8807 14 11.5 14C10.1193 14 9 12.8807 9 11.5C9 11.2509 9.03643 11.0104 9.10425 10.7833L5.71313 8.66388ZM11.5 5.00003C12.3284 5.00003 13 4.32846 13 3.50003C13 2.6716 12.3284 2.00003 11.5 2.00003C10.6716 2.00003 10 2.6716 10 3.50003C10 4.32846 10.6716 5.00003 11.5 5.00003ZM13 11.5C13 12.3285 12.3284 13 11.5 13C10.6716 13 10 12.3285 10 11.5C10 10.6716 10.6716 10 11.5 10C12.3284 10 13 10.6716 13 11.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShare2(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxShuffle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M12.3536 1.14645C12.1583 0.951184 11.8417 0.951184 11.6464 1.14645C11.4512 1.34171 11.4512 1.65829 11.6464 1.85355L12.7929 3H12C10.7037 3 9.71111 3.58423 8.87248 4.38931C8.20065 5.03427 7.59349 5.85684 6.99461 6.6682C6.86287 6.84668 6.73154 7.02462 6.6 7.2C5.10874 9.18835 3.49037 11 0.5 11C0.223858 11 0 11.2239 0 11.5C0 11.7761 0.223858 12 0.5 12C4.00963 12 5.89126 9.81165 7.4 7.8C7.54367 7.60845 7.6832 7.41962 7.81996 7.23454L7.82005 7.23443L7.82006 7.23441C8.41674 6.42695 8.96069 5.69085 9.56502 5.11069C10.2889 4.41577 11.0463 4 12 4H12.7929L11.6464 5.14645C11.4512 5.34171 11.4512 5.65829 11.6464 5.85355C11.8417 6.04882 12.1583 6.04882 12.3536 5.85355L14.3536 3.85355C14.5488 3.65829 14.5488 3.34171 14.3536 3.14645L12.3536 1.14645ZM0.5 3C3.35278 3 5.12992 4.44588 6.50548 6.06746L6.3762 6.24266C6.2483 6.4161 6.12293 6.58609 6 6.75C5.96397 6.79804 5.92798 6.84581 5.892 6.89331C4.57348 5.29306 3.02637 4 0.5 4C0.223858 4 0 3.77614 0 3.5C0 3.22386 0.223858 3 0.5 3ZM8.87248 10.6107C8.37284 10.131 7.90897 9.55314 7.45767 8.95468C7.64688 8.71693 7.82704 8.48061 8 8.25L8.08987 8.12987C8.58412 8.79402 9.05288 9.39766 9.56502 9.88931C10.2889 10.5842 11.0463 11 12 11H12.7929L11.6464 9.85355C11.4512 9.65829 11.4512 9.34171 11.6464 9.14645C11.8417 8.95118 12.1583 8.95118 12.3536 9.14645L14.3536 11.1464C14.5488 11.3417 14.5488 11.6583 14.3536 11.8536L12.3536 13.8536C12.1583 14.0488 11.8417 14.0488 11.6464 13.8536C11.4512 13.6583 11.4512 13.3417 11.6464 13.1464L12.7929 12H12C10.7037 12 9.71111 11.4158 8.87248 10.6107Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSize(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSketchLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.53731 0.826873C7.5125 0.824392 7.4875 0.824392 7.46269 0.826873L3.96269 1.17687C3.85672 1.18747 3.76025 1.24262 3.69736 1.32857L0.699771 5.42528C0.654046 5.48627 0.62647 5.56165 0.625057 5.6434C0.625019 5.6456 0.625 5.64781 0.625 5.65001C0.625 5.65052 0.625001 5.65103 0.625003 5.65153C0.625363 5.74237 0.658021 5.82559 0.712087 5.8903L7.21042 13.7883C7.28165 13.8749 7.38789 13.925 7.5 13.925C7.61211 13.925 7.71835 13.8749 7.78958 13.7883L14.2879 5.89031C14.342 5.8256 14.3746 5.74237 14.375 5.65153C14.375 5.65103 14.375 5.65052 14.375 5.65001C14.375 5.64849 14.375 5.64697 14.375 5.64545C14.3749 5.63963 14.3747 5.63382 14.3744 5.62801C14.37 5.55219 14.3431 5.48242 14.3002 5.42527L11.3026 1.32857C11.2397 1.24262 11.1433 1.18747 11.0373 1.17687L7.53731 0.826873ZM10.925 5.27501V5.25236L10.9223 5.27501H10.925ZM10.9342 5.17498H13.1877L11.2495 2.5261L10.9342 5.17498ZM10.5707 1.88395L8.04432 1.63131L10.1747 5.21034L10.5707 1.88395ZM6.95568 1.63131L4.42931 1.88395L4.82531 5.21034L6.95568 1.63131ZM3.75046 2.5261L1.81226 5.17498H4.0658L3.75046 2.5261ZM1.79416 6.02501L6.75861 12.0587L4.22371 6.0669C4.21787 6.0531 4.21314 6.0391 4.20949 6.02501H1.79416ZM5.15055 6.02501L7.49999 12.1085L9.84943 6.02501H9.78681H5.21319H5.15055ZM10.7905 6.02501C10.7869 6.0391 10.7821 6.0531 10.7763 6.0669L8.24139 12.0587L13.2058 6.02501H10.7905ZM7.5 2.18317L9.34038 5.27501H5.65962L7.5 2.18317Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSlash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.10876 14L9.46582 1H10.8178L5.46074 14H4.10876Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSlider(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.3004 7.49991C10.3004 8.4943 9.49426 9.30041 8.49988 9.30041C7.50549 9.30041 6.69938 8.4943 6.69938 7.49991C6.69938 6.50553 7.50549 5.69942 8.49988 5.69942C9.49426 5.69942 10.3004 6.50553 10.3004 7.49991ZM11.205 8C10.9699 9.28029 9.84816 10.2504 8.49988 10.2504C7.1516 10.2504 6.0299 9.28029 5.79473 8H0.5C0.223858 8 0 7.77614 0 7.5C0 7.22386 0.223858 7 0.5 7H5.7947C6.0298 5.71962 7.15154 4.74942 8.49988 4.74942C9.84822 4.74942 10.97 5.71962 11.2051 7H14.5C14.7761 7 15 7.22386 15 7.5C15 7.77614 14.7761 8 14.5 8H11.205Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpaceBetweenHorizontally(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.4999 0.999994C14.2237 0.999994 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L9.99992 5.99995C9.44764 5.99995 8.99993 6.44766 8.99993 6.99994L8.99993 7.99994C8.99993 8.55222 9.44764 8.99993 9.99992 8.99993L13.9999 8.99993L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999994 14.4999 0.999994ZM4.99996 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999994 0.499996 0.999994C0.223856 0.999994 -9.7852e-09 1.22385 -2.18557e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99993L4.99996 8.99993C5.55224 8.99993 5.99995 8.55222 5.99995 7.99993L5.99995 6.99994C5.99995 6.44766 5.55224 5.99995 4.99996 5.99995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpaceBetweenVertically(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1L9 1V5C9 5.55228 8.55228 6 8 6H7C6.44772 6 6 5.55228 6 5V1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 9C6.44772 9 6 9.44771 6 10V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9V10C9 9.44772 8.55228 9 8 9H7Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpaceEvenlyHorizontally(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992ZM0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992ZM1.99998 6.99994C1.99998 6.44766 2.44769 5.99995 2.99998 5.99995L5.99995 5.99995C6.55223 5.99995 6.99994 6.44766 6.99994 6.99994L6.99994 7.99993C6.99994 8.55221 6.55223 8.99992 5.99995 8.99992L2.99998 8.99992C2.4477 8.99992 1.99998 8.55221 1.99998 7.99993L1.99998 6.99994ZM8.99993 5.99995C8.44765 5.99995 7.99993 6.44766 7.99993 6.99994L7.99993 7.99993C7.99993 8.55221 8.44765 8.99992 8.99993 8.99992L11.9999 8.99992C12.5522 8.99992 12.9999 8.55221 12.9999 7.99993L12.9999 6.99994C12.9999 6.44766 12.5522 5.99995 11.9999 5.99995L8.99993 5.99995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpaceEvenlyVertically(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM7 2C6.44772 2 6 2.44772 6 3V6C6 6.55228 6.44772 7 7 7H8C8.55228 7 9 6.55228 9 6V3C9 2.44772 8.55228 2 8 2H7ZM7 8C6.44772 8 6 8.44771 6 9V12C6 12.5523 6.44772 13 7 13H8C8.55228 13 9 12.5523 9 12V9C9 8.44772 8.55228 8 8 8H7ZM1.49988 14C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H1.49988Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpeakerLoud(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.46968 1.05085C7.64122 1.13475 7.75 1.30904 7.75 1.5V13.5C7.75 13.691 7.64122 13.8653 7.46968 13.9492C7.29813 14.0331 7.09377 14.0119 6.94303 13.8947L3.2213 11H1.5C0.671571 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.2213L6.94303 1.10533C7.09377 0.988085 7.29813 0.966945 7.46968 1.05085ZM6.75 2.52232L3.69983 4.89468C3.61206 4.96294 3.50405 5 3.39286 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77615 1.22386 10 1.5 10H3.39286C3.50405 10 3.61206 10.0371 3.69983 10.1053L6.75 12.4777V2.52232ZM10.2784 3.84804C10.4623 3.72567 10.7106 3.77557 10.833 3.95949C12.2558 6.09798 12.2558 8.90199 10.833 11.0405C10.7106 11.2244 10.4623 11.2743 10.2784 11.1519C10.0944 11.0296 10.0445 10.7813 10.1669 10.5973C11.4111 8.72728 11.4111 6.27269 10.1669 4.40264C10.0445 4.21871 10.0944 3.97041 10.2784 3.84804ZM12.6785 1.43044C12.5356 1.2619 12.2832 1.24104 12.1147 1.38386C11.9462 1.52667 11.9253 1.77908 12.0681 1.94762C14.7773 5.14488 14.7773 9.85513 12.0681 13.0524C11.9253 13.2209 11.9462 13.4733 12.1147 13.6161C12.2832 13.759 12.5356 13.7381 12.6785 13.5696C15.6406 10.0739 15.6406 4.92612 12.6785 1.43044Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpeakerModerate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.833 3.95949C10.7106 3.77557 10.4623 3.72567 10.2784 3.84804C10.0944 3.97041 10.0445 4.21871 10.1669 4.40264C11.4111 6.27268 11.4111 8.72728 10.1669 10.5973C10.0445 10.7813 10.0944 11.0296 10.2784 11.1519C10.4623 11.2743 10.7106 11.2244 10.833 11.0405C12.2558 8.90199 12.2558 6.09798 10.833 3.95949Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpeakerOff(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.72361 1.05279C7.893 1.13749 8 1.31062 8 1.5V13.5C8 13.6894 7.893 13.8625 7.72361 13.9472C7.55421 14.0319 7.35151 14.0136 7.2 13.9L3.33333 11H1.5C0.671573 11 0 10.3284 0 9.5V5.5C0 4.67158 0.671573 4 1.5 4H3.33333L7.2 1.1C7.35151 0.986371 7.55421 0.968093 7.72361 1.05279ZM7 2.5L3.8 4.9C3.71345 4.96491 3.60819 5 3.5 5H1.5C1.22386 5 1 5.22386 1 5.5V9.5C1 9.77614 1.22386 10 1.5 10H3.5C3.60819 10 3.71345 10.0351 3.8 10.1L7 12.5V2.5ZM14.8536 5.14645C15.0488 5.34171 15.0488 5.65829 14.8536 5.85355L13.2071 7.5L14.8536 9.14645C15.0488 9.34171 15.0488 9.65829 14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.5 8.20711L10.8536 9.85355C10.6583 10.0488 10.3417 10.0488 10.1464 9.85355C9.95118 9.65829 9.95118 9.34171 10.1464 9.14645L11.7929 7.5L10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645C10.3417 4.95118 10.6583 4.95118 10.8536 5.14645L12.5 6.79289L14.1464 5.14645C14.3417 4.95118 14.6583 4.95118 14.8536 5.14645Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSpeakerQuiet(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 1.5C8 1.31062 7.893 1.13749 7.72361 1.05279C7.55421 0.968093 7.35151 0.986371 7.2 1.1L3.33333 4H1.5C0.671573 4 0 4.67158 0 5.5V9.5C0 10.3284 0.671573 11 1.5 11H3.33333L7.2 13.9C7.35151 14.0136 7.55421 14.0319 7.72361 13.9472C7.893 13.8625 8 13.6894 8 13.5V1.5ZM3.8 4.9L7 2.5V12.5L3.8 10.1C3.71345 10.0351 3.60819 10 3.5 10H1.5C1.22386 10 1 9.77614 1 9.5V5.5C1 5.22386 1.22386 5 1.5 5H3.5C3.60819 5 3.71345 4.96491 3.8 4.9ZM10.083 5.05577C9.96066 4.87185 9.71235 4.82195 9.52843 4.94432C9.3445 5.06669 9.2946 5.31499 9.41697 5.49892C10.2207 6.70693 10.2207 8.29303 9.41697 9.50104C9.2946 9.68496 9.3445 9.93326 9.52843 10.0556C9.71235 10.178 9.96066 10.1281 10.083 9.94418C11.0653 8.46773 11.0653 6.53222 10.083 5.05577Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSquare(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 1H1.5H13.5H14V1.5V13.5V14H13.5H1.5H1V13.5V1.5V1ZM2 2V13H13V2H2Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStack(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.75432 1.81954C7.59742 1.72682 7.4025 1.72682 7.24559 1.81954L1.74559 5.06954C1.59336 5.15949 1.49996 5.32317 1.49996 5.5C1.49996 5.67683 1.59336 5.84051 1.74559 5.93046L7.24559 9.18046C7.4025 9.27318 7.59742 9.27318 7.75432 9.18046L13.2543 5.93046C13.4066 5.84051 13.5 5.67683 13.5 5.5C13.5 5.32317 13.4066 5.15949 13.2543 5.06954L7.75432 1.81954ZM7.49996 8.16923L2.9828 5.5L7.49996 2.83077L12.0171 5.5L7.49996 8.16923ZM2.25432 8.31954C2.01658 8.17906 1.70998 8.2579 1.56949 8.49564C1.42901 8.73337 1.50785 9.03998 1.74559 9.18046L7.24559 12.4305C7.4025 12.5232 7.59742 12.5232 7.75432 12.4305L13.2543 9.18046C13.4921 9.03998 13.5709 8.73337 13.4304 8.49564C13.2899 8.2579 12.9833 8.17906 12.7456 8.31954L7.49996 11.4192L2.25432 8.31954Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStarFilled(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStar(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.97942 1.25171L6.9585 1.30199L5.58662 4.60039C5.54342 4.70426 5.44573 4.77523 5.3336 4.78422L1.7727 5.0697L1.71841 5.07405L1.38687 5.10063L1.08608 5.12475C0.820085 5.14607 0.712228 5.47802 0.914889 5.65162L1.14406 5.84793L1.39666 6.06431L1.43802 6.09974L4.15105 8.42374C4.23648 8.49692 4.2738 8.61176 4.24769 8.72118L3.41882 12.196L3.40618 12.249L3.32901 12.5725L3.25899 12.866C3.19708 13.1256 3.47945 13.3308 3.70718 13.1917L3.9647 13.0344L4.24854 12.861L4.29502 12.8326L7.34365 10.9705C7.43965 10.9119 7.5604 10.9119 7.6564 10.9705L10.705 12.8326L10.7515 12.861L11.0354 13.0344L11.2929 13.1917C11.5206 13.3308 11.803 13.1256 11.7411 12.866L11.671 12.5725L11.5939 12.249L11.5812 12.196L10.7524 8.72118C10.7263 8.61176 10.7636 8.49692 10.849 8.42374L13.562 6.09974L13.6034 6.06431L13.856 5.84793L14.0852 5.65162C14.2878 5.47802 14.18 5.14607 13.914 5.12475L13.6132 5.10063L13.2816 5.07405L13.2274 5.0697L9.66645 4.78422C9.55432 4.77523 9.45663 4.70426 9.41343 4.60039L8.04155 1.30199L8.02064 1.25171L7.89291 0.944609L7.77702 0.665992C7.67454 0.419604 7.32551 0.419604 7.22303 0.665992L7.10715 0.944609L6.97942 1.25171ZM7.50003 2.60397L6.50994 4.98442C6.32273 5.43453 5.89944 5.74207 5.41351 5.78103L2.84361 5.98705L4.8016 7.66428C5.17183 7.98142 5.33351 8.47903 5.2204 8.95321L4.62221 11.461L6.8224 10.1171C7.23842 9.86302 7.76164 9.86302 8.17766 10.1171L10.3778 11.461L9.77965 8.95321C9.66654 8.47903 9.82822 7.98142 10.1984 7.66428L12.1564 5.98705L9.58654 5.78103C9.10061 5.74207 8.67732 5.43453 8.49011 4.98442L7.50003 2.60397Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStitchesLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.84998 7.49998C1.84998 7.21321 1.87134 6.93143 1.91256 6.65615L9.56374 2.23875C9.86311 2.35627 10.15 2.49861 10.4219 2.66322L3.77065 6.50332C3.73669 6.52183 3.70482 6.5449 3.67602 6.57238C3.5911 6.65308 3.54245 6.76286 3.53682 6.87658C3.53359 6.9418 3.54451 7.00831 3.57086 7.07137C3.58927 7.1157 3.6149 7.15742 3.64744 7.19458C3.67306 7.22396 3.702 7.24941 3.73337 7.27069L7.32533 9.83813L3.87232 11.8317C2.63604 10.7953 1.84998 9.23944 1.84998 7.49998ZM8.36843 10.2751C8.37682 10.2706 8.38509 10.2659 8.39322 10.2608L9.84091 9.42499C9.84706 9.42163 9.85314 9.41812 9.85915 9.41446L11.3101 8.57677C11.3655 8.54649 11.4154 8.504 11.4554 8.44995C11.6034 8.25031 11.5616 7.96848 11.362 7.82046L7.82779 5.20017L11.2161 3.24393C12.4013 4.27963 13.15 5.80237 13.15 7.49998C13.15 7.83546 13.1207 8.16411 13.0647 8.48353L5.56875 12.8113C5.26138 12.6995 4.96646 12.5618 4.68662 12.4008L8.36843 10.2751ZM8.18149 9.34383L4.81659 6.93868L5.50918 6.53881L8.80604 8.98324L8.18149 9.34383ZM6.35875 6.04832L6.97822 5.69067L10.2751 8.13506L9.6556 8.49275L6.35875 6.04832ZM8.3318 1.91078L2.24263 5.42636C3.06941 3.33188 5.11164 1.84998 7.49998 1.84998C7.78258 1.84998 8.06033 1.87072 8.3318 1.91078ZM6.84684 13.1126C7.06114 13.1373 7.27908 13.15 7.49998 13.15C9.8246 13.15 11.8213 11.7461 12.6886 9.7399L6.84684 13.1126ZM7.49998 0.849976C3.82728 0.849976 0.849976 3.82728 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 3C2 2.44772 2.44772 2 3 2H12C12.5523 2 13 2.44772 13 3V12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12V3ZM12 3H3V12H12V3Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStopwatch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.49998 0.5C5.49998 0.223858 5.72383 0 5.99998 0H7.49998H8.99998C9.27612 0 9.49998 0.223858 9.49998 0.5C9.49998 0.776142 9.27612 1 8.99998 1H7.99998V2.11922C9.09832 2.20409 10.119 2.56622 10.992 3.13572C11.0116 3.10851 11.0336 3.08252 11.058 3.05806L11.858 2.25806C12.1021 2.01398 12.4978 2.01398 12.7419 2.25806C12.986 2.50214 12.986 2.89786 12.7419 3.14194L11.967 3.91682C13.1595 5.07925 13.9 6.70314 13.9 8.49998C13.9 12.0346 11.0346 14.9 7.49998 14.9C3.96535 14.9 1.09998 12.0346 1.09998 8.49998C1.09998 5.13362 3.69904 2.3743 6.99998 2.11922V1H5.99998C5.72383 1 5.49998 0.776142 5.49998 0.5ZM2.09998 8.49998C2.09998 5.51764 4.51764 3.09998 7.49998 3.09998C10.4823 3.09998 12.9 5.51764 12.9 8.49998C12.9 11.4823 10.4823 13.9 7.49998 13.9C4.51764 13.9 2.09998 11.4823 2.09998 8.49998ZM7.99998 4.5C7.99998 4.22386 7.77612 4 7.49998 4C7.22383 4 6.99998 4.22386 6.99998 4.5V9.5C6.99998 9.77614 7.22383 10 7.49998 10C7.77612 10 7.99998 9.77614 7.99998 9.5V4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStretchHorizontally(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14.4999 0.999992C14.2237 0.999992 13.9999 1.22385 13.9999 1.49999L13.9999 5.99995L0.999992 5.99995L0.999992 1.49999C0.999992 1.22385 0.776136 0.999992 0.499996 0.999992C0.223856 0.999992 -9.78509e-09 1.22385 -2.18556e-08 1.49999L4.07279e-07 13.4999C3.95208e-07 13.776 0.223855 13.9999 0.499996 13.9999C0.776136 13.9999 0.999992 13.776 0.999992 13.4999L0.999992 8.99992L13.9999 8.99992L13.9999 13.4999C13.9999 13.776 14.2237 13.9999 14.4999 13.9999C14.776 13.9999 14.9999 13.776 14.9999 13.4999L14.9999 1.49999C14.9999 1.22385 14.776 0.999992 14.4999 0.999992Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStretchVertically(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.999878 0.5C0.999878 0.223858 1.22374 0 1.49988 0H13.4999C13.776 0 13.9999 0.223858 13.9999 0.5C13.9999 0.776142 13.776 1 13.4999 1H6H1.49988C1.22374 1 0.999878 0.776142 0.999878 0.5ZM9 14V1L6 1V14H1.49988C1.22374 14 0.999878 14.2239 0.999878 14.5C0.999878 14.7761 1.22374 15 1.49988 15H13.4999C13.776 15 13.9999 14.7761 13.9999 14.5C13.9999 14.2239 13.776 14 13.4999 14H9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxStrikethrough(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSun(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSwitch(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10.5 4C8.567 4 7 5.567 7 7.5C7 9.433 8.567 11 10.5 11C12.433 11 14 9.433 14 7.5C14 5.567 12.433 4 10.5 4ZM7.67133 11C6.65183 10.175 6 8.91363 6 7.5C6 6.08637 6.65183 4.82498 7.67133 4H4.5C2.567 4 1 5.567 1 7.5C1 9.433 2.567 11 4.5 11H7.67133ZM0 7.5C0 5.01472 2.01472 3 4.5 3H10.5C12.9853 3 15 5.01472 15 7.5C15 9.98528 12.9853 12 10.5 12H4.5C2.01472 12 0 9.98528 0 7.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxSymbol(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTable(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 2H12.5C12.7761 2 13 2.22386 13 2.5V5H8V2ZM7 5V2H2.5C2.22386 2 2 2.22386 2 2.5V5H7ZM2 6V9H7V6H2ZM8 6H13V9H8V6ZM8 10H13V12.5C13 12.7761 12.7761 13 12.5 13H8V10ZM2 12.5V10H7V13H2.5C2.22386 13 2 12.7761 2 12.5ZM1 2.5C1 1.67157 1.67157 1 2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTarget(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.900024 7.50002C0.900024 3.85495 3.85495 0.900024 7.50002 0.900024C11.1451 0.900024 14.1 3.85495 14.1 7.50002C14.1 11.1451 11.1451 14.1 7.50002 14.1C3.85495 14.1 0.900024 11.1451 0.900024 7.50002ZM7.50002 1.80002C4.35201 1.80002 1.80002 4.35201 1.80002 7.50002C1.80002 10.648 4.35201 13.2 7.50002 13.2C10.648 13.2 13.2 10.648 13.2 7.50002C13.2 4.35201 10.648 1.80002 7.50002 1.80002ZM3.07504 7.50002C3.07504 5.05617 5.05618 3.07502 7.50004 3.07502C9.94388 3.07502 11.925 5.05617 11.925 7.50002C11.925 9.94386 9.94388 11.925 7.50004 11.925C5.05618 11.925 3.07504 9.94386 3.07504 7.50002ZM7.50004 3.92502C5.52562 3.92502 3.92504 5.52561 3.92504 7.50002C3.92504 9.47442 5.52563 11.075 7.50004 11.075C9.47444 11.075 11.075 9.47442 11.075 7.50002C11.075 5.52561 9.47444 3.92502 7.50004 3.92502ZM7.50004 5.25002C6.2574 5.25002 5.25004 6.25739 5.25004 7.50002C5.25004 8.74266 6.2574 9.75002 7.50004 9.75002C8.74267 9.75002 9.75004 8.74266 9.75004 7.50002C9.75004 6.25738 8.74267 5.25002 7.50004 5.25002ZM6.05004 7.50002C6.05004 6.69921 6.69923 6.05002 7.50004 6.05002C8.30084 6.05002 8.95004 6.69921 8.95004 7.50002C8.95004 8.30083 8.30084 8.95002 7.50004 8.95002C6.69923 8.95002 6.05004 8.30083 6.05004 7.50002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignBottom(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.89949 5.50002C3.89949 5.27911 3.7204 5.10003 3.49949 5.10003C3.27857 5.10003 3.09949 5.27911 3.09949 5.50002L3.09949 12.5343L1.78233 11.2172C1.62612 11.061 1.37285 11.061 1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829L3.21664 13.7829C3.29166 13.8579 3.3934 13.9 3.49949 13.9C3.60557 13.9 3.70732 13.8579 3.78233 13.7829L5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172C5.62612 11.061 5.37285 11.061 5.21664 11.2172L3.89949 12.5343L3.89949 5.50002ZM8.49998 13C8.22383 13 7.99998 12.7762 7.99998 12.5C7.99998 12.2239 8.22383 12 8.49998 12H14.5C14.7761 12 15 12.2239 15 12.5C15 12.7762 14.7761 13 14.5 13H8.49998ZM8.49998 10C8.22383 10 7.99998 9.77617 7.99998 9.50002C7.99998 9.22388 8.22383 9.00002 8.49998 9.00002H14.5C14.7761 9.00002 15 9.22388 15 9.50002C15 9.77617 14.7761 10 14.5 10H8.49998ZM7.99998 6.50002C7.99998 6.77617 8.22383 7.00002 8.49998 7.00002H14.5C14.7761 7.00002 15 6.77617 15 6.50002C15 6.22388 14.7761 6.00002 14.5 6.00002H8.49998C8.22383 6.00002 7.99998 6.22388 7.99998 6.50002Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignCenter(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM4 7.5C4 7.22386 4.22386 7 4.5 7H10.5C10.7761 7 11 7.22386 11 7.5C11 7.77614 10.7761 8 10.5 8H4.5C4.22386 8 4 7.77614 4 7.5ZM3 10.5C3 10.2239 3.22386 10 3.5 10H11.5C11.7761 10 12 10.2239 12 10.5C12 10.7761 11.7761 11 11.5 11H3.5C3.22386 11 3 10.7761 3 10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignJustify(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H12.5C12.7761 5 13 4.77614 13 4.5C13 4.22386 12.7761 4 12.5 4H2.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM2 7.5C2 7.22386 2.22386 7 2.5 7H7.5C7.77614 7 8 7.22386 8 7.5C8 7.77614 7.77614 8 7.5 8H2.5C2.22386 8 2 7.77614 2 7.5ZM2 10.5C2 10.2239 2.22386 10 2.5 10H10.5C10.7761 10 11 10.2239 11 10.5C11 10.7761 10.7761 11 10.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignMiddle(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.49949 14.9C3.7204 14.9 3.89949 14.7209 3.89949 14.5L3.89949 10.4657L5.21664 11.7829C5.37285 11.9391 5.62612 11.9391 5.78233 11.7829C5.93854 11.6267 5.93854 11.3734 5.78233 11.2172L3.78233 9.21718C3.70732 9.14217 3.60557 9.10002 3.49949 9.10002C3.3934 9.10002 3.29166 9.14217 3.21664 9.21718L1.21664 11.2172C1.06043 11.3734 1.06043 11.6267 1.21664 11.7829C1.37285 11.9391 1.62612 11.9391 1.78233 11.7829L3.09949 10.4657L3.09949 14.5C3.09949 14.7209 3.27857 14.9 3.49949 14.9ZM7.99998 10.5C7.99998 10.7762 8.22383 11 8.49998 11H14.5C14.7761 11 15 10.7762 15 10.5C15 10.2239 14.7761 10 14.5 10H8.49998C8.22383 10 7.99998 10.2239 7.99998 10.5ZM7.99998 7.50002C7.99998 7.77617 8.22383 8.00002 8.49998 8.00002H14.5C14.7761 8.00002 15 7.77617 15 7.50002C15 7.22388 14.7761 7.00002 14.5 7.00002H8.49998C8.22383 7.00002 7.99998 7.22388 7.99998 7.50002ZM8.49998 5.00002C8.22383 5.00002 7.99998 4.77617 7.99998 4.50002C7.99998 4.22388 8.22383 4.00002 8.49998 4.00002H14.5C14.7761 4.00002 15 4.22388 15 4.50002C15 4.77617 14.7761 5.00002 14.5 5.00002H8.49998ZM3.89949 0.500025C3.89949 0.279111 3.7204 0.100025 3.49949 0.100025C3.27857 0.100025 3.09949 0.279111 3.09949 0.500025L3.09949 4.53434L1.78233 3.21718C1.62612 3.06097 1.37285 3.06097 1.21664 3.21718C1.06043 3.37339 1.06043 3.62666 1.21664 3.78287L3.21664 5.78287C3.29166 5.85788 3.3934 5.90002 3.49949 5.90002C3.60557 5.90002 3.70732 5.85788 3.78233 5.78287L5.78233 3.78287C5.93854 3.62666 5.93854 3.37339 5.78233 3.21718C5.62612 3.06097 5.37285 3.06097 5.21664 3.21718L3.89949 4.53434L3.89949 0.500025Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M2 4.5C2 4.22386 2.22386 4 2.5 4H12.5C12.7761 4 13 4.22386 13 4.5C13 4.77614 12.7761 5 12.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM7 7.5C7 7.22386 7.22386 7 7.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H7.5C7.22386 8 7 7.77614 7 7.5ZM4 10.5C4 10.2239 4.22386 10 4.5 10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7761 12.7761 11 12.5 11H4.5C4.22386 11 4 10.7761 4 10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextAlignTop(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.89949 9.49998C3.89949 9.72089 3.7204 9.89997 3.49949 9.89997C3.27857 9.89997 3.09949 9.72089 3.09949 9.49998L3.09949 2.46566L1.78233 3.78282C1.62612 3.93903 1.37285 3.93903 1.21664 3.78282C1.06043 3.62661 1.06043 3.37334 1.21664 3.21713L3.21664 1.21713C3.29166 1.14212 3.3934 1.09998 3.49949 1.09998C3.60557 1.09998 3.70732 1.14212 3.78233 1.21713L5.78233 3.21713C5.93854 3.37334 5.93854 3.62661 5.78233 3.78282C5.62612 3.93903 5.37285 3.93903 5.21664 3.78282L3.89949 2.46566L3.89949 9.49998ZM8.49998 1.99998C8.22383 1.99998 7.99998 2.22383 7.99998 2.49998C7.99998 2.77612 8.22383 2.99998 8.49998 2.99998H14.5C14.7761 2.99998 15 2.77612 15 2.49998C15 2.22383 14.7761 1.99998 14.5 1.99998H8.49998ZM8.49998 4.99998C8.22383 4.99998 7.99998 5.22383 7.99998 5.49998C7.99998 5.77612 8.22383 5.99998 8.49998 5.99998H14.5C14.7761 5.99998 15 5.77612 15 5.49998C15 5.22383 14.7761 4.99998 14.5 4.99998H8.49998ZM7.99998 8.49998C7.99998 8.22383 8.22383 7.99998 8.49998 7.99998H14.5C14.7761 7.99998 15 8.22383 15 8.49998C15 8.77612 14.7761 8.99998 14.5 8.99998H8.49998C8.22383 8.99998 7.99998 8.77612 7.99998 8.49998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTextNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxText(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M3.94993 2.95002L3.94993 4.49998C3.94993 4.74851 3.74845 4.94998 3.49993 4.94998C3.2514 4.94998 3.04993 4.74851 3.04993 4.49998V2.50004C3.04993 2.45246 3.05731 2.40661 3.07099 2.36357C3.12878 2.18175 3.29897 2.05002 3.49993 2.05002H11.4999C11.6553 2.05002 11.7922 2.12872 11.8731 2.24842C11.9216 2.32024 11.9499 2.40682 11.9499 2.50002L11.9499 2.50004V4.49998C11.9499 4.74851 11.7485 4.94998 11.4999 4.94998C11.2514 4.94998 11.0499 4.74851 11.0499 4.49998V2.95002H8.04993V12.05H9.25428C9.50281 12.05 9.70428 12.2515 9.70428 12.5C9.70428 12.7486 9.50281 12.95 9.25428 12.95H5.75428C5.50575 12.95 5.30428 12.7486 5.30428 12.5C5.30428 12.2515 5.50575 12.05 5.75428 12.05H6.94993V2.95002H3.94993Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxThickArrowDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5 3.5C5 3.22386 5.22386 3 5.5 3H9.5C9.77614 3 10 3.22386 10 3.5V6H12.5C12.6873 6 12.8589 6.10467 12.9446 6.27121C13.0303 6.43774 13.0157 6.63821 12.9069 6.79062L7.90687 13.7906C7.81301 13.922 7.66148 14 7.5 14C7.33853 14 7.18699 13.922 7.09314 13.7906L2.09314 6.79062C1.98427 6.63821 1.96972 6.43774 2.05542 6.27121C2.14112 6.10467 2.31271 6 2.5 6H5V3.5ZM6 4V6.5C6 6.77614 5.77614 7 5.5 7H3.4716L7.5 12.6398L11.5284 7H9.5C9.22386 7 9 6.77614 9 6.5V4H6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxThickArrowLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1 7.5C1 7.66148 1.07798 7.81301 1.20938 7.90687L8.20938 12.9069C8.36179 13.0157 8.56226 13.0303 8.72879 12.9446C8.89533 12.8589 9 12.6873 9 12.5L9 10L11.5 10C11.7761 10 12 9.77614 12 9.5L12 5.5C12 5.22386 11.7761 5 11.5 5L9 5L9 2.5C9 2.31271 8.89533 2.14112 8.72879 2.05542C8.56226 1.96972 8.36179 1.98427 8.20938 2.09313L1.20938 7.09314C1.07798 7.18699 1 7.33853 1 7.5ZM8 3.4716L8 5.5C8 5.77614 8.22386 6 8.5 6L11 6L11 9L8.5 9C8.22386 9 8 9.22386 8 9.5L8 11.5284L2.36023 7.5L8 3.4716Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxThickArrowRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 7.5C14 7.66148 13.922 7.81301 13.7906 7.90687L6.79062 12.9069C6.63821 13.0157 6.43774 13.0303 6.27121 12.9446C6.10467 12.8589 6 12.6873 6 12.5L6 10L3.5 10C3.22386 10 3 9.77614 3 9.5L3 5.5C3 5.22386 3.22386 5 3.5 5L6 5L6 2.5C6 2.31271 6.10467 2.14112 6.27121 2.05542C6.43774 1.96972 6.63821 1.98427 6.79062 2.09313L13.7906 7.09314C13.922 7.18699 14 7.33853 14 7.5ZM7 3.4716L7 5.5C7 5.77614 6.77614 6 6.5 6L4 6L4 9L6.5 9C6.77614 9 7 9.22386 7 9.5L7 11.5284L12.6398 7.5L7 3.4716Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxThickArrowUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.5 1C7.66148 1 7.81301 1.07798 7.90687 1.20938L12.9069 8.20938C13.0157 8.36179 13.0303 8.56226 12.9446 8.72879C12.8589 8.89533 12.6873 9 12.5 9H10V11.5C10 11.7761 9.77614 12 9.5 12H5.5C5.22386 12 5 11.7761 5 11.5V9H2.5C2.31271 9 2.14112 8.89533 2.05542 8.72879C1.96972 8.56226 1.98427 8.36179 2.09314 8.20938L7.09314 1.20938C7.18699 1.07798 7.33853 1 7.5 1ZM3.4716 8H5.5C5.77614 8 6 8.22386 6 8.5V11H9V8.5C9 8.22386 9.22386 8 9.5 8H11.5284L7.5 2.36023L3.4716 8Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTimer(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49998 0.849976C7.22383 0.849976 6.99998 1.07383 6.99998 1.34998V3.52234C6.99998 3.79848 7.22383 4.02234 7.49998 4.02234C7.77612 4.02234 7.99998 3.79848 7.99998 3.52234V1.8718C10.8862 2.12488 13.15 4.54806 13.15 7.49998C13.15 10.6204 10.6204 13.15 7.49998 13.15C4.37957 13.15 1.84998 10.6204 1.84998 7.49998C1.84998 6.10612 2.35407 4.83128 3.19049 3.8459C3.36919 3.63538 3.34339 3.31985 3.13286 3.14115C2.92234 2.96245 2.60681 2.98825 2.42811 3.19877C1.44405 4.35808 0.849976 5.86029 0.849976 7.49998C0.849976 11.1727 3.82728 14.15 7.49998 14.15C11.1727 14.15 14.15 11.1727 14.15 7.49998C14.15 3.82728 11.1727 0.849976 7.49998 0.849976ZM6.74049 8.08072L4.22363 4.57237C4.15231 4.47295 4.16346 4.33652 4.24998 4.25C4.33649 4.16348 4.47293 4.15233 4.57234 4.22365L8.08069 6.74051C8.56227 7.08599 8.61906 7.78091 8.19998 8.2C7.78089 8.61909 7.08597 8.56229 6.74049 8.08072Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTokens(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.5 2C3.11929 2 2 3.11929 2 4.5C2 5.88072 3.11929 7 4.5 7C5.88072 7 7 5.88072 7 4.5C7 3.11929 5.88072 2 4.5 2ZM3 4.5C3 3.67157 3.67157 3 4.5 3C5.32843 3 6 3.67157 6 4.5C6 5.32843 5.32843 6 4.5 6C3.67157 6 3 5.32843 3 4.5ZM10.5 2C9.11929 2 8 3.11929 8 4.5C8 5.88072 9.11929 7 10.5 7C11.8807 7 13 5.88072 13 4.5C13 3.11929 11.8807 2 10.5 2ZM9 4.5C9 3.67157 9.67157 3 10.5 3C11.3284 3 12 3.67157 12 4.5C12 5.32843 11.3284 6 10.5 6C9.67157 6 9 5.32843 9 4.5ZM2 10.5C2 9.11929 3.11929 8 4.5 8C5.88072 8 7 9.11929 7 10.5C7 11.8807 5.88072 13 4.5 13C3.11929 13 2 11.8807 2 10.5ZM4.5 9C3.67157 9 3 9.67157 3 10.5C3 11.3284 3.67157 12 4.5 12C5.32843 12 6 11.3284 6 10.5C6 9.67157 5.32843 9 4.5 9ZM10.5 8C9.11929 8 8 9.11929 8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8ZM9 10.5C9 9.67157 9.67157 9 10.5 9C11.3284 9 12 9.67157 12 10.5C12 11.3284 11.3284 12 10.5 12C9.67157 12 9 11.3284 9 10.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTrackNext(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M13.0502 2.74989C13.0502 2.44613 12.804 2.19989 12.5002 2.19989C12.1965 2.19989 11.9502 2.44613 11.9502 2.74989V7.2825C11.9046 7.18802 11.8295 7.10851 11.7334 7.05776L2.73338 2.30776C2.5784 2.22596 2.3919 2.23127 2.24182 2.32176C2.09175 2.41225 2 2.57471 2 2.74995V12.25C2 12.4252 2.09175 12.5877 2.24182 12.6781C2.3919 12.7686 2.5784 12.7739 2.73338 12.6921L11.7334 7.94214C11.8295 7.89139 11.9046 7.81188 11.9502 7.7174V12.2499C11.9502 12.5536 12.1965 12.7999 12.5002 12.7999C12.804 12.7999 13.0502 12.5536 13.0502 12.2499V2.74989ZM3 11.4207V3.5792L10.4288 7.49995L3 11.4207Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTrackPrevious(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.94976 2.74989C1.94976 2.44613 2.196 2.19989 2.49976 2.19989C2.80351 2.19989 3.04976 2.44613 3.04976 2.74989V7.2825C3.0954 7.18802 3.17046 7.10851 3.26662 7.05776L12.2666 2.30776C12.4216 2.22596 12.6081 2.23127 12.7582 2.32176C12.9083 2.41225 13 2.57471 13 2.74995V12.25C13 12.4252 12.9083 12.5877 12.7582 12.6781C12.6081 12.7686 12.4216 12.7739 12.2666 12.6921L3.26662 7.94214C3.17046 7.89139 3.0954 7.81188 3.04976 7.7174V12.2499C3.04976 12.5536 2.80351 12.7999 2.49976 12.7999C2.196 12.7999 1.94976 12.5536 1.94976 12.2499V2.74989ZM4.57122 7.49995L12 11.4207V3.5792L4.57122 7.49995Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTransform(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.849976 1.74998C0.849976 1.25292 1.25292 0.849976 1.74998 0.849976H3.24998C3.74703 0.849976 4.14998 1.25292 4.14998 1.74998V2.04998H10.85V1.74998C10.85 1.25292 11.2529 0.849976 11.75 0.849976H13.25C13.747 0.849976 14.15 1.25292 14.15 1.74998V3.24998C14.15 3.74703 13.747 4.14998 13.25 4.14998H12.95V10.85H13.25C13.747 10.85 14.15 11.2529 14.15 11.75V13.25C14.15 13.747 13.747 14.15 13.25 14.15H11.75C11.2529 14.15 10.85 13.747 10.85 13.25V12.95H4.14998V13.25C4.14998 13.747 3.74703 14.15 3.24998 14.15H1.74998C1.25292 14.15 0.849976 13.747 0.849976 13.25V11.75C0.849976 11.2529 1.25292 10.85 1.74998 10.85H2.04998V4.14998H1.74998C1.25292 4.14998 0.849976 3.74703 0.849976 3.24998V1.74998ZM2.94998 4.14998V10.85H3.24998C3.74703 10.85 4.14998 11.2529 4.14998 11.75V12.05H10.85V11.75C10.85 11.2529 11.2529 10.85 11.75 10.85H12.05V4.14998H11.75C11.2529 4.14998 10.85 3.74703 10.85 3.24998V2.94998H4.14998V3.24998C4.14998 3.74703 3.74703 4.14998 3.24998 4.14998H2.94998ZM2.34998 1.74998H1.74998V2.34998V2.64998V3.24998H2.34998H2.64998H3.24998V2.64998V2.34998V1.74998H2.64998H2.34998ZM5.09998 5.99998C5.09998 5.50292 5.50292 5.09998 5.99998 5.09998H6.99998C7.49703 5.09998 7.89998 5.50292 7.89998 5.99998V6.99998C7.89998 7.03591 7.89787 7.07134 7.89378 7.10618C7.92861 7.10208 7.96405 7.09998 7.99998 7.09998H8.99998C9.49703 7.09998 9.89998 7.50292 9.89998 7.99998V8.99998C9.89998 9.49703 9.49703 9.89998 8.99998 9.89998H7.99998C7.50292 9.89998 7.09998 9.49703 7.09998 8.99998V7.99998C7.09998 7.96405 7.10208 7.92861 7.10618 7.89378C7.07134 7.89787 7.03591 7.89998 6.99998 7.89998H5.99998C5.50292 7.89998 5.09998 7.49703 5.09998 6.99998V5.99998ZM6.09998 5.99998H5.99998V6.09998V6.89998V6.99998H6.09998H6.89998H6.99998V6.89998V6.09998V5.99998H6.89998H6.09998ZM7.99998 7.99998H8.09998H8.89998H8.99998V8.09998V8.89998V8.99998H8.89998H8.09998H7.99998V8.89998V8.09998V7.99998ZM2.64998 11.75H2.34998H1.74998V12.35V12.65V13.25H2.34998H2.64998H3.24998V12.65V12.35V11.75H2.64998ZM11.75 1.74998H12.35H12.65H13.25V2.34998V2.64998V3.24998H12.65H12.35H11.75V2.64998V2.34998V1.74998ZM12.65 11.75H12.35H11.75V12.35V12.65V13.25H12.35H12.65H13.25V12.65V12.35V11.75H12.65Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTransparencyGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "opacity": ".25",
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0 0H3V3H0V0ZM6 3H3V6H0V9H3V12H0V15H3V12H6V15H9V12H12V15H15V12H12V9H15V6H12V3H15V0H12V3H9V0H6V3ZM6 6V3H9V6H6ZM6 9H3V6H6V9ZM9 9V6H12V9H9ZM9 9H6V12H9V9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTrash(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTriangleDown(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 6H11L7.5 10.5L4 6Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTriangleLeft(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M9 4L9 11L4.5 7.5L9 4Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTriangleRight(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M6 11L6 4L10.5 7.5L6 11Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTriangleUp(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "d": "M4 9H11L7.5 4.5L4 9Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxTwitterLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.23336 4.69629C7.23336 2.96884 8.63335 1.56857 10.36 1.56857C11.3736 1.56857 12.183 2.04804 12.7254 2.74385C13.3079 2.62467 13.8557 2.40913 14.3513 2.11508C14.1559 2.72598 13.7424 3.2396 13.2033 3.56463C13.2038 3.56568 13.2042 3.56674 13.2047 3.56779C13.7334 3.50361 14.2364 3.36302 14.7048 3.15546L14.7037 3.15715C14.3667 3.66183 13.9431 4.10736 13.4561 4.47034C13.4823 4.64672 13.4956 4.82427 13.4956 5.00079C13.4956 8.6871 10.6873 12.9746 5.52122 12.9746C3.93906 12.9746 2.46544 12.511 1.22505 11.7152C0.992632 11.5661 0.925108 11.2568 1.07423 11.0244C1.0874 11.0038 1.10183 10.9846 1.11734 10.9666C1.20582 10.8202 1.37438 10.7309 1.5554 10.7522C2.47066 10.8601 3.38568 10.7485 4.19219 10.3962C3.39226 10.0434 2.77129 9.35975 2.50204 8.51974C2.45359 8.3686 2.48835 8.20311 2.59351 8.08422C2.59716 8.0801 2.60087 8.07606 2.60464 8.0721C1.96391 7.50819 1.55973 6.68208 1.55973 5.76143V5.72759C1.55973 5.56814 1.64411 5.42059 1.78155 5.33974C1.82671 5.31317 1.87537 5.29511 1.92532 5.28558C1.70549 4.86154 1.58116 4.37984 1.58116 3.86958C1.58116 3.40165 1.58384 2.81192 1.91332 2.28081C1.98718 2.16175 2.10758 2.08915 2.2364 2.07195C2.42588 2.01237 2.64087 2.06969 2.77406 2.23302C3.86536 3.57126 5.44066 4.49583 7.23366 4.73961L7.23336 4.69629ZM5.52122 11.9746C4.73387 11.9746 3.97781 11.8435 3.27248 11.6023C4.13012 11.4538 4.95307 11.1159 5.66218 10.5602C5.81211 10.4427 5.87182 10.2435 5.81126 10.0629C5.7507 9.88234 5.583 9.75943 5.39255 9.75607C4.68968 9.74366 4.06712 9.39716 3.67793 8.86845C3.86828 8.85306 4.05428 8.82039 4.23445 8.77167C4.43603 8.71716 4.57363 8.53114 4.56674 8.32243C4.55985 8.11372 4.41029 7.93718 4.20555 7.89607C3.42694 7.73977 2.79883 7.16764 2.56169 6.42174C2.76255 6.47025 2.97102 6.4991 3.18482 6.5061C3.38563 6.51267 3.56646 6.38533 3.62795 6.19405C3.68943 6.00277 3.61666 5.79391 3.44963 5.68224C2.86523 5.29155 2.48116 4.62464 2.48116 3.86958C2.48116 3.70213 2.48352 3.55268 2.49355 3.41719C3.85115 4.79913 5.70873 5.68931 7.77588 5.79338C7.93225 5.80126 8.08328 5.73543 8.18395 5.61553C8.28463 5.49562 8.32332 5.33548 8.28851 5.18284C8.25255 5.02517 8.23336 4.86284 8.23336 4.69629C8.23336 3.52085 9.18591 2.56857 10.36 2.56857C11.5943 2.56857 12.4956 3.71208 12.4956 5.00079C12.4956 8.25709 10.0202 11.9746 5.52122 11.9746Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxUnderline(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxUpdate(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.90321 7.29677C1.90321 10.341 4.11041 12.4147 6.58893 12.8439C6.87255 12.893 7.06266 13.1627 7.01355 13.4464C6.96444 13.73 6.69471 13.9201 6.41109 13.871C3.49942 13.3668 0.86084 10.9127 0.86084 7.29677C0.860839 5.76009 1.55996 4.55245 2.37639 3.63377C2.96124 2.97568 3.63034 2.44135 4.16846 2.03202L2.53205 2.03202C2.25591 2.03202 2.03205 1.80816 2.03205 1.53202C2.03205 1.25588 2.25591 1.03202 2.53205 1.03202L5.53205 1.03202C5.80819 1.03202 6.03205 1.25588 6.03205 1.53202L6.03205 4.53202C6.03205 4.80816 5.80819 5.03202 5.53205 5.03202C5.25591 5.03202 5.03205 4.80816 5.03205 4.53202L5.03205 2.68645L5.03054 2.68759L5.03045 2.68766L5.03044 2.68767L5.03043 2.68767C4.45896 3.11868 3.76059 3.64538 3.15554 4.3262C2.44102 5.13021 1.90321 6.10154 1.90321 7.29677ZM13.0109 7.70321C13.0109 4.69115 10.8505 2.6296 8.40384 2.17029C8.12093 2.11718 7.93465 1.84479 7.98776 1.56188C8.04087 1.27898 8.31326 1.0927 8.59616 1.14581C11.4704 1.68541 14.0532 4.12605 14.0532 7.70321C14.0532 9.23988 13.3541 10.4475 12.5377 11.3662C11.9528 12.0243 11.2837 12.5586 10.7456 12.968L12.3821 12.968C12.6582 12.968 12.8821 13.1918 12.8821 13.468C12.8821 13.7441 12.6582 13.968 12.3821 13.968L9.38205 13.968C9.10591 13.968 8.88205 13.7441 8.88205 13.468L8.88205 10.468C8.88205 10.1918 9.10591 9.96796 9.38205 9.96796C9.65819 9.96796 9.88205 10.1918 9.88205 10.468L9.88205 12.3135L9.88362 12.3123C10.4551 11.8813 11.1535 11.3546 11.7585 10.6738C12.4731 9.86976 13.0109 8.89844 13.0109 7.70321Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxUpload(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.81825 1.18188C7.64251 1.00615 7.35759 1.00615 7.18185 1.18188L4.18185 4.18188C4.00611 4.35762 4.00611 4.64254 4.18185 4.81828C4.35759 4.99401 4.64251 4.99401 4.81825 4.81828L7.05005 2.58648V9.49996C7.05005 9.74849 7.25152 9.94996 7.50005 9.94996C7.74858 9.94996 7.95005 9.74849 7.95005 9.49996V2.58648L10.1819 4.81828C10.3576 4.99401 10.6425 4.99401 10.8182 4.81828C10.994 4.64254 10.994 4.35762 10.8182 4.18188L7.81825 1.18188ZM2.5 9.99997C2.77614 9.99997 3 10.2238 3 10.5V12C3 12.5538 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2238 12.2239 9.99997 12.5 9.99997C12.7761 9.99997 13 10.2238 13 10.5V12C13 13.104 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2238 2.22386 9.99997 2.5 9.99997Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxValueNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49985 0.877045C3.84216 0.877045 0.877014 3.84219 0.877014 7.49988C0.877014 9.1488 1.47963 10.657 2.47665 11.8162L1.64643 12.6464C1.45117 12.8417 1.45117 13.1583 1.64643 13.3535C1.8417 13.5488 2.15828 13.5488 2.35354 13.3535L3.18377 12.5233C4.34296 13.5202 5.85104 14.1227 7.49985 14.1227C11.1575 14.1227 14.1227 11.1575 14.1227 7.49988C14.1227 5.85107 13.5202 4.34299 12.5233 3.1838L13.3535 2.35354C13.5488 2.15827 13.5488 1.84169 13.3535 1.64643C13.1583 1.45117 12.8417 1.45117 12.6464 1.64643L11.8162 2.47668C10.657 1.47966 9.14877 0.877045 7.49985 0.877045ZM11.1422 3.15066C10.1567 2.32449 8.88639 1.82704 7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.88642 2.32446 10.1568 3.15063 11.1422L11.1422 3.15066ZM3.85776 11.8493C4.84317 12.6753 6.11343 13.1727 7.49985 13.1727C10.6328 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 6.11346 12.6753 4.8432 11.8493 3.85779L3.85776 11.8493Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxValue(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxVercelLogo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7.49998 1L6.92321 2.00307L1.17498 12L0.599976 13H1.7535H13.2464H14.4L13.825 12L8.07674 2.00307L7.49998 1ZM7.49998 3.00613L2.3285 12H12.6714L7.49998 3.00613Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxVideo(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.76447 3.12199C5.63151 3.04859 6.56082 3 7.5 3C8.43918 3 9.36849 3.04859 10.2355 3.12199C11.2796 3.21037 11.9553 3.27008 12.472 3.39203C12.9425 3.50304 13.2048 3.64976 13.4306 3.88086C13.4553 3.90618 13.4902 3.94414 13.5133 3.97092C13.7126 4.20149 13.8435 4.4887 13.918 5.03283C13.9978 5.6156 14 6.37644 14 7.52493C14 8.66026 13.9978 9.41019 13.9181 9.98538C13.8439 10.5206 13.7137 10.8061 13.5125 11.0387C13.4896 11.0651 13.4541 11.1038 13.4296 11.1287C13.2009 11.3625 12.9406 11.5076 12.4818 11.6164C11.9752 11.7365 11.3143 11.7942 10.2878 11.8797C9.41948 11.9521 8.47566 12 7.5 12C6.52434 12 5.58052 11.9521 4.7122 11.8797C3.68572 11.7942 3.02477 11.7365 2.51816 11.6164C2.05936 11.5076 1.7991 11.3625 1.57037 11.1287C1.54593 11.1038 1.51035 11.0651 1.48748 11.0387C1.28628 10.8061 1.15612 10.5206 1.08193 9.98538C1.00221 9.41019 1 8.66026 1 7.52493C1 6.37644 1.00216 5.6156 1.082 5.03283C1.15654 4.4887 1.28744 4.20149 1.48666 3.97092C1.5098 3.94414 1.54468 3.90618 1.56942 3.88086C1.7952 3.64976 2.05752 3.50304 2.52796 3.39203C3.04473 3.27008 3.7204 3.21037 4.76447 3.12199ZM0 7.52493C0 5.28296 0 4.16198 0.729985 3.31713C0.766457 3.27491 0.815139 3.22194 0.854123 3.18204C1.63439 2.38339 2.64963 2.29744 4.68012 2.12555C5.56923 2.05028 6.52724 2 7.5 2C8.47276 2 9.43077 2.05028 10.3199 2.12555C12.3504 2.29744 13.3656 2.38339 14.1459 3.18204C14.1849 3.22194 14.2335 3.27491 14.27 3.31713C15 4.16198 15 5.28296 15 7.52493C15 9.74012 15 10.8477 14.2688 11.6929C14.2326 11.7348 14.1832 11.7885 14.1444 11.8281C13.3629 12.6269 12.3655 12.71 10.3709 12.8763C9.47971 12.9505 8.50782 13 7.5 13C6.49218 13 5.52028 12.9505 4.62915 12.8763C2.63446 12.71 1.63712 12.6269 0.855558 11.8281C0.816844 11.7885 0.767442 11.7348 0.731221 11.6929C0 10.8477 0 9.74012 0 7.52493ZM5.25 5.38264C5.25 5.20225 5.43522 5.08124 5.60041 5.15369L10.428 7.27105C10.6274 7.35853 10.6274 7.64147 10.428 7.72895L5.60041 9.84631C5.43522 9.91876 5.25 9.79775 5.25 9.61736V5.38264Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxViewGrid(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M7 2H1.5C1.22386 2 1 2.22386 1 2.5V7H7V2ZM8 2V7H14V2.5C14 2.22386 13.7761 2 13.5 2H8ZM7 8H1V12.5C1 12.7761 1.22386 13 1.5 13H7V8ZM8 13V8H14V12.5C14 12.7761 13.7761 13 13.5 13H8ZM1.5 1C0.671573 1 0 1.67157 0 2.5V12.5C0 13.3284 0.671573 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.67157 14.3284 1 13.5 1H1.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxViewHorizontal(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M1.5 2H13.5C13.7761 2 14 2.22386 14 2.5V7H1V2.5C1 2.22386 1.22386 2 1.5 2ZM1 8V12.5C1 12.7761 1.22386 13 1.5 13H13.5C13.7761 13 14 12.7761 14 12.5V8H1ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxViewNone(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M14 2.58711L1.85163 13H13.5C13.7761 13 14 12.7761 14 12.5V2.58711ZM0.762879 13.8067L0.825396 13.8796L0.854717 13.8545C1.05017 13.9478 1.26899 14 1.5 14H13.5C14.3284 14 15 13.3284 15 12.5V2.5C15 1.93949 14.6926 1.45078 14.2371 1.19331L14.1746 1.12037L14.1453 1.1455C13.9498 1.05222 13.731 1 13.5 1H1.5C0.671573 1 0 1.67157 0 2.5V12.5C0 13.0605 0.307435 13.5492 0.762879 13.8067ZM1 12.4129L13.1484 2H1.5C1.22386 2 1 2.22386 1 2.5V12.4129Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxViewVertical(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M8 2H13.5C13.7761 2 14 2.22386 14 2.5V12.5C14 12.7761 13.7761 13 13.5 13H8V2ZM7 2H1.5C1.22386 2 1 2.22386 1 2.5V12.5C1 12.7761 1.22386 13 1.5 13H7V2ZM0 2.5C0 1.67157 0.671573 1 1.5 1H13.5C14.3284 1 15 1.67157 15 2.5V12.5C15 13.3284 14.3284 14 13.5 14H1.5C0.671573 14 0 13.3284 0 12.5V2.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxWidth(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M4.81812 4.68161C4.99386 4.85734 4.99386 5.14227 4.81812 5.318L3.08632 7.0498H11.9135L10.1817 5.318C10.006 5.14227 10.006 4.85734 10.1817 4.68161C10.3575 4.50587 10.6424 4.50587 10.8181 4.68161L13.3181 7.18161C13.4939 7.35734 13.4939 7.64227 13.3181 7.818L10.8181 10.318C10.6424 10.4937 10.3575 10.4937 10.1817 10.318C10.006 10.1423 10.006 9.85734 10.1817 9.68161L11.9135 7.9498H3.08632L4.81812 9.68161C4.99386 9.85734 4.99386 10.1423 4.81812 10.318C4.64239 10.4937 4.35746 10.4937 4.18173 10.318L1.68173 7.818C1.50599 7.64227 1.50599 7.35734 1.68173 7.18161L4.18173 4.68161C4.35746 4.50587 4.64239 4.50587 4.81812 4.68161Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxZoomIn(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M10 6.5C10 8.433 8.433 10 6.5 10C4.567 10 3 8.433 3 6.5C3 4.567 4.567 3 6.5 3C8.433 3 10 4.567 10 6.5ZM9.30884 10.0159C8.53901 10.6318 7.56251 11 6.5 11C4.01472 11 2 8.98528 2 6.5C2 4.01472 4.01472 2 6.5 2C8.98528 2 11 4.01472 11 6.5C11 7.56251 10.6318 8.53901 10.0159 9.30884L12.8536 12.1464C13.0488 12.3417 13.0488 12.6583 12.8536 12.8536C12.6583 13.0488 12.3417 13.0488 12.1464 12.8536L9.30884 10.0159ZM4.25 6.5C4.25 6.22386 4.47386 6 4.75 6H6V4.75C6 4.47386 6.22386 4.25 6.5 4.25C6.77614 4.25 7 4.47386 7 4.75V6H8.25C8.52614 6 8.75 6.22386 8.75 6.5C8.75 6.77614 8.52614 7 8.25 7H7V8.25C7 8.52614 6.77614 8.75 6.5 8.75C6.22386 8.75 6 8.52614 6 8.25V7H4.75C4.47386 7 4.25 6.77614 4.25 6.5Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}
function RxZoomOut(props) {
    return (0, _lib.GenIcon)({
        "tag": "svg",
        "attr": {
            "viewBox": "0 0 15 15",
            "fill": "none"
        },
        "child": [
            {
                "tag": "path",
                "attr": {
                    "fillRule": "evenodd",
                    "clipRule": "evenodd",
                    "d": "M6.5 10C8.433 10 10 8.433 10 6.5C10 4.567 8.433 3 6.5 3C4.567 3 3 4.567 3 6.5C3 8.433 4.567 10 6.5 10ZM6.5 11C7.56251 11 8.53901 10.6318 9.30884 10.0159L12.1464 12.8536C12.3417 13.0488 12.6583 13.0488 12.8536 12.8536C13.0488 12.6583 13.0488 12.3417 12.8536 12.1464L10.0159 9.30884C10.6318 8.53901 11 7.56251 11 6.5C11 4.01472 8.98528 2 6.5 2C4.01472 2 2 4.01472 2 6.5C2 8.98528 4.01472 11 6.5 11ZM4.75 6C4.47386 6 4.25 6.22386 4.25 6.5C4.25 6.77614 4.47386 7 4.75 7H8.25C8.52614 7 8.75 6.77614 8.75 6.5C8.75 6.22386 8.52614 6 8.25 6H4.75Z",
                    "fill": "currentColor"
                }
            }
        ]
    })(props);
}

},{"../lib":"9iXc2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1XNhU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var getDirectionStyle = function getDirectionStyle(dir, size) {
    var directionStyle = {
        left: {
            top: 0,
            left: 0,
            transform: 'translate3d(-100%, 0, 0)',
            width: size,
            height: '100vh'
        },
        right: {
            top: 0,
            right: 0,
            transform: 'translate3d(100%, 0, 0)',
            width: size,
            height: '100vh'
        },
        bottom: {
            left: 0,
            right: 0,
            bottom: 0,
            transform: 'translate3d(0, 100%, 0)',
            width: '100%',
            height: size
        },
        top: {
            left: 0,
            right: 0,
            top: 0,
            transform: 'translate3d(0, -100%, 0)',
            width: '100%',
            height: size
        }
    };
    return directionStyle[dir];
};
var EZDrawer = function EZDrawer(props) {
    var open = props.open, _props$onClose = props.onClose, onClose = _props$onClose === void 0 ? function() {} : _props$onClose, children = props.children, style = props.style, _props$enableOverlay = props.enableOverlay, enableOverlay = _props$enableOverlay === void 0 ? true : _props$enableOverlay, _props$overlayColor = props.overlayColor, overlayColor = _props$overlayColor === void 0 ? '#000' : _props$overlayColor, _props$overlayOpacity = props.overlayOpacity, overlayOpacity = _props$overlayOpacity === void 0 ? 0.4 : _props$overlayOpacity, _props$zIndex = props.zIndex, zIndex = _props$zIndex === void 0 ? 100 : _props$zIndex, _props$duration = props.duration, duration = _props$duration === void 0 ? 500 : _props$duration, direction = props.direction, _props$size = props.size, size = _props$size === void 0 ? 250 : _props$size, className = props.className, customIdSuffix = props.customIdSuffix, _props$lockBackground = props.lockBackgroundScroll, lockBackgroundScroll = _props$lockBackground === void 0 ? false : _props$lockBackground, _props$overlayClassNa = props.overlayClassName, overlayClassName = _props$overlayClassNa === void 0 ? '' : _props$overlayClassNa;
    var bodyRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var updatePageScroll = function updatePageScroll() {
            bodyRef.current = window.document.querySelector('body');
            if (bodyRef.current && lockBackgroundScroll) bodyRef.current.style.overflow = open ? 'hidden' : '';
        };
        updatePageScroll();
    }, [
        open
    ]);
    var idSuffix = (0, _react.useMemo)(function() {
        return customIdSuffix || (Math.random() + 1).toString(36).substring(7);
    }, [
        customIdSuffix
    ]);
    var overlayStyles = {
        backgroundColor: overlayColor.toString(),
        opacity: overlayOpacity,
        zIndex: zIndex
    };
    var drawerStyles = _extends({
        zIndex: zIndex + 1,
        transitionDuration: duration + "ms"
    }, getDirectionStyle(direction, size), style);
    return (0, _reactDefault.default).createElement("div", {
        id: 'EZDrawer' + idSuffix,
        className: 'EZDrawer'
    }, (0, _reactDefault.default).createElement("input", {
        type: 'checkbox',
        id: 'EZDrawer__checkbox' + idSuffix,
        className: 'EZDrawer__checkbox',
        onChange: onClose,
        checked: open
    }), (0, _reactDefault.default).createElement("nav", {
        role: 'navigation',
        id: 'EZDrawer__container' + idSuffix,
        style: drawerStyles,
        className: 'EZDrawer__container ' + className
    }, children), enableOverlay && (0, _reactDefault.default).createElement("label", {
        htmlFor: 'EZDrawer__checkbox' + idSuffix,
        id: 'EZDrawer__overlay' + idSuffix,
        className: 'EZDrawer__overlay ' + overlayClassName,
        style: overlayStyles
    }));
};
exports.default = EZDrawer;

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4HHR2":[function() {},{}],"iBYyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _stylesCss = require("react-grid-layout/css/styles.css");
var _md = require("react-icons/md");
var _useAudioNode = require("../../hooks/useAudioNode");
var _useAudioNodeDefault = parcelHelpers.interopDefault(_useAudioNode);
var _useNode = require("../../hooks/useNode");
var _useNodeDefault = parcelHelpers.interopDefault(_useNode);
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _styles = require("./styles");
let _ = (t)=>t, t;
const ControlPanelNodeWrapper = (0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
`));
const PanelNode = (props)=>{
    const { node } = props;
    const getControlPanelNode = (0, _storeDefault.default)((store)=>store.getControlPanelNode);
    const ControlPanelNode = (0, _react.useMemo)(()=>getControlPanelNode(node), [
        node
    ]);
    if (!ControlPanelNode) return null;
    return (0, _jsxRuntime.jsx)(ControlPanelNode, (0, _objectSpread._)({}, props));
};
const ControlPanelItem = (props)=>{
    const { node, showControls, onDelete } = props;
    const theme = (0, _useThemeDefault.default)();
    const { id } = node;
    const { node: audioNode } = (0, _useAudioNodeDefault.default)(id) || {};
    const { updateNodeValues } = (0, _useNodeDefault.default)(id);
    return (0, _jsxRuntime.jsxs)(ControlPanelNodeWrapper, {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _styles.TitleBarWrapper), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _styles.PanelTitle), {
                        children: node.data.label
                    }),
                    showControls && (0, _jsxRuntime.jsxs)((0, _styles.IconsBar), {
                        children: [
                            (0, _jsxRuntime.jsx)((0, _styles.IconWrapper), {
                                theme: theme,
                                children: (0, _jsxRuntime.jsx)((0, _md.MdDragHandle), {
                                    className: "grid-item-handle"
                                })
                            }),
                            (0, _jsxRuntime.jsx)((0, _styles.IconWrapper), {
                                theme: theme,
                                children: (0, _jsxRuntime.jsx)((0, _md.MdClose), {
                                    onClick: ()=>onDelete(node)
                                })
                            })
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)(PanelNode, {
                node: node,
                audioNode: audioNode,
                updateNodeValues: updateNodeValues
            })
        ]
    });
};
exports.default = ControlPanelItem;

},{"@swc/helpers/_/_object_spread":"awBF9","react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","react-grid-layout/css/styles.css":"coJMT","react-icons/md":"ixP1W","../../hooks/useAudioNode":"wk4N8","../../hooks/useNode":"7m9CB","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","./styles":"bZthZ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"coJMT":[function() {},{}],"wk4N8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const useAudioNode = (id)=>{
    const patch = (0, _storeDefault.default)(({ patch })=>patch);
    return patch.audioNodes.get(id);
};
exports.default = useAudioNode;

},{"../store":"eveyc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7m9CB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const useNode = (id)=>{
    const updateNodeData = (0, _storeDefault.default)(({ updateNodeData })=>updateNodeData);
    const updateNodeValues = (0, _react.useCallback)((values)=>updateNodeData(id, {
            values
        }), [
        id,
        updateNodeData
    ]);
    const updateNodeConfig = (0, _react.useCallback)((config)=>updateNodeData(id, {
            config
        }), [
        id,
        updateNodeData
    ]);
    const updateNodeLabel = (0, _react.useCallback)((label)=>updateNodeData(id, {
            label
        }), [
        id,
        updateNodeData
    ]);
    return {
        updateNodeValues,
        updateNodeConfig,
        updateNodeLabel
    };
};
exports.default = useNode;

},{"react":"lXMxO","../store":"eveyc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bZthZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanelTitle", ()=>PanelTitle);
parcelHelpers.export(exports, "TitleBarWrapper", ()=>TitleBarWrapper);
parcelHelpers.export(exports, "IconsBar", ()=>IconsBar);
parcelHelpers.export(exports, "IconWrapper", ()=>IconWrapper);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _stylesCss = require("react-grid-layout/css/styles.css");
var _node = require("../Node");
let _ = (t)=>t, t, t1, t2, t3;
const PanelTitle = (0, _styledDefault.default).div(t || (t = _`
  width: 100%;
  padding: 0.4rem 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`));
const TitleBarWrapper = (0, _styledDefault.default)((0, _node.TitleBar))(t1 || (t1 = _`
  display: flex;
  gap: 0.1rem;
  padding: 0 0.4rem;
  justify-content: start;
  font-size: 0.6rem;
  height: auto;
  min-width: 0;
`));
const IconsBar = (0, _styledDefault.default).div(t2 || (t2 = _`
  display: flex;
  align-items: center;
  height: 70%;
  width: auto;
  gap: 0.4rem;
`));
const IconWrapper = (0, _styledDefault.default).span(t3 || (t3 = _`
  width: auto;
  height: 100%;
  cursor: pointer;
  svg {
    width: auto;
    height: 100%;
  }
  &:hover {
    color: ${0};
    cursor: pointer;
  }
`), ({ theme })=>theme.colors.highlight2);

},{"@emotion/styled":"2Zr0D","react-grid-layout/css/styles.css":"coJMT","../Node":"hhQgt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"coJMT":[function() {},{}],"hhQgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TitleBarInner", ()=>TitleBarInner);
parcelHelpers.export(exports, "PortsPanel", ()=>PortsPanel);
parcelHelpers.export(exports, "InputPorts", ()=>InputPorts);
parcelHelpers.export(exports, "OutputPorts", ()=>OutputPorts);
parcelHelpers.export(exports, "Port", ()=>Port);
parcelHelpers.export(exports, "InputHandle", ()=>InputHandle);
parcelHelpers.export(exports, "StyledOutputHandle", ()=>StyledOutputHandle);
parcelHelpers.export(exports, "OutputHandle", ()=>OutputHandle);
parcelHelpers.export(exports, "TitleBar", ()=>TitleBar);
parcelHelpers.export(exports, "WNNode", ()=>WNNode);
var _extends = require("@swc/helpers/_/_extends");
var _objectDestructuringEmpty = require("@swc/helpers/_/_object_destructuring_empty");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _reResizable = require("re-resizable");
var _react1 = require("react");
var _md = require("react-icons/md");
var _reactflow = require("reactflow");
var _constants = require("../../constants");
var _useAudioNode = require("../../hooks/useAudioNode");
var _useAudioNodeDefault = parcelHelpers.interopDefault(_useAudioNode);
var _useNode = require("../../hooks/useNode");
var _useNodeDefault = parcelHelpers.interopDefault(_useNode);
var _useTheme = require("../../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _editableLabel = require("../EditableLabel");
var _editableLabelDefault = parcelHelpers.interopDefault(_editableLabel);
var _nodeInfoModal = require("../NodeInfoModal");
var _nodeInfoModalDefault = parcelHelpers.interopDefault(_nodeInfoModal);
let _ = (t)=>t, t, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12;
const NodeWrapper = (0, _styledDefault.default).div(t || (t = _`
  background-color: var(--leva-colors-elevation1);
`));
const NodeLoaderWrapper = (0, _styledDefault.default)(NodeWrapper)(t1 || (t1 = _`
  padding: 2rem 5rem;
`));
const NodeErrorWrapper = (0, _styledDefault.default)(NodeWrapper)(t2 || (t2 = _`
  padding: 1rem 2rem;
`));
const SettingsIconWrapper = (0, _styledDefault.default)((0, _md.MdSettings))(t3 || (t3 = _`
  font-size: 1.2rem;
  opacity: 0.4;
  width: 1rem;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`));
const InfoIconWrapper = (0, _styledDefault.default)((0, _md.MdInfoOutline))(t4 || (t4 = _`
  font-size: 1.2rem;
  opacity: 0.4;
  width: 1rem;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`));
const Section = (0, _styledDefault.default).div(t5 || (t5 = _`
  position: relative;
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  background-color: var(--leva-colors-elevation1);
`));
const TitleBarInner = (0, _styledDefault.default)(Section)(t6 || (t6 = _`
  display: flex;
  height: var(--leva-sizes-titleBarHeight);
  touch-action: none;
  align-items: center;
  justify-content: center;
  flex: 1 1 0%;
  color: var(--leva-colors-highlight1);
  padding: 0 0.4rem;
  gap: 0.3rem;
`));
const PortsPanel = (0, _styledDefault.default)(Section)(({ theme })=>`
  display: grid;
  grid-template-areas: "inputs outputs";
  background: ${theme.colors.elevation2};
  border-bottom: 1px solid ${theme.colors.elevation1};
  color: ${theme.colors.highlight3};
  font-size: 0.6rem;
`);
const InputPorts = (0, _styledDefault.default).div(t7 || (t7 = _`
  grid-area: inputs;
  text-align: left;
`));
const OutputPorts = (0, _styledDefault.default).div(t8 || (t8 = _`
  grid-area: outputs;
  text-align: right;
`));
const Port = (0, _styledDefault.default).div(t9 || (t9 = _`
  position: relative;
  padding: 5px 10px;
`));
const portColors = {
    [(0, _constants.PortType).Audio]: "#4ade80",
    [(0, _constants.PortType).Gate]: "#c084fc",
    [(0, _constants.PortType).Number]: "#38bdf8",
    [(0, _constants.PortType).Any]: "#ffffff"
};
const StyledHandle = (0, _react.withTheme)((0, _styledDefault.default)((0, _reactflow.Handle), {
    shouldForwardProp: (prop)=>prop !== "portType"
})(t10 || (t10 = _`
  --port-color: ${0};
  border-color: var(--port-color);
  background: var(--port-color);
  box-shadow: 0px 0px 0px 1px ${0} inset;
`), (props)=>{
    if (!props.portType) return props.theme.colors.highlight2;
    if (Array.isArray(props.portType)) {
        const colors = props.portType.map((type)=>portColors[type]);
        return `linear-gradient(0.25turn, ${colors.join(", ")});`;
    } else return portColors[props.portType];
}, ({ theme })=>theme.colors.elevation2));
const StyledInputHandle = (0, _react.withTheme)((0, _styledDefault.default)(StyledHandle)(t11 || (t11 = _`
  left: -3px;
`)));
const InputHandle = (_param)=>{
    var props = (0, _extends._)({}, (0, _objectDestructuringEmpty._)(_param));
    return (0, _jsxRuntime.jsx)(StyledInputHandle, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        type: "target",
        position: (0, _reactflow.Position).Left
    }));
};
const StyledOutputHandle = (0, _react.withTheme)((0, _styledDefault.default)(StyledHandle)(t12 || (t12 = _`
  right: -3px;
`)));
const OutputHandle = (props)=>(0, _jsxRuntime.jsx)(StyledOutputHandle, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        type: "source",
        position: (0, _reactflow.Position).Right
    }));
const TitleBar = (_param)=>{
    var { className } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "className"
    ]);
    return (0, _jsxRuntime.jsx)(TitleBarInner, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        className: [
            className,
            (0, _constants.DRAG_HANDLE_CLASS)
        ].join(" ")
    }));
};
const useNodeManifest = (type)=>{
    const data = (0, _storeDefault.default)((store)=>store.nodesConfiguration[type]);
    return data;
};
const useConfigNode = (type)=>{
    const { configNode: ConfigNode } = useNodeManifest(type);
    return {
        ConfigNode
    };
};
const WNNode = (props)=>{
    var _data_config;
    const { id, children, selected } = props, rest = (0, _objectWithoutProperties._)(props, [
        "id",
        "children",
        "selected"
    ]);
    const theme = (0, _useThemeDefault.default)();
    const getNode = (0, _storeDefault.default)(({ getNode })=>getNode);
    const nodesConfiguration = (0, _storeDefault.default)((store)=>store.nodesConfiguration);
    const [isInfoModalShown, setIsInfoModalShown] = (0, _react1.useState)(false);
    const { info } = useNodeManifest(props.type);
    const isResizeable = (0, _react1.useMemo)(()=>{
        var _nodesConfiguration_props_type_resizable;
        return (_nodesConfiguration_props_type_resizable = nodesConfiguration[props.type].resizable) !== null && _nodesConfiguration_props_type_resizable !== void 0 ? _nodesConfiguration_props_type_resizable : false;
    }, [
        nodesConfiguration,
        props.type
    ]);
    const { updateNodeLabel, updateNodeConfig } = (0, _useNodeDefault.default)(id);
    const { data } = getNode(id) || {};
    const audioNode = (0, _useAudioNodeDefault.default)(id);
    const { ConfigNode } = useConfigNode(rest.type);
    const [configMode, setShowConfigMode] = (0, _react1.useState)(false);
    if (!audioNode) return (0, _jsxRuntime.jsx)(NodeLoaderWrapper, {
        className: (0, _constants.DRAG_HANDLE_CLASS),
        children: "can't find audio node"
    });
    if (audioNode.loading) return (0, _jsxRuntime.jsx)(NodeLoaderWrapper, {
        className: (0, _constants.DRAG_HANDLE_CLASS),
        children: "loading"
    });
    if (audioNode.error) return (0, _jsxRuntime.jsxs)(NodeErrorWrapper, {
        className: (0, _constants.DRAG_HANDLE_CLASS),
        children: [
            "error: ",
            audioNode.error.toString()
        ]
    });
    if (!audioNode.node) return (0, _jsxRuntime.jsx)(NodeLoaderWrapper, {
        className: (0, _constants.DRAG_HANDLE_CLASS),
        children: "can't find audio node"
    });
    const size = data === null || data === void 0 ? void 0 : (_data_config = data.config) === null || _data_config === void 0 ? void 0 : _data_config.size;
    const { node: { inputs, outputs } } = audioNode;
    var _data_label;
    return (0, _jsxRuntime.jsxs)(NodeWrapper, {
        children: [
            (0, _jsxRuntime.jsxs)(TitleBar, {
                children: [
                    info && (0, _jsxRuntime.jsx)(InfoIconWrapper, {
                        onClickCapture: ()=>setIsInfoModalShown(true)
                    }),
                    (0, _jsxRuntime.jsx)((0, _editableLabelDefault.default), {
                        value: (_data_label = data === null || data === void 0 ? void 0 : data.label) !== null && _data_label !== void 0 ? _data_label : "No Name",
                        onChange: updateNodeLabel
                    }),
                    ConfigNode && (0, _jsxRuntime.jsx)(SettingsIconWrapper, {
                        onClickCapture: ()=>setShowConfigMode((isShown)=>!isShown)
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)(PortsPanel, {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)(InputPorts, {
                        children: inputs ? Object.keys(inputs).map((key, index)=>(0, _jsxRuntime.jsxs)(Port, {
                                children: [
                                    (0, _jsxRuntime.jsx)(InputHandle, {
                                        id: key,
                                        portType: inputs[key].type
                                    }),
                                    (0, _jsxRuntime.jsx)("span", {
                                        children: key
                                    })
                                ]
                            }, index)) : null
                    }),
                    (0, _jsxRuntime.jsx)(OutputPorts, {
                        children: outputs ? Object.keys(outputs).map((key, index)=>(0, _jsxRuntime.jsxs)(Port, {
                                children: [
                                    (0, _jsxRuntime.jsx)(OutputHandle, {
                                        id: key,
                                        portType: outputs[key].type
                                    }),
                                    (0, _jsxRuntime.jsx)("span", {
                                        children: key
                                    })
                                ]
                            }, index)) : null
                    })
                ]
            }),
            ConfigNode && configMode && selected ? (0, _jsxRuntime.jsx)(ConfigNode, (0, _objectSpread._)({}, props)) : isResizeable ? (0, _jsxRuntime.jsx)((0, _reResizable.Resizable), {
                size: size,
                minWidth: 180,
                minHeight: 30,
                enable: {
                    bottom: true,
                    bottomRight: true,
                    right: true
                },
                onResizeStop: (e, direction, ref, d)=>{
                    const newSize = size ? {
                        width: size.width + d.width,
                        height: size.height + d.height
                    } : ref.getBoundingClientRect();
                    updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, data === null || data === void 0 ? void 0 : data.config), {
                        size: newSize
                    }));
                },
                children: children
            }) : children,
            (0, _jsxRuntime.jsx)((0, _nodeInfoModalDefault.default), {
                isOpen: isInfoModalShown,
                type: props.type,
                onClose: ()=>setIsInfoModalShown(false),
                node: audioNode.node
            })
        ]
    });
};

},{"@swc/helpers/_/_extends":"7g5cA","@swc/helpers/_/_object_destructuring_empty":"40DPb","@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","re-resizable":"7k9Hb","react":"lXMxO","react-icons/md":"ixP1W","reactflow":"eL4zf","../../constants":"k5UCO","../../hooks/useAudioNode":"wk4N8","../../hooks/useNode":"7m9CB","../../hooks/useTheme":"kxvkQ","../../store":"eveyc","../EditableLabel":"jH267","../NodeInfoModal":"g4nqW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jH267":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TitleBarLabel", ()=>TitleBarLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
let _ = (t)=>t, t;
const TitleBarLabel = (0, _styledDefault.default).input(t || (t = _`
  width: 100%;
  background: none;
  border: none;
  text-align: center;
  color: var(--leva-colors-highlight1);
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  cursor: inherit;
  text-overflow: ellipsis;
  outline: none;

  &:focus {
    box-shadow: 0 0 0 green var(--leva-colors-accent2);
  }
  &:focus-within {
    box-shadow: 0 0 0 green var(--leva-colors-accent2);
  }
  &:focus-vissible {
    box-shadow: 0 0 0 green var(--leva-colors-accent2);
  }
  &:not([readonly]):focus {
    color: #fff;
    appearance: none;
    cursor: auto;
    background-color: var(--leva-colors-elevation2);
    padding: 0.3rem;
    border-radius: 0.2rem;
  }
`));
const EditableLabel = ({ onChange, value = "", className })=>{
    const labelInputRef = (0, _react.useRef)(null);
    const [labelEditMode, setLabelEditMode] = (0, _react.useState)(false);
    const editNodeLabel = (0, _react.useCallback)((event)=>{
        var //@ts-ignore
        _event_target;
        (_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.select();
        setLabelEditMode(true);
    }, [
        setLabelEditMode
    ]);
    const exitEditMode = (0, _react.useCallback)(()=>{
        var _window_getSelection;
        (_window_getSelection = window.getSelection()) === null || _window_getSelection === void 0 ? void 0 : _window_getSelection.collapseToEnd();
        setLabelEditMode(false);
    }, [
        setLabelEditMode
    ]);
    const saveNodeLabel = (0, _react.useCallback)(()=>{
        exitEditMode();
        if (labelInputRef.current) onChange(labelInputRef.current.value);
    }, [
        labelInputRef,
        exitEditMode,
        onChange
    ]);
    const cancelNodeLabelEdit = (0, _react.useCallback)(()=>{
        exitEditMode();
        if (labelInputRef.current && value) labelInputRef.current.value = value;
    }, [
        labelInputRef,
        exitEditMode,
        value
    ]);
    (0, _react.useEffect)(()=>{
        if (!labelInputRef.current) return;
        labelInputRef.current.value = value;
    }, [
        value,
        labelInputRef
    ]);
    return (0, _jsxRuntime.jsx)(TitleBarLabel, {
        ref: labelInputRef,
        type: "text",
        readOnly: !labelEditMode,
        onDoubleClick: (event)=>editNodeLabel(event),
        onBlur: saveNodeLabel,
        onKeyDown: (event)=>{
            switch(event.key){
                case "Escape":
                    cancelNodeLabelEdit();
                    break;
                case "Enter":
                    saveNodeLabel();
                    break;
            }
        },
        className: className
    });
};
exports.default = EditableLabel;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"g4nqW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _marked = require("marked");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _react = require("@emotion/react");
var _react1 = require("react");
let _ = (t)=>t, t;
const NodeInfoWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
  overflow: scroll;
  padding: 0.6rem;
  box-sizing: border-box;

  hr {
    border: none;
    border-bottom: 1px solid ${0};
  }

  code {
    background-color: ${0};
    color: ${0};
    font-family:
      source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }

  pre {
    background-color: ${0};
    padding: 0.2rem 0.3rem;
    border-radius: 1px;
  }

  a {
    color: ${0};
  }
`), ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.highlight3, ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.accent1));
const useNodeManifest = (type)=>{
    const data = (0, _storeDefault.default)((store)=>store.nodesConfiguration[type]);
    return data;
};
const NodeInfoModal = ({ isOpen, onClose, type: nodeType, node })=>{
    const { info, portsDescription } = useNodeManifest(nodeType);
    const portsInfo = (0, _react1.useMemo)(()=>{
        const parts = [];
        const inputPorts = node.inputs;
        if (inputPorts) {
            parts.push(`## Inputs`);
            for(const portName in inputPorts){
                var _portsDescription_inputs;
                const port = inputPorts[portName];
                parts.push(`### *${portName}*`);
                const description = portsDescription === null || portsDescription === void 0 ? void 0 : (_portsDescription_inputs = portsDescription.inputs) === null || _portsDescription_inputs === void 0 ? void 0 : _portsDescription_inputs[portName];
                if (description) parts.push(description);
                if (Array.isArray(port.type)) parts.push(`**Types**: \`${port.type.join(", ")}\``);
                else parts.push(`**Type**: \`${port.type || "unknown"}\``);
                if (port.range) parts.push(`**Range**: \`[${port.range[0]}, ${port.range[1]}]\``);
                if (port.defaultValue !== undefined) parts.push(`**Default**: \`${port.defaultValue}\``);
            }
        }
        const outputPorts = node.outputs;
        if (outputPorts) {
            parts.push(`## Outputs`);
            for(const portName in outputPorts){
                var _portsDescription_outputs;
                const port = outputPorts[portName];
                parts.push(`### *${portName}*`);
                const description = portsDescription === null || portsDescription === void 0 ? void 0 : (_portsDescription_outputs = portsDescription.outputs) === null || _portsDescription_outputs === void 0 ? void 0 : _portsDescription_outputs[portName];
                if (description) parts.push(description);
                if (Array.isArray(port.type)) parts.push(`**Types**: \`${port.type.join(", ")}\``);
                else parts.push(`**Type**: \`${port.type || "unknown"}\``);
                if (port.range) parts.push(`**Range**: \`[${port.range[0]}, ${port.range[1]}]\``);
                if (port.defaultValue !== undefined) parts.push(`**Default**: \`${port.defaultValue}\``);
            }
        }
        return parts.join("\n\n");
    }, [
        node,
        portsDescription
    ]);
    const combinedInfo = (info || "") + "\n\n" + portsInfo;
    return isOpen ? (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        onClose: onClose,
        children: (0, _jsxRuntime.jsx)(NodeInfoWrapper, {
            dangerouslySetInnerHTML: {
                __html: (0, _marked.marked)(combinedInfo || "")
            }
        })
    }) : null;
};
exports.default = NodeInfoModal;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","./Modal":"9rT1D","marked":"cqOOM","../store":"eveyc","@emotion/react":"ifT37","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cqOOM":[function(require,module,exports,__globalThis) {
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function getDefaults() {
        return {
            async: false,
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: '',
            highlight: null,
            hooks: null,
            langPrefix: 'language-',
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    exports1.defaults = getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = new RegExp(escapeTest.source, 'g');
    var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
    var escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    /**
   * @param {string} html
   */ function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === 'colon') return ':';
            if (n.charAt(0) === '#') return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return '';
        });
    }
    var caret = /(^|[^\[])\^/g;
    /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */ function edit(regex, opt) {
        regex = typeof regex === 'string' ? regex : regex.source;
        opt = opt || '';
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, '$1');
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */ function cleanUrl(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, '%');
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    /**
   * @param {string} base
   * @param {string} href
   */ function resolveUrl(base, href) {
        if (!baseUrls[' ' + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[' ' + base] = base + '/';
            else baseUrls[' ' + base] = rtrim(base, '/', true);
        }
        base = baseUrls[' ' + base];
        var relativeBase = base.indexOf(':') === -1;
        if (href.substring(0, 2) === '//') {
            if (relativeBase) return href;
            return base.replace(protocol, '$1') + href;
        } else if (href.charAt(0) === '/') {
            if (relativeBase) return href;
            return base.replace(domain, '$1') + href;
        } else return base + href;
    }
    var noopTest = {
        exec: function noopTest() {}
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
            else // add space before unescaped |
            return ' |';
        }), cells = row.split(/ \|/);
        var i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push('');
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        return cells;
    }
    /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */ function rtrim(str, c, invert) {
        var l = str.length;
        if (l === 0) return '';
        // Length of suffix matching the invert condition.
        var suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === '\\') i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
    // copied from https://stackoverflow.com/a/5450113/806777
    /**
   * @param {string} pattern
   * @param {number} count
   */ function repeatString(pattern, count) {
        if (count < 1) return '';
        var result = '';
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    function outputLink(cap, link, raw, lexer) {
        var href = link.href;
        var title = link.title ? escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            var token = {
                type: 'link',
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split('\n').map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join('\n');
    }
    /**
   * Tokenizer
   */ var Tokenizer = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: 'space',
                raw: cap[0]
            };
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic ? rtrim(text, '\n') : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || '');
                return {
                    type: 'code',
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, '#');
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: 'hr',
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *>[ \t]?/gm, '');
                var top = this.lexer.state.top;
                this.lexer.state.top = true;
                var tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: 'blockquote',
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
                var bull = cap[1].trim();
                var isordered = bull.length > 1;
                var list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: []
                };
                bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
                if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
                // Get next list item
                var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");
                // Check if current bullet point can start a new List Item
                while(src){
                    endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    line = cap[2].split('\n', 1)[0].replace(/^\t+/, function(t) {
                        return ' '.repeat(3 * t.length);
                    });
                    nextLine = src.split('\n', 1)[0];
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimLeft();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        // Items begin with at most one blank line
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
                        var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
                        var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
                        var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");
                        // Check if following lines should be included in List Item
                        while(src){
                            rawLine = src.split('\n', 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) // Dedent if possible
                            itemContents += '\n' + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += '\n' + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) // Check if current line is blank
                            blankLine = true;
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimRight();
                list.items[list.items.length - 1].text = itemContents.trimRight();
                list.raw = list.raw.trimRight();
                var l = list.items.length;
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(i = 0; i < l; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        var spacers = list.items[i].tokens.filter(function(t) {
                            return t.type === 'space';
                        });
                        var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                            return /\n.*\n/.test(t.raw);
                        });
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(i = 0; i < l; i++)list.items[i].loose = true;
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) {
                var token = {
                    type: 'html',
                    raw: cap[0],
                    pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
                    text: cap[0]
                };
                if (this.options.sanitize) {
                    var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
                    token.type = 'paragraph';
                    token.text = text;
                    token.tokens = this.lexer.inline(text);
                }
                return token;
            }
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
                var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
                var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
                return {
                    type: 'def',
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: 'table',
                    header: splitCells(cap[1]).map(function(c) {
                        return {
                            text: c
                        };
                    }),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i, j, k, row;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = 'right';
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = 'center';
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = 'left';
                        else item.align[i] = null;
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map(function(c) {
                        return {
                            text: c
                        };
                    });
                    // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                    // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                    }
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: 'heading',
                raw: cap[0],
                depth: cap[2].charAt(0) === '=' ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: 'paragraph',
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: 'text',
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        };
        _proto.escape = function escape$1(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: 'escape',
                raw: cap[0],
                text: escape(cap[1])
            };
        };
        _proto.tag = function tag(src) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: this.options.sanitize ? 'text' : 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                var href = cap[2];
                var title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : '';
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
                    title: title ? title.replace(this.rules.inline._escapes, '$1') : title
                }, cap[0], this.lexer);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                link = links[link.toLowerCase()];
                if (!link) {
                    var text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = '';
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || '';
            if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        var _text = raw.slice(1, -1);
                        return {
                            type: 'em',
                            raw: raw,
                            text: _text,
                            tokens: this.lexer.inlineTokens(_text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    var text = raw.slice(2, -2);
                    return {
                        type: 'strong',
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, ' ');
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: 'br',
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: 'del',
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === '@') {
                    text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = 'mailto:' + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === '@') {
                    text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = 'mailto:' + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === 'www.') href = 'http://' + cap[0];
                    else href = cap[0];
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (this.lexer.state.inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
                else text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: 'text',
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    /**
   * Block-Level Grammar
   */ var block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block.normal = _extends({}, block);
    /**
   * GFM Block Grammar
   */ block.gfm = _extends({}, block.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('table', block.gfm.table) // interrupt paragraphs with table
    .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block.pedantic = _extends({}, block.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: 'reflink|nolink(?!\\()',
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
            rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    };
    // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    // lookbehind is not available on Safari as of version 16
    // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
    inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
    inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline.normal = _extends({}, inline);
    /**
   * Pedantic Inline Grammar
   */ inline.pedantic = _extends({}, inline.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline.gfm = _extends({}, inline.normal, {
        escape: edit(inline.escape).replace('])', '~|])').getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline.breaks = _extends({}, inline.gfm, {
        br: edit(inline.br).replace('{2,}', '*').getRegex(),
        text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
    });
    /**
   * smartypants text replacement
   * @param {string} text
   */ function smartypants(text) {
        return text// em-dashes
        .replace(/---/g, "\u2014")// en-dashes
        .replace(/--/g, "\u2013")// opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")// closing singles & apostrophes
        .replace(/'/g, "\u2019")// opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")// closing doubles
        .replace(/"/g, "\u201D")// ellipses
        .replace(/\.{3}/g, "\u2026");
    }
    /**
   * mangle email addresses
   * @param {string} text
   */ function mangle(text) {
        var out = '', i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = 'x' + ch.toString(16);
            out += '&#' + ch + ';';
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        };
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        };
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, '\n');
            this.blockTokens(src, this.tokens);
            var next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        };
        _proto.blockTokens = function blockTokens(src, tokens) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (this.options.pedantic) src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
            else src = src.replace(/^( *)(\t+)/gm, function(_, leading, tabs) {
                return leading + '    '.repeat(tabs.length);
            });
            var token, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += '\n';
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        };
        _proto.inline = function inline(src, tokens) {
            if (tokens === void 0) tokens = [];
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        };
        _proto.inlineTokens = function inlineTokens(src, tokens) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            var token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null){
                maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
                this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
            }
            while(src){
                if (!keepPrevChar) prevChar = '';
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this2
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    /**
   * Renderer
   */ var Renderer = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || '').match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, '') + '\n';
            if (!lang) return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
            return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
        };
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        };
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) {
                var id = this.options.headerPrefix + slugger.slug(raw);
                return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
            }
            // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? 'ol' : 'ul', startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
            return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
        };
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
        };
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        };
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
        };
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? 'th' : 'td';
            var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
            return tag + content + ("</" + type + ">\n");
        };
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        };
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        };
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? '<br/>' : '<br>';
        };
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        };
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += '>' + text + '</a>';
            return out;
        };
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
            if (title) out += " title=\"" + title + "\"";
            out += this.options.xhtml ? '/>' : '>';
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return '' + text;
        };
        _proto.image = function image(href, title, text) {
            return '' + text;
        };
        _proto.br = function br() {
            return '';
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        /**
     * @param {string} value
     */ var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim()// remove html tags
            .replace(/<[!\/a-z].*?>/ig, '')// remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
        };
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + '-' + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        };
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    /**
   * Parsing & Compiling
   */ var Parser = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer();
            this.slugger = new Slugger();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        };
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        };
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = '', i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        'space',
                        'hr',
                        'heading',
                        'code',
                        'table',
                        'blockquote',
                        'list',
                        'html',
                        'paragraph',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'space':
                        continue;
                    case 'hr':
                        out += this.renderer.hr();
                        continue;
                    case 'heading':
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case 'code':
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case 'table':
                        header = '';
                        // header
                        cell = '';
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = '';
                        l2 = token.rows.length;
                        for(j = 0; j < l2; j++){
                            row = token.rows[j];
                            cell = '';
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case 'blockquote':
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case 'list':
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = '';
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = '';
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: 'text',
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case 'html':
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case 'paragraph':
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case 'text':
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === 'text'){
                            token = tokens[++i];
                            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = '', i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        'escape',
                        'html',
                        'link',
                        'image',
                        'strong',
                        'em',
                        'codespan',
                        'br',
                        'del',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'escape':
                        out += renderer.text(token.text);
                        break;
                    case 'html':
                        out += renderer.html(token.text);
                        break;
                    case 'link':
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case 'image':
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case 'strong':
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case 'em':
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case 'codespan':
                        out += renderer.codespan(token.text);
                        break;
                    case 'br':
                        out += renderer.br();
                        break;
                    case 'del':
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case 'text':
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Hooks = /*#__PURE__*/ function() {
        function Hooks(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Hooks.prototype;
        /**
     * Process markdown before marked
     */ _proto.preprocess = function preprocess(markdown) {
            return markdown;
        };
        _proto.postprocess = function postprocess(html) {
            return html;
        };
        return Hooks;
    }();
    Hooks.passThroughHooks = new Set([
        'preprocess',
        'postprocess'
    ]);
    function onError(silent, async, callback) {
        return function(e) {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (silent) {
                var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
                if (async) return Promise.resolve(msg);
                if (callback) {
                    callback(null, msg);
                    return;
                }
                return msg;
            }
            if (async) return Promise.reject(e);
            if (callback) {
                callback(e);
                return;
            }
            throw e;
        };
    }
    function parseMarkdown(lexer, parser) {
        return function(src, opt, callback) {
            if (typeof opt === 'function') {
                callback = opt;
                opt = null;
            }
            var origOpt = _extends({}, opt);
            opt = _extends({}, marked.defaults, origOpt);
            var throwError = onError(opt.silent, opt.async, callback);
            // throw error in case of non string input
            if (typeof src === 'undefined' || src === null) return throwError(new Error('marked(): input parameter is undefined or null'));
            if (typeof src !== 'string') return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
            checkSanitizeDeprecation(opt);
            if (opt.hooks) opt.hooks.options = opt;
            if (callback) {
                var highlight = opt.highlight;
                var tokens;
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    tokens = lexer(src, opt);
                } catch (e) {
                    return throwError(e);
                }
                var done = function done(err) {
                    var out;
                    if (!err) try {
                        if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                        out = parser(tokens, opt);
                        if (opt.hooks) out = opt.hooks.postprocess(out);
                    } catch (e) {
                        err = e;
                    }
                    opt.highlight = highlight;
                    return err ? throwError(err) : callback(null, out);
                };
                if (!highlight || highlight.length < 3) return done();
                delete opt.highlight;
                if (!tokens.length) return done();
                var pending = 0;
                marked.walkTokens(tokens, function(token) {
                    if (token.type === 'code') {
                        pending++;
                        setTimeout(function() {
                            highlight(token.text, token.lang, function(err, code) {
                                if (err) return done(err);
                                if (code != null && code !== token.text) {
                                    token.text = code;
                                    token.escaped = true;
                                }
                                pending--;
                                if (pending === 0) done();
                            });
                        }, 0);
                    }
                });
                if (pending === 0) done();
                return;
            }
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src) {
                return lexer(src, opt);
            }).then(function(tokens) {
                return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function() {
                    return tokens;
                }) : tokens;
            }).then(function(tokens) {
                return parser(tokens, opt);
            }).then(function(html) {
                return opt.hooks ? opt.hooks.postprocess(html) : html;
            })["catch"](throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                var _tokens = lexer(src, opt);
                if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
                var html = parser(_tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    /**
   * Marked
   */ function marked(src, opt, callback) {
        return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        marked.defaults = _extends({}, marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = exports1.defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args.forEach(function(pack) {
            // copy options to new object
            var opts = _extends({}, pack);
            // set async to true if it was set to true before
            opts.async = marked.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error('extension name required');
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === 'block') {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === 'inline') {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) (function() {
                var hooks = marked.defaults.hooks || new Hooks();
                var _loop3 = function _loop3(prop) {
                    var prevHook = hooks[prop];
                    if (Hooks.passThroughHooks.has(prop)) hooks[prop] = function(arg) {
                        if (marked.defaults.async) return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function(ret) {
                            return prevHook.call(hooks, ret);
                        });
                        var ret = pack.hooks[prop].call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[prop] = function() {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        var ret = pack.hooks[prop].apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                };
                for(var prop in pack.hooks)_loop3(prop);
                opts.hooks = hooks;
            })();
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var _walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    var values = [];
                    values.push(pack.walkTokens.call(this, token));
                    if (_walkTokens) values = values.concat(_walkTokens.call(this, token));
                    return values;
                };
            }
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var values = [];
        var _loop4 = function _loop4() {
            var token = _step.value;
            values = values.concat(callback.call(marked, token));
            switch(token.type){
                case 'table':
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        values = values.concat(marked.walkTokens(cell.tokens, callback));
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            values = values.concat(marked.walkTokens(_cell.tokens, callback));
                        }
                    }
                    break;
                case 'list':
                    values = values.concat(marked.walkTokens(token.items, callback));
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        values = values.concat(marked.walkTokens(token[childTokens], callback));
                    });
                    else if (token.tokens) values = values.concat(marked.walkTokens(token.tokens, callback));
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop4();
        return values;
    };
    /**
   * Parse Inline
   * @param {string} src
   */ marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.Hooks = Hooks;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = Parser.parse;
    var lexer = Lexer.lex;
    exports1.Hooks = Hooks;
    exports1.Lexer = Lexer;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.Slugger = Slugger;
    exports1.TextRenderer = TextRenderer;
    exports1.Tokenizer = Tokenizer;
    exports1.getDefaults = getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});

},{}],"1wM0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HelpModal", ()=>(0, _helpModalDefault.default));
parcelHelpers.export(exports, "HelpButton", ()=>HelpButton);
var _jsxRuntime = require("react/jsx-runtime");
var _fa = require("react-icons/fa");
var _reactflow = require("reactflow");
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _helpModal = require("./HelpModal");
var _helpModalDefault = parcelHelpers.interopDefault(_helpModal);
const HelpButton = ()=>{
    const toggleHelp = (0, _storeDefault.default)((store)=>store.toggleHelp);
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: (0, _jsxRuntime.jsx)((0, _reactflow.ControlButton), {
            onClick: toggleHelp,
            children: (0, _jsxRuntime.jsx)((0, _fa.FaQuestion), {})
        })
    });
};

},{"react/jsx-runtime":"g1NAx","react-icons/fa":"lut99","reactflow":"eL4zf","../../store":"eveyc","./HelpModal":"6i3O7","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6i3O7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@emotion/react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
// @ts-ignore
var _marked = require("marked");
var _store = require("../../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
//@ts-ignore
var _helpMd = require("bundle-text:./HELP.md");
var _helpMdDefault = parcelHelpers.interopDefault(_helpMd);
let _ = (t)=>t, t, t1;
const MdPreview = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _`
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: scroll;
  color: ${0};
  padding: 0 0.5rem;

  code {
    color: ${0};
    filter: hue-rotate(180deg);
  }
`), ({ theme })=>theme.colors.whitePrimary, ({ theme })=>theme.colors.accent3));
const ModalContent = (0, _react.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  padding: 1rem;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
`)));
const HelpModal = ()=>{
    const isHelpShown = (0, _storeDefault.default)((store)=>store.isHelpShown);
    const toggleHelp = (0, _storeDefault.default)((store)=>store.toggleHelp);
    if (!isHelpShown) return null;
    return (0, _jsxRuntime.jsx)((0, _modalDefault.default), {
        onClose: ()=>{
            toggleHelp();
        },
        children: (0, _jsxRuntime.jsx)(ModalContent, {
            children: (0, _jsxRuntime.jsx)(MdPreview, {
                dangerouslySetInnerHTML: {
                    __html: (0, _marked.marked)((0, _helpMdDefault.default))
                },
                onWheelCapture: (event)=>event.stopPropagation()
            })
        })
    });
};
exports.default = HelpModal;

},{"react/jsx-runtime":"g1NAx","@emotion/react":"ifT37","@emotion/styled":"2Zr0D","marked":"cqOOM","../../store":"eveyc","../Modal":"9rT1D","bundle-text:./HELP.md":"lOi94","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lOi94":[function(require,module,exports,__globalThis) {
module.exports = "# Quick start\n\n## Add node\n  - Mouse right click\n  - Select **'Add Node'** from context menu\n\n  ### &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;or\n\n  - Press `CMD+SHIFT+A`\n\n<br/>\n\n## Connect nodes\n  - Mouse left click and hold on source port\n  - Drop on target port\n\n<br/>\n\n## Delete Node or Connection\n  - Mouse right click on node/connection\n  - Select **'Delete Node'**/**'Delete Connection'** from context menu\n\n  ### &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;or\n\n  - Mouse left click on node/connection, then press `Backspace`\n\n<br/>\n\n\n## Move node\n  - Drag and Drop\n\n<br/>\n\n## Upload file\n  - Drag and drop audio or patch files onto the application\n  - Uploaded file appears as a new tab in the tabs bar at the top\n  - Click on the tab to view or edit the file\n\n\n";

},{}],"7zlhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _fa = require("react-icons/fa");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
var _useTheme = require("../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
let _ = (t)=>t, t, t1, t2, t3;
const Layout = (0, _styledDefault.default).div(t || (t = _`
  position: fixed;
  z-index: ${0};
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgb(24 28 32 / 90%);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  color: ${0};
  cursor: pointer;
`), ({ theme })=>theme.zIndex.resumeContextLayout, ({ theme })=>theme.colors.whitePrimary);
const Row = (0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`));
const Message = (0, _styledDefault.default).div(t2 || (t2 = _`
  font-family: var(--leva-fonts-mono);
  font-size: 2rem;
`));
const Icon = (0, _styledDefault.default)((0, _fa.FaVolumeOff))(t3 || (t3 = _`
  width: 7rem;
  height: 7rem;
`));
const ResumeContext = ()=>{
    const theme = (0, _useThemeDefault.default)();
    const patch = (0, _storeDefault.default)(({ patch })=>patch);
    const audioContext = patch.audioContext;
    const [isContextResumed, setIsContextResumed] = (0, _react.useState)(audioContext.state === "running");
    if (isContextResumed) return null;
    return (0, _jsxRuntime.jsxs)(Layout, {
        theme: theme,
        onClick: ()=>{
            audioContext.resume();
            setIsContextResumed(true);
        },
        children: [
            (0, _jsxRuntime.jsx)(Row, {
                children: (0, _jsxRuntime.jsx)(Message, {
                    theme: theme,
                    children: "Click anywhere to resume audio context"
                })
            }),
            (0, _jsxRuntime.jsx)(Row, {
                children: (0, _jsxRuntime.jsx)(Icon, {})
            })
        ]
    });
};
exports.default = ResumeContext;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","react-icons/fa":"lut99","../store":"eveyc","../hooks/useTheme":"kxvkQ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6eT7I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _fa = require("react-icons/fa");
var _reactflow = require("reactflow");
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const ToggleMinimap = ()=>{
    const setConfig = (0, _storeDefault.default)(({ setConfig })=>setConfig);
    const { showMinimap } = (0, _storeDefault.default)(({ config })=>config);
    return (0, _jsxRuntime.jsx)((0, _reactflow.ControlButton), {
        onClick: ()=>setConfig({
                showMinimap: !showMinimap
            }),
        children: showMinimap ? (0, _jsxRuntime.jsx)((0, _fa.FaMap), {}) : (0, _jsxRuntime.jsx)((0, _fa.FaRegMap), {})
    });
};
exports.default = ToggleMinimap;

},{"react/jsx-runtime":"g1NAx","react-icons/fa":"lut99","reactflow":"eL4zf","../store":"eveyc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dI0TN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactflow = require("reactflow");
var _useTheme = require("../hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _store = require("../store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const Wire = ({ id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, style = {}, data, markerStart, markerEnd, source, target, sourceHandleId, targetHandleId, selected })=>{
    const theme = (0, _useThemeDefault.default)();
    const getNode = (0, _storeDefault.default)(({ getNode })=>getNode);
    const sourceNode = getNode(source);
    const targetNode = getNode(target);
    const isConnectedToSelected = (sourceNode === null || sourceNode === void 0 ? void 0 : sourceNode.selected) || (targetNode === null || targetNode === void 0 ? void 0 : targetNode.selected);
    (0, _react.useEffect)(()=>{
        if (!sourceHandleId || !targetHandleId) return;
        console.log(`connected ${source} to ${target}`);
        return ()=>{
            console.log(`disconnected ${source} from ${target}`);
        };
    }, [
        source,
        sourceHandleId,
        target,
        targetHandleId
    ]);
    const [edgePath] = (0, _reactflow.getBezierPath)({
        targetX,
        targetY,
        targetPosition,
        sourceX,
        sourceY,
        sourcePosition
    });
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)("path", {
                id: id,
                style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
                    stroke: selected ? theme.colors.accent2 : isConnectedToSelected ? theme.colors.highlight3 : theme.colors.highlight2
                }),
                className: "react-flow__edge-path Wire",
                d: edgePath,
                markerEnd: markerEnd
            }),
            (0, _jsxRuntime.jsx)("path", {
                style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, style), {
                    strokeWidth: 8,
                    color: "transparent",
                    opacity: 0,
                    cursor: "pointer"
                }),
                d: edgePath,
                markerEnd: markerEnd
            })
        ]
    });
};
exports.default = Wire;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","reactflow":"eL4zf","../hooks/useTheme":"kxvkQ","../store":"eveyc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1Gg4X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "channelMerger",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"15iVg","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"15iVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "channelMerger", ()=>channelMerger);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _constants = require("@web-noise/core/constants");
const channelMerger = async (audioContext, data)=>{
    const merger = audioContext.createChannelMerger();
    return {
        inputs: Array.from({
            length: merger.numberOfInputs
        }).reduce((acc, item, index)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [`input${index}`]: {
                    port: [
                        merger,
                        index
                    ],
                    type: (0, _constants.PortType).Audio
                }
            }), {}),
        outputs: {
            output: {
                port: merger,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = channelMerger;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"36kMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./src/constants");
parcelHelpers.exportAll(_constants, exports);

},{"./src/constants":"k5UCO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5QSxj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Channel Splitter",
    description: `
  A utility node that separates a multi-channel audio stream into individual mono channels.

  Essential for per-channel processing, applying different effects to left and right channels,
  or analyzing individual channels separately before recombining them.
  `,
    info: `
  # Channel Splitter

  Separates multi-channel audio into individual mono channels.

  Use it to process left and right channels separately or to extract specific channels from surround sound.

  ## Usage
  - Input a stereo or multi-channel signal
  - Each output provides a single channel from the input
  - Typically used with Channel Merger for channel manipulation
  `,
    tags: [
        "splitter",
        "channels",
        "stereo",
        "multichannel"
    ],
    portsDescription: {
        inputs: {
            input: "Multi-channel audio input to be split"
        },
        outputs: {
            output0: "First channel output (left in stereo)",
            output1: "Second channel output (right in stereo)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"2II7J","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2II7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "channelSplitter",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"3Lv72","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3Lv72":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "channelSplitter", ()=>channelSplitter);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _constants = require("@web-noise/core/constants");
const channelSplitter = async (audioContext, data)=>{
    const splitter = audioContext.createChannelSplitter();
    return {
        inputs: {
            input: {
                port: splitter,
                type: (0, _constants.PortType).Audio
            }
        },
        outputs: Array.from({
            length: splitter.numberOfOutputs
        }).reduce((acc, item, index)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [`output${index}`]: {
                    port: [
                        splitter,
                        index
                    ],
                    type: (0, _constants.PortType).Audio
                }
            }), {})
    };
};
exports.default = channelSplitter;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3C54q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _convolver = require("./Convolver");
var _convolverDefault = parcelHelpers.interopDefault(_convolver);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _convolverDefault.default),
    node: (0, _nodeDefault.default),
    configNode: (0, _configDefault.default),
    resizable: true,
    defaultConfig: {
        size: {
            width: 220,
            height: 65
        }
    },
    name: "Convolver (Reverb/Space)",
    description: `
  An effect that applies the acoustic characteristics of a space to audio signals.

  Essential for adding depth, space, and realism to audio by simulating real acoustic environments
  like concert halls, rooms, or other spaces with distinctive sonic characteristics.
  `,
    info: `
  # Convolver

  Applies convolution effects to audio, creating realistic reverb and spatial processing.

  Use it to create realistic reverb, echo, or spatial effects using impulse response samples.

  ## Usage
  - Load an impulse response file (WAV/MP3)
  - Impulse responses capture the acoustic "signature" of real spaces
  - Higher quality impulse responses create more realistic effects
  - Commonly used for reverb, but can create many other effects
  `,
    tags: [
        "convolver",
        "reverb",
        "space",
        "effect",
        "impulse response"
    ],
    portsDescription: {
        inputs: {
            input: "Audio input to be processed with convolution"
        },
        outputs: {
            output: "Processed audio with applied convolution effect"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Convolver":"6a7Bh","./Node":"dHpLc","./base":"gjpV0","./Config":"3lka9","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6a7Bh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react = require("react");
var _lib = require("@web-noise/core/lib");
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _wave = require("../../webNoise/AudioTrack/Wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
var _react1 = require("@emotion/react");
let _ = (t)=>t, t, t1;
const ConvolverConfigWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
  display: flex;
  > * {
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
`)));
const ConvolverWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  position: relative;
  height: 100%;
  width: 100%;
  svg {
    position: absolute;
    width: auto;
    left: 0;
    right: 0;
    margin: auto;
  }
`)));
const Convolver = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data.values
    ]);
    const channel = (0, _lib.useMessageChannel)();
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        audioNode.registerPort(channel.port1);
    }, [
        audioNode,
        channel
    ]);
    const { url } = data.values || {};
    if (!url) return (0, _jsxRuntime.jsx)(ConvolverConfigWrapper, {
        children: (0, _jsxRuntime.jsx)((0, _configDefault.default), (0, _objectSpread._)({}, props))
    });
    return (0, _jsxRuntime.jsx)(ConvolverWrapper, {
        children: channel ? (0, _jsxRuntime.jsx)((0, _waveDefault.default), {
            port: channel.port2,
            waveColor: theme.colors.accent2,
            progressColor: "transparent",
            rangeColor: "transparent"
        }) : null
    });
};
exports.default = Convolver;

},{"@swc/helpers/_/_object_spread":"awBF9","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","@web-noise/core/lib":"8cGsd","./Config":"3lka9","../../webNoise/AudioTrack/Wave":"f0GG8","@emotion/react":"ifT37","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8cGsd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lib = require("./src/lib");
parcelHelpers.exportAll(_lib, exports);

},{"./src/lib":"j33ba","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3lka9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const ConvolverConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeValues, updateNodeConfig } = (0, _core.useNode)(id);
    const projectFiles = (0, _core.useStore)((store)=>store.project.files);
    const { config = {}, values = {} } = data;
    return (0, _jsxRuntime.jsx)((0, _components.ConfigPanel), {
        theme: theme,
        children: (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
            oneLineLabels: true,
            theme: theme,
            children: (0, _jsxRuntime.jsx)((0, _components.DropdownInput), {
                value: values.url,
                placeholder: "place URL here",
                onSubmit: (url)=>{
                    updateNodeValues({
                        url
                    });
                },
                options: projectFiles.filter((file)=>(0, _core.isAudio)(file)).map(({ id, name, file })=>({
                        value: `project://${id}`,
                        label: name
                    }))
            })
        })
    });
};
exports.default = ConvolverConfig;

},{"react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jYfYj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _components = require("./src/components");
parcelHelpers.exportAll(_components, exports);

},{"./src/components":"kLE5q","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kLE5q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "Checker", ()=>(0, _checkerDefault.default));
parcelHelpers.export(exports, "RadioGroup", ()=>(0, _radioGroupDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "DropdownInput", ()=>(0, _dropdownInputDefault.default));
parcelHelpers.export(exports, "ColorInput", ()=>(0, _colorInputDefault.default));
parcelHelpers.export(exports, "NumberInput", ()=>(0, _numberInputDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "Slider", ()=>(0, _sliderDefault.default));
parcelHelpers.export(exports, "SplineEditor", ()=>(0, _splineEditorDefault.default));
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _checker = require("./Checker");
var _checkerDefault = parcelHelpers.interopDefault(_checker);
var _radioGroup = require("./RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _dropdownInput = require("./DropdownInput");
var _dropdownInputDefault = parcelHelpers.interopDefault(_dropdownInput);
var _colorInput = require("./ColorInput");
var _colorInputDefault = parcelHelpers.interopDefault(_colorInput);
var _numberInput = require("./NumberInput");
var _numberInputDefault = parcelHelpers.interopDefault(_numberInput);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _splineEditor = require("./SplineEditor");
var _splineEditorDefault = parcelHelpers.interopDefault(_splineEditor);
var _nodeConfig = require("./NodeConfig");
parcelHelpers.exportAll(_nodeConfig, exports);

},{"./Modal":"9rT1D","./Checker":"himbU","./RadioGroup":"bgL2B","./Input":"cySVi","./DropdownInput":"3BlxY","./ColorInput":"hYtnv","./NumberInput":"7hwJ8","./Button":"fegj5","./Select":"3Ov4i","./Slider":"kLXc4","./SplineEditor":"gmHtd","./NodeConfig":"8bqoD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"himbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
let _ = (t)=>t, t, t1, t2, t3;
const CheckerBox = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.6rem;
  height: 0.6rem;
  background: ${0};
  border: 1px solid ${0};
  &::after {
    content: "";
    background: ${0};
  }
`), ({ theme })=>theme.colors.whitePrimary, ({ theme })=>theme.colors.highlight1, ({ theme })=>theme.colors.accent1);
const CheckerLabel = (0, _styledDefault.default).div(t1 || (t1 = _``));
const CheckerSubtitle = (0, _styledDefault.default).div(t2 || (t2 = _`
  font-size: 0.4rem;
  color: ${0};
`), ({ theme })=>theme.colors.highlight1);
const CheckedInner = (0, _styledDefault.default).label(t3 || (t3 = _`
  display: flex;
  cursor: pointer;
  gap: 0.4rem;
  line-height: 0.7rem;
  input {
    display: none;
  }
  input[type="radio"] ~ .checker-box {
    border-radius: 50%;
    &::after {
      border-radius: 50%;
    }
  }
  input:checked ~ .checker-box:after {
    width: 70%;
    height: 70%;
  }
`));
const Checker = ({ label, subtitle, name, type = "checkbox", onChange, checked = false })=>{
    const theme = (0, _core.useTheme)();
    return (0, _jsxRuntime.jsxs)(CheckedInner, {
        children: [
            (0, _jsxRuntime.jsx)("input", {
                type: type,
                name: name,
                checked: checked,
                onChange: ({ target })=>onChange === null || onChange === void 0 ? void 0 : onChange(target.checked)
            }),
            (0, _jsxRuntime.jsx)(CheckerBox, {
                className: "checker-box",
                theme: theme
            }),
            (0, _jsxRuntime.jsxs)("div", {
                children: [
                    (0, _jsxRuntime.jsx)(CheckerLabel, {
                        children: label
                    }),
                    subtitle ? (0, _jsxRuntime.jsx)(CheckerSubtitle, {
                        theme: theme,
                        children: subtitle
                    }) : null
                ]
            })
        ]
    });
};
exports.default = Checker;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bgL2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _checker = require("./Checker");
var _checkerDefault = parcelHelpers.interopDefault(_checker);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
let _ = (t)=>t, t;
const RadioGroupWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  color: ${0};
  padding: 0.5rem;
`), ({ theme })=>theme.colors.highlight2);
const RadioGroup = ({ options, value, onChange })=>{
    const theme = (0, _core.useTheme)();
    return (0, _jsxRuntime.jsx)(RadioGroupWrapper, {
        theme: theme,
        children: options.map(({ value: optionValue, label, subtitle }, index)=>(0, _jsxRuntime.jsx)((0, _checkerDefault.default), {
                value: value,
                type: "radio",
                label: label,
                subtitle: subtitle,
                onChange: ()=>onChange(optionValue),
                checked: optionValue === value
            }, index))
    });
};
exports.default = RadioGroup;

},{"react/jsx-runtime":"g1NAx","./Checker":"himbU","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cySVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputWrapper", ()=>InputWrapper);
parcelHelpers.export(exports, "InputInner", ()=>InputInner);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
let _ = (t)=>t, t, t1;
const InputWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  position: relative;
`));
const InputInner = (0, _styledDefault.default).input(t1 || (t1 = _`
  padding-right: 2rem;
  padding-left: 0.3rem;
  padding-top: 0;
  padding-bottom: 0;
  width: 100%;
  appearance: textfield;
  font-size: inherit;
  background: none;
  border: none;
  color: var(--leva-colors-highlight1);
  font-family: var(--leva-fonts-mono);
  cursor: inherit;
  text-overflow: ellipsis;
  outline: none;
  appearance: textfield;
  cursor: auto;
  background-color: var(--leva-colors-elevation3);
  border-radius: 0.2rem;
  height: 1.5rem;
  color: var(--leva-colors-highlight2);

  &:focus,
  &:hover {
    box-shadow: 0 0 0 var(--leva-borderWidths-focus) var(--leva-colors-accent2);
    color: ${0};
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin-right: 1rem;
  }
`), (0, _core.theme).colors.whitePrimary);
const Input = (_param)=>{
    var { type, value, placeholder, onChange = ()=>{}, inputProps } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "type",
        "value",
        "placeholder",
        "onChange",
        "inputProps"
    ]);
    return (0, _jsxRuntime.jsx)(InputWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)(InputInner, (0, _objectSpread._)({
            type: type,
            value: value,
            placeholder: placeholder,
            onKeyDownCapture: (event)=>{
                event.stopPropagation();
            },
            onChange: (event)=>{
                onChange(event.target.value);
            }
        }, inputProps))
    }));
};
exports.default = Input;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3BlxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _react1 = require("react");
var _fa = require("react-icons/fa");
var _input = require("./Input");
let _ = (t)=>t, t, t1, t2, t3, t4, t5;
const InputButton = (0, _react.withTheme)((0, _styledDefault.default).button(t || (t = _`
  position: absolute;
  right: 0;
  height: 100%;
  outline: none;
  background: none;
  border: none;
  color: ${0};
  cursor: pointer;
  display: flex;
  align-items: center;
  z-index: 2;
  &:hover {
    color: ${0};
  }
  &:active {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight1, ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.highlight3));
const DropdownContainer = (0, _styledDefault.default).div(t1 || (t1 = _`
  position: relative;
  width: 100%;
`));
const DropdownList = (0, _react.withTheme)((0, _styledDefault.default).div(t2 || (t2 = _`
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: ${0};
  border: 1px solid ${0};
  border-radius: 0.2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: ${0};

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${0};
  }

  &::-webkit-scrollbar-thumb {
    background: ${0};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${0};
  }
`), ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.elevation3, ({ isOpen })=>isOpen ? "block" : "none", ({ theme })=>theme.colors.elevation1, ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.highlight1));
const DropdownItem = (0, _react.withTheme)((0, _styledDefault.default).div(t3 || (t3 = _`
  padding: 0.4rem 0.5rem;
  cursor: pointer;
  color: ${0};
  background-color: ${0};
  font-family: var(--leva-fonts-mono);
  font-size: 0.9em;

  &:hover {
    background-color: ${0};
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight1, ({ theme, isHighlighted })=>isHighlighted ? theme.colors.elevation3 : "transparent", ({ theme })=>theme.colors.elevation3, ({ theme })=>theme.colors.highlight2));
const DropdownItemValue = (0, _styledDefault.default).div(t4 || (t4 = _`
  font-size: 0.85em;
  opacity: 0.7;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`));
const DropdownItemLabel = (0, _styledDefault.default).div(t5 || (t5 = _`
  font-size: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`));
const DropdownInput = (_param)=>{
    var { value = "", placeholder = "", onSubmit = ()=>{}, options = [] } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "value",
        "placeholder",
        "onSubmit",
        "options"
    ]);
    const [currentValue, setCurrentValue] = (0, _react1.useState)(value);
    const [isOpen, setIsOpen] = (0, _react1.useState)(false);
    const [highlightedIndex, setHighlightedIndex] = (0, _react1.useState)(-1);
    const inputRef = (0, _react1.useRef)(null);
    const dropdownRef = (0, _react1.useRef)(null);
    const filteredOptions = options.filter((option)=>{
        var _option_label;
        return currentValue === "" || option.value.toLowerCase().includes(currentValue.toLowerCase()) || ((_option_label = option.label) === null || _option_label === void 0 ? void 0 : _option_label.toLowerCase().includes(currentValue.toLowerCase()));
    });
    const applyCurrentValue = (0, _react1.useCallback)(()=>{
        onSubmit(currentValue);
        setIsOpen(false);
        setHighlightedIndex(-1);
    }, [
        currentValue,
        onSubmit
    ]);
    const selectOption = (0, _react1.useCallback)((option)=>{
        setCurrentValue(option.value);
        onSubmit(option.value);
        setIsOpen(false);
        setHighlightedIndex(-1);
    }, [
        onSubmit
    ]);
    const handleKeyDown = (0, _react1.useCallback)((event)=>{
        switch(event.key){
            case "Escape":
                setIsOpen(false);
                setHighlightedIndex(-1);
                break;
            case "Enter":
                if (isOpen && highlightedIndex >= 0 && filteredOptions[highlightedIndex]) {
                    event.preventDefault();
                    selectOption(filteredOptions[highlightedIndex]);
                } else applyCurrentValue();
                break;
            case "ArrowDown":
                event.preventDefault();
                if (!isOpen) {
                    setIsOpen(true);
                    setHighlightedIndex(0);
                } else setHighlightedIndex((prev)=>prev < filteredOptions.length - 1 ? prev + 1 : prev);
                break;
            case "ArrowUp":
                event.preventDefault();
                if (isOpen) setHighlightedIndex((prev)=>prev > 0 ? prev - 1 : prev);
                break;
        }
    }, [
        applyCurrentValue,
        isOpen,
        highlightedIndex,
        filteredOptions,
        selectOption
    ]);
    const handleInputChange = (value)=>{
        setCurrentValue(value);
        setIsOpen(true);
        setHighlightedIndex(-1);
    };
    const handleFocus = ()=>{
        if (options.length > 0) setIsOpen(true);
    };
    const handleBlur = ()=>{
        // Use setTimeout to allow click events on dropdown items to fire first
        setTimeout(()=>{
            setIsOpen(false);
            setHighlightedIndex(-1);
        }, 200);
    };
    // Handle clicking outside
    (0, _react1.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && inputRef.current && !inputRef.current.contains(event.target)) {
                setIsOpen(false);
                setHighlightedIndex(-1);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    // Scroll highlighted item into view
    (0, _react1.useEffect)(()=>{
        if (highlightedIndex >= 0 && dropdownRef.current) {
            const highlightedElement = dropdownRef.current.children[highlightedIndex];
            if (highlightedElement) highlightedElement.scrollIntoView({
                block: "nearest",
                behavior: "smooth"
            });
        }
    }, [
        highlightedIndex
    ]);
    return (0, _jsxRuntime.jsxs)(DropdownContainer, {
        children: [
            (0, _jsxRuntime.jsxs)((0, _input.InputWrapper), {
                children: [
                    (0, _jsxRuntime.jsx)((0, _input.InputInner), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
                        ref: inputRef,
                        value: currentValue,
                        placeholder: placeholder,
                        onKeyDown: handleKeyDown,
                        onChange: (event)=>handleInputChange(event.target.value),
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        autoComplete: "off"
                    })),
                    (0, _jsxRuntime.jsx)(InputButton, {
                        onClick: applyCurrentValue,
                        children: (0, _jsxRuntime.jsx)((0, _fa.FaRegArrowAltCircleRight), {})
                    })
                ]
            }),
            options.length > 0 && (0, _jsxRuntime.jsx)(DropdownList, {
                ref: dropdownRef,
                isOpen: isOpen && filteredOptions.length > 0,
                children: filteredOptions.map((option, index)=>(0, _jsxRuntime.jsxs)(DropdownItem, {
                        isHighlighted: index === highlightedIndex,
                        onClick: ()=>selectOption(option),
                        onMouseEnter: ()=>setHighlightedIndex(index),
                        children: [
                            (0, _jsxRuntime.jsx)(DropdownItemLabel, {
                                children: option.label || option.value
                            }),
                            option.value && (0, _jsxRuntime.jsx)(DropdownItemValue, {
                                children: option.value
                            })
                        ]
                    }, option.value + index))
            })
        ]
    });
};
exports.default = DropdownInput;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","react":"lXMxO","react-icons/fa":"lut99","./Input":"cySVi","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hYtnv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _input = require("./Input");
let _ = (t)=>t, t, t1;
const StyledInputWrapper = (0, _styledDefault.default)((0, _input.InputWrapper))(t || (t = _`
  gap: 0.5rem;
`));
const StyledInputInner = (0, _styledDefault.default)((0, _input.InputInner))(t1 || (t1 = _`
  padding: 0;
  aspect-ratio: 1 / 1;
  width: auto;
  cursor: pointer;
  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }
  &::-webkit-color-swatch {
    border-radius: 0.2rem;
    border: none;
  }
`));
const ColorInput = (_param)=>{
    var { value, onChange = ()=>{} } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "value",
        "onChange"
    ]);
    return (0, _jsxRuntime.jsxs)(StyledInputWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: [
            (0, _jsxRuntime.jsx)(StyledInputInner, {
                type: "color",
                value: value,
                onChange: (event)=>{
                    onChange(event.target.value);
                }
            }),
            (0, _jsxRuntime.jsx)((0, _input.InputInner), {
                value: value,
                onChange: (event)=>{
                    onChange(event.target.value);
                }
            })
        ]
    }));
};
exports.default = ColorInput;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","./Input":"cySVi","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7hwJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
// @ts-ignore
var _useDebounce = require("use-debounce");
let _ = (t)=>t, t, t1;
const SampleInput = (0, _styledDefault.default).span(t || (t = _`
  position: relative;
  &:after {
    content: "↕";
    position: absolute;
    top: -1px;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 1.2em;
    color: var(--leva-colors-highlight1);
  }
`));
const SampleInputInner = (0, _styledDefault.default).input(t1 || (t1 = _`
  width: 100%;
  appearance: textfield;
  font-size: inherit;
  background: none;
  border: none;
  text-align: right;
  color: var(--leva-colors-highlight1);
  font-family: var(--leva-fonts-mono);
  cursor: inherit;
  text-overflow: ellipsis;
  outline: none;
  appearance: textfield;
  cursor: auto;
  background-color: var(--leva-colors-elevation3);
  border-radius: 0.2rem;
  height: 1.5rem;
  color: var(--leva-colors-highlight2);

  &:focus,
  &:hover {
    box-shadow: 0 0 0 var(--leva-borderWidths-focus) var(--leva-colors-accent2);
  }
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin-right: 1rem;
  }
`));
const NumberInput = (_param)=>{
    var { max = Infinity, min = -Infinity, value, step = 1, onChange = ()=>{}, placeholder } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "max",
        "min",
        "value",
        "step",
        "onChange",
        "placeholder"
    ]);
    const inputRef = (0, _react.useRef)(null);
    const startChangedHandler = (0, _useDebounce.useThrottledCallback)((event)=>{
        if (typeof value === "undefined") return;
        //@TODO: come up with more logical factor calculation
        const factor = max < 10 ? 5 : max / 100;
        const st = +(value + Math.round(event.deltaY / factor) * step).toFixed(2);
        if (st < min || st > max) return;
        onChange(st);
    }, 100);
    (0, _react.useEffect)(()=>{
        if (!inputRef.current) return;
        inputRef.current.addEventListener("wheel", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            startChangedHandler(event);
        });
        inputRef.current.onchange = (event)=>{
            const value = event.target.value;
            onChange(+value);
        };
    }, [
        inputRef.current,
        onChange
    ]);
    (0, _react.useEffect)(()=>{
        if (typeof value === "undefined") return;
        inputRef.current && (inputRef.current.value = value.toString());
    }, [
        inputRef.current,
        value
    ]);
    return (0, _jsxRuntime.jsx)(SampleInput, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)(SampleInputInner, {
            ref: inputRef,
            type: "number",
            step: step,
            min: min,
            max: max,
            placeholder: placeholder
        })
    }));
};
exports.default = NumberInput;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","use-debounce":"ipTtc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ipTtc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebounce", ()=>o);
parcelHelpers.export(exports, "useDebouncedCallback", ()=>c);
parcelHelpers.export(exports, "useThrottledCallback", ()=>f);
var _react = require("react");
function c(u, e, c) {
    var i = this, a = (0, _react.useRef)(null), o = (0, _react.useRef)(0), f = (0, _react.useRef)(null), l = (0, _react.useRef)([]), m = (0, _react.useRef)(), v = (0, _react.useRef)(), d = (0, _react.useRef)(u), p = (0, _react.useRef)(!0);
    (0, _react.useEffect)(function() {
        d.current = u;
    }, [
        u
    ]);
    var g = !e && 0 !== e && "undefined" != typeof window;
    if ("function" != typeof u) throw new TypeError("Expected a function");
    e = +e || 0;
    var w = !!(c = c || {}).leading, s = !("trailing" in c) || !!c.trailing, x = "maxWait" in c, y = x ? Math.max(+c.maxWait || 0, e) : null;
    (0, _react.useEffect)(function() {
        return p.current = !0, function() {
            p.current = !1;
        };
    }, []);
    var h = (0, _react.useMemo)(function() {
        var r = function(r) {
            var n = l.current, t = m.current;
            return l.current = m.current = null, o.current = r, v.current = d.current.apply(t, n);
        }, n = function(r, n) {
            g && cancelAnimationFrame(f.current), f.current = g ? requestAnimationFrame(r) : setTimeout(r, n);
        }, t = function(r) {
            if (!p.current) return !1;
            var n = r - a.current;
            return !a.current || n >= e || n < 0 || x && r - o.current >= y;
        }, u = function(n) {
            return f.current = null, s && l.current ? r(n) : (l.current = m.current = null, v.current);
        }, c = function r() {
            var c = Date.now();
            if (t(c)) return u(c);
            if (p.current) {
                var i = e - (c - a.current), f = x ? Math.min(i, y - (c - o.current)) : i;
                n(r, f);
            }
        }, h = function() {
            var u = Date.now(), d = t(u);
            if (l.current = [].slice.call(arguments), m.current = i, a.current = u, d) {
                if (!f.current && p.current) return o.current = a.current, n(c, e), w ? r(a.current) : v.current;
                if (x) return n(c, e), r(a.current);
            }
            return f.current || n(c, e), v.current;
        };
        return h.cancel = function() {
            f.current && (g ? cancelAnimationFrame(f.current) : clearTimeout(f.current)), o.current = 0, l.current = a.current = m.current = f.current = null;
        }, h.isPending = function() {
            return !!f.current;
        }, h.flush = function() {
            return f.current ? u(Date.now()) : v.current;
        }, h;
    }, [
        w,
        x,
        e,
        y,
        s,
        g
    ]);
    return h;
}
function i(r, n) {
    return r === n;
}
function a(r) {
    return "function" == typeof r ? function() {
        return r;
    } : r;
}
function o(n, t, o) {
    var f, l, m = o && o.equalityFn || i, v = (f = (0, _react.useState)(a(n)), l = f[1], [
        f[0],
        (0, _react.useCallback)(function(r) {
            return l(a(r));
        }, [])
    ]), d = v[0], p = v[1], g = c((0, _react.useCallback)(function(r) {
        return p(r);
    }, [
        p
    ]), t, o), w = (0, _react.useRef)(n);
    return m(w.current, n) || (g(n), w.current = n), [
        d,
        g
    ];
}
function f(r, n, t) {
    var u = void 0 === t ? {} : t, e = u.leading, i = u.trailing;
    return c(r, n, {
        maxWait: n,
        leading: void 0 === e || e,
        trailing: void 0 === i || i
    });
}

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fegj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
let _ = (t)=>t, t;
const Button = (0, _styledDefault.default).button(t || (t = _`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  font-size: inherit;
  font-family: inherit;
  border: none;
  appearance: none;
  font-weight: var(--leva-fontWeights-button);
  height: var(--leva-sizes-rowHeight);
  border-radius: var(--leva-radii-sm);
  background-color: ${0};
  color: ${0};
  background-color: ${0};
  cursor: pointer;
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);

  &:hover {
    box-shadow: inset 0 0 0 var(--leva-borderWidths-hover)
      ${0};
  }

  &:active {
    box-shadow: inset 0 0 0 var(--leva-borderWidths-active)
      ${0};
    background-color: ${0};
  }
`), ({ theme })=>theme.colors.elevation1, ({ theme })=>theme.colors.highlight3, ({ theme })=>theme.colors.accent2, ({ theme })=>theme.colors.accent3, ({ theme })=>theme.colors.accent3, ({ theme })=>theme.colors.accent1);
exports.default = Button;

},{"@emotion/styled":"2Zr0D","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3Ov4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@emotion/react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
let _ = (t)=>t, t;
const SelectWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _`
  display: flex;
  align-items: center;
  position: relative;

  select {
    appearance: none;
    border: none;
    outline: none;
    width: 100%;
    font-weight: var(--leva-fontWeights-button);
    padding: 0.3rem 0.5rem;
    padding-right: 1rem;
    border-radius: var(--leva-radii-sm);
    background-color: ${0};
    color: ${0};
    cursor: pointer;
    font-family: var(--leva-fonts-mono);
    font-size: var(--leva-fontSizes-root);

    &:hover {
      box-shadow: inset 0 0 0 var(--leva-borderWidths-hover)
        ${0};
    }

    &:active {
      box-shadow: inset 0 0 0 var(--leva-borderWidths-active)
        ${0};
      background-color: ${0};
    }
  }

  &::after {
    position: absolute;
    right: 0.3rem;
    content: "";
    width: 0.5em;
    height: 0.3em;
    background-color: ${0};
    clip-path: polygon(100% 0%, 0 0%, 50% 100%);
  }
`), ({ theme })=>theme.colors.elevation1, ({ theme })=>theme.colors.highlight3, ({ theme })=>theme.colors.accent3, ({ theme })=>theme.colors.accent3, ({ theme })=>theme.colors.accent1, ({ theme })=>theme.colors.highlight3));
const Select = (_param)=>{
    var { options, placeholder, value, onChange } = _param, props = (0, _objectWithoutProperties._)(_param, [
        "options",
        "placeholder",
        "value",
        "onChange"
    ]);
    return (0, _jsxRuntime.jsx)(SelectWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsxs)("select", {
            value: value || "",
            onChange: (event)=>onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value),
            children: [
                placeholder && (0, _jsxRuntime.jsx)("option", {
                    value: "",
                    disabled: true,
                    children: placeholder
                }),
                options.map(({ value, label })=>(0, _jsxRuntime.jsx)("option", {
                        value: value,
                        children: label
                    }, value + label))
            ]
        })
    }));
};
exports.default = Select;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","react/jsx-runtime":"g1NAx","@emotion/react":"ifT37","@emotion/styled":"2Zr0D","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kLXc4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _rcSlider = require("rc-slider");
var _rcSliderDefault = parcelHelpers.interopDefault(_rcSlider);
var _indexCss = require("rc-slider/assets/index.css");
let _ = (t)=>t, t;
const Slider = (0, _styledDefault.default)((0, _rcSliderDefault.default))(t || (t = _`
  padding: 0;
  cursor: pointer;
  position: relative;

  &:hover {
    filter: brightness(125%);
  }

  .rc-slider-dot {
    border-radius: 0;
    box-shadow: none;
    margin: 0;
    border: none;
    background: ${0};
  }

  &.rc-slider-horizontal .rc-slider-dot {
    width: 1px;
    height: 0.25rem;
    bottom: -6px;
  }

  &.rc-slider-vertical .rc-slider-dot {
    width: 0.25rem;
    height: 1px;
    left: 3px;
  }

  .rc-slider-rail {
    background: ${0};
  }

  .rc-slider-track {
    background: ${0};
  }

  .rc-slider-handle {
    border-radius: 0.125rem;
    background: ${0};
    opacity: 1;
    cursor: pointer;
    border: none;
    &:hover {
      filter: brightness(110%);
    }
  }

  .rc-slider-handle,
  .rc-slider-handle.rc-slider-handle-dragging {
    box-shadow: 0 0 0 2px ${0};
  }

  &:before {
    content: "";
    position: absolute;
    background: transparent;
  }

  &.rc-slider-horizontal {
    height: 2px;

    .rc-slider-rail,
    .rc-slider-track,
    .rc-slider-step {
      height: 100%;
    }

    .rc-slider-handle {
      width: 0.5rem;
      height: 1rem;
      bottom: -7px;
    }

    .rc-slider-handle-dragging {
      cursor: ew-resize;
    }

    &:before {
      width: 100%;
      height: 1rem;
      top: -7px;
    }
  }

  &.rc-slider-vertical {
    width: 2px;

    .rc-slider-rail,
    .rc-slider-track,
    .rc-slider-step {
      width: 100%;
    }

    .rc-slider-track {
      left: 0;
    }

    .rc-slider-handle {
      width: 1rem;
      height: 0.5rem;
      right: -7px;
    }

    .rc-slider-handle-dragging {
      cursor: ns-resize;
    }

    &:before {
      height: 100%;
      width: 1rem;
      right: -7px;
    }
  }

  &.rc-slider-horizontal .rc-slider-mark {
    top: 1rem;
  }

  &.rc-slider-vertical .rc-slider-mark {
    left: 1rem;
  }

  .rc-slider-mark-text {
    font-size: 0.4rem;
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.elevation1, ({ theme, color })=>color || theme.colors.accent2, ({ theme, color })=>color || theme.colors.accent2, ({ theme })=>theme.colors.elevation2);
exports.default = Slider;

},{"@emotion/styled":"2Zr0D","rc-slider":"72fnj","rc-slider/assets/index.css":"jQ3S6","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"72fnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
exports.default = (0, _sliderDefault.default);

},{"./Slider":"biHDo","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"biHDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useMergedState = require("rc-util/es/hooks/useMergedState");
var _useMergedStateDefault = parcelHelpers.interopDefault(_useMergedState);
var _isEqual = require("rc-util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _warning = require("rc-util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _handles = require("./Handles");
var _handlesDefault = parcelHelpers.interopDefault(_handles);
var _marks = require("./Marks");
var _marksDefault = parcelHelpers.interopDefault(_marks);
var _steps = require("./Steps");
var _stepsDefault = parcelHelpers.interopDefault(_steps);
var _tracks = require("./Tracks");
var _tracksDefault = parcelHelpers.interopDefault(_tracks);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useDrag = require("./hooks/useDrag");
var _useDragDefault = parcelHelpers.interopDefault(_useDrag);
var _useOffset = require("./hooks/useOffset");
var _useOffsetDefault = parcelHelpers.interopDefault(_useOffset);
/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ var Slider = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-slider' : _props$prefixCls, className = props.className, style = props.style, classNames = props.classNames, styles = props.styles, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, autoFocus = props.autoFocus, onFocus = props.onFocus, onBlur = props.onBlur, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, value = props.value, defaultValue = props.defaultValue, range = props.range, count = props.count, onChange = props.onChange, onBeforeChange = props.onBeforeChange, onAfterChange = props.onAfterChange, onChangeComplete = props.onChangeComplete, _props$allowCross = props.allowCross, allowCross = _props$allowCross === void 0 ? true : _props$allowCross, _props$pushable = props.pushable, pushable = _props$pushable === void 0 ? false : _props$pushable, draggableTrack = props.draggableTrack, reverse = props.reverse, vertical = props.vertical, _props$included = props.included, included = _props$included === void 0 ? true : _props$included, startPoint = props.startPoint, trackStyle = props.trackStyle, handleStyle = props.handleStyle, railStyle = props.railStyle, dotStyle = props.dotStyle, activeDotStyle = props.activeDotStyle, marks = props.marks, dots = props.dots, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, ariaLabelForHandle = props.ariaLabelForHandle, ariaLabelledByForHandle = props.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = props.ariaValueTextFormatterForHandle;
    var handlesRef = _react.useRef(null);
    var containerRef = _react.useRef(null);
    var direction = _react.useMemo(function() {
        if (vertical) return reverse ? 'ttb' : 'btt';
        return reverse ? 'rtl' : 'ltr';
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    var mergedMin = _react.useMemo(function() {
        return isFinite(min) ? min : 0;
    }, [
        min
    ]);
    var mergedMax = _react.useMemo(function() {
        return isFinite(max) ? max : 100;
    }, [
        max
    ]);
    // ============================= Step =============================
    var mergedStep = _react.useMemo(function() {
        return step !== null && step <= 0 ? 1 : step;
    }, [
        step
    ]);
    // ============================= Push =============================
    var mergedPush = _react.useMemo(function() {
        if (typeof pushable === 'boolean') return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    var markList = _react.useMemo(function() {
        return Object.keys(marks || {}).map(function(key) {
            var mark = marks[key];
            var markObj = {
                value: Number(key)
            };
            if (mark && (0, _typeofDefault.default)(mark) === 'object' && !/*#__PURE__*/ _react.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(function(_ref) {
            var label = _ref.label;
            return label || typeof label === 'number';
        }).sort(function(a, b) {
            return a.value - b.value;
        });
    }, [
        marks
    ]);
    // ============================ Format ============================
    var _useOffset = (0, _useOffsetDefault.default)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush), _useOffset2 = (0, _slicedToArrayDefault.default)(_useOffset, 2), formatValue = _useOffset2[0], offsetValues = _useOffset2[1];
    // ============================ Values ============================
    var _useMergedState = (0, _useMergedStateDefault.default)(defaultValue, {
        value: value
    }), _useMergedState2 = (0, _slicedToArrayDefault.default)(_useMergedState, 2), mergedValue = _useMergedState2[0], setValue = _useMergedState2[1];
    var rawValues = _react.useMemo(function() {
        var valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        var _valueList = (0, _slicedToArrayDefault.default)(valueList, 1), _valueList$ = _valueList[0], val0 = _valueList$ === void 0 ? mergedMin : _valueList$;
        var returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (range) {
            returnValues = (0, _toConsumableArrayDefault.default)(valueList);
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                var pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount){
                    var _returnValues;
                    returnValues.push((_returnValues = returnValues[returnValues.length - 1]) !== null && _returnValues !== void 0 ? _returnValues : mergedMin);
                }
            }
            returnValues.sort(function(a, b) {
                return a - b;
            });
        }
        // Align in range
        returnValues.forEach(function(val, index) {
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        range,
        mergedMin,
        count,
        formatValue
    ]);
    // =========================== onChange ===========================
    var rawValuesRef = _react.useRef(rawValues);
    rawValuesRef.current = rawValues;
    var getTriggerValue = function getTriggerValue(triggerValues) {
        return range ? triggerValues : triggerValues[0];
    };
    var triggerChange = function triggerChange(nextValues) {
        // Order first
        var cloneNextValues = (0, _toConsumableArrayDefault.default)(nextValues).sort(function(a, b) {
            return a - b;
        });
        // Trigger event if needed
        if (onChange && !(0, _isEqualDefault.default)(cloneNextValues, rawValuesRef.current, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    };
    var finishChange = function finishChange() {
        var finishValue = getTriggerValue(rawValuesRef.current);
        onAfterChange === null || onAfterChange === void 0 || onAfterChange(finishValue);
        (0, _warningDefault.default)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete(finishValue);
    };
    var _useDrag = (0, _useDragDefault.default)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues), _useDrag2 = (0, _slicedToArrayDefault.default)(_useDrag, 4), draggingIndex = _useDrag2[0], draggingValue = _useDrag2[1], cacheValues = _useDrag2[2], onStartDrag = _useDrag2[3];
    var changeToCloseValue = function changeToCloseValue(newValue, e) {
        if (!disabled) {
            var valueIndex = 0;
            var valueDist = mergedMax - mergedMin;
            rawValues.forEach(function(val, index) {
                var dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
            });
            // Create new values
            var cloneNextValues = (0, _toConsumableArrayDefault.default)(rawValues);
            cloneNextValues[valueIndex] = newValue;
            // Fill value to match default 2
            if (range && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(cloneNextValues));
            triggerChange(cloneNextValues);
            if (e) {
                var _document$activeEleme, _document$activeEleme2;
                (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || (_document$activeEleme2 = _document$activeEleme.blur) === null || _document$activeEleme2 === void 0 || _document$activeEleme2.call(_document$activeEleme);
                handlesRef.current.focus(valueIndex);
                onStartDrag(e, valueIndex, cloneNextValues);
            }
        }
    };
    // ============================ Click =============================
    var onSliderMouseDown = function onSliderMouseDown(e) {
        e.preventDefault();
        var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height, left = _containerRef$current.left, top = _containerRef$current.top, bottom = _containerRef$current.bottom, right = _containerRef$current.right;
        var clientX = e.clientX, clientY = e.clientY;
        var percent;
        switch(direction){
            case 'btt':
                percent = (bottom - clientY) / height;
                break;
            case 'ttb':
                percent = (clientY - top) / height;
                break;
            case 'rtl':
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        var nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    var _React$useState = _react.useState(null), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), keyboardValue = _React$useState2[0], setKeyboardValue = _React$useState2[1];
    var onHandleOffsetChange = function onHandleOffsetChange(offset, valueIndex) {
        if (!disabled) {
            var next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue(next.value);
        }
    };
    _react.useEffect(function() {
        if (keyboardValue !== null) {
            var valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    var mergedDraggableTrack = _react.useMemo(function() {
        if (draggableTrack && mergedStep === null) return false;
        return draggableTrack;
    }, [
        draggableTrack,
        mergedStep
    ]);
    var onStartMove = function onStartMove(e, valueIndex) {
        onStartDrag(e, valueIndex);
        onBeforeChange === null || onBeforeChange === void 0 || onBeforeChange(getTriggerValue(rawValuesRef.current));
    };
    // Auto focus for updated handle
    var dragging = draggingIndex !== -1;
    _react.useEffect(function() {
        if (!dragging) {
            var valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    var sortedCacheValues = _react.useMemo(function() {
        return (0, _toConsumableArrayDefault.default)(cacheValues).sort(function(a, b) {
            return a - b;
        });
    }, [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    var _React$useMemo = _react.useMemo(function() {
        if (!range) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        range,
        mergedMin
    ]), _React$useMemo2 = (0, _slicedToArrayDefault.default)(_React$useMemo, 2), includedStart = _React$useMemo2[0], includedEnd = _React$useMemo2[1];
    // ============================= Refs =============================
    _react.useImperativeHandle(ref, function() {
        return {
            focus: function focus() {
                handlesRef.current.focus(0);
            },
            blur: function blur() {
                var _containerRef$current2;
                var _document = document, activeElement = _document.activeElement;
                if ((_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 && _containerRef$current2.contains(activeElement)) activeElement === null || activeElement === void 0 || activeElement.blur();
            }
        };
    });
    // ========================== Auto Focus ==========================
    _react.useEffect(function() {
        if (autoFocus) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    var context = _react.useMemo(function() {
        return {
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: range,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {}
        };
    }, [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        range,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaValueTextFormatterForHandle,
        styles,
        classNames
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: context
    }, /*#__PURE__*/ _react.createElement("div", {
        ref: containerRef,
        className: (0, _classnamesDefault.default)(prefixCls, className, (0, _definePropertyDefault.default)((0, _definePropertyDefault.default)((0, _definePropertyDefault.default)((0, _definePropertyDefault.default)({}, "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-vertical"), vertical), "".concat(prefixCls, "-horizontal"), !vertical), "".concat(prefixCls, "-with-marks"), markList.length)),
        style: style,
        onMouseDown: onSliderMouseDown
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _classnamesDefault.default)("".concat(prefixCls, "-rail"), classNames === null || classNames === void 0 ? void 0 : classNames.rail),
        style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, railStyle), styles === null || styles === void 0 ? void 0 : styles.rail)
    }), /*#__PURE__*/ _react.createElement((0, _tracksDefault.default), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: sortedCacheValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ _react.createElement((0, _stepsDefault.default), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ _react.createElement((0, _handlesDefault.default), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange
    }), /*#__PURE__*/ _react.createElement((0, _marksDefault.default), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
exports.default = Slider;

},{"@babel/runtime/helpers/esm/objectSpread2":"hdAgv","@babel/runtime/helpers/esm/defineProperty":"9y6jn","@babel/runtime/helpers/esm/toConsumableArray":"lwtGX","@babel/runtime/helpers/esm/slicedToArray":"Oz8Sg","@babel/runtime/helpers/esm/typeof":"dxfHD","classnames":"8ZF8C","rc-util/es/hooks/useMergedState":"6Z66o","rc-util/es/isEqual":"2KMoc","rc-util/es/warning":"3IW8L","react":"lXMxO","./Handles":"dM2F7","./Marks":"fvJoi","./Steps":"84rGW","./Tracks":"04Cjq","./context":"LZ7Sh","./hooks/useDrag":"dQ3Ml","./hooks/useOffset":"b82ri","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hdAgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"9y6jn","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9y6jn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"c2H8K","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"c2H8K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"dxfHD","./toPrimitive.js":"k965a","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dxfHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k965a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"dxfHD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lwtGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"gS5iq","./iterableToArray.js":"79ES1","./unsupportedIterableToArray.js":"3XRlH","./nonIterableSpread.js":"8LIvt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gS5iq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"9orzR","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9orzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"79ES1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3XRlH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"9orzR","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8LIvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"Oz8Sg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(r, e) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayLimitJsDefault.default)(r, e) || (0, _unsupportedIterableToArrayJsDefault.default)(r, e) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"fSHkU","./iterableToArrayLimit.js":"jzmkp","./unsupportedIterableToArray.js":"3XRlH","./nonIterableRest.js":"kX630","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fSHkU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jzmkp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kX630":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8ZF8C":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"6Z66o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergedState);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _useEvent = require("./useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useLayoutEffect = require("./useLayoutEffect");
var _useState = require("./useState");
var _useStateDefault = parcelHelpers.interopDefault(_useState);
/** We only think `undefined` is empty */ function hasValue(value) {
    return value !== undefined;
}
function useMergedState(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, _useStateDefault.default)(function() {
        if (hasValue(value)) return value;
        else if (hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, _useEventDefault.default)(onChange);
    var _useState3 = (0, _useStateDefault.default)([
        mergedValue
    ]), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        if (!hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, _useEventDefault.default)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

},{"@babel/runtime/helpers/esm/slicedToArray":"Oz8Sg","./useEvent":"3zk1u","./useLayoutEffect":"d1JQI","./useState":"8nbb1","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3zk1u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEvent);
var _react = require("react");
function useEvent(callback) {
    var fnRef = _react.useRef();
    fnRef.current = callback;
    var memoFn = _react.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"d1JQI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutUpdateEffect", ()=>useLayoutUpdateEffect);
var _react = require("react");
var _canUseDom = require("../Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var useInternalLayoutEffect = (0, _canUseDomDefault.default)() ? _react.useLayoutEffect : _react.useEffect;
var useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = _react.useRef(true);
    useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
    useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
exports.default = useLayoutEffect;

},{"react":"lXMxO","../Dom/canUseDom":"k6Zd0","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k6Zd0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>canUseDom);
function canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8nbb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSafeState);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _react = require("react");
function useSafeState(defaultValue) {
    var destroyRef = _react.useRef(false);
    var _React$useState = _react.useState(defaultValue), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    _react.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

},{"@babel/runtime/helpers/esm/slicedToArray":"Oz8Sg","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2KMoc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, _warningDefault.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, _typeofDefault.default)(a) === 'object' && (0, _typeofDefault.default)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
exports.default = isEqual;

},{"@babel/runtime/helpers/esm/typeof":"dxfHD","./warning":"3IW8L","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3IW8L":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preMessage", ()=>preMessage);
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ parcelHelpers.export(exports, "warning", ()=>warning);
/** @see Similar to {@link warning} */ parcelHelpers.export(exports, "note", ()=>note);
parcelHelpers.export(exports, "resetWarned", ()=>resetWarned);
parcelHelpers.export(exports, "call", ()=>call);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "warningOnce", ()=>warningOnce);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "noteOnce", ()=>noteOnce);
var warned = {};
var preWarningFns = [];
var preMessage = function preMessage(fn) {
    preWarningFns.push(fn);
};
function warning(valid, message) {
    var finalMessage;
}
function note(valid, message) {
    var finalMessage;
}
function resetWarned() {
    warned = {};
}
function call(method, valid, message) {
    if (!valid && !warned[message]) {
        method(false, message);
        warned[message] = true;
    }
}
function warningOnce(valid, message) {
    call(warning, valid, message);
}
function noteOnce(valid, message) {
    call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
exports.default = warningOnce;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dM2F7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _util = require("../util");
var _handle = require("./Handle");
var _handleDefault = parcelHelpers.interopDefault(_handle);
var _excluded = [
    "prefixCls",
    "style",
    "onStartMove",
    "onOffsetChange",
    "values",
    "handleRender",
    "activeHandleRender",
    "draggingIndex",
    "onFocus"
];
var Handles = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, style = props.style, onStartMove = props.onStartMove, onOffsetChange = props.onOffsetChange, values = props.values, handleRender = props.handleRender, activeHandleRender = props.activeHandleRender, draggingIndex = props.draggingIndex, onFocus = props.onFocus, restProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded);
    var handlesRef = _react.useRef({});
    _react.useImperativeHandle(ref, function() {
        return {
            focus: function focus(index) {
                var _handlesRef$current$i;
                (_handlesRef$current$i = handlesRef.current[index]) === null || _handlesRef$current$i === void 0 || _handlesRef$current$i.focus();
            }
        };
    });
    // =========================== Active ===========================
    var _React$useState = _react.useState(-1), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var onHandleFocus = function onHandleFocus(e, index) {
        setActiveIndex(index);
        onFocus === null || onFocus === void 0 || onFocus(e);
    };
    var onHandleMouseEnter = function onHandleMouseEnter(e, index) {
        setActiveIndex(index);
    };
    // =========================== Render ===========================
    // Handle Props
    var handleProps = (0, _objectSpread2Default.default)({
        prefixCls: prefixCls,
        onStartMove: onStartMove,
        onOffsetChange: onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter
    }, restProps);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, values.map(function(value, index) {
        return /*#__PURE__*/ _react.createElement((0, _handleDefault.default), (0, _extendsDefault.default)({
            ref: function ref(node) {
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: draggingIndex === index,
            style: (0, _util.getIndex)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && /*#__PURE__*/ _react.createElement((0, _handleDefault.default), (0, _extendsDefault.default)({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        render: activeHandleRender,
        style: {
            pointerEvents: 'none'
        },
        tabIndex: null,
        "aria-hidden": true
    })));
});
exports.default = Handles;

},{"@babel/runtime/helpers/esm/extends":"9dRPo","@babel/runtime/helpers/esm/objectSpread2":"hdAgv","@babel/runtime/helpers/esm/slicedToArray":"Oz8Sg","@babel/runtime/helpers/esm/objectWithoutProperties":"j5HBd","react":"lXMxO","../util":"DuTO5","./Handle":"kfoXj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j5HBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutProperties);
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = (0, _objectWithoutPropertiesLooseJsDefault.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

},{"./objectWithoutPropertiesLoose.js":"4sil6","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4sil6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"DuTO5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffset", ()=>getOffset);
parcelHelpers.export(exports, "getDirectionStyle", ()=>getDirectionStyle);
/** Return index value if is list or return value directly */ parcelHelpers.export(exports, "getIndex", ()=>getIndex);
function getOffset(value, min, max) {
    return (value - min) / (max - min);
}
function getDirectionStyle(direction, value, min, max) {
    var offset = getOffset(value, min, max);
    var positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateX(50%)';
            break;
        case 'btt':
            positionStyle.bottom = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateY(50%)';
            break;
        case 'ttb':
            positionStyle.top = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateY(-50%)';
            break;
        default:
            positionStyle.left = "".concat(offset * 100, "%");
            positionStyle.transform = 'translateX(-50%)';
            break;
    }
    return positionStyle;
}
function getIndex(value, index) {
    return Array.isArray(value) ? value[index] : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kfoXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _keyCode = require("rc-util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
var _excluded = [
    "prefixCls",
    "value",
    "valueIndex",
    "onStartMove",
    "style",
    "render",
    "dragging",
    "onOffsetChange",
    "onChangeComplete",
    "onFocus",
    "onMouseEnter"
];
var Handle = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, value = props.value, valueIndex = props.valueIndex, onStartMove = props.onStartMove, style = props.style, render = props.render, dragging = props.dragging, onOffsetChange = props.onOffsetChange, onChangeComplete = props.onChangeComplete, onFocus = props.onFocus, onMouseEnter = props.onMouseEnter, restProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded);
    var _React$useContext = _react.useContext((0, _contextDefault.default)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, disabled = _React$useContext.disabled, keyboard = _React$useContext.keyboard, range = _React$useContext.range, tabIndex = _React$useContext.tabIndex, ariaLabelForHandle = _React$useContext.ariaLabelForHandle, ariaLabelledByForHandle = _React$useContext.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _React$useContext.ariaValueTextFormatterForHandle, styles = _React$useContext.styles, classNames = _React$useContext.classNames;
    var handlePrefixCls = "".concat(prefixCls, "-handle");
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled) onStartMove(e, valueIndex);
    };
    var onInternalFocus = function onInternalFocus(e) {
        onFocus === null || onFocus === void 0 || onFocus(e, valueIndex);
    };
    var onInternalMouseEnter = function onInternalMouseEnter(e) {
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    var onKeyDown = function onKeyDown(e) {
        if (!disabled && keyboard) {
            var offset = null;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, _keyCodeDefault.default).LEFT:
                    offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
                    break;
                case (0, _keyCodeDefault.default).RIGHT:
                    offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
                    break;
                // Up is plus
                case (0, _keyCodeDefault.default).UP:
                    offset = direction !== 'ttb' ? 1 : -1;
                    break;
                // Down is minus
                case (0, _keyCodeDefault.default).DOWN:
                    offset = direction !== 'ttb' ? -1 : 1;
                    break;
                case (0, _keyCodeDefault.default).HOME:
                    offset = 'min';
                    break;
                case (0, _keyCodeDefault.default).END:
                    offset = 'max';
                    break;
                case (0, _keyCodeDefault.default).PAGE_UP:
                    offset = 2;
                    break;
                case (0, _keyCodeDefault.default).PAGE_DOWN:
                    offset = -2;
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    var handleKeyUp = function handleKeyUp(e) {
        switch(e.which || e.keyCode){
            case (0, _keyCodeDefault.default).LEFT:
            case (0, _keyCodeDefault.default).RIGHT:
            case (0, _keyCodeDefault.default).UP:
            case (0, _keyCodeDefault.default).DOWN:
            case (0, _keyCodeDefault.default).HOME:
            case (0, _keyCodeDefault.default).END:
            case (0, _keyCodeDefault.default).PAGE_UP:
            case (0, _keyCodeDefault.default).PAGE_DOWN:
                onChangeComplete === null || onChangeComplete === void 0 || onChangeComplete();
                break;
        }
    };
    // ============================ Offset ============================
    var positionStyle = (0, _util.getDirectionStyle)(direction, value, min, max);
    // ============================ Render ============================
    var divProps = {};
    if (valueIndex !== null) {
        var _getIndex;
        divProps = {
            tabIndex: disabled ? null : (0, _util.getIndex)(tabIndex, valueIndex),
            role: 'slider',
            'aria-valuemin': min,
            'aria-valuemax': max,
            'aria-valuenow': value,
            'aria-disabled': disabled,
            'aria-label': (0, _util.getIndex)(ariaLabelForHandle, valueIndex),
            'aria-labelledby': (0, _util.getIndex)(ariaLabelledByForHandle, valueIndex),
            'aria-valuetext': (_getIndex = (0, _util.getIndex)(ariaValueTextFormatterForHandle, valueIndex)) === null || _getIndex === void 0 ? void 0 : _getIndex(value),
            'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
            onMouseDown: onInternalStartMove,
            onTouchStart: onInternalStartMove,
            onFocus: onInternalFocus,
            onMouseEnter: onInternalMouseEnter,
            onKeyDown: onKeyDown,
            onKeyUp: handleKeyUp
        };
    }
    var handleNode = /*#__PURE__*/ _react.createElement("div", (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _classnamesDefault.default)(handlePrefixCls, (0, _definePropertyDefault.default)((0, _definePropertyDefault.default)({}, "".concat(handlePrefixCls, "-").concat(valueIndex + 1), valueIndex !== null && range), "".concat(handlePrefixCls, "-dragging"), dragging), classNames.handle),
        style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, positionStyle), style), styles.handle)
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging
    });
    return handleNode;
});
exports.default = Handle;

},{"@babel/runtime/helpers/esm/extends":"9dRPo","@babel/runtime/helpers/esm/objectSpread2":"hdAgv","@babel/runtime/helpers/esm/defineProperty":"9y6jn","@babel/runtime/helpers/esm/objectWithoutProperties":"j5HBd","classnames":"8ZF8C","rc-util/es/KeyCode":"93gCa","react":"lXMxO","../context":"LZ7Sh","../util":"DuTO5","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"93gCa":[function(require,module,exports,__globalThis) {
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case KeyCode.ALT:
            case KeyCode.CAPS_LOCK:
            case KeyCode.CONTEXT_MENU:
            case KeyCode.CTRL:
            case KeyCode.DOWN:
            case KeyCode.END:
            case KeyCode.ESC:
            case KeyCode.HOME:
            case KeyCode.INSERT:
            case KeyCode.LEFT:
            case KeyCode.MAC_FF_META:
            case KeyCode.META:
            case KeyCode.NUMLOCK:
            case KeyCode.NUM_CENTER:
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAUSE:
            case KeyCode.PRINT_SCREEN:
            case KeyCode.RIGHT:
            case KeyCode.SHIFT:
            case KeyCode.UP:
            case KeyCode.WIN_KEY:
            case KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) return true;
        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case KeyCode.SPACE:
            case KeyCode.QUESTION_MARK:
            case KeyCode.NUM_PLUS:
            case KeyCode.NUM_MINUS:
            case KeyCode.NUM_PERIOD:
            case KeyCode.NUM_DIVISION:
            case KeyCode.SEMICOLON:
            case KeyCode.DASH:
            case KeyCode.EQUALS:
            case KeyCode.COMMA:
            case KeyCode.PERIOD:
            case KeyCode.SLASH:
            case KeyCode.APOSTROPHE:
            case KeyCode.SINGLE_QUOTE:
            case KeyCode.OPEN_SQUARE_BRACKET:
            case KeyCode.BACKSLASH:
            case KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
exports.default = KeyCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"LZ7Sh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var SliderContext = /*#__PURE__*/ _react.createContext({
    min: 0,
    max: 0,
    direction: 'ltr',
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {}
});
exports.default = SliderContext;

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fvJoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _mark = require("./Mark");
var _markDefault = parcelHelpers.interopDefault(_mark);
var Marks = function Marks(props) {
    var prefixCls = props.prefixCls, marks = props.marks, onClick = props.onClick;
    var markPrefixCls = "".concat(prefixCls, "-mark");
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ _react.createElement("div", {
        className: markPrefixCls
    }, marks.map(function(_ref) {
        var value = _ref.value, style = _ref.style, label = _ref.label;
        return /*#__PURE__*/ _react.createElement((0, _markDefault.default), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label);
    }));
};
exports.default = Marks;

},{"react":"lXMxO","./Mark":"8YIex","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8YIex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
var Mark = function Mark(props) {
    var prefixCls = props.prefixCls, style = props.style, children = props.children, value = props.value, _onClick = props.onClick;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd, included = _React$useContext.included;
    var textCls = "".concat(prefixCls, "-text");
    // ============================ Offset ============================
    var positionStyle = (0, _util.getDirectionStyle)(direction, value, min, max);
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _classnamesDefault.default)(textCls, (0, _definePropertyDefault.default)({}, "".concat(textCls, "-active"), included && includedStart <= value && value <= includedEnd)),
        style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, positionStyle), style),
        onMouseDown: function onMouseDown(e) {
            e.stopPropagation();
        },
        onClick: function onClick() {
            _onClick(value);
        }
    }, children);
};
exports.default = Mark;

},{"@babel/runtime/helpers/esm/objectSpread2":"hdAgv","@babel/runtime/helpers/esm/defineProperty":"9y6jn","classnames":"8ZF8C","react":"lXMxO","../context":"LZ7Sh","../util":"DuTO5","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"84rGW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _dot = require("./Dot");
var _dotDefault = parcelHelpers.interopDefault(_dot);
var Steps = function Steps(props) {
    var prefixCls = props.prefixCls, marks = props.marks, dots = props.dots, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), min = _React$useContext.min, max = _React$useContext.max, step = _React$useContext.step;
    var stepDots = _react.useMemo(function() {
        var dotSet = new Set();
        // Add marks
        marks.forEach(function(mark) {
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            var current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, stepDots.map(function(dotValue) {
        return /*#__PURE__*/ _react.createElement((0, _dotDefault.default), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        });
    }));
};
exports.default = Steps;

},{"react":"lXMxO","../context":"LZ7Sh","./Dot":"k4XW2","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k4XW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
var Dot = function Dot(props) {
    var prefixCls = props.prefixCls, value = props.value, style = props.style, activeStyle = props.activeStyle;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), min = _React$useContext.min, max = _React$useContext.max, direction = _React$useContext.direction, included = _React$useContext.included, includedStart = _React$useContext.includedStart, includedEnd = _React$useContext.includedEnd;
    var dotClassName = "".concat(prefixCls, "-dot");
    var active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    var mergedStyle = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, (0, _util.getDirectionStyle)(direction, value, min, max)), typeof style === 'function' ? style(value) : style);
    if (active) mergedStyle = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, mergedStyle), typeof activeStyle === 'function' ? activeStyle(value) : activeStyle);
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _classnamesDefault.default)(dotClassName, (0, _definePropertyDefault.default)({}, "".concat(dotClassName, "-active"), active)),
        style: mergedStyle
    });
};
exports.default = Dot;

},{"@babel/runtime/helpers/esm/defineProperty":"9y6jn","@babel/runtime/helpers/esm/objectSpread2":"hdAgv","classnames":"8ZF8C","react":"lXMxO","../context":"LZ7Sh","../util":"DuTO5","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"04Cjq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
var _track = require("./Track");
var _trackDefault = parcelHelpers.interopDefault(_track);
var Tracks = function Tracks(props) {
    var prefixCls = props.prefixCls, style = props.style, values = props.values, startPoint = props.startPoint, onStartMove = props.onStartMove;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), included = _React$useContext.included, range = _React$useContext.range, min = _React$useContext.min, styles = _React$useContext.styles, classNames = _React$useContext.classNames;
    // =========================== List ===========================
    var trackList = _react.useMemo(function() {
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            var startValue = startPoint !== null && startPoint !== void 0 ? startPoint : min;
            var endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        var list = [];
        for(var i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    var tracksNode = classNames.tracks || styles.tracks ? /*#__PURE__*/ _react.createElement((0, _trackDefault.default), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, _classnamesDefault.default)(classNames.tracks, "".concat(prefixCls, "-tracks")),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, tracksNode, trackList.map(function(_ref, index) {
        var start = _ref.start, end = _ref.end;
        return /*#__PURE__*/ _react.createElement((0, _trackDefault.default), {
            index: index,
            prefixCls: prefixCls,
            style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, (0, _util.getIndex)(style, index)), styles.track),
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        });
    }));
};
exports.default = Tracks;

},{"@babel/runtime/helpers/esm/objectSpread2":"hdAgv","classnames":"8ZF8C","react":"lXMxO","../context":"LZ7Sh","../util":"DuTO5","./Track":"bXojb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bXojb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
var Track = function Track(props) {
    var prefixCls = props.prefixCls, style = props.style, start = props.start, end = props.end, index = props.index, onStartMove = props.onStartMove, replaceCls = props.replaceCls;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), direction = _React$useContext.direction, min = _React$useContext.min, max = _React$useContext.max, disabled = _React$useContext.disabled, range = _React$useContext.range, classNames = _React$useContext.classNames;
    var trackPrefixCls = "".concat(prefixCls, "-track");
    var offsetStart = (0, _util.getOffset)(start, min, max);
    var offsetEnd = (0, _util.getOffset)(end, min, max);
    // ============================ Events ============================
    var onInternalStartMove = function onInternalStartMove(e) {
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    var positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case 'btt':
            positionStyle.bottom = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        case 'ttb':
            positionStyle.top = "".concat(offsetStart * 100, "%");
            positionStyle.height = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
            break;
        default:
            positionStyle.left = "".concat(offsetStart * 100, "%");
            positionStyle.width = "".concat(offsetEnd * 100 - offsetStart * 100, "%");
    }
    var className = replaceCls || (0, _classnamesDefault.default)(trackPrefixCls, (0, _definePropertyDefault.default)((0, _definePropertyDefault.default)({}, "".concat(trackPrefixCls, "-").concat(index + 1), index !== null && range), "".concat(prefixCls, "-track-draggable"), onStartMove), classNames.track);
    return /*#__PURE__*/ _react.createElement("div", {
        className: className,
        style: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, positionStyle), style),
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
exports.default = Track;

},{"@babel/runtime/helpers/esm/objectSpread2":"hdAgv","@babel/runtime/helpers/esm/defineProperty":"9y6jn","classnames":"8ZF8C","react":"lXMxO","../context":"LZ7Sh","../util":"DuTO5","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dQ3Ml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _rcUtil = require("rc-util");
var _react = require("react");
function getPosition(e) {
    var obj = 'touches' in e ? e.touches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues) {
    var _React$useState = _react.useState(null), _React$useState2 = (0, _slicedToArrayDefault.default)(_React$useState, 2), draggingValue = _React$useState2[0], setDraggingValue = _React$useState2[1];
    var _React$useState3 = _react.useState(-1), _React$useState4 = (0, _slicedToArrayDefault.default)(_React$useState3, 2), draggingIndex = _React$useState4[0], setDraggingIndex = _React$useState4[1];
    var _React$useState5 = _react.useState(rawValues), _React$useState6 = (0, _slicedToArrayDefault.default)(_React$useState5, 2), cacheValues = _React$useState6[0], setCacheValues = _React$useState6[1];
    var _React$useState7 = _react.useState(rawValues), _React$useState8 = (0, _slicedToArrayDefault.default)(_React$useState7, 2), originValues = _React$useState8[0], setOriginValues = _React$useState8[1];
    var mouseMoveEventRef = _react.useRef(null);
    var mouseUpEventRef = _react.useRef(null);
    _react.useLayoutEffect(function() {
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    _react.useEffect(function() {
        return function() {
            document.removeEventListener('mousemove', mouseMoveEventRef.current);
            document.removeEventListener('mouseup', mouseUpEventRef.current);
            document.removeEventListener('touchmove', mouseMoveEventRef.current);
            document.removeEventListener('touchend', mouseUpEventRef.current);
        };
    }, []);
    var flushValues = function flushValues(nextValues, nextValue) {
        // Perf: Only update state when value changed
        if (cacheValues.some(function(val, i) {
            return val !== nextValues[i];
        })) {
            if (nextValue !== undefined) setDraggingValue(nextValue);
            setCacheValues(nextValues);
            triggerChange(nextValues);
        }
    };
    var updateCacheValue = (0, _rcUtil.useEvent)(function(valueIndex, offsetPercent) {
        // Basic point offset
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            var startValue = originValues[0];
            var endValue = originValues[originValues.length - 1];
            var maxStartOffset = min - startValue;
            var maxEndOffset = max - endValue;
            // Get valid offset
            var offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            var formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            var cloneCacheValues = originValues.map(function(val) {
                return val + offset;
            });
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            var offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            var cloneValues = (0, _toConsumableArrayDefault.default)(cacheValues);
            cloneValues[valueIndex] = originValues[valueIndex];
            var next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
            flushValues(next.values, next.value);
        }
    });
    var onStartMove = function onStartMove(e, valueIndex, startValues) {
        e.stopPropagation();
        // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
        var initialValues = startValues || rawValues;
        var originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        var _getPosition = getPosition(e), startX = _getPosition.pageX, startY = _getPosition.pageY;
        // Moving
        var onMouseMove = function onMouseMove(event) {
            event.preventDefault();
            var _getPosition2 = getPosition(event), moveX = _getPosition2.pageX, moveY = _getPosition2.pageY;
            var offsetX = moveX - startX;
            var offsetY = moveY - startY;
            var _containerRef$current = containerRef.current.getBoundingClientRect(), width = _containerRef$current.width, height = _containerRef$current.height;
            var offSetPercent;
            switch(direction){
                case 'btt':
                    offSetPercent = -offsetY / height;
                    break;
                case 'ttb':
                    offSetPercent = offsetY / height;
                    break;
                case 'rtl':
                    offSetPercent = -offsetX / width;
                    break;
                default:
                    offSetPercent = offsetX / width;
            }
            updateCacheValue(valueIndex, offSetPercent);
        };
        // End
        var onMouseUp = function onMouseUp(event) {
            event.preventDefault();
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('touchend', onMouseUp);
            document.removeEventListener('touchmove', onMouseMove);
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            setDraggingIndex(-1);
            finishChange();
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('touchend', onMouseUp);
        document.addEventListener('touchmove', onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
    };
    // Only return cache value when it mapping with rawValues
    var returnValues = _react.useMemo(function() {
        var sourceValues = (0, _toConsumableArrayDefault.default)(rawValues).sort(function(a, b) {
            return a - b;
        });
        var targetValues = (0, _toConsumableArrayDefault.default)(cacheValues).sort(function(a, b) {
            return a - b;
        });
        return sourceValues.every(function(val, index) {
            return val === targetValues[index];
        }) ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues
    ]);
    return [
        draggingIndex,
        draggingValue,
        returnValues,
        onStartMove
    ];
}
exports.default = useDrag;

},{"@babel/runtime/helpers/esm/toConsumableArray":"lwtGX","@babel/runtime/helpers/esm/slicedToArray":"Oz8Sg","rc-util":"at7tI","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"at7tI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEvent", ()=>(0, _useEventDefault.default));
parcelHelpers.export(exports, "useMergedState", ()=>(0, _useMergedStateDefault.default));
parcelHelpers.export(exports, "supportNodeRef", ()=>(0, _ref.supportNodeRef));
parcelHelpers.export(exports, "supportRef", ()=>(0, _ref.supportRef));
parcelHelpers.export(exports, "useComposeRef", ()=>(0, _ref.useComposeRef));
parcelHelpers.export(exports, "get", ()=>(0, _getDefault.default));
parcelHelpers.export(exports, "set", ()=>(0, _setDefault.default));
parcelHelpers.export(exports, "warning", ()=>(0, _warningDefault.default));
var _useEvent = require("./hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useMergedState = require("./hooks/useMergedState");
var _useMergedStateDefault = parcelHelpers.interopDefault(_useMergedState);
var _ref = require("./ref");
var _get = require("./utils/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("./utils/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);

},{"./hooks/useEvent":"3zk1u","./hooks/useMergedState":"6Z66o","./ref":"hsd7C","./utils/get":"2FFqi","./utils/set":"eS1W4","./warning":"3IW8L","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hsd7C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillRef", ()=>fillRef);
parcelHelpers.export(exports, "composeRef", ()=>composeRef);
parcelHelpers.export(exports, "useComposeRef", ()=>useComposeRef);
parcelHelpers.export(exports, "supportRef", ()=>supportRef);
parcelHelpers.export(exports, "supportNodeRef", ()=>supportNodeRef);
parcelHelpers.export(exports, "getNodeRef", ()=>getNodeRef);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _react = require("react");
var _reactIs = require("react-is");
var _useMemo = require("./hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isFragment = require("./React/isFragment");
var _isFragmentDefault = parcelHelpers.interopDefault(_isFragment);
var ReactMajorVersion = Number((0, _react.version).split('.')[0]);
var fillRef = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, _typeofDefault.default)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var composeRef = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            fillRef(ref, node);
        });
    };
};
var useComposeRef = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, _useMemoDefault.default)(function() {
        return composeRef.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var supportRef = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) return true;
    var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    return true;
};
function isReactElement(node) {
    return /*#__PURE__*/ (0, _react.isValidElement)(node) && !(0, _isFragmentDefault.default)(node);
}
var supportNodeRef = function supportNodeRef(node) {
    return isReactElement(node) && supportRef(node);
};
var getNodeRef = function getNodeRef(node) {
    if (node && isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

},{"@babel/runtime/helpers/esm/typeof":"dxfHD","react":"lXMxO","react-is":"cDLYm","./hooks/useMemo":"4GdDO","./React/isFragment":"k3NGD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cDLYm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"80VDs"}],"80VDs":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"4GdDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMemo);
var _react = require("react");
function useMemo(getValue, condition, shouldUpdate) {
    var cacheRef = _react.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

},{"react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k3NGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFragment);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function isFragment(object) {
    return(// Base object type
    object && (0, _typeofDefault.default)(object) === 'object' && // React Element type
    (object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === REACT_FRAGMENT_TYPE);
}

},{"@babel/runtime/helpers/esm/typeof":"dxfHD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2FFqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>get);
function get(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eS1W4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>set);
/**
 * Merge objects which will create
 */ parcelHelpers.export(exports, "merge", ()=>merge);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _toArray = require("@babel/runtime/helpers/esm/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _get = require("./get");
var _getDefault = parcelHelpers.interopDefault(_get);
function internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, _toArrayDefault.default)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, _toConsumableArrayDefault.default)(entity);
    else clone = (0, _objectSpread2Default.default)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function set(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, _getDefault.default)(entity, paths.slice(0, -1))) return entity;
    return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
    return (0, _typeofDefault.default)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function merge() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, _getDefault.default)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, _getDefault.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = set(clone, path, []);
                    else if (!originValue || (0, _typeofDefault.default)(originValue) !== 'object') // Init container if not exist
                    clone = set(clone, path, createEmpty(value));
                    keys(value).forEach(function(key) {
                        internalMerge([].concat((0, _toConsumableArrayDefault.default)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = set(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}

},{"@babel/runtime/helpers/esm/typeof":"dxfHD","@babel/runtime/helpers/esm/objectSpread2":"hdAgv","@babel/runtime/helpers/esm/toConsumableArray":"lwtGX","@babel/runtime/helpers/esm/toArray":"g7SPi","./get":"2FFqi","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"g7SPi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _toArray(r) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"fSHkU","./iterableToArray.js":"79ES1","./unsupportedIterableToArray.js":"3XRlH","./nonIterableRest.js":"kX630","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"b82ri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOffset);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
function useOffset(min, max, step, markList, allowCross, pushable) {
    var formatRangeValue = _react.useCallback(function(val) {
        return Math.max(min, Math.min(max, val));
    }, [
        min,
        max
    ]);
    var formatStepValue = _react.useCallback(function(val) {
        if (step !== null) {
            var stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            var getDecimal = function getDecimal(num) {
                return (String(num).split('.')[1] || '').length;
            };
            var maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            var fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    var formatValue = _react.useCallback(function(val) {
        var formatNextValue = formatRangeValue(val);
        // List align values
        var alignValues = markList.map(function(mark) {
            return mark.value;
        });
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        var closeValue = alignValues[0];
        var closeDist = max - min;
        alignValues.forEach(function(alignValue) {
            var dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    var offsetValue = function offsetValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        if (typeof offset === 'number') {
            var nextValue;
            var originValue = values[valueIndex];
            // Only used for `dist` mode
            var targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            var potentialValues = [];
            markList.forEach(function(mark) {
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            var sign = offset > 0 ? 1 : -1;
            if (mode === 'unit') potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter(function(val) {
                return val !== null;
            })// Remove reverse value
            .filter(function(val) {
                return offset < 0 ? val <= originValue : val >= originValue;
            });
            if (mode === 'unit') // `unit` mode can not contain itself
            potentialValues = potentialValues.filter(function(val) {
                return val !== originValue;
            });
            var compareValue = mode === 'unit' ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            var valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach(function(potentialValue) {
                var dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === 'dist') return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                var cloneValues = (0, _toConsumableArrayDefault.default)(values);
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === 'min') return min;
        else if (offset === 'max') return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ var offsetChangedValue = function offsetChangedValue(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        var originValue = values[valueIndex];
        var nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    var needPush = function needPush(dist) {
        return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
    };
    // Values
    var offsetValues = function offsetValues(values, offset, valueIndex) {
        var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'unit';
        var nextValues = values.map(formatValue);
        var originValue = nextValues[valueIndex];
        var nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            var pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === 'number' || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(var i = valueIndex + 1; i < nextValues.length; i += 1){
                var changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed){
                    var _offsetChangedValue = offsetChangedValue(nextValues, 1, i);
                    nextValues[i] = _offsetChangedValue.value;
                    changed = _offsetChangedValue.changed;
                }
            }
            // Start values
            for(var _i = valueIndex; _i > 0; _i -= 1){
                var _changed = true;
                while(needPush(nextValues[_i] - nextValues[_i - 1]) && _changed){
                    var _offsetChangedValue2 = offsetChangedValue(nextValues, -1, _i - 1);
                    nextValues[_i - 1] = _offsetChangedValue2.value;
                    _changed = _offsetChangedValue2.changed;
                }
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(var _i2 = nextValues.length - 1; _i2 > 0; _i2 -= 1){
                var _changed2 = true;
                while(needPush(nextValues[_i2] - nextValues[_i2 - 1]) && _changed2){
                    var _offsetChangedValue3 = offsetChangedValue(nextValues, -1, _i2 - 1);
                    nextValues[_i2 - 1] = _offsetChangedValue3.value;
                    _changed2 = _offsetChangedValue3.changed;
                }
            }
            // Start to End
            for(var _i3 = 0; _i3 < nextValues.length - 1; _i3 += 1){
                var _changed3 = true;
                while(needPush(nextValues[_i3 + 1] - nextValues[_i3]) && _changed3){
                    var _offsetChangedValue4 = offsetChangedValue(nextValues, 1, _i3 + 1);
                    nextValues[_i3 + 1] = _offsetChangedValue4.value;
                    _changed3 = _offsetChangedValue4.changed;
                }
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}

},{"@babel/runtime/helpers/esm/toConsumableArray":"lwtGX","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jQ3S6":[function() {},{}],"gmHtd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SplineEditor", ()=>SplineEditor);
var _jsxRuntime = require("react/jsx-runtime");
// @ts-nocheck
var _react = require("react");
//@ts-ignore
var _canvasSpliner = require("CanvasSpliner");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
let _ = (t)=>t, t;
class Spliner extends (0, _canvasSpliner.CanvasSpliner) {
    _updateMousePosition(evt) {
        var _this__canvas;
        const rect = (_this__canvas = this._canvas) === null || _this__canvas === void 0 ? void 0 : _this__canvas.getBoundingClientRect();
        const scaleX = this._canvas.width / rect.width;
        const scaleY = this._canvas.height / rect.height;
        this._mouse = {
            x: (evt.clientX - rect.left) * scaleX,
            y: this._height - (evt.clientY - rect.top) * scaleY
        };
    }
    getPoints() {
        const xFactor = 1 / this._width;
        const yFactor = 1 / this._height;
        return this._pointCollection._points.map(({ x, y })=>({
                x: x * xFactor,
                y: y * yFactor
            }));
    }
    removeAll() {
        const length = this._pointCollection.getNumberOfPoints();
        for(let i = length; i > 0; i--)this._pointCollection.remove(i - 1);
    }
    update(points) {
        this.removeAll();
        const xFactor = this._width;
        const yFactor = this._height;
        points.forEach(({ x, y })=>{
            this._pointCollection.add({
                x: x * xFactor,
                y: y * yFactor
            });
        });
        this.draw();
    }
    off(eventName, handler) {
    // @TODO: implement unsibscribe
    }
}
const WaveShaperInner = (0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
  position: relative;
  canvas {
    border: none !important;
    position: absolute;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
  }
`));
const SplineEditor = ({ onChange, onMove, points, type = "monotonic", textColor = "red", curveColor = (0, _core.theme).colors.accent2, gridStep = 0.25, gridColor = (0, _core.theme).colors.elevation2, controlPointRadius = 14, controlPointColor = (0, _core.theme).colors.vivid1 })=>{
    const ref = (0, _react.useRef)(null);
    const [spliner, setSpliner] = (0, _react.useState)();
    const handlePointsChange = (0, _react.useCallback)((csObj)=>{
        const points = csObj.getPoints();
        onChange === null || onChange === void 0 ? void 0 : onChange(points);
    }, [
        onChange
    ]);
    const handlePointMove = (0, _react.useCallback)((csObj)=>{
        const points = csObj.getPoints();
        onMove === null || onMove === void 0 ? void 0 : onMove(points);
    }, [
        onMove
    ]);
    (0, _react.useEffect)(()=>spliner === null || spliner === void 0 ? void 0 : spliner.update(points), [
        spliner,
        points
    ]);
    (0, _react.useEffect)(()=>spliner === null || spliner === void 0 ? void 0 : spliner.setSplineType(type), [
        spliner,
        type
    ]);
    (0, _react.useEffect)(()=>spliner === null || spliner === void 0 ? void 0 : spliner.setGridStep(gridStep), [
        spliner,
        gridStep
    ]);
    (0, _react.useEffect)(()=>spliner === null || spliner === void 0 ? void 0 : spliner.setGridColor(gridColor), [
        spliner,
        gridColor
    ]);
    (0, _react.useEffect)(()=>spliner === null || spliner === void 0 ? void 0 : spliner.setControlPointRadius(controlPointRadius), [
        spliner,
        controlPointRadius
    ]);
    (0, _react.useEffect)(()=>spliner === null || spliner === void 0 ? void 0 : spliner.setTextColor(textColor), [
        spliner,
        textColor
    ]);
    (0, _react.useEffect)(()=>{
        spliner === null || spliner === void 0 ? void 0 : spliner.setCurveColor("idle", curveColor);
    // spliner?.setCurveColor("moving", "yellow");
    }, [
        spliner,
        curveColor
    ]);
    (0, _react.useEffect)(()=>{
        spliner === null || spliner === void 0 ? void 0 : spliner.setControlPointColor("idle", controlPointColor);
    // spliner?.setControlPointColor("hovered", "blue");
    // spliner?.setControlPointColor("grabbed", "black");
    }, [
        spliner,
        controlPointColor
    ]);
    (0, _react.useEffect)(()=>{
        if (!spliner) return;
        spliner.setCurveThickness(4);
        spliner.on("movePoint", handlePointMove);
        spliner.on("releasePoint", handlePointsChange);
        spliner.on("pointAdded", handlePointsChange);
        spliner.on("pointRemoved", handlePointsChange);
        spliner.draw();
        return ()=>{
            spliner.off("movePoint", handlePointMove);
            spliner.off("releasePoint", handlePointsChange);
            spliner.off("pointAdded", handlePointsChange);
            spliner.off("pointRemoved", handlePointsChange);
        };
    }, [
        spliner,
        handlePointsChange,
        handlePointMove
    ]);
    (0, _react.useEffect)(()=>{
        if (!ref.current) return;
        const cs = new Spliner(ref.current, 1024, 1024);
        setSpliner(cs);
    }, [
        ref
    ]);
    return (0, _jsxRuntime.jsx)(WaveShaperInner, {
        ref: ref
    });
};
exports.default = SplineEditor;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","CanvasSpliner":"6Z0pB","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6Z0pB":[function(require,module,exports,__globalThis) {
/*
* Author    Jonathan Lurie - http://me.jonahanlurie.fr
* License   MIT
* Link      https://github.com/jonathanlurie/es6module
* Lab       MCIN - http://mcin.ca/ - Montreal Neurological Institute
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CanvasSpliner", ()=>CanvasSpliner) // Note: we chose not to export PointCollection
;
var _splines = require("splines");
var _splinesDefault = parcelHelpers.interopDefault(_splines);
var _pointCollectionJs = require("./PointCollection.js");
/**
* events:
*   - "movePoint" called everytime the pointer moves a point, with argument x and y normalized arrays
*   - "releasePoint" called everytime the pointers is released after moving a point, with argument x and y normalized arrays
*   - "pointAdded"
*/ class CanvasSpliner {
    /**
  * Get an array of all the x coordinates that CanvasSpliner computed an interpolation of.
  * See getYSeriesInterpolated to get the corresponding interpolated values.
  * @return {Array} of x values with regular interval in [0, 1]
  */ getXSeriesInterpolated() {
        return this._xSeriesInterpolated;
    }
    /**
  * Get all the interpolated values for each x given by getXSeriesInterpolated.
  * @return {Array} of interpolated y
  */ getYSeriesInterpolated() {
        return this._ySeriesInterpolated;
    }
    /**
  * Change the radius of the control points
  * @param {Number} r - the radius in pixel
  */ setControlPointRadius(r) {
        this._controlPointRadius = r;
    }
    /**
  * Set the color of the control point in a specific state
  * @param {String} state - must be one of: "idle", "hovered" or "grabbed"
  * @param {String} color - must be css style best is of form "rgba(244, 66, 167, 0.5)"
  */ setControlPointColor(state, color) {
        this._controlPointColor[state] = color;
    }
    /**
  * Set the color of the curve in a specific state
  * @param {String} state - must be one of: "idle" or "moving"
  * @param {String} color - must be css style best is of form "rgba(244, 66, 167, 0.5)"
  */ setCurveColor(state, color) {
        this._curveColor[state] = color;
    }
    /**
  * Set the color of the grid
  * @param {String} color - must be css style best is of form "rgba(244, 66, 167, 0.5)"
  */ setGridColor(color) {
        this._gridColor = color;
    }
    /**
  * Define the grid step in unit coodinate. Default: 0.33
  * @param {Number}
  */ setGridStep(gs) {
        if (gs <= 0 || gs >= 1) this._gridStep = 0;
        else this._gridStep = gs;
        this.draw();
    }
    /**
  * Set the color of the text
  * @param {String} color - must be css style best is of form "rgba(244, 66, 167, 0.5)"
  */ setTextColor(color) {
        this._textColor = color;
    }
    /**
  * Define the thickness of the curve
  * @param {Number} t - thickness in pixel
  */ setCurveThickness(t) {
        this._curveThickness = t;
    }
    /**
  * Define the canvas background color
  * @param {String} color - must be css style best is of form "rgba(244, 66, 167, 0.5)" 
  * Can allso be null/0/false to leave a blank background
  */ setBackgroundColor(color) {
        this._backgroundColor = color;
    }
    /**
  * @param {String} splineType - "natural" or "monotonic"
  */ setSplineType(splineType) {
        if (splineType === "monotonic") this._splineConstructor = (0, _splinesDefault.default).MonotonicCubicSpline;
        else this._splineConstructor = (0, _splinesDefault.default).CubicSpline;
    }
    /**
  * [PRIVATE]
  * Refresh the position of the pointer we store internally (relative to the canvas)
  */ _updateMousePosition(evt) {
        var rect = this._canvas.getBoundingClientRect();
        this._mouse = {
            x: evt.clientX - rect.left,
            y: this._height - (evt.clientY - rect.top)
        };
    }
    /**
  * [EVENT] [PRIVATE]
  * for when the mouse is moving over the canvas
  */ _onCanvasMouseMove(evt) {
        this._updateMousePosition(evt);
        //console.log( 'moving: ' + this._mouse.x + ',' + this._mouse.y );
        // check what control point is the closest from the pointer position
        var closestPointInfo = this._pointCollection.getClosestFrom(this._mouse);
        if (!closestPointInfo) return;
        // no point is currently grabbed
        if (this._pointGrabbedIndex == -1) {
            // the pointer hovers a point
            if (closestPointInfo.distance <= this._controlPointRadius) this._pointHoveredIndex = closestPointInfo.index;
            else {
                // ... but maybe it used to hove a point, in this case we want to redraw
                // to change back the color to idle mode
                var mustRedraw = false;
                if (this._pointHoveredIndex != -1) mustRedraw = true;
                this._pointHoveredIndex = -1;
                if (mustRedraw) this.draw();
            }
        } else {
            this._pointGrabbedIndex = this._pointCollection.updatePoint(this._pointGrabbedIndex, this._mouse);
            this._pointHoveredIndex = this._pointGrabbedIndex;
        }
        // reduce usless drawing
        if (this._pointHoveredIndex != -1 || this._pointGrabbedIndex != -1) this.draw();
        // now the buffer is filled (after draw)
        if (this._pointGrabbedIndex != -1) {
            var grabbedPoint = this._pointCollection.getPoint(this._pointGrabbedIndex);
            this._drawCoordinates(Math.round(grabbedPoint.x / this._width * 1000) / 1000, Math.round(grabbedPoint.y / this._height * 1000) / 1000);
            if (this._onEvents.movePoint) this._onEvents.movePoint(this);
        }
    }
    /**
  * [EVENT] [PRIVATE]
  * for when the mouse is clicked over the canvas
  */ _onCanvasMouseDown(evt) {
        //console.log( 'down ');
        this._mouseDown = true;
        if (this._pointHoveredIndex != -1) //console.log("grabing a point");
        this._pointGrabbedIndex = this._pointHoveredIndex;
    }
    /**
  * [EVENT] [PRIVATE]
  * for when the mouse is released over the canvas
  */ _onCanvasMouseUp(evt) {
        //console.log( 'up ' );
        var aPointWasGrabbed = this._pointGrabbedIndex != -1;
        this._mouseDown = false;
        this._pointGrabbedIndex = -1;
        this.draw();
        if (this._onEvents.releasePoint && aPointWasGrabbed) this._onEvents.releasePoint(this);
    }
    /**
  * [EVENT] [PRIVATE]
  * for when we double click on the canvas
  */ _onCanvasMouseDbclick(evt) {
        //console.log("dbclick");
        this._canvas.focus();
        if (this._pointHoveredIndex == -1) {
            var index = this.add({
                x: this._mouse.x / this._width,
                y: this._mouse.y / this._height
            });
            this._pointHoveredIndex = index;
        } else {
            this.remove(this._pointHoveredIndex);
            this._pointHoveredIndex = -1;
            this._pointGrabbedIndex = -1;
        }
    }
    /**
  * [EVENT] [PRIVATE]
  * for when the mouse is leaving the canvas
  */ _onCanvasMouseLeave(evt) {
        /*
    this._mouse = null;
    //console.log( "leave" );
    this._canvas.blur();
    this._canvas.style.border = this._borderStyle.out;

    this._mouseDown = false;
    this._pointGrabbedIndex = -1;
    this._pointHoveredIndex = -1;
    
    this.draw();
    */ this.draw();
    }
    /**
  * [EVENT] [PRIVATE]
  * The mouse enters the canvas
  */ _onCanvasMouseEnter(evt) {
        //console.log("enter");
        this._canvas.focus();
        this._canvas.style.border = this._borderStyle.in;
    }
    /**
  * [EVENT] [PRIVATE]
  * A keyboard key is released
  */ _onKeyUp(evt) {
        // mouse must be inside
        if (!this._mouse) return;
        //console.log("pressed: " + evt.key);
        switch(evt.key){
            case "d":
                this.remove(this._pointHoveredIndex);
                break;
            default:
        }
    }
    /**
  * Add a point to the collection
  * @param {Object} pt - of type {x: Number, y: Number} and optionnally the boolean properties "xLocked" and "yLocked". x and y must be in [0, 1]
  */ add(pt, draw = true) {
        var index = null;
        if ("x" in pt && "y" in pt) {
            pt.x *= this._width;
            pt.y *= this._height;
            index = this._pointCollection.add(pt);
        //console.log("a point is added");
        }
        if (draw) this.draw();
        if (this._onEvents.pointAdded) this._onEvents.pointAdded(this);
        return index;
    }
    /**
  * Remove a point using its index
  * @param {Number} index - index of the point to remove (from left to right, starting at 0)
  */ remove(index) {
        var removedPoint = this._pointCollection.remove(index);
        this.draw();
        if (this._onEvents.pointRemoved) this._onEvents.pointRemoved(this);
    }
    /**
  * Draw the whole canvas
  */ draw() {
        this._ctx.clearRect(0, 0, this._width, this._height);
        this._fillBackground();
        this._drawGrid();
        this._drawData();
    }
    /**
  * [PRIVATE]
  * Paint the background with a given color
  */ _fillBackground() {
        if (!this._backgroundColor) return;
        this._ctx.beginPath();
        this._ctx.rect(0, 0, this._width, this._height);
        this._ctx.fillStyle = this._backgroundColor;
        this._ctx.fill();
    }
    /**
  * [PRIVATE]
  * Display xy coordinates on the upper left corner
  */ _drawCoordinates(x, y) {
        var textSize = 14 / this._screenRatio;
        this._ctx.fillStyle = this._textColor;
        this._ctx.font = textSize + "px courier";
        this._ctx.fillText("x: " + x, 10 / this._screenRatio, 20 / this._screenRatio);
        this._ctx.fillText("y: " + y, 10 / this._screenRatio, 35 / this._screenRatio);
    }
    /**
  * [PRIVATE]
  * Draw the background grid
  */ _drawGrid() {
        var step = this._gridStep;
        if (step == 0) return;
        // horitontal grid
        this._ctx.beginPath();
        this._ctx.moveTo(0, 0);
        for(var i = step * this._height / this._screenRatio; i < this._height / this._screenRatio; i += step * this._height / this._screenRatio){
            this._ctx.moveTo(0, Math.round(i) + 0.5 / this._screenRatio);
            this._ctx.lineTo(this._width, Math.round(i) + 0.5 / this._screenRatio);
        }
        this._ctx.moveTo(0, 0);
        for(var i = step * this._width / this._screenRatio; i < this._width / this._screenRatio; i += step * this._width / this._screenRatio){
            this._ctx.moveTo(Math.round(i) + 0.5 / this._screenRatio, 0);
            this._ctx.lineTo(Math.round(i) + 0.5 / this._screenRatio, this._height);
        }
        this._ctx.strokeStyle = this._gridColor;
        this._ctx.lineWidth = 0.5;
        this._ctx.stroke();
        this._ctx.closePath();
    }
    /**
  * [PRIVATE]
  * Draw the data on the canvas
  * @param {Boolean} curve - whether or not we draw the curve
  * @param {Boolean} control - whether or not we draw the control points
  */ _drawData(curve = true, control = true) {
        var xSeries = this._pointCollection.getXseries();
        var ySeries = this._pointCollection.getYseries();
        var w = this._width;
        var h = this._height;
        if (!xSeries.length) return;
        // drawing the curve
        if (curve) {
            //console.log("draw curve");
            this._ctx.beginPath();
            this._ctx.moveTo(xSeries[0] / this._screenRatio, (h - ySeries[0]) / this._screenRatio);
            var splineInterpolator = new this._splineConstructor(xSeries, ySeries);
            this._xSeriesInterpolated.fill(0);
            this._ySeriesInterpolated.fill(0);
            // before the first point (if not at the left of the canvas)
            for(var x = 0; x < Math.ceil(xSeries[0]); x++){
                var y = ySeries[0];
                // copying the inteprolated values in a buffer
                this._xSeriesInterpolated[x] = x / w;
                this._ySeriesInterpolated[x] = y / h;
                // adjusting y for visual purpose
                y = y < 0 ? 0.5 : y > h ? h - 0.5 : y;
                this._ctx.lineTo(x / this._screenRatio, (h - y) / this._screenRatio);
            }
            // between the first and the last point
            for(var x = Math.ceil(xSeries[0]); x < Math.ceil(xSeries[xSeries.length - 1]); x++){
                var y = splineInterpolator.interpolate(x);
                // copying the inteprolated values in a buffer
                this._xSeriesInterpolated[x] = x / w;
                this._ySeriesInterpolated[x] = y / h;
                // adjusting y for visual purpose
                y = y < 0 ? 0.5 : y > h ? h - 0.5 : y;
                this._ctx.lineTo(x / this._screenRatio, (h - y) / this._screenRatio);
            }
            // after the last point (if not at the right of the canvas)
            for(var x = Math.ceil(xSeries[xSeries.length - 1]); x < w; x++){
                var y = ySeries[ySeries.length - 1];
                // copying the inteprolated values in a buffer
                this._xSeriesInterpolated[x] = x / w;
                this._ySeriesInterpolated[x] = y / h;
                // adjusting y for visual purpose
                y = y < 0 ? 0.5 : y > h ? h - 0.5 : y;
                this._ctx.lineTo(x / this._screenRatio, (h - y) / this._screenRatio);
            }
            this._ctx.strokeStyle = this._pointGrabbedIndex == -1 ? this._curveColor.idle : this._curveColor.moving;
            this._ctx.lineWidth = this._curveThickness / this._screenRatio;
            this._ctx.stroke();
            this._ctx.closePath();
        }
        // drawing the control points
        if (control) // control points
        for(var i = 0; i < xSeries.length; i++){
            this._ctx.beginPath();
            this._ctx.arc(xSeries[i] / this._screenRatio, (h - ySeries[i]) / this._screenRatio, this._controlPointRadius / this._screenRatio, 0, 2 * Math.PI);
            // drawing a point that is neither hovered nor grabbed
            if (this._pointHoveredIndex == -1) this._ctx.fillStyle = this._controlPointColor.idle;
            else // drawing a point that is hovered or grabbed
            if (i == this._pointHoveredIndex) {
                // the point is grabbed
                if (this._mouseDown) this._ctx.fillStyle = this._controlPointColor.grabbed;
                else this._ctx.fillStyle = this._controlPointColor.hovered;
            } else this._ctx.fillStyle = this._controlPointColor.idle;
            this._ctx.fill();
            this._ctx.closePath();
        }
    }
    /**
  * Get a single interpolated value
  * @param {Number} x - normalized x (in [0, 1])
  * @return {number} the normalized interpolated value
  */ getValue(x) {
        var xSeries = this._pointCollection.getXseries();
        var ySeries = this._pointCollection.getYseries();
        // before the first x, we return the fist y
        if (x <= xSeries[0] / this._width) return ySeries[0] / this._height;
        else // after the last x, we return the last y
        if (x >= xSeries[xSeries.length - 1] / this._width) return ySeries[ySeries.length - 1] / this._height;
        else {
            var splineInterpolator = new this._splineConstructor(xSeries, ySeries);
            return splineInterpolator.interpolate(x * this._width) / this._height;
        }
    }
    /**
  * Define an event
  * @param {String} eventName - name of the event. "movePoint", "releasePoint", "pointAdded" or "pointRemoved". They are both called with this in argument
  */ on(eventName, callback) {
        this._onEvents[eventName] = callback;
    }
    /**
  * @param {Object} parentContainer - can be a String: the ID of the parent DIV, or can be directly the DOM element that will host the CanvasSpliner
  * @param {Number} width - width of the canvas where CanvasSpliner draws 
  * @param {Number} height - height of the canvas where CanvasSpliner draws
  * @param {String} splineType - "natural" or "monotonic"
  */ constructor(parentContainer, width, height, splineType = 'natural'){
        // some styling
        // borders of the canvas element
        this._borderStyle = {
            in: "1px solid #d3d3ff",
            out: "1px solid #e3e3e3"
        };
        // radius of the control points
        this._controlPointRadius = 8;
        // color of the control points
        this._controlPointColor = {
            idle: "rgba(244, 66, 167, 0.5)",
            hovered: "rgba(0, 0, 255, 0.5)",
            grabbed: "rgba(0, 200, 0, 0.5)"
        };
        // style of the curve
        this._curveColor = {
            idle: 'rgba(0, 128, 255, 1)',
            moving: 'rgba(255, 128, 0, 1)'
        };
        // color of the grid
        this._gridColor = "rgba(0, 0, 0, 0.3)";
        // color of the text
        this._textColor = "rgba(0, 0, 0, 0.1)";
        // thickness of the curve
        this._curveThickness = 1;
        // color of the background
        this._backgroundColor = false;
        this._mouse = null;
        this._pointHoveredIndex = -1; // index of the grabbed point. -1 if none
        this._pointGrabbedIndex = -1;
        this._mouseDown = false; // says if the mouse is maintained clicked
        this._canvas = null;
        this._ctx = null;
        this._screenRatio = window.devicePixelRatio;
        var parentElem = null;
        if (typeof parentContainer === 'string' || parentContainer instanceof String) parentElem = document.getElementById(parentContainer);
        else parentElem = parentContainer;
        // abort if parent div does not exist
        if (!parentElem) return;
        // creating the canvas
        this._canvas = document.createElement('canvas');
        this._canvas.width = width;
        this._canvas.height = height;
        this._canvas.setAttribute("tabIndex", 1);
        this._canvas.style.outline = "none";
        this._canvas.style.cursor = "default";
        this._canvas.style.border = this._borderStyle.out;
        this._canvas.onselectstart = function() {
            return false;
        };
        this._width = width;
        this._height = height;
        // adding the canvas to the parent div
        parentElem.appendChild(this._canvas);
        this._ctx = this._canvas.getContext("2d");
        //this._ctx.scale( 1.1, 1.1)
        this._ctx.scale(this._screenRatio, this._screenRatio);
        // init the mouse and keyboard events
        this._canvas.addEventListener('mousemove', this._onCanvasMouseMove.bind(this), false);
        this._canvas.addEventListener('mousedown', this._onCanvasMouseDown.bind(this), false);
        //this._canvas.addEventListener('mouseup', this._onCanvasMouseUp.bind(this), false);
        window.addEventListener('mouseup', this._onCanvasMouseUp.bind(this), false);
        this._canvas.addEventListener('dblclick', this._onCanvasMouseDbclick.bind(this), false);
        this._canvas.addEventListener('mouseleave', this._onCanvasMouseLeave.bind(this), false);
        this._canvas.addEventListener('mouseenter', this._onCanvasMouseEnter.bind(this), false);
        this._canvas.addEventListener('keyup', this._onKeyUp.bind(this), false);
        //this._canvas.addEventListener( 'keydown', this._onKeyDown.bind(this), false );
        // dealing with cubic spline type
        this._splineConstructor = (0, _splinesDefault.default).CubicSpline;
        if (splineType === "monotonic") this._splineConstructor = (0, _splinesDefault.default).MonotonicCubicSpline;
        // the point collection
        this._pointCollection = new (0, _pointCollectionJs.PointCollection)();
        this._pointCollection.setBoundary("max", "x", width);
        this._pointCollection.setBoundary("max", "y", height);
        // interpolated values in a buffer
        this._xSeriesInterpolated = new Float32Array(this._width).fill(0);
        this._ySeriesInterpolated = new Float32Array(this._width).fill(0);
        this._gridStep = 1 / 3;
        // events
        this._onEvents = {
            movePoint: null,
            releasePoint: null,
            pointAdded: null
        };
        this.draw();
    }
} /* END of class CanvasSpliner */ 

},{"splines":"eeCMK","./PointCollection.js":"hQGrE","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eeCMK":[function(require,module,exports,__globalThis) {
/**
 * by George MacKerron, mackerron.com
 *
 * Monotonic Cubic Spline:
 *
 *  adapted from:
 *     http://sourceforge.net/mailarchive/forum.php?thread_name=EC90C5C6-C982-4F49-8D46-A64F270C5247%40gmail.com&forum_name=matplotlib-users
 *     (easier to read at http://old.nabble.com/%22Piecewise-Cubic-Hermite-Interpolating-Polynomial%22-in-python-td25204843.html)
 *
 *  with help from:
 *      F N Fritsch & R E Carlson (1980) 'Monotone Piecewise Cubic Interpolation', SIAM Journal of Numerical Analysis 17(2), 238 - 246.
 *      http://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 *      http://en.wikipedia.org/wiki/Cubic_Hermite_spline
 *
 *
 *  Natural and Clamped:
 *
 *  adapted from:
 *      http://www.michonline.com/ryan/csc/m510/splinepresent.html
 **/ var CubicSpline, MonotonicCubicSpline;
MonotonicCubicSpline = function() {
    function MonotonicCubicSpline(x, y) {
        var alpha, beta, delta, dist, i, m, n, tau, to_fix, _i, _j, _len, _len2, _ref, _ref2, _ref3, _ref4;
        n = x.length;
        delta = [];
        m = [];
        alpha = [];
        beta = [];
        dist = [];
        tau = [];
        for(i = 0, _ref = n - 1; 0 <= _ref ? i < _ref : i > _ref; 0 <= _ref ? i += 1 : i -= 1){
            delta[i] = (y[i + 1] - y[i]) / (x[i + 1] - x[i]);
            if (i > 0) m[i] = (delta[i - 1] + delta[i]) / 2;
        }
        m[0] = delta[0];
        m[n - 1] = delta[n - 2];
        to_fix = [];
        for(i = 0, _ref2 = n - 1; 0 <= _ref2 ? i < _ref2 : i > _ref2; 0 <= _ref2 ? i += 1 : i -= 1)if (delta[i] === 0) to_fix.push(i);
        for(_i = 0, _len = to_fix.length; _i < _len; _i++){
            i = to_fix[_i];
            m[i] = m[i + 1] = 0;
        }
        for(i = 0, _ref3 = n - 1; 0 <= _ref3 ? i < _ref3 : i > _ref3; 0 <= _ref3 ? i += 1 : i -= 1){
            alpha[i] = m[i] / delta[i];
            beta[i] = m[i + 1] / delta[i];
            dist[i] = Math.pow(alpha[i], 2) + Math.pow(beta[i], 2);
            tau[i] = 3 / Math.sqrt(dist[i]);
        }
        to_fix = [];
        for(i = 0, _ref4 = n - 1; 0 <= _ref4 ? i < _ref4 : i > _ref4; 0 <= _ref4 ? i += 1 : i -= 1)if (dist[i] > 9) to_fix.push(i);
        for(_j = 0, _len2 = to_fix.length; _j < _len2; _j++){
            i = to_fix[_j];
            m[i] = tau[i] * alpha[i] * delta[i];
            m[i + 1] = tau[i] * beta[i] * delta[i];
        }
        this.x = x.slice(0, n);
        this.y = y.slice(0, n);
        this.m = m;
    }
    MonotonicCubicSpline.prototype.interpolate = function(x) {
        var h, h00, h01, h10, h11, i, t, t2, t3, y, _ref;
        for(i = _ref = this.x.length - 2; _ref <= 0 ? i <= 0 : i >= 0; _ref <= 0 ? i += 1 : i -= 1){
            if (this.x[i] <= x) break;
        }
        h = this.x[i + 1] - this.x[i];
        t = (x - this.x[i]) / h;
        t2 = Math.pow(t, 2);
        t3 = Math.pow(t, 3);
        h00 = 2 * t3 - 3 * t2 + 1;
        h10 = t3 - 2 * t2 + t;
        h01 = -2 * t3 + 3 * t2;
        h11 = t3 - t2;
        y = h00 * this.y[i] + h10 * h * this.m[i] + h01 * this.y[i + 1] + h11 * h * this.m[i + 1];
        return y;
    };
    return MonotonicCubicSpline;
}();
CubicSpline = function() {
    function CubicSpline(x, a, d0, dn) {
        var b, c, clamped, d, h, i, k, l, n, s, u, y, z, _ref;
        if (!(x != null && a != null)) return;
        clamped = d0 != null && dn != null;
        n = x.length - 1;
        h = [];
        y = [];
        l = [];
        u = [];
        z = [];
        c = [];
        b = [];
        d = [];
        k = [];
        s = [];
        for(i = 0; 0 <= n ? i < n : i > n; 0 <= n ? i += 1 : i -= 1){
            h[i] = x[i + 1] - x[i];
            k[i] = a[i + 1] - a[i];
            s[i] = k[i] / h[i];
        }
        if (clamped) {
            y[0] = 3 * (a[1] - a[0]) / h[0] - 3 * d0;
            y[n] = 3 * dn - 3 * (a[n] - a[n - 1]) / h[n - 1];
        }
        for(i = 1; 1 <= n ? i < n : i > n; 1 <= n ? i += 1 : i -= 1)y[i] = 3 / h[i] * (a[i + 1] - a[i]) - 3 / h[i - 1] * (a[i] - a[i - 1]);
        if (clamped) {
            l[0] = 2 * h[0];
            u[0] = 0.5;
            z[0] = y[0] / l[0];
        } else {
            l[0] = 1;
            u[0] = 0;
            z[0] = 0;
        }
        for(i = 1; 1 <= n ? i < n : i > n; 1 <= n ? i += 1 : i -= 1){
            l[i] = 2 * (x[i + 1] - x[i - 1]) - h[i - 1] * u[i - 1];
            u[i] = h[i] / l[i];
            z[i] = (y[i] - h[i - 1] * z[i - 1]) / l[i];
        }
        if (clamped) {
            l[n] = h[n - 1] * (2 - u[n - 1]);
            z[n] = (y[n] - h[n - 1] * z[n - 1]) / l[n];
            c[n] = z[n];
        } else {
            l[n] = 1;
            z[n] = 0;
            c[n] = 0;
        }
        for(i = _ref = n - 1; _ref <= 0 ? i <= 0 : i >= 0; _ref <= 0 ? i += 1 : i -= 1){
            c[i] = z[i] - u[i] * c[i + 1];
            b[i] = (a[i + 1] - a[i]) / h[i] - h[i] * (c[i + 1] + 2 * c[i]) / 3;
            d[i] = (c[i + 1] - c[i]) / (3 * h[i]);
        }
        this.x = x.slice(0, n + 1);
        this.a = a.slice(0, n);
        this.b = b;
        this.c = c.slice(0, n);
        this.d = d;
    }
    CubicSpline.prototype.derivative = function() {
        var c, d, s, x, _i, _j, _len, _len2, _ref, _ref2, _ref3;
        s = new this.constructor();
        s.x = this.x.slice(0, this.x.length);
        s.a = this.b.slice(0, this.b.length);
        _ref = this.c;
        for(_i = 0, _len = _ref.length; _i < _len; _i++){
            c = _ref[_i];
            s.b = 2 * c;
        }
        _ref2 = this.d;
        for(_j = 0, _len2 = _ref2.length; _j < _len2; _j++){
            d = _ref2[_j];
            s.c = 3 * d;
        }
        for(x = 0, _ref3 = this.d.length; 0 <= _ref3 ? x < _ref3 : x > _ref3; 0 <= _ref3 ? x += 1 : x -= 1)s.d = 0;
        return s;
    };
    CubicSpline.prototype.interpolate = function(x) {
        var deltaX, i, y, _ref;
        for(i = _ref = this.x.length - 1; _ref <= 0 ? i <= 0 : i >= 0; _ref <= 0 ? i += 1 : i -= 1){
            if (this.x[i] <= x) break;
        }
        deltaX = x - this.x[i];
        y = this.a[i] + this.b[i] * deltaX + this.c[i] * Math.pow(deltaX, 2) + this.d[i] * Math.pow(deltaX, 3);
        return y;
    };
    return CubicSpline;
}();
module.exports = {
    CubicSpline: CubicSpline,
    MonotonicCubicSpline: MonotonicCubicSpline
};

},{}],"hQGrE":[function(require,module,exports,__globalThis) {
/**
*
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PointCollection", ()=>PointCollection);
class PointCollection {
    /**
  * Define the acceptable min and max bot both axis.
  * @param {String} bound - can be "min" or "max"
  * @param {String} axis - can be "x" or "y"
  * @param {Number} value - a number
  * Note that minimum boudaries are inclusive while max are exclusive
  */ setBoundary(bound, axis, value) {
        this["_" + bound][axis] = value;
    }
    /**
  *
  */ add(p) {
        var newIndex = null;
        if (p.x >= this._min.x && p.x <= this._max.x && p.y >= this._min.y && p.y <= this._max.y) {
            if (!("xLocked" in p)) p.xLocked = false;
            if (!("yLocked" in p)) p.yLocked = false;
            if (!("safe" in p)) p.safe = false;
            // adding the point
            this._points.push(p);
            this._sortPoints();
            newIndex = this._points.indexOf(p);
        }
        return newIndex;
    }
    _sortPoints() {
        // sorting the array upon x
        this._points.sort(function(p1, p2) {
            return p1.x - p2.x;
        });
    }
    /**
  * Remove the points at the given index.
  * @param {Number} index - index of the point to remove
  * @return {Object} the point that was just removed or null if out of bound
  */ remove(index) {
        var removedPoint = null;
        if (index >= 0 && index < this._points.length && !this._points[index].safe) removedPoint = this._points.splice(index, 1);
        return removedPoint;
    }
    /**
  * Get the index within the collection of the point that is the closest from
  * the one given in argument. Returns also the euclidiant distance to this point.
  * @return {Object} like {index: Number, distance: Number}, or null if there is
  * no point in this collection.
  */ getClosestFrom(p) {
        if (!this._points.length) return null;
        var closestDistance = Infinity;
        var closestPointIndex = null;
        for(var i = 0; i < this._points.length; i++){
            var d = Math.sqrt(Math.pow(p.x - this._points[i].x, 2) + Math.pow(p.y - this._points[i].y, 2));
            if (d < closestDistance) {
                closestDistance = d;
                closestPointIndex = i;
            }
        }
        return {
            index: closestPointIndex,
            distance: closestDistance
        };
    }
    /**
  * Gets the point at such index
  * @param {Number} index - the index of the point we want
  * @return {Object} point that contains at least "x" and "y" properties.
  */ getPoint(index) {
        if (index >= 0 && index < this._points.length) return this._points[index];
        else return null;
    }
    /**
  * Get the number of points in the collection
  * @return {Number} the number of points
  */ getNumberOfPoints() {
        return this._points.length;
    }
    /**
  * Update the posiiton of an existing point
  * @param {Number} index - index of the existing point to update
  * @param {Object} p - point that has coord we want to use as new coord. x and y values will be copied, no pointer association
  * @return {Number} new index, the changed point may have changed its index among the x-ordered list
  */ updatePoint(index, p) {
        var newIndex = index;
        if (index >= 0 && index < this._points.length) {
            if (p.x >= this._min.x && p.x < this._max.x && p.y >= this._min.y && p.y < this._max.y) {
                if (!this._points[index].xLocked) this._points[index].x = p.x;
                if (!this._points[index].yLocked) this._points[index].y = p.y;
                var thePointInArray = this._points[index];
                this._sortPoints();
                // the point may have changed its index
                newIndex = this._points.indexOf(thePointInArray);
            }
        }
        return newIndex;
    }
    /**
  * Get all "x" coordinates of the collection as an array of Number
  * @return {Array} of Number
  */ getXseries() {
        var xSeries = [];
        for(var i = 0; i < this._points.length; i++)xSeries.push(this._points[i].x);
        return xSeries;
    }
    /**
  * Get all "y" coordinates of the collection as an array of Number
  * @return {Array} of Number
  */ getYseries() {
        var ySeries = [];
        for(var i = 0; i < this._points.length; i++)ySeries.push(this._points[i].y);
        return ySeries;
    }
    constructor(){
        this._points = [];
        this._min = {
            x: 0,
            y: 0
        };
        this._max = {
            x: Infinity,
            y: Infinity
        };
    }
} /* END of class PointCollection */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8bqoD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfigRowLabel", ()=>ConfigRowLabel);
parcelHelpers.export(exports, "ConfigRowControl", ()=>ConfigRowControl);
parcelHelpers.export(exports, "ConfigRowSeparator", ()=>ConfigRowSeparator);
parcelHelpers.export(exports, "ConfigRow", ()=>ConfigRow);
parcelHelpers.export(exports, "ConfigPanel", ()=>ConfigPanel);
parcelHelpers.export(exports, "ConfigRowInner", ()=>ConfigRowInner);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
let _ = (t)=>t, t, t1, t2, t3, t4, t5;
const ConfigRowLabel = (0, _styledDefault.default).div(t || (t = _``));
const ConfigRowControl = (0, _styledDefault.default).div(t1 || (t1 = _`
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  color: ${0};
`), ({ theme })=>theme.colors.whitePrimary);
const ConfigRowSeparator = (0, _styledDefault.default).div(t2 || (t2 = _`
  border-bottom: 1px solid ${0};
`), ({ theme })=>theme.colors.elevation1);
const ConfigRow = (0, _styledDefault.default).div(t3 || (t3 = _`
  padding: 0.2rem 0.4rem;
  font-size: 0.7rem;
  color: ${0};
  position: relative;
  display: grid;
  align-items: center;
  grid-template-rows: minmax(1.5rem, max-content);
  grid-template-columns: ${0};
  row-gap: 0.1rem;
  column-gap: 0.4rem;
`), ({ theme })=>theme.colors.highlight2, ({ oneLineLabels })=>oneLineLabels ? "1fr" : "auto 10rem");
const ConfigPanel = (0, _styledDefault.default).div(t4 || (t4 = _`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  background: ${0};
  padding: 0.4rem 0.1rem;
`), ({ theme })=>theme.colors.elevation2);
const ConfigRowInner = (0, _styledDefault.default).div(t5 || (t5 = _``));

},{"@emotion/styled":"2Zr0D","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f0GG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
// @TODO: extract it to components
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
let _ = (t)=>t, t;
const WaveWrapper = (0, _styledDefault.default).div(t || (t = _`
  width: 100%;
  height: 100%;
  background: var(--leva-colors-elevation2);
  text-align: center;
`));
const RangeEdge = ({ start, color, width, height, align })=>{
    const resizeHandleX = align === "left" ? width : start;
    return (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            (0, _jsxRuntime.jsx)("rect", {
                x: start,
                y: 0,
                width: width,
                height: height,
                style: {
                    fill: color,
                    opacity: 0.1
                }
            }),
            (0, _jsxRuntime.jsx)("line", {
                x1: resizeHandleX,
                y1: 0,
                x2: resizeHandleX,
                y2: height,
                style: {
                    strokeWidth: 8,
                    color: "transparent",
                    opacity: 0
                }
            }),
            (0, _jsxRuntime.jsx)("line", {
                x1: resizeHandleX,
                y1: 0,
                x2: resizeHandleX,
                y2: height,
                style: {
                    stroke: color,
                    strokeWidth: 1
                }
            })
        ]
    });
};
const Wave = ({ waveColor = "blue", rangeColor = "red", progressColor = "grey", port })=>{
    const [max, setMax] = (0, _react.useState)(null);
    const viewPortWidth = 1000;
    const viewPortHeight = 250;
    const maxWidth = max ? viewPortWidth / max : 0;
    const [range, setRange] = (0, _react.useState)([
        0,
        0
    ]);
    const startWidth = range[0] * maxWidth;
    const endPosition = range[1] * maxWidth;
    const endWidth = Math.max(viewPortWidth - endPosition, 0);
    const stageRef = (0, _react.useRef)(null);
    const progressRef = (0, _react.useRef)(null);
    const waveRef = (0, _react.useRef)(null);
    const handlePortEvent = (0, _react.useCallback)((event)=>{
        const data = event.data;
        const { name } = data;
        switch(name){
            case "track":
                const { data: { length: bufferLength, channelData: [audioData] } } = data;
                const points = [];
                const step = Math.ceil(bufferLength / 1000);
                const sliceWidth = 1000 / bufferLength;
                for(let i = 0; i < bufferLength; i += step){
                    const x = i * sliceWidth;
                    const y = (audioData[i] + 1) * 250 / 2;
                    points.push(`${x},${y}`);
                }
                requestAnimationFrame(()=>{
                    var _waveRef_current;
                    (_waveRef_current = waveRef.current) === null || _waveRef_current === void 0 ? void 0 : _waveRef_current.setAttribute("points", points.join(" "));
                });
                setMax(data.data.duration);
                break;
            case "time":
                requestAnimationFrame(()=>{
                    var _progressRef_current, _progressRef_current1;
                    const newValue = data.progress * 1000;
                    (_progressRef_current = progressRef.current) === null || _progressRef_current === void 0 ? void 0 : _progressRef_current.setAttribute("x1", newValue.toString());
                    (_progressRef_current1 = progressRef.current) === null || _progressRef_current1 === void 0 ? void 0 : _progressRef_current1.setAttribute("x2", newValue.toString());
                });
                break;
            case "range":
                const range = data.data;
                setRange(range);
                break;
        }
    }, [
        progressRef.current,
        waveRef.current,
        setMax
    ]);
    (0, _react.useEffect)(()=>{
        port.addEventListener("message", handlePortEvent);
        return ()=>{
            port.removeEventListener("message", handlePortEvent);
        };
    }, [
        handlePortEvent
    ]);
    return (0, _jsxRuntime.jsx)(WaveWrapper, {
        children: (0, _jsxRuntime.jsxs)("svg", {
            ref: stageRef,
            viewBox: [
                0,
                0,
                viewPortWidth,
                viewPortHeight
            ].join(" "),
            style: {
                width: "95%",
                height: "100%"
            },
            children: [
                (0, _jsxRuntime.jsx)("polyline", {
                    ref: waveRef,
                    style: {
                        stroke: waveColor,
                        strokeWidth: 1
                    },
                    points: [
                        [
                            0,
                            viewPortHeight / 2
                        ].join(","),
                        [
                            viewPortWidth,
                            viewPortHeight / 2
                        ].join(",")
                    ].join(" ")
                }),
                (0, _jsxRuntime.jsx)("line", {
                    ref: progressRef,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: viewPortHeight,
                    style: {
                        stroke: progressColor,
                        strokeWidth: 1
                    }
                }),
                max && (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        (0, _jsxRuntime.jsx)(RangeEdge, {
                            start: 0,
                            width: startWidth,
                            height: viewPortHeight,
                            color: rangeColor,
                            align: "left"
                        }),
                        (0, _jsxRuntime.jsx)(RangeEdge, {
                            start: endPosition,
                            width: endWidth,
                            height: viewPortHeight,
                            color: rangeColor,
                            align: "right"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = Wave;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dHpLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _convolver = require("./Convolver");
var _convolverDefault = parcelHelpers.interopDefault(_convolver);
const ConvolverNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _convolverDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = ConvolverNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Convolver":"6a7Bh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gjpV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "convolver",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"3pnl8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3pnl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convolver", ()=>convolver);
var _constants = require("@web-noise/core/constants");
var _loadAudioBuffer = require("../../lib/loadAudioBuffer");
var _loadAudioBufferDefault = parcelHelpers.interopDefault(_loadAudioBuffer);
var _useBroadcast = require("../../lib/useBroadcast");
const convolver = async (audioContext, data)=>{
    const { url } = (data === null || data === void 0 ? void 0 : data.values) || {};
    const convolverNode = audioContext.createConvolver();
    const channel = new MessageChannel();
    channel.port1.start();
    channel.port2.start();
    const broadcast = (0, _useBroadcast.useBroadcast)(channel.port1);
    const loadBuffer = async (url)=>{
        try {
            const buffer = await (0, _loadAudioBufferDefault.default)(url, audioContext);
            convolverNode.buffer = buffer;
            const { sampleRate, length, duration, numberOfChannels } = buffer;
            const channelData = Array.from({
                length: numberOfChannels
            }, (_, i)=>buffer.getChannelData(i));
            const event = {
                name: "track",
                data: {
                    sampleRate,
                    length,
                    duration,
                    channelData
                }
            };
            broadcast(event);
        } catch (error) {
            // @TODO: should broadcast an error event
            const event = {
                name: "track",
                data: {
                    sampleRate: audioContext.sampleRate,
                    length: 0,
                    duration: 0,
                    channelData: [
                        new Float32Array(),
                        new Float32Array()
                    ]
                }
            };
            broadcast(event);
        }
    };
    if (url) await loadBuffer(url);
    return {
        inputs: {
            input: {
                port: convolverNode,
                type: (0, _constants.PortType).Audio
            }
        },
        outputs: {
            output: {
                port: convolverNode,
                type: (0, _constants.PortType).Audio
            }
        },
        setValues: ({ url } = {})=>{
            if (typeof url !== "undefined") loadBuffer(url);
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(channel.port2, port);
        }
    };
};
exports.default = convolver;

},{"@web-noise/core/constants":"36kMU","../../lib/loadAudioBuffer":"lrRrU","../../lib/useBroadcast":"ekNC4","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lrRrU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetch = require("@web-noise/fetch");
var _fetchDefault = parcelHelpers.interopDefault(_fetch);
exports.default = async (url, audioContext)=>{
    const response = await (0, _fetchDefault.default)(url);
    const arrayBuffer = await response.arrayBuffer();
    return audioContext.decodeAudioData(arrayBuffer);
};

},{"@web-noise/fetch":"aRn3r","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ekNC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Events", ()=>Events);
parcelHelpers.export(exports, "useBroadcast", ()=>useBroadcast);
parcelHelpers.export(exports, "addBroadcastListener", ()=>addBroadcastListener);
parcelHelpers.export(exports, "removeBroadcastListener", ()=>removeBroadcastListener);
var Events;
(function(Events) {
    Events["ADD_LISTENER"] = "ADD_LISTENER";
    Events["REMOVE_LISTENER"] = "REMOVE_LISTENER";
})(Events || (Events = {}));
const DEFAULT_POOL_NAME = "default";
const useBroadcast = (port)=>{
    const listeners = {
        [DEFAULT_POOL_NAME]: []
    };
    port.addEventListener("message", ({ data })=>{
        if (data.name === "ADD_LISTENER") {
            var _data_poolName;
            const poolName = (_data_poolName = data.poolName) !== null && _data_poolName !== void 0 ? _data_poolName : DEFAULT_POOL_NAME;
            if (!listeners[poolName]) listeners[poolName] = [];
            listeners[poolName].push(data.port);
        }
        if (data.name === "REMOVE_LISTENER") {
            var _data_poolName1;
            const poolName = (_data_poolName1 = data.poolName) !== null && _data_poolName1 !== void 0 ? _data_poolName1 : DEFAULT_POOL_NAME;
            if (!listeners[poolName]) listeners[poolName] = [];
            listeners[poolName].push(data.port);
        }
    });
    return (data, index = DEFAULT_POOL_NAME)=>{
        var _listeners_index;
        return (_listeners_index = listeners[index]) === null || _listeners_index === void 0 ? void 0 : _listeners_index.forEach((listener)=>listener.postMessage(data));
    };
};
const addBroadcastListener = (broadcastPort, listenerPort, poolName)=>{
    broadcastPort.postMessage({
        name: "ADD_LISTENER",
        port: listenerPort,
        poolName
    }, [
        listenerPort
    ]);
};
const removeBroadcastListener = (broadcastPort, listenerPort, poolName)=>{
    broadcastPort.postMessage({
        name: "REMOVE_LISTENER",
        // port: listenerPort,
        poolName
    }, []);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5CV3S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Delay (Time Shifter)",
    description: `
  A time-based effect that delays the audio signal by a specified amount of time.

  Essential for creating echo effects, comb filtering, and when combined with feedback,
  can produce reverb-like effects and complex modulations.
  `,
    info: `
  # Delay

  Creates a delayed copy of the incoming audio signal.

  Use it to create echoes, reverb effects, or time-based modulation when combined with feedback.
  `,
    tags: [
        "delay",
        "effect"
    ],
    portsDescription: {
        inputs: {
            input: "Audio input to be delayed",
            time: "Delay time in seconds"
        },
        outputs: {
            output: "Delayed audio output"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"gC27W","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gC27W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "delay",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"jArGg","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jArGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _constants = require("@web-noise/core/constants");
const delay = async (audioContext)=>{
    const delay = audioContext.createDelay();
    return {
        inputs: {
            time: {
                port: delay.delayTime,
                type: (0, _constants.PortType).Number,
                range: [
                    delay.delayTime.minValue,
                    delay.delayTime.maxValue
                ],
                defaultValue: delay.delayTime.value
            },
            input: {
                port: delay,
                type: (0, _constants.PortType).Any
            }
        },
        outputs: {
            output: {
                port: delay,
                type: (0, _constants.PortType).Any
            }
        }
    };
};
exports.default = delay;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2vRBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Dynamics Compressor",
    description: `
  An audio processor that reduces the volume of loud sounds and amplifies quiet sounds.

  Essential for creating professional-sounding mixes, preventing distortion,
  and making audio more consistent in volume.
  `,
    info: `
  # Dynamics Compressor

  Controls the dynamic range of audio signals by reducing the volume of loud parts
  and increasing the volume of quiet parts.

  Use it to control dynamic range, prevent clipping, and create a more balanced mix.

  ## Parameters
  - Threshold: Level at which compression begins (dB, typically -24 to 0)
  - Knee: How gradually compression is applied at the threshold (dB, typically 0 to 40)
  - Ratio: Amount of compression applied (ratio, typically 1 to 20)
  - Attack: How quickly compression is applied (seconds, typically 0 to 1)
  - Release: How quickly compression is released (seconds, typically 0 to 1)
  `,
    tags: [
        "compressor",
        "dynamics",
        "level",
        "mixing",
        "mastering"
    ],
    portsDescription: {
        inputs: {
            input: "Audio input to be compressed",
            threshold: "Level at which compression begins (dB)",
            knee: "Smoothness of the compression curve at the threshold (dB)",
            ratio: "Amount of compression applied (ratio)",
            attack: "Time to apply compression (seconds)",
            release: "Time to release compression (seconds)"
        },
        outputs: {
            output: "Compressed audio output"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"9zmwZ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9zmwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "dynamicsCompressor",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"bBZDY","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bBZDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dynamicsCompressor", ()=>dynamicsCompressor);
var _constants = require("@web-noise/core/constants");
const dynamicsCompressor = async (audioContext)=>{
    const compressor = audioContext.createDynamicsCompressor();
    return {
        inputs: {
            input: {
                port: compressor,
                type: (0, _constants.PortType).Audio
            },
            threshold: {
                port: compressor.threshold,
                type: (0, _constants.PortType).Number,
                range: [
                    compressor.threshold.minValue,
                    compressor.threshold.maxValue
                ],
                defaultValue: compressor.threshold.value
            },
            knee: {
                port: compressor.knee,
                type: (0, _constants.PortType).Number,
                range: [
                    compressor.knee.minValue,
                    compressor.knee.maxValue
                ],
                defaultValue: compressor.knee.value
            },
            ratio: {
                port: compressor.ratio,
                type: (0, _constants.PortType).Number,
                range: [
                    compressor.ratio.minValue,
                    compressor.ratio.maxValue
                ],
                defaultValue: compressor.ratio.value
            },
            attack: {
                port: compressor.attack,
                type: (0, _constants.PortType).Number,
                range: [
                    compressor.attack.minValue,
                    compressor.attack.maxValue
                ],
                defaultValue: compressor.attack.value
            },
            release: {
                port: compressor.release,
                type: (0, _constants.PortType).Number,
                range: [
                    compressor.release.minValue,
                    compressor.release.maxValue
                ],
                defaultValue: compressor.release.value
            }
        },
        outputs: {
            output: {
                port: compressor,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = dynamicsCompressor;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jx65b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _filter = require("./Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _filterDefault.default),
    node: (0, _nodeDefault.default),
    name: "Filter",
    description: `
  A versatile audio filter that shapes frequency content by attenuating or emphasizing 
  specific frequency ranges. 
  
  Perfect for removing unwanted frequencies, creating EQ effects, and sound design applications.
  `,
    info: `
  # Filter (Audio Frequency Processor)
  
  Shapes the frequency content of audio signals by attenuating or emphasizing specific frequency ranges.

  Use it to create effects like low-pass, high-pass, band-pass, 
  and more for sound design and audio processing.
  
  ## Values
  - lowpass: Allows frequencies below cutoff point
  - highpass: Allows frequencies above cutoff point
  - bandpass: Allows frequencies within a range
  - notch: Removes frequencies within a range
  - allpass: Alters phase without changing amplitude
  - lowshelf: Boosts/cuts frequencies below cutoff
  - highshelf: Boosts/cuts frequencies above cutoff
  - peaking: Boosts/cuts frequencies around center point
  `,
    tags: [
        "filter",
        "eq",
        "frequency",
        "audio processor",
        "effects",
        "biquad"
    ],
    portsDescription: {
        inputs: {
            in: "Audio signal to be filtered",
            frequency: "Cutoff or center frequency of the filter (in Hz)",
            detune: "Fine-tune adjustment of the frequency in cents",
            Q: "Q factor controlling the width/resonance of the filter",
            gain: "Gain amount for peaking and shelving filter types"
        },
        outputs: {
            out: "Filtered audio output"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Filter":"f4LwJ","./Node":"ddE2c","./base":"jGi39","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f4LwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t;
const FilterWrapper = (0, _styledDefault.default).div(t || (t = _`
  padding: 0.4rem 0.5rem;
  background-color: ${0};
`), ({ theme })=>theme.colors.elevation2);
const FILTER_OPTIONS = [
    {
        value: "lowpass",
        label: "lowpass"
    },
    {
        value: "allpass",
        label: "allpass"
    },
    {
        value: "bandpass",
        label: "bandpass"
    },
    {
        value: "highpass",
        label: "highpass"
    },
    {
        value: "highshelf",
        label: "highshelf"
    },
    {
        value: "lowshelf",
        label: "lowshelf"
    },
    {
        value: "notch",
        label: "notch"
    },
    {
        value: "peaking",
        label: "peaking"
    }
];
const DEFAULT_FILTER_TYPE = "lowpass";
const Filter = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const { type = DEFAULT_FILTER_TYPE } = data.values || {};
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data.values
    ]);
    return (0, _jsxRuntime.jsx)(FilterWrapper, {
        theme: theme,
        children: (0, _jsxRuntime.jsx)((0, _components.Select), {
            options: FILTER_OPTIONS,
            value: type,
            placeholder: "Filter Type",
            onChange: (value)=>updateNodeValues({
                    type: value
                })
        })
    });
};
exports.default = Filter;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ddE2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _filter = require("./Filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
const FilterNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _filterDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = FilterNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Filter":"f4LwJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jGi39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "filter",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"d64jF","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"d64jF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _constants = require("@web-noise/core/constants");
const filter = async (audioContext, data)=>{
    const filter = audioContext.createBiquadFilter();
    const { type } = (data === null || data === void 0 ? void 0 : data.values) || {};
    if (type) filter.type = type;
    return {
        inputs: {
            in: {
                port: filter,
                type: (0, _constants.PortType).Audio
            },
            frequency: {
                port: filter.frequency,
                type: (0, _constants.PortType).Number,
                range: [
                    filter.frequency.minValue,
                    filter.frequency.maxValue
                ],
                defaultValue: filter.frequency.value
            },
            detune: {
                port: filter.detune,
                type: (0, _constants.PortType).Number,
                range: [
                    filter.detune.minValue,
                    filter.detune.maxValue
                ],
                defaultValue: filter.detune.value
            },
            Q: {
                port: filter.Q,
                type: (0, _constants.PortType).Number,
                range: [
                    filter.Q.minValue,
                    filter.Q.maxValue
                ],
                defaultValue: filter.Q.value
            },
            gain: {
                port: filter.gain,
                type: (0, _constants.PortType).Number,
                range: [
                    filter.gain.minValue,
                    filter.gain.maxValue
                ],
                defaultValue: filter.gain.value
            }
        },
        outputs: {
            out: {
                port: filter,
                type: (0, _constants.PortType).Audio
            }
        },
        setValues: ({ type } = {})=>{
            type && (filter.type = type);
        },
        filter
    };
};
exports.default = filter;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2pwlA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _oscillator = require("./Oscillator");
var _oscillatorDefault = parcelHelpers.interopDefault(_oscillator);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _oscillatorDefault.default),
    node: (0, _nodeDefault.default),
    name: "Oscillator (Waveform Generator)",
    description: `
  A sound generator that creates various waveforms (sine, square,
  sawtooth, triangle) at different frequencies. Use it as a basic
  building block for synthesizers, sound effects, and audio experiments
  `,
    info: `
  # Oscillator 

  Creates pure tones with adjustable waveform and frequency.

  Perfect for creating basic synth sounds, bass lines, and sound
  effects.

  ## Values
  - \`Sine\`: Smooth, pure tone
  - \`Square\`: Sharp, buzzy sound
  - \`Sawtooth\`: Bright, harsh tone
  - \`Triangle\`: Soft, hollow sound
  `,
    tags: [
        "oscillator",
        "sine",
        "generator",
        "audio source"
    ],
    portsDescription: {
        inputs: {
            frequency: "Frequency (pitch) of the oscillator in Hertz (Hz)",
            detune: "Fine-tune of the frequency in cents (1/100th of a semitone)"
        },
        outputs: {
            out: "Audio output of the oscillator"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Oscillator":"4zd5F","./Node":"aBMU3","./base":"4wBJG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4zd5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _icons = require("./icons");
let _ = (t)=>t, t, t1, t2;
const OscillatorWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0.2rem 0.4rem;
  box-sizing: border-box;
  overflow: hidden;
`));
const IconsWrapper = (0, _styledDefault.default).div(t1 || (t1 = _`
  flex: 1;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  align-items: center;
`));
const Icon = (0, _styledDefault.default).div(t2 || (t2 = _`
  cursor: pointer;
  height: 50%;
  text-align: center;
  color: ${0};
  svg {
    height: 100%;
    fill: currentColor;
  }
  &:hover {
    color: ${0};
  }
`), ({ selected, theme })=>selected ? theme.colors.accent2 : theme.colors.highlight1, ({ theme })=>theme.colors.accent3);
const oscillatorTypes = [
    {
        icon: (0, _jsxRuntime.jsx)((0, _icons.SineIcon), {}),
        value: "sine"
    },
    {
        icon: (0, _jsxRuntime.jsx)((0, _icons.SawToothIcon), {}),
        value: "sawtooth"
    },
    {
        icon: (0, _jsxRuntime.jsx)((0, _icons.TriangleIcon), {}),
        value: "triangle"
    },
    {
        icon: (0, _jsxRuntime.jsx)((0, _icons.SquareIcon), {}),
        value: "square"
    }
];
const Oscillator = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data.values
    ]);
    const values = data.values || {};
    const { type = "sine" } = values;
    return (0, _jsxRuntime.jsx)(OscillatorWrapper, {
        theme: theme,
        children: (0, _jsxRuntime.jsx)(IconsWrapper, {
            theme: theme,
            children: oscillatorTypes.map(({ icon, value: optionValue }, index)=>(0, _jsxRuntime.jsx)(Icon, {
                    onClick: ()=>updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                            type: optionValue
                        })),
                    theme: theme,
                    selected: optionValue === type,
                    children: icon
                }, index))
        })
    });
};
exports.default = Oscillator;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","./icons":"b0ucz","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"b0ucz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SineIcon", ()=>SineIcon);
parcelHelpers.export(exports, "SawToothIcon", ()=>SawToothIcon);
parcelHelpers.export(exports, "TriangleIcon", ()=>TriangleIcon);
parcelHelpers.export(exports, "SquareIcon", ()=>SquareIcon);
var _jsxRuntime = require("react/jsx-runtime");
const SineIcon = ()=>(0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M22 28c-4 0-5.586-5.652-7.266-11.625C13.52 12.055 12 6.668 10 6.668c-4.52 0-4.668 9.238-4.668 9.332H2.668c0-.492.078-12 7.332-12 4 0 5.613 5.668 7.293 11.652 1.148 4.082 2.707 9.68 4.707 9.68 4.586 0 4.707-9.238 4.707-9.332h2.668c0 .492-.082 12-7.375 12zm0 0"
        })
    });
const SawToothIcon = ()=>(0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M14.668 29.332V9.105l-12 12.227v-3.773L17.332 2.668v20.227l12-12.227v3.773zm0 0"
        })
    });
const TriangleIcon = ()=>(0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        children: (0, _jsxRuntime.jsx)("path", {
            d: "m29.332 16-6.664 13.332L9.465 8.055 5.652 16H2.668L9.332 2.668l13.203 21.277L26.348 16zm0 0"
        })
    });
const SquareIcon = ()=>(0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        children: (0, _jsxRuntime.jsx)("path", {
            d: "M2.668 2.668V16h2.664V5.332h9.336v24h14.664V16h-2.664v10.668h-9.336v-24zm0 0"
        })
    });

},{"react/jsx-runtime":"g1NAx","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aBMU3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _oscillator = require("./Oscillator");
var _oscillatorDefault = parcelHelpers.interopDefault(_oscillator);
let _ = (t)=>t, t;
const OscillatorWrapper = (0, _styledDefault.default).div(t || (t = _`
  background: ${0};
`), ({ theme })=>theme.colors.elevation2);
const OscillatorNode = (props)=>{
    const { id, data } = props;
    const theme = (0, _core.useTheme)();
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)(OscillatorWrapper, {
            theme: theme,
            children: (0, _jsxRuntime.jsx)((0, _oscillatorDefault.default), {
                node: props,
                audioNode: node,
                updateNodeValues: updateNodeValues
            })
        })
    }));
};
exports.default = OscillatorNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","./Oscillator":"4zd5F","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4wBJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "oscillator",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"eJpCv","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eJpCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "oscillator", ()=>oscillator);
var _constants = require("@web-noise/core/constants");
const oscillator = async (audioContext, data)=>{
    const oscillator = audioContext.createOscillator();
    oscillator.frequency.value = 0;
    oscillator.start();
    return {
        inputs: {
            frequency: {
                port: oscillator.frequency,
                type: (0, _constants.PortType).Number,
                range: [
                    oscillator.frequency.minValue,
                    oscillator.frequency.maxValue
                ],
                defaultValue: oscillator.frequency.value
            },
            detune: {
                port: oscillator.detune,
                type: (0, _constants.PortType).Number,
                range: [
                    oscillator.detune.minValue,
                    oscillator.detune.maxValue
                ],
                defaultValue: oscillator.detune.value
            }
        },
        outputs: {
            out: {
                port: oscillator,
                type: (0, _constants.PortType).Any
            }
        },
        destroy: ()=>{
            oscillator.stop();
        },
        setValues: ({ type } = {})=>{
            type && (oscillator.type = type);
        },
        oscillator
    };
};
exports.default = oscillator;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"i9ehl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _parameter = require("./Parameter");
var _parameterDefault = parcelHelpers.interopDefault(_parameter);
var _parameterNode = require("./ParameterNode");
var _parameterNodeDefault = parcelHelpers.interopDefault(_parameterNode);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _parameterDefault.default),
    node: (0, _parameterNodeDefault.default),
    configNode: (0, _configDefault.default),
    name: "Parameter (Constant Value)",
    description: `
  A node that outputs a constant numerical value that can be adjusted manually.

  Essential for controlling various aspects of your audio graph, such as
  oscillator frequency, filter cutoff, gain levels, and more.
  `,
    info: `
  # Parameter

  Provides a constant value output that can be connected to audio parameters.
  Use it to control numeric audio parameters of other nodes like frequency, gain, etc.

  ## Values
  - Can be set to any numerical value
  - Configurable min/max range and step size
  - Can be modulated by connecting to the offset input
  `,
    tags: [
        "parameter",
        "constant",
        "control",
        "value"
    ],
    portsDescription: {
        inputs: {
            offset: "Modulation input for the constant value"
        },
        outputs: {
            out: "Constant value output that can be connected to audio parameters"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Parameter":"gkfaB","./ParameterNode":"88hf9","./base":"iVh6P","./Config":"jh7RD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gkfaB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react = require("react");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t;
const InputWrapper = (0, _styledDefault.default).div(t || (t = _`
  background: ${0};
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  color: ${0};
  min-height: 1.5rem;
  display: grid;
  grid-template-areas:
    ".    "
    "input"
    ".    ";
  grid-template-columns: 95%;
  grid-template-rows: auto 70% auto;
  width: 100%;
  justify-content: center;
  span {
    grid-area: input;
    display: flex;
    align-items: center;
    position: relative;
    color: inherit;
    ::after {
      display: none;
    }
  }
  input {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    margin: 0;
    border: 0;
    outline: none;
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
    font-family: inherit;
    padding: 0 0.4rem;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin-right: 0;
    }
  }
`), ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.whitePrimary);
const Parameter = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const { value = 0 } = data.values || {};
    const { min = -Infinity, max = Infinity, step = 1 } = data.config || {};
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data
    ]);
    return (0, _jsxRuntime.jsx)(InputWrapper, {
        theme: theme,
        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
            min: min,
            max: max,
            step: step,
            value: value,
            onChange: (value)=>{
                updateNodeValues === null || updateNodeValues === void 0 ? void 0 : updateNodeValues({
                    value
                });
            }
        })
    });
};
exports.default = Parameter;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"88hf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _parameter = require("./Parameter");
var _parameterDefault = parcelHelpers.interopDefault(_parameter);
const ParameterNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _parameterDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = ParameterNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Parameter":"gkfaB","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iVh6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constantSource = require("./constantSource");
const plugin = {
    type: "parameter",
    node: null,
    audioNode: (0, _constantSource.constantSource)
};
exports.default = plugin;

},{"./constantSource":"iZoBt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iZoBt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantSource", ()=>constantSource);
var _constants = require("@web-noise/core/constants");
const constantSource = (audioContext)=>{
    const constantSource = audioContext.createConstantSource();
    constantSource.offset.value = 0;
    constantSource.start();
    return {
        inputs: {
            offset: {
                port: constantSource.offset,
                type: (0, _constants.PortType).Number,
                range: [
                    constantSource.offset.minValue,
                    constantSource.offset.maxValue
                ],
                defaultValue: constantSource.offset.value
            }
        },
        outputs: {
            out: {
                port: constantSource,
                type: (0, _constants.PortType).Number
            }
        },
        constantSource,
        destroy: ()=>{
            constantSource.stop();
        },
        setValues: ({ value } = {})=>{
            typeof value !== "undefined" && constantSource.offset.setValueAtTime(value, audioContext.currentTime);
        }
    };
};
exports.default = constantSource;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jh7RD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t, t1, t2, t3;
const ConfigRowLabel = (0, _styledDefault.default).div(t || (t = _``));
const ConfigRowInput = (0, _styledDefault.default).div(t1 || (t1 = _`
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  color: ${0};
`), ({ theme })=>theme.colors.whitePrimary);
const ConfigRow = (0, _styledDefault.default).div(t2 || (t2 = _`
  position: relative;
  z-index: 100;
  display: grid;
  row-gap: var(--leva-space-rowGap);
  grid-template-rows: minmax(var(--leva-sizes-rowHeight), max-content);
  align-items: center;
  color: var(--leva-colors-highlight2);
  grid-template-columns: auto var(--leva-sizes-controlWidth);
  column-gap: var(--leva-space-colGap);
`));
const ConfigRowInner = (0, _styledDefault.default).div(t3 || (t3 = _`
  padding: 0.2rem 0.4rem;
  background: ${0};
  font-size: 0.7rem;
  span::after {
    display: none;
  }
  input {
    box-sizing: border-box;
    height: 100%;
    color: inherit;
    padding: 0.2rem 0.4rem;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin-right: 0;
    }
  }
`), ({ theme })=>theme.colors.elevation2);
const ParameterConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {
        min: -Infinity,
        max: Infinity,
        step: 1
    } } = data;
    const { min, max, step } = config;
    return (0, _jsxRuntime.jsxs)(ConfigRowInner, {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)(ConfigRow, {
                children: [
                    (0, _jsxRuntime.jsx)(ConfigRowLabel, {
                        children: "min"
                    }),
                    (0, _jsxRuntime.jsx)(ConfigRowInput, {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: min,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    min: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)(ConfigRow, {
                children: [
                    (0, _jsxRuntime.jsx)(ConfigRowLabel, {
                        children: "max"
                    }),
                    (0, _jsxRuntime.jsx)(ConfigRowInput, {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: max,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    max: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)(ConfigRow, {
                children: [
                    (0, _jsxRuntime.jsx)(ConfigRowLabel, {
                        children: "step"
                    }),
                    (0, _jsxRuntime.jsx)(ConfigRowInput, {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: step,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    step: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = ParameterConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"is85Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Stereo Panner (Spatial Positioning)",
    description: `
  A spatial audio processor that positions sounds in the stereo field from left to right.
  
  Perfect for creating spatial effects, stereo imaging, and adding movement to sounds.
  `,
    info: `
  # StereoPanner
  
  Positions audio signals in the stereo field between left and right channels.
  
  Use it to create immersive stereo mixes, add movement to sounds, or separate elements

  in your audio projects.
  ## Values
  - -1.0: Full left positioning
  - 0.0: Center positioning (equal in both channels)
  - 1.0: Full right positioning
  
  The panner uses equal-power panning to maintain consistent perceived volume across the stereo field.
  `,
    tags: [
        "panner",
        "stereo",
        "spatial",
        "positioning",
        "balance"
    ],
    portsDescription: {
        inputs: {
            input: "Audio signal to be positioned in the stereo field",
            pan: "Pan position value between -1 (full left) and 1 (full right)"
        },
        outputs: {
            output: "Panned audio output"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"ffgWc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ffgWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "stereoPanner",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"aib97","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aib97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereoPanner", ()=>stereoPanner);
var _constants = require("@web-noise/core/constants");
const stereoPanner = async (audioContext)=>{
    const panner = audioContext.createStereoPanner();
    return {
        inputs: {
            input: {
                port: panner,
                type: (0, _constants.PortType).Audio
            },
            pan: {
                port: panner.pan,
                type: (0, _constants.PortType).Number,
                range: [
                    panner.pan.minValue,
                    panner.pan.maxValue
                ],
                defaultValue: panner.pan.value
            }
        },
        outputs: {
            output: {
                port: panner,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = stereoPanner;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"18lxk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _waveShaper = require("./WaveShaper");
var _waveShaperDefault = parcelHelpers.interopDefault(_waveShaper);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _waveShaperDefault.default),
    configNode: (0, _configDefault.default),
    resizable: true,
    defaultConfig: {
        size: {
            width: 300,
            height: 340
        },
        curveColor: (0, _core.theme).colors.accent2,
        gridColor: (0, _core.theme).colors.elevation2,
        controlPointColor: (0, _core.theme).colors.vivid1,
        textColor: "#cf1616"
    },
    name: "Wave Shaper (Distortion Designer)",
    description: `
  A non-linear audio processor that transforms signals using a customizable curve.
  
  Perfect for creating distortion effects, harmonic enhancement, and creative sound design.
  `,
    info: `
  # WaveShaper
  
  Transforms audio signals by mapping input values to output values using a custom curve.

  Use it to create distortion effects, waveshaping, and other creative sound transformations
  by designing your own transfer function.
  
  ## Values
  - Control Points: Define the shape of the transfer function
  - Spline Type: Choose between monotonic (preserves direction) or natural cubic splines
  - Oversample: Reduce aliasing artifacts with 2x or 4x oversampling
  
  The visual editor allows you to create and manipulate the waveshaping curve by adding, 
  moving, and removing control points. The resulting curve maps input audio values 
  (-1 to 1) to output values.

  ## Curve Editor Usage
  - Double click on a point to remove it
  - Double click anywhere else to add a new point
  - Grab a point to move it
  `,
    tags: [
        "distortion",
        "waveshaper",
        "curve"
    ],
    portsDescription: {
        inputs: {
            input: "Audio signal to be processed by the waveshaping curve"
        },
        outputs: {
            output: "Processed audio output with applied waveshaping"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./WaveShaper":"eloy4","./Node":"57uQQ","./base":"aRh7N","./Config":"5RJSm","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eloy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
// @ts-nocheck
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
//@ts-ignore
var _canvasSpliner = require("CanvasSpliner");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t, t1, t2;
class Spliner extends (0, _canvasSpliner.CanvasSpliner) {
    _updateMousePosition(evt) {
        var _this__canvas;
        const rect = (_this__canvas = this._canvas) === null || _this__canvas === void 0 ? void 0 : _this__canvas.getBoundingClientRect();
        const scaleX = this._canvas.width / rect.width;
        const scaleY = this._canvas.height / rect.height;
        this._mouse = {
            x: (evt.clientX - rect.left) * scaleX,
            y: this._height - (evt.clientY - rect.top) * scaleY
        };
    }
    getPoints() {
        const xFactor = 1 / this._width;
        const yFactor = 1 / this._height;
        return this._pointCollection._points.map(({ x, y })=>({
                x: x * xFactor,
                y: y * yFactor
            }));
    }
    removeAll() {
        const length = this._pointCollection.getNumberOfPoints();
        for(let i = length; i > 0; i--)this._pointCollection.remove(i - 1);
    }
    update(points) {
        this.removeAll();
        const xFactor = this._width;
        const yFactor = this._height;
        points.forEach(({ x, y })=>{
            this._pointCollection.add({
                x: x * xFactor,
                y: y * yFactor
            });
        });
        this.draw();
    }
}
const WaveShaperWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 0.5rem;
  gap: 0.5rem;
  box-sizing: border-box;
`));
const WaveShaperValuesBar = (0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  width: 100%;
  gap: 1rem;
`));
const ValueSelectLabel = (0, _styledDefault.default).label(t2 || (t2 = _`
  display: flex;
  font-size: 0.5rem;
  align-items: center;
  color: ${0};
`), ({ theme })=>theme.colors.highlight2);
const WaveShaper = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const values = data.values || {};
    const { points = [
        {
            x: 0.25,
            y: 0.25
        },
        {
            x: 0.75,
            y: 0.75
        }
    ], splineType = "monotonic", oversample = "none" } = values;
    const config = data.config || {};
    const { gridColor, textColor, curveColor, controlPointColor } = config;
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data
    ]);
    return (0, _jsxRuntime.jsxs)(WaveShaperWrapper, {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)(WaveShaperValuesBar, {
                children: [
                    (0, _jsxRuntime.jsxs)(ValueSelectLabel, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)("span", {
                                children: "type:"
                            }),
                            (0, _jsxRuntime.jsx)((0, _components.Select), {
                                value: splineType,
                                options: [
                                    {
                                        label: "monotonic",
                                        value: "monotonic"
                                    },
                                    {
                                        label: "natural",
                                        value: "natural"
                                    }
                                ],
                                onChange: (splineType)=>updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                        splineType
                                    }))
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)(ValueSelectLabel, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)("span", {
                                children: "oversample:"
                            }),
                            (0, _jsxRuntime.jsx)((0, _components.Select), {
                                value: oversample,
                                options: [
                                    {
                                        label: "none",
                                        value: "none"
                                    },
                                    {
                                        label: "2x",
                                        value: "2x"
                                    },
                                    {
                                        label: "4x",
                                        value: "4x"
                                    }
                                ],
                                onChange: (newOversample)=>updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                        oversample: newOversample
                                    }))
                            })
                        ]
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.SplineEditor), {
                points: points,
                type: splineType,
                gridColor: gridColor,
                textColor: textColor,
                controlPointColor: controlPointColor,
                curveColor: curveColor,
                onChange: (points)=>updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, data.values), {
                        points
                    })),
                onMove: (points)=>{
                    var _audioNode_setValues;
                    audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, {
                        points,
                        splineType
                    });
                }
            })
        ]
    });
};
exports.default = WaveShaper;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","CanvasSpliner":"6Z0pB","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"57uQQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _waveShaper = require("./WaveShaper");
var _waveShaperDefault = parcelHelpers.interopDefault(_waveShaper);
const WaveShaperNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _waveShaperDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = WaveShaperNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./WaveShaper":"eloy4","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aRh7N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "waveShaper",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"aj8gi","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aj8gi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "waveShaper", ()=>waveShaper);
var _constants = require("@web-noise/core/constants");
var _generateWave = require("../../lib/generateWave");
const waveShaper = async (audioContext, data)=>{
    var _data_values;
    const waveShaper = audioContext.createWaveShaper();
    const updateCurve = (points, splineType)=>{
        const audioData = (0, _generateWave.generateWave)(points, splineType);
        // @ts-ignore
        waveShaper.curve = audioData;
    };
    if (data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.points) updateCurve(data.values.points);
    return {
        inputs: {
            input: {
                port: waveShaper,
                type: (0, _constants.PortType).Audio
            }
        },
        outputs: {
            output: {
                port: waveShaper,
                type: (0, _constants.PortType).Audio
            }
        },
        setValues: ({ points, splineType, oversample } = {})=>{
            updateCurve(points, splineType);
            if (typeof oversample !== "undefined") waveShaper.oversample = oversample;
        }
    };
};
exports.default = waveShaper;

},{"@web-noise/core/constants":"36kMU","../../lib/generateWave":"7Ih7i","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7Ih7i":[function(require,module,exports,__globalThis) {
//@ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateWave", ()=>generateWave);
var _splines = require("splines");
const generateWave = (points = [], type = "monotonic", samples = Math.pow(2, 16))=>{
    if (!points.length) return null;
    const [xSeries, ySeries] = points.reduce(([xAcc, yAcc], { x, y })=>[
            [
                ...xAcc,
                x * samples
            ],
            [
                ...yAcc,
                y
            ]
        ], [
        [],
        []
    ]);
    const ySeriesInterpolated = new Float32Array(samples).fill(0);
    const SplineInterpolator = type === "monotonic" ? (0, _splines.MonotonicCubicSpline) : (0, _splines.CubicSpline);
    const splineInterpolator = new SplineInterpolator(xSeries, ySeries);
    // before the first point (if not at the left of the canvas)
    for(let x = 0; x < Math.ceil(xSeries[0]); x++){
        const y = ySeries[0];
        // copying the inteprolated values in a buffer
        ySeriesInterpolated[x] = y;
    }
    // between the first and the last point
    for(let x = Math.ceil(xSeries[0]); x < Math.ceil(xSeries[xSeries.length - 1]); x++){
        const y = splineInterpolator.interpolate(x);
        // copying the inteprolated values in a buffer
        ySeriesInterpolated[x] = y;
    }
    // after the last point (if not at the right of the canvas)
    for(var x = Math.ceil(xSeries[xSeries.length - 1]); x < samples; x++){
        const y = ySeries[ySeries.length - 1];
        // copying the inteprolated values in a buffer
        ySeriesInterpolated[x] = y;
    }
    const audioData = new Float32Array(ySeriesInterpolated.map((value)=>{
        const newValue = value * 2 - 1;
        if (newValue > 1) return 1;
        if (newValue < -1) return -1;
        return newValue;
    }));
    return audioData;
};

},{"splines":"eeCMK","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5RJSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const WaveShaperConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeValues, updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { gridColor, textColor, controlPointColor, curveColor } = config;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Curve Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: curveColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    curveColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Point Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: controlPointColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    controlPointColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Grid Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: gridColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    gridColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Text Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: textColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    textColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            })
        ]
    });
};
exports.default = WaveShaperConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6VLMX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Gain (Volume Control)",
    description: `
  A volume control node that amplifies or attenuates audio signals passing through it.
  Essential for mixing, creating volume envelopes, and balancing levels between
  different audio sources.
  `,
    info: `
  # Gain

  Controls the volume (amplitude) of audio signals.

  It causes a given gain to be applied to the input data before its propagation to the output
  `,
    tags: [
        "gain",
        "volume",
        "amplitude"
    ],
    portsDescription: {
        inputs: {
            in: "Audio input to be processed",
            gain: `
      Control parameter for the gain (volume) level

      ## Values
      - 0: Silence (no sound)
      - 1: Unity gain (original volume)
      - <1: Attenuation (quieter)
      - >1: Amplification (louder)
      `
        },
        outputs: {
            out: "Audio output with applied gain"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"lgLfC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lgLfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "gain",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"18bN9","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"18bN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gain", ()=>gain);
var _constants = require("@web-noise/core/constants");
const gain = async (audioContext)=>{
    const gain = audioContext.createGain();
    gain.gain.value = 0;
    return {
        inputs: {
            in: {
                port: gain,
                type: (0, _constants.PortType).Any
            },
            gain: {
                port: gain.gain,
                type: (0, _constants.PortType).Number,
                range: [
                    gain.gain.minValue,
                    gain.gain.maxValue
                ],
                defaultValue: gain.gain.value
            }
        },
        outputs: {
            out: {
                type: (0, _constants.PortType).Any,
                port: gain
            }
        }
    };
};
exports.default = gain;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fM4fR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _destination = require("./Destination");
var _destinationDefault = parcelHelpers.interopDefault(_destination);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _destinationDefault.default),
    node: (0, _nodeDefault.default),
    name: "Destination (Speaker)",
    description: "The final audio processing or rendering destination (usually the speakers)",
    info: `# Destination

A node that represents the final audio processing or rendering destination in the Web Audio API, typically your system's speakers or headphones.

## Purpose

- Serve as the final destination for all audio processing chains
- Connect audio sources to the system's audio output hardware
- Automatically handle audio routing to the default playback device
- Provide the endpoint for all audio graph processing

## Usage Notes

- This is typically the final node in any Web Audio processing chain
- All audio that should be heard must eventually connect to this node
- The destination automatically handles sample rate conversion if needed
- Audio context must be resumed (often requires user interaction) before audio will play
- This node uses the system's default audio output device`,
    tags: [
        "output",
        "speakers",
        "playback",
        "destination",
        "audio-api"
    ],
    portsDescription: {
        inputs: {
            in: "Audio input that receives signals to be routed to the audio destination (speakers/headphones)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Destination":"9sPYe","./Node":"dF18U","./base":"cq7hv","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9sPYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _md = require("react-icons/md");
let _ = (t)=>t, t, t1;
const TitleBarWrapper = (0, _styledDefault.default)((0, _core.TitleBar))(t || (t = _`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 0.5rem;
`));
const SpeakerIcon = (0, _styledDefault.default)((0, _md.MdSpeaker))(t1 || (t1 = _`
  width: auto;
  height: 100%;
  color: ${0};
  opacity: 0.3;
`), ({ theme })=>theme.colors.whitePrimary);
const Destination = (_props)=>{
    const theme = (0, _core.useTheme)();
    return (0, _jsxRuntime.jsx)(TitleBarWrapper, {
        children: (0, _jsxRuntime.jsx)(SpeakerIcon, {
            theme: theme
        })
    });
};
exports.default = Destination;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react-icons/md":"ixP1W","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dF18U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _destination = require("./Destination");
var _destinationDefault = parcelHelpers.interopDefault(_destination);
let _ = (t)=>t, t;
const DestinationNodeWrapper = (0, _styledDefault.default).div(t || (t = _`
  width: 3rem;
  height: 3rem;
`));
const DestinationNode = (props)=>{
    var _node_inputs;
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsxs)(DestinationNodeWrapper, {
        children: [
            (0, _jsxRuntime.jsx)((0, _destinationDefault.default), {
                node: props,
                audioNode: node,
                updateNodeValues: updateNodeValues
            }),
            (0, _jsxRuntime.jsx)((0, _core.InputHandle), {
                id: "in",
                portType: node === null || node === void 0 ? void 0 : (_node_inputs = node.inputs) === null || _node_inputs === void 0 ? void 0 : _node_inputs.in.type
            })
        ]
    });
};
exports.default = DestinationNode;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","./Destination":"9sPYe","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cq7hv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "destination",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"is1Ma","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"is1Ma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("@web-noise/core/constants");
const destination = (audioContext)=>{
    const destination = audioContext.destination;
    return {
        inputs: {
            in: {
                port: destination,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = destination;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7dEz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "patchNodes", ()=>patchNodes);
var _patch = require("./Patch");
var _patchDefault = parcelHelpers.interopDefault(_patch);
var _inlet = require("./Inlet");
var _inletDefault = parcelHelpers.interopDefault(_inlet);
var _outlet = require("./Outlet");
var _outletDefault = parcelHelpers.interopDefault(_outlet);
const patchNodes = {
    components: [
        (0, _patchDefault.default),
        (0, _inletDefault.default),
        (0, _outletDefault.default)
    ],
    name: "Patch nodes",
    description: "Nodes for creating reusable patches with inlets and outlets"
};
exports.default = patchNodes;

},{"./Patch":"9c6Rw","./Inlet":"cwNoY","./Outlet":"bwG0P","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9c6Rw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _patch = require("./Patch");
var _patchDefault = parcelHelpers.interopDefault(_patch);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _patchDefault.default),
    name: "Patch (Subpatch Container)",
    description: "Container component that loads and embeds patches as reusable modules. Enables modular patch design by encapsulating complex signal processing graphs that can be saved and reused across projects with dynamic inputs and outputs.",
    info: `# Patch (Subpatch Container)

A container component that loads and embeds other patches as reusable modules within a parent patch. The Patch node enables hierarchical patch architecture where complex processing chains can be encapsulated and reused.

## Purpose

- Load and embed saved patches as reusable modules
- Create hierarchical patch architectures with nested subpatches
- Encapsulate complex signal processing chains as black-box components
- Enable modular patch design with reusable components
- Share and reuse patches across projects and collaborations

## Values

- **URL/Patch Data**: Source of the patch to load, either as a project reference (project://patch-id), external URL, or direct patch data. The loaded patch contains nodes, connections, and configuration.

The Patch node treats subpatches as self-contained modules with clearly defined external interfaces.`,
    tags: [
        "patch",
        "modular",
        "container",
        "subpatch",
        "encapsulation",
        "reusable"
    ],
    portsDescription: {
        inputs: {
        },
        outputs: {
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Patch":"7mbnD","./base":"6jDfH","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7mbnD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react = require("react");
// @ts-ignore
var _reactGridLayout = require("react-grid-layout");
var _reactGridLayoutDefault = parcelHelpers.interopDefault(_reactGridLayout);
var _stylesCss = require("react-grid-layout/css/styles.css");
var _components = require("@web-noise/core/components");
var _panelNode = require("./PanelNode");
var _panelNodeDefault = parcelHelpers.interopDefault(_panelNode);
let _ = (t)=>t, t, t1, t2;
const NodeWrapper = (0, _styledDefault.default).div(t || (t = _`
  background-color: ${0};
  padding: 2% 3%;
`), ({ theme })=>theme.colors.elevation2);
const PanelNodeWrapper = (0, _styledDefault.default).div(t1 || (t1 = _`
  background-color: ${0};
  display: grid;
  grid-template-rows: max-content auto;
`), ({ theme })=>theme.colors.elevation2);
const PanelNodeTitle = (0, _styledDefault.default).div(t2 || (t2 = _`
  color: ${0};
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  margin-left: 0.5rem;
  margin-top: 0.3rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`), ({ theme })=>theme.colors.highlight2);
const Patch = (props)=>{
    var _patchData_controlPanel, _patchData_controlPanel_size, _patchData_controlPanel1;
    const { id, data } = props;
    const { url } = data.values || {};
    const theme = (0, _core.useTheme)();
    const createNode = (0, _core.useStore)((store)=>store.createNode);
    const removeNode = (0, _core.useStore)((store)=>store.removeNode);
    const getNode = (0, _core.useStore)((store)=>store.getNode);
    const projectFiles = (0, _core.useStore)((store)=>store.project.files);
    const currentFileIndex = (0, _core.useStore)((store)=>store.currentFileIndex);
    const { updateNodeValues } = (0, _core.useNode)(id);
    const { node: audioNode } = (0, _core.useAudioNode)(id) || {};
    const patchData = audioNode === null || audioNode === void 0 ? void 0 : audioNode.patchData;
    const controlPanelNodes = patchData === null || patchData === void 0 ? void 0 : (_patchData_controlPanel = patchData.controlPanel) === null || _patchData_controlPanel === void 0 ? void 0 : _patchData_controlPanel.nodes;
    var _patchData_controlPanel_size_width;
    const width = (_patchData_controlPanel_size_width = patchData === null || patchData === void 0 ? void 0 : (_patchData_controlPanel1 = patchData.controlPanel) === null || _patchData_controlPanel1 === void 0 ? void 0 : (_patchData_controlPanel_size = _patchData_controlPanel1.size) === null || _patchData_controlPanel_size === void 0 ? void 0 : _patchData_controlPanel_size.width) !== null && _patchData_controlPanel_size_width !== void 0 ? _patchData_controlPanel_size_width : 200;
    const filteredNodes = (0, _react.useMemo)(()=>{
        const controlPanel = patchData === null || patchData === void 0 ? void 0 : patchData.controlPanel;
        const patchNodes = patchData === null || patchData === void 0 ? void 0 : patchData.nodes;
        if (!controlPanel || !patchNodes) return [];
        const nodeIds = controlPanel.nodes.map(({ id })=>id);
        return patchNodes.filter(({ id })=>nodeIds.includes(id));
    }, [
        patchData
    ]);
    const setPatchUrl = (0, _react.useCallback)((url)=>{
        const node = getNode(id);
        if (!node) {
            console.error(`could not find node: #${id}`);
            return;
        }
        removeNode(node);
        createNode((0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
            id: `${node.type}-${+new Date()}`,
            data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, node.data), {
                values: {
                    url
                }
            })
        }));
    }, [
        createNode,
        removeNode,
        id,
        getNode
    ]);
    return (0, _jsxRuntime.jsxs)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: [
            typeof url === "undefined" ? (0, _jsxRuntime.jsx)(NodeWrapper, {
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.DropdownInput), {
                    placeholder: "patch url",
                    onSubmit: setPatchUrl,
                    options: projectFiles.filter((file, index)=>index !== currentFileIndex && (0, _core.isPatch)(file)).map(({ id, name })=>({
                            value: `project://${id}`,
                            label: name
                        }))
                })
            }) : null,
            controlPanelNodes ? (0, _jsxRuntime.jsx)("div", {
                style: {
                    width: `${width + 1}px`
                },
                children: (0, _jsxRuntime.jsx)((0, _reactGridLayoutDefault.default), {
                    layout: controlPanelNodes.map(({ id: i, width, height, x, y }, index)=>({
                            i,
                            w: width || 4,
                            h: height || 6,
                            x: x || 0,
                            y: y || controlPanelNodes.length + index
                        })),
                    className: "layout",
                    cols: 4,
                    rowHeight: 10,
                    width: width,
                    margin: [
                        0,
                        0
                    ],
                    isResizable: false,
                    isDraggable: false,
                    children: filteredNodes.map((node)=>{
                        var _data_values_nodes, _data_values, _audioNode_audioNodes_get;
                        const nodeValues = (_data_values = data.values) === null || _data_values === void 0 ? void 0 : (_data_values_nodes = _data_values.nodes) === null || _data_values_nodes === void 0 ? void 0 : _data_values_nodes[node.id];
                        const extendedNode = (0, _objectSpreadProps._)((0, _objectSpread._)({}, node), {
                            data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, node.data), {
                                values: (0, _objectSpread._)({}, node.data.values, nodeValues || {})
                            })
                        });
                        return (0, _jsxRuntime.jsxs)(PanelNodeWrapper, {
                            theme: theme,
                            children: [
                                (0, _jsxRuntime.jsx)(PanelNodeTitle, {
                                    theme: theme,
                                    children: node.data.label
                                }),
                                (0, _jsxRuntime.jsx)((0, _panelNodeDefault.default), {
                                    node: extendedNode,
                                    audioNode: audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_audioNodes_get = audioNode.audioNodes.get(node.id)) === null || _audioNode_audioNodes_get === void 0 ? void 0 : _audioNode_audioNodes_get.node,
                                    updateNodeValues: (values)=>{
                                        var _data_values;
                                        updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, data.values), {
                                            nodes: (0, _objectSpreadProps._)((0, _objectSpread._)({}, (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.nodes), {
                                                [node.id]: values
                                            })
                                        }));
                                    }
                                })
                            ]
                        }, node.id);
                    })
                })
            }) : null
        ]
    }));
};
exports.default = Patch;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","react-grid-layout":"5Kdnk","react-grid-layout/css/styles.css":"coJMT","@web-noise/core/components":"jYfYj","./PanelNode":"lzfkz","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"coJMT":[function() {},{}],"lzfkz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _react = require("react");
var _stylesCss = require("react-grid-layout/css/styles.css");
const PanelNode = (props)=>{
    const { node } = props;
    const getControlPanelNode = (0, _core.useStore)((store)=>store.getControlPanelNode);
    const ControlPanelNode = (0, _react.useMemo)(()=>getControlPanelNode(node), [
        node,
        getControlPanelNode
    ]);
    if (!ControlPanelNode) return null;
    return (0, _jsxRuntime.jsx)(ControlPanelNode, (0, _objectSpread._)({}, props));
};
exports.default = PanelNode;

},{"@swc/helpers/_/_object_spread":"awBF9","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","react":"lXMxO","react-grid-layout/css/styles.css":"coJMT","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"coJMT":[function() {},{}],"6jDfH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _patchAudioNode = require("./patchAudioNode");
var _patchAudioNodeDefault = parcelHelpers.interopDefault(_patchAudioNode);
const plugin = {
    type: "patch",
    node: null,
    audioNode: (0, _patchAudioNodeDefault.default)
};
exports.default = plugin;

},{"./patchAudioNode":"eQ3lU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eQ3lU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPatchData", ()=>getPatchData);
parcelHelpers.export(exports, "patchNode", ()=>patchNode);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _patch = require("@web-noise/patch");
var _fetch = require("@web-noise/fetch");
var _fetchDefault = parcelHelpers.interopDefault(_fetch);
const getPatchData = async (values)=>{
    const { url, patch } = values;
    if (patch) return patch;
    if (typeof url !== "string") throw new Error("patch url is not specified");
    const data = await (0, _fetchDefault.default)(url).then((r)=>r.json());
    if (typeof data === "undefined") throw new Error("patch data is undefined");
    return data;
};
const patchNode = async (audioContext, data)=>{
    const values = data === null || data === void 0 ? void 0 : data.values;
    if (!values) return {};
    const patchData = await getPatchData(values);
    const { nodes, edges } = patchData;
    const { nodes: controlPanelNodes } = values || {};
    const patch = (0, _patch.createPatch)(audioContext);
    await patch.registerAudioNodes(nodes);
    patch.registerAudioConnections(edges);
    const { audioNodes } = patch;
    const { inputs, outputs } = nodes.reduce((acc, node)=>{
        const { type, id, data } = node;
        const { label } = data;
        if (type === "inlet") {
            var _audioNodes_get_node_inputs, _audioNodes_get_node, _audioNodes_get;
            const input = audioNodes === null || audioNodes === void 0 ? void 0 : (_audioNodes_get = audioNodes.get(id)) === null || _audioNodes_get === void 0 ? void 0 : (_audioNodes_get_node = _audioNodes_get.node) === null || _audioNodes_get_node === void 0 ? void 0 : (_audioNodes_get_node_inputs = _audioNodes_get_node.inputs) === null || _audioNodes_get_node_inputs === void 0 ? void 0 : _audioNodes_get_node_inputs.in;
            if (!input) return acc;
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                inputs: (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc.inputs), {
                    [label || `in-${+new Date()}`]: input
                })
            });
        }
        if (node.type === "outlet") {
            var _audioNodes_get_node_outputs, _audioNodes_get_node1, _audioNodes_get1;
            const output = audioNodes === null || audioNodes === void 0 ? void 0 : (_audioNodes_get1 = audioNodes.get(id)) === null || _audioNodes_get1 === void 0 ? void 0 : (_audioNodes_get_node1 = _audioNodes_get1.node) === null || _audioNodes_get_node1 === void 0 ? void 0 : (_audioNodes_get_node_outputs = _audioNodes_get_node1.outputs) === null || _audioNodes_get_node_outputs === void 0 ? void 0 : _audioNodes_get_node_outputs.out;
            if (!output) return acc;
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                outputs: (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc.outputs), {
                    [label || `out-${+new Date()}`]: output
                })
            });
        }
        return acc;
    }, {
        inputs: [],
        outputs: []
    });
    nodes.forEach(({ id, data: { values } })=>{
        var _node_node;
        const node = audioNodes.get(id);
        const setValues = node === null || node === void 0 ? void 0 : (_node_node = node.node) === null || _node_node === void 0 ? void 0 : _node_node.setValues;
        if (values && setValues) setValues(values);
    });
    Object.keys(controlPanelNodes || {}).forEach((id)=>{
        var _node_node_setValues, _node_node;
        const values = controlPanelNodes === null || controlPanelNodes === void 0 ? void 0 : controlPanelNodes[id];
        const node = audioNodes.get(id);
        node === null || node === void 0 ? void 0 : (_node_node = node.node) === null || _node_node === void 0 ? void 0 : (_node_node_setValues = _node_node.setValues) === null || _node_node_setValues === void 0 ? void 0 : _node_node_setValues.call(_node_node, values);
    });
    return {
        inputs,
        outputs,
        patchData: patchData,
        audioNodes,
        destroy: ()=>{
            //disconnect all nodes from each other
            //unregister all nodes
            audioNodes.forEach(({ node })=>{
                var _node_destroy;
                return node === null || node === void 0 ? void 0 : (_node_destroy = node.destroy) === null || _node_destroy === void 0 ? void 0 : _node_destroy.call(node);
            });
        }
    };
};
exports.default = patchNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/patch":"8lm4y","@web-noise/fetch":"aRn3r","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cwNoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Inlet (Patch Input)",
    description: "Patch boundary component that creates an input port for encapsulated patches. Defines where external signals enter a subpatch, enabling modular patch design and reusable audio processing modules.",
    info: `# Inlet (Patch Input)

A patch boundary component that creates input ports for encapsulated audio patches. Inlet nodes mark where signals from parent patches enter subpatches, enabling modular and hierarchical patch architecture.

## Purpose

- Define input ports for reusable patch modules
- Create boundaries for encapsulated signal processing chains
- Enable modular patch design with clear input contracts
- Allow complex patches to be packaged as reusable components
- Organize large projects with hierarchical patch structures


Inlet nodes work in conjunction with Outlet nodes to create complete input/output interfaces for subpatches and modules.`,
    tags: [
        "patch",
        "modular",
        "input",
        "boundary",
        "routing",
        "subpatch"
    ],
    portsDescription: {
        inputs: {
            in: "Input port receiving signals from parent patch context"
        },
        outputs: {
            out: "Output port forwarding signals to nodes within the patch"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"eRKsF","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eRKsF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("../../webNoise/PassThrough/audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "inlet",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"../../webNoise/PassThrough/audioNode":"5LLFk","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5LLFk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "passThrough", ()=>passThrough);
var _constants = require("@web-noise/core/constants");
const passThrough = async (audioContext)=>{
    const passThroughNode = audioContext.createGain();
    passThroughNode.gain.value = 1;
    return {
        inputs: {
            in: {
                port: passThroughNode,
                type: (0, _constants.PortType).Any
            }
        },
        outputs: {
            out: {
                port: passThroughNode,
                type: (0, _constants.PortType).Any
            }
        }
    };
};
exports.default = passThrough;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bwG0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Outlet (Patch Output)",
    description: "Patch boundary component that creates an output port for encapsulated patches. Defines where internal signals exit a subpatch to the parent context, enabling modular patch design and reusable audio processing modules.",
    info: `# Outlet (Patch Output)

A patch boundary component that creates output ports for encapsulated audio patches. Outlet nodes mark where signals from within subpatches exit to parent patches, enabling modular and hierarchical patch architecture.

## Purpose

- Define output ports for reusable patch modules
- Create boundaries for encapsulated signal processing chains
- Enable modular patch design with clear output contracts
- Allow complex patches to be packaged as reusable components
- Organize large projects with hierarchical patch structures

Outlet nodes work in conjunction with Inlet nodes to create complete input/output interfaces for subpatches and modules.`,
    tags: [
        "patch",
        "modular",
        "output",
        "boundary",
        "routing",
        "subpatch"
    ],
    portsDescription: {
        inputs: {
            in: "Input port receiving signals from nodes within the patch"
        },
        outputs: {
            out: "Output port forwarding signals to parent patch context"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"loms0","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"loms0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("../../webNoise/PassThrough/audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "outlet",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"../../webNoise/PassThrough/audioNode":"5LLFk","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8xLgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "webNoiseNodes", ()=>webNoiseNodes);
var _adsr = require("./ADSR");
var _adsrDefault = parcelHelpers.interopDefault(_adsr);
var _audioOutput = require("./AudioOutput");
var _audioOutputDefault = parcelHelpers.interopDefault(_audioOutput);
var _audioInput = require("./AudioInput");
var _audioInputDefault = parcelHelpers.interopDefault(_audioInput);
var _distortion = require("./Distortion");
var _distortionDefault = parcelHelpers.interopDefault(_distortion);
var _frequencyMeter = require("./FrequencyMeter");
var _frequencyMeterDefault = parcelHelpers.interopDefault(_frequencyMeter);
var _gate = require("./Gate");
var _gateDefault = parcelHelpers.interopDefault(_gate);
var _gauge = require("./Gauge");
var _gaugeDefault = parcelHelpers.interopDefault(_gauge);
var _limiter = require("./Limiter");
var _limiterDefault = parcelHelpers.interopDefault(_limiter);
var _mathNode = require("./MathNode");
var _mathNodeDefault = parcelHelpers.interopDefault(_mathNode);
var _midiNote = require("./MidiNote");
var _midiNoteDefault = parcelHelpers.interopDefault(_midiNote);
var _oscilloscope = require("./Oscilloscope");
var _oscilloscopeDefault = parcelHelpers.interopDefault(_oscilloscope);
var _phaseVocoder = require("./PhaseVocoder");
var _phaseVocoderDefault = parcelHelpers.interopDefault(_phaseVocoder);
var _quantizer = require("./Quantizer");
var _quantizerDefault = parcelHelpers.interopDefault(_quantizer);
var _scale = require("./Scale");
var _scaleDefault = parcelHelpers.interopDefault(_scale);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _spectroscope = require("./Spectroscope");
var _spectroscopeDefault = parcelHelpers.interopDefault(_spectroscope);
var _sticker = require("./Sticker");
var _stickerDefault = parcelHelpers.interopDefault(_sticker);
var _valueMeter = require("./ValueMeter");
var _valueMeterDefault = parcelHelpers.interopDefault(_valueMeter);
var _midiToFrequency = require("./MidiToFrequency");
var _midiToFrequencyDefault = parcelHelpers.interopDefault(_midiToFrequency);
var _whiteNoise = require("./WhiteNoise");
var _whiteNoiseDefault = parcelHelpers.interopDefault(_whiteNoise);
var _audioTrack = require("./AudioTrack");
var _audioTrackDefault = parcelHelpers.interopDefault(_audioTrack);
var _clock = require("./Clock");
var _clockDefault = parcelHelpers.interopDefault(_clock);
var _dataRecorder = require("./DataRecorder");
var _dataRecorderDefault = parcelHelpers.interopDefault(_dataRecorder);
var _midiInput = require("./MidiInput");
var _midiInputDefault = parcelHelpers.interopDefault(_midiInput);
var _randomSequencer = require("./RandomSequencer");
var _randomSequencerDefault = parcelHelpers.interopDefault(_randomSequencer);
var _sequencer = require("./Sequencer");
var _sequencerDefault = parcelHelpers.interopDefault(_sequencer);
var _virtualKeyboard = require("./VirtualKeyboard");
var _virtualKeyboardDefault = parcelHelpers.interopDefault(_virtualKeyboard);
var _audioRecorder = require("./AudioRecorder");
var _audioRecorderDefault = parcelHelpers.interopDefault(_audioRecorder);
var _passThrough = require("./PassThrough");
var _passThroughDefault = parcelHelpers.interopDefault(_passThrough);
const webNoiseNodes = {
    components: [
        (0, _adsrDefault.default),
        (0, _gaugeDefault.default),
        (0, _clockDefault.default),
        (0, _whiteNoiseDefault.default),
        (0, _oscilloscopeDefault.default),
        (0, _spectroscopeDefault.default),
        (0, _virtualKeyboardDefault.default),
        (0, _randomSequencerDefault.default),
        (0, _sequencerDefault.default),
        (0, _gateDefault.default),
        (0, _selectDefault.default),
        (0, _sliderDefault.default),
        (0, _mathNodeDefault.default),
        (0, _midiToFrequencyDefault.default),
        (0, _audioTrackDefault.default),
        (0, _valueMeterDefault.default),
        (0, _stickerDefault.default),
        (0, _midiInputDefault.default),
        (0, _dataRecorderDefault.default),
        (0, _midiNoteDefault.default),
        (0, _frequencyMeterDefault.default),
        (0, _quantizerDefault.default),
        (0, _scaleDefault.default),
        (0, _phaseVocoderDefault.default),
        (0, _distortionDefault.default),
        (0, _limiterDefault.default),
        (0, _audioOutputDefault.default),
        (0, _audioInputDefault.default),
        (0, _audioRecorderDefault.default),
        (0, _passThroughDefault.default)
    ],
    name: "Web Noise base nodes",
    description: "Advanced synthesis tools, effects processors, sequencers, and utilities for modular audio production"
};
exports.default = webNoiseNodes;

},{"./ADSR":"2H1D5","./AudioOutput":"ifKpA","./AudioInput":"ibPuP","./Distortion":"gYENu","./FrequencyMeter":"1MVdR","./Gate":"enpQS","./Gauge":"8bFVa","./Limiter":"2OpoD","./MathNode":"inRvF","./MidiNote":"62aV2","./Oscilloscope":"17AhU","./PhaseVocoder":"7qavW","./Quantizer":"5Utaq","./Scale":"gkdLK","./Select":"8qOgQ","./Slider":"1y6oi","./Spectroscope":"zbfLc","./Sticker":"45Ue9","./ValueMeter":"iz2SM","./MidiToFrequency":"kj8KJ","./WhiteNoise":"41PYh","./AudioTrack":"6uvtu","./Clock":"ihbkK","./DataRecorder":"6MFeS","./MidiInput":"1SIJB","./RandomSequencer":"lLKAQ","./Sequencer":"73J8e","./VirtualKeyboard":"4gh66","./AudioRecorder":"eKoOW","./PassThrough":"ehjXh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2H1D5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _adsr = require("./ADSR");
var _adsrDefault = parcelHelpers.interopDefault(_adsr);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _adsrDefault.default),
    configNode: (0, _configDefault.default),
    resizable: true,
    defaultConfig: (0, _defaultConfigDefault.default),
    name: "ADSR (Envelope Generator)",
    description: "Generates Attack-Decay-Sustain-Release envelope signals for shaping audio parameters over time. Essential for creating dynamic volume, filter, and modulation effects in synthesizers.",
    info: `# ADSR Envelope Generator

An envelope generator that produces control signals for shaping audio parameters over time. ADSR envelopes are fundamental building blocks in sound synthesis and audio processing.

## Purpose

- Shape the amplitude of sounds to create natural dynamics
- Control filter cutoff for timbral evolution
- Modulate any parameter that accepts control signals
- Create percussive, sustained, or evolving sounds

## Values

- **Attack (A)**: Time (0-60s) for the envelope to reach peak level. Controls how quickly a sound fades in.
- **Attack Curve**: Shape (0-1) of the attack phase. Lower values create linear attacks, higher values create exponential attacks.
- **Decay (D)**: Time (0-60s) for the envelope to fall from peak to sustain level. Controls the initial fade after the attack.
- **Sustain (S)**: Level (0-1) maintained while the trigger is active. Controls the steady-state volume.
- **Release (R)**: Time (0-60s) for the envelope to fall from sustain to zero after trigger release. Controls how quickly a sound fades out.
- **Trigger**: Gate signal (0 or 1) that starts the envelope when > 0 and releases it when 0.`,
    tags: [
        "envelope",
        "modulation",
        "synthesis",
        "control",
        "adsr"
    ],
    portsDescription: {
        inputs: {
            trigger: "Gate signal that starts the envelope when > 0 and releases it when 0",
            A: "Attack time in seconds (0-60s)",
            attackCurve: "Shape of the attack curve (0-1), where 0 is linear and 1 is exponential",
            D: "Decay time in seconds (0-60s)",
            S: "Sustain level (0-1)",
            R: "Release time in seconds (0-60s)"
        },
        outputs: {
            gain: "Envelope output signal (0-1) for controlling audio parameters"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"dYU5b","./ADSR":"5nlHs","./Node":"hYE1I","./Config":"gPJTe","./defaultConfig":"2L6e6","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dYU5b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "adsr",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"eDGKT","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eDGKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adsr", ()=>adsr);
var _constants = require("@web-noise/core/constants");
var _useBroadcast = require("../../lib/useBroadcast");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const adsrWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/ADSR/audioNode.ts");
const adsr = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(adsrWorklet);
    const adsr = new AudioWorkletNode(audioContext, "adsr-processor");
    const trigger = adsr.parameters.get((0, _types.ADSRParameters).Trigger);
    const A = adsr.parameters.get((0, _types.ADSRParameters).A);
    const attackCurve = adsr.parameters.get((0, _types.ADSRParameters).AttackCurve);
    const D = adsr.parameters.get((0, _types.ADSRParameters).D);
    const S = adsr.parameters.get((0, _types.ADSRParameters).S);
    const R = adsr.parameters.get((0, _types.ADSRParameters).R);
    return {
        inputs: {
            trigger: {
                port: trigger,
                type: (0, _constants.PortType).Gate,
                range: [
                    trigger.minValue,
                    trigger.maxValue
                ],
                defaultValue: trigger.value
            },
            A: {
                port: A,
                type: (0, _constants.PortType).Number,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            attackCurve: {
                port: attackCurve,
                type: (0, _constants.PortType).Number,
                range: [
                    attackCurve.minValue,
                    attackCurve.maxValue
                ],
                defaultValue: attackCurve.value
            },
            D: {
                port: D,
                type: (0, _constants.PortType).Number,
                range: [
                    D.minValue,
                    D.maxValue
                ],
                defaultValue: D.value
            },
            S: {
                port: S,
                type: (0, _constants.PortType).Number,
                range: [
                    S.minValue,
                    S.maxValue
                ],
                defaultValue: S.value
            },
            R: {
                port: R,
                type: (0, _constants.PortType).Number,
                range: [
                    R.minValue,
                    R.maxValue
                ],
                defaultValue: R.value
            }
        },
        outputs: {
            gain: {
                port: adsr,
                type: (0, _constants.PortType).Gate,
                range: [
                    0,
                    1
                ],
                defaultValue: 0
            }
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(adsr.port, port);
        }
    };
};
exports.default = adsr;

},{"@web-noise/core/constants":"36kMU","../../lib/useBroadcast":"ekNC4","./types":"kbDS5","worklet:./worklet.ts":"hUNbM","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kbDS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADSRParameters", ()=>ADSRParameters);
parcelHelpers.export(exports, "PHASES", ()=>PHASES);
parcelHelpers.export(exports, "WorkerEventNames", ()=>WorkerEventNames);
var ADSRParameters;
(function(ADSRParameters) {
    ADSRParameters["A"] = "attack";
    ADSRParameters["AttackCurve"] = "attackCurve";
    ADSRParameters["D"] = "decay";
    ADSRParameters["S"] = "sustain";
    ADSRParameters["R"] = "release";
    ADSRParameters["Trigger"] = "trigger";
})(ADSRParameters || (ADSRParameters = {}));
var PHASES;
(function(PHASES) {
    PHASES["IDLE"] = "idle";
    PHASES["ATTACK"] = "attack";
    PHASES["DECAY"] = "decay";
    PHASES["SUSTAIN"] = "sustain";
    PHASES["RELEASE"] = "release";
})(PHASES || (PHASES = {}));
var WorkerEventNames;
(function(WorkerEventNames) {
    WorkerEventNames["INIT"] = "INIT";
    WorkerEventNames["SET_COLORS"] = "SET_COLORS";
})(WorkerEventNames || (WorkerEventNames = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hUNbM":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4bcep");

},{}],"5nlHs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _lib = require("@web-noise/core/lib");
var _scope = require("./Scope");
var _scopeDefault = parcelHelpers.interopDefault(_scope);
let _ = (t)=>t, t;
const ADSRWrapper = (0, _styledDefault.default).div(t || (t = _`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${0};
  canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`), ({ backgroundColor })=>backgroundColor);
const ADSR = ({ node: props, audioNode })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const channel = (0, _lib.useMessageChannel)();
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        audioNode.registerPort(channel.port1);
    }, [
        audioNode,
        channel
    ]);
    const { backgroundColor, colors } = data.config || {};
    return (0, _jsxRuntime.jsx)(ADSRWrapper, {
        backgroundColor: backgroundColor,
        theme: theme,
        children: channel ? (0, _jsxRuntime.jsx)((0, _scopeDefault.default), {
            port: channel.port2,
            colors: colors
        }) : null
    });
};
exports.default = ADSR;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@web-noise/core/lib":"8cGsd","./Scope":"102AZ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"102AZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lib = require("@web-noise/core/lib");
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
var _types = require("./types");
//@ts-ignore
var _rendererWorkerTs = require("worklet:./renderer.worker.ts");
var _rendererWorkerTsDefault = parcelHelpers.interopDefault(_rendererWorkerTs);
const rendererWorker = new URL((0, _rendererWorkerTsDefault.default), "file:///packages/base-nodes/src/webNoise/ADSR/Scope.tsx");
const Scope = ({ port, colors = (0, _defaultConfigDefault.default).colors })=>{
    const worker = (0, _lib.useWorker)(rendererWorker);
    const canvasRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const canvasElement = canvasRef.current;
        if (canvasElement && worker) {
            const canvas = canvasElement.transferControlToOffscreen();
            const message = {
                name: (0, _types.WorkerEventNames).INIT,
                canvas,
                port
            };
            worker.postMessage(message, [
                canvas,
                port
            ]);
        }
    }, [
        canvasRef,
        port,
        worker
    ]);
    (0, _react.useEffect)(()=>{
        if (!worker) return;
        const message = {
            name: (0, _types.WorkerEventNames).SET_COLORS,
            colors
        };
        worker.postMessage(message);
    }, [
        colors,
        worker
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: canvasRef
    });
};
exports.default = Scope;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core/lib":"8cGsd","./defaultConfig":"2L6e6","./types":"kbDS5","worklet:./renderer.worker.ts":"2ohYS","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2L6e6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    backgroundColor: (0, _core.theme).colors.elevation1,
    colors: {
        attack: (0, _core.theme).colors.accent2,
        decay: (0, _core.theme).colors.accent2,
        sustain: (0, _core.theme).colors.accent2,
        release: (0, _core.theme).colors.accent2
    },
    size: {
        width: 280,
        height: 150
    }
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2ohYS":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("esP4X");

},{}],"hYE1I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _adsr = require("./ADSR");
var _adsrDefault = parcelHelpers.interopDefault(_adsr);
const ADSRNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _adsrDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = ADSRNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./ADSR":"5nlHs","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gPJTe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const ADSRConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { backgroundColor, colors } = config;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Background Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: backgroundColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    backgroundColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Attack Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: colors === null || colors === void 0 ? void 0 : colors.attack,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    colors: (0, _objectSpreadProps._)((0, _objectSpread._)({}, colors), {
                                        attack: value
                                    })
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Decay Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: colors === null || colors === void 0 ? void 0 : colors.decay,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    colors: (0, _objectSpreadProps._)((0, _objectSpread._)({}, colors), {
                                        decay: value
                                    })
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Sustain Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: colors === null || colors === void 0 ? void 0 : colors.sustain,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    colors: (0, _objectSpreadProps._)((0, _objectSpread._)({}, colors), {
                                        sustain: value
                                    })
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Release Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: colors === null || colors === void 0 ? void 0 : colors.release,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    colors: (0, _objectSpreadProps._)((0, _objectSpread._)({}, colors), {
                                        release: value
                                    })
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            })
        ]
    });
};
exports.default = ADSRConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ifKpA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _audioOutput = require("./AudioOutput");
var _audioOutputDefault = parcelHelpers.interopDefault(_audioOutput);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _audioOutputDefault.default),
    node: (0, _nodeDefault.default),
    name: "Audio Output (Speakers)",
    description: "Routes audio to speakers, headphones, and other output devices connected to your system.",
    info: `# Audio Output

A node that routes audio to speakers, headphones, and other output devices connected to your system.

## Purpose

- Route audio to specific output devices like speakers or headphones
- Select between multiple audio outputs for different monitoring scenarios
- Create multi-channel audio systems with different outputs
- Test audio on different devices without changing system settings

## Usage Notes

- Browser security may require user interaction before audio output selection can be used
- Some browsers may have limited support for the Audio Output Devices API
- Default output refers to the system's current default audio device
- For best results, ensure your browser has permission to access audio devices
- Device selection is maintained across audio context suspensions`,
    tags: [
        "output",
        "speakers",
        "playback",
        "destination"
    ],
    portsDescription: {
        inputs: {
            input: "Audio input that receives signals to be routed to the selected output device"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"98fOl","./AudioOutput":"aXy0r","./Node":"eW16k","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"98fOl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "audioOutput",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"6kwUh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6kwUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audioOutput", ()=>audioOutput);
var _constants = require("@web-noise/core/constants");
var _eventBus = require("../../lib/EventBus");
var _eventBusDefault = parcelHelpers.interopDefault(_eventBus);
var _constants1 = require("./constants");
const getAudioOutputsList = async ()=>{
    return navigator.mediaDevices.enumerateDevices().then((devices)=>devices.filter(({ kind })=>kind === "audiooutput")).catch((e)=>{
        console.log("Could not access your audio devices.", e);
        return [];
    });
};
const audioOutput = async (audioContext, data)=>{
    var _data_values;
    const events = new (0, _eventBusDefault.default)();
    const destination = audioContext.createMediaStreamDestination();
    const audio = new Audio();
    audio.srcObject = destination.stream;
    audio.play();
    const output = audioContext.createGain();
    output.gain.value = 1;
    var _data_values_currentOutput;
    let currentOutputDeviceId = (_data_values_currentOutput = data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.currentOutput) !== null && _data_values_currentOutput !== void 0 ? _data_values_currentOutput : (0, _constants1.DEFAULT_OUTPUT);
    //@ts-ignore
    await audio.setSinkId("default");
    let audioOutputs = await getAudioOutputsList();
    const updateAudioOutputHandler = async ()=>{
        //@ts-ignore
        await audio.setSinkId(currentOutputDeviceId);
    };
    navigator.mediaDevices.addEventListener("devicechange", async ()=>{
        const newAudioOutputs = await getAudioOutputsList();
        // For some reason 'devicechange' event gets fired twice
        const audioOutputIds = audioOutputs.map(({ deviceId })=>deviceId);
        const isEqual = audioOutputs.length === newAudioOutputs.length && newAudioOutputs.every(({ deviceId })=>audioOutputIds.includes(deviceId));
        if (!isEqual) {
            audioOutputs = newAudioOutputs;
            events.trigger("list", audioOutputs);
            updateAudioOutputHandler();
        }
    });
    updateAudioOutputHandler();
    return {
        inputs: {
            input: {
                port: destination,
                type: (0, _constants.PortType).Audio
            }
        },
        audioOutputs,
        addEventListener: (...args)=>events.addEventListener(...args),
        setValues: ({ currentOutput: currentOutputValue } = {})=>{
            if (typeof currentOutputValue !== "undefined") {
                currentOutputDeviceId = currentOutputValue;
                updateAudioOutputHandler();
            }
        }
    };
};
exports.default = audioOutput;

},{"@web-noise/core/constants":"36kMU","../../lib/EventBus":"76U72","./constants":"k0bae","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"76U72":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EventBus);
var _defineProperty = require("@swc/helpers/_/_define_property");
class EventBus {
    trigger(eventName, ...args) {
        const callbackObject = this.eventObject[eventName];
        if (!callbackObject) return console.warn(eventName + " not found!");
        for(let id in callbackObject)callbackObject[id](...args);
    }
    addEventListener(eventName, callback) {
        if (!this.eventObject[eventName]) this.eventObject[eventName] = {};
        const id = this.callbackId++;
        this.eventObject[eventName][id] = callback;
        const unSubscribe = ()=>{
            delete this.eventObject[eventName][id];
            if (Object.keys(this.eventObject[eventName]).length === 0) delete this.eventObject[eventName];
        };
        return unSubscribe;
    }
    constructor(){
        (0, _defineProperty._)(this, "eventObject", {});
        (0, _defineProperty._)(this, "callbackId", 0);
    }
}

},{"@swc/helpers/_/_define_property":"k9ryq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k0bae":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_OUTPUT", ()=>DEFAULT_OUTPUT);
const DEFAULT_OUTPUT = "default";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aXy0r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@emotion/react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react1 = require("react");
var _components = require("@web-noise/core/components");
var _constants = require("./constants");
let _ = (t)=>t, t, t1, t2;
const AudioOutputWrapper = (0, _styledDefault.default).div(t || (t = _``));
const OutputDropdownWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  background-color: var(--leva-colors-elevation2);
  padding: 0.4rem 0.5rem;
  height: 100%;
  box-sizing: border-box;
`)));
const NoAudioInputsMessage = (0, _styledDefault.default).div(t2 || (t2 = _`
  color: ${0};
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  padding: 0.5rem;
`), ({ theme })=>theme.colors.highlight1);
const AudioOutput = ({ node: props, audioNode, updateNodeValues, full })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const [audioOutputs, setAudioOutputs] = (0, _react1.useState)([]);
    const { currentOutput = (0, _constants.DEFAULT_OUTPUT) } = data.values || {};
    const outputsChangeHandler = (0, _react1.useCallback)((outputs)=>setAudioOutputs(()=>outputs), []);
    (0, _react1.useEffect)(()=>{
        if (!audioNode) return;
        outputsChangeHandler([
            ...audioNode.audioOutputs
        ]);
        const unSubscribe = audioNode.addEventListener("list", outputsChangeHandler);
        return ()=>unSubscribe();
    }, [
        audioNode,
        audioNode === null || audioNode === void 0 ? void 0 : audioNode.audioInputs,
        outputsChangeHandler
    ]);
    (0, _react1.useEffect)(()=>audioNode === null || audioNode === void 0 ? void 0 : audioNode.setValues(data.values), [
        audioNode,
        data
    ]);
    const options = (0, _react1.useMemo)(()=>[
            ...audioOutputs.map(({ deviceId, label })=>({
                    label,
                    subtitle: `Device ID: ${deviceId}`,
                    value: deviceId
                }))
        ], [
        audioOutputs
    ]);
    if (full) return (0, _jsxRuntime.jsx)(AudioOutputWrapper, {
        theme: theme,
        children: audioOutputs.length ? (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
            options: options,
            value: currentOutput,
            onChange: (deviceId)=>updateNodeValues({
                    currentOutput: deviceId
                })
        }) : (0, _jsxRuntime.jsx)(NoAudioInputsMessage, {
            theme: theme,
            children: "No Audio Outputs available"
        })
    });
    return (0, _jsxRuntime.jsx)(OutputDropdownWrapper, {
        children: (0, _jsxRuntime.jsx)((0, _components.Select), {
            options: options,
            value: currentOutput || (0, _constants.DEFAULT_OUTPUT),
            onChange: (deviceId)=>updateNodeValues({
                    currentOutput: deviceId
                })
        })
    });
};
exports.default = AudioOutput;

},{"react/jsx-runtime":"g1NAx","@emotion/react":"ifT37","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","@web-noise/core/components":"jYfYj","./constants":"k0bae","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eW16k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _audioOutput = require("./AudioOutput");
var _audioOutputDefault = parcelHelpers.interopDefault(_audioOutput);
const AudioOutputNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _audioOutputDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues,
            full: true
        })
    }));
};
exports.default = AudioOutputNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./AudioOutput":"aXy0r","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ibPuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _audioInput = require("./AudioInput");
var _audioInputDefault = parcelHelpers.interopDefault(_audioInput);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _audioInputDefault.default),
    name: "Audio Input (Microphone)",
    description: "Captures audio from microphones and other input devices connected to your system..",
    info: `# Audio Input

A node that captures audio from microphones and other input devices connected to your system.

## Purpose

- Capture live audio from microphones or sound cards for processing
- Record voice, instruments, or ambient sounds
- Use external audio sources in your audio graph
- Create interactive audio applications that respond to sound input

## Usage Notes

- Browser security requires user interaction before audio input can be accessed
- The first time you use this node, you'll need to grant permission to access your microphone
- Some devices may not be available if already in use by other applications
- For best results, use headphones to prevent feedback when using microphones`,
    tags: [
        "input",
        "microphone",
        "capture",
        "recording",
        "source"
    ],
    portsDescription: {
        outputs: {
            output: "Audio output that provides the captured audio signal from the selected input device"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"3ItZv","./AudioInput":"6rqgT","./Node":"1W5dh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3ItZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "audioInput",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"cabmA","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cabmA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("@web-noise/core/constants");
var _eventBus = require("../../lib/EventBus");
var _eventBusDefault = parcelHelpers.interopDefault(_eventBus);
//@ts-ignore
var _workletTs = require("worklet:../PassThrough/worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const passThroughWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/AudioInput/audioNode.ts");
const getAudioInputsList = async ()=>{
    return navigator.mediaDevices.enumerateDevices().then((devices)=>devices.filter(({ kind })=>kind === "audioinput")).catch((e)=>{
        console.log("Could not access your audio devices.", e);
        return [];
    });
};
const getAudioStream = async (deviceId)=>{
    return navigator.mediaDevices.getUserMedia({
        audio: {
            deviceId
        }
    }).catch((e)=>{
        console.log("Could not access audio device.", e);
        return null;
    });
};
const audioInput = async (audioContext, data)=>{
    var _data_values;
    await audioContext.audioWorklet.addModule(passThroughWorklet);
    const output = new AudioWorkletNode(audioContext, "pass-through-processor");
    const events = new (0, _eventBusDefault.default)();
    let currentInputDeviceId = null;
    let currentInputSource = null;
    await getAudioStream((data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.currentInput) || "default");
    let audioInputs = await getAudioInputsList();
    const updateAudioInputHandler = async ()=>{
        if (currentInputSource) {
            currentInputSource.disconnect();
            currentInputSource.mediaStream.getTracks().forEach((track)=>{
                track.stop();
                track.enabled = false;
            });
        }
        for (var input of audioInputs)if (input.deviceId === currentInputDeviceId) {
            const mediaStream = await getAudioStream(currentInputDeviceId);
            if (mediaStream) {
                currentInputSource = audioContext.createMediaStreamSource(mediaStream);
                currentInputSource.connect(output);
            }
            return;
        }
        currentInputSource = null;
    };
    navigator.mediaDevices.addEventListener("devicechange", async ()=>{
        const newAudioInputs = await getAudioInputsList();
        // For some reason 'devicechange' event gets fired twice
        const audioInputIds = audioInputs.map(({ deviceId })=>deviceId);
        const isEqual = audioInputs.length === newAudioInputs.length && newAudioInputs.every(({ deviceId })=>audioInputIds.includes(deviceId));
        if (!isEqual) {
            audioInputs = newAudioInputs;
            events.trigger("message", {
                name: "inputs-list",
                data: audioInputs
            });
            updateAudioInputHandler();
        }
    });
    updateAudioInputHandler();
    return {
        outputs: {
            output: {
                port: output,
                type: (0, _constants.PortType).Audio
            }
        },
        audioInputs,
        destroy: ()=>{},
        addEventListener: (...args)=>events.addEventListener(...args),
        setValues: ({ currentInput: currentInputValue } = {})=>{
            if (typeof currentInputValue !== "undefined") {
                currentInputDeviceId = currentInputValue;
                updateAudioInputHandler();
            }
        }
    };
};
exports.default = audioInput;

},{"@web-noise/core/constants":"36kMU","../../lib/EventBus":"76U72","worklet:../PassThrough/worklet.ts":"aNNLv","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aNNLv":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("eON9s");

},{}],"6rqgT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t, t1;
const AudioInputWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  color: ${0};
  padding: 0.5rem;

  select {
    box-shadow: inset 0 0 1px ${0};
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.highlight2));
const NoAudioInputsMessage = (0, _react1.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  color: ${0};
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  padding: 0.5rem;
`), ({ theme })=>theme.colors.highlight1));
const NO_DEVICE_OPTION = "none";
const AudioInput = ({ node: props, audioNode, updateNodeValues, full })=>{
    const { data } = props;
    const [audioInputs, setAudioInputs] = (0, _react.useState)([]);
    const { currentInput = null } = data.values || {};
    const inputsChangeHandler = (0, _react.useCallback)((inputs)=>setAudioInputs(()=>inputs), []);
    (0, _react.useEffect)(()=>{
        if (!audioNode) return;
        inputsChangeHandler([
            ...audioNode.audioInputs
        ]);
        const statusEventHandler = (data)=>{
            const { name } = data;
            switch(name){
                case "inputs-list":
                    inputsChangeHandler(data.data);
                    break;
            }
        };
        const unSubscribe = audioNode.addEventListener("message", statusEventHandler);
        return ()=>unSubscribe();
    }, [
        audioNode,
        inputsChangeHandler
    ]);
    const options = (0, _react.useMemo)(()=>[
            {
                label: "None",
                value: NO_DEVICE_OPTION
            },
            ...audioInputs.map(({ deviceId, label })=>({
                    label,
                    subtitle: `Device ID: ${deviceId}`,
                    value: deviceId
                }))
        ], [
        audioInputs
    ]);
    return (0, _jsxRuntime.jsx)(AudioInputWrapper, {
        children: audioInputs.length ? full ? (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
            options: options,
            value: currentInput === null ? NO_DEVICE_OPTION : currentInput,
            onChange: (deviceId)=>updateNodeValues({
                    currentInput: deviceId
                })
        }) : (0, _jsxRuntime.jsx)((0, _components.Select), {
            options: options,
            value: currentInput === null ? NO_DEVICE_OPTION : currentInput,
            onChange: (deviceId)=>updateNodeValues({
                    currentInput: deviceId === NO_DEVICE_OPTION ? null : deviceId
                })
        }) : (0, _jsxRuntime.jsx)(NoAudioInputsMessage, {
            children: "No Audio Inputs available"
        })
    });
};
exports.default = AudioInput;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1W5dh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _core = require("@web-noise/core");
var _audioInput = require("./AudioInput");
var _audioInputDefault = parcelHelpers.interopDefault(_audioInput);
const AudioInputNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    (0, _react.useEffect)(()=>{
        var _node_setValues;
        return node === null || node === void 0 ? void 0 : (_node_setValues = node.setValues) === null || _node_setValues === void 0 ? void 0 : _node_setValues.call(node, data.values);
    }, [
        node,
        data.values
    ]);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _audioInputDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues,
            full: true
        })
    }));
};
exports.default = AudioInputNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core":"8EHNf","./AudioInput":"6rqgT","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gYENu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _distortion = require("./Distortion");
var _distortionDefault = parcelHelpers.interopDefault(_distortion);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _distortionDefault.default),
    node: (0, _nodeDefault.default),
    resizable: true,
    defaultConfig: {
        size: {
            width: 100,
            height: 100
        }
    },
    name: "Distortion",
    description: "Alters the waveform of an input signal to create effects from subtle warmth to heavy fuzz. Uses a waveshaper with dynamically generated curves.",
    info: `# Distortion

A waveshaper-based distortion effect. It modifies the input signal's waveform according to a shaping curve, adding harmonics and saturation.

## Purpose

- Add warmth and character to sounds
- Create aggressive fuzz or overdrive effects
- Simulate analog saturation
`,
    tags: [
        "distortion",
        "effect",
        "waveshaper",
        "fuzz",
        "overdrive",
        "saturation"
    ],
    portsDescription: {
        inputs: {
            input: "The audio signal to be distorted.",
            drive: "Controls the intensity of the distortion.",
            type: `Selects the distortion algorithm.

        Options
        - 0 - Digital Clipper
        - 1 - Analog Warm
        - 2 - Fuzz`
        },
        outputs: {
            output: "The distorted audio signal."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"7QwZn","./Distortion":"cLjoq","./Node":"k7maJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7QwZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "distortion",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"1oxPq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1oxPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distortion", ()=>distortion);
var _constants = require("@web-noise/core/constants");
var _useBroadcast = require("../../lib/useBroadcast");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const distortionWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Distortion/audioNode.ts");
const distortion = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(distortionWorklet);
    const curveGeneratorNode = new AudioWorkletNode(audioContext, "distortion-processor", {
        numberOfOutputs: 0
    });
    curveGeneratorNode.port.start();
    const waveShaper = audioContext.createWaveShaper();
    const channel = new MessageChannel();
    channel.port2.start();
    (0, _useBroadcast.addBroadcastListener)(curveGeneratorNode.port, channel.port1);
    channel.port2.addEventListener("message", ({ data })=>{
        waveShaper.curve = data;
    });
    const type = curveGeneratorNode.parameters.get((0, _types.DistortionParameters).Type);
    return {
        inputs: {
            input: {
                port: waveShaper,
                type: (0, _constants.PortType).Audio
            },
            drive: {
                port: curveGeneratorNode,
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    2
                ],
                defaultValue: 0
            },
            type: {
                port: type,
                type: (0, _constants.PortType).Number,
                range: [
                    type.minValue,
                    type.maxValue
                ],
                defaultValue: type.defaultValue
            }
        },
        outputs: {
            output: {
                port: waveShaper,
                type: (0, _constants.PortType).Audio
            }
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(curveGeneratorNode.port, port);
        }
    };
};
exports.default = distortion;

},{"@web-noise/core/constants":"36kMU","../../lib/useBroadcast":"ekNC4","./types":"8IORH","worklet:./worklet.ts":"h7K6u","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8IORH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DistortionParameters", ()=>DistortionParameters);
var DistortionParameters;
(function(DistortionParameters) {
    DistortionParameters["Type"] = "type";
})(DistortionParameters || (DistortionParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"h7K6u":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jScul");

},{}],"cLjoq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _scope = require("../../components/Scope");
var _scopeDefault = parcelHelpers.interopDefault(_scope);
var _lib = require("@web-noise/core/lib");
let _ = (t)=>t, t;
const DistortionWrapper = (0, _styledDefault.default).div(t || (t = _`
  position: relative;
  width: 100%;
  height: 100%;
  canvas {
    position: absolute;
    width: 70%;
    height: 80%;
    left: 14%;
    top: 10%;
  }
`));
const Distortion = ({ audioNode })=>{
    const theme = (0, _core.useTheme)();
    const channel = (0, _lib.useMessageChannel)();
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        audioNode.registerPort(channel.port1);
    }, [
        audioNode,
        channel
    ]);
    return (0, _jsxRuntime.jsx)(DistortionWrapper, {
        theme: theme,
        children: channel ? (0, _jsxRuntime.jsx)((0, _scopeDefault.default), {
            port: channel.port2,
            color: theme.colors.whitePrimary,
            lineWidth: 6
        }) : null
    });
};
exports.default = Distortion;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","../../components/Scope":"dJVfQ","@web-noise/core/lib":"8cGsd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dJVfQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lib = require("@web-noise/core/lib");
//@ts-ignore
var _rendererWorkerTs = require("worklet:./renderer.worker.ts");
var _rendererWorkerTsDefault = parcelHelpers.interopDefault(_rendererWorkerTs);
const rendererWorker = new URL((0, _rendererWorkerTsDefault.default), "file:///packages/base-nodes/src/components/Scope/index.tsx");
const defaultConfig = {
    minValue: -1,
    maxValue: 1,
    lineWidth: 1,
    color: "white"
};
const Scope = ({ port, color = defaultConfig.color, lineWidth = defaultConfig.lineWidth, minValue = defaultConfig.minValue, maxValue = defaultConfig.maxValue })=>{
    const worker = (0, _lib.useWorker)(rendererWorker);
    const canvasRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const canvasElement = canvasRef.current;
        if (canvasElement && worker) {
            const canvas = canvasElement.transferControlToOffscreen();
            worker.postMessage({
                name: "INIT",
                canvas,
                port
            }, [
                canvas,
                port
            ]);
        }
    }, [
        canvasRef,
        port,
        worker
    ]);
    (0, _react.useEffect)(()=>{
        if (!worker) return;
        worker.postMessage({
            name: "SET_COLOR",
            color
        });
    }, [
        color,
        worker
    ]);
    (0, _react.useEffect)(()=>{
        if (!worker || !lineWidth) return;
        worker.postMessage({
            name: "SET_LINE_WIDTH",
            width: lineWidth
        });
    }, [
        lineWidth,
        worker
    ]);
    (0, _react.useEffect)(()=>{
        if (!worker) return;
        worker.postMessage({
            name: "SET_SCALE",
            minValue,
            maxValue
        });
    }, [
        minValue,
        maxValue,
        worker
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: canvasRef
    });
};
exports.default = Scope;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core/lib":"8cGsd","worklet:./renderer.worker.ts":"eEOpb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eEOpb":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("h9Jr9");

},{}],"k7maJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _distortion = require("./Distortion");
var _distortionDefault = parcelHelpers.interopDefault(_distortion);
const DistortionNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _distortionDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = DistortionNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Distortion":"cLjoq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1MVdR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Frequency Meter",
    description: "Analyzes an audio signal to detect and output its fundamental frequency. Useful for tuning or frequency-driven effects.",
    info: `# Frequency Meter

A pitch detection node that analyzes an audio signal and outputs its fundamental frequency in Hertz (Hz).

## Purpose

- Tune instruments or oscillators
- Create frequency-reactive visuals or effects
- Analyze the pitch of a sound source
`,
    tags: [
        "frequency",
        "tuner",
        "analysis",
        "utility",
        "meter"
    ],
    portsDescription: {
        inputs: {
            input: "The audio signal to be analyzed.",
            method: `Selects the pitch detection algorithm.

        Options
        - 0 - default
        - 1 - yin
        - 2 - mcomb 
        - 3 - schmitt
        - 4 - fcomb 
        - 5 - yinfft
        - 6 - yinfast
        - 7 - specacf
        `,
            fftSize: "The FFT buffer size for analysis.",
            hopSize: "The hop size (analysis interval)."
        },
        outputs: {
            frequency: "The detected frequency in Hz."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"9OpJp","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9OpJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "frequencyMeter",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"d7Z0w","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"d7Z0w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const worklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/FrequencyMeter/audioNode.ts");
const frequencyMeter = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(worklet);
    const frequencyMeter = new AudioWorkletNode(audioContext, "frequency-meter-processor");
    const method = frequencyMeter.parameters.get((0, _types.FrequencyMeterParameters).Method);
    const fftSize = frequencyMeter.parameters.get((0, _types.FrequencyMeterParameters).FFTSize);
    const hopSize = frequencyMeter.parameters.get((0, _types.FrequencyMeterParameters).HopSize);
    return {
        inputs: {
            input: {
                port: frequencyMeter,
                type: (0, _constants.PortType).Audio
            },
            method: {
                port: method,
                type: (0, _constants.PortType).Number,
                range: [
                    method.minValue,
                    method.maxValue
                ],
                defaultValue: method.defaultValue
            },
            fftSize: {
                port: fftSize,
                type: (0, _constants.PortType).Number,
                range: [
                    fftSize.minValue,
                    fftSize.maxValue
                ],
                defaultValue: fftSize.defaultValue
            },
            hopSize: {
                port: hopSize,
                type: (0, _constants.PortType).Number,
                range: [
                    hopSize.minValue,
                    hopSize.maxValue
                ],
                defaultValue: hopSize.defaultValue
            }
        },
        outputs: {
            frequency: {
                port: frequencyMeter,
                type: (0, _constants.PortType).Number
            }
        }
    };
};
exports.default = frequencyMeter;

},{"@web-noise/core/constants":"36kMU","./types":"dcwHU","worklet:./worklet.ts":"ip3IY","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dcwHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FrequencyMeterParameters", ()=>FrequencyMeterParameters);
var FrequencyMeterParameters;
(function(FrequencyMeterParameters) {
    FrequencyMeterParameters["Method"] = "method";
    FrequencyMeterParameters["FFTSize"] = "fftSize";
    FrequencyMeterParameters["HopSize"] = "hopSize";
})(FrequencyMeterParameters || (FrequencyMeterParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ip3IY":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5HeqG");

},{}],"enpQS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _gate = require("./Gate");
var _gateDefault = parcelHelpers.interopDefault(_gate);
var _gateNode = require("./GateNode");
var _gateNodeDefault = parcelHelpers.interopDefault(_gateNode);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const Gate = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _gateNodeDefault.default),
    controlPanelNode: (0, _gateDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Gate",
    description: "A manual gate control that outputs a high (1) or low (0) signal. Can be configured as a momentary button or a toggle switch.",
    info: `# Gate

A UI control that outputs a binary signal (0 or 1). It can function as a momentary trigger or a toggle switch, making it a fundamental tool for manual control and interaction.

## Purpose

- Manually trigger envelopes or sequencers
- Switch between different states in a patch
- Provide a simple on/off control for any parameter

## Values

The node's behavior (momentary vs. toggle) and appearance can be configured in its settings panel.`,
    tags: [
        "gate",
        "trigger",
        "control",
        "ui",
        "button",
        "switch"
    ],
    portsDescription: {
        inputs: {},
        outputs: {
            out: "Outputs a signal of 1 when active and 0 when inactive."
        }
    }
});
exports.default = Gate;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"l8kLV","./Gate":"fna7a","./GateNode":"23NFp","./Config":"hupwW","./defaultConfig":"aaFUl","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"l8kLV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const Gate = {
    type: "gate",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = Gate;

},{"./audioNode":"leMmG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"leMmG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gate", ()=>gate);
var _constants = require("@web-noise/core/constants");
const gate = (audioContext, data)=>{
    var _data_values;
    const constantSource = audioContext.createConstantSource();
    var _data_values_isOpened;
    constantSource.offset.value = +((_data_values_isOpened = data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.isOpened) !== null && _data_values_isOpened !== void 0 ? _data_values_isOpened : false);
    constantSource.start();
    return {
        outputs: {
            out: {
                port: constantSource,
                type: (0, _constants.PortType).Gate,
                range: [
                    0,
                    1
                ],
                defaultValue: 0
            }
        },
        setValues: ({ isOpened } = {})=>{
            typeof isOpened !== "undefined" && constantSource.offset.setValueAtTime(+isOpened, audioContext.currentTime);
        },
        open: ()=>{},
        close: ()=>{}
    };
};
exports.default = gate;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fna7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _gateButtons = require("./GateButtons");
let _ = (t)=>t, t;
const Section = (0, _styledDefault.default).div(t || (t = _`
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  background-color: var(--leva-colors-elevation2);
  padding: 0.4rem 0.5rem;
  height: 100%;
  box-sizing: border-box;
`));
const Gate = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const { isOpened = false } = data.values || {};
    const config = data.config || {};
    const { isToggle } = config;
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data
    ]);
    return (0, _jsxRuntime.jsx)(Section, {
        children: isToggle ? (0, _jsxRuntime.jsx)((0, _gateButtons.ToggleButton), {
            toggled: isOpened,
            onToggle: (isToggled)=>updateNodeValues({
                    isOpened: isToggled
                }),
            config: config
        }) : (0, _jsxRuntime.jsx)((0, _gateButtons.TriggerButton), {
            triggered: isOpened,
            onPressed: ()=>updateNodeValues({
                    isOpened: true
                }),
            onReleased: ()=>updateNodeValues({
                    isOpened: false
                }),
            config: config
        })
    });
};
exports.default = Gate;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","./GateButtons":"b9Qa8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"b9Qa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TriggerButton", ()=>TriggerButton);
parcelHelpers.export(exports, "ToggleButton", ()=>ToggleButton);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react = require("react");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t;
const StyledButton = (0, _styledDefault.default)((0, _components.Button))(t || (t = _`
  width: 100%;
  height: 100%;
  min-height: 1.2rem;
  user-select: none;
  background-color: ${0};
  color: ${0};
  &:active {
    box-shadow: inherit;
    background-color: ${0};
  }
`), ({ color })=>color, ({ textColor })=>textColor, ({ color })=>color);
const TriggerButton = ({ config, triggered, onPressed, onReleased })=>{
    const theme = (0, _core.useTheme)();
    const handlePressed = (0, _react.useCallback)(()=>{
        onPressed();
    }, [
        onPressed
    ]);
    const handleReleased = (0, _react.useCallback)(()=>{
        onReleased();
    }, [
        onReleased
    ]);
    const { label, color, textColor, colorOpened, textColorOpened } = config;
    return (0, _jsxRuntime.jsx)(StyledButton, {
        color: triggered ? colorOpened : color,
        textColor: triggered ? textColorOpened : textColor,
        theme: theme,
        onMouseDown: ()=>handlePressed(),
        onMouseUp: ()=>handleReleased(),
        onMouseOut: ()=>triggered && handleReleased(),
        children: label
    });
};
const ToggleButton = ({ config, onToggle, toggled })=>{
    const theme = (0, _core.useTheme)();
    const { label, color, textColor, labelOpened, colorOpened, textColorOpened } = config;
    return (0, _jsxRuntime.jsx)(StyledButton, {
        color: toggled ? colorOpened : color,
        textColor: toggled ? textColorOpened : textColor,
        theme: theme,
        onClick: ()=>onToggle(!toggled),
        children: toggled ? labelOpened : label
    });
};

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"23NFp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _gate = require("./Gate");
var _gateDefault = parcelHelpers.interopDefault(_gate);
const GateNode = (props)=>{
    const { id, data } = props;
    const theme = (0, _core.useTheme)();
    const { node } = (0, _core.useAudioNode)(id) || {};
    //@TODO type-parametrise useNode<NodeData>
    const { updateNodeValues } = (0, _core.useNode)(id);
    const DEFAULT_CONFIG = {
        label: "open",
        color: theme.colors.accent2,
        textColor: theme.colors.highlight3,
        labelOpened: "close",
        colorOpened: theme.colors.accent3,
        textColorOpened: theme.colors.highlight3,
        isToggle: false
    };
    const config = (0, _objectSpread._)({}, DEFAULT_CONFIG, data.config);
    const propsWithFallback = (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
            config
        })
    });
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _gateDefault.default), {
            node: propsWithFallback,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = GateNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Gate":"fna7a","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hupwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const ConfigMode = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { label, color, textColor, labelOpened, colorOpened, textColorOpened, isToggle } = config;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "label"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.Input), {
                            value: label,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    label: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: color,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    color: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "text color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: textColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    textColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                    children: "Opened State:"
                })
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: colorOpened,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    colorOpened: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "text color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: textColorOpened,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    textColorOpened: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _components.Checker), {
                        label: "is toggle",
                        value: true,
                        checked: isToggle,
                        onChange: (value)=>{
                            console.log(456654, value);
                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                isToggle: value
                            }));
                        }
                    })
                })
            }),
            isToggle && (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "label"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.Input), {
                            value: labelOpened,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    labelOpened: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = ConfigMode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aaFUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    label: "open",
    color: (0, _core.theme).colors.accent2,
    textColor: (0, _core.theme).colors.highlight3,
    labelOpened: "close",
    colorOpened: (0, _core.theme).colors.accent3,
    textColorOpened: (0, _core.theme).colors.highlight3,
    isToggle: false
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8bFVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _gauge = require("./Gauge");
var _gaugeDefault = parcelHelpers.interopDefault(_gauge);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _gaugeDefault.default),
    node: (0, _nodeDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Gauge (Radial Meter)",
    description: "Visualizes a numerical signal as a radial gauge meter. Provides a clear, analog-style display for various values.",
    info: `# Gauge

A graphical meter that displays a single numerical value on a radial gauge. It's perfect for getting a quick visual reading of a signal's level or state.

## Purpose

- Monitor signal levels (e.g., volume, modulation depth)
- Provide visual feedback for control signals
- Create dashboard-like interfaces

## Configuration

The appearance of the gauge, including its range (min/max), ticks, colors, and custom labels, can be extensively customized in the node's configuration panel.`,
    tags: [
        "gauge",
        "meter",
        "visualizer",
        "utility",
        "level",
        "display"
    ],
    portsDescription: {
        inputs: {
            in: "The numerical signal to be displayed on the gauge."
        },
        outputs: {}
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"jPlwt","./Gauge":"6vttB","./Node":"lD8gH","./Config":"8klfk","./defaultConfig":"jDHyz","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jPlwt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("../ValueMeter/audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "gauge",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"../ValueMeter/audioNode":"avWVt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"avWVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "valueMeter", ()=>valueMeter);
var _constants = require("@web-noise/core/constants");
var _useBroadcast = require("../../lib/useBroadcast");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const valueMeterWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/ValueMeter/audioNode.ts");
const valueMeter = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(valueMeterWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "value-meter-processor");
    return {
        inputs: {
            input: {
                port: workletNode,
                type: (0, _constants.PortType).Any
            }
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(workletNode.port, port);
        }
    };
};
exports.default = valueMeter;

},{"@web-noise/core/constants":"36kMU","../../lib/useBroadcast":"ekNC4","worklet:./worklet.ts":"44HcD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"44HcD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8WVNl");

},{}],"6vttB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _lib = require("@web-noise/core/lib");
var _scope = require("./Scope");
var _scopeDefault = parcelHelpers.interopDefault(_scope);
let _ = (t)=>t, t;
const GaugeWrapper = (0, _styledDefault.default).div(t || (t = _`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${0};
  canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`), ({ backgroundColor })=>backgroundColor);
const Gauge = ({ node: props, audioNode })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const channel = (0, _lib.useMessageChannel)();
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        audioNode.registerPort(channel.port1);
    }, [
        audioNode,
        channel
    ]);
    const { backgroundColor } = data.config || {};
    return (0, _jsxRuntime.jsx)(GaugeWrapper, {
        theme: theme,
        backgroundColor: backgroundColor,
        children: channel ? (0, _jsxRuntime.jsx)((0, _scopeDefault.default), {
            port: channel.port2,
            config: data.config
        }) : null
    });
};
exports.default = Gauge;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@web-noise/core/lib":"8cGsd","./Scope":"9LekS","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9LekS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lib = require("@web-noise/core/lib");
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
var _types = require("./types");
//@ts-ignore
var _rendererWorkerTs = require("worklet:./renderer.worker.ts");
var _rendererWorkerTsDefault = parcelHelpers.interopDefault(_rendererWorkerTs);
const rendererWorker = new URL((0, _rendererWorkerTsDefault.default), "file:///packages/base-nodes/src/webNoise/Gauge/Scope.tsx");
const Scope = ({ port, config = (0, _defaultConfigDefault.default) })=>{
    const worker = (0, _lib.useWorker)(rendererWorker);
    const canvasRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const canvasElement = canvasRef.current;
        if (canvasElement && worker) {
            const canvas = canvasElement.transferControlToOffscreen();
            const message = {
                name: (0, _types.WorkerEventNames).INIT,
                canvas,
                port
            };
            worker.postMessage(message, [
                canvas,
                port
            ]);
        }
    }, [
        canvasRef,
        port,
        worker
    ]);
    (0, _react.useEffect)(()=>{
        if (!worker) return;
        const message = {
            name: (0, _types.WorkerEventNames).SET_CONFIG,
            config
        };
        worker.postMessage(message);
    }, [
        config,
        worker
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: canvasRef
    });
};
exports.default = Scope;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core/lib":"8cGsd","./defaultConfig":"jDHyz","./types":"2mWQA","worklet:./renderer.worker.ts":"c4mJ5","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jDHyz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    backgroundColor: (0, _core.theme).colors.elevation1,
    min: -1,
    max: 1,
    majorTicks: 10,
    minorTicks: 50,
    labelsInterval: 5,
    arcColor: (0, _core.theme).colors.whitePrimary,
    arrowColor: (0, _core.theme).colors.vivid1,
    ticksColor: (0, _core.theme).colors.elevation2,
    labelsColor: (0, _core.theme).colors.elevation2,
    labels: [],
    size: {
        width: 280,
        height: 120
    }
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2mWQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WorkerEventNames", ()=>WorkerEventNames);
var WorkerEventNames;
(function(WorkerEventNames) {
    WorkerEventNames["INIT"] = "INIT";
    WorkerEventNames["SET_CONFIG"] = "SET_CONFIG";
})(WorkerEventNames || (WorkerEventNames = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"c4mJ5":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("eB3HU");

},{}],"lD8gH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _gauge = require("./Gauge");
var _gaugeDefault = parcelHelpers.interopDefault(_gauge);
const GaugeNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _gaugeDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = GaugeNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Gauge":"6vttB","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8klfk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _md = require("react-icons/md");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t, t1, t2, t3, t4, t5, t6;
const OptionsRow = (0, _styledDefault.default)((0, _components.ConfigRowControl))(t || (t = _`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`));
const OptionsInputLabel = (0, _styledDefault.default).div(t1 || (t1 = _`
  width: 100%;
`));
const OptionRow = (0, _styledDefault.default)((0, _components.ConfigRowControl))(t2 || (t2 = _`
  display: grid;
  grid-template-columns: 3rem 5rem 6rem 1rem;
  grid-template-rows: 1.6rem;
  grid-gap: 0.2rem;
  align-items: center;
  justify-items: end;
  & > * {
    height: 100%;
  }
  input {
    height: 100%;
  }
`));
const OptionValueInput = (0, _styledDefault.default)((0, _components.NumberInput))(t3 || (t3 = _`
  &::after {
    display: none;
  }
  input {
    box-sizing: border-box;
    height: 100%;
    color: inherit;
    padding: 0.2rem 0.4rem;
    text-align: left;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin-right: 0;
    }
  }
`));
const OptionLabelInput = (0, _styledDefault.default)((0, _components.Input))(t4 || (t4 = _`
  input {
    padding-right: 0.2rem;
  }
`));
const OptionLabelColor = (0, _styledDefault.default)((0, _components.ColorInput))(t5 || (t5 = _`
  gap: 0.2rem;
  input {
    padding-right: 0;
  }
`));
const DeleteOptionIcon = (0, _styledDefault.default)((0, _md.MdDelete))(t6 || (t6 = _`
  cursor: pointer;
  color: ${0};
  &:hover {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.whitePrimary);
const GaugeConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { min, max, majorTicks, minorTicks, labelsInterval, backgroundColor, arcColor, arrowColor, ticksColor, labelsColor, labels = [] } = data.config || {};
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "min"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: min,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    min: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "max"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: max,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    max: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "major ticks"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            min: 0,
                            value: majorTicks,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    majorTicks: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "minor ticks"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            min: 0,
                            value: minorTicks,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    minorTicks: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "labels interval"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            min: 0,
                            value: labelsInterval,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    labelsInterval: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Background Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: backgroundColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    backgroundColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Arc Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: arcColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    arcColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Arrow Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: arrowColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    arrowColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Ticks Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: ticksColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    ticksColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Labels Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: labelsColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    labelsColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (labels === null || labels === void 0 ? void 0 : labels.length) ? (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsxs)(OptionRow, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)(OptionsInputLabel, {
                                children: "value"
                            }),
                            (0, _jsxRuntime.jsx)(OptionsInputLabel, {
                                children: "label"
                            }),
                            (0, _jsxRuntime.jsx)(OptionsInputLabel, {
                                children: "color"
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)(OptionsRow, {
                        theme: theme,
                        children: labels === null || labels === void 0 ? void 0 : labels.map(({ label, value, color }, optionIndex)=>(0, _jsxRuntime.jsxs)(OptionRow, {
                                theme: theme,
                                children: [
                                    (0, _jsxRuntime.jsx)(OptionValueInput, {
                                        placeholder: "value",
                                        value: value,
                                        onChange: (newValue)=>{
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                labels: labels.map((item, index)=>index === optionIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                                                        value: newValue
                                                    }) : item)
                                            }));
                                        }
                                    }),
                                    (0, _jsxRuntime.jsx)(OptionLabelInput, {
                                        placeholder: "label",
                                        value: label || "",
                                        onChange: (newValue)=>{
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                labels: labels.map((item, index)=>index === optionIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                                                        label: newValue
                                                    }) : item)
                                            }));
                                        }
                                    }),
                                    (0, _jsxRuntime.jsx)(OptionLabelColor, {
                                        value: color || "",
                                        onChange: (newValue)=>{
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                labels: labels.map((item, index)=>index === optionIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                                                        color: newValue
                                                    }) : item)
                                            }));
                                        }
                                    }),
                                    (0, _jsxRuntime.jsx)(DeleteOptionIcon, {
                                        theme: theme,
                                        onClick: ()=>{
                                            const filteredLabels = labels.filter((_item, index)=>index !== optionIndex);
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                labels: filteredLabels
                                            }));
                                        }
                                    })
                                ]
                            }, optionIndex))
                    })
                ]
            }) : null,
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _components.Button), {
                        theme: theme,
                        onClick: ()=>updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                labels: [
                                    ...labels,
                                    {}
                                ]
                            })),
                        children: "Add Label"
                    })
                })
            })
        ]
    });
};
exports.default = GaugeConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react-icons/md":"ixP1W","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2OpoD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Limiter",
    description: "Prevents an audio signal from exceeding a hard-coded threshold, avoiding clipping. Ideal for mastering or bus processing.",
    info: `# Limiter

A peak limiter that prevents an audio signal from exceeding a specific level. It's a crucial tool for controlling dynamics and preventing distortion on a master bus or individual tracks.

## Purpose

- Prevent digital clipping and distortion
- Increase the overall loudness of a track (when used with makeup gain, not included)
- Protect speakers and listeners from sudden loud peaks

## Values

This limiter has a fixed internal threshold and release time. It does not expose any user-configurable parameters.`,
    tags: [
        "limiter",
        "dynamics",
        "effect",
        "mastering",
        "compressor",
        "peak"
    ],
    portsDescription: {
        inputs: {
            input: "The audio signal to be limited."
        },
        outputs: {
            output: "The limited audio signal."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"7sp4y","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7sp4y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "limiter",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"d3pdx","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"d3pdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "limiter", ()=>limiter);
var _constants = require("@web-noise/core/constants");
//@ts-ignore
var _indexTs = require("worklet:./worklet/index.ts");
var _indexTsDefault = parcelHelpers.interopDefault(_indexTs);
const limiterWorklet = new URL((0, _indexTsDefault.default), "file:///packages/base-nodes/src/webNoise/Limiter/audioNode.ts");
const limiter = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(limiterWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "limiter-processor", {
        channelCountMode: "explicit",
        outputChannelCount: [
            2
        ],
        channelCount: 2
    });
    return {
        inputs: {
            input: {
                port: workletNode,
                type: (0, _constants.PortType).Audio
            }
        },
        outputs: {
            output: {
                port: workletNode,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = limiter;

},{"@web-noise/core/constants":"36kMU","worklet:./worklet/index.ts":"drSqS","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"drSqS":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2SinS");

},{}],"inRvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _mathNode = require("./MathNode");
var _mathNodeDefault = parcelHelpers.interopDefault(_mathNode);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _mathNodeDefault.default),
    name: "Math Expression",
    description: "Evaluates a user-defined math expression with multiple inputs. Enables complex custom signal processing and logic.",
    info: `# Math Expression

A powerful node that processes signals using a custom math expression. It provides several inputs that can be used as variables in your code.

## Purpose

- Perform complex mathematical operations on signals
- Create custom mixers, crossfaders, or logic gates
- Implement custom synthesis or effect algorithms

## Variables
- Standard JavaScript \`Math\` object functions are available (e.g., \`Math.sin()\`, \`Math.max()\`).

## Example

\`(A * X) + (B * (1 - X))\`
This expression crossfades between signals A and B using X as the control.`,
    tags: [
        "math",
        "expression",
        "scripting",
        "logic",
        "utility",
        "processor"
    ],
    portsDescription: {
        inputs: {
            A: "Audio-rate input 'A'.",
            B: "Audio-rate input 'B'.",
            C: "Audio-rate input 'C'.",
            X: "Control-rate input 'X'.",
            Y: "Control-rate input 'Y'.",
            Z: "Control-rate input 'Z'.",
            INPUT: "Main audio-rate input."
        },
        outputs: {
            out: "The result of the evaluated expression."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"ieoiw","./MathNode":"gIxs4","./Node":"c0huQ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ieoiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "mathNode",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"1Mqr1","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1Mqr1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mathNode", ()=>mathNode);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const mathNodeWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/MathNode/audioNode.ts");
const mathNode = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(mathNodeWorklet);
    const mathNode = new AudioWorkletNode(audioContext, "math-node-processor");
    const A = mathNode.parameters.get((0, _types.MathNodeParameters).A);
    const B = mathNode.parameters.get((0, _types.MathNodeParameters).B);
    const C = mathNode.parameters.get((0, _types.MathNodeParameters).C);
    const X = mathNode.parameters.get((0, _types.MathNodeParameters).X);
    const Y = mathNode.parameters.get((0, _types.MathNodeParameters).Y);
    const Z = mathNode.parameters.get((0, _types.MathNodeParameters).Z);
    return {
        outputs: {
            out: {
                port: mathNode,
                type: (0, _constants.PortType).Any
            }
        },
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Number,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Number,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            },
            C: {
                port: C,
                type: (0, _constants.PortType).Number,
                range: [
                    C.minValue,
                    C.maxValue
                ],
                defaultValue: C.value
            },
            X: {
                port: X,
                type: (0, _constants.PortType).Number,
                range: [
                    X.minValue,
                    X.maxValue
                ],
                defaultValue: X.value
            },
            Y: {
                port: Y,
                type: (0, _constants.PortType).Number,
                range: [
                    Y.minValue,
                    Y.maxValue
                ],
                defaultValue: Y.value
            },
            Z: {
                port: Z,
                type: (0, _constants.PortType).Number,
                range: [
                    Z.minValue,
                    Z.maxValue
                ],
                defaultValue: Z.value
            },
            INPUT: {
                port: mathNode,
                type: (0, _constants.PortType).Any
            }
        },
        setValues: ({ expression } = {})=>expression && mathNode.port.postMessage({
                name: "expression",
                value: expression
            })
    };
};
exports.default = mathNode;

},{"@web-noise/core/constants":"36kMU","./types":"6lO6T","worklet:./worklet.ts":"z0CPq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6lO6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MathNodeParameters", ()=>MathNodeParameters);
var MathNodeParameters;
(function(MathNodeParameters) {
    MathNodeParameters["A"] = "A";
    MathNodeParameters["B"] = "B";
    MathNodeParameters["C"] = "C";
    MathNodeParameters["X"] = "X";
    MathNodeParameters["Y"] = "Y";
    MathNodeParameters["Z"] = "Z";
})(MathNodeParameters || (MathNodeParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"z0CPq":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("44l9G");

},{}],"gIxs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _fa = require("react-icons/fa");
var _reactSimpleCodeEditor = require("react-simple-code-editor");
var _reactSimpleCodeEditorDefault = parcelHelpers.interopDefault(_reactSimpleCodeEditor);
//@ts-ignore
var _prismCore = require("prismjs/components/prism-core");
var _prismClike = require("prismjs/components/prism-clike");
var _prismJavascript = require("prismjs/components/prism-javascript");
var _prismOkaidiaCss = require("prismjs/themes/prism-okaidia.css");
var _core = require("@web-noise/core");
let _ = (t)=>t, t, t1, t2, t3;
const MathNodeWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  display: flex;
  flex-direction: row;
  gap: 0.25rem;
  padding: 0.125rem;
  background: ${0};
  align-items: center;
`), ({ theme })=>theme.colors.elevation2));
const EditorWrapper = (0, _react1.withTheme)((0, _styledDefault.default)((0, _reactSimpleCodeEditorDefault.default))(t1 || (t1 = _`
  color: white;
  min-width: 10rem;
  background-color: ${0};
  border-radius: 3px;
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
`), ({ theme })=>theme.colors.elevation3));
const IconWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t2 || (t2 = _`
  cursor: pointer;
  color: ${0};
  &:hover: {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.accent2));
const SetIcon = (0, _react1.withTheme)((0, _styledDefault.default)((0, _fa.FaRegArrowAltCircleRight))(t3 || (t3 = _`
  cursor: pointer;
  color: ${0};
  &:hover {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.accent2));
const MathNode = ({ node: props, audioNode, updateNodeValues })=>{
    const { data, id } = props;
    const theme = (0, _core.useTheme)();
    const { expression = "//expression" } = data.values || {};
    const [value, setValue] = (0, _react.useState)(expression);
    return (0, _jsxRuntime.jsxs)(MathNodeWrapper, {
        children: [
            (0, _jsxRuntime.jsx)(EditorWrapper, {
                theme: theme,
                value: value || "",
                onValueChange: (code)=>setValue(code),
                highlight: (code)=>(0, _prismCore.highlight)(code, (0, _prismCore.languages).js),
                padding: 10
            }),
            (0, _jsxRuntime.jsx)(SetIcon, {
                onClick: ()=>updateNodeValues({
                        expression: value
                    })
            })
        ]
    });
};
exports.default = MathNode;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","react-icons/fa":"lut99","react-simple-code-editor":"1lMOx","prismjs/components/prism-core":"7eCwX","prismjs/components/prism-clike":"4du6W","prismjs/components/prism-javascript":"juL0c","prismjs/themes/prism-okaidia.css":"5w1Pa","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1lMOx":[function(require,module,exports,__globalThis) {
"use strict";
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
var React = __importStar(require("da1552d66d20efa1"));
var KEYCODE_ENTER = 13;
var KEYCODE_TAB = 9;
var KEYCODE_BACKSPACE = 8;
var KEYCODE_Y = 89;
var KEYCODE_Z = 90;
var KEYCODE_M = 77;
var KEYCODE_PARENS = 57;
var KEYCODE_BRACKETS = 219;
var KEYCODE_QUOTE = 222;
var KEYCODE_BACK_QUOTE = 192;
var KEYCODE_ESCAPE = 27;
var HISTORY_LIMIT = 100;
var HISTORY_TIME_GAP = 3000;
var isWindows = typeof window !== 'undefined' && 'navigator' in window && /Win/i.test(navigator.platform);
var isMacLike = typeof window !== 'undefined' && 'navigator' in window && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
var className = 'npm__react-simple-code-editor__textarea';
var cssText = /* CSS */ "\n/**\n * Reset the text fill color so that placeholder is visible\n */\n.".concat(className, ":empty {\n  -webkit-text-fill-color: inherit !important;\n}\n\n/**\n * Hack to apply on some CSS on IE10 and IE11\n */\n@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n  /**\n    * IE doesn't support '-webkit-text-fill-color'\n    * So we use 'color: transparent' to make the text transparent on IE\n    * Unlike other browsers, it doesn't affect caret color in IE\n    */\n  .").concat(className, " {\n    color: transparent !important;\n  }\n\n  .").concat(className, "::selection {\n    background-color: #accef7 !important;\n    color: transparent !important;\n  }\n}\n");
var Editor = /** @class */ function(_super) {
    __extends(Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            capture: true
        };
        _this._recordCurrentState = function() {
            var input = _this._input;
            if (!input) return;
            // Save current state of the input
            var value = input.value, selectionStart = input.selectionStart, selectionEnd = input.selectionEnd;
            _this._recordChange({
                value: value,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd
            });
        };
        _this._getLines = function(text, position) {
            return text.substring(0, position).split('\n');
        };
        _this._recordChange = function(record, overwrite) {
            var _a, _b, _c;
            if (overwrite === void 0) overwrite = false;
            var _d = _this._history, stack = _d.stack, offset = _d.offset;
            if (stack.length && offset > -1) {
                // When something updates, drop the redo operations
                _this._history.stack = stack.slice(0, offset + 1);
                // Limit the number of operations to 100
                var count = _this._history.stack.length;
                if (count > HISTORY_LIMIT) {
                    var extras = count - HISTORY_LIMIT;
                    _this._history.stack = stack.slice(extras, count);
                    _this._history.offset = Math.max(_this._history.offset - extras, 0);
                }
            }
            var timestamp = Date.now();
            if (overwrite) {
                var last = _this._history.stack[_this._history.offset];
                if (last && timestamp - last.timestamp < HISTORY_TIME_GAP) {
                    // A previous entry exists and was in short interval
                    // Match the last word in the line
                    var re = /[^a-z0-9]([a-z0-9]+)$/i;
                    // Get the previous line
                    var previous = (_a = _this._getLines(last.value, last.selectionStart).pop()) === null || _a === void 0 ? void 0 : _a.match(re);
                    // Get the current line
                    var current = (_b = _this._getLines(record.value, record.selectionStart).pop()) === null || _b === void 0 ? void 0 : _b.match(re);
                    if ((previous === null || previous === void 0 ? void 0 : previous[1]) && ((_c = current === null || current === void 0 ? void 0 : current[1]) === null || _c === void 0 ? void 0 : _c.startsWith(previous[1]))) {
                        // The last word of the previous line and current line match
                        // Overwrite previous entry so that undo will remove whole word
                        _this._history.stack[_this._history.offset] = __assign(__assign({}, record), {
                            timestamp: timestamp
                        });
                        return;
                    }
                }
            }
            // Add the new operation to the stack
            _this._history.stack.push(__assign(__assign({}, record), {
                timestamp: timestamp
            }));
            _this._history.offset++;
        };
        _this._updateInput = function(record) {
            var input = _this._input;
            if (!input) return;
            // Update values and selection state
            input.value = record.value;
            input.selectionStart = record.selectionStart;
            input.selectionEnd = record.selectionEnd;
            _this.props.onValueChange(record.value);
        };
        _this._applyEdits = function(record) {
            // Save last selection state
            var input = _this._input;
            var last = _this._history.stack[_this._history.offset];
            if (last && input) _this._history.stack[_this._history.offset] = __assign(__assign({}, last), {
                selectionStart: input.selectionStart,
                selectionEnd: input.selectionEnd
            });
            // Save the changes
            _this._recordChange(record);
            _this._updateInput(record);
        };
        _this._undoEdit = function() {
            var _a = _this._history, stack = _a.stack, offset = _a.offset;
            // Get the previous edit
            var record = stack[offset - 1];
            if (record) {
                // Apply the changes and update the offset
                _this._updateInput(record);
                _this._history.offset = Math.max(offset - 1, 0);
            }
        };
        _this._redoEdit = function() {
            var _a = _this._history, stack = _a.stack, offset = _a.offset;
            // Get the next edit
            var record = stack[offset + 1];
            if (record) {
                // Apply the changes and update the offset
                _this._updateInput(record);
                _this._history.offset = Math.min(offset + 1, stack.length - 1);
            }
        };
        _this._handleKeyDown = function(e) {
            var _a = _this.props, tabSize = _a.tabSize, insertSpaces = _a.insertSpaces, ignoreTabKey = _a.ignoreTabKey, onKeyDown = _a.onKeyDown;
            if (onKeyDown) {
                onKeyDown(e);
                if (e.defaultPrevented) return;
            }
            if (e.keyCode === KEYCODE_ESCAPE) e.currentTarget.blur();
            var _b = e.currentTarget, value = _b.value, selectionStart = _b.selectionStart, selectionEnd = _b.selectionEnd;
            var tabCharacter = (insertSpaces ? ' ' : '\t').repeat(tabSize);
            if (e.keyCode === KEYCODE_TAB && !ignoreTabKey && _this.state.capture) {
                // Prevent focus change
                e.preventDefault();
                if (e.shiftKey) {
                    // Unindent selected lines
                    var linesBeforeCaret = _this._getLines(value, selectionStart);
                    var startLine_1 = linesBeforeCaret.length - 1;
                    var endLine_1 = _this._getLines(value, selectionEnd).length - 1;
                    var nextValue = value.split('\n').map(function(line, i) {
                        if (i >= startLine_1 && i <= endLine_1 && line.startsWith(tabCharacter)) return line.substring(tabCharacter.length);
                        return line;
                    }).join('\n');
                    if (value !== nextValue) {
                        var startLineText = linesBeforeCaret[startLine_1];
                        _this._applyEdits({
                            value: nextValue,
                            // Move the start cursor if first line in selection was modified
                            // It was modified only if it started with a tab
                            selectionStart: (startLineText === null || startLineText === void 0 ? void 0 : startLineText.startsWith(tabCharacter)) ? selectionStart - tabCharacter.length : selectionStart,
                            // Move the end cursor by total number of characters removed
                            selectionEnd: selectionEnd - (value.length - nextValue.length)
                        });
                    }
                } else if (selectionStart !== selectionEnd) {
                    // Indent selected lines
                    var linesBeforeCaret = _this._getLines(value, selectionStart);
                    var startLine_2 = linesBeforeCaret.length - 1;
                    var endLine_2 = _this._getLines(value, selectionEnd).length - 1;
                    var startLineText = linesBeforeCaret[startLine_2];
                    _this._applyEdits({
                        value: value.split('\n').map(function(line, i) {
                            if (i >= startLine_2 && i <= endLine_2) return tabCharacter + line;
                            return line;
                        }).join('\n'),
                        // Move the start cursor by number of characters added in first line of selection
                        // Don't move it if it there was no text before cursor
                        selectionStart: startLineText && /\S/.test(startLineText) ? selectionStart + tabCharacter.length : selectionStart,
                        // Move the end cursor by total number of characters added
                        selectionEnd: selectionEnd + tabCharacter.length * (endLine_2 - startLine_2 + 1)
                    });
                } else {
                    var updatedSelection = selectionStart + tabCharacter.length;
                    _this._applyEdits({
                        // Insert tab character at caret
                        value: value.substring(0, selectionStart) + tabCharacter + value.substring(selectionEnd),
                        // Update caret position
                        selectionStart: updatedSelection,
                        selectionEnd: updatedSelection
                    });
                }
            } else if (e.keyCode === KEYCODE_BACKSPACE) {
                var hasSelection = selectionStart !== selectionEnd;
                var textBeforeCaret = value.substring(0, selectionStart);
                if (textBeforeCaret.endsWith(tabCharacter) && !hasSelection) {
                    // Prevent default delete behaviour
                    e.preventDefault();
                    var updatedSelection = selectionStart - tabCharacter.length;
                    _this._applyEdits({
                        // Remove tab character at caret
                        value: value.substring(0, selectionStart - tabCharacter.length) + value.substring(selectionEnd),
                        // Update caret position
                        selectionStart: updatedSelection,
                        selectionEnd: updatedSelection
                    });
                }
            } else if (e.keyCode === KEYCODE_ENTER) // Ignore selections
            {
                if (selectionStart === selectionEnd) {
                    // Get the current line
                    var line = _this._getLines(value, selectionStart).pop();
                    var matches = line === null || line === void 0 ? void 0 : line.match(/^\s+/);
                    if (matches === null || matches === void 0 ? void 0 : matches[0]) {
                        e.preventDefault();
                        // Preserve indentation on inserting a new line
                        var indent = '\n' + matches[0];
                        var updatedSelection = selectionStart + indent.length;
                        _this._applyEdits({
                            // Insert indentation character at caret
                            value: value.substring(0, selectionStart) + indent + value.substring(selectionEnd),
                            // Update caret position
                            selectionStart: updatedSelection,
                            selectionEnd: updatedSelection
                        });
                    }
                }
            } else if (e.keyCode === KEYCODE_PARENS || e.keyCode === KEYCODE_BRACKETS || e.keyCode === KEYCODE_QUOTE || e.keyCode === KEYCODE_BACK_QUOTE) {
                var chars = void 0;
                if (e.keyCode === KEYCODE_PARENS && e.shiftKey) chars = [
                    '(',
                    ')'
                ];
                else if (e.keyCode === KEYCODE_BRACKETS) {
                    if (e.shiftKey) chars = [
                        '{',
                        '}'
                    ];
                    else chars = [
                        '[',
                        ']'
                    ];
                } else if (e.keyCode === KEYCODE_QUOTE) {
                    if (e.shiftKey) chars = [
                        '"',
                        '"'
                    ];
                    else chars = [
                        "'",
                        "'"
                    ];
                } else if (e.keyCode === KEYCODE_BACK_QUOTE && !e.shiftKey) chars = [
                    '`',
                    '`'
                ];
                // If text is selected, wrap them in the characters
                if (selectionStart !== selectionEnd && chars) {
                    e.preventDefault();
                    _this._applyEdits({
                        value: value.substring(0, selectionStart) + chars[0] + value.substring(selectionStart, selectionEnd) + chars[1] + value.substring(selectionEnd),
                        // Update caret position
                        selectionStart: selectionStart,
                        selectionEnd: selectionEnd + 2
                    });
                }
            } else if ((isMacLike ? e.metaKey && e.keyCode === KEYCODE_Z : e.ctrlKey && e.keyCode === KEYCODE_Z) && !e.shiftKey && !e.altKey) {
                e.preventDefault();
                _this._undoEdit();
            } else if ((isMacLike ? e.metaKey && e.keyCode === KEYCODE_Z && e.shiftKey : isWindows ? e.ctrlKey && e.keyCode === KEYCODE_Y : e.ctrlKey && e.keyCode === KEYCODE_Z && e.shiftKey) && !e.altKey) {
                e.preventDefault();
                _this._redoEdit();
            } else if (e.keyCode === KEYCODE_M && e.ctrlKey && (isMacLike ? e.shiftKey : true)) {
                e.preventDefault();
                // Toggle capturing tab key so users can focus away
                _this.setState(function(state) {
                    return {
                        capture: !state.capture
                    };
                });
            }
        };
        _this._handleChange = function(e) {
            var _a = e.currentTarget, value = _a.value, selectionStart = _a.selectionStart, selectionEnd = _a.selectionEnd;
            _this._recordChange({
                value: value,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd
            }, true);
            _this.props.onValueChange(value);
        };
        _this._history = {
            stack: [],
            offset: -1
        };
        _this._input = null;
        return _this;
    }
    Editor.prototype.componentDidMount = function() {
        this._recordCurrentState();
    };
    Object.defineProperty(Editor.prototype, "session", {
        get: function() {
            return {
                history: this._history
            };
        },
        set: function(session) {
            this._history = session.history;
        },
        enumerable: false,
        configurable: true
    });
    Editor.prototype.render = function() {
        var _this = this;
        var _a = this.props, value = _a.value, style = _a.style, padding = _a.padding, highlight = _a.highlight, textareaId = _a.textareaId, textareaClassName = _a.textareaClassName, autoFocus = _a.autoFocus, disabled = _a.disabled, form = _a.form, maxLength = _a.maxLength, minLength = _a.minLength, name = _a.name, placeholder = _a.placeholder, readOnly = _a.readOnly, required = _a.required, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyUp = _a.onKeyUp, /* eslint-disable @typescript-eslint/no-unused-vars */ onKeyDown = _a.onKeyDown, onValueChange = _a.onValueChange, tabSize = _a.tabSize, insertSpaces = _a.insertSpaces, ignoreTabKey = _a.ignoreTabKey, /* eslint-enable @typescript-eslint/no-unused-vars */ preClassName = _a.preClassName, rest = __rest(_a, [
            "value",
            "style",
            "padding",
            "highlight",
            "textareaId",
            "textareaClassName",
            "autoFocus",
            "disabled",
            "form",
            "maxLength",
            "minLength",
            "name",
            "placeholder",
            "readOnly",
            "required",
            "onClick",
            "onFocus",
            "onBlur",
            "onKeyUp",
            "onKeyDown",
            "onValueChange",
            "tabSize",
            "insertSpaces",
            "ignoreTabKey",
            "preClassName"
        ]);
        var contentStyle = {
            paddingTop: typeof padding === 'object' ? padding.top : padding,
            paddingRight: typeof padding === 'object' ? padding.right : padding,
            paddingBottom: typeof padding === 'object' ? padding.bottom : padding,
            paddingLeft: typeof padding === 'object' ? padding.left : padding
        };
        var highlighted = highlight(value);
        return React.createElement("div", __assign({}, rest, {
            style: __assign(__assign({}, styles.container), style)
        }), React.createElement("pre", __assign({
            className: preClassName,
            "aria-hidden": "true",
            style: __assign(__assign(__assign({}, styles.editor), styles.highlight), contentStyle)
        }, typeof highlighted === 'string' ? {
            dangerouslySetInnerHTML: {
                __html: highlighted + '<br />'
            }
        } : {
            children: highlighted
        })), React.createElement("textarea", {
            ref: function(c) {
                return _this._input = c;
            },
            style: __assign(__assign(__assign({}, styles.editor), styles.textarea), contentStyle),
            className: className + (textareaClassName ? " ".concat(textareaClassName) : ''),
            id: textareaId,
            value: value,
            onChange: this._handleChange,
            onKeyDown: this._handleKeyDown,
            onClick: onClick,
            onKeyUp: onKeyUp,
            onFocus: onFocus,
            onBlur: onBlur,
            disabled: disabled,
            form: form,
            maxLength: maxLength,
            minLength: minLength,
            name: name,
            placeholder: placeholder,
            readOnly: readOnly,
            required: required,
            autoFocus: autoFocus,
            autoCapitalize: "off",
            autoComplete: "off",
            autoCorrect: "off",
            spellCheck: false,
            "data-gramm": false
        }), React.createElement("style", {
            dangerouslySetInnerHTML: {
                __html: cssText
            }
        }));
    };
    Editor.defaultProps = {
        tabSize: 2,
        insertSpaces: true,
        ignoreTabKey: false,
        padding: 0
    };
    return Editor;
}(React.Component);
exports.default = Editor;
var styles = {
    container: {
        position: 'relative',
        textAlign: 'left',
        boxSizing: 'border-box',
        padding: 0,
        overflow: 'hidden'
    },
    textarea: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        resize: 'none',
        color: 'inherit',
        overflow: 'hidden',
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        WebkitTextFillColor: 'transparent'
    },
    highlight: {
        position: 'relative',
        pointerEvents: 'none'
    },
    editor: {
        margin: 0,
        border: 0,
        background: 'none',
        boxSizing: 'inherit',
        display: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        fontStyle: 'inherit',
        fontVariantLigatures: 'inherit',
        fontWeight: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: 'inherit',
        tabSize: 'inherit',
        textIndent: 'inherit',
        textRendering: 'inherit',
        textTransform: 'inherit',
        whiteSpace: 'pre-wrap',
        wordBreak: 'keep-all',
        overflowWrap: 'break-word'
    }
};

},{"da1552d66d20efa1":"lXMxO"}],"7eCwX":[function(require,module,exports,__globalThis) {
/// <reference lib="WebWorker"/>
var global = arguments[3];
var _self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}(_self);
if (module.exports) module.exports = Prism;
// hack for components to work correctly in node.js
if (typeof global !== 'undefined') global.Prism = Prism;
 // some additional documentation/types
 /**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */  /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */  /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */  /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ 

},{}],"4du6W":[function(require,module,exports,__globalThis) {
Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};

},{}],"juL0c":[function(require,module,exports,__globalThis) {
Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;

},{}],"5w1Pa":[function() {},{}],"c0huQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _core = require("@web-noise/core");
var _mathNode = require("./MathNode");
var _mathNodeDefault = parcelHelpers.interopDefault(_mathNode);
const MathNodeNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    (0, _react.useEffect)(()=>{
        var _node_setValues;
        return node === null || node === void 0 ? void 0 : (_node_setValues = node.setValues) === null || _node_setValues === void 0 ? void 0 : _node_setValues.call(node, data.values);
    }, [
        node,
        data.values
    ]);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _mathNodeDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = MathNodeNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core":"8EHNf","./MathNode":"gIxs4","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"62aV2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _notes = require("./notes");
var _notesDefault = parcelHelpers.interopDefault(_notes);
const MidiNote = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _selectDefault.default)), {
    type: "midiNote",
    name: "MIDI Note",
    description: "Outputs a constant MIDI note value (0-127) selected from a dropdown list of standard musical notes.",
    info: `# MIDI Note

A specialized version of the Select node, pre-configured with a list of MIDI notes. It provides a user-friendly way to select a specific pitch.

## Purpose

- Set a fixed pitch for an oscillator or synth
- Define notes in a sequence
- Transpose other signals by a specific musical interval

## Values

The dropdown contains a list of notes from A0 to G#9, which correspond to MIDI values 21 through 128.`,
    tags: [
        "midi",
        "note",
        "pitch",
        "control",
        "constant",
        "select"
    ],
    portsDescription: {
        inputs: {},
        outputs: {
            out: "Outputs the selected MIDI note number as a constant signal."
        }
    },
    defaultConfig: {
        placeholder: "Select note",
        options: (0, _notesDefault.default)
    }
});
exports.default = MidiNote;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","../Select":"8qOgQ","./notes":"brHOK","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8qOgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectNode = require("./SelectNode");
var _selectNodeDefault = parcelHelpers.interopDefault(_selectNode);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const Select = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _selectNodeDefault.default),
    controlPanelNode: (0, _selectDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    name: "Select (Value Selector)",
    description: "Outputs a constant signal based on user selection from configurable options. Provides discrete control values for switching between presets, selecting parameters, or generating static control voltages in modular synthesis.",
    info: `# Select

A user-controlled constant value generator that outputs numeric signals based on selection from a predefined list of options. The select node provides a simple interface for choosing between preset values, making it ideal for switching between different parameter settings.

## Purpose

- Switch between preset parameter values
- Select from predefined control voltage levels
- Implement parameter banks with labeled options
- Provide discrete value selection for modulation targets
- Create user-friendly interfaces for complex parameter mappings

## Values

- **Selection**: The currently active option key that determines the output value. When a selection is made, the node looks up the corresponding numeric value from the options list and outputs it as a constant signal.
`,
    tags: [
        "utility",
        "control",
        "selector",
        "constant",
        "preset",
        "switch"
    ],
    portsDescription: {
        inputs: {},
        outputs: {
            out: "Constant signal output corresponding to the value of the currently selected option"
        }
    }
});
exports.default = Select;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Select":"76mbd","./SelectNode":"2ZHQT","./Config":"kdur7","./defaultConfig":"k26lW","./base":"hgISt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"76mbd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("react");
var _components = require("@web-noise/core/components");
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
let _ = (t)=>t, t;
const Section = (0, _styledDefault.default).div(t || (t = _`
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  background-color: var(--leva-colors-elevation2);
  padding: 0.4rem 0.5rem;
  height: 100%;
  box-sizing: border-box;
`));
const Select = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const config = (0, _objectSpread._)({}, (0, _defaultConfigDefault.default), data.config);
    const { options = [], placeholder } = config;
    const { value } = data.values || {};
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data
    ]);
    return (0, _jsxRuntime.jsx)(Section, {
        children: (0, _jsxRuntime.jsx)((0, _components.Select), {
            options: options.map(({ key })=>({
                    value: key,
                    label: key
                })),
            placeholder: placeholder,
            value: value || "",
            onChange: (newValue)=>updateNodeValues({
                    value: newValue
                })
        })
    });
};
exports.default = Select;

},{"@swc/helpers/_/_object_spread":"awBF9","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","react":"lXMxO","@web-noise/core/components":"jYfYj","./defaultConfig":"k26lW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"k26lW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const config = {
    placeholder: "Select value"
};
exports.default = config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2ZHQT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const SelectNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    //@TODO type-parametrise useNode<NodeData>
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = SelectNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Select":"76mbd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kdur7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _md = require("react-icons/md");
var _components = require("@web-noise/core/components");
var _react = require("react");
let _ = (t)=>t, t, t1, t2, t3, t4, t5, t6;
const OptionsRow = (0, _styledDefault.default)((0, _components.ConfigRowControl))(t || (t = _`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`));
const OptionsInputLabel = (0, _styledDefault.default).div(t1 || (t1 = _`
  width: 100%;
`));
const AddOptionButton = (0, _styledDefault.default)((0, _components.Button))(t2 || (t2 = _`
  width: 100%;
`));
const OptionRow = (0, _styledDefault.default)((0, _components.ConfigRowControl))(t3 || (t3 = _`
  display: grid;
  grid-template-columns: 8rem 5rem 1rem;
  grid-template-rows: 1.6rem;
  grid-gap: 0.2rem;
  align-items: center;
  justify-items: end;
  & > * {
    height: 100%;
  }
  input {
    height: 100%;
  }
`));
const OptionValueInput = (0, _styledDefault.default)((0, _components.NumberInput))(t4 || (t4 = _`
  &::after {
    display: none;
  }
  input {
    box-sizing: border-box;
    height: 100%;
    color: inherit;
    padding: 0.2rem 0.4rem;
    text-align: left;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin-right: 0;
    }
  }
`));
const OptionLabelInput = (0, _styledDefault.default)((0, _components.Input))(t5 || (t5 = _`
  input {
    padding-right: 0.2rem;
  }
`));
const DeleteOptionIcon = (0, _styledDefault.default)((0, _md.MdDelete))(t6 || (t6 = _`
  cursor: pointer;
  color: ${0};
  &:hover {
    color: ${0};
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.whitePrimary);
const ConfigMode = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig, updateNodeValues } = (0, _core.useNode)(id);
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { config } = data;
    const { options = [], placeholder = "" } = config || {};
    (0, _react.useEffect)(()=>{
        if (!node || !config) return;
        node.setConfig(config);
    }, [
        config,
        node
    ]);
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "placeholder"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.Input), {
                            value: placeholder,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    placeholder: value
                                }));
                            }
                        })
                    })
                ]
            }),
            options.length ? (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsxs)(OptionRow, {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)(OptionsInputLabel, {
                                children: "label"
                            }),
                            (0, _jsxRuntime.jsx)(OptionsInputLabel, {
                                children: "value"
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsx)(OptionsRow, {
                        theme: theme,
                        children: options.map(({ key, value }, optionIndex)=>(0, _jsxRuntime.jsxs)(OptionRow, {
                                theme: theme,
                                children: [
                                    (0, _jsxRuntime.jsx)(OptionLabelInput, {
                                        placeholder: "label",
                                        value: key,
                                        onChange: (newValue)=>{
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                options: options.map((item, index)=>index === optionIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                                                        key: newValue
                                                    }) : item)
                                            }));
                                        }
                                    }),
                                    (0, _jsxRuntime.jsx)(OptionValueInput, {
                                        placeholder: "value",
                                        value: value,
                                        onChange: (newValue)=>{
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                options: options.map((item, index)=>index === optionIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                                                        value: newValue
                                                    }) : item)
                                            }));
                                        }
                                    }),
                                    (0, _jsxRuntime.jsx)(DeleteOptionIcon, {
                                        theme: theme,
                                        onClick: ()=>{
                                            var _filteredOptions_find;
                                            const filteredOptions = options.filter((_item, index)=>index !== optionIndex);
                                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                                options: filteredOptions
                                            }));
                                            const newValue = (_filteredOptions_find = filteredOptions.find((item)=>item.key === key)) === null || _filteredOptions_find === void 0 ? void 0 : _filteredOptions_find.key;
                                            updateNodeValues({
                                                value: newValue
                                            });
                                        }
                                    })
                                ]
                            }, optionIndex))
                    })
                ]
            }) : (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                    children: "no options yet"
                })
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)(AddOptionButton, {
                        theme: theme,
                        onClick: ()=>updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                options: [
                                    ...options,
                                    {
                                        key: `option ${options.length + 1}`,
                                        value: 0
                                    }
                                ]
                            })),
                        children: "Add Option"
                    })
                })
            })
        ]
    });
};
exports.default = ConfigMode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@emotion/styled":"2Zr0D","react-icons/md":"ixP1W","@web-noise/core/components":"jYfYj","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hgISt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const Select = {
    type: "select",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = Select;

},{"./audioNode":"2oW88","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2oW88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "select", ()=>select);
var _constants = require("@web-noise/core/constants");
const select = async (audioContext, data)=>{
    var _data_config, _data_values;
    let currentOptions = data === null || data === void 0 ? void 0 : (_data_config = data.config) === null || _data_config === void 0 ? void 0 : _data_config.options;
    let currentValue = data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.value;
    const constantSource = audioContext.createConstantSource();
    constantSource.start();
    const updateValue = ()=>{
        constantSource.offset.value = 0;
        if (!currentOptions) return;
        const { value } = currentOptions.find(({ key })=>key === currentValue) || {};
        if (typeof value === "undefined") return;
        constantSource.offset.value = value;
    };
    updateValue();
    return {
        outputs: {
            out: {
                port: constantSource,
                type: (0, _constants.PortType).Number,
                range: [
                    constantSource.offset.minValue,
                    constantSource.offset.maxValue
                ],
                defaultValue: constantSource.offset.value
            }
        },
        setValues: ({ value } = {})=>{
            if (typeof value !== "undefined") {
                currentValue = value;
                updateValue();
            }
        },
        setConfig: ({ options } = {})=>{
            if (typeof options !== "undefined") {
                currentOptions = options;
                updateValue();
            }
        }
    };
};
exports.default = select;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"brHOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const notes = [
    {
        key: "G#9/Ab9",
        value: 128
    },
    {
        key: "G9",
        value: 127
    },
    {
        key: "F#9/Gb9",
        value: 126
    },
    {
        key: "F9",
        value: 125
    },
    {
        key: "E9",
        value: 124
    },
    {
        key: "D#9/Eb9",
        value: 123
    },
    {
        key: "D9",
        value: 122
    },
    {
        key: "C#9/Db9",
        value: 121
    },
    {
        key: "C9",
        value: 120
    },
    {
        key: "B8",
        value: 119
    },
    {
        key: "A#8/Bb8",
        value: 118
    },
    {
        key: "A8",
        value: 117
    },
    {
        key: "G#8/Ab8",
        value: 116
    },
    {
        key: "G8",
        value: 115
    },
    {
        key: "F#8/Gb8",
        value: 114
    },
    {
        key: "F8",
        value: 113
    },
    {
        key: "E8",
        value: 112
    },
    {
        key: "D#8/Eb8",
        value: 111
    },
    {
        key: "D8",
        value: 110
    },
    {
        key: "C#8/Db8",
        value: 109
    },
    {
        key: "C8",
        value: 108
    },
    {
        key: "B7",
        value: 107
    },
    {
        key: "A#7/Bb7",
        value: 106
    },
    {
        key: "A7",
        value: 105
    },
    {
        key: "G#7/Ab7",
        value: 104
    },
    {
        key: "G7",
        value: 103
    },
    {
        key: "F#7/Gb7",
        value: 102
    },
    {
        key: "F7",
        value: 101
    },
    {
        key: "E7",
        value: 100
    },
    {
        key: "D#7/Eb7",
        value: 99
    },
    {
        key: "D7",
        value: 98
    },
    {
        key: "C#7/Db7",
        value: 97
    },
    {
        key: "C7",
        value: 96
    },
    {
        key: "B6",
        value: 95
    },
    {
        key: "A#6/Bb6",
        value: 94
    },
    {
        key: "A6",
        value: 93
    },
    {
        key: "G#6/Ab6",
        value: 92
    },
    {
        key: "G6",
        value: 91
    },
    {
        key: "F#6/Gb6",
        value: 90
    },
    {
        key: "F6",
        value: 89
    },
    {
        key: "E6",
        value: 88
    },
    {
        key: "D#6/Eb6",
        value: 87
    },
    {
        key: "D6",
        value: 86
    },
    {
        key: "C#6/Db6",
        value: 85
    },
    {
        key: "C6",
        value: 84
    },
    {
        key: "B5",
        value: 83
    },
    {
        key: "A#5/Bb5",
        value: 82
    },
    {
        key: "A5",
        value: 81
    },
    {
        key: "G#5/Ab5",
        value: 80
    },
    {
        key: "G5",
        value: 79
    },
    {
        key: "F#5/Gb5",
        value: 78
    },
    {
        key: "F5",
        value: 77
    },
    {
        key: "E5",
        value: 76
    },
    {
        key: "D#5/Eb5",
        value: 75
    },
    {
        key: "D5",
        value: 74
    },
    {
        key: "C#5/Db5",
        value: 73
    },
    {
        key: "C5",
        value: 72
    },
    {
        key: "B4",
        value: 71
    },
    {
        key: "A#4/Bb4",
        value: 70
    },
    {
        key: "A4 concert pitch",
        value: 69
    },
    {
        key: "G#4/Ab4",
        value: 68
    },
    {
        key: "G4",
        value: 67
    },
    {
        key: "F#4/Gb4",
        value: 66
    },
    {
        key: "F4",
        value: 65
    },
    {
        key: "E4",
        value: 64
    },
    {
        key: "D#4/Eb4",
        value: 63
    },
    {
        key: "D4",
        value: 62
    },
    {
        key: "C#4/Db4",
        value: 61
    },
    {
        key: "C4",
        value: 60
    },
    {
        key: "B3",
        value: 59
    },
    {
        key: "A#3/Bb3",
        value: 58
    },
    {
        key: "A3",
        value: 57
    },
    {
        key: "G#3/Ab3",
        value: 56
    },
    {
        key: "G3",
        value: 55
    },
    {
        key: "F#3/Gb3",
        value: 54
    },
    {
        key: "F3",
        value: 53
    },
    {
        key: "E3",
        value: 52
    },
    {
        key: "D#3/Eb3",
        value: 51
    },
    {
        key: "D3",
        value: 50
    },
    {
        key: "C#3/Db3",
        value: 49
    },
    {
        key: "C3",
        value: 48
    },
    {
        key: "B2",
        value: 47
    },
    {
        key: "A#2/Bb2",
        value: 46
    },
    {
        key: "A2",
        value: 45
    },
    {
        key: "G#2/Ab2",
        value: 44
    },
    {
        key: "G2",
        value: 43
    },
    {
        key: "F#2/Gb2",
        value: 42
    },
    {
        key: "F2",
        value: 41
    },
    {
        key: "E2",
        value: 40
    },
    {
        key: "D#2/Eb2",
        value: 39
    },
    {
        key: "D2",
        value: 38
    },
    {
        key: "C#2/Db2",
        value: 37
    },
    {
        key: "C2",
        value: 36
    },
    {
        key: "B1",
        value: 35
    },
    {
        key: "A#1/Bb1",
        value: 34
    },
    {
        key: "A1",
        value: 33
    },
    {
        key: "G#1/Ab1",
        value: 32
    },
    {
        key: "G1",
        value: 31
    },
    {
        key: "F#1/Gb1",
        value: 30
    },
    {
        key: "F1",
        value: 29
    },
    {
        key: "E1",
        value: 28
    },
    {
        key: "D#1/Eb1",
        value: 27
    },
    {
        key: "D1",
        value: 26
    },
    {
        key: "C#1/Db1",
        value: 25
    },
    {
        key: "C1",
        value: 24
    },
    {
        key: "B0",
        value: 23
    },
    {
        key: "A#0/Bb0",
        value: 22
    },
    {
        key: "A0",
        value: 21
    }
];
exports.default = notes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"17AhU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _oscilloscope = require("./Oscilloscope");
var _oscilloscopeDefault = parcelHelpers.interopDefault(_oscilloscope);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _oscilloscopeDefault.default),
    node: (0, _nodeDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Oscilloscope (Visualizer)",
    description: "Visualizes the waveform of up to two audio signals in real-time. Essential for signal analysis and debugging.",
    info: `# Oscilloscope

A real-time waveform visualizer. The Oscilloscope plots an audio signal's amplitude over time, revealing its shape, frequency, and dynamic range. It can overlay two signals for comparison.

## Purpose

- Analyze the shape of a waveform (e.g., sine, square, sawtooth)
- Debug audio signals and identify issues like clipping
- Compare the input and output of an effect
- Visualize modulation and LFOs

## Configuration

The appearance, including colors, min/max display values, and a grid overlay, can be customized in the node's settings panel.`,
    tags: [
        "oscilloscope",
        "scope",
        "visualizer",
        "analysis",
        "waveform",
        "utility"
    ],
    portsDescription: {
        inputs: {
            input1: "The first audio signal to display.",
            input2: "The second audio signal to display.",
            fftSize: "The analysis window size (buffer size)."
        },
        outputs: {}
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Oscilloscope":"iFUKp","./Node":"bddyV","./base":"2cU47","./Config":"eewpZ","./defaultConfig":"cljzX","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iFUKp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _scope = require("../../components/Scope");
var _scopeDefault = parcelHelpers.interopDefault(_scope);
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
let _ = (t)=>t, t;
const Stage = (0, _styledDefault.default).div(t || (t = _`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${0};
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`), ({ backgroundColor })=>backgroundColor);
const Oscilloscope = ({ node: props, audioNode })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const [ports, setPorts] = (0, _react.useState)();
    const { config = {} } = data;
    const { showGrid, backgroundColor, gridColor = theme.colors.whitePrimary, input1Color = theme.colors.accent2, input2Color = theme.colors.vivid1, minValue, maxValue, gridRows, gridColumns } = config;
    (0, _react.useEffect)(()=>{
        if (!audioNode) return;
        const channel1 = new MessageChannel();
        channel1.port2.start();
        const channel2 = new MessageChannel();
        channel2.port2.start();
        audioNode.registerPorts([
            channel1.port1,
            channel2.port1
        ]);
        setPorts([
            channel1.port2,
            channel2.port2
        ]);
    }, [
        audioNode
    ]);
    if (!ports) return null;
    return (0, _jsxRuntime.jsxs)(Stage, {
        backgroundColor: backgroundColor,
        children: [
            showGrid ? (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                color: gridColor,
                minValue: minValue,
                maxValue: maxValue,
                rows: gridRows,
                columns: gridColumns
            }) : null,
            (0, _jsxRuntime.jsx)((0, _scopeDefault.default), {
                port: ports[0],
                color: input1Color,
                minValue: minValue,
                maxValue: maxValue
            }),
            (0, _jsxRuntime.jsx)((0, _scopeDefault.default), {
                port: ports[1],
                color: input2Color,
                minValue: minValue,
                maxValue: maxValue
            })
        ]
    });
};
exports.default = Oscilloscope;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","../../components/Scope":"dJVfQ","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","./Grid":"gFCYK","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gFCYK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const Grid = ({ color, minValue = (0, _defaultConfigDefault.default).minValue, maxValue = (0, _defaultConfigDefault.default).maxValue, rows = (0, _defaultConfigDefault.default).gridRows, columns = (0, _defaultConfigDefault.default).gridColumns })=>{
    const canvasRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const canvas = canvasRef.current;
        const ctx = canvas === null || canvas === void 0 ? void 0 : canvas.getContext("2d");
        if (!canvas || !ctx) return;
        const { height, width } = canvas;
        ctx.strokeStyle = color;
        ctx.lineWidth = 0.1;
        const xGap = width / columns;
        for(let x = xGap; x < width; x += xGap){
            ctx.beginPath();
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            ctx.stroke();
        }
        const yGap = height / rows;
        for(var y = yGap; y < height; y += yGap){
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }
        ctx.font = "10px serif";
        ctx.fillStyle = color;
        ctx.fillText(maxValue.toString(), 3, 12);
        const middleValue = (maxValue + minValue) / 2;
        ctx.fillText(middleValue.toString(), 3, height / 2 + 12);
        ctx.fillText(minValue.toString(), 2, height - 3);
    }, [
        color,
        canvasRef
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: canvasRef
    });
};
exports.default = Grid;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","./defaultConfig":"cljzX","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cljzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    minValue: -1,
    maxValue: 1,
    backgroundColor: (0, _core.theme).colors.elevation1,
    input1Color: (0, _core.theme).colors.accent2,
    input2Color: (0, _core.theme).colors.vivid1,
    showGrid: false,
    gridColor: (0, _core.theme).colors.whitePrimary,
    gridRows: 4,
    gridColumns: 8,
    size: {
        width: 280,
        height: 150
    }
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bddyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _oscilloscope = require("./Oscilloscope");
var _oscilloscopeDefault = parcelHelpers.interopDefault(_oscilloscope);
let _ = (t)=>t, t;
const OscilloscopeWrapper = (0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
`));
const OscilloscopeNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)(OscilloscopeWrapper, {
            children: (0, _jsxRuntime.jsx)((0, _oscilloscopeDefault.default), {
                node: props,
                audioNode: node,
                updateNodeValues: updateNodeValues
            })
        })
    }));
};
exports.default = OscilloscopeNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","./Oscilloscope":"iFUKp","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2cU47":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "oscilloscope",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"hP3yU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hP3yU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PORTS_AMOUNT", ()=>PORTS_AMOUNT);
parcelHelpers.export(exports, "oscilloscope", ()=>oscilloscope);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _constants = require("@web-noise/core/constants");
var _useBroadcast = require("../../lib/useBroadcast");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const oscilloscopeWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Oscilloscope/audioNode.ts");
const PORTS_AMOUNT = 2;
const oscilloscope = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(oscilloscopeWorklet);
    const analyser = new AudioWorkletNode(audioContext, "oscilloscope-processor", {
        numberOfInputs: PORTS_AMOUNT
    });
    analyser.port.start();
    const fftSize = analyser.parameters.get((0, _types.OscilloscopeParameters).FFTSize);
    return {
        inputs: (0, _objectSpread._)({
            fftSize: {
                port: fftSize,
                type: (0, _constants.PortType).Number,
                defaultValue: fftSize.value
            }
        }, [
            null,
            null
        ].reduce((acc, port, index)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [`input${index + 1}`]: {
                    port: [
                        analyser,
                        index
                    ],
                    type: (0, _constants.PortType).Any
                }
            }), {})),
        registerPorts: (ports)=>{
            ports.forEach((port, index)=>{
                (0, _useBroadcast.addBroadcastListener)(analyser.port, port, index);
            });
        }
    };
};
exports.default = oscilloscope;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core/constants":"36kMU","../../lib/useBroadcast":"ekNC4","./types":"3wwcj","worklet:./worklet.ts":"1XCEd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3wwcj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OscilloscopeParameters", ()=>OscilloscopeParameters);
var OscilloscopeParameters;
(function(OscilloscopeParameters) {
    OscilloscopeParameters["FFTSize"] = "fftSize";
})(OscilloscopeParameters || (OscilloscopeParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1XCEd":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("b6oD5");

},{}],"eewpZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t;
const NumberInputStyled = (0, _styledDefault.default)((0, _components.NumberInput))(t || (t = _`
  display: flex;
  height: 1.5rem;
  &::after {
    display: none;
  }
  input {
    box-sizing: border-box;
    height: 100%;
    color: inherit;
    padding: 0.2rem 0.4rem;
    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
      margin-right: 0;
    }
  }
`));
const OscilloscopeConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { minValue, maxValue, backgroundColor, input1Color, input2Color, showGrid, gridColor, gridRows, gridColumns } = config;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "min value"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)(NumberInputStyled, {
                            theme: theme,
                            value: minValue,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    minValue: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "max value"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)(NumberInputStyled, {
                            theme: theme,
                            value: maxValue,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    maxValue: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Background Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: backgroundColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    backgroundColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Input1 Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: input1Color,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    input1Color: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Input2 Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: input2Color,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    input2Color: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _components.Checker), {
                        label: "Show Grid",
                        value: true,
                        checked: showGrid,
                        onChange: (value)=>{
                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                showGrid: value
                            }));
                        }
                    })
                })
            }),
            showGrid && (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                                children: "Grid Color"
                            }),
                            (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                                theme: theme,
                                children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                                    value: gridColor,
                                    onChange: (value)=>{
                                        updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                            gridColor: value
                                        }));
                                    }
                                })
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                                children: "Rows"
                            }),
                            (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                                theme: theme,
                                children: (0, _jsxRuntime.jsx)(NumberInputStyled, {
                                    theme: theme,
                                    min: 0,
                                    max: 32,
                                    step: 2,
                                    value: gridRows,
                                    onChange: (value)=>{
                                        updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                            gridRows: value
                                        }));
                                    }
                                })
                            })
                        ]
                    }),
                    (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                        theme: theme,
                        children: [
                            (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                                children: "Columns"
                            }),
                            (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                                theme: theme,
                                children: (0, _jsxRuntime.jsx)(NumberInputStyled, {
                                    theme: theme,
                                    min: 0,
                                    max: 64,
                                    step: 2,
                                    value: gridColumns,
                                    onChange: (value)=>{
                                        updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                            gridColumns: value
                                        }));
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = OscilloscopeConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7qavW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Phase Vocoder (Pitch Shifter)",
    description: "Real-time pitch-shifting effect that changes the pitch of audio signals without altering their duration.",
    info: `# Phase Vocoder (Pitch Shifter)

A real-time pitch-shifting processor that transforms audio pitch while preserving timing. The phase vocoder uses spectral analysis to shift frequency components, enabling musical pitch effects without time stretching.

## Purpose

- Shift pitch up or down without changing audio duration
- Create harmony effects by layering pitch-shifted signals
- Transpose musical performances in real-time
- Design unique vocal and instrumental effects
- Correct pitch in recordings while maintaining natural timing
`,
    tags: [
        "pitch",
        "vocoder",
        "effect",
        "frequency",
        "spectral",
        "synthesis"
    ],
    portsDescription: {
        inputs: {
            input: "Audio signal to be pitch-shifted",
            pitch: "Pitch shift factor (multiplier), where 1.0 = no change, 2.0 = one octave up, 0.5 = one octave down.  Values like 1.5 create musical intervals (e.g., perfect fifth). Higher values shift pitch upward, lower values shift pitch downward."
        },
        outputs: {
            output: "Pitch-shifted audio signal with preserved duration"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"iQS6t","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iQS6t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "phaseVocoder",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"hGOjs","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hGOjs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phaseVocoder", ()=>phaseVocoder);
var _constants = require("@web-noise/core/constants");
//@ts-ignore
var _workletPhazeVocoder = require("worklet:phaze-vocoder");
var _workletPhazeVocoderDefault = parcelHelpers.interopDefault(_workletPhazeVocoder);
const phaseVocoderWorklet = new URL((0, _workletPhazeVocoderDefault.default), "file:///packages/base-nodes/src/webNoise/PhaseVocoder/audioNode.ts");
const phaseVocoder = async (audioContext)=>{
    try {
        await audioContext.audioWorklet.addModule(phaseVocoderWorklet);
    } catch (e) {
        console.warn("processor is already registered");
    }
    const phaseVocoderNode = new AudioWorkletNode(audioContext, "phase-vocoder-processor");
    const pitch = phaseVocoderNode.parameters.get("pitchFactor");
    const gainNode = audioContext.createGain();
    gainNode.gain.value = 1;
    phaseVocoderNode.connect(gainNode);
    return {
        inputs: {
            input: {
                port: phaseVocoderNode,
                type: (0, _constants.PortType).Audio
            },
            pitch: {
                port: pitch,
                type: (0, _constants.PortType).Number,
                range: [
                    pitch.minValue,
                    pitch.maxValue
                ],
                defaultValue: pitch.value
            }
        },
        outputs: {
            output: {
                port: gainNode,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = phaseVocoder;

},{"@web-noise/core/constants":"36kMU","worklet:phaze-vocoder":"bElAc","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bElAc":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jVeg1");

},{}],"5Utaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Quantizer (Bit Depth Reducer)",
    description: "Reduces the bit depth of signals",
    info: `# Quantizer (Bit Depth Reducer)

A bit depth reduction processor that creates lo-fi and digital distortion effects by quantizing audio samples. The quantizer reduces audio resolution, producing characteristic digital artifacts ranging from subtle vintage warmth to extreme digital degradation.

## Purpose

- Create lo-fi and retro digital audio effects
- Emulate vintage samplers and digital audio equipment
- Add digital distortion and harmonic content to sounds
- Design aggressive, metallic timbres for electronic music
- Produce bit-crushed effects for sound design
`,
    tags: [
        "bitcrusher",
        "distortion",
        "lo-fi",
        "effect",
        "digital",
        "quantization"
    ],
    portsDescription: {
        inputs: {
            input: "Audio signal to be quantized",
            bitDepth: "Number of bits for quantization (1-16), where lower values create more distortion"
        },
        outputs: {
            output: "Quantized audio signal with reduced bit depth and digital artifacts"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"5zKL3","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5zKL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "quantizer",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"dJ1sf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dJ1sf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quantizer", ()=>quantizer);
var _constants = require("@web-noise/core/constants");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const quantizerWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Quantizer/audioNode.ts");
const quantizer = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(quantizerWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "quantizer-processor");
    const bitDepth = workletNode.parameters.get("bitDepth");
    return {
        inputs: {
            bitDepth: {
                port: bitDepth,
                type: (0, _constants.PortType).Number,
                range: [
                    bitDepth.minValue,
                    bitDepth.maxValue
                ],
                defaultValue: bitDepth.value
            },
            input: {
                port: workletNode,
                type: (0, _constants.PortType).Any
            }
        },
        outputs: {
            output: {
                port: workletNode,
                type: (0, _constants.PortType).Any
            }
        }
    };
};
exports.default = quantizer;

},{"@web-noise/core/constants":"36kMU","worklet:./worklet.ts":"iT0DW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iT0DW":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("h4nf1");

},{}],"gkdLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Scale (Range Mapper)",
    description: "Maps input values from one range to another with linear interpolation. Essential for converting control signals between different parameter ranges, adapting modulation sources, and normalizing sensor or MIDI data for audio processing.",
    info: `# Scale (Range Mapper)

A linear range mapping utility that converts signals from an input range to an output range. The scale node clamps and interpolates values, making it essential for adapting control voltages and modulation signals in modular synthesis environments.

## Purpose

- Convert signals between different parameter ranges
- Adapt LFO or envelope outputs to control specific parameters
- Map MIDI values to audio-rate parameter ranges
- Normalize sensor data for audio processing
- Invert or flip signal ranges by swapping min/max values
`,
    tags: [
        "utility",
        "mapping",
        "scale",
        "range",
        "converter",
        "modulation"
    ],
    portsDescription: {
        inputs: {
            in: "Input signal to be scaled from input range to output range",
            inMin: "Minimum boundary of input range. Values below this are clamped to this minimum.",
            inMax: "Maximum boundary of input range. Values above this are clamped to this maximum.",
            outMin: "Minimum value of output range. The scaled output will never go below this value.",
            outMax: "Maximum value of output range. The scaled output will never exceed this value."
        },
        outputs: {
            out: "Scaled output signal linearly mapped to the output range with clamping"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"65JX3","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"65JX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "scale",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"1kUYr","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1kUYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scale", ()=>scale);
var _constants = require("@web-noise/core/constants");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const scaleWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Scale/audioNode.ts");
const scale = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(scaleWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "scale-processor", {
        numberOfInputs: 5
    });
    return {
        inputs: {
            in: {
                port: [
                    workletNode,
                    0
                ],
                type: (0, _constants.PortType).Any
            },
            inMin: {
                port: [
                    workletNode,
                    1
                ],
                type: (0, _constants.PortType).Number,
                defaultValue: -1
            },
            inMax: {
                port: [
                    workletNode,
                    2
                ],
                type: (0, _constants.PortType).Number,
                defaultValue: 1
            },
            outMin: {
                port: [
                    workletNode,
                    3
                ],
                type: (0, _constants.PortType).Number,
                defaultValue: -1
            },
            outMax: {
                port: [
                    workletNode,
                    4
                ],
                type: (0, _constants.PortType).Number,
                defaultValue: 1
            }
        },
        outputs: {
            out: {
                port: workletNode,
                type: (0, _constants.PortType).Any
            }
        }
    };
};
exports.default = scale;

},{"@web-noise/core/constants":"36kMU","worklet:./worklet.ts":"lrWbG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lrWbG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("dFLHh");

},{}],"1y6oi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _sliderDefault.default),
    node: (0, _nodeDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Slider (Control Value)",
    description: "User-controlled constant value generator with adjustable output. Provides manual control over parameter values through a slider interface, with support for external modulation of the offset parameter for dynamic value changes.",
    info: `# Slider (Control Value)

A user-controlled constant value generator that outputs adjustable signals through a slider interface. The slider provides intuitive manual control over parameter values while supporting external modulation through its offset input.

## Purpose

- Provide manual control over audio parameters like frequency, gain, or filter cutoff
- Create static control voltages with user-adjustable levels
- Serve as a base value that can be modulated by LFOs or envelopes
- Automate parameters through UI interaction
- Generate constant signals for testing and calibration

## Values

The current slider position that determines the base output level. Can be adjusted through the UI or set programmatically. The range is typically configured (default 0-1), but the actual output can exceed this range through modulation.

## Configuration

Adjustable parameters include minimum value (default: 0), maximum value (default: 1), step size (default: 0.1), orientation (horizontal/vertical), visual scale display, and color customization.
`,
    tags: [
        "utility",
        "control",
        "slider",
        "constant",
        "modulation",
        "input"
    ],
    portsDescription: {
        inputs: {
            offset: "AudioParam accepting modulation sources, added to the base slider value"
        },
        outputs: {
            output: "Constant signal output with current slider value plus any offset modulation"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"xIeTR","./Slider":"l52GF","./Node":"2h4KF","./Config":"2A4E0","./defaultConfig":"jBvKO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"xIeTR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "slider",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"1fi3R","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1fi3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slider", ()=>slider);
var _constants = require("@web-noise/core/constants");
const slider = async (audioContext, data)=>{
    var _data_values;
    const constantSource = audioContext.createConstantSource();
    var _data_values_value;
    constantSource.offset.value = (_data_values_value = data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.value) !== null && _data_values_value !== void 0 ? _data_values_value : 0;
    constantSource.start();
    const offset = constantSource.offset;
    return {
        inputs: {
            offset: {
                port: offset,
                type: (0, _constants.PortType).Number,
                range: [
                    offset.minValue,
                    offset.maxValue
                ],
                defaultValue: offset.value
            }
        },
        outputs: {
            output: {
                port: constantSource,
                type: (0, _constants.PortType).Number,
                range: [
                    offset.minValue,
                    offset.maxValue
                ],
                defaultValue: constantSource.offset.value
            }
        },
        setValues: ({ value } = {})=>{
            if (typeof value !== "undefined") constantSource.offset.value = value;
        }
    };
};
exports.default = slider;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"l52GF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _indexCss = require("rc-slider/assets/index.css");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
let _ = (t)=>t, t;
const SliderWrapper = (0, _styledDefault.default).div(t || (t = _`
  display: flex;
  box-sizing: border-box;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 0.6rem;
  background: ${0};
`), ({ theme })=>theme.colors.elevation2);
const Slider = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const { value = 0 } = data.values || {};
    const config = (0, _objectSpread._)({}, (0, _defaultConfigDefault.default), data.config);
    const { min, max, step, isVertical, color, showScale, scaleSteps } = config;
    const marks = (0, _react.useMemo)(()=>{
        if (!showScale) return {};
        if (scaleSteps === 1) return {
            [max]: max
        };
        const step = (max - min) / (scaleSteps - 1);
        return Array.from({
            length: scaleSteps
        }, (_, index)=>min + index * step).reduce((acc, val)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [val]: val.toString().slice(0, 4)
            }), {});
    }, [
        min,
        max,
        showScale,
        scaleSteps
    ]);
    (0, _react.useEffect)(()=>{
        var _audioNode_setValues;
        return audioNode === null || audioNode === void 0 ? void 0 : (_audioNode_setValues = audioNode.setValues) === null || _audioNode_setValues === void 0 ? void 0 : _audioNode_setValues.call(audioNode, data.values);
    }, [
        audioNode,
        data
    ]);
    return (0, _jsxRuntime.jsx)(SliderWrapper, {
        theme: theme,
        children: (0, _jsxRuntime.jsx)((0, _components.Slider), {
            theme: theme,
            color: color,
            min: min,
            max: max,
            step: step,
            marks: marks,
            vertical: isVertical,
            value: value,
            onChange: (value)=>{
                updateNodeValues === null || updateNodeValues === void 0 ? void 0 : updateNodeValues({
                    value
                });
            },
            onChangeComplete: (value)=>{
                updateNodeValues === null || updateNodeValues === void 0 ? void 0 : updateNodeValues({
                    value
                });
            }
        })
    });
};
exports.default = Slider;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","rc-slider/assets/index.css":"jQ3S6","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","./defaultConfig":"jBvKO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jQ3S6":[function() {},{}],"jBvKO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    min: 0,
    max: 1,
    step: 0.1,
    isVertical: false,
    color: (0, _core.theme).colors.accent2,
    showScale: true,
    scaleSteps: 3,
    size: {
        height: 80,
        width: 100
    }
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2h4KF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
const SliderNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _sliderDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = SliderNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Slider":"l52GF","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2A4E0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const SliderConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config } = data;
    const { min, max, step, isVertical, color, showScale, scaleSteps } = config || {};
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Min"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: min,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    min: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Max"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: max,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    max: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Step"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: step,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    step: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: color,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    color: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _components.Checker), {
                        label: "Is vertical",
                        value: true,
                        checked: isVertical,
                        onChange: (value)=>{
                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                isVertical: value
                            }));
                        }
                    })
                })
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _components.Checker), {
                        label: "Show scale",
                        value: true,
                        checked: showScale,
                        onChange: (value)=>{
                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                showScale: value
                            }));
                        }
                    })
                })
            }),
            showScale && (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Scale steps"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            value: scaleSteps,
                            min: 1,
                            max: 25,
                            step: 1,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    scaleSteps: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = SliderConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"zbfLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _spectroscope = require("./Spectroscope");
var _spectroscopeDefault = parcelHelpers.interopDefault(_spectroscope);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _spectroscopeDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Spectroscope (Frequency Analyzer)",
    description: "Real-time frequency spectrum analyzer that visualizes audio frequency content using FFT analysis. Essential for understanding harmonic structure, identifying frequencies, and monitoring spectral balance in mixing and sound design.",
    info: `# Spectroscope (Frequency Analyzer)

A real-time frequency spectrum analyzer that uses Fast Fourier Transform (FFT) to visualize the frequency content of audio signals. The spectroscope provides detailed insight into harmonic structure, overtones, and spectral characteristics.

## Purpose

- Visualize frequency content and harmonic structure of audio signals
- Identify fundamental frequencies and overtones in musical material
- Monitor spectral balance during mixing and mastering
- Analyze resonances and problem frequencies in sound design
- Educational tool for understanding frequency relationships and harmonics

The spectroscope is a non-destructive analysis tool\u{2014}it does not modify the audio signal and has no audio output.`,
    tags: [
        "visualization",
        "analysis",
        "spectrum",
        "frequency",
        "fft",
        "analyzer"
    ],
    portsDescription: {
        inputs: {
            input: "Audio signal to analyze for frequency content",
            fftSize: "FFT window size (default: 2048), must be power of 2, controls frequency vs time resolution"
        },
        outputs: {}
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./Spectroscope":"c9nfW","./Node":"2eVXm","./Config":"7poi1","./defaultConfig":"kWhUL","./base":"eoTQv","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"c9nfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react = require("react");
var _scope = require("./Scope");
var _scopeDefault = parcelHelpers.interopDefault(_scope);
let _ = (t)=>t, t;
const SpectroscopeWrapper = (0, _styledDefault.default).div(t || (t = _`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: ${0};
  canvas {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`), ({ backgroundColor })=>backgroundColor);
const Spectroscope = ({ node: props, audioNode })=>{
    const { data } = props;
    const theme = (0, _core.useTheme)();
    const [port, setPort] = (0, _react.useState)();
    const { backgroundColor, inputColor } = data.config || {};
    (0, _react.useEffect)(()=>{
        if (!audioNode) return;
        const channel = new MessageChannel();
        channel.port2.start();
        audioNode.registerPort(channel.port1);
        setPort(channel.port2);
    }, [
        audioNode
    ]);
    if (!port) return null;
    return (0, _jsxRuntime.jsx)(SpectroscopeWrapper, {
        theme: theme,
        backgroundColor: backgroundColor,
        children: (0, _jsxRuntime.jsx)((0, _scopeDefault.default), {
            port: port,
            color: inputColor
        })
    });
};
exports.default = Spectroscope;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","./Scope":"dz4Bk","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dz4Bk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _lib = require("@web-noise/core/lib");
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
//@ts-ignore
var _rendererWorkerTs = require("worklet:./renderer.worker.ts");
var _rendererWorkerTsDefault = parcelHelpers.interopDefault(_rendererWorkerTs);
const rendererWorker = new URL((0, _rendererWorkerTsDefault.default), "file:///packages/base-nodes/src/webNoise/Spectroscope/Scope.tsx");
const Scope = ({ port, color = (0, _defaultConfigDefault.default).inputColor })=>{
    const worker = (0, _lib.useWorker)(rendererWorker);
    const canvasRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const canvasElement = canvasRef.current;
        if (canvasElement && worker) {
            //@ts-ignore
            const canvas = canvasElement.transferControlToOffscreen();
            worker.postMessage({
                name: "INIT",
                canvas,
                port
            }, [
                canvas,
                port
            ]);
        }
    }, [
        canvasRef,
        port,
        worker
    ]);
    (0, _react.useEffect)(()=>{
        if (!worker) return;
        worker.postMessage({
            name: "SET_COLOR",
            color
        });
    }, [
        color,
        worker
    ]);
    return (0, _jsxRuntime.jsx)("canvas", {
        ref: canvasRef
    });
};
exports.default = Scope;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core/lib":"8cGsd","./defaultConfig":"kWhUL","worklet:./renderer.worker.ts":"gsvgG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kWhUL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    backgroundColor: (0, _core.theme).colors.elevation1,
    inputColor: (0, _core.theme).colors.accent2,
    size: {
        width: 280,
        height: 150
    }
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gsvgG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("23klZ");

},{}],"2eVXm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _spectroscope = require("./Spectroscope");
var _spectroscopeDefault = parcelHelpers.interopDefault(_spectroscope);
const SpectroscopeNode = (props)=>{
    const { id } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _spectroscopeDefault.default), {
            node: props,
            audioNode: node
        })
    }));
};
exports.default = SpectroscopeNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./Spectroscope":"c9nfW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7poi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const SpectroscopeConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { backgroundColor, inputColor } = config;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Background Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: backgroundColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    backgroundColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Input1 Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: inputColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    inputColor: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = SpectroscopeConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eoTQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "spectroscope",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"4bfcg","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4bfcg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spectroscope", ()=>spectroscope);
var _constants = require("@web-noise/core/constants");
var _useBroadcast = require("../../lib/useBroadcast");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const spectroscopeWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Spectroscope/audioNode.ts");
const spectroscope = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(spectroscopeWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "spectroscope-processor");
    const fftSize = workletNode.parameters.get("fftSize");
    return {
        inputs: {
            fftSize: {
                port: fftSize,
                type: (0, _constants.PortType).Number,
                range: [
                    fftSize.minValue,
                    fftSize.maxValue
                ],
                defaultValue: 2048
            },
            input: {
                port: workletNode,
                type: (0, _constants.PortType).Any
            }
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(workletNode.port, port);
        }
    };
};
exports.default = spectroscope;

},{"@web-noise/core/constants":"36kMU","../../lib/useBroadcast":"ekNC4","worklet:./worklet.ts":"4i0lX","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4i0lX":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("8lZLA");

},{}],"45Ue9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _sticker = require("./Sticker");
var _stickerDefault = parcelHelpers.interopDefault(_sticker);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _stickerDefault.default),
    node: (0, _nodeDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    name: "Sticker (Text Annotation)",
    description: "Visual annotation component for displaying Markdown-formatted text notes. Used for documenting patches, labeling signal flows, explaining parameters, and adding instructional content without any audio processing functionality.",
    info: `# Sticker (Text Annotation)

A pure interface component for adding visual annotations and documentation to audio patches. The sticker displays Markdown-formatted text with customizable styling, enabling clear communication of patch design, parameter settings, and usage instructions.

## Purpose

- Document complex signal flows and routing
- Add explanatory notes to patches and presets
- Label sections and groups of related nodes
- Create tutorials and instructional content
- Provide reminders about parameter ranges and settings

The sticker is a visual-only component with no audio inputs or outputs. It exists purely for documentation and annotation purposes.`,
    tags: [
        "documentation",
        "annotation",
        "text",
        "label",
        "interface",
        "markdown"
    ],
    portsDescription: {
        inputs: {},
        outputs: {}
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"lUYLS","./Sticker":"3LamH","./Node":"g14ce","./defaultConfig":"hJwJy","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lUYLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const plugin = {
    type: "sticker",
    audioNode: false,
    node: null
};
exports.default = plugin;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3LamH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _marked = require("marked");
let _ = (t)=>t, t;
const MdPreview = (0, _styledDefault.default).div(t || (t = _`
  font-size: 0.7rem;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: scroll;
  color: ${0};
  background-color: ${0};
  padding: 0 0.5rem;
`), ({ textColor })=>textColor, ({ backgroundColor })=>backgroundColor);
const Sticker = ({ node: props })=>{
    const { data } = props;
    const { text = "*Double click to edit*" } = data.values || {};
    const { transparentBackground, backgroundColor, textColor } = data.config || {};
    return (0, _jsxRuntime.jsx)(MdPreview, {
        backgroundColor: transparentBackground ? "none" : backgroundColor,
        textColor: textColor,
        dangerouslySetInnerHTML: {
            __html: (0, _marked.marked)(text)
        },
        onWheelCapture: (event)=>event.stopPropagation()
    });
};
exports.default = Sticker;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","marked":"cqOOM","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"g14ce":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _reResizable = require("re-resizable");
var _react = require("react");
var _md = require("react-icons/md");
var _core = require("@web-noise/core");
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _sticker = require("./Sticker");
var _stickerDefault = parcelHelpers.interopDefault(_sticker);
let _ = (t)=>t, t, t1, t2, t3, t4, t5;
const StickerNodeWrapper = (0, _styledDefault.default).div(t || (t = _`
  position: relative;
`));
const TitleBarWrapper = (0, _styledDefault.default)((0, _core.TitleBar))(t1 || (t1 = _`
  width: auto;
  height: 100%;
  padding: 0;
  background-color: transparent;

  hr {
    border: none;
    border-bottom: 1px solid var(--leva-colors-elevation3);
  }

  code {
    background-color: var(--leva-colors-elevation3);
  }

  pre {
    background-color: var(--leva-colors-elevation3);
    padding: 0.2rem 0.3rem;
    border-radius: 1px;
  }

  a {
    color: var(--leva-colors-accent1);
  }
`));
const MdEditor = (0, _styledDefault.default).textarea(t2 || (t2 = _`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border: none;
  padding: 0;
  resize: none;
  padding: 0.5rem 0.3rem;
  background: var(--leva-colors-elevation1);
  color: #fff;

  &:focus,
  &:active {
    outline: none;
  }
`));
const StickerWrapper = (0, _styledDefault.default).div(t3 || (t3 = _`
  width: 100%;
  height: 100%;
`));
const SettingsIconWrapper = (0, _styledDefault.default)((0, _md.MdSettings))(t4 || (t4 = _`
  font-size: 1.2rem;
  opacity: 0.4;
  width: 1rem;
  color: ${0};
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
`), ({ theme })=>theme.colors.highlight2);
const Toolbar = (0, _styledDefault.default).div(t5 || (t5 = _`
  position: absolute;
  top: -1.5rem;
`));
const StickerNode = (props)=>{
    const { id, data, selected } = props;
    const { updateNodeValues, updateNodeConfig } = (0, _core.useNode)(id);
    const theme = (0, _core.useTheme)();
    const editorRef = (0, _react.useRef)(null);
    const [editMode, setEditMode] = (0, _react.useState)(false);
    const [configMode, setConfigMode] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!editMode || !editorRef.current) return;
        editorRef.current.focus();
    }, [
        editorRef,
        editMode
    ]);
    (0, _react.useEffect)(()=>{
        if (configMode && !selected) setConfigMode(false);
    }, [
        selected,
        configMode
    ]);
    const { text = `*Double click to edit*` } = data.values || {};
    const { size } = data.config || {};
    const { width = 200, height = 100 } = size || {};
    const [currentValue, setCurrentValue] = (0, _react.useState)(text);
    return (0, _jsxRuntime.jsxs)(StickerNodeWrapper, {
        children: [
            selected && (0, _jsxRuntime.jsx)(Toolbar, {
                theme: theme,
                children: (0, _jsxRuntime.jsx)(SettingsIconWrapper, {
                    theme: theme,
                    onClickCapture: ()=>setConfigMode((isShown)=>!isShown)
                })
            }),
            configMode ? (0, _jsxRuntime.jsx)(TitleBarWrapper, {
                children: (0, _jsxRuntime.jsx)((0, _configDefault.default), (0, _objectSpread._)({}, props))
            }) : (0, _jsxRuntime.jsxs)((0, _reResizable.Resizable), {
                enable: {
                    top: false,
                    right: true,
                    bottom: true,
                    left: false,
                    topRight: false,
                    bottomRight: true,
                    bottomLeft: false,
                    topLeft: false
                },
                minWidth: 100,
                minHeight: 50,
                size: {
                    width,
                    height
                },
                onResizeStop: (e, direction, ref, d)=>{
                    updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, data.config), {
                        size: {
                            width: width + d.width,
                            height: height + d.height
                        }
                    }));
                },
                children: [
                    editMode && (0, _jsxRuntime.jsx)(MdEditor, {
                        ref: editorRef,
                        value: currentValue,
                        onChange: (event)=>setCurrentValue(event.target.value),
                        onBlur: ()=>{
                            updateNodeValues({
                                text: currentValue,
                                width,
                                height
                            });
                            setEditMode(false);
                        },
                        onWheelCapture: (event)=>event.stopPropagation()
                    }),
                    !editMode && (0, _jsxRuntime.jsx)(TitleBarWrapper, {
                        children: (0, _jsxRuntime.jsx)(StickerWrapper, {
                            onDoubleClick: ()=>setEditMode(true),
                            style: editMode ? {
                                display: "none"
                            } : {},
                            children: (0, _jsxRuntime.jsx)((0, _stickerDefault.default), {
                                node: props
                            })
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = StickerNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","re-resizable":"7k9Hb","react":"lXMxO","react-icons/md":"ixP1W","@web-noise/core":"8EHNf","./Config":"ir9ui","./Sticker":"3LamH","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ir9ui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const StickerConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config } = data;
    const { transparentBackground, backgroundColor, textColor } = config || {};
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Text Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: textColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    textColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                    theme: theme,
                    children: (0, _jsxRuntime.jsx)((0, _components.Checker), {
                        label: "Transparent Background",
                        value: true,
                        checked: transparentBackground,
                        onChange: (value)=>{
                            console.log(456654, value);
                            updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                transparentBackground: value
                            }));
                        }
                    })
                })
            }),
            !transparentBackground && (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Background Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: backgroundColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    backgroundColor: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = StickerConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hJwJy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@web-noise/core");
const config = {
    transparentBackground: false,
    backgroundColor: (0, _core.theme).colors.elevation2,
    textColor: (0, _core.theme).colors.whitePrimary,
    size: {
        width: 280,
        height: 150
    }
};
exports.default = config;

},{"@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iz2SM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _valueMeter = require("./ValueMeter");
var _valueMeterDefault = parcelHelpers.interopDefault(_valueMeter);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    controlPanelNode: (0, _valueMeterDefault.default),
    node: (0, _nodeDefault.default),
    name: "Value (Digital) Meter",
    description: "Displays the instantaneous numerical value of an incoming signal. Ideal for monitoring control voltages and modulation.",
    info: `# Value Meter

A simple display that shows the current numerical value of an incoming signal. It's a fundamental tool for monitoring and debugging any data stream within your patch.

## Purpose

- Monitor control signals (e.g., LFOs, envelopes)
- Debug numerical outputs from other nodes
- Provide real-time feedback on parameter values
`,
    tags: [
        "meter",
        "value",
        "display",
        "utility",
        "monitor",
        "debug"
    ],
    portsDescription: {
        inputs: {
            input: "The numerical signal to be displayed."
        },
        outputs: {}
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./ValueMeter":"kLWgE","./Node":"bHkh1","./base":"gxsvS","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kLWgE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
let _ = (t)=>t, t, t1;
const ValueMeterWrapper = (0, _styledDefault.default).div(t || (t = _`
  height: 100%;
`));
const ValueDisplay = (0, _styledDefault.default).input(t1 || (t1 = _`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  text-align: right;
  pointer-events: none;
  outline: none;
  border: none;
  background-color: ${0};
  color: ${0};
  padding: 0.3rem;
  text-overflow: ellipsis;
`), ({ theme })=>theme.colors.elevation2, ({ theme })=>theme.colors.whitePrimary);
const ValueMeter = ({ audioNode })=>{
    const theme = (0, _core.useTheme)();
    const inputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!audioNode || !inputRef.current) return;
        const channel = new MessageChannel();
        channel.port2.start();
        audioNode.registerPort(channel.port1);
        let currentValue = null;
        const handler = ({ data })=>{
            if (data.length === 0) currentValue = null;
            for(let i = 0; i < data.length; i++)currentValue = data[i];
        };
        channel.port2.addEventListener("message", handler);
        const render = ()=>{
            if (!inputRef.current) return;
            inputRef.current.value = currentValue === null ? "" : currentValue.toString();
            requestAnimationFrame(render);
        };
        render();
        return ()=>{
            channel.port2.removeEventListener("message", handler);
        };
    }, [
        audioNode,
        inputRef
    ]);
    return (0, _jsxRuntime.jsx)(ValueMeterWrapper, {
        theme: theme,
        children: (0, _jsxRuntime.jsx)(ValueDisplay, {
            theme: theme,
            readOnly: true,
            ref: inputRef,
            placeholder: "NO DATA"
        })
    });
};
exports.default = ValueMeter;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bHkh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _valueMeter = require("./ValueMeter");
var _valueMeterDefault = parcelHelpers.interopDefault(_valueMeter);
const ValueMeterNode = (props)=>{
    const { id } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _valueMeterDefault.default), {
            node: props,
            audioNode: node
        })
    }));
};
exports.default = ValueMeterNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./ValueMeter":"kLWgE","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gxsvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "valueMeter",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"avWVt","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kj8KJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _core = require("@web-noise/core");
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "MIDI to Frequency Converter",
    description: "Converts MIDI note numbers to their corresponding frequencies in Hertz (Hz). Essential for pitch control from MIDI sources.",
    info: `# MIDI to Frequency

Translates MIDI note numbers (0-127) into audible frequencies (Hz). This node is fundamental for using MIDI pitch information to control oscillators and other frequency-modulated modules.

## Purpose

- Drive oscillators with MIDI keyboards or sequencers
- Create pitch-shifting effects based on MIDI input
- Ensure accurate tuning from MIDI sources

## Inputs

- **MIDI**: The MIDI note number. Standard MIDI notes range from 0 to 127.
- **Tune**: An optional base frequency in Hz. This allows you to adjust the reference pitch (e.g., A4 = 440 Hz). If not connected, it defaults to 440 Hz.`,
    tags: [
        "midi",
        "frequency",
        "pitch",
        "converter",
        "utility",
        "note"
    ],
    portsDescription: {
        inputs: {
            midi: "The incoming MIDI note number (0-127).",
            tune: "Optional: Base frequency in Hz (defaults to 440 Hz)."
        },
        outputs: {
            out: "The calculated frequency in Hertz (Hz)."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"d81lU","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"d81lU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "midiToFrequency",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"hM8H1","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hM8H1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "midiToFrequency", ()=>midiToFrequency);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:../MathNode/worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const sciptNodeWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/MidiToFrequency/audioNode.ts");
const midiToFrequency = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(sciptNodeWorklet);
    const mathNode = new AudioWorkletNode(audioContext, "math-node-processor", {
        processorOptions: {
            expression: "(B ? B : 440) * Math.pow(2, (A - 69) / 12)"
        }
    });
    const midi = mathNode.parameters.get((0, _types.MidiToFrequencyParameters).Midi);
    const tune = mathNode.parameters.get((0, _types.MidiToFrequencyParameters).Tune);
    return {
        outputs: {
            out: {
                port: mathNode,
                type: (0, _constants.PortType).Number
            }
        },
        inputs: {
            midi: {
                port: midi,
                type: (0, _constants.PortType).Number,
                range: [
                    midi.minValue,
                    midi.maxValue
                ],
                defaultValue: midi.value
            },
            tune: {
                port: tune,
                type: (0, _constants.PortType).Number,
                range: [
                    tune.minValue,
                    tune.maxValue
                ],
                defaultValue: 440
            }
        }
    };
};
exports.default = midiToFrequency;

},{"@web-noise/core/constants":"36kMU","./types":"f749Q","worklet:../MathNode/worklet.ts":"z0CPq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f749Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MidiToFrequencyParameters", ()=>MidiToFrequencyParameters);
var MidiToFrequencyParameters;
(function(MidiToFrequencyParameters) {
    MidiToFrequencyParameters["Midi"] = "A";
    MidiToFrequencyParameters["Tune"] = "B";
})(MidiToFrequencyParameters || (MidiToFrequencyParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"41PYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "White Noise  Generator",
    description: "Random noise generator producing white noise with equal energy across all frequencies. Essential for creating percussion sounds, synthesizer textures, wind/ocean effects, and as a modulation source for unpredictable sonic variations.",
    info: `# White Noise Generator

A continuous random noise generator that produces white noise\u{2014}a signal with equal energy distribution across all frequencies. White noise is a fundamental building block in sound synthesis and design, providing raw sonic material for creating various textures and effects.

## Purpose

- Generate raw noise for percussion sounds (snares, hi-hats, cymbals)
- Create wind, ocean, and atmospheric sound effects
- Provide texture and air in synthesizer patches
- Serve as a random modulation source for parameters
- Test audio systems and analyze frequency response


White noise can be filtered to create different colored noises: low-pass filtering creates darker, bass-heavy noise; high-pass filtering creates brighter, thinner noise; band-pass filtering creates focused noise bands useful for specific timbral effects.`,
    tags: [
        "noise",
        "generator",
        "source",
        "white",
        "random",
        "synthesis"
    ],
    portsDescription: {
        inputs: {},
        outputs: {
            out: "White noise audio signal (-1 to 1) with equal energy across all frequencies"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"igcoZ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"igcoZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "whiteNoise",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"2xVCu","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2xVCu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whiteNoise", ()=>whiteNoise);
var _constants = require("@web-noise/core/constants");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const whiteNoiseWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/WhiteNoise/audioNode.ts");
const whiteNoise = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(whiteNoiseWorklet);
    const whiteNoise = new AudioWorkletNode(audioContext, "white-noise-processor");
    return {
        outputs: {
            out: {
                port: whiteNoise,
                type: (0, _constants.PortType).Audio
            }
        }
    };
};
exports.default = whiteNoise;

},{"@web-noise/core/constants":"36kMU","worklet:./worklet.ts":"doE4o","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"doE4o":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("a5jIg");

},{}],"6uvtu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _audioTrack = require("./AudioTrack");
var _audioTrackDefault = parcelHelpers.interopDefault(_audioTrack);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _audioTrackDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Audio Track",
    description: "Plays audio from a URL. Supports looping, playback rate control, and defining playback ranges.",
    info: `# Audio Track

Plays audio from a URL. It's suitable for playing samples, loops, or backing tracks.

## Purpose

- Play audio files
- Create samplers and drum machines
- Control playback with gates and triggers

## Values

- **url**: URL of the audio file to load.

hit Enter or click the arrow button after pasting URL to load the file`,
    tags: [
        "audio",
        "sampler",
        "playback",
        "buffer",
        "track"
    ],
    portsDescription: {
        inputs: {
            gate: "Gate signal to start (>=0.5) and stop (<0.5) playback.",
            restart: "Trigger signal to reset playback to the start of the range.",
            loop: "Toggle looping (0 for off, 1 for on).",
            start: "Playback start time in seconds.",
            end: "Playback end time in seconds.",
            detune: "Playback detune in cents.",
            playbackRate: "Controls the playback speed."
        },
        outputs: {
            out: "The main audio output.",
            gate: "Gate signal indicating if the track is currently playing.",
            duration: "The total duration of the audio in seconds.",
            time: "The current playback time in seconds."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"j2EzB","./AudioTrack":"54gFd","./Node":"dqsOd","./Config":"3qygX","./defaultConfig":"ej6ES","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j2EzB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "audioTrack",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"1ptKb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1ptKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audioTrack", ()=>audioTrack);
var _fetch = require("@web-noise/fetch");
var _fetchDefault = parcelHelpers.interopDefault(_fetch);
var _constants = require("@web-noise/core/constants");
var _eventBus = require("../../lib/EventBus");
var _eventBusDefault = parcelHelpers.interopDefault(_eventBus);
var _useBroadcast = require("../../lib/useBroadcast");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const audioTrackWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/AudioTrack/audioNode.ts");
// @TODO: use loadAudioBuffer from lib
const loadTrack = async (url, audioContext)=>{
    const response = await (0, _fetchDefault.default)(url);
    const arrayBuffer = await response.arrayBuffer();
    return audioContext.decodeAudioData(arrayBuffer);
};
const audioTrack = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(audioTrackWorklet);
    const audioTrack = new AudioWorkletNode(audioContext, "audio-track-processor", {
        numberOfOutputs: 4
    });
    const events = new (0, _eventBusDefault.default)();
    const gate = audioTrack.parameters.get((0, _types.AudioTrackParameters).Gate);
    const restart = audioTrack.parameters.get((0, _types.AudioTrackParameters).Restart);
    const loop = audioTrack.parameters.get((0, _types.AudioTrackParameters).Loop);
    const start = audioTrack.parameters.get((0, _types.AudioTrackParameters).Start);
    const end = audioTrack.parameters.get((0, _types.AudioTrackParameters).End);
    const detune = audioTrack.parameters.get((0, _types.AudioTrackParameters).Detune);
    const playbackRate = audioTrack.parameters.get((0, _types.AudioTrackParameters).PlaybackRate);
    audioTrack.port.start();
    const loadBuffer = async (url)=>{
        events.trigger("status", {
            name: "loading"
        });
        try {
            const buffer = await loadTrack(url, audioContext);
            const { sampleRate, length, duration, numberOfChannels } = buffer;
            const channelData = Array.from({
                length: numberOfChannels
            }, (_, i)=>buffer.getChannelData(i));
            const event = {
                name: "track",
                data: {
                    sampleRate,
                    length,
                    duration,
                    channelData
                }
            };
            audioTrack.port.postMessage(event);
        } catch (e) {
            events.trigger("status", {
                name: "error",
                error: e
            });
        }
        events.trigger("status", {
            name: "loaded"
        });
    };
    return {
        audioTrackWorklet: audioTrack,
        inputs: {
            gate: {
                port: gate,
                type: (0, _constants.PortType).Gate,
                range: [
                    gate.minValue,
                    gate.maxValue
                ],
                defaultValue: gate.defaultValue
            },
            restart: {
                port: restart,
                type: (0, _constants.PortType).Gate,
                range: [
                    restart.minValue,
                    restart.maxValue
                ],
                defaultValue: restart.defaultValue
            },
            loop: {
                port: loop,
                type: (0, _constants.PortType).Gate,
                range: [
                    loop.minValue,
                    loop.maxValue
                ],
                defaultValue: loop.defaultValue
            },
            start: {
                port: start,
                type: (0, _constants.PortType).Number,
                range: [
                    start.minValue,
                    start.maxValue
                ],
                defaultValue: start.defaultValue
            },
            end: {
                port: end,
                type: (0, _constants.PortType).Number,
                range: [
                    end.minValue,
                    end.maxValue
                ],
                defaultValue: end.defaultValue
            },
            detune: {
                port: detune,
                type: (0, _constants.PortType).Number,
                range: [
                    detune.minValue,
                    detune.maxValue
                ],
                defaultValue: detune.defaultValue
            },
            playbackRate: {
                port: playbackRate,
                type: (0, _constants.PortType).Number,
                range: [
                    playbackRate.minValue,
                    playbackRate.maxValue
                ],
                defaultValue: playbackRate.defaultValue
            }
        },
        outputs: {
            out: {
                port: [
                    audioTrack,
                    0
                ],
                type: (0, _constants.PortType).Audio
            },
            gate: {
                port: [
                    audioTrack,
                    1
                ],
                type: (0, _constants.PortType).Gate
            },
            duration: {
                port: [
                    audioTrack,
                    2
                ],
                type: (0, _constants.PortType).Number
            },
            time: {
                port: [
                    audioTrack,
                    3
                ],
                type: (0, _constants.PortType).Number
            }
        },
        setValues: ({ src: srcValue } = {})=>{
            typeof srcValue !== "undefined" && srcValue !== "" && loadBuffer(srcValue);
        },
        destroy: ()=>{
            audioTrack.port.close();
        },
        loadBuffer,
        addEventListener: (...args)=>events.addEventListener(...args),
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(audioTrack.port, port);
            return audioTrack.port;
        }
    };
};
exports.default = audioTrack;

},{"@web-noise/fetch":"aRn3r","@web-noise/core/constants":"36kMU","../../lib/EventBus":"76U72","../../lib/useBroadcast":"ekNC4","./types":"4QD9a","worklet:./worklet.ts":"9Ys1b","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4QD9a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AudioTrackParameters", ()=>AudioTrackParameters);
var AudioTrackParameters;
(function(AudioTrackParameters) {
    AudioTrackParameters["Gate"] = "gate";
    AudioTrackParameters["Restart"] = "restart";
    AudioTrackParameters["Loop"] = "loop";
    AudioTrackParameters["Start"] = "start";
    AudioTrackParameters["End"] = "end";
    AudioTrackParameters["Detune"] = "detune";
    AudioTrackParameters["PlaybackRate"] = "playbackRate";
})(AudioTrackParameters || (AudioTrackParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9Ys1b":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2pRAu");

},{}],"54gFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
var _lib = require("@web-noise/core/lib");
var _wave = require("./Wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
let _ = (t)=>t, t, t1, t2, t3;
const AudioTrackWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _``)));
const Section = (0, _styledDefault.default).div(t1 || (t1 = _`
  font-family: var(--leva-fonts-mono);
  font-size: var(--leva-fontSizes-root);
  background-color: var(--leva-colors-elevation2);
  padding: 0.4rem 0.5rem;
}
`));
const Loader = (0, _react1.withTheme)((0, _styledDefault.default).div(t2 || (t2 = _`
  position: absolute;
  z-index: 1;
  color: ${0};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--leva-fonts-mono);
  background: rgba(0, 0, 0, 0.7);
`), ({ theme })=>theme.colors.whitePrimary));
const SampleInterval = (0, _react1.withTheme)((0, _styledDefault.default).div(t3 || (t3 = _`
  display: grid;
  grid-template-columns: 50% 50%;
  padding: 0.2rem 0.5rem;
  background: ${0};
`), ({ theme })=>theme.colors.elevation2));
const AudioTrack = ({ node: props, audioNode, updateNodeValues })=>{
    const { id, data } = props;
    const projectFiles = (0, _core.useStore)((store)=>store.project.files);
    const [isLoading, setLoading] = (0, _react.useState)(false);
    const channel = (0, _lib.useMessageChannel)();
    const { src = "" } = data.values || {};
    const { waveColor, progressColor, rangeColor } = data.config || {};
    (0, _react.useEffect)(()=>{
        requestAnimationFrame(()=>audioNode === null || audioNode === void 0 ? void 0 : audioNode.setValues({
                src
            }));
    }, [
        src,
        audioNode
    ]);
    (0, _react.useEffect)(()=>{
        if (!audioNode) return;
        const statusEventHandler = (data)=>{
            const { name } = data;
            switch(name){
                case "error":
                    console.error(data.error);
                    break;
                case "loading":
                    setLoading(true);
                    break;
                case "loaded":
                    setLoading(false);
                    break;
            }
        };
        const unSubscribe = audioNode.addEventListener("status", statusEventHandler);
        return ()=>unSubscribe();
    }, [
        audioNode
    ]);
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        const workletPort = audioNode.registerPort(channel.port1);
    }, [
        audioNode,
        channel
    ]);
    return (0, _jsxRuntime.jsxs)(AudioTrackWrapper, {
        children: [
            (0, _jsxRuntime.jsx)(Section, {
                children: (0, _jsxRuntime.jsx)((0, _components.DropdownInput), {
                    value: src,
                    placeholder: "place URL here",
                    onSubmit: (src)=>{
                        updateNodeValues({
                            src
                        });
                    },
                    options: projectFiles.filter((file)=>(0, _core.isAudio)(file)).map(({ id, name, file })=>({
                            value: `project://${id}`,
                            label: name
                        }))
                })
            }),
            (0, _jsxRuntime.jsxs)("div", {
                style: {
                    position: "relative",
                    cursor: "default"
                },
                children: [
                    audioNode && isLoading && (0, _jsxRuntime.jsx)(Loader, {
                        children: "loading"
                    }),
                    audioNode && channel && (0, _jsxRuntime.jsx)((0, _waveDefault.default), {
                        waveColor: waveColor,
                        rangeColor: rangeColor,
                        progressColor: progressColor,
                        port: channel.port2
                    })
                ]
            })
        ]
    });
};
exports.default = AudioTrack;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@web-noise/core/lib":"8cGsd","./Wave":"f0GG8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dqsOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _audioTrack = require("./AudioTrack");
var _audioTrackDefault = parcelHelpers.interopDefault(_audioTrack);
const AudioTrackNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _audioTrackDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = AudioTrackNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./AudioTrack":"54gFd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3qygX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const AudioTrackConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeConfig } = (0, _core.useNode)(id);
    const { config = {} } = data;
    const { waveColor, progressColor, rangeColor } = config;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Wave Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: waveColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    waveColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Progress Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: progressColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    progressColor: value
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Range Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: rangeColor,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    rangeColor: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = AudioTrackConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ej6ES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const config = {
    waveColor: "#007bff",
    progressColor: "#8c92a4",
    rangeColor: "#14df42",
    size: {
        width: 280,
        height: 110
    }
};
exports.default = config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ihbkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _core = require("@web-noise/core");
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Clock",
    description: "Generates a rhythmic trigger signal at a specified tempo (BPM). Essential for sequencing and synchronization.",
    info: `# Clock

A tempo-based trigger generator. The Clock node is the heart of any rhythmic patch, providing a steady pulse for sequencers, drum machines, and other time-based modules.

## Purpose

- Drive sequencers and rhythmic generators
- Synchronize multiple parts of a patch
- Create time-based musical events
`,
    tags: [
        "clock",
        "tempo",
        "bpm",
        "trigger",
        "sequencer",
        "rhythm"
    ],
    portsDescription: {
        inputs: {
            bpm: "The tempo in beats per minute.",
            duty: "The pulse width of the output signal (0-0.99)."
        },
        outputs: {
            trigger: "A trigger signal that fires at the specified BPM."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"2pPUh","@web-noise/core":"8EHNf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2pPUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "clock",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"3Xo2V","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3Xo2V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const clockWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Clock/audioNode.ts");
const clock = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(clockWorklet);
    const clock = new AudioWorkletNode(audioContext, "clock-processor", {
        numberOfOutputs: 1
    });
    const bpm = clock.parameters.get((0, _types.ClockParameters).BPM);
    const duty = clock.parameters.get((0, _types.ClockParameters).Duty);
    return {
        inputs: {
            bpm: {
                port: bpm,
                type: (0, _constants.PortType).Number,
                range: [
                    bpm.minValue,
                    bpm.maxValue
                ],
                defaultValue: bpm.defaultValue
            },
            duty: {
                port: duty,
                type: (0, _constants.PortType).Number,
                range: [
                    duty.minValue,
                    duty.maxValue
                ],
                defaultValue: duty.defaultValue
            }
        },
        outputs: {
            trigger: {
                port: [
                    clock,
                    0
                ],
                type: (0, _constants.PortType).Gate
            }
        }
    };
};
exports.default = clock;

},{"@web-noise/core/constants":"36kMU","./types":"an6pf","worklet:./worklet.ts":"dYACs","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"an6pf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClockParameters", ()=>ClockParameters);
var ClockParameters;
(function(ClockParameters) {
    ClockParameters["BPM"] = "bpm";
    ClockParameters["Duty"] = "duty";
})(ClockParameters || (ClockParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dYACs":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7MGN4");

},{}],"6MFeS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _dataRecorder = require("./DataRecorder");
var _dataRecorderDefault = parcelHelpers.interopDefault(_dataRecorder);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _dataRecorderDefault.default),
    name: "Data Recorder",
    description: "Records raw numerical data from up to two inputs into a downloadable JSON file. Useful for capturing control signals or debugging.",
    info: `# Data Recorder

A utility node for capturing streams of numerical data. Unlike an audio recorder, this node records the raw values from its inputs, making it ideal for logging control signals, analyzing data patterns, or debugging complex patches.

## Purpose

- Record and analyze control voltage (CV) or modulation signals
- Debug data streams within a patch
- Export data for use in external applications or visualizations
`,
    tags: [
        "data",
        "recorder",
        "utility",
        "cv",
        "debugging",
        "logging"
    ],
    portsDescription: {
        inputs: {
            gate: "Gate signal to start (>=0.5) and stop (<0.5) recording.",
            "0": "The first data stream to record.",
            "1": "The second data stream to record."
        },
        outputs: {}
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"6lhep","./DataRecorder":"7zbP4","./Node":"fs6Eb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6lhep":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "dataRecorder",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"ays4m","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ays4m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dataRecorder", ()=>dataRecorder);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
var _useBroadcast = require("../../lib/useBroadcast");
const dataRecorderWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/DataRecorder/audioNode.ts");
const dataRecorder = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(dataRecorderWorklet);
    const dataRecorder = new AudioWorkletNode(audioContext, "data-recorder-processor", {
        numberOfInputs: 2
    });
    const gate = dataRecorder.parameters.get((0, _types.DataRecorderParameters).Gate);
    dataRecorder.port.start();
    return {
        inputs: {
            gate: {
                port: gate,
                type: (0, _constants.PortType).Gate,
                range: [
                    gate.minValue,
                    gate.maxValue
                ],
                defaultValue: gate.defaultValue
            },
            "0": {
                port: [
                    dataRecorder,
                    0
                ],
                type: (0, _constants.PortType).Any
            },
            "1": {
                port: [
                    dataRecorder,
                    1
                ],
                type: (0, _constants.PortType).Any
            }
        },
        destroy: ()=>{
            dataRecorder.port.close();
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(dataRecorder.port, port);
            return dataRecorder.port;
        }
    };
};
exports.default = dataRecorder;

},{"@web-noise/core/constants":"36kMU","./types":"8iVEw","worklet:./worklet.ts":"cKXmg","../../lib/useBroadcast":"ekNC4","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8iVEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DataRecorderParameters", ()=>DataRecorderParameters);
var DataRecorderParameters;
(function(DataRecorderParameters) {
    DataRecorderParameters["Gate"] = "gate";
})(DataRecorderParameters || (DataRecorderParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cKXmg":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1sWlm");

},{}],"7zbP4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _jsFileDownload = require("js-file-download");
var _jsFileDownloadDefault = parcelHelpers.interopDefault(_jsFileDownload);
var _fa = require("react-icons/fa");
var _lib = require("@web-noise/core/lib");
let _ = (t)=>t, t, t1, t2, t3;
const DataRecorderWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  background-color: ${0};
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 0 0.5rem;
`), ({ theme })=>theme.colors.elevation2));
const RecordingIndicator = (0, _react1.withTheme)((0, _styledDefault.default).span(t1 || (t1 = _`
  color: ${0};
  &:after {
    content: "${0}";
  }
`), ({ theme, isRecording })=>isRecording ? theme.colors.accent3 : theme.colors.highlight1, ({ isRecording })=>isRecording ? "\u29BF" : "\u29BE"));
const RecrodingTime = (0, _react1.withTheme)((0, _styledDefault.default).input(t2 || (t2 = _`
  text-align: right;
  pointer-events: none;
  outline: none;
  border: none;
  color: ${0};
  padding: 0.3rem 0;
  background: none;
  text-align: center;
  font-family: var(--leva-fonts-mono);
  width: 100%;
`), ({ isRecording, theme })=>isRecording ? theme.colors.highlight3 : theme.colors.highlight1));
const DownloadButton = (0, _react1.withTheme)((0, _styledDefault.default).button(t3 || (t3 = _`
  display: flex;
  background: none;
  outline: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0;
  &:disabled {
    color: grey;
  }
`)));
const duratinToTime = (duration)=>{
    const m = Math.floor(duration / 60).toString().padStart(2, "0");
    const s = Math.floor(duration % 60).toString().padStart(2, "0");
    const ms = Math.floor(duration % 1 * 100).toString().padStart(2, "0");
    return `${m}:${s}.${ms}`;
};
const DataRecorder = ({ node: props, audioNode, updateNodeValues })=>{
    const { id, data } = props;
    const [isRecording, setIsRecording] = (0, _react.useState)(false);
    const [recorderData, setRecorderData] = (0, _react.useState)();
    const progressDisplayRef = (0, _react.useRef)(null);
    const progressTimeRef = (0, _react.useRef)(null);
    const channel = (0, _lib.useMessageChannel)();
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        audioNode.registerPort(channel.port1);
        channel.port2.addEventListener("message", ({ data })=>{
            switch(data.name){
                case "start":
                    setIsRecording(()=>true);
                    break;
                case "stop":
                    setIsRecording(()=>false);
                    setRecorderData(()=>data.data);
                    break;
                case "progress":
                    if (data.data !== progressTimeRef.current) {
                        window.requestAnimationFrame(()=>{
                            if (!progressDisplayRef.current) return;
                            progressDisplayRef.current.value = duratinToTime(data.data);
                        });
                        //@ts-ignore
                        progressTimeRef.current = data.time;
                    }
                    break;
            }
        });
    }, [
        audioNode,
        channel
    ]);
    return (0, _jsxRuntime.jsxs)(DataRecorderWrapper, {
        children: [
            (0, _jsxRuntime.jsx)(RecordingIndicator, {
                isRecording: isRecording
            }),
            (0, _jsxRuntime.jsx)(RecrodingTime, {
                isRecording: isRecording,
                ref: progressDisplayRef,
                readOnly: true,
                disabled: true,
                defaultValue: duratinToTime(0)
            }),
            (0, _jsxRuntime.jsx)(DownloadButton, {
                disabled: isRecording || !recorderData,
                onClick: ()=>{
                    if (!recorderData) return;
                    const fileName = "data-recorder-session.json";
                    (0, _jsFileDownloadDefault.default)(JSON.stringify((0, _objectSpreadProps._)((0, _objectSpread._)({}, recorderData), {
                        channels: [
                            Array.from(recorderData.channels[0]),
                            Array.from(recorderData.channels[1])
                        ]
                    }), null, 2), fileName);
                },
                children: (0, _jsxRuntime.jsx)((0, _fa.FaFileDownload), {})
            })
        ]
    });
};
exports.default = DataRecorder;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","js-file-download":"3XznK","react-icons/fa":"lut99","@web-noise/core/lib":"8cGsd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fs6Eb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _dataRecorder = require("./DataRecorder");
var _dataRecorderDefault = parcelHelpers.interopDefault(_dataRecorder);
const DataRecorderNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _dataRecorderDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = DataRecorderNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./DataRecorder":"7zbP4","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1SIJB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _midiInput = require("./MidiInput");
var _midiInputDefault = parcelHelpers.interopDefault(_midiInput);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _midiInputDefault.default),
    name: "MIDI Input",
    description: "Receives messages from a connected hardware MIDI device. Outputs command, note, and velocity signals.",
    info: `# MIDI Input

Connects to a hardware MIDI device and translates incoming messages into signals. This node is the bridge between your physical MIDI controllers and the Web Noise environment.

## Purpose

- Play instruments with a MIDI keyboard
- Control parameters with MIDI knobs and faders
- Trigger events from MIDI drum pads
`,
    tags: [
        "midi",
        "input",
        "controller",
        "hardware",
        "keyboard",
        "control"
    ],
    portsDescription: {
        inputs: {},
        outputs: {
            command: "The MIDI status byte (144 for Note On, 224 for Pitch Bend).",
            note: "The first data byte ( MIDI note number).",
            velocity: "The second data byte (note velocity)."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"85DFJ","./MidiInput":"ha2dh","./Node":"1Se3L","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"85DFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "midiInput",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"5cmts","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5cmts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "midiInput", ()=>midiInput);
var _constants = require("@web-noise/core/constants");
var _eventBus = require("../../lib/EventBus");
var _eventBusDefault = parcelHelpers.interopDefault(_eventBus);
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const midiInputWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/MidiInput/audioNode.ts");
const midiInput = async (audioContext, data)=>{
    const events = new (0, _eventBusDefault.default)();
    await audioContext.audioWorklet.addModule(midiInputWorklet);
    const midiInputNode = new AudioWorkletNode(audioContext, "midi-input-processor", {
        numberOfOutputs: 3
    });
    // @ts-ignore
    let currentInputDeviceId = null;
    // @ts-ignore
    const access = await navigator.requestMIDIAccess().catch((e)=>{
        console.log("Could not access your MIDI devices.", e);
        return null;
    });
    // @ts-ignore
    let midiInputs = access ? [
        ...access.inputs.values()
    ] : [];
    // @ts-ignore
    const midiMessageHandler = (event)=>{
        midiInputNode.port.postMessage({
            name: "midimessage",
            value: event.data
        });
    };
    const updateMidiInputHandler = ()=>{
        for (var input of midiInputs){
            input.onmidimessage = ()=>{};
            if (input.id === currentInputDeviceId) input.onmidimessage = midiMessageHandler;
        }
    };
    access === null || access === void 0 ? void 0 : access.addEventListener("statechange", (event)=>{
        midiInputs = [
            ...access.inputs.values()
        ];
        events.trigger("message", {
            name: "inputs-list",
            data: midiInputs
        });
        updateMidiInputHandler();
    });
    updateMidiInputHandler();
    return {
        outputs: {
            command: {
                port: [
                    midiInputNode,
                    0
                ],
                type: (0, _constants.PortType).Number,
                range: [
                    144,
                    224
                ],
                defaultValue: 144
            },
            note: {
                port: [
                    midiInputNode,
                    1
                ],
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    127
                ],
                defaultValue: 0
            },
            velocity: {
                port: [
                    midiInputNode,
                    2
                ],
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    127
                ],
                defaultValue: 0
            }
        },
        midiInputs,
        destroy: ()=>{},
        addEventListener: (...args)=>events.addEventListener(...args),
        setValues: ({ currentInput: currentInputValue } = {})=>{
            if (typeof currentInputValue !== "undefined") {
                currentInputDeviceId = currentInputValue;
                updateMidiInputHandler();
            }
        }
    };
};
exports.default = midiInput;

},{"@web-noise/core/constants":"36kMU","../../lib/EventBus":"76U72","worklet:./worklet.ts":"6DMed","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6DMed":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("lkEev");

},{}],"ha2dh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _components = require("@web-noise/core/components");
let _ = (t)=>t, t, t1, t2;
const MidiInputWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _``)));
const MidiDevicesList = (0, _react1.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: var(--leva-fonts-mono);
  font-size: 0.7rem;
  color: ${0};
  padding: 0.5rem;

  select {
    box-shadow: inset 0 0 1px ${0};
  }
`), ({ theme })=>theme.colors.highlight2, ({ theme })=>theme.colors.highlight2));
const NoMidiDevicesMessage = (0, _react1.withTheme)((0, _styledDefault.default).div(t2 || (t2 = _`
  color: ${0};
`), ({ theme })=>theme.colors.highlight1));
const MidiInput = ({ node: props, audioNode, updateNodeValues, full })=>{
    const { id, data } = props;
    const [midiInputs, setMidiInputs] = (0, _react.useState)([]);
    const { currentInput = null } = data.values || {};
    const inputsChangeHandler = (0, _react.useCallback)((inputs)=>{
        setMidiInputs(()=>inputs);
    }, []);
    (0, _react.useEffect)(()=>{
        if (!audioNode) return;
        inputsChangeHandler([
            ...audioNode.midiInputs
        ]);
        const statusEventHandler = (data)=>{
            const { name } = data;
            switch(name){
                case "inputs-list":
                    inputsChangeHandler(data.data);
                    break;
            }
        };
        const unSubscribe = audioNode.addEventListener("message", statusEventHandler);
        return ()=>unSubscribe();
    }, [
        audioNode,
        inputsChangeHandler
    ]);
    const options = (0, _react.useMemo)(()=>[
            {
                label: "None",
                value: "",
                subtitle: ""
            },
            ...midiInputs.map(({ id, name })=>({
                    label: name || `MIDI Input ${id}`,
                    subtitle: `Device ID: ${id}`,
                    value: id
                }))
        ], [
        midiInputs
    ]);
    return (0, _jsxRuntime.jsx)(MidiInputWrapper, {
        children: (0, _jsxRuntime.jsx)(MidiDevicesList, {
            children: midiInputs.length ? full ? (0, _jsxRuntime.jsx)((0, _components.RadioGroup), {
                options: options,
                value: currentInput || "",
                onChange: (deviceId)=>updateNodeValues({
                        currentInput: deviceId || null
                    })
            }) : (0, _jsxRuntime.jsx)((0, _components.Select), {
                options: options,
                value: currentInput || "",
                onChange: (currentInput)=>updateNodeValues({
                        currentInput: currentInput || null
                    })
            }) : (0, _jsxRuntime.jsx)(NoMidiDevicesMessage, {
                children: "No MIDI devices available"
            })
        })
    });
};
exports.default = MidiInput;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1Se3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _core = require("@web-noise/core");
var _midiInput = require("./MidiInput");
var _midiInputDefault = parcelHelpers.interopDefault(_midiInput);
const MidiInputNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    const { currentInput = null } = data.values || {};
    (0, _react.useEffect)(()=>node === null || node === void 0 ? void 0 : node.setValues({
            currentInput
        }), [
        node,
        data
    ]);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _midiInputDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues,
            full: true
        })
    }));
};
exports.default = MidiInputNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core":"8EHNf","./MidiInput":"ha2dh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lLKAQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _randomSequencer = require("./RandomSequencer");
var _randomSequencerDefault = parcelHelpers.interopDefault(_randomSequencer);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _randomSequencerDefault.default),
    defaultConfig: {},
    name: "Random Sequencer (MIDI Note Generator)",
    description: "Generates random MIDI notes from a pentatonic scale when triggered. Creates generative musical sequences for algorithmic composition and experimental sound design by outputting note numbers that control pitch-based audio processors.",
    info: `# Random Sequencer (MIDI Note Generator)

A trigger-driven random note generator that outputs MIDI note numbers from a predefined musical scale. The sequencer creates generative melodic patterns by selecting random notes when triggered, enabling algorithmic composition and unpredictable musical sequences.

## Purpose

- Generate random melodic sequences for algorithmic composition
- Create generative music patterns that evolve over time
- Produce unpredictable note sequences for experimental music
- Add controlled randomness to modular synthesis patches
- Drive pitch parameters of oscillators and samplers with random values
`,
    tags: [
        "sequencer",
        "random",
        "midi",
        "generator",
        "algorithmic",
        "generative"
    ],
    portsDescription: {
        inputs: {
            trigger: "Gate signal that triggers a new random note when crossing threshold (0.5)"
        },
        outputs: {
            midi: "MIDI note number output (45-93) from pentatonic scale, held until next trigger"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"9wa6X","./RandomSequencer":"42khF","./Node":"9pnLQ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9wa6X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "randomSequencer",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"ijyja","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ijyja":[function(require,module,exports,__globalThis) {
//@ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
var _useBroadcast = require("../../lib/useBroadcast");
var _constants = require("@web-noise/core/constants");
const randomSequencerWorkletProcessor = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/RandomSequencer/audioNode.ts");
exports.default = async (audioContext)=>{
    await audioContext.audioWorklet.addModule(randomSequencerWorkletProcessor);
    const randomSequencer = new AudioWorkletNode(audioContext, "random-sequencer-processor");
    return {
        inputs: {
            trigger: {
                port: randomSequencer,
                type: (0, _constants.PortType).Gate,
                range: [
                    0,
                    1
                ],
                defaultValue: 0
            }
        },
        outputs: {
            midi: {
                port: randomSequencer,
                type: (0, _constants.PortType).Number,
                range: [
                    45,
                    93
                ]
            }
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(randomSequencer.port, port);
            return randomSequencer.port;
        }
    };
};

},{"worklet:./worklet.ts":"hjK5o","../../lib/useBroadcast":"ekNC4","@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hjK5o":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1Ilh0");

},{}],"42khF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _components = require("@web-noise/core/components");
var _lib = require("@web-noise/core/lib");
let _ = (t)=>t, t, t1;
const RandomSequencerWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  background: ${0};
  padding: 0.2rem;
`), ({ theme })=>theme.colors.elevation2));
const StyledInput = (0, _react1.withTheme)((0, _styledDefault.default)((0, _components.Input))(t1 || (t1 = _`
  height: 100%;
  width: 100%;
  input {
    height: 100%;
  }
`)));
const RandomSequencer = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const [value, setValue] = (0, _react.useState)(null);
    const channel = (0, _lib.useMessageChannel)();
    (0, _react.useEffect)(()=>{
        if (!audioNode || !channel) return;
        const workletPort = audioNode.registerPort(channel.port1);
        channel.port2.addEventListener("message", ({ data: { name, note } })=>{
            if (name === "noteChange") setValue(note);
        });
        workletPort.postMessage({
            name: "GET_CURRENT_NOTE"
        });
    }, [
        audioNode,
        channel,
        setValue
    ]);
    return (0, _jsxRuntime.jsx)(RandomSequencerWrapper, {
        children: (0, _jsxRuntime.jsx)(StyledInput, {
            inputProps: {
                readOnly: true
            },
            value: value || "waiting for trigger.."
        })
    });
};
exports.default = RandomSequencer;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","@web-noise/core/components":"jYfYj","@web-noise/core/lib":"8cGsd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"9pnLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _randomSequencer = require("./RandomSequencer");
var _randomSequencerDefault = parcelHelpers.interopDefault(_randomSequencer);
const RandomSequencerNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _randomSequencerDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = RandomSequencerNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./RandomSequencer":"42khF","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"73J8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _sequencer = require("./Sequencer");
var _sequencerDefault = parcelHelpers.interopDefault(_sequencer);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _sequencerDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: {
        color: "#007bff",
        size: {
            height: 80,
            width: 100
        }
    },
    resizable: true,
    name: "Step Sequencer",
    description: "A clock-driven step sequencer. Plays back programmable sequences of notes or gates when triggered. Creates rhythmic patterns and melodic sequences for electronic music production by outputting gate states or MIDI notes",
    info: `# Sequencer (Step Sequencer)

A clock-driven step sequencer that plays back user-defined patterns of notes and gates. The sequencer advances through a sequence of steps in response to clock signals, making it essential for creating rhythmic patterns, drum sequences, and melodic loops.

## Purpose

- Create rhythmic gate patterns for triggering envelopes and drums
- Program melodic sequences and bass lines
- Generate synchronized patterns for modular synthesis
- Build complex polyrhythmic compositions
- Design evolving sequences with programmable note and gate combinations
`,
    tags: [
        "sequencer",
        "pattern",
        "rhythm",
        "melody",
        "midi",
        "clock",
        "step"
    ],
    portsDescription: {
        inputs: {
            gate: "Clock signal that advances to next step on rising edge (threshold: 0.5)",
            reset: "Trigger signal that resets sequencer to beginning (threshold: 0.5)"
        },
        outputs: {
            gate: "Gate output mirroring clock when step gate is 1, or 0 for rests",
            note: "MIDI note number from current step (0-127)",
            index: "Current step index in sequence (0-based)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"1ek2P","./Sequencer":"1JJhx","./Node":"l7iBf","./Config":"aeg9V","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1ek2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "sequencer",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"6np2p","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6np2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sequencer", ()=>sequencer);
var _constants = require("@web-noise/core/constants");
var _useBroadcast = require("../../lib/useBroadcast");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const sequencerWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/Sequencer/audioNode.ts");
const sequencer = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(sequencerWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "sequencer-processor", {
        numberOfOutputs: 3
    });
    const gate = workletNode.parameters.get("gate");
    const reset = workletNode.parameters.get("reset");
    return {
        inputs: {
            gate: {
                port: gate,
                type: (0, _constants.PortType).Gate,
                range: [
                    gate.minValue,
                    gate.maxValue
                ],
                defaultValue: gate.value
            },
            reset: {
                port: reset,
                type: (0, _constants.PortType).Gate,
                range: [
                    reset.minValue,
                    reset.maxValue
                ],
                defaultValue: reset.value
            }
        },
        outputs: {
            gate: {
                port: [
                    workletNode,
                    0
                ],
                type: (0, _constants.PortType).Gate,
                range: [
                    0,
                    1
                ],
                defaultValue: 0
            },
            note: {
                port: [
                    workletNode,
                    1
                ],
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    127
                ],
                defaultValue: 0
            },
            index: {
                port: [
                    workletNode,
                    2
                ],
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    Infinity
                ],
                defaultValue: 0
            }
        },
        registerPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(workletNode.port, port);
            return workletNode.port;
        },
        setValues: ({ sequence } = {})=>{
            if (typeof sequence !== "undefined") workletNode.port.postMessage({
                name: "SET_SEQUENCE",
                data: sequence
            });
        }
    };
};
exports.default = sequencer;

},{"@web-noise/core/constants":"36kMU","../../lib/useBroadcast":"ekNC4","worklet:./worklet.ts":"kC37f","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kC37f":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("cszEK");

},{}],"1JJhx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _components = require("@web-noise/core/components");
var _lib = require("@web-noise/core/lib");
var _react1 = require("react");
var _notes = require("../MidiNote/notes");
var _notesDefault = parcelHelpers.interopDefault(_notes);
let _ = (t)=>t, t, t1, t2, t3, t4;
const SequencerWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _`
  display: flex;
  height: 100%;
  width: 100%;
  padding: 0.1rem;
  gap: 0.1rem;
  box-sizing: border-box;
  overflow: hidden;
`)));
const SequenceCell = (0, _react.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  gap: 0.2rem;
  opacity: ${0};

  &.active {
    label {
      filter: brightness(125%);
    }
    select {
      color: ${0};
    }
  }
`), ({ state })=>state ? "1" : "0.5", ({ color })=>color));
const NoteSelector = (0, _react.withTheme)((0, _styledDefault.default)((0, _components.Select))(t2 || (t2 = _`
  select {
    text-align: center;
    padding: 0;
    line-height: 2;
  }
  &::after {
    display: none;
  }
`)));
const Pad = (0, _react.withTheme)((0, _styledDefault.default).label(t3 || (t3 = _`
  height: auto;
  width: auto;
  aspect-ratio: 1 / 1;
  cursor: pointer;
  border: 1px solid color-mix(in srgb, ${0}, #000 25%);
  background: ${0};
`), ({ color })=>color, ({ color })=>color));
const PadInput = (0, _react.withTheme)((0, _styledDefault.default).input(t4 || (t4 = _`
  display: none;
`)));
const NOTE_OPTIONS = [
    {
        value: "0",
        label: "\u25CF"
    },
    ...(0, _notesDefault.default).map(({ value, key })=>({
            label: key,
            value: value.toString()
        }))
];
const Sequencer = ({ node: props, audioNode, updateNodeValues })=>{
    const { data } = props;
    const { values, config } = data;
    const { sequence } = values || {};
    const ref = (0, _react1.useRef)(null);
    const channel = (0, _lib.useMessageChannel)();
    (0, _react1.useEffect)(()=>{
        if (!audioNode || !channel || !ref.current) return;
        audioNode.registerPort(channel.port1);
        channel.port2.addEventListener("message", ({ data })=>{
            if (data.name === "STEP_START") {
                var _ref_current;
                const element = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.querySelectorAll(".sequence-cell")[data.data];
                element === null || element === void 0 ? void 0 : element.classList.add("active");
            }
            if (data.name === "STEP_END") {
                var _ref_current1;
                const element = (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : _ref_current1.querySelectorAll(".sequence-cell")[data.data];
                element === null || element === void 0 ? void 0 : element.classList.remove("active");
            }
            if (data.name === "RESET") {
                var _ref_current2;
                const elements = (_ref_current2 = ref.current) === null || _ref_current2 === void 0 ? void 0 : _ref_current2.querySelectorAll(".sequence-cell");
                elements === null || elements === void 0 ? void 0 : elements.forEach((element)=>{
                    element.classList.remove("active");
                });
            }
        });
    }, [
        audioNode,
        channel,
        ref
    ]);
    return (0, _jsxRuntime.jsx)(SequencerWrapper, {
        ref: ref,
        children: sequence === null || sequence === void 0 ? void 0 : sequence.map(([state, note], index)=>(0, _jsxRuntime.jsxs)(SequenceCell, {
                state: state,
                className: "sequence-cell",
                color: config === null || config === void 0 ? void 0 : config.color,
                children: [
                    (0, _jsxRuntime.jsx)(NoteSelector, {
                        options: NOTE_OPTIONS,
                        value: note.toString(),
                        placeholder: "Select note",
                        onChange: (value)=>{
                            const newSequence = [
                                ...sequence
                            ];
                            newSequence[index][1] = +value;
                            updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                sequence: newSequence
                            }));
                        }
                    }),
                    (0, _jsxRuntime.jsx)(Pad, {
                        color: config === null || config === void 0 ? void 0 : config.color,
                        children: (0, _jsxRuntime.jsx)(PadInput, {
                            type: "checkbox",
                            checked: Boolean(state),
                            onChange: (event)=>{
                                const newSequence = [
                                    ...sequence
                                ];
                                newSequence[index][0] = +event.target.checked;
                                updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                    sequence: newSequence
                                }));
                            }
                        })
                    })
                ]
            }, index))
    });
};
exports.default = Sequencer;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","@web-noise/core/components":"jYfYj","@web-noise/core/lib":"8cGsd","react":"lXMxO","../MidiNote/notes":"brHOK","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"l7iBf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _core = require("@web-noise/core");
var _sequencer = require("./Sequencer");
var _sequencerDefault = parcelHelpers.interopDefault(_sequencer);
const DEFAULT_SEQUENCE = [
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ],
    [
        0,
        0
    ]
];
const SequencerNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    (0, _react.useEffect)(()=>{
        if (data.values) {
            var _node_setValues;
            node === null || node === void 0 ? void 0 : (_node_setValues = node.setValues) === null || _node_setValues === void 0 ? void 0 : _node_setValues.call(node, data.values);
            return;
        }
        updateNodeValues({
            sequence: DEFAULT_SEQUENCE
        });
    }, [
        node,
        data.values
    ]);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _sequencerDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = SequencerNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","react":"lXMxO","@web-noise/core":"8EHNf","./Sequencer":"1JJhx","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aeg9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
const SequencerConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeValues, updateNodeConfig } = (0, _core.useNode)(id);
    const { config, values } = data || {};
    const { color } = config || {};
    const { sequence } = values || {};
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Steps"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.NumberInput), {
                            min: 2,
                            max: 32,
                            value: sequence === null || sequence === void 0 ? void 0 : sequence.length,
                            onChange: (value)=>{
                                const newSequence = Array.from({
                                    length: value
                                }).map((value, index)=>(sequence === null || sequence === void 0 ? void 0 : sequence[index]) || [
                                        0,
                                        0
                                    ]);
                                updateNodeValues((0, _objectSpreadProps._)((0, _objectSpread._)({}, values), {
                                    sequence: newSequence
                                }));
                            }
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)((0, _components.ConfigRowSeparator), {
                theme: theme
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Color"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.ColorInput), {
                            value: color,
                            onChange: (value)=>{
                                updateNodeConfig === null || updateNodeConfig === void 0 ? void 0 : updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    color: value
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = SequencerConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4gh66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _virtualKeyboard = require("./VirtualKeyboard");
var _virtualKeyboardDefault = parcelHelpers.interopDefault(_virtualKeyboard);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("./Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _virtualKeyboardDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    resizable: true,
    name: "Virtual Keyboard (MIDI Controller)",
    description: "Interactive MIDI controller interface that generates note-on and note-off commands through a keyboard display. Outputs MIDI command, note, and velocity signals for triggering synthesizers, samplers, and virtual instruments.",
    info: `# Virtual Keyboard (MIDI Controller)

An interactive MIDI controller that outputs note-on and note-off commands through a visual keyboard interface. The virtual keyboard provides an intuitive way to play musical notes and control MIDI-compatible sound generators.

## Purpose

- Play musical notes interactively through a visual keyboard interface
- Generate MIDI-style control signals for synthesizers and samplers
- Trigger note-based sound events with precise timing
- Create melodic sequences and musical performances
- Provide mouse/touch-based musical input for synthesis patches
`,
    tags: [
        "controller",
        "midi",
        "keyboard",
        "input",
        "trigger",
        "interface"
    ],
    portsDescription: {
        inputs: {},
        outputs: {
            command: "MIDI command output: 144 for note-on, 128 for note-off",
            note: "MIDI note number (0-127), where 60 is Middle C",
            velocity: "MIDI velocity value (currently fixed at 127)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"3bxhA","./VirtualKeyboard":"kYEba","./Node":"g0gYF","./Config":"imKU2","./defaultConfig":"cVNAG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3bxhA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "virtualKeyboard",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"lGEEq","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lGEEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "virtualKeyboard", ()=>virtualKeyboard);
var _constants = require("@web-noise/core/constants");
const virtualKeyboard = async (audioContext, data)=>{
    const commandNode = audioContext.createConstantSource();
    commandNode.offset.value = 0;
    commandNode.start();
    const noteNode = audioContext.createConstantSource();
    noteNode.offset.value = 0;
    noteNode.start();
    const velocityNode = audioContext.createConstantSource();
    velocityNode.offset.value = 0;
    velocityNode.start();
    return {
        outputs: {
            command: {
                port: commandNode,
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    255
                ],
                defaultValue: commandNode.offset.value
            },
            note: {
                port: noteNode,
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    127
                ],
                defaultValue: noteNode.offset.value
            },
            velocity: {
                port: velocityNode,
                type: (0, _constants.PortType).Number,
                range: [
                    0,
                    127
                ],
                defaultValue: velocityNode.offset.value
            }
        },
        midi: velocityNode,
        gate: commandNode,
        frequency: noteNode,
        play (note) {
            commandNode.offset.setValueAtTime(144, audioContext.currentTime);
            noteNode.offset.setValueAtTime(note, audioContext.currentTime);
            velocityNode.offset.setValueAtTime(127, audioContext.currentTime);
        },
        stop (note) {
            commandNode.offset.setValueAtTime(128, audioContext.currentTime);
            noteNode.offset.setValueAtTime(note, audioContext.currentTime);
            velocityNode.offset.setValueAtTime(127, audioContext.currentTime);
        }
    };
};
exports.default = virtualKeyboard;

},{"@web-noise/core/constants":"36kMU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"kYEba":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react1 = require("@emotion/react");
var _core = require("@web-noise/core");
// @ts-ignore
var _reactPiano = require("react-piano");
var _stylesCss = require("react-piano/dist/styles.css");
let _ = (t)=>t, t, t1;
const VirtualKeyboardWrapper = (0, _react1.withTheme)((0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
`)));
const Keyboard = (0, _styledDefault.default)((0, _reactPiano.Piano))(t1 || (t1 = _`
  height: 100%;
  .ReactPiano__Key--natural {
    border-radius: 0;
  }

  .ReactPiano__Key--accidental {
    border-radius: 0 0 3px 3px;
  }
`));
const VirtualKeyboard = ({ node: props, audioNode, updateNodeValues })=>{
    const { id, data } = props;
    const { values, config } = data || {};
    const { node } = (0, _core.useAudioNode)(id) || {};
    const firstNote = config === null || config === void 0 ? void 0 : config.firstNote;
    const lastNote = (0, _react.useMemo)(()=>((config === null || config === void 0 ? void 0 : config.firstNote) || 0) + ((config === null || config === void 0 ? void 0 : config.keyboardSize) || 0), [
        values
    ]);
    const keyboardShortcuts = (0, _react.useMemo)(()=>(0, _reactPiano.KeyboardShortcuts).create({
            firstNote: firstNote,
            lastNote: lastNote,
            keyboardConfig: (0, _reactPiano.KeyboardShortcuts).HOME_ROW
        }), [
        firstNote,
        lastNote
    ]);
    const playNote = (0, _react.useCallback)((midiNumber)=>{
        if (!node) return;
        node.play(midiNumber);
    }, [
        node
    ]);
    const stopNote = (0, _react.useCallback)((midiNumber)=>{
        if (!node) return;
        node.stop(midiNumber);
    }, [
        node
    ]);
    return (0, _jsxRuntime.jsx)(VirtualKeyboardWrapper, {
        children: (0, _jsxRuntime.jsx)(Keyboard, {
            noteRange: {
                first: firstNote,
                last: lastNote
            },
            playNote: playNote,
            stopNote: stopNote,
            // width={config?.size?.width || 400}
            keyboardShortcuts: keyboardShortcuts
        })
    });
};
exports.default = VirtualKeyboard;

},{"react/jsx-runtime":"g1NAx","react":"lXMxO","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","@web-noise/core":"8EHNf","react-piano":"boXYU","react-piano/dist/styles.css":"4ikqV","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"boXYU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ControlledPiano", ()=>ControlledPiano);
parcelHelpers.export(exports, "Piano", ()=>Piano);
parcelHelpers.export(exports, "Keyboard", ()=>Keyboard);
parcelHelpers.export(exports, "KeyboardShortcuts", ()=>KeyboardShortcuts);
parcelHelpers.export(exports, "MidiNumbers", ()=>MidiNumbers);
var _justRange = require("just-range");
var _justRangeDefault = parcelHelpers.interopDefault(_justRange);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _lodashDifference = require("lodash.difference");
var _lodashDifferenceDefault = parcelHelpers.interopDefault(_lodashDifference);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var SORTED_PITCHES = [
    'C',
    'Db',
    'D',
    'Eb',
    'E',
    'F',
    'Gb',
    'G',
    'Ab',
    'A',
    'Bb',
    'B'
];
var ACCIDENTAL_PITCHES = [
    'Db',
    'Eb',
    'Gb',
    'Ab',
    'Bb'
];
var PITCH_INDEXES = {
    C: 0,
    'C#': 1,
    Db: 1,
    D: 2,
    'D#': 3,
    Eb: 3,
    E: 4,
    F: 5,
    'F#': 6,
    Gb: 6,
    G: 7,
    'G#': 8,
    Ab: 8,
    A: 9,
    'A#': 10,
    Bb: 10,
    B: 11
};
var MIDI_NUMBER_C0 = 12;
var MIN_MIDI_NUMBER = MIDI_NUMBER_C0;
var MAX_MIDI_NUMBER = 127;
var NOTE_REGEX = /([a-g])([#b]?)(\d+)/;
var NOTES_IN_OCTAVE = 12; // Converts string notes in scientific pitch notation to a MIDI number, or null.
//
// Example: "c#0" => 13, "eb5" => 75, "abc" => null
//
// References:
// - http://www.flutopedia.com/octave_notation.htm
// - https://github.com/danigb/tonal/blob/master/packages/note/index.js
function fromNote(note) {
    if (!note) throw Error('Invalid note argument');
    var match = NOTE_REGEX.exec(note.toLowerCase());
    if (!match) throw Error('Invalid note argument');
    var _match = _slicedToArray(match, 4), letter = _match[1], accidental = _match[2], octave = _match[3];
    var pitchName = "".concat(letter.toUpperCase()).concat(accidental);
    var pitchIndex = PITCH_INDEXES[pitchName];
    if (pitchIndex == null) throw Error('Invalid note argument');
    return MIDI_NUMBER_C0 + pitchIndex + NOTES_IN_OCTAVE * parseInt(octave, 10);
} //
// Build cache for getAttributes
//
function buildMidiNumberAttributes(midiNumber) {
    var pitchIndex = (midiNumber - MIDI_NUMBER_C0) % NOTES_IN_OCTAVE;
    var octave = Math.floor((midiNumber - MIDI_NUMBER_C0) / NOTES_IN_OCTAVE);
    var pitchName = SORTED_PITCHES[pitchIndex];
    return {
        note: "".concat(pitchName).concat(octave),
        pitchName: pitchName,
        octave: octave,
        midiNumber: midiNumber,
        isAccidental: ACCIDENTAL_PITCHES.includes(pitchName)
    };
}
function buildMidiNumberAttributesCache() {
    return (0, _justRangeDefault.default)(MIN_MIDI_NUMBER, MAX_MIDI_NUMBER + 1).reduce(function(cache, midiNumber) {
        cache[midiNumber] = buildMidiNumberAttributes(midiNumber);
        return cache;
    }, {});
}
var midiNumberAttributesCache = buildMidiNumberAttributesCache(); // Returns an object containing various attributes for a given MIDI number.
// Throws error for invalid midiNumbers.
function getAttributes(midiNumber) {
    var attrs = midiNumberAttributesCache[midiNumber];
    if (!attrs) throw Error('Invalid MIDI number');
    return attrs;
} // Returns all MIDI numbers corresponding to natural notes, e.g. C and not C# or Bb.
var NATURAL_MIDI_NUMBERS = (0, _justRangeDefault.default)(MIN_MIDI_NUMBER, MAX_MIDI_NUMBER + 1).filter(function(midiNumber) {
    return !getAttributes(midiNumber).isAccidental;
});
var MidiNumbers = {
    fromNote: fromNote,
    getAttributes: getAttributes,
    MIN_MIDI_NUMBER: MIN_MIDI_NUMBER,
    MAX_MIDI_NUMBER: MAX_MIDI_NUMBER,
    NATURAL_MIDI_NUMBERS: NATURAL_MIDI_NUMBERS
};
var Key = /*#__PURE__*/ function(_React$Component) {
    _inherits(Key, _React$Component);
    function Key() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Key);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Key)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "onPlayNoteInput", function() {
            _this.props.onPlayNoteInput(_this.props.midiNumber);
        });
        _defineProperty(_assertThisInitialized(_this), "onStopNoteInput", function() {
            _this.props.onStopNoteInput(_this.props.midiNumber);
        });
        return _this;
    }
    _createClass(Key, [
        {
            key: "getAbsoluteKeyPosition",
            // Key position is represented by the number of natural key widths from the left
            value: function getAbsoluteKeyPosition(midiNumber) {
                var OCTAVE_WIDTH = 7;
                var _MidiNumbers$getAttri = MidiNumbers.getAttributes(midiNumber), octave = _MidiNumbers$getAttri.octave, pitchName = _MidiNumbers$getAttri.pitchName;
                var pitchPosition = this.props.pitchPositions[pitchName];
                var octavePosition = OCTAVE_WIDTH * octave;
                return pitchPosition + octavePosition;
            }
        },
        {
            key: "getRelativeKeyPosition",
            value: function getRelativeKeyPosition(midiNumber) {
                return this.getAbsoluteKeyPosition(midiNumber) - this.getAbsoluteKeyPosition(this.props.noteRange.first);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, naturalKeyWidth = _this$props.naturalKeyWidth, accidentalWidthRatio = _this$props.accidentalWidthRatio, midiNumber = _this$props.midiNumber, gliss = _this$props.gliss, useTouchEvents = _this$props.useTouchEvents, accidental = _this$props.accidental, active = _this$props.active, disabled = _this$props.disabled, children = _this$props.children; // Need to conditionally include/exclude handlers based on useTouchEvents,
                // because otherwise mobile taps double fire events.
                return (0, _reactDefault.default).createElement("div", {
                    className: (0, _classnamesDefault.default)('ReactPiano__Key', {
                        'ReactPiano__Key--accidental': accidental,
                        'ReactPiano__Key--natural': !accidental,
                        'ReactPiano__Key--disabled': disabled,
                        'ReactPiano__Key--active': active
                    }),
                    style: {
                        left: ratioToPercentage(this.getRelativeKeyPosition(midiNumber) * naturalKeyWidth),
                        width: ratioToPercentage(accidental ? accidentalWidthRatio * naturalKeyWidth : naturalKeyWidth)
                    },
                    onMouseDown: useTouchEvents ? null : this.onPlayNoteInput,
                    onMouseUp: useTouchEvents ? null : this.onStopNoteInput,
                    onMouseEnter: gliss ? this.onPlayNoteInput : null,
                    onMouseLeave: this.onStopNoteInput,
                    onTouchStart: useTouchEvents ? this.onPlayNoteInput : null,
                    onTouchCancel: useTouchEvents ? this.onStopNoteInput : null,
                    onTouchEnd: useTouchEvents ? this.onStopNoteInput : null
                }, (0, _reactDefault.default).createElement("div", {
                    className: "ReactPiano__NoteLabelContainer"
                }, children));
            }
        }
    ]);
    return Key;
}((0, _reactDefault.default).Component);
_defineProperty(Key, "propTypes", {
    midiNumber: (0, _propTypesDefault.default).number.isRequired,
    naturalKeyWidth: (0, _propTypesDefault.default).number.isRequired,
    // Width as a ratio between 0 and 1
    gliss: (0, _propTypesDefault.default).bool.isRequired,
    useTouchEvents: (0, _propTypesDefault.default).bool.isRequired,
    accidental: (0, _propTypesDefault.default).bool.isRequired,
    active: (0, _propTypesDefault.default).bool.isRequired,
    disabled: (0, _propTypesDefault.default).bool.isRequired,
    onPlayNoteInput: (0, _propTypesDefault.default).func.isRequired,
    onStopNoteInput: (0, _propTypesDefault.default).func.isRequired,
    accidentalWidthRatio: (0, _propTypesDefault.default).number.isRequired,
    pitchPositions: (0, _propTypesDefault.default).object.isRequired,
    children: (0, _propTypesDefault.default).node
});
_defineProperty(Key, "defaultProps", {
    accidentalWidthRatio: 0.65,
    pitchPositions: {
        C: 0,
        Db: 0.55,
        D: 1,
        Eb: 1.8,
        E: 2,
        F: 3,
        Gb: 3.5,
        G: 4,
        Ab: 4.7,
        A: 5,
        Bb: 5.85,
        B: 6
    }
});
function ratioToPercentage(ratio) {
    return "".concat(ratio * 100, "%");
}
var Keyboard = /*#__PURE__*/ function(_React$Component) {
    _inherits(Keyboard, _React$Component);
    function Keyboard() {
        _classCallCheck(this, Keyboard);
        return _possibleConstructorReturn(this, _getPrototypeOf(Keyboard).apply(this, arguments));
    }
    _createClass(Keyboard, [
        {
            key: "getMidiNumbers",
            // Range of midi numbers on keyboard
            value: function getMidiNumbers() {
                return (0, _justRangeDefault.default)(this.props.noteRange.first, this.props.noteRange.last + 1);
            }
        },
        {
            key: "getNaturalKeyCount",
            value: function getNaturalKeyCount() {
                return this.getMidiNumbers().filter(function(number) {
                    var _MidiNumbers$getAttri = MidiNumbers.getAttributes(number), isAccidental = _MidiNumbers$getAttri.isAccidental;
                    return !isAccidental;
                }).length;
            } // Returns a ratio between 0 and 1
        },
        {
            key: "getNaturalKeyWidth",
            value: function getNaturalKeyWidth() {
                return 1 / this.getNaturalKeyCount();
            }
        },
        {
            key: "getWidth",
            value: function getWidth() {
                return this.props.width ? this.props.width : '100%';
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (!this.props.width) return '100%';
                var keyWidth = this.props.width * this.getNaturalKeyWidth();
                return "".concat(keyWidth / this.props.keyWidthToHeight, "px");
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var naturalKeyWidth = this.getNaturalKeyWidth();
                return (0, _reactDefault.default).createElement("div", {
                    className: (0, _classnamesDefault.default)('ReactPiano__Keyboard', this.props.className),
                    style: {
                        width: this.getWidth(),
                        height: this.getHeight()
                    }
                }, this.getMidiNumbers().map(function(midiNumber) {
                    var _MidiNumbers$getAttri2 = MidiNumbers.getAttributes(midiNumber), note = _MidiNumbers$getAttri2.note, isAccidental = _MidiNumbers$getAttri2.isAccidental;
                    var isActive = !_this.props.disabled && _this.props.activeNotes.includes(midiNumber);
                    return (0, _reactDefault.default).createElement(Key, {
                        naturalKeyWidth: naturalKeyWidth,
                        midiNumber: midiNumber,
                        noteRange: _this.props.noteRange,
                        active: isActive,
                        accidental: isAccidental,
                        disabled: _this.props.disabled,
                        onPlayNoteInput: _this.props.onPlayNoteInput,
                        onStopNoteInput: _this.props.onStopNoteInput,
                        gliss: _this.props.gliss,
                        useTouchEvents: _this.props.useTouchEvents,
                        key: midiNumber
                    }, _this.props.disabled ? null : _this.props.renderNoteLabel({
                        isActive: isActive,
                        isAccidental: isAccidental,
                        midiNumber: midiNumber
                    }));
                }));
            }
        }
    ]);
    return Keyboard;
}((0, _reactDefault.default).Component);
_defineProperty(Keyboard, "propTypes", {
    noteRange: noteRangePropType,
    activeNotes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number),
    onPlayNoteInput: (0, _propTypesDefault.default).func.isRequired,
    onStopNoteInput: (0, _propTypesDefault.default).func.isRequired,
    renderNoteLabel: (0, _propTypesDefault.default).func.isRequired,
    keyWidthToHeight: (0, _propTypesDefault.default).number.isRequired,
    className: (0, _propTypesDefault.default).string,
    disabled: (0, _propTypesDefault.default).bool,
    gliss: (0, _propTypesDefault.default).bool,
    useTouchEvents: (0, _propTypesDefault.default).bool,
    // If width is not provided, must have fixed width and height in parent container
    width: (0, _propTypesDefault.default).number
});
_defineProperty(Keyboard, "defaultProps", {
    disabled: false,
    gliss: false,
    useTouchEvents: false,
    keyWidthToHeight: 0.33,
    renderNoteLabel: function renderNoteLabel() {}
});
function isNaturalMidiNumber(value) {
    if (typeof value !== 'number') return false;
    return MidiNumbers.NATURAL_MIDI_NUMBERS.includes(value);
}
function noteRangePropType(props, propName, componentName) {
    var _props$propName = props[propName], first = _props$propName.first, last = _props$propName.last;
    if (!first || !last) return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". ").concat(propName, " must be an object with .first and .last values."));
    if (!isNaturalMidiNumber(first) || !isNaturalMidiNumber(last)) return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". ").concat(propName, " values must be valid MIDI numbers, and should not be accidentals (sharp or flat notes)."));
    if (first >= last) return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". ").concat(propName, ".first must be smaller than ").concat(propName, ".last."));
}
var ControlledPiano = /*#__PURE__*/ function(_React$Component) {
    _inherits(ControlledPiano, _React$Component);
    function ControlledPiano() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, ControlledPiano);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ControlledPiano)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "state", {
            isMouseDown: false,
            useTouchEvents: false
        });
        _defineProperty(_assertThisInitialized(_this), "handleNoteChanges", function(_ref) {
            var prevActiveNotes = _ref.prevActiveNotes, nextActiveNotes = _ref.nextActiveNotes;
            if (_this.props.disabled) return;
            var notesStopped = (0, _lodashDifferenceDefault.default)(prevActiveNotes, nextActiveNotes);
            var notesStarted = (0, _lodashDifferenceDefault.default)(nextActiveNotes, prevActiveNotes);
            notesStarted.forEach(function(midiNumber) {
                _this.props.playNote(midiNumber);
            });
            notesStopped.forEach(function(midiNumber) {
                _this.props.stopNote(midiNumber);
            });
        });
        _defineProperty(_assertThisInitialized(_this), "getMidiNumberForKey", function(key) {
            if (!_this.props.keyboardShortcuts) return null;
            var shortcut = _this.props.keyboardShortcuts.find(function(sh) {
                return sh.key === key;
            });
            return shortcut && shortcut.midiNumber;
        });
        _defineProperty(_assertThisInitialized(_this), "getKeyForMidiNumber", function(midiNumber) {
            if (!_this.props.keyboardShortcuts) return null;
            var shortcut = _this.props.keyboardShortcuts.find(function(sh) {
                return sh.midiNumber === midiNumber;
            });
            return shortcut && shortcut.key;
        });
        _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(event) {
            // Don't conflict with existing combinations like ctrl + t
            if (event.ctrlKey || event.metaKey || event.shiftKey) return;
            var midiNumber = _this.getMidiNumberForKey(event.key);
            if (midiNumber) _this.onPlayNoteInput(midiNumber);
        });
        _defineProperty(_assertThisInitialized(_this), "onKeyUp", function(event) {
            // This *should* also check for event.ctrlKey || event.metaKey || event.ShiftKey like onKeyDown does,
            // but at least on Mac Chrome, when mashing down many alphanumeric keystrokes at once,
            // ctrlKey is fired unexpectedly, which would cause onStopNote to NOT be fired, which causes problematic
            // lingering notes. Since it's fairly safe to call onStopNote even when not necessary,
            // the ctrl/meta/shift check is removed to fix that issue.
            var midiNumber = _this.getMidiNumberForKey(event.key);
            if (midiNumber) _this.onStopNoteInput(midiNumber);
        });
        _defineProperty(_assertThisInitialized(_this), "onPlayNoteInput", function(midiNumber) {
            if (_this.props.disabled) return;
             // Pass in previous activeNotes for recording functionality
            _this.props.onPlayNoteInput(midiNumber, _this.props.activeNotes);
        });
        _defineProperty(_assertThisInitialized(_this), "onStopNoteInput", function(midiNumber) {
            if (_this.props.disabled) return;
             // Pass in previous activeNotes for recording functionality
            _this.props.onStopNoteInput(midiNumber, _this.props.activeNotes);
        });
        _defineProperty(_assertThisInitialized(_this), "onMouseDown", function() {
            _this.setState({
                isMouseDown: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onMouseUp", function() {
            _this.setState({
                isMouseDown: false
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onTouchStart", function() {
            _this.setState({
                useTouchEvents: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "renderNoteLabel", function(_ref2) {
            var midiNumber = _ref2.midiNumber, isActive = _ref2.isActive, isAccidental = _ref2.isAccidental;
            var keyboardShortcut = _this.getKeyForMidiNumber(midiNumber);
            return _this.props.renderNoteLabel({
                keyboardShortcut: keyboardShortcut,
                midiNumber: midiNumber,
                isActive: isActive,
                isAccidental: isAccidental
            });
        });
        return _this;
    }
    _createClass(ControlledPiano, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener('keydown', this.onKeyDown);
                window.addEventListener('keyup', this.onKeyUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener('keydown', this.onKeyDown);
                window.removeEventListener('keyup', this.onKeyUp);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.activeNotes !== prevProps.activeNotes) this.handleNoteChanges({
                    prevActiveNotes: prevProps.activeNotes || [],
                    nextActiveNotes: this.props.activeNotes || []
                });
            } // This function is responsible for diff'ing activeNotes
        },
        {
            key: "render",
            value: function render() {
                return (0, _reactDefault.default).createElement("div", {
                    style: {
                        width: '100%',
                        height: '100%'
                    },
                    onMouseDown: this.onMouseDown,
                    onMouseUp: this.onMouseUp,
                    onTouchStart: this.onTouchStart,
                    "data-testid": "container"
                }, (0, _reactDefault.default).createElement(Keyboard, {
                    noteRange: this.props.noteRange,
                    onPlayNoteInput: this.onPlayNoteInput,
                    onStopNoteInput: this.onStopNoteInput,
                    activeNotes: this.props.activeNotes,
                    className: this.props.className,
                    disabled: this.props.disabled,
                    width: this.props.width,
                    keyWidthToHeight: this.props.keyWidthToHeight,
                    gliss: this.state.isMouseDown,
                    useTouchEvents: this.state.useTouchEvents,
                    renderNoteLabel: this.renderNoteLabel
                }));
            }
        }
    ]);
    return ControlledPiano;
}((0, _reactDefault.default).Component);
_defineProperty(ControlledPiano, "propTypes", {
    noteRange: (0, _propTypesDefault.default).object.isRequired,
    activeNotes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number.isRequired).isRequired,
    playNote: (0, _propTypesDefault.default).func.isRequired,
    stopNote: (0, _propTypesDefault.default).func.isRequired,
    onPlayNoteInput: (0, _propTypesDefault.default).func.isRequired,
    onStopNoteInput: (0, _propTypesDefault.default).func.isRequired,
    renderNoteLabel: (0, _propTypesDefault.default).func.isRequired,
    className: (0, _propTypesDefault.default).string,
    disabled: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).number,
    keyWidthToHeight: (0, _propTypesDefault.default).number,
    keyboardShortcuts: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        key: (0, _propTypesDefault.default).string.isRequired,
        midiNumber: (0, _propTypesDefault.default).number.isRequired
    }))
});
_defineProperty(ControlledPiano, "defaultProps", {
    renderNoteLabel: function renderNoteLabel(_ref3) {
        var keyboardShortcut = _ref3.keyboardShortcut, midiNumber = _ref3.midiNumber, isActive = _ref3.isActive, isAccidental = _ref3.isAccidental;
        return keyboardShortcut ? (0, _reactDefault.default).createElement("div", {
            className: (0, _classnamesDefault.default)('ReactPiano__NoteLabel', {
                'ReactPiano__NoteLabel--active': isActive,
                'ReactPiano__NoteLabel--accidental': isAccidental,
                'ReactPiano__NoteLabel--natural': !isAccidental
            })
        }, keyboardShortcut) : null;
    }
});
var Piano = /*#__PURE__*/ function(_React$Component) {
    _inherits(Piano, _React$Component);
    function Piano() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Piano);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Piano)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "state", {
            activeNotes: _this.props.activeNotes || []
        });
        _defineProperty(_assertThisInitialized(_this), "handlePlayNoteInput", function(midiNumber) {
            _this.setState(function(prevState) {
                // Need to be handled inside setState in order to set prevActiveNotes without
                // race conditions.
                if (_this.props.onPlayNoteInput) _this.props.onPlayNoteInput(midiNumber, {
                    prevActiveNotes: prevState.activeNotes
                });
                 // Don't append note to activeNotes if it's already present
                if (prevState.activeNotes.includes(midiNumber)) return null;
                return {
                    activeNotes: prevState.activeNotes.concat(midiNumber)
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleStopNoteInput", function(midiNumber) {
            _this.setState(function(prevState) {
                // Need to be handled inside setState in order to set prevActiveNotes without
                // race conditions.
                if (_this.props.onStopNoteInput) _this.props.onStopNoteInput(midiNumber, {
                    prevActiveNotes: _this.state.activeNotes
                });
                return {
                    activeNotes: prevState.activeNotes.filter(function(note) {
                        return midiNumber !== note;
                    })
                };
            });
        });
        return _this;
    }
    _createClass(Piano, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // Make activeNotes "controllable" by using internal
                // state by default, but allowing prop overrides.
                if (prevProps.activeNotes !== this.props.activeNotes && this.state.activeNotes !== this.props.activeNotes) this.setState({
                    activeNotes: this.props.activeNotes || []
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, activeNotes = _this$props.activeNotes, onPlayNoteInput = _this$props.onPlayNoteInput, onStopNoteInput = _this$props.onStopNoteInput, otherProps = _objectWithoutProperties(_this$props, [
                    "activeNotes",
                    "onPlayNoteInput",
                    "onStopNoteInput"
                ]);
                return (0, _reactDefault.default).createElement(ControlledPiano, _extends({
                    activeNotes: this.state.activeNotes,
                    onPlayNoteInput: this.handlePlayNoteInput,
                    onStopNoteInput: this.handleStopNoteInput
                }, otherProps));
            }
        }
    ]);
    return Piano;
}((0, _reactDefault.default).Component);
_defineProperty(Piano, "propTypes", {
    noteRange: (0, _propTypesDefault.default).object.isRequired,
    activeNotes: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).number.isRequired),
    playNote: (0, _propTypesDefault.default).func.isRequired,
    stopNote: (0, _propTypesDefault.default).func.isRequired,
    onPlayNoteInput: (0, _propTypesDefault.default).func,
    onStopNoteInput: (0, _propTypesDefault.default).func,
    renderNoteLabel: (0, _propTypesDefault.default).func,
    className: (0, _propTypesDefault.default).string,
    disabled: (0, _propTypesDefault.default).bool,
    width: (0, _propTypesDefault.default).number,
    keyWidthToHeight: (0, _propTypesDefault.default).number,
    keyboardShortcuts: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).shape({
        key: (0, _propTypesDefault.default).string.isRequired,
        midiNumber: (0, _propTypesDefault.default).number.isRequired
    }))
});
function createKeyboardShortcuts(_ref) {
    var firstNote = _ref.firstNote, lastNote = _ref.lastNote, keyboardConfig = _ref.keyboardConfig;
    var currentMidiNumber = firstNote;
    var naturalKeyIndex = 0;
    var keyboardShortcuts = [];
    while(naturalKeyIndex < keyboardConfig.length && // Note to be assigned does not surpass range
    currentMidiNumber <= lastNote){
        var key = keyboardConfig[naturalKeyIndex];
        var _MidiNumbers$getAttri = MidiNumbers.getAttributes(currentMidiNumber), isAccidental = _MidiNumbers$getAttri.isAccidental;
        if (isAccidental) keyboardShortcuts.push({
            key: key.flat,
            midiNumber: currentMidiNumber
        });
        else {
            keyboardShortcuts.push({
                key: key.natural,
                midiNumber: currentMidiNumber
            });
            naturalKeyIndex += 1;
        }
        currentMidiNumber += 1;
    }
    return keyboardShortcuts;
}
var KeyboardShortcuts = {
    create: createKeyboardShortcuts,
    // Preset configurations
    BOTTOM_ROW: [
        {
            natural: 'z',
            flat: 'a',
            sharp: 's'
        },
        {
            natural: 'x',
            flat: 's',
            sharp: 'd'
        },
        {
            natural: 'c',
            flat: 'd',
            sharp: 'f'
        },
        {
            natural: 'v',
            flat: 'f',
            sharp: 'g'
        },
        {
            natural: 'b',
            flat: 'g',
            sharp: 'h'
        },
        {
            natural: 'n',
            flat: 'h',
            sharp: 'j'
        },
        {
            natural: 'm',
            flat: 'j',
            sharp: 'k'
        },
        {
            natural: ',',
            flat: 'k',
            sharp: 'l'
        },
        {
            natural: '.',
            flat: 'l',
            sharp: ';'
        },
        {
            natural: '/',
            flat: ';',
            sharp: "'"
        }
    ],
    HOME_ROW: [
        {
            natural: 'a',
            flat: 'q',
            sharp: 'w'
        },
        {
            natural: 's',
            flat: 'w',
            sharp: 'e'
        },
        {
            natural: 'd',
            flat: 'e',
            sharp: 'r'
        },
        {
            natural: 'f',
            flat: 'r',
            sharp: 't'
        },
        {
            natural: 'g',
            flat: 't',
            sharp: 'y'
        },
        {
            natural: 'h',
            flat: 'y',
            sharp: 'u'
        },
        {
            natural: 'j',
            flat: 'u',
            sharp: 'i'
        },
        {
            natural: 'k',
            flat: 'i',
            sharp: 'o'
        },
        {
            natural: 'l',
            flat: 'o',
            sharp: 'p'
        },
        {
            natural: ';',
            flat: 'p',
            sharp: '['
        },
        {
            natural: "'",
            flat: '[',
            sharp: ']'
        }
    ],
    QWERTY_ROW: [
        {
            natural: 'q',
            flat: '1',
            sharp: '2'
        },
        {
            natural: 'w',
            flat: '2',
            sharp: '3'
        },
        {
            natural: 'e',
            flat: '3',
            sharp: '4'
        },
        {
            natural: 'r',
            flat: '4',
            sharp: '5'
        },
        {
            natural: 't',
            flat: '5',
            sharp: '6'
        },
        {
            natural: 'y',
            flat: '6',
            sharp: '7'
        },
        {
            natural: 'u',
            flat: '7',
            sharp: '8'
        },
        {
            natural: 'i',
            flat: '8',
            sharp: '9'
        },
        {
            natural: 'o',
            flat: '9',
            sharp: '0'
        },
        {
            natural: 'p',
            flat: '0',
            sharp: '-'
        },
        {
            natural: '[',
            flat: '-',
            sharp: '='
        }
    ]
};

},{"just-range":"dXshH","react":"lXMxO","prop-types":"esp3E","classnames":"8ZF8C","lodash.difference":"dk1tC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dXshH":[function(require,module,exports,__globalThis) {
module.exports = range;
/*
  range(0, 5); // [0, 1, 2, 3, 4]
  range(5); // [0, 1, 2, 3, 4]
  range(-5); // [0, -1, -2, -3, -4]
  range(0, 20, 5) // [0, 5, 10, 15]
  range(0, -20, -5) // [0, -5, -10, -15]
*/ function range(start, stop, step) {
    if (start != null && typeof start != 'number') throw new Error('start must be a number or null');
    if (stop != null && typeof stop != 'number') throw new Error('stop must be a number or null');
    if (step != null && typeof step != 'number') throw new Error('step must be a number or null');
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (step == null) step = stop > start ? 1 : -1;
    var toReturn = [];
    var increasing = start < stop; //← here’s the change
    for(; increasing ? start < stop : start > stop; start += step)toReturn.push(start);
    return toReturn;
}

},{}],"dk1tC":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var global = arguments[3];
var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array ? array.length : 0;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    if (value !== value) return baseFindIndex(array, baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = arrayMap(values, baseUnary(iteratee));
    if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
    } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order of result values is determined by the
 * order they occur in the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var difference = baseRest(function(array, values) {
    return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
});
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = difference;

},{}],"4ikqV":[function() {},{}],"g0gYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _virtualKeyboard = require("./VirtualKeyboard");
var _virtualKeyboardDefault = parcelHelpers.interopDefault(_virtualKeyboard);
var _react = require("@emotion/react");
let _ = (t)=>t, t;
const VirtualKeyboardWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  position: absolute;
  width: 100%;
`)));
const VirtualKeyboardNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)(VirtualKeyboardWrapper, {
            children: (0, _jsxRuntime.jsx)((0, _virtualKeyboardDefault.default), {
                node: props,
                audioNode: node,
                updateNodeValues: updateNodeValues
            })
        })
    }));
};
exports.default = VirtualKeyboardNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","./VirtualKeyboard":"kYEba","@emotion/react":"ifT37","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"imKU2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _components = require("@web-noise/core/components");
var _notes = require("../MidiNote/notes");
var _notesDefault = parcelHelpers.interopDefault(_notes);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const FIRST_NOTE_OPTIONS = (0, _notesDefault.default).map(({ value, key })=>({
        label: key,
        value: value.toString()
    }));
const VirtualKeyboardConfig = ({ id, data })=>{
    const theme = (0, _core.useTheme)();
    const { updateNodeValues, updateNodeConfig } = (0, _core.useNode)(id);
    const { config = (0, _defaultConfigDefault.default) } = data || {};
    var _config_firstNote, _config_keyboardSize;
    return (0, _jsxRuntime.jsxs)((0, _components.ConfigPanel), {
        theme: theme,
        children: [
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "First Note"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.Select), {
                            options: FIRST_NOTE_OPTIONS,
                            value: ((_config_firstNote = config.firstNote) !== null && _config_firstNote !== void 0 ? _config_firstNote : (0, _defaultConfigDefault.default).firstNote).toString(),
                            placeholder: "Select note",
                            onChange: (value)=>updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    firstNote: +value
                                }))
                        })
                    })
                ]
            }),
            (0, _jsxRuntime.jsxs)((0, _components.ConfigRow), {
                oneLineLabels: true,
                theme: theme,
                children: [
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowLabel), {
                        children: "Keyboard Size"
                    }),
                    (0, _jsxRuntime.jsx)((0, _components.ConfigRowControl), {
                        theme: theme,
                        children: (0, _jsxRuntime.jsx)((0, _components.Select), {
                            options: [
                                {
                                    value: "12",
                                    label: "12 keys"
                                },
                                {
                                    value: "24",
                                    label: "24 keys"
                                }
                            ],
                            value: ((_config_keyboardSize = config === null || config === void 0 ? void 0 : config.keyboardSize) !== null && _config_keyboardSize !== void 0 ? _config_keyboardSize : (0, _defaultConfigDefault.default).keyboardSize).toString(),
                            placeholder: "Select note",
                            onChange: (value)=>updateNodeConfig((0, _objectSpreadProps._)((0, _objectSpread._)({}, config), {
                                    keyboardSize: +value
                                }))
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = VirtualKeyboardConfig;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","@web-noise/core/components":"jYfYj","../MidiNote/notes":"brHOK","./defaultConfig":"cVNAG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cVNAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    firstNote: 60,
    keyboardSize: 12
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eKoOW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _audioRecorder = require("./AudioRecorder");
var _audioRecorderDefault = parcelHelpers.interopDefault(_audioRecorder);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _config = require("../AudioTrack/Config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _defaultConfig = require("./defaultConfig");
var _defaultConfigDefault = parcelHelpers.interopDefault(_defaultConfig);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _nodeDefault.default),
    controlPanelNode: (0, _audioRecorderDefault.default),
    configNode: (0, _configDefault.default),
    defaultConfig: (0, _defaultConfigDefault.default),
    name: "Audio Recorder",
    description: "Records audio from an input stream into a buffer, which can then be played back or downloaded.",
    info: `# Audio Recorder

The Audio Recorder node captures audio from an input and stores it in an internal buffer. Once the recording is complete, the audio can be played back and manipulated like a regular audio track. It's ideal for sampling, live performance, and sound design.

## Purpose

- Capture live audio input
- Create and manipulate audio samples
- Debug and analyze audio signals
- Download recorded audio for external use

## Values

- **record**: Gate signal (0 or 1) to start/stop recording.
- **erase**: Trigger signal to clear the recorded buffer.
- **play**: Gate signal to start/stop playback.
- **loop**: Toggle looping (0 or 1).
- **playbackRate**: Controls the playback speed of the audio.`,
    tags: [
        "audio",
        "recorder",
        "sampler",
        "buffer",
        "capture"
    ],
    portsDescription: {
        inputs: {
            input: "The audio stream to be recorded.",
            record: "Gate signal to start (>=0.5) and stop (<0.5) recording.",
            erase: "Trigger signal to clear the recorded audio.",
            play: "Gate signal to play the recorded audio.",
            restart: "Trigger signal to restart playback from the beginning.",
            loop: "Toggle looping (0 for off, 1 for on).",
            start: "Playback start time in seconds.",
            end: "Playback end time in seconds.",
            detune: "Playback detune in cents.",
            playbackRate: "Controls the playback speed."
        },
        outputs: {
            output: "The audio output of the recorded sample."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"ciRbF","./AudioRecorder":"3Emc3","./Node":"11Ipo","../AudioTrack/Config":"3qygX","./defaultConfig":"ciVbJ","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ciRbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "audioRecorder",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"86d80","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"86d80":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audioRecorder", ()=>audioRecorder);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
//@ts-ignore
var _useBroadcast = require("../../lib/useBroadcast");
var _audioNode = require("../AudioTrack/audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const recorderWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/webNoise/AudioRecorder/audioNode.ts");
const audioRecorder = async (audioContext, data)=>{
    var _data_values;
    await audioContext.audioWorklet.addModule(recorderWorklet);
    const recorderNode = new AudioWorkletNode(audioContext, "audio-recorder-processor");
    const audioTrack = await (0, _audioNodeDefault.default)(audioContext);
    if (data === null || data === void 0 ? void 0 : (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.src) audioTrack.setValues({
        src: data.values.src
    });
    const record = recorderNode.parameters.get((0, _types.RecorderParameters).Record);
    const erase = recorderNode.parameters.get((0, _types.RecorderParameters).Erase);
    recorderNode.port.start();
    const channel = new MessageChannel();
    channel.port1.start();
    channel.port2.start();
    (0, _useBroadcast.addBroadcastListener)(recorderNode.port, channel.port1);
    channel.port2.addEventListener("message", (event)=>{
        audioTrack.audioTrackWorklet.port.postMessage(event.data);
    });
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, audioTrack), {
        inputs: {
            input: {
                port: recorderNode,
                type: (0, _constants.PortType).Audio
            },
            record: {
                port: record,
                type: (0, _constants.PortType).Gate,
                range: [
                    record.minValue,
                    record.maxValue
                ],
                defaultValue: record.value
            },
            erase: {
                port: erase,
                type: (0, _constants.PortType).Gate,
                range: [
                    erase.minValue,
                    erase.maxValue
                ],
                defaultValue: erase.value
            },
            play: audioTrack.inputs.gate,
            // @TODO: iterate over predefined inputs
            restart: audioTrack.inputs.restart,
            loop: audioTrack.inputs.loop,
            start: audioTrack.inputs.start,
            end: audioTrack.inputs.end,
            detune: audioTrack.inputs.detune,
            playbackRate: audioTrack.inputs.playbackRate
        },
        destroy: ()=>{
            var _audioTrack_destroy;
            recorderNode.port.close();
            (_audioTrack_destroy = audioTrack.destroy) === null || _audioTrack_destroy === void 0 ? void 0 : _audioTrack_destroy.call(audioTrack);
        },
        registerRecorderPort: (port)=>{
            (0, _useBroadcast.addBroadcastListener)(recorderNode.port, port);
            return recorderNode.port;
        }
    });
};
exports.default = audioRecorder;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core/constants":"36kMU","./types":"7uJ8w","worklet:./worklet.ts":"bgFDh","../../lib/useBroadcast":"ekNC4","../AudioTrack/audioNode":"1ptKb","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7uJ8w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RecorderParameters", ()=>RecorderParameters);
var RecorderParameters;
(function(RecorderParameters) {
    RecorderParameters["Record"] = "record";
    RecorderParameters["Erase"] = "erase";
})(RecorderParameters || (RecorderParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"bgFDh":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("9Bo6I");

},{}],"3Emc3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _react1 = require("react");
var _jsFileDownload = require("js-file-download");
var _jsFileDownloadDefault = parcelHelpers.interopDefault(_jsFileDownload);
var _fa = require("react-icons/fa");
//@ts-ignore
var _audiobufferToWav = require("audiobuffer-to-wav");
var _audiobufferToWavDefault = parcelHelpers.interopDefault(_audiobufferToWav);
var _core = require("@web-noise/core");
var _lib = require("@web-noise/core/lib");
var _format = require("../../lib/format");
var _wave = require("../AudioTrack/Wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
let _ = (t)=>t, t, t1, t2, t3, t4;
const RecorderWrapper = (0, _react.withTheme)((0, _styledDefault.default).div(t || (t = _``)));
const RecorderStatusPanel = (0, _react.withTheme)((0, _styledDefault.default).div(t1 || (t1 = _`
  background-color: ${0};
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 0 0.5rem;
  gap: 0.5rem;
`), ({ theme })=>theme.colors.elevation2));
const RecordingIndicator = (0, _react.withTheme)((0, _styledDefault.default).span(t2 || (t2 = _`
  color: ${0};
  &:after {
    content: "${0}";
  }
`), ({ theme, isRecording })=>isRecording ? theme.colors.accent3 : theme.colors.highlight1, ({ isRecording })=>isRecording ? "\u29BF" : "\u29BE"));
const RecrodingTime = (0, _react.withTheme)((0, _styledDefault.default).input(t3 || (t3 = _`
  text-align: right;
  pointer-events: none;
  outline: none;
  border: none;
  color: ${0};
  padding: 0.3rem 0;
  background: none;
  text-align: center;
  font-family: var(--leva-fonts-mono);
  width: 100%;
`), ({ isRecording, theme })=>isRecording ? theme.colors.highlight3 : theme.colors.highlight1));
const ActionButton = (0, _react.withTheme)((0, _styledDefault.default).button(t4 || (t4 = _`
  display: flex;
  background: none;
  outline: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 0;
  &:disabled {
    color: grey;
  }
`)));
const trackDataToWav = (trackData)=>{
    const audioCtx = new AudioContext({
        sampleRate: trackData.sampleRate
    });
    const buffer = audioCtx.createBuffer(trackData.channelData.length, trackData.channelData[0].length, trackData.sampleRate);
    // Create new Float32Arrays to ensure correct type
    for(let i = 0; i < trackData.channelData.length; i++){
        const channelData = new Float32Array(trackData.channelData[i]);
        buffer.copyToChannel(channelData, i);
    }
    const wav = (0, _audiobufferToWavDefault.default)(buffer);
    return wav;
};
const arrayBufferToBase64 = (buffer)=>{
    const bytes = new Uint8Array(buffer);
    let binary = "";
    const chunkSize = 0x4000; // 16 KB
    for(let i = 0; i < bytes.byteLength; i += chunkSize){
        const chunk = bytes.subarray(i, i + chunkSize);
        const numberArray = Array.from(chunk);
        binary += String.fromCharCode.apply(null, numberArray);
    }
    return btoa(binary);
};
const Recorder = ({ node: props, audioNode, updateNodeValues })=>{
    var _data_values;
    const { id, data } = props;
    const addFile = (0, _core.useStore)((store)=>store.addFile);
    const progressDisplayRef = (0, _react1.useRef)(null);
    const progressTimeRef = (0, _react1.useRef)(null);
    const [isRecording, setIsRecording] = (0, _react1.useState)(false);
    const recorderData = (0, _react1.useRef)(null);
    const playerChannel = (0, _lib.useMessageChannel)();
    const recorderChannel = (0, _lib.useMessageChannel)();
    const { waveColor, progressColor, rangeColor } = data.config || {};
    (0, _react1.useEffect)(()=>{
        if (!audioNode || !recorderChannel) return;
        const workletPort = audioNode.registerRecorderPort(recorderChannel.port1);
        const handleMessage = ({ data })=>{
            switch(data.name){
                case "START_RECORDING":
                    setIsRecording(()=>true);
                    break;
                case "STOP_RECORDING":
                    const audioData = recorderData.current;
                    if (!audioData) break;
                    const wav = trackDataToWav(audioData);
                    const base64Wav = arrayBufferToBase64(wav);
                    const dataURL = `data:audio/wav;base64,${base64Wav}`;
                    updateNodeValues({
                        src: dataURL
                    });
                    setIsRecording(()=>false);
                    break;
                case "ERASE":
                    recorderData.current = null;
                    updateNodeValues({
                        src: undefined
                    });
                    break;
            }
        };
        recorderChannel.port2.addEventListener("message", handleMessage);
        return ()=>{
            recorderChannel.port2.removeEventListener("message", handleMessage);
        };
    }, [
        audioNode,
        recorderChannel,
        recorderData,
        updateNodeValues
    ]);
    (0, _react1.useEffect)(()=>{
        if (!audioNode || !playerChannel) return;
        const workletPort = audioNode.registerPort(playerChannel.port1);
        const handleMessage = ({ data })=>{
            switch(data.name){
                case "track":
                    recorderData.current = data.data;
                    if (data.data.duration !== progressTimeRef.current) {
                        window.requestAnimationFrame(()=>{
                            if (!progressDisplayRef.current) return;
                            progressDisplayRef.current.value = (0, _format.durationToTime)(data.data.duration);
                        });
                        //@ts-ignore
                        progressTimeRef.current = data.data.duration;
                    }
                    break;
            }
        };
        playerChannel.port2.addEventListener("message", handleMessage);
        return ()=>{
            playerChannel.port2.removeEventListener("message", handleMessage);
        };
    }, [
        audioNode,
        playerChannel,
        recorderData
    ]);
    return (0, _jsxRuntime.jsxs)(RecorderWrapper, {
        children: [
            (0, _jsxRuntime.jsxs)(RecorderStatusPanel, {
                children: [
                    (0, _jsxRuntime.jsx)(RecordingIndicator, {
                        isRecording: isRecording
                    }),
                    (0, _jsxRuntime.jsx)(RecrodingTime, {
                        isRecording: isRecording,
                        ref: progressDisplayRef,
                        readOnly: true,
                        disabled: true,
                        defaultValue: (0, _format.durationToTime)(0)
                    }),
                    (0, _jsxRuntime.jsx)(ActionButton, {
                        disabled: isRecording || !((_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.src),
                        onClick: ()=>{
                            var _data_values;
                            const src = (_data_values = data.values) === null || _data_values === void 0 ? void 0 : _data_values.src;
                            if (!src) return;
                            addFile({
                                type: "audio",
                                // @TODO: use nanoid here
                                id: `audio-file-${+new Date()}`,
                                name: `recording-${+new Date()}.wav`,
                                file: src
                            });
                        },
                        children: (0, _jsxRuntime.jsx)((0, _fa.FaFileExport), {})
                    }),
                    (0, _jsxRuntime.jsx)(ActionButton, {
                        disabled: isRecording || !recorderData.current || !recorderData.current.length,
                        onClick: ()=>{
                            const audioData = recorderData.current;
                            if (!audioData) return;
                            const fileName = `web-noise-recording-${+new Date()}.wav`;
                            const wav = trackDataToWav(audioData);
                            (0, _jsFileDownloadDefault.default)(wav, fileName);
                        },
                        children: (0, _jsxRuntime.jsx)((0, _fa.FaFileDownload), {})
                    })
                ]
            }),
            (0, _jsxRuntime.jsx)("div", {
                style: {
                    position: "relative",
                    cursor: "default"
                },
                children: audioNode && playerChannel && (0, _jsxRuntime.jsx)((0, _waveDefault.default), {
                    waveColor: waveColor,
                    rangeColor: rangeColor,
                    progressColor: progressColor,
                    port: playerChannel.port2
                })
            })
        ]
    });
};
exports.default = Recorder;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@emotion/react":"ifT37","react":"lXMxO","js-file-download":"3XznK","react-icons/fa":"lut99","audiobuffer-to-wav":"ionGW","@web-noise/core":"8EHNf","@web-noise/core/lib":"8cGsd","../../lib/format":"nq8Oy","../AudioTrack/Wave":"f0GG8","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ionGW":[function(require,module,exports,__globalThis) {
module.exports = audioBufferToWav;
function audioBufferToWav(buffer, opt) {
    opt = opt || {};
    var numChannels = buffer.numberOfChannels;
    var sampleRate = buffer.sampleRate;
    var format = opt.float32 ? 3 : 1;
    var bitDepth = format === 3 ? 32 : 16;
    var result;
    if (numChannels === 2) result = interleave(buffer.getChannelData(0), buffer.getChannelData(1));
    else result = buffer.getChannelData(0);
    return encodeWAV(result, format, sampleRate, numChannels, bitDepth);
}
function encodeWAV(samples, format, sampleRate, numChannels, bitDepth) {
    var bytesPerSample = bitDepth / 8;
    var blockAlign = numChannels * bytesPerSample;
    var buffer = new ArrayBuffer(44 + samples.length * bytesPerSample);
    var view = new DataView(buffer);
    /* RIFF identifier */ writeString(view, 0, 'RIFF');
    /* RIFF chunk length */ view.setUint32(4, 36 + samples.length * bytesPerSample, true);
    /* RIFF type */ writeString(view, 8, 'WAVE');
    /* format chunk identifier */ writeString(view, 12, 'fmt ');
    /* format chunk length */ view.setUint32(16, 16, true);
    /* sample format (raw) */ view.setUint16(20, format, true);
    /* channel count */ view.setUint16(22, numChannels, true);
    /* sample rate */ view.setUint32(24, sampleRate, true);
    /* byte rate (sample rate * block align) */ view.setUint32(28, sampleRate * blockAlign, true);
    /* block align (channel count * bytes per sample) */ view.setUint16(32, blockAlign, true);
    /* bits per sample */ view.setUint16(34, bitDepth, true);
    /* data chunk identifier */ writeString(view, 36, 'data');
    /* data chunk length */ view.setUint32(40, samples.length * bytesPerSample, true);
    if (format === 1) floatTo16BitPCM(view, 44, samples);
    else writeFloat32(view, 44, samples);
    return buffer;
}
function interleave(inputL, inputR) {
    var length = inputL.length + inputR.length;
    var result = new Float32Array(length);
    var index = 0;
    var inputIndex = 0;
    while(index < length){
        result[index++] = inputL[inputIndex];
        result[index++] = inputR[inputIndex];
        inputIndex++;
    }
    return result;
}
function writeFloat32(output, offset, input) {
    for(var i = 0; i < input.length; i++, offset += 4)output.setFloat32(offset, input[i], true);
}
function floatTo16BitPCM(output, offset, input) {
    for(var i = 0; i < input.length; i++, offset += 2){
        var s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
    }
}
function writeString(view, offset, string) {
    for(var i = 0; i < string.length; i++)view.setUint8(offset + i, string.charCodeAt(i));
}

},{}],"nq8Oy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationToTime", ()=>durationToTime);
const durationToTime = (duration)=>{
    const m = Math.floor(duration / 60).toString().padStart(2, "0");
    const s = Math.floor(duration % 60).toString().padStart(2, "0");
    const ms = Math.floor(duration % 1 * 100).toString().padStart(2, "0");
    return `${m}:${s}.${ms}`;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"11Ipo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _audioRecorder = require("./AudioRecorder");
var _audioRecorderDefault = parcelHelpers.interopDefault(_audioRecorder);
const RecorderNode = (props)=>{
    const { id, data } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues } = (0, _core.useNode)(id);
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _audioRecorderDefault.default), {
            node: props,
            audioNode: node,
            updateNodeValues: updateNodeValues
        })
    }));
};
exports.default = RecorderNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","./AudioRecorder":"3Emc3","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ciVbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const config = {
    waveColor: "#007bff",
    progressColor: "#8c92a4",
    rangeColor: "#14df42",
    size: {
        width: 280,
        height: 110
    }
};
exports.default = config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ehjXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "Pass Through",
    description: "A simple utility node that passes the input signal directly to the output without modification. Useful for organizing patch cables.",
    info: `# Pass Through

A utility node that simply passes any signal from its input directly to its output. It has no effect on the sound.

## Purpose

- Organize complex patches by routing signals through a clear point.
- Create multiple connection points from a single source by chaining Pass Through nodes.
- Act as a placeholder or debugging point in a signal chain.`,
    tags: [
        "utility",
        "routing",
        "passthrough",
        "organization"
    ],
    portsDescription: {
        inputs: {
            in: "The signal to be passed through."
        },
        outputs: {
            out: "The unmodified output signal."
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"PFt8G","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"PFt8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "passThrough",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = plugin;

},{"./audioNode":"5LLFk","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7VS6o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _script = require("./Script");
var _scriptDefault = parcelHelpers.interopDefault(_script);
var _workletScript = require("./WorkletScript");
var _workletScriptDefault = parcelHelpers.interopDefault(_workletScript);
const scriptNodes = {
    components: [
        (0, _scriptDefault.default),
        (0, _workletScriptDefault.default)
    ],
    name: "Script nodes",
    description: "Programmable audio nodes that execute custom JavaScript code for creating unique audio processors, effects, and routing logic, debugging and sketching up audio graphs. Includes both control-rate and audio-rate processing options."
};
exports.default = scriptNodes;

},{"./Script":"klNs8","./WorkletScript":"aSq5F","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"klNs8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _scriptNode = require("../ScriptNode");
var _scriptNodeDefault = parcelHelpers.interopDefault(_scriptNode);
const Script = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _scriptNodeDefault.default),
    name: "Script (Programmable Audio Processor)",
    description: "Executes custom JavaScript code with access to the Web Audio API, enabling creation of custom audio routing, processing algorithms, and dynamic behaviors. Features multiple inputs/outputs, trigger events, and a sandboxed execution environment.",
    info: `# Script

A programmable audio processor that executes custom JavaScript code with access to the Web Audio API and multiple audio inputs/outputs.

## Purpose

- Create custom audio routing and processing logic not available in built-in nodes
- Implement unique DSP algorithms and sound design techniques
- Build dynamic, event-driven audio behaviors
- Prototype and experiment with audio processing ideas
- Combine and orchestrate multiple audio nodes programmatically

## Values

- **Expression**: JavaScript code that executes in a sandboxed environment with access to ScriptSandbox API. The code can create audio nodes, set up connections, and register event handlers. Code is transpiled and executed asynchronously, with errors reported through the message channel.

## ScriptSandbox API

The code has access to a global \`ScriptSandbox\` object with:

- **inputs**: Array of 4 AudioWorkletNode instances for receiving audio signals
- **outputs**: Array of 4 AudioWorkletNode instances for sending processed audio
- **audioContext**: The main AudioContext for creating Web Audio API nodes
- **onTriggered(fn)**: Register callback to execute when trigger input activates (signal > threshold)
- **onUntriggered(fn)**: Register callback to execute when trigger input deactivates (signal returns to 0)

## Example

\`\`\`javascript
const { inputs, outputs, audioContext } = ScriptSandbox;

// Simple pass-through
inputs[0].connect(outputs[0]);

// Create dynamic gain control
const gain = audioContext.createGain();
gain.gain.value = 0.5;
inputs[1].connect(gain).connect(outputs[1]);

// Respond to trigger events
ScriptSandbox.onTriggered(() => {
  gain.gain.value = 1.0; // Boost volume on trigger
});

ScriptSandbox.onUntriggered(() => {
  gain.gain.value = 0.5; // Return to normal
});

// Create filter sweep on input 2
const filter = audioContext.createBiquadFilter();
filter.type = 'lowpass';
filter.frequency.value = 1000;
inputs[2].connect(filter).connect(outputs[2]);

ScriptSandbox.onTriggered(() => {
  filter.frequency.setTargetAtTime(5000, audioContext.currentTime, 0.1);
});
\`\`\``,
    tags: [
        "programming",
        "scripting",
        "custom",
        "dynamic",
        "routing",
        "experimental"
    ],
    portsDescription: {
        inputs: {
            trigger: "Audio input that triggers event callbacks when signal crosses threshold",
            input0: "First audio input for custom processing",
            input1: "Second audio input for custom processing",
            input2: "Third audio input for custom processing",
            input3: "Fourth audio input for custom processing"
        },
        outputs: {
            output0: "First audio output from custom processing",
            output1: "Second audio output from custom processing",
            output2: "Third audio output from custom processing",
            output3: "Fourth audio output from custom processing"
        }
    }
});
exports.default = Script;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"J7KX9","../ScriptNode":"9mXTm","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"J7KX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const Script = {
    type: "script",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = Script;

},{"./audioNode":"1V69N","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1V69N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _constants = require("@web-noise/core/constants");
var _transpile = require("../transpile");
var _transpileDefault = parcelHelpers.interopDefault(_transpile);
//@ts-ignore
var _workletTs = require("worklet:../../webNoise/PassThrough/worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
//@ts-ignore
var _triggerWatcherWorkletTs = require("worklet:./triggerWatcher.worklet.ts");
var _triggerWatcherWorkletTsDefault = parcelHelpers.interopDefault(_triggerWatcherWorkletTs);
const passThroughWorker = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/scriptNodes/Script/audioNode.ts");
const triggerWatcherWorklet = new URL((0, _triggerWatcherWorkletTsDefault.default), "file:///packages/base-nodes/src/scriptNodes/Script/audioNode.ts");
const INPUTS_COUNT = 4;
const OUTPUTS_COUNT = 4;
const createPassThroughNode = (audioContext)=>new AudioWorkletNode(audioContext, "pass-through-processor");
const createPassThroughNodes = (audioContext, length)=>Array.from(new Array(length), ()=>createPassThroughNode(audioContext));
const AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const scriptNode = async (audioContext, data)=>{
    await Promise.all([
        audioContext.audioWorklet.addModule(passThroughWorker),
        audioContext.audioWorklet.addModule(triggerWatcherWorklet)
    ]);
    const triggerWatcher = new AudioWorkletNode(audioContext, "trigger-watcher-processor");
    triggerWatcher.port.start();
    const inputs = createPassThroughNodes(audioContext, INPUTS_COUNT);
    const outputs = createPassThroughNodes(audioContext, OUTPUTS_COUNT);
    let currentInputs = [];
    let currentOutputs = [];
    let currentOnTriggeredCallback = null;
    let currentOnUntriggeredCallback = null;
    triggerWatcher.port.addEventListener("message", ({ data })=>{
        switch(data.name){
            case "triggered":
                currentOnTriggeredCallback === null || currentOnTriggeredCallback === void 0 ? void 0 : currentOnTriggeredCallback();
                break;
            case "untriggered":
                currentOnUntriggeredCallback === null || currentOnUntriggeredCallback === void 0 ? void 0 : currentOnUntriggeredCallback();
                break;
        }
    });
    const runExpression = async (expression)=>{
        inputs.forEach((input, index)=>input.disconnect(currentInputs[index]));
        currentOutputs.forEach((output, index)=>output.disconnect(outputs[index]));
        currentOnTriggeredCallback = null;
        currentOnUntriggeredCallback = null;
        currentInputs = createPassThroughNodes(audioContext, INPUTS_COUNT);
        inputs.forEach((input, index)=>input.connect(currentInputs[index]));
        currentOutputs = createPassThroughNodes(audioContext, OUTPUTS_COUNT);
        currentOutputs.forEach((output, index)=>output.connect(outputs[index]));
        try {
            const expressionFn = new AsyncFunction("ScriptSandbox", (0, _transpileDefault.default)(expression));
            await expressionFn({
                onTriggered: (fn)=>{
                    currentOnTriggeredCallback = fn;
                },
                onUntriggered: (fn)=>{
                    currentOnUntriggeredCallback = fn;
                },
                inputs: currentInputs,
                outputs: currentOutputs,
                audioContext
            });
            channel.port1.postMessage({
                name: "clean-error"
            });
        } catch (error) {
            channel.port1.postMessage({
                name: "error",
                error
            });
        }
    };
    const channel = new MessageChannel();
    channel.port1.onmessage = ({ data })=>{
        switch(data.name){
            case "expression":
                runExpression(data.value);
                break;
        }
    };
    channel.port2.start();
    const { expression } = (data === null || data === void 0 ? void 0 : data.values) || {};
    expression && runExpression(expression);
    return {
        inputs: (0, _objectSpread._)({
            trigger: {
                port: triggerWatcher,
                type: (0, _constants.PortType).Gate
            }
        }, inputs.reduce((acc, port, index)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [`input${index}`]: {
                    port,
                    type: (0, _constants.PortType).Any
                }
            }), {})),
        outputs: outputs.reduce((acc, port, index)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), {
                [`output${index}`]: {
                    port,
                    type: (0, _constants.PortType).Any
                }
            }), {}),
        destroy: ()=>{
            triggerWatcher.port.close();
        },
        setValues: ({ expression } = {})=>{
            expression && channel.port2.postMessage({
                name: "expression",
                value: expression
            });
        },
        channel: channel.port2
    };
};
exports.default = scriptNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core/constants":"36kMU","../transpile":"htWAz","worklet:../../webNoise/PassThrough/worklet.ts":"aNNLv","worklet:./triggerWatcher.worklet.ts":"6zixU","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"htWAz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typescript = require("typescript");
var _typescriptDefault = parcelHelpers.interopDefault(_typescript);
const transpile = (expression)=>(0, _typescriptDefault.default).transpile(expression, {
        target: (0, _typescriptDefault.default).ScriptTarget.ESNext,
        module: (0, _typescriptDefault.default).ModuleKind.ESNext
    });
exports.default = transpile;

},{"typescript":"hxURv","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hxURv":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
let _ = (t)=>t, t, t1;
var process = require("7eaeaab38355d551");
var __filename = "node_modules/typescript/lib/typescript.js";
var __dirname = "node_modules/typescript/lib";
var global = arguments[3];
var Buffer = require("1db20b9c0a4ee0c9").Buffer;
var ts = {};
((module1)=>{
    "use strict";
    var __defProp = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __export = (target, all)=>{
        for(var name in all)__defProp(target, name, {
            get: all[name],
            enumerable: true
        });
    };
    var __copyProps = (to, from, except, desc)=>{
        if (from && typeof from === "object" || typeof from === "function") {
            for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                get: ()=>from[key],
                enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
            });
        }
        return to;
    };
    var __toCommonJS = (mod)=>(__copyProps, mod); // Modified helper to skip setting __esModule.
    // src/typescript/typescript.ts
    var typescript_exports = {};
    __export(typescript_exports, {
        ANONYMOUS: ()=>ANONYMOUS,
        AccessFlags: ()=>AccessFlags,
        AssertionLevel: ()=>AssertionLevel,
        AssignmentDeclarationKind: ()=>AssignmentDeclarationKind,
        AssignmentKind: ()=>AssignmentKind,
        Associativity: ()=>Associativity,
        BreakpointResolver: ()=>ts_BreakpointResolver_exports,
        BuilderFileEmit: ()=>BuilderFileEmit,
        BuilderProgramKind: ()=>BuilderProgramKind,
        BuilderState: ()=>BuilderState,
        CallHierarchy: ()=>ts_CallHierarchy_exports,
        CharacterCodes: ()=>CharacterCodes,
        CheckFlags: ()=>CheckFlags,
        CheckMode: ()=>CheckMode,
        ClassificationType: ()=>ClassificationType,
        ClassificationTypeNames: ()=>ClassificationTypeNames,
        CommentDirectiveType: ()=>CommentDirectiveType,
        Comparison: ()=>Comparison,
        CompletionInfoFlags: ()=>CompletionInfoFlags,
        CompletionTriggerKind: ()=>CompletionTriggerKind,
        Completions: ()=>ts_Completions_exports,
        ContainerFlags: ()=>ContainerFlags,
        ContextFlags: ()=>ContextFlags,
        Debug: ()=>Debug,
        DiagnosticCategory: ()=>DiagnosticCategory,
        Diagnostics: ()=>Diagnostics,
        DocumentHighlights: ()=>DocumentHighlights,
        ElementFlags: ()=>ElementFlags,
        EmitFlags: ()=>EmitFlags,
        EmitHint: ()=>EmitHint,
        EmitOnly: ()=>EmitOnly,
        EndOfLineState: ()=>EndOfLineState,
        ExitStatus: ()=>ExitStatus,
        ExportKind: ()=>ExportKind,
        Extension: ()=>Extension,
        ExternalEmitHelpers: ()=>ExternalEmitHelpers,
        FileIncludeKind: ()=>FileIncludeKind,
        FilePreprocessingDiagnosticsKind: ()=>FilePreprocessingDiagnosticsKind,
        FileSystemEntryKind: ()=>FileSystemEntryKind,
        FileWatcherEventKind: ()=>FileWatcherEventKind,
        FindAllReferences: ()=>ts_FindAllReferences_exports,
        FlattenLevel: ()=>FlattenLevel,
        FlowFlags: ()=>FlowFlags,
        ForegroundColorEscapeSequences: ()=>ForegroundColorEscapeSequences,
        FunctionFlags: ()=>FunctionFlags,
        GeneratedIdentifierFlags: ()=>GeneratedIdentifierFlags,
        GetLiteralTextFlags: ()=>GetLiteralTextFlags,
        GoToDefinition: ()=>ts_GoToDefinition_exports,
        HighlightSpanKind: ()=>HighlightSpanKind,
        IdentifierNameMap: ()=>IdentifierNameMap,
        ImportKind: ()=>ImportKind,
        ImportsNotUsedAsValues: ()=>ImportsNotUsedAsValues,
        IndentStyle: ()=>IndentStyle,
        IndexFlags: ()=>IndexFlags,
        IndexKind: ()=>IndexKind,
        InferenceFlags: ()=>InferenceFlags,
        InferencePriority: ()=>InferencePriority,
        InlayHintKind: ()=>InlayHintKind2,
        InlayHints: ()=>ts_InlayHints_exports,
        InternalEmitFlags: ()=>InternalEmitFlags,
        InternalNodeBuilderFlags: ()=>InternalNodeBuilderFlags,
        InternalSymbolName: ()=>InternalSymbolName,
        IntersectionFlags: ()=>IntersectionFlags,
        InvalidatedProjectKind: ()=>InvalidatedProjectKind,
        JSDocParsingMode: ()=>JSDocParsingMode,
        JsDoc: ()=>ts_JsDoc_exports,
        JsTyping: ()=>ts_JsTyping_exports,
        JsxEmit: ()=>JsxEmit,
        JsxFlags: ()=>JsxFlags,
        JsxReferenceKind: ()=>JsxReferenceKind,
        LanguageFeatureMinimumTarget: ()=>LanguageFeatureMinimumTarget,
        LanguageServiceMode: ()=>LanguageServiceMode,
        LanguageVariant: ()=>LanguageVariant,
        LexicalEnvironmentFlags: ()=>LexicalEnvironmentFlags,
        ListFormat: ()=>ListFormat,
        LogLevel: ()=>LogLevel,
        MapCode: ()=>ts_MapCode_exports,
        MemberOverrideStatus: ()=>MemberOverrideStatus,
        ModifierFlags: ()=>ModifierFlags,
        ModuleDetectionKind: ()=>ModuleDetectionKind,
        ModuleInstanceState: ()=>ModuleInstanceState,
        ModuleKind: ()=>ModuleKind,
        ModuleResolutionKind: ()=>ModuleResolutionKind,
        ModuleSpecifierEnding: ()=>ModuleSpecifierEnding,
        NavigateTo: ()=>ts_NavigateTo_exports,
        NavigationBar: ()=>ts_NavigationBar_exports,
        NewLineKind: ()=>NewLineKind,
        NodeBuilderFlags: ()=>NodeBuilderFlags,
        NodeCheckFlags: ()=>NodeCheckFlags,
        NodeFactoryFlags: ()=>NodeFactoryFlags,
        NodeFlags: ()=>NodeFlags,
        NodeResolutionFeatures: ()=>NodeResolutionFeatures,
        ObjectFlags: ()=>ObjectFlags,
        OperationCanceledException: ()=>OperationCanceledException,
        OperatorPrecedence: ()=>OperatorPrecedence,
        OrganizeImports: ()=>ts_OrganizeImports_exports,
        OrganizeImportsMode: ()=>OrganizeImportsMode,
        OuterExpressionKinds: ()=>OuterExpressionKinds,
        OutliningElementsCollector: ()=>ts_OutliningElementsCollector_exports,
        OutliningSpanKind: ()=>OutliningSpanKind,
        OutputFileType: ()=>OutputFileType,
        PackageJsonAutoImportPreference: ()=>PackageJsonAutoImportPreference,
        PackageJsonDependencyGroup: ()=>PackageJsonDependencyGroup,
        PatternMatchKind: ()=>PatternMatchKind,
        PollingInterval: ()=>PollingInterval,
        PollingWatchKind: ()=>PollingWatchKind,
        PragmaKindFlags: ()=>PragmaKindFlags,
        PredicateSemantics: ()=>PredicateSemantics,
        PreparePasteEdits: ()=>ts_preparePasteEdits_exports,
        PrivateIdentifierKind: ()=>PrivateIdentifierKind,
        ProcessLevel: ()=>ProcessLevel,
        ProgramUpdateLevel: ()=>ProgramUpdateLevel,
        QuotePreference: ()=>QuotePreference,
        RegularExpressionFlags: ()=>RegularExpressionFlags,
        RelationComparisonResult: ()=>RelationComparisonResult,
        Rename: ()=>ts_Rename_exports,
        ScriptElementKind: ()=>ScriptElementKind,
        ScriptElementKindModifier: ()=>ScriptElementKindModifier,
        ScriptKind: ()=>ScriptKind,
        ScriptSnapshot: ()=>ScriptSnapshot,
        ScriptTarget: ()=>ScriptTarget,
        SemanticClassificationFormat: ()=>SemanticClassificationFormat,
        SemanticMeaning: ()=>SemanticMeaning,
        SemicolonPreference: ()=>SemicolonPreference,
        SignatureCheckMode: ()=>SignatureCheckMode,
        SignatureFlags: ()=>SignatureFlags,
        SignatureHelp: ()=>ts_SignatureHelp_exports,
        SignatureInfo: ()=>SignatureInfo,
        SignatureKind: ()=>SignatureKind,
        SmartSelectionRange: ()=>ts_SmartSelectionRange_exports,
        SnippetKind: ()=>SnippetKind,
        StatisticType: ()=>StatisticType,
        StructureIsReused: ()=>StructureIsReused,
        SymbolAccessibility: ()=>SymbolAccessibility,
        SymbolDisplay: ()=>ts_SymbolDisplay_exports,
        SymbolDisplayPartKind: ()=>SymbolDisplayPartKind,
        SymbolFlags: ()=>SymbolFlags,
        SymbolFormatFlags: ()=>SymbolFormatFlags,
        SyntaxKind: ()=>SyntaxKind,
        Ternary: ()=>Ternary,
        ThrottledCancellationToken: ()=>ThrottledCancellationToken,
        TokenClass: ()=>TokenClass,
        TokenFlags: ()=>TokenFlags,
        TransformFlags: ()=>TransformFlags,
        TypeFacts: ()=>TypeFacts,
        TypeFlags: ()=>TypeFlags,
        TypeFormatFlags: ()=>TypeFormatFlags,
        TypeMapKind: ()=>TypeMapKind,
        TypePredicateKind: ()=>TypePredicateKind,
        TypeReferenceSerializationKind: ()=>TypeReferenceSerializationKind,
        UnionReduction: ()=>UnionReduction,
        UpToDateStatusType: ()=>UpToDateStatusType,
        VarianceFlags: ()=>VarianceFlags,
        Version: ()=>Version,
        VersionRange: ()=>VersionRange,
        WatchDirectoryFlags: ()=>WatchDirectoryFlags,
        WatchDirectoryKind: ()=>WatchDirectoryKind,
        WatchFileKind: ()=>WatchFileKind,
        WatchLogLevel: ()=>WatchLogLevel,
        WatchType: ()=>WatchType,
        accessPrivateIdentifier: ()=>accessPrivateIdentifier,
        addEmitFlags: ()=>addEmitFlags,
        addEmitHelper: ()=>addEmitHelper,
        addEmitHelpers: ()=>addEmitHelpers,
        addInternalEmitFlags: ()=>addInternalEmitFlags,
        addNodeFactoryPatcher: ()=>addNodeFactoryPatcher,
        addObjectAllocatorPatcher: ()=>addObjectAllocatorPatcher,
        addRange: ()=>addRange,
        addRelatedInfo: ()=>addRelatedInfo,
        addSyntheticLeadingComment: ()=>addSyntheticLeadingComment,
        addSyntheticTrailingComment: ()=>addSyntheticTrailingComment,
        addToSeen: ()=>addToSeen,
        advancedAsyncSuperHelper: ()=>advancedAsyncSuperHelper,
        affectsDeclarationPathOptionDeclarations: ()=>affectsDeclarationPathOptionDeclarations,
        affectsEmitOptionDeclarations: ()=>affectsEmitOptionDeclarations,
        allKeysStartWithDot: ()=>allKeysStartWithDot,
        altDirectorySeparator: ()=>altDirectorySeparator,
        and: ()=>and,
        append: ()=>append,
        appendIfUnique: ()=>appendIfUnique,
        arrayFrom: ()=>arrayFrom,
        arrayIsEqualTo: ()=>arrayIsEqualTo,
        arrayIsHomogeneous: ()=>arrayIsHomogeneous,
        arrayOf: ()=>arrayOf,
        arrayReverseIterator: ()=>arrayReverseIterator,
        arrayToMap: ()=>arrayToMap,
        arrayToMultiMap: ()=>arrayToMultiMap,
        arrayToNumericMap: ()=>arrayToNumericMap,
        assertType: ()=>assertType,
        assign: ()=>assign,
        asyncSuperHelper: ()=>asyncSuperHelper,
        attachFileToDiagnostics: ()=>attachFileToDiagnostics,
        base64decode: ()=>base64decode,
        base64encode: ()=>base64encode,
        binarySearch: ()=>binarySearch,
        binarySearchKey: ()=>binarySearchKey,
        bindSourceFile: ()=>bindSourceFile,
        breakIntoCharacterSpans: ()=>breakIntoCharacterSpans,
        breakIntoWordSpans: ()=>breakIntoWordSpans,
        buildLinkParts: ()=>buildLinkParts,
        buildOpts: ()=>buildOpts,
        buildOverload: ()=>buildOverload,
        bundlerModuleNameResolver: ()=>bundlerModuleNameResolver,
        canBeConvertedToAsync: ()=>canBeConvertedToAsync,
        canHaveDecorators: ()=>canHaveDecorators,
        canHaveExportModifier: ()=>canHaveExportModifier,
        canHaveFlowNode: ()=>canHaveFlowNode,
        canHaveIllegalDecorators: ()=>canHaveIllegalDecorators,
        canHaveIllegalModifiers: ()=>canHaveIllegalModifiers,
        canHaveIllegalType: ()=>canHaveIllegalType,
        canHaveIllegalTypeParameters: ()=>canHaveIllegalTypeParameters,
        canHaveJSDoc: ()=>canHaveJSDoc,
        canHaveLocals: ()=>canHaveLocals,
        canHaveModifiers: ()=>canHaveModifiers,
        canHaveModuleSpecifier: ()=>canHaveModuleSpecifier,
        canHaveSymbol: ()=>canHaveSymbol,
        canIncludeBindAndCheckDiagnostics: ()=>canIncludeBindAndCheckDiagnostics,
        canJsonReportNoInputFiles: ()=>canJsonReportNoInputFiles,
        canProduceDiagnostics: ()=>canProduceDiagnostics,
        canUsePropertyAccess: ()=>canUsePropertyAccess,
        canWatchAffectingLocation: ()=>canWatchAffectingLocation,
        canWatchAtTypes: ()=>canWatchAtTypes,
        canWatchDirectoryOrFile: ()=>canWatchDirectoryOrFile,
        canWatchDirectoryOrFilePath: ()=>canWatchDirectoryOrFilePath,
        cartesianProduct: ()=>cartesianProduct,
        cast: ()=>cast,
        chainBundle: ()=>chainBundle,
        chainDiagnosticMessages: ()=>chainDiagnosticMessages,
        changeAnyExtension: ()=>changeAnyExtension,
        changeCompilerHostLikeToUseCache: ()=>changeCompilerHostLikeToUseCache,
        changeExtension: ()=>changeExtension,
        changeFullExtension: ()=>changeFullExtension,
        changesAffectModuleResolution: ()=>changesAffectModuleResolution,
        changesAffectingProgramStructure: ()=>changesAffectingProgramStructure,
        characterCodeToRegularExpressionFlag: ()=>characterCodeToRegularExpressionFlag,
        childIsDecorated: ()=>childIsDecorated,
        classElementOrClassElementParameterIsDecorated: ()=>classElementOrClassElementParameterIsDecorated,
        classHasClassThisAssignment: ()=>classHasClassThisAssignment,
        classHasDeclaredOrExplicitlyAssignedName: ()=>classHasDeclaredOrExplicitlyAssignedName,
        classHasExplicitlyAssignedName: ()=>classHasExplicitlyAssignedName,
        classOrConstructorParameterIsDecorated: ()=>classOrConstructorParameterIsDecorated,
        classicNameResolver: ()=>classicNameResolver,
        classifier: ()=>ts_classifier_exports,
        cleanExtendedConfigCache: ()=>cleanExtendedConfigCache,
        clear: ()=>clear,
        clearMap: ()=>clearMap,
        clearSharedExtendedConfigFileWatcher: ()=>clearSharedExtendedConfigFileWatcher,
        climbPastPropertyAccess: ()=>climbPastPropertyAccess,
        clone: ()=>clone,
        cloneCompilerOptions: ()=>cloneCompilerOptions,
        closeFileWatcher: ()=>closeFileWatcher,
        closeFileWatcherOf: ()=>closeFileWatcherOf,
        codefix: ()=>ts_codefix_exports,
        collapseTextChangeRangesAcrossMultipleVersions: ()=>collapseTextChangeRangesAcrossMultipleVersions,
        collectExternalModuleInfo: ()=>collectExternalModuleInfo,
        combine: ()=>combine,
        combinePaths: ()=>combinePaths,
        commandLineOptionOfCustomType: ()=>commandLineOptionOfCustomType,
        commentPragmas: ()=>commentPragmas,
        commonOptionsWithBuild: ()=>commonOptionsWithBuild,
        compact: ()=>compact,
        compareBooleans: ()=>compareBooleans,
        compareDataObjects: ()=>compareDataObjects,
        compareDiagnostics: ()=>compareDiagnostics,
        compareEmitHelpers: ()=>compareEmitHelpers,
        compareNumberOfDirectorySeparators: ()=>compareNumberOfDirectorySeparators,
        comparePaths: ()=>comparePaths,
        comparePathsCaseInsensitive: ()=>comparePathsCaseInsensitive,
        comparePathsCaseSensitive: ()=>comparePathsCaseSensitive,
        comparePatternKeys: ()=>comparePatternKeys,
        compareProperties: ()=>compareProperties,
        compareStringsCaseInsensitive: ()=>compareStringsCaseInsensitive,
        compareStringsCaseInsensitiveEslintCompatible: ()=>compareStringsCaseInsensitiveEslintCompatible,
        compareStringsCaseSensitive: ()=>compareStringsCaseSensitive,
        compareStringsCaseSensitiveUI: ()=>compareStringsCaseSensitiveUI,
        compareTextSpans: ()=>compareTextSpans,
        compareValues: ()=>compareValues,
        compilerOptionsAffectDeclarationPath: ()=>compilerOptionsAffectDeclarationPath,
        compilerOptionsAffectEmit: ()=>compilerOptionsAffectEmit,
        compilerOptionsAffectSemanticDiagnostics: ()=>compilerOptionsAffectSemanticDiagnostics,
        compilerOptionsDidYouMeanDiagnostics: ()=>compilerOptionsDidYouMeanDiagnostics,
        compilerOptionsIndicateEsModules: ()=>compilerOptionsIndicateEsModules,
        computeCommonSourceDirectoryOfFilenames: ()=>computeCommonSourceDirectoryOfFilenames,
        computeLineAndCharacterOfPosition: ()=>computeLineAndCharacterOfPosition,
        computeLineOfPosition: ()=>computeLineOfPosition,
        computeLineStarts: ()=>computeLineStarts,
        computePositionOfLineAndCharacter: ()=>computePositionOfLineAndCharacter,
        computeSignatureWithDiagnostics: ()=>computeSignatureWithDiagnostics,
        computeSuggestionDiagnostics: ()=>computeSuggestionDiagnostics,
        computedOptions: ()=>computedOptions,
        concatenate: ()=>concatenate,
        concatenateDiagnosticMessageChains: ()=>concatenateDiagnosticMessageChains,
        consumesNodeCoreModules: ()=>consumesNodeCoreModules,
        contains: ()=>contains,
        containsIgnoredPath: ()=>containsIgnoredPath,
        containsObjectRestOrSpread: ()=>containsObjectRestOrSpread,
        containsParseError: ()=>containsParseError,
        containsPath: ()=>containsPath,
        convertCompilerOptionsForTelemetry: ()=>convertCompilerOptionsForTelemetry,
        convertCompilerOptionsFromJson: ()=>convertCompilerOptionsFromJson,
        convertJsonOption: ()=>convertJsonOption,
        convertToBase64: ()=>convertToBase64,
        convertToJson: ()=>convertToJson,
        convertToObject: ()=>convertToObject,
        convertToOptionsWithAbsolutePaths: ()=>convertToOptionsWithAbsolutePaths,
        convertToRelativePath: ()=>convertToRelativePath,
        convertToTSConfig: ()=>convertToTSConfig,
        convertTypeAcquisitionFromJson: ()=>convertTypeAcquisitionFromJson,
        copyComments: ()=>copyComments,
        copyEntries: ()=>copyEntries,
        copyLeadingComments: ()=>copyLeadingComments,
        copyProperties: ()=>copyProperties,
        copyTrailingAsLeadingComments: ()=>copyTrailingAsLeadingComments,
        copyTrailingComments: ()=>copyTrailingComments,
        couldStartTrivia: ()=>couldStartTrivia,
        countWhere: ()=>countWhere,
        createAbstractBuilder: ()=>createAbstractBuilder,
        createAccessorPropertyBackingField: ()=>createAccessorPropertyBackingField,
        createAccessorPropertyGetRedirector: ()=>createAccessorPropertyGetRedirector,
        createAccessorPropertySetRedirector: ()=>createAccessorPropertySetRedirector,
        createBaseNodeFactory: ()=>createBaseNodeFactory,
        createBinaryExpressionTrampoline: ()=>createBinaryExpressionTrampoline,
        createBuilderProgram: ()=>createBuilderProgram,
        createBuilderProgramUsingIncrementalBuildInfo: ()=>createBuilderProgramUsingIncrementalBuildInfo,
        createBuilderStatusReporter: ()=>createBuilderStatusReporter,
        createCacheableExportInfoMap: ()=>createCacheableExportInfoMap,
        createCachedDirectoryStructureHost: ()=>createCachedDirectoryStructureHost,
        createClassifier: ()=>createClassifier,
        createCommentDirectivesMap: ()=>createCommentDirectivesMap,
        createCompilerDiagnostic: ()=>createCompilerDiagnostic,
        createCompilerDiagnosticForInvalidCustomType: ()=>createCompilerDiagnosticForInvalidCustomType,
        createCompilerDiagnosticFromMessageChain: ()=>createCompilerDiagnosticFromMessageChain,
        createCompilerHost: ()=>createCompilerHost,
        createCompilerHostFromProgramHost: ()=>createCompilerHostFromProgramHost,
        createCompilerHostWorker: ()=>createCompilerHostWorker,
        createDetachedDiagnostic: ()=>createDetachedDiagnostic,
        createDiagnosticCollection: ()=>createDiagnosticCollection,
        createDiagnosticForFileFromMessageChain: ()=>createDiagnosticForFileFromMessageChain,
        createDiagnosticForNode: ()=>createDiagnosticForNode,
        createDiagnosticForNodeArray: ()=>createDiagnosticForNodeArray,
        createDiagnosticForNodeArrayFromMessageChain: ()=>createDiagnosticForNodeArrayFromMessageChain,
        createDiagnosticForNodeFromMessageChain: ()=>createDiagnosticForNodeFromMessageChain,
        createDiagnosticForNodeInSourceFile: ()=>createDiagnosticForNodeInSourceFile,
        createDiagnosticForRange: ()=>createDiagnosticForRange,
        createDiagnosticMessageChainFromDiagnostic: ()=>createDiagnosticMessageChainFromDiagnostic,
        createDiagnosticReporter: ()=>createDiagnosticReporter,
        createDocumentPositionMapper: ()=>createDocumentPositionMapper,
        createDocumentRegistry: ()=>createDocumentRegistry,
        createDocumentRegistryInternal: ()=>createDocumentRegistryInternal,
        createEmitAndSemanticDiagnosticsBuilderProgram: ()=>createEmitAndSemanticDiagnosticsBuilderProgram,
        createEmitHelperFactory: ()=>createEmitHelperFactory,
        createEmptyExports: ()=>createEmptyExports,
        createEvaluator: ()=>createEvaluator,
        createExpressionForJsxElement: ()=>createExpressionForJsxElement,
        createExpressionForJsxFragment: ()=>createExpressionForJsxFragment,
        createExpressionForObjectLiteralElementLike: ()=>createExpressionForObjectLiteralElementLike,
        createExpressionForPropertyName: ()=>createExpressionForPropertyName,
        createExpressionFromEntityName: ()=>createExpressionFromEntityName,
        createExternalHelpersImportDeclarationIfNeeded: ()=>createExternalHelpersImportDeclarationIfNeeded,
        createFileDiagnostic: ()=>createFileDiagnostic,
        createFileDiagnosticFromMessageChain: ()=>createFileDiagnosticFromMessageChain,
        createFlowNode: ()=>createFlowNode,
        createForOfBindingStatement: ()=>createForOfBindingStatement,
        createFutureSourceFile: ()=>createFutureSourceFile,
        createGetCanonicalFileName: ()=>createGetCanonicalFileName,
        createGetIsolatedDeclarationErrors: ()=>createGetIsolatedDeclarationErrors,
        createGetSourceFile: ()=>createGetSourceFile,
        createGetSymbolAccessibilityDiagnosticForNode: ()=>createGetSymbolAccessibilityDiagnosticForNode,
        createGetSymbolAccessibilityDiagnosticForNodeName: ()=>createGetSymbolAccessibilityDiagnosticForNodeName,
        createGetSymbolWalker: ()=>createGetSymbolWalker,
        createIncrementalCompilerHost: ()=>createIncrementalCompilerHost,
        createIncrementalProgram: ()=>createIncrementalProgram,
        createJsxFactoryExpression: ()=>createJsxFactoryExpression,
        createLanguageService: ()=>createLanguageService,
        createLanguageServiceSourceFile: ()=>createLanguageServiceSourceFile,
        createMemberAccessForPropertyName: ()=>createMemberAccessForPropertyName,
        createModeAwareCache: ()=>createModeAwareCache,
        createModeAwareCacheKey: ()=>createModeAwareCacheKey,
        createModeMismatchDetails: ()=>createModeMismatchDetails,
        createModuleNotFoundChain: ()=>createModuleNotFoundChain,
        createModuleResolutionCache: ()=>createModuleResolutionCache,
        createModuleResolutionLoader: ()=>createModuleResolutionLoader,
        createModuleResolutionLoaderUsingGlobalCache: ()=>createModuleResolutionLoaderUsingGlobalCache,
        createModuleSpecifierResolutionHost: ()=>createModuleSpecifierResolutionHost,
        createMultiMap: ()=>createMultiMap,
        createNameResolver: ()=>createNameResolver,
        createNodeConverters: ()=>createNodeConverters,
        createNodeFactory: ()=>createNodeFactory,
        createOptionNameMap: ()=>createOptionNameMap,
        createOverload: ()=>createOverload,
        createPackageJsonImportFilter: ()=>createPackageJsonImportFilter,
        createPackageJsonInfo: ()=>createPackageJsonInfo,
        createParenthesizerRules: ()=>createParenthesizerRules,
        createPatternMatcher: ()=>createPatternMatcher,
        createPrinter: ()=>createPrinter,
        createPrinterWithDefaults: ()=>createPrinterWithDefaults,
        createPrinterWithRemoveComments: ()=>createPrinterWithRemoveComments,
        createPrinterWithRemoveCommentsNeverAsciiEscape: ()=>createPrinterWithRemoveCommentsNeverAsciiEscape,
        createPrinterWithRemoveCommentsOmitTrailingSemicolon: ()=>createPrinterWithRemoveCommentsOmitTrailingSemicolon,
        createProgram: ()=>createProgram,
        createProgramDiagnostics: ()=>createProgramDiagnostics,
        createProgramHost: ()=>createProgramHost,
        createPropertyNameNodeForIdentifierOrLiteral: ()=>createPropertyNameNodeForIdentifierOrLiteral,
        createQueue: ()=>createQueue,
        createRange: ()=>createRange,
        createRedirectedBuilderProgram: ()=>createRedirectedBuilderProgram,
        createResolutionCache: ()=>createResolutionCache,
        createRuntimeTypeSerializer: ()=>createRuntimeTypeSerializer,
        createScanner: ()=>createScanner,
        createSemanticDiagnosticsBuilderProgram: ()=>createSemanticDiagnosticsBuilderProgram,
        createSet: ()=>createSet,
        createSolutionBuilder: ()=>createSolutionBuilder,
        createSolutionBuilderHost: ()=>createSolutionBuilderHost,
        createSolutionBuilderWithWatch: ()=>createSolutionBuilderWithWatch,
        createSolutionBuilderWithWatchHost: ()=>createSolutionBuilderWithWatchHost,
        createSortedArray: ()=>createSortedArray,
        createSourceFile: ()=>createSourceFile,
        createSourceMapGenerator: ()=>createSourceMapGenerator,
        createSourceMapSource: ()=>createSourceMapSource,
        createSuperAccessVariableStatement: ()=>createSuperAccessVariableStatement,
        createSymbolTable: ()=>createSymbolTable,
        createSymlinkCache: ()=>createSymlinkCache,
        createSyntacticTypeNodeBuilder: ()=>createSyntacticTypeNodeBuilder,
        createSystemWatchFunctions: ()=>createSystemWatchFunctions,
        createTextChange: ()=>createTextChange,
        createTextChangeFromStartLength: ()=>createTextChangeFromStartLength,
        createTextChangeRange: ()=>createTextChangeRange,
        createTextRangeFromNode: ()=>createTextRangeFromNode,
        createTextRangeFromSpan: ()=>createTextRangeFromSpan,
        createTextSpan: ()=>createTextSpan,
        createTextSpanFromBounds: ()=>createTextSpanFromBounds,
        createTextSpanFromNode: ()=>createTextSpanFromNode,
        createTextSpanFromRange: ()=>createTextSpanFromRange,
        createTextSpanFromStringLiteralLikeContent: ()=>createTextSpanFromStringLiteralLikeContent,
        createTextWriter: ()=>createTextWriter,
        createTokenRange: ()=>createTokenRange,
        createTypeChecker: ()=>createTypeChecker,
        createTypeReferenceDirectiveResolutionCache: ()=>createTypeReferenceDirectiveResolutionCache,
        createTypeReferenceResolutionLoader: ()=>createTypeReferenceResolutionLoader,
        createWatchCompilerHost: ()=>createWatchCompilerHost2,
        createWatchCompilerHostOfConfigFile: ()=>createWatchCompilerHostOfConfigFile,
        createWatchCompilerHostOfFilesAndCompilerOptions: ()=>createWatchCompilerHostOfFilesAndCompilerOptions,
        createWatchFactory: ()=>createWatchFactory,
        createWatchHost: ()=>createWatchHost,
        createWatchProgram: ()=>createWatchProgram,
        createWatchStatusReporter: ()=>createWatchStatusReporter,
        createWriteFileMeasuringIO: ()=>createWriteFileMeasuringIO,
        declarationNameToString: ()=>declarationNameToString,
        decodeMappings: ()=>decodeMappings,
        decodedTextSpanIntersectsWith: ()=>decodedTextSpanIntersectsWith,
        deduplicate: ()=>deduplicate,
        defaultHoverMaximumTruncationLength: ()=>defaultHoverMaximumTruncationLength,
        defaultInitCompilerOptions: ()=>defaultInitCompilerOptions,
        defaultMaximumTruncationLength: ()=>defaultMaximumTruncationLength,
        diagnosticCategoryName: ()=>diagnosticCategoryName,
        diagnosticToString: ()=>diagnosticToString,
        diagnosticsEqualityComparer: ()=>diagnosticsEqualityComparer,
        directoryProbablyExists: ()=>directoryProbablyExists,
        directorySeparator: ()=>directorySeparator,
        displayPart: ()=>displayPart,
        displayPartsToString: ()=>displayPartsToString,
        disposeEmitNodes: ()=>disposeEmitNodes,
        documentSpansEqual: ()=>documentSpansEqual,
        dumpTracingLegend: ()=>dumpTracingLegend,
        elementAt: ()=>elementAt,
        elideNodes: ()=>elideNodes,
        emitDetachedComments: ()=>emitDetachedComments,
        emitFiles: ()=>emitFiles,
        emitFilesAndReportErrors: ()=>emitFilesAndReportErrors,
        emitFilesAndReportErrorsAndGetExitStatus: ()=>emitFilesAndReportErrorsAndGetExitStatus,
        emitModuleKindIsNonNodeESM: ()=>emitModuleKindIsNonNodeESM,
        emitNewLineBeforeLeadingCommentOfPosition: ()=>emitNewLineBeforeLeadingCommentOfPosition,
        emitResolverSkipsTypeChecking: ()=>emitResolverSkipsTypeChecking,
        emitSkippedWithNoDiagnostics: ()=>emitSkippedWithNoDiagnostics,
        emptyArray: ()=>emptyArray,
        emptyFileSystemEntries: ()=>emptyFileSystemEntries,
        emptyMap: ()=>emptyMap,
        emptyOptions: ()=>emptyOptions,
        endsWith: ()=>endsWith,
        ensurePathIsNonModuleName: ()=>ensurePathIsNonModuleName,
        ensureScriptKind: ()=>ensureScriptKind,
        ensureTrailingDirectorySeparator: ()=>ensureTrailingDirectorySeparator,
        entityNameToString: ()=>entityNameToString,
        enumerateInsertsAndDeletes: ()=>enumerateInsertsAndDeletes,
        equalOwnProperties: ()=>equalOwnProperties,
        equateStringsCaseInsensitive: ()=>equateStringsCaseInsensitive,
        equateStringsCaseSensitive: ()=>equateStringsCaseSensitive,
        equateValues: ()=>equateValues,
        escapeJsxAttributeString: ()=>escapeJsxAttributeString,
        escapeLeadingUnderscores: ()=>escapeLeadingUnderscores,
        escapeNonAsciiString: ()=>escapeNonAsciiString,
        escapeSnippetText: ()=>escapeSnippetText,
        escapeString: ()=>escapeString,
        escapeTemplateSubstitution: ()=>escapeTemplateSubstitution,
        evaluatorResult: ()=>evaluatorResult,
        every: ()=>every,
        exclusivelyPrefixedNodeCoreModules: ()=>exclusivelyPrefixedNodeCoreModules,
        executeCommandLine: ()=>executeCommandLine,
        expandPreOrPostfixIncrementOrDecrementExpression: ()=>expandPreOrPostfixIncrementOrDecrementExpression,
        explainFiles: ()=>explainFiles,
        explainIfFileIsRedirectAndImpliedFormat: ()=>explainIfFileIsRedirectAndImpliedFormat,
        exportAssignmentIsAlias: ()=>exportAssignmentIsAlias,
        expressionResultIsUnused: ()=>expressionResultIsUnused,
        extend: ()=>extend,
        extensionFromPath: ()=>extensionFromPath,
        extensionIsTS: ()=>extensionIsTS,
        extensionsNotSupportingExtensionlessResolution: ()=>extensionsNotSupportingExtensionlessResolution,
        externalHelpersModuleNameText: ()=>externalHelpersModuleNameText,
        factory: ()=>factory,
        fileExtensionIs: ()=>fileExtensionIs,
        fileExtensionIsOneOf: ()=>fileExtensionIsOneOf,
        fileIncludeReasonToDiagnostics: ()=>fileIncludeReasonToDiagnostics,
        fileShouldUseJavaScriptRequire: ()=>fileShouldUseJavaScriptRequire,
        filter: ()=>filter,
        filterMutate: ()=>filterMutate,
        filterSemanticDiagnostics: ()=>filterSemanticDiagnostics,
        find: ()=>find,
        findAncestor: ()=>findAncestor,
        findBestPatternMatch: ()=>findBestPatternMatch,
        findChildOfKind: ()=>findChildOfKind,
        findComputedPropertyNameCacheAssignment: ()=>findComputedPropertyNameCacheAssignment,
        findConfigFile: ()=>findConfigFile,
        findConstructorDeclaration: ()=>findConstructorDeclaration,
        findContainingList: ()=>findContainingList,
        findDiagnosticForNode: ()=>findDiagnosticForNode,
        findFirstNonJsxWhitespaceToken: ()=>findFirstNonJsxWhitespaceToken,
        findIndex: ()=>findIndex,
        findLast: ()=>findLast,
        findLastIndex: ()=>findLastIndex,
        findListItemInfo: ()=>findListItemInfo,
        findModifier: ()=>findModifier,
        findNextToken: ()=>findNextToken,
        findPackageJson: ()=>findPackageJson,
        findPackageJsons: ()=>findPackageJsons,
        findPrecedingMatchingToken: ()=>findPrecedingMatchingToken,
        findPrecedingToken: ()=>findPrecedingToken,
        findSuperStatementIndexPath: ()=>findSuperStatementIndexPath,
        findTokenOnLeftOfPosition: ()=>findTokenOnLeftOfPosition,
        findUseStrictPrologue: ()=>findUseStrictPrologue,
        first: ()=>first,
        firstDefined: ()=>firstDefined,
        firstDefinedIterator: ()=>firstDefinedIterator,
        firstIterator: ()=>firstIterator,
        firstOrOnly: ()=>firstOrOnly,
        firstOrUndefined: ()=>firstOrUndefined,
        firstOrUndefinedIterator: ()=>firstOrUndefinedIterator,
        fixupCompilerOptions: ()=>fixupCompilerOptions,
        flatMap: ()=>flatMap,
        flatMapIterator: ()=>flatMapIterator,
        flatMapToMutable: ()=>flatMapToMutable,
        flatten: ()=>flatten,
        flattenCommaList: ()=>flattenCommaList,
        flattenDestructuringAssignment: ()=>flattenDestructuringAssignment,
        flattenDestructuringBinding: ()=>flattenDestructuringBinding,
        flattenDiagnosticMessageText: ()=>flattenDiagnosticMessageText,
        forEach: ()=>forEach,
        forEachAncestor: ()=>forEachAncestor,
        forEachAncestorDirectory: ()=>forEachAncestorDirectory,
        forEachAncestorDirectoryStoppingAtGlobalCache: ()=>forEachAncestorDirectoryStoppingAtGlobalCache,
        forEachChild: ()=>forEachChild,
        forEachChildRecursively: ()=>forEachChildRecursively,
        forEachDynamicImportOrRequireCall: ()=>forEachDynamicImportOrRequireCall,
        forEachEmittedFile: ()=>forEachEmittedFile,
        forEachEnclosingBlockScopeContainer: ()=>forEachEnclosingBlockScopeContainer,
        forEachEntry: ()=>forEachEntry,
        forEachExternalModuleToImportFrom: ()=>forEachExternalModuleToImportFrom,
        forEachImportClauseDeclaration: ()=>forEachImportClauseDeclaration,
        forEachKey: ()=>forEachKey,
        forEachLeadingCommentRange: ()=>forEachLeadingCommentRange,
        forEachNameInAccessChainWalkingLeft: ()=>forEachNameInAccessChainWalkingLeft,
        forEachNameOfDefaultExport: ()=>forEachNameOfDefaultExport,
        forEachOptionsSyntaxByName: ()=>forEachOptionsSyntaxByName,
        forEachProjectReference: ()=>forEachProjectReference,
        forEachPropertyAssignment: ()=>forEachPropertyAssignment,
        forEachResolvedProjectReference: ()=>forEachResolvedProjectReference,
        forEachReturnStatement: ()=>forEachReturnStatement,
        forEachRight: ()=>forEachRight,
        forEachTrailingCommentRange: ()=>forEachTrailingCommentRange,
        forEachTsConfigPropArray: ()=>forEachTsConfigPropArray,
        forEachUnique: ()=>forEachUnique,
        forEachYieldExpression: ()=>forEachYieldExpression,
        formatColorAndReset: ()=>formatColorAndReset,
        formatDiagnostic: ()=>formatDiagnostic,
        formatDiagnostics: ()=>formatDiagnostics,
        formatDiagnosticsWithColorAndContext: ()=>formatDiagnosticsWithColorAndContext,
        formatGeneratedName: ()=>formatGeneratedName,
        formatGeneratedNamePart: ()=>formatGeneratedNamePart,
        formatLocation: ()=>formatLocation,
        formatMessage: ()=>formatMessage,
        formatStringFromArgs: ()=>formatStringFromArgs,
        formatting: ()=>ts_formatting_exports,
        generateDjb2Hash: ()=>generateDjb2Hash,
        generateTSConfig: ()=>generateTSConfig,
        getAdjustedReferenceLocation: ()=>getAdjustedReferenceLocation,
        getAdjustedRenameLocation: ()=>getAdjustedRenameLocation,
        getAliasDeclarationFromName: ()=>getAliasDeclarationFromName,
        getAllAccessorDeclarations: ()=>getAllAccessorDeclarations,
        getAllDecoratorsOfClass: ()=>getAllDecoratorsOfClass,
        getAllDecoratorsOfClassElement: ()=>getAllDecoratorsOfClassElement,
        getAllJSDocTags: ()=>getAllJSDocTags,
        getAllJSDocTagsOfKind: ()=>getAllJSDocTagsOfKind,
        getAllKeys: ()=>getAllKeys,
        getAllProjectOutputs: ()=>getAllProjectOutputs,
        getAllSuperTypeNodes: ()=>getAllSuperTypeNodes,
        getAllowImportingTsExtensions: ()=>getAllowImportingTsExtensions,
        getAllowJSCompilerOption: ()=>getAllowJSCompilerOption,
        getAllowSyntheticDefaultImports: ()=>getAllowSyntheticDefaultImports,
        getAncestor: ()=>getAncestor,
        getAnyExtensionFromPath: ()=>getAnyExtensionFromPath,
        getAreDeclarationMapsEnabled: ()=>getAreDeclarationMapsEnabled,
        getAssignedExpandoInitializer: ()=>getAssignedExpandoInitializer,
        getAssignedName: ()=>getAssignedName,
        getAssignmentDeclarationKind: ()=>getAssignmentDeclarationKind,
        getAssignmentDeclarationPropertyAccessKind: ()=>getAssignmentDeclarationPropertyAccessKind,
        getAssignmentTargetKind: ()=>getAssignmentTargetKind,
        getAutomaticTypeDirectiveNames: ()=>getAutomaticTypeDirectiveNames,
        getBaseFileName: ()=>getBaseFileName,
        getBinaryOperatorPrecedence: ()=>getBinaryOperatorPrecedence,
        getBuildInfo: ()=>getBuildInfo,
        getBuildInfoFileVersionMap: ()=>getBuildInfoFileVersionMap,
        getBuildInfoText: ()=>getBuildInfoText,
        getBuildOrderFromAnyBuildOrder: ()=>getBuildOrderFromAnyBuildOrder,
        getBuilderCreationParameters: ()=>getBuilderCreationParameters,
        getBuilderFileEmit: ()=>getBuilderFileEmit,
        getCanonicalDiagnostic: ()=>getCanonicalDiagnostic,
        getCheckFlags: ()=>getCheckFlags,
        getClassExtendsHeritageElement: ()=>getClassExtendsHeritageElement,
        getClassLikeDeclarationOfSymbol: ()=>getClassLikeDeclarationOfSymbol,
        getCombinedLocalAndExportSymbolFlags: ()=>getCombinedLocalAndExportSymbolFlags,
        getCombinedModifierFlags: ()=>getCombinedModifierFlags,
        getCombinedNodeFlags: ()=>getCombinedNodeFlags,
        getCombinedNodeFlagsAlwaysIncludeJSDoc: ()=>getCombinedNodeFlagsAlwaysIncludeJSDoc,
        getCommentRange: ()=>getCommentRange,
        getCommonSourceDirectory: ()=>getCommonSourceDirectory,
        getCommonSourceDirectoryOfConfig: ()=>getCommonSourceDirectoryOfConfig,
        getCompilerOptionValue: ()=>getCompilerOptionValue,
        getConditions: ()=>getConditions,
        getConfigFileParsingDiagnostics: ()=>getConfigFileParsingDiagnostics,
        getConstantValue: ()=>getConstantValue,
        getContainerFlags: ()=>getContainerFlags,
        getContainerNode: ()=>getContainerNode,
        getContainingClass: ()=>getContainingClass,
        getContainingClassExcludingClassDecorators: ()=>getContainingClassExcludingClassDecorators,
        getContainingClassStaticBlock: ()=>getContainingClassStaticBlock,
        getContainingFunction: ()=>getContainingFunction,
        getContainingFunctionDeclaration: ()=>getContainingFunctionDeclaration,
        getContainingFunctionOrClassStaticBlock: ()=>getContainingFunctionOrClassStaticBlock,
        getContainingNodeArray: ()=>getContainingNodeArray,
        getContainingObjectLiteralElement: ()=>getContainingObjectLiteralElement,
        getContextualTypeFromParent: ()=>getContextualTypeFromParent,
        getContextualTypeFromParentOrAncestorTypeNode: ()=>getContextualTypeFromParentOrAncestorTypeNode,
        getDeclarationDiagnostics: ()=>getDeclarationDiagnostics,
        getDeclarationEmitExtensionForPath: ()=>getDeclarationEmitExtensionForPath,
        getDeclarationEmitOutputFilePath: ()=>getDeclarationEmitOutputFilePath,
        getDeclarationEmitOutputFilePathWorker: ()=>getDeclarationEmitOutputFilePathWorker,
        getDeclarationFileExtension: ()=>getDeclarationFileExtension,
        getDeclarationFromName: ()=>getDeclarationFromName,
        getDeclarationModifierFlagsFromSymbol: ()=>getDeclarationModifierFlagsFromSymbol,
        getDeclarationOfKind: ()=>getDeclarationOfKind,
        getDeclarationsOfKind: ()=>getDeclarationsOfKind,
        getDeclaredExpandoInitializer: ()=>getDeclaredExpandoInitializer,
        getDecorators: ()=>getDecorators,
        getDefaultCompilerOptions: ()=>getDefaultCompilerOptions2,
        getDefaultFormatCodeSettings: ()=>getDefaultFormatCodeSettings,
        getDefaultLibFileName: ()=>getDefaultLibFileName,
        getDefaultLibFilePath: ()=>getDefaultLibFilePath,
        getDefaultLikeExportInfo: ()=>getDefaultLikeExportInfo,
        getDefaultLikeExportNameFromDeclaration: ()=>getDefaultLikeExportNameFromDeclaration,
        getDefaultResolutionModeForFileWorker: ()=>getDefaultResolutionModeForFileWorker,
        getDiagnosticText: ()=>getDiagnosticText,
        getDiagnosticsWithinSpan: ()=>getDiagnosticsWithinSpan,
        getDirectoryPath: ()=>getDirectoryPath,
        getDirectoryToWatchFailedLookupLocation: ()=>getDirectoryToWatchFailedLookupLocation,
        getDirectoryToWatchFailedLookupLocationFromTypeRoot: ()=>getDirectoryToWatchFailedLookupLocationFromTypeRoot,
        getDocumentPositionMapper: ()=>getDocumentPositionMapper,
        getDocumentSpansEqualityComparer: ()=>getDocumentSpansEqualityComparer,
        getESModuleInterop: ()=>getESModuleInterop,
        getEditsForFileRename: ()=>getEditsForFileRename,
        getEffectiveBaseTypeNode: ()=>getEffectiveBaseTypeNode,
        getEffectiveConstraintOfTypeParameter: ()=>getEffectiveConstraintOfTypeParameter,
        getEffectiveContainerForJSDocTemplateTag: ()=>getEffectiveContainerForJSDocTemplateTag,
        getEffectiveImplementsTypeNodes: ()=>getEffectiveImplementsTypeNodes,
        getEffectiveInitializer: ()=>getEffectiveInitializer,
        getEffectiveJSDocHost: ()=>getEffectiveJSDocHost,
        getEffectiveModifierFlags: ()=>getEffectiveModifierFlags,
        getEffectiveModifierFlagsAlwaysIncludeJSDoc: ()=>getEffectiveModifierFlagsAlwaysIncludeJSDoc,
        getEffectiveModifierFlagsNoCache: ()=>getEffectiveModifierFlagsNoCache,
        getEffectiveReturnTypeNode: ()=>getEffectiveReturnTypeNode,
        getEffectiveSetAccessorTypeAnnotationNode: ()=>getEffectiveSetAccessorTypeAnnotationNode,
        getEffectiveTypeAnnotationNode: ()=>getEffectiveTypeAnnotationNode,
        getEffectiveTypeParameterDeclarations: ()=>getEffectiveTypeParameterDeclarations,
        getEffectiveTypeRoots: ()=>getEffectiveTypeRoots,
        getElementOrPropertyAccessArgumentExpressionOrName: ()=>getElementOrPropertyAccessArgumentExpressionOrName,
        getElementOrPropertyAccessName: ()=>getElementOrPropertyAccessName,
        getElementsOfBindingOrAssignmentPattern: ()=>getElementsOfBindingOrAssignmentPattern,
        getEmitDeclarations: ()=>getEmitDeclarations,
        getEmitFlags: ()=>getEmitFlags,
        getEmitHelpers: ()=>getEmitHelpers,
        getEmitModuleDetectionKind: ()=>getEmitModuleDetectionKind,
        getEmitModuleFormatOfFileWorker: ()=>getEmitModuleFormatOfFileWorker,
        getEmitModuleKind: ()=>getEmitModuleKind,
        getEmitModuleResolutionKind: ()=>getEmitModuleResolutionKind,
        getEmitScriptTarget: ()=>getEmitScriptTarget,
        getEmitStandardClassFields: ()=>getEmitStandardClassFields,
        getEnclosingBlockScopeContainer: ()=>getEnclosingBlockScopeContainer,
        getEnclosingContainer: ()=>getEnclosingContainer,
        getEncodedSemanticClassifications: ()=>getEncodedSemanticClassifications,
        getEncodedSyntacticClassifications: ()=>getEncodedSyntacticClassifications,
        getEndLinePosition: ()=>getEndLinePosition,
        getEntityNameFromTypeNode: ()=>getEntityNameFromTypeNode,
        getEntrypointsFromPackageJsonInfo: ()=>getEntrypointsFromPackageJsonInfo,
        getErrorCountForSummary: ()=>getErrorCountForSummary,
        getErrorSpanForNode: ()=>getErrorSpanForNode,
        getErrorSummaryText: ()=>getErrorSummaryText,
        getEscapedTextOfIdentifierOrLiteral: ()=>getEscapedTextOfIdentifierOrLiteral,
        getEscapedTextOfJsxAttributeName: ()=>getEscapedTextOfJsxAttributeName,
        getEscapedTextOfJsxNamespacedName: ()=>getEscapedTextOfJsxNamespacedName,
        getExpandoInitializer: ()=>getExpandoInitializer,
        getExportAssignmentExpression: ()=>getExportAssignmentExpression,
        getExportInfoMap: ()=>getExportInfoMap,
        getExportNeedsImportStarHelper: ()=>getExportNeedsImportStarHelper,
        getExpressionAssociativity: ()=>getExpressionAssociativity,
        getExpressionPrecedence: ()=>getExpressionPrecedence,
        getExternalHelpersModuleName: ()=>getExternalHelpersModuleName,
        getExternalModuleImportEqualsDeclarationExpression: ()=>getExternalModuleImportEqualsDeclarationExpression,
        getExternalModuleName: ()=>getExternalModuleName,
        getExternalModuleNameFromDeclaration: ()=>getExternalModuleNameFromDeclaration,
        getExternalModuleNameFromPath: ()=>getExternalModuleNameFromPath,
        getExternalModuleNameLiteral: ()=>getExternalModuleNameLiteral,
        getExternalModuleRequireArgument: ()=>getExternalModuleRequireArgument,
        getFallbackOptions: ()=>getFallbackOptions,
        getFileEmitOutput: ()=>getFileEmitOutput,
        getFileMatcherPatterns: ()=>getFileMatcherPatterns,
        getFileNamesFromConfigSpecs: ()=>getFileNamesFromConfigSpecs,
        getFileWatcherEventKind: ()=>getFileWatcherEventKind,
        getFilesInErrorForSummary: ()=>getFilesInErrorForSummary,
        getFirstConstructorWithBody: ()=>getFirstConstructorWithBody,
        getFirstIdentifier: ()=>getFirstIdentifier,
        getFirstNonSpaceCharacterPosition: ()=>getFirstNonSpaceCharacterPosition,
        getFirstProjectOutput: ()=>getFirstProjectOutput,
        getFixableErrorSpanExpression: ()=>getFixableErrorSpanExpression,
        getFormatCodeSettingsForWriting: ()=>getFormatCodeSettingsForWriting,
        getFullWidth: ()=>getFullWidth,
        getFunctionFlags: ()=>getFunctionFlags,
        getHeritageClause: ()=>getHeritageClause,
        getHostSignatureFromJSDoc: ()=>getHostSignatureFromJSDoc,
        getIdentifierAutoGenerate: ()=>getIdentifierAutoGenerate,
        getIdentifierGeneratedImportReference: ()=>getIdentifierGeneratedImportReference,
        getIdentifierTypeArguments: ()=>getIdentifierTypeArguments,
        getImmediatelyInvokedFunctionExpression: ()=>getImmediatelyInvokedFunctionExpression,
        getImpliedNodeFormatForEmitWorker: ()=>getImpliedNodeFormatForEmitWorker,
        getImpliedNodeFormatForFile: ()=>getImpliedNodeFormatForFile,
        getImpliedNodeFormatForFileWorker: ()=>getImpliedNodeFormatForFileWorker,
        getImportNeedsImportDefaultHelper: ()=>getImportNeedsImportDefaultHelper,
        getImportNeedsImportStarHelper: ()=>getImportNeedsImportStarHelper,
        getIndentString: ()=>getIndentString,
        getInferredLibraryNameResolveFrom: ()=>getInferredLibraryNameResolveFrom,
        getInitializedVariables: ()=>getInitializedVariables,
        getInitializerOfBinaryExpression: ()=>getInitializerOfBinaryExpression,
        getInitializerOfBindingOrAssignmentElement: ()=>getInitializerOfBindingOrAssignmentElement,
        getInterfaceBaseTypeNodes: ()=>getInterfaceBaseTypeNodes,
        getInternalEmitFlags: ()=>getInternalEmitFlags,
        getInvokedExpression: ()=>getInvokedExpression,
        getIsFileExcluded: ()=>getIsFileExcluded,
        getIsolatedModules: ()=>getIsolatedModules,
        getJSDocAugmentsTag: ()=>getJSDocAugmentsTag,
        getJSDocClassTag: ()=>getJSDocClassTag,
        getJSDocCommentRanges: ()=>getJSDocCommentRanges,
        getJSDocCommentsAndTags: ()=>getJSDocCommentsAndTags,
        getJSDocDeprecatedTag: ()=>getJSDocDeprecatedTag,
        getJSDocDeprecatedTagNoCache: ()=>getJSDocDeprecatedTagNoCache,
        getJSDocEnumTag: ()=>getJSDocEnumTag,
        getJSDocHost: ()=>getJSDocHost,
        getJSDocImplementsTags: ()=>getJSDocImplementsTags,
        getJSDocOverloadTags: ()=>getJSDocOverloadTags,
        getJSDocOverrideTagNoCache: ()=>getJSDocOverrideTagNoCache,
        getJSDocParameterTags: ()=>getJSDocParameterTags,
        getJSDocParameterTagsNoCache: ()=>getJSDocParameterTagsNoCache,
        getJSDocPrivateTag: ()=>getJSDocPrivateTag,
        getJSDocPrivateTagNoCache: ()=>getJSDocPrivateTagNoCache,
        getJSDocProtectedTag: ()=>getJSDocProtectedTag,
        getJSDocProtectedTagNoCache: ()=>getJSDocProtectedTagNoCache,
        getJSDocPublicTag: ()=>getJSDocPublicTag,
        getJSDocPublicTagNoCache: ()=>getJSDocPublicTagNoCache,
        getJSDocReadonlyTag: ()=>getJSDocReadonlyTag,
        getJSDocReadonlyTagNoCache: ()=>getJSDocReadonlyTagNoCache,
        getJSDocReturnTag: ()=>getJSDocReturnTag,
        getJSDocReturnType: ()=>getJSDocReturnType,
        getJSDocRoot: ()=>getJSDocRoot,
        getJSDocSatisfiesExpressionType: ()=>getJSDocSatisfiesExpressionType,
        getJSDocSatisfiesTag: ()=>getJSDocSatisfiesTag,
        getJSDocTags: ()=>getJSDocTags,
        getJSDocTemplateTag: ()=>getJSDocTemplateTag,
        getJSDocThisTag: ()=>getJSDocThisTag,
        getJSDocType: ()=>getJSDocType,
        getJSDocTypeAliasName: ()=>getJSDocTypeAliasName,
        getJSDocTypeAssertionType: ()=>getJSDocTypeAssertionType,
        getJSDocTypeParameterDeclarations: ()=>getJSDocTypeParameterDeclarations,
        getJSDocTypeParameterTags: ()=>getJSDocTypeParameterTags,
        getJSDocTypeParameterTagsNoCache: ()=>getJSDocTypeParameterTagsNoCache,
        getJSDocTypeTag: ()=>getJSDocTypeTag,
        getJSXImplicitImportBase: ()=>getJSXImplicitImportBase,
        getJSXRuntimeImport: ()=>getJSXRuntimeImport,
        getJSXTransformEnabled: ()=>getJSXTransformEnabled,
        getKeyForCompilerOptions: ()=>getKeyForCompilerOptions,
        getLanguageVariant: ()=>getLanguageVariant,
        getLastChild: ()=>getLastChild,
        getLeadingCommentRanges: ()=>getLeadingCommentRanges,
        getLeadingCommentRangesOfNode: ()=>getLeadingCommentRangesOfNode,
        getLeftmostAccessExpression: ()=>getLeftmostAccessExpression,
        getLeftmostExpression: ()=>getLeftmostExpression,
        getLibFileNameFromLibReference: ()=>getLibFileNameFromLibReference,
        getLibNameFromLibReference: ()=>getLibNameFromLibReference,
        getLibraryNameFromLibFileName: ()=>getLibraryNameFromLibFileName,
        getLineAndCharacterOfPosition: ()=>getLineAndCharacterOfPosition,
        getLineInfo: ()=>getLineInfo,
        getLineOfLocalPosition: ()=>getLineOfLocalPosition,
        getLineStartPositionForPosition: ()=>getLineStartPositionForPosition,
        getLineStarts: ()=>getLineStarts,
        getLinesBetweenPositionAndNextNonWhitespaceCharacter: ()=>getLinesBetweenPositionAndNextNonWhitespaceCharacter,
        getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter: ()=>getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter,
        getLinesBetweenPositions: ()=>getLinesBetweenPositions,
        getLinesBetweenRangeEndAndRangeStart: ()=>getLinesBetweenRangeEndAndRangeStart,
        getLinesBetweenRangeEndPositions: ()=>getLinesBetweenRangeEndPositions,
        getLiteralText: ()=>getLiteralText,
        getLocalNameForExternalImport: ()=>getLocalNameForExternalImport,
        getLocalSymbolForExportDefault: ()=>getLocalSymbolForExportDefault,
        getLocaleSpecificMessage: ()=>getLocaleSpecificMessage,
        getLocaleTimeString: ()=>getLocaleTimeString,
        getMappedContextSpan: ()=>getMappedContextSpan,
        getMappedDocumentSpan: ()=>getMappedDocumentSpan,
        getMappedLocation: ()=>getMappedLocation,
        getMatchedFileSpec: ()=>getMatchedFileSpec,
        getMatchedIncludeSpec: ()=>getMatchedIncludeSpec,
        getMeaningFromDeclaration: ()=>getMeaningFromDeclaration,
        getMeaningFromLocation: ()=>getMeaningFromLocation,
        getMembersOfDeclaration: ()=>getMembersOfDeclaration,
        getModeForFileReference: ()=>getModeForFileReference,
        getModeForResolutionAtIndex: ()=>getModeForResolutionAtIndex,
        getModeForUsageLocation: ()=>getModeForUsageLocation,
        getModifiedTime: ()=>getModifiedTime,
        getModifiers: ()=>getModifiers,
        getModuleInstanceState: ()=>getModuleInstanceState,
        getModuleNameStringLiteralAt: ()=>getModuleNameStringLiteralAt,
        getModuleSpecifierEndingPreference: ()=>getModuleSpecifierEndingPreference,
        getModuleSpecifierResolverHost: ()=>getModuleSpecifierResolverHost,
        getNameForExportedSymbol: ()=>getNameForExportedSymbol,
        getNameFromImportAttribute: ()=>getNameFromImportAttribute,
        getNameFromIndexInfo: ()=>getNameFromIndexInfo,
        getNameFromPropertyName: ()=>getNameFromPropertyName,
        getNameOfAccessExpression: ()=>getNameOfAccessExpression,
        getNameOfCompilerOptionValue: ()=>getNameOfCompilerOptionValue,
        getNameOfDeclaration: ()=>getNameOfDeclaration,
        getNameOfExpando: ()=>getNameOfExpando,
        getNameOfJSDocTypedef: ()=>getNameOfJSDocTypedef,
        getNameOfScriptTarget: ()=>getNameOfScriptTarget,
        getNameOrArgument: ()=>getNameOrArgument,
        getNameTable: ()=>getNameTable,
        getNamespaceDeclarationNode: ()=>getNamespaceDeclarationNode,
        getNewLineCharacter: ()=>getNewLineCharacter,
        getNewLineKind: ()=>getNewLineKind,
        getNewLineOrDefaultFromHost: ()=>getNewLineOrDefaultFromHost,
        getNewTargetContainer: ()=>getNewTargetContainer,
        getNextJSDocCommentLocation: ()=>getNextJSDocCommentLocation,
        getNodeChildren: ()=>getNodeChildren,
        getNodeForGeneratedName: ()=>getNodeForGeneratedName,
        getNodeId: ()=>getNodeId,
        getNodeKind: ()=>getNodeKind,
        getNodeModifiers: ()=>getNodeModifiers,
        getNodeModulePathParts: ()=>getNodeModulePathParts,
        getNonAssignedNameOfDeclaration: ()=>getNonAssignedNameOfDeclaration,
        getNonAssignmentOperatorForCompoundAssignment: ()=>getNonAssignmentOperatorForCompoundAssignment,
        getNonAugmentationDeclaration: ()=>getNonAugmentationDeclaration,
        getNonDecoratorTokenPosOfNode: ()=>getNonDecoratorTokenPosOfNode,
        getNonIncrementalBuildInfoRoots: ()=>getNonIncrementalBuildInfoRoots,
        getNonModifierTokenPosOfNode: ()=>getNonModifierTokenPosOfNode,
        getNormalizedAbsolutePath: ()=>getNormalizedAbsolutePath,
        getNormalizedAbsolutePathWithoutRoot: ()=>getNormalizedAbsolutePathWithoutRoot,
        getNormalizedPathComponents: ()=>getNormalizedPathComponents,
        getObjectFlags: ()=>getObjectFlags,
        getOperatorAssociativity: ()=>getOperatorAssociativity,
        getOperatorPrecedence: ()=>getOperatorPrecedence,
        getOptionFromName: ()=>getOptionFromName,
        getOptionsForLibraryResolution: ()=>getOptionsForLibraryResolution,
        getOptionsNameMap: ()=>getOptionsNameMap,
        getOptionsSyntaxByArrayElementValue: ()=>getOptionsSyntaxByArrayElementValue,
        getOptionsSyntaxByValue: ()=>getOptionsSyntaxByValue,
        getOrCreateEmitNode: ()=>getOrCreateEmitNode,
        getOrUpdate: ()=>getOrUpdate,
        getOriginalNode: ()=>getOriginalNode,
        getOriginalNodeId: ()=>getOriginalNodeId,
        getOutputDeclarationFileName: ()=>getOutputDeclarationFileName,
        getOutputDeclarationFileNameWorker: ()=>getOutputDeclarationFileNameWorker,
        getOutputExtension: ()=>getOutputExtension,
        getOutputFileNames: ()=>getOutputFileNames,
        getOutputJSFileNameWorker: ()=>getOutputJSFileNameWorker,
        getOutputPathsFor: ()=>getOutputPathsFor,
        getOwnEmitOutputFilePath: ()=>getOwnEmitOutputFilePath,
        getOwnKeys: ()=>getOwnKeys,
        getOwnValues: ()=>getOwnValues,
        getPackageJsonTypesVersionsPaths: ()=>getPackageJsonTypesVersionsPaths,
        getPackageNameFromTypesPackageName: ()=>getPackageNameFromTypesPackageName,
        getPackageScopeForPath: ()=>getPackageScopeForPath,
        getParameterSymbolFromJSDoc: ()=>getParameterSymbolFromJSDoc,
        getParentNodeInSpan: ()=>getParentNodeInSpan,
        getParseTreeNode: ()=>getParseTreeNode,
        getParsedCommandLineOfConfigFile: ()=>getParsedCommandLineOfConfigFile,
        getPathComponents: ()=>getPathComponents,
        getPathFromPathComponents: ()=>getPathFromPathComponents,
        getPathUpdater: ()=>getPathUpdater,
        getPathsBasePath: ()=>getPathsBasePath,
        getPatternFromSpec: ()=>getPatternFromSpec,
        getPendingEmitKindWithSeen: ()=>getPendingEmitKindWithSeen,
        getPositionOfLineAndCharacter: ()=>getPositionOfLineAndCharacter,
        getPossibleGenericSignatures: ()=>getPossibleGenericSignatures,
        getPossibleOriginalInputExtensionForExtension: ()=>getPossibleOriginalInputExtensionForExtension,
        getPossibleOriginalInputPathWithoutChangingExt: ()=>getPossibleOriginalInputPathWithoutChangingExt,
        getPossibleTypeArgumentsInfo: ()=>getPossibleTypeArgumentsInfo,
        getPreEmitDiagnostics: ()=>getPreEmitDiagnostics,
        getPrecedingNonSpaceCharacterPosition: ()=>getPrecedingNonSpaceCharacterPosition,
        getPrivateIdentifier: ()=>getPrivateIdentifier,
        getProperties: ()=>getProperties,
        getProperty: ()=>getProperty,
        getPropertyAssignmentAliasLikeExpression: ()=>getPropertyAssignmentAliasLikeExpression,
        getPropertyNameForPropertyNameNode: ()=>getPropertyNameForPropertyNameNode,
        getPropertyNameFromType: ()=>getPropertyNameFromType,
        getPropertyNameOfBindingOrAssignmentElement: ()=>getPropertyNameOfBindingOrAssignmentElement,
        getPropertySymbolFromBindingElement: ()=>getPropertySymbolFromBindingElement,
        getPropertySymbolsFromContextualType: ()=>getPropertySymbolsFromContextualType,
        getQuoteFromPreference: ()=>getQuoteFromPreference,
        getQuotePreference: ()=>getQuotePreference,
        getRangesWhere: ()=>getRangesWhere,
        getRefactorContextSpan: ()=>getRefactorContextSpan,
        getReferencedFileLocation: ()=>getReferencedFileLocation,
        getRegexFromPattern: ()=>getRegexFromPattern,
        getRegularExpressionForWildcard: ()=>getRegularExpressionForWildcard,
        getRegularExpressionsForWildcards: ()=>getRegularExpressionsForWildcards,
        getRelativePathFromDirectory: ()=>getRelativePathFromDirectory,
        getRelativePathFromFile: ()=>getRelativePathFromFile,
        getRelativePathToDirectoryOrUrl: ()=>getRelativePathToDirectoryOrUrl,
        getRenameLocation: ()=>getRenameLocation,
        getReplacementSpanForContextToken: ()=>getReplacementSpanForContextToken,
        getResolutionDiagnostic: ()=>getResolutionDiagnostic,
        getResolutionModeOverride: ()=>getResolutionModeOverride,
        getResolveJsonModule: ()=>getResolveJsonModule,
        getResolvePackageJsonExports: ()=>getResolvePackageJsonExports,
        getResolvePackageJsonImports: ()=>getResolvePackageJsonImports,
        getResolvedExternalModuleName: ()=>getResolvedExternalModuleName,
        getResolvedModuleFromResolution: ()=>getResolvedModuleFromResolution,
        getResolvedTypeReferenceDirectiveFromResolution: ()=>getResolvedTypeReferenceDirectiveFromResolution,
        getRestIndicatorOfBindingOrAssignmentElement: ()=>getRestIndicatorOfBindingOrAssignmentElement,
        getRestParameterElementType: ()=>getRestParameterElementType,
        getRightMostAssignedExpression: ()=>getRightMostAssignedExpression,
        getRootDeclaration: ()=>getRootDeclaration,
        getRootDirectoryOfResolutionCache: ()=>getRootDirectoryOfResolutionCache,
        getRootLength: ()=>getRootLength,
        getScriptKind: ()=>getScriptKind,
        getScriptKindFromFileName: ()=>getScriptKindFromFileName,
        getScriptTargetFeatures: ()=>getScriptTargetFeatures,
        getSelectedEffectiveModifierFlags: ()=>getSelectedEffectiveModifierFlags,
        getSelectedSyntacticModifierFlags: ()=>getSelectedSyntacticModifierFlags,
        getSemanticClassifications: ()=>getSemanticClassifications,
        getSemanticJsxChildren: ()=>getSemanticJsxChildren,
        getSetAccessorTypeAnnotationNode: ()=>getSetAccessorTypeAnnotationNode,
        getSetAccessorValueParameter: ()=>getSetAccessorValueParameter,
        getSetExternalModuleIndicator: ()=>getSetExternalModuleIndicator,
        getShebang: ()=>getShebang,
        getSingleVariableOfVariableStatement: ()=>getSingleVariableOfVariableStatement,
        getSnapshotText: ()=>getSnapshotText,
        getSnippetElement: ()=>getSnippetElement,
        getSourceFileOfModule: ()=>getSourceFileOfModule,
        getSourceFileOfNode: ()=>getSourceFileOfNode,
        getSourceFilePathInNewDir: ()=>getSourceFilePathInNewDir,
        getSourceFileVersionAsHashFromText: ()=>getSourceFileVersionAsHashFromText,
        getSourceFilesToEmit: ()=>getSourceFilesToEmit,
        getSourceMapRange: ()=>getSourceMapRange,
        getSourceMapper: ()=>getSourceMapper,
        getSourceTextOfNodeFromSourceFile: ()=>getSourceTextOfNodeFromSourceFile,
        getSpanOfTokenAtPosition: ()=>getSpanOfTokenAtPosition,
        getSpellingSuggestion: ()=>getSpellingSuggestion,
        getStartPositionOfLine: ()=>getStartPositionOfLine,
        getStartPositionOfRange: ()=>getStartPositionOfRange,
        getStartsOnNewLine: ()=>getStartsOnNewLine,
        getStaticPropertiesAndClassStaticBlock: ()=>getStaticPropertiesAndClassStaticBlock,
        getStrictOptionValue: ()=>getStrictOptionValue,
        getStringComparer: ()=>getStringComparer,
        getSubPatternFromSpec: ()=>getSubPatternFromSpec,
        getSuperCallFromStatement: ()=>getSuperCallFromStatement,
        getSuperContainer: ()=>getSuperContainer,
        getSupportedCodeFixes: ()=>getSupportedCodeFixes,
        getSupportedExtensions: ()=>getSupportedExtensions,
        getSupportedExtensionsWithJsonIfResolveJsonModule: ()=>getSupportedExtensionsWithJsonIfResolveJsonModule,
        getSwitchedType: ()=>getSwitchedType,
        getSymbolId: ()=>getSymbolId,
        getSymbolNameForPrivateIdentifier: ()=>getSymbolNameForPrivateIdentifier,
        getSymbolTarget: ()=>getSymbolTarget,
        getSyntacticClassifications: ()=>getSyntacticClassifications,
        getSyntacticModifierFlags: ()=>getSyntacticModifierFlags,
        getSyntacticModifierFlagsNoCache: ()=>getSyntacticModifierFlagsNoCache,
        getSynthesizedDeepClone: ()=>getSynthesizedDeepClone,
        getSynthesizedDeepCloneWithReplacements: ()=>getSynthesizedDeepCloneWithReplacements,
        getSynthesizedDeepClones: ()=>getSynthesizedDeepClones,
        getSynthesizedDeepClonesWithReplacements: ()=>getSynthesizedDeepClonesWithReplacements,
        getSyntheticLeadingComments: ()=>getSyntheticLeadingComments,
        getSyntheticTrailingComments: ()=>getSyntheticTrailingComments,
        getTargetLabel: ()=>getTargetLabel,
        getTargetOfBindingOrAssignmentElement: ()=>getTargetOfBindingOrAssignmentElement,
        getTemporaryModuleResolutionState: ()=>getTemporaryModuleResolutionState,
        getTextOfConstantValue: ()=>getTextOfConstantValue,
        getTextOfIdentifierOrLiteral: ()=>getTextOfIdentifierOrLiteral,
        getTextOfJSDocComment: ()=>getTextOfJSDocComment,
        getTextOfJsxAttributeName: ()=>getTextOfJsxAttributeName,
        getTextOfJsxNamespacedName: ()=>getTextOfJsxNamespacedName,
        getTextOfNode: ()=>getTextOfNode,
        getTextOfNodeFromSourceText: ()=>getTextOfNodeFromSourceText,
        getTextOfPropertyName: ()=>getTextOfPropertyName,
        getThisContainer: ()=>getThisContainer,
        getThisParameter: ()=>getThisParameter,
        getTokenAtPosition: ()=>getTokenAtPosition,
        getTokenPosOfNode: ()=>getTokenPosOfNode,
        getTokenSourceMapRange: ()=>getTokenSourceMapRange,
        getTouchingPropertyName: ()=>getTouchingPropertyName,
        getTouchingToken: ()=>getTouchingToken,
        getTrailingCommentRanges: ()=>getTrailingCommentRanges,
        getTrailingSemicolonDeferringWriter: ()=>getTrailingSemicolonDeferringWriter,
        getTransformers: ()=>getTransformers,
        getTsBuildInfoEmitOutputFilePath: ()=>getTsBuildInfoEmitOutputFilePath,
        getTsConfigObjectLiteralExpression: ()=>getTsConfigObjectLiteralExpression,
        getTsConfigPropArrayElementValue: ()=>getTsConfigPropArrayElementValue,
        getTypeAnnotationNode: ()=>getTypeAnnotationNode,
        getTypeArgumentOrTypeParameterList: ()=>getTypeArgumentOrTypeParameterList,
        getTypeKeywordOfTypeOnlyImport: ()=>getTypeKeywordOfTypeOnlyImport,
        getTypeNode: ()=>getTypeNode,
        getTypeNodeIfAccessible: ()=>getTypeNodeIfAccessible,
        getTypeParameterFromJsDoc: ()=>getTypeParameterFromJsDoc,
        getTypeParameterOwner: ()=>getTypeParameterOwner,
        getTypesPackageName: ()=>getTypesPackageName,
        getUILocale: ()=>getUILocale,
        getUniqueName: ()=>getUniqueName,
        getUniqueSymbolId: ()=>getUniqueSymbolId,
        getUseDefineForClassFields: ()=>getUseDefineForClassFields,
        getWatchErrorSummaryDiagnosticMessage: ()=>getWatchErrorSummaryDiagnosticMessage,
        getWatchFactory: ()=>getWatchFactory,
        group: ()=>group,
        groupBy: ()=>groupBy,
        guessIndentation: ()=>guessIndentation,
        handleNoEmitOptions: ()=>handleNoEmitOptions,
        handleWatchOptionsConfigDirTemplateSubstitution: ()=>handleWatchOptionsConfigDirTemplateSubstitution,
        hasAbstractModifier: ()=>hasAbstractModifier,
        hasAccessorModifier: ()=>hasAccessorModifier,
        hasAmbientModifier: ()=>hasAmbientModifier,
        hasChangesInResolutions: ()=>hasChangesInResolutions,
        hasContextSensitiveParameters: ()=>hasContextSensitiveParameters,
        hasDecorators: ()=>hasDecorators,
        hasDocComment: ()=>hasDocComment,
        hasDynamicName: ()=>hasDynamicName,
        hasEffectiveModifier: ()=>hasEffectiveModifier,
        hasEffectiveModifiers: ()=>hasEffectiveModifiers,
        hasEffectiveReadonlyModifier: ()=>hasEffectiveReadonlyModifier,
        hasExtension: ()=>hasExtension,
        hasImplementationTSFileExtension: ()=>hasImplementationTSFileExtension,
        hasIndexSignature: ()=>hasIndexSignature,
        hasInferredType: ()=>hasInferredType,
        hasInitializer: ()=>hasInitializer,
        hasInvalidEscape: ()=>hasInvalidEscape,
        hasJSDocNodes: ()=>hasJSDocNodes,
        hasJSDocParameterTags: ()=>hasJSDocParameterTags,
        hasJSFileExtension: ()=>hasJSFileExtension,
        hasJsonModuleEmitEnabled: ()=>hasJsonModuleEmitEnabled,
        hasOnlyExpressionInitializer: ()=>hasOnlyExpressionInitializer,
        hasOverrideModifier: ()=>hasOverrideModifier,
        hasPossibleExternalModuleReference: ()=>hasPossibleExternalModuleReference,
        hasProperty: ()=>hasProperty,
        hasPropertyAccessExpressionWithName: ()=>hasPropertyAccessExpressionWithName,
        hasQuestionToken: ()=>hasQuestionToken,
        hasRecordedExternalHelpers: ()=>hasRecordedExternalHelpers,
        hasResolutionModeOverride: ()=>hasResolutionModeOverride,
        hasRestParameter: ()=>hasRestParameter,
        hasScopeMarker: ()=>hasScopeMarker,
        hasStaticModifier: ()=>hasStaticModifier,
        hasSyntacticModifier: ()=>hasSyntacticModifier,
        hasSyntacticModifiers: ()=>hasSyntacticModifiers,
        hasTSFileExtension: ()=>hasTSFileExtension,
        hasTabstop: ()=>hasTabstop,
        hasTrailingDirectorySeparator: ()=>hasTrailingDirectorySeparator,
        hasType: ()=>hasType,
        hasTypeArguments: ()=>hasTypeArguments,
        hasZeroOrOneAsteriskCharacter: ()=>hasZeroOrOneAsteriskCharacter,
        hostGetCanonicalFileName: ()=>hostGetCanonicalFileName,
        hostUsesCaseSensitiveFileNames: ()=>hostUsesCaseSensitiveFileNames,
        idText: ()=>idText,
        identifierIsThisKeyword: ()=>identifierIsThisKeyword,
        identifierToKeywordKind: ()=>identifierToKeywordKind,
        identity: ()=>identity,
        identitySourceMapConsumer: ()=>identitySourceMapConsumer,
        ignoreSourceNewlines: ()=>ignoreSourceNewlines,
        ignoredPaths: ()=>ignoredPaths,
        importFromModuleSpecifier: ()=>importFromModuleSpecifier,
        importSyntaxAffectsModuleResolution: ()=>importSyntaxAffectsModuleResolution,
        indexOfAnyCharCode: ()=>indexOfAnyCharCode,
        indexOfNode: ()=>indexOfNode,
        indicesOf: ()=>indicesOf,
        inferredTypesContainingFile: ()=>inferredTypesContainingFile,
        injectClassNamedEvaluationHelperBlockIfMissing: ()=>injectClassNamedEvaluationHelperBlockIfMissing,
        injectClassThisAssignmentIfMissing: ()=>injectClassThisAssignmentIfMissing,
        insertImports: ()=>insertImports,
        insertSorted: ()=>insertSorted,
        insertStatementAfterCustomPrologue: ()=>insertStatementAfterCustomPrologue,
        insertStatementAfterStandardPrologue: ()=>insertStatementAfterStandardPrologue,
        insertStatementsAfterCustomPrologue: ()=>insertStatementsAfterCustomPrologue,
        insertStatementsAfterStandardPrologue: ()=>insertStatementsAfterStandardPrologue,
        intersperse: ()=>intersperse,
        intrinsicTagNameToString: ()=>intrinsicTagNameToString,
        introducesArgumentsExoticObject: ()=>introducesArgumentsExoticObject,
        inverseJsxOptionMap: ()=>inverseJsxOptionMap,
        isAbstractConstructorSymbol: ()=>isAbstractConstructorSymbol,
        isAbstractModifier: ()=>isAbstractModifier,
        isAccessExpression: ()=>isAccessExpression,
        isAccessibilityModifier: ()=>isAccessibilityModifier,
        isAccessor: ()=>isAccessor,
        isAccessorModifier: ()=>isAccessorModifier,
        isAliasableExpression: ()=>isAliasableExpression,
        isAmbientModule: ()=>isAmbientModule,
        isAmbientPropertyDeclaration: ()=>isAmbientPropertyDeclaration,
        isAnyDirectorySeparator: ()=>isAnyDirectorySeparator,
        isAnyImportOrBareOrAccessedRequire: ()=>isAnyImportOrBareOrAccessedRequire,
        isAnyImportOrReExport: ()=>isAnyImportOrReExport,
        isAnyImportOrRequireStatement: ()=>isAnyImportOrRequireStatement,
        isAnyImportSyntax: ()=>isAnyImportSyntax,
        isAnySupportedFileExtension: ()=>isAnySupportedFileExtension,
        isApplicableVersionedTypesKey: ()=>isApplicableVersionedTypesKey,
        isArgumentExpressionOfElementAccess: ()=>isArgumentExpressionOfElementAccess,
        isArray: ()=>isArray,
        isArrayBindingElement: ()=>isArrayBindingElement,
        isArrayBindingOrAssignmentElement: ()=>isArrayBindingOrAssignmentElement,
        isArrayBindingOrAssignmentPattern: ()=>isArrayBindingOrAssignmentPattern,
        isArrayBindingPattern: ()=>isArrayBindingPattern,
        isArrayLiteralExpression: ()=>isArrayLiteralExpression,
        isArrayLiteralOrObjectLiteralDestructuringPattern: ()=>isArrayLiteralOrObjectLiteralDestructuringPattern,
        isArrayTypeNode: ()=>isArrayTypeNode,
        isArrowFunction: ()=>isArrowFunction,
        isAsExpression: ()=>isAsExpression,
        isAssertClause: ()=>isAssertClause,
        isAssertEntry: ()=>isAssertEntry,
        isAssertionExpression: ()=>isAssertionExpression,
        isAssertsKeyword: ()=>isAssertsKeyword,
        isAssignmentDeclaration: ()=>isAssignmentDeclaration,
        isAssignmentExpression: ()=>isAssignmentExpression,
        isAssignmentOperator: ()=>isAssignmentOperator,
        isAssignmentPattern: ()=>isAssignmentPattern,
        isAssignmentTarget: ()=>isAssignmentTarget,
        isAsteriskToken: ()=>isAsteriskToken,
        isAsyncFunction: ()=>isAsyncFunction,
        isAsyncModifier: ()=>isAsyncModifier,
        isAutoAccessorPropertyDeclaration: ()=>isAutoAccessorPropertyDeclaration,
        isAwaitExpression: ()=>isAwaitExpression,
        isAwaitKeyword: ()=>isAwaitKeyword,
        isBigIntLiteral: ()=>isBigIntLiteral,
        isBinaryExpression: ()=>isBinaryExpression,
        isBinaryLogicalOperator: ()=>isBinaryLogicalOperator,
        isBinaryOperatorToken: ()=>isBinaryOperatorToken,
        isBindableObjectDefinePropertyCall: ()=>isBindableObjectDefinePropertyCall,
        isBindableStaticAccessExpression: ()=>isBindableStaticAccessExpression,
        isBindableStaticElementAccessExpression: ()=>isBindableStaticElementAccessExpression,
        isBindableStaticNameExpression: ()=>isBindableStaticNameExpression,
        isBindingElement: ()=>isBindingElement,
        isBindingElementOfBareOrAccessedRequire: ()=>isBindingElementOfBareOrAccessedRequire,
        isBindingName: ()=>isBindingName,
        isBindingOrAssignmentElement: ()=>isBindingOrAssignmentElement,
        isBindingOrAssignmentPattern: ()=>isBindingOrAssignmentPattern,
        isBindingPattern: ()=>isBindingPattern,
        isBlock: ()=>isBlock,
        isBlockLike: ()=>isBlockLike,
        isBlockOrCatchScoped: ()=>isBlockOrCatchScoped,
        isBlockScope: ()=>isBlockScope,
        isBlockScopedContainerTopLevel: ()=>isBlockScopedContainerTopLevel,
        isBooleanLiteral: ()=>isBooleanLiteral,
        isBreakOrContinueStatement: ()=>isBreakOrContinueStatement,
        isBreakStatement: ()=>isBreakStatement,
        isBuildCommand: ()=>isBuildCommand,
        isBuildInfoFile: ()=>isBuildInfoFile,
        isBuilderProgram: ()=>isBuilderProgram,
        isBundle: ()=>isBundle,
        isCallChain: ()=>isCallChain,
        isCallExpression: ()=>isCallExpression,
        isCallExpressionTarget: ()=>isCallExpressionTarget,
        isCallLikeExpression: ()=>isCallLikeExpression,
        isCallLikeOrFunctionLikeExpression: ()=>isCallLikeOrFunctionLikeExpression,
        isCallOrNewExpression: ()=>isCallOrNewExpression,
        isCallOrNewExpressionTarget: ()=>isCallOrNewExpressionTarget,
        isCallSignatureDeclaration: ()=>isCallSignatureDeclaration,
        isCallToHelper: ()=>isCallToHelper,
        isCaseBlock: ()=>isCaseBlock,
        isCaseClause: ()=>isCaseClause,
        isCaseKeyword: ()=>isCaseKeyword,
        isCaseOrDefaultClause: ()=>isCaseOrDefaultClause,
        isCatchClause: ()=>isCatchClause,
        isCatchClauseVariableDeclaration: ()=>isCatchClauseVariableDeclaration,
        isCatchClauseVariableDeclarationOrBindingElement: ()=>isCatchClauseVariableDeclarationOrBindingElement,
        isCheckJsEnabledForFile: ()=>isCheckJsEnabledForFile,
        isCircularBuildOrder: ()=>isCircularBuildOrder,
        isClassDeclaration: ()=>isClassDeclaration,
        isClassElement: ()=>isClassElement,
        isClassExpression: ()=>isClassExpression,
        isClassInstanceProperty: ()=>isClassInstanceProperty,
        isClassLike: ()=>isClassLike,
        isClassMemberModifier: ()=>isClassMemberModifier,
        isClassNamedEvaluationHelperBlock: ()=>isClassNamedEvaluationHelperBlock,
        isClassOrTypeElement: ()=>isClassOrTypeElement,
        isClassStaticBlockDeclaration: ()=>isClassStaticBlockDeclaration,
        isClassThisAssignmentBlock: ()=>isClassThisAssignmentBlock,
        isColonToken: ()=>isColonToken,
        isCommaExpression: ()=>isCommaExpression,
        isCommaListExpression: ()=>isCommaListExpression,
        isCommaSequence: ()=>isCommaSequence,
        isCommaToken: ()=>isCommaToken,
        isComment: ()=>isComment,
        isCommonJsExportPropertyAssignment: ()=>isCommonJsExportPropertyAssignment,
        isCommonJsExportedExpression: ()=>isCommonJsExportedExpression,
        isCompoundAssignment: ()=>isCompoundAssignment,
        isComputedNonLiteralName: ()=>isComputedNonLiteralName,
        isComputedPropertyName: ()=>isComputedPropertyName,
        isConciseBody: ()=>isConciseBody,
        isConditionalExpression: ()=>isConditionalExpression,
        isConditionalTypeNode: ()=>isConditionalTypeNode,
        isConstAssertion: ()=>isConstAssertion,
        isConstTypeReference: ()=>isConstTypeReference,
        isConstructSignatureDeclaration: ()=>isConstructSignatureDeclaration,
        isConstructorDeclaration: ()=>isConstructorDeclaration,
        isConstructorTypeNode: ()=>isConstructorTypeNode,
        isContextualKeyword: ()=>isContextualKeyword,
        isContinueStatement: ()=>isContinueStatement,
        isCustomPrologue: ()=>isCustomPrologue,
        isDebuggerStatement: ()=>isDebuggerStatement,
        isDeclaration: ()=>isDeclaration,
        isDeclarationBindingElement: ()=>isDeclarationBindingElement,
        isDeclarationFileName: ()=>isDeclarationFileName,
        isDeclarationName: ()=>isDeclarationName,
        isDeclarationNameOfEnumOrNamespace: ()=>isDeclarationNameOfEnumOrNamespace,
        isDeclarationReadonly: ()=>isDeclarationReadonly,
        isDeclarationStatement: ()=>isDeclarationStatement,
        isDeclarationWithTypeParameterChildren: ()=>isDeclarationWithTypeParameterChildren,
        isDeclarationWithTypeParameters: ()=>isDeclarationWithTypeParameters,
        isDecorator: ()=>isDecorator,
        isDecoratorTarget: ()=>isDecoratorTarget,
        isDefaultClause: ()=>isDefaultClause,
        isDefaultImport: ()=>isDefaultImport,
        isDefaultModifier: ()=>isDefaultModifier,
        isDefaultedExpandoInitializer: ()=>isDefaultedExpandoInitializer,
        isDeleteExpression: ()=>isDeleteExpression,
        isDeleteTarget: ()=>isDeleteTarget,
        isDeprecatedDeclaration: ()=>isDeprecatedDeclaration,
        isDestructuringAssignment: ()=>isDestructuringAssignment,
        isDiskPathRoot: ()=>isDiskPathRoot,
        isDoStatement: ()=>isDoStatement,
        isDocumentRegistryEntry: ()=>isDocumentRegistryEntry,
        isDotDotDotToken: ()=>isDotDotDotToken,
        isDottedName: ()=>isDottedName,
        isDynamicName: ()=>isDynamicName,
        isEffectiveExternalModule: ()=>isEffectiveExternalModule,
        isEffectiveStrictModeSourceFile: ()=>isEffectiveStrictModeSourceFile,
        isElementAccessChain: ()=>isElementAccessChain,
        isElementAccessExpression: ()=>isElementAccessExpression,
        isEmittedFileOfProgram: ()=>isEmittedFileOfProgram,
        isEmptyArrayLiteral: ()=>isEmptyArrayLiteral,
        isEmptyBindingElement: ()=>isEmptyBindingElement,
        isEmptyBindingPattern: ()=>isEmptyBindingPattern,
        isEmptyObjectLiteral: ()=>isEmptyObjectLiteral,
        isEmptyStatement: ()=>isEmptyStatement,
        isEmptyStringLiteral: ()=>isEmptyStringLiteral,
        isEntityName: ()=>isEntityName,
        isEntityNameExpression: ()=>isEntityNameExpression,
        isEnumConst: ()=>isEnumConst,
        isEnumDeclaration: ()=>isEnumDeclaration,
        isEnumMember: ()=>isEnumMember,
        isEqualityOperatorKind: ()=>isEqualityOperatorKind,
        isEqualsGreaterThanToken: ()=>isEqualsGreaterThanToken,
        isExclamationToken: ()=>isExclamationToken,
        isExcludedFile: ()=>isExcludedFile,
        isExclusivelyTypeOnlyImportOrExport: ()=>isExclusivelyTypeOnlyImportOrExport,
        isExpandoPropertyDeclaration: ()=>isExpandoPropertyDeclaration,
        isExportAssignment: ()=>isExportAssignment,
        isExportDeclaration: ()=>isExportDeclaration,
        isExportModifier: ()=>isExportModifier,
        isExportName: ()=>isExportName,
        isExportNamespaceAsDefaultDeclaration: ()=>isExportNamespaceAsDefaultDeclaration,
        isExportOrDefaultModifier: ()=>isExportOrDefaultModifier,
        isExportSpecifier: ()=>isExportSpecifier,
        isExportsIdentifier: ()=>isExportsIdentifier,
        isExportsOrModuleExportsOrAlias: ()=>isExportsOrModuleExportsOrAlias,
        isExpression: ()=>isExpression,
        isExpressionNode: ()=>isExpressionNode,
        isExpressionOfExternalModuleImportEqualsDeclaration: ()=>isExpressionOfExternalModuleImportEqualsDeclaration,
        isExpressionOfOptionalChainRoot: ()=>isExpressionOfOptionalChainRoot,
        isExpressionStatement: ()=>isExpressionStatement,
        isExpressionWithTypeArguments: ()=>isExpressionWithTypeArguments,
        isExpressionWithTypeArgumentsInClassExtendsClause: ()=>isExpressionWithTypeArgumentsInClassExtendsClause,
        isExternalModule: ()=>isExternalModule,
        isExternalModuleAugmentation: ()=>isExternalModuleAugmentation,
        isExternalModuleImportEqualsDeclaration: ()=>isExternalModuleImportEqualsDeclaration,
        isExternalModuleIndicator: ()=>isExternalModuleIndicator,
        isExternalModuleNameRelative: ()=>isExternalModuleNameRelative,
        isExternalModuleReference: ()=>isExternalModuleReference,
        isExternalModuleSymbol: ()=>isExternalModuleSymbol,
        isExternalOrCommonJsModule: ()=>isExternalOrCommonJsModule,
        isFileLevelReservedGeneratedIdentifier: ()=>isFileLevelReservedGeneratedIdentifier,
        isFileLevelUniqueName: ()=>isFileLevelUniqueName,
        isFileProbablyExternalModule: ()=>isFileProbablyExternalModule,
        isFirstDeclarationOfSymbolParameter: ()=>isFirstDeclarationOfSymbolParameter,
        isFixablePromiseHandler: ()=>isFixablePromiseHandler,
        isForInOrOfStatement: ()=>isForInOrOfStatement,
        isForInStatement: ()=>isForInStatement,
        isForInitializer: ()=>isForInitializer,
        isForOfStatement: ()=>isForOfStatement,
        isForStatement: ()=>isForStatement,
        isFullSourceFile: ()=>isFullSourceFile,
        isFunctionBlock: ()=>isFunctionBlock,
        isFunctionBody: ()=>isFunctionBody,
        isFunctionDeclaration: ()=>isFunctionDeclaration,
        isFunctionExpression: ()=>isFunctionExpression,
        isFunctionExpressionOrArrowFunction: ()=>isFunctionExpressionOrArrowFunction,
        isFunctionLike: ()=>isFunctionLike,
        isFunctionLikeDeclaration: ()=>isFunctionLikeDeclaration,
        isFunctionLikeKind: ()=>isFunctionLikeKind,
        isFunctionLikeOrClassStaticBlockDeclaration: ()=>isFunctionLikeOrClassStaticBlockDeclaration,
        isFunctionOrConstructorTypeNode: ()=>isFunctionOrConstructorTypeNode,
        isFunctionOrModuleBlock: ()=>isFunctionOrModuleBlock,
        isFunctionSymbol: ()=>isFunctionSymbol,
        isFunctionTypeNode: ()=>isFunctionTypeNode,
        isGeneratedIdentifier: ()=>isGeneratedIdentifier,
        isGeneratedPrivateIdentifier: ()=>isGeneratedPrivateIdentifier,
        isGetAccessor: ()=>isGetAccessor,
        isGetAccessorDeclaration: ()=>isGetAccessorDeclaration,
        isGetOrSetAccessorDeclaration: ()=>isGetOrSetAccessorDeclaration,
        isGlobalScopeAugmentation: ()=>isGlobalScopeAugmentation,
        isGlobalSourceFile: ()=>isGlobalSourceFile,
        isGrammarError: ()=>isGrammarError,
        isHeritageClause: ()=>isHeritageClause,
        isHoistedFunction: ()=>isHoistedFunction,
        isHoistedVariableStatement: ()=>isHoistedVariableStatement,
        isIdentifier: ()=>isIdentifier,
        isIdentifierANonContextualKeyword: ()=>isIdentifierANonContextualKeyword,
        isIdentifierName: ()=>isIdentifierName,
        isIdentifierOrThisTypeNode: ()=>isIdentifierOrThisTypeNode,
        isIdentifierPart: ()=>isIdentifierPart,
        isIdentifierStart: ()=>isIdentifierStart,
        isIdentifierText: ()=>isIdentifierText,
        isIdentifierTypePredicate: ()=>isIdentifierTypePredicate,
        isIdentifierTypeReference: ()=>isIdentifierTypeReference,
        isIfStatement: ()=>isIfStatement,
        isIgnoredFileFromWildCardWatching: ()=>isIgnoredFileFromWildCardWatching,
        isImplicitGlob: ()=>isImplicitGlob,
        isImportAttribute: ()=>isImportAttribute,
        isImportAttributeName: ()=>isImportAttributeName,
        isImportAttributes: ()=>isImportAttributes,
        isImportCall: ()=>isImportCall,
        isImportClause: ()=>isImportClause,
        isImportDeclaration: ()=>isImportDeclaration,
        isImportEqualsDeclaration: ()=>isImportEqualsDeclaration,
        isImportKeyword: ()=>isImportKeyword,
        isImportMeta: ()=>isImportMeta,
        isImportOrExportSpecifier: ()=>isImportOrExportSpecifier,
        isImportOrExportSpecifierName: ()=>isImportOrExportSpecifierName,
        isImportSpecifier: ()=>isImportSpecifier,
        isImportTypeAssertionContainer: ()=>isImportTypeAssertionContainer,
        isImportTypeNode: ()=>isImportTypeNode,
        isImportable: ()=>isImportable,
        isInComment: ()=>isInComment,
        isInCompoundLikeAssignment: ()=>isInCompoundLikeAssignment,
        isInExpressionContext: ()=>isInExpressionContext,
        isInJSDoc: ()=>isInJSDoc,
        isInJSFile: ()=>isInJSFile,
        isInJSXText: ()=>isInJSXText,
        isInJsonFile: ()=>isInJsonFile,
        isInNonReferenceComment: ()=>isInNonReferenceComment,
        isInReferenceComment: ()=>isInReferenceComment,
        isInRightSideOfInternalImportEqualsDeclaration: ()=>isInRightSideOfInternalImportEqualsDeclaration,
        isInString: ()=>isInString,
        isInTemplateString: ()=>isInTemplateString,
        isInTopLevelContext: ()=>isInTopLevelContext,
        isInTypeQuery: ()=>isInTypeQuery,
        isIncrementalBuildInfo: ()=>isIncrementalBuildInfo,
        isIncrementalBundleEmitBuildInfo: ()=>isIncrementalBundleEmitBuildInfo,
        isIncrementalCompilation: ()=>isIncrementalCompilation,
        isIndexSignatureDeclaration: ()=>isIndexSignatureDeclaration,
        isIndexedAccessTypeNode: ()=>isIndexedAccessTypeNode,
        isInferTypeNode: ()=>isInferTypeNode,
        isInfinityOrNaNString: ()=>isInfinityOrNaNString,
        isInitializedProperty: ()=>isInitializedProperty,
        isInitializedVariable: ()=>isInitializedVariable,
        isInsideJsxElement: ()=>isInsideJsxElement,
        isInsideJsxElementOrAttribute: ()=>isInsideJsxElementOrAttribute,
        isInsideNodeModules: ()=>isInsideNodeModules,
        isInsideTemplateLiteral: ()=>isInsideTemplateLiteral,
        isInstanceOfExpression: ()=>isInstanceOfExpression,
        isInstantiatedModule: ()=>isInstantiatedModule,
        isInterfaceDeclaration: ()=>isInterfaceDeclaration,
        isInternalDeclaration: ()=>isInternalDeclaration,
        isInternalModuleImportEqualsDeclaration: ()=>isInternalModuleImportEqualsDeclaration,
        isInternalName: ()=>isInternalName,
        isIntersectionTypeNode: ()=>isIntersectionTypeNode,
        isIntrinsicJsxName: ()=>isIntrinsicJsxName,
        isIterationStatement: ()=>isIterationStatement,
        isJSDoc: ()=>isJSDoc,
        isJSDocAllType: ()=>isJSDocAllType,
        isJSDocAugmentsTag: ()=>isJSDocAugmentsTag,
        isJSDocAuthorTag: ()=>isJSDocAuthorTag,
        isJSDocCallbackTag: ()=>isJSDocCallbackTag,
        isJSDocClassTag: ()=>isJSDocClassTag,
        isJSDocCommentContainingNode: ()=>isJSDocCommentContainingNode,
        isJSDocConstructSignature: ()=>isJSDocConstructSignature,
        isJSDocDeprecatedTag: ()=>isJSDocDeprecatedTag,
        isJSDocEnumTag: ()=>isJSDocEnumTag,
        isJSDocFunctionType: ()=>isJSDocFunctionType,
        isJSDocImplementsTag: ()=>isJSDocImplementsTag,
        isJSDocImportTag: ()=>isJSDocImportTag,
        isJSDocIndexSignature: ()=>isJSDocIndexSignature,
        isJSDocLikeText: ()=>isJSDocLikeText,
        isJSDocLink: ()=>isJSDocLink,
        isJSDocLinkCode: ()=>isJSDocLinkCode,
        isJSDocLinkLike: ()=>isJSDocLinkLike,
        isJSDocLinkPlain: ()=>isJSDocLinkPlain,
        isJSDocMemberName: ()=>isJSDocMemberName,
        isJSDocNameReference: ()=>isJSDocNameReference,
        isJSDocNamepathType: ()=>isJSDocNamepathType,
        isJSDocNamespaceBody: ()=>isJSDocNamespaceBody,
        isJSDocNode: ()=>isJSDocNode,
        isJSDocNonNullableType: ()=>isJSDocNonNullableType,
        isJSDocNullableType: ()=>isJSDocNullableType,
        isJSDocOptionalParameter: ()=>isJSDocOptionalParameter,
        isJSDocOptionalType: ()=>isJSDocOptionalType,
        isJSDocOverloadTag: ()=>isJSDocOverloadTag,
        isJSDocOverrideTag: ()=>isJSDocOverrideTag,
        isJSDocParameterTag: ()=>isJSDocParameterTag,
        isJSDocPrivateTag: ()=>isJSDocPrivateTag,
        isJSDocPropertyLikeTag: ()=>isJSDocPropertyLikeTag,
        isJSDocPropertyTag: ()=>isJSDocPropertyTag,
        isJSDocProtectedTag: ()=>isJSDocProtectedTag,
        isJSDocPublicTag: ()=>isJSDocPublicTag,
        isJSDocReadonlyTag: ()=>isJSDocReadonlyTag,
        isJSDocReturnTag: ()=>isJSDocReturnTag,
        isJSDocSatisfiesExpression: ()=>isJSDocSatisfiesExpression,
        isJSDocSatisfiesTag: ()=>isJSDocSatisfiesTag,
        isJSDocSeeTag: ()=>isJSDocSeeTag,
        isJSDocSignature: ()=>isJSDocSignature,
        isJSDocTag: ()=>isJSDocTag,
        isJSDocTemplateTag: ()=>isJSDocTemplateTag,
        isJSDocThisTag: ()=>isJSDocThisTag,
        isJSDocThrowsTag: ()=>isJSDocThrowsTag,
        isJSDocTypeAlias: ()=>isJSDocTypeAlias,
        isJSDocTypeAssertion: ()=>isJSDocTypeAssertion,
        isJSDocTypeExpression: ()=>isJSDocTypeExpression,
        isJSDocTypeLiteral: ()=>isJSDocTypeLiteral,
        isJSDocTypeTag: ()=>isJSDocTypeTag,
        isJSDocTypedefTag: ()=>isJSDocTypedefTag,
        isJSDocUnknownTag: ()=>isJSDocUnknownTag,
        isJSDocUnknownType: ()=>isJSDocUnknownType,
        isJSDocVariadicType: ()=>isJSDocVariadicType,
        isJSXTagName: ()=>isJSXTagName,
        isJsonEqual: ()=>isJsonEqual,
        isJsonSourceFile: ()=>isJsonSourceFile,
        isJsxAttribute: ()=>isJsxAttribute,
        isJsxAttributeLike: ()=>isJsxAttributeLike,
        isJsxAttributeName: ()=>isJsxAttributeName,
        isJsxAttributes: ()=>isJsxAttributes,
        isJsxCallLike: ()=>isJsxCallLike,
        isJsxChild: ()=>isJsxChild,
        isJsxClosingElement: ()=>isJsxClosingElement,
        isJsxClosingFragment: ()=>isJsxClosingFragment,
        isJsxElement: ()=>isJsxElement,
        isJsxExpression: ()=>isJsxExpression,
        isJsxFragment: ()=>isJsxFragment,
        isJsxNamespacedName: ()=>isJsxNamespacedName,
        isJsxOpeningElement: ()=>isJsxOpeningElement,
        isJsxOpeningFragment: ()=>isJsxOpeningFragment,
        isJsxOpeningLikeElement: ()=>isJsxOpeningLikeElement,
        isJsxOpeningLikeElementTagName: ()=>isJsxOpeningLikeElementTagName,
        isJsxSelfClosingElement: ()=>isJsxSelfClosingElement,
        isJsxSpreadAttribute: ()=>isJsxSpreadAttribute,
        isJsxTagNameExpression: ()=>isJsxTagNameExpression,
        isJsxText: ()=>isJsxText,
        isJumpStatementTarget: ()=>isJumpStatementTarget,
        isKeyword: ()=>isKeyword,
        isKeywordOrPunctuation: ()=>isKeywordOrPunctuation,
        isKnownSymbol: ()=>isKnownSymbol,
        isLabelName: ()=>isLabelName,
        isLabelOfLabeledStatement: ()=>isLabelOfLabeledStatement,
        isLabeledStatement: ()=>isLabeledStatement,
        isLateVisibilityPaintedStatement: ()=>isLateVisibilityPaintedStatement,
        isLeftHandSideExpression: ()=>isLeftHandSideExpression,
        isLet: ()=>isLet,
        isLineBreak: ()=>isLineBreak,
        isLiteralComputedPropertyDeclarationName: ()=>isLiteralComputedPropertyDeclarationName,
        isLiteralExpression: ()=>isLiteralExpression,
        isLiteralExpressionOfObject: ()=>isLiteralExpressionOfObject,
        isLiteralImportTypeNode: ()=>isLiteralImportTypeNode,
        isLiteralKind: ()=>isLiteralKind,
        isLiteralNameOfPropertyDeclarationOrIndexAccess: ()=>isLiteralNameOfPropertyDeclarationOrIndexAccess,
        isLiteralTypeLiteral: ()=>isLiteralTypeLiteral,
        isLiteralTypeNode: ()=>isLiteralTypeNode,
        isLocalName: ()=>isLocalName,
        isLogicalOperator: ()=>isLogicalOperator,
        isLogicalOrCoalescingAssignmentExpression: ()=>isLogicalOrCoalescingAssignmentExpression,
        isLogicalOrCoalescingAssignmentOperator: ()=>isLogicalOrCoalescingAssignmentOperator,
        isLogicalOrCoalescingBinaryExpression: ()=>isLogicalOrCoalescingBinaryExpression,
        isLogicalOrCoalescingBinaryOperator: ()=>isLogicalOrCoalescingBinaryOperator,
        isMappedTypeNode: ()=>isMappedTypeNode,
        isMemberName: ()=>isMemberName,
        isMetaProperty: ()=>isMetaProperty,
        isMethodDeclaration: ()=>isMethodDeclaration,
        isMethodOrAccessor: ()=>isMethodOrAccessor,
        isMethodSignature: ()=>isMethodSignature,
        isMinusToken: ()=>isMinusToken,
        isMissingDeclaration: ()=>isMissingDeclaration,
        isMissingPackageJsonInfo: ()=>isMissingPackageJsonInfo,
        isModifier: ()=>isModifier,
        isModifierKind: ()=>isModifierKind,
        isModifierLike: ()=>isModifierLike,
        isModuleAugmentationExternal: ()=>isModuleAugmentationExternal,
        isModuleBlock: ()=>isModuleBlock,
        isModuleBody: ()=>isModuleBody,
        isModuleDeclaration: ()=>isModuleDeclaration,
        isModuleExportName: ()=>isModuleExportName,
        isModuleExportsAccessExpression: ()=>isModuleExportsAccessExpression,
        isModuleIdentifier: ()=>isModuleIdentifier,
        isModuleName: ()=>isModuleName,
        isModuleOrEnumDeclaration: ()=>isModuleOrEnumDeclaration,
        isModuleReference: ()=>isModuleReference,
        isModuleSpecifierLike: ()=>isModuleSpecifierLike,
        isModuleWithStringLiteralName: ()=>isModuleWithStringLiteralName,
        isNameOfFunctionDeclaration: ()=>isNameOfFunctionDeclaration,
        isNameOfModuleDeclaration: ()=>isNameOfModuleDeclaration,
        isNamedDeclaration: ()=>isNamedDeclaration,
        isNamedEvaluation: ()=>isNamedEvaluation,
        isNamedEvaluationSource: ()=>isNamedEvaluationSource,
        isNamedExportBindings: ()=>isNamedExportBindings,
        isNamedExports: ()=>isNamedExports,
        isNamedImportBindings: ()=>isNamedImportBindings,
        isNamedImports: ()=>isNamedImports,
        isNamedImportsOrExports: ()=>isNamedImportsOrExports,
        isNamedTupleMember: ()=>isNamedTupleMember,
        isNamespaceBody: ()=>isNamespaceBody,
        isNamespaceExport: ()=>isNamespaceExport,
        isNamespaceExportDeclaration: ()=>isNamespaceExportDeclaration,
        isNamespaceImport: ()=>isNamespaceImport,
        isNamespaceReexportDeclaration: ()=>isNamespaceReexportDeclaration,
        isNewExpression: ()=>isNewExpression,
        isNewExpressionTarget: ()=>isNewExpressionTarget,
        isNewScopeNode: ()=>isNewScopeNode,
        isNoSubstitutionTemplateLiteral: ()=>isNoSubstitutionTemplateLiteral,
        isNodeArray: ()=>isNodeArray,
        isNodeArrayMultiLine: ()=>isNodeArrayMultiLine,
        isNodeDescendantOf: ()=>isNodeDescendantOf,
        isNodeKind: ()=>isNodeKind,
        isNodeLikeSystem: ()=>isNodeLikeSystem,
        isNodeModulesDirectory: ()=>isNodeModulesDirectory,
        isNodeWithPossibleHoistedDeclaration: ()=>isNodeWithPossibleHoistedDeclaration,
        isNonContextualKeyword: ()=>isNonContextualKeyword,
        isNonGlobalAmbientModule: ()=>isNonGlobalAmbientModule,
        isNonNullAccess: ()=>isNonNullAccess,
        isNonNullChain: ()=>isNonNullChain,
        isNonNullExpression: ()=>isNonNullExpression,
        isNonStaticMethodOrAccessorWithPrivateName: ()=>isNonStaticMethodOrAccessorWithPrivateName,
        isNotEmittedStatement: ()=>isNotEmittedStatement,
        isNullishCoalesce: ()=>isNullishCoalesce,
        isNumber: ()=>isNumber,
        isNumericLiteral: ()=>isNumericLiteral,
        isNumericLiteralName: ()=>isNumericLiteralName,
        isObjectBindingElementWithoutPropertyName: ()=>isObjectBindingElementWithoutPropertyName,
        isObjectBindingOrAssignmentElement: ()=>isObjectBindingOrAssignmentElement,
        isObjectBindingOrAssignmentPattern: ()=>isObjectBindingOrAssignmentPattern,
        isObjectBindingPattern: ()=>isObjectBindingPattern,
        isObjectLiteralElement: ()=>isObjectLiteralElement,
        isObjectLiteralElementLike: ()=>isObjectLiteralElementLike,
        isObjectLiteralExpression: ()=>isObjectLiteralExpression,
        isObjectLiteralMethod: ()=>isObjectLiteralMethod,
        isObjectLiteralOrClassExpressionMethodOrAccessor: ()=>isObjectLiteralOrClassExpressionMethodOrAccessor,
        isObjectTypeDeclaration: ()=>isObjectTypeDeclaration,
        isOmittedExpression: ()=>isOmittedExpression,
        isOptionalChain: ()=>isOptionalChain,
        isOptionalChainRoot: ()=>isOptionalChainRoot,
        isOptionalDeclaration: ()=>isOptionalDeclaration,
        isOptionalJSDocPropertyLikeTag: ()=>isOptionalJSDocPropertyLikeTag,
        isOptionalTypeNode: ()=>isOptionalTypeNode,
        isOuterExpression: ()=>isOuterExpression,
        isOutermostOptionalChain: ()=>isOutermostOptionalChain,
        isOverrideModifier: ()=>isOverrideModifier,
        isPackageJsonInfo: ()=>isPackageJsonInfo,
        isPackedArrayLiteral: ()=>isPackedArrayLiteral,
        isParameter: ()=>isParameter,
        isParameterPropertyDeclaration: ()=>isParameterPropertyDeclaration,
        isParameterPropertyModifier: ()=>isParameterPropertyModifier,
        isParenthesizedExpression: ()=>isParenthesizedExpression,
        isParenthesizedTypeNode: ()=>isParenthesizedTypeNode,
        isParseTreeNode: ()=>isParseTreeNode,
        isPartOfParameterDeclaration: ()=>isPartOfParameterDeclaration,
        isPartOfTypeNode: ()=>isPartOfTypeNode,
        isPartOfTypeOnlyImportOrExportDeclaration: ()=>isPartOfTypeOnlyImportOrExportDeclaration,
        isPartOfTypeQuery: ()=>isPartOfTypeQuery,
        isPartiallyEmittedExpression: ()=>isPartiallyEmittedExpression,
        isPatternMatch: ()=>isPatternMatch,
        isPinnedComment: ()=>isPinnedComment,
        isPlainJsFile: ()=>isPlainJsFile,
        isPlusToken: ()=>isPlusToken,
        isPossiblyTypeArgumentPosition: ()=>isPossiblyTypeArgumentPosition,
        isPostfixUnaryExpression: ()=>isPostfixUnaryExpression,
        isPrefixUnaryExpression: ()=>isPrefixUnaryExpression,
        isPrimitiveLiteralValue: ()=>isPrimitiveLiteralValue,
        isPrivateIdentifier: ()=>isPrivateIdentifier,
        isPrivateIdentifierClassElementDeclaration: ()=>isPrivateIdentifierClassElementDeclaration,
        isPrivateIdentifierPropertyAccessExpression: ()=>isPrivateIdentifierPropertyAccessExpression,
        isPrivateIdentifierSymbol: ()=>isPrivateIdentifierSymbol,
        isProgramUptoDate: ()=>isProgramUptoDate,
        isPrologueDirective: ()=>isPrologueDirective,
        isPropertyAccessChain: ()=>isPropertyAccessChain,
        isPropertyAccessEntityNameExpression: ()=>isPropertyAccessEntityNameExpression,
        isPropertyAccessExpression: ()=>isPropertyAccessExpression,
        isPropertyAccessOrQualifiedName: ()=>isPropertyAccessOrQualifiedName,
        isPropertyAccessOrQualifiedNameOrImportTypeNode: ()=>isPropertyAccessOrQualifiedNameOrImportTypeNode,
        isPropertyAssignment: ()=>isPropertyAssignment,
        isPropertyDeclaration: ()=>isPropertyDeclaration,
        isPropertyName: ()=>isPropertyName,
        isPropertyNameLiteral: ()=>isPropertyNameLiteral,
        isPropertySignature: ()=>isPropertySignature,
        isPrototypeAccess: ()=>isPrototypeAccess,
        isPrototypePropertyAssignment: ()=>isPrototypePropertyAssignment,
        isPunctuation: ()=>isPunctuation,
        isPushOrUnshiftIdentifier: ()=>isPushOrUnshiftIdentifier,
        isQualifiedName: ()=>isQualifiedName,
        isQuestionDotToken: ()=>isQuestionDotToken,
        isQuestionOrExclamationToken: ()=>isQuestionOrExclamationToken,
        isQuestionOrPlusOrMinusToken: ()=>isQuestionOrPlusOrMinusToken,
        isQuestionToken: ()=>isQuestionToken,
        isReadonlyKeyword: ()=>isReadonlyKeyword,
        isReadonlyKeywordOrPlusOrMinusToken: ()=>isReadonlyKeywordOrPlusOrMinusToken,
        isRecognizedTripleSlashComment: ()=>isRecognizedTripleSlashComment,
        isReferenceFileLocation: ()=>isReferenceFileLocation,
        isReferencedFile: ()=>isReferencedFile,
        isRegularExpressionLiteral: ()=>isRegularExpressionLiteral,
        isRequireCall: ()=>isRequireCall,
        isRequireVariableStatement: ()=>isRequireVariableStatement,
        isRestParameter: ()=>isRestParameter,
        isRestTypeNode: ()=>isRestTypeNode,
        isReturnStatement: ()=>isReturnStatement,
        isReturnStatementWithFixablePromiseHandler: ()=>isReturnStatementWithFixablePromiseHandler,
        isRightSideOfAccessExpression: ()=>isRightSideOfAccessExpression,
        isRightSideOfInstanceofExpression: ()=>isRightSideOfInstanceofExpression,
        isRightSideOfPropertyAccess: ()=>isRightSideOfPropertyAccess,
        isRightSideOfQualifiedName: ()=>isRightSideOfQualifiedName,
        isRightSideOfQualifiedNameOrPropertyAccess: ()=>isRightSideOfQualifiedNameOrPropertyAccess,
        isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName: ()=>isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName,
        isRootedDiskPath: ()=>isRootedDiskPath,
        isSameEntityName: ()=>isSameEntityName,
        isSatisfiesExpression: ()=>isSatisfiesExpression,
        isSemicolonClassElement: ()=>isSemicolonClassElement,
        isSetAccessor: ()=>isSetAccessor,
        isSetAccessorDeclaration: ()=>isSetAccessorDeclaration,
        isShiftOperatorOrHigher: ()=>isShiftOperatorOrHigher,
        isShorthandAmbientModuleSymbol: ()=>isShorthandAmbientModuleSymbol,
        isShorthandPropertyAssignment: ()=>isShorthandPropertyAssignment,
        isSideEffectImport: ()=>isSideEffectImport,
        isSignedNumericLiteral: ()=>isSignedNumericLiteral,
        isSimpleCopiableExpression: ()=>isSimpleCopiableExpression,
        isSimpleInlineableExpression: ()=>isSimpleInlineableExpression,
        isSimpleParameterList: ()=>isSimpleParameterList,
        isSingleOrDoubleQuote: ()=>isSingleOrDoubleQuote,
        isSolutionConfig: ()=>isSolutionConfig,
        isSourceElement: ()=>isSourceElement,
        isSourceFile: ()=>isSourceFile,
        isSourceFileFromLibrary: ()=>isSourceFileFromLibrary,
        isSourceFileJS: ()=>isSourceFileJS,
        isSourceFileNotJson: ()=>isSourceFileNotJson,
        isSourceMapping: ()=>isSourceMapping,
        isSpecialPropertyDeclaration: ()=>isSpecialPropertyDeclaration,
        isSpreadAssignment: ()=>isSpreadAssignment,
        isSpreadElement: ()=>isSpreadElement,
        isStatement: ()=>isStatement,
        isStatementButNotDeclaration: ()=>isStatementButNotDeclaration,
        isStatementOrBlock: ()=>isStatementOrBlock,
        isStatementWithLocals: ()=>isStatementWithLocals,
        isStatic: ()=>isStatic,
        isStaticModifier: ()=>isStaticModifier,
        isString: ()=>isString,
        isStringANonContextualKeyword: ()=>isStringANonContextualKeyword,
        isStringAndEmptyAnonymousObjectIntersection: ()=>isStringAndEmptyAnonymousObjectIntersection,
        isStringDoubleQuoted: ()=>isStringDoubleQuoted,
        isStringLiteral: ()=>isStringLiteral,
        isStringLiteralLike: ()=>isStringLiteralLike,
        isStringLiteralOrJsxExpression: ()=>isStringLiteralOrJsxExpression,
        isStringLiteralOrTemplate: ()=>isStringLiteralOrTemplate,
        isStringOrNumericLiteralLike: ()=>isStringOrNumericLiteralLike,
        isStringOrRegularExpressionOrTemplateLiteral: ()=>isStringOrRegularExpressionOrTemplateLiteral,
        isStringTextContainingNode: ()=>isStringTextContainingNode,
        isSuperCall: ()=>isSuperCall,
        isSuperKeyword: ()=>isSuperKeyword,
        isSuperProperty: ()=>isSuperProperty,
        isSupportedSourceFileName: ()=>isSupportedSourceFileName,
        isSwitchStatement: ()=>isSwitchStatement,
        isSyntaxList: ()=>isSyntaxList,
        isSyntheticExpression: ()=>isSyntheticExpression,
        isSyntheticReference: ()=>isSyntheticReference,
        isTagName: ()=>isTagName,
        isTaggedTemplateExpression: ()=>isTaggedTemplateExpression,
        isTaggedTemplateTag: ()=>isTaggedTemplateTag,
        isTemplateExpression: ()=>isTemplateExpression,
        isTemplateHead: ()=>isTemplateHead,
        isTemplateLiteral: ()=>isTemplateLiteral,
        isTemplateLiteralKind: ()=>isTemplateLiteralKind,
        isTemplateLiteralToken: ()=>isTemplateLiteralToken,
        isTemplateLiteralTypeNode: ()=>isTemplateLiteralTypeNode,
        isTemplateLiteralTypeSpan: ()=>isTemplateLiteralTypeSpan,
        isTemplateMiddle: ()=>isTemplateMiddle,
        isTemplateMiddleOrTemplateTail: ()=>isTemplateMiddleOrTemplateTail,
        isTemplateSpan: ()=>isTemplateSpan,
        isTemplateTail: ()=>isTemplateTail,
        isTextWhiteSpaceLike: ()=>isTextWhiteSpaceLike,
        isThis: ()=>isThis,
        isThisContainerOrFunctionBlock: ()=>isThisContainerOrFunctionBlock,
        isThisIdentifier: ()=>isThisIdentifier,
        isThisInTypeQuery: ()=>isThisInTypeQuery,
        isThisInitializedDeclaration: ()=>isThisInitializedDeclaration,
        isThisInitializedObjectBindingExpression: ()=>isThisInitializedObjectBindingExpression,
        isThisProperty: ()=>isThisProperty,
        isThisTypeNode: ()=>isThisTypeNode,
        isThisTypeParameter: ()=>isThisTypeParameter,
        isThisTypePredicate: ()=>isThisTypePredicate,
        isThrowStatement: ()=>isThrowStatement,
        isToken: ()=>isToken,
        isTokenKind: ()=>isTokenKind,
        isTraceEnabled: ()=>isTraceEnabled,
        isTransientSymbol: ()=>isTransientSymbol,
        isTrivia: ()=>isTrivia,
        isTryStatement: ()=>isTryStatement,
        isTupleTypeNode: ()=>isTupleTypeNode,
        isTypeAlias: ()=>isTypeAlias,
        isTypeAliasDeclaration: ()=>isTypeAliasDeclaration,
        isTypeAssertionExpression: ()=>isTypeAssertionExpression,
        isTypeDeclaration: ()=>isTypeDeclaration,
        isTypeElement: ()=>isTypeElement,
        isTypeKeyword: ()=>isTypeKeyword,
        isTypeKeywordTokenOrIdentifier: ()=>isTypeKeywordTokenOrIdentifier,
        isTypeLiteralNode: ()=>isTypeLiteralNode,
        isTypeNode: ()=>isTypeNode,
        isTypeNodeKind: ()=>isTypeNodeKind,
        isTypeOfExpression: ()=>isTypeOfExpression,
        isTypeOnlyExportDeclaration: ()=>isTypeOnlyExportDeclaration,
        isTypeOnlyImportDeclaration: ()=>isTypeOnlyImportDeclaration,
        isTypeOnlyImportOrExportDeclaration: ()=>isTypeOnlyImportOrExportDeclaration,
        isTypeOperatorNode: ()=>isTypeOperatorNode,
        isTypeParameterDeclaration: ()=>isTypeParameterDeclaration,
        isTypePredicateNode: ()=>isTypePredicateNode,
        isTypeQueryNode: ()=>isTypeQueryNode,
        isTypeReferenceNode: ()=>isTypeReferenceNode,
        isTypeReferenceType: ()=>isTypeReferenceType,
        isTypeUsableAsPropertyName: ()=>isTypeUsableAsPropertyName,
        isUMDExportSymbol: ()=>isUMDExportSymbol,
        isUnaryExpression: ()=>isUnaryExpression,
        isUnaryExpressionWithWrite: ()=>isUnaryExpressionWithWrite,
        isUnicodeIdentifierStart: ()=>isUnicodeIdentifierStart,
        isUnionTypeNode: ()=>isUnionTypeNode,
        isUrl: ()=>isUrl,
        isValidBigIntString: ()=>isValidBigIntString,
        isValidESSymbolDeclaration: ()=>isValidESSymbolDeclaration,
        isValidTypeOnlyAliasUseSite: ()=>isValidTypeOnlyAliasUseSite,
        isValueSignatureDeclaration: ()=>isValueSignatureDeclaration,
        isVarAwaitUsing: ()=>isVarAwaitUsing,
        isVarConst: ()=>isVarConst,
        isVarConstLike: ()=>isVarConstLike,
        isVarUsing: ()=>isVarUsing,
        isVariableDeclaration: ()=>isVariableDeclaration,
        isVariableDeclarationInVariableStatement: ()=>isVariableDeclarationInVariableStatement,
        isVariableDeclarationInitializedToBareOrAccessedRequire: ()=>isVariableDeclarationInitializedToBareOrAccessedRequire,
        isVariableDeclarationInitializedToRequire: ()=>isVariableDeclarationInitializedToRequire,
        isVariableDeclarationList: ()=>isVariableDeclarationList,
        isVariableLike: ()=>isVariableLike,
        isVariableStatement: ()=>isVariableStatement,
        isVoidExpression: ()=>isVoidExpression,
        isWatchSet: ()=>isWatchSet,
        isWhileStatement: ()=>isWhileStatement,
        isWhiteSpaceLike: ()=>isWhiteSpaceLike,
        isWhiteSpaceSingleLine: ()=>isWhiteSpaceSingleLine,
        isWithStatement: ()=>isWithStatement,
        isWriteAccess: ()=>isWriteAccess,
        isWriteOnlyAccess: ()=>isWriteOnlyAccess,
        isYieldExpression: ()=>isYieldExpression,
        jsxModeNeedsExplicitImport: ()=>jsxModeNeedsExplicitImport,
        keywordPart: ()=>keywordPart,
        last: ()=>last,
        lastOrUndefined: ()=>lastOrUndefined,
        length: ()=>length,
        libMap: ()=>libMap,
        libs: ()=>libs,
        lineBreakPart: ()=>lineBreakPart,
        loadModuleFromGlobalCache: ()=>loadModuleFromGlobalCache,
        loadWithModeAwareCache: ()=>loadWithModeAwareCache,
        makeIdentifierFromModuleName: ()=>makeIdentifierFromModuleName,
        makeImport: ()=>makeImport,
        makeStringLiteral: ()=>makeStringLiteral,
        mangleScopedPackageName: ()=>mangleScopedPackageName,
        map: ()=>map,
        mapAllOrFail: ()=>mapAllOrFail,
        mapDefined: ()=>mapDefined,
        mapDefinedIterator: ()=>mapDefinedIterator,
        mapEntries: ()=>mapEntries,
        mapIterator: ()=>mapIterator,
        mapOneOrMany: ()=>mapOneOrMany,
        mapToDisplayParts: ()=>mapToDisplayParts,
        matchFiles: ()=>matchFiles,
        matchPatternOrExact: ()=>matchPatternOrExact,
        matchedText: ()=>matchedText,
        matchesExclude: ()=>matchesExclude,
        matchesExcludeWorker: ()=>matchesExcludeWorker,
        maxBy: ()=>maxBy,
        maybeBind: ()=>maybeBind,
        maybeSetLocalizedDiagnosticMessages: ()=>maybeSetLocalizedDiagnosticMessages,
        memoize: ()=>memoize,
        memoizeOne: ()=>memoizeOne,
        min: ()=>min,
        minAndMax: ()=>minAndMax,
        missingFileModifiedTime: ()=>missingFileModifiedTime,
        modifierToFlag: ()=>modifierToFlag,
        modifiersToFlags: ()=>modifiersToFlags,
        moduleExportNameIsDefault: ()=>moduleExportNameIsDefault,
        moduleExportNameTextEscaped: ()=>moduleExportNameTextEscaped,
        moduleExportNameTextUnescaped: ()=>moduleExportNameTextUnescaped,
        moduleOptionDeclaration: ()=>moduleOptionDeclaration,
        moduleResolutionIsEqualTo: ()=>moduleResolutionIsEqualTo,
        moduleResolutionNameAndModeGetter: ()=>moduleResolutionNameAndModeGetter,
        moduleResolutionOptionDeclarations: ()=>moduleResolutionOptionDeclarations,
        moduleResolutionSupportsPackageJsonExportsAndImports: ()=>moduleResolutionSupportsPackageJsonExportsAndImports,
        moduleResolutionUsesNodeModules: ()=>moduleResolutionUsesNodeModules,
        moduleSpecifierToValidIdentifier: ()=>moduleSpecifierToValidIdentifier,
        moduleSpecifiers: ()=>ts_moduleSpecifiers_exports,
        moduleSupportsImportAttributes: ()=>moduleSupportsImportAttributes,
        moduleSymbolToValidIdentifier: ()=>moduleSymbolToValidIdentifier,
        moveEmitHelpers: ()=>moveEmitHelpers,
        moveRangeEnd: ()=>moveRangeEnd,
        moveRangePastDecorators: ()=>moveRangePastDecorators,
        moveRangePastModifiers: ()=>moveRangePastModifiers,
        moveRangePos: ()=>moveRangePos,
        moveSyntheticComments: ()=>moveSyntheticComments,
        mutateMap: ()=>mutateMap,
        mutateMapSkippingNewValues: ()=>mutateMapSkippingNewValues,
        needsParentheses: ()=>needsParentheses,
        needsScopeMarker: ()=>needsScopeMarker,
        newCaseClauseTracker: ()=>newCaseClauseTracker,
        newPrivateEnvironment: ()=>newPrivateEnvironment,
        noEmitNotification: ()=>noEmitNotification,
        noEmitSubstitution: ()=>noEmitSubstitution,
        noTransformers: ()=>noTransformers,
        noTruncationMaximumTruncationLength: ()=>noTruncationMaximumTruncationLength,
        nodeCanBeDecorated: ()=>nodeCanBeDecorated,
        nodeCoreModules: ()=>nodeCoreModules,
        nodeHasName: ()=>nodeHasName,
        nodeIsDecorated: ()=>nodeIsDecorated,
        nodeIsMissing: ()=>nodeIsMissing,
        nodeIsPresent: ()=>nodeIsPresent,
        nodeIsSynthesized: ()=>nodeIsSynthesized,
        nodeModuleNameResolver: ()=>nodeModuleNameResolver,
        nodeModulesPathPart: ()=>nodeModulesPathPart,
        nodeNextJsonConfigResolver: ()=>nodeNextJsonConfigResolver,
        nodeOrChildIsDecorated: ()=>nodeOrChildIsDecorated,
        nodeOverlapsWithStartEnd: ()=>nodeOverlapsWithStartEnd,
        nodePosToString: ()=>nodePosToString,
        nodeSeenTracker: ()=>nodeSeenTracker,
        nodeStartsNewLexicalEnvironment: ()=>nodeStartsNewLexicalEnvironment,
        noop: ()=>noop,
        noopFileWatcher: ()=>noopFileWatcher,
        normalizePath: ()=>normalizePath,
        normalizeSlashes: ()=>normalizeSlashes,
        normalizeSpans: ()=>normalizeSpans,
        not: ()=>not,
        notImplemented: ()=>notImplemented,
        notImplementedResolver: ()=>notImplementedResolver,
        nullNodeConverters: ()=>nullNodeConverters,
        nullParenthesizerRules: ()=>nullParenthesizerRules,
        nullTransformationContext: ()=>nullTransformationContext,
        objectAllocator: ()=>objectAllocator,
        operatorPart: ()=>operatorPart,
        optionDeclarations: ()=>optionDeclarations,
        optionMapToObject: ()=>optionMapToObject,
        optionsAffectingProgramStructure: ()=>optionsAffectingProgramStructure,
        optionsForBuild: ()=>optionsForBuild,
        optionsForWatch: ()=>optionsForWatch,
        optionsHaveChanges: ()=>optionsHaveChanges,
        or: ()=>or,
        orderedRemoveItem: ()=>orderedRemoveItem,
        orderedRemoveItemAt: ()=>orderedRemoveItemAt,
        packageIdToPackageName: ()=>packageIdToPackageName,
        packageIdToString: ()=>packageIdToString,
        parameterIsThisKeyword: ()=>parameterIsThisKeyword,
        parameterNamePart: ()=>parameterNamePart,
        parseBaseNodeFactory: ()=>parseBaseNodeFactory,
        parseBigInt: ()=>parseBigInt,
        parseBuildCommand: ()=>parseBuildCommand,
        parseCommandLine: ()=>parseCommandLine,
        parseCommandLineWorker: ()=>parseCommandLineWorker,
        parseConfigFileTextToJson: ()=>parseConfigFileTextToJson,
        parseConfigFileWithSystem: ()=>parseConfigFileWithSystem,
        parseConfigHostFromCompilerHostLike: ()=>parseConfigHostFromCompilerHostLike,
        parseCustomTypeOption: ()=>parseCustomTypeOption,
        parseIsolatedEntityName: ()=>parseIsolatedEntityName,
        parseIsolatedJSDocComment: ()=>parseIsolatedJSDocComment,
        parseJSDocTypeExpressionForTests: ()=>parseJSDocTypeExpressionForTests,
        parseJsonConfigFileContent: ()=>parseJsonConfigFileContent,
        parseJsonSourceFileConfigFileContent: ()=>parseJsonSourceFileConfigFileContent,
        parseJsonText: ()=>parseJsonText,
        parseListTypeOption: ()=>parseListTypeOption,
        parseNodeFactory: ()=>parseNodeFactory,
        parseNodeModuleFromPath: ()=>parseNodeModuleFromPath,
        parsePackageName: ()=>parsePackageName,
        parsePseudoBigInt: ()=>parsePseudoBigInt,
        parseValidBigInt: ()=>parseValidBigInt,
        pasteEdits: ()=>ts_PasteEdits_exports,
        patchWriteFileEnsuringDirectory: ()=>patchWriteFileEnsuringDirectory,
        pathContainsNodeModules: ()=>pathContainsNodeModules,
        pathIsAbsolute: ()=>pathIsAbsolute,
        pathIsBareSpecifier: ()=>pathIsBareSpecifier,
        pathIsRelative: ()=>pathIsRelative,
        patternText: ()=>patternText,
        performIncrementalCompilation: ()=>performIncrementalCompilation,
        performance: ()=>ts_performance_exports,
        positionBelongsToNode: ()=>positionBelongsToNode,
        positionIsASICandidate: ()=>positionIsASICandidate,
        positionIsSynthesized: ()=>positionIsSynthesized,
        positionsAreOnSameLine: ()=>positionsAreOnSameLine,
        preProcessFile: ()=>preProcessFile,
        probablyUsesSemicolons: ()=>probablyUsesSemicolons,
        processCommentPragmas: ()=>processCommentPragmas,
        processPragmasIntoFields: ()=>processPragmasIntoFields,
        processTaggedTemplateExpression: ()=>processTaggedTemplateExpression,
        programContainsEsModules: ()=>programContainsEsModules,
        programContainsModules: ()=>programContainsModules,
        projectReferenceIsEqualTo: ()=>projectReferenceIsEqualTo,
        propertyNamePart: ()=>propertyNamePart,
        pseudoBigIntToString: ()=>pseudoBigIntToString,
        punctuationPart: ()=>punctuationPart,
        pushIfUnique: ()=>pushIfUnique,
        quote: ()=>quote,
        quotePreferenceFromString: ()=>quotePreferenceFromString,
        rangeContainsPosition: ()=>rangeContainsPosition,
        rangeContainsPositionExclusive: ()=>rangeContainsPositionExclusive,
        rangeContainsRange: ()=>rangeContainsRange,
        rangeContainsRangeExclusive: ()=>rangeContainsRangeExclusive,
        rangeContainsStartEnd: ()=>rangeContainsStartEnd,
        rangeEndIsOnSameLineAsRangeStart: ()=>rangeEndIsOnSameLineAsRangeStart,
        rangeEndPositionsAreOnSameLine: ()=>rangeEndPositionsAreOnSameLine,
        rangeEquals: ()=>rangeEquals,
        rangeIsOnSingleLine: ()=>rangeIsOnSingleLine,
        rangeOfNode: ()=>rangeOfNode,
        rangeOfTypeParameters: ()=>rangeOfTypeParameters,
        rangeOverlapsWithStartEnd: ()=>rangeOverlapsWithStartEnd,
        rangeStartIsOnSameLineAsRangeEnd: ()=>rangeStartIsOnSameLineAsRangeEnd,
        rangeStartPositionsAreOnSameLine: ()=>rangeStartPositionsAreOnSameLine,
        readBuilderProgram: ()=>readBuilderProgram,
        readConfigFile: ()=>readConfigFile,
        readJson: ()=>readJson,
        readJsonConfigFile: ()=>readJsonConfigFile,
        readJsonOrUndefined: ()=>readJsonOrUndefined,
        reduceEachLeadingCommentRange: ()=>reduceEachLeadingCommentRange,
        reduceEachTrailingCommentRange: ()=>reduceEachTrailingCommentRange,
        reduceLeft: ()=>reduceLeft,
        reduceLeftIterator: ()=>reduceLeftIterator,
        reducePathComponents: ()=>reducePathComponents,
        refactor: ()=>ts_refactor_exports,
        regExpEscape: ()=>regExpEscape,
        regularExpressionFlagToCharacterCode: ()=>regularExpressionFlagToCharacterCode,
        relativeComplement: ()=>relativeComplement,
        removeAllComments: ()=>removeAllComments,
        removeEmitHelper: ()=>removeEmitHelper,
        removeExtension: ()=>removeExtension,
        removeFileExtension: ()=>removeFileExtension,
        removeIgnoredPath: ()=>removeIgnoredPath,
        removeMinAndVersionNumbers: ()=>removeMinAndVersionNumbers,
        removePrefix: ()=>removePrefix,
        removeSuffix: ()=>removeSuffix,
        removeTrailingDirectorySeparator: ()=>removeTrailingDirectorySeparator,
        repeatString: ()=>repeatString,
        replaceElement: ()=>replaceElement,
        replaceFirstStar: ()=>replaceFirstStar,
        resolutionExtensionIsTSOrJson: ()=>resolutionExtensionIsTSOrJson,
        resolveConfigFileProjectName: ()=>resolveConfigFileProjectName,
        resolveJSModule: ()=>resolveJSModule,
        resolveLibrary: ()=>resolveLibrary,
        resolveModuleName: ()=>resolveModuleName,
        resolveModuleNameFromCache: ()=>resolveModuleNameFromCache,
        resolvePackageNameToPackageJson: ()=>resolvePackageNameToPackageJson,
        resolvePath: ()=>resolvePath,
        resolveProjectReferencePath: ()=>resolveProjectReferencePath,
        resolveTripleslashReference: ()=>resolveTripleslashReference,
        resolveTypeReferenceDirective: ()=>resolveTypeReferenceDirective,
        resolvingEmptyArray: ()=>resolvingEmptyArray,
        returnFalse: ()=>returnFalse,
        returnNoopFileWatcher: ()=>returnNoopFileWatcher,
        returnTrue: ()=>returnTrue,
        returnUndefined: ()=>returnUndefined,
        returnsPromise: ()=>returnsPromise,
        rewriteModuleSpecifier: ()=>rewriteModuleSpecifier,
        sameFlatMap: ()=>sameFlatMap,
        sameMap: ()=>sameMap,
        sameMapping: ()=>sameMapping,
        scanTokenAtPosition: ()=>scanTokenAtPosition,
        scanner: ()=>scanner,
        semanticDiagnosticsOptionDeclarations: ()=>semanticDiagnosticsOptionDeclarations,
        serializeCompilerOptions: ()=>serializeCompilerOptions,
        server: ()=>ts_server_exports4,
        servicesVersion: ()=>servicesVersion,
        setCommentRange: ()=>setCommentRange,
        setConfigFileInOptions: ()=>setConfigFileInOptions,
        setConstantValue: ()=>setConstantValue,
        setEmitFlags: ()=>setEmitFlags,
        setGetSourceFileAsHashVersioned: ()=>setGetSourceFileAsHashVersioned,
        setIdentifierAutoGenerate: ()=>setIdentifierAutoGenerate,
        setIdentifierGeneratedImportReference: ()=>setIdentifierGeneratedImportReference,
        setIdentifierTypeArguments: ()=>setIdentifierTypeArguments,
        setInternalEmitFlags: ()=>setInternalEmitFlags,
        setLocalizedDiagnosticMessages: ()=>setLocalizedDiagnosticMessages,
        setNodeChildren: ()=>setNodeChildren,
        setNodeFlags: ()=>setNodeFlags,
        setObjectAllocator: ()=>setObjectAllocator,
        setOriginalNode: ()=>setOriginalNode,
        setParent: ()=>setParent,
        setParentRecursive: ()=>setParentRecursive,
        setPrivateIdentifier: ()=>setPrivateIdentifier,
        setSnippetElement: ()=>setSnippetElement,
        setSourceMapRange: ()=>setSourceMapRange,
        setStackTraceLimit: ()=>setStackTraceLimit,
        setStartsOnNewLine: ()=>setStartsOnNewLine,
        setSyntheticLeadingComments: ()=>setSyntheticLeadingComments,
        setSyntheticTrailingComments: ()=>setSyntheticTrailingComments,
        setSys: ()=>setSys,
        setSysLog: ()=>setSysLog,
        setTextRange: ()=>setTextRange,
        setTextRangeEnd: ()=>setTextRangeEnd,
        setTextRangePos: ()=>setTextRangePos,
        setTextRangePosEnd: ()=>setTextRangePosEnd,
        setTextRangePosWidth: ()=>setTextRangePosWidth,
        setTokenSourceMapRange: ()=>setTokenSourceMapRange,
        setTypeNode: ()=>setTypeNode,
        setUILocale: ()=>setUILocale,
        setValueDeclaration: ()=>setValueDeclaration,
        shouldAllowImportingTsExtension: ()=>shouldAllowImportingTsExtension,
        shouldPreserveConstEnums: ()=>shouldPreserveConstEnums,
        shouldRewriteModuleSpecifier: ()=>shouldRewriteModuleSpecifier,
        shouldUseUriStyleNodeCoreModules: ()=>shouldUseUriStyleNodeCoreModules,
        showModuleSpecifier: ()=>showModuleSpecifier,
        signatureHasRestParameter: ()=>signatureHasRestParameter,
        signatureToDisplayParts: ()=>signatureToDisplayParts,
        single: ()=>single,
        singleElementArray: ()=>singleElementArray,
        singleIterator: ()=>singleIterator,
        singleOrMany: ()=>singleOrMany,
        singleOrUndefined: ()=>singleOrUndefined,
        skipAlias: ()=>skipAlias,
        skipConstraint: ()=>skipConstraint,
        skipOuterExpressions: ()=>skipOuterExpressions,
        skipParentheses: ()=>skipParentheses,
        skipPartiallyEmittedExpressions: ()=>skipPartiallyEmittedExpressions,
        skipTrivia: ()=>skipTrivia,
        skipTypeChecking: ()=>skipTypeChecking,
        skipTypeCheckingIgnoringNoCheck: ()=>skipTypeCheckingIgnoringNoCheck,
        skipTypeParentheses: ()=>skipTypeParentheses,
        skipWhile: ()=>skipWhile,
        sliceAfter: ()=>sliceAfter,
        some: ()=>some,
        sortAndDeduplicate: ()=>sortAndDeduplicate,
        sortAndDeduplicateDiagnostics: ()=>sortAndDeduplicateDiagnostics,
        sourceFileAffectingCompilerOptions: ()=>sourceFileAffectingCompilerOptions,
        sourceFileMayBeEmitted: ()=>sourceFileMayBeEmitted,
        sourceMapCommentRegExp: ()=>sourceMapCommentRegExp,
        sourceMapCommentRegExpDontCareLineStart: ()=>sourceMapCommentRegExpDontCareLineStart,
        spacePart: ()=>spacePart,
        spanMap: ()=>spanMap,
        startEndContainsRange: ()=>startEndContainsRange,
        startEndOverlapsWithStartEnd: ()=>startEndOverlapsWithStartEnd,
        startOnNewLine: ()=>startOnNewLine,
        startTracing: ()=>startTracing,
        startsWith: ()=>startsWith,
        startsWithDirectory: ()=>startsWithDirectory,
        startsWithUnderscore: ()=>startsWithUnderscore,
        startsWithUseStrict: ()=>startsWithUseStrict,
        stringContainsAt: ()=>stringContainsAt,
        stringToToken: ()=>stringToToken,
        stripQuotes: ()=>stripQuotes,
        supportedDeclarationExtensions: ()=>supportedDeclarationExtensions,
        supportedJSExtensionsFlat: ()=>supportedJSExtensionsFlat,
        supportedLocaleDirectories: ()=>supportedLocaleDirectories,
        supportedTSExtensionsFlat: ()=>supportedTSExtensionsFlat,
        supportedTSImplementationExtensions: ()=>supportedTSImplementationExtensions,
        suppressLeadingAndTrailingTrivia: ()=>suppressLeadingAndTrailingTrivia,
        suppressLeadingTrivia: ()=>suppressLeadingTrivia,
        suppressTrailingTrivia: ()=>suppressTrailingTrivia,
        symbolEscapedNameNoDefault: ()=>symbolEscapedNameNoDefault,
        symbolName: ()=>symbolName,
        symbolNameNoDefault: ()=>symbolNameNoDefault,
        symbolToDisplayParts: ()=>symbolToDisplayParts,
        sys: ()=>sys,
        sysLog: ()=>sysLog,
        tagNamesAreEquivalent: ()=>tagNamesAreEquivalent,
        takeWhile: ()=>takeWhile,
        targetOptionDeclaration: ()=>targetOptionDeclaration,
        targetToLibMap: ()=>targetToLibMap,
        testFormatSettings: ()=>testFormatSettings,
        textChangeRangeIsUnchanged: ()=>textChangeRangeIsUnchanged,
        textChangeRangeNewSpan: ()=>textChangeRangeNewSpan,
        textChanges: ()=>ts_textChanges_exports,
        textOrKeywordPart: ()=>textOrKeywordPart,
        textPart: ()=>textPart,
        textRangeContainsPositionInclusive: ()=>textRangeContainsPositionInclusive,
        textRangeContainsTextSpan: ()=>textRangeContainsTextSpan,
        textRangeIntersectsWithTextSpan: ()=>textRangeIntersectsWithTextSpan,
        textSpanContainsPosition: ()=>textSpanContainsPosition,
        textSpanContainsTextRange: ()=>textSpanContainsTextRange,
        textSpanContainsTextSpan: ()=>textSpanContainsTextSpan,
        textSpanEnd: ()=>textSpanEnd,
        textSpanIntersection: ()=>textSpanIntersection,
        textSpanIntersectsWith: ()=>textSpanIntersectsWith,
        textSpanIntersectsWithPosition: ()=>textSpanIntersectsWithPosition,
        textSpanIntersectsWithTextSpan: ()=>textSpanIntersectsWithTextSpan,
        textSpanIsEmpty: ()=>textSpanIsEmpty,
        textSpanOverlap: ()=>textSpanOverlap,
        textSpanOverlapsWith: ()=>textSpanOverlapsWith,
        textSpansEqual: ()=>textSpansEqual,
        textToKeywordObj: ()=>textToKeywordObj,
        timestamp: ()=>timestamp,
        toArray: ()=>toArray,
        toBuilderFileEmit: ()=>toBuilderFileEmit,
        toBuilderStateFileInfoForMultiEmit: ()=>toBuilderStateFileInfoForMultiEmit,
        toEditorSettings: ()=>toEditorSettings,
        toFileNameLowerCase: ()=>toFileNameLowerCase,
        toPath: ()=>toPath,
        toProgramEmitPending: ()=>toProgramEmitPending,
        toSorted: ()=>toSorted,
        tokenIsIdentifierOrKeyword: ()=>tokenIsIdentifierOrKeyword,
        tokenIsIdentifierOrKeywordOrGreaterThan: ()=>tokenIsIdentifierOrKeywordOrGreaterThan,
        tokenToString: ()=>tokenToString,
        trace: ()=>trace,
        tracing: ()=>tracing,
        tracingEnabled: ()=>tracingEnabled,
        transferSourceFileChildren: ()=>transferSourceFileChildren,
        transform: ()=>transform,
        transformClassFields: ()=>transformClassFields,
        transformDeclarations: ()=>transformDeclarations,
        transformECMAScriptModule: ()=>transformECMAScriptModule,
        transformES2015: ()=>transformES2015,
        transformES2016: ()=>transformES2016,
        transformES2017: ()=>transformES2017,
        transformES2018: ()=>transformES2018,
        transformES2019: ()=>transformES2019,
        transformES2020: ()=>transformES2020,
        transformES2021: ()=>transformES2021,
        transformESDecorators: ()=>transformESDecorators,
        transformESNext: ()=>transformESNext,
        transformGenerators: ()=>transformGenerators,
        transformImpliedNodeFormatDependentModule: ()=>transformImpliedNodeFormatDependentModule,
        transformJsx: ()=>transformJsx,
        transformLegacyDecorators: ()=>transformLegacyDecorators,
        transformModule: ()=>transformModule,
        transformNamedEvaluation: ()=>transformNamedEvaluation,
        transformNodes: ()=>transformNodes,
        transformSystemModule: ()=>transformSystemModule,
        transformTypeScript: ()=>transformTypeScript,
        transpile: ()=>transpile,
        transpileDeclaration: ()=>transpileDeclaration,
        transpileModule: ()=>transpileModule,
        transpileOptionValueCompilerOptions: ()=>transpileOptionValueCompilerOptions,
        tryAddToSet: ()=>tryAddToSet,
        tryAndIgnoreErrors: ()=>tryAndIgnoreErrors,
        tryCast: ()=>tryCast,
        tryDirectoryExists: ()=>tryDirectoryExists,
        tryExtractTSExtension: ()=>tryExtractTSExtension,
        tryFileExists: ()=>tryFileExists,
        tryGetClassExtendingExpressionWithTypeArguments: ()=>tryGetClassExtendingExpressionWithTypeArguments,
        tryGetClassImplementingOrExtendingExpressionWithTypeArguments: ()=>tryGetClassImplementingOrExtendingExpressionWithTypeArguments,
        tryGetDirectories: ()=>tryGetDirectories,
        tryGetExtensionFromPath: ()=>tryGetExtensionFromPath2,
        tryGetImportFromModuleSpecifier: ()=>tryGetImportFromModuleSpecifier,
        tryGetJSDocSatisfiesTypeNode: ()=>tryGetJSDocSatisfiesTypeNode,
        tryGetModuleNameFromFile: ()=>tryGetModuleNameFromFile,
        tryGetModuleSpecifierFromDeclaration: ()=>tryGetModuleSpecifierFromDeclaration,
        tryGetNativePerformanceHooks: ()=>tryGetNativePerformanceHooks,
        tryGetPropertyAccessOrIdentifierToString: ()=>tryGetPropertyAccessOrIdentifierToString,
        tryGetPropertyNameOfBindingOrAssignmentElement: ()=>tryGetPropertyNameOfBindingOrAssignmentElement,
        tryGetSourceMappingURL: ()=>tryGetSourceMappingURL,
        tryGetTextOfPropertyName: ()=>tryGetTextOfPropertyName,
        tryParseJson: ()=>tryParseJson,
        tryParsePattern: ()=>tryParsePattern,
        tryParsePatterns: ()=>tryParsePatterns,
        tryParseRawSourceMap: ()=>tryParseRawSourceMap,
        tryReadDirectory: ()=>tryReadDirectory,
        tryReadFile: ()=>tryReadFile,
        tryRemoveDirectoryPrefix: ()=>tryRemoveDirectoryPrefix,
        tryRemoveExtension: ()=>tryRemoveExtension,
        tryRemovePrefix: ()=>tryRemovePrefix,
        tryRemoveSuffix: ()=>tryRemoveSuffix,
        tscBuildOption: ()=>tscBuildOption,
        typeAcquisitionDeclarations: ()=>typeAcquisitionDeclarations,
        typeAliasNamePart: ()=>typeAliasNamePart,
        typeDirectiveIsEqualTo: ()=>typeDirectiveIsEqualTo,
        typeKeywords: ()=>typeKeywords,
        typeParameterNamePart: ()=>typeParameterNamePart,
        typeToDisplayParts: ()=>typeToDisplayParts,
        unchangedPollThresholds: ()=>unchangedPollThresholds,
        unchangedTextChangeRange: ()=>unchangedTextChangeRange,
        unescapeLeadingUnderscores: ()=>unescapeLeadingUnderscores,
        unmangleScopedPackageName: ()=>unmangleScopedPackageName,
        unorderedRemoveItem: ()=>unorderedRemoveItem,
        unprefixedNodeCoreModules: ()=>unprefixedNodeCoreModules,
        unreachableCodeIsError: ()=>unreachableCodeIsError,
        unsetNodeChildren: ()=>unsetNodeChildren,
        unusedLabelIsError: ()=>unusedLabelIsError,
        unwrapInnermostStatementOfLabel: ()=>unwrapInnermostStatementOfLabel,
        unwrapParenthesizedExpression: ()=>unwrapParenthesizedExpression,
        updateErrorForNoInputFiles: ()=>updateErrorForNoInputFiles,
        updateLanguageServiceSourceFile: ()=>updateLanguageServiceSourceFile,
        updateMissingFilePathsWatch: ()=>updateMissingFilePathsWatch,
        updateResolutionField: ()=>updateResolutionField,
        updateSharedExtendedConfigFileWatcher: ()=>updateSharedExtendedConfigFileWatcher,
        updateSourceFile: ()=>updateSourceFile,
        updateWatchingWildcardDirectories: ()=>updateWatchingWildcardDirectories,
        usingSingleLineStringWriter: ()=>usingSingleLineStringWriter,
        utf16EncodeAsString: ()=>utf16EncodeAsString,
        validateLocaleAndSetLanguage: ()=>validateLocaleAndSetLanguage,
        version: ()=>version,
        versionMajorMinor: ()=>versionMajorMinor,
        visitArray: ()=>visitArray,
        visitCommaListElements: ()=>visitCommaListElements,
        visitEachChild: ()=>visitEachChild,
        visitFunctionBody: ()=>visitFunctionBody,
        visitIterationBody: ()=>visitIterationBody,
        visitLexicalEnvironment: ()=>visitLexicalEnvironment,
        visitNode: ()=>visitNode,
        visitNodes: ()=>visitNodes2,
        visitParameterList: ()=>visitParameterList,
        walkUpBindingElementsAndPatterns: ()=>walkUpBindingElementsAndPatterns,
        walkUpOuterExpressions: ()=>walkUpOuterExpressions,
        walkUpParenthesizedExpressions: ()=>walkUpParenthesizedExpressions,
        walkUpParenthesizedTypes: ()=>walkUpParenthesizedTypes,
        walkUpParenthesizedTypesAndGetParentAndChild: ()=>walkUpParenthesizedTypesAndGetParentAndChild,
        whitespaceOrMapCommentRegExp: ()=>whitespaceOrMapCommentRegExp,
        writeCommentRange: ()=>writeCommentRange,
        writeFile: ()=>writeFile,
        writeFileEnsuringDirectories: ()=>writeFileEnsuringDirectories,
        zipWith: ()=>zipWith
    });
    module1.exports = __toCommonJS(typescript_exports);
    // src/compiler/corePublic.ts
    var versionMajorMinor = "5.9";
    var version = "5.9.2";
    var Comparison = /* @__PURE__ */ ((Comparison3)=>{
        Comparison3[Comparison3["LessThan"] = -1] = "LessThan";
        Comparison3[Comparison3["EqualTo"] = 0] = "EqualTo";
        Comparison3[Comparison3["GreaterThan"] = 1] = "GreaterThan";
        return Comparison3;
    })(Comparison || {});
    // src/compiler/core.ts
    var emptyArray = [];
    var emptyMap = /* @__PURE__ */ new Map();
    function length(array) {
        return array !== void 0 ? array.length : 0;
    }
    function forEach(array, callback) {
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const result = callback(array[i], i);
            if (result) return result;
        }
        return void 0;
    }
    function forEachRight(array, callback) {
        if (array !== void 0) for(let i = array.length - 1; i >= 0; i--){
            const result = callback(array[i], i);
            if (result) return result;
        }
        return void 0;
    }
    function firstDefined(array, callback) {
        if (array === void 0) return void 0;
        for(let i = 0; i < array.length; i++){
            const result = callback(array[i], i);
            if (result !== void 0) return result;
        }
        return void 0;
    }
    function firstDefinedIterator(iter, callback) {
        for (const value1 of iter){
            const result = callback(value1);
            if (result !== void 0) return result;
        }
        return void 0;
    }
    function reduceLeftIterator(iterator, f, initial) {
        let result = initial;
        if (iterator) {
            let pos = 0;
            for (const value1 of iterator){
                result = f(result, value1, pos);
                pos++;
            }
        }
        return result;
    }
    function zipWith(arrayA, arrayB, callback) {
        const result = [];
        Debug.assertEqual(arrayA.length, arrayB.length);
        for(let i = 0; i < arrayA.length; i++)result.push(callback(arrayA[i], arrayB[i], i));
        return result;
    }
    function intersperse(input, element) {
        if (input.length <= 1) return input;
        const result = [];
        for(let i = 0, n = input.length; i < n; i++){
            if (i !== 0) result.push(element);
            result.push(input[i]);
        }
        return result;
    }
    function every(array, callback) {
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            if (!callback(array[i], i)) return false;
        }
        return true;
    }
    function find(array, predicate, startIndex) {
        if (array === void 0) return void 0;
        for(let i = startIndex !== null && startIndex !== void 0 ? startIndex : 0; i < array.length; i++){
            const value1 = array[i];
            if (predicate(value1, i)) return value1;
        }
        return void 0;
    }
    function findLast(array, predicate, startIndex) {
        if (array === void 0) return void 0;
        for(let i = startIndex !== null && startIndex !== void 0 ? startIndex : array.length - 1; i >= 0; i--){
            const value1 = array[i];
            if (predicate(value1, i)) return value1;
        }
        return void 0;
    }
    function findIndex(array, predicate, startIndex) {
        if (array === void 0) return -1;
        for(let i = startIndex !== null && startIndex !== void 0 ? startIndex : 0; i < array.length; i++){
            if (predicate(array[i], i)) return i;
        }
        return -1;
    }
    function findLastIndex(array, predicate, startIndex) {
        if (array === void 0) return -1;
        for(let i = startIndex !== null && startIndex !== void 0 ? startIndex : array.length - 1; i >= 0; i--){
            if (predicate(array[i], i)) return i;
        }
        return -1;
    }
    function contains(array, value1, equalityComparer = equateValues) {
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            if (equalityComparer(array[i], value1)) return true;
        }
        return false;
    }
    function indexOfAnyCharCode(text, charCodes, start) {
        for(let i = start !== null && start !== void 0 ? start : 0; i < text.length; i++){
            if (contains(charCodes, text.charCodeAt(i))) return i;
        }
        return -1;
    }
    function countWhere(array, predicate) {
        let count = 0;
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const v1 = array[i];
            if (predicate(v1, i)) count++;
        }
        return count;
    }
    function filter(array, f) {
        if (array !== void 0) {
            const len = array.length;
            let i = 0;
            while(i < len && f(array[i]))i++;
            if (i < len) {
                const result = array.slice(0, i);
                i++;
                while(i < len){
                    const item = array[i];
                    if (f(item)) result.push(item);
                    i++;
                }
                return result;
            }
        }
        return array;
    }
    function filterMutate(array, f) {
        let outIndex = 0;
        for(let i = 0; i < array.length; i++)if (f(array[i], i, array)) {
            array[outIndex] = array[i];
            outIndex++;
        }
        array.length = outIndex;
    }
    function clear(array) {
        array.length = 0;
    }
    function map(array, f) {
        let result;
        if (array !== void 0) {
            result = [];
            for(let i = 0; i < array.length; i++)result.push(f(array[i], i));
        }
        return result;
    }
    function* mapIterator(iter, mapFn) {
        for (const x of iter)yield mapFn(x);
    }
    function sameMap(array, f) {
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const item = array[i];
            const mapped = f(item, i);
            if (item !== mapped) {
                const result = array.slice(0, i);
                result.push(mapped);
                for(i++; i < array.length; i++)result.push(f(array[i], i));
                return result;
            }
        }
        return array;
    }
    function flatten(array) {
        const result = [];
        for(let i = 0; i < array.length; i++){
            const v1 = array[i];
            if (v1) {
                if (isArray(v1)) addRange(result, v1);
                else result.push(v1);
            }
        }
        return result;
    }
    function flatMap(array, mapfn) {
        let result;
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const v1 = mapfn(array[i], i);
            if (v1) {
                if (isArray(v1)) result = addRange(result, v1);
                else result = append(result, v1);
            }
        }
        return result !== null && result !== void 0 ? result : emptyArray;
    }
    function flatMapToMutable(array, mapfn) {
        const result = [];
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const v1 = mapfn(array[i], i);
            if (v1) {
                if (isArray(v1)) addRange(result, v1);
                else result.push(v1);
            }
        }
        return result;
    }
    function* flatMapIterator(iter, mapfn) {
        for (const x of iter){
            const iter2 = mapfn(x);
            if (!iter2) continue;
            yield* iter2;
        }
    }
    function sameFlatMap(array, mapfn) {
        let result;
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const item = array[i];
            const mapped = mapfn(item, i);
            if (result || item !== mapped || isArray(mapped)) {
                if (!result) result = array.slice(0, i);
                if (isArray(mapped)) addRange(result, mapped);
                else result.push(mapped);
            }
        }
        return result !== null && result !== void 0 ? result : array;
    }
    function mapAllOrFail(array, mapFn) {
        const result = [];
        for(let i = 0; i < array.length; i++){
            const mapped = mapFn(array[i], i);
            if (mapped === void 0) return void 0;
            result.push(mapped);
        }
        return result;
    }
    function mapDefined(array, mapFn) {
        const result = [];
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const mapped = mapFn(array[i], i);
            if (mapped !== void 0) result.push(mapped);
        }
        return result;
    }
    function* mapDefinedIterator(iter, mapFn) {
        for (const x of iter){
            const value1 = mapFn(x);
            if (value1 !== void 0) yield value1;
        }
    }
    function getOrUpdate(map2, key, callback) {
        if (map2.has(key)) return map2.get(key);
        const value1 = callback();
        map2.set(key, value1);
        return value1;
    }
    function tryAddToSet(set, value1) {
        if (!set.has(value1)) {
            set.add(value1);
            return true;
        }
        return false;
    }
    function* singleIterator(value1) {
        yield value1;
    }
    function spanMap(array, keyfn, mapfn) {
        let result;
        if (array !== void 0) {
            result = [];
            const len = array.length;
            let previousKey;
            let key;
            let start = 0;
            let pos = 0;
            while(start < len){
                while(pos < len){
                    const value1 = array[pos];
                    key = keyfn(value1, pos);
                    if (pos === 0) previousKey = key;
                    else if (key !== previousKey) break;
                    pos++;
                }
                if (start < pos) {
                    const v1 = mapfn(array.slice(start, pos), previousKey, start, pos);
                    if (v1) result.push(v1);
                    start = pos;
                }
                previousKey = key;
                pos++;
            }
        }
        return result;
    }
    function mapEntries(map2, f) {
        if (map2 === void 0) return void 0;
        const result = /* @__PURE__ */ new Map();
        map2.forEach((value1, key)=>{
            const [newKey, newValue] = f(key, value1);
            result.set(newKey, newValue);
        });
        return result;
    }
    function some(array, predicate) {
        if (array !== void 0) {
            if (predicate !== void 0) for(let i = 0; i < array.length; i++){
                if (predicate(array[i])) return true;
            }
            else return array.length > 0;
        }
        return false;
    }
    function getRangesWhere(arr, pred, cb) {
        let start;
        for(let i = 0; i < arr.length; i++){
            if (pred(arr[i])) start = start === void 0 ? i : start;
            else if (start !== void 0) {
                cb(start, i);
                start = void 0;
            }
        }
        if (start !== void 0) cb(start, arr.length);
    }
    function concatenate(array1, array2) {
        if (array2 === void 0 || array2.length === 0) return array1;
        if (array1 === void 0 || array1.length === 0) return array2;
        return [
            ...array1,
            ...array2
        ];
    }
    function selectIndex(_, i) {
        return i;
    }
    function indicesOf(array) {
        return array.map(selectIndex);
    }
    function deduplicateRelational(array, equalityComparer, comparer) {
        const indices = indicesOf(array);
        stableSortIndices(array, indices, comparer);
        let last2 = array[indices[0]];
        const deduplicated = [
            indices[0]
        ];
        for(let i = 1; i < indices.length; i++){
            const index = indices[i];
            const item = array[index];
            if (!equalityComparer(last2, item)) {
                deduplicated.push(index);
                last2 = item;
            }
        }
        deduplicated.sort();
        return deduplicated.map((i)=>array[i]);
    }
    function deduplicateEquality(array, equalityComparer) {
        const result = [];
        for(let i = 0; i < array.length; i++)pushIfUnique(result, array[i], equalityComparer);
        return result;
    }
    function deduplicate(array, equalityComparer, comparer) {
        return array.length === 0 ? [] : array.length === 1 ? array.slice() : comparer ? deduplicateRelational(array, equalityComparer, comparer) : deduplicateEquality(array, equalityComparer);
    }
    function deduplicateSorted(array, comparer) {
        if (array.length === 0) return emptyArray;
        let last2 = array[0];
        const deduplicated = [
            last2
        ];
        for(let i = 1; i < array.length; i++){
            const next = array[i];
            switch(comparer(next, last2)){
                // equality comparison
                case true:
                // relational comparison
                // falls through
                case 0 /* EqualTo */ :
                    continue;
                case -1 /* LessThan */ :
                    return Debug.fail("Array is unsorted.");
            }
            deduplicated.push(last2 = next);
        }
        return deduplicated;
    }
    function createSortedArray() {
        return [];
    }
    function insertSorted(array, insert, compare, equalityComparer, allowDuplicates) {
        if (array.length === 0) {
            array.push(insert);
            return true;
        }
        const insertIndex = binarySearch(array, insert, identity, compare);
        if (insertIndex < 0) {
            if (equalityComparer && !allowDuplicates) {
                const idx = ~insertIndex;
                if (idx > 0 && equalityComparer(insert, array[idx - 1])) return false;
                if (idx < array.length && equalityComparer(insert, array[idx])) {
                    array.splice(idx, 1, insert);
                    return true;
                }
            }
            array.splice(~insertIndex, 0, insert);
            return true;
        }
        if (allowDuplicates) {
            array.splice(insertIndex, 0, insert);
            return true;
        }
        return false;
    }
    function sortAndDeduplicate(array, comparer, equalityComparer) {
        var _ref;
        return deduplicateSorted(toSorted(array, comparer), (_ref = equalityComparer !== null && equalityComparer !== void 0 ? equalityComparer : comparer) !== null && _ref !== void 0 ? _ref : compareStringsCaseSensitive);
    }
    function arrayIsEqualTo(array1, array2, equalityComparer = equateValues) {
        if (array1 === void 0 || array2 === void 0) return array1 === array2;
        if (array1.length !== array2.length) return false;
        for(let i = 0; i < array1.length; i++){
            if (!equalityComparer(array1[i], array2[i], i)) return false;
        }
        return true;
    }
    function compact(array) {
        let result;
        if (array !== void 0) for(let i = 0; i < array.length; i++){
            const v1 = array[i];
            if (result !== null && result !== void 0 ? result : !v1) {
                result !== null && result !== void 0 ? result : result = array.slice(0, i);
                if (v1) result.push(v1);
            }
        }
        return result !== null && result !== void 0 ? result : array;
    }
    function relativeComplement(arrayA, arrayB, comparer) {
        if (!arrayB || !arrayA || arrayB.length === 0 || arrayA.length === 0) return arrayB;
        const result = [];
        loopB: for(let offsetA = 0, offsetB = 0; offsetB < arrayB.length; offsetB++){
            if (offsetB > 0) Debug.assertGreaterThanOrEqual(comparer(arrayB[offsetB], arrayB[offsetB - 1]), 0 /* EqualTo */ );
            loopA: for(const startA = offsetA; offsetA < arrayA.length; offsetA++){
                if (offsetA > startA) Debug.assertGreaterThanOrEqual(comparer(arrayA[offsetA], arrayA[offsetA - 1]), 0 /* EqualTo */ );
                switch(comparer(arrayB[offsetB], arrayA[offsetA])){
                    case -1 /* LessThan */ :
                        result.push(arrayB[offsetB]);
                        continue loopB;
                    case 0 /* EqualTo */ :
                        continue loopB;
                    case 1 /* GreaterThan */ :
                        continue loopA;
                }
            }
        }
        return result;
    }
    function append(to, value1) {
        if (value1 === void 0) return to;
        if (to === void 0) return [
            value1
        ];
        to.push(value1);
        return to;
    }
    function combine(xs, ys) {
        if (xs === void 0) return ys;
        if (ys === void 0) return xs;
        if (isArray(xs)) return isArray(ys) ? concatenate(xs, ys) : append(xs, ys);
        if (isArray(ys)) return append(ys, xs);
        return [
            xs,
            ys
        ];
    }
    function toOffset(array, offset) {
        return offset < 0 ? array.length + offset : offset;
    }
    function addRange(to, from, start, end) {
        if (from === void 0 || from.length === 0) return to;
        if (to === void 0) return from.slice(start, end);
        start = start === void 0 ? 0 : toOffset(from, start);
        end = end === void 0 ? from.length : toOffset(from, end);
        for(let i = start; i < end && i < from.length; i++)if (from[i] !== void 0) to.push(from[i]);
        return to;
    }
    function pushIfUnique(array, toAdd, equalityComparer) {
        if (contains(array, toAdd, equalityComparer)) return false;
        else {
            array.push(toAdd);
            return true;
        }
    }
    function appendIfUnique(array, toAdd, equalityComparer) {
        if (array !== void 0) {
            pushIfUnique(array, toAdd, equalityComparer);
            return array;
        } else return [
            toAdd
        ];
    }
    function stableSortIndices(array, indices, comparer) {
        indices.sort((x, y)=>comparer(array[x], array[y]) || compareValues(x, y));
    }
    function toSorted(array, comparer) {
        return array.length === 0 ? emptyArray : array.slice().sort(comparer);
    }
    function* arrayReverseIterator(array) {
        for(let i = array.length - 1; i >= 0; i--)yield array[i];
    }
    function rangeEquals(array1, array2, pos, end) {
        while(pos < end){
            if (array1[pos] !== array2[pos]) return false;
            pos++;
        }
        return true;
    }
    var elementAt = !!Array.prototype.at ? (array, offset)=>array == null ? void 0 : array.at(offset) : (array, offset)=>{
        if (array !== void 0) {
            offset = toOffset(array, offset);
            if (offset < array.length) return array[offset];
        }
        return void 0;
    };
    function firstOrUndefined(array) {
        return array === void 0 || array.length === 0 ? void 0 : array[0];
    }
    function firstOrUndefinedIterator(iter) {
        if (iter !== void 0) {
            for (const value1 of iter)return value1;
        }
        return void 0;
    }
    function first(array) {
        Debug.assert(array.length !== 0);
        return array[0];
    }
    function firstIterator(iter) {
        for (const value1 of iter)return value1;
        Debug.fail("iterator is empty");
    }
    function lastOrUndefined(array) {
        return array === void 0 || array.length === 0 ? void 0 : array[array.length - 1];
    }
    function last(array) {
        Debug.assert(array.length !== 0);
        return array[array.length - 1];
    }
    function singleOrUndefined(array) {
        return array !== void 0 && array.length === 1 ? array[0] : void 0;
    }
    function single(array) {
        return Debug.checkDefined(singleOrUndefined(array));
    }
    function singleOrMany(array) {
        return array !== void 0 && array.length === 1 ? array[0] : array;
    }
    function replaceElement(array, index, value1) {
        const result = array.slice(0);
        result[index] = value1;
        return result;
    }
    function binarySearch(array, value1, keySelector, keyComparer, offset) {
        return binarySearchKey(array, keySelector(value1), keySelector, keyComparer, offset);
    }
    function binarySearchKey(array, key, keySelector, keyComparer, offset) {
        if (!some(array)) return -1;
        let low = offset !== null && offset !== void 0 ? offset : 0;
        let high = array.length - 1;
        while(low <= high){
            const middle = low + (high - low >> 1);
            const midKey = keySelector(array[middle], middle);
            switch(keyComparer(midKey, key)){
                case -1 /* LessThan */ :
                    low = middle + 1;
                    break;
                case 0 /* EqualTo */ :
                    return middle;
                case 1 /* GreaterThan */ :
                    high = middle - 1;
                    break;
            }
        }
        return ~low;
    }
    function reduceLeft(array, f, initial, start, count) {
        if (array && array.length > 0) {
            const size = array.length;
            if (size > 0) {
                let pos = start === void 0 || start < 0 ? 0 : start;
                const end = count === void 0 || pos + count > size - 1 ? size - 1 : pos + count;
                let result;
                if (arguments.length <= 2) {
                    result = array[pos];
                    pos++;
                } else result = initial;
                while(pos <= end){
                    result = f(result, array[pos], pos);
                    pos++;
                }
                return result;
            }
        }
        return initial;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    function hasProperty(map2, key) {
        return hasOwnProperty.call(map2, key);
    }
    function getProperty(map2, key) {
        return hasOwnProperty.call(map2, key) ? map2[key] : void 0;
    }
    function getOwnKeys(map2) {
        const keys = [];
        for(const key in map2)if (hasOwnProperty.call(map2, key)) keys.push(key);
        return keys;
    }
    function getAllKeys(obj) {
        const result = [];
        do {
            const names = Object.getOwnPropertyNames(obj);
            for (const name of names)pushIfUnique(result, name);
        }while (obj = Object.getPrototypeOf(obj));
        return result;
    }
    function getOwnValues(collection) {
        const values = [];
        for(const key in collection)if (hasOwnProperty.call(collection, key)) values.push(collection[key]);
        return values;
    }
    function arrayOf(count, f) {
        const result = new Array(count);
        for(let i = 0; i < count; i++)result[i] = f(i);
        return result;
    }
    function arrayFrom(iterator, map2) {
        const result = [];
        for (const value1 of iterator)result.push(map2 ? map2(value1) : value1);
        return result;
    }
    function assign(t, ...args) {
        for (const arg of args){
            if (arg === void 0) continue;
            for(const p in arg)if (hasProperty(arg, p)) t[p] = arg[p];
        }
        return t;
    }
    function equalOwnProperties(left, right, equalityComparer = equateValues) {
        if (left === right) return true;
        if (!left || !right) return false;
        for(const key in left)if (hasOwnProperty.call(left, key)) {
            if (!hasOwnProperty.call(right, key)) return false;
            if (!equalityComparer(left[key], right[key])) return false;
        }
        for(const key in right)if (hasOwnProperty.call(right, key)) {
            if (!hasOwnProperty.call(left, key)) return false;
        }
        return true;
    }
    function arrayToMap(array, makeKey, makeValue = identity) {
        const result = /* @__PURE__ */ new Map();
        for(let i = 0; i < array.length; i++){
            const value1 = array[i];
            const key = makeKey(value1);
            if (key !== void 0) result.set(key, makeValue(value1));
        }
        return result;
    }
    function arrayToNumericMap(array, makeKey, makeValue = identity) {
        const result = [];
        for(let i = 0; i < array.length; i++){
            const value1 = array[i];
            result[makeKey(value1)] = makeValue(value1);
        }
        return result;
    }
    function arrayToMultiMap(values, makeKey, makeValue = identity) {
        const result = createMultiMap();
        for(let i = 0; i < values.length; i++){
            const value1 = values[i];
            result.add(makeKey(value1), makeValue(value1));
        }
        return result;
    }
    function group(values, getGroupId, resultSelector = identity) {
        return arrayFrom(arrayToMultiMap(values, getGroupId).values(), resultSelector);
    }
    function groupBy(values, keySelector) {
        const result = {};
        if (values !== void 0) for(let i = 0; i < values.length; i++){
            const value1 = values[i];
            const key = `${keySelector(value1)}`;
            var _result_key;
            const array = (_result_key = result[key]) !== null && _result_key !== void 0 ? _result_key : result[key] = [];
            array.push(value1);
        }
        return result;
    }
    function clone(object) {
        const result = {};
        for(const id in object)if (hasOwnProperty.call(object, id)) result[id] = object[id];
        return result;
    }
    function extend(first2, second) {
        const result = {};
        for(const id in second)if (hasOwnProperty.call(second, id)) result[id] = second[id];
        for(const id in first2)if (hasOwnProperty.call(first2, id)) result[id] = first2[id];
        return result;
    }
    function copyProperties(first2, second) {
        for(const id in second)if (hasOwnProperty.call(second, id)) first2[id] = second[id];
    }
    function maybeBind(obj, fn) {
        return fn == null ? void 0 : fn.bind(obj);
    }
    function createMultiMap() {
        const map2 = /* @__PURE__ */ new Map();
        map2.add = multiMapAdd;
        map2.remove = multiMapRemove;
        return map2;
    }
    function multiMapAdd(key, value1) {
        let values = this.get(key);
        if (values !== void 0) values.push(value1);
        else this.set(key, values = [
            value1
        ]);
        return values;
    }
    function multiMapRemove(key, value1) {
        const values = this.get(key);
        if (values !== void 0) {
            unorderedRemoveItem(values, value1);
            if (!values.length) this.delete(key);
        }
    }
    function createQueue(items) {
        var _ref;
        const elements = (_ref = items == null ? void 0 : items.slice()) !== null && _ref !== void 0 ? _ref : [];
        let headIndex = 0;
        function isEmpty() {
            return headIndex === elements.length;
        }
        function enqueue(...items2) {
            elements.push(...items2);
        }
        function dequeue() {
            if (isEmpty()) throw new Error("Queue is empty");
            const result = elements[headIndex];
            elements[headIndex] = void 0;
            headIndex++;
            if (headIndex > 100 && headIndex > elements.length >> 1) {
                const newLength = elements.length - headIndex;
                elements.copyWithin(/*target*/ 0, /*start*/ headIndex);
                elements.length = newLength;
                headIndex = 0;
            }
            return result;
        }
        return {
            enqueue,
            dequeue,
            isEmpty
        };
    }
    function createSet(getHashCode, equals) {
        const multiMap = /* @__PURE__ */ new Map();
        let size = 0;
        function* getElementIterator() {
            for (const value1 of multiMap.values())if (isArray(value1)) yield* value1;
            else yield value1;
        }
        const set = {
            has (element) {
                const hash = getHashCode(element);
                if (!multiMap.has(hash)) return false;
                const candidates = multiMap.get(hash);
                if (isArray(candidates)) return contains(candidates, element, equals);
                return equals(candidates, element);
            },
            add (element) {
                const hash = getHashCode(element);
                if (multiMap.has(hash)) {
                    const values = multiMap.get(hash);
                    if (isArray(values)) {
                        if (!contains(values, element, equals)) {
                            values.push(element);
                            size++;
                        }
                    } else {
                        const value1 = values;
                        if (!equals(value1, element)) {
                            multiMap.set(hash, [
                                value1,
                                element
                            ]);
                            size++;
                        }
                    }
                } else {
                    multiMap.set(hash, element);
                    size++;
                }
                return this;
            },
            delete (element) {
                const hash = getHashCode(element);
                if (!multiMap.has(hash)) return false;
                const candidates = multiMap.get(hash);
                if (isArray(candidates)) {
                    for(let i = 0; i < candidates.length; i++)if (equals(candidates[i], element)) {
                        if (candidates.length === 1) multiMap.delete(hash);
                        else if (candidates.length === 2) multiMap.set(hash, candidates[1 - i]);
                        else unorderedRemoveItemAt(candidates, i);
                        size--;
                        return true;
                    }
                } else {
                    const candidate = candidates;
                    if (equals(candidate, element)) {
                        multiMap.delete(hash);
                        size--;
                        return true;
                    }
                }
                return false;
            },
            clear () {
                multiMap.clear();
                size = 0;
            },
            get size () {
                return size;
            },
            forEach (action) {
                for (const elements of arrayFrom(multiMap.values())){
                    if (isArray(elements)) for (const element of elements)action(element, element, set);
                    else {
                        const element = elements;
                        action(element, element, set);
                    }
                }
            },
            keys () {
                return getElementIterator();
            },
            values () {
                return getElementIterator();
            },
            *entries () {
                for (const value1 of getElementIterator())yield [
                    value1,
                    value1
                ];
            },
            [Symbol.iterator]: ()=>{
                return getElementIterator();
            },
            [Symbol.toStringTag]: multiMap[Symbol.toStringTag]
        };
        return set;
    }
    function isArray(value1) {
        return Array.isArray(value1);
    }
    function toArray(value1) {
        return isArray(value1) ? value1 : [
            value1
        ];
    }
    function isString(text) {
        return typeof text === "string";
    }
    function isNumber(x) {
        return typeof x === "number";
    }
    function tryCast(value1, test) {
        return value1 !== void 0 && test(value1) ? value1 : void 0;
    }
    function cast(value1, test) {
        if (value1 !== void 0 && test(value1)) return value1;
        return Debug.fail(`Invalid cast. The supplied value ${value1} did not pass the test '${Debug.getFunctionName(test)}'.`);
    }
    function noop(_) {}
    function returnFalse() {
        return false;
    }
    function returnTrue() {
        return true;
    }
    function returnUndefined() {
        return void 0;
    }
    function identity(x) {
        return x;
    }
    function toLowerCase(x) {
        return x.toLowerCase();
    }
    var fileNameLowerCaseRegExp = /[^\u0130\u0131\u00DFa-z0-9\\/:\-_. ]+/g;
    function toFileNameLowerCase(x) {
        return fileNameLowerCaseRegExp.test(x) ? x.replace(fileNameLowerCaseRegExp, toLowerCase) : x;
    }
    function notImplemented() {
        throw new Error("Not implemented");
    }
    function memoize(callback) {
        let value1;
        return ()=>{
            if (callback) {
                value1 = callback();
                callback = void 0;
            }
            return value1;
        };
    }
    function memoizeOne(callback) {
        const map2 = /* @__PURE__ */ new Map();
        return (arg)=>{
            const key = `${typeof arg}:${arg}`;
            let value1 = map2.get(key);
            if (value1 === void 0 && !map2.has(key)) {
                value1 = callback(arg);
                map2.set(key, value1);
            }
            return value1;
        };
    }
    var AssertionLevel = /* @__PURE__ */ ((AssertionLevel2)=>{
        AssertionLevel2[AssertionLevel2["None"] = 0] = "None";
        AssertionLevel2[AssertionLevel2["Normal"] = 1] = "Normal";
        AssertionLevel2[AssertionLevel2["Aggressive"] = 2] = "Aggressive";
        AssertionLevel2[AssertionLevel2["VeryAggressive"] = 3] = "VeryAggressive";
        return AssertionLevel2;
    })(AssertionLevel || {});
    function equateValues(a, b) {
        return a === b;
    }
    function equateStringsCaseInsensitive(a, b) {
        return a === b || a !== void 0 && b !== void 0 && a.toUpperCase() === b.toUpperCase();
    }
    function equateStringsCaseSensitive(a, b) {
        return equateValues(a, b);
    }
    function compareComparableValues(a, b) {
        return a === b ? 0 /* EqualTo */  : a === void 0 ? -1 /* LessThan */  : b === void 0 ? 1 /* GreaterThan */  : a < b ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
    }
    function compareValues(a, b) {
        return compareComparableValues(a, b);
    }
    function compareTextSpans(a, b) {
        return compareValues(a == null ? void 0 : a.start, b == null ? void 0 : b.start) || compareValues(a == null ? void 0 : a.length, b == null ? void 0 : b.length);
    }
    function maxBy(arr, init, mapper) {
        for(let i = 0; i < arr.length; i++)init = Math.max(init, mapper(arr[i]));
        return init;
    }
    function min(items, compare) {
        return reduceLeft(items, (x, y)=>compare(x, y) === -1 /* LessThan */  ? x : y);
    }
    function compareStringsCaseInsensitive(a, b) {
        if (a === b) return 0 /* EqualTo */ ;
        if (a === void 0) return -1 /* LessThan */ ;
        if (b === void 0) return 1 /* GreaterThan */ ;
        a = a.toUpperCase();
        b = b.toUpperCase();
        return a < b ? -1 /* LessThan */  : a > b ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
    }
    function compareStringsCaseInsensitiveEslintCompatible(a, b) {
        if (a === b) return 0 /* EqualTo */ ;
        if (a === void 0) return -1 /* LessThan */ ;
        if (b === void 0) return 1 /* GreaterThan */ ;
        a = a.toLowerCase();
        b = b.toLowerCase();
        return a < b ? -1 /* LessThan */  : a > b ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
    }
    function compareStringsCaseSensitive(a, b) {
        return compareComparableValues(a, b);
    }
    function getStringComparer(ignoreCase) {
        return ignoreCase ? compareStringsCaseInsensitive : compareStringsCaseSensitive;
    }
    var createUIStringComparer = /* @__PURE__ */ (()=>{
        return createIntlCollatorStringComparer;
        function compareWithCallback(a, b, comparer) {
            if (a === b) return 0 /* EqualTo */ ;
            if (a === void 0) return -1 /* LessThan */ ;
            if (b === void 0) return 1 /* GreaterThan */ ;
            const value1 = comparer(a, b);
            return value1 < 0 ? -1 /* LessThan */  : value1 > 0 ? 1 /* GreaterThan */  : 0 /* EqualTo */ ;
        }
        function createIntlCollatorStringComparer(locale) {
            const comparer = new Intl.Collator(locale, {
                usage: "sort",
                sensitivity: "variant",
                numeric: true
            }).compare;
            return (a, b)=>compareWithCallback(a, b, comparer);
        }
    })();
    var uiComparerCaseSensitive;
    var uiLocale;
    function getUILocale() {
        return uiLocale;
    }
    function setUILocale(value1) {
        if (uiLocale !== value1) {
            uiLocale = value1;
            uiComparerCaseSensitive = void 0;
        }
    }
    function compareStringsCaseSensitiveUI(a, b) {
        uiComparerCaseSensitive !== null && uiComparerCaseSensitive !== void 0 ? uiComparerCaseSensitive : uiComparerCaseSensitive = createUIStringComparer(uiLocale);
        return uiComparerCaseSensitive(a, b);
    }
    function compareProperties(a, b, key, comparer) {
        return a === b ? 0 /* EqualTo */  : a === void 0 ? -1 /* LessThan */  : b === void 0 ? 1 /* GreaterThan */  : comparer(a[key], b[key]);
    }
    function compareBooleans(a, b) {
        return compareValues(a ? 1 : 0, b ? 1 : 0);
    }
    function getSpellingSuggestion(name, candidates, getName) {
        const maximumLengthDifference = Math.max(2, Math.floor(name.length * 0.34));
        let bestDistance = Math.floor(name.length * 0.4) + 1;
        let bestCandidate;
        for (const candidate of candidates){
            const candidateName = getName(candidate);
            if (candidateName !== void 0 && Math.abs(candidateName.length - name.length) <= maximumLengthDifference) {
                if (candidateName === name) continue;
                if (candidateName.length < 3 && candidateName.toLowerCase() !== name.toLowerCase()) continue;
                const distance = levenshteinWithMax(name, candidateName, bestDistance - 0.1);
                if (distance === void 0) continue;
                Debug.assert(distance < bestDistance);
                bestDistance = distance;
                bestCandidate = candidate;
            }
        }
        return bestCandidate;
    }
    function levenshteinWithMax(s1, s2, max) {
        let previous = new Array(s2.length + 1);
        let current = new Array(s2.length + 1);
        const big = max + 0.01;
        for(let i = 0; i <= s2.length; i++)previous[i] = i;
        for(let i = 1; i <= s1.length; i++){
            const c1 = s1.charCodeAt(i - 1);
            const minJ = Math.ceil(i > max ? i - max : 1);
            const maxJ = Math.floor(s2.length > max + i ? max + i : s2.length);
            current[0] = i;
            let colMin = i;
            for(let j = 1; j < minJ; j++)current[j] = big;
            for(let j = minJ; j <= maxJ; j++){
                const substitutionDistance = s1[i - 1].toLowerCase() === s2[j - 1].toLowerCase() ? previous[j - 1] + 0.1 : previous[j - 1] + 2;
                const dist = c1 === s2.charCodeAt(j - 1) ? previous[j - 1] : Math.min(/*delete*/ previous[j] + 1, /*insert*/ current[j - 1] + 1, /*substitute*/ substitutionDistance);
                current[j] = dist;
                colMin = Math.min(colMin, dist);
            }
            for(let j = maxJ + 1; j <= s2.length; j++)current[j] = big;
            if (colMin > max) return void 0;
            const temp = previous;
            previous = current;
            current = temp;
        }
        const res = previous[s2.length];
        return res > max ? void 0 : res;
    }
    function endsWith(str, suffix, ignoreCase) {
        const expectedPos = str.length - suffix.length;
        return expectedPos >= 0 && (ignoreCase ? equateStringsCaseInsensitive(str.slice(expectedPos), suffix) : str.indexOf(suffix, expectedPos) === expectedPos);
    }
    function removeSuffix(str, suffix) {
        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : str;
    }
    function tryRemoveSuffix(str, suffix) {
        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : void 0;
    }
    function removeMinAndVersionNumbers(fileName) {
        let end = fileName.length;
        for(let pos = end - 1; pos > 0; pos--){
            let ch = fileName.charCodeAt(pos);
            if (ch >= 48 /* _0 */  && ch <= 57 /* _9 */ ) do {
                --pos;
                ch = fileName.charCodeAt(pos);
            }while (pos > 0 && ch >= 48 /* _0 */  && ch <= 57 /* _9 */ );
            else if (pos > 4 && (ch === 110 /* n */  || ch === 78 /* N */ )) {
                --pos;
                ch = fileName.charCodeAt(pos);
                if (ch !== 105 /* i */  && ch !== 73 /* I */ ) break;
                --pos;
                ch = fileName.charCodeAt(pos);
                if (ch !== 109 /* m */  && ch !== 77 /* M */ ) break;
                --pos;
                ch = fileName.charCodeAt(pos);
            } else break;
            if (ch !== 45 /* minus */  && ch !== 46 /* dot */ ) break;
            end = pos;
        }
        return end === fileName.length ? fileName : fileName.slice(0, end);
    }
    function orderedRemoveItem(array, item) {
        for(let i = 0; i < array.length; i++)if (array[i] === item) {
            orderedRemoveItemAt(array, i);
            return true;
        }
        return false;
    }
    function orderedRemoveItemAt(array, index) {
        for(let i = index; i < array.length - 1; i++)array[i] = array[i + 1];
        array.pop();
    }
    function unorderedRemoveItemAt(array, index) {
        array[index] = array[array.length - 1];
        array.pop();
    }
    function unorderedRemoveItem(array, item) {
        return unorderedRemoveFirstItemWhere(array, (element)=>element === item);
    }
    function unorderedRemoveFirstItemWhere(array, predicate) {
        for(let i = 0; i < array.length; i++)if (predicate(array[i])) {
            unorderedRemoveItemAt(array, i);
            return true;
        }
        return false;
    }
    function createGetCanonicalFileName(useCaseSensitiveFileNames2) {
        return useCaseSensitiveFileNames2 ? identity : toFileNameLowerCase;
    }
    function patternText({ prefix, suffix }) {
        return `${prefix}*${suffix}`;
    }
    function matchedText(pattern, candidate) {
        Debug.assert(isPatternMatch(pattern, candidate));
        return candidate.substring(pattern.prefix.length, candidate.length - pattern.suffix.length);
    }
    function findBestPatternMatch(values, getPattern, candidate) {
        let matchedValue;
        let longestMatchPrefixLength = -1;
        for(let i = 0; i < values.length; i++){
            const v1 = values[i];
            const pattern = getPattern(v1);
            if (pattern.prefix.length > longestMatchPrefixLength && isPatternMatch(pattern, candidate)) {
                longestMatchPrefixLength = pattern.prefix.length;
                matchedValue = v1;
            }
        }
        return matchedValue;
    }
    function startsWith(str, prefix, ignoreCase) {
        return ignoreCase ? equateStringsCaseInsensitive(str.slice(0, prefix.length), prefix) : str.lastIndexOf(prefix, 0) === 0;
    }
    function removePrefix(str, prefix) {
        return startsWith(str, prefix) ? str.substr(prefix.length) : str;
    }
    function tryRemovePrefix(str, prefix, getCanonicalFileName = identity) {
        return startsWith(getCanonicalFileName(str), getCanonicalFileName(prefix)) ? str.substring(prefix.length) : void 0;
    }
    function isPatternMatch({ prefix, suffix }, candidate) {
        return candidate.length >= prefix.length + suffix.length && startsWith(candidate, prefix) && endsWith(candidate, suffix);
    }
    function and(f, g) {
        return (arg)=>f(arg) && g(arg);
    }
    function or(...fs) {
        return (...args)=>{
            let lastResult;
            for (const f of fs){
                lastResult = f(...args);
                if (lastResult) return lastResult;
            }
            return lastResult;
        };
    }
    function not(fn) {
        return (...args)=>!fn(...args);
    }
    function assertType(_) {}
    function singleElementArray(t) {
        return t === void 0 ? void 0 : [
            t
        ];
    }
    function enumerateInsertsAndDeletes(newItems, oldItems, comparer, inserted, deleted, unchanged) {
        unchanged !== null && unchanged !== void 0 ? unchanged : unchanged = noop;
        let newIndex = 0;
        let oldIndex = 0;
        const newLen = newItems.length;
        const oldLen = oldItems.length;
        let hasChanges = false;
        while(newIndex < newLen && oldIndex < oldLen){
            const newItem = newItems[newIndex];
            const oldItem = oldItems[oldIndex];
            const compareResult = comparer(newItem, oldItem);
            if (compareResult === -1 /* LessThan */ ) {
                inserted(newItem);
                newIndex++;
                hasChanges = true;
            } else if (compareResult === 1 /* GreaterThan */ ) {
                deleted(oldItem);
                oldIndex++;
                hasChanges = true;
            } else {
                unchanged(oldItem, newItem);
                newIndex++;
                oldIndex++;
            }
        }
        while(newIndex < newLen){
            inserted(newItems[newIndex++]);
            hasChanges = true;
        }
        while(oldIndex < oldLen){
            deleted(oldItems[oldIndex++]);
            hasChanges = true;
        }
        return hasChanges;
    }
    function cartesianProduct(arrays) {
        const result = [];
        cartesianProductWorker(arrays, result, /*outer*/ void 0, 0);
        return result;
    }
    function cartesianProductWorker(arrays, result, outer, index) {
        for (const element of arrays[index]){
            let inner;
            if (outer) {
                inner = outer.slice();
                inner.push(element);
            } else inner = [
                element
            ];
            if (index === arrays.length - 1) result.push(inner);
            else cartesianProductWorker(arrays, result, inner, index + 1);
        }
    }
    function takeWhile(array, predicate) {
        if (array !== void 0) {
            const len = array.length;
            let index = 0;
            while(index < len && predicate(array[index]))index++;
            return array.slice(0, index);
        }
    }
    function skipWhile(array, predicate) {
        if (array !== void 0) {
            const len = array.length;
            let index = 0;
            while(index < len && predicate(array[index]))index++;
            return array.slice(index);
        }
    }
    function isNodeLikeSystem() {
        return false;
    }
    // src/compiler/debug.ts
    var LogLevel = /* @__PURE__ */ ((LogLevel3)=>{
        LogLevel3[LogLevel3["Off"] = 0] = "Off";
        LogLevel3[LogLevel3["Error"] = 1] = "Error";
        LogLevel3[LogLevel3["Warning"] = 2] = "Warning";
        LogLevel3[LogLevel3["Info"] = 3] = "Info";
        LogLevel3[LogLevel3["Verbose"] = 4] = "Verbose";
        return LogLevel3;
    })(LogLevel || {});
    var Debug;
    ((Debug2)=>{
        let currentAssertionLevel = 0 /* None */ ;
        Debug2.currentLogLevel = 2 /* Warning */ ;
        Debug2.isDebugging = false;
        function shouldLog(level) {
            return Debug2.currentLogLevel <= level;
        }
        Debug2.shouldLog = shouldLog;
        function logMessage(level, s) {
            if (Debug2.loggingHost && shouldLog(level)) Debug2.loggingHost.log(level, s);
        }
        function log(s) {
            logMessage(3 /* Info */ , s);
        }
        Debug2.log = log;
        ((_log)=>{
            function error2(s) {
                logMessage(1 /* Error */ , s);
            }
            _log.error = error2;
            function warn(s) {
                logMessage(2 /* Warning */ , s);
            }
            _log.warn = warn;
            function log2(s) {
                logMessage(3 /* Info */ , s);
            }
            _log.log = log2;
            function trace2(s) {
                logMessage(4 /* Verbose */ , s);
            }
            _log.trace = trace2;
        })(log = Debug2.log || (Debug2.log = {}));
        const assertionCache = {};
        function getAssertionLevel() {
            return currentAssertionLevel;
        }
        Debug2.getAssertionLevel = getAssertionLevel;
        function setAssertionLevel(level) {
            const prevAssertionLevel = currentAssertionLevel;
            currentAssertionLevel = level;
            if (level > prevAssertionLevel) for (const key of getOwnKeys(assertionCache)){
                const cachedFunc = assertionCache[key];
                if (cachedFunc !== void 0 && Debug2[key] !== cachedFunc.assertion && level >= cachedFunc.level) {
                    Debug2[key] = cachedFunc;
                    assertionCache[key] = void 0;
                }
            }
        }
        Debug2.setAssertionLevel = setAssertionLevel;
        function shouldAssert(level) {
            return currentAssertionLevel >= level;
        }
        Debug2.shouldAssert = shouldAssert;
        function shouldAssertFunction(level, name) {
            if (!shouldAssert(level)) {
                assertionCache[name] = {
                    level,
                    assertion: Debug2[name]
                };
                Debug2[name] = noop;
                return false;
            }
            return true;
        }
        function fail(message, stackCrawlMark) {
            debugger;
            const e = new Error(message ? `Debug Failure. ${message}` : "Debug Failure.");
            if (Error.captureStackTrace) Error.captureStackTrace(e, stackCrawlMark || fail);
            throw e;
        }
        Debug2.fail = fail;
        function failBadSyntaxKind(node, message, stackCrawlMark) {
            return fail(`${message || "Unexpected node."}\r
Node ${formatSyntaxKind(node.kind)} was unexpected.`, stackCrawlMark || failBadSyntaxKind);
        }
        Debug2.failBadSyntaxKind = failBadSyntaxKind;
        function assert(expression, message, verboseDebugInfo, stackCrawlMark) {
            if (!expression) {
                message = message ? `False expression: ${message}` : "False expression.";
                if (verboseDebugInfo) message += "\r\nVerbose Debug Information: " + (typeof verboseDebugInfo === "string" ? verboseDebugInfo : verboseDebugInfo());
                fail(message, stackCrawlMark || assert);
            }
        }
        Debug2.assert = assert;
        function assertEqual(a, b, msg, msg2, stackCrawlMark) {
            if (a !== b) {
                const message = msg ? msg2 ? `${msg} ${msg2}` : msg : "";
                fail(`Expected ${a} === ${b}. ${message}`, stackCrawlMark || assertEqual);
            }
        }
        Debug2.assertEqual = assertEqual;
        function assertLessThan(a, b, msg, stackCrawlMark) {
            if (a >= b) fail(`Expected ${a} < ${b}. ${msg || ""}`, stackCrawlMark || assertLessThan);
        }
        Debug2.assertLessThan = assertLessThan;
        function assertLessThanOrEqual(a, b, stackCrawlMark) {
            if (a > b) fail(`Expected ${a} <= ${b}`, stackCrawlMark || assertLessThanOrEqual);
        }
        Debug2.assertLessThanOrEqual = assertLessThanOrEqual;
        function assertGreaterThanOrEqual(a, b, stackCrawlMark) {
            if (a < b) fail(`Expected ${a} >= ${b}`, stackCrawlMark || assertGreaterThanOrEqual);
        }
        Debug2.assertGreaterThanOrEqual = assertGreaterThanOrEqual;
        function assertIsDefined(value1, message, stackCrawlMark) {
            if (value1 === void 0 || value1 === null) fail(message, stackCrawlMark || assertIsDefined);
        }
        Debug2.assertIsDefined = assertIsDefined;
        function checkDefined(value1, message, stackCrawlMark) {
            assertIsDefined(value1, message, stackCrawlMark || checkDefined);
            return value1;
        }
        Debug2.checkDefined = checkDefined;
        function assertEachIsDefined(value1, message, stackCrawlMark) {
            for (const v1 of value1)assertIsDefined(v1, message, stackCrawlMark || assertEachIsDefined);
        }
        Debug2.assertEachIsDefined = assertEachIsDefined;
        function checkEachDefined(value1, message, stackCrawlMark) {
            assertEachIsDefined(value1, message, stackCrawlMark || checkEachDefined);
            return value1;
        }
        Debug2.checkEachDefined = checkEachDefined;
        function assertNever(member, message = "Illegal value:", stackCrawlMark) {
            const detail = typeof member === "object" && hasProperty(member, "kind") && hasProperty(member, "pos") ? "SyntaxKind: " + formatSyntaxKind(member.kind) : JSON.stringify(member);
            return fail(`${message} ${detail}`, stackCrawlMark || assertNever);
        }
        Debug2.assertNever = assertNever;
        function assertEachNode(nodes, test, message, stackCrawlMark) {
            if (shouldAssertFunction(1 /* Normal */ , "assertEachNode")) assert(test === void 0 || every(nodes, test), message || "Unexpected node.", ()=>`Node array did not pass test '${getFunctionName(test)}'.`, stackCrawlMark || assertEachNode);
        }
        Debug2.assertEachNode = assertEachNode;
        function assertNode(node, test, message, stackCrawlMark) {
            if (shouldAssertFunction(1 /* Normal */ , "assertNode")) assert(node !== void 0 && (test === void 0 || test(node)), message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node == null ? void 0 : node.kind)} did not pass test '${getFunctionName(test)}'.`, stackCrawlMark || assertNode);
        }
        Debug2.assertNode = assertNode;
        function assertNotNode(node, test, message, stackCrawlMark) {
            if (shouldAssertFunction(1 /* Normal */ , "assertNotNode")) assert(node === void 0 || test === void 0 || !test(node), message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node.kind)} should not have passed test '${getFunctionName(test)}'.`, stackCrawlMark || assertNotNode);
        }
        Debug2.assertNotNode = assertNotNode;
        function assertOptionalNode(node, test, message, stackCrawlMark) {
            if (shouldAssertFunction(1 /* Normal */ , "assertOptionalNode")) assert(test === void 0 || node === void 0 || test(node), message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node == null ? void 0 : node.kind)} did not pass test '${getFunctionName(test)}'.`, stackCrawlMark || assertOptionalNode);
        }
        Debug2.assertOptionalNode = assertOptionalNode;
        function assertOptionalToken(node, kind, message, stackCrawlMark) {
            if (shouldAssertFunction(1 /* Normal */ , "assertOptionalToken")) assert(kind === void 0 || node === void 0 || node.kind === kind, message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node == null ? void 0 : node.kind)} was not a '${formatSyntaxKind(kind)}' token.`, stackCrawlMark || assertOptionalToken);
        }
        Debug2.assertOptionalToken = assertOptionalToken;
        function assertMissingNode(node, message, stackCrawlMark) {
            if (shouldAssertFunction(1 /* Normal */ , "assertMissingNode")) assert(node === void 0, message || "Unexpected node.", ()=>`Node ${formatSyntaxKind(node.kind)} was unexpected'.`, stackCrawlMark || assertMissingNode);
        }
        Debug2.assertMissingNode = assertMissingNode;
        function type(_value) {}
        Debug2.type = type;
        function getFunctionName(func) {
            if (typeof func !== "function") return "";
            else if (hasProperty(func, "name")) return func.name;
            else {
                const text = Function.prototype.toString.call(func);
                const match = /^function\s+([\w$]+)\s*\(/.exec(text);
                return match ? match[1] : "";
            }
        }
        Debug2.getFunctionName = getFunctionName;
        function formatSymbol(symbol) {
            return `{ name: ${unescapeLeadingUnderscores(symbol.escapedName)}; flags: ${formatSymbolFlags(symbol.flags)}; declarations: ${map(symbol.declarations, (node)=>formatSyntaxKind(node.kind))} }`;
        }
        Debug2.formatSymbol = formatSymbol;
        function formatEnum(value1 = 0, enumObject, isFlags) {
            const members = getEnumMembers(enumObject);
            if (value1 === 0) return members.length > 0 && members[0][0] === 0 ? members[0][1] : "0";
            if (isFlags) {
                const result = [];
                let remainingFlags = value1;
                for (const [enumValue, enumName] of members){
                    if (enumValue > value1) break;
                    if (enumValue !== 0 && enumValue & value1) {
                        result.push(enumName);
                        remainingFlags &= ~enumValue;
                    }
                }
                if (remainingFlags === 0) return result.join("|");
            } else for (const [enumValue, enumName] of members){
                if (enumValue === value1) return enumName;
            }
            return value1.toString();
        }
        Debug2.formatEnum = formatEnum;
        const enumMemberCache = /* @__PURE__ */ new Map();
        function getEnumMembers(enumObject) {
            const existing = enumMemberCache.get(enumObject);
            if (existing) return existing;
            const result = [];
            for(const name in enumObject){
                const value1 = enumObject[name];
                if (typeof value1 === "number") result.push([
                    value1,
                    name
                ]);
            }
            const sorted = toSorted(result, (x, y)=>compareValues(x[0], y[0]));
            enumMemberCache.set(enumObject, sorted);
            return sorted;
        }
        function formatSyntaxKind(kind) {
            return formatEnum(kind, SyntaxKind, /*isFlags*/ false);
        }
        Debug2.formatSyntaxKind = formatSyntaxKind;
        function formatSnippetKind(kind) {
            return formatEnum(kind, SnippetKind, /*isFlags*/ false);
        }
        Debug2.formatSnippetKind = formatSnippetKind;
        function formatScriptKind(kind) {
            return formatEnum(kind, ScriptKind, /*isFlags*/ false);
        }
        Debug2.formatScriptKind = formatScriptKind;
        function formatNodeFlags(flags) {
            return formatEnum(flags, NodeFlags, /*isFlags*/ true);
        }
        Debug2.formatNodeFlags = formatNodeFlags;
        function formatNodeCheckFlags(flags) {
            return formatEnum(flags, NodeCheckFlags, /*isFlags*/ true);
        }
        Debug2.formatNodeCheckFlags = formatNodeCheckFlags;
        function formatModifierFlags(flags) {
            return formatEnum(flags, ModifierFlags, /*isFlags*/ true);
        }
        Debug2.formatModifierFlags = formatModifierFlags;
        function formatTransformFlags(flags) {
            return formatEnum(flags, TransformFlags, /*isFlags*/ true);
        }
        Debug2.formatTransformFlags = formatTransformFlags;
        function formatEmitFlags(flags) {
            return formatEnum(flags, EmitFlags, /*isFlags*/ true);
        }
        Debug2.formatEmitFlags = formatEmitFlags;
        function formatSymbolFlags(flags) {
            return formatEnum(flags, SymbolFlags, /*isFlags*/ true);
        }
        Debug2.formatSymbolFlags = formatSymbolFlags;
        function formatTypeFlags(flags) {
            return formatEnum(flags, TypeFlags, /*isFlags*/ true);
        }
        Debug2.formatTypeFlags = formatTypeFlags;
        function formatSignatureFlags(flags) {
            return formatEnum(flags, SignatureFlags, /*isFlags*/ true);
        }
        Debug2.formatSignatureFlags = formatSignatureFlags;
        function formatObjectFlags(flags) {
            return formatEnum(flags, ObjectFlags, /*isFlags*/ true);
        }
        Debug2.formatObjectFlags = formatObjectFlags;
        function formatFlowFlags(flags) {
            return formatEnum(flags, FlowFlags, /*isFlags*/ true);
        }
        Debug2.formatFlowFlags = formatFlowFlags;
        function formatRelationComparisonResult(result) {
            return formatEnum(result, RelationComparisonResult, /*isFlags*/ true);
        }
        Debug2.formatRelationComparisonResult = formatRelationComparisonResult;
        function formatCheckMode(mode) {
            return formatEnum(mode, CheckMode, /*isFlags*/ true);
        }
        Debug2.formatCheckMode = formatCheckMode;
        function formatSignatureCheckMode(mode) {
            return formatEnum(mode, SignatureCheckMode, /*isFlags*/ true);
        }
        Debug2.formatSignatureCheckMode = formatSignatureCheckMode;
        function formatTypeFacts(facts) {
            return formatEnum(facts, TypeFacts, /*isFlags*/ true);
        }
        Debug2.formatTypeFacts = formatTypeFacts;
        let isDebugInfoEnabled = false;
        let flowNodeProto;
        function attachFlowNodeDebugInfoWorker(flowNode) {
            if (!("__debugFlowFlags" in flowNode)) Object.defineProperties(flowNode, {
                // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                __tsDebuggerDisplay: {
                    value () {
                        const flowHeader = this.flags & 2 /* Start */  ? "FlowStart" : this.flags & 4 /* BranchLabel */  ? "FlowBranchLabel" : this.flags & 8 /* LoopLabel */  ? "FlowLoopLabel" : this.flags & 16 /* Assignment */  ? "FlowAssignment" : this.flags & 32 /* TrueCondition */  ? "FlowTrueCondition" : this.flags & 64 /* FalseCondition */  ? "FlowFalseCondition" : this.flags & 128 /* SwitchClause */  ? "FlowSwitchClause" : this.flags & 256 /* ArrayMutation */  ? "FlowArrayMutation" : this.flags & 512 /* Call */  ? "FlowCall" : this.flags & 1024 /* ReduceLabel */  ? "FlowReduceLabel" : this.flags & 1 /* Unreachable */  ? "FlowUnreachable" : "UnknownFlow";
                        const remainingFlags = this.flags & -2048;
                        return `${flowHeader}${remainingFlags ? ` (${formatFlowFlags(remainingFlags)})` : ""}`;
                    }
                },
                __debugFlowFlags: {
                    get () {
                        return formatEnum(this.flags, FlowFlags, /*isFlags*/ true);
                    }
                },
                __debugToString: {
                    value () {
                        return formatControlFlowGraph(this);
                    }
                }
            });
        }
        function attachFlowNodeDebugInfo(flowNode) {
            if (isDebugInfoEnabled) {
                if (typeof Object.setPrototypeOf === "function") {
                    if (!flowNodeProto) {
                        flowNodeProto = Object.create(Object.prototype);
                        attachFlowNodeDebugInfoWorker(flowNodeProto);
                    }
                    Object.setPrototypeOf(flowNode, flowNodeProto);
                } else attachFlowNodeDebugInfoWorker(flowNode);
            }
            return flowNode;
        }
        Debug2.attachFlowNodeDebugInfo = attachFlowNodeDebugInfo;
        let nodeArrayProto;
        function attachNodeArrayDebugInfoWorker(array) {
            if (!("__tsDebuggerDisplay" in array)) Object.defineProperties(array, {
                __tsDebuggerDisplay: {
                    value (defaultValue) {
                        defaultValue = String(defaultValue).replace(/(?:,[\s\w]+:[^,]+)+\]$/, "]");
                        return `NodeArray ${defaultValue}`;
                    }
                }
            });
        }
        function attachNodeArrayDebugInfo(array) {
            if (isDebugInfoEnabled) {
                if (typeof Object.setPrototypeOf === "function") {
                    if (!nodeArrayProto) {
                        nodeArrayProto = Object.create(Array.prototype);
                        attachNodeArrayDebugInfoWorker(nodeArrayProto);
                    }
                    Object.setPrototypeOf(array, nodeArrayProto);
                } else attachNodeArrayDebugInfoWorker(array);
            }
        }
        Debug2.attachNodeArrayDebugInfo = attachNodeArrayDebugInfo;
        function enableDebugInfo() {
            if (isDebugInfoEnabled) return;
            const weakTypeTextMap = /* @__PURE__ */ new WeakMap();
            const weakNodeTextMap = /* @__PURE__ */ new WeakMap();
            Object.defineProperties(objectAllocator.getSymbolConstructor().prototype, {
                // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                __tsDebuggerDisplay: {
                    value () {
                        const symbolHeader = this.flags & 33554432 /* Transient */  ? "TransientSymbol" : "Symbol";
                        const remainingSymbolFlags = this.flags & -33554433 /* Transient */ ;
                        return `${symbolHeader} '${symbolName(this)}'${remainingSymbolFlags ? ` (${formatSymbolFlags(remainingSymbolFlags)})` : ""}`;
                    }
                },
                __debugFlags: {
                    get () {
                        return formatSymbolFlags(this.flags);
                    }
                }
            });
            Object.defineProperties(objectAllocator.getTypeConstructor().prototype, {
                // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                __tsDebuggerDisplay: {
                    value () {
                        const typeHeader = this.flags & 67359327 /* Intrinsic */  ? `IntrinsicType ${this.intrinsicName}${this.debugIntrinsicName ? ` (${this.debugIntrinsicName})` : ""}` : this.flags & 98304 /* Nullable */  ? "NullableType" : this.flags & 384 /* StringOrNumberLiteral */  ? `LiteralType ${JSON.stringify(this.value)}` : this.flags & 2048 /* BigIntLiteral */  ? `LiteralType ${this.value.negative ? "-" : ""}${this.value.base10Value}n` : this.flags & 8192 /* UniqueESSymbol */  ? "UniqueESSymbolType" : this.flags & 32 /* Enum */  ? "EnumType" : this.flags & 1048576 /* Union */  ? "UnionType" : this.flags & 2097152 /* Intersection */  ? "IntersectionType" : this.flags & 4194304 /* Index */  ? "IndexType" : this.flags & 8388608 /* IndexedAccess */  ? "IndexedAccessType" : this.flags & 16777216 /* Conditional */  ? "ConditionalType" : this.flags & 33554432 /* Substitution */  ? "SubstitutionType" : this.flags & 262144 /* TypeParameter */  ? "TypeParameter" : this.flags & 524288 /* Object */  ? this.objectFlags & 3 /* ClassOrInterface */  ? "InterfaceType" : this.objectFlags & 4 /* Reference */  ? "TypeReference" : this.objectFlags & 8 /* Tuple */  ? "TupleType" : this.objectFlags & 16 /* Anonymous */  ? "AnonymousType" : this.objectFlags & 32 /* Mapped */  ? "MappedType" : this.objectFlags & 1024 /* ReverseMapped */  ? "ReverseMappedType" : this.objectFlags & 256 /* EvolvingArray */  ? "EvolvingArrayType" : "ObjectType" : "Type";
                        const remainingObjectFlags = this.flags & 524288 /* Object */  ? this.objectFlags & -1344 /* ObjectTypeKindMask */  : 0;
                        return `${typeHeader}${this.symbol ? ` '${symbolName(this.symbol)}'` : ""}${remainingObjectFlags ? ` (${formatObjectFlags(remainingObjectFlags)})` : ""}`;
                    }
                },
                __debugFlags: {
                    get () {
                        return formatTypeFlags(this.flags);
                    }
                },
                __debugObjectFlags: {
                    get () {
                        return this.flags & 524288 /* Object */  ? formatObjectFlags(this.objectFlags) : "";
                    }
                },
                __debugTypeToString: {
                    value () {
                        let text = weakTypeTextMap.get(this);
                        if (text === void 0) {
                            text = this.checker.typeToString(this);
                            weakTypeTextMap.set(this, text);
                        }
                        return text;
                    }
                }
            });
            Object.defineProperties(objectAllocator.getSignatureConstructor().prototype, {
                __debugFlags: {
                    get () {
                        return formatSignatureFlags(this.flags);
                    }
                },
                __debugSignatureToString: {
                    value () {
                        var _a;
                        return (_a = this.checker) == null ? void 0 : _a.signatureToString(this);
                    }
                }
            });
            const nodeConstructors = [
                objectAllocator.getNodeConstructor(),
                objectAllocator.getIdentifierConstructor(),
                objectAllocator.getTokenConstructor(),
                objectAllocator.getSourceFileConstructor()
            ];
            for (const ctor of nodeConstructors)if (!hasProperty(ctor.prototype, "__debugKind")) Object.defineProperties(ctor.prototype, {
                // for use with vscode-js-debug's new customDescriptionGenerator in launch.json
                __tsDebuggerDisplay: {
                    value () {
                        const nodeHeader = isGeneratedIdentifier(this) ? "GeneratedIdentifier" : isIdentifier(this) ? `Identifier '${idText(this)}'` : isPrivateIdentifier(this) ? `PrivateIdentifier '${idText(this)}'` : isStringLiteral(this) ? `StringLiteral ${JSON.stringify(this.text.length < 10 ? this.text : this.text.slice(10) + "...")}` : isNumericLiteral(this) ? `NumericLiteral ${this.text}` : isBigIntLiteral(this) ? `BigIntLiteral ${this.text}n` : isTypeParameterDeclaration(this) ? "TypeParameterDeclaration" : isParameter(this) ? "ParameterDeclaration" : isConstructorDeclaration(this) ? "ConstructorDeclaration" : isGetAccessorDeclaration(this) ? "GetAccessorDeclaration" : isSetAccessorDeclaration(this) ? "SetAccessorDeclaration" : isCallSignatureDeclaration(this) ? "CallSignatureDeclaration" : isConstructSignatureDeclaration(this) ? "ConstructSignatureDeclaration" : isIndexSignatureDeclaration(this) ? "IndexSignatureDeclaration" : isTypePredicateNode(this) ? "TypePredicateNode" : isTypeReferenceNode(this) ? "TypeReferenceNode" : isFunctionTypeNode(this) ? "FunctionTypeNode" : isConstructorTypeNode(this) ? "ConstructorTypeNode" : isTypeQueryNode(this) ? "TypeQueryNode" : isTypeLiteralNode(this) ? "TypeLiteralNode" : isArrayTypeNode(this) ? "ArrayTypeNode" : isTupleTypeNode(this) ? "TupleTypeNode" : isOptionalTypeNode(this) ? "OptionalTypeNode" : isRestTypeNode(this) ? "RestTypeNode" : isUnionTypeNode(this) ? "UnionTypeNode" : isIntersectionTypeNode(this) ? "IntersectionTypeNode" : isConditionalTypeNode(this) ? "ConditionalTypeNode" : isInferTypeNode(this) ? "InferTypeNode" : isParenthesizedTypeNode(this) ? "ParenthesizedTypeNode" : isThisTypeNode(this) ? "ThisTypeNode" : isTypeOperatorNode(this) ? "TypeOperatorNode" : isIndexedAccessTypeNode(this) ? "IndexedAccessTypeNode" : isMappedTypeNode(this) ? "MappedTypeNode" : isLiteralTypeNode(this) ? "LiteralTypeNode" : isNamedTupleMember(this) ? "NamedTupleMember" : isImportTypeNode(this) ? "ImportTypeNode" : formatSyntaxKind(this.kind);
                        return `${nodeHeader}${this.flags ? ` (${formatNodeFlags(this.flags)})` : ""}`;
                    }
                },
                __debugKind: {
                    get () {
                        return formatSyntaxKind(this.kind);
                    }
                },
                __debugNodeFlags: {
                    get () {
                        return formatNodeFlags(this.flags);
                    }
                },
                __debugModifierFlags: {
                    get () {
                        return formatModifierFlags(getEffectiveModifierFlagsNoCache(this));
                    }
                },
                __debugTransformFlags: {
                    get () {
                        return formatTransformFlags(this.transformFlags);
                    }
                },
                __debugIsParseTreeNode: {
                    get () {
                        return isParseTreeNode(this);
                    }
                },
                __debugEmitFlags: {
                    get () {
                        return formatEmitFlags(getEmitFlags(this));
                    }
                },
                __debugGetText: {
                    value (includeTrivia) {
                        if (nodeIsSynthesized(this)) return "";
                        let text = weakNodeTextMap.get(this);
                        if (text === void 0) {
                            const parseNode = getParseTreeNode(this);
                            const sourceFile = parseNode && getSourceFileOfNode(parseNode);
                            text = sourceFile ? getSourceTextOfNodeFromSourceFile(sourceFile, parseNode, includeTrivia) : "";
                            weakNodeTextMap.set(this, text);
                        }
                        return text;
                    }
                }
            });
            isDebugInfoEnabled = true;
        }
        Debug2.enableDebugInfo = enableDebugInfo;
        function formatVariance(varianceFlags) {
            const variance = varianceFlags & 7 /* VarianceMask */ ;
            let result = variance === 0 /* Invariant */  ? "in out" : variance === 3 /* Bivariant */  ? "[bivariant]" : variance === 2 /* Contravariant */  ? "in" : variance === 1 /* Covariant */  ? "out" : variance === 4 /* Independent */  ? "[independent]" : "";
            if (varianceFlags & 8 /* Unmeasurable */ ) result += " (unmeasurable)";
            else if (varianceFlags & 16 /* Unreliable */ ) result += " (unreliable)";
            return result;
        }
        Debug2.formatVariance = formatVariance;
        class DebugTypeMapper {
            __debugToString() {
                var _a;
                type(this);
                switch(this.kind){
                    case 3 /* Function */ :
                        return ((_a = this.debugInfo) == null ? void 0 : _a.call(this)) || "(function mapper)";
                    case 0 /* Simple */ :
                        return `${this.source.__debugTypeToString()} -> ${this.target.__debugTypeToString()}`;
                    case 1 /* Array */ :
                        return zipWith(this.sources, this.targets || map(this.sources, ()=>"any"), (s, t)=>`${s.__debugTypeToString()} -> ${typeof t === "string" ? t : t.__debugTypeToString()}`).join(", ");
                    case 2 /* Deferred */ :
                        return zipWith(this.sources, this.targets, (s, t)=>`${s.__debugTypeToString()} -> ${t().__debugTypeToString()}`).join(", ");
                    case 5 /* Merged */ :
                    case 4 /* Composite */ :
                        return `m1: ${this.mapper1.__debugToString().split("\n").join("\n    ")}
m2: ${this.mapper2.__debugToString().split("\n").join("\n    ")}`;
                    default:
                        return assertNever(this);
                }
            }
        }
        Debug2.DebugTypeMapper = DebugTypeMapper;
        function attachDebugPrototypeIfDebug(mapper) {
            if (Debug2.isDebugging) return Object.setPrototypeOf(mapper, DebugTypeMapper.prototype);
            return mapper;
        }
        Debug2.attachDebugPrototypeIfDebug = attachDebugPrototypeIfDebug;
        function printControlFlowGraph(flowNode) {
            return console.log(formatControlFlowGraph(flowNode));
        }
        Debug2.printControlFlowGraph = printControlFlowGraph;
        function formatControlFlowGraph(flowNode) {
            let nextDebugFlowId = -1;
            function getDebugFlowNodeId(f) {
                if (!f.id) {
                    f.id = nextDebugFlowId;
                    nextDebugFlowId--;
                }
                return f.id;
            }
            let BoxCharacter;
            ((BoxCharacter2)=>{
                BoxCharacter2["lr"] = "\u2500";
                BoxCharacter2["ud"] = "\u2502";
                BoxCharacter2["dr"] = "\u256D";
                BoxCharacter2["dl"] = "\u256E";
                BoxCharacter2["ul"] = "\u256F";
                BoxCharacter2["ur"] = "\u2570";
                BoxCharacter2["udr"] = "\u251C";
                BoxCharacter2["udl"] = "\u2524";
                BoxCharacter2["dlr"] = "\u252C";
                BoxCharacter2["ulr"] = "\u2534";
                BoxCharacter2["udlr"] = "\u256B";
            })(BoxCharacter || (BoxCharacter = {}));
            let Connection;
            ((Connection2)=>{
                Connection2[Connection2["None"] = 0] = "None";
                Connection2[Connection2["Up"] = 1] = "Up";
                Connection2[Connection2["Down"] = 2] = "Down";
                Connection2[Connection2["Left"] = 4] = "Left";
                Connection2[Connection2["Right"] = 8] = "Right";
                Connection2[Connection2["UpDown"] = 3] = "UpDown";
                Connection2[Connection2["LeftRight"] = 12] = "LeftRight";
                Connection2[Connection2["UpLeft"] = 5] = "UpLeft";
                Connection2[Connection2["UpRight"] = 9] = "UpRight";
                Connection2[Connection2["DownLeft"] = 6] = "DownLeft";
                Connection2[Connection2["DownRight"] = 10] = "DownRight";
                Connection2[Connection2["UpDownLeft"] = 7] = "UpDownLeft";
                Connection2[Connection2["UpDownRight"] = 11] = "UpDownRight";
                Connection2[Connection2["UpLeftRight"] = 13] = "UpLeftRight";
                Connection2[Connection2["DownLeftRight"] = 14] = "DownLeftRight";
                Connection2[Connection2["UpDownLeftRight"] = 15] = "UpDownLeftRight";
                Connection2[Connection2["NoChildren"] = 16] = "NoChildren";
            })(Connection || (Connection = {}));
            const hasAntecedentFlags = 2032 /* ReduceLabel */ ;
            const hasNodeFlags = 882 /* ArrayMutation */ ;
            const links = /* @__PURE__ */ Object.create(/*o*/ null);
            const nodes = [];
            const edges = [];
            const root = buildGraphNode(flowNode, /* @__PURE__ */ new Set());
            for (const node of nodes){
                node.text = renderFlowNode(node.flowNode, node.circular);
                computeLevel(node);
            }
            const height = computeHeight(root);
            const columnWidths = computeColumnWidths(height);
            computeLanes(root, 0);
            return renderGraph();
            function isFlowSwitchClause(f) {
                return !!(f.flags & 128 /* SwitchClause */ );
            }
            function hasAntecedents(f) {
                return !!(f.flags & 12 /* Label */ ) && !!f.antecedent;
            }
            function hasAntecedent(f) {
                return !!(f.flags & hasAntecedentFlags);
            }
            function hasNode(f) {
                return !!(f.flags & hasNodeFlags);
            }
            function getChildren(node) {
                const children = [];
                for (const edge of node.edges)if (edge.source === node) children.push(edge.target);
                return children;
            }
            function getParents(node) {
                const parents = [];
                for (const edge of node.edges)if (edge.target === node) parents.push(edge.source);
                return parents;
            }
            function buildGraphNode(flowNode2, seen) {
                const id = getDebugFlowNodeId(flowNode2);
                let graphNode = links[id];
                if (graphNode && seen.has(flowNode2)) {
                    graphNode.circular = true;
                    graphNode = {
                        id: -1,
                        flowNode: flowNode2,
                        edges: [],
                        text: "",
                        lane: -1,
                        endLane: -1,
                        level: -1,
                        circular: "circularity"
                    };
                    nodes.push(graphNode);
                    return graphNode;
                }
                seen.add(flowNode2);
                if (!graphNode) {
                    links[id] = graphNode = {
                        id,
                        flowNode: flowNode2,
                        edges: [],
                        text: "",
                        lane: -1,
                        endLane: -1,
                        level: -1,
                        circular: false
                    };
                    nodes.push(graphNode);
                    if (hasAntecedents(flowNode2)) for (const antecedent of flowNode2.antecedent)buildGraphEdge(graphNode, antecedent, seen);
                    else if (hasAntecedent(flowNode2)) buildGraphEdge(graphNode, flowNode2.antecedent, seen);
                }
                seen.delete(flowNode2);
                return graphNode;
            }
            function buildGraphEdge(source, antecedent, seen) {
                const target = buildGraphNode(antecedent, seen);
                const edge = {
                    source,
                    target
                };
                edges.push(edge);
                source.edges.push(edge);
                target.edges.push(edge);
            }
            function computeLevel(node) {
                if (node.level !== -1) return node.level;
                let level = 0;
                for (const parent2 of getParents(node))level = Math.max(level, computeLevel(parent2) + 1);
                return node.level = level;
            }
            function computeHeight(node) {
                let height2 = 0;
                for (const child of getChildren(node))height2 = Math.max(height2, computeHeight(child));
                return height2 + 1;
            }
            function computeColumnWidths(height2) {
                const columns = fill(Array(height2), 0);
                for (const node of nodes)columns[node.level] = Math.max(columns[node.level], node.text.length);
                return columns;
            }
            function computeLanes(node, lane) {
                if (node.lane === -1) {
                    node.lane = lane;
                    node.endLane = lane;
                    const children = getChildren(node);
                    for(let i = 0; i < children.length; i++){
                        if (i > 0) lane++;
                        const child = children[i];
                        computeLanes(child, lane);
                        if (child.endLane > node.endLane) lane = child.endLane;
                    }
                    node.endLane = lane;
                }
            }
            function getHeader2(flags) {
                if (flags & 2 /* Start */ ) return "Start";
                if (flags & 4 /* BranchLabel */ ) return "Branch";
                if (flags & 8 /* LoopLabel */ ) return "Loop";
                if (flags & 16 /* Assignment */ ) return "Assignment";
                if (flags & 32 /* TrueCondition */ ) return "True";
                if (flags & 64 /* FalseCondition */ ) return "False";
                if (flags & 128 /* SwitchClause */ ) return "SwitchClause";
                if (flags & 256 /* ArrayMutation */ ) return "ArrayMutation";
                if (flags & 512 /* Call */ ) return "Call";
                if (flags & 1024 /* ReduceLabel */ ) return "ReduceLabel";
                if (flags & 1 /* Unreachable */ ) return "Unreachable";
                throw new Error();
            }
            function getNodeText(node) {
                const sourceFile = getSourceFileOfNode(node);
                return getSourceTextOfNodeFromSourceFile(sourceFile, node, /*includeTrivia*/ false);
            }
            function renderFlowNode(flowNode2, circular) {
                let text = getHeader2(flowNode2.flags);
                if (circular) text = `${text}#${getDebugFlowNodeId(flowNode2)}`;
                if (isFlowSwitchClause(flowNode2)) {
                    const clauses = [];
                    const { switchStatement, clauseStart, clauseEnd } = flowNode2.node;
                    for(let i = clauseStart; i < clauseEnd; i++){
                        const clause = switchStatement.caseBlock.clauses[i];
                        if (isDefaultClause(clause)) clauses.push("default");
                        else clauses.push(getNodeText(clause.expression));
                    }
                    text += ` (${clauses.join(", ")})`;
                } else if (hasNode(flowNode2)) {
                    if (flowNode2.node) text += ` (${getNodeText(flowNode2.node)})`;
                }
                return circular === "circularity" ? `Circular(${text})` : text;
            }
            function renderGraph() {
                const columnCount = columnWidths.length;
                const laneCount = maxBy(nodes, 0, (n)=>n.lane) + 1;
                const lanes = fill(Array(laneCount), "");
                const grid = columnWidths.map(()=>Array(laneCount));
                const connectors = columnWidths.map(()=>fill(Array(laneCount), 0));
                for (const node of nodes){
                    grid[node.level][node.lane] = node;
                    const children = getChildren(node);
                    for(let i = 0; i < children.length; i++){
                        const child = children[i];
                        let connector = 8 /* Right */ ;
                        if (child.lane === node.lane) connector |= 4 /* Left */ ;
                        if (i > 0) connector |= 1 /* Up */ ;
                        if (i < children.length - 1) connector |= 2 /* Down */ ;
                        connectors[node.level][child.lane] |= connector;
                    }
                    if (children.length === 0) connectors[node.level][node.lane] |= 16 /* NoChildren */ ;
                    const parents = getParents(node);
                    for(let i = 0; i < parents.length; i++){
                        const parent2 = parents[i];
                        let connector = 4 /* Left */ ;
                        if (i > 0) connector |= 1 /* Up */ ;
                        if (i < parents.length - 1) connector |= 2 /* Down */ ;
                        connectors[node.level - 1][parent2.lane] |= connector;
                    }
                }
                for(let column = 0; column < columnCount; column++)for(let lane = 0; lane < laneCount; lane++){
                    const left = column > 0 ? connectors[column - 1][lane] : 0;
                    const above = lane > 0 ? connectors[column][lane - 1] : 0;
                    let connector = connectors[column][lane];
                    if (!connector) {
                        if (left & 8 /* Right */ ) connector |= 12 /* LeftRight */ ;
                        if (above & 2 /* Down */ ) connector |= 3 /* UpDown */ ;
                        connectors[column][lane] = connector;
                    }
                }
                for(let column = 0; column < columnCount; column++)for(let lane = 0; lane < lanes.length; lane++){
                    const connector = connectors[column][lane];
                    const fill2 = connector & 4 /* Left */  ? "\u2500" /* lr */  : " ";
                    const node = grid[column][lane];
                    if (!node) {
                        if (column < columnCount - 1) writeLane(lane, repeat(fill2, columnWidths[column] + 1));
                    } else {
                        writeLane(lane, node.text);
                        if (column < columnCount - 1) {
                            writeLane(lane, " ");
                            writeLane(lane, repeat(fill2, columnWidths[column] - node.text.length));
                        }
                    }
                    writeLane(lane, getBoxCharacter(connector));
                    writeLane(lane, connector & 8 /* Right */  && column < columnCount - 1 && !grid[column + 1][lane] ? "\u2500" /* lr */  : " ");
                }
                return `
${lanes.join("\n")}
`;
                function writeLane(lane, text) {
                    lanes[lane] += text;
                }
            }
            function getBoxCharacter(connector) {
                switch(connector){
                    case 3 /* UpDown */ :
                        return "\u2502" /* ud */ ;
                    case 12 /* LeftRight */ :
                        return "\u2500" /* lr */ ;
                    case 5 /* UpLeft */ :
                        return "\u256F" /* ul */ ;
                    case 9 /* UpRight */ :
                        return "\u2570" /* ur */ ;
                    case 6 /* DownLeft */ :
                        return "\u256E" /* dl */ ;
                    case 10 /* DownRight */ :
                        return "\u256D" /* dr */ ;
                    case 7 /* UpDownLeft */ :
                        return "\u2524" /* udl */ ;
                    case 11 /* UpDownRight */ :
                        return "\u251C" /* udr */ ;
                    case 13 /* UpLeftRight */ :
                        return "\u2534" /* ulr */ ;
                    case 14 /* DownLeftRight */ :
                        return "\u252C" /* dlr */ ;
                    case 15 /* UpDownLeftRight */ :
                        return "\u256B" /* udlr */ ;
                }
                return " ";
            }
            function fill(array, value1) {
                if (array.fill) array.fill(value1);
                else for(let i = 0; i < array.length; i++)array[i] = value1;
                return array;
            }
            function repeat(ch, length2) {
                if (ch.repeat) return length2 > 0 ? ch.repeat(length2) : "";
                let s = "";
                while(s.length < length2)s += ch;
                return s;
            }
        }
        Debug2.formatControlFlowGraph = formatControlFlowGraph;
    })(Debug || (Debug = {}));
    // src/compiler/semver.ts
    var versionRegExp = /^(0|[1-9]\d*)(?:\.(0|[1-9]\d*)(?:\.(0|[1-9]\d*)(?:-([a-z0-9-.]+))?(?:\+([a-z0-9-.]+))?)?)?$/i;
    var prereleaseRegExp = /^(?:0|[1-9]\d*|[a-z-][a-z0-9-]*)(?:\.(?:0|[1-9]\d*|[a-z-][a-z0-9-]*))*$/i;
    var prereleasePartRegExp = /^(?:0|[1-9]\d*|[a-z-][a-z0-9-]*)$/i;
    var buildRegExp = /^[a-z0-9-]+(?:\.[a-z0-9-]+)*$/i;
    var buildPartRegExp = /^[a-z0-9-]+$/i;
    var numericIdentifierRegExp = /^(?:0|[1-9]\d*)$/;
    var _Version = class _Version {
        static tryParse(text) {
            const result = tryParseComponents(text);
            if (!result) return void 0;
            const { major, minor, patch, prerelease, build: build2 } = result;
            return new _Version(major, minor, patch, prerelease, build2);
        }
        compareTo(other) {
            if (this === other) return 0 /* EqualTo */ ;
            if (other === void 0) return 1 /* GreaterThan */ ;
            return compareValues(this.major, other.major) || compareValues(this.minor, other.minor) || compareValues(this.patch, other.patch) || comparePrereleaseIdentifiers(this.prerelease, other.prerelease);
        }
        increment(field) {
            switch(field){
                case "major":
                    return new _Version(this.major + 1, 0, 0);
                case "minor":
                    return new _Version(this.major, this.minor + 1, 0);
                case "patch":
                    return new _Version(this.major, this.minor, this.patch + 1);
                default:
                    return Debug.assertNever(field);
            }
        }
        with(fields) {
            const { major = this.major, minor = this.minor, patch = this.patch, prerelease = this.prerelease, build: build2 = this.build } = fields;
            return new _Version(major, minor, patch, prerelease, build2);
        }
        toString() {
            let result = `${this.major}.${this.minor}.${this.patch}`;
            if (some(this.prerelease)) result += `-${this.prerelease.join(".")}`;
            if (some(this.build)) result += `+${this.build.join(".")}`;
            return result;
        }
        constructor(major, minor = 0, patch = 0, prerelease = "", build2 = ""){
            if (typeof major === "string") {
                const result = Debug.checkDefined(tryParseComponents(major), "Invalid version");
                ({ major, minor, patch, prerelease, build: build2 } = result);
            }
            Debug.assert(major >= 0, "Invalid argument: major");
            Debug.assert(minor >= 0, "Invalid argument: minor");
            Debug.assert(patch >= 0, "Invalid argument: patch");
            const prereleaseArray = prerelease ? isArray(prerelease) ? prerelease : prerelease.split(".") : emptyArray;
            const buildArray = build2 ? isArray(build2) ? build2 : build2.split(".") : emptyArray;
            Debug.assert(every(prereleaseArray, (s)=>prereleasePartRegExp.test(s)), "Invalid argument: prerelease");
            Debug.assert(every(buildArray, (s)=>buildPartRegExp.test(s)), "Invalid argument: build");
            this.major = major;
            this.minor = minor;
            this.patch = patch;
            this.prerelease = prereleaseArray;
            this.build = buildArray;
        }
    };
    _Version.zero = new _Version(0, 0, 0, [
        "0"
    ]);
    var Version = _Version;
    function tryParseComponents(text) {
        const match = versionRegExp.exec(text);
        if (!match) return void 0;
        const [, major, minor = "0", patch = "0", prerelease = "", build2 = ""] = match;
        if (prerelease && !prereleaseRegExp.test(prerelease)) return void 0;
        if (build2 && !buildRegExp.test(build2)) return void 0;
        return {
            major: parseInt(major, 10),
            minor: parseInt(minor, 10),
            patch: parseInt(patch, 10),
            prerelease,
            build: build2
        };
    }
    function comparePrereleaseIdentifiers(left, right) {
        if (left === right) return 0 /* EqualTo */ ;
        if (left.length === 0) return right.length === 0 ? 0 /* EqualTo */  : 1 /* GreaterThan */ ;
        if (right.length === 0) return -1 /* LessThan */ ;
        const length2 = Math.min(left.length, right.length);
        for(let i = 0; i < length2; i++){
            const leftIdentifier = left[i];
            const rightIdentifier = right[i];
            if (leftIdentifier === rightIdentifier) continue;
            const leftIsNumeric = numericIdentifierRegExp.test(leftIdentifier);
            const rightIsNumeric = numericIdentifierRegExp.test(rightIdentifier);
            if (leftIsNumeric || rightIsNumeric) {
                if (leftIsNumeric !== rightIsNumeric) return leftIsNumeric ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
                const result = compareValues(+leftIdentifier, +rightIdentifier);
                if (result) return result;
            } else {
                const result = compareStringsCaseSensitive(leftIdentifier, rightIdentifier);
                if (result) return result;
            }
        }
        return compareValues(left.length, right.length);
    }
    var VersionRange = class _VersionRange {
        static tryParse(text) {
            const sets = parseRange(text);
            if (sets) {
                const range = new _VersionRange("");
                range._alternatives = sets;
                return range;
            }
            return void 0;
        }
        /**
   * Tests whether a version matches the range. This is equivalent to `satisfies(version, range, { includePrerelease: true })`.
   * in `node-semver`.
   */ test(version2) {
            if (typeof version2 === "string") version2 = new Version(version2);
            return testDisjunction(version2, this._alternatives);
        }
        toString() {
            return formatDisjunction(this._alternatives);
        }
        constructor(spec){
            this._alternatives = spec ? Debug.checkDefined(parseRange(spec), "Invalid range spec.") : emptyArray;
        }
    };
    var logicalOrRegExp = /\|\|/;
    var whitespaceRegExp = /\s+/;
    var partialRegExp = /^([x*0]|[1-9]\d*)(?:\.([x*0]|[1-9]\d*)(?:\.([x*0]|[1-9]\d*)(?:-([a-z0-9-.]+))?(?:\+([a-z0-9-.]+))?)?)?$/i;
    var hyphenRegExp = /^\s*([a-z0-9-+.*]+)\s+-\s+([a-z0-9-+.*]+)\s*$/i;
    var rangeRegExp = /^([~^<>=]|<=|>=)?\s*([a-z0-9-+.*]+)$/i;
    function parseRange(text) {
        const alternatives = [];
        for (let range of text.trim().split(logicalOrRegExp)){
            if (!range) continue;
            const comparators = [];
            range = range.trim();
            const match = hyphenRegExp.exec(range);
            if (match) {
                if (!parseHyphen(match[1], match[2], comparators)) return void 0;
            } else for (const simple of range.split(whitespaceRegExp)){
                const match2 = rangeRegExp.exec(simple.trim());
                if (!match2 || !parseComparator(match2[1], match2[2], comparators)) return void 0;
            }
            alternatives.push(comparators);
        }
        return alternatives;
    }
    function parsePartial(text) {
        const match = partialRegExp.exec(text);
        if (!match) return void 0;
        const [, major, minor = "*", patch = "*", prerelease, build2] = match;
        const version2 = new Version(isWildcard(major) ? 0 : parseInt(major, 10), isWildcard(major) || isWildcard(minor) ? 0 : parseInt(minor, 10), isWildcard(major) || isWildcard(minor) || isWildcard(patch) ? 0 : parseInt(patch, 10), prerelease, build2);
        return {
            version: version2,
            major,
            minor,
            patch
        };
    }
    function parseHyphen(left, right, comparators) {
        const leftResult = parsePartial(left);
        if (!leftResult) return false;
        const rightResult = parsePartial(right);
        if (!rightResult) return false;
        if (!isWildcard(leftResult.major)) comparators.push(createComparator(">=", leftResult.version));
        if (!isWildcard(rightResult.major)) comparators.push(isWildcard(rightResult.minor) ? createComparator("<", rightResult.version.increment("major")) : isWildcard(rightResult.patch) ? createComparator("<", rightResult.version.increment("minor")) : createComparator("<=", rightResult.version));
        return true;
    }
    function parseComparator(operator, text, comparators) {
        const result = parsePartial(text);
        if (!result) return false;
        const { version: version2, major, minor, patch } = result;
        if (!isWildcard(major)) switch(operator){
            case "~":
                comparators.push(createComparator(">=", version2));
                comparators.push(createComparator("<", version2.increment(isWildcard(minor) ? "major" : "minor")));
                break;
            case "^":
                comparators.push(createComparator(">=", version2));
                comparators.push(createComparator("<", version2.increment(version2.major > 0 || isWildcard(minor) ? "major" : version2.minor > 0 || isWildcard(patch) ? "minor" : "patch")));
                break;
            case "<":
            case ">=":
                comparators.push(isWildcard(minor) || isWildcard(patch) ? createComparator(operator, version2.with({
                    prerelease: "0"
                })) : createComparator(operator, version2));
                break;
            case "<=":
            case ">":
                comparators.push(isWildcard(minor) ? createComparator(operator === "<=" ? "<" : ">=", version2.increment("major").with({
                    prerelease: "0"
                })) : isWildcard(patch) ? createComparator(operator === "<=" ? "<" : ">=", version2.increment("minor").with({
                    prerelease: "0"
                })) : createComparator(operator, version2));
                break;
            case "=":
            case void 0:
                if (isWildcard(minor) || isWildcard(patch)) {
                    comparators.push(createComparator(">=", version2.with({
                        prerelease: "0"
                    })));
                    comparators.push(createComparator("<", version2.increment(isWildcard(minor) ? "major" : "minor").with({
                        prerelease: "0"
                    })));
                } else comparators.push(createComparator("=", version2));
                break;
            default:
                return false;
        }
        else if (operator === "<" || operator === ">") comparators.push(createComparator("<", Version.zero));
        return true;
    }
    function isWildcard(part) {
        return part === "*" || part === "x" || part === "X";
    }
    function createComparator(operator, operand) {
        return {
            operator,
            operand
        };
    }
    function testDisjunction(version2, alternatives) {
        if (alternatives.length === 0) return true;
        for (const alternative of alternatives){
            if (testAlternative(version2, alternative)) return true;
        }
        return false;
    }
    function testAlternative(version2, comparators) {
        for (const comparator of comparators){
            if (!testComparator(version2, comparator.operator, comparator.operand)) return false;
        }
        return true;
    }
    function testComparator(version2, operator, operand) {
        const cmp = version2.compareTo(operand);
        switch(operator){
            case "<":
                return cmp < 0;
            case "<=":
                return cmp <= 0;
            case ">":
                return cmp > 0;
            case ">=":
                return cmp >= 0;
            case "=":
                return cmp === 0;
            default:
                return Debug.assertNever(operator);
        }
    }
    function formatDisjunction(alternatives) {
        return map(alternatives, formatAlternative).join(" || ") || "*";
    }
    function formatAlternative(comparators) {
        return map(comparators, formatComparator).join(" ");
    }
    function formatComparator(comparator) {
        return `${comparator.operator}${comparator.operand}`;
    }
    // src/compiler/performanceCore.ts
    function tryGetPerformance() {
        if (isNodeLikeSystem()) try {
            const { performance: performance2 } = require("7d4ad3bc1ff7a848");
            if (performance2) return {
                shouldWriteNativeEvents: false,
                performance: performance2
            };
        } catch (e) {}
        if (typeof performance === "object") return {
            shouldWriteNativeEvents: true,
            performance
        };
        return void 0;
    }
    function tryGetPerformanceHooks() {
        const p = tryGetPerformance();
        if (!p) return void 0;
        const { shouldWriteNativeEvents, performance: performance2 } = p;
        const hooks = {
            shouldWriteNativeEvents,
            performance: void 0,
            performanceTime: void 0
        };
        if (typeof performance2.timeOrigin === "number" && typeof performance2.now === "function") hooks.performanceTime = performance2;
        if (hooks.performanceTime && typeof performance2.mark === "function" && typeof performance2.measure === "function" && typeof performance2.clearMarks === "function" && typeof performance2.clearMeasures === "function") hooks.performance = performance2;
        return hooks;
    }
    var nativePerformanceHooks = tryGetPerformanceHooks();
    var nativePerformanceTime = nativePerformanceHooks == null ? void 0 : nativePerformanceHooks.performanceTime;
    function tryGetNativePerformanceHooks() {
        return nativePerformanceHooks;
    }
    var timestamp = nativePerformanceTime ? ()=>nativePerformanceTime.now() : Date.now;
    // src/compiler/_namespaces/ts.performance.ts
    var ts_performance_exports = {};
    __export(ts_performance_exports, {
        clearMarks: ()=>clearMarks,
        clearMeasures: ()=>clearMeasures,
        createTimer: ()=>createTimer,
        createTimerIf: ()=>createTimerIf,
        disable: ()=>disable,
        enable: ()=>enable,
        forEachMark: ()=>forEachMark,
        forEachMeasure: ()=>forEachMeasure,
        getCount: ()=>getCount,
        getDuration: ()=>getDuration,
        isEnabled: ()=>isEnabled,
        mark: ()=>mark,
        measure: ()=>measure,
        nullTimer: ()=>nullTimer
    });
    // src/compiler/performance.ts
    var perfHooks;
    var performanceImpl;
    function createTimerIf(condition, measureName, startMarkName, endMarkName) {
        return condition ? createTimer(measureName, startMarkName, endMarkName) : nullTimer;
    }
    function createTimer(measureName, startMarkName, endMarkName) {
        let enterCount = 0;
        return {
            enter,
            exit
        };
        function enter() {
            if (++enterCount === 1) mark(startMarkName);
        }
        function exit() {
            if (--enterCount === 0) {
                mark(endMarkName);
                measure(measureName, startMarkName, endMarkName);
            } else if (enterCount < 0) Debug.fail("enter/exit count does not match.");
        }
    }
    var nullTimer = {
        enter: noop,
        exit: noop
    };
    var enabled = false;
    var timeorigin = timestamp();
    var marks = /* @__PURE__ */ new Map();
    var counts = /* @__PURE__ */ new Map();
    var durations = /* @__PURE__ */ new Map();
    function mark(markName) {
        if (enabled) {
            var _counts_get;
            const count = (_counts_get = counts.get(markName)) !== null && _counts_get !== void 0 ? _counts_get : 0;
            counts.set(markName, count + 1);
            marks.set(markName, timestamp());
            performanceImpl == null || performanceImpl.mark(markName);
            if (typeof onProfilerEvent === "function") onProfilerEvent(markName);
        }
    }
    function measure(measureName, startMarkName, endMarkName) {
        if (enabled) {
            var _ref;
            const end = (_ref = endMarkName !== void 0 ? marks.get(endMarkName) : void 0) !== null && _ref !== void 0 ? _ref : timestamp();
            var _ref1;
            const start = (_ref1 = startMarkName !== void 0 ? marks.get(startMarkName) : void 0) !== null && _ref1 !== void 0 ? _ref1 : timeorigin;
            const previousDuration = durations.get(measureName) || 0;
            durations.set(measureName, previousDuration + (end - start));
            performanceImpl == null || performanceImpl.measure(measureName, startMarkName, endMarkName);
        }
    }
    function getCount(markName) {
        return counts.get(markName) || 0;
    }
    function getDuration(measureName) {
        return durations.get(measureName) || 0;
    }
    function forEachMeasure(cb) {
        durations.forEach((duration, measureName)=>cb(measureName, duration));
    }
    function forEachMark(cb) {
        marks.forEach((_time, markName)=>cb(markName));
    }
    function clearMeasures(name) {
        if (name !== void 0) durations.delete(name);
        else durations.clear();
        performanceImpl == null || performanceImpl.clearMeasures(name);
    }
    function clearMarks(name) {
        if (name !== void 0) {
            counts.delete(name);
            marks.delete(name);
        } else {
            counts.clear();
            marks.clear();
        }
        performanceImpl == null || performanceImpl.clearMarks(name);
    }
    function isEnabled() {
        return enabled;
    }
    function enable(system = sys) {
        var _a;
        if (!enabled) {
            enabled = true;
            perfHooks || (perfHooks = tryGetNativePerformanceHooks());
            if (perfHooks == null ? void 0 : perfHooks.performance) {
                timeorigin = perfHooks.performance.timeOrigin;
                if (perfHooks.shouldWriteNativeEvents || ((_a = system == null ? void 0 : system.cpuProfilingEnabled) == null ? void 0 : _a.call(system)) || (system == null ? void 0 : system.debugMode)) performanceImpl = perfHooks.performance;
            }
        }
        return true;
    }
    function disable() {
        if (enabled) {
            marks.clear();
            counts.clear();
            durations.clear();
            performanceImpl = void 0;
            enabled = false;
        }
    }
    // src/compiler/tracing.ts
    var tracing;
    var tracingEnabled;
    ((tracingEnabled2)=>{
        let fs;
        let traceCount = 0;
        let traceFd = 0;
        let mode;
        const typeCatalog = [];
        let legendPath;
        const legend = [];
        function startTracing2(tracingMode, traceDir, configFilePath) {
            Debug.assert(!tracing, "Tracing already started");
            if (fs === void 0) try {
                fs = require("ab76108507da6451");
            } catch (e) {
                throw new Error(`tracing requires having fs
(original error: ${e.message || e})`);
            }
            mode = tracingMode;
            typeCatalog.length = 0;
            if (legendPath === void 0) legendPath = combinePaths(traceDir, "legend.json");
            if (!fs.existsSync(traceDir)) fs.mkdirSync(traceDir, {
                recursive: true
            });
            const countPart = mode === "build" ? `.${process.pid}-${++traceCount}` : mode === "server" ? `.${process.pid}` : ``;
            const tracePath = combinePaths(traceDir, `trace${countPart}.json`);
            const typesPath = combinePaths(traceDir, `types${countPart}.json`);
            legend.push({
                configFilePath,
                tracePath,
                typesPath
            });
            traceFd = fs.openSync(tracePath, "w");
            tracing = tracingEnabled2;
            const meta = {
                cat: "__metadata",
                ph: "M",
                ts: 1e3 * timestamp(),
                pid: 1,
                tid: 1
            };
            fs.writeSync(traceFd, "[\n" + [
                (0, _objectSpread._)({
                    name: "process_name",
                    args: {
                        name: "tsc"
                    }
                }, meta),
                (0, _objectSpread._)({
                    name: "thread_name",
                    args: {
                        name: "Main"
                    }
                }, meta),
                (0, _objectSpreadProps._)((0, _objectSpread._)({
                    name: "TracingStartedInBrowser"
                }, meta), {
                    cat: "disabled-by-default-devtools.timeline"
                })
            ].map((v1)=>JSON.stringify(v1)).join(",\n"));
        }
        tracingEnabled2.startTracing = startTracing2;
        function stopTracing() {
            Debug.assert(tracing, "Tracing is not in progress");
            Debug.assert(!!typeCatalog.length === (mode !== "server"));
            fs.writeSync(traceFd, `
]
`);
            fs.closeSync(traceFd);
            tracing = void 0;
            if (typeCatalog.length) dumpTypes(typeCatalog);
            else legend[legend.length - 1].typesPath = void 0;
        }
        tracingEnabled2.stopTracing = stopTracing;
        function recordType(type) {
            if (mode !== "server") typeCatalog.push(type);
        }
        tracingEnabled2.recordType = recordType;
        let Phase;
        ((Phase2)=>{
            Phase2["Parse"] = "parse";
            Phase2["Program"] = "program";
            Phase2["Bind"] = "bind";
            Phase2["Check"] = "check";
            Phase2["CheckTypes"] = "checkTypes";
            Phase2["Emit"] = "emit";
            Phase2["Session"] = "session";
        })(Phase = tracingEnabled2.Phase || (tracingEnabled2.Phase = {}));
        function instant(phase, name, args) {
            writeEvent("I", phase, name, args, `"s":"g"`);
        }
        tracingEnabled2.instant = instant;
        const eventStack = [];
        function push(phase, name, args, separateBeginAndEnd = false) {
            if (separateBeginAndEnd) writeEvent("B", phase, name, args);
            eventStack.push({
                phase,
                name,
                args,
                time: 1e3 * timestamp(),
                separateBeginAndEnd
            });
        }
        tracingEnabled2.push = push;
        function pop(results) {
            Debug.assert(eventStack.length > 0);
            writeStackEvent(eventStack.length - 1, 1e3 * timestamp(), results);
            eventStack.length--;
        }
        tracingEnabled2.pop = pop;
        function popAll() {
            const endTime = 1e3 * timestamp();
            for(let i = eventStack.length - 1; i >= 0; i--)writeStackEvent(i, endTime);
            eventStack.length = 0;
        }
        tracingEnabled2.popAll = popAll;
        const sampleInterval = 10000;
        function writeStackEvent(index, endTime, results) {
            const { phase, name, args, time, separateBeginAndEnd } = eventStack[index];
            if (separateBeginAndEnd) {
                Debug.assert(!results, "`results` are not supported for events with `separateBeginAndEnd`");
                writeEvent("E", phase, name, args, /*extras*/ void 0, endTime);
            } else if (sampleInterval - time % sampleInterval <= endTime - time) writeEvent("X", phase, name, (0, _objectSpreadProps._)((0, _objectSpread._)({}, args), {
                results
            }), `"dur":${endTime - time}`, time);
        }
        function writeEvent(eventType, phase, name, args, extras, time = 1e3 * timestamp()) {
            if (mode === "server" && phase === "checkTypes" /* CheckTypes */ ) return;
            mark("beginTracing");
            fs.writeSync(traceFd, `,
{"pid":1,"tid":1,"ph":"${eventType}","cat":"${phase}","ts":${time},"name":"${name}"`);
            if (extras) fs.writeSync(traceFd, `,${extras}`);
            if (args) fs.writeSync(traceFd, `,"args":${JSON.stringify(args)}`);
            fs.writeSync(traceFd, `}`);
            mark("endTracing");
            measure("Tracing", "beginTracing", "endTracing");
        }
        function getLocation(node) {
            const file = getSourceFileOfNode(node);
            return !file ? void 0 : {
                path: file.path,
                start: indexFromOne(getLineAndCharacterOfPosition(file, node.pos)),
                end: indexFromOne(getLineAndCharacterOfPosition(file, node.end))
            };
            function indexFromOne(lc) {
                return {
                    line: lc.line + 1,
                    character: lc.character + 1
                };
            }
        }
        function dumpTypes(types) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s;
            mark("beginDumpTypes");
            const typesPath = legend[legend.length - 1].typesPath;
            const typesFd = fs.openSync(typesPath, "w");
            const recursionIdentityMap = /* @__PURE__ */ new Map();
            fs.writeSync(typesFd, "[");
            const numTypes = types.length;
            for(let i = 0; i < numTypes; i++){
                const type = types[i];
                const objectFlags = type.objectFlags;
                var _type_aliasSymbol;
                const symbol = (_type_aliasSymbol = type.aliasSymbol) !== null && _type_aliasSymbol !== void 0 ? _type_aliasSymbol : type.symbol;
                let display;
                if (objectFlags & 16 /* Anonymous */  | type.flags & 2944 /* Literal */ ) try {
                    display = (_a = type.checker) == null ? void 0 : _a.typeToString(type);
                } catch (e) {
                    display = void 0;
                }
                let indexedAccessProperties = {};
                if (type.flags & 8388608 /* IndexedAccess */ ) {
                    const indexedAccessType = type;
                    indexedAccessProperties = {
                        indexedAccessObjectType: (_b = indexedAccessType.objectType) == null ? void 0 : _b.id,
                        indexedAccessIndexType: (_c = indexedAccessType.indexType) == null ? void 0 : _c.id
                    };
                }
                let referenceProperties = {};
                if (objectFlags & 4 /* Reference */ ) {
                    const referenceType = type;
                    referenceProperties = {
                        instantiatedType: (_d = referenceType.target) == null ? void 0 : _d.id,
                        typeArguments: (_e = referenceType.resolvedTypeArguments) == null ? void 0 : _e.map((t)=>t.id),
                        referenceLocation: getLocation(referenceType.node)
                    };
                }
                let conditionalProperties = {};
                if (type.flags & 16777216 /* Conditional */ ) {
                    const conditionalType = type;
                    var _ref, _ref1;
                    conditionalProperties = {
                        conditionalCheckType: (_f = conditionalType.checkType) == null ? void 0 : _f.id,
                        conditionalExtendsType: (_g = conditionalType.extendsType) == null ? void 0 : _g.id,
                        conditionalTrueType: (_ref = (_h = conditionalType.resolvedTrueType) == null ? void 0 : _h.id) !== null && _ref !== void 0 ? _ref : -1,
                        conditionalFalseType: (_ref1 = (_i = conditionalType.resolvedFalseType) == null ? void 0 : _i.id) !== null && _ref1 !== void 0 ? _ref1 : -1
                    };
                }
                let substitutionProperties = {};
                if (type.flags & 33554432 /* Substitution */ ) {
                    const substitutionType = type;
                    substitutionProperties = {
                        substitutionBaseType: (_j = substitutionType.baseType) == null ? void 0 : _j.id,
                        constraintType: (_k = substitutionType.constraint) == null ? void 0 : _k.id
                    };
                }
                let reverseMappedProperties = {};
                if (objectFlags & 1024 /* ReverseMapped */ ) {
                    const reverseMappedType = type;
                    reverseMappedProperties = {
                        reverseMappedSourceType: (_l = reverseMappedType.source) == null ? void 0 : _l.id,
                        reverseMappedMappedType: (_m = reverseMappedType.mappedType) == null ? void 0 : _m.id,
                        reverseMappedConstraintType: (_n = reverseMappedType.constraintType) == null ? void 0 : _n.id
                    };
                }
                let evolvingArrayProperties = {};
                if (objectFlags & 256 /* EvolvingArray */ ) {
                    const evolvingArrayType = type;
                    evolvingArrayProperties = {
                        evolvingArrayElementType: evolvingArrayType.elementType.id,
                        evolvingArrayFinalType: (_o = evolvingArrayType.finalArrayType) == null ? void 0 : _o.id
                    };
                }
                let recursionToken;
                const recursionIdentity = type.checker.getRecursionIdentity(type);
                if (recursionIdentity) {
                    recursionToken = recursionIdentityMap.get(recursionIdentity);
                    if (!recursionToken) {
                        recursionToken = recursionIdentityMap.size;
                        recursionIdentityMap.set(recursionIdentity, recursionToken);
                    }
                }
                const descriptor = (0, _objectSpreadProps._)((0, _objectSpread._)({
                    id: type.id,
                    intrinsicName: type.intrinsicName,
                    symbolName: (symbol == null ? void 0 : symbol.escapedName) && unescapeLeadingUnderscores(symbol.escapedName),
                    recursionId: recursionToken,
                    isTuple: objectFlags & 8 /* Tuple */  ? true : void 0,
                    unionTypes: type.flags & 1048576 /* Union */  ? (_p = type.types) == null ? void 0 : _p.map((t)=>t.id) : void 0,
                    intersectionTypes: type.flags & 2097152 /* Intersection */  ? type.types.map((t)=>t.id) : void 0,
                    aliasTypeArguments: (_q = type.aliasTypeArguments) == null ? void 0 : _q.map((t)=>t.id),
                    keyofType: type.flags & 4194304 /* Index */  ? (_r = type.type) == null ? void 0 : _r.id : void 0
                }, indexedAccessProperties, referenceProperties, conditionalProperties, substitutionProperties, reverseMappedProperties, evolvingArrayProperties), {
                    destructuringPattern: getLocation(type.pattern),
                    firstDeclaration: getLocation((_s = symbol == null ? void 0 : symbol.declarations) == null ? void 0 : _s[0]),
                    flags: Debug.formatTypeFlags(type.flags).split("|"),
                    display
                });
                fs.writeSync(typesFd, JSON.stringify(descriptor));
                if (i < numTypes - 1) fs.writeSync(typesFd, ",\n");
            }
            fs.writeSync(typesFd, "]\n");
            fs.closeSync(typesFd);
            mark("endDumpTypes");
            measure("Dump types", "beginDumpTypes", "endDumpTypes");
        }
        function dumpLegend() {
            if (!legendPath) return;
            fs.writeFileSync(legendPath, JSON.stringify(legend));
        }
        tracingEnabled2.dumpLegend = dumpLegend;
    })(tracingEnabled || (tracingEnabled = {}));
    var startTracing = tracingEnabled.startTracing;
    var dumpTracingLegend = tracingEnabled.dumpLegend;
    // src/compiler/types.ts
    var SyntaxKind = /* @__PURE__ */ ((SyntaxKind5)=>{
        SyntaxKind5[SyntaxKind5["Unknown"] = 0] = "Unknown";
        SyntaxKind5[SyntaxKind5["EndOfFileToken"] = 1] = "EndOfFileToken";
        SyntaxKind5[SyntaxKind5["SingleLineCommentTrivia"] = 2] = "SingleLineCommentTrivia";
        SyntaxKind5[SyntaxKind5["MultiLineCommentTrivia"] = 3] = "MultiLineCommentTrivia";
        SyntaxKind5[SyntaxKind5["NewLineTrivia"] = 4] = "NewLineTrivia";
        SyntaxKind5[SyntaxKind5["WhitespaceTrivia"] = 5] = "WhitespaceTrivia";
        SyntaxKind5[SyntaxKind5["ShebangTrivia"] = 6] = "ShebangTrivia";
        SyntaxKind5[SyntaxKind5["ConflictMarkerTrivia"] = 7] = "ConflictMarkerTrivia";
        SyntaxKind5[SyntaxKind5["NonTextFileMarkerTrivia"] = 8] = "NonTextFileMarkerTrivia";
        SyntaxKind5[SyntaxKind5["NumericLiteral"] = 9] = "NumericLiteral";
        SyntaxKind5[SyntaxKind5["BigIntLiteral"] = 10] = "BigIntLiteral";
        SyntaxKind5[SyntaxKind5["StringLiteral"] = 11] = "StringLiteral";
        SyntaxKind5[SyntaxKind5["JsxText"] = 12] = "JsxText";
        SyntaxKind5[SyntaxKind5["JsxTextAllWhiteSpaces"] = 13] = "JsxTextAllWhiteSpaces";
        SyntaxKind5[SyntaxKind5["RegularExpressionLiteral"] = 14] = "RegularExpressionLiteral";
        SyntaxKind5[SyntaxKind5["NoSubstitutionTemplateLiteral"] = 15] = "NoSubstitutionTemplateLiteral";
        SyntaxKind5[SyntaxKind5["TemplateHead"] = 16] = "TemplateHead";
        SyntaxKind5[SyntaxKind5["TemplateMiddle"] = 17] = "TemplateMiddle";
        SyntaxKind5[SyntaxKind5["TemplateTail"] = 18] = "TemplateTail";
        SyntaxKind5[SyntaxKind5["OpenBraceToken"] = 19] = "OpenBraceToken";
        SyntaxKind5[SyntaxKind5["CloseBraceToken"] = 20] = "CloseBraceToken";
        SyntaxKind5[SyntaxKind5["OpenParenToken"] = 21] = "OpenParenToken";
        SyntaxKind5[SyntaxKind5["CloseParenToken"] = 22] = "CloseParenToken";
        SyntaxKind5[SyntaxKind5["OpenBracketToken"] = 23] = "OpenBracketToken";
        SyntaxKind5[SyntaxKind5["CloseBracketToken"] = 24] = "CloseBracketToken";
        SyntaxKind5[SyntaxKind5["DotToken"] = 25] = "DotToken";
        SyntaxKind5[SyntaxKind5["DotDotDotToken"] = 26] = "DotDotDotToken";
        SyntaxKind5[SyntaxKind5["SemicolonToken"] = 27] = "SemicolonToken";
        SyntaxKind5[SyntaxKind5["CommaToken"] = 28] = "CommaToken";
        SyntaxKind5[SyntaxKind5["QuestionDotToken"] = 29] = "QuestionDotToken";
        SyntaxKind5[SyntaxKind5["LessThanToken"] = 30] = "LessThanToken";
        SyntaxKind5[SyntaxKind5["LessThanSlashToken"] = 31] = "LessThanSlashToken";
        SyntaxKind5[SyntaxKind5["GreaterThanToken"] = 32] = "GreaterThanToken";
        SyntaxKind5[SyntaxKind5["LessThanEqualsToken"] = 33] = "LessThanEqualsToken";
        SyntaxKind5[SyntaxKind5["GreaterThanEqualsToken"] = 34] = "GreaterThanEqualsToken";
        SyntaxKind5[SyntaxKind5["EqualsEqualsToken"] = 35] = "EqualsEqualsToken";
        SyntaxKind5[SyntaxKind5["ExclamationEqualsToken"] = 36] = "ExclamationEqualsToken";
        SyntaxKind5[SyntaxKind5["EqualsEqualsEqualsToken"] = 37] = "EqualsEqualsEqualsToken";
        SyntaxKind5[SyntaxKind5["ExclamationEqualsEqualsToken"] = 38] = "ExclamationEqualsEqualsToken";
        SyntaxKind5[SyntaxKind5["EqualsGreaterThanToken"] = 39] = "EqualsGreaterThanToken";
        SyntaxKind5[SyntaxKind5["PlusToken"] = 40] = "PlusToken";
        SyntaxKind5[SyntaxKind5["MinusToken"] = 41] = "MinusToken";
        SyntaxKind5[SyntaxKind5["AsteriskToken"] = 42] = "AsteriskToken";
        SyntaxKind5[SyntaxKind5["AsteriskAsteriskToken"] = 43] = "AsteriskAsteriskToken";
        SyntaxKind5[SyntaxKind5["SlashToken"] = 44] = "SlashToken";
        SyntaxKind5[SyntaxKind5["PercentToken"] = 45] = "PercentToken";
        SyntaxKind5[SyntaxKind5["PlusPlusToken"] = 46] = "PlusPlusToken";
        SyntaxKind5[SyntaxKind5["MinusMinusToken"] = 47] = "MinusMinusToken";
        SyntaxKind5[SyntaxKind5["LessThanLessThanToken"] = 48] = "LessThanLessThanToken";
        SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanToken"] = 49] = "GreaterThanGreaterThanToken";
        SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanGreaterThanToken"] = 50] = "GreaterThanGreaterThanGreaterThanToken";
        SyntaxKind5[SyntaxKind5["AmpersandToken"] = 51] = "AmpersandToken";
        SyntaxKind5[SyntaxKind5["BarToken"] = 52] = "BarToken";
        SyntaxKind5[SyntaxKind5["CaretToken"] = 53] = "CaretToken";
        SyntaxKind5[SyntaxKind5["ExclamationToken"] = 54] = "ExclamationToken";
        SyntaxKind5[SyntaxKind5["TildeToken"] = 55] = "TildeToken";
        SyntaxKind5[SyntaxKind5["AmpersandAmpersandToken"] = 56] = "AmpersandAmpersandToken";
        SyntaxKind5[SyntaxKind5["BarBarToken"] = 57] = "BarBarToken";
        SyntaxKind5[SyntaxKind5["QuestionToken"] = 58] = "QuestionToken";
        SyntaxKind5[SyntaxKind5["ColonToken"] = 59] = "ColonToken";
        SyntaxKind5[SyntaxKind5["AtToken"] = 60] = "AtToken";
        SyntaxKind5[SyntaxKind5["QuestionQuestionToken"] = 61] = "QuestionQuestionToken";
        SyntaxKind5[SyntaxKind5["BacktickToken"] = 62] = "BacktickToken";
        SyntaxKind5[SyntaxKind5["HashToken"] = 63] = "HashToken";
        SyntaxKind5[SyntaxKind5["EqualsToken"] = 64] = "EqualsToken";
        SyntaxKind5[SyntaxKind5["PlusEqualsToken"] = 65] = "PlusEqualsToken";
        SyntaxKind5[SyntaxKind5["MinusEqualsToken"] = 66] = "MinusEqualsToken";
        SyntaxKind5[SyntaxKind5["AsteriskEqualsToken"] = 67] = "AsteriskEqualsToken";
        SyntaxKind5[SyntaxKind5["AsteriskAsteriskEqualsToken"] = 68] = "AsteriskAsteriskEqualsToken";
        SyntaxKind5[SyntaxKind5["SlashEqualsToken"] = 69] = "SlashEqualsToken";
        SyntaxKind5[SyntaxKind5["PercentEqualsToken"] = 70] = "PercentEqualsToken";
        SyntaxKind5[SyntaxKind5["LessThanLessThanEqualsToken"] = 71] = "LessThanLessThanEqualsToken";
        SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanEqualsToken"] = 72] = "GreaterThanGreaterThanEqualsToken";
        SyntaxKind5[SyntaxKind5["GreaterThanGreaterThanGreaterThanEqualsToken"] = 73] = "GreaterThanGreaterThanGreaterThanEqualsToken";
        SyntaxKind5[SyntaxKind5["AmpersandEqualsToken"] = 74] = "AmpersandEqualsToken";
        SyntaxKind5[SyntaxKind5["BarEqualsToken"] = 75] = "BarEqualsToken";
        SyntaxKind5[SyntaxKind5["BarBarEqualsToken"] = 76] = "BarBarEqualsToken";
        SyntaxKind5[SyntaxKind5["AmpersandAmpersandEqualsToken"] = 77] = "AmpersandAmpersandEqualsToken";
        SyntaxKind5[SyntaxKind5["QuestionQuestionEqualsToken"] = 78] = "QuestionQuestionEqualsToken";
        SyntaxKind5[SyntaxKind5["CaretEqualsToken"] = 79] = "CaretEqualsToken";
        SyntaxKind5[SyntaxKind5["Identifier"] = 80] = "Identifier";
        SyntaxKind5[SyntaxKind5["PrivateIdentifier"] = 81] = "PrivateIdentifier";
        SyntaxKind5[SyntaxKind5["JSDocCommentTextToken"] = 82] = "JSDocCommentTextToken";
        SyntaxKind5[SyntaxKind5["BreakKeyword"] = 83] = "BreakKeyword";
        SyntaxKind5[SyntaxKind5["CaseKeyword"] = 84] = "CaseKeyword";
        SyntaxKind5[SyntaxKind5["CatchKeyword"] = 85] = "CatchKeyword";
        SyntaxKind5[SyntaxKind5["ClassKeyword"] = 86] = "ClassKeyword";
        SyntaxKind5[SyntaxKind5["ConstKeyword"] = 87] = "ConstKeyword";
        SyntaxKind5[SyntaxKind5["ContinueKeyword"] = 88] = "ContinueKeyword";
        SyntaxKind5[SyntaxKind5["DebuggerKeyword"] = 89] = "DebuggerKeyword";
        SyntaxKind5[SyntaxKind5["DefaultKeyword"] = 90] = "DefaultKeyword";
        SyntaxKind5[SyntaxKind5["DeleteKeyword"] = 91] = "DeleteKeyword";
        SyntaxKind5[SyntaxKind5["DoKeyword"] = 92] = "DoKeyword";
        SyntaxKind5[SyntaxKind5["ElseKeyword"] = 93] = "ElseKeyword";
        SyntaxKind5[SyntaxKind5["EnumKeyword"] = 94] = "EnumKeyword";
        SyntaxKind5[SyntaxKind5["ExportKeyword"] = 95] = "ExportKeyword";
        SyntaxKind5[SyntaxKind5["ExtendsKeyword"] = 96] = "ExtendsKeyword";
        SyntaxKind5[SyntaxKind5["FalseKeyword"] = 97] = "FalseKeyword";
        SyntaxKind5[SyntaxKind5["FinallyKeyword"] = 98] = "FinallyKeyword";
        SyntaxKind5[SyntaxKind5["ForKeyword"] = 99] = "ForKeyword";
        SyntaxKind5[SyntaxKind5["FunctionKeyword"] = 100] = "FunctionKeyword";
        SyntaxKind5[SyntaxKind5["IfKeyword"] = 101] = "IfKeyword";
        SyntaxKind5[SyntaxKind5["ImportKeyword"] = 102] = "ImportKeyword";
        SyntaxKind5[SyntaxKind5["InKeyword"] = 103] = "InKeyword";
        SyntaxKind5[SyntaxKind5["InstanceOfKeyword"] = 104] = "InstanceOfKeyword";
        SyntaxKind5[SyntaxKind5["NewKeyword"] = 105] = "NewKeyword";
        SyntaxKind5[SyntaxKind5["NullKeyword"] = 106] = "NullKeyword";
        SyntaxKind5[SyntaxKind5["ReturnKeyword"] = 107] = "ReturnKeyword";
        SyntaxKind5[SyntaxKind5["SuperKeyword"] = 108] = "SuperKeyword";
        SyntaxKind5[SyntaxKind5["SwitchKeyword"] = 109] = "SwitchKeyword";
        SyntaxKind5[SyntaxKind5["ThisKeyword"] = 110] = "ThisKeyword";
        SyntaxKind5[SyntaxKind5["ThrowKeyword"] = 111] = "ThrowKeyword";
        SyntaxKind5[SyntaxKind5["TrueKeyword"] = 112] = "TrueKeyword";
        SyntaxKind5[SyntaxKind5["TryKeyword"] = 113] = "TryKeyword";
        SyntaxKind5[SyntaxKind5["TypeOfKeyword"] = 114] = "TypeOfKeyword";
        SyntaxKind5[SyntaxKind5["VarKeyword"] = 115] = "VarKeyword";
        SyntaxKind5[SyntaxKind5["VoidKeyword"] = 116] = "VoidKeyword";
        SyntaxKind5[SyntaxKind5["WhileKeyword"] = 117] = "WhileKeyword";
        SyntaxKind5[SyntaxKind5["WithKeyword"] = 118] = "WithKeyword";
        SyntaxKind5[SyntaxKind5["ImplementsKeyword"] = 119] = "ImplementsKeyword";
        SyntaxKind5[SyntaxKind5["InterfaceKeyword"] = 120] = "InterfaceKeyword";
        SyntaxKind5[SyntaxKind5["LetKeyword"] = 121] = "LetKeyword";
        SyntaxKind5[SyntaxKind5["PackageKeyword"] = 122] = "PackageKeyword";
        SyntaxKind5[SyntaxKind5["PrivateKeyword"] = 123] = "PrivateKeyword";
        SyntaxKind5[SyntaxKind5["ProtectedKeyword"] = 124] = "ProtectedKeyword";
        SyntaxKind5[SyntaxKind5["PublicKeyword"] = 125] = "PublicKeyword";
        SyntaxKind5[SyntaxKind5["StaticKeyword"] = 126] = "StaticKeyword";
        SyntaxKind5[SyntaxKind5["YieldKeyword"] = 127] = "YieldKeyword";
        SyntaxKind5[SyntaxKind5["AbstractKeyword"] = 128] = "AbstractKeyword";
        SyntaxKind5[SyntaxKind5["AccessorKeyword"] = 129] = "AccessorKeyword";
        SyntaxKind5[SyntaxKind5["AsKeyword"] = 130] = "AsKeyword";
        SyntaxKind5[SyntaxKind5["AssertsKeyword"] = 131] = "AssertsKeyword";
        SyntaxKind5[SyntaxKind5["AssertKeyword"] = 132] = "AssertKeyword";
        SyntaxKind5[SyntaxKind5["AnyKeyword"] = 133] = "AnyKeyword";
        SyntaxKind5[SyntaxKind5["AsyncKeyword"] = 134] = "AsyncKeyword";
        SyntaxKind5[SyntaxKind5["AwaitKeyword"] = 135] = "AwaitKeyword";
        SyntaxKind5[SyntaxKind5["BooleanKeyword"] = 136] = "BooleanKeyword";
        SyntaxKind5[SyntaxKind5["ConstructorKeyword"] = 137] = "ConstructorKeyword";
        SyntaxKind5[SyntaxKind5["DeclareKeyword"] = 138] = "DeclareKeyword";
        SyntaxKind5[SyntaxKind5["GetKeyword"] = 139] = "GetKeyword";
        SyntaxKind5[SyntaxKind5["InferKeyword"] = 140] = "InferKeyword";
        SyntaxKind5[SyntaxKind5["IntrinsicKeyword"] = 141] = "IntrinsicKeyword";
        SyntaxKind5[SyntaxKind5["IsKeyword"] = 142] = "IsKeyword";
        SyntaxKind5[SyntaxKind5["KeyOfKeyword"] = 143] = "KeyOfKeyword";
        SyntaxKind5[SyntaxKind5["ModuleKeyword"] = 144] = "ModuleKeyword";
        SyntaxKind5[SyntaxKind5["NamespaceKeyword"] = 145] = "NamespaceKeyword";
        SyntaxKind5[SyntaxKind5["NeverKeyword"] = 146] = "NeverKeyword";
        SyntaxKind5[SyntaxKind5["OutKeyword"] = 147] = "OutKeyword";
        SyntaxKind5[SyntaxKind5["ReadonlyKeyword"] = 148] = "ReadonlyKeyword";
        SyntaxKind5[SyntaxKind5["RequireKeyword"] = 149] = "RequireKeyword";
        SyntaxKind5[SyntaxKind5["NumberKeyword"] = 150] = "NumberKeyword";
        SyntaxKind5[SyntaxKind5["ObjectKeyword"] = 151] = "ObjectKeyword";
        SyntaxKind5[SyntaxKind5["SatisfiesKeyword"] = 152] = "SatisfiesKeyword";
        SyntaxKind5[SyntaxKind5["SetKeyword"] = 153] = "SetKeyword";
        SyntaxKind5[SyntaxKind5["StringKeyword"] = 154] = "StringKeyword";
        SyntaxKind5[SyntaxKind5["SymbolKeyword"] = 155] = "SymbolKeyword";
        SyntaxKind5[SyntaxKind5["TypeKeyword"] = 156] = "TypeKeyword";
        SyntaxKind5[SyntaxKind5["UndefinedKeyword"] = 157] = "UndefinedKeyword";
        SyntaxKind5[SyntaxKind5["UniqueKeyword"] = 158] = "UniqueKeyword";
        SyntaxKind5[SyntaxKind5["UnknownKeyword"] = 159] = "UnknownKeyword";
        SyntaxKind5[SyntaxKind5["UsingKeyword"] = 160] = "UsingKeyword";
        SyntaxKind5[SyntaxKind5["FromKeyword"] = 161] = "FromKeyword";
        SyntaxKind5[SyntaxKind5["GlobalKeyword"] = 162] = "GlobalKeyword";
        SyntaxKind5[SyntaxKind5["BigIntKeyword"] = 163] = "BigIntKeyword";
        SyntaxKind5[SyntaxKind5["OverrideKeyword"] = 164] = "OverrideKeyword";
        SyntaxKind5[SyntaxKind5["OfKeyword"] = 165] = "OfKeyword";
        SyntaxKind5[SyntaxKind5["DeferKeyword"] = 166] = "DeferKeyword";
        SyntaxKind5[SyntaxKind5["QualifiedName"] = 167] = "QualifiedName";
        SyntaxKind5[SyntaxKind5["ComputedPropertyName"] = 168] = "ComputedPropertyName";
        SyntaxKind5[SyntaxKind5["TypeParameter"] = 169] = "TypeParameter";
        SyntaxKind5[SyntaxKind5["Parameter"] = 170] = "Parameter";
        SyntaxKind5[SyntaxKind5["Decorator"] = 171] = "Decorator";
        SyntaxKind5[SyntaxKind5["PropertySignature"] = 172] = "PropertySignature";
        SyntaxKind5[SyntaxKind5["PropertyDeclaration"] = 173] = "PropertyDeclaration";
        SyntaxKind5[SyntaxKind5["MethodSignature"] = 174] = "MethodSignature";
        SyntaxKind5[SyntaxKind5["MethodDeclaration"] = 175] = "MethodDeclaration";
        SyntaxKind5[SyntaxKind5["ClassStaticBlockDeclaration"] = 176] = "ClassStaticBlockDeclaration";
        SyntaxKind5[SyntaxKind5["Constructor"] = 177] = "Constructor";
        SyntaxKind5[SyntaxKind5["GetAccessor"] = 178] = "GetAccessor";
        SyntaxKind5[SyntaxKind5["SetAccessor"] = 179] = "SetAccessor";
        SyntaxKind5[SyntaxKind5["CallSignature"] = 180] = "CallSignature";
        SyntaxKind5[SyntaxKind5["ConstructSignature"] = 181] = "ConstructSignature";
        SyntaxKind5[SyntaxKind5["IndexSignature"] = 182] = "IndexSignature";
        SyntaxKind5[SyntaxKind5["TypePredicate"] = 183] = "TypePredicate";
        SyntaxKind5[SyntaxKind5["TypeReference"] = 184] = "TypeReference";
        SyntaxKind5[SyntaxKind5["FunctionType"] = 185] = "FunctionType";
        SyntaxKind5[SyntaxKind5["ConstructorType"] = 186] = "ConstructorType";
        SyntaxKind5[SyntaxKind5["TypeQuery"] = 187] = "TypeQuery";
        SyntaxKind5[SyntaxKind5["TypeLiteral"] = 188] = "TypeLiteral";
        SyntaxKind5[SyntaxKind5["ArrayType"] = 189] = "ArrayType";
        SyntaxKind5[SyntaxKind5["TupleType"] = 190] = "TupleType";
        SyntaxKind5[SyntaxKind5["OptionalType"] = 191] = "OptionalType";
        SyntaxKind5[SyntaxKind5["RestType"] = 192] = "RestType";
        SyntaxKind5[SyntaxKind5["UnionType"] = 193] = "UnionType";
        SyntaxKind5[SyntaxKind5["IntersectionType"] = 194] = "IntersectionType";
        SyntaxKind5[SyntaxKind5["ConditionalType"] = 195] = "ConditionalType";
        SyntaxKind5[SyntaxKind5["InferType"] = 196] = "InferType";
        SyntaxKind5[SyntaxKind5["ParenthesizedType"] = 197] = "ParenthesizedType";
        SyntaxKind5[SyntaxKind5["ThisType"] = 198] = "ThisType";
        SyntaxKind5[SyntaxKind5["TypeOperator"] = 199] = "TypeOperator";
        SyntaxKind5[SyntaxKind5["IndexedAccessType"] = 200] = "IndexedAccessType";
        SyntaxKind5[SyntaxKind5["MappedType"] = 201] = "MappedType";
        SyntaxKind5[SyntaxKind5["LiteralType"] = 202] = "LiteralType";
        SyntaxKind5[SyntaxKind5["NamedTupleMember"] = 203] = "NamedTupleMember";
        SyntaxKind5[SyntaxKind5["TemplateLiteralType"] = 204] = "TemplateLiteralType";
        SyntaxKind5[SyntaxKind5["TemplateLiteralTypeSpan"] = 205] = "TemplateLiteralTypeSpan";
        SyntaxKind5[SyntaxKind5["ImportType"] = 206] = "ImportType";
        SyntaxKind5[SyntaxKind5["ObjectBindingPattern"] = 207] = "ObjectBindingPattern";
        SyntaxKind5[SyntaxKind5["ArrayBindingPattern"] = 208] = "ArrayBindingPattern";
        SyntaxKind5[SyntaxKind5["BindingElement"] = 209] = "BindingElement";
        SyntaxKind5[SyntaxKind5["ArrayLiteralExpression"] = 210] = "ArrayLiteralExpression";
        SyntaxKind5[SyntaxKind5["ObjectLiteralExpression"] = 211] = "ObjectLiteralExpression";
        SyntaxKind5[SyntaxKind5["PropertyAccessExpression"] = 212] = "PropertyAccessExpression";
        SyntaxKind5[SyntaxKind5["ElementAccessExpression"] = 213] = "ElementAccessExpression";
        SyntaxKind5[SyntaxKind5["CallExpression"] = 214] = "CallExpression";
        SyntaxKind5[SyntaxKind5["NewExpression"] = 215] = "NewExpression";
        SyntaxKind5[SyntaxKind5["TaggedTemplateExpression"] = 216] = "TaggedTemplateExpression";
        SyntaxKind5[SyntaxKind5["TypeAssertionExpression"] = 217] = "TypeAssertionExpression";
        SyntaxKind5[SyntaxKind5["ParenthesizedExpression"] = 218] = "ParenthesizedExpression";
        SyntaxKind5[SyntaxKind5["FunctionExpression"] = 219] = "FunctionExpression";
        SyntaxKind5[SyntaxKind5["ArrowFunction"] = 220] = "ArrowFunction";
        SyntaxKind5[SyntaxKind5["DeleteExpression"] = 221] = "DeleteExpression";
        SyntaxKind5[SyntaxKind5["TypeOfExpression"] = 222] = "TypeOfExpression";
        SyntaxKind5[SyntaxKind5["VoidExpression"] = 223] = "VoidExpression";
        SyntaxKind5[SyntaxKind5["AwaitExpression"] = 224] = "AwaitExpression";
        SyntaxKind5[SyntaxKind5["PrefixUnaryExpression"] = 225] = "PrefixUnaryExpression";
        SyntaxKind5[SyntaxKind5["PostfixUnaryExpression"] = 226] = "PostfixUnaryExpression";
        SyntaxKind5[SyntaxKind5["BinaryExpression"] = 227] = "BinaryExpression";
        SyntaxKind5[SyntaxKind5["ConditionalExpression"] = 228] = "ConditionalExpression";
        SyntaxKind5[SyntaxKind5["TemplateExpression"] = 229] = "TemplateExpression";
        SyntaxKind5[SyntaxKind5["YieldExpression"] = 230] = "YieldExpression";
        SyntaxKind5[SyntaxKind5["SpreadElement"] = 231] = "SpreadElement";
        SyntaxKind5[SyntaxKind5["ClassExpression"] = 232] = "ClassExpression";
        SyntaxKind5[SyntaxKind5["OmittedExpression"] = 233] = "OmittedExpression";
        SyntaxKind5[SyntaxKind5["ExpressionWithTypeArguments"] = 234] = "ExpressionWithTypeArguments";
        SyntaxKind5[SyntaxKind5["AsExpression"] = 235] = "AsExpression";
        SyntaxKind5[SyntaxKind5["NonNullExpression"] = 236] = "NonNullExpression";
        SyntaxKind5[SyntaxKind5["MetaProperty"] = 237] = "MetaProperty";
        SyntaxKind5[SyntaxKind5["SyntheticExpression"] = 238] = "SyntheticExpression";
        SyntaxKind5[SyntaxKind5["SatisfiesExpression"] = 239] = "SatisfiesExpression";
        SyntaxKind5[SyntaxKind5["TemplateSpan"] = 240] = "TemplateSpan";
        SyntaxKind5[SyntaxKind5["SemicolonClassElement"] = 241] = "SemicolonClassElement";
        SyntaxKind5[SyntaxKind5["Block"] = 242] = "Block";
        SyntaxKind5[SyntaxKind5["EmptyStatement"] = 243] = "EmptyStatement";
        SyntaxKind5[SyntaxKind5["VariableStatement"] = 244] = "VariableStatement";
        SyntaxKind5[SyntaxKind5["ExpressionStatement"] = 245] = "ExpressionStatement";
        SyntaxKind5[SyntaxKind5["IfStatement"] = 246] = "IfStatement";
        SyntaxKind5[SyntaxKind5["DoStatement"] = 247] = "DoStatement";
        SyntaxKind5[SyntaxKind5["WhileStatement"] = 248] = "WhileStatement";
        SyntaxKind5[SyntaxKind5["ForStatement"] = 249] = "ForStatement";
        SyntaxKind5[SyntaxKind5["ForInStatement"] = 250] = "ForInStatement";
        SyntaxKind5[SyntaxKind5["ForOfStatement"] = 251] = "ForOfStatement";
        SyntaxKind5[SyntaxKind5["ContinueStatement"] = 252] = "ContinueStatement";
        SyntaxKind5[SyntaxKind5["BreakStatement"] = 253] = "BreakStatement";
        SyntaxKind5[SyntaxKind5["ReturnStatement"] = 254] = "ReturnStatement";
        SyntaxKind5[SyntaxKind5["WithStatement"] = 255] = "WithStatement";
        SyntaxKind5[SyntaxKind5["SwitchStatement"] = 256] = "SwitchStatement";
        SyntaxKind5[SyntaxKind5["LabeledStatement"] = 257] = "LabeledStatement";
        SyntaxKind5[SyntaxKind5["ThrowStatement"] = 258] = "ThrowStatement";
        SyntaxKind5[SyntaxKind5["TryStatement"] = 259] = "TryStatement";
        SyntaxKind5[SyntaxKind5["DebuggerStatement"] = 260] = "DebuggerStatement";
        SyntaxKind5[SyntaxKind5["VariableDeclaration"] = 261] = "VariableDeclaration";
        SyntaxKind5[SyntaxKind5["VariableDeclarationList"] = 262] = "VariableDeclarationList";
        SyntaxKind5[SyntaxKind5["FunctionDeclaration"] = 263] = "FunctionDeclaration";
        SyntaxKind5[SyntaxKind5["ClassDeclaration"] = 264] = "ClassDeclaration";
        SyntaxKind5[SyntaxKind5["InterfaceDeclaration"] = 265] = "InterfaceDeclaration";
        SyntaxKind5[SyntaxKind5["TypeAliasDeclaration"] = 266] = "TypeAliasDeclaration";
        SyntaxKind5[SyntaxKind5["EnumDeclaration"] = 267] = "EnumDeclaration";
        SyntaxKind5[SyntaxKind5["ModuleDeclaration"] = 268] = "ModuleDeclaration";
        SyntaxKind5[SyntaxKind5["ModuleBlock"] = 269] = "ModuleBlock";
        SyntaxKind5[SyntaxKind5["CaseBlock"] = 270] = "CaseBlock";
        SyntaxKind5[SyntaxKind5["NamespaceExportDeclaration"] = 271] = "NamespaceExportDeclaration";
        SyntaxKind5[SyntaxKind5["ImportEqualsDeclaration"] = 272] = "ImportEqualsDeclaration";
        SyntaxKind5[SyntaxKind5["ImportDeclaration"] = 273] = "ImportDeclaration";
        SyntaxKind5[SyntaxKind5["ImportClause"] = 274] = "ImportClause";
        SyntaxKind5[SyntaxKind5["NamespaceImport"] = 275] = "NamespaceImport";
        SyntaxKind5[SyntaxKind5["NamedImports"] = 276] = "NamedImports";
        SyntaxKind5[SyntaxKind5["ImportSpecifier"] = 277] = "ImportSpecifier";
        SyntaxKind5[SyntaxKind5["ExportAssignment"] = 278] = "ExportAssignment";
        SyntaxKind5[SyntaxKind5["ExportDeclaration"] = 279] = "ExportDeclaration";
        SyntaxKind5[SyntaxKind5["NamedExports"] = 280] = "NamedExports";
        SyntaxKind5[SyntaxKind5["NamespaceExport"] = 281] = "NamespaceExport";
        SyntaxKind5[SyntaxKind5["ExportSpecifier"] = 282] = "ExportSpecifier";
        SyntaxKind5[SyntaxKind5["MissingDeclaration"] = 283] = "MissingDeclaration";
        SyntaxKind5[SyntaxKind5["ExternalModuleReference"] = 284] = "ExternalModuleReference";
        SyntaxKind5[SyntaxKind5["JsxElement"] = 285] = "JsxElement";
        SyntaxKind5[SyntaxKind5["JsxSelfClosingElement"] = 286] = "JsxSelfClosingElement";
        SyntaxKind5[SyntaxKind5["JsxOpeningElement"] = 287] = "JsxOpeningElement";
        SyntaxKind5[SyntaxKind5["JsxClosingElement"] = 288] = "JsxClosingElement";
        SyntaxKind5[SyntaxKind5["JsxFragment"] = 289] = "JsxFragment";
        SyntaxKind5[SyntaxKind5["JsxOpeningFragment"] = 290] = "JsxOpeningFragment";
        SyntaxKind5[SyntaxKind5["JsxClosingFragment"] = 291] = "JsxClosingFragment";
        SyntaxKind5[SyntaxKind5["JsxAttribute"] = 292] = "JsxAttribute";
        SyntaxKind5[SyntaxKind5["JsxAttributes"] = 293] = "JsxAttributes";
        SyntaxKind5[SyntaxKind5["JsxSpreadAttribute"] = 294] = "JsxSpreadAttribute";
        SyntaxKind5[SyntaxKind5["JsxExpression"] = 295] = "JsxExpression";
        SyntaxKind5[SyntaxKind5["JsxNamespacedName"] = 296] = "JsxNamespacedName";
        SyntaxKind5[SyntaxKind5["CaseClause"] = 297] = "CaseClause";
        SyntaxKind5[SyntaxKind5["DefaultClause"] = 298] = "DefaultClause";
        SyntaxKind5[SyntaxKind5["HeritageClause"] = 299] = "HeritageClause";
        SyntaxKind5[SyntaxKind5["CatchClause"] = 300] = "CatchClause";
        SyntaxKind5[SyntaxKind5["ImportAttributes"] = 301] = "ImportAttributes";
        SyntaxKind5[SyntaxKind5["ImportAttribute"] = 302] = "ImportAttribute";
        SyntaxKind5[SyntaxKind5["AssertClause"] = 301 /* ImportAttributes */ ] = "AssertClause";
        SyntaxKind5[SyntaxKind5["AssertEntry"] = 302 /* ImportAttribute */ ] = "AssertEntry";
        SyntaxKind5[SyntaxKind5["ImportTypeAssertionContainer"] = 303] = "ImportTypeAssertionContainer";
        SyntaxKind5[SyntaxKind5["PropertyAssignment"] = 304] = "PropertyAssignment";
        SyntaxKind5[SyntaxKind5["ShorthandPropertyAssignment"] = 305] = "ShorthandPropertyAssignment";
        SyntaxKind5[SyntaxKind5["SpreadAssignment"] = 306] = "SpreadAssignment";
        SyntaxKind5[SyntaxKind5["EnumMember"] = 307] = "EnumMember";
        SyntaxKind5[SyntaxKind5["SourceFile"] = 308] = "SourceFile";
        SyntaxKind5[SyntaxKind5["Bundle"] = 309] = "Bundle";
        SyntaxKind5[SyntaxKind5["JSDocTypeExpression"] = 310] = "JSDocTypeExpression";
        SyntaxKind5[SyntaxKind5["JSDocNameReference"] = 311] = "JSDocNameReference";
        SyntaxKind5[SyntaxKind5["JSDocMemberName"] = 312] = "JSDocMemberName";
        SyntaxKind5[SyntaxKind5["JSDocAllType"] = 313] = "JSDocAllType";
        SyntaxKind5[SyntaxKind5["JSDocUnknownType"] = 314] = "JSDocUnknownType";
        SyntaxKind5[SyntaxKind5["JSDocNullableType"] = 315] = "JSDocNullableType";
        SyntaxKind5[SyntaxKind5["JSDocNonNullableType"] = 316] = "JSDocNonNullableType";
        SyntaxKind5[SyntaxKind5["JSDocOptionalType"] = 317] = "JSDocOptionalType";
        SyntaxKind5[SyntaxKind5["JSDocFunctionType"] = 318] = "JSDocFunctionType";
        SyntaxKind5[SyntaxKind5["JSDocVariadicType"] = 319] = "JSDocVariadicType";
        SyntaxKind5[SyntaxKind5["JSDocNamepathType"] = 320] = "JSDocNamepathType";
        SyntaxKind5[SyntaxKind5["JSDoc"] = 321] = "JSDoc";
        SyntaxKind5[SyntaxKind5["JSDocComment"] = 321 /* JSDoc */ ] = "JSDocComment";
        SyntaxKind5[SyntaxKind5["JSDocText"] = 322] = "JSDocText";
        SyntaxKind5[SyntaxKind5["JSDocTypeLiteral"] = 323] = "JSDocTypeLiteral";
        SyntaxKind5[SyntaxKind5["JSDocSignature"] = 324] = "JSDocSignature";
        SyntaxKind5[SyntaxKind5["JSDocLink"] = 325] = "JSDocLink";
        SyntaxKind5[SyntaxKind5["JSDocLinkCode"] = 326] = "JSDocLinkCode";
        SyntaxKind5[SyntaxKind5["JSDocLinkPlain"] = 327] = "JSDocLinkPlain";
        SyntaxKind5[SyntaxKind5["JSDocTag"] = 328] = "JSDocTag";
        SyntaxKind5[SyntaxKind5["JSDocAugmentsTag"] = 329] = "JSDocAugmentsTag";
        SyntaxKind5[SyntaxKind5["JSDocImplementsTag"] = 330] = "JSDocImplementsTag";
        SyntaxKind5[SyntaxKind5["JSDocAuthorTag"] = 331] = "JSDocAuthorTag";
        SyntaxKind5[SyntaxKind5["JSDocDeprecatedTag"] = 332] = "JSDocDeprecatedTag";
        SyntaxKind5[SyntaxKind5["JSDocClassTag"] = 333] = "JSDocClassTag";
        SyntaxKind5[SyntaxKind5["JSDocPublicTag"] = 334] = "JSDocPublicTag";
        SyntaxKind5[SyntaxKind5["JSDocPrivateTag"] = 335] = "JSDocPrivateTag";
        SyntaxKind5[SyntaxKind5["JSDocProtectedTag"] = 336] = "JSDocProtectedTag";
        SyntaxKind5[SyntaxKind5["JSDocReadonlyTag"] = 337] = "JSDocReadonlyTag";
        SyntaxKind5[SyntaxKind5["JSDocOverrideTag"] = 338] = "JSDocOverrideTag";
        SyntaxKind5[SyntaxKind5["JSDocCallbackTag"] = 339] = "JSDocCallbackTag";
        SyntaxKind5[SyntaxKind5["JSDocOverloadTag"] = 340] = "JSDocOverloadTag";
        SyntaxKind5[SyntaxKind5["JSDocEnumTag"] = 341] = "JSDocEnumTag";
        SyntaxKind5[SyntaxKind5["JSDocParameterTag"] = 342] = "JSDocParameterTag";
        SyntaxKind5[SyntaxKind5["JSDocReturnTag"] = 343] = "JSDocReturnTag";
        SyntaxKind5[SyntaxKind5["JSDocThisTag"] = 344] = "JSDocThisTag";
        SyntaxKind5[SyntaxKind5["JSDocTypeTag"] = 345] = "JSDocTypeTag";
        SyntaxKind5[SyntaxKind5["JSDocTemplateTag"] = 346] = "JSDocTemplateTag";
        SyntaxKind5[SyntaxKind5["JSDocTypedefTag"] = 347] = "JSDocTypedefTag";
        SyntaxKind5[SyntaxKind5["JSDocSeeTag"] = 348] = "JSDocSeeTag";
        SyntaxKind5[SyntaxKind5["JSDocPropertyTag"] = 349] = "JSDocPropertyTag";
        SyntaxKind5[SyntaxKind5["JSDocThrowsTag"] = 350] = "JSDocThrowsTag";
        SyntaxKind5[SyntaxKind5["JSDocSatisfiesTag"] = 351] = "JSDocSatisfiesTag";
        SyntaxKind5[SyntaxKind5["JSDocImportTag"] = 352] = "JSDocImportTag";
        SyntaxKind5[SyntaxKind5["SyntaxList"] = 353] = "SyntaxList";
        SyntaxKind5[SyntaxKind5["NotEmittedStatement"] = 354] = "NotEmittedStatement";
        SyntaxKind5[SyntaxKind5["NotEmittedTypeElement"] = 355] = "NotEmittedTypeElement";
        SyntaxKind5[SyntaxKind5["PartiallyEmittedExpression"] = 356] = "PartiallyEmittedExpression";
        SyntaxKind5[SyntaxKind5["CommaListExpression"] = 357] = "CommaListExpression";
        SyntaxKind5[SyntaxKind5["SyntheticReferenceExpression"] = 358] = "SyntheticReferenceExpression";
        SyntaxKind5[SyntaxKind5["Count"] = 359] = "Count";
        SyntaxKind5[SyntaxKind5["FirstAssignment"] = 64 /* EqualsToken */ ] = "FirstAssignment";
        SyntaxKind5[SyntaxKind5["LastAssignment"] = 79 /* CaretEqualsToken */ ] = "LastAssignment";
        SyntaxKind5[SyntaxKind5["FirstCompoundAssignment"] = 65 /* PlusEqualsToken */ ] = "FirstCompoundAssignment";
        SyntaxKind5[SyntaxKind5["LastCompoundAssignment"] = 79 /* CaretEqualsToken */ ] = "LastCompoundAssignment";
        SyntaxKind5[SyntaxKind5["FirstReservedWord"] = 83 /* BreakKeyword */ ] = "FirstReservedWord";
        SyntaxKind5[SyntaxKind5["LastReservedWord"] = 118 /* WithKeyword */ ] = "LastReservedWord";
        SyntaxKind5[SyntaxKind5["FirstKeyword"] = 83 /* BreakKeyword */ ] = "FirstKeyword";
        SyntaxKind5[SyntaxKind5["LastKeyword"] = 166 /* DeferKeyword */ ] = "LastKeyword";
        SyntaxKind5[SyntaxKind5["FirstFutureReservedWord"] = 119 /* ImplementsKeyword */ ] = "FirstFutureReservedWord";
        SyntaxKind5[SyntaxKind5["LastFutureReservedWord"] = 127 /* YieldKeyword */ ] = "LastFutureReservedWord";
        SyntaxKind5[SyntaxKind5["FirstTypeNode"] = 183 /* TypePredicate */ ] = "FirstTypeNode";
        SyntaxKind5[SyntaxKind5["LastTypeNode"] = 206 /* ImportType */ ] = "LastTypeNode";
        SyntaxKind5[SyntaxKind5["FirstPunctuation"] = 19 /* OpenBraceToken */ ] = "FirstPunctuation";
        SyntaxKind5[SyntaxKind5["LastPunctuation"] = 79 /* CaretEqualsToken */ ] = "LastPunctuation";
        SyntaxKind5[SyntaxKind5["FirstToken"] = 0 /* Unknown */ ] = "FirstToken";
        SyntaxKind5[SyntaxKind5["LastToken"] = 166 /* LastKeyword */ ] = "LastToken";
        SyntaxKind5[SyntaxKind5["FirstTriviaToken"] = 2 /* SingleLineCommentTrivia */ ] = "FirstTriviaToken";
        SyntaxKind5[SyntaxKind5["LastTriviaToken"] = 7 /* ConflictMarkerTrivia */ ] = "LastTriviaToken";
        SyntaxKind5[SyntaxKind5["FirstLiteralToken"] = 9 /* NumericLiteral */ ] = "FirstLiteralToken";
        SyntaxKind5[SyntaxKind5["LastLiteralToken"] = 15 /* NoSubstitutionTemplateLiteral */ ] = "LastLiteralToken";
        SyntaxKind5[SyntaxKind5["FirstTemplateToken"] = 15 /* NoSubstitutionTemplateLiteral */ ] = "FirstTemplateToken";
        SyntaxKind5[SyntaxKind5["LastTemplateToken"] = 18 /* TemplateTail */ ] = "LastTemplateToken";
        SyntaxKind5[SyntaxKind5["FirstBinaryOperator"] = 30 /* LessThanToken */ ] = "FirstBinaryOperator";
        SyntaxKind5[SyntaxKind5["LastBinaryOperator"] = 79 /* CaretEqualsToken */ ] = "LastBinaryOperator";
        SyntaxKind5[SyntaxKind5["FirstStatement"] = 244 /* VariableStatement */ ] = "FirstStatement";
        SyntaxKind5[SyntaxKind5["LastStatement"] = 260 /* DebuggerStatement */ ] = "LastStatement";
        SyntaxKind5[SyntaxKind5["FirstNode"] = 167 /* QualifiedName */ ] = "FirstNode";
        SyntaxKind5[SyntaxKind5["FirstJSDocNode"] = 310 /* JSDocTypeExpression */ ] = "FirstJSDocNode";
        SyntaxKind5[SyntaxKind5["LastJSDocNode"] = 352 /* JSDocImportTag */ ] = "LastJSDocNode";
        SyntaxKind5[SyntaxKind5["FirstJSDocTagNode"] = 328 /* JSDocTag */ ] = "FirstJSDocTagNode";
        SyntaxKind5[SyntaxKind5["LastJSDocTagNode"] = 352 /* JSDocImportTag */ ] = "LastJSDocTagNode";
        SyntaxKind5[SyntaxKind5["FirstContextualKeyword"] = 128 /* AbstractKeyword */ ] = "FirstContextualKeyword";
        SyntaxKind5[SyntaxKind5["LastContextualKeyword"] = 166 /* LastKeyword */ ] = "LastContextualKeyword";
        return SyntaxKind5;
    })(SyntaxKind || {});
    var NodeFlags = /* @__PURE__ */ ((NodeFlags3)=>{
        NodeFlags3[NodeFlags3["None"] = 0] = "None";
        NodeFlags3[NodeFlags3["Let"] = 1] = "Let";
        NodeFlags3[NodeFlags3["Const"] = 2] = "Const";
        NodeFlags3[NodeFlags3["Using"] = 4] = "Using";
        NodeFlags3[NodeFlags3["AwaitUsing"] = 6] = "AwaitUsing";
        NodeFlags3[NodeFlags3["NestedNamespace"] = 8] = "NestedNamespace";
        NodeFlags3[NodeFlags3["Synthesized"] = 16] = "Synthesized";
        NodeFlags3[NodeFlags3["Namespace"] = 32] = "Namespace";
        NodeFlags3[NodeFlags3["OptionalChain"] = 64] = "OptionalChain";
        NodeFlags3[NodeFlags3["ExportContext"] = 128] = "ExportContext";
        NodeFlags3[NodeFlags3["ContainsThis"] = 256] = "ContainsThis";
        NodeFlags3[NodeFlags3["HasImplicitReturn"] = 512] = "HasImplicitReturn";
        NodeFlags3[NodeFlags3["HasExplicitReturn"] = 1024] = "HasExplicitReturn";
        NodeFlags3[NodeFlags3["GlobalAugmentation"] = 2048] = "GlobalAugmentation";
        NodeFlags3[NodeFlags3["HasAsyncFunctions"] = 4096] = "HasAsyncFunctions";
        NodeFlags3[NodeFlags3["DisallowInContext"] = 8192] = "DisallowInContext";
        NodeFlags3[NodeFlags3["YieldContext"] = 16384] = "YieldContext";
        NodeFlags3[NodeFlags3["DecoratorContext"] = 32768] = "DecoratorContext";
        NodeFlags3[NodeFlags3["AwaitContext"] = 65536] = "AwaitContext";
        NodeFlags3[NodeFlags3["DisallowConditionalTypesContext"] = 131072] = "DisallowConditionalTypesContext";
        NodeFlags3[NodeFlags3["ThisNodeHasError"] = 262144] = "ThisNodeHasError";
        NodeFlags3[NodeFlags3["JavaScriptFile"] = 524288] = "JavaScriptFile";
        NodeFlags3[NodeFlags3["ThisNodeOrAnySubNodesHasError"] = 1048576] = "ThisNodeOrAnySubNodesHasError";
        NodeFlags3[NodeFlags3["HasAggregatedChildData"] = 2097152] = "HasAggregatedChildData";
        NodeFlags3[NodeFlags3["PossiblyContainsDynamicImport"] = 4194304] = "PossiblyContainsDynamicImport";
        NodeFlags3[NodeFlags3["PossiblyContainsImportMeta"] = 8388608] = "PossiblyContainsImportMeta";
        NodeFlags3[NodeFlags3["JSDoc"] = 16777216] = "JSDoc";
        NodeFlags3[NodeFlags3["Ambient"] = 33554432] = "Ambient";
        NodeFlags3[NodeFlags3["InWithStatement"] = 67108864] = "InWithStatement";
        NodeFlags3[NodeFlags3["JsonFile"] = 134217728] = "JsonFile";
        NodeFlags3[NodeFlags3["TypeCached"] = 268435456] = "TypeCached";
        NodeFlags3[NodeFlags3["Deprecated"] = 536870912] = "Deprecated";
        NodeFlags3[NodeFlags3["BlockScoped"] = 7] = "BlockScoped";
        NodeFlags3[NodeFlags3["Constant"] = 6] = "Constant";
        NodeFlags3[NodeFlags3["ReachabilityCheckFlags"] = 1536] = "ReachabilityCheckFlags";
        NodeFlags3[NodeFlags3["ReachabilityAndEmitFlags"] = 5632] = "ReachabilityAndEmitFlags";
        NodeFlags3[NodeFlags3["ContextFlags"] = 101441536] = "ContextFlags";
        NodeFlags3[NodeFlags3["TypeExcludesFlags"] = 81920] = "TypeExcludesFlags";
        NodeFlags3[NodeFlags3["PermanentlySetIncrementalFlags"] = 12582912] = "PermanentlySetIncrementalFlags";
        NodeFlags3[NodeFlags3["IdentifierHasExtendedUnicodeEscape"] = 256 /* ContainsThis */ ] = "IdentifierHasExtendedUnicodeEscape";
        NodeFlags3[NodeFlags3["IdentifierIsInJSDocNamespace"] = 4096 /* HasAsyncFunctions */ ] = "IdentifierIsInJSDocNamespace";
        return NodeFlags3;
    })(NodeFlags || {});
    var ModifierFlags = /* @__PURE__ */ ((ModifierFlags3)=>{
        ModifierFlags3[ModifierFlags3["None"] = 0] = "None";
        ModifierFlags3[ModifierFlags3["Public"] = 1] = "Public";
        ModifierFlags3[ModifierFlags3["Private"] = 2] = "Private";
        ModifierFlags3[ModifierFlags3["Protected"] = 4] = "Protected";
        ModifierFlags3[ModifierFlags3["Readonly"] = 8] = "Readonly";
        ModifierFlags3[ModifierFlags3["Override"] = 16] = "Override";
        ModifierFlags3[ModifierFlags3["Export"] = 32] = "Export";
        ModifierFlags3[ModifierFlags3["Abstract"] = 64] = "Abstract";
        ModifierFlags3[ModifierFlags3["Ambient"] = 128] = "Ambient";
        ModifierFlags3[ModifierFlags3["Static"] = 256] = "Static";
        ModifierFlags3[ModifierFlags3["Accessor"] = 512] = "Accessor";
        ModifierFlags3[ModifierFlags3["Async"] = 1024] = "Async";
        ModifierFlags3[ModifierFlags3["Default"] = 2048] = "Default";
        ModifierFlags3[ModifierFlags3["Const"] = 4096] = "Const";
        ModifierFlags3[ModifierFlags3["In"] = 8192] = "In";
        ModifierFlags3[ModifierFlags3["Out"] = 16384] = "Out";
        ModifierFlags3[ModifierFlags3["Decorator"] = 32768] = "Decorator";
        ModifierFlags3[ModifierFlags3["Deprecated"] = 65536] = "Deprecated";
        ModifierFlags3[ModifierFlags3["JSDocPublic"] = 8388608] = "JSDocPublic";
        ModifierFlags3[ModifierFlags3["JSDocPrivate"] = 16777216] = "JSDocPrivate";
        ModifierFlags3[ModifierFlags3["JSDocProtected"] = 33554432] = "JSDocProtected";
        ModifierFlags3[ModifierFlags3["JSDocReadonly"] = 67108864] = "JSDocReadonly";
        ModifierFlags3[ModifierFlags3["JSDocOverride"] = 134217728] = "JSDocOverride";
        ModifierFlags3[ModifierFlags3["SyntacticOrJSDocModifiers"] = 31] = "SyntacticOrJSDocModifiers";
        ModifierFlags3[ModifierFlags3["SyntacticOnlyModifiers"] = 65504] = "SyntacticOnlyModifiers";
        ModifierFlags3[ModifierFlags3["SyntacticModifiers"] = 65535] = "SyntacticModifiers";
        ModifierFlags3[ModifierFlags3["JSDocCacheOnlyModifiers"] = 260046848] = "JSDocCacheOnlyModifiers";
        ModifierFlags3[ModifierFlags3["JSDocOnlyModifiers"] = 65536 /* Deprecated */ ] = "JSDocOnlyModifiers";
        ModifierFlags3[ModifierFlags3["NonCacheOnlyModifiers"] = 131071] = "NonCacheOnlyModifiers";
        ModifierFlags3[ModifierFlags3["HasComputedJSDocModifiers"] = 268435456] = "HasComputedJSDocModifiers";
        ModifierFlags3[ModifierFlags3["HasComputedFlags"] = 536870912] = "HasComputedFlags";
        ModifierFlags3[ModifierFlags3["AccessibilityModifier"] = 7] = "AccessibilityModifier";
        ModifierFlags3[ModifierFlags3["ParameterPropertyModifier"] = 31] = "ParameterPropertyModifier";
        ModifierFlags3[ModifierFlags3["NonPublicAccessibilityModifier"] = 6] = "NonPublicAccessibilityModifier";
        ModifierFlags3[ModifierFlags3["TypeScriptModifier"] = 28895] = "TypeScriptModifier";
        ModifierFlags3[ModifierFlags3["ExportDefault"] = 2080] = "ExportDefault";
        ModifierFlags3[ModifierFlags3["All"] = 131071] = "All";
        ModifierFlags3[ModifierFlags3["Modifier"] = 98303] = "Modifier";
        return ModifierFlags3;
    })(ModifierFlags || {});
    var JsxFlags = /* @__PURE__ */ ((JsxFlags2)=>{
        JsxFlags2[JsxFlags2["None"] = 0] = "None";
        JsxFlags2[JsxFlags2["IntrinsicNamedElement"] = 1] = "IntrinsicNamedElement";
        JsxFlags2[JsxFlags2["IntrinsicIndexedElement"] = 2] = "IntrinsicIndexedElement";
        JsxFlags2[JsxFlags2["IntrinsicElement"] = 3] = "IntrinsicElement";
        return JsxFlags2;
    })(JsxFlags || {});
    var RelationComparisonResult = /* @__PURE__ */ ((RelationComparisonResult3)=>{
        RelationComparisonResult3[RelationComparisonResult3["None"] = 0] = "None";
        RelationComparisonResult3[RelationComparisonResult3["Succeeded"] = 1] = "Succeeded";
        RelationComparisonResult3[RelationComparisonResult3["Failed"] = 2] = "Failed";
        RelationComparisonResult3[RelationComparisonResult3["ReportsUnmeasurable"] = 8] = "ReportsUnmeasurable";
        RelationComparisonResult3[RelationComparisonResult3["ReportsUnreliable"] = 16] = "ReportsUnreliable";
        RelationComparisonResult3[RelationComparisonResult3["ReportsMask"] = 24] = "ReportsMask";
        RelationComparisonResult3[RelationComparisonResult3["ComplexityOverflow"] = 32] = "ComplexityOverflow";
        RelationComparisonResult3[RelationComparisonResult3["StackDepthOverflow"] = 64] = "StackDepthOverflow";
        RelationComparisonResult3[RelationComparisonResult3["Overflow"] = 96] = "Overflow";
        return RelationComparisonResult3;
    })(RelationComparisonResult || {});
    var PredicateSemantics = /* @__PURE__ */ ((PredicateSemantics2)=>{
        PredicateSemantics2[PredicateSemantics2["None"] = 0] = "None";
        PredicateSemantics2[PredicateSemantics2["Always"] = 1] = "Always";
        PredicateSemantics2[PredicateSemantics2["Never"] = 2] = "Never";
        PredicateSemantics2[PredicateSemantics2["Sometimes"] = 3] = "Sometimes";
        return PredicateSemantics2;
    })(PredicateSemantics || {});
    var GeneratedIdentifierFlags = /* @__PURE__ */ ((GeneratedIdentifierFlags2)=>{
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["None"] = 0] = "None";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Auto"] = 1] = "Auto";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Loop"] = 2] = "Loop";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Unique"] = 3] = "Unique";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Node"] = 4] = "Node";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["KindMask"] = 7] = "KindMask";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["ReservedInNestedScopes"] = 8] = "ReservedInNestedScopes";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["Optimistic"] = 16] = "Optimistic";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["FileLevel"] = 32] = "FileLevel";
        GeneratedIdentifierFlags2[GeneratedIdentifierFlags2["AllowNameSubstitution"] = 64] = "AllowNameSubstitution";
        return GeneratedIdentifierFlags2;
    })(GeneratedIdentifierFlags || {});
    var RegularExpressionFlags = /* @__PURE__ */ ((RegularExpressionFlags2)=>{
        RegularExpressionFlags2[RegularExpressionFlags2["None"] = 0] = "None";
        RegularExpressionFlags2[RegularExpressionFlags2["HasIndices"] = 1] = "HasIndices";
        RegularExpressionFlags2[RegularExpressionFlags2["Global"] = 2] = "Global";
        RegularExpressionFlags2[RegularExpressionFlags2["IgnoreCase"] = 4] = "IgnoreCase";
        RegularExpressionFlags2[RegularExpressionFlags2["Multiline"] = 8] = "Multiline";
        RegularExpressionFlags2[RegularExpressionFlags2["DotAll"] = 16] = "DotAll";
        RegularExpressionFlags2[RegularExpressionFlags2["Unicode"] = 32] = "Unicode";
        RegularExpressionFlags2[RegularExpressionFlags2["UnicodeSets"] = 64] = "UnicodeSets";
        RegularExpressionFlags2[RegularExpressionFlags2["Sticky"] = 128] = "Sticky";
        RegularExpressionFlags2[RegularExpressionFlags2["AnyUnicodeMode"] = 96] = "AnyUnicodeMode";
        RegularExpressionFlags2[RegularExpressionFlags2["Modifiers"] = 28] = "Modifiers";
        return RegularExpressionFlags2;
    })(RegularExpressionFlags || {});
    var TokenFlags = /* @__PURE__ */ ((TokenFlags2)=>{
        TokenFlags2[TokenFlags2["None"] = 0] = "None";
        TokenFlags2[TokenFlags2["PrecedingLineBreak"] = 1] = "PrecedingLineBreak";
        TokenFlags2[TokenFlags2["PrecedingJSDocComment"] = 2] = "PrecedingJSDocComment";
        TokenFlags2[TokenFlags2["Unterminated"] = 4] = "Unterminated";
        TokenFlags2[TokenFlags2["ExtendedUnicodeEscape"] = 8] = "ExtendedUnicodeEscape";
        TokenFlags2[TokenFlags2["Scientific"] = 16] = "Scientific";
        TokenFlags2[TokenFlags2["Octal"] = 32] = "Octal";
        TokenFlags2[TokenFlags2["HexSpecifier"] = 64] = "HexSpecifier";
        TokenFlags2[TokenFlags2["BinarySpecifier"] = 128] = "BinarySpecifier";
        TokenFlags2[TokenFlags2["OctalSpecifier"] = 256] = "OctalSpecifier";
        TokenFlags2[TokenFlags2["ContainsSeparator"] = 512] = "ContainsSeparator";
        TokenFlags2[TokenFlags2["UnicodeEscape"] = 1024] = "UnicodeEscape";
        TokenFlags2[TokenFlags2["ContainsInvalidEscape"] = 2048] = "ContainsInvalidEscape";
        TokenFlags2[TokenFlags2["HexEscape"] = 4096] = "HexEscape";
        TokenFlags2[TokenFlags2["ContainsLeadingZero"] = 8192] = "ContainsLeadingZero";
        TokenFlags2[TokenFlags2["ContainsInvalidSeparator"] = 16384] = "ContainsInvalidSeparator";
        TokenFlags2[TokenFlags2["PrecedingJSDocLeadingAsterisks"] = 32768] = "PrecedingJSDocLeadingAsterisks";
        TokenFlags2[TokenFlags2["BinaryOrOctalSpecifier"] = 384] = "BinaryOrOctalSpecifier";
        TokenFlags2[TokenFlags2["WithSpecifier"] = 448] = "WithSpecifier";
        TokenFlags2[TokenFlags2["StringLiteralFlags"] = 7176] = "StringLiteralFlags";
        TokenFlags2[TokenFlags2["NumericLiteralFlags"] = 25584] = "NumericLiteralFlags";
        TokenFlags2[TokenFlags2["TemplateLiteralLikeFlags"] = 7176] = "TemplateLiteralLikeFlags";
        TokenFlags2[TokenFlags2["IsInvalid"] = 26656] = "IsInvalid";
        return TokenFlags2;
    })(TokenFlags || {});
    var FlowFlags = /* @__PURE__ */ ((FlowFlags2)=>{
        FlowFlags2[FlowFlags2["Unreachable"] = 1] = "Unreachable";
        FlowFlags2[FlowFlags2["Start"] = 2] = "Start";
        FlowFlags2[FlowFlags2["BranchLabel"] = 4] = "BranchLabel";
        FlowFlags2[FlowFlags2["LoopLabel"] = 8] = "LoopLabel";
        FlowFlags2[FlowFlags2["Assignment"] = 16] = "Assignment";
        FlowFlags2[FlowFlags2["TrueCondition"] = 32] = "TrueCondition";
        FlowFlags2[FlowFlags2["FalseCondition"] = 64] = "FalseCondition";
        FlowFlags2[FlowFlags2["SwitchClause"] = 128] = "SwitchClause";
        FlowFlags2[FlowFlags2["ArrayMutation"] = 256] = "ArrayMutation";
        FlowFlags2[FlowFlags2["Call"] = 512] = "Call";
        FlowFlags2[FlowFlags2["ReduceLabel"] = 1024] = "ReduceLabel";
        FlowFlags2[FlowFlags2["Referenced"] = 2048] = "Referenced";
        FlowFlags2[FlowFlags2["Shared"] = 4096] = "Shared";
        FlowFlags2[FlowFlags2["Label"] = 12] = "Label";
        FlowFlags2[FlowFlags2["Condition"] = 96] = "Condition";
        return FlowFlags2;
    })(FlowFlags || {});
    var CommentDirectiveType = /* @__PURE__ */ ((CommentDirectiveType2)=>{
        CommentDirectiveType2[CommentDirectiveType2["ExpectError"] = 0] = "ExpectError";
        CommentDirectiveType2[CommentDirectiveType2["Ignore"] = 1] = "Ignore";
        return CommentDirectiveType2;
    })(CommentDirectiveType || {});
    var OperationCanceledException = class {
    };
    var FileIncludeKind = /* @__PURE__ */ ((FileIncludeKind2)=>{
        FileIncludeKind2[FileIncludeKind2["RootFile"] = 0] = "RootFile";
        FileIncludeKind2[FileIncludeKind2["SourceFromProjectReference"] = 1] = "SourceFromProjectReference";
        FileIncludeKind2[FileIncludeKind2["OutputFromProjectReference"] = 2] = "OutputFromProjectReference";
        FileIncludeKind2[FileIncludeKind2["Import"] = 3] = "Import";
        FileIncludeKind2[FileIncludeKind2["ReferenceFile"] = 4] = "ReferenceFile";
        FileIncludeKind2[FileIncludeKind2["TypeReferenceDirective"] = 5] = "TypeReferenceDirective";
        FileIncludeKind2[FileIncludeKind2["LibFile"] = 6] = "LibFile";
        FileIncludeKind2[FileIncludeKind2["LibReferenceDirective"] = 7] = "LibReferenceDirective";
        FileIncludeKind2[FileIncludeKind2["AutomaticTypeDirectiveFile"] = 8] = "AutomaticTypeDirectiveFile";
        return FileIncludeKind2;
    })(FileIncludeKind || {});
    var FilePreprocessingDiagnosticsKind = /* @__PURE__ */ ((FilePreprocessingDiagnosticsKind2)=>{
        FilePreprocessingDiagnosticsKind2[FilePreprocessingDiagnosticsKind2["FilePreprocessingLibReferenceDiagnostic"] = 0] = "FilePreprocessingLibReferenceDiagnostic";
        FilePreprocessingDiagnosticsKind2[FilePreprocessingDiagnosticsKind2["FilePreprocessingFileExplainingDiagnostic"] = 1] = "FilePreprocessingFileExplainingDiagnostic";
        FilePreprocessingDiagnosticsKind2[FilePreprocessingDiagnosticsKind2["ResolutionDiagnostics"] = 2] = "ResolutionDiagnostics";
        return FilePreprocessingDiagnosticsKind2;
    })(FilePreprocessingDiagnosticsKind || {});
    var EmitOnly = /* @__PURE__ */ ((EmitOnly4)=>{
        EmitOnly4[EmitOnly4["Js"] = 0] = "Js";
        EmitOnly4[EmitOnly4["Dts"] = 1] = "Dts";
        EmitOnly4[EmitOnly4["BuilderSignature"] = 2] = "BuilderSignature";
        return EmitOnly4;
    })(EmitOnly || {});
    var StructureIsReused = /* @__PURE__ */ ((StructureIsReused2)=>{
        StructureIsReused2[StructureIsReused2["Not"] = 0] = "Not";
        StructureIsReused2[StructureIsReused2["SafeModules"] = 1] = "SafeModules";
        StructureIsReused2[StructureIsReused2["Completely"] = 2] = "Completely";
        return StructureIsReused2;
    })(StructureIsReused || {});
    var ExitStatus = /* @__PURE__ */ ((ExitStatus2)=>{
        ExitStatus2[ExitStatus2["Success"] = 0] = "Success";
        ExitStatus2[ExitStatus2["DiagnosticsPresent_OutputsSkipped"] = 1] = "DiagnosticsPresent_OutputsSkipped";
        ExitStatus2[ExitStatus2["DiagnosticsPresent_OutputsGenerated"] = 2] = "DiagnosticsPresent_OutputsGenerated";
        ExitStatus2[ExitStatus2["InvalidProject_OutputsSkipped"] = 3] = "InvalidProject_OutputsSkipped";
        ExitStatus2[ExitStatus2["ProjectReferenceCycle_OutputsSkipped"] = 4] = "ProjectReferenceCycle_OutputsSkipped";
        return ExitStatus2;
    })(ExitStatus || {});
    var MemberOverrideStatus = /* @__PURE__ */ ((MemberOverrideStatus2)=>{
        MemberOverrideStatus2[MemberOverrideStatus2["Ok"] = 0] = "Ok";
        MemberOverrideStatus2[MemberOverrideStatus2["NeedsOverride"] = 1] = "NeedsOverride";
        MemberOverrideStatus2[MemberOverrideStatus2["HasInvalidOverride"] = 2] = "HasInvalidOverride";
        return MemberOverrideStatus2;
    })(MemberOverrideStatus || {});
    var UnionReduction = /* @__PURE__ */ ((UnionReduction2)=>{
        UnionReduction2[UnionReduction2["None"] = 0] = "None";
        UnionReduction2[UnionReduction2["Literal"] = 1] = "Literal";
        UnionReduction2[UnionReduction2["Subtype"] = 2] = "Subtype";
        return UnionReduction2;
    })(UnionReduction || {});
    var IntersectionFlags = /* @__PURE__ */ ((IntersectionFlags2)=>{
        IntersectionFlags2[IntersectionFlags2["None"] = 0] = "None";
        IntersectionFlags2[IntersectionFlags2["NoSupertypeReduction"] = 1] = "NoSupertypeReduction";
        IntersectionFlags2[IntersectionFlags2["NoConstraintReduction"] = 2] = "NoConstraintReduction";
        return IntersectionFlags2;
    })(IntersectionFlags || {});
    var ContextFlags = /* @__PURE__ */ ((ContextFlags3)=>{
        ContextFlags3[ContextFlags3["None"] = 0] = "None";
        ContextFlags3[ContextFlags3["Signature"] = 1] = "Signature";
        ContextFlags3[ContextFlags3["NoConstraints"] = 2] = "NoConstraints";
        ContextFlags3[ContextFlags3["Completions"] = 4] = "Completions";
        ContextFlags3[ContextFlags3["SkipBindingPatterns"] = 8] = "SkipBindingPatterns";
        return ContextFlags3;
    })(ContextFlags || {});
    var NodeBuilderFlags = /* @__PURE__ */ ((NodeBuilderFlags2)=>{
        NodeBuilderFlags2[NodeBuilderFlags2["None"] = 0] = "None";
        NodeBuilderFlags2[NodeBuilderFlags2["NoTruncation"] = 1] = "NoTruncation";
        NodeBuilderFlags2[NodeBuilderFlags2["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
        NodeBuilderFlags2[NodeBuilderFlags2["GenerateNamesForShadowedTypeParams"] = 4] = "GenerateNamesForShadowedTypeParams";
        NodeBuilderFlags2[NodeBuilderFlags2["UseStructuralFallback"] = 8] = "UseStructuralFallback";
        NodeBuilderFlags2[NodeBuilderFlags2["ForbidIndexedAccessSymbolReferences"] = 16] = "ForbidIndexedAccessSymbolReferences";
        NodeBuilderFlags2[NodeBuilderFlags2["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
        NodeBuilderFlags2[NodeBuilderFlags2["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
        NodeBuilderFlags2[NodeBuilderFlags2["UseOnlyExternalAliasing"] = 128] = "UseOnlyExternalAliasing";
        NodeBuilderFlags2[NodeBuilderFlags2["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
        NodeBuilderFlags2[NodeBuilderFlags2["WriteTypeParametersInQualifiedName"] = 512] = "WriteTypeParametersInQualifiedName";
        NodeBuilderFlags2[NodeBuilderFlags2["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
        NodeBuilderFlags2[NodeBuilderFlags2["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
        NodeBuilderFlags2[NodeBuilderFlags2["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
        NodeBuilderFlags2[NodeBuilderFlags2["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
        NodeBuilderFlags2[NodeBuilderFlags2["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
        NodeBuilderFlags2[NodeBuilderFlags2["UseSingleQuotesForStringLiteralType"] = 268435456] = "UseSingleQuotesForStringLiteralType";
        NodeBuilderFlags2[NodeBuilderFlags2["NoTypeReduction"] = 536870912] = "NoTypeReduction";
        NodeBuilderFlags2[NodeBuilderFlags2["OmitThisParameter"] = 33554432] = "OmitThisParameter";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowThisInObjectLiteral"] = 32768] = "AllowThisInObjectLiteral";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowQualifiedNameInPlaceOfIdentifier"] = 65536] = "AllowQualifiedNameInPlaceOfIdentifier";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowAnonymousIdentifier"] = 131072] = "AllowAnonymousIdentifier";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowEmptyUnionOrIntersection"] = 262144] = "AllowEmptyUnionOrIntersection";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowEmptyTuple"] = 524288] = "AllowEmptyTuple";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowEmptyIndexInfoType"] = 2097152] = "AllowEmptyIndexInfoType";
        NodeBuilderFlags2[NodeBuilderFlags2["AllowNodeModulesRelativePaths"] = 67108864] = "AllowNodeModulesRelativePaths";
        NodeBuilderFlags2[NodeBuilderFlags2["IgnoreErrors"] = 70221824] = "IgnoreErrors";
        NodeBuilderFlags2[NodeBuilderFlags2["InObjectTypeLiteral"] = 4194304] = "InObjectTypeLiteral";
        NodeBuilderFlags2[NodeBuilderFlags2["InTypeAlias"] = 8388608] = "InTypeAlias";
        NodeBuilderFlags2[NodeBuilderFlags2["InInitialEntityName"] = 16777216] = "InInitialEntityName";
        return NodeBuilderFlags2;
    })(NodeBuilderFlags || {});
    var InternalNodeBuilderFlags = /* @__PURE__ */ ((InternalNodeBuilderFlags2)=>{
        InternalNodeBuilderFlags2[InternalNodeBuilderFlags2["None"] = 0] = "None";
        InternalNodeBuilderFlags2[InternalNodeBuilderFlags2["WriteComputedProps"] = 1] = "WriteComputedProps";
        InternalNodeBuilderFlags2[InternalNodeBuilderFlags2["NoSyntacticPrinter"] = 2] = "NoSyntacticPrinter";
        InternalNodeBuilderFlags2[InternalNodeBuilderFlags2["DoNotIncludeSymbolChain"] = 4] = "DoNotIncludeSymbolChain";
        InternalNodeBuilderFlags2[InternalNodeBuilderFlags2["AllowUnresolvedNames"] = 8] = "AllowUnresolvedNames";
        return InternalNodeBuilderFlags2;
    })(InternalNodeBuilderFlags || {});
    var TypeFormatFlags = /* @__PURE__ */ ((TypeFormatFlags2)=>{
        TypeFormatFlags2[TypeFormatFlags2["None"] = 0] = "None";
        TypeFormatFlags2[TypeFormatFlags2["NoTruncation"] = 1] = "NoTruncation";
        TypeFormatFlags2[TypeFormatFlags2["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
        TypeFormatFlags2[TypeFormatFlags2["GenerateNamesForShadowedTypeParams"] = 4] = "GenerateNamesForShadowedTypeParams";
        TypeFormatFlags2[TypeFormatFlags2["UseStructuralFallback"] = 8] = "UseStructuralFallback";
        TypeFormatFlags2[TypeFormatFlags2["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
        TypeFormatFlags2[TypeFormatFlags2["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
        TypeFormatFlags2[TypeFormatFlags2["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
        TypeFormatFlags2[TypeFormatFlags2["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
        TypeFormatFlags2[TypeFormatFlags2["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
        TypeFormatFlags2[TypeFormatFlags2["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
        TypeFormatFlags2[TypeFormatFlags2["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
        TypeFormatFlags2[TypeFormatFlags2["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
        TypeFormatFlags2[TypeFormatFlags2["UseSingleQuotesForStringLiteralType"] = 268435456] = "UseSingleQuotesForStringLiteralType";
        TypeFormatFlags2[TypeFormatFlags2["NoTypeReduction"] = 536870912] = "NoTypeReduction";
        TypeFormatFlags2[TypeFormatFlags2["OmitThisParameter"] = 33554432] = "OmitThisParameter";
        TypeFormatFlags2[TypeFormatFlags2["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
        TypeFormatFlags2[TypeFormatFlags2["AddUndefined"] = 131072] = "AddUndefined";
        TypeFormatFlags2[TypeFormatFlags2["WriteArrowStyleSignature"] = 262144] = "WriteArrowStyleSignature";
        TypeFormatFlags2[TypeFormatFlags2["InArrayType"] = 524288] = "InArrayType";
        TypeFormatFlags2[TypeFormatFlags2["InElementType"] = 2097152] = "InElementType";
        TypeFormatFlags2[TypeFormatFlags2["InFirstTypeArgument"] = 4194304] = "InFirstTypeArgument";
        TypeFormatFlags2[TypeFormatFlags2["InTypeAlias"] = 8388608] = "InTypeAlias";
        TypeFormatFlags2[TypeFormatFlags2["NodeBuilderFlagsMask"] = 848330095] = "NodeBuilderFlagsMask";
        return TypeFormatFlags2;
    })(TypeFormatFlags || {});
    var SymbolFormatFlags = /* @__PURE__ */ ((SymbolFormatFlags2)=>{
        SymbolFormatFlags2[SymbolFormatFlags2["None"] = 0] = "None";
        SymbolFormatFlags2[SymbolFormatFlags2["WriteTypeParametersOrArguments"] = 1] = "WriteTypeParametersOrArguments";
        SymbolFormatFlags2[SymbolFormatFlags2["UseOnlyExternalAliasing"] = 2] = "UseOnlyExternalAliasing";
        SymbolFormatFlags2[SymbolFormatFlags2["AllowAnyNodeKind"] = 4] = "AllowAnyNodeKind";
        SymbolFormatFlags2[SymbolFormatFlags2["UseAliasDefinedOutsideCurrentScope"] = 8] = "UseAliasDefinedOutsideCurrentScope";
        SymbolFormatFlags2[SymbolFormatFlags2["WriteComputedProps"] = 16] = "WriteComputedProps";
        SymbolFormatFlags2[SymbolFormatFlags2["DoNotIncludeSymbolChain"] = 32] = "DoNotIncludeSymbolChain";
        return SymbolFormatFlags2;
    })(SymbolFormatFlags || {});
    var SymbolAccessibility = /* @__PURE__ */ ((SymbolAccessibility2)=>{
        SymbolAccessibility2[SymbolAccessibility2["Accessible"] = 0] = "Accessible";
        SymbolAccessibility2[SymbolAccessibility2["NotAccessible"] = 1] = "NotAccessible";
        SymbolAccessibility2[SymbolAccessibility2["CannotBeNamed"] = 2] = "CannotBeNamed";
        SymbolAccessibility2[SymbolAccessibility2["NotResolved"] = 3] = "NotResolved";
        return SymbolAccessibility2;
    })(SymbolAccessibility || {});
    var TypePredicateKind = /* @__PURE__ */ ((TypePredicateKind2)=>{
        TypePredicateKind2[TypePredicateKind2["This"] = 0] = "This";
        TypePredicateKind2[TypePredicateKind2["Identifier"] = 1] = "Identifier";
        TypePredicateKind2[TypePredicateKind2["AssertsThis"] = 2] = "AssertsThis";
        TypePredicateKind2[TypePredicateKind2["AssertsIdentifier"] = 3] = "AssertsIdentifier";
        return TypePredicateKind2;
    })(TypePredicateKind || {});
    var TypeReferenceSerializationKind = /* @__PURE__ */ ((TypeReferenceSerializationKind2)=>{
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["Unknown"] = 0] = "Unknown";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["TypeWithConstructSignatureAndValue"] = 1] = "TypeWithConstructSignatureAndValue";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["VoidNullableOrNeverType"] = 2] = "VoidNullableOrNeverType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["NumberLikeType"] = 3] = "NumberLikeType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["BigIntLikeType"] = 4] = "BigIntLikeType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["StringLikeType"] = 5] = "StringLikeType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["BooleanType"] = 6] = "BooleanType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["ArrayLikeType"] = 7] = "ArrayLikeType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["ESSymbolType"] = 8] = "ESSymbolType";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["Promise"] = 9] = "Promise";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["TypeWithCallSignature"] = 10] = "TypeWithCallSignature";
        TypeReferenceSerializationKind2[TypeReferenceSerializationKind2["ObjectType"] = 11] = "ObjectType";
        return TypeReferenceSerializationKind2;
    })(TypeReferenceSerializationKind || {});
    var SymbolFlags = /* @__PURE__ */ ((SymbolFlags3)=>{
        SymbolFlags3[SymbolFlags3["None"] = 0] = "None";
        SymbolFlags3[SymbolFlags3["FunctionScopedVariable"] = 1] = "FunctionScopedVariable";
        SymbolFlags3[SymbolFlags3["BlockScopedVariable"] = 2] = "BlockScopedVariable";
        SymbolFlags3[SymbolFlags3["Property"] = 4] = "Property";
        SymbolFlags3[SymbolFlags3["EnumMember"] = 8] = "EnumMember";
        SymbolFlags3[SymbolFlags3["Function"] = 16] = "Function";
        SymbolFlags3[SymbolFlags3["Class"] = 32] = "Class";
        SymbolFlags3[SymbolFlags3["Interface"] = 64] = "Interface";
        SymbolFlags3[SymbolFlags3["ConstEnum"] = 128] = "ConstEnum";
        SymbolFlags3[SymbolFlags3["RegularEnum"] = 256] = "RegularEnum";
        SymbolFlags3[SymbolFlags3["ValueModule"] = 512] = "ValueModule";
        SymbolFlags3[SymbolFlags3["NamespaceModule"] = 1024] = "NamespaceModule";
        SymbolFlags3[SymbolFlags3["TypeLiteral"] = 2048] = "TypeLiteral";
        SymbolFlags3[SymbolFlags3["ObjectLiteral"] = 4096] = "ObjectLiteral";
        SymbolFlags3[SymbolFlags3["Method"] = 8192] = "Method";
        SymbolFlags3[SymbolFlags3["Constructor"] = 16384] = "Constructor";
        SymbolFlags3[SymbolFlags3["GetAccessor"] = 32768] = "GetAccessor";
        SymbolFlags3[SymbolFlags3["SetAccessor"] = 65536] = "SetAccessor";
        SymbolFlags3[SymbolFlags3["Signature"] = 131072] = "Signature";
        SymbolFlags3[SymbolFlags3["TypeParameter"] = 262144] = "TypeParameter";
        SymbolFlags3[SymbolFlags3["TypeAlias"] = 524288] = "TypeAlias";
        SymbolFlags3[SymbolFlags3["ExportValue"] = 1048576] = "ExportValue";
        SymbolFlags3[SymbolFlags3["Alias"] = 2097152] = "Alias";
        SymbolFlags3[SymbolFlags3["Prototype"] = 4194304] = "Prototype";
        SymbolFlags3[SymbolFlags3["ExportStar"] = 8388608] = "ExportStar";
        SymbolFlags3[SymbolFlags3["Optional"] = 16777216] = "Optional";
        SymbolFlags3[SymbolFlags3["Transient"] = 33554432] = "Transient";
        SymbolFlags3[SymbolFlags3["Assignment"] = 67108864] = "Assignment";
        SymbolFlags3[SymbolFlags3["ModuleExports"] = 134217728] = "ModuleExports";
        SymbolFlags3[SymbolFlags3["All"] = -1] = "All";
        SymbolFlags3[SymbolFlags3["Enum"] = 384] = "Enum";
        SymbolFlags3[SymbolFlags3["Variable"] = 3] = "Variable";
        SymbolFlags3[SymbolFlags3["Value"] = 111551] = "Value";
        SymbolFlags3[SymbolFlags3["Type"] = 788968] = "Type";
        SymbolFlags3[SymbolFlags3["Namespace"] = 1920] = "Namespace";
        SymbolFlags3[SymbolFlags3["Module"] = 1536] = "Module";
        SymbolFlags3[SymbolFlags3["Accessor"] = 98304] = "Accessor";
        SymbolFlags3[SymbolFlags3["FunctionScopedVariableExcludes"] = 111550] = "FunctionScopedVariableExcludes";
        SymbolFlags3[SymbolFlags3["BlockScopedVariableExcludes"] = 111551 /* Value */ ] = "BlockScopedVariableExcludes";
        SymbolFlags3[SymbolFlags3["ParameterExcludes"] = 111551 /* Value */ ] = "ParameterExcludes";
        SymbolFlags3[SymbolFlags3["PropertyExcludes"] = 0 /* None */ ] = "PropertyExcludes";
        SymbolFlags3[SymbolFlags3["EnumMemberExcludes"] = 900095] = "EnumMemberExcludes";
        SymbolFlags3[SymbolFlags3["FunctionExcludes"] = 110991] = "FunctionExcludes";
        SymbolFlags3[SymbolFlags3["ClassExcludes"] = 899503] = "ClassExcludes";
        SymbolFlags3[SymbolFlags3["InterfaceExcludes"] = 788872] = "InterfaceExcludes";
        SymbolFlags3[SymbolFlags3["RegularEnumExcludes"] = 899327] = "RegularEnumExcludes";
        SymbolFlags3[SymbolFlags3["ConstEnumExcludes"] = 899967] = "ConstEnumExcludes";
        SymbolFlags3[SymbolFlags3["ValueModuleExcludes"] = 110735] = "ValueModuleExcludes";
        SymbolFlags3[SymbolFlags3["NamespaceModuleExcludes"] = 0] = "NamespaceModuleExcludes";
        SymbolFlags3[SymbolFlags3["MethodExcludes"] = 103359] = "MethodExcludes";
        SymbolFlags3[SymbolFlags3["GetAccessorExcludes"] = 46015] = "GetAccessorExcludes";
        SymbolFlags3[SymbolFlags3["SetAccessorExcludes"] = 78783] = "SetAccessorExcludes";
        SymbolFlags3[SymbolFlags3["AccessorExcludes"] = 13247] = "AccessorExcludes";
        SymbolFlags3[SymbolFlags3["TypeParameterExcludes"] = 526824] = "TypeParameterExcludes";
        SymbolFlags3[SymbolFlags3["TypeAliasExcludes"] = 788968 /* Type */ ] = "TypeAliasExcludes";
        SymbolFlags3[SymbolFlags3["AliasExcludes"] = 2097152 /* Alias */ ] = "AliasExcludes";
        SymbolFlags3[SymbolFlags3["ModuleMember"] = 2623475] = "ModuleMember";
        SymbolFlags3[SymbolFlags3["ExportHasLocal"] = 944] = "ExportHasLocal";
        SymbolFlags3[SymbolFlags3["BlockScoped"] = 418] = "BlockScoped";
        SymbolFlags3[SymbolFlags3["PropertyOrAccessor"] = 98308] = "PropertyOrAccessor";
        SymbolFlags3[SymbolFlags3["ClassMember"] = 106500] = "ClassMember";
        SymbolFlags3[SymbolFlags3["ExportSupportsDefaultModifier"] = 112] = "ExportSupportsDefaultModifier";
        SymbolFlags3[SymbolFlags3["ExportDoesNotSupportDefaultModifier"] = -113] = "ExportDoesNotSupportDefaultModifier";
        SymbolFlags3[SymbolFlags3["Classifiable"] = 2885600] = "Classifiable";
        SymbolFlags3[SymbolFlags3["LateBindingContainer"] = 6256] = "LateBindingContainer";
        return SymbolFlags3;
    })(SymbolFlags || {});
    var CheckFlags = /* @__PURE__ */ ((CheckFlags2)=>{
        CheckFlags2[CheckFlags2["None"] = 0] = "None";
        CheckFlags2[CheckFlags2["Instantiated"] = 1] = "Instantiated";
        CheckFlags2[CheckFlags2["SyntheticProperty"] = 2] = "SyntheticProperty";
        CheckFlags2[CheckFlags2["SyntheticMethod"] = 4] = "SyntheticMethod";
        CheckFlags2[CheckFlags2["Readonly"] = 8] = "Readonly";
        CheckFlags2[CheckFlags2["ReadPartial"] = 16] = "ReadPartial";
        CheckFlags2[CheckFlags2["WritePartial"] = 32] = "WritePartial";
        CheckFlags2[CheckFlags2["HasNonUniformType"] = 64] = "HasNonUniformType";
        CheckFlags2[CheckFlags2["HasLiteralType"] = 128] = "HasLiteralType";
        CheckFlags2[CheckFlags2["ContainsPublic"] = 256] = "ContainsPublic";
        CheckFlags2[CheckFlags2["ContainsProtected"] = 512] = "ContainsProtected";
        CheckFlags2[CheckFlags2["ContainsPrivate"] = 1024] = "ContainsPrivate";
        CheckFlags2[CheckFlags2["ContainsStatic"] = 2048] = "ContainsStatic";
        CheckFlags2[CheckFlags2["Late"] = 4096] = "Late";
        CheckFlags2[CheckFlags2["ReverseMapped"] = 8192] = "ReverseMapped";
        CheckFlags2[CheckFlags2["OptionalParameter"] = 16384] = "OptionalParameter";
        CheckFlags2[CheckFlags2["RestParameter"] = 32768] = "RestParameter";
        CheckFlags2[CheckFlags2["DeferredType"] = 65536] = "DeferredType";
        CheckFlags2[CheckFlags2["HasNeverType"] = 131072] = "HasNeverType";
        CheckFlags2[CheckFlags2["Mapped"] = 262144] = "Mapped";
        CheckFlags2[CheckFlags2["StripOptional"] = 524288] = "StripOptional";
        CheckFlags2[CheckFlags2["Unresolved"] = 1048576] = "Unresolved";
        CheckFlags2[CheckFlags2["Synthetic"] = 6] = "Synthetic";
        CheckFlags2[CheckFlags2["Discriminant"] = 192] = "Discriminant";
        CheckFlags2[CheckFlags2["Partial"] = 48] = "Partial";
        return CheckFlags2;
    })(CheckFlags || {});
    var InternalSymbolName = /* @__PURE__ */ ((InternalSymbolName2)=>{
        InternalSymbolName2["Call"] = "__call";
        InternalSymbolName2["Constructor"] = "__constructor";
        InternalSymbolName2["New"] = "__new";
        InternalSymbolName2["Index"] = "__index";
        InternalSymbolName2["ExportStar"] = "__export";
        InternalSymbolName2["Global"] = "__global";
        InternalSymbolName2["Missing"] = "__missing";
        InternalSymbolName2["Type"] = "__type";
        InternalSymbolName2["Object"] = "__object";
        InternalSymbolName2["JSXAttributes"] = "__jsxAttributes";
        InternalSymbolName2["Class"] = "__class";
        InternalSymbolName2["Function"] = "__function";
        InternalSymbolName2["Computed"] = "__computed";
        InternalSymbolName2["Resolving"] = "__resolving__";
        InternalSymbolName2["ExportEquals"] = "export=";
        InternalSymbolName2["Default"] = "default";
        InternalSymbolName2["This"] = "this";
        InternalSymbolName2["InstantiationExpression"] = "__instantiationExpression";
        InternalSymbolName2["ImportAttributes"] = "__importAttributes";
        return InternalSymbolName2;
    })(InternalSymbolName || {});
    var NodeCheckFlags = /* @__PURE__ */ ((NodeCheckFlags3)=>{
        NodeCheckFlags3[NodeCheckFlags3["None"] = 0] = "None";
        NodeCheckFlags3[NodeCheckFlags3["TypeChecked"] = 1] = "TypeChecked";
        NodeCheckFlags3[NodeCheckFlags3["LexicalThis"] = 2] = "LexicalThis";
        NodeCheckFlags3[NodeCheckFlags3["CaptureThis"] = 4] = "CaptureThis";
        NodeCheckFlags3[NodeCheckFlags3["CaptureNewTarget"] = 8] = "CaptureNewTarget";
        NodeCheckFlags3[NodeCheckFlags3["SuperInstance"] = 16] = "SuperInstance";
        NodeCheckFlags3[NodeCheckFlags3["SuperStatic"] = 32] = "SuperStatic";
        NodeCheckFlags3[NodeCheckFlags3["ContextChecked"] = 64] = "ContextChecked";
        NodeCheckFlags3[NodeCheckFlags3["MethodWithSuperPropertyAccessInAsync"] = 128] = "MethodWithSuperPropertyAccessInAsync";
        NodeCheckFlags3[NodeCheckFlags3["MethodWithSuperPropertyAssignmentInAsync"] = 256] = "MethodWithSuperPropertyAssignmentInAsync";
        NodeCheckFlags3[NodeCheckFlags3["CaptureArguments"] = 512] = "CaptureArguments";
        NodeCheckFlags3[NodeCheckFlags3["EnumValuesComputed"] = 1024] = "EnumValuesComputed";
        NodeCheckFlags3[NodeCheckFlags3["LexicalModuleMergesWithClass"] = 2048] = "LexicalModuleMergesWithClass";
        NodeCheckFlags3[NodeCheckFlags3["LoopWithCapturedBlockScopedBinding"] = 4096] = "LoopWithCapturedBlockScopedBinding";
        NodeCheckFlags3[NodeCheckFlags3["ContainsCapturedBlockScopeBinding"] = 8192] = "ContainsCapturedBlockScopeBinding";
        NodeCheckFlags3[NodeCheckFlags3["CapturedBlockScopedBinding"] = 16384] = "CapturedBlockScopedBinding";
        NodeCheckFlags3[NodeCheckFlags3["BlockScopedBindingInLoop"] = 32768] = "BlockScopedBindingInLoop";
        NodeCheckFlags3[NodeCheckFlags3["NeedsLoopOutParameter"] = 65536] = "NeedsLoopOutParameter";
        NodeCheckFlags3[NodeCheckFlags3["AssignmentsMarked"] = 131072] = "AssignmentsMarked";
        NodeCheckFlags3[NodeCheckFlags3["ContainsConstructorReference"] = 262144] = "ContainsConstructorReference";
        NodeCheckFlags3[NodeCheckFlags3["ConstructorReference"] = 536870912] = "ConstructorReference";
        NodeCheckFlags3[NodeCheckFlags3["ContainsClassWithPrivateIdentifiers"] = 1048576] = "ContainsClassWithPrivateIdentifiers";
        NodeCheckFlags3[NodeCheckFlags3["ContainsSuperPropertyInStaticInitializer"] = 2097152] = "ContainsSuperPropertyInStaticInitializer";
        NodeCheckFlags3[NodeCheckFlags3["InCheckIdentifier"] = 4194304] = "InCheckIdentifier";
        NodeCheckFlags3[NodeCheckFlags3["PartiallyTypeChecked"] = 8388608] = "PartiallyTypeChecked";
        NodeCheckFlags3[NodeCheckFlags3["LazyFlags"] = 539358128] = "LazyFlags";
        return NodeCheckFlags3;
    })(NodeCheckFlags || {});
    var TypeFlags = /* @__PURE__ */ ((TypeFlags2)=>{
        TypeFlags2[TypeFlags2["Any"] = 1] = "Any";
        TypeFlags2[TypeFlags2["Unknown"] = 2] = "Unknown";
        TypeFlags2[TypeFlags2["String"] = 4] = "String";
        TypeFlags2[TypeFlags2["Number"] = 8] = "Number";
        TypeFlags2[TypeFlags2["Boolean"] = 16] = "Boolean";
        TypeFlags2[TypeFlags2["Enum"] = 32] = "Enum";
        TypeFlags2[TypeFlags2["BigInt"] = 64] = "BigInt";
        TypeFlags2[TypeFlags2["StringLiteral"] = 128] = "StringLiteral";
        TypeFlags2[TypeFlags2["NumberLiteral"] = 256] = "NumberLiteral";
        TypeFlags2[TypeFlags2["BooleanLiteral"] = 512] = "BooleanLiteral";
        TypeFlags2[TypeFlags2["EnumLiteral"] = 1024] = "EnumLiteral";
        TypeFlags2[TypeFlags2["BigIntLiteral"] = 2048] = "BigIntLiteral";
        TypeFlags2[TypeFlags2["ESSymbol"] = 4096] = "ESSymbol";
        TypeFlags2[TypeFlags2["UniqueESSymbol"] = 8192] = "UniqueESSymbol";
        TypeFlags2[TypeFlags2["Void"] = 16384] = "Void";
        TypeFlags2[TypeFlags2["Undefined"] = 32768] = "Undefined";
        TypeFlags2[TypeFlags2["Null"] = 65536] = "Null";
        TypeFlags2[TypeFlags2["Never"] = 131072] = "Never";
        TypeFlags2[TypeFlags2["TypeParameter"] = 262144] = "TypeParameter";
        TypeFlags2[TypeFlags2["Object"] = 524288] = "Object";
        TypeFlags2[TypeFlags2["Union"] = 1048576] = "Union";
        TypeFlags2[TypeFlags2["Intersection"] = 2097152] = "Intersection";
        TypeFlags2[TypeFlags2["Index"] = 4194304] = "Index";
        TypeFlags2[TypeFlags2["IndexedAccess"] = 8388608] = "IndexedAccess";
        TypeFlags2[TypeFlags2["Conditional"] = 16777216] = "Conditional";
        TypeFlags2[TypeFlags2["Substitution"] = 33554432] = "Substitution";
        TypeFlags2[TypeFlags2["NonPrimitive"] = 67108864] = "NonPrimitive";
        TypeFlags2[TypeFlags2["TemplateLiteral"] = 134217728] = "TemplateLiteral";
        TypeFlags2[TypeFlags2["StringMapping"] = 268435456] = "StringMapping";
        TypeFlags2[TypeFlags2["Reserved1"] = 536870912] = "Reserved1";
        TypeFlags2[TypeFlags2["Reserved2"] = 1073741824] = "Reserved2";
        TypeFlags2[TypeFlags2["AnyOrUnknown"] = 3] = "AnyOrUnknown";
        TypeFlags2[TypeFlags2["Nullable"] = 98304] = "Nullable";
        TypeFlags2[TypeFlags2["Literal"] = 2944] = "Literal";
        TypeFlags2[TypeFlags2["Unit"] = 109472] = "Unit";
        TypeFlags2[TypeFlags2["Freshable"] = 2976] = "Freshable";
        TypeFlags2[TypeFlags2["StringOrNumberLiteral"] = 384] = "StringOrNumberLiteral";
        TypeFlags2[TypeFlags2["StringOrNumberLiteralOrUnique"] = 8576] = "StringOrNumberLiteralOrUnique";
        TypeFlags2[TypeFlags2["DefinitelyFalsy"] = 117632] = "DefinitelyFalsy";
        TypeFlags2[TypeFlags2["PossiblyFalsy"] = 117724] = "PossiblyFalsy";
        TypeFlags2[TypeFlags2["Intrinsic"] = 67359327] = "Intrinsic";
        TypeFlags2[TypeFlags2["StringLike"] = 402653316] = "StringLike";
        TypeFlags2[TypeFlags2["NumberLike"] = 296] = "NumberLike";
        TypeFlags2[TypeFlags2["BigIntLike"] = 2112] = "BigIntLike";
        TypeFlags2[TypeFlags2["BooleanLike"] = 528] = "BooleanLike";
        TypeFlags2[TypeFlags2["EnumLike"] = 1056] = "EnumLike";
        TypeFlags2[TypeFlags2["ESSymbolLike"] = 12288] = "ESSymbolLike";
        TypeFlags2[TypeFlags2["VoidLike"] = 49152] = "VoidLike";
        TypeFlags2[TypeFlags2["Primitive"] = 402784252] = "Primitive";
        TypeFlags2[TypeFlags2["DefinitelyNonNullable"] = 470302716] = "DefinitelyNonNullable";
        TypeFlags2[TypeFlags2["DisjointDomains"] = 469892092] = "DisjointDomains";
        TypeFlags2[TypeFlags2["UnionOrIntersection"] = 3145728] = "UnionOrIntersection";
        TypeFlags2[TypeFlags2["StructuredType"] = 3670016] = "StructuredType";
        TypeFlags2[TypeFlags2["TypeVariable"] = 8650752] = "TypeVariable";
        TypeFlags2[TypeFlags2["InstantiableNonPrimitive"] = 58982400] = "InstantiableNonPrimitive";
        TypeFlags2[TypeFlags2["InstantiablePrimitive"] = 406847488] = "InstantiablePrimitive";
        TypeFlags2[TypeFlags2["Instantiable"] = 465829888] = "Instantiable";
        TypeFlags2[TypeFlags2["StructuredOrInstantiable"] = 469499904] = "StructuredOrInstantiable";
        TypeFlags2[TypeFlags2["ObjectFlagsType"] = 3899393] = "ObjectFlagsType";
        TypeFlags2[TypeFlags2["Simplifiable"] = 25165824] = "Simplifiable";
        TypeFlags2[TypeFlags2["Singleton"] = 67358815] = "Singleton";
        TypeFlags2[TypeFlags2["Narrowable"] = 536624127] = "Narrowable";
        TypeFlags2[TypeFlags2["IncludesMask"] = 473694207] = "IncludesMask";
        TypeFlags2[TypeFlags2["IncludesMissingType"] = 262144 /* TypeParameter */ ] = "IncludesMissingType";
        TypeFlags2[TypeFlags2["IncludesNonWideningType"] = 4194304 /* Index */ ] = "IncludesNonWideningType";
        TypeFlags2[TypeFlags2["IncludesWildcard"] = 8388608 /* IndexedAccess */ ] = "IncludesWildcard";
        TypeFlags2[TypeFlags2["IncludesEmptyObject"] = 16777216 /* Conditional */ ] = "IncludesEmptyObject";
        TypeFlags2[TypeFlags2["IncludesInstantiable"] = 33554432 /* Substitution */ ] = "IncludesInstantiable";
        TypeFlags2[TypeFlags2["IncludesConstrainedTypeVariable"] = 536870912 /* Reserved1 */ ] = "IncludesConstrainedTypeVariable";
        TypeFlags2[TypeFlags2["IncludesError"] = 1073741824 /* Reserved2 */ ] = "IncludesError";
        TypeFlags2[TypeFlags2["NotPrimitiveUnion"] = 36323331] = "NotPrimitiveUnion";
        return TypeFlags2;
    })(TypeFlags || {});
    var ObjectFlags = /* @__PURE__ */ ((ObjectFlags3)=>{
        ObjectFlags3[ObjectFlags3["None"] = 0] = "None";
        ObjectFlags3[ObjectFlags3["Class"] = 1] = "Class";
        ObjectFlags3[ObjectFlags3["Interface"] = 2] = "Interface";
        ObjectFlags3[ObjectFlags3["Reference"] = 4] = "Reference";
        ObjectFlags3[ObjectFlags3["Tuple"] = 8] = "Tuple";
        ObjectFlags3[ObjectFlags3["Anonymous"] = 16] = "Anonymous";
        ObjectFlags3[ObjectFlags3["Mapped"] = 32] = "Mapped";
        ObjectFlags3[ObjectFlags3["Instantiated"] = 64] = "Instantiated";
        ObjectFlags3[ObjectFlags3["ObjectLiteral"] = 128] = "ObjectLiteral";
        ObjectFlags3[ObjectFlags3["EvolvingArray"] = 256] = "EvolvingArray";
        ObjectFlags3[ObjectFlags3["ObjectLiteralPatternWithComputedProperties"] = 512] = "ObjectLiteralPatternWithComputedProperties";
        ObjectFlags3[ObjectFlags3["ReverseMapped"] = 1024] = "ReverseMapped";
        ObjectFlags3[ObjectFlags3["JsxAttributes"] = 2048] = "JsxAttributes";
        ObjectFlags3[ObjectFlags3["JSLiteral"] = 4096] = "JSLiteral";
        ObjectFlags3[ObjectFlags3["FreshLiteral"] = 8192] = "FreshLiteral";
        ObjectFlags3[ObjectFlags3["ArrayLiteral"] = 16384] = "ArrayLiteral";
        ObjectFlags3[ObjectFlags3["PrimitiveUnion"] = 32768] = "PrimitiveUnion";
        ObjectFlags3[ObjectFlags3["ContainsWideningType"] = 65536] = "ContainsWideningType";
        ObjectFlags3[ObjectFlags3["ContainsObjectOrArrayLiteral"] = 131072] = "ContainsObjectOrArrayLiteral";
        ObjectFlags3[ObjectFlags3["NonInferrableType"] = 262144] = "NonInferrableType";
        ObjectFlags3[ObjectFlags3["CouldContainTypeVariablesComputed"] = 524288] = "CouldContainTypeVariablesComputed";
        ObjectFlags3[ObjectFlags3["CouldContainTypeVariables"] = 1048576] = "CouldContainTypeVariables";
        ObjectFlags3[ObjectFlags3["SingleSignatureType"] = 134217728] = "SingleSignatureType";
        ObjectFlags3[ObjectFlags3["ClassOrInterface"] = 3] = "ClassOrInterface";
        ObjectFlags3[ObjectFlags3["RequiresWidening"] = 196608] = "RequiresWidening";
        ObjectFlags3[ObjectFlags3["PropagatingFlags"] = 458752] = "PropagatingFlags";
        ObjectFlags3[ObjectFlags3["InstantiatedMapped"] = 96] = "InstantiatedMapped";
        ObjectFlags3[ObjectFlags3["ObjectTypeKindMask"] = 1343] = "ObjectTypeKindMask";
        ObjectFlags3[ObjectFlags3["ContainsSpread"] = 2097152] = "ContainsSpread";
        ObjectFlags3[ObjectFlags3["ObjectRestType"] = 4194304] = "ObjectRestType";
        ObjectFlags3[ObjectFlags3["InstantiationExpressionType"] = 8388608] = "InstantiationExpressionType";
        ObjectFlags3[ObjectFlags3["IsClassInstanceClone"] = 16777216] = "IsClassInstanceClone";
        ObjectFlags3[ObjectFlags3["IdenticalBaseTypeCalculated"] = 33554432] = "IdenticalBaseTypeCalculated";
        ObjectFlags3[ObjectFlags3["IdenticalBaseTypeExists"] = 67108864] = "IdenticalBaseTypeExists";
        ObjectFlags3[ObjectFlags3["IsGenericTypeComputed"] = 2097152] = "IsGenericTypeComputed";
        ObjectFlags3[ObjectFlags3["IsGenericObjectType"] = 4194304] = "IsGenericObjectType";
        ObjectFlags3[ObjectFlags3["IsGenericIndexType"] = 8388608] = "IsGenericIndexType";
        ObjectFlags3[ObjectFlags3["IsGenericType"] = 12582912] = "IsGenericType";
        ObjectFlags3[ObjectFlags3["ContainsIntersections"] = 16777216] = "ContainsIntersections";
        ObjectFlags3[ObjectFlags3["IsUnknownLikeUnionComputed"] = 33554432] = "IsUnknownLikeUnionComputed";
        ObjectFlags3[ObjectFlags3["IsUnknownLikeUnion"] = 67108864] = "IsUnknownLikeUnion";
        ObjectFlags3[ObjectFlags3["IsNeverIntersectionComputed"] = 16777216] = "IsNeverIntersectionComputed";
        ObjectFlags3[ObjectFlags3["IsNeverIntersection"] = 33554432] = "IsNeverIntersection";
        ObjectFlags3[ObjectFlags3["IsConstrainedTypeVariable"] = 67108864] = "IsConstrainedTypeVariable";
        return ObjectFlags3;
    })(ObjectFlags || {});
    var VarianceFlags = /* @__PURE__ */ ((VarianceFlags2)=>{
        VarianceFlags2[VarianceFlags2["Invariant"] = 0] = "Invariant";
        VarianceFlags2[VarianceFlags2["Covariant"] = 1] = "Covariant";
        VarianceFlags2[VarianceFlags2["Contravariant"] = 2] = "Contravariant";
        VarianceFlags2[VarianceFlags2["Bivariant"] = 3] = "Bivariant";
        VarianceFlags2[VarianceFlags2["Independent"] = 4] = "Independent";
        VarianceFlags2[VarianceFlags2["VarianceMask"] = 7] = "VarianceMask";
        VarianceFlags2[VarianceFlags2["Unmeasurable"] = 8] = "Unmeasurable";
        VarianceFlags2[VarianceFlags2["Unreliable"] = 16] = "Unreliable";
        VarianceFlags2[VarianceFlags2["AllowsStructuralFallback"] = 24] = "AllowsStructuralFallback";
        return VarianceFlags2;
    })(VarianceFlags || {});
    var ElementFlags = /* @__PURE__ */ ((ElementFlags2)=>{
        ElementFlags2[ElementFlags2["Required"] = 1] = "Required";
        ElementFlags2[ElementFlags2["Optional"] = 2] = "Optional";
        ElementFlags2[ElementFlags2["Rest"] = 4] = "Rest";
        ElementFlags2[ElementFlags2["Variadic"] = 8] = "Variadic";
        ElementFlags2[ElementFlags2["Fixed"] = 3] = "Fixed";
        ElementFlags2[ElementFlags2["Variable"] = 12] = "Variable";
        ElementFlags2[ElementFlags2["NonRequired"] = 14] = "NonRequired";
        ElementFlags2[ElementFlags2["NonRest"] = 11] = "NonRest";
        return ElementFlags2;
    })(ElementFlags || {});
    var AccessFlags = /* @__PURE__ */ ((AccessFlags2)=>{
        AccessFlags2[AccessFlags2["None"] = 0] = "None";
        AccessFlags2[AccessFlags2["IncludeUndefined"] = 1] = "IncludeUndefined";
        AccessFlags2[AccessFlags2["NoIndexSignatures"] = 2] = "NoIndexSignatures";
        AccessFlags2[AccessFlags2["Writing"] = 4] = "Writing";
        AccessFlags2[AccessFlags2["CacheSymbol"] = 8] = "CacheSymbol";
        AccessFlags2[AccessFlags2["AllowMissing"] = 16] = "AllowMissing";
        AccessFlags2[AccessFlags2["ExpressionPosition"] = 32] = "ExpressionPosition";
        AccessFlags2[AccessFlags2["ReportDeprecated"] = 64] = "ReportDeprecated";
        AccessFlags2[AccessFlags2["SuppressNoImplicitAnyError"] = 128] = "SuppressNoImplicitAnyError";
        AccessFlags2[AccessFlags2["Contextual"] = 256] = "Contextual";
        AccessFlags2[AccessFlags2["Persistent"] = 1 /* IncludeUndefined */ ] = "Persistent";
        return AccessFlags2;
    })(AccessFlags || {});
    var IndexFlags = /* @__PURE__ */ ((IndexFlags2)=>{
        IndexFlags2[IndexFlags2["None"] = 0] = "None";
        IndexFlags2[IndexFlags2["StringsOnly"] = 1] = "StringsOnly";
        IndexFlags2[IndexFlags2["NoIndexSignatures"] = 2] = "NoIndexSignatures";
        IndexFlags2[IndexFlags2["NoReducibleCheck"] = 4] = "NoReducibleCheck";
        return IndexFlags2;
    })(IndexFlags || {});
    var JsxReferenceKind = /* @__PURE__ */ ((JsxReferenceKind2)=>{
        JsxReferenceKind2[JsxReferenceKind2["Component"] = 0] = "Component";
        JsxReferenceKind2[JsxReferenceKind2["Function"] = 1] = "Function";
        JsxReferenceKind2[JsxReferenceKind2["Mixed"] = 2] = "Mixed";
        return JsxReferenceKind2;
    })(JsxReferenceKind || {});
    var SignatureKind = /* @__PURE__ */ ((SignatureKind2)=>{
        SignatureKind2[SignatureKind2["Call"] = 0] = "Call";
        SignatureKind2[SignatureKind2["Construct"] = 1] = "Construct";
        return SignatureKind2;
    })(SignatureKind || {});
    var SignatureFlags = /* @__PURE__ */ ((SignatureFlags5)=>{
        SignatureFlags5[SignatureFlags5["None"] = 0] = "None";
        SignatureFlags5[SignatureFlags5["HasRestParameter"] = 1] = "HasRestParameter";
        SignatureFlags5[SignatureFlags5["HasLiteralTypes"] = 2] = "HasLiteralTypes";
        SignatureFlags5[SignatureFlags5["Abstract"] = 4] = "Abstract";
        SignatureFlags5[SignatureFlags5["IsInnerCallChain"] = 8] = "IsInnerCallChain";
        SignatureFlags5[SignatureFlags5["IsOuterCallChain"] = 16] = "IsOuterCallChain";
        SignatureFlags5[SignatureFlags5["IsUntypedSignatureInJSFile"] = 32] = "IsUntypedSignatureInJSFile";
        SignatureFlags5[SignatureFlags5["IsNonInferrable"] = 64] = "IsNonInferrable";
        SignatureFlags5[SignatureFlags5["IsSignatureCandidateForOverloadFailure"] = 128] = "IsSignatureCandidateForOverloadFailure";
        SignatureFlags5[SignatureFlags5["PropagatingFlags"] = 167] = "PropagatingFlags";
        SignatureFlags5[SignatureFlags5["CallChainFlags"] = 24] = "CallChainFlags";
        return SignatureFlags5;
    })(SignatureFlags || {});
    var IndexKind = /* @__PURE__ */ ((IndexKind2)=>{
        IndexKind2[IndexKind2["String"] = 0] = "String";
        IndexKind2[IndexKind2["Number"] = 1] = "Number";
        return IndexKind2;
    })(IndexKind || {});
    var TypeMapKind = /* @__PURE__ */ ((TypeMapKind2)=>{
        TypeMapKind2[TypeMapKind2["Simple"] = 0] = "Simple";
        TypeMapKind2[TypeMapKind2["Array"] = 1] = "Array";
        TypeMapKind2[TypeMapKind2["Deferred"] = 2] = "Deferred";
        TypeMapKind2[TypeMapKind2["Function"] = 3] = "Function";
        TypeMapKind2[TypeMapKind2["Composite"] = 4] = "Composite";
        TypeMapKind2[TypeMapKind2["Merged"] = 5] = "Merged";
        return TypeMapKind2;
    })(TypeMapKind || {});
    var InferencePriority = /* @__PURE__ */ ((InferencePriority2)=>{
        InferencePriority2[InferencePriority2["None"] = 0] = "None";
        InferencePriority2[InferencePriority2["NakedTypeVariable"] = 1] = "NakedTypeVariable";
        InferencePriority2[InferencePriority2["SpeculativeTuple"] = 2] = "SpeculativeTuple";
        InferencePriority2[InferencePriority2["SubstituteSource"] = 4] = "SubstituteSource";
        InferencePriority2[InferencePriority2["HomomorphicMappedType"] = 8] = "HomomorphicMappedType";
        InferencePriority2[InferencePriority2["PartialHomomorphicMappedType"] = 16] = "PartialHomomorphicMappedType";
        InferencePriority2[InferencePriority2["MappedTypeConstraint"] = 32] = "MappedTypeConstraint";
        InferencePriority2[InferencePriority2["ContravariantConditional"] = 64] = "ContravariantConditional";
        InferencePriority2[InferencePriority2["ReturnType"] = 128] = "ReturnType";
        InferencePriority2[InferencePriority2["LiteralKeyof"] = 256] = "LiteralKeyof";
        InferencePriority2[InferencePriority2["NoConstraints"] = 512] = "NoConstraints";
        InferencePriority2[InferencePriority2["AlwaysStrict"] = 1024] = "AlwaysStrict";
        InferencePriority2[InferencePriority2["MaxValue"] = 2048] = "MaxValue";
        InferencePriority2[InferencePriority2["PriorityImpliesCombination"] = 416] = "PriorityImpliesCombination";
        InferencePriority2[InferencePriority2["Circularity"] = -1] = "Circularity";
        return InferencePriority2;
    })(InferencePriority || {});
    var InferenceFlags = /* @__PURE__ */ ((InferenceFlags2)=>{
        InferenceFlags2[InferenceFlags2["None"] = 0] = "None";
        InferenceFlags2[InferenceFlags2["NoDefault"] = 1] = "NoDefault";
        InferenceFlags2[InferenceFlags2["AnyDefault"] = 2] = "AnyDefault";
        InferenceFlags2[InferenceFlags2["SkippedGenericFunction"] = 4] = "SkippedGenericFunction";
        return InferenceFlags2;
    })(InferenceFlags || {});
    var Ternary = /* @__PURE__ */ ((Ternary2)=>{
        Ternary2[Ternary2["False"] = 0] = "False";
        Ternary2[Ternary2["Unknown"] = 1] = "Unknown";
        Ternary2[Ternary2["Maybe"] = 3] = "Maybe";
        Ternary2[Ternary2["True"] = -1] = "True";
        return Ternary2;
    })(Ternary || {});
    var AssignmentDeclarationKind = /* @__PURE__ */ ((AssignmentDeclarationKind2)=>{
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["None"] = 0] = "None";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["ExportsProperty"] = 1] = "ExportsProperty";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["ModuleExports"] = 2] = "ModuleExports";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["PrototypeProperty"] = 3] = "PrototypeProperty";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["ThisProperty"] = 4] = "ThisProperty";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["Property"] = 5] = "Property";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["Prototype"] = 6] = "Prototype";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["ObjectDefinePropertyValue"] = 7] = "ObjectDefinePropertyValue";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["ObjectDefinePropertyExports"] = 8] = "ObjectDefinePropertyExports";
        AssignmentDeclarationKind2[AssignmentDeclarationKind2["ObjectDefinePrototypeProperty"] = 9] = "ObjectDefinePrototypeProperty";
        return AssignmentDeclarationKind2;
    })(AssignmentDeclarationKind || {});
    var DiagnosticCategory = /* @__PURE__ */ ((DiagnosticCategory2)=>{
        DiagnosticCategory2[DiagnosticCategory2["Warning"] = 0] = "Warning";
        DiagnosticCategory2[DiagnosticCategory2["Error"] = 1] = "Error";
        DiagnosticCategory2[DiagnosticCategory2["Suggestion"] = 2] = "Suggestion";
        DiagnosticCategory2[DiagnosticCategory2["Message"] = 3] = "Message";
        return DiagnosticCategory2;
    })(DiagnosticCategory || {});
    function diagnosticCategoryName(d, lowerCase = true) {
        const name = DiagnosticCategory[d.category];
        return lowerCase ? name.toLowerCase() : name;
    }
    var ModuleResolutionKind = /* @__PURE__ */ ((ModuleResolutionKind3)=>{
        ModuleResolutionKind3[ModuleResolutionKind3["Classic"] = 1] = "Classic";
        ModuleResolutionKind3[ModuleResolutionKind3["NodeJs"] = 2] = "NodeJs";
        ModuleResolutionKind3[ModuleResolutionKind3["Node10"] = 2] = "Node10";
        ModuleResolutionKind3[ModuleResolutionKind3["Node16"] = 3] = "Node16";
        ModuleResolutionKind3[ModuleResolutionKind3["NodeNext"] = 99] = "NodeNext";
        ModuleResolutionKind3[ModuleResolutionKind3["Bundler"] = 100] = "Bundler";
        return ModuleResolutionKind3;
    })(ModuleResolutionKind || {});
    var ModuleDetectionKind = /* @__PURE__ */ ((ModuleDetectionKind2)=>{
        ModuleDetectionKind2[ModuleDetectionKind2["Legacy"] = 1] = "Legacy";
        ModuleDetectionKind2[ModuleDetectionKind2["Auto"] = 2] = "Auto";
        ModuleDetectionKind2[ModuleDetectionKind2["Force"] = 3] = "Force";
        return ModuleDetectionKind2;
    })(ModuleDetectionKind || {});
    var WatchFileKind = /* @__PURE__ */ ((WatchFileKind3)=>{
        WatchFileKind3[WatchFileKind3["FixedPollingInterval"] = 0] = "FixedPollingInterval";
        WatchFileKind3[WatchFileKind3["PriorityPollingInterval"] = 1] = "PriorityPollingInterval";
        WatchFileKind3[WatchFileKind3["DynamicPriorityPolling"] = 2] = "DynamicPriorityPolling";
        WatchFileKind3[WatchFileKind3["FixedChunkSizePolling"] = 3] = "FixedChunkSizePolling";
        WatchFileKind3[WatchFileKind3["UseFsEvents"] = 4] = "UseFsEvents";
        WatchFileKind3[WatchFileKind3["UseFsEventsOnParentDirectory"] = 5] = "UseFsEventsOnParentDirectory";
        return WatchFileKind3;
    })(WatchFileKind || {});
    var WatchDirectoryKind = /* @__PURE__ */ ((WatchDirectoryKind3)=>{
        WatchDirectoryKind3[WatchDirectoryKind3["UseFsEvents"] = 0] = "UseFsEvents";
        WatchDirectoryKind3[WatchDirectoryKind3["FixedPollingInterval"] = 1] = "FixedPollingInterval";
        WatchDirectoryKind3[WatchDirectoryKind3["DynamicPriorityPolling"] = 2] = "DynamicPriorityPolling";
        WatchDirectoryKind3[WatchDirectoryKind3["FixedChunkSizePolling"] = 3] = "FixedChunkSizePolling";
        return WatchDirectoryKind3;
    })(WatchDirectoryKind || {});
    var PollingWatchKind = /* @__PURE__ */ ((PollingWatchKind3)=>{
        PollingWatchKind3[PollingWatchKind3["FixedInterval"] = 0] = "FixedInterval";
        PollingWatchKind3[PollingWatchKind3["PriorityInterval"] = 1] = "PriorityInterval";
        PollingWatchKind3[PollingWatchKind3["DynamicPriority"] = 2] = "DynamicPriority";
        PollingWatchKind3[PollingWatchKind3["FixedChunkSize"] = 3] = "FixedChunkSize";
        return PollingWatchKind3;
    })(PollingWatchKind || {});
    var ModuleKind = /* @__PURE__ */ ((ModuleKind3)=>{
        ModuleKind3[ModuleKind3["None"] = 0] = "None";
        ModuleKind3[ModuleKind3["CommonJS"] = 1] = "CommonJS";
        ModuleKind3[ModuleKind3["AMD"] = 2] = "AMD";
        ModuleKind3[ModuleKind3["UMD"] = 3] = "UMD";
        ModuleKind3[ModuleKind3["System"] = 4] = "System";
        ModuleKind3[ModuleKind3["ES2015"] = 5] = "ES2015";
        ModuleKind3[ModuleKind3["ES2020"] = 6] = "ES2020";
        ModuleKind3[ModuleKind3["ES2022"] = 7] = "ES2022";
        ModuleKind3[ModuleKind3["ESNext"] = 99] = "ESNext";
        ModuleKind3[ModuleKind3["Node16"] = 100] = "Node16";
        ModuleKind3[ModuleKind3["Node18"] = 101] = "Node18";
        ModuleKind3[ModuleKind3["Node20"] = 102] = "Node20";
        ModuleKind3[ModuleKind3["NodeNext"] = 199] = "NodeNext";
        ModuleKind3[ModuleKind3["Preserve"] = 200] = "Preserve";
        return ModuleKind3;
    })(ModuleKind || {});
    var JsxEmit = /* @__PURE__ */ ((JsxEmit3)=>{
        JsxEmit3[JsxEmit3["None"] = 0] = "None";
        JsxEmit3[JsxEmit3["Preserve"] = 1] = "Preserve";
        JsxEmit3[JsxEmit3["React"] = 2] = "React";
        JsxEmit3[JsxEmit3["ReactNative"] = 3] = "ReactNative";
        JsxEmit3[JsxEmit3["ReactJSX"] = 4] = "ReactJSX";
        JsxEmit3[JsxEmit3["ReactJSXDev"] = 5] = "ReactJSXDev";
        return JsxEmit3;
    })(JsxEmit || {});
    var ImportsNotUsedAsValues = /* @__PURE__ */ ((ImportsNotUsedAsValues2)=>{
        ImportsNotUsedAsValues2[ImportsNotUsedAsValues2["Remove"] = 0] = "Remove";
        ImportsNotUsedAsValues2[ImportsNotUsedAsValues2["Preserve"] = 1] = "Preserve";
        ImportsNotUsedAsValues2[ImportsNotUsedAsValues2["Error"] = 2] = "Error";
        return ImportsNotUsedAsValues2;
    })(ImportsNotUsedAsValues || {});
    var NewLineKind = /* @__PURE__ */ ((NewLineKind3)=>{
        NewLineKind3[NewLineKind3["CarriageReturnLineFeed"] = 0] = "CarriageReturnLineFeed";
        NewLineKind3[NewLineKind3["LineFeed"] = 1] = "LineFeed";
        return NewLineKind3;
    })(NewLineKind || {});
    var ScriptKind = /* @__PURE__ */ ((ScriptKind7)=>{
        ScriptKind7[ScriptKind7["Unknown"] = 0] = "Unknown";
        ScriptKind7[ScriptKind7["JS"] = 1] = "JS";
        ScriptKind7[ScriptKind7["JSX"] = 2] = "JSX";
        ScriptKind7[ScriptKind7["TS"] = 3] = "TS";
        ScriptKind7[ScriptKind7["TSX"] = 4] = "TSX";
        ScriptKind7[ScriptKind7["External"] = 5] = "External";
        ScriptKind7[ScriptKind7["JSON"] = 6] = "JSON";
        ScriptKind7[ScriptKind7["Deferred"] = 7] = "Deferred";
        return ScriptKind7;
    })(ScriptKind || {});
    var ScriptTarget = /* @__PURE__ */ ((ScriptTarget12)=>{
        ScriptTarget12[ScriptTarget12["ES3"] = 0] = "ES3";
        ScriptTarget12[ScriptTarget12["ES5"] = 1] = "ES5";
        ScriptTarget12[ScriptTarget12["ES2015"] = 2] = "ES2015";
        ScriptTarget12[ScriptTarget12["ES2016"] = 3] = "ES2016";
        ScriptTarget12[ScriptTarget12["ES2017"] = 4] = "ES2017";
        ScriptTarget12[ScriptTarget12["ES2018"] = 5] = "ES2018";
        ScriptTarget12[ScriptTarget12["ES2019"] = 6] = "ES2019";
        ScriptTarget12[ScriptTarget12["ES2020"] = 7] = "ES2020";
        ScriptTarget12[ScriptTarget12["ES2021"] = 8] = "ES2021";
        ScriptTarget12[ScriptTarget12["ES2022"] = 9] = "ES2022";
        ScriptTarget12[ScriptTarget12["ES2023"] = 10] = "ES2023";
        ScriptTarget12[ScriptTarget12["ES2024"] = 11] = "ES2024";
        ScriptTarget12[ScriptTarget12["ESNext"] = 99] = "ESNext";
        ScriptTarget12[ScriptTarget12["JSON"] = 100] = "JSON";
        ScriptTarget12[ScriptTarget12["Latest"] = 99 /* ESNext */ ] = "Latest";
        return ScriptTarget12;
    })(ScriptTarget || {});
    var LanguageVariant = /* @__PURE__ */ ((LanguageVariant3)=>{
        LanguageVariant3[LanguageVariant3["Standard"] = 0] = "Standard";
        LanguageVariant3[LanguageVariant3["JSX"] = 1] = "JSX";
        return LanguageVariant3;
    })(LanguageVariant || {});
    var WatchDirectoryFlags = /* @__PURE__ */ ((WatchDirectoryFlags3)=>{
        WatchDirectoryFlags3[WatchDirectoryFlags3["None"] = 0] = "None";
        WatchDirectoryFlags3[WatchDirectoryFlags3["Recursive"] = 1] = "Recursive";
        return WatchDirectoryFlags3;
    })(WatchDirectoryFlags || {});
    var CharacterCodes = /* @__PURE__ */ ((CharacterCodes2)=>{
        CharacterCodes2[CharacterCodes2["EOF"] = -1] = "EOF";
        CharacterCodes2[CharacterCodes2["nullCharacter"] = 0] = "nullCharacter";
        CharacterCodes2[CharacterCodes2["maxAsciiCharacter"] = 127] = "maxAsciiCharacter";
        CharacterCodes2[CharacterCodes2["lineFeed"] = 10] = "lineFeed";
        CharacterCodes2[CharacterCodes2["carriageReturn"] = 13] = "carriageReturn";
        CharacterCodes2[CharacterCodes2["lineSeparator"] = 8232] = "lineSeparator";
        CharacterCodes2[CharacterCodes2["paragraphSeparator"] = 8233] = "paragraphSeparator";
        CharacterCodes2[CharacterCodes2["nextLine"] = 133] = "nextLine";
        CharacterCodes2[CharacterCodes2["space"] = 32] = "space";
        CharacterCodes2[CharacterCodes2["nonBreakingSpace"] = 160] = "nonBreakingSpace";
        CharacterCodes2[CharacterCodes2["enQuad"] = 8192] = "enQuad";
        CharacterCodes2[CharacterCodes2["emQuad"] = 8193] = "emQuad";
        CharacterCodes2[CharacterCodes2["enSpace"] = 8194] = "enSpace";
        CharacterCodes2[CharacterCodes2["emSpace"] = 8195] = "emSpace";
        CharacterCodes2[CharacterCodes2["threePerEmSpace"] = 8196] = "threePerEmSpace";
        CharacterCodes2[CharacterCodes2["fourPerEmSpace"] = 8197] = "fourPerEmSpace";
        CharacterCodes2[CharacterCodes2["sixPerEmSpace"] = 8198] = "sixPerEmSpace";
        CharacterCodes2[CharacterCodes2["figureSpace"] = 8199] = "figureSpace";
        CharacterCodes2[CharacterCodes2["punctuationSpace"] = 8200] = "punctuationSpace";
        CharacterCodes2[CharacterCodes2["thinSpace"] = 8201] = "thinSpace";
        CharacterCodes2[CharacterCodes2["hairSpace"] = 8202] = "hairSpace";
        CharacterCodes2[CharacterCodes2["zeroWidthSpace"] = 8203] = "zeroWidthSpace";
        CharacterCodes2[CharacterCodes2["narrowNoBreakSpace"] = 8239] = "narrowNoBreakSpace";
        CharacterCodes2[CharacterCodes2["ideographicSpace"] = 12288] = "ideographicSpace";
        CharacterCodes2[CharacterCodes2["mathematicalSpace"] = 8287] = "mathematicalSpace";
        CharacterCodes2[CharacterCodes2["ogham"] = 5760] = "ogham";
        CharacterCodes2[CharacterCodes2["replacementCharacter"] = 65533] = "replacementCharacter";
        CharacterCodes2[CharacterCodes2["_"] = 95] = "_";
        CharacterCodes2[CharacterCodes2["$"] = 36] = "$";
        CharacterCodes2[CharacterCodes2["_0"] = 48] = "_0";
        CharacterCodes2[CharacterCodes2["_1"] = 49] = "_1";
        CharacterCodes2[CharacterCodes2["_2"] = 50] = "_2";
        CharacterCodes2[CharacterCodes2["_3"] = 51] = "_3";
        CharacterCodes2[CharacterCodes2["_4"] = 52] = "_4";
        CharacterCodes2[CharacterCodes2["_5"] = 53] = "_5";
        CharacterCodes2[CharacterCodes2["_6"] = 54] = "_6";
        CharacterCodes2[CharacterCodes2["_7"] = 55] = "_7";
        CharacterCodes2[CharacterCodes2["_8"] = 56] = "_8";
        CharacterCodes2[CharacterCodes2["_9"] = 57] = "_9";
        CharacterCodes2[CharacterCodes2["a"] = 97] = "a";
        CharacterCodes2[CharacterCodes2["b"] = 98] = "b";
        CharacterCodes2[CharacterCodes2["c"] = 99] = "c";
        CharacterCodes2[CharacterCodes2["d"] = 100] = "d";
        CharacterCodes2[CharacterCodes2["e"] = 101] = "e";
        CharacterCodes2[CharacterCodes2["f"] = 102] = "f";
        CharacterCodes2[CharacterCodes2["g"] = 103] = "g";
        CharacterCodes2[CharacterCodes2["h"] = 104] = "h";
        CharacterCodes2[CharacterCodes2["i"] = 105] = "i";
        CharacterCodes2[CharacterCodes2["j"] = 106] = "j";
        CharacterCodes2[CharacterCodes2["k"] = 107] = "k";
        CharacterCodes2[CharacterCodes2["l"] = 108] = "l";
        CharacterCodes2[CharacterCodes2["m"] = 109] = "m";
        CharacterCodes2[CharacterCodes2["n"] = 110] = "n";
        CharacterCodes2[CharacterCodes2["o"] = 111] = "o";
        CharacterCodes2[CharacterCodes2["p"] = 112] = "p";
        CharacterCodes2[CharacterCodes2["q"] = 113] = "q";
        CharacterCodes2[CharacterCodes2["r"] = 114] = "r";
        CharacterCodes2[CharacterCodes2["s"] = 115] = "s";
        CharacterCodes2[CharacterCodes2["t"] = 116] = "t";
        CharacterCodes2[CharacterCodes2["u"] = 117] = "u";
        CharacterCodes2[CharacterCodes2["v"] = 118] = "v";
        CharacterCodes2[CharacterCodes2["w"] = 119] = "w";
        CharacterCodes2[CharacterCodes2["x"] = 120] = "x";
        CharacterCodes2[CharacterCodes2["y"] = 121] = "y";
        CharacterCodes2[CharacterCodes2["z"] = 122] = "z";
        CharacterCodes2[CharacterCodes2["A"] = 65] = "A";
        CharacterCodes2[CharacterCodes2["B"] = 66] = "B";
        CharacterCodes2[CharacterCodes2["C"] = 67] = "C";
        CharacterCodes2[CharacterCodes2["D"] = 68] = "D";
        CharacterCodes2[CharacterCodes2["E"] = 69] = "E";
        CharacterCodes2[CharacterCodes2["F"] = 70] = "F";
        CharacterCodes2[CharacterCodes2["G"] = 71] = "G";
        CharacterCodes2[CharacterCodes2["H"] = 72] = "H";
        CharacterCodes2[CharacterCodes2["I"] = 73] = "I";
        CharacterCodes2[CharacterCodes2["J"] = 74] = "J";
        CharacterCodes2[CharacterCodes2["K"] = 75] = "K";
        CharacterCodes2[CharacterCodes2["L"] = 76] = "L";
        CharacterCodes2[CharacterCodes2["M"] = 77] = "M";
        CharacterCodes2[CharacterCodes2["N"] = 78] = "N";
        CharacterCodes2[CharacterCodes2["O"] = 79] = "O";
        CharacterCodes2[CharacterCodes2["P"] = 80] = "P";
        CharacterCodes2[CharacterCodes2["Q"] = 81] = "Q";
        CharacterCodes2[CharacterCodes2["R"] = 82] = "R";
        CharacterCodes2[CharacterCodes2["S"] = 83] = "S";
        CharacterCodes2[CharacterCodes2["T"] = 84] = "T";
        CharacterCodes2[CharacterCodes2["U"] = 85] = "U";
        CharacterCodes2[CharacterCodes2["V"] = 86] = "V";
        CharacterCodes2[CharacterCodes2["W"] = 87] = "W";
        CharacterCodes2[CharacterCodes2["X"] = 88] = "X";
        CharacterCodes2[CharacterCodes2["Y"] = 89] = "Y";
        CharacterCodes2[CharacterCodes2["Z"] = 90] = "Z";
        CharacterCodes2[CharacterCodes2["ampersand"] = 38] = "ampersand";
        CharacterCodes2[CharacterCodes2["asterisk"] = 42] = "asterisk";
        CharacterCodes2[CharacterCodes2["at"] = 64] = "at";
        CharacterCodes2[CharacterCodes2["backslash"] = 92] = "backslash";
        CharacterCodes2[CharacterCodes2["backtick"] = 96] = "backtick";
        CharacterCodes2[CharacterCodes2["bar"] = 124] = "bar";
        CharacterCodes2[CharacterCodes2["caret"] = 94] = "caret";
        CharacterCodes2[CharacterCodes2["closeBrace"] = 125] = "closeBrace";
        CharacterCodes2[CharacterCodes2["closeBracket"] = 93] = "closeBracket";
        CharacterCodes2[CharacterCodes2["closeParen"] = 41] = "closeParen";
        CharacterCodes2[CharacterCodes2["colon"] = 58] = "colon";
        CharacterCodes2[CharacterCodes2["comma"] = 44] = "comma";
        CharacterCodes2[CharacterCodes2["dot"] = 46] = "dot";
        CharacterCodes2[CharacterCodes2["doubleQuote"] = 34] = "doubleQuote";
        CharacterCodes2[CharacterCodes2["equals"] = 61] = "equals";
        CharacterCodes2[CharacterCodes2["exclamation"] = 33] = "exclamation";
        CharacterCodes2[CharacterCodes2["greaterThan"] = 62] = "greaterThan";
        CharacterCodes2[CharacterCodes2["hash"] = 35] = "hash";
        CharacterCodes2[CharacterCodes2["lessThan"] = 60] = "lessThan";
        CharacterCodes2[CharacterCodes2["minus"] = 45] = "minus";
        CharacterCodes2[CharacterCodes2["openBrace"] = 123] = "openBrace";
        CharacterCodes2[CharacterCodes2["openBracket"] = 91] = "openBracket";
        CharacterCodes2[CharacterCodes2["openParen"] = 40] = "openParen";
        CharacterCodes2[CharacterCodes2["percent"] = 37] = "percent";
        CharacterCodes2[CharacterCodes2["plus"] = 43] = "plus";
        CharacterCodes2[CharacterCodes2["question"] = 63] = "question";
        CharacterCodes2[CharacterCodes2["semicolon"] = 59] = "semicolon";
        CharacterCodes2[CharacterCodes2["singleQuote"] = 39] = "singleQuote";
        CharacterCodes2[CharacterCodes2["slash"] = 47] = "slash";
        CharacterCodes2[CharacterCodes2["tilde"] = 126] = "tilde";
        CharacterCodes2[CharacterCodes2["backspace"] = 8] = "backspace";
        CharacterCodes2[CharacterCodes2["formFeed"] = 12] = "formFeed";
        CharacterCodes2[CharacterCodes2["byteOrderMark"] = 65279] = "byteOrderMark";
        CharacterCodes2[CharacterCodes2["tab"] = 9] = "tab";
        CharacterCodes2[CharacterCodes2["verticalTab"] = 11] = "verticalTab";
        return CharacterCodes2;
    })(CharacterCodes || {});
    var Extension = /* @__PURE__ */ ((Extension2)=>{
        Extension2["Ts"] = ".ts";
        Extension2["Tsx"] = ".tsx";
        Extension2["Dts"] = ".d.ts";
        Extension2["Js"] = ".js";
        Extension2["Jsx"] = ".jsx";
        Extension2["Json"] = ".json";
        Extension2["TsBuildInfo"] = ".tsbuildinfo";
        Extension2["Mjs"] = ".mjs";
        Extension2["Mts"] = ".mts";
        Extension2["Dmts"] = ".d.mts";
        Extension2["Cjs"] = ".cjs";
        Extension2["Cts"] = ".cts";
        Extension2["Dcts"] = ".d.cts";
        return Extension2;
    })(Extension || {});
    var TransformFlags = /* @__PURE__ */ ((TransformFlags3)=>{
        TransformFlags3[TransformFlags3["None"] = 0] = "None";
        TransformFlags3[TransformFlags3["ContainsTypeScript"] = 1] = "ContainsTypeScript";
        TransformFlags3[TransformFlags3["ContainsJsx"] = 2] = "ContainsJsx";
        TransformFlags3[TransformFlags3["ContainsESNext"] = 4] = "ContainsESNext";
        TransformFlags3[TransformFlags3["ContainsES2022"] = 8] = "ContainsES2022";
        TransformFlags3[TransformFlags3["ContainsES2021"] = 16] = "ContainsES2021";
        TransformFlags3[TransformFlags3["ContainsES2020"] = 32] = "ContainsES2020";
        TransformFlags3[TransformFlags3["ContainsES2019"] = 64] = "ContainsES2019";
        TransformFlags3[TransformFlags3["ContainsES2018"] = 128] = "ContainsES2018";
        TransformFlags3[TransformFlags3["ContainsES2017"] = 256] = "ContainsES2017";
        TransformFlags3[TransformFlags3["ContainsES2016"] = 512] = "ContainsES2016";
        TransformFlags3[TransformFlags3["ContainsES2015"] = 1024] = "ContainsES2015";
        TransformFlags3[TransformFlags3["ContainsGenerator"] = 2048] = "ContainsGenerator";
        TransformFlags3[TransformFlags3["ContainsDestructuringAssignment"] = 4096] = "ContainsDestructuringAssignment";
        TransformFlags3[TransformFlags3["ContainsTypeScriptClassSyntax"] = 8192] = "ContainsTypeScriptClassSyntax";
        TransformFlags3[TransformFlags3["ContainsLexicalThis"] = 16384] = "ContainsLexicalThis";
        TransformFlags3[TransformFlags3["ContainsRestOrSpread"] = 32768] = "ContainsRestOrSpread";
        TransformFlags3[TransformFlags3["ContainsObjectRestOrSpread"] = 65536] = "ContainsObjectRestOrSpread";
        TransformFlags3[TransformFlags3["ContainsComputedPropertyName"] = 131072] = "ContainsComputedPropertyName";
        TransformFlags3[TransformFlags3["ContainsBlockScopedBinding"] = 262144] = "ContainsBlockScopedBinding";
        TransformFlags3[TransformFlags3["ContainsBindingPattern"] = 524288] = "ContainsBindingPattern";
        TransformFlags3[TransformFlags3["ContainsYield"] = 1048576] = "ContainsYield";
        TransformFlags3[TransformFlags3["ContainsAwait"] = 2097152] = "ContainsAwait";
        TransformFlags3[TransformFlags3["ContainsHoistedDeclarationOrCompletion"] = 4194304] = "ContainsHoistedDeclarationOrCompletion";
        TransformFlags3[TransformFlags3["ContainsDynamicImport"] = 8388608] = "ContainsDynamicImport";
        TransformFlags3[TransformFlags3["ContainsClassFields"] = 16777216] = "ContainsClassFields";
        TransformFlags3[TransformFlags3["ContainsDecorators"] = 33554432] = "ContainsDecorators";
        TransformFlags3[TransformFlags3["ContainsPossibleTopLevelAwait"] = 67108864] = "ContainsPossibleTopLevelAwait";
        TransformFlags3[TransformFlags3["ContainsLexicalSuper"] = 134217728] = "ContainsLexicalSuper";
        TransformFlags3[TransformFlags3["ContainsUpdateExpressionForIdentifier"] = 268435456] = "ContainsUpdateExpressionForIdentifier";
        TransformFlags3[TransformFlags3["ContainsPrivateIdentifierInExpression"] = 536870912] = "ContainsPrivateIdentifierInExpression";
        TransformFlags3[TransformFlags3["HasComputedFlags"] = -2147483648] = "HasComputedFlags";
        TransformFlags3[TransformFlags3["AssertTypeScript"] = 1 /* ContainsTypeScript */ ] = "AssertTypeScript";
        TransformFlags3[TransformFlags3["AssertJsx"] = 2 /* ContainsJsx */ ] = "AssertJsx";
        TransformFlags3[TransformFlags3["AssertESNext"] = 4 /* ContainsESNext */ ] = "AssertESNext";
        TransformFlags3[TransformFlags3["AssertES2022"] = 8 /* ContainsES2022 */ ] = "AssertES2022";
        TransformFlags3[TransformFlags3["AssertES2021"] = 16 /* ContainsES2021 */ ] = "AssertES2021";
        TransformFlags3[TransformFlags3["AssertES2020"] = 32 /* ContainsES2020 */ ] = "AssertES2020";
        TransformFlags3[TransformFlags3["AssertES2019"] = 64 /* ContainsES2019 */ ] = "AssertES2019";
        TransformFlags3[TransformFlags3["AssertES2018"] = 128 /* ContainsES2018 */ ] = "AssertES2018";
        TransformFlags3[TransformFlags3["AssertES2017"] = 256 /* ContainsES2017 */ ] = "AssertES2017";
        TransformFlags3[TransformFlags3["AssertES2016"] = 512 /* ContainsES2016 */ ] = "AssertES2016";
        TransformFlags3[TransformFlags3["AssertES2015"] = 1024 /* ContainsES2015 */ ] = "AssertES2015";
        TransformFlags3[TransformFlags3["AssertGenerator"] = 2048 /* ContainsGenerator */ ] = "AssertGenerator";
        TransformFlags3[TransformFlags3["AssertDestructuringAssignment"] = 4096 /* ContainsDestructuringAssignment */ ] = "AssertDestructuringAssignment";
        TransformFlags3[TransformFlags3["OuterExpressionExcludes"] = -2147483648 /* HasComputedFlags */ ] = "OuterExpressionExcludes";
        TransformFlags3[TransformFlags3["PropertyAccessExcludes"] = -2147483648 /* OuterExpressionExcludes */ ] = "PropertyAccessExcludes";
        TransformFlags3[TransformFlags3["NodeExcludes"] = -2147483648 /* PropertyAccessExcludes */ ] = "NodeExcludes";
        TransformFlags3[TransformFlags3["ArrowFunctionExcludes"] = -2072174592] = "ArrowFunctionExcludes";
        TransformFlags3[TransformFlags3["FunctionExcludes"] = -1937940480] = "FunctionExcludes";
        TransformFlags3[TransformFlags3["ConstructorExcludes"] = -1937948672] = "ConstructorExcludes";
        TransformFlags3[TransformFlags3["MethodOrAccessorExcludes"] = -2005057536] = "MethodOrAccessorExcludes";
        TransformFlags3[TransformFlags3["PropertyExcludes"] = -2013249536] = "PropertyExcludes";
        TransformFlags3[TransformFlags3["ClassExcludes"] = -2147344384] = "ClassExcludes";
        TransformFlags3[TransformFlags3["ModuleExcludes"] = -1941676032] = "ModuleExcludes";
        TransformFlags3[TransformFlags3["TypeExcludes"] = -2] = "TypeExcludes";
        TransformFlags3[TransformFlags3["ObjectLiteralExcludes"] = -2147278848] = "ObjectLiteralExcludes";
        TransformFlags3[TransformFlags3["ArrayLiteralOrCallOrNewExcludes"] = -2147450880] = "ArrayLiteralOrCallOrNewExcludes";
        TransformFlags3[TransformFlags3["VariableDeclarationListExcludes"] = -2146893824] = "VariableDeclarationListExcludes";
        TransformFlags3[TransformFlags3["ParameterExcludes"] = -2147483648 /* NodeExcludes */ ] = "ParameterExcludes";
        TransformFlags3[TransformFlags3["CatchClauseExcludes"] = -2147418112] = "CatchClauseExcludes";
        TransformFlags3[TransformFlags3["BindingPatternExcludes"] = -2147450880] = "BindingPatternExcludes";
        TransformFlags3[TransformFlags3["ContainsLexicalThisOrSuper"] = 134234112] = "ContainsLexicalThisOrSuper";
        TransformFlags3[TransformFlags3["PropertyNamePropagatingFlags"] = 134234112] = "PropertyNamePropagatingFlags";
        return TransformFlags3;
    })(TransformFlags || {});
    var SnippetKind = /* @__PURE__ */ ((SnippetKind3)=>{
        SnippetKind3[SnippetKind3["TabStop"] = 0] = "TabStop";
        SnippetKind3[SnippetKind3["Placeholder"] = 1] = "Placeholder";
        SnippetKind3[SnippetKind3["Choice"] = 2] = "Choice";
        SnippetKind3[SnippetKind3["Variable"] = 3] = "Variable";
        return SnippetKind3;
    })(SnippetKind || {});
    var EmitFlags = /* @__PURE__ */ ((EmitFlags3)=>{
        EmitFlags3[EmitFlags3["None"] = 0] = "None";
        EmitFlags3[EmitFlags3["SingleLine"] = 1] = "SingleLine";
        EmitFlags3[EmitFlags3["MultiLine"] = 2] = "MultiLine";
        EmitFlags3[EmitFlags3["AdviseOnEmitNode"] = 4] = "AdviseOnEmitNode";
        EmitFlags3[EmitFlags3["NoSubstitution"] = 8] = "NoSubstitution";
        EmitFlags3[EmitFlags3["CapturesThis"] = 16] = "CapturesThis";
        EmitFlags3[EmitFlags3["NoLeadingSourceMap"] = 32] = "NoLeadingSourceMap";
        EmitFlags3[EmitFlags3["NoTrailingSourceMap"] = 64] = "NoTrailingSourceMap";
        EmitFlags3[EmitFlags3["NoSourceMap"] = 96] = "NoSourceMap";
        EmitFlags3[EmitFlags3["NoNestedSourceMaps"] = 128] = "NoNestedSourceMaps";
        EmitFlags3[EmitFlags3["NoTokenLeadingSourceMaps"] = 256] = "NoTokenLeadingSourceMaps";
        EmitFlags3[EmitFlags3["NoTokenTrailingSourceMaps"] = 512] = "NoTokenTrailingSourceMaps";
        EmitFlags3[EmitFlags3["NoTokenSourceMaps"] = 768] = "NoTokenSourceMaps";
        EmitFlags3[EmitFlags3["NoLeadingComments"] = 1024] = "NoLeadingComments";
        EmitFlags3[EmitFlags3["NoTrailingComments"] = 2048] = "NoTrailingComments";
        EmitFlags3[EmitFlags3["NoComments"] = 3072] = "NoComments";
        EmitFlags3[EmitFlags3["NoNestedComments"] = 4096] = "NoNestedComments";
        EmitFlags3[EmitFlags3["HelperName"] = 8192] = "HelperName";
        EmitFlags3[EmitFlags3["ExportName"] = 16384] = "ExportName";
        EmitFlags3[EmitFlags3["LocalName"] = 32768] = "LocalName";
        EmitFlags3[EmitFlags3["InternalName"] = 65536] = "InternalName";
        EmitFlags3[EmitFlags3["Indented"] = 131072] = "Indented";
        EmitFlags3[EmitFlags3["NoIndentation"] = 262144] = "NoIndentation";
        EmitFlags3[EmitFlags3["AsyncFunctionBody"] = 524288] = "AsyncFunctionBody";
        EmitFlags3[EmitFlags3["ReuseTempVariableScope"] = 1048576] = "ReuseTempVariableScope";
        EmitFlags3[EmitFlags3["CustomPrologue"] = 2097152] = "CustomPrologue";
        EmitFlags3[EmitFlags3["NoHoisting"] = 4194304] = "NoHoisting";
        EmitFlags3[EmitFlags3["Iterator"] = 8388608] = "Iterator";
        EmitFlags3[EmitFlags3["NoAsciiEscaping"] = 16777216] = "NoAsciiEscaping";
        return EmitFlags3;
    })(EmitFlags || {});
    var InternalEmitFlags = /* @__PURE__ */ ((InternalEmitFlags3)=>{
        InternalEmitFlags3[InternalEmitFlags3["None"] = 0] = "None";
        InternalEmitFlags3[InternalEmitFlags3["TypeScriptClassWrapper"] = 1] = "TypeScriptClassWrapper";
        InternalEmitFlags3[InternalEmitFlags3["NeverApplyImportHelper"] = 2] = "NeverApplyImportHelper";
        InternalEmitFlags3[InternalEmitFlags3["IgnoreSourceNewlines"] = 4] = "IgnoreSourceNewlines";
        InternalEmitFlags3[InternalEmitFlags3["Immutable"] = 8] = "Immutable";
        InternalEmitFlags3[InternalEmitFlags3["IndirectCall"] = 16] = "IndirectCall";
        InternalEmitFlags3[InternalEmitFlags3["TransformPrivateStaticElements"] = 32] = "TransformPrivateStaticElements";
        return InternalEmitFlags3;
    })(InternalEmitFlags || {});
    var LanguageFeatureMinimumTarget = {
        Classes: 2 /* ES2015 */ ,
        ForOf: 2 /* ES2015 */ ,
        Generators: 2 /* ES2015 */ ,
        Iteration: 2 /* ES2015 */ ,
        SpreadElements: 2 /* ES2015 */ ,
        RestElements: 2 /* ES2015 */ ,
        TaggedTemplates: 2 /* ES2015 */ ,
        DestructuringAssignment: 2 /* ES2015 */ ,
        BindingPatterns: 2 /* ES2015 */ ,
        ArrowFunctions: 2 /* ES2015 */ ,
        BlockScopedVariables: 2 /* ES2015 */ ,
        ObjectAssign: 2 /* ES2015 */ ,
        RegularExpressionFlagsUnicode: 2 /* ES2015 */ ,
        RegularExpressionFlagsSticky: 2 /* ES2015 */ ,
        Exponentiation: 3 /* ES2016 */ ,
        AsyncFunctions: 4 /* ES2017 */ ,
        ForAwaitOf: 5 /* ES2018 */ ,
        AsyncGenerators: 5 /* ES2018 */ ,
        AsyncIteration: 5 /* ES2018 */ ,
        ObjectSpreadRest: 5 /* ES2018 */ ,
        RegularExpressionFlagsDotAll: 5 /* ES2018 */ ,
        BindinglessCatch: 6 /* ES2019 */ ,
        BigInt: 7 /* ES2020 */ ,
        NullishCoalesce: 7 /* ES2020 */ ,
        OptionalChaining: 7 /* ES2020 */ ,
        LogicalAssignment: 8 /* ES2021 */ ,
        TopLevelAwait: 9 /* ES2022 */ ,
        ClassFields: 9 /* ES2022 */ ,
        PrivateNamesAndClassStaticBlocks: 9 /* ES2022 */ ,
        RegularExpressionFlagsHasIndices: 9 /* ES2022 */ ,
        ShebangComments: 10 /* ES2023 */ ,
        RegularExpressionFlagsUnicodeSets: 11 /* ES2024 */ ,
        UsingAndAwaitUsing: 99 /* ESNext */ ,
        ClassAndClassElementDecorators: 99 /* ESNext */ 
    };
    var ExternalEmitHelpers = /* @__PURE__ */ ((ExternalEmitHelpers2)=>{
        ExternalEmitHelpers2[ExternalEmitHelpers2["Extends"] = 1] = "Extends";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Assign"] = 2] = "Assign";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Rest"] = 4] = "Rest";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Decorate"] = 8] = "Decorate";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ESDecorateAndRunInitializers"] = 8 /* Decorate */ ] = "ESDecorateAndRunInitializers";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Metadata"] = 16] = "Metadata";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Param"] = 32] = "Param";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Awaiter"] = 64] = "Awaiter";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Generator"] = 128] = "Generator";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Values"] = 256] = "Values";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Read"] = 512] = "Read";
        ExternalEmitHelpers2[ExternalEmitHelpers2["SpreadArray"] = 1024] = "SpreadArray";
        ExternalEmitHelpers2[ExternalEmitHelpers2["Await"] = 2048] = "Await";
        ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncGenerator"] = 4096] = "AsyncGenerator";
        ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncDelegator"] = 8192] = "AsyncDelegator";
        ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncValues"] = 16384] = "AsyncValues";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ExportStar"] = 32768] = "ExportStar";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ImportStar"] = 65536] = "ImportStar";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ImportDefault"] = 131072] = "ImportDefault";
        ExternalEmitHelpers2[ExternalEmitHelpers2["MakeTemplateObject"] = 262144] = "MakeTemplateObject";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ClassPrivateFieldGet"] = 524288] = "ClassPrivateFieldGet";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ClassPrivateFieldSet"] = 1048576] = "ClassPrivateFieldSet";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ClassPrivateFieldIn"] = 2097152] = "ClassPrivateFieldIn";
        ExternalEmitHelpers2[ExternalEmitHelpers2["SetFunctionName"] = 4194304] = "SetFunctionName";
        ExternalEmitHelpers2[ExternalEmitHelpers2["PropKey"] = 8388608] = "PropKey";
        ExternalEmitHelpers2[ExternalEmitHelpers2["AddDisposableResourceAndDisposeResources"] = 16777216] = "AddDisposableResourceAndDisposeResources";
        ExternalEmitHelpers2[ExternalEmitHelpers2["RewriteRelativeImportExtension"] = 33554432] = "RewriteRelativeImportExtension";
        ExternalEmitHelpers2[ExternalEmitHelpers2["FirstEmitHelper"] = 1 /* Extends */ ] = "FirstEmitHelper";
        ExternalEmitHelpers2[ExternalEmitHelpers2["LastEmitHelper"] = 16777216 /* AddDisposableResourceAndDisposeResources */ ] = "LastEmitHelper";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ForOfIncludes"] = 256 /* Values */ ] = "ForOfIncludes";
        ExternalEmitHelpers2[ExternalEmitHelpers2["ForAwaitOfIncludes"] = 16384 /* AsyncValues */ ] = "ForAwaitOfIncludes";
        ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncGeneratorIncludes"] = 6144] = "AsyncGeneratorIncludes";
        ExternalEmitHelpers2[ExternalEmitHelpers2["AsyncDelegatorIncludes"] = 26624] = "AsyncDelegatorIncludes";
        ExternalEmitHelpers2[ExternalEmitHelpers2["SpreadIncludes"] = 1536] = "SpreadIncludes";
        return ExternalEmitHelpers2;
    })(ExternalEmitHelpers || {});
    var EmitHint = /* @__PURE__ */ ((EmitHint5)=>{
        EmitHint5[EmitHint5["SourceFile"] = 0] = "SourceFile";
        EmitHint5[EmitHint5["Expression"] = 1] = "Expression";
        EmitHint5[EmitHint5["IdentifierName"] = 2] = "IdentifierName";
        EmitHint5[EmitHint5["MappedTypeParameter"] = 3] = "MappedTypeParameter";
        EmitHint5[EmitHint5["Unspecified"] = 4] = "Unspecified";
        EmitHint5[EmitHint5["EmbeddedStatement"] = 5] = "EmbeddedStatement";
        EmitHint5[EmitHint5["JsxAttributeValue"] = 6] = "JsxAttributeValue";
        EmitHint5[EmitHint5["ImportTypeNodeAttributes"] = 7] = "ImportTypeNodeAttributes";
        return EmitHint5;
    })(EmitHint || {});
    var OuterExpressionKinds = /* @__PURE__ */ ((OuterExpressionKinds2)=>{
        OuterExpressionKinds2[OuterExpressionKinds2["Parentheses"] = 1] = "Parentheses";
        OuterExpressionKinds2[OuterExpressionKinds2["TypeAssertions"] = 2] = "TypeAssertions";
        OuterExpressionKinds2[OuterExpressionKinds2["NonNullAssertions"] = 4] = "NonNullAssertions";
        OuterExpressionKinds2[OuterExpressionKinds2["PartiallyEmittedExpressions"] = 8] = "PartiallyEmittedExpressions";
        OuterExpressionKinds2[OuterExpressionKinds2["ExpressionsWithTypeArguments"] = 16] = "ExpressionsWithTypeArguments";
        OuterExpressionKinds2[OuterExpressionKinds2["Satisfies"] = 32] = "Satisfies";
        OuterExpressionKinds2[OuterExpressionKinds2["Assertions"] = 38] = "Assertions";
        OuterExpressionKinds2[OuterExpressionKinds2["All"] = 63] = "All";
        OuterExpressionKinds2[OuterExpressionKinds2["ExcludeJSDocTypeAssertion"] = -2147483648] = "ExcludeJSDocTypeAssertion";
        return OuterExpressionKinds2;
    })(OuterExpressionKinds || {});
    var LexicalEnvironmentFlags = /* @__PURE__ */ ((LexicalEnvironmentFlags2)=>{
        LexicalEnvironmentFlags2[LexicalEnvironmentFlags2["None"] = 0] = "None";
        LexicalEnvironmentFlags2[LexicalEnvironmentFlags2["InParameters"] = 1] = "InParameters";
        LexicalEnvironmentFlags2[LexicalEnvironmentFlags2["VariablesHoistedInParameters"] = 2] = "VariablesHoistedInParameters";
        return LexicalEnvironmentFlags2;
    })(LexicalEnvironmentFlags || {});
    var ListFormat = /* @__PURE__ */ ((ListFormat2)=>{
        ListFormat2[ListFormat2["None"] = 0] = "None";
        ListFormat2[ListFormat2["SingleLine"] = 0] = "SingleLine";
        ListFormat2[ListFormat2["MultiLine"] = 1] = "MultiLine";
        ListFormat2[ListFormat2["PreserveLines"] = 2] = "PreserveLines";
        ListFormat2[ListFormat2["LinesMask"] = 3] = "LinesMask";
        ListFormat2[ListFormat2["NotDelimited"] = 0] = "NotDelimited";
        ListFormat2[ListFormat2["BarDelimited"] = 4] = "BarDelimited";
        ListFormat2[ListFormat2["AmpersandDelimited"] = 8] = "AmpersandDelimited";
        ListFormat2[ListFormat2["CommaDelimited"] = 16] = "CommaDelimited";
        ListFormat2[ListFormat2["AsteriskDelimited"] = 32] = "AsteriskDelimited";
        ListFormat2[ListFormat2["DelimitersMask"] = 60] = "DelimitersMask";
        ListFormat2[ListFormat2["AllowTrailingComma"] = 64] = "AllowTrailingComma";
        ListFormat2[ListFormat2["Indented"] = 128] = "Indented";
        ListFormat2[ListFormat2["SpaceBetweenBraces"] = 256] = "SpaceBetweenBraces";
        ListFormat2[ListFormat2["SpaceBetweenSiblings"] = 512] = "SpaceBetweenSiblings";
        ListFormat2[ListFormat2["Braces"] = 1024] = "Braces";
        ListFormat2[ListFormat2["Parenthesis"] = 2048] = "Parenthesis";
        ListFormat2[ListFormat2["AngleBrackets"] = 4096] = "AngleBrackets";
        ListFormat2[ListFormat2["SquareBrackets"] = 8192] = "SquareBrackets";
        ListFormat2[ListFormat2["BracketsMask"] = 15360] = "BracketsMask";
        ListFormat2[ListFormat2["OptionalIfUndefined"] = 16384] = "OptionalIfUndefined";
        ListFormat2[ListFormat2["OptionalIfEmpty"] = 32768] = "OptionalIfEmpty";
        ListFormat2[ListFormat2["Optional"] = 49152] = "Optional";
        ListFormat2[ListFormat2["PreferNewLine"] = 65536] = "PreferNewLine";
        ListFormat2[ListFormat2["NoTrailingNewLine"] = 131072] = "NoTrailingNewLine";
        ListFormat2[ListFormat2["NoInterveningComments"] = 262144] = "NoInterveningComments";
        ListFormat2[ListFormat2["NoSpaceIfEmpty"] = 524288] = "NoSpaceIfEmpty";
        ListFormat2[ListFormat2["SingleElement"] = 1048576] = "SingleElement";
        ListFormat2[ListFormat2["SpaceAfterList"] = 2097152] = "SpaceAfterList";
        ListFormat2[ListFormat2["Modifiers"] = 2359808] = "Modifiers";
        ListFormat2[ListFormat2["HeritageClauses"] = 512] = "HeritageClauses";
        ListFormat2[ListFormat2["SingleLineTypeLiteralMembers"] = 768] = "SingleLineTypeLiteralMembers";
        ListFormat2[ListFormat2["MultiLineTypeLiteralMembers"] = 32897] = "MultiLineTypeLiteralMembers";
        ListFormat2[ListFormat2["SingleLineTupleTypeElements"] = 528] = "SingleLineTupleTypeElements";
        ListFormat2[ListFormat2["MultiLineTupleTypeElements"] = 657] = "MultiLineTupleTypeElements";
        ListFormat2[ListFormat2["UnionTypeConstituents"] = 516] = "UnionTypeConstituents";
        ListFormat2[ListFormat2["IntersectionTypeConstituents"] = 520] = "IntersectionTypeConstituents";
        ListFormat2[ListFormat2["ObjectBindingPatternElements"] = 525136] = "ObjectBindingPatternElements";
        ListFormat2[ListFormat2["ArrayBindingPatternElements"] = 524880] = "ArrayBindingPatternElements";
        ListFormat2[ListFormat2["ObjectLiteralExpressionProperties"] = 526226] = "ObjectLiteralExpressionProperties";
        ListFormat2[ListFormat2["ImportAttributes"] = 526226] = "ImportAttributes";
        ListFormat2[ListFormat2["ImportClauseEntries"] = 526226 /* ImportAttributes */ ] = "ImportClauseEntries";
        ListFormat2[ListFormat2["ArrayLiteralExpressionElements"] = 8914] = "ArrayLiteralExpressionElements";
        ListFormat2[ListFormat2["CommaListElements"] = 528] = "CommaListElements";
        ListFormat2[ListFormat2["CallExpressionArguments"] = 2576] = "CallExpressionArguments";
        ListFormat2[ListFormat2["NewExpressionArguments"] = 18960] = "NewExpressionArguments";
        ListFormat2[ListFormat2["TemplateExpressionSpans"] = 262144] = "TemplateExpressionSpans";
        ListFormat2[ListFormat2["SingleLineBlockStatements"] = 768] = "SingleLineBlockStatements";
        ListFormat2[ListFormat2["MultiLineBlockStatements"] = 129] = "MultiLineBlockStatements";
        ListFormat2[ListFormat2["VariableDeclarationList"] = 528] = "VariableDeclarationList";
        ListFormat2[ListFormat2["SingleLineFunctionBodyStatements"] = 768] = "SingleLineFunctionBodyStatements";
        ListFormat2[ListFormat2["MultiLineFunctionBodyStatements"] = 1 /* MultiLine */ ] = "MultiLineFunctionBodyStatements";
        ListFormat2[ListFormat2["ClassHeritageClauses"] = 0 /* SingleLine */ ] = "ClassHeritageClauses";
        ListFormat2[ListFormat2["ClassMembers"] = 129] = "ClassMembers";
        ListFormat2[ListFormat2["InterfaceMembers"] = 129] = "InterfaceMembers";
        ListFormat2[ListFormat2["EnumMembers"] = 145] = "EnumMembers";
        ListFormat2[ListFormat2["CaseBlockClauses"] = 129] = "CaseBlockClauses";
        ListFormat2[ListFormat2["NamedImportsOrExportsElements"] = 525136] = "NamedImportsOrExportsElements";
        ListFormat2[ListFormat2["JsxElementOrFragmentChildren"] = 262144] = "JsxElementOrFragmentChildren";
        ListFormat2[ListFormat2["JsxElementAttributes"] = 262656] = "JsxElementAttributes";
        ListFormat2[ListFormat2["CaseOrDefaultClauseStatements"] = 163969] = "CaseOrDefaultClauseStatements";
        ListFormat2[ListFormat2["HeritageClauseTypes"] = 528] = "HeritageClauseTypes";
        ListFormat2[ListFormat2["SourceFileStatements"] = 131073] = "SourceFileStatements";
        ListFormat2[ListFormat2["Decorators"] = 2146305] = "Decorators";
        ListFormat2[ListFormat2["TypeArguments"] = 53776] = "TypeArguments";
        ListFormat2[ListFormat2["TypeParameters"] = 53776] = "TypeParameters";
        ListFormat2[ListFormat2["Parameters"] = 2576] = "Parameters";
        ListFormat2[ListFormat2["IndexSignatureParameters"] = 8848] = "IndexSignatureParameters";
        ListFormat2[ListFormat2["JSDocComment"] = 33] = "JSDocComment";
        return ListFormat2;
    })(ListFormat || {});
    var PragmaKindFlags = /* @__PURE__ */ ((PragmaKindFlags2)=>{
        PragmaKindFlags2[PragmaKindFlags2["None"] = 0] = "None";
        PragmaKindFlags2[PragmaKindFlags2["TripleSlashXML"] = 1] = "TripleSlashXML";
        PragmaKindFlags2[PragmaKindFlags2["SingleLine"] = 2] = "SingleLine";
        PragmaKindFlags2[PragmaKindFlags2["MultiLine"] = 4] = "MultiLine";
        PragmaKindFlags2[PragmaKindFlags2["All"] = 7] = "All";
        PragmaKindFlags2[PragmaKindFlags2["Default"] = 7 /* All */ ] = "Default";
        return PragmaKindFlags2;
    })(PragmaKindFlags || {});
    var commentPragmas = {
        "reference": {
            args: [
                {
                    name: "types",
                    optional: true,
                    captureSpan: true
                },
                {
                    name: "lib",
                    optional: true,
                    captureSpan: true
                },
                {
                    name: "path",
                    optional: true,
                    captureSpan: true
                },
                {
                    name: "no-default-lib",
                    optional: true
                },
                {
                    name: "resolution-mode",
                    optional: true
                },
                {
                    name: "preserve",
                    optional: true
                }
            ],
            kind: 1 /* TripleSlashXML */ 
        },
        "amd-dependency": {
            args: [
                {
                    name: "path"
                },
                {
                    name: "name",
                    optional: true
                }
            ],
            kind: 1 /* TripleSlashXML */ 
        },
        "amd-module": {
            args: [
                {
                    name: "name"
                }
            ],
            kind: 1 /* TripleSlashXML */ 
        },
        "ts-check": {
            kind: 2 /* SingleLine */ 
        },
        "ts-nocheck": {
            kind: 2 /* SingleLine */ 
        },
        "jsx": {
            args: [
                {
                    name: "factory"
                }
            ],
            kind: 4 /* MultiLine */ 
        },
        "jsxfrag": {
            args: [
                {
                    name: "factory"
                }
            ],
            kind: 4 /* MultiLine */ 
        },
        "jsximportsource": {
            args: [
                {
                    name: "factory"
                }
            ],
            kind: 4 /* MultiLine */ 
        },
        "jsxruntime": {
            args: [
                {
                    name: "factory"
                }
            ],
            kind: 4 /* MultiLine */ 
        }
    };
    var JSDocParsingMode = /* @__PURE__ */ ((JSDocParsingMode6)=>{
        JSDocParsingMode6[JSDocParsingMode6["ParseAll"] = 0] = "ParseAll";
        JSDocParsingMode6[JSDocParsingMode6["ParseNone"] = 1] = "ParseNone";
        JSDocParsingMode6[JSDocParsingMode6["ParseForTypeErrors"] = 2] = "ParseForTypeErrors";
        JSDocParsingMode6[JSDocParsingMode6["ParseForTypeInfo"] = 3] = "ParseForTypeInfo";
        return JSDocParsingMode6;
    })(JSDocParsingMode || {});
    // src/compiler/sys.ts
    function generateDjb2Hash(data) {
        let acc = 5381;
        for(let i = 0; i < data.length; i++)acc = (acc << 5) + acc + data.charCodeAt(i);
        return acc.toString();
    }
    function setStackTraceLimit() {
        if (Error.stackTraceLimit < 100) Error.stackTraceLimit = 100;
    }
    var FileWatcherEventKind = /* @__PURE__ */ ((FileWatcherEventKind2)=>{
        FileWatcherEventKind2[FileWatcherEventKind2["Created"] = 0] = "Created";
        FileWatcherEventKind2[FileWatcherEventKind2["Changed"] = 1] = "Changed";
        FileWatcherEventKind2[FileWatcherEventKind2["Deleted"] = 2] = "Deleted";
        return FileWatcherEventKind2;
    })(FileWatcherEventKind || {});
    var PollingInterval = /* @__PURE__ */ ((PollingInterval3)=>{
        PollingInterval3[PollingInterval3["High"] = 2e3] = "High";
        PollingInterval3[PollingInterval3["Medium"] = 500] = "Medium";
        PollingInterval3[PollingInterval3["Low"] = 250] = "Low";
        return PollingInterval3;
    })(PollingInterval || {});
    var missingFileModifiedTime = /* @__PURE__ */ new Date(0);
    function getModifiedTime(host, fileName) {
        return host.getModifiedTime(fileName) || missingFileModifiedTime;
    }
    function createPollingIntervalBasedLevels(levels) {
        return {
            [250 /* Low */ ]: levels.Low,
            [500 /* Medium */ ]: levels.Medium,
            [2e3 /* High */ ]: levels.High
        };
    }
    var defaultChunkLevels = {
        Low: 32,
        Medium: 64,
        High: 256
    };
    var pollingChunkSize = createPollingIntervalBasedLevels(defaultChunkLevels);
    var unchangedPollThresholds = createPollingIntervalBasedLevels(defaultChunkLevels);
    function setCustomPollingValues(system) {
        if (!system.getEnvironmentVariable) return;
        const pollingIntervalChanged = setCustomLevels("TSC_WATCH_POLLINGINTERVAL", PollingInterval);
        pollingChunkSize = getCustomPollingBasedLevels("TSC_WATCH_POLLINGCHUNKSIZE", defaultChunkLevels) || pollingChunkSize;
        unchangedPollThresholds = getCustomPollingBasedLevels("TSC_WATCH_UNCHANGEDPOLLTHRESHOLDS", defaultChunkLevels) || unchangedPollThresholds;
        function getLevel(envVar, level) {
            return system.getEnvironmentVariable(`${envVar}_${level.toUpperCase()}`);
        }
        function getCustomLevels(baseVariable) {
            let customLevels;
            setCustomLevel("Low");
            setCustomLevel("Medium");
            setCustomLevel("High");
            return customLevels;
            function setCustomLevel(level) {
                const customLevel = getLevel(baseVariable, level);
                if (customLevel) (customLevels || (customLevels = {}))[level] = Number(customLevel);
            }
        }
        function setCustomLevels(baseVariable, levels) {
            const customLevels = getCustomLevels(baseVariable);
            if (customLevels) {
                setLevel("Low");
                setLevel("Medium");
                setLevel("High");
                return true;
            }
            return false;
            function setLevel(level) {
                levels[level] = customLevels[level] || levels[level];
            }
        }
        function getCustomPollingBasedLevels(baseVariable, defaultLevels) {
            const customLevels = getCustomLevels(baseVariable);
            return (pollingIntervalChanged || customLevels) && createPollingIntervalBasedLevels(customLevels ? (0, _objectSpread._)({}, defaultLevels, customLevels) : defaultLevels);
        }
    }
    function pollWatchedFileQueue(host, queue, pollIndex, chunkSize, callbackOnWatchFileStat) {
        let definedValueCopyToIndex = pollIndex;
        for(let canVisit = queue.length; chunkSize && canVisit; nextPollIndex(), canVisit--){
            const watchedFile = queue[pollIndex];
            if (!watchedFile) continue;
            else if (watchedFile.isClosed) {
                queue[pollIndex] = void 0;
                continue;
            }
            chunkSize--;
            const fileChanged = onWatchedFileStat(watchedFile, getModifiedTime(host, watchedFile.fileName));
            if (watchedFile.isClosed) {
                queue[pollIndex] = void 0;
                continue;
            }
            callbackOnWatchFileStat == null || callbackOnWatchFileStat(watchedFile, pollIndex, fileChanged);
            if (queue[pollIndex]) {
                if (definedValueCopyToIndex < pollIndex) {
                    queue[definedValueCopyToIndex] = watchedFile;
                    queue[pollIndex] = void 0;
                }
                definedValueCopyToIndex++;
            }
        }
        return pollIndex;
        function nextPollIndex() {
            pollIndex++;
            if (pollIndex === queue.length) {
                if (definedValueCopyToIndex < pollIndex) queue.length = definedValueCopyToIndex;
                pollIndex = 0;
                definedValueCopyToIndex = 0;
            }
        }
    }
    function createDynamicPriorityPollingWatchFile(host) {
        const watchedFiles = [];
        const changedFilesInLastPoll = [];
        const lowPollingIntervalQueue = createPollingIntervalQueue(250 /* Low */ );
        const mediumPollingIntervalQueue = createPollingIntervalQueue(500 /* Medium */ );
        const highPollingIntervalQueue = createPollingIntervalQueue(2e3 /* High */ );
        return watchFile2;
        function watchFile2(fileName, callback, defaultPollingInterval) {
            const file = {
                fileName,
                callback,
                unchangedPolls: 0,
                mtime: getModifiedTime(host, fileName)
            };
            watchedFiles.push(file);
            addToPollingIntervalQueue(file, defaultPollingInterval);
            return {
                close: ()=>{
                    file.isClosed = true;
                    unorderedRemoveItem(watchedFiles, file);
                }
            };
        }
        function createPollingIntervalQueue(pollingInterval) {
            const queue = [];
            queue.pollingInterval = pollingInterval;
            queue.pollIndex = 0;
            queue.pollScheduled = false;
            return queue;
        }
        function pollPollingIntervalQueue(_timeoutType, queue) {
            queue.pollIndex = pollQueue(queue, queue.pollingInterval, queue.pollIndex, pollingChunkSize[queue.pollingInterval]);
            if (queue.length) scheduleNextPoll(queue.pollingInterval);
            else {
                Debug.assert(queue.pollIndex === 0);
                queue.pollScheduled = false;
            }
        }
        function pollLowPollingIntervalQueue(_timeoutType, queue) {
            pollQueue(changedFilesInLastPoll, 250 /* Low */ , /*pollIndex*/ 0, changedFilesInLastPoll.length);
            pollPollingIntervalQueue(_timeoutType, queue);
            if (!queue.pollScheduled && changedFilesInLastPoll.length) scheduleNextPoll(250 /* Low */ );
        }
        function pollQueue(queue, pollingInterval, pollIndex, chunkSize) {
            return pollWatchedFileQueue(host, queue, pollIndex, chunkSize, onWatchFileStat);
            function onWatchFileStat(watchedFile, pollIndex2, fileChanged) {
                if (fileChanged) {
                    watchedFile.unchangedPolls = 0;
                    if (queue !== changedFilesInLastPoll) {
                        queue[pollIndex2] = void 0;
                        addChangedFileToLowPollingIntervalQueue(watchedFile);
                    }
                } else if (watchedFile.unchangedPolls !== unchangedPollThresholds[pollingInterval]) watchedFile.unchangedPolls++;
                else if (queue === changedFilesInLastPoll) {
                    watchedFile.unchangedPolls = 1;
                    queue[pollIndex2] = void 0;
                    addToPollingIntervalQueue(watchedFile, 250 /* Low */ );
                } else if (pollingInterval !== 2e3 /* High */ ) {
                    watchedFile.unchangedPolls++;
                    queue[pollIndex2] = void 0;
                    addToPollingIntervalQueue(watchedFile, pollingInterval === 250 /* Low */  ? 500 /* Medium */  : 2e3 /* High */ );
                }
            }
        }
        function pollingIntervalQueue(pollingInterval) {
            switch(pollingInterval){
                case 250 /* Low */ :
                    return lowPollingIntervalQueue;
                case 500 /* Medium */ :
                    return mediumPollingIntervalQueue;
                case 2e3 /* High */ :
                    return highPollingIntervalQueue;
            }
        }
        function addToPollingIntervalQueue(file, pollingInterval) {
            pollingIntervalQueue(pollingInterval).push(file);
            scheduleNextPollIfNotAlreadyScheduled(pollingInterval);
        }
        function addChangedFileToLowPollingIntervalQueue(file) {
            changedFilesInLastPoll.push(file);
            scheduleNextPollIfNotAlreadyScheduled(250 /* Low */ );
        }
        function scheduleNextPollIfNotAlreadyScheduled(pollingInterval) {
            if (!pollingIntervalQueue(pollingInterval).pollScheduled) scheduleNextPoll(pollingInterval);
        }
        function scheduleNextPoll(pollingInterval) {
            pollingIntervalQueue(pollingInterval).pollScheduled = host.setTimeout(pollingInterval === 250 /* Low */  ? pollLowPollingIntervalQueue : pollPollingIntervalQueue, pollingInterval, pollingInterval === 250 /* Low */  ? "pollLowPollingIntervalQueue" : "pollPollingIntervalQueue", pollingIntervalQueue(pollingInterval));
        }
    }
    function createUseFsEventsOnParentDirectoryWatchFile(fsWatch, useCaseSensitiveFileNames2, getModifiedTime3, fsWatchWithTimestamp) {
        const fileWatcherCallbacks = createMultiMap();
        const fileTimestamps = fsWatchWithTimestamp ? /* @__PURE__ */ new Map() : void 0;
        const dirWatchers = /* @__PURE__ */ new Map();
        const toCanonicalName = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        return nonPollingWatchFile;
        function nonPollingWatchFile(fileName, callback, _pollingInterval, fallbackOptions) {
            const filePath = toCanonicalName(fileName);
            if (fileWatcherCallbacks.add(filePath, callback).length === 1 && fileTimestamps) fileTimestamps.set(filePath, getModifiedTime3(fileName) || missingFileModifiedTime);
            const dirPath = getDirectoryPath(filePath) || ".";
            const watcher = dirWatchers.get(dirPath) || createDirectoryWatcher(getDirectoryPath(fileName) || ".", dirPath, fallbackOptions);
            watcher.referenceCount++;
            return {
                close: ()=>{
                    if (watcher.referenceCount === 1) {
                        watcher.close();
                        dirWatchers.delete(dirPath);
                    } else watcher.referenceCount--;
                    fileWatcherCallbacks.remove(filePath, callback);
                }
            };
        }
        function createDirectoryWatcher(dirName, dirPath, fallbackOptions) {
            const watcher = fsWatch(dirName, 1 /* Directory */ , (eventName, relativeFileName)=>{
                if (!isString(relativeFileName)) return;
                const fileName = getNormalizedAbsolutePath(relativeFileName, dirName);
                const filePath = toCanonicalName(fileName);
                const callbacks = fileName && fileWatcherCallbacks.get(filePath);
                if (callbacks) {
                    let currentModifiedTime;
                    let eventKind = 1 /* Changed */ ;
                    if (fileTimestamps) {
                        const existingTime = fileTimestamps.get(filePath);
                        if (eventName === "change") {
                            currentModifiedTime = getModifiedTime3(fileName) || missingFileModifiedTime;
                            if (currentModifiedTime.getTime() === existingTime.getTime()) return;
                        }
                        currentModifiedTime || (currentModifiedTime = getModifiedTime3(fileName) || missingFileModifiedTime);
                        fileTimestamps.set(filePath, currentModifiedTime);
                        if (existingTime === missingFileModifiedTime) eventKind = 0 /* Created */ ;
                        else if (currentModifiedTime === missingFileModifiedTime) eventKind = 2 /* Deleted */ ;
                    }
                    for (const fileCallback of callbacks)fileCallback(fileName, eventKind, currentModifiedTime);
                }
            }, /*recursive*/ false, 500 /* Medium */ , fallbackOptions);
            watcher.referenceCount = 0;
            dirWatchers.set(dirPath, watcher);
            return watcher;
        }
    }
    function createFixedChunkSizePollingWatchFile(host) {
        const watchedFiles = [];
        let pollIndex = 0;
        let pollScheduled;
        return watchFile2;
        function watchFile2(fileName, callback) {
            const file = {
                fileName,
                callback,
                mtime: getModifiedTime(host, fileName)
            };
            watchedFiles.push(file);
            scheduleNextPoll();
            return {
                close: ()=>{
                    file.isClosed = true;
                    unorderedRemoveItem(watchedFiles, file);
                }
            };
        }
        function pollQueue() {
            pollScheduled = void 0;
            pollIndex = pollWatchedFileQueue(host, watchedFiles, pollIndex, pollingChunkSize[250 /* Low */ ]);
            scheduleNextPoll();
        }
        function scheduleNextPoll() {
            if (!watchedFiles.length || pollScheduled) return;
            pollScheduled = host.setTimeout(pollQueue, 2e3 /* High */ , "pollQueue");
        }
    }
    function createSingleWatcherPerName(cache, useCaseSensitiveFileNames2, name, callback, createWatcher) {
        const toCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        const path = toCanonicalFileName(name);
        const existing = cache.get(path);
        if (existing) existing.callbacks.push(callback);
        else cache.set(path, {
            watcher: createWatcher(// Cant infer types correctly so lets satisfy checker
            (param1, param2, param3)=>{
                var _a;
                return (_a = cache.get(path)) == null ? void 0 : _a.callbacks.slice().forEach((cb)=>cb(param1, param2, param3));
            }),
            callbacks: [
                callback
            ]
        });
        return {
            close: ()=>{
                const watcher = cache.get(path);
                if (!watcher) return;
                if (!orderedRemoveItem(watcher.callbacks, callback) || watcher.callbacks.length) return;
                cache.delete(path);
                closeFileWatcherOf(watcher);
            }
        };
    }
    function onWatchedFileStat(watchedFile, modifiedTime) {
        const oldTime = watchedFile.mtime.getTime();
        const newTime = modifiedTime.getTime();
        if (oldTime !== newTime) {
            watchedFile.mtime = modifiedTime;
            watchedFile.callback(watchedFile.fileName, getFileWatcherEventKind(oldTime, newTime), modifiedTime);
            return true;
        }
        return false;
    }
    function getFileWatcherEventKind(oldTime, newTime) {
        return oldTime === 0 ? 0 /* Created */  : newTime === 0 ? 2 /* Deleted */  : 1 /* Changed */ ;
    }
    var ignoredPaths = [
        "/node_modules/.",
        "/.git",
        "/.#"
    ];
    var curSysLog = noop;
    function sysLog(s) {
        return curSysLog(s);
    }
    function setSysLog(logger) {
        curSysLog = logger;
    }
    function createDirectoryWatcherSupportingRecursive({ watchDirectory, useCaseSensitiveFileNames: useCaseSensitiveFileNames2, getCurrentDirectory, getAccessibleSortedChildDirectories, fileSystemEntryExists, realpath, setTimeout: setTimeout2, clearTimeout: clearTimeout2 }) {
        const cache = /* @__PURE__ */ new Map();
        const callbackCache = createMultiMap();
        const cacheToUpdateChildWatches = /* @__PURE__ */ new Map();
        let timerToUpdateChildWatches;
        const filePathComparer = getStringComparer(!useCaseSensitiveFileNames2);
        const toCanonicalFilePath = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        return (dirName, callback, recursive, options)=>recursive ? createDirectoryWatcher(dirName, options, callback) : watchDirectory(dirName, callback, recursive, options);
        function createDirectoryWatcher(dirName, options, callback, link) {
            const dirPath = toCanonicalFilePath(dirName);
            let directoryWatcher = cache.get(dirPath);
            if (directoryWatcher) directoryWatcher.refCount++;
            else {
                directoryWatcher = {
                    watcher: watchDirectory(dirName, (fileName)=>{
                        var _a;
                        if (isIgnoredPath(fileName, options)) return;
                        if (options == null ? void 0 : options.synchronousWatchDirectory) {
                            if (!((_a = cache.get(dirPath)) == null ? void 0 : _a.targetWatcher)) invokeCallbacks(dirName, dirPath, fileName);
                            updateChildWatches(dirName, dirPath, options);
                        } else nonSyncUpdateChildWatches(dirName, dirPath, fileName, options);
                    }, /*recursive*/ false, options),
                    refCount: 1,
                    childWatches: emptyArray,
                    targetWatcher: void 0,
                    links: void 0
                };
                cache.set(dirPath, directoryWatcher);
                updateChildWatches(dirName, dirPath, options);
            }
            var _directoryWatcher_links;
            if (link) ((_directoryWatcher_links = directoryWatcher.links) !== null && _directoryWatcher_links !== void 0 ? _directoryWatcher_links : directoryWatcher.links = /* @__PURE__ */ new Set()).add(link);
            const callbackToAdd = callback && {
                dirName,
                callback
            };
            if (callbackToAdd) callbackCache.add(dirPath, callbackToAdd);
            return {
                dirName,
                close: ()=>{
                    var _a;
                    const directoryWatcher2 = Debug.checkDefined(cache.get(dirPath));
                    if (callbackToAdd) callbackCache.remove(dirPath, callbackToAdd);
                    if (link) (_a = directoryWatcher2.links) == null || _a.delete(link);
                    directoryWatcher2.refCount--;
                    if (directoryWatcher2.refCount) return;
                    cache.delete(dirPath);
                    directoryWatcher2.links = void 0;
                    closeFileWatcherOf(directoryWatcher2);
                    closeTargetWatcher(directoryWatcher2);
                    directoryWatcher2.childWatches.forEach(closeFileWatcher);
                }
            };
        }
        function invokeCallbacks(dirName, dirPath, fileNameOrInvokeMap, fileNames) {
            var _a, _b;
            let fileName;
            let invokeMap;
            if (isString(fileNameOrInvokeMap)) fileName = fileNameOrInvokeMap;
            else invokeMap = fileNameOrInvokeMap;
            callbackCache.forEach((callbacks, rootDirName)=>{
                if (invokeMap && invokeMap.get(rootDirName) === true) return;
                if (rootDirName === dirPath || startsWith(dirPath, rootDirName) && dirPath[rootDirName.length] === directorySeparator) {
                    if (invokeMap) {
                        if (fileNames) {
                            const existing = invokeMap.get(rootDirName);
                            if (existing) existing.push(...fileNames);
                            else invokeMap.set(rootDirName, fileNames.slice());
                        } else invokeMap.set(rootDirName, true);
                    } else callbacks.forEach(({ callback })=>callback(fileName));
                }
            });
            (_b = (_a = cache.get(dirPath)) == null ? void 0 : _a.links) == null || _b.forEach((link)=>{
                const toPathInLink = (fileName2)=>combinePaths(link, getRelativePathFromDirectory(dirName, fileName2, toCanonicalFilePath));
                if (invokeMap) invokeCallbacks(link, toCanonicalFilePath(link), invokeMap, fileNames == null ? void 0 : fileNames.map(toPathInLink));
                else invokeCallbacks(link, toCanonicalFilePath(link), toPathInLink(fileName));
            });
        }
        function nonSyncUpdateChildWatches(dirName, dirPath, fileName, options) {
            const parentWatcher = cache.get(dirPath);
            if (parentWatcher && fileSystemEntryExists(dirName, 1 /* Directory */ )) {
                scheduleUpdateChildWatches(dirName, dirPath, fileName, options);
                return;
            }
            invokeCallbacks(dirName, dirPath, fileName);
            closeTargetWatcher(parentWatcher);
            removeChildWatches(parentWatcher);
        }
        function scheduleUpdateChildWatches(dirName, dirPath, fileName, options) {
            const existing = cacheToUpdateChildWatches.get(dirPath);
            if (existing) existing.fileNames.push(fileName);
            else cacheToUpdateChildWatches.set(dirPath, {
                dirName,
                options,
                fileNames: [
                    fileName
                ]
            });
            if (timerToUpdateChildWatches) {
                clearTimeout2(timerToUpdateChildWatches);
                timerToUpdateChildWatches = void 0;
            }
            timerToUpdateChildWatches = setTimeout2(onTimerToUpdateChildWatches, 1e3, "timerToUpdateChildWatches");
        }
        function onTimerToUpdateChildWatches() {
            var _a;
            timerToUpdateChildWatches = void 0;
            sysLog(`sysLog:: onTimerToUpdateChildWatches:: ${cacheToUpdateChildWatches.size}`);
            const start = timestamp();
            const invokeMap = /* @__PURE__ */ new Map();
            while(!timerToUpdateChildWatches && cacheToUpdateChildWatches.size){
                const result = cacheToUpdateChildWatches.entries().next();
                Debug.assert(!result.done);
                const { value: [dirPath, { dirName, options, fileNames }] } = result;
                cacheToUpdateChildWatches.delete(dirPath);
                const hasChanges = updateChildWatches(dirName, dirPath, options);
                if (!((_a = cache.get(dirPath)) == null ? void 0 : _a.targetWatcher)) invokeCallbacks(dirName, dirPath, invokeMap, hasChanges ? void 0 : fileNames);
            }
            sysLog(`sysLog:: invokingWatchers:: Elapsed:: ${timestamp() - start}ms:: ${cacheToUpdateChildWatches.size}`);
            callbackCache.forEach((callbacks, rootDirName)=>{
                const existing = invokeMap.get(rootDirName);
                if (existing) callbacks.forEach(({ callback, dirName })=>{
                    if (isArray(existing)) existing.forEach(callback);
                    else callback(dirName);
                });
            });
            const elapsed = timestamp() - start;
            sysLog(`sysLog:: Elapsed:: ${elapsed}ms:: onTimerToUpdateChildWatches:: ${cacheToUpdateChildWatches.size} ${timerToUpdateChildWatches}`);
        }
        function removeChildWatches(parentWatcher) {
            if (!parentWatcher) return;
            const existingChildWatches = parentWatcher.childWatches;
            parentWatcher.childWatches = emptyArray;
            for (const childWatcher of existingChildWatches){
                childWatcher.close();
                removeChildWatches(cache.get(toCanonicalFilePath(childWatcher.dirName)));
            }
        }
        function closeTargetWatcher(watcher) {
            if (watcher == null ? void 0 : watcher.targetWatcher) {
                watcher.targetWatcher.close();
                watcher.targetWatcher = void 0;
            }
        }
        function updateChildWatches(parentDir, parentDirPath, options) {
            const parentWatcher = cache.get(parentDirPath);
            if (!parentWatcher) return false;
            const target = normalizePath(realpath(parentDir));
            let hasChanges;
            let newChildWatches;
            if (filePathComparer(target, parentDir) === 0 /* EqualTo */ ) hasChanges = enumerateInsertsAndDeletes(fileSystemEntryExists(parentDir, 1 /* Directory */ ) ? mapDefined(getAccessibleSortedChildDirectories(parentDir), (child)=>{
                const childFullName = getNormalizedAbsolutePath(child, parentDir);
                return !isIgnoredPath(childFullName, options) && filePathComparer(childFullName, normalizePath(realpath(childFullName))) === 0 /* EqualTo */  ? childFullName : void 0;
            }) : emptyArray, parentWatcher.childWatches, (child, childWatcher)=>filePathComparer(child, childWatcher.dirName), createAndAddChildDirectoryWatcher, closeFileWatcher, addChildDirectoryWatcher);
            else if (parentWatcher.targetWatcher && filePathComparer(target, parentWatcher.targetWatcher.dirName) === 0 /* EqualTo */ ) {
                hasChanges = false;
                Debug.assert(parentWatcher.childWatches === emptyArray);
            } else {
                closeTargetWatcher(parentWatcher);
                parentWatcher.targetWatcher = createDirectoryWatcher(target, options, /*callback*/ void 0, parentDir);
                parentWatcher.childWatches.forEach(closeFileWatcher);
                hasChanges = true;
            }
            parentWatcher.childWatches = newChildWatches || emptyArray;
            return hasChanges;
            function createAndAddChildDirectoryWatcher(childName) {
                const result = createDirectoryWatcher(childName, options);
                addChildDirectoryWatcher(result);
            }
            function addChildDirectoryWatcher(childWatcher) {
                (newChildWatches || (newChildWatches = [])).push(childWatcher);
            }
        }
        function isIgnoredPath(path, options) {
            return some(ignoredPaths, (searchPath)=>isInPath(path, searchPath)) || isIgnoredByWatchOptions(path, options, useCaseSensitiveFileNames2, getCurrentDirectory);
        }
        function isInPath(path, searchPath) {
            if (path.includes(searchPath)) return true;
            if (useCaseSensitiveFileNames2) return false;
            return toCanonicalFilePath(path).includes(searchPath);
        }
    }
    var FileSystemEntryKind = /* @__PURE__ */ ((FileSystemEntryKind2)=>{
        FileSystemEntryKind2[FileSystemEntryKind2["File"] = 0] = "File";
        FileSystemEntryKind2[FileSystemEntryKind2["Directory"] = 1] = "Directory";
        return FileSystemEntryKind2;
    })(FileSystemEntryKind || {});
    function createFileWatcherCallback(callback) {
        return (_fileName, eventKind, modifiedTime)=>callback(eventKind === 1 /* Changed */  ? "change" : "rename", "", modifiedTime);
    }
    function createFsWatchCallbackForFileWatcherCallback(fileName, callback, getModifiedTime3) {
        return (eventName, _relativeFileName, modifiedTime)=>{
            if (eventName === "rename") {
                modifiedTime || (modifiedTime = getModifiedTime3(fileName) || missingFileModifiedTime);
                callback(fileName, modifiedTime !== missingFileModifiedTime ? 0 /* Created */  : 2 /* Deleted */ , modifiedTime);
            } else callback(fileName, 1 /* Changed */ , modifiedTime);
        };
    }
    function isIgnoredByWatchOptions(pathToCheck, options, useCaseSensitiveFileNames2, getCurrentDirectory) {
        return ((options == null ? void 0 : options.excludeDirectories) || (options == null ? void 0 : options.excludeFiles)) && (matchesExclude(pathToCheck, options == null ? void 0 : options.excludeFiles, useCaseSensitiveFileNames2, getCurrentDirectory()) || matchesExclude(pathToCheck, options == null ? void 0 : options.excludeDirectories, useCaseSensitiveFileNames2, getCurrentDirectory()));
    }
    function createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback, options, useCaseSensitiveFileNames2, getCurrentDirectory) {
        return (eventName, relativeFileName)=>{
            if (eventName === "rename") {
                const fileName = !relativeFileName ? directoryName : normalizePath(combinePaths(directoryName, relativeFileName));
                if (!relativeFileName || !isIgnoredByWatchOptions(fileName, options, useCaseSensitiveFileNames2, getCurrentDirectory)) callback(fileName);
            }
        };
    }
    function createSystemWatchFunctions({ pollingWatchFileWorker, getModifiedTime: getModifiedTime3, setTimeout: setTimeout2, clearTimeout: clearTimeout2, fsWatchWorker, fileSystemEntryExists, useCaseSensitiveFileNames: useCaseSensitiveFileNames2, getCurrentDirectory, fsSupportsRecursiveFsWatch, getAccessibleSortedChildDirectories, realpath, tscWatchFile, useNonPollingWatchers, tscWatchDirectory, inodeWatching, fsWatchWithTimestamp, sysLog: sysLog2 }) {
        const pollingWatches = /* @__PURE__ */ new Map();
        const fsWatches = /* @__PURE__ */ new Map();
        const fsWatchesRecursive = /* @__PURE__ */ new Map();
        let dynamicPollingWatchFile;
        let fixedChunkSizePollingWatchFile;
        let nonPollingWatchFile;
        let hostRecursiveDirectoryWatcher;
        let hitSystemWatcherLimit = false;
        return {
            watchFile: watchFile2,
            watchDirectory
        };
        function watchFile2(fileName, callback, pollingInterval, options) {
            options = updateOptionsForWatchFile(options, useNonPollingWatchers);
            const watchFileKind = Debug.checkDefined(options.watchFile);
            switch(watchFileKind){
                case 0 /* FixedPollingInterval */ :
                    return pollingWatchFile(fileName, callback, 250 /* Low */ , /*options*/ void 0);
                case 1 /* PriorityPollingInterval */ :
                    return pollingWatchFile(fileName, callback, pollingInterval, /*options*/ void 0);
                case 2 /* DynamicPriorityPolling */ :
                    return ensureDynamicPollingWatchFile()(fileName, callback, pollingInterval, /*options*/ void 0);
                case 3 /* FixedChunkSizePolling */ :
                    return ensureFixedChunkSizePollingWatchFile()(fileName, callback, /* pollingInterval */ void 0, /*options*/ void 0);
                case 4 /* UseFsEvents */ :
                    return fsWatch(fileName, 0 /* File */ , createFsWatchCallbackForFileWatcherCallback(fileName, callback, getModifiedTime3), /*recursive*/ false, pollingInterval, getFallbackOptions(options));
                case 5 /* UseFsEventsOnParentDirectory */ :
                    if (!nonPollingWatchFile) nonPollingWatchFile = createUseFsEventsOnParentDirectoryWatchFile(fsWatch, useCaseSensitiveFileNames2, getModifiedTime3, fsWatchWithTimestamp);
                    return nonPollingWatchFile(fileName, callback, pollingInterval, getFallbackOptions(options));
                default:
                    Debug.assertNever(watchFileKind);
            }
        }
        function ensureDynamicPollingWatchFile() {
            return dynamicPollingWatchFile || (dynamicPollingWatchFile = createDynamicPriorityPollingWatchFile({
                getModifiedTime: getModifiedTime3,
                setTimeout: setTimeout2
            }));
        }
        function ensureFixedChunkSizePollingWatchFile() {
            return fixedChunkSizePollingWatchFile || (fixedChunkSizePollingWatchFile = createFixedChunkSizePollingWatchFile({
                getModifiedTime: getModifiedTime3,
                setTimeout: setTimeout2
            }));
        }
        function updateOptionsForWatchFile(options, useNonPollingWatchers2) {
            if (options && options.watchFile !== void 0) return options;
            switch(tscWatchFile){
                case "PriorityPollingInterval":
                    return {
                        watchFile: 1 /* PriorityPollingInterval */ 
                    };
                case "DynamicPriorityPolling":
                    return {
                        watchFile: 2 /* DynamicPriorityPolling */ 
                    };
                case "UseFsEvents":
                    return generateWatchFileOptions(4 /* UseFsEvents */ , 1 /* PriorityInterval */ , options);
                case "UseFsEventsWithFallbackDynamicPolling":
                    return generateWatchFileOptions(4 /* UseFsEvents */ , 2 /* DynamicPriority */ , options);
                case "UseFsEventsOnParentDirectory":
                    useNonPollingWatchers2 = true;
                // fall through
                default:
                    return useNonPollingWatchers2 ? // Use notifications from FS to watch with falling back to fs.watchFile
                    generateWatchFileOptions(5 /* UseFsEventsOnParentDirectory */ , 1 /* PriorityInterval */ , options) : // Default to using fs events
                    {
                        watchFile: 4 /* UseFsEvents */ 
                    };
            }
        }
        function generateWatchFileOptions(watchFile3, fallbackPolling, options) {
            const defaultFallbackPolling = options == null ? void 0 : options.fallbackPolling;
            return {
                watchFile: watchFile3,
                fallbackPolling: defaultFallbackPolling === void 0 ? fallbackPolling : defaultFallbackPolling
            };
        }
        function watchDirectory(directoryName, callback, recursive, options) {
            if (fsSupportsRecursiveFsWatch) return fsWatch(directoryName, 1 /* Directory */ , createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback, options, useCaseSensitiveFileNames2, getCurrentDirectory), recursive, 500 /* Medium */ , getFallbackOptions(options));
            if (!hostRecursiveDirectoryWatcher) hostRecursiveDirectoryWatcher = createDirectoryWatcherSupportingRecursive({
                useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
                getCurrentDirectory,
                fileSystemEntryExists,
                getAccessibleSortedChildDirectories,
                watchDirectory: nonRecursiveWatchDirectory,
                realpath,
                setTimeout: setTimeout2,
                clearTimeout: clearTimeout2
            });
            return hostRecursiveDirectoryWatcher(directoryName, callback, recursive, options);
        }
        function nonRecursiveWatchDirectory(directoryName, callback, recursive, options) {
            Debug.assert(!recursive);
            const watchDirectoryOptions = updateOptionsForWatchDirectory(options);
            const watchDirectoryKind = Debug.checkDefined(watchDirectoryOptions.watchDirectory);
            switch(watchDirectoryKind){
                case 1 /* FixedPollingInterval */ :
                    return pollingWatchFile(directoryName, ()=>callback(directoryName), 500 /* Medium */ , /*options*/ void 0);
                case 2 /* DynamicPriorityPolling */ :
                    return ensureDynamicPollingWatchFile()(directoryName, ()=>callback(directoryName), 500 /* Medium */ , /*options*/ void 0);
                case 3 /* FixedChunkSizePolling */ :
                    return ensureFixedChunkSizePollingWatchFile()(directoryName, ()=>callback(directoryName), /* pollingInterval */ void 0, /*options*/ void 0);
                case 0 /* UseFsEvents */ :
                    return fsWatch(directoryName, 1 /* Directory */ , createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback, options, useCaseSensitiveFileNames2, getCurrentDirectory), recursive, 500 /* Medium */ , getFallbackOptions(watchDirectoryOptions));
                default:
                    Debug.assertNever(watchDirectoryKind);
            }
        }
        function updateOptionsForWatchDirectory(options) {
            if (options && options.watchDirectory !== void 0) return options;
            switch(tscWatchDirectory){
                case "RecursiveDirectoryUsingFsWatchFile":
                    return {
                        watchDirectory: 1 /* FixedPollingInterval */ 
                    };
                case "RecursiveDirectoryUsingDynamicPriorityPolling":
                    return {
                        watchDirectory: 2 /* DynamicPriorityPolling */ 
                    };
                default:
                    const defaultFallbackPolling = options == null ? void 0 : options.fallbackPolling;
                    return {
                        watchDirectory: 0 /* UseFsEvents */ ,
                        fallbackPolling: defaultFallbackPolling !== void 0 ? defaultFallbackPolling : void 0
                    };
            }
        }
        function pollingWatchFile(fileName, callback, pollingInterval, options) {
            return createSingleWatcherPerName(pollingWatches, useCaseSensitiveFileNames2, fileName, callback, (cb)=>pollingWatchFileWorker(fileName, cb, pollingInterval, options));
        }
        function fsWatch(fileOrDirectory, entryKind, callback, recursive, fallbackPollingInterval, fallbackOptions) {
            return createSingleWatcherPerName(recursive ? fsWatchesRecursive : fsWatches, useCaseSensitiveFileNames2, fileOrDirectory, callback, (cb)=>fsWatchHandlingExistenceOnHost(fileOrDirectory, entryKind, cb, recursive, fallbackPollingInterval, fallbackOptions));
        }
        function fsWatchHandlingExistenceOnHost(fileOrDirectory, entryKind, callback, recursive, fallbackPollingInterval, fallbackOptions) {
            let lastDirectoryPartWithDirectorySeparator;
            let lastDirectoryPart;
            if (inodeWatching) {
                lastDirectoryPartWithDirectorySeparator = fileOrDirectory.substring(fileOrDirectory.lastIndexOf(directorySeparator));
                lastDirectoryPart = lastDirectoryPartWithDirectorySeparator.slice(directorySeparator.length);
            }
            let watcher = !fileSystemEntryExists(fileOrDirectory, entryKind) ? watchMissingFileSystemEntry() : watchPresentFileSystemEntry();
            return {
                close: ()=>{
                    if (watcher) {
                        watcher.close();
                        watcher = void 0;
                    }
                }
            };
            function updateWatcher(createWatcher) {
                if (watcher) {
                    sysLog2(`sysLog:: ${fileOrDirectory}:: Changing watcher to ${createWatcher === watchPresentFileSystemEntry ? "Present" : "Missing"}FileSystemEntryWatcher`);
                    watcher.close();
                    watcher = createWatcher();
                }
            }
            function watchPresentFileSystemEntry() {
                if (hitSystemWatcherLimit) {
                    sysLog2(`sysLog:: ${fileOrDirectory}:: Defaulting to watchFile`);
                    return watchPresentFileSystemEntryWithFsWatchFile();
                }
                try {
                    const presentWatcher = (entryKind === 1 /* Directory */  || !fsWatchWithTimestamp ? fsWatchWorker : fsWatchWorkerHandlingTimestamp)(fileOrDirectory, recursive, inodeWatching ? callbackChangingToMissingFileSystemEntry : callback);
                    presentWatcher.on("error", ()=>{
                        callback("rename", "");
                        updateWatcher(watchMissingFileSystemEntry);
                    });
                    return presentWatcher;
                } catch (e) {
                    hitSystemWatcherLimit || (hitSystemWatcherLimit = e.code === "ENOSPC");
                    sysLog2(`sysLog:: ${fileOrDirectory}:: Changing to watchFile`);
                    return watchPresentFileSystemEntryWithFsWatchFile();
                }
            }
            function callbackChangingToMissingFileSystemEntry(event, relativeName) {
                let originalRelativeName;
                if (relativeName && endsWith(relativeName, "~")) {
                    originalRelativeName = relativeName;
                    relativeName = relativeName.slice(0, relativeName.length - 1);
                }
                if (event === "rename" && (!relativeName || relativeName === lastDirectoryPart || endsWith(relativeName, lastDirectoryPartWithDirectorySeparator))) {
                    const modifiedTime = getModifiedTime3(fileOrDirectory) || missingFileModifiedTime;
                    if (originalRelativeName) callback(event, originalRelativeName, modifiedTime);
                    callback(event, relativeName, modifiedTime);
                    if (inodeWatching) updateWatcher(modifiedTime === missingFileModifiedTime ? watchMissingFileSystemEntry : watchPresentFileSystemEntry);
                    else if (modifiedTime === missingFileModifiedTime) updateWatcher(watchMissingFileSystemEntry);
                } else {
                    if (originalRelativeName) callback(event, originalRelativeName);
                    callback(event, relativeName);
                }
            }
            function watchPresentFileSystemEntryWithFsWatchFile() {
                return watchFile2(fileOrDirectory, createFileWatcherCallback(callback), fallbackPollingInterval, fallbackOptions);
            }
            function watchMissingFileSystemEntry() {
                return watchFile2(fileOrDirectory, (_fileName, eventKind, modifiedTime)=>{
                    if (eventKind === 0 /* Created */ ) {
                        modifiedTime || (modifiedTime = getModifiedTime3(fileOrDirectory) || missingFileModifiedTime);
                        if (modifiedTime !== missingFileModifiedTime) {
                            callback("rename", "", modifiedTime);
                            updateWatcher(watchPresentFileSystemEntry);
                        }
                    }
                }, fallbackPollingInterval, fallbackOptions);
            }
        }
        function fsWatchWorkerHandlingTimestamp(fileOrDirectory, recursive, callback) {
            let modifiedTime = getModifiedTime3(fileOrDirectory) || missingFileModifiedTime;
            return fsWatchWorker(fileOrDirectory, recursive, (eventName, relativeFileName, currentModifiedTime)=>{
                if (eventName === "change") {
                    currentModifiedTime || (currentModifiedTime = getModifiedTime3(fileOrDirectory) || missingFileModifiedTime);
                    if (currentModifiedTime.getTime() === modifiedTime.getTime()) return;
                }
                modifiedTime = currentModifiedTime || getModifiedTime3(fileOrDirectory) || missingFileModifiedTime;
                callback(eventName, relativeFileName, modifiedTime);
            });
        }
    }
    function patchWriteFileEnsuringDirectory(sys2) {
        const originalWriteFile = sys2.writeFile;
        sys2.writeFile = (path, data, writeBom)=>writeFileEnsuringDirectories(path, data, !!writeBom, (path2, data2, writeByteOrderMark)=>originalWriteFile.call(sys2, path2, data2, writeByteOrderMark), (path2)=>sys2.createDirectory(path2), (path2)=>sys2.directoryExists(path2));
    }
    var sys = (()=>{
        const byteOrderMarkIndicator = "\uFEFF";
        function getNodeSystem() {
            const nativePattern = /^native |^\([^)]+\)$|^(?:internal[\\/]|[\w\s]+(?:\.js)?$)/;
            const _fs = require("ab76108507da6451");
            const _path = require("84a2874c38c7e5af");
            const _os = require("6d5608769d2f4020");
            let _crypto;
            try {
                _crypto = require("b057e440c079efce");
            } catch (e) {
                _crypto = void 0;
            }
            let activeSession;
            let profilePath = "./profile.cpuprofile";
            const isMacOs = process.platform === "darwin";
            const isLinuxOrMacOs = process.platform === "linux" || isMacOs;
            const statSyncOptions = {
                throwIfNoEntry: false
            };
            const platform = _os.platform();
            const useCaseSensitiveFileNames2 = isFileSystemCaseSensitive();
            const fsRealpath = !!_fs.realpathSync.native ? process.platform === "win32" ? fsRealPathHandlingLongPath : _fs.realpathSync.native : _fs.realpathSync;
            const executingFilePath = __filename.endsWith("sys.js") ? _path.join(_path.dirname(__dirname), "__fake__.js") : __filename;
            const fsSupportsRecursiveFsWatch = process.platform === "win32" || isMacOs;
            const getCurrentDirectory = memoize(()=>process.cwd());
            const { watchFile: watchFile2, watchDirectory } = createSystemWatchFunctions({
                pollingWatchFileWorker: fsWatchFileWorker,
                getModifiedTime: getModifiedTime3,
                setTimeout,
                clearTimeout,
                fsWatchWorker,
                useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
                getCurrentDirectory,
                fileSystemEntryExists,
                // Node 4.0 `fs.watch` function supports the "recursive" option on both OSX and Windows
                // (ref: https://github.com/nodejs/node/pull/2649 and https://github.com/Microsoft/TypeScript/issues/4643)
                fsSupportsRecursiveFsWatch,
                getAccessibleSortedChildDirectories: (path)=>getAccessibleFileSystemEntries(path).directories,
                realpath,
                tscWatchFile: undefined,
                useNonPollingWatchers: false,
                tscWatchDirectory: undefined,
                inodeWatching: isLinuxOrMacOs,
                fsWatchWithTimestamp: isMacOs,
                sysLog
            });
            const nodeSystem = {
                args: process.argv.slice(2),
                newLine: _os.EOL,
                useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
                write (s) {
                    process.stdout.write(s);
                },
                getWidthOfTerminal () {
                    return process.stdout.columns;
                },
                writeOutputIsTTY () {
                    return process.stdout.isTTY;
                },
                readFile,
                writeFile: writeFile2,
                watchFile: watchFile2,
                watchDirectory,
                preferNonRecursiveWatch: !fsSupportsRecursiveFsWatch,
                resolvePath: (path)=>_path.resolve(path),
                fileExists,
                directoryExists,
                getAccessibleFileSystemEntries,
                createDirectory (directoryName) {
                    if (!nodeSystem.directoryExists(directoryName)) try {
                        _fs.mkdirSync(directoryName);
                    } catch (e) {
                        if (e.code !== "EEXIST") throw e;
                    }
                },
                getExecutingFilePath () {
                    return executingFilePath;
                },
                getCurrentDirectory,
                getDirectories,
                getEnvironmentVariable (name) {
                    return process.env[name] || "";
                },
                readDirectory,
                getModifiedTime: getModifiedTime3,
                setModifiedTime,
                deleteFile,
                createHash: _crypto ? createSHA256Hash : generateDjb2Hash,
                createSHA256Hash: _crypto ? createSHA256Hash : void 0,
                getMemoryUsage () {
                    if (global.gc) global.gc();
                    return process.memoryUsage().heapUsed;
                },
                getFileSize (path) {
                    const stat = statSync(path);
                    if (stat == null ? void 0 : stat.isFile()) return stat.size;
                    return 0;
                },
                exit (exitCode) {
                    disableCPUProfiler(()=>process.exit(exitCode));
                },
                enableCPUProfiler,
                disableCPUProfiler,
                cpuProfilingEnabled: ()=>!!activeSession || contains(process.execArgv, "--cpu-prof") || contains(process.execArgv, "--prof"),
                realpath,
                debugMode: some(process.execArgv, (arg)=>/^--(?:inspect|debug)(?:-brk)?(?:=\d+)?$/i.test(arg)) || !!process.recordreplay,
                tryEnableSourceMapsForHost () {
                    try {
                        require("e778f2031f24174f").install();
                    } catch (e) {}
                },
                setTimeout,
                clearTimeout,
                clearScreen: ()=>{
                    process.stdout.write("\x1B[2J\x1B[3J\x1B[H");
                },
                setBlocking: ()=>{
                    var _a;
                    const handle = (_a = process.stdout) == null ? void 0 : _a._handle;
                    if (handle && handle.setBlocking) handle.setBlocking(true);
                },
                base64decode: (input)=>Buffer.from(input, "base64").toString("utf8"),
                base64encode: (input)=>Buffer.from(input).toString("base64"),
                require: (baseDir, moduleName)=>{
                    try {
                        const modulePath = resolveJSModule(moduleName, baseDir, nodeSystem);
                        return {
                            module: require(modulePath),
                            modulePath,
                            error: void 0
                        };
                    } catch (error2) {
                        return {
                            module: void 0,
                            modulePath: void 0,
                            error: error2
                        };
                    }
                }
            };
            return nodeSystem;
            function statSync(path) {
                try {
                    return _fs.statSync(path, statSyncOptions);
                } catch (e) {
                    return void 0;
                }
            }
            function enableCPUProfiler(path, cb) {
                if (activeSession) {
                    cb();
                    return false;
                }
                const inspector = require("2f60673b96dc4a39");
                if (!inspector || !inspector.Session) {
                    cb();
                    return false;
                }
                const session = new inspector.Session();
                session.connect();
                session.post("Profiler.enable", ()=>{
                    session.post("Profiler.start", ()=>{
                        activeSession = session;
                        profilePath = path;
                        cb();
                    });
                });
                return true;
            }
            function cleanupPaths(profile) {
                let externalFileCounter = 0;
                const remappedPaths = /* @__PURE__ */ new Map();
                const normalizedDir = normalizeSlashes(_path.dirname(executingFilePath));
                const fileUrlRoot = `file://${getRootLength(normalizedDir) === 1 ? "" : "/"}${normalizedDir}`;
                for (const node of profile.nodes)if (node.callFrame.url) {
                    const url = normalizeSlashes(node.callFrame.url);
                    if (containsPath(fileUrlRoot, url, useCaseSensitiveFileNames2)) node.callFrame.url = getRelativePathToDirectoryOrUrl(fileUrlRoot, url, fileUrlRoot, createGetCanonicalFileName(useCaseSensitiveFileNames2), /*isAbsolutePathAnUrl*/ true);
                    else if (!nativePattern.test(url)) {
                        node.callFrame.url = (remappedPaths.has(url) ? remappedPaths : remappedPaths.set(url, `external${externalFileCounter}.js`)).get(url);
                        externalFileCounter++;
                    }
                }
                return profile;
            }
            function disableCPUProfiler(cb) {
                if (activeSession && activeSession !== "stopping") {
                    const s = activeSession;
                    activeSession.post("Profiler.stop", (err, { profile })=>{
                        var _a;
                        if (!err) {
                            if ((_a = statSync(profilePath)) == null ? void 0 : _a.isDirectory()) profilePath = _path.join(profilePath, `${/* @__PURE__ */ new Date().toISOString().replace(/:/g, "-")}+P${process.pid}.cpuprofile`);
                            try {
                                _fs.mkdirSync(_path.dirname(profilePath), {
                                    recursive: true
                                });
                            } catch (e) {}
                            _fs.writeFileSync(profilePath, JSON.stringify(cleanupPaths(profile)));
                        }
                        activeSession = void 0;
                        s.disconnect();
                        cb();
                    });
                    activeSession = "stopping";
                    return true;
                } else {
                    cb();
                    return false;
                }
            }
            function isFileSystemCaseSensitive() {
                if (platform === "win32" || platform === "win64") return false;
                return !fileExists(swapCase(__filename));
            }
            function swapCase(s) {
                return s.replace(/\w/g, (ch)=>{
                    const up = ch.toUpperCase();
                    return ch === up ? ch.toLowerCase() : up;
                });
            }
            function fsWatchFileWorker(fileName, callback, pollingInterval) {
                _fs.watchFile(fileName, {
                    persistent: true,
                    interval: pollingInterval
                }, fileChanged);
                let eventKind;
                return {
                    close: ()=>_fs.unwatchFile(fileName, fileChanged)
                };
                function fileChanged(curr, prev) {
                    const isPreviouslyDeleted = +prev.mtime === 0 || eventKind === 2 /* Deleted */ ;
                    if (+curr.mtime === 0) {
                        if (isPreviouslyDeleted) return;
                        eventKind = 2 /* Deleted */ ;
                    } else if (isPreviouslyDeleted) eventKind = 0 /* Created */ ;
                    else if (+curr.mtime === +prev.mtime) return;
                    else eventKind = 1 /* Changed */ ;
                    callback(fileName, eventKind, curr.mtime);
                }
            }
            function fsWatchWorker(fileOrDirectory, recursive, callback) {
                return _fs.watch(fileOrDirectory, fsSupportsRecursiveFsWatch ? {
                    persistent: true,
                    recursive: !!recursive
                } : {
                    persistent: true
                }, callback);
            }
            function readFile(fileName, _encoding) {
                let buffer;
                try {
                    buffer = _fs.readFileSync(fileName);
                } catch (e) {
                    return void 0;
                }
                let len = buffer.length;
                if (len >= 2 && buffer[0] === 254 && buffer[1] === 255) {
                    len &= -2;
                    for(let i = 0; i < len; i += 2){
                        const temp = buffer[i];
                        buffer[i] = buffer[i + 1];
                        buffer[i + 1] = temp;
                    }
                    return buffer.toString("utf16le", 2);
                }
                if (len >= 2 && buffer[0] === 255 && buffer[1] === 254) return buffer.toString("utf16le", 2);
                if (len >= 3 && buffer[0] === 239 && buffer[1] === 187 && buffer[2] === 191) return buffer.toString("utf8", 3);
                return buffer.toString("utf8");
            }
            function writeFile2(fileName, data, writeByteOrderMark) {
                if (writeByteOrderMark) data = byteOrderMarkIndicator + data;
                let fd;
                try {
                    fd = _fs.openSync(fileName, "w");
                    _fs.writeSync(fd, data, /*position*/ void 0, "utf8");
                } finally{
                    if (fd !== void 0) _fs.closeSync(fd);
                }
            }
            function getAccessibleFileSystemEntries(path) {
                try {
                    const entries = _fs.readdirSync(path || ".", {
                        withFileTypes: true
                    });
                    const files = [];
                    const directories = [];
                    for (const dirent of entries){
                        const entry = typeof dirent === "string" ? dirent : dirent.name;
                        if (entry === "." || entry === "..") continue;
                        let stat;
                        if (typeof dirent === "string" || dirent.isSymbolicLink()) {
                            const name = combinePaths(path, entry);
                            stat = statSync(name);
                            if (!stat) continue;
                        } else stat = dirent;
                        if (stat.isFile()) files.push(entry);
                        else if (stat.isDirectory()) directories.push(entry);
                    }
                    files.sort();
                    directories.sort();
                    return {
                        files,
                        directories
                    };
                } catch (e) {
                    return emptyFileSystemEntries;
                }
            }
            function readDirectory(path, extensions, excludes, includes, depth) {
                return matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames2, process.cwd(), depth, getAccessibleFileSystemEntries, realpath);
            }
            function fileSystemEntryExists(path, entryKind) {
                const stat = statSync(path);
                if (!stat) return false;
                switch(entryKind){
                    case 0 /* File */ :
                        return stat.isFile();
                    case 1 /* Directory */ :
                        return stat.isDirectory();
                    default:
                        return false;
                }
            }
            function fileExists(path) {
                return fileSystemEntryExists(path, 0 /* File */ );
            }
            function directoryExists(path) {
                return fileSystemEntryExists(path, 1 /* Directory */ );
            }
            function getDirectories(path) {
                return getAccessibleFileSystemEntries(path).directories.slice();
            }
            function fsRealPathHandlingLongPath(path) {
                return path.length < 260 ? _fs.realpathSync.native(path) : _fs.realpathSync(path);
            }
            function realpath(path) {
                try {
                    return fsRealpath(path);
                } catch (e) {
                    return path;
                }
            }
            function getModifiedTime3(path) {
                var _a;
                return (_a = statSync(path)) == null ? void 0 : _a.mtime;
            }
            function setModifiedTime(path, time) {
                try {
                    _fs.utimesSync(path, time, time);
                } catch (e) {
                    return;
                }
            }
            function deleteFile(path) {
                try {
                    return _fs.unlinkSync(path);
                } catch (e) {
                    return;
                }
            }
            function createSHA256Hash(data) {
                const hash = _crypto.createHash("sha256");
                hash.update(data);
                return hash.digest("hex");
            }
        }
        let sys2;
        if (isNodeLikeSystem()) sys2 = getNodeSystem();
        if (sys2) patchWriteFileEnsuringDirectory(sys2);
        return sys2;
    })();
    function setSys(s) {
        sys = s;
    }
    if (sys && sys.getEnvironmentVariable) {
        setCustomPollingValues(sys);
        Debug.setAssertionLevel(/^development$/i.test(sys.getEnvironmentVariable("NODE_ENV")) ? 1 /* Normal */  : 0 /* None */ );
    }
    if (sys && sys.debugMode) Debug.isDebugging = true;
    // src/compiler/path.ts
    var directorySeparator = "/";
    var altDirectorySeparator = "\\";
    var urlSchemeSeparator = "://";
    var backslashRegExp = /\\/g;
    function isAnyDirectorySeparator(charCode) {
        return charCode === 47 /* slash */  || charCode === 92 /* backslash */ ;
    }
    function isUrl(path) {
        return getEncodedRootLength(path) < 0;
    }
    function isRootedDiskPath(path) {
        return getEncodedRootLength(path) > 0;
    }
    function isDiskPathRoot(path) {
        const rootLength = getEncodedRootLength(path);
        return rootLength > 0 && rootLength === path.length;
    }
    function pathIsAbsolute(path) {
        return getEncodedRootLength(path) !== 0;
    }
    function pathIsRelative(path) {
        return /^\.\.?(?:$|[\\/])/.test(path);
    }
    function pathIsBareSpecifier(path) {
        return !pathIsAbsolute(path) && !pathIsRelative(path);
    }
    function hasExtension(fileName) {
        return getBaseFileName(fileName).includes(".");
    }
    function fileExtensionIs(path, extension) {
        return path.length > extension.length && endsWith(path, extension);
    }
    function fileExtensionIsOneOf(path, extensions) {
        for (const extension of extensions){
            if (fileExtensionIs(path, extension)) return true;
        }
        return false;
    }
    function hasTrailingDirectorySeparator(path) {
        return path.length > 0 && isAnyDirectorySeparator(path.charCodeAt(path.length - 1));
    }
    function isVolumeCharacter(charCode) {
        return charCode >= 97 /* a */  && charCode <= 122 /* z */  || charCode >= 65 /* A */  && charCode <= 90 /* Z */ ;
    }
    function getFileUrlVolumeSeparatorEnd(url, start) {
        const ch0 = url.charCodeAt(start);
        if (ch0 === 58 /* colon */ ) return start + 1;
        if (ch0 === 37 /* percent */  && url.charCodeAt(start + 1) === 51 /* _3 */ ) {
            const ch2 = url.charCodeAt(start + 2);
            if (ch2 === 97 /* a */  || ch2 === 65 /* A */ ) return start + 3;
        }
        return -1;
    }
    function getEncodedRootLength(path) {
        if (!path) return 0;
        const ch0 = path.charCodeAt(0);
        if (ch0 === 47 /* slash */  || ch0 === 92 /* backslash */ ) {
            if (path.charCodeAt(1) !== ch0) return 1;
            const p1 = path.indexOf(ch0 === 47 /* slash */  ? directorySeparator : altDirectorySeparator, 2);
            if (p1 < 0) return path.length;
            return p1 + 1;
        }
        if (isVolumeCharacter(ch0) && path.charCodeAt(1) === 58 /* colon */ ) {
            const ch2 = path.charCodeAt(2);
            if (ch2 === 47 /* slash */  || ch2 === 92 /* backslash */ ) return 3;
            if (path.length === 2) return 2;
        }
        const schemeEnd = path.indexOf(urlSchemeSeparator);
        if (schemeEnd !== -1) {
            const authorityStart = schemeEnd + urlSchemeSeparator.length;
            const authorityEnd = path.indexOf(directorySeparator, authorityStart);
            if (authorityEnd !== -1) {
                const scheme = path.slice(0, schemeEnd);
                const authority = path.slice(authorityStart, authorityEnd);
                if (scheme === "file" && (authority === "" || authority === "localhost") && isVolumeCharacter(path.charCodeAt(authorityEnd + 1))) {
                    const volumeSeparatorEnd = getFileUrlVolumeSeparatorEnd(path, authorityEnd + 2);
                    if (volumeSeparatorEnd !== -1) {
                        if (path.charCodeAt(volumeSeparatorEnd) === 47 /* slash */ ) return ~(volumeSeparatorEnd + 1);
                        if (volumeSeparatorEnd === path.length) return ~volumeSeparatorEnd;
                    }
                }
                return ~(authorityEnd + 1);
            }
            return ~path.length;
        }
        return 0;
    }
    function getRootLength(path) {
        const rootLength = getEncodedRootLength(path);
        return rootLength < 0 ? ~rootLength : rootLength;
    }
    function getDirectoryPath(path) {
        path = normalizeSlashes(path);
        const rootLength = getRootLength(path);
        if (rootLength === path.length) return path;
        path = removeTrailingDirectorySeparator(path);
        return path.slice(0, Math.max(rootLength, path.lastIndexOf(directorySeparator)));
    }
    function getBaseFileName(path, extensions, ignoreCase) {
        path = normalizeSlashes(path);
        const rootLength = getRootLength(path);
        if (rootLength === path.length) return "";
        path = removeTrailingDirectorySeparator(path);
        const name = path.slice(Math.max(getRootLength(path), path.lastIndexOf(directorySeparator) + 1));
        const extension = extensions !== void 0 && ignoreCase !== void 0 ? getAnyExtensionFromPath(name, extensions, ignoreCase) : void 0;
        return extension ? name.slice(0, name.length - extension.length) : name;
    }
    function tryGetExtensionFromPath(path, extension, stringEqualityComparer) {
        if (!startsWith(extension, ".")) extension = "." + extension;
        if (path.length >= extension.length && path.charCodeAt(path.length - extension.length) === 46 /* dot */ ) {
            const pathExtension = path.slice(path.length - extension.length);
            if (stringEqualityComparer(pathExtension, extension)) return pathExtension;
        }
    }
    function getAnyExtensionFromPathWorker(path, extensions, stringEqualityComparer) {
        if (typeof extensions === "string") return tryGetExtensionFromPath(path, extensions, stringEqualityComparer) || "";
        for (const extension of extensions){
            const result = tryGetExtensionFromPath(path, extension, stringEqualityComparer);
            if (result) return result;
        }
        return "";
    }
    function getAnyExtensionFromPath(path, extensions, ignoreCase) {
        if (extensions) return getAnyExtensionFromPathWorker(removeTrailingDirectorySeparator(path), extensions, ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive);
        const baseFileName = getBaseFileName(path);
        const extensionIndex = baseFileName.lastIndexOf(".");
        if (extensionIndex >= 0) return baseFileName.substring(extensionIndex);
        return "";
    }
    function pathComponents(path, rootLength) {
        const root = path.substring(0, rootLength);
        const rest = path.substring(rootLength).split(directorySeparator);
        if (rest.length && !lastOrUndefined(rest)) rest.pop();
        return [
            root,
            ...rest
        ];
    }
    function getPathComponents(path, currentDirectory = "") {
        path = combinePaths(currentDirectory, path);
        return pathComponents(path, getRootLength(path));
    }
    function getPathFromPathComponents(pathComponents2, length2) {
        if (pathComponents2.length === 0) return "";
        const root = pathComponents2[0] && ensureTrailingDirectorySeparator(pathComponents2[0]);
        return root + pathComponents2.slice(1, length2).join(directorySeparator);
    }
    function normalizeSlashes(path) {
        return path.includes("\\") ? path.replace(backslashRegExp, directorySeparator) : path;
    }
    function reducePathComponents(components) {
        if (!some(components)) return [];
        const reduced = [
            components[0]
        ];
        for(let i = 1; i < components.length; i++){
            const component = components[i];
            if (!component) continue;
            if (component === ".") continue;
            if (component === "..") {
                if (reduced.length > 1) {
                    if (reduced[reduced.length - 1] !== "..") {
                        reduced.pop();
                        continue;
                    }
                } else if (reduced[0]) continue;
            }
            reduced.push(component);
        }
        return reduced;
    }
    function combinePaths(path, ...paths) {
        if (path) path = normalizeSlashes(path);
        for (let relativePath of paths){
            if (!relativePath) continue;
            relativePath = normalizeSlashes(relativePath);
            if (!path || getRootLength(relativePath) !== 0) path = relativePath;
            else path = ensureTrailingDirectorySeparator(path) + relativePath;
        }
        return path;
    }
    function resolvePath(path, ...paths) {
        return normalizePath(some(paths) ? combinePaths(path, ...paths) : normalizeSlashes(path));
    }
    function getNormalizedPathComponents(path, currentDirectory) {
        return reducePathComponents(getPathComponents(path, currentDirectory));
    }
    function getNormalizedAbsolutePath(path, currentDirectory) {
        let rootLength = getRootLength(path);
        if (rootLength === 0 && currentDirectory) {
            path = combinePaths(currentDirectory, path);
            rootLength = getRootLength(path);
        } else path = normalizeSlashes(path);
        const simpleNormalized = simpleNormalizePath(path);
        if (simpleNormalized !== void 0) return simpleNormalized.length > rootLength ? removeTrailingDirectorySeparator(simpleNormalized) : simpleNormalized;
        const length2 = path.length;
        const root = path.substring(0, rootLength);
        let normalized;
        let index = rootLength;
        let segmentStart = index;
        let normalizedUpTo = index;
        let seenNonDotDotSegment = rootLength !== 0;
        while(index < length2){
            segmentStart = index;
            let ch = path.charCodeAt(index);
            while(ch === 47 /* slash */  && index + 1 < length2){
                index++;
                ch = path.charCodeAt(index);
            }
            if (index > segmentStart) {
                normalized !== null && normalized !== void 0 ? normalized : normalized = path.substring(0, segmentStart - 1);
                segmentStart = index;
            }
            let segmentEnd = path.indexOf(directorySeparator, index + 1);
            if (segmentEnd === -1) segmentEnd = length2;
            const segmentLength = segmentEnd - segmentStart;
            if (segmentLength === 1 && path.charCodeAt(index) === 46 /* dot */ ) normalized !== null && normalized !== void 0 ? normalized : normalized = path.substring(0, normalizedUpTo);
            else if (segmentLength === 2 && path.charCodeAt(index) === 46 /* dot */  && path.charCodeAt(index + 1) === 46 /* dot */ ) {
                if (!seenNonDotDotSegment) {
                    if (normalized !== void 0) normalized += normalized.length === rootLength ? ".." : "/..";
                    else normalizedUpTo = index + 2;
                } else if (normalized === void 0) {
                    if (normalizedUpTo - 2 >= 0) normalized = path.substring(0, Math.max(rootLength, path.lastIndexOf(directorySeparator, normalizedUpTo - 2)));
                    else normalized = path.substring(0, normalizedUpTo);
                } else {
                    const lastSlash = normalized.lastIndexOf(directorySeparator);
                    if (lastSlash !== -1) normalized = normalized.substring(0, Math.max(rootLength, lastSlash));
                    else normalized = root;
                    if (normalized.length === rootLength) seenNonDotDotSegment = rootLength !== 0;
                }
            } else if (normalized !== void 0) {
                if (normalized.length !== rootLength) normalized += directorySeparator;
                seenNonDotDotSegment = true;
                normalized += path.substring(segmentStart, segmentEnd);
            } else {
                seenNonDotDotSegment = true;
                normalizedUpTo = segmentEnd;
            }
            index = segmentEnd + 1;
        }
        return normalized !== null && normalized !== void 0 ? normalized : length2 > rootLength ? removeTrailingDirectorySeparator(path) : path;
    }
    function normalizePath(path) {
        path = normalizeSlashes(path);
        let normalized = simpleNormalizePath(path);
        if (normalized !== void 0) return normalized;
        normalized = getNormalizedAbsolutePath(path, "");
        return normalized && hasTrailingDirectorySeparator(path) ? ensureTrailingDirectorySeparator(normalized) : normalized;
    }
    function simpleNormalizePath(path) {
        if (!relativePathSegmentRegExp.test(path)) return path;
        let simplified = path.replace(/\/\.\//g, "/");
        if (simplified.startsWith("./")) simplified = simplified.slice(2);
        if (simplified !== path) {
            path = simplified;
            if (!relativePathSegmentRegExp.test(path)) return path;
        }
        return void 0;
    }
    function getPathWithoutRoot(pathComponents2) {
        if (pathComponents2.length === 0) return "";
        return pathComponents2.slice(1).join(directorySeparator);
    }
    function getNormalizedAbsolutePathWithoutRoot(fileName, currentDirectory) {
        return getPathWithoutRoot(getNormalizedPathComponents(fileName, currentDirectory));
    }
    function toPath(fileName, basePath, getCanonicalFileName) {
        const nonCanonicalizedPath = isRootedDiskPath(fileName) ? normalizePath(fileName) : getNormalizedAbsolutePath(fileName, basePath);
        return getCanonicalFileName(nonCanonicalizedPath);
    }
    function removeTrailingDirectorySeparator(path) {
        if (hasTrailingDirectorySeparator(path)) return path.substr(0, path.length - 1);
        return path;
    }
    function ensureTrailingDirectorySeparator(path) {
        if (!hasTrailingDirectorySeparator(path)) return path + directorySeparator;
        return path;
    }
    function ensurePathIsNonModuleName(path) {
        return !pathIsAbsolute(path) && !pathIsRelative(path) ? "./" + path : path;
    }
    function changeAnyExtension(path, ext, extensions, ignoreCase) {
        const pathext = extensions !== void 0 && ignoreCase !== void 0 ? getAnyExtensionFromPath(path, extensions, ignoreCase) : getAnyExtensionFromPath(path);
        return pathext ? path.slice(0, path.length - pathext.length) + (startsWith(ext, ".") ? ext : "." + ext) : path;
    }
    function changeFullExtension(path, newExtension) {
        const declarationExtension = getDeclarationFileExtension(path);
        if (declarationExtension) return path.slice(0, path.length - declarationExtension.length) + (startsWith(newExtension, ".") ? newExtension : "." + newExtension);
        return changeAnyExtension(path, newExtension);
    }
    var relativePathSegmentRegExp = /\/\/|(?:^|\/)\.\.?(?:$|\/)/;
    function comparePathsWorker(a, b, componentComparer) {
        if (a === b) return 0 /* EqualTo */ ;
        if (a === void 0) return -1 /* LessThan */ ;
        if (b === void 0) return 1 /* GreaterThan */ ;
        const aRoot = a.substring(0, getRootLength(a));
        const bRoot = b.substring(0, getRootLength(b));
        const result = compareStringsCaseInsensitive(aRoot, bRoot);
        if (result !== 0 /* EqualTo */ ) return result;
        const aRest = a.substring(aRoot.length);
        const bRest = b.substring(bRoot.length);
        if (!relativePathSegmentRegExp.test(aRest) && !relativePathSegmentRegExp.test(bRest)) return componentComparer(aRest, bRest);
        const aComponents = reducePathComponents(getPathComponents(a));
        const bComponents = reducePathComponents(getPathComponents(b));
        const sharedLength = Math.min(aComponents.length, bComponents.length);
        for(let i = 1; i < sharedLength; i++){
            const result2 = componentComparer(aComponents[i], bComponents[i]);
            if (result2 !== 0 /* EqualTo */ ) return result2;
        }
        return compareValues(aComponents.length, bComponents.length);
    }
    function comparePathsCaseSensitive(a, b) {
        return comparePathsWorker(a, b, compareStringsCaseSensitive);
    }
    function comparePathsCaseInsensitive(a, b) {
        return comparePathsWorker(a, b, compareStringsCaseInsensitive);
    }
    function comparePaths(a, b, currentDirectory, ignoreCase) {
        if (typeof currentDirectory === "string") {
            a = combinePaths(currentDirectory, a);
            b = combinePaths(currentDirectory, b);
        } else if (typeof currentDirectory === "boolean") ignoreCase = currentDirectory;
        return comparePathsWorker(a, b, getStringComparer(ignoreCase));
    }
    function containsPath(parent2, child, currentDirectory, ignoreCase) {
        if (typeof currentDirectory === "string") {
            parent2 = combinePaths(currentDirectory, parent2);
            child = combinePaths(currentDirectory, child);
        } else if (typeof currentDirectory === "boolean") ignoreCase = currentDirectory;
        if (parent2 === void 0 || child === void 0) return false;
        if (parent2 === child) return true;
        const parentComponents = reducePathComponents(getPathComponents(parent2));
        const childComponents = reducePathComponents(getPathComponents(child));
        if (childComponents.length < parentComponents.length) return false;
        const componentEqualityComparer = ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive;
        for(let i = 0; i < parentComponents.length; i++){
            const equalityComparer = i === 0 ? equateStringsCaseInsensitive : componentEqualityComparer;
            if (!equalityComparer(parentComponents[i], childComponents[i])) return false;
        }
        return true;
    }
    function startsWithDirectory(fileName, directoryName, getCanonicalFileName) {
        const canonicalFileName = getCanonicalFileName(fileName);
        const canonicalDirectoryName = getCanonicalFileName(directoryName);
        return startsWith(canonicalFileName, canonicalDirectoryName + "/") || startsWith(canonicalFileName, canonicalDirectoryName + "\\");
    }
    function getPathComponentsRelativeTo(from, to, stringEqualityComparer, getCanonicalFileName) {
        const fromComponents = reducePathComponents(getPathComponents(from));
        const toComponents = reducePathComponents(getPathComponents(to));
        let start;
        for(start = 0; start < fromComponents.length && start < toComponents.length; start++){
            const fromComponent = getCanonicalFileName(fromComponents[start]);
            const toComponent = getCanonicalFileName(toComponents[start]);
            const comparer = start === 0 ? equateStringsCaseInsensitive : stringEqualityComparer;
            if (!comparer(fromComponent, toComponent)) break;
        }
        if (start === 0) return toComponents;
        const components = toComponents.slice(start);
        const relative = [];
        for(; start < fromComponents.length; start++)relative.push("..");
        return [
            "",
            ...relative,
            ...components
        ];
    }
    function getRelativePathFromDirectory(fromDirectory, to, getCanonicalFileNameOrIgnoreCase) {
        Debug.assert(getRootLength(fromDirectory) > 0 === getRootLength(to) > 0, "Paths must either both be absolute or both be relative");
        const getCanonicalFileName = typeof getCanonicalFileNameOrIgnoreCase === "function" ? getCanonicalFileNameOrIgnoreCase : identity;
        const ignoreCase = typeof getCanonicalFileNameOrIgnoreCase === "boolean" ? getCanonicalFileNameOrIgnoreCase : false;
        const pathComponents2 = getPathComponentsRelativeTo(fromDirectory, to, ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive, getCanonicalFileName);
        return getPathFromPathComponents(pathComponents2);
    }
    function convertToRelativePath(absoluteOrRelativePath, basePath, getCanonicalFileName) {
        return !isRootedDiskPath(absoluteOrRelativePath) ? absoluteOrRelativePath : getRelativePathToDirectoryOrUrl(basePath, absoluteOrRelativePath, basePath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
    }
    function getRelativePathFromFile(from, to, getCanonicalFileName) {
        return ensurePathIsNonModuleName(getRelativePathFromDirectory(getDirectoryPath(from), to, getCanonicalFileName));
    }
    function getRelativePathToDirectoryOrUrl(directoryPathOrUrl, relativeOrAbsolutePath, currentDirectory, getCanonicalFileName, isAbsolutePathAnUrl) {
        const pathComponents2 = getPathComponentsRelativeTo(resolvePath(currentDirectory, directoryPathOrUrl), resolvePath(currentDirectory, relativeOrAbsolutePath), equateStringsCaseSensitive, getCanonicalFileName);
        const firstComponent = pathComponents2[0];
        if (isAbsolutePathAnUrl && isRootedDiskPath(firstComponent)) {
            const prefix = firstComponent.charAt(0) === directorySeparator ? "file://" : "file:///";
            pathComponents2[0] = prefix + firstComponent;
        }
        return getPathFromPathComponents(pathComponents2);
    }
    function forEachAncestorDirectory(directory, callback) {
        while(true){
            const result = callback(directory);
            if (result !== void 0) return result;
            const parentPath = getDirectoryPath(directory);
            if (parentPath === directory) return void 0;
            directory = parentPath;
        }
    }
    function isNodeModulesDirectory(dirPath) {
        return endsWith(dirPath, "/node_modules");
    }
    // src/compiler/diagnosticInformationMap.generated.ts
    function diag(code, category, key, message, reportsUnnecessary, elidedInCompatabilityPyramid, reportsDeprecated) {
        return {
            code,
            category,
            key,
            message,
            reportsUnnecessary,
            elidedInCompatabilityPyramid,
            reportsDeprecated
        };
    }
    var Diagnostics = {
        Unterminated_string_literal: diag(1002, 1 /* Error */ , "Unterminated_string_literal_1002", "Unterminated string literal."),
        Identifier_expected: diag(1003, 1 /* Error */ , "Identifier_expected_1003", "Identifier expected."),
        _0_expected: diag(1005, 1 /* Error */ , "_0_expected_1005", "'{0}' expected."),
        A_file_cannot_have_a_reference_to_itself: diag(1006, 1 /* Error */ , "A_file_cannot_have_a_reference_to_itself_1006", "A file cannot have a reference to itself."),
        The_parser_expected_to_find_a_1_to_match_the_0_token_here: diag(1007, 1 /* Error */ , "The_parser_expected_to_find_a_1_to_match_the_0_token_here_1007", "The parser expected to find a '{1}' to match the '{0}' token here."),
        Trailing_comma_not_allowed: diag(1009, 1 /* Error */ , "Trailing_comma_not_allowed_1009", "Trailing comma not allowed."),
        Asterisk_Slash_expected: diag(1010, 1 /* Error */ , "Asterisk_Slash_expected_1010", "'*/' expected."),
        An_element_access_expression_should_take_an_argument: diag(1011, 1 /* Error */ , "An_element_access_expression_should_take_an_argument_1011", "An element access expression should take an argument."),
        Unexpected_token: diag(1012, 1 /* Error */ , "Unexpected_token_1012", "Unexpected token."),
        A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma: diag(1013, 1 /* Error */ , "A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma_1013", "A rest parameter or binding pattern may not have a trailing comma."),
        A_rest_parameter_must_be_last_in_a_parameter_list: diag(1014, 1 /* Error */ , "A_rest_parameter_must_be_last_in_a_parameter_list_1014", "A rest parameter must be last in a parameter list."),
        Parameter_cannot_have_question_mark_and_initializer: diag(1015, 1 /* Error */ , "Parameter_cannot_have_question_mark_and_initializer_1015", "Parameter cannot have question mark and initializer."),
        A_required_parameter_cannot_follow_an_optional_parameter: diag(1016, 1 /* Error */ , "A_required_parameter_cannot_follow_an_optional_parameter_1016", "A required parameter cannot follow an optional parameter."),
        An_index_signature_cannot_have_a_rest_parameter: diag(1017, 1 /* Error */ , "An_index_signature_cannot_have_a_rest_parameter_1017", "An index signature cannot have a rest parameter."),
        An_index_signature_parameter_cannot_have_an_accessibility_modifier: diag(1018, 1 /* Error */ , "An_index_signature_parameter_cannot_have_an_accessibility_modifier_1018", "An index signature parameter cannot have an accessibility modifier."),
        An_index_signature_parameter_cannot_have_a_question_mark: diag(1019, 1 /* Error */ , "An_index_signature_parameter_cannot_have_a_question_mark_1019", "An index signature parameter cannot have a question mark."),
        An_index_signature_parameter_cannot_have_an_initializer: diag(1020, 1 /* Error */ , "An_index_signature_parameter_cannot_have_an_initializer_1020", "An index signature parameter cannot have an initializer."),
        An_index_signature_must_have_a_type_annotation: diag(1021, 1 /* Error */ , "An_index_signature_must_have_a_type_annotation_1021", "An index signature must have a type annotation."),
        An_index_signature_parameter_must_have_a_type_annotation: diag(1022, 1 /* Error */ , "An_index_signature_parameter_must_have_a_type_annotation_1022", "An index signature parameter must have a type annotation."),
        readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature: diag(1024, 1 /* Error */ , "readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature_1024", "'readonly' modifier can only appear on a property declaration or index signature."),
        An_index_signature_cannot_have_a_trailing_comma: diag(1025, 1 /* Error */ , "An_index_signature_cannot_have_a_trailing_comma_1025", "An index signature cannot have a trailing comma."),
        Accessibility_modifier_already_seen: diag(1028, 1 /* Error */ , "Accessibility_modifier_already_seen_1028", "Accessibility modifier already seen."),
        _0_modifier_must_precede_1_modifier: diag(1029, 1 /* Error */ , "_0_modifier_must_precede_1_modifier_1029", "'{0}' modifier must precede '{1}' modifier."),
        _0_modifier_already_seen: diag(1030, 1 /* Error */ , "_0_modifier_already_seen_1030", "'{0}' modifier already seen."),
        _0_modifier_cannot_appear_on_class_elements_of_this_kind: diag(1031, 1 /* Error */ , "_0_modifier_cannot_appear_on_class_elements_of_this_kind_1031", "'{0}' modifier cannot appear on class elements of this kind."),
        super_must_be_followed_by_an_argument_list_or_member_access: diag(1034, 1 /* Error */ , "super_must_be_followed_by_an_argument_list_or_member_access_1034", "'super' must be followed by an argument list or member access."),
        Only_ambient_modules_can_use_quoted_names: diag(1035, 1 /* Error */ , "Only_ambient_modules_can_use_quoted_names_1035", "Only ambient modules can use quoted names."),
        Statements_are_not_allowed_in_ambient_contexts: diag(1036, 1 /* Error */ , "Statements_are_not_allowed_in_ambient_contexts_1036", "Statements are not allowed in ambient contexts."),
        A_declare_modifier_cannot_be_used_in_an_already_ambient_context: diag(1038, 1 /* Error */ , "A_declare_modifier_cannot_be_used_in_an_already_ambient_context_1038", "A 'declare' modifier cannot be used in an already ambient context."),
        Initializers_are_not_allowed_in_ambient_contexts: diag(1039, 1 /* Error */ , "Initializers_are_not_allowed_in_ambient_contexts_1039", "Initializers are not allowed in ambient contexts."),
        _0_modifier_cannot_be_used_in_an_ambient_context: diag(1040, 1 /* Error */ , "_0_modifier_cannot_be_used_in_an_ambient_context_1040", "'{0}' modifier cannot be used in an ambient context."),
        _0_modifier_cannot_be_used_here: diag(1042, 1 /* Error */ , "_0_modifier_cannot_be_used_here_1042", "'{0}' modifier cannot be used here."),
        _0_modifier_cannot_appear_on_a_module_or_namespace_element: diag(1044, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_module_or_namespace_element_1044", "'{0}' modifier cannot appear on a module or namespace element."),
        Top_level_declarations_in_d_ts_files_must_start_with_either_a_declare_or_export_modifier: diag(1046, 1 /* Error */ , "Top_level_declarations_in_d_ts_files_must_start_with_either_a_declare_or_export_modifier_1046", "Top-level declarations in .d.ts files must start with either a 'declare' or 'export' modifier."),
        A_rest_parameter_cannot_be_optional: diag(1047, 1 /* Error */ , "A_rest_parameter_cannot_be_optional_1047", "A rest parameter cannot be optional."),
        A_rest_parameter_cannot_have_an_initializer: diag(1048, 1 /* Error */ , "A_rest_parameter_cannot_have_an_initializer_1048", "A rest parameter cannot have an initializer."),
        A_set_accessor_must_have_exactly_one_parameter: diag(1049, 1 /* Error */ , "A_set_accessor_must_have_exactly_one_parameter_1049", "A 'set' accessor must have exactly one parameter."),
        A_set_accessor_cannot_have_an_optional_parameter: diag(1051, 1 /* Error */ , "A_set_accessor_cannot_have_an_optional_parameter_1051", "A 'set' accessor cannot have an optional parameter."),
        A_set_accessor_parameter_cannot_have_an_initializer: diag(1052, 1 /* Error */ , "A_set_accessor_parameter_cannot_have_an_initializer_1052", "A 'set' accessor parameter cannot have an initializer."),
        A_set_accessor_cannot_have_rest_parameter: diag(1053, 1 /* Error */ , "A_set_accessor_cannot_have_rest_parameter_1053", "A 'set' accessor cannot have rest parameter."),
        A_get_accessor_cannot_have_parameters: diag(1054, 1 /* Error */ , "A_get_accessor_cannot_have_parameters_1054", "A 'get' accessor cannot have parameters."),
        Type_0_is_not_a_valid_async_function_return_type_in_ES5_because_it_does_not_refer_to_a_Promise_compatible_constructor_value: diag(1055, 1 /* Error */ , "Type_0_is_not_a_valid_async_function_return_type_in_ES5_because_it_does_not_refer_to_a_Promise_compa_1055", "Type '{0}' is not a valid async function return type in ES5 because it does not refer to a Promise-compatible constructor value."),
        Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher: diag(1056, 1 /* Error */ , "Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher_1056", "Accessors are only available when targeting ECMAScript 5 and higher."),
        The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1058, 1 /* Error */ , "The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_t_1058", "The return type of an async function must either be a valid promise or must not contain a callable 'then' member."),
        A_promise_must_have_a_then_method: diag(1059, 1 /* Error */ , "A_promise_must_have_a_then_method_1059", "A promise must have a 'then' method."),
        The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback: diag(1060, 1 /* Error */ , "The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback_1060", "The first parameter of the 'then' method of a promise must be a callback."),
        Enum_member_must_have_initializer: diag(1061, 1 /* Error */ , "Enum_member_must_have_initializer_1061", "Enum member must have initializer."),
        Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method: diag(1062, 1 /* Error */ , "Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method_1062", "Type is referenced directly or indirectly in the fulfillment callback of its own 'then' method."),
        An_export_assignment_cannot_be_used_in_a_namespace: diag(1063, 1 /* Error */ , "An_export_assignment_cannot_be_used_in_a_namespace_1063", "An export assignment cannot be used in a namespace."),
        The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_write_Promise_0: diag(1064, 1 /* Error */ , "The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_wri_1064", "The return type of an async function or method must be the global Promise<T> type. Did you mean to write 'Promise<{0}>'?"),
        The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type: diag(1065, 1 /* Error */ , "The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_1065", "The return type of an async function or method must be the global Promise<T> type."),
        In_ambient_enum_declarations_member_initializer_must_be_constant_expression: diag(1066, 1 /* Error */ , "In_ambient_enum_declarations_member_initializer_must_be_constant_expression_1066", "In ambient enum declarations member initializer must be constant expression."),
        Unexpected_token_A_constructor_method_accessor_or_property_was_expected: diag(1068, 1 /* Error */ , "Unexpected_token_A_constructor_method_accessor_or_property_was_expected_1068", "Unexpected token. A constructor, method, accessor, or property was expected."),
        Unexpected_token_A_type_parameter_name_was_expected_without_curly_braces: diag(1069, 1 /* Error */ , "Unexpected_token_A_type_parameter_name_was_expected_without_curly_braces_1069", "Unexpected token. A type parameter name was expected without curly braces."),
        _0_modifier_cannot_appear_on_a_type_member: diag(1070, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_type_member_1070", "'{0}' modifier cannot appear on a type member."),
        _0_modifier_cannot_appear_on_an_index_signature: diag(1071, 1 /* Error */ , "_0_modifier_cannot_appear_on_an_index_signature_1071", "'{0}' modifier cannot appear on an index signature."),
        A_0_modifier_cannot_be_used_with_an_import_declaration: diag(1079, 1 /* Error */ , "A_0_modifier_cannot_be_used_with_an_import_declaration_1079", "A '{0}' modifier cannot be used with an import declaration."),
        Invalid_reference_directive_syntax: diag(1084, 1 /* Error */ , "Invalid_reference_directive_syntax_1084", "Invalid 'reference' directive syntax."),
        _0_modifier_cannot_appear_on_a_constructor_declaration: diag(1089, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_constructor_declaration_1089", "'{0}' modifier cannot appear on a constructor declaration."),
        _0_modifier_cannot_appear_on_a_parameter: diag(1090, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_parameter_1090", "'{0}' modifier cannot appear on a parameter."),
        Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement: diag(1091, 1 /* Error */ , "Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement_1091", "Only a single variable declaration is allowed in a 'for...in' statement."),
        Type_parameters_cannot_appear_on_a_constructor_declaration: diag(1092, 1 /* Error */ , "Type_parameters_cannot_appear_on_a_constructor_declaration_1092", "Type parameters cannot appear on a constructor declaration."),
        Type_annotation_cannot_appear_on_a_constructor_declaration: diag(1093, 1 /* Error */ , "Type_annotation_cannot_appear_on_a_constructor_declaration_1093", "Type annotation cannot appear on a constructor declaration."),
        An_accessor_cannot_have_type_parameters: diag(1094, 1 /* Error */ , "An_accessor_cannot_have_type_parameters_1094", "An accessor cannot have type parameters."),
        A_set_accessor_cannot_have_a_return_type_annotation: diag(1095, 1 /* Error */ , "A_set_accessor_cannot_have_a_return_type_annotation_1095", "A 'set' accessor cannot have a return type annotation."),
        An_index_signature_must_have_exactly_one_parameter: diag(1096, 1 /* Error */ , "An_index_signature_must_have_exactly_one_parameter_1096", "An index signature must have exactly one parameter."),
        _0_list_cannot_be_empty: diag(1097, 1 /* Error */ , "_0_list_cannot_be_empty_1097", "'{0}' list cannot be empty."),
        Type_parameter_list_cannot_be_empty: diag(1098, 1 /* Error */ , "Type_parameter_list_cannot_be_empty_1098", "Type parameter list cannot be empty."),
        Type_argument_list_cannot_be_empty: diag(1099, 1 /* Error */ , "Type_argument_list_cannot_be_empty_1099", "Type argument list cannot be empty."),
        Invalid_use_of_0_in_strict_mode: diag(1100, 1 /* Error */ , "Invalid_use_of_0_in_strict_mode_1100", "Invalid use of '{0}' in strict mode."),
        with_statements_are_not_allowed_in_strict_mode: diag(1101, 1 /* Error */ , "with_statements_are_not_allowed_in_strict_mode_1101", "'with' statements are not allowed in strict mode."),
        delete_cannot_be_called_on_an_identifier_in_strict_mode: diag(1102, 1 /* Error */ , "delete_cannot_be_called_on_an_identifier_in_strict_mode_1102", "'delete' cannot be called on an identifier in strict mode."),
        for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules: diag(1103, 1 /* Error */ , "for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules_1103", "'for await' loops are only allowed within async functions and at the top levels of modules."),
        A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement: diag(1104, 1 /* Error */ , "A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement_1104", "A 'continue' statement can only be used within an enclosing iteration statement."),
        A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement: diag(1105, 1 /* Error */ , "A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement_1105", "A 'break' statement can only be used within an enclosing iteration or switch statement."),
        The_left_hand_side_of_a_for_of_statement_may_not_be_async: diag(1106, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_may_not_be_async_1106", "The left-hand side of a 'for...of' statement may not be 'async'."),
        Jump_target_cannot_cross_function_boundary: diag(1107, 1 /* Error */ , "Jump_target_cannot_cross_function_boundary_1107", "Jump target cannot cross function boundary."),
        A_return_statement_can_only_be_used_within_a_function_body: diag(1108, 1 /* Error */ , "A_return_statement_can_only_be_used_within_a_function_body_1108", "A 'return' statement can only be used within a function body."),
        Expression_expected: diag(1109, 1 /* Error */ , "Expression_expected_1109", "Expression expected."),
        Type_expected: diag(1110, 1 /* Error */ , "Type_expected_1110", "Type expected."),
        Private_field_0_must_be_declared_in_an_enclosing_class: diag(1111, 1 /* Error */ , "Private_field_0_must_be_declared_in_an_enclosing_class_1111", "Private field '{0}' must be declared in an enclosing class."),
        A_default_clause_cannot_appear_more_than_once_in_a_switch_statement: diag(1113, 1 /* Error */ , "A_default_clause_cannot_appear_more_than_once_in_a_switch_statement_1113", "A 'default' clause cannot appear more than once in a 'switch' statement."),
        Duplicate_label_0: diag(1114, 1 /* Error */ , "Duplicate_label_0_1114", "Duplicate label '{0}'."),
        A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement: diag(1115, 1 /* Error */ , "A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement_1115", "A 'continue' statement can only jump to a label of an enclosing iteration statement."),
        A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement: diag(1116, 1 /* Error */ , "A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement_1116", "A 'break' statement can only jump to a label of an enclosing statement."),
        An_object_literal_cannot_have_multiple_properties_with_the_same_name: diag(1117, 1 /* Error */ , "An_object_literal_cannot_have_multiple_properties_with_the_same_name_1117", "An object literal cannot have multiple properties with the same name."),
        An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name: diag(1118, 1 /* Error */ , "An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name_1118", "An object literal cannot have multiple get/set accessors with the same name."),
        An_object_literal_cannot_have_property_and_accessor_with_the_same_name: diag(1119, 1 /* Error */ , "An_object_literal_cannot_have_property_and_accessor_with_the_same_name_1119", "An object literal cannot have property and accessor with the same name."),
        An_export_assignment_cannot_have_modifiers: diag(1120, 1 /* Error */ , "An_export_assignment_cannot_have_modifiers_1120", "An export assignment cannot have modifiers."),
        Octal_literals_are_not_allowed_Use_the_syntax_0: diag(1121, 1 /* Error */ , "Octal_literals_are_not_allowed_Use_the_syntax_0_1121", "Octal literals are not allowed. Use the syntax '{0}'."),
        Variable_declaration_list_cannot_be_empty: diag(1123, 1 /* Error */ , "Variable_declaration_list_cannot_be_empty_1123", "Variable declaration list cannot be empty."),
        Digit_expected: diag(1124, 1 /* Error */ , "Digit_expected_1124", "Digit expected."),
        Hexadecimal_digit_expected: diag(1125, 1 /* Error */ , "Hexadecimal_digit_expected_1125", "Hexadecimal digit expected."),
        Unexpected_end_of_text: diag(1126, 1 /* Error */ , "Unexpected_end_of_text_1126", "Unexpected end of text."),
        Invalid_character: diag(1127, 1 /* Error */ , "Invalid_character_1127", "Invalid character."),
        Declaration_or_statement_expected: diag(1128, 1 /* Error */ , "Declaration_or_statement_expected_1128", "Declaration or statement expected."),
        Statement_expected: diag(1129, 1 /* Error */ , "Statement_expected_1129", "Statement expected."),
        case_or_default_expected: diag(1130, 1 /* Error */ , "case_or_default_expected_1130", "'case' or 'default' expected."),
        Property_or_signature_expected: diag(1131, 1 /* Error */ , "Property_or_signature_expected_1131", "Property or signature expected."),
        Enum_member_expected: diag(1132, 1 /* Error */ , "Enum_member_expected_1132", "Enum member expected."),
        Variable_declaration_expected: diag(1134, 1 /* Error */ , "Variable_declaration_expected_1134", "Variable declaration expected."),
        Argument_expression_expected: diag(1135, 1 /* Error */ , "Argument_expression_expected_1135", "Argument expression expected."),
        Property_assignment_expected: diag(1136, 1 /* Error */ , "Property_assignment_expected_1136", "Property assignment expected."),
        Expression_or_comma_expected: diag(1137, 1 /* Error */ , "Expression_or_comma_expected_1137", "Expression or comma expected."),
        Parameter_declaration_expected: diag(1138, 1 /* Error */ , "Parameter_declaration_expected_1138", "Parameter declaration expected."),
        Type_parameter_declaration_expected: diag(1139, 1 /* Error */ , "Type_parameter_declaration_expected_1139", "Type parameter declaration expected."),
        Type_argument_expected: diag(1140, 1 /* Error */ , "Type_argument_expected_1140", "Type argument expected."),
        String_literal_expected: diag(1141, 1 /* Error */ , "String_literal_expected_1141", "String literal expected."),
        Line_break_not_permitted_here: diag(1142, 1 /* Error */ , "Line_break_not_permitted_here_1142", "Line break not permitted here."),
        or_expected: diag(1144, 1 /* Error */ , "or_expected_1144", "'{' or ';' expected."),
        or_JSX_element_expected: diag(1145, 1 /* Error */ , "or_JSX_element_expected_1145", "'{' or JSX element expected."),
        Declaration_expected: diag(1146, 1 /* Error */ , "Declaration_expected_1146", "Declaration expected."),
        Import_declarations_in_a_namespace_cannot_reference_a_module: diag(1147, 1 /* Error */ , "Import_declarations_in_a_namespace_cannot_reference_a_module_1147", "Import declarations in a namespace cannot reference a module."),
        Cannot_use_imports_exports_or_module_augmentations_when_module_is_none: diag(1148, 1 /* Error */ , "Cannot_use_imports_exports_or_module_augmentations_when_module_is_none_1148", "Cannot use imports, exports, or module augmentations when '--module' is 'none'."),
        File_name_0_differs_from_already_included_file_name_1_only_in_casing: diag(1149, 1 /* Error */ , "File_name_0_differs_from_already_included_file_name_1_only_in_casing_1149", "File name '{0}' differs from already included file name '{1}' only in casing."),
        _0_declarations_must_be_initialized: diag(1155, 1 /* Error */ , "_0_declarations_must_be_initialized_1155", "'{0}' declarations must be initialized."),
        _0_declarations_can_only_be_declared_inside_a_block: diag(1156, 1 /* Error */ , "_0_declarations_can_only_be_declared_inside_a_block_1156", "'{0}' declarations can only be declared inside a block."),
        Unterminated_template_literal: diag(1160, 1 /* Error */ , "Unterminated_template_literal_1160", "Unterminated template literal."),
        Unterminated_regular_expression_literal: diag(1161, 1 /* Error */ , "Unterminated_regular_expression_literal_1161", "Unterminated regular expression literal."),
        An_object_member_cannot_be_declared_optional: diag(1162, 1 /* Error */ , "An_object_member_cannot_be_declared_optional_1162", "An object member cannot be declared optional."),
        A_yield_expression_is_only_allowed_in_a_generator_body: diag(1163, 1 /* Error */ , "A_yield_expression_is_only_allowed_in_a_generator_body_1163", "A 'yield' expression is only allowed in a generator body."),
        Computed_property_names_are_not_allowed_in_enums: diag(1164, 1 /* Error */ , "Computed_property_names_are_not_allowed_in_enums_1164", "Computed property names are not allowed in enums."),
        A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1165, 1 /* Error */ , "A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_t_1165", "A computed property name in an ambient context must refer to an expression whose type is a literal type or a 'unique symbol' type."),
        A_computed_property_name_in_a_class_property_declaration_must_have_a_simple_literal_type_or_a_unique_symbol_type: diag(1166, 1 /* Error */ , "A_computed_property_name_in_a_class_property_declaration_must_have_a_simple_literal_type_or_a_unique_1166", "A computed property name in a class property declaration must have a simple literal type or a 'unique symbol' type."),
        A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1168, 1 /* Error */ , "A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_ty_1168", "A computed property name in a method overload must refer to an expression whose type is a literal type or a 'unique symbol' type."),
        A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1169, 1 /* Error */ , "A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_1169", "A computed property name in an interface must refer to an expression whose type is a literal type or a 'unique symbol' type."),
        A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1170, 1 /* Error */ , "A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type__1170", "A computed property name in a type literal must refer to an expression whose type is a literal type or a 'unique symbol' type."),
        A_comma_expression_is_not_allowed_in_a_computed_property_name: diag(1171, 1 /* Error */ , "A_comma_expression_is_not_allowed_in_a_computed_property_name_1171", "A comma expression is not allowed in a computed property name."),
        extends_clause_already_seen: diag(1172, 1 /* Error */ , "extends_clause_already_seen_1172", "'extends' clause already seen."),
        extends_clause_must_precede_implements_clause: diag(1173, 1 /* Error */ , "extends_clause_must_precede_implements_clause_1173", "'extends' clause must precede 'implements' clause."),
        Classes_can_only_extend_a_single_class: diag(1174, 1 /* Error */ , "Classes_can_only_extend_a_single_class_1174", "Classes can only extend a single class."),
        implements_clause_already_seen: diag(1175, 1 /* Error */ , "implements_clause_already_seen_1175", "'implements' clause already seen."),
        Interface_declaration_cannot_have_implements_clause: diag(1176, 1 /* Error */ , "Interface_declaration_cannot_have_implements_clause_1176", "Interface declaration cannot have 'implements' clause."),
        Binary_digit_expected: diag(1177, 1 /* Error */ , "Binary_digit_expected_1177", "Binary digit expected."),
        Octal_digit_expected: diag(1178, 1 /* Error */ , "Octal_digit_expected_1178", "Octal digit expected."),
        Unexpected_token_expected: diag(1179, 1 /* Error */ , "Unexpected_token_expected_1179", "Unexpected token. '{' expected."),
        Property_destructuring_pattern_expected: diag(1180, 1 /* Error */ , "Property_destructuring_pattern_expected_1180", "Property destructuring pattern expected."),
        Array_element_destructuring_pattern_expected: diag(1181, 1 /* Error */ , "Array_element_destructuring_pattern_expected_1181", "Array element destructuring pattern expected."),
        A_destructuring_declaration_must_have_an_initializer: diag(1182, 1 /* Error */ , "A_destructuring_declaration_must_have_an_initializer_1182", "A destructuring declaration must have an initializer."),
        An_implementation_cannot_be_declared_in_ambient_contexts: diag(1183, 1 /* Error */ , "An_implementation_cannot_be_declared_in_ambient_contexts_1183", "An implementation cannot be declared in ambient contexts."),
        Modifiers_cannot_appear_here: diag(1184, 1 /* Error */ , "Modifiers_cannot_appear_here_1184", "Modifiers cannot appear here."),
        Merge_conflict_marker_encountered: diag(1185, 1 /* Error */ , "Merge_conflict_marker_encountered_1185", "Merge conflict marker encountered."),
        A_rest_element_cannot_have_an_initializer: diag(1186, 1 /* Error */ , "A_rest_element_cannot_have_an_initializer_1186", "A rest element cannot have an initializer."),
        A_parameter_property_may_not_be_declared_using_a_binding_pattern: diag(1187, 1 /* Error */ , "A_parameter_property_may_not_be_declared_using_a_binding_pattern_1187", "A parameter property may not be declared using a binding pattern."),
        Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement: diag(1188, 1 /* Error */ , "Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement_1188", "Only a single variable declaration is allowed in a 'for...of' statement."),
        The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer: diag(1189, 1 /* Error */ , "The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer_1189", "The variable declaration of a 'for...in' statement cannot have an initializer."),
        The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer: diag(1190, 1 /* Error */ , "The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer_1190", "The variable declaration of a 'for...of' statement cannot have an initializer."),
        An_import_declaration_cannot_have_modifiers: diag(1191, 1 /* Error */ , "An_import_declaration_cannot_have_modifiers_1191", "An import declaration cannot have modifiers."),
        Module_0_has_no_default_export: diag(1192, 1 /* Error */ , "Module_0_has_no_default_export_1192", "Module '{0}' has no default export."),
        An_export_declaration_cannot_have_modifiers: diag(1193, 1 /* Error */ , "An_export_declaration_cannot_have_modifiers_1193", "An export declaration cannot have modifiers."),
        Export_declarations_are_not_permitted_in_a_namespace: diag(1194, 1 /* Error */ , "Export_declarations_are_not_permitted_in_a_namespace_1194", "Export declarations are not permitted in a namespace."),
        export_Asterisk_does_not_re_export_a_default: diag(1195, 1 /* Error */ , "export_Asterisk_does_not_re_export_a_default_1195", "'export *' does not re-export a default."),
        Catch_clause_variable_type_annotation_must_be_any_or_unknown_if_specified: diag(1196, 1 /* Error */ , "Catch_clause_variable_type_annotation_must_be_any_or_unknown_if_specified_1196", "Catch clause variable type annotation must be 'any' or 'unknown' if specified."),
        Catch_clause_variable_cannot_have_an_initializer: diag(1197, 1 /* Error */ , "Catch_clause_variable_cannot_have_an_initializer_1197", "Catch clause variable cannot have an initializer."),
        An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive: diag(1198, 1 /* Error */ , "An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive_1198", "An extended Unicode escape value must be between 0x0 and 0x10FFFF inclusive."),
        Unterminated_Unicode_escape_sequence: diag(1199, 1 /* Error */ , "Unterminated_Unicode_escape_sequence_1199", "Unterminated Unicode escape sequence."),
        Line_terminator_not_permitted_before_arrow: diag(1200, 1 /* Error */ , "Line_terminator_not_permitted_before_arrow_1200", "Line terminator not permitted before arrow."),
        Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead: diag(1202, 1 /* Error */ , "Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_1202", `Import assignment cannot be used when targeting ECMAScript modules. Consider using 'import * as ns from "mod"', 'import {a} from "mod"', 'import d from "mod"', or another module format instead.`),
        Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead: diag(1203, 1 /* Error */ , "Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or__1203", "Export assignment cannot be used when targeting ECMAScript modules. Consider using 'export default' or another module format instead."),
        Re_exporting_a_type_when_0_is_enabled_requires_using_export_type: diag(1205, 1 /* Error */ , "Re_exporting_a_type_when_0_is_enabled_requires_using_export_type_1205", "Re-exporting a type when '{0}' is enabled requires using 'export type'."),
        Decorators_are_not_valid_here: diag(1206, 1 /* Error */ , "Decorators_are_not_valid_here_1206", "Decorators are not valid here."),
        Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name: diag(1207, 1 /* Error */ , "Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name_1207", "Decorators cannot be applied to multiple get/set accessors of the same name."),
        Invalid_optional_chain_from_new_expression_Did_you_mean_to_call_0: diag(1209, 1 /* Error */ , "Invalid_optional_chain_from_new_expression_Did_you_mean_to_call_0_1209", "Invalid optional chain from new expression. Did you mean to call '{0}()'?"),
        Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of_0_For_more_information_see_https_Colon_Slash_Slashdeveloper_mozilla_org_Slashen_US_Slashdocs_SlashWeb_SlashJavaScript_SlashReference_SlashStrict_mode: diag(1210, 1 /* Error */ , "Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of__1210", "Code contained in a class is evaluated in JavaScript's strict mode which does not allow this use of '{0}'. For more information, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Strict_mode."),
        A_class_declaration_without_the_default_modifier_must_have_a_name: diag(1211, 1 /* Error */ , "A_class_declaration_without_the_default_modifier_must_have_a_name_1211", "A class declaration without the 'default' modifier must have a name."),
        Identifier_expected_0_is_a_reserved_word_in_strict_mode: diag(1212, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_in_strict_mode_1212", "Identifier expected. '{0}' is a reserved word in strict mode."),
        Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode: diag(1213, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_stric_1213", "Identifier expected. '{0}' is a reserved word in strict mode. Class definitions are automatically in strict mode."),
        Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode: diag(1214, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode_1214", "Identifier expected. '{0}' is a reserved word in strict mode. Modules are automatically in strict mode."),
        Invalid_use_of_0_Modules_are_automatically_in_strict_mode: diag(1215, 1 /* Error */ , "Invalid_use_of_0_Modules_are_automatically_in_strict_mode_1215", "Invalid use of '{0}'. Modules are automatically in strict mode."),
        Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules: diag(1216, 1 /* Error */ , "Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules_1216", "Identifier expected. '__esModule' is reserved as an exported marker when transforming ECMAScript modules."),
        Export_assignment_is_not_supported_when_module_flag_is_system: diag(1218, 1 /* Error */ , "Export_assignment_is_not_supported_when_module_flag_is_system_1218", "Export assignment is not supported when '--module' flag is 'system'."),
        Generators_are_not_allowed_in_an_ambient_context: diag(1221, 1 /* Error */ , "Generators_are_not_allowed_in_an_ambient_context_1221", "Generators are not allowed in an ambient context."),
        An_overload_signature_cannot_be_declared_as_a_generator: diag(1222, 1 /* Error */ , "An_overload_signature_cannot_be_declared_as_a_generator_1222", "An overload signature cannot be declared as a generator."),
        _0_tag_already_specified: diag(1223, 1 /* Error */ , "_0_tag_already_specified_1223", "'{0}' tag already specified."),
        Signature_0_must_be_a_type_predicate: diag(1224, 1 /* Error */ , "Signature_0_must_be_a_type_predicate_1224", "Signature '{0}' must be a type predicate."),
        Cannot_find_parameter_0: diag(1225, 1 /* Error */ , "Cannot_find_parameter_0_1225", "Cannot find parameter '{0}'."),
        Type_predicate_0_is_not_assignable_to_1: diag(1226, 1 /* Error */ , "Type_predicate_0_is_not_assignable_to_1_1226", "Type predicate '{0}' is not assignable to '{1}'."),
        Parameter_0_is_not_in_the_same_position_as_parameter_1: diag(1227, 1 /* Error */ , "Parameter_0_is_not_in_the_same_position_as_parameter_1_1227", "Parameter '{0}' is not in the same position as parameter '{1}'."),
        A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods: diag(1228, 1 /* Error */ , "A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods_1228", "A type predicate is only allowed in return type position for functions and methods."),
        A_type_predicate_cannot_reference_a_rest_parameter: diag(1229, 1 /* Error */ , "A_type_predicate_cannot_reference_a_rest_parameter_1229", "A type predicate cannot reference a rest parameter."),
        A_type_predicate_cannot_reference_element_0_in_a_binding_pattern: diag(1230, 1 /* Error */ , "A_type_predicate_cannot_reference_element_0_in_a_binding_pattern_1230", "A type predicate cannot reference element '{0}' in a binding pattern."),
        An_export_assignment_must_be_at_the_top_level_of_a_file_or_module_declaration: diag(1231, 1 /* Error */ , "An_export_assignment_must_be_at_the_top_level_of_a_file_or_module_declaration_1231", "An export assignment must be at the top level of a file or module declaration."),
        An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module: diag(1232, 1 /* Error */ , "An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module_1232", "An import declaration can only be used at the top level of a namespace or module."),
        An_export_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module: diag(1233, 1 /* Error */ , "An_export_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module_1233", "An export declaration can only be used at the top level of a namespace or module."),
        An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file: diag(1234, 1 /* Error */ , "An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file_1234", "An ambient module declaration is only allowed at the top level in a file."),
        A_namespace_declaration_is_only_allowed_at_the_top_level_of_a_namespace_or_module: diag(1235, 1 /* Error */ , "A_namespace_declaration_is_only_allowed_at_the_top_level_of_a_namespace_or_module_1235", "A namespace declaration is only allowed at the top level of a namespace or module."),
        The_return_type_of_a_property_decorator_function_must_be_either_void_or_any: diag(1236, 1 /* Error */ , "The_return_type_of_a_property_decorator_function_must_be_either_void_or_any_1236", "The return type of a property decorator function must be either 'void' or 'any'."),
        The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any: diag(1237, 1 /* Error */ , "The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any_1237", "The return type of a parameter decorator function must be either 'void' or 'any'."),
        Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression: diag(1238, 1 /* Error */ , "Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression_1238", "Unable to resolve signature of class decorator when called as an expression."),
        Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression: diag(1239, 1 /* Error */ , "Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression_1239", "Unable to resolve signature of parameter decorator when called as an expression."),
        Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression: diag(1240, 1 /* Error */ , "Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression_1240", "Unable to resolve signature of property decorator when called as an expression."),
        Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression: diag(1241, 1 /* Error */ , "Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression_1241", "Unable to resolve signature of method decorator when called as an expression."),
        abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration: diag(1242, 1 /* Error */ , "abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration_1242", "'abstract' modifier can only appear on a class, method, or property declaration."),
        _0_modifier_cannot_be_used_with_1_modifier: diag(1243, 1 /* Error */ , "_0_modifier_cannot_be_used_with_1_modifier_1243", "'{0}' modifier cannot be used with '{1}' modifier."),
        Abstract_methods_can_only_appear_within_an_abstract_class: diag(1244, 1 /* Error */ , "Abstract_methods_can_only_appear_within_an_abstract_class_1244", "Abstract methods can only appear within an abstract class."),
        Method_0_cannot_have_an_implementation_because_it_is_marked_abstract: diag(1245, 1 /* Error */ , "Method_0_cannot_have_an_implementation_because_it_is_marked_abstract_1245", "Method '{0}' cannot have an implementation because it is marked abstract."),
        An_interface_property_cannot_have_an_initializer: diag(1246, 1 /* Error */ , "An_interface_property_cannot_have_an_initializer_1246", "An interface property cannot have an initializer."),
        A_type_literal_property_cannot_have_an_initializer: diag(1247, 1 /* Error */ , "A_type_literal_property_cannot_have_an_initializer_1247", "A type literal property cannot have an initializer."),
        A_class_member_cannot_have_the_0_keyword: diag(1248, 1 /* Error */ , "A_class_member_cannot_have_the_0_keyword_1248", "A class member cannot have the '{0}' keyword."),
        A_decorator_can_only_decorate_a_method_implementation_not_an_overload: diag(1249, 1 /* Error */ , "A_decorator_can_only_decorate_a_method_implementation_not_an_overload_1249", "A decorator can only decorate a method implementation, not an overload."),
        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5: diag(1250, 1 /* Error */ , "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_1250", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES5'."),
        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_Class_definitions_are_automatically_in_strict_mode: diag(1251, 1 /* Error */ , "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_Class_definiti_1251", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES5'. Class definitions are automatically in strict mode."),
        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_Modules_are_automatically_in_strict_mode: diag(1252, 1 /* Error */ , "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_Modules_are_au_1252", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES5'. Modules are automatically in strict mode."),
        Abstract_properties_can_only_appear_within_an_abstract_class: diag(1253, 1 /* Error */ , "Abstract_properties_can_only_appear_within_an_abstract_class_1253", "Abstract properties can only appear within an abstract class."),
        A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_or_literal_enum_reference: diag(1254, 1 /* Error */ , "A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_or_literal_enum_refere_1254", "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference."),
        A_definite_assignment_assertion_is_not_permitted_in_this_context: diag(1255, 1 /* Error */ , "A_definite_assignment_assertion_is_not_permitted_in_this_context_1255", "A definite assignment assertion '!' is not permitted in this context."),
        A_required_element_cannot_follow_an_optional_element: diag(1257, 1 /* Error */ , "A_required_element_cannot_follow_an_optional_element_1257", "A required element cannot follow an optional element."),
        A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration: diag(1258, 1 /* Error */ , "A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration_1258", "A default export must be at the top level of a file or module declaration."),
        Module_0_can_only_be_default_imported_using_the_1_flag: diag(1259, 1 /* Error */ , "Module_0_can_only_be_default_imported_using_the_1_flag_1259", "Module '{0}' can only be default-imported using the '{1}' flag"),
        Keywords_cannot_contain_escape_characters: diag(1260, 1 /* Error */ , "Keywords_cannot_contain_escape_characters_1260", "Keywords cannot contain escape characters."),
        Already_included_file_name_0_differs_from_file_name_1_only_in_casing: diag(1261, 1 /* Error */ , "Already_included_file_name_0_differs_from_file_name_1_only_in_casing_1261", "Already included file name '{0}' differs from file name '{1}' only in casing."),
        Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module: diag(1262, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module_1262", "Identifier expected. '{0}' is a reserved word at the top-level of a module."),
        Declarations_with_initializers_cannot_also_have_definite_assignment_assertions: diag(1263, 1 /* Error */ , "Declarations_with_initializers_cannot_also_have_definite_assignment_assertions_1263", "Declarations with initializers cannot also have definite assignment assertions."),
        Declarations_with_definite_assignment_assertions_must_also_have_type_annotations: diag(1264, 1 /* Error */ , "Declarations_with_definite_assignment_assertions_must_also_have_type_annotations_1264", "Declarations with definite assignment assertions must also have type annotations."),
        A_rest_element_cannot_follow_another_rest_element: diag(1265, 1 /* Error */ , "A_rest_element_cannot_follow_another_rest_element_1265", "A rest element cannot follow another rest element."),
        An_optional_element_cannot_follow_a_rest_element: diag(1266, 1 /* Error */ , "An_optional_element_cannot_follow_a_rest_element_1266", "An optional element cannot follow a rest element."),
        Property_0_cannot_have_an_initializer_because_it_is_marked_abstract: diag(1267, 1 /* Error */ , "Property_0_cannot_have_an_initializer_because_it_is_marked_abstract_1267", "Property '{0}' cannot have an initializer because it is marked abstract."),
        An_index_signature_parameter_type_must_be_string_number_symbol_or_a_template_literal_type: diag(1268, 1 /* Error */ , "An_index_signature_parameter_type_must_be_string_number_symbol_or_a_template_literal_type_1268", "An index signature parameter type must be 'string', 'number', 'symbol', or a template literal type."),
        Cannot_use_export_import_on_a_type_or_type_only_namespace_when_0_is_enabled: diag(1269, 1 /* Error */ , "Cannot_use_export_import_on_a_type_or_type_only_namespace_when_0_is_enabled_1269", "Cannot use 'export import' on a type or type-only namespace when '{0}' is enabled."),
        Decorator_function_return_type_0_is_not_assignable_to_type_1: diag(1270, 1 /* Error */ , "Decorator_function_return_type_0_is_not_assignable_to_type_1_1270", "Decorator function return type '{0}' is not assignable to type '{1}'."),
        Decorator_function_return_type_is_0_but_is_expected_to_be_void_or_any: diag(1271, 1 /* Error */ , "Decorator_function_return_type_is_0_but_is_expected_to_be_void_or_any_1271", "Decorator function return type is '{0}' but is expected to be 'void' or 'any'."),
        A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_when_isolatedModules_and_emitDecoratorMetadata_are_enabled: diag(1272, 1 /* Error */ , "A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_w_1272", "A type referenced in a decorated signature must be imported with 'import type' or a namespace import when 'isolatedModules' and 'emitDecoratorMetadata' are enabled."),
        _0_modifier_cannot_appear_on_a_type_parameter: diag(1273, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_type_parameter_1273", "'{0}' modifier cannot appear on a type parameter"),
        _0_modifier_can_only_appear_on_a_type_parameter_of_a_class_interface_or_type_alias: diag(1274, 1 /* Error */ , "_0_modifier_can_only_appear_on_a_type_parameter_of_a_class_interface_or_type_alias_1274", "'{0}' modifier can only appear on a type parameter of a class, interface or type alias"),
        accessor_modifier_can_only_appear_on_a_property_declaration: diag(1275, 1 /* Error */ , "accessor_modifier_can_only_appear_on_a_property_declaration_1275", "'accessor' modifier can only appear on a property declaration."),
        An_accessor_property_cannot_be_declared_optional: diag(1276, 1 /* Error */ , "An_accessor_property_cannot_be_declared_optional_1276", "An 'accessor' property cannot be declared optional."),
        _0_modifier_can_only_appear_on_a_type_parameter_of_a_function_method_or_class: diag(1277, 1 /* Error */ , "_0_modifier_can_only_appear_on_a_type_parameter_of_a_function_method_or_class_1277", "'{0}' modifier can only appear on a type parameter of a function, method or class"),
        The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_0: diag(1278, 1 /* Error */ , "The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_0_1278", "The runtime will invoke the decorator with {1} arguments, but the decorator expects {0}."),
        The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_at_least_0: diag(1279, 1 /* Error */ , "The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_at_least_0_1279", "The runtime will invoke the decorator with {1} arguments, but the decorator expects at least {0}."),
        Namespaces_are_not_allowed_in_global_script_files_when_0_is_enabled_If_this_file_is_not_intended_to_be_a_global_script_set_moduleDetection_to_force_or_add_an_empty_export_statement: diag(1280, 1 /* Error */ , "Namespaces_are_not_allowed_in_global_script_files_when_0_is_enabled_If_this_file_is_not_intended_to__1280", "Namespaces are not allowed in global script files when '{0}' is enabled. If this file is not intended to be a global script, set 'moduleDetection' to 'force' or add an empty 'export {}' statement."),
        Cannot_access_0_from_another_file_without_qualification_when_1_is_enabled_Use_2_instead: diag(1281, 1 /* Error */ , "Cannot_access_0_from_another_file_without_qualification_when_1_is_enabled_Use_2_instead_1281", "Cannot access '{0}' from another file without qualification when '{1}' is enabled. Use '{2}' instead."),
        An_export_declaration_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type: diag(1282, 1 /* Error */ , "An_export_declaration_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers__1282", "An 'export =' declaration must reference a value when 'verbatimModuleSyntax' is enabled, but '{0}' only refers to a type."),
        An_export_declaration_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration: diag(1283, 1 /* Error */ , "An_export_declaration_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolve_1283", "An 'export =' declaration must reference a real value when 'verbatimModuleSyntax' is enabled, but '{0}' resolves to a type-only declaration."),
        An_export_default_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type: diag(1284, 1 /* Error */ , "An_export_default_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_1284", "An 'export default' must reference a value when 'verbatimModuleSyntax' is enabled, but '{0}' only refers to a type."),
        An_export_default_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration: diag(1285, 1 /* Error */ , "An_export_default_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_1285", "An 'export default' must reference a real value when 'verbatimModuleSyntax' is enabled, but '{0}' resolves to a type-only declaration."),
        ECMAScript_imports_and_exports_cannot_be_written_in_a_CommonJS_file_under_verbatimModuleSyntax: diag(1286, 1 /* Error */ , "ECMAScript_imports_and_exports_cannot_be_written_in_a_CommonJS_file_under_verbatimModuleSyntax_1286", "ECMAScript imports and exports cannot be written in a CommonJS file under 'verbatimModuleSyntax'."),
        A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled: diag(1287, 1 /* Error */ , "A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimM_1287", "A top-level 'export' modifier cannot be used on value declarations in a CommonJS module when 'verbatimModuleSyntax' is enabled."),
        An_import_alias_cannot_resolve_to_a_type_or_type_only_declaration_when_verbatimModuleSyntax_is_enabled: diag(1288, 1 /* Error */ , "An_import_alias_cannot_resolve_to_a_type_or_type_only_declaration_when_verbatimModuleSyntax_is_enabl_1288", "An import alias cannot resolve to a type or type-only declaration when 'verbatimModuleSyntax' is enabled."),
        _0_resolves_to_a_type_only_declaration_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_import_type_where_0_is_imported: diag(1289, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_marked_type_only_in_this_file_before_re_exporting_1289", "'{0}' resolves to a type-only declaration and must be marked type-only in this file before re-exporting when '{1}' is enabled. Consider using 'import type' where '{0}' is imported."),
        _0_resolves_to_a_type_only_declaration_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_export_type_0_as_default: diag(1290, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_marked_type_only_in_this_file_before_re_exporting_1290", "'{0}' resolves to a type-only declaration and must be marked type-only in this file before re-exporting when '{1}' is enabled. Consider using 'export type { {0} as default }'."),
        _0_resolves_to_a_type_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_import_type_where_0_is_imported: diag(1291, 1 /* Error */ , "_0_resolves_to_a_type_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enable_1291", "'{0}' resolves to a type and must be marked type-only in this file before re-exporting when '{1}' is enabled. Consider using 'import type' where '{0}' is imported."),
        _0_resolves_to_a_type_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_export_type_0_as_default: diag(1292, 1 /* Error */ , "_0_resolves_to_a_type_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enable_1292", "'{0}' resolves to a type and must be marked type-only in this file before re-exporting when '{1}' is enabled. Consider using 'export type { {0} as default }'."),
        ECMAScript_module_syntax_is_not_allowed_in_a_CommonJS_module_when_module_is_set_to_preserve: diag(1293, 1 /* Error */ , "ECMAScript_module_syntax_is_not_allowed_in_a_CommonJS_module_when_module_is_set_to_preserve_1293", "ECMAScript module syntax is not allowed in a CommonJS module when 'module' is set to 'preserve'."),
        This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled: diag(1294, 1 /* Error */ , "This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled_1294", "This syntax is not allowed when 'erasableSyntaxOnly' is enabled."),
        ECMAScript_imports_and_exports_cannot_be_written_in_a_CommonJS_file_under_verbatimModuleSyntax_Adjust_the_type_field_in_the_nearest_package_json_to_make_this_file_an_ECMAScript_module_or_adjust_your_verbatimModuleSyntax_module_and_moduleResolution_settings_in_TypeScript: diag(1295, 1 /* Error */ , "ECMAScript_imports_and_exports_cannot_be_written_in_a_CommonJS_file_under_verbatimModuleSyntax_Adjus_1295", "ECMAScript imports and exports cannot be written in a CommonJS file under 'verbatimModuleSyntax'. Adjust the 'type' field in the nearest 'package.json' to make this file an ECMAScript module, or adjust your 'verbatimModuleSyntax', 'module', and 'moduleResolution' settings in TypeScript."),
        with_statements_are_not_allowed_in_an_async_function_block: diag(1300, 1 /* Error */ , "with_statements_are_not_allowed_in_an_async_function_block_1300", "'with' statements are not allowed in an async function block."),
        await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules: diag(1308, 1 /* Error */ , "await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules_1308", "'await' expressions are only allowed within async functions and at the top levels of modules."),
        The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level: diag(1309, 1 /* Error */ , "The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level_1309", "The current file is a CommonJS module and cannot use 'await' at the top level."),
        Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern: diag(1312, 1 /* Error */ , "Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_1312", "Did you mean to use a ':'? An '=' can only follow a property name when the containing object literal is part of a destructuring pattern."),
        The_body_of_an_if_statement_cannot_be_the_empty_statement: diag(1313, 1 /* Error */ , "The_body_of_an_if_statement_cannot_be_the_empty_statement_1313", "The body of an 'if' statement cannot be the empty statement."),
        Global_module_exports_may_only_appear_in_module_files: diag(1314, 1 /* Error */ , "Global_module_exports_may_only_appear_in_module_files_1314", "Global module exports may only appear in module files."),
        Global_module_exports_may_only_appear_in_declaration_files: diag(1315, 1 /* Error */ , "Global_module_exports_may_only_appear_in_declaration_files_1315", "Global module exports may only appear in declaration files."),
        Global_module_exports_may_only_appear_at_top_level: diag(1316, 1 /* Error */ , "Global_module_exports_may_only_appear_at_top_level_1316", "Global module exports may only appear at top level."),
        A_parameter_property_cannot_be_declared_using_a_rest_parameter: diag(1317, 1 /* Error */ , "A_parameter_property_cannot_be_declared_using_a_rest_parameter_1317", "A parameter property cannot be declared using a rest parameter."),
        An_abstract_accessor_cannot_have_an_implementation: diag(1318, 1 /* Error */ , "An_abstract_accessor_cannot_have_an_implementation_1318", "An abstract accessor cannot have an implementation."),
        A_default_export_can_only_be_used_in_an_ECMAScript_style_module: diag(1319, 1 /* Error */ , "A_default_export_can_only_be_used_in_an_ECMAScript_style_module_1319", "A default export can only be used in an ECMAScript-style module."),
        Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1320, 1 /* Error */ , "Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member_1320", "Type of 'await' operand must either be a valid promise or must not contain a callable 'then' member."),
        Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1321, 1 /* Error */ , "Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_cal_1321", "Type of 'yield' operand in an async generator must either be a valid promise or must not contain a callable 'then' member."),
        Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1322, 1 /* Error */ , "Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_con_1322", "Type of iterated elements of a 'yield*' operand must either be a valid promise or must not contain a callable 'then' member."),
        Dynamic_imports_are_only_supported_when_the_module_flag_is_set_to_es2020_es2022_esnext_commonjs_amd_system_umd_node16_node18_node20_or_nodenext: diag(1323, 1 /* Error */ , "Dynamic_imports_are_only_supported_when_the_module_flag_is_set_to_es2020_es2022_esnext_commonjs_amd__1323", "Dynamic imports are only supported when the '--module' flag is set to 'es2020', 'es2022', 'esnext', 'commonjs', 'amd', 'system', 'umd', 'node16', 'node18', 'node20', or 'nodenext'."),
        Dynamic_imports_only_support_a_second_argument_when_the_module_option_is_set_to_esnext_node16_node18_node20_nodenext_or_preserve: diag(1324, 1 /* Error */ , "Dynamic_imports_only_support_a_second_argument_when_the_module_option_is_set_to_esnext_node16_node18_1324", "Dynamic imports only support a second argument when the '--module' option is set to 'esnext', 'node16', 'node18', 'node20', 'nodenext', or 'preserve'."),
        Argument_of_dynamic_import_cannot_be_spread_element: diag(1325, 1 /* Error */ , "Argument_of_dynamic_import_cannot_be_spread_element_1325", "Argument of dynamic import cannot be spread element."),
        This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot_have_type_arguments: diag(1326, 1 /* Error */ , "This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot__1326", "This use of 'import' is invalid. 'import()' calls can be written, but they must have parentheses and cannot have type arguments."),
        String_literal_with_double_quotes_expected: diag(1327, 1 /* Error */ , "String_literal_with_double_quotes_expected_1327", "String literal with double quotes expected."),
        Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal: diag(1328, 1 /* Error */ , "Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_li_1328", "Property value can only be string literal, numeric literal, 'true', 'false', 'null', object literal or array literal."),
        _0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0: diag(1329, 1 /* Error */ , "_0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write__1329", "'{0}' accepts too few arguments to be used as a decorator here. Did you mean to call it first and write '@{0}()'?"),
        A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly: diag(1330, 1 /* Error */ , "A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly_1330", "A property of an interface or type literal whose type is a 'unique symbol' type must be 'readonly'."),
        A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly: diag(1331, 1 /* Error */ , "A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly_1331", "A property of a class whose type is a 'unique symbol' type must be both 'static' and 'readonly'."),
        A_variable_whose_type_is_a_unique_symbol_type_must_be_const: diag(1332, 1 /* Error */ , "A_variable_whose_type_is_a_unique_symbol_type_must_be_const_1332", "A variable whose type is a 'unique symbol' type must be 'const'."),
        unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name: diag(1333, 1 /* Error */ , "unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name_1333", "'unique symbol' types may not be used on a variable declaration with a binding name."),
        unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement: diag(1334, 1 /* Error */ , "unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement_1334", "'unique symbol' types are only allowed on variables in a variable statement."),
        unique_symbol_types_are_not_allowed_here: diag(1335, 1 /* Error */ , "unique_symbol_types_are_not_allowed_here_1335", "'unique symbol' types are not allowed here."),
        An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_object_type_instead: diag(1337, 1 /* Error */ , "An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_o_1337", "An index signature parameter type cannot be a literal type or generic type. Consider using a mapped object type instead."),
        infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type: diag(1338, 1 /* Error */ , "infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type_1338", "'infer' declarations are only permitted in the 'extends' clause of a conditional type."),
        Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here: diag(1339, 1 /* Error */ , "Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here_1339", "Module '{0}' does not refer to a value, but is used as a value here."),
        Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0: diag(1340, 1 /* Error */ , "Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0_1340", "Module '{0}' does not refer to a type, but is used as a type here. Did you mean 'typeof import('{0}')'?"),
        Class_constructor_may_not_be_an_accessor: diag(1341, 1 /* Error */ , "Class_constructor_may_not_be_an_accessor_1341", "Class constructor may not be an accessor."),
        The_import_meta_meta_property_is_only_allowed_when_the_module_option_is_es2020_es2022_esnext_system_node16_node18_node20_or_nodenext: diag(1343, 1 /* Error */ , "The_import_meta_meta_property_is_only_allowed_when_the_module_option_is_es2020_es2022_esnext_system__1343", "The 'import.meta' meta-property is only allowed when the '--module' option is 'es2020', 'es2022', 'esnext', 'system', 'node16', 'node18', 'node20', or 'nodenext'."),
        A_label_is_not_allowed_here: diag(1344, 1 /* Error */ , "A_label_is_not_allowed_here_1344", "'A label is not allowed here."),
        An_expression_of_type_void_cannot_be_tested_for_truthiness: diag(1345, 1 /* Error */ , "An_expression_of_type_void_cannot_be_tested_for_truthiness_1345", "An expression of type 'void' cannot be tested for truthiness."),
        This_parameter_is_not_allowed_with_use_strict_directive: diag(1346, 1 /* Error */ , "This_parameter_is_not_allowed_with_use_strict_directive_1346", "This parameter is not allowed with 'use strict' directive."),
        use_strict_directive_cannot_be_used_with_non_simple_parameter_list: diag(1347, 1 /* Error */ , "use_strict_directive_cannot_be_used_with_non_simple_parameter_list_1347", "'use strict' directive cannot be used with non-simple parameter list."),
        Non_simple_parameter_declared_here: diag(1348, 1 /* Error */ , "Non_simple_parameter_declared_here_1348", "Non-simple parameter declared here."),
        use_strict_directive_used_here: diag(1349, 1 /* Error */ , "use_strict_directive_used_here_1349", "'use strict' directive used here."),
        Print_the_final_configuration_instead_of_building: diag(1350, 3 /* Message */ , "Print_the_final_configuration_instead_of_building_1350", "Print the final configuration instead of building."),
        An_identifier_or_keyword_cannot_immediately_follow_a_numeric_literal: diag(1351, 1 /* Error */ , "An_identifier_or_keyword_cannot_immediately_follow_a_numeric_literal_1351", "An identifier or keyword cannot immediately follow a numeric literal."),
        A_bigint_literal_cannot_use_exponential_notation: diag(1352, 1 /* Error */ , "A_bigint_literal_cannot_use_exponential_notation_1352", "A bigint literal cannot use exponential notation."),
        A_bigint_literal_must_be_an_integer: diag(1353, 1 /* Error */ , "A_bigint_literal_must_be_an_integer_1353", "A bigint literal must be an integer."),
        readonly_type_modifier_is_only_permitted_on_array_and_tuple_literal_types: diag(1354, 1 /* Error */ , "readonly_type_modifier_is_only_permitted_on_array_and_tuple_literal_types_1354", "'readonly' type modifier is only permitted on array and tuple literal types."),
        A_const_assertions_can_only_be_applied_to_references_to_enum_members_or_string_number_boolean_array_or_object_literals: diag(1355, 1 /* Error */ , "A_const_assertions_can_only_be_applied_to_references_to_enum_members_or_string_number_boolean_array__1355", "A 'const' assertions can only be applied to references to enum members, or string, number, boolean, array, or object literals."),
        Did_you_mean_to_mark_this_function_as_async: diag(1356, 1 /* Error */ , "Did_you_mean_to_mark_this_function_as_async_1356", "Did you mean to mark this function as 'async'?"),
        An_enum_member_name_must_be_followed_by_a_or: diag(1357, 1 /* Error */ , "An_enum_member_name_must_be_followed_by_a_or_1357", "An enum member name must be followed by a ',', '=', or '}'."),
        Tagged_template_expressions_are_not_permitted_in_an_optional_chain: diag(1358, 1 /* Error */ , "Tagged_template_expressions_are_not_permitted_in_an_optional_chain_1358", "Tagged template expressions are not permitted in an optional chain."),
        Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here: diag(1359, 1 /* Error */ , "Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here_1359", "Identifier expected. '{0}' is a reserved word that cannot be used here."),
        Type_0_does_not_satisfy_the_expected_type_1: diag(1360, 1 /* Error */ , "Type_0_does_not_satisfy_the_expected_type_1_1360", "Type '{0}' does not satisfy the expected type '{1}'."),
        _0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type: diag(1361, 1 /* Error */ , "_0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type_1361", "'{0}' cannot be used as a value because it was imported using 'import type'."),
        _0_cannot_be_used_as_a_value_because_it_was_exported_using_export_type: diag(1362, 1 /* Error */ , "_0_cannot_be_used_as_a_value_because_it_was_exported_using_export_type_1362", "'{0}' cannot be used as a value because it was exported using 'export type'."),
        A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both: diag(1363, 1 /* Error */ , "A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both_1363", "A type-only import can specify a default import or named bindings, but not both."),
        Convert_to_type_only_export: diag(1364, 3 /* Message */ , "Convert_to_type_only_export_1364", "Convert to type-only export"),
        Convert_all_re_exported_types_to_type_only_exports: diag(1365, 3 /* Message */ , "Convert_all_re_exported_types_to_type_only_exports_1365", "Convert all re-exported types to type-only exports"),
        Split_into_two_separate_import_declarations: diag(1366, 3 /* Message */ , "Split_into_two_separate_import_declarations_1366", "Split into two separate import declarations"),
        Split_all_invalid_type_only_imports: diag(1367, 3 /* Message */ , "Split_all_invalid_type_only_imports_1367", "Split all invalid type-only imports"),
        Class_constructor_may_not_be_a_generator: diag(1368, 1 /* Error */ , "Class_constructor_may_not_be_a_generator_1368", "Class constructor may not be a generator."),
        Did_you_mean_0: diag(1369, 3 /* Message */ , "Did_you_mean_0_1369", "Did you mean '{0}'?"),
        await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module: diag(1375, 1 /* Error */ , "await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_fi_1375", "'await' expressions are only allowed at the top level of a file when that file is a module, but this file has no imports or exports. Consider adding an empty 'export {}' to make this file a module."),
        _0_was_imported_here: diag(1376, 3 /* Message */ , "_0_was_imported_here_1376", "'{0}' was imported here."),
        _0_was_exported_here: diag(1377, 3 /* Message */ , "_0_was_exported_here_1377", "'{0}' was exported here."),
        Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher: diag(1378, 1 /* Error */ , "Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_n_1378", "Top-level 'await' expressions are only allowed when the 'module' option is set to 'es2022', 'esnext', 'system', 'node16', 'node18', 'node20', 'nodenext', or 'preserve', and the 'target' option is set to 'es2017' or higher."),
        An_import_alias_cannot_reference_a_declaration_that_was_exported_using_export_type: diag(1379, 1 /* Error */ , "An_import_alias_cannot_reference_a_declaration_that_was_exported_using_export_type_1379", "An import alias cannot reference a declaration that was exported using 'export type'."),
        An_import_alias_cannot_reference_a_declaration_that_was_imported_using_import_type: diag(1380, 1 /* Error */ , "An_import_alias_cannot_reference_a_declaration_that_was_imported_using_import_type_1380", "An import alias cannot reference a declaration that was imported using 'import type'."),
        Unexpected_token_Did_you_mean_or_rbrace: diag(1381, 1 /* Error */ , "Unexpected_token_Did_you_mean_or_rbrace_1381", "Unexpected token. Did you mean `{'}'}` or `&rbrace;`?"),
        Unexpected_token_Did_you_mean_or_gt: diag(1382, 1 /* Error */ , "Unexpected_token_Did_you_mean_or_gt_1382", "Unexpected token. Did you mean `{'>'}` or `&gt;`?"),
        Function_type_notation_must_be_parenthesized_when_used_in_a_union_type: diag(1385, 1 /* Error */ , "Function_type_notation_must_be_parenthesized_when_used_in_a_union_type_1385", "Function type notation must be parenthesized when used in a union type."),
        Constructor_type_notation_must_be_parenthesized_when_used_in_a_union_type: diag(1386, 1 /* Error */ , "Constructor_type_notation_must_be_parenthesized_when_used_in_a_union_type_1386", "Constructor type notation must be parenthesized when used in a union type."),
        Function_type_notation_must_be_parenthesized_when_used_in_an_intersection_type: diag(1387, 1 /* Error */ , "Function_type_notation_must_be_parenthesized_when_used_in_an_intersection_type_1387", "Function type notation must be parenthesized when used in an intersection type."),
        Constructor_type_notation_must_be_parenthesized_when_used_in_an_intersection_type: diag(1388, 1 /* Error */ , "Constructor_type_notation_must_be_parenthesized_when_used_in_an_intersection_type_1388", "Constructor type notation must be parenthesized when used in an intersection type."),
        _0_is_not_allowed_as_a_variable_declaration_name: diag(1389, 1 /* Error */ , "_0_is_not_allowed_as_a_variable_declaration_name_1389", "'{0}' is not allowed as a variable declaration name."),
        _0_is_not_allowed_as_a_parameter_name: diag(1390, 1 /* Error */ , "_0_is_not_allowed_as_a_parameter_name_1390", "'{0}' is not allowed as a parameter name."),
        An_import_alias_cannot_use_import_type: diag(1392, 1 /* Error */ , "An_import_alias_cannot_use_import_type_1392", "An import alias cannot use 'import type'"),
        Imported_via_0_from_file_1: diag(1393, 3 /* Message */ , "Imported_via_0_from_file_1_1393", "Imported via {0} from file '{1}'"),
        Imported_via_0_from_file_1_with_packageId_2: diag(1394, 3 /* Message */ , "Imported_via_0_from_file_1_with_packageId_2_1394", "Imported via {0} from file '{1}' with packageId '{2}'"),
        Imported_via_0_from_file_1_to_import_importHelpers_as_specified_in_compilerOptions: diag(1395, 3 /* Message */ , "Imported_via_0_from_file_1_to_import_importHelpers_as_specified_in_compilerOptions_1395", "Imported via {0} from file '{1}' to import 'importHelpers' as specified in compilerOptions"),
        Imported_via_0_from_file_1_with_packageId_2_to_import_importHelpers_as_specified_in_compilerOptions: diag(1396, 3 /* Message */ , "Imported_via_0_from_file_1_with_packageId_2_to_import_importHelpers_as_specified_in_compilerOptions_1396", "Imported via {0} from file '{1}' with packageId '{2}' to import 'importHelpers' as specified in compilerOptions"),
        Imported_via_0_from_file_1_to_import_jsx_and_jsxs_factory_functions: diag(1397, 3 /* Message */ , "Imported_via_0_from_file_1_to_import_jsx_and_jsxs_factory_functions_1397", "Imported via {0} from file '{1}' to import 'jsx' and 'jsxs' factory functions"),
        Imported_via_0_from_file_1_with_packageId_2_to_import_jsx_and_jsxs_factory_functions: diag(1398, 3 /* Message */ , "Imported_via_0_from_file_1_with_packageId_2_to_import_jsx_and_jsxs_factory_functions_1398", "Imported via {0} from file '{1}' with packageId '{2}' to import 'jsx' and 'jsxs' factory functions"),
        File_is_included_via_import_here: diag(1399, 3 /* Message */ , "File_is_included_via_import_here_1399", "File is included via import here."),
        Referenced_via_0_from_file_1: diag(1400, 3 /* Message */ , "Referenced_via_0_from_file_1_1400", "Referenced via '{0}' from file '{1}'"),
        File_is_included_via_reference_here: diag(1401, 3 /* Message */ , "File_is_included_via_reference_here_1401", "File is included via reference here."),
        Type_library_referenced_via_0_from_file_1: diag(1402, 3 /* Message */ , "Type_library_referenced_via_0_from_file_1_1402", "Type library referenced via '{0}' from file '{1}'"),
        Type_library_referenced_via_0_from_file_1_with_packageId_2: diag(1403, 3 /* Message */ , "Type_library_referenced_via_0_from_file_1_with_packageId_2_1403", "Type library referenced via '{0}' from file '{1}' with packageId '{2}'"),
        File_is_included_via_type_library_reference_here: diag(1404, 3 /* Message */ , "File_is_included_via_type_library_reference_here_1404", "File is included via type library reference here."),
        Library_referenced_via_0_from_file_1: diag(1405, 3 /* Message */ , "Library_referenced_via_0_from_file_1_1405", "Library referenced via '{0}' from file '{1}'"),
        File_is_included_via_library_reference_here: diag(1406, 3 /* Message */ , "File_is_included_via_library_reference_here_1406", "File is included via library reference here."),
        Matched_by_include_pattern_0_in_1: diag(1407, 3 /* Message */ , "Matched_by_include_pattern_0_in_1_1407", "Matched by include pattern '{0}' in '{1}'"),
        File_is_matched_by_include_pattern_specified_here: diag(1408, 3 /* Message */ , "File_is_matched_by_include_pattern_specified_here_1408", "File is matched by include pattern specified here."),
        Part_of_files_list_in_tsconfig_json: diag(1409, 3 /* Message */ , "Part_of_files_list_in_tsconfig_json_1409", "Part of 'files' list in tsconfig.json"),
        File_is_matched_by_files_list_specified_here: diag(1410, 3 /* Message */ , "File_is_matched_by_files_list_specified_here_1410", "File is matched by 'files' list specified here."),
        Output_from_referenced_project_0_included_because_1_specified: diag(1411, 3 /* Message */ , "Output_from_referenced_project_0_included_because_1_specified_1411", "Output from referenced project '{0}' included because '{1}' specified"),
        Output_from_referenced_project_0_included_because_module_is_specified_as_none: diag(1412, 3 /* Message */ , "Output_from_referenced_project_0_included_because_module_is_specified_as_none_1412", "Output from referenced project '{0}' included because '--module' is specified as 'none'"),
        File_is_output_from_referenced_project_specified_here: diag(1413, 3 /* Message */ , "File_is_output_from_referenced_project_specified_here_1413", "File is output from referenced project specified here."),
        Source_from_referenced_project_0_included_because_1_specified: diag(1414, 3 /* Message */ , "Source_from_referenced_project_0_included_because_1_specified_1414", "Source from referenced project '{0}' included because '{1}' specified"),
        Source_from_referenced_project_0_included_because_module_is_specified_as_none: diag(1415, 3 /* Message */ , "Source_from_referenced_project_0_included_because_module_is_specified_as_none_1415", "Source from referenced project '{0}' included because '--module' is specified as 'none'"),
        File_is_source_from_referenced_project_specified_here: diag(1416, 3 /* Message */ , "File_is_source_from_referenced_project_specified_here_1416", "File is source from referenced project specified here."),
        Entry_point_of_type_library_0_specified_in_compilerOptions: diag(1417, 3 /* Message */ , "Entry_point_of_type_library_0_specified_in_compilerOptions_1417", "Entry point of type library '{0}' specified in compilerOptions"),
        Entry_point_of_type_library_0_specified_in_compilerOptions_with_packageId_1: diag(1418, 3 /* Message */ , "Entry_point_of_type_library_0_specified_in_compilerOptions_with_packageId_1_1418", "Entry point of type library '{0}' specified in compilerOptions with packageId '{1}'"),
        File_is_entry_point_of_type_library_specified_here: diag(1419, 3 /* Message */ , "File_is_entry_point_of_type_library_specified_here_1419", "File is entry point of type library specified here."),
        Entry_point_for_implicit_type_library_0: diag(1420, 3 /* Message */ , "Entry_point_for_implicit_type_library_0_1420", "Entry point for implicit type library '{0}'"),
        Entry_point_for_implicit_type_library_0_with_packageId_1: diag(1421, 3 /* Message */ , "Entry_point_for_implicit_type_library_0_with_packageId_1_1421", "Entry point for implicit type library '{0}' with packageId '{1}'"),
        Library_0_specified_in_compilerOptions: diag(1422, 3 /* Message */ , "Library_0_specified_in_compilerOptions_1422", "Library '{0}' specified in compilerOptions"),
        File_is_library_specified_here: diag(1423, 3 /* Message */ , "File_is_library_specified_here_1423", "File is library specified here."),
        Default_library: diag(1424, 3 /* Message */ , "Default_library_1424", "Default library"),
        Default_library_for_target_0: diag(1425, 3 /* Message */ , "Default_library_for_target_0_1425", "Default library for target '{0}'"),
        File_is_default_library_for_target_specified_here: diag(1426, 3 /* Message */ , "File_is_default_library_for_target_specified_here_1426", "File is default library for target specified here."),
        Root_file_specified_for_compilation: diag(1427, 3 /* Message */ , "Root_file_specified_for_compilation_1427", "Root file specified for compilation"),
        File_is_output_of_project_reference_source_0: diag(1428, 3 /* Message */ , "File_is_output_of_project_reference_source_0_1428", "File is output of project reference source '{0}'"),
        File_redirects_to_file_0: diag(1429, 3 /* Message */ , "File_redirects_to_file_0_1429", "File redirects to file '{0}'"),
        The_file_is_in_the_program_because_Colon: diag(1430, 3 /* Message */ , "The_file_is_in_the_program_because_Colon_1430", "The file is in the program because:"),
        for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module: diag(1431, 1 /* Error */ , "for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_1431", "'for await' loops are only allowed at the top level of a file when that file is a module, but this file has no imports or exports. Consider adding an empty 'export {}' to make this file a module."),
        Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher: diag(1432, 1 /* Error */ , "Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_nod_1432", "Top-level 'for await' loops are only allowed when the 'module' option is set to 'es2022', 'esnext', 'system', 'node16', 'node18', 'node20', 'nodenext', or 'preserve', and the 'target' option is set to 'es2017' or higher."),
        Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters: diag(1433, 1 /* Error */ , "Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters_1433", "Neither decorators nor modifiers may be applied to 'this' parameters."),
        Unexpected_keyword_or_identifier: diag(1434, 1 /* Error */ , "Unexpected_keyword_or_identifier_1434", "Unexpected keyword or identifier."),
        Unknown_keyword_or_identifier_Did_you_mean_0: diag(1435, 1 /* Error */ , "Unknown_keyword_or_identifier_Did_you_mean_0_1435", "Unknown keyword or identifier. Did you mean '{0}'?"),
        Decorators_must_precede_the_name_and_all_keywords_of_property_declarations: diag(1436, 1 /* Error */ , "Decorators_must_precede_the_name_and_all_keywords_of_property_declarations_1436", "Decorators must precede the name and all keywords of property declarations."),
        Namespace_must_be_given_a_name: diag(1437, 1 /* Error */ , "Namespace_must_be_given_a_name_1437", "Namespace must be given a name."),
        Interface_must_be_given_a_name: diag(1438, 1 /* Error */ , "Interface_must_be_given_a_name_1438", "Interface must be given a name."),
        Type_alias_must_be_given_a_name: diag(1439, 1 /* Error */ , "Type_alias_must_be_given_a_name_1439", "Type alias must be given a name."),
        Variable_declaration_not_allowed_at_this_location: diag(1440, 1 /* Error */ , "Variable_declaration_not_allowed_at_this_location_1440", "Variable declaration not allowed at this location."),
        Cannot_start_a_function_call_in_a_type_annotation: diag(1441, 1 /* Error */ , "Cannot_start_a_function_call_in_a_type_annotation_1441", "Cannot start a function call in a type annotation."),
        Expected_for_property_initializer: diag(1442, 1 /* Error */ , "Expected_for_property_initializer_1442", "Expected '=' for property initializer."),
        Module_declaration_names_may_only_use_or_quoted_strings: diag(1443, 1 /* Error */ , "Module_declaration_names_may_only_use_or_quoted_strings_1443", `Module declaration names may only use ' or " quoted strings.`),
        _0_resolves_to_a_type_only_declaration_and_must_be_re_exported_using_a_type_only_re_export_when_1_is_enabled: diag(1448, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_re_exported_using_a_type_only_re_export_when_1_is_1448", "'{0}' resolves to a type-only declaration and must be re-exported using a type-only re-export when '{1}' is enabled."),
        Preserve_unused_imported_values_in_the_JavaScript_output_that_would_otherwise_be_removed: diag(1449, 3 /* Message */ , "Preserve_unused_imported_values_in_the_JavaScript_output_that_would_otherwise_be_removed_1449", "Preserve unused imported values in the JavaScript output that would otherwise be removed."),
        Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_set_of_attributes_as_arguments: diag(1450, 3 /* Message */ , "Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_set_of_attributes_as_arguments_1450", "Dynamic imports can only accept a module specifier and an optional set of attributes as arguments"),
        Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression: diag(1451, 1 /* Error */ , "Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member__1451", "Private identifiers are only allowed in class bodies and may only be used as part of a class member declaration, property access, or on the left-hand-side of an 'in' expression"),
        resolution_mode_should_be_either_require_or_import: diag(1453, 1 /* Error */ , "resolution_mode_should_be_either_require_or_import_1453", "`resolution-mode` should be either `require` or `import`."),
        resolution_mode_can_only_be_set_for_type_only_imports: diag(1454, 1 /* Error */ , "resolution_mode_can_only_be_set_for_type_only_imports_1454", "`resolution-mode` can only be set for type-only imports."),
        resolution_mode_is_the_only_valid_key_for_type_import_assertions: diag(1455, 1 /* Error */ , "resolution_mode_is_the_only_valid_key_for_type_import_assertions_1455", "`resolution-mode` is the only valid key for type import assertions."),
        Type_import_assertions_should_have_exactly_one_key_resolution_mode_with_value_import_or_require: diag(1456, 1 /* Error */ , "Type_import_assertions_should_have_exactly_one_key_resolution_mode_with_value_import_or_require_1456", "Type import assertions should have exactly one key - `resolution-mode` - with value `import` or `require`."),
        Matched_by_default_include_pattern_Asterisk_Asterisk_Slash_Asterisk: diag(1457, 3 /* Message */ , "Matched_by_default_include_pattern_Asterisk_Asterisk_Slash_Asterisk_1457", "Matched by default include pattern '**/*'"),
        File_is_ECMAScript_module_because_0_has_field_type_with_value_module: diag(1458, 3 /* Message */ , "File_is_ECMAScript_module_because_0_has_field_type_with_value_module_1458", `File is ECMAScript module because '{0}' has field "type" with value "module"`),
        File_is_CommonJS_module_because_0_has_field_type_whose_value_is_not_module: diag(1459, 3 /* Message */ , "File_is_CommonJS_module_because_0_has_field_type_whose_value_is_not_module_1459", `File is CommonJS module because '{0}' has field "type" whose value is not "module"`),
        File_is_CommonJS_module_because_0_does_not_have_field_type: diag(1460, 3 /* Message */ , "File_is_CommonJS_module_because_0_does_not_have_field_type_1460", `File is CommonJS module because '{0}' does not have field "type"`),
        File_is_CommonJS_module_because_package_json_was_not_found: diag(1461, 3 /* Message */ , "File_is_CommonJS_module_because_package_json_was_not_found_1461", "File is CommonJS module because 'package.json' was not found"),
        resolution_mode_is_the_only_valid_key_for_type_import_attributes: diag(1463, 1 /* Error */ , "resolution_mode_is_the_only_valid_key_for_type_import_attributes_1463", "'resolution-mode' is the only valid key for type import attributes."),
        Type_import_attributes_should_have_exactly_one_key_resolution_mode_with_value_import_or_require: diag(1464, 1 /* Error */ , "Type_import_attributes_should_have_exactly_one_key_resolution_mode_with_value_import_or_require_1464", "Type import attributes should have exactly one key - 'resolution-mode' - with value 'import' or 'require'."),
        The_import_meta_meta_property_is_not_allowed_in_files_which_will_build_into_CommonJS_output: diag(1470, 1 /* Error */ , "The_import_meta_meta_property_is_not_allowed_in_files_which_will_build_into_CommonJS_output_1470", "The 'import.meta' meta-property is not allowed in files which will build into CommonJS output."),
        Module_0_cannot_be_imported_using_this_construct_The_specifier_only_resolves_to_an_ES_module_which_cannot_be_imported_with_require_Use_an_ECMAScript_import_instead: diag(1471, 1 /* Error */ , "Module_0_cannot_be_imported_using_this_construct_The_specifier_only_resolves_to_an_ES_module_which_c_1471", "Module '{0}' cannot be imported using this construct. The specifier only resolves to an ES module, which cannot be imported with 'require'. Use an ECMAScript import instead."),
        catch_or_finally_expected: diag(1472, 1 /* Error */ , "catch_or_finally_expected_1472", "'catch' or 'finally' expected."),
        An_import_declaration_can_only_be_used_at_the_top_level_of_a_module: diag(1473, 1 /* Error */ , "An_import_declaration_can_only_be_used_at_the_top_level_of_a_module_1473", "An import declaration can only be used at the top level of a module."),
        An_export_declaration_can_only_be_used_at_the_top_level_of_a_module: diag(1474, 1 /* Error */ , "An_export_declaration_can_only_be_used_at_the_top_level_of_a_module_1474", "An export declaration can only be used at the top level of a module."),
        Control_what_method_is_used_to_detect_module_format_JS_files: diag(1475, 3 /* Message */ , "Control_what_method_is_used_to_detect_module_format_JS_files_1475", "Control what method is used to detect module-format JS files."),
        auto_Colon_Treat_files_with_imports_exports_import_meta_jsx_with_jsx_Colon_react_jsx_or_esm_format_with_module_Colon_node16_as_modules: diag(1476, 3 /* Message */ , "auto_Colon_Treat_files_with_imports_exports_import_meta_jsx_with_jsx_Colon_react_jsx_or_esm_format_w_1476", '"auto": Treat files with imports, exports, import.meta, jsx (with jsx: react-jsx), or esm format (with module: node16+) as modules.'),
        An_instantiation_expression_cannot_be_followed_by_a_property_access: diag(1477, 1 /* Error */ , "An_instantiation_expression_cannot_be_followed_by_a_property_access_1477", "An instantiation expression cannot be followed by a property access."),
        Identifier_or_string_literal_expected: diag(1478, 1 /* Error */ , "Identifier_or_string_literal_expected_1478", "Identifier or string literal expected."),
        The_current_file_is_a_CommonJS_module_whose_imports_will_produce_require_calls_however_the_referenced_file_is_an_ECMAScript_module_and_cannot_be_imported_with_require_Consider_writing_a_dynamic_import_0_call_instead: diag(1479, 1 /* Error */ , "The_current_file_is_a_CommonJS_module_whose_imports_will_produce_require_calls_however_the_reference_1479", `The current file is a CommonJS module whose imports will produce 'require' calls; however, the referenced file is an ECMAScript module and cannot be imported with 'require'. Consider writing a dynamic 'import("{0}")' call instead.`),
        To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_create_a_local_package_json_file_with_type_Colon_module: diag(1480, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_create_a_local_packag_1480", 'To convert this file to an ECMAScript module, change its file extension to \'{0}\' or create a local package.json file with `{ "type": "module" }`.'),
        To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_add_the_field_type_Colon_module_to_1: diag(1481, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_add_the_field_type_Co_1481", `To convert this file to an ECMAScript module, change its file extension to '{0}', or add the field \`"type": "module"\` to '{1}'.`),
        To_convert_this_file_to_an_ECMAScript_module_add_the_field_type_Colon_module_to_0: diag(1482, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_add_the_field_type_Colon_module_to_0_1482", 'To convert this file to an ECMAScript module, add the field `"type": "module"` to \'{0}\'.'),
        To_convert_this_file_to_an_ECMAScript_module_create_a_local_package_json_file_with_type_Colon_module: diag(1483, 3 /* Message */ , "To_convert_this_file_to_an_ECMAScript_module_create_a_local_package_json_file_with_type_Colon_module_1483", 'To convert this file to an ECMAScript module, create a local package.json file with `{ "type": "module" }`.'),
        _0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled: diag(1484, 1 /* Error */ , "_0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled_1484", "'{0}' is a type and must be imported using a type-only import when 'verbatimModuleSyntax' is enabled."),
        _0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled: diag(1485, 1 /* Error */ , "_0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimMo_1485", "'{0}' resolves to a type-only declaration and must be imported using a type-only import when 'verbatimModuleSyntax' is enabled."),
        Decorator_used_before_export_here: diag(1486, 1 /* Error */ , "Decorator_used_before_export_here_1486", "Decorator used before 'export' here."),
        Octal_escape_sequences_are_not_allowed_Use_the_syntax_0: diag(1487, 1 /* Error */ , "Octal_escape_sequences_are_not_allowed_Use_the_syntax_0_1487", "Octal escape sequences are not allowed. Use the syntax '{0}'."),
        Escape_sequence_0_is_not_allowed: diag(1488, 1 /* Error */ , "Escape_sequence_0_is_not_allowed_1488", "Escape sequence '{0}' is not allowed."),
        Decimals_with_leading_zeros_are_not_allowed: diag(1489, 1 /* Error */ , "Decimals_with_leading_zeros_are_not_allowed_1489", "Decimals with leading zeros are not allowed."),
        File_appears_to_be_binary: diag(1490, 1 /* Error */ , "File_appears_to_be_binary_1490", "File appears to be binary."),
        _0_modifier_cannot_appear_on_a_using_declaration: diag(1491, 1 /* Error */ , "_0_modifier_cannot_appear_on_a_using_declaration_1491", "'{0}' modifier cannot appear on a 'using' declaration."),
        _0_declarations_may_not_have_binding_patterns: diag(1492, 1 /* Error */ , "_0_declarations_may_not_have_binding_patterns_1492", "'{0}' declarations may not have binding patterns."),
        The_left_hand_side_of_a_for_in_statement_cannot_be_a_using_declaration: diag(1493, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_cannot_be_a_using_declaration_1493", "The left-hand side of a 'for...in' statement cannot be a 'using' declaration."),
        The_left_hand_side_of_a_for_in_statement_cannot_be_an_await_using_declaration: diag(1494, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_cannot_be_an_await_using_declaration_1494", "The left-hand side of a 'for...in' statement cannot be an 'await using' declaration."),
        _0_modifier_cannot_appear_on_an_await_using_declaration: diag(1495, 1 /* Error */ , "_0_modifier_cannot_appear_on_an_await_using_declaration_1495", "'{0}' modifier cannot appear on an 'await using' declaration."),
        Identifier_string_literal_or_number_literal_expected: diag(1496, 1 /* Error */ , "Identifier_string_literal_or_number_literal_expected_1496", "Identifier, string literal, or number literal expected."),
        Expression_must_be_enclosed_in_parentheses_to_be_used_as_a_decorator: diag(1497, 1 /* Error */ , "Expression_must_be_enclosed_in_parentheses_to_be_used_as_a_decorator_1497", "Expression must be enclosed in parentheses to be used as a decorator."),
        Invalid_syntax_in_decorator: diag(1498, 1 /* Error */ , "Invalid_syntax_in_decorator_1498", "Invalid syntax in decorator."),
        Unknown_regular_expression_flag: diag(1499, 1 /* Error */ , "Unknown_regular_expression_flag_1499", "Unknown regular expression flag."),
        Duplicate_regular_expression_flag: diag(1500, 1 /* Error */ , "Duplicate_regular_expression_flag_1500", "Duplicate regular expression flag."),
        This_regular_expression_flag_is_only_available_when_targeting_0_or_later: diag(1501, 1 /* Error */ , "This_regular_expression_flag_is_only_available_when_targeting_0_or_later_1501", "This regular expression flag is only available when targeting '{0}' or later."),
        The_Unicode_u_flag_and_the_Unicode_Sets_v_flag_cannot_be_set_simultaneously: diag(1502, 1 /* Error */ , "The_Unicode_u_flag_and_the_Unicode_Sets_v_flag_cannot_be_set_simultaneously_1502", "The Unicode (u) flag and the Unicode Sets (v) flag cannot be set simultaneously."),
        Named_capturing_groups_are_only_available_when_targeting_ES2018_or_later: diag(1503, 1 /* Error */ , "Named_capturing_groups_are_only_available_when_targeting_ES2018_or_later_1503", "Named capturing groups are only available when targeting 'ES2018' or later."),
        Subpattern_flags_must_be_present_when_there_is_a_minus_sign: diag(1504, 1 /* Error */ , "Subpattern_flags_must_be_present_when_there_is_a_minus_sign_1504", "Subpattern flags must be present when there is a minus sign."),
        Incomplete_quantifier_Digit_expected: diag(1505, 1 /* Error */ , "Incomplete_quantifier_Digit_expected_1505", "Incomplete quantifier. Digit expected."),
        Numbers_out_of_order_in_quantifier: diag(1506, 1 /* Error */ , "Numbers_out_of_order_in_quantifier_1506", "Numbers out of order in quantifier."),
        There_is_nothing_available_for_repetition: diag(1507, 1 /* Error */ , "There_is_nothing_available_for_repetition_1507", "There is nothing available for repetition."),
        Unexpected_0_Did_you_mean_to_escape_it_with_backslash: diag(1508, 1 /* Error */ , "Unexpected_0_Did_you_mean_to_escape_it_with_backslash_1508", "Unexpected '{0}'. Did you mean to escape it with backslash?"),
        This_regular_expression_flag_cannot_be_toggled_within_a_subpattern: diag(1509, 1 /* Error */ , "This_regular_expression_flag_cannot_be_toggled_within_a_subpattern_1509", "This regular expression flag cannot be toggled within a subpattern."),
        k_must_be_followed_by_a_capturing_group_name_enclosed_in_angle_brackets: diag(1510, 1 /* Error */ , "k_must_be_followed_by_a_capturing_group_name_enclosed_in_angle_brackets_1510", "'\\k' must be followed by a capturing group name enclosed in angle brackets."),
        q_is_only_available_inside_character_class: diag(1511, 1 /* Error */ , "q_is_only_available_inside_character_class_1511", "'\\q' is only available inside character class."),
        c_must_be_followed_by_an_ASCII_letter: diag(1512, 1 /* Error */ , "c_must_be_followed_by_an_ASCII_letter_1512", "'\\c' must be followed by an ASCII letter."),
        Undetermined_character_escape: diag(1513, 1 /* Error */ , "Undetermined_character_escape_1513", "Undetermined character escape."),
        Expected_a_capturing_group_name: diag(1514, 1 /* Error */ , "Expected_a_capturing_group_name_1514", "Expected a capturing group name."),
        Named_capturing_groups_with_the_same_name_must_be_mutually_exclusive_to_each_other: diag(1515, 1 /* Error */ , "Named_capturing_groups_with_the_same_name_must_be_mutually_exclusive_to_each_other_1515", "Named capturing groups with the same name must be mutually exclusive to each other."),
        A_character_class_range_must_not_be_bounded_by_another_character_class: diag(1516, 1 /* Error */ , "A_character_class_range_must_not_be_bounded_by_another_character_class_1516", "A character class range must not be bounded by another character class."),
        Range_out_of_order_in_character_class: diag(1517, 1 /* Error */ , "Range_out_of_order_in_character_class_1517", "Range out of order in character class."),
        Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_character_class: diag(1518, 1 /* Error */ , "Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_characte_1518", "Anything that would possibly match more than a single character is invalid inside a negated character class."),
        Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead: diag(1519, 1 /* Error */ , "Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead_1519", "Operators must not be mixed within a character class. Wrap it in a nested class instead."),
        Expected_a_class_set_operand: diag(1520, 1 /* Error */ , "Expected_a_class_set_operand_1520", "Expected a class set operand."),
        q_must_be_followed_by_string_alternatives_enclosed_in_braces: diag(1521, 1 /* Error */ , "q_must_be_followed_by_string_alternatives_enclosed_in_braces_1521", "'\\q' must be followed by string alternatives enclosed in braces."),
        A_character_class_must_not_contain_a_reserved_double_punctuator_Did_you_mean_to_escape_it_with_backslash: diag(1522, 1 /* Error */ , "A_character_class_must_not_contain_a_reserved_double_punctuator_Did_you_mean_to_escape_it_with_backs_1522", "A character class must not contain a reserved double punctuator. Did you mean to escape it with backslash?"),
        Expected_a_Unicode_property_name: diag(1523, 1 /* Error */ , "Expected_a_Unicode_property_name_1523", "Expected a Unicode property name."),
        Unknown_Unicode_property_name: diag(1524, 1 /* Error */ , "Unknown_Unicode_property_name_1524", "Unknown Unicode property name."),
        Expected_a_Unicode_property_value: diag(1525, 1 /* Error */ , "Expected_a_Unicode_property_value_1525", "Expected a Unicode property value."),
        Unknown_Unicode_property_value: diag(1526, 1 /* Error */ , "Unknown_Unicode_property_value_1526", "Unknown Unicode property value."),
        Expected_a_Unicode_property_name_or_value: diag(1527, 1 /* Error */ , "Expected_a_Unicode_property_name_or_value_1527", "Expected a Unicode property name or value."),
        Any_Unicode_property_that_would_possibly_match_more_than_a_single_character_is_only_available_when_the_Unicode_Sets_v_flag_is_set: diag(1528, 1 /* Error */ , "Any_Unicode_property_that_would_possibly_match_more_than_a_single_character_is_only_available_when_t_1528", "Any Unicode property that would possibly match more than a single character is only available when the Unicode Sets (v) flag is set."),
        Unknown_Unicode_property_name_or_value: diag(1529, 1 /* Error */ , "Unknown_Unicode_property_name_or_value_1529", "Unknown Unicode property name or value."),
        Unicode_property_value_expressions_are_only_available_when_the_Unicode_u_flag_or_the_Unicode_Sets_v_flag_is_set: diag(1530, 1 /* Error */ , "Unicode_property_value_expressions_are_only_available_when_the_Unicode_u_flag_or_the_Unicode_Sets_v__1530", "Unicode property value expressions are only available when the Unicode (u) flag or the Unicode Sets (v) flag is set."),
        _0_must_be_followed_by_a_Unicode_property_value_expression_enclosed_in_braces: diag(1531, 1 /* Error */ , "_0_must_be_followed_by_a_Unicode_property_value_expression_enclosed_in_braces_1531", "'\\{0}' must be followed by a Unicode property value expression enclosed in braces."),
        There_is_no_capturing_group_named_0_in_this_regular_expression: diag(1532, 1 /* Error */ , "There_is_no_capturing_group_named_0_in_this_regular_expression_1532", "There is no capturing group named '{0}' in this regular expression."),
        This_backreference_refers_to_a_group_that_does_not_exist_There_are_only_0_capturing_groups_in_this_regular_expression: diag(1533, 1 /* Error */ , "This_backreference_refers_to_a_group_that_does_not_exist_There_are_only_0_capturing_groups_in_this_r_1533", "This backreference refers to a group that does not exist. There are only {0} capturing groups in this regular expression."),
        This_backreference_refers_to_a_group_that_does_not_exist_There_are_no_capturing_groups_in_this_regular_expression: diag(1534, 1 /* Error */ , "This_backreference_refers_to_a_group_that_does_not_exist_There_are_no_capturing_groups_in_this_regul_1534", "This backreference refers to a group that does not exist. There are no capturing groups in this regular expression."),
        This_character_cannot_be_escaped_in_a_regular_expression: diag(1535, 1 /* Error */ , "This_character_cannot_be_escaped_in_a_regular_expression_1535", "This character cannot be escaped in a regular expression."),
        Octal_escape_sequences_and_backreferences_are_not_allowed_in_a_character_class_If_this_was_intended_as_an_escape_sequence_use_the_syntax_0_instead: diag(1536, 1 /* Error */ , "Octal_escape_sequences_and_backreferences_are_not_allowed_in_a_character_class_If_this_was_intended__1536", "Octal escape sequences and backreferences are not allowed in a character class. If this was intended as an escape sequence, use the syntax '{0}' instead."),
        Decimal_escape_sequences_and_backreferences_are_not_allowed_in_a_character_class: diag(1537, 1 /* Error */ , "Decimal_escape_sequences_and_backreferences_are_not_allowed_in_a_character_class_1537", "Decimal escape sequences and backreferences are not allowed in a character class."),
        Unicode_escape_sequences_are_only_available_when_the_Unicode_u_flag_or_the_Unicode_Sets_v_flag_is_set: diag(1538, 1 /* Error */ , "Unicode_escape_sequences_are_only_available_when_the_Unicode_u_flag_or_the_Unicode_Sets_v_flag_is_se_1538", "Unicode escape sequences are only available when the Unicode (u) flag or the Unicode Sets (v) flag is set."),
        A_bigint_literal_cannot_be_used_as_a_property_name: diag(1539, 1 /* Error */ , "A_bigint_literal_cannot_be_used_as_a_property_name_1539", "A 'bigint' literal cannot be used as a property name."),
        A_namespace_declaration_should_not_be_declared_using_the_module_keyword_Please_use_the_namespace_keyword_instead: diag(1540, 2 /* Suggestion */ , "A_namespace_declaration_should_not_be_declared_using_the_module_keyword_Please_use_the_namespace_key_1540", "A 'namespace' declaration should not be declared using the 'module' keyword. Please use the 'namespace' keyword instead.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ void 0, /*reportsDeprecated*/ true),
        Type_only_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute: diag(1541, 1 /* Error */ , "Type_only_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribut_1541", "Type-only import of an ECMAScript module from a CommonJS module must have a 'resolution-mode' attribute."),
        Type_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute: diag(1542, 1 /* Error */ , "Type_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute_1542", "Type import of an ECMAScript module from a CommonJS module must have a 'resolution-mode' attribute."),
        Importing_a_JSON_file_into_an_ECMAScript_module_requires_a_type_Colon_json_import_attribute_when_module_is_set_to_0: diag(1543, 1 /* Error */ , "Importing_a_JSON_file_into_an_ECMAScript_module_requires_a_type_Colon_json_import_attribute_when_mod_1543", `Importing a JSON file into an ECMAScript module requires a 'type: "json"' import attribute when 'module' is set to '{0}'.`),
        Named_imports_from_a_JSON_file_into_an_ECMAScript_module_are_not_allowed_when_module_is_set_to_0: diag(1544, 1 /* Error */ , "Named_imports_from_a_JSON_file_into_an_ECMAScript_module_are_not_allowed_when_module_is_set_to_0_1544", "Named imports from a JSON file into an ECMAScript module are not allowed when 'module' is set to '{0}'."),
        using_declarations_are_not_allowed_in_ambient_contexts: diag(1545, 1 /* Error */ , "using_declarations_are_not_allowed_in_ambient_contexts_1545", "'using' declarations are not allowed in ambient contexts."),
        await_using_declarations_are_not_allowed_in_ambient_contexts: diag(1546, 1 /* Error */ , "await_using_declarations_are_not_allowed_in_ambient_contexts_1546", "'await using' declarations are not allowed in ambient contexts."),
        The_types_of_0_are_incompatible_between_these_types: diag(2200, 1 /* Error */ , "The_types_of_0_are_incompatible_between_these_types_2200", "The types of '{0}' are incompatible between these types."),
        The_types_returned_by_0_are_incompatible_between_these_types: diag(2201, 1 /* Error */ , "The_types_returned_by_0_are_incompatible_between_these_types_2201", "The types returned by '{0}' are incompatible between these types."),
        Call_signature_return_types_0_and_1_are_incompatible: diag(2202, 1 /* Error */ , "Call_signature_return_types_0_and_1_are_incompatible_2202", "Call signature return types '{0}' and '{1}' are incompatible.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
        Construct_signature_return_types_0_and_1_are_incompatible: diag(2203, 1 /* Error */ , "Construct_signature_return_types_0_and_1_are_incompatible_2203", "Construct signature return types '{0}' and '{1}' are incompatible.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
        Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1: diag(2204, 1 /* Error */ , "Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1_2204", "Call signatures with no arguments have incompatible return types '{0}' and '{1}'.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
        Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1: diag(2205, 1 /* Error */ , "Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1_2205", "Construct signatures with no arguments have incompatible return types '{0}' and '{1}'.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ true),
        The_type_modifier_cannot_be_used_on_a_named_import_when_import_type_is_used_on_its_import_statement: diag(2206, 1 /* Error */ , "The_type_modifier_cannot_be_used_on_a_named_import_when_import_type_is_used_on_its_import_statement_2206", "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement."),
        The_type_modifier_cannot_be_used_on_a_named_export_when_export_type_is_used_on_its_export_statement: diag(2207, 1 /* Error */ , "The_type_modifier_cannot_be_used_on_a_named_export_when_export_type_is_used_on_its_export_statement_2207", "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement."),
        This_type_parameter_might_need_an_extends_0_constraint: diag(2208, 1 /* Error */ , "This_type_parameter_might_need_an_extends_0_constraint_2208", "This type parameter might need an `extends {0}` constraint."),
        The_project_root_is_ambiguous_but_is_required_to_resolve_export_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate: diag(2209, 1 /* Error */ , "The_project_root_is_ambiguous_but_is_required_to_resolve_export_map_entry_0_in_file_1_Supply_the_roo_2209", "The project root is ambiguous, but is required to resolve export map entry '{0}' in file '{1}'. Supply the `rootDir` compiler option to disambiguate."),
        The_project_root_is_ambiguous_but_is_required_to_resolve_import_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate: diag(2210, 1 /* Error */ , "The_project_root_is_ambiguous_but_is_required_to_resolve_import_map_entry_0_in_file_1_Supply_the_roo_2210", "The project root is ambiguous, but is required to resolve import map entry '{0}' in file '{1}'. Supply the `rootDir` compiler option to disambiguate."),
        Add_extends_constraint: diag(2211, 3 /* Message */ , "Add_extends_constraint_2211", "Add `extends` constraint."),
        Add_extends_constraint_to_all_type_parameters: diag(2212, 3 /* Message */ , "Add_extends_constraint_to_all_type_parameters_2212", "Add `extends` constraint to all type parameters"),
        Duplicate_identifier_0: diag(2300, 1 /* Error */ , "Duplicate_identifier_0_2300", "Duplicate identifier '{0}'."),
        Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor: diag(2301, 1 /* Error */ , "Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor_2301", "Initializer of instance member variable '{0}' cannot reference identifier '{1}' declared in the constructor."),
        Static_members_cannot_reference_class_type_parameters: diag(2302, 1 /* Error */ , "Static_members_cannot_reference_class_type_parameters_2302", "Static members cannot reference class type parameters."),
        Circular_definition_of_import_alias_0: diag(2303, 1 /* Error */ , "Circular_definition_of_import_alias_0_2303", "Circular definition of import alias '{0}'."),
        Cannot_find_name_0: diag(2304, 1 /* Error */ , "Cannot_find_name_0_2304", "Cannot find name '{0}'."),
        Module_0_has_no_exported_member_1: diag(2305, 1 /* Error */ , "Module_0_has_no_exported_member_1_2305", "Module '{0}' has no exported member '{1}'."),
        File_0_is_not_a_module: diag(2306, 1 /* Error */ , "File_0_is_not_a_module_2306", "File '{0}' is not a module."),
        Cannot_find_module_0_or_its_corresponding_type_declarations: diag(2307, 1 /* Error */ , "Cannot_find_module_0_or_its_corresponding_type_declarations_2307", "Cannot find module '{0}' or its corresponding type declarations."),
        Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity: diag(2308, 1 /* Error */ , "Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambig_2308", "Module {0} has already exported a member named '{1}'. Consider explicitly re-exporting to resolve the ambiguity."),
        An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements: diag(2309, 1 /* Error */ , "An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements_2309", "An export assignment cannot be used in a module with other exported elements."),
        Type_0_recursively_references_itself_as_a_base_type: diag(2310, 1 /* Error */ , "Type_0_recursively_references_itself_as_a_base_type_2310", "Type '{0}' recursively references itself as a base type."),
        Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function: diag(2311, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function_2311", "Cannot find name '{0}'. Did you mean to write this in an async function?"),
        An_interface_can_only_extend_an_object_type_or_intersection_of_object_types_with_statically_known_members: diag(2312, 1 /* Error */ , "An_interface_can_only_extend_an_object_type_or_intersection_of_object_types_with_statically_known_me_2312", "An interface can only extend an object type or intersection of object types with statically known members."),
        Type_parameter_0_has_a_circular_constraint: diag(2313, 1 /* Error */ , "Type_parameter_0_has_a_circular_constraint_2313", "Type parameter '{0}' has a circular constraint."),
        Generic_type_0_requires_1_type_argument_s: diag(2314, 1 /* Error */ , "Generic_type_0_requires_1_type_argument_s_2314", "Generic type '{0}' requires {1} type argument(s)."),
        Type_0_is_not_generic: diag(2315, 1 /* Error */ , "Type_0_is_not_generic_2315", "Type '{0}' is not generic."),
        Global_type_0_must_be_a_class_or_interface_type: diag(2316, 1 /* Error */ , "Global_type_0_must_be_a_class_or_interface_type_2316", "Global type '{0}' must be a class or interface type."),
        Global_type_0_must_have_1_type_parameter_s: diag(2317, 1 /* Error */ , "Global_type_0_must_have_1_type_parameter_s_2317", "Global type '{0}' must have {1} type parameter(s)."),
        Cannot_find_global_type_0: diag(2318, 1 /* Error */ , "Cannot_find_global_type_0_2318", "Cannot find global type '{0}'."),
        Named_property_0_of_types_1_and_2_are_not_identical: diag(2319, 1 /* Error */ , "Named_property_0_of_types_1_and_2_are_not_identical_2319", "Named property '{0}' of types '{1}' and '{2}' are not identical."),
        Interface_0_cannot_simultaneously_extend_types_1_and_2: diag(2320, 1 /* Error */ , "Interface_0_cannot_simultaneously_extend_types_1_and_2_2320", "Interface '{0}' cannot simultaneously extend types '{1}' and '{2}'."),
        Excessive_stack_depth_comparing_types_0_and_1: diag(2321, 1 /* Error */ , "Excessive_stack_depth_comparing_types_0_and_1_2321", "Excessive stack depth comparing types '{0}' and '{1}'."),
        Type_0_is_not_assignable_to_type_1: diag(2322, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_2322", "Type '{0}' is not assignable to type '{1}'."),
        Cannot_redeclare_exported_variable_0: diag(2323, 1 /* Error */ , "Cannot_redeclare_exported_variable_0_2323", "Cannot redeclare exported variable '{0}'."),
        Property_0_is_missing_in_type_1: diag(2324, 1 /* Error */ , "Property_0_is_missing_in_type_1_2324", "Property '{0}' is missing in type '{1}'."),
        Property_0_is_private_in_type_1_but_not_in_type_2: diag(2325, 1 /* Error */ , "Property_0_is_private_in_type_1_but_not_in_type_2_2325", "Property '{0}' is private in type '{1}' but not in type '{2}'."),
        Types_of_property_0_are_incompatible: diag(2326, 1 /* Error */ , "Types_of_property_0_are_incompatible_2326", "Types of property '{0}' are incompatible."),
        Property_0_is_optional_in_type_1_but_required_in_type_2: diag(2327, 1 /* Error */ , "Property_0_is_optional_in_type_1_but_required_in_type_2_2327", "Property '{0}' is optional in type '{1}' but required in type '{2}'."),
        Types_of_parameters_0_and_1_are_incompatible: diag(2328, 1 /* Error */ , "Types_of_parameters_0_and_1_are_incompatible_2328", "Types of parameters '{0}' and '{1}' are incompatible."),
        Index_signature_for_type_0_is_missing_in_type_1: diag(2329, 1 /* Error */ , "Index_signature_for_type_0_is_missing_in_type_1_2329", "Index signature for type '{0}' is missing in type '{1}'."),
        _0_and_1_index_signatures_are_incompatible: diag(2330, 1 /* Error */ , "_0_and_1_index_signatures_are_incompatible_2330", "'{0}' and '{1}' index signatures are incompatible."),
        this_cannot_be_referenced_in_a_module_or_namespace_body: diag(2331, 1 /* Error */ , "this_cannot_be_referenced_in_a_module_or_namespace_body_2331", "'this' cannot be referenced in a module or namespace body."),
        this_cannot_be_referenced_in_current_location: diag(2332, 1 /* Error */ , "this_cannot_be_referenced_in_current_location_2332", "'this' cannot be referenced in current location."),
        this_cannot_be_referenced_in_a_static_property_initializer: diag(2334, 1 /* Error */ , "this_cannot_be_referenced_in_a_static_property_initializer_2334", "'this' cannot be referenced in a static property initializer."),
        super_can_only_be_referenced_in_a_derived_class: diag(2335, 1 /* Error */ , "super_can_only_be_referenced_in_a_derived_class_2335", "'super' can only be referenced in a derived class."),
        super_cannot_be_referenced_in_constructor_arguments: diag(2336, 1 /* Error */ , "super_cannot_be_referenced_in_constructor_arguments_2336", "'super' cannot be referenced in constructor arguments."),
        Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors: diag(2337, 1 /* Error */ , "Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors_2337", "Super calls are not permitted outside constructors or in nested functions inside constructors."),
        super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class: diag(2338, 1 /* Error */ , "super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_der_2338", "'super' property access is permitted only in a constructor, member function, or member accessor of a derived class."),
        Property_0_does_not_exist_on_type_1: diag(2339, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_2339", "Property '{0}' does not exist on type '{1}'."),
        Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword: diag(2340, 1 /* Error */ , "Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword_2340", "Only public and protected methods of the base class are accessible via the 'super' keyword."),
        Property_0_is_private_and_only_accessible_within_class_1: diag(2341, 1 /* Error */ , "Property_0_is_private_and_only_accessible_within_class_1_2341", "Property '{0}' is private and only accessible within class '{1}'."),
        This_syntax_requires_an_imported_helper_named_1_which_does_not_exist_in_0_Consider_upgrading_your_version_of_0: diag(2343, 1 /* Error */ , "This_syntax_requires_an_imported_helper_named_1_which_does_not_exist_in_0_Consider_upgrading_your_ve_2343", "This syntax requires an imported helper named '{1}' which does not exist in '{0}'. Consider upgrading your version of '{0}'."),
        Type_0_does_not_satisfy_the_constraint_1: diag(2344, 1 /* Error */ , "Type_0_does_not_satisfy_the_constraint_1_2344", "Type '{0}' does not satisfy the constraint '{1}'."),
        Argument_of_type_0_is_not_assignable_to_parameter_of_type_1: diag(2345, 1 /* Error */ , "Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_2345", "Argument of type '{0}' is not assignable to parameter of type '{1}'."),
        Call_target_does_not_contain_any_signatures: diag(2346, 1 /* Error */ , "Call_target_does_not_contain_any_signatures_2346", "Call target does not contain any signatures."),
        Untyped_function_calls_may_not_accept_type_arguments: diag(2347, 1 /* Error */ , "Untyped_function_calls_may_not_accept_type_arguments_2347", "Untyped function calls may not accept type arguments."),
        Value_of_type_0_is_not_callable_Did_you_mean_to_include_new: diag(2348, 1 /* Error */ , "Value_of_type_0_is_not_callable_Did_you_mean_to_include_new_2348", "Value of type '{0}' is not callable. Did you mean to include 'new'?"),
        This_expression_is_not_callable: diag(2349, 1 /* Error */ , "This_expression_is_not_callable_2349", "This expression is not callable."),
        Only_a_void_function_can_be_called_with_the_new_keyword: diag(2350, 1 /* Error */ , "Only_a_void_function_can_be_called_with_the_new_keyword_2350", "Only a void function can be called with the 'new' keyword."),
        This_expression_is_not_constructable: diag(2351, 1 /* Error */ , "This_expression_is_not_constructable_2351", "This expression is not constructable."),
        Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the_other_If_this_was_intentional_convert_the_expression_to_unknown_first: diag(2352, 1 /* Error */ , "Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the__2352", "Conversion of type '{0}' to type '{1}' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first."),
        Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1: diag(2353, 1 /* Error */ , "Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1_2353", "Object literal may only specify known properties, and '{0}' does not exist in type '{1}'."),
        This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found: diag(2354, 1 /* Error */ , "This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found_2354", "This syntax requires an imported helper but module '{0}' cannot be found."),
        A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value: diag(2355, 1 /* Error */ , "A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value_2355", "A function whose declared type is neither 'undefined', 'void', nor 'any' must return a value."),
        An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type: diag(2356, 1 /* Error */ , "An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type_2356", "An arithmetic operand must be of type 'any', 'number', 'bigint' or an enum type."),
        The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access: diag(2357, 1 /* Error */ , "The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access_2357", "The operand of an increment or decrement operator must be a variable or a property access."),
        The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2358, 1 /* Error */ , "The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_paramete_2358", "The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter."),
        The_right_hand_side_of_an_instanceof_expression_must_be_either_of_type_any_a_class_function_or_other_type_assignable_to_the_Function_interface_type_or_an_object_type_with_a_Symbol_hasInstance_method: diag(2359, 1 /* Error */ , "The_right_hand_side_of_an_instanceof_expression_must_be_either_of_type_any_a_class_function_or_other_2359", "The right-hand side of an 'instanceof' expression must be either of type 'any', a class, function, or other type assignable to the 'Function' interface type, or an object type with a 'Symbol.hasInstance' method."),
        The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type: diag(2362, 1 /* Error */ , "The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type_2362", "The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type."),
        The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type: diag(2363, 1 /* Error */ , "The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type_2363", "The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type."),
        The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access: diag(2364, 1 /* Error */ , "The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access_2364", "The left-hand side of an assignment expression must be a variable or a property access."),
        Operator_0_cannot_be_applied_to_types_1_and_2: diag(2365, 1 /* Error */ , "Operator_0_cannot_be_applied_to_types_1_and_2_2365", "Operator '{0}' cannot be applied to types '{1}' and '{2}'."),
        Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined: diag(2366, 1 /* Error */ , "Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined_2366", "Function lacks ending return statement and return type does not include 'undefined'."),
        This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap: diag(2367, 1 /* Error */ , "This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap_2367", "This comparison appears to be unintentional because the types '{0}' and '{1}' have no overlap."),
        Type_parameter_name_cannot_be_0: diag(2368, 1 /* Error */ , "Type_parameter_name_cannot_be_0_2368", "Type parameter name cannot be '{0}'."),
        A_parameter_property_is_only_allowed_in_a_constructor_implementation: diag(2369, 1 /* Error */ , "A_parameter_property_is_only_allowed_in_a_constructor_implementation_2369", "A parameter property is only allowed in a constructor implementation."),
        A_rest_parameter_must_be_of_an_array_type: diag(2370, 1 /* Error */ , "A_rest_parameter_must_be_of_an_array_type_2370", "A rest parameter must be of an array type."),
        A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation: diag(2371, 1 /* Error */ , "A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation_2371", "A parameter initializer is only allowed in a function or constructor implementation."),
        Parameter_0_cannot_reference_itself: diag(2372, 1 /* Error */ , "Parameter_0_cannot_reference_itself_2372", "Parameter '{0}' cannot reference itself."),
        Parameter_0_cannot_reference_identifier_1_declared_after_it: diag(2373, 1 /* Error */ , "Parameter_0_cannot_reference_identifier_1_declared_after_it_2373", "Parameter '{0}' cannot reference identifier '{1}' declared after it."),
        Duplicate_index_signature_for_type_0: diag(2374, 1 /* Error */ , "Duplicate_index_signature_for_type_0_2374", "Duplicate index signature for type '{0}'."),
        Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties: diag(2375, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefi_2375", "Type '{0}' is not assignable to type '{1}' with 'exactOptionalPropertyTypes: true'. Consider adding 'undefined' to the types of the target's properties."),
        A_super_call_must_be_the_first_statement_in_the_constructor_to_refer_to_super_or_this_when_a_derived_class_contains_initialized_properties_parameter_properties_or_private_identifiers: diag(2376, 1 /* Error */ , "A_super_call_must_be_the_first_statement_in_the_constructor_to_refer_to_super_or_this_when_a_derived_2376", "A 'super' call must be the first statement in the constructor to refer to 'super' or 'this' when a derived class contains initialized properties, parameter properties, or private identifiers."),
        Constructors_for_derived_classes_must_contain_a_super_call: diag(2377, 1 /* Error */ , "Constructors_for_derived_classes_must_contain_a_super_call_2377", "Constructors for derived classes must contain a 'super' call."),
        A_get_accessor_must_return_a_value: diag(2378, 1 /* Error */ , "A_get_accessor_must_return_a_value_2378", "A 'get' accessor must return a value."),
        Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties: diag(2379, 1 /* Error */ , "Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_tr_2379", "Argument of type '{0}' is not assignable to parameter of type '{1}' with 'exactOptionalPropertyTypes: true'. Consider adding 'undefined' to the types of the target's properties."),
        Overload_signatures_must_all_be_exported_or_non_exported: diag(2383, 1 /* Error */ , "Overload_signatures_must_all_be_exported_or_non_exported_2383", "Overload signatures must all be exported or non-exported."),
        Overload_signatures_must_all_be_ambient_or_non_ambient: diag(2384, 1 /* Error */ , "Overload_signatures_must_all_be_ambient_or_non_ambient_2384", "Overload signatures must all be ambient or non-ambient."),
        Overload_signatures_must_all_be_public_private_or_protected: diag(2385, 1 /* Error */ , "Overload_signatures_must_all_be_public_private_or_protected_2385", "Overload signatures must all be public, private or protected."),
        Overload_signatures_must_all_be_optional_or_required: diag(2386, 1 /* Error */ , "Overload_signatures_must_all_be_optional_or_required_2386", "Overload signatures must all be optional or required."),
        Function_overload_must_be_static: diag(2387, 1 /* Error */ , "Function_overload_must_be_static_2387", "Function overload must be static."),
        Function_overload_must_not_be_static: diag(2388, 1 /* Error */ , "Function_overload_must_not_be_static_2388", "Function overload must not be static."),
        Function_implementation_name_must_be_0: diag(2389, 1 /* Error */ , "Function_implementation_name_must_be_0_2389", "Function implementation name must be '{0}'."),
        Constructor_implementation_is_missing: diag(2390, 1 /* Error */ , "Constructor_implementation_is_missing_2390", "Constructor implementation is missing."),
        Function_implementation_is_missing_or_not_immediately_following_the_declaration: diag(2391, 1 /* Error */ , "Function_implementation_is_missing_or_not_immediately_following_the_declaration_2391", "Function implementation is missing or not immediately following the declaration."),
        Multiple_constructor_implementations_are_not_allowed: diag(2392, 1 /* Error */ , "Multiple_constructor_implementations_are_not_allowed_2392", "Multiple constructor implementations are not allowed."),
        Duplicate_function_implementation: diag(2393, 1 /* Error */ , "Duplicate_function_implementation_2393", "Duplicate function implementation."),
        This_overload_signature_is_not_compatible_with_its_implementation_signature: diag(2394, 1 /* Error */ , "This_overload_signature_is_not_compatible_with_its_implementation_signature_2394", "This overload signature is not compatible with its implementation signature."),
        Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local: diag(2395, 1 /* Error */ , "Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local_2395", "Individual declarations in merged declaration '{0}' must be all exported or all local."),
        Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters: diag(2396, 1 /* Error */ , "Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters_2396", "Duplicate identifier 'arguments'. Compiler uses 'arguments' to initialize rest parameters."),
        Declaration_name_conflicts_with_built_in_global_identifier_0: diag(2397, 1 /* Error */ , "Declaration_name_conflicts_with_built_in_global_identifier_0_2397", "Declaration name conflicts with built-in global identifier '{0}'."),
        constructor_cannot_be_used_as_a_parameter_property_name: diag(2398, 1 /* Error */ , "constructor_cannot_be_used_as_a_parameter_property_name_2398", "'constructor' cannot be used as a parameter property name."),
        Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference: diag(2399, 1 /* Error */ , "Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference_2399", "Duplicate identifier '_this'. Compiler uses variable declaration '_this' to capture 'this' reference."),
        Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference: diag(2400, 1 /* Error */ , "Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference_2400", "Expression resolves to variable declaration '_this' that compiler uses to capture 'this' reference."),
        A_super_call_must_be_a_root_level_statement_within_a_constructor_of_a_derived_class_that_contains_initialized_properties_parameter_properties_or_private_identifiers: diag(2401, 1 /* Error */ , "A_super_call_must_be_a_root_level_statement_within_a_constructor_of_a_derived_class_that_contains_in_2401", "A 'super' call must be a root-level statement within a constructor of a derived class that contains initialized properties, parameter properties, or private identifiers."),
        Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference: diag(2402, 1 /* Error */ , "Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference_2402", "Expression resolves to '_super' that compiler uses to capture base class reference."),
        Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2: diag(2403, 1 /* Error */ , "Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_t_2403", "Subsequent variable declarations must have the same type.  Variable '{0}' must be of type '{1}', but here has type '{2}'."),
        The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation: diag(2404, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation_2404", "The left-hand side of a 'for...in' statement cannot use a type annotation."),
        The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any: diag(2405, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any_2405", "The left-hand side of a 'for...in' statement must be of type 'string' or 'any'."),
        The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access: diag(2406, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access_2406", "The left-hand side of a 'for...in' statement must be a variable or a property access."),
        The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_here_has_type_0: diag(2407, 1 /* Error */ , "The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_2407", "The right-hand side of a 'for...in' statement must be of type 'any', an object type or a type parameter, but here has type '{0}'."),
        Setters_cannot_return_a_value: diag(2408, 1 /* Error */ , "Setters_cannot_return_a_value_2408", "Setters cannot return a value."),
        Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class: diag(2409, 1 /* Error */ , "Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class_2409", "Return type of constructor signature must be assignable to the instance type of the class."),
        The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any: diag(2410, 1 /* Error */ , "The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any_2410", "The 'with' statement is not supported. All symbols in a 'with' block will have type 'any'."),
        Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target: diag(2412, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefi_2412", "Type '{0}' is not assignable to type '{1}' with 'exactOptionalPropertyTypes: true'. Consider adding 'undefined' to the type of the target."),
        Property_0_of_type_1_is_not_assignable_to_2_index_type_3: diag(2411, 1 /* Error */ , "Property_0_of_type_1_is_not_assignable_to_2_index_type_3_2411", "Property '{0}' of type '{1}' is not assignable to '{2}' index type '{3}'."),
        _0_index_type_1_is_not_assignable_to_2_index_type_3: diag(2413, 1 /* Error */ , "_0_index_type_1_is_not_assignable_to_2_index_type_3_2413", "'{0}' index type '{1}' is not assignable to '{2}' index type '{3}'."),
        Class_name_cannot_be_0: diag(2414, 1 /* Error */ , "Class_name_cannot_be_0_2414", "Class name cannot be '{0}'."),
        Class_0_incorrectly_extends_base_class_1: diag(2415, 1 /* Error */ , "Class_0_incorrectly_extends_base_class_1_2415", "Class '{0}' incorrectly extends base class '{1}'."),
        Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2: diag(2416, 1 /* Error */ , "Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2_2416", "Property '{0}' in type '{1}' is not assignable to the same property in base type '{2}'."),
        Class_static_side_0_incorrectly_extends_base_class_static_side_1: diag(2417, 1 /* Error */ , "Class_static_side_0_incorrectly_extends_base_class_static_side_1_2417", "Class static side '{0}' incorrectly extends base class static side '{1}'."),
        Type_of_computed_property_s_value_is_0_which_is_not_assignable_to_type_1: diag(2418, 1 /* Error */ , "Type_of_computed_property_s_value_is_0_which_is_not_assignable_to_type_1_2418", "Type of computed property's value is '{0}', which is not assignable to type '{1}'."),
        Types_of_construct_signatures_are_incompatible: diag(2419, 1 /* Error */ , "Types_of_construct_signatures_are_incompatible_2419", "Types of construct signatures are incompatible."),
        Class_0_incorrectly_implements_interface_1: diag(2420, 1 /* Error */ , "Class_0_incorrectly_implements_interface_1_2420", "Class '{0}' incorrectly implements interface '{1}'."),
        A_class_can_only_implement_an_object_type_or_intersection_of_object_types_with_statically_known_members: diag(2422, 1 /* Error */ , "A_class_can_only_implement_an_object_type_or_intersection_of_object_types_with_statically_known_memb_2422", "A class can only implement an object type or intersection of object types with statically known members."),
        Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor: diag(2423, 1 /* Error */ , "Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_access_2423", "Class '{0}' defines instance member function '{1}', but extended class '{2}' defines it as instance member accessor."),
        Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2425, 1 /* Error */ , "Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_functi_2425", "Class '{0}' defines instance member property '{1}', but extended class '{2}' defines it as instance member function."),
        Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2426, 1 /* Error */ , "Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_functi_2426", "Class '{0}' defines instance member accessor '{1}', but extended class '{2}' defines it as instance member function."),
        Interface_name_cannot_be_0: diag(2427, 1 /* Error */ , "Interface_name_cannot_be_0_2427", "Interface name cannot be '{0}'."),
        All_declarations_of_0_must_have_identical_type_parameters: diag(2428, 1 /* Error */ , "All_declarations_of_0_must_have_identical_type_parameters_2428", "All declarations of '{0}' must have identical type parameters."),
        Interface_0_incorrectly_extends_interface_1: diag(2430, 1 /* Error */ , "Interface_0_incorrectly_extends_interface_1_2430", "Interface '{0}' incorrectly extends interface '{1}'."),
        Enum_name_cannot_be_0: diag(2431, 1 /* Error */ , "Enum_name_cannot_be_0_2431", "Enum name cannot be '{0}'."),
        In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element: diag(2432, 1 /* Error */ , "In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enu_2432", "In an enum with multiple declarations, only one declaration can omit an initializer for its first enum element."),
        A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged: diag(2433, 1 /* Error */ , "A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merg_2433", "A namespace declaration cannot be in a different file from a class or function with which it is merged."),
        A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged: diag(2434, 1 /* Error */ , "A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged_2434", "A namespace declaration cannot be located prior to a class or function with which it is merged."),
        Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces: diag(2435, 1 /* Error */ , "Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces_2435", "Ambient modules cannot be nested in other modules or namespaces."),
        Ambient_module_declaration_cannot_specify_relative_module_name: diag(2436, 1 /* Error */ , "Ambient_module_declaration_cannot_specify_relative_module_name_2436", "Ambient module declaration cannot specify relative module name."),
        Module_0_is_hidden_by_a_local_declaration_with_the_same_name: diag(2437, 1 /* Error */ , "Module_0_is_hidden_by_a_local_declaration_with_the_same_name_2437", "Module '{0}' is hidden by a local declaration with the same name."),
        Import_name_cannot_be_0: diag(2438, 1 /* Error */ , "Import_name_cannot_be_0_2438", "Import name cannot be '{0}'."),
        Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name: diag(2439, 1 /* Error */ , "Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relati_2439", "Import or export declaration in an ambient module declaration cannot reference module through relative module name."),
        Import_declaration_conflicts_with_local_declaration_of_0: diag(2440, 1 /* Error */ , "Import_declaration_conflicts_with_local_declaration_of_0_2440", "Import declaration conflicts with local declaration of '{0}'."),
        Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module: diag(2441, 1 /* Error */ , "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_2441", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module."),
        Types_have_separate_declarations_of_a_private_property_0: diag(2442, 1 /* Error */ , "Types_have_separate_declarations_of_a_private_property_0_2442", "Types have separate declarations of a private property '{0}'."),
        Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2: diag(2443, 1 /* Error */ , "Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2_2443", "Property '{0}' is protected but type '{1}' is not a class derived from '{2}'."),
        Property_0_is_protected_in_type_1_but_public_in_type_2: diag(2444, 1 /* Error */ , "Property_0_is_protected_in_type_1_but_public_in_type_2_2444", "Property '{0}' is protected in type '{1}' but public in type '{2}'."),
        Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses: diag(2445, 1 /* Error */ , "Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses_2445", "Property '{0}' is protected and only accessible within class '{1}' and its subclasses."),
        Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_This_is_an_instance_of_class_2: diag(2446, 1 /* Error */ , "Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_This_is_an_instance_of_cl_2446", "Property '{0}' is protected and only accessible through an instance of class '{1}'. This is an instance of class '{2}'."),
        The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead: diag(2447, 1 /* Error */ , "The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead_2447", "The '{0}' operator is not allowed for boolean types. Consider using '{1}' instead."),
        Block_scoped_variable_0_used_before_its_declaration: diag(2448, 1 /* Error */ , "Block_scoped_variable_0_used_before_its_declaration_2448", "Block-scoped variable '{0}' used before its declaration."),
        Class_0_used_before_its_declaration: diag(2449, 1 /* Error */ , "Class_0_used_before_its_declaration_2449", "Class '{0}' used before its declaration."),
        Enum_0_used_before_its_declaration: diag(2450, 1 /* Error */ , "Enum_0_used_before_its_declaration_2450", "Enum '{0}' used before its declaration."),
        Cannot_redeclare_block_scoped_variable_0: diag(2451, 1 /* Error */ , "Cannot_redeclare_block_scoped_variable_0_2451", "Cannot redeclare block-scoped variable '{0}'."),
        An_enum_member_cannot_have_a_numeric_name: diag(2452, 1 /* Error */ , "An_enum_member_cannot_have_a_numeric_name_2452", "An enum member cannot have a numeric name."),
        Variable_0_is_used_before_being_assigned: diag(2454, 1 /* Error */ , "Variable_0_is_used_before_being_assigned_2454", "Variable '{0}' is used before being assigned."),
        Type_alias_0_circularly_references_itself: diag(2456, 1 /* Error */ , "Type_alias_0_circularly_references_itself_2456", "Type alias '{0}' circularly references itself."),
        Type_alias_name_cannot_be_0: diag(2457, 1 /* Error */ , "Type_alias_name_cannot_be_0_2457", "Type alias name cannot be '{0}'."),
        An_AMD_module_cannot_have_multiple_name_assignments: diag(2458, 1 /* Error */ , "An_AMD_module_cannot_have_multiple_name_assignments_2458", "An AMD module cannot have multiple name assignments."),
        Module_0_declares_1_locally_but_it_is_not_exported: diag(2459, 1 /* Error */ , "Module_0_declares_1_locally_but_it_is_not_exported_2459", "Module '{0}' declares '{1}' locally, but it is not exported."),
        Module_0_declares_1_locally_but_it_is_exported_as_2: diag(2460, 1 /* Error */ , "Module_0_declares_1_locally_but_it_is_exported_as_2_2460", "Module '{0}' declares '{1}' locally, but it is exported as '{2}'."),
        Type_0_is_not_an_array_type: diag(2461, 1 /* Error */ , "Type_0_is_not_an_array_type_2461", "Type '{0}' is not an array type."),
        A_rest_element_must_be_last_in_a_destructuring_pattern: diag(2462, 1 /* Error */ , "A_rest_element_must_be_last_in_a_destructuring_pattern_2462", "A rest element must be last in a destructuring pattern."),
        A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature: diag(2463, 1 /* Error */ , "A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature_2463", "A binding pattern parameter cannot be optional in an implementation signature."),
        A_computed_property_name_must_be_of_type_string_number_symbol_or_any: diag(2464, 1 /* Error */ , "A_computed_property_name_must_be_of_type_string_number_symbol_or_any_2464", "A computed property name must be of type 'string', 'number', 'symbol', or 'any'."),
        this_cannot_be_referenced_in_a_computed_property_name: diag(2465, 1 /* Error */ , "this_cannot_be_referenced_in_a_computed_property_name_2465", "'this' cannot be referenced in a computed property name."),
        super_cannot_be_referenced_in_a_computed_property_name: diag(2466, 1 /* Error */ , "super_cannot_be_referenced_in_a_computed_property_name_2466", "'super' cannot be referenced in a computed property name."),
        A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type: diag(2467, 1 /* Error */ , "A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type_2467", "A computed property name cannot reference a type parameter from its containing type."),
        Cannot_find_global_value_0: diag(2468, 1 /* Error */ , "Cannot_find_global_value_0_2468", "Cannot find global value '{0}'."),
        The_0_operator_cannot_be_applied_to_type_symbol: diag(2469, 1 /* Error */ , "The_0_operator_cannot_be_applied_to_type_symbol_2469", "The '{0}' operator cannot be applied to type 'symbol'."),
        Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher: diag(2472, 1 /* Error */ , "Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher_2472", "Spread operator in 'new' expressions is only available when targeting ECMAScript 5 and higher."),
        Enum_declarations_must_all_be_const_or_non_const: diag(2473, 1 /* Error */ , "Enum_declarations_must_all_be_const_or_non_const_2473", "Enum declarations must all be const or non-const."),
        const_enum_member_initializers_must_be_constant_expressions: diag(2474, 1 /* Error */ , "const_enum_member_initializers_must_be_constant_expressions_2474", "const enum member initializers must be constant expressions."),
        const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query: diag(2475, 1 /* Error */ , "const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_im_2475", "'const' enums can only be used in property or index access expressions or the right hand side of an import declaration or export assignment or type query."),
        A_const_enum_member_can_only_be_accessed_using_a_string_literal: diag(2476, 1 /* Error */ , "A_const_enum_member_can_only_be_accessed_using_a_string_literal_2476", "A const enum member can only be accessed using a string literal."),
        const_enum_member_initializer_was_evaluated_to_a_non_finite_value: diag(2477, 1 /* Error */ , "const_enum_member_initializer_was_evaluated_to_a_non_finite_value_2477", "'const' enum member initializer was evaluated to a non-finite value."),
        const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN: diag(2478, 1 /* Error */ , "const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN_2478", "'const' enum member initializer was evaluated to disallowed value 'NaN'."),
        let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations: diag(2480, 1 /* Error */ , "let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations_2480", "'let' is not allowed to be used as a name in 'let' or 'const' declarations."),
        Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1: diag(2481, 1 /* Error */ , "Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1_2481", "Cannot initialize outer scoped variable '{0}' in the same scope as block scoped declaration '{1}'."),
        The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation: diag(2483, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation_2483", "The left-hand side of a 'for...of' statement cannot use a type annotation."),
        Export_declaration_conflicts_with_exported_declaration_of_0: diag(2484, 1 /* Error */ , "Export_declaration_conflicts_with_exported_declaration_of_0_2484", "Export declaration conflicts with exported declaration of '{0}'."),
        The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access: diag(2487, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access_2487", "The left-hand side of a 'for...of' statement must be a variable or a property access."),
        Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2488, 1 /* Error */ , "Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator_2488", "Type '{0}' must have a '[Symbol.iterator]()' method that returns an iterator."),
        An_iterator_must_have_a_next_method: diag(2489, 1 /* Error */ , "An_iterator_must_have_a_next_method_2489", "An iterator must have a 'next()' method."),
        The_type_returned_by_the_0_method_of_an_iterator_must_have_a_value_property: diag(2490, 1 /* Error */ , "The_type_returned_by_the_0_method_of_an_iterator_must_have_a_value_property_2490", "The type returned by the '{0}()' method of an iterator must have a 'value' property."),
        The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern: diag(2491, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern_2491", "The left-hand side of a 'for...in' statement cannot be a destructuring pattern."),
        Cannot_redeclare_identifier_0_in_catch_clause: diag(2492, 1 /* Error */ , "Cannot_redeclare_identifier_0_in_catch_clause_2492", "Cannot redeclare identifier '{0}' in catch clause."),
        Tuple_type_0_of_length_1_has_no_element_at_index_2: diag(2493, 1 /* Error */ , "Tuple_type_0_of_length_1_has_no_element_at_index_2_2493", "Tuple type '{0}' of length '{1}' has no element at index '{2}'."),
        Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher: diag(2494, 1 /* Error */ , "Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher_2494", "Using a string in a 'for...of' statement is only supported in ECMAScript 5 and higher."),
        Type_0_is_not_an_array_type_or_a_string_type: diag(2495, 1 /* Error */ , "Type_0_is_not_an_array_type_or_a_string_type_2495", "Type '{0}' is not an array type or a string type."),
        The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES5_Consider_using_a_standard_function_expression: diag(2496, 1 /* Error */ , "The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES5_Consider_using_a_standard_func_2496", "The 'arguments' object cannot be referenced in an arrow function in ES5. Consider using a standard function expression."),
        This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_referencing_its_default_export: diag(2497, 1 /* Error */ , "This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_2497", "This module can only be referenced with ECMAScript imports/exports by turning on the '{0}' flag and referencing its default export."),
        Module_0_uses_export_and_cannot_be_used_with_export_Asterisk: diag(2498, 1 /* Error */ , "Module_0_uses_export_and_cannot_be_used_with_export_Asterisk_2498", "Module '{0}' uses 'export =' and cannot be used with 'export *'."),
        An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2499, 1 /* Error */ , "An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments_2499", "An interface can only extend an identifier/qualified-name with optional type arguments."),
        A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2500, 1 /* Error */ , "A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments_2500", "A class can only implement an identifier/qualified-name with optional type arguments."),
        A_rest_element_cannot_contain_a_binding_pattern: diag(2501, 1 /* Error */ , "A_rest_element_cannot_contain_a_binding_pattern_2501", "A rest element cannot contain a binding pattern."),
        _0_is_referenced_directly_or_indirectly_in_its_own_type_annotation: diag(2502, 1 /* Error */ , "_0_is_referenced_directly_or_indirectly_in_its_own_type_annotation_2502", "'{0}' is referenced directly or indirectly in its own type annotation."),
        Cannot_find_namespace_0: diag(2503, 1 /* Error */ , "Cannot_find_namespace_0_2503", "Cannot find namespace '{0}'."),
        Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator: diag(2504, 1 /* Error */ , "Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator_2504", "Type '{0}' must have a '[Symbol.asyncIterator]()' method that returns an async iterator."),
        A_generator_cannot_have_a_void_type_annotation: diag(2505, 1 /* Error */ , "A_generator_cannot_have_a_void_type_annotation_2505", "A generator cannot have a 'void' type annotation."),
        _0_is_referenced_directly_or_indirectly_in_its_own_base_expression: diag(2506, 1 /* Error */ , "_0_is_referenced_directly_or_indirectly_in_its_own_base_expression_2506", "'{0}' is referenced directly or indirectly in its own base expression."),
        Type_0_is_not_a_constructor_function_type: diag(2507, 1 /* Error */ , "Type_0_is_not_a_constructor_function_type_2507", "Type '{0}' is not a constructor function type."),
        No_base_constructor_has_the_specified_number_of_type_arguments: diag(2508, 1 /* Error */ , "No_base_constructor_has_the_specified_number_of_type_arguments_2508", "No base constructor has the specified number of type arguments."),
        Base_constructor_return_type_0_is_not_an_object_type_or_intersection_of_object_types_with_statically_known_members: diag(2509, 1 /* Error */ , "Base_constructor_return_type_0_is_not_an_object_type_or_intersection_of_object_types_with_statically_2509", "Base constructor return type '{0}' is not an object type or intersection of object types with statically known members."),
        Base_constructors_must_all_have_the_same_return_type: diag(2510, 1 /* Error */ , "Base_constructors_must_all_have_the_same_return_type_2510", "Base constructors must all have the same return type."),
        Cannot_create_an_instance_of_an_abstract_class: diag(2511, 1 /* Error */ , "Cannot_create_an_instance_of_an_abstract_class_2511", "Cannot create an instance of an abstract class."),
        Overload_signatures_must_all_be_abstract_or_non_abstract: diag(2512, 1 /* Error */ , "Overload_signatures_must_all_be_abstract_or_non_abstract_2512", "Overload signatures must all be abstract or non-abstract."),
        Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression: diag(2513, 1 /* Error */ , "Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression_2513", "Abstract method '{0}' in class '{1}' cannot be accessed via super expression."),
        A_tuple_type_cannot_be_indexed_with_a_negative_value: diag(2514, 1 /* Error */ , "A_tuple_type_cannot_be_indexed_with_a_negative_value_2514", "A tuple type cannot be indexed with a negative value."),
        Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2: diag(2515, 1 /* Error */ , "Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2_2515", "Non-abstract class '{0}' does not implement inherited abstract member {1} from class '{2}'."),
        All_declarations_of_an_abstract_method_must_be_consecutive: diag(2516, 1 /* Error */ , "All_declarations_of_an_abstract_method_must_be_consecutive_2516", "All declarations of an abstract method must be consecutive."),
        Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type: diag(2517, 1 /* Error */ , "Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type_2517", "Cannot assign an abstract constructor type to a non-abstract constructor type."),
        A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard: diag(2518, 1 /* Error */ , "A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard_2518", "A 'this'-based type guard is not compatible with a parameter-based type guard."),
        An_async_iterator_must_have_a_next_method: diag(2519, 1 /* Error */ , "An_async_iterator_must_have_a_next_method_2519", "An async iterator must have a 'next()' method."),
        Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions: diag(2520, 1 /* Error */ , "Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions_2520", "Duplicate identifier '{0}'. Compiler uses declaration '{1}' to support async functions."),
        The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES5_Consider_using_a_standard_function_or_method: diag(2522, 1 /* Error */ , "The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES5_Consider_using_a_sta_2522", "The 'arguments' object cannot be referenced in an async function or method in ES5. Consider using a standard function or method."),
        yield_expressions_cannot_be_used_in_a_parameter_initializer: diag(2523, 1 /* Error */ , "yield_expressions_cannot_be_used_in_a_parameter_initializer_2523", "'yield' expressions cannot be used in a parameter initializer."),
        await_expressions_cannot_be_used_in_a_parameter_initializer: diag(2524, 1 /* Error */ , "await_expressions_cannot_be_used_in_a_parameter_initializer_2524", "'await' expressions cannot be used in a parameter initializer."),
        A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface: diag(2526, 1 /* Error */ , "A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface_2526", "A 'this' type is available only in a non-static member of a class or interface."),
        The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary: diag(2527, 1 /* Error */ , "The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary_2527", "The inferred type of '{0}' references an inaccessible '{1}' type. A type annotation is necessary."),
        A_module_cannot_have_multiple_default_exports: diag(2528, 1 /* Error */ , "A_module_cannot_have_multiple_default_exports_2528", "A module cannot have multiple default exports."),
        Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions: diag(2529, 1 /* Error */ , "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_func_2529", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module containing async functions."),
        Property_0_is_incompatible_with_index_signature: diag(2530, 1 /* Error */ , "Property_0_is_incompatible_with_index_signature_2530", "Property '{0}' is incompatible with index signature."),
        Object_is_possibly_null: diag(2531, 1 /* Error */ , "Object_is_possibly_null_2531", "Object is possibly 'null'."),
        Object_is_possibly_undefined: diag(2532, 1 /* Error */ , "Object_is_possibly_undefined_2532", "Object is possibly 'undefined'."),
        Object_is_possibly_null_or_undefined: diag(2533, 1 /* Error */ , "Object_is_possibly_null_or_undefined_2533", "Object is possibly 'null' or 'undefined'."),
        A_function_returning_never_cannot_have_a_reachable_end_point: diag(2534, 1 /* Error */ , "A_function_returning_never_cannot_have_a_reachable_end_point_2534", "A function returning 'never' cannot have a reachable end point."),
        Type_0_cannot_be_used_to_index_type_1: diag(2536, 1 /* Error */ , "Type_0_cannot_be_used_to_index_type_1_2536", "Type '{0}' cannot be used to index type '{1}'."),
        Type_0_has_no_matching_index_signature_for_type_1: diag(2537, 1 /* Error */ , "Type_0_has_no_matching_index_signature_for_type_1_2537", "Type '{0}' has no matching index signature for type '{1}'."),
        Type_0_cannot_be_used_as_an_index_type: diag(2538, 1 /* Error */ , "Type_0_cannot_be_used_as_an_index_type_2538", "Type '{0}' cannot be used as an index type."),
        Cannot_assign_to_0_because_it_is_not_a_variable: diag(2539, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_not_a_variable_2539", "Cannot assign to '{0}' because it is not a variable."),
        Cannot_assign_to_0_because_it_is_a_read_only_property: diag(2540, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_read_only_property_2540", "Cannot assign to '{0}' because it is a read-only property."),
        Index_signature_in_type_0_only_permits_reading: diag(2542, 1 /* Error */ , "Index_signature_in_type_0_only_permits_reading_2542", "Index signature in type '{0}' only permits reading."),
        Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference: diag(2543, 1 /* Error */ , "Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_me_2543", "Duplicate identifier '_newTarget'. Compiler uses variable declaration '_newTarget' to capture 'new.target' meta-property reference."),
        Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference: diag(2544, 1 /* Error */ , "Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta__2544", "Expression resolves to variable declaration '_newTarget' that compiler uses to capture 'new.target' meta-property reference."),
        A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any: diag(2545, 1 /* Error */ , "A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any_2545", "A mixin class must have a constructor with a single rest parameter of type 'any[]'."),
        The_type_returned_by_the_0_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property: diag(2547, 1 /* Error */ , "The_type_returned_by_the_0_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_pro_2547", "The type returned by the '{0}()' method of an async iterator must be a promise for a type with a 'value' property."),
        Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2548, 1 /* Error */ , "Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator_2548", "Type '{0}' is not an array type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
        Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2549, 1 /* Error */ , "Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns__2549", "Type '{0}' is not an array type or a string type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
        Property_0_does_not_exist_on_type_1_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2_or_later: diag(2550, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Do_you_need_to_change_your_target_library_Try_changing_the_lib_c_2550", "Property '{0}' does not exist on type '{1}'. Do you need to change your target library? Try changing the 'lib' compiler option to '{2}' or later."),
        Property_0_does_not_exist_on_type_1_Did_you_mean_2: diag(2551, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Did_you_mean_2_2551", "Property '{0}' does not exist on type '{1}'. Did you mean '{2}'?"),
        Cannot_find_name_0_Did_you_mean_1: diag(2552, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_1_2552", "Cannot find name '{0}'. Did you mean '{1}'?"),
        Computed_values_are_not_permitted_in_an_enum_with_string_valued_members: diag(2553, 1 /* Error */ , "Computed_values_are_not_permitted_in_an_enum_with_string_valued_members_2553", "Computed values are not permitted in an enum with string valued members."),
        Expected_0_arguments_but_got_1: diag(2554, 1 /* Error */ , "Expected_0_arguments_but_got_1_2554", "Expected {0} arguments, but got {1}."),
        Expected_at_least_0_arguments_but_got_1: diag(2555, 1 /* Error */ , "Expected_at_least_0_arguments_but_got_1_2555", "Expected at least {0} arguments, but got {1}."),
        A_spread_argument_must_either_have_a_tuple_type_or_be_passed_to_a_rest_parameter: diag(2556, 1 /* Error */ , "A_spread_argument_must_either_have_a_tuple_type_or_be_passed_to_a_rest_parameter_2556", "A spread argument must either have a tuple type or be passed to a rest parameter."),
        Expected_0_type_arguments_but_got_1: diag(2558, 1 /* Error */ , "Expected_0_type_arguments_but_got_1_2558", "Expected {0} type arguments, but got {1}."),
        Type_0_has_no_properties_in_common_with_type_1: diag(2559, 1 /* Error */ , "Type_0_has_no_properties_in_common_with_type_1_2559", "Type '{0}' has no properties in common with type '{1}'."),
        Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it: diag(2560, 1 /* Error */ , "Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it_2560", "Value of type '{0}' has no properties in common with type '{1}'. Did you mean to call it?"),
        Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2: diag(2561, 1 /* Error */ , "Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_writ_2561", "Object literal may only specify known properties, but '{0}' does not exist in type '{1}'. Did you mean to write '{2}'?"),
        Base_class_expressions_cannot_reference_class_type_parameters: diag(2562, 1 /* Error */ , "Base_class_expressions_cannot_reference_class_type_parameters_2562", "Base class expressions cannot reference class type parameters."),
        The_containing_function_or_module_body_is_too_large_for_control_flow_analysis: diag(2563, 1 /* Error */ , "The_containing_function_or_module_body_is_too_large_for_control_flow_analysis_2563", "The containing function or module body is too large for control flow analysis."),
        Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor: diag(2564, 1 /* Error */ , "Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor_2564", "Property '{0}' has no initializer and is not definitely assigned in the constructor."),
        Property_0_is_used_before_being_assigned: diag(2565, 1 /* Error */ , "Property_0_is_used_before_being_assigned_2565", "Property '{0}' is used before being assigned."),
        A_rest_element_cannot_have_a_property_name: diag(2566, 1 /* Error */ , "A_rest_element_cannot_have_a_property_name_2566", "A rest element cannot have a property name."),
        Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations: diag(2567, 1 /* Error */ , "Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations_2567", "Enum declarations can only merge with namespace or other enum declarations."),
        Property_0_may_not_exist_on_type_1_Did_you_mean_2: diag(2568, 1 /* Error */ , "Property_0_may_not_exist_on_type_1_Did_you_mean_2_2568", "Property '{0}' may not exist on type '{1}'. Did you mean '{2}'?"),
        Could_not_find_name_0_Did_you_mean_1: diag(2570, 1 /* Error */ , "Could_not_find_name_0_Did_you_mean_1_2570", "Could not find name '{0}'. Did you mean '{1}'?"),
        Object_is_of_type_unknown: diag(2571, 1 /* Error */ , "Object_is_of_type_unknown_2571", "Object is of type 'unknown'."),
        A_rest_element_type_must_be_an_array_type: diag(2574, 1 /* Error */ , "A_rest_element_type_must_be_an_array_type_2574", "A rest element type must be an array type."),
        No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments: diag(2575, 1 /* Error */ , "No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments_2575", "No overload expects {0} arguments, but overloads do exist that expect either {1} or {2} arguments."),
        Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead: diag(2576, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead_2576", "Property '{0}' does not exist on type '{1}'. Did you mean to access the static member '{2}' instead?"),
        Return_type_annotation_circularly_references_itself: diag(2577, 1 /* Error */ , "Return_type_annotation_circularly_references_itself_2577", "Return type annotation circularly references itself."),
        Unused_ts_expect_error_directive: diag(2578, 1 /* Error */ , "Unused_ts_expect_error_directive_2578", "Unused '@ts-expect-error' directive."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode: diag(2580, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashno_2580", "Cannot find name '{0}'. Do you need to install type definitions for node? Try `npm i --save-dev @types/node`."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery: diag(2581, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slash_2581", "Cannot find name '{0}'. Do you need to install type definitions for jQuery? Try `npm i --save-dev @types/jquery`."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha: diag(2582, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_type_2582", "Cannot find name '{0}'. Do you need to install type definitions for a test runner? Try `npm i --save-dev @types/jest` or `npm i --save-dev @types/mocha`."),
        Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_1_or_later: diag(2583, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2583", "Cannot find name '{0}'. Do you need to change your target library? Try changing the 'lib' compiler option to '{1}' or later."),
        Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_include_dom: diag(2584, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2584", "Cannot find name '{0}'. Do you need to change your target library? Try changing the 'lib' compiler option to include 'dom'."),
        _0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_es2015_or_later: diag(2585, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Do_you_need_to_change_your_target_library_2585", "'{0}' only refers to a type, but is being used as a value here. Do you need to change your target library? Try changing the 'lib' compiler option to es2015 or later."),
        Cannot_assign_to_0_because_it_is_a_constant: diag(2588, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_constant_2588", "Cannot assign to '{0}' because it is a constant."),
        Type_instantiation_is_excessively_deep_and_possibly_infinite: diag(2589, 1 /* Error */ , "Type_instantiation_is_excessively_deep_and_possibly_infinite_2589", "Type instantiation is excessively deep and possibly infinite."),
        Expression_produces_a_union_type_that_is_too_complex_to_represent: diag(2590, 1 /* Error */ , "Expression_produces_a_union_type_that_is_too_complex_to_represent_2590", "Expression produces a union type that is too complex to represent."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode_and_then_add_node_to_the_types_field_in_your_tsconfig: diag(2591, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashno_2591", "Cannot find name '{0}'. Do you need to install type definitions for node? Try `npm i --save-dev @types/node` and then add 'node' to the types field in your tsconfig."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery_and_then_add_jquery_to_the_types_field_in_your_tsconfig: diag(2592, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slash_2592", "Cannot find name '{0}'. Do you need to install type definitions for jQuery? Try `npm i --save-dev @types/jquery` and then add 'jquery' to the types field in your tsconfig."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha_and_then_add_jest_or_mocha_to_the_types_field_in_your_tsconfig: diag(2593, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_type_2593", "Cannot find name '{0}'. Do you need to install type definitions for a test runner? Try `npm i --save-dev @types/jest` or `npm i --save-dev @types/mocha` and then add 'jest' or 'mocha' to the types field in your tsconfig."),
        This_module_is_declared_with_export_and_can_only_be_used_with_a_default_import_when_using_the_0_flag: diag(2594, 1 /* Error */ , "This_module_is_declared_with_export_and_can_only_be_used_with_a_default_import_when_using_the_0_flag_2594", "This module is declared with 'export =', and can only be used with a default import when using the '{0}' flag."),
        _0_can_only_be_imported_by_using_a_default_import: diag(2595, 1 /* Error */ , "_0_can_only_be_imported_by_using_a_default_import_2595", "'{0}' can only be imported by using a default import."),
        _0_can_only_be_imported_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import: diag(2596, 1 /* Error */ , "_0_can_only_be_imported_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import_2596", "'{0}' can only be imported by turning on the 'esModuleInterop' flag and using a default import."),
        _0_can_only_be_imported_by_using_a_require_call_or_by_using_a_default_import: diag(2597, 1 /* Error */ , "_0_can_only_be_imported_by_using_a_require_call_or_by_using_a_default_import_2597", "'{0}' can only be imported by using a 'require' call or by using a default import."),
        _0_can_only_be_imported_by_using_a_require_call_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import: diag(2598, 1 /* Error */ , "_0_can_only_be_imported_by_using_a_require_call_or_by_turning_on_the_esModuleInterop_flag_and_using__2598", "'{0}' can only be imported by using a 'require' call or by turning on the 'esModuleInterop' flag and using a default import."),
        JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist: diag(2602, 1 /* Error */ , "JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist_2602", "JSX element implicitly has type 'any' because the global type 'JSX.Element' does not exist."),
        Property_0_in_type_1_is_not_assignable_to_type_2: diag(2603, 1 /* Error */ , "Property_0_in_type_1_is_not_assignable_to_type_2_2603", "Property '{0}' in type '{1}' is not assignable to type '{2}'."),
        JSX_element_type_0_does_not_have_any_construct_or_call_signatures: diag(2604, 1 /* Error */ , "JSX_element_type_0_does_not_have_any_construct_or_call_signatures_2604", "JSX element type '{0}' does not have any construct or call signatures."),
        Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property: diag(2606, 1 /* Error */ , "Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property_2606", "Property '{0}' of JSX spread attribute is not assignable to target property."),
        JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property: diag(2607, 1 /* Error */ , "JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property_2607", "JSX element class does not support attributes because it does not have a '{0}' property."),
        The_global_type_JSX_0_may_not_have_more_than_one_property: diag(2608, 1 /* Error */ , "The_global_type_JSX_0_may_not_have_more_than_one_property_2608", "The global type 'JSX.{0}' may not have more than one property."),
        JSX_spread_child_must_be_an_array_type: diag(2609, 1 /* Error */ , "JSX_spread_child_must_be_an_array_type_2609", "JSX spread child must be an array type."),
        _0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property: diag(2610, 1 /* Error */ , "_0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property_2610", "'{0}' is defined as an accessor in class '{1}', but is overridden here in '{2}' as an instance property."),
        _0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor: diag(2611, 1 /* Error */ , "_0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor_2611", "'{0}' is defined as a property in class '{1}', but is overridden here in '{2}' as an accessor."),
        Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_add_a_declare_modifier_or_remove_the_redundant_declaration: diag(2612, 1 /* Error */ , "Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_2612", "Property '{0}' will overwrite the base property in '{1}'. If this is intentional, add an initializer. Otherwise, add a 'declare' modifier or remove the redundant declaration."),
        Module_0_has_no_default_export_Did_you_mean_to_use_import_1_from_0_instead: diag(2613, 1 /* Error */ , "Module_0_has_no_default_export_Did_you_mean_to_use_import_1_from_0_instead_2613", "Module '{0}' has no default export. Did you mean to use 'import { {1} } from {0}' instead?"),
        Module_0_has_no_exported_member_1_Did_you_mean_to_use_import_1_from_0_instead: diag(2614, 1 /* Error */ , "Module_0_has_no_exported_member_1_Did_you_mean_to_use_import_1_from_0_instead_2614", "Module '{0}' has no exported member '{1}'. Did you mean to use 'import {1} from {0}' instead?"),
        Type_of_property_0_circularly_references_itself_in_mapped_type_1: diag(2615, 1 /* Error */ , "Type_of_property_0_circularly_references_itself_in_mapped_type_1_2615", "Type of property '{0}' circularly references itself in mapped type '{1}'."),
        _0_can_only_be_imported_by_using_import_1_require_2_or_a_default_import: diag(2616, 1 /* Error */ , "_0_can_only_be_imported_by_using_import_1_require_2_or_a_default_import_2616", "'{0}' can only be imported by using 'import {1} = require({2})' or a default import."),
        _0_can_only_be_imported_by_using_import_1_require_2_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import: diag(2617, 1 /* Error */ , "_0_can_only_be_imported_by_using_import_1_require_2_or_by_turning_on_the_esModuleInterop_flag_and_us_2617", "'{0}' can only be imported by using 'import {1} = require({2})' or by turning on the 'esModuleInterop' flag and using a default import."),
        Source_has_0_element_s_but_target_requires_1: diag(2618, 1 /* Error */ , "Source_has_0_element_s_but_target_requires_1_2618", "Source has {0} element(s) but target requires {1}."),
        Source_has_0_element_s_but_target_allows_only_1: diag(2619, 1 /* Error */ , "Source_has_0_element_s_but_target_allows_only_1_2619", "Source has {0} element(s) but target allows only {1}."),
        Target_requires_0_element_s_but_source_may_have_fewer: diag(2620, 1 /* Error */ , "Target_requires_0_element_s_but_source_may_have_fewer_2620", "Target requires {0} element(s) but source may have fewer."),
        Target_allows_only_0_element_s_but_source_may_have_more: diag(2621, 1 /* Error */ , "Target_allows_only_0_element_s_but_source_may_have_more_2621", "Target allows only {0} element(s) but source may have more."),
        Source_provides_no_match_for_required_element_at_position_0_in_target: diag(2623, 1 /* Error */ , "Source_provides_no_match_for_required_element_at_position_0_in_target_2623", "Source provides no match for required element at position {0} in target."),
        Source_provides_no_match_for_variadic_element_at_position_0_in_target: diag(2624, 1 /* Error */ , "Source_provides_no_match_for_variadic_element_at_position_0_in_target_2624", "Source provides no match for variadic element at position {0} in target."),
        Variadic_element_at_position_0_in_source_does_not_match_element_at_position_1_in_target: diag(2625, 1 /* Error */ , "Variadic_element_at_position_0_in_source_does_not_match_element_at_position_1_in_target_2625", "Variadic element at position {0} in source does not match element at position {1} in target."),
        Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target: diag(2626, 1 /* Error */ , "Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target_2626", "Type at position {0} in source is not compatible with type at position {1} in target."),
        Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target: diag(2627, 1 /* Error */ , "Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target_2627", "Type at positions {0} through {1} in source is not compatible with type at position {2} in target."),
        Cannot_assign_to_0_because_it_is_an_enum: diag(2628, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_an_enum_2628", "Cannot assign to '{0}' because it is an enum."),
        Cannot_assign_to_0_because_it_is_a_class: diag(2629, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_class_2629", "Cannot assign to '{0}' because it is a class."),
        Cannot_assign_to_0_because_it_is_a_function: diag(2630, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_function_2630", "Cannot assign to '{0}' because it is a function."),
        Cannot_assign_to_0_because_it_is_a_namespace: diag(2631, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_a_namespace_2631", "Cannot assign to '{0}' because it is a namespace."),
        Cannot_assign_to_0_because_it_is_an_import: diag(2632, 1 /* Error */ , "Cannot_assign_to_0_because_it_is_an_import_2632", "Cannot assign to '{0}' because it is an import."),
        JSX_property_access_expressions_cannot_include_JSX_namespace_names: diag(2633, 1 /* Error */ , "JSX_property_access_expressions_cannot_include_JSX_namespace_names_2633", "JSX property access expressions cannot include JSX namespace names"),
        _0_index_signatures_are_incompatible: diag(2634, 1 /* Error */ , "_0_index_signatures_are_incompatible_2634", "'{0}' index signatures are incompatible."),
        Type_0_has_no_signatures_for_which_the_type_argument_list_is_applicable: diag(2635, 1 /* Error */ , "Type_0_has_no_signatures_for_which_the_type_argument_list_is_applicable_2635", "Type '{0}' has no signatures for which the type argument list is applicable."),
        Type_0_is_not_assignable_to_type_1_as_implied_by_variance_annotation: diag(2636, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_as_implied_by_variance_annotation_2636", "Type '{0}' is not assignable to type '{1}' as implied by variance annotation."),
        Variance_annotations_are_only_supported_in_type_aliases_for_object_function_constructor_and_mapped_types: diag(2637, 1 /* Error */ , "Variance_annotations_are_only_supported_in_type_aliases_for_object_function_constructor_and_mapped_t_2637", "Variance annotations are only supported in type aliases for object, function, constructor, and mapped types."),
        Type_0_may_represent_a_primitive_value_which_is_not_permitted_as_the_right_operand_of_the_in_operator: diag(2638, 1 /* Error */ , "Type_0_may_represent_a_primitive_value_which_is_not_permitted_as_the_right_operand_of_the_in_operato_2638", "Type '{0}' may represent a primitive value, which is not permitted as the right operand of the 'in' operator."),
        React_components_cannot_include_JSX_namespace_names: diag(2639, 1 /* Error */ , "React_components_cannot_include_JSX_namespace_names_2639", "React components cannot include JSX namespace names"),
        Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity: diag(2649, 1 /* Error */ , "Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity_2649", "Cannot augment module '{0}' with value exports because it resolves to a non-module entity."),
        Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1_and_2_more: diag(2650, 1 /* Error */ , "Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1_and__2650", "Non-abstract class expression is missing implementations for the following members of '{0}': {1} and {2} more."),
        A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums: diag(2651, 1 /* Error */ , "A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_memb_2651", "A member initializer in a enum declaration cannot reference members declared after it, including members defined in other enums."),
        Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead: diag(2652, 1 /* Error */ , "Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_d_2652", "Merged declaration '{0}' cannot include a default export declaration. Consider adding a separate 'export default {0}' declaration instead."),
        Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1: diag(2653, 1 /* Error */ , "Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1_2653", "Non-abstract class expression does not implement inherited abstract member '{0}' from class '{1}'."),
        Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2: diag(2654, 1 /* Error */ , "Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2_2654", "Non-abstract class '{0}' is missing implementations for the following members of '{1}': {2}."),
        Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2_and_3_more: diag(2655, 1 /* Error */ , "Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2_and_3_more_2655", "Non-abstract class '{0}' is missing implementations for the following members of '{1}': {2} and {3} more."),
        Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1: diag(2656, 1 /* Error */ , "Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1_2656", "Non-abstract class expression is missing implementations for the following members of '{0}': {1}."),
        JSX_expressions_must_have_one_parent_element: diag(2657, 1 /* Error */ , "JSX_expressions_must_have_one_parent_element_2657", "JSX expressions must have one parent element."),
        Type_0_provides_no_match_for_the_signature_1: diag(2658, 1 /* Error */ , "Type_0_provides_no_match_for_the_signature_1_2658", "Type '{0}' provides no match for the signature '{1}'."),
        super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher: diag(2659, 1 /* Error */ , "super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_highe_2659", "'super' is only allowed in members of object literal expressions when option 'target' is 'ES2015' or higher."),
        super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions: diag(2660, 1 /* Error */ , "super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions_2660", "'super' can only be referenced in members of derived classes or object literal expressions."),
        Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module: diag(2661, 1 /* Error */ , "Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module_2661", "Cannot export '{0}'. Only local declarations can be exported from a module."),
        Cannot_find_name_0_Did_you_mean_the_static_member_1_0: diag(2662, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_the_static_member_1_0_2662", "Cannot find name '{0}'. Did you mean the static member '{1}.{0}'?"),
        Cannot_find_name_0_Did_you_mean_the_instance_member_this_0: diag(2663, 1 /* Error */ , "Cannot_find_name_0_Did_you_mean_the_instance_member_this_0_2663", "Cannot find name '{0}'. Did you mean the instance member 'this.{0}'?"),
        Invalid_module_name_in_augmentation_module_0_cannot_be_found: diag(2664, 1 /* Error */ , "Invalid_module_name_in_augmentation_module_0_cannot_be_found_2664", "Invalid module name in augmentation, module '{0}' cannot be found."),
        Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented: diag(2665, 1 /* Error */ , "Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augm_2665", "Invalid module name in augmentation. Module '{0}' resolves to an untyped module at '{1}', which cannot be augmented."),
        Exports_and_export_assignments_are_not_permitted_in_module_augmentations: diag(2666, 1 /* Error */ , "Exports_and_export_assignments_are_not_permitted_in_module_augmentations_2666", "Exports and export assignments are not permitted in module augmentations."),
        Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module: diag(2667, 1 /* Error */ , "Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_mod_2667", "Imports are not permitted in module augmentations. Consider moving them to the enclosing external module."),
        export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible: diag(2668, 1 /* Error */ , "export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always__2668", "'export' modifier cannot be applied to ambient modules and module augmentations since they are always visible."),
        Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations: diag(2669, 1 /* Error */ , "Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_2669", "Augmentations for the global scope can only be directly nested in external modules or ambient module declarations."),
        Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context: diag(2670, 1 /* Error */ , "Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambien_2670", "Augmentations for the global scope should have 'declare' modifier unless they appear in already ambient context."),
        Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity: diag(2671, 1 /* Error */ , "Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity_2671", "Cannot augment module '{0}' because it resolves to a non-module entity."),
        Cannot_assign_a_0_constructor_type_to_a_1_constructor_type: diag(2672, 1 /* Error */ , "Cannot_assign_a_0_constructor_type_to_a_1_constructor_type_2672", "Cannot assign a '{0}' constructor type to a '{1}' constructor type."),
        Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration: diag(2673, 1 /* Error */ , "Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration_2673", "Constructor of class '{0}' is private and only accessible within the class declaration."),
        Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration: diag(2674, 1 /* Error */ , "Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration_2674", "Constructor of class '{0}' is protected and only accessible within the class declaration."),
        Cannot_extend_a_class_0_Class_constructor_is_marked_as_private: diag(2675, 1 /* Error */ , "Cannot_extend_a_class_0_Class_constructor_is_marked_as_private_2675", "Cannot extend a class '{0}'. Class constructor is marked as private."),
        Accessors_must_both_be_abstract_or_non_abstract: diag(2676, 1 /* Error */ , "Accessors_must_both_be_abstract_or_non_abstract_2676", "Accessors must both be abstract or non-abstract."),
        A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type: diag(2677, 1 /* Error */ , "A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type_2677", "A type predicate's type must be assignable to its parameter's type."),
        Type_0_is_not_comparable_to_type_1: diag(2678, 1 /* Error */ , "Type_0_is_not_comparable_to_type_1_2678", "Type '{0}' is not comparable to type '{1}'."),
        A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void: diag(2679, 1 /* Error */ , "A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void_2679", "A function that is called with the 'new' keyword cannot have a 'this' type that is 'void'."),
        A_0_parameter_must_be_the_first_parameter: diag(2680, 1 /* Error */ , "A_0_parameter_must_be_the_first_parameter_2680", "A '{0}' parameter must be the first parameter."),
        A_constructor_cannot_have_a_this_parameter: diag(2681, 1 /* Error */ , "A_constructor_cannot_have_a_this_parameter_2681", "A constructor cannot have a 'this' parameter."),
        this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation: diag(2683, 1 /* Error */ , "this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_2683", "'this' implicitly has type 'any' because it does not have a type annotation."),
        The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1: diag(2684, 1 /* Error */ , "The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1_2684", "The 'this' context of type '{0}' is not assignable to method's 'this' of type '{1}'."),
        The_this_types_of_each_signature_are_incompatible: diag(2685, 1 /* Error */ , "The_this_types_of_each_signature_are_incompatible_2685", "The 'this' types of each signature are incompatible."),
        _0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead: diag(2686, 1 /* Error */ , "_0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead_2686", "'{0}' refers to a UMD global, but the current file is a module. Consider adding an import instead."),
        All_declarations_of_0_must_have_identical_modifiers: diag(2687, 1 /* Error */ , "All_declarations_of_0_must_have_identical_modifiers_2687", "All declarations of '{0}' must have identical modifiers."),
        Cannot_find_type_definition_file_for_0: diag(2688, 1 /* Error */ , "Cannot_find_type_definition_file_for_0_2688", "Cannot find type definition file for '{0}'."),
        Cannot_extend_an_interface_0_Did_you_mean_implements: diag(2689, 1 /* Error */ , "Cannot_extend_an_interface_0_Did_you_mean_implements_2689", "Cannot extend an interface '{0}'. Did you mean 'implements'?"),
        _0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0: diag(2690, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0_2690", "'{0}' only refers to a type, but is being used as a value here. Did you mean to use '{1} in {0}'?"),
        _0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible: diag(2692, 1 /* Error */ , "_0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible_2692", "'{0}' is a primitive, but '{1}' is a wrapper object. Prefer using '{0}' when possible."),
        _0_only_refers_to_a_type_but_is_being_used_as_a_value_here: diag(2693, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_2693", "'{0}' only refers to a type, but is being used as a value here."),
        Namespace_0_has_no_exported_member_1: diag(2694, 1 /* Error */ , "Namespace_0_has_no_exported_member_1_2694", "Namespace '{0}' has no exported member '{1}'."),
        Left_side_of_comma_operator_is_unused_and_has_no_side_effects: diag(2695, 1 /* Error */ , "Left_side_of_comma_operator_is_unused_and_has_no_side_effects_2695", "Left side of comma operator is unused and has no side effects.", /*reportsUnnecessary*/ true),
        The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead: diag(2696, 1 /* Error */ , "The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead_2696", "The 'Object' type is assignable to very few other types. Did you mean to use the 'any' type instead?"),
        An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2697, 1 /* Error */ , "An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_in_2697", "An async function or method must return a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your '--lib' option."),
        Spread_types_may_only_be_created_from_object_types: diag(2698, 1 /* Error */ , "Spread_types_may_only_be_created_from_object_types_2698", "Spread types may only be created from object types."),
        Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1: diag(2699, 1 /* Error */ , "Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1_2699", "Static property '{0}' conflicts with built-in property 'Function.{0}' of constructor function '{1}'."),
        Rest_types_may_only_be_created_from_object_types: diag(2700, 1 /* Error */ , "Rest_types_may_only_be_created_from_object_types_2700", "Rest types may only be created from object types."),
        The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access: diag(2701, 1 /* Error */ , "The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access_2701", "The target of an object rest assignment must be a variable or a property access."),
        _0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here: diag(2702, 1 /* Error */ , "_0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here_2702", "'{0}' only refers to a type, but is being used as a namespace here."),
        The_operand_of_a_delete_operator_must_be_a_property_reference: diag(2703, 1 /* Error */ , "The_operand_of_a_delete_operator_must_be_a_property_reference_2703", "The operand of a 'delete' operator must be a property reference."),
        The_operand_of_a_delete_operator_cannot_be_a_read_only_property: diag(2704, 1 /* Error */ , "The_operand_of_a_delete_operator_cannot_be_a_read_only_property_2704", "The operand of a 'delete' operator cannot be a read-only property."),
        An_async_function_or_method_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2705, 1 /* Error */ , "An_async_function_or_method_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_2705", "An async function or method in ES5 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your '--lib' option."),
        Required_type_parameters_may_not_follow_optional_type_parameters: diag(2706, 1 /* Error */ , "Required_type_parameters_may_not_follow_optional_type_parameters_2706", "Required type parameters may not follow optional type parameters."),
        Generic_type_0_requires_between_1_and_2_type_arguments: diag(2707, 1 /* Error */ , "Generic_type_0_requires_between_1_and_2_type_arguments_2707", "Generic type '{0}' requires between {1} and {2} type arguments."),
        Cannot_use_namespace_0_as_a_value: diag(2708, 1 /* Error */ , "Cannot_use_namespace_0_as_a_value_2708", "Cannot use namespace '{0}' as a value."),
        Cannot_use_namespace_0_as_a_type: diag(2709, 1 /* Error */ , "Cannot_use_namespace_0_as_a_type_2709", "Cannot use namespace '{0}' as a type."),
        _0_are_specified_twice_The_attribute_named_0_will_be_overwritten: diag(2710, 1 /* Error */ , "_0_are_specified_twice_The_attribute_named_0_will_be_overwritten_2710", "'{0}' are specified twice. The attribute named '{0}' will be overwritten."),
        A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2711, 1 /* Error */ , "A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES20_2711", "A dynamic import call returns a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your '--lib' option."),
        A_dynamic_import_call_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2712, 1 /* Error */ , "A_dynamic_import_call_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_t_2712", "A dynamic import call in ES5 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your '--lib' option."),
        Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1: diag(2713, 1 /* Error */ , "Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_p_2713", `Cannot access '{0}.{1}' because '{0}' is a type, but not a namespace. Did you mean to retrieve the type of the property '{1}' in '{0}' with '{0}["{1}"]'?`),
        The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context: diag(2714, 1 /* Error */ , "The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context_2714", "The expression of an export assignment must be an identifier or qualified name in an ambient context."),
        Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor: diag(2715, 1 /* Error */ , "Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor_2715", "Abstract property '{0}' in class '{1}' cannot be accessed in the constructor."),
        Type_parameter_0_has_a_circular_default: diag(2716, 1 /* Error */ , "Type_parameter_0_has_a_circular_default_2716", "Type parameter '{0}' has a circular default."),
        Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2: diag(2717, 1 /* Error */ , "Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_t_2717", "Subsequent property declarations must have the same type.  Property '{0}' must be of type '{1}', but here has type '{2}'."),
        Duplicate_property_0: diag(2718, 1 /* Error */ , "Duplicate_property_0_2718", "Duplicate property '{0}'."),
        Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated: diag(2719, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated_2719", "Type '{0}' is not assignable to type '{1}'. Two different types with this name exist, but they are unrelated."),
        Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass: diag(2720, 1 /* Error */ , "Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclas_2720", "Class '{0}' incorrectly implements class '{1}'. Did you mean to extend '{1}' and inherit its members as a subclass?"),
        Cannot_invoke_an_object_which_is_possibly_null: diag(2721, 1 /* Error */ , "Cannot_invoke_an_object_which_is_possibly_null_2721", "Cannot invoke an object which is possibly 'null'."),
        Cannot_invoke_an_object_which_is_possibly_undefined: diag(2722, 1 /* Error */ , "Cannot_invoke_an_object_which_is_possibly_undefined_2722", "Cannot invoke an object which is possibly 'undefined'."),
        Cannot_invoke_an_object_which_is_possibly_null_or_undefined: diag(2723, 1 /* Error */ , "Cannot_invoke_an_object_which_is_possibly_null_or_undefined_2723", "Cannot invoke an object which is possibly 'null' or 'undefined'."),
        _0_has_no_exported_member_named_1_Did_you_mean_2: diag(2724, 1 /* Error */ , "_0_has_no_exported_member_named_1_Did_you_mean_2_2724", "'{0}' has no exported member named '{1}'. Did you mean '{2}'?"),
        Class_name_cannot_be_Object_when_targeting_ES5_and_above_with_module_0: diag(2725, 1 /* Error */ , "Class_name_cannot_be_Object_when_targeting_ES5_and_above_with_module_0_2725", "Class name cannot be 'Object' when targeting ES5 and above with module {0}."),
        Cannot_find_lib_definition_for_0: diag(2726, 1 /* Error */ , "Cannot_find_lib_definition_for_0_2726", "Cannot find lib definition for '{0}'."),
        Cannot_find_lib_definition_for_0_Did_you_mean_1: diag(2727, 1 /* Error */ , "Cannot_find_lib_definition_for_0_Did_you_mean_1_2727", "Cannot find lib definition for '{0}'. Did you mean '{1}'?"),
        _0_is_declared_here: diag(2728, 3 /* Message */ , "_0_is_declared_here_2728", "'{0}' is declared here."),
        Property_0_is_used_before_its_initialization: diag(2729, 1 /* Error */ , "Property_0_is_used_before_its_initialization_2729", "Property '{0}' is used before its initialization."),
        An_arrow_function_cannot_have_a_this_parameter: diag(2730, 1 /* Error */ , "An_arrow_function_cannot_have_a_this_parameter_2730", "An arrow function cannot have a 'this' parameter."),
        Implicit_conversion_of_a_symbol_to_a_string_will_fail_at_runtime_Consider_wrapping_this_expression_in_String: diag(2731, 1 /* Error */ , "Implicit_conversion_of_a_symbol_to_a_string_will_fail_at_runtime_Consider_wrapping_this_expression_i_2731", "Implicit conversion of a 'symbol' to a 'string' will fail at runtime. Consider wrapping this expression in 'String(...)'."),
        Cannot_find_module_0_Consider_using_resolveJsonModule_to_import_module_with_json_extension: diag(2732, 1 /* Error */ , "Cannot_find_module_0_Consider_using_resolveJsonModule_to_import_module_with_json_extension_2732", "Cannot find module '{0}'. Consider using '--resolveJsonModule' to import module with '.json' extension."),
        Property_0_was_also_declared_here: diag(2733, 1 /* Error */ , "Property_0_was_also_declared_here_2733", "Property '{0}' was also declared here."),
        Are_you_missing_a_semicolon: diag(2734, 1 /* Error */ , "Are_you_missing_a_semicolon_2734", "Are you missing a semicolon?"),
        Did_you_mean_for_0_to_be_constrained_to_type_new_args_Colon_any_1: diag(2735, 1 /* Error */ , "Did_you_mean_for_0_to_be_constrained_to_type_new_args_Colon_any_1_2735", "Did you mean for '{0}' to be constrained to type 'new (...args: any[]) => {1}'?"),
        Operator_0_cannot_be_applied_to_type_1: diag(2736, 1 /* Error */ , "Operator_0_cannot_be_applied_to_type_1_2736", "Operator '{0}' cannot be applied to type '{1}'."),
        BigInt_literals_are_not_available_when_targeting_lower_than_ES2020: diag(2737, 1 /* Error */ , "BigInt_literals_are_not_available_when_targeting_lower_than_ES2020_2737", "BigInt literals are not available when targeting lower than ES2020."),
        An_outer_value_of_this_is_shadowed_by_this_container: diag(2738, 3 /* Message */ , "An_outer_value_of_this_is_shadowed_by_this_container_2738", "An outer value of 'this' is shadowed by this container."),
        Type_0_is_missing_the_following_properties_from_type_1_Colon_2: diag(2739, 1 /* Error */ , "Type_0_is_missing_the_following_properties_from_type_1_Colon_2_2739", "Type '{0}' is missing the following properties from type '{1}': {2}"),
        Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more: diag(2740, 1 /* Error */ , "Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more_2740", "Type '{0}' is missing the following properties from type '{1}': {2}, and {3} more."),
        Property_0_is_missing_in_type_1_but_required_in_type_2: diag(2741, 1 /* Error */ , "Property_0_is_missing_in_type_1_but_required_in_type_2_2741", "Property '{0}' is missing in type '{1}' but required in type '{2}'."),
        The_inferred_type_of_0_cannot_be_named_without_a_reference_to_1_This_is_likely_not_portable_A_type_annotation_is_necessary: diag(2742, 1 /* Error */ , "The_inferred_type_of_0_cannot_be_named_without_a_reference_to_1_This_is_likely_not_portable_A_type_a_2742", "The inferred type of '{0}' cannot be named without a reference to '{1}'. This is likely not portable. A type annotation is necessary."),
        No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments: diag(2743, 1 /* Error */ , "No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments_2743", "No overload expects {0} type arguments, but overloads do exist that expect either {1} or {2} type arguments."),
        Type_parameter_defaults_can_only_reference_previously_declared_type_parameters: diag(2744, 1 /* Error */ , "Type_parameter_defaults_can_only_reference_previously_declared_type_parameters_2744", "Type parameter defaults can only reference previously declared type parameters."),
        This_JSX_tag_s_0_prop_expects_type_1_which_requires_multiple_children_but_only_a_single_child_was_provided: diag(2745, 1 /* Error */ , "This_JSX_tag_s_0_prop_expects_type_1_which_requires_multiple_children_but_only_a_single_child_was_pr_2745", "This JSX tag's '{0}' prop expects type '{1}' which requires multiple children, but only a single child was provided."),
        This_JSX_tag_s_0_prop_expects_a_single_child_of_type_1_but_multiple_children_were_provided: diag(2746, 1 /* Error */ , "This_JSX_tag_s_0_prop_expects_a_single_child_of_type_1_but_multiple_children_were_provided_2746", "This JSX tag's '{0}' prop expects a single child of type '{1}', but multiple children were provided."),
        _0_components_don_t_accept_text_as_child_elements_Text_in_JSX_has_the_type_string_but_the_expected_type_of_1_is_2: diag(2747, 1 /* Error */ , "_0_components_don_t_accept_text_as_child_elements_Text_in_JSX_has_the_type_string_but_the_expected_t_2747", "'{0}' components don't accept text as child elements. Text in JSX has the type 'string', but the expected type of '{1}' is '{2}'."),
        Cannot_access_ambient_const_enums_when_0_is_enabled: diag(2748, 1 /* Error */ , "Cannot_access_ambient_const_enums_when_0_is_enabled_2748", "Cannot access ambient const enums when '{0}' is enabled."),
        _0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0: diag(2749, 1 /* Error */ , "_0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0_2749", "'{0}' refers to a value, but is being used as a type here. Did you mean 'typeof {0}'?"),
        The_implementation_signature_is_declared_here: diag(2750, 1 /* Error */ , "The_implementation_signature_is_declared_here_2750", "The implementation signature is declared here."),
        Circularity_originates_in_type_at_this_location: diag(2751, 1 /* Error */ , "Circularity_originates_in_type_at_this_location_2751", "Circularity originates in type at this location."),
        The_first_export_default_is_here: diag(2752, 1 /* Error */ , "The_first_export_default_is_here_2752", "The first export default is here."),
        Another_export_default_is_here: diag(2753, 1 /* Error */ , "Another_export_default_is_here_2753", "Another export default is here."),
        super_may_not_use_type_arguments: diag(2754, 1 /* Error */ , "super_may_not_use_type_arguments_2754", "'super' may not use type arguments."),
        No_constituent_of_type_0_is_callable: diag(2755, 1 /* Error */ , "No_constituent_of_type_0_is_callable_2755", "No constituent of type '{0}' is callable."),
        Not_all_constituents_of_type_0_are_callable: diag(2756, 1 /* Error */ , "Not_all_constituents_of_type_0_are_callable_2756", "Not all constituents of type '{0}' are callable."),
        Type_0_has_no_call_signatures: diag(2757, 1 /* Error */ , "Type_0_has_no_call_signatures_2757", "Type '{0}' has no call signatures."),
        Each_member_of_the_union_type_0_has_signatures_but_none_of_those_signatures_are_compatible_with_each_other: diag(2758, 1 /* Error */ , "Each_member_of_the_union_type_0_has_signatures_but_none_of_those_signatures_are_compatible_with_each_2758", "Each member of the union type '{0}' has signatures, but none of those signatures are compatible with each other."),
        No_constituent_of_type_0_is_constructable: diag(2759, 1 /* Error */ , "No_constituent_of_type_0_is_constructable_2759", "No constituent of type '{0}' is constructable."),
        Not_all_constituents_of_type_0_are_constructable: diag(2760, 1 /* Error */ , "Not_all_constituents_of_type_0_are_constructable_2760", "Not all constituents of type '{0}' are constructable."),
        Type_0_has_no_construct_signatures: diag(2761, 1 /* Error */ , "Type_0_has_no_construct_signatures_2761", "Type '{0}' has no construct signatures."),
        Each_member_of_the_union_type_0_has_construct_signatures_but_none_of_those_signatures_are_compatible_with_each_other: diag(2762, 1 /* Error */ , "Each_member_of_the_union_type_0_has_construct_signatures_but_none_of_those_signatures_are_compatible_2762", "Each member of the union type '{0}' has construct signatures, but none of those signatures are compatible with each other."),
        Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_for_of_will_always_send_0: diag(2763, 1 /* Error */ , "Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_for_of_will_always_s_2763", "Cannot iterate value because the 'next' method of its iterator expects type '{1}', but for-of will always send '{0}'."),
        Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_spread_will_always_send_0: diag(2764, 1 /* Error */ , "Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_spread_will_al_2764", "Cannot iterate value because the 'next' method of its iterator expects type '{1}', but array spread will always send '{0}'."),
        Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_destructuring_will_always_send_0: diag(2765, 1 /* Error */ , "Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_destructuring__2765", "Cannot iterate value because the 'next' method of its iterator expects type '{1}', but array destructuring will always send '{0}'."),
        Cannot_delegate_iteration_to_value_because_the_next_method_of_its_iterator_expects_type_1_but_the_containing_generator_will_always_send_0: diag(2766, 1 /* Error */ , "Cannot_delegate_iteration_to_value_because_the_next_method_of_its_iterator_expects_type_1_but_the_co_2766", "Cannot delegate iteration to value because the 'next' method of its iterator expects type '{1}', but the containing generator will always send '{0}'."),
        The_0_property_of_an_iterator_must_be_a_method: diag(2767, 1 /* Error */ , "The_0_property_of_an_iterator_must_be_a_method_2767", "The '{0}' property of an iterator must be a method."),
        The_0_property_of_an_async_iterator_must_be_a_method: diag(2768, 1 /* Error */ , "The_0_property_of_an_async_iterator_must_be_a_method_2768", "The '{0}' property of an async iterator must be a method."),
        No_overload_matches_this_call: diag(2769, 1 /* Error */ , "No_overload_matches_this_call_2769", "No overload matches this call."),
        The_last_overload_gave_the_following_error: diag(2770, 1 /* Error */ , "The_last_overload_gave_the_following_error_2770", "The last overload gave the following error."),
        The_last_overload_is_declared_here: diag(2771, 1 /* Error */ , "The_last_overload_is_declared_here_2771", "The last overload is declared here."),
        Overload_0_of_1_2_gave_the_following_error: diag(2772, 1 /* Error */ , "Overload_0_of_1_2_gave_the_following_error_2772", "Overload {0} of {1}, '{2}', gave the following error."),
        Did_you_forget_to_use_await: diag(2773, 1 /* Error */ , "Did_you_forget_to_use_await_2773", "Did you forget to use 'await'?"),
        This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_instead: diag(2774, 1 /* Error */ , "This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_2774", "This condition will always return true since this function is always defined. Did you mean to call it instead?"),
        Assertions_require_every_name_in_the_call_target_to_be_declared_with_an_explicit_type_annotation: diag(2775, 1 /* Error */ , "Assertions_require_every_name_in_the_call_target_to_be_declared_with_an_explicit_type_annotation_2775", "Assertions require every name in the call target to be declared with an explicit type annotation."),
        Assertions_require_the_call_target_to_be_an_identifier_or_qualified_name: diag(2776, 1 /* Error */ , "Assertions_require_the_call_target_to_be_an_identifier_or_qualified_name_2776", "Assertions require the call target to be an identifier or qualified name."),
        The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access: diag(2777, 1 /* Error */ , "The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access_2777", "The operand of an increment or decrement operator may not be an optional property access."),
        The_target_of_an_object_rest_assignment_may_not_be_an_optional_property_access: diag(2778, 1 /* Error */ , "The_target_of_an_object_rest_assignment_may_not_be_an_optional_property_access_2778", "The target of an object rest assignment may not be an optional property access."),
        The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access: diag(2779, 1 /* Error */ , "The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access_2779", "The left-hand side of an assignment expression may not be an optional property access."),
        The_left_hand_side_of_a_for_in_statement_may_not_be_an_optional_property_access: diag(2780, 1 /* Error */ , "The_left_hand_side_of_a_for_in_statement_may_not_be_an_optional_property_access_2780", "The left-hand side of a 'for...in' statement may not be an optional property access."),
        The_left_hand_side_of_a_for_of_statement_may_not_be_an_optional_property_access: diag(2781, 1 /* Error */ , "The_left_hand_side_of_a_for_of_statement_may_not_be_an_optional_property_access_2781", "The left-hand side of a 'for...of' statement may not be an optional property access."),
        _0_needs_an_explicit_type_annotation: diag(2782, 3 /* Message */ , "_0_needs_an_explicit_type_annotation_2782", "'{0}' needs an explicit type annotation."),
        _0_is_specified_more_than_once_so_this_usage_will_be_overwritten: diag(2783, 1 /* Error */ , "_0_is_specified_more_than_once_so_this_usage_will_be_overwritten_2783", "'{0}' is specified more than once, so this usage will be overwritten."),
        get_and_set_accessors_cannot_declare_this_parameters: diag(2784, 1 /* Error */ , "get_and_set_accessors_cannot_declare_this_parameters_2784", "'get' and 'set' accessors cannot declare 'this' parameters."),
        This_spread_always_overwrites_this_property: diag(2785, 1 /* Error */ , "This_spread_always_overwrites_this_property_2785", "This spread always overwrites this property."),
        _0_cannot_be_used_as_a_JSX_component: diag(2786, 1 /* Error */ , "_0_cannot_be_used_as_a_JSX_component_2786", "'{0}' cannot be used as a JSX component."),
        Its_return_type_0_is_not_a_valid_JSX_element: diag(2787, 1 /* Error */ , "Its_return_type_0_is_not_a_valid_JSX_element_2787", "Its return type '{0}' is not a valid JSX element."),
        Its_instance_type_0_is_not_a_valid_JSX_element: diag(2788, 1 /* Error */ , "Its_instance_type_0_is_not_a_valid_JSX_element_2788", "Its instance type '{0}' is not a valid JSX element."),
        Its_element_type_0_is_not_a_valid_JSX_element: diag(2789, 1 /* Error */ , "Its_element_type_0_is_not_a_valid_JSX_element_2789", "Its element type '{0}' is not a valid JSX element."),
        The_operand_of_a_delete_operator_must_be_optional: diag(2790, 1 /* Error */ , "The_operand_of_a_delete_operator_must_be_optional_2790", "The operand of a 'delete' operator must be optional."),
        Exponentiation_cannot_be_performed_on_bigint_values_unless_the_target_option_is_set_to_es2016_or_later: diag(2791, 1 /* Error */ , "Exponentiation_cannot_be_performed_on_bigint_values_unless_the_target_option_is_set_to_es2016_or_lat_2791", "Exponentiation cannot be performed on 'bigint' values unless the 'target' option is set to 'es2016' or later."),
        Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_to_the_paths_option: diag(2792, 1 /* Error */ , "Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_t_2792", "Cannot find module '{0}'. Did you mean to set the 'moduleResolution' option to 'nodenext', or to add aliases to the 'paths' option?"),
        The_call_would_have_succeeded_against_this_implementation_but_implementation_signatures_of_overloads_are_not_externally_visible: diag(2793, 1 /* Error */ , "The_call_would_have_succeeded_against_this_implementation_but_implementation_signatures_of_overloads_2793", "The call would have succeeded against this implementation, but implementation signatures of overloads are not externally visible."),
        Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise: diag(2794, 1 /* Error */ , "Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise_2794", "Expected {0} arguments, but got {1}. Did you forget to include 'void' in your type argument to 'Promise'?"),
        The_intrinsic_keyword_can_only_be_used_to_declare_compiler_provided_intrinsic_types: diag(2795, 1 /* Error */ , "The_intrinsic_keyword_can_only_be_used_to_declare_compiler_provided_intrinsic_types_2795", "The 'intrinsic' keyword can only be used to declare compiler provided intrinsic types."),
        It_is_likely_that_you_are_missing_a_comma_to_separate_these_two_template_expressions_They_form_a_tagged_template_expression_which_cannot_be_invoked: diag(2796, 1 /* Error */ , "It_is_likely_that_you_are_missing_a_comma_to_separate_these_two_template_expressions_They_form_a_tag_2796", "It is likely that you are missing a comma to separate these two template expressions. They form a tagged template expression which cannot be invoked."),
        A_mixin_class_that_extends_from_a_type_variable_containing_an_abstract_construct_signature_must_also_be_declared_abstract: diag(2797, 1 /* Error */ , "A_mixin_class_that_extends_from_a_type_variable_containing_an_abstract_construct_signature_must_also_2797", "A mixin class that extends from a type variable containing an abstract construct signature must also be declared 'abstract'."),
        The_declaration_was_marked_as_deprecated_here: diag(2798, 1 /* Error */ , "The_declaration_was_marked_as_deprecated_here_2798", "The declaration was marked as deprecated here."),
        Type_produces_a_tuple_type_that_is_too_large_to_represent: diag(2799, 1 /* Error */ , "Type_produces_a_tuple_type_that_is_too_large_to_represent_2799", "Type produces a tuple type that is too large to represent."),
        Expression_produces_a_tuple_type_that_is_too_large_to_represent: diag(2800, 1 /* Error */ , "Expression_produces_a_tuple_type_that_is_too_large_to_represent_2800", "Expression produces a tuple type that is too large to represent."),
        This_condition_will_always_return_true_since_this_0_is_always_defined: diag(2801, 1 /* Error */ , "This_condition_will_always_return_true_since_this_0_is_always_defined_2801", "This condition will always return true since this '{0}' is always defined."),
        Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher: diag(2802, 1 /* Error */ , "Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es201_2802", "Type '{0}' can only be iterated through when using the '--downlevelIteration' flag or with a '--target' of 'es2015' or higher."),
        Cannot_assign_to_private_method_0_Private_methods_are_not_writable: diag(2803, 1 /* Error */ , "Cannot_assign_to_private_method_0_Private_methods_are_not_writable_2803", "Cannot assign to private method '{0}'. Private methods are not writable."),
        Duplicate_identifier_0_Static_and_instance_elements_cannot_share_the_same_private_name: diag(2804, 1 /* Error */ , "Duplicate_identifier_0_Static_and_instance_elements_cannot_share_the_same_private_name_2804", "Duplicate identifier '{0}'. Static and instance elements cannot share the same private name."),
        Private_accessor_was_defined_without_a_getter: diag(2806, 1 /* Error */ , "Private_accessor_was_defined_without_a_getter_2806", "Private accessor was defined without a getter."),
        This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0: diag(2807, 1 /* Error */ , "This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_o_2807", "This syntax requires an imported helper named '{1}' with {2} parameters, which is not compatible with the one in '{0}'. Consider upgrading your version of '{0}'."),
        A_get_accessor_must_be_at_least_as_accessible_as_the_setter: diag(2808, 1 /* Error */ , "A_get_accessor_must_be_at_least_as_accessible_as_the_setter_2808", "A get accessor must be at least as accessible as the setter"),
        Declaration_or_statement_expected_This_follows_a_block_of_statements_so_if_you_intended_to_write_a_destructuring_assignment_you_might_need_to_wrap_the_whole_assignment_in_parentheses: diag(2809, 1 /* Error */ , "Declaration_or_statement_expected_This_follows_a_block_of_statements_so_if_you_intended_to_write_a_d_2809", "Declaration or statement expected. This '=' follows a block of statements, so if you intended to write a destructuring assignment, you might need to wrap the whole assignment in parentheses."),
        Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_without_arguments: diag(2810, 1 /* Error */ , "Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_2810", "Expected 1 argument, but got 0. 'new Promise()' needs a JSDoc hint to produce a 'resolve' that can be called without arguments."),
        Initializer_for_property_0: diag(2811, 1 /* Error */ , "Initializer_for_property_0_2811", "Initializer for property '{0}'"),
        Property_0_does_not_exist_on_type_1_Try_changing_the_lib_compiler_option_to_include_dom: diag(2812, 1 /* Error */ , "Property_0_does_not_exist_on_type_1_Try_changing_the_lib_compiler_option_to_include_dom_2812", "Property '{0}' does not exist on type '{1}'. Try changing the 'lib' compiler option to include 'dom'."),
        Class_declaration_cannot_implement_overload_list_for_0: diag(2813, 1 /* Error */ , "Class_declaration_cannot_implement_overload_list_for_0_2813", "Class declaration cannot implement overload list for '{0}'."),
        Function_with_bodies_can_only_merge_with_classes_that_are_ambient: diag(2814, 1 /* Error */ , "Function_with_bodies_can_only_merge_with_classes_that_are_ambient_2814", "Function with bodies can only merge with classes that are ambient."),
        arguments_cannot_be_referenced_in_property_initializers_or_class_static_initialization_blocks: diag(2815, 1 /* Error */ , "arguments_cannot_be_referenced_in_property_initializers_or_class_static_initialization_blocks_2815", "'arguments' cannot be referenced in property initializers or class static initialization blocks."),
        Cannot_use_this_in_a_static_property_initializer_of_a_decorated_class: diag(2816, 1 /* Error */ , "Cannot_use_this_in_a_static_property_initializer_of_a_decorated_class_2816", "Cannot use 'this' in a static property initializer of a decorated class."),
        Property_0_has_no_initializer_and_is_not_definitely_assigned_in_a_class_static_block: diag(2817, 1 /* Error */ , "Property_0_has_no_initializer_and_is_not_definitely_assigned_in_a_class_static_block_2817", "Property '{0}' has no initializer and is not definitely assigned in a class static block."),
        Duplicate_identifier_0_Compiler_reserves_name_1_when_emitting_super_references_in_static_initializers: diag(2818, 1 /* Error */ , "Duplicate_identifier_0_Compiler_reserves_name_1_when_emitting_super_references_in_static_initializer_2818", "Duplicate identifier '{0}'. Compiler reserves name '{1}' when emitting 'super' references in static initializers."),
        Namespace_name_cannot_be_0: diag(2819, 1 /* Error */ , "Namespace_name_cannot_be_0_2819", "Namespace name cannot be '{0}'."),
        Type_0_is_not_assignable_to_type_1_Did_you_mean_2: diag(2820, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_Did_you_mean_2_2820", "Type '{0}' is not assignable to type '{1}'. Did you mean '{2}'?"),
        Import_assertions_are_only_supported_when_the_module_option_is_set_to_esnext_node18_node20_nodenext_or_preserve: diag(2821, 1 /* Error */ , "Import_assertions_are_only_supported_when_the_module_option_is_set_to_esnext_node18_node20_nodenext__2821", "Import assertions are only supported when the '--module' option is set to 'esnext', 'node18', 'node20', 'nodenext', or 'preserve'."),
        Import_assertions_cannot_be_used_with_type_only_imports_or_exports: diag(2822, 1 /* Error */ , "Import_assertions_cannot_be_used_with_type_only_imports_or_exports_2822", "Import assertions cannot be used with type-only imports or exports."),
        Import_attributes_are_only_supported_when_the_module_option_is_set_to_esnext_node18_node20_nodenext_or_preserve: diag(2823, 1 /* Error */ , "Import_attributes_are_only_supported_when_the_module_option_is_set_to_esnext_node18_node20_nodenext__2823", "Import attributes are only supported when the '--module' option is set to 'esnext', 'node18', 'node20', 'nodenext', or 'preserve'."),
        Cannot_find_namespace_0_Did_you_mean_1: diag(2833, 1 /* Error */ , "Cannot_find_namespace_0_Did_you_mean_1_2833", "Cannot find namespace '{0}'. Did you mean '{1}'?"),
        Relative_import_paths_need_explicit_file_extensions_in_ECMAScript_imports_when_moduleResolution_is_node16_or_nodenext_Consider_adding_an_extension_to_the_import_path: diag(2834, 1 /* Error */ , "Relative_import_paths_need_explicit_file_extensions_in_ECMAScript_imports_when_moduleResolution_is_n_2834", "Relative import paths need explicit file extensions in ECMAScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Consider adding an extension to the import path."),
        Relative_import_paths_need_explicit_file_extensions_in_ECMAScript_imports_when_moduleResolution_is_node16_or_nodenext_Did_you_mean_0: diag(2835, 1 /* Error */ , "Relative_import_paths_need_explicit_file_extensions_in_ECMAScript_imports_when_moduleResolution_is_n_2835", "Relative import paths need explicit file extensions in ECMAScript imports when '--moduleResolution' is 'node16' or 'nodenext'. Did you mean '{0}'?"),
        Import_assertions_are_not_allowed_on_statements_that_compile_to_CommonJS_require_calls: diag(2836, 1 /* Error */ , "Import_assertions_are_not_allowed_on_statements_that_compile_to_CommonJS_require_calls_2836", "Import assertions are not allowed on statements that compile to CommonJS 'require' calls."),
        Import_assertion_values_must_be_string_literal_expressions: diag(2837, 1 /* Error */ , "Import_assertion_values_must_be_string_literal_expressions_2837", "Import assertion values must be string literal expressions."),
        All_declarations_of_0_must_have_identical_constraints: diag(2838, 1 /* Error */ , "All_declarations_of_0_must_have_identical_constraints_2838", "All declarations of '{0}' must have identical constraints."),
        This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value: diag(2839, 1 /* Error */ , "This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value_2839", "This condition will always return '{0}' since JavaScript compares objects by reference, not value."),
        An_interface_cannot_extend_a_primitive_type_like_0_It_can_only_extend_other_named_object_types: diag(2840, 1 /* Error */ , "An_interface_cannot_extend_a_primitive_type_like_0_It_can_only_extend_other_named_object_types_2840", "An interface cannot extend a primitive type like '{0}'. It can only extend other named object types."),
        _0_is_an_unused_renaming_of_1_Did_you_intend_to_use_it_as_a_type_annotation: diag(2842, 1 /* Error */ , "_0_is_an_unused_renaming_of_1_Did_you_intend_to_use_it_as_a_type_annotation_2842", "'{0}' is an unused renaming of '{1}'. Did you intend to use it as a type annotation?"),
        We_can_only_write_a_type_for_0_by_adding_a_type_for_the_entire_parameter_here: diag(2843, 1 /* Error */ , "We_can_only_write_a_type_for_0_by_adding_a_type_for_the_entire_parameter_here_2843", "We can only write a type for '{0}' by adding a type for the entire parameter here."),
        Type_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor: diag(2844, 1 /* Error */ , "Type_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor_2844", "Type of instance member variable '{0}' cannot reference identifier '{1}' declared in the constructor."),
        This_condition_will_always_return_0: diag(2845, 1 /* Error */ , "This_condition_will_always_return_0_2845", "This condition will always return '{0}'."),
        A_declaration_file_cannot_be_imported_without_import_type_Did_you_mean_to_import_an_implementation_file_0_instead: diag(2846, 1 /* Error */ , "A_declaration_file_cannot_be_imported_without_import_type_Did_you_mean_to_import_an_implementation_f_2846", "A declaration file cannot be imported without 'import type'. Did you mean to import an implementation file '{0}' instead?"),
        The_right_hand_side_of_an_instanceof_expression_must_not_be_an_instantiation_expression: diag(2848, 1 /* Error */ , "The_right_hand_side_of_an_instanceof_expression_must_not_be_an_instantiation_expression_2848", "The right-hand side of an 'instanceof' expression must not be an instantiation expression."),
        Target_signature_provides_too_few_arguments_Expected_0_or_more_but_got_1: diag(2849, 1 /* Error */ , "Target_signature_provides_too_few_arguments_Expected_0_or_more_but_got_1_2849", "Target signature provides too few arguments. Expected {0} or more, but got {1}."),
        The_initializer_of_a_using_declaration_must_be_either_an_object_with_a_Symbol_dispose_method_or_be_null_or_undefined: diag(2850, 1 /* Error */ , "The_initializer_of_a_using_declaration_must_be_either_an_object_with_a_Symbol_dispose_method_or_be_n_2850", "The initializer of a 'using' declaration must be either an object with a '[Symbol.dispose]()' method, or be 'null' or 'undefined'."),
        The_initializer_of_an_await_using_declaration_must_be_either_an_object_with_a_Symbol_asyncDispose_or_Symbol_dispose_method_or_be_null_or_undefined: diag(2851, 1 /* Error */ , "The_initializer_of_an_await_using_declaration_must_be_either_an_object_with_a_Symbol_asyncDispose_or_2851", "The initializer of an 'await using' declaration must be either an object with a '[Symbol.asyncDispose]()' or '[Symbol.dispose]()' method, or be 'null' or 'undefined'."),
        await_using_statements_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules: diag(2852, 1 /* Error */ , "await_using_statements_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules_2852", "'await using' statements are only allowed within async functions and at the top levels of modules."),
        await_using_statements_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module: diag(2853, 1 /* Error */ , "await_using_statements_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_th_2853", "'await using' statements are only allowed at the top level of a file when that file is a module, but this file has no imports or exports. Consider adding an empty 'export {}' to make this file a module."),
        Top_level_await_using_statements_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher: diag(2854, 1 /* Error */ , "Top_level_await_using_statements_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_sys_2854", "Top-level 'await using' statements are only allowed when the 'module' option is set to 'es2022', 'esnext', 'system', 'node16', 'node18', 'node20', 'nodenext', or 'preserve', and the 'target' option is set to 'es2017' or higher."),
        Class_field_0_defined_by_the_parent_class_is_not_accessible_in_the_child_class_via_super: diag(2855, 1 /* Error */ , "Class_field_0_defined_by_the_parent_class_is_not_accessible_in_the_child_class_via_super_2855", "Class field '{0}' defined by the parent class is not accessible in the child class via super."),
        Import_attributes_are_not_allowed_on_statements_that_compile_to_CommonJS_require_calls: diag(2856, 1 /* Error */ , "Import_attributes_are_not_allowed_on_statements_that_compile_to_CommonJS_require_calls_2856", "Import attributes are not allowed on statements that compile to CommonJS 'require' calls."),
        Import_attributes_cannot_be_used_with_type_only_imports_or_exports: diag(2857, 1 /* Error */ , "Import_attributes_cannot_be_used_with_type_only_imports_or_exports_2857", "Import attributes cannot be used with type-only imports or exports."),
        Import_attribute_values_must_be_string_literal_expressions: diag(2858, 1 /* Error */ , "Import_attribute_values_must_be_string_literal_expressions_2858", "Import attribute values must be string literal expressions."),
        Excessive_complexity_comparing_types_0_and_1: diag(2859, 1 /* Error */ , "Excessive_complexity_comparing_types_0_and_1_2859", "Excessive complexity comparing types '{0}' and '{1}'."),
        The_left_hand_side_of_an_instanceof_expression_must_be_assignable_to_the_first_argument_of_the_right_hand_side_s_Symbol_hasInstance_method: diag(2860, 1 /* Error */ , "The_left_hand_side_of_an_instanceof_expression_must_be_assignable_to_the_first_argument_of_the_right_2860", "The left-hand side of an 'instanceof' expression must be assignable to the first argument of the right-hand side's '[Symbol.hasInstance]' method."),
        An_object_s_Symbol_hasInstance_method_must_return_a_boolean_value_for_it_to_be_used_on_the_right_hand_side_of_an_instanceof_expression: diag(2861, 1 /* Error */ , "An_object_s_Symbol_hasInstance_method_must_return_a_boolean_value_for_it_to_be_used_on_the_right_han_2861", "An object's '[Symbol.hasInstance]' method must return a boolean value for it to be used on the right-hand side of an 'instanceof' expression."),
        Type_0_is_generic_and_can_only_be_indexed_for_reading: diag(2862, 1 /* Error */ , "Type_0_is_generic_and_can_only_be_indexed_for_reading_2862", "Type '{0}' is generic and can only be indexed for reading."),
        A_class_cannot_extend_a_primitive_type_like_0_Classes_can_only_extend_constructable_values: diag(2863, 1 /* Error */ , "A_class_cannot_extend_a_primitive_type_like_0_Classes_can_only_extend_constructable_values_2863", "A class cannot extend a primitive type like '{0}'. Classes can only extend constructable values."),
        A_class_cannot_implement_a_primitive_type_like_0_It_can_only_implement_other_named_object_types: diag(2864, 1 /* Error */ , "A_class_cannot_implement_a_primitive_type_like_0_It_can_only_implement_other_named_object_types_2864", "A class cannot implement a primitive type like '{0}'. It can only implement other named object types."),
        Import_0_conflicts_with_local_value_so_must_be_declared_with_a_type_only_import_when_isolatedModules_is_enabled: diag(2865, 1 /* Error */ , "Import_0_conflicts_with_local_value_so_must_be_declared_with_a_type_only_import_when_isolatedModules_2865", "Import '{0}' conflicts with local value, so must be declared with a type-only import when 'isolatedModules' is enabled."),
        Import_0_conflicts_with_global_value_used_in_this_file_so_must_be_declared_with_a_type_only_import_when_isolatedModules_is_enabled: diag(2866, 1 /* Error */ , "Import_0_conflicts_with_global_value_used_in_this_file_so_must_be_declared_with_a_type_only_import_w_2866", "Import '{0}' conflicts with global value used in this file, so must be declared with a type-only import when 'isolatedModules' is enabled."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_Bun_Try_npm_i_save_dev_types_Slashbun: diag(2867, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_Bun_Try_npm_i_save_dev_types_Slashbun_2867", "Cannot find name '{0}'. Do you need to install type definitions for Bun? Try `npm i --save-dev @types/bun`."),
        Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_Bun_Try_npm_i_save_dev_types_Slashbun_and_then_add_bun_to_the_types_field_in_your_tsconfig: diag(2868, 1 /* Error */ , "Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_Bun_Try_npm_i_save_dev_types_Slashbun_2868", "Cannot find name '{0}'. Do you need to install type definitions for Bun? Try `npm i --save-dev @types/bun` and then add 'bun' to the types field in your tsconfig."),
        Right_operand_of_is_unreachable_because_the_left_operand_is_never_nullish: diag(2869, 1 /* Error */ , "Right_operand_of_is_unreachable_because_the_left_operand_is_never_nullish_2869", "Right operand of ?? is unreachable because the left operand is never nullish."),
        This_binary_expression_is_never_nullish_Are_you_missing_parentheses: diag(2870, 1 /* Error */ , "This_binary_expression_is_never_nullish_Are_you_missing_parentheses_2870", "This binary expression is never nullish. Are you missing parentheses?"),
        This_expression_is_always_nullish: diag(2871, 1 /* Error */ , "This_expression_is_always_nullish_2871", "This expression is always nullish."),
        This_kind_of_expression_is_always_truthy: diag(2872, 1 /* Error */ , "This_kind_of_expression_is_always_truthy_2872", "This kind of expression is always truthy."),
        This_kind_of_expression_is_always_falsy: diag(2873, 1 /* Error */ , "This_kind_of_expression_is_always_falsy_2873", "This kind of expression is always falsy."),
        This_JSX_tag_requires_0_to_be_in_scope_but_it_could_not_be_found: diag(2874, 1 /* Error */ , "This_JSX_tag_requires_0_to_be_in_scope_but_it_could_not_be_found_2874", "This JSX tag requires '{0}' to be in scope, but it could not be found."),
        This_JSX_tag_requires_the_module_path_0_to_exist_but_none_could_be_found_Make_sure_you_have_types_for_the_appropriate_package_installed: diag(2875, 1 /* Error */ , "This_JSX_tag_requires_the_module_path_0_to_exist_but_none_could_be_found_Make_sure_you_have_types_fo_2875", "This JSX tag requires the module path '{0}' to exist, but none could be found. Make sure you have types for the appropriate package installed."),
        This_relative_import_path_is_unsafe_to_rewrite_because_it_looks_like_a_file_name_but_actually_resolves_to_0: diag(2876, 1 /* Error */ , "This_relative_import_path_is_unsafe_to_rewrite_because_it_looks_like_a_file_name_but_actually_resolv_2876", 'This relative import path is unsafe to rewrite because it looks like a file name, but actually resolves to "{0}".'),
        This_import_uses_a_0_extension_to_resolve_to_an_input_TypeScript_file_but_will_not_be_rewritten_during_emit_because_it_is_not_a_relative_path: diag(2877, 1 /* Error */ , "This_import_uses_a_0_extension_to_resolve_to_an_input_TypeScript_file_but_will_not_be_rewritten_duri_2877", "This import uses a '{0}' extension to resolve to an input TypeScript file, but will not be rewritten during emit because it is not a relative path."),
        This_import_path_is_unsafe_to_rewrite_because_it_resolves_to_another_project_and_the_relative_path_between_the_projects_output_files_is_not_the_same_as_the_relative_path_between_its_input_files: diag(2878, 1 /* Error */ , "This_import_path_is_unsafe_to_rewrite_because_it_resolves_to_another_project_and_the_relative_path_b_2878", "This import path is unsafe to rewrite because it resolves to another project, and the relative path between the projects' output files is not the same as the relative path between its input files."),
        Using_JSX_fragments_requires_fragment_factory_0_to_be_in_scope_but_it_could_not_be_found: diag(2879, 1 /* Error */ , "Using_JSX_fragments_requires_fragment_factory_0_to_be_in_scope_but_it_could_not_be_found_2879", "Using JSX fragments requires fragment factory '{0}' to be in scope, but it could not be found."),
        Import_assertions_have_been_replaced_by_import_attributes_Use_with_instead_of_assert: diag(2880, 1 /* Error */ , "Import_assertions_have_been_replaced_by_import_attributes_Use_with_instead_of_assert_2880", "Import assertions have been replaced by import attributes. Use 'with' instead of 'assert'."),
        This_expression_is_never_nullish: diag(2881, 1 /* Error */ , "This_expression_is_never_nullish_2881", "This expression is never nullish."),
        Import_declaration_0_is_using_private_name_1: diag(4e3, 1 /* Error */ , "Import_declaration_0_is_using_private_name_1_4000", "Import declaration '{0}' is using private name '{1}'."),
        Type_parameter_0_of_exported_class_has_or_is_using_private_name_1: diag(4002, 1 /* Error */ , "Type_parameter_0_of_exported_class_has_or_is_using_private_name_1_4002", "Type parameter '{0}' of exported class has or is using private name '{1}'."),
        Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1: diag(4004, 1 /* Error */ , "Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1_4004", "Type parameter '{0}' of exported interface has or is using private name '{1}'."),
        Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4006, 1 /* Error */ , "Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4006", "Type parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
        Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4008, 1 /* Error */ , "Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4008", "Type parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
        Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4010, 1 /* Error */ , "Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4010", "Type parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
        Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4012, 1 /* Error */ , "Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4012", "Type parameter '{0}' of public method from exported class has or is using private name '{1}'."),
        Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4014, 1 /* Error */ , "Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4014", "Type parameter '{0}' of method from exported interface has or is using private name '{1}'."),
        Type_parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4016, 1 /* Error */ , "Type_parameter_0_of_exported_function_has_or_is_using_private_name_1_4016", "Type parameter '{0}' of exported function has or is using private name '{1}'."),
        Implements_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4019, 1 /* Error */ , "Implements_clause_of_exported_class_0_has_or_is_using_private_name_1_4019", "Implements clause of exported class '{0}' has or is using private name '{1}'."),
        extends_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4020, 1 /* Error */ , "extends_clause_of_exported_class_0_has_or_is_using_private_name_1_4020", "'extends' clause of exported class '{0}' has or is using private name '{1}'."),
        extends_clause_of_exported_class_has_or_is_using_private_name_0: diag(4021, 1 /* Error */ , "extends_clause_of_exported_class_has_or_is_using_private_name_0_4021", "'extends' clause of exported class has or is using private name '{0}'."),
        extends_clause_of_exported_interface_0_has_or_is_using_private_name_1: diag(4022, 1 /* Error */ , "extends_clause_of_exported_interface_0_has_or_is_using_private_name_1_4022", "'extends' clause of exported interface '{0}' has or is using private name '{1}'."),
        Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4023, 1 /* Error */ , "Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4023", "Exported variable '{0}' has or is using name '{1}' from external module {2} but cannot be named."),
        Exported_variable_0_has_or_is_using_name_1_from_private_module_2: diag(4024, 1 /* Error */ , "Exported_variable_0_has_or_is_using_name_1_from_private_module_2_4024", "Exported variable '{0}' has or is using name '{1}' from private module '{2}'."),
        Exported_variable_0_has_or_is_using_private_name_1: diag(4025, 1 /* Error */ , "Exported_variable_0_has_or_is_using_private_name_1_4025", "Exported variable '{0}' has or is using private name '{1}'."),
        Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4026, 1 /* Error */ , "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot__4026", "Public static property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4027, 1 /* Error */ , "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4027", "Public static property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
        Public_static_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4028, 1 /* Error */ , "Public_static_property_0_of_exported_class_has_or_is_using_private_name_1_4028", "Public static property '{0}' of exported class has or is using private name '{1}'."),
        Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4029, 1 /* Error */ , "Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_name_4029", "Public property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4030, 1 /* Error */ , "Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4030", "Public property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
        Public_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4031, 1 /* Error */ , "Public_property_0_of_exported_class_has_or_is_using_private_name_1_4031", "Public property '{0}' of exported class has or is using private name '{1}'."),
        Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4032, 1 /* Error */ , "Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4032", "Property '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
        Property_0_of_exported_interface_has_or_is_using_private_name_1: diag(4033, 1 /* Error */ , "Property_0_of_exported_interface_has_or_is_using_private_name_1_4033", "Property '{0}' of exported interface has or is using private name '{1}'."),
        Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4034, 1 /* Error */ , "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_mod_4034", "Parameter type of public static setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
        Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4035, 1 /* Error */ , "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1_4035", "Parameter type of public static setter '{0}' from exported class has or is using private name '{1}'."),
        Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4036, 1 /* Error */ , "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4036", "Parameter type of public setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
        Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4037, 1 /* Error */ , "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1_4037", "Parameter type of public setter '{0}' from exported class has or is using private name '{1}'."),
        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4038, 1 /* Error */ , "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_modul_4038", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4039, 1 /* Error */ , "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_4039", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4040, 1 /* Error */ , "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1_4040", "Return type of public static getter '{0}' from exported class has or is using private name '{1}'."),
        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4041, 1 /* Error */ , "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_4041", "Return type of public getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4042, 1 /* Error */ , "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4042", "Return type of public getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4043, 1 /* Error */ , "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1_4043", "Return type of public getter '{0}' from exported class has or is using private name '{1}'."),
        Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4044, 1 /* Error */ , "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_mod_4044", "Return type of constructor signature from exported interface has or is using name '{0}' from private module '{1}'."),
        Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4045, 1 /* Error */ , "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0_4045", "Return type of constructor signature from exported interface has or is using private name '{0}'."),
        Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4046, 1 /* Error */ , "Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4046", "Return type of call signature from exported interface has or is using name '{0}' from private module '{1}'."),
        Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4047, 1 /* Error */ , "Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0_4047", "Return type of call signature from exported interface has or is using private name '{0}'."),
        Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4048, 1 /* Error */ , "Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4048", "Return type of index signature from exported interface has or is using name '{0}' from private module '{1}'."),
        Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4049, 1 /* Error */ , "Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0_4049", "Return type of index signature from exported interface has or is using private name '{0}'."),
        Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4050, 1 /* Error */ , "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module__4050", "Return type of public static method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
        Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4051, 1 /* Error */ , "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4051", "Return type of public static method from exported class has or is using name '{0}' from private module '{1}'."),
        Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0: diag(4052, 1 /* Error */ , "Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0_4052", "Return type of public static method from exported class has or is using private name '{0}'."),
        Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4053, 1 /* Error */ , "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_c_4053", "Return type of public method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
        Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4054, 1 /* Error */ , "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4054", "Return type of public method from exported class has or is using name '{0}' from private module '{1}'."),
        Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0: diag(4055, 1 /* Error */ , "Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0_4055", "Return type of public method from exported class has or is using private name '{0}'."),
        Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4056, 1 /* Error */ , "Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4056", "Return type of method from exported interface has or is using name '{0}' from private module '{1}'."),
        Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0: diag(4057, 1 /* Error */ , "Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0_4057", "Return type of method from exported interface has or is using private name '{0}'."),
        Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4058, 1 /* Error */ , "Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named_4058", "Return type of exported function has or is using name '{0}' from external module {1} but cannot be named."),
        Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1: diag(4059, 1 /* Error */ , "Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1_4059", "Return type of exported function has or is using name '{0}' from private module '{1}'."),
        Return_type_of_exported_function_has_or_is_using_private_name_0: diag(4060, 1 /* Error */ , "Return_type_of_exported_function_has_or_is_using_private_name_0_4060", "Return type of exported function has or is using private name '{0}'."),
        Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4061, 1 /* Error */ , "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_can_4061", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4062, 1 /* Error */ , "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2_4062", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1: diag(4063, 1 /* Error */ , "Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1_4063", "Parameter '{0}' of constructor from exported class has or is using private name '{1}'."),
        Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4064, 1 /* Error */ , "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_mod_4064", "Parameter '{0}' of constructor signature from exported interface has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4065, 1 /* Error */ , "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4065", "Parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
        Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4066, 1 /* Error */ , "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4066", "Parameter '{0}' of call signature from exported interface has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4067, 1 /* Error */ , "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4067", "Parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4068, 1 /* Error */ , "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module__4068", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4069, 1 /* Error */ , "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4069", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4070, 1 /* Error */ , "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4070", "Parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
        Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4071, 1 /* Error */ , "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_c_4071", "Parameter '{0}' of public method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4072, 1 /* Error */ , "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4072", "Parameter '{0}' of public method from exported class has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4073, 1 /* Error */ , "Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4073", "Parameter '{0}' of public method from exported class has or is using private name '{1}'."),
        Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4074, 1 /* Error */ , "Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4074", "Parameter '{0}' of method from exported interface has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4075, 1 /* Error */ , "Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4075", "Parameter '{0}' of method from exported interface has or is using private name '{1}'."),
        Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4076, 1 /* Error */ , "Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4076", "Parameter '{0}' of exported function has or is using name '{1}' from external module {2} but cannot be named."),
        Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2: diag(4077, 1 /* Error */ , "Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2_4077", "Parameter '{0}' of exported function has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4078, 1 /* Error */ , "Parameter_0_of_exported_function_has_or_is_using_private_name_1_4078", "Parameter '{0}' of exported function has or is using private name '{1}'."),
        Exported_type_alias_0_has_or_is_using_private_name_1: diag(4081, 1 /* Error */ , "Exported_type_alias_0_has_or_is_using_private_name_1_4081", "Exported type alias '{0}' has or is using private name '{1}'."),
        Default_export_of_the_module_has_or_is_using_private_name_0: diag(4082, 1 /* Error */ , "Default_export_of_the_module_has_or_is_using_private_name_0_4082", "Default export of the module has or is using private name '{0}'."),
        Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1: diag(4083, 1 /* Error */ , "Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1_4083", "Type parameter '{0}' of exported type alias has or is using private name '{1}'."),
        Exported_type_alias_0_has_or_is_using_private_name_1_from_module_2: diag(4084, 1 /* Error */ , "Exported_type_alias_0_has_or_is_using_private_name_1_from_module_2_4084", "Exported type alias '{0}' has or is using private name '{1}' from module {2}."),
        Extends_clause_for_inferred_type_0_has_or_is_using_private_name_1: diag(4085, 1 /* Error */ , "Extends_clause_for_inferred_type_0_has_or_is_using_private_name_1_4085", "Extends clause for inferred type '{0}' has or is using private name '{1}'."),
        Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4091, 1 /* Error */ , "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4091", "Parameter '{0}' of index signature from exported interface has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4092, 1 /* Error */ , "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1_4092", "Parameter '{0}' of index signature from exported interface has or is using private name '{1}'."),
        Property_0_of_exported_anonymous_class_type_may_not_be_private_or_protected: diag(4094, 1 /* Error */ , "Property_0_of_exported_anonymous_class_type_may_not_be_private_or_protected_4094", "Property '{0}' of exported anonymous class type may not be private or protected."),
        Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4095, 1 /* Error */ , "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_4095", "Public static method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4096, 1 /* Error */ , "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4096", "Public static method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
        Public_static_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4097, 1 /* Error */ , "Public_static_method_0_of_exported_class_has_or_is_using_private_name_1_4097", "Public static method '{0}' of exported class has or is using private name '{1}'."),
        Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4098, 1 /* Error */ , "Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4098", "Public method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
        Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4099, 1 /* Error */ , "Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4099", "Public method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
        Public_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4100, 1 /* Error */ , "Public_method_0_of_exported_class_has_or_is_using_private_name_1_4100", "Public method '{0}' of exported class has or is using private name '{1}'."),
        Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4101, 1 /* Error */ , "Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4101", "Method '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
        Method_0_of_exported_interface_has_or_is_using_private_name_1: diag(4102, 1 /* Error */ , "Method_0_of_exported_interface_has_or_is_using_private_name_1_4102", "Method '{0}' of exported interface has or is using private name '{1}'."),
        Type_parameter_0_of_exported_mapped_object_type_is_using_private_name_1: diag(4103, 1 /* Error */ , "Type_parameter_0_of_exported_mapped_object_type_is_using_private_name_1_4103", "Type parameter '{0}' of exported mapped object type is using private name '{1}'."),
        The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1: diag(4104, 1 /* Error */ , "The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1_4104", "The type '{0}' is 'readonly' and cannot be assigned to the mutable type '{1}'."),
        Private_or_protected_member_0_cannot_be_accessed_on_a_type_parameter: diag(4105, 1 /* Error */ , "Private_or_protected_member_0_cannot_be_accessed_on_a_type_parameter_4105", "Private or protected member '{0}' cannot be accessed on a type parameter."),
        Parameter_0_of_accessor_has_or_is_using_private_name_1: diag(4106, 1 /* Error */ , "Parameter_0_of_accessor_has_or_is_using_private_name_1_4106", "Parameter '{0}' of accessor has or is using private name '{1}'."),
        Parameter_0_of_accessor_has_or_is_using_name_1_from_private_module_2: diag(4107, 1 /* Error */ , "Parameter_0_of_accessor_has_or_is_using_name_1_from_private_module_2_4107", "Parameter '{0}' of accessor has or is using name '{1}' from private module '{2}'."),
        Parameter_0_of_accessor_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4108, 1 /* Error */ , "Parameter_0_of_accessor_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4108", "Parameter '{0}' of accessor has or is using name '{1}' from external module '{2}' but cannot be named."),
        Type_arguments_for_0_circularly_reference_themselves: diag(4109, 1 /* Error */ , "Type_arguments_for_0_circularly_reference_themselves_4109", "Type arguments for '{0}' circularly reference themselves."),
        Tuple_type_arguments_circularly_reference_themselves: diag(4110, 1 /* Error */ , "Tuple_type_arguments_circularly_reference_themselves_4110", "Tuple type arguments circularly reference themselves."),
        Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0: diag(4111, 1 /* Error */ , "Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0_4111", "Property '{0}' comes from an index signature, so it must be accessed with ['{0}']."),
        This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class: diag(4112, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another__4112", "This member cannot have an 'override' modifier because its containing class '{0}' does not extend another class."),
        This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0: diag(4113, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_4113", "This member cannot have an 'override' modifier because it is not declared in the base class '{0}'."),
        This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0: diag(4114, 1 /* Error */ , "This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0_4114", "This member must have an 'override' modifier because it overrides a member in the base class '{0}'."),
        This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0: diag(4115, 1 /* Error */ , "This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0_4115", "This parameter property must have an 'override' modifier because it overrides a member in base class '{0}'."),
        This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0: diag(4116, 1 /* Error */ , "This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared__4116", "This member must have an 'override' modifier because it overrides an abstract method that is declared in the base class '{0}'."),
        This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1: diag(4117, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you__4117", "This member cannot have an 'override' modifier because it is not declared in the base class '{0}'. Did you mean '{1}'?"),
        The_type_of_this_node_cannot_be_serialized_because_its_property_0_cannot_be_serialized: diag(4118, 1 /* Error */ , "The_type_of_this_node_cannot_be_serialized_because_its_property_0_cannot_be_serialized_4118", "The type of this node cannot be serialized because its property '{0}' cannot be serialized."),
        This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0: diag(4119, 1 /* Error */ , "This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_4119", "This member must have a JSDoc comment with an '@override' tag because it overrides a member in the base class '{0}'."),
        This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0: diag(4120, 1 /* Error */ , "This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_4120", "This parameter property must have a JSDoc comment with an '@override' tag because it overrides a member in the base class '{0}'."),
        This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class: diag(4121, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_4121", "This member cannot have a JSDoc comment with an '@override' tag because its containing class '{0}' does not extend another class."),
        This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0: diag(4122, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base__4122", "This member cannot have a JSDoc comment with an '@override' tag because it is not declared in the base class '{0}'."),
        This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1: diag(4123, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base__4123", "This member cannot have a JSDoc comment with an 'override' tag because it is not declared in the base class '{0}'. Did you mean '{1}'?"),
        Compiler_option_0_of_value_1_is_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_with_npm_install_D_typescript_next: diag(4124, 1 /* Error */ , "Compiler_option_0_of_value_1_is_unstable_Use_nightly_TypeScript_to_silence_this_error_Try_updating_w_4124", "Compiler option '{0}' of value '{1}' is unstable. Use nightly TypeScript to silence this error. Try updating with 'npm install -D typescript@next'."),
        Each_declaration_of_0_1_differs_in_its_value_where_2_was_expected_but_3_was_given: diag(4125, 1 /* Error */ , "Each_declaration_of_0_1_differs_in_its_value_where_2_was_expected_but_3_was_given_4125", "Each declaration of '{0}.{1}' differs in its value, where '{2}' was expected but '{3}' was given."),
        One_value_of_0_1_is_the_string_2_and_the_other_is_assumed_to_be_an_unknown_numeric_value: diag(4126, 1 /* Error */ , "One_value_of_0_1_is_the_string_2_and_the_other_is_assumed_to_be_an_unknown_numeric_value_4126", "One value of '{0}.{1}' is the string '{2}', and the other is assumed to be an unknown numeric value."),
        This_member_cannot_have_an_override_modifier_because_its_name_is_dynamic: diag(4127, 1 /* Error */ , "This_member_cannot_have_an_override_modifier_because_its_name_is_dynamic_4127", "This member cannot have an 'override' modifier because its name is dynamic."),
        This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_name_is_dynamic: diag(4128, 1 /* Error */ , "This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_name_is_dynamic_4128", "This member cannot have a JSDoc comment with an '@override' tag because its name is dynamic."),
        The_current_host_does_not_support_the_0_option: diag(5001, 1 /* Error */ , "The_current_host_does_not_support_the_0_option_5001", "The current host does not support the '{0}' option."),
        Cannot_find_the_common_subdirectory_path_for_the_input_files: diag(5009, 1 /* Error */ , "Cannot_find_the_common_subdirectory_path_for_the_input_files_5009", "Cannot find the common subdirectory path for the input files."),
        File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5010, 1 /* Error */ , "File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0_5010", "File specification cannot end in a recursive directory wildcard ('**'): '{0}'."),
        Cannot_read_file_0_Colon_1: diag(5012, 1 /* Error */ , "Cannot_read_file_0_Colon_1_5012", "Cannot read file '{0}': {1}."),
        Unknown_compiler_option_0: diag(5023, 1 /* Error */ , "Unknown_compiler_option_0_5023", "Unknown compiler option '{0}'."),
        Compiler_option_0_requires_a_value_of_type_1: diag(5024, 1 /* Error */ , "Compiler_option_0_requires_a_value_of_type_1_5024", "Compiler option '{0}' requires a value of type {1}."),
        Unknown_compiler_option_0_Did_you_mean_1: diag(5025, 1 /* Error */ , "Unknown_compiler_option_0_Did_you_mean_1_5025", "Unknown compiler option '{0}'. Did you mean '{1}'?"),
        Could_not_write_file_0_Colon_1: diag(5033, 1 /* Error */ , "Could_not_write_file_0_Colon_1_5033", "Could not write file '{0}': {1}."),
        Option_project_cannot_be_mixed_with_source_files_on_a_command_line: diag(5042, 1 /* Error */ , "Option_project_cannot_be_mixed_with_source_files_on_a_command_line_5042", "Option 'project' cannot be mixed with source files on a command line."),
        Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher: diag(5047, 1 /* Error */ , "Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES_5047", "Option 'isolatedModules' can only be used when either option '--module' is provided or option 'target' is 'ES2015' or higher."),
        Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided: diag(5051, 1 /* Error */ , "Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided_5051", "Option '{0} can only be used when either option '--inlineSourceMap' or option '--sourceMap' is provided."),
        Option_0_cannot_be_specified_without_specifying_option_1: diag(5052, 1 /* Error */ , "Option_0_cannot_be_specified_without_specifying_option_1_5052", "Option '{0}' cannot be specified without specifying option '{1}'."),
        Option_0_cannot_be_specified_with_option_1: diag(5053, 1 /* Error */ , "Option_0_cannot_be_specified_with_option_1_5053", "Option '{0}' cannot be specified with option '{1}'."),
        A_tsconfig_json_file_is_already_defined_at_Colon_0: diag(5054, 1 /* Error */ , "A_tsconfig_json_file_is_already_defined_at_Colon_0_5054", "A 'tsconfig.json' file is already defined at: '{0}'."),
        Cannot_write_file_0_because_it_would_overwrite_input_file: diag(5055, 1 /* Error */ , "Cannot_write_file_0_because_it_would_overwrite_input_file_5055", "Cannot write file '{0}' because it would overwrite input file."),
        Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files: diag(5056, 1 /* Error */ , "Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files_5056", "Cannot write file '{0}' because it would be overwritten by multiple input files."),
        Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0: diag(5057, 1 /* Error */ , "Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0_5057", "Cannot find a tsconfig.json file at the specified directory: '{0}'."),
        The_specified_path_does_not_exist_Colon_0: diag(5058, 1 /* Error */ , "The_specified_path_does_not_exist_Colon_0_5058", "The specified path does not exist: '{0}'."),
        Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier: diag(5059, 1 /* Error */ , "Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier_5059", "Invalid value for '--reactNamespace'. '{0}' is not a valid identifier."),
        Pattern_0_can_have_at_most_one_Asterisk_character: diag(5061, 1 /* Error */ , "Pattern_0_can_have_at_most_one_Asterisk_character_5061", "Pattern '{0}' can have at most one '*' character."),
        Substitution_0_in_pattern_1_can_have_at_most_one_Asterisk_character: diag(5062, 1 /* Error */ , "Substitution_0_in_pattern_1_can_have_at_most_one_Asterisk_character_5062", "Substitution '{0}' in pattern '{1}' can have at most one '*' character."),
        Substitutions_for_pattern_0_should_be_an_array: diag(5063, 1 /* Error */ , "Substitutions_for_pattern_0_should_be_an_array_5063", "Substitutions for pattern '{0}' should be an array."),
        Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2: diag(5064, 1 /* Error */ , "Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2_5064", "Substitution '{0}' for pattern '{1}' has incorrect type, expected 'string', got '{2}'."),
        File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5065, 1 /* Error */ , "File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildca_5065", "File specification cannot contain a parent directory ('..') that appears after a recursive directory wildcard ('**'): '{0}'."),
        Substitutions_for_pattern_0_shouldn_t_be_an_empty_array: diag(5066, 1 /* Error */ , "Substitutions_for_pattern_0_shouldn_t_be_an_empty_array_5066", "Substitutions for pattern '{0}' shouldn't be an empty array."),
        Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name: diag(5067, 1 /* Error */ , "Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name_5067", "Invalid value for 'jsxFactory'. '{0}' is not a valid identifier or qualified-name."),
        Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig: diag(5068, 1 /* Error */ , "Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript__5068", "Adding a tsconfig.json file will help organize projects that contain both TypeScript and JavaScript files. Learn more at https://aka.ms/tsconfig."),
        Option_0_cannot_be_specified_without_specifying_option_1_or_option_2: diag(5069, 1 /* Error */ , "Option_0_cannot_be_specified_without_specifying_option_1_or_option_2_5069", "Option '{0}' cannot be specified without specifying option '{1}' or option '{2}'."),
        Option_resolveJsonModule_cannot_be_specified_when_moduleResolution_is_set_to_classic: diag(5070, 1 /* Error */ , "Option_resolveJsonModule_cannot_be_specified_when_moduleResolution_is_set_to_classic_5070", "Option '--resolveJsonModule' cannot be specified when 'moduleResolution' is set to 'classic'."),
        Option_resolveJsonModule_cannot_be_specified_when_module_is_set_to_none_system_or_umd: diag(5071, 1 /* Error */ , "Option_resolveJsonModule_cannot_be_specified_when_module_is_set_to_none_system_or_umd_5071", "Option '--resolveJsonModule' cannot be specified when 'module' is set to 'none', 'system', or 'umd'."),
        Unknown_build_option_0: diag(5072, 1 /* Error */ , "Unknown_build_option_0_5072", "Unknown build option '{0}'."),
        Build_option_0_requires_a_value_of_type_1: diag(5073, 1 /* Error */ , "Build_option_0_requires_a_value_of_type_1_5073", "Build option '{0}' requires a value of type {1}."),
        Option_incremental_can_only_be_specified_using_tsconfig_emitting_to_single_file_or_when_option_tsBuildInfoFile_is_specified: diag(5074, 1 /* Error */ , "Option_incremental_can_only_be_specified_using_tsconfig_emitting_to_single_file_or_when_option_tsBui_5074", "Option '--incremental' can only be specified using tsconfig, emitting to single file or when option '--tsBuildInfoFile' is specified."),
        _0_is_assignable_to_the_constraint_of_type_1_but_1_could_be_instantiated_with_a_different_subtype_of_constraint_2: diag(5075, 1 /* Error */ , "_0_is_assignable_to_the_constraint_of_type_1_but_1_could_be_instantiated_with_a_different_subtype_of_5075", "'{0}' is assignable to the constraint of type '{1}', but '{1}' could be instantiated with a different subtype of constraint '{2}'."),
        _0_and_1_operations_cannot_be_mixed_without_parentheses: diag(5076, 1 /* Error */ , "_0_and_1_operations_cannot_be_mixed_without_parentheses_5076", "'{0}' and '{1}' operations cannot be mixed without parentheses."),
        Unknown_build_option_0_Did_you_mean_1: diag(5077, 1 /* Error */ , "Unknown_build_option_0_Did_you_mean_1_5077", "Unknown build option '{0}'. Did you mean '{1}'?"),
        Unknown_watch_option_0: diag(5078, 1 /* Error */ , "Unknown_watch_option_0_5078", "Unknown watch option '{0}'."),
        Unknown_watch_option_0_Did_you_mean_1: diag(5079, 1 /* Error */ , "Unknown_watch_option_0_Did_you_mean_1_5079", "Unknown watch option '{0}'. Did you mean '{1}'?"),
        Watch_option_0_requires_a_value_of_type_1: diag(5080, 1 /* Error */ , "Watch_option_0_requires_a_value_of_type_1_5080", "Watch option '{0}' requires a value of type {1}."),
        Cannot_find_a_tsconfig_json_file_at_the_current_directory_Colon_0: diag(5081, 1 /* Error */ , "Cannot_find_a_tsconfig_json_file_at_the_current_directory_Colon_0_5081", "Cannot find a tsconfig.json file at the current directory: {0}."),
        _0_could_be_instantiated_with_an_arbitrary_type_which_could_be_unrelated_to_1: diag(5082, 1 /* Error */ , "_0_could_be_instantiated_with_an_arbitrary_type_which_could_be_unrelated_to_1_5082", "'{0}' could be instantiated with an arbitrary type which could be unrelated to '{1}'."),
        Cannot_read_file_0: diag(5083, 1 /* Error */ , "Cannot_read_file_0_5083", "Cannot read file '{0}'."),
        A_tuple_member_cannot_be_both_optional_and_rest: diag(5085, 1 /* Error */ , "A_tuple_member_cannot_be_both_optional_and_rest_5085", "A tuple member cannot be both optional and rest."),
        A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_colon_rather_than_after_the_type: diag(5086, 1 /* Error */ , "A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_c_5086", "A labeled tuple element is declared as optional with a question mark after the name and before the colon, rather than after the type."),
        A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type: diag(5087, 1 /* Error */ , "A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type_5087", "A labeled tuple element is declared as rest with a '...' before the name, rather than before the type."),
        The_inferred_type_of_0_references_a_type_with_a_cyclic_structure_which_cannot_be_trivially_serialized_A_type_annotation_is_necessary: diag(5088, 1 /* Error */ , "The_inferred_type_of_0_references_a_type_with_a_cyclic_structure_which_cannot_be_trivially_serialize_5088", "The inferred type of '{0}' references a type with a cyclic structure which cannot be trivially serialized. A type annotation is necessary."),
        Option_0_cannot_be_specified_when_option_jsx_is_1: diag(5089, 1 /* Error */ , "Option_0_cannot_be_specified_when_option_jsx_is_1_5089", "Option '{0}' cannot be specified when option 'jsx' is '{1}'."),
        Non_relative_paths_are_not_allowed_when_baseUrl_is_not_set_Did_you_forget_a_leading_Slash: diag(5090, 1 /* Error */ , "Non_relative_paths_are_not_allowed_when_baseUrl_is_not_set_Did_you_forget_a_leading_Slash_5090", "Non-relative paths are not allowed when 'baseUrl' is not set. Did you forget a leading './'?"),
        Option_preserveConstEnums_cannot_be_disabled_when_0_is_enabled: diag(5091, 1 /* Error */ , "Option_preserveConstEnums_cannot_be_disabled_when_0_is_enabled_5091", "Option 'preserveConstEnums' cannot be disabled when '{0}' is enabled."),
        The_root_value_of_a_0_file_must_be_an_object: diag(5092, 1 /* Error */ , "The_root_value_of_a_0_file_must_be_an_object_5092", "The root value of a '{0}' file must be an object."),
        Compiler_option_0_may_only_be_used_with_build: diag(5093, 1 /* Error */ , "Compiler_option_0_may_only_be_used_with_build_5093", "Compiler option '--{0}' may only be used with '--build'."),
        Compiler_option_0_may_not_be_used_with_build: diag(5094, 1 /* Error */ , "Compiler_option_0_may_not_be_used_with_build_5094", "Compiler option '--{0}' may not be used with '--build'."),
        Option_0_can_only_be_used_when_module_is_set_to_preserve_or_to_es2015_or_later: diag(5095, 1 /* Error */ , "Option_0_can_only_be_used_when_module_is_set_to_preserve_or_to_es2015_or_later_5095", "Option '{0}' can only be used when 'module' is set to 'preserve' or to 'es2015' or later."),
        Option_allowImportingTsExtensions_can_only_be_used_when_either_noEmit_or_emitDeclarationOnly_is_set: diag(5096, 1 /* Error */ , "Option_allowImportingTsExtensions_can_only_be_used_when_either_noEmit_or_emitDeclarationOnly_is_set_5096", "Option 'allowImportingTsExtensions' can only be used when either 'noEmit' or 'emitDeclarationOnly' is set."),
        An_import_path_can_only_end_with_a_0_extension_when_allowImportingTsExtensions_is_enabled: diag(5097, 1 /* Error */ , "An_import_path_can_only_end_with_a_0_extension_when_allowImportingTsExtensions_is_enabled_5097", "An import path can only end with a '{0}' extension when 'allowImportingTsExtensions' is enabled."),
        Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler: diag(5098, 1 /* Error */ , "Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler_5098", "Option '{0}' can only be used when 'moduleResolution' is set to 'node16', 'nodenext', or 'bundler'."),
        Option_0_is_deprecated_and_will_stop_functioning_in_TypeScript_1_Specify_compilerOption_ignoreDeprecations_Colon_2_to_silence_this_error: diag(5101, 1 /* Error */ , "Option_0_is_deprecated_and_will_stop_functioning_in_TypeScript_1_Specify_compilerOption_ignoreDeprec_5101", `Option '{0}' is deprecated and will stop functioning in TypeScript {1}. Specify compilerOption '"ignoreDeprecations": "{2}"' to silence this error.`),
        Option_0_has_been_removed_Please_remove_it_from_your_configuration: diag(5102, 1 /* Error */ , "Option_0_has_been_removed_Please_remove_it_from_your_configuration_5102", "Option '{0}' has been removed. Please remove it from your configuration."),
        Invalid_value_for_ignoreDeprecations: diag(5103, 1 /* Error */ , "Invalid_value_for_ignoreDeprecations_5103", "Invalid value for '--ignoreDeprecations'."),
        Option_0_is_redundant_and_cannot_be_specified_with_option_1: diag(5104, 1 /* Error */ , "Option_0_is_redundant_and_cannot_be_specified_with_option_1_5104", "Option '{0}' is redundant and cannot be specified with option '{1}'."),
        Option_verbatimModuleSyntax_cannot_be_used_when_module_is_set_to_UMD_AMD_or_System: diag(5105, 1 /* Error */ , "Option_verbatimModuleSyntax_cannot_be_used_when_module_is_set_to_UMD_AMD_or_System_5105", "Option 'verbatimModuleSyntax' cannot be used when 'module' is set to 'UMD', 'AMD', or 'System'."),
        Use_0_instead: diag(5106, 3 /* Message */ , "Use_0_instead_5106", "Use '{0}' instead."),
        Option_0_1_is_deprecated_and_will_stop_functioning_in_TypeScript_2_Specify_compilerOption_ignoreDeprecations_Colon_3_to_silence_this_error: diag(5107, 1 /* Error */ , "Option_0_1_is_deprecated_and_will_stop_functioning_in_TypeScript_2_Specify_compilerOption_ignoreDepr_5107", `Option '{0}={1}' is deprecated and will stop functioning in TypeScript {2}. Specify compilerOption '"ignoreDeprecations": "{3}"' to silence this error.`),
        Option_0_1_has_been_removed_Please_remove_it_from_your_configuration: diag(5108, 1 /* Error */ , "Option_0_1_has_been_removed_Please_remove_it_from_your_configuration_5108", "Option '{0}={1}' has been removed. Please remove it from your configuration."),
        Option_moduleResolution_must_be_set_to_0_or_left_unspecified_when_option_module_is_set_to_1: diag(5109, 1 /* Error */ , "Option_moduleResolution_must_be_set_to_0_or_left_unspecified_when_option_module_is_set_to_1_5109", "Option 'moduleResolution' must be set to '{0}' (or left unspecified) when option 'module' is set to '{1}'."),
        Option_module_must_be_set_to_0_when_option_moduleResolution_is_set_to_1: diag(5110, 1 /* Error */ , "Option_module_must_be_set_to_0_when_option_moduleResolution_is_set_to_1_5110", "Option 'module' must be set to '{0}' when option 'moduleResolution' is set to '{1}'."),
        Generates_a_sourcemap_for_each_corresponding_d_ts_file: diag(6e3, 3 /* Message */ , "Generates_a_sourcemap_for_each_corresponding_d_ts_file_6000", "Generates a sourcemap for each corresponding '.d.ts' file."),
        Concatenate_and_emit_output_to_single_file: diag(6001, 3 /* Message */ , "Concatenate_and_emit_output_to_single_file_6001", "Concatenate and emit output to single file."),
        Generates_corresponding_d_ts_file: diag(6002, 3 /* Message */ , "Generates_corresponding_d_ts_file_6002", "Generates corresponding '.d.ts' file."),
        Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations: diag(6004, 3 /* Message */ , "Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations_6004", "Specify the location where debugger should locate TypeScript files instead of source locations."),
        Watch_input_files: diag(6005, 3 /* Message */ , "Watch_input_files_6005", "Watch input files."),
        Redirect_output_structure_to_the_directory: diag(6006, 3 /* Message */ , "Redirect_output_structure_to_the_directory_6006", "Redirect output structure to the directory."),
        Do_not_erase_const_enum_declarations_in_generated_code: diag(6007, 3 /* Message */ , "Do_not_erase_const_enum_declarations_in_generated_code_6007", "Do not erase const enum declarations in generated code."),
        Do_not_emit_outputs_if_any_errors_were_reported: diag(6008, 3 /* Message */ , "Do_not_emit_outputs_if_any_errors_were_reported_6008", "Do not emit outputs if any errors were reported."),
        Do_not_emit_comments_to_output: diag(6009, 3 /* Message */ , "Do_not_emit_comments_to_output_6009", "Do not emit comments to output."),
        Do_not_emit_outputs: diag(6010, 3 /* Message */ , "Do_not_emit_outputs_6010", "Do not emit outputs."),
        Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typechecking: diag(6011, 3 /* Message */ , "Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typech_6011", "Allow default imports from modules with no default export. This does not affect code emit, just typechecking."),
        Skip_type_checking_of_declaration_files: diag(6012, 3 /* Message */ , "Skip_type_checking_of_declaration_files_6012", "Skip type checking of declaration files."),
        Do_not_resolve_the_real_path_of_symlinks: diag(6013, 3 /* Message */ , "Do_not_resolve_the_real_path_of_symlinks_6013", "Do not resolve the real path of symlinks."),
        Only_emit_d_ts_declaration_files: diag(6014, 3 /* Message */ , "Only_emit_d_ts_declaration_files_6014", "Only emit '.d.ts' declaration files."),
        Specify_ECMAScript_target_version: diag(6015, 3 /* Message */ , "Specify_ECMAScript_target_version_6015", "Specify ECMAScript target version."),
        Specify_module_code_generation: diag(6016, 3 /* Message */ , "Specify_module_code_generation_6016", "Specify module code generation."),
        Print_this_message: diag(6017, 3 /* Message */ , "Print_this_message_6017", "Print this message."),
        Print_the_compiler_s_version: diag(6019, 3 /* Message */ , "Print_the_compiler_s_version_6019", "Print the compiler's version."),
        Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json: diag(6020, 3 /* Message */ , "Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json_6020", "Compile the project given the path to its configuration file, or to a folder with a 'tsconfig.json'."),
        Syntax_Colon_0: diag(6023, 3 /* Message */ , "Syntax_Colon_0_6023", "Syntax: {0}"),
        options: diag(6024, 3 /* Message */ , "options_6024", "options"),
        file: diag(6025, 3 /* Message */ , "file_6025", "file"),
        Examples_Colon_0: diag(6026, 3 /* Message */ , "Examples_Colon_0_6026", "Examples: {0}"),
        Options_Colon: diag(6027, 3 /* Message */ , "Options_Colon_6027", "Options:"),
        Version_0: diag(6029, 3 /* Message */ , "Version_0_6029", "Version {0}"),
        Insert_command_line_options_and_files_from_a_file: diag(6030, 3 /* Message */ , "Insert_command_line_options_and_files_from_a_file_6030", "Insert command line options and files from a file."),
        Starting_compilation_in_watch_mode: diag(6031, 3 /* Message */ , "Starting_compilation_in_watch_mode_6031", "Starting compilation in watch mode..."),
        File_change_detected_Starting_incremental_compilation: diag(6032, 3 /* Message */ , "File_change_detected_Starting_incremental_compilation_6032", "File change detected. Starting incremental compilation..."),
        KIND: diag(6034, 3 /* Message */ , "KIND_6034", "KIND"),
        FILE: diag(6035, 3 /* Message */ , "FILE_6035", "FILE"),
        VERSION: diag(6036, 3 /* Message */ , "VERSION_6036", "VERSION"),
        LOCATION: diag(6037, 3 /* Message */ , "LOCATION_6037", "LOCATION"),
        DIRECTORY: diag(6038, 3 /* Message */ , "DIRECTORY_6038", "DIRECTORY"),
        STRATEGY: diag(6039, 3 /* Message */ , "STRATEGY_6039", "STRATEGY"),
        FILE_OR_DIRECTORY: diag(6040, 3 /* Message */ , "FILE_OR_DIRECTORY_6040", "FILE OR DIRECTORY"),
        Errors_Files: diag(6041, 3 /* Message */ , "Errors_Files_6041", "Errors  Files"),
        Generates_corresponding_map_file: diag(6043, 3 /* Message */ , "Generates_corresponding_map_file_6043", "Generates corresponding '.map' file."),
        Compiler_option_0_expects_an_argument: diag(6044, 1 /* Error */ , "Compiler_option_0_expects_an_argument_6044", "Compiler option '{0}' expects an argument."),
        Unterminated_quoted_string_in_response_file_0: diag(6045, 1 /* Error */ , "Unterminated_quoted_string_in_response_file_0_6045", "Unterminated quoted string in response file '{0}'."),
        Argument_for_0_option_must_be_Colon_1: diag(6046, 1 /* Error */ , "Argument_for_0_option_must_be_Colon_1_6046", "Argument for '{0}' option must be: {1}."),
        Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1: diag(6048, 1 /* Error */ , "Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1_6048", "Locale must be of the form <language> or <language>-<territory>. For example '{0}' or '{1}'."),
        Unable_to_open_file_0: diag(6050, 1 /* Error */ , "Unable_to_open_file_0_6050", "Unable to open file '{0}'."),
        Corrupted_locale_file_0: diag(6051, 1 /* Error */ , "Corrupted_locale_file_0_6051", "Corrupted locale file {0}."),
        Raise_error_on_expressions_and_declarations_with_an_implied_any_type: diag(6052, 3 /* Message */ , "Raise_error_on_expressions_and_declarations_with_an_implied_any_type_6052", "Raise error on expressions and declarations with an implied 'any' type."),
        File_0_not_found: diag(6053, 1 /* Error */ , "File_0_not_found_6053", "File '{0}' not found."),
        File_0_has_an_unsupported_extension_The_only_supported_extensions_are_1: diag(6054, 1 /* Error */ , "File_0_has_an_unsupported_extension_The_only_supported_extensions_are_1_6054", "File '{0}' has an unsupported extension. The only supported extensions are {1}."),
        Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures: diag(6055, 3 /* Message */ , "Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures_6055", "Suppress noImplicitAny errors for indexing objects lacking index signatures."),
        Do_not_emit_declarations_for_code_that_has_an_internal_annotation: diag(6056, 3 /* Message */ , "Do_not_emit_declarations_for_code_that_has_an_internal_annotation_6056", "Do not emit declarations for code that has an '@internal' annotation."),
        Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir: diag(6058, 3 /* Message */ , "Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir_6058", "Specify the root directory of input files. Use to control the output directory structure with --outDir."),
        File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files: diag(6059, 1 /* Error */ , "File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files_6059", "File '{0}' is not under 'rootDir' '{1}'. 'rootDir' is expected to contain all source files."),
        Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix: diag(6060, 3 /* Message */ , "Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix_6060", "Specify the end of line sequence to be used when emitting files: 'CRLF' (dos) or 'LF' (unix)."),
        NEWLINE: diag(6061, 3 /* Message */ , "NEWLINE_6061", "NEWLINE"),
        Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_null_on_command_line: diag(6064, 1 /* Error */ , "Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_null_on_command_line_6064", "Option '{0}' can only be specified in 'tsconfig.json' file or set to 'null' on command line."),
        Enables_experimental_support_for_ES7_decorators: diag(6065, 3 /* Message */ , "Enables_experimental_support_for_ES7_decorators_6065", "Enables experimental support for ES7 decorators."),
        Enables_experimental_support_for_emitting_type_metadata_for_decorators: diag(6066, 3 /* Message */ , "Enables_experimental_support_for_emitting_type_metadata_for_decorators_6066", "Enables experimental support for emitting type metadata for decorators."),
        Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file: diag(6070, 3 /* Message */ , "Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file_6070", "Initializes a TypeScript project and creates a tsconfig.json file."),
        Successfully_created_a_tsconfig_json_file: diag(6071, 3 /* Message */ , "Successfully_created_a_tsconfig_json_file_6071", "Successfully created a tsconfig.json file."),
        Suppress_excess_property_checks_for_object_literals: diag(6072, 3 /* Message */ , "Suppress_excess_property_checks_for_object_literals_6072", "Suppress excess property checks for object literals."),
        Stylize_errors_and_messages_using_color_and_context_experimental: diag(6073, 3 /* Message */ , "Stylize_errors_and_messages_using_color_and_context_experimental_6073", "Stylize errors and messages using color and context (experimental)."),
        Do_not_report_errors_on_unused_labels: diag(6074, 3 /* Message */ , "Do_not_report_errors_on_unused_labels_6074", "Do not report errors on unused labels."),
        Report_error_when_not_all_code_paths_in_function_return_a_value: diag(6075, 3 /* Message */ , "Report_error_when_not_all_code_paths_in_function_return_a_value_6075", "Report error when not all code paths in function return a value."),
        Report_errors_for_fallthrough_cases_in_switch_statement: diag(6076, 3 /* Message */ , "Report_errors_for_fallthrough_cases_in_switch_statement_6076", "Report errors for fallthrough cases in switch statement."),
        Do_not_report_errors_on_unreachable_code: diag(6077, 3 /* Message */ , "Do_not_report_errors_on_unreachable_code_6077", "Do not report errors on unreachable code."),
        Disallow_inconsistently_cased_references_to_the_same_file: diag(6078, 3 /* Message */ , "Disallow_inconsistently_cased_references_to_the_same_file_6078", "Disallow inconsistently-cased references to the same file."),
        Specify_library_files_to_be_included_in_the_compilation: diag(6079, 3 /* Message */ , "Specify_library_files_to_be_included_in_the_compilation_6079", "Specify library files to be included in the compilation."),
        Specify_JSX_code_generation: diag(6080, 3 /* Message */ , "Specify_JSX_code_generation_6080", "Specify JSX code generation."),
        Only_amd_and_system_modules_are_supported_alongside_0: diag(6082, 1 /* Error */ , "Only_amd_and_system_modules_are_supported_alongside_0_6082", "Only 'amd' and 'system' modules are supported alongside --{0}."),
        Base_directory_to_resolve_non_absolute_module_names: diag(6083, 3 /* Message */ , "Base_directory_to_resolve_non_absolute_module_names_6083", "Base directory to resolve non-absolute module names."),
        Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react_JSX_emit: diag(6084, 3 /* Message */ , "Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react__6084", "[Deprecated] Use '--jsxFactory' instead. Specify the object invoked for createElement when targeting 'react' JSX emit"),
        Enable_tracing_of_the_name_resolution_process: diag(6085, 3 /* Message */ , "Enable_tracing_of_the_name_resolution_process_6085", "Enable tracing of the name resolution process."),
        Resolving_module_0_from_1: diag(6086, 3 /* Message */ , "Resolving_module_0_from_1_6086", "======== Resolving module '{0}' from '{1}'. ========"),
        Explicitly_specified_module_resolution_kind_Colon_0: diag(6087, 3 /* Message */ , "Explicitly_specified_module_resolution_kind_Colon_0_6087", "Explicitly specified module resolution kind: '{0}'."),
        Module_resolution_kind_is_not_specified_using_0: diag(6088, 3 /* Message */ , "Module_resolution_kind_is_not_specified_using_0_6088", "Module resolution kind is not specified, using '{0}'."),
        Module_name_0_was_successfully_resolved_to_1: diag(6089, 3 /* Message */ , "Module_name_0_was_successfully_resolved_to_1_6089", "======== Module name '{0}' was successfully resolved to '{1}'. ========"),
        Module_name_0_was_not_resolved: diag(6090, 3 /* Message */ , "Module_name_0_was_not_resolved_6090", "======== Module name '{0}' was not resolved. ========"),
        paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0: diag(6091, 3 /* Message */ , "paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0_6091", "'paths' option is specified, looking for a pattern to match module name '{0}'."),
        Module_name_0_matched_pattern_1: diag(6092, 3 /* Message */ , "Module_name_0_matched_pattern_1_6092", "Module name '{0}', matched pattern '{1}'."),
        Trying_substitution_0_candidate_module_location_Colon_1: diag(6093, 3 /* Message */ , "Trying_substitution_0_candidate_module_location_Colon_1_6093", "Trying substitution '{0}', candidate module location: '{1}'."),
        Resolving_module_name_0_relative_to_base_url_1_2: diag(6094, 3 /* Message */ , "Resolving_module_name_0_relative_to_base_url_1_2_6094", "Resolving module name '{0}' relative to base url '{1}' - '{2}'."),
        Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_types_Colon_1: diag(6095, 3 /* Message */ , "Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_types_Colon_1_6095", "Loading module as file / folder, candidate module location '{0}', target file types: {1}."),
        File_0_does_not_exist: diag(6096, 3 /* Message */ , "File_0_does_not_exist_6096", "File '{0}' does not exist."),
        File_0_exists_use_it_as_a_name_resolution_result: diag(6097, 3 /* Message */ , "File_0_exists_use_it_as_a_name_resolution_result_6097", "File '{0}' exists - use it as a name resolution result."),
        Loading_module_0_from_node_modules_folder_target_file_types_Colon_1: diag(6098, 3 /* Message */ , "Loading_module_0_from_node_modules_folder_target_file_types_Colon_1_6098", "Loading module '{0}' from 'node_modules' folder, target file types: {1}."),
        Found_package_json_at_0: diag(6099, 3 /* Message */ , "Found_package_json_at_0_6099", "Found 'package.json' at '{0}'."),
        package_json_does_not_have_a_0_field: diag(6100, 3 /* Message */ , "package_json_does_not_have_a_0_field_6100", "'package.json' does not have a '{0}' field."),
        package_json_has_0_field_1_that_references_2: diag(6101, 3 /* Message */ , "package_json_has_0_field_1_that_references_2_6101", "'package.json' has '{0}' field '{1}' that references '{2}'."),
        Allow_javascript_files_to_be_compiled: diag(6102, 3 /* Message */ , "Allow_javascript_files_to_be_compiled_6102", "Allow javascript files to be compiled."),
        Checking_if_0_is_the_longest_matching_prefix_for_1_2: diag(6104, 3 /* Message */ , "Checking_if_0_is_the_longest_matching_prefix_for_1_2_6104", "Checking if '{0}' is the longest matching prefix for '{1}' - '{2}'."),
        Expected_type_of_0_field_in_package_json_to_be_1_got_2: diag(6105, 3 /* Message */ , "Expected_type_of_0_field_in_package_json_to_be_1_got_2_6105", "Expected type of '{0}' field in 'package.json' to be '{1}', got '{2}'."),
        baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1: diag(6106, 3 /* Message */ , "baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1_6106", "'baseUrl' option is set to '{0}', using this value to resolve non-relative module name '{1}'."),
        rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0: diag(6107, 3 /* Message */ , "rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0_6107", "'rootDirs' option is set, using it to resolve relative module name '{0}'."),
        Longest_matching_prefix_for_0_is_1: diag(6108, 3 /* Message */ , "Longest_matching_prefix_for_0_is_1_6108", "Longest matching prefix for '{0}' is '{1}'."),
        Loading_0_from_the_root_dir_1_candidate_location_2: diag(6109, 3 /* Message */ , "Loading_0_from_the_root_dir_1_candidate_location_2_6109", "Loading '{0}' from the root dir '{1}', candidate location '{2}'."),
        Trying_other_entries_in_rootDirs: diag(6110, 3 /* Message */ , "Trying_other_entries_in_rootDirs_6110", "Trying other entries in 'rootDirs'."),
        Module_resolution_using_rootDirs_has_failed: diag(6111, 3 /* Message */ , "Module_resolution_using_rootDirs_has_failed_6111", "Module resolution using 'rootDirs' has failed."),
        Do_not_emit_use_strict_directives_in_module_output: diag(6112, 3 /* Message */ , "Do_not_emit_use_strict_directives_in_module_output_6112", "Do not emit 'use strict' directives in module output."),
        Enable_strict_null_checks: diag(6113, 3 /* Message */ , "Enable_strict_null_checks_6113", "Enable strict null checks."),
        Unknown_option_excludes_Did_you_mean_exclude: diag(6114, 1 /* Error */ , "Unknown_option_excludes_Did_you_mean_exclude_6114", "Unknown option 'excludes'. Did you mean 'exclude'?"),
        Raise_error_on_this_expressions_with_an_implied_any_type: diag(6115, 3 /* Message */ , "Raise_error_on_this_expressions_with_an_implied_any_type_6115", "Raise error on 'this' expressions with an implied 'any' type."),
        Resolving_type_reference_directive_0_containing_file_1_root_directory_2: diag(6116, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_1_root_directory_2_6116", "======== Resolving type reference directive '{0}', containing file '{1}', root directory '{2}'. ========"),
        Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2: diag(6119, 3 /* Message */ , "Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2_6119", "======== Type reference directive '{0}' was successfully resolved to '{1}', primary: {2}. ========"),
        Type_reference_directive_0_was_not_resolved: diag(6120, 3 /* Message */ , "Type_reference_directive_0_was_not_resolved_6120", "======== Type reference directive '{0}' was not resolved. ========"),
        Resolving_with_primary_search_path_0: diag(6121, 3 /* Message */ , "Resolving_with_primary_search_path_0_6121", "Resolving with primary search path '{0}'."),
        Root_directory_cannot_be_determined_skipping_primary_search_paths: diag(6122, 3 /* Message */ , "Root_directory_cannot_be_determined_skipping_primary_search_paths_6122", "Root directory cannot be determined, skipping primary search paths."),
        Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set: diag(6123, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set_6123", "======== Resolving type reference directive '{0}', containing file '{1}', root directory not set. ========"),
        Type_declaration_files_to_be_included_in_compilation: diag(6124, 3 /* Message */ , "Type_declaration_files_to_be_included_in_compilation_6124", "Type declaration files to be included in compilation."),
        Looking_up_in_node_modules_folder_initial_location_0: diag(6125, 3 /* Message */ , "Looking_up_in_node_modules_folder_initial_location_0_6125", "Looking up in 'node_modules' folder, initial location '{0}'."),
        Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder: diag(6126, 3 /* Message */ , "Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_mod_6126", "Containing file is not specified and root directory cannot be determined, skipping lookup in 'node_modules' folder."),
        Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1: diag(6127, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1_6127", "======== Resolving type reference directive '{0}', containing file not set, root directory '{1}'. ========"),
        Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set: diag(6128, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set_6128", "======== Resolving type reference directive '{0}', containing file not set, root directory not set. ========"),
        Resolving_real_path_for_0_result_1: diag(6130, 3 /* Message */ , "Resolving_real_path_for_0_result_1_6130", "Resolving real path for '{0}', result '{1}'."),
        Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system: diag(6131, 1 /* Error */ , "Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system_6131", "Cannot compile modules using option '{0}' unless the '--module' flag is 'amd' or 'system'."),
        File_name_0_has_a_1_extension_stripping_it: diag(6132, 3 /* Message */ , "File_name_0_has_a_1_extension_stripping_it_6132", "File name '{0}' has a '{1}' extension - stripping it."),
        _0_is_declared_but_its_value_is_never_read: diag(6133, 1 /* Error */ , "_0_is_declared_but_its_value_is_never_read_6133", "'{0}' is declared but its value is never read.", /*reportsUnnecessary*/ true),
        Report_errors_on_unused_locals: diag(6134, 3 /* Message */ , "Report_errors_on_unused_locals_6134", "Report errors on unused locals."),
        Report_errors_on_unused_parameters: diag(6135, 3 /* Message */ , "Report_errors_on_unused_parameters_6135", "Report errors on unused parameters."),
        The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files: diag(6136, 3 /* Message */ , "The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files_6136", "The maximum dependency depth to search under node_modules and load JavaScript files."),
        Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1: diag(6137, 1 /* Error */ , "Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1_6137", "Cannot import type declaration files. Consider importing '{0}' instead of '{1}'."),
        Property_0_is_declared_but_its_value_is_never_read: diag(6138, 1 /* Error */ , "Property_0_is_declared_but_its_value_is_never_read_6138", "Property '{0}' is declared but its value is never read.", /*reportsUnnecessary*/ true),
        Import_emit_helpers_from_tslib: diag(6139, 3 /* Message */ , "Import_emit_helpers_from_tslib_6139", "Import emit helpers from 'tslib'."),
        Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2: diag(6140, 1 /* Error */ , "Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using__6140", "Auto discovery for typings is enabled in project '{0}'. Running extra resolution pass for module '{1}' using cache location '{2}'."),
        Parse_in_strict_mode_and_emit_use_strict_for_each_source_file: diag(6141, 3 /* Message */ , "Parse_in_strict_mode_and_emit_use_strict_for_each_source_file_6141", 'Parse in strict mode and emit "use strict" for each source file.'),
        Module_0_was_resolved_to_1_but_jsx_is_not_set: diag(6142, 1 /* Error */ , "Module_0_was_resolved_to_1_but_jsx_is_not_set_6142", "Module '{0}' was resolved to '{1}', but '--jsx' is not set."),
        Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1: diag(6144, 3 /* Message */ , "Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1_6144", "Module '{0}' was resolved as locally declared ambient module in file '{1}'."),
        Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h: diag(6146, 3 /* Message */ , "Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h_6146", "Specify the JSX factory function to use when targeting 'react' JSX emit, e.g. 'React.createElement' or 'h'."),
        Resolution_for_module_0_was_found_in_cache_from_location_1: diag(6147, 3 /* Message */ , "Resolution_for_module_0_was_found_in_cache_from_location_1_6147", "Resolution for module '{0}' was found in cache from location '{1}'."),
        Directory_0_does_not_exist_skipping_all_lookups_in_it: diag(6148, 3 /* Message */ , "Directory_0_does_not_exist_skipping_all_lookups_in_it_6148", "Directory '{0}' does not exist, skipping all lookups in it."),
        Show_diagnostic_information: diag(6149, 3 /* Message */ , "Show_diagnostic_information_6149", "Show diagnostic information."),
        Show_verbose_diagnostic_information: diag(6150, 3 /* Message */ , "Show_verbose_diagnostic_information_6150", "Show verbose diagnostic information."),
        Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file: diag(6151, 3 /* Message */ , "Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file_6151", "Emit a single file with source maps instead of having a separate file."),
        Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap_to_be_set: diag(6152, 3 /* Message */ , "Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap__6152", "Emit the source alongside the sourcemaps within a single file; requires '--inlineSourceMap' or '--sourceMap' to be set."),
        Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule: diag(6153, 3 /* Message */ , "Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule_6153", "Transpile each file as a separate module (similar to 'ts.transpileModule')."),
        Print_names_of_generated_files_part_of_the_compilation: diag(6154, 3 /* Message */ , "Print_names_of_generated_files_part_of_the_compilation_6154", "Print names of generated files part of the compilation."),
        Print_names_of_files_part_of_the_compilation: diag(6155, 3 /* Message */ , "Print_names_of_files_part_of_the_compilation_6155", "Print names of files part of the compilation."),
        The_locale_used_when_displaying_messages_to_the_user_e_g_en_us: diag(6156, 3 /* Message */ , "The_locale_used_when_displaying_messages_to_the_user_e_g_en_us_6156", "The locale used when displaying messages to the user (e.g. 'en-us')"),
        Do_not_generate_custom_helper_functions_like_extends_in_compiled_output: diag(6157, 3 /* Message */ , "Do_not_generate_custom_helper_functions_like_extends_in_compiled_output_6157", "Do not generate custom helper functions like '__extends' in compiled output."),
        Do_not_include_the_default_library_file_lib_d_ts: diag(6158, 3 /* Message */ , "Do_not_include_the_default_library_file_lib_d_ts_6158", "Do not include the default library file (lib.d.ts)."),
        Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files: diag(6159, 3 /* Message */ , "Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files_6159", "Do not add triple-slash references or imported modules to the list of compiled files."),
        Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files: diag(6160, 3 /* Message */ , "Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files_6160", "[Deprecated] Use '--skipLibCheck' instead. Skip type checking of default library declaration files."),
        List_of_folders_to_include_type_definitions_from: diag(6161, 3 /* Message */ , "List_of_folders_to_include_type_definitions_from_6161", "List of folders to include type definitions from."),
        Disable_size_limitations_on_JavaScript_projects: diag(6162, 3 /* Message */ , "Disable_size_limitations_on_JavaScript_projects_6162", "Disable size limitations on JavaScript projects."),
        The_character_set_of_the_input_files: diag(6163, 3 /* Message */ , "The_character_set_of_the_input_files_6163", "The character set of the input files."),
        Skipping_module_0_that_looks_like_an_absolute_URI_target_file_types_Colon_1: diag(6164, 3 /* Message */ , "Skipping_module_0_that_looks_like_an_absolute_URI_target_file_types_Colon_1_6164", "Skipping module '{0}' that looks like an absolute URI, target file types: {1}."),
        Do_not_truncate_error_messages: diag(6165, 3 /* Message */ , "Do_not_truncate_error_messages_6165", "Do not truncate error messages."),
        Output_directory_for_generated_declaration_files: diag(6166, 3 /* Message */ , "Output_directory_for_generated_declaration_files_6166", "Output directory for generated declaration files."),
        A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl: diag(6167, 3 /* Message */ , "A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl_6167", "A series of entries which re-map imports to lookup locations relative to the 'baseUrl'."),
        List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime: diag(6168, 3 /* Message */ , "List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime_6168", "List of root folders whose combined content represents the structure of the project at runtime."),
        Show_all_compiler_options: diag(6169, 3 /* Message */ , "Show_all_compiler_options_6169", "Show all compiler options."),
        Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file: diag(6170, 3 /* Message */ , "Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file_6170", "[Deprecated] Use '--outFile' instead. Concatenate and emit output to single file"),
        Command_line_Options: diag(6171, 3 /* Message */ , "Command_line_Options_6171", "Command-line Options"),
        Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5: diag(6179, 3 /* Message */ , "Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_6179", "Provide full support for iterables in 'for-of', spread, and destructuring when targeting 'ES5'."),
        Enable_all_strict_type_checking_options: diag(6180, 3 /* Message */ , "Enable_all_strict_type_checking_options_6180", "Enable all strict type-checking options."),
        Scoped_package_detected_looking_in_0: diag(6182, 3 /* Message */ , "Scoped_package_detected_looking_in_0_6182", "Scoped package detected, looking in '{0}'"),
        Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2: diag(6183, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_6183", "Reusing resolution of module '{0}' from '{1}' of old program, it was successfully resolved to '{2}'."),
        Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3: diag(6184, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package__6184", "Reusing resolution of module '{0}' from '{1}' of old program, it was successfully resolved to '{2}' with Package ID '{3}'."),
        Enable_strict_checking_of_function_types: diag(6186, 3 /* Message */ , "Enable_strict_checking_of_function_types_6186", "Enable strict checking of function types."),
        Enable_strict_checking_of_property_initialization_in_classes: diag(6187, 3 /* Message */ , "Enable_strict_checking_of_property_initialization_in_classes_6187", "Enable strict checking of property initialization in classes."),
        Numeric_separators_are_not_allowed_here: diag(6188, 1 /* Error */ , "Numeric_separators_are_not_allowed_here_6188", "Numeric separators are not allowed here."),
        Multiple_consecutive_numeric_separators_are_not_permitted: diag(6189, 1 /* Error */ , "Multiple_consecutive_numeric_separators_are_not_permitted_6189", "Multiple consecutive numeric separators are not permitted."),
        Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen: diag(6191, 3 /* Message */ , "Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen_6191", "Whether to keep outdated console output in watch mode instead of clearing the screen."),
        All_imports_in_import_declaration_are_unused: diag(6192, 1 /* Error */ , "All_imports_in_import_declaration_are_unused_6192", "All imports in import declaration are unused.", /*reportsUnnecessary*/ true),
        Found_1_error_Watching_for_file_changes: diag(6193, 3 /* Message */ , "Found_1_error_Watching_for_file_changes_6193", "Found 1 error. Watching for file changes."),
        Found_0_errors_Watching_for_file_changes: diag(6194, 3 /* Message */ , "Found_0_errors_Watching_for_file_changes_6194", "Found {0} errors. Watching for file changes."),
        Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols: diag(6195, 3 /* Message */ , "Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols_6195", "Resolve 'keyof' to string valued property names only (no numbers or symbols)."),
        _0_is_declared_but_never_used: diag(6196, 1 /* Error */ , "_0_is_declared_but_never_used_6196", "'{0}' is declared but never used.", /*reportsUnnecessary*/ true),
        Include_modules_imported_with_json_extension: diag(6197, 3 /* Message */ , "Include_modules_imported_with_json_extension_6197", "Include modules imported with '.json' extension"),
        All_destructured_elements_are_unused: diag(6198, 1 /* Error */ , "All_destructured_elements_are_unused_6198", "All destructured elements are unused.", /*reportsUnnecessary*/ true),
        All_variables_are_unused: diag(6199, 1 /* Error */ , "All_variables_are_unused_6199", "All variables are unused.", /*reportsUnnecessary*/ true),
        Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0: diag(6200, 1 /* Error */ , "Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0_6200", "Definitions of the following identifiers conflict with those in another file: {0}"),
        Conflicts_are_in_this_file: diag(6201, 3 /* Message */ , "Conflicts_are_in_this_file_6201", "Conflicts are in this file."),
        Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0: diag(6202, 1 /* Error */ , "Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0_6202", "Project references may not form a circular graph. Cycle detected: {0}"),
        _0_was_also_declared_here: diag(6203, 3 /* Message */ , "_0_was_also_declared_here_6203", "'{0}' was also declared here."),
        and_here: diag(6204, 3 /* Message */ , "and_here_6204", "and here."),
        All_type_parameters_are_unused: diag(6205, 1 /* Error */ , "All_type_parameters_are_unused_6205", "All type parameters are unused."),
        package_json_has_a_typesVersions_field_with_version_specific_path_mappings: diag(6206, 3 /* Message */ , "package_json_has_a_typesVersions_field_with_version_specific_path_mappings_6206", "'package.json' has a 'typesVersions' field with version-specific path mappings."),
        package_json_does_not_have_a_typesVersions_entry_that_matches_version_0: diag(6207, 3 /* Message */ , "package_json_does_not_have_a_typesVersions_entry_that_matches_version_0_6207", "'package.json' does not have a 'typesVersions' entry that matches version '{0}'."),
        package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_match_module_name_2: diag(6208, 3 /* Message */ , "package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_ma_6208", "'package.json' has a 'typesVersions' entry '{0}' that matches compiler version '{1}', looking for a pattern to match module name '{2}'."),
        package_json_has_a_typesVersions_entry_0_that_is_not_a_valid_semver_range: diag(6209, 3 /* Message */ , "package_json_has_a_typesVersions_entry_0_that_is_not_a_valid_semver_range_6209", "'package.json' has a 'typesVersions' entry '{0}' that is not a valid semver range."),
        An_argument_for_0_was_not_provided: diag(6210, 3 /* Message */ , "An_argument_for_0_was_not_provided_6210", "An argument for '{0}' was not provided."),
        An_argument_matching_this_binding_pattern_was_not_provided: diag(6211, 3 /* Message */ , "An_argument_matching_this_binding_pattern_was_not_provided_6211", "An argument matching this binding pattern was not provided."),
        Did_you_mean_to_call_this_expression: diag(6212, 3 /* Message */ , "Did_you_mean_to_call_this_expression_6212", "Did you mean to call this expression?"),
        Did_you_mean_to_use_new_with_this_expression: diag(6213, 3 /* Message */ , "Did_you_mean_to_use_new_with_this_expression_6213", "Did you mean to use 'new' with this expression?"),
        Enable_strict_bind_call_and_apply_methods_on_functions: diag(6214, 3 /* Message */ , "Enable_strict_bind_call_and_apply_methods_on_functions_6214", "Enable strict 'bind', 'call', and 'apply' methods on functions."),
        Using_compiler_options_of_project_reference_redirect_0: diag(6215, 3 /* Message */ , "Using_compiler_options_of_project_reference_redirect_0_6215", "Using compiler options of project reference redirect '{0}'."),
        Found_1_error: diag(6216, 3 /* Message */ , "Found_1_error_6216", "Found 1 error."),
        Found_0_errors: diag(6217, 3 /* Message */ , "Found_0_errors_6217", "Found {0} errors."),
        Module_name_0_was_successfully_resolved_to_1_with_Package_ID_2: diag(6218, 3 /* Message */ , "Module_name_0_was_successfully_resolved_to_1_with_Package_ID_2_6218", "======== Module name '{0}' was successfully resolved to '{1}' with Package ID '{2}'. ========"),
        Type_reference_directive_0_was_successfully_resolved_to_1_with_Package_ID_2_primary_Colon_3: diag(6219, 3 /* Message */ , "Type_reference_directive_0_was_successfully_resolved_to_1_with_Package_ID_2_primary_Colon_3_6219", "======== Type reference directive '{0}' was successfully resolved to '{1}' with Package ID '{2}', primary: {3}. ========"),
        package_json_had_a_falsy_0_field: diag(6220, 3 /* Message */ , "package_json_had_a_falsy_0_field_6220", "'package.json' had a falsy '{0}' field."),
        Disable_use_of_source_files_instead_of_declaration_files_from_referenced_projects: diag(6221, 3 /* Message */ , "Disable_use_of_source_files_instead_of_declaration_files_from_referenced_projects_6221", "Disable use of source files instead of declaration files from referenced projects."),
        Emit_class_fields_with_Define_instead_of_Set: diag(6222, 3 /* Message */ , "Emit_class_fields_with_Define_instead_of_Set_6222", "Emit class fields with Define instead of Set."),
        Generates_a_CPU_profile: diag(6223, 3 /* Message */ , "Generates_a_CPU_profile_6223", "Generates a CPU profile."),
        Disable_solution_searching_for_this_project: diag(6224, 3 /* Message */ , "Disable_solution_searching_for_this_project_6224", "Disable solution searching for this project."),
        Specify_strategy_for_watching_file_Colon_FixedPollingInterval_default_PriorityPollingInterval_DynamicPriorityPolling_FixedChunkSizePolling_UseFsEvents_UseFsEventsOnParentDirectory: diag(6225, 3 /* Message */ , "Specify_strategy_for_watching_file_Colon_FixedPollingInterval_default_PriorityPollingInterval_Dynami_6225", "Specify strategy for watching file: 'FixedPollingInterval' (default), 'PriorityPollingInterval', 'DynamicPriorityPolling', 'FixedChunkSizePolling', 'UseFsEvents', 'UseFsEventsOnParentDirectory'."),
        Specify_strategy_for_watching_directory_on_platforms_that_don_t_support_recursive_watching_natively_Colon_UseFsEvents_default_FixedPollingInterval_DynamicPriorityPolling_FixedChunkSizePolling: diag(6226, 3 /* Message */ , "Specify_strategy_for_watching_directory_on_platforms_that_don_t_support_recursive_watching_natively__6226", "Specify strategy for watching directory on platforms that don't support recursive watching natively: 'UseFsEvents' (default), 'FixedPollingInterval', 'DynamicPriorityPolling', 'FixedChunkSizePolling'."),
        Specify_strategy_for_creating_a_polling_watch_when_it_fails_to_create_using_file_system_events_Colon_FixedInterval_default_PriorityInterval_DynamicPriority_FixedChunkSize: diag(6227, 3 /* Message */ , "Specify_strategy_for_creating_a_polling_watch_when_it_fails_to_create_using_file_system_events_Colon_6227", "Specify strategy for creating a polling watch when it fails to create using file system events: 'FixedInterval' (default), 'PriorityInterval', 'DynamicPriority', 'FixedChunkSize'."),
        Tag_0_expects_at_least_1_arguments_but_the_JSX_factory_2_provides_at_most_3: diag(6229, 1 /* Error */ , "Tag_0_expects_at_least_1_arguments_but_the_JSX_factory_2_provides_at_most_3_6229", "Tag '{0}' expects at least '{1}' arguments, but the JSX factory '{2}' provides at most '{3}'."),
        Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_false_or_null_on_command_line: diag(6230, 1 /* Error */ , "Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_false_or_null_on_command_line_6230", "Option '{0}' can only be specified in 'tsconfig.json' file or set to 'false' or 'null' on command line."),
        Could_not_resolve_the_path_0_with_the_extensions_Colon_1: diag(6231, 1 /* Error */ , "Could_not_resolve_the_path_0_with_the_extensions_Colon_1_6231", "Could not resolve the path '{0}' with the extensions: {1}."),
        Declaration_augments_declaration_in_another_file_This_cannot_be_serialized: diag(6232, 1 /* Error */ , "Declaration_augments_declaration_in_another_file_This_cannot_be_serialized_6232", "Declaration augments declaration in another file. This cannot be serialized."),
        This_is_the_declaration_being_augmented_Consider_moving_the_augmenting_declaration_into_the_same_file: diag(6233, 1 /* Error */ , "This_is_the_declaration_being_augmented_Consider_moving_the_augmenting_declaration_into_the_same_fil_6233", "This is the declaration being augmented. Consider moving the augmenting declaration into the same file."),
        This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without: diag(6234, 1 /* Error */ , "This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without_6234", "This expression is not callable because it is a 'get' accessor. Did you mean to use it without '()'?"),
        Disable_loading_referenced_projects: diag(6235, 3 /* Message */ , "Disable_loading_referenced_projects_6235", "Disable loading referenced projects."),
        Arguments_for_the_rest_parameter_0_were_not_provided: diag(6236, 1 /* Error */ , "Arguments_for_the_rest_parameter_0_were_not_provided_6236", "Arguments for the rest parameter '{0}' were not provided."),
        Generates_an_event_trace_and_a_list_of_types: diag(6237, 3 /* Message */ , "Generates_an_event_trace_and_a_list_of_types_6237", "Generates an event trace and a list of types."),
        Specify_the_module_specifier_to_be_used_to_import_the_jsx_and_jsxs_factory_functions_from_eg_react: diag(6238, 1 /* Error */ , "Specify_the_module_specifier_to_be_used_to_import_the_jsx_and_jsxs_factory_functions_from_eg_react_6238", "Specify the module specifier to be used to import the 'jsx' and 'jsxs' factory functions from. eg, react"),
        File_0_exists_according_to_earlier_cached_lookups: diag(6239, 3 /* Message */ , "File_0_exists_according_to_earlier_cached_lookups_6239", "File '{0}' exists according to earlier cached lookups."),
        File_0_does_not_exist_according_to_earlier_cached_lookups: diag(6240, 3 /* Message */ , "File_0_does_not_exist_according_to_earlier_cached_lookups_6240", "File '{0}' does not exist according to earlier cached lookups."),
        Resolution_for_type_reference_directive_0_was_found_in_cache_from_location_1: diag(6241, 3 /* Message */ , "Resolution_for_type_reference_directive_0_was_found_in_cache_from_location_1_6241", "Resolution for type reference directive '{0}' was found in cache from location '{1}'."),
        Resolving_type_reference_directive_0_containing_file_1: diag(6242, 3 /* Message */ , "Resolving_type_reference_directive_0_containing_file_1_6242", "======== Resolving type reference directive '{0}', containing file '{1}'. ========"),
        Interpret_optional_property_types_as_written_rather_than_adding_undefined: diag(6243, 3 /* Message */ , "Interpret_optional_property_types_as_written_rather_than_adding_undefined_6243", "Interpret optional property types as written, rather than adding 'undefined'."),
        Modules: diag(6244, 3 /* Message */ , "Modules_6244", "Modules"),
        File_Management: diag(6245, 3 /* Message */ , "File_Management_6245", "File Management"),
        Emit: diag(6246, 3 /* Message */ , "Emit_6246", "Emit"),
        JavaScript_Support: diag(6247, 3 /* Message */ , "JavaScript_Support_6247", "JavaScript Support"),
        Type_Checking: diag(6248, 3 /* Message */ , "Type_Checking_6248", "Type Checking"),
        Editor_Support: diag(6249, 3 /* Message */ , "Editor_Support_6249", "Editor Support"),
        Watch_and_Build_Modes: diag(6250, 3 /* Message */ , "Watch_and_Build_Modes_6250", "Watch and Build Modes"),
        Compiler_Diagnostics: diag(6251, 3 /* Message */ , "Compiler_Diagnostics_6251", "Compiler Diagnostics"),
        Interop_Constraints: diag(6252, 3 /* Message */ , "Interop_Constraints_6252", "Interop Constraints"),
        Backwards_Compatibility: diag(6253, 3 /* Message */ , "Backwards_Compatibility_6253", "Backwards Compatibility"),
        Language_and_Environment: diag(6254, 3 /* Message */ , "Language_and_Environment_6254", "Language and Environment"),
        Projects: diag(6255, 3 /* Message */ , "Projects_6255", "Projects"),
        Output_Formatting: diag(6256, 3 /* Message */ , "Output_Formatting_6256", "Output Formatting"),
        Completeness: diag(6257, 3 /* Message */ , "Completeness_6257", "Completeness"),
        _0_should_be_set_inside_the_compilerOptions_object_of_the_config_json_file: diag(6258, 1 /* Error */ , "_0_should_be_set_inside_the_compilerOptions_object_of_the_config_json_file_6258", "'{0}' should be set inside the 'compilerOptions' object of the config json file"),
        Found_1_error_in_0: diag(6259, 3 /* Message */ , "Found_1_error_in_0_6259", "Found 1 error in {0}"),
        Found_0_errors_in_the_same_file_starting_at_Colon_1: diag(6260, 3 /* Message */ , "Found_0_errors_in_the_same_file_starting_at_Colon_1_6260", "Found {0} errors in the same file, starting at: {1}"),
        Found_0_errors_in_1_files: diag(6261, 3 /* Message */ , "Found_0_errors_in_1_files_6261", "Found {0} errors in {1} files."),
        File_name_0_has_a_1_extension_looking_up_2_instead: diag(6262, 3 /* Message */ , "File_name_0_has_a_1_extension_looking_up_2_instead_6262", "File name '{0}' has a '{1}' extension - looking up '{2}' instead."),
        Module_0_was_resolved_to_1_but_allowArbitraryExtensions_is_not_set: diag(6263, 1 /* Error */ , "Module_0_was_resolved_to_1_but_allowArbitraryExtensions_is_not_set_6263", "Module '{0}' was resolved to '{1}', but '--allowArbitraryExtensions' is not set."),
        Enable_importing_files_with_any_extension_provided_a_declaration_file_is_present: diag(6264, 3 /* Message */ , "Enable_importing_files_with_any_extension_provided_a_declaration_file_is_present_6264", "Enable importing files with any extension, provided a declaration file is present."),
        Resolving_type_reference_directive_for_program_that_specifies_custom_typeRoots_skipping_lookup_in_node_modules_folder: diag(6265, 3 /* Message */ , "Resolving_type_reference_directive_for_program_that_specifies_custom_typeRoots_skipping_lookup_in_no_6265", "Resolving type reference directive for program that specifies custom typeRoots, skipping lookup in 'node_modules' folder."),
        Option_0_can_only_be_specified_on_command_line: diag(6266, 1 /* Error */ , "Option_0_can_only_be_specified_on_command_line_6266", "Option '{0}' can only be specified on command line."),
        Directory_0_has_no_containing_package_json_scope_Imports_will_not_resolve: diag(6270, 3 /* Message */ , "Directory_0_has_no_containing_package_json_scope_Imports_will_not_resolve_6270", "Directory '{0}' has no containing package.json scope. Imports will not resolve."),
        Import_specifier_0_does_not_exist_in_package_json_scope_at_path_1: diag(6271, 3 /* Message */ , "Import_specifier_0_does_not_exist_in_package_json_scope_at_path_1_6271", "Import specifier '{0}' does not exist in package.json scope at path '{1}'."),
        Invalid_import_specifier_0_has_no_possible_resolutions: diag(6272, 3 /* Message */ , "Invalid_import_specifier_0_has_no_possible_resolutions_6272", "Invalid import specifier '{0}' has no possible resolutions."),
        package_json_scope_0_has_no_imports_defined: diag(6273, 3 /* Message */ , "package_json_scope_0_has_no_imports_defined_6273", "package.json scope '{0}' has no imports defined."),
        package_json_scope_0_explicitly_maps_specifier_1_to_null: diag(6274, 3 /* Message */ , "package_json_scope_0_explicitly_maps_specifier_1_to_null_6274", "package.json scope '{0}' explicitly maps specifier '{1}' to null."),
        package_json_scope_0_has_invalid_type_for_target_of_specifier_1: diag(6275, 3 /* Message */ , "package_json_scope_0_has_invalid_type_for_target_of_specifier_1_6275", "package.json scope '{0}' has invalid type for target of specifier '{1}'"),
        Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1: diag(6276, 3 /* Message */ , "Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1_6276", "Export specifier '{0}' does not exist in package.json scope at path '{1}'."),
        Resolution_of_non_relative_name_failed_trying_with_modern_Node_resolution_features_disabled_to_see_if_npm_library_needs_configuration_update: diag(6277, 3 /* Message */ , "Resolution_of_non_relative_name_failed_trying_with_modern_Node_resolution_features_disabled_to_see_i_6277", "Resolution of non-relative name failed; trying with modern Node resolution features disabled to see if npm library needs configuration update."),
        There_are_types_at_0_but_this_result_could_not_be_resolved_when_respecting_package_json_exports_The_1_library_may_need_to_update_its_package_json_or_typings: diag(6278, 3 /* Message */ , "There_are_types_at_0_but_this_result_could_not_be_resolved_when_respecting_package_json_exports_The__6278", `There are types at '{0}', but this result could not be resolved when respecting package.json "exports". The '{1}' library may need to update its package.json or typings.`),
        Resolution_of_non_relative_name_failed_trying_with_moduleResolution_bundler_to_see_if_project_may_need_configuration_update: diag(6279, 3 /* Message */ , "Resolution_of_non_relative_name_failed_trying_with_moduleResolution_bundler_to_see_if_project_may_ne_6279", "Resolution of non-relative name failed; trying with '--moduleResolution bundler' to see if project may need configuration update."),
        There_are_types_at_0_but_this_result_could_not_be_resolved_under_your_current_moduleResolution_setting_Consider_updating_to_node16_nodenext_or_bundler: diag(6280, 3 /* Message */ , "There_are_types_at_0_but_this_result_could_not_be_resolved_under_your_current_moduleResolution_setti_6280", "There are types at '{0}', but this result could not be resolved under your current 'moduleResolution' setting. Consider updating to 'node16', 'nodenext', or 'bundler'."),
        package_json_has_a_peerDependencies_field: diag(6281, 3 /* Message */ , "package_json_has_a_peerDependencies_field_6281", "'package.json' has a 'peerDependencies' field."),
        Found_peerDependency_0_with_1_version: diag(6282, 3 /* Message */ , "Found_peerDependency_0_with_1_version_6282", "Found peerDependency '{0}' with '{1}' version."),
        Failed_to_find_peerDependency_0: diag(6283, 3 /* Message */ , "Failed_to_find_peerDependency_0_6283", "Failed to find peerDependency '{0}'."),
        File_Layout: diag(6284, 3 /* Message */ , "File_Layout_6284", "File Layout"),
        Environment_Settings: diag(6285, 3 /* Message */ , "Environment_Settings_6285", "Environment Settings"),
        See_also_https_Colon_Slash_Slashaka_ms_Slashtsconfig_Slashmodule: diag(6286, 3 /* Message */ , "See_also_https_Colon_Slash_Slashaka_ms_Slashtsconfig_Slashmodule_6286", "See also https://aka.ms/tsconfig/module"),
        For_nodejs_Colon: diag(6287, 3 /* Message */ , "For_nodejs_Colon_6287", "For nodejs:"),
        and_npm_install_D_types_Slashnode: diag(6290, 3 /* Message */ , "and_npm_install_D_types_Slashnode_6290", "and npm install -D @types/node"),
        Other_Outputs: diag(6291, 3 /* Message */ , "Other_Outputs_6291", "Other Outputs"),
        Stricter_Typechecking_Options: diag(6292, 3 /* Message */ , "Stricter_Typechecking_Options_6292", "Stricter Typechecking Options"),
        Style_Options: diag(6293, 3 /* Message */ , "Style_Options_6293", "Style Options"),
        Recommended_Options: diag(6294, 3 /* Message */ , "Recommended_Options_6294", "Recommended Options"),
        Enable_project_compilation: diag(6302, 3 /* Message */ , "Enable_project_compilation_6302", "Enable project compilation"),
        Composite_projects_may_not_disable_declaration_emit: diag(6304, 1 /* Error */ , "Composite_projects_may_not_disable_declaration_emit_6304", "Composite projects may not disable declaration emit."),
        Output_file_0_has_not_been_built_from_source_file_1: diag(6305, 1 /* Error */ , "Output_file_0_has_not_been_built_from_source_file_1_6305", "Output file '{0}' has not been built from source file '{1}'."),
        Referenced_project_0_must_have_setting_composite_Colon_true: diag(6306, 1 /* Error */ , "Referenced_project_0_must_have_setting_composite_Colon_true_6306", `Referenced project '{0}' must have setting "composite": true.`),
        File_0_is_not_listed_within_the_file_list_of_project_1_Projects_must_list_all_files_or_use_an_include_pattern: diag(6307, 1 /* Error */ , "File_0_is_not_listed_within_the_file_list_of_project_1_Projects_must_list_all_files_or_use_an_includ_6307", "File '{0}' is not listed within the file list of project '{1}'. Projects must list all files or use an 'include' pattern."),
        Referenced_project_0_may_not_disable_emit: diag(6310, 1 /* Error */ , "Referenced_project_0_may_not_disable_emit_6310", "Referenced project '{0}' may not disable emit."),
        Project_0_is_out_of_date_because_output_1_is_older_than_input_2: diag(6350, 3 /* Message */ , "Project_0_is_out_of_date_because_output_1_is_older_than_input_2_6350", "Project '{0}' is out of date because output '{1}' is older than input '{2}'"),
        Project_0_is_up_to_date_because_newest_input_1_is_older_than_output_2: diag(6351, 3 /* Message */ , "Project_0_is_up_to_date_because_newest_input_1_is_older_than_output_2_6351", "Project '{0}' is up to date because newest input '{1}' is older than output '{2}'"),
        Project_0_is_out_of_date_because_output_file_1_does_not_exist: diag(6352, 3 /* Message */ , "Project_0_is_out_of_date_because_output_file_1_does_not_exist_6352", "Project '{0}' is out of date because output file '{1}' does not exist"),
        Project_0_is_out_of_date_because_its_dependency_1_is_out_of_date: diag(6353, 3 /* Message */ , "Project_0_is_out_of_date_because_its_dependency_1_is_out_of_date_6353", "Project '{0}' is out of date because its dependency '{1}' is out of date"),
        Project_0_is_up_to_date_with_d_ts_files_from_its_dependencies: diag(6354, 3 /* Message */ , "Project_0_is_up_to_date_with_d_ts_files_from_its_dependencies_6354", "Project '{0}' is up to date with .d.ts files from its dependencies"),
        Projects_in_this_build_Colon_0: diag(6355, 3 /* Message */ , "Projects_in_this_build_Colon_0_6355", "Projects in this build: {0}"),
        A_non_dry_build_would_delete_the_following_files_Colon_0: diag(6356, 3 /* Message */ , "A_non_dry_build_would_delete_the_following_files_Colon_0_6356", "A non-dry build would delete the following files: {0}"),
        A_non_dry_build_would_build_project_0: diag(6357, 3 /* Message */ , "A_non_dry_build_would_build_project_0_6357", "A non-dry build would build project '{0}'"),
        Building_project_0: diag(6358, 3 /* Message */ , "Building_project_0_6358", "Building project '{0}'..."),
        Updating_output_timestamps_of_project_0: diag(6359, 3 /* Message */ , "Updating_output_timestamps_of_project_0_6359", "Updating output timestamps of project '{0}'..."),
        Project_0_is_up_to_date: diag(6361, 3 /* Message */ , "Project_0_is_up_to_date_6361", "Project '{0}' is up to date"),
        Skipping_build_of_project_0_because_its_dependency_1_has_errors: diag(6362, 3 /* Message */ , "Skipping_build_of_project_0_because_its_dependency_1_has_errors_6362", "Skipping build of project '{0}' because its dependency '{1}' has errors"),
        Project_0_can_t_be_built_because_its_dependency_1_has_errors: diag(6363, 3 /* Message */ , "Project_0_can_t_be_built_because_its_dependency_1_has_errors_6363", "Project '{0}' can't be built because its dependency '{1}' has errors"),
        Build_one_or_more_projects_and_their_dependencies_if_out_of_date: diag(6364, 3 /* Message */ , "Build_one_or_more_projects_and_their_dependencies_if_out_of_date_6364", "Build one or more projects and their dependencies, if out of date"),
        Delete_the_outputs_of_all_projects: diag(6365, 3 /* Message */ , "Delete_the_outputs_of_all_projects_6365", "Delete the outputs of all projects."),
        Show_what_would_be_built_or_deleted_if_specified_with_clean: diag(6367, 3 /* Message */ , "Show_what_would_be_built_or_deleted_if_specified_with_clean_6367", "Show what would be built (or deleted, if specified with '--clean')"),
        Option_build_must_be_the_first_command_line_argument: diag(6369, 1 /* Error */ , "Option_build_must_be_the_first_command_line_argument_6369", "Option '--build' must be the first command line argument."),
        Options_0_and_1_cannot_be_combined: diag(6370, 1 /* Error */ , "Options_0_and_1_cannot_be_combined_6370", "Options '{0}' and '{1}' cannot be combined."),
        Updating_unchanged_output_timestamps_of_project_0: diag(6371, 3 /* Message */ , "Updating_unchanged_output_timestamps_of_project_0_6371", "Updating unchanged output timestamps of project '{0}'..."),
        A_non_dry_build_would_update_timestamps_for_output_of_project_0: diag(6374, 3 /* Message */ , "A_non_dry_build_would_update_timestamps_for_output_of_project_0_6374", "A non-dry build would update timestamps for output of project '{0}'"),
        Cannot_write_file_0_because_it_will_overwrite_tsbuildinfo_file_generated_by_referenced_project_1: diag(6377, 1 /* Error */ , "Cannot_write_file_0_because_it_will_overwrite_tsbuildinfo_file_generated_by_referenced_project_1_6377", "Cannot write file '{0}' because it will overwrite '.tsbuildinfo' file generated by referenced project '{1}'"),
        Composite_projects_may_not_disable_incremental_compilation: diag(6379, 1 /* Error */ , "Composite_projects_may_not_disable_incremental_compilation_6379", "Composite projects may not disable incremental compilation."),
        Specify_file_to_store_incremental_compilation_information: diag(6380, 3 /* Message */ , "Specify_file_to_store_incremental_compilation_information_6380", "Specify file to store incremental compilation information"),
        Project_0_is_out_of_date_because_output_for_it_was_generated_with_version_1_that_differs_with_current_version_2: diag(6381, 3 /* Message */ , "Project_0_is_out_of_date_because_output_for_it_was_generated_with_version_1_that_differs_with_curren_6381", "Project '{0}' is out of date because output for it was generated with version '{1}' that differs with current version '{2}'"),
        Skipping_build_of_project_0_because_its_dependency_1_was_not_built: diag(6382, 3 /* Message */ , "Skipping_build_of_project_0_because_its_dependency_1_was_not_built_6382", "Skipping build of project '{0}' because its dependency '{1}' was not built"),
        Project_0_can_t_be_built_because_its_dependency_1_was_not_built: diag(6383, 3 /* Message */ , "Project_0_can_t_be_built_because_its_dependency_1_was_not_built_6383", "Project '{0}' can't be built because its dependency '{1}' was not built"),
        Have_recompiles_in_incremental_and_watch_assume_that_changes_within_a_file_will_only_affect_files_directly_depending_on_it: diag(6384, 3 /* Message */ , "Have_recompiles_in_incremental_and_watch_assume_that_changes_within_a_file_will_only_affect_files_di_6384", "Have recompiles in '--incremental' and '--watch' assume that changes within a file will only affect files directly depending on it."),
        _0_is_deprecated: diag(6385, 2 /* Suggestion */ , "_0_is_deprecated_6385", "'{0}' is deprecated.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ void 0, /*reportsDeprecated*/ true),
        Performance_timings_for_diagnostics_or_extendedDiagnostics_are_not_available_in_this_session_A_native_implementation_of_the_Web_Performance_API_could_not_be_found: diag(6386, 3 /* Message */ , "Performance_timings_for_diagnostics_or_extendedDiagnostics_are_not_available_in_this_session_A_nativ_6386", "Performance timings for '--diagnostics' or '--extendedDiagnostics' are not available in this session. A native implementation of the Web Performance API could not be found."),
        The_signature_0_of_1_is_deprecated: diag(6387, 2 /* Suggestion */ , "The_signature_0_of_1_is_deprecated_6387", "The signature '{0}' of '{1}' is deprecated.", /*reportsUnnecessary*/ void 0, /*elidedInCompatabilityPyramid*/ void 0, /*reportsDeprecated*/ true),
        Project_0_is_being_forcibly_rebuilt: diag(6388, 3 /* Message */ , "Project_0_is_being_forcibly_rebuilt_6388", "Project '{0}' is being forcibly rebuilt"),
        Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved: diag(6389, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved_6389", "Reusing resolution of module '{0}' from '{1}' of old program, it was not resolved."),
        Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2: diag(6390, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved__6390", "Reusing resolution of type reference directive '{0}' from '{1}' of old program, it was successfully resolved to '{2}'."),
        Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3: diag(6391, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved__6391", "Reusing resolution of type reference directive '{0}' from '{1}' of old program, it was successfully resolved to '{2}' with Package ID '{3}'."),
        Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_not_resolved: diag(6392, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_not_resolved_6392", "Reusing resolution of type reference directive '{0}' from '{1}' of old program, it was not resolved."),
        Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3: diag(6393, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_6393", "Reusing resolution of module '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}'."),
        Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3_with_Package_ID_4: diag(6394, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_6394", "Reusing resolution of module '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}' with Package ID '{4}'."),
        Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_not_resolved: diag(6395, 3 /* Message */ , "Reusing_resolution_of_module_0_from_1_found_in_cache_from_location_2_it_was_not_resolved_6395", "Reusing resolution of module '{0}' from '{1}' found in cache from location '{2}', it was not resolved."),
        Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3: diag(6396, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_succes_6396", "Reusing resolution of type reference directive '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}'."),
        Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_successfully_resolved_to_3_with_Package_ID_4: diag(6397, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_succes_6397", "Reusing resolution of type reference directive '{0}' from '{1}' found in cache from location '{2}', it was successfully resolved to '{3}' with Package ID '{4}'."),
        Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_not_resolved: diag(6398, 3 /* Message */ , "Reusing_resolution_of_type_reference_directive_0_from_1_found_in_cache_from_location_2_it_was_not_re_6398", "Reusing resolution of type reference directive '{0}' from '{1}' found in cache from location '{2}', it was not resolved."),
        Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_some_of_the_changes_were_not_emitted: diag(6399, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_some_of_the_changes_were_not_emitte_6399", "Project '{0}' is out of date because buildinfo file '{1}' indicates that some of the changes were not emitted"),
        Project_0_is_up_to_date_but_needs_to_update_timestamps_of_output_files_that_are_older_than_input_files: diag(6400, 3 /* Message */ , "Project_0_is_up_to_date_but_needs_to_update_timestamps_of_output_files_that_are_older_than_input_fil_6400", "Project '{0}' is up to date but needs to update timestamps of output files that are older than input files"),
        Project_0_is_out_of_date_because_there_was_error_reading_file_1: diag(6401, 3 /* Message */ , "Project_0_is_out_of_date_because_there_was_error_reading_file_1_6401", "Project '{0}' is out of date because there was error reading file '{1}'"),
        Resolving_in_0_mode_with_conditions_1: diag(6402, 3 /* Message */ , "Resolving_in_0_mode_with_conditions_1_6402", "Resolving in {0} mode with conditions {1}."),
        Matched_0_condition_1: diag(6403, 3 /* Message */ , "Matched_0_condition_1_6403", "Matched '{0}' condition '{1}'."),
        Using_0_subpath_1_with_target_2: diag(6404, 3 /* Message */ , "Using_0_subpath_1_with_target_2_6404", "Using '{0}' subpath '{1}' with target '{2}'."),
        Saw_non_matching_condition_0: diag(6405, 3 /* Message */ , "Saw_non_matching_condition_0_6405", "Saw non-matching condition '{0}'."),
        Project_0_is_out_of_date_because_buildinfo_file_1_indicates_there_is_change_in_compilerOptions: diag(6406, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_there_is_change_in_compilerOptions_6406", "Project '{0}' is out of date because buildinfo file '{1}' indicates there is change in compilerOptions"),
        Allow_imports_to_include_TypeScript_file_extensions_Requires_moduleResolution_bundler_and_either_noEmit_or_emitDeclarationOnly_to_be_set: diag(6407, 3 /* Message */ , "Allow_imports_to_include_TypeScript_file_extensions_Requires_moduleResolution_bundler_and_either_noE_6407", "Allow imports to include TypeScript file extensions. Requires '--moduleResolution bundler' and either '--noEmit' or '--emitDeclarationOnly' to be set."),
        Use_the_package_json_exports_field_when_resolving_package_imports: diag(6408, 3 /* Message */ , "Use_the_package_json_exports_field_when_resolving_package_imports_6408", "Use the package.json 'exports' field when resolving package imports."),
        Use_the_package_json_imports_field_when_resolving_imports: diag(6409, 3 /* Message */ , "Use_the_package_json_imports_field_when_resolving_imports_6409", "Use the package.json 'imports' field when resolving imports."),
        Conditions_to_set_in_addition_to_the_resolver_specific_defaults_when_resolving_imports: diag(6410, 3 /* Message */ , "Conditions_to_set_in_addition_to_the_resolver_specific_defaults_when_resolving_imports_6410", "Conditions to set in addition to the resolver-specific defaults when resolving imports."),
        true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false: diag(6411, 3 /* Message */ , "true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false_6411", "`true` when 'moduleResolution' is 'node16', 'nodenext', or 'bundler'; otherwise `false`."),
        Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_file_2_was_root_file_of_compilation_but_not_any_more: diag(6412, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_file_2_was_root_file_of_compilation_6412", "Project '{0}' is out of date because buildinfo file '{1}' indicates that file '{2}' was root file of compilation but not any more."),
        Entering_conditional_exports: diag(6413, 3 /* Message */ , "Entering_conditional_exports_6413", "Entering conditional exports."),
        Resolved_under_condition_0: diag(6414, 3 /* Message */ , "Resolved_under_condition_0_6414", "Resolved under condition '{0}'."),
        Failed_to_resolve_under_condition_0: diag(6415, 3 /* Message */ , "Failed_to_resolve_under_condition_0_6415", "Failed to resolve under condition '{0}'."),
        Exiting_conditional_exports: diag(6416, 3 /* Message */ , "Exiting_conditional_exports_6416", "Exiting conditional exports."),
        Searching_all_ancestor_node_modules_directories_for_preferred_extensions_Colon_0: diag(6417, 3 /* Message */ , "Searching_all_ancestor_node_modules_directories_for_preferred_extensions_Colon_0_6417", "Searching all ancestor node_modules directories for preferred extensions: {0}."),
        Searching_all_ancestor_node_modules_directories_for_fallback_extensions_Colon_0: diag(6418, 3 /* Message */ , "Searching_all_ancestor_node_modules_directories_for_fallback_extensions_Colon_0_6418", "Searching all ancestor node_modules directories for fallback extensions: {0}."),
        Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_program_needs_to_report_errors: diag(6419, 3 /* Message */ , "Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_program_needs_to_report_errors_6419", "Project '{0}' is out of date because buildinfo file '{1}' indicates that program needs to report errors."),
        Project_0_is_out_of_date_because_1: diag(6420, 3 /* Message */ , "Project_0_is_out_of_date_because_1_6420", "Project '{0}' is out of date because {1}."),
        Rewrite_ts_tsx_mts_and_cts_file_extensions_in_relative_import_paths_to_their_JavaScript_equivalent_in_output_files: diag(6421, 3 /* Message */ , "Rewrite_ts_tsx_mts_and_cts_file_extensions_in_relative_import_paths_to_their_JavaScript_equivalent_i_6421", "Rewrite '.ts', '.tsx', '.mts', and '.cts' file extensions in relative import paths to their JavaScript equivalent in output files."),
        The_expected_type_comes_from_property_0_which_is_declared_here_on_type_1: diag(6500, 3 /* Message */ , "The_expected_type_comes_from_property_0_which_is_declared_here_on_type_1_6500", "The expected type comes from property '{0}' which is declared here on type '{1}'"),
        The_expected_type_comes_from_this_index_signature: diag(6501, 3 /* Message */ , "The_expected_type_comes_from_this_index_signature_6501", "The expected type comes from this index signature."),
        The_expected_type_comes_from_the_return_type_of_this_signature: diag(6502, 3 /* Message */ , "The_expected_type_comes_from_the_return_type_of_this_signature_6502", "The expected type comes from the return type of this signature."),
        Print_names_of_files_that_are_part_of_the_compilation_and_then_stop_processing: diag(6503, 3 /* Message */ , "Print_names_of_files_that_are_part_of_the_compilation_and_then_stop_processing_6503", "Print names of files that are part of the compilation and then stop processing."),
        File_0_is_a_JavaScript_file_Did_you_mean_to_enable_the_allowJs_option: diag(6504, 1 /* Error */ , "File_0_is_a_JavaScript_file_Did_you_mean_to_enable_the_allowJs_option_6504", "File '{0}' is a JavaScript file. Did you mean to enable the 'allowJs' option?"),
        Print_names_of_files_and_the_reason_they_are_part_of_the_compilation: diag(6505, 3 /* Message */ , "Print_names_of_files_and_the_reason_they_are_part_of_the_compilation_6505", "Print names of files and the reason they are part of the compilation."),
        Consider_adding_a_declare_modifier_to_this_class: diag(6506, 3 /* Message */ , "Consider_adding_a_declare_modifier_to_this_class_6506", "Consider adding a 'declare' modifier to this class."),
        Allow_JavaScript_files_to_be_a_part_of_your_program_Use_the_checkJs_option_to_get_errors_from_these_files: diag(6600, 3 /* Message */ , "Allow_JavaScript_files_to_be_a_part_of_your_program_Use_the_checkJs_option_to_get_errors_from_these__6600", "Allow JavaScript files to be a part of your program. Use the 'checkJs' option to get errors from these files."),
        Allow_import_x_from_y_when_a_module_doesn_t_have_a_default_export: diag(6601, 3 /* Message */ , "Allow_import_x_from_y_when_a_module_doesn_t_have_a_default_export_6601", "Allow 'import x from y' when a module doesn't have a default export."),
        Allow_accessing_UMD_globals_from_modules: diag(6602, 3 /* Message */ , "Allow_accessing_UMD_globals_from_modules_6602", "Allow accessing UMD globals from modules."),
        Disable_error_reporting_for_unreachable_code: diag(6603, 3 /* Message */ , "Disable_error_reporting_for_unreachable_code_6603", "Disable error reporting for unreachable code."),
        Disable_error_reporting_for_unused_labels: diag(6604, 3 /* Message */ , "Disable_error_reporting_for_unused_labels_6604", "Disable error reporting for unused labels."),
        Ensure_use_strict_is_always_emitted: diag(6605, 3 /* Message */ , "Ensure_use_strict_is_always_emitted_6605", "Ensure 'use strict' is always emitted."),
        Have_recompiles_in_projects_that_use_incremental_and_watch_mode_assume_that_changes_within_a_file_will_only_affect_files_directly_depending_on_it: diag(6606, 3 /* Message */ , "Have_recompiles_in_projects_that_use_incremental_and_watch_mode_assume_that_changes_within_a_file_wi_6606", "Have recompiles in projects that use 'incremental' and 'watch' mode assume that changes within a file will only affect files directly depending on it."),
        Specify_the_base_directory_to_resolve_non_relative_module_names: diag(6607, 3 /* Message */ , "Specify_the_base_directory_to_resolve_non_relative_module_names_6607", "Specify the base directory to resolve non-relative module names."),
        No_longer_supported_In_early_versions_manually_set_the_text_encoding_for_reading_files: diag(6608, 3 /* Message */ , "No_longer_supported_In_early_versions_manually_set_the_text_encoding_for_reading_files_6608", "No longer supported. In early versions, manually set the text encoding for reading files."),
        Enable_error_reporting_in_type_checked_JavaScript_files: diag(6609, 3 /* Message */ , "Enable_error_reporting_in_type_checked_JavaScript_files_6609", "Enable error reporting in type-checked JavaScript files."),
        Enable_constraints_that_allow_a_TypeScript_project_to_be_used_with_project_references: diag(6611, 3 /* Message */ , "Enable_constraints_that_allow_a_TypeScript_project_to_be_used_with_project_references_6611", "Enable constraints that allow a TypeScript project to be used with project references."),
        Generate_d_ts_files_from_TypeScript_and_JavaScript_files_in_your_project: diag(6612, 3 /* Message */ , "Generate_d_ts_files_from_TypeScript_and_JavaScript_files_in_your_project_6612", "Generate .d.ts files from TypeScript and JavaScript files in your project."),
        Specify_the_output_directory_for_generated_declaration_files: diag(6613, 3 /* Message */ , "Specify_the_output_directory_for_generated_declaration_files_6613", "Specify the output directory for generated declaration files."),
        Create_sourcemaps_for_d_ts_files: diag(6614, 3 /* Message */ , "Create_sourcemaps_for_d_ts_files_6614", "Create sourcemaps for d.ts files."),
        Output_compiler_performance_information_after_building: diag(6615, 3 /* Message */ , "Output_compiler_performance_information_after_building_6615", "Output compiler performance information after building."),
        Disables_inference_for_type_acquisition_by_looking_at_filenames_in_a_project: diag(6616, 3 /* Message */ , "Disables_inference_for_type_acquisition_by_looking_at_filenames_in_a_project_6616", "Disables inference for type acquisition by looking at filenames in a project."),
        Reduce_the_number_of_projects_loaded_automatically_by_TypeScript: diag(6617, 3 /* Message */ , "Reduce_the_number_of_projects_loaded_automatically_by_TypeScript_6617", "Reduce the number of projects loaded automatically by TypeScript."),
        Remove_the_20mb_cap_on_total_source_code_size_for_JavaScript_files_in_the_TypeScript_language_server: diag(6618, 3 /* Message */ , "Remove_the_20mb_cap_on_total_source_code_size_for_JavaScript_files_in_the_TypeScript_language_server_6618", "Remove the 20mb cap on total source code size for JavaScript files in the TypeScript language server."),
        Opt_a_project_out_of_multi_project_reference_checking_when_editing: diag(6619, 3 /* Message */ , "Opt_a_project_out_of_multi_project_reference_checking_when_editing_6619", "Opt a project out of multi-project reference checking when editing."),
        Disable_preferring_source_files_instead_of_declaration_files_when_referencing_composite_projects: diag(6620, 3 /* Message */ , "Disable_preferring_source_files_instead_of_declaration_files_when_referencing_composite_projects_6620", "Disable preferring source files instead of declaration files when referencing composite projects."),
        Emit_more_compliant_but_verbose_and_less_performant_JavaScript_for_iteration: diag(6621, 3 /* Message */ , "Emit_more_compliant_but_verbose_and_less_performant_JavaScript_for_iteration_6621", "Emit more compliant, but verbose and less performant JavaScript for iteration."),
        Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files: diag(6622, 3 /* Message */ , "Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files_6622", "Emit a UTF-8 Byte Order Mark (BOM) in the beginning of output files."),
        Only_output_d_ts_files_and_not_JavaScript_files: diag(6623, 3 /* Message */ , "Only_output_d_ts_files_and_not_JavaScript_files_6623", "Only output d.ts files and not JavaScript files."),
        Emit_design_type_metadata_for_decorated_declarations_in_source_files: diag(6624, 3 /* Message */ , "Emit_design_type_metadata_for_decorated_declarations_in_source_files_6624", "Emit design-type metadata for decorated declarations in source files."),
        Disable_the_type_acquisition_for_JavaScript_projects: diag(6625, 3 /* Message */ , "Disable_the_type_acquisition_for_JavaScript_projects_6625", "Disable the type acquisition for JavaScript projects"),
        Emit_additional_JavaScript_to_ease_support_for_importing_CommonJS_modules_This_enables_allowSyntheticDefaultImports_for_type_compatibility: diag(6626, 3 /* Message */ , "Emit_additional_JavaScript_to_ease_support_for_importing_CommonJS_modules_This_enables_allowSyntheti_6626", "Emit additional JavaScript to ease support for importing CommonJS modules. This enables 'allowSyntheticDefaultImports' for type compatibility."),
        Filters_results_from_the_include_option: diag(6627, 3 /* Message */ , "Filters_results_from_the_include_option_6627", "Filters results from the `include` option."),
        Remove_a_list_of_directories_from_the_watch_process: diag(6628, 3 /* Message */ , "Remove_a_list_of_directories_from_the_watch_process_6628", "Remove a list of directories from the watch process."),
        Remove_a_list_of_files_from_the_watch_mode_s_processing: diag(6629, 3 /* Message */ , "Remove_a_list_of_files_from_the_watch_mode_s_processing_6629", "Remove a list of files from the watch mode's processing."),
        Enable_experimental_support_for_legacy_experimental_decorators: diag(6630, 3 /* Message */ , "Enable_experimental_support_for_legacy_experimental_decorators_6630", "Enable experimental support for legacy experimental decorators."),
        Print_files_read_during_the_compilation_including_why_it_was_included: diag(6631, 3 /* Message */ , "Print_files_read_during_the_compilation_including_why_it_was_included_6631", "Print files read during the compilation including why it was included."),
        Output_more_detailed_compiler_performance_information_after_building: diag(6632, 3 /* Message */ , "Output_more_detailed_compiler_performance_information_after_building_6632", "Output more detailed compiler performance information after building."),
        Specify_one_or_more_path_or_node_module_references_to_base_configuration_files_from_which_settings_are_inherited: diag(6633, 3 /* Message */ , "Specify_one_or_more_path_or_node_module_references_to_base_configuration_files_from_which_settings_a_6633", "Specify one or more path or node module references to base configuration files from which settings are inherited."),
        Specify_what_approach_the_watcher_should_use_if_the_system_runs_out_of_native_file_watchers: diag(6634, 3 /* Message */ , "Specify_what_approach_the_watcher_should_use_if_the_system_runs_out_of_native_file_watchers_6634", "Specify what approach the watcher should use if the system runs out of native file watchers."),
        Include_a_list_of_files_This_does_not_support_glob_patterns_as_opposed_to_include: diag(6635, 3 /* Message */ , "Include_a_list_of_files_This_does_not_support_glob_patterns_as_opposed_to_include_6635", "Include a list of files. This does not support glob patterns, as opposed to `include`."),
        Build_all_projects_including_those_that_appear_to_be_up_to_date: diag(6636, 3 /* Message */ , "Build_all_projects_including_those_that_appear_to_be_up_to_date_6636", "Build all projects, including those that appear to be up to date."),
        Ensure_that_casing_is_correct_in_imports: diag(6637, 3 /* Message */ , "Ensure_that_casing_is_correct_in_imports_6637", "Ensure that casing is correct in imports."),
        Emit_a_v8_CPU_profile_of_the_compiler_run_for_debugging: diag(6638, 3 /* Message */ , "Emit_a_v8_CPU_profile_of_the_compiler_run_for_debugging_6638", "Emit a v8 CPU profile of the compiler run for debugging."),
        Allow_importing_helper_functions_from_tslib_once_per_project_instead_of_including_them_per_file: diag(6639, 3 /* Message */ , "Allow_importing_helper_functions_from_tslib_once_per_project_instead_of_including_them_per_file_6639", "Allow importing helper functions from tslib once per project, instead of including them per-file."),
        Skip_building_downstream_projects_on_error_in_upstream_project: diag(6640, 3 /* Message */ , "Skip_building_downstream_projects_on_error_in_upstream_project_6640", "Skip building downstream projects on error in upstream project."),
        Specify_a_list_of_glob_patterns_that_match_files_to_be_included_in_compilation: diag(6641, 3 /* Message */ , "Specify_a_list_of_glob_patterns_that_match_files_to_be_included_in_compilation_6641", "Specify a list of glob patterns that match files to be included in compilation."),
        Save_tsbuildinfo_files_to_allow_for_incremental_compilation_of_projects: diag(6642, 3 /* Message */ , "Save_tsbuildinfo_files_to_allow_for_incremental_compilation_of_projects_6642", "Save .tsbuildinfo files to allow for incremental compilation of projects."),
        Include_sourcemap_files_inside_the_emitted_JavaScript: diag(6643, 3 /* Message */ , "Include_sourcemap_files_inside_the_emitted_JavaScript_6643", "Include sourcemap files inside the emitted JavaScript."),
        Include_source_code_in_the_sourcemaps_inside_the_emitted_JavaScript: diag(6644, 3 /* Message */ , "Include_source_code_in_the_sourcemaps_inside_the_emitted_JavaScript_6644", "Include source code in the sourcemaps inside the emitted JavaScript."),
        Ensure_that_each_file_can_be_safely_transpiled_without_relying_on_other_imports: diag(6645, 3 /* Message */ , "Ensure_that_each_file_can_be_safely_transpiled_without_relying_on_other_imports_6645", "Ensure that each file can be safely transpiled without relying on other imports."),
        Specify_what_JSX_code_is_generated: diag(6646, 3 /* Message */ , "Specify_what_JSX_code_is_generated_6646", "Specify what JSX code is generated."),
        Specify_the_JSX_factory_function_used_when_targeting_React_JSX_emit_e_g_React_createElement_or_h: diag(6647, 3 /* Message */ , "Specify_the_JSX_factory_function_used_when_targeting_React_JSX_emit_e_g_React_createElement_or_h_6647", "Specify the JSX factory function used when targeting React JSX emit, e.g. 'React.createElement' or 'h'."),
        Specify_the_JSX_Fragment_reference_used_for_fragments_when_targeting_React_JSX_emit_e_g_React_Fragment_or_Fragment: diag(6648, 3 /* Message */ , "Specify_the_JSX_Fragment_reference_used_for_fragments_when_targeting_React_JSX_emit_e_g_React_Fragme_6648", "Specify the JSX Fragment reference used for fragments when targeting React JSX emit e.g. 'React.Fragment' or 'Fragment'."),
        Specify_module_specifier_used_to_import_the_JSX_factory_functions_when_using_jsx_Colon_react_jsx_Asterisk: diag(6649, 3 /* Message */ , "Specify_module_specifier_used_to_import_the_JSX_factory_functions_when_using_jsx_Colon_react_jsx_Ast_6649", "Specify module specifier used to import the JSX factory functions when using 'jsx: react-jsx*'."),
        Make_keyof_only_return_strings_instead_of_string_numbers_or_symbols_Legacy_option: diag(6650, 3 /* Message */ , "Make_keyof_only_return_strings_instead_of_string_numbers_or_symbols_Legacy_option_6650", "Make keyof only return strings instead of string, numbers or symbols. Legacy option."),
        Specify_a_set_of_bundled_library_declaration_files_that_describe_the_target_runtime_environment: diag(6651, 3 /* Message */ , "Specify_a_set_of_bundled_library_declaration_files_that_describe_the_target_runtime_environment_6651", "Specify a set of bundled library declaration files that describe the target runtime environment."),
        Print_the_names_of_emitted_files_after_a_compilation: diag(6652, 3 /* Message */ , "Print_the_names_of_emitted_files_after_a_compilation_6652", "Print the names of emitted files after a compilation."),
        Print_all_of_the_files_read_during_the_compilation: diag(6653, 3 /* Message */ , "Print_all_of_the_files_read_during_the_compilation_6653", "Print all of the files read during the compilation."),
        Set_the_language_of_the_messaging_from_TypeScript_This_does_not_affect_emit: diag(6654, 3 /* Message */ , "Set_the_language_of_the_messaging_from_TypeScript_This_does_not_affect_emit_6654", "Set the language of the messaging from TypeScript. This does not affect emit."),
        Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations: diag(6655, 3 /* Message */ , "Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations_6655", "Specify the location where debugger should locate map files instead of generated locations."),
        Specify_the_maximum_folder_depth_used_for_checking_JavaScript_files_from_node_modules_Only_applicable_with_allowJs: diag(6656, 3 /* Message */ , "Specify_the_maximum_folder_depth_used_for_checking_JavaScript_files_from_node_modules_Only_applicabl_6656", "Specify the maximum folder depth used for checking JavaScript files from 'node_modules'. Only applicable with 'allowJs'."),
        Specify_what_module_code_is_generated: diag(6657, 3 /* Message */ , "Specify_what_module_code_is_generated_6657", "Specify what module code is generated."),
        Specify_how_TypeScript_looks_up_a_file_from_a_given_module_specifier: diag(6658, 3 /* Message */ , "Specify_how_TypeScript_looks_up_a_file_from_a_given_module_specifier_6658", "Specify how TypeScript looks up a file from a given module specifier."),
        Set_the_newline_character_for_emitting_files: diag(6659, 3 /* Message */ , "Set_the_newline_character_for_emitting_files_6659", "Set the newline character for emitting files."),
        Disable_emitting_files_from_a_compilation: diag(6660, 3 /* Message */ , "Disable_emitting_files_from_a_compilation_6660", "Disable emitting files from a compilation."),
        Disable_generating_custom_helper_functions_like_extends_in_compiled_output: diag(6661, 3 /* Message */ , "Disable_generating_custom_helper_functions_like_extends_in_compiled_output_6661", "Disable generating custom helper functions like '__extends' in compiled output."),
        Disable_emitting_files_if_any_type_checking_errors_are_reported: diag(6662, 3 /* Message */ , "Disable_emitting_files_if_any_type_checking_errors_are_reported_6662", "Disable emitting files if any type checking errors are reported."),
        Disable_truncating_types_in_error_messages: diag(6663, 3 /* Message */ , "Disable_truncating_types_in_error_messages_6663", "Disable truncating types in error messages."),
        Enable_error_reporting_for_fallthrough_cases_in_switch_statements: diag(6664, 3 /* Message */ , "Enable_error_reporting_for_fallthrough_cases_in_switch_statements_6664", "Enable error reporting for fallthrough cases in switch statements."),
        Enable_error_reporting_for_expressions_and_declarations_with_an_implied_any_type: diag(6665, 3 /* Message */ , "Enable_error_reporting_for_expressions_and_declarations_with_an_implied_any_type_6665", "Enable error reporting for expressions and declarations with an implied 'any' type."),
        Ensure_overriding_members_in_derived_classes_are_marked_with_an_override_modifier: diag(6666, 3 /* Message */ , "Ensure_overriding_members_in_derived_classes_are_marked_with_an_override_modifier_6666", "Ensure overriding members in derived classes are marked with an override modifier."),
        Enable_error_reporting_for_codepaths_that_do_not_explicitly_return_in_a_function: diag(6667, 3 /* Message */ , "Enable_error_reporting_for_codepaths_that_do_not_explicitly_return_in_a_function_6667", "Enable error reporting for codepaths that do not explicitly return in a function."),
        Enable_error_reporting_when_this_is_given_the_type_any: diag(6668, 3 /* Message */ , "Enable_error_reporting_when_this_is_given_the_type_any_6668", "Enable error reporting when 'this' is given the type 'any'."),
        Disable_adding_use_strict_directives_in_emitted_JavaScript_files: diag(6669, 3 /* Message */ , "Disable_adding_use_strict_directives_in_emitted_JavaScript_files_6669", "Disable adding 'use strict' directives in emitted JavaScript files."),
        Disable_including_any_library_files_including_the_default_lib_d_ts: diag(6670, 3 /* Message */ , "Disable_including_any_library_files_including_the_default_lib_d_ts_6670", "Disable including any library files, including the default lib.d.ts."),
        Enforces_using_indexed_accessors_for_keys_declared_using_an_indexed_type: diag(6671, 3 /* Message */ , "Enforces_using_indexed_accessors_for_keys_declared_using_an_indexed_type_6671", "Enforces using indexed accessors for keys declared using an indexed type."),
        Disallow_import_s_require_s_or_reference_s_from_expanding_the_number_of_files_TypeScript_should_add_to_a_project: diag(6672, 3 /* Message */ , "Disallow_import_s_require_s_or_reference_s_from_expanding_the_number_of_files_TypeScript_should_add__6672", "Disallow 'import's, 'require's or '<reference>'s from expanding the number of files TypeScript should add to a project."),
        Disable_strict_checking_of_generic_signatures_in_function_types: diag(6673, 3 /* Message */ , "Disable_strict_checking_of_generic_signatures_in_function_types_6673", "Disable strict checking of generic signatures in function types."),
        Add_undefined_to_a_type_when_accessed_using_an_index: diag(6674, 3 /* Message */ , "Add_undefined_to_a_type_when_accessed_using_an_index_6674", "Add 'undefined' to a type when accessed using an index."),
        Enable_error_reporting_when_local_variables_aren_t_read: diag(6675, 3 /* Message */ , "Enable_error_reporting_when_local_variables_aren_t_read_6675", "Enable error reporting when local variables aren't read."),
        Raise_an_error_when_a_function_parameter_isn_t_read: diag(6676, 3 /* Message */ , "Raise_an_error_when_a_function_parameter_isn_t_read_6676", "Raise an error when a function parameter isn't read."),
        Deprecated_setting_Use_outFile_instead: diag(6677, 3 /* Message */ , "Deprecated_setting_Use_outFile_instead_6677", "Deprecated setting. Use 'outFile' instead."),
        Specify_an_output_folder_for_all_emitted_files: diag(6678, 3 /* Message */ , "Specify_an_output_folder_for_all_emitted_files_6678", "Specify an output folder for all emitted files."),
        Specify_a_file_that_bundles_all_outputs_into_one_JavaScript_file_If_declaration_is_true_also_designates_a_file_that_bundles_all_d_ts_output: diag(6679, 3 /* Message */ , "Specify_a_file_that_bundles_all_outputs_into_one_JavaScript_file_If_declaration_is_true_also_designa_6679", "Specify a file that bundles all outputs into one JavaScript file. If 'declaration' is true, also designates a file that bundles all .d.ts output."),
        Specify_a_set_of_entries_that_re_map_imports_to_additional_lookup_locations: diag(6680, 3 /* Message */ , "Specify_a_set_of_entries_that_re_map_imports_to_additional_lookup_locations_6680", "Specify a set of entries that re-map imports to additional lookup locations."),
        Specify_a_list_of_language_service_plugins_to_include: diag(6681, 3 /* Message */ , "Specify_a_list_of_language_service_plugins_to_include_6681", "Specify a list of language service plugins to include."),
        Disable_erasing_const_enum_declarations_in_generated_code: diag(6682, 3 /* Message */ , "Disable_erasing_const_enum_declarations_in_generated_code_6682", "Disable erasing 'const enum' declarations in generated code."),
        Disable_resolving_symlinks_to_their_realpath_This_correlates_to_the_same_flag_in_node: diag(6683, 3 /* Message */ , "Disable_resolving_symlinks_to_their_realpath_This_correlates_to_the_same_flag_in_node_6683", "Disable resolving symlinks to their realpath. This correlates to the same flag in node."),
        Disable_wiping_the_console_in_watch_mode: diag(6684, 3 /* Message */ , "Disable_wiping_the_console_in_watch_mode_6684", "Disable wiping the console in watch mode."),
        Enable_color_and_formatting_in_TypeScript_s_output_to_make_compiler_errors_easier_to_read: diag(6685, 3 /* Message */ , "Enable_color_and_formatting_in_TypeScript_s_output_to_make_compiler_errors_easier_to_read_6685", "Enable color and formatting in TypeScript's output to make compiler errors easier to read."),
        Specify_the_object_invoked_for_createElement_This_only_applies_when_targeting_react_JSX_emit: diag(6686, 3 /* Message */ , "Specify_the_object_invoked_for_createElement_This_only_applies_when_targeting_react_JSX_emit_6686", "Specify the object invoked for 'createElement'. This only applies when targeting 'react' JSX emit."),
        Specify_an_array_of_objects_that_specify_paths_for_projects_Used_in_project_references: diag(6687, 3 /* Message */ , "Specify_an_array_of_objects_that_specify_paths_for_projects_Used_in_project_references_6687", "Specify an array of objects that specify paths for projects. Used in project references."),
        Disable_emitting_comments: diag(6688, 3 /* Message */ , "Disable_emitting_comments_6688", "Disable emitting comments."),
        Enable_importing_json_files: diag(6689, 3 /* Message */ , "Enable_importing_json_files_6689", "Enable importing .json files."),
        Specify_the_root_folder_within_your_source_files: diag(6690, 3 /* Message */ , "Specify_the_root_folder_within_your_source_files_6690", "Specify the root folder within your source files."),
        Allow_multiple_folders_to_be_treated_as_one_when_resolving_modules: diag(6691, 3 /* Message */ , "Allow_multiple_folders_to_be_treated_as_one_when_resolving_modules_6691", "Allow multiple folders to be treated as one when resolving modules."),
        Skip_type_checking_d_ts_files_that_are_included_with_TypeScript: diag(6692, 3 /* Message */ , "Skip_type_checking_d_ts_files_that_are_included_with_TypeScript_6692", "Skip type checking .d.ts files that are included with TypeScript."),
        Skip_type_checking_all_d_ts_files: diag(6693, 3 /* Message */ , "Skip_type_checking_all_d_ts_files_6693", "Skip type checking all .d.ts files."),
        Create_source_map_files_for_emitted_JavaScript_files: diag(6694, 3 /* Message */ , "Create_source_map_files_for_emitted_JavaScript_files_6694", "Create source map files for emitted JavaScript files."),
        Specify_the_root_path_for_debuggers_to_find_the_reference_source_code: diag(6695, 3 /* Message */ , "Specify_the_root_path_for_debuggers_to_find_the_reference_source_code_6695", "Specify the root path for debuggers to find the reference source code."),
        Check_that_the_arguments_for_bind_call_and_apply_methods_match_the_original_function: diag(6697, 3 /* Message */ , "Check_that_the_arguments_for_bind_call_and_apply_methods_match_the_original_function_6697", "Check that the arguments for 'bind', 'call', and 'apply' methods match the original function."),
        When_assigning_functions_check_to_ensure_parameters_and_the_return_values_are_subtype_compatible: diag(6698, 3 /* Message */ , "When_assigning_functions_check_to_ensure_parameters_and_the_return_values_are_subtype_compatible_6698", "When assigning functions, check to ensure parameters and the return values are subtype-compatible."),
        When_type_checking_take_into_account_null_and_undefined: diag(6699, 3 /* Message */ , "When_type_checking_take_into_account_null_and_undefined_6699", "When type checking, take into account 'null' and 'undefined'."),
        Check_for_class_properties_that_are_declared_but_not_set_in_the_constructor: diag(6700, 3 /* Message */ , "Check_for_class_properties_that_are_declared_but_not_set_in_the_constructor_6700", "Check for class properties that are declared but not set in the constructor."),
        Disable_emitting_declarations_that_have_internal_in_their_JSDoc_comments: diag(6701, 3 /* Message */ , "Disable_emitting_declarations_that_have_internal_in_their_JSDoc_comments_6701", "Disable emitting declarations that have '@internal' in their JSDoc comments."),
        Disable_reporting_of_excess_property_errors_during_the_creation_of_object_literals: diag(6702, 3 /* Message */ , "Disable_reporting_of_excess_property_errors_during_the_creation_of_object_literals_6702", "Disable reporting of excess property errors during the creation of object literals."),
        Suppress_noImplicitAny_errors_when_indexing_objects_that_lack_index_signatures: diag(6703, 3 /* Message */ , "Suppress_noImplicitAny_errors_when_indexing_objects_that_lack_index_signatures_6703", "Suppress 'noImplicitAny' errors when indexing objects that lack index signatures."),
        Synchronously_call_callbacks_and_update_the_state_of_directory_watchers_on_platforms_that_don_t_support_recursive_watching_natively: diag(6704, 3 /* Message */ , "Synchronously_call_callbacks_and_update_the_state_of_directory_watchers_on_platforms_that_don_t_supp_6704", "Synchronously call callbacks and update the state of directory watchers on platforms that don`t support recursive watching natively."),
        Set_the_JavaScript_language_version_for_emitted_JavaScript_and_include_compatible_library_declarations: diag(6705, 3 /* Message */ , "Set_the_JavaScript_language_version_for_emitted_JavaScript_and_include_compatible_library_declaratio_6705", "Set the JavaScript language version for emitted JavaScript and include compatible library declarations."),
        Log_paths_used_during_the_moduleResolution_process: diag(6706, 3 /* Message */ , "Log_paths_used_during_the_moduleResolution_process_6706", "Log paths used during the 'moduleResolution' process."),
        Specify_the_path_to_tsbuildinfo_incremental_compilation_file: diag(6707, 3 /* Message */ , "Specify_the_path_to_tsbuildinfo_incremental_compilation_file_6707", "Specify the path to .tsbuildinfo incremental compilation file."),
        Specify_options_for_automatic_acquisition_of_declaration_files: diag(6709, 3 /* Message */ , "Specify_options_for_automatic_acquisition_of_declaration_files_6709", "Specify options for automatic acquisition of declaration files."),
        Specify_multiple_folders_that_act_like_Slashnode_modules_Slash_types: diag(6710, 3 /* Message */ , "Specify_multiple_folders_that_act_like_Slashnode_modules_Slash_types_6710", "Specify multiple folders that act like './node_modules/@types'."),
        Specify_type_package_names_to_be_included_without_being_referenced_in_a_source_file: diag(6711, 3 /* Message */ , "Specify_type_package_names_to_be_included_without_being_referenced_in_a_source_file_6711", "Specify type package names to be included without being referenced in a source file."),
        Emit_ECMAScript_standard_compliant_class_fields: diag(6712, 3 /* Message */ , "Emit_ECMAScript_standard_compliant_class_fields_6712", "Emit ECMAScript-standard-compliant class fields."),
        Enable_verbose_logging: diag(6713, 3 /* Message */ , "Enable_verbose_logging_6713", "Enable verbose logging."),
        Specify_how_directories_are_watched_on_systems_that_lack_recursive_file_watching_functionality: diag(6714, 3 /* Message */ , "Specify_how_directories_are_watched_on_systems_that_lack_recursive_file_watching_functionality_6714", "Specify how directories are watched on systems that lack recursive file-watching functionality."),
        Specify_how_the_TypeScript_watch_mode_works: diag(6715, 3 /* Message */ , "Specify_how_the_TypeScript_watch_mode_works_6715", "Specify how the TypeScript watch mode works."),
        Require_undeclared_properties_from_index_signatures_to_use_element_accesses: diag(6717, 3 /* Message */ , "Require_undeclared_properties_from_index_signatures_to_use_element_accesses_6717", "Require undeclared properties from index signatures to use element accesses."),
        Specify_emit_Slashchecking_behavior_for_imports_that_are_only_used_for_types: diag(6718, 3 /* Message */ , "Specify_emit_Slashchecking_behavior_for_imports_that_are_only_used_for_types_6718", "Specify emit/checking behavior for imports that are only used for types."),
        Require_sufficient_annotation_on_exports_so_other_tools_can_trivially_generate_declaration_files: diag(6719, 3 /* Message */ , "Require_sufficient_annotation_on_exports_so_other_tools_can_trivially_generate_declaration_files_6719", "Require sufficient annotation on exports so other tools can trivially generate declaration files."),
        Built_in_iterators_are_instantiated_with_a_TReturn_type_of_undefined_instead_of_any: diag(6720, 3 /* Message */ , "Built_in_iterators_are_instantiated_with_a_TReturn_type_of_undefined_instead_of_any_6720", "Built-in iterators are instantiated with a 'TReturn' type of 'undefined' instead of 'any'."),
        Do_not_allow_runtime_constructs_that_are_not_part_of_ECMAScript: diag(6721, 3 /* Message */ , "Do_not_allow_runtime_constructs_that_are_not_part_of_ECMAScript_6721", "Do not allow runtime constructs that are not part of ECMAScript."),
        Default_catch_clause_variables_as_unknown_instead_of_any: diag(6803, 3 /* Message */ , "Default_catch_clause_variables_as_unknown_instead_of_any_6803", "Default catch clause variables as 'unknown' instead of 'any'."),
        Do_not_transform_or_elide_any_imports_or_exports_not_marked_as_type_only_ensuring_they_are_written_in_the_output_file_s_format_based_on_the_module_setting: diag(6804, 3 /* Message */ , "Do_not_transform_or_elide_any_imports_or_exports_not_marked_as_type_only_ensuring_they_are_written_i_6804", "Do not transform or elide any imports or exports not marked as type-only, ensuring they are written in the output file's format based on the 'module' setting."),
        Disable_full_type_checking_only_critical_parse_and_emit_errors_will_be_reported: diag(6805, 3 /* Message */ , "Disable_full_type_checking_only_critical_parse_and_emit_errors_will_be_reported_6805", "Disable full type checking (only critical parse and emit errors will be reported)."),
        Check_side_effect_imports: diag(6806, 3 /* Message */ , "Check_side_effect_imports_6806", "Check side effect imports."),
        This_operation_can_be_simplified_This_shift_is_identical_to_0_1_2: diag(6807, 1 /* Error */ , "This_operation_can_be_simplified_This_shift_is_identical_to_0_1_2_6807", "This operation can be simplified. This shift is identical to `{0} {1} {2}`."),
        Enable_lib_replacement: diag(6808, 3 /* Message */ , "Enable_lib_replacement_6808", "Enable lib replacement."),
        one_of_Colon: diag(6900, 3 /* Message */ , "one_of_Colon_6900", "one of:"),
        one_or_more_Colon: diag(6901, 3 /* Message */ , "one_or_more_Colon_6901", "one or more:"),
        type_Colon: diag(6902, 3 /* Message */ , "type_Colon_6902", "type:"),
        default_Colon: diag(6903, 3 /* Message */ , "default_Colon_6903", "default:"),
        module_system_or_esModuleInterop: diag(6904, 3 /* Message */ , "module_system_or_esModuleInterop_6904", 'module === "system" or esModuleInterop'),
        false_unless_strict_is_set: diag(6905, 3 /* Message */ , "false_unless_strict_is_set_6905", "`false`, unless `strict` is set"),
        false_unless_composite_is_set: diag(6906, 3 /* Message */ , "false_unless_composite_is_set_6906", "`false`, unless `composite` is set"),
        node_modules_bower_components_jspm_packages_plus_the_value_of_outDir_if_one_is_specified: diag(6907, 3 /* Message */ , "node_modules_bower_components_jspm_packages_plus_the_value_of_outDir_if_one_is_specified_6907", '`["node_modules", "bower_components", "jspm_packages"]`, plus the value of `outDir` if one is specified.'),
        if_files_is_specified_otherwise_Asterisk_Asterisk_Slash_Asterisk: diag(6908, 3 /* Message */ , "if_files_is_specified_otherwise_Asterisk_Asterisk_Slash_Asterisk_6908", '`[]` if `files` is specified, otherwise `["**/*"]`'),
        true_if_composite_false_otherwise: diag(6909, 3 /* Message */ , "true_if_composite_false_otherwise_6909", "`true` if `composite`, `false` otherwise"),
        module_AMD_or_UMD_or_System_or_ES6_then_Classic_Otherwise_Node: diag(69010, 3 /* Message */ , "module_AMD_or_UMD_or_System_or_ES6_then_Classic_Otherwise_Node_69010", "module === `AMD` or `UMD` or `System` or `ES6`, then `Classic`, Otherwise `Node`"),
        Computed_from_the_list_of_input_files: diag(6911, 3 /* Message */ , "Computed_from_the_list_of_input_files_6911", "Computed from the list of input files"),
        Platform_specific: diag(6912, 3 /* Message */ , "Platform_specific_6912", "Platform specific"),
        You_can_learn_about_all_of_the_compiler_options_at_0: diag(6913, 3 /* Message */ , "You_can_learn_about_all_of_the_compiler_options_at_0_6913", "You can learn about all of the compiler options at {0}"),
        Including_watch_w_will_start_watching_the_current_project_for_the_file_changes_Once_set_you_can_config_watch_mode_with_Colon: diag(6914, 3 /* Message */ , "Including_watch_w_will_start_watching_the_current_project_for_the_file_changes_Once_set_you_can_conf_6914", "Including --watch, -w will start watching the current project for the file changes. Once set, you can config watch mode with:"),
        Using_build_b_will_make_tsc_behave_more_like_a_build_orchestrator_than_a_compiler_This_is_used_to_trigger_building_composite_projects_which_you_can_learn_more_about_at_0: diag(6915, 3 /* Message */ , "Using_build_b_will_make_tsc_behave_more_like_a_build_orchestrator_than_a_compiler_This_is_used_to_tr_6915", "Using --build, -b will make tsc behave more like a build orchestrator than a compiler. This is used to trigger building composite projects which you can learn more about at {0}"),
        COMMON_COMMANDS: diag(6916, 3 /* Message */ , "COMMON_COMMANDS_6916", "COMMON COMMANDS"),
        ALL_COMPILER_OPTIONS: diag(6917, 3 /* Message */ , "ALL_COMPILER_OPTIONS_6917", "ALL COMPILER OPTIONS"),
        WATCH_OPTIONS: diag(6918, 3 /* Message */ , "WATCH_OPTIONS_6918", "WATCH OPTIONS"),
        BUILD_OPTIONS: diag(6919, 3 /* Message */ , "BUILD_OPTIONS_6919", "BUILD OPTIONS"),
        COMMON_COMPILER_OPTIONS: diag(6920, 3 /* Message */ , "COMMON_COMPILER_OPTIONS_6920", "COMMON COMPILER OPTIONS"),
        COMMAND_LINE_FLAGS: diag(6921, 3 /* Message */ , "COMMAND_LINE_FLAGS_6921", "COMMAND LINE FLAGS"),
        tsc_Colon_The_TypeScript_Compiler: diag(6922, 3 /* Message */ , "tsc_Colon_The_TypeScript_Compiler_6922", "tsc: The TypeScript Compiler"),
        Compiles_the_current_project_tsconfig_json_in_the_working_directory: diag(6923, 3 /* Message */ , "Compiles_the_current_project_tsconfig_json_in_the_working_directory_6923", "Compiles the current project (tsconfig.json in the working directory.)"),
        Ignoring_tsconfig_json_compiles_the_specified_files_with_default_compiler_options: diag(6924, 3 /* Message */ , "Ignoring_tsconfig_json_compiles_the_specified_files_with_default_compiler_options_6924", "Ignoring tsconfig.json, compiles the specified files with default compiler options."),
        Build_a_composite_project_in_the_working_directory: diag(6925, 3 /* Message */ , "Build_a_composite_project_in_the_working_directory_6925", "Build a composite project in the working directory."),
        Creates_a_tsconfig_json_with_the_recommended_settings_in_the_working_directory: diag(6926, 3 /* Message */ , "Creates_a_tsconfig_json_with_the_recommended_settings_in_the_working_directory_6926", "Creates a tsconfig.json with the recommended settings in the working directory."),
        Compiles_the_TypeScript_project_located_at_the_specified_path: diag(6927, 3 /* Message */ , "Compiles_the_TypeScript_project_located_at_the_specified_path_6927", "Compiles the TypeScript project located at the specified path."),
        An_expanded_version_of_this_information_showing_all_possible_compiler_options: diag(6928, 3 /* Message */ , "An_expanded_version_of_this_information_showing_all_possible_compiler_options_6928", "An expanded version of this information, showing all possible compiler options"),
        Compiles_the_current_project_with_additional_settings: diag(6929, 3 /* Message */ , "Compiles_the_current_project_with_additional_settings_6929", "Compiles the current project, with additional settings."),
        true_for_ES2022_and_above_including_ESNext: diag(6930, 3 /* Message */ , "true_for_ES2022_and_above_including_ESNext_6930", "`true` for ES2022 and above, including ESNext."),
        List_of_file_name_suffixes_to_search_when_resolving_a_module: diag(6931, 1 /* Error */ , "List_of_file_name_suffixes_to_search_when_resolving_a_module_6931", "List of file name suffixes to search when resolving a module."),
        Variable_0_implicitly_has_an_1_type: diag(7005, 1 /* Error */ , "Variable_0_implicitly_has_an_1_type_7005", "Variable '{0}' implicitly has an '{1}' type."),
        Parameter_0_implicitly_has_an_1_type: diag(7006, 1 /* Error */ , "Parameter_0_implicitly_has_an_1_type_7006", "Parameter '{0}' implicitly has an '{1}' type."),
        Member_0_implicitly_has_an_1_type: diag(7008, 1 /* Error */ , "Member_0_implicitly_has_an_1_type_7008", "Member '{0}' implicitly has an '{1}' type."),
        new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type: diag(7009, 1 /* Error */ , "new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type_7009", "'new' expression, whose target lacks a construct signature, implicitly has an 'any' type."),
        _0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type: diag(7010, 1 /* Error */ , "_0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type_7010", "'{0}', which lacks return-type annotation, implicitly has an '{1}' return type."),
        Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type: diag(7011, 1 /* Error */ , "Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type_7011", "Function expression, which lacks return-type annotation, implicitly has an '{0}' return type."),
        This_overload_implicitly_returns_the_type_0_because_it_lacks_a_return_type_annotation: diag(7012, 1 /* Error */ , "This_overload_implicitly_returns_the_type_0_because_it_lacks_a_return_type_annotation_7012", "This overload implicitly returns the type '{0}' because it lacks a return type annotation."),
        Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7013, 1 /* Error */ , "Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7013", "Construct signature, which lacks return-type annotation, implicitly has an 'any' return type."),
        Function_type_which_lacks_return_type_annotation_implicitly_has_an_0_return_type: diag(7014, 1 /* Error */ , "Function_type_which_lacks_return_type_annotation_implicitly_has_an_0_return_type_7014", "Function type, which lacks return-type annotation, implicitly has an '{0}' return type."),
        Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number: diag(7015, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number_7015", "Element implicitly has an 'any' type because index expression is not of type 'number'."),
        Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type: diag(7016, 1 /* Error */ , "Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type_7016", "Could not find a declaration file for module '{0}'. '{1}' implicitly has an 'any' type."),
        Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature: diag(7017, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_7017", "Element implicitly has an 'any' type because type '{0}' has no index signature."),
        Object_literal_s_property_0_implicitly_has_an_1_type: diag(7018, 1 /* Error */ , "Object_literal_s_property_0_implicitly_has_an_1_type_7018", "Object literal's property '{0}' implicitly has an '{1}' type."),
        Rest_parameter_0_implicitly_has_an_any_type: diag(7019, 1 /* Error */ , "Rest_parameter_0_implicitly_has_an_any_type_7019", "Rest parameter '{0}' implicitly has an 'any[]' type."),
        Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7020, 1 /* Error */ , "Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7020", "Call signature, which lacks return-type annotation, implicitly has an 'any' return type."),
        _0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer: diag(7022, 1 /* Error */ , "_0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or__7022", "'{0}' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer."),
        _0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7023, 1 /* Error */ , "_0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_reference_7023", "'{0}' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
        Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7024, 1 /* Error */ , "Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_ref_7024", "Function implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
        Generator_implicitly_has_yield_type_0_Consider_supplying_a_return_type_annotation: diag(7025, 1 /* Error */ , "Generator_implicitly_has_yield_type_0_Consider_supplying_a_return_type_annotation_7025", "Generator implicitly has yield type '{0}'. Consider supplying a return type annotation."),
        JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists: diag(7026, 1 /* Error */ , "JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists_7026", "JSX element implicitly has type 'any' because no interface 'JSX.{0}' exists."),
        Unreachable_code_detected: diag(7027, 1 /* Error */ , "Unreachable_code_detected_7027", "Unreachable code detected.", /*reportsUnnecessary*/ true),
        Unused_label: diag(7028, 1 /* Error */ , "Unused_label_7028", "Unused label.", /*reportsUnnecessary*/ true),
        Fallthrough_case_in_switch: diag(7029, 1 /* Error */ , "Fallthrough_case_in_switch_7029", "Fallthrough case in switch."),
        Not_all_code_paths_return_a_value: diag(7030, 1 /* Error */ , "Not_all_code_paths_return_a_value_7030", "Not all code paths return a value."),
        Binding_element_0_implicitly_has_an_1_type: diag(7031, 1 /* Error */ , "Binding_element_0_implicitly_has_an_1_type_7031", "Binding element '{0}' implicitly has an '{1}' type."),
        Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation: diag(7032, 1 /* Error */ , "Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation_7032", "Property '{0}' implicitly has type 'any', because its set accessor lacks a parameter type annotation."),
        Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation: diag(7033, 1 /* Error */ , "Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation_7033", "Property '{0}' implicitly has type 'any', because its get accessor lacks a return type annotation."),
        Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined: diag(7034, 1 /* Error */ , "Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined_7034", "Variable '{0}' implicitly has type '{1}' in some locations where its type cannot be determined."),
        Try_npm_i_save_dev_types_Slash_1_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0: diag(7035, 1 /* Error */ , "Try_npm_i_save_dev_types_Slash_1_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare__7035", "Try `npm i --save-dev @types/{1}` if it exists or add a new declaration (.d.ts) file containing `declare module '{0}';`"),
        Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0: diag(7036, 1 /* Error */ , "Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0_7036", "Dynamic import's specifier must be of type 'string', but here has type '{0}'."),
        Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for_all_imports_Implies_allowSyntheticDefaultImports: diag(7037, 3 /* Message */ , "Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for__7037", "Enables emit interoperability between CommonJS and ES Modules via creation of namespace objects for all imports. Implies 'allowSyntheticDefaultImports'."),
        Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_Consider_using_a_default_import_or_import_require_here_instead: diag(7038, 3 /* Message */ , "Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cau_7038", "Type originates at this import. A namespace-style import cannot be called or constructed, and will cause a failure at runtime. Consider using a default import or import require here instead."),
        Mapped_object_type_implicitly_has_an_any_template_type: diag(7039, 1 /* Error */ , "Mapped_object_type_implicitly_has_an_any_template_type_7039", "Mapped object type implicitly has an 'any' template type."),
        If_the_0_package_actually_exposes_this_module_consider_sending_a_pull_request_to_amend_https_Colon_Slash_Slashgithub_com_SlashDefinitelyTyped_SlashDefinitelyTyped_Slashtree_Slashmaster_Slashtypes_Slash_1: diag(7040, 1 /* Error */ , "If_the_0_package_actually_exposes_this_module_consider_sending_a_pull_request_to_amend_https_Colon_S_7040", "If the '{0}' package actually exposes this module, consider sending a pull request to amend 'https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/{1}'"),
        The_containing_arrow_function_captures_the_global_value_of_this: diag(7041, 1 /* Error */ , "The_containing_arrow_function_captures_the_global_value_of_this_7041", "The containing arrow function captures the global value of 'this'."),
        Module_0_was_resolved_to_1_but_resolveJsonModule_is_not_used: diag(7042, 1 /* Error */ , "Module_0_was_resolved_to_1_but_resolveJsonModule_is_not_used_7042", "Module '{0}' was resolved to '{1}', but '--resolveJsonModule' is not used."),
        Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage: diag(7043, 2 /* Suggestion */ , "Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage_7043", "Variable '{0}' implicitly has an '{1}' type, but a better type may be inferred from usage."),
        Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage: diag(7044, 2 /* Suggestion */ , "Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage_7044", "Parameter '{0}' implicitly has an '{1}' type, but a better type may be inferred from usage."),
        Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage: diag(7045, 2 /* Suggestion */ , "Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage_7045", "Member '{0}' implicitly has an '{1}' type, but a better type may be inferred from usage."),
        Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage: diag(7046, 2 /* Suggestion */ , "Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage_7046", "Variable '{0}' implicitly has type '{1}' in some locations, but a better type may be inferred from usage."),
        Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage: diag(7047, 2 /* Suggestion */ , "Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage_7047", "Rest parameter '{0}' implicitly has an 'any[]' type, but a better type may be inferred from usage."),
        Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage: diag(7048, 2 /* Suggestion */ , "Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage_7048", "Property '{0}' implicitly has type 'any', but a better type for its get accessor may be inferred from usage."),
        Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage: diag(7049, 2 /* Suggestion */ , "Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage_7049", "Property '{0}' implicitly has type 'any', but a better type for its set accessor may be inferred from usage."),
        _0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage: diag(7050, 2 /* Suggestion */ , "_0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage_7050", "'{0}' implicitly has an '{1}' return type, but a better type may be inferred from usage."),
        Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1: diag(7051, 1 /* Error */ , "Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1_7051", "Parameter has a name but no type. Did you mean '{0}: {1}'?"),
        Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_Did_you_mean_to_call_1: diag(7052, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_Did_you_mean_to_call_1_7052", "Element implicitly has an 'any' type because type '{0}' has no index signature. Did you mean to call '{1}'?"),
        Element_implicitly_has_an_any_type_because_expression_of_type_0_can_t_be_used_to_index_type_1: diag(7053, 1 /* Error */ , "Element_implicitly_has_an_any_type_because_expression_of_type_0_can_t_be_used_to_index_type_1_7053", "Element implicitly has an 'any' type because expression of type '{0}' can't be used to index type '{1}'."),
        No_index_signature_with_a_parameter_of_type_0_was_found_on_type_1: diag(7054, 1 /* Error */ , "No_index_signature_with_a_parameter_of_type_0_was_found_on_type_1_7054", "No index signature with a parameter of type '{0}' was found on type '{1}'."),
        _0_which_lacks_return_type_annotation_implicitly_has_an_1_yield_type: diag(7055, 1 /* Error */ , "_0_which_lacks_return_type_annotation_implicitly_has_an_1_yield_type_7055", "'{0}', which lacks return-type annotation, implicitly has an '{1}' yield type."),
        The_inferred_type_of_this_node_exceeds_the_maximum_length_the_compiler_will_serialize_An_explicit_type_annotation_is_needed: diag(7056, 1 /* Error */ , "The_inferred_type_of_this_node_exceeds_the_maximum_length_the_compiler_will_serialize_An_explicit_ty_7056", "The inferred type of this node exceeds the maximum length the compiler will serialize. An explicit type annotation is needed."),
        yield_expression_implicitly_results_in_an_any_type_because_its_containing_generator_lacks_a_return_type_annotation: diag(7057, 1 /* Error */ , "yield_expression_implicitly_results_in_an_any_type_because_its_containing_generator_lacks_a_return_t_7057", "'yield' expression implicitly results in an 'any' type because its containing generator lacks a return-type annotation."),
        If_the_0_package_actually_exposes_this_module_try_adding_a_new_declaration_d_ts_file_containing_declare_module_1: diag(7058, 1 /* Error */ , "If_the_0_package_actually_exposes_this_module_try_adding_a_new_declaration_d_ts_file_containing_decl_7058", "If the '{0}' package actually exposes this module, try adding a new declaration (.d.ts) file containing `declare module '{1}';`"),
        This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Use_an_as_expression_instead: diag(7059, 1 /* Error */ , "This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Use_an_as_expression_instead_7059", "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead."),
        This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Add_a_trailing_comma_or_explicit_constraint: diag(7060, 1 /* Error */ , "This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Add_a_trailing_comma_or_explicit_cons_7060", "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma or explicit constraint."),
        A_mapped_type_may_not_declare_properties_or_methods: diag(7061, 1 /* Error */ , "A_mapped_type_may_not_declare_properties_or_methods_7061", "A mapped type may not declare properties or methods."),
        You_cannot_rename_this_element: diag(8e3, 1 /* Error */ , "You_cannot_rename_this_element_8000", "You cannot rename this element."),
        You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library: diag(8001, 1 /* Error */ , "You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library_8001", "You cannot rename elements that are defined in the standard TypeScript library."),
        import_can_only_be_used_in_TypeScript_files: diag(8002, 1 /* Error */ , "import_can_only_be_used_in_TypeScript_files_8002", "'import ... =' can only be used in TypeScript files."),
        export_can_only_be_used_in_TypeScript_files: diag(8003, 1 /* Error */ , "export_can_only_be_used_in_TypeScript_files_8003", "'export =' can only be used in TypeScript files."),
        Type_parameter_declarations_can_only_be_used_in_TypeScript_files: diag(8004, 1 /* Error */ , "Type_parameter_declarations_can_only_be_used_in_TypeScript_files_8004", "Type parameter declarations can only be used in TypeScript files."),
        implements_clauses_can_only_be_used_in_TypeScript_files: diag(8005, 1 /* Error */ , "implements_clauses_can_only_be_used_in_TypeScript_files_8005", "'implements' clauses can only be used in TypeScript files."),
        _0_declarations_can_only_be_used_in_TypeScript_files: diag(8006, 1 /* Error */ , "_0_declarations_can_only_be_used_in_TypeScript_files_8006", "'{0}' declarations can only be used in TypeScript files."),
        Type_aliases_can_only_be_used_in_TypeScript_files: diag(8008, 1 /* Error */ , "Type_aliases_can_only_be_used_in_TypeScript_files_8008", "Type aliases can only be used in TypeScript files."),
        The_0_modifier_can_only_be_used_in_TypeScript_files: diag(8009, 1 /* Error */ , "The_0_modifier_can_only_be_used_in_TypeScript_files_8009", "The '{0}' modifier can only be used in TypeScript files."),
        Type_annotations_can_only_be_used_in_TypeScript_files: diag(8010, 1 /* Error */ , "Type_annotations_can_only_be_used_in_TypeScript_files_8010", "Type annotations can only be used in TypeScript files."),
        Type_arguments_can_only_be_used_in_TypeScript_files: diag(8011, 1 /* Error */ , "Type_arguments_can_only_be_used_in_TypeScript_files_8011", "Type arguments can only be used in TypeScript files."),
        Parameter_modifiers_can_only_be_used_in_TypeScript_files: diag(8012, 1 /* Error */ , "Parameter_modifiers_can_only_be_used_in_TypeScript_files_8012", "Parameter modifiers can only be used in TypeScript files."),
        Non_null_assertions_can_only_be_used_in_TypeScript_files: diag(8013, 1 /* Error */ , "Non_null_assertions_can_only_be_used_in_TypeScript_files_8013", "Non-null assertions can only be used in TypeScript files."),
        Type_assertion_expressions_can_only_be_used_in_TypeScript_files: diag(8016, 1 /* Error */ , "Type_assertion_expressions_can_only_be_used_in_TypeScript_files_8016", "Type assertion expressions can only be used in TypeScript files."),
        Signature_declarations_can_only_be_used_in_TypeScript_files: diag(8017, 1 /* Error */ , "Signature_declarations_can_only_be_used_in_TypeScript_files_8017", "Signature declarations can only be used in TypeScript files."),
        Report_errors_in_js_files: diag(8019, 3 /* Message */ , "Report_errors_in_js_files_8019", "Report errors in .js files."),
        JSDoc_types_can_only_be_used_inside_documentation_comments: diag(8020, 1 /* Error */ , "JSDoc_types_can_only_be_used_inside_documentation_comments_8020", "JSDoc types can only be used inside documentation comments."),
        JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags: diag(8021, 1 /* Error */ , "JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags_8021", "JSDoc '@typedef' tag should either have a type annotation or be followed by '@property' or '@member' tags."),
        JSDoc_0_is_not_attached_to_a_class: diag(8022, 1 /* Error */ , "JSDoc_0_is_not_attached_to_a_class_8022", "JSDoc '@{0}' is not attached to a class."),
        JSDoc_0_1_does_not_match_the_extends_2_clause: diag(8023, 1 /* Error */ , "JSDoc_0_1_does_not_match_the_extends_2_clause_8023", "JSDoc '@{0} {1}' does not match the 'extends {2}' clause."),
        JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name: diag(8024, 1 /* Error */ , "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_8024", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name."),
        Class_declarations_cannot_have_more_than_one_augments_or_extends_tag: diag(8025, 1 /* Error */ , "Class_declarations_cannot_have_more_than_one_augments_or_extends_tag_8025", "Class declarations cannot have more than one '@augments' or '@extends' tag."),
        Expected_0_type_arguments_provide_these_with_an_extends_tag: diag(8026, 1 /* Error */ , "Expected_0_type_arguments_provide_these_with_an_extends_tag_8026", "Expected {0} type arguments; provide these with an '@extends' tag."),
        Expected_0_1_type_arguments_provide_these_with_an_extends_tag: diag(8027, 1 /* Error */ , "Expected_0_1_type_arguments_provide_these_with_an_extends_tag_8027", "Expected {0}-{1} type arguments; provide these with an '@extends' tag."),
        JSDoc_may_only_appear_in_the_last_parameter_of_a_signature: diag(8028, 1 /* Error */ , "JSDoc_may_only_appear_in_the_last_parameter_of_a_signature_8028", "JSDoc '...' may only appear in the last parameter of a signature."),
        JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_had_an_array_type: diag(8029, 1 /* Error */ , "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_h_8029", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name. It would match 'arguments' if it had an array type."),
        The_type_of_a_function_declaration_must_match_the_function_s_signature: diag(8030, 1 /* Error */ , "The_type_of_a_function_declaration_must_match_the_function_s_signature_8030", "The type of a function declaration must match the function's signature."),
        You_cannot_rename_a_module_via_a_global_import: diag(8031, 1 /* Error */ , "You_cannot_rename_a_module_via_a_global_import_8031", "You cannot rename a module via a global import."),
        Qualified_name_0_is_not_allowed_without_a_leading_param_object_1: diag(8032, 1 /* Error */ , "Qualified_name_0_is_not_allowed_without_a_leading_param_object_1_8032", "Qualified name '{0}' is not allowed without a leading '@param {object} {1}'."),
        A_JSDoc_typedef_comment_may_not_contain_multiple_type_tags: diag(8033, 1 /* Error */ , "A_JSDoc_typedef_comment_may_not_contain_multiple_type_tags_8033", "A JSDoc '@typedef' comment may not contain multiple '@type' tags."),
        The_tag_was_first_specified_here: diag(8034, 1 /* Error */ , "The_tag_was_first_specified_here_8034", "The tag was first specified here."),
        You_cannot_rename_elements_that_are_defined_in_a_node_modules_folder: diag(8035, 1 /* Error */ , "You_cannot_rename_elements_that_are_defined_in_a_node_modules_folder_8035", "You cannot rename elements that are defined in a 'node_modules' folder."),
        You_cannot_rename_elements_that_are_defined_in_another_node_modules_folder: diag(8036, 1 /* Error */ , "You_cannot_rename_elements_that_are_defined_in_another_node_modules_folder_8036", "You cannot rename elements that are defined in another 'node_modules' folder."),
        Type_satisfaction_expressions_can_only_be_used_in_TypeScript_files: diag(8037, 1 /* Error */ , "Type_satisfaction_expressions_can_only_be_used_in_TypeScript_files_8037", "Type satisfaction expressions can only be used in TypeScript files."),
        Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export: diag(8038, 1 /* Error */ , "Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export_8038", "Decorators may not appear after 'export' or 'export default' if they also appear before 'export'."),
        A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag: diag(8039, 1 /* Error */ , "A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag_8039", "A JSDoc '@template' tag may not follow a '@typedef', '@callback', or '@overload' tag"),
        Declaration_emit_for_this_file_requires_using_private_name_0_An_explicit_type_annotation_may_unblock_declaration_emit: diag(9005, 1 /* Error */ , "Declaration_emit_for_this_file_requires_using_private_name_0_An_explicit_type_annotation_may_unblock_9005", "Declaration emit for this file requires using private name '{0}'. An explicit type annotation may unblock declaration emit."),
        Declaration_emit_for_this_file_requires_using_private_name_0_from_module_1_An_explicit_type_annotation_may_unblock_declaration_emit: diag(9006, 1 /* Error */ , "Declaration_emit_for_this_file_requires_using_private_name_0_from_module_1_An_explicit_type_annotati_9006", "Declaration emit for this file requires using private name '{0}' from module '{1}'. An explicit type annotation may unblock declaration emit."),
        Function_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations: diag(9007, 1 /* Error */ , "Function_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations_9007", "Function must have an explicit return type annotation with --isolatedDeclarations."),
        Method_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations: diag(9008, 1 /* Error */ , "Method_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations_9008", "Method must have an explicit return type annotation with --isolatedDeclarations."),
        At_least_one_accessor_must_have_an_explicit_type_annotation_with_isolatedDeclarations: diag(9009, 1 /* Error */ , "At_least_one_accessor_must_have_an_explicit_type_annotation_with_isolatedDeclarations_9009", "At least one accessor must have an explicit type annotation with --isolatedDeclarations."),
        Variable_must_have_an_explicit_type_annotation_with_isolatedDeclarations: diag(9010, 1 /* Error */ , "Variable_must_have_an_explicit_type_annotation_with_isolatedDeclarations_9010", "Variable must have an explicit type annotation with --isolatedDeclarations."),
        Parameter_must_have_an_explicit_type_annotation_with_isolatedDeclarations: diag(9011, 1 /* Error */ , "Parameter_must_have_an_explicit_type_annotation_with_isolatedDeclarations_9011", "Parameter must have an explicit type annotation with --isolatedDeclarations."),
        Property_must_have_an_explicit_type_annotation_with_isolatedDeclarations: diag(9012, 1 /* Error */ , "Property_must_have_an_explicit_type_annotation_with_isolatedDeclarations_9012", "Property must have an explicit type annotation with --isolatedDeclarations."),
        Expression_type_can_t_be_inferred_with_isolatedDeclarations: diag(9013, 1 /* Error */ , "Expression_type_can_t_be_inferred_with_isolatedDeclarations_9013", "Expression type can't be inferred with --isolatedDeclarations."),
        Computed_properties_must_be_number_or_string_literals_variables_or_dotted_expressions_with_isolatedDeclarations: diag(9014, 1 /* Error */ , "Computed_properties_must_be_number_or_string_literals_variables_or_dotted_expressions_with_isolatedD_9014", "Computed properties must be number or string literals, variables or dotted expressions with --isolatedDeclarations."),
        Objects_that_contain_spread_assignments_can_t_be_inferred_with_isolatedDeclarations: diag(9015, 1 /* Error */ , "Objects_that_contain_spread_assignments_can_t_be_inferred_with_isolatedDeclarations_9015", "Objects that contain spread assignments can't be inferred with --isolatedDeclarations."),
        Objects_that_contain_shorthand_properties_can_t_be_inferred_with_isolatedDeclarations: diag(9016, 1 /* Error */ , "Objects_that_contain_shorthand_properties_can_t_be_inferred_with_isolatedDeclarations_9016", "Objects that contain shorthand properties can't be inferred with --isolatedDeclarations."),
        Only_const_arrays_can_be_inferred_with_isolatedDeclarations: diag(9017, 1 /* Error */ , "Only_const_arrays_can_be_inferred_with_isolatedDeclarations_9017", "Only const arrays can be inferred with --isolatedDeclarations."),
        Arrays_with_spread_elements_can_t_inferred_with_isolatedDeclarations: diag(9018, 1 /* Error */ , "Arrays_with_spread_elements_can_t_inferred_with_isolatedDeclarations_9018", "Arrays with spread elements can't inferred with --isolatedDeclarations."),
        Binding_elements_can_t_be_exported_directly_with_isolatedDeclarations: diag(9019, 1 /* Error */ , "Binding_elements_can_t_be_exported_directly_with_isolatedDeclarations_9019", "Binding elements can't be exported directly with --isolatedDeclarations."),
        Enum_member_initializers_must_be_computable_without_references_to_external_symbols_with_isolatedDeclarations: diag(9020, 1 /* Error */ , "Enum_member_initializers_must_be_computable_without_references_to_external_symbols_with_isolatedDecl_9020", "Enum member initializers must be computable without references to external symbols with --isolatedDeclarations."),
        Extends_clause_can_t_contain_an_expression_with_isolatedDeclarations: diag(9021, 1 /* Error */ , "Extends_clause_can_t_contain_an_expression_with_isolatedDeclarations_9021", "Extends clause can't contain an expression with --isolatedDeclarations."),
        Inference_from_class_expressions_is_not_supported_with_isolatedDeclarations: diag(9022, 1 /* Error */ , "Inference_from_class_expressions_is_not_supported_with_isolatedDeclarations_9022", "Inference from class expressions is not supported with --isolatedDeclarations."),
        Assigning_properties_to_functions_without_declaring_them_is_not_supported_with_isolatedDeclarations_Add_an_explicit_declaration_for_the_properties_assigned_to_this_function: diag(9023, 1 /* Error */ , "Assigning_properties_to_functions_without_declaring_them_is_not_supported_with_isolatedDeclarations__9023", "Assigning properties to functions without declaring them is not supported with --isolatedDeclarations. Add an explicit declaration for the properties assigned to this function."),
        Declaration_emit_for_this_parameter_requires_implicitly_adding_undefined_to_its_type_This_is_not_supported_with_isolatedDeclarations: diag(9025, 1 /* Error */ , "Declaration_emit_for_this_parameter_requires_implicitly_adding_undefined_to_its_type_This_is_not_sup_9025", "Declaration emit for this parameter requires implicitly adding undefined to its type. This is not supported with --isolatedDeclarations."),
        Declaration_emit_for_this_file_requires_preserving_this_import_for_augmentations_This_is_not_supported_with_isolatedDeclarations: diag(9026, 1 /* Error */ , "Declaration_emit_for_this_file_requires_preserving_this_import_for_augmentations_This_is_not_support_9026", "Declaration emit for this file requires preserving this import for augmentations. This is not supported with --isolatedDeclarations."),
        Add_a_type_annotation_to_the_variable_0: diag(9027, 1 /* Error */ , "Add_a_type_annotation_to_the_variable_0_9027", "Add a type annotation to the variable {0}."),
        Add_a_type_annotation_to_the_parameter_0: diag(9028, 1 /* Error */ , "Add_a_type_annotation_to_the_parameter_0_9028", "Add a type annotation to the parameter {0}."),
        Add_a_type_annotation_to_the_property_0: diag(9029, 1 /* Error */ , "Add_a_type_annotation_to_the_property_0_9029", "Add a type annotation to the property {0}."),
        Add_a_return_type_to_the_function_expression: diag(9030, 1 /* Error */ , "Add_a_return_type_to_the_function_expression_9030", "Add a return type to the function expression."),
        Add_a_return_type_to_the_function_declaration: diag(9031, 1 /* Error */ , "Add_a_return_type_to_the_function_declaration_9031", "Add a return type to the function declaration."),
        Add_a_return_type_to_the_get_accessor_declaration: diag(9032, 1 /* Error */ , "Add_a_return_type_to_the_get_accessor_declaration_9032", "Add a return type to the get accessor declaration."),
        Add_a_type_to_parameter_of_the_set_accessor_declaration: diag(9033, 1 /* Error */ , "Add_a_type_to_parameter_of_the_set_accessor_declaration_9033", "Add a type to parameter of the set accessor declaration."),
        Add_a_return_type_to_the_method: diag(9034, 1 /* Error */ , "Add_a_return_type_to_the_method_9034", "Add a return type to the method"),
        Add_satisfies_and_a_type_assertion_to_this_expression_satisfies_T_as_T_to_make_the_type_explicit: diag(9035, 1 /* Error */ , "Add_satisfies_and_a_type_assertion_to_this_expression_satisfies_T_as_T_to_make_the_type_explicit_9035", "Add satisfies and a type assertion to this expression (satisfies T as T) to make the type explicit."),
        Move_the_expression_in_default_export_to_a_variable_and_add_a_type_annotation_to_it: diag(9036, 1 /* Error */ , "Move_the_expression_in_default_export_to_a_variable_and_add_a_type_annotation_to_it_9036", "Move the expression in default export to a variable and add a type annotation to it."),
        Default_exports_can_t_be_inferred_with_isolatedDeclarations: diag(9037, 1 /* Error */ , "Default_exports_can_t_be_inferred_with_isolatedDeclarations_9037", "Default exports can't be inferred with --isolatedDeclarations."),
        Computed_property_names_on_class_or_object_literals_cannot_be_inferred_with_isolatedDeclarations: diag(9038, 1 /* Error */ , "Computed_property_names_on_class_or_object_literals_cannot_be_inferred_with_isolatedDeclarations_9038", "Computed property names on class or object literals cannot be inferred with --isolatedDeclarations."),
        Type_containing_private_name_0_can_t_be_used_with_isolatedDeclarations: diag(9039, 1 /* Error */ , "Type_containing_private_name_0_can_t_be_used_with_isolatedDeclarations_9039", "Type containing private name '{0}' can't be used with --isolatedDeclarations."),
        JSX_attributes_must_only_be_assigned_a_non_empty_expression: diag(17e3, 1 /* Error */ , "JSX_attributes_must_only_be_assigned_a_non_empty_expression_17000", "JSX attributes must only be assigned a non-empty 'expression'."),
        JSX_elements_cannot_have_multiple_attributes_with_the_same_name: diag(17001, 1 /* Error */ , "JSX_elements_cannot_have_multiple_attributes_with_the_same_name_17001", "JSX elements cannot have multiple attributes with the same name."),
        Expected_corresponding_JSX_closing_tag_for_0: diag(17002, 1 /* Error */ , "Expected_corresponding_JSX_closing_tag_for_0_17002", "Expected corresponding JSX closing tag for '{0}'."),
        Cannot_use_JSX_unless_the_jsx_flag_is_provided: diag(17004, 1 /* Error */ , "Cannot_use_JSX_unless_the_jsx_flag_is_provided_17004", "Cannot use JSX unless the '--jsx' flag is provided."),
        A_constructor_cannot_contain_a_super_call_when_its_class_extends_null: diag(17005, 1 /* Error */ , "A_constructor_cannot_contain_a_super_call_when_its_class_extends_null_17005", "A constructor cannot contain a 'super' call when its class extends 'null'."),
        An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17006, 1 /* Error */ , "An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_ex_17006", "An unary expression with the '{0}' operator is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
        A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17007, 1 /* Error */ , "A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Con_17007", "A type assertion expression is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
        JSX_element_0_has_no_corresponding_closing_tag: diag(17008, 1 /* Error */ , "JSX_element_0_has_no_corresponding_closing_tag_17008", "JSX element '{0}' has no corresponding closing tag."),
        super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class: diag(17009, 1 /* Error */ , "super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class_17009", "'super' must be called before accessing 'this' in the constructor of a derived class."),
        Unknown_type_acquisition_option_0: diag(17010, 1 /* Error */ , "Unknown_type_acquisition_option_0_17010", "Unknown type acquisition option '{0}'."),
        super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class: diag(17011, 1 /* Error */ , "super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class_17011", "'super' must be called before accessing a property of 'super' in the constructor of a derived class."),
        _0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2: diag(17012, 1 /* Error */ , "_0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2_17012", "'{0}' is not a valid meta-property for keyword '{1}'. Did you mean '{2}'?"),
        Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor: diag(17013, 1 /* Error */ , "Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constru_17013", "Meta-property '{0}' is only allowed in the body of a function declaration, function expression, or constructor."),
        JSX_fragment_has_no_corresponding_closing_tag: diag(17014, 1 /* Error */ , "JSX_fragment_has_no_corresponding_closing_tag_17014", "JSX fragment has no corresponding closing tag."),
        Expected_corresponding_closing_tag_for_JSX_fragment: diag(17015, 1 /* Error */ , "Expected_corresponding_closing_tag_for_JSX_fragment_17015", "Expected corresponding closing tag for JSX fragment."),
        The_jsxFragmentFactory_compiler_option_must_be_provided_to_use_JSX_fragments_with_the_jsxFactory_compiler_option: diag(17016, 1 /* Error */ , "The_jsxFragmentFactory_compiler_option_must_be_provided_to_use_JSX_fragments_with_the_jsxFactory_com_17016", "The 'jsxFragmentFactory' compiler option must be provided to use JSX fragments with the 'jsxFactory' compiler option."),
        An_jsxFrag_pragma_is_required_when_using_an_jsx_pragma_with_JSX_fragments: diag(17017, 1 /* Error */ , "An_jsxFrag_pragma_is_required_when_using_an_jsx_pragma_with_JSX_fragments_17017", "An @jsxFrag pragma is required when using an @jsx pragma with JSX fragments."),
        Unknown_type_acquisition_option_0_Did_you_mean_1: diag(17018, 1 /* Error */ , "Unknown_type_acquisition_option_0_Did_you_mean_1_17018", "Unknown type acquisition option '{0}'. Did you mean '{1}'?"),
        _0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1: diag(17019, 1 /* Error */ , "_0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1_17019", "'{0}' at the end of a type is not valid TypeScript syntax. Did you mean to write '{1}'?"),
        _0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1: diag(17020, 1 /* Error */ , "_0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1_17020", "'{0}' at the start of a type is not valid TypeScript syntax. Did you mean to write '{1}'?"),
        Unicode_escape_sequence_cannot_appear_here: diag(17021, 1 /* Error */ , "Unicode_escape_sequence_cannot_appear_here_17021", "Unicode escape sequence cannot appear here."),
        Circularity_detected_while_resolving_configuration_Colon_0: diag(18e3, 1 /* Error */ , "Circularity_detected_while_resolving_configuration_Colon_0_18000", "Circularity detected while resolving configuration: {0}"),
        The_files_list_in_config_file_0_is_empty: diag(18002, 1 /* Error */ , "The_files_list_in_config_file_0_is_empty_18002", "The 'files' list in config file '{0}' is empty."),
        No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2: diag(18003, 1 /* Error */ , "No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2_18003", "No inputs were found in config file '{0}'. Specified 'include' paths were '{1}' and 'exclude' paths were '{2}'."),
        File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module: diag(80001, 2 /* Suggestion */ , "File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module_80001", "File is a CommonJS module; it may be converted to an ES module."),
        This_constructor_function_may_be_converted_to_a_class_declaration: diag(80002, 2 /* Suggestion */ , "This_constructor_function_may_be_converted_to_a_class_declaration_80002", "This constructor function may be converted to a class declaration."),
        Import_may_be_converted_to_a_default_import: diag(80003, 2 /* Suggestion */ , "Import_may_be_converted_to_a_default_import_80003", "Import may be converted to a default import."),
        JSDoc_types_may_be_moved_to_TypeScript_types: diag(80004, 2 /* Suggestion */ , "JSDoc_types_may_be_moved_to_TypeScript_types_80004", "JSDoc types may be moved to TypeScript types."),
        require_call_may_be_converted_to_an_import: diag(80005, 2 /* Suggestion */ , "require_call_may_be_converted_to_an_import_80005", "'require' call may be converted to an import."),
        This_may_be_converted_to_an_async_function: diag(80006, 2 /* Suggestion */ , "This_may_be_converted_to_an_async_function_80006", "This may be converted to an async function."),
        await_has_no_effect_on_the_type_of_this_expression: diag(80007, 2 /* Suggestion */ , "await_has_no_effect_on_the_type_of_this_expression_80007", "'await' has no effect on the type of this expression."),
        Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accurately_as_integers: diag(80008, 2 /* Suggestion */ , "Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accur_80008", "Numeric literals with absolute values equal to 2^53 or greater are too large to be represented accurately as integers."),
        JSDoc_typedef_may_be_converted_to_TypeScript_type: diag(80009, 2 /* Suggestion */ , "JSDoc_typedef_may_be_converted_to_TypeScript_type_80009", "JSDoc typedef may be converted to TypeScript type."),
        JSDoc_typedefs_may_be_converted_to_TypeScript_types: diag(80010, 2 /* Suggestion */ , "JSDoc_typedefs_may_be_converted_to_TypeScript_types_80010", "JSDoc typedefs may be converted to TypeScript types."),
        Add_missing_super_call: diag(90001, 3 /* Message */ , "Add_missing_super_call_90001", "Add missing 'super()' call"),
        Make_super_call_the_first_statement_in_the_constructor: diag(90002, 3 /* Message */ , "Make_super_call_the_first_statement_in_the_constructor_90002", "Make 'super()' call the first statement in the constructor"),
        Change_extends_to_implements: diag(90003, 3 /* Message */ , "Change_extends_to_implements_90003", "Change 'extends' to 'implements'"),
        Remove_unused_declaration_for_Colon_0: diag(90004, 3 /* Message */ , "Remove_unused_declaration_for_Colon_0_90004", "Remove unused declaration for: '{0}'"),
        Remove_import_from_0: diag(90005, 3 /* Message */ , "Remove_import_from_0_90005", "Remove import from '{0}'"),
        Implement_interface_0: diag(90006, 3 /* Message */ , "Implement_interface_0_90006", "Implement interface '{0}'"),
        Implement_inherited_abstract_class: diag(90007, 3 /* Message */ , "Implement_inherited_abstract_class_90007", "Implement inherited abstract class"),
        Add_0_to_unresolved_variable: diag(90008, 3 /* Message */ , "Add_0_to_unresolved_variable_90008", "Add '{0}.' to unresolved variable"),
        Remove_variable_statement: diag(90010, 3 /* Message */ , "Remove_variable_statement_90010", "Remove variable statement"),
        Remove_template_tag: diag(90011, 3 /* Message */ , "Remove_template_tag_90011", "Remove template tag"),
        Remove_type_parameters: diag(90012, 3 /* Message */ , "Remove_type_parameters_90012", "Remove type parameters"),
        Import_0_from_1: diag(90013, 3 /* Message */ , "Import_0_from_1_90013", `Import '{0}' from "{1}"`),
        Change_0_to_1: diag(90014, 3 /* Message */ , "Change_0_to_1_90014", "Change '{0}' to '{1}'"),
        Declare_property_0: diag(90016, 3 /* Message */ , "Declare_property_0_90016", "Declare property '{0}'"),
        Add_index_signature_for_property_0: diag(90017, 3 /* Message */ , "Add_index_signature_for_property_0_90017", "Add index signature for property '{0}'"),
        Disable_checking_for_this_file: diag(90018, 3 /* Message */ , "Disable_checking_for_this_file_90018", "Disable checking for this file"),
        Ignore_this_error_message: diag(90019, 3 /* Message */ , "Ignore_this_error_message_90019", "Ignore this error message"),
        Initialize_property_0_in_the_constructor: diag(90020, 3 /* Message */ , "Initialize_property_0_in_the_constructor_90020", "Initialize property '{0}' in the constructor"),
        Initialize_static_property_0: diag(90021, 3 /* Message */ , "Initialize_static_property_0_90021", "Initialize static property '{0}'"),
        Change_spelling_to_0: diag(90022, 3 /* Message */ , "Change_spelling_to_0_90022", "Change spelling to '{0}'"),
        Declare_method_0: diag(90023, 3 /* Message */ , "Declare_method_0_90023", "Declare method '{0}'"),
        Declare_static_method_0: diag(90024, 3 /* Message */ , "Declare_static_method_0_90024", "Declare static method '{0}'"),
        Prefix_0_with_an_underscore: diag(90025, 3 /* Message */ , "Prefix_0_with_an_underscore_90025", "Prefix '{0}' with an underscore"),
        Rewrite_as_the_indexed_access_type_0: diag(90026, 3 /* Message */ , "Rewrite_as_the_indexed_access_type_0_90026", "Rewrite as the indexed access type '{0}'"),
        Declare_static_property_0: diag(90027, 3 /* Message */ , "Declare_static_property_0_90027", "Declare static property '{0}'"),
        Call_decorator_expression: diag(90028, 3 /* Message */ , "Call_decorator_expression_90028", "Call decorator expression"),
        Add_async_modifier_to_containing_function: diag(90029, 3 /* Message */ , "Add_async_modifier_to_containing_function_90029", "Add async modifier to containing function"),
        Replace_infer_0_with_unknown: diag(90030, 3 /* Message */ , "Replace_infer_0_with_unknown_90030", "Replace 'infer {0}' with 'unknown'"),
        Replace_all_unused_infer_with_unknown: diag(90031, 3 /* Message */ , "Replace_all_unused_infer_with_unknown_90031", "Replace all unused 'infer' with 'unknown'"),
        Add_parameter_name: diag(90034, 3 /* Message */ , "Add_parameter_name_90034", "Add parameter name"),
        Declare_private_property_0: diag(90035, 3 /* Message */ , "Declare_private_property_0_90035", "Declare private property '{0}'"),
        Replace_0_with_Promise_1: diag(90036, 3 /* Message */ , "Replace_0_with_Promise_1_90036", "Replace '{0}' with 'Promise<{1}>'"),
        Fix_all_incorrect_return_type_of_an_async_functions: diag(90037, 3 /* Message */ , "Fix_all_incorrect_return_type_of_an_async_functions_90037", "Fix all incorrect return type of an async functions"),
        Declare_private_method_0: diag(90038, 3 /* Message */ , "Declare_private_method_0_90038", "Declare private method '{0}'"),
        Remove_unused_destructuring_declaration: diag(90039, 3 /* Message */ , "Remove_unused_destructuring_declaration_90039", "Remove unused destructuring declaration"),
        Remove_unused_declarations_for_Colon_0: diag(90041, 3 /* Message */ , "Remove_unused_declarations_for_Colon_0_90041", "Remove unused declarations for: '{0}'"),
        Declare_a_private_field_named_0: diag(90053, 3 /* Message */ , "Declare_a_private_field_named_0_90053", "Declare a private field named '{0}'."),
        Includes_imports_of_types_referenced_by_0: diag(90054, 3 /* Message */ , "Includes_imports_of_types_referenced_by_0_90054", "Includes imports of types referenced by '{0}'"),
        Remove_type_from_import_declaration_from_0: diag(90055, 3 /* Message */ , "Remove_type_from_import_declaration_from_0_90055", `Remove 'type' from import declaration from "{0}"`),
        Remove_type_from_import_of_0_from_1: diag(90056, 3 /* Message */ , "Remove_type_from_import_of_0_from_1_90056", `Remove 'type' from import of '{0}' from "{1}"`),
        Add_import_from_0: diag(90057, 3 /* Message */ , "Add_import_from_0_90057", 'Add import from "{0}"'),
        Update_import_from_0: diag(90058, 3 /* Message */ , "Update_import_from_0_90058", 'Update import from "{0}"'),
        Export_0_from_module_1: diag(90059, 3 /* Message */ , "Export_0_from_module_1_90059", "Export '{0}' from module '{1}'"),
        Export_all_referenced_locals: diag(90060, 3 /* Message */ , "Export_all_referenced_locals_90060", "Export all referenced locals"),
        Update_modifiers_of_0: diag(90061, 3 /* Message */ , "Update_modifiers_of_0_90061", "Update modifiers of '{0}'"),
        Add_annotation_of_type_0: diag(90062, 3 /* Message */ , "Add_annotation_of_type_0_90062", "Add annotation of type '{0}'"),
        Add_return_type_0: diag(90063, 3 /* Message */ , "Add_return_type_0_90063", "Add return type '{0}'"),
        Extract_base_class_to_variable: diag(90064, 3 /* Message */ , "Extract_base_class_to_variable_90064", "Extract base class to variable"),
        Extract_default_export_to_variable: diag(90065, 3 /* Message */ , "Extract_default_export_to_variable_90065", "Extract default export to variable"),
        Extract_binding_expressions_to_variable: diag(90066, 3 /* Message */ , "Extract_binding_expressions_to_variable_90066", "Extract binding expressions to variable"),
        Add_all_missing_type_annotations: diag(90067, 3 /* Message */ , "Add_all_missing_type_annotations_90067", "Add all missing type annotations"),
        Add_satisfies_and_an_inline_type_assertion_with_0: diag(90068, 3 /* Message */ , "Add_satisfies_and_an_inline_type_assertion_with_0_90068", "Add satisfies and an inline type assertion with '{0}'"),
        Extract_to_variable_and_replace_with_0_as_typeof_0: diag(90069, 3 /* Message */ , "Extract_to_variable_and_replace_with_0_as_typeof_0_90069", "Extract to variable and replace with '{0} as typeof {0}'"),
        Mark_array_literal_as_const: diag(90070, 3 /* Message */ , "Mark_array_literal_as_const_90070", "Mark array literal as const"),
        Annotate_types_of_properties_expando_function_in_a_namespace: diag(90071, 3 /* Message */ , "Annotate_types_of_properties_expando_function_in_a_namespace_90071", "Annotate types of properties expando function in a namespace"),
        Convert_function_to_an_ES2015_class: diag(95001, 3 /* Message */ , "Convert_function_to_an_ES2015_class_95001", "Convert function to an ES2015 class"),
        Convert_0_to_1_in_0: diag(95003, 3 /* Message */ , "Convert_0_to_1_in_0_95003", "Convert '{0}' to '{1} in {0}'"),
        Extract_to_0_in_1: diag(95004, 3 /* Message */ , "Extract_to_0_in_1_95004", "Extract to {0} in {1}"),
        Extract_function: diag(95005, 3 /* Message */ , "Extract_function_95005", "Extract function"),
        Extract_constant: diag(95006, 3 /* Message */ , "Extract_constant_95006", "Extract constant"),
        Extract_to_0_in_enclosing_scope: diag(95007, 3 /* Message */ , "Extract_to_0_in_enclosing_scope_95007", "Extract to {0} in enclosing scope"),
        Extract_to_0_in_1_scope: diag(95008, 3 /* Message */ , "Extract_to_0_in_1_scope_95008", "Extract to {0} in {1} scope"),
        Annotate_with_type_from_JSDoc: diag(95009, 3 /* Message */ , "Annotate_with_type_from_JSDoc_95009", "Annotate with type from JSDoc"),
        Infer_type_of_0_from_usage: diag(95011, 3 /* Message */ , "Infer_type_of_0_from_usage_95011", "Infer type of '{0}' from usage"),
        Infer_parameter_types_from_usage: diag(95012, 3 /* Message */ , "Infer_parameter_types_from_usage_95012", "Infer parameter types from usage"),
        Convert_to_default_import: diag(95013, 3 /* Message */ , "Convert_to_default_import_95013", "Convert to default import"),
        Install_0: diag(95014, 3 /* Message */ , "Install_0_95014", "Install '{0}'"),
        Replace_import_with_0: diag(95015, 3 /* Message */ , "Replace_import_with_0_95015", "Replace import with '{0}'."),
        Use_synthetic_default_member: diag(95016, 3 /* Message */ , "Use_synthetic_default_member_95016", "Use synthetic 'default' member."),
        Convert_to_ES_module: diag(95017, 3 /* Message */ , "Convert_to_ES_module_95017", "Convert to ES module"),
        Add_undefined_type_to_property_0: diag(95018, 3 /* Message */ , "Add_undefined_type_to_property_0_95018", "Add 'undefined' type to property '{0}'"),
        Add_initializer_to_property_0: diag(95019, 3 /* Message */ , "Add_initializer_to_property_0_95019", "Add initializer to property '{0}'"),
        Add_definite_assignment_assertion_to_property_0: diag(95020, 3 /* Message */ , "Add_definite_assignment_assertion_to_property_0_95020", "Add definite assignment assertion to property '{0}'"),
        Convert_all_type_literals_to_mapped_type: diag(95021, 3 /* Message */ , "Convert_all_type_literals_to_mapped_type_95021", "Convert all type literals to mapped type"),
        Add_all_missing_members: diag(95022, 3 /* Message */ , "Add_all_missing_members_95022", "Add all missing members"),
        Infer_all_types_from_usage: diag(95023, 3 /* Message */ , "Infer_all_types_from_usage_95023", "Infer all types from usage"),
        Delete_all_unused_declarations: diag(95024, 3 /* Message */ , "Delete_all_unused_declarations_95024", "Delete all unused declarations"),
        Prefix_all_unused_declarations_with_where_possible: diag(95025, 3 /* Message */ , "Prefix_all_unused_declarations_with_where_possible_95025", "Prefix all unused declarations with '_' where possible"),
        Fix_all_detected_spelling_errors: diag(95026, 3 /* Message */ , "Fix_all_detected_spelling_errors_95026", "Fix all detected spelling errors"),
        Add_initializers_to_all_uninitialized_properties: diag(95027, 3 /* Message */ , "Add_initializers_to_all_uninitialized_properties_95027", "Add initializers to all uninitialized properties"),
        Add_definite_assignment_assertions_to_all_uninitialized_properties: diag(95028, 3 /* Message */ , "Add_definite_assignment_assertions_to_all_uninitialized_properties_95028", "Add definite assignment assertions to all uninitialized properties"),
        Add_undefined_type_to_all_uninitialized_properties: diag(95029, 3 /* Message */ , "Add_undefined_type_to_all_uninitialized_properties_95029", "Add undefined type to all uninitialized properties"),
        Change_all_jsdoc_style_types_to_TypeScript: diag(95030, 3 /* Message */ , "Change_all_jsdoc_style_types_to_TypeScript_95030", "Change all jsdoc-style types to TypeScript"),
        Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types: diag(95031, 3 /* Message */ , "Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types_95031", "Change all jsdoc-style types to TypeScript (and add '| undefined' to nullable types)"),
        Implement_all_unimplemented_interfaces: diag(95032, 3 /* Message */ , "Implement_all_unimplemented_interfaces_95032", "Implement all unimplemented interfaces"),
        Install_all_missing_types_packages: diag(95033, 3 /* Message */ , "Install_all_missing_types_packages_95033", "Install all missing types packages"),
        Rewrite_all_as_indexed_access_types: diag(95034, 3 /* Message */ , "Rewrite_all_as_indexed_access_types_95034", "Rewrite all as indexed access types"),
        Convert_all_to_default_imports: diag(95035, 3 /* Message */ , "Convert_all_to_default_imports_95035", "Convert all to default imports"),
        Make_all_super_calls_the_first_statement_in_their_constructor: diag(95036, 3 /* Message */ , "Make_all_super_calls_the_first_statement_in_their_constructor_95036", "Make all 'super()' calls the first statement in their constructor"),
        Add_qualifier_to_all_unresolved_variables_matching_a_member_name: diag(95037, 3 /* Message */ , "Add_qualifier_to_all_unresolved_variables_matching_a_member_name_95037", "Add qualifier to all unresolved variables matching a member name"),
        Change_all_extended_interfaces_to_implements: diag(95038, 3 /* Message */ , "Change_all_extended_interfaces_to_implements_95038", "Change all extended interfaces to 'implements'"),
        Add_all_missing_super_calls: diag(95039, 3 /* Message */ , "Add_all_missing_super_calls_95039", "Add all missing super calls"),
        Implement_all_inherited_abstract_classes: diag(95040, 3 /* Message */ , "Implement_all_inherited_abstract_classes_95040", "Implement all inherited abstract classes"),
        Add_all_missing_async_modifiers: diag(95041, 3 /* Message */ , "Add_all_missing_async_modifiers_95041", "Add all missing 'async' modifiers"),
        Add_ts_ignore_to_all_error_messages: diag(95042, 3 /* Message */ , "Add_ts_ignore_to_all_error_messages_95042", "Add '@ts-ignore' to all error messages"),
        Annotate_everything_with_types_from_JSDoc: diag(95043, 3 /* Message */ , "Annotate_everything_with_types_from_JSDoc_95043", "Annotate everything with types from JSDoc"),
        Add_to_all_uncalled_decorators: diag(95044, 3 /* Message */ , "Add_to_all_uncalled_decorators_95044", "Add '()' to all uncalled decorators"),
        Convert_all_constructor_functions_to_classes: diag(95045, 3 /* Message */ , "Convert_all_constructor_functions_to_classes_95045", "Convert all constructor functions to classes"),
        Generate_get_and_set_accessors: diag(95046, 3 /* Message */ , "Generate_get_and_set_accessors_95046", "Generate 'get' and 'set' accessors"),
        Convert_require_to_import: diag(95047, 3 /* Message */ , "Convert_require_to_import_95047", "Convert 'require' to 'import'"),
        Convert_all_require_to_import: diag(95048, 3 /* Message */ , "Convert_all_require_to_import_95048", "Convert all 'require' to 'import'"),
        Move_to_a_new_file: diag(95049, 3 /* Message */ , "Move_to_a_new_file_95049", "Move to a new file"),
        Remove_unreachable_code: diag(95050, 3 /* Message */ , "Remove_unreachable_code_95050", "Remove unreachable code"),
        Remove_all_unreachable_code: diag(95051, 3 /* Message */ , "Remove_all_unreachable_code_95051", "Remove all unreachable code"),
        Add_missing_typeof: diag(95052, 3 /* Message */ , "Add_missing_typeof_95052", "Add missing 'typeof'"),
        Remove_unused_label: diag(95053, 3 /* Message */ , "Remove_unused_label_95053", "Remove unused label"),
        Remove_all_unused_labels: diag(95054, 3 /* Message */ , "Remove_all_unused_labels_95054", "Remove all unused labels"),
        Convert_0_to_mapped_object_type: diag(95055, 3 /* Message */ , "Convert_0_to_mapped_object_type_95055", "Convert '{0}' to mapped object type"),
        Convert_namespace_import_to_named_imports: diag(95056, 3 /* Message */ , "Convert_namespace_import_to_named_imports_95056", "Convert namespace import to named imports"),
        Convert_named_imports_to_namespace_import: diag(95057, 3 /* Message */ , "Convert_named_imports_to_namespace_import_95057", "Convert named imports to namespace import"),
        Add_or_remove_braces_in_an_arrow_function: diag(95058, 3 /* Message */ , "Add_or_remove_braces_in_an_arrow_function_95058", "Add or remove braces in an arrow function"),
        Add_braces_to_arrow_function: diag(95059, 3 /* Message */ , "Add_braces_to_arrow_function_95059", "Add braces to arrow function"),
        Remove_braces_from_arrow_function: diag(95060, 3 /* Message */ , "Remove_braces_from_arrow_function_95060", "Remove braces from arrow function"),
        Convert_default_export_to_named_export: diag(95061, 3 /* Message */ , "Convert_default_export_to_named_export_95061", "Convert default export to named export"),
        Convert_named_export_to_default_export: diag(95062, 3 /* Message */ , "Convert_named_export_to_default_export_95062", "Convert named export to default export"),
        Add_missing_enum_member_0: diag(95063, 3 /* Message */ , "Add_missing_enum_member_0_95063", "Add missing enum member '{0}'"),
        Add_all_missing_imports: diag(95064, 3 /* Message */ , "Add_all_missing_imports_95064", "Add all missing imports"),
        Convert_to_async_function: diag(95065, 3 /* Message */ , "Convert_to_async_function_95065", "Convert to async function"),
        Convert_all_to_async_functions: diag(95066, 3 /* Message */ , "Convert_all_to_async_functions_95066", "Convert all to async functions"),
        Add_missing_call_parentheses: diag(95067, 3 /* Message */ , "Add_missing_call_parentheses_95067", "Add missing call parentheses"),
        Add_all_missing_call_parentheses: diag(95068, 3 /* Message */ , "Add_all_missing_call_parentheses_95068", "Add all missing call parentheses"),
        Add_unknown_conversion_for_non_overlapping_types: diag(95069, 3 /* Message */ , "Add_unknown_conversion_for_non_overlapping_types_95069", "Add 'unknown' conversion for non-overlapping types"),
        Add_unknown_to_all_conversions_of_non_overlapping_types: diag(95070, 3 /* Message */ , "Add_unknown_to_all_conversions_of_non_overlapping_types_95070", "Add 'unknown' to all conversions of non-overlapping types"),
        Add_missing_new_operator_to_call: diag(95071, 3 /* Message */ , "Add_missing_new_operator_to_call_95071", "Add missing 'new' operator to call"),
        Add_missing_new_operator_to_all_calls: diag(95072, 3 /* Message */ , "Add_missing_new_operator_to_all_calls_95072", "Add missing 'new' operator to all calls"),
        Add_names_to_all_parameters_without_names: diag(95073, 3 /* Message */ , "Add_names_to_all_parameters_without_names_95073", "Add names to all parameters without names"),
        Enable_the_experimentalDecorators_option_in_your_configuration_file: diag(95074, 3 /* Message */ , "Enable_the_experimentalDecorators_option_in_your_configuration_file_95074", "Enable the 'experimentalDecorators' option in your configuration file"),
        Convert_parameters_to_destructured_object: diag(95075, 3 /* Message */ , "Convert_parameters_to_destructured_object_95075", "Convert parameters to destructured object"),
        Extract_type: diag(95077, 3 /* Message */ , "Extract_type_95077", "Extract type"),
        Extract_to_type_alias: diag(95078, 3 /* Message */ , "Extract_to_type_alias_95078", "Extract to type alias"),
        Extract_to_typedef: diag(95079, 3 /* Message */ , "Extract_to_typedef_95079", "Extract to typedef"),
        Infer_this_type_of_0_from_usage: diag(95080, 3 /* Message */ , "Infer_this_type_of_0_from_usage_95080", "Infer 'this' type of '{0}' from usage"),
        Add_const_to_unresolved_variable: diag(95081, 3 /* Message */ , "Add_const_to_unresolved_variable_95081", "Add 'const' to unresolved variable"),
        Add_const_to_all_unresolved_variables: diag(95082, 3 /* Message */ , "Add_const_to_all_unresolved_variables_95082", "Add 'const' to all unresolved variables"),
        Add_await: diag(95083, 3 /* Message */ , "Add_await_95083", "Add 'await'"),
        Add_await_to_initializer_for_0: diag(95084, 3 /* Message */ , "Add_await_to_initializer_for_0_95084", "Add 'await' to initializer for '{0}'"),
        Fix_all_expressions_possibly_missing_await: diag(95085, 3 /* Message */ , "Fix_all_expressions_possibly_missing_await_95085", "Fix all expressions possibly missing 'await'"),
        Remove_unnecessary_await: diag(95086, 3 /* Message */ , "Remove_unnecessary_await_95086", "Remove unnecessary 'await'"),
        Remove_all_unnecessary_uses_of_await: diag(95087, 3 /* Message */ , "Remove_all_unnecessary_uses_of_await_95087", "Remove all unnecessary uses of 'await'"),
        Enable_the_jsx_flag_in_your_configuration_file: diag(95088, 3 /* Message */ , "Enable_the_jsx_flag_in_your_configuration_file_95088", "Enable the '--jsx' flag in your configuration file"),
        Add_await_to_initializers: diag(95089, 3 /* Message */ , "Add_await_to_initializers_95089", "Add 'await' to initializers"),
        Extract_to_interface: diag(95090, 3 /* Message */ , "Extract_to_interface_95090", "Extract to interface"),
        Convert_to_a_bigint_numeric_literal: diag(95091, 3 /* Message */ , "Convert_to_a_bigint_numeric_literal_95091", "Convert to a bigint numeric literal"),
        Convert_all_to_bigint_numeric_literals: diag(95092, 3 /* Message */ , "Convert_all_to_bigint_numeric_literals_95092", "Convert all to bigint numeric literals"),
        Convert_const_to_let: diag(95093, 3 /* Message */ , "Convert_const_to_let_95093", "Convert 'const' to 'let'"),
        Prefix_with_declare: diag(95094, 3 /* Message */ , "Prefix_with_declare_95094", "Prefix with 'declare'"),
        Prefix_all_incorrect_property_declarations_with_declare: diag(95095, 3 /* Message */ , "Prefix_all_incorrect_property_declarations_with_declare_95095", "Prefix all incorrect property declarations with 'declare'"),
        Convert_to_template_string: diag(95096, 3 /* Message */ , "Convert_to_template_string_95096", "Convert to template string"),
        Add_export_to_make_this_file_into_a_module: diag(95097, 3 /* Message */ , "Add_export_to_make_this_file_into_a_module_95097", "Add 'export {}' to make this file into a module"),
        Set_the_target_option_in_your_configuration_file_to_0: diag(95098, 3 /* Message */ , "Set_the_target_option_in_your_configuration_file_to_0_95098", "Set the 'target' option in your configuration file to '{0}'"),
        Set_the_module_option_in_your_configuration_file_to_0: diag(95099, 3 /* Message */ , "Set_the_module_option_in_your_configuration_file_to_0_95099", "Set the 'module' option in your configuration file to '{0}'"),
        Convert_invalid_character_to_its_html_entity_code: diag(95100, 3 /* Message */ , "Convert_invalid_character_to_its_html_entity_code_95100", "Convert invalid character to its html entity code"),
        Convert_all_invalid_characters_to_HTML_entity_code: diag(95101, 3 /* Message */ , "Convert_all_invalid_characters_to_HTML_entity_code_95101", "Convert all invalid characters to HTML entity code"),
        Convert_all_const_to_let: diag(95102, 3 /* Message */ , "Convert_all_const_to_let_95102", "Convert all 'const' to 'let'"),
        Convert_function_expression_0_to_arrow_function: diag(95105, 3 /* Message */ , "Convert_function_expression_0_to_arrow_function_95105", "Convert function expression '{0}' to arrow function"),
        Convert_function_declaration_0_to_arrow_function: diag(95106, 3 /* Message */ , "Convert_function_declaration_0_to_arrow_function_95106", "Convert function declaration '{0}' to arrow function"),
        Fix_all_implicit_this_errors: diag(95107, 3 /* Message */ , "Fix_all_implicit_this_errors_95107", "Fix all implicit-'this' errors"),
        Wrap_invalid_character_in_an_expression_container: diag(95108, 3 /* Message */ , "Wrap_invalid_character_in_an_expression_container_95108", "Wrap invalid character in an expression container"),
        Wrap_all_invalid_characters_in_an_expression_container: diag(95109, 3 /* Message */ , "Wrap_all_invalid_characters_in_an_expression_container_95109", "Wrap all invalid characters in an expression container"),
        Visit_https_Colon_Slash_Slashaka_ms_Slashtsconfig_to_read_more_about_this_file: diag(95110, 3 /* Message */ , "Visit_https_Colon_Slash_Slashaka_ms_Slashtsconfig_to_read_more_about_this_file_95110", "Visit https://aka.ms/tsconfig to read more about this file"),
        Add_a_return_statement: diag(95111, 3 /* Message */ , "Add_a_return_statement_95111", "Add a return statement"),
        Remove_braces_from_arrow_function_body: diag(95112, 3 /* Message */ , "Remove_braces_from_arrow_function_body_95112", "Remove braces from arrow function body"),
        Wrap_the_following_body_with_parentheses_which_should_be_an_object_literal: diag(95113, 3 /* Message */ , "Wrap_the_following_body_with_parentheses_which_should_be_an_object_literal_95113", "Wrap the following body with parentheses which should be an object literal"),
        Add_all_missing_return_statement: diag(95114, 3 /* Message */ , "Add_all_missing_return_statement_95114", "Add all missing return statement"),
        Remove_braces_from_all_arrow_function_bodies_with_relevant_issues: diag(95115, 3 /* Message */ , "Remove_braces_from_all_arrow_function_bodies_with_relevant_issues_95115", "Remove braces from all arrow function bodies with relevant issues"),
        Wrap_all_object_literal_with_parentheses: diag(95116, 3 /* Message */ , "Wrap_all_object_literal_with_parentheses_95116", "Wrap all object literal with parentheses"),
        Move_labeled_tuple_element_modifiers_to_labels: diag(95117, 3 /* Message */ , "Move_labeled_tuple_element_modifiers_to_labels_95117", "Move labeled tuple element modifiers to labels"),
        Convert_overload_list_to_single_signature: diag(95118, 3 /* Message */ , "Convert_overload_list_to_single_signature_95118", "Convert overload list to single signature"),
        Generate_get_and_set_accessors_for_all_overriding_properties: diag(95119, 3 /* Message */ , "Generate_get_and_set_accessors_for_all_overriding_properties_95119", "Generate 'get' and 'set' accessors for all overriding properties"),
        Wrap_in_JSX_fragment: diag(95120, 3 /* Message */ , "Wrap_in_JSX_fragment_95120", "Wrap in JSX fragment"),
        Wrap_all_unparented_JSX_in_JSX_fragment: diag(95121, 3 /* Message */ , "Wrap_all_unparented_JSX_in_JSX_fragment_95121", "Wrap all unparented JSX in JSX fragment"),
        Convert_arrow_function_or_function_expression: diag(95122, 3 /* Message */ , "Convert_arrow_function_or_function_expression_95122", "Convert arrow function or function expression"),
        Convert_to_anonymous_function: diag(95123, 3 /* Message */ , "Convert_to_anonymous_function_95123", "Convert to anonymous function"),
        Convert_to_named_function: diag(95124, 3 /* Message */ , "Convert_to_named_function_95124", "Convert to named function"),
        Convert_to_arrow_function: diag(95125, 3 /* Message */ , "Convert_to_arrow_function_95125", "Convert to arrow function"),
        Remove_parentheses: diag(95126, 3 /* Message */ , "Remove_parentheses_95126", "Remove parentheses"),
        Could_not_find_a_containing_arrow_function: diag(95127, 3 /* Message */ , "Could_not_find_a_containing_arrow_function_95127", "Could not find a containing arrow function"),
        Containing_function_is_not_an_arrow_function: diag(95128, 3 /* Message */ , "Containing_function_is_not_an_arrow_function_95128", "Containing function is not an arrow function"),
        Could_not_find_export_statement: diag(95129, 3 /* Message */ , "Could_not_find_export_statement_95129", "Could not find export statement"),
        This_file_already_has_a_default_export: diag(95130, 3 /* Message */ , "This_file_already_has_a_default_export_95130", "This file already has a default export"),
        Could_not_find_import_clause: diag(95131, 3 /* Message */ , "Could_not_find_import_clause_95131", "Could not find import clause"),
        Could_not_find_namespace_import_or_named_imports: diag(95132, 3 /* Message */ , "Could_not_find_namespace_import_or_named_imports_95132", "Could not find namespace import or named imports"),
        Selection_is_not_a_valid_type_node: diag(95133, 3 /* Message */ , "Selection_is_not_a_valid_type_node_95133", "Selection is not a valid type node"),
        No_type_could_be_extracted_from_this_type_node: diag(95134, 3 /* Message */ , "No_type_could_be_extracted_from_this_type_node_95134", "No type could be extracted from this type node"),
        Could_not_find_property_for_which_to_generate_accessor: diag(95135, 3 /* Message */ , "Could_not_find_property_for_which_to_generate_accessor_95135", "Could not find property for which to generate accessor"),
        Name_is_not_valid: diag(95136, 3 /* Message */ , "Name_is_not_valid_95136", "Name is not valid"),
        Can_only_convert_property_with_modifier: diag(95137, 3 /* Message */ , "Can_only_convert_property_with_modifier_95137", "Can only convert property with modifier"),
        Switch_each_misused_0_to_1: diag(95138, 3 /* Message */ , "Switch_each_misused_0_to_1_95138", "Switch each misused '{0}' to '{1}'"),
        Convert_to_optional_chain_expression: diag(95139, 3 /* Message */ , "Convert_to_optional_chain_expression_95139", "Convert to optional chain expression"),
        Could_not_find_convertible_access_expression: diag(95140, 3 /* Message */ , "Could_not_find_convertible_access_expression_95140", "Could not find convertible access expression"),
        Could_not_find_matching_access_expressions: diag(95141, 3 /* Message */ , "Could_not_find_matching_access_expressions_95141", "Could not find matching access expressions"),
        Can_only_convert_logical_AND_access_chains: diag(95142, 3 /* Message */ , "Can_only_convert_logical_AND_access_chains_95142", "Can only convert logical AND access chains"),
        Add_void_to_Promise_resolved_without_a_value: diag(95143, 3 /* Message */ , "Add_void_to_Promise_resolved_without_a_value_95143", "Add 'void' to Promise resolved without a value"),
        Add_void_to_all_Promises_resolved_without_a_value: diag(95144, 3 /* Message */ , "Add_void_to_all_Promises_resolved_without_a_value_95144", "Add 'void' to all Promises resolved without a value"),
        Use_element_access_for_0: diag(95145, 3 /* Message */ , "Use_element_access_for_0_95145", "Use element access for '{0}'"),
        Use_element_access_for_all_undeclared_properties: diag(95146, 3 /* Message */ , "Use_element_access_for_all_undeclared_properties_95146", "Use element access for all undeclared properties."),
        Delete_all_unused_imports: diag(95147, 3 /* Message */ , "Delete_all_unused_imports_95147", "Delete all unused imports"),
        Infer_function_return_type: diag(95148, 3 /* Message */ , "Infer_function_return_type_95148", "Infer function return type"),
        Return_type_must_be_inferred_from_a_function: diag(95149, 3 /* Message */ , "Return_type_must_be_inferred_from_a_function_95149", "Return type must be inferred from a function"),
        Could_not_determine_function_return_type: diag(95150, 3 /* Message */ , "Could_not_determine_function_return_type_95150", "Could not determine function return type"),
        Could_not_convert_to_arrow_function: diag(95151, 3 /* Message */ , "Could_not_convert_to_arrow_function_95151", "Could not convert to arrow function"),
        Could_not_convert_to_named_function: diag(95152, 3 /* Message */ , "Could_not_convert_to_named_function_95152", "Could not convert to named function"),
        Could_not_convert_to_anonymous_function: diag(95153, 3 /* Message */ , "Could_not_convert_to_anonymous_function_95153", "Could not convert to anonymous function"),
        Can_only_convert_string_concatenations_and_string_literals: diag(95154, 3 /* Message */ , "Can_only_convert_string_concatenations_and_string_literals_95154", "Can only convert string concatenations and string literals"),
        Selection_is_not_a_valid_statement_or_statements: diag(95155, 3 /* Message */ , "Selection_is_not_a_valid_statement_or_statements_95155", "Selection is not a valid statement or statements"),
        Add_missing_function_declaration_0: diag(95156, 3 /* Message */ , "Add_missing_function_declaration_0_95156", "Add missing function declaration '{0}'"),
        Add_all_missing_function_declarations: diag(95157, 3 /* Message */ , "Add_all_missing_function_declarations_95157", "Add all missing function declarations"),
        Method_not_implemented: diag(95158, 3 /* Message */ , "Method_not_implemented_95158", "Method not implemented."),
        Function_not_implemented: diag(95159, 3 /* Message */ , "Function_not_implemented_95159", "Function not implemented."),
        Add_override_modifier: diag(95160, 3 /* Message */ , "Add_override_modifier_95160", "Add 'override' modifier"),
        Remove_override_modifier: diag(95161, 3 /* Message */ , "Remove_override_modifier_95161", "Remove 'override' modifier"),
        Add_all_missing_override_modifiers: diag(95162, 3 /* Message */ , "Add_all_missing_override_modifiers_95162", "Add all missing 'override' modifiers"),
        Remove_all_unnecessary_override_modifiers: diag(95163, 3 /* Message */ , "Remove_all_unnecessary_override_modifiers_95163", "Remove all unnecessary 'override' modifiers"),
        Can_only_convert_named_export: diag(95164, 3 /* Message */ , "Can_only_convert_named_export_95164", "Can only convert named export"),
        Add_missing_properties: diag(95165, 3 /* Message */ , "Add_missing_properties_95165", "Add missing properties"),
        Add_all_missing_properties: diag(95166, 3 /* Message */ , "Add_all_missing_properties_95166", "Add all missing properties"),
        Add_missing_attributes: diag(95167, 3 /* Message */ , "Add_missing_attributes_95167", "Add missing attributes"),
        Add_all_missing_attributes: diag(95168, 3 /* Message */ , "Add_all_missing_attributes_95168", "Add all missing attributes"),
        Add_undefined_to_optional_property_type: diag(95169, 3 /* Message */ , "Add_undefined_to_optional_property_type_95169", "Add 'undefined' to optional property type"),
        Convert_named_imports_to_default_import: diag(95170, 3 /* Message */ , "Convert_named_imports_to_default_import_95170", "Convert named imports to default import"),
        Delete_unused_param_tag_0: diag(95171, 3 /* Message */ , "Delete_unused_param_tag_0_95171", "Delete unused '@param' tag '{0}'"),
        Delete_all_unused_param_tags: diag(95172, 3 /* Message */ , "Delete_all_unused_param_tags_95172", "Delete all unused '@param' tags"),
        Rename_param_tag_name_0_to_1: diag(95173, 3 /* Message */ , "Rename_param_tag_name_0_to_1_95173", "Rename '@param' tag name '{0}' to '{1}'"),
        Use_0: diag(95174, 3 /* Message */ , "Use_0_95174", "Use `{0}`."),
        Use_Number_isNaN_in_all_conditions: diag(95175, 3 /* Message */ , "Use_Number_isNaN_in_all_conditions_95175", "Use `Number.isNaN` in all conditions."),
        Convert_typedef_to_TypeScript_type: diag(95176, 3 /* Message */ , "Convert_typedef_to_TypeScript_type_95176", "Convert typedef to TypeScript type."),
        Convert_all_typedef_to_TypeScript_types: diag(95177, 3 /* Message */ , "Convert_all_typedef_to_TypeScript_types_95177", "Convert all typedef to TypeScript types."),
        Move_to_file: diag(95178, 3 /* Message */ , "Move_to_file_95178", "Move to file"),
        Cannot_move_to_file_selected_file_is_invalid: diag(95179, 3 /* Message */ , "Cannot_move_to_file_selected_file_is_invalid_95179", "Cannot move to file, selected file is invalid"),
        Use_import_type: diag(95180, 3 /* Message */ , "Use_import_type_95180", "Use 'import type'"),
        Use_type_0: diag(95181, 3 /* Message */ , "Use_type_0_95181", "Use 'type {0}'"),
        Fix_all_with_type_only_imports: diag(95182, 3 /* Message */ , "Fix_all_with_type_only_imports_95182", "Fix all with type-only imports"),
        Cannot_move_statements_to_the_selected_file: diag(95183, 3 /* Message */ , "Cannot_move_statements_to_the_selected_file_95183", "Cannot move statements to the selected file"),
        Inline_variable: diag(95184, 3 /* Message */ , "Inline_variable_95184", "Inline variable"),
        Could_not_find_variable_to_inline: diag(95185, 3 /* Message */ , "Could_not_find_variable_to_inline_95185", "Could not find variable to inline."),
        Variables_with_multiple_declarations_cannot_be_inlined: diag(95186, 3 /* Message */ , "Variables_with_multiple_declarations_cannot_be_inlined_95186", "Variables with multiple declarations cannot be inlined."),
        Add_missing_comma_for_object_member_completion_0: diag(95187, 3 /* Message */ , "Add_missing_comma_for_object_member_completion_0_95187", "Add missing comma for object member completion '{0}'."),
        Add_missing_parameter_to_0: diag(95188, 3 /* Message */ , "Add_missing_parameter_to_0_95188", "Add missing parameter to '{0}'"),
        Add_missing_parameters_to_0: diag(95189, 3 /* Message */ , "Add_missing_parameters_to_0_95189", "Add missing parameters to '{0}'"),
        Add_all_missing_parameters: diag(95190, 3 /* Message */ , "Add_all_missing_parameters_95190", "Add all missing parameters"),
        Add_optional_parameter_to_0: diag(95191, 3 /* Message */ , "Add_optional_parameter_to_0_95191", "Add optional parameter to '{0}'"),
        Add_optional_parameters_to_0: diag(95192, 3 /* Message */ , "Add_optional_parameters_to_0_95192", "Add optional parameters to '{0}'"),
        Add_all_optional_parameters: diag(95193, 3 /* Message */ , "Add_all_optional_parameters_95193", "Add all optional parameters"),
        Wrap_in_parentheses: diag(95194, 3 /* Message */ , "Wrap_in_parentheses_95194", "Wrap in parentheses"),
        Wrap_all_invalid_decorator_expressions_in_parentheses: diag(95195, 3 /* Message */ , "Wrap_all_invalid_decorator_expressions_in_parentheses_95195", "Wrap all invalid decorator expressions in parentheses"),
        Add_resolution_mode_import_attribute: diag(95196, 3 /* Message */ , "Add_resolution_mode_import_attribute_95196", "Add 'resolution-mode' import attribute"),
        Add_resolution_mode_import_attribute_to_all_type_only_imports_that_need_it: diag(95197, 3 /* Message */ , "Add_resolution_mode_import_attribute_to_all_type_only_imports_that_need_it_95197", "Add 'resolution-mode' import attribute to all type-only imports that need it"),
        No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer: diag(18004, 1 /* Error */ , "No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer_18004", "No value exists in scope for the shorthand property '{0}'. Either declare one or provide an initializer."),
        Classes_may_not_have_a_field_named_constructor: diag(18006, 1 /* Error */ , "Classes_may_not_have_a_field_named_constructor_18006", "Classes may not have a field named 'constructor'."),
        JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array: diag(18007, 1 /* Error */ , "JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array_18007", "JSX expressions may not use the comma operator. Did you mean to write an array?"),
        Private_identifiers_cannot_be_used_as_parameters: diag(18009, 1 /* Error */ , "Private_identifiers_cannot_be_used_as_parameters_18009", "Private identifiers cannot be used as parameters."),
        An_accessibility_modifier_cannot_be_used_with_a_private_identifier: diag(18010, 1 /* Error */ , "An_accessibility_modifier_cannot_be_used_with_a_private_identifier_18010", "An accessibility modifier cannot be used with a private identifier."),
        The_operand_of_a_delete_operator_cannot_be_a_private_identifier: diag(18011, 1 /* Error */ , "The_operand_of_a_delete_operator_cannot_be_a_private_identifier_18011", "The operand of a 'delete' operator cannot be a private identifier."),
        constructor_is_a_reserved_word: diag(18012, 1 /* Error */ , "constructor_is_a_reserved_word_18012", "'#constructor' is a reserved word."),
        Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier: diag(18013, 1 /* Error */ , "Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier_18013", "Property '{0}' is not accessible outside class '{1}' because it has a private identifier."),
        The_property_0_cannot_be_accessed_on_type_1_within_this_class_because_it_is_shadowed_by_another_private_identifier_with_the_same_spelling: diag(18014, 1 /* Error */ , "The_property_0_cannot_be_accessed_on_type_1_within_this_class_because_it_is_shadowed_by_another_priv_18014", "The property '{0}' cannot be accessed on type '{1}' within this class because it is shadowed by another private identifier with the same spelling."),
        Property_0_in_type_1_refers_to_a_different_member_that_cannot_be_accessed_from_within_type_2: diag(18015, 1 /* Error */ , "Property_0_in_type_1_refers_to_a_different_member_that_cannot_be_accessed_from_within_type_2_18015", "Property '{0}' in type '{1}' refers to a different member that cannot be accessed from within type '{2}'."),
        Private_identifiers_are_not_allowed_outside_class_bodies: diag(18016, 1 /* Error */ , "Private_identifiers_are_not_allowed_outside_class_bodies_18016", "Private identifiers are not allowed outside class bodies."),
        The_shadowing_declaration_of_0_is_defined_here: diag(18017, 1 /* Error */ , "The_shadowing_declaration_of_0_is_defined_here_18017", "The shadowing declaration of '{0}' is defined here"),
        The_declaration_of_0_that_you_probably_intended_to_use_is_defined_here: diag(18018, 1 /* Error */ , "The_declaration_of_0_that_you_probably_intended_to_use_is_defined_here_18018", "The declaration of '{0}' that you probably intended to use is defined here"),
        _0_modifier_cannot_be_used_with_a_private_identifier: diag(18019, 1 /* Error */ , "_0_modifier_cannot_be_used_with_a_private_identifier_18019", "'{0}' modifier cannot be used with a private identifier."),
        An_enum_member_cannot_be_named_with_a_private_identifier: diag(18024, 1 /* Error */ , "An_enum_member_cannot_be_named_with_a_private_identifier_18024", "An enum member cannot be named with a private identifier."),
        can_only_be_used_at_the_start_of_a_file: diag(18026, 1 /* Error */ , "can_only_be_used_at_the_start_of_a_file_18026", "'#!' can only be used at the start of a file."),
        Compiler_reserves_name_0_when_emitting_private_identifier_downlevel: diag(18027, 1 /* Error */ , "Compiler_reserves_name_0_when_emitting_private_identifier_downlevel_18027", "Compiler reserves name '{0}' when emitting private identifier downlevel."),
        Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher: diag(18028, 1 /* Error */ , "Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher_18028", "Private identifiers are only available when targeting ECMAScript 2015 and higher."),
        Private_identifiers_are_not_allowed_in_variable_declarations: diag(18029, 1 /* Error */ , "Private_identifiers_are_not_allowed_in_variable_declarations_18029", "Private identifiers are not allowed in variable declarations."),
        An_optional_chain_cannot_contain_private_identifiers: diag(18030, 1 /* Error */ , "An_optional_chain_cannot_contain_private_identifiers_18030", "An optional chain cannot contain private identifiers."),
        The_intersection_0_was_reduced_to_never_because_property_1_has_conflicting_types_in_some_constituents: diag(18031, 1 /* Error */ , "The_intersection_0_was_reduced_to_never_because_property_1_has_conflicting_types_in_some_constituent_18031", "The intersection '{0}' was reduced to 'never' because property '{1}' has conflicting types in some constituents."),
        The_intersection_0_was_reduced_to_never_because_property_1_exists_in_multiple_constituents_and_is_private_in_some: diag(18032, 1 /* Error */ , "The_intersection_0_was_reduced_to_never_because_property_1_exists_in_multiple_constituents_and_is_pr_18032", "The intersection '{0}' was reduced to 'never' because property '{1}' exists in multiple constituents and is private in some."),
        Type_0_is_not_assignable_to_type_1_as_required_for_computed_enum_member_values: diag(18033, 1 /* Error */ , "Type_0_is_not_assignable_to_type_1_as_required_for_computed_enum_member_values_18033", "Type '{0}' is not assignable to type '{1}' as required for computed enum member values."),
        Specify_the_JSX_fragment_factory_function_to_use_when_targeting_react_JSX_emit_with_jsxFactory_compiler_option_is_specified_e_g_Fragment: diag(18034, 3 /* Message */ , "Specify_the_JSX_fragment_factory_function_to_use_when_targeting_react_JSX_emit_with_jsxFactory_compi_18034", "Specify the JSX fragment factory function to use when targeting 'react' JSX emit with 'jsxFactory' compiler option is specified, e.g. 'Fragment'."),
        Invalid_value_for_jsxFragmentFactory_0_is_not_a_valid_identifier_or_qualified_name: diag(18035, 1 /* Error */ , "Invalid_value_for_jsxFragmentFactory_0_is_not_a_valid_identifier_or_qualified_name_18035", "Invalid value for 'jsxFragmentFactory'. '{0}' is not a valid identifier or qualified-name."),
        Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_decorator: diag(18036, 1 /* Error */ , "Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_dec_18036", "Class decorators can't be used with static private identifier. Consider removing the experimental decorator."),
        await_expression_cannot_be_used_inside_a_class_static_block: diag(18037, 1 /* Error */ , "await_expression_cannot_be_used_inside_a_class_static_block_18037", "'await' expression cannot be used inside a class static block."),
        for_await_loops_cannot_be_used_inside_a_class_static_block: diag(18038, 1 /* Error */ , "for_await_loops_cannot_be_used_inside_a_class_static_block_18038", "'for await' loops cannot be used inside a class static block."),
        Invalid_use_of_0_It_cannot_be_used_inside_a_class_static_block: diag(18039, 1 /* Error */ , "Invalid_use_of_0_It_cannot_be_used_inside_a_class_static_block_18039", "Invalid use of '{0}'. It cannot be used inside a class static block."),
        A_return_statement_cannot_be_used_inside_a_class_static_block: diag(18041, 1 /* Error */ , "A_return_statement_cannot_be_used_inside_a_class_static_block_18041", "A 'return' statement cannot be used inside a class static block."),
        _0_is_a_type_and_cannot_be_imported_in_JavaScript_files_Use_1_in_a_JSDoc_type_annotation: diag(18042, 1 /* Error */ , "_0_is_a_type_and_cannot_be_imported_in_JavaScript_files_Use_1_in_a_JSDoc_type_annotation_18042", "'{0}' is a type and cannot be imported in JavaScript files. Use '{1}' in a JSDoc type annotation."),
        Types_cannot_appear_in_export_declarations_in_JavaScript_files: diag(18043, 1 /* Error */ , "Types_cannot_appear_in_export_declarations_in_JavaScript_files_18043", "Types cannot appear in export declarations in JavaScript files."),
        _0_is_automatically_exported_here: diag(18044, 3 /* Message */ , "_0_is_automatically_exported_here_18044", "'{0}' is automatically exported here."),
        Properties_with_the_accessor_modifier_are_only_available_when_targeting_ECMAScript_2015_and_higher: diag(18045, 1 /* Error */ , "Properties_with_the_accessor_modifier_are_only_available_when_targeting_ECMAScript_2015_and_higher_18045", "Properties with the 'accessor' modifier are only available when targeting ECMAScript 2015 and higher."),
        _0_is_of_type_unknown: diag(18046, 1 /* Error */ , "_0_is_of_type_unknown_18046", "'{0}' is of type 'unknown'."),
        _0_is_possibly_null: diag(18047, 1 /* Error */ , "_0_is_possibly_null_18047", "'{0}' is possibly 'null'."),
        _0_is_possibly_undefined: diag(18048, 1 /* Error */ , "_0_is_possibly_undefined_18048", "'{0}' is possibly 'undefined'."),
        _0_is_possibly_null_or_undefined: diag(18049, 1 /* Error */ , "_0_is_possibly_null_or_undefined_18049", "'{0}' is possibly 'null' or 'undefined'."),
        The_value_0_cannot_be_used_here: diag(18050, 1 /* Error */ , "The_value_0_cannot_be_used_here_18050", "The value '{0}' cannot be used here."),
        Compiler_option_0_cannot_be_given_an_empty_string: diag(18051, 1 /* Error */ , "Compiler_option_0_cannot_be_given_an_empty_string_18051", "Compiler option '{0}' cannot be given an empty string."),
        Its_type_0_is_not_a_valid_JSX_element_type: diag(18053, 1 /* Error */ , "Its_type_0_is_not_a_valid_JSX_element_type_18053", "Its type '{0}' is not a valid JSX element type."),
        await_using_statements_cannot_be_used_inside_a_class_static_block: diag(18054, 1 /* Error */ , "await_using_statements_cannot_be_used_inside_a_class_static_block_18054", "'await using' statements cannot be used inside a class static block."),
        _0_has_a_string_type_but_must_have_syntactically_recognizable_string_syntax_when_isolatedModules_is_enabled: diag(18055, 1 /* Error */ , "_0_has_a_string_type_but_must_have_syntactically_recognizable_string_syntax_when_isolatedModules_is__18055", "'{0}' has a string type, but must have syntactically recognizable string syntax when 'isolatedModules' is enabled."),
        Enum_member_following_a_non_literal_numeric_member_must_have_an_initializer_when_isolatedModules_is_enabled: diag(18056, 1 /* Error */ , "Enum_member_following_a_non_literal_numeric_member_must_have_an_initializer_when_isolatedModules_is__18056", "Enum member following a non-literal numeric member must have an initializer when 'isolatedModules' is enabled."),
        String_literal_import_and_export_names_are_not_supported_when_the_module_flag_is_set_to_es2015_or_es2020: diag(18057, 1 /* Error */ , "String_literal_import_and_export_names_are_not_supported_when_the_module_flag_is_set_to_es2015_or_es_18057", "String literal import and export names are not supported when the '--module' flag is set to 'es2015' or 'es2020'."),
        Default_imports_are_not_allowed_in_a_deferred_import: diag(18058, 1 /* Error */ , "Default_imports_are_not_allowed_in_a_deferred_import_18058", "Default imports are not allowed in a deferred import."),
        Named_imports_are_not_allowed_in_a_deferred_import: diag(18059, 1 /* Error */ , "Named_imports_are_not_allowed_in_a_deferred_import_18059", "Named imports are not allowed in a deferred import."),
        Deferred_imports_are_only_supported_when_the_module_flag_is_set_to_esnext_or_preserve: diag(18060, 1 /* Error */ , "Deferred_imports_are_only_supported_when_the_module_flag_is_set_to_esnext_or_preserve_18060", "Deferred imports are only supported when the '--module' flag is set to 'esnext' or 'preserve'."),
        _0_is_not_a_valid_meta_property_for_keyword_import_Did_you_mean_meta_or_defer: diag(18061, 1 /* Error */ , "_0_is_not_a_valid_meta_property_for_keyword_import_Did_you_mean_meta_or_defer_18061", "'{0}' is not a valid meta-property for keyword 'import'. Did you mean 'meta' or 'defer'?")
    };
    // src/compiler/scanner.ts
    function tokenIsIdentifierOrKeyword(token) {
        return token >= 80 /* Identifier */ ;
    }
    function tokenIsIdentifierOrKeywordOrGreaterThan(token) {
        return token === 32 /* GreaterThanToken */  || tokenIsIdentifierOrKeyword(token);
    }
    var textToKeywordObj = {
        abstract: 128 /* AbstractKeyword */ ,
        accessor: 129 /* AccessorKeyword */ ,
        any: 133 /* AnyKeyword */ ,
        as: 130 /* AsKeyword */ ,
        asserts: 131 /* AssertsKeyword */ ,
        assert: 132 /* AssertKeyword */ ,
        bigint: 163 /* BigIntKeyword */ ,
        boolean: 136 /* BooleanKeyword */ ,
        break: 83 /* BreakKeyword */ ,
        case: 84 /* CaseKeyword */ ,
        catch: 85 /* CatchKeyword */ ,
        class: 86 /* ClassKeyword */ ,
        continue: 88 /* ContinueKeyword */ ,
        const: 87 /* ConstKeyword */ ,
        ["constructor"]: 137 /* ConstructorKeyword */ ,
        debugger: 89 /* DebuggerKeyword */ ,
        declare: 138 /* DeclareKeyword */ ,
        default: 90 /* DefaultKeyword */ ,
        defer: 166 /* DeferKeyword */ ,
        delete: 91 /* DeleteKeyword */ ,
        do: 92 /* DoKeyword */ ,
        else: 93 /* ElseKeyword */ ,
        enum: 94 /* EnumKeyword */ ,
        export: 95 /* ExportKeyword */ ,
        extends: 96 /* ExtendsKeyword */ ,
        false: 97 /* FalseKeyword */ ,
        finally: 98 /* FinallyKeyword */ ,
        for: 99 /* ForKeyword */ ,
        from: 161 /* FromKeyword */ ,
        function: 100 /* FunctionKeyword */ ,
        get: 139 /* GetKeyword */ ,
        if: 101 /* IfKeyword */ ,
        implements: 119 /* ImplementsKeyword */ ,
        import: 102 /* ImportKeyword */ ,
        in: 103 /* InKeyword */ ,
        infer: 140 /* InferKeyword */ ,
        instanceof: 104 /* InstanceOfKeyword */ ,
        interface: 120 /* InterfaceKeyword */ ,
        intrinsic: 141 /* IntrinsicKeyword */ ,
        is: 142 /* IsKeyword */ ,
        keyof: 143 /* KeyOfKeyword */ ,
        let: 121 /* LetKeyword */ ,
        module: 144 /* ModuleKeyword */ ,
        namespace: 145 /* NamespaceKeyword */ ,
        never: 146 /* NeverKeyword */ ,
        new: 105 /* NewKeyword */ ,
        null: 106 /* NullKeyword */ ,
        number: 150 /* NumberKeyword */ ,
        object: 151 /* ObjectKeyword */ ,
        package: 122 /* PackageKeyword */ ,
        private: 123 /* PrivateKeyword */ ,
        protected: 124 /* ProtectedKeyword */ ,
        public: 125 /* PublicKeyword */ ,
        override: 164 /* OverrideKeyword */ ,
        out: 147 /* OutKeyword */ ,
        readonly: 148 /* ReadonlyKeyword */ ,
        require: 149 /* RequireKeyword */ ,
        global: 162 /* GlobalKeyword */ ,
        return: 107 /* ReturnKeyword */ ,
        satisfies: 152 /* SatisfiesKeyword */ ,
        set: 153 /* SetKeyword */ ,
        static: 126 /* StaticKeyword */ ,
        string: 154 /* StringKeyword */ ,
        super: 108 /* SuperKeyword */ ,
        switch: 109 /* SwitchKeyword */ ,
        symbol: 155 /* SymbolKeyword */ ,
        this: 110 /* ThisKeyword */ ,
        throw: 111 /* ThrowKeyword */ ,
        true: 112 /* TrueKeyword */ ,
        try: 113 /* TryKeyword */ ,
        type: 156 /* TypeKeyword */ ,
        typeof: 114 /* TypeOfKeyword */ ,
        undefined: 157 /* UndefinedKeyword */ ,
        unique: 158 /* UniqueKeyword */ ,
        unknown: 159 /* UnknownKeyword */ ,
        using: 160 /* UsingKeyword */ ,
        var: 115 /* VarKeyword */ ,
        void: 116 /* VoidKeyword */ ,
        while: 117 /* WhileKeyword */ ,
        with: 118 /* WithKeyword */ ,
        yield: 127 /* YieldKeyword */ ,
        async: 134 /* AsyncKeyword */ ,
        await: 135 /* AwaitKeyword */ ,
        of: 165 /* OfKeyword */ 
    };
    var textToKeyword = new Map(Object.entries(textToKeywordObj));
    var textToToken = new Map(Object.entries((0, _objectSpreadProps._)((0, _objectSpread._)({}, textToKeywordObj), {
        "{": 19 /* OpenBraceToken */ ,
        "}": 20 /* CloseBraceToken */ ,
        "(": 21 /* OpenParenToken */ ,
        ")": 22 /* CloseParenToken */ ,
        "[": 23 /* OpenBracketToken */ ,
        "]": 24 /* CloseBracketToken */ ,
        ".": 25 /* DotToken */ ,
        "...": 26 /* DotDotDotToken */ ,
        ";": 27 /* SemicolonToken */ ,
        ",": 28 /* CommaToken */ ,
        "<": 30 /* LessThanToken */ ,
        ">": 32 /* GreaterThanToken */ ,
        "<=": 33 /* LessThanEqualsToken */ ,
        ">=": 34 /* GreaterThanEqualsToken */ ,
        "==": 35 /* EqualsEqualsToken */ ,
        "!=": 36 /* ExclamationEqualsToken */ ,
        "===": 37 /* EqualsEqualsEqualsToken */ ,
        "!==": 38 /* ExclamationEqualsEqualsToken */ ,
        "=>": 39 /* EqualsGreaterThanToken */ ,
        "+": 40 /* PlusToken */ ,
        "-": 41 /* MinusToken */ ,
        "**": 43 /* AsteriskAsteriskToken */ ,
        "*": 42 /* AsteriskToken */ ,
        "/": 44 /* SlashToken */ ,
        "%": 45 /* PercentToken */ ,
        "++": 46 /* PlusPlusToken */ ,
        "--": 47 /* MinusMinusToken */ ,
        "<<": 48 /* LessThanLessThanToken */ ,
        "</": 31 /* LessThanSlashToken */ ,
        ">>": 49 /* GreaterThanGreaterThanToken */ ,
        ">>>": 50 /* GreaterThanGreaterThanGreaterThanToken */ ,
        "&": 51 /* AmpersandToken */ ,
        "|": 52 /* BarToken */ ,
        "^": 53 /* CaretToken */ ,
        "!": 54 /* ExclamationToken */ ,
        "~": 55 /* TildeToken */ ,
        "&&": 56 /* AmpersandAmpersandToken */ ,
        "||": 57 /* BarBarToken */ ,
        "?": 58 /* QuestionToken */ ,
        "??": 61 /* QuestionQuestionToken */ ,
        "?.": 29 /* QuestionDotToken */ ,
        ":": 59 /* ColonToken */ ,
        "=": 64 /* EqualsToken */ ,
        "+=": 65 /* PlusEqualsToken */ ,
        "-=": 66 /* MinusEqualsToken */ ,
        "*=": 67 /* AsteriskEqualsToken */ ,
        "**=": 68 /* AsteriskAsteriskEqualsToken */ ,
        "/=": 69 /* SlashEqualsToken */ ,
        "%=": 70 /* PercentEqualsToken */ ,
        "<<=": 71 /* LessThanLessThanEqualsToken */ ,
        ">>=": 72 /* GreaterThanGreaterThanEqualsToken */ ,
        ">>>=": 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ ,
        "&=": 74 /* AmpersandEqualsToken */ ,
        "|=": 75 /* BarEqualsToken */ ,
        "^=": 79 /* CaretEqualsToken */ ,
        "||=": 76 /* BarBarEqualsToken */ ,
        "&&=": 77 /* AmpersandAmpersandEqualsToken */ ,
        "??=": 78 /* QuestionQuestionEqualsToken */ ,
        "@": 60 /* AtToken */ ,
        "#": 63 /* HashToken */ ,
        "`": 62 /* BacktickToken */ 
    })));
    var charCodeToRegExpFlag = /* @__PURE__ */ new Map([
        [
            100 /* d */ ,
            1 /* HasIndices */ 
        ],
        [
            103 /* g */ ,
            2 /* Global */ 
        ],
        [
            105 /* i */ ,
            4 /* IgnoreCase */ 
        ],
        [
            109 /* m */ ,
            8 /* Multiline */ 
        ],
        [
            115 /* s */ ,
            16 /* DotAll */ 
        ],
        [
            117 /* u */ ,
            32 /* Unicode */ 
        ],
        [
            118 /* v */ ,
            64 /* UnicodeSets */ 
        ],
        [
            121 /* y */ ,
            128 /* Sticky */ 
        ]
    ]);
    var regExpFlagToFirstAvailableLanguageVersion = /* @__PURE__ */ new Map([
        [
            1 /* HasIndices */ ,
            LanguageFeatureMinimumTarget.RegularExpressionFlagsHasIndices
        ],
        [
            16 /* DotAll */ ,
            LanguageFeatureMinimumTarget.RegularExpressionFlagsDotAll
        ],
        [
            32 /* Unicode */ ,
            LanguageFeatureMinimumTarget.RegularExpressionFlagsUnicode
        ],
        [
            64 /* UnicodeSets */ ,
            LanguageFeatureMinimumTarget.RegularExpressionFlagsUnicodeSets
        ],
        [
            128 /* Sticky */ ,
            LanguageFeatureMinimumTarget.RegularExpressionFlagsSticky
        ]
    ]);
    var unicodeES5IdentifierStart = [
        170,
        170,
        181,
        181,
        186,
        186,
        192,
        214,
        216,
        246,
        248,
        705,
        710,
        721,
        736,
        740,
        748,
        748,
        750,
        750,
        880,
        884,
        886,
        887,
        890,
        893,
        902,
        902,
        904,
        906,
        908,
        908,
        910,
        929,
        931,
        1013,
        1015,
        1153,
        1162,
        1319,
        1329,
        1366,
        1369,
        1369,
        1377,
        1415,
        1488,
        1514,
        1520,
        1522,
        1568,
        1610,
        1646,
        1647,
        1649,
        1747,
        1749,
        1749,
        1765,
        1766,
        1774,
        1775,
        1786,
        1788,
        1791,
        1791,
        1808,
        1808,
        1810,
        1839,
        1869,
        1957,
        1969,
        1969,
        1994,
        2026,
        2036,
        2037,
        2042,
        2042,
        2048,
        2069,
        2074,
        2074,
        2084,
        2084,
        2088,
        2088,
        2112,
        2136,
        2208,
        2208,
        2210,
        2220,
        2308,
        2361,
        2365,
        2365,
        2384,
        2384,
        2392,
        2401,
        2417,
        2423,
        2425,
        2431,
        2437,
        2444,
        2447,
        2448,
        2451,
        2472,
        2474,
        2480,
        2482,
        2482,
        2486,
        2489,
        2493,
        2493,
        2510,
        2510,
        2524,
        2525,
        2527,
        2529,
        2544,
        2545,
        2565,
        2570,
        2575,
        2576,
        2579,
        2600,
        2602,
        2608,
        2610,
        2611,
        2613,
        2614,
        2616,
        2617,
        2649,
        2652,
        2654,
        2654,
        2674,
        2676,
        2693,
        2701,
        2703,
        2705,
        2707,
        2728,
        2730,
        2736,
        2738,
        2739,
        2741,
        2745,
        2749,
        2749,
        2768,
        2768,
        2784,
        2785,
        2821,
        2828,
        2831,
        2832,
        2835,
        2856,
        2858,
        2864,
        2866,
        2867,
        2869,
        2873,
        2877,
        2877,
        2908,
        2909,
        2911,
        2913,
        2929,
        2929,
        2947,
        2947,
        2949,
        2954,
        2958,
        2960,
        2962,
        2965,
        2969,
        2970,
        2972,
        2972,
        2974,
        2975,
        2979,
        2980,
        2984,
        2986,
        2990,
        3001,
        3024,
        3024,
        3077,
        3084,
        3086,
        3088,
        3090,
        3112,
        3114,
        3123,
        3125,
        3129,
        3133,
        3133,
        3160,
        3161,
        3168,
        3169,
        3205,
        3212,
        3214,
        3216,
        3218,
        3240,
        3242,
        3251,
        3253,
        3257,
        3261,
        3261,
        3294,
        3294,
        3296,
        3297,
        3313,
        3314,
        3333,
        3340,
        3342,
        3344,
        3346,
        3386,
        3389,
        3389,
        3406,
        3406,
        3424,
        3425,
        3450,
        3455,
        3461,
        3478,
        3482,
        3505,
        3507,
        3515,
        3517,
        3517,
        3520,
        3526,
        3585,
        3632,
        3634,
        3635,
        3648,
        3654,
        3713,
        3714,
        3716,
        3716,
        3719,
        3720,
        3722,
        3722,
        3725,
        3725,
        3732,
        3735,
        3737,
        3743,
        3745,
        3747,
        3749,
        3749,
        3751,
        3751,
        3754,
        3755,
        3757,
        3760,
        3762,
        3763,
        3773,
        3773,
        3776,
        3780,
        3782,
        3782,
        3804,
        3807,
        3840,
        3840,
        3904,
        3911,
        3913,
        3948,
        3976,
        3980,
        4096,
        4138,
        4159,
        4159,
        4176,
        4181,
        4186,
        4189,
        4193,
        4193,
        4197,
        4198,
        4206,
        4208,
        4213,
        4225,
        4238,
        4238,
        4256,
        4293,
        4295,
        4295,
        4301,
        4301,
        4304,
        4346,
        4348,
        4680,
        4682,
        4685,
        4688,
        4694,
        4696,
        4696,
        4698,
        4701,
        4704,
        4744,
        4746,
        4749,
        4752,
        4784,
        4786,
        4789,
        4792,
        4798,
        4800,
        4800,
        4802,
        4805,
        4808,
        4822,
        4824,
        4880,
        4882,
        4885,
        4888,
        4954,
        4992,
        5007,
        5024,
        5108,
        5121,
        5740,
        5743,
        5759,
        5761,
        5786,
        5792,
        5866,
        5870,
        5872,
        5888,
        5900,
        5902,
        5905,
        5920,
        5937,
        5952,
        5969,
        5984,
        5996,
        5998,
        6e3,
        6016,
        6067,
        6103,
        6103,
        6108,
        6108,
        6176,
        6263,
        6272,
        6312,
        6314,
        6314,
        6320,
        6389,
        6400,
        6428,
        6480,
        6509,
        6512,
        6516,
        6528,
        6571,
        6593,
        6599,
        6656,
        6678,
        6688,
        6740,
        6823,
        6823,
        6917,
        6963,
        6981,
        6987,
        7043,
        7072,
        7086,
        7087,
        7098,
        7141,
        7168,
        7203,
        7245,
        7247,
        7258,
        7293,
        7401,
        7404,
        7406,
        7409,
        7413,
        7414,
        7424,
        7615,
        7680,
        7957,
        7960,
        7965,
        7968,
        8005,
        8008,
        8013,
        8016,
        8023,
        8025,
        8025,
        8027,
        8027,
        8029,
        8029,
        8031,
        8061,
        8064,
        8116,
        8118,
        8124,
        8126,
        8126,
        8130,
        8132,
        8134,
        8140,
        8144,
        8147,
        8150,
        8155,
        8160,
        8172,
        8178,
        8180,
        8182,
        8188,
        8305,
        8305,
        8319,
        8319,
        8336,
        8348,
        8450,
        8450,
        8455,
        8455,
        8458,
        8467,
        8469,
        8469,
        8473,
        8477,
        8484,
        8484,
        8486,
        8486,
        8488,
        8488,
        8490,
        8493,
        8495,
        8505,
        8508,
        8511,
        8517,
        8521,
        8526,
        8526,
        8544,
        8584,
        11264,
        11310,
        11312,
        11358,
        11360,
        11492,
        11499,
        11502,
        11506,
        11507,
        11520,
        11557,
        11559,
        11559,
        11565,
        11565,
        11568,
        11623,
        11631,
        11631,
        11648,
        11670,
        11680,
        11686,
        11688,
        11694,
        11696,
        11702,
        11704,
        11710,
        11712,
        11718,
        11720,
        11726,
        11728,
        11734,
        11736,
        11742,
        11823,
        11823,
        12293,
        12295,
        12321,
        12329,
        12337,
        12341,
        12344,
        12348,
        12353,
        12438,
        12445,
        12447,
        12449,
        12538,
        12540,
        12543,
        12549,
        12589,
        12593,
        12686,
        12704,
        12730,
        12784,
        12799,
        13312,
        19893,
        19968,
        40908,
        40960,
        42124,
        42192,
        42237,
        42240,
        42508,
        42512,
        42527,
        42538,
        42539,
        42560,
        42606,
        42623,
        42647,
        42656,
        42735,
        42775,
        42783,
        42786,
        42888,
        42891,
        42894,
        42896,
        42899,
        42912,
        42922,
        43e3,
        43009,
        43011,
        43013,
        43015,
        43018,
        43020,
        43042,
        43072,
        43123,
        43138,
        43187,
        43250,
        43255,
        43259,
        43259,
        43274,
        43301,
        43312,
        43334,
        43360,
        43388,
        43396,
        43442,
        43471,
        43471,
        43520,
        43560,
        43584,
        43586,
        43588,
        43595,
        43616,
        43638,
        43642,
        43642,
        43648,
        43695,
        43697,
        43697,
        43701,
        43702,
        43705,
        43709,
        43712,
        43712,
        43714,
        43714,
        43739,
        43741,
        43744,
        43754,
        43762,
        43764,
        43777,
        43782,
        43785,
        43790,
        43793,
        43798,
        43808,
        43814,
        43816,
        43822,
        43968,
        44002,
        44032,
        55203,
        55216,
        55238,
        55243,
        55291,
        63744,
        64109,
        64112,
        64217,
        64256,
        64262,
        64275,
        64279,
        64285,
        64285,
        64287,
        64296,
        64298,
        64310,
        64312,
        64316,
        64318,
        64318,
        64320,
        64321,
        64323,
        64324,
        64326,
        64433,
        64467,
        64829,
        64848,
        64911,
        64914,
        64967,
        65008,
        65019,
        65136,
        65140,
        65142,
        65276,
        65313,
        65338,
        65345,
        65370,
        65382,
        65470,
        65474,
        65479,
        65482,
        65487,
        65490,
        65495,
        65498,
        65500
    ];
    var unicodeES5IdentifierPart = [
        170,
        170,
        181,
        181,
        186,
        186,
        192,
        214,
        216,
        246,
        248,
        705,
        710,
        721,
        736,
        740,
        748,
        748,
        750,
        750,
        768,
        884,
        886,
        887,
        890,
        893,
        902,
        902,
        904,
        906,
        908,
        908,
        910,
        929,
        931,
        1013,
        1015,
        1153,
        1155,
        1159,
        1162,
        1319,
        1329,
        1366,
        1369,
        1369,
        1377,
        1415,
        1425,
        1469,
        1471,
        1471,
        1473,
        1474,
        1476,
        1477,
        1479,
        1479,
        1488,
        1514,
        1520,
        1522,
        1552,
        1562,
        1568,
        1641,
        1646,
        1747,
        1749,
        1756,
        1759,
        1768,
        1770,
        1788,
        1791,
        1791,
        1808,
        1866,
        1869,
        1969,
        1984,
        2037,
        2042,
        2042,
        2048,
        2093,
        2112,
        2139,
        2208,
        2208,
        2210,
        2220,
        2276,
        2302,
        2304,
        2403,
        2406,
        2415,
        2417,
        2423,
        2425,
        2431,
        2433,
        2435,
        2437,
        2444,
        2447,
        2448,
        2451,
        2472,
        2474,
        2480,
        2482,
        2482,
        2486,
        2489,
        2492,
        2500,
        2503,
        2504,
        2507,
        2510,
        2519,
        2519,
        2524,
        2525,
        2527,
        2531,
        2534,
        2545,
        2561,
        2563,
        2565,
        2570,
        2575,
        2576,
        2579,
        2600,
        2602,
        2608,
        2610,
        2611,
        2613,
        2614,
        2616,
        2617,
        2620,
        2620,
        2622,
        2626,
        2631,
        2632,
        2635,
        2637,
        2641,
        2641,
        2649,
        2652,
        2654,
        2654,
        2662,
        2677,
        2689,
        2691,
        2693,
        2701,
        2703,
        2705,
        2707,
        2728,
        2730,
        2736,
        2738,
        2739,
        2741,
        2745,
        2748,
        2757,
        2759,
        2761,
        2763,
        2765,
        2768,
        2768,
        2784,
        2787,
        2790,
        2799,
        2817,
        2819,
        2821,
        2828,
        2831,
        2832,
        2835,
        2856,
        2858,
        2864,
        2866,
        2867,
        2869,
        2873,
        2876,
        2884,
        2887,
        2888,
        2891,
        2893,
        2902,
        2903,
        2908,
        2909,
        2911,
        2915,
        2918,
        2927,
        2929,
        2929,
        2946,
        2947,
        2949,
        2954,
        2958,
        2960,
        2962,
        2965,
        2969,
        2970,
        2972,
        2972,
        2974,
        2975,
        2979,
        2980,
        2984,
        2986,
        2990,
        3001,
        3006,
        3010,
        3014,
        3016,
        3018,
        3021,
        3024,
        3024,
        3031,
        3031,
        3046,
        3055,
        3073,
        3075,
        3077,
        3084,
        3086,
        3088,
        3090,
        3112,
        3114,
        3123,
        3125,
        3129,
        3133,
        3140,
        3142,
        3144,
        3146,
        3149,
        3157,
        3158,
        3160,
        3161,
        3168,
        3171,
        3174,
        3183,
        3202,
        3203,
        3205,
        3212,
        3214,
        3216,
        3218,
        3240,
        3242,
        3251,
        3253,
        3257,
        3260,
        3268,
        3270,
        3272,
        3274,
        3277,
        3285,
        3286,
        3294,
        3294,
        3296,
        3299,
        3302,
        3311,
        3313,
        3314,
        3330,
        3331,
        3333,
        3340,
        3342,
        3344,
        3346,
        3386,
        3389,
        3396,
        3398,
        3400,
        3402,
        3406,
        3415,
        3415,
        3424,
        3427,
        3430,
        3439,
        3450,
        3455,
        3458,
        3459,
        3461,
        3478,
        3482,
        3505,
        3507,
        3515,
        3517,
        3517,
        3520,
        3526,
        3530,
        3530,
        3535,
        3540,
        3542,
        3542,
        3544,
        3551,
        3570,
        3571,
        3585,
        3642,
        3648,
        3662,
        3664,
        3673,
        3713,
        3714,
        3716,
        3716,
        3719,
        3720,
        3722,
        3722,
        3725,
        3725,
        3732,
        3735,
        3737,
        3743,
        3745,
        3747,
        3749,
        3749,
        3751,
        3751,
        3754,
        3755,
        3757,
        3769,
        3771,
        3773,
        3776,
        3780,
        3782,
        3782,
        3784,
        3789,
        3792,
        3801,
        3804,
        3807,
        3840,
        3840,
        3864,
        3865,
        3872,
        3881,
        3893,
        3893,
        3895,
        3895,
        3897,
        3897,
        3902,
        3911,
        3913,
        3948,
        3953,
        3972,
        3974,
        3991,
        3993,
        4028,
        4038,
        4038,
        4096,
        4169,
        4176,
        4253,
        4256,
        4293,
        4295,
        4295,
        4301,
        4301,
        4304,
        4346,
        4348,
        4680,
        4682,
        4685,
        4688,
        4694,
        4696,
        4696,
        4698,
        4701,
        4704,
        4744,
        4746,
        4749,
        4752,
        4784,
        4786,
        4789,
        4792,
        4798,
        4800,
        4800,
        4802,
        4805,
        4808,
        4822,
        4824,
        4880,
        4882,
        4885,
        4888,
        4954,
        4957,
        4959,
        4992,
        5007,
        5024,
        5108,
        5121,
        5740,
        5743,
        5759,
        5761,
        5786,
        5792,
        5866,
        5870,
        5872,
        5888,
        5900,
        5902,
        5908,
        5920,
        5940,
        5952,
        5971,
        5984,
        5996,
        5998,
        6e3,
        6002,
        6003,
        6016,
        6099,
        6103,
        6103,
        6108,
        6109,
        6112,
        6121,
        6155,
        6157,
        6160,
        6169,
        6176,
        6263,
        6272,
        6314,
        6320,
        6389,
        6400,
        6428,
        6432,
        6443,
        6448,
        6459,
        6470,
        6509,
        6512,
        6516,
        6528,
        6571,
        6576,
        6601,
        6608,
        6617,
        6656,
        6683,
        6688,
        6750,
        6752,
        6780,
        6783,
        6793,
        6800,
        6809,
        6823,
        6823,
        6912,
        6987,
        6992,
        7001,
        7019,
        7027,
        7040,
        7155,
        7168,
        7223,
        7232,
        7241,
        7245,
        7293,
        7376,
        7378,
        7380,
        7414,
        7424,
        7654,
        7676,
        7957,
        7960,
        7965,
        7968,
        8005,
        8008,
        8013,
        8016,
        8023,
        8025,
        8025,
        8027,
        8027,
        8029,
        8029,
        8031,
        8061,
        8064,
        8116,
        8118,
        8124,
        8126,
        8126,
        8130,
        8132,
        8134,
        8140,
        8144,
        8147,
        8150,
        8155,
        8160,
        8172,
        8178,
        8180,
        8182,
        8188,
        8204,
        8205,
        8255,
        8256,
        8276,
        8276,
        8305,
        8305,
        8319,
        8319,
        8336,
        8348,
        8400,
        8412,
        8417,
        8417,
        8421,
        8432,
        8450,
        8450,
        8455,
        8455,
        8458,
        8467,
        8469,
        8469,
        8473,
        8477,
        8484,
        8484,
        8486,
        8486,
        8488,
        8488,
        8490,
        8493,
        8495,
        8505,
        8508,
        8511,
        8517,
        8521,
        8526,
        8526,
        8544,
        8584,
        11264,
        11310,
        11312,
        11358,
        11360,
        11492,
        11499,
        11507,
        11520,
        11557,
        11559,
        11559,
        11565,
        11565,
        11568,
        11623,
        11631,
        11631,
        11647,
        11670,
        11680,
        11686,
        11688,
        11694,
        11696,
        11702,
        11704,
        11710,
        11712,
        11718,
        11720,
        11726,
        11728,
        11734,
        11736,
        11742,
        11744,
        11775,
        11823,
        11823,
        12293,
        12295,
        12321,
        12335,
        12337,
        12341,
        12344,
        12348,
        12353,
        12438,
        12441,
        12442,
        12445,
        12447,
        12449,
        12538,
        12540,
        12543,
        12549,
        12589,
        12593,
        12686,
        12704,
        12730,
        12784,
        12799,
        13312,
        19893,
        19968,
        40908,
        40960,
        42124,
        42192,
        42237,
        42240,
        42508,
        42512,
        42539,
        42560,
        42607,
        42612,
        42621,
        42623,
        42647,
        42655,
        42737,
        42775,
        42783,
        42786,
        42888,
        42891,
        42894,
        42896,
        42899,
        42912,
        42922,
        43e3,
        43047,
        43072,
        43123,
        43136,
        43204,
        43216,
        43225,
        43232,
        43255,
        43259,
        43259,
        43264,
        43309,
        43312,
        43347,
        43360,
        43388,
        43392,
        43456,
        43471,
        43481,
        43520,
        43574,
        43584,
        43597,
        43600,
        43609,
        43616,
        43638,
        43642,
        43643,
        43648,
        43714,
        43739,
        43741,
        43744,
        43759,
        43762,
        43766,
        43777,
        43782,
        43785,
        43790,
        43793,
        43798,
        43808,
        43814,
        43816,
        43822,
        43968,
        44010,
        44012,
        44013,
        44016,
        44025,
        44032,
        55203,
        55216,
        55238,
        55243,
        55291,
        63744,
        64109,
        64112,
        64217,
        64256,
        64262,
        64275,
        64279,
        64285,
        64296,
        64298,
        64310,
        64312,
        64316,
        64318,
        64318,
        64320,
        64321,
        64323,
        64324,
        64326,
        64433,
        64467,
        64829,
        64848,
        64911,
        64914,
        64967,
        65008,
        65019,
        65024,
        65039,
        65056,
        65062,
        65075,
        65076,
        65101,
        65103,
        65136,
        65140,
        65142,
        65276,
        65296,
        65305,
        65313,
        65338,
        65343,
        65343,
        65345,
        65370,
        65382,
        65470,
        65474,
        65479,
        65482,
        65487,
        65490,
        65495,
        65498,
        65500
    ];
    var unicodeESNextIdentifierStart = [
        65,
        90,
        97,
        122,
        170,
        170,
        181,
        181,
        186,
        186,
        192,
        214,
        216,
        246,
        248,
        705,
        710,
        721,
        736,
        740,
        748,
        748,
        750,
        750,
        880,
        884,
        886,
        887,
        890,
        893,
        895,
        895,
        902,
        902,
        904,
        906,
        908,
        908,
        910,
        929,
        931,
        1013,
        1015,
        1153,
        1162,
        1327,
        1329,
        1366,
        1369,
        1369,
        1376,
        1416,
        1488,
        1514,
        1519,
        1522,
        1568,
        1610,
        1646,
        1647,
        1649,
        1747,
        1749,
        1749,
        1765,
        1766,
        1774,
        1775,
        1786,
        1788,
        1791,
        1791,
        1808,
        1808,
        1810,
        1839,
        1869,
        1957,
        1969,
        1969,
        1994,
        2026,
        2036,
        2037,
        2042,
        2042,
        2048,
        2069,
        2074,
        2074,
        2084,
        2084,
        2088,
        2088,
        2112,
        2136,
        2144,
        2154,
        2160,
        2183,
        2185,
        2190,
        2208,
        2249,
        2308,
        2361,
        2365,
        2365,
        2384,
        2384,
        2392,
        2401,
        2417,
        2432,
        2437,
        2444,
        2447,
        2448,
        2451,
        2472,
        2474,
        2480,
        2482,
        2482,
        2486,
        2489,
        2493,
        2493,
        2510,
        2510,
        2524,
        2525,
        2527,
        2529,
        2544,
        2545,
        2556,
        2556,
        2565,
        2570,
        2575,
        2576,
        2579,
        2600,
        2602,
        2608,
        2610,
        2611,
        2613,
        2614,
        2616,
        2617,
        2649,
        2652,
        2654,
        2654,
        2674,
        2676,
        2693,
        2701,
        2703,
        2705,
        2707,
        2728,
        2730,
        2736,
        2738,
        2739,
        2741,
        2745,
        2749,
        2749,
        2768,
        2768,
        2784,
        2785,
        2809,
        2809,
        2821,
        2828,
        2831,
        2832,
        2835,
        2856,
        2858,
        2864,
        2866,
        2867,
        2869,
        2873,
        2877,
        2877,
        2908,
        2909,
        2911,
        2913,
        2929,
        2929,
        2947,
        2947,
        2949,
        2954,
        2958,
        2960,
        2962,
        2965,
        2969,
        2970,
        2972,
        2972,
        2974,
        2975,
        2979,
        2980,
        2984,
        2986,
        2990,
        3001,
        3024,
        3024,
        3077,
        3084,
        3086,
        3088,
        3090,
        3112,
        3114,
        3129,
        3133,
        3133,
        3160,
        3162,
        3165,
        3165,
        3168,
        3169,
        3200,
        3200,
        3205,
        3212,
        3214,
        3216,
        3218,
        3240,
        3242,
        3251,
        3253,
        3257,
        3261,
        3261,
        3293,
        3294,
        3296,
        3297,
        3313,
        3314,
        3332,
        3340,
        3342,
        3344,
        3346,
        3386,
        3389,
        3389,
        3406,
        3406,
        3412,
        3414,
        3423,
        3425,
        3450,
        3455,
        3461,
        3478,
        3482,
        3505,
        3507,
        3515,
        3517,
        3517,
        3520,
        3526,
        3585,
        3632,
        3634,
        3635,
        3648,
        3654,
        3713,
        3714,
        3716,
        3716,
        3718,
        3722,
        3724,
        3747,
        3749,
        3749,
        3751,
        3760,
        3762,
        3763,
        3773,
        3773,
        3776,
        3780,
        3782,
        3782,
        3804,
        3807,
        3840,
        3840,
        3904,
        3911,
        3913,
        3948,
        3976,
        3980,
        4096,
        4138,
        4159,
        4159,
        4176,
        4181,
        4186,
        4189,
        4193,
        4193,
        4197,
        4198,
        4206,
        4208,
        4213,
        4225,
        4238,
        4238,
        4256,
        4293,
        4295,
        4295,
        4301,
        4301,
        4304,
        4346,
        4348,
        4680,
        4682,
        4685,
        4688,
        4694,
        4696,
        4696,
        4698,
        4701,
        4704,
        4744,
        4746,
        4749,
        4752,
        4784,
        4786,
        4789,
        4792,
        4798,
        4800,
        4800,
        4802,
        4805,
        4808,
        4822,
        4824,
        4880,
        4882,
        4885,
        4888,
        4954,
        4992,
        5007,
        5024,
        5109,
        5112,
        5117,
        5121,
        5740,
        5743,
        5759,
        5761,
        5786,
        5792,
        5866,
        5870,
        5880,
        5888,
        5905,
        5919,
        5937,
        5952,
        5969,
        5984,
        5996,
        5998,
        6e3,
        6016,
        6067,
        6103,
        6103,
        6108,
        6108,
        6176,
        6264,
        6272,
        6312,
        6314,
        6314,
        6320,
        6389,
        6400,
        6430,
        6480,
        6509,
        6512,
        6516,
        6528,
        6571,
        6576,
        6601,
        6656,
        6678,
        6688,
        6740,
        6823,
        6823,
        6917,
        6963,
        6981,
        6988,
        7043,
        7072,
        7086,
        7087,
        7098,
        7141,
        7168,
        7203,
        7245,
        7247,
        7258,
        7293,
        7296,
        7304,
        7312,
        7354,
        7357,
        7359,
        7401,
        7404,
        7406,
        7411,
        7413,
        7414,
        7418,
        7418,
        7424,
        7615,
        7680,
        7957,
        7960,
        7965,
        7968,
        8005,
        8008,
        8013,
        8016,
        8023,
        8025,
        8025,
        8027,
        8027,
        8029,
        8029,
        8031,
        8061,
        8064,
        8116,
        8118,
        8124,
        8126,
        8126,
        8130,
        8132,
        8134,
        8140,
        8144,
        8147,
        8150,
        8155,
        8160,
        8172,
        8178,
        8180,
        8182,
        8188,
        8305,
        8305,
        8319,
        8319,
        8336,
        8348,
        8450,
        8450,
        8455,
        8455,
        8458,
        8467,
        8469,
        8469,
        8472,
        8477,
        8484,
        8484,
        8486,
        8486,
        8488,
        8488,
        8490,
        8505,
        8508,
        8511,
        8517,
        8521,
        8526,
        8526,
        8544,
        8584,
        11264,
        11492,
        11499,
        11502,
        11506,
        11507,
        11520,
        11557,
        11559,
        11559,
        11565,
        11565,
        11568,
        11623,
        11631,
        11631,
        11648,
        11670,
        11680,
        11686,
        11688,
        11694,
        11696,
        11702,
        11704,
        11710,
        11712,
        11718,
        11720,
        11726,
        11728,
        11734,
        11736,
        11742,
        12293,
        12295,
        12321,
        12329,
        12337,
        12341,
        12344,
        12348,
        12353,
        12438,
        12443,
        12447,
        12449,
        12538,
        12540,
        12543,
        12549,
        12591,
        12593,
        12686,
        12704,
        12735,
        12784,
        12799,
        13312,
        19903,
        19968,
        42124,
        42192,
        42237,
        42240,
        42508,
        42512,
        42527,
        42538,
        42539,
        42560,
        42606,
        42623,
        42653,
        42656,
        42735,
        42775,
        42783,
        42786,
        42888,
        42891,
        42954,
        42960,
        42961,
        42963,
        42963,
        42965,
        42969,
        42994,
        43009,
        43011,
        43013,
        43015,
        43018,
        43020,
        43042,
        43072,
        43123,
        43138,
        43187,
        43250,
        43255,
        43259,
        43259,
        43261,
        43262,
        43274,
        43301,
        43312,
        43334,
        43360,
        43388,
        43396,
        43442,
        43471,
        43471,
        43488,
        43492,
        43494,
        43503,
        43514,
        43518,
        43520,
        43560,
        43584,
        43586,
        43588,
        43595,
        43616,
        43638,
        43642,
        43642,
        43646,
        43695,
        43697,
        43697,
        43701,
        43702,
        43705,
        43709,
        43712,
        43712,
        43714,
        43714,
        43739,
        43741,
        43744,
        43754,
        43762,
        43764,
        43777,
        43782,
        43785,
        43790,
        43793,
        43798,
        43808,
        43814,
        43816,
        43822,
        43824,
        43866,
        43868,
        43881,
        43888,
        44002,
        44032,
        55203,
        55216,
        55238,
        55243,
        55291,
        63744,
        64109,
        64112,
        64217,
        64256,
        64262,
        64275,
        64279,
        64285,
        64285,
        64287,
        64296,
        64298,
        64310,
        64312,
        64316,
        64318,
        64318,
        64320,
        64321,
        64323,
        64324,
        64326,
        64433,
        64467,
        64829,
        64848,
        64911,
        64914,
        64967,
        65008,
        65019,
        65136,
        65140,
        65142,
        65276,
        65313,
        65338,
        65345,
        65370,
        65382,
        65470,
        65474,
        65479,
        65482,
        65487,
        65490,
        65495,
        65498,
        65500,
        65536,
        65547,
        65549,
        65574,
        65576,
        65594,
        65596,
        65597,
        65599,
        65613,
        65616,
        65629,
        65664,
        65786,
        65856,
        65908,
        66176,
        66204,
        66208,
        66256,
        66304,
        66335,
        66349,
        66378,
        66384,
        66421,
        66432,
        66461,
        66464,
        66499,
        66504,
        66511,
        66513,
        66517,
        66560,
        66717,
        66736,
        66771,
        66776,
        66811,
        66816,
        66855,
        66864,
        66915,
        66928,
        66938,
        66940,
        66954,
        66956,
        66962,
        66964,
        66965,
        66967,
        66977,
        66979,
        66993,
        66995,
        67001,
        67003,
        67004,
        67072,
        67382,
        67392,
        67413,
        67424,
        67431,
        67456,
        67461,
        67463,
        67504,
        67506,
        67514,
        67584,
        67589,
        67592,
        67592,
        67594,
        67637,
        67639,
        67640,
        67644,
        67644,
        67647,
        67669,
        67680,
        67702,
        67712,
        67742,
        67808,
        67826,
        67828,
        67829,
        67840,
        67861,
        67872,
        67897,
        67968,
        68023,
        68030,
        68031,
        68096,
        68096,
        68112,
        68115,
        68117,
        68119,
        68121,
        68149,
        68192,
        68220,
        68224,
        68252,
        68288,
        68295,
        68297,
        68324,
        68352,
        68405,
        68416,
        68437,
        68448,
        68466,
        68480,
        68497,
        68608,
        68680,
        68736,
        68786,
        68800,
        68850,
        68864,
        68899,
        69248,
        69289,
        69296,
        69297,
        69376,
        69404,
        69415,
        69415,
        69424,
        69445,
        69488,
        69505,
        69552,
        69572,
        69600,
        69622,
        69635,
        69687,
        69745,
        69746,
        69749,
        69749,
        69763,
        69807,
        69840,
        69864,
        69891,
        69926,
        69956,
        69956,
        69959,
        69959,
        69968,
        70002,
        70006,
        70006,
        70019,
        70066,
        70081,
        70084,
        70106,
        70106,
        70108,
        70108,
        70144,
        70161,
        70163,
        70187,
        70207,
        70208,
        70272,
        70278,
        70280,
        70280,
        70282,
        70285,
        70287,
        70301,
        70303,
        70312,
        70320,
        70366,
        70405,
        70412,
        70415,
        70416,
        70419,
        70440,
        70442,
        70448,
        70450,
        70451,
        70453,
        70457,
        70461,
        70461,
        70480,
        70480,
        70493,
        70497,
        70656,
        70708,
        70727,
        70730,
        70751,
        70753,
        70784,
        70831,
        70852,
        70853,
        70855,
        70855,
        71040,
        71086,
        71128,
        71131,
        71168,
        71215,
        71236,
        71236,
        71296,
        71338,
        71352,
        71352,
        71424,
        71450,
        71488,
        71494,
        71680,
        71723,
        71840,
        71903,
        71935,
        71942,
        71945,
        71945,
        71948,
        71955,
        71957,
        71958,
        71960,
        71983,
        71999,
        71999,
        72001,
        72001,
        72096,
        72103,
        72106,
        72144,
        72161,
        72161,
        72163,
        72163,
        72192,
        72192,
        72203,
        72242,
        72250,
        72250,
        72272,
        72272,
        72284,
        72329,
        72349,
        72349,
        72368,
        72440,
        72704,
        72712,
        72714,
        72750,
        72768,
        72768,
        72818,
        72847,
        72960,
        72966,
        72968,
        72969,
        72971,
        73008,
        73030,
        73030,
        73056,
        73061,
        73063,
        73064,
        73066,
        73097,
        73112,
        73112,
        73440,
        73458,
        73474,
        73474,
        73476,
        73488,
        73490,
        73523,
        73648,
        73648,
        73728,
        74649,
        74752,
        74862,
        74880,
        75075,
        77712,
        77808,
        77824,
        78895,
        78913,
        78918,
        82944,
        83526,
        92160,
        92728,
        92736,
        92766,
        92784,
        92862,
        92880,
        92909,
        92928,
        92975,
        92992,
        92995,
        93027,
        93047,
        93053,
        93071,
        93760,
        93823,
        93952,
        94026,
        94032,
        94032,
        94099,
        94111,
        94176,
        94177,
        94179,
        94179,
        94208,
        100343,
        100352,
        101589,
        101632,
        101640,
        110576,
        110579,
        110581,
        110587,
        110589,
        110590,
        110592,
        110882,
        110898,
        110898,
        110928,
        110930,
        110933,
        110933,
        110948,
        110951,
        110960,
        111355,
        113664,
        113770,
        113776,
        113788,
        113792,
        113800,
        113808,
        113817,
        119808,
        119892,
        119894,
        119964,
        119966,
        119967,
        119970,
        119970,
        119973,
        119974,
        119977,
        119980,
        119982,
        119993,
        119995,
        119995,
        119997,
        120003,
        120005,
        120069,
        120071,
        120074,
        120077,
        120084,
        120086,
        120092,
        120094,
        120121,
        120123,
        120126,
        120128,
        120132,
        120134,
        120134,
        120138,
        120144,
        120146,
        120485,
        120488,
        120512,
        120514,
        120538,
        120540,
        120570,
        120572,
        120596,
        120598,
        120628,
        120630,
        120654,
        120656,
        120686,
        120688,
        120712,
        120714,
        120744,
        120746,
        120770,
        120772,
        120779,
        122624,
        122654,
        122661,
        122666,
        122928,
        122989,
        123136,
        123180,
        123191,
        123197,
        123214,
        123214,
        123536,
        123565,
        123584,
        123627,
        124112,
        124139,
        124896,
        124902,
        124904,
        124907,
        124909,
        124910,
        124912,
        124926,
        124928,
        125124,
        125184,
        125251,
        125259,
        125259,
        126464,
        126467,
        126469,
        126495,
        126497,
        126498,
        126500,
        126500,
        126503,
        126503,
        126505,
        126514,
        126516,
        126519,
        126521,
        126521,
        126523,
        126523,
        126530,
        126530,
        126535,
        126535,
        126537,
        126537,
        126539,
        126539,
        126541,
        126543,
        126545,
        126546,
        126548,
        126548,
        126551,
        126551,
        126553,
        126553,
        126555,
        126555,
        126557,
        126557,
        126559,
        126559,
        126561,
        126562,
        126564,
        126564,
        126567,
        126570,
        126572,
        126578,
        126580,
        126583,
        126585,
        126588,
        126590,
        126590,
        126592,
        126601,
        126603,
        126619,
        126625,
        126627,
        126629,
        126633,
        126635,
        126651,
        131072,
        173791,
        173824,
        177977,
        177984,
        178205,
        178208,
        183969,
        183984,
        191456,
        191472,
        192093,
        194560,
        195101,
        196608,
        201546,
        201552,
        205743
    ];
    var unicodeESNextIdentifierPart = [
        48,
        57,
        65,
        90,
        95,
        95,
        97,
        122,
        170,
        170,
        181,
        181,
        183,
        183,
        186,
        186,
        192,
        214,
        216,
        246,
        248,
        705,
        710,
        721,
        736,
        740,
        748,
        748,
        750,
        750,
        768,
        884,
        886,
        887,
        890,
        893,
        895,
        895,
        902,
        906,
        908,
        908,
        910,
        929,
        931,
        1013,
        1015,
        1153,
        1155,
        1159,
        1162,
        1327,
        1329,
        1366,
        1369,
        1369,
        1376,
        1416,
        1425,
        1469,
        1471,
        1471,
        1473,
        1474,
        1476,
        1477,
        1479,
        1479,
        1488,
        1514,
        1519,
        1522,
        1552,
        1562,
        1568,
        1641,
        1646,
        1747,
        1749,
        1756,
        1759,
        1768,
        1770,
        1788,
        1791,
        1791,
        1808,
        1866,
        1869,
        1969,
        1984,
        2037,
        2042,
        2042,
        2045,
        2045,
        2048,
        2093,
        2112,
        2139,
        2144,
        2154,
        2160,
        2183,
        2185,
        2190,
        2200,
        2273,
        2275,
        2403,
        2406,
        2415,
        2417,
        2435,
        2437,
        2444,
        2447,
        2448,
        2451,
        2472,
        2474,
        2480,
        2482,
        2482,
        2486,
        2489,
        2492,
        2500,
        2503,
        2504,
        2507,
        2510,
        2519,
        2519,
        2524,
        2525,
        2527,
        2531,
        2534,
        2545,
        2556,
        2556,
        2558,
        2558,
        2561,
        2563,
        2565,
        2570,
        2575,
        2576,
        2579,
        2600,
        2602,
        2608,
        2610,
        2611,
        2613,
        2614,
        2616,
        2617,
        2620,
        2620,
        2622,
        2626,
        2631,
        2632,
        2635,
        2637,
        2641,
        2641,
        2649,
        2652,
        2654,
        2654,
        2662,
        2677,
        2689,
        2691,
        2693,
        2701,
        2703,
        2705,
        2707,
        2728,
        2730,
        2736,
        2738,
        2739,
        2741,
        2745,
        2748,
        2757,
        2759,
        2761,
        2763,
        2765,
        2768,
        2768,
        2784,
        2787,
        2790,
        2799,
        2809,
        2815,
        2817,
        2819,
        2821,
        2828,
        2831,
        2832,
        2835,
        2856,
        2858,
        2864,
        2866,
        2867,
        2869,
        2873,
        2876,
        2884,
        2887,
        2888,
        2891,
        2893,
        2901,
        2903,
        2908,
        2909,
        2911,
        2915,
        2918,
        2927,
        2929,
        2929,
        2946,
        2947,
        2949,
        2954,
        2958,
        2960,
        2962,
        2965,
        2969,
        2970,
        2972,
        2972,
        2974,
        2975,
        2979,
        2980,
        2984,
        2986,
        2990,
        3001,
        3006,
        3010,
        3014,
        3016,
        3018,
        3021,
        3024,
        3024,
        3031,
        3031,
        3046,
        3055,
        3072,
        3084,
        3086,
        3088,
        3090,
        3112,
        3114,
        3129,
        3132,
        3140,
        3142,
        3144,
        3146,
        3149,
        3157,
        3158,
        3160,
        3162,
        3165,
        3165,
        3168,
        3171,
        3174,
        3183,
        3200,
        3203,
        3205,
        3212,
        3214,
        3216,
        3218,
        3240,
        3242,
        3251,
        3253,
        3257,
        3260,
        3268,
        3270,
        3272,
        3274,
        3277,
        3285,
        3286,
        3293,
        3294,
        3296,
        3299,
        3302,
        3311,
        3313,
        3315,
        3328,
        3340,
        3342,
        3344,
        3346,
        3396,
        3398,
        3400,
        3402,
        3406,
        3412,
        3415,
        3423,
        3427,
        3430,
        3439,
        3450,
        3455,
        3457,
        3459,
        3461,
        3478,
        3482,
        3505,
        3507,
        3515,
        3517,
        3517,
        3520,
        3526,
        3530,
        3530,
        3535,
        3540,
        3542,
        3542,
        3544,
        3551,
        3558,
        3567,
        3570,
        3571,
        3585,
        3642,
        3648,
        3662,
        3664,
        3673,
        3713,
        3714,
        3716,
        3716,
        3718,
        3722,
        3724,
        3747,
        3749,
        3749,
        3751,
        3773,
        3776,
        3780,
        3782,
        3782,
        3784,
        3790,
        3792,
        3801,
        3804,
        3807,
        3840,
        3840,
        3864,
        3865,
        3872,
        3881,
        3893,
        3893,
        3895,
        3895,
        3897,
        3897,
        3902,
        3911,
        3913,
        3948,
        3953,
        3972,
        3974,
        3991,
        3993,
        4028,
        4038,
        4038,
        4096,
        4169,
        4176,
        4253,
        4256,
        4293,
        4295,
        4295,
        4301,
        4301,
        4304,
        4346,
        4348,
        4680,
        4682,
        4685,
        4688,
        4694,
        4696,
        4696,
        4698,
        4701,
        4704,
        4744,
        4746,
        4749,
        4752,
        4784,
        4786,
        4789,
        4792,
        4798,
        4800,
        4800,
        4802,
        4805,
        4808,
        4822,
        4824,
        4880,
        4882,
        4885,
        4888,
        4954,
        4957,
        4959,
        4969,
        4977,
        4992,
        5007,
        5024,
        5109,
        5112,
        5117,
        5121,
        5740,
        5743,
        5759,
        5761,
        5786,
        5792,
        5866,
        5870,
        5880,
        5888,
        5909,
        5919,
        5940,
        5952,
        5971,
        5984,
        5996,
        5998,
        6e3,
        6002,
        6003,
        6016,
        6099,
        6103,
        6103,
        6108,
        6109,
        6112,
        6121,
        6155,
        6157,
        6159,
        6169,
        6176,
        6264,
        6272,
        6314,
        6320,
        6389,
        6400,
        6430,
        6432,
        6443,
        6448,
        6459,
        6470,
        6509,
        6512,
        6516,
        6528,
        6571,
        6576,
        6601,
        6608,
        6618,
        6656,
        6683,
        6688,
        6750,
        6752,
        6780,
        6783,
        6793,
        6800,
        6809,
        6823,
        6823,
        6832,
        6845,
        6847,
        6862,
        6912,
        6988,
        6992,
        7001,
        7019,
        7027,
        7040,
        7155,
        7168,
        7223,
        7232,
        7241,
        7245,
        7293,
        7296,
        7304,
        7312,
        7354,
        7357,
        7359,
        7376,
        7378,
        7380,
        7418,
        7424,
        7957,
        7960,
        7965,
        7968,
        8005,
        8008,
        8013,
        8016,
        8023,
        8025,
        8025,
        8027,
        8027,
        8029,
        8029,
        8031,
        8061,
        8064,
        8116,
        8118,
        8124,
        8126,
        8126,
        8130,
        8132,
        8134,
        8140,
        8144,
        8147,
        8150,
        8155,
        8160,
        8172,
        8178,
        8180,
        8182,
        8188,
        8204,
        8205,
        8255,
        8256,
        8276,
        8276,
        8305,
        8305,
        8319,
        8319,
        8336,
        8348,
        8400,
        8412,
        8417,
        8417,
        8421,
        8432,
        8450,
        8450,
        8455,
        8455,
        8458,
        8467,
        8469,
        8469,
        8472,
        8477,
        8484,
        8484,
        8486,
        8486,
        8488,
        8488,
        8490,
        8505,
        8508,
        8511,
        8517,
        8521,
        8526,
        8526,
        8544,
        8584,
        11264,
        11492,
        11499,
        11507,
        11520,
        11557,
        11559,
        11559,
        11565,
        11565,
        11568,
        11623,
        11631,
        11631,
        11647,
        11670,
        11680,
        11686,
        11688,
        11694,
        11696,
        11702,
        11704,
        11710,
        11712,
        11718,
        11720,
        11726,
        11728,
        11734,
        11736,
        11742,
        11744,
        11775,
        12293,
        12295,
        12321,
        12335,
        12337,
        12341,
        12344,
        12348,
        12353,
        12438,
        12441,
        12447,
        12449,
        12543,
        12549,
        12591,
        12593,
        12686,
        12704,
        12735,
        12784,
        12799,
        13312,
        19903,
        19968,
        42124,
        42192,
        42237,
        42240,
        42508,
        42512,
        42539,
        42560,
        42607,
        42612,
        42621,
        42623,
        42737,
        42775,
        42783,
        42786,
        42888,
        42891,
        42954,
        42960,
        42961,
        42963,
        42963,
        42965,
        42969,
        42994,
        43047,
        43052,
        43052,
        43072,
        43123,
        43136,
        43205,
        43216,
        43225,
        43232,
        43255,
        43259,
        43259,
        43261,
        43309,
        43312,
        43347,
        43360,
        43388,
        43392,
        43456,
        43471,
        43481,
        43488,
        43518,
        43520,
        43574,
        43584,
        43597,
        43600,
        43609,
        43616,
        43638,
        43642,
        43714,
        43739,
        43741,
        43744,
        43759,
        43762,
        43766,
        43777,
        43782,
        43785,
        43790,
        43793,
        43798,
        43808,
        43814,
        43816,
        43822,
        43824,
        43866,
        43868,
        43881,
        43888,
        44010,
        44012,
        44013,
        44016,
        44025,
        44032,
        55203,
        55216,
        55238,
        55243,
        55291,
        63744,
        64109,
        64112,
        64217,
        64256,
        64262,
        64275,
        64279,
        64285,
        64296,
        64298,
        64310,
        64312,
        64316,
        64318,
        64318,
        64320,
        64321,
        64323,
        64324,
        64326,
        64433,
        64467,
        64829,
        64848,
        64911,
        64914,
        64967,
        65008,
        65019,
        65024,
        65039,
        65056,
        65071,
        65075,
        65076,
        65101,
        65103,
        65136,
        65140,
        65142,
        65276,
        65296,
        65305,
        65313,
        65338,
        65343,
        65343,
        65345,
        65370,
        65381,
        65470,
        65474,
        65479,
        65482,
        65487,
        65490,
        65495,
        65498,
        65500,
        65536,
        65547,
        65549,
        65574,
        65576,
        65594,
        65596,
        65597,
        65599,
        65613,
        65616,
        65629,
        65664,
        65786,
        65856,
        65908,
        66045,
        66045,
        66176,
        66204,
        66208,
        66256,
        66272,
        66272,
        66304,
        66335,
        66349,
        66378,
        66384,
        66426,
        66432,
        66461,
        66464,
        66499,
        66504,
        66511,
        66513,
        66517,
        66560,
        66717,
        66720,
        66729,
        66736,
        66771,
        66776,
        66811,
        66816,
        66855,
        66864,
        66915,
        66928,
        66938,
        66940,
        66954,
        66956,
        66962,
        66964,
        66965,
        66967,
        66977,
        66979,
        66993,
        66995,
        67001,
        67003,
        67004,
        67072,
        67382,
        67392,
        67413,
        67424,
        67431,
        67456,
        67461,
        67463,
        67504,
        67506,
        67514,
        67584,
        67589,
        67592,
        67592,
        67594,
        67637,
        67639,
        67640,
        67644,
        67644,
        67647,
        67669,
        67680,
        67702,
        67712,
        67742,
        67808,
        67826,
        67828,
        67829,
        67840,
        67861,
        67872,
        67897,
        67968,
        68023,
        68030,
        68031,
        68096,
        68099,
        68101,
        68102,
        68108,
        68115,
        68117,
        68119,
        68121,
        68149,
        68152,
        68154,
        68159,
        68159,
        68192,
        68220,
        68224,
        68252,
        68288,
        68295,
        68297,
        68326,
        68352,
        68405,
        68416,
        68437,
        68448,
        68466,
        68480,
        68497,
        68608,
        68680,
        68736,
        68786,
        68800,
        68850,
        68864,
        68903,
        68912,
        68921,
        69248,
        69289,
        69291,
        69292,
        69296,
        69297,
        69373,
        69404,
        69415,
        69415,
        69424,
        69456,
        69488,
        69509,
        69552,
        69572,
        69600,
        69622,
        69632,
        69702,
        69734,
        69749,
        69759,
        69818,
        69826,
        69826,
        69840,
        69864,
        69872,
        69881,
        69888,
        69940,
        69942,
        69951,
        69956,
        69959,
        69968,
        70003,
        70006,
        70006,
        70016,
        70084,
        70089,
        70092,
        70094,
        70106,
        70108,
        70108,
        70144,
        70161,
        70163,
        70199,
        70206,
        70209,
        70272,
        70278,
        70280,
        70280,
        70282,
        70285,
        70287,
        70301,
        70303,
        70312,
        70320,
        70378,
        70384,
        70393,
        70400,
        70403,
        70405,
        70412,
        70415,
        70416,
        70419,
        70440,
        70442,
        70448,
        70450,
        70451,
        70453,
        70457,
        70459,
        70468,
        70471,
        70472,
        70475,
        70477,
        70480,
        70480,
        70487,
        70487,
        70493,
        70499,
        70502,
        70508,
        70512,
        70516,
        70656,
        70730,
        70736,
        70745,
        70750,
        70753,
        70784,
        70853,
        70855,
        70855,
        70864,
        70873,
        71040,
        71093,
        71096,
        71104,
        71128,
        71133,
        71168,
        71232,
        71236,
        71236,
        71248,
        71257,
        71296,
        71352,
        71360,
        71369,
        71424,
        71450,
        71453,
        71467,
        71472,
        71481,
        71488,
        71494,
        71680,
        71738,
        71840,
        71913,
        71935,
        71942,
        71945,
        71945,
        71948,
        71955,
        71957,
        71958,
        71960,
        71989,
        71991,
        71992,
        71995,
        72003,
        72016,
        72025,
        72096,
        72103,
        72106,
        72151,
        72154,
        72161,
        72163,
        72164,
        72192,
        72254,
        72263,
        72263,
        72272,
        72345,
        72349,
        72349,
        72368,
        72440,
        72704,
        72712,
        72714,
        72758,
        72760,
        72768,
        72784,
        72793,
        72818,
        72847,
        72850,
        72871,
        72873,
        72886,
        72960,
        72966,
        72968,
        72969,
        72971,
        73014,
        73018,
        73018,
        73020,
        73021,
        73023,
        73031,
        73040,
        73049,
        73056,
        73061,
        73063,
        73064,
        73066,
        73102,
        73104,
        73105,
        73107,
        73112,
        73120,
        73129,
        73440,
        73462,
        73472,
        73488,
        73490,
        73530,
        73534,
        73538,
        73552,
        73561,
        73648,
        73648,
        73728,
        74649,
        74752,
        74862,
        74880,
        75075,
        77712,
        77808,
        77824,
        78895,
        78912,
        78933,
        82944,
        83526,
        92160,
        92728,
        92736,
        92766,
        92768,
        92777,
        92784,
        92862,
        92864,
        92873,
        92880,
        92909,
        92912,
        92916,
        92928,
        92982,
        92992,
        92995,
        93008,
        93017,
        93027,
        93047,
        93053,
        93071,
        93760,
        93823,
        93952,
        94026,
        94031,
        94087,
        94095,
        94111,
        94176,
        94177,
        94179,
        94180,
        94192,
        94193,
        94208,
        100343,
        100352,
        101589,
        101632,
        101640,
        110576,
        110579,
        110581,
        110587,
        110589,
        110590,
        110592,
        110882,
        110898,
        110898,
        110928,
        110930,
        110933,
        110933,
        110948,
        110951,
        110960,
        111355,
        113664,
        113770,
        113776,
        113788,
        113792,
        113800,
        113808,
        113817,
        113821,
        113822,
        118528,
        118573,
        118576,
        118598,
        119141,
        119145,
        119149,
        119154,
        119163,
        119170,
        119173,
        119179,
        119210,
        119213,
        119362,
        119364,
        119808,
        119892,
        119894,
        119964,
        119966,
        119967,
        119970,
        119970,
        119973,
        119974,
        119977,
        119980,
        119982,
        119993,
        119995,
        119995,
        119997,
        120003,
        120005,
        120069,
        120071,
        120074,
        120077,
        120084,
        120086,
        120092,
        120094,
        120121,
        120123,
        120126,
        120128,
        120132,
        120134,
        120134,
        120138,
        120144,
        120146,
        120485,
        120488,
        120512,
        120514,
        120538,
        120540,
        120570,
        120572,
        120596,
        120598,
        120628,
        120630,
        120654,
        120656,
        120686,
        120688,
        120712,
        120714,
        120744,
        120746,
        120770,
        120772,
        120779,
        120782,
        120831,
        121344,
        121398,
        121403,
        121452,
        121461,
        121461,
        121476,
        121476,
        121499,
        121503,
        121505,
        121519,
        122624,
        122654,
        122661,
        122666,
        122880,
        122886,
        122888,
        122904,
        122907,
        122913,
        122915,
        122916,
        122918,
        122922,
        122928,
        122989,
        123023,
        123023,
        123136,
        123180,
        123184,
        123197,
        123200,
        123209,
        123214,
        123214,
        123536,
        123566,
        123584,
        123641,
        124112,
        124153,
        124896,
        124902,
        124904,
        124907,
        124909,
        124910,
        124912,
        124926,
        124928,
        125124,
        125136,
        125142,
        125184,
        125259,
        125264,
        125273,
        126464,
        126467,
        126469,
        126495,
        126497,
        126498,
        126500,
        126500,
        126503,
        126503,
        126505,
        126514,
        126516,
        126519,
        126521,
        126521,
        126523,
        126523,
        126530,
        126530,
        126535,
        126535,
        126537,
        126537,
        126539,
        126539,
        126541,
        126543,
        126545,
        126546,
        126548,
        126548,
        126551,
        126551,
        126553,
        126553,
        126555,
        126555,
        126557,
        126557,
        126559,
        126559,
        126561,
        126562,
        126564,
        126564,
        126567,
        126570,
        126572,
        126578,
        126580,
        126583,
        126585,
        126588,
        126590,
        126590,
        126592,
        126601,
        126603,
        126619,
        126625,
        126627,
        126629,
        126633,
        126635,
        126651,
        130032,
        130041,
        131072,
        173791,
        173824,
        177977,
        177984,
        178205,
        178208,
        183969,
        183984,
        191456,
        191472,
        192093,
        194560,
        195101,
        196608,
        201546,
        201552,
        205743,
        917760,
        917999
    ];
    var commentDirectiveRegExSingleLine = /^\/\/\/?\s*@(ts-expect-error|ts-ignore)/;
    var commentDirectiveRegExMultiLine = /^(?:\/|\*)*\s*@(ts-expect-error|ts-ignore)/;
    var jsDocSeeOrLink = /@(?:see|link)/i;
    function lookupInUnicodeMap(code, map2) {
        if (code < map2[0]) return false;
        let lo = 0;
        let hi = map2.length;
        let mid;
        while(lo + 1 < hi){
            mid = lo + (hi - lo) / 2;
            mid -= mid % 2;
            if (map2[mid] <= code && code <= map2[mid + 1]) return true;
            if (code < map2[mid]) hi = mid;
            else lo = mid + 2;
        }
        return false;
    }
    function isUnicodeIdentifierStart(code, languageVersion) {
        return languageVersion >= 2 /* ES2015 */  ? lookupInUnicodeMap(code, unicodeESNextIdentifierStart) : lookupInUnicodeMap(code, unicodeES5IdentifierStart);
    }
    function isUnicodeIdentifierPart(code, languageVersion) {
        return languageVersion >= 2 /* ES2015 */  ? lookupInUnicodeMap(code, unicodeESNextIdentifierPart) : lookupInUnicodeMap(code, unicodeES5IdentifierPart);
    }
    function makeReverseMap(source) {
        const result = [];
        source.forEach((value1, name)=>{
            result[value1] = name;
        });
        return result;
    }
    var tokenStrings = makeReverseMap(textToToken);
    function tokenToString(t) {
        return tokenStrings[t];
    }
    function stringToToken(s) {
        return textToToken.get(s);
    }
    var regExpFlagCharCodes = makeReverseMap(charCodeToRegExpFlag);
    function regularExpressionFlagToCharacterCode(f) {
        return regExpFlagCharCodes[f];
    }
    function characterCodeToRegularExpressionFlag(ch) {
        return charCodeToRegExpFlag.get(ch);
    }
    function computeLineStarts(text) {
        const result = [];
        let pos = 0;
        let lineStart = 0;
        while(pos < text.length){
            const ch = text.charCodeAt(pos);
            pos++;
            switch(ch){
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos) === 10 /* lineFeed */ ) pos++;
                // falls through
                case 10 /* lineFeed */ :
                    result.push(lineStart);
                    lineStart = pos;
                    break;
                default:
                    if (ch > 127 /* maxAsciiCharacter */  && isLineBreak(ch)) {
                        result.push(lineStart);
                        lineStart = pos;
                    }
                    break;
            }
        }
        result.push(lineStart);
        return result;
    }
    function getPositionOfLineAndCharacter(sourceFile, line, character, allowEdits) {
        return sourceFile.getPositionOfLineAndCharacter ? sourceFile.getPositionOfLineAndCharacter(line, character, allowEdits) : computePositionOfLineAndCharacter(getLineStarts(sourceFile), line, character, sourceFile.text, allowEdits);
    }
    function computePositionOfLineAndCharacter(lineStarts, line, character, debugText, allowEdits) {
        if (line < 0 || line >= lineStarts.length) {
            if (allowEdits) line = line < 0 ? 0 : line >= lineStarts.length ? lineStarts.length - 1 : line;
            else Debug.fail(`Bad line number. Line: ${line}, lineStarts.length: ${lineStarts.length} , line map is correct? ${debugText !== void 0 ? arrayIsEqualTo(lineStarts, computeLineStarts(debugText)) : "unknown"}`);
        }
        const res = lineStarts[line] + character;
        if (allowEdits) return res > lineStarts[line + 1] ? lineStarts[line + 1] : typeof debugText === "string" && res > debugText.length ? debugText.length : res;
        if (line < lineStarts.length - 1) Debug.assert(res < lineStarts[line + 1]);
        else if (debugText !== void 0) Debug.assert(res <= debugText.length);
        return res;
    }
    function getLineStarts(sourceFile) {
        return sourceFile.lineMap || (sourceFile.lineMap = computeLineStarts(sourceFile.text));
    }
    function computeLineAndCharacterOfPosition(lineStarts, position) {
        const lineNumber = computeLineOfPosition(lineStarts, position);
        return {
            line: lineNumber,
            character: position - lineStarts[lineNumber]
        };
    }
    function computeLineOfPosition(lineStarts, position, lowerBound) {
        let lineNumber = binarySearch(lineStarts, position, identity, compareValues, lowerBound);
        if (lineNumber < 0) {
            lineNumber = ~lineNumber - 1;
            Debug.assert(lineNumber !== -1, "position cannot precede the beginning of the file");
        }
        return lineNumber;
    }
    function getLinesBetweenPositions(sourceFile, pos1, pos2) {
        if (pos1 === pos2) return 0;
        const lineStarts = getLineStarts(sourceFile);
        const lower = Math.min(pos1, pos2);
        const isNegative = lower === pos2;
        const upper = isNegative ? pos1 : pos2;
        const lowerLine = computeLineOfPosition(lineStarts, lower);
        const upperLine = computeLineOfPosition(lineStarts, upper, lowerLine);
        return isNegative ? lowerLine - upperLine : upperLine - lowerLine;
    }
    function getLineAndCharacterOfPosition(sourceFile, position) {
        return computeLineAndCharacterOfPosition(getLineStarts(sourceFile), position);
    }
    function isWhiteSpaceLike(ch) {
        return isWhiteSpaceSingleLine(ch) || isLineBreak(ch);
    }
    function isWhiteSpaceSingleLine(ch) {
        return ch === 32 /* space */  || ch === 9 /* tab */  || ch === 11 /* verticalTab */  || ch === 12 /* formFeed */  || ch === 160 /* nonBreakingSpace */  || ch === 133 /* nextLine */  || ch === 5760 /* ogham */  || ch >= 8192 /* enQuad */  && ch <= 8203 /* zeroWidthSpace */  || ch === 8239 /* narrowNoBreakSpace */  || ch === 8287 /* mathematicalSpace */  || ch === 12288 /* ideographicSpace */  || ch === 65279 /* byteOrderMark */ ;
    }
    function isLineBreak(ch) {
        return ch === 10 /* lineFeed */  || ch === 13 /* carriageReturn */  || ch === 8232 /* lineSeparator */  || ch === 8233 /* paragraphSeparator */ ;
    }
    function isDigit(ch) {
        return ch >= 48 /* _0 */  && ch <= 57 /* _9 */ ;
    }
    function isHexDigit(ch) {
        return isDigit(ch) || ch >= 65 /* A */  && ch <= 70 /* F */  || ch >= 97 /* a */  && ch <= 102 /* f */ ;
    }
    function isASCIILetter(ch) {
        return ch >= 65 /* A */  && ch <= 90 /* Z */  || ch >= 97 /* a */  && ch <= 122 /* z */ ;
    }
    function isWordCharacter(ch) {
        return isASCIILetter(ch) || isDigit(ch) || ch === 95 /* _ */ ;
    }
    function isOctalDigit(ch) {
        return ch >= 48 /* _0 */  && ch <= 55 /* _7 */ ;
    }
    function couldStartTrivia(text, pos) {
        const ch = text.charCodeAt(pos);
        switch(ch){
            case 13 /* carriageReturn */ :
            case 10 /* lineFeed */ :
            case 9 /* tab */ :
            case 11 /* verticalTab */ :
            case 12 /* formFeed */ :
            case 32 /* space */ :
            case 47 /* slash */ :
            // starts of normal trivia
            // falls through
            case 60 /* lessThan */ :
            case 124 /* bar */ :
            case 61 /* equals */ :
            case 62 /* greaterThan */ :
                return true;
            case 35 /* hash */ :
                return pos === 0;
            default:
                return ch > 127 /* maxAsciiCharacter */ ;
        }
    }
    function skipTrivia(text, pos, stopAfterLineBreak, stopAtComments, inJSDoc) {
        if (positionIsSynthesized(pos)) return pos;
        let canConsumeStar = false;
        while(true){
            const ch = text.charCodeAt(pos);
            switch(ch){
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */ ) pos++;
                // falls through
                case 10 /* lineFeed */ :
                    pos++;
                    if (stopAfterLineBreak) return pos;
                    canConsumeStar = !!inJSDoc;
                    continue;
                case 9 /* tab */ :
                case 11 /* verticalTab */ :
                case 12 /* formFeed */ :
                case 32 /* space */ :
                    pos++;
                    continue;
                case 47 /* slash */ :
                    if (stopAtComments) break;
                    if (text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                        pos += 2;
                        while(pos < text.length){
                            if (isLineBreak(text.charCodeAt(pos))) break;
                            pos++;
                        }
                        canConsumeStar = false;
                        continue;
                    }
                    if (text.charCodeAt(pos + 1) === 42 /* asterisk */ ) {
                        pos += 2;
                        while(pos < text.length){
                            if (text.charCodeAt(pos) === 42 /* asterisk */  && text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                                pos += 2;
                                break;
                            }
                            pos++;
                        }
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                case 60 /* lessThan */ :
                case 124 /* bar */ :
                case 61 /* equals */ :
                case 62 /* greaterThan */ :
                    if (isConflictMarkerTrivia(text, pos)) {
                        pos = scanConflictMarkerTrivia(text, pos);
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                case 35 /* hash */ :
                    if (pos === 0 && isShebangTrivia(text, pos)) {
                        pos = scanShebangTrivia(text, pos);
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                case 42 /* asterisk */ :
                    if (canConsumeStar) {
                        pos++;
                        canConsumeStar = false;
                        continue;
                    }
                    break;
                default:
                    if (ch > 127 /* maxAsciiCharacter */  && isWhiteSpaceLike(ch)) {
                        pos++;
                        continue;
                    }
                    break;
            }
            return pos;
        }
    }
    var mergeConflictMarkerLength = 7;
    function isConflictMarkerTrivia(text, pos) {
        Debug.assert(pos >= 0);
        if (pos === 0 || isLineBreak(text.charCodeAt(pos - 1))) {
            const ch = text.charCodeAt(pos);
            if (pos + mergeConflictMarkerLength < text.length) {
                for(let i = 0; i < mergeConflictMarkerLength; i++){
                    if (text.charCodeAt(pos + i) !== ch) return false;
                }
                return ch === 61 /* equals */  || text.charCodeAt(pos + mergeConflictMarkerLength) === 32 /* space */ ;
            }
        }
        return false;
    }
    function scanConflictMarkerTrivia(text, pos, error2) {
        if (error2) error2(Diagnostics.Merge_conflict_marker_encountered, pos, mergeConflictMarkerLength);
        const ch = text.charCodeAt(pos);
        const len = text.length;
        if (ch === 60 /* lessThan */  || ch === 62 /* greaterThan */ ) while(pos < len && !isLineBreak(text.charCodeAt(pos)))pos++;
        else {
            Debug.assert(ch === 124 /* bar */  || ch === 61 /* equals */ );
            while(pos < len){
                const currentChar = text.charCodeAt(pos);
                if ((currentChar === 61 /* equals */  || currentChar === 62 /* greaterThan */ ) && currentChar !== ch && isConflictMarkerTrivia(text, pos)) break;
                pos++;
            }
        }
        return pos;
    }
    var shebangTriviaRegex = /^#!.*/;
    function isShebangTrivia(text, pos) {
        Debug.assert(pos === 0);
        return shebangTriviaRegex.test(text);
    }
    function scanShebangTrivia(text, pos) {
        const shebang = shebangTriviaRegex.exec(text)[0];
        pos = pos + shebang.length;
        return pos;
    }
    function iterateCommentRanges(reduce, text, pos, trailing, cb, state, initial) {
        let pendingPos;
        let pendingEnd;
        let pendingKind;
        let pendingHasTrailingNewLine;
        let hasPendingCommentRange = false;
        let collecting = trailing;
        let accumulator = initial;
        if (pos === 0) {
            collecting = true;
            const shebang = getShebang(text);
            if (shebang) pos = shebang.length;
        }
        scan: while(pos >= 0 && pos < text.length){
            const ch = text.charCodeAt(pos);
            switch(ch){
                case 13 /* carriageReturn */ :
                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */ ) pos++;
                // falls through
                case 10 /* lineFeed */ :
                    pos++;
                    if (trailing) break scan;
                    collecting = true;
                    if (hasPendingCommentRange) pendingHasTrailingNewLine = true;
                    continue;
                case 9 /* tab */ :
                case 11 /* verticalTab */ :
                case 12 /* formFeed */ :
                case 32 /* space */ :
                    pos++;
                    continue;
                case 47 /* slash */ :
                    const nextChar = text.charCodeAt(pos + 1);
                    let hasTrailingNewLine = false;
                    if (nextChar === 47 /* slash */  || nextChar === 42 /* asterisk */ ) {
                        const kind = nextChar === 47 /* slash */  ? 2 /* SingleLineCommentTrivia */  : 3 /* MultiLineCommentTrivia */ ;
                        const startPos = pos;
                        pos += 2;
                        if (nextChar === 47 /* slash */ ) while(pos < text.length){
                            if (isLineBreak(text.charCodeAt(pos))) {
                                hasTrailingNewLine = true;
                                break;
                            }
                            pos++;
                        }
                        else while(pos < text.length){
                            if (text.charCodeAt(pos) === 42 /* asterisk */  && text.charCodeAt(pos + 1) === 47 /* slash */ ) {
                                pos += 2;
                                break;
                            }
                            pos++;
                        }
                        if (collecting) {
                            if (hasPendingCommentRange) {
                                accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
                                if (!reduce && accumulator) return accumulator;
                            }
                            pendingPos = startPos;
                            pendingEnd = pos;
                            pendingKind = kind;
                            pendingHasTrailingNewLine = hasTrailingNewLine;
                            hasPendingCommentRange = true;
                        }
                        continue;
                    }
                    break scan;
                default:
                    if (ch > 127 /* maxAsciiCharacter */  && isWhiteSpaceLike(ch)) {
                        if (hasPendingCommentRange && isLineBreak(ch)) pendingHasTrailingNewLine = true;
                        pos++;
                        continue;
                    }
                    break scan;
            }
        }
        if (hasPendingCommentRange) accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
        return accumulator;
    }
    function forEachLeadingCommentRange(text, pos, cb, state) {
        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ false, cb, state);
    }
    function forEachTrailingCommentRange(text, pos, cb, state) {
        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ true, cb, state);
    }
    function reduceEachLeadingCommentRange(text, pos, cb, state, initial) {
        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ false, cb, state, initial);
    }
    function reduceEachTrailingCommentRange(text, pos, cb, state, initial) {
        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ true, cb, state, initial);
    }
    function appendCommentRange(pos, end, kind, hasTrailingNewLine, _state, comments = []) {
        comments.push({
            kind,
            pos,
            end,
            hasTrailingNewLine
        });
        return comments;
    }
    function getLeadingCommentRanges(text, pos) {
        return reduceEachLeadingCommentRange(text, pos, appendCommentRange, /*state*/ void 0, /*initial*/ void 0);
    }
    function getTrailingCommentRanges(text, pos) {
        return reduceEachTrailingCommentRange(text, pos, appendCommentRange, /*state*/ void 0, /*initial*/ void 0);
    }
    function getShebang(text) {
        const match = shebangTriviaRegex.exec(text);
        if (match) return match[0];
    }
    function isIdentifierStart(ch, languageVersion) {
        return isASCIILetter(ch) || ch === 36 /* $ */  || ch === 95 /* _ */  || ch > 127 /* maxAsciiCharacter */  && isUnicodeIdentifierStart(ch, languageVersion);
    }
    function isIdentifierPart(ch, languageVersion, identifierVariant) {
        return isWordCharacter(ch) || ch === 36 /* $ */  || // "-" and ":" are valid in JSX Identifiers
        (identifierVariant === 1 /* JSX */  ? ch === 45 /* minus */  || ch === 58 /* colon */  : false) || ch > 127 /* maxAsciiCharacter */  && isUnicodeIdentifierPart(ch, languageVersion);
    }
    function isIdentifierText(name, languageVersion, identifierVariant) {
        let ch = codePointAt(name, 0);
        if (!isIdentifierStart(ch, languageVersion)) return false;
        for(let i = charSize(ch); i < name.length; i += charSize(ch)){
            if (!isIdentifierPart(ch = codePointAt(name, i), languageVersion, identifierVariant)) return false;
        }
        return true;
    }
    function createScanner(languageVersion, skipTrivia2, languageVariant = 0 /* Standard */ , textInitial, onError, start, length2) {
        var text = textInitial;
        var pos;
        var end;
        var fullStartPos;
        var tokenStart;
        var token;
        var tokenValue;
        var tokenFlags;
        var commentDirectives;
        var skipJsDocLeadingAsterisks = 0;
        var scriptKind = 0 /* Unknown */ ;
        var jsDocParsingMode = 0 /* ParseAll */ ;
        setText(text, start, length2);
        var scanner2 = {
            getTokenFullStart: ()=>fullStartPos,
            getStartPos: ()=>fullStartPos,
            getTokenEnd: ()=>pos,
            getTextPos: ()=>pos,
            getToken: ()=>token,
            getTokenStart: ()=>tokenStart,
            getTokenPos: ()=>tokenStart,
            getTokenText: ()=>text.substring(tokenStart, pos),
            getTokenValue: ()=>tokenValue,
            hasUnicodeEscape: ()=>(tokenFlags & 1024 /* UnicodeEscape */ ) !== 0,
            hasExtendedUnicodeEscape: ()=>(tokenFlags & 8 /* ExtendedUnicodeEscape */ ) !== 0,
            hasPrecedingLineBreak: ()=>(tokenFlags & 1 /* PrecedingLineBreak */ ) !== 0,
            hasPrecedingJSDocComment: ()=>(tokenFlags & 2 /* PrecedingJSDocComment */ ) !== 0,
            hasPrecedingJSDocLeadingAsterisks: ()=>(tokenFlags & 32768 /* PrecedingJSDocLeadingAsterisks */ ) !== 0,
            isIdentifier: ()=>token === 80 /* Identifier */  || token > 118 /* LastReservedWord */ ,
            isReservedWord: ()=>token >= 83 /* FirstReservedWord */  && token <= 118 /* LastReservedWord */ ,
            isUnterminated: ()=>(tokenFlags & 4 /* Unterminated */ ) !== 0,
            getCommentDirectives: ()=>commentDirectives,
            getNumericLiteralFlags: ()=>tokenFlags & 25584 /* NumericLiteralFlags */ ,
            getTokenFlags: ()=>tokenFlags,
            reScanGreaterToken,
            reScanAsteriskEqualsToken,
            reScanSlashToken,
            reScanTemplateToken,
            reScanTemplateHeadOrNoSubstitutionTemplate,
            scanJsxIdentifier,
            scanJsxAttributeValue,
            reScanJsxAttributeValue,
            reScanJsxToken,
            reScanLessThanToken,
            reScanHashToken,
            reScanQuestionToken,
            reScanInvalidIdentifier,
            scanJsxToken,
            scanJsDocToken,
            scanJSDocCommentTextToken,
            scan,
            getText,
            clearCommentDirectives,
            setText,
            setScriptTarget,
            setLanguageVariant,
            setScriptKind,
            setJSDocParsingMode,
            setOnError,
            resetTokenState,
            setTextPos: resetTokenState,
            setSkipJsDocLeadingAsterisks,
            tryScan,
            lookAhead,
            scanRange
        };
        if (Debug.isDebugging) Object.defineProperty(scanner2, "__debugShowCurrentPositionInText", {
            get: ()=>{
                const text2 = scanner2.getText();
                return text2.slice(0, scanner2.getTokenFullStart()) + "\u2551" + text2.slice(scanner2.getTokenFullStart());
            }
        });
        return scanner2;
        function codePointUnchecked(pos2) {
            return codePointAt(text, pos2);
        }
        function codePointChecked(pos2) {
            return pos2 >= 0 && pos2 < end ? codePointUnchecked(pos2) : -1 /* EOF */ ;
        }
        function charCodeUnchecked(pos2) {
            return text.charCodeAt(pos2);
        }
        function charCodeChecked(pos2) {
            return pos2 >= 0 && pos2 < end ? charCodeUnchecked(pos2) : -1 /* EOF */ ;
        }
        function error2(message, errPos = pos, length3, arg0) {
            if (onError) {
                const oldPos = pos;
                pos = errPos;
                onError(message, length3 || 0, arg0);
                pos = oldPos;
            }
        }
        function scanNumberFragment() {
            let start2 = pos;
            let allowSeparator = false;
            let isPreviousTokenSeparator = false;
            let result = "";
            while(true){
                const ch = charCodeUnchecked(pos);
                if (ch === 95 /* _ */ ) {
                    tokenFlags |= 512 /* ContainsSeparator */ ;
                    if (allowSeparator) {
                        allowSeparator = false;
                        isPreviousTokenSeparator = true;
                        result += text.substring(start2, pos);
                    } else {
                        tokenFlags |= 16384 /* ContainsInvalidSeparator */ ;
                        if (isPreviousTokenSeparator) error2(Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
                        else error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    }
                    pos++;
                    start2 = pos;
                    continue;
                }
                if (isDigit(ch)) {
                    allowSeparator = true;
                    isPreviousTokenSeparator = false;
                    pos++;
                    continue;
                }
                break;
            }
            if (charCodeUnchecked(pos - 1) === 95 /* _ */ ) {
                tokenFlags |= 16384 /* ContainsInvalidSeparator */ ;
                error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
            }
            return result + text.substring(start2, pos);
        }
        function scanNumber() {
            let start2 = pos;
            let mainFragment;
            if (charCodeUnchecked(pos) === 48 /* _0 */ ) {
                pos++;
                if (charCodeUnchecked(pos) === 95 /* _ */ ) {
                    tokenFlags |= 16896 /* ContainsInvalidSeparator */ ;
                    error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    pos--;
                    mainFragment = scanNumberFragment();
                } else if (!scanDigits()) {
                    tokenFlags |= 8192 /* ContainsLeadingZero */ ;
                    mainFragment = "" + +tokenValue;
                } else if (!tokenValue) mainFragment = "0";
                else {
                    tokenValue = "" + parseInt(tokenValue, 8);
                    tokenFlags |= 32 /* Octal */ ;
                    const withMinus = token === 41 /* MinusToken */ ;
                    const literal = (withMinus ? "-" : "") + "0o" + (+tokenValue).toString(8);
                    if (withMinus) start2--;
                    error2(Diagnostics.Octal_literals_are_not_allowed_Use_the_syntax_0, start2, pos - start2, literal);
                    return 9 /* NumericLiteral */ ;
                }
            } else mainFragment = scanNumberFragment();
            let decimalFragment;
            let scientificFragment;
            if (charCodeUnchecked(pos) === 46 /* dot */ ) {
                pos++;
                decimalFragment = scanNumberFragment();
            }
            let end2 = pos;
            if (charCodeUnchecked(pos) === 69 /* E */  || charCodeUnchecked(pos) === 101 /* e */ ) {
                pos++;
                tokenFlags |= 16 /* Scientific */ ;
                if (charCodeUnchecked(pos) === 43 /* plus */  || charCodeUnchecked(pos) === 45 /* minus */ ) pos++;
                const preNumericPart = pos;
                const finalFragment = scanNumberFragment();
                if (!finalFragment) error2(Diagnostics.Digit_expected);
                else {
                    scientificFragment = text.substring(end2, preNumericPart) + finalFragment;
                    end2 = pos;
                }
            }
            let result;
            if (tokenFlags & 512 /* ContainsSeparator */ ) {
                result = mainFragment;
                if (decimalFragment) result += "." + decimalFragment;
                if (scientificFragment) result += scientificFragment;
            } else result = text.substring(start2, end2);
            if (tokenFlags & 8192 /* ContainsLeadingZero */ ) {
                error2(Diagnostics.Decimals_with_leading_zeros_are_not_allowed, start2, end2 - start2);
                tokenValue = "" + +result;
                return 9 /* NumericLiteral */ ;
            }
            if (decimalFragment !== void 0 || tokenFlags & 16 /* Scientific */ ) {
                checkForIdentifierStartAfterNumericLiteral(start2, decimalFragment === void 0 && !!(tokenFlags & 16 /* Scientific */ ));
                tokenValue = "" + +result;
                return 9 /* NumericLiteral */ ;
            } else {
                tokenValue = result;
                const type = checkBigIntSuffix();
                checkForIdentifierStartAfterNumericLiteral(start2);
                return type;
            }
        }
        function checkForIdentifierStartAfterNumericLiteral(numericStart, isScientific) {
            if (!isIdentifierStart(codePointUnchecked(pos), languageVersion)) return;
            const identifierStart = pos;
            const { length: length3 } = scanIdentifierParts();
            if (length3 === 1 && text[identifierStart] === "n") {
                if (isScientific) error2(Diagnostics.A_bigint_literal_cannot_use_exponential_notation, numericStart, identifierStart - numericStart + 1);
                else error2(Diagnostics.A_bigint_literal_must_be_an_integer, numericStart, identifierStart - numericStart + 1);
            } else {
                error2(Diagnostics.An_identifier_or_keyword_cannot_immediately_follow_a_numeric_literal, identifierStart, length3);
                pos = identifierStart;
            }
        }
        function scanDigits() {
            const start2 = pos;
            let isOctal = true;
            while(isDigit(charCodeChecked(pos))){
                if (!isOctalDigit(charCodeUnchecked(pos))) isOctal = false;
                pos++;
            }
            tokenValue = text.substring(start2, pos);
            return isOctal;
        }
        function scanExactNumberOfHexDigits(count, canHaveSeparators) {
            const valueString = scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ false, canHaveSeparators);
            return valueString ? parseInt(valueString, 16) : -1;
        }
        function scanMinimumNumberOfHexDigits(count, canHaveSeparators) {
            return scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ true, canHaveSeparators);
        }
        function scanHexDigits(minCount, scanAsManyAsPossible, canHaveSeparators) {
            let valueChars = [];
            let allowSeparator = false;
            let isPreviousTokenSeparator = false;
            while(valueChars.length < minCount || scanAsManyAsPossible){
                let ch = charCodeUnchecked(pos);
                if (canHaveSeparators && ch === 95 /* _ */ ) {
                    tokenFlags |= 512 /* ContainsSeparator */ ;
                    if (allowSeparator) {
                        allowSeparator = false;
                        isPreviousTokenSeparator = true;
                    } else if (isPreviousTokenSeparator) error2(Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
                    else error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    pos++;
                    continue;
                }
                allowSeparator = canHaveSeparators;
                if (ch >= 65 /* A */  && ch <= 70 /* F */ ) ch += 32 /* A */ ;
                else if (!(ch >= 48 /* _0 */  && ch <= 57 /* _9 */  || ch >= 97 /* a */  && ch <= 102 /* f */ )) break;
                valueChars.push(ch);
                pos++;
                isPreviousTokenSeparator = false;
            }
            if (valueChars.length < minCount) valueChars = [];
            if (charCodeUnchecked(pos - 1) === 95 /* _ */ ) error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
            return String.fromCharCode(...valueChars);
        }
        function scanString(jsxAttributeString = false) {
            const quote2 = charCodeUnchecked(pos);
            pos++;
            let result = "";
            let start2 = pos;
            while(true){
                if (pos >= end) {
                    result += text.substring(start2, pos);
                    tokenFlags |= 4 /* Unterminated */ ;
                    error2(Diagnostics.Unterminated_string_literal);
                    break;
                }
                const ch = charCodeUnchecked(pos);
                if (ch === quote2) {
                    result += text.substring(start2, pos);
                    pos++;
                    break;
                }
                if (ch === 92 /* backslash */  && !jsxAttributeString) {
                    result += text.substring(start2, pos);
                    result += scanEscapeSequence(3 /* ReportErrors */ );
                    start2 = pos;
                    continue;
                }
                if ((ch === 10 /* lineFeed */  || ch === 13 /* carriageReturn */ ) && !jsxAttributeString) {
                    result += text.substring(start2, pos);
                    tokenFlags |= 4 /* Unterminated */ ;
                    error2(Diagnostics.Unterminated_string_literal);
                    break;
                }
                pos++;
            }
            return result;
        }
        function scanTemplateAndSetTokenValue(shouldEmitInvalidEscapeError) {
            const startedWithBacktick = charCodeUnchecked(pos) === 96 /* backtick */ ;
            pos++;
            let start2 = pos;
            let contents = "";
            let resultingToken;
            while(true){
                if (pos >= end) {
                    contents += text.substring(start2, pos);
                    tokenFlags |= 4 /* Unterminated */ ;
                    error2(Diagnostics.Unterminated_template_literal);
                    resultingToken = startedWithBacktick ? 15 /* NoSubstitutionTemplateLiteral */  : 18 /* TemplateTail */ ;
                    break;
                }
                const currChar = charCodeUnchecked(pos);
                if (currChar === 96 /* backtick */ ) {
                    contents += text.substring(start2, pos);
                    pos++;
                    resultingToken = startedWithBacktick ? 15 /* NoSubstitutionTemplateLiteral */  : 18 /* TemplateTail */ ;
                    break;
                }
                if (currChar === 36 /* $ */  && pos + 1 < end && charCodeUnchecked(pos + 1) === 123 /* openBrace */ ) {
                    contents += text.substring(start2, pos);
                    pos += 2;
                    resultingToken = startedWithBacktick ? 16 /* TemplateHead */  : 17 /* TemplateMiddle */ ;
                    break;
                }
                if (currChar === 92 /* backslash */ ) {
                    contents += text.substring(start2, pos);
                    contents += scanEscapeSequence(1 /* String */  | (shouldEmitInvalidEscapeError ? 2 /* ReportErrors */  : 0));
                    start2 = pos;
                    continue;
                }
                if (currChar === 13 /* carriageReturn */ ) {
                    contents += text.substring(start2, pos);
                    pos++;
                    if (pos < end && charCodeUnchecked(pos) === 10 /* lineFeed */ ) pos++;
                    contents += "\n";
                    start2 = pos;
                    continue;
                }
                pos++;
            }
            Debug.assert(resultingToken !== void 0);
            tokenValue = contents;
            return resultingToken;
        }
        function scanEscapeSequence(flags) {
            const start2 = pos;
            pos++;
            if (pos >= end) {
                error2(Diagnostics.Unexpected_end_of_text);
                return "";
            }
            const ch = charCodeUnchecked(pos);
            pos++;
            switch(ch){
                case 48 /* _0 */ :
                    if (pos >= end || !isDigit(charCodeUnchecked(pos))) return "\0";
                // '\01', '\011'
                // falls through
                case 49 /* _1 */ :
                case 50 /* _2 */ :
                case 51 /* _3 */ :
                    if (pos < end && isOctalDigit(charCodeUnchecked(pos))) pos++;
                // '\17', '\177'
                // falls through
                case 52 /* _4 */ :
                case 53 /* _5 */ :
                case 54 /* _6 */ :
                case 55 /* _7 */ :
                    if (pos < end && isOctalDigit(charCodeUnchecked(pos))) pos++;
                    tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                    if (flags & 6 /* ReportInvalidEscapeErrors */ ) {
                        const code = parseInt(text.substring(start2 + 1, pos), 8);
                        if (flags & 4 /* RegularExpression */  && !(flags & 32 /* AtomEscape */ ) && ch !== 48 /* _0 */ ) error2(Diagnostics.Octal_escape_sequences_and_backreferences_are_not_allowed_in_a_character_class_If_this_was_intended_as_an_escape_sequence_use_the_syntax_0_instead, start2, pos - start2, "\\x" + code.toString(16).padStart(2, "0"));
                        else error2(Diagnostics.Octal_escape_sequences_are_not_allowed_Use_the_syntax_0, start2, pos - start2, "\\x" + code.toString(16).padStart(2, "0"));
                        return String.fromCharCode(code);
                    }
                    return text.substring(start2, pos);
                case 56 /* _8 */ :
                case 57 /* _9 */ :
                    tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                    if (flags & 6 /* ReportInvalidEscapeErrors */ ) {
                        if (flags & 4 /* RegularExpression */  && !(flags & 32 /* AtomEscape */ )) error2(Diagnostics.Decimal_escape_sequences_and_backreferences_are_not_allowed_in_a_character_class, start2, pos - start2);
                        else error2(Diagnostics.Escape_sequence_0_is_not_allowed, start2, pos - start2, text.substring(start2, pos));
                        return String.fromCharCode(ch);
                    }
                    return text.substring(start2, pos);
                case 98 /* b */ :
                    return "\b";
                case 116 /* t */ :
                    return "	";
                case 110 /* n */ :
                    return "\n";
                case 118 /* v */ :
                    return "\v";
                case 102 /* f */ :
                    return "\f";
                case 114 /* r */ :
                    return "\r";
                case 39 /* singleQuote */ :
                    return "'";
                case 34 /* doubleQuote */ :
                    return '"';
                case 117 /* u */ :
                    if (pos < end && charCodeUnchecked(pos) === 123 /* openBrace */ ) {
                        pos -= 2;
                        const result = scanExtendedUnicodeEscape(!!(flags & 6 /* ReportInvalidEscapeErrors */ ));
                        if (!(flags & 17 /* AllowExtendedUnicodeEscape */ )) {
                            tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                            if (flags & 6 /* ReportInvalidEscapeErrors */ ) error2(Diagnostics.Unicode_escape_sequences_are_only_available_when_the_Unicode_u_flag_or_the_Unicode_Sets_v_flag_is_set, start2, pos - start2);
                        }
                        return result;
                    }
                    for(; pos < start2 + 6; pos++)if (!(pos < end && isHexDigit(charCodeUnchecked(pos)))) {
                        tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                        if (flags & 6 /* ReportInvalidEscapeErrors */ ) error2(Diagnostics.Hexadecimal_digit_expected);
                        return text.substring(start2, pos);
                    }
                    tokenFlags |= 1024 /* UnicodeEscape */ ;
                    const escapedValue = parseInt(text.substring(start2 + 2, pos), 16);
                    const escapedValueString = String.fromCharCode(escapedValue);
                    if (flags & 16 /* AnyUnicodeMode */  && escapedValue >= 55296 && escapedValue <= 56319 && pos + 6 < end && text.substring(pos, pos + 2) === "\\u" && charCodeUnchecked(pos + 2) !== 123 /* openBrace */ ) {
                        const nextStart = pos;
                        let nextPos = pos + 2;
                        for(; nextPos < nextStart + 6; nextPos++){
                            if (!isHexDigit(charCodeUnchecked(nextPos))) return escapedValueString;
                        }
                        const nextEscapedValue = parseInt(text.substring(nextStart + 2, nextPos), 16);
                        if (nextEscapedValue >= 56320 && nextEscapedValue <= 57343) {
                            pos = nextPos;
                            return escapedValueString + String.fromCharCode(nextEscapedValue);
                        }
                    }
                    return escapedValueString;
                case 120 /* x */ :
                    for(; pos < start2 + 4; pos++)if (!(pos < end && isHexDigit(charCodeUnchecked(pos)))) {
                        tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                        if (flags & 6 /* ReportInvalidEscapeErrors */ ) error2(Diagnostics.Hexadecimal_digit_expected);
                        return text.substring(start2, pos);
                    }
                    tokenFlags |= 4096 /* HexEscape */ ;
                    return String.fromCharCode(parseInt(text.substring(start2 + 2, pos), 16));
                // when encountering a LineContinuation (i.e. a backslash and a line terminator sequence),
                // the line terminator is interpreted to be "the empty code unit sequence".
                case 13 /* carriageReturn */ :
                    if (pos < end && charCodeUnchecked(pos) === 10 /* lineFeed */ ) pos++;
                // falls through
                case 10 /* lineFeed */ :
                case 8232 /* lineSeparator */ :
                case 8233 /* paragraphSeparator */ :
                    return "";
                default:
                    if (flags & 16 /* AnyUnicodeMode */  || flags & 4 /* RegularExpression */  && !(flags & 8 /* AnnexB */ ) && isIdentifierPart(ch, languageVersion)) error2(Diagnostics.This_character_cannot_be_escaped_in_a_regular_expression, pos - 2, 2);
                    return String.fromCharCode(ch);
            }
        }
        function scanExtendedUnicodeEscape(shouldEmitInvalidEscapeError) {
            const start2 = pos;
            pos += 3;
            const escapedStart = pos;
            const escapedValueString = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
            const escapedValue = escapedValueString ? parseInt(escapedValueString, 16) : -1;
            let isInvalidExtendedEscape = false;
            if (escapedValue < 0) {
                if (shouldEmitInvalidEscapeError) error2(Diagnostics.Hexadecimal_digit_expected);
                isInvalidExtendedEscape = true;
            } else if (escapedValue > 1114111) {
                if (shouldEmitInvalidEscapeError) error2(Diagnostics.An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive, escapedStart, pos - escapedStart);
                isInvalidExtendedEscape = true;
            }
            if (pos >= end) {
                if (shouldEmitInvalidEscapeError) error2(Diagnostics.Unexpected_end_of_text);
                isInvalidExtendedEscape = true;
            } else if (charCodeUnchecked(pos) === 125 /* closeBrace */ ) pos++;
            else {
                if (shouldEmitInvalidEscapeError) error2(Diagnostics.Unterminated_Unicode_escape_sequence);
                isInvalidExtendedEscape = true;
            }
            if (isInvalidExtendedEscape) {
                tokenFlags |= 2048 /* ContainsInvalidEscape */ ;
                return text.substring(start2, pos);
            }
            tokenFlags |= 8 /* ExtendedUnicodeEscape */ ;
            return utf16EncodeAsString(escapedValue);
        }
        function peekUnicodeEscape() {
            if (pos + 5 < end && charCodeUnchecked(pos + 1) === 117 /* u */ ) {
                const start2 = pos;
                pos += 2;
                const value1 = scanExactNumberOfHexDigits(4, /*canHaveSeparators*/ false);
                pos = start2;
                return value1;
            }
            return -1;
        }
        function peekExtendedUnicodeEscape() {
            if (codePointUnchecked(pos + 1) === 117 /* u */  && codePointUnchecked(pos + 2) === 123 /* openBrace */ ) {
                const start2 = pos;
                pos += 3;
                const escapedValueString = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
                const escapedValue = escapedValueString ? parseInt(escapedValueString, 16) : -1;
                pos = start2;
                return escapedValue;
            }
            return -1;
        }
        function scanIdentifierParts() {
            let result = "";
            let start2 = pos;
            while(pos < end){
                let ch = codePointUnchecked(pos);
                if (isIdentifierPart(ch, languageVersion)) pos += charSize(ch);
                else if (ch === 92 /* backslash */ ) {
                    ch = peekExtendedUnicodeEscape();
                    if (ch >= 0 && isIdentifierPart(ch, languageVersion)) {
                        result += scanExtendedUnicodeEscape(/*shouldEmitInvalidEscapeError*/ true);
                        start2 = pos;
                        continue;
                    }
                    ch = peekUnicodeEscape();
                    if (!(ch >= 0 && isIdentifierPart(ch, languageVersion))) break;
                    tokenFlags |= 1024 /* UnicodeEscape */ ;
                    result += text.substring(start2, pos);
                    result += utf16EncodeAsString(ch);
                    pos += 6;
                    start2 = pos;
                } else break;
            }
            result += text.substring(start2, pos);
            return result;
        }
        function getIdentifierToken() {
            const len = tokenValue.length;
            if (len >= 2 && len <= 12) {
                const ch = tokenValue.charCodeAt(0);
                if (ch >= 97 /* a */  && ch <= 122 /* z */ ) {
                    const keyword = textToKeyword.get(tokenValue);
                    if (keyword !== void 0) return token = keyword;
                }
            }
            return token = 80 /* Identifier */ ;
        }
        function scanBinaryOrOctalDigits(base) {
            let value1 = "";
            let separatorAllowed = false;
            let isPreviousTokenSeparator = false;
            while(true){
                const ch = charCodeUnchecked(pos);
                if (ch === 95 /* _ */ ) {
                    tokenFlags |= 512 /* ContainsSeparator */ ;
                    if (separatorAllowed) {
                        separatorAllowed = false;
                        isPreviousTokenSeparator = true;
                    } else if (isPreviousTokenSeparator) error2(Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
                    else error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
                    pos++;
                    continue;
                }
                separatorAllowed = true;
                if (!isDigit(ch) || ch - 48 /* _0 */  >= base) break;
                value1 += text[pos];
                pos++;
                isPreviousTokenSeparator = false;
            }
            if (charCodeUnchecked(pos - 1) === 95 /* _ */ ) error2(Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
            return value1;
        }
        function checkBigIntSuffix() {
            if (charCodeUnchecked(pos) === 110 /* n */ ) {
                tokenValue += "n";
                if (tokenFlags & 384 /* BinaryOrOctalSpecifier */ ) tokenValue = parsePseudoBigInt(tokenValue) + "n";
                pos++;
                return 10 /* BigIntLiteral */ ;
            } else {
                const numericValue = tokenFlags & 128 /* BinarySpecifier */  ? parseInt(tokenValue.slice(2), 2) : tokenFlags & 256 /* OctalSpecifier */  ? parseInt(tokenValue.slice(2), 8) : +tokenValue;
                tokenValue = "" + numericValue;
                return 9 /* NumericLiteral */ ;
            }
        }
        function scan() {
            fullStartPos = pos;
            tokenFlags = 0 /* None */ ;
            while(true){
                tokenStart = pos;
                if (pos >= end) return token = 1 /* EndOfFileToken */ ;
                const ch = codePointUnchecked(pos);
                if (pos === 0) {
                    if (ch === 35 /* hash */  && isShebangTrivia(text, pos)) {
                        pos = scanShebangTrivia(text, pos);
                        if (skipTrivia2) continue;
                        else return token = 6 /* ShebangTrivia */ ;
                    }
                }
                switch(ch){
                    case 10 /* lineFeed */ :
                    case 13 /* carriageReturn */ :
                        tokenFlags |= 1 /* PrecedingLineBreak */ ;
                        if (skipTrivia2) {
                            pos++;
                            continue;
                        } else {
                            if (ch === 13 /* carriageReturn */  && pos + 1 < end && charCodeUnchecked(pos + 1) === 10 /* lineFeed */ ) pos += 2;
                            else pos++;
                            return token = 4 /* NewLineTrivia */ ;
                        }
                    case 9 /* tab */ :
                    case 11 /* verticalTab */ :
                    case 12 /* formFeed */ :
                    case 32 /* space */ :
                    case 160 /* nonBreakingSpace */ :
                    case 5760 /* ogham */ :
                    case 8192 /* enQuad */ :
                    case 8193 /* emQuad */ :
                    case 8194 /* enSpace */ :
                    case 8195 /* emSpace */ :
                    case 8196 /* threePerEmSpace */ :
                    case 8197 /* fourPerEmSpace */ :
                    case 8198 /* sixPerEmSpace */ :
                    case 8199 /* figureSpace */ :
                    case 8200 /* punctuationSpace */ :
                    case 8201 /* thinSpace */ :
                    case 8202 /* hairSpace */ :
                    case 8203 /* zeroWidthSpace */ :
                    case 8239 /* narrowNoBreakSpace */ :
                    case 8287 /* mathematicalSpace */ :
                    case 12288 /* ideographicSpace */ :
                    case 65279 /* byteOrderMark */ :
                        if (skipTrivia2) {
                            pos++;
                            continue;
                        } else {
                            while(pos < end && isWhiteSpaceSingleLine(charCodeUnchecked(pos)))pos++;
                            return token = 5 /* WhitespaceTrivia */ ;
                        }
                    case 33 /* exclamation */ :
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 38 /* ExclamationEqualsEqualsToken */ ;
                            return pos += 2, token = 36 /* ExclamationEqualsToken */ ;
                        }
                        pos++;
                        return token = 54 /* ExclamationToken */ ;
                    case 34 /* doubleQuote */ :
                    case 39 /* singleQuote */ :
                        tokenValue = scanString();
                        return token = 11 /* StringLiteral */ ;
                    case 96 /* backtick */ :
                        return token = scanTemplateAndSetTokenValue(/*shouldEmitInvalidEscapeError*/ false);
                    case 37 /* percent */ :
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 70 /* PercentEqualsToken */ ;
                        pos++;
                        return token = 45 /* PercentToken */ ;
                    case 38 /* ampersand */ :
                        if (charCodeUnchecked(pos + 1) === 38 /* ampersand */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 77 /* AmpersandAmpersandEqualsToken */ ;
                            return pos += 2, token = 56 /* AmpersandAmpersandToken */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 74 /* AmpersandEqualsToken */ ;
                        pos++;
                        return token = 51 /* AmpersandToken */ ;
                    case 40 /* openParen */ :
                        pos++;
                        return token = 21 /* OpenParenToken */ ;
                    case 41 /* closeParen */ :
                        pos++;
                        return token = 22 /* CloseParenToken */ ;
                    case 42 /* asterisk */ :
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 67 /* AsteriskEqualsToken */ ;
                        if (charCodeUnchecked(pos + 1) === 42 /* asterisk */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 68 /* AsteriskAsteriskEqualsToken */ ;
                            return pos += 2, token = 43 /* AsteriskAsteriskToken */ ;
                        }
                        pos++;
                        if (skipJsDocLeadingAsterisks && (tokenFlags & 32768 /* PrecedingJSDocLeadingAsterisks */ ) === 0 && tokenFlags & 1 /* PrecedingLineBreak */ ) {
                            tokenFlags |= 32768 /* PrecedingJSDocLeadingAsterisks */ ;
                            continue;
                        }
                        return token = 42 /* AsteriskToken */ ;
                    case 43 /* plus */ :
                        if (charCodeUnchecked(pos + 1) === 43 /* plus */ ) return pos += 2, token = 46 /* PlusPlusToken */ ;
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 65 /* PlusEqualsToken */ ;
                        pos++;
                        return token = 40 /* PlusToken */ ;
                    case 44 /* comma */ :
                        pos++;
                        return token = 28 /* CommaToken */ ;
                    case 45 /* minus */ :
                        if (charCodeUnchecked(pos + 1) === 45 /* minus */ ) return pos += 2, token = 47 /* MinusMinusToken */ ;
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 66 /* MinusEqualsToken */ ;
                        pos++;
                        return token = 41 /* MinusToken */ ;
                    case 46 /* dot */ :
                        if (isDigit(charCodeUnchecked(pos + 1))) {
                            scanNumber();
                            return token = 9 /* NumericLiteral */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 46 /* dot */  && charCodeUnchecked(pos + 2) === 46 /* dot */ ) return pos += 3, token = 26 /* DotDotDotToken */ ;
                        pos++;
                        return token = 25 /* DotToken */ ;
                    case 47 /* slash */ :
                        if (charCodeUnchecked(pos + 1) === 47 /* slash */ ) {
                            pos += 2;
                            while(pos < end){
                                if (isLineBreak(charCodeUnchecked(pos))) break;
                                pos++;
                            }
                            commentDirectives = appendIfCommentDirective(commentDirectives, text.slice(tokenStart, pos), commentDirectiveRegExSingleLine, tokenStart);
                            if (skipTrivia2) continue;
                            else return token = 2 /* SingleLineCommentTrivia */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 42 /* asterisk */ ) {
                            pos += 2;
                            const isJSDoc2 = charCodeUnchecked(pos) === 42 /* asterisk */  && charCodeUnchecked(pos + 1) !== 47 /* slash */ ;
                            let commentClosed = false;
                            let lastLineStart = tokenStart;
                            while(pos < end){
                                const ch2 = charCodeUnchecked(pos);
                                if (ch2 === 42 /* asterisk */  && charCodeUnchecked(pos + 1) === 47 /* slash */ ) {
                                    pos += 2;
                                    commentClosed = true;
                                    break;
                                }
                                pos++;
                                if (isLineBreak(ch2)) {
                                    lastLineStart = pos;
                                    tokenFlags |= 1 /* PrecedingLineBreak */ ;
                                }
                            }
                            if (isJSDoc2 && shouldParseJSDoc()) tokenFlags |= 2 /* PrecedingJSDocComment */ ;
                            commentDirectives = appendIfCommentDirective(commentDirectives, text.slice(lastLineStart, pos), commentDirectiveRegExMultiLine, lastLineStart);
                            if (!commentClosed) error2(Diagnostics.Asterisk_Slash_expected);
                            if (skipTrivia2) continue;
                            else {
                                if (!commentClosed) tokenFlags |= 4 /* Unterminated */ ;
                                return token = 3 /* MultiLineCommentTrivia */ ;
                            }
                        }
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 69 /* SlashEqualsToken */ ;
                        pos++;
                        return token = 44 /* SlashToken */ ;
                    case 48 /* _0 */ :
                        if (pos + 2 < end && (charCodeUnchecked(pos + 1) === 88 /* X */  || charCodeUnchecked(pos + 1) === 120 /* x */ )) {
                            pos += 2;
                            tokenValue = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ true);
                            if (!tokenValue) {
                                error2(Diagnostics.Hexadecimal_digit_expected);
                                tokenValue = "0";
                            }
                            tokenValue = "0x" + tokenValue;
                            tokenFlags |= 64 /* HexSpecifier */ ;
                            return token = checkBigIntSuffix();
                        } else if (pos + 2 < end && (charCodeUnchecked(pos + 1) === 66 /* B */  || charCodeUnchecked(pos + 1) === 98 /* b */ )) {
                            pos += 2;
                            tokenValue = scanBinaryOrOctalDigits(/* base */ 2);
                            if (!tokenValue) {
                                error2(Diagnostics.Binary_digit_expected);
                                tokenValue = "0";
                            }
                            tokenValue = "0b" + tokenValue;
                            tokenFlags |= 128 /* BinarySpecifier */ ;
                            return token = checkBigIntSuffix();
                        } else if (pos + 2 < end && (charCodeUnchecked(pos + 1) === 79 /* O */  || charCodeUnchecked(pos + 1) === 111 /* o */ )) {
                            pos += 2;
                            tokenValue = scanBinaryOrOctalDigits(/* base */ 8);
                            if (!tokenValue) {
                                error2(Diagnostics.Octal_digit_expected);
                                tokenValue = "0";
                            }
                            tokenValue = "0o" + tokenValue;
                            tokenFlags |= 256 /* OctalSpecifier */ ;
                            return token = checkBigIntSuffix();
                        }
                    // falls through
                    case 49 /* _1 */ :
                    case 50 /* _2 */ :
                    case 51 /* _3 */ :
                    case 52 /* _4 */ :
                    case 53 /* _5 */ :
                    case 54 /* _6 */ :
                    case 55 /* _7 */ :
                    case 56 /* _8 */ :
                    case 57 /* _9 */ :
                        return token = scanNumber();
                    case 58 /* colon */ :
                        pos++;
                        return token = 59 /* ColonToken */ ;
                    case 59 /* semicolon */ :
                        pos++;
                        return token = 27 /* SemicolonToken */ ;
                    case 60 /* lessThan */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error2);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 60 /* lessThan */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 71 /* LessThanLessThanEqualsToken */ ;
                            return pos += 2, token = 48 /* LessThanLessThanToken */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 33 /* LessThanEqualsToken */ ;
                        if (languageVariant === 1 /* JSX */  && charCodeUnchecked(pos + 1) === 47 /* slash */  && charCodeUnchecked(pos + 2) !== 42 /* asterisk */ ) return pos += 2, token = 31 /* LessThanSlashToken */ ;
                        pos++;
                        return token = 30 /* LessThanToken */ ;
                    case 61 /* equals */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error2);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 37 /* EqualsEqualsEqualsToken */ ;
                            return pos += 2, token = 35 /* EqualsEqualsToken */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 62 /* greaterThan */ ) return pos += 2, token = 39 /* EqualsGreaterThanToken */ ;
                        pos++;
                        return token = 64 /* EqualsToken */ ;
                    case 62 /* greaterThan */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error2);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        pos++;
                        return token = 32 /* GreaterThanToken */ ;
                    case 63 /* question */ :
                        if (charCodeUnchecked(pos + 1) === 46 /* dot */  && !isDigit(charCodeUnchecked(pos + 2))) return pos += 2, token = 29 /* QuestionDotToken */ ;
                        if (charCodeUnchecked(pos + 1) === 63 /* question */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 78 /* QuestionQuestionEqualsToken */ ;
                            return pos += 2, token = 61 /* QuestionQuestionToken */ ;
                        }
                        pos++;
                        return token = 58 /* QuestionToken */ ;
                    case 91 /* openBracket */ :
                        pos++;
                        return token = 23 /* OpenBracketToken */ ;
                    case 93 /* closeBracket */ :
                        pos++;
                        return token = 24 /* CloseBracketToken */ ;
                    case 94 /* caret */ :
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 79 /* CaretEqualsToken */ ;
                        pos++;
                        return token = 53 /* CaretToken */ ;
                    case 123 /* openBrace */ :
                        pos++;
                        return token = 19 /* OpenBraceToken */ ;
                    case 124 /* bar */ :
                        if (isConflictMarkerTrivia(text, pos)) {
                            pos = scanConflictMarkerTrivia(text, pos, error2);
                            if (skipTrivia2) continue;
                            else return token = 7 /* ConflictMarkerTrivia */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 124 /* bar */ ) {
                            if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 76 /* BarBarEqualsToken */ ;
                            return pos += 2, token = 57 /* BarBarToken */ ;
                        }
                        if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 75 /* BarEqualsToken */ ;
                        pos++;
                        return token = 52 /* BarToken */ ;
                    case 125 /* closeBrace */ :
                        pos++;
                        return token = 20 /* CloseBraceToken */ ;
                    case 126 /* tilde */ :
                        pos++;
                        return token = 55 /* TildeToken */ ;
                    case 64 /* at */ :
                        pos++;
                        return token = 60 /* AtToken */ ;
                    case 92 /* backslash */ :
                        const extendedCookedChar = peekExtendedUnicodeEscape();
                        if (extendedCookedChar >= 0 && isIdentifierStart(extendedCookedChar, languageVersion)) {
                            tokenValue = scanExtendedUnicodeEscape(/*shouldEmitInvalidEscapeError*/ true) + scanIdentifierParts();
                            return token = getIdentifierToken();
                        }
                        const cookedChar = peekUnicodeEscape();
                        if (cookedChar >= 0 && isIdentifierStart(cookedChar, languageVersion)) {
                            pos += 6;
                            tokenFlags |= 1024 /* UnicodeEscape */ ;
                            tokenValue = String.fromCharCode(cookedChar) + scanIdentifierParts();
                            return token = getIdentifierToken();
                        }
                        error2(Diagnostics.Invalid_character);
                        pos++;
                        return token = 0 /* Unknown */ ;
                    case 35 /* hash */ :
                        if (pos !== 0 && text[pos + 1] === "!") {
                            error2(Diagnostics.can_only_be_used_at_the_start_of_a_file, pos, 2);
                            pos++;
                            return token = 0 /* Unknown */ ;
                        }
                        const charAfterHash = codePointUnchecked(pos + 1);
                        if (charAfterHash === 92 /* backslash */ ) {
                            pos++;
                            const extendedCookedChar2 = peekExtendedUnicodeEscape();
                            if (extendedCookedChar2 >= 0 && isIdentifierStart(extendedCookedChar2, languageVersion)) {
                                tokenValue = "#" + scanExtendedUnicodeEscape(/*shouldEmitInvalidEscapeError*/ true) + scanIdentifierParts();
                                return token = 81 /* PrivateIdentifier */ ;
                            }
                            const cookedChar2 = peekUnicodeEscape();
                            if (cookedChar2 >= 0 && isIdentifierStart(cookedChar2, languageVersion)) {
                                pos += 6;
                                tokenFlags |= 1024 /* UnicodeEscape */ ;
                                tokenValue = "#" + String.fromCharCode(cookedChar2) + scanIdentifierParts();
                                return token = 81 /* PrivateIdentifier */ ;
                            }
                            pos--;
                        }
                        if (isIdentifierStart(charAfterHash, languageVersion)) {
                            pos++;
                            scanIdentifier(charAfterHash, languageVersion);
                        } else {
                            tokenValue = "#";
                            error2(Diagnostics.Invalid_character, pos++, charSize(ch));
                        }
                        return token = 81 /* PrivateIdentifier */ ;
                    case 65533 /* replacementCharacter */ :
                        error2(Diagnostics.File_appears_to_be_binary, 0, 0);
                        pos = end;
                        return token = 8 /* NonTextFileMarkerTrivia */ ;
                    default:
                        const identifierKind = scanIdentifier(ch, languageVersion);
                        if (identifierKind) return token = identifierKind;
                        else if (isWhiteSpaceSingleLine(ch)) {
                            pos += charSize(ch);
                            continue;
                        } else if (isLineBreak(ch)) {
                            tokenFlags |= 1 /* PrecedingLineBreak */ ;
                            pos += charSize(ch);
                            continue;
                        }
                        const size = charSize(ch);
                        error2(Diagnostics.Invalid_character, pos, size);
                        pos += size;
                        return token = 0 /* Unknown */ ;
                }
            }
        }
        function shouldParseJSDoc() {
            switch(jsDocParsingMode){
                case 0 /* ParseAll */ :
                    return true;
                case 1 /* ParseNone */ :
                    return false;
            }
            if (scriptKind !== 3 /* TS */  && scriptKind !== 4 /* TSX */ ) return true;
            if (jsDocParsingMode === 3 /* ParseForTypeInfo */ ) return false;
            return jsDocSeeOrLink.test(text.slice(fullStartPos, pos));
        }
        function reScanInvalidIdentifier() {
            Debug.assert(token === 0 /* Unknown */ , "'reScanInvalidIdentifier' should only be called when the current token is 'SyntaxKind.Unknown'.");
            pos = tokenStart = fullStartPos;
            tokenFlags = 0;
            const ch = codePointUnchecked(pos);
            const identifierKind = scanIdentifier(ch, 99 /* ESNext */ );
            if (identifierKind) return token = identifierKind;
            pos += charSize(ch);
            return token;
        }
        function scanIdentifier(startCharacter, languageVersion2) {
            let ch = startCharacter;
            if (isIdentifierStart(ch, languageVersion2)) {
                pos += charSize(ch);
                while(pos < end && isIdentifierPart(ch = codePointUnchecked(pos), languageVersion2))pos += charSize(ch);
                tokenValue = text.substring(tokenStart, pos);
                if (ch === 92 /* backslash */ ) tokenValue += scanIdentifierParts();
                return getIdentifierToken();
            }
        }
        function reScanGreaterToken() {
            if (token === 32 /* GreaterThanToken */ ) {
                if (charCodeUnchecked(pos) === 62 /* greaterThan */ ) {
                    if (charCodeUnchecked(pos + 1) === 62 /* greaterThan */ ) {
                        if (charCodeUnchecked(pos + 2) === 61 /* equals */ ) return pos += 3, token = 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ ;
                        return pos += 2, token = 50 /* GreaterThanGreaterThanGreaterThanToken */ ;
                    }
                    if (charCodeUnchecked(pos + 1) === 61 /* equals */ ) return pos += 2, token = 72 /* GreaterThanGreaterThanEqualsToken */ ;
                    pos++;
                    return token = 49 /* GreaterThanGreaterThanToken */ ;
                }
                if (charCodeUnchecked(pos) === 61 /* equals */ ) {
                    pos++;
                    return token = 34 /* GreaterThanEqualsToken */ ;
                }
            }
            return token;
        }
        function reScanAsteriskEqualsToken() {
            Debug.assert(token === 67 /* AsteriskEqualsToken */ , "'reScanAsteriskEqualsToken' should only be called on a '*='");
            pos = tokenStart + 1;
            return token = 64 /* EqualsToken */ ;
        }
        function reScanSlashToken(reportErrors2) {
            if (token === 44 /* SlashToken */  || token === 69 /* SlashEqualsToken */ ) {
                const startOfRegExpBody = tokenStart + 1;
                pos = startOfRegExpBody;
                let inEscape = false;
                let namedCaptureGroups = false;
                let inCharacterClass = false;
                while(true){
                    const ch = charCodeChecked(pos);
                    if (ch === -1 /* EOF */  || isLineBreak(ch)) {
                        tokenFlags |= 4 /* Unterminated */ ;
                        break;
                    }
                    if (inEscape) inEscape = false;
                    else if (ch === 47 /* slash */  && !inCharacterClass) break;
                    else if (ch === 91 /* openBracket */ ) inCharacterClass = true;
                    else if (ch === 92 /* backslash */ ) inEscape = true;
                    else if (ch === 93 /* closeBracket */ ) inCharacterClass = false;
                    else if (!inCharacterClass && ch === 40 /* openParen */  && charCodeChecked(pos + 1) === 63 /* question */  && charCodeChecked(pos + 2) === 60 /* lessThan */  && charCodeChecked(pos + 3) !== 61 /* equals */  && charCodeChecked(pos + 3) !== 33 /* exclamation */ ) namedCaptureGroups = true;
                    pos++;
                }
                const endOfRegExpBody = pos;
                if (tokenFlags & 4 /* Unterminated */ ) {
                    pos = startOfRegExpBody;
                    inEscape = false;
                    let characterClassDepth = 0;
                    let inDecimalQuantifier = false;
                    let groupDepth = 0;
                    while(pos < endOfRegExpBody){
                        const ch = charCodeUnchecked(pos);
                        if (inEscape) inEscape = false;
                        else if (ch === 92 /* backslash */ ) inEscape = true;
                        else if (ch === 91 /* openBracket */ ) characterClassDepth++;
                        else if (ch === 93 /* closeBracket */  && characterClassDepth) characterClassDepth--;
                        else if (!characterClassDepth) {
                            if (ch === 123 /* openBrace */ ) inDecimalQuantifier = true;
                            else if (ch === 125 /* closeBrace */  && inDecimalQuantifier) inDecimalQuantifier = false;
                            else if (!inDecimalQuantifier) {
                                if (ch === 40 /* openParen */ ) groupDepth++;
                                else if (ch === 41 /* closeParen */  && groupDepth) groupDepth--;
                                else if (ch === 41 /* closeParen */  || ch === 93 /* closeBracket */  || ch === 125 /* closeBrace */ ) break;
                            }
                        }
                        pos++;
                    }
                    while(isWhiteSpaceLike(charCodeChecked(pos - 1)) || charCodeChecked(pos - 1) === 59 /* semicolon */ )pos--;
                    error2(Diagnostics.Unterminated_regular_expression_literal, tokenStart, pos - tokenStart);
                } else {
                    pos++;
                    let regExpFlags = 0 /* None */ ;
                    while(true){
                        const ch = codePointChecked(pos);
                        if (ch === -1 /* EOF */  || !isIdentifierPart(ch, languageVersion)) break;
                        const size = charSize(ch);
                        if (reportErrors2) {
                            const flag = characterCodeToRegularExpressionFlag(ch);
                            if (flag === void 0) error2(Diagnostics.Unknown_regular_expression_flag, pos, size);
                            else if (regExpFlags & flag) error2(Diagnostics.Duplicate_regular_expression_flag, pos, size);
                            else if (((regExpFlags | flag) & 96 /* AnyUnicodeMode */ ) === 96 /* AnyUnicodeMode */ ) error2(Diagnostics.The_Unicode_u_flag_and_the_Unicode_Sets_v_flag_cannot_be_set_simultaneously, pos, size);
                            else {
                                regExpFlags |= flag;
                                checkRegularExpressionFlagAvailability(flag, size);
                            }
                        }
                        pos += size;
                    }
                    if (reportErrors2) scanRange(startOfRegExpBody, endOfRegExpBody - startOfRegExpBody, ()=>{
                        scanRegularExpressionWorker(regExpFlags, /*annexB*/ true, namedCaptureGroups);
                    });
                }
                tokenValue = text.substring(tokenStart, pos);
                token = 14 /* RegularExpressionLiteral */ ;
            }
            return token;
        }
        function scanRegularExpressionWorker(regExpFlags, annexB, namedCaptureGroups) {
            var unicodeSetsMode = !!(regExpFlags & 64 /* UnicodeSets */ );
            var anyUnicodeMode = !!(regExpFlags & 96 /* AnyUnicodeMode */ );
            var anyUnicodeModeOrNonAnnexB = anyUnicodeMode || !annexB;
            var mayContainStrings = false;
            var numberOfCapturingGroups = 0;
            var groupSpecifiers;
            var groupNameReferences;
            var decimalEscapes;
            var namedCapturingGroupsScopeStack = [];
            var topNamedCapturingGroupsScope;
            function scanDisjunction(isInGroup) {
                while(true){
                    namedCapturingGroupsScopeStack.push(topNamedCapturingGroupsScope);
                    topNamedCapturingGroupsScope = void 0;
                    scanAlternative(isInGroup);
                    topNamedCapturingGroupsScope = namedCapturingGroupsScopeStack.pop();
                    if (charCodeChecked(pos) !== 124 /* bar */ ) return;
                    pos++;
                }
            }
            function scanAlternative(isInGroup) {
                let isPreviousTermQuantifiable = false;
                while(true){
                    const start2 = pos;
                    const ch = charCodeChecked(pos);
                    switch(ch){
                        case -1 /* EOF */ :
                            return;
                        case 94 /* caret */ :
                        case 36 /* $ */ :
                            pos++;
                            isPreviousTermQuantifiable = false;
                            break;
                        case 92 /* backslash */ :
                            pos++;
                            switch(charCodeChecked(pos)){
                                case 98 /* b */ :
                                case 66 /* B */ :
                                    pos++;
                                    isPreviousTermQuantifiable = false;
                                    break;
                                default:
                                    scanAtomEscape();
                                    isPreviousTermQuantifiable = true;
                                    break;
                            }
                            break;
                        case 40 /* openParen */ :
                            pos++;
                            if (charCodeChecked(pos) === 63 /* question */ ) {
                                pos++;
                                switch(charCodeChecked(pos)){
                                    case 61 /* equals */ :
                                    case 33 /* exclamation */ :
                                        pos++;
                                        isPreviousTermQuantifiable = !anyUnicodeModeOrNonAnnexB;
                                        break;
                                    case 60 /* lessThan */ :
                                        const groupNameStart = pos;
                                        pos++;
                                        switch(charCodeChecked(pos)){
                                            case 61 /* equals */ :
                                            case 33 /* exclamation */ :
                                                pos++;
                                                isPreviousTermQuantifiable = false;
                                                break;
                                            default:
                                                scanGroupName(/*isReference*/ false);
                                                scanExpectedChar(62 /* greaterThan */ );
                                                if (languageVersion < 5 /* ES2018 */ ) error2(Diagnostics.Named_capturing_groups_are_only_available_when_targeting_ES2018_or_later, groupNameStart, pos - groupNameStart);
                                                numberOfCapturingGroups++;
                                                isPreviousTermQuantifiable = true;
                                                break;
                                        }
                                        break;
                                    default:
                                        const start3 = pos;
                                        const setFlags = scanPatternModifiers(0 /* None */ );
                                        if (charCodeChecked(pos) === 45 /* minus */ ) {
                                            pos++;
                                            scanPatternModifiers(setFlags);
                                            if (pos === start3 + 1) error2(Diagnostics.Subpattern_flags_must_be_present_when_there_is_a_minus_sign, start3, pos - start3);
                                        }
                                        scanExpectedChar(58 /* colon */ );
                                        isPreviousTermQuantifiable = true;
                                        break;
                                }
                            } else {
                                numberOfCapturingGroups++;
                                isPreviousTermQuantifiable = true;
                            }
                            scanDisjunction(/*isInGroup*/ true);
                            scanExpectedChar(41 /* closeParen */ );
                            break;
                        case 123 /* openBrace */ :
                            pos++;
                            const digitsStart = pos;
                            scanDigits();
                            const min2 = tokenValue;
                            if (!anyUnicodeModeOrNonAnnexB && !min2) {
                                isPreviousTermQuantifiable = true;
                                break;
                            }
                            if (charCodeChecked(pos) === 44 /* comma */ ) {
                                pos++;
                                scanDigits();
                                const max = tokenValue;
                                if (!min2) {
                                    if (max || charCodeChecked(pos) === 125 /* closeBrace */ ) error2(Diagnostics.Incomplete_quantifier_Digit_expected, digitsStart, 0);
                                    else {
                                        error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, start2, 1, String.fromCharCode(ch));
                                        isPreviousTermQuantifiable = true;
                                        break;
                                    }
                                } else if (max && Number.parseInt(min2) > Number.parseInt(max) && (anyUnicodeModeOrNonAnnexB || charCodeChecked(pos) === 125 /* closeBrace */ )) error2(Diagnostics.Numbers_out_of_order_in_quantifier, digitsStart, pos - digitsStart);
                            } else if (!min2) {
                                if (anyUnicodeModeOrNonAnnexB) error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, start2, 1, String.fromCharCode(ch));
                                isPreviousTermQuantifiable = true;
                                break;
                            }
                            if (charCodeChecked(pos) !== 125 /* closeBrace */ ) {
                                if (anyUnicodeModeOrNonAnnexB) {
                                    error2(Diagnostics._0_expected, pos, 0, String.fromCharCode(125 /* closeBrace */ ));
                                    pos--;
                                } else {
                                    isPreviousTermQuantifiable = true;
                                    break;
                                }
                            }
                        // falls through
                        case 42 /* asterisk */ :
                        case 43 /* plus */ :
                        case 63 /* question */ :
                            pos++;
                            if (charCodeChecked(pos) === 63 /* question */ ) pos++;
                            if (!isPreviousTermQuantifiable) error2(Diagnostics.There_is_nothing_available_for_repetition, start2, pos - start2);
                            isPreviousTermQuantifiable = false;
                            break;
                        case 46 /* dot */ :
                            pos++;
                            isPreviousTermQuantifiable = true;
                            break;
                        case 91 /* openBracket */ :
                            pos++;
                            if (unicodeSetsMode) scanClassSetExpression();
                            else scanClassRanges();
                            scanExpectedChar(93 /* closeBracket */ );
                            isPreviousTermQuantifiable = true;
                            break;
                        case 41 /* closeParen */ :
                            if (isInGroup) return;
                        // falls through
                        case 93 /* closeBracket */ :
                        case 125 /* closeBrace */ :
                            if (anyUnicodeModeOrNonAnnexB || ch === 41 /* closeParen */ ) error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos, 1, String.fromCharCode(ch));
                            pos++;
                            isPreviousTermQuantifiable = true;
                            break;
                        case 47 /* slash */ :
                        case 124 /* bar */ :
                            return;
                        default:
                            scanSourceCharacter();
                            isPreviousTermQuantifiable = true;
                            break;
                    }
                }
            }
            function scanPatternModifiers(currFlags) {
                while(true){
                    const ch = codePointChecked(pos);
                    if (ch === -1 /* EOF */  || !isIdentifierPart(ch, languageVersion)) break;
                    const size = charSize(ch);
                    const flag = characterCodeToRegularExpressionFlag(ch);
                    if (flag === void 0) error2(Diagnostics.Unknown_regular_expression_flag, pos, size);
                    else if (currFlags & flag) error2(Diagnostics.Duplicate_regular_expression_flag, pos, size);
                    else if (!(flag & 28 /* Modifiers */ )) error2(Diagnostics.This_regular_expression_flag_cannot_be_toggled_within_a_subpattern, pos, size);
                    else {
                        currFlags |= flag;
                        checkRegularExpressionFlagAvailability(flag, size);
                    }
                    pos += size;
                }
                return currFlags;
            }
            function scanAtomEscape() {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 92 /* backslash */ );
                switch(charCodeChecked(pos)){
                    case 107 /* k */ :
                        pos++;
                        if (charCodeChecked(pos) === 60 /* lessThan */ ) {
                            pos++;
                            scanGroupName(/*isReference*/ true);
                            scanExpectedChar(62 /* greaterThan */ );
                        } else if (anyUnicodeModeOrNonAnnexB || namedCaptureGroups) error2(Diagnostics.k_must_be_followed_by_a_capturing_group_name_enclosed_in_angle_brackets, pos - 2, 2);
                        break;
                    case 113 /* q */ :
                        if (unicodeSetsMode) {
                            pos++;
                            error2(Diagnostics.q_is_only_available_inside_character_class, pos - 2, 2);
                            break;
                        }
                    // falls through
                    default:
                        Debug.assert(scanCharacterClassEscape() || scanDecimalEscape() || scanCharacterEscape(/*atomEscape*/ true));
                        break;
                }
            }
            function scanDecimalEscape() {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 92 /* backslash */ );
                const ch = charCodeChecked(pos);
                if (ch >= 49 /* _1 */  && ch <= 57 /* _9 */ ) {
                    const start2 = pos;
                    scanDigits();
                    decimalEscapes = append(decimalEscapes, {
                        pos: start2,
                        end: pos,
                        value: +tokenValue
                    });
                    return true;
                }
                return false;
            }
            function scanCharacterEscape(atomEscape) {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 92 /* backslash */ );
                let ch = charCodeChecked(pos);
                switch(ch){
                    case -1 /* EOF */ :
                        error2(Diagnostics.Undetermined_character_escape, pos - 1, 1);
                        return "\\";
                    case 99 /* c */ :
                        pos++;
                        ch = charCodeChecked(pos);
                        if (isASCIILetter(ch)) {
                            pos++;
                            return String.fromCharCode(ch & 31);
                        }
                        if (anyUnicodeModeOrNonAnnexB) error2(Diagnostics.c_must_be_followed_by_an_ASCII_letter, pos - 2, 2);
                        else if (atomEscape) {
                            pos--;
                            return "\\";
                        }
                        return String.fromCharCode(ch);
                    case 94 /* caret */ :
                    case 36 /* $ */ :
                    case 47 /* slash */ :
                    case 92 /* backslash */ :
                    case 46 /* dot */ :
                    case 42 /* asterisk */ :
                    case 43 /* plus */ :
                    case 63 /* question */ :
                    case 40 /* openParen */ :
                    case 41 /* closeParen */ :
                    case 91 /* openBracket */ :
                    case 93 /* closeBracket */ :
                    case 123 /* openBrace */ :
                    case 125 /* closeBrace */ :
                    case 124 /* bar */ :
                        pos++;
                        return String.fromCharCode(ch);
                    default:
                        pos--;
                        return scanEscapeSequence(4 /* RegularExpression */  | (annexB ? 8 /* AnnexB */  : 0) | (anyUnicodeMode ? 16 /* AnyUnicodeMode */  : 0) | (atomEscape ? 32 /* AtomEscape */  : 0));
                }
            }
            function scanGroupName(isReference) {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 60 /* lessThan */ );
                tokenStart = pos;
                scanIdentifier(codePointChecked(pos), languageVersion);
                if (pos === tokenStart) error2(Diagnostics.Expected_a_capturing_group_name);
                else if (isReference) groupNameReferences = append(groupNameReferences, {
                    pos: tokenStart,
                    end: pos,
                    name: tokenValue
                });
                else if ((topNamedCapturingGroupsScope == null ? void 0 : topNamedCapturingGroupsScope.has(tokenValue)) || namedCapturingGroupsScopeStack.some((group2)=>group2 == null ? void 0 : group2.has(tokenValue))) error2(Diagnostics.Named_capturing_groups_with_the_same_name_must_be_mutually_exclusive_to_each_other, tokenStart, pos - tokenStart);
                else {
                    topNamedCapturingGroupsScope !== null && topNamedCapturingGroupsScope !== void 0 ? topNamedCapturingGroupsScope : topNamedCapturingGroupsScope = /* @__PURE__ */ new Set();
                    topNamedCapturingGroupsScope.add(tokenValue);
                    groupSpecifiers !== null && groupSpecifiers !== void 0 ? groupSpecifiers : groupSpecifiers = /* @__PURE__ */ new Set();
                    groupSpecifiers.add(tokenValue);
                }
            }
            function isClassContentExit(ch) {
                return ch === 93 /* closeBracket */  || ch === -1 /* EOF */  || pos >= end;
            }
            function scanClassRanges() {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 91 /* openBracket */ );
                if (charCodeChecked(pos) === 94 /* caret */ ) pos++;
                while(true){
                    const ch = charCodeChecked(pos);
                    if (isClassContentExit(ch)) return;
                    const minStart = pos;
                    const minCharacter = scanClassAtom();
                    if (charCodeChecked(pos) === 45 /* minus */ ) {
                        pos++;
                        const ch2 = charCodeChecked(pos);
                        if (isClassContentExit(ch2)) return;
                        if (!minCharacter && anyUnicodeModeOrNonAnnexB) error2(Diagnostics.A_character_class_range_must_not_be_bounded_by_another_character_class, minStart, pos - 1 - minStart);
                        const maxStart = pos;
                        const maxCharacter = scanClassAtom();
                        if (!maxCharacter && anyUnicodeModeOrNonAnnexB) {
                            error2(Diagnostics.A_character_class_range_must_not_be_bounded_by_another_character_class, maxStart, pos - maxStart);
                            continue;
                        }
                        if (!minCharacter) continue;
                        const minCharacterValue = codePointAt(minCharacter, 0);
                        const maxCharacterValue = codePointAt(maxCharacter, 0);
                        if (minCharacter.length === charSize(minCharacterValue) && maxCharacter.length === charSize(maxCharacterValue) && minCharacterValue > maxCharacterValue) error2(Diagnostics.Range_out_of_order_in_character_class, minStart, pos - minStart);
                    }
                }
            }
            function scanClassSetExpression() {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 91 /* openBracket */ );
                let isCharacterComplement = false;
                if (charCodeChecked(pos) === 94 /* caret */ ) {
                    pos++;
                    isCharacterComplement = true;
                }
                let expressionMayContainStrings = false;
                let ch = charCodeChecked(pos);
                if (isClassContentExit(ch)) return;
                let start2 = pos;
                let operand;
                switch(text.slice(pos, pos + 2)){
                    // TODO: don't use slice
                    case "--":
                    case "&&":
                        error2(Diagnostics.Expected_a_class_set_operand);
                        mayContainStrings = false;
                        break;
                    default:
                        operand = scanClassSetOperand();
                        break;
                }
                switch(charCodeChecked(pos)){
                    case 45 /* minus */ :
                        if (charCodeChecked(pos + 1) === 45 /* minus */ ) {
                            if (isCharacterComplement && mayContainStrings) error2(Diagnostics.Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_character_class, start2, pos - start2);
                            expressionMayContainStrings = mayContainStrings;
                            scanClassSetSubExpression(3 /* ClassSubtraction */ );
                            mayContainStrings = !isCharacterComplement && expressionMayContainStrings;
                            return;
                        }
                        break;
                    case 38 /* ampersand */ :
                        if (charCodeChecked(pos + 1) === 38 /* ampersand */ ) {
                            scanClassSetSubExpression(2 /* ClassIntersection */ );
                            if (isCharacterComplement && mayContainStrings) error2(Diagnostics.Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_character_class, start2, pos - start2);
                            expressionMayContainStrings = mayContainStrings;
                            mayContainStrings = !isCharacterComplement && expressionMayContainStrings;
                            return;
                        } else error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos, 1, String.fromCharCode(ch));
                        break;
                    default:
                        if (isCharacterComplement && mayContainStrings) error2(Diagnostics.Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_character_class, start2, pos - start2);
                        expressionMayContainStrings = mayContainStrings;
                        break;
                }
                while(true){
                    ch = charCodeChecked(pos);
                    if (ch === -1 /* EOF */ ) break;
                    switch(ch){
                        case 45 /* minus */ :
                            pos++;
                            ch = charCodeChecked(pos);
                            if (isClassContentExit(ch)) {
                                mayContainStrings = !isCharacterComplement && expressionMayContainStrings;
                                return;
                            }
                            if (ch === 45 /* minus */ ) {
                                pos++;
                                error2(Diagnostics.Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead, pos - 2, 2);
                                start2 = pos - 2;
                                operand = text.slice(start2, pos);
                                continue;
                            } else {
                                if (!operand) error2(Diagnostics.A_character_class_range_must_not_be_bounded_by_another_character_class, start2, pos - 1 - start2);
                                const secondStart = pos;
                                const secondOperand = scanClassSetOperand();
                                if (isCharacterComplement && mayContainStrings) error2(Diagnostics.Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_character_class, secondStart, pos - secondStart);
                                expressionMayContainStrings || (expressionMayContainStrings = mayContainStrings);
                                if (!secondOperand) {
                                    error2(Diagnostics.A_character_class_range_must_not_be_bounded_by_another_character_class, secondStart, pos - secondStart);
                                    break;
                                }
                                if (!operand) break;
                                const minCharacterValue = codePointAt(operand, 0);
                                const maxCharacterValue = codePointAt(secondOperand, 0);
                                if (operand.length === charSize(minCharacterValue) && secondOperand.length === charSize(maxCharacterValue) && minCharacterValue > maxCharacterValue) error2(Diagnostics.Range_out_of_order_in_character_class, start2, pos - start2);
                            }
                            break;
                        case 38 /* ampersand */ :
                            start2 = pos;
                            pos++;
                            if (charCodeChecked(pos) === 38 /* ampersand */ ) {
                                pos++;
                                error2(Diagnostics.Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead, pos - 2, 2);
                                if (charCodeChecked(pos) === 38 /* ampersand */ ) {
                                    error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos, 1, String.fromCharCode(ch));
                                    pos++;
                                }
                            } else error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos - 1, 1, String.fromCharCode(ch));
                            operand = text.slice(start2, pos);
                            continue;
                    }
                    if (isClassContentExit(charCodeChecked(pos))) break;
                    start2 = pos;
                    switch(text.slice(pos, pos + 2)){
                        // TODO: don't use slice
                        case "--":
                        case "&&":
                            error2(Diagnostics.Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead, pos, 2);
                            pos += 2;
                            operand = text.slice(start2, pos);
                            break;
                        default:
                            operand = scanClassSetOperand();
                            break;
                    }
                }
                mayContainStrings = !isCharacterComplement && expressionMayContainStrings;
            }
            function scanClassSetSubExpression(expressionType) {
                let expressionMayContainStrings = mayContainStrings;
                while(true){
                    let ch = charCodeChecked(pos);
                    if (isClassContentExit(ch)) break;
                    switch(ch){
                        case 45 /* minus */ :
                            pos++;
                            if (charCodeChecked(pos) === 45 /* minus */ ) {
                                pos++;
                                if (expressionType !== 3 /* ClassSubtraction */ ) error2(Diagnostics.Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead, pos - 2, 2);
                            } else error2(Diagnostics.Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead, pos - 1, 1);
                            break;
                        case 38 /* ampersand */ :
                            pos++;
                            if (charCodeChecked(pos) === 38 /* ampersand */ ) {
                                pos++;
                                if (expressionType !== 2 /* ClassIntersection */ ) error2(Diagnostics.Operators_must_not_be_mixed_within_a_character_class_Wrap_it_in_a_nested_class_instead, pos - 2, 2);
                                if (charCodeChecked(pos) === 38 /* ampersand */ ) {
                                    error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos, 1, String.fromCharCode(ch));
                                    pos++;
                                }
                            } else error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos - 1, 1, String.fromCharCode(ch));
                            break;
                        default:
                            switch(expressionType){
                                case 3 /* ClassSubtraction */ :
                                    error2(Diagnostics._0_expected, pos, 0, "--");
                                    break;
                                case 2 /* ClassIntersection */ :
                                    error2(Diagnostics._0_expected, pos, 0, "&&");
                                    break;
                                default:
                                    break;
                            }
                            break;
                    }
                    ch = charCodeChecked(pos);
                    if (isClassContentExit(ch)) {
                        error2(Diagnostics.Expected_a_class_set_operand);
                        break;
                    }
                    scanClassSetOperand();
                    expressionMayContainStrings && (expressionMayContainStrings = mayContainStrings);
                }
                mayContainStrings = expressionMayContainStrings;
            }
            function scanClassSetOperand() {
                mayContainStrings = false;
                switch(charCodeChecked(pos)){
                    case -1 /* EOF */ :
                        return "";
                    case 91 /* openBracket */ :
                        pos++;
                        scanClassSetExpression();
                        scanExpectedChar(93 /* closeBracket */ );
                        return "";
                    case 92 /* backslash */ :
                        pos++;
                        if (scanCharacterClassEscape()) return "";
                        else if (charCodeChecked(pos) === 113 /* q */ ) {
                            pos++;
                            if (charCodeChecked(pos) === 123 /* openBrace */ ) {
                                pos++;
                                scanClassStringDisjunctionContents();
                                scanExpectedChar(125 /* closeBrace */ );
                                return "";
                            } else {
                                error2(Diagnostics.q_must_be_followed_by_string_alternatives_enclosed_in_braces, pos - 2, 2);
                                return "q";
                            }
                        }
                        pos--;
                    // falls through
                    default:
                        return scanClassSetCharacter();
                }
            }
            function scanClassStringDisjunctionContents() {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 123 /* openBrace */ );
                let characterCount = 0;
                while(true){
                    const ch = charCodeChecked(pos);
                    switch(ch){
                        case -1 /* EOF */ :
                            return;
                        case 125 /* closeBrace */ :
                            if (characterCount !== 1) mayContainStrings = true;
                            return;
                        case 124 /* bar */ :
                            if (characterCount !== 1) mayContainStrings = true;
                            pos++;
                            start = pos;
                            characterCount = 0;
                            break;
                        default:
                            scanClassSetCharacter();
                            characterCount++;
                            break;
                    }
                }
            }
            function scanClassSetCharacter() {
                const ch = charCodeChecked(pos);
                if (ch === -1 /* EOF */ ) return "";
                if (ch === 92 /* backslash */ ) {
                    pos++;
                    const ch2 = charCodeChecked(pos);
                    switch(ch2){
                        case 98 /* b */ :
                            pos++;
                            return "\b";
                        case 38 /* ampersand */ :
                        case 45 /* minus */ :
                        case 33 /* exclamation */ :
                        case 35 /* hash */ :
                        case 37 /* percent */ :
                        case 44 /* comma */ :
                        case 58 /* colon */ :
                        case 59 /* semicolon */ :
                        case 60 /* lessThan */ :
                        case 61 /* equals */ :
                        case 62 /* greaterThan */ :
                        case 64 /* at */ :
                        case 96 /* backtick */ :
                        case 126 /* tilde */ :
                            pos++;
                            return String.fromCharCode(ch2);
                        default:
                            return scanCharacterEscape(/*atomEscape*/ false);
                    }
                } else if (ch === charCodeChecked(pos + 1)) switch(ch){
                    case 38 /* ampersand */ :
                    case 33 /* exclamation */ :
                    case 35 /* hash */ :
                    case 37 /* percent */ :
                    case 42 /* asterisk */ :
                    case 43 /* plus */ :
                    case 44 /* comma */ :
                    case 46 /* dot */ :
                    case 58 /* colon */ :
                    case 59 /* semicolon */ :
                    case 60 /* lessThan */ :
                    case 61 /* equals */ :
                    case 62 /* greaterThan */ :
                    case 63 /* question */ :
                    case 64 /* at */ :
                    case 96 /* backtick */ :
                    case 126 /* tilde */ :
                        error2(Diagnostics.A_character_class_must_not_contain_a_reserved_double_punctuator_Did_you_mean_to_escape_it_with_backslash, pos, 2);
                        pos += 2;
                        return text.substring(pos - 2, pos);
                }
                switch(ch){
                    case 47 /* slash */ :
                    case 40 /* openParen */ :
                    case 41 /* closeParen */ :
                    case 91 /* openBracket */ :
                    case 93 /* closeBracket */ :
                    case 123 /* openBrace */ :
                    case 125 /* closeBrace */ :
                    case 45 /* minus */ :
                    case 124 /* bar */ :
                        error2(Diagnostics.Unexpected_0_Did_you_mean_to_escape_it_with_backslash, pos, 1, String.fromCharCode(ch));
                        pos++;
                        return String.fromCharCode(ch);
                }
                return scanSourceCharacter();
            }
            function scanClassAtom() {
                if (charCodeChecked(pos) === 92 /* backslash */ ) {
                    pos++;
                    const ch = charCodeChecked(pos);
                    switch(ch){
                        case 98 /* b */ :
                            pos++;
                            return "\b";
                        case 45 /* minus */ :
                            pos++;
                            return String.fromCharCode(ch);
                        default:
                            if (scanCharacterClassEscape()) return "";
                            return scanCharacterEscape(/*atomEscape*/ false);
                    }
                } else return scanSourceCharacter();
            }
            function scanCharacterClassEscape() {
                Debug.assertEqual(charCodeUnchecked(pos - 1), 92 /* backslash */ );
                let isCharacterComplement = false;
                const start2 = pos - 1;
                const ch = charCodeChecked(pos);
                switch(ch){
                    case 100 /* d */ :
                    case 68 /* D */ :
                    case 115 /* s */ :
                    case 83 /* S */ :
                    case 119 /* w */ :
                    case 87 /* W */ :
                        pos++;
                        return true;
                    case 80 /* P */ :
                        isCharacterComplement = true;
                    // falls through
                    case 112 /* p */ :
                        pos++;
                        if (charCodeChecked(pos) === 123 /* openBrace */ ) {
                            pos++;
                            const propertyNameOrValueStart = pos;
                            const propertyNameOrValue = scanWordCharacters();
                            if (charCodeChecked(pos) === 61 /* equals */ ) {
                                const propertyName = nonBinaryUnicodeProperties.get(propertyNameOrValue);
                                if (pos === propertyNameOrValueStart) error2(Diagnostics.Expected_a_Unicode_property_name);
                                else if (propertyName === void 0) {
                                    error2(Diagnostics.Unknown_Unicode_property_name, propertyNameOrValueStart, pos - propertyNameOrValueStart);
                                    const suggestion = getSpellingSuggestion(propertyNameOrValue, nonBinaryUnicodeProperties.keys(), identity);
                                    if (suggestion) error2(Diagnostics.Did_you_mean_0, propertyNameOrValueStart, pos - propertyNameOrValueStart, suggestion);
                                }
                                pos++;
                                const propertyValueStart = pos;
                                const propertyValue = scanWordCharacters();
                                if (pos === propertyValueStart) error2(Diagnostics.Expected_a_Unicode_property_value);
                                else if (propertyName !== void 0 && !valuesOfNonBinaryUnicodeProperties[propertyName].has(propertyValue)) {
                                    error2(Diagnostics.Unknown_Unicode_property_value, propertyValueStart, pos - propertyValueStart);
                                    const suggestion = getSpellingSuggestion(propertyValue, valuesOfNonBinaryUnicodeProperties[propertyName], identity);
                                    if (suggestion) error2(Diagnostics.Did_you_mean_0, propertyValueStart, pos - propertyValueStart, suggestion);
                                }
                            } else {
                                if (pos === propertyNameOrValueStart) error2(Diagnostics.Expected_a_Unicode_property_name_or_value);
                                else if (binaryUnicodePropertiesOfStrings.has(propertyNameOrValue)) {
                                    if (!unicodeSetsMode) error2(Diagnostics.Any_Unicode_property_that_would_possibly_match_more_than_a_single_character_is_only_available_when_the_Unicode_Sets_v_flag_is_set, propertyNameOrValueStart, pos - propertyNameOrValueStart);
                                    else if (isCharacterComplement) error2(Diagnostics.Anything_that_would_possibly_match_more_than_a_single_character_is_invalid_inside_a_negated_character_class, propertyNameOrValueStart, pos - propertyNameOrValueStart);
                                    else mayContainStrings = true;
                                } else if (!valuesOfNonBinaryUnicodeProperties.General_Category.has(propertyNameOrValue) && !binaryUnicodeProperties.has(propertyNameOrValue)) {
                                    error2(Diagnostics.Unknown_Unicode_property_name_or_value, propertyNameOrValueStart, pos - propertyNameOrValueStart);
                                    const suggestion = getSpellingSuggestion(propertyNameOrValue, [
                                        ...valuesOfNonBinaryUnicodeProperties.General_Category,
                                        ...binaryUnicodeProperties,
                                        ...binaryUnicodePropertiesOfStrings
                                    ], identity);
                                    if (suggestion) error2(Diagnostics.Did_you_mean_0, propertyNameOrValueStart, pos - propertyNameOrValueStart, suggestion);
                                }
                            }
                            scanExpectedChar(125 /* closeBrace */ );
                            if (!anyUnicodeMode) error2(Diagnostics.Unicode_property_value_expressions_are_only_available_when_the_Unicode_u_flag_or_the_Unicode_Sets_v_flag_is_set, start2, pos - start2);
                        } else if (anyUnicodeModeOrNonAnnexB) error2(Diagnostics._0_must_be_followed_by_a_Unicode_property_value_expression_enclosed_in_braces, pos - 2, 2, String.fromCharCode(ch));
                        else {
                            pos--;
                            return false;
                        }
                        return true;
                }
                return false;
            }
            function scanWordCharacters() {
                let value1 = "";
                while(true){
                    const ch = charCodeChecked(pos);
                    if (ch === -1 /* EOF */  || !isWordCharacter(ch)) break;
                    value1 += String.fromCharCode(ch);
                    pos++;
                }
                return value1;
            }
            function scanSourceCharacter() {
                const size = anyUnicodeMode ? charSize(codePointChecked(pos)) : 1;
                pos += size;
                return size > 0 ? text.substring(pos - size, pos) : "";
            }
            function scanExpectedChar(ch) {
                if (charCodeChecked(pos) === ch) pos++;
                else error2(Diagnostics._0_expected, pos, 0, String.fromCharCode(ch));
            }
            scanDisjunction(/*isInGroup*/ false);
            forEach(groupNameReferences, (reference)=>{
                if (!(groupSpecifiers == null ? void 0 : groupSpecifiers.has(reference.name))) {
                    error2(Diagnostics.There_is_no_capturing_group_named_0_in_this_regular_expression, reference.pos, reference.end - reference.pos, reference.name);
                    if (groupSpecifiers) {
                        const suggestion = getSpellingSuggestion(reference.name, groupSpecifiers, identity);
                        if (suggestion) error2(Diagnostics.Did_you_mean_0, reference.pos, reference.end - reference.pos, suggestion);
                    }
                }
            });
            forEach(decimalEscapes, (escape)=>{
                if (escape.value > numberOfCapturingGroups) {
                    if (numberOfCapturingGroups) error2(Diagnostics.This_backreference_refers_to_a_group_that_does_not_exist_There_are_only_0_capturing_groups_in_this_regular_expression, escape.pos, escape.end - escape.pos, numberOfCapturingGroups);
                    else error2(Diagnostics.This_backreference_refers_to_a_group_that_does_not_exist_There_are_no_capturing_groups_in_this_regular_expression, escape.pos, escape.end - escape.pos);
                }
            });
        }
        function checkRegularExpressionFlagAvailability(flag, size) {
            const availableFrom = regExpFlagToFirstAvailableLanguageVersion.get(flag);
            if (availableFrom && languageVersion < availableFrom) error2(Diagnostics.This_regular_expression_flag_is_only_available_when_targeting_0_or_later, pos, size, getNameOfScriptTarget(availableFrom));
        }
        function appendIfCommentDirective(commentDirectives2, text2, commentDirectiveRegEx, lineStart) {
            const type = getDirectiveFromComment(text2.trimStart(), commentDirectiveRegEx);
            if (type === void 0) return commentDirectives2;
            return append(commentDirectives2, {
                range: {
                    pos: lineStart,
                    end: pos
                },
                type
            });
        }
        function getDirectiveFromComment(text2, commentDirectiveRegEx) {
            const match = commentDirectiveRegEx.exec(text2);
            if (!match) return void 0;
            switch(match[1]){
                case "ts-expect-error":
                    return 0 /* ExpectError */ ;
                case "ts-ignore":
                    return 1 /* Ignore */ ;
            }
            return void 0;
        }
        function reScanTemplateToken(isTaggedTemplate) {
            pos = tokenStart;
            return token = scanTemplateAndSetTokenValue(!isTaggedTemplate);
        }
        function reScanTemplateHeadOrNoSubstitutionTemplate() {
            pos = tokenStart;
            return token = scanTemplateAndSetTokenValue(/*shouldEmitInvalidEscapeError*/ true);
        }
        function reScanJsxToken(allowMultilineJsxText = true) {
            pos = tokenStart = fullStartPos;
            return token = scanJsxToken(allowMultilineJsxText);
        }
        function reScanLessThanToken() {
            if (token === 48 /* LessThanLessThanToken */ ) {
                pos = tokenStart + 1;
                return token = 30 /* LessThanToken */ ;
            }
            return token;
        }
        function reScanHashToken() {
            if (token === 81 /* PrivateIdentifier */ ) {
                pos = tokenStart + 1;
                return token = 63 /* HashToken */ ;
            }
            return token;
        }
        function reScanQuestionToken() {
            Debug.assert(token === 61 /* QuestionQuestionToken */ , "'reScanQuestionToken' should only be called on a '??'");
            pos = tokenStart + 1;
            return token = 58 /* QuestionToken */ ;
        }
        function scanJsxToken(allowMultilineJsxText = true) {
            fullStartPos = tokenStart = pos;
            if (pos >= end) return token = 1 /* EndOfFileToken */ ;
            let char = charCodeUnchecked(pos);
            if (char === 60 /* lessThan */ ) {
                if (charCodeUnchecked(pos + 1) === 47 /* slash */ ) {
                    pos += 2;
                    return token = 31 /* LessThanSlashToken */ ;
                }
                pos++;
                return token = 30 /* LessThanToken */ ;
            }
            if (char === 123 /* openBrace */ ) {
                pos++;
                return token = 19 /* OpenBraceToken */ ;
            }
            let firstNonWhitespace = 0;
            while(pos < end){
                char = charCodeUnchecked(pos);
                if (char === 123 /* openBrace */ ) break;
                if (char === 60 /* lessThan */ ) {
                    if (isConflictMarkerTrivia(text, pos)) {
                        pos = scanConflictMarkerTrivia(text, pos, error2);
                        return token = 7 /* ConflictMarkerTrivia */ ;
                    }
                    break;
                }
                if (char === 62 /* greaterThan */ ) error2(Diagnostics.Unexpected_token_Did_you_mean_or_gt, pos, 1);
                if (char === 125 /* closeBrace */ ) error2(Diagnostics.Unexpected_token_Did_you_mean_or_rbrace, pos, 1);
                if (isLineBreak(char) && firstNonWhitespace === 0) firstNonWhitespace = -1;
                else if (!allowMultilineJsxText && isLineBreak(char) && firstNonWhitespace > 0) break;
                else if (!isWhiteSpaceLike(char)) firstNonWhitespace = pos;
                pos++;
            }
            tokenValue = text.substring(fullStartPos, pos);
            return firstNonWhitespace === -1 ? 13 /* JsxTextAllWhiteSpaces */  : 12 /* JsxText */ ;
        }
        function scanJsxIdentifier() {
            if (tokenIsIdentifierOrKeyword(token)) {
                while(pos < end){
                    const ch = charCodeUnchecked(pos);
                    if (ch === 45 /* minus */ ) {
                        tokenValue += "-";
                        pos++;
                        continue;
                    }
                    const oldPos = pos;
                    tokenValue += scanIdentifierParts();
                    if (pos === oldPos) break;
                }
                return getIdentifierToken();
            }
            return token;
        }
        function scanJsxAttributeValue() {
            fullStartPos = pos;
            switch(charCodeUnchecked(pos)){
                case 34 /* doubleQuote */ :
                case 39 /* singleQuote */ :
                    tokenValue = scanString(/*jsxAttributeString*/ true);
                    return token = 11 /* StringLiteral */ ;
                default:
                    return scan();
            }
        }
        function reScanJsxAttributeValue() {
            pos = tokenStart = fullStartPos;
            return scanJsxAttributeValue();
        }
        function scanJSDocCommentTextToken(inBackticks) {
            fullStartPos = tokenStart = pos;
            tokenFlags = 0 /* None */ ;
            if (pos >= end) return token = 1 /* EndOfFileToken */ ;
            for(let ch = charCodeUnchecked(pos); pos < end && !isLineBreak(ch) && ch !== 96 /* backtick */ ; ch = codePointUnchecked(++pos))if (!inBackticks) {
                if (ch === 123 /* openBrace */ ) break;
                else if (ch === 64 /* at */  && pos - 1 >= 0 && isWhiteSpaceSingleLine(charCodeUnchecked(pos - 1)) && !(pos + 1 < end && isWhiteSpaceLike(charCodeUnchecked(pos + 1)))) break;
            }
            if (pos === tokenStart) return scanJsDocToken();
            tokenValue = text.substring(tokenStart, pos);
            return token = 82 /* JSDocCommentTextToken */ ;
        }
        function scanJsDocToken() {
            fullStartPos = tokenStart = pos;
            tokenFlags = 0 /* None */ ;
            if (pos >= end) return token = 1 /* EndOfFileToken */ ;
            const ch = codePointUnchecked(pos);
            pos += charSize(ch);
            switch(ch){
                case 9 /* tab */ :
                case 11 /* verticalTab */ :
                case 12 /* formFeed */ :
                case 32 /* space */ :
                    while(pos < end && isWhiteSpaceSingleLine(charCodeUnchecked(pos)))pos++;
                    return token = 5 /* WhitespaceTrivia */ ;
                case 64 /* at */ :
                    return token = 60 /* AtToken */ ;
                case 13 /* carriageReturn */ :
                    if (charCodeUnchecked(pos) === 10 /* lineFeed */ ) pos++;
                // falls through
                case 10 /* lineFeed */ :
                    tokenFlags |= 1 /* PrecedingLineBreak */ ;
                    return token = 4 /* NewLineTrivia */ ;
                case 42 /* asterisk */ :
                    return token = 42 /* AsteriskToken */ ;
                case 123 /* openBrace */ :
                    return token = 19 /* OpenBraceToken */ ;
                case 125 /* closeBrace */ :
                    return token = 20 /* CloseBraceToken */ ;
                case 91 /* openBracket */ :
                    return token = 23 /* OpenBracketToken */ ;
                case 93 /* closeBracket */ :
                    return token = 24 /* CloseBracketToken */ ;
                case 40 /* openParen */ :
                    return token = 21 /* OpenParenToken */ ;
                case 41 /* closeParen */ :
                    return token = 22 /* CloseParenToken */ ;
                case 60 /* lessThan */ :
                    return token = 30 /* LessThanToken */ ;
                case 62 /* greaterThan */ :
                    return token = 32 /* GreaterThanToken */ ;
                case 61 /* equals */ :
                    return token = 64 /* EqualsToken */ ;
                case 44 /* comma */ :
                    return token = 28 /* CommaToken */ ;
                case 46 /* dot */ :
                    return token = 25 /* DotToken */ ;
                case 96 /* backtick */ :
                    return token = 62 /* BacktickToken */ ;
                case 35 /* hash */ :
                    return token = 63 /* HashToken */ ;
                case 92 /* backslash */ :
                    pos--;
                    const extendedCookedChar = peekExtendedUnicodeEscape();
                    if (extendedCookedChar >= 0 && isIdentifierStart(extendedCookedChar, languageVersion)) {
                        tokenValue = scanExtendedUnicodeEscape(/*shouldEmitInvalidEscapeError*/ true) + scanIdentifierParts();
                        return token = getIdentifierToken();
                    }
                    const cookedChar = peekUnicodeEscape();
                    if (cookedChar >= 0 && isIdentifierStart(cookedChar, languageVersion)) {
                        pos += 6;
                        tokenFlags |= 1024 /* UnicodeEscape */ ;
                        tokenValue = String.fromCharCode(cookedChar) + scanIdentifierParts();
                        return token = getIdentifierToken();
                    }
                    pos++;
                    return token = 0 /* Unknown */ ;
            }
            if (isIdentifierStart(ch, languageVersion)) {
                let char = ch;
                while(pos < end && isIdentifierPart(char = codePointUnchecked(pos), languageVersion) || char === 45 /* minus */ )pos += charSize(char);
                tokenValue = text.substring(tokenStart, pos);
                if (char === 92 /* backslash */ ) tokenValue += scanIdentifierParts();
                return token = getIdentifierToken();
            } else return token = 0 /* Unknown */ ;
        }
        function speculationHelper(callback, isLookahead) {
            const savePos = pos;
            const saveStartPos = fullStartPos;
            const saveTokenPos = tokenStart;
            const saveToken = token;
            const saveTokenValue = tokenValue;
            const saveTokenFlags = tokenFlags;
            const result = callback();
            if (!result || isLookahead) {
                pos = savePos;
                fullStartPos = saveStartPos;
                tokenStart = saveTokenPos;
                token = saveToken;
                tokenValue = saveTokenValue;
                tokenFlags = saveTokenFlags;
            }
            return result;
        }
        function scanRange(start2, length3, callback) {
            const saveEnd = end;
            const savePos = pos;
            const saveStartPos = fullStartPos;
            const saveTokenPos = tokenStart;
            const saveToken = token;
            const saveTokenValue = tokenValue;
            const saveTokenFlags = tokenFlags;
            const saveErrorExpectations = commentDirectives;
            setText(text, start2, length3);
            const result = callback();
            end = saveEnd;
            pos = savePos;
            fullStartPos = saveStartPos;
            tokenStart = saveTokenPos;
            token = saveToken;
            tokenValue = saveTokenValue;
            tokenFlags = saveTokenFlags;
            commentDirectives = saveErrorExpectations;
            return result;
        }
        function lookAhead(callback) {
            return speculationHelper(callback, /*isLookahead*/ true);
        }
        function tryScan(callback) {
            return speculationHelper(callback, /*isLookahead*/ false);
        }
        function getText() {
            return text;
        }
        function clearCommentDirectives() {
            commentDirectives = void 0;
        }
        function setText(newText, start2, length3) {
            text = newText || "";
            end = length3 === void 0 ? text.length : start2 + length3;
            resetTokenState(start2 || 0);
        }
        function setOnError(errorCallback) {
            onError = errorCallback;
        }
        function setScriptTarget(scriptTarget) {
            languageVersion = scriptTarget;
        }
        function setLanguageVariant(variant) {
            languageVariant = variant;
        }
        function setScriptKind(kind) {
            scriptKind = kind;
        }
        function setJSDocParsingMode(kind) {
            jsDocParsingMode = kind;
        }
        function resetTokenState(position) {
            Debug.assert(position >= 0);
            pos = position;
            fullStartPos = position;
            tokenStart = position;
            token = 0 /* Unknown */ ;
            tokenValue = void 0;
            tokenFlags = 0 /* None */ ;
        }
        function setSkipJsDocLeadingAsterisks(skip) {
            skipJsDocLeadingAsterisks += skip ? 1 : -1;
        }
    }
    function codePointAt(s, i) {
        return s.codePointAt(i);
    }
    function charSize(ch) {
        if (ch >= 65536) return 2;
        if (ch === -1 /* EOF */ ) return 0;
        return 1;
    }
    function utf16EncodeAsStringFallback(codePoint) {
        Debug.assert(0 <= codePoint && codePoint <= 1114111);
        if (codePoint <= 65535) return String.fromCharCode(codePoint);
        const codeUnit1 = Math.floor((codePoint - 65536) / 1024) + 55296;
        const codeUnit2 = (codePoint - 65536) % 1024 + 56320;
        return String.fromCharCode(codeUnit1, codeUnit2);
    }
    var utf16EncodeAsStringWorker = String.fromCodePoint ? (codePoint)=>String.fromCodePoint(codePoint) : utf16EncodeAsStringFallback;
    function utf16EncodeAsString(codePoint) {
        return utf16EncodeAsStringWorker(codePoint);
    }
    var nonBinaryUnicodeProperties = new Map(Object.entries({
        General_Category: "General_Category",
        gc: "General_Category",
        Script: "Script",
        sc: "Script",
        Script_Extensions: "Script_Extensions",
        scx: "Script_Extensions"
    }));
    var binaryUnicodeProperties = /* @__PURE__ */ new Set([
        "ASCII",
        "ASCII_Hex_Digit",
        "AHex",
        "Alphabetic",
        "Alpha",
        "Any",
        "Assigned",
        "Bidi_Control",
        "Bidi_C",
        "Bidi_Mirrored",
        "Bidi_M",
        "Case_Ignorable",
        "CI",
        "Cased",
        "Changes_When_Casefolded",
        "CWCF",
        "Changes_When_Casemapped",
        "CWCM",
        "Changes_When_Lowercased",
        "CWL",
        "Changes_When_NFKC_Casefolded",
        "CWKCF",
        "Changes_When_Titlecased",
        "CWT",
        "Changes_When_Uppercased",
        "CWU",
        "Dash",
        "Default_Ignorable_Code_Point",
        "DI",
        "Deprecated",
        "Dep",
        "Diacritic",
        "Dia",
        "Emoji",
        "Emoji_Component",
        "EComp",
        "Emoji_Modifier",
        "EMod",
        "Emoji_Modifier_Base",
        "EBase",
        "Emoji_Presentation",
        "EPres",
        "Extended_Pictographic",
        "ExtPict",
        "Extender",
        "Ext",
        "Grapheme_Base",
        "Gr_Base",
        "Grapheme_Extend",
        "Gr_Ext",
        "Hex_Digit",
        "Hex",
        "IDS_Binary_Operator",
        "IDSB",
        "IDS_Trinary_Operator",
        "IDST",
        "ID_Continue",
        "IDC",
        "ID_Start",
        "IDS",
        "Ideographic",
        "Ideo",
        "Join_Control",
        "Join_C",
        "Logical_Order_Exception",
        "LOE",
        "Lowercase",
        "Lower",
        "Math",
        "Noncharacter_Code_Point",
        "NChar",
        "Pattern_Syntax",
        "Pat_Syn",
        "Pattern_White_Space",
        "Pat_WS",
        "Quotation_Mark",
        "QMark",
        "Radical",
        "Regional_Indicator",
        "RI",
        "Sentence_Terminal",
        "STerm",
        "Soft_Dotted",
        "SD",
        "Terminal_Punctuation",
        "Term",
        "Unified_Ideograph",
        "UIdeo",
        "Uppercase",
        "Upper",
        "Variation_Selector",
        "VS",
        "White_Space",
        "space",
        "XID_Continue",
        "XIDC",
        "XID_Start",
        "XIDS"
    ]);
    var binaryUnicodePropertiesOfStrings = /* @__PURE__ */ new Set([
        "Basic_Emoji",
        "Emoji_Keycap_Sequence",
        "RGI_Emoji_Modifier_Sequence",
        "RGI_Emoji_Flag_Sequence",
        "RGI_Emoji_Tag_Sequence",
        "RGI_Emoji_ZWJ_Sequence",
        "RGI_Emoji"
    ]);
    var valuesOfNonBinaryUnicodeProperties = {
        General_Category: /* @__PURE__ */ new Set([
            "C",
            "Other",
            "Cc",
            "Control",
            "cntrl",
            "Cf",
            "Format",
            "Cn",
            "Unassigned",
            "Co",
            "Private_Use",
            "Cs",
            "Surrogate",
            "L",
            "Letter",
            "LC",
            "Cased_Letter",
            "Ll",
            "Lowercase_Letter",
            "Lm",
            "Modifier_Letter",
            "Lo",
            "Other_Letter",
            "Lt",
            "Titlecase_Letter",
            "Lu",
            "Uppercase_Letter",
            "M",
            "Mark",
            "Combining_Mark",
            "Mc",
            "Spacing_Mark",
            "Me",
            "Enclosing_Mark",
            "Mn",
            "Nonspacing_Mark",
            "N",
            "Number",
            "Nd",
            "Decimal_Number",
            "digit",
            "Nl",
            "Letter_Number",
            "No",
            "Other_Number",
            "P",
            "Punctuation",
            "punct",
            "Pc",
            "Connector_Punctuation",
            "Pd",
            "Dash_Punctuation",
            "Pe",
            "Close_Punctuation",
            "Pf",
            "Final_Punctuation",
            "Pi",
            "Initial_Punctuation",
            "Po",
            "Other_Punctuation",
            "Ps",
            "Open_Punctuation",
            "S",
            "Symbol",
            "Sc",
            "Currency_Symbol",
            "Sk",
            "Modifier_Symbol",
            "Sm",
            "Math_Symbol",
            "So",
            "Other_Symbol",
            "Z",
            "Separator",
            "Zl",
            "Line_Separator",
            "Zp",
            "Paragraph_Separator",
            "Zs",
            "Space_Separator"
        ]),
        Script: /* @__PURE__ */ new Set([
            "Adlm",
            "Adlam",
            "Aghb",
            "Caucasian_Albanian",
            "Ahom",
            "Arab",
            "Arabic",
            "Armi",
            "Imperial_Aramaic",
            "Armn",
            "Armenian",
            "Avst",
            "Avestan",
            "Bali",
            "Balinese",
            "Bamu",
            "Bamum",
            "Bass",
            "Bassa_Vah",
            "Batk",
            "Batak",
            "Beng",
            "Bengali",
            "Bhks",
            "Bhaiksuki",
            "Bopo",
            "Bopomofo",
            "Brah",
            "Brahmi",
            "Brai",
            "Braille",
            "Bugi",
            "Buginese",
            "Buhd",
            "Buhid",
            "Cakm",
            "Chakma",
            "Cans",
            "Canadian_Aboriginal",
            "Cari",
            "Carian",
            "Cham",
            "Cher",
            "Cherokee",
            "Chrs",
            "Chorasmian",
            "Copt",
            "Coptic",
            "Qaac",
            "Cpmn",
            "Cypro_Minoan",
            "Cprt",
            "Cypriot",
            "Cyrl",
            "Cyrillic",
            "Deva",
            "Devanagari",
            "Diak",
            "Dives_Akuru",
            "Dogr",
            "Dogra",
            "Dsrt",
            "Deseret",
            "Dupl",
            "Duployan",
            "Egyp",
            "Egyptian_Hieroglyphs",
            "Elba",
            "Elbasan",
            "Elym",
            "Elymaic",
            "Ethi",
            "Ethiopic",
            "Geor",
            "Georgian",
            "Glag",
            "Glagolitic",
            "Gong",
            "Gunjala_Gondi",
            "Gonm",
            "Masaram_Gondi",
            "Goth",
            "Gothic",
            "Gran",
            "Grantha",
            "Grek",
            "Greek",
            "Gujr",
            "Gujarati",
            "Guru",
            "Gurmukhi",
            "Hang",
            "Hangul",
            "Hani",
            "Han",
            "Hano",
            "Hanunoo",
            "Hatr",
            "Hatran",
            "Hebr",
            "Hebrew",
            "Hira",
            "Hiragana",
            "Hluw",
            "Anatolian_Hieroglyphs",
            "Hmng",
            "Pahawh_Hmong",
            "Hmnp",
            "Nyiakeng_Puachue_Hmong",
            "Hrkt",
            "Katakana_Or_Hiragana",
            "Hung",
            "Old_Hungarian",
            "Ital",
            "Old_Italic",
            "Java",
            "Javanese",
            "Kali",
            "Kayah_Li",
            "Kana",
            "Katakana",
            "Kawi",
            "Khar",
            "Kharoshthi",
            "Khmr",
            "Khmer",
            "Khoj",
            "Khojki",
            "Kits",
            "Khitan_Small_Script",
            "Knda",
            "Kannada",
            "Kthi",
            "Kaithi",
            "Lana",
            "Tai_Tham",
            "Laoo",
            "Lao",
            "Latn",
            "Latin",
            "Lepc",
            "Lepcha",
            "Limb",
            "Limbu",
            "Lina",
            "Linear_A",
            "Linb",
            "Linear_B",
            "Lisu",
            "Lyci",
            "Lycian",
            "Lydi",
            "Lydian",
            "Mahj",
            "Mahajani",
            "Maka",
            "Makasar",
            "Mand",
            "Mandaic",
            "Mani",
            "Manichaean",
            "Marc",
            "Marchen",
            "Medf",
            "Medefaidrin",
            "Mend",
            "Mende_Kikakui",
            "Merc",
            "Meroitic_Cursive",
            "Mero",
            "Meroitic_Hieroglyphs",
            "Mlym",
            "Malayalam",
            "Modi",
            "Mong",
            "Mongolian",
            "Mroo",
            "Mro",
            "Mtei",
            "Meetei_Mayek",
            "Mult",
            "Multani",
            "Mymr",
            "Myanmar",
            "Nagm",
            "Nag_Mundari",
            "Nand",
            "Nandinagari",
            "Narb",
            "Old_North_Arabian",
            "Nbat",
            "Nabataean",
            "Newa",
            "Nkoo",
            "Nko",
            "Nshu",
            "Nushu",
            "Ogam",
            "Ogham",
            "Olck",
            "Ol_Chiki",
            "Orkh",
            "Old_Turkic",
            "Orya",
            "Oriya",
            "Osge",
            "Osage",
            "Osma",
            "Osmanya",
            "Ougr",
            "Old_Uyghur",
            "Palm",
            "Palmyrene",
            "Pauc",
            "Pau_Cin_Hau",
            "Perm",
            "Old_Permic",
            "Phag",
            "Phags_Pa",
            "Phli",
            "Inscriptional_Pahlavi",
            "Phlp",
            "Psalter_Pahlavi",
            "Phnx",
            "Phoenician",
            "Plrd",
            "Miao",
            "Prti",
            "Inscriptional_Parthian",
            "Rjng",
            "Rejang",
            "Rohg",
            "Hanifi_Rohingya",
            "Runr",
            "Runic",
            "Samr",
            "Samaritan",
            "Sarb",
            "Old_South_Arabian",
            "Saur",
            "Saurashtra",
            "Sgnw",
            "SignWriting",
            "Shaw",
            "Shavian",
            "Shrd",
            "Sharada",
            "Sidd",
            "Siddham",
            "Sind",
            "Khudawadi",
            "Sinh",
            "Sinhala",
            "Sogd",
            "Sogdian",
            "Sogo",
            "Old_Sogdian",
            "Sora",
            "Sora_Sompeng",
            "Soyo",
            "Soyombo",
            "Sund",
            "Sundanese",
            "Sylo",
            "Syloti_Nagri",
            "Syrc",
            "Syriac",
            "Tagb",
            "Tagbanwa",
            "Takr",
            "Takri",
            "Tale",
            "Tai_Le",
            "Talu",
            "New_Tai_Lue",
            "Taml",
            "Tamil",
            "Tang",
            "Tangut",
            "Tavt",
            "Tai_Viet",
            "Telu",
            "Telugu",
            "Tfng",
            "Tifinagh",
            "Tglg",
            "Tagalog",
            "Thaa",
            "Thaana",
            "Thai",
            "Tibt",
            "Tibetan",
            "Tirh",
            "Tirhuta",
            "Tnsa",
            "Tangsa",
            "Toto",
            "Ugar",
            "Ugaritic",
            "Vaii",
            "Vai",
            "Vith",
            "Vithkuqi",
            "Wara",
            "Warang_Citi",
            "Wcho",
            "Wancho",
            "Xpeo",
            "Old_Persian",
            "Xsux",
            "Cuneiform",
            "Yezi",
            "Yezidi",
            "Yiii",
            "Yi",
            "Zanb",
            "Zanabazar_Square",
            "Zinh",
            "Inherited",
            "Qaai",
            "Zyyy",
            "Common",
            "Zzzz",
            "Unknown"
        ]),
        Script_Extensions: void 0
    };
    valuesOfNonBinaryUnicodeProperties.Script_Extensions = valuesOfNonBinaryUnicodeProperties.Script;
    // src/compiler/utilitiesPublic.ts
    function isExternalModuleNameRelative(moduleName) {
        return pathIsRelative(moduleName) || isRootedDiskPath(moduleName);
    }
    function sortAndDeduplicateDiagnostics(diagnostics) {
        return sortAndDeduplicate(diagnostics, compareDiagnostics, diagnosticsEqualityComparer);
    }
    var targetToLibMap = /* @__PURE__ */ new Map([
        [
            99 /* ESNext */ ,
            "lib.esnext.full.d.ts"
        ],
        [
            11 /* ES2024 */ ,
            "lib.es2024.full.d.ts"
        ],
        [
            10 /* ES2023 */ ,
            "lib.es2023.full.d.ts"
        ],
        [
            9 /* ES2022 */ ,
            "lib.es2022.full.d.ts"
        ],
        [
            8 /* ES2021 */ ,
            "lib.es2021.full.d.ts"
        ],
        [
            7 /* ES2020 */ ,
            "lib.es2020.full.d.ts"
        ],
        [
            6 /* ES2019 */ ,
            "lib.es2019.full.d.ts"
        ],
        [
            5 /* ES2018 */ ,
            "lib.es2018.full.d.ts"
        ],
        [
            4 /* ES2017 */ ,
            "lib.es2017.full.d.ts"
        ],
        [
            3 /* ES2016 */ ,
            "lib.es2016.full.d.ts"
        ],
        [
            2 /* ES2015 */ ,
            "lib.es6.d.ts"
        ]
    ]);
    function getDefaultLibFileName(options) {
        const target = getEmitScriptTarget(options);
        switch(target){
            case 99 /* ESNext */ :
            case 11 /* ES2024 */ :
            case 10 /* ES2023 */ :
            case 9 /* ES2022 */ :
            case 8 /* ES2021 */ :
            case 7 /* ES2020 */ :
            case 6 /* ES2019 */ :
            case 5 /* ES2018 */ :
            case 4 /* ES2017 */ :
            case 3 /* ES2016 */ :
            case 2 /* ES2015 */ :
                return targetToLibMap.get(target);
            default:
                return "lib.d.ts";
        }
    }
    function textSpanEnd(span) {
        return span.start + span.length;
    }
    function textSpanIsEmpty(span) {
        return span.length === 0;
    }
    function textSpanContainsPosition(span, position) {
        return position >= span.start && position < textSpanEnd(span);
    }
    function textRangeContainsPositionInclusive(range, position) {
        return position >= range.pos && position <= range.end;
    }
    function textSpanContainsTextSpan(span, other) {
        return other.start >= span.start && textSpanEnd(other) <= textSpanEnd(span);
    }
    function textSpanContainsTextRange(span, range) {
        return range.pos >= span.start && range.end <= textSpanEnd(span);
    }
    function textRangeContainsTextSpan(range, span) {
        return span.start >= range.pos && textSpanEnd(span) <= range.end;
    }
    function textSpanOverlapsWith(span, other) {
        return textSpanOverlap(span, other) !== void 0;
    }
    function textSpanOverlap(span1, span2) {
        const overlap = textSpanIntersection(span1, span2);
        return overlap && overlap.length === 0 ? void 0 : overlap;
    }
    function textSpanIntersectsWithTextSpan(span, other) {
        return decodedTextSpanIntersectsWith(span.start, span.length, other.start, other.length);
    }
    function textSpanIntersectsWith(span, start, length2) {
        return decodedTextSpanIntersectsWith(span.start, span.length, start, length2);
    }
    function decodedTextSpanIntersectsWith(start1, length1, start2, length2) {
        const end1 = start1 + length1;
        const end2 = start2 + length2;
        return start2 <= end1 && end2 >= start1;
    }
    function textSpanIntersectsWithPosition(span, position) {
        return position <= textSpanEnd(span) && position >= span.start;
    }
    function textRangeIntersectsWithTextSpan(range, span) {
        return textSpanIntersectsWith(span, range.pos, range.end - range.pos);
    }
    function textSpanIntersection(span1, span2) {
        const start = Math.max(span1.start, span2.start);
        const end = Math.min(textSpanEnd(span1), textSpanEnd(span2));
        return start <= end ? createTextSpanFromBounds(start, end) : void 0;
    }
    function normalizeSpans(spans) {
        spans = spans.filter((span)=>span.length > 0).sort((a, b)=>{
            return a.start !== b.start ? a.start - b.start : a.length - b.length;
        });
        const result = [];
        let i = 0;
        while(i < spans.length){
            let span = spans[i];
            let j = i + 1;
            while(j < spans.length && textSpanIntersectsWithTextSpan(span, spans[j])){
                const start = Math.min(span.start, spans[j].start);
                const end = Math.max(textSpanEnd(span), textSpanEnd(spans[j]));
                span = createTextSpanFromBounds(start, end);
                j++;
            }
            i = j;
            result.push(span);
        }
        return result;
    }
    function createTextSpan(start, length2) {
        if (start < 0) throw new Error("start < 0");
        if (length2 < 0) throw new Error("length < 0");
        return {
            start,
            length: length2
        };
    }
    function createTextSpanFromBounds(start, end) {
        return createTextSpan(start, end - start);
    }
    function textChangeRangeNewSpan(range) {
        return createTextSpan(range.span.start, range.newLength);
    }
    function textChangeRangeIsUnchanged(range) {
        return textSpanIsEmpty(range.span) && range.newLength === 0;
    }
    function createTextChangeRange(span, newLength) {
        if (newLength < 0) throw new Error("newLength < 0");
        return {
            span,
            newLength
        };
    }
    var unchangedTextChangeRange = createTextChangeRange(createTextSpan(0, 0), 0);
    function collapseTextChangeRangesAcrossMultipleVersions(changes) {
        if (changes.length === 0) return unchangedTextChangeRange;
        if (changes.length === 1) return changes[0];
        const change0 = changes[0];
        let oldStartN = change0.span.start;
        let oldEndN = textSpanEnd(change0.span);
        let newEndN = oldStartN + change0.newLength;
        for(let i = 1; i < changes.length; i++){
            const nextChange = changes[i];
            const oldStart1 = oldStartN;
            const oldEnd1 = oldEndN;
            const newEnd1 = newEndN;
            const oldStart2 = nextChange.span.start;
            const oldEnd2 = textSpanEnd(nextChange.span);
            const newEnd2 = oldStart2 + nextChange.newLength;
            oldStartN = Math.min(oldStart1, oldStart2);
            oldEndN = Math.max(oldEnd1, oldEnd1 + (oldEnd2 - newEnd1));
            newEndN = Math.max(newEnd2, newEnd2 + (newEnd1 - oldEnd2));
        }
        return createTextChangeRange(createTextSpanFromBounds(oldStartN, oldEndN), /*newLength*/ newEndN - oldStartN);
    }
    function getTypeParameterOwner(d) {
        if (d && d.kind === 169 /* TypeParameter */ ) for(let current = d; current; current = current.parent){
            if (isFunctionLike(current) || isClassLike(current) || current.kind === 265 /* InterfaceDeclaration */ ) return current;
        }
    }
    function isParameterPropertyDeclaration(node, parent2) {
        return isParameter(node) && hasSyntacticModifier(node, 31 /* ParameterPropertyModifier */ ) && parent2.kind === 177 /* Constructor */ ;
    }
    function isEmptyBindingPattern(node) {
        if (isBindingPattern(node)) return every(node.elements, isEmptyBindingElement);
        return false;
    }
    function isEmptyBindingElement(node) {
        if (isOmittedExpression(node)) return true;
        return isEmptyBindingPattern(node.name);
    }
    function walkUpBindingElementsAndPatterns(binding) {
        let node = binding.parent;
        while(isBindingElement(node.parent))node = node.parent.parent;
        return node.parent;
    }
    function getCombinedFlags(node, getFlags) {
        if (isBindingElement(node)) node = walkUpBindingElementsAndPatterns(node);
        let flags = getFlags(node);
        if (node.kind === 261 /* VariableDeclaration */ ) node = node.parent;
        if (node && node.kind === 262 /* VariableDeclarationList */ ) {
            flags |= getFlags(node);
            node = node.parent;
        }
        if (node && node.kind === 244 /* VariableStatement */ ) flags |= getFlags(node);
        return flags;
    }
    function getCombinedModifierFlags(node) {
        return getCombinedFlags(node, getEffectiveModifierFlags);
    }
    function getCombinedNodeFlagsAlwaysIncludeJSDoc(node) {
        return getCombinedFlags(node, getEffectiveModifierFlagsAlwaysIncludeJSDoc);
    }
    function getCombinedNodeFlags(node) {
        return getCombinedFlags(node, getNodeFlags);
    }
    function getNodeFlags(node) {
        return node.flags;
    }
    var supportedLocaleDirectories = [
        "cs",
        "de",
        "es",
        "fr",
        "it",
        "ja",
        "ko",
        "pl",
        "pt-br",
        "ru",
        "tr",
        "zh-cn",
        "zh-tw"
    ];
    function validateLocaleAndSetLanguage(locale, sys2, errors) {
        const lowerCaseLocale = locale.toLowerCase();
        const matchResult = /^([a-z]+)(?:[_-]([a-z]+))?$/.exec(lowerCaseLocale);
        if (!matchResult) {
            if (errors) errors.push(createCompilerDiagnostic(Diagnostics.Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1, "en", "ja-jp"));
            return;
        }
        const language = matchResult[1];
        const territory = matchResult[2];
        if (contains(supportedLocaleDirectories, lowerCaseLocale) && !trySetLanguageAndTerritory(language, territory, errors)) trySetLanguageAndTerritory(language, /*territory*/ void 0, errors);
        setUILocale(locale);
        function trySetLanguageAndTerritory(language2, territory2, errors2) {
            const compilerFilePath = normalizePath(sys2.getExecutingFilePath());
            const containingDirectoryPath = getDirectoryPath(compilerFilePath);
            let filePath = combinePaths(containingDirectoryPath, language2);
            if (territory2) filePath = filePath + "-" + territory2;
            filePath = sys2.resolvePath(combinePaths(filePath, "diagnosticMessages.generated.json"));
            if (!sys2.fileExists(filePath)) return false;
            let fileContents = "";
            try {
                fileContents = sys2.readFile(filePath);
            } catch (e) {
                if (errors2) errors2.push(createCompilerDiagnostic(Diagnostics.Unable_to_open_file_0, filePath));
                return false;
            }
            try {
                setLocalizedDiagnosticMessages(JSON.parse(fileContents));
            } catch (e) {
                if (errors2) errors2.push(createCompilerDiagnostic(Diagnostics.Corrupted_locale_file_0, filePath));
                return false;
            }
            return true;
        }
    }
    function getOriginalNode(node, nodeTest) {
        if (node) while(node.original !== void 0)node = node.original;
        if (!node || !nodeTest) return node;
        return nodeTest(node) ? node : void 0;
    }
    function findAncestor(node, callback) {
        while(node){
            const result = callback(node);
            if (result === "quit") return void 0;
            else if (result) return node;
            node = node.parent;
        }
        return void 0;
    }
    function isParseTreeNode(node) {
        return (node.flags & 16 /* Synthesized */ ) === 0;
    }
    function getParseTreeNode(node, nodeTest) {
        if (node === void 0 || isParseTreeNode(node)) return node;
        node = node.original;
        while(node){
            if (isParseTreeNode(node)) return !nodeTest || nodeTest(node) ? node : void 0;
            node = node.original;
        }
    }
    function escapeLeadingUnderscores(identifier) {
        return identifier.length >= 2 && identifier.charCodeAt(0) === 95 /* _ */  && identifier.charCodeAt(1) === 95 /* _ */  ? "_" + identifier : identifier;
    }
    function unescapeLeadingUnderscores(identifier) {
        const id = identifier;
        return id.length >= 3 && id.charCodeAt(0) === 95 /* _ */  && id.charCodeAt(1) === 95 /* _ */  && id.charCodeAt(2) === 95 /* _ */  ? id.substr(1) : id;
    }
    function idText(identifierOrPrivateName) {
        return unescapeLeadingUnderscores(identifierOrPrivateName.escapedText);
    }
    function identifierToKeywordKind(node) {
        const token = stringToToken(node.escapedText);
        return token ? tryCast(token, isKeyword) : void 0;
    }
    function symbolName(symbol) {
        if (symbol.valueDeclaration && isPrivateIdentifierClassElementDeclaration(symbol.valueDeclaration)) return idText(symbol.valueDeclaration.name);
        return unescapeLeadingUnderscores(symbol.escapedName);
    }
    function nameForNamelessJSDocTypedef(declaration) {
        const hostNode = declaration.parent.parent;
        if (!hostNode) return void 0;
        if (isDeclaration(hostNode)) return getDeclarationIdentifier(hostNode);
        switch(hostNode.kind){
            case 244 /* VariableStatement */ :
                if (hostNode.declarationList && hostNode.declarationList.declarations[0]) return getDeclarationIdentifier(hostNode.declarationList.declarations[0]);
                break;
            case 245 /* ExpressionStatement */ :
                let expr = hostNode.expression;
                if (expr.kind === 227 /* BinaryExpression */  && expr.operatorToken.kind === 64 /* EqualsToken */ ) expr = expr.left;
                switch(expr.kind){
                    case 212 /* PropertyAccessExpression */ :
                        return expr.name;
                    case 213 /* ElementAccessExpression */ :
                        const arg = expr.argumentExpression;
                        if (isIdentifier(arg)) return arg;
                }
                break;
            case 218 /* ParenthesizedExpression */ :
                return getDeclarationIdentifier(hostNode.expression);
            case 257 /* LabeledStatement */ :
                if (isDeclaration(hostNode.statement) || isExpression(hostNode.statement)) return getDeclarationIdentifier(hostNode.statement);
                break;
        }
    }
    function getDeclarationIdentifier(node) {
        const name = getNameOfDeclaration(node);
        return name && isIdentifier(name) ? name : void 0;
    }
    function nodeHasName(statement, name) {
        if (isNamedDeclaration(statement) && isIdentifier(statement.name) && idText(statement.name) === idText(name)) return true;
        if (isVariableStatement(statement) && some(statement.declarationList.declarations, (d)=>nodeHasName(d, name))) return true;
        return false;
    }
    function getNameOfJSDocTypedef(declaration) {
        return declaration.name || nameForNamelessJSDocTypedef(declaration);
    }
    function isNamedDeclaration(node) {
        return !!node.name;
    }
    function getNonAssignedNameOfDeclaration(declaration) {
        switch(declaration.kind){
            case 80 /* Identifier */ :
                return declaration;
            case 349 /* JSDocPropertyTag */ :
            case 342 /* JSDocParameterTag */ :
                {
                    const { name } = declaration;
                    if (name.kind === 167 /* QualifiedName */ ) return name.right;
                    break;
                }
            case 214 /* CallExpression */ :
            case 227 /* BinaryExpression */ :
                {
                    const expr2 = declaration;
                    switch(getAssignmentDeclarationKind(expr2)){
                        case 1 /* ExportsProperty */ :
                        case 4 /* ThisProperty */ :
                        case 5 /* Property */ :
                        case 3 /* PrototypeProperty */ :
                            return getElementOrPropertyAccessArgumentExpressionOrName(expr2.left);
                        case 7 /* ObjectDefinePropertyValue */ :
                        case 8 /* ObjectDefinePropertyExports */ :
                        case 9 /* ObjectDefinePrototypeProperty */ :
                            return expr2.arguments[1];
                        default:
                            return void 0;
                    }
                }
            case 347 /* JSDocTypedefTag */ :
                return getNameOfJSDocTypedef(declaration);
            case 341 /* JSDocEnumTag */ :
                return nameForNamelessJSDocTypedef(declaration);
            case 278 /* ExportAssignment */ :
                {
                    const { expression } = declaration;
                    return isIdentifier(expression) ? expression : void 0;
                }
            case 213 /* ElementAccessExpression */ :
                const expr = declaration;
                if (isBindableStaticElementAccessExpression(expr)) return expr.argumentExpression;
        }
        return declaration.name;
    }
    function getNameOfDeclaration(declaration) {
        if (declaration === void 0) return void 0;
        return getNonAssignedNameOfDeclaration(declaration) || (isFunctionExpression(declaration) || isArrowFunction(declaration) || isClassExpression(declaration) ? getAssignedName(declaration) : void 0);
    }
    function getAssignedName(node) {
        if (!node.parent) return void 0;
        else if (isPropertyAssignment(node.parent) || isBindingElement(node.parent)) return node.parent.name;
        else if (isBinaryExpression(node.parent) && node === node.parent.right) {
            if (isIdentifier(node.parent.left)) return node.parent.left;
            else if (isAccessExpression(node.parent.left)) return getElementOrPropertyAccessArgumentExpressionOrName(node.parent.left);
        } else if (isVariableDeclaration(node.parent) && isIdentifier(node.parent.name)) return node.parent.name;
    }
    function getDecorators(node) {
        if (hasDecorators(node)) return filter(node.modifiers, isDecorator);
    }
    function getModifiers(node) {
        if (hasSyntacticModifier(node, 98303 /* Modifier */ )) return filter(node.modifiers, isModifier);
    }
    function getJSDocParameterTagsWorker(param, noCache) {
        if (param.name) {
            if (isIdentifier(param.name)) {
                const name = param.name.escapedText;
                return getJSDocTagsWorker(param.parent, noCache).filter((tag)=>isJSDocParameterTag(tag) && isIdentifier(tag.name) && tag.name.escapedText === name);
            } else {
                const i = param.parent.parameters.indexOf(param);
                Debug.assert(i > -1, "Parameters should always be in their parents' parameter list");
                const paramTags = getJSDocTagsWorker(param.parent, noCache).filter(isJSDocParameterTag);
                if (i < paramTags.length) return [
                    paramTags[i]
                ];
            }
        }
        return emptyArray;
    }
    function getJSDocParameterTags(param) {
        return getJSDocParameterTagsWorker(param, /*noCache*/ false);
    }
    function getJSDocParameterTagsNoCache(param) {
        return getJSDocParameterTagsWorker(param, /*noCache*/ true);
    }
    function getJSDocTypeParameterTagsWorker(param, noCache) {
        const name = param.name.escapedText;
        return getJSDocTagsWorker(param.parent, noCache).filter((tag)=>isJSDocTemplateTag(tag) && tag.typeParameters.some((tp)=>tp.name.escapedText === name));
    }
    function getJSDocTypeParameterTags(param) {
        return getJSDocTypeParameterTagsWorker(param, /*noCache*/ false);
    }
    function getJSDocTypeParameterTagsNoCache(param) {
        return getJSDocTypeParameterTagsWorker(param, /*noCache*/ true);
    }
    function hasJSDocParameterTags(node) {
        return !!getFirstJSDocTag(node, isJSDocParameterTag);
    }
    function getJSDocAugmentsTag(node) {
        return getFirstJSDocTag(node, isJSDocAugmentsTag);
    }
    function getJSDocImplementsTags(node) {
        return getAllJSDocTags(node, isJSDocImplementsTag);
    }
    function getJSDocClassTag(node) {
        return getFirstJSDocTag(node, isJSDocClassTag);
    }
    function getJSDocPublicTag(node) {
        return getFirstJSDocTag(node, isJSDocPublicTag);
    }
    function getJSDocPublicTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocPublicTag, /*noCache*/ true);
    }
    function getJSDocPrivateTag(node) {
        return getFirstJSDocTag(node, isJSDocPrivateTag);
    }
    function getJSDocPrivateTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocPrivateTag, /*noCache*/ true);
    }
    function getJSDocProtectedTag(node) {
        return getFirstJSDocTag(node, isJSDocProtectedTag);
    }
    function getJSDocProtectedTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocProtectedTag, /*noCache*/ true);
    }
    function getJSDocReadonlyTag(node) {
        return getFirstJSDocTag(node, isJSDocReadonlyTag);
    }
    function getJSDocReadonlyTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocReadonlyTag, /*noCache*/ true);
    }
    function getJSDocOverrideTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocOverrideTag, /*noCache*/ true);
    }
    function getJSDocDeprecatedTag(node) {
        return getFirstJSDocTag(node, isJSDocDeprecatedTag);
    }
    function getJSDocDeprecatedTagNoCache(node) {
        return getFirstJSDocTag(node, isJSDocDeprecatedTag, /*noCache*/ true);
    }
    function getJSDocEnumTag(node) {
        return getFirstJSDocTag(node, isJSDocEnumTag);
    }
    function getJSDocThisTag(node) {
        return getFirstJSDocTag(node, isJSDocThisTag);
    }
    function getJSDocReturnTag(node) {
        return getFirstJSDocTag(node, isJSDocReturnTag);
    }
    function getJSDocTemplateTag(node) {
        return getFirstJSDocTag(node, isJSDocTemplateTag);
    }
    function getJSDocSatisfiesTag(node) {
        return getFirstJSDocTag(node, isJSDocSatisfiesTag);
    }
    function getJSDocTypeTag(node) {
        const tag = getFirstJSDocTag(node, isJSDocTypeTag);
        if (tag && tag.typeExpression && tag.typeExpression.type) return tag;
        return void 0;
    }
    function getJSDocType(node) {
        let tag = getFirstJSDocTag(node, isJSDocTypeTag);
        if (!tag && isParameter(node)) tag = find(getJSDocParameterTags(node), (tag2)=>!!tag2.typeExpression);
        return tag && tag.typeExpression && tag.typeExpression.type;
    }
    function getJSDocReturnType(node) {
        const returnTag = getJSDocReturnTag(node);
        if (returnTag && returnTag.typeExpression) return returnTag.typeExpression.type;
        const typeTag = getJSDocTypeTag(node);
        if (typeTag && typeTag.typeExpression) {
            const type = typeTag.typeExpression.type;
            if (isTypeLiteralNode(type)) {
                const sig = find(type.members, isCallSignatureDeclaration);
                return sig && sig.type;
            }
            if (isFunctionTypeNode(type) || isJSDocFunctionType(type)) return type.type;
        }
    }
    function getJSDocTagsWorker(node, noCache) {
        var _a;
        if (!canHaveJSDoc(node)) return emptyArray;
        let tags = (_a = node.jsDoc) == null ? void 0 : _a.jsDocCache;
        if (tags === void 0 || noCache) {
            const comments = getJSDocCommentsAndTags(node, noCache);
            Debug.assert(comments.length < 2 || comments[0] !== comments[1]);
            tags = flatMap(comments, (j)=>isJSDoc(j) ? j.tags : j);
            if (!noCache) {
                var _node_jsDoc;
                (_node_jsDoc = node.jsDoc) !== null && _node_jsDoc !== void 0 ? _node_jsDoc : node.jsDoc = [];
                node.jsDoc.jsDocCache = tags;
            }
        }
        return tags;
    }
    function getJSDocTags(node) {
        return getJSDocTagsWorker(node, /*noCache*/ false);
    }
    function getFirstJSDocTag(node, predicate, noCache) {
        return find(getJSDocTagsWorker(node, noCache), predicate);
    }
    function getAllJSDocTags(node, predicate) {
        return getJSDocTags(node).filter(predicate);
    }
    function getAllJSDocTagsOfKind(node, kind) {
        return getJSDocTags(node).filter((doc)=>doc.kind === kind);
    }
    function getTextOfJSDocComment(comment) {
        return typeof comment === "string" ? comment : comment == null ? void 0 : comment.map((c)=>c.kind === 322 /* JSDocText */  ? c.text : formatJSDocLink(c)).join("");
    }
    function formatJSDocLink(link) {
        const kind = link.kind === 325 /* JSDocLink */  ? "link" : link.kind === 326 /* JSDocLinkCode */  ? "linkcode" : "linkplain";
        const name = link.name ? entityNameToString(link.name) : "";
        const space = link.name && (link.text === "" || link.text.startsWith("://")) ? "" : " ";
        return `{@${kind} ${name}${space}${link.text}}`;
    }
    function getEffectiveTypeParameterDeclarations(node) {
        if (isJSDocSignature(node)) {
            if (isJSDocOverloadTag(node.parent)) {
                const jsDoc = getJSDocRoot(node.parent);
                if (jsDoc && length(jsDoc.tags)) return flatMap(jsDoc.tags, (tag)=>isJSDocTemplateTag(tag) ? tag.typeParameters : void 0);
            }
            return emptyArray;
        }
        if (isJSDocTypeAlias(node)) {
            Debug.assert(node.parent.kind === 321 /* JSDoc */ );
            return flatMap(node.parent.tags, (tag)=>isJSDocTemplateTag(tag) ? tag.typeParameters : void 0);
        }
        if (node.typeParameters) return node.typeParameters;
        if (canHaveIllegalTypeParameters(node) && node.typeParameters) return node.typeParameters;
        if (isInJSFile(node)) {
            const decls = getJSDocTypeParameterDeclarations(node);
            if (decls.length) return decls;
            const typeTag = getJSDocType(node);
            if (typeTag && isFunctionTypeNode(typeTag) && typeTag.typeParameters) return typeTag.typeParameters;
        }
        return emptyArray;
    }
    function getEffectiveConstraintOfTypeParameter(node) {
        return node.constraint ? node.constraint : isJSDocTemplateTag(node.parent) && node === node.parent.typeParameters[0] ? node.parent.constraint : void 0;
    }
    function isMemberName(node) {
        return node.kind === 80 /* Identifier */  || node.kind === 81 /* PrivateIdentifier */ ;
    }
    function isGetOrSetAccessorDeclaration(node) {
        return node.kind === 179 /* SetAccessor */  || node.kind === 178 /* GetAccessor */ ;
    }
    function isPropertyAccessChain(node) {
        return isPropertyAccessExpression(node) && !!(node.flags & 64 /* OptionalChain */ );
    }
    function isElementAccessChain(node) {
        return isElementAccessExpression(node) && !!(node.flags & 64 /* OptionalChain */ );
    }
    function isCallChain(node) {
        return isCallExpression(node) && !!(node.flags & 64 /* OptionalChain */ );
    }
    function isOptionalChain(node) {
        const kind = node.kind;
        return !!(node.flags & 64 /* OptionalChain */ ) && (kind === 212 /* PropertyAccessExpression */  || kind === 213 /* ElementAccessExpression */  || kind === 214 /* CallExpression */  || kind === 236 /* NonNullExpression */ );
    }
    function isOptionalChainRoot(node) {
        return isOptionalChain(node) && !isNonNullExpression(node) && !!node.questionDotToken;
    }
    function isExpressionOfOptionalChainRoot(node) {
        return isOptionalChainRoot(node.parent) && node.parent.expression === node;
    }
    function isOutermostOptionalChain(node) {
        return !isOptionalChain(node.parent) || isOptionalChainRoot(node.parent) || node !== node.parent.expression;
    }
    function isNullishCoalesce(node) {
        return node.kind === 227 /* BinaryExpression */  && node.operatorToken.kind === 61 /* QuestionQuestionToken */ ;
    }
    function isConstTypeReference(node) {
        return isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "const" && !node.typeArguments;
    }
    function skipPartiallyEmittedExpressions(node) {
        return skipOuterExpressions(node, 8 /* PartiallyEmittedExpressions */ );
    }
    function isNonNullChain(node) {
        return isNonNullExpression(node) && !!(node.flags & 64 /* OptionalChain */ );
    }
    function isBreakOrContinueStatement(node) {
        return node.kind === 253 /* BreakStatement */  || node.kind === 252 /* ContinueStatement */ ;
    }
    function isNamedExportBindings(node) {
        return node.kind === 281 /* NamespaceExport */  || node.kind === 280 /* NamedExports */ ;
    }
    function isJSDocPropertyLikeTag(node) {
        return node.kind === 349 /* JSDocPropertyTag */  || node.kind === 342 /* JSDocParameterTag */ ;
    }
    function isNodeKind(kind) {
        return kind >= 167 /* FirstNode */ ;
    }
    function isTokenKind(kind) {
        return kind >= 0 /* FirstToken */  && kind <= 166 /* LastToken */ ;
    }
    function isToken(n) {
        return isTokenKind(n.kind);
    }
    function isNodeArray(array) {
        return hasProperty(array, "pos") && hasProperty(array, "end");
    }
    function isLiteralKind(kind) {
        return 9 /* FirstLiteralToken */  <= kind && kind <= 15 /* LastLiteralToken */ ;
    }
    function isLiteralExpression(node) {
        return isLiteralKind(node.kind);
    }
    function isLiteralExpressionOfObject(node) {
        switch(node.kind){
            case 211 /* ObjectLiteralExpression */ :
            case 210 /* ArrayLiteralExpression */ :
            case 14 /* RegularExpressionLiteral */ :
            case 219 /* FunctionExpression */ :
            case 232 /* ClassExpression */ :
                return true;
        }
        return false;
    }
    function isTemplateLiteralKind(kind) {
        return 15 /* FirstTemplateToken */  <= kind && kind <= 18 /* LastTemplateToken */ ;
    }
    function isTemplateLiteralToken(node) {
        return isTemplateLiteralKind(node.kind);
    }
    function isTemplateMiddleOrTemplateTail(node) {
        const kind = node.kind;
        return kind === 17 /* TemplateMiddle */  || kind === 18 /* TemplateTail */ ;
    }
    function isImportOrExportSpecifier(node) {
        return isImportSpecifier(node) || isExportSpecifier(node);
    }
    function isTypeOnlyImportDeclaration(node) {
        switch(node.kind){
            case 277 /* ImportSpecifier */ :
                return node.isTypeOnly || node.parent.parent.phaseModifier === 156 /* TypeKeyword */ ;
            case 275 /* NamespaceImport */ :
                return node.parent.phaseModifier === 156 /* TypeKeyword */ ;
            case 274 /* ImportClause */ :
                return node.phaseModifier === 156 /* TypeKeyword */ ;
            case 272 /* ImportEqualsDeclaration */ :
                return node.isTypeOnly;
        }
        return false;
    }
    function isTypeOnlyExportDeclaration(node) {
        switch(node.kind){
            case 282 /* ExportSpecifier */ :
                return node.isTypeOnly || node.parent.parent.isTypeOnly;
            case 279 /* ExportDeclaration */ :
                return node.isTypeOnly && !!node.moduleSpecifier && !node.exportClause;
            case 281 /* NamespaceExport */ :
                return node.parent.isTypeOnly;
        }
        return false;
    }
    function isTypeOnlyImportOrExportDeclaration(node) {
        return isTypeOnlyImportDeclaration(node) || isTypeOnlyExportDeclaration(node);
    }
    function isPartOfTypeOnlyImportOrExportDeclaration(node) {
        return findAncestor(node, isTypeOnlyImportOrExportDeclaration) !== void 0;
    }
    function isStringTextContainingNode(node) {
        return node.kind === 11 /* StringLiteral */  || isTemplateLiteralKind(node.kind);
    }
    function isImportAttributeName(node) {
        return isStringLiteral(node) || isIdentifier(node);
    }
    function isGeneratedIdentifier(node) {
        var _a;
        return isIdentifier(node) && ((_a = node.emitNode) == null ? void 0 : _a.autoGenerate) !== void 0;
    }
    function isGeneratedPrivateIdentifier(node) {
        var _a;
        return isPrivateIdentifier(node) && ((_a = node.emitNode) == null ? void 0 : _a.autoGenerate) !== void 0;
    }
    function isFileLevelReservedGeneratedIdentifier(node) {
        const flags = node.emitNode.autoGenerate.flags;
        return !!(flags & 32 /* FileLevel */ ) && !!(flags & 16 /* Optimistic */ ) && !!(flags & 8 /* ReservedInNestedScopes */ );
    }
    function isPrivateIdentifierClassElementDeclaration(node) {
        return (isPropertyDeclaration(node) || isMethodOrAccessor(node)) && isPrivateIdentifier(node.name);
    }
    function isPrivateIdentifierPropertyAccessExpression(node) {
        return isPropertyAccessExpression(node) && isPrivateIdentifier(node.name);
    }
    function isModifierKind(token) {
        switch(token){
            case 128 /* AbstractKeyword */ :
            case 129 /* AccessorKeyword */ :
            case 134 /* AsyncKeyword */ :
            case 87 /* ConstKeyword */ :
            case 138 /* DeclareKeyword */ :
            case 90 /* DefaultKeyword */ :
            case 95 /* ExportKeyword */ :
            case 103 /* InKeyword */ :
            case 125 /* PublicKeyword */ :
            case 123 /* PrivateKeyword */ :
            case 124 /* ProtectedKeyword */ :
            case 148 /* ReadonlyKeyword */ :
            case 126 /* StaticKeyword */ :
            case 147 /* OutKeyword */ :
            case 164 /* OverrideKeyword */ :
                return true;
        }
        return false;
    }
    function isParameterPropertyModifier(kind) {
        return !!(modifierToFlag(kind) & 31 /* ParameterPropertyModifier */ );
    }
    function isClassMemberModifier(idToken) {
        return isParameterPropertyModifier(idToken) || idToken === 126 /* StaticKeyword */  || idToken === 164 /* OverrideKeyword */  || idToken === 129 /* AccessorKeyword */ ;
    }
    function isModifier(node) {
        return isModifierKind(node.kind);
    }
    function isEntityName(node) {
        const kind = node.kind;
        return kind === 167 /* QualifiedName */  || kind === 80 /* Identifier */ ;
    }
    function isPropertyName(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 81 /* PrivateIdentifier */  || kind === 11 /* StringLiteral */  || kind === 9 /* NumericLiteral */  || kind === 168 /* ComputedPropertyName */ ;
    }
    function isBindingName(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 207 /* ObjectBindingPattern */  || kind === 208 /* ArrayBindingPattern */ ;
    }
    function isFunctionLike(node) {
        return !!node && isFunctionLikeKind(node.kind);
    }
    function isFunctionLikeOrClassStaticBlockDeclaration(node) {
        return !!node && (isFunctionLikeKind(node.kind) || isClassStaticBlockDeclaration(node));
    }
    function isFunctionLikeDeclaration(node) {
        return node && isFunctionLikeDeclarationKind(node.kind);
    }
    function isBooleanLiteral(node) {
        return node.kind === 112 /* TrueKeyword */  || node.kind === 97 /* FalseKeyword */ ;
    }
    function isFunctionLikeDeclarationKind(kind) {
        switch(kind){
            case 263 /* FunctionDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 177 /* Constructor */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return true;
            default:
                return false;
        }
    }
    function isFunctionLikeKind(kind) {
        switch(kind){
            case 174 /* MethodSignature */ :
            case 180 /* CallSignature */ :
            case 324 /* JSDocSignature */ :
            case 181 /* ConstructSignature */ :
            case 182 /* IndexSignature */ :
            case 185 /* FunctionType */ :
            case 318 /* JSDocFunctionType */ :
            case 186 /* ConstructorType */ :
                return true;
            default:
                return isFunctionLikeDeclarationKind(kind);
        }
    }
    function isFunctionOrModuleBlock(node) {
        return isSourceFile(node) || isModuleBlock(node) || isBlock(node) && isFunctionLike(node.parent);
    }
    function isClassElement(node) {
        const kind = node.kind;
        return kind === 177 /* Constructor */  || kind === 173 /* PropertyDeclaration */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */  || kind === 182 /* IndexSignature */  || kind === 176 /* ClassStaticBlockDeclaration */  || kind === 241 /* SemicolonClassElement */ ;
    }
    function isClassLike(node) {
        return node && (node.kind === 264 /* ClassDeclaration */  || node.kind === 232 /* ClassExpression */ );
    }
    function isAccessor(node) {
        return node && (node.kind === 178 /* GetAccessor */  || node.kind === 179 /* SetAccessor */ );
    }
    function isAutoAccessorPropertyDeclaration(node) {
        return isPropertyDeclaration(node) && hasAccessorModifier(node);
    }
    function isClassInstanceProperty(node) {
        if (isInJSFile(node) && isExpandoPropertyDeclaration(node)) return (!isBindableStaticAccessExpression(node) || !isPrototypeAccess(node.expression)) && !isBindableStaticNameExpression(node, /*excludeThisKeyword*/ true);
        return node.parent && isClassLike(node.parent) && isPropertyDeclaration(node) && !hasAccessorModifier(node);
    }
    function isMethodOrAccessor(node) {
        switch(node.kind){
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return true;
            default:
                return false;
        }
    }
    function isModifierLike(node) {
        return isModifier(node) || isDecorator(node);
    }
    function isTypeElement(node) {
        const kind = node.kind;
        return kind === 181 /* ConstructSignature */  || kind === 180 /* CallSignature */  || kind === 172 /* PropertySignature */  || kind === 174 /* MethodSignature */  || kind === 182 /* IndexSignature */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */  || kind === 355 /* NotEmittedTypeElement */ ;
    }
    function isClassOrTypeElement(node) {
        return isTypeElement(node) || isClassElement(node);
    }
    function isObjectLiteralElementLike(node) {
        const kind = node.kind;
        return kind === 304 /* PropertyAssignment */  || kind === 305 /* ShorthandPropertyAssignment */  || kind === 306 /* SpreadAssignment */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */ ;
    }
    function isTypeNode(node) {
        return isTypeNodeKind(node.kind);
    }
    function isFunctionOrConstructorTypeNode(node) {
        switch(node.kind){
            case 185 /* FunctionType */ :
            case 186 /* ConstructorType */ :
                return true;
        }
        return false;
    }
    function isBindingPattern(node) {
        if (node) {
            const kind = node.kind;
            return kind === 208 /* ArrayBindingPattern */  || kind === 207 /* ObjectBindingPattern */ ;
        }
        return false;
    }
    function isAssignmentPattern(node) {
        const kind = node.kind;
        return kind === 210 /* ArrayLiteralExpression */  || kind === 211 /* ObjectLiteralExpression */ ;
    }
    function isArrayBindingElement(node) {
        const kind = node.kind;
        return kind === 209 /* BindingElement */  || kind === 233 /* OmittedExpression */ ;
    }
    function isDeclarationBindingElement(bindingElement) {
        switch(bindingElement.kind){
            case 261 /* VariableDeclaration */ :
            case 170 /* Parameter */ :
            case 209 /* BindingElement */ :
                return true;
        }
        return false;
    }
    function isBindingOrAssignmentElement(node) {
        return isVariableDeclaration(node) || isParameter(node) || isObjectBindingOrAssignmentElement(node) || isArrayBindingOrAssignmentElement(node);
    }
    function isBindingOrAssignmentPattern(node) {
        return isObjectBindingOrAssignmentPattern(node) || isArrayBindingOrAssignmentPattern(node);
    }
    function isObjectBindingOrAssignmentPattern(node) {
        switch(node.kind){
            case 207 /* ObjectBindingPattern */ :
            case 211 /* ObjectLiteralExpression */ :
                return true;
        }
        return false;
    }
    function isObjectBindingOrAssignmentElement(node) {
        switch(node.kind){
            case 209 /* BindingElement */ :
            case 304 /* PropertyAssignment */ :
            // AssignmentProperty
            case 305 /* ShorthandPropertyAssignment */ :
            // AssignmentProperty
            case 306 /* SpreadAssignment */ :
                return true;
        }
        return false;
    }
    function isArrayBindingOrAssignmentPattern(node) {
        switch(node.kind){
            case 208 /* ArrayBindingPattern */ :
            case 210 /* ArrayLiteralExpression */ :
                return true;
        }
        return false;
    }
    function isArrayBindingOrAssignmentElement(node) {
        switch(node.kind){
            case 209 /* BindingElement */ :
            case 233 /* OmittedExpression */ :
            // Elision
            case 231 /* SpreadElement */ :
            // AssignmentRestElement
            case 210 /* ArrayLiteralExpression */ :
            // ArrayAssignmentPattern
            case 211 /* ObjectLiteralExpression */ :
            // ObjectAssignmentPattern
            case 80 /* Identifier */ :
            // DestructuringAssignmentTarget
            case 212 /* PropertyAccessExpression */ :
            // DestructuringAssignmentTarget
            case 213 /* ElementAccessExpression */ :
                return true;
        }
        return isAssignmentExpression(node, /*excludeCompoundAssignment*/ true);
    }
    function isPropertyAccessOrQualifiedNameOrImportTypeNode(node) {
        const kind = node.kind;
        return kind === 212 /* PropertyAccessExpression */  || kind === 167 /* QualifiedName */  || kind === 206 /* ImportType */ ;
    }
    function isPropertyAccessOrQualifiedName(node) {
        const kind = node.kind;
        return kind === 212 /* PropertyAccessExpression */  || kind === 167 /* QualifiedName */ ;
    }
    function isCallLikeOrFunctionLikeExpression(node) {
        return isCallLikeExpression(node) || isFunctionExpressionOrArrowFunction(node);
    }
    function isCallLikeExpression(node) {
        switch(node.kind){
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
            case 216 /* TaggedTemplateExpression */ :
            case 171 /* Decorator */ :
            case 287 /* JsxOpeningElement */ :
            case 286 /* JsxSelfClosingElement */ :
            case 290 /* JsxOpeningFragment */ :
                return true;
            case 227 /* BinaryExpression */ :
                return node.operatorToken.kind === 104 /* InstanceOfKeyword */ ;
            default:
                return false;
        }
    }
    function isCallOrNewExpression(node) {
        return node.kind === 214 /* CallExpression */  || node.kind === 215 /* NewExpression */ ;
    }
    function isTemplateLiteral(node) {
        const kind = node.kind;
        return kind === 229 /* TemplateExpression */  || kind === 15 /* NoSubstitutionTemplateLiteral */ ;
    }
    function isLeftHandSideExpression(node) {
        return isLeftHandSideExpressionKind(skipPartiallyEmittedExpressions(node).kind);
    }
    function isLeftHandSideExpressionKind(kind) {
        switch(kind){
            case 212 /* PropertyAccessExpression */ :
            case 213 /* ElementAccessExpression */ :
            case 215 /* NewExpression */ :
            case 214 /* CallExpression */ :
            case 285 /* JsxElement */ :
            case 286 /* JsxSelfClosingElement */ :
            case 289 /* JsxFragment */ :
            case 216 /* TaggedTemplateExpression */ :
            case 210 /* ArrayLiteralExpression */ :
            case 218 /* ParenthesizedExpression */ :
            case 211 /* ObjectLiteralExpression */ :
            case 232 /* ClassExpression */ :
            case 219 /* FunctionExpression */ :
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
            // technically this is only an Expression if it's in a `#field in expr` BinaryExpression
            case 14 /* RegularExpressionLiteral */ :
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 229 /* TemplateExpression */ :
            case 97 /* FalseKeyword */ :
            case 106 /* NullKeyword */ :
            case 110 /* ThisKeyword */ :
            case 112 /* TrueKeyword */ :
            case 108 /* SuperKeyword */ :
            case 236 /* NonNullExpression */ :
            case 234 /* ExpressionWithTypeArguments */ :
            case 237 /* MetaProperty */ :
            case 102 /* ImportKeyword */ :
            // technically this is only an Expression if it's in a CallExpression
            case 283 /* MissingDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isUnaryExpression(node) {
        return isUnaryExpressionKind(skipPartiallyEmittedExpressions(node).kind);
    }
    function isUnaryExpressionKind(kind) {
        switch(kind){
            case 225 /* PrefixUnaryExpression */ :
            case 226 /* PostfixUnaryExpression */ :
            case 221 /* DeleteExpression */ :
            case 222 /* TypeOfExpression */ :
            case 223 /* VoidExpression */ :
            case 224 /* AwaitExpression */ :
            case 217 /* TypeAssertionExpression */ :
                return true;
            default:
                return isLeftHandSideExpressionKind(kind);
        }
    }
    function isUnaryExpressionWithWrite(expr) {
        switch(expr.kind){
            case 226 /* PostfixUnaryExpression */ :
                return true;
            case 225 /* PrefixUnaryExpression */ :
                return expr.operator === 46 /* PlusPlusToken */  || expr.operator === 47 /* MinusMinusToken */ ;
            default:
                return false;
        }
    }
    function isLiteralTypeLiteral(node) {
        switch(node.kind){
            case 106 /* NullKeyword */ :
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 225 /* PrefixUnaryExpression */ :
                return true;
            default:
                return isLiteralExpression(node);
        }
    }
    function isExpression(node) {
        return isExpressionKind(skipPartiallyEmittedExpressions(node).kind);
    }
    function isExpressionKind(kind) {
        switch(kind){
            case 228 /* ConditionalExpression */ :
            case 230 /* YieldExpression */ :
            case 220 /* ArrowFunction */ :
            case 227 /* BinaryExpression */ :
            case 231 /* SpreadElement */ :
            case 235 /* AsExpression */ :
            case 233 /* OmittedExpression */ :
            case 357 /* CommaListExpression */ :
            case 356 /* PartiallyEmittedExpression */ :
            case 239 /* SatisfiesExpression */ :
                return true;
            default:
                return isUnaryExpressionKind(kind);
        }
    }
    function isAssertionExpression(node) {
        const kind = node.kind;
        return kind === 217 /* TypeAssertionExpression */  || kind === 235 /* AsExpression */ ;
    }
    function isIterationStatement(node, lookInLabeledStatements) {
        switch(node.kind){
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 247 /* DoStatement */ :
            case 248 /* WhileStatement */ :
                return true;
            case 257 /* LabeledStatement */ :
                return lookInLabeledStatements && isIterationStatement(node.statement, lookInLabeledStatements);
        }
        return false;
    }
    function isScopeMarker(node) {
        return isExportAssignment(node) || isExportDeclaration(node);
    }
    function hasScopeMarker(statements) {
        return some(statements, isScopeMarker);
    }
    function needsScopeMarker(result) {
        return !isAnyImportOrReExport(result) && !isExportAssignment(result) && !hasSyntacticModifier(result, 32 /* Export */ ) && !isAmbientModule(result);
    }
    function isExternalModuleIndicator(result) {
        return isAnyImportOrReExport(result) || isExportAssignment(result) || hasSyntacticModifier(result, 32 /* Export */ );
    }
    function isForInOrOfStatement(node) {
        return node.kind === 250 /* ForInStatement */  || node.kind === 251 /* ForOfStatement */ ;
    }
    function isConciseBody(node) {
        return isBlock(node) || isExpression(node);
    }
    function isFunctionBody(node) {
        return isBlock(node);
    }
    function isForInitializer(node) {
        return isVariableDeclarationList(node) || isExpression(node);
    }
    function isModuleBody(node) {
        const kind = node.kind;
        return kind === 269 /* ModuleBlock */  || kind === 268 /* ModuleDeclaration */  || kind === 80 /* Identifier */ ;
    }
    function isNamespaceBody(node) {
        const kind = node.kind;
        return kind === 269 /* ModuleBlock */  || kind === 268 /* ModuleDeclaration */ ;
    }
    function isJSDocNamespaceBody(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 268 /* ModuleDeclaration */ ;
    }
    function isNamedImportBindings(node) {
        const kind = node.kind;
        return kind === 276 /* NamedImports */  || kind === 275 /* NamespaceImport */ ;
    }
    function isModuleOrEnumDeclaration(node) {
        return node.kind === 268 /* ModuleDeclaration */  || node.kind === 267 /* EnumDeclaration */ ;
    }
    function canHaveSymbol(node) {
        switch(node.kind){
            case 220 /* ArrowFunction */ :
            case 227 /* BinaryExpression */ :
            case 209 /* BindingElement */ :
            case 214 /* CallExpression */ :
            case 180 /* CallSignature */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 176 /* ClassStaticBlockDeclaration */ :
            case 177 /* Constructor */ :
            case 186 /* ConstructorType */ :
            case 181 /* ConstructSignature */ :
            case 213 /* ElementAccessExpression */ :
            case 267 /* EnumDeclaration */ :
            case 307 /* EnumMember */ :
            case 278 /* ExportAssignment */ :
            case 279 /* ExportDeclaration */ :
            case 282 /* ExportSpecifier */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 185 /* FunctionType */ :
            case 178 /* GetAccessor */ :
            case 80 /* Identifier */ :
            case 274 /* ImportClause */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 277 /* ImportSpecifier */ :
            case 182 /* IndexSignature */ :
            case 265 /* InterfaceDeclaration */ :
            case 339 /* JSDocCallbackTag */ :
            case 341 /* JSDocEnumTag */ :
            case 318 /* JSDocFunctionType */ :
            case 342 /* JSDocParameterTag */ :
            case 349 /* JSDocPropertyTag */ :
            case 324 /* JSDocSignature */ :
            case 347 /* JSDocTypedefTag */ :
            case 323 /* JSDocTypeLiteral */ :
            case 292 /* JsxAttribute */ :
            case 293 /* JsxAttributes */ :
            case 294 /* JsxSpreadAttribute */ :
            case 201 /* MappedType */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 268 /* ModuleDeclaration */ :
            case 203 /* NamedTupleMember */ :
            case 281 /* NamespaceExport */ :
            case 271 /* NamespaceExportDeclaration */ :
            case 275 /* NamespaceImport */ :
            case 215 /* NewExpression */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
            case 211 /* ObjectLiteralExpression */ :
            case 170 /* Parameter */ :
            case 212 /* PropertyAccessExpression */ :
            case 304 /* PropertyAssignment */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 179 /* SetAccessor */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 308 /* SourceFile */ :
            case 306 /* SpreadAssignment */ :
            case 11 /* StringLiteral */ :
            case 266 /* TypeAliasDeclaration */ :
            case 188 /* TypeLiteral */ :
            case 169 /* TypeParameter */ :
            case 261 /* VariableDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function canHaveLocals(node) {
        switch(node.kind){
            case 220 /* ArrowFunction */ :
            case 242 /* Block */ :
            case 180 /* CallSignature */ :
            case 270 /* CaseBlock */ :
            case 300 /* CatchClause */ :
            case 176 /* ClassStaticBlockDeclaration */ :
            case 195 /* ConditionalType */ :
            case 177 /* Constructor */ :
            case 186 /* ConstructorType */ :
            case 181 /* ConstructSignature */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 185 /* FunctionType */ :
            case 178 /* GetAccessor */ :
            case 182 /* IndexSignature */ :
            case 339 /* JSDocCallbackTag */ :
            case 341 /* JSDocEnumTag */ :
            case 318 /* JSDocFunctionType */ :
            case 324 /* JSDocSignature */ :
            case 347 /* JSDocTypedefTag */ :
            case 201 /* MappedType */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 268 /* ModuleDeclaration */ :
            case 179 /* SetAccessor */ :
            case 308 /* SourceFile */ :
            case 266 /* TypeAliasDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isDeclarationKind(kind) {
        return kind === 220 /* ArrowFunction */  || kind === 209 /* BindingElement */  || kind === 264 /* ClassDeclaration */  || kind === 232 /* ClassExpression */  || kind === 176 /* ClassStaticBlockDeclaration */  || kind === 177 /* Constructor */  || kind === 267 /* EnumDeclaration */  || kind === 307 /* EnumMember */  || kind === 282 /* ExportSpecifier */  || kind === 263 /* FunctionDeclaration */  || kind === 219 /* FunctionExpression */  || kind === 178 /* GetAccessor */  || kind === 274 /* ImportClause */  || kind === 272 /* ImportEqualsDeclaration */  || kind === 277 /* ImportSpecifier */  || kind === 265 /* InterfaceDeclaration */  || kind === 292 /* JsxAttribute */  || kind === 175 /* MethodDeclaration */  || kind === 174 /* MethodSignature */  || kind === 268 /* ModuleDeclaration */  || kind === 271 /* NamespaceExportDeclaration */  || kind === 275 /* NamespaceImport */  || kind === 281 /* NamespaceExport */  || kind === 170 /* Parameter */  || kind === 304 /* PropertyAssignment */  || kind === 173 /* PropertyDeclaration */  || kind === 172 /* PropertySignature */  || kind === 179 /* SetAccessor */  || kind === 305 /* ShorthandPropertyAssignment */  || kind === 266 /* TypeAliasDeclaration */  || kind === 169 /* TypeParameter */  || kind === 261 /* VariableDeclaration */  || kind === 347 /* JSDocTypedefTag */  || kind === 339 /* JSDocCallbackTag */  || kind === 349 /* JSDocPropertyTag */  || kind === 203 /* NamedTupleMember */ ;
    }
    function isDeclarationStatementKind(kind) {
        return kind === 263 /* FunctionDeclaration */  || kind === 283 /* MissingDeclaration */  || kind === 264 /* ClassDeclaration */  || kind === 265 /* InterfaceDeclaration */  || kind === 266 /* TypeAliasDeclaration */  || kind === 267 /* EnumDeclaration */  || kind === 268 /* ModuleDeclaration */  || kind === 273 /* ImportDeclaration */  || kind === 272 /* ImportEqualsDeclaration */  || kind === 279 /* ExportDeclaration */  || kind === 278 /* ExportAssignment */  || kind === 271 /* NamespaceExportDeclaration */ ;
    }
    function isStatementKindButNotDeclarationKind(kind) {
        return kind === 253 /* BreakStatement */  || kind === 252 /* ContinueStatement */  || kind === 260 /* DebuggerStatement */  || kind === 247 /* DoStatement */  || kind === 245 /* ExpressionStatement */  || kind === 243 /* EmptyStatement */  || kind === 250 /* ForInStatement */  || kind === 251 /* ForOfStatement */  || kind === 249 /* ForStatement */  || kind === 246 /* IfStatement */  || kind === 257 /* LabeledStatement */  || kind === 254 /* ReturnStatement */  || kind === 256 /* SwitchStatement */  || kind === 258 /* ThrowStatement */  || kind === 259 /* TryStatement */  || kind === 244 /* VariableStatement */  || kind === 248 /* WhileStatement */  || kind === 255 /* WithStatement */  || kind === 354 /* NotEmittedStatement */ ;
    }
    function isDeclaration(node) {
        if (node.kind === 169 /* TypeParameter */ ) return node.parent && node.parent.kind !== 346 /* JSDocTemplateTag */  || isInJSFile(node);
        return isDeclarationKind(node.kind);
    }
    function isDeclarationStatement(node) {
        return isDeclarationStatementKind(node.kind);
    }
    function isStatementButNotDeclaration(node) {
        return isStatementKindButNotDeclarationKind(node.kind);
    }
    function isStatement(node) {
        const kind = node.kind;
        return isStatementKindButNotDeclarationKind(kind) || isDeclarationStatementKind(kind) || isBlockStatement(node);
    }
    function isBlockStatement(node) {
        if (node.kind !== 242 /* Block */ ) return false;
        if (node.parent !== void 0) {
            if (node.parent.kind === 259 /* TryStatement */  || node.parent.kind === 300 /* CatchClause */ ) return false;
        }
        return !isFunctionBlock(node);
    }
    function isStatementOrBlock(node) {
        const kind = node.kind;
        return isStatementKindButNotDeclarationKind(kind) || isDeclarationStatementKind(kind) || kind === 242 /* Block */ ;
    }
    function isModuleReference(node) {
        const kind = node.kind;
        return kind === 284 /* ExternalModuleReference */  || kind === 167 /* QualifiedName */  || kind === 80 /* Identifier */ ;
    }
    function isJsxTagNameExpression(node) {
        const kind = node.kind;
        return kind === 110 /* ThisKeyword */  || kind === 80 /* Identifier */  || kind === 212 /* PropertyAccessExpression */  || kind === 296 /* JsxNamespacedName */ ;
    }
    function isJsxChild(node) {
        const kind = node.kind;
        return kind === 285 /* JsxElement */  || kind === 295 /* JsxExpression */  || kind === 286 /* JsxSelfClosingElement */  || kind === 12 /* JsxText */  || kind === 289 /* JsxFragment */ ;
    }
    function isJsxAttributeLike(node) {
        const kind = node.kind;
        return kind === 292 /* JsxAttribute */  || kind === 294 /* JsxSpreadAttribute */ ;
    }
    function isStringLiteralOrJsxExpression(node) {
        const kind = node.kind;
        return kind === 11 /* StringLiteral */  || kind === 295 /* JsxExpression */ ;
    }
    function isJsxOpeningLikeElement(node) {
        const kind = node.kind;
        return kind === 287 /* JsxOpeningElement */  || kind === 286 /* JsxSelfClosingElement */ ;
    }
    function isJsxCallLike(node) {
        const kind = node.kind;
        return kind === 287 /* JsxOpeningElement */  || kind === 286 /* JsxSelfClosingElement */  || kind === 290 /* JsxOpeningFragment */ ;
    }
    function isCaseOrDefaultClause(node) {
        const kind = node.kind;
        return kind === 297 /* CaseClause */  || kind === 298 /* DefaultClause */ ;
    }
    function isJSDocNode(node) {
        return node.kind >= 310 /* FirstJSDocNode */  && node.kind <= 352 /* LastJSDocNode */ ;
    }
    function isJSDocCommentContainingNode(node) {
        return node.kind === 321 /* JSDoc */  || node.kind === 320 /* JSDocNamepathType */  || node.kind === 322 /* JSDocText */  || isJSDocLinkLike(node) || isJSDocTag(node) || isJSDocTypeLiteral(node) || isJSDocSignature(node);
    }
    function isJSDocTag(node) {
        return node.kind >= 328 /* FirstJSDocTagNode */  && node.kind <= 352 /* LastJSDocTagNode */ ;
    }
    function isSetAccessor(node) {
        return node.kind === 179 /* SetAccessor */ ;
    }
    function isGetAccessor(node) {
        return node.kind === 178 /* GetAccessor */ ;
    }
    function hasJSDocNodes(node) {
        if (!canHaveJSDoc(node)) return false;
        const { jsDoc } = node;
        return !!jsDoc && jsDoc.length > 0;
    }
    function hasType(node) {
        return !!node.type;
    }
    function hasInitializer(node) {
        return !!node.initializer;
    }
    function hasOnlyExpressionInitializer(node) {
        switch(node.kind){
            case 261 /* VariableDeclaration */ :
            case 170 /* Parameter */ :
            case 209 /* BindingElement */ :
            case 173 /* PropertyDeclaration */ :
            case 304 /* PropertyAssignment */ :
            case 307 /* EnumMember */ :
                return true;
            default:
                return false;
        }
    }
    function isObjectLiteralElement(node) {
        return node.kind === 292 /* JsxAttribute */  || node.kind === 294 /* JsxSpreadAttribute */  || isObjectLiteralElementLike(node);
    }
    function isTypeReferenceType(node) {
        return node.kind === 184 /* TypeReference */  || node.kind === 234 /* ExpressionWithTypeArguments */ ;
    }
    var MAX_SMI_X86 = 1073741823;
    function guessIndentation(lines) {
        let indentation = MAX_SMI_X86;
        for (const line of lines){
            if (!line.length) continue;
            let i = 0;
            for(; i < line.length && i < indentation; i++){
                if (!isWhiteSpaceLike(line.charCodeAt(i))) break;
            }
            if (i < indentation) indentation = i;
            if (indentation === 0) return 0;
        }
        return indentation === MAX_SMI_X86 ? void 0 : indentation;
    }
    function isStringLiteralLike(node) {
        return node.kind === 11 /* StringLiteral */  || node.kind === 15 /* NoSubstitutionTemplateLiteral */ ;
    }
    function isJSDocLinkLike(node) {
        return node.kind === 325 /* JSDocLink */  || node.kind === 326 /* JSDocLinkCode */  || node.kind === 327 /* JSDocLinkPlain */ ;
    }
    function hasRestParameter(s) {
        const last2 = lastOrUndefined(s.parameters);
        return !!last2 && isRestParameter(last2);
    }
    function isRestParameter(node) {
        const type = isJSDocParameterTag(node) ? node.typeExpression && node.typeExpression.type : node.type;
        return node.dotDotDotToken !== void 0 || !!type && type.kind === 319 /* JSDocVariadicType */ ;
    }
    function hasInternalAnnotation(range, sourceFile) {
        const comment = sourceFile.text.substring(range.pos, range.end);
        return comment.includes("@internal");
    }
    function isInternalDeclaration(node, sourceFile) {
        sourceFile !== null && sourceFile !== void 0 ? sourceFile : sourceFile = getSourceFileOfNode(node);
        const parseTreeNode = getParseTreeNode(node);
        if (parseTreeNode && parseTreeNode.kind === 170 /* Parameter */ ) {
            const paramIdx = parseTreeNode.parent.parameters.indexOf(parseTreeNode);
            const previousSibling = paramIdx > 0 ? parseTreeNode.parent.parameters[paramIdx - 1] : void 0;
            const text = sourceFile.text;
            const commentRanges = previousSibling ? concatenate(// to handle
            // ... parameters, /** @internal */
            // public param: string
            getTrailingCommentRanges(text, skipTrivia(text, previousSibling.end + 1, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true)), getLeadingCommentRanges(text, node.pos)) : getTrailingCommentRanges(text, skipTrivia(text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true));
            return some(commentRanges) && hasInternalAnnotation(last(commentRanges), sourceFile);
        }
        const leadingCommentRanges = parseTreeNode && getLeadingCommentRangesOfNode(parseTreeNode, sourceFile);
        return !!forEach(leadingCommentRanges, (range)=>{
            return hasInternalAnnotation(range, sourceFile);
        });
    }
    // src/compiler/utilities.ts
    var resolvingEmptyArray = [];
    var externalHelpersModuleNameText = "tslib";
    var defaultMaximumTruncationLength = 160;
    var noTruncationMaximumTruncationLength = 1e6;
    var defaultHoverMaximumTruncationLength = 500;
    function getDeclarationOfKind(symbol, kind) {
        const declarations = symbol.declarations;
        if (declarations) for (const declaration of declarations){
            if (declaration.kind === kind) return declaration;
        }
        return void 0;
    }
    function getDeclarationsOfKind(symbol, kind) {
        return filter(symbol.declarations || emptyArray, (d)=>d.kind === kind);
    }
    function createSymbolTable(symbols) {
        const result = /* @__PURE__ */ new Map();
        if (symbols) for (const symbol of symbols)result.set(symbol.escapedName, symbol);
        return result;
    }
    function isTransientSymbol(symbol) {
        return (symbol.flags & 33554432 /* Transient */ ) !== 0;
    }
    function isExternalModuleSymbol(moduleSymbol) {
        return !!(moduleSymbol.flags & 1536 /* Module */ ) && moduleSymbol.escapedName.charCodeAt(0) === 34 /* doubleQuote */ ;
    }
    var stringWriter = createSingleLineStringWriter();
    function createSingleLineStringWriter() {
        var str = "";
        const writeText = (text)=>str += text;
        return {
            getText: ()=>str,
            write: writeText,
            rawWrite: writeText,
            writeKeyword: writeText,
            writeOperator: writeText,
            writePunctuation: writeText,
            writeSpace: writeText,
            writeStringLiteral: writeText,
            writeLiteral: writeText,
            writeParameter: writeText,
            writeProperty: writeText,
            writeSymbol: (s, _)=>writeText(s),
            writeTrailingSemicolon: writeText,
            writeComment: writeText,
            getTextPos: ()=>str.length,
            getLine: ()=>0,
            getColumn: ()=>0,
            getIndent: ()=>0,
            isAtStartOfLine: ()=>false,
            hasTrailingComment: ()=>false,
            hasTrailingWhitespace: ()=>!!str.length && isWhiteSpaceLike(str.charCodeAt(str.length - 1)),
            // Completely ignore indentation for string writers.  And map newlines to
            // a single space.
            writeLine: ()=>str += " ",
            increaseIndent: noop,
            decreaseIndent: noop,
            clear: ()=>str = ""
        };
    }
    function changesAffectModuleResolution(oldOptions, newOptions) {
        return oldOptions.configFilePath !== newOptions.configFilePath || optionsHaveModuleResolutionChanges(oldOptions, newOptions);
    }
    function optionsHaveModuleResolutionChanges(oldOptions, newOptions) {
        return optionsHaveChanges(oldOptions, newOptions, moduleResolutionOptionDeclarations);
    }
    function changesAffectingProgramStructure(oldOptions, newOptions) {
        return optionsHaveChanges(oldOptions, newOptions, optionsAffectingProgramStructure);
    }
    function optionsHaveChanges(oldOptions, newOptions, optionDeclarations2) {
        return oldOptions !== newOptions && optionDeclarations2.some((o)=>!isJsonEqual(getCompilerOptionValue(oldOptions, o), getCompilerOptionValue(newOptions, o)));
    }
    function forEachAncestor(node, callback) {
        while(true){
            const res = callback(node);
            if (res === "quit") return void 0;
            if (res !== void 0) return res;
            if (isSourceFile(node)) return void 0;
            node = node.parent;
        }
    }
    function forEachEntry(map2, callback) {
        const iterator = map2.entries();
        for (const [key, value1] of iterator){
            const result = callback(value1, key);
            if (result) return result;
        }
        return void 0;
    }
    function forEachKey(map2, callback) {
        const iterator = map2.keys();
        for (const key of iterator){
            const result = callback(key);
            if (result) return result;
        }
        return void 0;
    }
    function copyEntries(source, target) {
        source.forEach((value1, key)=>{
            target.set(key, value1);
        });
    }
    function usingSingleLineStringWriter(action) {
        const oldString = stringWriter.getText();
        try {
            action(stringWriter);
            return stringWriter.getText();
        } finally{
            stringWriter.clear();
            stringWriter.writeKeyword(oldString);
        }
    }
    function getFullWidth(node) {
        return node.end - node.pos;
    }
    function projectReferenceIsEqualTo(oldRef, newRef) {
        return oldRef.path === newRef.path && !oldRef.prepend === !newRef.prepend && !oldRef.circular === !newRef.circular;
    }
    function moduleResolutionIsEqualTo(oldResolution, newResolution) {
        return oldResolution === newResolution || oldResolution.resolvedModule === newResolution.resolvedModule || !!oldResolution.resolvedModule && !!newResolution.resolvedModule && oldResolution.resolvedModule.isExternalLibraryImport === newResolution.resolvedModule.isExternalLibraryImport && oldResolution.resolvedModule.extension === newResolution.resolvedModule.extension && oldResolution.resolvedModule.resolvedFileName === newResolution.resolvedModule.resolvedFileName && oldResolution.resolvedModule.originalPath === newResolution.resolvedModule.originalPath && packageIdIsEqual(oldResolution.resolvedModule.packageId, newResolution.resolvedModule.packageId) && oldResolution.alternateResult === newResolution.alternateResult;
    }
    function getResolvedModuleFromResolution(resolution) {
        return resolution.resolvedModule;
    }
    function getResolvedTypeReferenceDirectiveFromResolution(resolution) {
        return resolution.resolvedTypeReferenceDirective;
    }
    function createModuleNotFoundChain(sourceFile, host, moduleReference, mode, packageName) {
        var _a;
        const alternateResult = (_a = host.getResolvedModule(sourceFile, moduleReference, mode)) == null ? void 0 : _a.alternateResult;
        const alternateResultMessage = alternateResult && (getEmitModuleResolutionKind(host.getCompilerOptions()) === 2 /* Node10 */  ? [
            Diagnostics.There_are_types_at_0_but_this_result_could_not_be_resolved_under_your_current_moduleResolution_setting_Consider_updating_to_node16_nodenext_or_bundler,
            [
                alternateResult
            ]
        ] : [
            Diagnostics.There_are_types_at_0_but_this_result_could_not_be_resolved_when_respecting_package_json_exports_The_1_library_may_need_to_update_its_package_json_or_typings,
            [
                alternateResult,
                alternateResult.includes(nodeModulesPathPart + "@types/") ? `@types/${mangleScopedPackageName(packageName)}` : packageName
            ]
        ]);
        const result = alternateResultMessage ? chainDiagnosticMessages(/*details*/ void 0, alternateResultMessage[0], ...alternateResultMessage[1]) : host.typesPackageExists(packageName) ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.If_the_0_package_actually_exposes_this_module_consider_sending_a_pull_request_to_amend_https_Colon_Slash_Slashgithub_com_SlashDefinitelyTyped_SlashDefinitelyTyped_Slashtree_Slashmaster_Slashtypes_Slash_1, packageName, mangleScopedPackageName(packageName)) : host.packageBundlesTypes(packageName) ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.If_the_0_package_actually_exposes_this_module_try_adding_a_new_declaration_d_ts_file_containing_declare_module_1, packageName, moduleReference) : chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Try_npm_i_save_dev_types_Slash_1_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0, moduleReference, mangleScopedPackageName(packageName));
        if (result) result.repopulateInfo = ()=>({
                moduleReference,
                mode,
                packageName: packageName === moduleReference ? void 0 : packageName
            });
        return result;
    }
    function createModeMismatchDetails(currentSourceFile) {
        const ext = tryGetExtensionFromPath2(currentSourceFile.fileName);
        const scope = currentSourceFile.packageJsonScope;
        const targetExt = ext === ".ts" /* Ts */  ? ".mts" /* Mts */  : ext === ".js" /* Js */  ? ".mjs" /* Mjs */  : void 0;
        const result = scope && !scope.contents.packageJsonContent.type ? targetExt ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_add_the_field_type_Colon_module_to_1, targetExt, combinePaths(scope.packageDirectory, "package.json")) : chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_add_the_field_type_Colon_module_to_0, combinePaths(scope.packageDirectory, "package.json")) : targetExt ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_change_its_file_extension_to_0_or_create_a_local_package_json_file_with_type_Colon_module, targetExt) : chainDiagnosticMessages(/*details*/ void 0, Diagnostics.To_convert_this_file_to_an_ECMAScript_module_create_a_local_package_json_file_with_type_Colon_module);
        result.repopulateInfo = ()=>true;
        return result;
    }
    function packageIdIsEqual(a, b) {
        return a === b || !!a && !!b && a.name === b.name && a.subModuleName === b.subModuleName && a.version === b.version && a.peerDependencies === b.peerDependencies;
    }
    function packageIdToPackageName({ name, subModuleName }) {
        return subModuleName ? `${name}/${subModuleName}` : name;
    }
    function packageIdToString(packageId) {
        var _packageId_peerDependencies;
        return `${packageIdToPackageName(packageId)}@${packageId.version}${(_packageId_peerDependencies = packageId.peerDependencies) !== null && _packageId_peerDependencies !== void 0 ? _packageId_peerDependencies : ""}`;
    }
    function typeDirectiveIsEqualTo(oldResolution, newResolution) {
        return oldResolution === newResolution || oldResolution.resolvedTypeReferenceDirective === newResolution.resolvedTypeReferenceDirective || !!oldResolution.resolvedTypeReferenceDirective && !!newResolution.resolvedTypeReferenceDirective && oldResolution.resolvedTypeReferenceDirective.resolvedFileName === newResolution.resolvedTypeReferenceDirective.resolvedFileName && !!oldResolution.resolvedTypeReferenceDirective.primary === !!newResolution.resolvedTypeReferenceDirective.primary && oldResolution.resolvedTypeReferenceDirective.originalPath === newResolution.resolvedTypeReferenceDirective.originalPath;
    }
    function hasChangesInResolutions(names, newResolutions, getOldResolution, comparer) {
        Debug.assert(names.length === newResolutions.length);
        for(let i = 0; i < names.length; i++){
            const newResolution = newResolutions[i];
            const entry = names[i];
            const oldResolution = getOldResolution(entry);
            const changed = oldResolution ? !newResolution || !comparer(oldResolution, newResolution) : newResolution;
            if (changed) return true;
        }
        return false;
    }
    function containsParseError(node) {
        aggregateChildData(node);
        return (node.flags & 1048576 /* ThisNodeOrAnySubNodesHasError */ ) !== 0;
    }
    function aggregateChildData(node) {
        if (!(node.flags & 2097152 /* HasAggregatedChildData */ )) {
            const thisNodeOrAnySubNodesHasError = (node.flags & 262144 /* ThisNodeHasError */ ) !== 0 || forEachChild(node, containsParseError);
            if (thisNodeOrAnySubNodesHasError) node.flags |= 1048576 /* ThisNodeOrAnySubNodesHasError */ ;
            node.flags |= 2097152 /* HasAggregatedChildData */ ;
        }
    }
    function getSourceFileOfNode(node) {
        while(node && node.kind !== 308 /* SourceFile */ )node = node.parent;
        return node;
    }
    function getSourceFileOfModule(module2) {
        return getSourceFileOfNode(module2.valueDeclaration || getNonAugmentationDeclaration(module2));
    }
    function isPlainJsFile(file, checkJs) {
        return !!file && (file.scriptKind === 1 /* JS */  || file.scriptKind === 2 /* JSX */ ) && !file.checkJsDirective && checkJs === void 0;
    }
    function isStatementWithLocals(node) {
        switch(node.kind){
            case 242 /* Block */ :
            case 270 /* CaseBlock */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
                return true;
        }
        return false;
    }
    function getStartPositionOfLine(line, sourceFile) {
        Debug.assert(line >= 0);
        return getLineStarts(sourceFile)[line];
    }
    function nodePosToString(node) {
        const file = getSourceFileOfNode(node);
        const loc = getLineAndCharacterOfPosition(file, node.pos);
        return `${file.fileName}(${loc.line + 1},${loc.character + 1})`;
    }
    function getEndLinePosition(line, sourceFile) {
        Debug.assert(line >= 0);
        const lineStarts = getLineStarts(sourceFile);
        const lineIndex = line;
        const sourceText = sourceFile.text;
        if (lineIndex + 1 === lineStarts.length) return sourceText.length - 1;
        else {
            const start = lineStarts[lineIndex];
            let pos = lineStarts[lineIndex + 1] - 1;
            Debug.assert(isLineBreak(sourceText.charCodeAt(pos)));
            while(start <= pos && isLineBreak(sourceText.charCodeAt(pos)))pos--;
            return pos;
        }
    }
    function isFileLevelUniqueName(sourceFile, name, hasGlobalName) {
        return !(hasGlobalName && hasGlobalName(name)) && !sourceFile.identifiers.has(name);
    }
    function nodeIsMissing(node) {
        if (node === void 0) return true;
        return node.pos === node.end && node.pos >= 0 && node.kind !== 1 /* EndOfFileToken */ ;
    }
    function nodeIsPresent(node) {
        return !nodeIsMissing(node);
    }
    function isGrammarError(parent2, child) {
        if (isTypeParameterDeclaration(parent2)) return child === parent2.expression;
        if (isClassStaticBlockDeclaration(parent2)) return child === parent2.modifiers;
        if (isPropertySignature(parent2)) return child === parent2.initializer;
        if (isPropertyDeclaration(parent2)) return child === parent2.questionToken && isAutoAccessorPropertyDeclaration(parent2);
        if (isPropertyAssignment(parent2)) return child === parent2.modifiers || child === parent2.questionToken || child === parent2.exclamationToken || isGrammarErrorElement(parent2.modifiers, child, isModifierLike);
        if (isShorthandPropertyAssignment(parent2)) return child === parent2.equalsToken || child === parent2.modifiers || child === parent2.questionToken || child === parent2.exclamationToken || isGrammarErrorElement(parent2.modifiers, child, isModifierLike);
        if (isMethodDeclaration(parent2)) return child === parent2.exclamationToken;
        if (isConstructorDeclaration(parent2)) return child === parent2.typeParameters || child === parent2.type || isGrammarErrorElement(parent2.typeParameters, child, isTypeParameterDeclaration);
        if (isGetAccessorDeclaration(parent2)) return child === parent2.typeParameters || isGrammarErrorElement(parent2.typeParameters, child, isTypeParameterDeclaration);
        if (isSetAccessorDeclaration(parent2)) return child === parent2.typeParameters || child === parent2.type || isGrammarErrorElement(parent2.typeParameters, child, isTypeParameterDeclaration);
        if (isNamespaceExportDeclaration(parent2)) return child === parent2.modifiers || isGrammarErrorElement(parent2.modifiers, child, isModifierLike);
        return false;
    }
    function isGrammarErrorElement(nodeArray, child, isElement) {
        if (!nodeArray || isArray(child) || !isElement(child)) return false;
        return contains(nodeArray, child);
    }
    function insertStatementsAfterPrologue(to, from, isPrologueDirective2) {
        if (from === void 0 || from.length === 0) return to;
        let statementIndex = 0;
        for(; statementIndex < to.length; ++statementIndex){
            if (!isPrologueDirective2(to[statementIndex])) break;
        }
        to.splice(statementIndex, 0, ...from);
        return to;
    }
    function insertStatementAfterPrologue(to, statement, isPrologueDirective2) {
        if (statement === void 0) return to;
        let statementIndex = 0;
        for(; statementIndex < to.length; ++statementIndex){
            if (!isPrologueDirective2(to[statementIndex])) break;
        }
        to.splice(statementIndex, 0, statement);
        return to;
    }
    function isAnyPrologueDirective(node) {
        return isPrologueDirective(node) || !!(getEmitFlags(node) & 2097152 /* CustomPrologue */ );
    }
    function insertStatementsAfterStandardPrologue(to, from) {
        return insertStatementsAfterPrologue(to, from, isPrologueDirective);
    }
    function insertStatementsAfterCustomPrologue(to, from) {
        return insertStatementsAfterPrologue(to, from, isAnyPrologueDirective);
    }
    function insertStatementAfterStandardPrologue(to, statement) {
        return insertStatementAfterPrologue(to, statement, isPrologueDirective);
    }
    function insertStatementAfterCustomPrologue(to, statement) {
        return insertStatementAfterPrologue(to, statement, isAnyPrologueDirective);
    }
    function isRecognizedTripleSlashComment(text, commentPos, commentEnd) {
        if (text.charCodeAt(commentPos + 1) === 47 /* slash */  && commentPos + 2 < commentEnd && text.charCodeAt(commentPos + 2) === 47 /* slash */ ) {
            const textSubStr = text.substring(commentPos, commentEnd);
            return fullTripleSlashReferencePathRegEx.test(textSubStr) || fullTripleSlashAMDReferencePathRegEx.test(textSubStr) || fullTripleSlashAMDModuleRegEx.test(textSubStr) || fullTripleSlashReferenceTypeReferenceDirectiveRegEx.test(textSubStr) || fullTripleSlashLibReferenceRegEx.test(textSubStr) || defaultLibReferenceRegEx.test(textSubStr) ? true : false;
        }
        return false;
    }
    function isPinnedComment(text, start) {
        return text.charCodeAt(start + 1) === 42 /* asterisk */  && text.charCodeAt(start + 2) === 33 /* exclamation */ ;
    }
    function createCommentDirectivesMap(sourceFile, commentDirectives) {
        const directivesByLine = new Map(commentDirectives.map((commentDirective)=>[
                `${getLineAndCharacterOfPosition(sourceFile, commentDirective.range.end).line}`,
                commentDirective
            ]));
        const usedLines = /* @__PURE__ */ new Map();
        return {
            getUnusedExpectations,
            markUsed
        };
        function getUnusedExpectations() {
            return arrayFrom(directivesByLine.entries()).filter(([line, directive])=>directive.type === 0 /* ExpectError */  && !usedLines.get(line)).map(([_, directive])=>directive);
        }
        function markUsed(line) {
            if (!directivesByLine.has(`${line}`)) return false;
            usedLines.set(`${line}`, true);
            return true;
        }
    }
    function getTokenPosOfNode(node, sourceFile, includeJsDoc) {
        if (nodeIsMissing(node)) return node.pos;
        if (isJSDocNode(node) || node.kind === 12 /* JsxText */ ) return skipTrivia((sourceFile !== null && sourceFile !== void 0 ? sourceFile : getSourceFileOfNode(node)).text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
        if (includeJsDoc && hasJSDocNodes(node)) return getTokenPosOfNode(node.jsDoc[0], sourceFile);
        if (node.kind === 353 /* SyntaxList */ ) {
            sourceFile !== null && sourceFile !== void 0 ? sourceFile : sourceFile = getSourceFileOfNode(node);
            const first2 = firstOrUndefined(getNodeChildren(node, sourceFile));
            if (first2) return getTokenPosOfNode(first2, sourceFile, includeJsDoc);
        }
        return skipTrivia((sourceFile !== null && sourceFile !== void 0 ? sourceFile : getSourceFileOfNode(node)).text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ false, isInJSDoc(node));
    }
    function getNonDecoratorTokenPosOfNode(node, sourceFile) {
        const lastDecorator = !nodeIsMissing(node) && canHaveModifiers(node) ? findLast(node.modifiers, isDecorator) : void 0;
        if (!lastDecorator) return getTokenPosOfNode(node, sourceFile);
        return skipTrivia((sourceFile || getSourceFileOfNode(node)).text, lastDecorator.end);
    }
    function getNonModifierTokenPosOfNode(node, sourceFile) {
        const lastModifier = !nodeIsMissing(node) && canHaveModifiers(node) && node.modifiers ? last(node.modifiers) : void 0;
        if (!lastModifier) return getTokenPosOfNode(node, sourceFile);
        return skipTrivia((sourceFile || getSourceFileOfNode(node)).text, lastModifier.end);
    }
    function getSourceTextOfNodeFromSourceFile(sourceFile, node, includeTrivia = false) {
        return getTextOfNodeFromSourceText(sourceFile.text, node, includeTrivia);
    }
    function isJSDocTypeExpressionOrChild(node) {
        return !!findAncestor(node, isJSDocTypeExpression);
    }
    function isExportNamespaceAsDefaultDeclaration(node) {
        return !!(isExportDeclaration(node) && node.exportClause && isNamespaceExport(node.exportClause) && moduleExportNameIsDefault(node.exportClause.name));
    }
    function moduleExportNameTextUnescaped(node) {
        return node.kind === 11 /* StringLiteral */  ? node.text : unescapeLeadingUnderscores(node.escapedText);
    }
    function moduleExportNameTextEscaped(node) {
        return node.kind === 11 /* StringLiteral */  ? escapeLeadingUnderscores(node.text) : node.escapedText;
    }
    function moduleExportNameIsDefault(node) {
        return (node.kind === 11 /* StringLiteral */  ? node.text : node.escapedText) === "default" /* Default */ ;
    }
    function getTextOfNodeFromSourceText(sourceText, node, includeTrivia = false) {
        if (nodeIsMissing(node)) return "";
        let text = sourceText.substring(includeTrivia ? node.pos : skipTrivia(sourceText, node.pos), node.end);
        if (isJSDocTypeExpressionOrChild(node)) text = text.split(/\r\n|\n|\r/).map((line)=>line.replace(/^\s*\*/, "").trimStart()).join("\n");
        return text;
    }
    function getTextOfNode(node, includeTrivia = false) {
        return getSourceTextOfNodeFromSourceFile(getSourceFileOfNode(node), node, includeTrivia);
    }
    function getPos(range) {
        return range.pos;
    }
    function indexOfNode(nodeArray, node) {
        return binarySearch(nodeArray, node, getPos, compareValues);
    }
    function getEmitFlags(node) {
        const emitNode = node.emitNode;
        return emitNode && emitNode.flags || 0;
    }
    function getInternalEmitFlags(node) {
        const emitNode = node.emitNode;
        return emitNode && emitNode.internalFlags || 0;
    }
    var getScriptTargetFeatures = /* @__PURE__ */ memoize(()=>new Map(Object.entries({
            Array: new Map(Object.entries({
                es2015: [
                    "find",
                    "findIndex",
                    "fill",
                    "copyWithin",
                    "entries",
                    "keys",
                    "values"
                ],
                es2016: [
                    "includes"
                ],
                es2019: [
                    "flat",
                    "flatMap"
                ],
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Iterator: new Map(Object.entries({
                es2015: emptyArray
            })),
            AsyncIterator: new Map(Object.entries({
                es2015: emptyArray
            })),
            ArrayBuffer: new Map(Object.entries({
                es2024: [
                    "maxByteLength",
                    "resizable",
                    "resize",
                    "detached",
                    "transfer",
                    "transferToFixedLength"
                ]
            })),
            Atomics: new Map(Object.entries({
                es2017: [
                    "add",
                    "and",
                    "compareExchange",
                    "exchange",
                    "isLockFree",
                    "load",
                    "or",
                    "store",
                    "sub",
                    "wait",
                    "notify",
                    "xor"
                ],
                es2024: [
                    "waitAsync"
                ],
                esnext: [
                    "pause"
                ]
            })),
            SharedArrayBuffer: new Map(Object.entries({
                es2017: [
                    "byteLength",
                    "slice"
                ],
                es2024: [
                    "growable",
                    "maxByteLength",
                    "grow"
                ]
            })),
            AsyncIterable: new Map(Object.entries({
                es2018: emptyArray
            })),
            AsyncIterableIterator: new Map(Object.entries({
                es2018: emptyArray
            })),
            AsyncGenerator: new Map(Object.entries({
                es2018: emptyArray
            })),
            AsyncGeneratorFunction: new Map(Object.entries({
                es2018: emptyArray
            })),
            RegExp: new Map(Object.entries({
                es2015: [
                    "flags",
                    "sticky",
                    "unicode"
                ],
                es2018: [
                    "dotAll"
                ],
                es2024: [
                    "unicodeSets"
                ]
            })),
            Reflect: new Map(Object.entries({
                es2015: [
                    "apply",
                    "construct",
                    "defineProperty",
                    "deleteProperty",
                    "get",
                    "getOwnPropertyDescriptor",
                    "getPrototypeOf",
                    "has",
                    "isExtensible",
                    "ownKeys",
                    "preventExtensions",
                    "set",
                    "setPrototypeOf"
                ]
            })),
            ArrayConstructor: new Map(Object.entries({
                es2015: [
                    "from",
                    "of"
                ],
                esnext: [
                    "fromAsync"
                ]
            })),
            ObjectConstructor: new Map(Object.entries({
                es2015: [
                    "assign",
                    "getOwnPropertySymbols",
                    "keys",
                    "is",
                    "setPrototypeOf"
                ],
                es2017: [
                    "values",
                    "entries",
                    "getOwnPropertyDescriptors"
                ],
                es2019: [
                    "fromEntries"
                ],
                es2022: [
                    "hasOwn"
                ],
                es2024: [
                    "groupBy"
                ]
            })),
            NumberConstructor: new Map(Object.entries({
                es2015: [
                    "isFinite",
                    "isInteger",
                    "isNaN",
                    "isSafeInteger",
                    "parseFloat",
                    "parseInt"
                ]
            })),
            Math: new Map(Object.entries({
                es2015: [
                    "clz32",
                    "imul",
                    "sign",
                    "log10",
                    "log2",
                    "log1p",
                    "expm1",
                    "cosh",
                    "sinh",
                    "tanh",
                    "acosh",
                    "asinh",
                    "atanh",
                    "hypot",
                    "trunc",
                    "fround",
                    "cbrt"
                ],
                esnext: [
                    "f16round"
                ]
            })),
            Map: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            MapConstructor: new Map(Object.entries({
                es2024: [
                    "groupBy"
                ]
            })),
            Set: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ],
                esnext: [
                    "union",
                    "intersection",
                    "difference",
                    "symmetricDifference",
                    "isSubsetOf",
                    "isSupersetOf",
                    "isDisjointFrom"
                ]
            })),
            PromiseConstructor: new Map(Object.entries({
                es2015: [
                    "all",
                    "race",
                    "reject",
                    "resolve"
                ],
                es2020: [
                    "allSettled"
                ],
                es2021: [
                    "any"
                ],
                es2024: [
                    "withResolvers"
                ]
            })),
            Symbol: new Map(Object.entries({
                es2015: [
                    "for",
                    "keyFor"
                ],
                es2019: [
                    "description"
                ]
            })),
            WeakMap: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            WeakSet: new Map(Object.entries({
                es2015: [
                    "entries",
                    "keys",
                    "values"
                ]
            })),
            String: new Map(Object.entries({
                es2015: [
                    "codePointAt",
                    "includes",
                    "endsWith",
                    "normalize",
                    "repeat",
                    "startsWith",
                    "anchor",
                    "big",
                    "blink",
                    "bold",
                    "fixed",
                    "fontcolor",
                    "fontsize",
                    "italics",
                    "link",
                    "small",
                    "strike",
                    "sub",
                    "sup"
                ],
                es2017: [
                    "padStart",
                    "padEnd"
                ],
                es2019: [
                    "trimStart",
                    "trimEnd",
                    "trimLeft",
                    "trimRight"
                ],
                es2020: [
                    "matchAll"
                ],
                es2021: [
                    "replaceAll"
                ],
                es2022: [
                    "at"
                ],
                es2024: [
                    "isWellFormed",
                    "toWellFormed"
                ]
            })),
            StringConstructor: new Map(Object.entries({
                es2015: [
                    "fromCodePoint",
                    "raw"
                ]
            })),
            DateTimeFormat: new Map(Object.entries({
                es2017: [
                    "formatToParts"
                ]
            })),
            Promise: new Map(Object.entries({
                es2015: emptyArray,
                es2018: [
                    "finally"
                ]
            })),
            RegExpMatchArray: new Map(Object.entries({
                es2018: [
                    "groups"
                ]
            })),
            RegExpExecArray: new Map(Object.entries({
                es2018: [
                    "groups"
                ]
            })),
            Intl: new Map(Object.entries({
                es2018: [
                    "PluralRules"
                ]
            })),
            NumberFormat: new Map(Object.entries({
                es2018: [
                    "formatToParts"
                ]
            })),
            SymbolConstructor: new Map(Object.entries({
                es2020: [
                    "matchAll"
                ],
                esnext: [
                    "metadata",
                    "dispose",
                    "asyncDispose"
                ]
            })),
            DataView: new Map(Object.entries({
                es2020: [
                    "setBigInt64",
                    "setBigUint64",
                    "getBigInt64",
                    "getBigUint64"
                ],
                esnext: [
                    "setFloat16",
                    "getFloat16"
                ]
            })),
            BigInt: new Map(Object.entries({
                es2020: emptyArray
            })),
            RelativeTimeFormat: new Map(Object.entries({
                es2020: [
                    "format",
                    "formatToParts",
                    "resolvedOptions"
                ]
            })),
            Int8Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Uint8Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Uint8ClampedArray: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Int16Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Uint16Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Int32Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Uint32Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Float16Array: new Map(Object.entries({
                esnext: emptyArray
            })),
            Float32Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Float64Array: new Map(Object.entries({
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            BigInt64Array: new Map(Object.entries({
                es2020: emptyArray,
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            BigUint64Array: new Map(Object.entries({
                es2020: emptyArray,
                es2022: [
                    "at"
                ],
                es2023: [
                    "findLastIndex",
                    "findLast",
                    "toReversed",
                    "toSorted",
                    "toSpliced",
                    "with"
                ]
            })),
            Error: new Map(Object.entries({
                es2022: [
                    "cause"
                ]
            }))
        })));
    var GetLiteralTextFlags = /* @__PURE__ */ ((GetLiteralTextFlags2)=>{
        GetLiteralTextFlags2[GetLiteralTextFlags2["None"] = 0] = "None";
        GetLiteralTextFlags2[GetLiteralTextFlags2["NeverAsciiEscape"] = 1] = "NeverAsciiEscape";
        GetLiteralTextFlags2[GetLiteralTextFlags2["JsxAttributeEscape"] = 2] = "JsxAttributeEscape";
        GetLiteralTextFlags2[GetLiteralTextFlags2["TerminateUnterminatedLiterals"] = 4] = "TerminateUnterminatedLiterals";
        GetLiteralTextFlags2[GetLiteralTextFlags2["AllowNumericSeparator"] = 8] = "AllowNumericSeparator";
        return GetLiteralTextFlags2;
    })(GetLiteralTextFlags || {});
    function getLiteralText(node, sourceFile, flags) {
        if (sourceFile && canUseOriginalText(node, flags)) return getSourceTextOfNodeFromSourceFile(sourceFile, node);
        switch(node.kind){
            case 11 /* StringLiteral */ :
                {
                    const escapeText = flags & 2 /* JsxAttributeEscape */  ? escapeJsxAttributeString : flags & 1 /* NeverAsciiEscape */  || getEmitFlags(node) & 16777216 /* NoAsciiEscaping */  ? escapeString : escapeNonAsciiString;
                    if (node.singleQuote) return "'" + escapeText(node.text, 39 /* singleQuote */ ) + "'";
                    else return '"' + escapeText(node.text, 34 /* doubleQuote */ ) + '"';
                }
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 16 /* TemplateHead */ :
            case 17 /* TemplateMiddle */ :
            case 18 /* TemplateTail */ :
                {
                    const escapeText = flags & 1 /* NeverAsciiEscape */  || getEmitFlags(node) & 16777216 /* NoAsciiEscaping */  ? escapeString : escapeNonAsciiString;
                    var _node_rawText;
                    const rawText = (_node_rawText = node.rawText) !== null && _node_rawText !== void 0 ? _node_rawText : escapeTemplateSubstitution(escapeText(node.text, 96 /* backtick */ ));
                    switch(node.kind){
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                            return "`" + rawText + "`";
                        case 16 /* TemplateHead */ :
                            return "`" + rawText + "${";
                        case 17 /* TemplateMiddle */ :
                            return "}" + rawText + "${";
                        case 18 /* TemplateTail */ :
                            return "}" + rawText + "`";
                    }
                    break;
                }
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
                return node.text;
            case 14 /* RegularExpressionLiteral */ :
                if (flags & 4 /* TerminateUnterminatedLiterals */  && node.isUnterminated) return node.text + (node.text.charCodeAt(node.text.length - 1) === 92 /* backslash */  ? " /" : "/");
                return node.text;
        }
        return Debug.fail(`Literal kind '${node.kind}' not accounted for.`);
    }
    function canUseOriginalText(node, flags) {
        if (nodeIsSynthesized(node) || !node.parent || flags & 4 /* TerminateUnterminatedLiterals */  && node.isUnterminated) return false;
        if (isNumericLiteral(node)) {
            if (node.numericLiteralFlags & 26656 /* IsInvalid */ ) return false;
            if (node.numericLiteralFlags & 512 /* ContainsSeparator */ ) return !!(flags & 8 /* AllowNumericSeparator */ );
        }
        return !isBigIntLiteral(node);
    }
    function getTextOfConstantValue(value1) {
        return isString(value1) ? `"${escapeString(value1)}"` : "" + value1;
    }
    function makeIdentifierFromModuleName(moduleName) {
        return getBaseFileName(moduleName).replace(/^(\d)/, "_$1").replace(/\W/g, "_");
    }
    function isBlockOrCatchScoped(declaration) {
        return (getCombinedNodeFlags(declaration) & 7 /* BlockScoped */ ) !== 0 || isCatchClauseVariableDeclarationOrBindingElement(declaration);
    }
    function isCatchClauseVariableDeclarationOrBindingElement(declaration) {
        const node = getRootDeclaration(declaration);
        return node.kind === 261 /* VariableDeclaration */  && node.parent.kind === 300 /* CatchClause */ ;
    }
    function isAmbientModule(node) {
        return isModuleDeclaration(node) && (node.name.kind === 11 /* StringLiteral */  || isGlobalScopeAugmentation(node));
    }
    function isModuleWithStringLiteralName(node) {
        return isModuleDeclaration(node) && node.name.kind === 11 /* StringLiteral */ ;
    }
    function isNonGlobalAmbientModule(node) {
        return isModuleDeclaration(node) && isStringLiteral(node.name);
    }
    function isEffectiveModuleDeclaration(node) {
        return isModuleDeclaration(node) || isIdentifier(node);
    }
    function isShorthandAmbientModuleSymbol(moduleSymbol) {
        return isShorthandAmbientModule(moduleSymbol.valueDeclaration);
    }
    function isShorthandAmbientModule(node) {
        return !!node && node.kind === 268 /* ModuleDeclaration */  && !node.body;
    }
    function isBlockScopedContainerTopLevel(node) {
        return node.kind === 308 /* SourceFile */  || node.kind === 268 /* ModuleDeclaration */  || isFunctionLikeOrClassStaticBlockDeclaration(node);
    }
    function isGlobalScopeAugmentation(module2) {
        return !!(module2.flags & 2048 /* GlobalAugmentation */ );
    }
    function isExternalModuleAugmentation(node) {
        return isAmbientModule(node) && isModuleAugmentationExternal(node);
    }
    function isModuleAugmentationExternal(node) {
        switch(node.parent.kind){
            case 308 /* SourceFile */ :
                return isExternalModule(node.parent);
            case 269 /* ModuleBlock */ :
                return isAmbientModule(node.parent.parent) && isSourceFile(node.parent.parent.parent) && !isExternalModule(node.parent.parent.parent);
        }
        return false;
    }
    function getNonAugmentationDeclaration(symbol) {
        var _a;
        return (_a = symbol.declarations) == null ? void 0 : _a.find((d)=>!isExternalModuleAugmentation(d) && !(isModuleDeclaration(d) && isGlobalScopeAugmentation(d)));
    }
    function isCommonJSContainingModuleKind(kind) {
        return kind === 1 /* CommonJS */  || 100 /* Node16 */  <= kind && kind <= 199 /* NodeNext */ ;
    }
    function isEffectiveExternalModule(node, compilerOptions) {
        return isExternalModule(node) || isCommonJSContainingModuleKind(getEmitModuleKind(compilerOptions)) && !!node.commonJsModuleIndicator;
    }
    function isEffectiveStrictModeSourceFile(node, compilerOptions) {
        switch(node.scriptKind){
            case 1 /* JS */ :
            case 3 /* TS */ :
            case 2 /* JSX */ :
            case 4 /* TSX */ :
                break;
            default:
                return false;
        }
        if (node.isDeclarationFile) return false;
        if (getStrictOptionValue(compilerOptions, "alwaysStrict")) return true;
        if (startsWithUseStrict(node.statements)) return true;
        if (isExternalModule(node) || getIsolatedModules(compilerOptions)) return true;
        return false;
    }
    function isAmbientPropertyDeclaration(node) {
        return !!(node.flags & 33554432 /* Ambient */ ) || hasSyntacticModifier(node, 128 /* Ambient */ );
    }
    function isBlockScope(node, parentNode) {
        switch(node.kind){
            case 308 /* SourceFile */ :
            case 270 /* CaseBlock */ :
            case 300 /* CatchClause */ :
            case 268 /* ModuleDeclaration */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 177 /* Constructor */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 173 /* PropertyDeclaration */ :
            case 176 /* ClassStaticBlockDeclaration */ :
                return true;
            case 242 /* Block */ :
                return !isFunctionLikeOrClassStaticBlockDeclaration(parentNode);
        }
        return false;
    }
    function isDeclarationWithTypeParameters(node) {
        Debug.type(node);
        switch(node.kind){
            case 339 /* JSDocCallbackTag */ :
            case 347 /* JSDocTypedefTag */ :
            case 324 /* JSDocSignature */ :
                return true;
            default:
                assertType(node);
                return isDeclarationWithTypeParameterChildren(node);
        }
    }
    function isDeclarationWithTypeParameterChildren(node) {
        Debug.type(node);
        switch(node.kind){
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 174 /* MethodSignature */ :
            case 182 /* IndexSignature */ :
            case 185 /* FunctionType */ :
            case 186 /* ConstructorType */ :
            case 318 /* JSDocFunctionType */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 346 /* JSDocTemplateTag */ :
            case 263 /* FunctionDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 177 /* Constructor */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return true;
            default:
                assertType(node);
                return false;
        }
    }
    function isAnyImportSyntax(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function isAnyImportOrBareOrAccessedRequire(node) {
        return isAnyImportSyntax(node) || isVariableDeclarationInitializedToBareOrAccessedRequire(node);
    }
    function isAnyImportOrRequireStatement(node) {
        return isAnyImportSyntax(node) || isRequireVariableStatement(node);
    }
    function isLateVisibilityPaintedStatement(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 244 /* VariableStatement */ :
            case 264 /* ClassDeclaration */ :
            case 263 /* FunctionDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 267 /* EnumDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function hasPossibleExternalModuleReference(node) {
        return isAnyImportOrReExport(node) || isModuleDeclaration(node) || isImportTypeNode(node) || isImportCall(node);
    }
    function isAnyImportOrReExport(node) {
        return isAnyImportSyntax(node) || isExportDeclaration(node);
    }
    function getEnclosingContainer(node) {
        return findAncestor(node.parent, (n)=>!!(getContainerFlags(n) & 1 /* IsContainer */ ));
    }
    function getEnclosingBlockScopeContainer(node) {
        return findAncestor(node.parent, (current)=>isBlockScope(current, current.parent));
    }
    function forEachEnclosingBlockScopeContainer(node, cb) {
        let container = getEnclosingBlockScopeContainer(node);
        while(container){
            cb(container);
            container = getEnclosingBlockScopeContainer(container);
        }
    }
    function declarationNameToString(name) {
        return !name || getFullWidth(name) === 0 ? "(Missing)" : getTextOfNode(name);
    }
    function getNameFromIndexInfo(info) {
        return info.declaration ? declarationNameToString(info.declaration.parameters[0].name) : void 0;
    }
    function isComputedNonLiteralName(name) {
        return name.kind === 168 /* ComputedPropertyName */  && !isStringOrNumericLiteralLike(name.expression);
    }
    function tryGetTextOfPropertyName(name) {
        var _a;
        switch(name.kind){
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
                return ((_a = name.emitNode) == null ? void 0 : _a.autoGenerate) ? void 0 : name.escapedText;
            case 11 /* StringLiteral */ :
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return escapeLeadingUnderscores(name.text);
            case 168 /* ComputedPropertyName */ :
                if (isStringOrNumericLiteralLike(name.expression)) return escapeLeadingUnderscores(name.expression.text);
                return void 0;
            case 296 /* JsxNamespacedName */ :
                return getEscapedTextOfJsxNamespacedName(name);
            default:
                return Debug.assertNever(name);
        }
    }
    function getTextOfPropertyName(name) {
        return Debug.checkDefined(tryGetTextOfPropertyName(name));
    }
    function entityNameToString(name) {
        switch(name.kind){
            case 110 /* ThisKeyword */ :
                return "this";
            case 81 /* PrivateIdentifier */ :
            case 80 /* Identifier */ :
                return getFullWidth(name) === 0 ? idText(name) : getTextOfNode(name);
            case 167 /* QualifiedName */ :
                return entityNameToString(name.left) + "." + entityNameToString(name.right);
            case 212 /* PropertyAccessExpression */ :
                if (isIdentifier(name.name) || isPrivateIdentifier(name.name)) return entityNameToString(name.expression) + "." + entityNameToString(name.name);
                else return Debug.assertNever(name.name);
            case 312 /* JSDocMemberName */ :
                return entityNameToString(name.left) + "#" + entityNameToString(name.right);
            case 296 /* JsxNamespacedName */ :
                return entityNameToString(name.namespace) + ":" + entityNameToString(name.name);
            default:
                return Debug.assertNever(name);
        }
    }
    function createDiagnosticForNode(node, message, ...args) {
        const sourceFile = getSourceFileOfNode(node);
        return createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args);
    }
    function createDiagnosticForNodeArray(sourceFile, nodes, message, ...args) {
        const start = skipTrivia(sourceFile.text, nodes.pos);
        return createFileDiagnostic(sourceFile, start, nodes.end - start, message, ...args);
    }
    function createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args) {
        const span = getErrorSpanForNode(sourceFile, node);
        return createFileDiagnostic(sourceFile, span.start, span.length, message, ...args);
    }
    function createDiagnosticForNodeFromMessageChain(sourceFile, node, messageChain, relatedInformation) {
        const span = getErrorSpanForNode(sourceFile, node);
        return createFileDiagnosticFromMessageChain(sourceFile, span.start, span.length, messageChain, relatedInformation);
    }
    function createDiagnosticForNodeArrayFromMessageChain(sourceFile, nodes, messageChain, relatedInformation) {
        const start = skipTrivia(sourceFile.text, nodes.pos);
        return createFileDiagnosticFromMessageChain(sourceFile, start, nodes.end - start, messageChain, relatedInformation);
    }
    function assertDiagnosticLocation(sourceText, start, length2) {
        Debug.assertGreaterThanOrEqual(start, 0);
        Debug.assertGreaterThanOrEqual(length2, 0);
        Debug.assertLessThanOrEqual(start, sourceText.length);
        Debug.assertLessThanOrEqual(start + length2, sourceText.length);
    }
    function createFileDiagnosticFromMessageChain(file, start, length2, messageChain, relatedInformation) {
        assertDiagnosticLocation(file.text, start, length2);
        return {
            file,
            start,
            length: length2,
            code: messageChain.code,
            category: messageChain.category,
            messageText: messageChain.next ? messageChain : messageChain.messageText,
            relatedInformation,
            canonicalHead: messageChain.canonicalHead
        };
    }
    function createDiagnosticForFileFromMessageChain(sourceFile, messageChain, relatedInformation) {
        return {
            file: sourceFile,
            start: 0,
            length: 0,
            code: messageChain.code,
            category: messageChain.category,
            messageText: messageChain.next ? messageChain : messageChain.messageText,
            relatedInformation
        };
    }
    function createDiagnosticMessageChainFromDiagnostic(diagnostic) {
        return typeof diagnostic.messageText === "string" ? {
            code: diagnostic.code,
            category: diagnostic.category,
            messageText: diagnostic.messageText,
            next: diagnostic.next
        } : diagnostic.messageText;
    }
    function createDiagnosticForRange(sourceFile, range, message) {
        return {
            file: sourceFile,
            start: range.pos,
            length: range.end - range.pos,
            code: message.code,
            category: message.category,
            messageText: message.message
        };
    }
    function getCanonicalDiagnostic(message, ...args) {
        return {
            code: message.code,
            messageText: formatMessage(message, ...args)
        };
    }
    function getSpanOfTokenAtPosition(sourceFile, pos) {
        const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError*/ void 0, pos);
        scanner2.scan();
        const start = scanner2.getTokenStart();
        return createTextSpanFromBounds(start, scanner2.getTokenEnd());
    }
    function scanTokenAtPosition(sourceFile, pos) {
        const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError*/ void 0, pos);
        scanner2.scan();
        return scanner2.getToken();
    }
    function getErrorSpanForArrowFunction(sourceFile, node) {
        const pos = skipTrivia(sourceFile.text, node.pos);
        if (node.body && node.body.kind === 242 /* Block */ ) {
            const { line: startLine } = getLineAndCharacterOfPosition(sourceFile, node.body.pos);
            const { line: endLine } = getLineAndCharacterOfPosition(sourceFile, node.body.end);
            if (startLine < endLine) return createTextSpan(pos, getEndLinePosition(startLine, sourceFile) - pos + 1);
        }
        return createTextSpanFromBounds(pos, node.end);
    }
    function getErrorSpanForNode(sourceFile, node) {
        let errorNode = node;
        switch(node.kind){
            case 308 /* SourceFile */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, 0, /*stopAfterLineBreak*/ false);
                    if (pos2 === sourceFile.text.length) return createTextSpan(0, 0);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            // This list is a work in progress. Add missing node kinds to improve their error
            // spans.
            case 261 /* VariableDeclaration */ :
            case 209 /* BindingElement */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 307 /* EnumMember */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 266 /* TypeAliasDeclaration */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 275 /* NamespaceImport */ :
                errorNode = node.name;
                break;
            case 220 /* ArrowFunction */ :
                return getErrorSpanForArrowFunction(sourceFile, node);
            case 297 /* CaseClause */ :
            case 298 /* DefaultClause */ :
                {
                    const start = skipTrivia(sourceFile.text, node.pos);
                    const end = node.statements.length > 0 ? node.statements[0].pos : node.end;
                    return createTextSpanFromBounds(start, end);
                }
            case 254 /* ReturnStatement */ :
            case 230 /* YieldExpression */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, node.pos);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            case 239 /* SatisfiesExpression */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, node.expression.end);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            case 351 /* JSDocSatisfiesTag */ :
                {
                    const pos2 = skipTrivia(sourceFile.text, node.tagName.pos);
                    return getSpanOfTokenAtPosition(sourceFile, pos2);
                }
            case 177 /* Constructor */ :
                {
                    const constructorDeclaration = node;
                    const start = skipTrivia(sourceFile.text, constructorDeclaration.pos);
                    const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError*/ void 0, start);
                    let token = scanner2.scan();
                    while(token !== 137 /* ConstructorKeyword */  && token !== 1 /* EndOfFileToken */ )token = scanner2.scan();
                    const end = scanner2.getTokenEnd();
                    return createTextSpanFromBounds(start, end);
                }
        }
        if (errorNode === void 0) return getSpanOfTokenAtPosition(sourceFile, node.pos);
        Debug.assert(!isJSDoc(errorNode));
        const isMissing = nodeIsMissing(errorNode);
        const pos = isMissing || isJsxText(node) ? errorNode.pos : skipTrivia(sourceFile.text, errorNode.pos);
        if (isMissing) {
            Debug.assert(pos === errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
            Debug.assert(pos === errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
        } else {
            Debug.assert(pos >= errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
            Debug.assert(pos <= errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
        }
        return createTextSpanFromBounds(pos, errorNode.end);
    }
    function isGlobalSourceFile(node) {
        return node.kind === 308 /* SourceFile */  && !isExternalOrCommonJsModule(node);
    }
    function isExternalOrCommonJsModule(file) {
        return (file.externalModuleIndicator || file.commonJsModuleIndicator) !== void 0;
    }
    function isJsonSourceFile(file) {
        return file.scriptKind === 6 /* JSON */ ;
    }
    function isEnumConst(node) {
        return !!(getCombinedModifierFlags(node) & 4096 /* Const */ );
    }
    function isDeclarationReadonly(declaration) {
        return !!(getCombinedModifierFlags(declaration) & 8 /* Readonly */  && !isParameterPropertyDeclaration(declaration, declaration.parent));
    }
    function isVarAwaitUsing(node) {
        return (getCombinedNodeFlags(node) & 7 /* BlockScoped */ ) === 6 /* AwaitUsing */ ;
    }
    function isVarUsing(node) {
        return (getCombinedNodeFlags(node) & 7 /* BlockScoped */ ) === 4 /* Using */ ;
    }
    function isVarConst(node) {
        return (getCombinedNodeFlags(node) & 7 /* BlockScoped */ ) === 2 /* Const */ ;
    }
    function isVarConstLike(node) {
        const blockScopeKind = getCombinedNodeFlags(node) & 7 /* BlockScoped */ ;
        return blockScopeKind === 2 /* Const */  || blockScopeKind === 4 /* Using */  || blockScopeKind === 6 /* AwaitUsing */ ;
    }
    function isLet(node) {
        return (getCombinedNodeFlags(node) & 7 /* BlockScoped */ ) === 1 /* Let */ ;
    }
    function isSuperCall(n) {
        return n.kind === 214 /* CallExpression */  && n.expression.kind === 108 /* SuperKeyword */ ;
    }
    function isImportCall(n) {
        if (n.kind !== 214 /* CallExpression */ ) return false;
        const e = n.expression;
        return e.kind === 102 /* ImportKeyword */  || isMetaProperty(e) && e.keywordToken === 102 /* ImportKeyword */  && e.name.escapedText === "defer";
    }
    function isImportMeta(n) {
        return isMetaProperty(n) && n.keywordToken === 102 /* ImportKeyword */  && n.name.escapedText === "meta";
    }
    function isLiteralImportTypeNode(n) {
        return isImportTypeNode(n) && isLiteralTypeNode(n.argument) && isStringLiteral(n.argument.literal);
    }
    function isPrologueDirective(node) {
        return node.kind === 245 /* ExpressionStatement */  && node.expression.kind === 11 /* StringLiteral */ ;
    }
    function isCustomPrologue(node) {
        return !!(getEmitFlags(node) & 2097152 /* CustomPrologue */ );
    }
    function isHoistedFunction(node) {
        return isCustomPrologue(node) && isFunctionDeclaration(node);
    }
    function isHoistedVariable(node) {
        return isIdentifier(node.name) && !node.initializer;
    }
    function isHoistedVariableStatement(node) {
        return isCustomPrologue(node) && isVariableStatement(node) && every(node.declarationList.declarations, isHoistedVariable);
    }
    function getLeadingCommentRangesOfNode(node, sourceFileOfNode) {
        return node.kind !== 12 /* JsxText */  ? getLeadingCommentRanges(sourceFileOfNode.text, node.pos) : void 0;
    }
    function getJSDocCommentRanges(node, text) {
        const commentRanges = node.kind === 170 /* Parameter */  || node.kind === 169 /* TypeParameter */  || node.kind === 219 /* FunctionExpression */  || node.kind === 220 /* ArrowFunction */  || node.kind === 218 /* ParenthesizedExpression */  || node.kind === 261 /* VariableDeclaration */  || node.kind === 282 /* ExportSpecifier */  ? concatenate(getTrailingCommentRanges(text, node.pos), getLeadingCommentRanges(text, node.pos)) : getLeadingCommentRanges(text, node.pos);
        return filter(commentRanges, (comment)=>comment.end <= node.end && // Due to parse errors sometime empty parameter may get comments assigned to it that end up not in parameter range
            text.charCodeAt(comment.pos + 1) === 42 /* asterisk */  && text.charCodeAt(comment.pos + 2) === 42 /* asterisk */  && text.charCodeAt(comment.pos + 3) !== 47 /* slash */ );
    }
    var fullTripleSlashReferencePathRegEx = /^\/\/\/\s*<reference\s+path\s*=\s*(?:'[^']*'|"[^"]*").*?\/>/;
    var fullTripleSlashReferenceTypeReferenceDirectiveRegEx = /^\/\/\/\s*<reference\s+types\s*=\s*(?:'[^']*'|"[^"]*").*?\/>/;
    var fullTripleSlashLibReferenceRegEx = /^\/\/\/\s*<reference\s+lib\s*=\s*(?:'[^']*'|"[^"]*").*?\/>/;
    var fullTripleSlashAMDReferencePathRegEx = /^\/\/\/\s*<amd-dependency\s+path\s*=\s*(?:'[^']*'|"[^"]*").*?\/>/;
    var fullTripleSlashAMDModuleRegEx = /^\/\/\/\s*<amd-module\s+(?:\S.*?)??\/>/;
    var defaultLibReferenceRegEx = /^\/\/\/\s*<reference\s+no-default-lib\s*=\s*(?:'[^']*'|"[^"]*")\s*\/>/;
    function isPartOfTypeNode(node) {
        if (183 /* FirstTypeNode */  <= node.kind && node.kind <= 206 /* LastTypeNode */ ) return true;
        switch(node.kind){
            case 133 /* AnyKeyword */ :
            case 159 /* UnknownKeyword */ :
            case 150 /* NumberKeyword */ :
            case 163 /* BigIntKeyword */ :
            case 154 /* StringKeyword */ :
            case 136 /* BooleanKeyword */ :
            case 155 /* SymbolKeyword */ :
            case 151 /* ObjectKeyword */ :
            case 157 /* UndefinedKeyword */ :
            case 106 /* NullKeyword */ :
            case 146 /* NeverKeyword */ :
                return true;
            case 116 /* VoidKeyword */ :
                return node.parent.kind !== 223 /* VoidExpression */ ;
            case 234 /* ExpressionWithTypeArguments */ :
                return isPartOfTypeExpressionWithTypeArguments(node);
            case 169 /* TypeParameter */ :
                return node.parent.kind === 201 /* MappedType */  || node.parent.kind === 196 /* InferType */ ;
            // Identifiers and qualified names may be type nodes, depending on their context. Climb
            // above them to find the lowest container
            case 80 /* Identifier */ :
                if (node.parent.kind === 167 /* QualifiedName */  && node.parent.right === node) node = node.parent;
                else if (node.parent.kind === 212 /* PropertyAccessExpression */  && node.parent.name === node) node = node.parent;
                Debug.assert(node.kind === 80 /* Identifier */  || node.kind === 167 /* QualifiedName */  || node.kind === 212 /* PropertyAccessExpression */ , "'node' was expected to be a qualified name, identifier or property access in 'isPartOfTypeNode'.");
            // falls through
            case 167 /* QualifiedName */ :
            case 212 /* PropertyAccessExpression */ :
            case 110 /* ThisKeyword */ :
                {
                    const { parent: parent2 } = node;
                    if (parent2.kind === 187 /* TypeQuery */ ) return false;
                    if (parent2.kind === 206 /* ImportType */ ) return !parent2.isTypeOf;
                    if (183 /* FirstTypeNode */  <= parent2.kind && parent2.kind <= 206 /* LastTypeNode */ ) return true;
                    switch(parent2.kind){
                        case 234 /* ExpressionWithTypeArguments */ :
                            return isPartOfTypeExpressionWithTypeArguments(parent2);
                        case 169 /* TypeParameter */ :
                            return node === parent2.constraint;
                        case 346 /* JSDocTemplateTag */ :
                            return node === parent2.constraint;
                        case 173 /* PropertyDeclaration */ :
                        case 172 /* PropertySignature */ :
                        case 170 /* Parameter */ :
                        case 261 /* VariableDeclaration */ :
                            return node === parent2.type;
                        case 263 /* FunctionDeclaration */ :
                        case 219 /* FunctionExpression */ :
                        case 220 /* ArrowFunction */ :
                        case 177 /* Constructor */ :
                        case 175 /* MethodDeclaration */ :
                        case 174 /* MethodSignature */ :
                        case 178 /* GetAccessor */ :
                        case 179 /* SetAccessor */ :
                            return node === parent2.type;
                        case 180 /* CallSignature */ :
                        case 181 /* ConstructSignature */ :
                        case 182 /* IndexSignature */ :
                            return node === parent2.type;
                        case 217 /* TypeAssertionExpression */ :
                            return node === parent2.type;
                        case 214 /* CallExpression */ :
                        case 215 /* NewExpression */ :
                        case 216 /* TaggedTemplateExpression */ :
                            return contains(parent2.typeArguments, node);
                    }
                }
        }
        return false;
    }
    function isPartOfTypeExpressionWithTypeArguments(node) {
        return isJSDocImplementsTag(node.parent) || isJSDocAugmentsTag(node.parent) || isHeritageClause(node.parent) && !isExpressionWithTypeArgumentsInClassExtendsClause(node);
    }
    function forEachReturnStatement(body, visitor) {
        return traverse(body);
        function traverse(node) {
            switch(node.kind){
                case 254 /* ReturnStatement */ :
                    return visitor(node);
                case 270 /* CaseBlock */ :
                case 242 /* Block */ :
                case 246 /* IfStatement */ :
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                case 249 /* ForStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                case 255 /* WithStatement */ :
                case 256 /* SwitchStatement */ :
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                case 257 /* LabeledStatement */ :
                case 259 /* TryStatement */ :
                case 300 /* CatchClause */ :
                    return forEachChild(node, traverse);
            }
        }
    }
    function forEachYieldExpression(body, visitor) {
        return traverse(body);
        function traverse(node) {
            switch(node.kind){
                case 230 /* YieldExpression */ :
                    visitor(node);
                    const operand = node.expression;
                    if (operand) traverse(operand);
                    return;
                case 267 /* EnumDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                    return;
                default:
                    if (isFunctionLike(node)) {
                        if (node.name && node.name.kind === 168 /* ComputedPropertyName */ ) {
                            traverse(node.name.expression);
                            return;
                        }
                    } else if (!isPartOfTypeNode(node)) forEachChild(node, traverse);
            }
        }
    }
    function getRestParameterElementType(node) {
        if (node && node.kind === 189 /* ArrayType */ ) return node.elementType;
        else if (node && node.kind === 184 /* TypeReference */ ) return singleOrUndefined(node.typeArguments);
        else return void 0;
    }
    function getMembersOfDeclaration(node) {
        switch(node.kind){
            case 265 /* InterfaceDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 188 /* TypeLiteral */ :
                return node.members;
            case 211 /* ObjectLiteralExpression */ :
                return node.properties;
        }
    }
    function isVariableLike(node) {
        if (node) switch(node.kind){
            case 209 /* BindingElement */ :
            case 307 /* EnumMember */ :
            case 170 /* Parameter */ :
            case 304 /* PropertyAssignment */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 261 /* VariableDeclaration */ :
                return true;
        }
        return false;
    }
    function isVariableDeclarationInVariableStatement(node) {
        return node.parent.kind === 262 /* VariableDeclarationList */  && node.parent.parent.kind === 244 /* VariableStatement */ ;
    }
    function isCommonJsExportedExpression(node) {
        if (!isInJSFile(node)) return false;
        return isObjectLiteralExpression(node.parent) && isBinaryExpression(node.parent.parent) && getAssignmentDeclarationKind(node.parent.parent) === 2 /* ModuleExports */  || isCommonJsExportPropertyAssignment(node.parent);
    }
    function isCommonJsExportPropertyAssignment(node) {
        if (!isInJSFile(node)) return false;
        return isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 1 /* ExportsProperty */ ;
    }
    function isValidESSymbolDeclaration(node) {
        return (isVariableDeclaration(node) ? isVarConst(node) && isIdentifier(node.name) && isVariableDeclarationInVariableStatement(node) : isPropertyDeclaration(node) ? hasEffectiveReadonlyModifier(node) && hasStaticModifier(node) : isPropertySignature(node) && hasEffectiveReadonlyModifier(node)) || isCommonJsExportPropertyAssignment(node);
    }
    function introducesArgumentsExoticObject(node) {
        switch(node.kind){
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 177 /* Constructor */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
                return true;
        }
        return false;
    }
    function unwrapInnermostStatementOfLabel(node, beforeUnwrapLabelCallback) {
        while(true){
            if (beforeUnwrapLabelCallback) beforeUnwrapLabelCallback(node);
            if (node.statement.kind !== 257 /* LabeledStatement */ ) return node.statement;
            node = node.statement;
        }
    }
    function isFunctionBlock(node) {
        return node && node.kind === 242 /* Block */  && isFunctionLike(node.parent);
    }
    function isObjectLiteralMethod(node) {
        return node && node.kind === 175 /* MethodDeclaration */  && node.parent.kind === 211 /* ObjectLiteralExpression */ ;
    }
    function isObjectLiteralOrClassExpressionMethodOrAccessor(node) {
        return (node.kind === 175 /* MethodDeclaration */  || node.kind === 178 /* GetAccessor */  || node.kind === 179 /* SetAccessor */ ) && (node.parent.kind === 211 /* ObjectLiteralExpression */  || node.parent.kind === 232 /* ClassExpression */ );
    }
    function isIdentifierTypePredicate(predicate) {
        return predicate && predicate.kind === 1 /* Identifier */ ;
    }
    function isThisTypePredicate(predicate) {
        return predicate && predicate.kind === 0 /* This */ ;
    }
    function forEachPropertyAssignment(objectLiteral, key, callback, key2) {
        return forEach(objectLiteral == null ? void 0 : objectLiteral.properties, (property)=>{
            if (!isPropertyAssignment(property)) return void 0;
            const propName = tryGetTextOfPropertyName(property.name);
            return key === propName || key2 && key2 === propName ? callback(property) : void 0;
        });
    }
    function getTsConfigObjectLiteralExpression(tsConfigSourceFile) {
        if (tsConfigSourceFile && tsConfigSourceFile.statements.length) {
            const expression = tsConfigSourceFile.statements[0].expression;
            return tryCast(expression, isObjectLiteralExpression);
        }
    }
    function getTsConfigPropArrayElementValue(tsConfigSourceFile, propKey, elementValue) {
        return forEachTsConfigPropArray(tsConfigSourceFile, propKey, (property)=>isArrayLiteralExpression(property.initializer) ? find(property.initializer.elements, (element)=>isStringLiteral(element) && element.text === elementValue) : void 0);
    }
    function forEachTsConfigPropArray(tsConfigSourceFile, propKey, callback) {
        return forEachPropertyAssignment(getTsConfigObjectLiteralExpression(tsConfigSourceFile), propKey, callback);
    }
    function getContainingFunction(node) {
        return findAncestor(node.parent, isFunctionLike);
    }
    function getContainingFunctionDeclaration(node) {
        return findAncestor(node.parent, isFunctionLikeDeclaration);
    }
    function getContainingClass(node) {
        return findAncestor(node.parent, isClassLike);
    }
    function getContainingClassStaticBlock(node) {
        return findAncestor(node.parent, (n)=>{
            if (isClassLike(n) || isFunctionLike(n)) return "quit";
            return isClassStaticBlockDeclaration(n);
        });
    }
    function getContainingFunctionOrClassStaticBlock(node) {
        return findAncestor(node.parent, isFunctionLikeOrClassStaticBlockDeclaration);
    }
    function getContainingClassExcludingClassDecorators(node) {
        const decorator = findAncestor(node.parent, (n)=>isClassLike(n) ? "quit" : isDecorator(n));
        return decorator && isClassLike(decorator.parent) ? getContainingClass(decorator.parent) : getContainingClass(decorator !== null && decorator !== void 0 ? decorator : node);
    }
    function getThisContainer(node, includeArrowFunctions, includeClassComputedPropertyName) {
        Debug.assert(node.kind !== 308 /* SourceFile */ );
        while(true){
            node = node.parent;
            if (!node) return Debug.fail();
            switch(node.kind){
                case 168 /* ComputedPropertyName */ :
                    if (includeClassComputedPropertyName && isClassLike(node.parent.parent)) return node;
                    node = node.parent.parent;
                    break;
                case 171 /* Decorator */ :
                    if (node.parent.kind === 170 /* Parameter */  && isClassElement(node.parent.parent)) node = node.parent.parent;
                    else if (isClassElement(node.parent)) node = node.parent;
                    break;
                case 220 /* ArrowFunction */ :
                    if (!includeArrowFunctions) continue;
                // falls through
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 268 /* ModuleDeclaration */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 180 /* CallSignature */ :
                case 181 /* ConstructSignature */ :
                case 182 /* IndexSignature */ :
                case 267 /* EnumDeclaration */ :
                case 308 /* SourceFile */ :
                    return node;
            }
        }
    }
    function isThisContainerOrFunctionBlock(node) {
        switch(node.kind){
            // Arrow functions use the same scope, but may do so in a "delayed" manner
            // For example, `const getThis = () => this` may be before a super() call in a derived constructor
            case 220 /* ArrowFunction */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 173 /* PropertyDeclaration */ :
                return true;
            case 242 /* Block */ :
                switch(node.parent.kind){
                    case 177 /* Constructor */ :
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        return true;
                    default:
                        return false;
                }
            default:
                return false;
        }
    }
    function isInTopLevelContext(node) {
        if (isIdentifier(node) && (isClassDeclaration(node.parent) || isFunctionDeclaration(node.parent)) && node.parent.name === node) node = node.parent;
        const container = getThisContainer(node, /*includeArrowFunctions*/ true, /*includeClassComputedPropertyName*/ false);
        return isSourceFile(container);
    }
    function getNewTargetContainer(node) {
        const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
        if (container) switch(container.kind){
            case 177 /* Constructor */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
                return container;
        }
        return void 0;
    }
    function getSuperContainer(node, stopOnFunctions) {
        while(true){
            node = node.parent;
            if (!node) return void 0;
            switch(node.kind){
                case 168 /* ComputedPropertyName */ :
                    node = node.parent;
                    break;
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    if (!stopOnFunctions) continue;
                // falls through
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    return node;
                case 171 /* Decorator */ :
                    if (node.parent.kind === 170 /* Parameter */  && isClassElement(node.parent.parent)) node = node.parent.parent;
                    else if (isClassElement(node.parent)) node = node.parent;
                    break;
            }
        }
    }
    function getImmediatelyInvokedFunctionExpression(func) {
        if (func.kind === 219 /* FunctionExpression */  || func.kind === 220 /* ArrowFunction */ ) {
            let prev = func;
            let parent2 = func.parent;
            while(parent2.kind === 218 /* ParenthesizedExpression */ ){
                prev = parent2;
                parent2 = parent2.parent;
            }
            if (parent2.kind === 214 /* CallExpression */  && parent2.expression === prev) return parent2;
        }
    }
    function isSuperProperty(node) {
        const kind = node.kind;
        return (kind === 212 /* PropertyAccessExpression */  || kind === 213 /* ElementAccessExpression */ ) && node.expression.kind === 108 /* SuperKeyword */ ;
    }
    function isThisProperty(node) {
        const kind = node.kind;
        return (kind === 212 /* PropertyAccessExpression */  || kind === 213 /* ElementAccessExpression */ ) && node.expression.kind === 110 /* ThisKeyword */ ;
    }
    function isThisInitializedDeclaration(node) {
        var _a;
        return !!node && isVariableDeclaration(node) && ((_a = node.initializer) == null ? void 0 : _a.kind) === 110 /* ThisKeyword */ ;
    }
    function isThisInitializedObjectBindingExpression(node) {
        return !!node && (isShorthandPropertyAssignment(node) || isPropertyAssignment(node)) && isBinaryExpression(node.parent.parent) && node.parent.parent.operatorToken.kind === 64 /* EqualsToken */  && node.parent.parent.right.kind === 110 /* ThisKeyword */ ;
    }
    function getEntityNameFromTypeNode(node) {
        switch(node.kind){
            case 184 /* TypeReference */ :
                return node.typeName;
            case 234 /* ExpressionWithTypeArguments */ :
                return isEntityNameExpression(node.expression) ? node.expression : void 0;
            // TODO(rbuckton): These aren't valid TypeNodes, but we treat them as such because of `isPartOfTypeNode`, which returns `true` for things that aren't `TypeNode`s.
            case 80 /* Identifier */ :
            case 167 /* QualifiedName */ :
                return node;
        }
        return void 0;
    }
    function getInvokedExpression(node) {
        switch(node.kind){
            case 216 /* TaggedTemplateExpression */ :
                return node.tag;
            case 287 /* JsxOpeningElement */ :
            case 286 /* JsxSelfClosingElement */ :
                return node.tagName;
            case 227 /* BinaryExpression */ :
                return node.right;
            case 290 /* JsxOpeningFragment */ :
                return node;
            default:
                return node.expression;
        }
    }
    function nodeCanBeDecorated(useLegacyDecorators, node, parent2, grandparent) {
        if (useLegacyDecorators && isNamedDeclaration(node) && isPrivateIdentifier(node.name)) return false;
        switch(node.kind){
            case 264 /* ClassDeclaration */ :
                return true;
            case 232 /* ClassExpression */ :
                return !useLegacyDecorators;
            case 173 /* PropertyDeclaration */ :
                return parent2 !== void 0 && (useLegacyDecorators ? isClassDeclaration(parent2) : isClassLike(parent2) && !hasAbstractModifier(node) && !hasAmbientModifier(node));
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 175 /* MethodDeclaration */ :
                return node.body !== void 0 && parent2 !== void 0 && (useLegacyDecorators ? isClassDeclaration(parent2) : isClassLike(parent2));
            case 170 /* Parameter */ :
                if (!useLegacyDecorators) return false;
                return parent2 !== void 0 && parent2.body !== void 0 && (parent2.kind === 177 /* Constructor */  || parent2.kind === 175 /* MethodDeclaration */  || parent2.kind === 179 /* SetAccessor */ ) && getThisParameter(parent2) !== node && grandparent !== void 0 && grandparent.kind === 264 /* ClassDeclaration */ ;
        }
        return false;
    }
    function nodeIsDecorated(useLegacyDecorators, node, parent2, grandparent) {
        return hasDecorators(node) && nodeCanBeDecorated(useLegacyDecorators, node, parent2, grandparent);
    }
    function nodeOrChildIsDecorated(useLegacyDecorators, node, parent2, grandparent) {
        return nodeIsDecorated(useLegacyDecorators, node, parent2, grandparent) || childIsDecorated(useLegacyDecorators, node, parent2);
    }
    function childIsDecorated(useLegacyDecorators, node, parent2) {
        switch(node.kind){
            case 264 /* ClassDeclaration */ :
                return some(node.members, (m)=>nodeOrChildIsDecorated(useLegacyDecorators, m, node, parent2));
            case 232 /* ClassExpression */ :
                return !useLegacyDecorators && some(node.members, (m)=>nodeOrChildIsDecorated(useLegacyDecorators, m, node, parent2));
            case 175 /* MethodDeclaration */ :
            case 179 /* SetAccessor */ :
            case 177 /* Constructor */ :
                return some(node.parameters, (p)=>nodeIsDecorated(useLegacyDecorators, p, node, parent2));
            default:
                return false;
        }
    }
    function classOrConstructorParameterIsDecorated(useLegacyDecorators, node) {
        if (nodeIsDecorated(useLegacyDecorators, node)) return true;
        const constructor = getFirstConstructorWithBody(node);
        return !!constructor && childIsDecorated(useLegacyDecorators, constructor, node);
    }
    function classElementOrClassElementParameterIsDecorated(useLegacyDecorators, node, parent2) {
        let parameters;
        if (isAccessor(node)) {
            const { firstAccessor, secondAccessor, setAccessor } = getAllAccessorDeclarations(parent2.members, node);
            const firstAccessorWithDecorators = hasDecorators(firstAccessor) ? firstAccessor : secondAccessor && hasDecorators(secondAccessor) ? secondAccessor : void 0;
            if (!firstAccessorWithDecorators || node !== firstAccessorWithDecorators) return false;
            parameters = setAccessor == null ? void 0 : setAccessor.parameters;
        } else if (isMethodDeclaration(node)) parameters = node.parameters;
        if (nodeIsDecorated(useLegacyDecorators, node, parent2)) return true;
        if (parameters) for (const parameter of parameters){
            if (parameterIsThisKeyword(parameter)) continue;
            if (nodeIsDecorated(useLegacyDecorators, parameter, node, parent2)) return true;
        }
        return false;
    }
    function isEmptyStringLiteral(node) {
        if (node.textSourceNode) {
            switch(node.textSourceNode.kind){
                case 11 /* StringLiteral */ :
                    return isEmptyStringLiteral(node.textSourceNode);
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return node.text === "";
            }
            return false;
        }
        return node.text === "";
    }
    function isJSXTagName(node) {
        const { parent: parent2 } = node;
        if (parent2.kind === 287 /* JsxOpeningElement */  || parent2.kind === 286 /* JsxSelfClosingElement */  || parent2.kind === 288 /* JsxClosingElement */ ) return parent2.tagName === node;
        return false;
    }
    function isExpressionNode(node) {
        switch(node.kind){
            case 108 /* SuperKeyword */ :
            case 106 /* NullKeyword */ :
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 14 /* RegularExpressionLiteral */ :
            case 210 /* ArrayLiteralExpression */ :
            case 211 /* ObjectLiteralExpression */ :
            case 212 /* PropertyAccessExpression */ :
            case 213 /* ElementAccessExpression */ :
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
            case 216 /* TaggedTemplateExpression */ :
            case 235 /* AsExpression */ :
            case 217 /* TypeAssertionExpression */ :
            case 239 /* SatisfiesExpression */ :
            case 236 /* NonNullExpression */ :
            case 218 /* ParenthesizedExpression */ :
            case 219 /* FunctionExpression */ :
            case 232 /* ClassExpression */ :
            case 220 /* ArrowFunction */ :
            case 223 /* VoidExpression */ :
            case 221 /* DeleteExpression */ :
            case 222 /* TypeOfExpression */ :
            case 225 /* PrefixUnaryExpression */ :
            case 226 /* PostfixUnaryExpression */ :
            case 227 /* BinaryExpression */ :
            case 228 /* ConditionalExpression */ :
            case 231 /* SpreadElement */ :
            case 229 /* TemplateExpression */ :
            case 233 /* OmittedExpression */ :
            case 285 /* JsxElement */ :
            case 286 /* JsxSelfClosingElement */ :
            case 289 /* JsxFragment */ :
            case 230 /* YieldExpression */ :
            case 224 /* AwaitExpression */ :
                return true;
            case 237 /* MetaProperty */ :
                return !isImportCall(node.parent) || node.parent.expression !== node;
            case 234 /* ExpressionWithTypeArguments */ :
                return !isHeritageClause(node.parent) && !isJSDocAugmentsTag(node.parent);
            case 167 /* QualifiedName */ :
                while(node.parent.kind === 167 /* QualifiedName */ )node = node.parent;
                return node.parent.kind === 187 /* TypeQuery */  || isJSDocLinkLike(node.parent) || isJSDocNameReference(node.parent) || isJSDocMemberName(node.parent) || isJSXTagName(node);
            case 312 /* JSDocMemberName */ :
                while(isJSDocMemberName(node.parent))node = node.parent;
                return node.parent.kind === 187 /* TypeQuery */  || isJSDocLinkLike(node.parent) || isJSDocNameReference(node.parent) || isJSDocMemberName(node.parent) || isJSXTagName(node);
            case 81 /* PrivateIdentifier */ :
                return isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 103 /* InKeyword */ ;
            case 80 /* Identifier */ :
                if (node.parent.kind === 187 /* TypeQuery */  || isJSDocLinkLike(node.parent) || isJSDocNameReference(node.parent) || isJSDocMemberName(node.parent) || isJSXTagName(node)) return true;
            // falls through
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 110 /* ThisKeyword */ :
                return isInExpressionContext(node);
            default:
                return false;
        }
    }
    function isInExpressionContext(node) {
        const { parent: parent2 } = node;
        switch(parent2.kind){
            case 261 /* VariableDeclaration */ :
            case 170 /* Parameter */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 307 /* EnumMember */ :
            case 304 /* PropertyAssignment */ :
            case 209 /* BindingElement */ :
                return parent2.initializer === node;
            case 245 /* ExpressionStatement */ :
            case 246 /* IfStatement */ :
            case 247 /* DoStatement */ :
            case 248 /* WhileStatement */ :
            case 254 /* ReturnStatement */ :
            case 255 /* WithStatement */ :
            case 256 /* SwitchStatement */ :
            case 297 /* CaseClause */ :
            case 258 /* ThrowStatement */ :
                return parent2.expression === node;
            case 249 /* ForStatement */ :
                const forStatement = parent2;
                return forStatement.initializer === node && forStatement.initializer.kind !== 262 /* VariableDeclarationList */  || forStatement.condition === node || forStatement.incrementor === node;
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
                const forInOrOfStatement = parent2;
                return forInOrOfStatement.initializer === node && forInOrOfStatement.initializer.kind !== 262 /* VariableDeclarationList */  || forInOrOfStatement.expression === node;
            case 217 /* TypeAssertionExpression */ :
            case 235 /* AsExpression */ :
                return node === parent2.expression;
            case 240 /* TemplateSpan */ :
                return node === parent2.expression;
            case 168 /* ComputedPropertyName */ :
                return node === parent2.expression;
            case 171 /* Decorator */ :
            case 295 /* JsxExpression */ :
            case 294 /* JsxSpreadAttribute */ :
            case 306 /* SpreadAssignment */ :
                return true;
            case 234 /* ExpressionWithTypeArguments */ :
                return parent2.expression === node && !isPartOfTypeNode(parent2);
            case 305 /* ShorthandPropertyAssignment */ :
                return parent2.objectAssignmentInitializer === node;
            case 239 /* SatisfiesExpression */ :
                return node === parent2.expression;
            default:
                return isExpressionNode(parent2);
        }
    }
    function isPartOfTypeQuery(node) {
        while(node.kind === 167 /* QualifiedName */  || node.kind === 80 /* Identifier */ )node = node.parent;
        return node.kind === 187 /* TypeQuery */ ;
    }
    function isNamespaceReexportDeclaration(node) {
        return isNamespaceExport(node) && !!node.parent.moduleSpecifier;
    }
    function isExternalModuleImportEqualsDeclaration(node) {
        return node.kind === 272 /* ImportEqualsDeclaration */  && node.moduleReference.kind === 284 /* ExternalModuleReference */ ;
    }
    function getExternalModuleImportEqualsDeclarationExpression(node) {
        Debug.assert(isExternalModuleImportEqualsDeclaration(node));
        return node.moduleReference.expression;
    }
    function getExternalModuleRequireArgument(node) {
        return isVariableDeclarationInitializedToBareOrAccessedRequire(node) && getLeftmostAccessExpression(node.initializer).arguments[0];
    }
    function isInternalModuleImportEqualsDeclaration(node) {
        return node.kind === 272 /* ImportEqualsDeclaration */  && node.moduleReference.kind !== 284 /* ExternalModuleReference */ ;
    }
    function isFullSourceFile(sourceFile) {
        return (sourceFile == null ? void 0 : sourceFile.kind) === 308 /* SourceFile */ ;
    }
    function isSourceFileJS(file) {
        return isInJSFile(file);
    }
    function isInJSFile(node) {
        return !!node && !!(node.flags & 524288 /* JavaScriptFile */ );
    }
    function isInJsonFile(node) {
        return !!node && !!(node.flags & 134217728 /* JsonFile */ );
    }
    function isSourceFileNotJson(file) {
        return !isJsonSourceFile(file);
    }
    function isInJSDoc(node) {
        return !!node && !!(node.flags & 16777216 /* JSDoc */ );
    }
    function isJSDocIndexSignature(node) {
        return isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "Object" && node.typeArguments && node.typeArguments.length === 2 && (node.typeArguments[0].kind === 154 /* StringKeyword */  || node.typeArguments[0].kind === 150 /* NumberKeyword */ );
    }
    function isRequireCall(callExpression, requireStringLiteralLikeArgument) {
        if (callExpression.kind !== 214 /* CallExpression */ ) return false;
        const { expression, arguments: args } = callExpression;
        if (expression.kind !== 80 /* Identifier */  || expression.escapedText !== "require") return false;
        if (args.length !== 1) return false;
        const arg = args[0];
        return !requireStringLiteralLikeArgument || isStringLiteralLike(arg);
    }
    function isVariableDeclarationInitializedToRequire(node) {
        return isVariableDeclarationInitializedWithRequireHelper(node, /*allowAccessedRequire*/ false);
    }
    function isVariableDeclarationInitializedToBareOrAccessedRequire(node) {
        return isVariableDeclarationInitializedWithRequireHelper(node, /*allowAccessedRequire*/ true);
    }
    function isBindingElementOfBareOrAccessedRequire(node) {
        return isBindingElement(node) && isVariableDeclarationInitializedToBareOrAccessedRequire(node.parent.parent);
    }
    function isVariableDeclarationInitializedWithRequireHelper(node, allowAccessedRequire) {
        return isVariableDeclaration(node) && !!node.initializer && isRequireCall(allowAccessedRequire ? getLeftmostAccessExpression(node.initializer) : node.initializer, /*requireStringLiteralLikeArgument*/ true);
    }
    function isRequireVariableStatement(node) {
        return isVariableStatement(node) && node.declarationList.declarations.length > 0 && every(node.declarationList.declarations, (decl)=>isVariableDeclarationInitializedToRequire(decl));
    }
    function isSingleOrDoubleQuote(charCode) {
        return charCode === 39 /* singleQuote */  || charCode === 34 /* doubleQuote */ ;
    }
    function isStringDoubleQuoted(str, sourceFile) {
        return getSourceTextOfNodeFromSourceFile(sourceFile, str).charCodeAt(0) === 34 /* doubleQuote */ ;
    }
    function isAssignmentDeclaration(decl) {
        return isBinaryExpression(decl) || isAccessExpression(decl) || isIdentifier(decl) || isCallExpression(decl);
    }
    function getEffectiveInitializer(node) {
        if (isInJSFile(node) && node.initializer && isBinaryExpression(node.initializer) && (node.initializer.operatorToken.kind === 57 /* BarBarToken */  || node.initializer.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && node.name && isEntityNameExpression(node.name) && isSameEntityName(node.name, node.initializer.left)) return node.initializer.right;
        return node.initializer;
    }
    function getDeclaredExpandoInitializer(node) {
        const init = getEffectiveInitializer(node);
        return init && getExpandoInitializer(init, isPrototypeAccess(node.name));
    }
    function hasExpandoValueProperty(node, isPrototypeAssignment) {
        return forEach(node.properties, (p)=>isPropertyAssignment(p) && isIdentifier(p.name) && p.name.escapedText === "value" && p.initializer && getExpandoInitializer(p.initializer, isPrototypeAssignment));
    }
    function getAssignedExpandoInitializer(node) {
        if (node && node.parent && isBinaryExpression(node.parent) && node.parent.operatorToken.kind === 64 /* EqualsToken */ ) {
            const isPrototypeAssignment = isPrototypeAccess(node.parent.left);
            return getExpandoInitializer(node.parent.right, isPrototypeAssignment) || getDefaultedExpandoInitializer(node.parent.left, node.parent.right, isPrototypeAssignment);
        }
        if (node && isCallExpression(node) && isBindableObjectDefinePropertyCall(node)) {
            const result = hasExpandoValueProperty(node.arguments[2], node.arguments[1].text === "prototype");
            if (result) return result;
        }
    }
    function getExpandoInitializer(initializer, isPrototypeAssignment) {
        if (isCallExpression(initializer)) {
            const e = skipParentheses(initializer.expression);
            return e.kind === 219 /* FunctionExpression */  || e.kind === 220 /* ArrowFunction */  ? initializer : void 0;
        }
        if (initializer.kind === 219 /* FunctionExpression */  || initializer.kind === 232 /* ClassExpression */  || initializer.kind === 220 /* ArrowFunction */ ) return initializer;
        if (isObjectLiteralExpression(initializer) && (initializer.properties.length === 0 || isPrototypeAssignment)) return initializer;
    }
    function getDefaultedExpandoInitializer(name, initializer, isPrototypeAssignment) {
        const e = isBinaryExpression(initializer) && (initializer.operatorToken.kind === 57 /* BarBarToken */  || initializer.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && getExpandoInitializer(initializer.right, isPrototypeAssignment);
        if (e && isSameEntityName(name, initializer.left)) return e;
    }
    function isDefaultedExpandoInitializer(node) {
        const name = isVariableDeclaration(node.parent) ? node.parent.name : isBinaryExpression(node.parent) && node.parent.operatorToken.kind === 64 /* EqualsToken */  ? node.parent.left : void 0;
        return name && getExpandoInitializer(node.right, isPrototypeAccess(name)) && isEntityNameExpression(name) && isSameEntityName(name, node.left);
    }
    function getNameOfExpando(node) {
        if (isBinaryExpression(node.parent)) {
            const parent2 = (node.parent.operatorToken.kind === 57 /* BarBarToken */  || node.parent.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && isBinaryExpression(node.parent.parent) ? node.parent.parent : node.parent;
            if (parent2.operatorToken.kind === 64 /* EqualsToken */  && isIdentifier(parent2.left)) return parent2.left;
        } else if (isVariableDeclaration(node.parent)) return node.parent.name;
    }
    function isSameEntityName(name, initializer) {
        if (isPropertyNameLiteral(name) && isPropertyNameLiteral(initializer)) return getTextOfIdentifierOrLiteral(name) === getTextOfIdentifierOrLiteral(initializer);
        if (isMemberName(name) && isLiteralLikeAccess(initializer) && (initializer.expression.kind === 110 /* ThisKeyword */  || isIdentifier(initializer.expression) && (initializer.expression.escapedText === "window" || initializer.expression.escapedText === "self" || initializer.expression.escapedText === "global"))) return isSameEntityName(name, getNameOrArgument(initializer));
        if (isLiteralLikeAccess(name) && isLiteralLikeAccess(initializer)) return getElementOrPropertyAccessName(name) === getElementOrPropertyAccessName(initializer) && isSameEntityName(name.expression, initializer.expression);
        return false;
    }
    function getRightMostAssignedExpression(node) {
        while(isAssignmentExpression(node, /*excludeCompoundAssignment*/ true))node = node.right;
        return node;
    }
    function isExportsIdentifier(node) {
        return isIdentifier(node) && node.escapedText === "exports";
    }
    function isModuleIdentifier(node) {
        return isIdentifier(node) && node.escapedText === "module";
    }
    function isModuleExportsAccessExpression(node) {
        return (isPropertyAccessExpression(node) || isLiteralLikeElementAccess(node)) && isModuleIdentifier(node.expression) && getElementOrPropertyAccessName(node) === "exports";
    }
    function getAssignmentDeclarationKind(expr) {
        const special = getAssignmentDeclarationKindWorker(expr);
        return special === 5 /* Property */  || isInJSFile(expr) ? special : 0 /* None */ ;
    }
    function isBindableObjectDefinePropertyCall(expr) {
        return length(expr.arguments) === 3 && isPropertyAccessExpression(expr.expression) && isIdentifier(expr.expression.expression) && idText(expr.expression.expression) === "Object" && idText(expr.expression.name) === "defineProperty" && isStringOrNumericLiteralLike(expr.arguments[1]) && isBindableStaticNameExpression(expr.arguments[0], /*excludeThisKeyword*/ true);
    }
    function isLiteralLikeAccess(node) {
        return isPropertyAccessExpression(node) || isLiteralLikeElementAccess(node);
    }
    function isLiteralLikeElementAccess(node) {
        return isElementAccessExpression(node) && isStringOrNumericLiteralLike(node.argumentExpression);
    }
    function isBindableStaticAccessExpression(node, excludeThisKeyword) {
        return isPropertyAccessExpression(node) && (!excludeThisKeyword && node.expression.kind === 110 /* ThisKeyword */  || isIdentifier(node.name) && isBindableStaticNameExpression(node.expression, /*excludeThisKeyword*/ true)) || isBindableStaticElementAccessExpression(node, excludeThisKeyword);
    }
    function isBindableStaticElementAccessExpression(node, excludeThisKeyword) {
        return isLiteralLikeElementAccess(node) && (!excludeThisKeyword && node.expression.kind === 110 /* ThisKeyword */  || isEntityNameExpression(node.expression) || isBindableStaticAccessExpression(node.expression, /*excludeThisKeyword*/ true));
    }
    function isBindableStaticNameExpression(node, excludeThisKeyword) {
        return isEntityNameExpression(node) || isBindableStaticAccessExpression(node, excludeThisKeyword);
    }
    function getNameOrArgument(expr) {
        if (isPropertyAccessExpression(expr)) return expr.name;
        return expr.argumentExpression;
    }
    function getAssignmentDeclarationKindWorker(expr) {
        if (isCallExpression(expr)) {
            if (!isBindableObjectDefinePropertyCall(expr)) return 0 /* None */ ;
            const entityName = expr.arguments[0];
            if (isExportsIdentifier(entityName) || isModuleExportsAccessExpression(entityName)) return 8 /* ObjectDefinePropertyExports */ ;
            if (isBindableStaticAccessExpression(entityName) && getElementOrPropertyAccessName(entityName) === "prototype") return 9 /* ObjectDefinePrototypeProperty */ ;
            return 7 /* ObjectDefinePropertyValue */ ;
        }
        if (expr.operatorToken.kind !== 64 /* EqualsToken */  || !isAccessExpression(expr.left) || isVoidZero(getRightMostAssignedExpression(expr))) return 0 /* None */ ;
        if (isBindableStaticNameExpression(expr.left.expression, /*excludeThisKeyword*/ true) && getElementOrPropertyAccessName(expr.left) === "prototype" && isObjectLiteralExpression(getInitializerOfBinaryExpression(expr))) return 6 /* Prototype */ ;
        return getAssignmentDeclarationPropertyAccessKind(expr.left);
    }
    function isVoidZero(node) {
        return isVoidExpression(node) && isNumericLiteral(node.expression) && node.expression.text === "0";
    }
    function getElementOrPropertyAccessArgumentExpressionOrName(node) {
        if (isPropertyAccessExpression(node)) return node.name;
        const arg = skipParentheses(node.argumentExpression);
        if (isNumericLiteral(arg) || isStringLiteralLike(arg)) return arg;
        return node;
    }
    function getElementOrPropertyAccessName(node) {
        const name = getElementOrPropertyAccessArgumentExpressionOrName(node);
        if (name) {
            if (isIdentifier(name)) return name.escapedText;
            if (isStringLiteralLike(name) || isNumericLiteral(name)) return escapeLeadingUnderscores(name.text);
        }
        return void 0;
    }
    function getAssignmentDeclarationPropertyAccessKind(lhs) {
        if (lhs.expression.kind === 110 /* ThisKeyword */ ) return 4 /* ThisProperty */ ;
        else if (isModuleExportsAccessExpression(lhs)) return 2 /* ModuleExports */ ;
        else if (isBindableStaticNameExpression(lhs.expression, /*excludeThisKeyword*/ true)) {
            if (isPrototypeAccess(lhs.expression)) return 3 /* PrototypeProperty */ ;
            let nextToLast = lhs;
            while(!isIdentifier(nextToLast.expression))nextToLast = nextToLast.expression;
            const id = nextToLast.expression;
            if ((id.escapedText === "exports" || id.escapedText === "module" && getElementOrPropertyAccessName(nextToLast) === "exports") && // ExportsProperty does not support binding with computed names
            isBindableStaticAccessExpression(lhs)) return 1 /* ExportsProperty */ ;
            if (isBindableStaticNameExpression(lhs, /*excludeThisKeyword*/ true) || isElementAccessExpression(lhs) && isDynamicName(lhs)) return 5 /* Property */ ;
        }
        return 0 /* None */ ;
    }
    function getInitializerOfBinaryExpression(expr) {
        while(isBinaryExpression(expr.right))expr = expr.right;
        return expr.right;
    }
    function isPrototypePropertyAssignment(node) {
        return isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 3 /* PrototypeProperty */ ;
    }
    function isSpecialPropertyDeclaration(expr) {
        return isInJSFile(expr) && expr.parent && expr.parent.kind === 245 /* ExpressionStatement */  && (!isElementAccessExpression(expr) || isLiteralLikeElementAccess(expr)) && !!getJSDocTypeTag(expr.parent);
    }
    function setValueDeclaration(symbol, node) {
        const { valueDeclaration } = symbol;
        if (!valueDeclaration || !(node.flags & 33554432 /* Ambient */  && !isInJSFile(node) && !(valueDeclaration.flags & 33554432 /* Ambient */ )) && isAssignmentDeclaration(valueDeclaration) && !isAssignmentDeclaration(node) || valueDeclaration.kind !== node.kind && isEffectiveModuleDeclaration(valueDeclaration)) symbol.valueDeclaration = node;
    }
    function isFunctionSymbol(symbol) {
        if (!symbol || !symbol.valueDeclaration) return false;
        const decl = symbol.valueDeclaration;
        return decl.kind === 263 /* FunctionDeclaration */  || isVariableDeclaration(decl) && decl.initializer && isFunctionLike(decl.initializer);
    }
    function canHaveModuleSpecifier(node) {
        switch(node == null ? void 0 : node.kind){
            case 261 /* VariableDeclaration */ :
            case 209 /* BindingElement */ :
            case 273 /* ImportDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 274 /* ImportClause */ :
            case 281 /* NamespaceExport */ :
            case 275 /* NamespaceImport */ :
            case 282 /* ExportSpecifier */ :
            case 277 /* ImportSpecifier */ :
            case 206 /* ImportType */ :
                return true;
        }
        return false;
    }
    function tryGetModuleSpecifierFromDeclaration(node) {
        var _a, _b;
        switch(node.kind){
            case 261 /* VariableDeclaration */ :
            case 209 /* BindingElement */ :
                return (_a = findAncestor(node.initializer, (node2)=>isRequireCall(node2, /*requireStringLiteralLikeArgument*/ true))) == null ? void 0 : _a.arguments[0];
            case 273 /* ImportDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 352 /* JSDocImportTag */ :
                return tryCast(node.moduleSpecifier, isStringLiteralLike);
            case 272 /* ImportEqualsDeclaration */ :
                return tryCast((_b = tryCast(node.moduleReference, isExternalModuleReference)) == null ? void 0 : _b.expression, isStringLiteralLike);
            case 274 /* ImportClause */ :
            case 281 /* NamespaceExport */ :
                return tryCast(node.parent.moduleSpecifier, isStringLiteralLike);
            case 275 /* NamespaceImport */ :
            case 282 /* ExportSpecifier */ :
                return tryCast(node.parent.parent.moduleSpecifier, isStringLiteralLike);
            case 277 /* ImportSpecifier */ :
                return tryCast(node.parent.parent.parent.moduleSpecifier, isStringLiteralLike);
            case 206 /* ImportType */ :
                return isLiteralImportTypeNode(node) ? node.argument.literal : void 0;
            default:
                Debug.assertNever(node);
        }
    }
    function importFromModuleSpecifier(node) {
        return tryGetImportFromModuleSpecifier(node) || Debug.failBadSyntaxKind(node.parent);
    }
    function tryGetImportFromModuleSpecifier(node) {
        switch(node.parent.kind){
            case 273 /* ImportDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 352 /* JSDocImportTag */ :
                return node.parent;
            case 284 /* ExternalModuleReference */ :
                return node.parent.parent;
            case 214 /* CallExpression */ :
                return isImportCall(node.parent) || isRequireCall(node.parent, /*requireStringLiteralLikeArgument*/ false) ? node.parent : void 0;
            case 202 /* LiteralType */ :
                if (!isStringLiteral(node)) break;
                return tryCast(node.parent.parent, isImportTypeNode);
            default:
                return void 0;
        }
    }
    function shouldRewriteModuleSpecifier(specifier, compilerOptions) {
        return !!compilerOptions.rewriteRelativeImportExtensions && pathIsRelative(specifier) && !isDeclarationFileName(specifier) && hasTSFileExtension(specifier);
    }
    function getExternalModuleName(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 352 /* JSDocImportTag */ :
                return node.moduleSpecifier;
            case 272 /* ImportEqualsDeclaration */ :
                return node.moduleReference.kind === 284 /* ExternalModuleReference */  ? node.moduleReference.expression : void 0;
            case 206 /* ImportType */ :
                return isLiteralImportTypeNode(node) ? node.argument.literal : void 0;
            case 214 /* CallExpression */ :
                return node.arguments[0];
            case 268 /* ModuleDeclaration */ :
                return node.name.kind === 11 /* StringLiteral */  ? node.name : void 0;
            default:
                return Debug.assertNever(node);
        }
    }
    function getNamespaceDeclarationNode(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
                return node.importClause && tryCast(node.importClause.namedBindings, isNamespaceImport);
            case 272 /* ImportEqualsDeclaration */ :
                return node;
            case 279 /* ExportDeclaration */ :
                return node.exportClause && tryCast(node.exportClause, isNamespaceExport);
            default:
                return Debug.assertNever(node);
        }
    }
    function isDefaultImport(node) {
        return (node.kind === 273 /* ImportDeclaration */  || node.kind === 352 /* JSDocImportTag */ ) && !!node.importClause && !!node.importClause.name;
    }
    function forEachImportClauseDeclaration(node, action) {
        if (node.name) {
            const result = action(node);
            if (result) return result;
        }
        if (node.namedBindings) {
            const result = isNamespaceImport(node.namedBindings) ? action(node.namedBindings) : forEach(node.namedBindings.elements, action);
            if (result) return result;
        }
    }
    function hasQuestionToken(node) {
        switch(node.kind){
            case 170 /* Parameter */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 304 /* PropertyAssignment */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
                return node.questionToken !== void 0;
        }
        return false;
    }
    function isJSDocConstructSignature(node) {
        const param = isJSDocFunctionType(node) ? firstOrUndefined(node.parameters) : void 0;
        const name = tryCast(param && param.name, isIdentifier);
        return !!name && name.escapedText === "new";
    }
    function isJSDocTypeAlias(node) {
        return node.kind === 347 /* JSDocTypedefTag */  || node.kind === 339 /* JSDocCallbackTag */  || node.kind === 341 /* JSDocEnumTag */ ;
    }
    function isTypeAlias(node) {
        return isJSDocTypeAlias(node) || isTypeAliasDeclaration(node);
    }
    function getSourceOfAssignment(node) {
        return isExpressionStatement(node) && isBinaryExpression(node.expression) && node.expression.operatorToken.kind === 64 /* EqualsToken */  ? getRightMostAssignedExpression(node.expression) : void 0;
    }
    function getSourceOfDefaultedAssignment(node) {
        return isExpressionStatement(node) && isBinaryExpression(node.expression) && getAssignmentDeclarationKind(node.expression) !== 0 /* None */  && isBinaryExpression(node.expression.right) && (node.expression.right.operatorToken.kind === 57 /* BarBarToken */  || node.expression.right.operatorToken.kind === 61 /* QuestionQuestionToken */ ) ? node.expression.right.right : void 0;
    }
    function getSingleInitializerOfVariableStatementOrPropertyDeclaration(node) {
        switch(node.kind){
            case 244 /* VariableStatement */ :
                const v1 = getSingleVariableOfVariableStatement(node);
                return v1 && v1.initializer;
            case 173 /* PropertyDeclaration */ :
                return node.initializer;
            case 304 /* PropertyAssignment */ :
                return node.initializer;
        }
    }
    function getSingleVariableOfVariableStatement(node) {
        return isVariableStatement(node) ? firstOrUndefined(node.declarationList.declarations) : void 0;
    }
    function getNestedModuleDeclaration(node) {
        return isModuleDeclaration(node) && node.body && node.body.kind === 268 /* ModuleDeclaration */  ? node.body : void 0;
    }
    function canHaveFlowNode(node) {
        if (node.kind >= 244 /* FirstStatement */  && node.kind <= 260 /* LastStatement */ ) return true;
        switch(node.kind){
            case 80 /* Identifier */ :
            case 110 /* ThisKeyword */ :
            case 108 /* SuperKeyword */ :
            case 167 /* QualifiedName */ :
            case 237 /* MetaProperty */ :
            case 213 /* ElementAccessExpression */ :
            case 212 /* PropertyAccessExpression */ :
            case 209 /* BindingElement */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return true;
            default:
                return false;
        }
    }
    function canHaveJSDoc(node) {
        switch(node.kind){
            case 220 /* ArrowFunction */ :
            case 227 /* BinaryExpression */ :
            case 242 /* Block */ :
            case 253 /* BreakStatement */ :
            case 180 /* CallSignature */ :
            case 297 /* CaseClause */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 176 /* ClassStaticBlockDeclaration */ :
            case 177 /* Constructor */ :
            case 186 /* ConstructorType */ :
            case 181 /* ConstructSignature */ :
            case 252 /* ContinueStatement */ :
            case 260 /* DebuggerStatement */ :
            case 247 /* DoStatement */ :
            case 213 /* ElementAccessExpression */ :
            case 243 /* EmptyStatement */ :
            case 1 /* EndOfFileToken */ :
            case 267 /* EnumDeclaration */ :
            case 307 /* EnumMember */ :
            case 278 /* ExportAssignment */ :
            case 279 /* ExportDeclaration */ :
            case 282 /* ExportSpecifier */ :
            case 245 /* ExpressionStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 249 /* ForStatement */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 185 /* FunctionType */ :
            case 178 /* GetAccessor */ :
            case 80 /* Identifier */ :
            case 246 /* IfStatement */ :
            case 273 /* ImportDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 182 /* IndexSignature */ :
            case 265 /* InterfaceDeclaration */ :
            case 318 /* JSDocFunctionType */ :
            case 324 /* JSDocSignature */ :
            case 257 /* LabeledStatement */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 268 /* ModuleDeclaration */ :
            case 203 /* NamedTupleMember */ :
            case 271 /* NamespaceExportDeclaration */ :
            case 211 /* ObjectLiteralExpression */ :
            case 170 /* Parameter */ :
            case 218 /* ParenthesizedExpression */ :
            case 212 /* PropertyAccessExpression */ :
            case 304 /* PropertyAssignment */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 254 /* ReturnStatement */ :
            case 241 /* SemicolonClassElement */ :
            case 179 /* SetAccessor */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 306 /* SpreadAssignment */ :
            case 256 /* SwitchStatement */ :
            case 258 /* ThrowStatement */ :
            case 259 /* TryStatement */ :
            case 266 /* TypeAliasDeclaration */ :
            case 169 /* TypeParameter */ :
            case 261 /* VariableDeclaration */ :
            case 244 /* VariableStatement */ :
            case 248 /* WhileStatement */ :
            case 255 /* WithStatement */ :
                return true;
            default:
                return false;
        }
    }
    function getJSDocCommentsAndTags(hostNode, noCache) {
        let result;
        if (isVariableLike(hostNode) && hasInitializer(hostNode) && hasJSDocNodes(hostNode.initializer)) result = addRange(result, filterOwnedJSDocTags(hostNode, hostNode.initializer.jsDoc));
        let node = hostNode;
        while(node && node.parent){
            if (hasJSDocNodes(node)) result = addRange(result, filterOwnedJSDocTags(hostNode, node.jsDoc));
            if (node.kind === 170 /* Parameter */ ) {
                result = addRange(result, (noCache ? getJSDocParameterTagsNoCache : getJSDocParameterTags)(node));
                break;
            }
            if (node.kind === 169 /* TypeParameter */ ) {
                result = addRange(result, (noCache ? getJSDocTypeParameterTagsNoCache : getJSDocTypeParameterTags)(node));
                break;
            }
            node = getNextJSDocCommentLocation(node);
        }
        return result || emptyArray;
    }
    function filterOwnedJSDocTags(hostNode, comments) {
        const lastJsDoc = last(comments);
        return flatMap(comments, (jsDoc)=>{
            if (jsDoc === lastJsDoc) {
                const ownedTags = filter(jsDoc.tags, (tag)=>ownsJSDocTag(hostNode, tag));
                return jsDoc.tags === ownedTags ? [
                    jsDoc
                ] : ownedTags;
            } else return filter(jsDoc.tags, isJSDocOverloadTag);
        });
    }
    function ownsJSDocTag(hostNode, tag) {
        return !(isJSDocTypeTag(tag) || isJSDocSatisfiesTag(tag)) || !tag.parent || !isJSDoc(tag.parent) || !isParenthesizedExpression(tag.parent.parent) || tag.parent.parent === hostNode;
    }
    function getNextJSDocCommentLocation(node) {
        const parent2 = node.parent;
        if (parent2.kind === 304 /* PropertyAssignment */  || parent2.kind === 278 /* ExportAssignment */  || parent2.kind === 173 /* PropertyDeclaration */  || parent2.kind === 245 /* ExpressionStatement */  && node.kind === 212 /* PropertyAccessExpression */  || parent2.kind === 254 /* ReturnStatement */  || getNestedModuleDeclaration(parent2) || isAssignmentExpression(node)) return parent2;
        else if (parent2.parent && (getSingleVariableOfVariableStatement(parent2.parent) === node || isAssignmentExpression(parent2))) return parent2.parent;
        else if (parent2.parent && parent2.parent.parent && (getSingleVariableOfVariableStatement(parent2.parent.parent) || getSingleInitializerOfVariableStatementOrPropertyDeclaration(parent2.parent.parent) === node || getSourceOfDefaultedAssignment(parent2.parent.parent))) return parent2.parent.parent;
    }
    function getParameterSymbolFromJSDoc(node) {
        if (node.symbol) return node.symbol;
        if (!isIdentifier(node.name)) return void 0;
        const name = node.name.escapedText;
        const decl = getHostSignatureFromJSDoc(node);
        if (!decl) return void 0;
        const parameter = find(decl.parameters, (p)=>p.name.kind === 80 /* Identifier */  && p.name.escapedText === name);
        return parameter && parameter.symbol;
    }
    function getEffectiveContainerForJSDocTemplateTag(node) {
        if (isJSDoc(node.parent) && node.parent.tags) {
            const typeAlias = find(node.parent.tags, isJSDocTypeAlias);
            if (typeAlias) return typeAlias;
        }
        return getHostSignatureFromJSDoc(node);
    }
    function getJSDocOverloadTags(node) {
        return getAllJSDocTags(node, isJSDocOverloadTag);
    }
    function getHostSignatureFromJSDoc(node) {
        const host = getEffectiveJSDocHost(node);
        if (host) return isPropertySignature(host) && host.type && isFunctionLike(host.type) ? host.type : isFunctionLike(host) ? host : void 0;
        return void 0;
    }
    function getEffectiveJSDocHost(node) {
        const host = getJSDocHost(node);
        if (host) return getSourceOfDefaultedAssignment(host) || getSourceOfAssignment(host) || getSingleInitializerOfVariableStatementOrPropertyDeclaration(host) || getSingleVariableOfVariableStatement(host) || getNestedModuleDeclaration(host) || host;
    }
    function getJSDocHost(node) {
        const jsDoc = getJSDocRoot(node);
        if (!jsDoc) return void 0;
        const host = jsDoc.parent;
        if (host && host.jsDoc && jsDoc === lastOrUndefined(host.jsDoc)) return host;
    }
    function getJSDocRoot(node) {
        return findAncestor(node.parent, isJSDoc);
    }
    function getTypeParameterFromJsDoc(node) {
        const name = node.name.escapedText;
        const { typeParameters } = node.parent.parent.parent;
        return typeParameters && find(typeParameters, (p)=>p.name.escapedText === name);
    }
    function hasTypeArguments(node) {
        return !!node.typeArguments;
    }
    var AssignmentKind = /* @__PURE__ */ ((AssignmentKind2)=>{
        AssignmentKind2[AssignmentKind2["None"] = 0] = "None";
        AssignmentKind2[AssignmentKind2["Definite"] = 1] = "Definite";
        AssignmentKind2[AssignmentKind2["Compound"] = 2] = "Compound";
        return AssignmentKind2;
    })(AssignmentKind || {});
    function getAssignmentTarget(node) {
        let parent2 = node.parent;
        while(true){
            switch(parent2.kind){
                case 227 /* BinaryExpression */ :
                    const binaryExpression = parent2;
                    const binaryOperator = binaryExpression.operatorToken.kind;
                    return isAssignmentOperator(binaryOperator) && binaryExpression.left === node ? binaryExpression : void 0;
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    const unaryExpression = parent2;
                    const unaryOperator = unaryExpression.operator;
                    return unaryOperator === 46 /* PlusPlusToken */  || unaryOperator === 47 /* MinusMinusToken */  ? unaryExpression : void 0;
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                    const forInOrOfStatement = parent2;
                    return forInOrOfStatement.initializer === node ? forInOrOfStatement : void 0;
                case 218 /* ParenthesizedExpression */ :
                case 210 /* ArrayLiteralExpression */ :
                case 231 /* SpreadElement */ :
                case 236 /* NonNullExpression */ :
                    node = parent2;
                    break;
                case 306 /* SpreadAssignment */ :
                    node = parent2.parent;
                    break;
                case 305 /* ShorthandPropertyAssignment */ :
                    if (parent2.name !== node) return void 0;
                    node = parent2.parent;
                    break;
                case 304 /* PropertyAssignment */ :
                    if (parent2.name === node) return void 0;
                    node = parent2.parent;
                    break;
                default:
                    return void 0;
            }
            parent2 = node.parent;
        }
    }
    function getAssignmentTargetKind(node) {
        const target = getAssignmentTarget(node);
        if (!target) return 0 /* None */ ;
        switch(target.kind){
            case 227 /* BinaryExpression */ :
                const binaryOperator = target.operatorToken.kind;
                return binaryOperator === 64 /* EqualsToken */  || isLogicalOrCoalescingAssignmentOperator(binaryOperator) ? 1 /* Definite */  : 2 /* Compound */ ;
            case 225 /* PrefixUnaryExpression */ :
            case 226 /* PostfixUnaryExpression */ :
                return 2 /* Compound */ ;
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
                return 1 /* Definite */ ;
        }
    }
    function isAssignmentTarget(node) {
        return !!getAssignmentTarget(node);
    }
    function isCompoundLikeAssignment(assignment) {
        const right = skipParentheses(assignment.right);
        return right.kind === 227 /* BinaryExpression */  && isShiftOperatorOrHigher(right.operatorToken.kind);
    }
    function isInCompoundLikeAssignment(node) {
        const target = getAssignmentTarget(node);
        return !!target && isAssignmentExpression(target, /*excludeCompoundAssignment*/ true) && isCompoundLikeAssignment(target);
    }
    function isNodeWithPossibleHoistedDeclaration(node) {
        switch(node.kind){
            case 242 /* Block */ :
            case 244 /* VariableStatement */ :
            case 255 /* WithStatement */ :
            case 246 /* IfStatement */ :
            case 256 /* SwitchStatement */ :
            case 270 /* CaseBlock */ :
            case 297 /* CaseClause */ :
            case 298 /* DefaultClause */ :
            case 257 /* LabeledStatement */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 247 /* DoStatement */ :
            case 248 /* WhileStatement */ :
            case 259 /* TryStatement */ :
            case 300 /* CatchClause */ :
                return true;
        }
        return false;
    }
    function isValueSignatureDeclaration(node) {
        return isFunctionExpression(node) || isArrowFunction(node) || isMethodOrAccessor(node) || isFunctionDeclaration(node) || isConstructorDeclaration(node);
    }
    function walkUp(node, kind) {
        while(node && node.kind === kind)node = node.parent;
        return node;
    }
    function walkUpParenthesizedTypes(node) {
        return walkUp(node, 197 /* ParenthesizedType */ );
    }
    function walkUpParenthesizedExpressions(node) {
        return walkUp(node, 218 /* ParenthesizedExpression */ );
    }
    function walkUpParenthesizedTypesAndGetParentAndChild(node) {
        let child;
        while(node && node.kind === 197 /* ParenthesizedType */ ){
            child = node;
            node = node.parent;
        }
        return [
            child,
            node
        ];
    }
    function skipTypeParentheses(node) {
        while(isParenthesizedTypeNode(node))node = node.type;
        return node;
    }
    function skipParentheses(node, excludeJSDocTypeAssertions) {
        const flags = excludeJSDocTypeAssertions ? -2147483647 /* ExcludeJSDocTypeAssertion */  : 1 /* Parentheses */ ;
        return skipOuterExpressions(node, flags);
    }
    function isDeleteTarget(node) {
        if (node.kind !== 212 /* PropertyAccessExpression */  && node.kind !== 213 /* ElementAccessExpression */ ) return false;
        node = walkUpParenthesizedExpressions(node.parent);
        return node && node.kind === 221 /* DeleteExpression */ ;
    }
    function isNodeDescendantOf(node, ancestor) {
        while(node){
            if (node === ancestor) return true;
            node = node.parent;
        }
        return false;
    }
    function isDeclarationName(name) {
        return !isSourceFile(name) && !isBindingPattern(name) && isDeclaration(name.parent) && name.parent.name === name;
    }
    function getDeclarationFromName(name) {
        const parent2 = name.parent;
        switch(name.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
                if (isComputedPropertyName(parent2)) return parent2.parent;
            // falls through
            case 80 /* Identifier */ :
                if (isDeclaration(parent2)) return parent2.name === name ? parent2 : void 0;
                else if (isQualifiedName(parent2)) {
                    const tag = parent2.parent;
                    return isJSDocParameterTag(tag) && tag.name === parent2 ? tag : void 0;
                } else {
                    const binExp = parent2.parent;
                    return isBinaryExpression(binExp) && getAssignmentDeclarationKind(binExp) !== 0 /* None */  && (binExp.left.symbol || binExp.symbol) && getNameOfDeclaration(binExp) === name ? binExp : void 0;
                }
            case 81 /* PrivateIdentifier */ :
                return isDeclaration(parent2) && parent2.name === name ? parent2 : void 0;
            default:
                return void 0;
        }
    }
    function isLiteralComputedPropertyDeclarationName(node) {
        return isStringOrNumericLiteralLike(node) && node.parent.kind === 168 /* ComputedPropertyName */  && isDeclaration(node.parent.parent);
    }
    function isIdentifierName(node) {
        const parent2 = node.parent;
        switch(parent2.kind){
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 307 /* EnumMember */ :
            case 304 /* PropertyAssignment */ :
            case 212 /* PropertyAccessExpression */ :
                return parent2.name === node;
            case 167 /* QualifiedName */ :
                return parent2.right === node;
            case 209 /* BindingElement */ :
            case 277 /* ImportSpecifier */ :
                return parent2.propertyName === node;
            case 282 /* ExportSpecifier */ :
            case 292 /* JsxAttribute */ :
            case 286 /* JsxSelfClosingElement */ :
            case 287 /* JsxOpeningElement */ :
            case 288 /* JsxClosingElement */ :
                return true;
        }
        return false;
    }
    function getAliasDeclarationFromName(node) {
        switch(node.parent.kind){
            case 274 /* ImportClause */ :
            case 277 /* ImportSpecifier */ :
            case 275 /* NamespaceImport */ :
            case 282 /* ExportSpecifier */ :
            case 278 /* ExportAssignment */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 281 /* NamespaceExport */ :
                return node.parent;
            case 167 /* QualifiedName */ :
                do node = node.parent;
                while (node.parent.kind === 167 /* QualifiedName */ );
                return getAliasDeclarationFromName(node);
        }
    }
    function isAliasableExpression(e) {
        return isEntityNameExpression(e) || isClassExpression(e);
    }
    function exportAssignmentIsAlias(node) {
        const e = getExportAssignmentExpression(node);
        return isAliasableExpression(e);
    }
    function getExportAssignmentExpression(node) {
        return isExportAssignment(node) ? node.expression : node.right;
    }
    function getPropertyAssignmentAliasLikeExpression(node) {
        return node.kind === 305 /* ShorthandPropertyAssignment */  ? node.name : node.kind === 304 /* PropertyAssignment */  ? node.initializer : node.parent.right;
    }
    function getEffectiveBaseTypeNode(node) {
        const baseType = getClassExtendsHeritageElement(node);
        if (baseType && isInJSFile(node)) {
            const tag = getJSDocAugmentsTag(node);
            if (tag) return tag.class;
        }
        return baseType;
    }
    function getClassExtendsHeritageElement(node) {
        const heritageClause = getHeritageClause(node.heritageClauses, 96 /* ExtendsKeyword */ );
        return heritageClause && heritageClause.types.length > 0 ? heritageClause.types[0] : void 0;
    }
    function getEffectiveImplementsTypeNodes(node) {
        if (isInJSFile(node)) return getJSDocImplementsTags(node).map((n)=>n.class);
        else {
            const heritageClause = getHeritageClause(node.heritageClauses, 119 /* ImplementsKeyword */ );
            return heritageClause == null ? void 0 : heritageClause.types;
        }
    }
    function getAllSuperTypeNodes(node) {
        return isInterfaceDeclaration(node) ? getInterfaceBaseTypeNodes(node) || emptyArray : isClassLike(node) ? concatenate(singleElementArray(getEffectiveBaseTypeNode(node)), getEffectiveImplementsTypeNodes(node)) || emptyArray : emptyArray;
    }
    function getInterfaceBaseTypeNodes(node) {
        const heritageClause = getHeritageClause(node.heritageClauses, 96 /* ExtendsKeyword */ );
        return heritageClause ? heritageClause.types : void 0;
    }
    function getHeritageClause(clauses, kind) {
        if (clauses) for (const clause of clauses){
            if (clause.token === kind) return clause;
        }
        return void 0;
    }
    function getAncestor(node, kind) {
        while(node){
            if (node.kind === kind) return node;
            node = node.parent;
        }
        return void 0;
    }
    function isKeyword(token) {
        return 83 /* FirstKeyword */  <= token && token <= 166 /* LastKeyword */ ;
    }
    function isPunctuation(token) {
        return 19 /* FirstPunctuation */  <= token && token <= 79 /* LastPunctuation */ ;
    }
    function isKeywordOrPunctuation(token) {
        return isKeyword(token) || isPunctuation(token);
    }
    function isContextualKeyword(token) {
        return 128 /* FirstContextualKeyword */  <= token && token <= 166 /* LastContextualKeyword */ ;
    }
    function isNonContextualKeyword(token) {
        return isKeyword(token) && !isContextualKeyword(token);
    }
    function isStringANonContextualKeyword(name) {
        const token = stringToToken(name);
        return token !== void 0 && isNonContextualKeyword(token);
    }
    function isIdentifierANonContextualKeyword(node) {
        const originalKeywordKind = identifierToKeywordKind(node);
        return !!originalKeywordKind && !isContextualKeyword(originalKeywordKind);
    }
    function isTrivia(token) {
        return 2 /* FirstTriviaToken */  <= token && token <= 7 /* LastTriviaToken */ ;
    }
    var FunctionFlags = /* @__PURE__ */ ((FunctionFlags2)=>{
        FunctionFlags2[FunctionFlags2["Normal"] = 0] = "Normal";
        FunctionFlags2[FunctionFlags2["Generator"] = 1] = "Generator";
        FunctionFlags2[FunctionFlags2["Async"] = 2] = "Async";
        FunctionFlags2[FunctionFlags2["Invalid"] = 4] = "Invalid";
        FunctionFlags2[FunctionFlags2["AsyncGenerator"] = 3] = "AsyncGenerator";
        return FunctionFlags2;
    })(FunctionFlags || {});
    function getFunctionFlags(node) {
        if (!node) return 4 /* Invalid */ ;
        let flags = 0 /* Normal */ ;
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 175 /* MethodDeclaration */ :
                if (node.asteriskToken) flags |= 1 /* Generator */ ;
            // falls through
            case 220 /* ArrowFunction */ :
                if (hasSyntacticModifier(node, 1024 /* Async */ )) flags |= 2 /* Async */ ;
                break;
        }
        if (!node.body) flags |= 4 /* Invalid */ ;
        return flags;
    }
    function isAsyncFunction(node) {
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 175 /* MethodDeclaration */ :
                return node.body !== void 0 && node.asteriskToken === void 0 && hasSyntacticModifier(node, 1024 /* Async */ );
        }
        return false;
    }
    function isStringOrNumericLiteralLike(node) {
        return isStringLiteralLike(node) || isNumericLiteral(node);
    }
    function isSignedNumericLiteral(node) {
        return isPrefixUnaryExpression(node) && (node.operator === 40 /* PlusToken */  || node.operator === 41 /* MinusToken */ ) && isNumericLiteral(node.operand);
    }
    function hasDynamicName(declaration) {
        const name = getNameOfDeclaration(declaration);
        return !!name && isDynamicName(name);
    }
    function isDynamicName(name) {
        if (!(name.kind === 168 /* ComputedPropertyName */  || name.kind === 213 /* ElementAccessExpression */ )) return false;
        const expr = isElementAccessExpression(name) ? skipParentheses(name.argumentExpression) : name.expression;
        return !isStringOrNumericLiteralLike(expr) && !isSignedNumericLiteral(expr);
    }
    function getPropertyNameForPropertyNameNode(name) {
        switch(name.kind){
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
                return name.escapedText;
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
                return escapeLeadingUnderscores(name.text);
            case 168 /* ComputedPropertyName */ :
                const nameExpression = name.expression;
                if (isStringOrNumericLiteralLike(nameExpression)) return escapeLeadingUnderscores(nameExpression.text);
                else if (isSignedNumericLiteral(nameExpression)) {
                    if (nameExpression.operator === 41 /* MinusToken */ ) return tokenToString(nameExpression.operator) + nameExpression.operand.text;
                    return nameExpression.operand.text;
                }
                return void 0;
            case 296 /* JsxNamespacedName */ :
                return getEscapedTextOfJsxNamespacedName(name);
            default:
                return Debug.assertNever(name);
        }
    }
    function isPropertyNameLiteral(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
                return true;
            default:
                return false;
        }
    }
    function getTextOfIdentifierOrLiteral(node) {
        return isMemberName(node) ? idText(node) : isJsxNamespacedName(node) ? getTextOfJsxNamespacedName(node) : node.text;
    }
    function getEscapedTextOfIdentifierOrLiteral(node) {
        return isMemberName(node) ? node.escapedText : isJsxNamespacedName(node) ? getEscapedTextOfJsxNamespacedName(node) : escapeLeadingUnderscores(node.text);
    }
    function getSymbolNameForPrivateIdentifier(containingClassSymbol, description3) {
        return `__#${getSymbolId(containingClassSymbol)}@${description3}`;
    }
    function isKnownSymbol(symbol) {
        return startsWith(symbol.escapedName, "__@");
    }
    function isPrivateIdentifierSymbol(symbol) {
        return startsWith(symbol.escapedName, "__#");
    }
    function isProtoSetter(node) {
        return isIdentifier(node) ? idText(node) === "__proto__" : isStringLiteral(node) && node.text === "__proto__";
    }
    function isAnonymousFunctionDefinition(node, cb) {
        node = skipOuterExpressions(node);
        switch(node.kind){
            case 232 /* ClassExpression */ :
                if (classHasDeclaredOrExplicitlyAssignedName(node)) return false;
                break;
            case 219 /* FunctionExpression */ :
                if (node.name) return false;
                break;
            case 220 /* ArrowFunction */ :
                break;
            default:
                return false;
        }
        return typeof cb === "function" ? cb(node) : true;
    }
    function isNamedEvaluationSource(node) {
        switch(node.kind){
            case 304 /* PropertyAssignment */ :
                return !isProtoSetter(node.name);
            case 305 /* ShorthandPropertyAssignment */ :
                return !!node.objectAssignmentInitializer;
            case 261 /* VariableDeclaration */ :
                return isIdentifier(node.name) && !!node.initializer;
            case 170 /* Parameter */ :
                return isIdentifier(node.name) && !!node.initializer && !node.dotDotDotToken;
            case 209 /* BindingElement */ :
                return isIdentifier(node.name) && !!node.initializer && !node.dotDotDotToken;
            case 173 /* PropertyDeclaration */ :
                return !!node.initializer;
            case 227 /* BinaryExpression */ :
                switch(node.operatorToken.kind){
                    case 64 /* EqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return isIdentifier(node.left);
                }
                break;
            case 278 /* ExportAssignment */ :
                return true;
        }
        return false;
    }
    function isNamedEvaluation(node, cb) {
        if (!isNamedEvaluationSource(node)) return false;
        switch(node.kind){
            case 304 /* PropertyAssignment */ :
                return isAnonymousFunctionDefinition(node.initializer, cb);
            case 305 /* ShorthandPropertyAssignment */ :
                return isAnonymousFunctionDefinition(node.objectAssignmentInitializer, cb);
            case 261 /* VariableDeclaration */ :
            case 170 /* Parameter */ :
            case 209 /* BindingElement */ :
            case 173 /* PropertyDeclaration */ :
                return isAnonymousFunctionDefinition(node.initializer, cb);
            case 227 /* BinaryExpression */ :
                return isAnonymousFunctionDefinition(node.right, cb);
            case 278 /* ExportAssignment */ :
                return isAnonymousFunctionDefinition(node.expression, cb);
        }
    }
    function isPushOrUnshiftIdentifier(node) {
        return node.escapedText === "push" || node.escapedText === "unshift";
    }
    function isPartOfParameterDeclaration(node) {
        const root = getRootDeclaration(node);
        return root.kind === 170 /* Parameter */ ;
    }
    function getRootDeclaration(node) {
        while(node.kind === 209 /* BindingElement */ )node = node.parent.parent;
        return node;
    }
    function nodeStartsNewLexicalEnvironment(node) {
        const kind = node.kind;
        return kind === 177 /* Constructor */  || kind === 219 /* FunctionExpression */  || kind === 263 /* FunctionDeclaration */  || kind === 220 /* ArrowFunction */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */  || kind === 268 /* ModuleDeclaration */  || kind === 308 /* SourceFile */ ;
    }
    function nodeIsSynthesized(range) {
        return positionIsSynthesized(range.pos) || positionIsSynthesized(range.end);
    }
    var Associativity = /* @__PURE__ */ ((Associativity2)=>{
        Associativity2[Associativity2["Left"] = 0] = "Left";
        Associativity2[Associativity2["Right"] = 1] = "Right";
        return Associativity2;
    })(Associativity || {});
    function getExpressionAssociativity(expression) {
        const operator = getOperator(expression);
        const hasArguments = expression.kind === 215 /* NewExpression */  && expression.arguments !== void 0;
        return getOperatorAssociativity(expression.kind, operator, hasArguments);
    }
    function getOperatorAssociativity(kind, operator, hasArguments) {
        switch(kind){
            case 215 /* NewExpression */ :
                return hasArguments ? 0 /* Left */  : 1 /* Right */ ;
            case 225 /* PrefixUnaryExpression */ :
            case 222 /* TypeOfExpression */ :
            case 223 /* VoidExpression */ :
            case 221 /* DeleteExpression */ :
            case 224 /* AwaitExpression */ :
            case 228 /* ConditionalExpression */ :
            case 230 /* YieldExpression */ :
                return 1 /* Right */ ;
            case 227 /* BinaryExpression */ :
                switch(operator){
                    case 43 /* AsteriskAsteriskToken */ :
                    case 64 /* EqualsToken */ :
                    case 65 /* PlusEqualsToken */ :
                    case 66 /* MinusEqualsToken */ :
                    case 68 /* AsteriskAsteriskEqualsToken */ :
                    case 67 /* AsteriskEqualsToken */ :
                    case 69 /* SlashEqualsToken */ :
                    case 70 /* PercentEqualsToken */ :
                    case 71 /* LessThanLessThanEqualsToken */ :
                    case 72 /* GreaterThanGreaterThanEqualsToken */ :
                    case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                    case 74 /* AmpersandEqualsToken */ :
                    case 79 /* CaretEqualsToken */ :
                    case 75 /* BarEqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return 1 /* Right */ ;
                }
        }
        return 0 /* Left */ ;
    }
    function getExpressionPrecedence(expression) {
        const operator = getOperator(expression);
        const hasArguments = expression.kind === 215 /* NewExpression */  && expression.arguments !== void 0;
        return getOperatorPrecedence(expression.kind, operator, hasArguments);
    }
    function getOperator(expression) {
        if (expression.kind === 227 /* BinaryExpression */ ) return expression.operatorToken.kind;
        else if (expression.kind === 225 /* PrefixUnaryExpression */  || expression.kind === 226 /* PostfixUnaryExpression */ ) return expression.operator;
        else return expression.kind;
    }
    var OperatorPrecedence = /* @__PURE__ */ ((OperatorPrecedence2)=>{
        OperatorPrecedence2[OperatorPrecedence2["Comma"] = 0] = "Comma";
        OperatorPrecedence2[OperatorPrecedence2["Spread"] = 1] = "Spread";
        OperatorPrecedence2[OperatorPrecedence2["Yield"] = 2] = "Yield";
        OperatorPrecedence2[OperatorPrecedence2["Assignment"] = 3] = "Assignment";
        OperatorPrecedence2[OperatorPrecedence2["Conditional"] = 4] = "Conditional";
        OperatorPrecedence2[OperatorPrecedence2["LogicalOR"] = 5] = "LogicalOR";
        OperatorPrecedence2[OperatorPrecedence2["Coalesce"] = 5 /* LogicalOR */ ] = "Coalesce";
        OperatorPrecedence2[OperatorPrecedence2["LogicalAND"] = 6] = "LogicalAND";
        OperatorPrecedence2[OperatorPrecedence2["BitwiseOR"] = 7] = "BitwiseOR";
        OperatorPrecedence2[OperatorPrecedence2["BitwiseXOR"] = 8] = "BitwiseXOR";
        OperatorPrecedence2[OperatorPrecedence2["BitwiseAND"] = 9] = "BitwiseAND";
        OperatorPrecedence2[OperatorPrecedence2["Equality"] = 10] = "Equality";
        OperatorPrecedence2[OperatorPrecedence2["Relational"] = 11] = "Relational";
        OperatorPrecedence2[OperatorPrecedence2["Shift"] = 12] = "Shift";
        OperatorPrecedence2[OperatorPrecedence2["Additive"] = 13] = "Additive";
        OperatorPrecedence2[OperatorPrecedence2["Multiplicative"] = 14] = "Multiplicative";
        OperatorPrecedence2[OperatorPrecedence2["Exponentiation"] = 15] = "Exponentiation";
        OperatorPrecedence2[OperatorPrecedence2["Unary"] = 16] = "Unary";
        OperatorPrecedence2[OperatorPrecedence2["Update"] = 17] = "Update";
        OperatorPrecedence2[OperatorPrecedence2["LeftHandSide"] = 18] = "LeftHandSide";
        OperatorPrecedence2[OperatorPrecedence2["Member"] = 19] = "Member";
        OperatorPrecedence2[OperatorPrecedence2["Primary"] = 20] = "Primary";
        OperatorPrecedence2[OperatorPrecedence2["Highest"] = 20 /* Primary */ ] = "Highest";
        OperatorPrecedence2[OperatorPrecedence2["Lowest"] = 0 /* Comma */ ] = "Lowest";
        OperatorPrecedence2[OperatorPrecedence2["Invalid"] = -1] = "Invalid";
        return OperatorPrecedence2;
    })(OperatorPrecedence || {});
    function getOperatorPrecedence(nodeKind, operatorKind, hasArguments) {
        switch(nodeKind){
            case 357 /* CommaListExpression */ :
                return 0 /* Comma */ ;
            case 231 /* SpreadElement */ :
                return 1 /* Spread */ ;
            case 230 /* YieldExpression */ :
                return 2 /* Yield */ ;
            case 228 /* ConditionalExpression */ :
                return 4 /* Conditional */ ;
            case 227 /* BinaryExpression */ :
                switch(operatorKind){
                    case 28 /* CommaToken */ :
                        return 0 /* Comma */ ;
                    case 64 /* EqualsToken */ :
                    case 65 /* PlusEqualsToken */ :
                    case 66 /* MinusEqualsToken */ :
                    case 68 /* AsteriskAsteriskEqualsToken */ :
                    case 67 /* AsteriskEqualsToken */ :
                    case 69 /* SlashEqualsToken */ :
                    case 70 /* PercentEqualsToken */ :
                    case 71 /* LessThanLessThanEqualsToken */ :
                    case 72 /* GreaterThanGreaterThanEqualsToken */ :
                    case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                    case 74 /* AmpersandEqualsToken */ :
                    case 79 /* CaretEqualsToken */ :
                    case 75 /* BarEqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return 3 /* Assignment */ ;
                    default:
                        return getBinaryOperatorPrecedence(operatorKind);
                }
            // TODO: Should prefix `++` and `--` be moved to the `Update` precedence?
            case 217 /* TypeAssertionExpression */ :
            case 236 /* NonNullExpression */ :
            case 225 /* PrefixUnaryExpression */ :
            case 222 /* TypeOfExpression */ :
            case 223 /* VoidExpression */ :
            case 221 /* DeleteExpression */ :
            case 224 /* AwaitExpression */ :
                return 16 /* Unary */ ;
            case 226 /* PostfixUnaryExpression */ :
                return 17 /* Update */ ;
            case 214 /* CallExpression */ :
                return 18 /* LeftHandSide */ ;
            case 215 /* NewExpression */ :
                return hasArguments ? 19 /* Member */  : 18 /* LeftHandSide */ ;
            case 216 /* TaggedTemplateExpression */ :
            case 212 /* PropertyAccessExpression */ :
            case 213 /* ElementAccessExpression */ :
            case 237 /* MetaProperty */ :
                return 19 /* Member */ ;
            case 235 /* AsExpression */ :
            case 239 /* SatisfiesExpression */ :
                return 11 /* Relational */ ;
            case 110 /* ThisKeyword */ :
            case 108 /* SuperKeyword */ :
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
            case 106 /* NullKeyword */ :
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 9 /* NumericLiteral */ :
            case 10 /* BigIntLiteral */ :
            case 11 /* StringLiteral */ :
            case 210 /* ArrayLiteralExpression */ :
            case 211 /* ObjectLiteralExpression */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 232 /* ClassExpression */ :
            case 14 /* RegularExpressionLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 229 /* TemplateExpression */ :
            case 218 /* ParenthesizedExpression */ :
            case 233 /* OmittedExpression */ :
            case 285 /* JsxElement */ :
            case 286 /* JsxSelfClosingElement */ :
            case 289 /* JsxFragment */ :
                return 20 /* Primary */ ;
            default:
                return -1 /* Invalid */ ;
        }
    }
    function getBinaryOperatorPrecedence(kind) {
        switch(kind){
            case 61 /* QuestionQuestionToken */ :
                return 5 /* Coalesce */ ;
            case 57 /* BarBarToken */ :
                return 5 /* LogicalOR */ ;
            case 56 /* AmpersandAmpersandToken */ :
                return 6 /* LogicalAND */ ;
            case 52 /* BarToken */ :
                return 7 /* BitwiseOR */ ;
            case 53 /* CaretToken */ :
                return 8 /* BitwiseXOR */ ;
            case 51 /* AmpersandToken */ :
                return 9 /* BitwiseAND */ ;
            case 35 /* EqualsEqualsToken */ :
            case 36 /* ExclamationEqualsToken */ :
            case 37 /* EqualsEqualsEqualsToken */ :
            case 38 /* ExclamationEqualsEqualsToken */ :
                return 10 /* Equality */ ;
            case 30 /* LessThanToken */ :
            case 32 /* GreaterThanToken */ :
            case 33 /* LessThanEqualsToken */ :
            case 34 /* GreaterThanEqualsToken */ :
            case 104 /* InstanceOfKeyword */ :
            case 103 /* InKeyword */ :
            case 130 /* AsKeyword */ :
            case 152 /* SatisfiesKeyword */ :
                return 11 /* Relational */ ;
            case 48 /* LessThanLessThanToken */ :
            case 49 /* GreaterThanGreaterThanToken */ :
            case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                return 12 /* Shift */ ;
            case 40 /* PlusToken */ :
            case 41 /* MinusToken */ :
                return 13 /* Additive */ ;
            case 42 /* AsteriskToken */ :
            case 44 /* SlashToken */ :
            case 45 /* PercentToken */ :
                return 14 /* Multiplicative */ ;
            case 43 /* AsteriskAsteriskToken */ :
                return 15 /* Exponentiation */ ;
        }
        return -1;
    }
    function getSemanticJsxChildren(children) {
        return filter(children, (i)=>{
            switch(i.kind){
                case 295 /* JsxExpression */ :
                    return !!i.expression;
                case 12 /* JsxText */ :
                    return !i.containsOnlyTriviaWhiteSpaces;
                default:
                    return true;
            }
        });
    }
    function createDiagnosticCollection() {
        let nonFileDiagnostics = [];
        const filesWithDiagnostics = [];
        const fileDiagnostics = /* @__PURE__ */ new Map();
        let hasReadNonFileDiagnostics = false;
        return {
            add,
            lookup,
            getGlobalDiagnostics,
            getDiagnostics: getDiagnostics2
        };
        function lookup(diagnostic) {
            let diagnostics;
            if (diagnostic.file) diagnostics = fileDiagnostics.get(diagnostic.file.fileName);
            else diagnostics = nonFileDiagnostics;
            if (!diagnostics) return void 0;
            const result = binarySearch(diagnostics, diagnostic, identity, compareDiagnosticsSkipRelatedInformation);
            if (result >= 0) return diagnostics[result];
            if (~result > 0 && diagnosticsEqualityComparer(diagnostic, diagnostics[~result - 1])) return diagnostics[~result - 1];
            return void 0;
        }
        function add(diagnostic) {
            let diagnostics;
            if (diagnostic.file) {
                diagnostics = fileDiagnostics.get(diagnostic.file.fileName);
                if (!diagnostics) {
                    diagnostics = [];
                    fileDiagnostics.set(diagnostic.file.fileName, diagnostics);
                    insertSorted(filesWithDiagnostics, diagnostic.file.fileName, compareStringsCaseSensitive);
                }
            } else {
                if (hasReadNonFileDiagnostics) {
                    hasReadNonFileDiagnostics = false;
                    nonFileDiagnostics = nonFileDiagnostics.slice();
                }
                diagnostics = nonFileDiagnostics;
            }
            insertSorted(diagnostics, diagnostic, compareDiagnosticsSkipRelatedInformation, diagnosticsEqualityComparer);
        }
        function getGlobalDiagnostics() {
            hasReadNonFileDiagnostics = true;
            return nonFileDiagnostics;
        }
        function getDiagnostics2(fileName) {
            if (fileName) return fileDiagnostics.get(fileName) || [];
            const fileDiags = flatMapToMutable(filesWithDiagnostics, (f)=>fileDiagnostics.get(f));
            if (!nonFileDiagnostics.length) return fileDiags;
            fileDiags.unshift(...nonFileDiagnostics);
            return fileDiags;
        }
    }
    var templateSubstitutionRegExp = /\$\{/g;
    function escapeTemplateSubstitution(str) {
        return str.replace(templateSubstitutionRegExp, "\\${");
    }
    function containsInvalidEscapeFlag(node) {
        return !!((node.templateFlags || 0) & 2048 /* ContainsInvalidEscape */ );
    }
    function hasInvalidEscape(template) {
        return template && !!(isNoSubstitutionTemplateLiteral(template) ? containsInvalidEscapeFlag(template) : containsInvalidEscapeFlag(template.head) || some(template.templateSpans, (span)=>containsInvalidEscapeFlag(span.literal)));
    }
    var doubleQuoteEscapedCharsRegExp = /[\\"\u0000-\u001f\u2028\u2029\u0085]/g;
    var singleQuoteEscapedCharsRegExp = /[\\'\u0000-\u001f\u2028\u2029\u0085]/g;
    var backtickQuoteEscapedCharsRegExp = /\r\n|[\\`\u0000-\u0009\u000b-\u001f\u2028\u2029\u0085]/g;
    var escapedCharsMap = new Map(Object.entries({
        "	": "\\t",
        "\v": "\\v",
        "\f": "\\f",
        "\b": "\\b",
        "\r": "\\r",
        "\n": "\\n",
        "\\": "\\\\",
        '"': '\\"',
        "'": "\\'",
        "`": "\\`",
        "\u2028": "\\u2028",
        // lineSeparator
        "\u2029": "\\u2029",
        // paragraphSeparator
        "\x85": "\\u0085",
        // nextLine
        "\r\n": "\\r\\n"
    }));
    function encodeUtf16EscapeSequence(charCode) {
        const hexCharCode = charCode.toString(16).toUpperCase();
        const paddedHexCode = ("0000" + hexCharCode).slice(-4);
        return "\\u" + paddedHexCode;
    }
    function getReplacement(c, offset, input) {
        if (c.charCodeAt(0) === 0 /* nullCharacter */ ) {
            const lookAhead = input.charCodeAt(offset + c.length);
            if (lookAhead >= 48 /* _0 */  && lookAhead <= 57 /* _9 */ ) return "\\x00";
            return "\\0";
        }
        return escapedCharsMap.get(c) || encodeUtf16EscapeSequence(c.charCodeAt(0));
    }
    function escapeString(s, quoteChar) {
        const escapedCharsRegExp = quoteChar === 96 /* backtick */  ? backtickQuoteEscapedCharsRegExp : quoteChar === 39 /* singleQuote */  ? singleQuoteEscapedCharsRegExp : doubleQuoteEscapedCharsRegExp;
        return s.replace(escapedCharsRegExp, getReplacement);
    }
    var nonAsciiCharacters = /[^\u0000-\u007F]/g;
    function escapeNonAsciiString(s, quoteChar) {
        s = escapeString(s, quoteChar);
        return nonAsciiCharacters.test(s) ? s.replace(nonAsciiCharacters, (c)=>encodeUtf16EscapeSequence(c.charCodeAt(0))) : s;
    }
    var jsxDoubleQuoteEscapedCharsRegExp = /["\u0000-\u001f\u2028\u2029\u0085]/g;
    var jsxSingleQuoteEscapedCharsRegExp = /['\u0000-\u001f\u2028\u2029\u0085]/g;
    var jsxEscapedCharsMap = new Map(Object.entries({
        '"': "&quot;",
        "'": "&apos;"
    }));
    function encodeJsxCharacterEntity(charCode) {
        const hexCharCode = charCode.toString(16).toUpperCase();
        return "&#x" + hexCharCode + ";";
    }
    function getJsxAttributeStringReplacement(c) {
        if (c.charCodeAt(0) === 0 /* nullCharacter */ ) return "&#0;";
        return jsxEscapedCharsMap.get(c) || encodeJsxCharacterEntity(c.charCodeAt(0));
    }
    function escapeJsxAttributeString(s, quoteChar) {
        const escapedCharsRegExp = quoteChar === 39 /* singleQuote */  ? jsxSingleQuoteEscapedCharsRegExp : jsxDoubleQuoteEscapedCharsRegExp;
        return s.replace(escapedCharsRegExp, getJsxAttributeStringReplacement);
    }
    function stripQuotes(name) {
        const length2 = name.length;
        if (length2 >= 2 && name.charCodeAt(0) === name.charCodeAt(length2 - 1) && isQuoteOrBacktick(name.charCodeAt(0))) return name.substring(1, length2 - 1);
        return name;
    }
    function isQuoteOrBacktick(charCode) {
        return charCode === 39 /* singleQuote */  || charCode === 34 /* doubleQuote */  || charCode === 96 /* backtick */ ;
    }
    function isIntrinsicJsxName(name) {
        const ch = name.charCodeAt(0);
        return ch >= 97 /* a */  && ch <= 122 /* z */  || name.includes("-");
    }
    var indentStrings = [
        "",
        "    "
    ];
    function getIndentString(level) {
        const singleLevel = indentStrings[1];
        for(let current = indentStrings.length; current <= level; current++)indentStrings.push(indentStrings[current - 1] + singleLevel);
        return indentStrings[level];
    }
    function getIndentSize() {
        return indentStrings[1].length;
    }
    function createTextWriter(newLine) {
        var output;
        var indent3;
        var lineStart;
        var lineCount;
        var linePos;
        var hasTrailingComment = false;
        function updateLineCountAndPosFor(s) {
            const lineStartsOfS = computeLineStarts(s);
            if (lineStartsOfS.length > 1) {
                lineCount = lineCount + lineStartsOfS.length - 1;
                linePos = output.length - s.length + last(lineStartsOfS);
                lineStart = linePos - output.length === 0;
            } else lineStart = false;
        }
        function writeText(s) {
            if (s && s.length) {
                if (lineStart) {
                    s = getIndentString(indent3) + s;
                    lineStart = false;
                }
                output += s;
                updateLineCountAndPosFor(s);
            }
        }
        function write(s) {
            if (s) hasTrailingComment = false;
            writeText(s);
        }
        function writeComment(s) {
            if (s) hasTrailingComment = true;
            writeText(s);
        }
        function reset2() {
            output = "";
            indent3 = 0;
            lineStart = true;
            lineCount = 0;
            linePos = 0;
            hasTrailingComment = false;
        }
        function rawWrite(s) {
            if (s !== void 0) {
                output += s;
                updateLineCountAndPosFor(s);
                hasTrailingComment = false;
            }
        }
        function writeLiteral(s) {
            if (s && s.length) write(s);
        }
        function writeLine(force) {
            if (!lineStart || force) {
                output += newLine;
                lineCount++;
                linePos = output.length;
                lineStart = true;
                hasTrailingComment = false;
            }
        }
        reset2();
        return {
            write,
            rawWrite,
            writeLiteral,
            writeLine,
            increaseIndent: ()=>{
                indent3++;
            },
            decreaseIndent: ()=>{
                indent3--;
            },
            getIndent: ()=>indent3,
            getTextPos: ()=>output.length,
            getLine: ()=>lineCount,
            getColumn: ()=>lineStart ? indent3 * getIndentSize() : output.length - linePos,
            getText: ()=>output,
            isAtStartOfLine: ()=>lineStart,
            hasTrailingComment: ()=>hasTrailingComment,
            hasTrailingWhitespace: ()=>!!output.length && isWhiteSpaceLike(output.charCodeAt(output.length - 1)),
            clear: reset2,
            writeKeyword: write,
            writeOperator: write,
            writeParameter: write,
            writeProperty: write,
            writePunctuation: write,
            writeSpace: write,
            writeStringLiteral: write,
            writeSymbol: (s, _)=>write(s),
            writeTrailingSemicolon: write,
            writeComment
        };
    }
    function getTrailingSemicolonDeferringWriter(writer) {
        let pendingTrailingSemicolon = false;
        function commitPendingTrailingSemicolon() {
            if (pendingTrailingSemicolon) {
                writer.writeTrailingSemicolon(";");
                pendingTrailingSemicolon = false;
            }
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, writer), {
            writeTrailingSemicolon () {
                pendingTrailingSemicolon = true;
            },
            writeLiteral (s) {
                commitPendingTrailingSemicolon();
                writer.writeLiteral(s);
            },
            writeStringLiteral (s) {
                commitPendingTrailingSemicolon();
                writer.writeStringLiteral(s);
            },
            writeSymbol (s, sym) {
                commitPendingTrailingSemicolon();
                writer.writeSymbol(s, sym);
            },
            writePunctuation (s) {
                commitPendingTrailingSemicolon();
                writer.writePunctuation(s);
            },
            writeKeyword (s) {
                commitPendingTrailingSemicolon();
                writer.writeKeyword(s);
            },
            writeOperator (s) {
                commitPendingTrailingSemicolon();
                writer.writeOperator(s);
            },
            writeParameter (s) {
                commitPendingTrailingSemicolon();
                writer.writeParameter(s);
            },
            writeSpace (s) {
                commitPendingTrailingSemicolon();
                writer.writeSpace(s);
            },
            writeProperty (s) {
                commitPendingTrailingSemicolon();
                writer.writeProperty(s);
            },
            writeComment (s) {
                commitPendingTrailingSemicolon();
                writer.writeComment(s);
            },
            writeLine () {
                commitPendingTrailingSemicolon();
                writer.writeLine();
            },
            increaseIndent () {
                commitPendingTrailingSemicolon();
                writer.increaseIndent();
            },
            decreaseIndent () {
                commitPendingTrailingSemicolon();
                writer.decreaseIndent();
            }
        });
    }
    function hostUsesCaseSensitiveFileNames(host) {
        return host.useCaseSensitiveFileNames ? host.useCaseSensitiveFileNames() : false;
    }
    function hostGetCanonicalFileName(host) {
        return createGetCanonicalFileName(hostUsesCaseSensitiveFileNames(host));
    }
    function getResolvedExternalModuleName(host, file, referenceFile) {
        return file.moduleName || getExternalModuleNameFromPath(host, file.fileName, referenceFile && referenceFile.fileName);
    }
    function getCanonicalAbsolutePath(host, path) {
        return host.getCanonicalFileName(getNormalizedAbsolutePath(path, host.getCurrentDirectory()));
    }
    function getExternalModuleNameFromDeclaration(host, resolver, declaration) {
        const file = resolver.getExternalModuleFileFromDeclaration(declaration);
        if (!file || file.isDeclarationFile) return void 0;
        const specifier = getExternalModuleName(declaration);
        if (specifier && isStringLiteralLike(specifier) && !pathIsRelative(specifier.text) && !getCanonicalAbsolutePath(host, file.path).includes(getCanonicalAbsolutePath(host, ensureTrailingDirectorySeparator(host.getCommonSourceDirectory())))) return void 0;
        return getResolvedExternalModuleName(host, file);
    }
    function getExternalModuleNameFromPath(host, fileName, referencePath) {
        const getCanonicalFileName = (f)=>host.getCanonicalFileName(f);
        const dir = toPath(referencePath ? getDirectoryPath(referencePath) : host.getCommonSourceDirectory(), host.getCurrentDirectory(), getCanonicalFileName);
        const filePath = getNormalizedAbsolutePath(fileName, host.getCurrentDirectory());
        const relativePath = getRelativePathToDirectoryOrUrl(dir, filePath, dir, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
        const extensionless = removeFileExtension(relativePath);
        return referencePath ? ensurePathIsNonModuleName(extensionless) : extensionless;
    }
    function getOwnEmitOutputFilePath(fileName, host, extension) {
        const compilerOptions = host.getCompilerOptions();
        let emitOutputFilePathWithoutExtension;
        if (compilerOptions.outDir) emitOutputFilePathWithoutExtension = removeFileExtension(getSourceFilePathInNewDir(fileName, host, compilerOptions.outDir));
        else emitOutputFilePathWithoutExtension = removeFileExtension(fileName);
        return emitOutputFilePathWithoutExtension + extension;
    }
    function getDeclarationEmitOutputFilePath(fileName, host) {
        return getDeclarationEmitOutputFilePathWorker(fileName, host.getCompilerOptions(), host);
    }
    function getDeclarationEmitOutputFilePathWorker(fileName, options, host) {
        const outputDir = options.declarationDir || options.outDir;
        const path = outputDir ? getSourceFilePathInNewDirWorker(fileName, outputDir, host.getCurrentDirectory(), host.getCommonSourceDirectory(), (f)=>host.getCanonicalFileName(f)) : fileName;
        const declarationExtension = getDeclarationEmitExtensionForPath(path);
        return removeFileExtension(path) + declarationExtension;
    }
    function getDeclarationEmitExtensionForPath(path) {
        return fileExtensionIsOneOf(path, [
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ]) ? ".d.mts" /* Dmts */  : fileExtensionIsOneOf(path, [
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ 
        ]) ? ".d.cts" /* Dcts */  : fileExtensionIsOneOf(path, [
            ".json" /* Json */ 
        ]) ? `.d.json.ts` : // Drive-by redefinition of json declaration file output name so if it's ever enabled, it behaves well
        ".d.ts" /* Dts */ ;
    }
    function getPossibleOriginalInputExtensionForExtension(path) {
        return fileExtensionIsOneOf(path, [
            ".d.mts" /* Dmts */ ,
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ]) ? [
            ".mts" /* Mts */ ,
            ".mjs" /* Mjs */ 
        ] : fileExtensionIsOneOf(path, [
            ".d.cts" /* Dcts */ ,
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ 
        ]) ? [
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ] : fileExtensionIsOneOf(path, [
            `.d.json.ts`
        ]) ? [
            ".json" /* Json */ 
        ] : [
            ".tsx" /* Tsx */ ,
            ".ts" /* Ts */ ,
            ".jsx" /* Jsx */ ,
            ".js" /* Js */ 
        ];
    }
    function getPossibleOriginalInputPathWithoutChangingExt(filePath, ignoreCase, outputDir, getCommonSourceDirectory2) {
        return outputDir ? resolvePath(getCommonSourceDirectory2(), getRelativePathFromDirectory(outputDir, filePath, ignoreCase)) : filePath;
    }
    function getPathsBasePath(options, host) {
        var _a;
        if (!options.paths) return void 0;
        var _options_baseUrl;
        return (_options_baseUrl = options.baseUrl) !== null && _options_baseUrl !== void 0 ? _options_baseUrl : Debug.checkDefined(options.pathsBasePath || ((_a = host.getCurrentDirectory) == null ? void 0 : _a.call(host)), "Encountered 'paths' without a 'baseUrl', config file, or host 'getCurrentDirectory'.");
    }
    function getSourceFilesToEmit(host, targetSourceFile, forceDtsEmit) {
        const options = host.getCompilerOptions();
        if (options.outFile) {
            const moduleKind = getEmitModuleKind(options);
            const moduleEmitEnabled = options.emitDeclarationOnly || moduleKind === 2 /* AMD */  || moduleKind === 4 /* System */ ;
            return filter(host.getSourceFiles(), (sourceFile)=>(moduleEmitEnabled || !isExternalModule(sourceFile)) && sourceFileMayBeEmitted(sourceFile, host, forceDtsEmit));
        } else {
            const sourceFiles = targetSourceFile === void 0 ? host.getSourceFiles() : [
                targetSourceFile
            ];
            return filter(sourceFiles, (sourceFile)=>sourceFileMayBeEmitted(sourceFile, host, forceDtsEmit));
        }
    }
    function sourceFileMayBeEmitted(sourceFile, host, forceDtsEmit) {
        const options = host.getCompilerOptions();
        if (options.noEmitForJsFiles && isSourceFileJS(sourceFile)) return false;
        if (sourceFile.isDeclarationFile) return false;
        if (host.isSourceFileFromExternalLibrary(sourceFile)) return false;
        if (forceDtsEmit) return true;
        if (host.isSourceOfProjectReferenceRedirect(sourceFile.fileName)) return false;
        if (!isJsonSourceFile(sourceFile)) return true;
        if (host.getRedirectFromSourceFile(sourceFile.fileName)) return false;
        if (options.outFile) return true;
        if (!options.outDir) return false;
        if (options.rootDir || options.composite && options.configFilePath) {
            const commonDir = getNormalizedAbsolutePath(getCommonSourceDirectory(options, ()=>[], host.getCurrentDirectory(), host.getCanonicalFileName), host.getCurrentDirectory());
            const outputPath = getSourceFilePathInNewDirWorker(sourceFile.fileName, options.outDir, host.getCurrentDirectory(), commonDir, host.getCanonicalFileName);
            if (comparePaths(sourceFile.fileName, outputPath, host.getCurrentDirectory(), !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */ ) return false;
        }
        return true;
    }
    function getSourceFilePathInNewDir(fileName, host, newDirPath) {
        return getSourceFilePathInNewDirWorker(fileName, newDirPath, host.getCurrentDirectory(), host.getCommonSourceDirectory(), (f)=>host.getCanonicalFileName(f));
    }
    function getSourceFilePathInNewDirWorker(fileName, newDirPath, currentDirectory, commonSourceDirectory, getCanonicalFileName) {
        let sourceFilePath = getNormalizedAbsolutePath(fileName, currentDirectory);
        const isSourceFileInCommonSourceDirectory = getCanonicalFileName(sourceFilePath).indexOf(getCanonicalFileName(commonSourceDirectory)) === 0;
        sourceFilePath = isSourceFileInCommonSourceDirectory ? sourceFilePath.substring(commonSourceDirectory.length) : sourceFilePath;
        return combinePaths(newDirPath, sourceFilePath);
    }
    function writeFile(host, diagnostics, fileName, text, writeByteOrderMark, sourceFiles, data) {
        host.writeFile(fileName, text, writeByteOrderMark, (hostErrorMessage)=>{
            diagnostics.add(createCompilerDiagnostic(Diagnostics.Could_not_write_file_0_Colon_1, fileName, hostErrorMessage));
        }, sourceFiles, data);
    }
    function ensureDirectoriesExist(directoryPath, createDirectory, directoryExists) {
        if (directoryPath.length > getRootLength(directoryPath) && !directoryExists(directoryPath)) {
            const parentDirectory = getDirectoryPath(directoryPath);
            ensureDirectoriesExist(parentDirectory, createDirectory, directoryExists);
            createDirectory(directoryPath);
        }
    }
    function writeFileEnsuringDirectories(path, data, writeByteOrderMark, writeFile2, createDirectory, directoryExists) {
        try {
            writeFile2(path, data, writeByteOrderMark);
        } catch (e) {
            ensureDirectoriesExist(getDirectoryPath(normalizePath(path)), createDirectory, directoryExists);
            writeFile2(path, data, writeByteOrderMark);
        }
    }
    function getLineOfLocalPosition(sourceFile, pos) {
        const lineStarts = getLineStarts(sourceFile);
        return computeLineOfPosition(lineStarts, pos);
    }
    function getLineOfLocalPositionFromLineMap(lineMap, pos) {
        return computeLineOfPosition(lineMap, pos);
    }
    function getFirstConstructorWithBody(node) {
        return find(node.members, (member)=>isConstructorDeclaration(member) && nodeIsPresent(member.body));
    }
    function getSetAccessorValueParameter(accessor) {
        if (accessor && accessor.parameters.length > 0) {
            const hasThis = accessor.parameters.length === 2 && parameterIsThisKeyword(accessor.parameters[0]);
            return accessor.parameters[hasThis ? 1 : 0];
        }
    }
    function getSetAccessorTypeAnnotationNode(accessor) {
        const parameter = getSetAccessorValueParameter(accessor);
        return parameter && parameter.type;
    }
    function getThisParameter(signature) {
        if (signature.parameters.length && !isJSDocSignature(signature)) {
            const thisParameter = signature.parameters[0];
            if (parameterIsThisKeyword(thisParameter)) return thisParameter;
        }
    }
    function parameterIsThisKeyword(parameter) {
        return isThisIdentifier(parameter.name);
    }
    function isThisIdentifier(node) {
        return !!node && node.kind === 80 /* Identifier */  && identifierIsThisKeyword(node);
    }
    function isInTypeQuery(node) {
        return !!findAncestor(node, (n)=>n.kind === 187 /* TypeQuery */  ? true : n.kind === 80 /* Identifier */  || n.kind === 167 /* QualifiedName */  ? false : "quit");
    }
    function isThisInTypeQuery(node) {
        if (!isThisIdentifier(node)) return false;
        while(isQualifiedName(node.parent) && node.parent.left === node)node = node.parent;
        return node.parent.kind === 187 /* TypeQuery */ ;
    }
    function identifierIsThisKeyword(id) {
        return id.escapedText === "this";
    }
    function getAllAccessorDeclarations(declarations, accessor) {
        let firstAccessor;
        let secondAccessor;
        let getAccessor;
        let setAccessor;
        if (hasDynamicName(accessor)) {
            firstAccessor = accessor;
            if (accessor.kind === 178 /* GetAccessor */ ) getAccessor = accessor;
            else if (accessor.kind === 179 /* SetAccessor */ ) setAccessor = accessor;
            else Debug.fail("Accessor has wrong kind");
        } else forEach(declarations, (member)=>{
            if (isAccessor(member) && isStatic(member) === isStatic(accessor)) {
                const memberName = getPropertyNameForPropertyNameNode(member.name);
                const accessorName = getPropertyNameForPropertyNameNode(accessor.name);
                if (memberName === accessorName) {
                    if (!firstAccessor) firstAccessor = member;
                    else if (!secondAccessor) secondAccessor = member;
                    if (member.kind === 178 /* GetAccessor */  && !getAccessor) getAccessor = member;
                    if (member.kind === 179 /* SetAccessor */  && !setAccessor) setAccessor = member;
                }
            }
        });
        return {
            firstAccessor,
            secondAccessor,
            getAccessor,
            setAccessor
        };
    }
    function getEffectiveTypeAnnotationNode(node) {
        if (!isInJSFile(node) && isFunctionDeclaration(node)) return void 0;
        if (isTypeAliasDeclaration(node)) return void 0;
        const type = node.type;
        if (type || !isInJSFile(node)) return type;
        return isJSDocPropertyLikeTag(node) ? node.typeExpression && node.typeExpression.type : getJSDocType(node);
    }
    function getTypeAnnotationNode(node) {
        return node.type;
    }
    function getEffectiveReturnTypeNode(node) {
        return isJSDocSignature(node) ? node.type && node.type.typeExpression && node.type.typeExpression.type : node.type || (isInJSFile(node) ? getJSDocReturnType(node) : void 0);
    }
    function getJSDocTypeParameterDeclarations(node) {
        return flatMap(getJSDocTags(node), (tag)=>isNonTypeAliasTemplate(tag) ? tag.typeParameters : void 0);
    }
    function isNonTypeAliasTemplate(tag) {
        return isJSDocTemplateTag(tag) && !(tag.parent.kind === 321 /* JSDoc */  && (tag.parent.tags.some(isJSDocTypeAlias) || tag.parent.tags.some(isJSDocOverloadTag)));
    }
    function getEffectiveSetAccessorTypeAnnotationNode(node) {
        const parameter = getSetAccessorValueParameter(node);
        return parameter && getEffectiveTypeAnnotationNode(parameter);
    }
    function emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments) {
        emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, node.pos, leadingComments);
    }
    function emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, pos, leadingComments) {
        if (leadingComments && leadingComments.length && pos !== leadingComments[0].pos && getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, leadingComments[0].pos)) writer.writeLine();
    }
    function emitNewLineBeforeLeadingCommentOfPosition(lineMap, writer, pos, commentPos) {
        if (pos !== commentPos && getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, commentPos)) writer.writeLine();
    }
    function emitComments(text, lineMap, writer, comments, leadingSeparator, trailingSeparator, newLine, writeComment) {
        if (comments && comments.length > 0) {
            if (leadingSeparator) writer.writeSpace(" ");
            let emitInterveningSeparator = false;
            for (const comment of comments){
                if (emitInterveningSeparator) {
                    writer.writeSpace(" ");
                    emitInterveningSeparator = false;
                }
                writeComment(text, lineMap, writer, comment.pos, comment.end, newLine);
                if (comment.hasTrailingNewLine) writer.writeLine();
                else emitInterveningSeparator = true;
            }
            if (emitInterveningSeparator && trailingSeparator) writer.writeSpace(" ");
        }
    }
    function emitDetachedComments(text, lineMap, writer, writeComment, node, newLine, removeComments) {
        let leadingComments;
        let currentDetachedCommentInfo;
        if (removeComments) {
            if (node.pos === 0) leadingComments = filter(getLeadingCommentRanges(text, node.pos), isPinnedCommentLocal);
        } else leadingComments = getLeadingCommentRanges(text, node.pos);
        if (leadingComments) {
            const detachedComments = [];
            let lastComment;
            for (const comment of leadingComments){
                if (lastComment) {
                    const lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, lastComment.end);
                    const commentLine = getLineOfLocalPositionFromLineMap(lineMap, comment.pos);
                    if (commentLine >= lastCommentLine + 2) break;
                }
                detachedComments.push(comment);
                lastComment = comment;
            }
            if (detachedComments.length) {
                const lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, last(detachedComments).end);
                const nodeLine = getLineOfLocalPositionFromLineMap(lineMap, skipTrivia(text, node.pos));
                if (nodeLine >= lastCommentLine + 2) {
                    emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments);
                    emitComments(text, lineMap, writer, detachedComments, /*leadingSeparator*/ false, /*trailingSeparator*/ true, newLine, writeComment);
                    currentDetachedCommentInfo = {
                        nodePos: node.pos,
                        detachedCommentEndPos: last(detachedComments).end
                    };
                }
            }
        }
        return currentDetachedCommentInfo;
        function isPinnedCommentLocal(comment) {
            return isPinnedComment(text, comment.pos);
        }
    }
    function writeCommentRange(text, lineMap, writer, commentPos, commentEnd, newLine) {
        if (text.charCodeAt(commentPos + 1) === 42 /* asterisk */ ) {
            const firstCommentLineAndCharacter = computeLineAndCharacterOfPosition(lineMap, commentPos);
            const lineCount = lineMap.length;
            let firstCommentLineIndent;
            for(let pos = commentPos, currentLine = firstCommentLineAndCharacter.line; pos < commentEnd; currentLine++){
                const nextLineStart = currentLine + 1 === lineCount ? text.length + 1 : lineMap[currentLine + 1];
                if (pos !== commentPos) {
                    if (firstCommentLineIndent === void 0) firstCommentLineIndent = calculateIndent(text, lineMap[firstCommentLineAndCharacter.line], commentPos);
                    const currentWriterIndentSpacing = writer.getIndent() * getIndentSize();
                    const spacesToEmit = currentWriterIndentSpacing - firstCommentLineIndent + calculateIndent(text, pos, nextLineStart);
                    if (spacesToEmit > 0) {
                        let numberOfSingleSpacesToEmit = spacesToEmit % getIndentSize();
                        const indentSizeSpaceString = getIndentString((spacesToEmit - numberOfSingleSpacesToEmit) / getIndentSize());
                        writer.rawWrite(indentSizeSpaceString);
                        while(numberOfSingleSpacesToEmit){
                            writer.rawWrite(" ");
                            numberOfSingleSpacesToEmit--;
                        }
                    } else writer.rawWrite("");
                }
                writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart);
                pos = nextLineStart;
            }
        } else writer.writeComment(text.substring(commentPos, commentEnd));
    }
    function writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart) {
        const end = Math.min(commentEnd, nextLineStart - 1);
        const currentLineText = text.substring(pos, end).trim();
        if (currentLineText) {
            writer.writeComment(currentLineText);
            if (end !== commentEnd) writer.writeLine();
        } else writer.rawWrite(newLine);
    }
    function calculateIndent(text, pos, end) {
        let currentLineIndent = 0;
        for(; pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos)); pos++)if (text.charCodeAt(pos) === 9 /* tab */ ) currentLineIndent += getIndentSize() - currentLineIndent % getIndentSize();
        else currentLineIndent++;
        return currentLineIndent;
    }
    function hasEffectiveModifiers(node) {
        return getEffectiveModifierFlags(node) !== 0 /* None */ ;
    }
    function hasSyntacticModifiers(node) {
        return getSyntacticModifierFlags(node) !== 0 /* None */ ;
    }
    function hasEffectiveModifier(node, flags) {
        return !!getSelectedEffectiveModifierFlags(node, flags);
    }
    function hasSyntacticModifier(node, flags) {
        return !!getSelectedSyntacticModifierFlags(node, flags);
    }
    function isStatic(node) {
        return isClassElement(node) && hasStaticModifier(node) || isClassStaticBlockDeclaration(node);
    }
    function hasStaticModifier(node) {
        return hasSyntacticModifier(node, 256 /* Static */ );
    }
    function hasOverrideModifier(node) {
        return hasEffectiveModifier(node, 16 /* Override */ );
    }
    function hasAbstractModifier(node) {
        return hasSyntacticModifier(node, 64 /* Abstract */ );
    }
    function hasAmbientModifier(node) {
        return hasSyntacticModifier(node, 128 /* Ambient */ );
    }
    function hasAccessorModifier(node) {
        return hasSyntacticModifier(node, 512 /* Accessor */ );
    }
    function hasEffectiveReadonlyModifier(node) {
        return hasEffectiveModifier(node, 8 /* Readonly */ );
    }
    function hasDecorators(node) {
        return hasSyntacticModifier(node, 32768 /* Decorator */ );
    }
    function getSelectedEffectiveModifierFlags(node, flags) {
        return getEffectiveModifierFlags(node) & flags;
    }
    function getSelectedSyntacticModifierFlags(node, flags) {
        return getSyntacticModifierFlags(node) & flags;
    }
    function getModifierFlagsWorker(node, includeJSDoc, alwaysIncludeJSDoc) {
        if (node.kind >= 0 /* FirstToken */  && node.kind <= 166 /* LastToken */ ) return 0 /* None */ ;
        if (!(node.modifierFlagsCache & 536870912 /* HasComputedFlags */ )) node.modifierFlagsCache = getSyntacticModifierFlagsNoCache(node) | 536870912 /* HasComputedFlags */ ;
        if (alwaysIncludeJSDoc || includeJSDoc && isInJSFile(node)) {
            if (!(node.modifierFlagsCache & 268435456 /* HasComputedJSDocModifiers */ ) && node.parent) node.modifierFlagsCache |= getRawJSDocModifierFlagsNoCache(node) | 268435456 /* HasComputedJSDocModifiers */ ;
            return selectEffectiveModifierFlags(node.modifierFlagsCache);
        }
        return selectSyntacticModifierFlags(node.modifierFlagsCache);
    }
    function getEffectiveModifierFlags(node) {
        return getModifierFlagsWorker(node, /*includeJSDoc*/ true);
    }
    function getEffectiveModifierFlagsAlwaysIncludeJSDoc(node) {
        return getModifierFlagsWorker(node, /*includeJSDoc*/ true, /*alwaysIncludeJSDoc*/ true);
    }
    function getSyntacticModifierFlags(node) {
        return getModifierFlagsWorker(node, /*includeJSDoc*/ false);
    }
    function getRawJSDocModifierFlagsNoCache(node) {
        let flags = 0 /* None */ ;
        if (!!node.parent && !isParameter(node)) {
            if (isInJSFile(node)) {
                if (getJSDocPublicTagNoCache(node)) flags |= 8388608 /* JSDocPublic */ ;
                if (getJSDocPrivateTagNoCache(node)) flags |= 16777216 /* JSDocPrivate */ ;
                if (getJSDocProtectedTagNoCache(node)) flags |= 33554432 /* JSDocProtected */ ;
                if (getJSDocReadonlyTagNoCache(node)) flags |= 67108864 /* JSDocReadonly */ ;
                if (getJSDocOverrideTagNoCache(node)) flags |= 134217728 /* JSDocOverride */ ;
            }
            if (getJSDocDeprecatedTagNoCache(node)) flags |= 65536 /* Deprecated */ ;
        }
        return flags;
    }
    function selectSyntacticModifierFlags(flags) {
        return flags & 65535 /* SyntacticModifiers */ ;
    }
    function selectEffectiveModifierFlags(flags) {
        return flags & 131071 /* NonCacheOnlyModifiers */  | (flags & 260046848 /* JSDocCacheOnlyModifiers */ ) >>> 23;
    }
    function getJSDocModifierFlagsNoCache(node) {
        return selectEffectiveModifierFlags(getRawJSDocModifierFlagsNoCache(node));
    }
    function getEffectiveModifierFlagsNoCache(node) {
        return getSyntacticModifierFlagsNoCache(node) | getJSDocModifierFlagsNoCache(node);
    }
    function getSyntacticModifierFlagsNoCache(node) {
        let flags = canHaveModifiers(node) ? modifiersToFlags(node.modifiers) : 0 /* None */ ;
        if (node.flags & 8 /* NestedNamespace */  || node.kind === 80 /* Identifier */  && node.flags & 4096 /* IdentifierIsInJSDocNamespace */ ) flags |= 32 /* Export */ ;
        return flags;
    }
    function modifiersToFlags(modifiers) {
        let flags = 0 /* None */ ;
        if (modifiers) for (const modifier of modifiers)flags |= modifierToFlag(modifier.kind);
        return flags;
    }
    function modifierToFlag(token) {
        switch(token){
            case 126 /* StaticKeyword */ :
                return 256 /* Static */ ;
            case 125 /* PublicKeyword */ :
                return 1 /* Public */ ;
            case 124 /* ProtectedKeyword */ :
                return 4 /* Protected */ ;
            case 123 /* PrivateKeyword */ :
                return 2 /* Private */ ;
            case 128 /* AbstractKeyword */ :
                return 64 /* Abstract */ ;
            case 129 /* AccessorKeyword */ :
                return 512 /* Accessor */ ;
            case 95 /* ExportKeyword */ :
                return 32 /* Export */ ;
            case 138 /* DeclareKeyword */ :
                return 128 /* Ambient */ ;
            case 87 /* ConstKeyword */ :
                return 4096 /* Const */ ;
            case 90 /* DefaultKeyword */ :
                return 2048 /* Default */ ;
            case 134 /* AsyncKeyword */ :
                return 1024 /* Async */ ;
            case 148 /* ReadonlyKeyword */ :
                return 8 /* Readonly */ ;
            case 164 /* OverrideKeyword */ :
                return 16 /* Override */ ;
            case 103 /* InKeyword */ :
                return 8192 /* In */ ;
            case 147 /* OutKeyword */ :
                return 16384 /* Out */ ;
            case 171 /* Decorator */ :
                return 32768 /* Decorator */ ;
        }
        return 0 /* None */ ;
    }
    function isBinaryLogicalOperator(token) {
        return token === 57 /* BarBarToken */  || token === 56 /* AmpersandAmpersandToken */ ;
    }
    function isLogicalOperator(token) {
        return isBinaryLogicalOperator(token) || token === 54 /* ExclamationToken */ ;
    }
    function isLogicalOrCoalescingAssignmentOperator(token) {
        return token === 76 /* BarBarEqualsToken */  || token === 77 /* AmpersandAmpersandEqualsToken */  || token === 78 /* QuestionQuestionEqualsToken */ ;
    }
    function isLogicalOrCoalescingAssignmentExpression(expr) {
        return isBinaryExpression(expr) && isLogicalOrCoalescingAssignmentOperator(expr.operatorToken.kind);
    }
    function isLogicalOrCoalescingBinaryOperator(token) {
        return isBinaryLogicalOperator(token) || token === 61 /* QuestionQuestionToken */ ;
    }
    function isLogicalOrCoalescingBinaryExpression(expr) {
        return isBinaryExpression(expr) && isLogicalOrCoalescingBinaryOperator(expr.operatorToken.kind);
    }
    function isAssignmentOperator(token) {
        return token >= 64 /* FirstAssignment */  && token <= 79 /* LastAssignment */ ;
    }
    function tryGetClassExtendingExpressionWithTypeArguments(node) {
        const cls = tryGetClassImplementingOrExtendingExpressionWithTypeArguments(node);
        return cls && !cls.isImplements ? cls.class : void 0;
    }
    function tryGetClassImplementingOrExtendingExpressionWithTypeArguments(node) {
        if (isExpressionWithTypeArguments(node)) {
            if (isHeritageClause(node.parent) && isClassLike(node.parent.parent)) return {
                class: node.parent.parent,
                isImplements: node.parent.token === 119 /* ImplementsKeyword */ 
            };
            if (isJSDocAugmentsTag(node.parent)) {
                const host = getEffectiveJSDocHost(node.parent);
                if (host && isClassLike(host)) return {
                    class: host,
                    isImplements: false
                };
            }
        }
        return void 0;
    }
    function isAssignmentExpression(node, excludeCompoundAssignment) {
        return isBinaryExpression(node) && (excludeCompoundAssignment ? node.operatorToken.kind === 64 /* EqualsToken */  : isAssignmentOperator(node.operatorToken.kind)) && isLeftHandSideExpression(node.left);
    }
    function isDestructuringAssignment(node) {
        if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
            const kind = node.left.kind;
            return kind === 211 /* ObjectLiteralExpression */  || kind === 210 /* ArrayLiteralExpression */ ;
        }
        return false;
    }
    function isExpressionWithTypeArgumentsInClassExtendsClause(node) {
        return tryGetClassExtendingExpressionWithTypeArguments(node) !== void 0;
    }
    function isEntityNameExpression(node) {
        return node.kind === 80 /* Identifier */  || isPropertyAccessEntityNameExpression(node);
    }
    function getFirstIdentifier(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
                return node;
            case 167 /* QualifiedName */ :
                do node = node.left;
                while (node.kind !== 80 /* Identifier */ );
                return node;
            case 212 /* PropertyAccessExpression */ :
                do node = node.expression;
                while (node.kind !== 80 /* Identifier */ );
                return node;
        }
    }
    function isDottedName(node) {
        return node.kind === 80 /* Identifier */  || node.kind === 110 /* ThisKeyword */  || node.kind === 108 /* SuperKeyword */  || node.kind === 237 /* MetaProperty */  || node.kind === 212 /* PropertyAccessExpression */  && isDottedName(node.expression) || node.kind === 218 /* ParenthesizedExpression */  && isDottedName(node.expression);
    }
    function isPropertyAccessEntityNameExpression(node) {
        return isPropertyAccessExpression(node) && isIdentifier(node.name) && isEntityNameExpression(node.expression);
    }
    function tryGetPropertyAccessOrIdentifierToString(expr) {
        if (isPropertyAccessExpression(expr)) {
            const baseStr = tryGetPropertyAccessOrIdentifierToString(expr.expression);
            if (baseStr !== void 0) return baseStr + "." + entityNameToString(expr.name);
        } else if (isElementAccessExpression(expr)) {
            const baseStr = tryGetPropertyAccessOrIdentifierToString(expr.expression);
            if (baseStr !== void 0 && isPropertyName(expr.argumentExpression)) return baseStr + "." + getPropertyNameForPropertyNameNode(expr.argumentExpression);
        } else if (isIdentifier(expr)) return unescapeLeadingUnderscores(expr.escapedText);
        else if (isJsxNamespacedName(expr)) return getTextOfJsxNamespacedName(expr);
        return void 0;
    }
    function isPrototypeAccess(node) {
        return isBindableStaticAccessExpression(node) && getElementOrPropertyAccessName(node) === "prototype";
    }
    function isRightSideOfQualifiedNameOrPropertyAccess(node) {
        return node.parent.kind === 167 /* QualifiedName */  && node.parent.right === node || node.parent.kind === 212 /* PropertyAccessExpression */  && node.parent.name === node || node.parent.kind === 237 /* MetaProperty */  && node.parent.name === node;
    }
    function isRightSideOfAccessExpression(node) {
        return !!node.parent && (isPropertyAccessExpression(node.parent) && node.parent.name === node || isElementAccessExpression(node.parent) && node.parent.argumentExpression === node);
    }
    function isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName(node) {
        return isQualifiedName(node.parent) && node.parent.right === node || isPropertyAccessExpression(node.parent) && node.parent.name === node || isJSDocMemberName(node.parent) && node.parent.right === node;
    }
    function isInstanceOfExpression(node) {
        return isBinaryExpression(node) && node.operatorToken.kind === 104 /* InstanceOfKeyword */ ;
    }
    function isRightSideOfInstanceofExpression(node) {
        return isInstanceOfExpression(node.parent) && node === node.parent.right;
    }
    function isEmptyObjectLiteral(expression) {
        return expression.kind === 211 /* ObjectLiteralExpression */  && expression.properties.length === 0;
    }
    function isEmptyArrayLiteral(expression) {
        return expression.kind === 210 /* ArrayLiteralExpression */  && expression.elements.length === 0;
    }
    function getLocalSymbolForExportDefault(symbol) {
        if (!isExportDefaultSymbol(symbol) || !symbol.declarations) return void 0;
        for (const decl of symbol.declarations){
            if (decl.localSymbol) return decl.localSymbol;
        }
        return void 0;
    }
    function isExportDefaultSymbol(symbol) {
        return symbol && length(symbol.declarations) > 0 && hasSyntacticModifier(symbol.declarations[0], 2048 /* Default */ );
    }
    function tryExtractTSExtension(fileName) {
        return find(supportedTSExtensionsForExtractExtension, (extension)=>fileExtensionIs(fileName, extension));
    }
    function getExpandedCharCodes(input) {
        const output = [];
        const length2 = input.length;
        for(let i = 0; i < length2; i++){
            const charCode = input.charCodeAt(i);
            if (charCode < 128) output.push(charCode);
            else if (charCode < 2048) {
                output.push(charCode >> 6 | 192);
                output.push(charCode & 63 | 128);
            } else if (charCode < 65536) {
                output.push(charCode >> 12 | 224);
                output.push(charCode >> 6 & 63 | 128);
                output.push(charCode & 63 | 128);
            } else if (charCode < 131072) {
                output.push(charCode >> 18 | 240);
                output.push(charCode >> 12 & 63 | 128);
                output.push(charCode >> 6 & 63 | 128);
                output.push(charCode & 63 | 128);
            } else Debug.assert(false, "Unexpected code point");
        }
        return output;
    }
    var base64Digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    function convertToBase64(input) {
        let result = "";
        const charCodes = getExpandedCharCodes(input);
        let i = 0;
        const length2 = charCodes.length;
        let byte1, byte2, byte3, byte4;
        while(i < length2){
            byte1 = charCodes[i] >> 2;
            byte2 = (charCodes[i] & 3) << 4 | charCodes[i + 1] >> 4;
            byte3 = (charCodes[i + 1] & 15) << 2 | charCodes[i + 2] >> 6;
            byte4 = charCodes[i + 2] & 63;
            if (i + 1 >= length2) byte3 = byte4 = 64;
            else if (i + 2 >= length2) byte4 = 64;
            result += base64Digits.charAt(byte1) + base64Digits.charAt(byte2) + base64Digits.charAt(byte3) + base64Digits.charAt(byte4);
            i += 3;
        }
        return result;
    }
    function getStringFromExpandedCharCodes(codes) {
        let output = "";
        let i = 0;
        const length2 = codes.length;
        while(i < length2){
            const charCode = codes[i];
            if (charCode < 128) {
                output += String.fromCharCode(charCode);
                i++;
            } else if ((charCode & 192) === 192) {
                let value1 = charCode & 63;
                i++;
                let nextCode = codes[i];
                while((nextCode & 192) === 128){
                    value1 = value1 << 6 | nextCode & 63;
                    i++;
                    nextCode = codes[i];
                }
                output += String.fromCharCode(value1);
            } else {
                output += String.fromCharCode(charCode);
                i++;
            }
        }
        return output;
    }
    function base64encode(host, input) {
        if (host && host.base64encode) return host.base64encode(input);
        return convertToBase64(input);
    }
    function base64decode(host, input) {
        if (host && host.base64decode) return host.base64decode(input);
        const length2 = input.length;
        const expandedCharCodes = [];
        let i = 0;
        while(i < length2){
            if (input.charCodeAt(i) === base64Digits.charCodeAt(64)) break;
            const ch1 = base64Digits.indexOf(input[i]);
            const ch2 = base64Digits.indexOf(input[i + 1]);
            const ch3 = base64Digits.indexOf(input[i + 2]);
            const ch4 = base64Digits.indexOf(input[i + 3]);
            const code1 = (ch1 & 63) << 2 | ch2 >> 4 & 3;
            const code2 = (ch2 & 15) << 4 | ch3 >> 2 & 15;
            const code3 = (ch3 & 3) << 6 | ch4 & 63;
            if (code2 === 0 && ch3 !== 0) expandedCharCodes.push(code1);
            else if (code3 === 0 && ch4 !== 0) expandedCharCodes.push(code1, code2);
            else expandedCharCodes.push(code1, code2, code3);
            i += 4;
        }
        return getStringFromExpandedCharCodes(expandedCharCodes);
    }
    function readJsonOrUndefined(path, hostOrText) {
        const jsonText = isString(hostOrText) ? hostOrText : hostOrText.readFile(path);
        if (!jsonText) return void 0;
        let result = tryParseJson(jsonText);
        if (result === void 0) {
            const looseResult = parseConfigFileTextToJson(path, jsonText);
            if (!looseResult.error) result = looseResult.config;
        }
        return result;
    }
    function readJson(path, host) {
        return readJsonOrUndefined(path, host) || {};
    }
    function tryParseJson(text) {
        try {
            return JSON.parse(text);
        } catch (e) {
            return void 0;
        }
    }
    function directoryProbablyExists(directoryName, host) {
        return !host.directoryExists || host.directoryExists(directoryName);
    }
    var carriageReturnLineFeed = "\r\n";
    var lineFeed = "\n";
    function getNewLineCharacter(options) {
        switch(options.newLine){
            case 0 /* CarriageReturnLineFeed */ :
                return carriageReturnLineFeed;
            case 1 /* LineFeed */ :
            case void 0:
                return lineFeed;
        }
    }
    function createRange(pos, end = pos) {
        Debug.assert(end >= pos || end === -1);
        return {
            pos,
            end
        };
    }
    function moveRangeEnd(range, end) {
        return createRange(range.pos, end);
    }
    function moveRangePos(range, pos) {
        return createRange(pos, range.end);
    }
    function moveRangePastDecorators(node) {
        const lastDecorator = canHaveModifiers(node) ? findLast(node.modifiers, isDecorator) : void 0;
        return lastDecorator && !positionIsSynthesized(lastDecorator.end) ? moveRangePos(node, lastDecorator.end) : node;
    }
    function moveRangePastModifiers(node) {
        if (isPropertyDeclaration(node) || isMethodDeclaration(node)) return moveRangePos(node, node.name.pos);
        const lastModifier = canHaveModifiers(node) ? lastOrUndefined(node.modifiers) : void 0;
        return lastModifier && !positionIsSynthesized(lastModifier.end) ? moveRangePos(node, lastModifier.end) : moveRangePastDecorators(node);
    }
    function createTokenRange(pos, token) {
        return createRange(pos, pos + tokenToString(token).length);
    }
    function rangeIsOnSingleLine(range, sourceFile) {
        return rangeStartIsOnSameLineAsRangeEnd(range, range, sourceFile);
    }
    function rangeStartPositionsAreOnSameLine(range1, range2, sourceFile) {
        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile, /*includeComments*/ false), getStartPositionOfRange(range2, sourceFile, /*includeComments*/ false), sourceFile);
    }
    function rangeEndPositionsAreOnSameLine(range1, range2, sourceFile) {
        return positionsAreOnSameLine(range1.end, range2.end, sourceFile);
    }
    function rangeStartIsOnSameLineAsRangeEnd(range1, range2, sourceFile) {
        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile, /*includeComments*/ false), range2.end, sourceFile);
    }
    function rangeEndIsOnSameLineAsRangeStart(range1, range2, sourceFile) {
        return positionsAreOnSameLine(range1.end, getStartPositionOfRange(range2, sourceFile, /*includeComments*/ false), sourceFile);
    }
    function getLinesBetweenRangeEndAndRangeStart(range1, range2, sourceFile, includeSecondRangeComments) {
        const range2Start = getStartPositionOfRange(range2, sourceFile, includeSecondRangeComments);
        return getLinesBetweenPositions(sourceFile, range1.end, range2Start);
    }
    function getLinesBetweenRangeEndPositions(range1, range2, sourceFile) {
        return getLinesBetweenPositions(sourceFile, range1.end, range2.end);
    }
    function isNodeArrayMultiLine(list, sourceFile) {
        return !positionsAreOnSameLine(list.pos, list.end, sourceFile);
    }
    function positionsAreOnSameLine(pos1, pos2, sourceFile) {
        return getLinesBetweenPositions(sourceFile, pos1, pos2) === 0;
    }
    function getStartPositionOfRange(range, sourceFile, includeComments) {
        return positionIsSynthesized(range.pos) ? -1 : skipTrivia(sourceFile.text, range.pos, /*stopAfterLineBreak*/ false, includeComments);
    }
    function getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter(pos, stopPos, sourceFile, includeComments) {
        const startPos = skipTrivia(sourceFile.text, pos, /*stopAfterLineBreak*/ false, includeComments);
        const prevPos = getPreviousNonWhitespacePosition(startPos, stopPos, sourceFile);
        return getLinesBetweenPositions(sourceFile, prevPos !== null && prevPos !== void 0 ? prevPos : stopPos, startPos);
    }
    function getLinesBetweenPositionAndNextNonWhitespaceCharacter(pos, stopPos, sourceFile, includeComments) {
        const nextPos = skipTrivia(sourceFile.text, pos, /*stopAfterLineBreak*/ false, includeComments);
        return getLinesBetweenPositions(sourceFile, pos, Math.min(stopPos, nextPos));
    }
    function rangeContainsRange(r1, r2) {
        return startEndContainsRange(r1.pos, r1.end, r2);
    }
    function startEndContainsRange(start, end, range) {
        return start <= range.pos && end >= range.end;
    }
    function getPreviousNonWhitespacePosition(pos, stopPos = 0, sourceFile) {
        while(pos-- > stopPos){
            if (!isWhiteSpaceLike(sourceFile.text.charCodeAt(pos))) return pos;
        }
    }
    function isDeclarationNameOfEnumOrNamespace(node) {
        const parseNode = getParseTreeNode(node);
        if (parseNode) switch(parseNode.parent.kind){
            case 267 /* EnumDeclaration */ :
            case 268 /* ModuleDeclaration */ :
                return parseNode === parseNode.parent.name;
        }
        return false;
    }
    function getInitializedVariables(node) {
        return filter(node.declarations, isInitializedVariable);
    }
    function isInitializedVariable(node) {
        return isVariableDeclaration(node) && node.initializer !== void 0;
    }
    function isWatchSet(options) {
        return options.watch && hasProperty(options, "watch");
    }
    function closeFileWatcher(watcher) {
        watcher.close();
    }
    function getCheckFlags(symbol) {
        return symbol.flags & 33554432 /* Transient */  ? symbol.links.checkFlags : 0;
    }
    function getDeclarationModifierFlagsFromSymbol(s, isWrite = false) {
        if (s.valueDeclaration) {
            const declaration = isWrite && s.declarations && find(s.declarations, isSetAccessorDeclaration) || s.flags & 32768 /* GetAccessor */  && find(s.declarations, isGetAccessorDeclaration) || s.valueDeclaration;
            const flags = getCombinedModifierFlags(declaration);
            return s.parent && s.parent.flags & 32 /* Class */  ? flags : flags & -8 /* AccessibilityModifier */ ;
        }
        if (getCheckFlags(s) & 6 /* Synthetic */ ) {
            const checkFlags = s.links.checkFlags;
            const accessModifier = checkFlags & 1024 /* ContainsPrivate */  ? 2 /* Private */  : checkFlags & 256 /* ContainsPublic */  ? 1 /* Public */  : 4 /* Protected */ ;
            const staticModifier = checkFlags & 2048 /* ContainsStatic */  ? 256 /* Static */  : 0;
            return accessModifier | staticModifier;
        }
        if (s.flags & 4194304 /* Prototype */ ) return 257 /* Static */ ;
        return 0;
    }
    function skipAlias(symbol, checker) {
        return symbol.flags & 2097152 /* Alias */  ? checker.getAliasedSymbol(symbol) : symbol;
    }
    function getCombinedLocalAndExportSymbolFlags(symbol) {
        return symbol.exportSymbol ? symbol.exportSymbol.flags | symbol.flags : symbol.flags;
    }
    function isWriteOnlyAccess(node) {
        return accessKind(node) === 1 /* Write */ ;
    }
    function isWriteAccess(node) {
        return accessKind(node) !== 0 /* Read */ ;
    }
    function accessKind(node) {
        const { parent: parent2 } = node;
        switch(parent2 == null ? void 0 : parent2.kind){
            case 218 /* ParenthesizedExpression */ :
                return accessKind(parent2);
            case 226 /* PostfixUnaryExpression */ :
            case 225 /* PrefixUnaryExpression */ :
                const { operator } = parent2;
                return operator === 46 /* PlusPlusToken */  || operator === 47 /* MinusMinusToken */  ? 2 /* ReadWrite */  : 0 /* Read */ ;
            case 227 /* BinaryExpression */ :
                const { left, operatorToken } = parent2;
                return left === node && isAssignmentOperator(operatorToken.kind) ? operatorToken.kind === 64 /* EqualsToken */  ? 1 /* Write */  : 2 /* ReadWrite */  : 0 /* Read */ ;
            case 212 /* PropertyAccessExpression */ :
                return parent2.name !== node ? 0 /* Read */  : accessKind(parent2);
            case 304 /* PropertyAssignment */ :
                {
                    const parentAccess = accessKind(parent2.parent);
                    return node === parent2.name ? reverseAccessKind(parentAccess) : parentAccess;
                }
            case 305 /* ShorthandPropertyAssignment */ :
                return node === parent2.objectAssignmentInitializer ? 0 /* Read */  : accessKind(parent2.parent);
            case 210 /* ArrayLiteralExpression */ :
                return accessKind(parent2);
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
                return node === parent2.initializer ? 1 /* Write */  : 0 /* Read */ ;
            default:
                return 0 /* Read */ ;
        }
    }
    function reverseAccessKind(a) {
        switch(a){
            case 0 /* Read */ :
                return 1 /* Write */ ;
            case 1 /* Write */ :
                return 0 /* Read */ ;
            case 2 /* ReadWrite */ :
                return 2 /* ReadWrite */ ;
            default:
                return Debug.assertNever(a);
        }
    }
    function compareDataObjects(dst, src) {
        if (!dst || !src || Object.keys(dst).length !== Object.keys(src).length) return false;
        for(const e in dst){
            if (typeof dst[e] === "object") {
                if (!compareDataObjects(dst[e], src[e])) return false;
            } else if (typeof dst[e] !== "function") {
                if (dst[e] !== src[e]) return false;
            }
        }
        return true;
    }
    function clearMap(map2, onDeleteValue) {
        map2.forEach(onDeleteValue);
        map2.clear();
    }
    function mutateMapSkippingNewValues(map2, newMap, options) {
        const { onDeleteValue, onExistingValue } = options;
        map2.forEach((existingValue, key)=>{
            var _a;
            if (!(newMap == null ? void 0 : newMap.has(key))) {
                map2.delete(key);
                onDeleteValue(existingValue, key);
            } else if (onExistingValue) onExistingValue(existingValue, (_a = newMap.get) == null ? void 0 : _a.call(newMap, key), key);
        });
    }
    function mutateMap(map2, newMap, options) {
        mutateMapSkippingNewValues(map2, newMap, options);
        const { createNewValue } = options;
        newMap == null || newMap.forEach((valueInNewMap, key)=>{
            if (!map2.has(key)) map2.set(key, createNewValue(key, valueInNewMap));
        });
    }
    function isAbstractConstructorSymbol(symbol) {
        if (symbol.flags & 32 /* Class */ ) {
            const declaration = getClassLikeDeclarationOfSymbol(symbol);
            return !!declaration && hasSyntacticModifier(declaration, 64 /* Abstract */ );
        }
        return false;
    }
    function getClassLikeDeclarationOfSymbol(symbol) {
        var _a;
        return (_a = symbol.declarations) == null ? void 0 : _a.find(isClassLike);
    }
    function getObjectFlags(type) {
        return type.flags & 3899393 /* ObjectFlagsType */  ? type.objectFlags : 0;
    }
    function isUMDExportSymbol(symbol) {
        return !!symbol && !!symbol.declarations && !!symbol.declarations[0] && isNamespaceExportDeclaration(symbol.declarations[0]);
    }
    function showModuleSpecifier({ moduleSpecifier }) {
        return isStringLiteral(moduleSpecifier) ? moduleSpecifier.text : getTextOfNode(moduleSpecifier);
    }
    function getLastChild(node) {
        let lastChild;
        forEachChild(node, (child)=>{
            if (nodeIsPresent(child)) lastChild = child;
        }, (children)=>{
            for(let i = children.length - 1; i >= 0; i--)if (nodeIsPresent(children[i])) {
                lastChild = children[i];
                break;
            }
        });
        return lastChild;
    }
    function addToSeen(seen, key) {
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    }
    function isObjectTypeDeclaration(node) {
        return isClassLike(node) || isInterfaceDeclaration(node) || isTypeLiteralNode(node);
    }
    function isTypeNodeKind(kind) {
        return kind >= 183 /* FirstTypeNode */  && kind <= 206 /* LastTypeNode */  || kind === 133 /* AnyKeyword */  || kind === 159 /* UnknownKeyword */  || kind === 150 /* NumberKeyword */  || kind === 163 /* BigIntKeyword */  || kind === 151 /* ObjectKeyword */  || kind === 136 /* BooleanKeyword */  || kind === 154 /* StringKeyword */  || kind === 155 /* SymbolKeyword */  || kind === 116 /* VoidKeyword */  || kind === 157 /* UndefinedKeyword */  || kind === 146 /* NeverKeyword */  || kind === 141 /* IntrinsicKeyword */  || kind === 234 /* ExpressionWithTypeArguments */  || kind === 313 /* JSDocAllType */  || kind === 314 /* JSDocUnknownType */  || kind === 315 /* JSDocNullableType */  || kind === 316 /* JSDocNonNullableType */  || kind === 317 /* JSDocOptionalType */  || kind === 318 /* JSDocFunctionType */  || kind === 319 /* JSDocVariadicType */ ;
    }
    function isAccessExpression(node) {
        return node.kind === 212 /* PropertyAccessExpression */  || node.kind === 213 /* ElementAccessExpression */ ;
    }
    function getNameOfAccessExpression(node) {
        if (node.kind === 212 /* PropertyAccessExpression */ ) return node.name;
        Debug.assert(node.kind === 213 /* ElementAccessExpression */ );
        return node.argumentExpression;
    }
    function isNamedImportsOrExports(node) {
        return node.kind === 276 /* NamedImports */  || node.kind === 280 /* NamedExports */ ;
    }
    function getLeftmostAccessExpression(expr) {
        while(isAccessExpression(expr))expr = expr.expression;
        return expr;
    }
    function forEachNameInAccessChainWalkingLeft(name, action) {
        if (isAccessExpression(name.parent) && isRightSideOfAccessExpression(name)) return walkAccessExpression(name.parent);
        function walkAccessExpression(access) {
            if (access.kind === 212 /* PropertyAccessExpression */ ) {
                const res = action(access.name);
                if (res !== void 0) return res;
            } else if (access.kind === 213 /* ElementAccessExpression */ ) {
                if (isIdentifier(access.argumentExpression) || isStringLiteralLike(access.argumentExpression)) {
                    const res = action(access.argumentExpression);
                    if (res !== void 0) return res;
                } else return void 0;
            }
            if (isAccessExpression(access.expression)) return walkAccessExpression(access.expression);
            if (isIdentifier(access.expression)) return action(access.expression);
            return void 0;
        }
    }
    function getLeftmostExpression(node, stopAtCallExpressions) {
        while(true){
            switch(node.kind){
                case 226 /* PostfixUnaryExpression */ :
                    node = node.operand;
                    continue;
                case 227 /* BinaryExpression */ :
                    node = node.left;
                    continue;
                case 228 /* ConditionalExpression */ :
                    node = node.condition;
                    continue;
                case 216 /* TaggedTemplateExpression */ :
                    node = node.tag;
                    continue;
                case 214 /* CallExpression */ :
                    if (stopAtCallExpressions) return node;
                // falls through
                case 235 /* AsExpression */ :
                case 213 /* ElementAccessExpression */ :
                case 212 /* PropertyAccessExpression */ :
                case 236 /* NonNullExpression */ :
                case 356 /* PartiallyEmittedExpression */ :
                case 239 /* SatisfiesExpression */ :
                    node = node.expression;
                    continue;
            }
            return node;
        }
    }
    function Symbol4(flags, name) {
        this.flags = flags;
        this.escapedName = name;
        this.declarations = void 0;
        this.valueDeclaration = void 0;
        this.id = 0;
        this.mergeId = 0;
        this.parent = void 0;
        this.members = void 0;
        this.exports = void 0;
        this.exportSymbol = void 0;
        this.constEnumOnlyModule = void 0;
        this.isReferenced = void 0;
        this.lastAssignmentPos = void 0;
        this.links = void 0;
    }
    function Type3(checker, flags) {
        this.flags = flags;
        if (Debug.isDebugging || tracing) this.checker = checker;
    }
    function Signature2(checker, flags) {
        this.flags = flags;
        if (Debug.isDebugging) this.checker = checker;
    }
    function Node4(kind, pos, end) {
        this.pos = pos;
        this.end = end;
        this.kind = kind;
        this.id = 0;
        this.flags = 0 /* None */ ;
        this.modifierFlagsCache = 0 /* None */ ;
        this.transformFlags = 0 /* None */ ;
        this.parent = void 0;
        this.original = void 0;
        this.emitNode = void 0;
    }
    function Token(kind, pos, end) {
        this.pos = pos;
        this.end = end;
        this.kind = kind;
        this.id = 0;
        this.flags = 0 /* None */ ;
        this.transformFlags = 0 /* None */ ;
        this.parent = void 0;
        this.emitNode = void 0;
    }
    function Identifier2(kind, pos, end) {
        this.pos = pos;
        this.end = end;
        this.kind = kind;
        this.id = 0;
        this.flags = 0 /* None */ ;
        this.transformFlags = 0 /* None */ ;
        this.parent = void 0;
        this.original = void 0;
        this.emitNode = void 0;
    }
    function SourceMapSource(fileName, text, skipTrivia2) {
        this.fileName = fileName;
        this.text = text;
        this.skipTrivia = skipTrivia2 || ((pos)=>pos);
    }
    var objectAllocator = {
        getNodeConstructor: ()=>Node4,
        getTokenConstructor: ()=>Token,
        getIdentifierConstructor: ()=>Identifier2,
        getPrivateIdentifierConstructor: ()=>Node4,
        getSourceFileConstructor: ()=>Node4,
        getSymbolConstructor: ()=>Symbol4,
        getTypeConstructor: ()=>Type3,
        getSignatureConstructor: ()=>Signature2,
        getSourceMapSourceConstructor: ()=>SourceMapSource
    };
    var objectAllocatorPatchers = [];
    function addObjectAllocatorPatcher(fn) {
        objectAllocatorPatchers.push(fn);
        fn(objectAllocator);
    }
    function setObjectAllocator(alloc) {
        Object.assign(objectAllocator, alloc);
        forEach(objectAllocatorPatchers, (fn)=>fn(objectAllocator));
    }
    function formatStringFromArgs(text, args) {
        return text.replace(/\{(\d+)\}/g, (_match, index)=>"" + Debug.checkDefined(args[+index]));
    }
    var localizedDiagnosticMessages;
    function setLocalizedDiagnosticMessages(messages) {
        localizedDiagnosticMessages = messages;
    }
    function maybeSetLocalizedDiagnosticMessages(getMessages) {
        if (!localizedDiagnosticMessages && getMessages) localizedDiagnosticMessages = getMessages();
    }
    function getLocaleSpecificMessage(message) {
        return localizedDiagnosticMessages && localizedDiagnosticMessages[message.key] || message.message;
    }
    function createDetachedDiagnostic(fileName, sourceText, start, length2, message, ...args) {
        if (start + length2 > sourceText.length) length2 = sourceText.length - start;
        assertDiagnosticLocation(sourceText, start, length2);
        let text = getLocaleSpecificMessage(message);
        if (some(args)) text = formatStringFromArgs(text, args);
        return {
            file: void 0,
            start,
            length: length2,
            messageText: text,
            category: message.category,
            code: message.code,
            reportsUnnecessary: message.reportsUnnecessary,
            fileName
        };
    }
    function isDiagnosticWithDetachedLocation(diagnostic) {
        return diagnostic.file === void 0 && diagnostic.start !== void 0 && diagnostic.length !== void 0 && typeof diagnostic.fileName === "string";
    }
    function attachFileToDiagnostic(diagnostic, file) {
        const fileName = file.fileName || "";
        const length2 = file.text.length;
        Debug.assertEqual(diagnostic.fileName, fileName);
        Debug.assertLessThanOrEqual(diagnostic.start, length2);
        Debug.assertLessThanOrEqual(diagnostic.start + diagnostic.length, length2);
        const diagnosticWithLocation = {
            file,
            start: diagnostic.start,
            length: diagnostic.length,
            messageText: diagnostic.messageText,
            category: diagnostic.category,
            code: diagnostic.code,
            reportsUnnecessary: diagnostic.reportsUnnecessary
        };
        if (diagnostic.relatedInformation) {
            diagnosticWithLocation.relatedInformation = [];
            for (const related of diagnostic.relatedInformation)if (isDiagnosticWithDetachedLocation(related) && related.fileName === fileName) {
                Debug.assertLessThanOrEqual(related.start, length2);
                Debug.assertLessThanOrEqual(related.start + related.length, length2);
                diagnosticWithLocation.relatedInformation.push(attachFileToDiagnostic(related, file));
            } else diagnosticWithLocation.relatedInformation.push(related);
        }
        return diagnosticWithLocation;
    }
    function attachFileToDiagnostics(diagnostics, file) {
        const diagnosticsWithLocation = [];
        for (const diagnostic of diagnostics)diagnosticsWithLocation.push(attachFileToDiagnostic(diagnostic, file));
        return diagnosticsWithLocation;
    }
    function createFileDiagnostic(file, start, length2, message, ...args) {
        assertDiagnosticLocation(file.text, start, length2);
        let text = getLocaleSpecificMessage(message);
        if (some(args)) text = formatStringFromArgs(text, args);
        return {
            file,
            start,
            length: length2,
            messageText: text,
            category: message.category,
            code: message.code,
            reportsUnnecessary: message.reportsUnnecessary,
            reportsDeprecated: message.reportsDeprecated
        };
    }
    function formatMessage(message, ...args) {
        let text = getLocaleSpecificMessage(message);
        if (some(args)) text = formatStringFromArgs(text, args);
        return text;
    }
    function createCompilerDiagnostic(message, ...args) {
        let text = getLocaleSpecificMessage(message);
        if (some(args)) text = formatStringFromArgs(text, args);
        return {
            file: void 0,
            start: void 0,
            length: void 0,
            messageText: text,
            category: message.category,
            code: message.code,
            reportsUnnecessary: message.reportsUnnecessary,
            reportsDeprecated: message.reportsDeprecated
        };
    }
    function createCompilerDiagnosticFromMessageChain(chain, relatedInformation) {
        return {
            file: void 0,
            start: void 0,
            length: void 0,
            code: chain.code,
            category: chain.category,
            messageText: chain.next ? chain : chain.messageText,
            relatedInformation
        };
    }
    function chainDiagnosticMessages(details, message, ...args) {
        let text = getLocaleSpecificMessage(message);
        if (some(args)) text = formatStringFromArgs(text, args);
        return {
            messageText: text,
            category: message.category,
            code: message.code,
            next: details === void 0 || Array.isArray(details) ? details : [
                details
            ]
        };
    }
    function concatenateDiagnosticMessageChains(headChain, tailChain) {
        let lastChain = headChain;
        while(lastChain.next)lastChain = lastChain.next[0];
        lastChain.next = [
            tailChain
        ];
    }
    function getDiagnosticFilePath(diagnostic) {
        return diagnostic.file ? diagnostic.file.path : void 0;
    }
    function compareDiagnostics(d1, d2) {
        return compareDiagnosticsSkipRelatedInformation(d1, d2) || compareRelatedInformation(d1, d2) || 0 /* EqualTo */ ;
    }
    function compareDiagnosticsSkipRelatedInformation(d1, d2) {
        const code1 = getDiagnosticCode(d1);
        const code2 = getDiagnosticCode(d2);
        return compareStringsCaseSensitive(getDiagnosticFilePath(d1), getDiagnosticFilePath(d2)) || compareValues(d1.start, d2.start) || compareValues(d1.length, d2.length) || compareValues(code1, code2) || compareMessageText(d1, d2) || 0 /* EqualTo */ ;
    }
    function compareRelatedInformation(d1, d2) {
        if (!d1.relatedInformation && !d2.relatedInformation) return 0 /* EqualTo */ ;
        if (d1.relatedInformation && d2.relatedInformation) return compareValues(d2.relatedInformation.length, d1.relatedInformation.length) || forEach(d1.relatedInformation, (d1i, index)=>{
            const d2i = d2.relatedInformation[index];
            return compareDiagnostics(d1i, d2i);
        }) || 0 /* EqualTo */ ;
        return d1.relatedInformation ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
    }
    function compareMessageText(d1, d2) {
        let headMsg1 = getDiagnosticMessage(d1);
        let headMsg2 = getDiagnosticMessage(d2);
        if (typeof headMsg1 !== "string") headMsg1 = headMsg1.messageText;
        if (typeof headMsg2 !== "string") headMsg2 = headMsg2.messageText;
        const chain1 = typeof d1.messageText !== "string" ? d1.messageText.next : void 0;
        const chain2 = typeof d2.messageText !== "string" ? d2.messageText.next : void 0;
        let res = compareStringsCaseSensitive(headMsg1, headMsg2);
        if (res) return res;
        res = compareMessageChain(chain1, chain2);
        if (res) return res;
        if (d1.canonicalHead && !d2.canonicalHead) return -1 /* LessThan */ ;
        if (d2.canonicalHead && !d1.canonicalHead) return 1 /* GreaterThan */ ;
        return 0 /* EqualTo */ ;
    }
    function compareMessageChain(c1, c2) {
        if (c1 === void 0 && c2 === void 0) return 0 /* EqualTo */ ;
        if (c1 === void 0) return 1 /* GreaterThan */ ;
        if (c2 === void 0) return -1 /* LessThan */ ;
        return compareMessageChainSize(c1, c2) || compareMessageChainContent(c1, c2);
    }
    function compareMessageChainSize(c1, c2) {
        if (c1 === void 0 && c2 === void 0) return 0 /* EqualTo */ ;
        if (c1 === void 0) return 1 /* GreaterThan */ ;
        if (c2 === void 0) return -1 /* LessThan */ ;
        let res = compareValues(c2.length, c1.length);
        if (res) return res;
        for(let i = 0; i < c2.length; i++){
            res = compareMessageChainSize(c1[i].next, c2[i].next);
            if (res) return res;
        }
        return 0 /* EqualTo */ ;
    }
    function compareMessageChainContent(c1, c2) {
        let res;
        for(let i = 0; i < c2.length; i++){
            res = compareStringsCaseSensitive(c1[i].messageText, c2[i].messageText);
            if (res) return res;
            if (c1[i].next === void 0) continue;
            res = compareMessageChainContent(c1[i].next, c2[i].next);
            if (res) return res;
        }
        return 0 /* EqualTo */ ;
    }
    function diagnosticsEqualityComparer(d1, d2) {
        const code1 = getDiagnosticCode(d1);
        const code2 = getDiagnosticCode(d2);
        const msg1 = getDiagnosticMessage(d1);
        const msg2 = getDiagnosticMessage(d2);
        return compareStringsCaseSensitive(getDiagnosticFilePath(d1), getDiagnosticFilePath(d2)) === 0 /* EqualTo */  && compareValues(d1.start, d2.start) === 0 /* EqualTo */  && compareValues(d1.length, d2.length) === 0 /* EqualTo */  && compareValues(code1, code2) === 0 /* EqualTo */  && messageTextEqualityComparer(msg1, msg2);
    }
    function getDiagnosticCode(d) {
        var _a;
        return ((_a = d.canonicalHead) == null ? void 0 : _a.code) || d.code;
    }
    function getDiagnosticMessage(d) {
        var _a;
        return ((_a = d.canonicalHead) == null ? void 0 : _a.messageText) || d.messageText;
    }
    function messageTextEqualityComparer(m1, m2) {
        const t1 = typeof m1 === "string" ? m1 : m1.messageText;
        const t2 = typeof m2 === "string" ? m2 : m2.messageText;
        return compareStringsCaseSensitive(t1, t2) === 0 /* EqualTo */ ;
    }
    function getLanguageVariant(scriptKind) {
        return scriptKind === 4 /* TSX */  || scriptKind === 2 /* JSX */  || scriptKind === 1 /* JS */  || scriptKind === 6 /* JSON */  ? 1 /* JSX */  : 0 /* Standard */ ;
    }
    function walkTreeForJSXTags(node) {
        if (!(node.transformFlags & 2 /* ContainsJsx */ )) return void 0;
        return isJsxOpeningLikeElement(node) || isJsxFragment(node) ? node : forEachChild(node, walkTreeForJSXTags);
    }
    function isFileModuleFromUsingJSXTag(file) {
        return !file.isDeclarationFile ? walkTreeForJSXTags(file) : void 0;
    }
    function isFileForcedToBeModuleByFormat(file, options) {
        return (getImpliedNodeFormatForEmitWorker(file, options) === 99 /* ESNext */  || fileExtensionIsOneOf(file.fileName, [
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ ,
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ])) && !file.isDeclarationFile ? true : void 0;
    }
    function getSetExternalModuleIndicator(options) {
        switch(getEmitModuleDetectionKind(options)){
            case 3 /* Force */ :
                return (file)=>{
                    file.externalModuleIndicator = isFileProbablyExternalModule(file) || !file.isDeclarationFile || void 0;
                };
            case 1 /* Legacy */ :
                return (file)=>{
                    file.externalModuleIndicator = isFileProbablyExternalModule(file);
                };
            case 2 /* Auto */ :
                const checks = [
                    isFileProbablyExternalModule
                ];
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) checks.push(isFileModuleFromUsingJSXTag);
                checks.push(isFileForcedToBeModuleByFormat);
                const combined = or(...checks);
                const callback = (file)=>void (file.externalModuleIndicator = combined(file, options));
                return callback;
        }
    }
    function importSyntaxAffectsModuleResolution(options) {
        const moduleResolution = getEmitModuleResolutionKind(options);
        return 3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */  || getResolvePackageJsonExports(options) || getResolvePackageJsonImports(options);
    }
    function createComputedCompilerOptions(options) {
        return options;
    }
    var _computedOptions = createComputedCompilerOptions({
        allowImportingTsExtensions: {
            dependencies: [
                "rewriteRelativeImportExtensions"
            ],
            computeValue: (compilerOptions)=>{
                return !!(compilerOptions.allowImportingTsExtensions || compilerOptions.rewriteRelativeImportExtensions);
            }
        },
        target: {
            dependencies: [
                "module"
            ],
            computeValue: (compilerOptions)=>{
                const target = compilerOptions.target === 0 /* ES3 */  ? void 0 : compilerOptions.target;
                return target !== null && target !== void 0 ? target : compilerOptions.module === 100 /* Node16 */  && 9 /* ES2022 */  || compilerOptions.module === 101 /* Node18 */  && 9 /* ES2022 */  || compilerOptions.module === 102 /* Node20 */  && 10 /* ES2023 */  || compilerOptions.module === 199 /* NodeNext */  && 99 /* ESNext */  || 1 /* ES5 */ ;
            }
        },
        module: {
            dependencies: [
                "target"
            ],
            computeValue: (compilerOptions)=>{
                return typeof compilerOptions.module === "number" ? compilerOptions.module : _computedOptions.target.computeValue(compilerOptions) >= 2 /* ES2015 */  ? 5 /* ES2015 */  : 1 /* CommonJS */ ;
            }
        },
        moduleResolution: {
            dependencies: [
                "module",
                "target"
            ],
            computeValue: (compilerOptions)=>{
                let moduleResolution = compilerOptions.moduleResolution;
                if (moduleResolution === void 0) switch(_computedOptions.module.computeValue(compilerOptions)){
                    case 1 /* CommonJS */ :
                        moduleResolution = 2 /* Node10 */ ;
                        break;
                    case 100 /* Node16 */ :
                    case 101 /* Node18 */ :
                    case 102 /* Node20 */ :
                        moduleResolution = 3 /* Node16 */ ;
                        break;
                    case 199 /* NodeNext */ :
                        moduleResolution = 99 /* NodeNext */ ;
                        break;
                    case 200 /* Preserve */ :
                        moduleResolution = 100 /* Bundler */ ;
                        break;
                    default:
                        moduleResolution = 1 /* Classic */ ;
                        break;
                }
                return moduleResolution;
            }
        },
        moduleDetection: {
            dependencies: [
                "module",
                "target"
            ],
            computeValue: (compilerOptions)=>{
                if (compilerOptions.moduleDetection !== void 0) return compilerOptions.moduleDetection;
                const moduleKind = _computedOptions.module.computeValue(compilerOptions);
                return 100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  ? 3 /* Force */  : 2 /* Auto */ ;
            }
        },
        isolatedModules: {
            dependencies: [
                "verbatimModuleSyntax"
            ],
            computeValue: (compilerOptions)=>{
                return !!(compilerOptions.isolatedModules || compilerOptions.verbatimModuleSyntax);
            }
        },
        esModuleInterop: {
            dependencies: [
                "module",
                "target"
            ],
            computeValue: (compilerOptions)=>{
                if (compilerOptions.esModuleInterop !== void 0) return compilerOptions.esModuleInterop;
                switch(_computedOptions.module.computeValue(compilerOptions)){
                    case 100 /* Node16 */ :
                    case 101 /* Node18 */ :
                    case 102 /* Node20 */ :
                    case 199 /* NodeNext */ :
                    case 200 /* Preserve */ :
                        return true;
                }
                return false;
            }
        },
        allowSyntheticDefaultImports: {
            dependencies: [
                "module",
                "target",
                "moduleResolution"
            ],
            computeValue: (compilerOptions)=>{
                if (compilerOptions.allowSyntheticDefaultImports !== void 0) return compilerOptions.allowSyntheticDefaultImports;
                return _computedOptions.esModuleInterop.computeValue(compilerOptions) || _computedOptions.module.computeValue(compilerOptions) === 4 /* System */  || _computedOptions.moduleResolution.computeValue(compilerOptions) === 100 /* Bundler */ ;
            }
        },
        resolvePackageJsonExports: {
            dependencies: [
                "moduleResolution"
            ],
            computeValue: (compilerOptions)=>{
                const moduleResolution = _computedOptions.moduleResolution.computeValue(compilerOptions);
                if (!moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) return false;
                if (compilerOptions.resolvePackageJsonExports !== void 0) return compilerOptions.resolvePackageJsonExports;
                switch(moduleResolution){
                    case 3 /* Node16 */ :
                    case 99 /* NodeNext */ :
                    case 100 /* Bundler */ :
                        return true;
                }
                return false;
            }
        },
        resolvePackageJsonImports: {
            dependencies: [
                "moduleResolution",
                "resolvePackageJsonExports"
            ],
            computeValue: (compilerOptions)=>{
                const moduleResolution = _computedOptions.moduleResolution.computeValue(compilerOptions);
                if (!moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) return false;
                if (compilerOptions.resolvePackageJsonImports !== void 0) return compilerOptions.resolvePackageJsonImports;
                switch(moduleResolution){
                    case 3 /* Node16 */ :
                    case 99 /* NodeNext */ :
                    case 100 /* Bundler */ :
                        return true;
                }
                return false;
            }
        },
        resolveJsonModule: {
            dependencies: [
                "moduleResolution",
                "module",
                "target"
            ],
            computeValue: (compilerOptions)=>{
                if (compilerOptions.resolveJsonModule !== void 0) return compilerOptions.resolveJsonModule;
                switch(_computedOptions.module.computeValue(compilerOptions)){
                    // TODO in 6.0: uncomment
                    // case ModuleKind.Node16:
                    // case ModuleKind.Node18:
                    case 102 /* Node20 */ :
                    case 199 /* NodeNext */ :
                        return true;
                }
                return _computedOptions.moduleResolution.computeValue(compilerOptions) === 100 /* Bundler */ ;
            }
        },
        declaration: {
            dependencies: [
                "composite"
            ],
            computeValue: (compilerOptions)=>{
                return !!(compilerOptions.declaration || compilerOptions.composite);
            }
        },
        preserveConstEnums: {
            dependencies: [
                "isolatedModules",
                "verbatimModuleSyntax"
            ],
            computeValue: (compilerOptions)=>{
                return !!(compilerOptions.preserveConstEnums || _computedOptions.isolatedModules.computeValue(compilerOptions));
            }
        },
        incremental: {
            dependencies: [
                "composite"
            ],
            computeValue: (compilerOptions)=>{
                return !!(compilerOptions.incremental || compilerOptions.composite);
            }
        },
        declarationMap: {
            dependencies: [
                "declaration",
                "composite"
            ],
            computeValue: (compilerOptions)=>{
                return !!(compilerOptions.declarationMap && _computedOptions.declaration.computeValue(compilerOptions));
            }
        },
        allowJs: {
            dependencies: [
                "checkJs"
            ],
            computeValue: (compilerOptions)=>{
                return compilerOptions.allowJs === void 0 ? !!compilerOptions.checkJs : compilerOptions.allowJs;
            }
        },
        useDefineForClassFields: {
            dependencies: [
                "target",
                "module"
            ],
            computeValue: (compilerOptions)=>{
                return compilerOptions.useDefineForClassFields === void 0 ? _computedOptions.target.computeValue(compilerOptions) >= 9 /* ES2022 */  : compilerOptions.useDefineForClassFields;
            }
        },
        noImplicitAny: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "noImplicitAny");
            }
        },
        noImplicitThis: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "noImplicitThis");
            }
        },
        strictNullChecks: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "strictNullChecks");
            }
        },
        strictFunctionTypes: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "strictFunctionTypes");
            }
        },
        strictBindCallApply: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "strictBindCallApply");
            }
        },
        strictPropertyInitialization: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "strictPropertyInitialization");
            }
        },
        strictBuiltinIteratorReturn: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "strictBuiltinIteratorReturn");
            }
        },
        alwaysStrict: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "alwaysStrict");
            }
        },
        useUnknownInCatchVariables: {
            dependencies: [
                "strict"
            ],
            computeValue: (compilerOptions)=>{
                return getStrictOptionValue(compilerOptions, "useUnknownInCatchVariables");
            }
        }
    });
    var computedOptions = _computedOptions;
    var getAllowImportingTsExtensions = _computedOptions.allowImportingTsExtensions.computeValue;
    var getEmitScriptTarget = _computedOptions.target.computeValue;
    var getEmitModuleKind = _computedOptions.module.computeValue;
    var getEmitModuleResolutionKind = _computedOptions.moduleResolution.computeValue;
    var getEmitModuleDetectionKind = _computedOptions.moduleDetection.computeValue;
    var getIsolatedModules = _computedOptions.isolatedModules.computeValue;
    var getESModuleInterop = _computedOptions.esModuleInterop.computeValue;
    var getAllowSyntheticDefaultImports = _computedOptions.allowSyntheticDefaultImports.computeValue;
    var getResolvePackageJsonExports = _computedOptions.resolvePackageJsonExports.computeValue;
    var getResolvePackageJsonImports = _computedOptions.resolvePackageJsonImports.computeValue;
    var getResolveJsonModule = _computedOptions.resolveJsonModule.computeValue;
    var getEmitDeclarations = _computedOptions.declaration.computeValue;
    var shouldPreserveConstEnums = _computedOptions.preserveConstEnums.computeValue;
    var isIncrementalCompilation = _computedOptions.incremental.computeValue;
    var getAreDeclarationMapsEnabled = _computedOptions.declarationMap.computeValue;
    var getAllowJSCompilerOption = _computedOptions.allowJs.computeValue;
    var getUseDefineForClassFields = _computedOptions.useDefineForClassFields.computeValue;
    function emitModuleKindIsNonNodeESM(moduleKind) {
        return moduleKind >= 5 /* ES2015 */  && moduleKind <= 99 /* ESNext */ ;
    }
    function hasJsonModuleEmitEnabled(options) {
        switch(getEmitModuleKind(options)){
            case 0 /* None */ :
            case 4 /* System */ :
            case 3 /* UMD */ :
                return false;
        }
        return true;
    }
    function unreachableCodeIsError(options) {
        return options.allowUnreachableCode === false;
    }
    function unusedLabelIsError(options) {
        return options.allowUnusedLabels === false;
    }
    function moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution) {
        return moduleResolution >= 3 /* Node16 */  && moduleResolution <= 99 /* NodeNext */  || moduleResolution === 100 /* Bundler */ ;
    }
    function moduleSupportsImportAttributes(moduleKind) {
        return 101 /* Node18 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  || moduleKind === 200 /* Preserve */  || moduleKind === 99 /* ESNext */ ;
    }
    function getStrictOptionValue(compilerOptions, flag) {
        return compilerOptions[flag] === void 0 ? !!compilerOptions.strict : !!compilerOptions[flag];
    }
    function getNameOfScriptTarget(scriptTarget) {
        return forEachEntry(targetOptionDeclaration.type, (value1, key)=>value1 === scriptTarget ? key : void 0);
    }
    function getEmitStandardClassFields(compilerOptions) {
        return compilerOptions.useDefineForClassFields !== false && getEmitScriptTarget(compilerOptions) >= 9 /* ES2022 */ ;
    }
    function compilerOptionsAffectSemanticDiagnostics(newOptions, oldOptions) {
        return optionsHaveChanges(oldOptions, newOptions, semanticDiagnosticsOptionDeclarations);
    }
    function compilerOptionsAffectEmit(newOptions, oldOptions) {
        return optionsHaveChanges(oldOptions, newOptions, affectsEmitOptionDeclarations);
    }
    function compilerOptionsAffectDeclarationPath(newOptions, oldOptions) {
        return optionsHaveChanges(oldOptions, newOptions, affectsDeclarationPathOptionDeclarations);
    }
    function getCompilerOptionValue(options, option) {
        return option.strictFlag ? getStrictOptionValue(options, option.name) : option.allowJsFlag ? getAllowJSCompilerOption(options) : options[option.name];
    }
    function getJSXTransformEnabled(options) {
        const jsx = options.jsx;
        return jsx === 2 /* React */  || jsx === 4 /* ReactJSX */  || jsx === 5 /* ReactJSXDev */ ;
    }
    function getJSXImplicitImportBase(compilerOptions, file) {
        const jsxImportSourcePragmas = file == null ? void 0 : file.pragmas.get("jsximportsource");
        const jsxImportSourcePragma = isArray(jsxImportSourcePragmas) ? jsxImportSourcePragmas[jsxImportSourcePragmas.length - 1] : jsxImportSourcePragmas;
        const jsxRuntimePragmas = file == null ? void 0 : file.pragmas.get("jsxruntime");
        const jsxRuntimePragma = isArray(jsxRuntimePragmas) ? jsxRuntimePragmas[jsxRuntimePragmas.length - 1] : jsxRuntimePragmas;
        if ((jsxRuntimePragma == null ? void 0 : jsxRuntimePragma.arguments.factory) === "classic") return void 0;
        return compilerOptions.jsx === 4 /* ReactJSX */  || compilerOptions.jsx === 5 /* ReactJSXDev */  || compilerOptions.jsxImportSource || jsxImportSourcePragma || (jsxRuntimePragma == null ? void 0 : jsxRuntimePragma.arguments.factory) === "automatic" ? (jsxImportSourcePragma == null ? void 0 : jsxImportSourcePragma.arguments.factory) || compilerOptions.jsxImportSource || "react" : void 0;
    }
    function getJSXRuntimeImport(base, options) {
        return base ? `${base}/${options.jsx === 5 /* ReactJSXDev */  ? "jsx-dev-runtime" : "jsx-runtime"}` : void 0;
    }
    function hasZeroOrOneAsteriskCharacter(str) {
        let seenAsterisk = false;
        for(let i = 0; i < str.length; i++)if (str.charCodeAt(i) === 42 /* asterisk */ ) {
            if (!seenAsterisk) seenAsterisk = true;
            else return false;
        }
        return true;
    }
    function createSymlinkCache(cwd, getCanonicalFileName) {
        let symlinkedDirectories;
        let symlinkedDirectoriesByRealpath;
        let symlinkedFiles;
        let hasProcessedResolutions = false;
        return {
            getSymlinkedFiles: ()=>symlinkedFiles,
            getSymlinkedDirectories: ()=>symlinkedDirectories,
            getSymlinkedDirectoriesByRealpath: ()=>symlinkedDirectoriesByRealpath,
            setSymlinkedFile: (path, real)=>(symlinkedFiles || (symlinkedFiles = /* @__PURE__ */ new Map())).set(path, real),
            setSymlinkedDirectory: (symlink, real)=>{
                let symlinkPath = toPath(symlink, cwd, getCanonicalFileName);
                if (!containsIgnoredPath(symlinkPath)) {
                    symlinkPath = ensureTrailingDirectorySeparator(symlinkPath);
                    if (real !== false && !(symlinkedDirectories == null ? void 0 : symlinkedDirectories.has(symlinkPath))) (symlinkedDirectoriesByRealpath || (symlinkedDirectoriesByRealpath = createMultiMap())).add(real.realPath, symlink);
                    (symlinkedDirectories || (symlinkedDirectories = /* @__PURE__ */ new Map())).set(symlinkPath, real);
                }
            },
            setSymlinksFromResolutions (forEachResolvedModule, forEachResolvedTypeReferenceDirective, typeReferenceDirectives) {
                Debug.assert(!hasProcessedResolutions);
                hasProcessedResolutions = true;
                forEachResolvedModule((resolution)=>processResolution(this, resolution.resolvedModule));
                forEachResolvedTypeReferenceDirective((resolution)=>processResolution(this, resolution.resolvedTypeReferenceDirective));
                typeReferenceDirectives.forEach((resolution)=>processResolution(this, resolution.resolvedTypeReferenceDirective));
            },
            hasProcessedResolutions: ()=>hasProcessedResolutions,
            setSymlinksFromResolution (resolution) {
                processResolution(this, resolution);
            },
            hasAnySymlinks
        };
        function hasAnySymlinks() {
            return !!(symlinkedFiles == null ? void 0 : symlinkedFiles.size) || !!symlinkedDirectories && !!forEachEntry(symlinkedDirectories, (value1)=>!!value1);
        }
        function processResolution(cache, resolution) {
            if (!resolution || !resolution.originalPath || !resolution.resolvedFileName) return;
            const { resolvedFileName, originalPath } = resolution;
            cache.setSymlinkedFile(toPath(originalPath, cwd, getCanonicalFileName), resolvedFileName);
            const [commonResolved, commonOriginal] = guessDirectorySymlink(resolvedFileName, originalPath, cwd, getCanonicalFileName) || emptyArray;
            if (commonResolved && commonOriginal) cache.setSymlinkedDirectory(commonOriginal, {
                real: ensureTrailingDirectorySeparator(commonResolved),
                realPath: ensureTrailingDirectorySeparator(toPath(commonResolved, cwd, getCanonicalFileName))
            });
        }
    }
    function guessDirectorySymlink(a, b, cwd, getCanonicalFileName) {
        const aParts = getPathComponents(getNormalizedAbsolutePath(a, cwd));
        const bParts = getPathComponents(getNormalizedAbsolutePath(b, cwd));
        let isDirectory = false;
        while(aParts.length >= 2 && bParts.length >= 2 && !isNodeModulesOrScopedPackageDirectory(aParts[aParts.length - 2], getCanonicalFileName) && !isNodeModulesOrScopedPackageDirectory(bParts[bParts.length - 2], getCanonicalFileName) && getCanonicalFileName(aParts[aParts.length - 1]) === getCanonicalFileName(bParts[bParts.length - 1])){
            aParts.pop();
            bParts.pop();
            isDirectory = true;
        }
        return isDirectory ? [
            getPathFromPathComponents(aParts),
            getPathFromPathComponents(bParts)
        ] : void 0;
    }
    function isNodeModulesOrScopedPackageDirectory(s, getCanonicalFileName) {
        return s !== void 0 && (getCanonicalFileName(s) === "node_modules" || startsWith(s, "@"));
    }
    function stripLeadingDirectorySeparator(s) {
        return isAnyDirectorySeparator(s.charCodeAt(0)) ? s.slice(1) : void 0;
    }
    function tryRemoveDirectoryPrefix(path, dirPath, getCanonicalFileName) {
        const withoutPrefix = tryRemovePrefix(path, dirPath, getCanonicalFileName);
        return withoutPrefix === void 0 ? void 0 : stripLeadingDirectorySeparator(withoutPrefix);
    }
    var reservedCharacterPattern = /[^\w\s/]/g;
    function regExpEscape(text) {
        return text.replace(reservedCharacterPattern, escapeRegExpCharacter);
    }
    function escapeRegExpCharacter(match) {
        return "\\" + match;
    }
    var wildcardCharCodes = [
        42 /* asterisk */ ,
        63 /* question */ 
    ];
    var commonPackageFolders = [
        "node_modules",
        "bower_components",
        "jspm_packages"
    ];
    var implicitExcludePathRegexPattern = `(?!(?:${commonPackageFolders.join("|")})(?:/|$))`;
    var filesMatcher = {
        /**
   * Matches any single directory segment unless it is the last segment and a .min.js file
   * Breakdown:
   *  [^./]                   # matches everything up to the first . character (excluding directory separators)
   *  (\\.(?!min\\.js$))?     # matches . characters but not if they are part of the .min.js file extension
   */ singleAsteriskRegexFragment: "(?:[^./]|(?:\\.(?!min\\.js$))?)*",
        /**
   * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
   * files or directories, does not match subdirectories that start with a . character
   */ doubleAsteriskRegexFragment: `(?:/${implicitExcludePathRegexPattern}[^/.][^/]*)*?`,
        replaceWildcardCharacter: (match)=>replaceWildcardCharacter(match, filesMatcher.singleAsteriskRegexFragment)
    };
    var directoriesMatcher = {
        singleAsteriskRegexFragment: "[^/]*",
        /**
   * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
   * files or directories, does not match subdirectories that start with a . character
   */ doubleAsteriskRegexFragment: `(?:/${implicitExcludePathRegexPattern}[^/.][^/]*)*?`,
        replaceWildcardCharacter: (match)=>replaceWildcardCharacter(match, directoriesMatcher.singleAsteriskRegexFragment)
    };
    var excludeMatcher = {
        singleAsteriskRegexFragment: "[^/]*",
        doubleAsteriskRegexFragment: "(?:/.+?)?",
        replaceWildcardCharacter: (match)=>replaceWildcardCharacter(match, excludeMatcher.singleAsteriskRegexFragment)
    };
    var wildcardMatchers = {
        files: filesMatcher,
        directories: directoriesMatcher,
        exclude: excludeMatcher
    };
    function getRegularExpressionForWildcard(specs, basePath, usage) {
        const patterns = getRegularExpressionsForWildcards(specs, basePath, usage);
        if (!patterns || !patterns.length) return void 0;
        const pattern = patterns.map((pattern2)=>`(?:${pattern2})`).join("|");
        const terminator = usage === "exclude" ? "(?:$|/)" : "$";
        return `^(?:${pattern})${terminator}`;
    }
    function getRegularExpressionsForWildcards(specs, basePath, usage) {
        if (specs === void 0 || specs.length === 0) return void 0;
        return flatMap(specs, (spec)=>spec && getSubPatternFromSpec(spec, basePath, usage, wildcardMatchers[usage]));
    }
    function isImplicitGlob(lastPathComponent) {
        return !/[.*?]/.test(lastPathComponent);
    }
    function getPatternFromSpec(spec, basePath, usage) {
        const pattern = spec && getSubPatternFromSpec(spec, basePath, usage, wildcardMatchers[usage]);
        return pattern && `^(?:${pattern})${usage === "exclude" ? "(?:$|/)" : "$"}`;
    }
    function getSubPatternFromSpec(spec, basePath, usage, { singleAsteriskRegexFragment, doubleAsteriskRegexFragment, replaceWildcardCharacter: replaceWildcardCharacter2 } = wildcardMatchers[usage]) {
        let subpattern = "";
        let hasWrittenComponent = false;
        const components = getNormalizedPathComponents(spec, basePath);
        const lastComponent = last(components);
        if (usage !== "exclude" && lastComponent === "**") return void 0;
        components[0] = removeTrailingDirectorySeparator(components[0]);
        if (isImplicitGlob(lastComponent)) components.push("**", "*");
        let optionalCount = 0;
        for (let component of components){
            if (component === "**") subpattern += doubleAsteriskRegexFragment;
            else {
                if (usage === "directories") {
                    subpattern += "(?:";
                    optionalCount++;
                }
                if (hasWrittenComponent) subpattern += directorySeparator;
                if (usage !== "exclude") {
                    let componentPattern = "";
                    if (component.charCodeAt(0) === 42 /* asterisk */ ) {
                        componentPattern += "(?:[^./]" + singleAsteriskRegexFragment + ")?";
                        component = component.substr(1);
                    } else if (component.charCodeAt(0) === 63 /* question */ ) {
                        componentPattern += "[^./]";
                        component = component.substr(1);
                    }
                    componentPattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter2);
                    if (componentPattern !== component) subpattern += implicitExcludePathRegexPattern;
                    subpattern += componentPattern;
                } else subpattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter2);
            }
            hasWrittenComponent = true;
        }
        while(optionalCount > 0){
            subpattern += ")?";
            optionalCount--;
        }
        return subpattern;
    }
    function replaceWildcardCharacter(match, singleAsteriskRegexFragment) {
        return match === "*" ? singleAsteriskRegexFragment : match === "?" ? "[^/]" : "\\" + match;
    }
    function getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames2, currentDirectory) {
        path = normalizePath(path);
        currentDirectory = normalizePath(currentDirectory);
        const absolutePath = combinePaths(currentDirectory, path);
        return {
            includeFilePatterns: map(getRegularExpressionsForWildcards(includes, absolutePath, "files"), (pattern)=>`^${pattern}$`),
            includeFilePattern: getRegularExpressionForWildcard(includes, absolutePath, "files"),
            includeDirectoryPattern: getRegularExpressionForWildcard(includes, absolutePath, "directories"),
            excludePattern: getRegularExpressionForWildcard(excludes, absolutePath, "exclude"),
            basePaths: getBasePaths(path, includes, useCaseSensitiveFileNames2)
        };
    }
    function getRegexFromPattern(pattern, useCaseSensitiveFileNames2) {
        return new RegExp(pattern, useCaseSensitiveFileNames2 ? "" : "i");
    }
    function matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames2, currentDirectory, depth, getFileSystemEntries, realpath) {
        path = normalizePath(path);
        currentDirectory = normalizePath(currentDirectory);
        const patterns = getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames2, currentDirectory);
        const includeFileRegexes = patterns.includeFilePatterns && patterns.includeFilePatterns.map((pattern)=>getRegexFromPattern(pattern, useCaseSensitiveFileNames2));
        const includeDirectoryRegex = patterns.includeDirectoryPattern && getRegexFromPattern(patterns.includeDirectoryPattern, useCaseSensitiveFileNames2);
        const excludeRegex = patterns.excludePattern && getRegexFromPattern(patterns.excludePattern, useCaseSensitiveFileNames2);
        const results = includeFileRegexes ? includeFileRegexes.map(()=>[]) : [
            []
        ];
        const visited = /* @__PURE__ */ new Map();
        const toCanonical = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        for (const basePath of patterns.basePaths)visitDirectory(basePath, combinePaths(currentDirectory, basePath), depth);
        return flatten(results);
        function visitDirectory(path2, absolutePath, depth2) {
            const canonicalPath = toCanonical(realpath(absolutePath));
            if (visited.has(canonicalPath)) return;
            visited.set(canonicalPath, true);
            const { files, directories } = getFileSystemEntries(path2);
            for (const current of toSorted(files, compareStringsCaseSensitive)){
                const name = combinePaths(path2, current);
                const absoluteName = combinePaths(absolutePath, current);
                if (extensions && !fileExtensionIsOneOf(name, extensions)) continue;
                if (excludeRegex && excludeRegex.test(absoluteName)) continue;
                if (!includeFileRegexes) results[0].push(name);
                else {
                    const includeIndex = findIndex(includeFileRegexes, (re)=>re.test(absoluteName));
                    if (includeIndex !== -1) results[includeIndex].push(name);
                }
            }
            if (depth2 !== void 0) {
                depth2--;
                if (depth2 === 0) return;
            }
            for (const current of toSorted(directories, compareStringsCaseSensitive)){
                const name = combinePaths(path2, current);
                const absoluteName = combinePaths(absolutePath, current);
                if ((!includeDirectoryRegex || includeDirectoryRegex.test(absoluteName)) && (!excludeRegex || !excludeRegex.test(absoluteName))) visitDirectory(name, absoluteName, depth2);
            }
        }
    }
    function getBasePaths(path, includes, useCaseSensitiveFileNames2) {
        const basePaths = [
            path
        ];
        if (includes) {
            const includeBasePaths = [];
            for (const include of includes){
                const absolute = isRootedDiskPath(include) ? include : normalizePath(combinePaths(path, include));
                includeBasePaths.push(getIncludeBasePath(absolute));
            }
            includeBasePaths.sort(getStringComparer(!useCaseSensitiveFileNames2));
            for (const includeBasePath of includeBasePaths)if (every(basePaths, (basePath)=>!containsPath(basePath, includeBasePath, path, !useCaseSensitiveFileNames2))) basePaths.push(includeBasePath);
        }
        return basePaths;
    }
    function getIncludeBasePath(absolute) {
        const wildcardOffset = indexOfAnyCharCode(absolute, wildcardCharCodes);
        if (wildcardOffset < 0) return !hasExtension(absolute) ? absolute : removeTrailingDirectorySeparator(getDirectoryPath(absolute));
        return absolute.substring(0, absolute.lastIndexOf(directorySeparator, wildcardOffset));
    }
    function ensureScriptKind(fileName, scriptKind) {
        return scriptKind || getScriptKindFromFileName(fileName) || 3 /* TS */ ;
    }
    function getScriptKindFromFileName(fileName) {
        const ext = fileName.substr(fileName.lastIndexOf("."));
        switch(ext.toLowerCase()){
            case ".js" /* Js */ :
            case ".cjs" /* Cjs */ :
            case ".mjs" /* Mjs */ :
                return 1 /* JS */ ;
            case ".jsx" /* Jsx */ :
                return 2 /* JSX */ ;
            case ".ts" /* Ts */ :
            case ".cts" /* Cts */ :
            case ".mts" /* Mts */ :
                return 3 /* TS */ ;
            case ".tsx" /* Tsx */ :
                return 4 /* TSX */ ;
            case ".json" /* Json */ :
                return 6 /* JSON */ ;
            default:
                return 0 /* Unknown */ ;
        }
    }
    var supportedTSExtensions = [
        [
            ".ts" /* Ts */ ,
            ".tsx" /* Tsx */ ,
            ".d.ts" /* Dts */ 
        ],
        [
            ".cts" /* Cts */ ,
            ".d.cts" /* Dcts */ 
        ],
        [
            ".mts" /* Mts */ ,
            ".d.mts" /* Dmts */ 
        ]
    ];
    var supportedTSExtensionsFlat = flatten(supportedTSExtensions);
    var supportedTSExtensionsWithJson = [
        ...supportedTSExtensions,
        [
            ".json" /* Json */ 
        ]
    ];
    var supportedTSExtensionsForExtractExtension = [
        ".d.ts" /* Dts */ ,
        ".d.cts" /* Dcts */ ,
        ".d.mts" /* Dmts */ ,
        ".cts" /* Cts */ ,
        ".mts" /* Mts */ ,
        ".ts" /* Ts */ ,
        ".tsx" /* Tsx */ 
    ];
    var supportedJSExtensions = [
        [
            ".js" /* Js */ ,
            ".jsx" /* Jsx */ 
        ],
        [
            ".mjs" /* Mjs */ 
        ],
        [
            ".cjs" /* Cjs */ 
        ]
    ];
    var supportedJSExtensionsFlat = flatten(supportedJSExtensions);
    var allSupportedExtensions = [
        [
            ".ts" /* Ts */ ,
            ".tsx" /* Tsx */ ,
            ".d.ts" /* Dts */ ,
            ".js" /* Js */ ,
            ".jsx" /* Jsx */ 
        ],
        [
            ".cts" /* Cts */ ,
            ".d.cts" /* Dcts */ ,
            ".cjs" /* Cjs */ 
        ],
        [
            ".mts" /* Mts */ ,
            ".d.mts" /* Dmts */ ,
            ".mjs" /* Mjs */ 
        ]
    ];
    var allSupportedExtensionsWithJson = [
        ...allSupportedExtensions,
        [
            ".json" /* Json */ 
        ]
    ];
    var supportedDeclarationExtensions = [
        ".d.ts" /* Dts */ ,
        ".d.cts" /* Dcts */ ,
        ".d.mts" /* Dmts */ 
    ];
    var supportedTSImplementationExtensions = [
        ".ts" /* Ts */ ,
        ".cts" /* Cts */ ,
        ".mts" /* Mts */ ,
        ".tsx" /* Tsx */ 
    ];
    var extensionsNotSupportingExtensionlessResolution = [
        ".mts" /* Mts */ ,
        ".d.mts" /* Dmts */ ,
        ".mjs" /* Mjs */ ,
        ".cts" /* Cts */ ,
        ".d.cts" /* Dcts */ ,
        ".cjs" /* Cjs */ 
    ];
    function getSupportedExtensions(options, extraFileExtensions) {
        const needJsExtensions = options && getAllowJSCompilerOption(options);
        if (!extraFileExtensions || extraFileExtensions.length === 0) return needJsExtensions ? allSupportedExtensions : supportedTSExtensions;
        const builtins = needJsExtensions ? allSupportedExtensions : supportedTSExtensions;
        const flatBuiltins = flatten(builtins);
        const extensions = [
            ...builtins,
            ...mapDefined(extraFileExtensions, (x)=>x.scriptKind === 7 /* Deferred */  || needJsExtensions && isJSLike(x.scriptKind) && !flatBuiltins.includes(x.extension) ? [
                    x.extension
                ] : void 0)
        ];
        return extensions;
    }
    function getSupportedExtensionsWithJsonIfResolveJsonModule(options, supportedExtensions) {
        if (!options || !getResolveJsonModule(options)) return supportedExtensions;
        if (supportedExtensions === allSupportedExtensions) return allSupportedExtensionsWithJson;
        if (supportedExtensions === supportedTSExtensions) return supportedTSExtensionsWithJson;
        return [
            ...supportedExtensions,
            [
                ".json" /* Json */ 
            ]
        ];
    }
    function isJSLike(scriptKind) {
        return scriptKind === 1 /* JS */  || scriptKind === 2 /* JSX */ ;
    }
    function hasJSFileExtension(fileName) {
        return some(supportedJSExtensionsFlat, (extension)=>fileExtensionIs(fileName, extension));
    }
    function hasTSFileExtension(fileName) {
        return some(supportedTSExtensionsFlat, (extension)=>fileExtensionIs(fileName, extension));
    }
    function hasImplementationTSFileExtension(fileName) {
        return some(supportedTSImplementationExtensions, (extension)=>fileExtensionIs(fileName, extension)) && !isDeclarationFileName(fileName);
    }
    var ModuleSpecifierEnding = /* @__PURE__ */ ((ModuleSpecifierEnding2)=>{
        ModuleSpecifierEnding2[ModuleSpecifierEnding2["Minimal"] = 0] = "Minimal";
        ModuleSpecifierEnding2[ModuleSpecifierEnding2["Index"] = 1] = "Index";
        ModuleSpecifierEnding2[ModuleSpecifierEnding2["JsExtension"] = 2] = "JsExtension";
        ModuleSpecifierEnding2[ModuleSpecifierEnding2["TsExtension"] = 3] = "TsExtension";
        return ModuleSpecifierEnding2;
    })(ModuleSpecifierEnding || {});
    function usesExtensionsOnImports({ imports }, hasExtension2 = or(hasJSFileExtension, hasTSFileExtension)) {
        return firstDefined(imports, ({ text })=>pathIsRelative(text) && !fileExtensionIsOneOf(text, extensionsNotSupportingExtensionlessResolution) ? hasExtension2(text) : void 0) || false;
    }
    function getModuleSpecifierEndingPreference(preference, resolutionMode, compilerOptions, sourceFile) {
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        const moduleResolutionIsNodeNext = 3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */ ;
        if (preference === "js" || resolutionMode === 99 /* ESNext */  && moduleResolutionIsNodeNext) {
            if (!shouldAllowImportingTsExtension(compilerOptions)) return 2 /* JsExtension */ ;
            return inferPreference() !== 2 /* JsExtension */  ? 3 /* TsExtension */  : 2 /* JsExtension */ ;
        }
        if (preference === "minimal") return 0 /* Minimal */ ;
        if (preference === "index") return 1 /* Index */ ;
        if (!shouldAllowImportingTsExtension(compilerOptions)) return sourceFile && usesExtensionsOnImports(sourceFile) ? 2 /* JsExtension */  : 0 /* Minimal */ ;
        return inferPreference();
        function inferPreference() {
            let usesJsExtensions = false;
            const specifiers = (sourceFile == null ? void 0 : sourceFile.imports.length) ? sourceFile.imports : sourceFile && isSourceFileJS(sourceFile) ? getRequiresAtTopOfFile(sourceFile).map((r)=>r.arguments[0]) : emptyArray;
            for (const specifier of specifiers)if (pathIsRelative(specifier.text)) {
                if (moduleResolutionIsNodeNext && resolutionMode === 1 /* CommonJS */  && getModeForUsageLocation(sourceFile, specifier, compilerOptions) === 99 /* ESNext */ ) continue;
                if (fileExtensionIsOneOf(specifier.text, extensionsNotSupportingExtensionlessResolution)) continue;
                if (hasTSFileExtension(specifier.text)) return 3 /* TsExtension */ ;
                if (hasJSFileExtension(specifier.text)) usesJsExtensions = true;
            }
            return usesJsExtensions ? 2 /* JsExtension */  : 0 /* Minimal */ ;
        }
    }
    function getRequiresAtTopOfFile(sourceFile) {
        let nonRequireStatementCount = 0;
        let requires;
        for (const statement of sourceFile.statements){
            if (nonRequireStatementCount > 3) break;
            if (isRequireVariableStatement(statement)) requires = concatenate(requires, statement.declarationList.declarations.map((d)=>d.initializer));
            else if (isExpressionStatement(statement) && isRequireCall(statement.expression, /*requireStringLiteralLikeArgument*/ true)) requires = append(requires, statement.expression);
            else nonRequireStatementCount++;
        }
        return requires || emptyArray;
    }
    function isSupportedSourceFileName(fileName, compilerOptions, extraFileExtensions) {
        if (!fileName) return false;
        const supportedExtensions = getSupportedExtensions(compilerOptions, extraFileExtensions);
        for (const extension of flatten(getSupportedExtensionsWithJsonIfResolveJsonModule(compilerOptions, supportedExtensions))){
            if (fileExtensionIs(fileName, extension)) return true;
        }
        return false;
    }
    function numberOfDirectorySeparators(str) {
        const match = str.match(/\//g);
        return match ? match.length : 0;
    }
    function compareNumberOfDirectorySeparators(path1, path2) {
        return compareValues(numberOfDirectorySeparators(path1), numberOfDirectorySeparators(path2));
    }
    var extensionsToRemove = [
        ".d.ts" /* Dts */ ,
        ".d.mts" /* Dmts */ ,
        ".d.cts" /* Dcts */ ,
        ".mjs" /* Mjs */ ,
        ".mts" /* Mts */ ,
        ".cjs" /* Cjs */ ,
        ".cts" /* Cts */ ,
        ".ts" /* Ts */ ,
        ".js" /* Js */ ,
        ".tsx" /* Tsx */ ,
        ".jsx" /* Jsx */ ,
        ".json" /* Json */ 
    ];
    function removeFileExtension(path) {
        for (const ext of extensionsToRemove){
            const extensionless = tryRemoveExtension(path, ext);
            if (extensionless !== void 0) return extensionless;
        }
        return path;
    }
    function tryRemoveExtension(path, extension) {
        return fileExtensionIs(path, extension) ? removeExtension(path, extension) : void 0;
    }
    function removeExtension(path, extension) {
        return path.substring(0, path.length - extension.length);
    }
    function changeExtension(path, newExtension) {
        return changeAnyExtension(path, newExtension, extensionsToRemove, /*ignoreCase*/ false);
    }
    function tryParsePattern(pattern) {
        const indexOfStar = pattern.indexOf("*");
        if (indexOfStar === -1) return pattern;
        return pattern.indexOf("*", indexOfStar + 1) !== -1 ? void 0 : {
            prefix: pattern.substr(0, indexOfStar),
            suffix: pattern.substr(indexOfStar + 1)
        };
    }
    var parsedPatternsCache = /* @__PURE__ */ new WeakMap();
    function tryParsePatterns(paths) {
        let result = parsedPatternsCache.get(paths);
        if (result !== void 0) return result;
        let matchableStringSet;
        let patterns;
        const pathList = getOwnKeys(paths);
        for (const path of pathList){
            const patternOrStr = tryParsePattern(path);
            if (patternOrStr === void 0) continue;
            else if (typeof patternOrStr === "string") (matchableStringSet !== null && matchableStringSet !== void 0 ? matchableStringSet : matchableStringSet = /* @__PURE__ */ new Set()).add(patternOrStr);
            else (patterns !== null && patterns !== void 0 ? patterns : patterns = []).push(patternOrStr);
        }
        parsedPatternsCache.set(paths, result = {
            matchableStringSet,
            patterns
        });
        return result;
    }
    function positionIsSynthesized(pos) {
        return !(pos >= 0);
    }
    function extensionIsTS(ext) {
        return ext === ".ts" /* Ts */  || ext === ".tsx" /* Tsx */  || ext === ".d.ts" /* Dts */  || ext === ".cts" /* Cts */  || ext === ".mts" /* Mts */  || ext === ".d.mts" /* Dmts */  || ext === ".d.cts" /* Dcts */  || startsWith(ext, ".d.") && endsWith(ext, ".ts");
    }
    function resolutionExtensionIsTSOrJson(ext) {
        return extensionIsTS(ext) || ext === ".json" /* Json */ ;
    }
    function extensionFromPath(path) {
        const ext = tryGetExtensionFromPath2(path);
        return ext !== void 0 ? ext : Debug.fail(`File ${path} has unknown extension.`);
    }
    function isAnySupportedFileExtension(path) {
        return tryGetExtensionFromPath2(path) !== void 0;
    }
    function tryGetExtensionFromPath2(path) {
        return find(extensionsToRemove, (e)=>fileExtensionIs(path, e));
    }
    function isCheckJsEnabledForFile(sourceFile, compilerOptions) {
        return sourceFile.checkJsDirective ? sourceFile.checkJsDirective.enabled : compilerOptions.checkJs;
    }
    var emptyFileSystemEntries = {
        files: emptyArray,
        directories: emptyArray
    };
    function matchPatternOrExact(parsedPatterns, candidate) {
        const { matchableStringSet, patterns } = parsedPatterns;
        if (matchableStringSet == null ? void 0 : matchableStringSet.has(candidate)) return candidate;
        if (patterns === void 0 || patterns.length === 0) return void 0;
        return findBestPatternMatch(patterns, (_)=>_, candidate);
    }
    function sliceAfter(arr, value1) {
        const index = arr.indexOf(value1);
        Debug.assert(index !== -1);
        return arr.slice(index);
    }
    function addRelatedInfo(diagnostic, ...relatedInformation) {
        if (!relatedInformation.length) return diagnostic;
        if (!diagnostic.relatedInformation) diagnostic.relatedInformation = [];
        Debug.assert(diagnostic.relatedInformation !== emptyArray, "Diagnostic had empty array singleton for related info, but is still being constructed!");
        diagnostic.relatedInformation.push(...relatedInformation);
        return diagnostic;
    }
    function minAndMax(arr, getValue) {
        Debug.assert(arr.length !== 0);
        let min2 = getValue(arr[0]);
        let max = min2;
        for(let i = 1; i < arr.length; i++){
            const value1 = getValue(arr[i]);
            if (value1 < min2) min2 = value1;
            else if (value1 > max) max = value1;
        }
        return {
            min: min2,
            max
        };
    }
    function rangeOfNode(node) {
        return {
            pos: getTokenPosOfNode(node),
            end: node.end
        };
    }
    function rangeOfTypeParameters(sourceFile, typeParameters) {
        const pos = typeParameters.pos - 1;
        const end = Math.min(sourceFile.text.length, skipTrivia(sourceFile.text, typeParameters.end) + 1);
        return {
            pos,
            end
        };
    }
    function skipTypeChecking(sourceFile, options, host) {
        return skipTypeCheckingWorker(sourceFile, options, host, /*ignoreNoCheck*/ false);
    }
    function skipTypeCheckingIgnoringNoCheck(sourceFile, options, host) {
        return skipTypeCheckingWorker(sourceFile, options, host, /*ignoreNoCheck*/ true);
    }
    function skipTypeCheckingWorker(sourceFile, options, host, ignoreNoCheck) {
        return options.skipLibCheck && sourceFile.isDeclarationFile || options.skipDefaultLibCheck && sourceFile.hasNoDefaultLib || !ignoreNoCheck && options.noCheck || host.isSourceOfProjectReferenceRedirect(sourceFile.fileName) || !canIncludeBindAndCheckDiagnostics(sourceFile, options);
    }
    function canIncludeBindAndCheckDiagnostics(sourceFile, options) {
        if (!!sourceFile.checkJsDirective && sourceFile.checkJsDirective.enabled === false) return false;
        if (sourceFile.scriptKind === 3 /* TS */  || sourceFile.scriptKind === 4 /* TSX */  || sourceFile.scriptKind === 5 /* External */ ) return true;
        const isJs = sourceFile.scriptKind === 1 /* JS */  || sourceFile.scriptKind === 2 /* JSX */ ;
        const isCheckJs = isJs && isCheckJsEnabledForFile(sourceFile, options);
        const isPlainJs = isPlainJsFile(sourceFile, options.checkJs);
        return isPlainJs || isCheckJs || sourceFile.scriptKind === 7 /* Deferred */ ;
    }
    function isJsonEqual(a, b) {
        return a === b || typeof a === "object" && a !== null && typeof b === "object" && b !== null && equalOwnProperties(a, b, isJsonEqual);
    }
    function parsePseudoBigInt(stringValue) {
        let log2Base;
        switch(stringValue.charCodeAt(1)){
            // "x" in "0x123"
            case 98 /* b */ :
            case 66 /* B */ :
                log2Base = 1;
                break;
            case 111 /* o */ :
            case 79 /* O */ :
                log2Base = 3;
                break;
            case 120 /* x */ :
            case 88 /* X */ :
                log2Base = 4;
                break;
            default:
                const nIndex = stringValue.length - 1;
                let nonZeroStart = 0;
                while(stringValue.charCodeAt(nonZeroStart) === 48 /* _0 */ )nonZeroStart++;
                return stringValue.slice(nonZeroStart, nIndex) || "0";
        }
        const startIndex = 2, endIndex = stringValue.length - 1;
        const bitsNeeded = (endIndex - startIndex) * log2Base;
        const segments = new Uint16Array((bitsNeeded >>> 4) + (bitsNeeded & 15 ? 1 : 0));
        for(let i = endIndex - 1, bitOffset = 0; i >= startIndex; i--, bitOffset += log2Base){
            const segment = bitOffset >>> 4;
            const digitChar = stringValue.charCodeAt(i);
            const digit = digitChar <= 57 /* _9 */  ? digitChar - 48 /* _0 */  : 10 + digitChar - (digitChar <= 70 /* F */  ? 65 /* A */  : 97 /* a */ );
            const shiftedDigit = digit << (bitOffset & 15);
            segments[segment] |= shiftedDigit;
            const residual = shiftedDigit >>> 16;
            if (residual) segments[segment + 1] |= residual;
        }
        let base10Value = "";
        let firstNonzeroSegment = segments.length - 1;
        let segmentsRemaining = true;
        while(segmentsRemaining){
            let mod10 = 0;
            segmentsRemaining = false;
            for(let segment = firstNonzeroSegment; segment >= 0; segment--){
                const newSegment = mod10 << 16 | segments[segment];
                const segmentValue = newSegment / 10 | 0;
                segments[segment] = segmentValue;
                mod10 = newSegment - segmentValue * 10;
                if (segmentValue && !segmentsRemaining) {
                    firstNonzeroSegment = segment;
                    segmentsRemaining = true;
                }
            }
            base10Value = mod10 + base10Value;
        }
        return base10Value;
    }
    function pseudoBigIntToString({ negative, base10Value }) {
        return (negative && base10Value !== "0" ? "-" : "") + base10Value;
    }
    function parseBigInt(text) {
        if (!isValidBigIntString(text, /*roundTripOnly*/ false)) return void 0;
        return parseValidBigInt(text);
    }
    function parseValidBigInt(text) {
        const negative = text.startsWith("-");
        const base10Value = parsePseudoBigInt(`${negative ? text.slice(1) : text}n`);
        return {
            negative,
            base10Value
        };
    }
    function isValidBigIntString(s, roundTripOnly) {
        if (s === "") return false;
        const scanner2 = createScanner(99 /* ESNext */ , /*skipTrivia*/ false);
        let success = true;
        scanner2.setOnError(()=>success = false);
        scanner2.setText(s + "n");
        let result = scanner2.scan();
        const negative = result === 41 /* MinusToken */ ;
        if (negative) result = scanner2.scan();
        const flags = scanner2.getTokenFlags();
        return success && result === 10 /* BigIntLiteral */  && scanner2.getTokenEnd() === s.length + 1 && !(flags & 512 /* ContainsSeparator */ ) && (!roundTripOnly || s === pseudoBigIntToString({
            negative,
            base10Value: parsePseudoBigInt(scanner2.getTokenValue())
        }));
    }
    function isValidTypeOnlyAliasUseSite(useSite) {
        return !!(useSite.flags & 33554432 /* Ambient */ ) || isInJSDoc(useSite) || isPartOfTypeQuery(useSite) || isIdentifierInNonEmittingHeritageClause(useSite) || isPartOfPossiblyValidTypeOrAbstractComputedPropertyName(useSite) || !(isExpressionNode(useSite) || isShorthandPropertyNameUseSite(useSite));
    }
    function isShorthandPropertyNameUseSite(useSite) {
        return isIdentifier(useSite) && isShorthandPropertyAssignment(useSite.parent) && useSite.parent.name === useSite;
    }
    function isPartOfPossiblyValidTypeOrAbstractComputedPropertyName(node) {
        while(node.kind === 80 /* Identifier */  || node.kind === 212 /* PropertyAccessExpression */ )node = node.parent;
        if (node.kind !== 168 /* ComputedPropertyName */ ) return false;
        if (hasSyntacticModifier(node.parent, 64 /* Abstract */ )) return true;
        const containerKind = node.parent.parent.kind;
        return containerKind === 265 /* InterfaceDeclaration */  || containerKind === 188 /* TypeLiteral */ ;
    }
    function isIdentifierInNonEmittingHeritageClause(node) {
        if (node.kind !== 80 /* Identifier */ ) return false;
        const heritageClause = findAncestor(node.parent, (parent2)=>{
            switch(parent2.kind){
                case 299 /* HeritageClause */ :
                    return true;
                case 212 /* PropertyAccessExpression */ :
                case 234 /* ExpressionWithTypeArguments */ :
                    return false;
                default:
                    return "quit";
            }
        });
        return (heritageClause == null ? void 0 : heritageClause.token) === 119 /* ImplementsKeyword */  || (heritageClause == null ? void 0 : heritageClause.parent.kind) === 265 /* InterfaceDeclaration */ ;
    }
    function isIdentifierTypeReference(node) {
        return isTypeReferenceNode(node) && isIdentifier(node.typeName);
    }
    function arrayIsHomogeneous(array, comparer = equateValues) {
        if (array.length < 2) return true;
        const first2 = array[0];
        for(let i = 1, length2 = array.length; i < length2; i++){
            const target = array[i];
            if (!comparer(first2, target)) return false;
        }
        return true;
    }
    function setTextRangePos(range, pos) {
        range.pos = pos;
        return range;
    }
    function setTextRangeEnd(range, end) {
        range.end = end;
        return range;
    }
    function setTextRangePosEnd(range, pos, end) {
        return setTextRangeEnd(setTextRangePos(range, pos), end);
    }
    function setTextRangePosWidth(range, pos, width) {
        return setTextRangePosEnd(range, pos, pos + width);
    }
    function setNodeFlags(node, newFlags) {
        if (node) node.flags = newFlags;
        return node;
    }
    function setParent(child, parent2) {
        if (child && parent2) child.parent = parent2;
        return child;
    }
    function setParentRecursive(rootNode, incremental) {
        if (!rootNode) return rootNode;
        forEachChildRecursively(rootNode, isJSDocNode(rootNode) ? bindParentToChildIgnoringJSDoc : bindParentToChild);
        return rootNode;
        function bindParentToChildIgnoringJSDoc(child, parent2) {
            if (incremental && child.parent === parent2) return "skip";
            setParent(child, parent2);
        }
        function bindJSDoc(child) {
            if (hasJSDocNodes(child)) for (const doc of child.jsDoc){
                bindParentToChildIgnoringJSDoc(doc, child);
                forEachChildRecursively(doc, bindParentToChildIgnoringJSDoc);
            }
        }
        function bindParentToChild(child, parent2) {
            return bindParentToChildIgnoringJSDoc(child, parent2) || bindJSDoc(child);
        }
    }
    function isPackedElement(node) {
        return !isOmittedExpression(node);
    }
    function isPackedArrayLiteral(node) {
        return isArrayLiteralExpression(node) && every(node.elements, isPackedElement);
    }
    function expressionResultIsUnused(node) {
        Debug.assertIsDefined(node.parent);
        while(true){
            const parent2 = node.parent;
            if (isParenthesizedExpression(parent2)) {
                node = parent2;
                continue;
            }
            if (isExpressionStatement(parent2) || isVoidExpression(parent2) || isForStatement(parent2) && (parent2.initializer === node || parent2.incrementor === node)) return true;
            if (isCommaListExpression(parent2)) {
                if (node !== last(parent2.elements)) return true;
                node = parent2;
                continue;
            }
            if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 28 /* CommaToken */ ) {
                if (node === parent2.left) return true;
                node = parent2;
                continue;
            }
            return false;
        }
    }
    function containsIgnoredPath(path) {
        return some(ignoredPaths, (p)=>path.includes(p));
    }
    function getContainingNodeArray(node) {
        if (!node.parent) return void 0;
        switch(node.kind){
            case 169 /* TypeParameter */ :
                const { parent: parent3 } = node;
                return parent3.kind === 196 /* InferType */  ? void 0 : parent3.typeParameters;
            case 170 /* Parameter */ :
                return node.parent.parameters;
            case 205 /* TemplateLiteralTypeSpan */ :
                return node.parent.templateSpans;
            case 240 /* TemplateSpan */ :
                return node.parent.templateSpans;
            case 171 /* Decorator */ :
                {
                    const { parent: parent4 } = node;
                    return canHaveDecorators(parent4) ? parent4.modifiers : void 0;
                }
            case 299 /* HeritageClause */ :
                return node.parent.heritageClauses;
        }
        const { parent: parent2 } = node;
        if (isJSDocTag(node)) return isJSDocTypeLiteral(node.parent) ? void 0 : node.parent.tags;
        switch(parent2.kind){
            case 188 /* TypeLiteral */ :
            case 265 /* InterfaceDeclaration */ :
                return isTypeElement(node) ? parent2.members : void 0;
            case 193 /* UnionType */ :
            case 194 /* IntersectionType */ :
                return parent2.types;
            case 190 /* TupleType */ :
            case 210 /* ArrayLiteralExpression */ :
            case 357 /* CommaListExpression */ :
            case 276 /* NamedImports */ :
            case 280 /* NamedExports */ :
                return parent2.elements;
            case 211 /* ObjectLiteralExpression */ :
            case 293 /* JsxAttributes */ :
                return parent2.properties;
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
                return isTypeNode(node) ? parent2.typeArguments : parent2.expression === node ? void 0 : parent2.arguments;
            case 285 /* JsxElement */ :
            case 289 /* JsxFragment */ :
                return isJsxChild(node) ? parent2.children : void 0;
            case 287 /* JsxOpeningElement */ :
            case 286 /* JsxSelfClosingElement */ :
                return isTypeNode(node) ? parent2.typeArguments : void 0;
            case 242 /* Block */ :
            case 297 /* CaseClause */ :
            case 298 /* DefaultClause */ :
            case 269 /* ModuleBlock */ :
                return parent2.statements;
            case 270 /* CaseBlock */ :
                return parent2.clauses;
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
                return isClassElement(node) ? parent2.members : void 0;
            case 267 /* EnumDeclaration */ :
                return isEnumMember(node) ? parent2.members : void 0;
            case 308 /* SourceFile */ :
                return parent2.statements;
        }
    }
    function hasContextSensitiveParameters(node) {
        if (!node.typeParameters) {
            if (some(node.parameters, (p)=>!getEffectiveTypeAnnotationNode(p))) return true;
            if (node.kind !== 220 /* ArrowFunction */ ) {
                const parameter = firstOrUndefined(node.parameters);
                if (!(parameter && parameterIsThisKeyword(parameter))) return true;
            }
        }
        return false;
    }
    function isInfinityOrNaNString(name) {
        return name === "Infinity" || name === "-Infinity" || name === "NaN";
    }
    function isCatchClauseVariableDeclaration(node) {
        return node.kind === 261 /* VariableDeclaration */  && node.parent.kind === 300 /* CatchClause */ ;
    }
    function isFunctionExpressionOrArrowFunction(node) {
        return node.kind === 219 /* FunctionExpression */  || node.kind === 220 /* ArrowFunction */ ;
    }
    function escapeSnippetText(text) {
        return text.replace(/\$/g, ()=>"\\$");
    }
    function isNumericLiteralName(name) {
        return (+name).toString() === name;
    }
    function createPropertyNameNodeForIdentifierOrLiteral(name, target, singleQuote, stringNamed, isMethod) {
        const isMethodNamedNew = isMethod && name === "new";
        return !isMethodNamedNew && isIdentifierText(name, target) ? factory.createIdentifier(name) : !stringNamed && !isMethodNamedNew && isNumericLiteralName(name) && +name >= 0 ? factory.createNumericLiteral(+name) : factory.createStringLiteral(name, !!singleQuote);
    }
    function isThisTypeParameter(type) {
        return !!(type.flags & 262144 /* TypeParameter */  && type.isThisType);
    }
    function getNodeModulePathParts(fullPath) {
        let topLevelNodeModulesIndex = 0;
        let topLevelPackageNameIndex = 0;
        let packageRootIndex = 0;
        let fileNameIndex = 0;
        let States;
        ((States2)=>{
            States2[States2["BeforeNodeModules"] = 0] = "BeforeNodeModules";
            States2[States2["NodeModules"] = 1] = "NodeModules";
            States2[States2["Scope"] = 2] = "Scope";
            States2[States2["PackageContent"] = 3] = "PackageContent";
        })(States || (States = {}));
        let partStart = 0;
        let partEnd = 0;
        let state = 0 /* BeforeNodeModules */ ;
        while(partEnd >= 0){
            partStart = partEnd;
            partEnd = fullPath.indexOf("/", partStart + 1);
            switch(state){
                case 0 /* BeforeNodeModules */ :
                    if (fullPath.indexOf(nodeModulesPathPart, partStart) === partStart) {
                        topLevelNodeModulesIndex = partStart;
                        topLevelPackageNameIndex = partEnd;
                        state = 1 /* NodeModules */ ;
                    }
                    break;
                case 1 /* NodeModules */ :
                case 2 /* Scope */ :
                    if (state === 1 /* NodeModules */  && fullPath.charAt(partStart + 1) === "@") state = 2 /* Scope */ ;
                    else {
                        packageRootIndex = partEnd;
                        state = 3 /* PackageContent */ ;
                    }
                    break;
                case 3 /* PackageContent */ :
                    if (fullPath.indexOf(nodeModulesPathPart, partStart) === partStart) state = 1 /* NodeModules */ ;
                    else state = 3 /* PackageContent */ ;
                    break;
            }
        }
        fileNameIndex = partStart;
        return state > 1 /* NodeModules */  ? {
            topLevelNodeModulesIndex,
            topLevelPackageNameIndex,
            packageRootIndex,
            fileNameIndex
        } : void 0;
    }
    function isTypeDeclaration(node) {
        switch(node.kind){
            case 169 /* TypeParameter */ :
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 347 /* JSDocTypedefTag */ :
            case 339 /* JSDocCallbackTag */ :
            case 341 /* JSDocEnumTag */ :
                return true;
            case 274 /* ImportClause */ :
                return node.phaseModifier === 156 /* TypeKeyword */ ;
            case 277 /* ImportSpecifier */ :
                return node.parent.parent.phaseModifier === 156 /* TypeKeyword */ ;
            case 282 /* ExportSpecifier */ :
                return node.parent.parent.isTypeOnly;
            default:
                return false;
        }
    }
    function canHaveExportModifier(node) {
        return isEnumDeclaration(node) || isVariableStatement(node) || isFunctionDeclaration(node) || isClassDeclaration(node) || isInterfaceDeclaration(node) || isTypeDeclaration(node) || isModuleDeclaration(node) && !isExternalModuleAugmentation(node) && !isGlobalScopeAugmentation(node);
    }
    function isOptionalJSDocPropertyLikeTag(node) {
        if (!isJSDocPropertyLikeTag(node)) return false;
        const { isBracketed, typeExpression } = node;
        return isBracketed || !!typeExpression && typeExpression.type.kind === 317 /* JSDocOptionalType */ ;
    }
    function canUsePropertyAccess(name, languageVersion) {
        if (name.length === 0) return false;
        const firstChar = name.charCodeAt(0);
        return firstChar === 35 /* hash */  ? name.length > 1 && isIdentifierStart(name.charCodeAt(1), languageVersion) : isIdentifierStart(firstChar, languageVersion);
    }
    function hasTabstop(node) {
        var _a;
        return ((_a = getSnippetElement(node)) == null ? void 0 : _a.kind) === 0 /* TabStop */ ;
    }
    function isJSDocOptionalParameter(node) {
        return isInJSFile(node) && // node.type should only be a JSDocOptionalType when node is a parameter of a JSDocFunctionType
        (node.type && node.type.kind === 317 /* JSDocOptionalType */  || getJSDocParameterTags(node).some(isOptionalJSDocPropertyLikeTag));
    }
    function isOptionalDeclaration(declaration) {
        switch(declaration.kind){
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
                return !!declaration.questionToken;
            case 170 /* Parameter */ :
                return !!declaration.questionToken || isJSDocOptionalParameter(declaration);
            case 349 /* JSDocPropertyTag */ :
            case 342 /* JSDocParameterTag */ :
                return isOptionalJSDocPropertyLikeTag(declaration);
            default:
                return false;
        }
    }
    function isNonNullAccess(node) {
        const kind = node.kind;
        return (kind === 212 /* PropertyAccessExpression */  || kind === 213 /* ElementAccessExpression */ ) && isNonNullExpression(node.expression);
    }
    function isJSDocSatisfiesExpression(node) {
        return isInJSFile(node) && isParenthesizedExpression(node) && hasJSDocNodes(node) && !!getJSDocSatisfiesTag(node);
    }
    function getJSDocSatisfiesExpressionType(node) {
        return Debug.checkDefined(tryGetJSDocSatisfiesTypeNode(node));
    }
    function tryGetJSDocSatisfiesTypeNode(node) {
        const tag = getJSDocSatisfiesTag(node);
        return tag && tag.typeExpression && tag.typeExpression.type;
    }
    function getEscapedTextOfJsxAttributeName(node) {
        return isIdentifier(node) ? node.escapedText : getEscapedTextOfJsxNamespacedName(node);
    }
    function getTextOfJsxAttributeName(node) {
        return isIdentifier(node) ? idText(node) : getTextOfJsxNamespacedName(node);
    }
    function isJsxAttributeName(node) {
        const kind = node.kind;
        return kind === 80 /* Identifier */  || kind === 296 /* JsxNamespacedName */ ;
    }
    function getEscapedTextOfJsxNamespacedName(node) {
        return `${node.namespace.escapedText}:${idText(node.name)}`;
    }
    function getTextOfJsxNamespacedName(node) {
        return `${idText(node.namespace)}:${idText(node.name)}`;
    }
    function intrinsicTagNameToString(node) {
        return isIdentifier(node) ? idText(node) : getTextOfJsxNamespacedName(node);
    }
    function isTypeUsableAsPropertyName(type) {
        return !!(type.flags & 8576 /* StringOrNumberLiteralOrUnique */ );
    }
    function getPropertyNameFromType(type) {
        if (type.flags & 8192 /* UniqueESSymbol */ ) return type.escapedName;
        if (type.flags & 384 /* NumberLiteral */ ) return escapeLeadingUnderscores("" + type.value);
        return Debug.fail();
    }
    function isExpandoPropertyDeclaration(declaration) {
        return !!declaration && (isPropertyAccessExpression(declaration) || isElementAccessExpression(declaration) || isBinaryExpression(declaration));
    }
    function hasResolutionModeOverride(node) {
        if (node === void 0) return false;
        return !!getResolutionModeOverride(node.attributes);
    }
    var stringReplace = String.prototype.replace;
    function replaceFirstStar(s, replacement) {
        return stringReplace.call(s, "*", replacement);
    }
    function getNameFromImportAttribute(node) {
        return isIdentifier(node.name) ? node.name.escapedText : escapeLeadingUnderscores(node.name.text);
    }
    function isSourceElement(node) {
        switch(node.kind){
            case 169 /* TypeParameter */ :
            case 170 /* Parameter */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 186 /* ConstructorType */ :
            case 185 /* FunctionType */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 182 /* IndexSignature */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 176 /* ClassStaticBlockDeclaration */ :
            case 177 /* Constructor */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 184 /* TypeReference */ :
            case 183 /* TypePredicate */ :
            case 187 /* TypeQuery */ :
            case 188 /* TypeLiteral */ :
            case 189 /* ArrayType */ :
            case 190 /* TupleType */ :
            case 193 /* UnionType */ :
            case 194 /* IntersectionType */ :
            case 197 /* ParenthesizedType */ :
            case 191 /* OptionalType */ :
            case 192 /* RestType */ :
            case 198 /* ThisType */ :
            case 199 /* TypeOperator */ :
            case 195 /* ConditionalType */ :
            case 196 /* InferType */ :
            case 204 /* TemplateLiteralType */ :
            case 206 /* ImportType */ :
            case 203 /* NamedTupleMember */ :
            case 329 /* JSDocAugmentsTag */ :
            case 330 /* JSDocImplementsTag */ :
            case 347 /* JSDocTypedefTag */ :
            case 339 /* JSDocCallbackTag */ :
            case 341 /* JSDocEnumTag */ :
            case 346 /* JSDocTemplateTag */ :
            case 345 /* JSDocTypeTag */ :
            case 325 /* JSDocLink */ :
            case 326 /* JSDocLinkCode */ :
            case 327 /* JSDocLinkPlain */ :
            case 342 /* JSDocParameterTag */ :
            case 349 /* JSDocPropertyTag */ :
            case 318 /* JSDocFunctionType */ :
            case 316 /* JSDocNonNullableType */ :
            case 315 /* JSDocNullableType */ :
            case 313 /* JSDocAllType */ :
            case 314 /* JSDocUnknownType */ :
            case 323 /* JSDocTypeLiteral */ :
            case 319 /* JSDocVariadicType */ :
            case 310 /* JSDocTypeExpression */ :
            case 334 /* JSDocPublicTag */ :
            case 336 /* JSDocProtectedTag */ :
            case 335 /* JSDocPrivateTag */ :
            case 351 /* JSDocSatisfiesTag */ :
            case 344 /* JSDocThisTag */ :
            case 200 /* IndexedAccessType */ :
            case 201 /* MappedType */ :
            case 263 /* FunctionDeclaration */ :
            case 242 /* Block */ :
            case 269 /* ModuleBlock */ :
            case 244 /* VariableStatement */ :
            case 245 /* ExpressionStatement */ :
            case 246 /* IfStatement */ :
            case 247 /* DoStatement */ :
            case 248 /* WhileStatement */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 252 /* ContinueStatement */ :
            case 253 /* BreakStatement */ :
            case 254 /* ReturnStatement */ :
            case 255 /* WithStatement */ :
            case 256 /* SwitchStatement */ :
            case 257 /* LabeledStatement */ :
            case 258 /* ThrowStatement */ :
            case 259 /* TryStatement */ :
            case 261 /* VariableDeclaration */ :
            case 209 /* BindingElement */ :
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 273 /* ImportDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 278 /* ExportAssignment */ :
            case 243 /* EmptyStatement */ :
            case 260 /* DebuggerStatement */ :
            case 283 /* MissingDeclaration */ :
                return true;
        }
        return false;
    }
    function evaluatorResult(value1, isSyntacticallyString = false, resolvedOtherFiles = false, hasExternalReferences = false) {
        return {
            value: value1,
            isSyntacticallyString,
            resolvedOtherFiles,
            hasExternalReferences
        };
    }
    function createEvaluator({ evaluateElementAccessExpression, evaluateEntityNameExpression }) {
        function evaluate(expr, location) {
            let isSyntacticallyString = false;
            let resolvedOtherFiles = false;
            let hasExternalReferences = false;
            expr = skipParentheses(expr);
            switch(expr.kind){
                case 225 /* PrefixUnaryExpression */ :
                    const result = evaluate(expr.operand, location);
                    resolvedOtherFiles = result.resolvedOtherFiles;
                    hasExternalReferences = result.hasExternalReferences;
                    if (typeof result.value === "number") switch(expr.operator){
                        case 40 /* PlusToken */ :
                            return evaluatorResult(result.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                        case 41 /* MinusToken */ :
                            return evaluatorResult(-result.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                        case 55 /* TildeToken */ :
                            return evaluatorResult(~result.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                    }
                    break;
                case 227 /* BinaryExpression */ :
                    {
                        const left = evaluate(expr.left, location);
                        const right = evaluate(expr.right, location);
                        isSyntacticallyString = (left.isSyntacticallyString || right.isSyntacticallyString) && expr.operatorToken.kind === 40 /* PlusToken */ ;
                        resolvedOtherFiles = left.resolvedOtherFiles || right.resolvedOtherFiles;
                        hasExternalReferences = left.hasExternalReferences || right.hasExternalReferences;
                        if (typeof left.value === "number" && typeof right.value === "number") switch(expr.operatorToken.kind){
                            case 52 /* BarToken */ :
                                return evaluatorResult(left.value | right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 51 /* AmpersandToken */ :
                                return evaluatorResult(left.value & right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 49 /* GreaterThanGreaterThanToken */ :
                                return evaluatorResult(left.value >> right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                                return evaluatorResult(left.value >>> right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 48 /* LessThanLessThanToken */ :
                                return evaluatorResult(left.value << right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 53 /* CaretToken */ :
                                return evaluatorResult(left.value ^ right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 42 /* AsteriskToken */ :
                                return evaluatorResult(left.value * right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 44 /* SlashToken */ :
                                return evaluatorResult(left.value / right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 40 /* PlusToken */ :
                                return evaluatorResult(left.value + right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 41 /* MinusToken */ :
                                return evaluatorResult(left.value - right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 45 /* PercentToken */ :
                                return evaluatorResult(left.value % right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                            case 43 /* AsteriskAsteriskToken */ :
                                return evaluatorResult(left.value ** right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                        }
                        else if ((typeof left.value === "string" || typeof left.value === "number") && (typeof right.value === "string" || typeof right.value === "number") && expr.operatorToken.kind === 40 /* PlusToken */ ) return evaluatorResult("" + left.value + right.value, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
                        break;
                    }
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return evaluatorResult(expr.text, /*isSyntacticallyString*/ true);
                case 229 /* TemplateExpression */ :
                    return evaluateTemplateExpression(expr, location);
                case 9 /* NumericLiteral */ :
                    return evaluatorResult(+expr.text);
                case 80 /* Identifier */ :
                    return evaluateEntityNameExpression(expr, location);
                case 212 /* PropertyAccessExpression */ :
                    if (isEntityNameExpression(expr)) return evaluateEntityNameExpression(expr, location);
                    break;
                case 213 /* ElementAccessExpression */ :
                    return evaluateElementAccessExpression(expr, location);
            }
            return evaluatorResult(/*value*/ void 0, isSyntacticallyString, resolvedOtherFiles, hasExternalReferences);
        }
        function evaluateTemplateExpression(expr, location) {
            let result = expr.head.text;
            let resolvedOtherFiles = false;
            let hasExternalReferences = false;
            for (const span of expr.templateSpans){
                const spanResult = evaluate(span.expression, location);
                if (spanResult.value === void 0) return evaluatorResult(/*value*/ void 0, /*isSyntacticallyString*/ true);
                result += spanResult.value;
                result += span.literal.text;
                resolvedOtherFiles || (resolvedOtherFiles = spanResult.resolvedOtherFiles);
                hasExternalReferences || (hasExternalReferences = spanResult.hasExternalReferences);
            }
            return evaluatorResult(result, /*isSyntacticallyString*/ true, resolvedOtherFiles, hasExternalReferences);
        }
        return evaluate;
    }
    function isConstAssertion(location) {
        return isAssertionExpression(location) && isConstTypeReference(location.type) || isJSDocTypeTag(location) && isConstTypeReference(location.typeExpression);
    }
    function findConstructorDeclaration(node) {
        const members = node.members;
        for (const member of members){
            if (member.kind === 177 /* Constructor */  && nodeIsPresent(member.body)) return member;
        }
    }
    function createNameResolver({ compilerOptions, requireSymbol, argumentsSymbol, error: error2, getSymbolOfDeclaration, globals, lookup, setRequiresScopeChangeCache = returnUndefined, getRequiresScopeChangeCache = returnUndefined, onPropertyWithInvalidInitializer = returnFalse, onFailedToResolveSymbol = returnUndefined, onSuccessfullyResolvedSymbol = returnUndefined }) {
        var isolatedModulesLikeFlagName = compilerOptions.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules";
        var emitStandardClassFields = getEmitStandardClassFields(compilerOptions);
        var emptySymbols = createSymbolTable();
        return resolveNameHelper;
        function resolveNameHelper(location, nameArg, meaning, nameNotFoundMessage, isUse, excludeGlobals) {
            var _a, _b, _c;
            const originalLocation = location;
            let result;
            let lastLocation;
            let lastSelfReferenceLocation;
            let propertyWithInvalidInitializer;
            let associatedDeclarationForContainingInitializerOrBindingName;
            let withinDeferredContext = false;
            let grandparent;
            const name = isString(nameArg) ? nameArg : nameArg.escapedText;
            loop: while(location){
                if (name === "const" && isConstAssertion(location)) return void 0;
                if (isModuleOrEnumDeclaration(location) && lastLocation && location.name === lastLocation) {
                    lastLocation = location;
                    location = location.parent;
                }
                if (canHaveLocals(location) && location.locals && !isGlobalSourceFile(location)) {
                    if (result = lookup(location.locals, name, meaning)) {
                        let useResult = true;
                        if (isFunctionLike(location) && lastLocation && lastLocation !== location.body) {
                            if (meaning & result.flags & 788968 /* Type */  && lastLocation.kind !== 321 /* JSDoc */ ) useResult = result.flags & 262144 /* TypeParameter */  ? !!(lastLocation.flags & 16 /* Synthesized */ ) || // Synthetic fake scopes are added for signatures so type parameters are accessible from them
                            lastLocation === location.type || lastLocation.kind === 170 /* Parameter */  || lastLocation.kind === 342 /* JSDocParameterTag */  || lastLocation.kind === 343 /* JSDocReturnTag */  || lastLocation.kind === 169 /* TypeParameter */  : false;
                            if (meaning & result.flags & 3 /* Variable */ ) {
                                if (useOuterVariableScopeInParameter(result, location, lastLocation)) useResult = false;
                                else if (result.flags & 1 /* FunctionScopedVariable */ ) useResult = lastLocation.kind === 170 /* Parameter */  || !!(lastLocation.flags & 16 /* Synthesized */ ) || // Synthetic fake scopes are added for signatures so parameters are accessible from them
                                lastLocation === location.type && !!findAncestor(result.valueDeclaration, isParameter);
                            }
                        } else if (location.kind === 195 /* ConditionalType */ ) useResult = lastLocation === location.trueType;
                        if (useResult) break loop;
                        else result = void 0;
                    }
                }
                withinDeferredContext = withinDeferredContext || getIsDeferredContext(location, lastLocation);
                switch(location.kind){
                    case 308 /* SourceFile */ :
                        if (!isExternalOrCommonJsModule(location)) break;
                    // falls through
                    case 268 /* ModuleDeclaration */ :
                        const moduleExports = ((_a = getSymbolOfDeclaration(location)) == null ? void 0 : _a.exports) || emptySymbols;
                        if (location.kind === 308 /* SourceFile */  || isModuleDeclaration(location) && location.flags & 33554432 /* Ambient */  && !isGlobalScopeAugmentation(location)) {
                            if (result = moduleExports.get("default" /* Default */ )) {
                                const localSymbol = getLocalSymbolForExportDefault(result);
                                if (localSymbol && result.flags & meaning && localSymbol.escapedName === name) break loop;
                                result = void 0;
                            }
                            const moduleExport = moduleExports.get(name);
                            if (moduleExport && moduleExport.flags === 2097152 /* Alias */  && (getDeclarationOfKind(moduleExport, 282 /* ExportSpecifier */ ) || getDeclarationOfKind(moduleExport, 281 /* NamespaceExport */ ))) break;
                        }
                        if (name !== "default" /* Default */  && (result = lookup(moduleExports, name, meaning & 2623475 /* ModuleMember */ ))) {
                            if (isSourceFile(location) && location.commonJsModuleIndicator && !((_b = result.declarations) == null ? void 0 : _b.some(isJSDocTypeAlias))) result = void 0;
                            else break loop;
                        }
                        break;
                    case 267 /* EnumDeclaration */ :
                        if (result = lookup(((_c = getSymbolOfDeclaration(location)) == null ? void 0 : _c.exports) || emptySymbols, name, meaning & 8 /* EnumMember */ )) {
                            if (nameNotFoundMessage && getIsolatedModules(compilerOptions) && !(location.flags & 33554432 /* Ambient */ ) && getSourceFileOfNode(location) !== getSourceFileOfNode(result.valueDeclaration)) error2(originalLocation, Diagnostics.Cannot_access_0_from_another_file_without_qualification_when_1_is_enabled_Use_2_instead, unescapeLeadingUnderscores(name), isolatedModulesLikeFlagName, `${unescapeLeadingUnderscores(getSymbolOfDeclaration(location).escapedName)}.${unescapeLeadingUnderscores(name)}`);
                            break loop;
                        }
                        break;
                    case 173 /* PropertyDeclaration */ :
                        if (!isStatic(location)) {
                            const ctor = findConstructorDeclaration(location.parent);
                            if (ctor && ctor.locals) {
                                if (lookup(ctor.locals, name, meaning & 111551 /* Value */ )) {
                                    Debug.assertNode(location, isPropertyDeclaration);
                                    propertyWithInvalidInitializer = location;
                                }
                            }
                        }
                        break;
                    case 264 /* ClassDeclaration */ :
                    case 232 /* ClassExpression */ :
                    case 265 /* InterfaceDeclaration */ :
                        if (result = lookup(getSymbolOfDeclaration(location).members || emptySymbols, name, meaning & 788968 /* Type */ )) {
                            if (!isTypeParameterSymbolDeclaredInContainer(result, location)) {
                                result = void 0;
                                break;
                            }
                            if (lastLocation && isStatic(lastLocation)) {
                                if (nameNotFoundMessage) error2(originalLocation, Diagnostics.Static_members_cannot_reference_class_type_parameters);
                                return void 0;
                            }
                            break loop;
                        }
                        if (isClassExpression(location) && meaning & 32 /* Class */ ) {
                            const className = location.name;
                            if (className && name === className.escapedText) {
                                result = location.symbol;
                                break loop;
                            }
                        }
                        break;
                    case 234 /* ExpressionWithTypeArguments */ :
                        if (lastLocation === location.expression && location.parent.token === 96 /* ExtendsKeyword */ ) {
                            const container = location.parent.parent;
                            if (isClassLike(container) && (result = lookup(getSymbolOfDeclaration(container).members, name, meaning & 788968 /* Type */ ))) {
                                if (nameNotFoundMessage) error2(originalLocation, Diagnostics.Base_class_expressions_cannot_reference_class_type_parameters);
                                return void 0;
                            }
                        }
                        break;
                    // It is not legal to reference a class's own type parameters from a computed property name that
                    // belongs to the class. For example:
                    //
                    //   function foo<T>() { return '' }
                    //   class C<T> { // <-- Class's own type parameter T
                    //       [foo<T>()]() { } // <-- Reference to T from class's own computed property
                    //   }
                    //
                    case 168 /* ComputedPropertyName */ :
                        grandparent = location.parent.parent;
                        if (isClassLike(grandparent) || grandparent.kind === 265 /* InterfaceDeclaration */ ) {
                            if (result = lookup(getSymbolOfDeclaration(grandparent).members, name, meaning & 788968 /* Type */ )) {
                                if (nameNotFoundMessage) error2(originalLocation, Diagnostics.A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type);
                                return void 0;
                            }
                        }
                        break;
                    case 220 /* ArrowFunction */ :
                        if (getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */ ) break;
                    // falls through
                    case 175 /* MethodDeclaration */ :
                    case 177 /* Constructor */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 263 /* FunctionDeclaration */ :
                        if (meaning & 3 /* Variable */  && name === "arguments") {
                            result = argumentsSymbol;
                            break loop;
                        }
                        break;
                    case 219 /* FunctionExpression */ :
                        if (meaning & 3 /* Variable */  && name === "arguments") {
                            result = argumentsSymbol;
                            break loop;
                        }
                        if (meaning & 16 /* Function */ ) {
                            const functionName = location.name;
                            if (functionName && name === functionName.escapedText) {
                                result = location.symbol;
                                break loop;
                            }
                        }
                        break;
                    case 171 /* Decorator */ :
                        if (location.parent && location.parent.kind === 170 /* Parameter */ ) location = location.parent;
                        if (location.parent && (isClassElement(location.parent) || location.parent.kind === 264 /* ClassDeclaration */ )) location = location.parent;
                        break;
                    case 347 /* JSDocTypedefTag */ :
                    case 339 /* JSDocCallbackTag */ :
                    case 341 /* JSDocEnumTag */ :
                    case 352 /* JSDocImportTag */ :
                        const root = getJSDocRoot(location);
                        if (root) location = root.parent;
                        break;
                    case 170 /* Parameter */ :
                        if (lastLocation && (lastLocation === location.initializer || lastLocation === location.name && isBindingPattern(lastLocation))) {
                            if (!associatedDeclarationForContainingInitializerOrBindingName) associatedDeclarationForContainingInitializerOrBindingName = location;
                        }
                        break;
                    case 209 /* BindingElement */ :
                        if (lastLocation && (lastLocation === location.initializer || lastLocation === location.name && isBindingPattern(lastLocation))) {
                            if (isPartOfParameterDeclaration(location) && !associatedDeclarationForContainingInitializerOrBindingName) associatedDeclarationForContainingInitializerOrBindingName = location;
                        }
                        break;
                    case 196 /* InferType */ :
                        if (meaning & 262144 /* TypeParameter */ ) {
                            const parameterName = location.typeParameter.name;
                            if (parameterName && name === parameterName.escapedText) {
                                result = location.typeParameter.symbol;
                                break loop;
                            }
                        }
                        break;
                    case 282 /* ExportSpecifier */ :
                        if (lastLocation && lastLocation === location.propertyName && location.parent.parent.moduleSpecifier) location = location.parent.parent.parent;
                        break;
                }
                if (isSelfReferenceLocation(location, lastLocation)) lastSelfReferenceLocation = location;
                lastLocation = location;
                location = isJSDocTemplateTag(location) ? getEffectiveContainerForJSDocTemplateTag(location) || location.parent : isJSDocParameterTag(location) || isJSDocReturnTag(location) ? getHostSignatureFromJSDoc(location) || location.parent : location.parent;
            }
            if (isUse && result && (!lastSelfReferenceLocation || result !== lastSelfReferenceLocation.symbol)) result.isReferenced |= meaning;
            if (!result) {
                if (lastLocation) {
                    Debug.assertNode(lastLocation, isSourceFile);
                    if (lastLocation.commonJsModuleIndicator && name === "exports" && meaning & lastLocation.symbol.flags) return lastLocation.symbol;
                }
                if (!excludeGlobals) result = lookup(globals, name, meaning);
            }
            if (!result) {
                if (originalLocation && isInJSFile(originalLocation) && originalLocation.parent) {
                    if (isRequireCall(originalLocation.parent, /*requireStringLiteralLikeArgument*/ false)) return requireSymbol;
                }
            }
            if (nameNotFoundMessage) {
                if (propertyWithInvalidInitializer && onPropertyWithInvalidInitializer(originalLocation, name, propertyWithInvalidInitializer, result)) return void 0;
                if (!result) onFailedToResolveSymbol(originalLocation, nameArg, meaning, nameNotFoundMessage);
                else onSuccessfullyResolvedSymbol(originalLocation, result, meaning, lastLocation, associatedDeclarationForContainingInitializerOrBindingName, withinDeferredContext);
            }
            return result;
        }
        function useOuterVariableScopeInParameter(result, location, lastLocation) {
            const target = getEmitScriptTarget(compilerOptions);
            const functionLocation = location;
            if (isParameter(lastLocation) && functionLocation.body && result.valueDeclaration && result.valueDeclaration.pos >= functionLocation.body.pos && result.valueDeclaration.end <= functionLocation.body.end) {
                if (target >= 2 /* ES2015 */ ) {
                    let declarationRequiresScopeChange = getRequiresScopeChangeCache(functionLocation);
                    if (declarationRequiresScopeChange === void 0) {
                        declarationRequiresScopeChange = forEach(functionLocation.parameters, requiresScopeChange) || false;
                        setRequiresScopeChangeCache(functionLocation, declarationRequiresScopeChange);
                    }
                    return !declarationRequiresScopeChange;
                }
            }
            return false;
            function requiresScopeChange(node) {
                return requiresScopeChangeWorker(node.name) || !!node.initializer && requiresScopeChangeWorker(node.initializer);
            }
            function requiresScopeChangeWorker(node) {
                switch(node.kind){
                    case 220 /* ArrowFunction */ :
                    case 219 /* FunctionExpression */ :
                    case 263 /* FunctionDeclaration */ :
                    case 177 /* Constructor */ :
                        return false;
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 304 /* PropertyAssignment */ :
                        return requiresScopeChangeWorker(node.name);
                    case 173 /* PropertyDeclaration */ :
                        if (hasStaticModifier(node)) return !emitStandardClassFields;
                        return requiresScopeChangeWorker(node.name);
                    default:
                        if (isNullishCoalesce(node) || isOptionalChain(node)) return target < 7 /* ES2020 */ ;
                        if (isBindingElement(node) && node.dotDotDotToken && isObjectBindingPattern(node.parent)) return target < 4 /* ES2017 */ ;
                        if (isTypeNode(node)) return false;
                        return forEachChild(node, requiresScopeChangeWorker) || false;
                }
            }
        }
        function getIsDeferredContext(location, lastLocation) {
            if (location.kind !== 220 /* ArrowFunction */  && location.kind !== 219 /* FunctionExpression */ ) return isTypeQueryNode(location) || (isFunctionLikeDeclaration(location) || location.kind === 173 /* PropertyDeclaration */  && !isStatic(location)) && (!lastLocation || lastLocation !== location.name);
            if (lastLocation && lastLocation === location.name) return false;
            if (location.asteriskToken || hasSyntacticModifier(location, 1024 /* Async */ )) return true;
            return !getImmediatelyInvokedFunctionExpression(location);
        }
        function isSelfReferenceLocation(node, lastLocation) {
            switch(node.kind){
                case 170 /* Parameter */ :
                    return !!lastLocation && lastLocation === node.name;
                case 263 /* FunctionDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 267 /* EnumDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                    return true;
                default:
                    return false;
            }
        }
        function isTypeParameterSymbolDeclaredInContainer(symbol, container) {
            if (symbol.declarations) {
                for (const decl of symbol.declarations)if (decl.kind === 169 /* TypeParameter */ ) {
                    const parent2 = isJSDocTemplateTag(decl.parent) ? getJSDocHost(decl.parent) : decl.parent;
                    if (parent2 === container) return !(isJSDocTemplateTag(decl.parent) && find(decl.parent.parent.tags, isJSDocTypeAlias));
                }
            }
            return false;
        }
    }
    function isPrimitiveLiteralValue(node, includeBigInt = true) {
        Debug.type(node);
        switch(node.kind){
            case 112 /* TrueKeyword */ :
            case 97 /* FalseKeyword */ :
            case 9 /* NumericLiteral */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return true;
            case 10 /* BigIntLiteral */ :
                return includeBigInt;
            case 225 /* PrefixUnaryExpression */ :
                if (node.operator === 41 /* MinusToken */ ) return isNumericLiteral(node.operand) || includeBigInt && isBigIntLiteral(node.operand);
                if (node.operator === 40 /* PlusToken */ ) return isNumericLiteral(node.operand);
                return false;
            default:
                assertType(node);
                return false;
        }
    }
    function unwrapParenthesizedExpression(o) {
        while(o.kind === 218 /* ParenthesizedExpression */ )o = o.expression;
        return o;
    }
    function hasInferredType(node) {
        Debug.type(node);
        switch(node.kind){
            case 170 /* Parameter */ :
            case 172 /* PropertySignature */ :
            case 173 /* PropertyDeclaration */ :
            case 209 /* BindingElement */ :
            case 212 /* PropertyAccessExpression */ :
            case 213 /* ElementAccessExpression */ :
            case 227 /* BinaryExpression */ :
            case 261 /* VariableDeclaration */ :
            case 278 /* ExportAssignment */ :
            case 304 /* PropertyAssignment */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 342 /* JSDocParameterTag */ :
            case 349 /* JSDocPropertyTag */ :
                return true;
            default:
                assertType(node);
                return false;
        }
    }
    function isSideEffectImport(node) {
        const ancestor = findAncestor(node, isImportDeclaration);
        return !!ancestor && !ancestor.importClause;
    }
    var unprefixedNodeCoreModulesList = [
        "assert",
        "assert/strict",
        "async_hooks",
        "buffer",
        "child_process",
        "cluster",
        "console",
        "constants",
        "crypto",
        "dgram",
        "diagnostics_channel",
        "dns",
        "dns/promises",
        "domain",
        "events",
        "fs",
        "fs/promises",
        "http",
        "http2",
        "https",
        "inspector",
        "inspector/promises",
        "module",
        "net",
        "os",
        "path",
        "path/posix",
        "path/win32",
        "perf_hooks",
        "process",
        "punycode",
        "querystring",
        "readline",
        "readline/promises",
        "repl",
        "stream",
        "stream/consumers",
        "stream/promises",
        "stream/web",
        "string_decoder",
        "sys",
        "test/mock_loader",
        "timers",
        "timers/promises",
        "tls",
        "trace_events",
        "tty",
        "url",
        "util",
        "util/types",
        "v8",
        "vm",
        "wasi",
        "worker_threads",
        "zlib"
    ];
    var unprefixedNodeCoreModules = new Set(unprefixedNodeCoreModulesList);
    var exclusivelyPrefixedNodeCoreModules = /* @__PURE__ */ new Set([
        "node:sea",
        "node:sqlite",
        "node:test",
        "node:test/reporters"
    ]);
    var nodeCoreModules = /* @__PURE__ */ new Set([
        ...unprefixedNodeCoreModulesList,
        ...unprefixedNodeCoreModulesList.map((name)=>`node:${name}`),
        ...exclusivelyPrefixedNodeCoreModules
    ]);
    function forEachDynamicImportOrRequireCall(file, includeTypeSpaceImports, requireStringLiteralLikeArgument, cb) {
        const isJavaScriptFile = isInJSFile(file);
        const r = /import|require/g;
        while(r.exec(file.text) !== null){
            const node = getNodeAtPosition(file, r.lastIndex, /*includeJSDoc*/ includeTypeSpaceImports);
            if (isJavaScriptFile && isRequireCall(node, requireStringLiteralLikeArgument)) cb(node, node.arguments[0]);
            else if (isImportCall(node) && node.arguments.length >= 1 && (!requireStringLiteralLikeArgument || isStringLiteralLike(node.arguments[0]))) cb(node, node.arguments[0]);
            else if (includeTypeSpaceImports && isLiteralImportTypeNode(node)) cb(node, node.argument.literal);
            else if (includeTypeSpaceImports && isJSDocImportTag(node)) {
                const moduleNameExpr = getExternalModuleName(node);
                if (moduleNameExpr && isStringLiteral(moduleNameExpr) && moduleNameExpr.text) cb(node, moduleNameExpr);
            }
        }
    }
    function getNodeAtPosition(sourceFile, position, includeJSDoc) {
        const isJavaScriptFile = isInJSFile(sourceFile);
        let current = sourceFile;
        const getContainingChild = (child)=>{
            if (child.pos <= position && (position < child.end || position === child.end && child.kind === 1 /* EndOfFileToken */ )) return child;
        };
        while(true){
            const child = isJavaScriptFile && includeJSDoc && hasJSDocNodes(current) && forEach(current.jsDoc, getContainingChild) || forEachChild(current, getContainingChild);
            if (!child || isMetaProperty(child)) return current;
            current = child;
        }
    }
    function isNewScopeNode(node) {
        return isFunctionLike(node) || isJSDocSignature(node) || isMappedTypeNode(node);
    }
    function getLibNameFromLibReference(libReference) {
        return toFileNameLowerCase(libReference.fileName);
    }
    function getLibFileNameFromLibReference(libReference) {
        const libName = getLibNameFromLibReference(libReference);
        return libMap.get(libName);
    }
    function forEachResolvedProjectReference(resolvedProjectReferences, cb) {
        return forEachProjectReference(/*projectReferences*/ void 0, resolvedProjectReferences, (resolvedRef)=>resolvedRef && cb(resolvedRef));
    }
    function forEachProjectReference(projectReferences, resolvedProjectReferences, cbResolvedRef, cbRef) {
        let seenResolvedRefs;
        return worker(projectReferences, resolvedProjectReferences, /*parent*/ void 0);
        function worker(projectReferences2, resolvedProjectReferences2, parent2) {
            if (cbRef) {
                const result = cbRef(projectReferences2, parent2);
                if (result) return result;
            }
            let skipChildren;
            return forEach(resolvedProjectReferences2, (resolvedRef, index)=>{
                if (resolvedRef && (seenResolvedRefs == null ? void 0 : seenResolvedRefs.has(resolvedRef.sourceFile.path))) {
                    (skipChildren !== null && skipChildren !== void 0 ? skipChildren : skipChildren = /* @__PURE__ */ new Set()).add(resolvedRef);
                    return void 0;
                }
                const result = cbResolvedRef(resolvedRef, parent2, index);
                if (result || !resolvedRef) return result;
                (seenResolvedRefs || (seenResolvedRefs = /* @__PURE__ */ new Set())).add(resolvedRef.sourceFile.path);
            }) || forEach(resolvedProjectReferences2, (resolvedRef)=>resolvedRef && !(skipChildren == null ? void 0 : skipChildren.has(resolvedRef)) ? worker(resolvedRef.commandLine.projectReferences, resolvedRef.references, resolvedRef) : void 0);
        }
    }
    function getOptionsSyntaxByArrayElementValue(optionsObject, name, value1) {
        return optionsObject && getPropertyArrayElementValue(optionsObject, name, value1);
    }
    function getPropertyArrayElementValue(objectLiteral, propKey, elementValue) {
        return forEachPropertyAssignment(objectLiteral, propKey, (property)=>isArrayLiteralExpression(property.initializer) ? find(property.initializer.elements, (element)=>isStringLiteral(element) && element.text === elementValue) : void 0);
    }
    function getOptionsSyntaxByValue(optionsObject, name, value1) {
        return forEachOptionsSyntaxByName(optionsObject, name, (property)=>isStringLiteral(property.initializer) && property.initializer.text === value1 ? property.initializer : void 0);
    }
    function forEachOptionsSyntaxByName(optionsObject, name, callback) {
        return forEachPropertyAssignment(optionsObject, name, callback);
    }
    function getSynthesizedDeepClone(node, includeTrivia = true) {
        const clone2 = node && getSynthesizedDeepCloneWorker(node);
        if (clone2 && !includeTrivia) suppressLeadingAndTrailingTrivia(clone2);
        return setParentRecursive(clone2, /*incremental*/ false);
    }
    function getSynthesizedDeepCloneWithReplacements(node, includeTrivia, replaceNode) {
        let clone2 = replaceNode(node);
        if (clone2) setOriginalNode(clone2, node);
        else clone2 = getSynthesizedDeepCloneWorker(node, replaceNode);
        if (clone2 && !includeTrivia) suppressLeadingAndTrailingTrivia(clone2);
        return clone2;
    }
    function getSynthesizedDeepCloneWorker(node, replaceNode) {
        const nodeClone = replaceNode ? (n)=>getSynthesizedDeepCloneWithReplacements(n, /*includeTrivia*/ true, replaceNode) : getSynthesizedDeepClone;
        const nodesClone = replaceNode ? (ns)=>ns && getSynthesizedDeepClonesWithReplacements(ns, /*includeTrivia*/ true, replaceNode) : (ns)=>ns && getSynthesizedDeepClones(ns);
        const visited = visitEachChild(node, nodeClone, /*context*/ void 0, nodesClone, nodeClone);
        if (visited === node) {
            const clone2 = isStringLiteral(node) ? setOriginalNode(factory.createStringLiteralFromNode(node), node) : isNumericLiteral(node) ? setOriginalNode(factory.createNumericLiteral(node.text, node.numericLiteralFlags), node) : factory.cloneNode(node);
            return setTextRange(clone2, node);
        }
        visited.parent = void 0;
        return visited;
    }
    function getSynthesizedDeepClones(nodes, includeTrivia = true) {
        if (nodes) {
            const cloned = factory.createNodeArray(nodes.map((n)=>getSynthesizedDeepClone(n, includeTrivia)), nodes.hasTrailingComma);
            setTextRange(cloned, nodes);
            return cloned;
        }
        return nodes;
    }
    function getSynthesizedDeepClonesWithReplacements(nodes, includeTrivia, replaceNode) {
        return factory.createNodeArray(nodes.map((n)=>getSynthesizedDeepCloneWithReplacements(n, includeTrivia, replaceNode)), nodes.hasTrailingComma);
    }
    function suppressLeadingAndTrailingTrivia(node) {
        suppressLeadingTrivia(node);
        suppressTrailingTrivia(node);
    }
    function suppressLeadingTrivia(node) {
        addEmitFlagsRecursively(node, 1024 /* NoLeadingComments */ , getFirstChild);
    }
    function suppressTrailingTrivia(node) {
        addEmitFlagsRecursively(node, 2048 /* NoTrailingComments */ , getLastChild);
    }
    function addEmitFlagsRecursively(node, flag, getChild) {
        addEmitFlags(node, flag);
        const child = getChild(node);
        if (child) addEmitFlagsRecursively(child, flag, getChild);
    }
    function getFirstChild(node) {
        return forEachChild(node, (child)=>child);
    }
    // src/compiler/factory/baseNodeFactory.ts
    function createBaseNodeFactory() {
        let NodeConstructor2;
        let TokenConstructor2;
        let IdentifierConstructor2;
        let PrivateIdentifierConstructor2;
        let SourceFileConstructor2;
        return {
            createBaseSourceFileNode,
            createBaseIdentifierNode,
            createBasePrivateIdentifierNode,
            createBaseTokenNode,
            createBaseNode
        };
        function createBaseSourceFileNode(kind) {
            return new (SourceFileConstructor2 || (SourceFileConstructor2 = objectAllocator.getSourceFileConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBaseIdentifierNode(kind) {
            return new (IdentifierConstructor2 || (IdentifierConstructor2 = objectAllocator.getIdentifierConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBasePrivateIdentifierNode(kind) {
            return new (PrivateIdentifierConstructor2 || (PrivateIdentifierConstructor2 = objectAllocator.getPrivateIdentifierConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBaseTokenNode(kind) {
            return new (TokenConstructor2 || (TokenConstructor2 = objectAllocator.getTokenConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
        function createBaseNode(kind) {
            return new (NodeConstructor2 || (NodeConstructor2 = objectAllocator.getNodeConstructor()))(kind, /*pos*/ -1, /*end*/ -1);
        }
    }
    // src/compiler/factory/parenthesizerRules.ts
    function createParenthesizerRules(factory2) {
        let binaryLeftOperandParenthesizerCache;
        let binaryRightOperandParenthesizerCache;
        return {
            getParenthesizeLeftSideOfBinaryForOperator,
            getParenthesizeRightSideOfBinaryForOperator,
            parenthesizeLeftSideOfBinary,
            parenthesizeRightSideOfBinary,
            parenthesizeExpressionOfComputedPropertyName,
            parenthesizeConditionOfConditionalExpression,
            parenthesizeBranchOfConditionalExpression,
            parenthesizeExpressionOfExportDefault,
            parenthesizeExpressionOfNew,
            parenthesizeLeftSideOfAccess,
            parenthesizeOperandOfPostfixUnary,
            parenthesizeOperandOfPrefixUnary,
            parenthesizeExpressionsOfCommaDelimitedList,
            parenthesizeExpressionForDisallowedComma,
            parenthesizeExpressionOfExpressionStatement,
            parenthesizeConciseBodyOfArrowFunction,
            parenthesizeCheckTypeOfConditionalType,
            parenthesizeExtendsTypeOfConditionalType,
            parenthesizeConstituentTypesOfUnionType,
            parenthesizeConstituentTypeOfUnionType,
            parenthesizeConstituentTypesOfIntersectionType,
            parenthesizeConstituentTypeOfIntersectionType,
            parenthesizeOperandOfTypeOperator,
            parenthesizeOperandOfReadonlyTypeOperator,
            parenthesizeNonArrayTypeOfPostfixType,
            parenthesizeElementTypesOfTupleType,
            parenthesizeElementTypeOfTupleType,
            parenthesizeTypeOfOptionalType,
            parenthesizeTypeArguments,
            parenthesizeLeadingTypeArgument
        };
        function getParenthesizeLeftSideOfBinaryForOperator(operatorKind) {
            binaryLeftOperandParenthesizerCache || (binaryLeftOperandParenthesizerCache = /* @__PURE__ */ new Map());
            let parenthesizerRule = binaryLeftOperandParenthesizerCache.get(operatorKind);
            if (!parenthesizerRule) {
                parenthesizerRule = (node)=>parenthesizeLeftSideOfBinary(operatorKind, node);
                binaryLeftOperandParenthesizerCache.set(operatorKind, parenthesizerRule);
            }
            return parenthesizerRule;
        }
        function getParenthesizeRightSideOfBinaryForOperator(operatorKind) {
            binaryRightOperandParenthesizerCache || (binaryRightOperandParenthesizerCache = /* @__PURE__ */ new Map());
            let parenthesizerRule = binaryRightOperandParenthesizerCache.get(operatorKind);
            if (!parenthesizerRule) {
                parenthesizerRule = (node)=>parenthesizeRightSideOfBinary(operatorKind, /*leftSide*/ void 0, node);
                binaryRightOperandParenthesizerCache.set(operatorKind, parenthesizerRule);
            }
            return parenthesizerRule;
        }
        function binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
            const binaryOperatorPrecedence = getOperatorPrecedence(227 /* BinaryExpression */ , binaryOperator);
            const binaryOperatorAssociativity = getOperatorAssociativity(227 /* BinaryExpression */ , binaryOperator);
            const emittedOperand = skipPartiallyEmittedExpressions(operand);
            if (!isLeftSideOfBinary && operand.kind === 220 /* ArrowFunction */  && binaryOperatorPrecedence > 3 /* Assignment */ ) return true;
            const operandPrecedence = getExpressionPrecedence(emittedOperand);
            switch(compareValues(operandPrecedence, binaryOperatorPrecedence)){
                case -1 /* LessThan */ :
                    if (!isLeftSideOfBinary && binaryOperatorAssociativity === 1 /* Right */  && operand.kind === 230 /* YieldExpression */ ) return false;
                    return true;
                case 1 /* GreaterThan */ :
                    return false;
                case 0 /* EqualTo */ :
                    if (isLeftSideOfBinary) return binaryOperatorAssociativity === 1 /* Right */ ;
                    else {
                        if (isBinaryExpression(emittedOperand) && emittedOperand.operatorToken.kind === binaryOperator) {
                            if (operatorHasAssociativeProperty(binaryOperator)) return false;
                            if (binaryOperator === 40 /* PlusToken */ ) {
                                const leftKind = leftOperand ? getLiteralKindOfBinaryPlusOperand(leftOperand) : 0 /* Unknown */ ;
                                if (isLiteralKind(leftKind) && leftKind === getLiteralKindOfBinaryPlusOperand(emittedOperand)) return false;
                            }
                        }
                        const operandAssociativity = getExpressionAssociativity(emittedOperand);
                        return operandAssociativity === 0 /* Left */ ;
                    }
            }
        }
        function operatorHasAssociativeProperty(binaryOperator) {
            return binaryOperator === 42 /* AsteriskToken */  || binaryOperator === 52 /* BarToken */  || binaryOperator === 51 /* AmpersandToken */  || binaryOperator === 53 /* CaretToken */  || binaryOperator === 28 /* CommaToken */ ;
        }
        function getLiteralKindOfBinaryPlusOperand(node) {
            node = skipPartiallyEmittedExpressions(node);
            if (isLiteralKind(node.kind)) return node.kind;
            if (node.kind === 227 /* BinaryExpression */  && node.operatorToken.kind === 40 /* PlusToken */ ) {
                if (node.cachedLiteralKind !== void 0) return node.cachedLiteralKind;
                const leftKind = getLiteralKindOfBinaryPlusOperand(node.left);
                const literalKind = isLiteralKind(leftKind) && leftKind === getLiteralKindOfBinaryPlusOperand(node.right) ? leftKind : 0 /* Unknown */ ;
                node.cachedLiteralKind = literalKind;
                return literalKind;
            }
            return 0 /* Unknown */ ;
        }
        function parenthesizeBinaryOperand(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
            const skipped = skipPartiallyEmittedExpressions(operand);
            if (skipped.kind === 218 /* ParenthesizedExpression */ ) return operand;
            return binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand) ? factory2.createParenthesizedExpression(operand) : operand;
        }
        function parenthesizeLeftSideOfBinary(binaryOperator, leftSide) {
            return parenthesizeBinaryOperand(binaryOperator, leftSide, /*isLeftSideOfBinary*/ true);
        }
        function parenthesizeRightSideOfBinary(binaryOperator, leftSide, rightSide) {
            return parenthesizeBinaryOperand(binaryOperator, rightSide, /*isLeftSideOfBinary*/ false, leftSide);
        }
        function parenthesizeExpressionOfComputedPropertyName(expression) {
            return isCommaSequence(expression) ? factory2.createParenthesizedExpression(expression) : expression;
        }
        function parenthesizeConditionOfConditionalExpression(condition) {
            const conditionalPrecedence = getOperatorPrecedence(228 /* ConditionalExpression */ , 58 /* QuestionToken */ );
            const emittedCondition = skipPartiallyEmittedExpressions(condition);
            const conditionPrecedence = getExpressionPrecedence(emittedCondition);
            if (compareValues(conditionPrecedence, conditionalPrecedence) !== 1 /* GreaterThan */ ) return factory2.createParenthesizedExpression(condition);
            return condition;
        }
        function parenthesizeBranchOfConditionalExpression(branch) {
            const emittedExpression = skipPartiallyEmittedExpressions(branch);
            return isCommaSequence(emittedExpression) ? factory2.createParenthesizedExpression(branch) : branch;
        }
        function parenthesizeExpressionOfExportDefault(expression) {
            const check = skipPartiallyEmittedExpressions(expression);
            let needsParens = isCommaSequence(check);
            if (!needsParens) switch(getLeftmostExpression(check, /*stopAtCallExpressions*/ false).kind){
                case 232 /* ClassExpression */ :
                case 219 /* FunctionExpression */ :
                    needsParens = true;
            }
            return needsParens ? factory2.createParenthesizedExpression(expression) : expression;
        }
        function parenthesizeExpressionOfNew(expression) {
            const leftmostExpr = getLeftmostExpression(expression, /*stopAtCallExpressions*/ true);
            switch(leftmostExpr.kind){
                case 214 /* CallExpression */ :
                    return factory2.createParenthesizedExpression(expression);
                case 215 /* NewExpression */ :
                    return !leftmostExpr.arguments ? factory2.createParenthesizedExpression(expression) : expression;
            }
            return parenthesizeLeftSideOfAccess(expression);
        }
        function parenthesizeLeftSideOfAccess(expression, optionalChain) {
            const emittedExpression = skipPartiallyEmittedExpressions(expression);
            if (isLeftHandSideExpression(emittedExpression) && (emittedExpression.kind !== 215 /* NewExpression */  || emittedExpression.arguments) && (optionalChain || !isOptionalChain(emittedExpression))) return expression;
            return setTextRange(factory2.createParenthesizedExpression(expression), expression);
        }
        function parenthesizeOperandOfPostfixUnary(operand) {
            return isLeftHandSideExpression(operand) ? operand : setTextRange(factory2.createParenthesizedExpression(operand), operand);
        }
        function parenthesizeOperandOfPrefixUnary(operand) {
            return isUnaryExpression(operand) ? operand : setTextRange(factory2.createParenthesizedExpression(operand), operand);
        }
        function parenthesizeExpressionsOfCommaDelimitedList(elements) {
            const result = sameMap(elements, parenthesizeExpressionForDisallowedComma);
            return setTextRange(factory2.createNodeArray(result, elements.hasTrailingComma), elements);
        }
        function parenthesizeExpressionForDisallowedComma(expression) {
            const emittedExpression = skipPartiallyEmittedExpressions(expression);
            const expressionPrecedence = getExpressionPrecedence(emittedExpression);
            const commaPrecedence = getOperatorPrecedence(227 /* BinaryExpression */ , 28 /* CommaToken */ );
            return expressionPrecedence > commaPrecedence ? expression : setTextRange(factory2.createParenthesizedExpression(expression), expression);
        }
        function parenthesizeExpressionOfExpressionStatement(expression) {
            const emittedExpression = skipPartiallyEmittedExpressions(expression);
            if (isCallExpression(emittedExpression)) {
                const callee = emittedExpression.expression;
                const kind = skipPartiallyEmittedExpressions(callee).kind;
                if (kind === 219 /* FunctionExpression */  || kind === 220 /* ArrowFunction */ ) {
                    const updated = factory2.updateCallExpression(emittedExpression, setTextRange(factory2.createParenthesizedExpression(callee), callee), emittedExpression.typeArguments, emittedExpression.arguments);
                    return factory2.restoreOuterExpressions(expression, updated, 8 /* PartiallyEmittedExpressions */ );
                }
            }
            const leftmostExpressionKind = getLeftmostExpression(emittedExpression, /*stopAtCallExpressions*/ false).kind;
            if (leftmostExpressionKind === 211 /* ObjectLiteralExpression */  || leftmostExpressionKind === 219 /* FunctionExpression */ ) return setTextRange(factory2.createParenthesizedExpression(expression), expression);
            return expression;
        }
        function parenthesizeConciseBodyOfArrowFunction(body) {
            if (!isBlock(body) && (isCommaSequence(body) || getLeftmostExpression(body, /*stopAtCallExpressions*/ false).kind === 211 /* ObjectLiteralExpression */ )) return setTextRange(factory2.createParenthesizedExpression(body), body);
            return body;
        }
        function parenthesizeCheckTypeOfConditionalType(checkType) {
            switch(checkType.kind){
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                case 195 /* ConditionalType */ :
                    return factory2.createParenthesizedType(checkType);
            }
            return checkType;
        }
        function parenthesizeExtendsTypeOfConditionalType(extendsType) {
            switch(extendsType.kind){
                case 195 /* ConditionalType */ :
                    return factory2.createParenthesizedType(extendsType);
            }
            return extendsType;
        }
        function parenthesizeConstituentTypeOfUnionType(type) {
            switch(type.kind){
                case 193 /* UnionType */ :
                // Not strictly necessary, but a union containing a union should have been flattened
                case 194 /* IntersectionType */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeCheckTypeOfConditionalType(type);
        }
        function parenthesizeConstituentTypesOfUnionType(members) {
            return factory2.createNodeArray(sameMap(members, parenthesizeConstituentTypeOfUnionType));
        }
        function parenthesizeConstituentTypeOfIntersectionType(type) {
            switch(type.kind){
                case 193 /* UnionType */ :
                case 194 /* IntersectionType */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeConstituentTypeOfUnionType(type);
        }
        function parenthesizeConstituentTypesOfIntersectionType(members) {
            return factory2.createNodeArray(sameMap(members, parenthesizeConstituentTypeOfIntersectionType));
        }
        function parenthesizeOperandOfTypeOperator(type) {
            switch(type.kind){
                case 194 /* IntersectionType */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeConstituentTypeOfIntersectionType(type);
        }
        function parenthesizeOperandOfReadonlyTypeOperator(type) {
            switch(type.kind){
                case 199 /* TypeOperator */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeOperandOfTypeOperator(type);
        }
        function parenthesizeNonArrayTypeOfPostfixType(type) {
            switch(type.kind){
                case 196 /* InferType */ :
                case 199 /* TypeOperator */ :
                case 187 /* TypeQuery */ :
                    return factory2.createParenthesizedType(type);
            }
            return parenthesizeOperandOfTypeOperator(type);
        }
        function parenthesizeElementTypesOfTupleType(types) {
            return factory2.createNodeArray(sameMap(types, parenthesizeElementTypeOfTupleType));
        }
        function parenthesizeElementTypeOfTupleType(type) {
            if (hasJSDocPostfixQuestion(type)) return factory2.createParenthesizedType(type);
            return type;
        }
        function hasJSDocPostfixQuestion(type) {
            if (isJSDocNullableType(type)) return type.postfix;
            if (isNamedTupleMember(type)) return hasJSDocPostfixQuestion(type.type);
            if (isFunctionTypeNode(type) || isConstructorTypeNode(type) || isTypeOperatorNode(type)) return hasJSDocPostfixQuestion(type.type);
            if (isConditionalTypeNode(type)) return hasJSDocPostfixQuestion(type.falseType);
            if (isUnionTypeNode(type)) return hasJSDocPostfixQuestion(last(type.types));
            if (isIntersectionTypeNode(type)) return hasJSDocPostfixQuestion(last(type.types));
            if (isInferTypeNode(type)) return !!type.typeParameter.constraint && hasJSDocPostfixQuestion(type.typeParameter.constraint);
            return false;
        }
        function parenthesizeTypeOfOptionalType(type) {
            if (hasJSDocPostfixQuestion(type)) return factory2.createParenthesizedType(type);
            return parenthesizeNonArrayTypeOfPostfixType(type);
        }
        function parenthesizeLeadingTypeArgument(node) {
            return isFunctionOrConstructorTypeNode(node) && node.typeParameters ? factory2.createParenthesizedType(node) : node;
        }
        function parenthesizeOrdinalTypeArgument(node, i) {
            return i === 0 ? parenthesizeLeadingTypeArgument(node) : node;
        }
        function parenthesizeTypeArguments(typeArguments) {
            if (some(typeArguments)) return factory2.createNodeArray(sameMap(typeArguments, parenthesizeOrdinalTypeArgument));
        }
    }
    var nullParenthesizerRules = {
        getParenthesizeLeftSideOfBinaryForOperator: (_)=>identity,
        getParenthesizeRightSideOfBinaryForOperator: (_)=>identity,
        parenthesizeLeftSideOfBinary: (_binaryOperator, leftSide)=>leftSide,
        parenthesizeRightSideOfBinary: (_binaryOperator, _leftSide, rightSide)=>rightSide,
        parenthesizeExpressionOfComputedPropertyName: identity,
        parenthesizeConditionOfConditionalExpression: identity,
        parenthesizeBranchOfConditionalExpression: identity,
        parenthesizeExpressionOfExportDefault: identity,
        parenthesizeExpressionOfNew: (expression)=>cast(expression, isLeftHandSideExpression),
        parenthesizeLeftSideOfAccess: (expression)=>cast(expression, isLeftHandSideExpression),
        parenthesizeOperandOfPostfixUnary: (operand)=>cast(operand, isLeftHandSideExpression),
        parenthesizeOperandOfPrefixUnary: (operand)=>cast(operand, isUnaryExpression),
        parenthesizeExpressionsOfCommaDelimitedList: (nodes)=>cast(nodes, isNodeArray),
        parenthesizeExpressionForDisallowedComma: identity,
        parenthesizeExpressionOfExpressionStatement: identity,
        parenthesizeConciseBodyOfArrowFunction: identity,
        parenthesizeCheckTypeOfConditionalType: identity,
        parenthesizeExtendsTypeOfConditionalType: identity,
        parenthesizeConstituentTypesOfUnionType: (nodes)=>cast(nodes, isNodeArray),
        parenthesizeConstituentTypeOfUnionType: identity,
        parenthesizeConstituentTypesOfIntersectionType: (nodes)=>cast(nodes, isNodeArray),
        parenthesizeConstituentTypeOfIntersectionType: identity,
        parenthesizeOperandOfTypeOperator: identity,
        parenthesizeOperandOfReadonlyTypeOperator: identity,
        parenthesizeNonArrayTypeOfPostfixType: identity,
        parenthesizeElementTypesOfTupleType: (nodes)=>cast(nodes, isNodeArray),
        parenthesizeElementTypeOfTupleType: identity,
        parenthesizeTypeOfOptionalType: identity,
        parenthesizeTypeArguments: (nodes)=>nodes && cast(nodes, isNodeArray),
        parenthesizeLeadingTypeArgument: identity
    };
    // src/compiler/factory/nodeConverters.ts
    function createNodeConverters(factory2) {
        return {
            convertToFunctionBlock,
            convertToFunctionExpression,
            convertToClassExpression,
            convertToArrayAssignmentElement,
            convertToObjectAssignmentElement,
            convertToAssignmentPattern,
            convertToObjectAssignmentPattern,
            convertToArrayAssignmentPattern,
            convertToAssignmentElementTarget
        };
        function convertToFunctionBlock(node, multiLine) {
            if (isBlock(node)) return node;
            const returnStatement = factory2.createReturnStatement(node);
            setTextRange(returnStatement, node);
            const body = factory2.createBlock([
                returnStatement
            ], multiLine);
            setTextRange(body, node);
            return body;
        }
        function convertToFunctionExpression(node) {
            var _a;
            if (!node.body) return Debug.fail(`Cannot convert a FunctionDeclaration without a body`);
            const updated = factory2.createFunctionExpression((_a = getModifiers(node)) == null ? void 0 : _a.filter((modifier)=>!isExportModifier(modifier) && !isDefaultModifier(modifier)), node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body);
            setOriginalNode(updated, node);
            setTextRange(updated, node);
            if (getStartsOnNewLine(node)) setStartsOnNewLine(updated, /*newLine*/ true);
            return updated;
        }
        function convertToClassExpression(node) {
            var _a;
            const updated = factory2.createClassExpression((_a = node.modifiers) == null ? void 0 : _a.filter((modifier)=>!isExportModifier(modifier) && !isDefaultModifier(modifier)), node.name, node.typeParameters, node.heritageClauses, node.members);
            setOriginalNode(updated, node);
            setTextRange(updated, node);
            if (getStartsOnNewLine(node)) setStartsOnNewLine(updated, /*newLine*/ true);
            return updated;
        }
        function convertToArrayAssignmentElement(element) {
            if (isBindingElement(element)) {
                if (element.dotDotDotToken) {
                    Debug.assertNode(element.name, isIdentifier);
                    return setOriginalNode(setTextRange(factory2.createSpreadElement(element.name), element), element);
                }
                const expression = convertToAssignmentElementTarget(element.name);
                return element.initializer ? setOriginalNode(setTextRange(factory2.createAssignment(expression, element.initializer), element), element) : expression;
            }
            return cast(element, isExpression);
        }
        function convertToObjectAssignmentElement(element) {
            if (isBindingElement(element)) {
                if (element.dotDotDotToken) {
                    Debug.assertNode(element.name, isIdentifier);
                    return setOriginalNode(setTextRange(factory2.createSpreadAssignment(element.name), element), element);
                }
                if (element.propertyName) {
                    const expression = convertToAssignmentElementTarget(element.name);
                    return setOriginalNode(setTextRange(factory2.createPropertyAssignment(element.propertyName, element.initializer ? factory2.createAssignment(expression, element.initializer) : expression), element), element);
                }
                Debug.assertNode(element.name, isIdentifier);
                return setOriginalNode(setTextRange(factory2.createShorthandPropertyAssignment(element.name, element.initializer), element), element);
            }
            return cast(element, isObjectLiteralElementLike);
        }
        function convertToAssignmentPattern(node) {
            switch(node.kind){
                case 208 /* ArrayBindingPattern */ :
                case 210 /* ArrayLiteralExpression */ :
                    return convertToArrayAssignmentPattern(node);
                case 207 /* ObjectBindingPattern */ :
                case 211 /* ObjectLiteralExpression */ :
                    return convertToObjectAssignmentPattern(node);
            }
        }
        function convertToObjectAssignmentPattern(node) {
            if (isObjectBindingPattern(node)) return setOriginalNode(setTextRange(factory2.createObjectLiteralExpression(map(node.elements, convertToObjectAssignmentElement)), node), node);
            return cast(node, isObjectLiteralExpression);
        }
        function convertToArrayAssignmentPattern(node) {
            if (isArrayBindingPattern(node)) return setOriginalNode(setTextRange(factory2.createArrayLiteralExpression(map(node.elements, convertToArrayAssignmentElement)), node), node);
            return cast(node, isArrayLiteralExpression);
        }
        function convertToAssignmentElementTarget(node) {
            if (isBindingPattern(node)) return convertToAssignmentPattern(node);
            return cast(node, isExpression);
        }
    }
    var nullNodeConverters = {
        convertToFunctionBlock: notImplemented,
        convertToFunctionExpression: notImplemented,
        convertToClassExpression: notImplemented,
        convertToArrayAssignmentElement: notImplemented,
        convertToObjectAssignmentElement: notImplemented,
        convertToAssignmentPattern: notImplemented,
        convertToObjectAssignmentPattern: notImplemented,
        convertToArrayAssignmentPattern: notImplemented,
        convertToAssignmentElementTarget: notImplemented
    };
    // src/compiler/factory/nodeFactory.ts
    var nextAutoGenerateId = 0;
    var NodeFactoryFlags = /* @__PURE__ */ ((NodeFactoryFlags2)=>{
        NodeFactoryFlags2[NodeFactoryFlags2["None"] = 0] = "None";
        NodeFactoryFlags2[NodeFactoryFlags2["NoParenthesizerRules"] = 1] = "NoParenthesizerRules";
        NodeFactoryFlags2[NodeFactoryFlags2["NoNodeConverters"] = 2] = "NoNodeConverters";
        NodeFactoryFlags2[NodeFactoryFlags2["NoIndentationOnFreshPropertyAccess"] = 4] = "NoIndentationOnFreshPropertyAccess";
        NodeFactoryFlags2[NodeFactoryFlags2["NoOriginalNode"] = 8] = "NoOriginalNode";
        return NodeFactoryFlags2;
    })(NodeFactoryFlags || {});
    var nodeFactoryPatchers = [];
    function addNodeFactoryPatcher(fn) {
        nodeFactoryPatchers.push(fn);
    }
    function createNodeFactory(flags, baseFactory2) {
        const setOriginal = flags & 8 /* NoOriginalNode */  ? identity : setOriginalNode;
        const parenthesizerRules = memoize(()=>flags & 1 /* NoParenthesizerRules */  ? nullParenthesizerRules : createParenthesizerRules(factory2));
        const converters = memoize(()=>flags & 2 /* NoNodeConverters */  ? nullNodeConverters : createNodeConverters(factory2));
        const getBinaryCreateFunction = memoizeOne((operator)=>(left, right)=>createBinaryExpression(left, operator, right));
        const getPrefixUnaryCreateFunction = memoizeOne((operator)=>(operand)=>createPrefixUnaryExpression(operator, operand));
        const getPostfixUnaryCreateFunction = memoizeOne((operator)=>(operand)=>createPostfixUnaryExpression(operand, operator));
        const getJSDocPrimaryTypeCreateFunction = memoizeOne((kind)=>()=>createJSDocPrimaryTypeWorker(kind));
        const getJSDocUnaryTypeCreateFunction = memoizeOne((kind)=>(type)=>createJSDocUnaryTypeWorker(kind, type));
        const getJSDocUnaryTypeUpdateFunction = memoizeOne((kind)=>(node, type)=>updateJSDocUnaryTypeWorker(kind, node, type));
        const getJSDocPrePostfixUnaryTypeCreateFunction = memoizeOne((kind)=>(type, postfix)=>createJSDocPrePostfixUnaryTypeWorker(kind, type, postfix));
        const getJSDocPrePostfixUnaryTypeUpdateFunction = memoizeOne((kind)=>(node, type)=>updateJSDocPrePostfixUnaryTypeWorker(kind, node, type));
        const getJSDocSimpleTagCreateFunction = memoizeOne((kind)=>(tagName, comment)=>createJSDocSimpleTagWorker(kind, tagName, comment));
        const getJSDocSimpleTagUpdateFunction = memoizeOne((kind)=>(node, tagName, comment)=>updateJSDocSimpleTagWorker(kind, node, tagName, comment));
        const getJSDocTypeLikeTagCreateFunction = memoizeOne((kind)=>(tagName, typeExpression, comment)=>createJSDocTypeLikeTagWorker(kind, tagName, typeExpression, comment));
        const getJSDocTypeLikeTagUpdateFunction = memoizeOne((kind)=>(node, tagName, typeExpression, comment)=>updateJSDocTypeLikeTagWorker(kind, node, tagName, typeExpression, comment));
        const factory2 = {
            get parenthesizer () {
                return parenthesizerRules();
            },
            get converters () {
                return converters();
            },
            baseFactory: baseFactory2,
            flags,
            createNodeArray,
            createNumericLiteral,
            createBigIntLiteral,
            createStringLiteral,
            createStringLiteralFromNode,
            createRegularExpressionLiteral,
            createLiteralLikeNode,
            createIdentifier,
            createTempVariable,
            createLoopVariable,
            createUniqueName,
            getGeneratedNameForNode,
            createPrivateIdentifier,
            createUniquePrivateName,
            getGeneratedPrivateNameForNode,
            createToken,
            createSuper,
            createThis,
            createNull,
            createTrue,
            createFalse,
            createModifier,
            createModifiersFromModifierFlags,
            createQualifiedName,
            updateQualifiedName,
            createComputedPropertyName,
            updateComputedPropertyName,
            createTypeParameterDeclaration,
            updateTypeParameterDeclaration,
            createParameterDeclaration,
            updateParameterDeclaration,
            createDecorator,
            updateDecorator,
            createPropertySignature,
            updatePropertySignature,
            createPropertyDeclaration,
            updatePropertyDeclaration: updatePropertyDeclaration2,
            createMethodSignature,
            updateMethodSignature,
            createMethodDeclaration,
            updateMethodDeclaration,
            createConstructorDeclaration,
            updateConstructorDeclaration,
            createGetAccessorDeclaration,
            updateGetAccessorDeclaration,
            createSetAccessorDeclaration,
            updateSetAccessorDeclaration,
            createCallSignature,
            updateCallSignature,
            createConstructSignature,
            updateConstructSignature,
            createIndexSignature,
            updateIndexSignature,
            createClassStaticBlockDeclaration,
            updateClassStaticBlockDeclaration,
            createTemplateLiteralTypeSpan,
            updateTemplateLiteralTypeSpan,
            createKeywordTypeNode,
            createTypePredicateNode,
            updateTypePredicateNode,
            createTypeReferenceNode,
            updateTypeReferenceNode,
            createFunctionTypeNode,
            updateFunctionTypeNode,
            createConstructorTypeNode,
            updateConstructorTypeNode,
            createTypeQueryNode,
            updateTypeQueryNode,
            createTypeLiteralNode,
            updateTypeLiteralNode,
            createArrayTypeNode,
            updateArrayTypeNode,
            createTupleTypeNode,
            updateTupleTypeNode,
            createNamedTupleMember,
            updateNamedTupleMember,
            createOptionalTypeNode,
            updateOptionalTypeNode,
            createRestTypeNode,
            updateRestTypeNode,
            createUnionTypeNode,
            updateUnionTypeNode,
            createIntersectionTypeNode,
            updateIntersectionTypeNode,
            createConditionalTypeNode,
            updateConditionalTypeNode,
            createInferTypeNode,
            updateInferTypeNode,
            createImportTypeNode,
            updateImportTypeNode,
            createParenthesizedType,
            updateParenthesizedType,
            createThisTypeNode,
            createTypeOperatorNode,
            updateTypeOperatorNode,
            createIndexedAccessTypeNode,
            updateIndexedAccessTypeNode,
            createMappedTypeNode,
            updateMappedTypeNode,
            createLiteralTypeNode,
            updateLiteralTypeNode,
            createTemplateLiteralType,
            updateTemplateLiteralType,
            createObjectBindingPattern,
            updateObjectBindingPattern,
            createArrayBindingPattern,
            updateArrayBindingPattern,
            createBindingElement,
            updateBindingElement,
            createArrayLiteralExpression,
            updateArrayLiteralExpression,
            createObjectLiteralExpression,
            updateObjectLiteralExpression,
            createPropertyAccessExpression: flags & 4 /* NoIndentationOnFreshPropertyAccess */  ? (expression, name)=>setEmitFlags(createPropertyAccessExpression(expression, name), 262144 /* NoIndentation */ ) : createPropertyAccessExpression,
            updatePropertyAccessExpression,
            createPropertyAccessChain: flags & 4 /* NoIndentationOnFreshPropertyAccess */  ? (expression, questionDotToken, name)=>setEmitFlags(createPropertyAccessChain(expression, questionDotToken, name), 262144 /* NoIndentation */ ) : createPropertyAccessChain,
            updatePropertyAccessChain,
            createElementAccessExpression,
            updateElementAccessExpression,
            createElementAccessChain,
            updateElementAccessChain,
            createCallExpression,
            updateCallExpression,
            createCallChain,
            updateCallChain,
            createNewExpression,
            updateNewExpression,
            createTaggedTemplateExpression,
            updateTaggedTemplateExpression,
            createTypeAssertion,
            updateTypeAssertion,
            createParenthesizedExpression,
            updateParenthesizedExpression,
            createFunctionExpression,
            updateFunctionExpression,
            createArrowFunction,
            updateArrowFunction,
            createDeleteExpression,
            updateDeleteExpression,
            createTypeOfExpression,
            updateTypeOfExpression,
            createVoidExpression,
            updateVoidExpression,
            createAwaitExpression,
            updateAwaitExpression,
            createPrefixUnaryExpression,
            updatePrefixUnaryExpression,
            createPostfixUnaryExpression,
            updatePostfixUnaryExpression,
            createBinaryExpression,
            updateBinaryExpression,
            createConditionalExpression,
            updateConditionalExpression,
            createTemplateExpression,
            updateTemplateExpression,
            createTemplateHead,
            createTemplateMiddle,
            createTemplateTail,
            createNoSubstitutionTemplateLiteral,
            createTemplateLiteralLikeNode,
            createYieldExpression,
            updateYieldExpression,
            createSpreadElement,
            updateSpreadElement,
            createClassExpression,
            updateClassExpression,
            createOmittedExpression,
            createExpressionWithTypeArguments,
            updateExpressionWithTypeArguments,
            createAsExpression,
            updateAsExpression,
            createNonNullExpression,
            updateNonNullExpression,
            createSatisfiesExpression,
            updateSatisfiesExpression,
            createNonNullChain,
            updateNonNullChain,
            createMetaProperty,
            updateMetaProperty,
            createTemplateSpan,
            updateTemplateSpan,
            createSemicolonClassElement,
            createBlock,
            updateBlock,
            createVariableStatement,
            updateVariableStatement,
            createEmptyStatement,
            createExpressionStatement,
            updateExpressionStatement,
            createIfStatement,
            updateIfStatement,
            createDoStatement,
            updateDoStatement,
            createWhileStatement,
            updateWhileStatement,
            createForStatement,
            updateForStatement,
            createForInStatement,
            updateForInStatement,
            createForOfStatement,
            updateForOfStatement,
            createContinueStatement,
            updateContinueStatement,
            createBreakStatement,
            updateBreakStatement,
            createReturnStatement,
            updateReturnStatement,
            createWithStatement,
            updateWithStatement,
            createSwitchStatement,
            updateSwitchStatement,
            createLabeledStatement,
            updateLabeledStatement,
            createThrowStatement,
            updateThrowStatement,
            createTryStatement,
            updateTryStatement,
            createDebuggerStatement,
            createVariableDeclaration,
            updateVariableDeclaration,
            createVariableDeclarationList,
            updateVariableDeclarationList,
            createFunctionDeclaration,
            updateFunctionDeclaration,
            createClassDeclaration,
            updateClassDeclaration,
            createInterfaceDeclaration,
            updateInterfaceDeclaration,
            createTypeAliasDeclaration,
            updateTypeAliasDeclaration,
            createEnumDeclaration,
            updateEnumDeclaration,
            createModuleDeclaration,
            updateModuleDeclaration,
            createModuleBlock,
            updateModuleBlock,
            createCaseBlock,
            updateCaseBlock,
            createNamespaceExportDeclaration,
            updateNamespaceExportDeclaration,
            createImportEqualsDeclaration,
            updateImportEqualsDeclaration,
            createImportDeclaration,
            updateImportDeclaration,
            createImportClause: createImportClause2,
            updateImportClause,
            createAssertClause,
            updateAssertClause,
            createAssertEntry,
            updateAssertEntry,
            createImportTypeAssertionContainer,
            updateImportTypeAssertionContainer,
            createImportAttributes,
            updateImportAttributes,
            createImportAttribute,
            updateImportAttribute,
            createNamespaceImport,
            updateNamespaceImport,
            createNamespaceExport,
            updateNamespaceExport,
            createNamedImports,
            updateNamedImports,
            createImportSpecifier,
            updateImportSpecifier,
            createExportAssignment: createExportAssignment2,
            updateExportAssignment,
            createExportDeclaration,
            updateExportDeclaration,
            createNamedExports,
            updateNamedExports,
            createExportSpecifier,
            updateExportSpecifier,
            createMissingDeclaration,
            createExternalModuleReference,
            updateExternalModuleReference,
            // lazily load factory members for JSDoc types with similar structure
            get createJSDocAllType () {
                return getJSDocPrimaryTypeCreateFunction(313 /* JSDocAllType */ );
            },
            get createJSDocUnknownType () {
                return getJSDocPrimaryTypeCreateFunction(314 /* JSDocUnknownType */ );
            },
            get createJSDocNonNullableType () {
                return getJSDocPrePostfixUnaryTypeCreateFunction(316 /* JSDocNonNullableType */ );
            },
            get updateJSDocNonNullableType () {
                return getJSDocPrePostfixUnaryTypeUpdateFunction(316 /* JSDocNonNullableType */ );
            },
            get createJSDocNullableType () {
                return getJSDocPrePostfixUnaryTypeCreateFunction(315 /* JSDocNullableType */ );
            },
            get updateJSDocNullableType () {
                return getJSDocPrePostfixUnaryTypeUpdateFunction(315 /* JSDocNullableType */ );
            },
            get createJSDocOptionalType () {
                return getJSDocUnaryTypeCreateFunction(317 /* JSDocOptionalType */ );
            },
            get updateJSDocOptionalType () {
                return getJSDocUnaryTypeUpdateFunction(317 /* JSDocOptionalType */ );
            },
            get createJSDocVariadicType () {
                return getJSDocUnaryTypeCreateFunction(319 /* JSDocVariadicType */ );
            },
            get updateJSDocVariadicType () {
                return getJSDocUnaryTypeUpdateFunction(319 /* JSDocVariadicType */ );
            },
            get createJSDocNamepathType () {
                return getJSDocUnaryTypeCreateFunction(320 /* JSDocNamepathType */ );
            },
            get updateJSDocNamepathType () {
                return getJSDocUnaryTypeUpdateFunction(320 /* JSDocNamepathType */ );
            },
            createJSDocFunctionType,
            updateJSDocFunctionType,
            createJSDocTypeLiteral,
            updateJSDocTypeLiteral,
            createJSDocTypeExpression,
            updateJSDocTypeExpression,
            createJSDocSignature,
            updateJSDocSignature,
            createJSDocTemplateTag,
            updateJSDocTemplateTag,
            createJSDocTypedefTag,
            updateJSDocTypedefTag,
            createJSDocParameterTag,
            updateJSDocParameterTag,
            createJSDocPropertyTag,
            updateJSDocPropertyTag,
            createJSDocCallbackTag,
            updateJSDocCallbackTag,
            createJSDocOverloadTag,
            updateJSDocOverloadTag,
            createJSDocAugmentsTag,
            updateJSDocAugmentsTag,
            createJSDocImplementsTag,
            updateJSDocImplementsTag,
            createJSDocSeeTag,
            updateJSDocSeeTag,
            createJSDocImportTag,
            updateJSDocImportTag,
            createJSDocNameReference,
            updateJSDocNameReference,
            createJSDocMemberName,
            updateJSDocMemberName,
            createJSDocLink,
            updateJSDocLink,
            createJSDocLinkCode,
            updateJSDocLinkCode,
            createJSDocLinkPlain,
            updateJSDocLinkPlain,
            // lazily load factory members for JSDoc tags with similar structure
            get createJSDocTypeTag () {
                return getJSDocTypeLikeTagCreateFunction(345 /* JSDocTypeTag */ );
            },
            get updateJSDocTypeTag () {
                return getJSDocTypeLikeTagUpdateFunction(345 /* JSDocTypeTag */ );
            },
            get createJSDocReturnTag () {
                return getJSDocTypeLikeTagCreateFunction(343 /* JSDocReturnTag */ );
            },
            get updateJSDocReturnTag () {
                return getJSDocTypeLikeTagUpdateFunction(343 /* JSDocReturnTag */ );
            },
            get createJSDocThisTag () {
                return getJSDocTypeLikeTagCreateFunction(344 /* JSDocThisTag */ );
            },
            get updateJSDocThisTag () {
                return getJSDocTypeLikeTagUpdateFunction(344 /* JSDocThisTag */ );
            },
            get createJSDocAuthorTag () {
                return getJSDocSimpleTagCreateFunction(331 /* JSDocAuthorTag */ );
            },
            get updateJSDocAuthorTag () {
                return getJSDocSimpleTagUpdateFunction(331 /* JSDocAuthorTag */ );
            },
            get createJSDocClassTag () {
                return getJSDocSimpleTagCreateFunction(333 /* JSDocClassTag */ );
            },
            get updateJSDocClassTag () {
                return getJSDocSimpleTagUpdateFunction(333 /* JSDocClassTag */ );
            },
            get createJSDocPublicTag () {
                return getJSDocSimpleTagCreateFunction(334 /* JSDocPublicTag */ );
            },
            get updateJSDocPublicTag () {
                return getJSDocSimpleTagUpdateFunction(334 /* JSDocPublicTag */ );
            },
            get createJSDocPrivateTag () {
                return getJSDocSimpleTagCreateFunction(335 /* JSDocPrivateTag */ );
            },
            get updateJSDocPrivateTag () {
                return getJSDocSimpleTagUpdateFunction(335 /* JSDocPrivateTag */ );
            },
            get createJSDocProtectedTag () {
                return getJSDocSimpleTagCreateFunction(336 /* JSDocProtectedTag */ );
            },
            get updateJSDocProtectedTag () {
                return getJSDocSimpleTagUpdateFunction(336 /* JSDocProtectedTag */ );
            },
            get createJSDocReadonlyTag () {
                return getJSDocSimpleTagCreateFunction(337 /* JSDocReadonlyTag */ );
            },
            get updateJSDocReadonlyTag () {
                return getJSDocSimpleTagUpdateFunction(337 /* JSDocReadonlyTag */ );
            },
            get createJSDocOverrideTag () {
                return getJSDocSimpleTagCreateFunction(338 /* JSDocOverrideTag */ );
            },
            get updateJSDocOverrideTag () {
                return getJSDocSimpleTagUpdateFunction(338 /* JSDocOverrideTag */ );
            },
            get createJSDocDeprecatedTag () {
                return getJSDocSimpleTagCreateFunction(332 /* JSDocDeprecatedTag */ );
            },
            get updateJSDocDeprecatedTag () {
                return getJSDocSimpleTagUpdateFunction(332 /* JSDocDeprecatedTag */ );
            },
            get createJSDocThrowsTag () {
                return getJSDocTypeLikeTagCreateFunction(350 /* JSDocThrowsTag */ );
            },
            get updateJSDocThrowsTag () {
                return getJSDocTypeLikeTagUpdateFunction(350 /* JSDocThrowsTag */ );
            },
            get createJSDocSatisfiesTag () {
                return getJSDocTypeLikeTagCreateFunction(351 /* JSDocSatisfiesTag */ );
            },
            get updateJSDocSatisfiesTag () {
                return getJSDocTypeLikeTagUpdateFunction(351 /* JSDocSatisfiesTag */ );
            },
            createJSDocEnumTag,
            updateJSDocEnumTag,
            createJSDocUnknownTag,
            updateJSDocUnknownTag,
            createJSDocText,
            updateJSDocText,
            createJSDocComment,
            updateJSDocComment,
            createJsxElement,
            updateJsxElement,
            createJsxSelfClosingElement,
            updateJsxSelfClosingElement,
            createJsxOpeningElement,
            updateJsxOpeningElement,
            createJsxClosingElement,
            updateJsxClosingElement,
            createJsxFragment,
            createJsxText,
            updateJsxText,
            createJsxOpeningFragment,
            createJsxJsxClosingFragment,
            updateJsxFragment,
            createJsxAttribute,
            updateJsxAttribute,
            createJsxAttributes,
            updateJsxAttributes,
            createJsxSpreadAttribute,
            updateJsxSpreadAttribute,
            createJsxExpression,
            updateJsxExpression,
            createJsxNamespacedName,
            updateJsxNamespacedName,
            createCaseClause,
            updateCaseClause,
            createDefaultClause,
            updateDefaultClause,
            createHeritageClause,
            updateHeritageClause,
            createCatchClause,
            updateCatchClause,
            createPropertyAssignment,
            updatePropertyAssignment,
            createShorthandPropertyAssignment,
            updateShorthandPropertyAssignment,
            createSpreadAssignment,
            updateSpreadAssignment,
            createEnumMember,
            updateEnumMember,
            createSourceFile: createSourceFile2,
            updateSourceFile: updateSourceFile2,
            createRedirectedSourceFile,
            createBundle,
            updateBundle,
            createSyntheticExpression,
            createSyntaxList: createSyntaxList3,
            createNotEmittedStatement,
            createNotEmittedTypeElement,
            createPartiallyEmittedExpression,
            updatePartiallyEmittedExpression,
            createCommaListExpression,
            updateCommaListExpression,
            createSyntheticReferenceExpression,
            updateSyntheticReferenceExpression,
            cloneNode,
            // Lazily load factory methods for common operator factories and utilities
            get createComma () {
                return getBinaryCreateFunction(28 /* CommaToken */ );
            },
            get createAssignment () {
                return getBinaryCreateFunction(64 /* EqualsToken */ );
            },
            get createLogicalOr () {
                return getBinaryCreateFunction(57 /* BarBarToken */ );
            },
            get createLogicalAnd () {
                return getBinaryCreateFunction(56 /* AmpersandAmpersandToken */ );
            },
            get createBitwiseOr () {
                return getBinaryCreateFunction(52 /* BarToken */ );
            },
            get createBitwiseXor () {
                return getBinaryCreateFunction(53 /* CaretToken */ );
            },
            get createBitwiseAnd () {
                return getBinaryCreateFunction(51 /* AmpersandToken */ );
            },
            get createStrictEquality () {
                return getBinaryCreateFunction(37 /* EqualsEqualsEqualsToken */ );
            },
            get createStrictInequality () {
                return getBinaryCreateFunction(38 /* ExclamationEqualsEqualsToken */ );
            },
            get createEquality () {
                return getBinaryCreateFunction(35 /* EqualsEqualsToken */ );
            },
            get createInequality () {
                return getBinaryCreateFunction(36 /* ExclamationEqualsToken */ );
            },
            get createLessThan () {
                return getBinaryCreateFunction(30 /* LessThanToken */ );
            },
            get createLessThanEquals () {
                return getBinaryCreateFunction(33 /* LessThanEqualsToken */ );
            },
            get createGreaterThan () {
                return getBinaryCreateFunction(32 /* GreaterThanToken */ );
            },
            get createGreaterThanEquals () {
                return getBinaryCreateFunction(34 /* GreaterThanEqualsToken */ );
            },
            get createLeftShift () {
                return getBinaryCreateFunction(48 /* LessThanLessThanToken */ );
            },
            get createRightShift () {
                return getBinaryCreateFunction(49 /* GreaterThanGreaterThanToken */ );
            },
            get createUnsignedRightShift () {
                return getBinaryCreateFunction(50 /* GreaterThanGreaterThanGreaterThanToken */ );
            },
            get createAdd () {
                return getBinaryCreateFunction(40 /* PlusToken */ );
            },
            get createSubtract () {
                return getBinaryCreateFunction(41 /* MinusToken */ );
            },
            get createMultiply () {
                return getBinaryCreateFunction(42 /* AsteriskToken */ );
            },
            get createDivide () {
                return getBinaryCreateFunction(44 /* SlashToken */ );
            },
            get createModulo () {
                return getBinaryCreateFunction(45 /* PercentToken */ );
            },
            get createExponent () {
                return getBinaryCreateFunction(43 /* AsteriskAsteriskToken */ );
            },
            get createPrefixPlus () {
                return getPrefixUnaryCreateFunction(40 /* PlusToken */ );
            },
            get createPrefixMinus () {
                return getPrefixUnaryCreateFunction(41 /* MinusToken */ );
            },
            get createPrefixIncrement () {
                return getPrefixUnaryCreateFunction(46 /* PlusPlusToken */ );
            },
            get createPrefixDecrement () {
                return getPrefixUnaryCreateFunction(47 /* MinusMinusToken */ );
            },
            get createBitwiseNot () {
                return getPrefixUnaryCreateFunction(55 /* TildeToken */ );
            },
            get createLogicalNot () {
                return getPrefixUnaryCreateFunction(54 /* ExclamationToken */ );
            },
            get createPostfixIncrement () {
                return getPostfixUnaryCreateFunction(46 /* PlusPlusToken */ );
            },
            get createPostfixDecrement () {
                return getPostfixUnaryCreateFunction(47 /* MinusMinusToken */ );
            },
            // Compound nodes
            createImmediatelyInvokedFunctionExpression,
            createImmediatelyInvokedArrowFunction,
            createVoidZero,
            createExportDefault,
            createExternalModuleExport,
            createTypeCheck,
            createIsNotTypeCheck,
            createMethodCall,
            createGlobalMethodCall,
            createFunctionBindCall,
            createFunctionCallCall,
            createFunctionApplyCall,
            createArraySliceCall,
            createArrayConcatCall,
            createObjectDefinePropertyCall,
            createObjectGetOwnPropertyDescriptorCall,
            createReflectGetCall,
            createReflectSetCall,
            createPropertyDescriptor,
            createCallBinding,
            createAssignmentTargetWrapper,
            // Utilities
            inlineExpressions,
            getInternalName,
            getLocalName,
            getExportName,
            getDeclarationName,
            getNamespaceMemberName,
            getExternalModuleOrNamespaceExportName,
            restoreOuterExpressions,
            restoreEnclosingLabel,
            createUseStrictPrologue,
            copyPrologue,
            copyStandardPrologue,
            copyCustomPrologue,
            ensureUseStrict,
            liftToBlock,
            mergeLexicalEnvironment,
            replaceModifiers,
            replaceDecoratorsAndModifiers,
            replacePropertyName
        };
        forEach(nodeFactoryPatchers, (fn)=>fn(factory2));
        return factory2;
        function createNodeArray(elements, hasTrailingComma) {
            if (elements === void 0 || elements === emptyArray) elements = [];
            else if (isNodeArray(elements)) {
                if (hasTrailingComma === void 0 || elements.hasTrailingComma === hasTrailingComma) {
                    if (elements.transformFlags === void 0) aggregateChildrenFlags(elements);
                    Debug.attachNodeArrayDebugInfo(elements);
                    return elements;
                }
                const array2 = elements.slice();
                array2.pos = elements.pos;
                array2.end = elements.end;
                array2.hasTrailingComma = hasTrailingComma;
                array2.transformFlags = elements.transformFlags;
                Debug.attachNodeArrayDebugInfo(array2);
                return array2;
            }
            const length2 = elements.length;
            const array = length2 >= 1 && length2 <= 4 ? elements.slice() : elements;
            array.pos = -1;
            array.end = -1;
            array.hasTrailingComma = !!hasTrailingComma;
            array.transformFlags = 0 /* None */ ;
            aggregateChildrenFlags(array);
            Debug.attachNodeArrayDebugInfo(array);
            return array;
        }
        function createBaseNode(kind) {
            return baseFactory2.createBaseNode(kind);
        }
        function createBaseDeclaration(kind) {
            const node = createBaseNode(kind);
            node.symbol = void 0;
            node.localSymbol = void 0;
            return node;
        }
        function finishUpdateBaseSignatureDeclaration(updated, original) {
            if (updated !== original) updated.typeArguments = original.typeArguments;
            return update(updated, original);
        }
        function createNumericLiteral(value1, numericLiteralFlags = 0 /* None */ ) {
            const text = typeof value1 === "number" ? value1 + "" : value1;
            Debug.assert(text.charCodeAt(0) !== 45 /* minus */ , "Negative numbers should be created in combination with createPrefixUnaryExpression");
            const node = createBaseDeclaration(9 /* NumericLiteral */ );
            node.text = text;
            node.numericLiteralFlags = numericLiteralFlags;
            if (numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */ ) node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createBigIntLiteral(value1) {
            const node = createBaseToken(10 /* BigIntLiteral */ );
            node.text = typeof value1 === "string" ? value1 : pseudoBigIntToString(value1) + "n";
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function createBaseStringLiteral(text, isSingleQuote) {
            const node = createBaseDeclaration(11 /* StringLiteral */ );
            node.text = text;
            node.singleQuote = isSingleQuote;
            return node;
        }
        function createStringLiteral(text, isSingleQuote, hasExtendedUnicodeEscape) {
            const node = createBaseStringLiteral(text, isSingleQuote);
            node.hasExtendedUnicodeEscape = hasExtendedUnicodeEscape;
            if (hasExtendedUnicodeEscape) node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createStringLiteralFromNode(sourceNode) {
            const node = createBaseStringLiteral(getTextOfIdentifierOrLiteral(sourceNode), /*isSingleQuote*/ void 0);
            node.textSourceNode = sourceNode;
            return node;
        }
        function createRegularExpressionLiteral(text) {
            const node = createBaseToken(14 /* RegularExpressionLiteral */ );
            node.text = text;
            return node;
        }
        function createLiteralLikeNode(kind, text) {
            switch(kind){
                case 9 /* NumericLiteral */ :
                    return createNumericLiteral(text, /*numericLiteralFlags*/ 0);
                case 10 /* BigIntLiteral */ :
                    return createBigIntLiteral(text);
                case 11 /* StringLiteral */ :
                    return createStringLiteral(text, /*isSingleQuote*/ void 0);
                case 12 /* JsxText */ :
                    return createJsxText(text, /*containsOnlyTriviaWhiteSpaces*/ false);
                case 13 /* JsxTextAllWhiteSpaces */ :
                    return createJsxText(text, /*containsOnlyTriviaWhiteSpaces*/ true);
                case 14 /* RegularExpressionLiteral */ :
                    return createRegularExpressionLiteral(text);
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return createTemplateLiteralLikeNode(kind, text, /*rawText*/ void 0, /*templateFlags*/ 0);
            }
        }
        function createBaseIdentifier(escapedText) {
            const node = baseFactory2.createBaseIdentifierNode(80 /* Identifier */ );
            node.escapedText = escapedText;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            node.symbol = void 0;
            return node;
        }
        function createBaseGeneratedIdentifier(text, autoGenerateFlags, prefix, suffix) {
            const node = createBaseIdentifier(escapeLeadingUnderscores(text));
            setIdentifierAutoGenerate(node, {
                flags: autoGenerateFlags,
                id: nextAutoGenerateId,
                prefix,
                suffix
            });
            nextAutoGenerateId++;
            return node;
        }
        function createIdentifier(text, originalKeywordKind, hasExtendedUnicodeEscape) {
            if (originalKeywordKind === void 0 && text) originalKeywordKind = stringToToken(text);
            if (originalKeywordKind === 80 /* Identifier */ ) originalKeywordKind = void 0;
            const node = createBaseIdentifier(escapeLeadingUnderscores(text));
            if (hasExtendedUnicodeEscape) node.flags |= 256 /* IdentifierHasExtendedUnicodeEscape */ ;
            if (node.escapedText === "await") node.transformFlags |= 67108864 /* ContainsPossibleTopLevelAwait */ ;
            if (node.flags & 256 /* IdentifierHasExtendedUnicodeEscape */ ) node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createTempVariable(recordTempVariable, reservedInNestedScopes, prefix, suffix) {
            let flags2 = 1 /* Auto */ ;
            if (reservedInNestedScopes) flags2 |= 8 /* ReservedInNestedScopes */ ;
            const name = createBaseGeneratedIdentifier("", flags2, prefix, suffix);
            if (recordTempVariable) recordTempVariable(name);
            return name;
        }
        function createLoopVariable(reservedInNestedScopes) {
            let flags2 = 2 /* Loop */ ;
            if (reservedInNestedScopes) flags2 |= 8 /* ReservedInNestedScopes */ ;
            return createBaseGeneratedIdentifier("", flags2, /*prefix*/ void 0, /*suffix*/ void 0);
        }
        function createUniqueName(text, flags2 = 0 /* None */ , prefix, suffix) {
            Debug.assert(!(flags2 & 7 /* KindMask */ ), "Argument out of range: flags");
            Debug.assert((flags2 & 48 /* FileLevel */ ) !== 32 /* FileLevel */ , "GeneratedIdentifierFlags.FileLevel cannot be set without also setting GeneratedIdentifierFlags.Optimistic");
            return createBaseGeneratedIdentifier(text, 3 /* Unique */  | flags2, prefix, suffix);
        }
        function getGeneratedNameForNode(node, flags2 = 0, prefix, suffix) {
            Debug.assert(!(flags2 & 7 /* KindMask */ ), "Argument out of range: flags");
            const text = !node ? "" : isMemberName(node) ? formatGeneratedName(/*privateName*/ false, prefix, node, suffix, idText) : `generated@${getNodeId(node)}`;
            if (prefix || suffix) flags2 |= 16 /* Optimistic */ ;
            const name = createBaseGeneratedIdentifier(text, 4 /* Node */  | flags2, prefix, suffix);
            name.original = node;
            return name;
        }
        function createBasePrivateIdentifier(escapedText) {
            const node = baseFactory2.createBasePrivateIdentifierNode(81 /* PrivateIdentifier */ );
            node.escapedText = escapedText;
            node.transformFlags |= 16777216 /* ContainsClassFields */ ;
            return node;
        }
        function createPrivateIdentifier(text) {
            if (!startsWith(text, "#")) Debug.fail("First character of private identifier must be #: " + text);
            return createBasePrivateIdentifier(escapeLeadingUnderscores(text));
        }
        function createBaseGeneratedPrivateIdentifier(text, autoGenerateFlags, prefix, suffix) {
            const node = createBasePrivateIdentifier(escapeLeadingUnderscores(text));
            setIdentifierAutoGenerate(node, {
                flags: autoGenerateFlags,
                id: nextAutoGenerateId,
                prefix,
                suffix
            });
            nextAutoGenerateId++;
            return node;
        }
        function createUniquePrivateName(text, prefix, suffix) {
            if (text && !startsWith(text, "#")) Debug.fail("First character of private identifier must be #: " + text);
            const autoGenerateFlags = 8 /* ReservedInNestedScopes */  | (text ? 3 /* Unique */  : 1 /* Auto */ );
            return createBaseGeneratedPrivateIdentifier(text !== null && text !== void 0 ? text : "", autoGenerateFlags, prefix, suffix);
        }
        function getGeneratedPrivateNameForNode(node, prefix, suffix) {
            const text = isMemberName(node) ? formatGeneratedName(/*privateName*/ true, prefix, node, suffix, idText) : `#generated@${getNodeId(node)}`;
            const flags2 = prefix || suffix ? 16 /* Optimistic */  : 0 /* None */ ;
            const name = createBaseGeneratedPrivateIdentifier(text, 4 /* Node */  | flags2, prefix, suffix);
            name.original = node;
            return name;
        }
        function createBaseToken(kind) {
            return baseFactory2.createBaseTokenNode(kind);
        }
        function createToken(token) {
            Debug.assert(token >= 0 /* FirstToken */  && token <= 166 /* LastToken */ , "Invalid token");
            Debug.assert(token <= 15 /* FirstTemplateToken */  || token >= 18 /* LastTemplateToken */ , "Invalid token. Use 'createTemplateLiteralLikeNode' to create template literals.");
            Debug.assert(token <= 9 /* FirstLiteralToken */  || token >= 15 /* LastLiteralToken */ , "Invalid token. Use 'createLiteralLikeNode' to create literals.");
            Debug.assert(token !== 80 /* Identifier */ , "Invalid token. Use 'createIdentifier' to create identifiers");
            const node = createBaseToken(token);
            let transformFlags = 0 /* None */ ;
            switch(token){
                case 134 /* AsyncKeyword */ :
                    transformFlags = 384 /* ContainsES2018 */ ;
                    break;
                case 160 /* UsingKeyword */ :
                    transformFlags = 4 /* ContainsESNext */ ;
                    break;
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                case 128 /* AbstractKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 87 /* ConstKeyword */ :
                case 133 /* AnyKeyword */ :
                case 150 /* NumberKeyword */ :
                case 163 /* BigIntKeyword */ :
                case 146 /* NeverKeyword */ :
                case 151 /* ObjectKeyword */ :
                case 103 /* InKeyword */ :
                case 147 /* OutKeyword */ :
                case 164 /* OverrideKeyword */ :
                case 154 /* StringKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 116 /* VoidKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 157 /* UndefinedKeyword */ :
                    transformFlags = 1 /* ContainsTypeScript */ ;
                    break;
                case 108 /* SuperKeyword */ :
                    transformFlags = 134218752 /* ContainsLexicalSuper */ ;
                    node.flowNode = void 0;
                    break;
                case 126 /* StaticKeyword */ :
                    transformFlags = 1024 /* ContainsES2015 */ ;
                    break;
                case 129 /* AccessorKeyword */ :
                    transformFlags = 16777216 /* ContainsClassFields */ ;
                    break;
                case 110 /* ThisKeyword */ :
                    transformFlags = 16384 /* ContainsLexicalThis */ ;
                    node.flowNode = void 0;
                    break;
            }
            if (transformFlags) node.transformFlags |= transformFlags;
            return node;
        }
        function createSuper() {
            return createToken(108 /* SuperKeyword */ );
        }
        function createThis() {
            return createToken(110 /* ThisKeyword */ );
        }
        function createNull() {
            return createToken(106 /* NullKeyword */ );
        }
        function createTrue() {
            return createToken(112 /* TrueKeyword */ );
        }
        function createFalse() {
            return createToken(97 /* FalseKeyword */ );
        }
        function createModifier(kind) {
            return createToken(kind);
        }
        function createModifiersFromModifierFlags(flags2) {
            const result = [];
            if (flags2 & 32 /* Export */ ) result.push(createModifier(95 /* ExportKeyword */ ));
            if (flags2 & 128 /* Ambient */ ) result.push(createModifier(138 /* DeclareKeyword */ ));
            if (flags2 & 2048 /* Default */ ) result.push(createModifier(90 /* DefaultKeyword */ ));
            if (flags2 & 4096 /* Const */ ) result.push(createModifier(87 /* ConstKeyword */ ));
            if (flags2 & 1 /* Public */ ) result.push(createModifier(125 /* PublicKeyword */ ));
            if (flags2 & 2 /* Private */ ) result.push(createModifier(123 /* PrivateKeyword */ ));
            if (flags2 & 4 /* Protected */ ) result.push(createModifier(124 /* ProtectedKeyword */ ));
            if (flags2 & 64 /* Abstract */ ) result.push(createModifier(128 /* AbstractKeyword */ ));
            if (flags2 & 256 /* Static */ ) result.push(createModifier(126 /* StaticKeyword */ ));
            if (flags2 & 16 /* Override */ ) result.push(createModifier(164 /* OverrideKeyword */ ));
            if (flags2 & 8 /* Readonly */ ) result.push(createModifier(148 /* ReadonlyKeyword */ ));
            if (flags2 & 512 /* Accessor */ ) result.push(createModifier(129 /* AccessorKeyword */ ));
            if (flags2 & 1024 /* Async */ ) result.push(createModifier(134 /* AsyncKeyword */ ));
            if (flags2 & 8192 /* In */ ) result.push(createModifier(103 /* InKeyword */ ));
            if (flags2 & 16384 /* Out */ ) result.push(createModifier(147 /* OutKeyword */ ));
            return result.length ? result : void 0;
        }
        function createQualifiedName(left, right) {
            const node = createBaseNode(167 /* QualifiedName */ );
            node.left = left;
            node.right = asName(right);
            node.transformFlags |= propagateChildFlags(node.left) | propagateIdentifierNameFlags(node.right);
            node.flowNode = void 0;
            return node;
        }
        function updateQualifiedName(node, left, right) {
            return node.left !== left || node.right !== right ? update(createQualifiedName(left, right), node) : node;
        }
        function createComputedPropertyName(expression) {
            const node = createBaseNode(168 /* ComputedPropertyName */ );
            node.expression = parenthesizerRules().parenthesizeExpressionOfComputedPropertyName(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 132096 /* ContainsComputedPropertyName */ ;
            return node;
        }
        function updateComputedPropertyName(node, expression) {
            return node.expression !== expression ? update(createComputedPropertyName(expression), node) : node;
        }
        function createTypeParameterDeclaration(modifiers, name, constraint, defaultType) {
            const node = createBaseDeclaration(169 /* TypeParameter */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.constraint = constraint;
            node.default = defaultType;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.expression = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updateTypeParameterDeclaration(node, modifiers, name, constraint, defaultType) {
            return node.modifiers !== modifiers || node.name !== name || node.constraint !== constraint || node.default !== defaultType ? update(createTypeParameterDeclaration(modifiers, name, constraint, defaultType), node) : node;
        }
        function createParameterDeclaration(modifiers, dotDotDotToken, name, questionToken, type, initializer) {
            const node = createBaseDeclaration(170 /* Parameter */ );
            node.modifiers = asNodeArray(modifiers);
            node.dotDotDotToken = dotDotDotToken;
            node.name = asName(name);
            node.questionToken = questionToken;
            node.type = type;
            node.initializer = asInitializer(initializer);
            var _node_questionToken, _node_dotDotDotToken;
            if (isThisIdentifier(node.name)) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.dotDotDotToken) | propagateNameFlags(node.name) | propagateChildFlags(node.questionToken) | propagateChildFlags(node.initializer) | (((_node_questionToken = node.questionToken) !== null && _node_questionToken !== void 0 ? _node_questionToken : node.type) ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | (((_node_dotDotDotToken = node.dotDotDotToken) !== null && _node_dotDotDotToken !== void 0 ? _node_dotDotDotToken : node.initializer) ? 1024 /* ContainsES2015 */  : 0 /* None */ ) | (modifiersToFlags(node.modifiers) & 31 /* ParameterPropertyModifier */  ? 8192 /* ContainsTypeScriptClassSyntax */  : 0 /* None */ );
            node.jsDoc = void 0;
            return node;
        }
        function updateParameterDeclaration(node, modifiers, dotDotDotToken, name, questionToken, type, initializer) {
            return node.modifiers !== modifiers || node.dotDotDotToken !== dotDotDotToken || node.name !== name || node.questionToken !== questionToken || node.type !== type || node.initializer !== initializer ? update(createParameterDeclaration(modifiers, dotDotDotToken, name, questionToken, type, initializer), node) : node;
        }
        function createDecorator(expression) {
            const node = createBaseNode(171 /* Decorator */ );
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            node.transformFlags |= propagateChildFlags(node.expression) | 33562625 /* ContainsDecorators */ ;
            return node;
        }
        function updateDecorator(node, expression) {
            return node.expression !== expression ? update(createDecorator(expression), node) : node;
        }
        function createPropertySignature(modifiers, name, questionToken, type) {
            const node = createBaseDeclaration(172 /* PropertySignature */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.type = type;
            node.questionToken = questionToken;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.initializer = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updatePropertySignature(node, modifiers, name, questionToken, type) {
            return node.modifiers !== modifiers || node.name !== name || node.questionToken !== questionToken || node.type !== type ? finishUpdatePropertySignature(createPropertySignature(modifiers, name, questionToken, type), node) : node;
        }
        function finishUpdatePropertySignature(updated, original) {
            if (updated !== original) updated.initializer = original.initializer;
            return update(updated, original);
        }
        function createPropertyDeclaration(modifiers, name, questionOrExclamationToken, type, initializer) {
            const node = createBaseDeclaration(173 /* PropertyDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.questionToken = questionOrExclamationToken && isQuestionToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0;
            node.exclamationToken = questionOrExclamationToken && isExclamationToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0;
            node.type = type;
            node.initializer = asInitializer(initializer);
            const isAmbient = node.flags & 33554432 /* Ambient */  || modifiersToFlags(node.modifiers) & 128 /* Ambient */ ;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildFlags(node.initializer) | (isAmbient || node.questionToken || node.exclamationToken || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | (isComputedPropertyName(node.name) || modifiersToFlags(node.modifiers) & 256 /* Static */  && node.initializer ? 8192 /* ContainsTypeScriptClassSyntax */  : 0 /* None */ ) | 16777216 /* ContainsClassFields */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updatePropertyDeclaration2(node, modifiers, name, questionOrExclamationToken, type, initializer) {
            return node.modifiers !== modifiers || node.name !== name || node.questionToken !== (questionOrExclamationToken !== void 0 && isQuestionToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0) || node.exclamationToken !== (questionOrExclamationToken !== void 0 && isExclamationToken(questionOrExclamationToken) ? questionOrExclamationToken : void 0) || node.type !== type || node.initializer !== initializer ? update(createPropertyDeclaration(modifiers, name, questionOrExclamationToken, type, initializer), node) : node;
        }
        function createMethodSignature(modifiers, name, questionToken, typeParameters, parameters, type) {
            const node = createBaseDeclaration(174 /* MethodSignature */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.questionToken = questionToken;
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateMethodSignature(node, modifiers, name, questionToken, typeParameters, parameters, type) {
            return node.modifiers !== modifiers || node.name !== name || node.questionToken !== questionToken || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createMethodSignature(modifiers, name, questionToken, typeParameters, parameters, type), node) : node;
        }
        function createMethodDeclaration(modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
            const node = createBaseDeclaration(175 /* MethodDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.asteriskToken = asteriskToken;
            node.name = asName(name);
            node.questionToken = questionToken;
            node.exclamationToken = void 0;
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else {
                const isAsync = modifiersToFlags(node.modifiers) & 1024 /* Async */ ;
                const isGenerator = !!node.asteriskToken;
                const isAsyncGenerator = isAsync && isGenerator;
                node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.asteriskToken) | propagateNameFlags(node.name) | propagateChildFlags(node.questionToken) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (isAsyncGenerator ? 128 /* ContainsES2018 */  : isAsync ? 256 /* ContainsES2017 */  : isGenerator ? 2048 /* ContainsGenerator */  : 0 /* None */ ) | (node.questionToken || node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            }
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateMethodDeclaration(node, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
            return node.modifiers !== modifiers || node.asteriskToken !== asteriskToken || node.name !== name || node.questionToken !== questionToken || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateMethodDeclaration(createMethodDeclaration(modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body), node) : node;
        }
        function finishUpdateMethodDeclaration(updated, original) {
            if (updated !== original) updated.exclamationToken = original.exclamationToken;
            return update(updated, original);
        }
        function createClassStaticBlockDeclaration(body) {
            const node = createBaseDeclaration(176 /* ClassStaticBlockDeclaration */ );
            node.body = body;
            node.transformFlags = propagateChildFlags(body) | 16777216 /* ContainsClassFields */ ;
            node.modifiers = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateClassStaticBlockDeclaration(node, body) {
            return node.body !== body ? finishUpdateClassStaticBlockDeclaration(createClassStaticBlockDeclaration(body), node) : node;
        }
        function finishUpdateClassStaticBlockDeclaration(updated, original) {
            if (updated !== original) updated.modifiers = original.modifiers;
            return update(updated, original);
        }
        function createConstructorDeclaration(modifiers, parameters, body) {
            const node = createBaseDeclaration(177 /* Constructor */ );
            node.modifiers = asNodeArray(modifiers);
            node.parameters = createNodeArray(parameters);
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | 1024 /* ContainsES2015 */ ;
            node.typeParameters = void 0;
            node.type = void 0;
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateConstructorDeclaration(node, modifiers, parameters, body) {
            return node.modifiers !== modifiers || node.parameters !== parameters || node.body !== body ? finishUpdateConstructorDeclaration(createConstructorDeclaration(modifiers, parameters, body), node) : node;
        }
        function finishUpdateConstructorDeclaration(updated, original) {
            if (updated !== original) {
                updated.typeParameters = original.typeParameters;
                updated.type = original.type;
            }
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createGetAccessorDeclaration(modifiers, name, parameters, type, body) {
            const node = createBaseDeclaration(178 /* GetAccessor */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.typeArguments = void 0;
            node.typeParameters = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateGetAccessorDeclaration(node, modifiers, name, parameters, type, body) {
            return node.modifiers !== modifiers || node.name !== name || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateGetAccessorDeclaration(createGetAccessorDeclaration(modifiers, name, parameters, type, body), node) : node;
        }
        function finishUpdateGetAccessorDeclaration(updated, original) {
            if (updated !== original) updated.typeParameters = original.typeParameters;
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createSetAccessorDeclaration(modifiers, name, parameters, body) {
            const node = createBaseDeclaration(179 /* SetAccessor */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.parameters = createNodeArray(parameters);
            node.body = body;
            if (!node.body) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.typeArguments = void 0;
            node.typeParameters = void 0;
            node.type = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateSetAccessorDeclaration(node, modifiers, name, parameters, body) {
            return node.modifiers !== modifiers || node.name !== name || node.parameters !== parameters || node.body !== body ? finishUpdateSetAccessorDeclaration(createSetAccessorDeclaration(modifiers, name, parameters, body), node) : node;
        }
        function finishUpdateSetAccessorDeclaration(updated, original) {
            if (updated !== original) {
                updated.typeParameters = original.typeParameters;
                updated.type = original.type;
            }
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createCallSignature(typeParameters, parameters, type) {
            const node = createBaseDeclaration(180 /* CallSignature */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateCallSignature(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createCallSignature(typeParameters, parameters, type), node) : node;
        }
        function createConstructSignature(typeParameters, parameters, type) {
            const node = createBaseDeclaration(181 /* ConstructSignature */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateConstructSignature(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createConstructSignature(typeParameters, parameters, type), node) : node;
        }
        function createIndexSignature(modifiers, parameters, type) {
            const node = createBaseDeclaration(182 /* IndexSignature */ );
            node.modifiers = asNodeArray(modifiers);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateIndexSignature(node, modifiers, parameters, type) {
            return node.parameters !== parameters || node.type !== type || node.modifiers !== modifiers ? finishUpdateBaseSignatureDeclaration(createIndexSignature(modifiers, parameters, type), node) : node;
        }
        function createTemplateLiteralTypeSpan(type, literal) {
            const node = createBaseNode(205 /* TemplateLiteralTypeSpan */ );
            node.type = type;
            node.literal = literal;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTemplateLiteralTypeSpan(node, type, literal) {
            return node.type !== type || node.literal !== literal ? update(createTemplateLiteralTypeSpan(type, literal), node) : node;
        }
        function createKeywordTypeNode(kind) {
            return createToken(kind);
        }
        function createTypePredicateNode(assertsModifier, parameterName, type) {
            const node = createBaseNode(183 /* TypePredicate */ );
            node.assertsModifier = assertsModifier;
            node.parameterName = asName(parameterName);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypePredicateNode(node, assertsModifier, parameterName, type) {
            return node.assertsModifier !== assertsModifier || node.parameterName !== parameterName || node.type !== type ? update(createTypePredicateNode(assertsModifier, parameterName, type), node) : node;
        }
        function createTypeReferenceNode(typeName, typeArguments) {
            const node = createBaseNode(184 /* TypeReference */ );
            node.typeName = asName(typeName);
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(createNodeArray(typeArguments));
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeReferenceNode(node, typeName, typeArguments) {
            return node.typeName !== typeName || node.typeArguments !== typeArguments ? update(createTypeReferenceNode(typeName, typeArguments), node) : node;
        }
        function createFunctionTypeNode(typeParameters, parameters, type) {
            const node = createBaseDeclaration(185 /* FunctionType */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.modifiers = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateFunctionTypeNode(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateFunctionTypeNode(createFunctionTypeNode(typeParameters, parameters, type), node) : node;
        }
        function finishUpdateFunctionTypeNode(updated, original) {
            if (updated !== original) updated.modifiers = original.modifiers;
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createConstructorTypeNode(...args) {
            return args.length === 4 ? createConstructorTypeNode1(...args) : args.length === 3 ? createConstructorTypeNode2(...args) : Debug.fail("Incorrect number of arguments specified.");
        }
        function createConstructorTypeNode1(modifiers, typeParameters, parameters, type) {
            const node = createBaseDeclaration(186 /* ConstructorType */ );
            node.modifiers = asNodeArray(modifiers);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function createConstructorTypeNode2(typeParameters, parameters, type) {
            return createConstructorTypeNode1(/*modifiers*/ void 0, typeParameters, parameters, type);
        }
        function updateConstructorTypeNode(...args) {
            return args.length === 5 ? updateConstructorTypeNode1(...args) : args.length === 4 ? updateConstructorTypeNode2(...args) : Debug.fail("Incorrect number of arguments specified.");
        }
        function updateConstructorTypeNode1(node, modifiers, typeParameters, parameters, type) {
            return node.modifiers !== modifiers || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? finishUpdateBaseSignatureDeclaration(createConstructorTypeNode(modifiers, typeParameters, parameters, type), node) : node;
        }
        function updateConstructorTypeNode2(node, typeParameters, parameters, type) {
            return updateConstructorTypeNode1(node, node.modifiers, typeParameters, parameters, type);
        }
        function createTypeQueryNode(exprName, typeArguments) {
            const node = createBaseNode(187 /* TypeQuery */ );
            node.exprName = exprName;
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(typeArguments);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeQueryNode(node, exprName, typeArguments) {
            return node.exprName !== exprName || node.typeArguments !== typeArguments ? update(createTypeQueryNode(exprName, typeArguments), node) : node;
        }
        function createTypeLiteralNode(members) {
            const node = createBaseDeclaration(188 /* TypeLiteral */ );
            node.members = createNodeArray(members);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeLiteralNode(node, members) {
            return node.members !== members ? update(createTypeLiteralNode(members), node) : node;
        }
        function createArrayTypeNode(elementType) {
            const node = createBaseNode(189 /* ArrayType */ );
            node.elementType = parenthesizerRules().parenthesizeNonArrayTypeOfPostfixType(elementType);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateArrayTypeNode(node, elementType) {
            return node.elementType !== elementType ? update(createArrayTypeNode(elementType), node) : node;
        }
        function createTupleTypeNode(elements) {
            const node = createBaseNode(190 /* TupleType */ );
            node.elements = createNodeArray(parenthesizerRules().parenthesizeElementTypesOfTupleType(elements));
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTupleTypeNode(node, elements) {
            return node.elements !== elements ? update(createTupleTypeNode(elements), node) : node;
        }
        function createNamedTupleMember(dotDotDotToken, name, questionToken, type) {
            const node = createBaseDeclaration(203 /* NamedTupleMember */ );
            node.dotDotDotToken = dotDotDotToken;
            node.name = name;
            node.questionToken = questionToken;
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateNamedTupleMember(node, dotDotDotToken, name, questionToken, type) {
            return node.dotDotDotToken !== dotDotDotToken || node.name !== name || node.questionToken !== questionToken || node.type !== type ? update(createNamedTupleMember(dotDotDotToken, name, questionToken, type), node) : node;
        }
        function createOptionalTypeNode(type) {
            const node = createBaseNode(191 /* OptionalType */ );
            node.type = parenthesizerRules().parenthesizeTypeOfOptionalType(type);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateOptionalTypeNode(node, type) {
            return node.type !== type ? update(createOptionalTypeNode(type), node) : node;
        }
        function createRestTypeNode(type) {
            const node = createBaseNode(192 /* RestType */ );
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateRestTypeNode(node, type) {
            return node.type !== type ? update(createRestTypeNode(type), node) : node;
        }
        function createUnionOrIntersectionTypeNode(kind, types, parenthesize) {
            const node = createBaseNode(kind);
            node.types = factory2.createNodeArray(parenthesize(types));
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateUnionOrIntersectionTypeNode(node, types, parenthesize) {
            return node.types !== types ? update(createUnionOrIntersectionTypeNode(node.kind, types, parenthesize), node) : node;
        }
        function createUnionTypeNode(types) {
            return createUnionOrIntersectionTypeNode(193 /* UnionType */ , types, parenthesizerRules().parenthesizeConstituentTypesOfUnionType);
        }
        function updateUnionTypeNode(node, types) {
            return updateUnionOrIntersectionTypeNode(node, types, parenthesizerRules().parenthesizeConstituentTypesOfUnionType);
        }
        function createIntersectionTypeNode(types) {
            return createUnionOrIntersectionTypeNode(194 /* IntersectionType */ , types, parenthesizerRules().parenthesizeConstituentTypesOfIntersectionType);
        }
        function updateIntersectionTypeNode(node, types) {
            return updateUnionOrIntersectionTypeNode(node, types, parenthesizerRules().parenthesizeConstituentTypesOfIntersectionType);
        }
        function createConditionalTypeNode(checkType, extendsType, trueType, falseType) {
            const node = createBaseNode(195 /* ConditionalType */ );
            node.checkType = parenthesizerRules().parenthesizeCheckTypeOfConditionalType(checkType);
            node.extendsType = parenthesizerRules().parenthesizeExtendsTypeOfConditionalType(extendsType);
            node.trueType = trueType;
            node.falseType = falseType;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateConditionalTypeNode(node, checkType, extendsType, trueType, falseType) {
            return node.checkType !== checkType || node.extendsType !== extendsType || node.trueType !== trueType || node.falseType !== falseType ? update(createConditionalTypeNode(checkType, extendsType, trueType, falseType), node) : node;
        }
        function createInferTypeNode(typeParameter) {
            const node = createBaseNode(196 /* InferType */ );
            node.typeParameter = typeParameter;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateInferTypeNode(node, typeParameter) {
            return node.typeParameter !== typeParameter ? update(createInferTypeNode(typeParameter), node) : node;
        }
        function createTemplateLiteralType(head, templateSpans) {
            const node = createBaseNode(204 /* TemplateLiteralType */ );
            node.head = head;
            node.templateSpans = createNodeArray(templateSpans);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTemplateLiteralType(node, head, templateSpans) {
            return node.head !== head || node.templateSpans !== templateSpans ? update(createTemplateLiteralType(head, templateSpans), node) : node;
        }
        function createImportTypeNode(argument, attributes, qualifier, typeArguments, isTypeOf = false) {
            const node = createBaseNode(206 /* ImportType */ );
            node.argument = argument;
            node.attributes = attributes;
            if (node.assertions && node.assertions.assertClause && node.attributes) node.assertions.assertClause = node.attributes;
            node.qualifier = qualifier;
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(typeArguments);
            node.isTypeOf = isTypeOf;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateImportTypeNode(node, argument, attributes, qualifier, typeArguments, isTypeOf = node.isTypeOf) {
            return node.argument !== argument || node.attributes !== attributes || node.qualifier !== qualifier || node.typeArguments !== typeArguments || node.isTypeOf !== isTypeOf ? update(createImportTypeNode(argument, attributes, qualifier, typeArguments, isTypeOf), node) : node;
        }
        function createParenthesizedType(type) {
            const node = createBaseNode(197 /* ParenthesizedType */ );
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateParenthesizedType(node, type) {
            return node.type !== type ? update(createParenthesizedType(type), node) : node;
        }
        function createThisTypeNode() {
            const node = createBaseNode(198 /* ThisType */ );
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function createTypeOperatorNode(operator, type) {
            const node = createBaseNode(199 /* TypeOperator */ );
            node.operator = operator;
            node.type = operator === 148 /* ReadonlyKeyword */  ? parenthesizerRules().parenthesizeOperandOfReadonlyTypeOperator(type) : parenthesizerRules().parenthesizeOperandOfTypeOperator(type);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeOperatorNode(node, type) {
            return node.type !== type ? update(createTypeOperatorNode(node.operator, type), node) : node;
        }
        function createIndexedAccessTypeNode(objectType, indexType) {
            const node = createBaseNode(200 /* IndexedAccessType */ );
            node.objectType = parenthesizerRules().parenthesizeNonArrayTypeOfPostfixType(objectType);
            node.indexType = indexType;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateIndexedAccessTypeNode(node, objectType, indexType) {
            return node.objectType !== objectType || node.indexType !== indexType ? update(createIndexedAccessTypeNode(objectType, indexType), node) : node;
        }
        function createMappedTypeNode(readonlyToken, typeParameter, nameType, questionToken, type, members) {
            const node = createBaseDeclaration(201 /* MappedType */ );
            node.readonlyToken = readonlyToken;
            node.typeParameter = typeParameter;
            node.nameType = nameType;
            node.questionToken = questionToken;
            node.type = type;
            node.members = members && createNodeArray(members);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateMappedTypeNode(node, readonlyToken, typeParameter, nameType, questionToken, type, members) {
            return node.readonlyToken !== readonlyToken || node.typeParameter !== typeParameter || node.nameType !== nameType || node.questionToken !== questionToken || node.type !== type || node.members !== members ? update(createMappedTypeNode(readonlyToken, typeParameter, nameType, questionToken, type, members), node) : node;
        }
        function createLiteralTypeNode(literal) {
            const node = createBaseNode(202 /* LiteralType */ );
            node.literal = literal;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateLiteralTypeNode(node, literal) {
            return node.literal !== literal ? update(createLiteralTypeNode(literal), node) : node;
        }
        function createObjectBindingPattern(elements) {
            const node = createBaseNode(207 /* ObjectBindingPattern */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements) | 525312 /* ContainsBindingPattern */ ;
            if (node.transformFlags & 32768 /* ContainsRestOrSpread */ ) node.transformFlags |= 65664 /* ContainsObjectRestOrSpread */ ;
            return node;
        }
        function updateObjectBindingPattern(node, elements) {
            return node.elements !== elements ? update(createObjectBindingPattern(elements), node) : node;
        }
        function createArrayBindingPattern(elements) {
            const node = createBaseNode(208 /* ArrayBindingPattern */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements) | 525312 /* ContainsBindingPattern */ ;
            return node;
        }
        function updateArrayBindingPattern(node, elements) {
            return node.elements !== elements ? update(createArrayBindingPattern(elements), node) : node;
        }
        function createBindingElement(dotDotDotToken, propertyName, name, initializer) {
            const node = createBaseDeclaration(209 /* BindingElement */ );
            node.dotDotDotToken = dotDotDotToken;
            node.propertyName = asName(propertyName);
            node.name = asName(name);
            node.initializer = asInitializer(initializer);
            node.transformFlags |= propagateChildFlags(node.dotDotDotToken) | propagateNameFlags(node.propertyName) | propagateNameFlags(node.name) | propagateChildFlags(node.initializer) | (node.dotDotDotToken ? 32768 /* ContainsRestOrSpread */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            node.flowNode = void 0;
            return node;
        }
        function updateBindingElement(node, dotDotDotToken, propertyName, name, initializer) {
            return node.propertyName !== propertyName || node.dotDotDotToken !== dotDotDotToken || node.name !== name || node.initializer !== initializer ? update(createBindingElement(dotDotDotToken, propertyName, name, initializer), node) : node;
        }
        function createArrayLiteralExpression(elements, multiLine) {
            const node = createBaseNode(210 /* ArrayLiteralExpression */ );
            const lastElement = elements && lastOrUndefined(elements);
            const elementsArray = createNodeArray(elements, lastElement && isOmittedExpression(lastElement) ? true : void 0);
            node.elements = parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(elementsArray);
            node.multiLine = multiLine;
            node.transformFlags |= propagateChildrenFlags(node.elements);
            return node;
        }
        function updateArrayLiteralExpression(node, elements) {
            return node.elements !== elements ? update(createArrayLiteralExpression(elements, node.multiLine), node) : node;
        }
        function createObjectLiteralExpression(properties, multiLine) {
            const node = createBaseDeclaration(211 /* ObjectLiteralExpression */ );
            node.properties = createNodeArray(properties);
            node.multiLine = multiLine;
            node.transformFlags |= propagateChildrenFlags(node.properties);
            node.jsDoc = void 0;
            return node;
        }
        function updateObjectLiteralExpression(node, properties) {
            return node.properties !== properties ? update(createObjectLiteralExpression(properties, node.multiLine), node) : node;
        }
        function createBasePropertyAccessExpression(expression, questionDotToken, name) {
            const node = createBaseDeclaration(212 /* PropertyAccessExpression */ );
            node.expression = expression;
            node.questionDotToken = questionDotToken;
            node.name = name;
            node.transformFlags = propagateChildFlags(node.expression) | propagateChildFlags(node.questionDotToken) | (isIdentifier(node.name) ? propagateIdentifierNameFlags(node.name) : propagateChildFlags(node.name) | 536870912 /* ContainsPrivateIdentifierInExpression */ );
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function createPropertyAccessExpression(expression, name) {
            const node = createBasePropertyAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false), /*questionDotToken*/ void 0, asName(name));
            if (isSuperKeyword(expression)) node.transformFlags |= 384 /* ContainsES2018 */ ;
            return node;
        }
        function updatePropertyAccessExpression(node, expression, name) {
            if (isPropertyAccessChain(node)) return updatePropertyAccessChain(node, expression, node.questionDotToken, cast(name, isIdentifier));
            return node.expression !== expression || node.name !== name ? update(createPropertyAccessExpression(expression, name), node) : node;
        }
        function createPropertyAccessChain(expression, questionDotToken, name) {
            const node = createBasePropertyAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true), questionDotToken, asName(name));
            node.flags |= 64 /* OptionalChain */ ;
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function updatePropertyAccessChain(node, expression, questionDotToken, name) {
            Debug.assert(!!(node.flags & 64 /* OptionalChain */ ), "Cannot update a PropertyAccessExpression using updatePropertyAccessChain. Use updatePropertyAccess instead.");
            return node.expression !== expression || node.questionDotToken !== questionDotToken || node.name !== name ? update(createPropertyAccessChain(expression, questionDotToken, name), node) : node;
        }
        function createBaseElementAccessExpression(expression, questionDotToken, argumentExpression) {
            const node = createBaseDeclaration(213 /* ElementAccessExpression */ );
            node.expression = expression;
            node.questionDotToken = questionDotToken;
            node.argumentExpression = argumentExpression;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.questionDotToken) | propagateChildFlags(node.argumentExpression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function createElementAccessExpression(expression, index) {
            const node = createBaseElementAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false), /*questionDotToken*/ void 0, asExpression(index));
            if (isSuperKeyword(expression)) node.transformFlags |= 384 /* ContainsES2018 */ ;
            return node;
        }
        function updateElementAccessExpression(node, expression, argumentExpression) {
            if (isElementAccessChain(node)) return updateElementAccessChain(node, expression, node.questionDotToken, argumentExpression);
            return node.expression !== expression || node.argumentExpression !== argumentExpression ? update(createElementAccessExpression(expression, argumentExpression), node) : node;
        }
        function createElementAccessChain(expression, questionDotToken, index) {
            const node = createBaseElementAccessExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true), questionDotToken, asExpression(index));
            node.flags |= 64 /* OptionalChain */ ;
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function updateElementAccessChain(node, expression, questionDotToken, argumentExpression) {
            Debug.assert(!!(node.flags & 64 /* OptionalChain */ ), "Cannot update a ElementAccessExpression using updateElementAccessChain. Use updateElementAccess instead.");
            return node.expression !== expression || node.questionDotToken !== questionDotToken || node.argumentExpression !== argumentExpression ? update(createElementAccessChain(expression, questionDotToken, argumentExpression), node) : node;
        }
        function createBaseCallExpression(expression, questionDotToken, typeArguments, argumentsArray) {
            const node = createBaseDeclaration(214 /* CallExpression */ );
            node.expression = expression;
            node.questionDotToken = questionDotToken;
            node.typeArguments = typeArguments;
            node.arguments = argumentsArray;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.questionDotToken) | propagateChildrenFlags(node.typeArguments) | propagateChildrenFlags(node.arguments);
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            if (isSuperProperty(node.expression)) node.transformFlags |= 16384 /* ContainsLexicalThis */ ;
            return node;
        }
        function createCallExpression(expression, typeArguments, argumentsArray) {
            const node = createBaseCallExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false), /*questionDotToken*/ void 0, asNodeArray(typeArguments), parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(createNodeArray(argumentsArray)));
            if (isImportKeyword(node.expression)) node.transformFlags |= 8388608 /* ContainsDynamicImport */ ;
            return node;
        }
        function updateCallExpression(node, expression, typeArguments, argumentsArray) {
            if (isCallChain(node)) return updateCallChain(node, expression, node.questionDotToken, typeArguments, argumentsArray);
            return node.expression !== expression || node.typeArguments !== typeArguments || node.arguments !== argumentsArray ? update(createCallExpression(expression, typeArguments, argumentsArray), node) : node;
        }
        function createCallChain(expression, questionDotToken, typeArguments, argumentsArray) {
            const node = createBaseCallExpression(parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true), questionDotToken, asNodeArray(typeArguments), parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(createNodeArray(argumentsArray)));
            node.flags |= 64 /* OptionalChain */ ;
            node.transformFlags |= 32 /* ContainsES2020 */ ;
            return node;
        }
        function updateCallChain(node, expression, questionDotToken, typeArguments, argumentsArray) {
            Debug.assert(!!(node.flags & 64 /* OptionalChain */ ), "Cannot update a CallExpression using updateCallChain. Use updateCall instead.");
            return node.expression !== expression || node.questionDotToken !== questionDotToken || node.typeArguments !== typeArguments || node.arguments !== argumentsArray ? update(createCallChain(expression, questionDotToken, typeArguments, argumentsArray), node) : node;
        }
        function createNewExpression(expression, typeArguments, argumentsArray) {
            const node = createBaseDeclaration(215 /* NewExpression */ );
            node.expression = parenthesizerRules().parenthesizeExpressionOfNew(expression);
            node.typeArguments = asNodeArray(typeArguments);
            node.arguments = argumentsArray ? parenthesizerRules().parenthesizeExpressionsOfCommaDelimitedList(argumentsArray) : void 0;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildrenFlags(node.typeArguments) | propagateChildrenFlags(node.arguments) | 32 /* ContainsES2020 */ ;
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateNewExpression(node, expression, typeArguments, argumentsArray) {
            return node.expression !== expression || node.typeArguments !== typeArguments || node.arguments !== argumentsArray ? update(createNewExpression(expression, typeArguments, argumentsArray), node) : node;
        }
        function createTaggedTemplateExpression(tag, typeArguments, template) {
            const node = createBaseNode(216 /* TaggedTemplateExpression */ );
            node.tag = parenthesizerRules().parenthesizeLeftSideOfAccess(tag, /*optionalChain*/ false);
            node.typeArguments = asNodeArray(typeArguments);
            node.template = template;
            node.transformFlags |= propagateChildFlags(node.tag) | propagateChildrenFlags(node.typeArguments) | propagateChildFlags(node.template) | 1024 /* ContainsES2015 */ ;
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            if (hasInvalidEscape(node.template)) node.transformFlags |= 128 /* ContainsES2018 */ ;
            return node;
        }
        function updateTaggedTemplateExpression(node, tag, typeArguments, template) {
            return node.tag !== tag || node.typeArguments !== typeArguments || node.template !== template ? update(createTaggedTemplateExpression(tag, typeArguments, template), node) : node;
        }
        function createTypeAssertion(type, expression) {
            const node = createBaseNode(217 /* TypeAssertionExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.type = type;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.type) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateTypeAssertion(node, type, expression) {
            return node.type !== type || node.expression !== expression ? update(createTypeAssertion(type, expression), node) : node;
        }
        function createParenthesizedExpression(expression) {
            const node = createBaseNode(218 /* ParenthesizedExpression */ );
            node.expression = expression;
            node.transformFlags = propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            return node;
        }
        function updateParenthesizedExpression(node, expression) {
            return node.expression !== expression ? update(createParenthesizedExpression(expression), node) : node;
        }
        function createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            const node = createBaseDeclaration(219 /* FunctionExpression */ );
            node.modifiers = asNodeArray(modifiers);
            node.asteriskToken = asteriskToken;
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            const isAsync = modifiersToFlags(node.modifiers) & 1024 /* Async */ ;
            const isGenerator = !!node.asteriskToken;
            const isAsyncGenerator = isAsync && isGenerator;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.asteriskToken) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (isAsyncGenerator ? 128 /* ContainsES2018 */  : isAsync ? 256 /* ContainsES2017 */  : isGenerator ? 2048 /* ContainsGenerator */  : 0 /* None */ ) | (node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateFunctionExpression(node, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            return node.name !== name || node.modifiers !== modifiers || node.asteriskToken !== asteriskToken || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateBaseSignatureDeclaration(createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body), node) : node;
        }
        function createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body) {
            const node = createBaseDeclaration(220 /* ArrowFunction */ );
            node.modifiers = asNodeArray(modifiers);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.equalsGreaterThanToken = equalsGreaterThanToken !== null && equalsGreaterThanToken !== void 0 ? equalsGreaterThanToken : createToken(39 /* EqualsGreaterThanToken */ );
            node.body = parenthesizerRules().parenthesizeConciseBodyOfArrowFunction(body);
            const isAsync = modifiersToFlags(node.modifiers) & 1024 /* Async */ ;
            node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.equalsGreaterThanToken) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | (isAsync ? 16640 /* ContainsLexicalThis */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateArrowFunction(node, modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body) {
            return node.modifiers !== modifiers || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.equalsGreaterThanToken !== equalsGreaterThanToken || node.body !== body ? finishUpdateBaseSignatureDeclaration(createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body), node) : node;
        }
        function createDeleteExpression(expression) {
            const node = createBaseNode(221 /* DeleteExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            return node;
        }
        function updateDeleteExpression(node, expression) {
            return node.expression !== expression ? update(createDeleteExpression(expression), node) : node;
        }
        function createTypeOfExpression(expression) {
            const node = createBaseNode(222 /* TypeOfExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            return node;
        }
        function updateTypeOfExpression(node, expression) {
            return node.expression !== expression ? update(createTypeOfExpression(expression), node) : node;
        }
        function createVoidExpression(expression) {
            const node = createBaseNode(223 /* VoidExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            return node;
        }
        function updateVoidExpression(node, expression) {
            return node.expression !== expression ? update(createVoidExpression(expression), node) : node;
        }
        function createAwaitExpression(expression) {
            const node = createBaseNode(224 /* AwaitExpression */ );
            node.expression = parenthesizerRules().parenthesizeOperandOfPrefixUnary(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 2097536 /* ContainsAwait */ ;
            return node;
        }
        function updateAwaitExpression(node, expression) {
            return node.expression !== expression ? update(createAwaitExpression(expression), node) : node;
        }
        function createPrefixUnaryExpression(operator, operand) {
            const node = createBaseNode(225 /* PrefixUnaryExpression */ );
            node.operator = operator;
            node.operand = parenthesizerRules().parenthesizeOperandOfPrefixUnary(operand);
            node.transformFlags |= propagateChildFlags(node.operand);
            if ((operator === 46 /* PlusPlusToken */  || operator === 47 /* MinusMinusToken */ ) && isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand)) node.transformFlags |= 268435456 /* ContainsUpdateExpressionForIdentifier */ ;
            return node;
        }
        function updatePrefixUnaryExpression(node, operand) {
            return node.operand !== operand ? update(createPrefixUnaryExpression(node.operator, operand), node) : node;
        }
        function createPostfixUnaryExpression(operand, operator) {
            const node = createBaseNode(226 /* PostfixUnaryExpression */ );
            node.operator = operator;
            node.operand = parenthesizerRules().parenthesizeOperandOfPostfixUnary(operand);
            node.transformFlags |= propagateChildFlags(node.operand);
            if (isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand)) node.transformFlags |= 268435456 /* ContainsUpdateExpressionForIdentifier */ ;
            return node;
        }
        function updatePostfixUnaryExpression(node, operand) {
            return node.operand !== operand ? update(createPostfixUnaryExpression(operand, node.operator), node) : node;
        }
        function createBinaryExpression(left, operator, right) {
            const node = createBaseDeclaration(227 /* BinaryExpression */ );
            const operatorToken = asToken(operator);
            const operatorKind = operatorToken.kind;
            node.left = parenthesizerRules().parenthesizeLeftSideOfBinary(operatorKind, left);
            node.operatorToken = operatorToken;
            node.right = parenthesizerRules().parenthesizeRightSideOfBinary(operatorKind, node.left, right);
            node.transformFlags |= propagateChildFlags(node.left) | propagateChildFlags(node.operatorToken) | propagateChildFlags(node.right);
            if (operatorKind === 61 /* QuestionQuestionToken */ ) node.transformFlags |= 32 /* ContainsES2020 */ ;
            else if (operatorKind === 64 /* EqualsToken */ ) {
                if (isObjectLiteralExpression(node.left)) node.transformFlags |= 5248 /* ContainsDestructuringAssignment */  | propagateAssignmentPatternFlags(node.left);
                else if (isArrayLiteralExpression(node.left)) node.transformFlags |= 5120 /* ContainsDestructuringAssignment */  | propagateAssignmentPatternFlags(node.left);
            } else if (operatorKind === 43 /* AsteriskAsteriskToken */  || operatorKind === 68 /* AsteriskAsteriskEqualsToken */ ) node.transformFlags |= 512 /* ContainsES2016 */ ;
            else if (isLogicalOrCoalescingAssignmentOperator(operatorKind)) node.transformFlags |= 16 /* ContainsES2021 */ ;
            if (operatorKind === 103 /* InKeyword */  && isPrivateIdentifier(node.left)) node.transformFlags |= 536870912 /* ContainsPrivateIdentifierInExpression */ ;
            node.jsDoc = void 0;
            return node;
        }
        function propagateAssignmentPatternFlags(node) {
            return containsObjectRestOrSpread(node) ? 65536 /* ContainsObjectRestOrSpread */  : 0 /* None */ ;
        }
        function updateBinaryExpression(node, left, operator, right) {
            return node.left !== left || node.operatorToken !== operator || node.right !== right ? update(createBinaryExpression(left, operator, right), node) : node;
        }
        function createConditionalExpression(condition, questionToken, whenTrue, colonToken, whenFalse) {
            const node = createBaseNode(228 /* ConditionalExpression */ );
            node.condition = parenthesizerRules().parenthesizeConditionOfConditionalExpression(condition);
            node.questionToken = questionToken !== null && questionToken !== void 0 ? questionToken : createToken(58 /* QuestionToken */ );
            node.whenTrue = parenthesizerRules().parenthesizeBranchOfConditionalExpression(whenTrue);
            node.colonToken = colonToken !== null && colonToken !== void 0 ? colonToken : createToken(59 /* ColonToken */ );
            node.whenFalse = parenthesizerRules().parenthesizeBranchOfConditionalExpression(whenFalse);
            node.transformFlags |= propagateChildFlags(node.condition) | propagateChildFlags(node.questionToken) | propagateChildFlags(node.whenTrue) | propagateChildFlags(node.colonToken) | propagateChildFlags(node.whenFalse);
            node.flowNodeWhenFalse = void 0;
            node.flowNodeWhenTrue = void 0;
            return node;
        }
        function updateConditionalExpression(node, condition, questionToken, whenTrue, colonToken, whenFalse) {
            return node.condition !== condition || node.questionToken !== questionToken || node.whenTrue !== whenTrue || node.colonToken !== colonToken || node.whenFalse !== whenFalse ? update(createConditionalExpression(condition, questionToken, whenTrue, colonToken, whenFalse), node) : node;
        }
        function createTemplateExpression(head, templateSpans) {
            const node = createBaseNode(229 /* TemplateExpression */ );
            node.head = head;
            node.templateSpans = createNodeArray(templateSpans);
            node.transformFlags |= propagateChildFlags(node.head) | propagateChildrenFlags(node.templateSpans) | 1024 /* ContainsES2015 */ ;
            return node;
        }
        function updateTemplateExpression(node, head, templateSpans) {
            return node.head !== head || node.templateSpans !== templateSpans ? update(createTemplateExpression(head, templateSpans), node) : node;
        }
        function checkTemplateLiteralLikeNode(kind, text, rawText, templateFlags = 0 /* None */ ) {
            Debug.assert(!(templateFlags & -7177 /* TemplateLiteralLikeFlags */ ), "Unsupported template flags.");
            let cooked = void 0;
            if (rawText !== void 0 && rawText !== text) {
                cooked = getCookedText(kind, rawText);
                if (typeof cooked === "object") return Debug.fail("Invalid raw text");
            }
            if (text === void 0) {
                if (cooked === void 0) return Debug.fail("Arguments 'text' and 'rawText' may not both be undefined.");
                text = cooked;
            } else if (cooked !== void 0) Debug.assert(text === cooked, "Expected argument 'text' to be the normalized (i.e. 'cooked') version of argument 'rawText'.");
            return text;
        }
        function getTransformFlagsOfTemplateLiteralLike(templateFlags) {
            let transformFlags = 1024 /* ContainsES2015 */ ;
            if (templateFlags) transformFlags |= 128 /* ContainsES2018 */ ;
            return transformFlags;
        }
        function createTemplateLiteralLikeToken(kind, text, rawText, templateFlags) {
            const node = createBaseToken(kind);
            node.text = text;
            node.rawText = rawText;
            node.templateFlags = templateFlags & 7176 /* TemplateLiteralLikeFlags */ ;
            node.transformFlags = getTransformFlagsOfTemplateLiteralLike(node.templateFlags);
            return node;
        }
        function createTemplateLiteralLikeDeclaration(kind, text, rawText, templateFlags) {
            const node = createBaseDeclaration(kind);
            node.text = text;
            node.rawText = rawText;
            node.templateFlags = templateFlags & 7176 /* TemplateLiteralLikeFlags */ ;
            node.transformFlags = getTransformFlagsOfTemplateLiteralLike(node.templateFlags);
            return node;
        }
        function createTemplateLiteralLikeNode(kind, text, rawText, templateFlags) {
            if (kind === 15 /* NoSubstitutionTemplateLiteral */ ) return createTemplateLiteralLikeDeclaration(kind, text, rawText, templateFlags);
            return createTemplateLiteralLikeToken(kind, text, rawText, templateFlags);
        }
        function createTemplateHead(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
        }
        function createTemplateMiddle(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeNode(17 /* TemplateMiddle */ , text, rawText, templateFlags);
        }
        function createTemplateTail(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeNode(18 /* TemplateTail */ , text, rawText, templateFlags);
        }
        function createNoSubstitutionTemplateLiteral(text, rawText, templateFlags) {
            text = checkTemplateLiteralLikeNode(16 /* TemplateHead */ , text, rawText, templateFlags);
            return createTemplateLiteralLikeDeclaration(15 /* NoSubstitutionTemplateLiteral */ , text, rawText, templateFlags);
        }
        function createYieldExpression(asteriskToken, expression) {
            Debug.assert(!asteriskToken || !!expression, "A `YieldExpression` with an asteriskToken must have an expression.");
            const node = createBaseNode(230 /* YieldExpression */ );
            node.expression = expression && parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.asteriskToken = asteriskToken;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.asteriskToken) | 1049728 /* ContainsYield */ ;
            return node;
        }
        function updateYieldExpression(node, asteriskToken, expression) {
            return node.expression !== expression || node.asteriskToken !== asteriskToken ? update(createYieldExpression(asteriskToken, expression), node) : node;
        }
        function createSpreadElement(expression) {
            const node = createBaseNode(231 /* SpreadElement */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 33792 /* ContainsRestOrSpread */ ;
            return node;
        }
        function updateSpreadElement(node, expression) {
            return node.expression !== expression ? update(createSpreadElement(expression), node) : node;
        }
        function createClassExpression(modifiers, name, typeParameters, heritageClauses, members) {
            const node = createBaseDeclaration(232 /* ClassExpression */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.heritageClauses = asNodeArray(heritageClauses);
            node.members = createNodeArray(members);
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.heritageClauses) | propagateChildrenFlags(node.members) | (node.typeParameters ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateClassExpression(node, modifiers, name, typeParameters, heritageClauses, members) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.heritageClauses !== heritageClauses || node.members !== members ? update(createClassExpression(modifiers, name, typeParameters, heritageClauses, members), node) : node;
        }
        function createOmittedExpression() {
            return createBaseNode(233 /* OmittedExpression */ );
        }
        function createExpressionWithTypeArguments(expression, typeArguments) {
            const node = createBaseNode(234 /* ExpressionWithTypeArguments */ );
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            node.typeArguments = typeArguments && parenthesizerRules().parenthesizeTypeArguments(typeArguments);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildrenFlags(node.typeArguments) | 1024 /* ContainsES2015 */ ;
            return node;
        }
        function updateExpressionWithTypeArguments(node, expression, typeArguments) {
            return node.expression !== expression || node.typeArguments !== typeArguments ? update(createExpressionWithTypeArguments(expression, typeArguments), node) : node;
        }
        function createAsExpression(expression, type) {
            const node = createBaseNode(235 /* AsExpression */ );
            node.expression = expression;
            node.type = type;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.type) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateAsExpression(node, expression, type) {
            return node.expression !== expression || node.type !== type ? update(createAsExpression(expression, type), node) : node;
        }
        function createNonNullExpression(expression) {
            const node = createBaseNode(236 /* NonNullExpression */ );
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            node.transformFlags |= propagateChildFlags(node.expression) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateNonNullExpression(node, expression) {
            if (isNonNullChain(node)) return updateNonNullChain(node, expression);
            return node.expression !== expression ? update(createNonNullExpression(expression), node) : node;
        }
        function createSatisfiesExpression(expression, type) {
            const node = createBaseNode(239 /* SatisfiesExpression */ );
            node.expression = expression;
            node.type = type;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.type) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateSatisfiesExpression(node, expression, type) {
            return node.expression !== expression || node.type !== type ? update(createSatisfiesExpression(expression, type), node) : node;
        }
        function createNonNullChain(expression) {
            const node = createBaseNode(236 /* NonNullExpression */ );
            node.flags |= 64 /* OptionalChain */ ;
            node.expression = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ true);
            node.transformFlags |= propagateChildFlags(node.expression) | 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateNonNullChain(node, expression) {
            Debug.assert(!!(node.flags & 64 /* OptionalChain */ ), "Cannot update a NonNullExpression using updateNonNullChain. Use updateNonNullExpression instead.");
            return node.expression !== expression ? update(createNonNullChain(expression), node) : node;
        }
        function createMetaProperty(keywordToken, name) {
            const node = createBaseNode(237 /* MetaProperty */ );
            node.keywordToken = keywordToken;
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.name);
            switch(keywordToken){
                case 105 /* NewKeyword */ :
                    node.transformFlags |= 1024 /* ContainsES2015 */ ;
                    break;
                case 102 /* ImportKeyword */ :
                    node.transformFlags |= 32 /* ContainsES2020 */ ;
                    break;
                default:
                    return Debug.assertNever(keywordToken);
            }
            node.flowNode = void 0;
            return node;
        }
        function updateMetaProperty(node, name) {
            return node.name !== name ? update(createMetaProperty(node.keywordToken, name), node) : node;
        }
        function createTemplateSpan(expression, literal) {
            const node = createBaseNode(240 /* TemplateSpan */ );
            node.expression = expression;
            node.literal = literal;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.literal) | 1024 /* ContainsES2015 */ ;
            return node;
        }
        function updateTemplateSpan(node, expression, literal) {
            return node.expression !== expression || node.literal !== literal ? update(createTemplateSpan(expression, literal), node) : node;
        }
        function createSemicolonClassElement() {
            const node = createBaseNode(241 /* SemicolonClassElement */ );
            node.transformFlags |= 1024 /* ContainsES2015 */ ;
            return node;
        }
        function createBlock(statements, multiLine) {
            const node = createBaseNode(242 /* Block */ );
            node.statements = createNodeArray(statements);
            node.multiLine = multiLine;
            node.transformFlags |= propagateChildrenFlags(node.statements);
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateBlock(node, statements) {
            return node.statements !== statements ? update(createBlock(statements, node.multiLine), node) : node;
        }
        function createVariableStatement(modifiers, declarationList) {
            const node = createBaseNode(244 /* VariableStatement */ );
            node.modifiers = asNodeArray(modifiers);
            node.declarationList = isArray(declarationList) ? createVariableDeclarationList(declarationList) : declarationList;
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.declarationList);
            if (modifiersToFlags(node.modifiers) & 128 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateVariableStatement(node, modifiers, declarationList) {
            return node.modifiers !== modifiers || node.declarationList !== declarationList ? update(createVariableStatement(modifiers, declarationList), node) : node;
        }
        function createEmptyStatement() {
            const node = createBaseNode(243 /* EmptyStatement */ );
            node.jsDoc = void 0;
            return node;
        }
        function createExpressionStatement(expression) {
            const node = createBaseNode(245 /* ExpressionStatement */ );
            node.expression = parenthesizerRules().parenthesizeExpressionOfExpressionStatement(expression);
            node.transformFlags |= propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateExpressionStatement(node, expression) {
            return node.expression !== expression ? update(createExpressionStatement(expression), node) : node;
        }
        function createIfStatement(expression, thenStatement, elseStatement) {
            const node = createBaseNode(246 /* IfStatement */ );
            node.expression = expression;
            node.thenStatement = asEmbeddedStatement(thenStatement);
            node.elseStatement = asEmbeddedStatement(elseStatement);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.thenStatement) | propagateChildFlags(node.elseStatement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateIfStatement(node, expression, thenStatement, elseStatement) {
            return node.expression !== expression || node.thenStatement !== thenStatement || node.elseStatement !== elseStatement ? update(createIfStatement(expression, thenStatement, elseStatement), node) : node;
        }
        function createDoStatement(statement, expression) {
            const node = createBaseNode(247 /* DoStatement */ );
            node.statement = asEmbeddedStatement(statement);
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.statement) | propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateDoStatement(node, statement, expression) {
            return node.statement !== statement || node.expression !== expression ? update(createDoStatement(statement, expression), node) : node;
        }
        function createWhileStatement(expression, statement) {
            const node = createBaseNode(248 /* WhileStatement */ );
            node.expression = expression;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateWhileStatement(node, expression, statement) {
            return node.expression !== expression || node.statement !== statement ? update(createWhileStatement(expression, statement), node) : node;
        }
        function createForStatement(initializer, condition, incrementor, statement) {
            const node = createBaseNode(249 /* ForStatement */ );
            node.initializer = initializer;
            node.condition = condition;
            node.incrementor = incrementor;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.initializer) | propagateChildFlags(node.condition) | propagateChildFlags(node.incrementor) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateForStatement(node, initializer, condition, incrementor, statement) {
            return node.initializer !== initializer || node.condition !== condition || node.incrementor !== incrementor || node.statement !== statement ? update(createForStatement(initializer, condition, incrementor, statement), node) : node;
        }
        function createForInStatement(initializer, expression, statement) {
            const node = createBaseNode(250 /* ForInStatement */ );
            node.initializer = initializer;
            node.expression = expression;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.initializer) | propagateChildFlags(node.expression) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateForInStatement(node, initializer, expression, statement) {
            return node.initializer !== initializer || node.expression !== expression || node.statement !== statement ? update(createForInStatement(initializer, expression, statement), node) : node;
        }
        function createForOfStatement(awaitModifier, initializer, expression, statement) {
            const node = createBaseNode(251 /* ForOfStatement */ );
            node.awaitModifier = awaitModifier;
            node.initializer = initializer;
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.awaitModifier) | propagateChildFlags(node.initializer) | propagateChildFlags(node.expression) | propagateChildFlags(node.statement) | 1024 /* ContainsES2015 */ ;
            if (awaitModifier) node.transformFlags |= 128 /* ContainsES2018 */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateForOfStatement(node, awaitModifier, initializer, expression, statement) {
            return node.awaitModifier !== awaitModifier || node.initializer !== initializer || node.expression !== expression || node.statement !== statement ? update(createForOfStatement(awaitModifier, initializer, expression, statement), node) : node;
        }
        function createContinueStatement(label) {
            const node = createBaseNode(252 /* ContinueStatement */ );
            node.label = asName(label);
            node.transformFlags |= propagateChildFlags(node.label) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateContinueStatement(node, label) {
            return node.label !== label ? update(createContinueStatement(label), node) : node;
        }
        function createBreakStatement(label) {
            const node = createBaseNode(253 /* BreakStatement */ );
            node.label = asName(label);
            node.transformFlags |= propagateChildFlags(node.label) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateBreakStatement(node, label) {
            return node.label !== label ? update(createBreakStatement(label), node) : node;
        }
        function createReturnStatement(expression) {
            const node = createBaseNode(254 /* ReturnStatement */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression) | 4194432 /* ContainsHoistedDeclarationOrCompletion */ ;
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateReturnStatement(node, expression) {
            return node.expression !== expression ? update(createReturnStatement(expression), node) : node;
        }
        function createWithStatement(expression, statement) {
            const node = createBaseNode(255 /* WithStatement */ );
            node.expression = expression;
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateWithStatement(node, expression, statement) {
            return node.expression !== expression || node.statement !== statement ? update(createWithStatement(expression, statement), node) : node;
        }
        function createSwitchStatement(expression, caseBlock) {
            const node = createBaseNode(256 /* SwitchStatement */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.caseBlock = caseBlock;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.caseBlock);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            node.possiblyExhaustive = false;
            return node;
        }
        function updateSwitchStatement(node, expression, caseBlock) {
            return node.expression !== expression || node.caseBlock !== caseBlock ? update(createSwitchStatement(expression, caseBlock), node) : node;
        }
        function createLabeledStatement(label, statement) {
            const node = createBaseNode(257 /* LabeledStatement */ );
            node.label = asName(label);
            node.statement = asEmbeddedStatement(statement);
            node.transformFlags |= propagateChildFlags(node.label) | propagateChildFlags(node.statement);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateLabeledStatement(node, label, statement) {
            return node.label !== label || node.statement !== statement ? update(createLabeledStatement(label, statement), node) : node;
        }
        function createThrowStatement(expression) {
            const node = createBaseNode(258 /* ThrowStatement */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateThrowStatement(node, expression) {
            return node.expression !== expression ? update(createThrowStatement(expression), node) : node;
        }
        function createTryStatement(tryBlock, catchClause, finallyBlock) {
            const node = createBaseNode(259 /* TryStatement */ );
            node.tryBlock = tryBlock;
            node.catchClause = catchClause;
            node.finallyBlock = finallyBlock;
            node.transformFlags |= propagateChildFlags(node.tryBlock) | propagateChildFlags(node.catchClause) | propagateChildFlags(node.finallyBlock);
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function updateTryStatement(node, tryBlock, catchClause, finallyBlock) {
            return node.tryBlock !== tryBlock || node.catchClause !== catchClause || node.finallyBlock !== finallyBlock ? update(createTryStatement(tryBlock, catchClause, finallyBlock), node) : node;
        }
        function createDebuggerStatement() {
            const node = createBaseNode(260 /* DebuggerStatement */ );
            node.jsDoc = void 0;
            node.flowNode = void 0;
            return node;
        }
        function createVariableDeclaration(name, exclamationToken, type, initializer) {
            const node = createBaseDeclaration(261 /* VariableDeclaration */ );
            node.name = asName(name);
            node.exclamationToken = exclamationToken;
            node.type = type;
            node.initializer = asInitializer(initializer);
            var _node_exclamationToken;
            node.transformFlags |= propagateNameFlags(node.name) | propagateChildFlags(node.initializer) | (((_node_exclamationToken = node.exclamationToken) !== null && _node_exclamationToken !== void 0 ? _node_exclamationToken : node.type) ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.jsDoc = void 0;
            return node;
        }
        function updateVariableDeclaration(node, name, exclamationToken, type, initializer) {
            return node.name !== name || node.type !== type || node.exclamationToken !== exclamationToken || node.initializer !== initializer ? update(createVariableDeclaration(name, exclamationToken, type, initializer), node) : node;
        }
        function createVariableDeclarationList(declarations, flags2 = 0 /* None */ ) {
            const node = createBaseNode(262 /* VariableDeclarationList */ );
            node.flags |= flags2 & 7 /* BlockScoped */ ;
            node.declarations = createNodeArray(declarations);
            node.transformFlags |= propagateChildrenFlags(node.declarations) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            if (flags2 & 7 /* BlockScoped */ ) node.transformFlags |= 263168 /* ContainsBlockScopedBinding */ ;
            if (flags2 & 4 /* Using */ ) node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateVariableDeclarationList(node, declarations) {
            return node.declarations !== declarations ? update(createVariableDeclarationList(declarations, node.flags), node) : node;
        }
        function createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            const node = createBaseDeclaration(263 /* FunctionDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.asteriskToken = asteriskToken;
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.body = body;
            if (!node.body || modifiersToFlags(node.modifiers) & 128 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else {
                const isAsync = modifiersToFlags(node.modifiers) & 1024 /* Async */ ;
                const isGenerator = !!node.asteriskToken;
                const isAsyncGenerator = isAsync && isGenerator;
                node.transformFlags = propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.asteriskToken) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.parameters) | propagateChildFlags(node.type) | propagateChildFlags(node.body) & -67108865 /* ContainsPossibleTopLevelAwait */  | (isAsyncGenerator ? 128 /* ContainsES2018 */  : isAsync ? 256 /* ContainsES2017 */  : isGenerator ? 2048 /* ContainsGenerator */  : 0 /* None */ ) | (node.typeParameters || node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 4194304 /* ContainsHoistedDeclarationOrCompletion */ ;
            }
            node.typeArguments = void 0;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.returnFlowNode = void 0;
            return node;
        }
        function updateFunctionDeclaration(node, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
            return node.modifiers !== modifiers || node.asteriskToken !== asteriskToken || node.name !== name || node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type || node.body !== body ? finishUpdateFunctionDeclaration(createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, body), node) : node;
        }
        function finishUpdateFunctionDeclaration(updated, original) {
            if (updated !== original) {
                if (updated.modifiers === original.modifiers) updated.modifiers = original.modifiers;
            }
            return finishUpdateBaseSignatureDeclaration(updated, original);
        }
        function createClassDeclaration(modifiers, name, typeParameters, heritageClauses, members) {
            const node = createBaseDeclaration(264 /* ClassDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.heritageClauses = asNodeArray(heritageClauses);
            node.members = createNodeArray(members);
            if (modifiersToFlags(node.modifiers) & 128 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else {
                node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateNameFlags(node.name) | propagateChildrenFlags(node.typeParameters) | propagateChildrenFlags(node.heritageClauses) | propagateChildrenFlags(node.members) | (node.typeParameters ? 1 /* ContainsTypeScript */  : 0 /* None */ ) | 1024 /* ContainsES2015 */ ;
                if (node.transformFlags & 8192 /* ContainsTypeScriptClassSyntax */ ) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            }
            node.jsDoc = void 0;
            return node;
        }
        function updateClassDeclaration(node, modifiers, name, typeParameters, heritageClauses, members) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.heritageClauses !== heritageClauses || node.members !== members ? update(createClassDeclaration(modifiers, name, typeParameters, heritageClauses, members), node) : node;
        }
        function createInterfaceDeclaration(modifiers, name, typeParameters, heritageClauses, members) {
            const node = createBaseDeclaration(265 /* InterfaceDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.heritageClauses = asNodeArray(heritageClauses);
            node.members = createNodeArray(members);
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateInterfaceDeclaration(node, modifiers, name, typeParameters, heritageClauses, members) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.heritageClauses !== heritageClauses || node.members !== members ? update(createInterfaceDeclaration(modifiers, name, typeParameters, heritageClauses, members), node) : node;
        }
        function createTypeAliasDeclaration(modifiers, name, typeParameters, type) {
            const node = createBaseDeclaration(266 /* TypeAliasDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.typeParameters = asNodeArray(typeParameters);
            node.type = type;
            node.transformFlags = 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateTypeAliasDeclaration(node, modifiers, name, typeParameters, type) {
            return node.modifiers !== modifiers || node.name !== name || node.typeParameters !== typeParameters || node.type !== type ? update(createTypeAliasDeclaration(modifiers, name, typeParameters, type), node) : node;
        }
        function createEnumDeclaration(modifiers, name, members) {
            const node = createBaseDeclaration(267 /* EnumDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.members = createNodeArray(members);
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.name) | propagateChildrenFlags(node.members) | 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateEnumDeclaration(node, modifiers, name, members) {
            return node.modifiers !== modifiers || node.name !== name || node.members !== members ? update(createEnumDeclaration(modifiers, name, members), node) : node;
        }
        function createModuleDeclaration(modifiers, name, body, flags2 = 0 /* None */ ) {
            const node = createBaseDeclaration(268 /* ModuleDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.flags |= flags2 & 2088 /* GlobalAugmentation */ ;
            node.name = name;
            node.body = body;
            if (modifiersToFlags(node.modifiers) & 128 /* Ambient */ ) node.transformFlags = 1 /* ContainsTypeScript */ ;
            else node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.name) | propagateChildFlags(node.body) | 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateModuleDeclaration(node, modifiers, name, body) {
            return node.modifiers !== modifiers || node.name !== name || node.body !== body ? update(createModuleDeclaration(modifiers, name, body, node.flags), node) : node;
        }
        function createModuleBlock(statements) {
            const node = createBaseNode(269 /* ModuleBlock */ );
            node.statements = createNodeArray(statements);
            node.transformFlags |= propagateChildrenFlags(node.statements);
            node.jsDoc = void 0;
            return node;
        }
        function updateModuleBlock(node, statements) {
            return node.statements !== statements ? update(createModuleBlock(statements), node) : node;
        }
        function createCaseBlock(clauses) {
            const node = createBaseNode(270 /* CaseBlock */ );
            node.clauses = createNodeArray(clauses);
            node.transformFlags |= propagateChildrenFlags(node.clauses);
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateCaseBlock(node, clauses) {
            return node.clauses !== clauses ? update(createCaseBlock(clauses), node) : node;
        }
        function createNamespaceExportDeclaration(name) {
            const node = createBaseDeclaration(271 /* NamespaceExportDeclaration */ );
            node.name = asName(name);
            node.transformFlags |= propagateIdentifierNameFlags(node.name) | 1 /* ContainsTypeScript */ ;
            node.modifiers = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updateNamespaceExportDeclaration(node, name) {
            return node.name !== name ? finishUpdateNamespaceExportDeclaration(createNamespaceExportDeclaration(name), node) : node;
        }
        function finishUpdateNamespaceExportDeclaration(updated, original) {
            if (updated !== original) updated.modifiers = original.modifiers;
            return update(updated, original);
        }
        function createImportEqualsDeclaration(modifiers, isTypeOnly, name, moduleReference) {
            const node = createBaseDeclaration(272 /* ImportEqualsDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.name = asName(name);
            node.isTypeOnly = isTypeOnly;
            node.moduleReference = moduleReference;
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateIdentifierNameFlags(node.name) | propagateChildFlags(node.moduleReference);
            if (!isExternalModuleReference(node.moduleReference)) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateImportEqualsDeclaration(node, modifiers, isTypeOnly, name, moduleReference) {
            return node.modifiers !== modifiers || node.isTypeOnly !== isTypeOnly || node.name !== name || node.moduleReference !== moduleReference ? update(createImportEqualsDeclaration(modifiers, isTypeOnly, name, moduleReference), node) : node;
        }
        function createImportDeclaration(modifiers, importClause, moduleSpecifier, attributes) {
            const node = createBaseNode(273 /* ImportDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.importClause = importClause;
            node.moduleSpecifier = moduleSpecifier;
            node.attributes = node.assertClause = attributes;
            node.transformFlags |= propagateChildFlags(node.importClause) | propagateChildFlags(node.moduleSpecifier);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateImportDeclaration(node, modifiers, importClause, moduleSpecifier, attributes) {
            return node.modifiers !== modifiers || node.importClause !== importClause || node.moduleSpecifier !== moduleSpecifier || node.attributes !== attributes ? update(createImportDeclaration(modifiers, importClause, moduleSpecifier, attributes), node) : node;
        }
        function createImportClause2(phaseModifier, name, namedBindings) {
            const node = createBaseDeclaration(274 /* ImportClause */ );
            if (typeof phaseModifier === "boolean") phaseModifier = phaseModifier ? 156 /* TypeKeyword */  : void 0;
            node.isTypeOnly = phaseModifier === 156 /* TypeKeyword */ ;
            node.phaseModifier = phaseModifier;
            node.name = name;
            node.namedBindings = namedBindings;
            node.transformFlags |= propagateChildFlags(node.name) | propagateChildFlags(node.namedBindings);
            if (phaseModifier === 156 /* TypeKeyword */ ) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateImportClause(node, phaseModifier, name, namedBindings) {
            if (typeof phaseModifier === "boolean") phaseModifier = phaseModifier ? 156 /* TypeKeyword */  : void 0;
            return node.phaseModifier !== phaseModifier || node.name !== name || node.namedBindings !== namedBindings ? update(createImportClause2(phaseModifier, name, namedBindings), node) : node;
        }
        function createAssertClause(elements, multiLine) {
            const node = createBaseNode(301 /* AssertClause */ );
            node.elements = createNodeArray(elements);
            node.multiLine = multiLine;
            node.token = 132 /* AssertKeyword */ ;
            node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateAssertClause(node, elements, multiLine) {
            return node.elements !== elements || node.multiLine !== multiLine ? update(createAssertClause(elements, multiLine), node) : node;
        }
        function createAssertEntry(name, value1) {
            const node = createBaseNode(302 /* AssertEntry */ );
            node.name = name;
            node.value = value1;
            node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateAssertEntry(node, name, value1) {
            return node.name !== name || node.value !== value1 ? update(createAssertEntry(name, value1), node) : node;
        }
        function createImportTypeAssertionContainer(clause, multiLine) {
            const node = createBaseNode(303 /* ImportTypeAssertionContainer */ );
            node.assertClause = clause;
            node.multiLine = multiLine;
            return node;
        }
        function updateImportTypeAssertionContainer(node, clause, multiLine) {
            return node.assertClause !== clause || node.multiLine !== multiLine ? update(createImportTypeAssertionContainer(clause, multiLine), node) : node;
        }
        function createImportAttributes(elements, multiLine, token) {
            const node = createBaseNode(301 /* ImportAttributes */ );
            node.token = token !== null && token !== void 0 ? token : 118 /* WithKeyword */ ;
            node.elements = createNodeArray(elements);
            node.multiLine = multiLine;
            node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateImportAttributes(node, elements, multiLine) {
            return node.elements !== elements || node.multiLine !== multiLine ? update(createImportAttributes(elements, multiLine, node.token), node) : node;
        }
        function createImportAttribute(name, value1) {
            const node = createBaseNode(302 /* ImportAttribute */ );
            node.name = name;
            node.value = value1;
            node.transformFlags |= 4 /* ContainsESNext */ ;
            return node;
        }
        function updateImportAttribute(node, name, value1) {
            return node.name !== name || node.value !== value1 ? update(createImportAttribute(name, value1), node) : node;
        }
        function createNamespaceImport(name) {
            const node = createBaseDeclaration(275 /* NamespaceImport */ );
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.name);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamespaceImport(node, name) {
            return node.name !== name ? update(createNamespaceImport(name), node) : node;
        }
        function createNamespaceExport(name) {
            const node = createBaseDeclaration(281 /* NamespaceExport */ );
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.name) | 32 /* ContainsES2020 */ ;
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamespaceExport(node, name) {
            return node.name !== name ? update(createNamespaceExport(name), node) : node;
        }
        function createNamedImports(elements) {
            const node = createBaseNode(276 /* NamedImports */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamedImports(node, elements) {
            return node.elements !== elements ? update(createNamedImports(elements), node) : node;
        }
        function createImportSpecifier(isTypeOnly, propertyName, name) {
            const node = createBaseDeclaration(277 /* ImportSpecifier */ );
            node.isTypeOnly = isTypeOnly;
            node.propertyName = propertyName;
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.propertyName) | propagateChildFlags(node.name);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateImportSpecifier(node, isTypeOnly, propertyName, name) {
            return node.isTypeOnly !== isTypeOnly || node.propertyName !== propertyName || node.name !== name ? update(createImportSpecifier(isTypeOnly, propertyName, name), node) : node;
        }
        function createExportAssignment2(modifiers, isExportEquals, expression) {
            const node = createBaseDeclaration(278 /* ExportAssignment */ );
            node.modifiers = asNodeArray(modifiers);
            node.isExportEquals = isExportEquals;
            node.expression = isExportEquals ? parenthesizerRules().parenthesizeRightSideOfBinary(64 /* EqualsToken */ , /*leftSide*/ void 0, expression) : parenthesizerRules().parenthesizeExpressionOfExportDefault(expression);
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.expression);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateExportAssignment(node, modifiers, expression) {
            return node.modifiers !== modifiers || node.expression !== expression ? update(createExportAssignment2(modifiers, node.isExportEquals, expression), node) : node;
        }
        function createExportDeclaration(modifiers, isTypeOnly, exportClause, moduleSpecifier, attributes) {
            const node = createBaseDeclaration(279 /* ExportDeclaration */ );
            node.modifiers = asNodeArray(modifiers);
            node.isTypeOnly = isTypeOnly;
            node.exportClause = exportClause;
            node.moduleSpecifier = moduleSpecifier;
            node.attributes = node.assertClause = attributes;
            node.transformFlags |= propagateChildrenFlags(node.modifiers) | propagateChildFlags(node.exportClause) | propagateChildFlags(node.moduleSpecifier);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateExportDeclaration(node, modifiers, isTypeOnly, exportClause, moduleSpecifier, attributes) {
            return node.modifiers !== modifiers || node.isTypeOnly !== isTypeOnly || node.exportClause !== exportClause || node.moduleSpecifier !== moduleSpecifier || node.attributes !== attributes ? finishUpdateExportDeclaration(createExportDeclaration(modifiers, isTypeOnly, exportClause, moduleSpecifier, attributes), node) : node;
        }
        function finishUpdateExportDeclaration(updated, original) {
            if (updated !== original) {
                if (updated.modifiers === original.modifiers) updated.modifiers = original.modifiers;
            }
            return update(updated, original);
        }
        function createNamedExports(elements) {
            const node = createBaseNode(280 /* NamedExports */ );
            node.elements = createNodeArray(elements);
            node.transformFlags |= propagateChildrenFlags(node.elements);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateNamedExports(node, elements) {
            return node.elements !== elements ? update(createNamedExports(elements), node) : node;
        }
        function createExportSpecifier(isTypeOnly, propertyName, name) {
            const node = createBaseNode(282 /* ExportSpecifier */ );
            node.isTypeOnly = isTypeOnly;
            node.propertyName = asName(propertyName);
            node.name = asName(name);
            node.transformFlags |= propagateChildFlags(node.propertyName) | propagateChildFlags(node.name);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateExportSpecifier(node, isTypeOnly, propertyName, name) {
            return node.isTypeOnly !== isTypeOnly || node.propertyName !== propertyName || node.name !== name ? update(createExportSpecifier(isTypeOnly, propertyName, name), node) : node;
        }
        function createMissingDeclaration() {
            const node = createBaseDeclaration(283 /* MissingDeclaration */ );
            node.jsDoc = void 0;
            return node;
        }
        function createExternalModuleReference(expression) {
            const node = createBaseNode(284 /* ExternalModuleReference */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression);
            node.transformFlags &= -67108865 /* ContainsPossibleTopLevelAwait */ ;
            return node;
        }
        function updateExternalModuleReference(node, expression) {
            return node.expression !== expression ? update(createExternalModuleReference(expression), node) : node;
        }
        function createJSDocPrimaryTypeWorker(kind) {
            return createBaseNode(kind);
        }
        function createJSDocPrePostfixUnaryTypeWorker(kind, type, postfix = false) {
            const node = createJSDocUnaryTypeWorker(kind, postfix ? type && parenthesizerRules().parenthesizeNonArrayTypeOfPostfixType(type) : type);
            node.postfix = postfix;
            return node;
        }
        function createJSDocUnaryTypeWorker(kind, type) {
            const node = createBaseNode(kind);
            node.type = type;
            return node;
        }
        function updateJSDocPrePostfixUnaryTypeWorker(kind, node, type) {
            return node.type !== type ? update(createJSDocPrePostfixUnaryTypeWorker(kind, type, node.postfix), node) : node;
        }
        function updateJSDocUnaryTypeWorker(kind, node, type) {
            return node.type !== type ? update(createJSDocUnaryTypeWorker(kind, type), node) : node;
        }
        function createJSDocFunctionType(parameters, type) {
            const node = createBaseDeclaration(318 /* JSDocFunctionType */ );
            node.parameters = asNodeArray(parameters);
            node.type = type;
            node.transformFlags = propagateChildrenFlags(node.parameters) | (node.type ? 1 /* ContainsTypeScript */  : 0 /* None */ );
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            node.typeArguments = void 0;
            return node;
        }
        function updateJSDocFunctionType(node, parameters, type) {
            return node.parameters !== parameters || node.type !== type ? update(createJSDocFunctionType(parameters, type), node) : node;
        }
        function createJSDocTypeLiteral(propertyTags, isArrayType = false) {
            const node = createBaseDeclaration(323 /* JSDocTypeLiteral */ );
            node.jsDocPropertyTags = asNodeArray(propertyTags);
            node.isArrayType = isArrayType;
            return node;
        }
        function updateJSDocTypeLiteral(node, propertyTags, isArrayType) {
            return node.jsDocPropertyTags !== propertyTags || node.isArrayType !== isArrayType ? update(createJSDocTypeLiteral(propertyTags, isArrayType), node) : node;
        }
        function createJSDocTypeExpression(type) {
            const node = createBaseNode(310 /* JSDocTypeExpression */ );
            node.type = type;
            return node;
        }
        function updateJSDocTypeExpression(node, type) {
            return node.type !== type ? update(createJSDocTypeExpression(type), node) : node;
        }
        function createJSDocSignature(typeParameters, parameters, type) {
            const node = createBaseDeclaration(324 /* JSDocSignature */ );
            node.typeParameters = asNodeArray(typeParameters);
            node.parameters = createNodeArray(parameters);
            node.type = type;
            node.jsDoc = void 0;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocSignature(node, typeParameters, parameters, type) {
            return node.typeParameters !== typeParameters || node.parameters !== parameters || node.type !== type ? update(createJSDocSignature(typeParameters, parameters, type), node) : node;
        }
        function getDefaultTagName(node) {
            const defaultTagName = getDefaultTagNameForKind(node.kind);
            return node.tagName.escapedText === escapeLeadingUnderscores(defaultTagName) ? node.tagName : createIdentifier(defaultTagName);
        }
        function createBaseJSDocTag(kind, tagName, comment) {
            const node = createBaseNode(kind);
            node.tagName = tagName;
            node.comment = comment;
            return node;
        }
        function createBaseJSDocTagDeclaration(kind, tagName, comment) {
            const node = createBaseDeclaration(kind);
            node.tagName = tagName;
            node.comment = comment;
            return node;
        }
        function createJSDocTemplateTag(tagName, constraint, typeParameters, comment) {
            const node = createBaseJSDocTag(346 /* JSDocTemplateTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("template"), comment);
            node.constraint = constraint;
            node.typeParameters = createNodeArray(typeParameters);
            return node;
        }
        function updateJSDocTemplateTag(node, tagName = getDefaultTagName(node), constraint, typeParameters, comment) {
            return node.tagName !== tagName || node.constraint !== constraint || node.typeParameters !== typeParameters || node.comment !== comment ? update(createJSDocTemplateTag(tagName, constraint, typeParameters, comment), node) : node;
        }
        function createJSDocTypedefTag(tagName, typeExpression, fullName, comment) {
            const node = createBaseJSDocTagDeclaration(347 /* JSDocTypedefTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("typedef"), comment);
            node.typeExpression = typeExpression;
            node.fullName = fullName;
            node.name = getJSDocTypeAliasName(fullName);
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocTypedefTag(node, tagName = getDefaultTagName(node), typeExpression, fullName, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.fullName !== fullName || node.comment !== comment ? update(createJSDocTypedefTag(tagName, typeExpression, fullName, comment), node) : node;
        }
        function createJSDocParameterTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment) {
            const node = createBaseJSDocTagDeclaration(342 /* JSDocParameterTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("param"), comment);
            node.typeExpression = typeExpression;
            node.name = name;
            node.isNameFirst = !!isNameFirst;
            node.isBracketed = isBracketed;
            return node;
        }
        function updateJSDocParameterTag(node, tagName = getDefaultTagName(node), name, isBracketed, typeExpression, isNameFirst, comment) {
            return node.tagName !== tagName || node.name !== name || node.isBracketed !== isBracketed || node.typeExpression !== typeExpression || node.isNameFirst !== isNameFirst || node.comment !== comment ? update(createJSDocParameterTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment), node) : node;
        }
        function createJSDocPropertyTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment) {
            const node = createBaseJSDocTagDeclaration(349 /* JSDocPropertyTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("prop"), comment);
            node.typeExpression = typeExpression;
            node.name = name;
            node.isNameFirst = !!isNameFirst;
            node.isBracketed = isBracketed;
            return node;
        }
        function updateJSDocPropertyTag(node, tagName = getDefaultTagName(node), name, isBracketed, typeExpression, isNameFirst, comment) {
            return node.tagName !== tagName || node.name !== name || node.isBracketed !== isBracketed || node.typeExpression !== typeExpression || node.isNameFirst !== isNameFirst || node.comment !== comment ? update(createJSDocPropertyTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment), node) : node;
        }
        function createJSDocCallbackTag(tagName, typeExpression, fullName, comment) {
            const node = createBaseJSDocTagDeclaration(339 /* JSDocCallbackTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("callback"), comment);
            node.typeExpression = typeExpression;
            node.fullName = fullName;
            node.name = getJSDocTypeAliasName(fullName);
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocCallbackTag(node, tagName = getDefaultTagName(node), typeExpression, fullName, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.fullName !== fullName || node.comment !== comment ? update(createJSDocCallbackTag(tagName, typeExpression, fullName, comment), node) : node;
        }
        function createJSDocOverloadTag(tagName, typeExpression, comment) {
            const node = createBaseJSDocTag(340 /* JSDocOverloadTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("overload"), comment);
            node.typeExpression = typeExpression;
            return node;
        }
        function updateJSDocOverloadTag(node, tagName = getDefaultTagName(node), typeExpression, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.comment !== comment ? update(createJSDocOverloadTag(tagName, typeExpression, comment), node) : node;
        }
        function createJSDocAugmentsTag(tagName, className, comment) {
            const node = createBaseJSDocTag(329 /* JSDocAugmentsTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("augments"), comment);
            node.class = className;
            return node;
        }
        function updateJSDocAugmentsTag(node, tagName = getDefaultTagName(node), className, comment) {
            return node.tagName !== tagName || node.class !== className || node.comment !== comment ? update(createJSDocAugmentsTag(tagName, className, comment), node) : node;
        }
        function createJSDocImplementsTag(tagName, className, comment) {
            const node = createBaseJSDocTag(330 /* JSDocImplementsTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("implements"), comment);
            node.class = className;
            return node;
        }
        function createJSDocSeeTag(tagName, name, comment) {
            const node = createBaseJSDocTag(348 /* JSDocSeeTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("see"), comment);
            node.name = name;
            return node;
        }
        function updateJSDocSeeTag(node, tagName, name, comment) {
            return node.tagName !== tagName || node.name !== name || node.comment !== comment ? update(createJSDocSeeTag(tagName, name, comment), node) : node;
        }
        function createJSDocNameReference(name) {
            const node = createBaseNode(311 /* JSDocNameReference */ );
            node.name = name;
            return node;
        }
        function updateJSDocNameReference(node, name) {
            return node.name !== name ? update(createJSDocNameReference(name), node) : node;
        }
        function createJSDocMemberName(left, right) {
            const node = createBaseNode(312 /* JSDocMemberName */ );
            node.left = left;
            node.right = right;
            node.transformFlags |= propagateChildFlags(node.left) | propagateChildFlags(node.right);
            return node;
        }
        function updateJSDocMemberName(node, left, right) {
            return node.left !== left || node.right !== right ? update(createJSDocMemberName(left, right), node) : node;
        }
        function createJSDocLink(name, text) {
            const node = createBaseNode(325 /* JSDocLink */ );
            node.name = name;
            node.text = text;
            return node;
        }
        function updateJSDocLink(node, name, text) {
            return node.name !== name ? update(createJSDocLink(name, text), node) : node;
        }
        function createJSDocLinkCode(name, text) {
            const node = createBaseNode(326 /* JSDocLinkCode */ );
            node.name = name;
            node.text = text;
            return node;
        }
        function updateJSDocLinkCode(node, name, text) {
            return node.name !== name ? update(createJSDocLinkCode(name, text), node) : node;
        }
        function createJSDocLinkPlain(name, text) {
            const node = createBaseNode(327 /* JSDocLinkPlain */ );
            node.name = name;
            node.text = text;
            return node;
        }
        function updateJSDocLinkPlain(node, name, text) {
            return node.name !== name ? update(createJSDocLinkPlain(name, text), node) : node;
        }
        function updateJSDocImplementsTag(node, tagName = getDefaultTagName(node), className, comment) {
            return node.tagName !== tagName || node.class !== className || node.comment !== comment ? update(createJSDocImplementsTag(tagName, className, comment), node) : node;
        }
        function createJSDocSimpleTagWorker(kind, tagName, comment) {
            const node = createBaseJSDocTag(kind, tagName !== null && tagName !== void 0 ? tagName : createIdentifier(getDefaultTagNameForKind(kind)), comment);
            return node;
        }
        function updateJSDocSimpleTagWorker(kind, node, tagName = getDefaultTagName(node), comment) {
            return node.tagName !== tagName || node.comment !== comment ? update(createJSDocSimpleTagWorker(kind, tagName, comment), node) : node;
        }
        function createJSDocTypeLikeTagWorker(kind, tagName, typeExpression, comment) {
            const node = createBaseJSDocTag(kind, tagName !== null && tagName !== void 0 ? tagName : createIdentifier(getDefaultTagNameForKind(kind)), comment);
            node.typeExpression = typeExpression;
            return node;
        }
        function updateJSDocTypeLikeTagWorker(kind, node, tagName = getDefaultTagName(node), typeExpression, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.comment !== comment ? update(createJSDocTypeLikeTagWorker(kind, tagName, typeExpression, comment), node) : node;
        }
        function createJSDocUnknownTag(tagName, comment) {
            const node = createBaseJSDocTag(328 /* JSDocTag */ , tagName, comment);
            return node;
        }
        function updateJSDocUnknownTag(node, tagName, comment) {
            return node.tagName !== tagName || node.comment !== comment ? update(createJSDocUnknownTag(tagName, comment), node) : node;
        }
        function createJSDocEnumTag(tagName, typeExpression, comment) {
            const node = createBaseJSDocTagDeclaration(341 /* JSDocEnumTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier(getDefaultTagNameForKind(341 /* JSDocEnumTag */ )), comment);
            node.typeExpression = typeExpression;
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateJSDocEnumTag(node, tagName = getDefaultTagName(node), typeExpression, comment) {
            return node.tagName !== tagName || node.typeExpression !== typeExpression || node.comment !== comment ? update(createJSDocEnumTag(tagName, typeExpression, comment), node) : node;
        }
        function createJSDocImportTag(tagName, importClause, moduleSpecifier, attributes, comment) {
            const node = createBaseJSDocTag(352 /* JSDocImportTag */ , tagName !== null && tagName !== void 0 ? tagName : createIdentifier("import"), comment);
            node.importClause = importClause;
            node.moduleSpecifier = moduleSpecifier;
            node.attributes = attributes;
            node.comment = comment;
            return node;
        }
        function updateJSDocImportTag(node, tagName, importClause, moduleSpecifier, attributes, comment) {
            return node.tagName !== tagName || node.comment !== comment || node.importClause !== importClause || node.moduleSpecifier !== moduleSpecifier || node.attributes !== attributes ? update(createJSDocImportTag(tagName, importClause, moduleSpecifier, attributes, comment), node) : node;
        }
        function createJSDocText(text) {
            const node = createBaseNode(322 /* JSDocText */ );
            node.text = text;
            return node;
        }
        function updateJSDocText(node, text) {
            return node.text !== text ? update(createJSDocText(text), node) : node;
        }
        function createJSDocComment(comment, tags) {
            const node = createBaseNode(321 /* JSDoc */ );
            node.comment = comment;
            node.tags = asNodeArray(tags);
            return node;
        }
        function updateJSDocComment(node, comment, tags) {
            return node.comment !== comment || node.tags !== tags ? update(createJSDocComment(comment, tags), node) : node;
        }
        function createJsxElement(openingElement, children, closingElement) {
            const node = createBaseNode(285 /* JsxElement */ );
            node.openingElement = openingElement;
            node.children = createNodeArray(children);
            node.closingElement = closingElement;
            node.transformFlags |= propagateChildFlags(node.openingElement) | propagateChildrenFlags(node.children) | propagateChildFlags(node.closingElement) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxElement(node, openingElement, children, closingElement) {
            return node.openingElement !== openingElement || node.children !== children || node.closingElement !== closingElement ? update(createJsxElement(openingElement, children, closingElement), node) : node;
        }
        function createJsxSelfClosingElement(tagName, typeArguments, attributes) {
            const node = createBaseNode(286 /* JsxSelfClosingElement */ );
            node.tagName = tagName;
            node.typeArguments = asNodeArray(typeArguments);
            node.attributes = attributes;
            node.transformFlags |= propagateChildFlags(node.tagName) | propagateChildrenFlags(node.typeArguments) | propagateChildFlags(node.attributes) | 2 /* ContainsJsx */ ;
            if (node.typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateJsxSelfClosingElement(node, tagName, typeArguments, attributes) {
            return node.tagName !== tagName || node.typeArguments !== typeArguments || node.attributes !== attributes ? update(createJsxSelfClosingElement(tagName, typeArguments, attributes), node) : node;
        }
        function createJsxOpeningElement(tagName, typeArguments, attributes) {
            const node = createBaseNode(287 /* JsxOpeningElement */ );
            node.tagName = tagName;
            node.typeArguments = asNodeArray(typeArguments);
            node.attributes = attributes;
            node.transformFlags |= propagateChildFlags(node.tagName) | propagateChildrenFlags(node.typeArguments) | propagateChildFlags(node.attributes) | 2 /* ContainsJsx */ ;
            if (typeArguments) node.transformFlags |= 1 /* ContainsTypeScript */ ;
            return node;
        }
        function updateJsxOpeningElement(node, tagName, typeArguments, attributes) {
            return node.tagName !== tagName || node.typeArguments !== typeArguments || node.attributes !== attributes ? update(createJsxOpeningElement(tagName, typeArguments, attributes), node) : node;
        }
        function createJsxClosingElement(tagName) {
            const node = createBaseNode(288 /* JsxClosingElement */ );
            node.tagName = tagName;
            node.transformFlags |= propagateChildFlags(node.tagName) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxClosingElement(node, tagName) {
            return node.tagName !== tagName ? update(createJsxClosingElement(tagName), node) : node;
        }
        function createJsxFragment(openingFragment, children, closingFragment) {
            const node = createBaseNode(289 /* JsxFragment */ );
            node.openingFragment = openingFragment;
            node.children = createNodeArray(children);
            node.closingFragment = closingFragment;
            node.transformFlags |= propagateChildFlags(node.openingFragment) | propagateChildrenFlags(node.children) | propagateChildFlags(node.closingFragment) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxFragment(node, openingFragment, children, closingFragment) {
            return node.openingFragment !== openingFragment || node.children !== children || node.closingFragment !== closingFragment ? update(createJsxFragment(openingFragment, children, closingFragment), node) : node;
        }
        function createJsxText(text, containsOnlyTriviaWhiteSpaces) {
            const node = createBaseNode(12 /* JsxText */ );
            node.text = text;
            node.containsOnlyTriviaWhiteSpaces = !!containsOnlyTriviaWhiteSpaces;
            node.transformFlags |= 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxText(node, text, containsOnlyTriviaWhiteSpaces) {
            return node.text !== text || node.containsOnlyTriviaWhiteSpaces !== containsOnlyTriviaWhiteSpaces ? update(createJsxText(text, containsOnlyTriviaWhiteSpaces), node) : node;
        }
        function createJsxOpeningFragment() {
            const node = createBaseNode(290 /* JsxOpeningFragment */ );
            node.transformFlags |= 2 /* ContainsJsx */ ;
            return node;
        }
        function createJsxJsxClosingFragment() {
            const node = createBaseNode(291 /* JsxClosingFragment */ );
            node.transformFlags |= 2 /* ContainsJsx */ ;
            return node;
        }
        function createJsxAttribute(name, initializer) {
            const node = createBaseDeclaration(292 /* JsxAttribute */ );
            node.name = name;
            node.initializer = initializer;
            node.transformFlags |= propagateChildFlags(node.name) | propagateChildFlags(node.initializer) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxAttribute(node, name, initializer) {
            return node.name !== name || node.initializer !== initializer ? update(createJsxAttribute(name, initializer), node) : node;
        }
        function createJsxAttributes(properties) {
            const node = createBaseDeclaration(293 /* JsxAttributes */ );
            node.properties = createNodeArray(properties);
            node.transformFlags |= propagateChildrenFlags(node.properties) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxAttributes(node, properties) {
            return node.properties !== properties ? update(createJsxAttributes(properties), node) : node;
        }
        function createJsxSpreadAttribute(expression) {
            const node = createBaseNode(294 /* JsxSpreadAttribute */ );
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.expression) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxSpreadAttribute(node, expression) {
            return node.expression !== expression ? update(createJsxSpreadAttribute(expression), node) : node;
        }
        function createJsxExpression(dotDotDotToken, expression) {
            const node = createBaseNode(295 /* JsxExpression */ );
            node.dotDotDotToken = dotDotDotToken;
            node.expression = expression;
            node.transformFlags |= propagateChildFlags(node.dotDotDotToken) | propagateChildFlags(node.expression) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxExpression(node, expression) {
            return node.expression !== expression ? update(createJsxExpression(node.dotDotDotToken, expression), node) : node;
        }
        function createJsxNamespacedName(namespace, name) {
            const node = createBaseNode(296 /* JsxNamespacedName */ );
            node.namespace = namespace;
            node.name = name;
            node.transformFlags |= propagateChildFlags(node.namespace) | propagateChildFlags(node.name) | 2 /* ContainsJsx */ ;
            return node;
        }
        function updateJsxNamespacedName(node, namespace, name) {
            return node.namespace !== namespace || node.name !== name ? update(createJsxNamespacedName(namespace, name), node) : node;
        }
        function createCaseClause(expression, statements) {
            const node = createBaseNode(297 /* CaseClause */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.statements = createNodeArray(statements);
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildrenFlags(node.statements);
            node.jsDoc = void 0;
            return node;
        }
        function updateCaseClause(node, expression, statements) {
            return node.expression !== expression || node.statements !== statements ? update(createCaseClause(expression, statements), node) : node;
        }
        function createDefaultClause(statements) {
            const node = createBaseNode(298 /* DefaultClause */ );
            node.statements = createNodeArray(statements);
            node.transformFlags = propagateChildrenFlags(node.statements);
            return node;
        }
        function updateDefaultClause(node, statements) {
            return node.statements !== statements ? update(createDefaultClause(statements), node) : node;
        }
        function createHeritageClause(token, types) {
            const node = createBaseNode(299 /* HeritageClause */ );
            node.token = token;
            node.types = createNodeArray(types);
            node.transformFlags |= propagateChildrenFlags(node.types);
            switch(token){
                case 96 /* ExtendsKeyword */ :
                    node.transformFlags |= 1024 /* ContainsES2015 */ ;
                    break;
                case 119 /* ImplementsKeyword */ :
                    node.transformFlags |= 1 /* ContainsTypeScript */ ;
                    break;
                default:
                    return Debug.assertNever(token);
            }
            return node;
        }
        function updateHeritageClause(node, types) {
            return node.types !== types ? update(createHeritageClause(node.token, types), node) : node;
        }
        function createCatchClause(variableDeclaration, block) {
            const node = createBaseNode(300 /* CatchClause */ );
            node.variableDeclaration = asVariableDeclaration(variableDeclaration);
            node.block = block;
            node.transformFlags |= propagateChildFlags(node.variableDeclaration) | propagateChildFlags(node.block) | (!variableDeclaration ? 64 /* ContainsES2019 */  : 0 /* None */ );
            node.locals = void 0;
            node.nextContainer = void 0;
            return node;
        }
        function updateCatchClause(node, variableDeclaration, block) {
            return node.variableDeclaration !== variableDeclaration || node.block !== block ? update(createCatchClause(variableDeclaration, block), node) : node;
        }
        function createPropertyAssignment(name, initializer) {
            const node = createBaseDeclaration(304 /* PropertyAssignment */ );
            node.name = asName(name);
            node.initializer = parenthesizerRules().parenthesizeExpressionForDisallowedComma(initializer);
            node.transformFlags |= propagateNameFlags(node.name) | propagateChildFlags(node.initializer);
            node.modifiers = void 0;
            node.questionToken = void 0;
            node.exclamationToken = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updatePropertyAssignment(node, name, initializer) {
            return node.name !== name || node.initializer !== initializer ? finishUpdatePropertyAssignment(createPropertyAssignment(name, initializer), node) : node;
        }
        function finishUpdatePropertyAssignment(updated, original) {
            if (updated !== original) {
                updated.modifiers = original.modifiers;
                updated.questionToken = original.questionToken;
                updated.exclamationToken = original.exclamationToken;
            }
            return update(updated, original);
        }
        function createShorthandPropertyAssignment(name, objectAssignmentInitializer) {
            const node = createBaseDeclaration(305 /* ShorthandPropertyAssignment */ );
            node.name = asName(name);
            node.objectAssignmentInitializer = objectAssignmentInitializer && parenthesizerRules().parenthesizeExpressionForDisallowedComma(objectAssignmentInitializer);
            node.transformFlags |= propagateIdentifierNameFlags(node.name) | propagateChildFlags(node.objectAssignmentInitializer) | 1024 /* ContainsES2015 */ ;
            node.equalsToken = void 0;
            node.modifiers = void 0;
            node.questionToken = void 0;
            node.exclamationToken = void 0;
            node.jsDoc = void 0;
            return node;
        }
        function updateShorthandPropertyAssignment(node, name, objectAssignmentInitializer) {
            return node.name !== name || node.objectAssignmentInitializer !== objectAssignmentInitializer ? finishUpdateShorthandPropertyAssignment(createShorthandPropertyAssignment(name, objectAssignmentInitializer), node) : node;
        }
        function finishUpdateShorthandPropertyAssignment(updated, original) {
            if (updated !== original) {
                updated.modifiers = original.modifiers;
                updated.questionToken = original.questionToken;
                updated.exclamationToken = original.exclamationToken;
                updated.equalsToken = original.equalsToken;
            }
            return update(updated, original);
        }
        function createSpreadAssignment(expression) {
            const node = createBaseDeclaration(306 /* SpreadAssignment */ );
            node.expression = parenthesizerRules().parenthesizeExpressionForDisallowedComma(expression);
            node.transformFlags |= propagateChildFlags(node.expression) | 65664 /* ContainsObjectRestOrSpread */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateSpreadAssignment(node, expression) {
            return node.expression !== expression ? update(createSpreadAssignment(expression), node) : node;
        }
        function createEnumMember(name, initializer) {
            const node = createBaseDeclaration(307 /* EnumMember */ );
            node.name = asName(name);
            node.initializer = initializer && parenthesizerRules().parenthesizeExpressionForDisallowedComma(initializer);
            node.transformFlags |= propagateChildFlags(node.name) | propagateChildFlags(node.initializer) | 1 /* ContainsTypeScript */ ;
            node.jsDoc = void 0;
            return node;
        }
        function updateEnumMember(node, name, initializer) {
            return node.name !== name || node.initializer !== initializer ? update(createEnumMember(name, initializer), node) : node;
        }
        function createSourceFile2(statements, endOfFileToken, flags2) {
            const node = baseFactory2.createBaseSourceFileNode(308 /* SourceFile */ );
            node.statements = createNodeArray(statements);
            node.endOfFileToken = endOfFileToken;
            node.flags |= flags2;
            node.text = "";
            node.fileName = "";
            node.path = "";
            node.resolvedPath = "";
            node.originalFileName = "";
            node.languageVersion = 1 /* ES5 */ ;
            node.languageVariant = 0;
            node.scriptKind = 0;
            node.isDeclarationFile = false;
            node.hasNoDefaultLib = false;
            node.transformFlags |= propagateChildrenFlags(node.statements) | propagateChildFlags(node.endOfFileToken);
            node.locals = void 0;
            node.nextContainer = void 0;
            node.endFlowNode = void 0;
            node.nodeCount = 0;
            node.identifierCount = 0;
            node.symbolCount = 0;
            node.parseDiagnostics = void 0;
            node.bindDiagnostics = void 0;
            node.bindSuggestionDiagnostics = void 0;
            node.lineMap = void 0;
            node.externalModuleIndicator = void 0;
            node.setExternalModuleIndicator = void 0;
            node.pragmas = void 0;
            node.checkJsDirective = void 0;
            node.referencedFiles = void 0;
            node.typeReferenceDirectives = void 0;
            node.libReferenceDirectives = void 0;
            node.amdDependencies = void 0;
            node.commentDirectives = void 0;
            node.identifiers = void 0;
            node.packageJsonLocations = void 0;
            node.packageJsonScope = void 0;
            node.imports = void 0;
            node.moduleAugmentations = void 0;
            node.ambientModuleNames = void 0;
            node.classifiableNames = void 0;
            node.impliedNodeFormat = void 0;
            return node;
        }
        function createRedirectedSourceFile(redirectInfo) {
            const node = Object.create(redirectInfo.redirectTarget);
            Object.defineProperties(node, {
                id: {
                    get () {
                        return this.redirectInfo.redirectTarget.id;
                    },
                    set (value1) {
                        this.redirectInfo.redirectTarget.id = value1;
                    }
                },
                symbol: {
                    get () {
                        return this.redirectInfo.redirectTarget.symbol;
                    },
                    set (value1) {
                        this.redirectInfo.redirectTarget.symbol = value1;
                    }
                }
            });
            node.redirectInfo = redirectInfo;
            return node;
        }
        function cloneRedirectedSourceFile(source) {
            const node = createRedirectedSourceFile(source.redirectInfo);
            node.flags |= source.flags & -17 /* Synthesized */ ;
            node.fileName = source.fileName;
            node.path = source.path;
            node.resolvedPath = source.resolvedPath;
            node.originalFileName = source.originalFileName;
            node.packageJsonLocations = source.packageJsonLocations;
            node.packageJsonScope = source.packageJsonScope;
            node.emitNode = void 0;
            return node;
        }
        function cloneSourceFileWorker(source) {
            const node = baseFactory2.createBaseSourceFileNode(308 /* SourceFile */ );
            node.flags |= source.flags & -17 /* Synthesized */ ;
            for(const p in source){
                if (hasProperty(node, p) || !hasProperty(source, p)) continue;
                if (p === "emitNode") {
                    node.emitNode = void 0;
                    continue;
                }
                node[p] = source[p];
            }
            return node;
        }
        function cloneSourceFile(source) {
            const node = source.redirectInfo ? cloneRedirectedSourceFile(source) : cloneSourceFileWorker(source);
            setOriginal(node, source);
            return node;
        }
        function cloneSourceFileWithChanges(source, statements, isDeclarationFile, referencedFiles, typeReferences, hasNoDefaultLib, libReferences) {
            const node = cloneSourceFile(source);
            node.statements = createNodeArray(statements);
            node.isDeclarationFile = isDeclarationFile;
            node.referencedFiles = referencedFiles;
            node.typeReferenceDirectives = typeReferences;
            node.hasNoDefaultLib = hasNoDefaultLib;
            node.libReferenceDirectives = libReferences;
            node.transformFlags = propagateChildrenFlags(node.statements) | propagateChildFlags(node.endOfFileToken);
            return node;
        }
        function updateSourceFile2(node, statements, isDeclarationFile = node.isDeclarationFile, referencedFiles = node.referencedFiles, typeReferenceDirectives = node.typeReferenceDirectives, hasNoDefaultLib = node.hasNoDefaultLib, libReferenceDirectives = node.libReferenceDirectives) {
            return node.statements !== statements || node.isDeclarationFile !== isDeclarationFile || node.referencedFiles !== referencedFiles || node.typeReferenceDirectives !== typeReferenceDirectives || node.hasNoDefaultLib !== hasNoDefaultLib || node.libReferenceDirectives !== libReferenceDirectives ? update(cloneSourceFileWithChanges(node, statements, isDeclarationFile, referencedFiles, typeReferenceDirectives, hasNoDefaultLib, libReferenceDirectives), node) : node;
        }
        function createBundle(sourceFiles) {
            const node = createBaseNode(309 /* Bundle */ );
            node.sourceFiles = sourceFiles;
            node.syntheticFileReferences = void 0;
            node.syntheticTypeReferences = void 0;
            node.syntheticLibReferences = void 0;
            node.hasNoDefaultLib = void 0;
            return node;
        }
        function updateBundle(node, sourceFiles) {
            return node.sourceFiles !== sourceFiles ? update(createBundle(sourceFiles), node) : node;
        }
        function createSyntheticExpression(type, isSpread = false, tupleNameSource) {
            const node = createBaseNode(238 /* SyntheticExpression */ );
            node.type = type;
            node.isSpread = isSpread;
            node.tupleNameSource = tupleNameSource;
            return node;
        }
        function createSyntaxList3(children) {
            const node = createBaseNode(353 /* SyntaxList */ );
            node._children = children;
            return node;
        }
        function createNotEmittedStatement(original) {
            const node = createBaseNode(354 /* NotEmittedStatement */ );
            node.original = original;
            setTextRange(node, original);
            return node;
        }
        function createPartiallyEmittedExpression(expression, original) {
            const node = createBaseNode(356 /* PartiallyEmittedExpression */ );
            node.expression = expression;
            node.original = original;
            node.transformFlags |= propagateChildFlags(node.expression) | 1 /* ContainsTypeScript */ ;
            setTextRange(node, original);
            return node;
        }
        function updatePartiallyEmittedExpression(node, expression) {
            return node.expression !== expression ? update(createPartiallyEmittedExpression(expression, node.original), node) : node;
        }
        function createNotEmittedTypeElement() {
            return createBaseNode(355 /* NotEmittedTypeElement */ );
        }
        function flattenCommaElements(node) {
            if (nodeIsSynthesized(node) && !isParseTreeNode(node) && !node.original && !node.emitNode && !node.id) {
                if (isCommaListExpression(node)) return node.elements;
                if (isBinaryExpression(node) && isCommaToken(node.operatorToken)) return [
                    node.left,
                    node.right
                ];
            }
            return node;
        }
        function createCommaListExpression(elements) {
            const node = createBaseNode(357 /* CommaListExpression */ );
            node.elements = createNodeArray(sameFlatMap(elements, flattenCommaElements));
            node.transformFlags |= propagateChildrenFlags(node.elements);
            return node;
        }
        function updateCommaListExpression(node, elements) {
            return node.elements !== elements ? update(createCommaListExpression(elements), node) : node;
        }
        function createSyntheticReferenceExpression(expression, thisArg) {
            const node = createBaseNode(358 /* SyntheticReferenceExpression */ );
            node.expression = expression;
            node.thisArg = thisArg;
            node.transformFlags |= propagateChildFlags(node.expression) | propagateChildFlags(node.thisArg);
            return node;
        }
        function updateSyntheticReferenceExpression(node, expression, thisArg) {
            return node.expression !== expression || node.thisArg !== thisArg ? update(createSyntheticReferenceExpression(expression, thisArg), node) : node;
        }
        function cloneGeneratedIdentifier(node) {
            const clone2 = createBaseIdentifier(node.escapedText);
            clone2.flags |= node.flags & -17 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginal(clone2, node);
            setIdentifierAutoGenerate(clone2, (0, _objectSpread._)({}, node.emitNode.autoGenerate));
            return clone2;
        }
        function cloneIdentifier(node) {
            const clone2 = createBaseIdentifier(node.escapedText);
            clone2.flags |= node.flags & -17 /* Synthesized */ ;
            clone2.jsDoc = node.jsDoc;
            clone2.flowNode = node.flowNode;
            clone2.symbol = node.symbol;
            clone2.transformFlags = node.transformFlags;
            setOriginal(clone2, node);
            const typeArguments = getIdentifierTypeArguments(node);
            if (typeArguments) setIdentifierTypeArguments(clone2, typeArguments);
            return clone2;
        }
        function cloneGeneratedPrivateIdentifier(node) {
            const clone2 = createBasePrivateIdentifier(node.escapedText);
            clone2.flags |= node.flags & -17 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginal(clone2, node);
            setIdentifierAutoGenerate(clone2, (0, _objectSpread._)({}, node.emitNode.autoGenerate));
            return clone2;
        }
        function clonePrivateIdentifier(node) {
            const clone2 = createBasePrivateIdentifier(node.escapedText);
            clone2.flags |= node.flags & -17 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginal(clone2, node);
            return clone2;
        }
        function cloneNode(node) {
            if (node === void 0) return node;
            if (isSourceFile(node)) return cloneSourceFile(node);
            if (isGeneratedIdentifier(node)) return cloneGeneratedIdentifier(node);
            if (isIdentifier(node)) return cloneIdentifier(node);
            if (isGeneratedPrivateIdentifier(node)) return cloneGeneratedPrivateIdentifier(node);
            if (isPrivateIdentifier(node)) return clonePrivateIdentifier(node);
            const clone2 = !isNodeKind(node.kind) ? baseFactory2.createBaseTokenNode(node.kind) : baseFactory2.createBaseNode(node.kind);
            clone2.flags |= node.flags & -17 /* Synthesized */ ;
            clone2.transformFlags = node.transformFlags;
            setOriginal(clone2, node);
            for(const key in node){
                if (hasProperty(clone2, key) || !hasProperty(node, key)) continue;
                clone2[key] = node[key];
            }
            return clone2;
        }
        function createImmediatelyInvokedFunctionExpression(statements, param, paramValue) {
            return createCallExpression(createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ param ? [
                param
            ] : [], /*type*/ void 0, createBlock(statements, /*multiLine*/ true)), /*typeArguments*/ void 0, /*argumentsArray*/ paramValue ? [
                paramValue
            ] : []);
        }
        function createImmediatelyInvokedArrowFunction(statements, param, paramValue) {
            return createCallExpression(createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /*parameters*/ param ? [
                param
            ] : [], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, createBlock(statements, /*multiLine*/ true)), /*typeArguments*/ void 0, /*argumentsArray*/ paramValue ? [
                paramValue
            ] : []);
        }
        function createVoidZero() {
            return createVoidExpression(createNumericLiteral("0"));
        }
        function createExportDefault(expression) {
            return createExportAssignment2(/*modifiers*/ void 0, /*isExportEquals*/ false, expression);
        }
        function createExternalModuleExport(exportName) {
            return createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, createNamedExports([
                createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, exportName)
            ]));
        }
        function createTypeCheck(value1, tag) {
            return tag === "null" ? factory2.createStrictEquality(value1, createNull()) : tag === "undefined" ? factory2.createStrictEquality(value1, createVoidZero()) : factory2.createStrictEquality(createTypeOfExpression(value1), createStringLiteral(tag));
        }
        function createIsNotTypeCheck(value1, tag) {
            return tag === "null" ? factory2.createStrictInequality(value1, createNull()) : tag === "undefined" ? factory2.createStrictInequality(value1, createVoidZero()) : factory2.createStrictInequality(createTypeOfExpression(value1), createStringLiteral(tag));
        }
        function createMethodCall(object, methodName, argumentsList) {
            if (isCallChain(object)) return createCallChain(createPropertyAccessChain(object, /*questionDotToken*/ void 0, methodName), /*questionDotToken*/ void 0, /*typeArguments*/ void 0, argumentsList);
            return createCallExpression(createPropertyAccessExpression(object, methodName), /*typeArguments*/ void 0, argumentsList);
        }
        function createFunctionBindCall(target, thisArg, argumentsList) {
            return createMethodCall(target, "bind", [
                thisArg,
                ...argumentsList
            ]);
        }
        function createFunctionCallCall(target, thisArg, argumentsList) {
            return createMethodCall(target, "call", [
                thisArg,
                ...argumentsList
            ]);
        }
        function createFunctionApplyCall(target, thisArg, argumentsExpression) {
            return createMethodCall(target, "apply", [
                thisArg,
                argumentsExpression
            ]);
        }
        function createGlobalMethodCall(globalObjectName, methodName, argumentsList) {
            return createMethodCall(createIdentifier(globalObjectName), methodName, argumentsList);
        }
        function createArraySliceCall(array, start) {
            return createMethodCall(array, "slice", start === void 0 ? [] : [
                asExpression(start)
            ]);
        }
        function createArrayConcatCall(array, argumentsList) {
            return createMethodCall(array, "concat", argumentsList);
        }
        function createObjectDefinePropertyCall(target, propertyName, attributes) {
            return createGlobalMethodCall("Object", "defineProperty", [
                target,
                asExpression(propertyName),
                attributes
            ]);
        }
        function createObjectGetOwnPropertyDescriptorCall(target, propertyName) {
            return createGlobalMethodCall("Object", "getOwnPropertyDescriptor", [
                target,
                asExpression(propertyName)
            ]);
        }
        function createReflectGetCall(target, propertyKey, receiver) {
            return createGlobalMethodCall("Reflect", "get", receiver ? [
                target,
                propertyKey,
                receiver
            ] : [
                target,
                propertyKey
            ]);
        }
        function createReflectSetCall(target, propertyKey, value1, receiver) {
            return createGlobalMethodCall("Reflect", "set", receiver ? [
                target,
                propertyKey,
                value1,
                receiver
            ] : [
                target,
                propertyKey,
                value1
            ]);
        }
        function tryAddPropertyAssignment(properties, propertyName, expression) {
            if (expression) {
                properties.push(createPropertyAssignment(propertyName, expression));
                return true;
            }
            return false;
        }
        function createPropertyDescriptor(attributes, singleLine) {
            const properties = [];
            tryAddPropertyAssignment(properties, "enumerable", asExpression(attributes.enumerable));
            tryAddPropertyAssignment(properties, "configurable", asExpression(attributes.configurable));
            let isData = tryAddPropertyAssignment(properties, "writable", asExpression(attributes.writable));
            isData = tryAddPropertyAssignment(properties, "value", attributes.value) || isData;
            let isAccessor2 = tryAddPropertyAssignment(properties, "get", attributes.get);
            isAccessor2 = tryAddPropertyAssignment(properties, "set", attributes.set) || isAccessor2;
            Debug.assert(!(isData && isAccessor2), "A PropertyDescriptor may not be both an accessor descriptor and a data descriptor.");
            return createObjectLiteralExpression(properties, !singleLine);
        }
        function updateOuterExpression(outerExpression, expression) {
            switch(outerExpression.kind){
                case 218 /* ParenthesizedExpression */ :
                    return updateParenthesizedExpression(outerExpression, expression);
                case 217 /* TypeAssertionExpression */ :
                    return updateTypeAssertion(outerExpression, outerExpression.type, expression);
                case 235 /* AsExpression */ :
                    return updateAsExpression(outerExpression, expression, outerExpression.type);
                case 239 /* SatisfiesExpression */ :
                    return updateSatisfiesExpression(outerExpression, expression, outerExpression.type);
                case 236 /* NonNullExpression */ :
                    return updateNonNullExpression(outerExpression, expression);
                case 234 /* ExpressionWithTypeArguments */ :
                    return updateExpressionWithTypeArguments(outerExpression, expression, outerExpression.typeArguments);
                case 356 /* PartiallyEmittedExpression */ :
                    return updatePartiallyEmittedExpression(outerExpression, expression);
            }
        }
        function isIgnorableParen(node) {
            return isParenthesizedExpression(node) && nodeIsSynthesized(node) && nodeIsSynthesized(getSourceMapRange(node)) && nodeIsSynthesized(getCommentRange(node)) && !some(getSyntheticLeadingComments(node)) && !some(getSyntheticTrailingComments(node));
        }
        function restoreOuterExpressions(outerExpression, innerExpression, kinds = 63 /* All */ ) {
            if (outerExpression && isOuterExpression(outerExpression, kinds) && !isIgnorableParen(outerExpression)) return updateOuterExpression(outerExpression, restoreOuterExpressions(outerExpression.expression, innerExpression));
            return innerExpression;
        }
        function restoreEnclosingLabel(node, outermostLabeledStatement, afterRestoreLabelCallback) {
            if (!outermostLabeledStatement) return node;
            const updated = updateLabeledStatement(outermostLabeledStatement, outermostLabeledStatement.label, isLabeledStatement(outermostLabeledStatement.statement) ? restoreEnclosingLabel(node, outermostLabeledStatement.statement) : node);
            if (afterRestoreLabelCallback) afterRestoreLabelCallback(outermostLabeledStatement);
            return updated;
        }
        function shouldBeCapturedInTempVariable(node, cacheIdentifiers) {
            const target = skipParentheses(node);
            switch(target.kind){
                case 80 /* Identifier */ :
                    return cacheIdentifiers;
                case 110 /* ThisKeyword */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 11 /* StringLiteral */ :
                    return false;
                case 210 /* ArrayLiteralExpression */ :
                    const elements = target.elements;
                    if (elements.length === 0) return false;
                    return true;
                case 211 /* ObjectLiteralExpression */ :
                    return target.properties.length > 0;
                default:
                    return true;
            }
        }
        function createCallBinding(expression, recordTempVariable, languageVersion, cacheIdentifiers = false) {
            const callee = skipOuterExpressions(expression, 63 /* All */ );
            let thisArg;
            let target;
            if (isSuperProperty(callee)) {
                thisArg = createThis();
                target = callee;
            } else if (isSuperKeyword(callee)) {
                thisArg = createThis();
                target = languageVersion !== void 0 && languageVersion < 2 /* ES2015 */  ? setTextRange(createIdentifier("_super"), callee) : callee;
            } else if (getEmitFlags(callee) & 8192 /* HelperName */ ) {
                thisArg = createVoidZero();
                target = parenthesizerRules().parenthesizeLeftSideOfAccess(callee, /*optionalChain*/ false);
            } else if (isPropertyAccessExpression(callee)) {
                if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
                    thisArg = createTempVariable(recordTempVariable);
                    target = createPropertyAccessExpression(setTextRange(factory2.createAssignment(thisArg, callee.expression), callee.expression), callee.name);
                    setTextRange(target, callee);
                } else {
                    thisArg = callee.expression;
                    target = callee;
                }
            } else if (isElementAccessExpression(callee)) {
                if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
                    thisArg = createTempVariable(recordTempVariable);
                    target = createElementAccessExpression(setTextRange(factory2.createAssignment(thisArg, callee.expression), callee.expression), callee.argumentExpression);
                    setTextRange(target, callee);
                } else {
                    thisArg = callee.expression;
                    target = callee;
                }
            } else {
                thisArg = createVoidZero();
                target = parenthesizerRules().parenthesizeLeftSideOfAccess(expression, /*optionalChain*/ false);
            }
            return {
                target,
                thisArg
            };
        }
        function createAssignmentTargetWrapper(paramName, expression) {
            return createPropertyAccessExpression(// Explicit parens required because of v8 regression (https://bugs.chromium.org/p/v8/issues/detail?id=9560)
            createParenthesizedExpression(createObjectLiteralExpression([
                createSetAccessorDeclaration(/*modifiers*/ void 0, "value", [
                    createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, paramName, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
                ], createBlock([
                    createExpressionStatement(expression)
                ]))
            ])), "value");
        }
        function inlineExpressions(expressions) {
            return expressions.length > 10 ? createCommaListExpression(expressions) : reduceLeft(expressions, factory2.createComma);
        }
        function getName(node, allowComments, allowSourceMaps, emitFlags = 0, ignoreAssignedName) {
            const nodeName = ignoreAssignedName ? node && getNonAssignedNameOfDeclaration(node) : getNameOfDeclaration(node);
            if (nodeName && isIdentifier(nodeName) && !isGeneratedIdentifier(nodeName)) {
                const name = setParent(setTextRange(cloneNode(nodeName), nodeName), nodeName.parent);
                emitFlags |= getEmitFlags(nodeName);
                if (!allowSourceMaps) emitFlags |= 96 /* NoSourceMap */ ;
                if (!allowComments) emitFlags |= 3072 /* NoComments */ ;
                if (emitFlags) setEmitFlags(name, emitFlags);
                return name;
            }
            return getGeneratedNameForNode(node);
        }
        function getInternalName(node, allowComments, allowSourceMaps) {
            return getName(node, allowComments, allowSourceMaps, 98304 /* InternalName */ );
        }
        function getLocalName(node, allowComments, allowSourceMaps, ignoreAssignedName) {
            return getName(node, allowComments, allowSourceMaps, 32768 /* LocalName */ , ignoreAssignedName);
        }
        function getExportName(node, allowComments, allowSourceMaps) {
            return getName(node, allowComments, allowSourceMaps, 16384 /* ExportName */ );
        }
        function getDeclarationName(node, allowComments, allowSourceMaps) {
            return getName(node, allowComments, allowSourceMaps);
        }
        function getNamespaceMemberName(ns, name, allowComments, allowSourceMaps) {
            const qualifiedName = createPropertyAccessExpression(ns, nodeIsSynthesized(name) ? name : cloneNode(name));
            setTextRange(qualifiedName, name);
            let emitFlags = 0;
            if (!allowSourceMaps) emitFlags |= 96 /* NoSourceMap */ ;
            if (!allowComments) emitFlags |= 3072 /* NoComments */ ;
            if (emitFlags) setEmitFlags(qualifiedName, emitFlags);
            return qualifiedName;
        }
        function getExternalModuleOrNamespaceExportName(ns, node, allowComments, allowSourceMaps) {
            if (ns && hasSyntacticModifier(node, 32 /* Export */ )) return getNamespaceMemberName(ns, getName(node), allowComments, allowSourceMaps);
            return getExportName(node, allowComments, allowSourceMaps);
        }
        function copyPrologue(source, target, ensureUseStrict2, visitor) {
            const offset = copyStandardPrologue(source, target, 0, ensureUseStrict2);
            return copyCustomPrologue(source, target, offset, visitor);
        }
        function isUseStrictPrologue2(node) {
            return isStringLiteral(node.expression) && node.expression.text === "use strict";
        }
        function createUseStrictPrologue() {
            return startOnNewLine(createExpressionStatement(createStringLiteral("use strict")));
        }
        function copyStandardPrologue(source, target, statementOffset = 0, ensureUseStrict2) {
            Debug.assert(target.length === 0, "Prologue directives should be at the first statement in the target statements array");
            let foundUseStrict = false;
            const numStatements = source.length;
            while(statementOffset < numStatements){
                const statement = source[statementOffset];
                if (isPrologueDirective(statement)) {
                    if (isUseStrictPrologue2(statement)) foundUseStrict = true;
                    target.push(statement);
                } else break;
                statementOffset++;
            }
            if (ensureUseStrict2 && !foundUseStrict) target.push(createUseStrictPrologue());
            return statementOffset;
        }
        function copyCustomPrologue(source, target, statementOffset, visitor, filter2 = returnTrue) {
            const numStatements = source.length;
            while(statementOffset !== void 0 && statementOffset < numStatements){
                const statement = source[statementOffset];
                if (getEmitFlags(statement) & 2097152 /* CustomPrologue */  && filter2(statement)) append(target, visitor ? visitNode(statement, visitor, isStatement) : statement);
                else break;
                statementOffset++;
            }
            return statementOffset;
        }
        function ensureUseStrict(statements) {
            const foundUseStrict = findUseStrictPrologue(statements);
            if (!foundUseStrict) return setTextRange(createNodeArray([
                createUseStrictPrologue(),
                ...statements
            ]), statements);
            return statements;
        }
        function liftToBlock(nodes) {
            Debug.assert(every(nodes, isStatementOrBlock), "Cannot lift nodes to a Block.");
            return singleOrUndefined(nodes) || createBlock(nodes);
        }
        function findSpanEnd(array, test, start) {
            let i = start;
            while(i < array.length && test(array[i]))i++;
            return i;
        }
        function mergeLexicalEnvironment(statements, declarations) {
            if (!some(declarations)) return statements;
            const leftStandardPrologueEnd = findSpanEnd(statements, isPrologueDirective, 0);
            const leftHoistedFunctionsEnd = findSpanEnd(statements, isHoistedFunction, leftStandardPrologueEnd);
            const leftHoistedVariablesEnd = findSpanEnd(statements, isHoistedVariableStatement, leftHoistedFunctionsEnd);
            const rightStandardPrologueEnd = findSpanEnd(declarations, isPrologueDirective, 0);
            const rightHoistedFunctionsEnd = findSpanEnd(declarations, isHoistedFunction, rightStandardPrologueEnd);
            const rightHoistedVariablesEnd = findSpanEnd(declarations, isHoistedVariableStatement, rightHoistedFunctionsEnd);
            const rightCustomPrologueEnd = findSpanEnd(declarations, isCustomPrologue, rightHoistedVariablesEnd);
            Debug.assert(rightCustomPrologueEnd === declarations.length, "Expected declarations to be valid standard or custom prologues");
            const left = isNodeArray(statements) ? statements.slice() : statements;
            if (rightCustomPrologueEnd > rightHoistedVariablesEnd) left.splice(leftHoistedVariablesEnd, 0, ...declarations.slice(rightHoistedVariablesEnd, rightCustomPrologueEnd));
            if (rightHoistedVariablesEnd > rightHoistedFunctionsEnd) left.splice(leftHoistedFunctionsEnd, 0, ...declarations.slice(rightHoistedFunctionsEnd, rightHoistedVariablesEnd));
            if (rightHoistedFunctionsEnd > rightStandardPrologueEnd) left.splice(leftStandardPrologueEnd, 0, ...declarations.slice(rightStandardPrologueEnd, rightHoistedFunctionsEnd));
            if (rightStandardPrologueEnd > 0) {
                if (leftStandardPrologueEnd === 0) left.splice(0, 0, ...declarations.slice(0, rightStandardPrologueEnd));
                else {
                    const leftPrologues = /* @__PURE__ */ new Map();
                    for(let i = 0; i < leftStandardPrologueEnd; i++){
                        const leftPrologue = statements[i];
                        leftPrologues.set(leftPrologue.expression.text, true);
                    }
                    for(let i = rightStandardPrologueEnd - 1; i >= 0; i--){
                        const rightPrologue = declarations[i];
                        if (!leftPrologues.has(rightPrologue.expression.text)) left.unshift(rightPrologue);
                    }
                }
            }
            if (isNodeArray(statements)) return setTextRange(createNodeArray(left, statements.hasTrailingComma), statements);
            return statements;
        }
        function replaceModifiers(node, modifiers) {
            let modifierArray;
            if (typeof modifiers === "number") modifierArray = createModifiersFromModifierFlags(modifiers);
            else modifierArray = modifiers;
            var _node_questionToken;
            return isTypeParameterDeclaration(node) ? updateTypeParameterDeclaration(node, modifierArray, node.name, node.constraint, node.default) : isParameter(node) ? updateParameterDeclaration(node, modifierArray, node.dotDotDotToken, node.name, node.questionToken, node.type, node.initializer) : isConstructorTypeNode(node) ? updateConstructorTypeNode1(node, modifierArray, node.typeParameters, node.parameters, node.type) : isPropertySignature(node) ? updatePropertySignature(node, modifierArray, node.name, node.questionToken, node.type) : isPropertyDeclaration(node) ? updatePropertyDeclaration2(node, modifierArray, node.name, (_node_questionToken = node.questionToken) !== null && _node_questionToken !== void 0 ? _node_questionToken : node.exclamationToken, node.type, node.initializer) : isMethodSignature(node) ? updateMethodSignature(node, modifierArray, node.name, node.questionToken, node.typeParameters, node.parameters, node.type) : isMethodDeclaration(node) ? updateMethodDeclaration(node, modifierArray, node.asteriskToken, node.name, node.questionToken, node.typeParameters, node.parameters, node.type, node.body) : isConstructorDeclaration(node) ? updateConstructorDeclaration(node, modifierArray, node.parameters, node.body) : isGetAccessorDeclaration(node) ? updateGetAccessorDeclaration(node, modifierArray, node.name, node.parameters, node.type, node.body) : isSetAccessorDeclaration(node) ? updateSetAccessorDeclaration(node, modifierArray, node.name, node.parameters, node.body) : isIndexSignatureDeclaration(node) ? updateIndexSignature(node, modifierArray, node.parameters, node.type) : isFunctionExpression(node) ? updateFunctionExpression(node, modifierArray, node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body) : isArrowFunction(node) ? updateArrowFunction(node, modifierArray, node.typeParameters, node.parameters, node.type, node.equalsGreaterThanToken, node.body) : isClassExpression(node) ? updateClassExpression(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isVariableStatement(node) ? updateVariableStatement(node, modifierArray, node.declarationList) : isFunctionDeclaration(node) ? updateFunctionDeclaration(node, modifierArray, node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body) : isClassDeclaration(node) ? updateClassDeclaration(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isInterfaceDeclaration(node) ? updateInterfaceDeclaration(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isTypeAliasDeclaration(node) ? updateTypeAliasDeclaration(node, modifierArray, node.name, node.typeParameters, node.type) : isEnumDeclaration(node) ? updateEnumDeclaration(node, modifierArray, node.name, node.members) : isModuleDeclaration(node) ? updateModuleDeclaration(node, modifierArray, node.name, node.body) : isImportEqualsDeclaration(node) ? updateImportEqualsDeclaration(node, modifierArray, node.isTypeOnly, node.name, node.moduleReference) : isImportDeclaration(node) ? updateImportDeclaration(node, modifierArray, node.importClause, node.moduleSpecifier, node.attributes) : isExportAssignment(node) ? updateExportAssignment(node, modifierArray, node.expression) : isExportDeclaration(node) ? updateExportDeclaration(node, modifierArray, node.isTypeOnly, node.exportClause, node.moduleSpecifier, node.attributes) : Debug.assertNever(node);
        }
        function replaceDecoratorsAndModifiers(node, modifierArray) {
            var _node_questionToken;
            return isParameter(node) ? updateParameterDeclaration(node, modifierArray, node.dotDotDotToken, node.name, node.questionToken, node.type, node.initializer) : isPropertyDeclaration(node) ? updatePropertyDeclaration2(node, modifierArray, node.name, (_node_questionToken = node.questionToken) !== null && _node_questionToken !== void 0 ? _node_questionToken : node.exclamationToken, node.type, node.initializer) : isMethodDeclaration(node) ? updateMethodDeclaration(node, modifierArray, node.asteriskToken, node.name, node.questionToken, node.typeParameters, node.parameters, node.type, node.body) : isGetAccessorDeclaration(node) ? updateGetAccessorDeclaration(node, modifierArray, node.name, node.parameters, node.type, node.body) : isSetAccessorDeclaration(node) ? updateSetAccessorDeclaration(node, modifierArray, node.name, node.parameters, node.body) : isClassExpression(node) ? updateClassExpression(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : isClassDeclaration(node) ? updateClassDeclaration(node, modifierArray, node.name, node.typeParameters, node.heritageClauses, node.members) : Debug.assertNever(node);
        }
        function replacePropertyName(node, name) {
            switch(node.kind){
                case 178 /* GetAccessor */ :
                    return updateGetAccessorDeclaration(node, node.modifiers, name, node.parameters, node.type, node.body);
                case 179 /* SetAccessor */ :
                    return updateSetAccessorDeclaration(node, node.modifiers, name, node.parameters, node.body);
                case 175 /* MethodDeclaration */ :
                    return updateMethodDeclaration(node, node.modifiers, node.asteriskToken, name, node.questionToken, node.typeParameters, node.parameters, node.type, node.body);
                case 174 /* MethodSignature */ :
                    return updateMethodSignature(node, node.modifiers, name, node.questionToken, node.typeParameters, node.parameters, node.type);
                case 173 /* PropertyDeclaration */ :
                    var _node_questionToken;
                    return updatePropertyDeclaration2(node, node.modifiers, name, (_node_questionToken = node.questionToken) !== null && _node_questionToken !== void 0 ? _node_questionToken : node.exclamationToken, node.type, node.initializer);
                case 172 /* PropertySignature */ :
                    return updatePropertySignature(node, node.modifiers, name, node.questionToken, node.type);
                case 304 /* PropertyAssignment */ :
                    return updatePropertyAssignment(node, name, node.initializer);
            }
        }
        function asNodeArray(array) {
            return array ? createNodeArray(array) : void 0;
        }
        function asName(name) {
            return typeof name === "string" ? createIdentifier(name) : name;
        }
        function asExpression(value1) {
            return typeof value1 === "string" ? createStringLiteral(value1) : typeof value1 === "number" ? createNumericLiteral(value1) : typeof value1 === "boolean" ? value1 ? createTrue() : createFalse() : value1;
        }
        function asInitializer(node) {
            return node && parenthesizerRules().parenthesizeExpressionForDisallowedComma(node);
        }
        function asToken(value1) {
            return typeof value1 === "number" ? createToken(value1) : value1;
        }
        function asEmbeddedStatement(statement) {
            return statement && isNotEmittedStatement(statement) ? setTextRange(setOriginal(createEmptyStatement(), statement), statement) : statement;
        }
        function asVariableDeclaration(variableDeclaration) {
            if (typeof variableDeclaration === "string" || variableDeclaration && !isVariableDeclaration(variableDeclaration)) return createVariableDeclaration(variableDeclaration, /*exclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            return variableDeclaration;
        }
        function update(updated, original) {
            if (updated !== original) {
                setOriginal(updated, original);
                setTextRange(updated, original);
            }
            return updated;
        }
    }
    function getDefaultTagNameForKind(kind) {
        switch(kind){
            case 345 /* JSDocTypeTag */ :
                return "type";
            case 343 /* JSDocReturnTag */ :
                return "returns";
            case 344 /* JSDocThisTag */ :
                return "this";
            case 341 /* JSDocEnumTag */ :
                return "enum";
            case 331 /* JSDocAuthorTag */ :
                return "author";
            case 333 /* JSDocClassTag */ :
                return "class";
            case 334 /* JSDocPublicTag */ :
                return "public";
            case 335 /* JSDocPrivateTag */ :
                return "private";
            case 336 /* JSDocProtectedTag */ :
                return "protected";
            case 337 /* JSDocReadonlyTag */ :
                return "readonly";
            case 338 /* JSDocOverrideTag */ :
                return "override";
            case 346 /* JSDocTemplateTag */ :
                return "template";
            case 347 /* JSDocTypedefTag */ :
                return "typedef";
            case 342 /* JSDocParameterTag */ :
                return "param";
            case 349 /* JSDocPropertyTag */ :
                return "prop";
            case 339 /* JSDocCallbackTag */ :
                return "callback";
            case 340 /* JSDocOverloadTag */ :
                return "overload";
            case 329 /* JSDocAugmentsTag */ :
                return "augments";
            case 330 /* JSDocImplementsTag */ :
                return "implements";
            case 352 /* JSDocImportTag */ :
                return "import";
            default:
                return Debug.fail(`Unsupported kind: ${Debug.formatSyntaxKind(kind)}`);
        }
    }
    var rawTextScanner;
    var invalidValueSentinel = {};
    function getCookedText(kind, rawText) {
        if (!rawTextScanner) rawTextScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, 0 /* Standard */ );
        switch(kind){
            case 15 /* NoSubstitutionTemplateLiteral */ :
                rawTextScanner.setText("`" + rawText + "`");
                break;
            case 16 /* TemplateHead */ :
                rawTextScanner.setText("`" + rawText + "${");
                break;
            case 17 /* TemplateMiddle */ :
                rawTextScanner.setText("}" + rawText + "${");
                break;
            case 18 /* TemplateTail */ :
                rawTextScanner.setText("}" + rawText + "`");
                break;
        }
        let token = rawTextScanner.scan();
        if (token === 20 /* CloseBraceToken */ ) token = rawTextScanner.reScanTemplateToken(/*isTaggedTemplate*/ false);
        if (rawTextScanner.isUnterminated()) {
            rawTextScanner.setText(void 0);
            return invalidValueSentinel;
        }
        let tokenValue;
        switch(token){
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 16 /* TemplateHead */ :
            case 17 /* TemplateMiddle */ :
            case 18 /* TemplateTail */ :
                tokenValue = rawTextScanner.getTokenValue();
                break;
        }
        if (tokenValue === void 0 || rawTextScanner.scan() !== 1 /* EndOfFileToken */ ) {
            rawTextScanner.setText(void 0);
            return invalidValueSentinel;
        }
        rawTextScanner.setText(void 0);
        return tokenValue;
    }
    function propagateNameFlags(node) {
        return node && isIdentifier(node) ? propagateIdentifierNameFlags(node) : propagateChildFlags(node);
    }
    function propagateIdentifierNameFlags(node) {
        return propagateChildFlags(node) & -67108865 /* ContainsPossibleTopLevelAwait */ ;
    }
    function propagatePropertyNameFlagsOfChild(node, transformFlags) {
        return transformFlags | node.transformFlags & 134234112 /* PropertyNamePropagatingFlags */ ;
    }
    function propagateChildFlags(child) {
        if (!child) return 0 /* None */ ;
        const childFlags = child.transformFlags & ~getTransformFlagsSubtreeExclusions(child.kind);
        return isNamedDeclaration(child) && isPropertyName(child.name) ? propagatePropertyNameFlagsOfChild(child.name, childFlags) : childFlags;
    }
    function propagateChildrenFlags(children) {
        return children ? children.transformFlags : 0 /* None */ ;
    }
    function aggregateChildrenFlags(children) {
        let subtreeFlags = 0 /* None */ ;
        for (const child of children)subtreeFlags |= propagateChildFlags(child);
        children.transformFlags = subtreeFlags;
    }
    function getTransformFlagsSubtreeExclusions(kind) {
        if (kind >= 183 /* FirstTypeNode */  && kind <= 206 /* LastTypeNode */ ) return -2 /* TypeExcludes */ ;
        switch(kind){
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
            case 210 /* ArrayLiteralExpression */ :
                return -2147450880 /* ArrayLiteralOrCallOrNewExcludes */ ;
            case 268 /* ModuleDeclaration */ :
                return -1941676032 /* ModuleExcludes */ ;
            case 170 /* Parameter */ :
                return -2147483648 /* ParameterExcludes */ ;
            case 220 /* ArrowFunction */ :
                return -2072174592 /* ArrowFunctionExcludes */ ;
            case 219 /* FunctionExpression */ :
            case 263 /* FunctionDeclaration */ :
                return -1937940480 /* FunctionExcludes */ ;
            case 262 /* VariableDeclarationList */ :
                return -2146893824 /* VariableDeclarationListExcludes */ ;
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
                return -2147344384 /* ClassExcludes */ ;
            case 177 /* Constructor */ :
                return -1937948672 /* ConstructorExcludes */ ;
            case 173 /* PropertyDeclaration */ :
                return -2013249536 /* PropertyExcludes */ ;
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return -2005057536 /* MethodOrAccessorExcludes */ ;
            case 133 /* AnyKeyword */ :
            case 150 /* NumberKeyword */ :
            case 163 /* BigIntKeyword */ :
            case 146 /* NeverKeyword */ :
            case 154 /* StringKeyword */ :
            case 151 /* ObjectKeyword */ :
            case 136 /* BooleanKeyword */ :
            case 155 /* SymbolKeyword */ :
            case 116 /* VoidKeyword */ :
            case 169 /* TypeParameter */ :
            case 172 /* PropertySignature */ :
            case 174 /* MethodSignature */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 182 /* IndexSignature */ :
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
                return -2 /* TypeExcludes */ ;
            case 211 /* ObjectLiteralExpression */ :
                return -2147278848 /* ObjectLiteralExcludes */ ;
            case 300 /* CatchClause */ :
                return -2147418112 /* CatchClauseExcludes */ ;
            case 207 /* ObjectBindingPattern */ :
            case 208 /* ArrayBindingPattern */ :
                return -2147450880 /* BindingPatternExcludes */ ;
            case 217 /* TypeAssertionExpression */ :
            case 239 /* SatisfiesExpression */ :
            case 235 /* AsExpression */ :
            case 356 /* PartiallyEmittedExpression */ :
            case 218 /* ParenthesizedExpression */ :
            case 108 /* SuperKeyword */ :
                return -2147483648 /* OuterExpressionExcludes */ ;
            case 212 /* PropertyAccessExpression */ :
            case 213 /* ElementAccessExpression */ :
                return -2147483648 /* PropertyAccessExcludes */ ;
            default:
                return -2147483648 /* NodeExcludes */ ;
        }
    }
    var baseFactory = createBaseNodeFactory();
    function makeSynthetic(node) {
        node.flags |= 16 /* Synthesized */ ;
        return node;
    }
    var syntheticFactory = {
        createBaseSourceFileNode: (kind)=>makeSynthetic(baseFactory.createBaseSourceFileNode(kind)),
        createBaseIdentifierNode: (kind)=>makeSynthetic(baseFactory.createBaseIdentifierNode(kind)),
        createBasePrivateIdentifierNode: (kind)=>makeSynthetic(baseFactory.createBasePrivateIdentifierNode(kind)),
        createBaseTokenNode: (kind)=>makeSynthetic(baseFactory.createBaseTokenNode(kind)),
        createBaseNode: (kind)=>makeSynthetic(baseFactory.createBaseNode(kind))
    };
    var factory = createNodeFactory(4 /* NoIndentationOnFreshPropertyAccess */ , syntheticFactory);
    var SourceMapSource2;
    function createSourceMapSource(fileName, text, skipTrivia2) {
        return new (SourceMapSource2 || (SourceMapSource2 = objectAllocator.getSourceMapSourceConstructor()))(fileName, text, skipTrivia2);
    }
    function setOriginalNode(node, original) {
        if (node.original !== original) {
            node.original = original;
            if (original) {
                const emitNode = original.emitNode;
                if (emitNode) node.emitNode = mergeEmitNode(emitNode, node.emitNode);
            }
        }
        return node;
    }
    function mergeEmitNode(sourceEmitNode, destEmitNode) {
        const { flags, internalFlags, leadingComments, trailingComments, commentRange, sourceMapRange, tokenSourceMapRanges, constantValue, helpers, startsOnNewLine, snippetElement, classThis, assignedName } = sourceEmitNode;
        if (!destEmitNode) destEmitNode = {};
        if (flags) destEmitNode.flags = flags;
        if (internalFlags) destEmitNode.internalFlags = internalFlags & -9 /* Immutable */ ;
        if (leadingComments) destEmitNode.leadingComments = addRange(leadingComments.slice(), destEmitNode.leadingComments);
        if (trailingComments) destEmitNode.trailingComments = addRange(trailingComments.slice(), destEmitNode.trailingComments);
        if (commentRange) destEmitNode.commentRange = commentRange;
        if (sourceMapRange) destEmitNode.sourceMapRange = sourceMapRange;
        if (tokenSourceMapRanges) destEmitNode.tokenSourceMapRanges = mergeTokenSourceMapRanges(tokenSourceMapRanges, destEmitNode.tokenSourceMapRanges);
        if (constantValue !== void 0) destEmitNode.constantValue = constantValue;
        if (helpers) for (const helper of helpers)destEmitNode.helpers = appendIfUnique(destEmitNode.helpers, helper);
        if (startsOnNewLine !== void 0) destEmitNode.startsOnNewLine = startsOnNewLine;
        if (snippetElement !== void 0) destEmitNode.snippetElement = snippetElement;
        if (classThis) destEmitNode.classThis = classThis;
        if (assignedName) destEmitNode.assignedName = assignedName;
        return destEmitNode;
    }
    function mergeTokenSourceMapRanges(sourceRanges, destRanges) {
        if (!destRanges) destRanges = [];
        for(const key in sourceRanges)destRanges[key] = sourceRanges[key];
        return destRanges;
    }
    // src/compiler/factory/emitNode.ts
    function getOrCreateEmitNode(node) {
        if (!node.emitNode) {
            if (isParseTreeNode(node)) {
                if (node.kind === 308 /* SourceFile */ ) return node.emitNode = {
                    annotatedNodes: [
                        node
                    ]
                };
                var _getSourceFileOfNode;
                const sourceFile = (_getSourceFileOfNode = getSourceFileOfNode(getParseTreeNode(getSourceFileOfNode(node)))) !== null && _getSourceFileOfNode !== void 0 ? _getSourceFileOfNode : Debug.fail("Could not determine parsed source file.");
                getOrCreateEmitNode(sourceFile).annotatedNodes.push(node);
            }
            node.emitNode = {};
        } else Debug.assert(!(node.emitNode.internalFlags & 8 /* Immutable */ ), "Invalid attempt to mutate an immutable node.");
        return node.emitNode;
    }
    function disposeEmitNodes(sourceFile) {
        var _a, _b;
        const annotatedNodes = (_b = (_a = getSourceFileOfNode(getParseTreeNode(sourceFile))) == null ? void 0 : _a.emitNode) == null ? void 0 : _b.annotatedNodes;
        if (annotatedNodes) for (const node of annotatedNodes)node.emitNode = void 0;
    }
    function removeAllComments(node) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.flags |= 3072 /* NoComments */ ;
        emitNode.leadingComments = void 0;
        emitNode.trailingComments = void 0;
        return node;
    }
    function setEmitFlags(node, emitFlags) {
        getOrCreateEmitNode(node).flags = emitFlags;
        return node;
    }
    function addEmitFlags(node, emitFlags) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.flags = emitNode.flags | emitFlags;
        return node;
    }
    function setInternalEmitFlags(node, emitFlags) {
        getOrCreateEmitNode(node).internalFlags = emitFlags;
        return node;
    }
    function addInternalEmitFlags(node, emitFlags) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.internalFlags = emitNode.internalFlags | emitFlags;
        return node;
    }
    function getSourceMapRange(node) {
        var _a;
        var _ref;
        return (_ref = (_a = node.emitNode) == null ? void 0 : _a.sourceMapRange) !== null && _ref !== void 0 ? _ref : node;
    }
    function setSourceMapRange(node, range) {
        getOrCreateEmitNode(node).sourceMapRange = range;
        return node;
    }
    function getTokenSourceMapRange(node, token) {
        var _a, _b;
        return (_b = (_a = node.emitNode) == null ? void 0 : _a.tokenSourceMapRanges) == null ? void 0 : _b[token];
    }
    function setTokenSourceMapRange(node, token, range) {
        const emitNode = getOrCreateEmitNode(node);
        var _emitNode_tokenSourceMapRanges;
        const tokenSourceMapRanges = (_emitNode_tokenSourceMapRanges = emitNode.tokenSourceMapRanges) !== null && _emitNode_tokenSourceMapRanges !== void 0 ? _emitNode_tokenSourceMapRanges : emitNode.tokenSourceMapRanges = [];
        tokenSourceMapRanges[token] = range;
        return node;
    }
    function getStartsOnNewLine(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.startsOnNewLine;
    }
    function setStartsOnNewLine(node, newLine) {
        getOrCreateEmitNode(node).startsOnNewLine = newLine;
        return node;
    }
    function getCommentRange(node) {
        var _a;
        var _ref;
        return (_ref = (_a = node.emitNode) == null ? void 0 : _a.commentRange) !== null && _ref !== void 0 ? _ref : node;
    }
    function setCommentRange(node, range) {
        getOrCreateEmitNode(node).commentRange = range;
        return node;
    }
    function getSyntheticLeadingComments(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.leadingComments;
    }
    function setSyntheticLeadingComments(node, comments) {
        getOrCreateEmitNode(node).leadingComments = comments;
        return node;
    }
    function addSyntheticLeadingComment(node, kind, text, hasTrailingNewLine) {
        return setSyntheticLeadingComments(node, append(getSyntheticLeadingComments(node), {
            kind,
            pos: -1,
            end: -1,
            hasTrailingNewLine,
            text
        }));
    }
    function getSyntheticTrailingComments(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.trailingComments;
    }
    function setSyntheticTrailingComments(node, comments) {
        getOrCreateEmitNode(node).trailingComments = comments;
        return node;
    }
    function addSyntheticTrailingComment(node, kind, text, hasTrailingNewLine) {
        return setSyntheticTrailingComments(node, append(getSyntheticTrailingComments(node), {
            kind,
            pos: -1,
            end: -1,
            hasTrailingNewLine,
            text
        }));
    }
    function moveSyntheticComments(node, original) {
        setSyntheticLeadingComments(node, getSyntheticLeadingComments(original));
        setSyntheticTrailingComments(node, getSyntheticTrailingComments(original));
        const emit = getOrCreateEmitNode(original);
        emit.leadingComments = void 0;
        emit.trailingComments = void 0;
        return node;
    }
    function getConstantValue(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.constantValue;
    }
    function setConstantValue(node, value1) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.constantValue = value1;
        return node;
    }
    function addEmitHelper(node, helper) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.helpers = append(emitNode.helpers, helper);
        return node;
    }
    function addEmitHelpers(node, helpers) {
        if (some(helpers)) {
            const emitNode = getOrCreateEmitNode(node);
            for (const helper of helpers)emitNode.helpers = appendIfUnique(emitNode.helpers, helper);
        }
        return node;
    }
    function removeEmitHelper(node, helper) {
        var _a;
        const helpers = (_a = node.emitNode) == null ? void 0 : _a.helpers;
        if (helpers) return orderedRemoveItem(helpers, helper);
        return false;
    }
    function getEmitHelpers(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.helpers;
    }
    function moveEmitHelpers(source, target, predicate) {
        const sourceEmitNode = source.emitNode;
        const sourceEmitHelpers = sourceEmitNode && sourceEmitNode.helpers;
        if (!some(sourceEmitHelpers)) return;
        const targetEmitNode = getOrCreateEmitNode(target);
        let helpersRemoved = 0;
        for(let i = 0; i < sourceEmitHelpers.length; i++){
            const helper = sourceEmitHelpers[i];
            if (predicate(helper)) {
                helpersRemoved++;
                targetEmitNode.helpers = appendIfUnique(targetEmitNode.helpers, helper);
            } else if (helpersRemoved > 0) sourceEmitHelpers[i - helpersRemoved] = helper;
        }
        if (helpersRemoved > 0) sourceEmitHelpers.length -= helpersRemoved;
    }
    function getSnippetElement(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.snippetElement;
    }
    function setSnippetElement(node, snippet) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.snippetElement = snippet;
        return node;
    }
    function ignoreSourceNewlines(node) {
        getOrCreateEmitNode(node).internalFlags |= 4 /* IgnoreSourceNewlines */ ;
        return node;
    }
    function setTypeNode(node, type) {
        const emitNode = getOrCreateEmitNode(node);
        emitNode.typeNode = type;
        return node;
    }
    function getTypeNode(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.typeNode;
    }
    function setIdentifierTypeArguments(node, typeArguments) {
        getOrCreateEmitNode(node).identifierTypeArguments = typeArguments;
        return node;
    }
    function getIdentifierTypeArguments(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.identifierTypeArguments;
    }
    function setIdentifierAutoGenerate(node, autoGenerate) {
        getOrCreateEmitNode(node).autoGenerate = autoGenerate;
        return node;
    }
    function getIdentifierAutoGenerate(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.autoGenerate;
    }
    function setIdentifierGeneratedImportReference(node, value1) {
        getOrCreateEmitNode(node).generatedImportReference = value1;
        return node;
    }
    function getIdentifierGeneratedImportReference(node) {
        var _a;
        return (_a = node.emitNode) == null ? void 0 : _a.generatedImportReference;
    }
    // src/compiler/factory/emitHelpers.ts
    var PrivateIdentifierKind = /* @__PURE__ */ ((PrivateIdentifierKind2)=>{
        PrivateIdentifierKind2["Field"] = "f";
        PrivateIdentifierKind2["Method"] = "m";
        PrivateIdentifierKind2["Accessor"] = "a";
        return PrivateIdentifierKind2;
    })(PrivateIdentifierKind || {});
    function createEmitHelperFactory(context) {
        const factory2 = context.factory;
        const immutableTrue = memoize(()=>setInternalEmitFlags(factory2.createTrue(), 8 /* Immutable */ ));
        const immutableFalse = memoize(()=>setInternalEmitFlags(factory2.createFalse(), 8 /* Immutable */ ));
        return {
            getUnscopedHelperName,
            // TypeScript Helpers
            createDecorateHelper,
            createMetadataHelper,
            createParamHelper,
            // ES Decorators Helpers
            createESDecorateHelper,
            createRunInitializersHelper,
            // ES2018 Helpers
            createAssignHelper,
            createAwaitHelper,
            createAsyncGeneratorHelper,
            createAsyncDelegatorHelper,
            createAsyncValuesHelper,
            // ES2018 Destructuring Helpers
            createRestHelper,
            // ES2017 Helpers
            createAwaiterHelper,
            // ES2015 Helpers
            createExtendsHelper,
            createTemplateObjectHelper,
            createSpreadArrayHelper,
            createPropKeyHelper,
            createSetFunctionNameHelper,
            // ES2015 Destructuring Helpers
            createValuesHelper,
            createReadHelper,
            // ES2015 Generator Helpers
            createGeneratorHelper,
            // ES Module Helpers
            createImportStarHelper,
            createImportStarCallbackHelper,
            createImportDefaultHelper,
            createExportStarHelper,
            // Class Fields Helpers
            createClassPrivateFieldGetHelper,
            createClassPrivateFieldSetHelper,
            createClassPrivateFieldInHelper,
            // 'using' helpers
            createAddDisposableResourceHelper,
            createDisposeResourcesHelper,
            // --rewriteRelativeImportExtensions helpers
            createRewriteRelativeImportExtensionsHelper
        };
        function getUnscopedHelperName(name) {
            return setEmitFlags(factory2.createIdentifier(name), 8196 /* AdviseOnEmitNode */ );
        }
        function createDecorateHelper(decoratorExpressions, target, memberName, descriptor) {
            context.requestEmitHelper(decorateHelper);
            const argumentsArray = [];
            argumentsArray.push(factory2.createArrayLiteralExpression(decoratorExpressions, /*multiLine*/ true));
            argumentsArray.push(target);
            if (memberName) {
                argumentsArray.push(memberName);
                if (descriptor) argumentsArray.push(descriptor);
            }
            return factory2.createCallExpression(getUnscopedHelperName("__decorate"), /*typeArguments*/ void 0, argumentsArray);
        }
        function createMetadataHelper(metadataKey, metadataValue) {
            context.requestEmitHelper(metadataHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__metadata"), /*typeArguments*/ void 0, [
                factory2.createStringLiteral(metadataKey),
                metadataValue
            ]);
        }
        function createParamHelper(expression, parameterOffset, location) {
            context.requestEmitHelper(paramHelper);
            return setTextRange(factory2.createCallExpression(getUnscopedHelperName("__param"), /*typeArguments*/ void 0, [
                factory2.createNumericLiteral(parameterOffset + ""),
                expression
            ]), location);
        }
        function createESDecorateClassContextObject(contextIn) {
            const properties = [
                factory2.createPropertyAssignment(factory2.createIdentifier("kind"), factory2.createStringLiteral("class")),
                factory2.createPropertyAssignment(factory2.createIdentifier("name"), contextIn.name),
                factory2.createPropertyAssignment(factory2.createIdentifier("metadata"), contextIn.metadata)
            ];
            return factory2.createObjectLiteralExpression(properties);
        }
        function createESDecorateClassElementAccessGetMethod(elementName) {
            const accessor = elementName.computed ? factory2.createElementAccessExpression(factory2.createIdentifier("obj"), elementName.name) : factory2.createPropertyAccessExpression(factory2.createIdentifier("obj"), elementName.name);
            return factory2.createPropertyAssignment("get", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("obj"))
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, accessor));
        }
        function createESDecorateClassElementAccessSetMethod(elementName) {
            const accessor = elementName.computed ? factory2.createElementAccessExpression(factory2.createIdentifier("obj"), elementName.name) : factory2.createPropertyAccessExpression(factory2.createIdentifier("obj"), elementName.name);
            return factory2.createPropertyAssignment("set", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("obj")),
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("value"))
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(accessor, factory2.createIdentifier("value")))
            ])));
        }
        function createESDecorateClassElementAccessHasMethod(elementName) {
            const propertyName = elementName.computed ? elementName.name : isIdentifier(elementName.name) ? factory2.createStringLiteralFromNode(elementName.name) : elementName.name;
            return factory2.createPropertyAssignment("has", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.createIdentifier("obj"))
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createBinaryExpression(propertyName, 103 /* InKeyword */ , factory2.createIdentifier("obj"))));
        }
        function createESDecorateClassElementAccessObject(name, access) {
            const properties = [];
            properties.push(createESDecorateClassElementAccessHasMethod(name));
            if (access.get) properties.push(createESDecorateClassElementAccessGetMethod(name));
            if (access.set) properties.push(createESDecorateClassElementAccessSetMethod(name));
            return factory2.createObjectLiteralExpression(properties);
        }
        function createESDecorateClassElementContextObject(contextIn) {
            const properties = [
                factory2.createPropertyAssignment(factory2.createIdentifier("kind"), factory2.createStringLiteral(contextIn.kind)),
                factory2.createPropertyAssignment(factory2.createIdentifier("name"), contextIn.name.computed ? contextIn.name.name : factory2.createStringLiteralFromNode(contextIn.name.name)),
                factory2.createPropertyAssignment(factory2.createIdentifier("static"), contextIn.static ? factory2.createTrue() : factory2.createFalse()),
                factory2.createPropertyAssignment(factory2.createIdentifier("private"), contextIn.private ? factory2.createTrue() : factory2.createFalse()),
                factory2.createPropertyAssignment(factory2.createIdentifier("access"), createESDecorateClassElementAccessObject(contextIn.name, contextIn.access)),
                factory2.createPropertyAssignment(factory2.createIdentifier("metadata"), contextIn.metadata)
            ];
            return factory2.createObjectLiteralExpression(properties);
        }
        function createESDecorateContextObject(contextIn) {
            return contextIn.kind === "class" ? createESDecorateClassContextObject(contextIn) : createESDecorateClassElementContextObject(contextIn);
        }
        function createESDecorateHelper(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
            context.requestEmitHelper(esDecorateHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__esDecorate"), /*typeArguments*/ void 0, [
                ctor !== null && ctor !== void 0 ? ctor : factory2.createNull(),
                descriptorIn !== null && descriptorIn !== void 0 ? descriptorIn : factory2.createNull(),
                decorators,
                createESDecorateContextObject(contextIn),
                initializers,
                extraInitializers
            ]);
        }
        function createRunInitializersHelper(thisArg, initializers, value1) {
            context.requestEmitHelper(runInitializersHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__runInitializers"), /*typeArguments*/ void 0, value1 ? [
                thisArg,
                initializers,
                value1
            ] : [
                thisArg,
                initializers
            ]);
        }
        function createAssignHelper(attributesSegments) {
            if (getEmitScriptTarget(context.getCompilerOptions()) >= 2 /* ES2015 */ ) return factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "assign"), /*typeArguments*/ void 0, attributesSegments);
            context.requestEmitHelper(assignHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__assign"), /*typeArguments*/ void 0, attributesSegments);
        }
        function createAwaitHelper(expression) {
            context.requestEmitHelper(awaitHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__await"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createAsyncGeneratorHelper(generatorFunc, hasLexicalThis) {
            context.requestEmitHelper(awaitHelper);
            context.requestEmitHelper(asyncGeneratorHelper);
            (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 1572864 /* ReuseTempVariableScope */ ;
            return factory2.createCallExpression(getUnscopedHelperName("__asyncGenerator"), /*typeArguments*/ void 0, [
                hasLexicalThis ? factory2.createThis() : factory2.createVoidZero(),
                factory2.createIdentifier("arguments"),
                generatorFunc
            ]);
        }
        function createAsyncDelegatorHelper(expression) {
            context.requestEmitHelper(awaitHelper);
            context.requestEmitHelper(asyncDelegator);
            return factory2.createCallExpression(getUnscopedHelperName("__asyncDelegator"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createAsyncValuesHelper(expression) {
            context.requestEmitHelper(asyncValues);
            return factory2.createCallExpression(getUnscopedHelperName("__asyncValues"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createRestHelper(value1, elements, computedTempVariables, location) {
            context.requestEmitHelper(restHelper);
            const propertyNames = [];
            let computedTempVariableOffset = 0;
            for(let i = 0; i < elements.length - 1; i++){
                const propertyName = getPropertyNameOfBindingOrAssignmentElement(elements[i]);
                if (propertyName) {
                    if (isComputedPropertyName(propertyName)) {
                        Debug.assertIsDefined(computedTempVariables, "Encountered computed property name but 'computedTempVariables' argument was not provided.");
                        const temp = computedTempVariables[computedTempVariableOffset];
                        computedTempVariableOffset++;
                        propertyNames.push(factory2.createConditionalExpression(factory2.createTypeCheck(temp, "symbol"), /*questionToken*/ void 0, temp, /*colonToken*/ void 0, factory2.createAdd(temp, factory2.createStringLiteral(""))));
                    } else propertyNames.push(factory2.createStringLiteralFromNode(propertyName));
                }
            }
            return factory2.createCallExpression(getUnscopedHelperName("__rest"), /*typeArguments*/ void 0, [
                value1,
                setTextRange(factory2.createArrayLiteralExpression(propertyNames), location)
            ]);
        }
        function createAwaiterHelper(hasLexicalThis, argumentsExpression, promiseConstructor, parameters, body) {
            context.requestEmitHelper(awaiterHelper);
            const generatorFunc = factory2.createFunctionExpression(/*modifiers*/ void 0, factory2.createToken(42 /* AsteriskToken */ ), /*name*/ void 0, /*typeParameters*/ void 0, parameters !== null && parameters !== void 0 ? parameters : [], /*type*/ void 0, body);
            (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 1572864 /* ReuseTempVariableScope */ ;
            return factory2.createCallExpression(getUnscopedHelperName("__awaiter"), /*typeArguments*/ void 0, [
                hasLexicalThis ? factory2.createThis() : factory2.createVoidZero(),
                argumentsExpression !== null && argumentsExpression !== void 0 ? argumentsExpression : factory2.createVoidZero(),
                promiseConstructor ? createExpressionFromEntityName(factory2, promiseConstructor) : factory2.createVoidZero(),
                generatorFunc
            ]);
        }
        function createExtendsHelper(name) {
            context.requestEmitHelper(extendsHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__extends"), /*typeArguments*/ void 0, [
                name,
                factory2.createUniqueName("_super", 48 /* FileLevel */ )
            ]);
        }
        function createTemplateObjectHelper(cooked, raw) {
            context.requestEmitHelper(templateObjectHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__makeTemplateObject"), /*typeArguments*/ void 0, [
                cooked,
                raw
            ]);
        }
        function createSpreadArrayHelper(to, from, packFrom) {
            context.requestEmitHelper(spreadArrayHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__spreadArray"), /*typeArguments*/ void 0, [
                to,
                from,
                packFrom ? immutableTrue() : immutableFalse()
            ]);
        }
        function createPropKeyHelper(expr) {
            context.requestEmitHelper(propKeyHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__propKey"), /*typeArguments*/ void 0, [
                expr
            ]);
        }
        function createSetFunctionNameHelper(f, name, prefix) {
            context.requestEmitHelper(setFunctionNameHelper);
            return context.factory.createCallExpression(getUnscopedHelperName("__setFunctionName"), /*typeArguments*/ void 0, prefix ? [
                f,
                name,
                context.factory.createStringLiteral(prefix)
            ] : [
                f,
                name
            ]);
        }
        function createValuesHelper(expression) {
            context.requestEmitHelper(valuesHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__values"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createReadHelper(iteratorRecord, count) {
            context.requestEmitHelper(readHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__read"), /*typeArguments*/ void 0, count !== void 0 ? [
                iteratorRecord,
                factory2.createNumericLiteral(count + "")
            ] : [
                iteratorRecord
            ]);
        }
        function createGeneratorHelper(body) {
            context.requestEmitHelper(generatorHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__generator"), /*typeArguments*/ void 0, [
                factory2.createThis(),
                body
            ]);
        }
        function createImportStarHelper(expression) {
            context.requestEmitHelper(importStarHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__importStar"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createImportStarCallbackHelper() {
            context.requestEmitHelper(importStarHelper);
            return getUnscopedHelperName("__importStar");
        }
        function createImportDefaultHelper(expression) {
            context.requestEmitHelper(importDefaultHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__importDefault"), /*typeArguments*/ void 0, [
                expression
            ]);
        }
        function createExportStarHelper(moduleExpression, exportsExpression = factory2.createIdentifier("exports")) {
            context.requestEmitHelper(exportStarHelper);
            context.requestEmitHelper(createBindingHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__exportStar"), /*typeArguments*/ void 0, [
                moduleExpression,
                exportsExpression
            ]);
        }
        function createClassPrivateFieldGetHelper(receiver, state, kind, f) {
            context.requestEmitHelper(classPrivateFieldGetHelper);
            let args;
            if (!f) args = [
                receiver,
                state,
                factory2.createStringLiteral(kind)
            ];
            else args = [
                receiver,
                state,
                factory2.createStringLiteral(kind),
                f
            ];
            return factory2.createCallExpression(getUnscopedHelperName("__classPrivateFieldGet"), /*typeArguments*/ void 0, args);
        }
        function createClassPrivateFieldSetHelper(receiver, state, value1, kind, f) {
            context.requestEmitHelper(classPrivateFieldSetHelper);
            let args;
            if (!f) args = [
                receiver,
                state,
                value1,
                factory2.createStringLiteral(kind)
            ];
            else args = [
                receiver,
                state,
                value1,
                factory2.createStringLiteral(kind),
                f
            ];
            return factory2.createCallExpression(getUnscopedHelperName("__classPrivateFieldSet"), /*typeArguments*/ void 0, args);
        }
        function createClassPrivateFieldInHelper(state, receiver) {
            context.requestEmitHelper(classPrivateFieldInHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__classPrivateFieldIn"), /*typeArguments*/ void 0, [
                state,
                receiver
            ]);
        }
        function createAddDisposableResourceHelper(envBinding, value1, async) {
            context.requestEmitHelper(addDisposableResourceHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__addDisposableResource"), /*typeArguments*/ void 0, [
                envBinding,
                value1,
                async ? factory2.createTrue() : factory2.createFalse()
            ]);
        }
        function createDisposeResourcesHelper(envBinding) {
            context.requestEmitHelper(disposeResourcesHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__disposeResources"), /*typeArguments*/ void 0, [
                envBinding
            ]);
        }
        function createRewriteRelativeImportExtensionsHelper(expression) {
            context.requestEmitHelper(rewriteRelativeImportExtensionsHelper);
            return factory2.createCallExpression(getUnscopedHelperName("__rewriteRelativeImportExtension"), /*typeArguments*/ void 0, context.getCompilerOptions().jsx === 1 /* Preserve */  ? [
                expression,
                factory2.createTrue()
            ] : [
                expression
            ]);
        }
    }
    function compareEmitHelpers(x, y) {
        if (x === y) return 0 /* EqualTo */ ;
        if (x.priority === y.priority) return 0 /* EqualTo */ ;
        if (x.priority === void 0) return 1 /* GreaterThan */ ;
        if (y.priority === void 0) return -1 /* LessThan */ ;
        return compareValues(x.priority, y.priority);
    }
    function helperString(input, ...args) {
        return (uniqueName)=>{
            let result = "";
            for(let i = 0; i < args.length; i++){
                result += input[i];
                result += uniqueName(args[i]);
            }
            result += input[input.length - 1];
            return result;
        };
    }
    var decorateHelper = {
        name: "typescript:decorate",
        importName: "__decorate",
        scoped: false,
        priority: 2,
        text: `
            var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };`
    };
    var metadataHelper = {
        name: "typescript:metadata",
        importName: "__metadata",
        scoped: false,
        priority: 3,
        text: `
            var __metadata = (this && this.__metadata) || function (k, v) {
                if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
            };`
    };
    var paramHelper = {
        name: "typescript:param",
        importName: "__param",
        scoped: false,
        priority: 4,
        text: `
            var __param = (this && this.__param) || function (paramIndex, decorator) {
                return function (target, key) { decorator(target, key, paramIndex); }
            };`
    };
    var esDecorateHelper = {
        name: "typescript:esDecorate",
        importName: "__esDecorate",
        scoped: false,
        priority: 2,
        text: `
        var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
            function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
            var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
            var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
            var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
            var _, done = false;
            for (var i = decorators.length - 1; i >= 0; i--) {
                var context = {};
                for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
                for (var p in contextIn.access) context.access[p] = contextIn.access[p];
                context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
                var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
                if (kind === "accessor") {
                    if (result === void 0) continue;
                    if (result === null || typeof result !== "object") throw new TypeError("Object expected");
                    if (_ = accept(result.get)) descriptor.get = _;
                    if (_ = accept(result.set)) descriptor.set = _;
                    if (_ = accept(result.init)) initializers.unshift(_);
                }
                else if (_ = accept(result)) {
                    if (kind === "field") initializers.unshift(_);
                    else descriptor[key] = _;
                }
            }
            if (target) Object.defineProperty(target, contextIn.name, descriptor);
            done = true;
        };`
    };
    var runInitializersHelper = {
        name: "typescript:runInitializers",
        importName: "__runInitializers",
        scoped: false,
        priority: 2,
        text: `
        var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
            var useValue = arguments.length > 2;
            for (var i = 0; i < initializers.length; i++) {
                value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
            }
            return useValue ? value : void 0;
        };`
    };
    var assignHelper = {
        name: "typescript:assign",
        importName: "__assign",
        scoped: false,
        priority: 1,
        text: `
            var __assign = (this && this.__assign) || function () {
                __assign = Object.assign || function(t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                        s = arguments[i];
                        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                            t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };`
    };
    var awaitHelper = {
        name: "typescript:await",
        importName: "__await",
        scoped: false,
        text: `
            var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }`
    };
    var asyncGeneratorHelper = {
        name: "typescript:asyncGenerator",
        importName: "__asyncGenerator",
        scoped: false,
        dependencies: [
            awaitHelper
        ],
        text: `
        var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
            if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
            var g = generator.apply(thisArg, _arguments || []), i, q = [];
            return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
            function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
            function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
            function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
            function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
            function fulfill(value) { resume("next", value); }
            function reject(value) { resume("throw", value); }
            function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
        };`
    };
    var asyncDelegator = {
        name: "typescript:asyncDelegator",
        importName: "__asyncDelegator",
        scoped: false,
        dependencies: [
            awaitHelper
        ],
        text: `
            var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
                var i, p;
                return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
                function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
            };`
    };
    var asyncValues = {
        name: "typescript:asyncValues",
        importName: "__asyncValues",
        scoped: false,
        text: `
            var __asyncValues = (this && this.__asyncValues) || function (o) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var m = o[Symbol.asyncIterator], i;
                return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
                function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
                function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
            };`
    };
    var restHelper = {
        name: "typescript:rest",
        importName: "__rest",
        scoped: false,
        text: `
            var __rest = (this && this.__rest) || function (s, e) {
                var t = {};
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
                    t[p] = s[p];
                if (s != null && typeof Object.getOwnPropertySymbols === "function")
                    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                            t[p[i]] = s[p[i]];
                    }
                return t;
            };`
    };
    var awaiterHelper = {
        name: "typescript:awaiter",
        importName: "__awaiter",
        scoped: false,
        priority: 5,
        text: `
            var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
                function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
                return new (P || (P = Promise))(function (resolve, reject) {
                    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
                    function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
                    function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };`
    };
    var extendsHelper = {
        name: "typescript:extends",
        importName: "__extends",
        scoped: false,
        priority: 0,
        text: `
            var __extends = (this && this.__extends) || (function () {
                var extendStatics = function (d, b) {
                    extendStatics = Object.setPrototypeOf ||
                        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
                        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
                    return extendStatics(d, b);
                };

                return function (d, b) {
                    if (typeof b !== "function" && b !== null)
                        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() { this.constructor = d; }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            })();`
    };
    var templateObjectHelper = {
        name: "typescript:makeTemplateObject",
        importName: "__makeTemplateObject",
        scoped: false,
        priority: 0,
        text: `
            var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
                if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
                return cooked;
            };`
    };
    var readHelper = {
        name: "typescript:read",
        importName: "__read",
        scoped: false,
        text: `
            var __read = (this && this.__read) || function (o, n) {
                var m = typeof Symbol === "function" && o[Symbol.iterator];
                if (!m) return o;
                var i = m.call(o), r, ar = [], e;
                try {
                    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
                }
                catch (error) { e = { error: error }; }
                finally {
                    try {
                        if (r && !r.done && (m = i["return"])) m.call(i);
                    }
                    finally { if (e) throw e.error; }
                }
                return ar;
            };`
    };
    var spreadArrayHelper = {
        name: "typescript:spreadArray",
        importName: "__spreadArray",
        scoped: false,
        text: `
            var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
                if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
                    if (ar || !(i in from)) {
                        if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                        ar[i] = from[i];
                    }
                }
                return to.concat(ar || Array.prototype.slice.call(from));
            };`
    };
    var propKeyHelper = {
        name: "typescript:propKey",
        importName: "__propKey",
        scoped: false,
        text: `
        var __propKey = (this && this.__propKey) || function (x) {
            return typeof x === "symbol" ? x : "".concat(x);
        };`
    };
    var setFunctionNameHelper = {
        name: "typescript:setFunctionName",
        importName: "__setFunctionName",
        scoped: false,
        text: `
        var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
            if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
            return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
        };`
    };
    var valuesHelper = {
        name: "typescript:values",
        importName: "__values",
        scoped: false,
        text: `
            var __values = (this && this.__values) || function(o) {
                var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
                if (m) return m.call(o);
                if (o && typeof o.length === "number") return {
                    next: function () {
                        if (o && i >= o.length) o = void 0;
                        return { value: o && o[i++], done: !o };
                    }
                };
                throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
            };`
    };
    var generatorHelper = {
        name: "typescript:generator",
        importName: "__generator",
        scoped: false,
        priority: 6,
        text: `
            var __generator = (this && this.__generator) || function (thisArg, body) {
                var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
                return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
                function verb(n) { return function (v) { return step([n, v]); }; }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while (g && (g = 0, op[0] && (_ = 0)), _) try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [op[0] & 2, t.value];
                        switch (op[0]) {
                            case 0: case 1: t = op; break;
                            case 4: _.label++; return { value: op[1], done: false };
                            case 5: _.label++; y = op[1]; op = [0]; continue;
                            case 7: op = _.ops.pop(); _.trys.pop(); continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                                if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                                if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                                if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                                if (t[2]) _.ops.pop();
                                _.trys.pop(); continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
                    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
                }
            };`
    };
    var createBindingHelper = {
        name: "typescript:commonjscreatebinding",
        importName: "__createBinding",
        scoped: false,
        priority: 1,
        text: `
            var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                var desc = Object.getOwnPropertyDescriptor(m, k);
                if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
                  desc = { enumerable: true, get: function() { return m[k]; } };
                }
                Object.defineProperty(o, k2, desc);
            }) : (function(o, m, k, k2) {
                if (k2 === undefined) k2 = k;
                o[k2] = m[k];
            }));`
    };
    var setModuleDefaultHelper = {
        name: "typescript:commonjscreatevalue",
        importName: "__setModuleDefault",
        scoped: false,
        priority: 1,
        text: `
            var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
                Object.defineProperty(o, "default", { enumerable: true, value: v });
            }) : function(o, v) {
                o["default"] = v;
            });`
    };
    var importStarHelper = {
        name: "typescript:commonjsimportstar",
        importName: "__importStar",
        scoped: false,
        dependencies: [
            createBindingHelper,
            setModuleDefaultHelper
        ],
        priority: 2,
        text: `
            var __importStar = (this && this.__importStar) || (function () {
                var ownKeys = function(o) {
                    ownKeys = Object.getOwnPropertyNames || function (o) {
                        var ar = [];
                        for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
                        return ar;
                    };
                    return ownKeys(o);
                };
                return function (mod) {
                    if (mod && mod.__esModule) return mod;
                    var result = {};
                    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
                    __setModuleDefault(result, mod);
                    return result;
                };
            })();`
    };
    var importDefaultHelper = {
        name: "typescript:commonjsimportdefault",
        importName: "__importDefault",
        scoped: false,
        text: `
            var __importDefault = (this && this.__importDefault) || function (mod) {
                return (mod && mod.__esModule) ? mod : { "default": mod };
            };`
    };
    var exportStarHelper = {
        name: "typescript:export-star",
        importName: "__exportStar",
        scoped: false,
        dependencies: [
            createBindingHelper
        ],
        priority: 2,
        text: `
            var __exportStar = (this && this.__exportStar) || function(m, exports) {
                for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
            };`
    };
    var classPrivateFieldGetHelper = {
        name: "typescript:classPrivateFieldGet",
        importName: "__classPrivateFieldGet",
        scoped: false,
        text: `
            var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
                if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
                if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
            };`
    };
    var classPrivateFieldSetHelper = {
        name: "typescript:classPrivateFieldSet",
        importName: "__classPrivateFieldSet",
        scoped: false,
        text: `
            var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
                if (kind === "m") throw new TypeError("Private method is not writable");
                if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
                if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
            };`
    };
    var classPrivateFieldInHelper = {
        name: "typescript:classPrivateFieldIn",
        importName: "__classPrivateFieldIn",
        scoped: false,
        text: `
            var __classPrivateFieldIn = (this && this.__classPrivateFieldIn) || function(state, receiver) {
                if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
                return typeof state === "function" ? receiver === state : state.has(receiver);
            };`
    };
    var addDisposableResourceHelper = {
        name: "typescript:addDisposableResource",
        importName: "__addDisposableResource",
        scoped: false,
        text: `
        var __addDisposableResource = (this && this.__addDisposableResource) || function (env, value, async) {
            if (value !== null && value !== void 0) {
                if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
                var dispose, inner;
                if (async) {
                    if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
                    dispose = value[Symbol.asyncDispose];
                }
                if (dispose === void 0) {
                    if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
                    dispose = value[Symbol.dispose];
                    if (async) inner = dispose;
                }
                if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
                if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
                env.stack.push({ value: value, dispose: dispose, async: async });
            }
            else if (async) {
                env.stack.push({ async: true });
            }
            return value;
        };`
    };
    var disposeResourcesHelper = {
        name: "typescript:disposeResources",
        importName: "__disposeResources",
        scoped: false,
        text: `
        var __disposeResources = (this && this.__disposeResources) || (function (SuppressedError) {
            return function (env) {
                function fail(e) {
                    env.error = env.hasError ? new SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
                    env.hasError = true;
                }
                var r, s = 0;
                function next() {
                    while (r = env.stack.pop()) {
                        try {
                            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
                            if (r.dispose) {
                                var result = r.dispose.call(r.value);
                                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
                            }
                            else s |= 1;
                        }
                        catch (e) {
                            fail(e);
                        }
                    }
                    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
                    if (env.hasError) throw env.error;
                }
                return next();
            };
        })(typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
            var e = new Error(message);
            return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
        });`
    };
    var rewriteRelativeImportExtensionsHelper = {
        name: "typescript:rewriteRelativeImportExtensions",
        importName: "__rewriteRelativeImportExtension",
        scoped: false,
        text: `
        var __rewriteRelativeImportExtension = (this && this.__rewriteRelativeImportExtension) || function (path, preserveJsx) {
            if (typeof path === "string" && /^\\.\\.?\\//.test(path)) {
                return path.replace(/\\.(tsx)$|((?:\\.d)?)((?:\\.[^./]+?)?)\\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
                    return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
                });
            }
            return path;
        };`
    };
    var asyncSuperHelper = {
        name: "typescript:async-super",
        scoped: true,
        text: helperString(t || (t = _`
            const ${0} = name => super[name];`), "_superIndex")
    };
    var advancedAsyncSuperHelper = {
        name: "typescript:advanced-async-super",
        scoped: true,
        text: helperString(t1 || (t1 = _`
            const ${0} = (function (geti, seti) {
                const cache = Object.create(null);
                return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });
            })(name => super[name], (name, value) => super[name] = value);`), "_superIndex")
    };
    function isCallToHelper(firstSegment, helperName) {
        return isCallExpression(firstSegment) && isIdentifier(firstSegment.expression) && (getEmitFlags(firstSegment.expression) & 8192 /* HelperName */ ) !== 0 && firstSegment.expression.escapedText === helperName;
    }
    // src/compiler/factory/nodeTests.ts
    function isNumericLiteral(node) {
        return node.kind === 9 /* NumericLiteral */ ;
    }
    function isBigIntLiteral(node) {
        return node.kind === 10 /* BigIntLiteral */ ;
    }
    function isStringLiteral(node) {
        return node.kind === 11 /* StringLiteral */ ;
    }
    function isJsxText(node) {
        return node.kind === 12 /* JsxText */ ;
    }
    function isRegularExpressionLiteral(node) {
        return node.kind === 14 /* RegularExpressionLiteral */ ;
    }
    function isNoSubstitutionTemplateLiteral(node) {
        return node.kind === 15 /* NoSubstitutionTemplateLiteral */ ;
    }
    function isTemplateHead(node) {
        return node.kind === 16 /* TemplateHead */ ;
    }
    function isTemplateMiddle(node) {
        return node.kind === 17 /* TemplateMiddle */ ;
    }
    function isTemplateTail(node) {
        return node.kind === 18 /* TemplateTail */ ;
    }
    function isDotDotDotToken(node) {
        return node.kind === 26 /* DotDotDotToken */ ;
    }
    function isCommaToken(node) {
        return node.kind === 28 /* CommaToken */ ;
    }
    function isPlusToken(node) {
        return node.kind === 40 /* PlusToken */ ;
    }
    function isMinusToken(node) {
        return node.kind === 41 /* MinusToken */ ;
    }
    function isAsteriskToken(node) {
        return node.kind === 42 /* AsteriskToken */ ;
    }
    function isExclamationToken(node) {
        return node.kind === 54 /* ExclamationToken */ ;
    }
    function isQuestionToken(node) {
        return node.kind === 58 /* QuestionToken */ ;
    }
    function isColonToken(node) {
        return node.kind === 59 /* ColonToken */ ;
    }
    function isQuestionDotToken(node) {
        return node.kind === 29 /* QuestionDotToken */ ;
    }
    function isEqualsGreaterThanToken(node) {
        return node.kind === 39 /* EqualsGreaterThanToken */ ;
    }
    function isIdentifier(node) {
        return node.kind === 80 /* Identifier */ ;
    }
    function isPrivateIdentifier(node) {
        return node.kind === 81 /* PrivateIdentifier */ ;
    }
    function isExportModifier(node) {
        return node.kind === 95 /* ExportKeyword */ ;
    }
    function isDefaultModifier(node) {
        return node.kind === 90 /* DefaultKeyword */ ;
    }
    function isAsyncModifier(node) {
        return node.kind === 134 /* AsyncKeyword */ ;
    }
    function isAssertsKeyword(node) {
        return node.kind === 131 /* AssertsKeyword */ ;
    }
    function isAwaitKeyword(node) {
        return node.kind === 135 /* AwaitKeyword */ ;
    }
    function isReadonlyKeyword(node) {
        return node.kind === 148 /* ReadonlyKeyword */ ;
    }
    function isStaticModifier(node) {
        return node.kind === 126 /* StaticKeyword */ ;
    }
    function isAbstractModifier(node) {
        return node.kind === 128 /* AbstractKeyword */ ;
    }
    function isOverrideModifier(node) {
        return node.kind === 164 /* OverrideKeyword */ ;
    }
    function isAccessorModifier(node) {
        return node.kind === 129 /* AccessorKeyword */ ;
    }
    function isSuperKeyword(node) {
        return node.kind === 108 /* SuperKeyword */ ;
    }
    function isImportKeyword(node) {
        return node.kind === 102 /* ImportKeyword */ ;
    }
    function isCaseKeyword(node) {
        return node.kind === 84 /* CaseKeyword */ ;
    }
    function isQualifiedName(node) {
        return node.kind === 167 /* QualifiedName */ ;
    }
    function isComputedPropertyName(node) {
        return node.kind === 168 /* ComputedPropertyName */ ;
    }
    function isTypeParameterDeclaration(node) {
        return node.kind === 169 /* TypeParameter */ ;
    }
    function isParameter(node) {
        return node.kind === 170 /* Parameter */ ;
    }
    function isDecorator(node) {
        return node.kind === 171 /* Decorator */ ;
    }
    function isPropertySignature(node) {
        return node.kind === 172 /* PropertySignature */ ;
    }
    function isPropertyDeclaration(node) {
        return node.kind === 173 /* PropertyDeclaration */ ;
    }
    function isMethodSignature(node) {
        return node.kind === 174 /* MethodSignature */ ;
    }
    function isMethodDeclaration(node) {
        return node.kind === 175 /* MethodDeclaration */ ;
    }
    function isClassStaticBlockDeclaration(node) {
        return node.kind === 176 /* ClassStaticBlockDeclaration */ ;
    }
    function isConstructorDeclaration(node) {
        return node.kind === 177 /* Constructor */ ;
    }
    function isGetAccessorDeclaration(node) {
        return node.kind === 178 /* GetAccessor */ ;
    }
    function isSetAccessorDeclaration(node) {
        return node.kind === 179 /* SetAccessor */ ;
    }
    function isCallSignatureDeclaration(node) {
        return node.kind === 180 /* CallSignature */ ;
    }
    function isConstructSignatureDeclaration(node) {
        return node.kind === 181 /* ConstructSignature */ ;
    }
    function isIndexSignatureDeclaration(node) {
        return node.kind === 182 /* IndexSignature */ ;
    }
    function isTypePredicateNode(node) {
        return node.kind === 183 /* TypePredicate */ ;
    }
    function isTypeReferenceNode(node) {
        return node.kind === 184 /* TypeReference */ ;
    }
    function isFunctionTypeNode(node) {
        return node.kind === 185 /* FunctionType */ ;
    }
    function isConstructorTypeNode(node) {
        return node.kind === 186 /* ConstructorType */ ;
    }
    function isTypeQueryNode(node) {
        return node.kind === 187 /* TypeQuery */ ;
    }
    function isTypeLiteralNode(node) {
        return node.kind === 188 /* TypeLiteral */ ;
    }
    function isArrayTypeNode(node) {
        return node.kind === 189 /* ArrayType */ ;
    }
    function isTupleTypeNode(node) {
        return node.kind === 190 /* TupleType */ ;
    }
    function isNamedTupleMember(node) {
        return node.kind === 203 /* NamedTupleMember */ ;
    }
    function isOptionalTypeNode(node) {
        return node.kind === 191 /* OptionalType */ ;
    }
    function isRestTypeNode(node) {
        return node.kind === 192 /* RestType */ ;
    }
    function isUnionTypeNode(node) {
        return node.kind === 193 /* UnionType */ ;
    }
    function isIntersectionTypeNode(node) {
        return node.kind === 194 /* IntersectionType */ ;
    }
    function isConditionalTypeNode(node) {
        return node.kind === 195 /* ConditionalType */ ;
    }
    function isInferTypeNode(node) {
        return node.kind === 196 /* InferType */ ;
    }
    function isParenthesizedTypeNode(node) {
        return node.kind === 197 /* ParenthesizedType */ ;
    }
    function isThisTypeNode(node) {
        return node.kind === 198 /* ThisType */ ;
    }
    function isTypeOperatorNode(node) {
        return node.kind === 199 /* TypeOperator */ ;
    }
    function isIndexedAccessTypeNode(node) {
        return node.kind === 200 /* IndexedAccessType */ ;
    }
    function isMappedTypeNode(node) {
        return node.kind === 201 /* MappedType */ ;
    }
    function isLiteralTypeNode(node) {
        return node.kind === 202 /* LiteralType */ ;
    }
    function isImportTypeNode(node) {
        return node.kind === 206 /* ImportType */ ;
    }
    function isTemplateLiteralTypeSpan(node) {
        return node.kind === 205 /* TemplateLiteralTypeSpan */ ;
    }
    function isTemplateLiteralTypeNode(node) {
        return node.kind === 204 /* TemplateLiteralType */ ;
    }
    function isObjectBindingPattern(node) {
        return node.kind === 207 /* ObjectBindingPattern */ ;
    }
    function isArrayBindingPattern(node) {
        return node.kind === 208 /* ArrayBindingPattern */ ;
    }
    function isBindingElement(node) {
        return node.kind === 209 /* BindingElement */ ;
    }
    function isArrayLiteralExpression(node) {
        return node.kind === 210 /* ArrayLiteralExpression */ ;
    }
    function isObjectLiteralExpression(node) {
        return node.kind === 211 /* ObjectLiteralExpression */ ;
    }
    function isPropertyAccessExpression(node) {
        return node.kind === 212 /* PropertyAccessExpression */ ;
    }
    function isElementAccessExpression(node) {
        return node.kind === 213 /* ElementAccessExpression */ ;
    }
    function isCallExpression(node) {
        return node.kind === 214 /* CallExpression */ ;
    }
    function isNewExpression(node) {
        return node.kind === 215 /* NewExpression */ ;
    }
    function isTaggedTemplateExpression(node) {
        return node.kind === 216 /* TaggedTemplateExpression */ ;
    }
    function isTypeAssertionExpression(node) {
        return node.kind === 217 /* TypeAssertionExpression */ ;
    }
    function isParenthesizedExpression(node) {
        return node.kind === 218 /* ParenthesizedExpression */ ;
    }
    function isFunctionExpression(node) {
        return node.kind === 219 /* FunctionExpression */ ;
    }
    function isArrowFunction(node) {
        return node.kind === 220 /* ArrowFunction */ ;
    }
    function isDeleteExpression(node) {
        return node.kind === 221 /* DeleteExpression */ ;
    }
    function isTypeOfExpression(node) {
        return node.kind === 222 /* TypeOfExpression */ ;
    }
    function isVoidExpression(node) {
        return node.kind === 223 /* VoidExpression */ ;
    }
    function isAwaitExpression(node) {
        return node.kind === 224 /* AwaitExpression */ ;
    }
    function isPrefixUnaryExpression(node) {
        return node.kind === 225 /* PrefixUnaryExpression */ ;
    }
    function isPostfixUnaryExpression(node) {
        return node.kind === 226 /* PostfixUnaryExpression */ ;
    }
    function isBinaryExpression(node) {
        return node.kind === 227 /* BinaryExpression */ ;
    }
    function isConditionalExpression(node) {
        return node.kind === 228 /* ConditionalExpression */ ;
    }
    function isTemplateExpression(node) {
        return node.kind === 229 /* TemplateExpression */ ;
    }
    function isYieldExpression(node) {
        return node.kind === 230 /* YieldExpression */ ;
    }
    function isSpreadElement(node) {
        return node.kind === 231 /* SpreadElement */ ;
    }
    function isClassExpression(node) {
        return node.kind === 232 /* ClassExpression */ ;
    }
    function isOmittedExpression(node) {
        return node.kind === 233 /* OmittedExpression */ ;
    }
    function isExpressionWithTypeArguments(node) {
        return node.kind === 234 /* ExpressionWithTypeArguments */ ;
    }
    function isAsExpression(node) {
        return node.kind === 235 /* AsExpression */ ;
    }
    function isSatisfiesExpression(node) {
        return node.kind === 239 /* SatisfiesExpression */ ;
    }
    function isNonNullExpression(node) {
        return node.kind === 236 /* NonNullExpression */ ;
    }
    function isMetaProperty(node) {
        return node.kind === 237 /* MetaProperty */ ;
    }
    function isSyntheticExpression(node) {
        return node.kind === 238 /* SyntheticExpression */ ;
    }
    function isPartiallyEmittedExpression(node) {
        return node.kind === 356 /* PartiallyEmittedExpression */ ;
    }
    function isCommaListExpression(node) {
        return node.kind === 357 /* CommaListExpression */ ;
    }
    function isTemplateSpan(node) {
        return node.kind === 240 /* TemplateSpan */ ;
    }
    function isSemicolonClassElement(node) {
        return node.kind === 241 /* SemicolonClassElement */ ;
    }
    function isBlock(node) {
        return node.kind === 242 /* Block */ ;
    }
    function isVariableStatement(node) {
        return node.kind === 244 /* VariableStatement */ ;
    }
    function isEmptyStatement(node) {
        return node.kind === 243 /* EmptyStatement */ ;
    }
    function isExpressionStatement(node) {
        return node.kind === 245 /* ExpressionStatement */ ;
    }
    function isIfStatement(node) {
        return node.kind === 246 /* IfStatement */ ;
    }
    function isDoStatement(node) {
        return node.kind === 247 /* DoStatement */ ;
    }
    function isWhileStatement(node) {
        return node.kind === 248 /* WhileStatement */ ;
    }
    function isForStatement(node) {
        return node.kind === 249 /* ForStatement */ ;
    }
    function isForInStatement(node) {
        return node.kind === 250 /* ForInStatement */ ;
    }
    function isForOfStatement(node) {
        return node.kind === 251 /* ForOfStatement */ ;
    }
    function isContinueStatement(node) {
        return node.kind === 252 /* ContinueStatement */ ;
    }
    function isBreakStatement(node) {
        return node.kind === 253 /* BreakStatement */ ;
    }
    function isReturnStatement(node) {
        return node.kind === 254 /* ReturnStatement */ ;
    }
    function isWithStatement(node) {
        return node.kind === 255 /* WithStatement */ ;
    }
    function isSwitchStatement(node) {
        return node.kind === 256 /* SwitchStatement */ ;
    }
    function isLabeledStatement(node) {
        return node.kind === 257 /* LabeledStatement */ ;
    }
    function isThrowStatement(node) {
        return node.kind === 258 /* ThrowStatement */ ;
    }
    function isTryStatement(node) {
        return node.kind === 259 /* TryStatement */ ;
    }
    function isDebuggerStatement(node) {
        return node.kind === 260 /* DebuggerStatement */ ;
    }
    function isVariableDeclaration(node) {
        return node.kind === 261 /* VariableDeclaration */ ;
    }
    function isVariableDeclarationList(node) {
        return node.kind === 262 /* VariableDeclarationList */ ;
    }
    function isFunctionDeclaration(node) {
        return node.kind === 263 /* FunctionDeclaration */ ;
    }
    function isClassDeclaration(node) {
        return node.kind === 264 /* ClassDeclaration */ ;
    }
    function isInterfaceDeclaration(node) {
        return node.kind === 265 /* InterfaceDeclaration */ ;
    }
    function isTypeAliasDeclaration(node) {
        return node.kind === 266 /* TypeAliasDeclaration */ ;
    }
    function isEnumDeclaration(node) {
        return node.kind === 267 /* EnumDeclaration */ ;
    }
    function isModuleDeclaration(node) {
        return node.kind === 268 /* ModuleDeclaration */ ;
    }
    function isModuleBlock(node) {
        return node.kind === 269 /* ModuleBlock */ ;
    }
    function isCaseBlock(node) {
        return node.kind === 270 /* CaseBlock */ ;
    }
    function isNamespaceExportDeclaration(node) {
        return node.kind === 271 /* NamespaceExportDeclaration */ ;
    }
    function isImportEqualsDeclaration(node) {
        return node.kind === 272 /* ImportEqualsDeclaration */ ;
    }
    function isImportDeclaration(node) {
        return node.kind === 273 /* ImportDeclaration */ ;
    }
    function isImportClause(node) {
        return node.kind === 274 /* ImportClause */ ;
    }
    function isImportTypeAssertionContainer(node) {
        return node.kind === 303 /* ImportTypeAssertionContainer */ ;
    }
    function isAssertClause(node) {
        return node.kind === 301 /* AssertClause */ ;
    }
    function isAssertEntry(node) {
        return node.kind === 302 /* AssertEntry */ ;
    }
    function isImportAttributes(node) {
        return node.kind === 301 /* ImportAttributes */ ;
    }
    function isImportAttribute(node) {
        return node.kind === 302 /* ImportAttribute */ ;
    }
    function isNamespaceImport(node) {
        return node.kind === 275 /* NamespaceImport */ ;
    }
    function isNamespaceExport(node) {
        return node.kind === 281 /* NamespaceExport */ ;
    }
    function isNamedImports(node) {
        return node.kind === 276 /* NamedImports */ ;
    }
    function isImportSpecifier(node) {
        return node.kind === 277 /* ImportSpecifier */ ;
    }
    function isExportAssignment(node) {
        return node.kind === 278 /* ExportAssignment */ ;
    }
    function isExportDeclaration(node) {
        return node.kind === 279 /* ExportDeclaration */ ;
    }
    function isNamedExports(node) {
        return node.kind === 280 /* NamedExports */ ;
    }
    function isExportSpecifier(node) {
        return node.kind === 282 /* ExportSpecifier */ ;
    }
    function isModuleExportName(node) {
        return node.kind === 80 /* Identifier */  || node.kind === 11 /* StringLiteral */ ;
    }
    function isMissingDeclaration(node) {
        return node.kind === 283 /* MissingDeclaration */ ;
    }
    function isNotEmittedStatement(node) {
        return node.kind === 354 /* NotEmittedStatement */ ;
    }
    function isSyntheticReference(node) {
        return node.kind === 358 /* SyntheticReferenceExpression */ ;
    }
    function isExternalModuleReference(node) {
        return node.kind === 284 /* ExternalModuleReference */ ;
    }
    function isJsxElement(node) {
        return node.kind === 285 /* JsxElement */ ;
    }
    function isJsxSelfClosingElement(node) {
        return node.kind === 286 /* JsxSelfClosingElement */ ;
    }
    function isJsxOpeningElement(node) {
        return node.kind === 287 /* JsxOpeningElement */ ;
    }
    function isJsxClosingElement(node) {
        return node.kind === 288 /* JsxClosingElement */ ;
    }
    function isJsxFragment(node) {
        return node.kind === 289 /* JsxFragment */ ;
    }
    function isJsxOpeningFragment(node) {
        return node.kind === 290 /* JsxOpeningFragment */ ;
    }
    function isJsxClosingFragment(node) {
        return node.kind === 291 /* JsxClosingFragment */ ;
    }
    function isJsxAttribute(node) {
        return node.kind === 292 /* JsxAttribute */ ;
    }
    function isJsxAttributes(node) {
        return node.kind === 293 /* JsxAttributes */ ;
    }
    function isJsxSpreadAttribute(node) {
        return node.kind === 294 /* JsxSpreadAttribute */ ;
    }
    function isJsxExpression(node) {
        return node.kind === 295 /* JsxExpression */ ;
    }
    function isJsxNamespacedName(node) {
        return node.kind === 296 /* JsxNamespacedName */ ;
    }
    function isCaseClause(node) {
        return node.kind === 297 /* CaseClause */ ;
    }
    function isDefaultClause(node) {
        return node.kind === 298 /* DefaultClause */ ;
    }
    function isHeritageClause(node) {
        return node.kind === 299 /* HeritageClause */ ;
    }
    function isCatchClause(node) {
        return node.kind === 300 /* CatchClause */ ;
    }
    function isPropertyAssignment(node) {
        return node.kind === 304 /* PropertyAssignment */ ;
    }
    function isShorthandPropertyAssignment(node) {
        return node.kind === 305 /* ShorthandPropertyAssignment */ ;
    }
    function isSpreadAssignment(node) {
        return node.kind === 306 /* SpreadAssignment */ ;
    }
    function isEnumMember(node) {
        return node.kind === 307 /* EnumMember */ ;
    }
    function isSourceFile(node) {
        return node.kind === 308 /* SourceFile */ ;
    }
    function isBundle(node) {
        return node.kind === 309 /* Bundle */ ;
    }
    function isJSDocTypeExpression(node) {
        return node.kind === 310 /* JSDocTypeExpression */ ;
    }
    function isJSDocNameReference(node) {
        return node.kind === 311 /* JSDocNameReference */ ;
    }
    function isJSDocMemberName(node) {
        return node.kind === 312 /* JSDocMemberName */ ;
    }
    function isJSDocLink(node) {
        return node.kind === 325 /* JSDocLink */ ;
    }
    function isJSDocLinkCode(node) {
        return node.kind === 326 /* JSDocLinkCode */ ;
    }
    function isJSDocLinkPlain(node) {
        return node.kind === 327 /* JSDocLinkPlain */ ;
    }
    function isJSDocAllType(node) {
        return node.kind === 313 /* JSDocAllType */ ;
    }
    function isJSDocUnknownType(node) {
        return node.kind === 314 /* JSDocUnknownType */ ;
    }
    function isJSDocNullableType(node) {
        return node.kind === 315 /* JSDocNullableType */ ;
    }
    function isJSDocNonNullableType(node) {
        return node.kind === 316 /* JSDocNonNullableType */ ;
    }
    function isJSDocOptionalType(node) {
        return node.kind === 317 /* JSDocOptionalType */ ;
    }
    function isJSDocFunctionType(node) {
        return node.kind === 318 /* JSDocFunctionType */ ;
    }
    function isJSDocVariadicType(node) {
        return node.kind === 319 /* JSDocVariadicType */ ;
    }
    function isJSDocNamepathType(node) {
        return node.kind === 320 /* JSDocNamepathType */ ;
    }
    function isJSDoc(node) {
        return node.kind === 321 /* JSDoc */ ;
    }
    function isJSDocTypeLiteral(node) {
        return node.kind === 323 /* JSDocTypeLiteral */ ;
    }
    function isJSDocSignature(node) {
        return node.kind === 324 /* JSDocSignature */ ;
    }
    function isJSDocAugmentsTag(node) {
        return node.kind === 329 /* JSDocAugmentsTag */ ;
    }
    function isJSDocAuthorTag(node) {
        return node.kind === 331 /* JSDocAuthorTag */ ;
    }
    function isJSDocClassTag(node) {
        return node.kind === 333 /* JSDocClassTag */ ;
    }
    function isJSDocCallbackTag(node) {
        return node.kind === 339 /* JSDocCallbackTag */ ;
    }
    function isJSDocPublicTag(node) {
        return node.kind === 334 /* JSDocPublicTag */ ;
    }
    function isJSDocPrivateTag(node) {
        return node.kind === 335 /* JSDocPrivateTag */ ;
    }
    function isJSDocProtectedTag(node) {
        return node.kind === 336 /* JSDocProtectedTag */ ;
    }
    function isJSDocReadonlyTag(node) {
        return node.kind === 337 /* JSDocReadonlyTag */ ;
    }
    function isJSDocOverrideTag(node) {
        return node.kind === 338 /* JSDocOverrideTag */ ;
    }
    function isJSDocOverloadTag(node) {
        return node.kind === 340 /* JSDocOverloadTag */ ;
    }
    function isJSDocDeprecatedTag(node) {
        return node.kind === 332 /* JSDocDeprecatedTag */ ;
    }
    function isJSDocSeeTag(node) {
        return node.kind === 348 /* JSDocSeeTag */ ;
    }
    function isJSDocEnumTag(node) {
        return node.kind === 341 /* JSDocEnumTag */ ;
    }
    function isJSDocParameterTag(node) {
        return node.kind === 342 /* JSDocParameterTag */ ;
    }
    function isJSDocReturnTag(node) {
        return node.kind === 343 /* JSDocReturnTag */ ;
    }
    function isJSDocThisTag(node) {
        return node.kind === 344 /* JSDocThisTag */ ;
    }
    function isJSDocTypeTag(node) {
        return node.kind === 345 /* JSDocTypeTag */ ;
    }
    function isJSDocTemplateTag(node) {
        return node.kind === 346 /* JSDocTemplateTag */ ;
    }
    function isJSDocTypedefTag(node) {
        return node.kind === 347 /* JSDocTypedefTag */ ;
    }
    function isJSDocUnknownTag(node) {
        return node.kind === 328 /* JSDocTag */ ;
    }
    function isJSDocPropertyTag(node) {
        return node.kind === 349 /* JSDocPropertyTag */ ;
    }
    function isJSDocImplementsTag(node) {
        return node.kind === 330 /* JSDocImplementsTag */ ;
    }
    function isJSDocSatisfiesTag(node) {
        return node.kind === 351 /* JSDocSatisfiesTag */ ;
    }
    function isJSDocThrowsTag(node) {
        return node.kind === 350 /* JSDocThrowsTag */ ;
    }
    function isJSDocImportTag(node) {
        return node.kind === 352 /* JSDocImportTag */ ;
    }
    function isSyntaxList(n) {
        return n.kind === 353 /* SyntaxList */ ;
    }
    // src/compiler/factory/nodeChildren.ts
    var sourceFileToNodeChildren = /* @__PURE__ */ new WeakMap();
    function getNodeChildren(node, sourceFile) {
        var _a;
        const kind = node.kind;
        if (!isNodeKind(kind)) return emptyArray;
        if (kind === 353 /* SyntaxList */ ) return node._children;
        return (_a = sourceFileToNodeChildren.get(sourceFile)) == null ? void 0 : _a.get(node);
    }
    function setNodeChildren(node, sourceFile, children) {
        if (node.kind === 353 /* SyntaxList */ ) Debug.fail("Should not need to re-set the children of a SyntaxList.");
        let map2 = sourceFileToNodeChildren.get(sourceFile);
        if (map2 === void 0) {
            map2 = /* @__PURE__ */ new WeakMap();
            sourceFileToNodeChildren.set(sourceFile, map2);
        }
        map2.set(node, children);
        return children;
    }
    function unsetNodeChildren(node, origSourceFile) {
        var _a;
        if (node.kind === 353 /* SyntaxList */ ) Debug.fail("Did not expect to unset the children of a SyntaxList.");
        (_a = sourceFileToNodeChildren.get(origSourceFile)) == null || _a.delete(node);
    }
    function transferSourceFileChildren(sourceFile, targetSourceFile) {
        const map2 = sourceFileToNodeChildren.get(sourceFile);
        if (map2 !== void 0) {
            sourceFileToNodeChildren.delete(sourceFile);
            sourceFileToNodeChildren.set(targetSourceFile, map2);
        }
    }
    // src/compiler/factory/utilities.ts
    function createEmptyExports(factory2) {
        return factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports([]), /*moduleSpecifier*/ void 0);
    }
    function createMemberAccessForPropertyName(factory2, target, memberName, location) {
        if (isComputedPropertyName(memberName)) return setTextRange(factory2.createElementAccessExpression(target, memberName.expression), location);
        else {
            const expression = setTextRange(isMemberName(memberName) ? factory2.createPropertyAccessExpression(target, memberName) : factory2.createElementAccessExpression(target, memberName), memberName);
            addEmitFlags(expression, 128 /* NoNestedSourceMaps */ );
            return expression;
        }
    }
    function createReactNamespace(reactNamespace, parent2) {
        const react = parseNodeFactory.createIdentifier(reactNamespace || "React");
        setParent(react, getParseTreeNode(parent2));
        return react;
    }
    function createJsxFactoryExpressionFromEntityName(factory2, jsxFactory, parent2) {
        if (isQualifiedName(jsxFactory)) {
            const left = createJsxFactoryExpressionFromEntityName(factory2, jsxFactory.left, parent2);
            const right = factory2.createIdentifier(idText(jsxFactory.right));
            right.escapedText = jsxFactory.right.escapedText;
            return factory2.createPropertyAccessExpression(left, right);
        } else return createReactNamespace(idText(jsxFactory), parent2);
    }
    function createJsxFactoryExpression(factory2, jsxFactoryEntity, reactNamespace, parent2) {
        return jsxFactoryEntity ? createJsxFactoryExpressionFromEntityName(factory2, jsxFactoryEntity, parent2) : factory2.createPropertyAccessExpression(createReactNamespace(reactNamespace, parent2), "createElement");
    }
    function createJsxFragmentFactoryExpression(factory2, jsxFragmentFactoryEntity, reactNamespace, parent2) {
        return jsxFragmentFactoryEntity ? createJsxFactoryExpressionFromEntityName(factory2, jsxFragmentFactoryEntity, parent2) : factory2.createPropertyAccessExpression(createReactNamespace(reactNamespace, parent2), "Fragment");
    }
    function createExpressionForJsxElement(factory2, callee, tagName, props, children, location) {
        const argumentsList = [
            tagName
        ];
        if (props) argumentsList.push(props);
        if (children && children.length > 0) {
            if (!props) argumentsList.push(factory2.createNull());
            if (children.length > 1) for (const child of children){
                startOnNewLine(child);
                argumentsList.push(child);
            }
            else argumentsList.push(children[0]);
        }
        return setTextRange(factory2.createCallExpression(callee, /*typeArguments*/ void 0, argumentsList), location);
    }
    function createExpressionForJsxFragment(factory2, jsxFactoryEntity, jsxFragmentFactoryEntity, reactNamespace, children, parentElement, location) {
        const tagName = createJsxFragmentFactoryExpression(factory2, jsxFragmentFactoryEntity, reactNamespace, parentElement);
        const argumentsList = [
            tagName,
            factory2.createNull()
        ];
        if (children && children.length > 0) {
            if (children.length > 1) for (const child of children){
                startOnNewLine(child);
                argumentsList.push(child);
            }
            else argumentsList.push(children[0]);
        }
        return setTextRange(factory2.createCallExpression(createJsxFactoryExpression(factory2, jsxFactoryEntity, reactNamespace, parentElement), /*typeArguments*/ void 0, argumentsList), location);
    }
    function createForOfBindingStatement(factory2, node, boundValue) {
        if (isVariableDeclarationList(node)) {
            const firstDeclaration = first(node.declarations);
            const updatedDeclaration = factory2.updateVariableDeclaration(firstDeclaration, firstDeclaration.name, /*exclamationToken*/ void 0, /*type*/ void 0, boundValue);
            return setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.updateVariableDeclarationList(node, [
                updatedDeclaration
            ])), /*location*/ node);
        } else {
            const updatedExpression = setTextRange(factory2.createAssignment(node, boundValue), /*location*/ node);
            return setTextRange(factory2.createExpressionStatement(updatedExpression), /*location*/ node);
        }
    }
    function createExpressionFromEntityName(factory2, node) {
        if (isQualifiedName(node)) {
            const left = createExpressionFromEntityName(factory2, node.left);
            const right = setParent(setTextRange(factory2.cloneNode(node.right), node.right), node.right.parent);
            return setTextRange(factory2.createPropertyAccessExpression(left, right), node);
        } else return setParent(setTextRange(factory2.cloneNode(node), node), node.parent);
    }
    function createExpressionForPropertyName(factory2, memberName) {
        if (isIdentifier(memberName)) return factory2.createStringLiteralFromNode(memberName);
        else if (isComputedPropertyName(memberName)) return setParent(setTextRange(factory2.cloneNode(memberName.expression), memberName.expression), memberName.expression.parent);
        else return setParent(setTextRange(factory2.cloneNode(memberName), memberName), memberName.parent);
    }
    function createExpressionForAccessorDeclaration(factory2, properties, property, receiver, multiLine) {
        const { firstAccessor, getAccessor, setAccessor } = getAllAccessorDeclarations(properties, property);
        if (property === firstAccessor) return setTextRange(factory2.createObjectDefinePropertyCall(receiver, createExpressionForPropertyName(factory2, property.name), factory2.createPropertyDescriptor({
            enumerable: factory2.createFalse(),
            configurable: true,
            get: getAccessor && setTextRange(setOriginalNode(factory2.createFunctionExpression(getModifiers(getAccessor), /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, getAccessor.parameters, /*type*/ void 0, getAccessor.body), getAccessor), getAccessor),
            set: setAccessor && setTextRange(setOriginalNode(factory2.createFunctionExpression(getModifiers(setAccessor), /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, setAccessor.parameters, /*type*/ void 0, setAccessor.body), setAccessor), setAccessor)
        }, !multiLine)), firstAccessor);
        return void 0;
    }
    function createExpressionForPropertyAssignment(factory2, property, receiver) {
        return setOriginalNode(setTextRange(factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, property.name, /*location*/ property.name), property.initializer), property), property);
    }
    function createExpressionForShorthandPropertyAssignment(factory2, property, receiver) {
        return setOriginalNode(setTextRange(factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, property.name, /*location*/ property.name), factory2.cloneNode(property.name)), /*location*/ property), /*original*/ property);
    }
    function createExpressionForMethodDeclaration(factory2, method, receiver) {
        return setOriginalNode(setTextRange(factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, method.name, /*location*/ method.name), setOriginalNode(setTextRange(factory2.createFunctionExpression(getModifiers(method), method.asteriskToken, /*name*/ void 0, /*typeParameters*/ void 0, method.parameters, /*type*/ void 0, method.body), /*location*/ method), /*original*/ method)), /*location*/ method), /*original*/ method);
    }
    function createExpressionForObjectLiteralElementLike(factory2, node, property, receiver) {
        if (property.name && isPrivateIdentifier(property.name)) Debug.failBadSyntaxKind(property.name, "Private identifiers are not allowed in object literals.");
        switch(property.kind){
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return createExpressionForAccessorDeclaration(factory2, node.properties, property, receiver, !!node.multiLine);
            case 304 /* PropertyAssignment */ :
                return createExpressionForPropertyAssignment(factory2, property, receiver);
            case 305 /* ShorthandPropertyAssignment */ :
                return createExpressionForShorthandPropertyAssignment(factory2, property, receiver);
            case 175 /* MethodDeclaration */ :
                return createExpressionForMethodDeclaration(factory2, property, receiver);
        }
    }
    function expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, recordTempVariable, resultVariable) {
        const operator = node.operator;
        Debug.assert(operator === 46 /* PlusPlusToken */  || operator === 47 /* MinusMinusToken */ , "Expected 'node' to be a pre- or post-increment or pre- or post-decrement expression");
        const temp = factory2.createTempVariable(recordTempVariable);
        expression = factory2.createAssignment(temp, expression);
        setTextRange(expression, node.operand);
        let operation = isPrefixUnaryExpression(node) ? factory2.createPrefixUnaryExpression(operator, temp) : factory2.createPostfixUnaryExpression(temp, operator);
        setTextRange(operation, node);
        if (resultVariable) {
            operation = factory2.createAssignment(resultVariable, operation);
            setTextRange(operation, node);
        }
        expression = factory2.createComma(expression, operation);
        setTextRange(expression, node);
        if (isPostfixUnaryExpression(node)) {
            expression = factory2.createComma(expression, temp);
            setTextRange(expression, node);
        }
        return expression;
    }
    function isInternalName(node) {
        return (getEmitFlags(node) & 65536 /* InternalName */ ) !== 0;
    }
    function isLocalName(node) {
        return (getEmitFlags(node) & 32768 /* LocalName */ ) !== 0;
    }
    function isExportName(node) {
        return (getEmitFlags(node) & 16384 /* ExportName */ ) !== 0;
    }
    function isUseStrictPrologue(node) {
        return isStringLiteral(node.expression) && node.expression.text === "use strict";
    }
    function findUseStrictPrologue(statements) {
        for (const statement of statements){
            if (isPrologueDirective(statement)) {
                if (isUseStrictPrologue(statement)) return statement;
            } else break;
        }
        return void 0;
    }
    function startsWithUseStrict(statements) {
        const firstStatement = firstOrUndefined(statements);
        return firstStatement !== void 0 && isPrologueDirective(firstStatement) && isUseStrictPrologue(firstStatement);
    }
    function isCommaExpression(node) {
        return node.kind === 227 /* BinaryExpression */  && node.operatorToken.kind === 28 /* CommaToken */ ;
    }
    function isCommaSequence(node) {
        return isCommaExpression(node) || isCommaListExpression(node);
    }
    function isJSDocTypeAssertion(node) {
        return isParenthesizedExpression(node) && isInJSFile(node) && !!getJSDocTypeTag(node);
    }
    function getJSDocTypeAssertionType(node) {
        const type = getJSDocType(node);
        Debug.assertIsDefined(type);
        return type;
    }
    function isOuterExpression(node, kinds = 63 /* All */ ) {
        switch(node.kind){
            case 218 /* ParenthesizedExpression */ :
                if (kinds & -2147483648 /* ExcludeJSDocTypeAssertion */  && isJSDocTypeAssertion(node)) return false;
                return (kinds & 1 /* Parentheses */ ) !== 0;
            case 217 /* TypeAssertionExpression */ :
            case 235 /* AsExpression */ :
                return (kinds & 2 /* TypeAssertions */ ) !== 0;
            case 239 /* SatisfiesExpression */ :
                return (kinds & 34 /* Satisfies */ ) !== 0;
            case 234 /* ExpressionWithTypeArguments */ :
                return (kinds & 16 /* ExpressionsWithTypeArguments */ ) !== 0;
            case 236 /* NonNullExpression */ :
                return (kinds & 4 /* NonNullAssertions */ ) !== 0;
            case 356 /* PartiallyEmittedExpression */ :
                return (kinds & 8 /* PartiallyEmittedExpressions */ ) !== 0;
        }
        return false;
    }
    function skipOuterExpressions(node, kinds = 63 /* All */ ) {
        while(isOuterExpression(node, kinds))node = node.expression;
        return node;
    }
    function walkUpOuterExpressions(node, kinds = 63 /* All */ ) {
        let parent2 = node.parent;
        while(isOuterExpression(parent2, kinds)){
            parent2 = parent2.parent;
            Debug.assert(parent2);
        }
        return parent2;
    }
    function startOnNewLine(node) {
        return setStartsOnNewLine(node, /*newLine*/ true);
    }
    function getExternalHelpersModuleName(node) {
        const parseNode = getOriginalNode(node, isSourceFile);
        const emitNode = parseNode && parseNode.emitNode;
        return emitNode && emitNode.externalHelpersModuleName;
    }
    function hasRecordedExternalHelpers(sourceFile) {
        const parseNode = getOriginalNode(sourceFile, isSourceFile);
        const emitNode = parseNode && parseNode.emitNode;
        return !!emitNode && (!!emitNode.externalHelpersModuleName || !!emitNode.externalHelpers);
    }
    function createExternalHelpersImportDeclarationIfNeeded(nodeFactory, helperFactory, sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStar, hasImportDefault) {
        if (compilerOptions.importHelpers && isEffectiveExternalModule(sourceFile, compilerOptions)) {
            const moduleKind = getEmitModuleKind(compilerOptions);
            const impliedModuleKind = getImpliedNodeFormatForEmitWorker(sourceFile, compilerOptions);
            const helpers = getImportedHelpers(sourceFile);
            if (impliedModuleKind !== 1 /* CommonJS */  && (moduleKind >= 5 /* ES2015 */  && moduleKind <= 99 /* ESNext */  || impliedModuleKind === 99 /* ESNext */  || impliedModuleKind === void 0 && moduleKind === 200 /* Preserve */ )) {
                if (helpers) {
                    const helperNames = [];
                    for (const helper of helpers){
                        const importName = helper.importName;
                        if (importName) pushIfUnique(helperNames, importName);
                    }
                    if (some(helperNames)) {
                        helperNames.sort(compareStringsCaseSensitive);
                        const namedBindings = nodeFactory.createNamedImports(map(helperNames, (name)=>isFileLevelUniqueName(sourceFile, name) ? nodeFactory.createImportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, nodeFactory.createIdentifier(name)) : nodeFactory.createImportSpecifier(/*isTypeOnly*/ false, nodeFactory.createIdentifier(name), helperFactory.getUnscopedHelperName(name))));
                        const parseNode = getOriginalNode(sourceFile, isSourceFile);
                        const emitNode = getOrCreateEmitNode(parseNode);
                        emitNode.externalHelpers = true;
                        const externalHelpersImportDeclaration = nodeFactory.createImportDeclaration(/*modifiers*/ void 0, nodeFactory.createImportClause(/*phaseModifier*/ void 0, /*name*/ void 0, namedBindings), nodeFactory.createStringLiteral(externalHelpersModuleNameText), /*attributes*/ void 0);
                        addInternalEmitFlags(externalHelpersImportDeclaration, 2 /* NeverApplyImportHelper */ );
                        return externalHelpersImportDeclaration;
                    }
                }
            } else {
                const externalHelpersModuleName = getOrCreateExternalHelpersModuleNameIfNeeded(nodeFactory, sourceFile, compilerOptions, helpers, hasExportStarsToExportValues, hasImportStar || hasImportDefault);
                if (externalHelpersModuleName) {
                    const externalHelpersImportDeclaration = nodeFactory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, externalHelpersModuleName, nodeFactory.createExternalModuleReference(nodeFactory.createStringLiteral(externalHelpersModuleNameText)));
                    addInternalEmitFlags(externalHelpersImportDeclaration, 2 /* NeverApplyImportHelper */ );
                    return externalHelpersImportDeclaration;
                }
            }
        }
    }
    function getImportedHelpers(sourceFile) {
        return filter(getEmitHelpers(sourceFile), (helper)=>!helper.scoped);
    }
    function getOrCreateExternalHelpersModuleNameIfNeeded(factory2, node, compilerOptions, helpers, hasExportStarsToExportValues, hasImportStarOrImportDefault) {
        const externalHelpersModuleName = getExternalHelpersModuleName(node);
        if (externalHelpersModuleName) return externalHelpersModuleName;
        const create = some(helpers) || (hasExportStarsToExportValues || getESModuleInterop(compilerOptions) && hasImportStarOrImportDefault) && getEmitModuleFormatOfFileWorker(node, compilerOptions) < 4 /* System */ ;
        if (create) {
            const parseNode = getOriginalNode(node, isSourceFile);
            const emitNode = getOrCreateEmitNode(parseNode);
            return emitNode.externalHelpersModuleName || (emitNode.externalHelpersModuleName = factory2.createUniqueName(externalHelpersModuleNameText));
        }
    }
    function getLocalNameForExternalImport(factory2, node, sourceFile) {
        const namespaceDeclaration = getNamespaceDeclarationNode(node);
        if (namespaceDeclaration && !isDefaultImport(node) && !isExportNamespaceAsDefaultDeclaration(node)) {
            const name = namespaceDeclaration.name;
            if (name.kind === 11 /* StringLiteral */ ) return factory2.getGeneratedNameForNode(node);
            return isGeneratedIdentifier(name) ? name : factory2.createIdentifier(getSourceTextOfNodeFromSourceFile(sourceFile, name) || idText(name));
        }
        if (node.kind === 273 /* ImportDeclaration */  && node.importClause) return factory2.getGeneratedNameForNode(node);
        if (node.kind === 279 /* ExportDeclaration */  && node.moduleSpecifier) return factory2.getGeneratedNameForNode(node);
        return void 0;
    }
    function getExternalModuleNameLiteral(factory2, importNode, sourceFile, host, resolver, compilerOptions) {
        const moduleName = getExternalModuleName(importNode);
        if (moduleName && isStringLiteral(moduleName)) return tryGetModuleNameFromDeclaration(importNode, host, factory2, resolver, compilerOptions) || tryRenameExternalModule(factory2, moduleName, sourceFile) || factory2.cloneNode(moduleName);
        return void 0;
    }
    function tryRenameExternalModule(factory2, moduleName, sourceFile) {
        const rename = sourceFile.renamedDependencies && sourceFile.renamedDependencies.get(moduleName.text);
        return rename ? factory2.createStringLiteral(rename) : void 0;
    }
    function tryGetModuleNameFromFile(factory2, file, host, options) {
        if (!file) return void 0;
        if (file.moduleName) return factory2.createStringLiteral(file.moduleName);
        if (!file.isDeclarationFile && options.outFile) return factory2.createStringLiteral(getExternalModuleNameFromPath(host, file.fileName));
        return void 0;
    }
    function tryGetModuleNameFromDeclaration(declaration, host, factory2, resolver, compilerOptions) {
        return tryGetModuleNameFromFile(factory2, resolver.getExternalModuleFileFromDeclaration(declaration), host, compilerOptions);
    }
    function getInitializerOfBindingOrAssignmentElement(bindingElement) {
        if (isDeclarationBindingElement(bindingElement)) return bindingElement.initializer;
        if (isPropertyAssignment(bindingElement)) {
            const initializer = bindingElement.initializer;
            return isAssignmentExpression(initializer, /*excludeCompoundAssignment*/ true) ? initializer.right : void 0;
        }
        if (isShorthandPropertyAssignment(bindingElement)) return bindingElement.objectAssignmentInitializer;
        if (isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) return bindingElement.right;
        if (isSpreadElement(bindingElement)) return getInitializerOfBindingOrAssignmentElement(bindingElement.expression);
    }
    function getTargetOfBindingOrAssignmentElement(bindingElement) {
        if (isDeclarationBindingElement(bindingElement)) return bindingElement.name;
        if (isObjectLiteralElementLike(bindingElement)) {
            switch(bindingElement.kind){
                case 304 /* PropertyAssignment */ :
                    return getTargetOfBindingOrAssignmentElement(bindingElement.initializer);
                case 305 /* ShorthandPropertyAssignment */ :
                    return bindingElement.name;
                case 306 /* SpreadAssignment */ :
                    return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
            }
            return void 0;
        }
        if (isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) return getTargetOfBindingOrAssignmentElement(bindingElement.left);
        if (isSpreadElement(bindingElement)) return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
        return bindingElement;
    }
    function getRestIndicatorOfBindingOrAssignmentElement(bindingElement) {
        switch(bindingElement.kind){
            case 170 /* Parameter */ :
            case 209 /* BindingElement */ :
                return bindingElement.dotDotDotToken;
            case 231 /* SpreadElement */ :
            case 306 /* SpreadAssignment */ :
                return bindingElement;
        }
        return void 0;
    }
    function getPropertyNameOfBindingOrAssignmentElement(bindingElement) {
        const propertyName = tryGetPropertyNameOfBindingOrAssignmentElement(bindingElement);
        Debug.assert(!!propertyName || isSpreadAssignment(bindingElement), "Invalid property name for binding element.");
        return propertyName;
    }
    function tryGetPropertyNameOfBindingOrAssignmentElement(bindingElement) {
        switch(bindingElement.kind){
            case 209 /* BindingElement */ :
                if (bindingElement.propertyName) {
                    const propertyName = bindingElement.propertyName;
                    if (isPrivateIdentifier(propertyName)) return Debug.failBadSyntaxKind(propertyName);
                    return isComputedPropertyName(propertyName) && isStringOrNumericLiteral(propertyName.expression) ? propertyName.expression : propertyName;
                }
                break;
            case 304 /* PropertyAssignment */ :
                if (bindingElement.name) {
                    const propertyName = bindingElement.name;
                    if (isPrivateIdentifier(propertyName)) return Debug.failBadSyntaxKind(propertyName);
                    return isComputedPropertyName(propertyName) && isStringOrNumericLiteral(propertyName.expression) ? propertyName.expression : propertyName;
                }
                break;
            case 306 /* SpreadAssignment */ :
                if (bindingElement.name && isPrivateIdentifier(bindingElement.name)) return Debug.failBadSyntaxKind(bindingElement.name);
                return bindingElement.name;
        }
        const target = getTargetOfBindingOrAssignmentElement(bindingElement);
        if (target && isPropertyName(target)) return target;
    }
    function isStringOrNumericLiteral(node) {
        const kind = node.kind;
        return kind === 11 /* StringLiteral */  || kind === 9 /* NumericLiteral */ ;
    }
    function getElementsOfBindingOrAssignmentPattern(name) {
        switch(name.kind){
            case 207 /* ObjectBindingPattern */ :
            case 208 /* ArrayBindingPattern */ :
            case 210 /* ArrayLiteralExpression */ :
                return name.elements;
            case 211 /* ObjectLiteralExpression */ :
                return name.properties;
        }
    }
    function getJSDocTypeAliasName(fullName) {
        if (fullName) {
            let rightNode = fullName;
            while(true){
                if (isIdentifier(rightNode) || !rightNode.body) return isIdentifier(rightNode) ? rightNode : rightNode.name;
                rightNode = rightNode.body;
            }
        }
    }
    function canHaveIllegalType(node) {
        const kind = node.kind;
        return kind === 177 /* Constructor */  || kind === 179 /* SetAccessor */ ;
    }
    function canHaveIllegalTypeParameters(node) {
        const kind = node.kind;
        return kind === 177 /* Constructor */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */ ;
    }
    function canHaveIllegalDecorators(node) {
        const kind = node.kind;
        return kind === 304 /* PropertyAssignment */  || kind === 305 /* ShorthandPropertyAssignment */  || kind === 263 /* FunctionDeclaration */  || kind === 177 /* Constructor */  || kind === 182 /* IndexSignature */  || kind === 176 /* ClassStaticBlockDeclaration */  || kind === 283 /* MissingDeclaration */  || kind === 244 /* VariableStatement */  || kind === 265 /* InterfaceDeclaration */  || kind === 266 /* TypeAliasDeclaration */  || kind === 267 /* EnumDeclaration */  || kind === 268 /* ModuleDeclaration */  || kind === 272 /* ImportEqualsDeclaration */  || kind === 273 /* ImportDeclaration */  || kind === 271 /* NamespaceExportDeclaration */  || kind === 279 /* ExportDeclaration */  || kind === 278 /* ExportAssignment */ ;
    }
    function canHaveIllegalModifiers(node) {
        const kind = node.kind;
        return kind === 176 /* ClassStaticBlockDeclaration */  || kind === 304 /* PropertyAssignment */  || kind === 305 /* ShorthandPropertyAssignment */  || kind === 283 /* MissingDeclaration */  || kind === 271 /* NamespaceExportDeclaration */ ;
    }
    function isQuestionOrExclamationToken(node) {
        return isQuestionToken(node) || isExclamationToken(node);
    }
    function isIdentifierOrThisTypeNode(node) {
        return isIdentifier(node) || isThisTypeNode(node);
    }
    function isReadonlyKeywordOrPlusOrMinusToken(node) {
        return isReadonlyKeyword(node) || isPlusToken(node) || isMinusToken(node);
    }
    function isQuestionOrPlusOrMinusToken(node) {
        return isQuestionToken(node) || isPlusToken(node) || isMinusToken(node);
    }
    function isModuleName(node) {
        return isIdentifier(node) || isStringLiteral(node);
    }
    function isExponentiationOperator(kind) {
        return kind === 43 /* AsteriskAsteriskToken */ ;
    }
    function isMultiplicativeOperator(kind) {
        return kind === 42 /* AsteriskToken */  || kind === 44 /* SlashToken */  || kind === 45 /* PercentToken */ ;
    }
    function isMultiplicativeOperatorOrHigher(kind) {
        return isExponentiationOperator(kind) || isMultiplicativeOperator(kind);
    }
    function isAdditiveOperator(kind) {
        return kind === 40 /* PlusToken */  || kind === 41 /* MinusToken */ ;
    }
    function isAdditiveOperatorOrHigher(kind) {
        return isAdditiveOperator(kind) || isMultiplicativeOperatorOrHigher(kind);
    }
    function isShiftOperator(kind) {
        return kind === 48 /* LessThanLessThanToken */  || kind === 49 /* GreaterThanGreaterThanToken */  || kind === 50 /* GreaterThanGreaterThanGreaterThanToken */ ;
    }
    function isShiftOperatorOrHigher(kind) {
        return isShiftOperator(kind) || isAdditiveOperatorOrHigher(kind);
    }
    function isRelationalOperator(kind) {
        return kind === 30 /* LessThanToken */  || kind === 33 /* LessThanEqualsToken */  || kind === 32 /* GreaterThanToken */  || kind === 34 /* GreaterThanEqualsToken */  || kind === 104 /* InstanceOfKeyword */  || kind === 103 /* InKeyword */ ;
    }
    function isRelationalOperatorOrHigher(kind) {
        return isRelationalOperator(kind) || isShiftOperatorOrHigher(kind);
    }
    function isEqualityOperator(kind) {
        return kind === 35 /* EqualsEqualsToken */  || kind === 37 /* EqualsEqualsEqualsToken */  || kind === 36 /* ExclamationEqualsToken */  || kind === 38 /* ExclamationEqualsEqualsToken */ ;
    }
    function isEqualityOperatorOrHigher(kind) {
        return isEqualityOperator(kind) || isRelationalOperatorOrHigher(kind);
    }
    function isBitwiseOperator(kind) {
        return kind === 51 /* AmpersandToken */  || kind === 52 /* BarToken */  || kind === 53 /* CaretToken */ ;
    }
    function isBitwiseOperatorOrHigher(kind) {
        return isBitwiseOperator(kind) || isEqualityOperatorOrHigher(kind);
    }
    function isLogicalOperator2(kind) {
        return kind === 56 /* AmpersandAmpersandToken */  || kind === 57 /* BarBarToken */ ;
    }
    function isLogicalOperatorOrHigher(kind) {
        return isLogicalOperator2(kind) || isBitwiseOperatorOrHigher(kind);
    }
    function isAssignmentOperatorOrHigher(kind) {
        return kind === 61 /* QuestionQuestionToken */  || isLogicalOperatorOrHigher(kind) || isAssignmentOperator(kind);
    }
    function isBinaryOperator(kind) {
        return isAssignmentOperatorOrHigher(kind) || kind === 28 /* CommaToken */ ;
    }
    function isBinaryOperatorToken(node) {
        return isBinaryOperator(node.kind);
    }
    var BinaryExpressionState;
    ((BinaryExpressionState2)=>{
        function enter(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, outerState) {
            const prevUserState = stackIndex > 0 ? userStateStack[stackIndex - 1] : void 0;
            Debug.assertEqual(stateStack[stackIndex], enter);
            userStateStack[stackIndex] = machine.onEnter(nodeStack[stackIndex], prevUserState, outerState);
            stateStack[stackIndex] = nextState(machine, enter);
            return stackIndex;
        }
        BinaryExpressionState2.enter = enter;
        function left(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, _outerState) {
            Debug.assertEqual(stateStack[stackIndex], left);
            Debug.assertIsDefined(machine.onLeft);
            stateStack[stackIndex] = nextState(machine, left);
            const nextNode = machine.onLeft(nodeStack[stackIndex].left, userStateStack[stackIndex], nodeStack[stackIndex]);
            if (nextNode) {
                checkCircularity(stackIndex, nodeStack, nextNode);
                return pushStack(stackIndex, stateStack, nodeStack, userStateStack, nextNode);
            }
            return stackIndex;
        }
        BinaryExpressionState2.left = left;
        function operator(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, _outerState) {
            Debug.assertEqual(stateStack[stackIndex], operator);
            Debug.assertIsDefined(machine.onOperator);
            stateStack[stackIndex] = nextState(machine, operator);
            machine.onOperator(nodeStack[stackIndex].operatorToken, userStateStack[stackIndex], nodeStack[stackIndex]);
            return stackIndex;
        }
        BinaryExpressionState2.operator = operator;
        function right(machine, stackIndex, stateStack, nodeStack, userStateStack, _resultHolder, _outerState) {
            Debug.assertEqual(stateStack[stackIndex], right);
            Debug.assertIsDefined(machine.onRight);
            stateStack[stackIndex] = nextState(machine, right);
            const nextNode = machine.onRight(nodeStack[stackIndex].right, userStateStack[stackIndex], nodeStack[stackIndex]);
            if (nextNode) {
                checkCircularity(stackIndex, nodeStack, nextNode);
                return pushStack(stackIndex, stateStack, nodeStack, userStateStack, nextNode);
            }
            return stackIndex;
        }
        BinaryExpressionState2.right = right;
        function exit(machine, stackIndex, stateStack, nodeStack, userStateStack, resultHolder, _outerState) {
            Debug.assertEqual(stateStack[stackIndex], exit);
            stateStack[stackIndex] = nextState(machine, exit);
            const result = machine.onExit(nodeStack[stackIndex], userStateStack[stackIndex]);
            if (stackIndex > 0) {
                stackIndex--;
                if (machine.foldState) {
                    const side = stateStack[stackIndex] === exit ? "right" : "left";
                    userStateStack[stackIndex] = machine.foldState(userStateStack[stackIndex], result, side);
                }
            } else resultHolder.value = result;
            return stackIndex;
        }
        BinaryExpressionState2.exit = exit;
        function done(_machine, stackIndex, stateStack, _nodeStack, _userStateStack, _resultHolder, _outerState) {
            Debug.assertEqual(stateStack[stackIndex], done);
            return stackIndex;
        }
        BinaryExpressionState2.done = done;
        function nextState(machine, currentState) {
            switch(currentState){
                case enter:
                    if (machine.onLeft) return left;
                // falls through
                case left:
                    if (machine.onOperator) return operator;
                // falls through
                case operator:
                    if (machine.onRight) return right;
                // falls through
                case right:
                    return exit;
                case exit:
                    return done;
                case done:
                    return done;
                default:
                    Debug.fail("Invalid state");
            }
        }
        BinaryExpressionState2.nextState = nextState;
        function pushStack(stackIndex, stateStack, nodeStack, userStateStack, node) {
            stackIndex++;
            stateStack[stackIndex] = enter;
            nodeStack[stackIndex] = node;
            userStateStack[stackIndex] = void 0;
            return stackIndex;
        }
        function checkCircularity(stackIndex, nodeStack, node) {
            if (Debug.shouldAssert(2 /* Aggressive */ )) while(stackIndex >= 0){
                Debug.assert(nodeStack[stackIndex] !== node, "Circular traversal detected.");
                stackIndex--;
            }
        }
    })(BinaryExpressionState || (BinaryExpressionState = {}));
    var BinaryExpressionStateMachine = class {
        constructor(onEnter, onLeft, onOperator, onRight, onExit, foldState){
            this.onEnter = onEnter;
            this.onLeft = onLeft;
            this.onOperator = onOperator;
            this.onRight = onRight;
            this.onExit = onExit;
            this.foldState = foldState;
        }
    };
    function createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, foldState) {
        const machine = new BinaryExpressionStateMachine(onEnter, onLeft, onOperator, onRight, onExit, foldState);
        return trampoline;
        function trampoline(node, outerState) {
            const resultHolder = {
                value: void 0
            };
            const stateStack = [
                BinaryExpressionState.enter
            ];
            const nodeStack = [
                node
            ];
            const userStateStack = [
                void 0
            ];
            let stackIndex = 0;
            while(stateStack[stackIndex] !== BinaryExpressionState.done)stackIndex = stateStack[stackIndex](machine, stackIndex, stateStack, nodeStack, userStateStack, resultHolder, outerState);
            Debug.assertEqual(stackIndex, 0);
            return resultHolder.value;
        }
    }
    function isExportOrDefaultKeywordKind(kind) {
        return kind === 95 /* ExportKeyword */  || kind === 90 /* DefaultKeyword */ ;
    }
    function isExportOrDefaultModifier(node) {
        const kind = node.kind;
        return isExportOrDefaultKeywordKind(kind);
    }
    function elideNodes(factory2, nodes) {
        if (nodes === void 0) return void 0;
        if (nodes.length === 0) return nodes;
        return setTextRange(factory2.createNodeArray([], nodes.hasTrailingComma), nodes);
    }
    function getNodeForGeneratedName(name) {
        var _a;
        const autoGenerate = name.emitNode.autoGenerate;
        if (autoGenerate.flags & 4 /* Node */ ) {
            const autoGenerateId = autoGenerate.id;
            let node = name;
            let original = node.original;
            while(original){
                node = original;
                const autoGenerate2 = (_a = node.emitNode) == null ? void 0 : _a.autoGenerate;
                if (isMemberName(node) && (autoGenerate2 === void 0 || !!(autoGenerate2.flags & 4 /* Node */ ) && autoGenerate2.id !== autoGenerateId)) break;
                original = node.original;
            }
            return node;
        }
        return name;
    }
    function formatGeneratedNamePart(part, generateName) {
        return typeof part === "object" ? formatGeneratedName(/*privateName*/ false, part.prefix, part.node, part.suffix, generateName) : typeof part === "string" ? part.length > 0 && part.charCodeAt(0) === 35 /* hash */  ? part.slice(1) : part : "";
    }
    function formatIdentifier(name, generateName) {
        return typeof name === "string" ? name : formatIdentifierWorker(name, Debug.checkDefined(generateName));
    }
    function formatIdentifierWorker(node, generateName) {
        return isGeneratedPrivateIdentifier(node) ? generateName(node).slice(1) : isGeneratedIdentifier(node) ? generateName(node) : isPrivateIdentifier(node) ? node.escapedText.slice(1) : idText(node);
    }
    function formatGeneratedName(privateName, prefix, baseName, suffix, generateName) {
        prefix = formatGeneratedNamePart(prefix, generateName);
        suffix = formatGeneratedNamePart(suffix, generateName);
        baseName = formatIdentifier(baseName, generateName);
        return `${privateName ? "#" : ""}${prefix}${baseName}${suffix}`;
    }
    function createAccessorPropertyBackingField(factory2, node, modifiers, initializer) {
        return factory2.updatePropertyDeclaration(node, modifiers, factory2.getGeneratedPrivateNameForNode(node.name, /*prefix*/ void 0, "_accessor_storage"), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, initializer);
    }
    function createAccessorPropertyGetRedirector(factory2, node, modifiers, name, receiver = factory2.createThis()) {
        return factory2.createGetAccessorDeclaration(modifiers, name, [], /*type*/ void 0, factory2.createBlock([
            factory2.createReturnStatement(factory2.createPropertyAccessExpression(receiver, factory2.getGeneratedPrivateNameForNode(node.name, /*prefix*/ void 0, "_accessor_storage")))
        ]));
    }
    function createAccessorPropertySetRedirector(factory2, node, modifiers, name, receiver = factory2.createThis()) {
        return factory2.createSetAccessorDeclaration(modifiers, name, [
            factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value")
        ], factory2.createBlock([
            factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(receiver, factory2.getGeneratedPrivateNameForNode(node.name, /*prefix*/ void 0, "_accessor_storage")), factory2.createIdentifier("value")))
        ]));
    }
    function findComputedPropertyNameCacheAssignment(name) {
        let node = name.expression;
        while(true){
            node = skipOuterExpressions(node);
            if (isCommaListExpression(node)) {
                node = last(node.elements);
                continue;
            }
            if (isCommaExpression(node)) {
                node = node.right;
                continue;
            }
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true) && isGeneratedIdentifier(node.left)) return node;
            break;
        }
    }
    function isSyntheticParenthesizedExpression(node) {
        return isParenthesizedExpression(node) && nodeIsSynthesized(node) && !node.emitNode;
    }
    function flattenCommaListWorker(node, expressions) {
        if (isSyntheticParenthesizedExpression(node)) flattenCommaListWorker(node.expression, expressions);
        else if (isCommaExpression(node)) {
            flattenCommaListWorker(node.left, expressions);
            flattenCommaListWorker(node.right, expressions);
        } else if (isCommaListExpression(node)) for (const child of node.elements)flattenCommaListWorker(child, expressions);
        else expressions.push(node);
    }
    function flattenCommaList(node) {
        const expressions = [];
        flattenCommaListWorker(node, expressions);
        return expressions;
    }
    function containsObjectRestOrSpread(node) {
        if (node.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return true;
        if (node.transformFlags & 128 /* ContainsES2018 */ ) for (const element of getElementsOfBindingOrAssignmentPattern(node)){
            const target = getTargetOfBindingOrAssignmentElement(element);
            if (target && isAssignmentPattern(target)) {
                if (target.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return true;
                if (target.transformFlags & 128 /* ContainsES2018 */ ) {
                    if (containsObjectRestOrSpread(target)) return true;
                }
            }
        }
        return false;
    }
    // src/compiler/factory/utilitiesPublic.ts
    function setTextRange(range, location) {
        return location ? setTextRangePosEnd(range, location.pos, location.end) : range;
    }
    function canHaveModifiers(node) {
        const kind = node.kind;
        return kind === 169 /* TypeParameter */  || kind === 170 /* Parameter */  || kind === 172 /* PropertySignature */  || kind === 173 /* PropertyDeclaration */  || kind === 174 /* MethodSignature */  || kind === 175 /* MethodDeclaration */  || kind === 177 /* Constructor */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */  || kind === 182 /* IndexSignature */  || kind === 186 /* ConstructorType */  || kind === 219 /* FunctionExpression */  || kind === 220 /* ArrowFunction */  || kind === 232 /* ClassExpression */  || kind === 244 /* VariableStatement */  || kind === 263 /* FunctionDeclaration */  || kind === 264 /* ClassDeclaration */  || kind === 265 /* InterfaceDeclaration */  || kind === 266 /* TypeAliasDeclaration */  || kind === 267 /* EnumDeclaration */  || kind === 268 /* ModuleDeclaration */  || kind === 272 /* ImportEqualsDeclaration */  || kind === 273 /* ImportDeclaration */  || kind === 278 /* ExportAssignment */  || kind === 279 /* ExportDeclaration */ ;
    }
    function canHaveDecorators(node) {
        const kind = node.kind;
        return kind === 170 /* Parameter */  || kind === 173 /* PropertyDeclaration */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */  || kind === 232 /* ClassExpression */  || kind === 264 /* ClassDeclaration */ ;
    }
    // src/compiler/parser.ts
    var NodeConstructor;
    var TokenConstructor;
    var IdentifierConstructor;
    var PrivateIdentifierConstructor;
    var SourceFileConstructor;
    var parseBaseNodeFactory = {
        createBaseSourceFileNode: (kind)=>new (SourceFileConstructor || (SourceFileConstructor = objectAllocator.getSourceFileConstructor()))(kind, -1, -1),
        createBaseIdentifierNode: (kind)=>new (IdentifierConstructor || (IdentifierConstructor = objectAllocator.getIdentifierConstructor()))(kind, -1, -1),
        createBasePrivateIdentifierNode: (kind)=>new (PrivateIdentifierConstructor || (PrivateIdentifierConstructor = objectAllocator.getPrivateIdentifierConstructor()))(kind, -1, -1),
        createBaseTokenNode: (kind)=>new (TokenConstructor || (TokenConstructor = objectAllocator.getTokenConstructor()))(kind, -1, -1),
        createBaseNode: (kind)=>new (NodeConstructor || (NodeConstructor = objectAllocator.getNodeConstructor()))(kind, -1, -1)
    };
    var parseNodeFactory = createNodeFactory(1 /* NoParenthesizerRules */ , parseBaseNodeFactory);
    function visitNode2(cbNode, node) {
        return node && cbNode(node);
    }
    function visitNodes(cbNode, cbNodes, nodes) {
        if (nodes) {
            if (cbNodes) return cbNodes(nodes);
            for (const node of nodes){
                const result = cbNode(node);
                if (result) return result;
            }
        }
    }
    function isJSDocLikeText(text, start) {
        return text.charCodeAt(start + 1) === 42 /* asterisk */  && text.charCodeAt(start + 2) === 42 /* asterisk */  && text.charCodeAt(start + 3) !== 47 /* slash */ ;
    }
    function isFileProbablyExternalModule(sourceFile) {
        return forEach(sourceFile.statements, isAnExternalModuleIndicatorNode) || getImportMetaIfNecessary(sourceFile);
    }
    function isAnExternalModuleIndicatorNode(node) {
        return canHaveModifiers(node) && hasModifierOfKind(node, 95 /* ExportKeyword */ ) || isImportEqualsDeclaration(node) && isExternalModuleReference(node.moduleReference) || isImportDeclaration(node) || isExportAssignment(node) || isExportDeclaration(node) ? node : void 0;
    }
    function getImportMetaIfNecessary(sourceFile) {
        return sourceFile.flags & 8388608 /* PossiblyContainsImportMeta */  ? walkTreeForImportMeta(sourceFile) : void 0;
    }
    function walkTreeForImportMeta(node) {
        return isImportMeta2(node) ? node : forEachChild(node, walkTreeForImportMeta);
    }
    function hasModifierOfKind(node, kind) {
        return some(node.modifiers, (m)=>m.kind === kind);
    }
    function isImportMeta2(node) {
        return isMetaProperty(node) && node.keywordToken === 102 /* ImportKeyword */  && node.name.escapedText === "meta";
    }
    var forEachChildTable = {
        [167 /* QualifiedName */ ]: function forEachChildInQualifiedName(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.left) || visitNode2(cbNode, node.right);
        },
        [169 /* TypeParameter */ ]: function forEachChildInTypeParameter(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.constraint) || visitNode2(cbNode, node.default) || visitNode2(cbNode, node.expression);
        },
        [305 /* ShorthandPropertyAssignment */ ]: function forEachChildInShorthandPropertyAssignment(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.equalsToken) || visitNode2(cbNode, node.objectAssignmentInitializer);
        },
        [306 /* SpreadAssignment */ ]: function forEachChildInSpreadAssignment(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [170 /* Parameter */ ]: function forEachChildInParameter(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
        },
        [173 /* PropertyDeclaration */ ]: function forEachChildInPropertyDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
        },
        [172 /* PropertySignature */ ]: function forEachChildInPropertySignature(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
        },
        [304 /* PropertyAssignment */ ]: function forEachChildInPropertyAssignment(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.initializer);
        },
        [261 /* VariableDeclaration */ ]: function forEachChildInVariableDeclaration(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.exclamationToken) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.initializer);
        },
        [209 /* BindingElement */ ]: function forEachChildInBindingElement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.propertyName) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.initializer);
        },
        [182 /* IndexSignature */ ]: function forEachChildInIndexSignature(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
        },
        [186 /* ConstructorType */ ]: function forEachChildInConstructorType(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
        },
        [185 /* FunctionType */ ]: function forEachChildInFunctionType(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
        },
        [180 /* CallSignature */ ]: forEachChildInCallOrConstructSignature,
        [181 /* ConstructSignature */ ]: forEachChildInCallOrConstructSignature,
        [175 /* MethodDeclaration */ ]: function forEachChildInMethodDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.exclamationToken) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
        },
        [174 /* MethodSignature */ ]: function forEachChildInMethodSignature(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
        },
        [177 /* Constructor */ ]: function forEachChildInConstructor(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
        },
        [178 /* GetAccessor */ ]: function forEachChildInGetAccessor(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
        },
        [179 /* SetAccessor */ ]: function forEachChildInSetAccessor(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
        },
        [263 /* FunctionDeclaration */ ]: function forEachChildInFunctionDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
        },
        [219 /* FunctionExpression */ ]: function forEachChildInFunctionExpression(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.body);
        },
        [220 /* ArrowFunction */ ]: function forEachChildInArrowFunction(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type) || visitNode2(cbNode, node.equalsGreaterThanToken) || visitNode2(cbNode, node.body);
        },
        [176 /* ClassStaticBlockDeclaration */ ]: function forEachChildInClassStaticBlockDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.body);
        },
        [184 /* TypeReference */ ]: function forEachChildInTypeReference(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.typeName) || visitNodes(cbNode, cbNodes, node.typeArguments);
        },
        [183 /* TypePredicate */ ]: function forEachChildInTypePredicate(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.assertsModifier) || visitNode2(cbNode, node.parameterName) || visitNode2(cbNode, node.type);
        },
        [187 /* TypeQuery */ ]: function forEachChildInTypeQuery(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.exprName) || visitNodes(cbNode, cbNodes, node.typeArguments);
        },
        [188 /* TypeLiteral */ ]: function forEachChildInTypeLiteral(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.members);
        },
        [189 /* ArrayType */ ]: function forEachChildInArrayType(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.elementType);
        },
        [190 /* TupleType */ ]: function forEachChildInTupleType(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.elements);
        },
        [193 /* UnionType */ ]: forEachChildInUnionOrIntersectionType,
        [194 /* IntersectionType */ ]: forEachChildInUnionOrIntersectionType,
        [195 /* ConditionalType */ ]: function forEachChildInConditionalType(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.checkType) || visitNode2(cbNode, node.extendsType) || visitNode2(cbNode, node.trueType) || visitNode2(cbNode, node.falseType);
        },
        [196 /* InferType */ ]: function forEachChildInInferType(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.typeParameter);
        },
        [206 /* ImportType */ ]: function forEachChildInImportType(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.argument) || visitNode2(cbNode, node.attributes) || visitNode2(cbNode, node.qualifier) || visitNodes(cbNode, cbNodes, node.typeArguments);
        },
        [303 /* ImportTypeAssertionContainer */ ]: function forEachChildInImportTypeAssertionContainer(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.assertClause);
        },
        [197 /* ParenthesizedType */ ]: forEachChildInParenthesizedTypeOrTypeOperator,
        [199 /* TypeOperator */ ]: forEachChildInParenthesizedTypeOrTypeOperator,
        [200 /* IndexedAccessType */ ]: function forEachChildInIndexedAccessType(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.objectType) || visitNode2(cbNode, node.indexType);
        },
        [201 /* MappedType */ ]: function forEachChildInMappedType(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.readonlyToken) || visitNode2(cbNode, node.typeParameter) || visitNode2(cbNode, node.nameType) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type) || visitNodes(cbNode, cbNodes, node.members);
        },
        [202 /* LiteralType */ ]: function forEachChildInLiteralType(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.literal);
        },
        [203 /* NamedTupleMember */ ]: function forEachChildInNamedTupleMember(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.type);
        },
        [207 /* ObjectBindingPattern */ ]: forEachChildInObjectOrArrayBindingPattern,
        [208 /* ArrayBindingPattern */ ]: forEachChildInObjectOrArrayBindingPattern,
        [210 /* ArrayLiteralExpression */ ]: function forEachChildInArrayLiteralExpression(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.elements);
        },
        [211 /* ObjectLiteralExpression */ ]: function forEachChildInObjectLiteralExpression(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.properties);
        },
        [212 /* PropertyAccessExpression */ ]: function forEachChildInPropertyAccessExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.questionDotToken) || visitNode2(cbNode, node.name);
        },
        [213 /* ElementAccessExpression */ ]: function forEachChildInElementAccessExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.questionDotToken) || visitNode2(cbNode, node.argumentExpression);
        },
        [214 /* CallExpression */ ]: forEachChildInCallOrNewExpression,
        [215 /* NewExpression */ ]: forEachChildInCallOrNewExpression,
        [216 /* TaggedTemplateExpression */ ]: function forEachChildInTaggedTemplateExpression(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tag) || visitNode2(cbNode, node.questionDotToken) || visitNodes(cbNode, cbNodes, node.typeArguments) || visitNode2(cbNode, node.template);
        },
        [217 /* TypeAssertionExpression */ ]: function forEachChildInTypeAssertionExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.type) || visitNode2(cbNode, node.expression);
        },
        [218 /* ParenthesizedExpression */ ]: function forEachChildInParenthesizedExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [221 /* DeleteExpression */ ]: function forEachChildInDeleteExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [222 /* TypeOfExpression */ ]: function forEachChildInTypeOfExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [223 /* VoidExpression */ ]: function forEachChildInVoidExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [225 /* PrefixUnaryExpression */ ]: function forEachChildInPrefixUnaryExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.operand);
        },
        [230 /* YieldExpression */ ]: function forEachChildInYieldExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.asteriskToken) || visitNode2(cbNode, node.expression);
        },
        [224 /* AwaitExpression */ ]: function forEachChildInAwaitExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [226 /* PostfixUnaryExpression */ ]: function forEachChildInPostfixUnaryExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.operand);
        },
        [227 /* BinaryExpression */ ]: function forEachChildInBinaryExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.left) || visitNode2(cbNode, node.operatorToken) || visitNode2(cbNode, node.right);
        },
        [235 /* AsExpression */ ]: function forEachChildInAsExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.type);
        },
        [236 /* NonNullExpression */ ]: function forEachChildInNonNullExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [239 /* SatisfiesExpression */ ]: function forEachChildInSatisfiesExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.type);
        },
        [237 /* MetaProperty */ ]: function forEachChildInMetaProperty(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name);
        },
        [228 /* ConditionalExpression */ ]: function forEachChildInConditionalExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.condition) || visitNode2(cbNode, node.questionToken) || visitNode2(cbNode, node.whenTrue) || visitNode2(cbNode, node.colonToken) || visitNode2(cbNode, node.whenFalse);
        },
        [231 /* SpreadElement */ ]: function forEachChildInSpreadElement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [242 /* Block */ ]: forEachChildInBlock,
        [269 /* ModuleBlock */ ]: forEachChildInBlock,
        [308 /* SourceFile */ ]: function forEachChildInSourceFile(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.statements) || visitNode2(cbNode, node.endOfFileToken);
        },
        [244 /* VariableStatement */ ]: function forEachChildInVariableStatement(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.declarationList);
        },
        [262 /* VariableDeclarationList */ ]: function forEachChildInVariableDeclarationList(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.declarations);
        },
        [245 /* ExpressionStatement */ ]: function forEachChildInExpressionStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [246 /* IfStatement */ ]: function forEachChildInIfStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.thenStatement) || visitNode2(cbNode, node.elseStatement);
        },
        [247 /* DoStatement */ ]: function forEachChildInDoStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.statement) || visitNode2(cbNode, node.expression);
        },
        [248 /* WhileStatement */ ]: function forEachChildInWhileStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
        },
        [249 /* ForStatement */ ]: function forEachChildInForStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.initializer) || visitNode2(cbNode, node.condition) || visitNode2(cbNode, node.incrementor) || visitNode2(cbNode, node.statement);
        },
        [250 /* ForInStatement */ ]: function forEachChildInForInStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.initializer) || visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
        },
        [251 /* ForOfStatement */ ]: function forEachChildInForOfStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.awaitModifier) || visitNode2(cbNode, node.initializer) || visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
        },
        [252 /* ContinueStatement */ ]: forEachChildInContinueOrBreakStatement,
        [253 /* BreakStatement */ ]: forEachChildInContinueOrBreakStatement,
        [254 /* ReturnStatement */ ]: function forEachChildInReturnStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [255 /* WithStatement */ ]: function forEachChildInWithStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.statement);
        },
        [256 /* SwitchStatement */ ]: function forEachChildInSwitchStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.caseBlock);
        },
        [270 /* CaseBlock */ ]: function forEachChildInCaseBlock(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.clauses);
        },
        [297 /* CaseClause */ ]: function forEachChildInCaseClause(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNodes(cbNode, cbNodes, node.statements);
        },
        [298 /* DefaultClause */ ]: function forEachChildInDefaultClause(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.statements);
        },
        [257 /* LabeledStatement */ ]: function forEachChildInLabeledStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.label) || visitNode2(cbNode, node.statement);
        },
        [258 /* ThrowStatement */ ]: function forEachChildInThrowStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [259 /* TryStatement */ ]: function forEachChildInTryStatement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.tryBlock) || visitNode2(cbNode, node.catchClause) || visitNode2(cbNode, node.finallyBlock);
        },
        [300 /* CatchClause */ ]: function forEachChildInCatchClause(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.variableDeclaration) || visitNode2(cbNode, node.block);
        },
        [171 /* Decorator */ ]: function forEachChildInDecorator(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [264 /* ClassDeclaration */ ]: forEachChildInClassDeclarationOrExpression,
        [232 /* ClassExpression */ ]: forEachChildInClassDeclarationOrExpression,
        [265 /* InterfaceDeclaration */ ]: function forEachChildInInterfaceDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.heritageClauses) || visitNodes(cbNode, cbNodes, node.members);
        },
        [266 /* TypeAliasDeclaration */ ]: function forEachChildInTypeAliasDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNode2(cbNode, node.type);
        },
        [267 /* EnumDeclaration */ ]: function forEachChildInEnumDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.members);
        },
        [307 /* EnumMember */ ]: function forEachChildInEnumMember(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.initializer);
        },
        [268 /* ModuleDeclaration */ ]: function forEachChildInModuleDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.body);
        },
        [272 /* ImportEqualsDeclaration */ ]: function forEachChildInImportEqualsDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNode2(cbNode, node.moduleReference);
        },
        [273 /* ImportDeclaration */ ]: function forEachChildInImportDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.importClause) || visitNode2(cbNode, node.moduleSpecifier) || visitNode2(cbNode, node.attributes);
        },
        [274 /* ImportClause */ ]: function forEachChildInImportClause(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.namedBindings);
        },
        [301 /* ImportAttributes */ ]: function forEachChildInImportAttributes(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.elements);
        },
        [302 /* ImportAttribute */ ]: function forEachChildInImportAttribute(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.value);
        },
        [271 /* NamespaceExportDeclaration */ ]: function forEachChildInNamespaceExportDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name);
        },
        [275 /* NamespaceImport */ ]: function forEachChildInNamespaceImport(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name);
        },
        [281 /* NamespaceExport */ ]: function forEachChildInNamespaceExport(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name);
        },
        [276 /* NamedImports */ ]: forEachChildInNamedImportsOrExports,
        [280 /* NamedExports */ ]: forEachChildInNamedImportsOrExports,
        [279 /* ExportDeclaration */ ]: function forEachChildInExportDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.exportClause) || visitNode2(cbNode, node.moduleSpecifier) || visitNode2(cbNode, node.attributes);
        },
        [277 /* ImportSpecifier */ ]: forEachChildInImportOrExportSpecifier,
        [282 /* ExportSpecifier */ ]: forEachChildInImportOrExportSpecifier,
        [278 /* ExportAssignment */ ]: function forEachChildInExportAssignment(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.expression);
        },
        [229 /* TemplateExpression */ ]: function forEachChildInTemplateExpression(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.head) || visitNodes(cbNode, cbNodes, node.templateSpans);
        },
        [240 /* TemplateSpan */ ]: function forEachChildInTemplateSpan(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNode2(cbNode, node.literal);
        },
        [204 /* TemplateLiteralType */ ]: function forEachChildInTemplateLiteralType(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.head) || visitNodes(cbNode, cbNodes, node.templateSpans);
        },
        [205 /* TemplateLiteralTypeSpan */ ]: function forEachChildInTemplateLiteralTypeSpan(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.type) || visitNode2(cbNode, node.literal);
        },
        [168 /* ComputedPropertyName */ ]: function forEachChildInComputedPropertyName(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [299 /* HeritageClause */ ]: function forEachChildInHeritageClause(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.types);
        },
        [234 /* ExpressionWithTypeArguments */ ]: function forEachChildInExpressionWithTypeArguments(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.expression) || visitNodes(cbNode, cbNodes, node.typeArguments);
        },
        [284 /* ExternalModuleReference */ ]: function forEachChildInExternalModuleReference(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [283 /* MissingDeclaration */ ]: function forEachChildInMissingDeclaration(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.modifiers);
        },
        [357 /* CommaListExpression */ ]: function forEachChildInCommaListExpression(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.elements);
        },
        [285 /* JsxElement */ ]: function forEachChildInJsxElement(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.openingElement) || visitNodes(cbNode, cbNodes, node.children) || visitNode2(cbNode, node.closingElement);
        },
        [289 /* JsxFragment */ ]: function forEachChildInJsxFragment(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.openingFragment) || visitNodes(cbNode, cbNodes, node.children) || visitNode2(cbNode, node.closingFragment);
        },
        [286 /* JsxSelfClosingElement */ ]: forEachChildInJsxOpeningOrSelfClosingElement,
        [287 /* JsxOpeningElement */ ]: forEachChildInJsxOpeningOrSelfClosingElement,
        [293 /* JsxAttributes */ ]: function forEachChildInJsxAttributes(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.properties);
        },
        [292 /* JsxAttribute */ ]: function forEachChildInJsxAttribute(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name) || visitNode2(cbNode, node.initializer);
        },
        [294 /* JsxSpreadAttribute */ ]: function forEachChildInJsxSpreadAttribute(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.expression);
        },
        [295 /* JsxExpression */ ]: function forEachChildInJsxExpression(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.dotDotDotToken) || visitNode2(cbNode, node.expression);
        },
        [288 /* JsxClosingElement */ ]: function forEachChildInJsxClosingElement(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.tagName);
        },
        [296 /* JsxNamespacedName */ ]: function forEachChildInJsxNamespacedName(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.namespace) || visitNode2(cbNode, node.name);
        },
        [191 /* OptionalType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [192 /* RestType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [310 /* JSDocTypeExpression */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [316 /* JSDocNonNullableType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [315 /* JSDocNullableType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [317 /* JSDocOptionalType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [319 /* JSDocVariadicType */ ]: forEachChildInOptionalRestOrJSDocParameterModifier,
        [318 /* JSDocFunctionType */ ]: function forEachChildInJSDocFunctionType(node, cbNode, cbNodes) {
            return visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
        },
        [321 /* JSDoc */ ]: function forEachChildInJSDoc(node, cbNode, cbNodes) {
            return (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment)) || visitNodes(cbNode, cbNodes, node.tags);
        },
        [348 /* JSDocSeeTag */ ]: function forEachChildInJSDocSeeTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.name) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
        },
        [311 /* JSDocNameReference */ ]: function forEachChildInJSDocNameReference(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.name);
        },
        [312 /* JSDocMemberName */ ]: function forEachChildInJSDocMemberName(node, cbNode, _cbNodes) {
            return visitNode2(cbNode, node.left) || visitNode2(cbNode, node.right);
        },
        [342 /* JSDocParameterTag */ ]: forEachChildInJSDocParameterOrPropertyTag,
        [349 /* JSDocPropertyTag */ ]: forEachChildInJSDocParameterOrPropertyTag,
        [331 /* JSDocAuthorTag */ ]: function forEachChildInJSDocAuthorTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
        },
        [330 /* JSDocImplementsTag */ ]: function forEachChildInJSDocImplementsTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.class) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
        },
        [329 /* JSDocAugmentsTag */ ]: function forEachChildInJSDocAugmentsTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.class) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
        },
        [346 /* JSDocTemplateTag */ ]: function forEachChildInJSDocTemplateTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.constraint) || visitNodes(cbNode, cbNodes, node.typeParameters) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
        },
        [347 /* JSDocTypedefTag */ ]: function forEachChildInJSDocTypedefTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || (node.typeExpression && node.typeExpression.kind === 310 /* JSDocTypeExpression */  ? visitNode2(cbNode, node.typeExpression) || visitNode2(cbNode, node.fullName) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment)) : visitNode2(cbNode, node.fullName) || visitNode2(cbNode, node.typeExpression) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment)));
        },
        [339 /* JSDocCallbackTag */ ]: function forEachChildInJSDocCallbackTag(node, cbNode, cbNodes) {
            return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.fullName) || visitNode2(cbNode, node.typeExpression) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
        },
        [343 /* JSDocReturnTag */ ]: forEachChildInJSDocTypeLikeTag,
        [345 /* JSDocTypeTag */ ]: forEachChildInJSDocTypeLikeTag,
        [344 /* JSDocThisTag */ ]: forEachChildInJSDocTypeLikeTag,
        [341 /* JSDocEnumTag */ ]: forEachChildInJSDocTypeLikeTag,
        [351 /* JSDocSatisfiesTag */ ]: forEachChildInJSDocTypeLikeTag,
        [350 /* JSDocThrowsTag */ ]: forEachChildInJSDocTypeLikeTag,
        [340 /* JSDocOverloadTag */ ]: forEachChildInJSDocTypeLikeTag,
        [324 /* JSDocSignature */ ]: function forEachChildInJSDocSignature(node, cbNode, _cbNodes) {
            return forEach(node.typeParameters, cbNode) || forEach(node.parameters, cbNode) || visitNode2(cbNode, node.type);
        },
        [325 /* JSDocLink */ ]: forEachChildInJSDocLinkCodeOrPlain,
        [326 /* JSDocLinkCode */ ]: forEachChildInJSDocLinkCodeOrPlain,
        [327 /* JSDocLinkPlain */ ]: forEachChildInJSDocLinkCodeOrPlain,
        [323 /* JSDocTypeLiteral */ ]: function forEachChildInJSDocTypeLiteral(node, cbNode, _cbNodes) {
            return forEach(node.jsDocPropertyTags, cbNode);
        },
        [328 /* JSDocTag */ ]: forEachChildInJSDocTag,
        [333 /* JSDocClassTag */ ]: forEachChildInJSDocTag,
        [334 /* JSDocPublicTag */ ]: forEachChildInJSDocTag,
        [335 /* JSDocPrivateTag */ ]: forEachChildInJSDocTag,
        [336 /* JSDocProtectedTag */ ]: forEachChildInJSDocTag,
        [337 /* JSDocReadonlyTag */ ]: forEachChildInJSDocTag,
        [332 /* JSDocDeprecatedTag */ ]: forEachChildInJSDocTag,
        [338 /* JSDocOverrideTag */ ]: forEachChildInJSDocTag,
        [352 /* JSDocImportTag */ ]: forEachChildInJSDocImportTag,
        [356 /* PartiallyEmittedExpression */ ]: forEachChildInPartiallyEmittedExpression
    };
    function forEachChildInCallOrConstructSignature(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.parameters) || visitNode2(cbNode, node.type);
    }
    function forEachChildInUnionOrIntersectionType(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.types);
    }
    function forEachChildInParenthesizedTypeOrTypeOperator(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.type);
    }
    function forEachChildInObjectOrArrayBindingPattern(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.elements);
    }
    function forEachChildInCallOrNewExpression(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.expression) || // TODO: should we separate these branches out?
        visitNode2(cbNode, node.questionDotToken) || visitNodes(cbNode, cbNodes, node.typeArguments) || visitNodes(cbNode, cbNodes, node.arguments);
    }
    function forEachChildInBlock(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.statements);
    }
    function forEachChildInContinueOrBreakStatement(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.label);
    }
    function forEachChildInClassDeclarationOrExpression(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.modifiers) || visitNode2(cbNode, node.name) || visitNodes(cbNode, cbNodes, node.typeParameters) || visitNodes(cbNode, cbNodes, node.heritageClauses) || visitNodes(cbNode, cbNodes, node.members);
    }
    function forEachChildInNamedImportsOrExports(node, cbNode, cbNodes) {
        return visitNodes(cbNode, cbNodes, node.elements);
    }
    function forEachChildInImportOrExportSpecifier(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.propertyName) || visitNode2(cbNode, node.name);
    }
    function forEachChildInJsxOpeningOrSelfClosingElement(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || visitNodes(cbNode, cbNodes, node.typeArguments) || visitNode2(cbNode, node.attributes);
    }
    function forEachChildInOptionalRestOrJSDocParameterModifier(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.type);
    }
    function forEachChildInJSDocParameterOrPropertyTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || (node.isNameFirst ? visitNode2(cbNode, node.name) || visitNode2(cbNode, node.typeExpression) : visitNode2(cbNode, node.typeExpression) || visitNode2(cbNode, node.name)) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInJSDocTypeLikeTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.typeExpression) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInJSDocLinkCodeOrPlain(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.name);
    }
    function forEachChildInJSDocTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInJSDocImportTag(node, cbNode, cbNodes) {
        return visitNode2(cbNode, node.tagName) || visitNode2(cbNode, node.importClause) || visitNode2(cbNode, node.moduleSpecifier) || visitNode2(cbNode, node.attributes) || (typeof node.comment === "string" ? void 0 : visitNodes(cbNode, cbNodes, node.comment));
    }
    function forEachChildInPartiallyEmittedExpression(node, cbNode, _cbNodes) {
        return visitNode2(cbNode, node.expression);
    }
    function forEachChild(node, cbNode, cbNodes) {
        if (node === void 0 || node.kind <= 166 /* LastToken */ ) return;
        const fn = forEachChildTable[node.kind];
        return fn === void 0 ? void 0 : fn(node, cbNode, cbNodes);
    }
    function forEachChildRecursively(rootNode, cbNode, cbNodes) {
        const queue = gatherPossibleChildren(rootNode);
        const parents = [];
        while(parents.length < queue.length)parents.push(rootNode);
        while(queue.length !== 0){
            const current = queue.pop();
            const parent2 = parents.pop();
            if (isArray(current)) {
                if (cbNodes) {
                    const res = cbNodes(current, parent2);
                    if (res) {
                        if (res === "skip") continue;
                        return res;
                    }
                }
                for(let i = current.length - 1; i >= 0; --i){
                    queue.push(current[i]);
                    parents.push(parent2);
                }
            } else {
                const res = cbNode(current, parent2);
                if (res) {
                    if (res === "skip") continue;
                    return res;
                }
                if (current.kind >= 167 /* FirstNode */ ) for (const child of gatherPossibleChildren(current)){
                    queue.push(child);
                    parents.push(current);
                }
            }
        }
    }
    function gatherPossibleChildren(node) {
        const children = [];
        forEachChild(node, addWorkItem, addWorkItem);
        return children;
        function addWorkItem(n) {
            children.unshift(n);
        }
    }
    function setExternalModuleIndicator(sourceFile) {
        sourceFile.externalModuleIndicator = isFileProbablyExternalModule(sourceFile);
    }
    function createSourceFile(fileName, sourceText, languageVersionOrOptions, setParentNodes = false, scriptKind) {
        var _a, _b;
        (_a = tracing) == null || _a.push(tracing.Phase.Parse, "createSourceFile", {
            path: fileName
        }, /*separateBeginAndEnd*/ true);
        mark("beforeParse");
        let result;
        const { languageVersion, setExternalModuleIndicator: overrideSetExternalModuleIndicator, impliedNodeFormat: format, jsDocParsingMode } = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions : {
            languageVersion: languageVersionOrOptions
        };
        if (languageVersion === 100 /* JSON */ ) result = Parser.parseSourceFile(fileName, sourceText, languageVersion, /*syntaxCursor*/ void 0, setParentNodes, 6 /* JSON */ , noop, jsDocParsingMode);
        else {
            const setIndicator = format === void 0 ? overrideSetExternalModuleIndicator : (file)=>{
                file.impliedNodeFormat = format;
                return (overrideSetExternalModuleIndicator || setExternalModuleIndicator)(file);
            };
            result = Parser.parseSourceFile(fileName, sourceText, languageVersion, /*syntaxCursor*/ void 0, setParentNodes, scriptKind, setIndicator, jsDocParsingMode);
        }
        mark("afterParse");
        measure("Parse", "beforeParse", "afterParse");
        (_b = tracing) == null || _b.pop();
        return result;
    }
    function parseIsolatedEntityName(text, languageVersion) {
        return Parser.parseIsolatedEntityName(text, languageVersion);
    }
    function parseJsonText(fileName, sourceText) {
        return Parser.parseJsonText(fileName, sourceText);
    }
    function isExternalModule(file) {
        return file.externalModuleIndicator !== void 0;
    }
    function updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks = false) {
        const newSourceFile = IncrementalParser.updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
        newSourceFile.flags |= sourceFile.flags & 12582912 /* PermanentlySetIncrementalFlags */ ;
        return newSourceFile;
    }
    function parseIsolatedJSDocComment(content, start, length2) {
        const result = Parser.JSDocParser.parseIsolatedJSDocComment(content, start, length2);
        if (result && result.jsDoc) Parser.fixupParentReferences(result.jsDoc);
        return result;
    }
    function parseJSDocTypeExpressionForTests(content, start, length2) {
        return Parser.JSDocParser.parseJSDocTypeExpressionForTests(content, start, length2);
    }
    var Parser;
    ((Parser2)=>{
        var scanner2 = createScanner(99 /* Latest */ , /*skipTrivia*/ true);
        var disallowInAndDecoratorContext = 40960 /* DecoratorContext */ ;
        var NodeConstructor2;
        var TokenConstructor2;
        var IdentifierConstructor2;
        var PrivateIdentifierConstructor2;
        var SourceFileConstructor2;
        function countNode(node) {
            nodeCount++;
            return node;
        }
        var baseNodeFactory = {
            createBaseSourceFileNode: (kind)=>countNode(new SourceFileConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
            createBaseIdentifierNode: (kind)=>countNode(new IdentifierConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
            createBasePrivateIdentifierNode: (kind)=>countNode(new PrivateIdentifierConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
            createBaseTokenNode: (kind)=>countNode(new TokenConstructor2(kind, /*pos*/ 0, /*end*/ 0)),
            createBaseNode: (kind)=>countNode(new NodeConstructor2(kind, /*pos*/ 0, /*end*/ 0))
        };
        var factory2 = createNodeFactory(11 /* NoOriginalNode */ , baseNodeFactory);
        var { createNodeArray: factoryCreateNodeArray, createNumericLiteral: factoryCreateNumericLiteral, createStringLiteral: factoryCreateStringLiteral, createLiteralLikeNode: factoryCreateLiteralLikeNode, createIdentifier: factoryCreateIdentifier, createPrivateIdentifier: factoryCreatePrivateIdentifier, createToken: factoryCreateToken, createArrayLiteralExpression: factoryCreateArrayLiteralExpression, createObjectLiteralExpression: factoryCreateObjectLiteralExpression, createPropertyAccessExpression: factoryCreatePropertyAccessExpression, createPropertyAccessChain: factoryCreatePropertyAccessChain, createElementAccessExpression: factoryCreateElementAccessExpression, createElementAccessChain: factoryCreateElementAccessChain, createCallExpression: factoryCreateCallExpression, createCallChain: factoryCreateCallChain, createNewExpression: factoryCreateNewExpression, createParenthesizedExpression: factoryCreateParenthesizedExpression, createBlock: factoryCreateBlock, createVariableStatement: factoryCreateVariableStatement, createExpressionStatement: factoryCreateExpressionStatement, createIfStatement: factoryCreateIfStatement, createWhileStatement: factoryCreateWhileStatement, createForStatement: factoryCreateForStatement, createForOfStatement: factoryCreateForOfStatement, createVariableDeclaration: factoryCreateVariableDeclaration, createVariableDeclarationList: factoryCreateVariableDeclarationList } = factory2;
        var fileName;
        var sourceFlags;
        var sourceText;
        var languageVersion;
        var scriptKind;
        var languageVariant;
        var parseDiagnostics;
        var jsDocDiagnostics;
        var syntaxCursor;
        var currentToken;
        var nodeCount;
        var identifiers;
        var identifierCount;
        var parsingContext;
        var notParenthesizedArrow;
        var contextFlags;
        var topLevel = true;
        var parseErrorBeforeNextFinishedNode = false;
        function parseSourceFile(fileName2, sourceText2, languageVersion2, syntaxCursor2, setParentNodes = false, scriptKind2, setExternalModuleIndicatorOverride, jsDocParsingMode = 0 /* ParseAll */ ) {
            var _a;
            scriptKind2 = ensureScriptKind(fileName2, scriptKind2);
            if (scriptKind2 === 6 /* JSON */ ) {
                const result2 = parseJsonText2(fileName2, sourceText2, languageVersion2, syntaxCursor2, setParentNodes);
                convertToJson(result2, (_a = result2.statements[0]) == null ? void 0 : _a.expression, result2.parseDiagnostics, /*returnValue*/ false, /*jsonConversionNotifier*/ void 0);
                result2.referencedFiles = emptyArray;
                result2.typeReferenceDirectives = emptyArray;
                result2.libReferenceDirectives = emptyArray;
                result2.amdDependencies = emptyArray;
                result2.hasNoDefaultLib = false;
                result2.pragmas = emptyMap;
                return result2;
            }
            initializeState(fileName2, sourceText2, languageVersion2, syntaxCursor2, scriptKind2, jsDocParsingMode);
            const result = parseSourceFileWorker(languageVersion2, setParentNodes, scriptKind2, setExternalModuleIndicatorOverride || setExternalModuleIndicator, jsDocParsingMode);
            clearState();
            return result;
        }
        Parser2.parseSourceFile = parseSourceFile;
        function parseIsolatedEntityName2(content, languageVersion2) {
            initializeState("", content, languageVersion2, /*syntaxCursor*/ void 0, 1 /* JS */ , 0 /* ParseAll */ );
            nextToken();
            const entityName = parseEntityName(/*allowReservedWords*/ true);
            const isValid = token() === 1 /* EndOfFileToken */  && !parseDiagnostics.length;
            clearState();
            return isValid ? entityName : void 0;
        }
        Parser2.parseIsolatedEntityName = parseIsolatedEntityName2;
        function parseJsonText2(fileName2, sourceText2, languageVersion2 = 2 /* ES2015 */ , syntaxCursor2, setParentNodes = false) {
            initializeState(fileName2, sourceText2, languageVersion2, syntaxCursor2, 6 /* JSON */ , 0 /* ParseAll */ );
            sourceFlags = contextFlags;
            nextToken();
            const pos = getNodePos();
            let statements, endOfFileToken;
            if (token() === 1 /* EndOfFileToken */ ) {
                statements = createNodeArray([], pos, pos);
                endOfFileToken = parseTokenNode();
            } else {
                let expressions;
                while(token() !== 1 /* EndOfFileToken */ ){
                    let expression2;
                    switch(token()){
                        case 23 /* OpenBracketToken */ :
                            expression2 = parseArrayLiteralExpression();
                            break;
                        case 112 /* TrueKeyword */ :
                        case 97 /* FalseKeyword */ :
                        case 106 /* NullKeyword */ :
                            expression2 = parseTokenNode();
                            break;
                        case 41 /* MinusToken */ :
                            if (lookAhead(()=>nextToken() === 9 /* NumericLiteral */  && nextToken() !== 59 /* ColonToken */ )) expression2 = parsePrefixUnaryExpression();
                            else expression2 = parseObjectLiteralExpression();
                            break;
                        case 9 /* NumericLiteral */ :
                        case 11 /* StringLiteral */ :
                            if (lookAhead(()=>nextToken() !== 59 /* ColonToken */ )) {
                                expression2 = parseLiteralNode();
                                break;
                            }
                        // falls through
                        default:
                            expression2 = parseObjectLiteralExpression();
                            break;
                    }
                    if (expressions && isArray(expressions)) expressions.push(expression2);
                    else if (expressions) expressions = [
                        expressions,
                        expression2
                    ];
                    else {
                        expressions = expression2;
                        if (token() !== 1 /* EndOfFileToken */ ) parseErrorAtCurrentToken(Diagnostics.Unexpected_token);
                    }
                }
                const expression = isArray(expressions) ? finishNode(factoryCreateArrayLiteralExpression(expressions), pos) : Debug.checkDefined(expressions);
                const statement = factoryCreateExpressionStatement(expression);
                finishNode(statement, pos);
                statements = createNodeArray([
                    statement
                ], pos);
                endOfFileToken = parseExpectedToken(1 /* EndOfFileToken */ , Diagnostics.Unexpected_token);
            }
            const sourceFile = createSourceFile2(fileName2, 2 /* ES2015 */ , 6 /* JSON */ , /*isDeclarationFile*/ false, statements, endOfFileToken, sourceFlags, noop);
            if (setParentNodes) fixupParentReferences(sourceFile);
            sourceFile.nodeCount = nodeCount;
            sourceFile.identifierCount = identifierCount;
            sourceFile.identifiers = identifiers;
            sourceFile.parseDiagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
            if (jsDocDiagnostics) sourceFile.jsDocDiagnostics = attachFileToDiagnostics(jsDocDiagnostics, sourceFile);
            const result = sourceFile;
            clearState();
            return result;
        }
        Parser2.parseJsonText = parseJsonText2;
        function initializeState(_fileName, _sourceText, _languageVersion, _syntaxCursor, _scriptKind, _jsDocParsingMode) {
            NodeConstructor2 = objectAllocator.getNodeConstructor();
            TokenConstructor2 = objectAllocator.getTokenConstructor();
            IdentifierConstructor2 = objectAllocator.getIdentifierConstructor();
            PrivateIdentifierConstructor2 = objectAllocator.getPrivateIdentifierConstructor();
            SourceFileConstructor2 = objectAllocator.getSourceFileConstructor();
            fileName = normalizePath(_fileName);
            sourceText = _sourceText;
            languageVersion = _languageVersion;
            syntaxCursor = _syntaxCursor;
            scriptKind = _scriptKind;
            languageVariant = getLanguageVariant(_scriptKind);
            parseDiagnostics = [];
            parsingContext = 0;
            identifiers = /* @__PURE__ */ new Map();
            identifierCount = 0;
            nodeCount = 0;
            sourceFlags = 0;
            topLevel = true;
            switch(scriptKind){
                case 1 /* JS */ :
                case 2 /* JSX */ :
                    contextFlags = 524288 /* JavaScriptFile */ ;
                    break;
                case 6 /* JSON */ :
                    contextFlags = 134742016 /* JsonFile */ ;
                    break;
                default:
                    contextFlags = 0 /* None */ ;
                    break;
            }
            parseErrorBeforeNextFinishedNode = false;
            scanner2.setText(sourceText);
            scanner2.setOnError(scanError);
            scanner2.setScriptTarget(languageVersion);
            scanner2.setLanguageVariant(languageVariant);
            scanner2.setScriptKind(scriptKind);
            scanner2.setJSDocParsingMode(_jsDocParsingMode);
        }
        function clearState() {
            scanner2.clearCommentDirectives();
            scanner2.setText("");
            scanner2.setOnError(void 0);
            scanner2.setScriptKind(0 /* Unknown */ );
            scanner2.setJSDocParsingMode(0 /* ParseAll */ );
            sourceText = void 0;
            languageVersion = void 0;
            syntaxCursor = void 0;
            scriptKind = void 0;
            languageVariant = void 0;
            sourceFlags = 0;
            parseDiagnostics = void 0;
            jsDocDiagnostics = void 0;
            parsingContext = 0;
            identifiers = void 0;
            notParenthesizedArrow = void 0;
            topLevel = true;
        }
        function parseSourceFileWorker(languageVersion2, setParentNodes, scriptKind2, setExternalModuleIndicator2, jsDocParsingMode) {
            const isDeclarationFile = isDeclarationFileName(fileName);
            if (isDeclarationFile) contextFlags |= 33554432 /* Ambient */ ;
            sourceFlags = contextFlags;
            nextToken();
            const statements = parseList(0 /* SourceElements */ , parseStatement);
            Debug.assert(token() === 1 /* EndOfFileToken */ );
            const endHasJSDoc = hasPrecedingJSDocComment();
            const endOfFileToken = withJSDoc(parseTokenNode(), endHasJSDoc);
            const sourceFile = createSourceFile2(fileName, languageVersion2, scriptKind2, isDeclarationFile, statements, endOfFileToken, sourceFlags, setExternalModuleIndicator2);
            processCommentPragmas(sourceFile, sourceText);
            processPragmasIntoFields(sourceFile, reportPragmaDiagnostic);
            sourceFile.commentDirectives = scanner2.getCommentDirectives();
            sourceFile.nodeCount = nodeCount;
            sourceFile.identifierCount = identifierCount;
            sourceFile.identifiers = identifiers;
            sourceFile.parseDiagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
            sourceFile.jsDocParsingMode = jsDocParsingMode;
            if (jsDocDiagnostics) sourceFile.jsDocDiagnostics = attachFileToDiagnostics(jsDocDiagnostics, sourceFile);
            if (setParentNodes) fixupParentReferences(sourceFile);
            return sourceFile;
            function reportPragmaDiagnostic(pos, end, diagnostic) {
                parseDiagnostics.push(createDetachedDiagnostic(fileName, sourceText, pos, end, diagnostic));
            }
        }
        let hasDeprecatedTag = false;
        function withJSDoc(node, hasJSDoc) {
            if (!hasJSDoc) return node;
            Debug.assert(!node.jsDoc);
            const jsDoc = mapDefined(getJSDocCommentRanges(node, sourceText), (comment)=>JSDocParser.parseJSDocComment(node, comment.pos, comment.end - comment.pos));
            if (jsDoc.length) node.jsDoc = jsDoc;
            if (hasDeprecatedTag) {
                hasDeprecatedTag = false;
                node.flags |= 536870912 /* Deprecated */ ;
            }
            return node;
        }
        function reparseTopLevelAwait(sourceFile) {
            const savedSyntaxCursor = syntaxCursor;
            const baseSyntaxCursor = IncrementalParser.createSyntaxCursor(sourceFile);
            syntaxCursor = {
                currentNode: currentNode2
            };
            const statements = [];
            const savedParseDiagnostics = parseDiagnostics;
            parseDiagnostics = [];
            let pos = 0;
            let start = findNextStatementWithAwait(sourceFile.statements, 0);
            while(start !== -1){
                const prevStatement = sourceFile.statements[pos];
                const nextStatement = sourceFile.statements[start];
                addRange(statements, sourceFile.statements, pos, start);
                pos = findNextStatementWithoutAwait(sourceFile.statements, start);
                const diagnosticStart = findIndex(savedParseDiagnostics, (diagnostic)=>diagnostic.start >= prevStatement.pos);
                const diagnosticEnd = diagnosticStart >= 0 ? findIndex(savedParseDiagnostics, (diagnostic)=>diagnostic.start >= nextStatement.pos, diagnosticStart) : -1;
                if (diagnosticStart >= 0) addRange(parseDiagnostics, savedParseDiagnostics, diagnosticStart, diagnosticEnd >= 0 ? diagnosticEnd : void 0);
                speculationHelper(()=>{
                    const savedContextFlags = contextFlags;
                    contextFlags |= 65536 /* AwaitContext */ ;
                    scanner2.resetTokenState(nextStatement.pos);
                    nextToken();
                    while(token() !== 1 /* EndOfFileToken */ ){
                        const startPos = scanner2.getTokenFullStart();
                        const statement = parseListElement(0 /* SourceElements */ , parseStatement);
                        statements.push(statement);
                        if (startPos === scanner2.getTokenFullStart()) nextToken();
                        if (pos >= 0) {
                            const nonAwaitStatement = sourceFile.statements[pos];
                            if (statement.end === nonAwaitStatement.pos) break;
                            if (statement.end > nonAwaitStatement.pos) pos = findNextStatementWithoutAwait(sourceFile.statements, pos + 1);
                        }
                    }
                    contextFlags = savedContextFlags;
                }, 2 /* Reparse */ );
                start = pos >= 0 ? findNextStatementWithAwait(sourceFile.statements, pos) : -1;
            }
            if (pos >= 0) {
                const prevStatement = sourceFile.statements[pos];
                addRange(statements, sourceFile.statements, pos);
                const diagnosticStart = findIndex(savedParseDiagnostics, (diagnostic)=>diagnostic.start >= prevStatement.pos);
                if (diagnosticStart >= 0) addRange(parseDiagnostics, savedParseDiagnostics, diagnosticStart);
            }
            syntaxCursor = savedSyntaxCursor;
            return factory2.updateSourceFile(sourceFile, setTextRange(factoryCreateNodeArray(statements), sourceFile.statements));
            function containsPossibleTopLevelAwait(node) {
                return !(node.flags & 65536 /* AwaitContext */ ) && !!(node.transformFlags & 67108864 /* ContainsPossibleTopLevelAwait */ );
            }
            function findNextStatementWithAwait(statements2, start2) {
                for(let i = start2; i < statements2.length; i++){
                    if (containsPossibleTopLevelAwait(statements2[i])) return i;
                }
                return -1;
            }
            function findNextStatementWithoutAwait(statements2, start2) {
                for(let i = start2; i < statements2.length; i++){
                    if (!containsPossibleTopLevelAwait(statements2[i])) return i;
                }
                return -1;
            }
            function currentNode2(position) {
                const node = baseSyntaxCursor.currentNode(position);
                if (topLevel && node && containsPossibleTopLevelAwait(node)) markAsIntersectingIncrementalChange(node);
                return node;
            }
        }
        function fixupParentReferences(rootNode) {
            setParentRecursive(rootNode, /*incremental*/ true);
        }
        Parser2.fixupParentReferences = fixupParentReferences;
        function createSourceFile2(fileName2, languageVersion2, scriptKind2, isDeclarationFile, statements, endOfFileToken, flags, setExternalModuleIndicator2) {
            let sourceFile = factory2.createSourceFile(statements, endOfFileToken, flags);
            setTextRangePosWidth(sourceFile, 0, sourceText.length);
            setFields(sourceFile);
            if (!isDeclarationFile && isExternalModule(sourceFile) && sourceFile.transformFlags & 67108864 /* ContainsPossibleTopLevelAwait */ ) {
                const oldSourceFile = sourceFile;
                sourceFile = reparseTopLevelAwait(sourceFile);
                if (oldSourceFile !== sourceFile) setFields(sourceFile);
            }
            return sourceFile;
            function setFields(sourceFile2) {
                sourceFile2.text = sourceText;
                sourceFile2.bindDiagnostics = [];
                sourceFile2.bindSuggestionDiagnostics = void 0;
                sourceFile2.languageVersion = languageVersion2;
                sourceFile2.fileName = fileName2;
                sourceFile2.languageVariant = getLanguageVariant(scriptKind2);
                sourceFile2.isDeclarationFile = isDeclarationFile;
                sourceFile2.scriptKind = scriptKind2;
                setExternalModuleIndicator2(sourceFile2);
                sourceFile2.setExternalModuleIndicator = setExternalModuleIndicator2;
            }
        }
        function setContextFlag(val, flag) {
            if (val) contextFlags |= flag;
            else contextFlags &= ~flag;
        }
        function setDisallowInContext(val) {
            setContextFlag(val, 8192 /* DisallowInContext */ );
        }
        function setYieldContext(val) {
            setContextFlag(val, 16384 /* YieldContext */ );
        }
        function setDecoratorContext(val) {
            setContextFlag(val, 32768 /* DecoratorContext */ );
        }
        function setAwaitContext(val) {
            setContextFlag(val, 65536 /* AwaitContext */ );
        }
        function doOutsideOfContext(context, func) {
            const contextFlagsToClear = context & contextFlags;
            if (contextFlagsToClear) {
                setContextFlag(/*val*/ false, contextFlagsToClear);
                const result = func();
                setContextFlag(/*val*/ true, contextFlagsToClear);
                return result;
            }
            return func();
        }
        function doInsideOfContext(context, func) {
            const contextFlagsToSet = context & ~contextFlags;
            if (contextFlagsToSet) {
                setContextFlag(/*val*/ true, contextFlagsToSet);
                const result = func();
                setContextFlag(/*val*/ false, contextFlagsToSet);
                return result;
            }
            return func();
        }
        function allowInAnd(func) {
            return doOutsideOfContext(8192 /* DisallowInContext */ , func);
        }
        function disallowInAnd(func) {
            return doInsideOfContext(8192 /* DisallowInContext */ , func);
        }
        function allowConditionalTypesAnd(func) {
            return doOutsideOfContext(131072 /* DisallowConditionalTypesContext */ , func);
        }
        function disallowConditionalTypesAnd(func) {
            return doInsideOfContext(131072 /* DisallowConditionalTypesContext */ , func);
        }
        function doInYieldContext(func) {
            return doInsideOfContext(16384 /* YieldContext */ , func);
        }
        function doInDecoratorContext(func) {
            return doInsideOfContext(32768 /* DecoratorContext */ , func);
        }
        function doInAwaitContext(func) {
            return doInsideOfContext(65536 /* AwaitContext */ , func);
        }
        function doOutsideOfAwaitContext(func) {
            return doOutsideOfContext(65536 /* AwaitContext */ , func);
        }
        function doInYieldAndAwaitContext(func) {
            return doInsideOfContext(81920 /* AwaitContext */ , func);
        }
        function doOutsideOfYieldAndAwaitContext(func) {
            return doOutsideOfContext(81920 /* AwaitContext */ , func);
        }
        function inContext(flags) {
            return (contextFlags & flags) !== 0;
        }
        function inYieldContext() {
            return inContext(16384 /* YieldContext */ );
        }
        function inDisallowInContext() {
            return inContext(8192 /* DisallowInContext */ );
        }
        function inDisallowConditionalTypesContext() {
            return inContext(131072 /* DisallowConditionalTypesContext */ );
        }
        function inDecoratorContext() {
            return inContext(32768 /* DecoratorContext */ );
        }
        function inAwaitContext() {
            return inContext(65536 /* AwaitContext */ );
        }
        function parseErrorAtCurrentToken(message, ...args) {
            return parseErrorAt(scanner2.getTokenStart(), scanner2.getTokenEnd(), message, ...args);
        }
        function parseErrorAtPosition(start, length2, message, ...args) {
            const lastError = lastOrUndefined(parseDiagnostics);
            let result;
            if (!lastError || start !== lastError.start) {
                result = createDetachedDiagnostic(fileName, sourceText, start, length2, message, ...args);
                parseDiagnostics.push(result);
            }
            parseErrorBeforeNextFinishedNode = true;
            return result;
        }
        function parseErrorAt(start, end, message, ...args) {
            return parseErrorAtPosition(start, end - start, message, ...args);
        }
        function parseErrorAtRange(range, message, ...args) {
            parseErrorAt(range.pos, range.end, message, ...args);
        }
        function scanError(message, length2, arg0) {
            parseErrorAtPosition(scanner2.getTokenEnd(), length2, message, arg0);
        }
        function getNodePos() {
            return scanner2.getTokenFullStart();
        }
        function hasPrecedingJSDocComment() {
            return scanner2.hasPrecedingJSDocComment();
        }
        function token() {
            return currentToken;
        }
        function nextTokenWithoutCheck() {
            return currentToken = scanner2.scan();
        }
        function nextTokenAnd(func) {
            nextToken();
            return func();
        }
        function nextToken() {
            if (isKeyword(currentToken) && (scanner2.hasUnicodeEscape() || scanner2.hasExtendedUnicodeEscape())) parseErrorAt(scanner2.getTokenStart(), scanner2.getTokenEnd(), Diagnostics.Keywords_cannot_contain_escape_characters);
            return nextTokenWithoutCheck();
        }
        function nextTokenJSDoc() {
            return currentToken = scanner2.scanJsDocToken();
        }
        function nextJSDocCommentTextToken(inBackticks) {
            return currentToken = scanner2.scanJSDocCommentTextToken(inBackticks);
        }
        function reScanGreaterToken() {
            return currentToken = scanner2.reScanGreaterToken();
        }
        function reScanSlashToken() {
            return currentToken = scanner2.reScanSlashToken();
        }
        function reScanTemplateToken(isTaggedTemplate) {
            return currentToken = scanner2.reScanTemplateToken(isTaggedTemplate);
        }
        function reScanLessThanToken() {
            return currentToken = scanner2.reScanLessThanToken();
        }
        function reScanHashToken() {
            return currentToken = scanner2.reScanHashToken();
        }
        function scanJsxIdentifier() {
            return currentToken = scanner2.scanJsxIdentifier();
        }
        function scanJsxText() {
            return currentToken = scanner2.scanJsxToken();
        }
        function scanJsxAttributeValue() {
            return currentToken = scanner2.scanJsxAttributeValue();
        }
        function speculationHelper(callback, speculationKind) {
            const saveToken = currentToken;
            const saveParseDiagnosticsLength = parseDiagnostics.length;
            const saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
            const saveContextFlags = contextFlags;
            const result = speculationKind !== 0 /* TryParse */  ? scanner2.lookAhead(callback) : scanner2.tryScan(callback);
            Debug.assert(saveContextFlags === contextFlags);
            if (!result || speculationKind !== 0 /* TryParse */ ) {
                currentToken = saveToken;
                if (speculationKind !== 2 /* Reparse */ ) parseDiagnostics.length = saveParseDiagnosticsLength;
                parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
            }
            return result;
        }
        function lookAhead(callback) {
            return speculationHelper(callback, 1 /* Lookahead */ );
        }
        function tryParse(callback) {
            return speculationHelper(callback, 0 /* TryParse */ );
        }
        function isBindingIdentifier() {
            if (token() === 80 /* Identifier */ ) return true;
            return token() > 118 /* LastReservedWord */ ;
        }
        function isIdentifier2() {
            if (token() === 80 /* Identifier */ ) return true;
            if (token() === 127 /* YieldKeyword */  && inYieldContext()) return false;
            if (token() === 135 /* AwaitKeyword */  && inAwaitContext()) return false;
            return token() > 118 /* LastReservedWord */ ;
        }
        function parseExpected(kind, diagnosticMessage, shouldAdvance = true) {
            if (token() === kind) {
                if (shouldAdvance) nextToken();
                return true;
            }
            if (diagnosticMessage) parseErrorAtCurrentToken(diagnosticMessage);
            else parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(kind));
            return false;
        }
        const viableKeywordSuggestions = Object.keys(textToKeywordObj).filter((keyword)=>keyword.length > 2);
        function parseErrorForMissingSemicolonAfter(node) {
            if (isTaggedTemplateExpression(node)) {
                parseErrorAt(skipTrivia(sourceText, node.template.pos), node.template.end, Diagnostics.Module_declaration_names_may_only_use_or_quoted_strings);
                return;
            }
            const expressionText = isIdentifier(node) ? idText(node) : void 0;
            if (!expressionText || !isIdentifierText(expressionText, languageVersion)) {
                parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(27 /* SemicolonToken */ ));
                return;
            }
            const pos = skipTrivia(sourceText, node.pos);
            switch(expressionText){
                case "const":
                case "let":
                case "var":
                    parseErrorAt(pos, node.end, Diagnostics.Variable_declaration_not_allowed_at_this_location);
                    return;
                case "declare":
                    return;
                case "interface":
                    parseErrorForInvalidName(Diagnostics.Interface_name_cannot_be_0, Diagnostics.Interface_must_be_given_a_name, 19 /* OpenBraceToken */ );
                    return;
                case "is":
                    parseErrorAt(pos, scanner2.getTokenStart(), Diagnostics.A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods);
                    return;
                case "module":
                case "namespace":
                    parseErrorForInvalidName(Diagnostics.Namespace_name_cannot_be_0, Diagnostics.Namespace_must_be_given_a_name, 19 /* OpenBraceToken */ );
                    return;
                case "type":
                    parseErrorForInvalidName(Diagnostics.Type_alias_name_cannot_be_0, Diagnostics.Type_alias_must_be_given_a_name, 64 /* EqualsToken */ );
                    return;
            }
            var _getSpellingSuggestion;
            const suggestion = (_getSpellingSuggestion = getSpellingSuggestion(expressionText, viableKeywordSuggestions, identity)) !== null && _getSpellingSuggestion !== void 0 ? _getSpellingSuggestion : getSpaceSuggestion(expressionText);
            if (suggestion) {
                parseErrorAt(pos, node.end, Diagnostics.Unknown_keyword_or_identifier_Did_you_mean_0, suggestion);
                return;
            }
            if (token() === 0 /* Unknown */ ) return;
            parseErrorAt(pos, node.end, Diagnostics.Unexpected_keyword_or_identifier);
        }
        function parseErrorForInvalidName(nameDiagnostic, blankDiagnostic, tokenIfBlankName) {
            if (token() === tokenIfBlankName) parseErrorAtCurrentToken(blankDiagnostic);
            else parseErrorAtCurrentToken(nameDiagnostic, scanner2.getTokenValue());
        }
        function getSpaceSuggestion(expressionText) {
            for (const keyword of viableKeywordSuggestions){
                if (expressionText.length > keyword.length + 2 && startsWith(expressionText, keyword)) return `${keyword} ${expressionText.slice(keyword.length)}`;
            }
            return void 0;
        }
        function parseSemicolonAfterPropertyName(name, type, initializer) {
            if (token() === 60 /* AtToken */  && !scanner2.hasPrecedingLineBreak()) {
                parseErrorAtCurrentToken(Diagnostics.Decorators_must_precede_the_name_and_all_keywords_of_property_declarations);
                return;
            }
            if (token() === 21 /* OpenParenToken */ ) {
                parseErrorAtCurrentToken(Diagnostics.Cannot_start_a_function_call_in_a_type_annotation);
                nextToken();
                return;
            }
            if (type && !canParseSemicolon()) {
                if (initializer) parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(27 /* SemicolonToken */ ));
                else parseErrorAtCurrentToken(Diagnostics.Expected_for_property_initializer);
                return;
            }
            if (tryParseSemicolon()) return;
            if (initializer) {
                parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(27 /* SemicolonToken */ ));
                return;
            }
            parseErrorForMissingSemicolonAfter(name);
        }
        function parseExpectedJSDoc(kind) {
            if (token() === kind) {
                nextTokenJSDoc();
                return true;
            }
            Debug.assert(isKeywordOrPunctuation(kind));
            parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(kind));
            return false;
        }
        function parseExpectedMatchingBrackets(openKind, closeKind, openParsed, openPosition) {
            if (token() === closeKind) {
                nextToken();
                return;
            }
            const lastError = parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(closeKind));
            if (!openParsed) return;
            if (lastError) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, sourceText, openPosition, 1, Diagnostics.The_parser_expected_to_find_a_1_to_match_the_0_token_here, tokenToString(openKind), tokenToString(closeKind)));
        }
        function parseOptional(t) {
            if (token() === t) {
                nextToken();
                return true;
            }
            return false;
        }
        function parseOptionalToken(t) {
            if (token() === t) return parseTokenNode();
            return void 0;
        }
        function parseOptionalTokenJSDoc(t) {
            if (token() === t) return parseTokenNodeJSDoc();
            return void 0;
        }
        function parseExpectedToken(t, diagnosticMessage, arg0) {
            return parseOptionalToken(t) || createMissingNode(t, /*reportAtCurrentPosition*/ false, diagnosticMessage || Diagnostics._0_expected, arg0 || tokenToString(t));
        }
        function parseExpectedTokenJSDoc(t) {
            const optional = parseOptionalTokenJSDoc(t);
            if (optional) return optional;
            Debug.assert(isKeywordOrPunctuation(t));
            return createMissingNode(t, /*reportAtCurrentPosition*/ false, Diagnostics._0_expected, tokenToString(t));
        }
        function parseTokenNode() {
            const pos = getNodePos();
            const kind = token();
            nextToken();
            return finishNode(factoryCreateToken(kind), pos);
        }
        function parseTokenNodeJSDoc() {
            const pos = getNodePos();
            const kind = token();
            nextTokenJSDoc();
            return finishNode(factoryCreateToken(kind), pos);
        }
        function canParseSemicolon() {
            if (token() === 27 /* SemicolonToken */ ) return true;
            return token() === 20 /* CloseBraceToken */  || token() === 1 /* EndOfFileToken */  || scanner2.hasPrecedingLineBreak();
        }
        function tryParseSemicolon() {
            if (!canParseSemicolon()) return false;
            if (token() === 27 /* SemicolonToken */ ) nextToken();
            return true;
        }
        function parseSemicolon() {
            return tryParseSemicolon() || parseExpected(27 /* SemicolonToken */ );
        }
        function createNodeArray(elements, pos, end, hasTrailingComma) {
            const array = factoryCreateNodeArray(elements, hasTrailingComma);
            setTextRangePosEnd(array, pos, end !== null && end !== void 0 ? end : scanner2.getTokenFullStart());
            return array;
        }
        function finishNode(node, pos, end) {
            setTextRangePosEnd(node, pos, end !== null && end !== void 0 ? end : scanner2.getTokenFullStart());
            if (contextFlags) node.flags |= contextFlags;
            if (parseErrorBeforeNextFinishedNode) {
                parseErrorBeforeNextFinishedNode = false;
                node.flags |= 262144 /* ThisNodeHasError */ ;
            }
            return node;
        }
        function createMissingNode(kind, reportAtCurrentPosition, diagnosticMessage, ...args) {
            if (reportAtCurrentPosition) parseErrorAtPosition(scanner2.getTokenFullStart(), 0, diagnosticMessage, ...args);
            else if (diagnosticMessage) parseErrorAtCurrentToken(diagnosticMessage, ...args);
            const pos = getNodePos();
            const result = kind === 80 /* Identifier */  ? factoryCreateIdentifier("", /*originalKeywordKind*/ void 0) : isTemplateLiteralKind(kind) ? factory2.createTemplateLiteralLikeNode(kind, "", "", /*templateFlags*/ void 0) : kind === 9 /* NumericLiteral */  ? factoryCreateNumericLiteral("", /*numericLiteralFlags*/ void 0) : kind === 11 /* StringLiteral */  ? factoryCreateStringLiteral("", /*isSingleQuote*/ void 0) : kind === 283 /* MissingDeclaration */  ? factory2.createMissingDeclaration() : factoryCreateToken(kind);
            return finishNode(result, pos);
        }
        function internIdentifier(text) {
            let identifier = identifiers.get(text);
            if (identifier === void 0) identifiers.set(text, identifier = text);
            return identifier;
        }
        function createIdentifier(isIdentifier3, diagnosticMessage, privateIdentifierDiagnosticMessage) {
            if (isIdentifier3) {
                identifierCount++;
                const pos = scanner2.hasPrecedingJSDocLeadingAsterisks() ? scanner2.getTokenStart() : getNodePos();
                const originalKeywordKind = token();
                const text = internIdentifier(scanner2.getTokenValue());
                const hasExtendedUnicodeEscape = scanner2.hasExtendedUnicodeEscape();
                nextTokenWithoutCheck();
                return finishNode(factoryCreateIdentifier(text, originalKeywordKind, hasExtendedUnicodeEscape), pos);
            }
            if (token() === 81 /* PrivateIdentifier */ ) {
                parseErrorAtCurrentToken(privateIdentifierDiagnosticMessage || Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
                return createIdentifier(/*isIdentifier*/ true);
            }
            if (token() === 0 /* Unknown */  && scanner2.tryScan(()=>scanner2.reScanInvalidIdentifier() === 80 /* Identifier */ )) return createIdentifier(/*isIdentifier*/ true);
            identifierCount++;
            const reportAtCurrentPosition = token() === 1 /* EndOfFileToken */ ;
            const isReservedWord = scanner2.isReservedWord();
            const msgArg = scanner2.getTokenText();
            const defaultMessage = isReservedWord ? Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here : Diagnostics.Identifier_expected;
            return createMissingNode(80 /* Identifier */ , reportAtCurrentPosition, diagnosticMessage || defaultMessage, msgArg);
        }
        function parseBindingIdentifier(privateIdentifierDiagnosticMessage) {
            return createIdentifier(isBindingIdentifier(), /*diagnosticMessage*/ void 0, privateIdentifierDiagnosticMessage);
        }
        function parseIdentifier(diagnosticMessage, privateIdentifierDiagnosticMessage) {
            return createIdentifier(isIdentifier2(), diagnosticMessage, privateIdentifierDiagnosticMessage);
        }
        function parseIdentifierName(diagnosticMessage) {
            return createIdentifier(tokenIsIdentifierOrKeyword(token()), diagnosticMessage);
        }
        function parseIdentifierNameErrorOnUnicodeEscapeSequence() {
            if (scanner2.hasUnicodeEscape() || scanner2.hasExtendedUnicodeEscape()) parseErrorAtCurrentToken(Diagnostics.Unicode_escape_sequence_cannot_appear_here);
            return createIdentifier(tokenIsIdentifierOrKeyword(token()));
        }
        function isLiteralPropertyName() {
            return tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */  || token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */ ;
        }
        function isImportAttributeName2() {
            return tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */ ;
        }
        function parsePropertyNameWorker(allowComputedPropertyNames) {
            if (token() === 11 /* StringLiteral */  || token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */ ) {
                const node = parseLiteralNode();
                node.text = internIdentifier(node.text);
                return node;
            }
            if (allowComputedPropertyNames && token() === 23 /* OpenBracketToken */ ) return parseComputedPropertyName();
            if (token() === 81 /* PrivateIdentifier */ ) return parsePrivateIdentifier();
            return parseIdentifierName();
        }
        function parsePropertyName() {
            return parsePropertyNameWorker(/*allowComputedPropertyNames*/ true);
        }
        function parseComputedPropertyName() {
            const pos = getNodePos();
            parseExpected(23 /* OpenBracketToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpected(24 /* CloseBracketToken */ );
            return finishNode(factory2.createComputedPropertyName(expression), pos);
        }
        function parsePrivateIdentifier() {
            const pos = getNodePos();
            const node = factoryCreatePrivateIdentifier(internIdentifier(scanner2.getTokenValue()));
            nextToken();
            return finishNode(node, pos);
        }
        function parseContextualModifier(t) {
            return token() === t && tryParse(nextTokenCanFollowModifier);
        }
        function nextTokenIsOnSameLineAndCanFollowModifier() {
            nextToken();
            if (scanner2.hasPrecedingLineBreak()) return false;
            return canFollowModifier();
        }
        function nextTokenCanFollowModifier() {
            switch(token()){
                case 87 /* ConstKeyword */ :
                    return nextToken() === 94 /* EnumKeyword */ ;
                case 95 /* ExportKeyword */ :
                    nextToken();
                    if (token() === 90 /* DefaultKeyword */ ) return lookAhead(nextTokenCanFollowDefaultKeyword);
                    if (token() === 156 /* TypeKeyword */ ) return lookAhead(nextTokenCanFollowExportModifier);
                    return canFollowExportModifier();
                case 90 /* DefaultKeyword */ :
                    return nextTokenCanFollowDefaultKeyword();
                case 126 /* StaticKeyword */ :
                    nextToken();
                    return canFollowModifier();
                case 139 /* GetKeyword */ :
                case 153 /* SetKeyword */ :
                    nextToken();
                    return canFollowGetOrSetKeyword();
                default:
                    return nextTokenIsOnSameLineAndCanFollowModifier();
            }
        }
        function canFollowExportModifier() {
            return token() === 60 /* AtToken */  || token() !== 42 /* AsteriskToken */  && token() !== 130 /* AsKeyword */  && token() !== 19 /* OpenBraceToken */  && canFollowModifier();
        }
        function nextTokenCanFollowExportModifier() {
            nextToken();
            return canFollowExportModifier();
        }
        function parseAnyContextualModifier() {
            return isModifierKind(token()) && tryParse(nextTokenCanFollowModifier);
        }
        function canFollowModifier() {
            return token() === 23 /* OpenBracketToken */  || token() === 19 /* OpenBraceToken */  || token() === 42 /* AsteriskToken */  || token() === 26 /* DotDotDotToken */  || isLiteralPropertyName();
        }
        function canFollowGetOrSetKeyword() {
            return token() === 23 /* OpenBracketToken */  || isLiteralPropertyName();
        }
        function nextTokenCanFollowDefaultKeyword() {
            nextToken();
            return token() === 86 /* ClassKeyword */  || token() === 100 /* FunctionKeyword */  || token() === 120 /* InterfaceKeyword */  || token() === 60 /* AtToken */  || token() === 128 /* AbstractKeyword */  && lookAhead(nextTokenIsClassKeywordOnSameLine) || token() === 134 /* AsyncKeyword */  && lookAhead(nextTokenIsFunctionKeywordOnSameLine);
        }
        function isListElement2(parsingContext2, inErrorRecovery) {
            const node = currentNode(parsingContext2);
            if (node) return true;
            switch(parsingContext2){
                case 0 /* SourceElements */ :
                case 1 /* BlockStatements */ :
                case 3 /* SwitchClauseStatements */ :
                    return !(token() === 27 /* SemicolonToken */  && inErrorRecovery) && isStartOfStatement();
                case 2 /* SwitchClauses */ :
                    return token() === 84 /* CaseKeyword */  || token() === 90 /* DefaultKeyword */ ;
                case 4 /* TypeMembers */ :
                    return lookAhead(isTypeMemberStart);
                case 5 /* ClassMembers */ :
                    return lookAhead(isClassMemberStart) || token() === 27 /* SemicolonToken */  && !inErrorRecovery;
                case 6 /* EnumMembers */ :
                    return token() === 23 /* OpenBracketToken */  || isLiteralPropertyName();
                case 12 /* ObjectLiteralMembers */ :
                    switch(token()){
                        case 23 /* OpenBracketToken */ :
                        case 42 /* AsteriskToken */ :
                        case 26 /* DotDotDotToken */ :
                        case 25 /* DotToken */ :
                            return true;
                        default:
                            return isLiteralPropertyName();
                    }
                case 18 /* RestProperties */ :
                    return isLiteralPropertyName();
                case 9 /* ObjectBindingElements */ :
                    return token() === 23 /* OpenBracketToken */  || token() === 26 /* DotDotDotToken */  || isLiteralPropertyName();
                case 24 /* ImportAttributes */ :
                    return isImportAttributeName2();
                case 7 /* HeritageClauseElement */ :
                    if (token() === 19 /* OpenBraceToken */ ) return lookAhead(isValidHeritageClauseObjectLiteral);
                    if (!inErrorRecovery) return isStartOfLeftHandSideExpression() && !isHeritageClauseExtendsOrImplementsKeyword();
                    else return isIdentifier2() && !isHeritageClauseExtendsOrImplementsKeyword();
                case 8 /* VariableDeclarations */ :
                    return isBindingIdentifierOrPrivateIdentifierOrPattern();
                case 10 /* ArrayBindingElements */ :
                    return token() === 28 /* CommaToken */  || token() === 26 /* DotDotDotToken */  || isBindingIdentifierOrPrivateIdentifierOrPattern();
                case 19 /* TypeParameters */ :
                    return token() === 103 /* InKeyword */  || token() === 87 /* ConstKeyword */  || isIdentifier2();
                case 15 /* ArrayLiteralMembers */ :
                    switch(token()){
                        case 28 /* CommaToken */ :
                        case 25 /* DotToken */ :
                            return true;
                    }
                // falls through
                case 11 /* ArgumentExpressions */ :
                    return token() === 26 /* DotDotDotToken */  || isStartOfExpression();
                case 16 /* Parameters */ :
                    return isStartOfParameter(/*isJSDocParameter*/ false);
                case 17 /* JSDocParameters */ :
                    return isStartOfParameter(/*isJSDocParameter*/ true);
                case 20 /* TypeArguments */ :
                case 21 /* TupleElementTypes */ :
                    return token() === 28 /* CommaToken */  || isStartOfType();
                case 22 /* HeritageClauses */ :
                    return isHeritageClause2();
                case 23 /* ImportOrExportSpecifiers */ :
                    if (token() === 161 /* FromKeyword */  && lookAhead(nextTokenIsStringLiteral)) return false;
                    if (token() === 11 /* StringLiteral */ ) return true;
                    return tokenIsIdentifierOrKeyword(token());
                case 13 /* JsxAttributes */ :
                    return tokenIsIdentifierOrKeyword(token()) || token() === 19 /* OpenBraceToken */ ;
                case 14 /* JsxChildren */ :
                    return true;
                case 25 /* JSDocComment */ :
                    return true;
                case 26 /* Count */ :
                    return Debug.fail("ParsingContext.Count used as a context");
                // Not a real context, only a marker.
                default:
                    Debug.assertNever(parsingContext2, "Non-exhaustive case in 'isListElement'.");
            }
        }
        function isValidHeritageClauseObjectLiteral() {
            Debug.assert(token() === 19 /* OpenBraceToken */ );
            if (nextToken() === 20 /* CloseBraceToken */ ) {
                const next = nextToken();
                return next === 28 /* CommaToken */  || next === 19 /* OpenBraceToken */  || next === 96 /* ExtendsKeyword */  || next === 119 /* ImplementsKeyword */ ;
            }
            return true;
        }
        function nextTokenIsIdentifier() {
            nextToken();
            return isIdentifier2();
        }
        function nextTokenIsIdentifierOrKeyword() {
            nextToken();
            return tokenIsIdentifierOrKeyword(token());
        }
        function nextTokenIsIdentifierOrKeywordOrGreaterThan() {
            nextToken();
            return tokenIsIdentifierOrKeywordOrGreaterThan(token());
        }
        function isHeritageClauseExtendsOrImplementsKeyword() {
            if (token() === 119 /* ImplementsKeyword */  || token() === 96 /* ExtendsKeyword */ ) return lookAhead(nextTokenIsStartOfExpression);
            return false;
        }
        function nextTokenIsStartOfExpression() {
            nextToken();
            return isStartOfExpression();
        }
        function nextTokenIsStartOfType() {
            nextToken();
            return isStartOfType();
        }
        function isListTerminator(kind) {
            if (token() === 1 /* EndOfFileToken */ ) return true;
            switch(kind){
                case 1 /* BlockStatements */ :
                case 2 /* SwitchClauses */ :
                case 4 /* TypeMembers */ :
                case 5 /* ClassMembers */ :
                case 6 /* EnumMembers */ :
                case 12 /* ObjectLiteralMembers */ :
                case 9 /* ObjectBindingElements */ :
                case 23 /* ImportOrExportSpecifiers */ :
                case 24 /* ImportAttributes */ :
                    return token() === 20 /* CloseBraceToken */ ;
                case 3 /* SwitchClauseStatements */ :
                    return token() === 20 /* CloseBraceToken */  || token() === 84 /* CaseKeyword */  || token() === 90 /* DefaultKeyword */ ;
                case 7 /* HeritageClauseElement */ :
                    return token() === 19 /* OpenBraceToken */  || token() === 96 /* ExtendsKeyword */  || token() === 119 /* ImplementsKeyword */ ;
                case 8 /* VariableDeclarations */ :
                    return isVariableDeclaratorListTerminator();
                case 19 /* TypeParameters */ :
                    return token() === 32 /* GreaterThanToken */  || token() === 21 /* OpenParenToken */  || token() === 19 /* OpenBraceToken */  || token() === 96 /* ExtendsKeyword */  || token() === 119 /* ImplementsKeyword */ ;
                case 11 /* ArgumentExpressions */ :
                    return token() === 22 /* CloseParenToken */  || token() === 27 /* SemicolonToken */ ;
                case 15 /* ArrayLiteralMembers */ :
                case 21 /* TupleElementTypes */ :
                case 10 /* ArrayBindingElements */ :
                    return token() === 24 /* CloseBracketToken */ ;
                case 17 /* JSDocParameters */ :
                case 16 /* Parameters */ :
                case 18 /* RestProperties */ :
                    return token() === 22 /* CloseParenToken */  || token() === 24 /* CloseBracketToken */ ;
                case 20 /* TypeArguments */ :
                    return token() !== 28 /* CommaToken */ ;
                case 22 /* HeritageClauses */ :
                    return token() === 19 /* OpenBraceToken */  || token() === 20 /* CloseBraceToken */ ;
                case 13 /* JsxAttributes */ :
                    return token() === 32 /* GreaterThanToken */  || token() === 44 /* SlashToken */ ;
                case 14 /* JsxChildren */ :
                    return token() === 30 /* LessThanToken */  && lookAhead(nextTokenIsSlash);
                default:
                    return false;
            }
        }
        function isVariableDeclaratorListTerminator() {
            if (canParseSemicolon()) return true;
            if (isInOrOfKeyword(token())) return true;
            if (token() === 39 /* EqualsGreaterThanToken */ ) return true;
            return false;
        }
        function isInSomeParsingContext() {
            Debug.assert(parsingContext, "Missing parsing context");
            for(let kind = 0; kind < 26 /* Count */ ; kind++)if (parsingContext & 1 << kind) {
                if (isListElement2(kind, /*inErrorRecovery*/ true) || isListTerminator(kind)) return true;
            }
            return false;
        }
        function parseList(kind, parseElement) {
            const saveParsingContext = parsingContext;
            parsingContext |= 1 << kind;
            const list = [];
            const listPos = getNodePos();
            while(!isListTerminator(kind)){
                if (isListElement2(kind, /*inErrorRecovery*/ false)) {
                    list.push(parseListElement(kind, parseElement));
                    continue;
                }
                if (abortParsingListOrMoveToNextToken(kind)) break;
            }
            parsingContext = saveParsingContext;
            return createNodeArray(list, listPos);
        }
        function parseListElement(parsingContext2, parseElement) {
            const node = currentNode(parsingContext2);
            if (node) return consumeNode(node);
            return parseElement();
        }
        function currentNode(parsingContext2, pos) {
            var _a;
            if (!syntaxCursor || !isReusableParsingContext(parsingContext2) || parseErrorBeforeNextFinishedNode) return void 0;
            const node = syntaxCursor.currentNode(pos !== null && pos !== void 0 ? pos : scanner2.getTokenFullStart());
            if (nodeIsMissing(node) || intersectsIncrementalChange(node) || containsParseError(node)) return void 0;
            const nodeContextFlags = node.flags & 101441536 /* ContextFlags */ ;
            if (nodeContextFlags !== contextFlags) return void 0;
            if (!canReuseNode(node, parsingContext2)) return void 0;
            if (canHaveJSDoc(node) && ((_a = node.jsDoc) == null ? void 0 : _a.jsDocCache)) node.jsDoc.jsDocCache = void 0;
            return node;
        }
        function consumeNode(node) {
            scanner2.resetTokenState(node.end);
            nextToken();
            return node;
        }
        function isReusableParsingContext(parsingContext2) {
            switch(parsingContext2){
                case 5 /* ClassMembers */ :
                case 2 /* SwitchClauses */ :
                case 0 /* SourceElements */ :
                case 1 /* BlockStatements */ :
                case 3 /* SwitchClauseStatements */ :
                case 6 /* EnumMembers */ :
                case 4 /* TypeMembers */ :
                case 8 /* VariableDeclarations */ :
                case 17 /* JSDocParameters */ :
                case 16 /* Parameters */ :
                    return true;
            }
            return false;
        }
        function canReuseNode(node, parsingContext2) {
            switch(parsingContext2){
                case 5 /* ClassMembers */ :
                    return isReusableClassMember(node);
                case 2 /* SwitchClauses */ :
                    return isReusableSwitchClause(node);
                case 0 /* SourceElements */ :
                case 1 /* BlockStatements */ :
                case 3 /* SwitchClauseStatements */ :
                    return isReusableStatement(node);
                case 6 /* EnumMembers */ :
                    return isReusableEnumMember(node);
                case 4 /* TypeMembers */ :
                    return isReusableTypeMember(node);
                case 8 /* VariableDeclarations */ :
                    return isReusableVariableDeclaration(node);
                case 17 /* JSDocParameters */ :
                case 16 /* Parameters */ :
                    return isReusableParameter(node);
            }
            return false;
        }
        function isReusableClassMember(node) {
            if (node) switch(node.kind){
                case 177 /* Constructor */ :
                case 182 /* IndexSignature */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 173 /* PropertyDeclaration */ :
                case 241 /* SemicolonClassElement */ :
                    return true;
                case 175 /* MethodDeclaration */ :
                    const methodDeclaration = node;
                    const nameIsConstructor = methodDeclaration.name.kind === 80 /* Identifier */  && methodDeclaration.name.escapedText === "constructor";
                    return !nameIsConstructor;
            }
            return false;
        }
        function isReusableSwitchClause(node) {
            if (node) switch(node.kind){
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                    return true;
            }
            return false;
        }
        function isReusableStatement(node) {
            if (node) switch(node.kind){
                case 263 /* FunctionDeclaration */ :
                case 244 /* VariableStatement */ :
                case 242 /* Block */ :
                case 246 /* IfStatement */ :
                case 245 /* ExpressionStatement */ :
                case 258 /* ThrowStatement */ :
                case 254 /* ReturnStatement */ :
                case 256 /* SwitchStatement */ :
                case 253 /* BreakStatement */ :
                case 252 /* ContinueStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                case 249 /* ForStatement */ :
                case 248 /* WhileStatement */ :
                case 255 /* WithStatement */ :
                case 243 /* EmptyStatement */ :
                case 259 /* TryStatement */ :
                case 257 /* LabeledStatement */ :
                case 247 /* DoStatement */ :
                case 260 /* DebuggerStatement */ :
                case 273 /* ImportDeclaration */ :
                case 272 /* ImportEqualsDeclaration */ :
                case 279 /* ExportDeclaration */ :
                case 278 /* ExportAssignment */ :
                case 268 /* ModuleDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 267 /* EnumDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                    return true;
            }
            return false;
        }
        function isReusableEnumMember(node) {
            return node.kind === 307 /* EnumMember */ ;
        }
        function isReusableTypeMember(node) {
            if (node) switch(node.kind){
                case 181 /* ConstructSignature */ :
                case 174 /* MethodSignature */ :
                case 182 /* IndexSignature */ :
                case 172 /* PropertySignature */ :
                case 180 /* CallSignature */ :
                    return true;
            }
            return false;
        }
        function isReusableVariableDeclaration(node) {
            if (node.kind !== 261 /* VariableDeclaration */ ) return false;
            const variableDeclarator = node;
            return variableDeclarator.initializer === void 0;
        }
        function isReusableParameter(node) {
            if (node.kind !== 170 /* Parameter */ ) return false;
            const parameter = node;
            return parameter.initializer === void 0;
        }
        function abortParsingListOrMoveToNextToken(kind) {
            parsingContextErrors(kind);
            if (isInSomeParsingContext()) return true;
            nextToken();
            return false;
        }
        function parsingContextErrors(context) {
            switch(context){
                case 0 /* SourceElements */ :
                    return token() === 90 /* DefaultKeyword */  ? parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(95 /* ExportKeyword */ )) : parseErrorAtCurrentToken(Diagnostics.Declaration_or_statement_expected);
                case 1 /* BlockStatements */ :
                    return parseErrorAtCurrentToken(Diagnostics.Declaration_or_statement_expected);
                case 2 /* SwitchClauses */ :
                    return parseErrorAtCurrentToken(Diagnostics.case_or_default_expected);
                case 3 /* SwitchClauseStatements */ :
                    return parseErrorAtCurrentToken(Diagnostics.Statement_expected);
                case 18 /* RestProperties */ :
                // fallthrough
                case 4 /* TypeMembers */ :
                    return parseErrorAtCurrentToken(Diagnostics.Property_or_signature_expected);
                case 5 /* ClassMembers */ :
                    return parseErrorAtCurrentToken(Diagnostics.Unexpected_token_A_constructor_method_accessor_or_property_was_expected);
                case 6 /* EnumMembers */ :
                    return parseErrorAtCurrentToken(Diagnostics.Enum_member_expected);
                case 7 /* HeritageClauseElement */ :
                    return parseErrorAtCurrentToken(Diagnostics.Expression_expected);
                case 8 /* VariableDeclarations */ :
                    return isKeyword(token()) ? parseErrorAtCurrentToken(Diagnostics._0_is_not_allowed_as_a_variable_declaration_name, tokenToString(token())) : parseErrorAtCurrentToken(Diagnostics.Variable_declaration_expected);
                case 9 /* ObjectBindingElements */ :
                    return parseErrorAtCurrentToken(Diagnostics.Property_destructuring_pattern_expected);
                case 10 /* ArrayBindingElements */ :
                    return parseErrorAtCurrentToken(Diagnostics.Array_element_destructuring_pattern_expected);
                case 11 /* ArgumentExpressions */ :
                    return parseErrorAtCurrentToken(Diagnostics.Argument_expression_expected);
                case 12 /* ObjectLiteralMembers */ :
                    return parseErrorAtCurrentToken(Diagnostics.Property_assignment_expected);
                case 15 /* ArrayLiteralMembers */ :
                    return parseErrorAtCurrentToken(Diagnostics.Expression_or_comma_expected);
                case 17 /* JSDocParameters */ :
                    return parseErrorAtCurrentToken(Diagnostics.Parameter_declaration_expected);
                case 16 /* Parameters */ :
                    return isKeyword(token()) ? parseErrorAtCurrentToken(Diagnostics._0_is_not_allowed_as_a_parameter_name, tokenToString(token())) : parseErrorAtCurrentToken(Diagnostics.Parameter_declaration_expected);
                case 19 /* TypeParameters */ :
                    return parseErrorAtCurrentToken(Diagnostics.Type_parameter_declaration_expected);
                case 20 /* TypeArguments */ :
                    return parseErrorAtCurrentToken(Diagnostics.Type_argument_expected);
                case 21 /* TupleElementTypes */ :
                    return parseErrorAtCurrentToken(Diagnostics.Type_expected);
                case 22 /* HeritageClauses */ :
                    return parseErrorAtCurrentToken(Diagnostics.Unexpected_token_expected);
                case 23 /* ImportOrExportSpecifiers */ :
                    if (token() === 161 /* FromKeyword */ ) return parseErrorAtCurrentToken(Diagnostics._0_expected, "}");
                    return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                case 13 /* JsxAttributes */ :
                    return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                case 14 /* JsxChildren */ :
                    return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                case 24 /* ImportAttributes */ :
                    return parseErrorAtCurrentToken(Diagnostics.Identifier_or_string_literal_expected);
                case 25 /* JSDocComment */ :
                    return parseErrorAtCurrentToken(Diagnostics.Identifier_expected);
                case 26 /* Count */ :
                    return Debug.fail("ParsingContext.Count used as a context");
                // Not a real context, only a marker.
                default:
                    Debug.assertNever(context);
            }
        }
        function parseDelimitedList(kind, parseElement, considerSemicolonAsDelimiter) {
            const saveParsingContext = parsingContext;
            parsingContext |= 1 << kind;
            const list = [];
            const listPos = getNodePos();
            let commaStart = -1;
            while(true){
                if (isListElement2(kind, /*inErrorRecovery*/ false)) {
                    const startPos = scanner2.getTokenFullStart();
                    const result = parseListElement(kind, parseElement);
                    if (!result) {
                        parsingContext = saveParsingContext;
                        return void 0;
                    }
                    list.push(result);
                    commaStart = scanner2.getTokenStart();
                    if (parseOptional(28 /* CommaToken */ )) continue;
                    commaStart = -1;
                    if (isListTerminator(kind)) break;
                    parseExpected(28 /* CommaToken */ , getExpectedCommaDiagnostic(kind));
                    if (considerSemicolonAsDelimiter && token() === 27 /* SemicolonToken */  && !scanner2.hasPrecedingLineBreak()) nextToken();
                    if (startPos === scanner2.getTokenFullStart()) nextToken();
                    continue;
                }
                if (isListTerminator(kind)) break;
                if (abortParsingListOrMoveToNextToken(kind)) break;
            }
            parsingContext = saveParsingContext;
            return createNodeArray(list, listPos, /*end*/ void 0, commaStart >= 0);
        }
        function getExpectedCommaDiagnostic(kind) {
            return kind === 6 /* EnumMembers */  ? Diagnostics.An_enum_member_name_must_be_followed_by_a_or : void 0;
        }
        function createMissingList() {
            const list = createNodeArray([], getNodePos());
            list.isMissingList = true;
            return list;
        }
        function isMissingList(arr) {
            return !!arr.isMissingList;
        }
        function parseBracketedList(kind, parseElement, open, close) {
            if (parseExpected(open)) {
                const result = parseDelimitedList(kind, parseElement);
                parseExpected(close);
                return result;
            }
            return createMissingList();
        }
        function parseEntityName(allowReservedWords, diagnosticMessage) {
            const pos = getNodePos();
            let entity = allowReservedWords ? parseIdentifierName(diagnosticMessage) : parseIdentifier(diagnosticMessage);
            while(parseOptional(25 /* DotToken */ )){
                if (token() === 30 /* LessThanToken */ ) break;
                entity = finishNode(factory2.createQualifiedName(entity, parseRightSideOfDot(allowReservedWords, /*allowPrivateIdentifiers*/ false, /*allowUnicodeEscapeSequenceInIdentifierName*/ true)), pos);
            }
            return entity;
        }
        function createQualifiedName(entity, name) {
            return finishNode(factory2.createQualifiedName(entity, name), entity.pos);
        }
        function parseRightSideOfDot(allowIdentifierNames, allowPrivateIdentifiers, allowUnicodeEscapeSequenceInIdentifierName) {
            if (scanner2.hasPrecedingLineBreak() && tokenIsIdentifierOrKeyword(token())) {
                const matchesPattern = lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
                if (matchesPattern) return createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.Identifier_expected);
            }
            if (token() === 81 /* PrivateIdentifier */ ) {
                const node = parsePrivateIdentifier();
                return allowPrivateIdentifiers ? node : createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.Identifier_expected);
            }
            if (allowIdentifierNames) return allowUnicodeEscapeSequenceInIdentifierName ? parseIdentifierName() : parseIdentifierNameErrorOnUnicodeEscapeSequence();
            return parseIdentifier();
        }
        function parseTemplateSpans(isTaggedTemplate) {
            const pos = getNodePos();
            const list = [];
            let node;
            do {
                node = parseTemplateSpan(isTaggedTemplate);
                list.push(node);
            }while (node.literal.kind === 17 /* TemplateMiddle */ );
            return createNodeArray(list, pos);
        }
        function parseTemplateExpression(isTaggedTemplate) {
            const pos = getNodePos();
            return finishNode(factory2.createTemplateExpression(parseTemplateHead(isTaggedTemplate), parseTemplateSpans(isTaggedTemplate)), pos);
        }
        function parseTemplateType() {
            const pos = getNodePos();
            return finishNode(factory2.createTemplateLiteralType(parseTemplateHead(/*isTaggedTemplate*/ false), parseTemplateTypeSpans()), pos);
        }
        function parseTemplateTypeSpans() {
            const pos = getNodePos();
            const list = [];
            let node;
            do {
                node = parseTemplateTypeSpan();
                list.push(node);
            }while (node.literal.kind === 17 /* TemplateMiddle */ );
            return createNodeArray(list, pos);
        }
        function parseTemplateTypeSpan() {
            const pos = getNodePos();
            return finishNode(factory2.createTemplateLiteralTypeSpan(parseType(), parseLiteralOfTemplateSpan(/*isTaggedTemplate*/ false)), pos);
        }
        function parseLiteralOfTemplateSpan(isTaggedTemplate) {
            if (token() === 20 /* CloseBraceToken */ ) {
                reScanTemplateToken(isTaggedTemplate);
                return parseTemplateMiddleOrTemplateTail();
            } else return parseExpectedToken(18 /* TemplateTail */ , Diagnostics._0_expected, tokenToString(20 /* CloseBraceToken */ ));
        }
        function parseTemplateSpan(isTaggedTemplate) {
            const pos = getNodePos();
            return finishNode(factory2.createTemplateSpan(allowInAnd(parseExpression), parseLiteralOfTemplateSpan(isTaggedTemplate)), pos);
        }
        function parseLiteralNode() {
            return parseLiteralLikeNode(token());
        }
        function parseTemplateHead(isTaggedTemplate) {
            if (!isTaggedTemplate && scanner2.getTokenFlags() & 26656 /* IsInvalid */ ) reScanTemplateToken(/*isTaggedTemplate*/ false);
            const fragment = parseLiteralLikeNode(token());
            Debug.assert(fragment.kind === 16 /* TemplateHead */ , "Template head has wrong token kind");
            return fragment;
        }
        function parseTemplateMiddleOrTemplateTail() {
            const fragment = parseLiteralLikeNode(token());
            Debug.assert(fragment.kind === 17 /* TemplateMiddle */  || fragment.kind === 18 /* TemplateTail */ , "Template fragment has wrong token kind");
            return fragment;
        }
        function getTemplateLiteralRawText(kind) {
            const isLast = kind === 15 /* NoSubstitutionTemplateLiteral */  || kind === 18 /* TemplateTail */ ;
            const tokenText = scanner2.getTokenText();
            return tokenText.substring(1, tokenText.length - (scanner2.isUnterminated() ? 0 : isLast ? 1 : 2));
        }
        function parseLiteralLikeNode(kind) {
            const pos = getNodePos();
            const node = isTemplateLiteralKind(kind) ? factory2.createTemplateLiteralLikeNode(kind, scanner2.getTokenValue(), getTemplateLiteralRawText(kind), scanner2.getTokenFlags() & 7176 /* TemplateLiteralLikeFlags */ ) : // Note that theoretically the following condition would hold true literals like 009,
            // which is not octal. But because of how the scanner separates the tokens, we would
            // never get a token like this. Instead, we would get 00 and 9 as two separate tokens.
            // We also do not need to check for negatives because any prefix operator would be part of a
            // parent unary expression.
            kind === 9 /* NumericLiteral */  ? factoryCreateNumericLiteral(scanner2.getTokenValue(), scanner2.getNumericLiteralFlags()) : kind === 11 /* StringLiteral */  ? factoryCreateStringLiteral(scanner2.getTokenValue(), /*isSingleQuote*/ void 0, scanner2.hasExtendedUnicodeEscape()) : isLiteralKind(kind) ? factoryCreateLiteralLikeNode(kind, scanner2.getTokenValue()) : Debug.fail();
            if (scanner2.hasExtendedUnicodeEscape()) node.hasExtendedUnicodeEscape = true;
            if (scanner2.isUnterminated()) node.isUnterminated = true;
            nextToken();
            return finishNode(node, pos);
        }
        function parseEntityNameOfTypeReference() {
            return parseEntityName(/*allowReservedWords*/ true, Diagnostics.Type_expected);
        }
        function parseTypeArgumentsOfTypeReference() {
            if (!scanner2.hasPrecedingLineBreak() && reScanLessThanToken() === 30 /* LessThanToken */ ) return parseBracketedList(20 /* TypeArguments */ , parseType, 30 /* LessThanToken */ , 32 /* GreaterThanToken */ );
        }
        function parseTypeReference() {
            const pos = getNodePos();
            return finishNode(factory2.createTypeReferenceNode(parseEntityNameOfTypeReference(), parseTypeArgumentsOfTypeReference()), pos);
        }
        function typeHasArrowFunctionBlockingParseError(node) {
            switch(node.kind){
                case 184 /* TypeReference */ :
                    return nodeIsMissing(node.typeName);
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                    {
                        const { parameters, type } = node;
                        return isMissingList(parameters) || typeHasArrowFunctionBlockingParseError(type);
                    }
                case 197 /* ParenthesizedType */ :
                    return typeHasArrowFunctionBlockingParseError(node.type);
                default:
                    return false;
            }
        }
        function parseThisTypePredicate(lhs) {
            nextToken();
            return finishNode(factory2.createTypePredicateNode(/*assertsModifier*/ void 0, lhs, parseType()), lhs.pos);
        }
        function parseThisTypeNode() {
            const pos = getNodePos();
            nextToken();
            return finishNode(factory2.createThisTypeNode(), pos);
        }
        function parseJSDocAllType() {
            const pos = getNodePos();
            nextToken();
            return finishNode(factory2.createJSDocAllType(), pos);
        }
        function parseJSDocNonNullableType() {
            const pos = getNodePos();
            nextToken();
            return finishNode(factory2.createJSDocNonNullableType(parseNonArrayType(), /*postfix*/ false), pos);
        }
        function parseJSDocUnknownOrNullableType() {
            const pos = getNodePos();
            nextToken();
            if (token() === 28 /* CommaToken */  || token() === 20 /* CloseBraceToken */  || token() === 22 /* CloseParenToken */  || token() === 32 /* GreaterThanToken */  || token() === 64 /* EqualsToken */  || token() === 52 /* BarToken */ ) return finishNode(factory2.createJSDocUnknownType(), pos);
            else return finishNode(factory2.createJSDocNullableType(parseType(), /*postfix*/ false), pos);
        }
        function parseJSDocFunctionType() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            if (tryParse(nextTokenIsOpenParen)) {
                const parameters = parseParameters(36 /* JSDoc */ );
                const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                return withJSDoc(finishNode(factory2.createJSDocFunctionType(parameters, type), pos), hasJSDoc);
            }
            return finishNode(factory2.createTypeReferenceNode(parseIdentifierName(), /*typeArguments*/ void 0), pos);
        }
        function parseJSDocParameter() {
            const pos = getNodePos();
            let name;
            if (token() === 110 /* ThisKeyword */  || token() === 105 /* NewKeyword */ ) {
                name = parseIdentifierName();
                parseExpected(59 /* ColonToken */ );
            }
            return finishNode(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, // TODO(rbuckton): JSDoc parameters don't have names (except `this`/`new`), should we manufacture an empty identifier?
            name, /*questionToken*/ void 0, parseJSDocType(), /*initializer*/ void 0), pos);
        }
        function parseJSDocType() {
            scanner2.setSkipJsDocLeadingAsterisks(true);
            const pos = getNodePos();
            if (parseOptional(144 /* ModuleKeyword */ )) {
                const moduleTag = factory2.createJSDocNamepathType(/*type*/ void 0);
                terminate: while(true)switch(token()){
                    case 20 /* CloseBraceToken */ :
                    case 1 /* EndOfFileToken */ :
                    case 28 /* CommaToken */ :
                    case 5 /* WhitespaceTrivia */ :
                        break terminate;
                    default:
                        nextTokenJSDoc();
                }
                scanner2.setSkipJsDocLeadingAsterisks(false);
                return finishNode(moduleTag, pos);
            }
            const hasDotDotDot = parseOptional(26 /* DotDotDotToken */ );
            let type = parseTypeOrTypePredicate();
            scanner2.setSkipJsDocLeadingAsterisks(false);
            if (hasDotDotDot) type = finishNode(factory2.createJSDocVariadicType(type), pos);
            if (token() === 64 /* EqualsToken */ ) {
                nextToken();
                return finishNode(factory2.createJSDocOptionalType(type), pos);
            }
            return type;
        }
        function parseTypeQuery() {
            const pos = getNodePos();
            parseExpected(114 /* TypeOfKeyword */ );
            const entityName = parseEntityName(/*allowReservedWords*/ true);
            const typeArguments = !scanner2.hasPrecedingLineBreak() ? tryParseTypeArguments() : void 0;
            return finishNode(factory2.createTypeQueryNode(entityName, typeArguments), pos);
        }
        function parseTypeParameter() {
            const pos = getNodePos();
            const modifiers = parseModifiers(/*allowDecorators*/ false, /*permitConstAsModifier*/ true);
            const name = parseIdentifier();
            let constraint;
            let expression;
            if (parseOptional(96 /* ExtendsKeyword */ )) {
                if (isStartOfType() || !isStartOfExpression()) constraint = parseType();
                else expression = parseUnaryExpressionOrHigher();
            }
            const defaultType = parseOptional(64 /* EqualsToken */ ) ? parseType() : void 0;
            const node = factory2.createTypeParameterDeclaration(modifiers, name, constraint, defaultType);
            node.expression = expression;
            return finishNode(node, pos);
        }
        function parseTypeParameters() {
            if (token() === 30 /* LessThanToken */ ) return parseBracketedList(19 /* TypeParameters */ , parseTypeParameter, 30 /* LessThanToken */ , 32 /* GreaterThanToken */ );
        }
        function isStartOfParameter(isJSDocParameter) {
            return token() === 26 /* DotDotDotToken */  || isBindingIdentifierOrPrivateIdentifierOrPattern() || isModifierKind(token()) || token() === 60 /* AtToken */  || isStartOfType(/*inStartOfParameter*/ !isJSDocParameter);
        }
        function parseNameOfParameter(modifiers) {
            const name = parseIdentifierOrPattern(Diagnostics.Private_identifiers_cannot_be_used_as_parameters);
            if (getFullWidth(name) === 0 && !some(modifiers) && isModifierKind(token())) nextToken();
            return name;
        }
        function isParameterNameStart() {
            return isBindingIdentifier() || token() === 23 /* OpenBracketToken */  || token() === 19 /* OpenBraceToken */ ;
        }
        function parseParameter(inOuterAwaitContext) {
            return parseParameterWorker(inOuterAwaitContext);
        }
        function parseParameterForSpeculation(inOuterAwaitContext) {
            return parseParameterWorker(inOuterAwaitContext, /*allowAmbiguity*/ false);
        }
        function parseParameterWorker(inOuterAwaitContext, allowAmbiguity = true) {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = inOuterAwaitContext ? doInAwaitContext(()=>parseModifiers(/*allowDecorators*/ true)) : doOutsideOfAwaitContext(()=>parseModifiers(/*allowDecorators*/ true));
            if (token() === 110 /* ThisKeyword */ ) {
                const node2 = factory2.createParameterDeclaration(modifiers, /*dotDotDotToken*/ void 0, createIdentifier(/*isIdentifier*/ true), /*questionToken*/ void 0, parseTypeAnnotation(), /*initializer*/ void 0);
                const modifier = firstOrUndefined(modifiers);
                if (modifier) parseErrorAtRange(modifier, Diagnostics.Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters);
                return withJSDoc(finishNode(node2, pos), hasJSDoc);
            }
            const savedTopLevel = topLevel;
            topLevel = false;
            const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
            if (!allowAmbiguity && !isParameterNameStart()) return void 0;
            const node = withJSDoc(finishNode(factory2.createParameterDeclaration(modifiers, dotDotDotToken, parseNameOfParameter(modifiers), parseOptionalToken(58 /* QuestionToken */ ), parseTypeAnnotation(), parseInitializer()), pos), hasJSDoc);
            topLevel = savedTopLevel;
            return node;
        }
        function parseReturnType(returnToken, isType) {
            if (shouldParseReturnType(returnToken, isType)) return allowConditionalTypesAnd(parseTypeOrTypePredicate);
        }
        function shouldParseReturnType(returnToken, isType) {
            if (returnToken === 39 /* EqualsGreaterThanToken */ ) {
                parseExpected(returnToken);
                return true;
            } else if (parseOptional(59 /* ColonToken */ )) return true;
            else if (isType && token() === 39 /* EqualsGreaterThanToken */ ) {
                parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(59 /* ColonToken */ ));
                nextToken();
                return true;
            }
            return false;
        }
        function parseParametersWorker(flags, allowAmbiguity) {
            const savedYieldContext = inYieldContext();
            const savedAwaitContext = inAwaitContext();
            setYieldContext(!!(flags & 1 /* Yield */ ));
            setAwaitContext(!!(flags & 2 /* Await */ ));
            const parameters = flags & 32 /* JSDoc */  ? parseDelimitedList(17 /* JSDocParameters */ , parseJSDocParameter) : parseDelimitedList(16 /* Parameters */ , ()=>allowAmbiguity ? parseParameter(savedAwaitContext) : parseParameterForSpeculation(savedAwaitContext));
            setYieldContext(savedYieldContext);
            setAwaitContext(savedAwaitContext);
            return parameters;
        }
        function parseParameters(flags) {
            if (!parseExpected(21 /* OpenParenToken */ )) return createMissingList();
            const parameters = parseParametersWorker(flags, /*allowAmbiguity*/ true);
            parseExpected(22 /* CloseParenToken */ );
            return parameters;
        }
        function parseTypeMemberSemicolon() {
            if (parseOptional(28 /* CommaToken */ )) return;
            parseSemicolon();
        }
        function parseSignatureMember(kind) {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            if (kind === 181 /* ConstructSignature */ ) parseExpected(105 /* NewKeyword */ );
            const typeParameters = parseTypeParameters();
            const parameters = parseParameters(4 /* Type */ );
            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ true);
            parseTypeMemberSemicolon();
            const node = kind === 180 /* CallSignature */  ? factory2.createCallSignature(typeParameters, parameters, type) : factory2.createConstructSignature(typeParameters, parameters, type);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function isIndexSignature() {
            return token() === 23 /* OpenBracketToken */  && lookAhead(isUnambiguouslyIndexSignature);
        }
        function isUnambiguouslyIndexSignature() {
            nextToken();
            if (token() === 26 /* DotDotDotToken */  || token() === 24 /* CloseBracketToken */ ) return true;
            if (isModifierKind(token())) {
                nextToken();
                if (isIdentifier2()) return true;
            } else if (!isIdentifier2()) return false;
            else nextToken();
            if (token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */ ) return true;
            if (token() !== 58 /* QuestionToken */ ) return false;
            nextToken();
            return token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || token() === 24 /* CloseBracketToken */ ;
        }
        function parseIndexSignatureDeclaration(pos, hasJSDoc, modifiers) {
            const parameters = parseBracketedList(16 /* Parameters */ , ()=>parseParameter(/*inOuterAwaitContext*/ false), 23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ );
            const type = parseTypeAnnotation();
            parseTypeMemberSemicolon();
            const node = factory2.createIndexSignature(modifiers, parameters, type);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parsePropertyOrMethodSignature(pos, hasJSDoc, modifiers) {
            const name = parsePropertyName();
            const questionToken = parseOptionalToken(58 /* QuestionToken */ );
            let node;
            if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) {
                const typeParameters = parseTypeParameters();
                const parameters = parseParameters(4 /* Type */ );
                const type = parseReturnType(59 /* ColonToken */ , /*isType*/ true);
                node = factory2.createMethodSignature(modifiers, name, questionToken, typeParameters, parameters, type);
            } else {
                const type = parseTypeAnnotation();
                node = factory2.createPropertySignature(modifiers, name, questionToken, type);
                if (token() === 64 /* EqualsToken */ ) node.initializer = parseInitializer();
            }
            parseTypeMemberSemicolon();
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function isTypeMemberStart() {
            if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */  || token() === 139 /* GetKeyword */  || token() === 153 /* SetKeyword */ ) return true;
            let idToken = false;
            while(isModifierKind(token())){
                idToken = true;
                nextToken();
            }
            if (token() === 23 /* OpenBracketToken */ ) return true;
            if (isLiteralPropertyName()) {
                idToken = true;
                nextToken();
            }
            if (idToken) return token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */  || token() === 58 /* QuestionToken */  || token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || canParseSemicolon();
            return false;
        }
        function parseTypeMember() {
            if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) return parseSignatureMember(180 /* CallSignature */ );
            if (token() === 105 /* NewKeyword */  && lookAhead(nextTokenIsOpenParenOrLessThan)) return parseSignatureMember(181 /* ConstructSignature */ );
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = parseModifiers(/*allowDecorators*/ false);
            if (parseContextualModifier(139 /* GetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 178 /* GetAccessor */ , 4 /* Type */ );
            if (parseContextualModifier(153 /* SetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 179 /* SetAccessor */ , 4 /* Type */ );
            if (isIndexSignature()) return parseIndexSignatureDeclaration(pos, hasJSDoc, modifiers);
            return parsePropertyOrMethodSignature(pos, hasJSDoc, modifiers);
        }
        function nextTokenIsOpenParenOrLessThan() {
            nextToken();
            return token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ;
        }
        function nextTokenIsDot() {
            return nextToken() === 25 /* DotToken */ ;
        }
        function nextTokenIsOpenParenOrLessThanOrDot() {
            switch(nextToken()){
                case 21 /* OpenParenToken */ :
                case 30 /* LessThanToken */ :
                case 25 /* DotToken */ :
                    return true;
            }
            return false;
        }
        function parseTypeLiteral() {
            const pos = getNodePos();
            return finishNode(factory2.createTypeLiteralNode(parseObjectTypeMembers()), pos);
        }
        function parseObjectTypeMembers() {
            let members;
            if (parseExpected(19 /* OpenBraceToken */ )) {
                members = parseList(4 /* TypeMembers */ , parseTypeMember);
                parseExpected(20 /* CloseBraceToken */ );
            } else members = createMissingList();
            return members;
        }
        function isStartOfMappedType() {
            nextToken();
            if (token() === 40 /* PlusToken */  || token() === 41 /* MinusToken */ ) return nextToken() === 148 /* ReadonlyKeyword */ ;
            if (token() === 148 /* ReadonlyKeyword */ ) nextToken();
            return token() === 23 /* OpenBracketToken */  && nextTokenIsIdentifier() && nextToken() === 103 /* InKeyword */ ;
        }
        function parseMappedTypeParameter() {
            const pos = getNodePos();
            const name = parseIdentifierName();
            parseExpected(103 /* InKeyword */ );
            const type = parseType();
            return finishNode(factory2.createTypeParameterDeclaration(/*modifiers*/ void 0, name, type, /*defaultType*/ void 0), pos);
        }
        function parseMappedType() {
            const pos = getNodePos();
            parseExpected(19 /* OpenBraceToken */ );
            let readonlyToken;
            if (token() === 148 /* ReadonlyKeyword */  || token() === 40 /* PlusToken */  || token() === 41 /* MinusToken */ ) {
                readonlyToken = parseTokenNode();
                if (readonlyToken.kind !== 148 /* ReadonlyKeyword */ ) parseExpected(148 /* ReadonlyKeyword */ );
            }
            parseExpected(23 /* OpenBracketToken */ );
            const typeParameter = parseMappedTypeParameter();
            const nameType = parseOptional(130 /* AsKeyword */ ) ? parseType() : void 0;
            parseExpected(24 /* CloseBracketToken */ );
            let questionToken;
            if (token() === 58 /* QuestionToken */  || token() === 40 /* PlusToken */  || token() === 41 /* MinusToken */ ) {
                questionToken = parseTokenNode();
                if (questionToken.kind !== 58 /* QuestionToken */ ) parseExpected(58 /* QuestionToken */ );
            }
            const type = parseTypeAnnotation();
            parseSemicolon();
            const members = parseList(4 /* TypeMembers */ , parseTypeMember);
            parseExpected(20 /* CloseBraceToken */ );
            return finishNode(factory2.createMappedTypeNode(readonlyToken, typeParameter, nameType, questionToken, type, members), pos);
        }
        function parseTupleElementType() {
            const pos = getNodePos();
            if (parseOptional(26 /* DotDotDotToken */ )) return finishNode(factory2.createRestTypeNode(parseType()), pos);
            const type = parseType();
            if (isJSDocNullableType(type) && type.pos === type.type.pos) {
                const node = factory2.createOptionalTypeNode(type.type);
                setTextRange(node, type);
                node.flags = type.flags;
                return node;
            }
            return type;
        }
        function isNextTokenColonOrQuestionColon() {
            return nextToken() === 59 /* ColonToken */  || token() === 58 /* QuestionToken */  && nextToken() === 59 /* ColonToken */ ;
        }
        function isTupleElementName() {
            if (token() === 26 /* DotDotDotToken */ ) return tokenIsIdentifierOrKeyword(nextToken()) && isNextTokenColonOrQuestionColon();
            return tokenIsIdentifierOrKeyword(token()) && isNextTokenColonOrQuestionColon();
        }
        function parseTupleElementNameOrTupleElementType() {
            if (lookAhead(isTupleElementName)) {
                const pos = getNodePos();
                const hasJSDoc = hasPrecedingJSDocComment();
                const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                const name = parseIdentifierName();
                const questionToken = parseOptionalToken(58 /* QuestionToken */ );
                parseExpected(59 /* ColonToken */ );
                const type = parseTupleElementType();
                const node = factory2.createNamedTupleMember(dotDotDotToken, name, questionToken, type);
                return withJSDoc(finishNode(node, pos), hasJSDoc);
            }
            return parseTupleElementType();
        }
        function parseTupleType() {
            const pos = getNodePos();
            return finishNode(factory2.createTupleTypeNode(parseBracketedList(21 /* TupleElementTypes */ , parseTupleElementNameOrTupleElementType, 23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ )), pos);
        }
        function parseParenthesizedType() {
            const pos = getNodePos();
            parseExpected(21 /* OpenParenToken */ );
            const type = parseType();
            parseExpected(22 /* CloseParenToken */ );
            return finishNode(factory2.createParenthesizedType(type), pos);
        }
        function parseModifiersForConstructorType() {
            let modifiers;
            if (token() === 128 /* AbstractKeyword */ ) {
                const pos = getNodePos();
                nextToken();
                const modifier = finishNode(factoryCreateToken(128 /* AbstractKeyword */ ), pos);
                modifiers = createNodeArray([
                    modifier
                ], pos);
            }
            return modifiers;
        }
        function parseFunctionOrConstructorType() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = parseModifiersForConstructorType();
            const isConstructorType = parseOptional(105 /* NewKeyword */ );
            Debug.assert(!modifiers || isConstructorType, "Per isStartOfFunctionOrConstructorType, a function type cannot have modifiers.");
            const typeParameters = parseTypeParameters();
            const parameters = parseParameters(4 /* Type */ );
            const type = parseReturnType(39 /* EqualsGreaterThanToken */ , /*isType*/ false);
            const node = isConstructorType ? factory2.createConstructorTypeNode(modifiers, typeParameters, parameters, type) : factory2.createFunctionTypeNode(typeParameters, parameters, type);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseKeywordAndNoDot() {
            const node = parseTokenNode();
            return token() === 25 /* DotToken */  ? void 0 : node;
        }
        function parseLiteralTypeNode(negative) {
            const pos = getNodePos();
            if (negative) nextToken();
            let expression = token() === 112 /* TrueKeyword */  || token() === 97 /* FalseKeyword */  || token() === 106 /* NullKeyword */  ? parseTokenNode() : parseLiteralLikeNode(token());
            if (negative) expression = finishNode(factory2.createPrefixUnaryExpression(41 /* MinusToken */ , expression), pos);
            return finishNode(factory2.createLiteralTypeNode(expression), pos);
        }
        function isStartOfTypeOfImportType() {
            nextToken();
            return token() === 102 /* ImportKeyword */ ;
        }
        function parseImportType() {
            sourceFlags |= 4194304 /* PossiblyContainsDynamicImport */ ;
            const pos = getNodePos();
            const isTypeOf = parseOptional(114 /* TypeOfKeyword */ );
            parseExpected(102 /* ImportKeyword */ );
            parseExpected(21 /* OpenParenToken */ );
            const type = parseType();
            let attributes;
            if (parseOptional(28 /* CommaToken */ )) {
                const openBracePosition = scanner2.getTokenStart();
                parseExpected(19 /* OpenBraceToken */ );
                const currentToken2 = token();
                if (currentToken2 === 118 /* WithKeyword */  || currentToken2 === 132 /* AssertKeyword */ ) nextToken();
                else parseErrorAtCurrentToken(Diagnostics._0_expected, tokenToString(118 /* WithKeyword */ ));
                parseExpected(59 /* ColonToken */ );
                attributes = parseImportAttributes(currentToken2, /*skipKeyword*/ true);
                parseOptional(28 /* CommaToken */ );
                if (!parseExpected(20 /* CloseBraceToken */ )) {
                    const lastError = lastOrUndefined(parseDiagnostics);
                    if (lastError && lastError.code === Diagnostics._0_expected.code) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, sourceText, openBracePosition, 1, Diagnostics.The_parser_expected_to_find_a_1_to_match_the_0_token_here, "{", "}"));
                }
            }
            parseExpected(22 /* CloseParenToken */ );
            const qualifier = parseOptional(25 /* DotToken */ ) ? parseEntityNameOfTypeReference() : void 0;
            const typeArguments = parseTypeArgumentsOfTypeReference();
            return finishNode(factory2.createImportTypeNode(type, attributes, qualifier, typeArguments, isTypeOf), pos);
        }
        function nextTokenIsNumericOrBigIntLiteral() {
            nextToken();
            return token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */ ;
        }
        function parseNonArrayType() {
            switch(token()){
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 154 /* StringKeyword */ :
                case 150 /* NumberKeyword */ :
                case 163 /* BigIntKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 146 /* NeverKeyword */ :
                case 151 /* ObjectKeyword */ :
                    return tryParse(parseKeywordAndNoDot) || parseTypeReference();
                case 67 /* AsteriskEqualsToken */ :
                    scanner2.reScanAsteriskEqualsToken();
                // falls through
                case 42 /* AsteriskToken */ :
                    return parseJSDocAllType();
                case 61 /* QuestionQuestionToken */ :
                    scanner2.reScanQuestionToken();
                // falls through
                case 58 /* QuestionToken */ :
                    return parseJSDocUnknownOrNullableType();
                case 100 /* FunctionKeyword */ :
                    return parseJSDocFunctionType();
                case 54 /* ExclamationToken */ :
                    return parseJSDocNonNullableType();
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                    return parseLiteralTypeNode();
                case 41 /* MinusToken */ :
                    return lookAhead(nextTokenIsNumericOrBigIntLiteral) ? parseLiteralTypeNode(/*negative*/ true) : parseTypeReference();
                case 116 /* VoidKeyword */ :
                    return parseTokenNode();
                case 110 /* ThisKeyword */ :
                    {
                        const thisKeyword = parseThisTypeNode();
                        if (token() === 142 /* IsKeyword */  && !scanner2.hasPrecedingLineBreak()) return parseThisTypePredicate(thisKeyword);
                        else return thisKeyword;
                    }
                case 114 /* TypeOfKeyword */ :
                    return lookAhead(isStartOfTypeOfImportType) ? parseImportType() : parseTypeQuery();
                case 19 /* OpenBraceToken */ :
                    return lookAhead(isStartOfMappedType) ? parseMappedType() : parseTypeLiteral();
                case 23 /* OpenBracketToken */ :
                    return parseTupleType();
                case 21 /* OpenParenToken */ :
                    return parseParenthesizedType();
                case 102 /* ImportKeyword */ :
                    return parseImportType();
                case 131 /* AssertsKeyword */ :
                    return lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine) ? parseAssertsTypePredicate() : parseTypeReference();
                case 16 /* TemplateHead */ :
                    return parseTemplateType();
                default:
                    return parseTypeReference();
            }
        }
        function isStartOfType(inStartOfParameter) {
            switch(token()){
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 154 /* StringKeyword */ :
                case 150 /* NumberKeyword */ :
                case 163 /* BigIntKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 158 /* UniqueKeyword */ :
                case 116 /* VoidKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 106 /* NullKeyword */ :
                case 110 /* ThisKeyword */ :
                case 114 /* TypeOfKeyword */ :
                case 146 /* NeverKeyword */ :
                case 19 /* OpenBraceToken */ :
                case 23 /* OpenBracketToken */ :
                case 30 /* LessThanToken */ :
                case 52 /* BarToken */ :
                case 51 /* AmpersandToken */ :
                case 105 /* NewKeyword */ :
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 151 /* ObjectKeyword */ :
                case 42 /* AsteriskToken */ :
                case 58 /* QuestionToken */ :
                case 54 /* ExclamationToken */ :
                case 26 /* DotDotDotToken */ :
                case 140 /* InferKeyword */ :
                case 102 /* ImportKeyword */ :
                case 131 /* AssertsKeyword */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 16 /* TemplateHead */ :
                    return true;
                case 100 /* FunctionKeyword */ :
                    return !inStartOfParameter;
                case 41 /* MinusToken */ :
                    return !inStartOfParameter && lookAhead(nextTokenIsNumericOrBigIntLiteral);
                case 21 /* OpenParenToken */ :
                    return !inStartOfParameter && lookAhead(isStartOfParenthesizedOrFunctionType);
                default:
                    return isIdentifier2();
            }
        }
        function isStartOfParenthesizedOrFunctionType() {
            nextToken();
            return token() === 22 /* CloseParenToken */  || isStartOfParameter(/*isJSDocParameter*/ false) || isStartOfType();
        }
        function parsePostfixTypeOrHigher() {
            const pos = getNodePos();
            let type = parseNonArrayType();
            while(!scanner2.hasPrecedingLineBreak())switch(token()){
                case 54 /* ExclamationToken */ :
                    nextToken();
                    type = finishNode(factory2.createJSDocNonNullableType(type, /*postfix*/ true), pos);
                    break;
                case 58 /* QuestionToken */ :
                    if (lookAhead(nextTokenIsStartOfType)) return type;
                    nextToken();
                    type = finishNode(factory2.createJSDocNullableType(type, /*postfix*/ true), pos);
                    break;
                case 23 /* OpenBracketToken */ :
                    parseExpected(23 /* OpenBracketToken */ );
                    if (isStartOfType()) {
                        const indexType = parseType();
                        parseExpected(24 /* CloseBracketToken */ );
                        type = finishNode(factory2.createIndexedAccessTypeNode(type, indexType), pos);
                    } else {
                        parseExpected(24 /* CloseBracketToken */ );
                        type = finishNode(factory2.createArrayTypeNode(type), pos);
                    }
                    break;
                default:
                    return type;
            }
            return type;
        }
        function parseTypeOperator(operator) {
            const pos = getNodePos();
            parseExpected(operator);
            return finishNode(factory2.createTypeOperatorNode(operator, parseTypeOperatorOrHigher()), pos);
        }
        function tryParseConstraintOfInferType() {
            if (parseOptional(96 /* ExtendsKeyword */ )) {
                const constraint = disallowConditionalTypesAnd(parseType);
                if (inDisallowConditionalTypesContext() || token() !== 58 /* QuestionToken */ ) return constraint;
            }
        }
        function parseTypeParameterOfInferType() {
            const pos = getNodePos();
            const name = parseIdentifier();
            const constraint = tryParse(tryParseConstraintOfInferType);
            const node = factory2.createTypeParameterDeclaration(/*modifiers*/ void 0, name, constraint);
            return finishNode(node, pos);
        }
        function parseInferType() {
            const pos = getNodePos();
            parseExpected(140 /* InferKeyword */ );
            return finishNode(factory2.createInferTypeNode(parseTypeParameterOfInferType()), pos);
        }
        function parseTypeOperatorOrHigher() {
            const operator = token();
            switch(operator){
                case 143 /* KeyOfKeyword */ :
                case 158 /* UniqueKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                    return parseTypeOperator(operator);
                case 140 /* InferKeyword */ :
                    return parseInferType();
            }
            return allowConditionalTypesAnd(parsePostfixTypeOrHigher);
        }
        function parseFunctionOrConstructorTypeToError(isInUnionType) {
            if (isStartOfFunctionTypeOrConstructorType()) {
                const type = parseFunctionOrConstructorType();
                let diagnostic;
                if (isFunctionTypeNode(type)) diagnostic = isInUnionType ? Diagnostics.Function_type_notation_must_be_parenthesized_when_used_in_a_union_type : Diagnostics.Function_type_notation_must_be_parenthesized_when_used_in_an_intersection_type;
                else diagnostic = isInUnionType ? Diagnostics.Constructor_type_notation_must_be_parenthesized_when_used_in_a_union_type : Diagnostics.Constructor_type_notation_must_be_parenthesized_when_used_in_an_intersection_type;
                parseErrorAtRange(type, diagnostic);
                return type;
            }
            return void 0;
        }
        function parseUnionOrIntersectionType(operator, parseConstituentType, createTypeNode) {
            const pos = getNodePos();
            const isUnionType = operator === 52 /* BarToken */ ;
            const hasLeadingOperator = parseOptional(operator);
            let type = hasLeadingOperator && parseFunctionOrConstructorTypeToError(isUnionType) || parseConstituentType();
            if (token() === operator || hasLeadingOperator) {
                const types = [
                    type
                ];
                while(parseOptional(operator))types.push(parseFunctionOrConstructorTypeToError(isUnionType) || parseConstituentType());
                type = finishNode(createTypeNode(createNodeArray(types, pos)), pos);
            }
            return type;
        }
        function parseIntersectionTypeOrHigher() {
            return parseUnionOrIntersectionType(51 /* AmpersandToken */ , parseTypeOperatorOrHigher, factory2.createIntersectionTypeNode);
        }
        function parseUnionTypeOrHigher() {
            return parseUnionOrIntersectionType(52 /* BarToken */ , parseIntersectionTypeOrHigher, factory2.createUnionTypeNode);
        }
        function nextTokenIsNewKeyword() {
            nextToken();
            return token() === 105 /* NewKeyword */ ;
        }
        function isStartOfFunctionTypeOrConstructorType() {
            if (token() === 30 /* LessThanToken */ ) return true;
            if (token() === 21 /* OpenParenToken */  && lookAhead(isUnambiguouslyStartOfFunctionType)) return true;
            return token() === 105 /* NewKeyword */  || token() === 128 /* AbstractKeyword */  && lookAhead(nextTokenIsNewKeyword);
        }
        function skipParameterStart() {
            if (isModifierKind(token())) parseModifiers(/*allowDecorators*/ false);
            if (isIdentifier2() || token() === 110 /* ThisKeyword */ ) {
                nextToken();
                return true;
            }
            if (token() === 23 /* OpenBracketToken */  || token() === 19 /* OpenBraceToken */ ) {
                const previousErrorCount = parseDiagnostics.length;
                parseIdentifierOrPattern();
                return previousErrorCount === parseDiagnostics.length;
            }
            return false;
        }
        function isUnambiguouslyStartOfFunctionType() {
            nextToken();
            if (token() === 22 /* CloseParenToken */  || token() === 26 /* DotDotDotToken */ ) return true;
            if (skipParameterStart()) {
                if (token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || token() === 58 /* QuestionToken */  || token() === 64 /* EqualsToken */ ) return true;
                if (token() === 22 /* CloseParenToken */ ) {
                    nextToken();
                    if (token() === 39 /* EqualsGreaterThanToken */ ) return true;
                }
            }
            return false;
        }
        function parseTypeOrTypePredicate() {
            const pos = getNodePos();
            const typePredicateVariable = isIdentifier2() && tryParse(parseTypePredicatePrefix);
            const type = parseType();
            if (typePredicateVariable) return finishNode(factory2.createTypePredicateNode(/*assertsModifier*/ void 0, typePredicateVariable, type), pos);
            else return type;
        }
        function parseTypePredicatePrefix() {
            const id = parseIdentifier();
            if (token() === 142 /* IsKeyword */  && !scanner2.hasPrecedingLineBreak()) {
                nextToken();
                return id;
            }
        }
        function parseAssertsTypePredicate() {
            const pos = getNodePos();
            const assertsModifier = parseExpectedToken(131 /* AssertsKeyword */ );
            const parameterName = token() === 110 /* ThisKeyword */  ? parseThisTypeNode() : parseIdentifier();
            const type = parseOptional(142 /* IsKeyword */ ) ? parseType() : void 0;
            return finishNode(factory2.createTypePredicateNode(assertsModifier, parameterName, type), pos);
        }
        function parseType() {
            if (contextFlags & 81920 /* TypeExcludesFlags */ ) return doOutsideOfContext(81920 /* TypeExcludesFlags */ , parseType);
            if (isStartOfFunctionTypeOrConstructorType()) return parseFunctionOrConstructorType();
            const pos = getNodePos();
            const type = parseUnionTypeOrHigher();
            if (!inDisallowConditionalTypesContext() && !scanner2.hasPrecedingLineBreak() && parseOptional(96 /* ExtendsKeyword */ )) {
                const extendsType = disallowConditionalTypesAnd(parseType);
                parseExpected(58 /* QuestionToken */ );
                const trueType = allowConditionalTypesAnd(parseType);
                parseExpected(59 /* ColonToken */ );
                const falseType = allowConditionalTypesAnd(parseType);
                return finishNode(factory2.createConditionalTypeNode(type, extendsType, trueType, falseType), pos);
            }
            return type;
        }
        function parseTypeAnnotation() {
            return parseOptional(59 /* ColonToken */ ) ? parseType() : void 0;
        }
        function isStartOfLeftHandSideExpression() {
            switch(token()){
                case 110 /* ThisKeyword */ :
                case 108 /* SuperKeyword */ :
                case 106 /* NullKeyword */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 16 /* TemplateHead */ :
                case 21 /* OpenParenToken */ :
                case 23 /* OpenBracketToken */ :
                case 19 /* OpenBraceToken */ :
                case 100 /* FunctionKeyword */ :
                case 86 /* ClassKeyword */ :
                case 105 /* NewKeyword */ :
                case 44 /* SlashToken */ :
                case 69 /* SlashEqualsToken */ :
                case 80 /* Identifier */ :
                    return true;
                case 102 /* ImportKeyword */ :
                    return lookAhead(nextTokenIsOpenParenOrLessThanOrDot);
                default:
                    return isIdentifier2();
            }
        }
        function isStartOfExpression() {
            if (isStartOfLeftHandSideExpression()) return true;
            switch(token()){
                case 40 /* PlusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                case 54 /* ExclamationToken */ :
                case 91 /* DeleteKeyword */ :
                case 114 /* TypeOfKeyword */ :
                case 116 /* VoidKeyword */ :
                case 46 /* PlusPlusToken */ :
                case 47 /* MinusMinusToken */ :
                case 30 /* LessThanToken */ :
                case 135 /* AwaitKeyword */ :
                case 127 /* YieldKeyword */ :
                case 81 /* PrivateIdentifier */ :
                case 60 /* AtToken */ :
                    return true;
                default:
                    if (isBinaryOperator2()) return true;
                    return isIdentifier2();
            }
        }
        function isStartOfExpressionStatement() {
            return token() !== 19 /* OpenBraceToken */  && token() !== 100 /* FunctionKeyword */  && token() !== 86 /* ClassKeyword */  && token() !== 60 /* AtToken */  && isStartOfExpression();
        }
        function parseExpression() {
            const saveDecoratorContext = inDecoratorContext();
            if (saveDecoratorContext) setDecoratorContext(/*val*/ false);
            const pos = getNodePos();
            let expr = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
            let operatorToken;
            while(operatorToken = parseOptionalToken(28 /* CommaToken */ ))expr = makeBinaryExpression(expr, operatorToken, parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true), pos);
            if (saveDecoratorContext) setDecoratorContext(/*val*/ true);
            return expr;
        }
        function parseInitializer() {
            return parseOptional(64 /* EqualsToken */ ) ? parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true) : void 0;
        }
        function parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction) {
            if (isYieldExpression2()) return parseYieldExpression();
            const arrowExpression = tryParseParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction) || tryParseAsyncSimpleArrowFunctionExpression(allowReturnTypeInArrowFunction);
            if (arrowExpression) return arrowExpression;
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const expr = parseBinaryExpressionOrHigher(0 /* Lowest */ );
            if (expr.kind === 80 /* Identifier */  && token() === 39 /* EqualsGreaterThanToken */ ) return parseSimpleArrowFunctionExpression(pos, expr, allowReturnTypeInArrowFunction, hasJSDoc, /*asyncModifier*/ void 0);
            if (isLeftHandSideExpression(expr) && isAssignmentOperator(reScanGreaterToken())) return makeBinaryExpression(expr, parseTokenNode(), parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction), pos);
            return parseConditionalExpressionRest(expr, pos, allowReturnTypeInArrowFunction);
        }
        function isYieldExpression2() {
            if (token() === 127 /* YieldKeyword */ ) {
                if (inYieldContext()) return true;
                return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
            }
            return false;
        }
        function nextTokenIsIdentifierOnSameLine() {
            nextToken();
            return !scanner2.hasPrecedingLineBreak() && isIdentifier2();
        }
        function parseYieldExpression() {
            const pos = getNodePos();
            nextToken();
            if (!scanner2.hasPrecedingLineBreak() && (token() === 42 /* AsteriskToken */  || isStartOfExpression())) return finishNode(factory2.createYieldExpression(parseOptionalToken(42 /* AsteriskToken */ ), parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true)), pos);
            else return finishNode(factory2.createYieldExpression(/*asteriskToken*/ void 0, /*expression*/ void 0), pos);
        }
        function parseSimpleArrowFunctionExpression(pos, identifier, allowReturnTypeInArrowFunction, hasJSDoc, asyncModifier) {
            Debug.assert(token() === 39 /* EqualsGreaterThanToken */ , "parseSimpleArrowFunctionExpression should only have been called if we had a =>");
            const parameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, identifier, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            finishNode(parameter, identifier.pos);
            const parameters = createNodeArray([
                parameter
            ], parameter.pos, parameter.end);
            const equalsGreaterThanToken = parseExpectedToken(39 /* EqualsGreaterThanToken */ );
            const body = parseArrowFunctionExpressionBody(/*isAsync*/ !!asyncModifier, allowReturnTypeInArrowFunction);
            const node = factory2.createArrowFunction(asyncModifier, /*typeParameters*/ void 0, parameters, /*type*/ void 0, equalsGreaterThanToken, body);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function tryParseParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction) {
            const triState = isParenthesizedArrowFunctionExpression();
            if (triState === 0 /* False */ ) return void 0;
            return triState === 1 /* True */  ? parseParenthesizedArrowFunctionExpression(/*allowAmbiguity*/ true, /*allowReturnTypeInArrowFunction*/ true) : tryParse(()=>parsePossibleParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction));
        }
        function isParenthesizedArrowFunctionExpression() {
            if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */  || token() === 134 /* AsyncKeyword */ ) return lookAhead(isParenthesizedArrowFunctionExpressionWorker);
            if (token() === 39 /* EqualsGreaterThanToken */ ) return 1 /* True */ ;
            return 0 /* False */ ;
        }
        function isParenthesizedArrowFunctionExpressionWorker() {
            if (token() === 134 /* AsyncKeyword */ ) {
                nextToken();
                if (scanner2.hasPrecedingLineBreak()) return 0 /* False */ ;
                if (token() !== 21 /* OpenParenToken */  && token() !== 30 /* LessThanToken */ ) return 0 /* False */ ;
            }
            const first2 = token();
            const second = nextToken();
            if (first2 === 21 /* OpenParenToken */ ) {
                if (second === 22 /* CloseParenToken */ ) {
                    const third = nextToken();
                    switch(third){
                        case 39 /* EqualsGreaterThanToken */ :
                        case 59 /* ColonToken */ :
                        case 19 /* OpenBraceToken */ :
                            return 1 /* True */ ;
                        default:
                            return 0 /* False */ ;
                    }
                }
                if (second === 23 /* OpenBracketToken */  || second === 19 /* OpenBraceToken */ ) return 2 /* Unknown */ ;
                if (second === 26 /* DotDotDotToken */ ) return 1 /* True */ ;
                if (isModifierKind(second) && second !== 134 /* AsyncKeyword */  && lookAhead(nextTokenIsIdentifier)) {
                    if (nextToken() === 130 /* AsKeyword */ ) return 0 /* False */ ;
                    return 1 /* True */ ;
                }
                if (!isIdentifier2() && second !== 110 /* ThisKeyword */ ) return 0 /* False */ ;
                switch(nextToken()){
                    case 59 /* ColonToken */ :
                        return 1 /* True */ ;
                    case 58 /* QuestionToken */ :
                        nextToken();
                        if (token() === 59 /* ColonToken */  || token() === 28 /* CommaToken */  || token() === 64 /* EqualsToken */  || token() === 22 /* CloseParenToken */ ) return 1 /* True */ ;
                        return 0 /* False */ ;
                    case 28 /* CommaToken */ :
                    case 64 /* EqualsToken */ :
                    case 22 /* CloseParenToken */ :
                        return 2 /* Unknown */ ;
                }
                return 0 /* False */ ;
            } else {
                Debug.assert(first2 === 30 /* LessThanToken */ );
                if (!isIdentifier2() && token() !== 87 /* ConstKeyword */ ) return 0 /* False */ ;
                if (languageVariant === 1 /* JSX */ ) {
                    const isArrowFunctionInJsx = lookAhead(()=>{
                        parseOptional(87 /* ConstKeyword */ );
                        const third = nextToken();
                        if (third === 96 /* ExtendsKeyword */ ) {
                            const fourth = nextToken();
                            switch(fourth){
                                case 64 /* EqualsToken */ :
                                case 32 /* GreaterThanToken */ :
                                case 44 /* SlashToken */ :
                                    return false;
                                default:
                                    return true;
                            }
                        } else if (third === 28 /* CommaToken */  || third === 64 /* EqualsToken */ ) return true;
                        return false;
                    });
                    if (isArrowFunctionInJsx) return 1 /* True */ ;
                    return 0 /* False */ ;
                }
                return 2 /* Unknown */ ;
            }
        }
        function parsePossibleParenthesizedArrowFunctionExpression(allowReturnTypeInArrowFunction) {
            const tokenPos = scanner2.getTokenStart();
            if (notParenthesizedArrow == null ? void 0 : notParenthesizedArrow.has(tokenPos)) return void 0;
            const result = parseParenthesizedArrowFunctionExpression(/*allowAmbiguity*/ false, allowReturnTypeInArrowFunction);
            if (!result) (notParenthesizedArrow || (notParenthesizedArrow = /* @__PURE__ */ new Set())).add(tokenPos);
            return result;
        }
        function tryParseAsyncSimpleArrowFunctionExpression(allowReturnTypeInArrowFunction) {
            if (token() === 134 /* AsyncKeyword */ ) {
                if (lookAhead(isUnParenthesizedAsyncArrowFunctionWorker) === 1 /* True */ ) {
                    const pos = getNodePos();
                    const hasJSDoc = hasPrecedingJSDocComment();
                    const asyncModifier = parseModifiersForArrowFunction();
                    const expr = parseBinaryExpressionOrHigher(0 /* Lowest */ );
                    return parseSimpleArrowFunctionExpression(pos, expr, allowReturnTypeInArrowFunction, hasJSDoc, asyncModifier);
                }
            }
            return void 0;
        }
        function isUnParenthesizedAsyncArrowFunctionWorker() {
            if (token() === 134 /* AsyncKeyword */ ) {
                nextToken();
                if (scanner2.hasPrecedingLineBreak() || token() === 39 /* EqualsGreaterThanToken */ ) return 0 /* False */ ;
                const expr = parseBinaryExpressionOrHigher(0 /* Lowest */ );
                if (!scanner2.hasPrecedingLineBreak() && expr.kind === 80 /* Identifier */  && token() === 39 /* EqualsGreaterThanToken */ ) return 1 /* True */ ;
            }
            return 0 /* False */ ;
        }
        function parseParenthesizedArrowFunctionExpression(allowAmbiguity, allowReturnTypeInArrowFunction) {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = parseModifiersForArrowFunction();
            const isAsync = some(modifiers, isAsyncModifier) ? 2 /* Await */  : 0 /* None */ ;
            const typeParameters = parseTypeParameters();
            let parameters;
            if (!parseExpected(21 /* OpenParenToken */ )) {
                if (!allowAmbiguity) return void 0;
                parameters = createMissingList();
            } else {
                if (!allowAmbiguity) {
                    const maybeParameters = parseParametersWorker(isAsync, allowAmbiguity);
                    if (!maybeParameters) return void 0;
                    parameters = maybeParameters;
                } else parameters = parseParametersWorker(isAsync, allowAmbiguity);
                if (!parseExpected(22 /* CloseParenToken */ ) && !allowAmbiguity) return void 0;
            }
            const hasReturnColon = token() === 59 /* ColonToken */ ;
            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
            if (type && !allowAmbiguity && typeHasArrowFunctionBlockingParseError(type)) return void 0;
            let unwrappedType = type;
            while((unwrappedType == null ? void 0 : unwrappedType.kind) === 197 /* ParenthesizedType */ )unwrappedType = unwrappedType.type;
            const hasJSDocFunctionType = unwrappedType && isJSDocFunctionType(unwrappedType);
            if (!allowAmbiguity && token() !== 39 /* EqualsGreaterThanToken */  && (hasJSDocFunctionType || token() !== 19 /* OpenBraceToken */ )) return void 0;
            const lastToken = token();
            const equalsGreaterThanToken = parseExpectedToken(39 /* EqualsGreaterThanToken */ );
            const body = lastToken === 39 /* EqualsGreaterThanToken */  || lastToken === 19 /* OpenBraceToken */  ? parseArrowFunctionExpressionBody(some(modifiers, isAsyncModifier), allowReturnTypeInArrowFunction) : parseIdentifier();
            if (!allowReturnTypeInArrowFunction && hasReturnColon) {
                if (token() !== 59 /* ColonToken */ ) return void 0;
            }
            const node = factory2.createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseArrowFunctionExpressionBody(isAsync, allowReturnTypeInArrowFunction) {
            if (token() === 19 /* OpenBraceToken */ ) return parseFunctionBlock(isAsync ? 2 /* Await */  : 0 /* None */ );
            if (token() !== 27 /* SemicolonToken */  && token() !== 100 /* FunctionKeyword */  && token() !== 86 /* ClassKeyword */  && isStartOfStatement() && !isStartOfExpressionStatement()) return parseFunctionBlock(16 /* IgnoreMissingOpenBrace */  | (isAsync ? 2 /* Await */  : 0 /* None */ ));
            const savedYieldContext = inYieldContext();
            setYieldContext(false);
            const savedTopLevel = topLevel;
            topLevel = false;
            const node = isAsync ? doInAwaitContext(()=>parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction)) : doOutsideOfAwaitContext(()=>parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction));
            topLevel = savedTopLevel;
            setYieldContext(savedYieldContext);
            return node;
        }
        function parseConditionalExpressionRest(leftOperand, pos, allowReturnTypeInArrowFunction) {
            const questionToken = parseOptionalToken(58 /* QuestionToken */ );
            if (!questionToken) return leftOperand;
            let colonToken;
            return finishNode(factory2.createConditionalExpression(leftOperand, questionToken, doOutsideOfContext(disallowInAndDecoratorContext, ()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ false)), colonToken = parseExpectedToken(59 /* ColonToken */ ), nodeIsPresent(colonToken) ? parseAssignmentExpressionOrHigher(allowReturnTypeInArrowFunction) : createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ false, Diagnostics._0_expected, tokenToString(59 /* ColonToken */ ))), pos);
        }
        function parseBinaryExpressionOrHigher(precedence) {
            const pos = getNodePos();
            const leftOperand = parseUnaryExpressionOrHigher();
            return parseBinaryExpressionRest(precedence, leftOperand, pos);
        }
        function isInOrOfKeyword(t) {
            return t === 103 /* InKeyword */  || t === 165 /* OfKeyword */ ;
        }
        function parseBinaryExpressionRest(precedence, leftOperand, pos) {
            while(true){
                reScanGreaterToken();
                const newPrecedence = getBinaryOperatorPrecedence(token());
                const consumeCurrentOperator = token() === 43 /* AsteriskAsteriskToken */  ? newPrecedence >= precedence : newPrecedence > precedence;
                if (!consumeCurrentOperator) break;
                if (token() === 103 /* InKeyword */  && inDisallowInContext()) break;
                if (token() === 130 /* AsKeyword */  || token() === 152 /* SatisfiesKeyword */ ) {
                    if (scanner2.hasPrecedingLineBreak()) break;
                    else {
                        const keywordKind = token();
                        nextToken();
                        leftOperand = keywordKind === 152 /* SatisfiesKeyword */  ? makeSatisfiesExpression(leftOperand, parseType()) : makeAsExpression(leftOperand, parseType());
                    }
                } else leftOperand = makeBinaryExpression(leftOperand, parseTokenNode(), parseBinaryExpressionOrHigher(newPrecedence), pos);
            }
            return leftOperand;
        }
        function isBinaryOperator2() {
            if (inDisallowInContext() && token() === 103 /* InKeyword */ ) return false;
            return getBinaryOperatorPrecedence(token()) > 0;
        }
        function makeSatisfiesExpression(left, right) {
            return finishNode(factory2.createSatisfiesExpression(left, right), left.pos);
        }
        function makeBinaryExpression(left, operatorToken, right, pos) {
            return finishNode(factory2.createBinaryExpression(left, operatorToken, right), pos);
        }
        function makeAsExpression(left, right) {
            return finishNode(factory2.createAsExpression(left, right), left.pos);
        }
        function parsePrefixUnaryExpression() {
            const pos = getNodePos();
            return finishNode(factory2.createPrefixUnaryExpression(token(), nextTokenAnd(parseSimpleUnaryExpression)), pos);
        }
        function parseDeleteExpression() {
            const pos = getNodePos();
            return finishNode(factory2.createDeleteExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
        }
        function parseTypeOfExpression() {
            const pos = getNodePos();
            return finishNode(factory2.createTypeOfExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
        }
        function parseVoidExpression() {
            const pos = getNodePos();
            return finishNode(factory2.createVoidExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
        }
        function isAwaitExpression2() {
            if (token() === 135 /* AwaitKeyword */ ) {
                if (inAwaitContext()) return true;
                return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
            }
            return false;
        }
        function parseAwaitExpression() {
            const pos = getNodePos();
            return finishNode(factory2.createAwaitExpression(nextTokenAnd(parseSimpleUnaryExpression)), pos);
        }
        function parseUnaryExpressionOrHigher() {
            if (isUpdateExpression()) {
                const pos = getNodePos();
                const updateExpression = parseUpdateExpression();
                return token() === 43 /* AsteriskAsteriskToken */  ? parseBinaryExpressionRest(getBinaryOperatorPrecedence(token()), updateExpression, pos) : updateExpression;
            }
            const unaryOperator = token();
            const simpleUnaryExpression = parseSimpleUnaryExpression();
            if (token() === 43 /* AsteriskAsteriskToken */ ) {
                const pos = skipTrivia(sourceText, simpleUnaryExpression.pos);
                const { end } = simpleUnaryExpression;
                if (simpleUnaryExpression.kind === 217 /* TypeAssertionExpression */ ) parseErrorAt(pos, end, Diagnostics.A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses);
                else {
                    Debug.assert(isKeywordOrPunctuation(unaryOperator));
                    parseErrorAt(pos, end, Diagnostics.An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses, tokenToString(unaryOperator));
                }
            }
            return simpleUnaryExpression;
        }
        function parseSimpleUnaryExpression() {
            switch(token()){
                case 40 /* PlusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                case 54 /* ExclamationToken */ :
                    return parsePrefixUnaryExpression();
                case 91 /* DeleteKeyword */ :
                    return parseDeleteExpression();
                case 114 /* TypeOfKeyword */ :
                    return parseTypeOfExpression();
                case 116 /* VoidKeyword */ :
                    return parseVoidExpression();
                case 30 /* LessThanToken */ :
                    if (languageVariant === 1 /* JSX */ ) return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true, /*topInvalidNodePosition*/ void 0, /*openingTag*/ void 0, /*mustBeUnary*/ true);
                    return parseTypeAssertion();
                case 135 /* AwaitKeyword */ :
                    if (isAwaitExpression2()) return parseAwaitExpression();
                // falls through
                default:
                    return parseUpdateExpression();
            }
        }
        function isUpdateExpression() {
            switch(token()){
                case 40 /* PlusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                case 54 /* ExclamationToken */ :
                case 91 /* DeleteKeyword */ :
                case 114 /* TypeOfKeyword */ :
                case 116 /* VoidKeyword */ :
                case 135 /* AwaitKeyword */ :
                    return false;
                case 30 /* LessThanToken */ :
                    if (languageVariant !== 1 /* JSX */ ) return false;
                // We are in JSX context and the token is part of JSXElement.
                // falls through
                default:
                    return true;
            }
        }
        function parseUpdateExpression() {
            if (token() === 46 /* PlusPlusToken */  || token() === 47 /* MinusMinusToken */ ) {
                const pos = getNodePos();
                return finishNode(factory2.createPrefixUnaryExpression(token(), nextTokenAnd(parseLeftHandSideExpressionOrHigher)), pos);
            } else if (languageVariant === 1 /* JSX */  && token() === 30 /* LessThanToken */  && lookAhead(nextTokenIsIdentifierOrKeywordOrGreaterThan)) return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true);
            const expression = parseLeftHandSideExpressionOrHigher();
            Debug.assert(isLeftHandSideExpression(expression));
            if ((token() === 46 /* PlusPlusToken */  || token() === 47 /* MinusMinusToken */ ) && !scanner2.hasPrecedingLineBreak()) {
                const operator = token();
                nextToken();
                return finishNode(factory2.createPostfixUnaryExpression(expression, operator), expression.pos);
            }
            return expression;
        }
        function parseLeftHandSideExpressionOrHigher() {
            const pos = getNodePos();
            let expression;
            if (token() === 102 /* ImportKeyword */ ) {
                if (lookAhead(nextTokenIsOpenParenOrLessThan)) {
                    sourceFlags |= 4194304 /* PossiblyContainsDynamicImport */ ;
                    expression = parseTokenNode();
                } else if (lookAhead(nextTokenIsDot)) {
                    nextToken();
                    nextToken();
                    expression = finishNode(factory2.createMetaProperty(102 /* ImportKeyword */ , parseIdentifierName()), pos);
                    if (expression.name.escapedText === "defer") {
                        if (token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) sourceFlags |= 4194304 /* PossiblyContainsDynamicImport */ ;
                    } else sourceFlags |= 8388608 /* PossiblyContainsImportMeta */ ;
                } else expression = parseMemberExpressionOrHigher();
            } else expression = token() === 108 /* SuperKeyword */  ? parseSuperExpression() : parseMemberExpressionOrHigher();
            return parseCallExpressionRest(pos, expression);
        }
        function parseMemberExpressionOrHigher() {
            const pos = getNodePos();
            const expression = parsePrimaryExpression();
            return parseMemberExpressionRest(pos, expression, /*allowOptionalChain*/ true);
        }
        function parseSuperExpression() {
            const pos = getNodePos();
            let expression = parseTokenNode();
            if (token() === 30 /* LessThanToken */ ) {
                const startPos = getNodePos();
                const typeArguments = tryParse(parseTypeArgumentsInExpression);
                if (typeArguments !== void 0) {
                    parseErrorAt(startPos, getNodePos(), Diagnostics.super_may_not_use_type_arguments);
                    if (!isTemplateStartOfTaggedTemplate()) expression = factory2.createExpressionWithTypeArguments(expression, typeArguments);
                }
            }
            if (token() === 21 /* OpenParenToken */  || token() === 25 /* DotToken */  || token() === 23 /* OpenBracketToken */ ) return expression;
            parseExpectedToken(25 /* DotToken */ , Diagnostics.super_must_be_followed_by_an_argument_list_or_member_access);
            return finishNode(factoryCreatePropertyAccessExpression(expression, parseRightSideOfDot(/*allowIdentifierNames*/ true, /*allowPrivateIdentifiers*/ true, /*allowUnicodeEscapeSequenceInIdentifierName*/ true)), pos);
        }
        function parseJsxElementOrSelfClosingElementOrFragment(inExpressionContext, topInvalidNodePosition, openingTag, mustBeUnary = false) {
            const pos = getNodePos();
            const opening = parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext);
            let result;
            if (opening.kind === 287 /* JsxOpeningElement */ ) {
                let children = parseJsxChildren(opening);
                let closingElement;
                const lastChild = children[children.length - 1];
                if ((lastChild == null ? void 0 : lastChild.kind) === 285 /* JsxElement */  && !tagNamesAreEquivalent(lastChild.openingElement.tagName, lastChild.closingElement.tagName) && tagNamesAreEquivalent(opening.tagName, lastChild.closingElement.tagName)) {
                    const end = lastChild.children.end;
                    const newLast = finishNode(factory2.createJsxElement(lastChild.openingElement, lastChild.children, finishNode(factory2.createJsxClosingElement(finishNode(factoryCreateIdentifier(""), end, end)), end, end)), lastChild.openingElement.pos, end);
                    children = createNodeArray([
                        ...children.slice(0, children.length - 1),
                        newLast
                    ], children.pos, end);
                    closingElement = lastChild.closingElement;
                } else {
                    closingElement = parseJsxClosingElement(opening, inExpressionContext);
                    if (!tagNamesAreEquivalent(opening.tagName, closingElement.tagName)) {
                        if (openingTag && isJsxOpeningElement(openingTag) && tagNamesAreEquivalent(closingElement.tagName, openingTag.tagName)) parseErrorAtRange(opening.tagName, Diagnostics.JSX_element_0_has_no_corresponding_closing_tag, getTextOfNodeFromSourceText(sourceText, opening.tagName));
                        else parseErrorAtRange(closingElement.tagName, Diagnostics.Expected_corresponding_JSX_closing_tag_for_0, getTextOfNodeFromSourceText(sourceText, opening.tagName));
                    }
                }
                result = finishNode(factory2.createJsxElement(opening, children, closingElement), pos);
            } else if (opening.kind === 290 /* JsxOpeningFragment */ ) result = finishNode(factory2.createJsxFragment(opening, parseJsxChildren(opening), parseJsxClosingFragment(inExpressionContext)), pos);
            else {
                Debug.assert(opening.kind === 286 /* JsxSelfClosingElement */ );
                result = opening;
            }
            if (!mustBeUnary && inExpressionContext && token() === 30 /* LessThanToken */ ) {
                const topBadPos = typeof topInvalidNodePosition === "undefined" ? result.pos : topInvalidNodePosition;
                const invalidElement = tryParse(()=>parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true, topBadPos));
                if (invalidElement) {
                    const operatorToken = createMissingNode(28 /* CommaToken */ , /*reportAtCurrentPosition*/ false);
                    setTextRangePosWidth(operatorToken, invalidElement.pos, 0);
                    parseErrorAt(skipTrivia(sourceText, topBadPos), invalidElement.end, Diagnostics.JSX_expressions_must_have_one_parent_element);
                    return finishNode(factory2.createBinaryExpression(result, operatorToken, invalidElement), pos);
                }
            }
            return result;
        }
        function parseJsxText() {
            const pos = getNodePos();
            const node = factory2.createJsxText(scanner2.getTokenValue(), currentToken === 13 /* JsxTextAllWhiteSpaces */ );
            currentToken = scanner2.scanJsxToken();
            return finishNode(node, pos);
        }
        function parseJsxChild(openingTag, token2) {
            switch(token2){
                case 1 /* EndOfFileToken */ :
                    if (isJsxOpeningFragment(openingTag)) parseErrorAtRange(openingTag, Diagnostics.JSX_fragment_has_no_corresponding_closing_tag);
                    else {
                        const tag = openingTag.tagName;
                        const start = Math.min(skipTrivia(sourceText, tag.pos), tag.end);
                        parseErrorAt(start, tag.end, Diagnostics.JSX_element_0_has_no_corresponding_closing_tag, getTextOfNodeFromSourceText(sourceText, openingTag.tagName));
                    }
                    return void 0;
                case 31 /* LessThanSlashToken */ :
                case 7 /* ConflictMarkerTrivia */ :
                    return void 0;
                case 12 /* JsxText */ :
                case 13 /* JsxTextAllWhiteSpaces */ :
                    return parseJsxText();
                case 19 /* OpenBraceToken */ :
                    return parseJsxExpression(/*inExpressionContext*/ false);
                case 30 /* LessThanToken */ :
                    return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ false, /*topInvalidNodePosition*/ void 0, openingTag);
                default:
                    return Debug.assertNever(token2);
            }
        }
        function parseJsxChildren(openingTag) {
            const list = [];
            const listPos = getNodePos();
            const saveParsingContext = parsingContext;
            parsingContext |= 16384 /* JsxChildren */ ;
            while(true){
                const child = parseJsxChild(openingTag, currentToken = scanner2.reScanJsxToken());
                if (!child) break;
                list.push(child);
                if (isJsxOpeningElement(openingTag) && (child == null ? void 0 : child.kind) === 285 /* JsxElement */  && !tagNamesAreEquivalent(child.openingElement.tagName, child.closingElement.tagName) && tagNamesAreEquivalent(openingTag.tagName, child.closingElement.tagName)) break;
            }
            parsingContext = saveParsingContext;
            return createNodeArray(list, listPos);
        }
        function parseJsxAttributes() {
            const pos = getNodePos();
            return finishNode(factory2.createJsxAttributes(parseList(13 /* JsxAttributes */ , parseJsxAttribute)), pos);
        }
        function parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext) {
            const pos = getNodePos();
            parseExpected(30 /* LessThanToken */ );
            if (token() === 32 /* GreaterThanToken */ ) {
                scanJsxText();
                return finishNode(factory2.createJsxOpeningFragment(), pos);
            }
            const tagName = parseJsxElementName();
            const typeArguments = (contextFlags & 524288 /* JavaScriptFile */ ) === 0 ? tryParseTypeArguments() : void 0;
            const attributes = parseJsxAttributes();
            let node;
            if (token() === 32 /* GreaterThanToken */ ) {
                scanJsxText();
                node = factory2.createJsxOpeningElement(tagName, typeArguments, attributes);
            } else {
                parseExpected(44 /* SlashToken */ );
                if (parseExpected(32 /* GreaterThanToken */ , /*diagnosticMessage*/ void 0, /*shouldAdvance*/ false)) {
                    if (inExpressionContext) nextToken();
                    else scanJsxText();
                }
                node = factory2.createJsxSelfClosingElement(tagName, typeArguments, attributes);
            }
            return finishNode(node, pos);
        }
        function parseJsxElementName() {
            const pos = getNodePos();
            const initialExpression = parseJsxTagName();
            if (isJsxNamespacedName(initialExpression)) return initialExpression;
            let expression = initialExpression;
            while(parseOptional(25 /* DotToken */ ))expression = finishNode(factoryCreatePropertyAccessExpression(expression, parseRightSideOfDot(/*allowIdentifierNames*/ true, /*allowPrivateIdentifiers*/ false, /*allowUnicodeEscapeSequenceInIdentifierName*/ false)), pos);
            return expression;
        }
        function parseJsxTagName() {
            const pos = getNodePos();
            scanJsxIdentifier();
            const isThis2 = token() === 110 /* ThisKeyword */ ;
            const tagName = parseIdentifierNameErrorOnUnicodeEscapeSequence();
            if (parseOptional(59 /* ColonToken */ )) {
                scanJsxIdentifier();
                return finishNode(factory2.createJsxNamespacedName(tagName, parseIdentifierNameErrorOnUnicodeEscapeSequence()), pos);
            }
            return isThis2 ? finishNode(factory2.createToken(110 /* ThisKeyword */ ), pos) : tagName;
        }
        function parseJsxExpression(inExpressionContext) {
            const pos = getNodePos();
            if (!parseExpected(19 /* OpenBraceToken */ )) return void 0;
            let dotDotDotToken;
            let expression;
            if (token() !== 20 /* CloseBraceToken */ ) {
                if (!inExpressionContext) dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
                expression = parseExpression();
            }
            if (inExpressionContext) parseExpected(20 /* CloseBraceToken */ );
            else if (parseExpected(20 /* CloseBraceToken */ , /*diagnosticMessage*/ void 0, /*shouldAdvance*/ false)) scanJsxText();
            return finishNode(factory2.createJsxExpression(dotDotDotToken, expression), pos);
        }
        function parseJsxAttribute() {
            if (token() === 19 /* OpenBraceToken */ ) return parseJsxSpreadAttribute();
            const pos = getNodePos();
            return finishNode(factory2.createJsxAttribute(parseJsxAttributeName(), parseJsxAttributeValue()), pos);
        }
        function parseJsxAttributeValue() {
            if (token() === 64 /* EqualsToken */ ) {
                if (scanJsxAttributeValue() === 11 /* StringLiteral */ ) return parseLiteralNode();
                if (token() === 19 /* OpenBraceToken */ ) return parseJsxExpression(/*inExpressionContext*/ true);
                if (token() === 30 /* LessThanToken */ ) return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true);
                parseErrorAtCurrentToken(Diagnostics.or_JSX_element_expected);
            }
            return void 0;
        }
        function parseJsxAttributeName() {
            const pos = getNodePos();
            scanJsxIdentifier();
            const attrName = parseIdentifierNameErrorOnUnicodeEscapeSequence();
            if (parseOptional(59 /* ColonToken */ )) {
                scanJsxIdentifier();
                return finishNode(factory2.createJsxNamespacedName(attrName, parseIdentifierNameErrorOnUnicodeEscapeSequence()), pos);
            }
            return attrName;
        }
        function parseJsxSpreadAttribute() {
            const pos = getNodePos();
            parseExpected(19 /* OpenBraceToken */ );
            parseExpected(26 /* DotDotDotToken */ );
            const expression = parseExpression();
            parseExpected(20 /* CloseBraceToken */ );
            return finishNode(factory2.createJsxSpreadAttribute(expression), pos);
        }
        function parseJsxClosingElement(open, inExpressionContext) {
            const pos = getNodePos();
            parseExpected(31 /* LessThanSlashToken */ );
            const tagName = parseJsxElementName();
            if (parseExpected(32 /* GreaterThanToken */ , /*diagnosticMessage*/ void 0, /*shouldAdvance*/ false)) {
                if (inExpressionContext || !tagNamesAreEquivalent(open.tagName, tagName)) nextToken();
                else scanJsxText();
            }
            return finishNode(factory2.createJsxClosingElement(tagName), pos);
        }
        function parseJsxClosingFragment(inExpressionContext) {
            const pos = getNodePos();
            parseExpected(31 /* LessThanSlashToken */ );
            if (parseExpected(32 /* GreaterThanToken */ , Diagnostics.Expected_corresponding_closing_tag_for_JSX_fragment, /*shouldAdvance*/ false)) {
                if (inExpressionContext) nextToken();
                else scanJsxText();
            }
            return finishNode(factory2.createJsxJsxClosingFragment(), pos);
        }
        function parseTypeAssertion() {
            Debug.assert(languageVariant !== 1 /* JSX */ , "Type assertions should never be parsed in JSX; they should be parsed as comparisons or JSX elements/fragments.");
            const pos = getNodePos();
            parseExpected(30 /* LessThanToken */ );
            const type = parseType();
            parseExpected(32 /* GreaterThanToken */ );
            const expression = parseSimpleUnaryExpression();
            return finishNode(factory2.createTypeAssertion(type, expression), pos);
        }
        function nextTokenIsIdentifierOrKeywordOrOpenBracketOrTemplate() {
            nextToken();
            return tokenIsIdentifierOrKeyword(token()) || token() === 23 /* OpenBracketToken */  || isTemplateStartOfTaggedTemplate();
        }
        function isStartOfOptionalPropertyOrElementAccessChain() {
            return token() === 29 /* QuestionDotToken */  && lookAhead(nextTokenIsIdentifierOrKeywordOrOpenBracketOrTemplate);
        }
        function tryReparseOptionalChain(node) {
            if (node.flags & 64 /* OptionalChain */ ) return true;
            if (isNonNullExpression(node)) {
                let expr = node.expression;
                while(isNonNullExpression(expr) && !(expr.flags & 64 /* OptionalChain */ ))expr = expr.expression;
                if (expr.flags & 64 /* OptionalChain */ ) {
                    while(isNonNullExpression(node)){
                        node.flags |= 64 /* OptionalChain */ ;
                        node = node.expression;
                    }
                    return true;
                }
            }
            return false;
        }
        function parsePropertyAccessExpressionRest(pos, expression, questionDotToken) {
            const name = parseRightSideOfDot(/*allowIdentifierNames*/ true, /*allowPrivateIdentifiers*/ true, /*allowUnicodeEscapeSequenceInIdentifierName*/ true);
            const isOptionalChain2 = questionDotToken || tryReparseOptionalChain(expression);
            const propertyAccess = isOptionalChain2 ? factoryCreatePropertyAccessChain(expression, questionDotToken, name) : factoryCreatePropertyAccessExpression(expression, name);
            if (isOptionalChain2 && isPrivateIdentifier(propertyAccess.name)) parseErrorAtRange(propertyAccess.name, Diagnostics.An_optional_chain_cannot_contain_private_identifiers);
            if (isExpressionWithTypeArguments(expression) && expression.typeArguments) {
                const pos2 = expression.typeArguments.pos - 1;
                const end = skipTrivia(sourceText, expression.typeArguments.end) + 1;
                parseErrorAt(pos2, end, Diagnostics.An_instantiation_expression_cannot_be_followed_by_a_property_access);
            }
            return finishNode(propertyAccess, pos);
        }
        function parseElementAccessExpressionRest(pos, expression, questionDotToken) {
            let argumentExpression;
            if (token() === 24 /* CloseBracketToken */ ) argumentExpression = createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.An_element_access_expression_should_take_an_argument);
            else {
                const argument = allowInAnd(parseExpression);
                if (isStringOrNumericLiteralLike(argument)) argument.text = internIdentifier(argument.text);
                argumentExpression = argument;
            }
            parseExpected(24 /* CloseBracketToken */ );
            const indexedAccess = questionDotToken || tryReparseOptionalChain(expression) ? factoryCreateElementAccessChain(expression, questionDotToken, argumentExpression) : factoryCreateElementAccessExpression(expression, argumentExpression);
            return finishNode(indexedAccess, pos);
        }
        function parseMemberExpressionRest(pos, expression, allowOptionalChain) {
            while(true){
                let questionDotToken;
                let isPropertyAccess = false;
                if (allowOptionalChain && isStartOfOptionalPropertyOrElementAccessChain()) {
                    questionDotToken = parseExpectedToken(29 /* QuestionDotToken */ );
                    isPropertyAccess = tokenIsIdentifierOrKeyword(token());
                } else isPropertyAccess = parseOptional(25 /* DotToken */ );
                if (isPropertyAccess) {
                    expression = parsePropertyAccessExpressionRest(pos, expression, questionDotToken);
                    continue;
                }
                if ((questionDotToken || !inDecoratorContext()) && parseOptional(23 /* OpenBracketToken */ )) {
                    expression = parseElementAccessExpressionRest(pos, expression, questionDotToken);
                    continue;
                }
                if (isTemplateStartOfTaggedTemplate()) {
                    expression = !questionDotToken && expression.kind === 234 /* ExpressionWithTypeArguments */  ? parseTaggedTemplateRest(pos, expression.expression, questionDotToken, expression.typeArguments) : parseTaggedTemplateRest(pos, expression, questionDotToken, /*typeArguments*/ void 0);
                    continue;
                }
                if (!questionDotToken) {
                    if (token() === 54 /* ExclamationToken */  && !scanner2.hasPrecedingLineBreak()) {
                        nextToken();
                        expression = finishNode(factory2.createNonNullExpression(expression), pos);
                        continue;
                    }
                    const typeArguments = tryParse(parseTypeArgumentsInExpression);
                    if (typeArguments) {
                        expression = finishNode(factory2.createExpressionWithTypeArguments(expression, typeArguments), pos);
                        continue;
                    }
                }
                return expression;
            }
        }
        function isTemplateStartOfTaggedTemplate() {
            return token() === 15 /* NoSubstitutionTemplateLiteral */  || token() === 16 /* TemplateHead */ ;
        }
        function parseTaggedTemplateRest(pos, tag, questionDotToken, typeArguments) {
            const tagExpression = factory2.createTaggedTemplateExpression(tag, typeArguments, token() === 15 /* NoSubstitutionTemplateLiteral */  ? (reScanTemplateToken(/*isTaggedTemplate*/ true), parseLiteralNode()) : parseTemplateExpression(/*isTaggedTemplate*/ true));
            if (questionDotToken || tag.flags & 64 /* OptionalChain */ ) tagExpression.flags |= 64 /* OptionalChain */ ;
            tagExpression.questionDotToken = questionDotToken;
            return finishNode(tagExpression, pos);
        }
        function parseCallExpressionRest(pos, expression) {
            while(true){
                expression = parseMemberExpressionRest(pos, expression, /*allowOptionalChain*/ true);
                let typeArguments;
                const questionDotToken = parseOptionalToken(29 /* QuestionDotToken */ );
                if (questionDotToken) {
                    typeArguments = tryParse(parseTypeArgumentsInExpression);
                    if (isTemplateStartOfTaggedTemplate()) {
                        expression = parseTaggedTemplateRest(pos, expression, questionDotToken, typeArguments);
                        continue;
                    }
                }
                if (typeArguments || token() === 21 /* OpenParenToken */ ) {
                    if (!questionDotToken && expression.kind === 234 /* ExpressionWithTypeArguments */ ) {
                        typeArguments = expression.typeArguments;
                        expression = expression.expression;
                    }
                    const argumentList = parseArgumentList();
                    const callExpr = questionDotToken || tryReparseOptionalChain(expression) ? factoryCreateCallChain(expression, questionDotToken, typeArguments, argumentList) : factoryCreateCallExpression(expression, typeArguments, argumentList);
                    expression = finishNode(callExpr, pos);
                    continue;
                }
                if (questionDotToken) {
                    const name = createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ false, Diagnostics.Identifier_expected);
                    expression = finishNode(factoryCreatePropertyAccessChain(expression, questionDotToken, name), pos);
                }
                break;
            }
            return expression;
        }
        function parseArgumentList() {
            parseExpected(21 /* OpenParenToken */ );
            const result = parseDelimitedList(11 /* ArgumentExpressions */ , parseArgumentExpression);
            parseExpected(22 /* CloseParenToken */ );
            return result;
        }
        function parseTypeArgumentsInExpression() {
            if ((contextFlags & 524288 /* JavaScriptFile */ ) !== 0) return void 0;
            if (reScanLessThanToken() !== 30 /* LessThanToken */ ) return void 0;
            nextToken();
            const typeArguments = parseDelimitedList(20 /* TypeArguments */ , parseType);
            if (reScanGreaterToken() !== 32 /* GreaterThanToken */ ) return void 0;
            nextToken();
            return typeArguments && canFollowTypeArgumentsInExpression() ? typeArguments : void 0;
        }
        function canFollowTypeArgumentsInExpression() {
            switch(token()){
                // These tokens can follow a type argument list in a call expression.
                case 21 /* OpenParenToken */ :
                // foo<x>(
                case 15 /* NoSubstitutionTemplateLiteral */ :
                // foo<T> `...`
                case 16 /* TemplateHead */ :
                    return true;
                // A type argument list followed by `<` never makes sense, and a type argument list followed
                // by `>` is ambiguous with a (re-scanned) `>>` operator, so we disqualify both. Also, in
                // this context, `+` and `-` are unary operators, not binary operators.
                case 30 /* LessThanToken */ :
                case 32 /* GreaterThanToken */ :
                case 40 /* PlusToken */ :
                case 41 /* MinusToken */ :
                    return false;
            }
            return scanner2.hasPrecedingLineBreak() || isBinaryOperator2() || !isStartOfExpression();
        }
        function parsePrimaryExpression() {
            switch(token()){
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    if (scanner2.getTokenFlags() & 26656 /* IsInvalid */ ) reScanTemplateToken(/*isTaggedTemplate*/ false);
                // falls through
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 11 /* StringLiteral */ :
                    return parseLiteralNode();
                case 110 /* ThisKeyword */ :
                case 108 /* SuperKeyword */ :
                case 106 /* NullKeyword */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                    return parseTokenNode();
                case 21 /* OpenParenToken */ :
                    return parseParenthesizedExpression();
                case 23 /* OpenBracketToken */ :
                    return parseArrayLiteralExpression();
                case 19 /* OpenBraceToken */ :
                    return parseObjectLiteralExpression();
                case 134 /* AsyncKeyword */ :
                    if (!lookAhead(nextTokenIsFunctionKeywordOnSameLine)) break;
                    return parseFunctionExpression();
                case 60 /* AtToken */ :
                    return parseDecoratedExpression();
                case 86 /* ClassKeyword */ :
                    return parseClassExpression();
                case 100 /* FunctionKeyword */ :
                    return parseFunctionExpression();
                case 105 /* NewKeyword */ :
                    return parseNewExpressionOrNewDotTarget();
                case 44 /* SlashToken */ :
                case 69 /* SlashEqualsToken */ :
                    if (reScanSlashToken() === 14 /* RegularExpressionLiteral */ ) return parseLiteralNode();
                    break;
                case 16 /* TemplateHead */ :
                    return parseTemplateExpression(/*isTaggedTemplate*/ false);
                case 81 /* PrivateIdentifier */ :
                    return parsePrivateIdentifier();
            }
            return parseIdentifier(Diagnostics.Expression_expected);
        }
        function parseParenthesizedExpression() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(21 /* OpenParenToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpected(22 /* CloseParenToken */ );
            return withJSDoc(finishNode(factoryCreateParenthesizedExpression(expression), pos), hasJSDoc);
        }
        function parseSpreadElement() {
            const pos = getNodePos();
            parseExpected(26 /* DotDotDotToken */ );
            const expression = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
            return finishNode(factory2.createSpreadElement(expression), pos);
        }
        function parseArgumentOrArrayLiteralElement() {
            return token() === 26 /* DotDotDotToken */  ? parseSpreadElement() : token() === 28 /* CommaToken */  ? finishNode(factory2.createOmittedExpression(), getNodePos()) : parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
        }
        function parseArgumentExpression() {
            return doOutsideOfContext(disallowInAndDecoratorContext, parseArgumentOrArrayLiteralElement);
        }
        function parseArrayLiteralExpression() {
            const pos = getNodePos();
            const openBracketPosition = scanner2.getTokenStart();
            const openBracketParsed = parseExpected(23 /* OpenBracketToken */ );
            const multiLine = scanner2.hasPrecedingLineBreak();
            const elements = parseDelimitedList(15 /* ArrayLiteralMembers */ , parseArgumentOrArrayLiteralElement);
            parseExpectedMatchingBrackets(23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ , openBracketParsed, openBracketPosition);
            return finishNode(factoryCreateArrayLiteralExpression(elements, multiLine), pos);
        }
        function parseObjectLiteralElement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            if (parseOptionalToken(26 /* DotDotDotToken */ )) {
                const expression = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
                return withJSDoc(finishNode(factory2.createSpreadAssignment(expression), pos), hasJSDoc);
            }
            const modifiers = parseModifiers(/*allowDecorators*/ true);
            if (parseContextualModifier(139 /* GetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 178 /* GetAccessor */ , 0 /* None */ );
            if (parseContextualModifier(153 /* SetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 179 /* SetAccessor */ , 0 /* None */ );
            const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
            const tokenIsIdentifier = isIdentifier2();
            const name = parsePropertyName();
            const questionToken = parseOptionalToken(58 /* QuestionToken */ );
            const exclamationToken = parseOptionalToken(54 /* ExclamationToken */ );
            if (asteriskToken || token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) return parseMethodDeclaration(pos, hasJSDoc, modifiers, asteriskToken, name, questionToken, exclamationToken);
            let node;
            const isShorthandPropertyAssignment2 = tokenIsIdentifier && token() !== 59 /* ColonToken */ ;
            if (isShorthandPropertyAssignment2) {
                const equalsToken = parseOptionalToken(64 /* EqualsToken */ );
                const objectAssignmentInitializer = equalsToken ? allowInAnd(()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true)) : void 0;
                node = factory2.createShorthandPropertyAssignment(name, objectAssignmentInitializer);
                node.equalsToken = equalsToken;
            } else {
                parseExpected(59 /* ColonToken */ );
                const initializer = allowInAnd(()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true));
                node = factory2.createPropertyAssignment(name, initializer);
            }
            node.modifiers = modifiers;
            node.questionToken = questionToken;
            node.exclamationToken = exclamationToken;
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseObjectLiteralExpression() {
            const pos = getNodePos();
            const openBracePosition = scanner2.getTokenStart();
            const openBraceParsed = parseExpected(19 /* OpenBraceToken */ );
            const multiLine = scanner2.hasPrecedingLineBreak();
            const properties = parseDelimitedList(12 /* ObjectLiteralMembers */ , parseObjectLiteralElement, /*considerSemicolonAsDelimiter*/ true);
            parseExpectedMatchingBrackets(19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , openBraceParsed, openBracePosition);
            return finishNode(factoryCreateObjectLiteralExpression(properties, multiLine), pos);
        }
        function parseFunctionExpression() {
            const savedDecoratorContext = inDecoratorContext();
            setDecoratorContext(/*val*/ false);
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = parseModifiers(/*allowDecorators*/ false);
            parseExpected(100 /* FunctionKeyword */ );
            const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
            const isGenerator = asteriskToken ? 1 /* Yield */  : 0 /* None */ ;
            const isAsync = some(modifiers, isAsyncModifier) ? 2 /* Await */  : 0 /* None */ ;
            const name = isGenerator && isAsync ? doInYieldAndAwaitContext(parseOptionalBindingIdentifier) : isGenerator ? doInYieldContext(parseOptionalBindingIdentifier) : isAsync ? doInAwaitContext(parseOptionalBindingIdentifier) : parseOptionalBindingIdentifier();
            const typeParameters = parseTypeParameters();
            const parameters = parseParameters(isGenerator | isAsync);
            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
            const body = parseFunctionBlock(isGenerator | isAsync);
            setDecoratorContext(savedDecoratorContext);
            const node = factory2.createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseOptionalBindingIdentifier() {
            return isBindingIdentifier() ? parseBindingIdentifier() : void 0;
        }
        function parseNewExpressionOrNewDotTarget() {
            const pos = getNodePos();
            parseExpected(105 /* NewKeyword */ );
            if (parseOptional(25 /* DotToken */ )) {
                const name = parseIdentifierName();
                return finishNode(factory2.createMetaProperty(105 /* NewKeyword */ , name), pos);
            }
            const expressionPos = getNodePos();
            let expression = parseMemberExpressionRest(expressionPos, parsePrimaryExpression(), /*allowOptionalChain*/ false);
            let typeArguments;
            if (expression.kind === 234 /* ExpressionWithTypeArguments */ ) {
                typeArguments = expression.typeArguments;
                expression = expression.expression;
            }
            if (token() === 29 /* QuestionDotToken */ ) parseErrorAtCurrentToken(Diagnostics.Invalid_optional_chain_from_new_expression_Did_you_mean_to_call_0, getTextOfNodeFromSourceText(sourceText, expression));
            const argumentList = token() === 21 /* OpenParenToken */  ? parseArgumentList() : void 0;
            return finishNode(factoryCreateNewExpression(expression, typeArguments, argumentList), pos);
        }
        function parseBlock(ignoreMissingOpenBrace, diagnosticMessage) {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const openBracePosition = scanner2.getTokenStart();
            const openBraceParsed = parseExpected(19 /* OpenBraceToken */ , diagnosticMessage);
            if (openBraceParsed || ignoreMissingOpenBrace) {
                const multiLine = scanner2.hasPrecedingLineBreak();
                const statements = parseList(1 /* BlockStatements */ , parseStatement);
                parseExpectedMatchingBrackets(19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , openBraceParsed, openBracePosition);
                const result = withJSDoc(finishNode(factoryCreateBlock(statements, multiLine), pos), hasJSDoc);
                if (token() === 64 /* EqualsToken */ ) {
                    parseErrorAtCurrentToken(Diagnostics.Declaration_or_statement_expected_This_follows_a_block_of_statements_so_if_you_intended_to_write_a_destructuring_assignment_you_might_need_to_wrap_the_whole_assignment_in_parentheses);
                    nextToken();
                }
                return result;
            } else {
                const statements = createMissingList();
                return withJSDoc(finishNode(factoryCreateBlock(statements, /*multiLine*/ void 0), pos), hasJSDoc);
            }
        }
        function parseFunctionBlock(flags, diagnosticMessage) {
            const savedYieldContext = inYieldContext();
            setYieldContext(!!(flags & 1 /* Yield */ ));
            const savedAwaitContext = inAwaitContext();
            setAwaitContext(!!(flags & 2 /* Await */ ));
            const savedTopLevel = topLevel;
            topLevel = false;
            const saveDecoratorContext = inDecoratorContext();
            if (saveDecoratorContext) setDecoratorContext(/*val*/ false);
            const block = parseBlock(!!(flags & 16 /* IgnoreMissingOpenBrace */ ), diagnosticMessage);
            if (saveDecoratorContext) setDecoratorContext(/*val*/ true);
            topLevel = savedTopLevel;
            setYieldContext(savedYieldContext);
            setAwaitContext(savedAwaitContext);
            return block;
        }
        function parseEmptyStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(27 /* SemicolonToken */ );
            return withJSDoc(finishNode(factory2.createEmptyStatement(), pos), hasJSDoc);
        }
        function parseIfStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(101 /* IfKeyword */ );
            const openParenPosition = scanner2.getTokenStart();
            const openParenParsed = parseExpected(21 /* OpenParenToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
            const thenStatement = parseStatement();
            const elseStatement = parseOptional(93 /* ElseKeyword */ ) ? parseStatement() : void 0;
            return withJSDoc(finishNode(factoryCreateIfStatement(expression, thenStatement, elseStatement), pos), hasJSDoc);
        }
        function parseDoStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(92 /* DoKeyword */ );
            const statement = parseStatement();
            parseExpected(117 /* WhileKeyword */ );
            const openParenPosition = scanner2.getTokenStart();
            const openParenParsed = parseExpected(21 /* OpenParenToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
            parseOptional(27 /* SemicolonToken */ );
            return withJSDoc(finishNode(factory2.createDoStatement(statement, expression), pos), hasJSDoc);
        }
        function parseWhileStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(117 /* WhileKeyword */ );
            const openParenPosition = scanner2.getTokenStart();
            const openParenParsed = parseExpected(21 /* OpenParenToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
            const statement = parseStatement();
            return withJSDoc(finishNode(factoryCreateWhileStatement(expression, statement), pos), hasJSDoc);
        }
        function parseForOrForInOrForOfStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(99 /* ForKeyword */ );
            const awaitToken = parseOptionalToken(135 /* AwaitKeyword */ );
            parseExpected(21 /* OpenParenToken */ );
            let initializer;
            if (token() !== 27 /* SemicolonToken */ ) {
                if (token() === 115 /* VarKeyword */  || token() === 121 /* LetKeyword */  || token() === 87 /* ConstKeyword */  || token() === 160 /* UsingKeyword */  && lookAhead(nextTokenIsBindingIdentifierOrStartOfDestructuringOnSameLineDisallowOf) || // this one is meant to allow of
                token() === 135 /* AwaitKeyword */  && lookAhead(nextTokenIsUsingKeywordThenBindingIdentifierOrStartOfObjectDestructuringOnSameLine)) initializer = parseVariableDeclarationList(/*inForStatementInitializer*/ true);
                else initializer = disallowInAnd(parseExpression);
            }
            let node;
            if (awaitToken ? parseExpected(165 /* OfKeyword */ ) : parseOptional(165 /* OfKeyword */ )) {
                const expression = allowInAnd(()=>parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true));
                parseExpected(22 /* CloseParenToken */ );
                node = factoryCreateForOfStatement(awaitToken, initializer, expression, parseStatement());
            } else if (parseOptional(103 /* InKeyword */ )) {
                const expression = allowInAnd(parseExpression);
                parseExpected(22 /* CloseParenToken */ );
                node = factory2.createForInStatement(initializer, expression, parseStatement());
            } else {
                parseExpected(27 /* SemicolonToken */ );
                const condition = token() !== 27 /* SemicolonToken */  && token() !== 22 /* CloseParenToken */  ? allowInAnd(parseExpression) : void 0;
                parseExpected(27 /* SemicolonToken */ );
                const incrementor = token() !== 22 /* CloseParenToken */  ? allowInAnd(parseExpression) : void 0;
                parseExpected(22 /* CloseParenToken */ );
                node = factoryCreateForStatement(initializer, condition, incrementor, parseStatement());
            }
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseBreakOrContinueStatement(kind) {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(kind === 253 /* BreakStatement */  ? 83 /* BreakKeyword */  : 88 /* ContinueKeyword */ );
            const label = canParseSemicolon() ? void 0 : parseIdentifier();
            parseSemicolon();
            const node = kind === 253 /* BreakStatement */  ? factory2.createBreakStatement(label) : factory2.createContinueStatement(label);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseReturnStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(107 /* ReturnKeyword */ );
            const expression = canParseSemicolon() ? void 0 : allowInAnd(parseExpression);
            parseSemicolon();
            return withJSDoc(finishNode(factory2.createReturnStatement(expression), pos), hasJSDoc);
        }
        function parseWithStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(118 /* WithKeyword */ );
            const openParenPosition = scanner2.getTokenStart();
            const openParenParsed = parseExpected(21 /* OpenParenToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpectedMatchingBrackets(21 /* OpenParenToken */ , 22 /* CloseParenToken */ , openParenParsed, openParenPosition);
            const statement = doInsideOfContext(67108864 /* InWithStatement */ , parseStatement);
            return withJSDoc(finishNode(factory2.createWithStatement(expression, statement), pos), hasJSDoc);
        }
        function parseCaseClause() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(84 /* CaseKeyword */ );
            const expression = allowInAnd(parseExpression);
            parseExpected(59 /* ColonToken */ );
            const statements = parseList(3 /* SwitchClauseStatements */ , parseStatement);
            return withJSDoc(finishNode(factory2.createCaseClause(expression, statements), pos), hasJSDoc);
        }
        function parseDefaultClause() {
            const pos = getNodePos();
            parseExpected(90 /* DefaultKeyword */ );
            parseExpected(59 /* ColonToken */ );
            const statements = parseList(3 /* SwitchClauseStatements */ , parseStatement);
            return finishNode(factory2.createDefaultClause(statements), pos);
        }
        function parseCaseOrDefaultClause() {
            return token() === 84 /* CaseKeyword */  ? parseCaseClause() : parseDefaultClause();
        }
        function parseCaseBlock() {
            const pos = getNodePos();
            parseExpected(19 /* OpenBraceToken */ );
            const clauses = parseList(2 /* SwitchClauses */ , parseCaseOrDefaultClause);
            parseExpected(20 /* CloseBraceToken */ );
            return finishNode(factory2.createCaseBlock(clauses), pos);
        }
        function parseSwitchStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(109 /* SwitchKeyword */ );
            parseExpected(21 /* OpenParenToken */ );
            const expression = allowInAnd(parseExpression);
            parseExpected(22 /* CloseParenToken */ );
            const caseBlock = parseCaseBlock();
            return withJSDoc(finishNode(factory2.createSwitchStatement(expression, caseBlock), pos), hasJSDoc);
        }
        function parseThrowStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(111 /* ThrowKeyword */ );
            let expression = scanner2.hasPrecedingLineBreak() ? void 0 : allowInAnd(parseExpression);
            if (expression === void 0) {
                identifierCount++;
                expression = finishNode(factoryCreateIdentifier(""), getNodePos());
            }
            if (!tryParseSemicolon()) parseErrorForMissingSemicolonAfter(expression);
            return withJSDoc(finishNode(factory2.createThrowStatement(expression), pos), hasJSDoc);
        }
        function parseTryStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(113 /* TryKeyword */ );
            const tryBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
            const catchClause = token() === 85 /* CatchKeyword */  ? parseCatchClause() : void 0;
            let finallyBlock;
            if (!catchClause || token() === 98 /* FinallyKeyword */ ) {
                parseExpected(98 /* FinallyKeyword */ , Diagnostics.catch_or_finally_expected);
                finallyBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
            }
            return withJSDoc(finishNode(factory2.createTryStatement(tryBlock, catchClause, finallyBlock), pos), hasJSDoc);
        }
        function parseCatchClause() {
            const pos = getNodePos();
            parseExpected(85 /* CatchKeyword */ );
            let variableDeclaration;
            if (parseOptional(21 /* OpenParenToken */ )) {
                variableDeclaration = parseVariableDeclaration();
                parseExpected(22 /* CloseParenToken */ );
            } else variableDeclaration = void 0;
            const block = parseBlock(/*ignoreMissingOpenBrace*/ false);
            return finishNode(factory2.createCatchClause(variableDeclaration, block), pos);
        }
        function parseDebuggerStatement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            parseExpected(89 /* DebuggerKeyword */ );
            parseSemicolon();
            return withJSDoc(finishNode(factory2.createDebuggerStatement(), pos), hasJSDoc);
        }
        function parseExpressionOrLabeledStatement() {
            const pos = getNodePos();
            let hasJSDoc = hasPrecedingJSDocComment();
            let node;
            const hasParen = token() === 21 /* OpenParenToken */ ;
            const expression = allowInAnd(parseExpression);
            if (isIdentifier(expression) && parseOptional(59 /* ColonToken */ )) node = factory2.createLabeledStatement(expression, parseStatement());
            else {
                if (!tryParseSemicolon()) parseErrorForMissingSemicolonAfter(expression);
                node = factoryCreateExpressionStatement(expression);
                if (hasParen) hasJSDoc = false;
            }
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function nextTokenIsIdentifierOrKeywordOnSameLine() {
            nextToken();
            return tokenIsIdentifierOrKeyword(token()) && !scanner2.hasPrecedingLineBreak();
        }
        function nextTokenIsClassKeywordOnSameLine() {
            nextToken();
            return token() === 86 /* ClassKeyword */  && !scanner2.hasPrecedingLineBreak();
        }
        function nextTokenIsFunctionKeywordOnSameLine() {
            nextToken();
            return token() === 100 /* FunctionKeyword */  && !scanner2.hasPrecedingLineBreak();
        }
        function nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine() {
            nextToken();
            return (tokenIsIdentifierOrKeyword(token()) || token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */  || token() === 11 /* StringLiteral */ ) && !scanner2.hasPrecedingLineBreak();
        }
        function isDeclaration2() {
            while(true)switch(token()){
                case 115 /* VarKeyword */ :
                case 121 /* LetKeyword */ :
                case 87 /* ConstKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 86 /* ClassKeyword */ :
                case 94 /* EnumKeyword */ :
                    return true;
                case 160 /* UsingKeyword */ :
                    return isUsingDeclaration();
                case 135 /* AwaitKeyword */ :
                    return isAwaitUsingDeclaration();
                // 'declare', 'module', 'namespace', 'interface'* and 'type' are all legal JavaScript identifiers;
                // however, an identifier cannot be followed by another identifier on the same line. This is what we
                // count on to parse out the respective declarations. For instance, we exploit this to say that
                //
                //    namespace n
                //
                // can be none other than the beginning of a namespace declaration, but need to respect that JavaScript sees
                //
                //    namespace
                //    n
                //
                // as the identifier 'namespace' on one line followed by the identifier 'n' on another.
                // We need to look one token ahead to see if it permissible to try parsing a declaration.
                //
                // *Note*: 'interface' is actually a strict mode reserved word. So while
                //
                //   "use strict"
                //   interface
                //   I {}
                //
                // could be legal, it would add complexity for very little gain.
                case 120 /* InterfaceKeyword */ :
                case 156 /* TypeKeyword */ :
                case 166 /* DeferKeyword */ :
                    return nextTokenIsIdentifierOnSameLine();
                case 144 /* ModuleKeyword */ :
                case 145 /* NamespaceKeyword */ :
                    return nextTokenIsIdentifierOrStringLiteralOnSameLine();
                case 128 /* AbstractKeyword */ :
                case 129 /* AccessorKeyword */ :
                case 134 /* AsyncKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 125 /* PublicKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                    const previousToken = token();
                    nextToken();
                    if (scanner2.hasPrecedingLineBreak()) return false;
                    if (previousToken === 138 /* DeclareKeyword */  && token() === 156 /* TypeKeyword */ ) return true;
                    continue;
                case 162 /* GlobalKeyword */ :
                    nextToken();
                    return token() === 19 /* OpenBraceToken */  || token() === 80 /* Identifier */  || token() === 95 /* ExportKeyword */ ;
                case 102 /* ImportKeyword */ :
                    nextToken();
                    return token() === 166 /* DeferKeyword */  || token() === 11 /* StringLiteral */  || token() === 42 /* AsteriskToken */  || token() === 19 /* OpenBraceToken */  || tokenIsIdentifierOrKeyword(token());
                case 95 /* ExportKeyword */ :
                    let currentToken2 = nextToken();
                    if (currentToken2 === 156 /* TypeKeyword */ ) currentToken2 = lookAhead(nextToken);
                    if (currentToken2 === 64 /* EqualsToken */  || currentToken2 === 42 /* AsteriskToken */  || currentToken2 === 19 /* OpenBraceToken */  || currentToken2 === 90 /* DefaultKeyword */  || currentToken2 === 130 /* AsKeyword */  || currentToken2 === 60 /* AtToken */ ) return true;
                    continue;
                case 126 /* StaticKeyword */ :
                    nextToken();
                    continue;
                default:
                    return false;
            }
        }
        function isStartOfDeclaration() {
            return lookAhead(isDeclaration2);
        }
        function isStartOfStatement() {
            switch(token()){
                case 60 /* AtToken */ :
                case 27 /* SemicolonToken */ :
                case 19 /* OpenBraceToken */ :
                case 115 /* VarKeyword */ :
                case 121 /* LetKeyword */ :
                case 160 /* UsingKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 86 /* ClassKeyword */ :
                case 94 /* EnumKeyword */ :
                case 101 /* IfKeyword */ :
                case 92 /* DoKeyword */ :
                case 117 /* WhileKeyword */ :
                case 99 /* ForKeyword */ :
                case 88 /* ContinueKeyword */ :
                case 83 /* BreakKeyword */ :
                case 107 /* ReturnKeyword */ :
                case 118 /* WithKeyword */ :
                case 109 /* SwitchKeyword */ :
                case 111 /* ThrowKeyword */ :
                case 113 /* TryKeyword */ :
                case 89 /* DebuggerKeyword */ :
                // 'catch' and 'finally' do not actually indicate that the code is part of a statement,
                // however, we say they are here so that we may gracefully parse them and error later.
                // falls through
                case 85 /* CatchKeyword */ :
                case 98 /* FinallyKeyword */ :
                    return true;
                case 102 /* ImportKeyword */ :
                    return isStartOfDeclaration() || lookAhead(nextTokenIsOpenParenOrLessThanOrDot);
                case 87 /* ConstKeyword */ :
                case 95 /* ExportKeyword */ :
                    return isStartOfDeclaration();
                case 134 /* AsyncKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 120 /* InterfaceKeyword */ :
                case 144 /* ModuleKeyword */ :
                case 145 /* NamespaceKeyword */ :
                case 156 /* TypeKeyword */ :
                case 162 /* GlobalKeyword */ :
                case 166 /* DeferKeyword */ :
                    return true;
                case 129 /* AccessorKeyword */ :
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 126 /* StaticKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                    return isStartOfDeclaration() || !lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
                default:
                    return isStartOfExpression();
            }
        }
        function nextTokenIsBindingIdentifierOrStartOfDestructuring() {
            nextToken();
            return isBindingIdentifier() || token() === 19 /* OpenBraceToken */  || token() === 23 /* OpenBracketToken */ ;
        }
        function isLetDeclaration() {
            return lookAhead(nextTokenIsBindingIdentifierOrStartOfDestructuring);
        }
        function nextTokenIsBindingIdentifierOrStartOfDestructuringOnSameLineDisallowOf() {
            return nextTokenIsBindingIdentifierOrStartOfDestructuringOnSameLine(/*disallowOf*/ true);
        }
        function nextTokenIsEqualsOrSemicolonOrColonToken() {
            nextToken();
            return token() === 64 /* EqualsToken */  || token() === 27 /* SemicolonToken */  || token() === 59 /* ColonToken */ ;
        }
        function nextTokenIsBindingIdentifierOrStartOfDestructuringOnSameLine(disallowOf) {
            nextToken();
            if (disallowOf && token() === 165 /* OfKeyword */ ) return lookAhead(nextTokenIsEqualsOrSemicolonOrColonToken);
            return (isBindingIdentifier() || token() === 19 /* OpenBraceToken */ ) && !scanner2.hasPrecedingLineBreak();
        }
        function isUsingDeclaration() {
            return lookAhead(nextTokenIsBindingIdentifierOrStartOfDestructuringOnSameLine);
        }
        function nextTokenIsUsingKeywordThenBindingIdentifierOrStartOfObjectDestructuringOnSameLine(disallowOf) {
            if (nextToken() === 160 /* UsingKeyword */ ) return nextTokenIsBindingIdentifierOrStartOfDestructuringOnSameLine(disallowOf);
            return false;
        }
        function isAwaitUsingDeclaration() {
            return lookAhead(nextTokenIsUsingKeywordThenBindingIdentifierOrStartOfObjectDestructuringOnSameLine);
        }
        function parseStatement() {
            switch(token()){
                case 27 /* SemicolonToken */ :
                    return parseEmptyStatement();
                case 19 /* OpenBraceToken */ :
                    return parseBlock(/*ignoreMissingOpenBrace*/ false);
                case 115 /* VarKeyword */ :
                    return parseVariableStatement(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                case 121 /* LetKeyword */ :
                    if (isLetDeclaration()) return parseVariableStatement(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                    break;
                case 135 /* AwaitKeyword */ :
                    if (isAwaitUsingDeclaration()) return parseVariableStatement(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                    break;
                case 160 /* UsingKeyword */ :
                    if (isUsingDeclaration()) return parseVariableStatement(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                    break;
                case 100 /* FunctionKeyword */ :
                    return parseFunctionDeclaration(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                case 86 /* ClassKeyword */ :
                    return parseClassDeclaration(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0);
                case 101 /* IfKeyword */ :
                    return parseIfStatement();
                case 92 /* DoKeyword */ :
                    return parseDoStatement();
                case 117 /* WhileKeyword */ :
                    return parseWhileStatement();
                case 99 /* ForKeyword */ :
                    return parseForOrForInOrForOfStatement();
                case 88 /* ContinueKeyword */ :
                    return parseBreakOrContinueStatement(252 /* ContinueStatement */ );
                case 83 /* BreakKeyword */ :
                    return parseBreakOrContinueStatement(253 /* BreakStatement */ );
                case 107 /* ReturnKeyword */ :
                    return parseReturnStatement();
                case 118 /* WithKeyword */ :
                    return parseWithStatement();
                case 109 /* SwitchKeyword */ :
                    return parseSwitchStatement();
                case 111 /* ThrowKeyword */ :
                    return parseThrowStatement();
                case 113 /* TryKeyword */ :
                // Include 'catch' and 'finally' for error recovery.
                // falls through
                case 85 /* CatchKeyword */ :
                case 98 /* FinallyKeyword */ :
                    return parseTryStatement();
                case 89 /* DebuggerKeyword */ :
                    return parseDebuggerStatement();
                case 60 /* AtToken */ :
                    return parseDeclaration();
                case 134 /* AsyncKeyword */ :
                case 120 /* InterfaceKeyword */ :
                case 156 /* TypeKeyword */ :
                case 144 /* ModuleKeyword */ :
                case 145 /* NamespaceKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 87 /* ConstKeyword */ :
                case 94 /* EnumKeyword */ :
                case 95 /* ExportKeyword */ :
                case 102 /* ImportKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 125 /* PublicKeyword */ :
                case 128 /* AbstractKeyword */ :
                case 129 /* AccessorKeyword */ :
                case 126 /* StaticKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                case 162 /* GlobalKeyword */ :
                    if (isStartOfDeclaration()) return parseDeclaration();
                    break;
            }
            return parseExpressionOrLabeledStatement();
        }
        function isDeclareModifier(modifier) {
            return modifier.kind === 138 /* DeclareKeyword */ ;
        }
        function parseDeclaration() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = parseModifiers(/*allowDecorators*/ true);
            const isAmbient = some(modifiers, isDeclareModifier);
            if (isAmbient) {
                const node = tryReuseAmbientDeclaration(pos);
                if (node) return node;
                for (const m of modifiers)m.flags |= 33554432 /* Ambient */ ;
                return doInsideOfContext(33554432 /* Ambient */ , ()=>parseDeclarationWorker(pos, hasJSDoc, modifiers));
            } else return parseDeclarationWorker(pos, hasJSDoc, modifiers);
        }
        function tryReuseAmbientDeclaration(pos) {
            return doInsideOfContext(33554432 /* Ambient */ , ()=>{
                const node = currentNode(parsingContext, pos);
                if (node) return consumeNode(node);
            });
        }
        function parseDeclarationWorker(pos, hasJSDoc, modifiersIn) {
            switch(token()){
                case 115 /* VarKeyword */ :
                case 121 /* LetKeyword */ :
                case 87 /* ConstKeyword */ :
                case 160 /* UsingKeyword */ :
                case 135 /* AwaitKeyword */ :
                    return parseVariableStatement(pos, hasJSDoc, modifiersIn);
                case 100 /* FunctionKeyword */ :
                    return parseFunctionDeclaration(pos, hasJSDoc, modifiersIn);
                case 86 /* ClassKeyword */ :
                    return parseClassDeclaration(pos, hasJSDoc, modifiersIn);
                case 120 /* InterfaceKeyword */ :
                    return parseInterfaceDeclaration(pos, hasJSDoc, modifiersIn);
                case 156 /* TypeKeyword */ :
                    return parseTypeAliasDeclaration(pos, hasJSDoc, modifiersIn);
                case 94 /* EnumKeyword */ :
                    return parseEnumDeclaration(pos, hasJSDoc, modifiersIn);
                case 162 /* GlobalKeyword */ :
                case 144 /* ModuleKeyword */ :
                case 145 /* NamespaceKeyword */ :
                    return parseModuleDeclaration(pos, hasJSDoc, modifiersIn);
                case 102 /* ImportKeyword */ :
                    return parseImportDeclarationOrImportEqualsDeclaration(pos, hasJSDoc, modifiersIn);
                case 95 /* ExportKeyword */ :
                    nextToken();
                    switch(token()){
                        case 90 /* DefaultKeyword */ :
                        case 64 /* EqualsToken */ :
                            return parseExportAssignment(pos, hasJSDoc, modifiersIn);
                        case 130 /* AsKeyword */ :
                            return parseNamespaceExportDeclaration(pos, hasJSDoc, modifiersIn);
                        default:
                            return parseExportDeclaration(pos, hasJSDoc, modifiersIn);
                    }
                default:
                    if (modifiersIn) {
                        const missing = createMissingNode(283 /* MissingDeclaration */ , /*reportAtCurrentPosition*/ true, Diagnostics.Declaration_expected);
                        setTextRangePos(missing, pos);
                        missing.modifiers = modifiersIn;
                        return missing;
                    }
                    return void 0;
            }
        }
        function nextTokenIsStringLiteral() {
            return nextToken() === 11 /* StringLiteral */ ;
        }
        function nextTokenIsFromKeywordOrEqualsToken() {
            nextToken();
            return token() === 161 /* FromKeyword */  || token() === 64 /* EqualsToken */ ;
        }
        function nextTokenIsIdentifierOrStringLiteralOnSameLine() {
            nextToken();
            return !scanner2.hasPrecedingLineBreak() && (isIdentifier2() || token() === 11 /* StringLiteral */ );
        }
        function parseFunctionBlockOrSemicolon(flags, diagnosticMessage) {
            if (token() !== 19 /* OpenBraceToken */ ) {
                if (flags & 4 /* Type */ ) {
                    parseTypeMemberSemicolon();
                    return;
                }
                if (canParseSemicolon()) {
                    parseSemicolon();
                    return;
                }
            }
            return parseFunctionBlock(flags, diagnosticMessage);
        }
        function parseArrayBindingElement() {
            const pos = getNodePos();
            if (token() === 28 /* CommaToken */ ) return finishNode(factory2.createOmittedExpression(), pos);
            const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
            const name = parseIdentifierOrPattern();
            const initializer = parseInitializer();
            return finishNode(factory2.createBindingElement(dotDotDotToken, /*propertyName*/ void 0, name, initializer), pos);
        }
        function parseObjectBindingElement() {
            const pos = getNodePos();
            const dotDotDotToken = parseOptionalToken(26 /* DotDotDotToken */ );
            const tokenIsIdentifier = isBindingIdentifier();
            let propertyName = parsePropertyName();
            let name;
            if (tokenIsIdentifier && token() !== 59 /* ColonToken */ ) {
                name = propertyName;
                propertyName = void 0;
            } else {
                parseExpected(59 /* ColonToken */ );
                name = parseIdentifierOrPattern();
            }
            const initializer = parseInitializer();
            return finishNode(factory2.createBindingElement(dotDotDotToken, propertyName, name, initializer), pos);
        }
        function parseObjectBindingPattern() {
            const pos = getNodePos();
            parseExpected(19 /* OpenBraceToken */ );
            const elements = allowInAnd(()=>parseDelimitedList(9 /* ObjectBindingElements */ , parseObjectBindingElement));
            parseExpected(20 /* CloseBraceToken */ );
            return finishNode(factory2.createObjectBindingPattern(elements), pos);
        }
        function parseArrayBindingPattern() {
            const pos = getNodePos();
            parseExpected(23 /* OpenBracketToken */ );
            const elements = allowInAnd(()=>parseDelimitedList(10 /* ArrayBindingElements */ , parseArrayBindingElement));
            parseExpected(24 /* CloseBracketToken */ );
            return finishNode(factory2.createArrayBindingPattern(elements), pos);
        }
        function isBindingIdentifierOrPrivateIdentifierOrPattern() {
            return token() === 19 /* OpenBraceToken */  || token() === 23 /* OpenBracketToken */  || token() === 81 /* PrivateIdentifier */  || isBindingIdentifier();
        }
        function parseIdentifierOrPattern(privateIdentifierDiagnosticMessage) {
            if (token() === 23 /* OpenBracketToken */ ) return parseArrayBindingPattern();
            if (token() === 19 /* OpenBraceToken */ ) return parseObjectBindingPattern();
            return parseBindingIdentifier(privateIdentifierDiagnosticMessage);
        }
        function parseVariableDeclarationAllowExclamation() {
            return parseVariableDeclaration(/*allowExclamation*/ true);
        }
        function parseVariableDeclaration(allowExclamation) {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const name = parseIdentifierOrPattern(Diagnostics.Private_identifiers_are_not_allowed_in_variable_declarations);
            let exclamationToken;
            if (allowExclamation && name.kind === 80 /* Identifier */  && token() === 54 /* ExclamationToken */  && !scanner2.hasPrecedingLineBreak()) exclamationToken = parseTokenNode();
            const type = parseTypeAnnotation();
            const initializer = isInOrOfKeyword(token()) ? void 0 : parseInitializer();
            const node = factoryCreateVariableDeclaration(name, exclamationToken, type, initializer);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseVariableDeclarationList(inForStatementInitializer) {
            const pos = getNodePos();
            let flags = 0;
            switch(token()){
                case 115 /* VarKeyword */ :
                    break;
                case 121 /* LetKeyword */ :
                    flags |= 1 /* Let */ ;
                    break;
                case 87 /* ConstKeyword */ :
                    flags |= 2 /* Const */ ;
                    break;
                case 160 /* UsingKeyword */ :
                    flags |= 4 /* Using */ ;
                    break;
                case 135 /* AwaitKeyword */ :
                    Debug.assert(isAwaitUsingDeclaration());
                    flags |= 6 /* AwaitUsing */ ;
                    nextToken();
                    break;
                default:
                    Debug.fail();
            }
            nextToken();
            let declarations;
            if (token() === 165 /* OfKeyword */  && lookAhead(canFollowContextualOfKeyword)) declarations = createMissingList();
            else {
                const savedDisallowIn = inDisallowInContext();
                setDisallowInContext(inForStatementInitializer);
                declarations = parseDelimitedList(8 /* VariableDeclarations */ , inForStatementInitializer ? parseVariableDeclaration : parseVariableDeclarationAllowExclamation);
                setDisallowInContext(savedDisallowIn);
            }
            return finishNode(factoryCreateVariableDeclarationList(declarations, flags), pos);
        }
        function canFollowContextualOfKeyword() {
            return nextTokenIsIdentifier() && nextToken() === 22 /* CloseParenToken */ ;
        }
        function parseVariableStatement(pos, hasJSDoc, modifiers) {
            const declarationList = parseVariableDeclarationList(/*inForStatementInitializer*/ false);
            parseSemicolon();
            const node = factoryCreateVariableStatement(modifiers, declarationList);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseFunctionDeclaration(pos, hasJSDoc, modifiers) {
            const savedAwaitContext = inAwaitContext();
            const modifierFlags = modifiersToFlags(modifiers);
            parseExpected(100 /* FunctionKeyword */ );
            const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
            const name = modifierFlags & 2048 /* Default */  ? parseOptionalBindingIdentifier() : parseBindingIdentifier();
            const isGenerator = asteriskToken ? 1 /* Yield */  : 0 /* None */ ;
            const isAsync = modifierFlags & 1024 /* Async */  ? 2 /* Await */  : 0 /* None */ ;
            const typeParameters = parseTypeParameters();
            if (modifierFlags & 32 /* Export */ ) setAwaitContext(/*value*/ true);
            const parameters = parseParameters(isGenerator | isAsync);
            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
            const body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, Diagnostics.or_expected);
            setAwaitContext(savedAwaitContext);
            const node = factory2.createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, body);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseConstructorName() {
            if (token() === 137 /* ConstructorKeyword */ ) return parseExpected(137 /* ConstructorKeyword */ );
            if (token() === 11 /* StringLiteral */  && lookAhead(nextToken) === 21 /* OpenParenToken */ ) return tryParse(()=>{
                const literalNode = parseLiteralNode();
                return literalNode.text === "constructor" ? literalNode : void 0;
            });
        }
        function tryParseConstructorDeclaration(pos, hasJSDoc, modifiers) {
            return tryParse(()=>{
                if (parseConstructorName()) {
                    const typeParameters = parseTypeParameters();
                    const parameters = parseParameters(0 /* None */ );
                    const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
                    const body = parseFunctionBlockOrSemicolon(0 /* None */ , Diagnostics.or_expected);
                    const node = factory2.createConstructorDeclaration(modifiers, parameters, body);
                    node.typeParameters = typeParameters;
                    node.type = type;
                    return withJSDoc(finishNode(node, pos), hasJSDoc);
                }
            });
        }
        function parseMethodDeclaration(pos, hasJSDoc, modifiers, asteriskToken, name, questionToken, exclamationToken, diagnosticMessage) {
            const isGenerator = asteriskToken ? 1 /* Yield */  : 0 /* None */ ;
            const isAsync = some(modifiers, isAsyncModifier) ? 2 /* Await */  : 0 /* None */ ;
            const typeParameters = parseTypeParameters();
            const parameters = parseParameters(isGenerator | isAsync);
            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
            const body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, diagnosticMessage);
            const node = factory2.createMethodDeclaration(modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body);
            node.exclamationToken = exclamationToken;
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parsePropertyDeclaration(pos, hasJSDoc, modifiers, name, questionToken) {
            const exclamationToken = !questionToken && !scanner2.hasPrecedingLineBreak() ? parseOptionalToken(54 /* ExclamationToken */ ) : void 0;
            const type = parseTypeAnnotation();
            const initializer = doOutsideOfContext(90112 /* DisallowInContext */ , parseInitializer);
            parseSemicolonAfterPropertyName(name, type, initializer);
            const node = factory2.createPropertyDeclaration(modifiers, name, questionToken || exclamationToken, type, initializer);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parsePropertyOrMethodDeclaration(pos, hasJSDoc, modifiers) {
            const asteriskToken = parseOptionalToken(42 /* AsteriskToken */ );
            const name = parsePropertyName();
            const questionToken = parseOptionalToken(58 /* QuestionToken */ );
            if (asteriskToken || token() === 21 /* OpenParenToken */  || token() === 30 /* LessThanToken */ ) return parseMethodDeclaration(pos, hasJSDoc, modifiers, asteriskToken, name, questionToken, /*exclamationToken*/ void 0, Diagnostics.or_expected);
            return parsePropertyDeclaration(pos, hasJSDoc, modifiers, name, questionToken);
        }
        function parseAccessorDeclaration(pos, hasJSDoc, modifiers, kind, flags) {
            const name = parsePropertyName();
            const typeParameters = parseTypeParameters();
            const parameters = parseParameters(0 /* None */ );
            const type = parseReturnType(59 /* ColonToken */ , /*isType*/ false);
            const body = parseFunctionBlockOrSemicolon(flags);
            const node = kind === 178 /* GetAccessor */  ? factory2.createGetAccessorDeclaration(modifiers, name, parameters, type, body) : factory2.createSetAccessorDeclaration(modifiers, name, parameters, body);
            node.typeParameters = typeParameters;
            if (isSetAccessorDeclaration(node)) node.type = type;
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function isClassMemberStart() {
            let idToken;
            if (token() === 60 /* AtToken */ ) return true;
            while(isModifierKind(token())){
                idToken = token();
                if (isClassMemberModifier(idToken)) return true;
                nextToken();
            }
            if (token() === 42 /* AsteriskToken */ ) return true;
            if (isLiteralPropertyName()) {
                idToken = token();
                nextToken();
            }
            if (token() === 23 /* OpenBracketToken */ ) return true;
            if (idToken !== void 0) {
                if (!isKeyword(idToken) || idToken === 153 /* SetKeyword */  || idToken === 139 /* GetKeyword */ ) return true;
                switch(token()){
                    case 21 /* OpenParenToken */ :
                    // Method declaration
                    case 30 /* LessThanToken */ :
                    // Generic Method declaration
                    case 54 /* ExclamationToken */ :
                    // Non-null assertion on property name
                    case 59 /* ColonToken */ :
                    // Type Annotation for declaration
                    case 64 /* EqualsToken */ :
                    // Initializer for declaration
                    case 58 /* QuestionToken */ :
                        return true;
                    default:
                        return canParseSemicolon();
                }
            }
            return false;
        }
        function parseClassStaticBlockDeclaration(pos, hasJSDoc, modifiers) {
            parseExpectedToken(126 /* StaticKeyword */ );
            const body = parseClassStaticBlockBody();
            const node = withJSDoc(finishNode(factory2.createClassStaticBlockDeclaration(body), pos), hasJSDoc);
            node.modifiers = modifiers;
            return node;
        }
        function parseClassStaticBlockBody() {
            const savedYieldContext = inYieldContext();
            const savedAwaitContext = inAwaitContext();
            setYieldContext(false);
            setAwaitContext(true);
            const body = parseBlock(/*ignoreMissingOpenBrace*/ false);
            setYieldContext(savedYieldContext);
            setAwaitContext(savedAwaitContext);
            return body;
        }
        function parseDecoratorExpression() {
            if (inAwaitContext() && token() === 135 /* AwaitKeyword */ ) {
                const pos = getNodePos();
                const awaitExpression = parseIdentifier(Diagnostics.Expression_expected);
                nextToken();
                const memberExpression = parseMemberExpressionRest(pos, awaitExpression, /*allowOptionalChain*/ true);
                return parseCallExpressionRest(pos, memberExpression);
            }
            return parseLeftHandSideExpressionOrHigher();
        }
        function tryParseDecorator() {
            const pos = getNodePos();
            if (!parseOptional(60 /* AtToken */ )) return void 0;
            const expression = doInDecoratorContext(parseDecoratorExpression);
            return finishNode(factory2.createDecorator(expression), pos);
        }
        function tryParseModifier(hasSeenStaticModifier, permitConstAsModifier, stopOnStartOfClassStaticBlock) {
            const pos = getNodePos();
            const kind = token();
            if (token() === 87 /* ConstKeyword */  && permitConstAsModifier) {
                if (!tryParse(nextTokenIsOnSameLineAndCanFollowModifier)) return void 0;
            } else if (stopOnStartOfClassStaticBlock && token() === 126 /* StaticKeyword */  && lookAhead(nextTokenIsOpenBrace)) return void 0;
            else if (hasSeenStaticModifier && token() === 126 /* StaticKeyword */ ) return void 0;
            else {
                if (!parseAnyContextualModifier()) return void 0;
            }
            return finishNode(factoryCreateToken(kind), pos);
        }
        function parseModifiers(allowDecorators, permitConstAsModifier, stopOnStartOfClassStaticBlock) {
            const pos = getNodePos();
            let list;
            let decorator, modifier, hasSeenStaticModifier = false, hasLeadingModifier = false, hasTrailingDecorator = false;
            if (allowDecorators && token() === 60 /* AtToken */ ) while(decorator = tryParseDecorator())list = append(list, decorator);
            while(modifier = tryParseModifier(hasSeenStaticModifier, permitConstAsModifier, stopOnStartOfClassStaticBlock)){
                if (modifier.kind === 126 /* StaticKeyword */ ) hasSeenStaticModifier = true;
                list = append(list, modifier);
                hasLeadingModifier = true;
            }
            if (hasLeadingModifier && allowDecorators && token() === 60 /* AtToken */ ) while(decorator = tryParseDecorator()){
                list = append(list, decorator);
                hasTrailingDecorator = true;
            }
            if (hasTrailingDecorator) while(modifier = tryParseModifier(hasSeenStaticModifier, permitConstAsModifier, stopOnStartOfClassStaticBlock)){
                if (modifier.kind === 126 /* StaticKeyword */ ) hasSeenStaticModifier = true;
                list = append(list, modifier);
            }
            return list && createNodeArray(list, pos);
        }
        function parseModifiersForArrowFunction() {
            let modifiers;
            if (token() === 134 /* AsyncKeyword */ ) {
                const pos = getNodePos();
                nextToken();
                const modifier = finishNode(factoryCreateToken(134 /* AsyncKeyword */ ), pos);
                modifiers = createNodeArray([
                    modifier
                ], pos);
            }
            return modifiers;
        }
        function parseClassElement() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            if (token() === 27 /* SemicolonToken */ ) {
                nextToken();
                return withJSDoc(finishNode(factory2.createSemicolonClassElement(), pos), hasJSDoc);
            }
            const modifiers = parseModifiers(/*allowDecorators*/ true, /*permitConstAsModifier*/ true, /*stopOnStartOfClassStaticBlock*/ true);
            if (token() === 126 /* StaticKeyword */  && lookAhead(nextTokenIsOpenBrace)) return parseClassStaticBlockDeclaration(pos, hasJSDoc, modifiers);
            if (parseContextualModifier(139 /* GetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 178 /* GetAccessor */ , 0 /* None */ );
            if (parseContextualModifier(153 /* SetKeyword */ )) return parseAccessorDeclaration(pos, hasJSDoc, modifiers, 179 /* SetAccessor */ , 0 /* None */ );
            if (token() === 137 /* ConstructorKeyword */  || token() === 11 /* StringLiteral */ ) {
                const constructorDeclaration = tryParseConstructorDeclaration(pos, hasJSDoc, modifiers);
                if (constructorDeclaration) return constructorDeclaration;
            }
            if (isIndexSignature()) return parseIndexSignatureDeclaration(pos, hasJSDoc, modifiers);
            if (tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */  || token() === 9 /* NumericLiteral */  || token() === 10 /* BigIntLiteral */  || token() === 42 /* AsteriskToken */  || token() === 23 /* OpenBracketToken */ ) {
                const isAmbient = some(modifiers, isDeclareModifier);
                if (isAmbient) {
                    for (const m of modifiers)m.flags |= 33554432 /* Ambient */ ;
                    return doInsideOfContext(33554432 /* Ambient */ , ()=>parsePropertyOrMethodDeclaration(pos, hasJSDoc, modifiers));
                } else return parsePropertyOrMethodDeclaration(pos, hasJSDoc, modifiers);
            }
            if (modifiers) {
                const name = createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ true, Diagnostics.Declaration_expected);
                return parsePropertyDeclaration(pos, hasJSDoc, modifiers, name, /*questionToken*/ void 0);
            }
            return Debug.fail("Should not have attempted to parse class member declaration.");
        }
        function parseDecoratedExpression() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const modifiers = parseModifiers(/*allowDecorators*/ true);
            if (token() === 86 /* ClassKeyword */ ) return parseClassDeclarationOrExpression(pos, hasJSDoc, modifiers, 232 /* ClassExpression */ );
            const missing = createMissingNode(283 /* MissingDeclaration */ , /*reportAtCurrentPosition*/ true, Diagnostics.Expression_expected);
            setTextRangePos(missing, pos);
            missing.modifiers = modifiers;
            return missing;
        }
        function parseClassExpression() {
            return parseClassDeclarationOrExpression(getNodePos(), hasPrecedingJSDocComment(), /*modifiers*/ void 0, 232 /* ClassExpression */ );
        }
        function parseClassDeclaration(pos, hasJSDoc, modifiers) {
            return parseClassDeclarationOrExpression(pos, hasJSDoc, modifiers, 264 /* ClassDeclaration */ );
        }
        function parseClassDeclarationOrExpression(pos, hasJSDoc, modifiers, kind) {
            const savedAwaitContext = inAwaitContext();
            parseExpected(86 /* ClassKeyword */ );
            const name = parseNameOfClassDeclarationOrExpression();
            const typeParameters = parseTypeParameters();
            if (some(modifiers, isExportModifier)) setAwaitContext(/*value*/ true);
            const heritageClauses = parseHeritageClauses();
            let members;
            if (parseExpected(19 /* OpenBraceToken */ )) {
                members = parseClassMembers();
                parseExpected(20 /* CloseBraceToken */ );
            } else members = createMissingList();
            setAwaitContext(savedAwaitContext);
            const node = kind === 264 /* ClassDeclaration */  ? factory2.createClassDeclaration(modifiers, name, typeParameters, heritageClauses, members) : factory2.createClassExpression(modifiers, name, typeParameters, heritageClauses, members);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseNameOfClassDeclarationOrExpression() {
            return isBindingIdentifier() && !isImplementsClause() ? createIdentifier(isBindingIdentifier()) : void 0;
        }
        function isImplementsClause() {
            return token() === 119 /* ImplementsKeyword */  && lookAhead(nextTokenIsIdentifierOrKeyword);
        }
        function parseHeritageClauses() {
            if (isHeritageClause2()) return parseList(22 /* HeritageClauses */ , parseHeritageClause);
            return void 0;
        }
        function parseHeritageClause() {
            const pos = getNodePos();
            const tok = token();
            Debug.assert(tok === 96 /* ExtendsKeyword */  || tok === 119 /* ImplementsKeyword */ );
            nextToken();
            const types = parseDelimitedList(7 /* HeritageClauseElement */ , parseExpressionWithTypeArguments);
            return finishNode(factory2.createHeritageClause(tok, types), pos);
        }
        function parseExpressionWithTypeArguments() {
            const pos = getNodePos();
            const expression = parseLeftHandSideExpressionOrHigher();
            if (expression.kind === 234 /* ExpressionWithTypeArguments */ ) return expression;
            const typeArguments = tryParseTypeArguments();
            return finishNode(factory2.createExpressionWithTypeArguments(expression, typeArguments), pos);
        }
        function tryParseTypeArguments() {
            return token() === 30 /* LessThanToken */  ? parseBracketedList(20 /* TypeArguments */ , parseType, 30 /* LessThanToken */ , 32 /* GreaterThanToken */ ) : void 0;
        }
        function isHeritageClause2() {
            return token() === 96 /* ExtendsKeyword */  || token() === 119 /* ImplementsKeyword */ ;
        }
        function parseClassMembers() {
            return parseList(5 /* ClassMembers */ , parseClassElement);
        }
        function parseInterfaceDeclaration(pos, hasJSDoc, modifiers) {
            parseExpected(120 /* InterfaceKeyword */ );
            const name = parseIdentifier();
            const typeParameters = parseTypeParameters();
            const heritageClauses = parseHeritageClauses();
            const members = parseObjectTypeMembers();
            const node = factory2.createInterfaceDeclaration(modifiers, name, typeParameters, heritageClauses, members);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseTypeAliasDeclaration(pos, hasJSDoc, modifiers) {
            parseExpected(156 /* TypeKeyword */ );
            if (scanner2.hasPrecedingLineBreak()) parseErrorAtCurrentToken(Diagnostics.Line_break_not_permitted_here);
            const name = parseIdentifier();
            const typeParameters = parseTypeParameters();
            parseExpected(64 /* EqualsToken */ );
            const type = token() === 141 /* IntrinsicKeyword */  && tryParse(parseKeywordAndNoDot) || parseType();
            parseSemicolon();
            const node = factory2.createTypeAliasDeclaration(modifiers, name, typeParameters, type);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseEnumMember() {
            const pos = getNodePos();
            const hasJSDoc = hasPrecedingJSDocComment();
            const name = parsePropertyName();
            const initializer = allowInAnd(parseInitializer);
            return withJSDoc(finishNode(factory2.createEnumMember(name, initializer), pos), hasJSDoc);
        }
        function parseEnumDeclaration(pos, hasJSDoc, modifiers) {
            parseExpected(94 /* EnumKeyword */ );
            const name = parseIdentifier();
            let members;
            if (parseExpected(19 /* OpenBraceToken */ )) {
                members = doOutsideOfYieldAndAwaitContext(()=>parseDelimitedList(6 /* EnumMembers */ , parseEnumMember));
                parseExpected(20 /* CloseBraceToken */ );
            } else members = createMissingList();
            const node = factory2.createEnumDeclaration(modifiers, name, members);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseModuleBlock() {
            const pos = getNodePos();
            let statements;
            if (parseExpected(19 /* OpenBraceToken */ )) {
                statements = parseList(1 /* BlockStatements */ , parseStatement);
                parseExpected(20 /* CloseBraceToken */ );
            } else statements = createMissingList();
            return finishNode(factory2.createModuleBlock(statements), pos);
        }
        function parseModuleOrNamespaceDeclaration(pos, hasJSDoc, modifiers, flags) {
            const namespaceFlag = flags & 32 /* Namespace */ ;
            const name = flags & 8 /* NestedNamespace */  ? parseIdentifierName() : parseIdentifier();
            const body = parseOptional(25 /* DotToken */ ) ? parseModuleOrNamespaceDeclaration(getNodePos(), /*hasJSDoc*/ false, /*modifiers*/ void 0, 8 /* NestedNamespace */  | namespaceFlag) : parseModuleBlock();
            const node = factory2.createModuleDeclaration(modifiers, name, body, flags);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseAmbientExternalModuleDeclaration(pos, hasJSDoc, modifiersIn) {
            let flags = 0;
            let name;
            if (token() === 162 /* GlobalKeyword */ ) {
                name = parseIdentifier();
                flags |= 2048 /* GlobalAugmentation */ ;
            } else {
                name = parseLiteralNode();
                name.text = internIdentifier(name.text);
            }
            let body;
            if (token() === 19 /* OpenBraceToken */ ) body = parseModuleBlock();
            else parseSemicolon();
            const node = factory2.createModuleDeclaration(modifiersIn, name, body, flags);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseModuleDeclaration(pos, hasJSDoc, modifiersIn) {
            let flags = 0;
            if (token() === 162 /* GlobalKeyword */ ) return parseAmbientExternalModuleDeclaration(pos, hasJSDoc, modifiersIn);
            else if (parseOptional(145 /* NamespaceKeyword */ )) flags |= 32 /* Namespace */ ;
            else {
                parseExpected(144 /* ModuleKeyword */ );
                if (token() === 11 /* StringLiteral */ ) return parseAmbientExternalModuleDeclaration(pos, hasJSDoc, modifiersIn);
            }
            return parseModuleOrNamespaceDeclaration(pos, hasJSDoc, modifiersIn, flags);
        }
        function isExternalModuleReference2() {
            return token() === 149 /* RequireKeyword */  && lookAhead(nextTokenIsOpenParen);
        }
        function nextTokenIsOpenParen() {
            return nextToken() === 21 /* OpenParenToken */ ;
        }
        function nextTokenIsOpenBrace() {
            return nextToken() === 19 /* OpenBraceToken */ ;
        }
        function nextTokenIsSlash() {
            return nextToken() === 44 /* SlashToken */ ;
        }
        function parseNamespaceExportDeclaration(pos, hasJSDoc, modifiers) {
            parseExpected(130 /* AsKeyword */ );
            parseExpected(145 /* NamespaceKeyword */ );
            const name = parseIdentifier();
            parseSemicolon();
            const node = factory2.createNamespaceExportDeclaration(name);
            node.modifiers = modifiers;
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseImportDeclarationOrImportEqualsDeclaration(pos, hasJSDoc, modifiers) {
            parseExpected(102 /* ImportKeyword */ );
            const afterImportPos = scanner2.getTokenFullStart();
            let identifier;
            if (isIdentifier2()) identifier = parseIdentifier();
            let phaseModifier;
            if ((identifier == null ? void 0 : identifier.escapedText) === "type" && (token() !== 161 /* FromKeyword */  || isIdentifier2() && lookAhead(nextTokenIsFromKeywordOrEqualsToken)) && (isIdentifier2() || tokenAfterImportDefinitelyProducesImportDeclaration())) {
                phaseModifier = 156 /* TypeKeyword */ ;
                identifier = isIdentifier2() ? parseIdentifier() : void 0;
            } else if ((identifier == null ? void 0 : identifier.escapedText) === "defer" && (token() === 161 /* FromKeyword */  ? !lookAhead(nextTokenIsStringLiteral) : token() !== 28 /* CommaToken */  && token() !== 64 /* EqualsToken */ )) {
                phaseModifier = 166 /* DeferKeyword */ ;
                identifier = isIdentifier2() ? parseIdentifier() : void 0;
            }
            if (identifier && !tokenAfterImportedIdentifierDefinitelyProducesImportDeclaration() && phaseModifier !== 166 /* DeferKeyword */ ) return parseImportEqualsDeclaration(pos, hasJSDoc, modifiers, identifier, phaseModifier === 156 /* TypeKeyword */ );
            const importClause = tryParseImportClause(identifier, afterImportPos, phaseModifier, /*skipJsDocLeadingAsterisks*/ void 0);
            const moduleSpecifier = parseModuleSpecifier();
            const attributes = tryParseImportAttributes();
            parseSemicolon();
            const node = factory2.createImportDeclaration(modifiers, importClause, moduleSpecifier, attributes);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function tryParseImportClause(identifier, pos, phaseModifier, skipJsDocLeadingAsterisks = false) {
            let importClause;
            if (identifier || // import id
            token() === 42 /* AsteriskToken */  || // import *
            token() === 19 /* OpenBraceToken */ ) {
                importClause = parseImportClause(identifier, pos, phaseModifier, skipJsDocLeadingAsterisks);
                parseExpected(161 /* FromKeyword */ );
            }
            return importClause;
        }
        function tryParseImportAttributes() {
            const currentToken2 = token();
            if ((currentToken2 === 118 /* WithKeyword */  || currentToken2 === 132 /* AssertKeyword */ ) && !scanner2.hasPrecedingLineBreak()) return parseImportAttributes(currentToken2);
        }
        function parseImportAttribute() {
            const pos = getNodePos();
            const name = tokenIsIdentifierOrKeyword(token()) ? parseIdentifierName() : parseLiteralLikeNode(11 /* StringLiteral */ );
            parseExpected(59 /* ColonToken */ );
            const value1 = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
            return finishNode(factory2.createImportAttribute(name, value1), pos);
        }
        function parseImportAttributes(token2, skipKeyword) {
            const pos = getNodePos();
            if (!skipKeyword) parseExpected(token2);
            const openBracePosition = scanner2.getTokenStart();
            if (parseExpected(19 /* OpenBraceToken */ )) {
                const multiLine = scanner2.hasPrecedingLineBreak();
                const elements = parseDelimitedList(24 /* ImportAttributes */ , parseImportAttribute, /*considerSemicolonAsDelimiter*/ true);
                if (!parseExpected(20 /* CloseBraceToken */ )) {
                    const lastError = lastOrUndefined(parseDiagnostics);
                    if (lastError && lastError.code === Diagnostics._0_expected.code) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, sourceText, openBracePosition, 1, Diagnostics.The_parser_expected_to_find_a_1_to_match_the_0_token_here, "{", "}"));
                }
                return finishNode(factory2.createImportAttributes(elements, multiLine, token2), pos);
            } else {
                const elements = createNodeArray([], getNodePos(), /*end*/ void 0, /*hasTrailingComma*/ false);
                return finishNode(factory2.createImportAttributes(elements, /*multiLine*/ false, token2), pos);
            }
        }
        function tokenAfterImportDefinitelyProducesImportDeclaration() {
            return token() === 42 /* AsteriskToken */  || token() === 19 /* OpenBraceToken */ ;
        }
        function tokenAfterImportedIdentifierDefinitelyProducesImportDeclaration() {
            return token() === 28 /* CommaToken */  || token() === 161 /* FromKeyword */ ;
        }
        function parseImportEqualsDeclaration(pos, hasJSDoc, modifiers, identifier, isTypeOnly) {
            parseExpected(64 /* EqualsToken */ );
            const moduleReference = parseModuleReference();
            parseSemicolon();
            const node = factory2.createImportEqualsDeclaration(modifiers, isTypeOnly, identifier, moduleReference);
            const finished = withJSDoc(finishNode(node, pos), hasJSDoc);
            return finished;
        }
        function parseImportClause(identifier, pos, phaseModifier, skipJsDocLeadingAsterisks) {
            let namedBindings;
            if (!identifier || parseOptional(28 /* CommaToken */ )) {
                if (skipJsDocLeadingAsterisks) scanner2.setSkipJsDocLeadingAsterisks(true);
                if (token() === 42 /* AsteriskToken */ ) namedBindings = parseNamespaceImport();
                else namedBindings = parseNamedImportsOrExports(276 /* NamedImports */ );
                if (skipJsDocLeadingAsterisks) scanner2.setSkipJsDocLeadingAsterisks(false);
            }
            return finishNode(factory2.createImportClause(phaseModifier, identifier, namedBindings), pos);
        }
        function parseModuleReference() {
            return isExternalModuleReference2() ? parseExternalModuleReference() : parseEntityName(/*allowReservedWords*/ false);
        }
        function parseExternalModuleReference() {
            const pos = getNodePos();
            parseExpected(149 /* RequireKeyword */ );
            parseExpected(21 /* OpenParenToken */ );
            const expression = parseModuleSpecifier();
            parseExpected(22 /* CloseParenToken */ );
            return finishNode(factory2.createExternalModuleReference(expression), pos);
        }
        function parseModuleSpecifier() {
            if (token() === 11 /* StringLiteral */ ) {
                const result = parseLiteralNode();
                result.text = internIdentifier(result.text);
                return result;
            } else return parseExpression();
        }
        function parseNamespaceImport() {
            const pos = getNodePos();
            parseExpected(42 /* AsteriskToken */ );
            parseExpected(130 /* AsKeyword */ );
            const name = parseIdentifier();
            return finishNode(factory2.createNamespaceImport(name), pos);
        }
        function canParseModuleExportName() {
            return tokenIsIdentifierOrKeyword(token()) || token() === 11 /* StringLiteral */ ;
        }
        function parseModuleExportName(parseName) {
            return token() === 11 /* StringLiteral */  ? parseLiteralNode() : parseName();
        }
        function parseNamedImportsOrExports(kind) {
            const pos = getNodePos();
            const node = kind === 276 /* NamedImports */  ? factory2.createNamedImports(parseBracketedList(23 /* ImportOrExportSpecifiers */ , parseImportSpecifier, 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ )) : factory2.createNamedExports(parseBracketedList(23 /* ImportOrExportSpecifiers */ , parseExportSpecifier, 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ ));
            return finishNode(node, pos);
        }
        function parseExportSpecifier() {
            const hasJSDoc = hasPrecedingJSDocComment();
            return withJSDoc(parseImportOrExportSpecifier(282 /* ExportSpecifier */ ), hasJSDoc);
        }
        function parseImportSpecifier() {
            return parseImportOrExportSpecifier(277 /* ImportSpecifier */ );
        }
        function parseImportOrExportSpecifier(kind) {
            const pos = getNodePos();
            let checkIdentifierIsKeyword = isKeyword(token()) && !isIdentifier2();
            let checkIdentifierStart = scanner2.getTokenStart();
            let checkIdentifierEnd = scanner2.getTokenEnd();
            let isTypeOnly = false;
            let propertyName;
            let canParseAsKeyword = true;
            let name = parseModuleExportName(parseIdentifierName);
            if (name.kind === 80 /* Identifier */  && name.escapedText === "type") {
                if (token() === 130 /* AsKeyword */ ) {
                    const firstAs = parseIdentifierName();
                    if (token() === 130 /* AsKeyword */ ) {
                        const secondAs = parseIdentifierName();
                        if (canParseModuleExportName()) {
                            isTypeOnly = true;
                            propertyName = firstAs;
                            name = parseModuleExportName(parseNameWithKeywordCheck);
                            canParseAsKeyword = false;
                        } else {
                            propertyName = name;
                            name = secondAs;
                            canParseAsKeyword = false;
                        }
                    } else if (canParseModuleExportName()) {
                        propertyName = name;
                        canParseAsKeyword = false;
                        name = parseModuleExportName(parseNameWithKeywordCheck);
                    } else {
                        isTypeOnly = true;
                        name = firstAs;
                    }
                } else if (canParseModuleExportName()) {
                    isTypeOnly = true;
                    name = parseModuleExportName(parseNameWithKeywordCheck);
                }
            }
            if (canParseAsKeyword && token() === 130 /* AsKeyword */ ) {
                propertyName = name;
                parseExpected(130 /* AsKeyword */ );
                name = parseModuleExportName(parseNameWithKeywordCheck);
            }
            if (kind === 277 /* ImportSpecifier */ ) {
                if (name.kind !== 80 /* Identifier */ ) {
                    parseErrorAt(skipTrivia(sourceText, name.pos), name.end, Diagnostics.Identifier_expected);
                    name = setTextRangePosEnd(createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ false), name.pos, name.pos);
                } else if (checkIdentifierIsKeyword) parseErrorAt(checkIdentifierStart, checkIdentifierEnd, Diagnostics.Identifier_expected);
            }
            const node = kind === 277 /* ImportSpecifier */  ? factory2.createImportSpecifier(isTypeOnly, propertyName, name) : factory2.createExportSpecifier(isTypeOnly, propertyName, name);
            return finishNode(node, pos);
            function parseNameWithKeywordCheck() {
                checkIdentifierIsKeyword = isKeyword(token()) && !isIdentifier2();
                checkIdentifierStart = scanner2.getTokenStart();
                checkIdentifierEnd = scanner2.getTokenEnd();
                return parseIdentifierName();
            }
        }
        function parseNamespaceExport(pos) {
            return finishNode(factory2.createNamespaceExport(parseModuleExportName(parseIdentifierName)), pos);
        }
        function parseExportDeclaration(pos, hasJSDoc, modifiers) {
            const savedAwaitContext = inAwaitContext();
            setAwaitContext(/*value*/ true);
            let exportClause;
            let moduleSpecifier;
            let attributes;
            const isTypeOnly = parseOptional(156 /* TypeKeyword */ );
            const namespaceExportPos = getNodePos();
            if (parseOptional(42 /* AsteriskToken */ )) {
                if (parseOptional(130 /* AsKeyword */ )) exportClause = parseNamespaceExport(namespaceExportPos);
                parseExpected(161 /* FromKeyword */ );
                moduleSpecifier = parseModuleSpecifier();
            } else {
                exportClause = parseNamedImportsOrExports(280 /* NamedExports */ );
                if (token() === 161 /* FromKeyword */  || token() === 11 /* StringLiteral */  && !scanner2.hasPrecedingLineBreak()) {
                    parseExpected(161 /* FromKeyword */ );
                    moduleSpecifier = parseModuleSpecifier();
                }
            }
            const currentToken2 = token();
            if (moduleSpecifier && (currentToken2 === 118 /* WithKeyword */  || currentToken2 === 132 /* AssertKeyword */ ) && !scanner2.hasPrecedingLineBreak()) attributes = parseImportAttributes(currentToken2);
            parseSemicolon();
            setAwaitContext(savedAwaitContext);
            const node = factory2.createExportDeclaration(modifiers, isTypeOnly, exportClause, moduleSpecifier, attributes);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        function parseExportAssignment(pos, hasJSDoc, modifiers) {
            const savedAwaitContext = inAwaitContext();
            setAwaitContext(/*value*/ true);
            let isExportEquals;
            if (parseOptional(64 /* EqualsToken */ )) isExportEquals = true;
            else parseExpected(90 /* DefaultKeyword */ );
            const expression = parseAssignmentExpressionOrHigher(/*allowReturnTypeInArrowFunction*/ true);
            parseSemicolon();
            setAwaitContext(savedAwaitContext);
            const node = factory2.createExportAssignment(modifiers, isExportEquals, expression);
            return withJSDoc(finishNode(node, pos), hasJSDoc);
        }
        let ParsingContext;
        ((ParsingContext2)=>{
            ParsingContext2[ParsingContext2["SourceElements"] = 0] = "SourceElements";
            ParsingContext2[ParsingContext2["BlockStatements"] = 1] = "BlockStatements";
            ParsingContext2[ParsingContext2["SwitchClauses"] = 2] = "SwitchClauses";
            ParsingContext2[ParsingContext2["SwitchClauseStatements"] = 3] = "SwitchClauseStatements";
            ParsingContext2[ParsingContext2["TypeMembers"] = 4] = "TypeMembers";
            ParsingContext2[ParsingContext2["ClassMembers"] = 5] = "ClassMembers";
            ParsingContext2[ParsingContext2["EnumMembers"] = 6] = "EnumMembers";
            ParsingContext2[ParsingContext2["HeritageClauseElement"] = 7] = "HeritageClauseElement";
            ParsingContext2[ParsingContext2["VariableDeclarations"] = 8] = "VariableDeclarations";
            ParsingContext2[ParsingContext2["ObjectBindingElements"] = 9] = "ObjectBindingElements";
            ParsingContext2[ParsingContext2["ArrayBindingElements"] = 10] = "ArrayBindingElements";
            ParsingContext2[ParsingContext2["ArgumentExpressions"] = 11] = "ArgumentExpressions";
            ParsingContext2[ParsingContext2["ObjectLiteralMembers"] = 12] = "ObjectLiteralMembers";
            ParsingContext2[ParsingContext2["JsxAttributes"] = 13] = "JsxAttributes";
            ParsingContext2[ParsingContext2["JsxChildren"] = 14] = "JsxChildren";
            ParsingContext2[ParsingContext2["ArrayLiteralMembers"] = 15] = "ArrayLiteralMembers";
            ParsingContext2[ParsingContext2["Parameters"] = 16] = "Parameters";
            ParsingContext2[ParsingContext2["JSDocParameters"] = 17] = "JSDocParameters";
            ParsingContext2[ParsingContext2["RestProperties"] = 18] = "RestProperties";
            ParsingContext2[ParsingContext2["TypeParameters"] = 19] = "TypeParameters";
            ParsingContext2[ParsingContext2["TypeArguments"] = 20] = "TypeArguments";
            ParsingContext2[ParsingContext2["TupleElementTypes"] = 21] = "TupleElementTypes";
            ParsingContext2[ParsingContext2["HeritageClauses"] = 22] = "HeritageClauses";
            ParsingContext2[ParsingContext2["ImportOrExportSpecifiers"] = 23] = "ImportOrExportSpecifiers";
            ParsingContext2[ParsingContext2["ImportAttributes"] = 24] = "ImportAttributes";
            ParsingContext2[ParsingContext2["JSDocComment"] = 25] = "JSDocComment";
            ParsingContext2[ParsingContext2["Count"] = 26] = "Count";
        })(ParsingContext || (ParsingContext = {}));
        let Tristate;
        ((Tristate2)=>{
            Tristate2[Tristate2["False"] = 0] = "False";
            Tristate2[Tristate2["True"] = 1] = "True";
            Tristate2[Tristate2["Unknown"] = 2] = "Unknown";
        })(Tristate || (Tristate = {}));
        let JSDocParser;
        ((JSDocParser2)=>{
            function parseJSDocTypeExpressionForTests2(content, start, length2) {
                initializeState("file.js", content, 99 /* Latest */ , /*syntaxCursor*/ void 0, 1 /* JS */ , 0 /* ParseAll */ );
                scanner2.setText(content, start, length2);
                currentToken = scanner2.scan();
                const jsDocTypeExpression = parseJSDocTypeExpression();
                const sourceFile = createSourceFile2("file.js", 99 /* Latest */ , 1 /* JS */ , /*isDeclarationFile*/ false, [], factoryCreateToken(1 /* EndOfFileToken */ ), 0 /* None */ , noop);
                const diagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
                if (jsDocDiagnostics) sourceFile.jsDocDiagnostics = attachFileToDiagnostics(jsDocDiagnostics, sourceFile);
                clearState();
                return jsDocTypeExpression ? {
                    jsDocTypeExpression,
                    diagnostics
                } : void 0;
            }
            JSDocParser2.parseJSDocTypeExpressionForTests = parseJSDocTypeExpressionForTests2;
            function parseJSDocTypeExpression(mayOmitBraces) {
                const pos = getNodePos();
                const hasBrace = (mayOmitBraces ? parseOptional : parseExpected)(19 /* OpenBraceToken */ );
                const type = doInsideOfContext(16777216 /* JSDoc */ , parseJSDocType);
                if (!mayOmitBraces || hasBrace) parseExpectedJSDoc(20 /* CloseBraceToken */ );
                const result = factory2.createJSDocTypeExpression(type);
                fixupParentReferences(result);
                return finishNode(result, pos);
            }
            JSDocParser2.parseJSDocTypeExpression = parseJSDocTypeExpression;
            function parseJSDocNameReference() {
                const pos = getNodePos();
                const hasBrace = parseOptional(19 /* OpenBraceToken */ );
                const p2 = getNodePos();
                let entityName = parseEntityName(/*allowReservedWords*/ false);
                while(token() === 81 /* PrivateIdentifier */ ){
                    reScanHashToken();
                    nextTokenJSDoc();
                    entityName = finishNode(factory2.createJSDocMemberName(entityName, parseIdentifier()), p2);
                }
                if (hasBrace) parseExpectedJSDoc(20 /* CloseBraceToken */ );
                const result = factory2.createJSDocNameReference(entityName);
                fixupParentReferences(result);
                return finishNode(result, pos);
            }
            JSDocParser2.parseJSDocNameReference = parseJSDocNameReference;
            function parseIsolatedJSDocComment2(content, start, length2) {
                initializeState("", content, 99 /* Latest */ , /*syntaxCursor*/ void 0, 1 /* JS */ , 0 /* ParseAll */ );
                const jsDoc = doInsideOfContext(16777216 /* JSDoc */ , ()=>parseJSDocCommentWorker(start, length2));
                const sourceFile = {
                    languageVariant: 0 /* Standard */ ,
                    text: content
                };
                const diagnostics = attachFileToDiagnostics(parseDiagnostics, sourceFile);
                clearState();
                return jsDoc ? {
                    jsDoc,
                    diagnostics
                } : void 0;
            }
            JSDocParser2.parseIsolatedJSDocComment = parseIsolatedJSDocComment2;
            function parseJSDocComment(parent2, start, length2) {
                const saveToken = currentToken;
                const saveParseDiagnosticsLength = parseDiagnostics.length;
                const saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
                const comment = doInsideOfContext(16777216 /* JSDoc */ , ()=>parseJSDocCommentWorker(start, length2));
                setParent(comment, parent2);
                if (contextFlags & 524288 /* JavaScriptFile */ ) {
                    if (!jsDocDiagnostics) jsDocDiagnostics = [];
                    addRange(jsDocDiagnostics, parseDiagnostics, saveParseDiagnosticsLength);
                }
                currentToken = saveToken;
                parseDiagnostics.length = saveParseDiagnosticsLength;
                parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
                return comment;
            }
            JSDocParser2.parseJSDocComment = parseJSDocComment;
            let JSDocState;
            ((JSDocState2)=>{
                JSDocState2[JSDocState2["BeginningOfLine"] = 0] = "BeginningOfLine";
                JSDocState2[JSDocState2["SawAsterisk"] = 1] = "SawAsterisk";
                JSDocState2[JSDocState2["SavingComments"] = 2] = "SavingComments";
                JSDocState2[JSDocState2["SavingBackticks"] = 3] = "SavingBackticks";
            })(JSDocState || (JSDocState = {}));
            let PropertyLikeParse;
            ((PropertyLikeParse2)=>{
                PropertyLikeParse2[PropertyLikeParse2["Property"] = 1] = "Property";
                PropertyLikeParse2[PropertyLikeParse2["Parameter"] = 2] = "Parameter";
                PropertyLikeParse2[PropertyLikeParse2["CallbackParameter"] = 4] = "CallbackParameter";
            })(PropertyLikeParse || (PropertyLikeParse = {}));
            function parseJSDocCommentWorker(start = 0, length2) {
                const content = sourceText;
                const end = length2 === void 0 ? content.length : start + length2;
                length2 = end - start;
                Debug.assert(start >= 0);
                Debug.assert(start <= end);
                Debug.assert(end <= content.length);
                if (!isJSDocLikeText(content, start)) return void 0;
                let tags;
                let tagsPos;
                let tagsEnd;
                let linkEnd;
                let commentsPos;
                let comments = [];
                const parts = [];
                const saveParsingContext = parsingContext;
                parsingContext |= 33554432 /* JSDocComment */ ;
                const result = scanner2.scanRange(start + 3, length2 - 5, doJSDocScan);
                parsingContext = saveParsingContext;
                return result;
                function doJSDocScan() {
                    let state = 1 /* SawAsterisk */ ;
                    let margin;
                    let indent3 = start - (content.lastIndexOf("\n", start) + 1) + 4;
                    function pushComment(text) {
                        if (!margin) margin = indent3;
                        comments.push(text);
                        indent3 += text.length;
                    }
                    nextTokenJSDoc();
                    while(parseOptionalJsdoc(5 /* WhitespaceTrivia */ ));
                    if (parseOptionalJsdoc(4 /* NewLineTrivia */ )) {
                        state = 0 /* BeginningOfLine */ ;
                        indent3 = 0;
                    }
                    loop: while(true){
                        switch(token()){
                            case 60 /* AtToken */ :
                                removeTrailingWhitespace(comments);
                                if (!commentsPos) commentsPos = getNodePos();
                                addTag(parseTag(indent3));
                                state = 0 /* BeginningOfLine */ ;
                                margin = void 0;
                                break;
                            case 4 /* NewLineTrivia */ :
                                comments.push(scanner2.getTokenText());
                                state = 0 /* BeginningOfLine */ ;
                                indent3 = 0;
                                break;
                            case 42 /* AsteriskToken */ :
                                const asterisk = scanner2.getTokenText();
                                if (state === 1 /* SawAsterisk */ ) {
                                    state = 2 /* SavingComments */ ;
                                    pushComment(asterisk);
                                } else {
                                    Debug.assert(state === 0 /* BeginningOfLine */ );
                                    state = 1 /* SawAsterisk */ ;
                                    indent3 += asterisk.length;
                                }
                                break;
                            case 5 /* WhitespaceTrivia */ :
                                Debug.assert(state !== 2 /* SavingComments */ , "whitespace shouldn't come from the scanner while saving top-level comment text");
                                const whitespace = scanner2.getTokenText();
                                if (margin !== void 0 && indent3 + whitespace.length > margin) comments.push(whitespace.slice(margin - indent3));
                                indent3 += whitespace.length;
                                break;
                            case 1 /* EndOfFileToken */ :
                                break loop;
                            case 82 /* JSDocCommentTextToken */ :
                                state = 2 /* SavingComments */ ;
                                pushComment(scanner2.getTokenValue());
                                break;
                            case 19 /* OpenBraceToken */ :
                                state = 2 /* SavingComments */ ;
                                const commentEnd = scanner2.getTokenFullStart();
                                const linkStart = scanner2.getTokenEnd() - 1;
                                const link = parseJSDocLink(linkStart);
                                if (link) {
                                    if (!linkEnd) removeLeadingNewlines(comments);
                                    parts.push(finishNode(factory2.createJSDocText(comments.join("")), linkEnd !== null && linkEnd !== void 0 ? linkEnd : start, commentEnd));
                                    parts.push(link);
                                    comments = [];
                                    linkEnd = scanner2.getTokenEnd();
                                    break;
                                }
                            // fallthrough if it's not a {@link sequence
                            default:
                                state = 2 /* SavingComments */ ;
                                pushComment(scanner2.getTokenText());
                                break;
                        }
                        if (state === 2 /* SavingComments */ ) nextJSDocCommentTextToken(/*inBackticks*/ false);
                        else nextTokenJSDoc();
                    }
                    const trimmedComments = comments.join("").trimEnd();
                    if (parts.length && trimmedComments.length) parts.push(finishNode(factory2.createJSDocText(trimmedComments), linkEnd !== null && linkEnd !== void 0 ? linkEnd : start, commentsPos));
                    if (parts.length && tags) Debug.assertIsDefined(commentsPos, "having parsed tags implies that the end of the comment span should be set");
                    const tagsArray = tags && createNodeArray(tags, tagsPos, tagsEnd);
                    return finishNode(factory2.createJSDocComment(parts.length ? createNodeArray(parts, start, commentsPos) : trimmedComments.length ? trimmedComments : void 0, tagsArray), start, end);
                }
                function removeLeadingNewlines(comments2) {
                    while(comments2.length && (comments2[0] === "\n" || comments2[0] === "\r"))comments2.shift();
                }
                function removeTrailingWhitespace(comments2) {
                    while(comments2.length){
                        const trimmed = comments2[comments2.length - 1].trimEnd();
                        if (trimmed === "") comments2.pop();
                        else if (trimmed.length < comments2[comments2.length - 1].length) {
                            comments2[comments2.length - 1] = trimmed;
                            break;
                        } else break;
                    }
                }
                function isNextNonwhitespaceTokenEndOfFile() {
                    while(true){
                        nextTokenJSDoc();
                        if (token() === 1 /* EndOfFileToken */ ) return true;
                        if (!(token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ )) return false;
                    }
                }
                function skipWhitespace() {
                    if (token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ ) {
                        if (lookAhead(isNextNonwhitespaceTokenEndOfFile)) return;
                    }
                    while(token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ )nextTokenJSDoc();
                }
                function skipWhitespaceOrAsterisk() {
                    if (token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ ) {
                        if (lookAhead(isNextNonwhitespaceTokenEndOfFile)) return "";
                    }
                    let precedingLineBreak = scanner2.hasPrecedingLineBreak();
                    let seenLineBreak = false;
                    let indentText = "";
                    while(precedingLineBreak && token() === 42 /* AsteriskToken */  || token() === 5 /* WhitespaceTrivia */  || token() === 4 /* NewLineTrivia */ ){
                        indentText += scanner2.getTokenText();
                        if (token() === 4 /* NewLineTrivia */ ) {
                            precedingLineBreak = true;
                            seenLineBreak = true;
                            indentText = "";
                        } else if (token() === 42 /* AsteriskToken */ ) precedingLineBreak = false;
                        nextTokenJSDoc();
                    }
                    return seenLineBreak ? indentText : "";
                }
                function parseTag(margin) {
                    Debug.assert(token() === 60 /* AtToken */ );
                    const start2 = scanner2.getTokenStart();
                    nextTokenJSDoc();
                    const tagName = parseJSDocIdentifierName(/*message*/ void 0);
                    const indentText = skipWhitespaceOrAsterisk();
                    let tag;
                    switch(tagName.escapedText){
                        case "author":
                            tag = parseAuthorTag(start2, tagName, margin, indentText);
                            break;
                        case "implements":
                            tag = parseImplementsTag(start2, tagName, margin, indentText);
                            break;
                        case "augments":
                        case "extends":
                            tag = parseAugmentsTag(start2, tagName, margin, indentText);
                            break;
                        case "class":
                        case "constructor":
                            tag = parseSimpleTag(start2, factory2.createJSDocClassTag, tagName, margin, indentText);
                            break;
                        case "public":
                            tag = parseSimpleTag(start2, factory2.createJSDocPublicTag, tagName, margin, indentText);
                            break;
                        case "private":
                            tag = parseSimpleTag(start2, factory2.createJSDocPrivateTag, tagName, margin, indentText);
                            break;
                        case "protected":
                            tag = parseSimpleTag(start2, factory2.createJSDocProtectedTag, tagName, margin, indentText);
                            break;
                        case "readonly":
                            tag = parseSimpleTag(start2, factory2.createJSDocReadonlyTag, tagName, margin, indentText);
                            break;
                        case "override":
                            tag = parseSimpleTag(start2, factory2.createJSDocOverrideTag, tagName, margin, indentText);
                            break;
                        case "deprecated":
                            hasDeprecatedTag = true;
                            tag = parseSimpleTag(start2, factory2.createJSDocDeprecatedTag, tagName, margin, indentText);
                            break;
                        case "this":
                            tag = parseThisTag(start2, tagName, margin, indentText);
                            break;
                        case "enum":
                            tag = parseEnumTag(start2, tagName, margin, indentText);
                            break;
                        case "arg":
                        case "argument":
                        case "param":
                            return parseParameterOrPropertyTag(start2, tagName, 2 /* Parameter */ , margin);
                        case "return":
                        case "returns":
                            tag = parseReturnTag(start2, tagName, margin, indentText);
                            break;
                        case "template":
                            tag = parseTemplateTag(start2, tagName, margin, indentText);
                            break;
                        case "type":
                            tag = parseTypeTag(start2, tagName, margin, indentText);
                            break;
                        case "typedef":
                            tag = parseTypedefTag(start2, tagName, margin, indentText);
                            break;
                        case "callback":
                            tag = parseCallbackTag(start2, tagName, margin, indentText);
                            break;
                        case "overload":
                            tag = parseOverloadTag(start2, tagName, margin, indentText);
                            break;
                        case "satisfies":
                            tag = parseSatisfiesTag(start2, tagName, margin, indentText);
                            break;
                        case "see":
                            tag = parseSeeTag(start2, tagName, margin, indentText);
                            break;
                        case "exception":
                        case "throws":
                            tag = parseThrowsTag(start2, tagName, margin, indentText);
                            break;
                        case "import":
                            tag = parseImportTag(start2, tagName, margin, indentText);
                            break;
                        default:
                            tag = parseUnknownTag(start2, tagName, margin, indentText);
                            break;
                    }
                    return tag;
                }
                function parseTrailingTagComments(pos, end2, margin, indentText) {
                    if (!indentText) margin += end2 - pos;
                    return parseTagComments(margin, indentText.slice(margin));
                }
                function parseTagComments(indent3, initialMargin) {
                    const commentsPos2 = getNodePos();
                    let comments2 = [];
                    const parts2 = [];
                    let linkEnd2;
                    let state = 0 /* BeginningOfLine */ ;
                    let margin;
                    function pushComment(text) {
                        if (!margin) margin = indent3;
                        comments2.push(text);
                        indent3 += text.length;
                    }
                    if (initialMargin !== void 0) {
                        if (initialMargin !== "") pushComment(initialMargin);
                        state = 1 /* SawAsterisk */ ;
                    }
                    let tok = token();
                    loop: while(true){
                        switch(tok){
                            case 4 /* NewLineTrivia */ :
                                state = 0 /* BeginningOfLine */ ;
                                comments2.push(scanner2.getTokenText());
                                indent3 = 0;
                                break;
                            case 60 /* AtToken */ :
                                scanner2.resetTokenState(scanner2.getTokenEnd() - 1);
                                break loop;
                            case 1 /* EndOfFileToken */ :
                                break loop;
                            case 5 /* WhitespaceTrivia */ :
                                Debug.assert(state !== 2 /* SavingComments */  && state !== 3 /* SavingBackticks */ , "whitespace shouldn't come from the scanner while saving comment text");
                                const whitespace = scanner2.getTokenText();
                                if (margin !== void 0 && indent3 + whitespace.length > margin) {
                                    comments2.push(whitespace.slice(margin - indent3));
                                    state = 2 /* SavingComments */ ;
                                }
                                indent3 += whitespace.length;
                                break;
                            case 19 /* OpenBraceToken */ :
                                state = 2 /* SavingComments */ ;
                                const commentEnd = scanner2.getTokenFullStart();
                                const linkStart = scanner2.getTokenEnd() - 1;
                                const link = parseJSDocLink(linkStart);
                                if (link) {
                                    parts2.push(finishNode(factory2.createJSDocText(comments2.join("")), linkEnd2 !== null && linkEnd2 !== void 0 ? linkEnd2 : commentsPos2, commentEnd));
                                    parts2.push(link);
                                    comments2 = [];
                                    linkEnd2 = scanner2.getTokenEnd();
                                } else pushComment(scanner2.getTokenText());
                                break;
                            case 62 /* BacktickToken */ :
                                if (state === 3 /* SavingBackticks */ ) state = 2 /* SavingComments */ ;
                                else state = 3 /* SavingBackticks */ ;
                                pushComment(scanner2.getTokenText());
                                break;
                            case 82 /* JSDocCommentTextToken */ :
                                if (state !== 3 /* SavingBackticks */ ) state = 2 /* SavingComments */ ;
                                pushComment(scanner2.getTokenValue());
                                break;
                            case 42 /* AsteriskToken */ :
                                if (state === 0 /* BeginningOfLine */ ) {
                                    state = 1 /* SawAsterisk */ ;
                                    indent3 += 1;
                                    break;
                                }
                            // record the * as a comment
                            // falls through
                            default:
                                if (state !== 3 /* SavingBackticks */ ) state = 2 /* SavingComments */ ;
                                pushComment(scanner2.getTokenText());
                                break;
                        }
                        if (state === 2 /* SavingComments */  || state === 3 /* SavingBackticks */ ) tok = nextJSDocCommentTextToken(state === 3 /* SavingBackticks */ );
                        else tok = nextTokenJSDoc();
                    }
                    removeLeadingNewlines(comments2);
                    const trimmedComments = comments2.join("").trimEnd();
                    if (parts2.length) {
                        if (trimmedComments.length) parts2.push(finishNode(factory2.createJSDocText(trimmedComments), linkEnd2 !== null && linkEnd2 !== void 0 ? linkEnd2 : commentsPos2));
                        return createNodeArray(parts2, commentsPos2, scanner2.getTokenEnd());
                    } else if (trimmedComments.length) return trimmedComments;
                }
                function parseJSDocLink(start2) {
                    const linkType = tryParse(parseJSDocLinkPrefix);
                    if (!linkType) return void 0;
                    nextTokenJSDoc();
                    skipWhitespace();
                    const name = parseJSDocLinkName();
                    const text = [];
                    while(token() !== 20 /* CloseBraceToken */  && token() !== 4 /* NewLineTrivia */  && token() !== 1 /* EndOfFileToken */ ){
                        text.push(scanner2.getTokenText());
                        nextTokenJSDoc();
                    }
                    const create = linkType === "link" ? factory2.createJSDocLink : linkType === "linkcode" ? factory2.createJSDocLinkCode : factory2.createJSDocLinkPlain;
                    return finishNode(create(name, text.join("")), start2, scanner2.getTokenEnd());
                }
                function parseJSDocLinkName() {
                    if (tokenIsIdentifierOrKeyword(token())) {
                        const pos = getNodePos();
                        let name = parseIdentifierName();
                        while(parseOptional(25 /* DotToken */ ))name = finishNode(factory2.createQualifiedName(name, token() === 81 /* PrivateIdentifier */  ? createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ false) : parseIdentifierName()), pos);
                        while(token() === 81 /* PrivateIdentifier */ ){
                            reScanHashToken();
                            nextTokenJSDoc();
                            name = finishNode(factory2.createJSDocMemberName(name, parseIdentifier()), pos);
                        }
                        return name;
                    }
                    return void 0;
                }
                function parseJSDocLinkPrefix() {
                    skipWhitespaceOrAsterisk();
                    if (token() === 19 /* OpenBraceToken */  && nextTokenJSDoc() === 60 /* AtToken */  && tokenIsIdentifierOrKeyword(nextTokenJSDoc())) {
                        const kind = scanner2.getTokenValue();
                        if (isJSDocLinkTag(kind)) return kind;
                    }
                }
                function isJSDocLinkTag(kind) {
                    return kind === "link" || kind === "linkcode" || kind === "linkplain";
                }
                function parseUnknownTag(start2, tagName, indent3, indentText) {
                    return finishNode(factory2.createJSDocUnknownTag(tagName, parseTrailingTagComments(start2, getNodePos(), indent3, indentText)), start2);
                }
                function addTag(tag) {
                    if (!tag) return;
                    if (!tags) {
                        tags = [
                            tag
                        ];
                        tagsPos = tag.pos;
                    } else tags.push(tag);
                    tagsEnd = tag.end;
                }
                function tryParseTypeExpression() {
                    skipWhitespaceOrAsterisk();
                    return token() === 19 /* OpenBraceToken */  ? parseJSDocTypeExpression() : void 0;
                }
                function parseBracketNameInPropertyAndParamTag() {
                    const isBracketed = parseOptionalJsdoc(23 /* OpenBracketToken */ );
                    if (isBracketed) skipWhitespace();
                    const isBackquoted = parseOptionalJsdoc(62 /* BacktickToken */ );
                    const name = parseJSDocEntityName();
                    if (isBackquoted) parseExpectedTokenJSDoc(62 /* BacktickToken */ );
                    if (isBracketed) {
                        skipWhitespace();
                        if (parseOptionalToken(64 /* EqualsToken */ )) parseExpression();
                        parseExpected(24 /* CloseBracketToken */ );
                    }
                    return {
                        name,
                        isBracketed
                    };
                }
                function isObjectOrObjectArrayTypeReference(node) {
                    switch(node.kind){
                        case 151 /* ObjectKeyword */ :
                            return true;
                        case 189 /* ArrayType */ :
                            return isObjectOrObjectArrayTypeReference(node.elementType);
                        default:
                            return isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "Object" && !node.typeArguments;
                    }
                }
                function parseParameterOrPropertyTag(start2, tagName, target, indent3) {
                    let typeExpression = tryParseTypeExpression();
                    let isNameFirst = !typeExpression;
                    skipWhitespaceOrAsterisk();
                    const { name, isBracketed } = parseBracketNameInPropertyAndParamTag();
                    const indentText = skipWhitespaceOrAsterisk();
                    if (isNameFirst && !lookAhead(parseJSDocLinkPrefix)) typeExpression = tryParseTypeExpression();
                    const comment = parseTrailingTagComments(start2, getNodePos(), indent3, indentText);
                    const nestedTypeLiteral = parseNestedTypeLiteral(typeExpression, name, target, indent3);
                    if (nestedTypeLiteral) {
                        typeExpression = nestedTypeLiteral;
                        isNameFirst = true;
                    }
                    const result2 = target === 1 /* Property */  ? factory2.createJSDocPropertyTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment) : factory2.createJSDocParameterTag(tagName, name, isBracketed, typeExpression, isNameFirst, comment);
                    return finishNode(result2, start2);
                }
                function parseNestedTypeLiteral(typeExpression, name, target, indent3) {
                    if (typeExpression && isObjectOrObjectArrayTypeReference(typeExpression.type)) {
                        const pos = getNodePos();
                        let child;
                        let children;
                        while(child = tryParse(()=>parseChildParameterOrPropertyTag(target, indent3, name))){
                            if (child.kind === 342 /* JSDocParameterTag */  || child.kind === 349 /* JSDocPropertyTag */ ) children = append(children, child);
                            else if (child.kind === 346 /* JSDocTemplateTag */ ) parseErrorAtRange(child.tagName, Diagnostics.A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag);
                        }
                        if (children) {
                            const literal = finishNode(factory2.createJSDocTypeLiteral(children, typeExpression.type.kind === 189 /* ArrayType */ ), pos);
                            return finishNode(factory2.createJSDocTypeExpression(literal), pos);
                        }
                    }
                }
                function parseReturnTag(start2, tagName, indent3, indentText) {
                    if (some(tags, isJSDocReturnTag)) parseErrorAt(tagName.pos, scanner2.getTokenStart(), Diagnostics._0_tag_already_specified, unescapeLeadingUnderscores(tagName.escapedText));
                    const typeExpression = tryParseTypeExpression();
                    return finishNode(factory2.createJSDocReturnTag(tagName, typeExpression, parseTrailingTagComments(start2, getNodePos(), indent3, indentText)), start2);
                }
                function parseTypeTag(start2, tagName, indent3, indentText) {
                    if (some(tags, isJSDocTypeTag)) parseErrorAt(tagName.pos, scanner2.getTokenStart(), Diagnostics._0_tag_already_specified, unescapeLeadingUnderscores(tagName.escapedText));
                    const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
                    const comments2 = indent3 !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), indent3, indentText) : void 0;
                    return finishNode(factory2.createJSDocTypeTag(tagName, typeExpression, comments2), start2);
                }
                function parseSeeTag(start2, tagName, indent3, indentText) {
                    const isMarkdownOrJSDocLink = token() === 23 /* OpenBracketToken */  || lookAhead(()=>nextTokenJSDoc() === 60 /* AtToken */  && tokenIsIdentifierOrKeyword(nextTokenJSDoc()) && isJSDocLinkTag(scanner2.getTokenValue()));
                    const nameExpression = isMarkdownOrJSDocLink ? void 0 : parseJSDocNameReference();
                    const comments2 = indent3 !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), indent3, indentText) : void 0;
                    return finishNode(factory2.createJSDocSeeTag(tagName, nameExpression, comments2), start2);
                }
                function parseThrowsTag(start2, tagName, indent3, indentText) {
                    const typeExpression = tryParseTypeExpression();
                    const comment = parseTrailingTagComments(start2, getNodePos(), indent3, indentText);
                    return finishNode(factory2.createJSDocThrowsTag(tagName, typeExpression, comment), start2);
                }
                function parseAuthorTag(start2, tagName, indent3, indentText) {
                    const commentStart = getNodePos();
                    const textOnly = parseAuthorNameAndEmail();
                    let commentEnd = scanner2.getTokenFullStart();
                    const comments2 = parseTrailingTagComments(start2, commentEnd, indent3, indentText);
                    if (!comments2) commentEnd = scanner2.getTokenFullStart();
                    const allParts = typeof comments2 !== "string" ? createNodeArray(concatenate([
                        finishNode(textOnly, commentStart, commentEnd)
                    ], comments2), commentStart) : textOnly.text + comments2;
                    return finishNode(factory2.createJSDocAuthorTag(tagName, allParts), start2);
                }
                function parseAuthorNameAndEmail() {
                    const comments2 = [];
                    let inEmail = false;
                    let token2 = scanner2.getToken();
                    while(token2 !== 1 /* EndOfFileToken */  && token2 !== 4 /* NewLineTrivia */ ){
                        if (token2 === 30 /* LessThanToken */ ) inEmail = true;
                        else if (token2 === 60 /* AtToken */  && !inEmail) break;
                        else if (token2 === 32 /* GreaterThanToken */  && inEmail) {
                            comments2.push(scanner2.getTokenText());
                            scanner2.resetTokenState(scanner2.getTokenEnd());
                            break;
                        }
                        comments2.push(scanner2.getTokenText());
                        token2 = nextTokenJSDoc();
                    }
                    return factory2.createJSDocText(comments2.join(""));
                }
                function parseImplementsTag(start2, tagName, margin, indentText) {
                    const className = parseExpressionWithTypeArgumentsForAugments();
                    return finishNode(factory2.createJSDocImplementsTag(tagName, className, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                }
                function parseAugmentsTag(start2, tagName, margin, indentText) {
                    const className = parseExpressionWithTypeArgumentsForAugments();
                    return finishNode(factory2.createJSDocAugmentsTag(tagName, className, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                }
                function parseSatisfiesTag(start2, tagName, margin, indentText) {
                    const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ false);
                    const comments2 = margin !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), margin, indentText) : void 0;
                    return finishNode(factory2.createJSDocSatisfiesTag(tagName, typeExpression, comments2), start2);
                }
                function parseImportTag(start2, tagName, margin, indentText) {
                    const afterImportTagPos = scanner2.getTokenFullStart();
                    let identifier;
                    if (isIdentifier2()) identifier = parseIdentifier();
                    const importClause = tryParseImportClause(identifier, afterImportTagPos, 156 /* TypeKeyword */ , /*skipJsDocLeadingAsterisks*/ true);
                    const moduleSpecifier = parseModuleSpecifier();
                    const attributes = tryParseImportAttributes();
                    const comments2 = margin !== void 0 && indentText !== void 0 ? parseTrailingTagComments(start2, getNodePos(), margin, indentText) : void 0;
                    return finishNode(factory2.createJSDocImportTag(tagName, importClause, moduleSpecifier, attributes, comments2), start2);
                }
                function parseExpressionWithTypeArgumentsForAugments() {
                    const usedBrace = parseOptional(19 /* OpenBraceToken */ );
                    const pos = getNodePos();
                    const expression = parsePropertyAccessEntityNameExpression();
                    scanner2.setSkipJsDocLeadingAsterisks(true);
                    const typeArguments = tryParseTypeArguments();
                    scanner2.setSkipJsDocLeadingAsterisks(false);
                    const node = factory2.createExpressionWithTypeArguments(expression, typeArguments);
                    const res = finishNode(node, pos);
                    if (usedBrace) {
                        skipWhitespace();
                        parseExpected(20 /* CloseBraceToken */ );
                    }
                    return res;
                }
                function parsePropertyAccessEntityNameExpression() {
                    const pos = getNodePos();
                    let node = parseJSDocIdentifierName();
                    while(parseOptional(25 /* DotToken */ )){
                        const name = parseJSDocIdentifierName();
                        node = finishNode(factoryCreatePropertyAccessExpression(node, name), pos);
                    }
                    return node;
                }
                function parseSimpleTag(start2, createTag, tagName, margin, indentText) {
                    return finishNode(createTag(tagName, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                }
                function parseThisTag(start2, tagName, margin, indentText) {
                    const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
                    skipWhitespace();
                    return finishNode(factory2.createJSDocThisTag(tagName, typeExpression, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                }
                function parseEnumTag(start2, tagName, margin, indentText) {
                    const typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
                    skipWhitespace();
                    return finishNode(factory2.createJSDocEnumTag(tagName, typeExpression, parseTrailingTagComments(start2, getNodePos(), margin, indentText)), start2);
                }
                function parseTypedefTag(start2, tagName, indent3, indentText) {
                    let typeExpression = tryParseTypeExpression();
                    skipWhitespaceOrAsterisk();
                    const fullName = parseJSDocTypeNameWithNamespace();
                    skipWhitespace();
                    let comment = parseTagComments(indent3);
                    let end2;
                    if (!typeExpression || isObjectOrObjectArrayTypeReference(typeExpression.type)) {
                        let child;
                        let childTypeTag;
                        let jsDocPropertyTags;
                        let hasChildren = false;
                        while(child = tryParse(()=>parseChildPropertyTag(indent3))){
                            if (child.kind === 346 /* JSDocTemplateTag */ ) break;
                            hasChildren = true;
                            if (child.kind === 345 /* JSDocTypeTag */ ) {
                                if (childTypeTag) {
                                    const lastError = parseErrorAtCurrentToken(Diagnostics.A_JSDoc_typedef_comment_may_not_contain_multiple_type_tags);
                                    if (lastError) addRelatedInfo(lastError, createDetachedDiagnostic(fileName, sourceText, 0, 0, Diagnostics.The_tag_was_first_specified_here));
                                    break;
                                } else childTypeTag = child;
                            } else jsDocPropertyTags = append(jsDocPropertyTags, child);
                        }
                        if (hasChildren) {
                            const isArrayType = typeExpression && typeExpression.type.kind === 189 /* ArrayType */ ;
                            const jsdocTypeLiteral = factory2.createJSDocTypeLiteral(jsDocPropertyTags, isArrayType);
                            typeExpression = childTypeTag && childTypeTag.typeExpression && !isObjectOrObjectArrayTypeReference(childTypeTag.typeExpression.type) ? childTypeTag.typeExpression : finishNode(jsdocTypeLiteral, start2);
                            end2 = typeExpression.end;
                        }
                    }
                    var _ref;
                    end2 = end2 || comment !== void 0 ? getNodePos() : ((_ref = fullName !== null && fullName !== void 0 ? fullName : typeExpression) !== null && _ref !== void 0 ? _ref : tagName).end;
                    if (!comment) comment = parseTrailingTagComments(start2, end2, indent3, indentText);
                    const typedefTag = factory2.createJSDocTypedefTag(tagName, typeExpression, fullName, comment);
                    return finishNode(typedefTag, start2, end2);
                }
                function parseJSDocTypeNameWithNamespace(nested) {
                    const start2 = scanner2.getTokenStart();
                    if (!tokenIsIdentifierOrKeyword(token())) return void 0;
                    const typeNameOrNamespaceName = parseJSDocIdentifierName();
                    if (parseOptional(25 /* DotToken */ )) {
                        const body = parseJSDocTypeNameWithNamespace(/*nested*/ true);
                        const jsDocNamespaceNode = factory2.createModuleDeclaration(/*modifiers*/ void 0, typeNameOrNamespaceName, body, nested ? 8 /* NestedNamespace */  : void 0);
                        return finishNode(jsDocNamespaceNode, start2);
                    }
                    if (nested) typeNameOrNamespaceName.flags |= 4096 /* IdentifierIsInJSDocNamespace */ ;
                    return typeNameOrNamespaceName;
                }
                function parseCallbackTagParameters(indent3) {
                    const pos = getNodePos();
                    let child;
                    let parameters;
                    while(child = tryParse(()=>parseChildParameterOrPropertyTag(4 /* CallbackParameter */ , indent3))){
                        if (child.kind === 346 /* JSDocTemplateTag */ ) {
                            parseErrorAtRange(child.tagName, Diagnostics.A_JSDoc_template_tag_may_not_follow_a_typedef_callback_or_overload_tag);
                            break;
                        }
                        parameters = append(parameters, child);
                    }
                    return createNodeArray(parameters || [], pos);
                }
                function parseJSDocSignature(start2, indent3) {
                    const parameters = parseCallbackTagParameters(indent3);
                    const returnTag = tryParse(()=>{
                        if (parseOptionalJsdoc(60 /* AtToken */ )) {
                            const tag = parseTag(indent3);
                            if (tag && tag.kind === 343 /* JSDocReturnTag */ ) return tag;
                        }
                    });
                    return finishNode(factory2.createJSDocSignature(/*typeParameters*/ void 0, parameters, returnTag), start2);
                }
                function parseCallbackTag(start2, tagName, indent3, indentText) {
                    const fullName = parseJSDocTypeNameWithNamespace();
                    skipWhitespace();
                    let comment = parseTagComments(indent3);
                    const typeExpression = parseJSDocSignature(start2, indent3);
                    if (!comment) comment = parseTrailingTagComments(start2, getNodePos(), indent3, indentText);
                    const end2 = comment !== void 0 ? getNodePos() : typeExpression.end;
                    return finishNode(factory2.createJSDocCallbackTag(tagName, typeExpression, fullName, comment), start2, end2);
                }
                function parseOverloadTag(start2, tagName, indent3, indentText) {
                    skipWhitespace();
                    let comment = parseTagComments(indent3);
                    const typeExpression = parseJSDocSignature(start2, indent3);
                    if (!comment) comment = parseTrailingTagComments(start2, getNodePos(), indent3, indentText);
                    const end2 = comment !== void 0 ? getNodePos() : typeExpression.end;
                    return finishNode(factory2.createJSDocOverloadTag(tagName, typeExpression, comment), start2, end2);
                }
                function escapedTextsEqual(a, b) {
                    while(!isIdentifier(a) || !isIdentifier(b)){
                        if (!isIdentifier(a) && !isIdentifier(b) && a.right.escapedText === b.right.escapedText) {
                            a = a.left;
                            b = b.left;
                        } else return false;
                    }
                    return a.escapedText === b.escapedText;
                }
                function parseChildPropertyTag(indent3) {
                    return parseChildParameterOrPropertyTag(1 /* Property */ , indent3);
                }
                function parseChildParameterOrPropertyTag(target, indent3, name) {
                    let canParseTag = true;
                    let seenAsterisk = false;
                    while(true)switch(nextTokenJSDoc()){
                        case 60 /* AtToken */ :
                            if (canParseTag) {
                                const child = tryParseChildTag(target, indent3);
                                if (child && (child.kind === 342 /* JSDocParameterTag */  || child.kind === 349 /* JSDocPropertyTag */ ) && name && (isIdentifier(child.name) || !escapedTextsEqual(name, child.name.left))) return false;
                                return child;
                            }
                            seenAsterisk = false;
                            break;
                        case 4 /* NewLineTrivia */ :
                            canParseTag = true;
                            seenAsterisk = false;
                            break;
                        case 42 /* AsteriskToken */ :
                            if (seenAsterisk) canParseTag = false;
                            seenAsterisk = true;
                            break;
                        case 80 /* Identifier */ :
                            canParseTag = false;
                            break;
                        case 1 /* EndOfFileToken */ :
                            return false;
                    }
                }
                function tryParseChildTag(target, indent3) {
                    Debug.assert(token() === 60 /* AtToken */ );
                    const start2 = scanner2.getTokenFullStart();
                    nextTokenJSDoc();
                    const tagName = parseJSDocIdentifierName();
                    const indentText = skipWhitespaceOrAsterisk();
                    let t;
                    switch(tagName.escapedText){
                        case "type":
                            return target === 1 /* Property */  && parseTypeTag(start2, tagName);
                        case "prop":
                        case "property":
                            t = 1 /* Property */ ;
                            break;
                        case "arg":
                        case "argument":
                        case "param":
                            t = 6 /* CallbackParameter */ ;
                            break;
                        case "template":
                            return parseTemplateTag(start2, tagName, indent3, indentText);
                        case "this":
                            return parseThisTag(start2, tagName, indent3, indentText);
                        default:
                            return false;
                    }
                    if (!(target & t)) return false;
                    return parseParameterOrPropertyTag(start2, tagName, target, indent3);
                }
                function parseTemplateTagTypeParameter() {
                    const typeParameterPos = getNodePos();
                    const isBracketed = parseOptionalJsdoc(23 /* OpenBracketToken */ );
                    if (isBracketed) skipWhitespace();
                    const modifiers = parseModifiers(/*allowDecorators*/ false, /*permitConstAsModifier*/ true);
                    const name = parseJSDocIdentifierName(Diagnostics.Unexpected_token_A_type_parameter_name_was_expected_without_curly_braces);
                    let defaultType;
                    if (isBracketed) {
                        skipWhitespace();
                        parseExpected(64 /* EqualsToken */ );
                        defaultType = doInsideOfContext(16777216 /* JSDoc */ , parseJSDocType);
                        parseExpected(24 /* CloseBracketToken */ );
                    }
                    if (nodeIsMissing(name)) return void 0;
                    return finishNode(factory2.createTypeParameterDeclaration(modifiers, name, /*constraint*/ void 0, defaultType), typeParameterPos);
                }
                function parseTemplateTagTypeParameters() {
                    const pos = getNodePos();
                    const typeParameters = [];
                    do {
                        skipWhitespace();
                        const node = parseTemplateTagTypeParameter();
                        if (node !== void 0) typeParameters.push(node);
                        skipWhitespaceOrAsterisk();
                    }while (parseOptionalJsdoc(28 /* CommaToken */ ));
                    return createNodeArray(typeParameters, pos);
                }
                function parseTemplateTag(start2, tagName, indent3, indentText) {
                    const constraint = token() === 19 /* OpenBraceToken */  ? parseJSDocTypeExpression() : void 0;
                    const typeParameters = parseTemplateTagTypeParameters();
                    return finishNode(factory2.createJSDocTemplateTag(tagName, constraint, typeParameters, parseTrailingTagComments(start2, getNodePos(), indent3, indentText)), start2);
                }
                function parseOptionalJsdoc(t) {
                    if (token() === t) {
                        nextTokenJSDoc();
                        return true;
                    }
                    return false;
                }
                function parseJSDocEntityName() {
                    let entity = parseJSDocIdentifierName();
                    if (parseOptional(23 /* OpenBracketToken */ )) parseExpected(24 /* CloseBracketToken */ );
                    while(parseOptional(25 /* DotToken */ )){
                        const name = parseJSDocIdentifierName();
                        if (parseOptional(23 /* OpenBracketToken */ )) parseExpected(24 /* CloseBracketToken */ );
                        entity = createQualifiedName(entity, name);
                    }
                    return entity;
                }
                function parseJSDocIdentifierName(message) {
                    if (!tokenIsIdentifierOrKeyword(token())) return createMissingNode(80 /* Identifier */ , /*reportAtCurrentPosition*/ !message, message || Diagnostics.Identifier_expected);
                    identifierCount++;
                    const start2 = scanner2.getTokenStart();
                    const end2 = scanner2.getTokenEnd();
                    const originalKeywordKind = token();
                    const text = internIdentifier(scanner2.getTokenValue());
                    const result2 = finishNode(factoryCreateIdentifier(text, originalKeywordKind), start2, end2);
                    nextTokenJSDoc();
                    return result2;
                }
            }
        })(JSDocParser = Parser2.JSDocParser || (Parser2.JSDocParser = {}));
    })(Parser || (Parser = {}));
    var incrementallyParsedFiles = /* @__PURE__ */ new WeakSet();
    function markAsIncrementallyParsed(sourceFile) {
        if (incrementallyParsedFiles.has(sourceFile)) Debug.fail("Source file has already been incrementally parsed");
        incrementallyParsedFiles.add(sourceFile);
    }
    var intersectingChangeSet = /* @__PURE__ */ new WeakSet();
    function intersectsIncrementalChange(node) {
        return intersectingChangeSet.has(node);
    }
    function markAsIntersectingIncrementalChange(node) {
        intersectingChangeSet.add(node);
    }
    var IncrementalParser;
    ((IncrementalParser2)=>{
        function updateSourceFile2(sourceFile, newText, textChangeRange, aggressiveChecks) {
            aggressiveChecks = aggressiveChecks || Debug.shouldAssert(2 /* Aggressive */ );
            checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks);
            if (textChangeRangeIsUnchanged(textChangeRange)) return sourceFile;
            if (sourceFile.statements.length === 0) return Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, /*syntaxCursor*/ void 0, /*setParentNodes*/ true, sourceFile.scriptKind, sourceFile.setExternalModuleIndicator, sourceFile.jsDocParsingMode);
            markAsIncrementallyParsed(sourceFile);
            Parser.fixupParentReferences(sourceFile);
            const oldText = sourceFile.text;
            const syntaxCursor = createSyntaxCursor(sourceFile);
            const changeRange = extendToAffectedRange(sourceFile, textChangeRange);
            checkChangeRange(sourceFile, newText, changeRange, aggressiveChecks);
            Debug.assert(changeRange.span.start <= textChangeRange.span.start);
            Debug.assert(textSpanEnd(changeRange.span) === textSpanEnd(textChangeRange.span));
            Debug.assert(textSpanEnd(textChangeRangeNewSpan(changeRange)) === textSpanEnd(textChangeRangeNewSpan(textChangeRange)));
            const delta = textChangeRangeNewSpan(changeRange).length - changeRange.span.length;
            updateTokenPositionsAndMarkElements(sourceFile, changeRange.span.start, textSpanEnd(changeRange.span), textSpanEnd(textChangeRangeNewSpan(changeRange)), delta, oldText, newText, aggressiveChecks);
            const result = Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, syntaxCursor, /*setParentNodes*/ true, sourceFile.scriptKind, sourceFile.setExternalModuleIndicator, sourceFile.jsDocParsingMode);
            result.commentDirectives = getNewCommentDirectives(sourceFile.commentDirectives, result.commentDirectives, changeRange.span.start, textSpanEnd(changeRange.span), delta, oldText, newText, aggressiveChecks);
            result.impliedNodeFormat = sourceFile.impliedNodeFormat;
            transferSourceFileChildren(sourceFile, result);
            return result;
        }
        IncrementalParser2.updateSourceFile = updateSourceFile2;
        function getNewCommentDirectives(oldDirectives, newDirectives, changeStart, changeRangeOldEnd, delta, oldText, newText, aggressiveChecks) {
            if (!oldDirectives) return newDirectives;
            let commentDirectives;
            let addedNewlyScannedDirectives = false;
            for (const directive of oldDirectives){
                const { range, type } = directive;
                if (range.end < changeStart) commentDirectives = append(commentDirectives, directive);
                else if (range.pos > changeRangeOldEnd) {
                    addNewlyScannedDirectives();
                    const updatedDirective = {
                        range: {
                            pos: range.pos + delta,
                            end: range.end + delta
                        },
                        type
                    };
                    commentDirectives = append(commentDirectives, updatedDirective);
                    if (aggressiveChecks) Debug.assert(oldText.substring(range.pos, range.end) === newText.substring(updatedDirective.range.pos, updatedDirective.range.end));
                }
            }
            addNewlyScannedDirectives();
            return commentDirectives;
            function addNewlyScannedDirectives() {
                if (addedNewlyScannedDirectives) return;
                addedNewlyScannedDirectives = true;
                if (!commentDirectives) commentDirectives = newDirectives;
                else if (newDirectives) commentDirectives.push(...newDirectives);
            }
        }
        function moveElementEntirelyPastChangeRange(element, origSourceFile, isArray2, delta, oldText, newText, aggressiveChecks) {
            if (isArray2) visitArray2(element);
            else visitNode3(element);
            return;
            function visitNode3(node) {
                let text = "";
                if (aggressiveChecks && shouldCheckNode(node)) text = oldText.substring(node.pos, node.end);
                unsetNodeChildren(node, origSourceFile);
                setTextRangePosEnd(node, node.pos + delta, node.end + delta);
                if (aggressiveChecks && shouldCheckNode(node)) Debug.assert(text === newText.substring(node.pos, node.end));
                forEachChild(node, visitNode3, visitArray2);
                if (hasJSDocNodes(node)) for (const jsDocComment of node.jsDoc)visitNode3(jsDocComment);
                checkNodePositions(node, aggressiveChecks);
            }
            function visitArray2(array) {
                setTextRangePosEnd(array, array.pos + delta, array.end + delta);
                for (const node of array)visitNode3(node);
            }
        }
        function shouldCheckNode(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 80 /* Identifier */ :
                    return true;
            }
            return false;
        }
        function adjustIntersectingElement(element, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta) {
            Debug.assert(element.end >= changeStart, "Adjusting an element that was entirely before the change range");
            Debug.assert(element.pos <= changeRangeOldEnd, "Adjusting an element that was entirely after the change range");
            Debug.assert(element.pos <= element.end);
            const pos = Math.min(element.pos, changeRangeNewEnd);
            const end = element.end >= changeRangeOldEnd ? // Element ends after the change range.  Always adjust the end pos.
            element.end + delta : // Element ends in the change range.  The element will keep its position if
            // possible. Or Move backward to the new-end if it's in the 'Y' range.
            Math.min(element.end, changeRangeNewEnd);
            Debug.assert(pos <= end);
            if (element.parent) {
                const parent2 = element.parent;
                Debug.assertGreaterThanOrEqual(pos, parent2.pos);
                Debug.assertLessThanOrEqual(end, parent2.end);
            }
            setTextRangePosEnd(element, pos, end);
        }
        function checkNodePositions(node, aggressiveChecks) {
            if (aggressiveChecks) {
                let pos = node.pos;
                const visitNode3 = (child)=>{
                    Debug.assert(child.pos >= pos);
                    pos = child.end;
                };
                if (hasJSDocNodes(node)) for (const jsDocComment of node.jsDoc)visitNode3(jsDocComment);
                forEachChild(node, visitNode3);
                Debug.assert(pos <= node.end);
            }
        }
        function updateTokenPositionsAndMarkElements(sourceFile, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta, oldText, newText, aggressiveChecks) {
            visitNode3(sourceFile);
            return;
            function visitNode3(child) {
                Debug.assert(child.pos <= child.end);
                if (child.pos > changeRangeOldEnd) {
                    moveElementEntirelyPastChangeRange(child, sourceFile, /*isArray*/ false, delta, oldText, newText, aggressiveChecks);
                    return;
                }
                const fullEnd = child.end;
                if (fullEnd >= changeStart) {
                    markAsIntersectingIncrementalChange(child);
                    unsetNodeChildren(child, sourceFile);
                    adjustIntersectingElement(child, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
                    forEachChild(child, visitNode3, visitArray2);
                    if (hasJSDocNodes(child)) for (const jsDocComment of child.jsDoc)visitNode3(jsDocComment);
                    checkNodePositions(child, aggressiveChecks);
                    return;
                }
                Debug.assert(fullEnd < changeStart);
            }
            function visitArray2(array) {
                Debug.assert(array.pos <= array.end);
                if (array.pos > changeRangeOldEnd) {
                    moveElementEntirelyPastChangeRange(array, sourceFile, /*isArray*/ true, delta, oldText, newText, aggressiveChecks);
                    return;
                }
                const fullEnd = array.end;
                if (fullEnd >= changeStart) {
                    markAsIntersectingIncrementalChange(array);
                    adjustIntersectingElement(array, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
                    for (const node of array)visitNode3(node);
                    return;
                }
                Debug.assert(fullEnd < changeStart);
            }
        }
        function extendToAffectedRange(sourceFile, changeRange) {
            const maxLookahead = 1;
            let start = changeRange.span.start;
            for(let i = 0; start > 0 && i <= maxLookahead; i++){
                const nearestNode = findNearestNodeStartingBeforeOrAtPosition(sourceFile, start);
                Debug.assert(nearestNode.pos <= start);
                const position = nearestNode.pos;
                start = Math.max(0, position - 1);
            }
            const finalSpan = createTextSpanFromBounds(start, textSpanEnd(changeRange.span));
            const finalLength = changeRange.newLength + (changeRange.span.start - start);
            return createTextChangeRange(finalSpan, finalLength);
        }
        function findNearestNodeStartingBeforeOrAtPosition(sourceFile, position) {
            let bestResult = sourceFile;
            let lastNodeEntirelyBeforePosition;
            forEachChild(sourceFile, visit);
            if (lastNodeEntirelyBeforePosition) {
                const lastChildOfLastEntireNodeBeforePosition = getLastDescendant(lastNodeEntirelyBeforePosition);
                if (lastChildOfLastEntireNodeBeforePosition.pos > bestResult.pos) bestResult = lastChildOfLastEntireNodeBeforePosition;
            }
            return bestResult;
            function getLastDescendant(node) {
                while(true){
                    const lastChild = getLastChild(node);
                    if (lastChild) node = lastChild;
                    else return node;
                }
            }
            function visit(child) {
                if (nodeIsMissing(child)) return;
                if (child.pos <= position) {
                    if (child.pos >= bestResult.pos) bestResult = child;
                    if (position < child.end) {
                        forEachChild(child, visit);
                        return true;
                    } else {
                        Debug.assert(child.end <= position);
                        lastNodeEntirelyBeforePosition = child;
                    }
                } else {
                    Debug.assert(child.pos > position);
                    return true;
                }
            }
        }
        function checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks) {
            const oldText = sourceFile.text;
            if (textChangeRange) {
                Debug.assert(oldText.length - textChangeRange.span.length + textChangeRange.newLength === newText.length);
                if (aggressiveChecks || Debug.shouldAssert(3 /* VeryAggressive */ )) {
                    const oldTextPrefix = oldText.substr(0, textChangeRange.span.start);
                    const newTextPrefix = newText.substr(0, textChangeRange.span.start);
                    Debug.assert(oldTextPrefix === newTextPrefix);
                    const oldTextSuffix = oldText.substring(textSpanEnd(textChangeRange.span), oldText.length);
                    const newTextSuffix = newText.substring(textSpanEnd(textChangeRangeNewSpan(textChangeRange)), newText.length);
                    Debug.assert(oldTextSuffix === newTextSuffix);
                }
            }
        }
        function createSyntaxCursor(sourceFile) {
            let currentArray = sourceFile.statements;
            let currentArrayIndex = 0;
            Debug.assert(currentArrayIndex < currentArray.length);
            let current = currentArray[currentArrayIndex];
            let lastQueriedPosition = -1 /* Value */ ;
            return {
                currentNode (position) {
                    if (position !== lastQueriedPosition) {
                        if (current && current.end === position && currentArrayIndex < currentArray.length - 1) {
                            currentArrayIndex++;
                            current = currentArray[currentArrayIndex];
                        }
                        if (!current || current.pos !== position) findHighestListElementThatStartsAtPosition(position);
                    }
                    lastQueriedPosition = position;
                    Debug.assert(!current || current.pos === position);
                    return current;
                }
            };
            function findHighestListElementThatStartsAtPosition(position) {
                currentArray = void 0;
                currentArrayIndex = -1 /* Value */ ;
                current = void 0;
                forEachChild(sourceFile, visitNode3, visitArray2);
                return;
                function visitNode3(node) {
                    if (position >= node.pos && position < node.end) {
                        forEachChild(node, visitNode3, visitArray2);
                        return true;
                    }
                    return false;
                }
                function visitArray2(array) {
                    if (position >= array.pos && position < array.end) for(let i = 0; i < array.length; i++){
                        const child = array[i];
                        if (child) {
                            if (child.pos === position) {
                                currentArray = array;
                                currentArrayIndex = i;
                                current = child;
                                return true;
                            } else if (child.pos < position && position < child.end) {
                                forEachChild(child, visitNode3, visitArray2);
                                return true;
                            }
                        }
                    }
                    return false;
                }
            }
        }
        IncrementalParser2.createSyntaxCursor = createSyntaxCursor;
        let InvalidPosition;
        ((InvalidPosition2)=>{
            InvalidPosition2[InvalidPosition2["Value"] = -1] = "Value";
        })(InvalidPosition || (InvalidPosition = {}));
    })(IncrementalParser || (IncrementalParser = {}));
    function isDeclarationFileName(fileName) {
        return getDeclarationFileExtension(fileName) !== void 0;
    }
    function getDeclarationFileExtension(fileName) {
        const standardExtension = getAnyExtensionFromPath(fileName, supportedDeclarationExtensions, /*ignoreCase*/ false);
        if (standardExtension) return standardExtension;
        if (fileExtensionIs(fileName, ".ts" /* Ts */ )) {
            const baseName = getBaseFileName(fileName);
            const index = baseName.lastIndexOf(".d.");
            if (index >= 0) return baseName.substring(index);
        }
        return void 0;
    }
    function parseResolutionMode(mode, pos, end, reportDiagnostic) {
        if (!mode) return void 0;
        if (mode === "import") return 99 /* ESNext */ ;
        if (mode === "require") return 1 /* CommonJS */ ;
        reportDiagnostic(pos, end - pos, Diagnostics.resolution_mode_should_be_either_require_or_import);
        return void 0;
    }
    function processCommentPragmas(context, sourceText) {
        const pragmas = [];
        for (const range of getLeadingCommentRanges(sourceText, 0) || emptyArray){
            const comment = sourceText.substring(range.pos, range.end);
            extractPragmas(pragmas, range, comment);
        }
        context.pragmas = /* @__PURE__ */ new Map();
        for (const pragma of pragmas){
            if (context.pragmas.has(pragma.name)) {
                const currentValue = context.pragmas.get(pragma.name);
                if (currentValue instanceof Array) currentValue.push(pragma.args);
                else context.pragmas.set(pragma.name, [
                    currentValue,
                    pragma.args
                ]);
                continue;
            }
            context.pragmas.set(pragma.name, pragma.args);
        }
    }
    function processPragmasIntoFields(context, reportDiagnostic) {
        context.checkJsDirective = void 0;
        context.referencedFiles = [];
        context.typeReferenceDirectives = [];
        context.libReferenceDirectives = [];
        context.amdDependencies = [];
        context.hasNoDefaultLib = false;
        context.pragmas.forEach((entryOrList, key)=>{
            switch(key){
                case "reference":
                    {
                        const referencedFiles = context.referencedFiles;
                        const typeReferenceDirectives = context.typeReferenceDirectives;
                        const libReferenceDirectives = context.libReferenceDirectives;
                        forEach(toArray(entryOrList), (arg)=>{
                            const { types, lib, path, ["resolution-mode"]: res, preserve: _preserve } = arg.arguments;
                            const preserve = _preserve === "true" ? true : void 0;
                            if (arg.arguments["no-default-lib"] === "true") context.hasNoDefaultLib = true;
                            else if (types) {
                                const parsed = parseResolutionMode(res, types.pos, types.end, reportDiagnostic);
                                typeReferenceDirectives.push((0, _objectSpread._)({
                                    pos: types.pos,
                                    end: types.end,
                                    fileName: types.value
                                }, parsed ? {
                                    resolutionMode: parsed
                                } : {}, preserve ? {
                                    preserve
                                } : {}));
                            } else if (lib) libReferenceDirectives.push((0, _objectSpread._)({
                                pos: lib.pos,
                                end: lib.end,
                                fileName: lib.value
                            }, preserve ? {
                                preserve
                            } : {}));
                            else if (path) referencedFiles.push((0, _objectSpread._)({
                                pos: path.pos,
                                end: path.end,
                                fileName: path.value
                            }, preserve ? {
                                preserve
                            } : {}));
                            else reportDiagnostic(arg.range.pos, arg.range.end - arg.range.pos, Diagnostics.Invalid_reference_directive_syntax);
                        });
                        break;
                    }
                case "amd-dependency":
                    context.amdDependencies = map(toArray(entryOrList), (x)=>({
                            name: x.arguments.name,
                            path: x.arguments.path
                        }));
                    break;
                case "amd-module":
                    if (entryOrList instanceof Array) for (const entry of entryOrList){
                        if (context.moduleName) reportDiagnostic(entry.range.pos, entry.range.end - entry.range.pos, Diagnostics.An_AMD_module_cannot_have_multiple_name_assignments);
                        context.moduleName = entry.arguments.name;
                    }
                    else context.moduleName = entryOrList.arguments.name;
                    break;
                case "ts-nocheck":
                case "ts-check":
                    forEach(toArray(entryOrList), (entry)=>{
                        if (!context.checkJsDirective || entry.range.pos > context.checkJsDirective.pos) context.checkJsDirective = {
                            enabled: key === "ts-check",
                            end: entry.range.end,
                            pos: entry.range.pos
                        };
                    });
                    break;
                case "jsx":
                case "jsxfrag":
                case "jsximportsource":
                case "jsxruntime":
                    return;
                // Accessed directly
                default:
                    Debug.fail("Unhandled pragma kind");
            }
        });
    }
    var namedArgRegExCache = /* @__PURE__ */ new Map();
    function getNamedArgRegEx(name) {
        if (namedArgRegExCache.has(name)) return namedArgRegExCache.get(name);
        const result = new RegExp(`(\\s${name}\\s*=\\s*)(?:(?:'([^']*)')|(?:"([^"]*)"))`, "im");
        namedArgRegExCache.set(name, result);
        return result;
    }
    var tripleSlashXMLCommentStartRegEx = /^\/\/\/\s*<(\S+)\s.*?\/>/m;
    var singleLinePragmaRegEx = /^\/\/\/?\s*@([^\s:]+)((?:[^\S\r\n]|:).*)?$/m;
    function extractPragmas(pragmas, range, text) {
        const tripleSlash = range.kind === 2 /* SingleLineCommentTrivia */  && tripleSlashXMLCommentStartRegEx.exec(text);
        if (tripleSlash) {
            const name = tripleSlash[1].toLowerCase();
            const pragma = commentPragmas[name];
            if (!pragma || !(pragma.kind & 1 /* TripleSlashXML */ )) return;
            if (pragma.args) {
                const argument = {};
                for (const arg of pragma.args){
                    const matcher = getNamedArgRegEx(arg.name);
                    const matchResult = matcher.exec(text);
                    if (!matchResult && !arg.optional) return;
                    else if (matchResult) {
                        const value1 = matchResult[2] || matchResult[3];
                        if (arg.captureSpan) {
                            const startPos = range.pos + matchResult.index + matchResult[1].length + 1;
                            argument[arg.name] = {
                                value: value1,
                                pos: startPos,
                                end: startPos + value1.length
                            };
                        } else argument[arg.name] = value1;
                    }
                }
                pragmas.push({
                    name,
                    args: {
                        arguments: argument,
                        range
                    }
                });
            } else pragmas.push({
                name,
                args: {
                    arguments: {},
                    range
                }
            });
            return;
        }
        const singleLine = range.kind === 2 /* SingleLineCommentTrivia */  && singleLinePragmaRegEx.exec(text);
        if (singleLine) return addPragmaForMatch(pragmas, range, 2 /* SingleLine */ , singleLine);
        if (range.kind === 3 /* MultiLineCommentTrivia */ ) {
            const multiLinePragmaRegEx = /@(\S+)(\s+(?:\S.*)?)?$/gm;
            let multiLineMatch;
            while(multiLineMatch = multiLinePragmaRegEx.exec(text))addPragmaForMatch(pragmas, range, 4 /* MultiLine */ , multiLineMatch);
        }
    }
    function addPragmaForMatch(pragmas, range, kind, match) {
        if (!match) return;
        const name = match[1].toLowerCase();
        const pragma = commentPragmas[name];
        if (!pragma || !(pragma.kind & kind)) return;
        const args = match[2];
        const argument = getNamedPragmaArguments(pragma, args);
        if (argument === "fail") return;
        pragmas.push({
            name,
            args: {
                arguments: argument,
                range
            }
        });
        return;
    }
    function getNamedPragmaArguments(pragma, text) {
        if (!text) return {};
        if (!pragma.args) return {};
        const args = text.trim().split(/\s+/);
        const argMap = {};
        for(let i = 0; i < pragma.args.length; i++){
            const argument = pragma.args[i];
            if (!args[i] && !argument.optional) return "fail";
            if (argument.captureSpan) return Debug.fail("Capture spans not yet implemented for non-xml pragmas");
            argMap[argument.name] = args[i];
        }
        return argMap;
    }
    function tagNamesAreEquivalent(lhs, rhs) {
        if (lhs.kind !== rhs.kind) return false;
        if (lhs.kind === 80 /* Identifier */ ) return lhs.escapedText === rhs.escapedText;
        if (lhs.kind === 110 /* ThisKeyword */ ) return true;
        if (lhs.kind === 296 /* JsxNamespacedName */ ) return lhs.namespace.escapedText === rhs.namespace.escapedText && lhs.name.escapedText === rhs.name.escapedText;
        return lhs.name.escapedText === rhs.name.escapedText && tagNamesAreEquivalent(lhs.expression, rhs.expression);
    }
    // src/compiler/commandLineParser.ts
    var compileOnSaveCommandLineOption = {
        name: "compileOnSave",
        type: "boolean",
        defaultValueDescription: false
    };
    var jsxOptionMap = new Map(Object.entries({
        "preserve": 1 /* Preserve */ ,
        "react-native": 3 /* ReactNative */ ,
        "react-jsx": 4 /* ReactJSX */ ,
        "react-jsxdev": 5 /* ReactJSXDev */ ,
        "react": 2 /* React */ 
    }));
    var inverseJsxOptionMap = new Map(mapIterator(jsxOptionMap.entries(), ([key, value1])=>[
            "" + value1,
            key
        ]));
    var libEntries = [
        // JavaScript only
        [
            "es5",
            "lib.es5.d.ts"
        ],
        [
            "es6",
            "lib.es2015.d.ts"
        ],
        [
            "es2015",
            "lib.es2015.d.ts"
        ],
        [
            "es7",
            "lib.es2016.d.ts"
        ],
        [
            "es2016",
            "lib.es2016.d.ts"
        ],
        [
            "es2017",
            "lib.es2017.d.ts"
        ],
        [
            "es2018",
            "lib.es2018.d.ts"
        ],
        [
            "es2019",
            "lib.es2019.d.ts"
        ],
        [
            "es2020",
            "lib.es2020.d.ts"
        ],
        [
            "es2021",
            "lib.es2021.d.ts"
        ],
        [
            "es2022",
            "lib.es2022.d.ts"
        ],
        [
            "es2023",
            "lib.es2023.d.ts"
        ],
        [
            "es2024",
            "lib.es2024.d.ts"
        ],
        [
            "esnext",
            "lib.esnext.d.ts"
        ],
        // Host only
        [
            "dom",
            "lib.dom.d.ts"
        ],
        [
            "dom.iterable",
            "lib.dom.iterable.d.ts"
        ],
        [
            "dom.asynciterable",
            "lib.dom.asynciterable.d.ts"
        ],
        [
            "webworker",
            "lib.webworker.d.ts"
        ],
        [
            "webworker.importscripts",
            "lib.webworker.importscripts.d.ts"
        ],
        [
            "webworker.iterable",
            "lib.webworker.iterable.d.ts"
        ],
        [
            "webworker.asynciterable",
            "lib.webworker.asynciterable.d.ts"
        ],
        [
            "scripthost",
            "lib.scripthost.d.ts"
        ],
        // ES2015 Or ESNext By-feature options
        [
            "es2015.core",
            "lib.es2015.core.d.ts"
        ],
        [
            "es2015.collection",
            "lib.es2015.collection.d.ts"
        ],
        [
            "es2015.generator",
            "lib.es2015.generator.d.ts"
        ],
        [
            "es2015.iterable",
            "lib.es2015.iterable.d.ts"
        ],
        [
            "es2015.promise",
            "lib.es2015.promise.d.ts"
        ],
        [
            "es2015.proxy",
            "lib.es2015.proxy.d.ts"
        ],
        [
            "es2015.reflect",
            "lib.es2015.reflect.d.ts"
        ],
        [
            "es2015.symbol",
            "lib.es2015.symbol.d.ts"
        ],
        [
            "es2015.symbol.wellknown",
            "lib.es2015.symbol.wellknown.d.ts"
        ],
        [
            "es2016.array.include",
            "lib.es2016.array.include.d.ts"
        ],
        [
            "es2016.intl",
            "lib.es2016.intl.d.ts"
        ],
        [
            "es2017.arraybuffer",
            "lib.es2017.arraybuffer.d.ts"
        ],
        [
            "es2017.date",
            "lib.es2017.date.d.ts"
        ],
        [
            "es2017.object",
            "lib.es2017.object.d.ts"
        ],
        [
            "es2017.sharedmemory",
            "lib.es2017.sharedmemory.d.ts"
        ],
        [
            "es2017.string",
            "lib.es2017.string.d.ts"
        ],
        [
            "es2017.intl",
            "lib.es2017.intl.d.ts"
        ],
        [
            "es2017.typedarrays",
            "lib.es2017.typedarrays.d.ts"
        ],
        [
            "es2018.asyncgenerator",
            "lib.es2018.asyncgenerator.d.ts"
        ],
        [
            "es2018.asynciterable",
            "lib.es2018.asynciterable.d.ts"
        ],
        [
            "es2018.intl",
            "lib.es2018.intl.d.ts"
        ],
        [
            "es2018.promise",
            "lib.es2018.promise.d.ts"
        ],
        [
            "es2018.regexp",
            "lib.es2018.regexp.d.ts"
        ],
        [
            "es2019.array",
            "lib.es2019.array.d.ts"
        ],
        [
            "es2019.object",
            "lib.es2019.object.d.ts"
        ],
        [
            "es2019.string",
            "lib.es2019.string.d.ts"
        ],
        [
            "es2019.symbol",
            "lib.es2019.symbol.d.ts"
        ],
        [
            "es2019.intl",
            "lib.es2019.intl.d.ts"
        ],
        [
            "es2020.bigint",
            "lib.es2020.bigint.d.ts"
        ],
        [
            "es2020.date",
            "lib.es2020.date.d.ts"
        ],
        [
            "es2020.promise",
            "lib.es2020.promise.d.ts"
        ],
        [
            "es2020.sharedmemory",
            "lib.es2020.sharedmemory.d.ts"
        ],
        [
            "es2020.string",
            "lib.es2020.string.d.ts"
        ],
        [
            "es2020.symbol.wellknown",
            "lib.es2020.symbol.wellknown.d.ts"
        ],
        [
            "es2020.intl",
            "lib.es2020.intl.d.ts"
        ],
        [
            "es2020.number",
            "lib.es2020.number.d.ts"
        ],
        [
            "es2021.promise",
            "lib.es2021.promise.d.ts"
        ],
        [
            "es2021.string",
            "lib.es2021.string.d.ts"
        ],
        [
            "es2021.weakref",
            "lib.es2021.weakref.d.ts"
        ],
        [
            "es2021.intl",
            "lib.es2021.intl.d.ts"
        ],
        [
            "es2022.array",
            "lib.es2022.array.d.ts"
        ],
        [
            "es2022.error",
            "lib.es2022.error.d.ts"
        ],
        [
            "es2022.intl",
            "lib.es2022.intl.d.ts"
        ],
        [
            "es2022.object",
            "lib.es2022.object.d.ts"
        ],
        [
            "es2022.string",
            "lib.es2022.string.d.ts"
        ],
        [
            "es2022.regexp",
            "lib.es2022.regexp.d.ts"
        ],
        [
            "es2023.array",
            "lib.es2023.array.d.ts"
        ],
        [
            "es2023.collection",
            "lib.es2023.collection.d.ts"
        ],
        [
            "es2023.intl",
            "lib.es2023.intl.d.ts"
        ],
        [
            "es2024.arraybuffer",
            "lib.es2024.arraybuffer.d.ts"
        ],
        [
            "es2024.collection",
            "lib.es2024.collection.d.ts"
        ],
        [
            "es2024.object",
            "lib.es2024.object.d.ts"
        ],
        [
            "es2024.promise",
            "lib.es2024.promise.d.ts"
        ],
        [
            "es2024.regexp",
            "lib.es2024.regexp.d.ts"
        ],
        [
            "es2024.sharedmemory",
            "lib.es2024.sharedmemory.d.ts"
        ],
        [
            "es2024.string",
            "lib.es2024.string.d.ts"
        ],
        [
            "esnext.array",
            "lib.es2023.array.d.ts"
        ],
        [
            "esnext.collection",
            "lib.esnext.collection.d.ts"
        ],
        [
            "esnext.symbol",
            "lib.es2019.symbol.d.ts"
        ],
        [
            "esnext.asynciterable",
            "lib.es2018.asynciterable.d.ts"
        ],
        [
            "esnext.intl",
            "lib.esnext.intl.d.ts"
        ],
        [
            "esnext.disposable",
            "lib.esnext.disposable.d.ts"
        ],
        [
            "esnext.bigint",
            "lib.es2020.bigint.d.ts"
        ],
        [
            "esnext.string",
            "lib.es2022.string.d.ts"
        ],
        [
            "esnext.promise",
            "lib.es2024.promise.d.ts"
        ],
        [
            "esnext.weakref",
            "lib.es2021.weakref.d.ts"
        ],
        [
            "esnext.decorators",
            "lib.esnext.decorators.d.ts"
        ],
        [
            "esnext.object",
            "lib.es2024.object.d.ts"
        ],
        [
            "esnext.array",
            "lib.esnext.array.d.ts"
        ],
        [
            "esnext.regexp",
            "lib.es2024.regexp.d.ts"
        ],
        [
            "esnext.string",
            "lib.es2024.string.d.ts"
        ],
        [
            "esnext.iterator",
            "lib.esnext.iterator.d.ts"
        ],
        [
            "esnext.promise",
            "lib.esnext.promise.d.ts"
        ],
        [
            "esnext.float16",
            "lib.esnext.float16.d.ts"
        ],
        [
            "esnext.error",
            "lib.esnext.error.d.ts"
        ],
        [
            "esnext.sharedmemory",
            "lib.esnext.sharedmemory.d.ts"
        ],
        [
            "decorators",
            "lib.decorators.d.ts"
        ],
        [
            "decorators.legacy",
            "lib.decorators.legacy.d.ts"
        ]
    ];
    var libs = libEntries.map((entry)=>entry[0]);
    var libMap = new Map(libEntries);
    var optionsForWatch = [
        {
            name: "watchFile",
            type: new Map(Object.entries({
                fixedpollinginterval: 0 /* FixedPollingInterval */ ,
                prioritypollinginterval: 1 /* PriorityPollingInterval */ ,
                dynamicprioritypolling: 2 /* DynamicPriorityPolling */ ,
                fixedchunksizepolling: 3 /* FixedChunkSizePolling */ ,
                usefsevents: 4 /* UseFsEvents */ ,
                usefseventsonparentdirectory: 5 /* UseFsEventsOnParentDirectory */ 
            })),
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Specify_how_the_TypeScript_watch_mode_works,
            defaultValueDescription: 4 /* UseFsEvents */ 
        },
        {
            name: "watchDirectory",
            type: new Map(Object.entries({
                usefsevents: 0 /* UseFsEvents */ ,
                fixedpollinginterval: 1 /* FixedPollingInterval */ ,
                dynamicprioritypolling: 2 /* DynamicPriorityPolling */ ,
                fixedchunksizepolling: 3 /* FixedChunkSizePolling */ 
            })),
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Specify_how_directories_are_watched_on_systems_that_lack_recursive_file_watching_functionality,
            defaultValueDescription: 0 /* UseFsEvents */ 
        },
        {
            name: "fallbackPolling",
            type: new Map(Object.entries({
                fixedinterval: 0 /* FixedInterval */ ,
                priorityinterval: 1 /* PriorityInterval */ ,
                dynamicpriority: 2 /* DynamicPriority */ ,
                fixedchunksize: 3 /* FixedChunkSize */ 
            })),
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Specify_what_approach_the_watcher_should_use_if_the_system_runs_out_of_native_file_watchers,
            defaultValueDescription: 1 /* PriorityInterval */ 
        },
        {
            name: "synchronousWatchDirectory",
            type: "boolean",
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Synchronously_call_callbacks_and_update_the_state_of_directory_watchers_on_platforms_that_don_t_support_recursive_watching_natively,
            defaultValueDescription: false
        },
        {
            name: "excludeDirectories",
            type: "list",
            element: {
                name: "excludeDirectory",
                type: "string",
                isFilePath: true,
                extraValidation: specToDiagnostic
            },
            allowConfigDirTemplateSubstitution: true,
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Remove_a_list_of_directories_from_the_watch_process
        },
        {
            name: "excludeFiles",
            type: "list",
            element: {
                name: "excludeFile",
                type: "string",
                isFilePath: true,
                extraValidation: specToDiagnostic
            },
            allowConfigDirTemplateSubstitution: true,
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Remove_a_list_of_files_from_the_watch_mode_s_processing
        }
    ];
    var commonOptionsWithBuild = [
        {
            name: "help",
            shortName: "h",
            type: "boolean",
            showInSimplifiedHelpView: true,
            isCommandLineOnly: true,
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Print_this_message,
            defaultValueDescription: false
        },
        {
            name: "help",
            shortName: "?",
            type: "boolean",
            isCommandLineOnly: true,
            category: Diagnostics.Command_line_Options,
            defaultValueDescription: false
        },
        {
            name: "watch",
            shortName: "w",
            type: "boolean",
            showInSimplifiedHelpView: true,
            isCommandLineOnly: true,
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Watch_input_files,
            defaultValueDescription: false
        },
        {
            name: "preserveWatchOutput",
            type: "boolean",
            showInSimplifiedHelpView: false,
            category: Diagnostics.Output_Formatting,
            description: Diagnostics.Disable_wiping_the_console_in_watch_mode,
            defaultValueDescription: false
        },
        {
            name: "listFiles",
            type: "boolean",
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Print_all_of_the_files_read_during_the_compilation,
            defaultValueDescription: false
        },
        {
            name: "explainFiles",
            type: "boolean",
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Print_files_read_during_the_compilation_including_why_it_was_included,
            defaultValueDescription: false
        },
        {
            name: "listEmittedFiles",
            type: "boolean",
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Print_the_names_of_emitted_files_after_a_compilation,
            defaultValueDescription: false
        },
        {
            name: "pretty",
            type: "boolean",
            showInSimplifiedHelpView: true,
            category: Diagnostics.Output_Formatting,
            description: Diagnostics.Enable_color_and_formatting_in_TypeScript_s_output_to_make_compiler_errors_easier_to_read,
            defaultValueDescription: true
        },
        {
            name: "traceResolution",
            type: "boolean",
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Log_paths_used_during_the_moduleResolution_process,
            defaultValueDescription: false
        },
        {
            name: "diagnostics",
            type: "boolean",
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Output_compiler_performance_information_after_building,
            defaultValueDescription: false
        },
        {
            name: "extendedDiagnostics",
            type: "boolean",
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Output_more_detailed_compiler_performance_information_after_building,
            defaultValueDescription: false
        },
        {
            name: "generateCpuProfile",
            type: "string",
            isFilePath: true,
            paramType: Diagnostics.FILE_OR_DIRECTORY,
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Emit_a_v8_CPU_profile_of_the_compiler_run_for_debugging,
            defaultValueDescription: "profile.cpuprofile"
        },
        {
            name: "generateTrace",
            type: "string",
            isFilePath: true,
            paramType: Diagnostics.DIRECTORY,
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Generates_an_event_trace_and_a_list_of_types
        },
        {
            name: "incremental",
            shortName: "i",
            type: "boolean",
            category: Diagnostics.Projects,
            description: Diagnostics.Save_tsbuildinfo_files_to_allow_for_incremental_compilation_of_projects,
            transpileOptionValue: void 0,
            defaultValueDescription: Diagnostics.false_unless_composite_is_set
        },
        {
            name: "declaration",
            shortName: "d",
            type: "boolean",
            // Not setting affectsEmit because we calculate this flag might not affect full emit
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            transpileOptionValue: void 0,
            description: Diagnostics.Generate_d_ts_files_from_TypeScript_and_JavaScript_files_in_your_project,
            defaultValueDescription: Diagnostics.false_unless_composite_is_set
        },
        {
            name: "declarationMap",
            type: "boolean",
            // Not setting affectsEmit because we calculate this flag might not affect full emit
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            defaultValueDescription: false,
            description: Diagnostics.Create_sourcemaps_for_d_ts_files
        },
        {
            name: "emitDeclarationOnly",
            type: "boolean",
            // Not setting affectsEmit because we calculate this flag might not affect full emit
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Only_output_d_ts_files_and_not_JavaScript_files,
            transpileOptionValue: void 0,
            defaultValueDescription: false
        },
        {
            name: "sourceMap",
            type: "boolean",
            // Not setting affectsEmit because we calculate this flag might not affect full emit
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            defaultValueDescription: false,
            description: Diagnostics.Create_source_map_files_for_emitted_JavaScript_files
        },
        {
            name: "inlineSourceMap",
            type: "boolean",
            // Not setting affectsEmit because we calculate this flag might not affect full emit
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Include_sourcemap_files_inside_the_emitted_JavaScript,
            defaultValueDescription: false
        },
        {
            name: "noCheck",
            type: "boolean",
            showInSimplifiedHelpView: false,
            category: Diagnostics.Compiler_Diagnostics,
            description: Diagnostics.Disable_full_type_checking_only_critical_parse_and_emit_errors_will_be_reported,
            transpileOptionValue: true,
            defaultValueDescription: false
        },
        {
            name: "noEmit",
            type: "boolean",
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Disable_emitting_files_from_a_compilation,
            transpileOptionValue: void 0,
            defaultValueDescription: false
        },
        {
            name: "assumeChangesOnlyAffectDirectDependencies",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Watch_and_Build_Modes,
            description: Diagnostics.Have_recompiles_in_projects_that_use_incremental_and_watch_mode_assume_that_changes_within_a_file_will_only_affect_files_directly_depending_on_it,
            defaultValueDescription: false
        },
        {
            name: "locale",
            type: "string",
            category: Diagnostics.Command_line_Options,
            isCommandLineOnly: true,
            description: Diagnostics.Set_the_language_of_the_messaging_from_TypeScript_This_does_not_affect_emit,
            defaultValueDescription: Diagnostics.Platform_specific
        }
    ];
    var targetOptionDeclaration = {
        name: "target",
        shortName: "t",
        type: new Map(Object.entries({
            es3: 0 /* ES3 */ ,
            es5: 1 /* ES5 */ ,
            es6: 2 /* ES2015 */ ,
            es2015: 2 /* ES2015 */ ,
            es2016: 3 /* ES2016 */ ,
            es2017: 4 /* ES2017 */ ,
            es2018: 5 /* ES2018 */ ,
            es2019: 6 /* ES2019 */ ,
            es2020: 7 /* ES2020 */ ,
            es2021: 8 /* ES2021 */ ,
            es2022: 9 /* ES2022 */ ,
            es2023: 10 /* ES2023 */ ,
            es2024: 11 /* ES2024 */ ,
            esnext: 99 /* ESNext */ 
        })),
        affectsSourceFile: true,
        affectsModuleResolution: true,
        affectsEmit: true,
        affectsBuildInfo: true,
        deprecatedKeys: /* @__PURE__ */ new Set([
            "es3"
        ]),
        paramType: Diagnostics.VERSION,
        showInSimplifiedHelpView: true,
        category: Diagnostics.Language_and_Environment,
        description: Diagnostics.Set_the_JavaScript_language_version_for_emitted_JavaScript_and_include_compatible_library_declarations,
        defaultValueDescription: 1 /* ES5 */ 
    };
    var moduleOptionDeclaration = {
        name: "module",
        shortName: "m",
        type: new Map(Object.entries({
            none: 0 /* None */ ,
            commonjs: 1 /* CommonJS */ ,
            amd: 2 /* AMD */ ,
            system: 4 /* System */ ,
            umd: 3 /* UMD */ ,
            es6: 5 /* ES2015 */ ,
            es2015: 5 /* ES2015 */ ,
            es2020: 6 /* ES2020 */ ,
            es2022: 7 /* ES2022 */ ,
            esnext: 99 /* ESNext */ ,
            node16: 100 /* Node16 */ ,
            node18: 101 /* Node18 */ ,
            node20: 102 /* Node20 */ ,
            nodenext: 199 /* NodeNext */ ,
            preserve: 200 /* Preserve */ 
        })),
        affectsSourceFile: true,
        affectsModuleResolution: true,
        affectsEmit: true,
        affectsBuildInfo: true,
        paramType: Diagnostics.KIND,
        showInSimplifiedHelpView: true,
        category: Diagnostics.Modules,
        description: Diagnostics.Specify_what_module_code_is_generated,
        defaultValueDescription: void 0
    };
    var commandOptionsWithoutBuild = [
        // CommandLine only options
        {
            name: "all",
            type: "boolean",
            showInSimplifiedHelpView: true,
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Show_all_compiler_options,
            defaultValueDescription: false
        },
        {
            name: "version",
            shortName: "v",
            type: "boolean",
            showInSimplifiedHelpView: true,
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Print_the_compiler_s_version,
            defaultValueDescription: false
        },
        {
            name: "init",
            type: "boolean",
            showInSimplifiedHelpView: true,
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file,
            defaultValueDescription: false
        },
        {
            name: "project",
            shortName: "p",
            type: "string",
            isFilePath: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Command_line_Options,
            paramType: Diagnostics.FILE_OR_DIRECTORY,
            description: Diagnostics.Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json
        },
        {
            name: "showConfig",
            type: "boolean",
            showInSimplifiedHelpView: true,
            category: Diagnostics.Command_line_Options,
            isCommandLineOnly: true,
            description: Diagnostics.Print_the_final_configuration_instead_of_building,
            defaultValueDescription: false
        },
        {
            name: "listFilesOnly",
            type: "boolean",
            category: Diagnostics.Command_line_Options,
            isCommandLineOnly: true,
            description: Diagnostics.Print_names_of_files_that_are_part_of_the_compilation_and_then_stop_processing,
            defaultValueDescription: false
        },
        // Basic
        targetOptionDeclaration,
        moduleOptionDeclaration,
        {
            name: "lib",
            type: "list",
            element: {
                name: "lib",
                type: libMap,
                defaultValueDescription: void 0
            },
            affectsProgramStructure: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Specify_a_set_of_bundled_library_declaration_files_that_describe_the_target_runtime_environment,
            transpileOptionValue: void 0
        },
        {
            name: "allowJs",
            type: "boolean",
            allowJsFlag: true,
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.JavaScript_Support,
            description: Diagnostics.Allow_JavaScript_files_to_be_a_part_of_your_program_Use_the_checkJs_option_to_get_errors_from_these_files,
            defaultValueDescription: false
        },
        {
            name: "checkJs",
            type: "boolean",
            affectsModuleResolution: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.JavaScript_Support,
            description: Diagnostics.Enable_error_reporting_in_type_checked_JavaScript_files,
            defaultValueDescription: false
        },
        {
            name: "jsx",
            type: jsxOptionMap,
            affectsSourceFile: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsModuleResolution: true,
            // The checker emits an error when it sees JSX but this option is not set in compilerOptions.
            // This is effectively a semantic error, so mark this option as affecting semantic diagnostics
            // so we know to refresh errors when this option is changed.
            affectsSemanticDiagnostics: true,
            paramType: Diagnostics.KIND,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Specify_what_JSX_code_is_generated,
            defaultValueDescription: void 0
        },
        {
            name: "outFile",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsDeclarationPath: true,
            isFilePath: true,
            paramType: Diagnostics.FILE,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Specify_a_file_that_bundles_all_outputs_into_one_JavaScript_file_If_declaration_is_true_also_designates_a_file_that_bundles_all_d_ts_output,
            transpileOptionValue: void 0
        },
        {
            name: "outDir",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsDeclarationPath: true,
            isFilePath: true,
            paramType: Diagnostics.DIRECTORY,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Specify_an_output_folder_for_all_emitted_files
        },
        {
            name: "rootDir",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsDeclarationPath: true,
            isFilePath: true,
            paramType: Diagnostics.LOCATION,
            category: Diagnostics.Modules,
            description: Diagnostics.Specify_the_root_folder_within_your_source_files,
            defaultValueDescription: Diagnostics.Computed_from_the_list_of_input_files
        },
        {
            name: "composite",
            type: "boolean",
            // Not setting affectsEmit because we calculate this flag might not affect full emit
            affectsBuildInfo: true,
            isTSConfigOnly: true,
            category: Diagnostics.Projects,
            transpileOptionValue: void 0,
            defaultValueDescription: false,
            description: Diagnostics.Enable_constraints_that_allow_a_TypeScript_project_to_be_used_with_project_references
        },
        {
            name: "tsBuildInfoFile",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            isFilePath: true,
            paramType: Diagnostics.FILE,
            category: Diagnostics.Projects,
            transpileOptionValue: void 0,
            defaultValueDescription: ".tsbuildinfo",
            description: Diagnostics.Specify_the_path_to_tsbuildinfo_incremental_compilation_file
        },
        {
            name: "removeComments",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Emit,
            defaultValueDescription: false,
            description: Diagnostics.Disable_emitting_comments
        },
        {
            name: "importHelpers",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsSourceFile: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Allow_importing_helper_functions_from_tslib_once_per_project_instead_of_including_them_per_file,
            defaultValueDescription: false
        },
        {
            name: "importsNotUsedAsValues",
            type: new Map(Object.entries({
                remove: 0 /* Remove */ ,
                preserve: 1 /* Preserve */ ,
                error: 2 /* Error */ 
            })),
            affectsEmit: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Specify_emit_Slashchecking_behavior_for_imports_that_are_only_used_for_types,
            defaultValueDescription: 0 /* Remove */ 
        },
        {
            name: "downlevelIteration",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Emit_more_compliant_but_verbose_and_less_performant_JavaScript_for_iteration,
            defaultValueDescription: false
        },
        {
            name: "isolatedModules",
            type: "boolean",
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Ensure_that_each_file_can_be_safely_transpiled_without_relying_on_other_imports,
            transpileOptionValue: true,
            defaultValueDescription: false
        },
        {
            name: "verbatimModuleSyntax",
            type: "boolean",
            affectsEmit: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Do_not_transform_or_elide_any_imports_or_exports_not_marked_as_type_only_ensuring_they_are_written_in_the_output_file_s_format_based_on_the_module_setting,
            defaultValueDescription: false
        },
        {
            name: "isolatedDeclarations",
            type: "boolean",
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Require_sufficient_annotation_on_exports_so_other_tools_can_trivially_generate_declaration_files,
            defaultValueDescription: false,
            affectsBuildInfo: true,
            affectsSemanticDiagnostics: true
        },
        {
            name: "erasableSyntaxOnly",
            type: "boolean",
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Do_not_allow_runtime_constructs_that_are_not_part_of_ECMAScript,
            defaultValueDescription: false,
            affectsBuildInfo: true,
            affectsSemanticDiagnostics: true
        },
        {
            name: "libReplacement",
            type: "boolean",
            affectsProgramStructure: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Enable_lib_replacement,
            defaultValueDescription: true
        },
        // Strict Type Checks
        {
            name: "strict",
            type: "boolean",
            // Though this affects semantic diagnostics, affectsSemanticDiagnostics is not set here
            // The value of each strictFlag depends on own strictFlag value or this and never accessed directly.
            // But we need to store `strict` in builf info, even though it won't be examined directly, so that the
            // flags it controls (e.g. `strictNullChecks`) will be retrieved correctly
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enable_all_strict_type_checking_options,
            defaultValueDescription: false
        },
        {
            name: "noImplicitAny",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enable_error_reporting_for_expressions_and_declarations_with_an_implied_any_type,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "strictNullChecks",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.When_type_checking_take_into_account_null_and_undefined,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "strictFunctionTypes",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.When_assigning_functions_check_to_ensure_parameters_and_the_return_values_are_subtype_compatible,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "strictBindCallApply",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Check_that_the_arguments_for_bind_call_and_apply_methods_match_the_original_function,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "strictPropertyInitialization",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Check_for_class_properties_that_are_declared_but_not_set_in_the_constructor,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "strictBuiltinIteratorReturn",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Built_in_iterators_are_instantiated_with_a_TReturn_type_of_undefined_instead_of_any,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "noImplicitThis",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enable_error_reporting_when_this_is_given_the_type_any,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "useUnknownInCatchVariables",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Default_catch_clause_variables_as_unknown_instead_of_any,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        {
            name: "alwaysStrict",
            type: "boolean",
            affectsSourceFile: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            strictFlag: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Ensure_use_strict_is_always_emitted,
            defaultValueDescription: Diagnostics.false_unless_strict_is_set
        },
        // Additional Checks
        {
            name: "noUnusedLocals",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enable_error_reporting_when_local_variables_aren_t_read,
            defaultValueDescription: false
        },
        {
            name: "noUnusedParameters",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Raise_an_error_when_a_function_parameter_isn_t_read,
            defaultValueDescription: false
        },
        {
            name: "exactOptionalPropertyTypes",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Interpret_optional_property_types_as_written_rather_than_adding_undefined,
            defaultValueDescription: false
        },
        {
            name: "noImplicitReturns",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enable_error_reporting_for_codepaths_that_do_not_explicitly_return_in_a_function,
            defaultValueDescription: false
        },
        {
            name: "noFallthroughCasesInSwitch",
            type: "boolean",
            affectsBindDiagnostics: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enable_error_reporting_for_fallthrough_cases_in_switch_statements,
            defaultValueDescription: false
        },
        {
            name: "noUncheckedIndexedAccess",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Add_undefined_to_a_type_when_accessed_using_an_index,
            defaultValueDescription: false
        },
        {
            name: "noImplicitOverride",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Ensure_overriding_members_in_derived_classes_are_marked_with_an_override_modifier,
            defaultValueDescription: false
        },
        {
            name: "noPropertyAccessFromIndexSignature",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            showInSimplifiedHelpView: false,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Enforces_using_indexed_accessors_for_keys_declared_using_an_indexed_type,
            defaultValueDescription: false
        },
        // Module Resolution
        {
            name: "moduleResolution",
            type: new Map(Object.entries({
                // N.B. The first entry specifies the value shown in `tsc --init`
                node10: 2 /* Node10 */ ,
                node: 2 /* Node10 */ ,
                classic: 1 /* Classic */ ,
                node16: 3 /* Node16 */ ,
                nodenext: 99 /* NodeNext */ ,
                bundler: 100 /* Bundler */ 
            })),
            deprecatedKeys: /* @__PURE__ */ new Set([
                "node"
            ]),
            affectsSourceFile: true,
            affectsModuleResolution: true,
            paramType: Diagnostics.STRATEGY,
            category: Diagnostics.Modules,
            description: Diagnostics.Specify_how_TypeScript_looks_up_a_file_from_a_given_module_specifier,
            defaultValueDescription: Diagnostics.module_AMD_or_UMD_or_System_or_ES6_then_Classic_Otherwise_Node
        },
        {
            name: "baseUrl",
            type: "string",
            affectsModuleResolution: true,
            isFilePath: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Specify_the_base_directory_to_resolve_non_relative_module_names
        },
        {
            // this option can only be specified in tsconfig.json
            // use type = object to copy the value as-is
            name: "paths",
            type: "object",
            affectsModuleResolution: true,
            allowConfigDirTemplateSubstitution: true,
            isTSConfigOnly: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Specify_a_set_of_entries_that_re_map_imports_to_additional_lookup_locations,
            transpileOptionValue: void 0
        },
        {
            // this option can only be specified in tsconfig.json
            // use type = object to copy the value as-is
            name: "rootDirs",
            type: "list",
            isTSConfigOnly: true,
            element: {
                name: "rootDirs",
                type: "string",
                isFilePath: true
            },
            affectsModuleResolution: true,
            allowConfigDirTemplateSubstitution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Allow_multiple_folders_to_be_treated_as_one_when_resolving_modules,
            transpileOptionValue: void 0,
            defaultValueDescription: Diagnostics.Computed_from_the_list_of_input_files
        },
        {
            name: "typeRoots",
            type: "list",
            element: {
                name: "typeRoots",
                type: "string",
                isFilePath: true
            },
            affectsModuleResolution: true,
            allowConfigDirTemplateSubstitution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Specify_multiple_folders_that_act_like_Slashnode_modules_Slash_types
        },
        {
            name: "types",
            type: "list",
            element: {
                name: "types",
                type: "string"
            },
            affectsProgramStructure: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Specify_type_package_names_to_be_included_without_being_referenced_in_a_source_file,
            transpileOptionValue: void 0
        },
        {
            name: "allowSyntheticDefaultImports",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Allow_import_x_from_y_when_a_module_doesn_t_have_a_default_export,
            defaultValueDescription: Diagnostics.module_system_or_esModuleInterop
        },
        {
            name: "esModuleInterop",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            showInSimplifiedHelpView: true,
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Emit_additional_JavaScript_to_ease_support_for_importing_CommonJS_modules_This_enables_allowSyntheticDefaultImports_for_type_compatibility,
            defaultValueDescription: false
        },
        {
            name: "preserveSymlinks",
            type: "boolean",
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Disable_resolving_symlinks_to_their_realpath_This_correlates_to_the_same_flag_in_node,
            defaultValueDescription: false
        },
        {
            name: "allowUmdGlobalAccess",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Allow_accessing_UMD_globals_from_modules,
            defaultValueDescription: false
        },
        {
            name: "moduleSuffixes",
            type: "list",
            element: {
                name: "suffix",
                type: "string"
            },
            listPreserveFalsyValues: true,
            affectsModuleResolution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.List_of_file_name_suffixes_to_search_when_resolving_a_module
        },
        {
            name: "allowImportingTsExtensions",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Allow_imports_to_include_TypeScript_file_extensions_Requires_moduleResolution_bundler_and_either_noEmit_or_emitDeclarationOnly_to_be_set,
            defaultValueDescription: false,
            transpileOptionValue: void 0
        },
        {
            name: "rewriteRelativeImportExtensions",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Rewrite_ts_tsx_mts_and_cts_file_extensions_in_relative_import_paths_to_their_JavaScript_equivalent_in_output_files,
            defaultValueDescription: false
        },
        {
            name: "resolvePackageJsonExports",
            type: "boolean",
            affectsModuleResolution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Use_the_package_json_exports_field_when_resolving_package_imports,
            defaultValueDescription: Diagnostics.true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false
        },
        {
            name: "resolvePackageJsonImports",
            type: "boolean",
            affectsModuleResolution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Use_the_package_json_imports_field_when_resolving_imports,
            defaultValueDescription: Diagnostics.true_when_moduleResolution_is_node16_nodenext_or_bundler_otherwise_false
        },
        {
            name: "customConditions",
            type: "list",
            element: {
                name: "condition",
                type: "string"
            },
            affectsModuleResolution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Conditions_to_set_in_addition_to_the_resolver_specific_defaults_when_resolving_imports
        },
        {
            name: "noUncheckedSideEffectImports",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Check_side_effect_imports,
            defaultValueDescription: false
        },
        // Source Maps
        {
            name: "sourceRoot",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            paramType: Diagnostics.LOCATION,
            category: Diagnostics.Emit,
            description: Diagnostics.Specify_the_root_path_for_debuggers_to_find_the_reference_source_code
        },
        {
            name: "mapRoot",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            paramType: Diagnostics.LOCATION,
            category: Diagnostics.Emit,
            description: Diagnostics.Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations
        },
        {
            name: "inlineSources",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Include_source_code_in_the_sourcemaps_inside_the_emitted_JavaScript,
            defaultValueDescription: false
        },
        // Experimental
        {
            name: "experimentalDecorators",
            type: "boolean",
            affectsEmit: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Enable_experimental_support_for_legacy_experimental_decorators,
            defaultValueDescription: false
        },
        {
            name: "emitDecoratorMetadata",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Emit_design_type_metadata_for_decorated_declarations_in_source_files,
            defaultValueDescription: false
        },
        // Advanced
        {
            name: "jsxFactory",
            type: "string",
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Specify_the_JSX_factory_function_used_when_targeting_React_JSX_emit_e_g_React_createElement_or_h,
            defaultValueDescription: "`React.createElement`"
        },
        {
            name: "jsxFragmentFactory",
            type: "string",
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Specify_the_JSX_Fragment_reference_used_for_fragments_when_targeting_React_JSX_emit_e_g_React_Fragment_or_Fragment,
            defaultValueDescription: "React.Fragment"
        },
        {
            name: "jsxImportSource",
            type: "string",
            affectsSemanticDiagnostics: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsModuleResolution: true,
            affectsSourceFile: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Specify_module_specifier_used_to_import_the_JSX_factory_functions_when_using_jsx_Colon_react_jsx_Asterisk,
            defaultValueDescription: "react"
        },
        {
            name: "resolveJsonModule",
            type: "boolean",
            affectsModuleResolution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Enable_importing_json_files,
            defaultValueDescription: false
        },
        {
            name: "allowArbitraryExtensions",
            type: "boolean",
            affectsProgramStructure: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Enable_importing_files_with_any_extension_provided_a_declaration_file_is_present,
            defaultValueDescription: false
        },
        {
            name: "out",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsDeclarationPath: true,
            isFilePath: false,
            // This is intentionally broken to support compatibility with existing tsconfig files
            // for correct behaviour, please use outFile
            category: Diagnostics.Backwards_Compatibility,
            paramType: Diagnostics.FILE,
            transpileOptionValue: void 0,
            description: Diagnostics.Deprecated_setting_Use_outFile_instead
        },
        {
            name: "reactNamespace",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Specify_the_object_invoked_for_createElement_This_only_applies_when_targeting_react_JSX_emit,
            defaultValueDescription: "`React`"
        },
        {
            name: "skipDefaultLibCheck",
            type: "boolean",
            // We need to store these to determine whether `lib` files need to be rechecked
            affectsBuildInfo: true,
            category: Diagnostics.Completeness,
            description: Diagnostics.Skip_type_checking_d_ts_files_that_are_included_with_TypeScript,
            defaultValueDescription: false
        },
        {
            name: "charset",
            type: "string",
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.No_longer_supported_In_early_versions_manually_set_the_text_encoding_for_reading_files,
            defaultValueDescription: "utf8"
        },
        {
            name: "emitBOM",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files,
            defaultValueDescription: false
        },
        {
            name: "newLine",
            type: new Map(Object.entries({
                crlf: 0 /* CarriageReturnLineFeed */ ,
                lf: 1 /* LineFeed */ 
            })),
            affectsEmit: true,
            affectsBuildInfo: true,
            paramType: Diagnostics.NEWLINE,
            category: Diagnostics.Emit,
            description: Diagnostics.Set_the_newline_character_for_emitting_files,
            defaultValueDescription: "lf"
        },
        {
            name: "noErrorTruncation",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Output_Formatting,
            description: Diagnostics.Disable_truncating_types_in_error_messages,
            defaultValueDescription: false
        },
        {
            name: "noLib",
            type: "boolean",
            category: Diagnostics.Language_and_Environment,
            affectsProgramStructure: true,
            description: Diagnostics.Disable_including_any_library_files_including_the_default_lib_d_ts,
            // We are not returning a sourceFile for lib file when asked by the program,
            // so pass --noLib to avoid reporting a file not found error.
            transpileOptionValue: true,
            defaultValueDescription: false
        },
        {
            name: "noResolve",
            type: "boolean",
            affectsModuleResolution: true,
            category: Diagnostics.Modules,
            description: Diagnostics.Disallow_import_s_require_s_or_reference_s_from_expanding_the_number_of_files_TypeScript_should_add_to_a_project,
            // We are not doing a full typecheck, we are not resolving the whole context,
            // so pass --noResolve to avoid reporting missing file errors.
            transpileOptionValue: true,
            defaultValueDescription: false
        },
        {
            name: "stripInternal",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Disable_emitting_declarations_that_have_internal_in_their_JSDoc_comments,
            defaultValueDescription: false
        },
        {
            name: "disableSizeLimit",
            type: "boolean",
            affectsProgramStructure: true,
            category: Diagnostics.Editor_Support,
            description: Diagnostics.Remove_the_20mb_cap_on_total_source_code_size_for_JavaScript_files_in_the_TypeScript_language_server,
            defaultValueDescription: false
        },
        {
            name: "disableSourceOfProjectReferenceRedirect",
            type: "boolean",
            isTSConfigOnly: true,
            category: Diagnostics.Projects,
            description: Diagnostics.Disable_preferring_source_files_instead_of_declaration_files_when_referencing_composite_projects,
            defaultValueDescription: false
        },
        {
            name: "disableSolutionSearching",
            type: "boolean",
            isTSConfigOnly: true,
            category: Diagnostics.Projects,
            description: Diagnostics.Opt_a_project_out_of_multi_project_reference_checking_when_editing,
            defaultValueDescription: false
        },
        {
            name: "disableReferencedProjectLoad",
            type: "boolean",
            isTSConfigOnly: true,
            category: Diagnostics.Projects,
            description: Diagnostics.Reduce_the_number_of_projects_loaded_automatically_by_TypeScript,
            defaultValueDescription: false
        },
        {
            name: "noImplicitUseStrict",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Disable_adding_use_strict_directives_in_emitted_JavaScript_files,
            defaultValueDescription: false
        },
        {
            name: "noEmitHelpers",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Disable_generating_custom_helper_functions_like_extends_in_compiled_output,
            defaultValueDescription: false
        },
        {
            name: "noEmitOnError",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            transpileOptionValue: void 0,
            description: Diagnostics.Disable_emitting_files_if_any_type_checking_errors_are_reported,
            defaultValueDescription: false
        },
        {
            name: "preserveConstEnums",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Emit,
            description: Diagnostics.Disable_erasing_const_enum_declarations_in_generated_code,
            defaultValueDescription: false
        },
        {
            name: "declarationDir",
            type: "string",
            affectsEmit: true,
            affectsBuildInfo: true,
            affectsDeclarationPath: true,
            isFilePath: true,
            paramType: Diagnostics.DIRECTORY,
            category: Diagnostics.Emit,
            transpileOptionValue: void 0,
            description: Diagnostics.Specify_the_output_directory_for_generated_declaration_files
        },
        {
            name: "skipLibCheck",
            type: "boolean",
            // We need to store these to determine whether `lib` files need to be rechecked
            affectsBuildInfo: true,
            category: Diagnostics.Completeness,
            description: Diagnostics.Skip_type_checking_all_d_ts_files,
            defaultValueDescription: false
        },
        {
            name: "allowUnusedLabels",
            type: "boolean",
            affectsBindDiagnostics: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Disable_error_reporting_for_unused_labels,
            defaultValueDescription: void 0
        },
        {
            name: "allowUnreachableCode",
            type: "boolean",
            affectsBindDiagnostics: true,
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Type_Checking,
            description: Diagnostics.Disable_error_reporting_for_unreachable_code,
            defaultValueDescription: void 0
        },
        {
            name: "suppressExcessPropertyErrors",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Disable_reporting_of_excess_property_errors_during_the_creation_of_object_literals,
            defaultValueDescription: false
        },
        {
            name: "suppressImplicitAnyIndexErrors",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Suppress_noImplicitAny_errors_when_indexing_objects_that_lack_index_signatures,
            defaultValueDescription: false
        },
        {
            name: "forceConsistentCasingInFileNames",
            type: "boolean",
            affectsModuleResolution: true,
            category: Diagnostics.Interop_Constraints,
            description: Diagnostics.Ensure_that_casing_is_correct_in_imports,
            defaultValueDescription: true
        },
        {
            name: "maxNodeModuleJsDepth",
            type: "number",
            affectsModuleResolution: true,
            category: Diagnostics.JavaScript_Support,
            description: Diagnostics.Specify_the_maximum_folder_depth_used_for_checking_JavaScript_files_from_node_modules_Only_applicable_with_allowJs,
            defaultValueDescription: 0
        },
        {
            name: "noStrictGenericChecks",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsBuildInfo: true,
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Disable_strict_checking_of_generic_signatures_in_function_types,
            defaultValueDescription: false
        },
        {
            name: "useDefineForClassFields",
            type: "boolean",
            affectsSemanticDiagnostics: true,
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Language_and_Environment,
            description: Diagnostics.Emit_ECMAScript_standard_compliant_class_fields,
            defaultValueDescription: Diagnostics.true_for_ES2022_and_above_including_ESNext
        },
        {
            name: "preserveValueImports",
            type: "boolean",
            affectsEmit: true,
            affectsBuildInfo: true,
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Preserve_unused_imported_values_in_the_JavaScript_output_that_would_otherwise_be_removed,
            defaultValueDescription: false
        },
        {
            name: "keyofStringsOnly",
            type: "boolean",
            category: Diagnostics.Backwards_Compatibility,
            description: Diagnostics.Make_keyof_only_return_strings_instead_of_string_numbers_or_symbols_Legacy_option,
            defaultValueDescription: false
        },
        {
            // A list of plugins to load in the language service
            name: "plugins",
            type: "list",
            isTSConfigOnly: true,
            element: {
                name: "plugin",
                type: "object"
            },
            description: Diagnostics.Specify_a_list_of_language_service_plugins_to_include,
            category: Diagnostics.Editor_Support
        },
        {
            name: "moduleDetection",
            type: new Map(Object.entries({
                auto: 2 /* Auto */ ,
                legacy: 1 /* Legacy */ ,
                force: 3 /* Force */ 
            })),
            affectsSourceFile: true,
            affectsModuleResolution: true,
            description: Diagnostics.Control_what_method_is_used_to_detect_module_format_JS_files,
            category: Diagnostics.Language_and_Environment,
            defaultValueDescription: Diagnostics.auto_Colon_Treat_files_with_imports_exports_import_meta_jsx_with_jsx_Colon_react_jsx_or_esm_format_with_module_Colon_node16_as_modules
        },
        {
            name: "ignoreDeprecations",
            type: "string",
            defaultValueDescription: void 0
        }
    ];
    var optionDeclarations = [
        ...commonOptionsWithBuild,
        ...commandOptionsWithoutBuild
    ];
    var semanticDiagnosticsOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsSemanticDiagnostics);
    var affectsEmitOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsEmit);
    var affectsDeclarationPathOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsDeclarationPath);
    var moduleResolutionOptionDeclarations = optionDeclarations.filter((option)=>!!option.affectsModuleResolution);
    var sourceFileAffectingCompilerOptions = optionDeclarations.filter((option)=>!!option.affectsSourceFile || !!option.affectsBindDiagnostics);
    var optionsAffectingProgramStructure = optionDeclarations.filter((option)=>!!option.affectsProgramStructure);
    var transpileOptionValueCompilerOptions = optionDeclarations.filter((option)=>hasProperty(option, "transpileOptionValue"));
    var configDirTemplateSubstitutionOptions = optionDeclarations.filter((option)=>option.allowConfigDirTemplateSubstitution || !option.isCommandLineOnly && option.isFilePath);
    var configDirTemplateSubstitutionWatchOptions = optionsForWatch.filter((option)=>option.allowConfigDirTemplateSubstitution || !option.isCommandLineOnly && option.isFilePath);
    var commandLineOptionOfCustomType = optionDeclarations.filter(isCommandLineOptionOfCustomType);
    function isCommandLineOptionOfCustomType(option) {
        return !isString(option.type);
    }
    var tscBuildOption = {
        name: "build",
        type: "boolean",
        shortName: "b",
        showInSimplifiedHelpView: true,
        category: Diagnostics.Command_line_Options,
        description: Diagnostics.Build_one_or_more_projects_and_their_dependencies_if_out_of_date,
        defaultValueDescription: false
    };
    var optionsForBuild = [
        tscBuildOption,
        {
            name: "verbose",
            shortName: "v",
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Enable_verbose_logging,
            type: "boolean",
            defaultValueDescription: false
        },
        {
            name: "dry",
            shortName: "d",
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Show_what_would_be_built_or_deleted_if_specified_with_clean,
            type: "boolean",
            defaultValueDescription: false
        },
        {
            name: "force",
            shortName: "f",
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Build_all_projects_including_those_that_appear_to_be_up_to_date,
            type: "boolean",
            defaultValueDescription: false
        },
        {
            name: "clean",
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Delete_the_outputs_of_all_projects,
            type: "boolean",
            defaultValueDescription: false
        },
        {
            name: "stopBuildOnErrors",
            category: Diagnostics.Command_line_Options,
            description: Diagnostics.Skip_building_downstream_projects_on_error_in_upstream_project,
            type: "boolean",
            defaultValueDescription: false
        }
    ];
    var buildOpts = [
        ...commonOptionsWithBuild,
        ...optionsForBuild
    ];
    var typeAcquisitionDeclarations = [
        {
            name: "enable",
            type: "boolean",
            defaultValueDescription: false
        },
        {
            name: "include",
            type: "list",
            element: {
                name: "include",
                type: "string"
            }
        },
        {
            name: "exclude",
            type: "list",
            element: {
                name: "exclude",
                type: "string"
            }
        },
        {
            name: "disableFilenameBasedTypeAcquisition",
            type: "boolean",
            defaultValueDescription: false
        }
    ];
    function createOptionNameMap(optionDeclarations2) {
        const optionsNameMap = /* @__PURE__ */ new Map();
        const shortOptionNames = /* @__PURE__ */ new Map();
        forEach(optionDeclarations2, (option)=>{
            optionsNameMap.set(option.name.toLowerCase(), option);
            if (option.shortName) shortOptionNames.set(option.shortName, option.name);
        });
        return {
            optionsNameMap,
            shortOptionNames
        };
    }
    var optionsNameMapCache;
    function getOptionsNameMap() {
        return optionsNameMapCache || (optionsNameMapCache = createOptionNameMap(optionDeclarations));
    }
    var compilerOptionsAlternateMode = {
        diagnostic: Diagnostics.Compiler_option_0_may_only_be_used_with_build,
        getOptionsNameMap: getBuildOptionsNameMap
    };
    var defaultInitCompilerOptions = {
        module: 1 /* CommonJS */ ,
        target: 3 /* ES2016 */ ,
        strict: true,
        esModuleInterop: true,
        forceConsistentCasingInFileNames: true,
        skipLibCheck: true
    };
    function createCompilerDiagnosticForInvalidCustomType(opt) {
        return createDiagnosticForInvalidCustomType(opt, createCompilerDiagnostic);
    }
    function createDiagnosticForInvalidCustomType(opt, createDiagnostic) {
        const namesOfType = arrayFrom(opt.type.keys());
        const stringNames = (opt.deprecatedKeys ? namesOfType.filter((k)=>!opt.deprecatedKeys.has(k)) : namesOfType).map((key)=>`'${key}'`).join(", ");
        return createDiagnostic(Diagnostics.Argument_for_0_option_must_be_Colon_1, `--${opt.name}`, stringNames);
    }
    function parseCustomTypeOption(opt, value1, errors) {
        return convertJsonOptionOfCustomType(opt, (value1 !== null && value1 !== void 0 ? value1 : "").trim(), errors);
    }
    function parseListTypeOption(opt, value1 = "", errors) {
        value1 = value1.trim();
        if (startsWith(value1, "-")) return void 0;
        if (opt.type === "listOrElement" && !value1.includes(",")) return validateJsonOptionValue(opt, value1, errors);
        if (value1 === "") return [];
        const values = value1.split(",");
        switch(opt.element.type){
            case "number":
                return mapDefined(values, (v1)=>validateJsonOptionValue(opt.element, parseInt(v1), errors));
            case "string":
                return mapDefined(values, (v1)=>validateJsonOptionValue(opt.element, v1 || "", errors));
            case "boolean":
            case "object":
                return Debug.fail(`List of ${opt.element.type} is not yet supported.`);
            default:
                return mapDefined(values, (v1)=>parseCustomTypeOption(opt.element, v1, errors));
        }
    }
    function getOptionName(option) {
        return option.name;
    }
    function createUnknownOptionError(unknownOption, diagnostics, unknownOptionErrorText, node, sourceFile) {
        var _a;
        const otherOption = (_a = diagnostics.alternateMode) == null ? void 0 : _a.getOptionsNameMap().optionsNameMap.get(unknownOption.toLowerCase());
        if (otherOption) return createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, otherOption !== tscBuildOption ? diagnostics.alternateMode.diagnostic : Diagnostics.Option_build_must_be_the_first_command_line_argument, unknownOption);
        const possibleOption = getSpellingSuggestion(unknownOption, diagnostics.optionDeclarations, getOptionName);
        return possibleOption ? createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, diagnostics.unknownDidYouMeanDiagnostic, unknownOptionErrorText || unknownOption, possibleOption.name) : createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, diagnostics.unknownOptionDiagnostic, unknownOptionErrorText || unknownOption);
    }
    function parseCommandLineWorker(diagnostics, commandLine, readFile) {
        const options = {};
        let watchOptions;
        const fileNames = [];
        const errors = [];
        parseStrings(commandLine);
        return {
            options,
            watchOptions,
            fileNames,
            errors
        };
        function parseStrings(args) {
            let i = 0;
            while(i < args.length){
                const s = args[i];
                i++;
                if (s.charCodeAt(0) === 64 /* at */ ) parseResponseFile(s.slice(1));
                else if (s.charCodeAt(0) === 45 /* minus */ ) {
                    const inputOptionName = s.slice(s.charCodeAt(1) === 45 /* minus */  ? 2 : 1);
                    const opt = getOptionDeclarationFromName(diagnostics.getOptionsNameMap, inputOptionName, /*allowShort*/ true);
                    if (opt) i = parseOptionValue(args, i, diagnostics, opt, options, errors);
                    else {
                        const watchOpt = getOptionDeclarationFromName(watchOptionsDidYouMeanDiagnostics.getOptionsNameMap, inputOptionName, /*allowShort*/ true);
                        if (watchOpt) i = parseOptionValue(args, i, watchOptionsDidYouMeanDiagnostics, watchOpt, watchOptions || (watchOptions = {}), errors);
                        else errors.push(createUnknownOptionError(inputOptionName, diagnostics, s));
                    }
                } else fileNames.push(s);
            }
        }
        function parseResponseFile(fileName) {
            const text = tryReadFile(fileName, readFile || ((fileName2)=>sys.readFile(fileName2)));
            if (!isString(text)) {
                errors.push(text);
                return;
            }
            const args = [];
            let pos = 0;
            while(true){
                while(pos < text.length && text.charCodeAt(pos) <= 32 /* space */ )pos++;
                if (pos >= text.length) break;
                const start = pos;
                if (text.charCodeAt(start) === 34 /* doubleQuote */ ) {
                    pos++;
                    while(pos < text.length && text.charCodeAt(pos) !== 34 /* doubleQuote */ )pos++;
                    if (pos < text.length) {
                        args.push(text.substring(start + 1, pos));
                        pos++;
                    } else errors.push(createCompilerDiagnostic(Diagnostics.Unterminated_quoted_string_in_response_file_0, fileName));
                } else {
                    while(text.charCodeAt(pos) > 32 /* space */ )pos++;
                    args.push(text.substring(start, pos));
                }
            }
            parseStrings(args);
        }
    }
    function parseOptionValue(args, i, diagnostics, opt, options, errors) {
        if (opt.isTSConfigOnly) {
            const optValue = args[i];
            if (optValue === "null") {
                options[opt.name] = void 0;
                i++;
            } else if (opt.type === "boolean") {
                if (optValue === "false") {
                    options[opt.name] = validateJsonOptionValue(opt, /*value*/ false, errors);
                    i++;
                } else {
                    if (optValue === "true") i++;
                    errors.push(createCompilerDiagnostic(Diagnostics.Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_false_or_null_on_command_line, opt.name));
                }
            } else {
                errors.push(createCompilerDiagnostic(Diagnostics.Option_0_can_only_be_specified_in_tsconfig_json_file_or_set_to_null_on_command_line, opt.name));
                if (optValue && !startsWith(optValue, "-")) i++;
            }
        } else {
            if (!args[i] && opt.type !== "boolean") errors.push(createCompilerDiagnostic(diagnostics.optionTypeMismatchDiagnostic, opt.name, getCompilerOptionValueTypeString(opt)));
            if (args[i] !== "null") switch(opt.type){
                case "number":
                    options[opt.name] = validateJsonOptionValue(opt, parseInt(args[i]), errors);
                    i++;
                    break;
                case "boolean":
                    const optValue = args[i];
                    options[opt.name] = validateJsonOptionValue(opt, optValue !== "false", errors);
                    if (optValue === "false" || optValue === "true") i++;
                    break;
                case "string":
                    options[opt.name] = validateJsonOptionValue(opt, args[i] || "", errors);
                    i++;
                    break;
                case "list":
                    const result = parseListTypeOption(opt, args[i], errors);
                    options[opt.name] = result || [];
                    if (result) i++;
                    break;
                case "listOrElement":
                    Debug.fail("listOrElement not supported here");
                    break;
                // If not a primitive, the possible types are specified in what is effectively a map of options.
                default:
                    options[opt.name] = parseCustomTypeOption(opt, args[i], errors);
                    i++;
                    break;
            }
            else {
                options[opt.name] = void 0;
                i++;
            }
        }
        return i;
    }
    var compilerOptionsDidYouMeanDiagnostics = {
        alternateMode: compilerOptionsAlternateMode,
        getOptionsNameMap,
        optionDeclarations,
        unknownOptionDiagnostic: Diagnostics.Unknown_compiler_option_0,
        unknownDidYouMeanDiagnostic: Diagnostics.Unknown_compiler_option_0_Did_you_mean_1,
        optionTypeMismatchDiagnostic: Diagnostics.Compiler_option_0_expects_an_argument
    };
    function parseCommandLine(commandLine, readFile) {
        return parseCommandLineWorker(compilerOptionsDidYouMeanDiagnostics, commandLine, readFile);
    }
    function getOptionFromName(optionName, allowShort) {
        return getOptionDeclarationFromName(getOptionsNameMap, optionName, allowShort);
    }
    function getOptionDeclarationFromName(getOptionNameMap, optionName, allowShort = false) {
        optionName = optionName.toLowerCase();
        const { optionsNameMap, shortOptionNames } = getOptionNameMap();
        if (allowShort) {
            const short = shortOptionNames.get(optionName);
            if (short !== void 0) optionName = short;
        }
        return optionsNameMap.get(optionName);
    }
    var buildOptionsNameMapCache;
    function getBuildOptionsNameMap() {
        return buildOptionsNameMapCache || (buildOptionsNameMapCache = createOptionNameMap(buildOpts));
    }
    var buildOptionsAlternateMode = {
        diagnostic: Diagnostics.Compiler_option_0_may_not_be_used_with_build,
        getOptionsNameMap
    };
    var buildOptionsDidYouMeanDiagnostics = {
        alternateMode: buildOptionsAlternateMode,
        getOptionsNameMap: getBuildOptionsNameMap,
        optionDeclarations: buildOpts,
        unknownOptionDiagnostic: Diagnostics.Unknown_build_option_0,
        unknownDidYouMeanDiagnostic: Diagnostics.Unknown_build_option_0_Did_you_mean_1,
        optionTypeMismatchDiagnostic: Diagnostics.Build_option_0_requires_a_value_of_type_1
    };
    function parseBuildCommand(commandLine) {
        const { options, watchOptions, fileNames: projects, errors } = parseCommandLineWorker(buildOptionsDidYouMeanDiagnostics, commandLine);
        const buildOptions = options;
        if (projects.length === 0) projects.push(".");
        if (buildOptions.clean && buildOptions.force) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "clean", "force"));
        if (buildOptions.clean && buildOptions.verbose) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "clean", "verbose"));
        if (buildOptions.clean && buildOptions.watch) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "clean", "watch"));
        if (buildOptions.watch && buildOptions.dry) errors.push(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "watch", "dry"));
        return {
            buildOptions,
            watchOptions,
            projects,
            errors
        };
    }
    function getDiagnosticText(message, ...args) {
        return cast(createCompilerDiagnostic(message, ...args).messageText, isString);
    }
    function getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host, extendedConfigCache, watchOptionsToExtend, extraFileExtensions) {
        const configFileText = tryReadFile(configFileName, (fileName)=>host.readFile(fileName));
        if (!isString(configFileText)) {
            host.onUnRecoverableConfigFileDiagnostic(configFileText);
            return void 0;
        }
        const result = parseJsonText(configFileName, configFileText);
        const cwd = host.getCurrentDirectory();
        result.path = toPath(configFileName, cwd, createGetCanonicalFileName(host.useCaseSensitiveFileNames));
        result.resolvedPath = result.path;
        result.originalFileName = result.fileName;
        return parseJsonSourceFileConfigFileContent(result, host, getNormalizedAbsolutePath(getDirectoryPath(configFileName), cwd), optionsToExtend, getNormalizedAbsolutePath(configFileName, cwd), /*resolutionStack*/ void 0, extraFileExtensions, extendedConfigCache, watchOptionsToExtend);
    }
    function readConfigFile(fileName, readFile) {
        const textOrDiagnostic = tryReadFile(fileName, readFile);
        return isString(textOrDiagnostic) ? parseConfigFileTextToJson(fileName, textOrDiagnostic) : {
            config: {},
            error: textOrDiagnostic
        };
    }
    function parseConfigFileTextToJson(fileName, jsonText) {
        const jsonSourceFile = parseJsonText(fileName, jsonText);
        return {
            config: convertConfigFileToObject(jsonSourceFile, jsonSourceFile.parseDiagnostics, /*jsonConversionNotifier*/ void 0),
            error: jsonSourceFile.parseDiagnostics.length ? jsonSourceFile.parseDiagnostics[0] : void 0
        };
    }
    function readJsonConfigFile(fileName, readFile) {
        const textOrDiagnostic = tryReadFile(fileName, readFile);
        return isString(textOrDiagnostic) ? parseJsonText(fileName, textOrDiagnostic) : {
            fileName,
            parseDiagnostics: [
                textOrDiagnostic
            ]
        };
    }
    function tryReadFile(fileName, readFile) {
        let text;
        try {
            text = readFile(fileName);
        } catch (e) {
            return createCompilerDiagnostic(Diagnostics.Cannot_read_file_0_Colon_1, fileName, e.message);
        }
        return text === void 0 ? createCompilerDiagnostic(Diagnostics.Cannot_read_file_0, fileName) : text;
    }
    function commandLineOptionsToMap(options) {
        return arrayToMap(options, getOptionName);
    }
    var typeAcquisitionDidYouMeanDiagnostics = {
        optionDeclarations: typeAcquisitionDeclarations,
        unknownOptionDiagnostic: Diagnostics.Unknown_type_acquisition_option_0,
        unknownDidYouMeanDiagnostic: Diagnostics.Unknown_type_acquisition_option_0_Did_you_mean_1
    };
    var watchOptionsNameMapCache;
    function getWatchOptionsNameMap() {
        return watchOptionsNameMapCache || (watchOptionsNameMapCache = createOptionNameMap(optionsForWatch));
    }
    var watchOptionsDidYouMeanDiagnostics = {
        getOptionsNameMap: getWatchOptionsNameMap,
        optionDeclarations: optionsForWatch,
        unknownOptionDiagnostic: Diagnostics.Unknown_watch_option_0,
        unknownDidYouMeanDiagnostic: Diagnostics.Unknown_watch_option_0_Did_you_mean_1,
        optionTypeMismatchDiagnostic: Diagnostics.Watch_option_0_requires_a_value_of_type_1
    };
    var commandLineCompilerOptionsMapCache;
    function getCommandLineCompilerOptionsMap() {
        return commandLineCompilerOptionsMapCache || (commandLineCompilerOptionsMapCache = commandLineOptionsToMap(optionDeclarations));
    }
    var commandLineWatchOptionsMapCache;
    function getCommandLineWatchOptionsMap() {
        return commandLineWatchOptionsMapCache || (commandLineWatchOptionsMapCache = commandLineOptionsToMap(optionsForWatch));
    }
    var commandLineTypeAcquisitionMapCache;
    function getCommandLineTypeAcquisitionMap() {
        return commandLineTypeAcquisitionMapCache || (commandLineTypeAcquisitionMapCache = commandLineOptionsToMap(typeAcquisitionDeclarations));
    }
    var extendsOptionDeclaration = {
        name: "extends",
        type: "listOrElement",
        element: {
            name: "extends",
            type: "string"
        },
        category: Diagnostics.File_Management,
        disallowNullOrUndefined: true
    };
    var compilerOptionsDeclaration = {
        name: "compilerOptions",
        type: "object",
        elementOptions: getCommandLineCompilerOptionsMap(),
        extraKeyDiagnostics: compilerOptionsDidYouMeanDiagnostics
    };
    var watchOptionsDeclaration = {
        name: "watchOptions",
        type: "object",
        elementOptions: getCommandLineWatchOptionsMap(),
        extraKeyDiagnostics: watchOptionsDidYouMeanDiagnostics
    };
    var typeAcquisitionDeclaration = {
        name: "typeAcquisition",
        type: "object",
        elementOptions: getCommandLineTypeAcquisitionMap(),
        extraKeyDiagnostics: typeAcquisitionDidYouMeanDiagnostics
    };
    var _tsconfigRootOptions;
    function getTsconfigRootOptionsMap() {
        if (_tsconfigRootOptions === void 0) _tsconfigRootOptions = {
            name: void 0,
            // should never be needed since this is root
            type: "object",
            elementOptions: commandLineOptionsToMap([
                compilerOptionsDeclaration,
                watchOptionsDeclaration,
                typeAcquisitionDeclaration,
                extendsOptionDeclaration,
                {
                    name: "references",
                    type: "list",
                    element: {
                        name: "references",
                        type: "object"
                    },
                    category: Diagnostics.Projects
                },
                {
                    name: "files",
                    type: "list",
                    element: {
                        name: "files",
                        type: "string"
                    },
                    category: Diagnostics.File_Management
                },
                {
                    name: "include",
                    type: "list",
                    element: {
                        name: "include",
                        type: "string"
                    },
                    category: Diagnostics.File_Management,
                    defaultValueDescription: Diagnostics.if_files_is_specified_otherwise_Asterisk_Asterisk_Slash_Asterisk
                },
                {
                    name: "exclude",
                    type: "list",
                    element: {
                        name: "exclude",
                        type: "string"
                    },
                    category: Diagnostics.File_Management,
                    defaultValueDescription: Diagnostics.node_modules_bower_components_jspm_packages_plus_the_value_of_outDir_if_one_is_specified
                },
                compileOnSaveCommandLineOption
            ])
        };
        return _tsconfigRootOptions;
    }
    function convertConfigFileToObject(sourceFile, errors, jsonConversionNotifier) {
        var _a;
        const rootExpression = (_a = sourceFile.statements[0]) == null ? void 0 : _a.expression;
        if (rootExpression && rootExpression.kind !== 211 /* ObjectLiteralExpression */ ) {
            errors.push(createDiagnosticForNodeInSourceFile(sourceFile, rootExpression, Diagnostics.The_root_value_of_a_0_file_must_be_an_object, getBaseFileName(sourceFile.fileName) === "jsconfig.json" ? "jsconfig.json" : "tsconfig.json"));
            if (isArrayLiteralExpression(rootExpression)) {
                const firstObject = find(rootExpression.elements, isObjectLiteralExpression);
                if (firstObject) return convertToJson(sourceFile, firstObject, errors, /*returnValue*/ true, jsonConversionNotifier);
            }
            return {};
        }
        return convertToJson(sourceFile, rootExpression, errors, /*returnValue*/ true, jsonConversionNotifier);
    }
    function convertToObject(sourceFile, errors) {
        var _a;
        return convertToJson(sourceFile, (_a = sourceFile.statements[0]) == null ? void 0 : _a.expression, errors, /*returnValue*/ true, /*jsonConversionNotifier*/ void 0);
    }
    function convertToJson(sourceFile, rootExpression, errors, returnValue, jsonConversionNotifier) {
        if (!rootExpression) return returnValue ? {} : void 0;
        return convertPropertyValueToJson(rootExpression, jsonConversionNotifier == null ? void 0 : jsonConversionNotifier.rootOptions);
        function convertObjectLiteralExpressionToJson(node, objectOption) {
            var _a;
            const result = returnValue ? {} : void 0;
            for (const element of node.properties){
                if (element.kind !== 304 /* PropertyAssignment */ ) {
                    errors.push(createDiagnosticForNodeInSourceFile(sourceFile, element, Diagnostics.Property_assignment_expected));
                    continue;
                }
                if (element.questionToken) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, element.questionToken, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, "?"));
                if (!isDoubleQuotedString(element.name)) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, element.name, Diagnostics.String_literal_with_double_quotes_expected));
                const textOfKey = isComputedNonLiteralName(element.name) ? void 0 : getTextOfPropertyName(element.name);
                const keyText = textOfKey && unescapeLeadingUnderscores(textOfKey);
                const option = keyText ? (_a = objectOption == null ? void 0 : objectOption.elementOptions) == null ? void 0 : _a.get(keyText) : void 0;
                const value1 = convertPropertyValueToJson(element.initializer, option);
                if (typeof keyText !== "undefined") {
                    if (returnValue) result[keyText] = value1;
                    jsonConversionNotifier == null || jsonConversionNotifier.onPropertySet(keyText, value1, element, objectOption, option);
                }
            }
            return result;
        }
        function convertArrayLiteralExpressionToJson(elements, elementOption) {
            if (!returnValue) {
                elements.forEach((element)=>convertPropertyValueToJson(element, elementOption));
                return void 0;
            }
            return filter(elements.map((element)=>convertPropertyValueToJson(element, elementOption)), (v1)=>v1 !== void 0);
        }
        function convertPropertyValueToJson(valueExpression, option) {
            switch(valueExpression.kind){
                case 112 /* TrueKeyword */ :
                    return true;
                case 97 /* FalseKeyword */ :
                    return false;
                case 106 /* NullKeyword */ :
                    return null;
                // eslint-disable-line no-restricted-syntax
                case 11 /* StringLiteral */ :
                    if (!isDoubleQuotedString(valueExpression)) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, Diagnostics.String_literal_with_double_quotes_expected));
                    return valueExpression.text;
                case 9 /* NumericLiteral */ :
                    return Number(valueExpression.text);
                case 225 /* PrefixUnaryExpression */ :
                    if (valueExpression.operator !== 41 /* MinusToken */  || valueExpression.operand.kind !== 9 /* NumericLiteral */ ) break;
                    return -Number(valueExpression.operand.text);
                case 211 /* ObjectLiteralExpression */ :
                    const objectLiteralExpression = valueExpression;
                    return convertObjectLiteralExpressionToJson(objectLiteralExpression, option);
                case 210 /* ArrayLiteralExpression */ :
                    return convertArrayLiteralExpressionToJson(valueExpression.elements, option && option.element);
            }
            if (option) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, Diagnostics.Compiler_option_0_requires_a_value_of_type_1, option.name, getCompilerOptionValueTypeString(option)));
            else errors.push(createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, Diagnostics.Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal));
            return void 0;
        }
        function isDoubleQuotedString(node) {
            return isStringLiteral(node) && isStringDoubleQuoted(node, sourceFile);
        }
    }
    function getCompilerOptionValueTypeString(option) {
        return option.type === "listOrElement" ? `${getCompilerOptionValueTypeString(option.element)} or Array` : option.type === "list" ? "Array" : isString(option.type) ? option.type : "string";
    }
    function isCompilerOptionsValue(option, value1) {
        if (option) {
            if (isNullOrUndefined(value1)) return !option.disallowNullOrUndefined;
            if (option.type === "list") return isArray(value1);
            if (option.type === "listOrElement") return isArray(value1) || isCompilerOptionsValue(option.element, value1);
            const expectedType = isString(option.type) ? option.type : "string";
            return typeof value1 === expectedType;
        }
        return false;
    }
    function convertToTSConfig(configParseResult, configFileName, host) {
        var _a, _b, _c;
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames);
        const files = map(filter(configParseResult.fileNames, !((_b = (_a = configParseResult.options.configFile) == null ? void 0 : _a.configFileSpecs) == null ? void 0 : _b.validatedIncludeSpecs) ? returnTrue : matchesSpecs(configFileName, configParseResult.options.configFile.configFileSpecs.validatedIncludeSpecs, configParseResult.options.configFile.configFileSpecs.validatedExcludeSpecs, host)), (f)=>getRelativePathFromFile(getNormalizedAbsolutePath(configFileName, host.getCurrentDirectory()), getNormalizedAbsolutePath(f, host.getCurrentDirectory()), getCanonicalFileName));
        const pathOptions = {
            configFilePath: getNormalizedAbsolutePath(configFileName, host.getCurrentDirectory()),
            useCaseSensitiveFileNames: host.useCaseSensitiveFileNames
        };
        const optionMap = serializeCompilerOptions(configParseResult.options, pathOptions);
        const watchOptionMap = configParseResult.watchOptions && serializeWatchOptions(configParseResult.watchOptions);
        const config = (0, _objectSpreadProps._)((0, _objectSpread._)({
            compilerOptions: (0, _objectSpreadProps._)((0, _objectSpread._)({}, optionMapToObject(optionMap)), {
                showConfig: void 0,
                configFile: void 0,
                configFilePath: void 0,
                help: void 0,
                init: void 0,
                listFiles: void 0,
                listEmittedFiles: void 0,
                project: void 0,
                build: void 0,
                version: void 0
            }),
            watchOptions: watchOptionMap && optionMapToObject(watchOptionMap),
            references: map(configParseResult.projectReferences, (r)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                    path: r.originalPath ? r.originalPath : "",
                    originalPath: void 0
                })),
            files: length(files) ? files : void 0
        }, ((_c = configParseResult.options.configFile) == null ? void 0 : _c.configFileSpecs) ? {
            include: filterSameAsDefaultInclude(configParseResult.options.configFile.configFileSpecs.validatedIncludeSpecs),
            exclude: configParseResult.options.configFile.configFileSpecs.validatedExcludeSpecs
        } : {}), {
            compileOnSave: !!configParseResult.compileOnSave ? true : void 0
        });
        const providedKeys = new Set(optionMap.keys());
        const impliedCompilerOptions = {};
        for(const option in computedOptions)if (!providedKeys.has(option) && optionDependsOn(option, providedKeys)) {
            const implied = computedOptions[option].computeValue(configParseResult.options);
            const defaultValue = computedOptions[option].computeValue({});
            if (implied !== defaultValue) impliedCompilerOptions[option] = computedOptions[option].computeValue(configParseResult.options);
        }
        assign(config.compilerOptions, optionMapToObject(serializeCompilerOptions(impliedCompilerOptions, pathOptions)));
        return config;
    }
    function optionDependsOn(option, dependsOn) {
        const seen = /* @__PURE__ */ new Set();
        return optionDependsOnRecursive(option);
        function optionDependsOnRecursive(option2) {
            var _a;
            if (addToSeen(seen, option2)) return some((_a = computedOptions[option2]) == null ? void 0 : _a.dependencies, (dep)=>dependsOn.has(dep) || optionDependsOnRecursive(dep));
            return false;
        }
    }
    function optionMapToObject(optionMap) {
        return Object.fromEntries(optionMap);
    }
    function filterSameAsDefaultInclude(specs) {
        if (!length(specs)) return void 0;
        if (length(specs) !== 1) return specs;
        if (specs[0] === defaultIncludeSpec) return void 0;
        return specs;
    }
    function matchesSpecs(path, includeSpecs, excludeSpecs, host) {
        if (!includeSpecs) return returnTrue;
        const patterns = getFileMatcherPatterns(path, excludeSpecs, includeSpecs, host.useCaseSensitiveFileNames, host.getCurrentDirectory());
        const excludeRe = patterns.excludePattern && getRegexFromPattern(patterns.excludePattern, host.useCaseSensitiveFileNames);
        const includeRe = patterns.includeFilePattern && getRegexFromPattern(patterns.includeFilePattern, host.useCaseSensitiveFileNames);
        if (includeRe) {
            if (excludeRe) return (path2)=>!(includeRe.test(path2) && !excludeRe.test(path2));
            return (path2)=>!includeRe.test(path2);
        }
        if (excludeRe) return (path2)=>excludeRe.test(path2);
        return returnTrue;
    }
    function getCustomTypeMapOfCommandLineOption(optionDefinition) {
        switch(optionDefinition.type){
            case "string":
            case "number":
            case "boolean":
            case "object":
                return void 0;
            case "list":
            case "listOrElement":
                return getCustomTypeMapOfCommandLineOption(optionDefinition.element);
            default:
                return optionDefinition.type;
        }
    }
    function getNameOfCompilerOptionValue(value1, customTypeMap) {
        return forEachEntry(customTypeMap, (mapValue, key)=>{
            if (mapValue === value1) return key;
        });
    }
    function serializeCompilerOptions(options, pathOptions) {
        return serializeOptionBaseObject(options, getOptionsNameMap(), pathOptions);
    }
    function serializeWatchOptions(options) {
        return serializeOptionBaseObject(options, getWatchOptionsNameMap());
    }
    function serializeOptionBaseObject(options, { optionsNameMap }, pathOptions) {
        const result = /* @__PURE__ */ new Map();
        const getCanonicalFileName = pathOptions && createGetCanonicalFileName(pathOptions.useCaseSensitiveFileNames);
        for(const name in options)if (hasProperty(options, name)) {
            if (optionsNameMap.has(name) && (optionsNameMap.get(name).category === Diagnostics.Command_line_Options || optionsNameMap.get(name).category === Diagnostics.Output_Formatting)) continue;
            const value1 = options[name];
            const optionDefinition = optionsNameMap.get(name.toLowerCase());
            if (optionDefinition) {
                Debug.assert(optionDefinition.type !== "listOrElement");
                const customTypeMap = getCustomTypeMapOfCommandLineOption(optionDefinition);
                if (!customTypeMap) {
                    if (pathOptions && optionDefinition.isFilePath) result.set(name, getRelativePathFromFile(pathOptions.configFilePath, getNormalizedAbsolutePath(value1, getDirectoryPath(pathOptions.configFilePath)), getCanonicalFileName));
                    else if (pathOptions && optionDefinition.type === "list" && optionDefinition.element.isFilePath) result.set(name, value1.map((v1)=>getRelativePathFromFile(pathOptions.configFilePath, getNormalizedAbsolutePath(v1, getDirectoryPath(pathOptions.configFilePath)), getCanonicalFileName)));
                    else result.set(name, value1);
                } else if (optionDefinition.type === "list") result.set(name, value1.map((element)=>getNameOfCompilerOptionValue(element, customTypeMap)));
                else result.set(name, getNameOfCompilerOptionValue(value1, customTypeMap));
            }
        }
        return result;
    }
    function generateTSConfig(options, newLine) {
        const tab = "  ";
        const result = [];
        const allSetOptions = Object.keys(options).filter((k)=>k !== "init" && k !== "help" && k !== "watch");
        result.push(`{`);
        result.push(`${tab}// ${getLocaleSpecificMessage(Diagnostics.Visit_https_Colon_Slash_Slashaka_ms_Slashtsconfig_to_read_more_about_this_file)}`);
        result.push(`${tab}"compilerOptions": {`);
        emitHeader(Diagnostics.File_Layout);
        emitOption("rootDir", "./src", "optional");
        emitOption("outDir", "./dist", "optional");
        newline();
        emitHeader(Diagnostics.Environment_Settings);
        emitHeader(Diagnostics.See_also_https_Colon_Slash_Slashaka_ms_Slashtsconfig_Slashmodule);
        emitOption("module", 199 /* NodeNext */ );
        emitOption("target", 99 /* ESNext */ );
        emitOption("types", []);
        if (options.lib) emitOption("lib", options.lib);
        emitHeader(Diagnostics.For_nodejs_Colon);
        result.push(`${tab}${tab}// "lib": ["esnext"],`);
        result.push(`${tab}${tab}// "types": ["node"],`);
        emitHeader(Diagnostics.and_npm_install_D_types_Slashnode);
        newline();
        emitHeader(Diagnostics.Other_Outputs);
        emitOption("sourceMap", /*defaultValue*/ true);
        emitOption("declaration", /*defaultValue*/ true);
        emitOption("declarationMap", /*defaultValue*/ true);
        newline();
        emitHeader(Diagnostics.Stricter_Typechecking_Options);
        emitOption("noUncheckedIndexedAccess", /*defaultValue*/ true);
        emitOption("exactOptionalPropertyTypes", /*defaultValue*/ true);
        newline();
        emitHeader(Diagnostics.Style_Options);
        emitOption("noImplicitReturns", /*defaultValue*/ true, "optional");
        emitOption("noImplicitOverride", /*defaultValue*/ true, "optional");
        emitOption("noUnusedLocals", /*defaultValue*/ true, "optional");
        emitOption("noUnusedParameters", /*defaultValue*/ true, "optional");
        emitOption("noFallthroughCasesInSwitch", /*defaultValue*/ true, "optional");
        emitOption("noPropertyAccessFromIndexSignature", /*defaultValue*/ true, "optional");
        newline();
        emitHeader(Diagnostics.Recommended_Options);
        emitOption("strict", /*defaultValue*/ true);
        emitOption("jsx", 4 /* ReactJSX */ );
        emitOption("verbatimModuleSyntax", /*defaultValue*/ true);
        emitOption("isolatedModules", /*defaultValue*/ true);
        emitOption("noUncheckedSideEffectImports", /*defaultValue*/ true);
        emitOption("moduleDetection", 3 /* Force */ );
        emitOption("skipLibCheck", /*defaultValue*/ true);
        if (allSetOptions.length > 0) {
            newline();
            while(allSetOptions.length > 0)emitOption(allSetOptions[0], options[allSetOptions[0]]);
        }
        function newline() {
            result.push("");
        }
        function emitHeader(header) {
            result.push(`${tab}${tab}// ${getLocaleSpecificMessage(header)}`);
        }
        function emitOption(setting, defaultValue, commented = "never") {
            const existingOptionIndex = allSetOptions.indexOf(setting);
            if (existingOptionIndex >= 0) allSetOptions.splice(existingOptionIndex, 1);
            let comment;
            if (commented === "always") comment = true;
            else if (commented === "never") comment = false;
            else comment = !hasProperty(options, setting);
            var _options_setting;
            const value1 = (_options_setting = options[setting]) !== null && _options_setting !== void 0 ? _options_setting : defaultValue;
            if (comment) result.push(`${tab}${tab}// "${setting}": ${formatValueOrArray(setting, value1)},`);
            else result.push(`${tab}${tab}"${setting}": ${formatValueOrArray(setting, value1)},`);
        }
        function formatValueOrArray(settingName, value1) {
            const option = optionDeclarations.filter((c)=>c.name === settingName)[0];
            if (!option) Debug.fail(`No option named ${settingName}?`);
            const map2 = option.type instanceof Map ? option.type : void 0;
            if (isArray(value1)) {
                const map3 = "element" in option && option.element.type instanceof Map ? option.element.type : void 0;
                return `[${value1.map((v1)=>formatSingleValue(v1, map3)).join(", ")}]`;
            } else return formatSingleValue(value1, map2);
        }
        function formatSingleValue(value1, map2) {
            var _getNameOfCompilerOptionValue;
            if (map2) value1 = (_getNameOfCompilerOptionValue = getNameOfCompilerOptionValue(value1, map2)) !== null && _getNameOfCompilerOptionValue !== void 0 ? _getNameOfCompilerOptionValue : Debug.fail(`No matching value of ${value1}`);
            return JSON.stringify(value1);
        }
        result.push(`${tab}}`);
        result.push(`}`);
        result.push(``);
        return result.join(newLine);
    }
    function convertToOptionsWithAbsolutePaths(options, toAbsolutePath) {
        const result = {};
        const optionsNameMap = getOptionsNameMap().optionsNameMap;
        for(const name in options)if (hasProperty(options, name)) result[name] = convertToOptionValueWithAbsolutePaths(optionsNameMap.get(name.toLowerCase()), options[name], toAbsolutePath);
        if (result.configFilePath) result.configFilePath = toAbsolutePath(result.configFilePath);
        return result;
    }
    function convertToOptionValueWithAbsolutePaths(option, value1, toAbsolutePath) {
        if (option && !isNullOrUndefined(value1)) {
            if (option.type === "list") {
                const values = value1;
                if (option.element.isFilePath && values.length) return values.map(toAbsolutePath);
            } else if (option.isFilePath) return toAbsolutePath(value1);
            Debug.assert(option.type !== "listOrElement");
        }
        return value1;
    }
    function parseJsonConfigFileContent(json, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache, existingWatchOptions) {
        return parseJsonConfigFileContentWorker(json, /*sourceFile*/ void 0, host, basePath, existingOptions, existingWatchOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache);
    }
    function parseJsonSourceFileConfigFileContent(sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache, existingWatchOptions) {
        var _a, _b;
        (_a = tracing) == null || _a.push(tracing.Phase.Parse, "parseJsonSourceFileConfigFileContent", {
            path: sourceFile.fileName
        });
        const result = parseJsonConfigFileContentWorker(/*json*/ void 0, sourceFile, host, basePath, existingOptions, existingWatchOptions, configFileName, resolutionStack, extraFileExtensions, extendedConfigCache);
        (_b = tracing) == null || _b.pop();
        return result;
    }
    function setConfigFileInOptions(options, configFile) {
        if (configFile) Object.defineProperty(options, "configFile", {
            enumerable: false,
            writable: false,
            value: configFile
        });
    }
    function isNullOrUndefined(x) {
        return x === void 0 || x === null;
    }
    function directoryOfCombinedPath(fileName, basePath) {
        return getDirectoryPath(getNormalizedAbsolutePath(fileName, basePath));
    }
    var defaultIncludeSpec = "**/*";
    function parseJsonConfigFileContentWorker(json, sourceFile, host, basePath, existingOptions = {}, existingWatchOptions, configFileName, resolutionStack = [], extraFileExtensions = [], extendedConfigCache) {
        Debug.assert(json === void 0 && sourceFile !== void 0 || json !== void 0 && sourceFile === void 0);
        const errors = [];
        const parsedConfig = parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors, extendedConfigCache);
        const { raw } = parsedConfig;
        const options = handleOptionConfigDirTemplateSubstitution(extend(existingOptions, parsedConfig.options || {}), configDirTemplateSubstitutionOptions, basePath);
        const watchOptions = handleWatchOptionsConfigDirTemplateSubstitution(existingWatchOptions && parsedConfig.watchOptions ? extend(existingWatchOptions, parsedConfig.watchOptions) : parsedConfig.watchOptions || existingWatchOptions, basePath);
        options.configFilePath = configFileName && normalizeSlashes(configFileName);
        const basePathForFileNames = normalizePath(configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath);
        const configFileSpecs = getConfigFileSpecs();
        if (sourceFile) sourceFile.configFileSpecs = configFileSpecs;
        setConfigFileInOptions(options, sourceFile);
        return {
            options,
            watchOptions,
            fileNames: getFileNames(basePathForFileNames),
            projectReferences: getProjectReferences(basePathForFileNames),
            typeAcquisition: parsedConfig.typeAcquisition || getDefaultTypeAcquisition(),
            raw,
            errors,
            // Wildcard directories (provided as part of a wildcard path) are stored in a
            // file map that marks whether it was a regular wildcard match (with a `*` or `?` token),
            // or a recursive directory. This information is used by filesystem watchers to monitor for
            // new entries in these paths.
            wildcardDirectories: getWildcardDirectories(configFileSpecs, basePathForFileNames, host.useCaseSensitiveFileNames),
            compileOnSave: !!raw.compileOnSave
        };
        function getConfigFileSpecs() {
            const referencesOfRaw = getPropFromRaw("references", (element)=>typeof element === "object", "object");
            const filesSpecs = toPropValue(getSpecsFromRaw("files"));
            if (filesSpecs) {
                const hasZeroOrNoReferences = referencesOfRaw === "no-prop" || isArray(referencesOfRaw) && referencesOfRaw.length === 0;
                const hasExtends = hasProperty(raw, "extends");
                if (filesSpecs.length === 0 && hasZeroOrNoReferences && !hasExtends) {
                    if (sourceFile) {
                        const fileName = configFileName || "tsconfig.json";
                        const diagnosticMessage = Diagnostics.The_files_list_in_config_file_0_is_empty;
                        const nodeValue = forEachTsConfigPropArray(sourceFile, "files", (property)=>property.initializer);
                        const error2 = createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, nodeValue, diagnosticMessage, fileName);
                        errors.push(error2);
                    } else createCompilerDiagnosticOnlyIfJson(Diagnostics.The_files_list_in_config_file_0_is_empty, configFileName || "tsconfig.json");
                }
            }
            let includeSpecs = toPropValue(getSpecsFromRaw("include"));
            const excludeOfRaw = getSpecsFromRaw("exclude");
            let isDefaultIncludeSpec = false;
            let excludeSpecs = toPropValue(excludeOfRaw);
            if (excludeOfRaw === "no-prop") {
                const outDir = options.outDir;
                const declarationDir = options.declarationDir;
                if (outDir || declarationDir) excludeSpecs = filter([
                    outDir,
                    declarationDir
                ], (d)=>!!d);
            }
            if (filesSpecs === void 0 && includeSpecs === void 0) {
                includeSpecs = [
                    defaultIncludeSpec
                ];
                isDefaultIncludeSpec = true;
            }
            let validatedIncludeSpecsBeforeSubstitution, validatedExcludeSpecsBeforeSubstitution;
            let validatedIncludeSpecs, validatedExcludeSpecs;
            if (includeSpecs) {
                validatedIncludeSpecsBeforeSubstitution = validateSpecs(includeSpecs, errors, /*disallowTrailingRecursion*/ true, sourceFile, "include");
                validatedIncludeSpecs = getSubstitutedStringArrayWithConfigDirTemplate(validatedIncludeSpecsBeforeSubstitution, basePathForFileNames) || validatedIncludeSpecsBeforeSubstitution;
            }
            if (excludeSpecs) {
                validatedExcludeSpecsBeforeSubstitution = validateSpecs(excludeSpecs, errors, /*disallowTrailingRecursion*/ false, sourceFile, "exclude");
                validatedExcludeSpecs = getSubstitutedStringArrayWithConfigDirTemplate(validatedExcludeSpecsBeforeSubstitution, basePathForFileNames) || validatedExcludeSpecsBeforeSubstitution;
            }
            const validatedFilesSpecBeforeSubstitution = filter(filesSpecs, isString);
            const validatedFilesSpec = getSubstitutedStringArrayWithConfigDirTemplate(validatedFilesSpecBeforeSubstitution, basePathForFileNames) || validatedFilesSpecBeforeSubstitution;
            return {
                filesSpecs,
                includeSpecs,
                excludeSpecs,
                validatedFilesSpec,
                validatedIncludeSpecs,
                validatedExcludeSpecs,
                validatedFilesSpecBeforeSubstitution,
                validatedIncludeSpecsBeforeSubstitution,
                validatedExcludeSpecsBeforeSubstitution,
                isDefaultIncludeSpec
            };
        }
        function getFileNames(basePath2) {
            const fileNames = getFileNamesFromConfigSpecs(configFileSpecs, basePath2, options, host, extraFileExtensions);
            if (shouldReportNoInputFiles(fileNames, canJsonReportNoInputFiles(raw), resolutionStack)) errors.push(getErrorForNoInputFiles(configFileSpecs, configFileName));
            return fileNames;
        }
        function getProjectReferences(basePath2) {
            let projectReferences;
            const referencesOfRaw = getPropFromRaw("references", (element)=>typeof element === "object", "object");
            if (isArray(referencesOfRaw)) {
                for (const ref of referencesOfRaw)if (typeof ref.path !== "string") createCompilerDiagnosticOnlyIfJson(Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "reference.path", "string");
                else (projectReferences || (projectReferences = [])).push({
                    path: getNormalizedAbsolutePath(ref.path, basePath2),
                    originalPath: ref.path,
                    prepend: ref.prepend,
                    circular: ref.circular
                });
            }
            return projectReferences;
        }
        function toPropValue(specResult) {
            return isArray(specResult) ? specResult : void 0;
        }
        function getSpecsFromRaw(prop) {
            return getPropFromRaw(prop, isString, "string");
        }
        function getPropFromRaw(prop, validateElement, elementTypeName) {
            if (hasProperty(raw, prop) && !isNullOrUndefined(raw[prop])) {
                if (isArray(raw[prop])) {
                    const result = raw[prop];
                    if (!sourceFile && !every(result, validateElement)) errors.push(createCompilerDiagnostic(Diagnostics.Compiler_option_0_requires_a_value_of_type_1, prop, elementTypeName));
                    return result;
                } else {
                    createCompilerDiagnosticOnlyIfJson(Diagnostics.Compiler_option_0_requires_a_value_of_type_1, prop, "Array");
                    return "not-array";
                }
            }
            return "no-prop";
        }
        function createCompilerDiagnosticOnlyIfJson(message, ...args) {
            if (!sourceFile) errors.push(createCompilerDiagnostic(message, ...args));
        }
    }
    function handleWatchOptionsConfigDirTemplateSubstitution(watchOptions, basePath) {
        return handleOptionConfigDirTemplateSubstitution(watchOptions, configDirTemplateSubstitutionWatchOptions, basePath);
    }
    function handleOptionConfigDirTemplateSubstitution(options, optionDeclarations2, basePath) {
        if (!options) return options;
        let result;
        for (const option of optionDeclarations2)if (options[option.name] !== void 0) {
            const value1 = options[option.name];
            switch(option.type){
                case "string":
                    Debug.assert(option.isFilePath);
                    if (startsWithConfigDirTemplate(value1)) setOptionValue(option, getSubstitutedPathWithConfigDirTemplate(value1, basePath));
                    break;
                case "list":
                    Debug.assert(option.element.isFilePath);
                    const listResult = getSubstitutedStringArrayWithConfigDirTemplate(value1, basePath);
                    if (listResult) setOptionValue(option, listResult);
                    break;
                case "object":
                    Debug.assert(option.name === "paths");
                    const objectResult = getSubstitutedMapLikeOfStringArrayWithConfigDirTemplate(value1, basePath);
                    if (objectResult) setOptionValue(option, objectResult);
                    break;
                default:
                    Debug.fail("option type not supported");
            }
        }
        return result || options;
        function setOptionValue(option, value1) {
            (result !== null && result !== void 0 ? result : result = assign({}, options))[option.name] = value1;
        }
    }
    var configDirTemplate = `\${configDir}`;
    function startsWithConfigDirTemplate(value1) {
        return isString(value1) && startsWith(value1, configDirTemplate, /*ignoreCase*/ true);
    }
    function getSubstitutedPathWithConfigDirTemplate(value1, basePath) {
        return getNormalizedAbsolutePath(value1.replace(configDirTemplate, "./"), basePath);
    }
    function getSubstitutedStringArrayWithConfigDirTemplate(list, basePath) {
        if (!list) return list;
        let result;
        list.forEach((element, index)=>{
            if (!startsWithConfigDirTemplate(element)) return;
            (result !== null && result !== void 0 ? result : result = list.slice())[index] = getSubstitutedPathWithConfigDirTemplate(element, basePath);
        });
        return result;
    }
    function getSubstitutedMapLikeOfStringArrayWithConfigDirTemplate(mapLike, basePath) {
        let result;
        const ownKeys = getOwnKeys(mapLike);
        ownKeys.forEach((key)=>{
            if (!isArray(mapLike[key])) return;
            const subStitution = getSubstitutedStringArrayWithConfigDirTemplate(mapLike[key], basePath);
            if (!subStitution) return;
            (result !== null && result !== void 0 ? result : result = assign({}, mapLike))[key] = subStitution;
        });
        return result;
    }
    function isErrorNoInputFiles(error2) {
        return error2.code === Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2.code;
    }
    function getErrorForNoInputFiles({ includeSpecs, excludeSpecs }, configFileName) {
        return createCompilerDiagnostic(Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2, configFileName || "tsconfig.json", JSON.stringify(includeSpecs || []), JSON.stringify(excludeSpecs || []));
    }
    function shouldReportNoInputFiles(fileNames, canJsonReportNoInutFiles, resolutionStack) {
        return fileNames.length === 0 && canJsonReportNoInutFiles && (!resolutionStack || resolutionStack.length === 0);
    }
    function isSolutionConfig(config) {
        return !config.fileNames.length && hasProperty(config.raw, "references");
    }
    function canJsonReportNoInputFiles(raw) {
        return !hasProperty(raw, "files") && !hasProperty(raw, "references");
    }
    function updateErrorForNoInputFiles(fileNames, configFileName, configFileSpecs, configParseDiagnostics, canJsonReportNoInutFiles) {
        const existingErrors = configParseDiagnostics.length;
        if (shouldReportNoInputFiles(fileNames, canJsonReportNoInutFiles)) configParseDiagnostics.push(getErrorForNoInputFiles(configFileSpecs, configFileName));
        else filterMutate(configParseDiagnostics, (error2)=>!isErrorNoInputFiles(error2));
        return existingErrors !== configParseDiagnostics.length;
    }
    function isSuccessfulParsedTsconfig(value1) {
        return !!value1.options;
    }
    function parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors, extendedConfigCache) {
        var _a;
        basePath = normalizeSlashes(basePath);
        const resolvedPath = getNormalizedAbsolutePath(configFileName || "", basePath);
        if (resolutionStack.includes(resolvedPath)) {
            errors.push(createCompilerDiagnostic(Diagnostics.Circularity_detected_while_resolving_configuration_Colon_0, [
                ...resolutionStack,
                resolvedPath
            ].join(" -> ")));
            return {
                raw: json || convertToObject(sourceFile, errors)
            };
        }
        const ownConfig = json ? parseOwnConfigOfJson(json, host, basePath, configFileName, errors) : parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors);
        if ((_a = ownConfig.options) == null ? void 0 : _a.paths) ownConfig.options.pathsBasePath = basePath;
        if (ownConfig.extendedConfigPath) {
            resolutionStack = resolutionStack.concat([
                resolvedPath
            ]);
            const result = {
                options: {}
            };
            if (isString(ownConfig.extendedConfigPath)) applyExtendedConfig(result, ownConfig.extendedConfigPath);
            else ownConfig.extendedConfigPath.forEach((extendedConfigPath)=>applyExtendedConfig(result, extendedConfigPath));
            if (result.include) ownConfig.raw.include = result.include;
            if (result.exclude) ownConfig.raw.exclude = result.exclude;
            if (result.files) ownConfig.raw.files = result.files;
            if (ownConfig.raw.compileOnSave === void 0 && result.compileOnSave) ownConfig.raw.compileOnSave = result.compileOnSave;
            if (sourceFile && result.extendedSourceFiles) sourceFile.extendedSourceFiles = arrayFrom(result.extendedSourceFiles.keys());
            ownConfig.options = assign(result.options, ownConfig.options);
            ownConfig.watchOptions = ownConfig.watchOptions && result.watchOptions ? assignWatchOptions(result, ownConfig.watchOptions) : ownConfig.watchOptions || result.watchOptions;
        }
        return ownConfig;
        function applyExtendedConfig(result, extendedConfigPath) {
            const extendedConfig = getExtendedConfig(sourceFile, extendedConfigPath, host, resolutionStack, errors, extendedConfigCache, result);
            if (extendedConfig && isSuccessfulParsedTsconfig(extendedConfig)) {
                const extendsRaw = extendedConfig.raw;
                let relativeDifference;
                const setPropertyInResultIfNotUndefined = (propertyName)=>{
                    if (ownConfig.raw[propertyName]) return;
                    if (extendsRaw[propertyName]) result[propertyName] = map(extendsRaw[propertyName], (path)=>startsWithConfigDirTemplate(path) || isRootedDiskPath(path) ? path : combinePaths(relativeDifference || (relativeDifference = convertToRelativePath(getDirectoryPath(extendedConfigPath), basePath, createGetCanonicalFileName(host.useCaseSensitiveFileNames))), path));
                };
                setPropertyInResultIfNotUndefined("include");
                setPropertyInResultIfNotUndefined("exclude");
                setPropertyInResultIfNotUndefined("files");
                if (extendsRaw.compileOnSave !== void 0) result.compileOnSave = extendsRaw.compileOnSave;
                assign(result.options, extendedConfig.options);
                result.watchOptions = result.watchOptions && extendedConfig.watchOptions ? assignWatchOptions(result, extendedConfig.watchOptions) : result.watchOptions || extendedConfig.watchOptions;
            }
        }
        function assignWatchOptions(result, watchOptions) {
            if (result.watchOptionsCopied) return assign(result.watchOptions, watchOptions);
            result.watchOptionsCopied = true;
            return assign({}, result.watchOptions, watchOptions);
        }
    }
    function parseOwnConfigOfJson(json, host, basePath, configFileName, errors) {
        if (hasProperty(json, "excludes")) errors.push(createCompilerDiagnostic(Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
        const options = convertCompilerOptionsFromJsonWorker(json.compilerOptions, basePath, errors, configFileName);
        const typeAcquisition = convertTypeAcquisitionFromJsonWorker(json.typeAcquisition, basePath, errors, configFileName);
        const watchOptions = convertWatchOptionsFromJsonWorker(json.watchOptions, basePath, errors);
        json.compileOnSave = convertCompileOnSaveOptionFromJson(json, basePath, errors);
        const extendedConfigPath = json.extends || json.extends === "" ? getExtendsConfigPathOrArray(json.extends, host, basePath, configFileName, errors) : void 0;
        return {
            raw: json,
            options,
            watchOptions,
            typeAcquisition,
            extendedConfigPath
        };
    }
    function getExtendsConfigPathOrArray(value1, host, basePath, configFileName, errors, propertyAssignment, valueExpression, sourceFile) {
        let extendedConfigPath;
        const newBase = configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath;
        if (isString(value1)) extendedConfigPath = getExtendsConfigPath(value1, host, newBase, errors, valueExpression, sourceFile);
        else if (isArray(value1)) {
            extendedConfigPath = [];
            for(let index = 0; index < value1.length; index++){
                const fileName = value1[index];
                if (isString(fileName)) extendedConfigPath = append(extendedConfigPath, getExtendsConfigPath(fileName, host, newBase, errors, valueExpression == null ? void 0 : valueExpression.elements[index], sourceFile));
                else convertJsonOption(extendsOptionDeclaration.element, value1, basePath, errors, propertyAssignment, valueExpression == null ? void 0 : valueExpression.elements[index], sourceFile);
            }
        } else convertJsonOption(extendsOptionDeclaration, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile);
        return extendedConfigPath;
    }
    function parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors) {
        const options = getDefaultCompilerOptions(configFileName);
        let typeAcquisition;
        let watchOptions;
        let extendedConfigPath;
        let rootCompilerOptions;
        const rootOptions = getTsconfigRootOptionsMap();
        const json = convertConfigFileToObject(sourceFile, errors, {
            rootOptions,
            onPropertySet
        });
        if (!typeAcquisition) typeAcquisition = getDefaultTypeAcquisition(configFileName);
        if (rootCompilerOptions && json && json.compilerOptions === void 0) errors.push(createDiagnosticForNodeInSourceFile(sourceFile, rootCompilerOptions[0], Diagnostics._0_should_be_set_inside_the_compilerOptions_object_of_the_config_json_file, getTextOfPropertyName(rootCompilerOptions[0])));
        return {
            raw: json,
            options,
            watchOptions,
            typeAcquisition,
            extendedConfigPath
        };
        function onPropertySet(keyText, value1, propertyAssignment, parentOption, option) {
            if (option && option !== extendsOptionDeclaration) value1 = convertJsonOption(option, value1, basePath, errors, propertyAssignment, propertyAssignment.initializer, sourceFile);
            if (parentOption == null ? void 0 : parentOption.name) {
                if (option) {
                    let currentOption;
                    if (parentOption === compilerOptionsDeclaration) currentOption = options;
                    else if (parentOption === watchOptionsDeclaration) currentOption = watchOptions !== null && watchOptions !== void 0 ? watchOptions : watchOptions = {};
                    else if (parentOption === typeAcquisitionDeclaration) currentOption = typeAcquisition !== null && typeAcquisition !== void 0 ? typeAcquisition : typeAcquisition = getDefaultTypeAcquisition(configFileName);
                    else Debug.fail("Unknown option");
                    currentOption[option.name] = value1;
                } else if (keyText && (parentOption == null ? void 0 : parentOption.extraKeyDiagnostics)) {
                    if (parentOption.elementOptions) errors.push(createUnknownOptionError(keyText, parentOption.extraKeyDiagnostics, /*unknownOptionErrorText*/ void 0, propertyAssignment.name, sourceFile));
                    else errors.push(createDiagnosticForNodeInSourceFile(sourceFile, propertyAssignment.name, parentOption.extraKeyDiagnostics.unknownOptionDiagnostic, keyText));
                }
            } else if (parentOption === rootOptions) {
                if (option === extendsOptionDeclaration) extendedConfigPath = getExtendsConfigPathOrArray(value1, host, basePath, configFileName, errors, propertyAssignment, propertyAssignment.initializer, sourceFile);
                else if (!option) {
                    if (keyText === "excludes") errors.push(createDiagnosticForNodeInSourceFile(sourceFile, propertyAssignment.name, Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
                    if (find(commandOptionsWithoutBuild, (opt)=>opt.name === keyText)) rootCompilerOptions = append(rootCompilerOptions, propertyAssignment.name);
                }
            }
        }
    }
    function getExtendsConfigPath(extendedConfig, host, basePath, errors, valueExpression, sourceFile) {
        extendedConfig = normalizeSlashes(extendedConfig);
        if (isRootedDiskPath(extendedConfig) || startsWith(extendedConfig, "./") || startsWith(extendedConfig, "../")) {
            let extendedConfigPath = getNormalizedAbsolutePath(extendedConfig, basePath);
            if (!host.fileExists(extendedConfigPath) && !endsWith(extendedConfigPath, ".json" /* Json */ )) {
                extendedConfigPath = `${extendedConfigPath}.json`;
                if (!host.fileExists(extendedConfigPath)) {
                    errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.File_0_not_found, extendedConfig));
                    return void 0;
                }
            }
            return extendedConfigPath;
        }
        const resolved = nodeNextJsonConfigResolver(extendedConfig, combinePaths(basePath, "tsconfig.json"), host);
        if (resolved.resolvedModule) return resolved.resolvedModule.resolvedFileName;
        if (extendedConfig === "") errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.Compiler_option_0_cannot_be_given_an_empty_string, "extends"));
        else errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.File_0_not_found, extendedConfig));
        return void 0;
    }
    function getExtendedConfig(sourceFile, extendedConfigPath, host, resolutionStack, errors, extendedConfigCache, result) {
        const path = host.useCaseSensitiveFileNames ? extendedConfigPath : toFileNameLowerCase(extendedConfigPath);
        let value1;
        let extendedResult;
        let extendedConfig;
        if (extendedConfigCache && (value1 = extendedConfigCache.get(path))) ({ extendedResult, extendedConfig } = value1);
        else {
            extendedResult = readJsonConfigFile(extendedConfigPath, (path2)=>host.readFile(path2));
            if (!extendedResult.parseDiagnostics.length) extendedConfig = parseConfig(/*json*/ void 0, extendedResult, host, getDirectoryPath(extendedConfigPath), getBaseFileName(extendedConfigPath), resolutionStack, errors, extendedConfigCache);
            if (extendedConfigCache) extendedConfigCache.set(path, {
                extendedResult,
                extendedConfig
            });
        }
        if (sourceFile) {
            var _result_extendedSourceFiles;
            ((_result_extendedSourceFiles = result.extendedSourceFiles) !== null && _result_extendedSourceFiles !== void 0 ? _result_extendedSourceFiles : result.extendedSourceFiles = /* @__PURE__ */ new Set()).add(extendedResult.fileName);
            if (extendedResult.extendedSourceFiles) for (const extenedSourceFile of extendedResult.extendedSourceFiles)result.extendedSourceFiles.add(extenedSourceFile);
        }
        if (extendedResult.parseDiagnostics.length) {
            errors.push(...extendedResult.parseDiagnostics);
            return void 0;
        }
        return extendedConfig;
    }
    function convertCompileOnSaveOptionFromJson(jsonOption, basePath, errors) {
        if (!hasProperty(jsonOption, compileOnSaveCommandLineOption.name)) return false;
        const result = convertJsonOption(compileOnSaveCommandLineOption, jsonOption.compileOnSave, basePath, errors);
        return typeof result === "boolean" && result;
    }
    function convertCompilerOptionsFromJson(jsonOptions, basePath, configFileName) {
        const errors = [];
        const options = convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName);
        return {
            options,
            errors
        };
    }
    function convertTypeAcquisitionFromJson(jsonOptions, basePath, configFileName) {
        const errors = [];
        const options = convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName);
        return {
            options,
            errors
        };
    }
    function getDefaultCompilerOptions(configFileName) {
        const options = configFileName && getBaseFileName(configFileName) === "jsconfig.json" ? {
            allowJs: true,
            maxNodeModuleJsDepth: 2,
            allowSyntheticDefaultImports: true,
            skipLibCheck: true,
            noEmit: true
        } : {};
        return options;
    }
    function convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
        const options = getDefaultCompilerOptions(configFileName);
        convertOptionsFromJson(getCommandLineCompilerOptionsMap(), jsonOptions, basePath, options, compilerOptionsDidYouMeanDiagnostics, errors);
        if (configFileName) options.configFilePath = normalizeSlashes(configFileName);
        return options;
    }
    function getDefaultTypeAcquisition(configFileName) {
        return {
            enable: !!configFileName && getBaseFileName(configFileName) === "jsconfig.json",
            include: [],
            exclude: []
        };
    }
    function convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
        const options = getDefaultTypeAcquisition(configFileName);
        convertOptionsFromJson(getCommandLineTypeAcquisitionMap(), jsonOptions, basePath, options, typeAcquisitionDidYouMeanDiagnostics, errors);
        return options;
    }
    function convertWatchOptionsFromJsonWorker(jsonOptions, basePath, errors) {
        return convertOptionsFromJson(getCommandLineWatchOptionsMap(), jsonOptions, basePath, /*defaultOptions*/ void 0, watchOptionsDidYouMeanDiagnostics, errors);
    }
    function convertOptionsFromJson(optionsNameMap, jsonOptions, basePath, defaultOptions, diagnostics, errors) {
        if (!jsonOptions) return;
        for(const id in jsonOptions){
            const opt = optionsNameMap.get(id);
            if (opt) (defaultOptions || (defaultOptions = {}))[opt.name] = convertJsonOption(opt, jsonOptions[id], basePath, errors);
            else errors.push(createUnknownOptionError(id, diagnostics));
        }
        return defaultOptions;
    }
    function createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, node, message, ...args) {
        return sourceFile && node ? createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args) : createCompilerDiagnostic(message, ...args);
    }
    function convertJsonOption(opt, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile) {
        if (opt.isCommandLineOnly) {
            errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, propertyAssignment == null ? void 0 : propertyAssignment.name, Diagnostics.Option_0_can_only_be_specified_on_command_line, opt.name));
            return void 0;
        }
        if (isCompilerOptionsValue(opt, value1)) {
            const optType = opt.type;
            if (optType === "list" && isArray(value1)) return convertJsonOptionOfListType(opt, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile);
            else if (optType === "listOrElement") return isArray(value1) ? convertJsonOptionOfListType(opt, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile) : convertJsonOption(opt.element, value1, basePath, errors, propertyAssignment, valueExpression, sourceFile);
            else if (!isString(opt.type)) return convertJsonOptionOfCustomType(opt, value1, errors, valueExpression, sourceFile);
            const validatedValue = validateJsonOptionValue(opt, value1, errors, valueExpression, sourceFile);
            return isNullOrUndefined(validatedValue) ? validatedValue : normalizeNonListOptionValue(opt, basePath, validatedValue);
        } else errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, Diagnostics.Compiler_option_0_requires_a_value_of_type_1, opt.name, getCompilerOptionValueTypeString(opt)));
    }
    function normalizeNonListOptionValue(option, basePath, value1) {
        if (option.isFilePath) {
            value1 = normalizeSlashes(value1);
            value1 = !startsWithConfigDirTemplate(value1) ? getNormalizedAbsolutePath(value1, basePath) : value1;
            if (value1 === "") value1 = ".";
        }
        return value1;
    }
    function validateJsonOptionValue(opt, value1, errors, valueExpression, sourceFile) {
        var _a;
        if (isNullOrUndefined(value1)) return void 0;
        const d = (_a = opt.extraValidation) == null ? void 0 : _a.call(opt, value1);
        if (!d) return value1;
        errors.push(createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, ...d));
        return void 0;
    }
    function convertJsonOptionOfCustomType(opt, value1, errors, valueExpression, sourceFile) {
        if (isNullOrUndefined(value1)) return void 0;
        const key = value1.toLowerCase();
        const val = opt.type.get(key);
        if (val !== void 0) return validateJsonOptionValue(opt, val, errors, valueExpression, sourceFile);
        else errors.push(createDiagnosticForInvalidCustomType(opt, (message, ...args)=>createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(sourceFile, valueExpression, message, ...args)));
    }
    function convertJsonOptionOfListType(option, values, basePath, errors, propertyAssignment, valueExpression, sourceFile) {
        return filter(map(values, (v1, index)=>convertJsonOption(option.element, v1, basePath, errors, propertyAssignment, valueExpression == null ? void 0 : valueExpression.elements[index], sourceFile)), (v1)=>option.listPreserveFalsyValues ? true : !!v1);
    }
    var invalidTrailingRecursionPattern = /(?:^|\/)\*\*\/?$/;
    var wildcardDirectoryPattern = /^[^*?]*(?=\/[^/]*[*?])/;
    function getFileNamesFromConfigSpecs(configFileSpecs, basePath, options, host, extraFileExtensions = emptyArray) {
        basePath = normalizePath(basePath);
        const keyMapper = createGetCanonicalFileName(host.useCaseSensitiveFileNames);
        const literalFileMap = /* @__PURE__ */ new Map();
        const wildcardFileMap = /* @__PURE__ */ new Map();
        const wildCardJsonFileMap = /* @__PURE__ */ new Map();
        const { validatedFilesSpec, validatedIncludeSpecs, validatedExcludeSpecs } = configFileSpecs;
        const supportedExtensions = getSupportedExtensions(options, extraFileExtensions);
        const supportedExtensionsWithJsonIfResolveJsonModule = getSupportedExtensionsWithJsonIfResolveJsonModule(options, supportedExtensions);
        if (validatedFilesSpec) for (const fileName of validatedFilesSpec){
            const file = getNormalizedAbsolutePath(fileName, basePath);
            literalFileMap.set(keyMapper(file), file);
        }
        let jsonOnlyIncludeRegexes;
        if (validatedIncludeSpecs && validatedIncludeSpecs.length > 0) for (const file of host.readDirectory(basePath, flatten(supportedExtensionsWithJsonIfResolveJsonModule), validatedExcludeSpecs, validatedIncludeSpecs, /*depth*/ void 0)){
            if (fileExtensionIs(file, ".json" /* Json */ )) {
                if (!jsonOnlyIncludeRegexes) {
                    const includes = validatedIncludeSpecs.filter((s)=>endsWith(s, ".json" /* Json */ ));
                    const includeFilePatterns = map(getRegularExpressionsForWildcards(includes, basePath, "files"), (pattern)=>`^${pattern}$`);
                    jsonOnlyIncludeRegexes = includeFilePatterns ? includeFilePatterns.map((pattern)=>getRegexFromPattern(pattern, host.useCaseSensitiveFileNames)) : emptyArray;
                }
                const includeIndex = findIndex(jsonOnlyIncludeRegexes, (re)=>re.test(file));
                if (includeIndex !== -1) {
                    const key2 = keyMapper(file);
                    if (!literalFileMap.has(key2) && !wildCardJsonFileMap.has(key2)) wildCardJsonFileMap.set(key2, file);
                }
                continue;
            }
            if (hasFileWithHigherPriorityExtension(file, literalFileMap, wildcardFileMap, supportedExtensions, keyMapper)) continue;
            removeWildcardFilesWithLowerPriorityExtension(file, wildcardFileMap, supportedExtensions, keyMapper);
            const key = keyMapper(file);
            if (!literalFileMap.has(key) && !wildcardFileMap.has(key)) wildcardFileMap.set(key, file);
        }
        const literalFiles = arrayFrom(literalFileMap.values());
        const wildcardFiles = arrayFrom(wildcardFileMap.values());
        return literalFiles.concat(wildcardFiles, arrayFrom(wildCardJsonFileMap.values()));
    }
    function isExcludedFile(pathToCheck, spec, basePath, useCaseSensitiveFileNames2, currentDirectory) {
        const { validatedFilesSpec, validatedIncludeSpecs, validatedExcludeSpecs } = spec;
        if (!length(validatedIncludeSpecs) || !length(validatedExcludeSpecs)) return false;
        basePath = normalizePath(basePath);
        const keyMapper = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        if (validatedFilesSpec) for (const fileName of validatedFilesSpec){
            if (keyMapper(getNormalizedAbsolutePath(fileName, basePath)) === pathToCheck) return false;
        }
        return matchesExcludeWorker(pathToCheck, validatedExcludeSpecs, useCaseSensitiveFileNames2, currentDirectory, basePath);
    }
    function invalidDotDotAfterRecursiveWildcard(s) {
        const wildcardIndex = startsWith(s, "**/") ? 0 : s.indexOf("/**/");
        if (wildcardIndex === -1) return false;
        const lastDotIndex = endsWith(s, "/..") ? s.length : s.lastIndexOf("/../");
        return lastDotIndex > wildcardIndex;
    }
    function matchesExclude(pathToCheck, excludeSpecs, useCaseSensitiveFileNames2, currentDirectory) {
        return matchesExcludeWorker(pathToCheck, filter(excludeSpecs, (spec)=>!invalidDotDotAfterRecursiveWildcard(spec)), useCaseSensitiveFileNames2, currentDirectory);
    }
    function matchesExcludeWorker(pathToCheck, excludeSpecs, useCaseSensitiveFileNames2, currentDirectory, basePath) {
        const excludePattern = getRegularExpressionForWildcard(excludeSpecs, combinePaths(normalizePath(currentDirectory), basePath), "exclude");
        const excludeRegex = excludePattern && getRegexFromPattern(excludePattern, useCaseSensitiveFileNames2);
        if (!excludeRegex) return false;
        if (excludeRegex.test(pathToCheck)) return true;
        return !hasExtension(pathToCheck) && excludeRegex.test(ensureTrailingDirectorySeparator(pathToCheck));
    }
    function validateSpecs(specs, errors, disallowTrailingRecursion, jsonSourceFile, specKey) {
        return specs.filter((spec)=>{
            if (!isString(spec)) return false;
            const diag2 = specToDiagnostic(spec, disallowTrailingRecursion);
            if (diag2 !== void 0) errors.push(createDiagnostic(...diag2));
            return diag2 === void 0;
        });
        function createDiagnostic(message, spec) {
            const element = getTsConfigPropArrayElementValue(jsonSourceFile, specKey, spec);
            return createDiagnosticForNodeInSourceFileOrCompilerDiagnostic(jsonSourceFile, element, message, spec);
        }
    }
    function specToDiagnostic(spec, disallowTrailingRecursion) {
        Debug.assert(typeof spec === "string");
        if (disallowTrailingRecursion && invalidTrailingRecursionPattern.test(spec)) return [
            Diagnostics.File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0,
            spec
        ];
        else if (invalidDotDotAfterRecursiveWildcard(spec)) return [
            Diagnostics.File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0,
            spec
        ];
    }
    function getWildcardDirectories({ validatedIncludeSpecs: include, validatedExcludeSpecs: exclude }, basePath, useCaseSensitiveFileNames2) {
        const rawExcludeRegex = getRegularExpressionForWildcard(exclude, basePath, "exclude");
        const excludeRegex = rawExcludeRegex && new RegExp(rawExcludeRegex, useCaseSensitiveFileNames2 ? "" : "i");
        const wildcardDirectories = {};
        const wildCardKeyToPath = /* @__PURE__ */ new Map();
        if (include !== void 0) {
            const recursiveKeys = [];
            for (const file of include){
                const spec = normalizePath(combinePaths(basePath, file));
                if (excludeRegex && excludeRegex.test(spec)) continue;
                const match = getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames2);
                if (match) {
                    const { key, path, flags } = match;
                    const existingPath = wildCardKeyToPath.get(key);
                    const existingFlags = existingPath !== void 0 ? wildcardDirectories[existingPath] : void 0;
                    if (existingFlags === void 0 || existingFlags < flags) {
                        wildcardDirectories[existingPath !== void 0 ? existingPath : path] = flags;
                        if (existingPath === void 0) wildCardKeyToPath.set(key, path);
                        if (flags === 1 /* Recursive */ ) recursiveKeys.push(key);
                    }
                }
            }
            for(const path in wildcardDirectories){
                if (hasProperty(wildcardDirectories, path)) for (const recursiveKey of recursiveKeys){
                    const key = toCanonicalKey(path, useCaseSensitiveFileNames2);
                    if (key !== recursiveKey && containsPath(recursiveKey, key, basePath, !useCaseSensitiveFileNames2)) delete wildcardDirectories[path];
                }
            }
        }
        return wildcardDirectories;
    }
    function toCanonicalKey(path, useCaseSensitiveFileNames2) {
        return useCaseSensitiveFileNames2 ? path : toFileNameLowerCase(path);
    }
    function getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames2) {
        const match = wildcardDirectoryPattern.exec(spec);
        if (match) {
            const questionWildcardIndex = spec.indexOf("?");
            const starWildcardIndex = spec.indexOf("*");
            const lastDirectorySeperatorIndex = spec.lastIndexOf(directorySeparator);
            return {
                key: toCanonicalKey(match[0], useCaseSensitiveFileNames2),
                path: match[0],
                flags: questionWildcardIndex !== -1 && questionWildcardIndex < lastDirectorySeperatorIndex || starWildcardIndex !== -1 && starWildcardIndex < lastDirectorySeperatorIndex ? 1 /* Recursive */  : 0 /* None */ 
            };
        }
        if (isImplicitGlob(spec.substring(spec.lastIndexOf(directorySeparator) + 1))) {
            const path = removeTrailingDirectorySeparator(spec);
            return {
                key: toCanonicalKey(path, useCaseSensitiveFileNames2),
                path,
                flags: 1 /* Recursive */ 
            };
        }
        return void 0;
    }
    function hasFileWithHigherPriorityExtension(file, literalFiles, wildcardFiles, extensions, keyMapper) {
        const extensionGroup = forEach(extensions, (group2)=>fileExtensionIsOneOf(file, group2) ? group2 : void 0);
        if (!extensionGroup) return false;
        for (const ext of extensionGroup){
            if (fileExtensionIs(file, ext) && (ext !== ".ts" /* Ts */  || !fileExtensionIs(file, ".d.ts" /* Dts */ ))) return false;
            const higherPriorityPath = keyMapper(changeExtension(file, ext));
            if (literalFiles.has(higherPriorityPath) || wildcardFiles.has(higherPriorityPath)) {
                if (ext === ".d.ts" /* Dts */  && (fileExtensionIs(file, ".js" /* Js */ ) || fileExtensionIs(file, ".jsx" /* Jsx */ ))) continue;
                return true;
            }
        }
        return false;
    }
    function removeWildcardFilesWithLowerPriorityExtension(file, wildcardFiles, extensions, keyMapper) {
        const extensionGroup = forEach(extensions, (group2)=>fileExtensionIsOneOf(file, group2) ? group2 : void 0);
        if (!extensionGroup) return;
        for(let i = extensionGroup.length - 1; i >= 0; i--){
            const ext = extensionGroup[i];
            if (fileExtensionIs(file, ext)) return;
            const lowerPriorityPath = keyMapper(changeExtension(file, ext));
            wildcardFiles.delete(lowerPriorityPath);
        }
    }
    function convertCompilerOptionsForTelemetry(opts) {
        const out = {};
        for(const key in opts)if (hasProperty(opts, key)) {
            const type = getOptionFromName(key);
            if (type !== void 0) out[key] = getOptionValueWithEmptyStrings(opts[key], type);
        }
        return out;
    }
    function getOptionValueWithEmptyStrings(value1, option) {
        if (value1 === void 0) return value1;
        switch(option.type){
            case "object":
                return "";
            case "string":
                return "";
            case "number":
                return typeof value1 === "number" ? value1 : "";
            case "boolean":
                return typeof value1 === "boolean" ? value1 : "";
            case "listOrElement":
                if (!isArray(value1)) return getOptionValueWithEmptyStrings(value1, option.element);
            // fall through to list
            case "list":
                const elementType = option.element;
                return isArray(value1) ? mapDefined(value1, (v1)=>getOptionValueWithEmptyStrings(v1, elementType)) : "";
            default:
                return forEachEntry(option.type, (optionEnumValue, optionStringValue)=>{
                    if (optionEnumValue === value1) return optionStringValue;
                });
        }
    }
    // src/compiler/moduleNameResolver.ts
    function trace(host, message, ...args) {
        host.trace(formatMessage(message, ...args));
    }
    function isTraceEnabled(compilerOptions, host) {
        return !!compilerOptions.traceResolution && host.trace !== void 0;
    }
    function withPackageId(packageInfo, r, state) {
        let packageId;
        if (r && packageInfo) {
            const packageJsonContent = packageInfo.contents.packageJsonContent;
            if (typeof packageJsonContent.name === "string" && typeof packageJsonContent.version === "string") packageId = {
                name: packageJsonContent.name,
                subModuleName: r.path.slice(packageInfo.packageDirectory.length + directorySeparator.length),
                version: packageJsonContent.version,
                peerDependencies: getPeerDependenciesOfPackageJsonInfo(packageInfo, state)
            };
        }
        return r && {
            path: r.path,
            extension: r.ext,
            packageId,
            resolvedUsingTsExtension: r.resolvedUsingTsExtension
        };
    }
    function noPackageId(r) {
        return withPackageId(/*packageInfo*/ void 0, r, /*state*/ void 0);
    }
    function removeIgnoredPackageId(r) {
        if (r) {
            Debug.assert(r.packageId === void 0);
            return {
                path: r.path,
                ext: r.extension,
                resolvedUsingTsExtension: r.resolvedUsingTsExtension
            };
        }
    }
    function formatExtensions(extensions) {
        const result = [];
        if (extensions & 1 /* TypeScript */ ) result.push("TypeScript");
        if (extensions & 2 /* JavaScript */ ) result.push("JavaScript");
        if (extensions & 4 /* Declaration */ ) result.push("Declaration");
        if (extensions & 8 /* Json */ ) result.push("JSON");
        return result.join(", ");
    }
    function extensionsToExtensionsArray(extensions) {
        const result = [];
        if (extensions & 1 /* TypeScript */ ) result.push(...supportedTSImplementationExtensions);
        if (extensions & 2 /* JavaScript */ ) result.push(...supportedJSExtensionsFlat);
        if (extensions & 4 /* Declaration */ ) result.push(...supportedDeclarationExtensions);
        if (extensions & 8 /* Json */ ) result.push(".json" /* Json */ );
        return result;
    }
    function resolvedTypeScriptOnly(resolved) {
        if (!resolved) return void 0;
        Debug.assert(extensionIsTS(resolved.extension));
        return {
            fileName: resolved.path,
            packageId: resolved.packageId
        };
    }
    function createResolvedModuleWithFailedLookupLocationsHandlingSymlink(moduleName, resolved, isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, state, cache, alternateResult) {
        if (!state.resultFromCache && !state.compilerOptions.preserveSymlinks && resolved && isExternalLibraryImport && !resolved.originalPath && !isExternalModuleNameRelative(moduleName)) {
            const { resolvedFileName, originalPath } = getOriginalAndResolvedFileName(resolved.path, state.host, state.traceEnabled);
            if (originalPath) resolved = (0, _objectSpreadProps._)((0, _objectSpread._)({}, resolved), {
                path: resolvedFileName,
                originalPath
            });
        }
        return createResolvedModuleWithFailedLookupLocations(resolved, isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, state.resultFromCache, cache, alternateResult);
    }
    function createResolvedModuleWithFailedLookupLocations(resolved, isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, resultFromCache, cache, alternateResult) {
        if (resultFromCache) {
            if (!(cache == null ? void 0 : cache.isReadonly)) {
                resultFromCache.failedLookupLocations = updateResolutionField(resultFromCache.failedLookupLocations, failedLookupLocations);
                resultFromCache.affectingLocations = updateResolutionField(resultFromCache.affectingLocations, affectingLocations);
                resultFromCache.resolutionDiagnostics = updateResolutionField(resultFromCache.resolutionDiagnostics, diagnostics);
                return resultFromCache;
            } else return (0, _objectSpreadProps._)((0, _objectSpread._)({}, resultFromCache), {
                failedLookupLocations: initializeResolutionFieldForReadonlyCache(resultFromCache.failedLookupLocations, failedLookupLocations),
                affectingLocations: initializeResolutionFieldForReadonlyCache(resultFromCache.affectingLocations, affectingLocations),
                resolutionDiagnostics: initializeResolutionFieldForReadonlyCache(resultFromCache.resolutionDiagnostics, diagnostics)
            });
        }
        return {
            resolvedModule: resolved && {
                resolvedFileName: resolved.path,
                originalPath: resolved.originalPath === true ? void 0 : resolved.originalPath,
                extension: resolved.extension,
                isExternalLibraryImport,
                packageId: resolved.packageId,
                resolvedUsingTsExtension: !!resolved.resolvedUsingTsExtension
            },
            failedLookupLocations: initializeResolutionField(failedLookupLocations),
            affectingLocations: initializeResolutionField(affectingLocations),
            resolutionDiagnostics: initializeResolutionField(diagnostics),
            alternateResult
        };
    }
    function initializeResolutionField(value1) {
        return value1.length ? value1 : void 0;
    }
    function updateResolutionField(to, value1) {
        if (!(value1 == null ? void 0 : value1.length)) return to;
        if (!(to == null ? void 0 : to.length)) return value1;
        to.push(...value1);
        return to;
    }
    function initializeResolutionFieldForReadonlyCache(fromCache, value1) {
        if (!(fromCache == null ? void 0 : fromCache.length)) return initializeResolutionField(value1);
        if (!value1.length) return fromCache.slice();
        return [
            ...fromCache,
            ...value1
        ];
    }
    function readPackageJsonField(jsonContent, fieldName, typeOfTag, state) {
        if (!hasProperty(jsonContent, fieldName)) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_does_not_have_a_0_field, fieldName);
            return;
        }
        const value1 = jsonContent[fieldName];
        if (typeof value1 !== typeOfTag || value1 === null) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Expected_type_of_0_field_in_package_json_to_be_1_got_2, fieldName, typeOfTag, value1 === null ? "null" : typeof value1);
            return;
        }
        return value1;
    }
    function readPackageJsonPathField(jsonContent, fieldName, baseDirectory, state) {
        const fileName = readPackageJsonField(jsonContent, fieldName, "string", state);
        if (fileName === void 0) return;
        if (!fileName) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_had_a_falsy_0_field, fieldName);
            return;
        }
        const path = normalizePath(combinePaths(baseDirectory, fileName));
        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_0_field_1_that_references_2, fieldName, fileName, path);
        return path;
    }
    function readPackageJsonTypesFields(jsonContent, baseDirectory, state) {
        return readPackageJsonPathField(jsonContent, "typings", baseDirectory, state) || readPackageJsonPathField(jsonContent, "types", baseDirectory, state);
    }
    function readPackageJsonTSConfigField(jsonContent, baseDirectory, state) {
        return readPackageJsonPathField(jsonContent, "tsconfig", baseDirectory, state);
    }
    function readPackageJsonMainField(jsonContent, baseDirectory, state) {
        return readPackageJsonPathField(jsonContent, "main", baseDirectory, state);
    }
    function readPackageJsonTypesVersionsField(jsonContent, state) {
        const typesVersions = readPackageJsonField(jsonContent, "typesVersions", "object", state);
        if (typesVersions === void 0) return;
        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_typesVersions_field_with_version_specific_path_mappings);
        return typesVersions;
    }
    function readPackageJsonTypesVersionPaths(jsonContent, state) {
        const typesVersions = readPackageJsonTypesVersionsField(jsonContent, state);
        if (typesVersions === void 0) return;
        if (state.traceEnabled) {
            for(const key in typesVersions)if (hasProperty(typesVersions, key) && !VersionRange.tryParse(key)) trace(state.host, Diagnostics.package_json_has_a_typesVersions_entry_0_that_is_not_a_valid_semver_range, key);
        }
        const result = getPackageJsonTypesVersionsPaths(typesVersions);
        if (!result) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_does_not_have_a_typesVersions_entry_that_matches_version_0, versionMajorMinor);
            return;
        }
        const { version: bestVersionKey, paths: bestVersionPaths } = result;
        if (typeof bestVersionPaths !== "object") {
            if (state.traceEnabled) trace(state.host, Diagnostics.Expected_type_of_0_field_in_package_json_to_be_1_got_2, `typesVersions['${bestVersionKey}']`, "object", typeof bestVersionPaths);
            return;
        }
        return result;
    }
    var typeScriptVersion;
    function getPackageJsonTypesVersionsPaths(typesVersions) {
        if (!typeScriptVersion) typeScriptVersion = new Version(version);
        for(const key in typesVersions){
            if (!hasProperty(typesVersions, key)) continue;
            const keyRange = VersionRange.tryParse(key);
            if (keyRange === void 0) continue;
            if (keyRange.test(typeScriptVersion)) return {
                version: key,
                paths: typesVersions[key]
            };
        }
    }
    function getEffectiveTypeRoots(options, host) {
        if (options.typeRoots) return options.typeRoots;
        let currentDirectory;
        if (options.configFilePath) currentDirectory = getDirectoryPath(options.configFilePath);
        else if (host.getCurrentDirectory) currentDirectory = host.getCurrentDirectory();
        if (currentDirectory !== void 0) return getDefaultTypeRoots(currentDirectory);
    }
    function getDefaultTypeRoots(currentDirectory) {
        let typeRoots;
        forEachAncestorDirectory(normalizePath(currentDirectory), (directory)=>{
            const atTypes = combinePaths(directory, nodeModulesAtTypes);
            (typeRoots !== null && typeRoots !== void 0 ? typeRoots : typeRoots = []).push(atTypes);
        });
        return typeRoots;
    }
    var nodeModulesAtTypes = combinePaths("node_modules", "@types");
    function arePathsEqual(path1, path2, host) {
        const useCaseSensitiveFileNames2 = typeof host.useCaseSensitiveFileNames === "function" ? host.useCaseSensitiveFileNames() : host.useCaseSensitiveFileNames;
        return comparePaths(path1, path2, !useCaseSensitiveFileNames2) === 0 /* EqualTo */ ;
    }
    function getOriginalAndResolvedFileName(fileName, host, traceEnabled) {
        const resolvedFileName = realPath(fileName, host, traceEnabled);
        const pathsAreEqual = arePathsEqual(fileName, resolvedFileName, host);
        return {
            // If the fileName and realpath are differing only in casing prefer fileName so that we can issue correct errors for casing under forceConsistentCasingInFileNames
            resolvedFileName: pathsAreEqual ? fileName : resolvedFileName,
            originalPath: pathsAreEqual ? void 0 : fileName
        };
    }
    function getCandidateFromTypeRoot(typeRoot, typeReferenceDirectiveName, moduleResolutionState) {
        const nameForLookup = endsWith(typeRoot, "/node_modules/@types") || endsWith(typeRoot, "/node_modules/@types/") ? mangleScopedPackageNameWithTrace(typeReferenceDirectiveName, moduleResolutionState) : typeReferenceDirectiveName;
        return combinePaths(typeRoot, nameForLookup);
    }
    function resolveTypeReferenceDirective(typeReferenceDirectiveName, containingFile, options, host, redirectedReference, cache, resolutionMode) {
        Debug.assert(typeof typeReferenceDirectiveName === "string", "Non-string value passed to `ts.resolveTypeReferenceDirective`, likely by a wrapping package working with an outdated `resolveTypeReferenceDirectives` signature. This is probably not a problem in TS itself.");
        const traceEnabled = isTraceEnabled(options, host);
        if (redirectedReference) options = redirectedReference.commandLine.options;
        const containingDirectory = containingFile ? getDirectoryPath(containingFile) : void 0;
        let result = containingDirectory ? cache == null ? void 0 : cache.getFromDirectoryCache(typeReferenceDirectiveName, resolutionMode, containingDirectory, redirectedReference) : void 0;
        if (!result && containingDirectory && !isExternalModuleNameRelative(typeReferenceDirectiveName)) result = cache == null ? void 0 : cache.getFromNonRelativeNameCache(typeReferenceDirectiveName, resolutionMode, containingDirectory, redirectedReference);
        if (result) {
            if (traceEnabled) {
                trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_1, typeReferenceDirectiveName, containingFile);
                if (redirectedReference) trace(host, Diagnostics.Using_compiler_options_of_project_reference_redirect_0, redirectedReference.sourceFile.fileName);
                trace(host, Diagnostics.Resolution_for_type_reference_directive_0_was_found_in_cache_from_location_1, typeReferenceDirectiveName, containingDirectory);
                traceResult(result);
            }
            return result;
        }
        const typeRoots = getEffectiveTypeRoots(options, host);
        if (traceEnabled) {
            if (containingFile === void 0) {
                if (typeRoots === void 0) trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set, typeReferenceDirectiveName);
                else trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1, typeReferenceDirectiveName, typeRoots);
            } else if (typeRoots === void 0) trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set, typeReferenceDirectiveName, containingFile);
            else trace(host, Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_2, typeReferenceDirectiveName, containingFile, typeRoots);
            if (redirectedReference) trace(host, Diagnostics.Using_compiler_options_of_project_reference_redirect_0, redirectedReference.sourceFile.fileName);
        }
        const failedLookupLocations = [];
        const affectingLocations = [];
        let features = getNodeResolutionFeatures(options);
        if (resolutionMode !== void 0) features |= 30 /* AllFeatures */ ;
        const moduleResolution = getEmitModuleResolutionKind(options);
        if (resolutionMode === 99 /* ESNext */  && 3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */ ) features |= 32 /* EsmMode */ ;
        const conditions = features & 8 /* Exports */  ? getConditions(options, resolutionMode) : [];
        const diagnostics = [];
        const moduleResolutionState = {
            compilerOptions: options,
            host,
            traceEnabled,
            failedLookupLocations,
            affectingLocations,
            packageJsonInfoCache: cache,
            features,
            conditions,
            requestContainingDirectory: containingDirectory,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false,
            resolvedPackageDirectory: false
        };
        let resolved = primaryLookup();
        let primary = true;
        if (!resolved) {
            resolved = secondaryLookup();
            primary = false;
        }
        let resolvedTypeReferenceDirective;
        if (resolved) {
            const { fileName, packageId } = resolved;
            let resolvedFileName = fileName, originalPath;
            if (!options.preserveSymlinks) ({ resolvedFileName, originalPath } = getOriginalAndResolvedFileName(fileName, host, traceEnabled));
            resolvedTypeReferenceDirective = {
                primary,
                resolvedFileName,
                originalPath,
                packageId,
                isExternalLibraryImport: pathContainsNodeModules(fileName)
            };
        }
        result = {
            resolvedTypeReferenceDirective,
            failedLookupLocations: initializeResolutionField(failedLookupLocations),
            affectingLocations: initializeResolutionField(affectingLocations),
            resolutionDiagnostics: initializeResolutionField(diagnostics)
        };
        if (containingDirectory && cache && !cache.isReadonly) {
            cache.getOrCreateCacheForDirectory(containingDirectory, redirectedReference).set(typeReferenceDirectiveName, /*mode*/ resolutionMode, result);
            if (!isExternalModuleNameRelative(typeReferenceDirectiveName)) cache.getOrCreateCacheForNonRelativeName(typeReferenceDirectiveName, resolutionMode, redirectedReference).set(containingDirectory, result);
        }
        if (traceEnabled) traceResult(result);
        return result;
        function traceResult(result2) {
            var _a;
            if (!((_a = result2.resolvedTypeReferenceDirective) == null ? void 0 : _a.resolvedFileName)) trace(host, Diagnostics.Type_reference_directive_0_was_not_resolved, typeReferenceDirectiveName);
            else if (result2.resolvedTypeReferenceDirective.packageId) trace(host, Diagnostics.Type_reference_directive_0_was_successfully_resolved_to_1_with_Package_ID_2_primary_Colon_3, typeReferenceDirectiveName, result2.resolvedTypeReferenceDirective.resolvedFileName, packageIdToString(result2.resolvedTypeReferenceDirective.packageId), result2.resolvedTypeReferenceDirective.primary);
            else trace(host, Diagnostics.Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2, typeReferenceDirectiveName, result2.resolvedTypeReferenceDirective.resolvedFileName, result2.resolvedTypeReferenceDirective.primary);
        }
        function primaryLookup() {
            if (typeRoots && typeRoots.length) {
                if (traceEnabled) trace(host, Diagnostics.Resolving_with_primary_search_path_0, typeRoots.join(", "));
                return firstDefined(typeRoots, (typeRoot)=>{
                    const candidate = getCandidateFromTypeRoot(typeRoot, typeReferenceDirectiveName, moduleResolutionState);
                    const directoryExists = directoryProbablyExists(typeRoot, host);
                    if (!directoryExists && traceEnabled) trace(host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, typeRoot);
                    if (options.typeRoots) {
                        const resolvedFromFile = loadModuleFromFile(4 /* Declaration */ , candidate, !directoryExists, moduleResolutionState);
                        if (resolvedFromFile) {
                            const packageDirectory = parseNodeModuleFromPath(resolvedFromFile.path);
                            const packageInfo = packageDirectory ? getPackageJsonInfo(packageDirectory, /*onlyRecordFailures*/ false, moduleResolutionState) : void 0;
                            return resolvedTypeScriptOnly(withPackageId(packageInfo, resolvedFromFile, moduleResolutionState));
                        }
                    }
                    return resolvedTypeScriptOnly(loadNodeModuleFromDirectory(4 /* Declaration */ , candidate, !directoryExists, moduleResolutionState));
                });
            } else if (traceEnabled) trace(host, Diagnostics.Root_directory_cannot_be_determined_skipping_primary_search_paths);
        }
        function secondaryLookup() {
            const initialLocationForSecondaryLookup = containingFile && getDirectoryPath(containingFile);
            if (initialLocationForSecondaryLookup !== void 0) {
                let result2;
                if (!options.typeRoots || !endsWith(containingFile, inferredTypesContainingFile)) {
                    if (traceEnabled) trace(host, Diagnostics.Looking_up_in_node_modules_folder_initial_location_0, initialLocationForSecondaryLookup);
                    if (!isExternalModuleNameRelative(typeReferenceDirectiveName)) {
                        const searchResult = loadModuleFromNearestNodeModulesDirectory(4 /* Declaration */ , typeReferenceDirectiveName, initialLocationForSecondaryLookup, moduleResolutionState, /*cache*/ void 0, /*redirectedReference*/ void 0);
                        result2 = searchResult && searchResult.value;
                    } else {
                        const { path: candidate } = normalizePathForCJSResolution(initialLocationForSecondaryLookup, typeReferenceDirectiveName);
                        result2 = nodeLoadModuleByRelativeName(4 /* Declaration */ , candidate, /*onlyRecordFailures*/ false, moduleResolutionState, /*considerPackageJson*/ true);
                    }
                } else if (traceEnabled) trace(host, Diagnostics.Resolving_type_reference_directive_for_program_that_specifies_custom_typeRoots_skipping_lookup_in_node_modules_folder);
                return resolvedTypeScriptOnly(result2);
            } else if (traceEnabled) trace(host, Diagnostics.Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder);
        }
    }
    function getNodeResolutionFeatures(options) {
        let features = 0 /* None */ ;
        switch(getEmitModuleResolutionKind(options)){
            case 3 /* Node16 */ :
                features = 30 /* Node16Default */ ;
                break;
            case 99 /* NodeNext */ :
                features = 30 /* NodeNextDefault */ ;
                break;
            case 100 /* Bundler */ :
                features = 30 /* BundlerDefault */ ;
                break;
        }
        if (options.resolvePackageJsonExports) features |= 8 /* Exports */ ;
        else if (options.resolvePackageJsonExports === false) features &= -9 /* Exports */ ;
        if (options.resolvePackageJsonImports) features |= 2 /* Imports */ ;
        else if (options.resolvePackageJsonImports === false) features &= -3 /* Imports */ ;
        return features;
    }
    function getConditions(options, resolutionMode) {
        const moduleResolution = getEmitModuleResolutionKind(options);
        if (resolutionMode === void 0) {
            if (moduleResolution === 100 /* Bundler */ ) resolutionMode = 99 /* ESNext */ ;
            else if (moduleResolution === 2 /* Node10 */ ) return [];
        }
        const conditions = resolutionMode === 99 /* ESNext */  ? [
            "import"
        ] : [
            "require"
        ];
        if (!options.noDtsResolution) conditions.push("types");
        if (moduleResolution !== 100 /* Bundler */ ) conditions.push("node");
        return concatenate(conditions, options.customConditions);
    }
    function resolvePackageNameToPackageJson(packageName, containingDirectory, options, host, cache) {
        const moduleResolutionState = getTemporaryModuleResolutionState(cache == null ? void 0 : cache.getPackageJsonInfoCache(), host, options);
        return forEachAncestorDirectoryStoppingAtGlobalCache(host, containingDirectory, (ancestorDirectory)=>{
            if (getBaseFileName(ancestorDirectory) !== "node_modules") {
                const nodeModulesFolder = combinePaths(ancestorDirectory, "node_modules");
                const candidate = combinePaths(nodeModulesFolder, packageName);
                return getPackageJsonInfo(candidate, /*onlyRecordFailures*/ false, moduleResolutionState);
            }
        });
    }
    function getAutomaticTypeDirectiveNames(options, host) {
        if (options.types) return options.types;
        const result = [];
        if (host.directoryExists && host.getDirectories) {
            const typeRoots = getEffectiveTypeRoots(options, host);
            if (typeRoots) for (const root of typeRoots){
                if (host.directoryExists(root)) for (const typeDirectivePath of host.getDirectories(root)){
                    const normalized = normalizePath(typeDirectivePath);
                    const packageJsonPath = combinePaths(root, normalized, "package.json");
                    const isNotNeededPackage = host.fileExists(packageJsonPath) && readJson(packageJsonPath, host).typings === null;
                    if (!isNotNeededPackage) {
                        const baseFileName = getBaseFileName(normalized);
                        if (baseFileName.charCodeAt(0) !== 46 /* dot */ ) result.push(baseFileName);
                    }
                }
            }
        }
        return result;
    }
    function isPackageJsonInfo(entry) {
        return !!(entry == null ? void 0 : entry.contents);
    }
    function isMissingPackageJsonInfo(entry) {
        return !!entry && !entry.contents;
    }
    function compilerOptionValueToString(value1) {
        var _a;
        if (value1 === null || typeof value1 !== "object") return "" + value1;
        if (isArray(value1)) return `[${(_a = value1.map((e)=>compilerOptionValueToString(e))) == null ? void 0 : _a.join(",")}]`;
        let str = "{";
        for(const key in value1)if (hasProperty(value1, key)) str += `${key}: ${compilerOptionValueToString(value1[key])}`;
        return str + "}";
    }
    function getKeyForCompilerOptions(options, affectingOptionDeclarations) {
        return affectingOptionDeclarations.map((option)=>compilerOptionValueToString(getCompilerOptionValue(options, option))).join("|") + `|${options.pathsBasePath}`;
    }
    function createCacheWithRedirects(ownOptions, optionsToRedirectsKey) {
        const redirectsMap = /* @__PURE__ */ new Map();
        const redirectsKeyToMap = /* @__PURE__ */ new Map();
        let ownMap = /* @__PURE__ */ new Map();
        if (ownOptions) redirectsMap.set(ownOptions, ownMap);
        return {
            getMapOfCacheRedirects,
            getOrCreateMapOfCacheRedirects,
            update,
            clear: clear2,
            getOwnMap: ()=>ownMap
        };
        function getMapOfCacheRedirects(redirectedReference) {
            return redirectedReference ? getOrCreateMap(redirectedReference.commandLine.options, /*create*/ false) : ownMap;
        }
        function getOrCreateMapOfCacheRedirects(redirectedReference) {
            return redirectedReference ? getOrCreateMap(redirectedReference.commandLine.options, /*create*/ true) : ownMap;
        }
        function update(newOptions) {
            if (ownOptions !== newOptions) {
                if (ownOptions) ownMap = getOrCreateMap(newOptions, /*create*/ true);
                else redirectsMap.set(newOptions, ownMap);
                ownOptions = newOptions;
            }
        }
        function getOrCreateMap(redirectOptions, create) {
            let result = redirectsMap.get(redirectOptions);
            if (result) return result;
            const key = getRedirectsCacheKey(redirectOptions);
            result = redirectsKeyToMap.get(key);
            if (!result) {
                if (ownOptions) {
                    const ownKey = getRedirectsCacheKey(ownOptions);
                    if (ownKey === key) result = ownMap;
                    else if (!redirectsKeyToMap.has(ownKey)) redirectsKeyToMap.set(ownKey, ownMap);
                }
                if (create) result !== null && result !== void 0 ? result : result = /* @__PURE__ */ new Map();
                if (result) redirectsKeyToMap.set(key, result);
            }
            if (result) redirectsMap.set(redirectOptions, result);
            return result;
        }
        function clear2() {
            const ownKey = ownOptions && optionsToRedirectsKey.get(ownOptions);
            ownMap.clear();
            redirectsMap.clear();
            optionsToRedirectsKey.clear();
            redirectsKeyToMap.clear();
            if (ownOptions) {
                if (ownKey) optionsToRedirectsKey.set(ownOptions, ownKey);
                redirectsMap.set(ownOptions, ownMap);
            }
        }
        function getRedirectsCacheKey(options) {
            let result = optionsToRedirectsKey.get(options);
            if (!result) optionsToRedirectsKey.set(options, result = getKeyForCompilerOptions(options, moduleResolutionOptionDeclarations));
            return result;
        }
    }
    function createPackageJsonInfoCache(currentDirectory, getCanonicalFileName) {
        let cache;
        return {
            getPackageJsonInfo: getPackageJsonInfo2,
            setPackageJsonInfo,
            clear: clear2,
            getInternalMap
        };
        function getPackageJsonInfo2(packageJsonPath) {
            return cache == null ? void 0 : cache.get(toPath(packageJsonPath, currentDirectory, getCanonicalFileName));
        }
        function setPackageJsonInfo(packageJsonPath, info) {
            (cache || (cache = /* @__PURE__ */ new Map())).set(toPath(packageJsonPath, currentDirectory, getCanonicalFileName), info);
        }
        function clear2() {
            cache = void 0;
        }
        function getInternalMap() {
            return cache;
        }
    }
    function getOrCreateCache(cacheWithRedirects, redirectedReference, key, create) {
        const cache = cacheWithRedirects.getOrCreateMapOfCacheRedirects(redirectedReference);
        let result = cache.get(key);
        if (!result) {
            result = create();
            cache.set(key, result);
        }
        return result;
    }
    function createPerDirectoryResolutionCache(currentDirectory, getCanonicalFileName, options, optionsToRedirectsKey) {
        const directoryToModuleNameMap = createCacheWithRedirects(options, optionsToRedirectsKey);
        return {
            getFromDirectoryCache,
            getOrCreateCacheForDirectory,
            clear: clear2,
            update,
            directoryToModuleNameMap
        };
        function clear2() {
            directoryToModuleNameMap.clear();
        }
        function update(options2) {
            directoryToModuleNameMap.update(options2);
        }
        function getOrCreateCacheForDirectory(directoryName, redirectedReference) {
            const path = toPath(directoryName, currentDirectory, getCanonicalFileName);
            return getOrCreateCache(directoryToModuleNameMap, redirectedReference, path, ()=>createModeAwareCache());
        }
        function getFromDirectoryCache(name, mode, directoryName, redirectedReference) {
            var _a, _b;
            const path = toPath(directoryName, currentDirectory, getCanonicalFileName);
            return (_b = (_a = directoryToModuleNameMap.getMapOfCacheRedirects(redirectedReference)) == null ? void 0 : _a.get(path)) == null ? void 0 : _b.get(name, mode);
        }
    }
    function createModeAwareCacheKey(specifier, mode) {
        return mode === void 0 ? specifier : `${mode}|${specifier}`;
    }
    function createModeAwareCache() {
        const underlying = /* @__PURE__ */ new Map();
        const memoizedReverseKeys = /* @__PURE__ */ new Map();
        const cache = {
            get (specifier, mode) {
                return underlying.get(getUnderlyingCacheKey(specifier, mode));
            },
            set (specifier, mode, value1) {
                underlying.set(getUnderlyingCacheKey(specifier, mode), value1);
                return cache;
            },
            delete (specifier, mode) {
                underlying.delete(getUnderlyingCacheKey(specifier, mode));
                return cache;
            },
            has (specifier, mode) {
                return underlying.has(getUnderlyingCacheKey(specifier, mode));
            },
            forEach (cb) {
                return underlying.forEach((elem, key)=>{
                    const [specifier, mode] = memoizedReverseKeys.get(key);
                    return cb(elem, specifier, mode);
                });
            },
            size () {
                return underlying.size;
            }
        };
        return cache;
        function getUnderlyingCacheKey(specifier, mode) {
            const result = createModeAwareCacheKey(specifier, mode);
            memoizedReverseKeys.set(result, [
                specifier,
                mode
            ]);
            return result;
        }
    }
    function getOriginalOrResolvedModuleFileName(result) {
        return result.resolvedModule && (result.resolvedModule.originalPath || result.resolvedModule.resolvedFileName);
    }
    function getOriginalOrResolvedTypeReferenceFileName(result) {
        return result.resolvedTypeReferenceDirective && (result.resolvedTypeReferenceDirective.originalPath || result.resolvedTypeReferenceDirective.resolvedFileName);
    }
    function createNonRelativeNameResolutionCache(currentDirectory, getCanonicalFileName, options, getResolvedFileName, optionsToRedirectsKey) {
        const moduleNameToDirectoryMap = createCacheWithRedirects(options, optionsToRedirectsKey);
        return {
            getFromNonRelativeNameCache,
            getOrCreateCacheForNonRelativeName,
            clear: clear2,
            update
        };
        function clear2() {
            moduleNameToDirectoryMap.clear();
        }
        function update(options2) {
            moduleNameToDirectoryMap.update(options2);
        }
        function getFromNonRelativeNameCache(nonRelativeModuleName, mode, directoryName, redirectedReference) {
            var _a, _b;
            Debug.assert(!isExternalModuleNameRelative(nonRelativeModuleName));
            return (_b = (_a = moduleNameToDirectoryMap.getMapOfCacheRedirects(redirectedReference)) == null ? void 0 : _a.get(createModeAwareCacheKey(nonRelativeModuleName, mode))) == null ? void 0 : _b.get(directoryName);
        }
        function getOrCreateCacheForNonRelativeName(nonRelativeModuleName, mode, redirectedReference) {
            Debug.assert(!isExternalModuleNameRelative(nonRelativeModuleName));
            return getOrCreateCache(moduleNameToDirectoryMap, redirectedReference, createModeAwareCacheKey(nonRelativeModuleName, mode), createPerModuleNameCache);
        }
        function createPerModuleNameCache() {
            const directoryPathMap = /* @__PURE__ */ new Map();
            return {
                get,
                set
            };
            function get(directory) {
                return directoryPathMap.get(toPath(directory, currentDirectory, getCanonicalFileName));
            }
            function set(directory, result) {
                const path = toPath(directory, currentDirectory, getCanonicalFileName);
                if (directoryPathMap.has(path)) return;
                directoryPathMap.set(path, result);
                const resolvedFileName = getResolvedFileName(result);
                const commonPrefix = resolvedFileName && getCommonPrefix(path, resolvedFileName);
                let current = path;
                while(current !== commonPrefix){
                    const parent2 = getDirectoryPath(current);
                    if (parent2 === current || directoryPathMap.has(parent2)) break;
                    directoryPathMap.set(parent2, result);
                    current = parent2;
                }
            }
            function getCommonPrefix(directory, resolution) {
                const resolutionDirectory = toPath(getDirectoryPath(resolution), currentDirectory, getCanonicalFileName);
                let i = 0;
                const limit = Math.min(directory.length, resolutionDirectory.length);
                while(i < limit && directory.charCodeAt(i) === resolutionDirectory.charCodeAt(i))i++;
                if (i === directory.length && (resolutionDirectory.length === i || resolutionDirectory[i] === directorySeparator)) return directory;
                const rootLength = getRootLength(directory);
                if (i < rootLength) return void 0;
                const sep = directory.lastIndexOf(directorySeparator, i - 1);
                if (sep === -1) return void 0;
                return directory.substr(0, Math.max(sep, rootLength));
            }
        }
    }
    function createModuleOrTypeReferenceResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, getResolvedFileName, optionsToRedirectsKey) {
        optionsToRedirectsKey !== null && optionsToRedirectsKey !== void 0 ? optionsToRedirectsKey : optionsToRedirectsKey = /* @__PURE__ */ new Map();
        const perDirectoryResolutionCache = createPerDirectoryResolutionCache(currentDirectory, getCanonicalFileName, options, optionsToRedirectsKey);
        const nonRelativeNameResolutionCache = createNonRelativeNameResolutionCache(currentDirectory, getCanonicalFileName, options, getResolvedFileName, optionsToRedirectsKey);
        packageJsonInfoCache !== null && packageJsonInfoCache !== void 0 ? packageJsonInfoCache : packageJsonInfoCache = createPackageJsonInfoCache(currentDirectory, getCanonicalFileName);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, packageJsonInfoCache, perDirectoryResolutionCache, nonRelativeNameResolutionCache), {
            clear: clear2,
            update,
            getPackageJsonInfoCache: ()=>packageJsonInfoCache,
            clearAllExceptPackageJsonInfoCache,
            optionsToRedirectsKey
        });
        function clear2() {
            clearAllExceptPackageJsonInfoCache();
            packageJsonInfoCache.clear();
        }
        function clearAllExceptPackageJsonInfoCache() {
            perDirectoryResolutionCache.clear();
            nonRelativeNameResolutionCache.clear();
        }
        function update(options2) {
            perDirectoryResolutionCache.update(options2);
            nonRelativeNameResolutionCache.update(options2);
        }
    }
    function createModuleResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, optionsToRedirectsKey) {
        const result = createModuleOrTypeReferenceResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, getOriginalOrResolvedModuleFileName, optionsToRedirectsKey);
        result.getOrCreateCacheForModuleName = (nonRelativeName, mode, redirectedReference)=>result.getOrCreateCacheForNonRelativeName(nonRelativeName, mode, redirectedReference);
        return result;
    }
    function createTypeReferenceDirectiveResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, optionsToRedirectsKey) {
        return createModuleOrTypeReferenceResolutionCache(currentDirectory, getCanonicalFileName, options, packageJsonInfoCache, getOriginalOrResolvedTypeReferenceFileName, optionsToRedirectsKey);
    }
    function getOptionsForLibraryResolution(options) {
        return {
            moduleResolution: 2 /* Node10 */ ,
            traceResolution: options.traceResolution
        };
    }
    function resolveLibrary(libraryName, resolveFrom, compilerOptions, host, cache) {
        return resolveModuleName(libraryName, resolveFrom, getOptionsForLibraryResolution(compilerOptions), host, cache);
    }
    function resolveModuleNameFromCache(moduleName, containingFile, cache, mode) {
        const containingDirectory = getDirectoryPath(containingFile);
        return cache.getFromDirectoryCache(moduleName, mode, containingDirectory, /*redirectedReference*/ void 0);
    }
    function resolveModuleName(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        if (redirectedReference) compilerOptions = redirectedReference.commandLine.options;
        if (traceEnabled) {
            trace(host, Diagnostics.Resolving_module_0_from_1, moduleName, containingFile);
            if (redirectedReference) trace(host, Diagnostics.Using_compiler_options_of_project_reference_redirect_0, redirectedReference.sourceFile.fileName);
        }
        const containingDirectory = getDirectoryPath(containingFile);
        let result = cache == null ? void 0 : cache.getFromDirectoryCache(moduleName, resolutionMode, containingDirectory, redirectedReference);
        if (result) {
            if (traceEnabled) trace(host, Diagnostics.Resolution_for_module_0_was_found_in_cache_from_location_1, moduleName, containingDirectory);
        } else {
            let moduleResolution = compilerOptions.moduleResolution;
            if (moduleResolution === void 0) {
                moduleResolution = getEmitModuleResolutionKind(compilerOptions);
                if (traceEnabled) trace(host, Diagnostics.Module_resolution_kind_is_not_specified_using_0, ModuleResolutionKind[moduleResolution]);
            } else if (traceEnabled) trace(host, Diagnostics.Explicitly_specified_module_resolution_kind_Colon_0, ModuleResolutionKind[moduleResolution]);
            switch(moduleResolution){
                case 3 /* Node16 */ :
                    result = node16ModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
                    break;
                case 99 /* NodeNext */ :
                    result = nodeNextModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
                    break;
                case 2 /* Node10 */ :
                    result = nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode ? getConditions(compilerOptions, resolutionMode) : void 0);
                    break;
                case 1 /* Classic */ :
                    result = classicNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference);
                    break;
                case 100 /* Bundler */ :
                    result = bundlerModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode ? getConditions(compilerOptions, resolutionMode) : void 0);
                    break;
                default:
                    return Debug.fail(`Unexpected moduleResolution: ${moduleResolution}`);
            }
            if (cache && !cache.isReadonly) {
                cache.getOrCreateCacheForDirectory(containingDirectory, redirectedReference).set(moduleName, resolutionMode, result);
                if (!isExternalModuleNameRelative(moduleName)) cache.getOrCreateCacheForNonRelativeName(moduleName, resolutionMode, redirectedReference).set(containingDirectory, result);
            }
        }
        if (traceEnabled) {
            if (result.resolvedModule) {
                if (result.resolvedModule.packageId) trace(host, Diagnostics.Module_name_0_was_successfully_resolved_to_1_with_Package_ID_2, moduleName, result.resolvedModule.resolvedFileName, packageIdToString(result.resolvedModule.packageId));
                else trace(host, Diagnostics.Module_name_0_was_successfully_resolved_to_1, moduleName, result.resolvedModule.resolvedFileName);
            } else trace(host, Diagnostics.Module_name_0_was_not_resolved, moduleName);
        }
        return result;
    }
    function tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loader, state) {
        const resolved = tryLoadModuleUsingPathsIfEligible(extensions, moduleName, loader, state);
        if (resolved) return resolved.value;
        if (!isExternalModuleNameRelative(moduleName)) return tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, state);
        else return tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, state);
    }
    function tryLoadModuleUsingPathsIfEligible(extensions, moduleName, loader, state) {
        const { baseUrl, paths } = state.compilerOptions;
        if (paths && !pathIsRelative(moduleName)) {
            if (state.traceEnabled) {
                if (baseUrl) trace(state.host, Diagnostics.baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1, baseUrl, moduleName);
                trace(state.host, Diagnostics.paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0, moduleName);
            }
            const baseDirectory = getPathsBasePath(state.compilerOptions, state.host);
            const pathPatterns = tryParsePatterns(paths);
            return tryLoadModuleUsingPaths(extensions, moduleName, baseDirectory, paths, pathPatterns, loader, /*onlyRecordFailures*/ false, state);
        }
    }
    function tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, state) {
        if (!state.compilerOptions.rootDirs) return void 0;
        if (state.traceEnabled) trace(state.host, Diagnostics.rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0, moduleName);
        const candidate = normalizePath(combinePaths(containingDirectory, moduleName));
        let matchedRootDir;
        let matchedNormalizedPrefix;
        for (const rootDir of state.compilerOptions.rootDirs){
            let normalizedRoot = normalizePath(rootDir);
            if (!endsWith(normalizedRoot, directorySeparator)) normalizedRoot += directorySeparator;
            const isLongestMatchingPrefix = startsWith(candidate, normalizedRoot) && (matchedNormalizedPrefix === void 0 || matchedNormalizedPrefix.length < normalizedRoot.length);
            if (state.traceEnabled) trace(state.host, Diagnostics.Checking_if_0_is_the_longest_matching_prefix_for_1_2, normalizedRoot, candidate, isLongestMatchingPrefix);
            if (isLongestMatchingPrefix) {
                matchedNormalizedPrefix = normalizedRoot;
                matchedRootDir = rootDir;
            }
        }
        if (matchedNormalizedPrefix) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Longest_matching_prefix_for_0_is_1, candidate, matchedNormalizedPrefix);
            const suffix = candidate.substr(matchedNormalizedPrefix.length);
            if (state.traceEnabled) trace(state.host, Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, matchedNormalizedPrefix, candidate);
            const resolvedFileName = loader(extensions, candidate, !directoryProbablyExists(containingDirectory, state.host), state);
            if (resolvedFileName) return resolvedFileName;
            if (state.traceEnabled) trace(state.host, Diagnostics.Trying_other_entries_in_rootDirs);
            for (const rootDir of state.compilerOptions.rootDirs){
                if (rootDir === matchedRootDir) continue;
                const candidate2 = combinePaths(normalizePath(rootDir), suffix);
                if (state.traceEnabled) trace(state.host, Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, rootDir, candidate2);
                const baseDirectory = getDirectoryPath(candidate2);
                const resolvedFileName2 = loader(extensions, candidate2, !directoryProbablyExists(baseDirectory, state.host), state);
                if (resolvedFileName2) return resolvedFileName2;
            }
            if (state.traceEnabled) trace(state.host, Diagnostics.Module_resolution_using_rootDirs_has_failed);
        }
        return void 0;
    }
    function tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, state) {
        const { baseUrl } = state.compilerOptions;
        if (!baseUrl) return void 0;
        if (state.traceEnabled) trace(state.host, Diagnostics.baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1, baseUrl, moduleName);
        const candidate = normalizePath(combinePaths(baseUrl, moduleName));
        if (state.traceEnabled) trace(state.host, Diagnostics.Resolving_module_name_0_relative_to_base_url_1_2, moduleName, baseUrl, candidate);
        return loader(extensions, candidate, !directoryProbablyExists(getDirectoryPath(candidate), state.host), state);
    }
    function resolveJSModule(moduleName, initialDir, host) {
        const { resolvedModule, failedLookupLocations } = tryResolveJSModuleWorker(moduleName, initialDir, host);
        if (!resolvedModule) throw new Error(`Could not resolve JS module '${moduleName}' starting at '${initialDir}'. Looked in: ${failedLookupLocations == null ? void 0 : failedLookupLocations.join(", ")}`);
        return resolvedModule.resolvedFileName;
    }
    var NodeResolutionFeatures = /* @__PURE__ */ ((NodeResolutionFeatures2)=>{
        NodeResolutionFeatures2[NodeResolutionFeatures2["None"] = 0] = "None";
        NodeResolutionFeatures2[NodeResolutionFeatures2["Imports"] = 2] = "Imports";
        NodeResolutionFeatures2[NodeResolutionFeatures2["SelfName"] = 4] = "SelfName";
        NodeResolutionFeatures2[NodeResolutionFeatures2["Exports"] = 8] = "Exports";
        NodeResolutionFeatures2[NodeResolutionFeatures2["ExportsPatternTrailers"] = 16] = "ExportsPatternTrailers";
        NodeResolutionFeatures2[NodeResolutionFeatures2["AllFeatures"] = 30] = "AllFeatures";
        NodeResolutionFeatures2[NodeResolutionFeatures2["Node16Default"] = 30] = "Node16Default";
        NodeResolutionFeatures2[NodeResolutionFeatures2["NodeNextDefault"] = 30 /* AllFeatures */ ] = "NodeNextDefault";
        NodeResolutionFeatures2[NodeResolutionFeatures2["BundlerDefault"] = 30] = "BundlerDefault";
        NodeResolutionFeatures2[NodeResolutionFeatures2["EsmMode"] = 32] = "EsmMode";
        return NodeResolutionFeatures2;
    })(NodeResolutionFeatures || {});
    function node16ModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        return nodeNextModuleNameResolverWorker(30 /* Node16Default */ , moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
    }
    function nodeNextModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode) {
        return nodeNextModuleNameResolverWorker(30 /* NodeNextDefault */ , moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode);
    }
    function nodeNextModuleNameResolverWorker(features, moduleName, containingFile, compilerOptions, host, cache, redirectedReference, resolutionMode, conditions) {
        const containingDirectory = getDirectoryPath(containingFile);
        const esmMode = resolutionMode === 99 /* ESNext */  ? 32 /* EsmMode */  : 0;
        let extensions = compilerOptions.noDtsResolution ? 3 /* ImplementationFiles */  : 7 /* Declaration */ ;
        if (getResolveJsonModule(compilerOptions)) extensions |= 8 /* Json */ ;
        return nodeModuleNameResolverWorker(features | esmMode, moduleName, containingDirectory, compilerOptions, host, cache, extensions, /*isConfigLookup*/ false, redirectedReference, conditions);
    }
    function tryResolveJSModuleWorker(moduleName, initialDir, host) {
        return nodeModuleNameResolverWorker(0 /* None */ , moduleName, initialDir, {
            moduleResolution: 2 /* Node10 */ ,
            allowJs: true
        }, host, /*cache*/ void 0, 2 /* JavaScript */ , /*isConfigLookup*/ false, /*redirectedReference*/ void 0, /*conditions*/ void 0);
    }
    function bundlerModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, conditions) {
        const containingDirectory = getDirectoryPath(containingFile);
        let extensions = compilerOptions.noDtsResolution ? 3 /* ImplementationFiles */  : 7 /* Declaration */ ;
        if (getResolveJsonModule(compilerOptions)) extensions |= 8 /* Json */ ;
        return nodeModuleNameResolverWorker(getNodeResolutionFeatures(compilerOptions), moduleName, containingDirectory, compilerOptions, host, cache, extensions, /*isConfigLookup*/ false, redirectedReference, conditions);
    }
    function nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference, conditions, isConfigLookup) {
        let extensions;
        if (isConfigLookup) extensions = 8 /* Json */ ;
        else if (compilerOptions.noDtsResolution) {
            extensions = 3 /* ImplementationFiles */ ;
            if (getResolveJsonModule(compilerOptions)) extensions |= 8 /* Json */ ;
        } else extensions = getResolveJsonModule(compilerOptions) ? 15 /* Json */  : 7 /* Declaration */ ;
        return nodeModuleNameResolverWorker(conditions ? 30 /* AllFeatures */  : 0 /* None */ , moduleName, getDirectoryPath(containingFile), compilerOptions, host, cache, extensions, !!isConfigLookup, redirectedReference, conditions);
    }
    function nodeNextJsonConfigResolver(moduleName, containingFile, host) {
        return nodeModuleNameResolverWorker(30 /* NodeNextDefault */ , moduleName, getDirectoryPath(containingFile), {
            moduleResolution: 99 /* NodeNext */ 
        }, host, /*cache*/ void 0, 8 /* Json */ , /*isConfigLookup*/ true, /*redirectedReference*/ void 0, /*conditions*/ void 0);
    }
    function nodeModuleNameResolverWorker(features, moduleName, containingDirectory, compilerOptions, host, cache, extensions, isConfigLookup, redirectedReference, conditions) {
        var _a, _b, _c, _d, _e;
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        const failedLookupLocations = [];
        const affectingLocations = [];
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        conditions !== null && conditions !== void 0 ? conditions : conditions = getConditions(compilerOptions, moduleResolution === 100 /* Bundler */  || moduleResolution === 2 /* Node10 */  ? void 0 : features & 32 /* EsmMode */  ? 99 /* ESNext */  : 1 /* CommonJS */ );
        const diagnostics = [];
        const state = {
            compilerOptions,
            host,
            traceEnabled,
            failedLookupLocations,
            affectingLocations,
            packageJsonInfoCache: cache,
            features,
            conditions: conditions !== null && conditions !== void 0 ? conditions : emptyArray,
            requestContainingDirectory: containingDirectory,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup,
            candidateIsFromPackageJsonField: false,
            resolvedPackageDirectory: false
        };
        if (traceEnabled && moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) trace(host, Diagnostics.Resolving_in_0_mode_with_conditions_1, features & 32 /* EsmMode */  ? "ESM" : "CJS", state.conditions.map((c)=>`'${c}'`).join(", "));
        let result;
        if (moduleResolution === 2 /* Node10 */ ) {
            const priorityExtensions = extensions & 5 /* Declaration */ ;
            const secondaryExtensions = extensions & -6;
            result = priorityExtensions && tryResolve(priorityExtensions, state) || secondaryExtensions && tryResolve(secondaryExtensions, state) || void 0;
        } else result = tryResolve(extensions, state);
        let alternateResult;
        if (state.resolvedPackageDirectory && !isConfigLookup && !isExternalModuleNameRelative(moduleName)) {
            const wantedTypesButGotJs = (result == null ? void 0 : result.value) && extensions & 5 /* Declaration */  && !extensionIsOk(5 /* Declaration */ , result.value.resolved.extension);
            if (((_a = result == null ? void 0 : result.value) == null ? void 0 : _a.isExternalLibraryImport) && wantedTypesButGotJs && features & 8 /* Exports */  && (conditions == null ? void 0 : conditions.includes("import"))) {
                traceIfEnabled(state, Diagnostics.Resolution_of_non_relative_name_failed_trying_with_modern_Node_resolution_features_disabled_to_see_if_npm_library_needs_configuration_update);
                const diagnosticState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    features: state.features & -9 /* Exports */ ,
                    reportDiagnostic: noop
                });
                const diagnosticResult = tryResolve(extensions & 5 /* Declaration */ , diagnosticState);
                if ((_b = diagnosticResult == null ? void 0 : diagnosticResult.value) == null ? void 0 : _b.isExternalLibraryImport) alternateResult = diagnosticResult.value.resolved.path;
            } else if ((!(result == null ? void 0 : result.value) || wantedTypesButGotJs) && moduleResolution === 2 /* Node10 */ ) {
                traceIfEnabled(state, Diagnostics.Resolution_of_non_relative_name_failed_trying_with_moduleResolution_bundler_to_see_if_project_may_need_configuration_update);
                const diagnosticsCompilerOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.compilerOptions), {
                    moduleResolution: 100 /* Bundler */ 
                });
                const diagnosticState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    compilerOptions: diagnosticsCompilerOptions,
                    features: 30 /* BundlerDefault */ ,
                    conditions: getConditions(diagnosticsCompilerOptions),
                    reportDiagnostic: noop
                });
                const diagnosticResult = tryResolve(extensions & 5 /* Declaration */ , diagnosticState);
                if ((_c = diagnosticResult == null ? void 0 : diagnosticResult.value) == null ? void 0 : _c.isExternalLibraryImport) alternateResult = diagnosticResult.value.resolved.path;
            }
        }
        return createResolvedModuleWithFailedLookupLocationsHandlingSymlink(moduleName, (_d = result == null ? void 0 : result.value) == null ? void 0 : _d.resolved, (_e = result == null ? void 0 : result.value) == null ? void 0 : _e.isExternalLibraryImport, failedLookupLocations, affectingLocations, diagnostics, state, cache, alternateResult);
        function tryResolve(extensions2, state2) {
            const loader = (extensions3, candidate, onlyRecordFailures, state3)=>nodeLoadModuleByRelativeName(extensions3, candidate, onlyRecordFailures, state3, /*considerPackageJson*/ true);
            const resolved = tryLoadModuleUsingOptionalResolutionSettings(extensions2, moduleName, containingDirectory, loader, state2);
            if (resolved) return toSearchResult({
                resolved,
                isExternalLibraryImport: pathContainsNodeModules(resolved.path)
            });
            if (!isExternalModuleNameRelative(moduleName)) {
                if (features & 2 /* Imports */  && startsWith(moduleName, "#")) {
                    const resolved3 = loadModuleFromImports(extensions2, moduleName, containingDirectory, state2, cache, redirectedReference);
                    if (resolved3) return resolved3.value && {
                        value: {
                            resolved: resolved3.value,
                            isExternalLibraryImport: false
                        }
                    };
                }
                if (features & 4 /* SelfName */ ) {
                    const resolved3 = loadModuleFromSelfNameReference(extensions2, moduleName, containingDirectory, state2, cache, redirectedReference);
                    if (resolved3) return resolved3.value && {
                        value: {
                            resolved: resolved3.value,
                            isExternalLibraryImport: false
                        }
                    };
                }
                if (moduleName.includes(":")) {
                    if (traceEnabled) trace(host, Diagnostics.Skipping_module_0_that_looks_like_an_absolute_URI_target_file_types_Colon_1, moduleName, formatExtensions(extensions2));
                    return void 0;
                }
                if (traceEnabled) trace(host, Diagnostics.Loading_module_0_from_node_modules_folder_target_file_types_Colon_1, moduleName, formatExtensions(extensions2));
                let resolved2 = loadModuleFromNearestNodeModulesDirectory(extensions2, moduleName, containingDirectory, state2, cache, redirectedReference);
                if (extensions2 & 4 /* Declaration */ ) resolved2 !== null && resolved2 !== void 0 ? resolved2 : resolved2 = resolveFromTypeRoot(moduleName, state2);
                return resolved2 && {
                    value: resolved2.value && {
                        resolved: resolved2.value,
                        isExternalLibraryImport: true
                    }
                };
            } else {
                const { path: candidate, parts } = normalizePathForCJSResolution(containingDirectory, moduleName);
                const resolved2 = nodeLoadModuleByRelativeName(extensions2, candidate, /*onlyRecordFailures*/ false, state2, /*considerPackageJson*/ true);
                return resolved2 && toSearchResult({
                    resolved: resolved2,
                    isExternalLibraryImport: contains(parts, "node_modules")
                });
            }
        }
    }
    function normalizePathForCJSResolution(containingDirectory, moduleName) {
        const combined = combinePaths(containingDirectory, moduleName);
        const parts = getPathComponents(combined);
        const lastPart = lastOrUndefined(parts);
        const path = lastPart === "." || lastPart === ".." ? ensureTrailingDirectorySeparator(normalizePath(combined)) : normalizePath(combined);
        return {
            path,
            parts
        };
    }
    function realPath(path, host, traceEnabled) {
        if (!host.realpath) return path;
        const real = normalizePath(host.realpath(path));
        if (traceEnabled) trace(host, Diagnostics.Resolving_real_path_for_0_result_1, path, real);
        return real;
    }
    function nodeLoadModuleByRelativeName(extensions, candidate, onlyRecordFailures, state, considerPackageJson) {
        if (state.traceEnabled) trace(state.host, Diagnostics.Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_types_Colon_1, candidate, formatExtensions(extensions));
        if (!hasTrailingDirectorySeparator(candidate)) {
            if (!onlyRecordFailures) {
                const parentOfCandidate = getDirectoryPath(candidate);
                if (!directoryProbablyExists(parentOfCandidate, state.host)) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, parentOfCandidate);
                    onlyRecordFailures = true;
                }
            }
            const resolvedFromFile = loadModuleFromFile(extensions, candidate, onlyRecordFailures, state);
            if (resolvedFromFile) {
                const packageDirectory = considerPackageJson ? parseNodeModuleFromPath(resolvedFromFile.path) : void 0;
                const packageInfo = packageDirectory ? getPackageJsonInfo(packageDirectory, /*onlyRecordFailures*/ false, state) : void 0;
                return withPackageId(packageInfo, resolvedFromFile, state);
            }
        }
        if (!onlyRecordFailures) {
            const candidateExists = directoryProbablyExists(candidate, state.host);
            if (!candidateExists) {
                if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, candidate);
                onlyRecordFailures = true;
            }
        }
        if (!(state.features & 32 /* EsmMode */ )) return loadNodeModuleFromDirectory(extensions, candidate, onlyRecordFailures, state, considerPackageJson);
        return void 0;
    }
    var nodeModulesPathPart = "/node_modules/";
    function pathContainsNodeModules(path) {
        return path.includes(nodeModulesPathPart);
    }
    function parseNodeModuleFromPath(resolved, isFolder) {
        const path = normalizePath(resolved);
        const idx = path.lastIndexOf(nodeModulesPathPart);
        if (idx === -1) return void 0;
        const indexAfterNodeModules = idx + nodeModulesPathPart.length;
        let indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterNodeModules, isFolder);
        if (path.charCodeAt(indexAfterNodeModules) === 64 /* at */ ) indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterPackageName, isFolder);
        return path.slice(0, indexAfterPackageName);
    }
    function moveToNextDirectorySeparatorIfAvailable(path, prevSeparatorIndex, isFolder) {
        const nextSeparatorIndex = path.indexOf(directorySeparator, prevSeparatorIndex + 1);
        return nextSeparatorIndex === -1 ? isFolder ? path.length : prevSeparatorIndex : nextSeparatorIndex;
    }
    function loadModuleFromFileNoPackageId(extensions, candidate, onlyRecordFailures, state) {
        return noPackageId(loadModuleFromFile(extensions, candidate, onlyRecordFailures, state));
    }
    function loadModuleFromFile(extensions, candidate, onlyRecordFailures, state) {
        const resolvedByReplacingExtension = loadModuleFromFileNoImplicitExtensions(extensions, candidate, onlyRecordFailures, state);
        if (resolvedByReplacingExtension) return resolvedByReplacingExtension;
        if (!(state.features & 32 /* EsmMode */ )) {
            const resolvedByAddingExtension = tryAddingExtensions(candidate, extensions, "", onlyRecordFailures, state);
            if (resolvedByAddingExtension) return resolvedByAddingExtension;
        }
    }
    function loadModuleFromFileNoImplicitExtensions(extensions, candidate, onlyRecordFailures, state) {
        const filename = getBaseFileName(candidate);
        if (!filename.includes(".")) return void 0;
        let extensionless = removeFileExtension(candidate);
        if (extensionless === candidate) extensionless = candidate.substring(0, candidate.lastIndexOf("."));
        const extension = candidate.substring(extensionless.length);
        if (state.traceEnabled) trace(state.host, Diagnostics.File_name_0_has_a_1_extension_stripping_it, candidate, extension);
        return tryAddingExtensions(extensionless, extensions, extension, onlyRecordFailures, state);
    }
    function loadFileNameFromPackageJsonField(extensions, candidate, packageJsonValue, onlyRecordFailures, state) {
        if (extensions & 1 /* TypeScript */  && fileExtensionIsOneOf(candidate, supportedTSImplementationExtensions) || extensions & 4 /* Declaration */  && fileExtensionIsOneOf(candidate, supportedDeclarationExtensions)) {
            const result = tryFile(candidate, onlyRecordFailures, state);
            const ext = tryExtractTSExtension(candidate);
            return result !== void 0 ? {
                path: candidate,
                ext,
                resolvedUsingTsExtension: packageJsonValue ? !endsWith(packageJsonValue, ext) : void 0
            } : void 0;
        }
        if (state.isConfigLookup && extensions === 8 /* Json */  && fileExtensionIs(candidate, ".json" /* Json */ )) {
            const result = tryFile(candidate, onlyRecordFailures, state);
            return result !== void 0 ? {
                path: candidate,
                ext: ".json" /* Json */ ,
                resolvedUsingTsExtension: void 0
            } : void 0;
        }
        return loadModuleFromFileNoImplicitExtensions(extensions, candidate, onlyRecordFailures, state);
    }
    function tryAddingExtensions(candidate, extensions, originalExtension, onlyRecordFailures, state) {
        if (!onlyRecordFailures) {
            const directory = getDirectoryPath(candidate);
            if (directory) onlyRecordFailures = !directoryProbablyExists(directory, state.host);
        }
        switch(originalExtension){
            case ".mjs" /* Mjs */ :
            case ".mts" /* Mts */ :
            case ".d.mts" /* Dmts */ :
                return extensions & 1 /* TypeScript */  && tryExtension(".mts" /* Mts */ , originalExtension === ".mts" /* Mts */  || originalExtension === ".d.mts" /* Dmts */ ) || extensions & 4 /* Declaration */  && tryExtension(".d.mts" /* Dmts */ , originalExtension === ".mts" /* Mts */  || originalExtension === ".d.mts" /* Dmts */ ) || extensions & 2 /* JavaScript */  && tryExtension(".mjs" /* Mjs */ ) || void 0;
            case ".cjs" /* Cjs */ :
            case ".cts" /* Cts */ :
            case ".d.cts" /* Dcts */ :
                return extensions & 1 /* TypeScript */  && tryExtension(".cts" /* Cts */ , originalExtension === ".cts" /* Cts */  || originalExtension === ".d.cts" /* Dcts */ ) || extensions & 4 /* Declaration */  && tryExtension(".d.cts" /* Dcts */ , originalExtension === ".cts" /* Cts */  || originalExtension === ".d.cts" /* Dcts */ ) || extensions & 2 /* JavaScript */  && tryExtension(".cjs" /* Cjs */ ) || void 0;
            case ".json" /* Json */ :
                return extensions & 4 /* Declaration */  && tryExtension(".d.json.ts") || extensions & 8 /* Json */  && tryExtension(".json" /* Json */ ) || void 0;
            case ".tsx" /* Tsx */ :
            case ".jsx" /* Jsx */ :
                return extensions & 1 /* TypeScript */  && (tryExtension(".tsx" /* Tsx */ , originalExtension === ".tsx" /* Tsx */ ) || tryExtension(".ts" /* Ts */ , originalExtension === ".tsx" /* Tsx */ )) || extensions & 4 /* Declaration */  && tryExtension(".d.ts" /* Dts */ , originalExtension === ".tsx" /* Tsx */ ) || extensions & 2 /* JavaScript */  && (tryExtension(".jsx" /* Jsx */ ) || tryExtension(".js" /* Js */ )) || void 0;
            case ".ts" /* Ts */ :
            case ".d.ts" /* Dts */ :
            case ".js" /* Js */ :
            case "":
                return extensions & 1 /* TypeScript */  && (tryExtension(".ts" /* Ts */ , originalExtension === ".ts" /* Ts */  || originalExtension === ".d.ts" /* Dts */ ) || tryExtension(".tsx" /* Tsx */ , originalExtension === ".ts" /* Ts */  || originalExtension === ".d.ts" /* Dts */ )) || extensions & 4 /* Declaration */  && tryExtension(".d.ts" /* Dts */ , originalExtension === ".ts" /* Ts */  || originalExtension === ".d.ts" /* Dts */ ) || extensions & 2 /* JavaScript */  && (tryExtension(".js" /* Js */ ) || tryExtension(".jsx" /* Jsx */ )) || state.isConfigLookup && tryExtension(".json" /* Json */ ) || void 0;
            default:
                return extensions & 4 /* Declaration */  && !isDeclarationFileName(candidate + originalExtension) && tryExtension(`.d${originalExtension}.ts`) || void 0;
        }
        function tryExtension(ext, resolvedUsingTsExtension) {
            const path = tryFile(candidate + ext, onlyRecordFailures, state);
            return path === void 0 ? void 0 : {
                path,
                ext,
                resolvedUsingTsExtension: !state.candidateIsFromPackageJsonField && resolvedUsingTsExtension
            };
        }
    }
    function tryFile(fileName, onlyRecordFailures, state) {
        var _a;
        if (!((_a = state.compilerOptions.moduleSuffixes) == null ? void 0 : _a.length)) return tryFileLookup(fileName, onlyRecordFailures, state);
        var _tryGetExtensionFromPath2;
        const ext = (_tryGetExtensionFromPath2 = tryGetExtensionFromPath2(fileName)) !== null && _tryGetExtensionFromPath2 !== void 0 ? _tryGetExtensionFromPath2 : "";
        const fileNameNoExtension = ext ? removeExtension(fileName, ext) : fileName;
        return forEach(state.compilerOptions.moduleSuffixes, (suffix)=>tryFileLookup(fileNameNoExtension + suffix + ext, onlyRecordFailures, state));
    }
    function tryFileLookup(fileName, onlyRecordFailures, state) {
        var _a;
        if (!onlyRecordFailures) {
            if (state.host.fileExists(fileName)) {
                if (state.traceEnabled) trace(state.host, Diagnostics.File_0_exists_use_it_as_a_name_resolution_result, fileName);
                return fileName;
            } else if (state.traceEnabled) trace(state.host, Diagnostics.File_0_does_not_exist, fileName);
        }
        (_a = state.failedLookupLocations) == null || _a.push(fileName);
        return void 0;
    }
    function loadNodeModuleFromDirectory(extensions, candidate, onlyRecordFailures, state, considerPackageJson = true) {
        const packageInfo = considerPackageJson ? getPackageJsonInfo(candidate, onlyRecordFailures, state) : void 0;
        return withPackageId(packageInfo, loadNodeModuleFromDirectoryWorker(extensions, candidate, onlyRecordFailures, state, packageInfo), state);
    }
    function getEntrypointsFromPackageJsonInfo(packageJsonInfo, options, host, cache, resolveJs) {
        if (!resolveJs && packageJsonInfo.contents.resolvedEntrypoints !== void 0) return packageJsonInfo.contents.resolvedEntrypoints;
        let entrypoints;
        const extensions = 5 /* Declaration */  | (resolveJs ? 2 /* JavaScript */  : 0);
        const features = getNodeResolutionFeatures(options);
        const loadPackageJsonMainState = getTemporaryModuleResolutionState(cache == null ? void 0 : cache.getPackageJsonInfoCache(), host, options);
        loadPackageJsonMainState.conditions = getConditions(options);
        loadPackageJsonMainState.requestContainingDirectory = packageJsonInfo.packageDirectory;
        const mainResolution = loadNodeModuleFromDirectoryWorker(extensions, packageJsonInfo.packageDirectory, /*onlyRecordFailures*/ false, loadPackageJsonMainState, packageJsonInfo);
        entrypoints = append(entrypoints, mainResolution == null ? void 0 : mainResolution.path);
        if (features & 8 /* Exports */  && packageJsonInfo.contents.packageJsonContent.exports) {
            const conditionSets = deduplicate([
                getConditions(options, 99 /* ESNext */ ),
                getConditions(options, 1 /* CommonJS */ )
            ], arrayIsEqualTo);
            for (const conditions of conditionSets){
                const loadPackageJsonExportsState = (0, _objectSpreadProps._)((0, _objectSpread._)({}, loadPackageJsonMainState), {
                    failedLookupLocations: [],
                    conditions,
                    host
                });
                const exportResolutions = loadEntrypointsFromExportMap(packageJsonInfo, packageJsonInfo.contents.packageJsonContent.exports, loadPackageJsonExportsState, extensions);
                if (exportResolutions) for (const resolution of exportResolutions)entrypoints = appendIfUnique(entrypoints, resolution.path);
            }
        }
        return packageJsonInfo.contents.resolvedEntrypoints = entrypoints || false;
    }
    function loadEntrypointsFromExportMap(scope, exports2, state, extensions) {
        let entrypoints;
        if (isArray(exports2)) for (const target of exports2)loadEntrypointsFromTargetExports(target);
        else if (typeof exports2 === "object" && exports2 !== null && allKeysStartWithDot(exports2)) for(const key in exports2)loadEntrypointsFromTargetExports(exports2[key]);
        else loadEntrypointsFromTargetExports(exports2);
        return entrypoints;
        function loadEntrypointsFromTargetExports(target) {
            var _a, _b;
            if (typeof target === "string" && startsWith(target, "./")) {
                if (target.includes("*") && state.host.readDirectory) {
                    if (target.indexOf("*") !== target.lastIndexOf("*")) return false;
                    state.host.readDirectory(scope.packageDirectory, extensionsToExtensionsArray(extensions), /*excludes*/ void 0, [
                        changeFullExtension(replaceFirstStar(target, "**/*"), ".*")
                    ]).forEach((entry)=>{
                        entrypoints = appendIfUnique(entrypoints, {
                            path: entry,
                            ext: getAnyExtensionFromPath(entry),
                            resolvedUsingTsExtension: void 0
                        });
                    });
                } else {
                    const partsAfterFirst = getPathComponents(target).slice(2);
                    if (partsAfterFirst.includes("..") || partsAfterFirst.includes(".") || partsAfterFirst.includes("node_modules")) return false;
                    const resolvedTarget = combinePaths(scope.packageDirectory, target);
                    const finalPath = getNormalizedAbsolutePath(resolvedTarget, (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
                    const result = loadFileNameFromPackageJsonField(extensions, finalPath, target, /*onlyRecordFailures*/ false, state);
                    if (result) {
                        entrypoints = appendIfUnique(entrypoints, result, (a, b)=>a.path === b.path);
                        return true;
                    }
                }
            } else if (Array.isArray(target)) for (const t of target){
                const success = loadEntrypointsFromTargetExports(t);
                if (success) return true;
            }
            else if (typeof target === "object" && target !== null) return forEach(getOwnKeys(target), (key)=>{
                if (key === "default" || contains(state.conditions, key) || isApplicableVersionedTypesKey(state.conditions, key)) {
                    loadEntrypointsFromTargetExports(target[key]);
                    return true;
                }
            });
        }
    }
    function getTemporaryModuleResolutionState(packageJsonInfoCache, host, options) {
        return {
            host,
            compilerOptions: options,
            traceEnabled: isTraceEnabled(options, host),
            failedLookupLocations: void 0,
            affectingLocations: void 0,
            packageJsonInfoCache,
            features: 0 /* None */ ,
            conditions: emptyArray,
            requestContainingDirectory: void 0,
            reportDiagnostic: noop,
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false,
            resolvedPackageDirectory: false
        };
    }
    function getPackageScopeForPath(directory, state) {
        return forEachAncestorDirectoryStoppingAtGlobalCache(state.host, directory, (dir)=>getPackageJsonInfo(dir, /*onlyRecordFailures*/ false, state));
    }
    function getVersionPathsOfPackageJsonInfo(packageJsonInfo, state) {
        if (packageJsonInfo.contents.versionPaths === void 0) packageJsonInfo.contents.versionPaths = readPackageJsonTypesVersionPaths(packageJsonInfo.contents.packageJsonContent, state) || false;
        return packageJsonInfo.contents.versionPaths || void 0;
    }
    function getPeerDependenciesOfPackageJsonInfo(packageJsonInfo, state) {
        if (packageJsonInfo.contents.peerDependencies === void 0) packageJsonInfo.contents.peerDependencies = readPackageJsonPeerDependencies(packageJsonInfo, state) || false;
        return packageJsonInfo.contents.peerDependencies || void 0;
    }
    function readPackageJsonPeerDependencies(packageJsonInfo, state) {
        const peerDependencies = readPackageJsonField(packageJsonInfo.contents.packageJsonContent, "peerDependencies", "object", state);
        if (peerDependencies === void 0) return void 0;
        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_peerDependencies_field);
        const packageDirectory = realPath(packageJsonInfo.packageDirectory, state.host, state.traceEnabled);
        const nodeModules = packageDirectory.substring(0, packageDirectory.lastIndexOf("node_modules") + 12) + directorySeparator;
        let result = "";
        for(const key in peerDependencies)if (hasProperty(peerDependencies, key)) {
            const peerPackageJson = getPackageJsonInfo(nodeModules + key, /*onlyRecordFailures*/ false, state);
            if (peerPackageJson) {
                const version2 = peerPackageJson.contents.packageJsonContent.version;
                result += `+${key}@${version2}`;
                if (state.traceEnabled) trace(state.host, Diagnostics.Found_peerDependency_0_with_1_version, key, version2);
            } else if (state.traceEnabled) trace(state.host, Diagnostics.Failed_to_find_peerDependency_0, key);
        }
        return result;
    }
    function getPackageJsonInfo(packageDirectory, onlyRecordFailures, state) {
        var _a, _b, _c, _d, _e, _f;
        const { host, traceEnabled } = state;
        const packageJsonPath = combinePaths(packageDirectory, "package.json");
        if (onlyRecordFailures) {
            (_a = state.failedLookupLocations) == null || _a.push(packageJsonPath);
            return void 0;
        }
        const existing = (_b = state.packageJsonInfoCache) == null ? void 0 : _b.getPackageJsonInfo(packageJsonPath);
        if (existing !== void 0) {
            if (isPackageJsonInfo(existing)) {
                if (traceEnabled) trace(host, Diagnostics.File_0_exists_according_to_earlier_cached_lookups, packageJsonPath);
                (_c = state.affectingLocations) == null || _c.push(packageJsonPath);
                return existing.packageDirectory === packageDirectory ? existing : {
                    packageDirectory,
                    contents: existing.contents
                };
            } else {
                if (existing.directoryExists && traceEnabled) trace(host, Diagnostics.File_0_does_not_exist_according_to_earlier_cached_lookups, packageJsonPath);
                (_d = state.failedLookupLocations) == null || _d.push(packageJsonPath);
                return void 0;
            }
        }
        const directoryExists = directoryProbablyExists(packageDirectory, host);
        if (directoryExists && host.fileExists(packageJsonPath)) {
            const packageJsonContent = readJson(packageJsonPath, host);
            if (traceEnabled) trace(host, Diagnostics.Found_package_json_at_0, packageJsonPath);
            const result = {
                packageDirectory,
                contents: {
                    packageJsonContent,
                    versionPaths: void 0,
                    resolvedEntrypoints: void 0,
                    peerDependencies: void 0
                }
            };
            if (state.packageJsonInfoCache && !state.packageJsonInfoCache.isReadonly) state.packageJsonInfoCache.setPackageJsonInfo(packageJsonPath, result);
            (_e = state.affectingLocations) == null || _e.push(packageJsonPath);
            return result;
        } else {
            if (directoryExists && traceEnabled) trace(host, Diagnostics.File_0_does_not_exist, packageJsonPath);
            if (state.packageJsonInfoCache && !state.packageJsonInfoCache.isReadonly) state.packageJsonInfoCache.setPackageJsonInfo(packageJsonPath, {
                packageDirectory,
                directoryExists
            });
            (_f = state.failedLookupLocations) == null || _f.push(packageJsonPath);
        }
    }
    function loadNodeModuleFromDirectoryWorker(extensions, candidate, onlyRecordFailures, state, packageJson) {
        const versionPaths = packageJson && getVersionPathsOfPackageJsonInfo(packageJson, state);
        let packageFile;
        if (packageJson && arePathsEqual(packageJson == null ? void 0 : packageJson.packageDirectory, candidate, state.host)) {
            if (state.isConfigLookup) packageFile = readPackageJsonTSConfigField(packageJson.contents.packageJsonContent, packageJson.packageDirectory, state);
            else packageFile = extensions & 4 /* Declaration */  && readPackageJsonTypesFields(packageJson.contents.packageJsonContent, packageJson.packageDirectory, state) || extensions & 7 /* Declaration */  && readPackageJsonMainField(packageJson.contents.packageJsonContent, packageJson.packageDirectory, state) || void 0;
        }
        const loader = (extensions2, candidate2, onlyRecordFailures2, state2)=>{
            const fromFile = loadFileNameFromPackageJsonField(extensions2, candidate2, /*packageJsonValue*/ void 0, onlyRecordFailures2, state2);
            if (fromFile) return noPackageId(fromFile);
            const expandedExtensions = extensions2 === 4 /* Declaration */  ? 5 /* Declaration */  : extensions2;
            const features = state2.features;
            const candidateIsFromPackageJsonField = state2.candidateIsFromPackageJsonField;
            state2.candidateIsFromPackageJsonField = true;
            if ((packageJson == null ? void 0 : packageJson.contents.packageJsonContent.type) !== "module") state2.features &= -33 /* EsmMode */ ;
            const result = nodeLoadModuleByRelativeName(expandedExtensions, candidate2, onlyRecordFailures2, state2, /*considerPackageJson*/ false);
            state2.features = features;
            state2.candidateIsFromPackageJsonField = candidateIsFromPackageJsonField;
            return result;
        };
        const onlyRecordFailuresForPackageFile = packageFile ? !directoryProbablyExists(getDirectoryPath(packageFile), state.host) : void 0;
        const onlyRecordFailuresForIndex = onlyRecordFailures || !directoryProbablyExists(candidate, state.host);
        const indexPath = combinePaths(candidate, state.isConfigLookup ? "tsconfig" : "index");
        if (versionPaths && (!packageFile || containsPath(candidate, packageFile))) {
            const moduleName = getRelativePathFromDirectory(candidate, packageFile || indexPath, /*ignoreCase*/ false);
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_match_module_name_2, versionPaths.version, version, moduleName);
            const pathPatterns = tryParsePatterns(versionPaths.paths);
            const result = tryLoadModuleUsingPaths(extensions, moduleName, candidate, versionPaths.paths, pathPatterns, loader, onlyRecordFailuresForPackageFile || onlyRecordFailuresForIndex, state);
            if (result) return removeIgnoredPackageId(result.value);
        }
        const packageFileResult = packageFile && removeIgnoredPackageId(loader(extensions, packageFile, onlyRecordFailuresForPackageFile, state));
        if (packageFileResult) return packageFileResult;
        if (!(state.features & 32 /* EsmMode */ )) return loadModuleFromFile(extensions, indexPath, onlyRecordFailuresForIndex, state);
    }
    function extensionIsOk(extensions, extension) {
        return extensions & 2 /* JavaScript */  && (extension === ".js" /* Js */  || extension === ".jsx" /* Jsx */  || extension === ".mjs" /* Mjs */  || extension === ".cjs" /* Cjs */ ) || extensions & 1 /* TypeScript */  && (extension === ".ts" /* Ts */  || extension === ".tsx" /* Tsx */  || extension === ".mts" /* Mts */  || extension === ".cts" /* Cts */ ) || extensions & 4 /* Declaration */  && (extension === ".d.ts" /* Dts */  || extension === ".d.mts" /* Dmts */  || extension === ".d.cts" /* Dcts */ ) || extensions & 8 /* Json */  && extension === ".json" /* Json */  || false;
    }
    function parsePackageName(moduleName) {
        let idx = moduleName.indexOf(directorySeparator);
        if (moduleName[0] === "@") idx = moduleName.indexOf(directorySeparator, idx + 1);
        return idx === -1 ? {
            packageName: moduleName,
            rest: ""
        } : {
            packageName: moduleName.slice(0, idx),
            rest: moduleName.slice(idx + 1)
        };
    }
    function allKeysStartWithDot(obj) {
        return every(getOwnKeys(obj), (k)=>startsWith(k, "."));
    }
    function noKeyStartsWithDot(obj) {
        return !some(getOwnKeys(obj), (k)=>startsWith(k, "."));
    }
    function loadModuleFromSelfNameReference(extensions, moduleName, directory, state, cache, redirectedReference) {
        var _a, _b;
        const directoryPath = getNormalizedAbsolutePath(directory, (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
        const scope = getPackageScopeForPath(directoryPath, state);
        if (!scope || !scope.contents.packageJsonContent.exports) return void 0;
        if (typeof scope.contents.packageJsonContent.name !== "string") return void 0;
        const parts = getPathComponents(moduleName);
        const nameParts = getPathComponents(scope.contents.packageJsonContent.name);
        if (!every(nameParts, (p, i)=>parts[i] === p)) return void 0;
        const trailingParts = parts.slice(nameParts.length);
        const subpath = !length(trailingParts) ? "." : `.${directorySeparator}${trailingParts.join(directorySeparator)}`;
        if (getAllowJSCompilerOption(state.compilerOptions) && !pathContainsNodeModules(directory)) return loadModuleFromExports(scope, extensions, subpath, state, cache, redirectedReference);
        const priorityExtensions = extensions & 5 /* Declaration */ ;
        const secondaryExtensions = extensions & -6;
        return loadModuleFromExports(scope, priorityExtensions, subpath, state, cache, redirectedReference) || loadModuleFromExports(scope, secondaryExtensions, subpath, state, cache, redirectedReference);
    }
    function loadModuleFromExports(scope, extensions, subpath, state, cache, redirectedReference) {
        if (!scope.contents.packageJsonContent.exports) return void 0;
        if (subpath === ".") {
            let mainExport;
            if (typeof scope.contents.packageJsonContent.exports === "string" || Array.isArray(scope.contents.packageJsonContent.exports) || typeof scope.contents.packageJsonContent.exports === "object" && noKeyStartsWithDot(scope.contents.packageJsonContent.exports)) mainExport = scope.contents.packageJsonContent.exports;
            else if (hasProperty(scope.contents.packageJsonContent.exports, ".")) mainExport = scope.contents.packageJsonContent.exports["."];
            if (mainExport) {
                const loadModuleFromTargetExportOrImport = getLoadModuleFromTargetExportOrImport(extensions, state, cache, redirectedReference, subpath, scope, /*isImports*/ false);
                return loadModuleFromTargetExportOrImport(mainExport, "", /*pattern*/ false, ".");
            }
        } else if (allKeysStartWithDot(scope.contents.packageJsonContent.exports)) {
            if (typeof scope.contents.packageJsonContent.exports !== "object") {
                if (state.traceEnabled) trace(state.host, Diagnostics.Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1, subpath, scope.packageDirectory);
                return toSearchResult(/*value*/ void 0);
            }
            const result = loadModuleFromExportsOrImports(extensions, state, cache, redirectedReference, subpath, scope.contents.packageJsonContent.exports, scope, /*isImports*/ false);
            if (result) return result;
        }
        if (state.traceEnabled) trace(state.host, Diagnostics.Export_specifier_0_does_not_exist_in_package_json_scope_at_path_1, subpath, scope.packageDirectory);
        return toSearchResult(/*value*/ void 0);
    }
    function loadModuleFromImports(extensions, moduleName, directory, state, cache, redirectedReference) {
        var _a, _b;
        if (moduleName === "#" || startsWith(moduleName, "#/")) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Invalid_import_specifier_0_has_no_possible_resolutions, moduleName);
            return toSearchResult(/*value*/ void 0);
        }
        const directoryPath = getNormalizedAbsolutePath(directory, (_b = (_a = state.host).getCurrentDirectory) == null ? void 0 : _b.call(_a));
        const scope = getPackageScopeForPath(directoryPath, state);
        if (!scope) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_has_no_containing_package_json_scope_Imports_will_not_resolve, directoryPath);
            return toSearchResult(/*value*/ void 0);
        }
        if (!scope.contents.packageJsonContent.imports) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_no_imports_defined, scope.packageDirectory);
            return toSearchResult(/*value*/ void 0);
        }
        const result = loadModuleFromExportsOrImports(extensions, state, cache, redirectedReference, moduleName, scope.contents.packageJsonContent.imports, scope, /*isImports*/ true);
        if (result) return result;
        if (state.traceEnabled) trace(state.host, Diagnostics.Import_specifier_0_does_not_exist_in_package_json_scope_at_path_1, moduleName, scope.packageDirectory);
        return toSearchResult(/*value*/ void 0);
    }
    function comparePatternKeys(a, b) {
        const aPatternIndex = a.indexOf("*");
        const bPatternIndex = b.indexOf("*");
        const baseLenA = aPatternIndex === -1 ? a.length : aPatternIndex + 1;
        const baseLenB = bPatternIndex === -1 ? b.length : bPatternIndex + 1;
        if (baseLenA > baseLenB) return -1 /* LessThan */ ;
        if (baseLenB > baseLenA) return 1 /* GreaterThan */ ;
        if (aPatternIndex === -1) return 1 /* GreaterThan */ ;
        if (bPatternIndex === -1) return -1 /* LessThan */ ;
        if (a.length > b.length) return -1 /* LessThan */ ;
        if (b.length > a.length) return 1 /* GreaterThan */ ;
        return 0 /* EqualTo */ ;
    }
    function loadModuleFromExportsOrImports(extensions, state, cache, redirectedReference, moduleName, lookupTable, scope, isImports) {
        const loadModuleFromTargetExportOrImport = getLoadModuleFromTargetExportOrImport(extensions, state, cache, redirectedReference, moduleName, scope, isImports);
        if (!endsWith(moduleName, directorySeparator) && !moduleName.includes("*") && hasProperty(lookupTable, moduleName)) {
            const target = lookupTable[moduleName];
            return loadModuleFromTargetExportOrImport(target, /*subpath*/ "", /*pattern*/ false, moduleName);
        }
        const expandingKeys = toSorted(filter(getOwnKeys(lookupTable), (k)=>hasOneAsterisk(k) || endsWith(k, "/")), comparePatternKeys);
        for (const potentialTarget of expandingKeys){
            if (state.features & 16 /* ExportsPatternTrailers */  && matchesPatternWithTrailer(potentialTarget, moduleName)) {
                const target = lookupTable[potentialTarget];
                const starPos = potentialTarget.indexOf("*");
                const subpath = moduleName.substring(potentialTarget.substring(0, starPos).length, moduleName.length - (potentialTarget.length - 1 - starPos));
                return loadModuleFromTargetExportOrImport(target, subpath, /*pattern*/ true, potentialTarget);
            } else if (endsWith(potentialTarget, "*") && startsWith(moduleName, potentialTarget.substring(0, potentialTarget.length - 1))) {
                const target = lookupTable[potentialTarget];
                const subpath = moduleName.substring(potentialTarget.length - 1);
                return loadModuleFromTargetExportOrImport(target, subpath, /*pattern*/ true, potentialTarget);
            } else if (startsWith(moduleName, potentialTarget)) {
                const target = lookupTable[potentialTarget];
                const subpath = moduleName.substring(potentialTarget.length);
                return loadModuleFromTargetExportOrImport(target, subpath, /*pattern*/ false, potentialTarget);
            }
        }
        function matchesPatternWithTrailer(target, name) {
            if (endsWith(target, "*")) return false;
            const starPos = target.indexOf("*");
            if (starPos === -1) return false;
            return startsWith(name, target.substring(0, starPos)) && endsWith(name, target.substring(starPos + 1));
        }
    }
    function hasOneAsterisk(patternKey) {
        const firstStar = patternKey.indexOf("*");
        return firstStar !== -1 && firstStar === patternKey.lastIndexOf("*");
    }
    function getLoadModuleFromTargetExportOrImport(extensions, state, cache, redirectedReference, moduleName, scope, isImports) {
        return loadModuleFromTargetExportOrImport;
        function loadModuleFromTargetExportOrImport(target, subpath, pattern, key) {
            var _a, _b;
            if (typeof target === "string") {
                if (!pattern && subpath.length > 0 && !endsWith(target, "/")) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                if (!startsWith(target, "./")) {
                    if (isImports && !startsWith(target, "../") && !startsWith(target, "/") && !isRootedDiskPath(target)) {
                        const combinedLookup = pattern ? target.replace(/\*/g, subpath) : target + subpath;
                        traceIfEnabled(state, Diagnostics.Using_0_subpath_1_with_target_2, "imports", key, combinedLookup);
                        traceIfEnabled(state, Diagnostics.Resolving_module_0_from_1, combinedLookup, scope.packageDirectory + "/");
                        const result = nodeModuleNameResolverWorker(state.features, combinedLookup, scope.packageDirectory + "/", state.compilerOptions, state.host, cache, extensions, /*isConfigLookup*/ false, redirectedReference, state.conditions);
                        var _result_failedLookupLocations;
                        (_a = state.failedLookupLocations) == null || _a.push(...(_result_failedLookupLocations = result.failedLookupLocations) !== null && _result_failedLookupLocations !== void 0 ? _result_failedLookupLocations : emptyArray);
                        var _result_affectingLocations;
                        (_b = state.affectingLocations) == null || _b.push(...(_result_affectingLocations = result.affectingLocations) !== null && _result_affectingLocations !== void 0 ? _result_affectingLocations : emptyArray);
                        return toSearchResult(result.resolvedModule ? {
                            path: result.resolvedModule.resolvedFileName,
                            extension: result.resolvedModule.extension,
                            packageId: result.resolvedModule.packageId,
                            originalPath: result.resolvedModule.originalPath,
                            resolvedUsingTsExtension: result.resolvedModule.resolvedUsingTsExtension
                        } : void 0);
                    }
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                const parts = pathIsRelative(target) ? getPathComponents(target).slice(1) : getPathComponents(target);
                const partsAfterFirst = parts.slice(1);
                if (partsAfterFirst.includes("..") || partsAfterFirst.includes(".") || partsAfterFirst.includes("node_modules")) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                const resolvedTarget = combinePaths(scope.packageDirectory, target);
                const subpathParts = getPathComponents(subpath);
                if (subpathParts.includes("..") || subpathParts.includes(".") || subpathParts.includes("node_modules")) {
                    if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                    return toSearchResult(/*value*/ void 0);
                }
                if (state.traceEnabled) trace(state.host, Diagnostics.Using_0_subpath_1_with_target_2, isImports ? "imports" : "exports", key, pattern ? target.replace(/\*/g, subpath) : target + subpath);
                const finalPath = toAbsolutePath(pattern ? resolvedTarget.replace(/\*/g, subpath) : resolvedTarget + subpath);
                const inputLink = tryLoadInputFileForPath(finalPath, subpath, combinePaths(scope.packageDirectory, "package.json"), isImports);
                if (inputLink) return inputLink;
                return toSearchResult(withPackageId(scope, loadFileNameFromPackageJsonField(extensions, finalPath, target, /*onlyRecordFailures*/ false, state), state));
            } else if (typeof target === "object" && target !== null) {
                if (!Array.isArray(target)) {
                    traceIfEnabled(state, Diagnostics.Entering_conditional_exports);
                    for (const condition of getOwnKeys(target))if (condition === "default" || state.conditions.includes(condition) || isApplicableVersionedTypesKey(state.conditions, condition)) {
                        traceIfEnabled(state, Diagnostics.Matched_0_condition_1, isImports ? "imports" : "exports", condition);
                        const subTarget = target[condition];
                        const result = loadModuleFromTargetExportOrImport(subTarget, subpath, pattern, key);
                        if (result) {
                            traceIfEnabled(state, Diagnostics.Resolved_under_condition_0, condition);
                            traceIfEnabled(state, Diagnostics.Exiting_conditional_exports);
                            return result;
                        } else traceIfEnabled(state, Diagnostics.Failed_to_resolve_under_condition_0, condition);
                    } else traceIfEnabled(state, Diagnostics.Saw_non_matching_condition_0, condition);
                    traceIfEnabled(state, Diagnostics.Exiting_conditional_exports);
                    return void 0;
                } else {
                    if (!length(target)) {
                        if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
                        return toSearchResult(/*value*/ void 0);
                    }
                    for (const elem of target){
                        const result = loadModuleFromTargetExportOrImport(elem, subpath, pattern, key);
                        if (result) return result;
                    }
                }
            } else if (target === null) {
                if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_explicitly_maps_specifier_1_to_null, scope.packageDirectory, moduleName);
                return toSearchResult(/*value*/ void 0);
            }
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_scope_0_has_invalid_type_for_target_of_specifier_1, scope.packageDirectory, moduleName);
            return toSearchResult(/*value*/ void 0);
            function toAbsolutePath(path) {
                var _a2, _b2;
                if (path === void 0) return path;
                return getNormalizedAbsolutePath(path, (_b2 = (_a2 = state.host).getCurrentDirectory) == null ? void 0 : _b2.call(_a2));
            }
            function combineDirectoryPath(root, dir) {
                return ensureTrailingDirectorySeparator(combinePaths(root, dir));
            }
            function tryLoadInputFileForPath(finalPath, entry, packagePath, isImports2) {
                var _a2, _b2, _c, _d;
                if (!state.isConfigLookup && (state.compilerOptions.declarationDir || state.compilerOptions.outDir) && !finalPath.includes("/node_modules/") && (state.compilerOptions.configFile ? containsPath(scope.packageDirectory, toAbsolutePath(state.compilerOptions.configFile.fileName), !useCaseSensitiveFileNames(state)) : true)) {
                    const getCanonicalFileName = hostGetCanonicalFileName({
                        useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames(state)
                    });
                    const commonSourceDirGuesses = [];
                    if (state.compilerOptions.rootDir || state.compilerOptions.composite && state.compilerOptions.configFilePath) {
                        const commonDir = toAbsolutePath(getCommonSourceDirectory(state.compilerOptions, ()=>[], ((_b2 = (_a2 = state.host).getCurrentDirectory) == null ? void 0 : _b2.call(_a2)) || "", getCanonicalFileName));
                        commonSourceDirGuesses.push(commonDir);
                    } else if (state.requestContainingDirectory) {
                        const requestingFile = toAbsolutePath(combinePaths(state.requestContainingDirectory, "index.ts"));
                        const commonDir = toAbsolutePath(getCommonSourceDirectory(state.compilerOptions, ()=>[
                                requestingFile,
                                toAbsolutePath(packagePath)
                            ], ((_d = (_c = state.host).getCurrentDirectory) == null ? void 0 : _d.call(_c)) || "", getCanonicalFileName));
                        commonSourceDirGuesses.push(commonDir);
                        let fragment = ensureTrailingDirectorySeparator(commonDir);
                        while(fragment && fragment.length > 1){
                            const parts = getPathComponents(fragment);
                            parts.pop();
                            const commonDir2 = getPathFromPathComponents(parts);
                            commonSourceDirGuesses.unshift(commonDir2);
                            fragment = ensureTrailingDirectorySeparator(commonDir2);
                        }
                    }
                    if (commonSourceDirGuesses.length > 1) state.reportDiagnostic(createCompilerDiagnostic(isImports2 ? Diagnostics.The_project_root_is_ambiguous_but_is_required_to_resolve_import_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate : Diagnostics.The_project_root_is_ambiguous_but_is_required_to_resolve_export_map_entry_0_in_file_1_Supply_the_rootDir_compiler_option_to_disambiguate, entry === "" ? "." : entry, // replace empty string with `.` - the reverse of the operation done when entries are built - so main entrypoint errors don't look weird
                    packagePath));
                    for (const commonSourceDirGuess of commonSourceDirGuesses){
                        const candidateDirectories = getOutputDirectoriesForBaseDirectory(commonSourceDirGuess);
                        for (const candidateDir of candidateDirectories)if (containsPath(candidateDir, finalPath, !useCaseSensitiveFileNames(state))) {
                            const pathFragment = finalPath.slice(candidateDir.length + 1);
                            const possibleInputBase = combinePaths(commonSourceDirGuess, pathFragment);
                            const jsAndDtsExtensions = [
                                ".mjs" /* Mjs */ ,
                                ".cjs" /* Cjs */ ,
                                ".js" /* Js */ ,
                                ".json" /* Json */ ,
                                ".d.mts" /* Dmts */ ,
                                ".d.cts" /* Dcts */ ,
                                ".d.ts" /* Dts */ 
                            ];
                            for (const ext of jsAndDtsExtensions)if (fileExtensionIs(possibleInputBase, ext)) {
                                const inputExts = getPossibleOriginalInputExtensionForExtension(possibleInputBase);
                                for (const possibleExt of inputExts){
                                    if (!extensionIsOk(extensions, possibleExt)) continue;
                                    const possibleInputWithInputExtension = changeAnyExtension(possibleInputBase, possibleExt, ext, !useCaseSensitiveFileNames(state));
                                    if (state.host.fileExists(possibleInputWithInputExtension)) return toSearchResult(withPackageId(scope, loadFileNameFromPackageJsonField(extensions, possibleInputWithInputExtension, /*packageJsonValue*/ void 0, /*onlyRecordFailures*/ false, state), state));
                                }
                            }
                        }
                    }
                }
                return void 0;
                function getOutputDirectoriesForBaseDirectory(commonSourceDirGuess) {
                    var _a3, _b3;
                    const currentDir = state.compilerOptions.configFile ? ((_b3 = (_a3 = state.host).getCurrentDirectory) == null ? void 0 : _b3.call(_a3)) || "" : commonSourceDirGuess;
                    const candidateDirectories = [];
                    if (state.compilerOptions.declarationDir) candidateDirectories.push(toAbsolutePath(combineDirectoryPath(currentDir, state.compilerOptions.declarationDir)));
                    if (state.compilerOptions.outDir && state.compilerOptions.outDir !== state.compilerOptions.declarationDir) candidateDirectories.push(toAbsolutePath(combineDirectoryPath(currentDir, state.compilerOptions.outDir)));
                    return candidateDirectories;
                }
            }
        }
    }
    function isApplicableVersionedTypesKey(conditions, key) {
        if (!conditions.includes("types")) return false;
        if (!startsWith(key, "types@")) return false;
        const range = VersionRange.tryParse(key.substring(6));
        if (!range) return false;
        return range.test(version);
    }
    function loadModuleFromNearestNodeModulesDirectory(extensions, moduleName, directory, state, cache, redirectedReference) {
        return loadModuleFromNearestNodeModulesDirectoryWorker(extensions, moduleName, directory, state, /*typesScopeOnly*/ false, cache, redirectedReference);
    }
    function loadModuleFromNearestNodeModulesDirectoryTypesScope(moduleName, directory, state) {
        return loadModuleFromNearestNodeModulesDirectoryWorker(4 /* Declaration */ , moduleName, directory, state, /*typesScopeOnly*/ true, /*cache*/ void 0, /*redirectedReference*/ void 0);
    }
    function loadModuleFromNearestNodeModulesDirectoryWorker(extensions, moduleName, directory, state, typesScopeOnly, cache, redirectedReference) {
        const mode = state.features === 0 ? void 0 : state.features & 32 /* EsmMode */  || state.conditions.includes("import") ? 99 /* ESNext */  : 1 /* CommonJS */ ;
        const priorityExtensions = extensions & 5 /* Declaration */ ;
        const secondaryExtensions = extensions & -6;
        if (priorityExtensions) {
            traceIfEnabled(state, Diagnostics.Searching_all_ancestor_node_modules_directories_for_preferred_extensions_Colon_0, formatExtensions(priorityExtensions));
            const result = lookup(priorityExtensions);
            if (result) return result;
        }
        if (secondaryExtensions && !typesScopeOnly) {
            traceIfEnabled(state, Diagnostics.Searching_all_ancestor_node_modules_directories_for_fallback_extensions_Colon_0, formatExtensions(secondaryExtensions));
            return lookup(secondaryExtensions);
        }
        function lookup(extensions2) {
            return forEachAncestorDirectoryStoppingAtGlobalCache(state.host, normalizeSlashes(directory), (ancestorDirectory)=>{
                if (getBaseFileName(ancestorDirectory) !== "node_modules") {
                    const resolutionFromCache = tryFindNonRelativeModuleNameInCache(cache, moduleName, mode, ancestorDirectory, redirectedReference, state);
                    if (resolutionFromCache) return resolutionFromCache;
                    return toSearchResult(loadModuleFromImmediateNodeModulesDirectory(extensions2, moduleName, ancestorDirectory, state, typesScopeOnly, cache, redirectedReference));
                }
            });
        }
    }
    function forEachAncestorDirectoryStoppingAtGlobalCache(host, directory, callback) {
        var _a;
        const globalCache = (_a = host == null ? void 0 : host.getGlobalTypingsCacheLocation) == null ? void 0 : _a.call(host);
        return forEachAncestorDirectory(directory, (ancestorDirectory)=>{
            const result = callback(ancestorDirectory);
            if (result !== void 0) return result;
            if (ancestorDirectory === globalCache) return false;
        }) || void 0;
    }
    function loadModuleFromImmediateNodeModulesDirectory(extensions, moduleName, directory, state, typesScopeOnly, cache, redirectedReference) {
        const nodeModulesFolder = combinePaths(directory, "node_modules");
        const nodeModulesFolderExists = directoryProbablyExists(nodeModulesFolder, state.host);
        if (!nodeModulesFolderExists && state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesFolder);
        if (!typesScopeOnly) {
            const packageResult = loadModuleFromSpecificNodeModulesDirectory(extensions, moduleName, nodeModulesFolder, nodeModulesFolderExists, state, cache, redirectedReference);
            if (packageResult) return packageResult;
        }
        if (extensions & 4 /* Declaration */ ) {
            const nodeModulesAtTypes2 = combinePaths(nodeModulesFolder, "@types");
            let nodeModulesAtTypesExists = nodeModulesFolderExists;
            if (nodeModulesFolderExists && !directoryProbablyExists(nodeModulesAtTypes2, state.host)) {
                if (state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesAtTypes2);
                nodeModulesAtTypesExists = false;
            }
            return loadModuleFromSpecificNodeModulesDirectory(4 /* Declaration */ , mangleScopedPackageNameWithTrace(moduleName, state), nodeModulesAtTypes2, nodeModulesAtTypesExists, state, cache, redirectedReference);
        }
    }
    function loadModuleFromSpecificNodeModulesDirectory(extensions, moduleName, nodeModulesDirectory, nodeModulesDirectoryExists, state, cache, redirectedReference) {
        var _a, _b;
        const candidate = normalizePath(combinePaths(nodeModulesDirectory, moduleName));
        const { packageName, rest } = parsePackageName(moduleName);
        const packageDirectory = combinePaths(nodeModulesDirectory, packageName);
        let rootPackageInfo;
        let packageInfo = getPackageJsonInfo(candidate, !nodeModulesDirectoryExists, state);
        var _ref;
        if (rest !== "" && packageInfo && (!(state.features & 8 /* Exports */ ) || !hasProperty((_ref = (_a = rootPackageInfo = getPackageJsonInfo(packageDirectory, !nodeModulesDirectoryExists, state)) == null ? void 0 : _a.contents.packageJsonContent) !== null && _ref !== void 0 ? _ref : emptyArray, "exports"))) {
            const fromFile = loadModuleFromFile(extensions, candidate, !nodeModulesDirectoryExists, state);
            if (fromFile) return noPackageId(fromFile);
            const fromDirectory = loadNodeModuleFromDirectoryWorker(extensions, candidate, !nodeModulesDirectoryExists, state, packageInfo);
            return withPackageId(packageInfo, fromDirectory, state);
        }
        const loader = (extensions2, candidate2, onlyRecordFailures, state2)=>{
            let pathAndExtension = (rest || !(state2.features & 32 /* EsmMode */ )) && loadModuleFromFile(extensions2, candidate2, onlyRecordFailures, state2) || loadNodeModuleFromDirectoryWorker(extensions2, candidate2, onlyRecordFailures, state2, packageInfo);
            if (!pathAndExtension && !rest && packageInfo && (packageInfo.contents.packageJsonContent.exports === void 0 || packageInfo.contents.packageJsonContent.exports === null) && state2.features & 32 /* EsmMode */ ) pathAndExtension = loadModuleFromFile(extensions2, combinePaths(candidate2, "index.js"), onlyRecordFailures, state2);
            return withPackageId(packageInfo, pathAndExtension, state2);
        };
        if (rest !== "") packageInfo = rootPackageInfo !== null && rootPackageInfo !== void 0 ? rootPackageInfo : getPackageJsonInfo(packageDirectory, !nodeModulesDirectoryExists, state);
        if (packageInfo) state.resolvedPackageDirectory = true;
        if (packageInfo && packageInfo.contents.packageJsonContent.exports && state.features & 8 /* Exports */ ) return (_b = loadModuleFromExports(packageInfo, extensions, combinePaths(".", rest), state, cache, redirectedReference)) == null ? void 0 : _b.value;
        const versionPaths = rest !== "" && packageInfo ? getVersionPathsOfPackageJsonInfo(packageInfo, state) : void 0;
        if (versionPaths) {
            if (state.traceEnabled) trace(state.host, Diagnostics.package_json_has_a_typesVersions_entry_0_that_matches_compiler_version_1_looking_for_a_pattern_to_match_module_name_2, versionPaths.version, version, rest);
            const packageDirectoryExists = nodeModulesDirectoryExists && directoryProbablyExists(packageDirectory, state.host);
            const pathPatterns = tryParsePatterns(versionPaths.paths);
            const fromPaths = tryLoadModuleUsingPaths(extensions, rest, packageDirectory, versionPaths.paths, pathPatterns, loader, !packageDirectoryExists, state);
            if (fromPaths) return fromPaths.value;
        }
        return loader(extensions, candidate, !nodeModulesDirectoryExists, state);
    }
    function tryLoadModuleUsingPaths(extensions, moduleName, baseDirectory, paths, pathPatterns, loader, onlyRecordFailures, state) {
        const matchedPattern = matchPatternOrExact(pathPatterns, moduleName);
        if (matchedPattern) {
            const matchedStar = isString(matchedPattern) ? void 0 : matchedText(matchedPattern, moduleName);
            const matchedPatternText = isString(matchedPattern) ? matchedPattern : patternText(matchedPattern);
            if (state.traceEnabled) trace(state.host, Diagnostics.Module_name_0_matched_pattern_1, moduleName, matchedPatternText);
            const resolved = forEach(paths[matchedPatternText], (subst)=>{
                const path = matchedStar ? replaceFirstStar(subst, matchedStar) : subst;
                const candidate = normalizePath(combinePaths(baseDirectory, path));
                if (state.traceEnabled) trace(state.host, Diagnostics.Trying_substitution_0_candidate_module_location_Colon_1, subst, path);
                const extension = tryGetExtensionFromPath2(subst);
                if (extension !== void 0) {
                    const path2 = tryFile(candidate, onlyRecordFailures, state);
                    if (path2 !== void 0) return noPackageId({
                        path: path2,
                        ext: extension,
                        resolvedUsingTsExtension: void 0
                    });
                }
                return loader(extensions, candidate, onlyRecordFailures || !directoryProbablyExists(getDirectoryPath(candidate), state.host), state);
            });
            return {
                value: resolved
            };
        }
    }
    var mangledScopedPackageSeparator = "__";
    function mangleScopedPackageNameWithTrace(packageName, state) {
        const mangled = mangleScopedPackageName(packageName);
        if (state.traceEnabled && mangled !== packageName) trace(state.host, Diagnostics.Scoped_package_detected_looking_in_0, mangled);
        return mangled;
    }
    function getTypesPackageName(packageName) {
        return `@types/${mangleScopedPackageName(packageName)}`;
    }
    function mangleScopedPackageName(packageName) {
        if (startsWith(packageName, "@")) {
            const replaceSlash = packageName.replace(directorySeparator, mangledScopedPackageSeparator);
            if (replaceSlash !== packageName) return replaceSlash.slice(1);
        }
        return packageName;
    }
    function getPackageNameFromTypesPackageName(mangledName) {
        const withoutAtTypePrefix = removePrefix(mangledName, "@types/");
        if (withoutAtTypePrefix !== mangledName) return unmangleScopedPackageName(withoutAtTypePrefix);
        return mangledName;
    }
    function unmangleScopedPackageName(typesPackageName) {
        return typesPackageName.includes(mangledScopedPackageSeparator) ? "@" + typesPackageName.replace(mangledScopedPackageSeparator, directorySeparator) : typesPackageName;
    }
    function tryFindNonRelativeModuleNameInCache(cache, moduleName, mode, containingDirectory, redirectedReference, state) {
        const result = cache && cache.getFromNonRelativeNameCache(moduleName, mode, containingDirectory, redirectedReference);
        if (result) {
            if (state.traceEnabled) trace(state.host, Diagnostics.Resolution_for_module_0_was_found_in_cache_from_location_1, moduleName, containingDirectory);
            state.resultFromCache = result;
            return {
                value: result.resolvedModule && {
                    path: result.resolvedModule.resolvedFileName,
                    originalPath: result.resolvedModule.originalPath || true,
                    extension: result.resolvedModule.extension,
                    packageId: result.resolvedModule.packageId,
                    resolvedUsingTsExtension: result.resolvedModule.resolvedUsingTsExtension
                }
            };
        }
    }
    function classicNameResolver(moduleName, containingFile, compilerOptions, host, cache, redirectedReference) {
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        const failedLookupLocations = [];
        const affectingLocations = [];
        const containingDirectory = getDirectoryPath(containingFile);
        const diagnostics = [];
        const state = {
            compilerOptions,
            host,
            traceEnabled,
            failedLookupLocations,
            affectingLocations,
            packageJsonInfoCache: cache,
            features: 0 /* None */ ,
            conditions: [],
            requestContainingDirectory: containingDirectory,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false,
            resolvedPackageDirectory: false
        };
        const resolved = tryResolve(5 /* Declaration */ ) || tryResolve(2 /* JavaScript */  | (compilerOptions.resolveJsonModule ? 8 /* Json */  : 0));
        return createResolvedModuleWithFailedLookupLocationsHandlingSymlink(moduleName, resolved && resolved.value, (resolved == null ? void 0 : resolved.value) && pathContainsNodeModules(resolved.value.path), failedLookupLocations, affectingLocations, diagnostics, state, cache);
        function tryResolve(extensions) {
            const resolvedUsingSettings = tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loadModuleFromFileNoPackageId, state);
            if (resolvedUsingSettings) return {
                value: resolvedUsingSettings
            };
            if (!isExternalModuleNameRelative(moduleName)) {
                const resolved2 = forEachAncestorDirectoryStoppingAtGlobalCache(state.host, containingDirectory, (directory)=>{
                    const resolutionFromCache = tryFindNonRelativeModuleNameInCache(cache, moduleName, /*mode*/ void 0, directory, redirectedReference, state);
                    if (resolutionFromCache) return resolutionFromCache;
                    const searchName = normalizePath(combinePaths(directory, moduleName));
                    return toSearchResult(loadModuleFromFileNoPackageId(extensions, searchName, /*onlyRecordFailures*/ false, state));
                });
                if (resolved2) return resolved2;
                if (extensions & 5 /* Declaration */ ) {
                    let resolved3 = loadModuleFromNearestNodeModulesDirectoryTypesScope(moduleName, containingDirectory, state);
                    if (extensions & 4 /* Declaration */ ) resolved3 !== null && resolved3 !== void 0 ? resolved3 : resolved3 = resolveFromTypeRoot(moduleName, state);
                    return resolved3;
                }
            } else {
                const candidate = normalizePath(combinePaths(containingDirectory, moduleName));
                return toSearchResult(loadModuleFromFileNoPackageId(extensions, candidate, /*onlyRecordFailures*/ false, state));
            }
        }
    }
    function resolveFromTypeRoot(moduleName, state) {
        if (!state.compilerOptions.typeRoots) return;
        for (const typeRoot of state.compilerOptions.typeRoots){
            const candidate = getCandidateFromTypeRoot(typeRoot, moduleName, state);
            const directoryExists = directoryProbablyExists(typeRoot, state.host);
            if (!directoryExists && state.traceEnabled) trace(state.host, Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, typeRoot);
            const resolvedFromFile = loadModuleFromFile(4 /* Declaration */ , candidate, !directoryExists, state);
            if (resolvedFromFile) {
                const packageDirectory = parseNodeModuleFromPath(resolvedFromFile.path);
                const packageInfo = packageDirectory ? getPackageJsonInfo(packageDirectory, /*onlyRecordFailures*/ false, state) : void 0;
                return toSearchResult(withPackageId(packageInfo, resolvedFromFile, state));
            }
            const resolved = loadNodeModuleFromDirectory(4 /* Declaration */ , candidate, !directoryExists, state);
            if (resolved) return toSearchResult(resolved);
        }
    }
    function shouldAllowImportingTsExtension(compilerOptions, fromFileName) {
        return getAllowImportingTsExtensions(compilerOptions) || !!fromFileName && isDeclarationFileName(fromFileName);
    }
    function loadModuleFromGlobalCache(moduleName, projectName, compilerOptions, host, globalCache, packageJsonInfoCache) {
        const traceEnabled = isTraceEnabled(compilerOptions, host);
        if (traceEnabled) trace(host, Diagnostics.Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2, projectName, moduleName, globalCache);
        const failedLookupLocations = [];
        const affectingLocations = [];
        const diagnostics = [];
        const state = {
            compilerOptions,
            host,
            traceEnabled,
            failedLookupLocations,
            affectingLocations,
            packageJsonInfoCache,
            features: 0 /* None */ ,
            conditions: [],
            requestContainingDirectory: void 0,
            reportDiagnostic: (diag2)=>void diagnostics.push(diag2),
            isConfigLookup: false,
            candidateIsFromPackageJsonField: false,
            resolvedPackageDirectory: false
        };
        const resolved = loadModuleFromImmediateNodeModulesDirectory(4 /* Declaration */ , moduleName, globalCache, state, /*typesScopeOnly*/ false, /*cache*/ void 0, /*redirectedReference*/ void 0);
        return createResolvedModuleWithFailedLookupLocations(resolved, /*isExternalLibraryImport*/ true, failedLookupLocations, affectingLocations, diagnostics, state.resultFromCache, /*cache*/ void 0);
    }
    function toSearchResult(value1) {
        return value1 !== void 0 ? {
            value: value1
        } : void 0;
    }
    function traceIfEnabled(state, diagnostic, ...args) {
        if (state.traceEnabled) trace(state.host, diagnostic, ...args);
    }
    function useCaseSensitiveFileNames(state) {
        return !state.host.useCaseSensitiveFileNames ? true : typeof state.host.useCaseSensitiveFileNames === "boolean" ? state.host.useCaseSensitiveFileNames : state.host.useCaseSensitiveFileNames();
    }
    // src/compiler/binder.ts
    var ModuleInstanceState = /* @__PURE__ */ ((ModuleInstanceState2)=>{
        ModuleInstanceState2[ModuleInstanceState2["NonInstantiated"] = 0] = "NonInstantiated";
        ModuleInstanceState2[ModuleInstanceState2["Instantiated"] = 1] = "Instantiated";
        ModuleInstanceState2[ModuleInstanceState2["ConstEnumOnly"] = 2] = "ConstEnumOnly";
        return ModuleInstanceState2;
    })(ModuleInstanceState || {});
    function getModuleInstanceState(node, visited) {
        if (node.body && !node.body.parent) {
            setParent(node.body, node);
            setParentRecursive(node.body, /*incremental*/ false);
        }
        return node.body ? getModuleInstanceStateCached(node.body, visited) : 1 /* Instantiated */ ;
    }
    function getModuleInstanceStateCached(node, visited = /* @__PURE__ */ new Map()) {
        const nodeId = getNodeId(node);
        if (visited.has(nodeId)) return visited.get(nodeId) || 0 /* NonInstantiated */ ;
        visited.set(nodeId, void 0);
        const result = getModuleInstanceStateWorker(node, visited);
        visited.set(nodeId, result);
        return result;
    }
    function getModuleInstanceStateWorker(node, visited) {
        switch(node.kind){
            // 1. interface declarations, type alias declarations
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
                return 0 /* NonInstantiated */ ;
            // 2. const enum declarations
            case 267 /* EnumDeclaration */ :
                if (isEnumConst(node)) return 2 /* ConstEnumOnly */ ;
                break;
            // 3. non-exported import declarations
            case 273 /* ImportDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
                if (!hasSyntacticModifier(node, 32 /* Export */ )) return 0 /* NonInstantiated */ ;
                break;
            // 4. Export alias declarations pointing at only uninstantiated modules or things uninstantiated modules contain
            case 279 /* ExportDeclaration */ :
                const exportDeclaration = node;
                if (!exportDeclaration.moduleSpecifier && exportDeclaration.exportClause && exportDeclaration.exportClause.kind === 280 /* NamedExports */ ) {
                    let state = 0 /* NonInstantiated */ ;
                    for (const specifier of exportDeclaration.exportClause.elements){
                        const specifierState = getModuleInstanceStateForAliasTarget(specifier, visited);
                        if (specifierState > state) state = specifierState;
                        if (state === 1 /* Instantiated */ ) return state;
                    }
                    return state;
                }
                break;
            // 5. other uninstantiated module declarations.
            case 269 /* ModuleBlock */ :
                {
                    let state = 0 /* NonInstantiated */ ;
                    forEachChild(node, (n)=>{
                        const childState = getModuleInstanceStateCached(n, visited);
                        switch(childState){
                            case 0 /* NonInstantiated */ :
                                return;
                            case 2 /* ConstEnumOnly */ :
                                state = 2 /* ConstEnumOnly */ ;
                                return;
                            case 1 /* Instantiated */ :
                                state = 1 /* Instantiated */ ;
                                return true;
                            default:
                                Debug.assertNever(childState);
                        }
                    });
                    return state;
                }
            case 268 /* ModuleDeclaration */ :
                return getModuleInstanceState(node, visited);
            case 80 /* Identifier */ :
                if (node.flags & 4096 /* IdentifierIsInJSDocNamespace */ ) return 0 /* NonInstantiated */ ;
        }
        return 1 /* Instantiated */ ;
    }
    function getModuleInstanceStateForAliasTarget(specifier, visited) {
        const name = specifier.propertyName || specifier.name;
        if (name.kind !== 80 /* Identifier */ ) return 1 /* Instantiated */ ;
        let p = specifier.parent;
        while(p){
            if (isBlock(p) || isModuleBlock(p) || isSourceFile(p)) {
                const statements = p.statements;
                let found;
                for (const statement of statements)if (nodeHasName(statement, name)) {
                    if (!statement.parent) {
                        setParent(statement, p);
                        setParentRecursive(statement, /*incremental*/ false);
                    }
                    const state = getModuleInstanceStateCached(statement, visited);
                    if (found === void 0 || state > found) found = state;
                    if (found === 1 /* Instantiated */ ) return found;
                    if (statement.kind === 272 /* ImportEqualsDeclaration */ ) found = 1 /* Instantiated */ ;
                }
                if (found !== void 0) return found;
            }
            p = p.parent;
        }
        return 1 /* Instantiated */ ;
    }
    var ContainerFlags = /* @__PURE__ */ ((ContainerFlags2)=>{
        ContainerFlags2[ContainerFlags2["None"] = 0] = "None";
        ContainerFlags2[ContainerFlags2["IsContainer"] = 1] = "IsContainer";
        ContainerFlags2[ContainerFlags2["IsBlockScopedContainer"] = 2] = "IsBlockScopedContainer";
        ContainerFlags2[ContainerFlags2["IsControlFlowContainer"] = 4] = "IsControlFlowContainer";
        ContainerFlags2[ContainerFlags2["IsFunctionLike"] = 8] = "IsFunctionLike";
        ContainerFlags2[ContainerFlags2["IsFunctionExpression"] = 16] = "IsFunctionExpression";
        ContainerFlags2[ContainerFlags2["HasLocals"] = 32] = "HasLocals";
        ContainerFlags2[ContainerFlags2["IsInterface"] = 64] = "IsInterface";
        ContainerFlags2[ContainerFlags2["IsObjectLiteralOrClassExpressionMethodOrAccessor"] = 128] = "IsObjectLiteralOrClassExpressionMethodOrAccessor";
        return ContainerFlags2;
    })(ContainerFlags || {});
    function createFlowNode(flags, node, antecedent) {
        return Debug.attachFlowNodeDebugInfo({
            flags,
            id: 0,
            node,
            antecedent
        });
    }
    var binder = /* @__PURE__ */ createBinder();
    function bindSourceFile(file, options) {
        mark("beforeBind");
        binder(file, options);
        mark("afterBind");
        measure("Bind", "beforeBind", "afterBind");
    }
    function createBinder() {
        var file;
        var options;
        var languageVersion;
        var parent2;
        var container;
        var thisParentContainer;
        var blockScopeContainer;
        var lastContainer;
        var delayedTypeAliases;
        var seenThisKeyword;
        var jsDocImports;
        var currentFlow;
        var currentBreakTarget;
        var currentContinueTarget;
        var currentReturnTarget;
        var currentTrueTarget;
        var currentFalseTarget;
        var currentExceptionTarget;
        var preSwitchCaseFlow;
        var activeLabelList;
        var hasExplicitReturn;
        var inReturnPosition;
        var hasFlowEffects;
        var emitFlags;
        var inStrictMode;
        var inAssignmentPattern = false;
        var symbolCount = 0;
        var Symbol48;
        var classifiableNames;
        var unreachableFlow = createFlowNode(1 /* Unreachable */ , /*node*/ void 0, /*antecedent*/ void 0);
        var reportedUnreachableFlow = createFlowNode(1 /* Unreachable */ , /*node*/ void 0, /*antecedent*/ void 0);
        var bindBinaryExpressionFlow = createBindBinaryExpressionFlow();
        return bindSourceFile2;
        function createDiagnosticForNode2(node, message, ...args) {
            return createDiagnosticForNodeInSourceFile(getSourceFileOfNode(node) || file, node, message, ...args);
        }
        function bindSourceFile2(f, opts) {
            var _a, _b;
            file = f;
            options = opts;
            languageVersion = getEmitScriptTarget(options);
            inStrictMode = bindInStrictMode(file, opts);
            classifiableNames = /* @__PURE__ */ new Set();
            symbolCount = 0;
            Symbol48 = objectAllocator.getSymbolConstructor();
            Debug.attachFlowNodeDebugInfo(unreachableFlow);
            Debug.attachFlowNodeDebugInfo(reportedUnreachableFlow);
            if (!file.locals) {
                (_a = tracing) == null || _a.push(tracing.Phase.Bind, "bindSourceFile", {
                    path: file.path
                }, /*separateBeginAndEnd*/ true);
                bind(file);
                (_b = tracing) == null || _b.pop();
                file.symbolCount = symbolCount;
                file.classifiableNames = classifiableNames;
                delayedBindJSDocTypedefTag();
                bindJSDocImports();
            }
            file = void 0;
            options = void 0;
            languageVersion = void 0;
            parent2 = void 0;
            container = void 0;
            thisParentContainer = void 0;
            blockScopeContainer = void 0;
            lastContainer = void 0;
            delayedTypeAliases = void 0;
            jsDocImports = void 0;
            seenThisKeyword = false;
            currentFlow = void 0;
            currentBreakTarget = void 0;
            currentContinueTarget = void 0;
            currentReturnTarget = void 0;
            currentTrueTarget = void 0;
            currentFalseTarget = void 0;
            currentExceptionTarget = void 0;
            activeLabelList = void 0;
            hasExplicitReturn = false;
            inReturnPosition = false;
            hasFlowEffects = false;
            inAssignmentPattern = false;
            emitFlags = 0 /* None */ ;
        }
        function bindInStrictMode(file2, opts) {
            if (getStrictOptionValue(opts, "alwaysStrict") && !file2.isDeclarationFile) return true;
            else return !!file2.externalModuleIndicator;
        }
        function createSymbol(flags, name) {
            symbolCount++;
            return new Symbol48(flags, name);
        }
        function addDeclarationToSymbol(symbol, node, symbolFlags) {
            symbol.flags |= symbolFlags;
            node.symbol = symbol;
            symbol.declarations = appendIfUnique(symbol.declarations, node);
            if (symbolFlags & 1955 /* Variable */  && !symbol.exports) symbol.exports = createSymbolTable();
            if (symbolFlags & 6240 /* ObjectLiteral */  && !symbol.members) symbol.members = createSymbolTable();
            if (symbol.constEnumOnlyModule && symbol.flags & 304 /* RegularEnum */ ) symbol.constEnumOnlyModule = false;
            if (symbolFlags & 111551 /* Value */ ) setValueDeclaration(symbol, node);
        }
        function getDeclarationName(node) {
            if (node.kind === 278 /* ExportAssignment */ ) return node.isExportEquals ? "export=" /* ExportEquals */  : "default" /* Default */ ;
            const name = getNameOfDeclaration(node);
            if (name) {
                if (isAmbientModule(node)) {
                    const moduleName = getTextOfIdentifierOrLiteral(name);
                    return isGlobalScopeAugmentation(node) ? "__global" : `"${moduleName}"`;
                }
                if (name.kind === 168 /* ComputedPropertyName */ ) {
                    const nameExpression = name.expression;
                    if (isStringOrNumericLiteralLike(nameExpression)) return escapeLeadingUnderscores(nameExpression.text);
                    if (isSignedNumericLiteral(nameExpression)) return tokenToString(nameExpression.operator) + nameExpression.operand.text;
                    else Debug.fail("Only computed properties with literal names have declaration names");
                }
                if (isPrivateIdentifier(name)) {
                    const containingClass = getContainingClass(node);
                    if (!containingClass) return void 0;
                    const containingClassSymbol = containingClass.symbol;
                    return getSymbolNameForPrivateIdentifier(containingClassSymbol, name.escapedText);
                }
                if (isJsxNamespacedName(name)) return getEscapedTextOfJsxNamespacedName(name);
                return isPropertyNameLiteral(name) ? getEscapedTextOfIdentifierOrLiteral(name) : void 0;
            }
            switch(node.kind){
                case 177 /* Constructor */ :
                    return "__constructor" /* Constructor */ ;
                case 185 /* FunctionType */ :
                case 180 /* CallSignature */ :
                case 324 /* JSDocSignature */ :
                    return "__call" /* Call */ ;
                case 186 /* ConstructorType */ :
                case 181 /* ConstructSignature */ :
                    return "__new" /* New */ ;
                case 182 /* IndexSignature */ :
                    return "__index" /* Index */ ;
                case 279 /* ExportDeclaration */ :
                    return "__export" /* ExportStar */ ;
                case 308 /* SourceFile */ :
                    return "export=" /* ExportEquals */ ;
                case 227 /* BinaryExpression */ :
                    if (getAssignmentDeclarationKind(node) === 2 /* ModuleExports */ ) return "export=" /* ExportEquals */ ;
                    Debug.fail("Unknown binary declaration kind");
                    break;
                case 318 /* JSDocFunctionType */ :
                    return isJSDocConstructSignature(node) ? "__new" /* New */  : "__call" /* Call */ ;
                case 170 /* Parameter */ :
                    Debug.assert(node.parent.kind === 318 /* JSDocFunctionType */ , "Impossible parameter parent kind", ()=>`parent is: ${Debug.formatSyntaxKind(node.parent.kind)}, expected JSDocFunctionType`);
                    const functionType = node.parent;
                    const index = functionType.parameters.indexOf(node);
                    return "arg" + index;
            }
        }
        function getDisplayName(node) {
            return isNamedDeclaration(node) ? declarationNameToString(node.name) : unescapeLeadingUnderscores(Debug.checkDefined(getDeclarationName(node)));
        }
        function declareSymbol(symbolTable, parent3, node, includes, excludes, isReplaceableByMethod, isComputedName) {
            Debug.assert(isComputedName || !hasDynamicName(node));
            const isDefaultExport = hasSyntacticModifier(node, 2048 /* Default */ ) || isExportSpecifier(node) && moduleExportNameIsDefault(node.name);
            const name = isComputedName ? "__computed" /* Computed */  : isDefaultExport && parent3 ? "default" /* Default */  : getDeclarationName(node);
            let symbol;
            if (name === void 0) symbol = createSymbol(0 /* None */ , "__missing" /* Missing */ );
            else {
                symbol = symbolTable.get(name);
                if (includes & 2885600 /* Classifiable */ ) classifiableNames.add(name);
                if (!symbol) {
                    symbolTable.set(name, symbol = createSymbol(0 /* None */ , name));
                    if (isReplaceableByMethod) symbol.isReplaceableByMethod = true;
                } else if (isReplaceableByMethod && !symbol.isReplaceableByMethod) return symbol;
                else if (symbol.flags & excludes) {
                    if (symbol.isReplaceableByMethod) symbolTable.set(name, symbol = createSymbol(0 /* None */ , name));
                    else if (!(includes & 3 /* Variable */  && symbol.flags & 67108864 /* Assignment */ )) {
                        if (isNamedDeclaration(node)) setParent(node.name, node);
                        let message = symbol.flags & 2 /* BlockScopedVariable */  ? Diagnostics.Cannot_redeclare_block_scoped_variable_0 : Diagnostics.Duplicate_identifier_0;
                        let messageNeedsName = true;
                        if (symbol.flags & 384 /* Enum */  || includes & 384 /* Enum */ ) {
                            message = Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations;
                            messageNeedsName = false;
                        }
                        let multipleDefaultExports = false;
                        if (length(symbol.declarations)) {
                            if (isDefaultExport) {
                                message = Diagnostics.A_module_cannot_have_multiple_default_exports;
                                messageNeedsName = false;
                                multipleDefaultExports = true;
                            } else if (symbol.declarations && symbol.declarations.length && node.kind === 278 /* ExportAssignment */  && !node.isExportEquals) {
                                message = Diagnostics.A_module_cannot_have_multiple_default_exports;
                                messageNeedsName = false;
                                multipleDefaultExports = true;
                            }
                        }
                        const relatedInformation = [];
                        if (isTypeAliasDeclaration(node) && nodeIsMissing(node.type) && hasSyntacticModifier(node, 32 /* Export */ ) && symbol.flags & 2887656 /* Namespace */ ) relatedInformation.push(createDiagnosticForNode2(node, Diagnostics.Did_you_mean_0, `export type { ${unescapeLeadingUnderscores(node.name.escapedText)} }`));
                        const declarationName = getNameOfDeclaration(node) || node;
                        forEach(symbol.declarations, (declaration, index)=>{
                            const decl = getNameOfDeclaration(declaration) || declaration;
                            const diag3 = messageNeedsName ? createDiagnosticForNode2(decl, message, getDisplayName(declaration)) : createDiagnosticForNode2(decl, message);
                            file.bindDiagnostics.push(multipleDefaultExports ? addRelatedInfo(diag3, createDiagnosticForNode2(declarationName, index === 0 ? Diagnostics.Another_export_default_is_here : Diagnostics.and_here)) : diag3);
                            if (multipleDefaultExports) relatedInformation.push(createDiagnosticForNode2(decl, Diagnostics.The_first_export_default_is_here));
                        });
                        const diag2 = messageNeedsName ? createDiagnosticForNode2(declarationName, message, getDisplayName(node)) : createDiagnosticForNode2(declarationName, message);
                        file.bindDiagnostics.push(addRelatedInfo(diag2, ...relatedInformation));
                        symbol = createSymbol(0 /* None */ , name);
                    }
                }
            }
            addDeclarationToSymbol(symbol, node, includes);
            if (symbol.parent) Debug.assert(symbol.parent === parent3, "Existing symbol parent should match new one");
            else symbol.parent = parent3;
            return symbol;
        }
        function declareModuleMember(node, symbolFlags, symbolExcludes) {
            const hasExportModifier = !!(getCombinedModifierFlags(node) & 32 /* Export */ ) || jsdocTreatAsExported(node);
            if (symbolFlags & 2097152 /* Alias */ ) {
                if (node.kind === 282 /* ExportSpecifier */  || node.kind === 272 /* ImportEqualsDeclaration */  && hasExportModifier) return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                else {
                    Debug.assertNode(container, canHaveLocals);
                    return declareSymbol(container.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
                }
            } else {
                if (isJSDocTypeAlias(node)) Debug.assert(isInJSFile(node));
                if (!isAmbientModule(node) && (hasExportModifier || container.flags & 128 /* ExportContext */ )) {
                    if (!canHaveLocals(container) || !container.locals || hasSyntacticModifier(node, 2048 /* Default */ ) && !getDeclarationName(node)) return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                    const exportKind = symbolFlags & 111551 /* Value */  ? 1048576 /* ExportValue */  : 0;
                    const local = declareSymbol(container.locals, /*parent*/ void 0, node, exportKind, symbolExcludes);
                    local.exportSymbol = declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                    node.localSymbol = local;
                    return local;
                } else {
                    Debug.assertNode(container, canHaveLocals);
                    return declareSymbol(container.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
                }
            }
        }
        function jsdocTreatAsExported(node) {
            if (node.parent && isModuleDeclaration(node)) node = node.parent;
            if (!isJSDocTypeAlias(node)) return false;
            if (!isJSDocEnumTag(node) && !!node.fullName) return true;
            const declName = getNameOfDeclaration(node);
            if (!declName) return false;
            if (isPropertyAccessEntityNameExpression(declName.parent) && isTopLevelNamespaceAssignment(declName.parent)) return true;
            if (isDeclaration(declName.parent) && getCombinedModifierFlags(declName.parent) & 32 /* Export */ ) return true;
            return false;
        }
        function bindContainer(node, containerFlags) {
            const saveContainer = container;
            const saveThisParentContainer = thisParentContainer;
            const savedBlockScopeContainer = blockScopeContainer;
            const savedInReturnPosition = inReturnPosition;
            if (node.kind === 220 /* ArrowFunction */  && node.body.kind !== 242 /* Block */ ) inReturnPosition = true;
            if (containerFlags & 1 /* IsContainer */ ) {
                if (node.kind !== 220 /* ArrowFunction */ ) thisParentContainer = container;
                container = blockScopeContainer = node;
                if (containerFlags & 32 /* HasLocals */ ) {
                    container.locals = createSymbolTable();
                    addToContainerChain(container);
                }
            } else if (containerFlags & 2 /* IsBlockScopedContainer */ ) {
                blockScopeContainer = node;
                if (containerFlags & 32 /* HasLocals */ ) blockScopeContainer.locals = void 0;
            }
            if (containerFlags & 4 /* IsControlFlowContainer */ ) {
                const saveCurrentFlow = currentFlow;
                const saveBreakTarget = currentBreakTarget;
                const saveContinueTarget = currentContinueTarget;
                const saveReturnTarget = currentReturnTarget;
                const saveExceptionTarget = currentExceptionTarget;
                const saveActiveLabelList = activeLabelList;
                const saveHasExplicitReturn = hasExplicitReturn;
                const isImmediatelyInvoked = containerFlags & 16 /* IsFunctionExpression */  && !hasSyntacticModifier(node, 1024 /* Async */ ) && !node.asteriskToken && !!getImmediatelyInvokedFunctionExpression(node) || node.kind === 176 /* ClassStaticBlockDeclaration */ ;
                if (!isImmediatelyInvoked) {
                    currentFlow = createFlowNode(2 /* Start */ , /*node*/ void 0, /*antecedent*/ void 0);
                    if (containerFlags & 144 /* IsObjectLiteralOrClassExpressionMethodOrAccessor */ ) currentFlow.node = node;
                }
                currentReturnTarget = isImmediatelyInvoked || node.kind === 177 /* Constructor */  || isInJSFile(node) && (node.kind === 263 /* FunctionDeclaration */  || node.kind === 219 /* FunctionExpression */ ) ? createBranchLabel() : void 0;
                currentExceptionTarget = void 0;
                currentBreakTarget = void 0;
                currentContinueTarget = void 0;
                activeLabelList = void 0;
                hasExplicitReturn = false;
                bindChildren(node);
                node.flags &= -5633 /* ReachabilityAndEmitFlags */ ;
                if (!(currentFlow.flags & 1 /* Unreachable */ ) && containerFlags & 8 /* IsFunctionLike */  && nodeIsPresent(node.body)) {
                    node.flags |= 512 /* HasImplicitReturn */ ;
                    if (hasExplicitReturn) node.flags |= 1024 /* HasExplicitReturn */ ;
                    node.endFlowNode = currentFlow;
                }
                if (node.kind === 308 /* SourceFile */ ) {
                    node.flags |= emitFlags;
                    node.endFlowNode = currentFlow;
                }
                if (currentReturnTarget) {
                    addAntecedent(currentReturnTarget, currentFlow);
                    currentFlow = finishFlowLabel(currentReturnTarget);
                    if (node.kind === 177 /* Constructor */  || node.kind === 176 /* ClassStaticBlockDeclaration */  || isInJSFile(node) && (node.kind === 263 /* FunctionDeclaration */  || node.kind === 219 /* FunctionExpression */ )) node.returnFlowNode = currentFlow;
                }
                if (!isImmediatelyInvoked) currentFlow = saveCurrentFlow;
                currentBreakTarget = saveBreakTarget;
                currentContinueTarget = saveContinueTarget;
                currentReturnTarget = saveReturnTarget;
                currentExceptionTarget = saveExceptionTarget;
                activeLabelList = saveActiveLabelList;
                hasExplicitReturn = saveHasExplicitReturn;
            } else if (containerFlags & 64 /* IsInterface */ ) {
                seenThisKeyword = false;
                bindChildren(node);
                Debug.assertNotNode(node, isIdentifier);
                node.flags = seenThisKeyword ? node.flags | 256 /* ContainsThis */  : node.flags & -257 /* ContainsThis */ ;
            } else bindChildren(node);
            inReturnPosition = savedInReturnPosition;
            container = saveContainer;
            thisParentContainer = saveThisParentContainer;
            blockScopeContainer = savedBlockScopeContainer;
        }
        function bindEachFunctionsFirst(nodes) {
            bindEach(nodes, (n)=>n.kind === 263 /* FunctionDeclaration */  ? bind(n) : void 0);
            bindEach(nodes, (n)=>n.kind !== 263 /* FunctionDeclaration */  ? bind(n) : void 0);
        }
        function bindEach(nodes, bindFunction = bind) {
            if (nodes === void 0) return;
            forEach(nodes, bindFunction);
        }
        function bindEachChild(node) {
            forEachChild(node, bind, bindEach);
        }
        function bindChildren(node) {
            const saveInAssignmentPattern = inAssignmentPattern;
            inAssignmentPattern = false;
            if (checkUnreachable(node)) {
                if (canHaveFlowNode(node) && node.flowNode) node.flowNode = void 0;
                bindEachChild(node);
                bindJSDoc(node);
                inAssignmentPattern = saveInAssignmentPattern;
                return;
            }
            if (node.kind >= 244 /* FirstStatement */  && node.kind <= 260 /* LastStatement */  && (!options.allowUnreachableCode || node.kind === 254 /* ReturnStatement */ )) node.flowNode = currentFlow;
            switch(node.kind){
                case 248 /* WhileStatement */ :
                    bindWhileStatement(node);
                    break;
                case 247 /* DoStatement */ :
                    bindDoStatement(node);
                    break;
                case 249 /* ForStatement */ :
                    bindForStatement(node);
                    break;
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                    bindForInOrForOfStatement(node);
                    break;
                case 246 /* IfStatement */ :
                    bindIfStatement(node);
                    break;
                case 254 /* ReturnStatement */ :
                case 258 /* ThrowStatement */ :
                    bindReturnOrThrow(node);
                    break;
                case 253 /* BreakStatement */ :
                case 252 /* ContinueStatement */ :
                    bindBreakOrContinueStatement(node);
                    break;
                case 259 /* TryStatement */ :
                    bindTryStatement(node);
                    break;
                case 256 /* SwitchStatement */ :
                    bindSwitchStatement(node);
                    break;
                case 270 /* CaseBlock */ :
                    bindCaseBlock(node);
                    break;
                case 297 /* CaseClause */ :
                    bindCaseClause(node);
                    break;
                case 245 /* ExpressionStatement */ :
                    bindExpressionStatement(node);
                    break;
                case 257 /* LabeledStatement */ :
                    bindLabeledStatement(node);
                    break;
                case 225 /* PrefixUnaryExpression */ :
                    bindPrefixUnaryExpressionFlow(node);
                    break;
                case 226 /* PostfixUnaryExpression */ :
                    bindPostfixUnaryExpressionFlow(node);
                    break;
                case 227 /* BinaryExpression */ :
                    if (isDestructuringAssignment(node)) {
                        inAssignmentPattern = saveInAssignmentPattern;
                        bindDestructuringAssignmentFlow(node);
                        return;
                    }
                    bindBinaryExpressionFlow(node);
                    break;
                case 221 /* DeleteExpression */ :
                    bindDeleteExpressionFlow(node);
                    break;
                case 228 /* ConditionalExpression */ :
                    bindConditionalExpressionFlow(node);
                    break;
                case 261 /* VariableDeclaration */ :
                    bindVariableDeclarationFlow(node);
                    break;
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    bindAccessExpressionFlow(node);
                    break;
                case 214 /* CallExpression */ :
                    bindCallExpressionFlow(node);
                    break;
                case 236 /* NonNullExpression */ :
                    bindNonNullExpressionFlow(node);
                    break;
                case 347 /* JSDocTypedefTag */ :
                case 339 /* JSDocCallbackTag */ :
                case 341 /* JSDocEnumTag */ :
                    bindJSDocTypeAlias(node);
                    break;
                case 352 /* JSDocImportTag */ :
                    bindJSDocImportTag(node);
                    break;
                // In source files and blocks, bind functions first to match hoisting that occurs at runtime
                case 308 /* SourceFile */ :
                    bindEachFunctionsFirst(node.statements);
                    bind(node.endOfFileToken);
                    break;
                case 242 /* Block */ :
                case 269 /* ModuleBlock */ :
                    bindEachFunctionsFirst(node.statements);
                    break;
                case 209 /* BindingElement */ :
                    bindBindingElementFlow(node);
                    break;
                case 170 /* Parameter */ :
                    bindParameterFlow(node);
                    break;
                case 211 /* ObjectLiteralExpression */ :
                case 210 /* ArrayLiteralExpression */ :
                case 304 /* PropertyAssignment */ :
                case 231 /* SpreadElement */ :
                    inAssignmentPattern = saveInAssignmentPattern;
                // falls through
                default:
                    bindEachChild(node);
                    break;
            }
            bindJSDoc(node);
            inAssignmentPattern = saveInAssignmentPattern;
        }
        function isNarrowingExpression(expr) {
            switch(expr.kind){
                case 80 /* Identifier */ :
                case 110 /* ThisKeyword */ :
                    return true;
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    return containsNarrowableReference(expr);
                case 214 /* CallExpression */ :
                    return hasNarrowableArgument(expr);
                case 218 /* ParenthesizedExpression */ :
                    if (isJSDocTypeAssertion(expr)) return false;
                // fallthrough
                case 236 /* NonNullExpression */ :
                    return isNarrowingExpression(expr.expression);
                case 227 /* BinaryExpression */ :
                    return isNarrowingBinaryExpression(expr);
                case 225 /* PrefixUnaryExpression */ :
                    return expr.operator === 54 /* ExclamationToken */  && isNarrowingExpression(expr.operand);
                case 222 /* TypeOfExpression */ :
                    return isNarrowingExpression(expr.expression);
            }
            return false;
        }
        function isNarrowableReference(expr) {
            switch(expr.kind){
                case 80 /* Identifier */ :
                case 110 /* ThisKeyword */ :
                case 108 /* SuperKeyword */ :
                case 237 /* MetaProperty */ :
                    return true;
                case 212 /* PropertyAccessExpression */ :
                case 218 /* ParenthesizedExpression */ :
                case 236 /* NonNullExpression */ :
                    return isNarrowableReference(expr.expression);
                case 213 /* ElementAccessExpression */ :
                    return (isStringOrNumericLiteralLike(expr.argumentExpression) || isEntityNameExpression(expr.argumentExpression)) && isNarrowableReference(expr.expression);
                case 227 /* BinaryExpression */ :
                    return expr.operatorToken.kind === 28 /* CommaToken */  && isNarrowableReference(expr.right) || isAssignmentOperator(expr.operatorToken.kind) && isLeftHandSideExpression(expr.left);
            }
            return false;
        }
        function containsNarrowableReference(expr) {
            return isNarrowableReference(expr) || isOptionalChain(expr) && containsNarrowableReference(expr.expression);
        }
        function hasNarrowableArgument(expr) {
            if (expr.arguments) for (const argument of expr.arguments){
                if (containsNarrowableReference(argument)) return true;
            }
            if (expr.expression.kind === 212 /* PropertyAccessExpression */  && containsNarrowableReference(expr.expression.expression)) return true;
            return false;
        }
        function isNarrowingTypeofOperands(expr1, expr2) {
            return isTypeOfExpression(expr1) && isNarrowableOperand(expr1.expression) && isStringLiteralLike(expr2);
        }
        function isNarrowingBinaryExpression(expr) {
            switch(expr.operatorToken.kind){
                case 64 /* EqualsToken */ :
                case 76 /* BarBarEqualsToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                    return containsNarrowableReference(expr.left);
                case 35 /* EqualsEqualsToken */ :
                case 36 /* ExclamationEqualsToken */ :
                case 37 /* EqualsEqualsEqualsToken */ :
                case 38 /* ExclamationEqualsEqualsToken */ :
                    const left = skipParentheses(expr.left);
                    const right = skipParentheses(expr.right);
                    return isNarrowableOperand(left) || isNarrowableOperand(right) || isNarrowingTypeofOperands(right, left) || isNarrowingTypeofOperands(left, right) || isBooleanLiteral(right) && isNarrowingExpression(left) || isBooleanLiteral(left) && isNarrowingExpression(right);
                case 104 /* InstanceOfKeyword */ :
                    return isNarrowableOperand(expr.left);
                case 103 /* InKeyword */ :
                    return isNarrowingExpression(expr.right);
                case 28 /* CommaToken */ :
                    return isNarrowingExpression(expr.right);
            }
            return false;
        }
        function isNarrowableOperand(expr) {
            switch(expr.kind){
                case 218 /* ParenthesizedExpression */ :
                    return isNarrowableOperand(expr.expression);
                case 227 /* BinaryExpression */ :
                    switch(expr.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                            return isNarrowableOperand(expr.left);
                        case 28 /* CommaToken */ :
                            return isNarrowableOperand(expr.right);
                    }
            }
            return containsNarrowableReference(expr);
        }
        function createBranchLabel() {
            return createFlowNode(4 /* BranchLabel */ , /*node*/ void 0, /*antecedent*/ void 0);
        }
        function createLoopLabel() {
            return createFlowNode(8 /* LoopLabel */ , /*node*/ void 0, /*antecedent*/ void 0);
        }
        function createReduceLabel(target, antecedents, antecedent) {
            return createFlowNode(1024 /* ReduceLabel */ , {
                target,
                antecedents
            }, antecedent);
        }
        function setFlowNodeReferenced(flow) {
            flow.flags |= flow.flags & 2048 /* Referenced */  ? 4096 /* Shared */  : 2048 /* Referenced */ ;
        }
        function addAntecedent(label, antecedent) {
            if (!(antecedent.flags & 1 /* Unreachable */ ) && !contains(label.antecedent, antecedent)) {
                (label.antecedent || (label.antecedent = [])).push(antecedent);
                setFlowNodeReferenced(antecedent);
            }
        }
        function createFlowCondition(flags, antecedent, expression) {
            if (antecedent.flags & 1 /* Unreachable */ ) return antecedent;
            if (!expression) return flags & 32 /* TrueCondition */  ? antecedent : unreachableFlow;
            if ((expression.kind === 112 /* TrueKeyword */  && flags & 64 /* FalseCondition */  || expression.kind === 97 /* FalseKeyword */  && flags & 32 /* TrueCondition */ ) && !isExpressionOfOptionalChainRoot(expression) && !isNullishCoalesce(expression.parent)) return unreachableFlow;
            if (!isNarrowingExpression(expression)) return antecedent;
            setFlowNodeReferenced(antecedent);
            return createFlowNode(flags, expression, antecedent);
        }
        function createFlowSwitchClause(antecedent, switchStatement, clauseStart, clauseEnd) {
            setFlowNodeReferenced(antecedent);
            return createFlowNode(128 /* SwitchClause */ , {
                switchStatement,
                clauseStart,
                clauseEnd
            }, antecedent);
        }
        function createFlowMutation(flags, antecedent, node) {
            setFlowNodeReferenced(antecedent);
            hasFlowEffects = true;
            const result = createFlowNode(flags, node, antecedent);
            if (currentExceptionTarget) addAntecedent(currentExceptionTarget, result);
            return result;
        }
        function createFlowCall(antecedent, node) {
            setFlowNodeReferenced(antecedent);
            hasFlowEffects = true;
            return createFlowNode(512 /* Call */ , node, antecedent);
        }
        function finishFlowLabel(flow) {
            const antecedents = flow.antecedent;
            if (!antecedents) return unreachableFlow;
            if (antecedents.length === 1) return antecedents[0];
            return flow;
        }
        function isStatementCondition(node) {
            const parent3 = node.parent;
            switch(parent3.kind){
                case 246 /* IfStatement */ :
                case 248 /* WhileStatement */ :
                case 247 /* DoStatement */ :
                    return parent3.expression === node;
                case 249 /* ForStatement */ :
                case 228 /* ConditionalExpression */ :
                    return parent3.condition === node;
            }
            return false;
        }
        function isLogicalExpression(node) {
            while(true){
                if (node.kind === 218 /* ParenthesizedExpression */ ) node = node.expression;
                else if (node.kind === 225 /* PrefixUnaryExpression */  && node.operator === 54 /* ExclamationToken */ ) node = node.operand;
                else return isLogicalOrCoalescingBinaryExpression(node);
            }
        }
        function isLogicalAssignmentExpression(node) {
            return isLogicalOrCoalescingAssignmentExpression(skipParentheses(node));
        }
        function isTopLevelLogicalExpression(node) {
            while(isParenthesizedExpression(node.parent) || isPrefixUnaryExpression(node.parent) && node.parent.operator === 54 /* ExclamationToken */ )node = node.parent;
            return !isStatementCondition(node) && !isLogicalExpression(node.parent) && !(isOptionalChain(node.parent) && node.parent.expression === node);
        }
        function doWithConditionalBranches(action, value1, trueTarget, falseTarget) {
            const savedTrueTarget = currentTrueTarget;
            const savedFalseTarget = currentFalseTarget;
            currentTrueTarget = trueTarget;
            currentFalseTarget = falseTarget;
            action(value1);
            currentTrueTarget = savedTrueTarget;
            currentFalseTarget = savedFalseTarget;
        }
        function bindCondition(node, trueTarget, falseTarget) {
            doWithConditionalBranches(bind, node, trueTarget, falseTarget);
            if (!node || !isLogicalAssignmentExpression(node) && !isLogicalExpression(node) && !(isOptionalChain(node) && isOutermostOptionalChain(node))) {
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            }
        }
        function bindIterativeStatement(node, breakTarget, continueTarget) {
            const saveBreakTarget = currentBreakTarget;
            const saveContinueTarget = currentContinueTarget;
            currentBreakTarget = breakTarget;
            currentContinueTarget = continueTarget;
            bind(node);
            currentBreakTarget = saveBreakTarget;
            currentContinueTarget = saveContinueTarget;
        }
        function setContinueTarget(node, target) {
            let label = activeLabelList;
            while(label && node.parent.kind === 257 /* LabeledStatement */ ){
                label.continueTarget = target;
                label = label.next;
                node = node.parent;
            }
            return target;
        }
        function bindWhileStatement(node) {
            const preWhileLabel = setContinueTarget(node, createLoopLabel());
            const preBodyLabel = createBranchLabel();
            const postWhileLabel = createBranchLabel();
            addAntecedent(preWhileLabel, currentFlow);
            currentFlow = preWhileLabel;
            bindCondition(node.expression, preBodyLabel, postWhileLabel);
            currentFlow = finishFlowLabel(preBodyLabel);
            bindIterativeStatement(node.statement, postWhileLabel, preWhileLabel);
            addAntecedent(preWhileLabel, currentFlow);
            currentFlow = finishFlowLabel(postWhileLabel);
        }
        function bindDoStatement(node) {
            const preDoLabel = createLoopLabel();
            const preConditionLabel = setContinueTarget(node, createBranchLabel());
            const postDoLabel = createBranchLabel();
            addAntecedent(preDoLabel, currentFlow);
            currentFlow = preDoLabel;
            bindIterativeStatement(node.statement, postDoLabel, preConditionLabel);
            addAntecedent(preConditionLabel, currentFlow);
            currentFlow = finishFlowLabel(preConditionLabel);
            bindCondition(node.expression, preDoLabel, postDoLabel);
            currentFlow = finishFlowLabel(postDoLabel);
        }
        function bindForStatement(node) {
            const preLoopLabel = setContinueTarget(node, createLoopLabel());
            const preBodyLabel = createBranchLabel();
            const preIncrementorLabel = createBranchLabel();
            const postLoopLabel = createBranchLabel();
            bind(node.initializer);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = preLoopLabel;
            bindCondition(node.condition, preBodyLabel, postLoopLabel);
            currentFlow = finishFlowLabel(preBodyLabel);
            bindIterativeStatement(node.statement, postLoopLabel, preIncrementorLabel);
            addAntecedent(preIncrementorLabel, currentFlow);
            currentFlow = finishFlowLabel(preIncrementorLabel);
            bind(node.incrementor);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = finishFlowLabel(postLoopLabel);
        }
        function bindForInOrForOfStatement(node) {
            const preLoopLabel = setContinueTarget(node, createLoopLabel());
            const postLoopLabel = createBranchLabel();
            bind(node.expression);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = preLoopLabel;
            if (node.kind === 251 /* ForOfStatement */ ) bind(node.awaitModifier);
            addAntecedent(postLoopLabel, currentFlow);
            bind(node.initializer);
            if (node.initializer.kind !== 262 /* VariableDeclarationList */ ) bindAssignmentTargetFlow(node.initializer);
            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
            addAntecedent(preLoopLabel, currentFlow);
            currentFlow = finishFlowLabel(postLoopLabel);
        }
        function bindIfStatement(node) {
            const thenLabel = createBranchLabel();
            const elseLabel = createBranchLabel();
            const postIfLabel = createBranchLabel();
            bindCondition(node.expression, thenLabel, elseLabel);
            currentFlow = finishFlowLabel(thenLabel);
            bind(node.thenStatement);
            addAntecedent(postIfLabel, currentFlow);
            currentFlow = finishFlowLabel(elseLabel);
            bind(node.elseStatement);
            addAntecedent(postIfLabel, currentFlow);
            currentFlow = finishFlowLabel(postIfLabel);
        }
        function bindReturnOrThrow(node) {
            const savedInReturnPosition = inReturnPosition;
            inReturnPosition = true;
            bind(node.expression);
            inReturnPosition = savedInReturnPosition;
            if (node.kind === 254 /* ReturnStatement */ ) {
                hasExplicitReturn = true;
                if (currentReturnTarget) addAntecedent(currentReturnTarget, currentFlow);
            }
            currentFlow = unreachableFlow;
            hasFlowEffects = true;
        }
        function findActiveLabel(name) {
            for(let label = activeLabelList; label; label = label.next){
                if (label.name === name) return label;
            }
            return void 0;
        }
        function bindBreakOrContinueFlow(node, breakTarget, continueTarget) {
            const flowLabel = node.kind === 253 /* BreakStatement */  ? breakTarget : continueTarget;
            if (flowLabel) {
                addAntecedent(flowLabel, currentFlow);
                currentFlow = unreachableFlow;
                hasFlowEffects = true;
            }
        }
        function bindBreakOrContinueStatement(node) {
            bind(node.label);
            if (node.label) {
                const activeLabel = findActiveLabel(node.label.escapedText);
                if (activeLabel) {
                    activeLabel.referenced = true;
                    bindBreakOrContinueFlow(node, activeLabel.breakTarget, activeLabel.continueTarget);
                }
            } else bindBreakOrContinueFlow(node, currentBreakTarget, currentContinueTarget);
        }
        function bindTryStatement(node) {
            const saveReturnTarget = currentReturnTarget;
            const saveExceptionTarget = currentExceptionTarget;
            const normalExitLabel = createBranchLabel();
            const returnLabel = createBranchLabel();
            let exceptionLabel = createBranchLabel();
            if (node.finallyBlock) currentReturnTarget = returnLabel;
            addAntecedent(exceptionLabel, currentFlow);
            currentExceptionTarget = exceptionLabel;
            bind(node.tryBlock);
            addAntecedent(normalExitLabel, currentFlow);
            if (node.catchClause) {
                currentFlow = finishFlowLabel(exceptionLabel);
                exceptionLabel = createBranchLabel();
                addAntecedent(exceptionLabel, currentFlow);
                currentExceptionTarget = exceptionLabel;
                bind(node.catchClause);
                addAntecedent(normalExitLabel, currentFlow);
            }
            currentReturnTarget = saveReturnTarget;
            currentExceptionTarget = saveExceptionTarget;
            if (node.finallyBlock) {
                const finallyLabel = createBranchLabel();
                finallyLabel.antecedent = concatenate(concatenate(normalExitLabel.antecedent, exceptionLabel.antecedent), returnLabel.antecedent);
                currentFlow = finallyLabel;
                bind(node.finallyBlock);
                if (currentFlow.flags & 1 /* Unreachable */ ) currentFlow = unreachableFlow;
                else {
                    if (currentReturnTarget && returnLabel.antecedent) addAntecedent(currentReturnTarget, createReduceLabel(finallyLabel, returnLabel.antecedent, currentFlow));
                    if (currentExceptionTarget && exceptionLabel.antecedent) addAntecedent(currentExceptionTarget, createReduceLabel(finallyLabel, exceptionLabel.antecedent, currentFlow));
                    currentFlow = normalExitLabel.antecedent ? createReduceLabel(finallyLabel, normalExitLabel.antecedent, currentFlow) : unreachableFlow;
                }
            } else currentFlow = finishFlowLabel(normalExitLabel);
        }
        function bindSwitchStatement(node) {
            const postSwitchLabel = createBranchLabel();
            bind(node.expression);
            const saveBreakTarget = currentBreakTarget;
            const savePreSwitchCaseFlow = preSwitchCaseFlow;
            currentBreakTarget = postSwitchLabel;
            preSwitchCaseFlow = currentFlow;
            bind(node.caseBlock);
            addAntecedent(postSwitchLabel, currentFlow);
            const hasDefault = forEach(node.caseBlock.clauses, (c)=>c.kind === 298 /* DefaultClause */ );
            node.possiblyExhaustive = !hasDefault && !postSwitchLabel.antecedent;
            if (!hasDefault) addAntecedent(postSwitchLabel, createFlowSwitchClause(preSwitchCaseFlow, node, 0, 0));
            currentBreakTarget = saveBreakTarget;
            preSwitchCaseFlow = savePreSwitchCaseFlow;
            currentFlow = finishFlowLabel(postSwitchLabel);
        }
        function bindCaseBlock(node) {
            const clauses = node.clauses;
            const isNarrowingSwitch = node.parent.expression.kind === 112 /* TrueKeyword */  || isNarrowingExpression(node.parent.expression);
            let fallthroughFlow = unreachableFlow;
            for(let i = 0; i < clauses.length; i++){
                const clauseStart = i;
                while(!clauses[i].statements.length && i + 1 < clauses.length){
                    if (fallthroughFlow === unreachableFlow) currentFlow = preSwitchCaseFlow;
                    bind(clauses[i]);
                    i++;
                }
                const preCaseLabel = createBranchLabel();
                addAntecedent(preCaseLabel, isNarrowingSwitch ? createFlowSwitchClause(preSwitchCaseFlow, node.parent, clauseStart, i + 1) : preSwitchCaseFlow);
                addAntecedent(preCaseLabel, fallthroughFlow);
                currentFlow = finishFlowLabel(preCaseLabel);
                const clause = clauses[i];
                bind(clause);
                fallthroughFlow = currentFlow;
                if (!(currentFlow.flags & 1 /* Unreachable */ ) && i !== clauses.length - 1 && options.noFallthroughCasesInSwitch) clause.fallthroughFlowNode = currentFlow;
            }
        }
        function bindCaseClause(node) {
            const saveCurrentFlow = currentFlow;
            currentFlow = preSwitchCaseFlow;
            bind(node.expression);
            currentFlow = saveCurrentFlow;
            bindEach(node.statements);
        }
        function bindExpressionStatement(node) {
            bind(node.expression);
            maybeBindExpressionFlowIfCall(node.expression);
        }
        function maybeBindExpressionFlowIfCall(node) {
            if (node.kind === 214 /* CallExpression */ ) {
                const call = node;
                if (call.expression.kind !== 108 /* SuperKeyword */  && isDottedName(call.expression)) currentFlow = createFlowCall(currentFlow, call);
            }
        }
        function bindLabeledStatement(node) {
            const postStatementLabel = createBranchLabel();
            activeLabelList = {
                next: activeLabelList,
                name: node.label.escapedText,
                breakTarget: postStatementLabel,
                continueTarget: void 0,
                referenced: false
            };
            bind(node.label);
            bind(node.statement);
            if (!activeLabelList.referenced && !options.allowUnusedLabels) errorOrSuggestionOnNode(unusedLabelIsError(options), node.label, Diagnostics.Unused_label);
            activeLabelList = activeLabelList.next;
            addAntecedent(postStatementLabel, currentFlow);
            currentFlow = finishFlowLabel(postStatementLabel);
        }
        function bindDestructuringTargetFlow(node) {
            if (node.kind === 227 /* BinaryExpression */  && node.operatorToken.kind === 64 /* EqualsToken */ ) bindAssignmentTargetFlow(node.left);
            else bindAssignmentTargetFlow(node);
        }
        function bindAssignmentTargetFlow(node) {
            if (isNarrowableReference(node)) currentFlow = createFlowMutation(16 /* Assignment */ , currentFlow, node);
            else if (node.kind === 210 /* ArrayLiteralExpression */ ) {
                for (const e of node.elements)if (e.kind === 231 /* SpreadElement */ ) bindAssignmentTargetFlow(e.expression);
                else bindDestructuringTargetFlow(e);
            } else if (node.kind === 211 /* ObjectLiteralExpression */ ) for (const p of node.properties){
                if (p.kind === 304 /* PropertyAssignment */ ) bindDestructuringTargetFlow(p.initializer);
                else if (p.kind === 305 /* ShorthandPropertyAssignment */ ) bindAssignmentTargetFlow(p.name);
                else if (p.kind === 306 /* SpreadAssignment */ ) bindAssignmentTargetFlow(p.expression);
            }
        }
        function bindLogicalLikeExpression(node, trueTarget, falseTarget) {
            const preRightLabel = createBranchLabel();
            if (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */  || node.operatorToken.kind === 77 /* AmpersandAmpersandEqualsToken */ ) bindCondition(node.left, preRightLabel, falseTarget);
            else bindCondition(node.left, trueTarget, preRightLabel);
            currentFlow = finishFlowLabel(preRightLabel);
            bind(node.operatorToken);
            if (isLogicalOrCoalescingAssignmentOperator(node.operatorToken.kind)) {
                doWithConditionalBranches(bind, node.right, trueTarget, falseTarget);
                bindAssignmentTargetFlow(node.left);
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            } else bindCondition(node.right, trueTarget, falseTarget);
        }
        function bindPrefixUnaryExpressionFlow(node) {
            if (node.operator === 54 /* ExclamationToken */ ) {
                const saveTrueTarget = currentTrueTarget;
                currentTrueTarget = currentFalseTarget;
                currentFalseTarget = saveTrueTarget;
                bindEachChild(node);
                currentFalseTarget = currentTrueTarget;
                currentTrueTarget = saveTrueTarget;
            } else {
                bindEachChild(node);
                if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) bindAssignmentTargetFlow(node.operand);
            }
        }
        function bindPostfixUnaryExpressionFlow(node) {
            bindEachChild(node);
            if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) bindAssignmentTargetFlow(node.operand);
        }
        function bindDestructuringAssignmentFlow(node) {
            if (inAssignmentPattern) {
                inAssignmentPattern = false;
                bind(node.operatorToken);
                bind(node.right);
                inAssignmentPattern = true;
                bind(node.left);
            } else {
                inAssignmentPattern = true;
                bind(node.left);
                inAssignmentPattern = false;
                bind(node.operatorToken);
                bind(node.right);
            }
            bindAssignmentTargetFlow(node.left);
        }
        function createBindBinaryExpressionFlow() {
            return createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, /*foldState*/ void 0);
            function onEnter(node, state) {
                if (state) {
                    state.stackIndex++;
                    setParent(node, parent2);
                    const saveInStrictMode = inStrictMode;
                    bindWorker(node);
                    const saveParent = parent2;
                    parent2 = node;
                    state.skip = false;
                    state.inStrictModeStack[state.stackIndex] = saveInStrictMode;
                    state.parentStack[state.stackIndex] = saveParent;
                } else state = {
                    stackIndex: 0,
                    skip: false,
                    inStrictModeStack: [
                        void 0
                    ],
                    parentStack: [
                        void 0
                    ]
                };
                const operator = node.operatorToken.kind;
                if (isLogicalOrCoalescingBinaryOperator(operator) || isLogicalOrCoalescingAssignmentOperator(operator)) {
                    if (isTopLevelLogicalExpression(node)) {
                        const postExpressionLabel = createBranchLabel();
                        const saveCurrentFlow = currentFlow;
                        const saveHasFlowEffects = hasFlowEffects;
                        hasFlowEffects = false;
                        bindLogicalLikeExpression(node, postExpressionLabel, postExpressionLabel);
                        currentFlow = hasFlowEffects ? finishFlowLabel(postExpressionLabel) : saveCurrentFlow;
                        hasFlowEffects || (hasFlowEffects = saveHasFlowEffects);
                    } else bindLogicalLikeExpression(node, currentTrueTarget, currentFalseTarget);
                    state.skip = true;
                }
                return state;
            }
            function onLeft(left, state, node) {
                if (!state.skip) {
                    const maybeBound = maybeBind2(left);
                    if (node.operatorToken.kind === 28 /* CommaToken */ ) maybeBindExpressionFlowIfCall(left);
                    return maybeBound;
                }
            }
            function onOperator(operatorToken, state, _node) {
                if (!state.skip) bind(operatorToken);
            }
            function onRight(right, state, node) {
                if (!state.skip) {
                    const maybeBound = maybeBind2(right);
                    if (node.operatorToken.kind === 28 /* CommaToken */ ) maybeBindExpressionFlowIfCall(right);
                    return maybeBound;
                }
            }
            function onExit(node, state) {
                if (!state.skip) {
                    const operator = node.operatorToken.kind;
                    if (isAssignmentOperator(operator) && !isAssignmentTarget(node)) {
                        bindAssignmentTargetFlow(node.left);
                        if (operator === 64 /* EqualsToken */  && node.left.kind === 213 /* ElementAccessExpression */ ) {
                            const elementAccess = node.left;
                            if (isNarrowableOperand(elementAccess.expression)) currentFlow = createFlowMutation(256 /* ArrayMutation */ , currentFlow, node);
                        }
                    }
                }
                const savedInStrictMode = state.inStrictModeStack[state.stackIndex];
                const savedParent = state.parentStack[state.stackIndex];
                if (savedInStrictMode !== void 0) inStrictMode = savedInStrictMode;
                if (savedParent !== void 0) parent2 = savedParent;
                state.skip = false;
                state.stackIndex--;
            }
            function maybeBind2(node) {
                if (node && isBinaryExpression(node) && !isDestructuringAssignment(node)) return node;
                bind(node);
            }
        }
        function bindDeleteExpressionFlow(node) {
            bindEachChild(node);
            if (node.expression.kind === 212 /* PropertyAccessExpression */ ) bindAssignmentTargetFlow(node.expression);
        }
        function bindConditionalExpressionFlow(node) {
            const trueLabel = createBranchLabel();
            const falseLabel = createBranchLabel();
            const postExpressionLabel = createBranchLabel();
            const saveCurrentFlow = currentFlow;
            const saveHasFlowEffects = hasFlowEffects;
            hasFlowEffects = false;
            bindCondition(node.condition, trueLabel, falseLabel);
            currentFlow = finishFlowLabel(trueLabel);
            if (inReturnPosition) node.flowNodeWhenTrue = currentFlow;
            bind(node.questionToken);
            bind(node.whenTrue);
            addAntecedent(postExpressionLabel, currentFlow);
            currentFlow = finishFlowLabel(falseLabel);
            if (inReturnPosition) node.flowNodeWhenFalse = currentFlow;
            bind(node.colonToken);
            bind(node.whenFalse);
            addAntecedent(postExpressionLabel, currentFlow);
            currentFlow = hasFlowEffects ? finishFlowLabel(postExpressionLabel) : saveCurrentFlow;
            hasFlowEffects || (hasFlowEffects = saveHasFlowEffects);
        }
        function bindInitializedVariableFlow(node) {
            const name = !isOmittedExpression(node) ? node.name : void 0;
            if (isBindingPattern(name)) for (const child of name.elements)bindInitializedVariableFlow(child);
            else currentFlow = createFlowMutation(16 /* Assignment */ , currentFlow, node);
        }
        function bindVariableDeclarationFlow(node) {
            bindEachChild(node);
            if (node.initializer || isForInOrOfStatement(node.parent.parent)) bindInitializedVariableFlow(node);
        }
        function bindBindingElementFlow(node) {
            bind(node.dotDotDotToken);
            bind(node.propertyName);
            bindInitializer(node.initializer);
            bind(node.name);
        }
        function bindParameterFlow(node) {
            bindEach(node.modifiers);
            bind(node.dotDotDotToken);
            bind(node.questionToken);
            bind(node.type);
            bindInitializer(node.initializer);
            bind(node.name);
        }
        function bindInitializer(node) {
            if (!node) return;
            const entryFlow = currentFlow;
            bind(node);
            if (entryFlow === unreachableFlow || entryFlow === currentFlow) return;
            const exitFlow = createBranchLabel();
            addAntecedent(exitFlow, entryFlow);
            addAntecedent(exitFlow, currentFlow);
            currentFlow = finishFlowLabel(exitFlow);
        }
        function bindJSDocTypeAlias(node) {
            bind(node.tagName);
            if (node.kind !== 341 /* JSDocEnumTag */  && node.fullName) {
                setParent(node.fullName, node);
                setParentRecursive(node.fullName, /*incremental*/ false);
            }
            if (typeof node.comment !== "string") bindEach(node.comment);
        }
        function bindJSDocClassTag(node) {
            bindEachChild(node);
            const host = getHostSignatureFromJSDoc(node);
            if (host && host.kind !== 175 /* MethodDeclaration */ ) addDeclarationToSymbol(host.symbol, host, 32 /* Class */ );
        }
        function bindJSDocImportTag(node) {
            bind(node.tagName);
            bind(node.moduleSpecifier);
            bind(node.attributes);
            if (typeof node.comment !== "string") bindEach(node.comment);
        }
        function bindOptionalExpression(node, trueTarget, falseTarget) {
            doWithConditionalBranches(bind, node, trueTarget, falseTarget);
            if (!isOptionalChain(node) || isOutermostOptionalChain(node)) {
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            }
        }
        function bindOptionalChainRest(node) {
            switch(node.kind){
                case 212 /* PropertyAccessExpression */ :
                    bind(node.questionDotToken);
                    bind(node.name);
                    break;
                case 213 /* ElementAccessExpression */ :
                    bind(node.questionDotToken);
                    bind(node.argumentExpression);
                    break;
                case 214 /* CallExpression */ :
                    bind(node.questionDotToken);
                    bindEach(node.typeArguments);
                    bindEach(node.arguments);
                    break;
            }
        }
        function bindOptionalChain(node, trueTarget, falseTarget) {
            const preChainLabel = isOptionalChainRoot(node) ? createBranchLabel() : void 0;
            bindOptionalExpression(node.expression, preChainLabel || trueTarget, falseTarget);
            if (preChainLabel) currentFlow = finishFlowLabel(preChainLabel);
            doWithConditionalBranches(bindOptionalChainRest, node, trueTarget, falseTarget);
            if (isOutermostOptionalChain(node)) {
                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */ , currentFlow, node));
                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */ , currentFlow, node));
            }
        }
        function bindOptionalChainFlow(node) {
            if (isTopLevelLogicalExpression(node)) {
                const postExpressionLabel = createBranchLabel();
                const saveCurrentFlow = currentFlow;
                const saveHasFlowEffects = hasFlowEffects;
                bindOptionalChain(node, postExpressionLabel, postExpressionLabel);
                currentFlow = hasFlowEffects ? finishFlowLabel(postExpressionLabel) : saveCurrentFlow;
                hasFlowEffects || (hasFlowEffects = saveHasFlowEffects);
            } else bindOptionalChain(node, currentTrueTarget, currentFalseTarget);
        }
        function bindNonNullExpressionFlow(node) {
            if (isOptionalChain(node)) bindOptionalChainFlow(node);
            else bindEachChild(node);
        }
        function bindAccessExpressionFlow(node) {
            if (isOptionalChain(node)) bindOptionalChainFlow(node);
            else bindEachChild(node);
        }
        function bindCallExpressionFlow(node) {
            if (isOptionalChain(node)) bindOptionalChainFlow(node);
            else {
                const expr = skipParentheses(node.expression);
                if (expr.kind === 219 /* FunctionExpression */  || expr.kind === 220 /* ArrowFunction */ ) {
                    bindEach(node.typeArguments);
                    bindEach(node.arguments);
                    bind(node.expression);
                } else {
                    bindEachChild(node);
                    if (node.expression.kind === 108 /* SuperKeyword */ ) currentFlow = createFlowCall(currentFlow, node);
                }
            }
            if (node.expression.kind === 212 /* PropertyAccessExpression */ ) {
                const propertyAccess = node.expression;
                if (isIdentifier(propertyAccess.name) && isNarrowableOperand(propertyAccess.expression) && isPushOrUnshiftIdentifier(propertyAccess.name)) currentFlow = createFlowMutation(256 /* ArrayMutation */ , currentFlow, node);
            }
        }
        function addToContainerChain(next) {
            if (lastContainer) lastContainer.nextContainer = next;
            lastContainer = next;
        }
        function declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes) {
            switch(container.kind){
                // Modules, source files, and classes need specialized handling for how their
                // members are declared (for example, a member of a class will go into a specific
                // symbol table depending on if it is static or not). We defer to specialized
                // handlers to take care of declaring these child members.
                case 268 /* ModuleDeclaration */ :
                    return declareModuleMember(node, symbolFlags, symbolExcludes);
                case 308 /* SourceFile */ :
                    return declareSourceFileMember(node, symbolFlags, symbolExcludes);
                case 232 /* ClassExpression */ :
                case 264 /* ClassDeclaration */ :
                    return declareClassMember(node, symbolFlags, symbolExcludes);
                case 267 /* EnumDeclaration */ :
                    return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
                case 188 /* TypeLiteral */ :
                case 323 /* JSDocTypeLiteral */ :
                case 211 /* ObjectLiteralExpression */ :
                case 265 /* InterfaceDeclaration */ :
                case 293 /* JsxAttributes */ :
                    return declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                case 180 /* CallSignature */ :
                case 181 /* ConstructSignature */ :
                case 324 /* JSDocSignature */ :
                case 182 /* IndexSignature */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 318 /* JSDocFunctionType */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 201 /* MappedType */ :
                    if (container.locals) Debug.assertNode(container, canHaveLocals);
                    return declareSymbol(container.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
            }
        }
        function declareClassMember(node, symbolFlags, symbolExcludes) {
            return isStatic(node) ? declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes) : declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
        }
        function declareSourceFileMember(node, symbolFlags, symbolExcludes) {
            return isExternalModule(file) ? declareModuleMember(node, symbolFlags, symbolExcludes) : declareSymbol(file.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
        }
        function hasExportDeclarations(node) {
            const body = isSourceFile(node) ? node : tryCast(node.body, isModuleBlock);
            return !!body && body.statements.some((s)=>isExportDeclaration(s) || isExportAssignment(s));
        }
        function setExportContextFlag(node) {
            if (node.flags & 33554432 /* Ambient */  && !hasExportDeclarations(node)) node.flags |= 128 /* ExportContext */ ;
            else node.flags &= -129 /* ExportContext */ ;
        }
        function bindModuleDeclaration(node) {
            setExportContextFlag(node);
            if (isAmbientModule(node)) {
                if (hasSyntacticModifier(node, 32 /* Export */ )) errorOnFirstToken(node, Diagnostics.export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible);
                if (isModuleAugmentationExternal(node)) declareModuleSymbol(node);
                else {
                    let pattern;
                    if (node.name.kind === 11 /* StringLiteral */ ) {
                        const { text } = node.name;
                        pattern = tryParsePattern(text);
                        if (pattern === void 0) errorOnFirstToken(node.name, Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, text);
                    }
                    const symbol = declareSymbolAndAddToSymbolTable(node, 512 /* ValueModule */ , 110735 /* ValueModuleExcludes */ );
                    file.patternAmbientModules = append(file.patternAmbientModules, pattern && !isString(pattern) ? {
                        pattern,
                        symbol
                    } : void 0);
                }
            } else {
                const state = declareModuleSymbol(node);
                if (state !== 0 /* NonInstantiated */ ) {
                    const { symbol } = node;
                    symbol.constEnumOnlyModule = !(symbol.flags & 304 /* RegularEnum */ ) && state === 2 /* ConstEnumOnly */  && symbol.constEnumOnlyModule !== false;
                }
            }
        }
        function declareModuleSymbol(node) {
            const state = getModuleInstanceState(node);
            const instantiated = state !== 0 /* NonInstantiated */ ;
            declareSymbolAndAddToSymbolTable(node, instantiated ? 512 /* ValueModule */  : 1024 /* NamespaceModule */ , instantiated ? 110735 /* ValueModuleExcludes */  : 0 /* NamespaceModuleExcludes */ );
            return state;
        }
        function bindFunctionOrConstructorType(node) {
            const symbol = createSymbol(131072 /* Signature */ , getDeclarationName(node));
            addDeclarationToSymbol(symbol, node, 131072 /* Signature */ );
            const typeLiteralSymbol = createSymbol(2048 /* TypeLiteral */ , "__type" /* Type */ );
            addDeclarationToSymbol(typeLiteralSymbol, node, 2048 /* TypeLiteral */ );
            typeLiteralSymbol.members = createSymbolTable();
            typeLiteralSymbol.members.set(symbol.escapedName, symbol);
        }
        function bindObjectLiteralExpression(node) {
            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */ , "__object" /* Object */ );
        }
        function bindJsxAttributes(node) {
            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */ , "__jsxAttributes" /* JSXAttributes */ );
        }
        function bindJsxAttribute(node, symbolFlags, symbolExcludes) {
            return declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
        }
        function bindAnonymousDeclaration(node, symbolFlags, name) {
            const symbol = createSymbol(symbolFlags, name);
            if (symbolFlags & 106508 /* ClassMember */ ) symbol.parent = container.symbol;
            addDeclarationToSymbol(symbol, node, symbolFlags);
            return symbol;
        }
        function bindBlockScopedDeclaration(node, symbolFlags, symbolExcludes) {
            switch(blockScopeContainer.kind){
                case 268 /* ModuleDeclaration */ :
                    declareModuleMember(node, symbolFlags, symbolExcludes);
                    break;
                case 308 /* SourceFile */ :
                    if (isExternalOrCommonJsModule(container)) {
                        declareModuleMember(node, symbolFlags, symbolExcludes);
                        break;
                    }
                // falls through
                default:
                    Debug.assertNode(blockScopeContainer, canHaveLocals);
                    if (!blockScopeContainer.locals) {
                        blockScopeContainer.locals = createSymbolTable();
                        addToContainerChain(blockScopeContainer);
                    }
                    declareSymbol(blockScopeContainer.locals, /*parent*/ void 0, node, symbolFlags, symbolExcludes);
            }
        }
        function delayedBindJSDocTypedefTag() {
            if (!delayedTypeAliases) return;
            const saveContainer = container;
            const saveLastContainer = lastContainer;
            const saveBlockScopeContainer = blockScopeContainer;
            const saveParent = parent2;
            const saveCurrentFlow = currentFlow;
            for (const typeAlias of delayedTypeAliases){
                const host = typeAlias.parent.parent;
                container = getEnclosingContainer(host) || file;
                blockScopeContainer = getEnclosingBlockScopeContainer(host) || file;
                currentFlow = createFlowNode(2 /* Start */ , /*node*/ void 0, /*antecedent*/ void 0);
                parent2 = typeAlias;
                bind(typeAlias.typeExpression);
                const declName = getNameOfDeclaration(typeAlias);
                if ((isJSDocEnumTag(typeAlias) || !typeAlias.fullName) && declName && isPropertyAccessEntityNameExpression(declName.parent)) {
                    const isTopLevel = isTopLevelNamespaceAssignment(declName.parent);
                    if (isTopLevel) {
                        bindPotentiallyMissingNamespaces(file.symbol, declName.parent, isTopLevel, !!findAncestor(declName, (d)=>isPropertyAccessExpression(d) && d.name.escapedText === "prototype"), /*containerIsClass*/ false);
                        const oldContainer = container;
                        switch(getAssignmentDeclarationPropertyAccessKind(declName.parent)){
                            case 1 /* ExportsProperty */ :
                            case 2 /* ModuleExports */ :
                                if (!isExternalOrCommonJsModule(file)) container = void 0;
                                else container = file;
                                break;
                            case 4 /* ThisProperty */ :
                                container = declName.parent.expression;
                                break;
                            case 3 /* PrototypeProperty */ :
                                container = declName.parent.expression.name;
                                break;
                            case 5 /* Property */ :
                                container = isExportsOrModuleExportsOrAlias(file, declName.parent.expression) ? file : isPropertyAccessExpression(declName.parent.expression) ? declName.parent.expression.name : declName.parent.expression;
                                break;
                            case 0 /* None */ :
                                return Debug.fail("Shouldn't have detected typedef or enum on non-assignment declaration");
                        }
                        if (container) declareModuleMember(typeAlias, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                        container = oldContainer;
                    }
                } else if (isJSDocEnumTag(typeAlias) || !typeAlias.fullName || typeAlias.fullName.kind === 80 /* Identifier */ ) {
                    parent2 = typeAlias.parent;
                    bindBlockScopedDeclaration(typeAlias, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                } else bind(typeAlias.fullName);
            }
            container = saveContainer;
            lastContainer = saveLastContainer;
            blockScopeContainer = saveBlockScopeContainer;
            parent2 = saveParent;
            currentFlow = saveCurrentFlow;
        }
        function bindJSDocImports() {
            if (jsDocImports === void 0) return;
            const saveContainer = container;
            const saveLastContainer = lastContainer;
            const saveBlockScopeContainer = blockScopeContainer;
            const saveParent = parent2;
            const saveCurrentFlow = currentFlow;
            for (const jsDocImportTag of jsDocImports){
                const host = getJSDocHost(jsDocImportTag);
                const enclosingContainer = host ? getEnclosingContainer(host) : void 0;
                const enclosingBlockScopeContainer = host ? getEnclosingBlockScopeContainer(host) : void 0;
                container = enclosingContainer || file;
                blockScopeContainer = enclosingBlockScopeContainer || file;
                currentFlow = createFlowNode(2 /* Start */ , /*node*/ void 0, /*antecedent*/ void 0);
                parent2 = jsDocImportTag;
                bind(jsDocImportTag.importClause);
            }
            container = saveContainer;
            lastContainer = saveLastContainer;
            blockScopeContainer = saveBlockScopeContainer;
            parent2 = saveParent;
            currentFlow = saveCurrentFlow;
        }
        function checkContextualIdentifier(node) {
            if (!file.parseDiagnostics.length && !(node.flags & 33554432 /* Ambient */ ) && !(node.flags & 16777216 /* JSDoc */ ) && !isIdentifierName(node)) {
                const originalKeywordKind = identifierToKeywordKind(node);
                if (originalKeywordKind === void 0) return;
                if (inStrictMode && originalKeywordKind >= 119 /* FirstFutureReservedWord */  && originalKeywordKind <= 127 /* LastFutureReservedWord */ ) file.bindDiagnostics.push(createDiagnosticForNode2(node, getStrictModeIdentifierMessage(node), declarationNameToString(node)));
                else if (originalKeywordKind === 135 /* AwaitKeyword */ ) {
                    if (isExternalModule(file) && isInTopLevelContext(node)) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module, declarationNameToString(node)));
                    else if (node.flags & 65536 /* AwaitContext */ ) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here, declarationNameToString(node)));
                } else if (originalKeywordKind === 127 /* YieldKeyword */  && node.flags & 16384 /* YieldContext */ ) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here, declarationNameToString(node)));
            }
        }
        function getStrictModeIdentifierMessage(node) {
            if (getContainingClass(node)) return Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode;
            if (file.externalModuleIndicator) return Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode;
            return Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode;
        }
        function checkPrivateIdentifier(node) {
            if (node.escapedText === "#constructor") {
                if (!file.parseDiagnostics.length) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.constructor_is_a_reserved_word, declarationNameToString(node)));
            }
        }
        function checkStrictModeBinaryExpression(node) {
            if (inStrictMode && isLeftHandSideExpression(node.left) && isAssignmentOperator(node.operatorToken.kind)) checkStrictModeEvalOrArguments(node, node.left);
        }
        function checkStrictModeCatchClause(node) {
            if (inStrictMode && node.variableDeclaration) checkStrictModeEvalOrArguments(node, node.variableDeclaration.name);
        }
        function checkStrictModeDeleteExpression(node) {
            if (inStrictMode && node.expression.kind === 80 /* Identifier */ ) {
                const span = getErrorSpanForNode(file, node.expression);
                file.bindDiagnostics.push(createFileDiagnostic(file, span.start, span.length, Diagnostics.delete_cannot_be_called_on_an_identifier_in_strict_mode));
            }
        }
        function isEvalOrArgumentsIdentifier(node) {
            return isIdentifier(node) && (node.escapedText === "eval" || node.escapedText === "arguments");
        }
        function checkStrictModeEvalOrArguments(contextNode, name) {
            if (name && name.kind === 80 /* Identifier */ ) {
                const identifier = name;
                if (isEvalOrArgumentsIdentifier(identifier)) {
                    const span = getErrorSpanForNode(file, name);
                    file.bindDiagnostics.push(createFileDiagnostic(file, span.start, span.length, getStrictModeEvalOrArgumentsMessage(contextNode), idText(identifier)));
                }
            }
        }
        function getStrictModeEvalOrArgumentsMessage(node) {
            if (getContainingClass(node)) return Diagnostics.Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of_0_For_more_information_see_https_Colon_Slash_Slashdeveloper_mozilla_org_Slashen_US_Slashdocs_SlashWeb_SlashJavaScript_SlashReference_SlashStrict_mode;
            if (file.externalModuleIndicator) return Diagnostics.Invalid_use_of_0_Modules_are_automatically_in_strict_mode;
            return Diagnostics.Invalid_use_of_0_in_strict_mode;
        }
        function checkStrictModeFunctionName(node) {
            if (inStrictMode && !(node.flags & 33554432 /* Ambient */ )) checkStrictModeEvalOrArguments(node, node.name);
        }
        function getStrictModeBlockScopeFunctionDeclarationMessage(node) {
            if (getContainingClass(node)) return Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_Class_definitions_are_automatically_in_strict_mode;
            if (file.externalModuleIndicator) return Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5_Modules_are_automatically_in_strict_mode;
            return Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES5;
        }
        function checkStrictModeFunctionDeclaration(node) {
            if (languageVersion < 2 /* ES2015 */ ) {
                if (blockScopeContainer.kind !== 308 /* SourceFile */  && blockScopeContainer.kind !== 268 /* ModuleDeclaration */  && !isFunctionLikeOrClassStaticBlockDeclaration(blockScopeContainer)) {
                    const errorSpan = getErrorSpanForNode(file, node);
                    file.bindDiagnostics.push(createFileDiagnostic(file, errorSpan.start, errorSpan.length, getStrictModeBlockScopeFunctionDeclarationMessage(node)));
                }
            }
        }
        function checkStrictModePostfixUnaryExpression(node) {
            if (inStrictMode) checkStrictModeEvalOrArguments(node, node.operand);
        }
        function checkStrictModePrefixUnaryExpression(node) {
            if (inStrictMode) {
                if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) checkStrictModeEvalOrArguments(node, node.operand);
            }
        }
        function checkStrictModeWithStatement(node) {
            if (inStrictMode) errorOnFirstToken(node, Diagnostics.with_statements_are_not_allowed_in_strict_mode);
        }
        function checkStrictModeLabeledStatement(node) {
            if (inStrictMode && getEmitScriptTarget(options) >= 2 /* ES2015 */ ) {
                if (isDeclarationStatement(node.statement) || isVariableStatement(node.statement)) errorOnFirstToken(node.label, Diagnostics.A_label_is_not_allowed_here);
            }
        }
        function errorOnFirstToken(node, message, ...args) {
            const span = getSpanOfTokenAtPosition(file, node.pos);
            file.bindDiagnostics.push(createFileDiagnostic(file, span.start, span.length, message, ...args));
        }
        function errorOrSuggestionOnNode(isError, node, message) {
            errorOrSuggestionOnRange(isError, node, node, message);
        }
        function errorOrSuggestionOnRange(isError, startNode2, endNode2, message) {
            addErrorOrSuggestionDiagnostic(isError, {
                pos: getTokenPosOfNode(startNode2, file),
                end: endNode2.end
            }, message);
        }
        function addErrorOrSuggestionDiagnostic(isError, range, message) {
            const diag2 = createFileDiagnostic(file, range.pos, range.end - range.pos, message);
            if (isError) file.bindDiagnostics.push(diag2);
            else file.bindSuggestionDiagnostics = append(file.bindSuggestionDiagnostics, (0, _objectSpreadProps._)((0, _objectSpread._)({}, diag2), {
                category: 2 /* Suggestion */ 
            }));
        }
        function bind(node) {
            if (!node) return;
            setParent(node, parent2);
            if (tracing) node.tracingPath = file.path;
            const saveInStrictMode = inStrictMode;
            bindWorker(node);
            if (node.kind > 166 /* LastToken */ ) {
                const saveParent = parent2;
                parent2 = node;
                const containerFlags = getContainerFlags(node);
                if (containerFlags === 0 /* None */ ) bindChildren(node);
                else bindContainer(node, containerFlags);
                parent2 = saveParent;
            } else {
                const saveParent = parent2;
                if (node.kind === 1 /* EndOfFileToken */ ) parent2 = node;
                bindJSDoc(node);
                parent2 = saveParent;
            }
            inStrictMode = saveInStrictMode;
        }
        function bindJSDoc(node) {
            if (hasJSDocNodes(node)) {
                if (isInJSFile(node)) for (const j of node.jsDoc)bind(j);
                else for (const j of node.jsDoc){
                    setParent(j, node);
                    setParentRecursive(j, /*incremental*/ false);
                }
            }
        }
        function updateStrictModeStatementList(statements) {
            if (!inStrictMode) for (const statement of statements){
                if (!isPrologueDirective(statement)) return;
                if (isUseStrictPrologueDirective(statement)) {
                    inStrictMode = true;
                    return;
                }
            }
        }
        function isUseStrictPrologueDirective(node) {
            const nodeText2 = getSourceTextOfNodeFromSourceFile(file, node.expression);
            return nodeText2 === '"use strict"' || nodeText2 === "'use strict'";
        }
        function bindWorker(node) {
            switch(node.kind){
                /* Strict mode checks */ case 80 /* Identifier */ :
                    if (node.flags & 4096 /* IdentifierIsInJSDocNamespace */ ) {
                        let parentNode = node.parent;
                        while(parentNode && !isJSDocTypeAlias(parentNode))parentNode = parentNode.parent;
                        bindBlockScopedDeclaration(parentNode, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                        break;
                    }
                // falls through
                case 110 /* ThisKeyword */ :
                    if (currentFlow && (isExpression(node) || parent2.kind === 305 /* ShorthandPropertyAssignment */ )) node.flowNode = currentFlow;
                    return checkContextualIdentifier(node);
                case 167 /* QualifiedName */ :
                    if (currentFlow && isPartOfTypeQuery(node)) node.flowNode = currentFlow;
                    break;
                case 237 /* MetaProperty */ :
                case 108 /* SuperKeyword */ :
                    node.flowNode = currentFlow;
                    break;
                case 81 /* PrivateIdentifier */ :
                    return checkPrivateIdentifier(node);
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    const expr = node;
                    if (currentFlow && isNarrowableReference(expr)) expr.flowNode = currentFlow;
                    if (isSpecialPropertyDeclaration(expr)) bindSpecialPropertyDeclaration(expr);
                    if (isInJSFile(expr) && file.commonJsModuleIndicator && isModuleExportsAccessExpression(expr) && !lookupSymbolForName(blockScopeContainer, "module")) declareSymbol(file.locals, /*parent*/ void 0, expr.expression, 134217729 /* ModuleExports */ , 111550 /* FunctionScopedVariableExcludes */ );
                    break;
                case 227 /* BinaryExpression */ :
                    const specialKind = getAssignmentDeclarationKind(node);
                    switch(specialKind){
                        case 1 /* ExportsProperty */ :
                            bindExportsPropertyAssignment(node);
                            break;
                        case 2 /* ModuleExports */ :
                            bindModuleExportsAssignment(node);
                            break;
                        case 3 /* PrototypeProperty */ :
                            bindPrototypePropertyAssignment(node.left, node);
                            break;
                        case 6 /* Prototype */ :
                            bindPrototypeAssignment(node);
                            break;
                        case 4 /* ThisProperty */ :
                            bindThisPropertyAssignment(node);
                            break;
                        case 5 /* Property */ :
                            const expression = node.left.expression;
                            if (isInJSFile(node) && isIdentifier(expression)) {
                                const symbol = lookupSymbolForName(blockScopeContainer, expression.escapedText);
                                if (isThisInitializedDeclaration(symbol == null ? void 0 : symbol.valueDeclaration)) {
                                    bindThisPropertyAssignment(node);
                                    break;
                                }
                            }
                            bindSpecialPropertyAssignment(node);
                            break;
                        case 0 /* None */ :
                            break;
                        default:
                            Debug.fail("Unknown binary expression special property assignment kind");
                    }
                    return checkStrictModeBinaryExpression(node);
                case 300 /* CatchClause */ :
                    return checkStrictModeCatchClause(node);
                case 221 /* DeleteExpression */ :
                    return checkStrictModeDeleteExpression(node);
                case 226 /* PostfixUnaryExpression */ :
                    return checkStrictModePostfixUnaryExpression(node);
                case 225 /* PrefixUnaryExpression */ :
                    return checkStrictModePrefixUnaryExpression(node);
                case 255 /* WithStatement */ :
                    return checkStrictModeWithStatement(node);
                case 257 /* LabeledStatement */ :
                    return checkStrictModeLabeledStatement(node);
                case 198 /* ThisType */ :
                    seenThisKeyword = true;
                    return;
                case 183 /* TypePredicate */ :
                    break;
                // Binding the children will handle everything
                case 169 /* TypeParameter */ :
                    return bindTypeParameter(node);
                case 170 /* Parameter */ :
                    return bindParameter(node);
                case 261 /* VariableDeclaration */ :
                    return bindVariableDeclarationOrBindingElement(node);
                case 209 /* BindingElement */ :
                    node.flowNode = currentFlow;
                    return bindVariableDeclarationOrBindingElement(node);
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                    return bindPropertyWorker(node);
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                    return bindPropertyOrMethodOrAccessor(node, 4 /* Property */ , 0 /* PropertyExcludes */ );
                case 307 /* EnumMember */ :
                    return bindPropertyOrMethodOrAccessor(node, 8 /* EnumMember */ , 900095 /* EnumMemberExcludes */ );
                case 180 /* CallSignature */ :
                case 181 /* ConstructSignature */ :
                case 182 /* IndexSignature */ :
                    return declareSymbolAndAddToSymbolTable(node, 131072 /* Signature */ , 0 /* None */ );
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    return bindPropertyOrMethodOrAccessor(node, 8192 /* Method */  | (node.questionToken ? 16777216 /* Optional */  : 0 /* None */ ), isObjectLiteralMethod(node) ? 0 /* PropertyExcludes */  : 103359 /* MethodExcludes */ );
                case 263 /* FunctionDeclaration */ :
                    return bindFunctionDeclaration(node);
                case 177 /* Constructor */ :
                    return declareSymbolAndAddToSymbolTable(node, 16384 /* Constructor */ , /*symbolExcludes:*/ 0 /* None */ );
                case 178 /* GetAccessor */ :
                    return bindPropertyOrMethodOrAccessor(node, 32768 /* GetAccessor */ , 46015 /* GetAccessorExcludes */ );
                case 179 /* SetAccessor */ :
                    return bindPropertyOrMethodOrAccessor(node, 65536 /* SetAccessor */ , 78783 /* SetAccessorExcludes */ );
                case 185 /* FunctionType */ :
                case 318 /* JSDocFunctionType */ :
                case 324 /* JSDocSignature */ :
                case 186 /* ConstructorType */ :
                    return bindFunctionOrConstructorType(node);
                case 188 /* TypeLiteral */ :
                case 323 /* JSDocTypeLiteral */ :
                case 201 /* MappedType */ :
                    return bindAnonymousTypeWorker(node);
                case 333 /* JSDocClassTag */ :
                    return bindJSDocClassTag(node);
                case 211 /* ObjectLiteralExpression */ :
                    return bindObjectLiteralExpression(node);
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    return bindFunctionExpression(node);
                case 214 /* CallExpression */ :
                    const assignmentKind = getAssignmentDeclarationKind(node);
                    switch(assignmentKind){
                        case 7 /* ObjectDefinePropertyValue */ :
                            return bindObjectDefinePropertyAssignment(node);
                        case 8 /* ObjectDefinePropertyExports */ :
                            return bindObjectDefinePropertyExport(node);
                        case 9 /* ObjectDefinePrototypeProperty */ :
                            return bindObjectDefinePrototypeProperty(node);
                        case 0 /* None */ :
                            break;
                        // Nothing to do
                        default:
                            return Debug.fail("Unknown call expression assignment declaration kind");
                    }
                    if (isInJSFile(node)) bindCallExpression(node);
                    break;
                // Members of classes, interfaces, and modules
                case 232 /* ClassExpression */ :
                case 264 /* ClassDeclaration */ :
                    inStrictMode = true;
                    return bindClassLikeDeclaration(node);
                case 265 /* InterfaceDeclaration */ :
                    return bindBlockScopedDeclaration(node, 64 /* Interface */ , 788872 /* InterfaceExcludes */ );
                case 266 /* TypeAliasDeclaration */ :
                    return bindBlockScopedDeclaration(node, 524288 /* TypeAlias */ , 788968 /* TypeAliasExcludes */ );
                case 267 /* EnumDeclaration */ :
                    return bindEnumDeclaration(node);
                case 268 /* ModuleDeclaration */ :
                    return bindModuleDeclaration(node);
                // Jsx-attributes
                case 293 /* JsxAttributes */ :
                    return bindJsxAttributes(node);
                case 292 /* JsxAttribute */ :
                    return bindJsxAttribute(node, 4 /* Property */ , 0 /* PropertyExcludes */ );
                // Imports and exports
                case 272 /* ImportEqualsDeclaration */ :
                case 275 /* NamespaceImport */ :
                case 277 /* ImportSpecifier */ :
                case 282 /* ExportSpecifier */ :
                    return declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
                case 271 /* NamespaceExportDeclaration */ :
                    return bindNamespaceExportDeclaration(node);
                case 274 /* ImportClause */ :
                    return bindImportClause(node);
                case 279 /* ExportDeclaration */ :
                    return bindExportDeclaration(node);
                case 278 /* ExportAssignment */ :
                    return bindExportAssignment(node);
                case 308 /* SourceFile */ :
                    updateStrictModeStatementList(node.statements);
                    return bindSourceFileIfExternalModule();
                case 242 /* Block */ :
                    if (!isFunctionLikeOrClassStaticBlockDeclaration(node.parent)) return;
                // falls through
                case 269 /* ModuleBlock */ :
                    return updateStrictModeStatementList(node.statements);
                case 342 /* JSDocParameterTag */ :
                    if (node.parent.kind === 324 /* JSDocSignature */ ) return bindParameter(node);
                    if (node.parent.kind !== 323 /* JSDocTypeLiteral */ ) break;
                // falls through
                case 349 /* JSDocPropertyTag */ :
                    const propTag = node;
                    const flags = propTag.isBracketed || propTag.typeExpression && propTag.typeExpression.type.kind === 317 /* JSDocOptionalType */  ? 16777220 /* Optional */  : 4 /* Property */ ;
                    return declareSymbolAndAddToSymbolTable(propTag, flags, 0 /* PropertyExcludes */ );
                case 347 /* JSDocTypedefTag */ :
                case 339 /* JSDocCallbackTag */ :
                case 341 /* JSDocEnumTag */ :
                    return (delayedTypeAliases || (delayedTypeAliases = [])).push(node);
                case 340 /* JSDocOverloadTag */ :
                    return bind(node.typeExpression);
                case 352 /* JSDocImportTag */ :
                    return (jsDocImports || (jsDocImports = [])).push(node);
            }
        }
        function bindPropertyWorker(node) {
            const isAutoAccessor = isAutoAccessorPropertyDeclaration(node);
            const includes = isAutoAccessor ? 98304 /* Accessor */  : 4 /* Property */ ;
            const excludes = isAutoAccessor ? 13247 /* AccessorExcludes */  : 0 /* PropertyExcludes */ ;
            return bindPropertyOrMethodOrAccessor(node, includes | (node.questionToken ? 16777216 /* Optional */  : 0 /* None */ ), excludes);
        }
        function bindAnonymousTypeWorker(node) {
            return bindAnonymousDeclaration(node, 2048 /* TypeLiteral */ , "__type" /* Type */ );
        }
        function bindSourceFileIfExternalModule() {
            setExportContextFlag(file);
            if (isExternalModule(file)) bindSourceFileAsExternalModule();
            else if (isJsonSourceFile(file)) {
                bindSourceFileAsExternalModule();
                const originalSymbol = file.symbol;
                declareSymbol(file.symbol.exports, file.symbol, file, 4 /* Property */ , -1 /* All */ );
                file.symbol = originalSymbol;
            }
        }
        function bindSourceFileAsExternalModule() {
            bindAnonymousDeclaration(file, 512 /* ValueModule */ , `"${removeFileExtension(file.fileName)}"`);
        }
        function bindExportAssignment(node) {
            if (!container.symbol || !container.symbol.exports) bindAnonymousDeclaration(node, 111551 /* Value */ , getDeclarationName(node));
            else {
                const flags = exportAssignmentIsAlias(node) ? 2097152 /* Alias */  : 4 /* Property */ ;
                const symbol = declareSymbol(container.symbol.exports, container.symbol, node, flags, -1 /* All */ );
                if (node.isExportEquals) setValueDeclaration(symbol, node);
            }
        }
        function bindNamespaceExportDeclaration(node) {
            if (some(node.modifiers)) file.bindDiagnostics.push(createDiagnosticForNode2(node, Diagnostics.Modifiers_cannot_appear_here));
            const diag2 = !isSourceFile(node.parent) ? Diagnostics.Global_module_exports_may_only_appear_at_top_level : !isExternalModule(node.parent) ? Diagnostics.Global_module_exports_may_only_appear_in_module_files : !node.parent.isDeclarationFile ? Diagnostics.Global_module_exports_may_only_appear_in_declaration_files : void 0;
            if (diag2) file.bindDiagnostics.push(createDiagnosticForNode2(node, diag2));
            else {
                file.symbol.globalExports = file.symbol.globalExports || createSymbolTable();
                declareSymbol(file.symbol.globalExports, file.symbol, node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
            }
        }
        function bindExportDeclaration(node) {
            if (!container.symbol || !container.symbol.exports) bindAnonymousDeclaration(node, 8388608 /* ExportStar */ , getDeclarationName(node));
            else if (!node.exportClause) declareSymbol(container.symbol.exports, container.symbol, node, 8388608 /* ExportStar */ , 0 /* None */ );
            else if (isNamespaceExport(node.exportClause)) {
                setParent(node.exportClause, node);
                declareSymbol(container.symbol.exports, container.symbol, node.exportClause, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
            }
        }
        function bindImportClause(node) {
            if (node.name) declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
        }
        function setCommonJsModuleIndicator(node) {
            if (file.externalModuleIndicator && file.externalModuleIndicator !== true) return false;
            if (!file.commonJsModuleIndicator) {
                file.commonJsModuleIndicator = node;
                if (!file.externalModuleIndicator) bindSourceFileAsExternalModule();
            }
            return true;
        }
        function bindObjectDefinePropertyExport(node) {
            if (!setCommonJsModuleIndicator(node)) return;
            const symbol = forEachIdentifierInEntityName(node.arguments[0], /*parent*/ void 0, (id, symbol2)=>{
                if (symbol2) addDeclarationToSymbol(symbol2, id, 67110400 /* Assignment */ );
                return symbol2;
            });
            if (symbol) {
                const flags = 1048580 /* ExportValue */ ;
                declareSymbol(symbol.exports, symbol, node, flags, 0 /* None */ );
            }
        }
        function bindExportsPropertyAssignment(node) {
            if (!setCommonJsModuleIndicator(node)) return;
            const symbol = forEachIdentifierInEntityName(node.left.expression, /*parent*/ void 0, (id, symbol2)=>{
                if (symbol2) addDeclarationToSymbol(symbol2, id, 67110400 /* Assignment */ );
                return symbol2;
            });
            if (symbol) {
                const isAlias = isAliasableExpression(node.right) && (isExportsIdentifier(node.left.expression) || isModuleExportsAccessExpression(node.left.expression));
                const flags = isAlias ? 2097152 /* Alias */  : 1048580 /* ExportValue */ ;
                setParent(node.left, node);
                declareSymbol(symbol.exports, symbol, node.left, flags, 0 /* None */ );
            }
        }
        function bindModuleExportsAssignment(node) {
            if (!setCommonJsModuleIndicator(node)) return;
            const assignedExpression = getRightMostAssignedExpression(node.right);
            if (isEmptyObjectLiteral(assignedExpression) || container === file && isExportsOrModuleExportsOrAlias(file, assignedExpression)) return;
            if (isObjectLiteralExpression(assignedExpression) && every(assignedExpression.properties, isShorthandPropertyAssignment)) {
                forEach(assignedExpression.properties, bindExportAssignedObjectMemberAlias);
                return;
            }
            const flags = exportAssignmentIsAlias(node) ? 2097152 /* Alias */  : 1049092 /* ValueModule */ ;
            const symbol = declareSymbol(file.symbol.exports, file.symbol, node, flags | 67108864 /* Assignment */ , 0 /* None */ );
            setValueDeclaration(symbol, node);
        }
        function bindExportAssignedObjectMemberAlias(node) {
            declareSymbol(file.symbol.exports, file.symbol, node, 69206016 /* Assignment */ , 0 /* None */ );
        }
        function bindThisPropertyAssignment(node) {
            Debug.assert(isInJSFile(node));
            const hasPrivateIdentifier = isBinaryExpression(node) && isPropertyAccessExpression(node.left) && isPrivateIdentifier(node.left.name) || isPropertyAccessExpression(node) && isPrivateIdentifier(node.name);
            if (hasPrivateIdentifier) return;
            const thisContainer = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            switch(thisContainer.kind){
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                    let constructorSymbol = thisContainer.symbol;
                    if (isBinaryExpression(thisContainer.parent) && thisContainer.parent.operatorToken.kind === 64 /* EqualsToken */ ) {
                        const l = thisContainer.parent.left;
                        if (isBindableStaticAccessExpression(l) && isPrototypeAccess(l.expression)) constructorSymbol = lookupSymbolForPropertyAccess(l.expression.expression, thisParentContainer);
                    }
                    if (constructorSymbol && constructorSymbol.valueDeclaration) {
                        constructorSymbol.members = constructorSymbol.members || createSymbolTable();
                        if (hasDynamicName(node)) bindDynamicallyNamedThisPropertyAssignment(node, constructorSymbol, constructorSymbol.members);
                        else declareSymbol(constructorSymbol.members, constructorSymbol, node, 67108868 /* Assignment */ , 0 /* Property */ );
                        addDeclarationToSymbol(constructorSymbol, constructorSymbol.valueDeclaration, 32 /* Class */ );
                    }
                    break;
                case 177 /* Constructor */ :
                case 173 /* PropertyDeclaration */ :
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    const containingClass = thisContainer.parent;
                    const symbolTable = isStatic(thisContainer) ? containingClass.symbol.exports : containingClass.symbol.members;
                    if (hasDynamicName(node)) bindDynamicallyNamedThisPropertyAssignment(node, containingClass.symbol, symbolTable);
                    else declareSymbol(symbolTable, containingClass.symbol, node, 67108868 /* Assignment */ , 0 /* None */ , /*isReplaceableByMethod*/ true);
                    break;
                case 308 /* SourceFile */ :
                    if (hasDynamicName(node)) break;
                    else if (thisContainer.commonJsModuleIndicator) declareSymbol(thisContainer.symbol.exports, thisContainer.symbol, node, 1048580 /* ExportValue */ , 0 /* None */ );
                    else declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111550 /* FunctionScopedVariableExcludes */ );
                    break;
                // Namespaces are not allowed in javascript files, so do nothing here
                case 268 /* ModuleDeclaration */ :
                    break;
                default:
                    Debug.failBadSyntaxKind(thisContainer);
            }
        }
        function bindDynamicallyNamedThisPropertyAssignment(node, symbol, symbolTable) {
            declareSymbol(symbolTable, symbol, node, 4 /* Property */ , 0 /* None */ , /*isReplaceableByMethod*/ true, /*isComputedName*/ true);
            addLateBoundAssignmentDeclarationToSymbol(node, symbol);
        }
        function addLateBoundAssignmentDeclarationToSymbol(node, symbol) {
            if (symbol) (symbol.assignmentDeclarationMembers || (symbol.assignmentDeclarationMembers = /* @__PURE__ */ new Map())).set(getNodeId(node), node);
        }
        function bindSpecialPropertyDeclaration(node) {
            if (node.expression.kind === 110 /* ThisKeyword */ ) bindThisPropertyAssignment(node);
            else if (isBindableStaticAccessExpression(node) && node.parent.parent.kind === 308 /* SourceFile */ ) {
                if (isPrototypeAccess(node.expression)) bindPrototypePropertyAssignment(node, node.parent);
                else bindStaticPropertyAssignment(node);
            }
        }
        function bindPrototypeAssignment(node) {
            setParent(node.left, node);
            setParent(node.right, node);
            bindPropertyAssignment(node.left.expression, node.left, /*isPrototypeProperty*/ false, /*containerIsClass*/ true);
        }
        function bindObjectDefinePrototypeProperty(node) {
            const namespaceSymbol = lookupSymbolForPropertyAccess(node.arguments[0].expression);
            if (namespaceSymbol && namespaceSymbol.valueDeclaration) addDeclarationToSymbol(namespaceSymbol, namespaceSymbol.valueDeclaration, 32 /* Class */ );
            bindPotentiallyNewExpandoMemberToNamespace(node, namespaceSymbol, /*isPrototypeProperty*/ true);
        }
        function bindPrototypePropertyAssignment(lhs, parent3) {
            const classPrototype = lhs.expression;
            const constructorFunction = classPrototype.expression;
            setParent(constructorFunction, classPrototype);
            setParent(classPrototype, lhs);
            setParent(lhs, parent3);
            bindPropertyAssignment(constructorFunction, lhs, /*isPrototypeProperty*/ true, /*containerIsClass*/ true);
        }
        function bindObjectDefinePropertyAssignment(node) {
            let namespaceSymbol = lookupSymbolForPropertyAccess(node.arguments[0]);
            const isToplevel = node.parent.parent.kind === 308 /* SourceFile */ ;
            namespaceSymbol = bindPotentiallyMissingNamespaces(namespaceSymbol, node.arguments[0], isToplevel, /*isPrototypeProperty*/ false, /*containerIsClass*/ false);
            bindPotentiallyNewExpandoMemberToNamespace(node, namespaceSymbol, /*isPrototypeProperty*/ false);
        }
        function bindSpecialPropertyAssignment(node) {
            var _a;
            const parentSymbol = lookupSymbolForPropertyAccess(node.left.expression, blockScopeContainer) || lookupSymbolForPropertyAccess(node.left.expression, container);
            if (!isInJSFile(node) && !isFunctionSymbol(parentSymbol)) return;
            const rootExpr = getLeftmostAccessExpression(node.left);
            if (isIdentifier(rootExpr) && ((_a = lookupSymbolForName(container, rootExpr.escapedText)) == null ? void 0 : _a.flags) & 2097152 /* Alias */ ) return;
            setParent(node.left, node);
            setParent(node.right, node);
            if (isIdentifier(node.left.expression) && container === file && isExportsOrModuleExportsOrAlias(file, node.left.expression)) bindExportsPropertyAssignment(node);
            else if (hasDynamicName(node)) {
                bindAnonymousDeclaration(node, 67108868 /* Assignment */ , "__computed" /* Computed */ );
                const sym = bindPotentiallyMissingNamespaces(parentSymbol, node.left.expression, isTopLevelNamespaceAssignment(node.left), /*isPrototypeProperty*/ false, /*containerIsClass*/ false);
                addLateBoundAssignmentDeclarationToSymbol(node, sym);
            } else bindStaticPropertyAssignment(cast(node.left, isBindableStaticNameExpression));
        }
        function bindStaticPropertyAssignment(node) {
            Debug.assert(!isIdentifier(node));
            setParent(node.expression, node);
            bindPropertyAssignment(node.expression, node, /*isPrototypeProperty*/ false, /*containerIsClass*/ false);
        }
        function bindPotentiallyMissingNamespaces(namespaceSymbol, entityName, isToplevel, isPrototypeProperty, containerIsClass) {
            if ((namespaceSymbol == null ? void 0 : namespaceSymbol.flags) & 2097152 /* Alias */ ) return namespaceSymbol;
            if (isToplevel && !isPrototypeProperty) {
                const flags = 67110400 /* Assignment */ ;
                const excludeFlags = 110735 /* Assignment */ ;
                namespaceSymbol = forEachIdentifierInEntityName(entityName, namespaceSymbol, (id, symbol, parent3)=>{
                    if (symbol) {
                        addDeclarationToSymbol(symbol, id, flags);
                        return symbol;
                    } else {
                        const table = parent3 ? parent3.exports : file.jsGlobalAugmentations || (file.jsGlobalAugmentations = createSymbolTable());
                        return declareSymbol(table, parent3, id, flags, excludeFlags);
                    }
                });
            }
            if (containerIsClass && namespaceSymbol && namespaceSymbol.valueDeclaration) addDeclarationToSymbol(namespaceSymbol, namespaceSymbol.valueDeclaration, 32 /* Class */ );
            return namespaceSymbol;
        }
        function bindPotentiallyNewExpandoMemberToNamespace(declaration, namespaceSymbol, isPrototypeProperty) {
            if (!namespaceSymbol || !isExpandoSymbol(namespaceSymbol)) return;
            const symbolTable = isPrototypeProperty ? namespaceSymbol.members || (namespaceSymbol.members = createSymbolTable()) : namespaceSymbol.exports || (namespaceSymbol.exports = createSymbolTable());
            let includes = 0 /* None */ ;
            let excludes = 0 /* None */ ;
            if (isFunctionLikeDeclaration(getAssignedExpandoInitializer(declaration))) {
                includes = 8192 /* Method */ ;
                excludes = 103359 /* MethodExcludes */ ;
            } else if (isCallExpression(declaration) && isBindableObjectDefinePropertyCall(declaration)) {
                if (some(declaration.arguments[2].properties, (p)=>{
                    const id = getNameOfDeclaration(p);
                    return !!id && isIdentifier(id) && idText(id) === "set";
                })) {
                    includes |= 65540 /* Property */ ;
                    excludes |= 78783 /* SetAccessorExcludes */ ;
                }
                if (some(declaration.arguments[2].properties, (p)=>{
                    const id = getNameOfDeclaration(p);
                    return !!id && isIdentifier(id) && idText(id) === "get";
                })) {
                    includes |= 32772 /* Property */ ;
                    excludes |= 46015 /* GetAccessorExcludes */ ;
                }
            }
            if (includes === 0 /* None */ ) {
                includes = 4 /* Property */ ;
                excludes = 0 /* PropertyExcludes */ ;
            }
            declareSymbol(symbolTable, namespaceSymbol, declaration, includes | 67108864 /* Assignment */ , excludes & -67108865 /* Assignment */ );
        }
        function isTopLevelNamespaceAssignment(propertyAccess) {
            return isBinaryExpression(propertyAccess.parent) ? getParentOfBinaryExpression(propertyAccess.parent).parent.kind === 308 /* SourceFile */  : propertyAccess.parent.parent.kind === 308 /* SourceFile */ ;
        }
        function bindPropertyAssignment(name, propertyAccess, isPrototypeProperty, containerIsClass) {
            let namespaceSymbol = lookupSymbolForPropertyAccess(name, blockScopeContainer) || lookupSymbolForPropertyAccess(name, container);
            const isToplevel = isTopLevelNamespaceAssignment(propertyAccess);
            namespaceSymbol = bindPotentiallyMissingNamespaces(namespaceSymbol, propertyAccess.expression, isToplevel, isPrototypeProperty, containerIsClass);
            bindPotentiallyNewExpandoMemberToNamespace(propertyAccess, namespaceSymbol, isPrototypeProperty);
        }
        function isExpandoSymbol(symbol) {
            if (symbol.flags & 1072 /* NamespaceModule */ ) return true;
            const node = symbol.valueDeclaration;
            if (node && isCallExpression(node)) return !!getAssignedExpandoInitializer(node);
            let init = !node ? void 0 : isVariableDeclaration(node) ? node.initializer : isBinaryExpression(node) ? node.right : isPropertyAccessExpression(node) && isBinaryExpression(node.parent) ? node.parent.right : void 0;
            init = init && getRightMostAssignedExpression(init);
            if (init) {
                const isPrototypeAssignment = isPrototypeAccess(isVariableDeclaration(node) ? node.name : isBinaryExpression(node) ? node.left : node);
                return !!getExpandoInitializer(isBinaryExpression(init) && (init.operatorToken.kind === 57 /* BarBarToken */  || init.operatorToken.kind === 61 /* QuestionQuestionToken */ ) ? init.right : init, isPrototypeAssignment);
            }
            return false;
        }
        function getParentOfBinaryExpression(expr) {
            while(isBinaryExpression(expr.parent))expr = expr.parent;
            return expr.parent;
        }
        function lookupSymbolForPropertyAccess(node, lookupContainer = container) {
            if (isIdentifier(node)) return lookupSymbolForName(lookupContainer, node.escapedText);
            else {
                const symbol = lookupSymbolForPropertyAccess(node.expression);
                return symbol && symbol.exports && symbol.exports.get(getElementOrPropertyAccessName(node));
            }
        }
        function forEachIdentifierInEntityName(e, parent3, action) {
            if (isExportsOrModuleExportsOrAlias(file, e)) return file.symbol;
            else if (isIdentifier(e)) return action(e, lookupSymbolForPropertyAccess(e), parent3);
            else {
                const s = forEachIdentifierInEntityName(e.expression, parent3, action);
                const name = getNameOrArgument(e);
                if (isPrivateIdentifier(name)) Debug.fail("unexpected PrivateIdentifier");
                return action(name, s && s.exports && s.exports.get(getElementOrPropertyAccessName(e)), s);
            }
        }
        function bindCallExpression(node) {
            if (!file.commonJsModuleIndicator && isRequireCall(node, /*requireStringLiteralLikeArgument*/ false)) setCommonJsModuleIndicator(node);
        }
        function bindClassLikeDeclaration(node) {
            if (node.kind === 264 /* ClassDeclaration */ ) bindBlockScopedDeclaration(node, 32 /* Class */ , 899503 /* ClassExcludes */ );
            else {
                const bindingName = node.name ? node.name.escapedText : "__class" /* Class */ ;
                bindAnonymousDeclaration(node, 32 /* Class */ , bindingName);
                if (node.name) classifiableNames.add(node.name.escapedText);
            }
            const { symbol } = node;
            const prototypeSymbol = createSymbol(4194308 /* Prototype */ , "prototype");
            const symbolExport = symbol.exports.get(prototypeSymbol.escapedName);
            if (symbolExport) {
                if (node.name) setParent(node.name, node);
                file.bindDiagnostics.push(createDiagnosticForNode2(symbolExport.declarations[0], Diagnostics.Duplicate_identifier_0, symbolName(prototypeSymbol)));
            }
            symbol.exports.set(prototypeSymbol.escapedName, prototypeSymbol);
            prototypeSymbol.parent = symbol;
        }
        function bindEnumDeclaration(node) {
            return isEnumConst(node) ? bindBlockScopedDeclaration(node, 128 /* ConstEnum */ , 899967 /* ConstEnumExcludes */ ) : bindBlockScopedDeclaration(node, 256 /* RegularEnum */ , 899327 /* RegularEnumExcludes */ );
        }
        function bindVariableDeclarationOrBindingElement(node) {
            if (inStrictMode) checkStrictModeEvalOrArguments(node, node.name);
            if (!isBindingPattern(node.name)) {
                const possibleVariableDecl = node.kind === 261 /* VariableDeclaration */  ? node : node.parent.parent;
                if (isInJSFile(node) && isVariableDeclarationInitializedToBareOrAccessedRequire(possibleVariableDecl) && !getJSDocTypeTag(node) && !(getCombinedModifierFlags(node) & 32 /* Export */ )) declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */ , 2097152 /* AliasExcludes */ );
                else if (isBlockOrCatchScoped(node)) bindBlockScopedDeclaration(node, 2 /* BlockScopedVariable */ , 111551 /* BlockScopedVariableExcludes */ );
                else if (isPartOfParameterDeclaration(node)) declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111551 /* ParameterExcludes */ );
                else declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111550 /* FunctionScopedVariableExcludes */ );
            }
        }
        function bindParameter(node) {
            if (node.kind === 342 /* JSDocParameterTag */  && container.kind !== 324 /* JSDocSignature */ ) return;
            if (inStrictMode && !(node.flags & 33554432 /* Ambient */ )) checkStrictModeEvalOrArguments(node, node.name);
            if (isBindingPattern(node.name)) bindAnonymousDeclaration(node, 1 /* FunctionScopedVariable */ , "__" + node.parent.parameters.indexOf(node));
            else declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */ , 111551 /* ParameterExcludes */ );
            if (isParameterPropertyDeclaration(node, node.parent)) {
                const classDeclaration = node.parent.parent;
                declareSymbol(classDeclaration.symbol.members, classDeclaration.symbol, node, 4 /* Property */  | (node.questionToken ? 16777216 /* Optional */  : 0 /* None */ ), 0 /* PropertyExcludes */ );
            }
        }
        function bindFunctionDeclaration(node) {
            if (!file.isDeclarationFile && !(node.flags & 33554432 /* Ambient */ )) {
                if (isAsyncFunction(node)) emitFlags |= 4096 /* HasAsyncFunctions */ ;
            }
            checkStrictModeFunctionName(node);
            if (inStrictMode) {
                checkStrictModeFunctionDeclaration(node);
                bindBlockScopedDeclaration(node, 16 /* Function */ , 110991 /* FunctionExcludes */ );
            } else declareSymbolAndAddToSymbolTable(node, 16 /* Function */ , 110991 /* FunctionExcludes */ );
        }
        function bindFunctionExpression(node) {
            if (!file.isDeclarationFile && !(node.flags & 33554432 /* Ambient */ )) {
                if (isAsyncFunction(node)) emitFlags |= 4096 /* HasAsyncFunctions */ ;
            }
            if (currentFlow) node.flowNode = currentFlow;
            checkStrictModeFunctionName(node);
            const bindingName = node.name ? node.name.escapedText : "__function" /* Function */ ;
            return bindAnonymousDeclaration(node, 16 /* Function */ , bindingName);
        }
        function bindPropertyOrMethodOrAccessor(node, symbolFlags, symbolExcludes) {
            if (!file.isDeclarationFile && !(node.flags & 33554432 /* Ambient */ ) && isAsyncFunction(node)) emitFlags |= 4096 /* HasAsyncFunctions */ ;
            if (currentFlow && isObjectLiteralOrClassExpressionMethodOrAccessor(node)) node.flowNode = currentFlow;
            return hasDynamicName(node) ? bindAnonymousDeclaration(node, symbolFlags, "__computed" /* Computed */ ) : declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
        }
        function getInferTypeContainer(node) {
            const extendsType = findAncestor(node, (n)=>n.parent && isConditionalTypeNode(n.parent) && n.parent.extendsType === n);
            return extendsType && extendsType.parent;
        }
        function bindTypeParameter(node) {
            if (isJSDocTemplateTag(node.parent)) {
                const container2 = getEffectiveContainerForJSDocTemplateTag(node.parent);
                if (container2) {
                    Debug.assertNode(container2, canHaveLocals);
                    var _container2_locals;
                    (_container2_locals = container2.locals) !== null && _container2_locals !== void 0 ? _container2_locals : container2.locals = createSymbolTable();
                    declareSymbol(container2.locals, /*parent*/ void 0, node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
                } else declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
            } else if (node.parent.kind === 196 /* InferType */ ) {
                const container2 = getInferTypeContainer(node.parent);
                if (container2) {
                    Debug.assertNode(container2, canHaveLocals);
                    var _container2_locals1;
                    (_container2_locals1 = container2.locals) !== null && _container2_locals1 !== void 0 ? _container2_locals1 : container2.locals = createSymbolTable();
                    declareSymbol(container2.locals, /*parent*/ void 0, node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
                } else bindAnonymousDeclaration(node, 262144 /* TypeParameter */ , getDeclarationName(node));
            } else declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */ , 526824 /* TypeParameterExcludes */ );
        }
        function shouldReportErrorOnModuleDeclaration(node) {
            const instanceState = getModuleInstanceState(node);
            return instanceState === 1 /* Instantiated */  || instanceState === 2 /* ConstEnumOnly */  && shouldPreserveConstEnums(options);
        }
        function checkUnreachable(node) {
            if (!(currentFlow.flags & 1 /* Unreachable */ )) return false;
            if (currentFlow === unreachableFlow) {
                const reportError = // report error on all statements except empty ones
                isStatementButNotDeclaration(node) && node.kind !== 243 /* EmptyStatement */  || // report error on class declarations
                node.kind === 264 /* ClassDeclaration */  || // report errors on enums with preserved emit
                isEnumDeclarationWithPreservedEmit(node, options) || // report error on instantiated modules
                node.kind === 268 /* ModuleDeclaration */  && shouldReportErrorOnModuleDeclaration(node);
                if (reportError) {
                    currentFlow = reportedUnreachableFlow;
                    if (!options.allowUnreachableCode) {
                        const isError = unreachableCodeIsError(options) && !(node.flags & 33554432 /* Ambient */ ) && (!isVariableStatement(node) || !!(getCombinedNodeFlags(node.declarationList) & 7 /* BlockScoped */ ) || node.declarationList.declarations.some((d)=>!!d.initializer));
                        eachUnreachableRange(node, options, (start, end)=>errorOrSuggestionOnRange(isError, start, end, Diagnostics.Unreachable_code_detected));
                    }
                }
            }
            return true;
        }
    }
    function isEnumDeclarationWithPreservedEmit(node, options) {
        return node.kind === 267 /* EnumDeclaration */  && (!isEnumConst(node) || shouldPreserveConstEnums(options));
    }
    function eachUnreachableRange(node, options, cb) {
        if (isStatement(node) && isExecutableStatement(node) && isBlock(node.parent)) {
            const { statements } = node.parent;
            const slice = sliceAfter(statements, node);
            getRangesWhere(slice, isExecutableStatement, (start, afterEnd)=>cb(slice[start], slice[afterEnd - 1]));
        } else cb(node, node);
        function isExecutableStatement(s) {
            return !isFunctionDeclaration(s) && !isPurelyTypeDeclaration(s) && // `var x;` may declare a variable used above
            !(isVariableStatement(s) && !(getCombinedNodeFlags(s) & 7 /* BlockScoped */ ) && s.declarationList.declarations.some((d)=>!d.initializer));
        }
        function isPurelyTypeDeclaration(s) {
            switch(s.kind){
                case 265 /* InterfaceDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                    return true;
                case 268 /* ModuleDeclaration */ :
                    return getModuleInstanceState(s) !== 1 /* Instantiated */ ;
                case 267 /* EnumDeclaration */ :
                    return !isEnumDeclarationWithPreservedEmit(s, options);
                default:
                    return false;
            }
        }
    }
    function isExportsOrModuleExportsOrAlias(sourceFile, node) {
        let i = 0;
        const q = createQueue();
        q.enqueue(node);
        while(!q.isEmpty() && i < 100){
            i++;
            node = q.dequeue();
            if (isExportsIdentifier(node) || isModuleExportsAccessExpression(node)) return true;
            else if (isIdentifier(node)) {
                const symbol = lookupSymbolForName(sourceFile, node.escapedText);
                if (!!symbol && !!symbol.valueDeclaration && isVariableDeclaration(symbol.valueDeclaration) && !!symbol.valueDeclaration.initializer) {
                    const init = symbol.valueDeclaration.initializer;
                    q.enqueue(init);
                    if (isAssignmentExpression(init, /*excludeCompoundAssignment*/ true)) {
                        q.enqueue(init.left);
                        q.enqueue(init.right);
                    }
                }
            }
        }
        return false;
    }
    function getContainerFlags(node) {
        switch(node.kind){
            case 232 /* ClassExpression */ :
            case 264 /* ClassDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 211 /* ObjectLiteralExpression */ :
            case 188 /* TypeLiteral */ :
            case 323 /* JSDocTypeLiteral */ :
            case 293 /* JsxAttributes */ :
                return 1 /* IsContainer */ ;
            case 265 /* InterfaceDeclaration */ :
                return 65 /* IsInterface */ ;
            case 268 /* ModuleDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 201 /* MappedType */ :
            case 182 /* IndexSignature */ :
                return 33 /* HasLocals */ ;
            case 308 /* SourceFile */ :
                return 37 /* HasLocals */ ;
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 175 /* MethodDeclaration */ :
                if (isObjectLiteralOrClassExpressionMethodOrAccessor(node)) return 173 /* IsObjectLiteralOrClassExpressionMethodOrAccessor */ ;
            // falls through
            case 177 /* Constructor */ :
            case 263 /* FunctionDeclaration */ :
            case 174 /* MethodSignature */ :
            case 180 /* CallSignature */ :
            case 324 /* JSDocSignature */ :
            case 318 /* JSDocFunctionType */ :
            case 185 /* FunctionType */ :
            case 181 /* ConstructSignature */ :
            case 186 /* ConstructorType */ :
            case 176 /* ClassStaticBlockDeclaration */ :
                return 45 /* IsFunctionLike */ ;
            case 352 /* JSDocImportTag */ :
                return 37 /* HasLocals */ ;
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return 61 /* IsFunctionExpression */ ;
            case 269 /* ModuleBlock */ :
                return 4 /* IsControlFlowContainer */ ;
            case 173 /* PropertyDeclaration */ :
                return node.initializer ? 4 /* IsControlFlowContainer */  : 0;
            case 300 /* CatchClause */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 270 /* CaseBlock */ :
                return 34 /* HasLocals */ ;
            case 242 /* Block */ :
                return isFunctionLike(node.parent) || isClassStaticBlockDeclaration(node.parent) ? 0 /* None */  : 34 /* HasLocals */ ;
        }
        return 0 /* None */ ;
    }
    function lookupSymbolForName(container, name) {
        var _a, _b, _c, _d;
        const local = (_b = (_a = tryCast(container, canHaveLocals)) == null ? void 0 : _a.locals) == null ? void 0 : _b.get(name);
        var _local_exportSymbol;
        if (local) return (_local_exportSymbol = local.exportSymbol) !== null && _local_exportSymbol !== void 0 ? _local_exportSymbol : local;
        if (isSourceFile(container) && container.jsGlobalAugmentations && container.jsGlobalAugmentations.has(name)) return container.jsGlobalAugmentations.get(name);
        if (canHaveSymbol(container)) return (_d = (_c = container.symbol) == null ? void 0 : _c.exports) == null ? void 0 : _d.get(name);
    }
    // src/compiler/symbolWalker.ts
    function createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getConstraintOfTypeParameter, getFirstIdentifier2, getTypeArguments) {
        return getSymbolWalker;
        function getSymbolWalker(accept = ()=>true) {
            const visitedTypes = [];
            const visitedSymbols = [];
            return {
                walkType: (type)=>{
                    try {
                        visitType(type);
                        return {
                            visitedTypes: getOwnValues(visitedTypes),
                            visitedSymbols: getOwnValues(visitedSymbols)
                        };
                    } finally{
                        clear(visitedTypes);
                        clear(visitedSymbols);
                    }
                },
                walkSymbol: (symbol)=>{
                    try {
                        visitSymbol(symbol);
                        return {
                            visitedTypes: getOwnValues(visitedTypes),
                            visitedSymbols: getOwnValues(visitedSymbols)
                        };
                    } finally{
                        clear(visitedTypes);
                        clear(visitedSymbols);
                    }
                }
            };
            function visitType(type) {
                if (!type) return;
                if (visitedTypes[type.id]) return;
                visitedTypes[type.id] = type;
                const shouldBail = visitSymbol(type.symbol);
                if (shouldBail) return;
                if (type.flags & 524288 /* Object */ ) {
                    const objectType = type;
                    const objectFlags = objectType.objectFlags;
                    if (objectFlags & 4 /* Reference */ ) visitTypeReference(type);
                    if (objectFlags & 32 /* Mapped */ ) visitMappedType(type);
                    if (objectFlags & 3 /* Interface */ ) visitInterfaceType(type);
                    if (objectFlags & 24 /* Anonymous */ ) visitObjectType(objectType);
                }
                if (type.flags & 262144 /* TypeParameter */ ) visitTypeParameter(type);
                if (type.flags & 3145728 /* UnionOrIntersection */ ) visitUnionOrIntersectionType(type);
                if (type.flags & 4194304 /* Index */ ) visitIndexType(type);
                if (type.flags & 8388608 /* IndexedAccess */ ) visitIndexedAccessType(type);
            }
            function visitTypeReference(type) {
                visitType(type.target);
                forEach(getTypeArguments(type), visitType);
            }
            function visitTypeParameter(type) {
                visitType(getConstraintOfTypeParameter(type));
            }
            function visitUnionOrIntersectionType(type) {
                forEach(type.types, visitType);
            }
            function visitIndexType(type) {
                visitType(type.type);
            }
            function visitIndexedAccessType(type) {
                visitType(type.objectType);
                visitType(type.indexType);
                visitType(type.constraint);
            }
            function visitMappedType(type) {
                visitType(type.typeParameter);
                visitType(type.constraintType);
                visitType(type.templateType);
                visitType(type.modifiersType);
            }
            function visitSignature(signature) {
                const typePredicate = getTypePredicateOfSignature(signature);
                if (typePredicate) visitType(typePredicate.type);
                forEach(signature.typeParameters, visitType);
                for (const parameter of signature.parameters)visitSymbol(parameter);
                visitType(getRestTypeOfSignature(signature));
                visitType(getReturnTypeOfSignature(signature));
            }
            function visitInterfaceType(interfaceT) {
                visitObjectType(interfaceT);
                forEach(interfaceT.typeParameters, visitType);
                forEach(getBaseTypes(interfaceT), visitType);
                visitType(interfaceT.thisType);
            }
            function visitObjectType(type) {
                const resolved = resolveStructuredTypeMembers(type);
                for (const info of resolved.indexInfos){
                    visitType(info.keyType);
                    visitType(info.type);
                }
                for (const signature of resolved.callSignatures)visitSignature(signature);
                for (const signature of resolved.constructSignatures)visitSignature(signature);
                for (const p of resolved.properties)visitSymbol(p);
            }
            function visitSymbol(symbol) {
                if (!symbol) return false;
                const symbolId = getSymbolId(symbol);
                if (visitedSymbols[symbolId]) return false;
                visitedSymbols[symbolId] = symbol;
                if (!accept(symbol)) return true;
                const t = getTypeOfSymbol(symbol);
                visitType(t);
                if (symbol.exports) symbol.exports.forEach(visitSymbol);
                forEach(symbol.declarations, (d)=>{
                    if (d.type && d.type.kind === 187 /* TypeQuery */ ) {
                        const query = d.type;
                        const entity = getResolvedSymbol(getFirstIdentifier2(query.exprName));
                        visitSymbol(entity);
                    }
                });
                return false;
            }
        }
    }
    // src/compiler/_namespaces/ts.moduleSpecifiers.ts
    var ts_moduleSpecifiers_exports = {};
    __export(ts_moduleSpecifiers_exports, {
        RelativePreference: ()=>RelativePreference,
        countPathComponents: ()=>countPathComponents,
        forEachFileNameOfModule: ()=>forEachFileNameOfModule,
        getLocalModuleSpecifierBetweenFileNames: ()=>getLocalModuleSpecifierBetweenFileNames,
        getModuleSpecifier: ()=>getModuleSpecifier,
        getModuleSpecifierPreferences: ()=>getModuleSpecifierPreferences,
        getModuleSpecifiers: ()=>getModuleSpecifiers,
        getModuleSpecifiersWithCacheInfo: ()=>getModuleSpecifiersWithCacheInfo,
        getNodeModulesPackageName: ()=>getNodeModulesPackageName,
        tryGetJSExtensionForFile: ()=>tryGetJSExtensionForFile,
        tryGetModuleSpecifiersFromCache: ()=>tryGetModuleSpecifiersFromCache,
        tryGetRealFileNameForNonJsDeclarationFileName: ()=>tryGetRealFileNameForNonJsDeclarationFileName,
        updateModuleSpecifier: ()=>updateModuleSpecifier
    });
    // src/compiler/moduleSpecifiers.ts
    var stringToRegex = memoizeOne((pattern)=>{
        try {
            let slash = pattern.indexOf("/");
            if (slash !== 0) return new RegExp(pattern);
            const lastSlash = pattern.lastIndexOf("/");
            if (slash === lastSlash) return new RegExp(pattern);
            while((slash = pattern.indexOf("/", slash + 1)) !== lastSlash){
                if (pattern[slash - 1] !== "\\") return new RegExp(pattern);
            }
            const flags = pattern.substring(lastSlash + 1).replace(/[^iu]/g, "");
            pattern = pattern.substring(1, lastSlash);
            return new RegExp(pattern, flags);
        } catch (e) {
            return void 0;
        }
    });
    var RelativePreference = /* @__PURE__ */ ((RelativePreference2)=>{
        RelativePreference2[RelativePreference2["Relative"] = 0] = "Relative";
        RelativePreference2[RelativePreference2["NonRelative"] = 1] = "NonRelative";
        RelativePreference2[RelativePreference2["Shortest"] = 2] = "Shortest";
        RelativePreference2[RelativePreference2["ExternalNonRelative"] = 3] = "ExternalNonRelative";
        return RelativePreference2;
    })(RelativePreference || {});
    function getModuleSpecifierPreferences({ importModuleSpecifierPreference, importModuleSpecifierEnding, autoImportSpecifierExcludeRegexes }, host, compilerOptions, importingSourceFile, oldImportSpecifier) {
        const filePreferredEnding = getPreferredEnding();
        return {
            excludeRegexes: autoImportSpecifierExcludeRegexes,
            relativePreference: oldImportSpecifier !== void 0 ? isExternalModuleNameRelative(oldImportSpecifier) ? 0 /* Relative */  : 1 /* NonRelative */  : importModuleSpecifierPreference === "relative" ? 0 /* Relative */  : importModuleSpecifierPreference === "non-relative" ? 1 /* NonRelative */  : importModuleSpecifierPreference === "project-relative" ? 3 /* ExternalNonRelative */  : 2 /* Shortest */ ,
            getAllowedEndingsInPreferredOrder: (syntaxImpliedNodeFormat)=>{
                const impliedNodeFormat = getDefaultResolutionModeForFile(importingSourceFile, host, compilerOptions);
                const preferredEnding = syntaxImpliedNodeFormat !== impliedNodeFormat ? getPreferredEnding(syntaxImpliedNodeFormat) : filePreferredEnding;
                const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
                if ((syntaxImpliedNodeFormat !== null && syntaxImpliedNodeFormat !== void 0 ? syntaxImpliedNodeFormat : impliedNodeFormat) === 99 /* ESNext */  && 3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */ ) {
                    if (shouldAllowImportingTsExtension(compilerOptions, importingSourceFile.fileName)) return [
                        3 /* TsExtension */ ,
                        2 /* JsExtension */ 
                    ];
                    return [
                        2 /* JsExtension */ 
                    ];
                }
                if (getEmitModuleResolutionKind(compilerOptions) === 1 /* Classic */ ) return preferredEnding === 2 /* JsExtension */  ? [
                    2 /* JsExtension */ ,
                    1 /* Index */ 
                ] : [
                    1 /* Index */ ,
                    2 /* JsExtension */ 
                ];
                const allowImportingTsExtension = shouldAllowImportingTsExtension(compilerOptions, importingSourceFile.fileName);
                switch(preferredEnding){
                    case 2 /* JsExtension */ :
                        return allowImportingTsExtension ? [
                            2 /* JsExtension */ ,
                            3 /* TsExtension */ ,
                            0 /* Minimal */ ,
                            1 /* Index */ 
                        ] : [
                            2 /* JsExtension */ ,
                            0 /* Minimal */ ,
                            1 /* Index */ 
                        ];
                    case 3 /* TsExtension */ :
                        return [
                            3 /* TsExtension */ ,
                            0 /* Minimal */ ,
                            2 /* JsExtension */ ,
                            1 /* Index */ 
                        ];
                    case 1 /* Index */ :
                        return allowImportingTsExtension ? [
                            1 /* Index */ ,
                            0 /* Minimal */ ,
                            3 /* TsExtension */ ,
                            2 /* JsExtension */ 
                        ] : [
                            1 /* Index */ ,
                            0 /* Minimal */ ,
                            2 /* JsExtension */ 
                        ];
                    case 0 /* Minimal */ :
                        return allowImportingTsExtension ? [
                            0 /* Minimal */ ,
                            1 /* Index */ ,
                            3 /* TsExtension */ ,
                            2 /* JsExtension */ 
                        ] : [
                            0 /* Minimal */ ,
                            1 /* Index */ ,
                            2 /* JsExtension */ 
                        ];
                    default:
                        Debug.assertNever(preferredEnding);
                }
            }
        };
        function getPreferredEnding(resolutionMode) {
            if (oldImportSpecifier !== void 0) {
                if (hasJSFileExtension(oldImportSpecifier)) return 2 /* JsExtension */ ;
                if (endsWith(oldImportSpecifier, "/index")) return 1 /* Index */ ;
            }
            return getModuleSpecifierEndingPreference(importModuleSpecifierEnding, resolutionMode !== null && resolutionMode !== void 0 ? resolutionMode : getDefaultResolutionModeForFile(importingSourceFile, host, compilerOptions), compilerOptions, isFullSourceFile(importingSourceFile) ? importingSourceFile : void 0);
        }
    }
    function updateModuleSpecifier(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, oldImportSpecifier, options = {}) {
        const res = getModuleSpecifierWorker(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, getModuleSpecifierPreferences({}, host, compilerOptions, importingSourceFile, oldImportSpecifier), {}, options);
        if (res === oldImportSpecifier) return void 0;
        return res;
    }
    function getModuleSpecifier(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, options = {}) {
        return getModuleSpecifierWorker(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, getModuleSpecifierPreferences({}, host, compilerOptions, importingSourceFile), {}, options);
    }
    function getNodeModulesPackageName(compilerOptions, importingSourceFile, nodeModulesFileName, host, preferences, options = {}) {
        const info = getInfo(importingSourceFile.fileName, host);
        const modulePaths = getAllModulePaths(info, nodeModulesFileName, host, preferences, compilerOptions, options);
        return firstDefined(modulePaths, (modulePath)=>tryGetModuleNameAsNodeModule(modulePath, info, importingSourceFile, host, compilerOptions, preferences, /*packageNameOnly*/ true, options.overrideImportMode));
    }
    function getModuleSpecifierWorker(compilerOptions, importingSourceFile, importingSourceFileName, toFileName2, host, preferences, userPreferences, options = {}) {
        const info = getInfo(importingSourceFileName, host);
        const modulePaths = getAllModulePaths(info, toFileName2, host, userPreferences, compilerOptions, options);
        return firstDefined(modulePaths, (modulePath)=>tryGetModuleNameAsNodeModule(modulePath, info, importingSourceFile, host, compilerOptions, userPreferences, /*packageNameOnly*/ void 0, options.overrideImportMode)) || getLocalModuleSpecifier(toFileName2, info, compilerOptions, host, options.overrideImportMode || getDefaultResolutionModeForFile(importingSourceFile, host, compilerOptions), preferences);
    }
    function tryGetModuleSpecifiersFromCache(moduleSymbol, importingSourceFile, host, userPreferences, options = {}) {
        const result = tryGetModuleSpecifiersFromCacheWorker(moduleSymbol, importingSourceFile, host, userPreferences, options);
        return result[1] && {
            kind: result[0],
            moduleSpecifiers: result[1],
            computedWithoutCache: false
        };
    }
    function tryGetModuleSpecifiersFromCacheWorker(moduleSymbol, importingSourceFile, host, userPreferences, options = {}) {
        var _a;
        const moduleSourceFile = getSourceFileOfModule(moduleSymbol);
        if (!moduleSourceFile) return emptyArray;
        const cache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
        const cached = cache == null ? void 0 : cache.get(importingSourceFile.path, moduleSourceFile.path, userPreferences, options);
        return [
            cached == null ? void 0 : cached.kind,
            cached == null ? void 0 : cached.moduleSpecifiers,
            moduleSourceFile,
            cached == null ? void 0 : cached.modulePaths,
            cache
        ];
    }
    function getModuleSpecifiers(moduleSymbol, checker, compilerOptions, importingSourceFile, host, userPreferences, options = {}) {
        return getModuleSpecifiersWithCacheInfo(moduleSymbol, checker, compilerOptions, importingSourceFile, host, userPreferences, options, /*forAutoImport*/ false).moduleSpecifiers;
    }
    function getModuleSpecifiersWithCacheInfo(moduleSymbol, checker, compilerOptions, importingSourceFile, host, userPreferences, options = {}, forAutoImport) {
        let computedWithoutCache = false;
        const ambient = tryGetModuleNameFromAmbientModule(moduleSymbol, checker);
        if (ambient) return {
            kind: "ambient",
            moduleSpecifiers: !(forAutoImport && isExcludedByRegex(ambient, userPreferences.autoImportSpecifierExcludeRegexes)) ? [
                ambient
            ] : emptyArray,
            computedWithoutCache
        };
        let [kind, specifiers, moduleSourceFile, modulePaths, cache] = tryGetModuleSpecifiersFromCacheWorker(moduleSymbol, importingSourceFile, host, userPreferences, options);
        if (specifiers) return {
            kind,
            moduleSpecifiers: specifiers,
            computedWithoutCache
        };
        if (!moduleSourceFile) return {
            kind: void 0,
            moduleSpecifiers: emptyArray,
            computedWithoutCache
        };
        computedWithoutCache = true;
        modulePaths || (modulePaths = getAllModulePathsWorker(getInfo(importingSourceFile.fileName, host), moduleSourceFile.originalFileName, host, compilerOptions, options));
        const result = computeModuleSpecifiers(modulePaths, compilerOptions, importingSourceFile, host, userPreferences, options, forAutoImport);
        cache == null || cache.set(importingSourceFile.path, moduleSourceFile.path, userPreferences, options, result.kind, modulePaths, result.moduleSpecifiers);
        return result;
    }
    function getLocalModuleSpecifierBetweenFileNames(importingFile, targetFileName, compilerOptions, host, preferences, options = {}) {
        const info = getInfo(importingFile.fileName, host);
        var _options_overrideImportMode;
        const importMode = (_options_overrideImportMode = options.overrideImportMode) !== null && _options_overrideImportMode !== void 0 ? _options_overrideImportMode : importingFile.impliedNodeFormat;
        return getLocalModuleSpecifier(targetFileName, info, compilerOptions, host, importMode, getModuleSpecifierPreferences(preferences, host, compilerOptions, importingFile));
    }
    function computeModuleSpecifiers(modulePaths, compilerOptions, importingSourceFile, host, userPreferences, options = {}, forAutoImport) {
        const info = getInfo(importingSourceFile.fileName, host);
        const preferences = getModuleSpecifierPreferences(userPreferences, host, compilerOptions, importingSourceFile);
        const existingSpecifier = isFullSourceFile(importingSourceFile) && forEach(modulePaths, (modulePath)=>forEach(host.getFileIncludeReasons().get(toPath(modulePath.path, host.getCurrentDirectory(), info.getCanonicalFileName)), (reason)=>{
                if (reason.kind !== 3 /* Import */  || reason.file !== importingSourceFile.path) return void 0;
                const existingMode = host.getModeForResolutionAtIndex(importingSourceFile, reason.index);
                var _options_overrideImportMode;
                const targetMode = (_options_overrideImportMode = options.overrideImportMode) !== null && _options_overrideImportMode !== void 0 ? _options_overrideImportMode : host.getDefaultResolutionModeForFile(importingSourceFile);
                if (existingMode !== targetMode && existingMode !== void 0 && targetMode !== void 0) return void 0;
                const specifier = getModuleNameStringLiteralAt(importingSourceFile, reason.index).text;
                return preferences.relativePreference !== 1 /* NonRelative */  || !pathIsRelative(specifier) ? specifier : void 0;
            }));
        if (existingSpecifier) return {
            kind: void 0,
            moduleSpecifiers: [
                existingSpecifier
            ],
            computedWithoutCache: true
        };
        const importedFileIsInNodeModules = some(modulePaths, (p)=>p.isInNodeModules);
        let nodeModulesSpecifiers;
        let pathsSpecifiers;
        let redirectPathsSpecifiers;
        let relativeSpecifiers;
        for (const modulePath of modulePaths){
            const specifier = modulePath.isInNodeModules ? tryGetModuleNameAsNodeModule(modulePath, info, importingSourceFile, host, compilerOptions, userPreferences, /*packageNameOnly*/ void 0, options.overrideImportMode) : void 0;
            if (specifier && !(forAutoImport && isExcludedByRegex(specifier, preferences.excludeRegexes))) {
                nodeModulesSpecifiers = append(nodeModulesSpecifiers, specifier);
                if (modulePath.isRedirect) return {
                    kind: "node_modules",
                    moduleSpecifiers: nodeModulesSpecifiers,
                    computedWithoutCache: true
                };
            }
            const local = getLocalModuleSpecifier(modulePath.path, info, compilerOptions, host, options.overrideImportMode || importingSourceFile.impliedNodeFormat, preferences, /*pathsOnly*/ modulePath.isRedirect || !!specifier);
            if (!local || forAutoImport && isExcludedByRegex(local, preferences.excludeRegexes)) continue;
            if (modulePath.isRedirect) redirectPathsSpecifiers = append(redirectPathsSpecifiers, local);
            else if (pathIsBareSpecifier(local)) {
                if (pathContainsNodeModules(local)) relativeSpecifiers = append(relativeSpecifiers, local);
                else pathsSpecifiers = append(pathsSpecifiers, local);
            } else if (forAutoImport || !importedFileIsInNodeModules || modulePath.isInNodeModules) relativeSpecifiers = append(relativeSpecifiers, local);
        }
        return (pathsSpecifiers == null ? void 0 : pathsSpecifiers.length) ? {
            kind: "paths",
            moduleSpecifiers: pathsSpecifiers,
            computedWithoutCache: true
        } : (redirectPathsSpecifiers == null ? void 0 : redirectPathsSpecifiers.length) ? {
            kind: "redirect",
            moduleSpecifiers: redirectPathsSpecifiers,
            computedWithoutCache: true
        } : (nodeModulesSpecifiers == null ? void 0 : nodeModulesSpecifiers.length) ? {
            kind: "node_modules",
            moduleSpecifiers: nodeModulesSpecifiers,
            computedWithoutCache: true
        } : {
            kind: "relative",
            moduleSpecifiers: relativeSpecifiers !== null && relativeSpecifiers !== void 0 ? relativeSpecifiers : emptyArray,
            computedWithoutCache: true
        };
    }
    function isExcludedByRegex(moduleSpecifier, excludeRegexes) {
        return some(excludeRegexes, (pattern)=>{
            var _a;
            return !!((_a = stringToRegex(pattern)) == null ? void 0 : _a.test(moduleSpecifier));
        });
    }
    function getInfo(importingSourceFileName, host) {
        importingSourceFileName = getNormalizedAbsolutePath(importingSourceFileName, host.getCurrentDirectory());
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames ? host.useCaseSensitiveFileNames() : true);
        const sourceDirectory = getDirectoryPath(importingSourceFileName);
        return {
            getCanonicalFileName,
            importingSourceFileName,
            sourceDirectory,
            canonicalSourceDirectory: getCanonicalFileName(sourceDirectory)
        };
    }
    function getLocalModuleSpecifier(moduleFileName, info, compilerOptions, host, importMode, { getAllowedEndingsInPreferredOrder: getAllowedEndingsInPrefererredOrder, relativePreference, excludeRegexes }, pathsOnly) {
        const { baseUrl, paths, rootDirs } = compilerOptions;
        if (pathsOnly && !paths) return void 0;
        const { sourceDirectory, canonicalSourceDirectory, getCanonicalFileName } = info;
        const allowedEndings = getAllowedEndingsInPrefererredOrder(importMode);
        const relativePath = rootDirs && tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName, allowedEndings, compilerOptions) || processEnding(ensurePathIsNonModuleName(getRelativePathFromDirectory(sourceDirectory, moduleFileName, getCanonicalFileName)), allowedEndings, compilerOptions);
        if (!baseUrl && !paths && !getResolvePackageJsonImports(compilerOptions) || relativePreference === 0 /* Relative */ ) return pathsOnly ? void 0 : relativePath;
        const baseDirectory = getNormalizedAbsolutePath(getPathsBasePath(compilerOptions, host) || baseUrl, host.getCurrentDirectory());
        const relativeToBaseUrl = getRelativePathIfInSameVolume(moduleFileName, baseDirectory, getCanonicalFileName);
        if (!relativeToBaseUrl) return pathsOnly ? void 0 : relativePath;
        const fromPackageJsonImports = pathsOnly ? void 0 : tryGetModuleNameFromPackageJsonImports(moduleFileName, sourceDirectory, compilerOptions, host, importMode, prefersTsExtension(allowedEndings));
        const fromPaths = pathsOnly || fromPackageJsonImports === void 0 ? paths && tryGetModuleNameFromPaths(relativeToBaseUrl, paths, allowedEndings, baseDirectory, getCanonicalFileName, host, compilerOptions) : void 0;
        if (pathsOnly) return fromPaths;
        const maybeNonRelative = fromPackageJsonImports !== null && fromPackageJsonImports !== void 0 ? fromPackageJsonImports : fromPaths === void 0 && baseUrl !== void 0 ? processEnding(relativeToBaseUrl, allowedEndings, compilerOptions) : fromPaths;
        if (!maybeNonRelative) return relativePath;
        const relativeIsExcluded = isExcludedByRegex(relativePath, excludeRegexes);
        const nonRelativeIsExcluded = isExcludedByRegex(maybeNonRelative, excludeRegexes);
        if (!relativeIsExcluded && nonRelativeIsExcluded) return relativePath;
        if (relativeIsExcluded && !nonRelativeIsExcluded) return maybeNonRelative;
        if (relativePreference === 1 /* NonRelative */  && !pathIsRelative(maybeNonRelative)) return maybeNonRelative;
        if (relativePreference === 3 /* ExternalNonRelative */  && !pathIsRelative(maybeNonRelative)) {
            const projectDirectory = compilerOptions.configFilePath ? toPath(getDirectoryPath(compilerOptions.configFilePath), host.getCurrentDirectory(), info.getCanonicalFileName) : info.getCanonicalFileName(host.getCurrentDirectory());
            const modulePath = toPath(moduleFileName, projectDirectory, getCanonicalFileName);
            const sourceIsInternal = startsWith(canonicalSourceDirectory, projectDirectory);
            const targetIsInternal = startsWith(modulePath, projectDirectory);
            if (sourceIsInternal && !targetIsInternal || !sourceIsInternal && targetIsInternal) return maybeNonRelative;
            const nearestTargetPackageJson = getNearestAncestorDirectoryWithPackageJson(host, getDirectoryPath(modulePath));
            const nearestSourcePackageJson = getNearestAncestorDirectoryWithPackageJson(host, sourceDirectory);
            const ignoreCase = !hostUsesCaseSensitiveFileNames(host);
            if (!packageJsonPathsAreEqual(nearestTargetPackageJson, nearestSourcePackageJson, ignoreCase)) return maybeNonRelative;
            return relativePath;
        }
        return isPathRelativeToParent(maybeNonRelative) || countPathComponents(relativePath) < countPathComponents(maybeNonRelative) ? relativePath : maybeNonRelative;
    }
    function packageJsonPathsAreEqual(a, b, ignoreCase) {
        if (a === b) return true;
        if (a === void 0 || b === void 0) return false;
        return comparePaths(a, b, ignoreCase) === 0 /* EqualTo */ ;
    }
    function countPathComponents(path) {
        let count = 0;
        for(let i = startsWith(path, "./") ? 2 : 0; i < path.length; i++)if (path.charCodeAt(i) === 47 /* slash */ ) count++;
        return count;
    }
    function comparePathsByRedirectAndNumberOfDirectorySeparators(a, b) {
        return compareBooleans(b.isRedirect, a.isRedirect) || compareNumberOfDirectorySeparators(a.path, b.path);
    }
    function getNearestAncestorDirectoryWithPackageJson(host, fileName) {
        if (host.getNearestAncestorDirectoryWithPackageJson) return host.getNearestAncestorDirectoryWithPackageJson(fileName);
        return forEachAncestorDirectoryStoppingAtGlobalCache(host, fileName, (directory)=>host.fileExists(combinePaths(directory, "package.json")) ? directory : void 0);
    }
    function forEachFileNameOfModule(importingFileName, importedFileName, host, preferSymlinks, cb) {
        var _a, _b;
        const getCanonicalFileName = hostGetCanonicalFileName(host);
        const cwd = host.getCurrentDirectory();
        const referenceRedirect = host.isSourceOfProjectReferenceRedirect(importedFileName) ? (_a = host.getRedirectFromSourceFile(importedFileName)) == null ? void 0 : _a.outputDts : void 0;
        const importedPath = toPath(importedFileName, cwd, getCanonicalFileName);
        const redirects = host.redirectTargetsMap.get(importedPath) || emptyArray;
        const importedFileNames = [
            ...referenceRedirect ? [
                referenceRedirect
            ] : emptyArray,
            importedFileName,
            ...redirects
        ];
        const targets = importedFileNames.map((f)=>getNormalizedAbsolutePath(f, cwd));
        let shouldFilterIgnoredPaths = !every(targets, containsIgnoredPath);
        if (!preferSymlinks) {
            const result2 = forEach(targets, (p)=>!(shouldFilterIgnoredPaths && containsIgnoredPath(p)) && cb(p, referenceRedirect === p));
            if (result2) return result2;
        }
        const symlinkedDirectories = (_b = host.getSymlinkCache) == null ? void 0 : _b.call(host).getSymlinkedDirectoriesByRealpath();
        const fullImportedFileName = getNormalizedAbsolutePath(importedFileName, cwd);
        const result = symlinkedDirectories && forEachAncestorDirectoryStoppingAtGlobalCache(host, getDirectoryPath(fullImportedFileName), (realPathDirectory)=>{
            const symlinkDirectories = symlinkedDirectories.get(ensureTrailingDirectorySeparator(toPath(realPathDirectory, cwd, getCanonicalFileName)));
            if (!symlinkDirectories) return void 0;
            if (startsWithDirectory(importingFileName, realPathDirectory, getCanonicalFileName)) return false;
            return forEach(targets, (target)=>{
                if (!startsWithDirectory(target, realPathDirectory, getCanonicalFileName)) return;
                const relative = getRelativePathFromDirectory(realPathDirectory, target, getCanonicalFileName);
                for (const symlinkDirectory of symlinkDirectories){
                    const option = resolvePath(symlinkDirectory, relative);
                    const result2 = cb(option, target === referenceRedirect);
                    shouldFilterIgnoredPaths = true;
                    if (result2) return result2;
                }
            });
        });
        return result || (preferSymlinks ? forEach(targets, (p)=>shouldFilterIgnoredPaths && containsIgnoredPath(p) ? void 0 : cb(p, p === referenceRedirect)) : void 0);
    }
    function getAllModulePaths(info, importedFileName, host, preferences, compilerOptions, options = {}) {
        var _a;
        const importingFilePath = toPath(info.importingSourceFileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host));
        const importedFilePath = toPath(importedFileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host));
        const cache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
        if (cache) {
            const cached = cache.get(importingFilePath, importedFilePath, preferences, options);
            if (cached == null ? void 0 : cached.modulePaths) return cached.modulePaths;
        }
        const modulePaths = getAllModulePathsWorker(info, importedFileName, host, compilerOptions, options);
        if (cache) cache.setModulePaths(importingFilePath, importedFilePath, preferences, options, modulePaths);
        return modulePaths;
    }
    var runtimeDependencyFields = [
        "dependencies",
        "peerDependencies",
        "optionalDependencies"
    ];
    function getAllRuntimeDependencies(packageJson) {
        let result;
        for (const field of runtimeDependencyFields){
            const deps = packageJson[field];
            if (deps && typeof deps === "object") result = concatenate(result, getOwnKeys(deps));
        }
        return result;
    }
    function getAllModulePathsWorker(info, importedFileName, host, compilerOptions, options) {
        var _a, _b;
        const cache = (_a = host.getModuleResolutionCache) == null ? void 0 : _a.call(host);
        const links = (_b = host.getSymlinkCache) == null ? void 0 : _b.call(host);
        if (cache && links && host.readFile && !pathContainsNodeModules(info.importingSourceFileName)) {
            Debug.type(host);
            const state = getTemporaryModuleResolutionState(cache.getPackageJsonInfoCache(), host, {});
            const packageJson = getPackageScopeForPath(getDirectoryPath(info.importingSourceFileName), state);
            if (packageJson) {
                const toResolve = getAllRuntimeDependencies(packageJson.contents.packageJsonContent);
                for (const depName of toResolve || emptyArray){
                    const resolved = resolveModuleName(depName, combinePaths(packageJson.packageDirectory, "package.json"), compilerOptions, host, cache, /*redirectedReference*/ void 0, options.overrideImportMode);
                    links.setSymlinksFromResolution(resolved.resolvedModule);
                }
            }
        }
        const allFileNames = /* @__PURE__ */ new Map();
        let importedFileFromNodeModules = false;
        forEachFileNameOfModule(info.importingSourceFileName, importedFileName, host, /*preferSymlinks*/ true, (path, isRedirect)=>{
            const isInNodeModules = pathContainsNodeModules(path);
            allFileNames.set(path, {
                path: info.getCanonicalFileName(path),
                isRedirect,
                isInNodeModules
            });
            importedFileFromNodeModules = importedFileFromNodeModules || isInNodeModules;
        });
        const sortedPaths = [];
        for(let directory = info.canonicalSourceDirectory; allFileNames.size !== 0;){
            const directoryStart = ensureTrailingDirectorySeparator(directory);
            let pathsInDirectory;
            allFileNames.forEach(({ path, isRedirect, isInNodeModules }, fileName)=>{
                if (startsWith(path, directoryStart)) {
                    (pathsInDirectory || (pathsInDirectory = [])).push({
                        path: fileName,
                        isRedirect,
                        isInNodeModules
                    });
                    allFileNames.delete(fileName);
                }
            });
            if (pathsInDirectory) {
                if (pathsInDirectory.length > 1) pathsInDirectory.sort(comparePathsByRedirectAndNumberOfDirectorySeparators);
                sortedPaths.push(...pathsInDirectory);
            }
            const newDirectory = getDirectoryPath(directory);
            if (newDirectory === directory) break;
            directory = newDirectory;
        }
        if (allFileNames.size) {
            const remainingPaths = arrayFrom(allFileNames.entries(), ([fileName, { isRedirect, isInNodeModules }])=>({
                    path: fileName,
                    isRedirect,
                    isInNodeModules
                }));
            if (remainingPaths.length > 1) remainingPaths.sort(comparePathsByRedirectAndNumberOfDirectorySeparators);
            sortedPaths.push(...remainingPaths);
        }
        return sortedPaths;
    }
    function tryGetModuleNameFromAmbientModule(moduleSymbol, checker) {
        var _a;
        const decl = (_a = moduleSymbol.declarations) == null ? void 0 : _a.find((d)=>isNonGlobalAmbientModule(d) && (!isExternalModuleAugmentation(d) || !isExternalModuleNameRelative(getTextOfIdentifierOrLiteral(d.name))));
        if (decl) return decl.name.text;
        const ambientModuleDeclareCandidates = mapDefined(moduleSymbol.declarations, (d)=>{
            var _a2, _b, _c, _d;
            if (!isModuleDeclaration(d)) return;
            const topNamespace = getTopNamespace(d);
            if (!(((_a2 = topNamespace == null ? void 0 : topNamespace.parent) == null ? void 0 : _a2.parent) && isModuleBlock(topNamespace.parent) && isAmbientModule(topNamespace.parent.parent) && isSourceFile(topNamespace.parent.parent.parent))) return;
            const exportAssignment = (_d = (_c = (_b = topNamespace.parent.parent.symbol.exports) == null ? void 0 : _b.get("export=")) == null ? void 0 : _c.valueDeclaration) == null ? void 0 : _d.expression;
            if (!exportAssignment) return;
            const exportSymbol = checker.getSymbolAtLocation(exportAssignment);
            if (!exportSymbol) return;
            const originalExportSymbol = (exportSymbol == null ? void 0 : exportSymbol.flags) & 2097152 /* Alias */  ? checker.getAliasedSymbol(exportSymbol) : exportSymbol;
            if (originalExportSymbol === d.symbol) return topNamespace.parent.parent;
            function getTopNamespace(namespaceDeclaration) {
                while(namespaceDeclaration.flags & 8 /* NestedNamespace */ )namespaceDeclaration = namespaceDeclaration.parent;
                return namespaceDeclaration;
            }
        });
        const ambientModuleDeclare = ambientModuleDeclareCandidates[0];
        if (ambientModuleDeclare) return ambientModuleDeclare.name.text;
    }
    function tryGetModuleNameFromPaths(relativeToBaseUrl, paths, allowedEndings, baseDirectory, getCanonicalFileName, host, compilerOptions) {
        for(const key in paths)for (const patternText2 of paths[key]){
            const normalized = normalizePath(patternText2);
            var _getRelativePathIfInSameVolume;
            const pattern = (_getRelativePathIfInSameVolume = getRelativePathIfInSameVolume(normalized, baseDirectory, getCanonicalFileName)) !== null && _getRelativePathIfInSameVolume !== void 0 ? _getRelativePathIfInSameVolume : normalized;
            const indexOfStar = pattern.indexOf("*");
            const candidates = allowedEndings.map((ending)=>({
                    ending,
                    value: processEnding(relativeToBaseUrl, [
                        ending
                    ], compilerOptions)
                }));
            if (tryGetExtensionFromPath2(pattern)) candidates.push({
                ending: void 0,
                value: relativeToBaseUrl
            });
            if (indexOfStar !== -1) {
                const prefix = pattern.substring(0, indexOfStar);
                const suffix = pattern.substring(indexOfStar + 1);
                for (const { ending, value: value1 } of candidates)if (value1.length >= prefix.length + suffix.length && startsWith(value1, prefix) && endsWith(value1, suffix) && validateEnding({
                    ending,
                    value: value1
                })) {
                    const matchedStar = value1.substring(prefix.length, value1.length - suffix.length);
                    if (!pathIsRelative(matchedStar)) return replaceFirstStar(key, matchedStar);
                }
            } else if (some(candidates, (c)=>c.ending !== 0 /* Minimal */  && pattern === c.value) || some(candidates, (c)=>c.ending === 0 /* Minimal */  && pattern === c.value && validateEnding(c))) return key;
        }
        function validateEnding({ ending, value: value1 }) {
            return ending !== 0 /* Minimal */  || value1 === processEnding(relativeToBaseUrl, [
                ending
            ], compilerOptions, host);
        }
    }
    function tryGetModuleNameFromExportsOrImports(options, host, targetFilePath, packageDirectory, packageName, exports2, conditions, mode, isImports, preferTsExtension) {
        if (typeof exports2 === "string") {
            const ignoreCase = !hostUsesCaseSensitiveFileNames(host);
            const getCommonSourceDirectory2 = ()=>host.getCommonSourceDirectory();
            const outputFile = isImports && getOutputJSFileNameWorker(targetFilePath, options, ignoreCase, getCommonSourceDirectory2);
            const declarationFile = isImports && getOutputDeclarationFileNameWorker(targetFilePath, options, ignoreCase, getCommonSourceDirectory2);
            const pathOrPattern = getNormalizedAbsolutePath(combinePaths(packageDirectory, exports2), /*currentDirectory*/ void 0);
            const extensionSwappedTarget = hasTSFileExtension(targetFilePath) ? removeFileExtension(targetFilePath) + tryGetJSExtensionForFile(targetFilePath, options) : void 0;
            const canTryTsExtension = preferTsExtension && hasImplementationTSFileExtension(targetFilePath);
            switch(mode){
                case 0 /* Exact */ :
                    if (extensionSwappedTarget && comparePaths(extensionSwappedTarget, pathOrPattern, ignoreCase) === 0 /* EqualTo */  || comparePaths(targetFilePath, pathOrPattern, ignoreCase) === 0 /* EqualTo */  || outputFile && comparePaths(outputFile, pathOrPattern, ignoreCase) === 0 /* EqualTo */  || declarationFile && comparePaths(declarationFile, pathOrPattern, ignoreCase) === 0 /* EqualTo */ ) return {
                        moduleFileToTry: packageName
                    };
                    break;
                case 1 /* Directory */ :
                    if (canTryTsExtension && containsPath(targetFilePath, pathOrPattern, ignoreCase)) {
                        const fragment = getRelativePathFromDirectory(pathOrPattern, targetFilePath, /*ignoreCase*/ false);
                        return {
                            moduleFileToTry: getNormalizedAbsolutePath(combinePaths(combinePaths(packageName, exports2), fragment), /*currentDirectory*/ void 0)
                        };
                    }
                    if (extensionSwappedTarget && containsPath(pathOrPattern, extensionSwappedTarget, ignoreCase)) {
                        const fragment = getRelativePathFromDirectory(pathOrPattern, extensionSwappedTarget, /*ignoreCase*/ false);
                        return {
                            moduleFileToTry: getNormalizedAbsolutePath(combinePaths(combinePaths(packageName, exports2), fragment), /*currentDirectory*/ void 0)
                        };
                    }
                    if (!canTryTsExtension && containsPath(pathOrPattern, targetFilePath, ignoreCase)) {
                        const fragment = getRelativePathFromDirectory(pathOrPattern, targetFilePath, /*ignoreCase*/ false);
                        return {
                            moduleFileToTry: getNormalizedAbsolutePath(combinePaths(combinePaths(packageName, exports2), fragment), /*currentDirectory*/ void 0)
                        };
                    }
                    if (outputFile && containsPath(pathOrPattern, outputFile, ignoreCase)) {
                        const fragment = getRelativePathFromDirectory(pathOrPattern, outputFile, /*ignoreCase*/ false);
                        return {
                            moduleFileToTry: combinePaths(packageName, fragment)
                        };
                    }
                    if (declarationFile && containsPath(pathOrPattern, declarationFile, ignoreCase)) {
                        const fragment = changeFullExtension(getRelativePathFromDirectory(pathOrPattern, declarationFile, /*ignoreCase*/ false), getJSExtensionForFile(declarationFile, options));
                        return {
                            moduleFileToTry: combinePaths(packageName, fragment)
                        };
                    }
                    break;
                case 2 /* Pattern */ :
                    const starPos = pathOrPattern.indexOf("*");
                    const leadingSlice = pathOrPattern.slice(0, starPos);
                    const trailingSlice = pathOrPattern.slice(starPos + 1);
                    if (canTryTsExtension && startsWith(targetFilePath, leadingSlice, ignoreCase) && endsWith(targetFilePath, trailingSlice, ignoreCase)) {
                        const starReplacement = targetFilePath.slice(leadingSlice.length, targetFilePath.length - trailingSlice.length);
                        return {
                            moduleFileToTry: replaceFirstStar(packageName, starReplacement)
                        };
                    }
                    if (extensionSwappedTarget && startsWith(extensionSwappedTarget, leadingSlice, ignoreCase) && endsWith(extensionSwappedTarget, trailingSlice, ignoreCase)) {
                        const starReplacement = extensionSwappedTarget.slice(leadingSlice.length, extensionSwappedTarget.length - trailingSlice.length);
                        return {
                            moduleFileToTry: replaceFirstStar(packageName, starReplacement)
                        };
                    }
                    if (!canTryTsExtension && startsWith(targetFilePath, leadingSlice, ignoreCase) && endsWith(targetFilePath, trailingSlice, ignoreCase)) {
                        const starReplacement = targetFilePath.slice(leadingSlice.length, targetFilePath.length - trailingSlice.length);
                        return {
                            moduleFileToTry: replaceFirstStar(packageName, starReplacement)
                        };
                    }
                    if (outputFile && startsWith(outputFile, leadingSlice, ignoreCase) && endsWith(outputFile, trailingSlice, ignoreCase)) {
                        const starReplacement = outputFile.slice(leadingSlice.length, outputFile.length - trailingSlice.length);
                        return {
                            moduleFileToTry: replaceFirstStar(packageName, starReplacement)
                        };
                    }
                    if (declarationFile && startsWith(declarationFile, leadingSlice, ignoreCase) && endsWith(declarationFile, trailingSlice, ignoreCase)) {
                        const starReplacement = declarationFile.slice(leadingSlice.length, declarationFile.length - trailingSlice.length);
                        const substituted = replaceFirstStar(packageName, starReplacement);
                        const jsExtension = tryGetJSExtensionForFile(declarationFile, options);
                        return jsExtension ? {
                            moduleFileToTry: changeFullExtension(substituted, jsExtension)
                        } : void 0;
                    }
                    break;
            }
        } else if (Array.isArray(exports2)) return forEach(exports2, (e)=>tryGetModuleNameFromExportsOrImports(options, host, targetFilePath, packageDirectory, packageName, e, conditions, mode, isImports, preferTsExtension));
        else if (typeof exports2 === "object" && exports2 !== null) {
            for (const key of getOwnKeys(exports2))if (key === "default" || conditions.indexOf(key) >= 0 || isApplicableVersionedTypesKey(conditions, key)) {
                const subTarget = exports2[key];
                const result = tryGetModuleNameFromExportsOrImports(options, host, targetFilePath, packageDirectory, packageName, subTarget, conditions, mode, isImports, preferTsExtension);
                if (result) return result;
            }
        }
        return void 0;
    }
    function tryGetModuleNameFromExports(options, host, targetFilePath, packageDirectory, packageName, exports2, conditions) {
        if (typeof exports2 === "object" && exports2 !== null && !Array.isArray(exports2) && allKeysStartWithDot(exports2)) return forEach(getOwnKeys(exports2), (k)=>{
            const subPackageName = getNormalizedAbsolutePath(combinePaths(packageName, k), /*currentDirectory*/ void 0);
            const mode = endsWith(k, "/") ? 1 /* Directory */  : k.includes("*") ? 2 /* Pattern */  : 0 /* Exact */ ;
            return tryGetModuleNameFromExportsOrImports(options, host, targetFilePath, packageDirectory, subPackageName, exports2[k], conditions, mode, /*isImports*/ false, /*preferTsExtension*/ false);
        });
        return tryGetModuleNameFromExportsOrImports(options, host, targetFilePath, packageDirectory, packageName, exports2, conditions, 0 /* Exact */ , /*isImports*/ false, /*preferTsExtension*/ false);
    }
    function tryGetModuleNameFromPackageJsonImports(moduleFileName, sourceDirectory, options, host, importMode, preferTsExtension) {
        var _a, _b, _c;
        if (!host.readFile || !getResolvePackageJsonImports(options)) return void 0;
        const ancestorDirectoryWithPackageJson = getNearestAncestorDirectoryWithPackageJson(host, sourceDirectory);
        if (!ancestorDirectoryWithPackageJson) return void 0;
        const packageJsonPath = combinePaths(ancestorDirectoryWithPackageJson, "package.json");
        const cachedPackageJson = (_b = (_a = host.getPackageJsonInfoCache) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getPackageJsonInfo(packageJsonPath);
        if (isMissingPackageJsonInfo(cachedPackageJson) || !host.fileExists(packageJsonPath)) return void 0;
        const packageJsonContent = (cachedPackageJson == null ? void 0 : cachedPackageJson.contents.packageJsonContent) || tryParseJson(host.readFile(packageJsonPath));
        const imports = packageJsonContent == null ? void 0 : packageJsonContent.imports;
        if (!imports) return void 0;
        const conditions = getConditions(options, importMode);
        return (_c = forEach(getOwnKeys(imports), (k)=>{
            if (!startsWith(k, "#") || k === "#" || startsWith(k, "#/")) return void 0;
            const mode = endsWith(k, "/") ? 1 /* Directory */  : k.includes("*") ? 2 /* Pattern */  : 0 /* Exact */ ;
            return tryGetModuleNameFromExportsOrImports(options, host, moduleFileName, ancestorDirectoryWithPackageJson, k, imports[k], conditions, mode, /*isImports*/ true, preferTsExtension);
        })) == null ? void 0 : _c.moduleFileToTry;
    }
    function tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName, allowedEndings, compilerOptions) {
        const normalizedTargetPaths = getPathsRelativeToRootDirs(moduleFileName, rootDirs, getCanonicalFileName);
        if (normalizedTargetPaths === void 0) return void 0;
        const normalizedSourcePaths = getPathsRelativeToRootDirs(sourceDirectory, rootDirs, getCanonicalFileName);
        const relativePaths = flatMap(normalizedSourcePaths, (sourcePath)=>{
            return map(normalizedTargetPaths, (targetPath)=>ensurePathIsNonModuleName(getRelativePathFromDirectory(sourcePath, targetPath, getCanonicalFileName)));
        });
        const shortest = min(relativePaths, compareNumberOfDirectorySeparators);
        if (!shortest) return void 0;
        return processEnding(shortest, allowedEndings, compilerOptions);
    }
    function tryGetModuleNameAsNodeModule({ path, isRedirect }, { getCanonicalFileName, canonicalSourceDirectory }, importingSourceFile, host, options, userPreferences, packageNameOnly, overrideMode) {
        if (!host.fileExists || !host.readFile) return void 0;
        const parts = getNodeModulePathParts(path);
        if (!parts) return void 0;
        const preferences = getModuleSpecifierPreferences(userPreferences, host, options, importingSourceFile);
        const allowedEndings = preferences.getAllowedEndingsInPreferredOrder();
        let moduleSpecifier = path;
        let isPackageRootPath = false;
        if (!packageNameOnly) {
            let packageRootIndex = parts.packageRootIndex;
            let moduleFileName;
            while(true){
                const { moduleFileToTry, packageRootPath, blockedByExports, verbatimFromExports } = tryDirectoryWithPackageJson(packageRootIndex);
                if (getEmitModuleResolutionKind(options) !== 1 /* Classic */ ) {
                    if (blockedByExports) return void 0;
                    if (verbatimFromExports) return moduleFileToTry;
                }
                if (packageRootPath) {
                    moduleSpecifier = packageRootPath;
                    isPackageRootPath = true;
                    break;
                }
                if (!moduleFileName) moduleFileName = moduleFileToTry;
                packageRootIndex = path.indexOf(directorySeparator, packageRootIndex + 1);
                if (packageRootIndex === -1) {
                    moduleSpecifier = processEnding(moduleFileName, allowedEndings, options, host);
                    break;
                }
            }
        }
        if (isRedirect && !isPackageRootPath) return void 0;
        const globalTypingsCacheLocation = host.getGlobalTypingsCacheLocation && host.getGlobalTypingsCacheLocation();
        const pathToTopLevelNodeModules = getCanonicalFileName(moduleSpecifier.substring(0, parts.topLevelNodeModulesIndex));
        if (!(startsWith(canonicalSourceDirectory, pathToTopLevelNodeModules) || globalTypingsCacheLocation && startsWith(getCanonicalFileName(globalTypingsCacheLocation), pathToTopLevelNodeModules))) return void 0;
        const nodeModulesDirectoryName = moduleSpecifier.substring(parts.topLevelPackageNameIndex + 1);
        const packageName = getPackageNameFromTypesPackageName(nodeModulesDirectoryName);
        return getEmitModuleResolutionKind(options) === 1 /* Classic */  && packageName === nodeModulesDirectoryName ? void 0 : packageName;
        function tryDirectoryWithPackageJson(packageRootIndex) {
            var _a, _b;
            const packageRootPath = path.substring(0, packageRootIndex);
            const packageJsonPath = combinePaths(packageRootPath, "package.json");
            let moduleFileToTry = path;
            let maybeBlockedByTypesVersions = false;
            const cachedPackageJson = (_b = (_a = host.getPackageJsonInfoCache) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getPackageJsonInfo(packageJsonPath);
            if (isPackageJsonInfo(cachedPackageJson) || cachedPackageJson === void 0 && host.fileExists(packageJsonPath)) {
                const packageJsonContent = (cachedPackageJson == null ? void 0 : cachedPackageJson.contents.packageJsonContent) || tryParseJson(host.readFile(packageJsonPath));
                const importMode = overrideMode || getDefaultResolutionModeForFile(importingSourceFile, host, options);
                if (getResolvePackageJsonExports(options)) {
                    const nodeModulesDirectoryName2 = packageRootPath.substring(parts.topLevelPackageNameIndex + 1);
                    const packageName2 = getPackageNameFromTypesPackageName(nodeModulesDirectoryName2);
                    const conditions = getConditions(options, importMode);
                    const fromExports = (packageJsonContent == null ? void 0 : packageJsonContent.exports) ? tryGetModuleNameFromExports(options, host, path, packageRootPath, packageName2, packageJsonContent.exports, conditions) : void 0;
                    if (fromExports) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, fromExports), {
                        verbatimFromExports: true
                    });
                    if (packageJsonContent == null ? void 0 : packageJsonContent.exports) return {
                        moduleFileToTry: path,
                        blockedByExports: true
                    };
                }
                const versionPaths = (packageJsonContent == null ? void 0 : packageJsonContent.typesVersions) ? getPackageJsonTypesVersionsPaths(packageJsonContent.typesVersions) : void 0;
                if (versionPaths) {
                    const subModuleName = path.slice(packageRootPath.length + 1);
                    const fromPaths = tryGetModuleNameFromPaths(subModuleName, versionPaths.paths, allowedEndings, packageRootPath, getCanonicalFileName, host, options);
                    if (fromPaths === void 0) maybeBlockedByTypesVersions = true;
                    else moduleFileToTry = combinePaths(packageRootPath, fromPaths);
                }
                const mainFileRelative = (packageJsonContent == null ? void 0 : packageJsonContent.typings) || (packageJsonContent == null ? void 0 : packageJsonContent.types) || (packageJsonContent == null ? void 0 : packageJsonContent.main) || "index.js";
                if (isString(mainFileRelative) && !(maybeBlockedByTypesVersions && matchPatternOrExact(tryParsePatterns(versionPaths.paths), mainFileRelative))) {
                    const mainExportFile = toPath(mainFileRelative, packageRootPath, getCanonicalFileName);
                    const canonicalModuleFileToTry = getCanonicalFileName(moduleFileToTry);
                    if (removeFileExtension(mainExportFile) === removeFileExtension(canonicalModuleFileToTry)) return {
                        packageRootPath,
                        moduleFileToTry
                    };
                    else if ((packageJsonContent == null ? void 0 : packageJsonContent.type) !== "module" && !fileExtensionIsOneOf(canonicalModuleFileToTry, extensionsNotSupportingExtensionlessResolution) && startsWith(canonicalModuleFileToTry, mainExportFile) && getDirectoryPath(canonicalModuleFileToTry) === removeTrailingDirectorySeparator(mainExportFile) && removeFileExtension(getBaseFileName(canonicalModuleFileToTry)) === "index") return {
                        packageRootPath,
                        moduleFileToTry
                    };
                }
            } else {
                const fileName = getCanonicalFileName(moduleFileToTry.substring(parts.packageRootIndex + 1));
                if (fileName === "index.d.ts" || fileName === "index.js" || fileName === "index.ts" || fileName === "index.tsx") return {
                    moduleFileToTry,
                    packageRootPath
                };
            }
            return {
                moduleFileToTry
            };
        }
    }
    function tryGetAnyFileFromPath(host, path) {
        if (!host.fileExists) return;
        const extensions = flatten(getSupportedExtensions({
            allowJs: true
        }, [
            {
                extension: "node",
                isMixedContent: false
            },
            {
                extension: "json",
                isMixedContent: false,
                scriptKind: 6 /* JSON */ 
            }
        ]));
        for (const e of extensions){
            const fullPath = path + e;
            if (host.fileExists(fullPath)) return fullPath;
        }
    }
    function getPathsRelativeToRootDirs(path, rootDirs, getCanonicalFileName) {
        return mapDefined(rootDirs, (rootDir)=>{
            const relativePath = getRelativePathIfInSameVolume(path, rootDir, getCanonicalFileName);
            return relativePath !== void 0 && isPathRelativeToParent(relativePath) ? void 0 : relativePath;
        });
    }
    function processEnding(fileName, allowedEndings, options, host) {
        if (fileExtensionIsOneOf(fileName, [
            ".json" /* Json */ ,
            ".mjs" /* Mjs */ ,
            ".cjs" /* Cjs */ 
        ])) return fileName;
        const noExtension = removeFileExtension(fileName);
        if (fileName === noExtension) return fileName;
        const jsPriority = allowedEndings.indexOf(2 /* JsExtension */ );
        const tsPriority = allowedEndings.indexOf(3 /* TsExtension */ );
        if (fileExtensionIsOneOf(fileName, [
            ".mts" /* Mts */ ,
            ".cts" /* Cts */ 
        ]) && tsPriority !== -1 && tsPriority < jsPriority) return fileName;
        else if (fileExtensionIsOneOf(fileName, [
            ".d.mts" /* Dmts */ ,
            ".mts" /* Mts */ ,
            ".d.cts" /* Dcts */ ,
            ".cts" /* Cts */ 
        ])) return noExtension + getJSExtensionForFile(fileName, options);
        else if (!fileExtensionIsOneOf(fileName, [
            ".d.ts" /* Dts */ 
        ]) && fileExtensionIsOneOf(fileName, [
            ".ts" /* Ts */ 
        ]) && fileName.includes(".d.")) return tryGetRealFileNameForNonJsDeclarationFileName(fileName);
        switch(allowedEndings[0]){
            case 0 /* Minimal */ :
                const withoutIndex = removeSuffix(noExtension, "/index");
                if (host && withoutIndex !== noExtension && tryGetAnyFileFromPath(host, withoutIndex)) return noExtension;
                return withoutIndex;
            case 1 /* Index */ :
                return noExtension;
            case 2 /* JsExtension */ :
                return noExtension + getJSExtensionForFile(fileName, options);
            case 3 /* TsExtension */ :
                if (isDeclarationFileName(fileName)) {
                    const extensionlessPriority = allowedEndings.findIndex((e)=>e === 0 /* Minimal */  || e === 1 /* Index */ );
                    return extensionlessPriority !== -1 && extensionlessPriority < jsPriority ? noExtension : noExtension + getJSExtensionForFile(fileName, options);
                }
                return fileName;
            default:
                return Debug.assertNever(allowedEndings[0]);
        }
    }
    function tryGetRealFileNameForNonJsDeclarationFileName(fileName) {
        const baseName = getBaseFileName(fileName);
        if (!endsWith(fileName, ".ts" /* Ts */ ) || !baseName.includes(".d.") || fileExtensionIsOneOf(baseName, [
            ".d.ts" /* Dts */ 
        ])) return void 0;
        const noExtension = removeExtension(fileName, ".ts" /* Ts */ );
        const ext = noExtension.substring(noExtension.lastIndexOf("."));
        return noExtension.substring(0, noExtension.indexOf(".d.")) + ext;
    }
    function getJSExtensionForFile(fileName, options) {
        var _tryGetJSExtensionForFile;
        return (_tryGetJSExtensionForFile = tryGetJSExtensionForFile(fileName, options)) !== null && _tryGetJSExtensionForFile !== void 0 ? _tryGetJSExtensionForFile : Debug.fail(`Extension ${extensionFromPath(fileName)} is unsupported:: FileName:: ${fileName}`);
    }
    function tryGetJSExtensionForFile(fileName, options) {
        const ext = tryGetExtensionFromPath2(fileName);
        switch(ext){
            case ".ts" /* Ts */ :
            case ".d.ts" /* Dts */ :
                return ".js" /* Js */ ;
            case ".tsx" /* Tsx */ :
                return options.jsx === 1 /* Preserve */  ? ".jsx" /* Jsx */  : ".js" /* Js */ ;
            case ".js" /* Js */ :
            case ".jsx" /* Jsx */ :
            case ".json" /* Json */ :
                return ext;
            case ".d.mts" /* Dmts */ :
            case ".mts" /* Mts */ :
            case ".mjs" /* Mjs */ :
                return ".mjs" /* Mjs */ ;
            case ".d.cts" /* Dcts */ :
            case ".cts" /* Cts */ :
            case ".cjs" /* Cjs */ :
                return ".cjs" /* Cjs */ ;
            default:
                return void 0;
        }
    }
    function getRelativePathIfInSameVolume(path, directoryPath, getCanonicalFileName) {
        const relativePath = getRelativePathToDirectoryOrUrl(directoryPath, path, directoryPath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
        return isRootedDiskPath(relativePath) ? void 0 : relativePath;
    }
    function isPathRelativeToParent(path) {
        return startsWith(path, "..");
    }
    function getDefaultResolutionModeForFile(file, host, compilerOptions) {
        return isFullSourceFile(file) ? host.getDefaultResolutionModeForFile(file) : getDefaultResolutionModeForFileWorker(file, compilerOptions);
    }
    function prefersTsExtension(allowedEndings) {
        const tsPriority = allowedEndings.indexOf(3 /* TsExtension */ );
        return tsPriority > -1 && tsPriority < allowedEndings.indexOf(2 /* JsExtension */ );
    }
    // src/compiler/checker.ts
    var ambientModuleSymbolRegex = /^".+"$/;
    var anon = "(anonymous)";
    var nextSymbolId = 1;
    var nextNodeId = 1;
    var nextMergeId = 1;
    var nextFlowId = 1;
    var TypeFacts = /* @__PURE__ */ ((TypeFacts3)=>{
        TypeFacts3[TypeFacts3["None"] = 0] = "None";
        TypeFacts3[TypeFacts3["TypeofEQString"] = 1] = "TypeofEQString";
        TypeFacts3[TypeFacts3["TypeofEQNumber"] = 2] = "TypeofEQNumber";
        TypeFacts3[TypeFacts3["TypeofEQBigInt"] = 4] = "TypeofEQBigInt";
        TypeFacts3[TypeFacts3["TypeofEQBoolean"] = 8] = "TypeofEQBoolean";
        TypeFacts3[TypeFacts3["TypeofEQSymbol"] = 16] = "TypeofEQSymbol";
        TypeFacts3[TypeFacts3["TypeofEQObject"] = 32] = "TypeofEQObject";
        TypeFacts3[TypeFacts3["TypeofEQFunction"] = 64] = "TypeofEQFunction";
        TypeFacts3[TypeFacts3["TypeofEQHostObject"] = 128] = "TypeofEQHostObject";
        TypeFacts3[TypeFacts3["TypeofNEString"] = 256] = "TypeofNEString";
        TypeFacts3[TypeFacts3["TypeofNENumber"] = 512] = "TypeofNENumber";
        TypeFacts3[TypeFacts3["TypeofNEBigInt"] = 1024] = "TypeofNEBigInt";
        TypeFacts3[TypeFacts3["TypeofNEBoolean"] = 2048] = "TypeofNEBoolean";
        TypeFacts3[TypeFacts3["TypeofNESymbol"] = 4096] = "TypeofNESymbol";
        TypeFacts3[TypeFacts3["TypeofNEObject"] = 8192] = "TypeofNEObject";
        TypeFacts3[TypeFacts3["TypeofNEFunction"] = 16384] = "TypeofNEFunction";
        TypeFacts3[TypeFacts3["TypeofNEHostObject"] = 32768] = "TypeofNEHostObject";
        TypeFacts3[TypeFacts3["EQUndefined"] = 65536] = "EQUndefined";
        TypeFacts3[TypeFacts3["EQNull"] = 131072] = "EQNull";
        TypeFacts3[TypeFacts3["EQUndefinedOrNull"] = 262144] = "EQUndefinedOrNull";
        TypeFacts3[TypeFacts3["NEUndefined"] = 524288] = "NEUndefined";
        TypeFacts3[TypeFacts3["NENull"] = 1048576] = "NENull";
        TypeFacts3[TypeFacts3["NEUndefinedOrNull"] = 2097152] = "NEUndefinedOrNull";
        TypeFacts3[TypeFacts3["Truthy"] = 4194304] = "Truthy";
        TypeFacts3[TypeFacts3["Falsy"] = 8388608] = "Falsy";
        TypeFacts3[TypeFacts3["IsUndefined"] = 16777216] = "IsUndefined";
        TypeFacts3[TypeFacts3["IsNull"] = 33554432] = "IsNull";
        TypeFacts3[TypeFacts3["IsUndefinedOrNull"] = 50331648] = "IsUndefinedOrNull";
        TypeFacts3[TypeFacts3["All"] = 134217727] = "All";
        TypeFacts3[TypeFacts3["BaseStringStrictFacts"] = 3735041] = "BaseStringStrictFacts";
        TypeFacts3[TypeFacts3["BaseStringFacts"] = 12582401] = "BaseStringFacts";
        TypeFacts3[TypeFacts3["StringStrictFacts"] = 16317953] = "StringStrictFacts";
        TypeFacts3[TypeFacts3["StringFacts"] = 16776705] = "StringFacts";
        TypeFacts3[TypeFacts3["EmptyStringStrictFacts"] = 12123649] = "EmptyStringStrictFacts";
        TypeFacts3[TypeFacts3["EmptyStringFacts"] = 12582401 /* BaseStringFacts */ ] = "EmptyStringFacts";
        TypeFacts3[TypeFacts3["NonEmptyStringStrictFacts"] = 7929345] = "NonEmptyStringStrictFacts";
        TypeFacts3[TypeFacts3["NonEmptyStringFacts"] = 16776705] = "NonEmptyStringFacts";
        TypeFacts3[TypeFacts3["BaseNumberStrictFacts"] = 3734786] = "BaseNumberStrictFacts";
        TypeFacts3[TypeFacts3["BaseNumberFacts"] = 12582146] = "BaseNumberFacts";
        TypeFacts3[TypeFacts3["NumberStrictFacts"] = 16317698] = "NumberStrictFacts";
        TypeFacts3[TypeFacts3["NumberFacts"] = 16776450] = "NumberFacts";
        TypeFacts3[TypeFacts3["ZeroNumberStrictFacts"] = 12123394] = "ZeroNumberStrictFacts";
        TypeFacts3[TypeFacts3["ZeroNumberFacts"] = 12582146 /* BaseNumberFacts */ ] = "ZeroNumberFacts";
        TypeFacts3[TypeFacts3["NonZeroNumberStrictFacts"] = 7929090] = "NonZeroNumberStrictFacts";
        TypeFacts3[TypeFacts3["NonZeroNumberFacts"] = 16776450] = "NonZeroNumberFacts";
        TypeFacts3[TypeFacts3["BaseBigIntStrictFacts"] = 3734276] = "BaseBigIntStrictFacts";
        TypeFacts3[TypeFacts3["BaseBigIntFacts"] = 12581636] = "BaseBigIntFacts";
        TypeFacts3[TypeFacts3["BigIntStrictFacts"] = 16317188] = "BigIntStrictFacts";
        TypeFacts3[TypeFacts3["BigIntFacts"] = 16775940] = "BigIntFacts";
        TypeFacts3[TypeFacts3["ZeroBigIntStrictFacts"] = 12122884] = "ZeroBigIntStrictFacts";
        TypeFacts3[TypeFacts3["ZeroBigIntFacts"] = 12581636 /* BaseBigIntFacts */ ] = "ZeroBigIntFacts";
        TypeFacts3[TypeFacts3["NonZeroBigIntStrictFacts"] = 7928580] = "NonZeroBigIntStrictFacts";
        TypeFacts3[TypeFacts3["NonZeroBigIntFacts"] = 16775940] = "NonZeroBigIntFacts";
        TypeFacts3[TypeFacts3["BaseBooleanStrictFacts"] = 3733256] = "BaseBooleanStrictFacts";
        TypeFacts3[TypeFacts3["BaseBooleanFacts"] = 12580616] = "BaseBooleanFacts";
        TypeFacts3[TypeFacts3["BooleanStrictFacts"] = 16316168] = "BooleanStrictFacts";
        TypeFacts3[TypeFacts3["BooleanFacts"] = 16774920] = "BooleanFacts";
        TypeFacts3[TypeFacts3["FalseStrictFacts"] = 12121864] = "FalseStrictFacts";
        TypeFacts3[TypeFacts3["FalseFacts"] = 12580616 /* BaseBooleanFacts */ ] = "FalseFacts";
        TypeFacts3[TypeFacts3["TrueStrictFacts"] = 7927560] = "TrueStrictFacts";
        TypeFacts3[TypeFacts3["TrueFacts"] = 16774920] = "TrueFacts";
        TypeFacts3[TypeFacts3["SymbolStrictFacts"] = 7925520] = "SymbolStrictFacts";
        TypeFacts3[TypeFacts3["SymbolFacts"] = 16772880] = "SymbolFacts";
        TypeFacts3[TypeFacts3["ObjectStrictFacts"] = 7888800] = "ObjectStrictFacts";
        TypeFacts3[TypeFacts3["ObjectFacts"] = 16736160] = "ObjectFacts";
        TypeFacts3[TypeFacts3["FunctionStrictFacts"] = 7880640] = "FunctionStrictFacts";
        TypeFacts3[TypeFacts3["FunctionFacts"] = 16728e3] = "FunctionFacts";
        TypeFacts3[TypeFacts3["VoidFacts"] = 9830144] = "VoidFacts";
        TypeFacts3[TypeFacts3["UndefinedFacts"] = 26607360] = "UndefinedFacts";
        TypeFacts3[TypeFacts3["NullFacts"] = 42917664] = "NullFacts";
        TypeFacts3[TypeFacts3["EmptyObjectStrictFacts"] = 83427327] = "EmptyObjectStrictFacts";
        TypeFacts3[TypeFacts3["EmptyObjectFacts"] = 83886079] = "EmptyObjectFacts";
        TypeFacts3[TypeFacts3["UnknownFacts"] = 83886079] = "UnknownFacts";
        TypeFacts3[TypeFacts3["AllTypeofNE"] = 556800] = "AllTypeofNE";
        TypeFacts3[TypeFacts3["OrFactsMask"] = 8256] = "OrFactsMask";
        TypeFacts3[TypeFacts3["AndFactsMask"] = 134209471] = "AndFactsMask";
        return TypeFacts3;
    })(TypeFacts || {});
    var typeofNEFacts = new Map(Object.entries({
        string: 256 /* TypeofNEString */ ,
        number: 512 /* TypeofNENumber */ ,
        bigint: 1024 /* TypeofNEBigInt */ ,
        boolean: 2048 /* TypeofNEBoolean */ ,
        symbol: 4096 /* TypeofNESymbol */ ,
        undefined: 524288 /* NEUndefined */ ,
        object: 8192 /* TypeofNEObject */ ,
        function: 16384 /* TypeofNEFunction */ 
    }));
    var CheckMode = /* @__PURE__ */ ((CheckMode3)=>{
        CheckMode3[CheckMode3["Normal"] = 0] = "Normal";
        CheckMode3[CheckMode3["Contextual"] = 1] = "Contextual";
        CheckMode3[CheckMode3["Inferential"] = 2] = "Inferential";
        CheckMode3[CheckMode3["SkipContextSensitive"] = 4] = "SkipContextSensitive";
        CheckMode3[CheckMode3["SkipGenericFunctions"] = 8] = "SkipGenericFunctions";
        CheckMode3[CheckMode3["IsForSignatureHelp"] = 16] = "IsForSignatureHelp";
        CheckMode3[CheckMode3["RestBindingElement"] = 32] = "RestBindingElement";
        CheckMode3[CheckMode3["TypeOnly"] = 64] = "TypeOnly";
        return CheckMode3;
    })(CheckMode || {});
    var SignatureCheckMode = /* @__PURE__ */ ((SignatureCheckMode3)=>{
        SignatureCheckMode3[SignatureCheckMode3["None"] = 0] = "None";
        SignatureCheckMode3[SignatureCheckMode3["BivariantCallback"] = 1] = "BivariantCallback";
        SignatureCheckMode3[SignatureCheckMode3["StrictCallback"] = 2] = "StrictCallback";
        SignatureCheckMode3[SignatureCheckMode3["IgnoreReturnTypes"] = 4] = "IgnoreReturnTypes";
        SignatureCheckMode3[SignatureCheckMode3["StrictArity"] = 8] = "StrictArity";
        SignatureCheckMode3[SignatureCheckMode3["StrictTopSignature"] = 16] = "StrictTopSignature";
        SignatureCheckMode3[SignatureCheckMode3["Callback"] = 3] = "Callback";
        return SignatureCheckMode3;
    })(SignatureCheckMode || {});
    var isNotOverloadAndNotAccessor = and(isNotOverload, isNotAccessor);
    var intrinsicTypeKinds = new Map(Object.entries({
        Uppercase: 0 /* Uppercase */ ,
        Lowercase: 1 /* Lowercase */ ,
        Capitalize: 2 /* Capitalize */ ,
        Uncapitalize: 3 /* Uncapitalize */ ,
        NoInfer: 4 /* NoInfer */ 
    }));
    var SymbolLinks = class {
    };
    function NodeLinks() {
        this.flags = 0 /* None */ ;
    }
    function getNodeId(node) {
        if (!node.id) {
            node.id = nextNodeId;
            nextNodeId++;
        }
        return node.id;
    }
    function getSymbolId(symbol) {
        if (!symbol.id) {
            symbol.id = nextSymbolId;
            nextSymbolId++;
        }
        return symbol.id;
    }
    function isInstantiatedModule(node, preserveConstEnums) {
        const moduleState = getModuleInstanceState(node);
        return moduleState === 1 /* Instantiated */  || preserveConstEnums && moduleState === 2 /* ConstEnumOnly */ ;
    }
    function createTypeChecker(host) {
        var deferredDiagnosticsCallbacks = [];
        var addLazyDiagnostic = (arg)=>{
            deferredDiagnosticsCallbacks.push(arg);
        };
        var cancellationToken;
        var scanner2;
        var Symbol48 = objectAllocator.getSymbolConstructor();
        var Type29 = objectAllocator.getTypeConstructor();
        var Signature13 = objectAllocator.getSignatureConstructor();
        var typeCount = 0;
        var symbolCount = 0;
        var totalInstantiationCount = 0;
        var instantiationCount = 0;
        var instantiationDepth = 0;
        var inlineLevel = 0;
        var currentNode;
        var varianceTypeParameter;
        var isInferencePartiallyBlocked = false;
        var emptySymbols = createSymbolTable();
        var arrayVariances = [
            1 /* Covariant */ 
        ];
        var compilerOptions = host.getCompilerOptions();
        var languageVersion = getEmitScriptTarget(compilerOptions);
        var moduleKind = getEmitModuleKind(compilerOptions);
        var legacyDecorators = !!compilerOptions.experimentalDecorators;
        var useDefineForClassFields = getUseDefineForClassFields(compilerOptions);
        var emitStandardClassFields = getEmitStandardClassFields(compilerOptions);
        var allowSyntheticDefaultImports = getAllowSyntheticDefaultImports(compilerOptions);
        var strictNullChecks = getStrictOptionValue(compilerOptions, "strictNullChecks");
        var strictFunctionTypes = getStrictOptionValue(compilerOptions, "strictFunctionTypes");
        var strictBindCallApply = getStrictOptionValue(compilerOptions, "strictBindCallApply");
        var strictPropertyInitialization = getStrictOptionValue(compilerOptions, "strictPropertyInitialization");
        var strictBuiltinIteratorReturn = getStrictOptionValue(compilerOptions, "strictBuiltinIteratorReturn");
        var noImplicitAny = getStrictOptionValue(compilerOptions, "noImplicitAny");
        var noImplicitThis = getStrictOptionValue(compilerOptions, "noImplicitThis");
        var useUnknownInCatchVariables = getStrictOptionValue(compilerOptions, "useUnknownInCatchVariables");
        var exactOptionalPropertyTypes = compilerOptions.exactOptionalPropertyTypes;
        var noUncheckedSideEffectImports = !!compilerOptions.noUncheckedSideEffectImports;
        var checkBinaryExpression = createCheckBinaryExpression();
        var emitResolver = createResolver();
        var nodeBuilder = createNodeBuilder();
        var syntacticNodeBuilder = createSyntacticTypeNodeBuilder(compilerOptions, nodeBuilder.syntacticBuilderResolver);
        var evaluate = createEvaluator({
            evaluateElementAccessExpression,
            evaluateEntityNameExpression
        });
        var globals = createSymbolTable();
        var undefinedSymbol = createSymbol(4 /* Property */ , "undefined");
        undefinedSymbol.declarations = [];
        var globalThisSymbol = createSymbol(1536 /* Module */ , "globalThis", 8 /* Readonly */ );
        globalThisSymbol.exports = globals;
        globalThisSymbol.declarations = [];
        globals.set(globalThisSymbol.escapedName, globalThisSymbol);
        var argumentsSymbol = createSymbol(4 /* Property */ , "arguments");
        var requireSymbol = createSymbol(4 /* Property */ , "require");
        var isolatedModulesLikeFlagName = compilerOptions.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules";
        var canCollectSymbolAliasAccessabilityData = !compilerOptions.verbatimModuleSyntax;
        var apparentArgumentCount;
        var lastGetCombinedNodeFlagsNode;
        var lastGetCombinedNodeFlagsResult = 0 /* None */ ;
        var lastGetCombinedModifierFlagsNode;
        var lastGetCombinedModifierFlagsResult = 0 /* None */ ;
        var resolveName = createNameResolver({
            compilerOptions,
            requireSymbol,
            argumentsSymbol,
            globals,
            getSymbolOfDeclaration,
            error: error2,
            getRequiresScopeChangeCache,
            setRequiresScopeChangeCache,
            lookup: getSymbol2,
            onPropertyWithInvalidInitializer: checkAndReportErrorForInvalidInitializer,
            onFailedToResolveSymbol,
            onSuccessfullyResolvedSymbol
        });
        var resolveNameForSymbolSuggestion = createNameResolver({
            compilerOptions,
            requireSymbol,
            argumentsSymbol,
            globals,
            getSymbolOfDeclaration,
            error: error2,
            getRequiresScopeChangeCache,
            setRequiresScopeChangeCache,
            lookup: getSuggestionForSymbolNameLookup
        });
        const checker = {
            getNodeCount: ()=>reduceLeft(host.getSourceFiles(), (n, s)=>n + s.nodeCount, 0),
            getIdentifierCount: ()=>reduceLeft(host.getSourceFiles(), (n, s)=>n + s.identifierCount, 0),
            getSymbolCount: ()=>reduceLeft(host.getSourceFiles(), (n, s)=>n + s.symbolCount, symbolCount),
            getTypeCount: ()=>typeCount,
            getInstantiationCount: ()=>totalInstantiationCount,
            getRelationCacheSizes: ()=>({
                    assignable: assignableRelation.size,
                    identity: identityRelation.size,
                    subtype: subtypeRelation.size,
                    strictSubtype: strictSubtypeRelation.size
                }),
            isUndefinedSymbol: (symbol)=>symbol === undefinedSymbol,
            isArgumentsSymbol: (symbol)=>symbol === argumentsSymbol,
            isUnknownSymbol: (symbol)=>symbol === unknownSymbol,
            getMergedSymbol,
            symbolIsValue,
            getDiagnostics: getDiagnostics2,
            getGlobalDiagnostics,
            getRecursionIdentity,
            getUnmatchedProperties,
            getTypeOfSymbolAtLocation: (symbol, locationIn)=>{
                const location = getParseTreeNode(locationIn);
                return location ? getTypeOfSymbolAtLocation(symbol, location) : errorType;
            },
            getTypeOfSymbol,
            getSymbolsOfParameterPropertyDeclaration: (parameterIn, parameterName)=>{
                const parameter = getParseTreeNode(parameterIn, isParameter);
                if (parameter === void 0) return Debug.fail("Cannot get symbols of a synthetic parameter that cannot be resolved to a parse-tree node.");
                Debug.assert(isParameterPropertyDeclaration(parameter, parameter.parent));
                return getSymbolsOfParameterPropertyDeclaration(parameter, escapeLeadingUnderscores(parameterName));
            },
            getDeclaredTypeOfSymbol,
            getPropertiesOfType,
            getPropertyOfType: (type, name)=>getPropertyOfType(type, escapeLeadingUnderscores(name)),
            getPrivateIdentifierPropertyOfType: (leftType, name, location)=>{
                const node = getParseTreeNode(location);
                if (!node) return void 0;
                const propName = escapeLeadingUnderscores(name);
                const lexicallyScopedIdentifier = lookupSymbolForPrivateIdentifierDeclaration(propName, node);
                return lexicallyScopedIdentifier ? getPrivateIdentifierPropertyOfType(leftType, lexicallyScopedIdentifier) : void 0;
            },
            getTypeOfPropertyOfType: (type, name)=>getTypeOfPropertyOfType(type, escapeLeadingUnderscores(name)),
            getIndexInfoOfType: (type, kind)=>getIndexInfoOfType(type, kind === 0 /* String */  ? stringType : numberType),
            getIndexInfosOfType,
            getIndexInfosOfIndexSymbol,
            getSignaturesOfType,
            getIndexTypeOfType: (type, kind)=>getIndexTypeOfType(type, kind === 0 /* String */  ? stringType : numberType),
            getIndexType: (type)=>getIndexType(type),
            getBaseTypes,
            getBaseTypeOfLiteralType,
            getWidenedType,
            getWidenedLiteralType,
            fillMissingTypeArguments,
            getTypeFromTypeNode: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isTypeNode);
                return node ? getTypeFromTypeNode(node) : errorType;
            },
            getParameterType: getTypeAtPosition,
            getParameterIdentifierInfoAtPosition,
            getPromisedTypeOfPromise,
            getAwaitedType: (type)=>getAwaitedType(type),
            getReturnTypeOfSignature,
            isNullableType,
            getNullableType,
            getNonNullableType,
            getNonOptionalType: removeOptionalTypeMarker,
            getTypeArguments,
            typeToTypeNode: nodeBuilder.typeToTypeNode,
            typePredicateToTypePredicateNode: nodeBuilder.typePredicateToTypePredicateNode,
            indexInfoToIndexSignatureDeclaration: nodeBuilder.indexInfoToIndexSignatureDeclaration,
            signatureToSignatureDeclaration: nodeBuilder.signatureToSignatureDeclaration,
            symbolToEntityName: nodeBuilder.symbolToEntityName,
            symbolToExpression: nodeBuilder.symbolToExpression,
            symbolToNode: nodeBuilder.symbolToNode,
            symbolToTypeParameterDeclarations: nodeBuilder.symbolToTypeParameterDeclarations,
            symbolToParameterDeclaration: nodeBuilder.symbolToParameterDeclaration,
            typeParameterToDeclaration: nodeBuilder.typeParameterToDeclaration,
            getSymbolsInScope: (locationIn, meaning)=>{
                const location = getParseTreeNode(locationIn);
                return location ? getSymbolsInScope(location, meaning) : [];
            },
            getSymbolAtLocation: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getSymbolAtLocation(node, /*ignoreErrors*/ true) : void 0;
            },
            getIndexInfosAtLocation: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getIndexInfosAtLocation(node) : void 0;
            },
            getShorthandAssignmentValueSymbol: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getShorthandAssignmentValueSymbol(node) : void 0;
            },
            getExportSpecifierLocalTargetSymbol: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isExportSpecifier);
                return node ? getExportSpecifierLocalTargetSymbol(node) : void 0;
            },
            getExportSymbolOfSymbol (symbol) {
                return getMergedSymbol(symbol.exportSymbol || symbol);
            },
            getTypeAtLocation: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn);
                return node ? getTypeOfNode(node) : errorType;
            },
            getTypeOfAssignmentPattern: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isAssignmentPattern);
                return node && getTypeOfAssignmentPattern(node) || errorType;
            },
            getPropertySymbolOfDestructuringAssignment: (locationIn)=>{
                const location = getParseTreeNode(locationIn, isIdentifier);
                return location ? getPropertySymbolOfDestructuringAssignment(location) : void 0;
            },
            signatureToString: (signature, enclosingDeclaration, flags, kind)=>{
                return signatureToString(signature, getParseTreeNode(enclosingDeclaration), flags, kind);
            },
            typeToString: (type, enclosingDeclaration, flags)=>{
                return typeToString(type, getParseTreeNode(enclosingDeclaration), flags);
            },
            symbolToString: (symbol, enclosingDeclaration, meaning, flags)=>{
                return symbolToString(symbol, getParseTreeNode(enclosingDeclaration), meaning, flags);
            },
            typePredicateToString: (predicate, enclosingDeclaration, flags)=>{
                return typePredicateToString(predicate, getParseTreeNode(enclosingDeclaration), flags);
            },
            writeSignature: (signature, enclosingDeclaration, flags, kind, writer, maximumLength, verbosityLevel, out)=>{
                return signatureToString(signature, getParseTreeNode(enclosingDeclaration), flags, kind, writer, maximumLength, verbosityLevel, out);
            },
            writeType: (type, enclosingDeclaration, flags, writer, maximumLength, verbosityLevel, out)=>{
                return typeToString(type, getParseTreeNode(enclosingDeclaration), flags, writer, maximumLength, verbosityLevel, out);
            },
            writeSymbol: (symbol, enclosingDeclaration, meaning, flags, writer)=>{
                return symbolToString(symbol, getParseTreeNode(enclosingDeclaration), meaning, flags, writer);
            },
            writeTypePredicate: (predicate, enclosingDeclaration, flags, writer)=>{
                return typePredicateToString(predicate, getParseTreeNode(enclosingDeclaration), flags, writer);
            },
            getAugmentedPropertiesOfType,
            getRootSymbols,
            getSymbolOfExpando,
            getContextualType: (nodeIn, contextFlags)=>{
                const node = getParseTreeNode(nodeIn, isExpression);
                if (!node) return void 0;
                if (contextFlags & 4 /* Completions */ ) return runWithInferenceBlockedFromSourceNode(node, ()=>getContextualType2(node, contextFlags));
                return getContextualType2(node, contextFlags);
            },
            getContextualTypeForObjectLiteralElement: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isObjectLiteralElementLike);
                return node ? getContextualTypeForObjectLiteralElement(node, /*contextFlags*/ void 0) : void 0;
            },
            getContextualTypeForArgumentAtIndex: (nodeIn, argIndex)=>{
                const node = getParseTreeNode(nodeIn, isCallLikeExpression);
                return node && getContextualTypeForArgumentAtIndex(node, argIndex);
            },
            getContextualTypeForJsxAttribute: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isJsxAttributeLike);
                return node && getContextualTypeForJsxAttribute(node, /*contextFlags*/ void 0);
            },
            isContextSensitive,
            getTypeOfPropertyOfContextualType,
            getFullyQualifiedName,
            getResolvedSignature: (node, candidatesOutArray, argumentCount)=>getResolvedSignatureWorker(node, candidatesOutArray, argumentCount, 0 /* Normal */ ),
            getCandidateSignaturesForStringLiteralCompletions,
            getResolvedSignatureForSignatureHelp: (node, candidatesOutArray, argumentCount)=>runWithoutResolvedSignatureCaching(node, ()=>getResolvedSignatureWorker(node, candidatesOutArray, argumentCount, 16 /* IsForSignatureHelp */ )),
            getExpandedParameters,
            hasEffectiveRestParameter,
            containsArgumentsReference,
            getConstantValue: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, canHaveConstantValue);
                return node ? getConstantValue2(node) : void 0;
            },
            isValidPropertyAccess: (nodeIn, propertyName)=>{
                const node = getParseTreeNode(nodeIn, isPropertyAccessOrQualifiedNameOrImportTypeNode);
                return !!node && isValidPropertyAccess(node, escapeLeadingUnderscores(propertyName));
            },
            isValidPropertyAccessForCompletions: (nodeIn, type, property)=>{
                const node = getParseTreeNode(nodeIn, isPropertyAccessExpression);
                return !!node && isValidPropertyAccessForCompletions(node, type, property);
            },
            getSignatureFromDeclaration: (declarationIn)=>{
                const declaration = getParseTreeNode(declarationIn, isFunctionLike);
                return declaration ? getSignatureFromDeclaration(declaration) : void 0;
            },
            isImplementationOfOverload: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isFunctionLike);
                return node ? isImplementationOfOverload(node) : void 0;
            },
            getImmediateAliasedSymbol,
            getAliasedSymbol: resolveAlias,
            getEmitResolver,
            requiresAddingImplicitUndefined,
            getExportsOfModule: getExportsOfModuleAsArray,
            getExportsAndPropertiesOfModule,
            forEachExportAndPropertyOfModule,
            getSymbolWalker: createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getConstraintOfTypeParameter, getFirstIdentifier, getTypeArguments),
            getAmbientModules,
            getJsxIntrinsicTagNamesAt,
            isOptionalParameter: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isParameter);
                return node ? isOptionalParameter(node) : false;
            },
            tryGetMemberInModuleExports: (name, symbol)=>tryGetMemberInModuleExports(escapeLeadingUnderscores(name), symbol),
            tryGetMemberInModuleExportsAndProperties: (name, symbol)=>tryGetMemberInModuleExportsAndProperties(escapeLeadingUnderscores(name), symbol),
            tryFindAmbientModule: (moduleName)=>tryFindAmbientModule(moduleName, /*withAugmentations*/ true),
            getApparentType,
            getUnionType,
            isTypeAssignableTo,
            createAnonymousType,
            createSignature,
            createSymbol,
            createIndexInfo,
            getAnyType: ()=>anyType,
            getStringType: ()=>stringType,
            getStringLiteralType,
            getNumberType: ()=>numberType,
            getNumberLiteralType,
            getBigIntType: ()=>bigintType,
            getBigIntLiteralType,
            getUnknownType: ()=>unknownType,
            createPromiseType,
            createArrayType,
            getElementTypeOfArrayType,
            getBooleanType: ()=>booleanType,
            getFalseType: (fresh)=>fresh ? falseType : regularFalseType,
            getTrueType: (fresh)=>fresh ? trueType : regularTrueType,
            getVoidType: ()=>voidType,
            getUndefinedType: ()=>undefinedType,
            getNullType: ()=>nullType,
            getESSymbolType: ()=>esSymbolType,
            getNeverType: ()=>neverType,
            getNonPrimitiveType: ()=>nonPrimitiveType,
            getOptionalType: ()=>optionalType,
            getPromiseType: ()=>getGlobalPromiseType(/*reportErrors*/ false),
            getPromiseLikeType: ()=>getGlobalPromiseLikeType(/*reportErrors*/ false),
            getAnyAsyncIterableType: ()=>{
                const type = getGlobalAsyncIterableType(/*reportErrors*/ false);
                if (type === emptyGenericType) return void 0;
                return createTypeReference(type, [
                    anyType,
                    anyType,
                    anyType
                ]);
            },
            isSymbolAccessible,
            isArrayType,
            isTupleType,
            isArrayLikeType,
            isEmptyAnonymousObjectType,
            isTypeInvalidDueToUnionDiscriminant,
            getExactOptionalProperties,
            getAllPossiblePropertiesOfTypes,
            getSuggestedSymbolForNonexistentProperty,
            getSuggestedSymbolForNonexistentJSXAttribute,
            getSuggestedSymbolForNonexistentSymbol: (location, name, meaning)=>getSuggestedSymbolForNonexistentSymbol(location, escapeLeadingUnderscores(name), meaning),
            getSuggestedSymbolForNonexistentModule,
            getSuggestedSymbolForNonexistentClassMember,
            getBaseConstraintOfType,
            getDefaultFromTypeParameter: (type)=>type && type.flags & 262144 /* TypeParameter */  ? getDefaultFromTypeParameter(type) : void 0,
            resolveName (name, location, meaning, excludeGlobals) {
                return resolveName(location, escapeLeadingUnderscores(name), meaning, /*nameNotFoundMessage*/ void 0, /*isUse*/ false, excludeGlobals);
            },
            getJsxNamespace: (n)=>unescapeLeadingUnderscores(getJsxNamespace(n)),
            getJsxFragmentFactory: (n)=>{
                const jsxFragmentFactory = getJsxFragmentFactoryEntity(n);
                return jsxFragmentFactory && unescapeLeadingUnderscores(getFirstIdentifier(jsxFragmentFactory).escapedText);
            },
            getAccessibleSymbolChain,
            getTypePredicateOfSignature,
            resolveExternalModuleName: (moduleSpecifierIn)=>{
                const moduleSpecifier = getParseTreeNode(moduleSpecifierIn, isExpression);
                return moduleSpecifier && resolveExternalModuleName(moduleSpecifier, moduleSpecifier, /*ignoreErrors*/ true);
            },
            resolveExternalModuleSymbol,
            tryGetThisTypeAt: (nodeIn, includeGlobalThis, container)=>{
                const node = getParseTreeNode(nodeIn);
                return node && tryGetThisTypeAt(node, includeGlobalThis, container);
            },
            getTypeArgumentConstraint: (nodeIn)=>{
                const node = getParseTreeNode(nodeIn, isTypeNode);
                return node && getTypeArgumentConstraint(node);
            },
            getSuggestionDiagnostics: (fileIn, ct)=>{
                const file = getParseTreeNode(fileIn, isSourceFile) || Debug.fail("Could not determine parsed source file.");
                if (skipTypeChecking(file, compilerOptions, host)) return emptyArray;
                let diagnostics2;
                try {
                    cancellationToken = ct;
                    checkSourceFileWithEagerDiagnostics(file);
                    Debug.assert(!!(getNodeLinks(file).flags & 1 /* TypeChecked */ ));
                    diagnostics2 = addRange(diagnostics2, suggestionDiagnostics.getDiagnostics(file.fileName));
                    checkUnusedIdentifiers(getPotentiallyUnusedIdentifiers(file), (containingNode, kind, diag2)=>{
                        if (!containsParseError(containingNode) && !unusedIsError(kind, !!(containingNode.flags & 33554432 /* Ambient */ ))) (diagnostics2 || (diagnostics2 = [])).push((0, _objectSpreadProps._)((0, _objectSpread._)({}, diag2), {
                            category: 2 /* Suggestion */ 
                        }));
                    });
                    return diagnostics2 || emptyArray;
                } finally{
                    cancellationToken = void 0;
                }
            },
            runWithCancellationToken: (token, callback)=>{
                try {
                    cancellationToken = token;
                    return callback(checker);
                } finally{
                    cancellationToken = void 0;
                }
            },
            getLocalTypeParametersOfClassOrInterfaceOrTypeAlias,
            isDeclarationVisible,
            isPropertyAccessible,
            getTypeOnlyAliasDeclaration,
            getMemberOverrideModifierStatus,
            isTypeParameterPossiblyReferenced,
            typeHasCallOrConstructSignatures,
            getSymbolFlags,
            getTypeArgumentsForResolvedSignature,
            isLibType
        };
        function getTypeArgumentsForResolvedSignature(signature) {
            if (signature.mapper === void 0) return void 0;
            return instantiateTypes((signature.target || signature).typeParameters, signature.mapper);
        }
        function getCandidateSignaturesForStringLiteralCompletions(call, editingArgument) {
            const candidatesSet = /* @__PURE__ */ new Set();
            const candidates = [];
            runWithInferenceBlockedFromSourceNode(editingArgument, ()=>getResolvedSignatureWorker(call, candidates, /*argumentCount*/ void 0, 0 /* Normal */ ));
            for (const candidate of candidates)candidatesSet.add(candidate);
            candidates.length = 0;
            runWithoutResolvedSignatureCaching(editingArgument, ()=>getResolvedSignatureWorker(call, candidates, /*argumentCount*/ void 0, 0 /* Normal */ ));
            for (const candidate of candidates)candidatesSet.add(candidate);
            return arrayFrom(candidatesSet);
        }
        function runWithoutResolvedSignatureCaching(node, fn) {
            node = findAncestor(node, isCallLikeOrFunctionLikeExpression);
            if (node) {
                const cachedResolvedSignatures = [];
                const cachedTypes2 = [];
                while(node){
                    const nodeLinks2 = getNodeLinks(node);
                    cachedResolvedSignatures.push([
                        nodeLinks2,
                        nodeLinks2.resolvedSignature
                    ]);
                    nodeLinks2.resolvedSignature = void 0;
                    if (isFunctionExpressionOrArrowFunction(node)) {
                        const symbolLinks2 = getSymbolLinks(getSymbolOfDeclaration(node));
                        const type = symbolLinks2.type;
                        cachedTypes2.push([
                            symbolLinks2,
                            type
                        ]);
                        symbolLinks2.type = void 0;
                    }
                    node = findAncestor(node.parent, isCallLikeOrFunctionLikeExpression);
                }
                const result = fn();
                for (const [nodeLinks2, resolvedSignature] of cachedResolvedSignatures)nodeLinks2.resolvedSignature = resolvedSignature;
                for (const [symbolLinks2, type] of cachedTypes2)symbolLinks2.type = type;
                return result;
            }
            return fn();
        }
        function runWithInferenceBlockedFromSourceNode(node, fn) {
            const containingCall = findAncestor(node, isCallLikeExpression);
            if (containingCall) {
                let toMarkSkip = node;
                do {
                    getNodeLinks(toMarkSkip).skipDirectInference = true;
                    toMarkSkip = toMarkSkip.parent;
                }while (toMarkSkip && toMarkSkip !== containingCall);
            }
            isInferencePartiallyBlocked = true;
            const result = runWithoutResolvedSignatureCaching(node, fn);
            isInferencePartiallyBlocked = false;
            if (containingCall) {
                let toMarkSkip = node;
                do {
                    getNodeLinks(toMarkSkip).skipDirectInference = void 0;
                    toMarkSkip = toMarkSkip.parent;
                }while (toMarkSkip && toMarkSkip !== containingCall);
            }
            return result;
        }
        function getResolvedSignatureWorker(nodeIn, candidatesOutArray, argumentCount, checkMode) {
            const node = getParseTreeNode(nodeIn, isCallLikeExpression);
            apparentArgumentCount = argumentCount;
            const res = !node ? void 0 : getResolvedSignature(node, candidatesOutArray, checkMode);
            apparentArgumentCount = void 0;
            return res;
        }
        var tupleTypes = /* @__PURE__ */ new Map();
        var unionTypes = /* @__PURE__ */ new Map();
        var unionOfUnionTypes = /* @__PURE__ */ new Map();
        var intersectionTypes = /* @__PURE__ */ new Map();
        var stringLiteralTypes = /* @__PURE__ */ new Map();
        var numberLiteralTypes = /* @__PURE__ */ new Map();
        var bigIntLiteralTypes = /* @__PURE__ */ new Map();
        var enumLiteralTypes = /* @__PURE__ */ new Map();
        var indexedAccessTypes = /* @__PURE__ */ new Map();
        var templateLiteralTypes = /* @__PURE__ */ new Map();
        var stringMappingTypes = /* @__PURE__ */ new Map();
        var substitutionTypes = /* @__PURE__ */ new Map();
        var subtypeReductionCache = /* @__PURE__ */ new Map();
        var decoratorContextOverrideTypeCache = /* @__PURE__ */ new Map();
        var cachedTypes = /* @__PURE__ */ new Map();
        var evolvingArrayTypes = [];
        var undefinedProperties = /* @__PURE__ */ new Map();
        var markerTypes = /* @__PURE__ */ new Set();
        var unknownSymbol = createSymbol(4 /* Property */ , "unknown");
        var resolvingSymbol = createSymbol(0, "__resolving__" /* Resolving */ );
        var unresolvedSymbols = /* @__PURE__ */ new Map();
        var errorTypes = /* @__PURE__ */ new Map();
        var seenIntrinsicNames = /* @__PURE__ */ new Set();
        var anyType = createIntrinsicType(1 /* Any */ , "any");
        var autoType = createIntrinsicType(1 /* Any */ , "any", 262144 /* NonInferrableType */ , "auto");
        var wildcardType = createIntrinsicType(1 /* Any */ , "any", /*objectFlags*/ void 0, "wildcard");
        var blockedStringType = createIntrinsicType(1 /* Any */ , "any", /*objectFlags*/ void 0, "blocked string");
        var errorType = createIntrinsicType(1 /* Any */ , "error");
        var unresolvedType = createIntrinsicType(1 /* Any */ , "unresolved");
        var nonInferrableAnyType = createIntrinsicType(1 /* Any */ , "any", 65536 /* ContainsWideningType */ , "non-inferrable");
        var intrinsicMarkerType = createIntrinsicType(1 /* Any */ , "intrinsic");
        var unknownType = createIntrinsicType(2 /* Unknown */ , "unknown");
        var undefinedType = createIntrinsicType(32768 /* Undefined */ , "undefined");
        var undefinedWideningType = strictNullChecks ? undefinedType : createIntrinsicType(32768 /* Undefined */ , "undefined", 65536 /* ContainsWideningType */ , "widening");
        var missingType = createIntrinsicType(32768 /* Undefined */ , "undefined", /*objectFlags*/ void 0, "missing");
        var undefinedOrMissingType = exactOptionalPropertyTypes ? missingType : undefinedType;
        var optionalType = createIntrinsicType(32768 /* Undefined */ , "undefined", /*objectFlags*/ void 0, "optional");
        var nullType = createIntrinsicType(65536 /* Null */ , "null");
        var nullWideningType = strictNullChecks ? nullType : createIntrinsicType(65536 /* Null */ , "null", 65536 /* ContainsWideningType */ , "widening");
        var stringType = createIntrinsicType(4 /* String */ , "string");
        var numberType = createIntrinsicType(8 /* Number */ , "number");
        var bigintType = createIntrinsicType(64 /* BigInt */ , "bigint");
        var falseType = createIntrinsicType(512 /* BooleanLiteral */ , "false", /*objectFlags*/ void 0, "fresh");
        var regularFalseType = createIntrinsicType(512 /* BooleanLiteral */ , "false");
        var trueType = createIntrinsicType(512 /* BooleanLiteral */ , "true", /*objectFlags*/ void 0, "fresh");
        var regularTrueType = createIntrinsicType(512 /* BooleanLiteral */ , "true");
        trueType.regularType = regularTrueType;
        trueType.freshType = trueType;
        regularTrueType.regularType = regularTrueType;
        regularTrueType.freshType = trueType;
        falseType.regularType = regularFalseType;
        falseType.freshType = falseType;
        regularFalseType.regularType = regularFalseType;
        regularFalseType.freshType = falseType;
        var booleanType = getUnionType([
            regularFalseType,
            regularTrueType
        ]);
        var esSymbolType = createIntrinsicType(4096 /* ESSymbol */ , "symbol");
        var voidType = createIntrinsicType(16384 /* Void */ , "void");
        var neverType = createIntrinsicType(131072 /* Never */ , "never");
        var silentNeverType = createIntrinsicType(131072 /* Never */ , "never", 262144 /* NonInferrableType */ , "silent");
        var implicitNeverType = createIntrinsicType(131072 /* Never */ , "never", /*objectFlags*/ void 0, "implicit");
        var unreachableNeverType = createIntrinsicType(131072 /* Never */ , "never", /*objectFlags*/ void 0, "unreachable");
        var nonPrimitiveType = createIntrinsicType(67108864 /* NonPrimitive */ , "object");
        var stringOrNumberType = getUnionType([
            stringType,
            numberType
        ]);
        var stringNumberSymbolType = getUnionType([
            stringType,
            numberType,
            esSymbolType
        ]);
        var numberOrBigIntType = getUnionType([
            numberType,
            bigintType
        ]);
        var templateConstraintType = getUnionType([
            stringType,
            numberType,
            booleanType,
            bigintType,
            nullType,
            undefinedType
        ]);
        var numericStringType = getTemplateLiteralType([
            "",
            ""
        ], [
            numberType
        ]);
        var restrictiveMapper = makeFunctionTypeMapper((t)=>t.flags & 262144 /* TypeParameter */  ? getRestrictiveTypeParameter(t) : t, ()=>"(restrictive mapper)");
        var permissiveMapper = makeFunctionTypeMapper((t)=>t.flags & 262144 /* TypeParameter */  ? wildcardType : t, ()=>"(permissive mapper)");
        var uniqueLiteralType = createIntrinsicType(131072 /* Never */ , "never", /*objectFlags*/ void 0, "unique literal");
        var uniqueLiteralMapper = makeFunctionTypeMapper((t)=>t.flags & 262144 /* TypeParameter */  ? uniqueLiteralType : t, ()=>"(unique literal mapper)");
        var outofbandVarianceMarkerHandler;
        var reportUnreliableMapper = makeFunctionTypeMapper((t)=>{
            if (outofbandVarianceMarkerHandler && (t === markerSuperType || t === markerSubType || t === markerOtherType)) outofbandVarianceMarkerHandler(/*onlyUnreliable*/ true);
            return t;
        }, ()=>"(unmeasurable reporter)");
        var reportUnmeasurableMapper = makeFunctionTypeMapper((t)=>{
            if (outofbandVarianceMarkerHandler && (t === markerSuperType || t === markerSubType || t === markerOtherType)) outofbandVarianceMarkerHandler(/*onlyUnreliable*/ false);
            return t;
        }, ()=>"(unreliable reporter)");
        var emptyObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var emptyJsxObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        emptyJsxObjectType.objectFlags |= 2048 /* JsxAttributes */ ;
        var emptyFreshJsxObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        emptyFreshJsxObjectType.objectFlags |= 141440 /* ContainsObjectOrArrayLiteral */ ;
        var emptyTypeLiteralSymbol = createSymbol(2048 /* TypeLiteral */ , "__type" /* Type */ );
        emptyTypeLiteralSymbol.members = createSymbolTable();
        var emptyTypeLiteralType = createAnonymousType(emptyTypeLiteralSymbol, emptySymbols, emptyArray, emptyArray, emptyArray);
        var unknownEmptyObjectType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var unknownUnionType = strictNullChecks ? getUnionType([
            undefinedType,
            nullType,
            unknownEmptyObjectType
        ]) : unknownType;
        var emptyGenericType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        emptyGenericType.instantiations = /* @__PURE__ */ new Map();
        var anyFunctionType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        anyFunctionType.objectFlags |= 262144 /* NonInferrableType */ ;
        var noConstraintType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var circularConstraintType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var resolvingDefaultType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
        var markerSuperType = createTypeParameter();
        var markerSubType = createTypeParameter();
        markerSubType.constraint = markerSuperType;
        var markerOtherType = createTypeParameter();
        var markerSuperTypeForCheck = createTypeParameter();
        var markerSubTypeForCheck = createTypeParameter();
        markerSubTypeForCheck.constraint = markerSuperTypeForCheck;
        var noTypePredicate = createTypePredicate(1 /* Identifier */ , "<<unresolved>>", 0, anyType);
        var anySignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, anyType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var unknownSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, errorType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var resolvingSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, anyType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var silentNeverSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, silentNeverType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
        var enumNumberIndexInfo = createIndexInfo(numberType, stringType, /*isReadonly*/ true);
        var anyBaseTypeIndexInfo = createIndexInfo(stringType, anyType, /*isReadonly*/ false);
        var iterationTypesCache = /* @__PURE__ */ new Map();
        var noIterationTypes = {
            get yieldType () {
                return Debug.fail("Not supported");
            },
            get returnType () {
                return Debug.fail("Not supported");
            },
            get nextType () {
                return Debug.fail("Not supported");
            }
        };
        var anyIterationTypes = createIterationTypes(anyType, anyType, anyType);
        var silentNeverIterationTypes = createIterationTypes(silentNeverType, silentNeverType, silentNeverType);
        var asyncIterationTypesResolver = {
            iterableCacheKey: "iterationTypesOfAsyncIterable",
            iteratorCacheKey: "iterationTypesOfAsyncIterator",
            iteratorSymbolName: "asyncIterator",
            getGlobalIteratorType: getGlobalAsyncIteratorType,
            getGlobalIterableType: getGlobalAsyncIterableType,
            getGlobalIterableIteratorType: getGlobalAsyncIterableIteratorType,
            getGlobalIteratorObjectType: getGlobalAsyncIteratorObjectType,
            getGlobalGeneratorType: getGlobalAsyncGeneratorType,
            getGlobalBuiltinIteratorTypes: getGlobalBuiltinAsyncIteratorTypes,
            resolveIterationType: (type, errorNode)=>getAwaitedType(type, errorNode, Diagnostics.Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member),
            mustHaveANextMethodDiagnostic: Diagnostics.An_async_iterator_must_have_a_next_method,
            mustBeAMethodDiagnostic: Diagnostics.The_0_property_of_an_async_iterator_must_be_a_method,
            mustHaveAValueDiagnostic: Diagnostics.The_type_returned_by_the_0_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property
        };
        var syncIterationTypesResolver = {
            iterableCacheKey: "iterationTypesOfIterable",
            iteratorCacheKey: "iterationTypesOfIterator",
            iteratorSymbolName: "iterator",
            getGlobalIteratorType,
            getGlobalIterableType,
            getGlobalIterableIteratorType,
            getGlobalIteratorObjectType,
            getGlobalGeneratorType,
            getGlobalBuiltinIteratorTypes,
            resolveIterationType: (type, _errorNode)=>type,
            mustHaveANextMethodDiagnostic: Diagnostics.An_iterator_must_have_a_next_method,
            mustBeAMethodDiagnostic: Diagnostics.The_0_property_of_an_iterator_must_be_a_method,
            mustHaveAValueDiagnostic: Diagnostics.The_type_returned_by_the_0_method_of_an_iterator_must_have_a_value_property
        };
        var amalgamatedDuplicates;
        var reverseMappedCache = /* @__PURE__ */ new Map();
        var reverseHomomorphicMappedCache = /* @__PURE__ */ new Map();
        var ambientModulesCache;
        var patternAmbientModules;
        var patternAmbientModuleAugmentations;
        var globalObjectType;
        var globalFunctionType;
        var globalCallableFunctionType;
        var globalNewableFunctionType;
        var globalArrayType;
        var globalReadonlyArrayType;
        var globalStringType;
        var globalNumberType;
        var globalBooleanType;
        var globalRegExpType;
        var globalThisType;
        var anyArrayType;
        var autoArrayType;
        var anyReadonlyArrayType;
        var deferredGlobalNonNullableTypeAlias;
        var deferredGlobalESSymbolConstructorSymbol;
        var deferredGlobalESSymbolConstructorTypeSymbol;
        var deferredGlobalESSymbolType;
        var deferredGlobalTypedPropertyDescriptorType;
        var deferredGlobalPromiseType;
        var deferredGlobalPromiseLikeType;
        var deferredGlobalPromiseConstructorSymbol;
        var deferredGlobalPromiseConstructorLikeType;
        var deferredGlobalIterableType;
        var deferredGlobalIteratorType;
        var deferredGlobalIterableIteratorType;
        var deferredGlobalIteratorObjectType;
        var deferredGlobalGeneratorType;
        var deferredGlobalIteratorYieldResultType;
        var deferredGlobalIteratorReturnResultType;
        var deferredGlobalAsyncIterableType;
        var deferredGlobalAsyncIteratorType;
        var deferredGlobalAsyncIterableIteratorType;
        var deferredGlobalBuiltinIteratorTypes;
        var deferredGlobalBuiltinAsyncIteratorTypes;
        var deferredGlobalAsyncIteratorObjectType;
        var deferredGlobalAsyncGeneratorType;
        var deferredGlobalTemplateStringsArrayType;
        var deferredGlobalImportMetaType;
        var deferredGlobalImportMetaExpressionType;
        var deferredGlobalImportCallOptionsType;
        var deferredGlobalImportAttributesType;
        var deferredGlobalDisposableType;
        var deferredGlobalAsyncDisposableType;
        var deferredGlobalExtractSymbol;
        var deferredGlobalOmitSymbol;
        var deferredGlobalAwaitedSymbol;
        var deferredGlobalBigIntType;
        var deferredGlobalNaNSymbol;
        var deferredGlobalRecordSymbol;
        var deferredGlobalClassDecoratorContextType;
        var deferredGlobalClassMethodDecoratorContextType;
        var deferredGlobalClassGetterDecoratorContextType;
        var deferredGlobalClassSetterDecoratorContextType;
        var deferredGlobalClassAccessorDecoratorContextType;
        var deferredGlobalClassAccessorDecoratorTargetType;
        var deferredGlobalClassAccessorDecoratorResultType;
        var deferredGlobalClassFieldDecoratorContextType;
        var allPotentiallyUnusedIdentifiers = /* @__PURE__ */ new Map();
        var flowLoopStart = 0;
        var flowLoopCount = 0;
        var sharedFlowCount = 0;
        var flowAnalysisDisabled = false;
        var flowInvocationCount = 0;
        var lastFlowNode;
        var lastFlowNodeReachable;
        var flowTypeCache;
        var contextualTypeNodes = [];
        var contextualTypes = [];
        var contextualIsCache = [];
        var contextualTypeCount = 0;
        var contextualBindingPatterns = [];
        var inferenceContextNodes = [];
        var inferenceContexts = [];
        var inferenceContextCount = 0;
        var activeTypeMappers = [];
        var activeTypeMappersCaches = [];
        var activeTypeMappersCount = 0;
        var emptyStringType = getStringLiteralType("");
        var zeroType = getNumberLiteralType(0);
        var zeroBigIntType = getBigIntLiteralType({
            negative: false,
            base10Value: "0"
        });
        var resolutionTargets = [];
        var resolutionResults = [];
        var resolutionPropertyNames = [];
        var resolutionStart = 0;
        var inVarianceComputation = false;
        var suggestionCount = 0;
        var maximumSuggestionCount = 10;
        var mergedSymbols = [];
        var symbolLinks = [];
        var nodeLinks = [];
        var flowLoopCaches = [];
        var flowLoopNodes = [];
        var flowLoopKeys = [];
        var flowLoopTypes = [];
        var sharedFlowNodes = [];
        var sharedFlowTypes = [];
        var flowNodeReachable = [];
        var flowNodePostSuper = [];
        var potentialThisCollisions = [];
        var potentialNewTargetCollisions = [];
        var potentialWeakMapSetCollisions = [];
        var potentialReflectCollisions = [];
        var potentialUnusedRenamedBindingElementsInTypes = [];
        var awaitedTypeStack = [];
        var reverseMappedSourceStack = [];
        var reverseMappedTargetStack = [];
        var reverseExpandingFlags = 0 /* None */ ;
        var diagnostics = createDiagnosticCollection();
        var suggestionDiagnostics = createDiagnosticCollection();
        var typeofType = createTypeofType();
        var _jsxNamespace;
        var _jsxFactoryEntity;
        var subtypeRelation = /* @__PURE__ */ new Map();
        var strictSubtypeRelation = /* @__PURE__ */ new Map();
        var assignableRelation = /* @__PURE__ */ new Map();
        var comparableRelation = /* @__PURE__ */ new Map();
        var identityRelation = /* @__PURE__ */ new Map();
        var enumRelation = /* @__PURE__ */ new Map();
        var suggestedExtensions = [
            [
                ".mts",
                ".mjs"
            ],
            [
                ".ts",
                ".js"
            ],
            [
                ".cts",
                ".cjs"
            ],
            [
                ".mjs",
                ".mjs"
            ],
            [
                ".js",
                ".js"
            ],
            [
                ".cjs",
                ".cjs"
            ],
            [
                ".tsx",
                compilerOptions.jsx === 1 /* Preserve */  ? ".jsx" : ".js"
            ],
            [
                ".jsx",
                ".jsx"
            ],
            [
                ".json",
                ".json"
            ]
        ];
        initializeTypeChecker();
        return checker;
        function isDefinitelyReferenceToGlobalSymbolObject(node) {
            if (!isPropertyAccessExpression(node)) return false;
            if (!isIdentifier(node.name)) return false;
            if (!isPropertyAccessExpression(node.expression) && !isIdentifier(node.expression)) return false;
            if (isIdentifier(node.expression)) return idText(node.expression) === "Symbol" && getResolvedSymbol(node.expression) === (getGlobalSymbol("Symbol", 1160127 /* ExportValue */ , /*diagnostic*/ void 0) || unknownSymbol);
            if (!isIdentifier(node.expression.expression)) return false;
            return idText(node.expression.name) === "Symbol" && idText(node.expression.expression) === "globalThis" && getResolvedSymbol(node.expression.expression) === globalThisSymbol;
        }
        function getCachedType(key) {
            return key ? cachedTypes.get(key) : void 0;
        }
        function setCachedType(key, type) {
            if (key) cachedTypes.set(key, type);
            return type;
        }
        function getJsxNamespace(location) {
            if (location) {
                const file = getSourceFileOfNode(location);
                if (file) {
                    if (isJsxOpeningFragment(location)) {
                        if (file.localJsxFragmentNamespace) return file.localJsxFragmentNamespace;
                        const jsxFragmentPragma = file.pragmas.get("jsxfrag");
                        if (jsxFragmentPragma) {
                            const chosenPragma = isArray(jsxFragmentPragma) ? jsxFragmentPragma[0] : jsxFragmentPragma;
                            file.localJsxFragmentFactory = parseIsolatedEntityName(chosenPragma.arguments.factory, languageVersion);
                            visitNode(file.localJsxFragmentFactory, markAsSynthetic, isEntityName);
                            if (file.localJsxFragmentFactory) return file.localJsxFragmentNamespace = getFirstIdentifier(file.localJsxFragmentFactory).escapedText;
                        }
                        const entity = getJsxFragmentFactoryEntity(location);
                        if (entity) {
                            file.localJsxFragmentFactory = entity;
                            return file.localJsxFragmentNamespace = getFirstIdentifier(entity).escapedText;
                        }
                    } else {
                        const localJsxNamespace = getLocalJsxNamespace(file);
                        if (localJsxNamespace) return file.localJsxNamespace = localJsxNamespace;
                    }
                }
            }
            if (!_jsxNamespace) {
                _jsxNamespace = "React";
                if (compilerOptions.jsxFactory) {
                    _jsxFactoryEntity = parseIsolatedEntityName(compilerOptions.jsxFactory, languageVersion);
                    visitNode(_jsxFactoryEntity, markAsSynthetic);
                    if (_jsxFactoryEntity) _jsxNamespace = getFirstIdentifier(_jsxFactoryEntity).escapedText;
                } else if (compilerOptions.reactNamespace) _jsxNamespace = escapeLeadingUnderscores(compilerOptions.reactNamespace);
            }
            if (!_jsxFactoryEntity) _jsxFactoryEntity = factory.createQualifiedName(factory.createIdentifier(unescapeLeadingUnderscores(_jsxNamespace)), "createElement");
            return _jsxNamespace;
        }
        function getLocalJsxNamespace(file) {
            if (file.localJsxNamespace) return file.localJsxNamespace;
            const jsxPragma = file.pragmas.get("jsx");
            if (jsxPragma) {
                const chosenPragma = isArray(jsxPragma) ? jsxPragma[0] : jsxPragma;
                file.localJsxFactory = parseIsolatedEntityName(chosenPragma.arguments.factory, languageVersion);
                visitNode(file.localJsxFactory, markAsSynthetic, isEntityName);
                if (file.localJsxFactory) return file.localJsxNamespace = getFirstIdentifier(file.localJsxFactory).escapedText;
            }
        }
        function markAsSynthetic(node) {
            setTextRangePosEnd(node, -1, -1);
            return visitEachChild(node, markAsSynthetic, /*context*/ void 0);
        }
        function getEmitResolver(sourceFile, cancellationToken2, skipDiagnostics) {
            if (!skipDiagnostics) getDiagnostics2(sourceFile, cancellationToken2);
            return emitResolver;
        }
        function lookupOrIssueError(location, message, ...args) {
            const diagnostic = location ? createDiagnosticForNode(location, message, ...args) : createCompilerDiagnostic(message, ...args);
            const existing = diagnostics.lookup(diagnostic);
            if (existing) return existing;
            else {
                diagnostics.add(diagnostic);
                return diagnostic;
            }
        }
        function errorSkippedOn(key, location, message, ...args) {
            const diagnostic = error2(location, message, ...args);
            diagnostic.skippedOn = key;
            return diagnostic;
        }
        function createError(location, message, ...args) {
            return location ? createDiagnosticForNode(location, message, ...args) : createCompilerDiagnostic(message, ...args);
        }
        function error2(location, message, ...args) {
            const diagnostic = createError(location, message, ...args);
            diagnostics.add(diagnostic);
            return diagnostic;
        }
        function getVerbatimModuleSyntaxErrorMessage(node) {
            const sourceFile = getSourceFileOfNode(node);
            const fileName = sourceFile.fileName;
            if (fileExtensionIsOneOf(fileName, [
                ".cts" /* Cts */ ,
                ".cjs" /* Cjs */ 
            ])) return Diagnostics.ECMAScript_imports_and_exports_cannot_be_written_in_a_CommonJS_file_under_verbatimModuleSyntax;
            else return Diagnostics.ECMAScript_imports_and_exports_cannot_be_written_in_a_CommonJS_file_under_verbatimModuleSyntax_Adjust_the_type_field_in_the_nearest_package_json_to_make_this_file_an_ECMAScript_module_or_adjust_your_verbatimModuleSyntax_module_and_moduleResolution_settings_in_TypeScript;
        }
        function addErrorOrSuggestion(isError, diagnostic) {
            if (isError) diagnostics.add(diagnostic);
            else suggestionDiagnostics.add((0, _objectSpreadProps._)((0, _objectSpread._)({}, diagnostic), {
                category: 2 /* Suggestion */ 
            }));
        }
        function errorOrSuggestion(isError, location, message, ...args) {
            if (location.pos < 0 || location.end < 0) {
                if (!isError) return;
                const file = getSourceFileOfNode(location);
                addErrorOrSuggestion(isError, "message" in message ? createFileDiagnostic(file, 0, 0, message, ...args) : createDiagnosticForFileFromMessageChain(file, message));
                return;
            }
            addErrorOrSuggestion(isError, "message" in message ? createDiagnosticForNode(location, message, ...args) : createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(location), location, message));
        }
        function errorAndMaybeSuggestAwait(location, maybeMissingAwait, message, ...args) {
            const diagnostic = error2(location, message, ...args);
            if (maybeMissingAwait) {
                const related = createDiagnosticForNode(location, Diagnostics.Did_you_forget_to_use_await);
                addRelatedInfo(diagnostic, related);
            }
            return diagnostic;
        }
        function addDeprecatedSuggestionWorker(declarations, diagnostic) {
            const deprecatedTag = Array.isArray(declarations) ? forEach(declarations, getJSDocDeprecatedTag) : getJSDocDeprecatedTag(declarations);
            if (deprecatedTag) addRelatedInfo(diagnostic, createDiagnosticForNode(deprecatedTag, Diagnostics.The_declaration_was_marked_as_deprecated_here));
            suggestionDiagnostics.add(diagnostic);
            return diagnostic;
        }
        function isDeprecatedSymbol(symbol) {
            const parentSymbol = getParentOfSymbol(symbol);
            if (parentSymbol && length(symbol.declarations) > 1) return parentSymbol.flags & 64 /* Interface */  ? some(symbol.declarations, isDeprecatedDeclaration2) : every(symbol.declarations, isDeprecatedDeclaration2);
            return !!symbol.valueDeclaration && isDeprecatedDeclaration2(symbol.valueDeclaration) || length(symbol.declarations) && every(symbol.declarations, isDeprecatedDeclaration2);
        }
        function isDeprecatedDeclaration2(declaration) {
            return !!(getCombinedNodeFlagsCached(declaration) & 536870912 /* Deprecated */ );
        }
        function addDeprecatedSuggestion(location, declarations, deprecatedEntity) {
            const diagnostic = createDiagnosticForNode(location, Diagnostics._0_is_deprecated, deprecatedEntity);
            return addDeprecatedSuggestionWorker(declarations, diagnostic);
        }
        function addDeprecatedSuggestionWithSignature(location, declaration, deprecatedEntity, signatureString) {
            const diagnostic = deprecatedEntity ? createDiagnosticForNode(location, Diagnostics.The_signature_0_of_1_is_deprecated, signatureString, deprecatedEntity) : createDiagnosticForNode(location, Diagnostics._0_is_deprecated, signatureString);
            return addDeprecatedSuggestionWorker(declaration, diagnostic);
        }
        function createSymbol(flags, name, checkFlags) {
            symbolCount++;
            const symbol = new Symbol48(flags | 33554432 /* Transient */ , name);
            symbol.links = new SymbolLinks();
            symbol.links.checkFlags = checkFlags || 0 /* None */ ;
            return symbol;
        }
        function createParameter2(name, type) {
            const symbol = createSymbol(1 /* FunctionScopedVariable */ , name);
            symbol.links.type = type;
            return symbol;
        }
        function createProperty(name, type) {
            const symbol = createSymbol(4 /* Property */ , name);
            symbol.links.type = type;
            return symbol;
        }
        function getExcludedSymbolFlags(flags) {
            let result = 0;
            if (flags & 2 /* BlockScopedVariable */ ) result |= 111551 /* BlockScopedVariableExcludes */ ;
            if (flags & 1 /* FunctionScopedVariable */ ) result |= 111550 /* FunctionScopedVariableExcludes */ ;
            if (flags & 4 /* Property */ ) result |= 0 /* PropertyExcludes */ ;
            if (flags & 8 /* EnumMember */ ) result |= 900095 /* EnumMemberExcludes */ ;
            if (flags & 16 /* Function */ ) result |= 110991 /* FunctionExcludes */ ;
            if (flags & 32 /* Class */ ) result |= 899503 /* ClassExcludes */ ;
            if (flags & 64 /* Interface */ ) result |= 788872 /* InterfaceExcludes */ ;
            if (flags & 256 /* RegularEnum */ ) result |= 899327 /* RegularEnumExcludes */ ;
            if (flags & 128 /* ConstEnum */ ) result |= 899967 /* ConstEnumExcludes */ ;
            if (flags & 512 /* ValueModule */ ) result |= 110735 /* ValueModuleExcludes */ ;
            if (flags & 8192 /* Method */ ) result |= 103359 /* MethodExcludes */ ;
            if (flags & 32768 /* GetAccessor */ ) result |= 46015 /* GetAccessorExcludes */ ;
            if (flags & 65536 /* SetAccessor */ ) result |= 78783 /* SetAccessorExcludes */ ;
            if (flags & 262144 /* TypeParameter */ ) result |= 526824 /* TypeParameterExcludes */ ;
            if (flags & 524288 /* TypeAlias */ ) result |= 788968 /* TypeAliasExcludes */ ;
            if (flags & 2097152 /* Alias */ ) result |= 2097152 /* AliasExcludes */ ;
            return result;
        }
        function recordMergedSymbol(target, source) {
            if (!source.mergeId) {
                source.mergeId = nextMergeId;
                nextMergeId++;
            }
            mergedSymbols[source.mergeId] = target;
        }
        function cloneSymbol(symbol) {
            const result = createSymbol(symbol.flags, symbol.escapedName);
            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
            result.parent = symbol.parent;
            if (symbol.valueDeclaration) result.valueDeclaration = symbol.valueDeclaration;
            if (symbol.constEnumOnlyModule) result.constEnumOnlyModule = true;
            if (symbol.members) result.members = new Map(symbol.members);
            if (symbol.exports) result.exports = new Map(symbol.exports);
            recordMergedSymbol(result, symbol);
            return result;
        }
        function mergeSymbol(target, source, unidirectional = false) {
            if (!(target.flags & getExcludedSymbolFlags(source.flags)) || (source.flags | target.flags) & 67108864 /* Assignment */ ) {
                if (source === target) return target;
                if (!(target.flags & 33554432 /* Transient */ )) {
                    const resolvedTarget = resolveSymbol(target);
                    if (resolvedTarget === unknownSymbol) return source;
                    if (!(resolvedTarget.flags & getExcludedSymbolFlags(source.flags)) || (source.flags | resolvedTarget.flags) & 67108864 /* Assignment */ ) target = cloneSymbol(resolvedTarget);
                    else {
                        reportMergeSymbolError(target, source);
                        return source;
                    }
                }
                if (source.flags & 512 /* ValueModule */  && target.flags & 512 /* ValueModule */  && target.constEnumOnlyModule && !source.constEnumOnlyModule) target.constEnumOnlyModule = false;
                target.flags |= source.flags;
                if (source.valueDeclaration) setValueDeclaration(target, source.valueDeclaration);
                addRange(target.declarations, source.declarations);
                if (source.members) {
                    if (!target.members) target.members = createSymbolTable();
                    mergeSymbolTable(target.members, source.members, unidirectional);
                }
                if (source.exports) {
                    if (!target.exports) target.exports = createSymbolTable();
                    mergeSymbolTable(target.exports, source.exports, unidirectional, target);
                }
                if (!unidirectional) recordMergedSymbol(target, source);
            } else if (target.flags & 1024 /* NamespaceModule */ ) {
                if (target !== globalThisSymbol) error2(source.declarations && getNameOfDeclaration(source.declarations[0]), Diagnostics.Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity, symbolToString(target));
            } else reportMergeSymbolError(target, source);
            return target;
            function reportMergeSymbolError(target2, source2) {
                const isEitherEnum = !!(target2.flags & 384 /* Enum */  || source2.flags & 384 /* Enum */ );
                const isEitherBlockScoped = !!(target2.flags & 2 /* BlockScopedVariable */  || source2.flags & 2 /* BlockScopedVariable */ );
                const message = isEitherEnum ? Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations : isEitherBlockScoped ? Diagnostics.Cannot_redeclare_block_scoped_variable_0 : Diagnostics.Duplicate_identifier_0;
                const sourceSymbolFile = source2.declarations && getSourceFileOfNode(source2.declarations[0]);
                const targetSymbolFile = target2.declarations && getSourceFileOfNode(target2.declarations[0]);
                const isSourcePlainJs = isPlainJsFile(sourceSymbolFile, compilerOptions.checkJs);
                const isTargetPlainJs = isPlainJsFile(targetSymbolFile, compilerOptions.checkJs);
                const symbolName2 = symbolToString(source2);
                if (sourceSymbolFile && targetSymbolFile && amalgamatedDuplicates && !isEitherEnum && sourceSymbolFile !== targetSymbolFile) {
                    const firstFile = comparePaths(sourceSymbolFile.path, targetSymbolFile.path) === -1 /* LessThan */  ? sourceSymbolFile : targetSymbolFile;
                    const secondFile = firstFile === sourceSymbolFile ? targetSymbolFile : sourceSymbolFile;
                    const filesDuplicates = getOrUpdate(amalgamatedDuplicates, `${firstFile.path}|${secondFile.path}`, ()=>({
                            firstFile,
                            secondFile,
                            conflictingSymbols: /* @__PURE__ */ new Map()
                        }));
                    const conflictingSymbolInfo = getOrUpdate(filesDuplicates.conflictingSymbols, symbolName2, ()=>({
                            isBlockScoped: isEitherBlockScoped,
                            firstFileLocations: [],
                            secondFileLocations: []
                        }));
                    if (!isSourcePlainJs) addDuplicateLocations(conflictingSymbolInfo.firstFileLocations, source2);
                    if (!isTargetPlainJs) addDuplicateLocations(conflictingSymbolInfo.secondFileLocations, target2);
                } else {
                    if (!isSourcePlainJs) addDuplicateDeclarationErrorsForSymbols(source2, message, symbolName2, target2);
                    if (!isTargetPlainJs) addDuplicateDeclarationErrorsForSymbols(target2, message, symbolName2, source2);
                }
            }
            function addDuplicateLocations(locs, symbol) {
                if (symbol.declarations) for (const decl of symbol.declarations)pushIfUnique(locs, decl);
            }
        }
        function addDuplicateDeclarationErrorsForSymbols(target, message, symbolName2, source) {
            forEach(target.declarations, (node)=>{
                addDuplicateDeclarationError(node, message, symbolName2, source.declarations);
            });
        }
        function addDuplicateDeclarationError(node, message, symbolName2, relatedNodes) {
            const errorNode = (getExpandoInitializer(node, /*isPrototypeAssignment*/ false) ? getNameOfExpando(node) : getNameOfDeclaration(node)) || node;
            const err = lookupOrIssueError(errorNode, message, symbolName2);
            for (const relatedNode of relatedNodes || emptyArray){
                const adjustedNode = (getExpandoInitializer(relatedNode, /*isPrototypeAssignment*/ false) ? getNameOfExpando(relatedNode) : getNameOfDeclaration(relatedNode)) || relatedNode;
                if (adjustedNode === errorNode) continue;
                err.relatedInformation = err.relatedInformation || [];
                const leadingMessage = createDiagnosticForNode(adjustedNode, Diagnostics._0_was_also_declared_here, symbolName2);
                const followOnMessage = createDiagnosticForNode(adjustedNode, Diagnostics.and_here);
                if (length(err.relatedInformation) >= 5 || some(err.relatedInformation, (r)=>compareDiagnostics(r, followOnMessage) === 0 /* EqualTo */  || compareDiagnostics(r, leadingMessage) === 0 /* EqualTo */ )) continue;
                addRelatedInfo(err, !length(err.relatedInformation) ? leadingMessage : followOnMessage);
            }
        }
        function combineSymbolTables(first2, second) {
            if (!(first2 == null ? void 0 : first2.size)) return second;
            if (!(second == null ? void 0 : second.size)) return first2;
            const combined = createSymbolTable();
            mergeSymbolTable(combined, first2);
            mergeSymbolTable(combined, second);
            return combined;
        }
        function mergeSymbolTable(target, source, unidirectional = false, mergedParent) {
            source.forEach((sourceSymbol, id)=>{
                const targetSymbol = target.get(id);
                const merged = targetSymbol ? mergeSymbol(targetSymbol, sourceSymbol, unidirectional) : getMergedSymbol(sourceSymbol);
                if (mergedParent && targetSymbol) merged.parent = mergedParent;
                target.set(id, merged);
            });
        }
        function mergeModuleAugmentation(moduleName) {
            var _a, _b, _c;
            const moduleAugmentation = moduleName.parent;
            if (((_a = moduleAugmentation.symbol.declarations) == null ? void 0 : _a[0]) !== moduleAugmentation) {
                Debug.assert(moduleAugmentation.symbol.declarations.length > 1);
                return;
            }
            if (isGlobalScopeAugmentation(moduleAugmentation)) mergeSymbolTable(globals, moduleAugmentation.symbol.exports);
            else {
                const moduleNotFoundError = !(moduleName.parent.parent.flags & 33554432 /* Ambient */ ) ? Diagnostics.Invalid_module_name_in_augmentation_module_0_cannot_be_found : void 0;
                let mainModule = resolveExternalModuleNameWorker(moduleName, moduleName, moduleNotFoundError, /*ignoreErrors*/ false, /*isForAugmentation*/ true);
                if (!mainModule) return;
                mainModule = resolveExternalModuleSymbol(mainModule);
                if (mainModule.flags & 1920 /* Namespace */ ) {
                    if (some(patternAmbientModules, (module2)=>mainModule === module2.symbol)) {
                        const merged = mergeSymbol(moduleAugmentation.symbol, mainModule, /*unidirectional*/ true);
                        if (!patternAmbientModuleAugmentations) patternAmbientModuleAugmentations = /* @__PURE__ */ new Map();
                        patternAmbientModuleAugmentations.set(moduleName.text, merged);
                    } else {
                        if (((_b = mainModule.exports) == null ? void 0 : _b.get("__export" /* ExportStar */ )) && ((_c = moduleAugmentation.symbol.exports) == null ? void 0 : _c.size)) {
                            const resolvedExports = getResolvedMembersOrExportsOfSymbol(mainModule, "resolvedExports" /* resolvedExports */ );
                            for (const [key, value1] of arrayFrom(moduleAugmentation.symbol.exports.entries()))if (resolvedExports.has(key) && !mainModule.exports.has(key)) mergeSymbol(resolvedExports.get(key), value1);
                        }
                        mergeSymbol(mainModule, moduleAugmentation.symbol);
                    }
                } else error2(moduleName, Diagnostics.Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity, moduleName.text);
            }
        }
        function addUndefinedToGlobalsOrErrorOnRedeclaration() {
            const name = undefinedSymbol.escapedName;
            const targetSymbol = globals.get(name);
            if (targetSymbol) forEach(targetSymbol.declarations, (declaration)=>{
                if (!isTypeDeclaration(declaration)) diagnostics.add(createDiagnosticForNode(declaration, Diagnostics.Declaration_name_conflicts_with_built_in_global_identifier_0, unescapeLeadingUnderscores(name)));
            });
            else globals.set(name, undefinedSymbol);
        }
        function getSymbolLinks(symbol) {
            if (symbol.flags & 33554432 /* Transient */ ) return symbol.links;
            const id = getSymbolId(symbol);
            var _symbolLinks_id;
            return (_symbolLinks_id = symbolLinks[id]) !== null && _symbolLinks_id !== void 0 ? _symbolLinks_id : symbolLinks[id] = new SymbolLinks();
        }
        function getNodeLinks(node) {
            const nodeId = getNodeId(node);
            return nodeLinks[nodeId] || (nodeLinks[nodeId] = new NodeLinks());
        }
        function getSymbol2(symbols, name, meaning) {
            if (meaning) {
                const symbol = getMergedSymbol(symbols.get(name));
                if (symbol) {
                    if (symbol.flags & meaning) return symbol;
                    if (symbol.flags & 2097152 /* Alias */ ) {
                        const targetFlags = getSymbolFlags(symbol);
                        if (targetFlags & meaning) return symbol;
                    }
                }
            }
        }
        function getSymbolsOfParameterPropertyDeclaration(parameter, parameterName) {
            const constructorDeclaration = parameter.parent;
            const classDeclaration = parameter.parent.parent;
            const parameterSymbol = getSymbol2(constructorDeclaration.locals, parameterName, 111551 /* Value */ );
            const propertySymbol = getSymbol2(getMembersOfSymbol(classDeclaration.symbol), parameterName, 111551 /* Value */ );
            if (parameterSymbol && propertySymbol) return [
                parameterSymbol,
                propertySymbol
            ];
            return Debug.fail("There should exist two symbols, one as property declaration and one as parameter declaration");
        }
        function isBlockScopedNameDeclaredBeforeUse(declaration, usage) {
            const declarationFile = getSourceFileOfNode(declaration);
            const useFile = getSourceFileOfNode(usage);
            const declContainer = getEnclosingBlockScopeContainer(declaration);
            if (declarationFile !== useFile) {
                if (moduleKind && (declarationFile.externalModuleIndicator || useFile.externalModuleIndicator) || !compilerOptions.outFile || isInTypeQuery(usage) || declaration.flags & 33554432 /* Ambient */ ) return true;
                if (isUsedInFunctionOrInstanceProperty(usage, declaration)) return true;
                const sourceFiles = host.getSourceFiles();
                return sourceFiles.indexOf(declarationFile) <= sourceFiles.indexOf(useFile);
            }
            if (!!(usage.flags & 16777216 /* JSDoc */ ) || isInTypeQuery(usage) || isInAmbientOrTypeNode(usage)) return true;
            if (declaration.pos <= usage.pos && !(isPropertyDeclaration(declaration) && isThisProperty(usage.parent) && !declaration.initializer && !declaration.exclamationToken)) {
                if (declaration.kind === 209 /* BindingElement */ ) {
                    const errorBindingElement = getAncestor(usage, 209 /* BindingElement */ );
                    if (errorBindingElement) return findAncestor(errorBindingElement, isBindingElement) !== findAncestor(declaration, isBindingElement) || declaration.pos < errorBindingElement.pos;
                    return isBlockScopedNameDeclaredBeforeUse(getAncestor(declaration, 261 /* VariableDeclaration */ ), usage);
                } else if (declaration.kind === 261 /* VariableDeclaration */ ) return !isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration, usage);
                else if (isClassLike(declaration)) {
                    const container = findAncestor(usage, (n)=>n === declaration ? "quit" : isComputedPropertyName(n) ? n.parent.parent === declaration : !legacyDecorators && isDecorator(n) && (n.parent === declaration || isMethodDeclaration(n.parent) && n.parent.parent === declaration || isGetOrSetAccessorDeclaration(n.parent) && n.parent.parent === declaration || isPropertyDeclaration(n.parent) && n.parent.parent === declaration || isParameter(n.parent) && n.parent.parent.parent === declaration));
                    if (!container) return true;
                    if (!legacyDecorators && isDecorator(container)) return !!findAncestor(usage, (n)=>n === container ? "quit" : isFunctionLike(n) && !getImmediatelyInvokedFunctionExpression(n));
                    return false;
                } else if (isPropertyDeclaration(declaration)) return !isPropertyImmediatelyReferencedWithinDeclaration(declaration, usage, /*stopAtAnyPropertyDeclaration*/ false);
                else if (isParameterPropertyDeclaration(declaration, declaration.parent)) return !(emitStandardClassFields && getContainingClass(declaration) === getContainingClass(usage) && isUsedInFunctionOrInstanceProperty(usage, declaration));
                return true;
            }
            if (usage.parent.kind === 282 /* ExportSpecifier */  || usage.parent.kind === 278 /* ExportAssignment */  && usage.parent.isExportEquals) return true;
            if (usage.kind === 278 /* ExportAssignment */  && usage.isExportEquals) return true;
            if (isUsedInFunctionOrInstanceProperty(usage, declaration)) {
                if (emitStandardClassFields && getContainingClass(declaration) && (isPropertyDeclaration(declaration) || isParameterPropertyDeclaration(declaration, declaration.parent))) return !isPropertyImmediatelyReferencedWithinDeclaration(declaration, usage, /*stopAtAnyPropertyDeclaration*/ true);
                else return true;
            }
            return false;
            function isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration2, usage2) {
                switch(declaration2.parent.parent.kind){
                    case 244 /* VariableStatement */ :
                    case 249 /* ForStatement */ :
                    case 251 /* ForOfStatement */ :
                        if (isSameScopeDescendentOf(usage2, declaration2, declContainer)) return true;
                        break;
                }
                const grandparent = declaration2.parent.parent;
                return isForInOrOfStatement(grandparent) && isSameScopeDescendentOf(usage2, grandparent.expression, declContainer);
            }
            function isUsedInFunctionOrInstanceProperty(usage2, declaration2) {
                return isUsedInFunctionOrInstancePropertyWorker(usage2, declaration2);
            }
            function isUsedInFunctionOrInstancePropertyWorker(usage2, declaration2) {
                return !!findAncestor(usage2, (current)=>{
                    if (current === declContainer) return "quit";
                    if (isFunctionLike(current)) return !getImmediatelyInvokedFunctionExpression(current);
                    if (isClassStaticBlockDeclaration(current)) return declaration2.pos < usage2.pos;
                    const propertyDeclaration = tryCast(current.parent, isPropertyDeclaration);
                    if (propertyDeclaration) {
                        const initializerOfProperty = propertyDeclaration.initializer === current;
                        if (initializerOfProperty) {
                            if (isStatic(current.parent)) {
                                if (declaration2.kind === 175 /* MethodDeclaration */ ) return true;
                                if (isPropertyDeclaration(declaration2) && getContainingClass(usage2) === getContainingClass(declaration2)) {
                                    const propName = declaration2.name;
                                    if (isIdentifier(propName) || isPrivateIdentifier(propName)) {
                                        const type = getTypeOfSymbol(getSymbolOfDeclaration(declaration2));
                                        const staticBlocks = filter(declaration2.parent.members, isClassStaticBlockDeclaration);
                                        if (isPropertyInitializedInStaticBlocks(propName, type, staticBlocks, declaration2.parent.pos, current.pos)) return true;
                                    }
                                }
                            } else {
                                const isDeclarationInstanceProperty = declaration2.kind === 173 /* PropertyDeclaration */  && !isStatic(declaration2);
                                if (!isDeclarationInstanceProperty || getContainingClass(usage2) !== getContainingClass(declaration2)) return true;
                            }
                        }
                    }
                    const decorator = tryCast(current.parent, isDecorator);
                    if (decorator && decorator.expression === current) {
                        if (isParameter(decorator.parent)) return isUsedInFunctionOrInstancePropertyWorker(decorator.parent.parent.parent, declaration2) ? true : "quit";
                        if (isMethodDeclaration(decorator.parent)) return isUsedInFunctionOrInstancePropertyWorker(decorator.parent.parent, declaration2) ? true : "quit";
                    }
                    return false;
                });
            }
            function isPropertyImmediatelyReferencedWithinDeclaration(declaration2, usage2, stopAtAnyPropertyDeclaration) {
                if (usage2.end > declaration2.end) return false;
                const ancestorChangingReferenceScope = findAncestor(usage2, (node)=>{
                    if (node === declaration2) return "quit";
                    switch(node.kind){
                        case 220 /* ArrowFunction */ :
                            return true;
                        case 173 /* PropertyDeclaration */ :
                            return stopAtAnyPropertyDeclaration && (isPropertyDeclaration(declaration2) && node.parent === declaration2.parent || isParameterPropertyDeclaration(declaration2, declaration2.parent) && node.parent === declaration2.parent.parent) ? "quit" : true;
                        case 242 /* Block */ :
                            switch(node.parent.kind){
                                case 178 /* GetAccessor */ :
                                case 175 /* MethodDeclaration */ :
                                case 179 /* SetAccessor */ :
                                    return true;
                                default:
                                    return false;
                            }
                        default:
                            return false;
                    }
                });
                return ancestorChangingReferenceScope === void 0;
            }
        }
        function getRequiresScopeChangeCache(node) {
            return getNodeLinks(node).declarationRequiresScopeChange;
        }
        function setRequiresScopeChangeCache(node, value1) {
            getNodeLinks(node).declarationRequiresScopeChange = value1;
        }
        function checkAndReportErrorForInvalidInitializer(errorLocation, name, propertyWithInvalidInitializer, result) {
            if (!emitStandardClassFields) {
                if (errorLocation && !result && checkAndReportErrorForMissingPrefix(errorLocation, name, name)) return true;
                error2(errorLocation, errorLocation && propertyWithInvalidInitializer.type && textRangeContainsPositionInclusive(propertyWithInvalidInitializer.type, errorLocation.pos) ? Diagnostics.Type_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor : Diagnostics.Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor, declarationNameToString(propertyWithInvalidInitializer.name), diagnosticName(name));
                return true;
            }
            return false;
        }
        function onFailedToResolveSymbol(errorLocation, nameArg, meaning, nameNotFoundMessage) {
            const name = isString(nameArg) ? nameArg : nameArg.escapedText;
            addLazyDiagnostic(()=>{
                if (!errorLocation || errorLocation.parent.kind !== 325 /* JSDocLink */  && !checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) && !checkAndReportErrorForExtendingInterface(errorLocation) && !checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) && !checkAndReportErrorForExportingPrimitiveType(errorLocation, name) && !checkAndReportErrorForUsingNamespaceAsTypeOrValue(errorLocation, name, meaning) && !checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) && !checkAndReportErrorForUsingValueAsType(errorLocation, name, meaning)) {
                    let suggestion;
                    let suggestedLib;
                    if (nameArg) {
                        suggestedLib = getSuggestedLibForNonExistentName(nameArg);
                        if (suggestedLib) error2(errorLocation, nameNotFoundMessage, diagnosticName(nameArg), suggestedLib);
                    }
                    if (!suggestedLib && suggestionCount < maximumSuggestionCount) {
                        suggestion = getSuggestedSymbolForNonexistentSymbol(errorLocation, name, meaning);
                        const isGlobalScopeAugmentationDeclaration = (suggestion == null ? void 0 : suggestion.valueDeclaration) && isAmbientModule(suggestion.valueDeclaration) && isGlobalScopeAugmentation(suggestion.valueDeclaration);
                        if (isGlobalScopeAugmentationDeclaration) suggestion = void 0;
                        if (suggestion) {
                            const suggestionName = symbolToString(suggestion);
                            const isUncheckedJS = isUncheckedJSSuggestion(errorLocation, suggestion, /*excludeClasses*/ false);
                            const message = meaning === 1920 /* Namespace */  || nameArg && typeof nameArg !== "string" && nodeIsSynthesized(nameArg) ? Diagnostics.Cannot_find_namespace_0_Did_you_mean_1 : isUncheckedJS ? Diagnostics.Could_not_find_name_0_Did_you_mean_1 : Diagnostics.Cannot_find_name_0_Did_you_mean_1;
                            const diagnostic = createError(errorLocation, message, diagnosticName(nameArg), suggestionName);
                            diagnostic.canonicalHead = getCanonicalDiagnostic(nameNotFoundMessage, diagnosticName(nameArg));
                            addErrorOrSuggestion(!isUncheckedJS, diagnostic);
                            if (suggestion.valueDeclaration) addRelatedInfo(diagnostic, createDiagnosticForNode(suggestion.valueDeclaration, Diagnostics._0_is_declared_here, suggestionName));
                        }
                    }
                    if (!suggestion && !suggestedLib && nameArg) error2(errorLocation, nameNotFoundMessage, diagnosticName(nameArg));
                    suggestionCount++;
                }
            });
        }
        function onSuccessfullyResolvedSymbol(errorLocation, result, meaning, lastLocation, associatedDeclarationForContainingInitializerOrBindingName, withinDeferredContext) {
            addLazyDiagnostic(()=>{
                var _a;
                const name = result.escapedName;
                const isInExternalModule = lastLocation && isSourceFile(lastLocation) && isExternalOrCommonJsModule(lastLocation);
                if (errorLocation && (meaning & 2 /* BlockScopedVariable */  || (meaning & 32 /* Class */  || meaning & 384 /* Enum */ ) && (meaning & 111551 /* Value */ ) === 111551 /* Value */ )) {
                    const exportOrLocalSymbol = getExportSymbolOfValueSymbolIfExported(result);
                    if (exportOrLocalSymbol.flags & 2 /* BlockScopedVariable */  || exportOrLocalSymbol.flags & 32 /* Class */  || exportOrLocalSymbol.flags & 384 /* Enum */ ) checkResolvedBlockScopedVariable(exportOrLocalSymbol, errorLocation);
                }
                if (isInExternalModule && (meaning & 111551 /* Value */ ) === 111551 /* Value */  && !(errorLocation.flags & 16777216 /* JSDoc */ )) {
                    const merged = getMergedSymbol(result);
                    if (length(merged.declarations) && every(merged.declarations, (d)=>isNamespaceExportDeclaration(d) || isSourceFile(d) && !!d.symbol.globalExports)) errorOrSuggestion(!compilerOptions.allowUmdGlobalAccess, errorLocation, Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead, unescapeLeadingUnderscores(name));
                }
                if (associatedDeclarationForContainingInitializerOrBindingName && !withinDeferredContext && (meaning & 111551 /* Value */ ) === 111551 /* Value */ ) {
                    const candidate = getMergedSymbol(getLateBoundSymbol(result));
                    const root = getRootDeclaration(associatedDeclarationForContainingInitializerOrBindingName);
                    if (candidate === getSymbolOfDeclaration(associatedDeclarationForContainingInitializerOrBindingName)) error2(errorLocation, Diagnostics.Parameter_0_cannot_reference_itself, declarationNameToString(associatedDeclarationForContainingInitializerOrBindingName.name));
                    else if (candidate.valueDeclaration && candidate.valueDeclaration.pos > associatedDeclarationForContainingInitializerOrBindingName.pos && root.parent.locals && getSymbol2(root.parent.locals, candidate.escapedName, meaning) === candidate) error2(errorLocation, Diagnostics.Parameter_0_cannot_reference_identifier_1_declared_after_it, declarationNameToString(associatedDeclarationForContainingInitializerOrBindingName.name), declarationNameToString(errorLocation));
                }
                if (errorLocation && meaning & 111551 /* Value */  && result.flags & 2097152 /* Alias */  && !(result.flags & 111551 /* Value */ ) && !isValidTypeOnlyAliasUseSite(errorLocation)) {
                    const typeOnlyDeclaration = getTypeOnlyAliasDeclaration(result, 111551 /* Value */ );
                    if (typeOnlyDeclaration) {
                        const message = typeOnlyDeclaration.kind === 282 /* ExportSpecifier */  || typeOnlyDeclaration.kind === 279 /* ExportDeclaration */  || typeOnlyDeclaration.kind === 281 /* NamespaceExport */  ? Diagnostics._0_cannot_be_used_as_a_value_because_it_was_exported_using_export_type : Diagnostics._0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type;
                        const unescapedName = unescapeLeadingUnderscores(name);
                        addTypeOnlyDeclarationRelatedInfo(error2(errorLocation, message, unescapedName), typeOnlyDeclaration, unescapedName);
                    }
                }
                if (compilerOptions.isolatedModules && result && isInExternalModule && (meaning & 111551 /* Value */ ) === 111551 /* Value */ ) {
                    const isGlobal = getSymbol2(globals, name, meaning) === result;
                    const nonValueSymbol = isGlobal && isSourceFile(lastLocation) && lastLocation.locals && getSymbol2(lastLocation.locals, name, -111552 /* Value */ );
                    if (nonValueSymbol) {
                        const importDecl = (_a = nonValueSymbol.declarations) == null ? void 0 : _a.find((d)=>d.kind === 277 /* ImportSpecifier */  || d.kind === 274 /* ImportClause */  || d.kind === 275 /* NamespaceImport */  || d.kind === 272 /* ImportEqualsDeclaration */ );
                        if (importDecl && !isTypeOnlyImportDeclaration(importDecl)) error2(importDecl, Diagnostics.Import_0_conflicts_with_global_value_used_in_this_file_so_must_be_declared_with_a_type_only_import_when_isolatedModules_is_enabled, unescapeLeadingUnderscores(name));
                    }
                }
            });
        }
        function addTypeOnlyDeclarationRelatedInfo(diagnostic, typeOnlyDeclaration, unescapedName) {
            if (!typeOnlyDeclaration) return diagnostic;
            return addRelatedInfo(diagnostic, createDiagnosticForNode(typeOnlyDeclaration, typeOnlyDeclaration.kind === 282 /* ExportSpecifier */  || typeOnlyDeclaration.kind === 279 /* ExportDeclaration */  || typeOnlyDeclaration.kind === 281 /* NamespaceExport */  ? Diagnostics._0_was_exported_here : Diagnostics._0_was_imported_here, unescapedName));
        }
        function diagnosticName(nameArg) {
            return isString(nameArg) ? unescapeLeadingUnderscores(nameArg) : declarationNameToString(nameArg);
        }
        function checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) {
            if (!isIdentifier(errorLocation) || errorLocation.escapedText !== name || isTypeReferenceIdentifier(errorLocation) || isInTypeQuery(errorLocation)) return false;
            const container = getThisContainer(errorLocation, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            let location = container;
            while(location){
                if (isClassLike(location.parent)) {
                    const classSymbol = getSymbolOfDeclaration(location.parent);
                    if (!classSymbol) break;
                    const constructorType = getTypeOfSymbol(classSymbol);
                    if (getPropertyOfType(constructorType, name)) {
                        error2(errorLocation, Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0, diagnosticName(nameArg), symbolToString(classSymbol));
                        return true;
                    }
                    if (location === container && !isStatic(location)) {
                        const instanceType = getDeclaredTypeOfSymbol(classSymbol).thisType;
                        if (getPropertyOfType(instanceType, name)) {
                            error2(errorLocation, Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0, diagnosticName(nameArg));
                            return true;
                        }
                    }
                }
                location = location.parent;
            }
            return false;
        }
        function checkAndReportErrorForExtendingInterface(errorLocation) {
            const expression = getEntityNameForExtendingInterface(errorLocation);
            if (expression && resolveEntityName(expression, 64 /* Interface */ , /*ignoreErrors*/ true)) {
                error2(errorLocation, Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements, getTextOfNode(expression));
                return true;
            }
            return false;
        }
        function getEntityNameForExtendingInterface(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                case 212 /* PropertyAccessExpression */ :
                    return node.parent ? getEntityNameForExtendingInterface(node.parent) : void 0;
                case 234 /* ExpressionWithTypeArguments */ :
                    if (isEntityNameExpression(node.expression)) return node.expression;
                // falls through
                default:
                    return void 0;
            }
        }
        function checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) {
            const namespaceMeaning = 1920 /* Namespace */  | (isInJSFile(errorLocation) ? 111551 /* Value */  : 0);
            if (meaning === namespaceMeaning) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 788968 /* Type */  & ~namespaceMeaning, /*nameNotFoundMessage*/ void 0, /*isUse*/ false));
                const parent2 = errorLocation.parent;
                if (symbol) {
                    if (isQualifiedName(parent2)) {
                        Debug.assert(parent2.left === errorLocation, "Should only be resolving left side of qualified name as a namespace");
                        const propName = parent2.right.escapedText;
                        const propType = getPropertyOfType(getDeclaredTypeOfSymbol(symbol), propName);
                        if (propType) {
                            error2(parent2, Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1, unescapeLeadingUnderscores(name), unescapeLeadingUnderscores(propName));
                            return true;
                        }
                    }
                    error2(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here, unescapeLeadingUnderscores(name));
                    return true;
                }
            }
            return false;
        }
        function checkAndReportErrorForUsingValueAsType(errorLocation, name, meaning) {
            if (meaning & 788584 /* Namespace */ ) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 111127 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false));
                if (symbol && !(symbol.flags & 1920 /* Namespace */ )) {
                    error2(errorLocation, Diagnostics._0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0, unescapeLeadingUnderscores(name));
                    return true;
                }
            }
            return false;
        }
        function isPrimitiveTypeName(name) {
            return name === "any" || name === "string" || name === "number" || name === "boolean" || name === "never" || name === "unknown";
        }
        function checkAndReportErrorForExportingPrimitiveType(errorLocation, name) {
            if (isPrimitiveTypeName(name) && errorLocation.parent.kind === 282 /* ExportSpecifier */ ) {
                error2(errorLocation, Diagnostics.Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module, name);
                return true;
            }
            return false;
        }
        function checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) {
            if (meaning & 111551 /* Value */ ) {
                if (isPrimitiveTypeName(name)) {
                    const grandparent = errorLocation.parent.parent;
                    if (grandparent && grandparent.parent && isHeritageClause(grandparent)) {
                        const heritageKind = grandparent.token;
                        const containerKind = grandparent.parent.kind;
                        if (containerKind === 265 /* InterfaceDeclaration */  && heritageKind === 96 /* ExtendsKeyword */ ) error2(errorLocation, Diagnostics.An_interface_cannot_extend_a_primitive_type_like_0_It_can_only_extend_other_named_object_types, unescapeLeadingUnderscores(name));
                        else if (isClassLike(grandparent.parent) && heritageKind === 96 /* ExtendsKeyword */ ) error2(errorLocation, Diagnostics.A_class_cannot_extend_a_primitive_type_like_0_Classes_can_only_extend_constructable_values, unescapeLeadingUnderscores(name));
                        else if (isClassLike(grandparent.parent) && heritageKind === 119 /* ImplementsKeyword */ ) error2(errorLocation, Diagnostics.A_class_cannot_implement_a_primitive_type_like_0_It_can_only_implement_other_named_object_types, unescapeLeadingUnderscores(name));
                    } else error2(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, unescapeLeadingUnderscores(name));
                    return true;
                }
                const symbol = resolveSymbol(resolveName(errorLocation, name, 788544 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false));
                const allFlags = symbol && getSymbolFlags(symbol);
                if (symbol && allFlags !== void 0 && !(allFlags & 111551 /* Value */ )) {
                    const rawName = unescapeLeadingUnderscores(name);
                    if (isES2015OrLaterConstructorName(name)) error2(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_es2015_or_later, rawName);
                    else if (maybeMappedType(errorLocation, symbol)) error2(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0, rawName, rawName === "K" ? "P" : "K");
                    else error2(errorLocation, Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, rawName);
                    return true;
                }
            }
            return false;
        }
        function maybeMappedType(node, symbol) {
            const container = findAncestor(node.parent, (n)=>isComputedPropertyName(n) || isPropertySignature(n) ? false : isTypeLiteralNode(n) || "quit");
            if (container && container.members.length === 1) {
                const type = getDeclaredTypeOfSymbol(symbol);
                return !!(type.flags & 1048576 /* Union */ ) && allTypesAssignableToKind(type, 384 /* StringOrNumberLiteral */ , /*strict*/ true);
            }
            return false;
        }
        function isES2015OrLaterConstructorName(n) {
            switch(n){
                case "Promise":
                case "Symbol":
                case "Map":
                case "WeakMap":
                case "Set":
                case "WeakSet":
                    return true;
            }
            return false;
        }
        function checkAndReportErrorForUsingNamespaceAsTypeOrValue(errorLocation, name, meaning) {
            if (meaning & 111127 /* Type */ ) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 1024 /* NamespaceModule */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false));
                if (symbol) {
                    error2(errorLocation, Diagnostics.Cannot_use_namespace_0_as_a_value, unescapeLeadingUnderscores(name));
                    return true;
                }
            } else if (meaning & 788544 /* Value */ ) {
                const symbol = resolveSymbol(resolveName(errorLocation, name, 1536 /* Module */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false));
                if (symbol) {
                    error2(errorLocation, Diagnostics.Cannot_use_namespace_0_as_a_type, unescapeLeadingUnderscores(name));
                    return true;
                }
            }
            return false;
        }
        function checkResolvedBlockScopedVariable(result, errorLocation) {
            var _a;
            Debug.assert(!!(result.flags & 2 /* BlockScopedVariable */  || result.flags & 32 /* Class */  || result.flags & 384 /* Enum */ ));
            if (result.flags & 67108881 /* Assignment */  && result.flags & 32 /* Class */ ) return;
            const declaration = (_a = result.declarations) == null ? void 0 : _a.find((d)=>isBlockOrCatchScoped(d) || isClassLike(d) || d.kind === 267 /* EnumDeclaration */ );
            if (declaration === void 0) return Debug.fail("checkResolvedBlockScopedVariable could not find block-scoped declaration");
            if (!(declaration.flags & 33554432 /* Ambient */ ) && !isBlockScopedNameDeclaredBeforeUse(declaration, errorLocation)) {
                let diagnosticMessage;
                const declarationName = declarationNameToString(getNameOfDeclaration(declaration));
                if (result.flags & 2 /* BlockScopedVariable */ ) diagnosticMessage = error2(errorLocation, Diagnostics.Block_scoped_variable_0_used_before_its_declaration, declarationName);
                else if (result.flags & 32 /* Class */ ) diagnosticMessage = error2(errorLocation, Diagnostics.Class_0_used_before_its_declaration, declarationName);
                else if (result.flags & 256 /* RegularEnum */ ) diagnosticMessage = error2(errorLocation, Diagnostics.Enum_0_used_before_its_declaration, declarationName);
                else {
                    Debug.assert(!!(result.flags & 128 /* ConstEnum */ ));
                    if (getIsolatedModules(compilerOptions)) diagnosticMessage = error2(errorLocation, Diagnostics.Enum_0_used_before_its_declaration, declarationName);
                }
                if (diagnosticMessage) addRelatedInfo(diagnosticMessage, createDiagnosticForNode(declaration, Diagnostics._0_is_declared_here, declarationName));
            }
        }
        function isSameScopeDescendentOf(initial, parent2, stopAt) {
            return !!parent2 && !!findAncestor(initial, (n)=>n === parent2 || (n === stopAt || isFunctionLike(n) && (!getImmediatelyInvokedFunctionExpression(n) || getFunctionFlags(n) & 3 /* AsyncGenerator */ ) ? "quit" : false));
        }
        function getAnyImportSyntax(node) {
            switch(node.kind){
                case 272 /* ImportEqualsDeclaration */ :
                    return node;
                case 274 /* ImportClause */ :
                    return node.parent;
                case 275 /* NamespaceImport */ :
                    return node.parent.parent;
                case 277 /* ImportSpecifier */ :
                    return node.parent.parent.parent;
                default:
                    return void 0;
            }
        }
        function getDeclarationOfAliasSymbol(symbol) {
            return symbol.declarations && findLast(symbol.declarations, isAliasSymbolDeclaration);
        }
        function isAliasSymbolDeclaration(node) {
            return node.kind === 272 /* ImportEqualsDeclaration */  || node.kind === 271 /* NamespaceExportDeclaration */  || node.kind === 274 /* ImportClause */  && !!node.name || node.kind === 275 /* NamespaceImport */  || node.kind === 281 /* NamespaceExport */  || node.kind === 277 /* ImportSpecifier */  || node.kind === 282 /* ExportSpecifier */  || node.kind === 278 /* ExportAssignment */  && exportAssignmentIsAlias(node) || isBinaryExpression(node) && getAssignmentDeclarationKind(node) === 2 /* ModuleExports */  && exportAssignmentIsAlias(node) || isAccessExpression(node) && isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */  && isAliasableOrJsExpression(node.parent.right) || node.kind === 305 /* ShorthandPropertyAssignment */  || node.kind === 304 /* PropertyAssignment */  && isAliasableOrJsExpression(node.initializer) || node.kind === 261 /* VariableDeclaration */  && isVariableDeclarationInitializedToBareOrAccessedRequire(node) || node.kind === 209 /* BindingElement */  && isVariableDeclarationInitializedToBareOrAccessedRequire(node.parent.parent);
        }
        function isAliasableOrJsExpression(e) {
            return isAliasableExpression(e) || isFunctionExpression(e) && isJSConstructor(e);
        }
        function getTargetOfImportEqualsDeclaration(node, dontResolveAlias) {
            const commonJSPropertyAccess = getCommonJSPropertyAccess(node);
            if (commonJSPropertyAccess) {
                const name = getLeftmostAccessExpression(commonJSPropertyAccess.expression).arguments[0];
                return isIdentifier(commonJSPropertyAccess.name) ? resolveSymbol(getPropertyOfType(resolveExternalModuleTypeByLiteral(name), commonJSPropertyAccess.name.escapedText)) : void 0;
            }
            if (isVariableDeclaration(node) || node.moduleReference.kind === 284 /* ExternalModuleReference */ ) {
                const immediate = resolveExternalModuleName(node, getExternalModuleRequireArgument(node) || getExternalModuleImportEqualsDeclarationExpression(node));
                const resolved2 = resolveExternalModuleSymbol(immediate);
                if (resolved2 && 102 /* Node20 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ ) {
                    const moduleExports = getExportOfModule(resolved2, "module.exports", node, dontResolveAlias);
                    if (moduleExports) return moduleExports;
                }
                markSymbolOfAliasDeclarationIfTypeOnly(node, immediate, resolved2, /*overwriteEmpty*/ false);
                return resolved2;
            }
            const resolved = getSymbolOfPartOfRightHandSideOfImportEquals(node.moduleReference, dontResolveAlias);
            checkAndReportErrorForResolvingImportAliasToTypeOnlySymbol(node, resolved);
            return resolved;
        }
        function checkAndReportErrorForResolvingImportAliasToTypeOnlySymbol(node, resolved) {
            if (markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false) && !node.isTypeOnly) {
                const typeOnlyDeclaration = getTypeOnlyAliasDeclaration(getSymbolOfDeclaration(node));
                const isExport = typeOnlyDeclaration.kind === 282 /* ExportSpecifier */  || typeOnlyDeclaration.kind === 279 /* ExportDeclaration */ ;
                const message = isExport ? Diagnostics.An_import_alias_cannot_reference_a_declaration_that_was_exported_using_export_type : Diagnostics.An_import_alias_cannot_reference_a_declaration_that_was_imported_using_import_type;
                const relatedMessage = isExport ? Diagnostics._0_was_exported_here : Diagnostics._0_was_imported_here;
                const name = typeOnlyDeclaration.kind === 279 /* ExportDeclaration */  ? "*" : moduleExportNameTextUnescaped(typeOnlyDeclaration.name);
                addRelatedInfo(error2(node.moduleReference, message), createDiagnosticForNode(typeOnlyDeclaration, relatedMessage, name));
            }
        }
        function resolveExportByName(moduleSymbol, name, sourceNode, dontResolveAlias) {
            const exportValue = moduleSymbol.exports.get("export=" /* ExportEquals */ );
            const exportSymbol = exportValue ? getPropertyOfType(getTypeOfSymbol(exportValue), name, /*skipObjectFunctionPropertyAugment*/ true) : moduleSymbol.exports.get(name);
            const resolved = resolveSymbol(exportSymbol, dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(sourceNode, exportSymbol, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function isSyntacticDefault(node) {
            return isExportAssignment(node) && !node.isExportEquals || hasSyntacticModifier(node, 2048 /* Default */ ) || isExportSpecifier(node) || isNamespaceExport(node);
        }
        function getEmitSyntaxForModuleSpecifierExpression(usage) {
            return isStringLiteralLike(usage) ? host.getEmitSyntaxForUsageLocation(getSourceFileOfNode(usage), usage) : void 0;
        }
        function isESMFormatImportImportingCommonjsFormatFile(usageMode, targetMode) {
            return usageMode === 99 /* ESNext */  && targetMode === 1 /* CommonJS */ ;
        }
        function isOnlyImportableAsDefault(usage, resolvedModule) {
            if (100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ ) {
                const usageMode = getEmitSyntaxForModuleSpecifierExpression(usage);
                if (usageMode === 99 /* ESNext */ ) {
                    resolvedModule !== null && resolvedModule !== void 0 ? resolvedModule : resolvedModule = resolveExternalModuleName(usage, usage, /*ignoreErrors*/ true);
                    const targetFile = resolvedModule && getSourceFileOfModule(resolvedModule);
                    return targetFile && (isJsonSourceFile(targetFile) || getDeclarationFileExtension(targetFile.fileName) === ".d.json.ts");
                }
            }
            return false;
        }
        function canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias, usage) {
            const usageMode = file && getEmitSyntaxForModuleSpecifierExpression(usage);
            if (file && usageMode !== void 0) {
                const targetMode = host.getImpliedNodeFormatForEmit(file);
                if (usageMode === 99 /* ESNext */  && targetMode === 1 /* CommonJS */  && 100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ ) return true;
                if (usageMode === 99 /* ESNext */  && targetMode === 99 /* ESNext */ ) return false;
            }
            if (!allowSyntheticDefaultImports) return false;
            if (!file || file.isDeclarationFile) {
                const defaultExportSymbol = resolveExportByName(moduleSymbol, "default" /* Default */ , /*sourceNode*/ void 0, /*dontResolveAlias*/ true);
                if (defaultExportSymbol && some(defaultExportSymbol.declarations, isSyntacticDefault)) return false;
                if (resolveExportByName(moduleSymbol, escapeLeadingUnderscores("__esModule"), /*sourceNode*/ void 0, dontResolveAlias)) return false;
                return true;
            }
            if (!isSourceFileJS(file)) return hasExportAssignmentSymbol(moduleSymbol);
            return typeof file.externalModuleIndicator !== "object" && !resolveExportByName(moduleSymbol, escapeLeadingUnderscores("__esModule"), /*sourceNode*/ void 0, dontResolveAlias);
        }
        function getTargetOfImportClause(node, dontResolveAlias) {
            const moduleSymbol = resolveExternalModuleName(node, node.parent.moduleSpecifier);
            if (moduleSymbol) return getTargetofModuleDefault(moduleSymbol, node, dontResolveAlias);
        }
        function getTargetofModuleDefault(moduleSymbol, node, dontResolveAlias) {
            var _a;
            const file = (_a = moduleSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
            const specifier = getModuleSpecifierForImportOrExport(node);
            let exportDefaultSymbol;
            let exportModuleDotExportsSymbol;
            if (isShorthandAmbientModuleSymbol(moduleSymbol)) exportDefaultSymbol = moduleSymbol;
            else if (file && specifier && 102 /* Node20 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  && getEmitSyntaxForModuleSpecifierExpression(specifier) === 1 /* CommonJS */  && host.getImpliedNodeFormatForEmit(file) === 99 /* ESNext */  && (exportModuleDotExportsSymbol = resolveExportByName(moduleSymbol, "module.exports", node, dontResolveAlias))) {
                if (!getESModuleInterop(compilerOptions)) {
                    error2(node.name, Diagnostics.Module_0_can_only_be_default_imported_using_the_1_flag, symbolToString(moduleSymbol), "esModuleInterop");
                    return void 0;
                }
                markSymbolOfAliasDeclarationIfTypeOnly(node, exportModuleDotExportsSymbol, /*finalTarget*/ void 0, /*overwriteEmpty*/ false);
                return exportModuleDotExportsSymbol;
            } else exportDefaultSymbol = resolveExportByName(moduleSymbol, "default" /* Default */ , node, dontResolveAlias);
            if (!specifier) return exportDefaultSymbol;
            const hasDefaultOnly = isOnlyImportableAsDefault(specifier, moduleSymbol);
            const hasSyntheticDefault = canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias, specifier);
            if (!exportDefaultSymbol && !hasSyntheticDefault && !hasDefaultOnly) {
                if (hasExportAssignmentSymbol(moduleSymbol) && !allowSyntheticDefaultImports) {
                    const compilerOptionName = moduleKind >= 5 /* ES2015 */  ? "allowSyntheticDefaultImports" : "esModuleInterop";
                    const exportEqualsSymbol = moduleSymbol.exports.get("export=" /* ExportEquals */ );
                    const exportAssignment = exportEqualsSymbol.valueDeclaration;
                    const err = error2(node.name, Diagnostics.Module_0_can_only_be_default_imported_using_the_1_flag, symbolToString(moduleSymbol), compilerOptionName);
                    if (exportAssignment) addRelatedInfo(err, createDiagnosticForNode(exportAssignment, Diagnostics.This_module_is_declared_with_export_and_can_only_be_used_with_a_default_import_when_using_the_0_flag, compilerOptionName));
                } else if (isImportClause(node)) reportNonDefaultExport(moduleSymbol, node);
                else errorNoModuleMemberSymbol(moduleSymbol, moduleSymbol, node, isImportOrExportSpecifier(node) && node.propertyName || node.name);
            } else if (hasSyntheticDefault || hasDefaultOnly) {
                const resolved = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
                markSymbolOfAliasDeclarationIfTypeOnly(node, moduleSymbol, resolved, /*overwriteEmpty*/ false);
                return resolved;
            }
            markSymbolOfAliasDeclarationIfTypeOnly(node, exportDefaultSymbol, /*finalTarget*/ void 0, /*overwriteEmpty*/ false);
            return exportDefaultSymbol;
        }
        function getModuleSpecifierForImportOrExport(node) {
            switch(node.kind){
                case 274 /* ImportClause */ :
                    return node.parent.moduleSpecifier;
                case 272 /* ImportEqualsDeclaration */ :
                    return isExternalModuleReference(node.moduleReference) ? node.moduleReference.expression : void 0;
                case 275 /* NamespaceImport */ :
                    return node.parent.parent.moduleSpecifier;
                case 277 /* ImportSpecifier */ :
                    return node.parent.parent.parent.moduleSpecifier;
                case 282 /* ExportSpecifier */ :
                    return node.parent.parent.moduleSpecifier;
                default:
                    return Debug.assertNever(node);
            }
        }
        function reportNonDefaultExport(moduleSymbol, node) {
            var _a, _b, _c;
            if ((_a = moduleSymbol.exports) == null ? void 0 : _a.has(node.symbol.escapedName)) error2(node.name, Diagnostics.Module_0_has_no_default_export_Did_you_mean_to_use_import_1_from_0_instead, symbolToString(moduleSymbol), symbolToString(node.symbol));
            else {
                const diagnostic = error2(node.name, Diagnostics.Module_0_has_no_default_export, symbolToString(moduleSymbol));
                const exportStar = (_b = moduleSymbol.exports) == null ? void 0 : _b.get("__export" /* ExportStar */ );
                if (exportStar) {
                    const defaultExport = (_c = exportStar.declarations) == null ? void 0 : _c.find((decl)=>{
                        var _a2, _b2;
                        return !!(isExportDeclaration(decl) && decl.moduleSpecifier && ((_b2 = (_a2 = resolveExternalModuleName(decl, decl.moduleSpecifier)) == null ? void 0 : _a2.exports) == null ? void 0 : _b2.has("default" /* Default */ )));
                    });
                    if (defaultExport) addRelatedInfo(diagnostic, createDiagnosticForNode(defaultExport, Diagnostics.export_Asterisk_does_not_re_export_a_default));
                }
            }
        }
        function getTargetOfNamespaceImport(node, dontResolveAlias) {
            const moduleSpecifier = node.parent.parent.moduleSpecifier;
            const immediate = resolveExternalModuleName(node, moduleSpecifier);
            const resolved = resolveESModuleSymbol(immediate, moduleSpecifier, dontResolveAlias, /*suppressInteropError*/ false);
            markSymbolOfAliasDeclarationIfTypeOnly(node, immediate, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getTargetOfNamespaceExport(node, dontResolveAlias) {
            const moduleSpecifier = node.parent.moduleSpecifier;
            const immediate = moduleSpecifier && resolveExternalModuleName(node, moduleSpecifier);
            const resolved = moduleSpecifier && resolveESModuleSymbol(immediate, moduleSpecifier, dontResolveAlias, /*suppressInteropError*/ false);
            markSymbolOfAliasDeclarationIfTypeOnly(node, immediate, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function combineValueAndTypeSymbols(valueSymbol, typeSymbol) {
            if (valueSymbol === unknownSymbol && typeSymbol === unknownSymbol) return unknownSymbol;
            if (valueSymbol.flags & 790504 /* Namespace */ ) return valueSymbol;
            const result = createSymbol(valueSymbol.flags | typeSymbol.flags, valueSymbol.escapedName);
            Debug.assert(valueSymbol.declarations || typeSymbol.declarations);
            result.declarations = deduplicate(concatenate(valueSymbol.declarations, typeSymbol.declarations), equateValues);
            result.parent = valueSymbol.parent || typeSymbol.parent;
            if (valueSymbol.valueDeclaration) result.valueDeclaration = valueSymbol.valueDeclaration;
            if (typeSymbol.members) result.members = new Map(typeSymbol.members);
            if (valueSymbol.exports) result.exports = new Map(valueSymbol.exports);
            return result;
        }
        function getExportOfModule(symbol, nameText, specifier, dontResolveAlias) {
            var _a;
            if (symbol.flags & 1536 /* Module */ ) {
                const exportSymbol = getExportsOfSymbol(symbol).get(nameText);
                const resolved = resolveSymbol(exportSymbol, dontResolveAlias);
                const exportStarDeclaration = (_a = getSymbolLinks(symbol).typeOnlyExportStarMap) == null ? void 0 : _a.get(nameText);
                markSymbolOfAliasDeclarationIfTypeOnly(specifier, exportSymbol, resolved, /*overwriteEmpty*/ false, exportStarDeclaration, nameText);
                return resolved;
            }
        }
        function getPropertyOfVariable(symbol, name) {
            if (symbol.flags & 3 /* Variable */ ) {
                const typeAnnotation = symbol.valueDeclaration.type;
                if (typeAnnotation) return resolveSymbol(getPropertyOfType(getTypeFromTypeNode(typeAnnotation), name));
            }
        }
        function getExternalModuleMember(node, specifier, dontResolveAlias = false) {
            var _a;
            const moduleSpecifier = getExternalModuleRequireArgument(node) || node.moduleSpecifier;
            const moduleSymbol = resolveExternalModuleName(node, moduleSpecifier);
            const name = !isPropertyAccessExpression(specifier) && specifier.propertyName || specifier.name;
            if (!isIdentifier(name) && name.kind !== 11 /* StringLiteral */ ) return void 0;
            const nameText = moduleExportNameTextEscaped(name);
            const suppressInteropError = nameText === "default" /* Default */  && allowSyntheticDefaultImports;
            const targetSymbol = resolveESModuleSymbol(moduleSymbol, moduleSpecifier, /*dontResolveAlias*/ false, suppressInteropError);
            if (targetSymbol) {
                if (nameText || name.kind === 11 /* StringLiteral */ ) {
                    if (isShorthandAmbientModuleSymbol(moduleSymbol)) return moduleSymbol;
                    let symbolFromVariable;
                    if (moduleSymbol && moduleSymbol.exports && moduleSymbol.exports.get("export=" /* ExportEquals */ )) symbolFromVariable = getPropertyOfType(getTypeOfSymbol(targetSymbol), nameText, /*skipObjectFunctionPropertyAugment*/ true);
                    else symbolFromVariable = getPropertyOfVariable(targetSymbol, nameText);
                    symbolFromVariable = resolveSymbol(symbolFromVariable, dontResolveAlias);
                    let symbolFromModule = getExportOfModule(targetSymbol, nameText, specifier, dontResolveAlias);
                    if (symbolFromModule === void 0 && nameText === "default" /* Default */ ) {
                        const file = (_a = moduleSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
                        if (isOnlyImportableAsDefault(moduleSpecifier, moduleSymbol) || canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias, moduleSpecifier)) symbolFromModule = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
                    }
                    const symbol = symbolFromModule && symbolFromVariable && symbolFromModule !== symbolFromVariable ? combineValueAndTypeSymbols(symbolFromVariable, symbolFromModule) : symbolFromModule || symbolFromVariable;
                    if (isImportOrExportSpecifier(specifier) && isOnlyImportableAsDefault(moduleSpecifier, moduleSymbol) && nameText !== "default" /* Default */ ) error2(name, Diagnostics.Named_imports_from_a_JSON_file_into_an_ECMAScript_module_are_not_allowed_when_module_is_set_to_0, ModuleKind[moduleKind]);
                    else if (!symbol) errorNoModuleMemberSymbol(moduleSymbol, targetSymbol, node, name);
                    return symbol;
                }
            }
        }
        function errorNoModuleMemberSymbol(moduleSymbol, targetSymbol, node, name) {
            var _a;
            const moduleName = getFullyQualifiedName(moduleSymbol, node);
            const declarationName = declarationNameToString(name);
            const suggestion = isIdentifier(name) ? getSuggestedSymbolForNonexistentModule(name, targetSymbol) : void 0;
            if (suggestion !== void 0) {
                const suggestionName = symbolToString(suggestion);
                const diagnostic = error2(name, Diagnostics._0_has_no_exported_member_named_1_Did_you_mean_2, moduleName, declarationName, suggestionName);
                if (suggestion.valueDeclaration) addRelatedInfo(diagnostic, createDiagnosticForNode(suggestion.valueDeclaration, Diagnostics._0_is_declared_here, suggestionName));
            } else if ((_a = moduleSymbol.exports) == null ? void 0 : _a.has("default" /* Default */ )) error2(name, Diagnostics.Module_0_has_no_exported_member_1_Did_you_mean_to_use_import_1_from_0_instead, moduleName, declarationName);
            else reportNonExportedMember(node, name, declarationName, moduleSymbol, moduleName);
        }
        function reportNonExportedMember(node, name, declarationName, moduleSymbol, moduleName) {
            var _a, _b;
            const localSymbol = (_b = (_a = tryCast(moduleSymbol.valueDeclaration, canHaveLocals)) == null ? void 0 : _a.locals) == null ? void 0 : _b.get(moduleExportNameTextEscaped(name));
            const exports2 = moduleSymbol.exports;
            if (localSymbol) {
                const exportedEqualsSymbol = exports2 == null ? void 0 : exports2.get("export=" /* ExportEquals */ );
                if (exportedEqualsSymbol) getSymbolIfSameReference(exportedEqualsSymbol, localSymbol) ? reportInvalidImportEqualsExportMember(node, name, declarationName, moduleName) : error2(name, Diagnostics.Module_0_has_no_exported_member_1, moduleName, declarationName);
                else {
                    const exportedSymbol = exports2 ? find(symbolsToArray(exports2), (symbol)=>!!getSymbolIfSameReference(symbol, localSymbol)) : void 0;
                    const diagnostic = exportedSymbol ? error2(name, Diagnostics.Module_0_declares_1_locally_but_it_is_exported_as_2, moduleName, declarationName, symbolToString(exportedSymbol)) : error2(name, Diagnostics.Module_0_declares_1_locally_but_it_is_not_exported, moduleName, declarationName);
                    if (localSymbol.declarations) addRelatedInfo(diagnostic, ...map(localSymbol.declarations, (decl, index)=>createDiagnosticForNode(decl, index === 0 ? Diagnostics._0_is_declared_here : Diagnostics.and_here, declarationName)));
                }
            } else error2(name, Diagnostics.Module_0_has_no_exported_member_1, moduleName, declarationName);
        }
        function reportInvalidImportEqualsExportMember(node, name, declarationName, moduleName) {
            if (moduleKind >= 5 /* ES2015 */ ) {
                const message = getESModuleInterop(compilerOptions) ? Diagnostics._0_can_only_be_imported_by_using_a_default_import : Diagnostics._0_can_only_be_imported_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import;
                error2(name, message, declarationName);
            } else if (isInJSFile(node)) {
                const message = getESModuleInterop(compilerOptions) ? Diagnostics._0_can_only_be_imported_by_using_a_require_call_or_by_using_a_default_import : Diagnostics._0_can_only_be_imported_by_using_a_require_call_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import;
                error2(name, message, declarationName);
            } else {
                const message = getESModuleInterop(compilerOptions) ? Diagnostics._0_can_only_be_imported_by_using_import_1_require_2_or_a_default_import : Diagnostics._0_can_only_be_imported_by_using_import_1_require_2_or_by_turning_on_the_esModuleInterop_flag_and_using_a_default_import;
                error2(name, message, declarationName, declarationName, moduleName);
            }
        }
        function getTargetOfImportSpecifier(node, dontResolveAlias) {
            if (isImportSpecifier(node) && moduleExportNameIsDefault(node.propertyName || node.name)) {
                const specifier = getModuleSpecifierForImportOrExport(node);
                const moduleSymbol = specifier && resolveExternalModuleName(node, specifier);
                if (moduleSymbol) return getTargetofModuleDefault(moduleSymbol, node, dontResolveAlias);
            }
            const root = isBindingElement(node) ? getRootDeclaration(node) : node.parent.parent.parent;
            const commonJSPropertyAccess = getCommonJSPropertyAccess(root);
            const resolved = getExternalModuleMember(root, commonJSPropertyAccess || node, dontResolveAlias);
            const name = node.propertyName || node.name;
            if (commonJSPropertyAccess && resolved && isIdentifier(name)) return resolveSymbol(getPropertyOfType(getTypeOfSymbol(resolved), name.escapedText), dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getCommonJSPropertyAccess(node) {
            if (isVariableDeclaration(node) && node.initializer && isPropertyAccessExpression(node.initializer)) return node.initializer;
        }
        function getTargetOfNamespaceExportDeclaration(node, dontResolveAlias) {
            if (canHaveSymbol(node.parent)) {
                const resolved = resolveExternalModuleSymbol(node.parent.symbol, dontResolveAlias);
                markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
                return resolved;
            }
        }
        function getTargetOfExportSpecifier(node, meaning, dontResolveAlias) {
            const name = node.propertyName || node.name;
            if (moduleExportNameIsDefault(name)) {
                const specifier = getModuleSpecifierForImportOrExport(node);
                const moduleSymbol = specifier && resolveExternalModuleName(node, specifier);
                if (moduleSymbol) return getTargetofModuleDefault(moduleSymbol, node, !!dontResolveAlias);
            }
            const resolved = node.parent.parent.moduleSpecifier ? getExternalModuleMember(node.parent.parent, node, dontResolveAlias) : name.kind === 11 /* StringLiteral */  ? void 0 : // Skip for invalid syntax like this: export { "x" }
            resolveEntityName(name, meaning, /*ignoreErrors*/ false, dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getTargetOfExportAssignment(node, dontResolveAlias) {
            const expression = isExportAssignment(node) ? node.expression : node.right;
            const resolved = getTargetOfAliasLikeExpression(expression, dontResolveAlias);
            markSymbolOfAliasDeclarationIfTypeOnly(node, /*immediateTarget*/ void 0, resolved, /*overwriteEmpty*/ false);
            return resolved;
        }
        function getTargetOfAliasLikeExpression(expression, dontResolveAlias) {
            if (isClassExpression(expression)) return checkExpressionCached(expression).symbol;
            if (!isEntityName(expression) && !isEntityNameExpression(expression)) return void 0;
            const aliasLike = resolveEntityName(expression, 901119 /* Namespace */ , /*ignoreErrors*/ true, dontResolveAlias);
            if (aliasLike) return aliasLike;
            checkExpressionCached(expression);
            return getNodeLinks(expression).resolvedSymbol;
        }
        function getTargetOfAccessExpression(node, dontRecursivelyResolve) {
            if (!(isBinaryExpression(node.parent) && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */ )) return void 0;
            return getTargetOfAliasLikeExpression(node.parent.right, dontRecursivelyResolve);
        }
        function getTargetOfAliasDeclaration(node, dontRecursivelyResolve = false) {
            switch(node.kind){
                case 272 /* ImportEqualsDeclaration */ :
                case 261 /* VariableDeclaration */ :
                    return getTargetOfImportEqualsDeclaration(node, dontRecursivelyResolve);
                case 274 /* ImportClause */ :
                    return getTargetOfImportClause(node, dontRecursivelyResolve);
                case 275 /* NamespaceImport */ :
                    return getTargetOfNamespaceImport(node, dontRecursivelyResolve);
                case 281 /* NamespaceExport */ :
                    return getTargetOfNamespaceExport(node, dontRecursivelyResolve);
                case 277 /* ImportSpecifier */ :
                case 209 /* BindingElement */ :
                    return getTargetOfImportSpecifier(node, dontRecursivelyResolve);
                case 282 /* ExportSpecifier */ :
                    return getTargetOfExportSpecifier(node, 901119 /* Namespace */ , dontRecursivelyResolve);
                case 278 /* ExportAssignment */ :
                case 227 /* BinaryExpression */ :
                    return getTargetOfExportAssignment(node, dontRecursivelyResolve);
                case 271 /* NamespaceExportDeclaration */ :
                    return getTargetOfNamespaceExportDeclaration(node, dontRecursivelyResolve);
                case 305 /* ShorthandPropertyAssignment */ :
                    return resolveEntityName(node.name, 901119 /* Namespace */ , /*ignoreErrors*/ true, dontRecursivelyResolve);
                case 304 /* PropertyAssignment */ :
                    return getTargetOfAliasLikeExpression(node.initializer, dontRecursivelyResolve);
                case 213 /* ElementAccessExpression */ :
                case 212 /* PropertyAccessExpression */ :
                    return getTargetOfAccessExpression(node, dontRecursivelyResolve);
                default:
                    return Debug.fail();
            }
        }
        function isNonLocalAlias(symbol, excludes = 901119 /* Namespace */ ) {
            if (!symbol) return false;
            return (symbol.flags & (2097152 /* Alias */  | excludes)) === 2097152 /* Alias */  || !!(symbol.flags & 2097152 /* Alias */  && symbol.flags & 67108864 /* Assignment */ );
        }
        function resolveSymbol(symbol, dontResolveAlias) {
            return !dontResolveAlias && isNonLocalAlias(symbol) ? resolveAlias(symbol) : symbol;
        }
        function resolveAlias(symbol) {
            Debug.assert((symbol.flags & 2097152 /* Alias */ ) !== 0, "Should only get Alias here.");
            const links = getSymbolLinks(symbol);
            if (!links.aliasTarget) {
                links.aliasTarget = resolvingSymbol;
                const node = getDeclarationOfAliasSymbol(symbol);
                if (!node) return Debug.fail();
                const target = getTargetOfAliasDeclaration(node);
                if (links.aliasTarget === resolvingSymbol) links.aliasTarget = target || unknownSymbol;
                else error2(node, Diagnostics.Circular_definition_of_import_alias_0, symbolToString(symbol));
            } else if (links.aliasTarget === resolvingSymbol) links.aliasTarget = unknownSymbol;
            return links.aliasTarget;
        }
        function tryResolveAlias(symbol) {
            const links = getSymbolLinks(symbol);
            if (links.aliasTarget !== resolvingSymbol) return resolveAlias(symbol);
            return void 0;
        }
        function getSymbolFlags(symbol, excludeTypeOnlyMeanings, excludeLocalMeanings) {
            const typeOnlyDeclaration = excludeTypeOnlyMeanings && getTypeOnlyAliasDeclaration(symbol);
            const typeOnlyDeclarationIsExportStar = typeOnlyDeclaration && isExportDeclaration(typeOnlyDeclaration);
            const typeOnlyResolution = typeOnlyDeclaration && (typeOnlyDeclarationIsExportStar ? resolveExternalModuleName(typeOnlyDeclaration.moduleSpecifier, typeOnlyDeclaration.moduleSpecifier, /*ignoreErrors*/ true) : resolveAlias(typeOnlyDeclaration.symbol));
            const typeOnlyExportStarTargets = typeOnlyDeclarationIsExportStar && typeOnlyResolution ? getExportsOfModule(typeOnlyResolution) : void 0;
            let flags = excludeLocalMeanings ? 0 /* None */  : symbol.flags;
            let seenSymbols;
            while(symbol.flags & 2097152 /* Alias */ ){
                const target = getExportSymbolOfValueSymbolIfExported(resolveAlias(symbol));
                if (!typeOnlyDeclarationIsExportStar && target === typeOnlyResolution || (typeOnlyExportStarTargets == null ? void 0 : typeOnlyExportStarTargets.get(target.escapedName)) === target) break;
                if (target === unknownSymbol) return -1 /* All */ ;
                if (target === symbol || (seenSymbols == null ? void 0 : seenSymbols.has(target))) break;
                if (target.flags & 2097152 /* Alias */ ) {
                    if (seenSymbols) seenSymbols.add(target);
                    else seenSymbols = /* @__PURE__ */ new Set([
                        symbol,
                        target
                    ]);
                }
                flags |= target.flags;
                symbol = target;
            }
            return flags;
        }
        function markSymbolOfAliasDeclarationIfTypeOnly(aliasDeclaration, immediateTarget, finalTarget, overwriteEmpty, exportStarDeclaration, exportStarName) {
            if (!aliasDeclaration || isPropertyAccessExpression(aliasDeclaration)) return false;
            const sourceSymbol = getSymbolOfDeclaration(aliasDeclaration);
            if (isTypeOnlyImportOrExportDeclaration(aliasDeclaration)) {
                const links2 = getSymbolLinks(sourceSymbol);
                links2.typeOnlyDeclaration = aliasDeclaration;
                return true;
            }
            if (exportStarDeclaration) {
                const links2 = getSymbolLinks(sourceSymbol);
                links2.typeOnlyDeclaration = exportStarDeclaration;
                if (sourceSymbol.escapedName !== exportStarName) links2.typeOnlyExportStarName = exportStarName;
                return true;
            }
            const links = getSymbolLinks(sourceSymbol);
            return markSymbolOfAliasDeclarationIfTypeOnlyWorker(links, immediateTarget, overwriteEmpty) || markSymbolOfAliasDeclarationIfTypeOnlyWorker(links, finalTarget, overwriteEmpty);
        }
        function markSymbolOfAliasDeclarationIfTypeOnlyWorker(aliasDeclarationLinks, target, overwriteEmpty) {
            var _a;
            if (target && (aliasDeclarationLinks.typeOnlyDeclaration === void 0 || overwriteEmpty && aliasDeclarationLinks.typeOnlyDeclaration === false)) {
                var _ref;
                const exportSymbol = (_ref = (_a = target.exports) == null ? void 0 : _a.get("export=" /* ExportEquals */ )) !== null && _ref !== void 0 ? _ref : target;
                const typeOnly = exportSymbol.declarations && find(exportSymbol.declarations, isTypeOnlyImportOrExportDeclaration);
                var _ref1;
                aliasDeclarationLinks.typeOnlyDeclaration = (_ref1 = typeOnly !== null && typeOnly !== void 0 ? typeOnly : getSymbolLinks(exportSymbol).typeOnlyDeclaration) !== null && _ref1 !== void 0 ? _ref1 : false;
            }
            return !!aliasDeclarationLinks.typeOnlyDeclaration;
        }
        function getTypeOnlyAliasDeclaration(symbol, include) {
            var _a;
            if (!(symbol.flags & 2097152 /* Alias */ )) return void 0;
            const links = getSymbolLinks(symbol);
            if (links.typeOnlyDeclaration === void 0) {
                links.typeOnlyDeclaration = false;
                const resolved = resolveSymbol(symbol);
                markSymbolOfAliasDeclarationIfTypeOnly((_a = symbol.declarations) == null ? void 0 : _a[0], getDeclarationOfAliasSymbol(symbol) && getImmediateAliasedSymbol(symbol), resolved, /*overwriteEmpty*/ true);
            }
            if (include === void 0) return links.typeOnlyDeclaration || void 0;
            if (links.typeOnlyDeclaration) {
                const resolved = links.typeOnlyDeclaration.kind === 279 /* ExportDeclaration */  ? resolveSymbol(getExportsOfModule(links.typeOnlyDeclaration.symbol.parent).get(links.typeOnlyExportStarName || symbol.escapedName)) : resolveAlias(links.typeOnlyDeclaration.symbol);
                return getSymbolFlags(resolved) & include ? links.typeOnlyDeclaration : void 0;
            }
            return void 0;
        }
        function getSymbolOfPartOfRightHandSideOfImportEquals(entityName, dontResolveAlias) {
            if (entityName.kind === 80 /* Identifier */  && isRightSideOfQualifiedNameOrPropertyAccess(entityName)) entityName = entityName.parent;
            if (entityName.kind === 80 /* Identifier */  || entityName.parent.kind === 167 /* QualifiedName */ ) return resolveEntityName(entityName, 1920 /* Namespace */ , /*ignoreErrors*/ false, dontResolveAlias);
            else {
                Debug.assert(entityName.parent.kind === 272 /* ImportEqualsDeclaration */ );
                return resolveEntityName(entityName, 901119 /* Namespace */ , /*ignoreErrors*/ false, dontResolveAlias);
            }
        }
        function getFullyQualifiedName(symbol, containingLocation) {
            return symbol.parent ? getFullyQualifiedName(symbol.parent, containingLocation) + "." + symbolToString(symbol) : symbolToString(symbol, containingLocation, /*meaning*/ void 0, 36 /* AllowAnyNodeKind */ );
        }
        function getContainingQualifiedNameNode(node) {
            while(isQualifiedName(node.parent))node = node.parent;
            return node;
        }
        function tryGetQualifiedNameAsValue(node) {
            let left = getFirstIdentifier(node);
            let symbol = resolveName(left, left, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
            if (!symbol) return void 0;
            while(isQualifiedName(left.parent)){
                const type = getTypeOfSymbol(symbol);
                symbol = getPropertyOfType(type, left.parent.right.escapedText);
                if (!symbol) return void 0;
                left = left.parent;
            }
            return symbol;
        }
        function resolveEntityName(name, meaning, ignoreErrors, dontResolveAlias, location) {
            if (nodeIsMissing(name)) return void 0;
            const namespaceMeaning = 1920 /* Namespace */  | (isInJSFile(name) ? meaning & 111551 /* Value */  : 0);
            let symbol;
            if (name.kind === 80 /* Identifier */ ) {
                const message = meaning === namespaceMeaning || nodeIsSynthesized(name) ? Diagnostics.Cannot_find_namespace_0 : getCannotFindNameDiagnosticForName(getFirstIdentifier(name));
                const symbolFromJSPrototype = isInJSFile(name) && !nodeIsSynthesized(name) ? resolveEntityNameFromAssignmentDeclaration(name, meaning) : void 0;
                symbol = getMergedSymbol(resolveName(location || name, name, meaning, ignoreErrors || symbolFromJSPrototype ? void 0 : message, /*isUse*/ true, /*excludeGlobals*/ false));
                if (!symbol) return getMergedSymbol(symbolFromJSPrototype);
            } else if (name.kind === 167 /* QualifiedName */  || name.kind === 212 /* PropertyAccessExpression */ ) {
                const left = name.kind === 167 /* QualifiedName */  ? name.left : name.expression;
                const right = name.kind === 167 /* QualifiedName */  ? name.right : name.name;
                let namespace = resolveEntityName(left, namespaceMeaning, ignoreErrors, /*dontResolveAlias*/ false, location);
                if (!namespace || nodeIsMissing(right)) return void 0;
                else if (namespace === unknownSymbol) return namespace;
                if (namespace.valueDeclaration && isInJSFile(namespace.valueDeclaration) && getEmitModuleResolutionKind(compilerOptions) !== 100 /* Bundler */  && isVariableDeclaration(namespace.valueDeclaration) && namespace.valueDeclaration.initializer && isCommonJsRequire(namespace.valueDeclaration.initializer)) {
                    const moduleName = namespace.valueDeclaration.initializer.arguments[0];
                    const moduleSym = resolveExternalModuleName(moduleName, moduleName);
                    if (moduleSym) {
                        const resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
                        if (resolvedModuleSymbol) namespace = resolvedModuleSymbol;
                    }
                }
                symbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(namespace), right.escapedText, meaning));
                if (!symbol && namespace.flags & 2097152 /* Alias */ ) symbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(resolveAlias(namespace)), right.escapedText, meaning));
                if (!symbol) {
                    if (!ignoreErrors) {
                        const namespaceName = getFullyQualifiedName(namespace);
                        const declarationName = declarationNameToString(right);
                        const suggestionForNonexistentModule = getSuggestedSymbolForNonexistentModule(right, namespace);
                        if (suggestionForNonexistentModule) {
                            error2(right, Diagnostics._0_has_no_exported_member_named_1_Did_you_mean_2, namespaceName, declarationName, symbolToString(suggestionForNonexistentModule));
                            return void 0;
                        }
                        const containingQualifiedName = isQualifiedName(name) && getContainingQualifiedNameNode(name);
                        const canSuggestTypeof = globalObjectType && meaning & 788968 /* Type */  && containingQualifiedName && !isTypeOfExpression(containingQualifiedName.parent) && tryGetQualifiedNameAsValue(containingQualifiedName);
                        if (canSuggestTypeof) {
                            error2(containingQualifiedName, Diagnostics._0_refers_to_a_value_but_is_being_used_as_a_type_here_Did_you_mean_typeof_0, entityNameToString(containingQualifiedName));
                            return void 0;
                        }
                        if (meaning & 1920 /* Namespace */  && isQualifiedName(name.parent)) {
                            const exportedTypeSymbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(namespace), right.escapedText, 788968 /* Type */ ));
                            if (exportedTypeSymbol) {
                                error2(name.parent.right, Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1, symbolToString(exportedTypeSymbol), unescapeLeadingUnderscores(name.parent.right.escapedText));
                                return void 0;
                            }
                        }
                        error2(right, Diagnostics.Namespace_0_has_no_exported_member_1, namespaceName, declarationName);
                    }
                    return void 0;
                }
            } else Debug.assertNever(name, "Unknown entity name kind.");
            if (!nodeIsSynthesized(name) && isEntityName(name) && (symbol.flags & 2097152 /* Alias */  || name.parent.kind === 278 /* ExportAssignment */ )) markSymbolOfAliasDeclarationIfTypeOnly(getAliasDeclarationFromName(name), symbol, /*finalTarget*/ void 0, /*overwriteEmpty*/ true);
            return symbol.flags & meaning || dontResolveAlias ? symbol : resolveAlias(symbol);
        }
        function resolveEntityNameFromAssignmentDeclaration(name, meaning) {
            if (isJSDocTypeReference(name.parent)) {
                const secondaryLocation = getAssignmentDeclarationLocation(name.parent);
                if (secondaryLocation) return resolveName(secondaryLocation, name, meaning, /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
            }
        }
        function getAssignmentDeclarationLocation(node) {
            const typeAlias = findAncestor(node, (node2)=>!(isJSDocNode(node2) || node2.flags & 16777216 /* JSDoc */ ) ? "quit" : isJSDocTypeAlias(node2));
            if (typeAlias) return;
            const host2 = getJSDocHost(node);
            if (host2 && isExpressionStatement(host2) && isPrototypePropertyAssignment(host2.expression)) {
                const symbol = getSymbolOfDeclaration(host2.expression.left);
                if (symbol) return getDeclarationOfJSPrototypeContainer(symbol);
            }
            if (host2 && isFunctionExpression(host2) && isPrototypePropertyAssignment(host2.parent) && isExpressionStatement(host2.parent.parent)) {
                const symbol = getSymbolOfDeclaration(host2.parent.left);
                if (symbol) return getDeclarationOfJSPrototypeContainer(symbol);
            }
            if (host2 && (isObjectLiteralMethod(host2) || isPropertyAssignment(host2)) && isBinaryExpression(host2.parent.parent) && getAssignmentDeclarationKind(host2.parent.parent) === 6 /* Prototype */ ) {
                const symbol = getSymbolOfDeclaration(host2.parent.parent.left);
                if (symbol) return getDeclarationOfJSPrototypeContainer(symbol);
            }
            const sig = getEffectiveJSDocHost(node);
            if (sig && isFunctionLike(sig)) {
                const symbol = getSymbolOfDeclaration(sig);
                return symbol && symbol.valueDeclaration;
            }
        }
        function getDeclarationOfJSPrototypeContainer(symbol) {
            const decl = symbol.parent.valueDeclaration;
            if (!decl) return void 0;
            const initializer = isAssignmentDeclaration(decl) ? getAssignedExpandoInitializer(decl) : hasOnlyExpressionInitializer(decl) ? getDeclaredExpandoInitializer(decl) : void 0;
            return initializer || decl;
        }
        function getExpandoSymbol(symbol) {
            const decl = symbol.valueDeclaration;
            if (!decl || !isInJSFile(decl) || symbol.flags & 524288 /* TypeAlias */  || getExpandoInitializer(decl, /*isPrototypeAssignment*/ false)) return void 0;
            const init = isVariableDeclaration(decl) ? getDeclaredExpandoInitializer(decl) : getAssignedExpandoInitializer(decl);
            if (init) {
                const initSymbol = getSymbolOfNode(init);
                if (initSymbol) return mergeJSSymbols(initSymbol, symbol);
            }
        }
        function resolveExternalModuleName(location, moduleReferenceExpression, ignoreErrors) {
            const isClassic = getEmitModuleResolutionKind(compilerOptions) === 1 /* Classic */ ;
            const errorMessage = isClassic ? Diagnostics.Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_to_the_paths_option : Diagnostics.Cannot_find_module_0_or_its_corresponding_type_declarations;
            return resolveExternalModuleNameWorker(location, moduleReferenceExpression, ignoreErrors ? void 0 : errorMessage, ignoreErrors);
        }
        function resolveExternalModuleNameWorker(location, moduleReferenceExpression, moduleNotFoundError, ignoreErrors = false, isForAugmentation = false) {
            return isStringLiteralLike(moduleReferenceExpression) ? resolveExternalModule(location, moduleReferenceExpression.text, moduleNotFoundError, !ignoreErrors ? moduleReferenceExpression : void 0, isForAugmentation) : void 0;
        }
        function resolveExternalModule(location, moduleReference, moduleNotFoundError, errorNode, isForAugmentation = false) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
            if (errorNode && startsWith(moduleReference, "@types/")) {
                const diag2 = Diagnostics.Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1;
                const withoutAtTypePrefix = removePrefix(moduleReference, "@types/");
                error2(errorNode, diag2, withoutAtTypePrefix, moduleReference);
            }
            const ambientModule = tryFindAmbientModule(moduleReference, /*withAugmentations*/ true);
            if (ambientModule) return ambientModule;
            const currentSourceFile = getSourceFileOfNode(location);
            const contextSpecifier = isStringLiteralLike(location) ? location : ((_a = isModuleDeclaration(location) ? location : location.parent && isModuleDeclaration(location.parent) && location.parent.name === location ? location.parent : void 0) == null ? void 0 : _a.name) || ((_b = isLiteralImportTypeNode(location) ? location : void 0) == null ? void 0 : _b.argument.literal) || (isVariableDeclaration(location) && location.initializer && isRequireCall(location.initializer, /*requireStringLiteralLikeArgument*/ true) ? location.initializer.arguments[0] : void 0) || ((_c = findAncestor(location, isImportCall)) == null ? void 0 : _c.arguments[0]) || ((_d = findAncestor(location, or(isImportDeclaration, isJSDocImportTag, isExportDeclaration))) == null ? void 0 : _d.moduleSpecifier) || ((_e = findAncestor(location, isExternalModuleImportEqualsDeclaration)) == null ? void 0 : _e.moduleReference.expression);
            const mode = contextSpecifier && isStringLiteralLike(contextSpecifier) ? host.getModeForUsageLocation(currentSourceFile, contextSpecifier) : host.getDefaultResolutionModeForFile(currentSourceFile);
            const moduleResolutionKind = getEmitModuleResolutionKind(compilerOptions);
            const resolvedModule = (_f = host.getResolvedModule(currentSourceFile, moduleReference, mode)) == null ? void 0 : _f.resolvedModule;
            const resolutionDiagnostic = errorNode && resolvedModule && getResolutionDiagnostic(compilerOptions, resolvedModule, currentSourceFile);
            const sourceFile = resolvedModule && (!resolutionDiagnostic || resolutionDiagnostic === Diagnostics.Module_0_was_resolved_to_1_but_jsx_is_not_set) && host.getSourceFile(resolvedModule.resolvedFileName);
            if (sourceFile) {
                if (resolutionDiagnostic) error2(errorNode, resolutionDiagnostic, moduleReference, resolvedModule.resolvedFileName);
                if (resolvedModule.resolvedUsingTsExtension && isDeclarationFileName(moduleReference)) {
                    const importOrExport = ((_g = findAncestor(location, isImportDeclaration)) == null ? void 0 : _g.importClause) || findAncestor(location, or(isImportEqualsDeclaration, isExportDeclaration));
                    if (errorNode && importOrExport && !importOrExport.isTypeOnly || findAncestor(location, isImportCall)) error2(errorNode, Diagnostics.A_declaration_file_cannot_be_imported_without_import_type_Did_you_mean_to_import_an_implementation_file_0_instead, getSuggestedImportSource(Debug.checkDefined(tryExtractTSExtension(moduleReference))));
                } else if (resolvedModule.resolvedUsingTsExtension && !shouldAllowImportingTsExtension(compilerOptions, currentSourceFile.fileName)) {
                    const importOrExport = ((_h = findAncestor(location, isImportDeclaration)) == null ? void 0 : _h.importClause) || findAncestor(location, or(isImportEqualsDeclaration, isExportDeclaration));
                    if (errorNode && !((importOrExport == null ? void 0 : importOrExport.isTypeOnly) || findAncestor(location, isImportTypeNode))) {
                        const tsExtension = Debug.checkDefined(tryExtractTSExtension(moduleReference));
                        error2(errorNode, Diagnostics.An_import_path_can_only_end_with_a_0_extension_when_allowImportingTsExtensions_is_enabled, tsExtension);
                    }
                } else if (compilerOptions.rewriteRelativeImportExtensions && !(location.flags & 33554432 /* Ambient */ ) && !isDeclarationFileName(moduleReference) && !isLiteralImportTypeNode(location) && !isPartOfTypeOnlyImportOrExportDeclaration(location)) {
                    const shouldRewrite = shouldRewriteModuleSpecifier(moduleReference, compilerOptions);
                    if (!resolvedModule.resolvedUsingTsExtension && shouldRewrite) error2(errorNode, Diagnostics.This_relative_import_path_is_unsafe_to_rewrite_because_it_looks_like_a_file_name_but_actually_resolves_to_0, getRelativePathFromFile(getNormalizedAbsolutePath(currentSourceFile.fileName, host.getCurrentDirectory()), resolvedModule.resolvedFileName, hostGetCanonicalFileName(host)));
                    else if (resolvedModule.resolvedUsingTsExtension && !shouldRewrite && sourceFileMayBeEmitted(sourceFile, host)) error2(errorNode, Diagnostics.This_import_uses_a_0_extension_to_resolve_to_an_input_TypeScript_file_but_will_not_be_rewritten_during_emit_because_it_is_not_a_relative_path, getAnyExtensionFromPath(moduleReference));
                    else if (resolvedModule.resolvedUsingTsExtension && shouldRewrite) {
                        const redirect = (_i = host.getRedirectFromSourceFile(sourceFile.path)) == null ? void 0 : _i.resolvedRef;
                        if (redirect) {
                            const ignoreCase = !host.useCaseSensitiveFileNames();
                            const ownRootDir = host.getCommonSourceDirectory();
                            const otherRootDir = getCommonSourceDirectoryOfConfig(redirect.commandLine, ignoreCase);
                            const rootDirPath = getRelativePathFromDirectory(ownRootDir, otherRootDir, ignoreCase);
                            const outDirPath = getRelativePathFromDirectory(compilerOptions.outDir || ownRootDir, redirect.commandLine.options.outDir || otherRootDir, ignoreCase);
                            if (rootDirPath !== outDirPath) error2(errorNode, Diagnostics.This_import_path_is_unsafe_to_rewrite_because_it_resolves_to_another_project_and_the_relative_path_between_the_projects_output_files_is_not_the_same_as_the_relative_path_between_its_input_files);
                        }
                    }
                }
                if (sourceFile.symbol) {
                    if (errorNode && resolvedModule.isExternalLibraryImport && !resolutionExtensionIsTSOrJson(resolvedModule.extension)) errorOnImplicitAnyModule(/*isError*/ false, errorNode, currentSourceFile, mode, resolvedModule, moduleReference);
                    if (errorNode && (moduleKind === 100 /* Node16 */  || moduleKind === 101 /* Node18 */ )) {
                        const isSyncImport = currentSourceFile.impliedNodeFormat === 1 /* CommonJS */  && !findAncestor(location, isImportCall) || !!findAncestor(location, isImportEqualsDeclaration);
                        const overrideHost = findAncestor(location, (l)=>isImportTypeNode(l) || isExportDeclaration(l) || isImportDeclaration(l) || isJSDocImportTag(l));
                        if (isSyncImport && sourceFile.impliedNodeFormat === 99 /* ESNext */  && !hasResolutionModeOverride(overrideHost)) {
                            if (findAncestor(location, isImportEqualsDeclaration)) error2(errorNode, Diagnostics.Module_0_cannot_be_imported_using_this_construct_The_specifier_only_resolves_to_an_ES_module_which_cannot_be_imported_with_require_Use_an_ECMAScript_import_instead, moduleReference);
                            else {
                                let diagnosticDetails;
                                const ext = tryGetExtensionFromPath2(currentSourceFile.fileName);
                                if (ext === ".ts" /* Ts */  || ext === ".js" /* Js */  || ext === ".tsx" /* Tsx */  || ext === ".jsx" /* Jsx */ ) diagnosticDetails = createModeMismatchDetails(currentSourceFile);
                                const message = (overrideHost == null ? void 0 : overrideHost.kind) === 273 /* ImportDeclaration */  && ((_j = overrideHost.importClause) == null ? void 0 : _j.isTypeOnly) ? Diagnostics.Type_only_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute : (overrideHost == null ? void 0 : overrideHost.kind) === 206 /* ImportType */  ? Diagnostics.Type_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute : Diagnostics.The_current_file_is_a_CommonJS_module_whose_imports_will_produce_require_calls_however_the_referenced_file_is_an_ECMAScript_module_and_cannot_be_imported_with_require_Consider_writing_a_dynamic_import_0_call_instead;
                                diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorNode), errorNode, chainDiagnosticMessages(diagnosticDetails, message, moduleReference)));
                            }
                        }
                    }
                    return getMergedSymbol(sourceFile.symbol);
                }
                if (errorNode && moduleNotFoundError && !isSideEffectImport(errorNode)) error2(errorNode, Diagnostics.File_0_is_not_a_module, sourceFile.fileName);
                return void 0;
            }
            if (patternAmbientModules) {
                const pattern = findBestPatternMatch(patternAmbientModules, (_)=>_.pattern, moduleReference);
                if (pattern) {
                    const augmentation = patternAmbientModuleAugmentations && patternAmbientModuleAugmentations.get(moduleReference);
                    if (augmentation) return getMergedSymbol(augmentation);
                    return getMergedSymbol(pattern.symbol);
                }
            }
            if (!errorNode) return void 0;
            if (resolvedModule && !resolutionExtensionIsTSOrJson(resolvedModule.extension) && resolutionDiagnostic === void 0 || resolutionDiagnostic === Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type) {
                if (isForAugmentation) {
                    const diag2 = Diagnostics.Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented;
                    error2(errorNode, diag2, moduleReference, resolvedModule.resolvedFileName);
                } else errorOnImplicitAnyModule(/*isError*/ noImplicitAny && !!moduleNotFoundError, errorNode, currentSourceFile, mode, resolvedModule, moduleReference);
                return void 0;
            }
            if (moduleNotFoundError) {
                if (resolvedModule) {
                    const redirect = host.getRedirectFromSourceFile(resolvedModule.resolvedFileName);
                    if (redirect == null ? void 0 : redirect.outputDts) {
                        error2(errorNode, Diagnostics.Output_file_0_has_not_been_built_from_source_file_1, redirect.outputDts, resolvedModule.resolvedFileName);
                        return void 0;
                    }
                }
                if (resolutionDiagnostic) error2(errorNode, resolutionDiagnostic, moduleReference, resolvedModule.resolvedFileName);
                else {
                    const isExtensionlessRelativePathImport = pathIsRelative(moduleReference) && !hasExtension(moduleReference);
                    const resolutionIsNode16OrNext = moduleResolutionKind === 3 /* Node16 */  || moduleResolutionKind === 99 /* NodeNext */ ;
                    if (!getResolveJsonModule(compilerOptions) && fileExtensionIs(moduleReference, ".json" /* Json */ ) && moduleResolutionKind !== 1 /* Classic */  && hasJsonModuleEmitEnabled(compilerOptions)) error2(errorNode, Diagnostics.Cannot_find_module_0_Consider_using_resolveJsonModule_to_import_module_with_json_extension, moduleReference);
                    else if (mode === 99 /* ESNext */  && resolutionIsNode16OrNext && isExtensionlessRelativePathImport) {
                        const absoluteRef = getNormalizedAbsolutePath(moduleReference, getDirectoryPath(currentSourceFile.path));
                        const suggestedExt = (_k = suggestedExtensions.find(([actualExt, _importExt])=>host.fileExists(absoluteRef + actualExt))) == null ? void 0 : _k[1];
                        if (suggestedExt) error2(errorNode, Diagnostics.Relative_import_paths_need_explicit_file_extensions_in_ECMAScript_imports_when_moduleResolution_is_node16_or_nodenext_Did_you_mean_0, moduleReference + suggestedExt);
                        else error2(errorNode, Diagnostics.Relative_import_paths_need_explicit_file_extensions_in_ECMAScript_imports_when_moduleResolution_is_node16_or_nodenext_Consider_adding_an_extension_to_the_import_path);
                    } else if ((_l = host.getResolvedModule(currentSourceFile, moduleReference, mode)) == null ? void 0 : _l.alternateResult) {
                        const errorInfo = createModuleNotFoundChain(currentSourceFile, host, moduleReference, mode, moduleReference);
                        errorOrSuggestion(/*isError*/ true, errorNode, chainDiagnosticMessages(errorInfo, moduleNotFoundError, moduleReference));
                    } else error2(errorNode, moduleNotFoundError, moduleReference);
                }
            }
            return void 0;
            function getSuggestedImportSource(tsExtension) {
                const importSourceWithoutExtension = removeExtension(moduleReference, tsExtension);
                if (emitModuleKindIsNonNodeESM(moduleKind) || mode === 99 /* ESNext */ ) {
                    const preferTs = isDeclarationFileName(moduleReference) && shouldAllowImportingTsExtension(compilerOptions);
                    const ext = tsExtension === ".mts" /* Mts */  || tsExtension === ".d.mts" /* Dmts */  ? preferTs ? ".mts" : ".mjs" : tsExtension === ".cts" /* Cts */  || tsExtension === ".d.mts" /* Dmts */  ? preferTs ? ".cts" : ".cjs" : preferTs ? ".ts" : ".js";
                    return importSourceWithoutExtension + ext;
                }
                return importSourceWithoutExtension;
            }
        }
        function errorOnImplicitAnyModule(isError, errorNode, sourceFile, mode, { packageId, resolvedFileName }, moduleReference) {
            if (isSideEffectImport(errorNode)) return;
            let errorInfo;
            if (!isExternalModuleNameRelative(moduleReference) && packageId) errorInfo = createModuleNotFoundChain(sourceFile, host, moduleReference, mode, packageId.name);
            errorOrSuggestion(isError, errorNode, chainDiagnosticMessages(errorInfo, Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type, moduleReference, resolvedFileName));
        }
        function resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) {
            if (moduleSymbol == null ? void 0 : moduleSymbol.exports) {
                const exportEquals = resolveSymbol(moduleSymbol.exports.get("export=" /* ExportEquals */ ), dontResolveAlias);
                const exported = getCommonJsExportEquals(getMergedSymbol(exportEquals), getMergedSymbol(moduleSymbol));
                return getMergedSymbol(exported) || moduleSymbol;
            }
            return void 0;
        }
        function getCommonJsExportEquals(exported, moduleSymbol) {
            if (!exported || exported === unknownSymbol || exported === moduleSymbol || moduleSymbol.exports.size === 1 || exported.flags & 2097152 /* Alias */ ) return exported;
            const links = getSymbolLinks(exported);
            if (links.cjsExportMerged) return links.cjsExportMerged;
            const merged = exported.flags & 33554432 /* Transient */  ? exported : cloneSymbol(exported);
            merged.flags = merged.flags | 512 /* ValueModule */ ;
            if (merged.exports === void 0) merged.exports = createSymbolTable();
            moduleSymbol.exports.forEach((s, name)=>{
                if (name === "export=" /* ExportEquals */ ) return;
                merged.exports.set(name, merged.exports.has(name) ? mergeSymbol(merged.exports.get(name), s) : s);
            });
            if (merged === exported) {
                getSymbolLinks(merged).resolvedExports = void 0;
                getSymbolLinks(merged).resolvedMembers = void 0;
            }
            getSymbolLinks(merged).cjsExportMerged = merged;
            return links.cjsExportMerged = merged;
        }
        function resolveESModuleSymbol(moduleSymbol, referencingLocation, dontResolveAlias, suppressInteropError) {
            var _a;
            const symbol = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias);
            if (!dontResolveAlias && symbol) {
                if (!suppressInteropError && !(symbol.flags & 1539 /* Variable */ ) && !getDeclarationOfKind(symbol, 308 /* SourceFile */ )) {
                    const compilerOptionName = moduleKind >= 5 /* ES2015 */  ? "allowSyntheticDefaultImports" : "esModuleInterop";
                    error2(referencingLocation, Diagnostics.This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_referencing_its_default_export, compilerOptionName);
                    return symbol;
                }
                const referenceParent = referencingLocation.parent;
                const namespaceImport = isImportDeclaration(referenceParent) && getNamespaceDeclarationNode(referenceParent);
                if (namespaceImport || isImportCall(referenceParent)) {
                    const reference = isImportCall(referenceParent) ? referenceParent.arguments[0] : referenceParent.moduleSpecifier;
                    const type = getTypeOfSymbol(symbol);
                    const defaultOnlyType = getTypeWithSyntheticDefaultOnly(type, symbol, moduleSymbol, reference);
                    if (defaultOnlyType) return cloneTypeAsModuleType(symbol, defaultOnlyType, referenceParent);
                    const targetFile = (_a = moduleSymbol == null ? void 0 : moduleSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
                    const usageMode = getEmitSyntaxForModuleSpecifierExpression(reference);
                    let exportModuleDotExportsSymbol;
                    if (namespaceImport && targetFile && 102 /* Node20 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  && usageMode === 1 /* CommonJS */  && host.getImpliedNodeFormatForEmit(targetFile) === 99 /* ESNext */  && (exportModuleDotExportsSymbol = resolveExportByName(symbol, "module.exports", namespaceImport, dontResolveAlias))) {
                        if (!suppressInteropError && !(symbol.flags & 1539 /* Variable */ )) error2(referencingLocation, Diagnostics.This_module_can_only_be_referenced_with_ECMAScript_imports_Slashexports_by_turning_on_the_0_flag_and_referencing_its_default_export, "esModuleInterop");
                        if (getESModuleInterop(compilerOptions) && hasSignatures(type)) return cloneTypeAsModuleType(exportModuleDotExportsSymbol, type, referenceParent);
                        return exportModuleDotExportsSymbol;
                    }
                    const isEsmCjsRef = targetFile && isESMFormatImportImportingCommonjsFormatFile(usageMode, host.getImpliedNodeFormatForEmit(targetFile));
                    if (getESModuleInterop(compilerOptions) || isEsmCjsRef) {
                        if (hasSignatures(type) || getPropertyOfType(type, "default" /* Default */ , /*skipObjectFunctionPropertyAugment*/ true) || isEsmCjsRef) {
                            const moduleType = type.flags & 3670016 /* StructuredType */  ? getTypeWithSyntheticDefaultImportType(type, symbol, moduleSymbol, reference) : createDefaultPropertyWrapperForModule(symbol, symbol.parent);
                            return cloneTypeAsModuleType(symbol, moduleType, referenceParent);
                        }
                    }
                }
            }
            return symbol;
        }
        function hasSignatures(type) {
            return some(getSignaturesOfStructuredType(type, 0 /* Call */ )) || some(getSignaturesOfStructuredType(type, 1 /* Construct */ ));
        }
        function cloneTypeAsModuleType(symbol, moduleType, referenceParent) {
            const result = createSymbol(symbol.flags, symbol.escapedName);
            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
            result.parent = symbol.parent;
            result.links.target = symbol;
            result.links.originatingImport = referenceParent;
            if (symbol.valueDeclaration) result.valueDeclaration = symbol.valueDeclaration;
            if (symbol.constEnumOnlyModule) result.constEnumOnlyModule = true;
            if (symbol.members) result.members = new Map(symbol.members);
            if (symbol.exports) result.exports = new Map(symbol.exports);
            const resolvedModuleType = resolveStructuredTypeMembers(moduleType);
            result.links.type = createAnonymousType(result, resolvedModuleType.members, emptyArray, emptyArray, resolvedModuleType.indexInfos);
            return result;
        }
        function hasExportAssignmentSymbol(moduleSymbol) {
            return moduleSymbol.exports.get("export=" /* ExportEquals */ ) !== void 0;
        }
        function getExportsOfModuleAsArray(moduleSymbol) {
            return symbolsToArray(getExportsOfModule(moduleSymbol));
        }
        function getExportsAndPropertiesOfModule(moduleSymbol) {
            const exports2 = getExportsOfModuleAsArray(moduleSymbol);
            const exportEquals = resolveExternalModuleSymbol(moduleSymbol);
            if (exportEquals !== moduleSymbol) {
                const type = getTypeOfSymbol(exportEquals);
                if (shouldTreatPropertiesOfExternalModuleAsExports(type)) addRange(exports2, getPropertiesOfType(type));
            }
            return exports2;
        }
        function forEachExportAndPropertyOfModule(moduleSymbol, cb) {
            const exports2 = getExportsOfModule(moduleSymbol);
            exports2.forEach((symbol, key)=>{
                if (!isReservedMemberName(key)) cb(symbol, key);
            });
            const exportEquals = resolveExternalModuleSymbol(moduleSymbol);
            if (exportEquals !== moduleSymbol) {
                const type = getTypeOfSymbol(exportEquals);
                if (shouldTreatPropertiesOfExternalModuleAsExports(type)) forEachPropertyOfType(type, (symbol, escapedName)=>{
                    cb(symbol, escapedName);
                });
            }
        }
        function tryGetMemberInModuleExports(memberName, moduleSymbol) {
            const symbolTable = getExportsOfModule(moduleSymbol);
            if (symbolTable) return symbolTable.get(memberName);
        }
        function tryGetMemberInModuleExportsAndProperties(memberName, moduleSymbol) {
            const symbol = tryGetMemberInModuleExports(memberName, moduleSymbol);
            if (symbol) return symbol;
            const exportEquals = resolveExternalModuleSymbol(moduleSymbol);
            if (exportEquals === moduleSymbol) return void 0;
            const type = getTypeOfSymbol(exportEquals);
            return shouldTreatPropertiesOfExternalModuleAsExports(type) ? getPropertyOfType(type, memberName) : void 0;
        }
        function shouldTreatPropertiesOfExternalModuleAsExports(resolvedExternalModuleType) {
            return !(resolvedExternalModuleType.flags & 402784252 /* Primitive */  || getObjectFlags(resolvedExternalModuleType) & 1 /* Class */  || // `isArrayOrTupleLikeType` is too expensive to use in this auto-imports hot path
            isArrayType(resolvedExternalModuleType) || isTupleType(resolvedExternalModuleType));
        }
        function getExportsOfSymbol(symbol) {
            return symbol.flags & 6256 /* LateBindingContainer */  ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedExports" /* resolvedExports */ ) : symbol.flags & 1536 /* Module */  ? getExportsOfModule(symbol) : symbol.exports || emptySymbols;
        }
        function getExportsOfModule(moduleSymbol) {
            const links = getSymbolLinks(moduleSymbol);
            if (!links.resolvedExports) {
                const { exports: exports2, typeOnlyExportStarMap } = getExportsOfModuleWorker(moduleSymbol);
                links.resolvedExports = exports2;
                links.typeOnlyExportStarMap = typeOnlyExportStarMap;
            }
            return links.resolvedExports;
        }
        function extendExportSymbols(target, source, lookupTable, exportNode) {
            if (!source) return;
            source.forEach((sourceSymbol, id)=>{
                if (id === "default" /* Default */ ) return;
                const targetSymbol = target.get(id);
                if (!targetSymbol) {
                    target.set(id, sourceSymbol);
                    if (lookupTable && exportNode) lookupTable.set(id, {
                        specifierText: getTextOfNode(exportNode.moduleSpecifier)
                    });
                } else if (lookupTable && exportNode && targetSymbol && resolveSymbol(targetSymbol) !== resolveSymbol(sourceSymbol)) {
                    const collisionTracker = lookupTable.get(id);
                    if (!collisionTracker.exportsWithDuplicate) collisionTracker.exportsWithDuplicate = [
                        exportNode
                    ];
                    else collisionTracker.exportsWithDuplicate.push(exportNode);
                }
            });
        }
        function getExportsOfModuleWorker(moduleSymbol) {
            const visitedSymbols = [];
            let typeOnlyExportStarMap;
            const nonTypeOnlyNames = /* @__PURE__ */ new Set();
            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
            const exports2 = visit(moduleSymbol) || emptySymbols;
            if (typeOnlyExportStarMap) nonTypeOnlyNames.forEach((name)=>typeOnlyExportStarMap.delete(name));
            return {
                exports: exports2,
                typeOnlyExportStarMap
            };
            function visit(symbol, exportStar, isTypeOnly) {
                if (!isTypeOnly && (symbol == null ? void 0 : symbol.exports)) symbol.exports.forEach((_, name)=>nonTypeOnlyNames.add(name));
                if (!(symbol && symbol.exports && pushIfUnique(visitedSymbols, symbol))) return;
                const symbols = new Map(symbol.exports);
                const exportStars = symbol.exports.get("__export" /* ExportStar */ );
                if (exportStars) {
                    const nestedSymbols = createSymbolTable();
                    const lookupTable = /* @__PURE__ */ new Map();
                    if (exportStars.declarations) for (const node of exportStars.declarations){
                        const resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
                        const exportedSymbols = visit(resolvedModule, node, isTypeOnly || node.isTypeOnly);
                        extendExportSymbols(nestedSymbols, exportedSymbols, lookupTable, node);
                    }
                    lookupTable.forEach(({ exportsWithDuplicate }, id)=>{
                        if (id === "export=" || !(exportsWithDuplicate && exportsWithDuplicate.length) || symbols.has(id)) return;
                        for (const node of exportsWithDuplicate)diagnostics.add(createDiagnosticForNode(node, Diagnostics.Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity, lookupTable.get(id).specifierText, unescapeLeadingUnderscores(id)));
                    });
                    extendExportSymbols(symbols, nestedSymbols);
                }
                if (exportStar == null ? void 0 : exportStar.isTypeOnly) {
                    typeOnlyExportStarMap !== null && typeOnlyExportStarMap !== void 0 ? typeOnlyExportStarMap : typeOnlyExportStarMap = /* @__PURE__ */ new Map();
                    symbols.forEach((_, escapedName)=>typeOnlyExportStarMap.set(escapedName, exportStar));
                }
                return symbols;
            }
        }
        function getMergedSymbol(symbol) {
            let merged;
            return symbol && symbol.mergeId && (merged = mergedSymbols[symbol.mergeId]) ? merged : symbol;
        }
        function getSymbolOfDeclaration(node) {
            return getMergedSymbol(node.symbol && getLateBoundSymbol(node.symbol));
        }
        function getSymbolOfNode(node) {
            return canHaveSymbol(node) ? getSymbolOfDeclaration(node) : void 0;
        }
        function getParentOfSymbol(symbol) {
            return getMergedSymbol(symbol.parent && getLateBoundSymbol(symbol.parent));
        }
        function getFunctionExpressionParentSymbolOrSymbol(symbol) {
            var _a, _b;
            return ((_a = symbol.valueDeclaration) == null ? void 0 : _a.kind) === 220 /* ArrowFunction */  || ((_b = symbol.valueDeclaration) == null ? void 0 : _b.kind) === 219 /* FunctionExpression */  ? getSymbolOfNode(symbol.valueDeclaration.parent) || symbol : symbol;
        }
        function getAlternativeContainingModules(symbol, enclosingDeclaration) {
            const containingFile = getSourceFileOfNode(enclosingDeclaration);
            const id = getNodeId(containingFile);
            const links = getSymbolLinks(symbol);
            let results;
            if (links.extendedContainersByFile && (results = links.extendedContainersByFile.get(id))) return results;
            if (containingFile && containingFile.imports) {
                for (const importRef of containingFile.imports){
                    if (nodeIsSynthesized(importRef)) continue;
                    const resolvedModule = resolveExternalModuleName(enclosingDeclaration, importRef, /*ignoreErrors*/ true);
                    if (!resolvedModule) continue;
                    const ref = getAliasForSymbolInContainer(resolvedModule, symbol);
                    if (!ref) continue;
                    results = append(results, resolvedModule);
                }
                if (length(results)) {
                    (links.extendedContainersByFile || (links.extendedContainersByFile = /* @__PURE__ */ new Map())).set(id, results);
                    return results;
                }
            }
            if (links.extendedContainers) return links.extendedContainers;
            const otherFiles = host.getSourceFiles();
            for (const file of otherFiles){
                if (!isExternalModule(file)) continue;
                const sym = getSymbolOfDeclaration(file);
                const ref = getAliasForSymbolInContainer(sym, symbol);
                if (!ref) continue;
                results = append(results, sym);
            }
            return links.extendedContainers = results || emptyArray;
        }
        function getContainersOfSymbol(symbol, enclosingDeclaration, meaning) {
            const container = getParentOfSymbol(symbol);
            if (container && !(symbol.flags & 262144 /* TypeParameter */ )) return getWithAlternativeContainers(container);
            const candidates = mapDefined(symbol.declarations, (d)=>{
                if (!isAmbientModule(d) && d.parent) {
                    if (hasNonGlobalAugmentationExternalModuleSymbol(d.parent)) return getSymbolOfDeclaration(d.parent);
                    if (isModuleBlock(d.parent) && d.parent.parent && resolveExternalModuleSymbol(getSymbolOfDeclaration(d.parent.parent)) === symbol) return getSymbolOfDeclaration(d.parent.parent);
                }
                if (isClassExpression(d) && isBinaryExpression(d.parent) && d.parent.operatorToken.kind === 64 /* EqualsToken */  && isAccessExpression(d.parent.left) && isEntityNameExpression(d.parent.left.expression)) {
                    if (isModuleExportsAccessExpression(d.parent.left) || isExportsIdentifier(d.parent.left.expression)) return getSymbolOfDeclaration(getSourceFileOfNode(d));
                    checkExpressionCached(d.parent.left.expression);
                    return getNodeLinks(d.parent.left.expression).resolvedSymbol;
                }
            });
            if (!length(candidates)) return void 0;
            const containers = mapDefined(candidates, (candidate)=>getAliasForSymbolInContainer(candidate, symbol) ? candidate : void 0);
            let bestContainers = [];
            let alternativeContainers = [];
            for (const container2 of containers){
                const [bestMatch, ...rest] = getWithAlternativeContainers(container2);
                bestContainers = append(bestContainers, bestMatch);
                alternativeContainers = addRange(alternativeContainers, rest);
            }
            return concatenate(bestContainers, alternativeContainers);
            function getWithAlternativeContainers(container2) {
                const additionalContainers = mapDefined(container2.declarations, fileSymbolIfFileSymbolExportEqualsContainer);
                const reexportContainers = enclosingDeclaration && getAlternativeContainingModules(symbol, enclosingDeclaration);
                const objectLiteralContainer = getVariableDeclarationOfObjectLiteral(container2, meaning);
                if (enclosingDeclaration && container2.flags & getQualifiedLeftMeaning(meaning) && getAccessibleSymbolChain(container2, enclosingDeclaration, 1920 /* Namespace */ , /*useOnlyExternalAliasing*/ false)) return append(concatenate(concatenate([
                    container2
                ], additionalContainers), reexportContainers), objectLiteralContainer);
                const firstVariableMatch = !(container2.flags & getQualifiedLeftMeaning(meaning)) && container2.flags & 788968 /* Type */  && getDeclaredTypeOfSymbol(container2).flags & 524288 /* Object */  && meaning === 111551 /* Value */  ? forEachSymbolTableInScope(enclosingDeclaration, (t)=>{
                    return forEachEntry(t, (s)=>{
                        if (s.flags & getQualifiedLeftMeaning(meaning) && getTypeOfSymbol(s) === getDeclaredTypeOfSymbol(container2)) return s;
                    });
                }) : void 0;
                let res = firstVariableMatch ? [
                    firstVariableMatch,
                    ...additionalContainers,
                    container2
                ] : [
                    ...additionalContainers,
                    container2
                ];
                res = append(res, objectLiteralContainer);
                res = addRange(res, reexportContainers);
                return res;
            }
            function fileSymbolIfFileSymbolExportEqualsContainer(d) {
                return container && getFileSymbolIfFileSymbolExportEqualsContainer(d, container);
            }
        }
        function getVariableDeclarationOfObjectLiteral(symbol, meaning) {
            const firstDecl = !!length(symbol.declarations) && first(symbol.declarations);
            if (meaning & 111551 /* Value */  && firstDecl && firstDecl.parent && isVariableDeclaration(firstDecl.parent)) {
                if (isObjectLiteralExpression(firstDecl) && firstDecl === firstDecl.parent.initializer || isTypeLiteralNode(firstDecl) && firstDecl === firstDecl.parent.type) return getSymbolOfDeclaration(firstDecl.parent);
            }
        }
        function getFileSymbolIfFileSymbolExportEqualsContainer(d, container) {
            const fileSymbol = getExternalModuleContainer(d);
            const exported = fileSymbol && fileSymbol.exports && fileSymbol.exports.get("export=" /* ExportEquals */ );
            return exported && getSymbolIfSameReference(exported, container) ? fileSymbol : void 0;
        }
        function getAliasForSymbolInContainer(container, symbol) {
            if (container === getParentOfSymbol(symbol)) return symbol;
            const exportEquals = container.exports && container.exports.get("export=" /* ExportEquals */ );
            if (exportEquals && getSymbolIfSameReference(exportEquals, symbol)) return container;
            const exports2 = getExportsOfSymbol(container);
            const quick = exports2.get(symbol.escapedName);
            if (quick && getSymbolIfSameReference(quick, symbol)) return quick;
            return forEachEntry(exports2, (exported)=>{
                if (getSymbolIfSameReference(exported, symbol)) return exported;
            });
        }
        function getSymbolIfSameReference(s1, s2) {
            if (getMergedSymbol(resolveSymbol(getMergedSymbol(s1))) === getMergedSymbol(resolveSymbol(getMergedSymbol(s2)))) return s1;
        }
        function getExportSymbolOfValueSymbolIfExported(symbol) {
            return getMergedSymbol(symbol && (symbol.flags & 1048576 /* ExportValue */ ) !== 0 && symbol.exportSymbol || symbol);
        }
        function symbolIsValue(symbol, includeTypeOnlyMembers) {
            return !!(symbol.flags & 111551 /* Value */  || symbol.flags & 2097152 /* Alias */  && getSymbolFlags(symbol, !includeTypeOnlyMembers) & 111551 /* Value */ );
        }
        function createType(flags) {
            var _a;
            const result = new Type29(checker, flags);
            typeCount++;
            result.id = typeCount;
            (_a = tracing) == null || _a.recordType(result);
            return result;
        }
        function createTypeWithSymbol(flags, symbol) {
            const result = createType(flags);
            result.symbol = symbol;
            return result;
        }
        function createOriginType(flags) {
            return new Type29(checker, flags);
        }
        function createIntrinsicType(kind, intrinsicName, objectFlags = 0 /* None */ , debugIntrinsicName) {
            checkIntrinsicName(intrinsicName, debugIntrinsicName);
            const type = createType(kind);
            type.intrinsicName = intrinsicName;
            type.debugIntrinsicName = debugIntrinsicName;
            type.objectFlags = objectFlags | 52953088 /* IsNeverIntersectionComputed */ ;
            return type;
        }
        function checkIntrinsicName(name, debug) {
            const key = `${name},${debug !== null && debug !== void 0 ? debug : ""}`;
            if (seenIntrinsicNames.has(key)) Debug.fail(`Duplicate intrinsic type name ${name}${debug ? ` (${debug})` : ""}; you may need to pass a name to createIntrinsicType.`);
            seenIntrinsicNames.add(key);
        }
        function createObjectType(objectFlags, symbol) {
            const type = createTypeWithSymbol(524288 /* Object */ , symbol);
            type.objectFlags = objectFlags;
            type.members = void 0;
            type.properties = void 0;
            type.callSignatures = void 0;
            type.constructSignatures = void 0;
            type.indexInfos = void 0;
            return type;
        }
        function createTypeofType() {
            return getUnionType(arrayFrom(typeofNEFacts.keys(), getStringLiteralType));
        }
        function createTypeParameter(symbol) {
            return createTypeWithSymbol(262144 /* TypeParameter */ , symbol);
        }
        function isReservedMemberName(name) {
            return name.charCodeAt(0) === 95 /* _ */  && name.charCodeAt(1) === 95 /* _ */  && name.charCodeAt(2) !== 95 /* _ */  && name.charCodeAt(2) !== 64 /* at */  && name.charCodeAt(2) !== 35 /* hash */ ;
        }
        function getNamedMembers(members) {
            let result;
            members.forEach((symbol, id)=>{
                if (isNamedMember(symbol, id)) (result || (result = [])).push(symbol);
            });
            return result || emptyArray;
        }
        function isNamedMember(member, escapedName) {
            return !isReservedMemberName(escapedName) && symbolIsValue(member);
        }
        function getNamedOrIndexSignatureMembers(members) {
            const result = getNamedMembers(members);
            const index = getIndexSymbolFromSymbolTable(members);
            return index ? concatenate(result, [
                index
            ]) : result;
        }
        function setStructuredTypeMembers(type, members, callSignatures, constructSignatures, indexInfos) {
            const resolved = type;
            resolved.members = members;
            resolved.properties = emptyArray;
            resolved.callSignatures = callSignatures;
            resolved.constructSignatures = constructSignatures;
            resolved.indexInfos = indexInfos;
            if (members !== emptySymbols) resolved.properties = getNamedMembers(members);
            return resolved;
        }
        function createAnonymousType(symbol, members, callSignatures, constructSignatures, indexInfos) {
            return setStructuredTypeMembers(createObjectType(16 /* Anonymous */ , symbol), members, callSignatures, constructSignatures, indexInfos);
        }
        function getResolvedTypeWithoutAbstractConstructSignatures(type) {
            if (type.constructSignatures.length === 0) return type;
            if (type.objectTypeWithoutAbstractConstructSignatures) return type.objectTypeWithoutAbstractConstructSignatures;
            const constructSignatures = filter(type.constructSignatures, (signature)=>!(signature.flags & 4 /* Abstract */ ));
            if (type.constructSignatures === constructSignatures) return type;
            const typeCopy = createAnonymousType(type.symbol, type.members, type.callSignatures, some(constructSignatures) ? constructSignatures : emptyArray, type.indexInfos);
            type.objectTypeWithoutAbstractConstructSignatures = typeCopy;
            typeCopy.objectTypeWithoutAbstractConstructSignatures = typeCopy;
            return typeCopy;
        }
        function forEachSymbolTableInScope(enclosingDeclaration, callback) {
            let result;
            for(let location = enclosingDeclaration; location; location = location.parent){
                if (canHaveLocals(location) && location.locals && !isGlobalSourceFile(location)) {
                    if (result = callback(location.locals, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ true, location)) return result;
                }
                switch(location.kind){
                    case 308 /* SourceFile */ :
                        if (!isExternalOrCommonJsModule(location)) break;
                    // falls through
                    case 268 /* ModuleDeclaration */ :
                        const sym = getSymbolOfDeclaration(location);
                        if (result = callback((sym == null ? void 0 : sym.exports) || emptySymbols, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ true, location)) return result;
                        break;
                    case 264 /* ClassDeclaration */ :
                    case 232 /* ClassExpression */ :
                    case 265 /* InterfaceDeclaration */ :
                        let table;
                        (getSymbolOfDeclaration(location).members || emptySymbols).forEach((memberSymbol, key)=>{
                            if (memberSymbol.flags & 788968 /* Assignment */ ) (table || (table = createSymbolTable())).set(key, memberSymbol);
                        });
                        if (table && (result = callback(table, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ false, location))) return result;
                        break;
                }
            }
            return callback(globals, /*ignoreQualification*/ void 0, /*isLocalNameLookup*/ true);
        }
        function getQualifiedLeftMeaning(rightMeaning) {
            return rightMeaning === 111551 /* Value */  ? 111551 /* Value */  : 1920 /* Namespace */ ;
        }
        function getAccessibleSymbolChain(symbol, enclosingDeclaration, meaning, useOnlyExternalAliasing, visitedSymbolTablesMap = /* @__PURE__ */ new Map()) {
            if (!(symbol && !isPropertyOrMethodDeclarationSymbol(symbol))) return void 0;
            const links = getSymbolLinks(symbol);
            const cache = links.accessibleChainCache || (links.accessibleChainCache = /* @__PURE__ */ new Map());
            const firstRelevantLocation = forEachSymbolTableInScope(enclosingDeclaration, (_, __, ___, node)=>node);
            const key = `${useOnlyExternalAliasing ? 0 : 1}|${firstRelevantLocation ? getNodeId(firstRelevantLocation) : 0}|${meaning}`;
            if (cache.has(key)) return cache.get(key);
            const id = getSymbolId(symbol);
            let visitedSymbolTables = visitedSymbolTablesMap.get(id);
            if (!visitedSymbolTables) visitedSymbolTablesMap.set(id, visitedSymbolTables = []);
            const result = forEachSymbolTableInScope(enclosingDeclaration, getAccessibleSymbolChainFromSymbolTable);
            cache.set(key, result);
            return result;
            function getAccessibleSymbolChainFromSymbolTable(symbols, ignoreQualification, isLocalNameLookup) {
                if (!pushIfUnique(visitedSymbolTables, symbols)) return void 0;
                const result2 = trySymbolTable(symbols, ignoreQualification, isLocalNameLookup);
                visitedSymbolTables.pop();
                return result2;
            }
            function canQualifySymbol(symbolFromSymbolTable, meaning2) {
                return !needsQualification(symbolFromSymbolTable, enclosingDeclaration, meaning2) || // If symbol needs qualification, make sure that parent is accessible, if it is then this symbol is accessible too
                !!getAccessibleSymbolChain(symbolFromSymbolTable.parent, enclosingDeclaration, getQualifiedLeftMeaning(meaning2), useOnlyExternalAliasing, visitedSymbolTablesMap);
            }
            function isAccessible(symbolFromSymbolTable, resolvedAliasSymbol, ignoreQualification) {
                return (symbol === (resolvedAliasSymbol || symbolFromSymbolTable) || getMergedSymbol(symbol) === getMergedSymbol(resolvedAliasSymbol || symbolFromSymbolTable)) && // if the symbolFromSymbolTable is not external module (it could be if it was determined as ambient external module and would be in globals table)
                // and if symbolFromSymbolTable or alias resolution matches the symbol,
                // check the symbol can be qualified, it is only then this symbol is accessible
                !some(symbolFromSymbolTable.declarations, hasNonGlobalAugmentationExternalModuleSymbol) && (ignoreQualification || canQualifySymbol(getMergedSymbol(symbolFromSymbolTable), meaning));
            }
            function trySymbolTable(symbols, ignoreQualification, isLocalNameLookup) {
                if (isAccessible(symbols.get(symbol.escapedName), /*resolvedAliasSymbol*/ void 0, ignoreQualification)) return [
                    symbol
                ];
                const result2 = forEachEntry(symbols, (symbolFromSymbolTable)=>{
                    if (symbolFromSymbolTable.flags & 2097152 /* Alias */  && symbolFromSymbolTable.escapedName !== "export=" /* ExportEquals */  && symbolFromSymbolTable.escapedName !== "default" /* Default */  && !(isUMDExportSymbol(symbolFromSymbolTable) && enclosingDeclaration && isExternalModule(getSourceFileOfNode(enclosingDeclaration))) && (!useOnlyExternalAliasing || some(symbolFromSymbolTable.declarations, isExternalModuleImportEqualsDeclaration)) && (isLocalNameLookup ? !some(symbolFromSymbolTable.declarations, isNamespaceReexportDeclaration) : true) && (ignoreQualification || !getDeclarationOfKind(symbolFromSymbolTable, 282 /* ExportSpecifier */ ))) {
                        const resolvedImportedSymbol = resolveAlias(symbolFromSymbolTable);
                        const candidate = getCandidateListForSymbol(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification);
                        if (candidate) return candidate;
                    }
                    if (symbolFromSymbolTable.escapedName === symbol.escapedName && symbolFromSymbolTable.exportSymbol) {
                        if (isAccessible(getMergedSymbol(symbolFromSymbolTable.exportSymbol), /*resolvedAliasSymbol*/ void 0, ignoreQualification)) return [
                            symbol
                        ];
                    }
                });
                return result2 || (symbols === globals ? getCandidateListForSymbol(globalThisSymbol, globalThisSymbol, ignoreQualification) : void 0);
            }
            function getCandidateListForSymbol(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification) {
                if (isAccessible(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification)) return [
                    symbolFromSymbolTable
                ];
                const candidateTable = getExportsOfSymbol(resolvedImportedSymbol);
                const accessibleSymbolsFromExports = candidateTable && getAccessibleSymbolChainFromSymbolTable(candidateTable, /*ignoreQualification*/ true);
                if (accessibleSymbolsFromExports && canQualifySymbol(symbolFromSymbolTable, getQualifiedLeftMeaning(meaning))) return [
                    symbolFromSymbolTable
                ].concat(accessibleSymbolsFromExports);
            }
        }
        function needsQualification(symbol, enclosingDeclaration, meaning) {
            let qualify = false;
            forEachSymbolTableInScope(enclosingDeclaration, (symbolTable)=>{
                let symbolFromSymbolTable = getMergedSymbol(symbolTable.get(symbol.escapedName));
                if (!symbolFromSymbolTable) return false;
                if (symbolFromSymbolTable === symbol) return true;
                const shouldResolveAlias = symbolFromSymbolTable.flags & 2097152 /* Alias */  && !getDeclarationOfKind(symbolFromSymbolTable, 282 /* ExportSpecifier */ );
                symbolFromSymbolTable = shouldResolveAlias ? resolveAlias(symbolFromSymbolTable) : symbolFromSymbolTable;
                const flags = shouldResolveAlias ? getSymbolFlags(symbolFromSymbolTable) : symbolFromSymbolTable.flags;
                if (flags & meaning) {
                    qualify = true;
                    return true;
                }
                return false;
            });
            return qualify;
        }
        function isPropertyOrMethodDeclarationSymbol(symbol) {
            if (symbol.declarations && symbol.declarations.length) {
                for (const declaration of symbol.declarations)switch(declaration.kind){
                    case 173 /* PropertyDeclaration */ :
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        continue;
                    default:
                        return false;
                }
                return true;
            }
            return false;
        }
        function isTypeSymbolAccessible(typeSymbol, enclosingDeclaration) {
            const access = isSymbolAccessibleWorker(typeSymbol, enclosingDeclaration, 788968 /* Type */ , /*shouldComputeAliasesToMakeVisible*/ false, /*allowModules*/ true);
            return access.accessibility === 0 /* Accessible */ ;
        }
        function isValueSymbolAccessible(typeSymbol, enclosingDeclaration) {
            const access = isSymbolAccessibleWorker(typeSymbol, enclosingDeclaration, 111551 /* Value */ , /*shouldComputeAliasesToMakeVisible*/ false, /*allowModules*/ true);
            return access.accessibility === 0 /* Accessible */ ;
        }
        function isSymbolAccessibleByFlags(typeSymbol, enclosingDeclaration, flags) {
            const access = isSymbolAccessibleWorker(typeSymbol, enclosingDeclaration, flags, /*shouldComputeAliasesToMakeVisible*/ false, /*allowModules*/ false);
            return access.accessibility === 0 /* Accessible */ ;
        }
        function isAnySymbolAccessible(symbols, enclosingDeclaration, initialSymbol, meaning, shouldComputeAliasesToMakeVisible, allowModules) {
            if (!length(symbols)) return;
            let hadAccessibleChain;
            let earlyModuleBail = false;
            for (const symbol of symbols){
                const accessibleSymbolChain = getAccessibleSymbolChain(symbol, enclosingDeclaration, meaning, /*useOnlyExternalAliasing*/ false);
                if (accessibleSymbolChain) {
                    hadAccessibleChain = symbol;
                    const hasAccessibleDeclarations = hasVisibleDeclarations(accessibleSymbolChain[0], shouldComputeAliasesToMakeVisible);
                    if (hasAccessibleDeclarations) return hasAccessibleDeclarations;
                }
                if (allowModules) {
                    if (some(symbol.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) {
                        if (shouldComputeAliasesToMakeVisible) {
                            earlyModuleBail = true;
                            continue;
                        }
                        return {
                            accessibility: 0 /* Accessible */ 
                        };
                    }
                }
                const containers = getContainersOfSymbol(symbol, enclosingDeclaration, meaning);
                const parentResult = isAnySymbolAccessible(containers, enclosingDeclaration, initialSymbol, initialSymbol === symbol ? getQualifiedLeftMeaning(meaning) : meaning, shouldComputeAliasesToMakeVisible, allowModules);
                if (parentResult) return parentResult;
            }
            if (earlyModuleBail) return {
                accessibility: 0 /* Accessible */ 
            };
            if (hadAccessibleChain) return {
                accessibility: 1 /* NotAccessible */ ,
                errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
                errorModuleName: hadAccessibleChain !== initialSymbol ? symbolToString(hadAccessibleChain, enclosingDeclaration, 1920 /* Namespace */ ) : void 0
            };
        }
        function isSymbolAccessible(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible) {
            return isSymbolAccessibleWorker(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible, /*allowModules*/ true);
        }
        function isSymbolAccessibleWorker(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible, allowModules) {
            if (symbol && enclosingDeclaration) {
                const result = isAnySymbolAccessible([
                    symbol
                ], enclosingDeclaration, symbol, meaning, shouldComputeAliasesToMakeVisible, allowModules);
                if (result) return result;
                const symbolExternalModule = forEach(symbol.declarations, getExternalModuleContainer);
                if (symbolExternalModule) {
                    const enclosingExternalModule = getExternalModuleContainer(enclosingDeclaration);
                    if (symbolExternalModule !== enclosingExternalModule) return {
                        accessibility: 2 /* CannotBeNamed */ ,
                        errorSymbolName: symbolToString(symbol, enclosingDeclaration, meaning),
                        errorModuleName: symbolToString(symbolExternalModule),
                        errorNode: isInJSFile(enclosingDeclaration) ? enclosingDeclaration : void 0
                    };
                }
                return {
                    accessibility: 1 /* NotAccessible */ ,
                    errorSymbolName: symbolToString(symbol, enclosingDeclaration, meaning)
                };
            }
            return {
                accessibility: 0 /* Accessible */ 
            };
        }
        function getExternalModuleContainer(declaration) {
            const node = findAncestor(declaration, hasExternalModuleSymbol);
            return node && getSymbolOfDeclaration(node);
        }
        function hasExternalModuleSymbol(declaration) {
            return isAmbientModule(declaration) || declaration.kind === 308 /* SourceFile */  && isExternalOrCommonJsModule(declaration);
        }
        function hasNonGlobalAugmentationExternalModuleSymbol(declaration) {
            return isModuleWithStringLiteralName(declaration) || declaration.kind === 308 /* SourceFile */  && isExternalOrCommonJsModule(declaration);
        }
        function hasVisibleDeclarations(symbol, shouldComputeAliasToMakeVisible) {
            let aliasesToMakeVisible;
            if (!every(filter(symbol.declarations, (d)=>d.kind !== 80 /* Identifier */ ), getIsDeclarationVisible)) return void 0;
            return {
                accessibility: 0 /* Accessible */ ,
                aliasesToMakeVisible
            };
            function getIsDeclarationVisible(declaration) {
                var _a, _b;
                if (!isDeclarationVisible(declaration)) {
                    const anyImportSyntax = getAnyImportSyntax(declaration);
                    if (anyImportSyntax && !hasSyntacticModifier(anyImportSyntax, 32 /* Export */ ) && // import clause without export
                    isDeclarationVisible(anyImportSyntax.parent)) return addVisibleAlias(declaration, anyImportSyntax);
                    else if (isVariableDeclaration(declaration) && isVariableStatement(declaration.parent.parent) && !hasSyntacticModifier(declaration.parent.parent, 32 /* Export */ ) && // unexported variable statement
                    isDeclarationVisible(declaration.parent.parent.parent)) return addVisibleAlias(declaration, declaration.parent.parent);
                    else if (isLateVisibilityPaintedStatement(declaration) && !hasSyntacticModifier(declaration, 32 /* Export */ ) && isDeclarationVisible(declaration.parent)) return addVisibleAlias(declaration, declaration);
                    else if (isBindingElement(declaration)) {
                        if (symbol.flags & 2097152 /* Alias */  && isInJSFile(declaration) && ((_a = declaration.parent) == null ? void 0 : _a.parent) && isVariableDeclaration(declaration.parent.parent) && ((_b = declaration.parent.parent.parent) == null ? void 0 : _b.parent) && isVariableStatement(declaration.parent.parent.parent.parent) && !hasSyntacticModifier(declaration.parent.parent.parent.parent, 32 /* Export */ ) && declaration.parent.parent.parent.parent.parent && isDeclarationVisible(declaration.parent.parent.parent.parent.parent)) return addVisibleAlias(declaration, declaration.parent.parent.parent.parent);
                        else if (symbol.flags & 2 /* BlockScopedVariable */ ) {
                            const rootDeclaration = walkUpBindingElementsAndPatterns(declaration);
                            if (rootDeclaration.kind === 170 /* Parameter */ ) return false;
                            const variableStatement = rootDeclaration.parent.parent;
                            if (variableStatement.kind !== 244 /* VariableStatement */ ) return false;
                            if (hasSyntacticModifier(variableStatement, 32 /* Export */ )) return true;
                            if (!isDeclarationVisible(variableStatement.parent)) return false;
                            return addVisibleAlias(declaration, variableStatement);
                        }
                    }
                    return false;
                }
                return true;
            }
            function addVisibleAlias(declaration, aliasingStatement) {
                if (shouldComputeAliasToMakeVisible) {
                    getNodeLinks(declaration).isVisible = true;
                    aliasesToMakeVisible = appendIfUnique(aliasesToMakeVisible, aliasingStatement);
                }
                return true;
            }
        }
        function getMeaningOfEntityNameReference(entityName) {
            let meaning;
            if (entityName.parent.kind === 187 /* TypeQuery */  || entityName.parent.kind === 234 /* ExpressionWithTypeArguments */  && !isPartOfTypeNode(entityName.parent) || entityName.parent.kind === 168 /* ComputedPropertyName */  || entityName.parent.kind === 183 /* TypePredicate */  && entityName.parent.parameterName === entityName) meaning = 1160127 /* ExportValue */ ;
            else if (entityName.kind === 167 /* QualifiedName */  || entityName.kind === 212 /* PropertyAccessExpression */  || entityName.parent.kind === 272 /* ImportEqualsDeclaration */  || entityName.parent.kind === 167 /* QualifiedName */  && entityName.parent.left === entityName || entityName.parent.kind === 212 /* PropertyAccessExpression */  && entityName.parent.expression === entityName || entityName.parent.kind === 213 /* ElementAccessExpression */  && entityName.parent.expression === entityName) meaning = 1920 /* Namespace */ ;
            else meaning = 788968 /* Type */ ;
            return meaning;
        }
        function isEntityNameVisible(entityName, enclosingDeclaration, shouldComputeAliasToMakeVisible = true) {
            const meaning = getMeaningOfEntityNameReference(entityName);
            const firstIdentifier = getFirstIdentifier(entityName);
            const symbol = resolveName(enclosingDeclaration, firstIdentifier.escapedText, meaning, /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
            if (symbol && symbol.flags & 262144 /* TypeParameter */  && meaning & 788968 /* Type */ ) return {
                accessibility: 0 /* Accessible */ 
            };
            if (!symbol && isThisIdentifier(firstIdentifier) && isSymbolAccessible(getSymbolOfDeclaration(getThisContainer(firstIdentifier, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false)), firstIdentifier, meaning, /*shouldComputeAliasesToMakeVisible*/ false).accessibility === 0 /* Accessible */ ) return {
                accessibility: 0 /* Accessible */ 
            };
            if (!symbol) return {
                accessibility: 3 /* NotResolved */ ,
                errorSymbolName: getTextOfNode(firstIdentifier),
                errorNode: firstIdentifier
            };
            return hasVisibleDeclarations(symbol, shouldComputeAliasToMakeVisible) || {
                accessibility: 1 /* NotAccessible */ ,
                errorSymbolName: getTextOfNode(firstIdentifier),
                errorNode: firstIdentifier
            };
        }
        function symbolToString(symbol, enclosingDeclaration, meaning, flags = 4 /* AllowAnyNodeKind */ , writer) {
            let nodeFlags = 70221824 /* IgnoreErrors */ ;
            let internalNodeFlags = 0 /* None */ ;
            if (flags & 2 /* UseOnlyExternalAliasing */ ) nodeFlags |= 128 /* UseOnlyExternalAliasing */ ;
            if (flags & 1 /* WriteTypeParametersOrArguments */ ) nodeFlags |= 512 /* WriteTypeParametersInQualifiedName */ ;
            if (flags & 8 /* UseAliasDefinedOutsideCurrentScope */ ) nodeFlags |= 16384 /* UseAliasDefinedOutsideCurrentScope */ ;
            if (flags & 32 /* DoNotIncludeSymbolChain */ ) internalNodeFlags |= 4 /* DoNotIncludeSymbolChain */ ;
            if (flags & 16 /* WriteComputedProps */ ) internalNodeFlags |= 1 /* WriteComputedProps */ ;
            const builder = flags & 4 /* AllowAnyNodeKind */  ? nodeBuilder.symbolToNode : nodeBuilder.symbolToEntityName;
            return writer ? symbolToStringWorker(writer).getText() : usingSingleLineStringWriter(symbolToStringWorker);
            function symbolToStringWorker(writer2) {
                const entity = builder(symbol, meaning, enclosingDeclaration, nodeFlags, internalNodeFlags);
                const printer = (enclosingDeclaration == null ? void 0 : enclosingDeclaration.kind) === 308 /* SourceFile */  ? createPrinterWithRemoveCommentsNeverAsciiEscape() : createPrinterWithRemoveComments();
                const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
                printer.writeNode(4 /* Unspecified */ , entity, /*sourceFile*/ sourceFile, writer2);
                return writer2;
            }
        }
        function signatureToString(signature, enclosingDeclaration, flags = 0 /* None */ , kind, writer, maximumLength, verbosityLevel, out) {
            return writer ? signatureToStringWorker(writer).getText() : usingSingleLineStringWriter(signatureToStringWorker);
            function signatureToStringWorker(writer2) {
                let sigOutput;
                if (flags & 262144 /* WriteArrowStyleSignature */ ) sigOutput = kind === 1 /* Construct */  ? 186 /* ConstructorType */  : 185 /* FunctionType */ ;
                else sigOutput = kind === 1 /* Construct */  ? 181 /* ConstructSignature */  : 180 /* CallSignature */ ;
                const sig = nodeBuilder.signatureToSignatureDeclaration(signature, sigOutput, enclosingDeclaration, toNodeBuilderFlags(flags) | 70222336 /* WriteTypeParametersInQualifiedName */ , /*internalFlags*/ void 0, /*tracker*/ void 0, maximumLength, verbosityLevel, out);
                const printer = createPrinterWithRemoveCommentsOmitTrailingSemicolon();
                const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
                printer.writeNode(4 /* Unspecified */ , sig, /*sourceFile*/ sourceFile, getTrailingSemicolonDeferringWriter(writer2));
                return writer2;
            }
        }
        function typeToString(type, enclosingDeclaration, flags = 1064960 /* UseAliasDefinedOutsideCurrentScope */ , writer = createTextWriter(""), maximumLength, verbosityLevel, out) {
            const noTruncation = !maximumLength && compilerOptions.noErrorTruncation || flags & 1 /* NoTruncation */ ;
            const typeNode = nodeBuilder.typeToTypeNode(type, enclosingDeclaration, toNodeBuilderFlags(flags) | 70221824 /* IgnoreErrors */  | (noTruncation ? 1 /* NoTruncation */  : 0), /*internalFlags*/ void 0, /*tracker*/ void 0, maximumLength, verbosityLevel, out);
            if (typeNode === void 0) return Debug.fail("should always get typenode");
            const printer = type !== unresolvedType ? createPrinterWithRemoveComments() : createPrinterWithDefaults();
            const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
            printer.writeNode(4 /* Unspecified */ , typeNode, /*sourceFile*/ sourceFile, writer);
            const result = writer.getText();
            const maxLength2 = maximumLength || (noTruncation ? noTruncationMaximumTruncationLength * 2 : defaultMaximumTruncationLength * 2);
            if (maxLength2 && result && result.length >= maxLength2) return result.substr(0, maxLength2 - 3) + "...";
            return result;
        }
        function getTypeNamesForErrorDisplay(left, right) {
            let leftStr = symbolValueDeclarationIsContextSensitive(left.symbol) ? typeToString(left, left.symbol.valueDeclaration) : typeToString(left);
            let rightStr = symbolValueDeclarationIsContextSensitive(right.symbol) ? typeToString(right, right.symbol.valueDeclaration) : typeToString(right);
            if (leftStr === rightStr) {
                leftStr = getTypeNameForErrorDisplay(left);
                rightStr = getTypeNameForErrorDisplay(right);
            }
            return [
                leftStr,
                rightStr
            ];
        }
        function getTypeNameForErrorDisplay(type) {
            return typeToString(type, /*enclosingDeclaration*/ void 0, 64 /* UseFullyQualifiedType */ );
        }
        function symbolValueDeclarationIsContextSensitive(symbol) {
            return symbol && !!symbol.valueDeclaration && isExpression(symbol.valueDeclaration) && !isContextSensitive(symbol.valueDeclaration);
        }
        function toNodeBuilderFlags(flags = 0 /* None */ ) {
            return flags & 848330095 /* NodeBuilderFlagsMask */ ;
        }
        function isClassInstanceSide(type) {
            return !!type.symbol && !!(type.symbol.flags & 32 /* Class */ ) && (type === getDeclaredTypeOfClassOrInterface(type.symbol) || !!(type.flags & 524288 /* Object */ ) && !!(getObjectFlags(type) & 16777216 /* IsClassInstanceClone */ ));
        }
        function getTypeFromTypeNodeWithoutContext(node) {
            return getTypeFromTypeNode(node);
        }
        function createNodeBuilder() {
            const syntacticBuilderResolver = {
                evaluateEntityNameExpression,
                isExpandoFunctionDeclaration,
                hasLateBindableName,
                shouldRemoveDeclaration (context, node) {
                    return !(context.internalFlags & 8 /* AllowUnresolvedNames */  && isEntityNameExpression(node.name.expression) && checkComputedPropertyName(node.name).flags & 1 /* Any */ );
                },
                createRecoveryBoundary (context) {
                    return createRecoveryBoundary(context);
                },
                isDefinitelyReferenceToGlobalSymbolObject,
                getAllAccessorDeclarations: getAllAccessorDeclarationsForDeclaration,
                requiresAddingImplicitUndefined (declaration, symbol, enclosingDeclaration) {
                    var _a;
                    switch(declaration.kind){
                        case 173 /* PropertyDeclaration */ :
                        case 172 /* PropertySignature */ :
                        case 349 /* JSDocPropertyTag */ :
                            symbol !== null && symbol !== void 0 ? symbol : symbol = getSymbolOfDeclaration(declaration);
                            const type = getTypeOfSymbol(symbol);
                            return !!(symbol.flags & 4 /* Property */  && symbol.flags & 16777216 /* Optional */  && isOptionalDeclaration(declaration) && ((_a = symbol.links) == null ? void 0 : _a.mappedType) && containsNonMissingUndefinedType(type));
                        case 170 /* Parameter */ :
                        case 342 /* JSDocParameterTag */ :
                            return requiresAddingImplicitUndefined(declaration, enclosingDeclaration);
                        default:
                            Debug.assertNever(declaration);
                    }
                },
                isOptionalParameter,
                isUndefinedIdentifierExpression (node) {
                    return getSymbolAtLocation(node) === undefinedSymbol;
                },
                isEntityNameVisible (context, entityName, shouldComputeAliasToMakeVisible) {
                    return isEntityNameVisible(entityName, context.enclosingDeclaration, shouldComputeAliasToMakeVisible);
                },
                serializeExistingTypeNode (context, typeNode, addUndefined) {
                    return serializeExistingTypeNode(context, typeNode, !!addUndefined);
                },
                serializeReturnTypeForSignature (syntacticContext, signatureDeclaration, symbol) {
                    const context = syntacticContext;
                    const signature = getSignatureFromDeclaration(signatureDeclaration);
                    symbol !== null && symbol !== void 0 ? symbol : symbol = getSymbolOfDeclaration(signatureDeclaration);
                    var _context_enclosingSymbolTypes_get;
                    const returnType = (_context_enclosingSymbolTypes_get = context.enclosingSymbolTypes.get(getSymbolId(symbol))) !== null && _context_enclosingSymbolTypes_get !== void 0 ? _context_enclosingSymbolTypes_get : instantiateType(getReturnTypeOfSignature(signature), context.mapper);
                    return serializeInferredReturnTypeForSignature(context, signature, returnType);
                },
                serializeTypeOfExpression (syntacticContext, expr) {
                    const context = syntacticContext;
                    const type = instantiateType(getWidenedType(getRegularTypeOfExpression(expr)), context.mapper);
                    return typeToTypeNodeHelper(type, context);
                },
                serializeTypeOfDeclaration (syntacticContext, declaration, symbol) {
                    var _a;
                    const context = syntacticContext;
                    symbol !== null && symbol !== void 0 ? symbol : symbol = getSymbolOfDeclaration(declaration);
                    let type = (_a = context.enclosingSymbolTypes) == null ? void 0 : _a.get(getSymbolId(symbol));
                    if (type === void 0) type = symbol.flags & 98304 /* Accessor */  && declaration.kind === 179 /* SetAccessor */  ? instantiateType(getWriteTypeOfSymbol(symbol), context.mapper) : symbol && !(symbol.flags & 133120 /* Signature */ ) ? instantiateType(getWidenedLiteralType(getTypeOfSymbol(symbol)), context.mapper) : errorType;
                    const addUndefinedForParameter = declaration && (isParameter(declaration) || isJSDocParameterTag(declaration)) && requiresAddingImplicitUndefined(declaration, context.enclosingDeclaration);
                    if (addUndefinedForParameter) type = getOptionalType(type);
                    return serializeInferredTypeForDeclaration(symbol, context, type);
                },
                serializeNameOfParameter (context, parameter) {
                    return parameterToParameterDeclarationName(getSymbolOfDeclaration(parameter), parameter, context);
                },
                serializeEntityName (syntacticContext, node) {
                    const context = syntacticContext;
                    const symbol = getSymbolAtLocation(node, /*ignoreErrors*/ true);
                    if (!symbol) return void 0;
                    if (!isValueSymbolAccessible(symbol, context.enclosingDeclaration)) return void 0;
                    return symbolToExpression(symbol, context, 1160127 /* ExportValue */ );
                },
                serializeTypeName (context, node, isTypeOf, typeArguments) {
                    return serializeTypeName(context, node, isTypeOf, typeArguments);
                },
                getJsDocPropertyOverride (syntacticContext, jsDocTypeLiteral, jsDocProperty) {
                    const context = syntacticContext;
                    const name = isIdentifier(jsDocProperty.name) ? jsDocProperty.name : jsDocProperty.name.right;
                    const typeViaParent = getTypeOfPropertyOfType(getTypeFromTypeNode2(context, jsDocTypeLiteral), name.escapedText);
                    const overrideTypeNode = typeViaParent && jsDocProperty.typeExpression && getTypeFromTypeNode2(context, jsDocProperty.typeExpression.type) !== typeViaParent ? typeToTypeNodeHelper(typeViaParent, context) : void 0;
                    return overrideTypeNode;
                },
                enterNewScope (context, node) {
                    if (isFunctionLike(node) || isJSDocSignature(node)) {
                        const signature = getSignatureFromDeclaration(node);
                        return enterNewScope(context, node, signature.parameters, signature.typeParameters);
                    } else {
                        const typeParameters = isConditionalTypeNode(node) ? getInferTypeParameters(node) : [
                            getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node.typeParameter))
                        ];
                        return enterNewScope(context, node, /*expandedParams*/ void 0, typeParameters);
                    }
                },
                markNodeReuse (context, range, location) {
                    return setTextRange2(context, range, location);
                },
                trackExistingEntityName (context, node) {
                    return trackExistingEntityName(node, context);
                },
                trackComputedName (context, accessExpression) {
                    trackComputedName(accessExpression, context.enclosingDeclaration, context);
                },
                getModuleSpecifierOverride (syntacticContext, parent2, lit) {
                    const context = syntacticContext;
                    if (context.bundled || context.enclosingFile !== getSourceFileOfNode(lit)) {
                        let name = lit.text;
                        const originalName = name;
                        const nodeSymbol = getNodeLinks(parent2).resolvedSymbol;
                        const meaning = parent2.isTypeOf ? 111551 /* Value */  : 788968 /* Type */ ;
                        const parentSymbol = nodeSymbol && isSymbolAccessible(nodeSymbol, context.enclosingDeclaration, meaning, /*shouldComputeAliasesToMakeVisible*/ false).accessibility === 0 /* Accessible */  && lookupSymbolChain(nodeSymbol, context, meaning, /*yieldModuleSymbol*/ true)[0];
                        if (parentSymbol && isExternalModuleSymbol(parentSymbol)) name = getSpecifierForModuleSymbol(parentSymbol, context);
                        else {
                            const targetFile = getExternalModuleFileFromDeclaration(parent2);
                            if (targetFile) name = getSpecifierForModuleSymbol(targetFile.symbol, context);
                        }
                        if (name.includes("/node_modules/")) {
                            context.encounteredError = true;
                            if (context.tracker.reportLikelyUnsafeImportRequiredError) context.tracker.reportLikelyUnsafeImportRequiredError(name);
                        }
                        if (name !== originalName) return name;
                    }
                },
                canReuseTypeNode (context, typeNode) {
                    return canReuseTypeNode(context, typeNode);
                },
                canReuseTypeNodeAnnotation (syntacticContext, node, existing, symbol, requiresAddingUndefined) {
                    var _a;
                    const context = syntacticContext;
                    if (context.enclosingDeclaration === void 0) return false;
                    symbol !== null && symbol !== void 0 ? symbol : symbol = getSymbolOfDeclaration(node);
                    let type = (_a = context.enclosingSymbolTypes) == null ? void 0 : _a.get(getSymbolId(symbol));
                    if (type === void 0) {
                        if (symbol.flags & 98304 /* Accessor */ ) type = node.kind === 179 /* SetAccessor */  ? getWriteTypeOfSymbol(symbol) : getTypeOfAccessors(symbol);
                        else if (isValueSignatureDeclaration(node)) type = getReturnTypeOfSignature(getSignatureFromDeclaration(node));
                        else type = getTypeOfSymbol(symbol);
                    }
                    let annotationType = getTypeFromTypeNodeWithoutContext(existing);
                    if (isErrorType(annotationType)) return true;
                    if (requiresAddingUndefined && annotationType) annotationType = addOptionality(annotationType, !isParameter(node));
                    return !!annotationType && typeNodeIsEquivalentToType(node, type, annotationType) && existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(existing, type);
                }
            };
            return {
                syntacticBuilderResolver,
                typeToTypeNode: (type, enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, out)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, (context)=>typeToTypeNodeHelper(type, context), out),
                typePredicateToTypePredicateNode: (typePredicate, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>typePredicateToTypePredicateNodeHelper(typePredicate, context)),
                serializeTypeForDeclaration: (declaration, symbol, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>syntacticNodeBuilder.serializeTypeOfDeclaration(declaration, symbol, context)),
                serializeReturnTypeForSignature: (signature, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>syntacticNodeBuilder.serializeReturnTypeForSignature(signature, getSymbolOfDeclaration(signature), context)),
                serializeTypeForExpression: (expr, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>syntacticNodeBuilder.serializeTypeOfExpression(expr, context)),
                indexInfoToIndexSignatureDeclaration: (indexInfo, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>indexInfoToIndexSignatureDeclarationHelper(indexInfo, context, /*typeNode*/ void 0)),
                signatureToSignatureDeclaration: (signature, kind, enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, out)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, (context)=>signatureToSignatureDeclarationHelper(signature, kind, context), out),
                symbolToEntityName: (symbol, meaning, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>symbolToName(symbol, context, meaning, /*expectsIdentifier*/ false)),
                symbolToExpression: (symbol, meaning, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>symbolToExpression(symbol, context, meaning)),
                symbolToTypeParameterDeclarations: (symbol, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>typeParametersToTypeParameterDeclarations(symbol, context)),
                symbolToParameterDeclaration: (symbol, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>symbolToParameterDeclaration(symbol, context)),
                typeParameterToDeclaration: (parameter, enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, out)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, (context)=>typeParameterToDeclaration(parameter, context), out),
                symbolTableToDeclarationStatements: (symbolTable, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>symbolTableToDeclarationStatements(symbolTable, context)),
                symbolToNode: (symbol, meaning, enclosingDeclaration, flags, internalFlags, tracker)=>withContext2(enclosingDeclaration, flags, internalFlags, tracker, /*maximumLength*/ void 0, /*verbosityLevel*/ void 0, (context)=>symbolToNode(symbol, context, meaning)),
                symbolToDeclarations
            };
            function getTypeFromTypeNode2(context, node, noMappedTypes) {
                const type = getTypeFromTypeNodeWithoutContext(node);
                if (!context.mapper) return type;
                const mappedType = instantiateType(type, context.mapper);
                return noMappedTypes && mappedType !== type ? void 0 : mappedType;
            }
            function setTextRange2(context, range, location) {
                if (!nodeIsSynthesized(range) || !(range.flags & 16 /* Synthesized */ ) || !context.enclosingFile || context.enclosingFile !== getSourceFileOfNode(getOriginalNode(range))) range = factory.cloneNode(range);
                if (range === location) return range;
                if (!location) return range;
                let original = range.original;
                while(original && original !== location)original = original.original;
                if (!original) setOriginalNode(range, location);
                if (context.enclosingFile && context.enclosingFile === getSourceFileOfNode(getOriginalNode(location))) return setTextRange(range, location);
                return range;
            }
            function symbolToNode(symbol, context, meaning) {
                if (context.internalFlags & 1 /* WriteComputedProps */ ) {
                    if (symbol.valueDeclaration) {
                        const name = getNameOfDeclaration(symbol.valueDeclaration);
                        if (name && isComputedPropertyName(name)) return name;
                    }
                    const nameType = getSymbolLinks(symbol).nameType;
                    if (nameType && nameType.flags & 9216 /* UniqueESSymbol */ ) {
                        context.enclosingDeclaration = nameType.symbol.valueDeclaration;
                        return factory.createComputedPropertyName(symbolToExpression(nameType.symbol, context, meaning));
                    }
                }
                return symbolToExpression(symbol, context, meaning);
            }
            function symbolToDeclarations(symbol, meaning, flags, maximumLength, verbosityLevel, out) {
                const nodes = withContext2(/*enclosingDeclaration*/ void 0, flags, /*internalFlags*/ void 0, /*tracker*/ void 0, maximumLength, verbosityLevel, (context)=>symbolToDeclarationsWorker(symbol, context), out);
                return mapDefined(nodes, (node)=>{
                    switch(node.kind){
                        case 264 /* ClassDeclaration */ :
                            return simplifyClassDeclaration(node, symbol);
                        case 267 /* EnumDeclaration */ :
                            return simplifyModifiers(node, isEnumDeclaration, symbol);
                        case 265 /* InterfaceDeclaration */ :
                            return simplifyInterfaceDeclaration(node, symbol, meaning);
                        case 268 /* ModuleDeclaration */ :
                            return simplifyModifiers(node, isModuleDeclaration, symbol);
                        default:
                            return void 0;
                    }
                });
            }
            function simplifyClassDeclaration(classDecl, symbol) {
                const classDeclarations = filter(symbol.declarations, isClassLike);
                const originalClassDecl = classDeclarations && classDeclarations.length > 0 ? classDeclarations[0] : classDecl;
                const modifiers = getEffectiveModifierFlags(originalClassDecl) & -161;
                const isAnonymous = isClassExpression(originalClassDecl);
                if (isAnonymous) classDecl = factory.updateClassDeclaration(classDecl, classDecl.modifiers, /*name*/ void 0, classDecl.typeParameters, classDecl.heritageClauses, classDecl.members);
                return factory.replaceModifiers(classDecl, modifiers);
            }
            function simplifyModifiers(newDecl, isDeclKind, symbol) {
                const decls = filter(symbol.declarations, isDeclKind);
                const declWithModifiers = decls && decls.length > 0 ? decls[0] : newDecl;
                const modifiers = getEffectiveModifierFlags(declWithModifiers) & -161;
                return factory.replaceModifiers(newDecl, modifiers);
            }
            function simplifyInterfaceDeclaration(interfaceDecl, symbol, meaning) {
                if (!(meaning & 64 /* Interface */ )) return void 0;
                return simplifyModifiers(interfaceDecl, isInterfaceDeclaration, symbol);
            }
            function symbolToDeclarationsWorker(symbol, context) {
                const type = getDeclaredTypeOfSymbol(symbol);
                context.typeStack.push(type.id);
                context.typeStack.push(-1);
                const table = createSymbolTable([
                    symbol
                ]);
                const statements = symbolTableToDeclarationStatements(table, context);
                context.typeStack.pop();
                context.typeStack.pop();
                return statements;
            }
            function withContext2(enclosingDeclaration, flags, internalFlags, tracker, maximumLength, verbosityLevel, cb, out) {
                const moduleResolverHost = (tracker == null ? void 0 : tracker.trackSymbol) ? tracker.moduleResolverHost : (internalFlags || 0 /* None */ ) & 4 /* DoNotIncludeSymbolChain */  ? createBasicNodeBuilderModuleSpecifierResolutionHost(host) : void 0;
                flags = flags || 0 /* None */ ;
                const maxTruncationLength = maximumLength || (flags & 1 /* NoTruncation */  ? noTruncationMaximumTruncationLength : defaultMaximumTruncationLength);
                const context = {
                    enclosingDeclaration,
                    enclosingFile: enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration),
                    flags,
                    internalFlags: internalFlags || 0 /* None */ ,
                    tracker: void 0,
                    maxTruncationLength,
                    maxExpansionDepth: verbosityLevel !== null && verbosityLevel !== void 0 ? verbosityLevel : -1,
                    encounteredError: false,
                    suppressReportInferenceFallback: false,
                    reportedDiagnostic: false,
                    visitedTypes: void 0,
                    symbolDepth: void 0,
                    inferTypeParameters: void 0,
                    approximateLength: 0,
                    trackedSymbols: void 0,
                    bundled: !!compilerOptions.outFile && !!enclosingDeclaration && isExternalOrCommonJsModule(getSourceFileOfNode(enclosingDeclaration)),
                    truncating: false,
                    usedSymbolNames: void 0,
                    remappedSymbolNames: void 0,
                    remappedSymbolReferences: void 0,
                    reverseMappedStack: void 0,
                    mustCreateTypeParameterSymbolList: true,
                    typeParameterSymbolList: void 0,
                    mustCreateTypeParametersNamesLookups: true,
                    typeParameterNames: void 0,
                    typeParameterNamesByText: void 0,
                    typeParameterNamesByTextNextNameCount: void 0,
                    enclosingSymbolTypes: /* @__PURE__ */ new Map(),
                    mapper: void 0,
                    depth: 0,
                    typeStack: [],
                    out: {
                        canIncreaseExpansionDepth: false,
                        truncated: false
                    }
                };
                context.tracker = new SymbolTrackerImpl(context, tracker, moduleResolverHost);
                const resultingNode = cb(context);
                if (context.truncating && context.flags & 1 /* NoTruncation */ ) context.tracker.reportTruncationError();
                if (out) {
                    out.canIncreaseExpansionDepth = context.out.canIncreaseExpansionDepth;
                    out.truncated = context.out.truncated;
                }
                return context.encounteredError ? void 0 : resultingNode;
            }
            function addSymbolTypeToContext(context, symbol, type) {
                const id = getSymbolId(symbol);
                const oldType = context.enclosingSymbolTypes.get(id);
                context.enclosingSymbolTypes.set(id, type);
                return restore;
                function restore() {
                    if (oldType) context.enclosingSymbolTypes.set(id, oldType);
                    else context.enclosingSymbolTypes.delete(id);
                }
            }
            function saveRestoreFlags(context) {
                const flags = context.flags;
                const internalFlags = context.internalFlags;
                const depth = context.depth;
                return restore;
                function restore() {
                    context.flags = flags;
                    context.internalFlags = internalFlags;
                    context.depth = depth;
                }
            }
            function checkTruncationLengthIfExpanding(context) {
                return context.maxExpansionDepth >= 0 && checkTruncationLength(context);
            }
            function checkTruncationLength(context) {
                if (context.truncating) return context.truncating;
                return context.truncating = context.approximateLength > context.maxTruncationLength;
            }
            function canPossiblyExpandType(type, context) {
                for(let i = 0; i < context.typeStack.length - 1; i++){
                    if (context.typeStack[i] === type.id) return false;
                }
                return context.depth < context.maxExpansionDepth || context.depth === context.maxExpansionDepth && !context.out.canIncreaseExpansionDepth;
            }
            function shouldExpandType(type, context, isAlias = false) {
                if (!isAlias && isLibType(type)) return false;
                for(let i = 0; i < context.typeStack.length - 1; i++){
                    if (context.typeStack[i] === type.id) return false;
                }
                const result = context.depth < context.maxExpansionDepth;
                if (!result) context.out.canIncreaseExpansionDepth = true;
                return result;
            }
            function typeToTypeNodeHelper(type, context) {
                const restoreFlags = saveRestoreFlags(context);
                if (type) context.typeStack.push(type.id);
                const typeNode = typeToTypeNodeWorker(type, context);
                if (type) context.typeStack.pop();
                restoreFlags();
                return typeNode;
            }
            function typeToTypeNodeWorker(type, context) {
                var _a, _b;
                if (cancellationToken && cancellationToken.throwIfCancellationRequested) cancellationToken.throwIfCancellationRequested();
                const inTypeAlias = context.flags & 8388608 /* InTypeAlias */ ;
                context.flags &= -8388609 /* InTypeAlias */ ;
                let expandingEnum = false;
                if (!type) {
                    if (!(context.flags & 262144 /* AllowEmptyUnionOrIntersection */ )) {
                        context.encounteredError = true;
                        return void 0;
                    }
                    context.approximateLength += 3;
                    return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                }
                if (!(context.flags & 536870912 /* NoTypeReduction */ )) type = getReducedType(type);
                if (type.flags & 1 /* Any */ ) {
                    if (type.aliasSymbol) return factory.createTypeReferenceNode(symbolToEntityNameNode(type.aliasSymbol), mapToTypeNodes(type.aliasTypeArguments, context));
                    if (type === unresolvedType) return addSyntheticLeadingComment(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), 3 /* MultiLineCommentTrivia */ , "unresolved");
                    context.approximateLength += 3;
                    return factory.createKeywordTypeNode(type === intrinsicMarkerType ? 141 /* IntrinsicKeyword */  : 133 /* AnyKeyword */ );
                }
                if (type.flags & 2 /* Unknown */ ) return factory.createKeywordTypeNode(159 /* UnknownKeyword */ );
                if (type.flags & 4 /* String */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(154 /* StringKeyword */ );
                }
                if (type.flags & 8 /* Number */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(150 /* NumberKeyword */ );
                }
                if (type.flags & 64 /* BigInt */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(163 /* BigIntKeyword */ );
                }
                if (type.flags & 16 /* Boolean */  && !type.aliasSymbol) {
                    context.approximateLength += 7;
                    return factory.createKeywordTypeNode(136 /* BooleanKeyword */ );
                }
                if (type.flags & 1056 /* EnumLike */ ) {
                    if (type.symbol.flags & 8 /* EnumMember */ ) {
                        const parentSymbol = getParentOfSymbol(type.symbol);
                        const parentName = symbolToTypeNode(parentSymbol, context, 788968 /* Type */ );
                        if (getDeclaredTypeOfSymbol(parentSymbol) === type) return parentName;
                        const memberName = symbolName(type.symbol);
                        if (isIdentifierText(memberName, 1 /* ES5 */ )) return appendReferenceToType(parentName, factory.createTypeReferenceNode(memberName, /*typeArguments*/ void 0));
                        if (isImportTypeNode(parentName)) {
                            parentName.isTypeOf = true;
                            return factory.createIndexedAccessTypeNode(parentName, factory.createLiteralTypeNode(factory.createStringLiteral(memberName)));
                        } else if (isTypeReferenceNode(parentName)) return factory.createIndexedAccessTypeNode(factory.createTypeQueryNode(parentName.typeName), factory.createLiteralTypeNode(factory.createStringLiteral(memberName)));
                        else return Debug.fail("Unhandled type node kind returned from `symbolToTypeNode`.");
                    }
                    if (!shouldExpandType(type, context)) return symbolToTypeNode(type.symbol, context, 788968 /* Type */ );
                    else expandingEnum = true;
                }
                if (type.flags & 128 /* StringLiteral */ ) {
                    context.approximateLength += type.value.length + 2;
                    return factory.createLiteralTypeNode(setEmitFlags(factory.createStringLiteral(type.value, !!(context.flags & 268435456 /* UseSingleQuotesForStringLiteralType */ )), 16777216 /* NoAsciiEscaping */ ));
                }
                if (type.flags & 256 /* NumberLiteral */ ) {
                    const value1 = type.value;
                    context.approximateLength += ("" + value1).length;
                    return factory.createLiteralTypeNode(value1 < 0 ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createNumericLiteral(-value1)) : factory.createNumericLiteral(value1));
                }
                if (type.flags & 2048 /* BigIntLiteral */ ) {
                    context.approximateLength += pseudoBigIntToString(type.value).length + 1;
                    return factory.createLiteralTypeNode(factory.createBigIntLiteral(type.value));
                }
                if (type.flags & 512 /* BooleanLiteral */ ) {
                    context.approximateLength += type.intrinsicName.length;
                    return factory.createLiteralTypeNode(type.intrinsicName === "true" ? factory.createTrue() : factory.createFalse());
                }
                if (type.flags & 8192 /* UniqueESSymbol */ ) {
                    if (!(context.flags & 1048576 /* AllowUniqueESSymbolType */ )) {
                        if (isValueSymbolAccessible(type.symbol, context.enclosingDeclaration)) {
                            context.approximateLength += 6;
                            return symbolToTypeNode(type.symbol, context, 111551 /* Value */ );
                        }
                        if (context.tracker.reportInaccessibleUniqueSymbolError) context.tracker.reportInaccessibleUniqueSymbolError();
                    }
                    context.approximateLength += 13;
                    return factory.createTypeOperatorNode(158 /* UniqueKeyword */ , factory.createKeywordTypeNode(155 /* SymbolKeyword */ ));
                }
                if (type.flags & 16384 /* Void */ ) {
                    context.approximateLength += 4;
                    return factory.createKeywordTypeNode(116 /* VoidKeyword */ );
                }
                if (type.flags & 32768 /* Undefined */ ) {
                    context.approximateLength += 9;
                    return factory.createKeywordTypeNode(157 /* UndefinedKeyword */ );
                }
                if (type.flags & 65536 /* Null */ ) {
                    context.approximateLength += 4;
                    return factory.createLiteralTypeNode(factory.createNull());
                }
                if (type.flags & 131072 /* Never */ ) {
                    context.approximateLength += 5;
                    return factory.createKeywordTypeNode(146 /* NeverKeyword */ );
                }
                if (type.flags & 4096 /* ESSymbol */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(155 /* SymbolKeyword */ );
                }
                if (type.flags & 67108864 /* NonPrimitive */ ) {
                    context.approximateLength += 6;
                    return factory.createKeywordTypeNode(151 /* ObjectKeyword */ );
                }
                if (isThisTypeParameter(type)) {
                    if (context.flags & 4194304 /* InObjectTypeLiteral */ ) {
                        if (!context.encounteredError && !(context.flags & 32768 /* AllowThisInObjectLiteral */ )) context.encounteredError = true;
                        (_b = (_a = context.tracker).reportInaccessibleThisError) == null || _b.call(_a);
                    }
                    context.approximateLength += 4;
                    return factory.createThisTypeNode();
                }
                if (!inTypeAlias && type.aliasSymbol && (context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */  || isTypeSymbolAccessible(type.aliasSymbol, context.enclosingDeclaration))) {
                    if (!shouldExpandType(type, context, /*isAlias*/ true)) {
                        const typeArgumentNodes = mapToTypeNodes(type.aliasTypeArguments, context);
                        if (isReservedMemberName(type.aliasSymbol.escapedName) && !(type.aliasSymbol.flags & 32 /* Class */ )) return factory.createTypeReferenceNode(factory.createIdentifier(""), typeArgumentNodes);
                        if (length(typeArgumentNodes) === 1 && type.aliasSymbol === globalArrayType.symbol) return factory.createArrayTypeNode(typeArgumentNodes[0]);
                        return symbolToTypeNode(type.aliasSymbol, context, 788968 /* Type */ , typeArgumentNodes);
                    }
                    context.depth += 1;
                }
                const objectFlags = getObjectFlags(type);
                if (objectFlags & 4 /* Reference */ ) {
                    Debug.assert(!!(type.flags & 524288 /* Object */ ));
                    if (shouldExpandType(type, context)) {
                        context.depth += 1;
                        return createAnonymousTypeNode(type, /*forceClassExpansion*/ true, /*forceExpansion*/ true);
                    }
                    return type.node ? visitAndTransformType(type, typeReferenceToTypeNode) : typeReferenceToTypeNode(type);
                }
                if (type.flags & 262144 /* TypeParameter */  || objectFlags & 3 /* ClassOrInterface */ ) {
                    if (type.flags & 262144 /* TypeParameter */  && contains(context.inferTypeParameters, type)) {
                        context.approximateLength += symbolName(type.symbol).length + 6;
                        let constraintNode;
                        const constraint = getConstraintOfTypeParameter(type);
                        if (constraint) {
                            const inferredConstraint = getInferredTypeParameterConstraint(type, /*omitTypeReferences*/ true);
                            if (!(inferredConstraint && isTypeIdenticalTo(constraint, inferredConstraint))) {
                                context.approximateLength += 9;
                                constraintNode = constraint && typeToTypeNodeHelper(constraint, context);
                            }
                        }
                        return factory.createInferTypeNode(typeParameterToDeclarationWithConstraint(type, context, constraintNode));
                    }
                    if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && type.flags & 262144 /* TypeParameter */ ) {
                        const name2 = typeParameterToName(type, context);
                        context.approximateLength += idText(name2).length;
                        return factory.createTypeReferenceNode(factory.createIdentifier(idText(name2)), /*typeArguments*/ void 0);
                    }
                    if (objectFlags & 3 /* ClassOrInterface */  && shouldExpandType(type, context)) {
                        context.depth += 1;
                        return createAnonymousTypeNode(type, /*forceClassExpansion*/ true, /*forceExpansion*/ true);
                    }
                    if (type.symbol) return symbolToTypeNode(type.symbol, context, 788968 /* Type */ );
                    const name = (type === markerSuperTypeForCheck || type === markerSubTypeForCheck) && varianceTypeParameter && varianceTypeParameter.symbol ? (type === markerSubTypeForCheck ? "sub-" : "super-") + symbolName(varianceTypeParameter.symbol) : "?";
                    return factory.createTypeReferenceNode(factory.createIdentifier(name), /*typeArguments*/ void 0);
                }
                if (type.flags & 1048576 /* Union */  && type.origin) type = type.origin;
                if (type.flags & 3145728 /* Intersection */ ) {
                    const types = type.flags & 1048576 /* Union */  ? formatUnionTypes(type.types, expandingEnum) : type.types;
                    if (length(types) === 1) return typeToTypeNodeHelper(types[0], context);
                    const typeNodes = mapToTypeNodes(types, context, /*isBareList*/ true);
                    if (typeNodes && typeNodes.length > 0) return type.flags & 1048576 /* Union */  ? factory.createUnionTypeNode(typeNodes) : factory.createIntersectionTypeNode(typeNodes);
                    else {
                        if (!context.encounteredError && !(context.flags & 262144 /* AllowEmptyUnionOrIntersection */ )) context.encounteredError = true;
                        return void 0;
                    }
                }
                if (objectFlags & 48 /* Mapped */ ) {
                    Debug.assert(!!(type.flags & 524288 /* Object */ ));
                    return createAnonymousTypeNode(type);
                }
                if (type.flags & 4194304 /* Index */ ) {
                    const indexedType = type.type;
                    context.approximateLength += 6;
                    const indexTypeNode = typeToTypeNodeHelper(indexedType, context);
                    return factory.createTypeOperatorNode(143 /* KeyOfKeyword */ , indexTypeNode);
                }
                if (type.flags & 134217728 /* TemplateLiteral */ ) {
                    const texts = type.texts;
                    const types = type.types;
                    const templateHead = factory.createTemplateHead(texts[0]);
                    const templateSpans = factory.createNodeArray(map(types, (t, i)=>factory.createTemplateLiteralTypeSpan(typeToTypeNodeHelper(t, context), (i < types.length - 1 ? factory.createTemplateMiddle : factory.createTemplateTail)(texts[i + 1]))));
                    context.approximateLength += 2;
                    return factory.createTemplateLiteralType(templateHead, templateSpans);
                }
                if (type.flags & 268435456 /* StringMapping */ ) {
                    const typeNode = typeToTypeNodeHelper(type.type, context);
                    return symbolToTypeNode(type.symbol, context, 788968 /* Type */ , [
                        typeNode
                    ]);
                }
                if (type.flags & 8388608 /* IndexedAccess */ ) {
                    const objectTypeNode = typeToTypeNodeHelper(type.objectType, context);
                    const indexTypeNode = typeToTypeNodeHelper(type.indexType, context);
                    context.approximateLength += 2;
                    return factory.createIndexedAccessTypeNode(objectTypeNode, indexTypeNode);
                }
                if (type.flags & 16777216 /* Conditional */ ) return visitAndTransformType(type, (type2)=>conditionalTypeToTypeNode(type2));
                if (type.flags & 33554432 /* Substitution */ ) {
                    const typeNode = typeToTypeNodeHelper(type.baseType, context);
                    const noInferSymbol = isNoInferType(type) && getGlobalTypeSymbol("NoInfer", /*reportErrors*/ false);
                    return noInferSymbol ? symbolToTypeNode(noInferSymbol, context, 788968 /* Type */ , [
                        typeNode
                    ]) : typeNode;
                }
                return Debug.fail("Should be unreachable.");
                function conditionalTypeToTypeNode(type2) {
                    const checkTypeNode = typeToTypeNodeHelper(type2.checkType, context);
                    context.approximateLength += 15;
                    if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && type2.root.isDistributive && !(type2.checkType.flags & 262144 /* TypeParameter */ )) {
                        const newParam = createTypeParameter(createSymbol(262144 /* TypeParameter */ , "T"));
                        const name = typeParameterToName(newParam, context);
                        const newTypeVariable = factory.createTypeReferenceNode(name);
                        context.approximateLength += 37;
                        const newMapper = prependTypeMapping(type2.root.checkType, newParam, type2.mapper);
                        const saveInferTypeParameters2 = context.inferTypeParameters;
                        context.inferTypeParameters = type2.root.inferTypeParameters;
                        const extendsTypeNode2 = typeToTypeNodeHelper(instantiateType(type2.root.extendsType, newMapper), context);
                        context.inferTypeParameters = saveInferTypeParameters2;
                        const trueTypeNode2 = typeToTypeNodeOrCircularityElision(instantiateType(getTypeFromTypeNode2(context, type2.root.node.trueType), newMapper));
                        const falseTypeNode2 = typeToTypeNodeOrCircularityElision(instantiateType(getTypeFromTypeNode2(context, type2.root.node.falseType), newMapper));
                        return factory.createConditionalTypeNode(checkTypeNode, factory.createInferTypeNode(factory.createTypeParameterDeclaration(/*modifiers*/ void 0, factory.cloneNode(newTypeVariable.typeName))), factory.createConditionalTypeNode(factory.createTypeReferenceNode(factory.cloneNode(name)), typeToTypeNodeHelper(type2.checkType, context), factory.createConditionalTypeNode(newTypeVariable, extendsTypeNode2, trueTypeNode2, falseTypeNode2), factory.createKeywordTypeNode(146 /* NeverKeyword */ )), factory.createKeywordTypeNode(146 /* NeverKeyword */ ));
                    }
                    const saveInferTypeParameters = context.inferTypeParameters;
                    context.inferTypeParameters = type2.root.inferTypeParameters;
                    const extendsTypeNode = typeToTypeNodeHelper(type2.extendsType, context);
                    context.inferTypeParameters = saveInferTypeParameters;
                    const trueTypeNode = typeToTypeNodeOrCircularityElision(getTrueTypeFromConditionalType(type2));
                    const falseTypeNode = typeToTypeNodeOrCircularityElision(getFalseTypeFromConditionalType(type2));
                    return factory.createConditionalTypeNode(checkTypeNode, extendsTypeNode, trueTypeNode, falseTypeNode);
                }
                function typeToTypeNodeOrCircularityElision(type2) {
                    var _a2, _b2, _c;
                    if (type2.flags & 1048576 /* Union */ ) {
                        if ((_a2 = context.visitedTypes) == null ? void 0 : _a2.has(getTypeId(type2))) {
                            if (!(context.flags & 131072 /* AllowAnonymousIdentifier */ )) {
                                context.encounteredError = true;
                                (_c = (_b2 = context.tracker) == null ? void 0 : _b2.reportCyclicStructureError) == null || _c.call(_b2);
                            }
                            return createElidedInformationPlaceholder(context);
                        }
                        return visitAndTransformType(type2, (type3)=>typeToTypeNodeHelper(type3, context));
                    }
                    return typeToTypeNodeHelper(type2, context);
                }
                function isMappedTypeHomomorphic(type2) {
                    return !!getHomomorphicTypeVariable(type2);
                }
                function isHomomorphicMappedTypeWithNonHomomorphicInstantiation(type2) {
                    return !!type2.target && isMappedTypeHomomorphic(type2.target) && !isMappedTypeHomomorphic(type2);
                }
                function createMappedTypeNodeFromType(type2) {
                    var _a2;
                    Debug.assert(!!(type2.flags & 524288 /* Object */ ));
                    const readonlyToken = type2.declaration.readonlyToken ? factory.createToken(type2.declaration.readonlyToken.kind) : void 0;
                    const questionToken = type2.declaration.questionToken ? factory.createToken(type2.declaration.questionToken.kind) : void 0;
                    let appropriateConstraintTypeNode;
                    let newTypeVariable;
                    let templateType = getTemplateTypeFromMappedType(type2);
                    const typeParameter = getTypeParameterFromMappedType(type2);
                    const needsModifierPreservingWrapper = !isMappedTypeWithKeyofConstraintDeclaration(type2) && !(getModifiersTypeFromMappedType(type2).flags & 2 /* Unknown */ ) && context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && !(getConstraintTypeFromMappedType(type2).flags & 262144 /* TypeParameter */  && ((_a2 = getConstraintOfTypeParameter(getConstraintTypeFromMappedType(type2))) == null ? void 0 : _a2.flags) & 4194304 /* Index */ );
                    if (isMappedTypeWithKeyofConstraintDeclaration(type2)) {
                        if (isHomomorphicMappedTypeWithNonHomomorphicInstantiation(type2) && context.flags & 4 /* GenerateNamesForShadowedTypeParams */ ) {
                            const newConstraintParam = createTypeParameter(createSymbol(262144 /* TypeParameter */ , "T"));
                            const name = typeParameterToName(newConstraintParam, context);
                            const target = type2.target;
                            newTypeVariable = factory.createTypeReferenceNode(name);
                            templateType = instantiateType(getTemplateTypeFromMappedType(target), makeArrayTypeMapper([
                                getTypeParameterFromMappedType(target),
                                getModifiersTypeFromMappedType(target)
                            ], [
                                typeParameter,
                                newConstraintParam
                            ]));
                        }
                        appropriateConstraintTypeNode = factory.createTypeOperatorNode(143 /* KeyOfKeyword */ , newTypeVariable || typeToTypeNodeHelper(getModifiersTypeFromMappedType(type2), context));
                    } else if (needsModifierPreservingWrapper) {
                        const newParam = createTypeParameter(createSymbol(262144 /* TypeParameter */ , "T"));
                        const name = typeParameterToName(newParam, context);
                        newTypeVariable = factory.createTypeReferenceNode(name);
                        appropriateConstraintTypeNode = newTypeVariable;
                    } else appropriateConstraintTypeNode = typeToTypeNodeHelper(getConstraintTypeFromMappedType(type2), context);
                    const typeParameterNode = typeParameterToDeclarationWithConstraint(typeParameter, context, appropriateConstraintTypeNode);
                    const cleanup = enterNewScope(context, type2.declaration, /*expandedParams*/ void 0, [
                        getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(type2.declaration.typeParameter))
                    ]);
                    const nameTypeNode = type2.declaration.nameType ? typeToTypeNodeHelper(getNameTypeFromMappedType(type2), context) : void 0;
                    const templateTypeNode = typeToTypeNodeHelper(removeMissingType(templateType, !!(getMappedTypeModifiers(type2) & 4 /* IncludeOptional */ )), context);
                    cleanup();
                    const mappedTypeNode = factory.createMappedTypeNode(readonlyToken, typeParameterNode, nameTypeNode, questionToken, templateTypeNode, /*members*/ void 0);
                    context.approximateLength += 10;
                    const result = setEmitFlags(mappedTypeNode, 1 /* SingleLine */ );
                    if (isHomomorphicMappedTypeWithNonHomomorphicInstantiation(type2) && context.flags & 4 /* GenerateNamesForShadowedTypeParams */ ) {
                        const originalConstraint = instantiateType(getConstraintOfTypeParameter(getTypeFromTypeNode2(context, type2.declaration.typeParameter.constraint.type)) || unknownType, type2.mapper);
                        return factory.createConditionalTypeNode(typeToTypeNodeHelper(getModifiersTypeFromMappedType(type2), context), factory.createInferTypeNode(factory.createTypeParameterDeclaration(/*modifiers*/ void 0, factory.cloneNode(newTypeVariable.typeName), originalConstraint.flags & 2 /* Unknown */  ? void 0 : typeToTypeNodeHelper(originalConstraint, context))), result, factory.createKeywordTypeNode(146 /* NeverKeyword */ ));
                    } else if (needsModifierPreservingWrapper) return factory.createConditionalTypeNode(typeToTypeNodeHelper(getConstraintTypeFromMappedType(type2), context), factory.createInferTypeNode(factory.createTypeParameterDeclaration(/*modifiers*/ void 0, factory.cloneNode(newTypeVariable.typeName), factory.createTypeOperatorNode(143 /* KeyOfKeyword */ , typeToTypeNodeHelper(getModifiersTypeFromMappedType(type2), context)))), result, factory.createKeywordTypeNode(146 /* NeverKeyword */ ));
                    return result;
                }
                function createAnonymousTypeNode(type2, forceClassExpansion = false, forceExpansion = false) {
                    var _a2, _b2;
                    const typeId = type2.id;
                    const symbol = type2.symbol;
                    if (symbol) {
                        const isInstantiationExpressionType = !!(getObjectFlags(type2) & 8388608 /* InstantiationExpressionType */ );
                        if (isInstantiationExpressionType) {
                            const instantiationExpressionType = type2;
                            const existing = instantiationExpressionType.node;
                            if (isTypeQueryNode(existing) && getTypeFromTypeNode2(context, existing) === type2) {
                                const typeNode = syntacticNodeBuilder.tryReuseExistingTypeNode(context, existing);
                                if (typeNode) return typeNode;
                            }
                            if ((_a2 = context.visitedTypes) == null ? void 0 : _a2.has(typeId)) return createElidedInformationPlaceholder(context);
                            return visitAndTransformType(type2, createTypeNodeFromObjectType);
                        }
                        const isInstanceType = isClassInstanceSide(type2) ? 788968 /* Type */  : 111551 /* Value */ ;
                        if (isJSConstructor(symbol.valueDeclaration)) return symbolToTypeNode(symbol, context, isInstanceType);
                        else if (!forceExpansion && (symbol.flags & 32 /* Class */  && !forceClassExpansion && !getBaseTypeVariableOfClass(symbol) && !(symbol.valueDeclaration && isClassLike(symbol.valueDeclaration) && context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */  && (!isClassDeclaration(symbol.valueDeclaration) || isSymbolAccessible(symbol, context.enclosingDeclaration, isInstanceType, /*shouldComputeAliasesToMakeVisible*/ false).accessibility !== 0 /* Accessible */ )) || symbol.flags & 896 /* ValueModule */  || shouldWriteTypeOfFunctionSymbol())) {
                            if (shouldExpandType(type2, context)) context.depth += 1;
                            else return symbolToTypeNode(symbol, context, isInstanceType);
                        }
                        if ((_b2 = context.visitedTypes) == null ? void 0 : _b2.has(typeId)) {
                            const typeAlias = getTypeAliasForTypeLiteral(type2);
                            if (typeAlias) return symbolToTypeNode(typeAlias, context, 788968 /* Type */ );
                            else return createElidedInformationPlaceholder(context);
                        } else return visitAndTransformType(type2, createTypeNodeFromObjectType);
                    } else return createTypeNodeFromObjectType(type2);
                    function shouldWriteTypeOfFunctionSymbol() {
                        var _a3;
                        const isStaticMethodSymbol = !!(symbol.flags & 8192 /* Method */ ) && // typeof static method
                        some(symbol.declarations, (declaration)=>isStatic(declaration) && !isLateBindableIndexSignature(getNameOfDeclaration(declaration)));
                        const isNonLocalFunctionSymbol = !!(symbol.flags & 16 /* Function */ ) && (symbol.parent || // is exported function symbol
                        forEach(symbol.declarations, (declaration)=>declaration.parent.kind === 308 /* SourceFile */  || declaration.parent.kind === 269 /* ModuleBlock */ ));
                        if (isStaticMethodSymbol || isNonLocalFunctionSymbol) return (!!(context.flags & 4096 /* UseTypeOfFunction */ ) || ((_a3 = context.visitedTypes) == null ? void 0 : _a3.has(typeId))) && // it is type of the symbol uses itself recursively
                        (!(context.flags & 8 /* UseStructuralFallback */ ) || isValueSymbolAccessible(symbol, context.enclosingDeclaration));
                    }
                }
                function visitAndTransformType(type2, transform2) {
                    var _a2, _b2, _c;
                    const typeId = type2.id;
                    const isConstructorObject = getObjectFlags(type2) & 16 /* Anonymous */  && type2.symbol && type2.symbol.flags & 32 /* Class */ ;
                    const id = getObjectFlags(type2) & 4 /* Reference */  && type2.node ? "N" + getNodeId(type2.node) : type2.flags & 16777216 /* Conditional */  ? "N" + getNodeId(type2.root.node) : type2.symbol ? (isConstructorObject ? "+" : "") + getSymbolId(type2.symbol) : void 0;
                    if (!context.visitedTypes) context.visitedTypes = /* @__PURE__ */ new Set();
                    if (id && !context.symbolDepth) context.symbolDepth = /* @__PURE__ */ new Map();
                    const links = context.maxExpansionDepth >= 0 ? void 0 : context.enclosingDeclaration && getNodeLinks(context.enclosingDeclaration);
                    const key = `${getTypeId(type2)}|${context.flags}|${context.internalFlags}`;
                    if (links) links.serializedTypes || (links.serializedTypes = /* @__PURE__ */ new Map());
                    const cachedResult = (_a2 = links == null ? void 0 : links.serializedTypes) == null ? void 0 : _a2.get(key);
                    if (cachedResult) {
                        (_b2 = cachedResult.trackedSymbols) == null || _b2.forEach(([symbol, enclosingDeclaration, meaning])=>context.tracker.trackSymbol(symbol, enclosingDeclaration, meaning));
                        if (cachedResult.truncating) context.truncating = true;
                        context.approximateLength += cachedResult.addedLength;
                        return deepCloneOrReuseNode(cachedResult.node);
                    }
                    let depth;
                    if (id) {
                        depth = context.symbolDepth.get(id) || 0;
                        if (depth > 10) return createElidedInformationPlaceholder(context);
                        context.symbolDepth.set(id, depth + 1);
                    }
                    context.visitedTypes.add(typeId);
                    const prevTrackedSymbols = context.trackedSymbols;
                    context.trackedSymbols = void 0;
                    const startLength = context.approximateLength;
                    const result = transform2(type2);
                    const addedLength = context.approximateLength - startLength;
                    if (!context.reportedDiagnostic && !context.encounteredError) (_c = links == null ? void 0 : links.serializedTypes) == null || _c.set(key, {
                        node: result,
                        truncating: context.truncating,
                        addedLength,
                        trackedSymbols: context.trackedSymbols
                    });
                    context.visitedTypes.delete(typeId);
                    if (id) context.symbolDepth.set(id, depth);
                    context.trackedSymbols = prevTrackedSymbols;
                    return result;
                    function deepCloneOrReuseNode(node) {
                        if (!nodeIsSynthesized(node) && getParseTreeNode(node) === node) return node;
                        return setTextRange2(context, factory.cloneNode(visitEachChild(node, deepCloneOrReuseNode, /*context*/ void 0, deepCloneOrReuseNodes, deepCloneOrReuseNode)), node);
                    }
                    function deepCloneOrReuseNodes(nodes, visitor, test, start, count) {
                        if (nodes && nodes.length === 0) return setTextRange(factory.createNodeArray(/*elements*/ void 0, nodes.hasTrailingComma), nodes);
                        return visitNodes2(nodes, visitor, test, start, count);
                    }
                }
                function createTypeNodeFromObjectType(type2) {
                    if (isGenericMappedType(type2) || type2.containsError) return createMappedTypeNodeFromType(type2);
                    const resolved = resolveStructuredTypeMembers(type2);
                    if (!resolved.properties.length && !resolved.indexInfos.length) {
                        if (!resolved.callSignatures.length && !resolved.constructSignatures.length) {
                            context.approximateLength += 2;
                            return setEmitFlags(factory.createTypeLiteralNode(/*members*/ void 0), 1 /* SingleLine */ );
                        }
                        if (resolved.callSignatures.length === 1 && !resolved.constructSignatures.length) {
                            const signature = resolved.callSignatures[0];
                            const signatureNode = signatureToSignatureDeclarationHelper(signature, 185 /* FunctionType */ , context);
                            return signatureNode;
                        }
                        if (resolved.constructSignatures.length === 1 && !resolved.callSignatures.length) {
                            const signature = resolved.constructSignatures[0];
                            const signatureNode = signatureToSignatureDeclarationHelper(signature, 186 /* ConstructorType */ , context);
                            return signatureNode;
                        }
                    }
                    const abstractSignatures = filter(resolved.constructSignatures, (signature)=>!!(signature.flags & 4 /* Abstract */ ));
                    if (some(abstractSignatures)) {
                        const types = map(abstractSignatures, getOrCreateTypeFromSignature);
                        const typeElementCount = resolved.callSignatures.length + (resolved.constructSignatures.length - abstractSignatures.length) + resolved.indexInfos.length + // exclude `prototype` when writing a class expression as a type literal, as per
                        // the logic in `createTypeNodesFromResolvedType`.
                        (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */  ? countWhere(resolved.properties, (p)=>!(p.flags & 4194304 /* Prototype */ )) : length(resolved.properties));
                        if (typeElementCount) types.push(getResolvedTypeWithoutAbstractConstructSignatures(resolved));
                        return typeToTypeNodeHelper(getIntersectionType(types), context);
                    }
                    const restoreFlags = saveRestoreFlags(context);
                    context.flags |= 4194304 /* InObjectTypeLiteral */ ;
                    const members = createTypeNodesFromResolvedType(resolved);
                    restoreFlags();
                    const typeLiteralNode = factory.createTypeLiteralNode(members);
                    context.approximateLength += 2;
                    setEmitFlags(typeLiteralNode, context.flags & 1024 /* MultilineObjectLiterals */  ? 0 : 1 /* SingleLine */ );
                    return typeLiteralNode;
                }
                function typeReferenceToTypeNode(type2) {
                    let typeArguments = getTypeArguments(type2);
                    if (type2.target === globalArrayType || type2.target === globalReadonlyArrayType) {
                        if (context.flags & 2 /* WriteArrayAsGenericType */ ) {
                            const typeArgumentNode = typeToTypeNodeHelper(typeArguments[0], context);
                            return factory.createTypeReferenceNode(type2.target === globalArrayType ? "Array" : "ReadonlyArray", [
                                typeArgumentNode
                            ]);
                        }
                        const elementType = typeToTypeNodeHelper(typeArguments[0], context);
                        const arrayType = factory.createArrayTypeNode(elementType);
                        return type2.target === globalArrayType ? arrayType : factory.createTypeOperatorNode(148 /* ReadonlyKeyword */ , arrayType);
                    } else if (type2.target.objectFlags & 8 /* Tuple */ ) {
                        typeArguments = sameMap(typeArguments, (t, i)=>removeMissingType(t, !!(type2.target.elementFlags[i] & 2 /* Optional */ )));
                        if (typeArguments.length > 0) {
                            const arity = getTypeReferenceArity(type2);
                            const tupleConstituentNodes = mapToTypeNodes(typeArguments.slice(0, arity), context);
                            if (tupleConstituentNodes) {
                                const { labeledElementDeclarations } = type2.target;
                                for(let i = 0; i < tupleConstituentNodes.length; i++){
                                    const flags = type2.target.elementFlags[i];
                                    const labeledElementDeclaration = labeledElementDeclarations == null ? void 0 : labeledElementDeclarations[i];
                                    if (labeledElementDeclaration) tupleConstituentNodes[i] = factory.createNamedTupleMember(flags & 12 /* Variable */  ? factory.createToken(26 /* DotDotDotToken */ ) : void 0, factory.createIdentifier(unescapeLeadingUnderscores(getTupleElementLabel(labeledElementDeclaration))), flags & 2 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, flags & 4 /* Rest */  ? factory.createArrayTypeNode(tupleConstituentNodes[i]) : tupleConstituentNodes[i]);
                                    else tupleConstituentNodes[i] = flags & 12 /* Variable */  ? factory.createRestTypeNode(flags & 4 /* Rest */  ? factory.createArrayTypeNode(tupleConstituentNodes[i]) : tupleConstituentNodes[i]) : flags & 2 /* Optional */  ? factory.createOptionalTypeNode(tupleConstituentNodes[i]) : tupleConstituentNodes[i];
                                }
                                const tupleTypeNode = setEmitFlags(factory.createTupleTypeNode(tupleConstituentNodes), 1 /* SingleLine */ );
                                return type2.target.readonly ? factory.createTypeOperatorNode(148 /* ReadonlyKeyword */ , tupleTypeNode) : tupleTypeNode;
                            }
                        }
                        if (context.encounteredError || context.flags & 524288 /* AllowEmptyTuple */ ) {
                            const tupleTypeNode = setEmitFlags(factory.createTupleTypeNode([]), 1 /* SingleLine */ );
                            return type2.target.readonly ? factory.createTypeOperatorNode(148 /* ReadonlyKeyword */ , tupleTypeNode) : tupleTypeNode;
                        }
                        context.encounteredError = true;
                        return void 0;
                    } else if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */  && type2.symbol.valueDeclaration && isClassLike(type2.symbol.valueDeclaration) && !isValueSymbolAccessible(type2.symbol, context.enclosingDeclaration)) return createAnonymousTypeNode(type2);
                    else {
                        const outerTypeParameters = type2.target.outerTypeParameters;
                        let i = 0;
                        let resultType;
                        if (outerTypeParameters) {
                            const length2 = outerTypeParameters.length;
                            while(i < length2){
                                const start = i;
                                const parent2 = getParentSymbolOfTypeParameter(outerTypeParameters[i]);
                                do i++;
                                while (i < length2 && getParentSymbolOfTypeParameter(outerTypeParameters[i]) === parent2);
                                if (!rangeEquals(outerTypeParameters, typeArguments, start, i)) {
                                    const typeArgumentSlice = mapToTypeNodes(typeArguments.slice(start, i), context);
                                    const restoreFlags2 = saveRestoreFlags(context);
                                    context.flags |= 16 /* ForbidIndexedAccessSymbolReferences */ ;
                                    const ref = symbolToTypeNode(parent2, context, 788968 /* Type */ , typeArgumentSlice);
                                    restoreFlags2();
                                    resultType = !resultType ? ref : appendReferenceToType(resultType, ref);
                                }
                            }
                        }
                        let typeArgumentNodes;
                        if (typeArguments.length > 0) {
                            let typeParameterCount = 0;
                            if (type2.target.typeParameters) {
                                typeParameterCount = Math.min(type2.target.typeParameters.length, typeArguments.length);
                                if (isReferenceToType2(type2, getGlobalIterableType(/*reportErrors*/ false)) || isReferenceToType2(type2, getGlobalIterableIteratorType(/*reportErrors*/ false)) || isReferenceToType2(type2, getGlobalAsyncIterableType(/*reportErrors*/ false)) || isReferenceToType2(type2, getGlobalAsyncIterableIteratorType(/*reportErrors*/ false))) {
                                    if (!type2.node || !isTypeReferenceNode(type2.node) || !type2.node.typeArguments || type2.node.typeArguments.length < typeParameterCount) while(typeParameterCount > 0){
                                        const typeArgument = typeArguments[typeParameterCount - 1];
                                        const typeParameter = type2.target.typeParameters[typeParameterCount - 1];
                                        const defaultType = getDefaultFromTypeParameter(typeParameter);
                                        if (!defaultType || !isTypeIdenticalTo(typeArgument, defaultType)) break;
                                        typeParameterCount--;
                                    }
                                }
                            }
                            typeArgumentNodes = mapToTypeNodes(typeArguments.slice(i, typeParameterCount), context);
                        }
                        const restoreFlags = saveRestoreFlags(context);
                        context.flags |= 16 /* ForbidIndexedAccessSymbolReferences */ ;
                        const finalRef = symbolToTypeNode(type2.symbol, context, 788968 /* Type */ , typeArgumentNodes);
                        restoreFlags();
                        return !resultType ? finalRef : appendReferenceToType(resultType, finalRef);
                    }
                }
                function appendReferenceToType(root, ref) {
                    if (isImportTypeNode(root)) {
                        let typeArguments = root.typeArguments;
                        let qualifier = root.qualifier;
                        if (qualifier) {
                            if (isIdentifier(qualifier)) {
                                if (typeArguments !== getIdentifierTypeArguments(qualifier)) qualifier = setIdentifierTypeArguments(factory.cloneNode(qualifier), typeArguments);
                            } else if (typeArguments !== getIdentifierTypeArguments(qualifier.right)) qualifier = factory.updateQualifiedName(qualifier, qualifier.left, setIdentifierTypeArguments(factory.cloneNode(qualifier.right), typeArguments));
                        }
                        typeArguments = ref.typeArguments;
                        const ids = getAccessStack(ref);
                        for (const id of ids)qualifier = qualifier ? factory.createQualifiedName(qualifier, id) : id;
                        return factory.updateImportTypeNode(root, root.argument, root.attributes, qualifier, typeArguments, root.isTypeOf);
                    } else {
                        let typeArguments = root.typeArguments;
                        let typeName = root.typeName;
                        if (isIdentifier(typeName)) {
                            if (typeArguments !== getIdentifierTypeArguments(typeName)) typeName = setIdentifierTypeArguments(factory.cloneNode(typeName), typeArguments);
                        } else if (typeArguments !== getIdentifierTypeArguments(typeName.right)) typeName = factory.updateQualifiedName(typeName, typeName.left, setIdentifierTypeArguments(factory.cloneNode(typeName.right), typeArguments));
                        typeArguments = ref.typeArguments;
                        const ids = getAccessStack(ref);
                        for (const id of ids)typeName = factory.createQualifiedName(typeName, id);
                        return factory.updateTypeReferenceNode(root, typeName, typeArguments);
                    }
                }
                function getAccessStack(ref) {
                    let state = ref.typeName;
                    const ids = [];
                    while(!isIdentifier(state)){
                        ids.unshift(state.right);
                        state = state.left;
                    }
                    ids.unshift(state);
                    return ids;
                }
                function indexInfoToObjectComputedNamesOrSignatureDeclaration(indexInfo, context2, typeNode) {
                    if (indexInfo.components) {
                        const allComponentComputedNamesSerializable = every(indexInfo.components, (e)=>{
                            var _a2;
                            return !!(e.name && isComputedPropertyName(e.name) && isEntityNameExpression(e.name.expression) && context2.enclosingDeclaration && ((_a2 = isEntityNameVisible(e.name.expression, context2.enclosingDeclaration, /*shouldComputeAliasToMakeVisible*/ false)) == null ? void 0 : _a2.accessibility) === 0 /* Accessible */ );
                        });
                        if (allComponentComputedNamesSerializable) {
                            const newComponents = filter(indexInfo.components, (e)=>{
                                return !hasLateBindableName(e);
                            });
                            return map(newComponents, (e)=>{
                                trackComputedName(e.name.expression, context2.enclosingDeclaration, context2);
                                return setTextRange2(context2, factory.createPropertySignature(indexInfo.isReadonly ? [
                                    factory.createModifier(148 /* ReadonlyKeyword */ )
                                ] : void 0, e.name, (isPropertySignature(e) || isPropertyDeclaration(e) || isMethodSignature(e) || isMethodDeclaration(e) || isGetAccessor(e) || isSetAccessor(e)) && e.questionToken ? factory.createToken(58 /* QuestionToken */ ) : void 0, typeNode || typeToTypeNodeHelper(getTypeOfSymbol(e.symbol), context2)), e);
                            });
                        }
                    }
                    return [
                        indexInfoToIndexSignatureDeclarationHelper(indexInfo, context2, typeNode)
                    ];
                }
                function createTypeNodesFromResolvedType(resolvedType) {
                    if (checkTruncationLength(context)) {
                        context.out.truncated = true;
                        if (context.flags & 1 /* NoTruncation */ ) return [
                            addSyntheticTrailingComment(factory.createNotEmittedTypeElement(), 3 /* MultiLineCommentTrivia */ , "elided")
                        ];
                        return [
                            factory.createPropertySignature(/*modifiers*/ void 0, "...", /*questionToken*/ void 0, /*type*/ void 0)
                        ];
                    }
                    context.typeStack.push(-1);
                    const typeElements = [];
                    for (const signature of resolvedType.callSignatures)typeElements.push(signatureToSignatureDeclarationHelper(signature, 180 /* CallSignature */ , context));
                    for (const signature of resolvedType.constructSignatures){
                        if (signature.flags & 4 /* Abstract */ ) continue;
                        typeElements.push(signatureToSignatureDeclarationHelper(signature, 181 /* ConstructSignature */ , context));
                    }
                    for (const info of resolvedType.indexInfos)typeElements.push(...indexInfoToObjectComputedNamesOrSignatureDeclaration(info, context, resolvedType.objectFlags & 1024 /* ReverseMapped */  ? createElidedInformationPlaceholder(context) : void 0));
                    const properties = resolvedType.properties;
                    if (!properties) {
                        context.typeStack.pop();
                        return typeElements;
                    }
                    let i = 0;
                    for (const propertySymbol of properties){
                        if (isExpanding(context) && propertySymbol.flags & 4194304 /* Prototype */ ) continue;
                        i++;
                        if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */ ) {
                            if (propertySymbol.flags & 4194304 /* Prototype */ ) continue;
                            if (getDeclarationModifierFlagsFromSymbol(propertySymbol) & 6 /* Protected */  && context.tracker.reportPrivateInBaseOfClassExpression) context.tracker.reportPrivateInBaseOfClassExpression(unescapeLeadingUnderscores(propertySymbol.escapedName));
                        }
                        if (checkTruncationLength(context) && i + 2 < properties.length - 1) {
                            context.out.truncated = true;
                            if (context.flags & 1 /* NoTruncation */ ) {
                                const typeElement = typeElements.pop();
                                typeElements.push(addSyntheticTrailingComment(typeElement, 3 /* MultiLineCommentTrivia */ , `... ${properties.length - i} more elided ...`));
                            } else typeElements.push(factory.createPropertySignature(/*modifiers*/ void 0, `... ${properties.length - i} more ...`, /*questionToken*/ void 0, /*type*/ void 0));
                            addPropertyToElementList(properties[properties.length - 1], context, typeElements);
                            break;
                        }
                        addPropertyToElementList(propertySymbol, context, typeElements);
                    }
                    context.typeStack.pop();
                    return typeElements.length ? typeElements : void 0;
                }
            }
            function createElidedInformationPlaceholder(context) {
                context.approximateLength += 3;
                if (!(context.flags & 1 /* NoTruncation */ )) return factory.createTypeReferenceNode(factory.createIdentifier("..."), /*typeArguments*/ void 0);
                return addSyntheticLeadingComment(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), 3 /* MultiLineCommentTrivia */ , "elided");
            }
            function shouldUsePlaceholderForProperty(propertySymbol, context) {
                var _a;
                const depth = 3;
                return !!(getCheckFlags(propertySymbol) & 8192 /* ReverseMapped */ ) && (contains(context.reverseMappedStack, propertySymbol) || ((_a = context.reverseMappedStack) == null ? void 0 : _a[0]) && !(getObjectFlags(last(context.reverseMappedStack).links.propertyType) & 16 /* Anonymous */ ) || isDeeplyNestedReverseMappedTypeProperty());
                function isDeeplyNestedReverseMappedTypeProperty() {
                    var _a2;
                    var _ref;
                    if (((_ref = (_a2 = context.reverseMappedStack) == null ? void 0 : _a2.length) !== null && _ref !== void 0 ? _ref : 0) < depth) return false;
                    for(let i = 0; i < depth; i++){
                        const prop = context.reverseMappedStack[context.reverseMappedStack.length - 1 - i];
                        if (prop.links.mappedType.symbol !== propertySymbol.links.mappedType.symbol) return false;
                    }
                    return true;
                }
            }
            function addPropertyToElementList(propertySymbol, context, typeElements) {
                var _a;
                const propertyIsReverseMapped = !!(getCheckFlags(propertySymbol) & 8192 /* ReverseMapped */ );
                const propertyType = shouldUsePlaceholderForProperty(propertySymbol, context) ? anyType : getNonMissingTypeOfSymbol(propertySymbol);
                const saveEnclosingDeclaration = context.enclosingDeclaration;
                context.enclosingDeclaration = void 0;
                if (context.tracker.canTrackSymbol && isLateBoundName(propertySymbol.escapedName)) {
                    if (propertySymbol.declarations) {
                        const decl = first(propertySymbol.declarations);
                        if (hasLateBindableName(decl)) {
                            if (isBinaryExpression(decl)) {
                                const name = getNameOfDeclaration(decl);
                                if (name && isElementAccessExpression(name) && isPropertyAccessEntityNameExpression(name.argumentExpression)) trackComputedName(name.argumentExpression, saveEnclosingDeclaration, context);
                            } else trackComputedName(decl.name.expression, saveEnclosingDeclaration, context);
                        }
                    } else context.tracker.reportNonSerializableProperty(symbolToString(propertySymbol));
                }
                context.enclosingDeclaration = propertySymbol.valueDeclaration || ((_a = propertySymbol.declarations) == null ? void 0 : _a[0]) || saveEnclosingDeclaration;
                const propertyName = getPropertyNameNodeForSymbol(propertySymbol, context);
                context.enclosingDeclaration = saveEnclosingDeclaration;
                context.approximateLength += symbolName(propertySymbol).length + 1;
                if (propertySymbol.flags & 98304 /* Accessor */ ) {
                    const writeType = getWriteTypeOfSymbol(propertySymbol);
                    if (!isErrorType(propertyType) && !isErrorType(writeType)) {
                        const symbolMapper = getSymbolLinks(propertySymbol).mapper;
                        const propDeclaration = getDeclarationOfKind(propertySymbol, 173 /* PropertyDeclaration */ );
                        if (propertyType !== writeType || propertySymbol.parent.flags & 32 /* Class */  && !propDeclaration) {
                            const getterDeclaration = getDeclarationOfKind(propertySymbol, 178 /* GetAccessor */ );
                            if (getterDeclaration) {
                                const getterSignature = getSignatureFromDeclaration(getterDeclaration);
                                typeElements.push(setCommentRange2(context, signatureToSignatureDeclarationHelper(symbolMapper ? instantiateSignature(getterSignature, symbolMapper) : getterSignature, 178 /* GetAccessor */ , context, {
                                    name: propertyName
                                }), getterDeclaration));
                            }
                            const setterDeclaration = getDeclarationOfKind(propertySymbol, 179 /* SetAccessor */ );
                            if (setterDeclaration) {
                                const setterSignature = getSignatureFromDeclaration(setterDeclaration);
                                typeElements.push(setCommentRange2(context, signatureToSignatureDeclarationHelper(symbolMapper ? instantiateSignature(setterSignature, symbolMapper) : setterSignature, 179 /* SetAccessor */ , context, {
                                    name: propertyName
                                }), setterDeclaration));
                            }
                            return;
                        }
                        if (propertySymbol.parent.flags & 32 /* Class */  && propDeclaration && find(propDeclaration.modifiers, isAccessorModifier)) {
                            const fakeGetterSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, propertyType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
                            typeElements.push(setCommentRange2(context, signatureToSignatureDeclarationHelper(fakeGetterSignature, 178 /* GetAccessor */ , context, {
                                name: propertyName
                            }), propDeclaration));
                            const setterParam = createSymbol(1 /* FunctionScopedVariable */ , "arg");
                            setterParam.links.type = writeType;
                            const fakeSetterSignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                setterParam
                            ], voidType, /*resolvedTypePredicate*/ void 0, 0, 0 /* None */ );
                            typeElements.push(signatureToSignatureDeclarationHelper(fakeSetterSignature, 179 /* SetAccessor */ , context, {
                                name: propertyName
                            }));
                            return;
                        }
                    }
                }
                const optionalToken = propertySymbol.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0;
                if (propertySymbol.flags & 8208 /* Method */  && !getPropertiesOfObjectType(propertyType).length && !isReadonlySymbol(propertySymbol)) {
                    const signatures = getSignaturesOfType(filterType(propertyType, (t)=>!(t.flags & 32768 /* Undefined */ )), 0 /* Call */ );
                    for (const signature of signatures){
                        const methodDeclaration = signatureToSignatureDeclarationHelper(signature, 174 /* MethodSignature */ , context, {
                            name: propertyName,
                            questionToken: optionalToken
                        });
                        typeElements.push(preserveCommentsOn(methodDeclaration, signature.declaration || propertySymbol.valueDeclaration));
                    }
                    if (signatures.length || !optionalToken) return;
                }
                let propertyTypeNode;
                if (shouldUsePlaceholderForProperty(propertySymbol, context)) propertyTypeNode = createElidedInformationPlaceholder(context);
                else {
                    if (propertyIsReverseMapped) {
                        context.reverseMappedStack || (context.reverseMappedStack = []);
                        context.reverseMappedStack.push(propertySymbol);
                    }
                    propertyTypeNode = propertyType ? serializeTypeForDeclaration(context, /*declaration*/ void 0, propertyType, propertySymbol) : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                    if (propertyIsReverseMapped) context.reverseMappedStack.pop();
                }
                const modifiers = isReadonlySymbol(propertySymbol) ? [
                    factory.createToken(148 /* ReadonlyKeyword */ )
                ] : void 0;
                if (modifiers) context.approximateLength += 9;
                const propertySignature = factory.createPropertySignature(modifiers, propertyName, optionalToken, propertyTypeNode);
                typeElements.push(preserveCommentsOn(propertySignature, propertySymbol.valueDeclaration));
                function preserveCommentsOn(node, range) {
                    var _a2;
                    const jsdocPropertyTag = (_a2 = propertySymbol.declarations) == null ? void 0 : _a2.find((d)=>d.kind === 349 /* JSDocPropertyTag */ );
                    if (jsdocPropertyTag) {
                        const commentText = getTextOfJSDocComment(jsdocPropertyTag.comment);
                        if (commentText) setSyntheticLeadingComments(node, [
                            {
                                kind: 3 /* MultiLineCommentTrivia */ ,
                                text: "*\n * " + commentText.replace(/\n/g, "\n * ") + "\n ",
                                pos: -1,
                                end: -1,
                                hasTrailingNewLine: true
                            }
                        ]);
                    } else if (range) setCommentRange2(context, node, range);
                    return node;
                }
            }
            function setCommentRange2(context, node, range) {
                if (context.enclosingFile && context.enclosingFile === getSourceFileOfNode(range)) return setCommentRange(node, range);
                return node;
            }
            function mapToTypeNodes(types, context, isBareList) {
                if (some(types)) {
                    if (checkTruncationLength(context)) {
                        context.out.truncated = true;
                        if (!isBareList) return [
                            context.flags & 1 /* NoTruncation */  ? addSyntheticLeadingComment(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), 3 /* MultiLineCommentTrivia */ , "elided") : factory.createTypeReferenceNode("...", /*typeArguments*/ void 0)
                        ];
                        else if (types.length > 2) return [
                            typeToTypeNodeHelper(types[0], context),
                            context.flags & 1 /* NoTruncation */  ? addSyntheticLeadingComment(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), 3 /* MultiLineCommentTrivia */ , `... ${types.length - 2} more elided ...`) : factory.createTypeReferenceNode(`... ${types.length - 2} more ...`, /*typeArguments*/ void 0),
                            typeToTypeNodeHelper(types[types.length - 1], context)
                        ];
                    }
                    const mayHaveNameCollisions = !(context.flags & 64 /* UseFullyQualifiedType */ );
                    const seenNames = mayHaveNameCollisions ? createMultiMap() : void 0;
                    const result = [];
                    let i = 0;
                    for (const type of types){
                        i++;
                        if (checkTruncationLength(context) && i + 2 < types.length - 1) {
                            context.out.truncated = true;
                            result.push(context.flags & 1 /* NoTruncation */  ? addSyntheticLeadingComment(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), 3 /* MultiLineCommentTrivia */ , `... ${types.length - i} more elided ...`) : factory.createTypeReferenceNode(`... ${types.length - i} more ...`, /*typeArguments*/ void 0));
                            const typeNode2 = typeToTypeNodeHelper(types[types.length - 1], context);
                            if (typeNode2) result.push(typeNode2);
                            break;
                        }
                        context.approximateLength += 2;
                        const typeNode = typeToTypeNodeHelper(type, context);
                        if (typeNode) {
                            result.push(typeNode);
                            if (seenNames && isIdentifierTypeReference(typeNode)) seenNames.add(typeNode.typeName.escapedText, [
                                type,
                                result.length - 1
                            ]);
                        }
                    }
                    if (seenNames) {
                        const restoreFlags = saveRestoreFlags(context);
                        context.flags |= 64 /* UseFullyQualifiedType */ ;
                        seenNames.forEach((types2)=>{
                            if (!arrayIsHomogeneous(types2, ([a], [b])=>typesAreSameReference(a, b))) for (const [type, resultIndex] of types2)result[resultIndex] = typeToTypeNodeHelper(type, context);
                        });
                        restoreFlags();
                    }
                    return result;
                }
            }
            function typesAreSameReference(a, b) {
                return a === b || !!a.symbol && a.symbol === b.symbol || !!a.aliasSymbol && a.aliasSymbol === b.aliasSymbol;
            }
            function indexInfoToIndexSignatureDeclarationHelper(indexInfo, context, typeNode) {
                const name = getNameFromIndexInfo(indexInfo) || "x";
                const indexerTypeNode = typeToTypeNodeHelper(indexInfo.keyType, context);
                const indexingParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name, /*questionToken*/ void 0, indexerTypeNode, /*initializer*/ void 0);
                if (!typeNode) typeNode = typeToTypeNodeHelper(indexInfo.type || anyType, context);
                if (!indexInfo.type && !(context.flags & 2097152 /* AllowEmptyIndexInfoType */ )) context.encounteredError = true;
                context.approximateLength += name.length + 4;
                return factory.createIndexSignature(indexInfo.isReadonly ? [
                    factory.createToken(148 /* ReadonlyKeyword */ )
                ] : void 0, [
                    indexingParameter
                ], typeNode);
            }
            function signatureToSignatureDeclarationHelper(signature, kind, context, options) {
                var _a;
                let typeParameters;
                let typeArguments;
                const expandedParams = getExpandedParameters(signature, /*skipUnionExpanding*/ true)[0];
                const cleanup = enterNewScope(context, signature.declaration, expandedParams, signature.typeParameters, signature.parameters, signature.mapper);
                context.approximateLength += 3;
                if (context.flags & 32 /* WriteTypeArgumentsOfSignature */  && signature.target && signature.mapper && signature.target.typeParameters) typeArguments = signature.target.typeParameters.map((parameter)=>typeToTypeNodeHelper(instantiateType(parameter, signature.mapper), context));
                else typeParameters = signature.typeParameters && signature.typeParameters.map((parameter)=>typeParameterToDeclaration(parameter, context));
                const restoreFlags = saveRestoreFlags(context);
                context.flags &= -257 /* SuppressAnyReturnType */ ;
                const parameters = (some(expandedParams, (p)=>p !== expandedParams[expandedParams.length - 1] && !!(getCheckFlags(p) & 32768 /* RestParameter */ )) ? signature.parameters : expandedParams).map((parameter)=>symbolToParameterDeclaration(parameter, context, kind === 177 /* Constructor */ ));
                const thisParameter = context.flags & 33554432 /* OmitThisParameter */  ? void 0 : tryGetThisParameterDeclaration(signature, context);
                if (thisParameter) parameters.unshift(thisParameter);
                restoreFlags();
                const returnTypeNode = serializeReturnTypeForSignature(context, signature);
                let modifiers = options == null ? void 0 : options.modifiers;
                if (kind === 186 /* ConstructorType */  && signature.flags & 4 /* Abstract */ ) {
                    const flags = modifiersToFlags(modifiers);
                    modifiers = factory.createModifiersFromModifierFlags(flags | 64 /* Abstract */ );
                }
                var _ref, _ref1, _ref2, _ref3;
                const node = kind === 180 /* CallSignature */  ? factory.createCallSignature(typeParameters, parameters, returnTypeNode) : kind === 181 /* ConstructSignature */  ? factory.createConstructSignature(typeParameters, parameters, returnTypeNode) : kind === 174 /* MethodSignature */  ? factory.createMethodSignature(modifiers, (_ref = options == null ? void 0 : options.name) !== null && _ref !== void 0 ? _ref : factory.createIdentifier(""), options == null ? void 0 : options.questionToken, typeParameters, parameters, returnTypeNode) : kind === 175 /* MethodDeclaration */  ? factory.createMethodDeclaration(modifiers, /*asteriskToken*/ void 0, (_ref1 = options == null ? void 0 : options.name) !== null && _ref1 !== void 0 ? _ref1 : factory.createIdentifier(""), /*questionToken*/ void 0, typeParameters, parameters, returnTypeNode, /*body*/ void 0) : kind === 177 /* Constructor */  ? factory.createConstructorDeclaration(modifiers, parameters, /*body*/ void 0) : kind === 178 /* GetAccessor */  ? factory.createGetAccessorDeclaration(modifiers, (_ref2 = options == null ? void 0 : options.name) !== null && _ref2 !== void 0 ? _ref2 : factory.createIdentifier(""), parameters, returnTypeNode, /*body*/ void 0) : kind === 179 /* SetAccessor */  ? factory.createSetAccessorDeclaration(modifiers, (_ref3 = options == null ? void 0 : options.name) !== null && _ref3 !== void 0 ? _ref3 : factory.createIdentifier(""), parameters, /*body*/ void 0) : kind === 182 /* IndexSignature */  ? factory.createIndexSignature(modifiers, parameters, returnTypeNode) : kind === 318 /* JSDocFunctionType */  ? factory.createJSDocFunctionType(parameters, returnTypeNode) : kind === 185 /* FunctionType */  ? factory.createFunctionTypeNode(typeParameters, parameters, returnTypeNode !== null && returnTypeNode !== void 0 ? returnTypeNode : factory.createTypeReferenceNode(factory.createIdentifier(""))) : kind === 186 /* ConstructorType */  ? factory.createConstructorTypeNode(modifiers, typeParameters, parameters, returnTypeNode !== null && returnTypeNode !== void 0 ? returnTypeNode : factory.createTypeReferenceNode(factory.createIdentifier(""))) : kind === 263 /* FunctionDeclaration */  ? factory.createFunctionDeclaration(modifiers, /*asteriskToken*/ void 0, (options == null ? void 0 : options.name) ? cast(options.name, isIdentifier) : factory.createIdentifier(""), typeParameters, parameters, returnTypeNode, /*body*/ void 0) : kind === 219 /* FunctionExpression */  ? factory.createFunctionExpression(modifiers, /*asteriskToken*/ void 0, (options == null ? void 0 : options.name) ? cast(options.name, isIdentifier) : factory.createIdentifier(""), typeParameters, parameters, returnTypeNode, factory.createBlock([])) : kind === 220 /* ArrowFunction */  ? factory.createArrowFunction(modifiers, typeParameters, parameters, returnTypeNode, /*equalsGreaterThanToken*/ void 0, factory.createBlock([])) : Debug.assertNever(kind);
                if (typeArguments) node.typeArguments = factory.createNodeArray(typeArguments);
                if (((_a = signature.declaration) == null ? void 0 : _a.kind) === 324 /* JSDocSignature */  && signature.declaration.parent.kind === 340 /* JSDocOverloadTag */ ) {
                    const comment = getTextOfNode(signature.declaration.parent.parent, /*includeTrivia*/ true).slice(2, -2).split(/\r\n|\n|\r/).map((line)=>line.replace(/^\s+/, " ")).join("\n");
                    addSyntheticLeadingComment(node, 3 /* MultiLineCommentTrivia */ , comment, /*hasTrailingNewLine*/ true);
                }
                cleanup == null || cleanup();
                return node;
            }
            function createRecoveryBoundary(context) {
                if (cancellationToken && cancellationToken.throwIfCancellationRequested) cancellationToken.throwIfCancellationRequested();
                let trackedSymbols;
                let unreportedErrors;
                let hadError = false;
                const oldTracker = context.tracker;
                const oldTrackedSymbols = context.trackedSymbols;
                context.trackedSymbols = void 0;
                const oldEncounteredError = context.encounteredError;
                context.tracker = new SymbolTrackerImpl(context, (0, _objectSpreadProps._)((0, _objectSpread._)({}, oldTracker.inner), {
                    reportCyclicStructureError () {
                        markError(()=>oldTracker.reportCyclicStructureError());
                    },
                    reportInaccessibleThisError () {
                        markError(()=>oldTracker.reportInaccessibleThisError());
                    },
                    reportInaccessibleUniqueSymbolError () {
                        markError(()=>oldTracker.reportInaccessibleUniqueSymbolError());
                    },
                    reportLikelyUnsafeImportRequiredError (specifier) {
                        markError(()=>oldTracker.reportLikelyUnsafeImportRequiredError(specifier));
                    },
                    reportNonSerializableProperty (name) {
                        markError(()=>oldTracker.reportNonSerializableProperty(name));
                    },
                    reportPrivateInBaseOfClassExpression (propertyName) {
                        markError(()=>oldTracker.reportPrivateInBaseOfClassExpression(propertyName));
                    },
                    trackSymbol (sym, decl, meaning) {
                        (trackedSymbols !== null && trackedSymbols !== void 0 ? trackedSymbols : trackedSymbols = []).push([
                            sym,
                            decl,
                            meaning
                        ]);
                        return false;
                    },
                    moduleResolverHost: context.tracker.moduleResolverHost
                }), context.tracker.moduleResolverHost);
                return {
                    startRecoveryScope,
                    finalizeBoundary,
                    markError,
                    hadError: ()=>hadError
                };
                function markError(unreportedError) {
                    hadError = true;
                    if (unreportedError) (unreportedErrors !== null && unreportedErrors !== void 0 ? unreportedErrors : unreportedErrors = []).push(unreportedError);
                }
                function startRecoveryScope() {
                    var _ref;
                    const trackedSymbolsTop = (_ref = trackedSymbols == null ? void 0 : trackedSymbols.length) !== null && _ref !== void 0 ? _ref : 0;
                    var _ref1;
                    const unreportedErrorsTop = (_ref1 = unreportedErrors == null ? void 0 : unreportedErrors.length) !== null && _ref1 !== void 0 ? _ref1 : 0;
                    return ()=>{
                        hadError = false;
                        if (trackedSymbols) trackedSymbols.length = trackedSymbolsTop;
                        if (unreportedErrors) unreportedErrors.length = unreportedErrorsTop;
                    };
                }
                function finalizeBoundary() {
                    context.tracker = oldTracker;
                    context.trackedSymbols = oldTrackedSymbols;
                    context.encounteredError = oldEncounteredError;
                    unreportedErrors == null || unreportedErrors.forEach((fn)=>fn());
                    if (hadError) return false;
                    trackedSymbols == null || trackedSymbols.forEach(([symbol, enclosingDeclaration, meaning])=>context.tracker.trackSymbol(symbol, enclosingDeclaration, meaning));
                    return true;
                }
            }
            function enterNewScope(context, declaration, expandedParams, typeParameters, originalParameters, mapper) {
                const cleanupContext = cloneNodeBuilderContext(context);
                let cleanupParams;
                let cleanupTypeParams;
                const oldEnclosingDecl = context.enclosingDeclaration;
                const oldMapper = context.mapper;
                if (mapper) context.mapper = mapper;
                if (context.enclosingDeclaration && declaration) {
                    let pushFakeScope2 = function(kind, addAll) {
                        Debug.assert(context.enclosingDeclaration);
                        let existingFakeScope;
                        if (getNodeLinks(context.enclosingDeclaration).fakeScopeForSignatureDeclaration === kind) existingFakeScope = context.enclosingDeclaration;
                        else if (context.enclosingDeclaration.parent && getNodeLinks(context.enclosingDeclaration.parent).fakeScopeForSignatureDeclaration === kind) existingFakeScope = context.enclosingDeclaration.parent;
                        Debug.assertOptionalNode(existingFakeScope, isBlock);
                        var _ref;
                        const locals = (_ref = existingFakeScope == null ? void 0 : existingFakeScope.locals) !== null && _ref !== void 0 ? _ref : createSymbolTable();
                        let newLocals;
                        let oldLocals;
                        addAll((name, symbol)=>{
                            if (existingFakeScope) {
                                const oldSymbol = locals.get(name);
                                if (!oldSymbol) newLocals = append(newLocals, name);
                                else oldLocals = append(oldLocals, {
                                    name,
                                    oldSymbol
                                });
                            }
                            locals.set(name, symbol);
                        });
                        if (!existingFakeScope) {
                            const fakeScope = factory.createBlock(emptyArray);
                            getNodeLinks(fakeScope).fakeScopeForSignatureDeclaration = kind;
                            fakeScope.locals = locals;
                            setParent(fakeScope, context.enclosingDeclaration);
                            context.enclosingDeclaration = fakeScope;
                        } else return function undo() {
                            forEach(newLocals, (s)=>locals.delete(s));
                            forEach(oldLocals, (s)=>locals.set(s.name, s.oldSymbol));
                        };
                    };
                    var pushFakeScope = pushFakeScope2;
                    cleanupParams = !some(expandedParams) ? void 0 : pushFakeScope2("params", (add)=>{
                        if (!expandedParams) return;
                        for(let pIndex = 0; pIndex < expandedParams.length; pIndex++){
                            const param = expandedParams[pIndex];
                            const originalParam = originalParameters == null ? void 0 : originalParameters[pIndex];
                            if (originalParameters && originalParam !== param) {
                                add(param.escapedName, unknownSymbol);
                                if (originalParam) add(originalParam.escapedName, unknownSymbol);
                            } else if (!forEach(param.declarations, (d)=>{
                                if (isParameter(d) && isBindingPattern(d.name)) {
                                    bindPattern(d.name);
                                    return true;
                                }
                                return void 0;
                                function bindPattern(p) {
                                    forEach(p.elements, (e)=>{
                                        switch(e.kind){
                                            case 233 /* OmittedExpression */ :
                                                return;
                                            case 209 /* BindingElement */ :
                                                return bindElement(e);
                                            default:
                                                return Debug.assertNever(e);
                                        }
                                    });
                                }
                                function bindElement(e) {
                                    if (isBindingPattern(e.name)) return bindPattern(e.name);
                                    const symbol = getSymbolOfDeclaration(e);
                                    add(symbol.escapedName, symbol);
                                }
                            })) add(param.escapedName, param);
                        }
                    });
                    if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && some(typeParameters)) cleanupTypeParams = pushFakeScope2("typeParams", (add)=>{
                        for (const typeParam of typeParameters !== null && typeParameters !== void 0 ? typeParameters : emptyArray){
                            const typeParamName = typeParameterToName(typeParam, context).escapedText;
                            add(typeParamName, typeParam.symbol);
                        }
                    });
                }
                return ()=>{
                    cleanupParams == null || cleanupParams();
                    cleanupTypeParams == null || cleanupTypeParams();
                    cleanupContext();
                    context.enclosingDeclaration = oldEnclosingDecl;
                    context.mapper = oldMapper;
                };
            }
            function tryGetThisParameterDeclaration(signature, context) {
                if (signature.thisParameter) return symbolToParameterDeclaration(signature.thisParameter, context);
                if (signature.declaration && isInJSFile(signature.declaration)) {
                    const thisTag = getJSDocThisTag(signature.declaration);
                    if (thisTag && thisTag.typeExpression) return factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "this", /*questionToken*/ void 0, typeToTypeNodeHelper(getTypeFromTypeNode2(context, thisTag.typeExpression), context));
                }
            }
            function typeParameterToDeclarationWithConstraint(type, context, constraintNode) {
                const restoreFlags = saveRestoreFlags(context);
                context.flags &= -513 /* WriteTypeParametersInQualifiedName */ ;
                const modifiers = factory.createModifiersFromModifierFlags(getTypeParameterModifiers(type));
                const name = typeParameterToName(type, context);
                const defaultParameter = getDefaultFromTypeParameter(type);
                const defaultParameterNode = defaultParameter && typeToTypeNodeHelper(defaultParameter, context);
                restoreFlags();
                return factory.createTypeParameterDeclaration(modifiers, name, constraintNode, defaultParameterNode);
            }
            function typeToTypeNodeHelperWithPossibleReusableTypeNode(type, typeNode, context) {
                return !canPossiblyExpandType(type, context) && typeNode && getTypeFromTypeNode2(context, typeNode) === type && syntacticNodeBuilder.tryReuseExistingTypeNode(context, typeNode) || typeToTypeNodeHelper(type, context);
            }
            function typeParameterToDeclaration(type, context, constraint = getConstraintOfTypeParameter(type)) {
                const constraintNode = constraint && typeToTypeNodeHelperWithPossibleReusableTypeNode(constraint, getConstraintDeclaration(type), context);
                return typeParameterToDeclarationWithConstraint(type, context, constraintNode);
            }
            function typePredicateToTypePredicateNodeHelper(typePredicate, context) {
                const assertsModifier = typePredicate.kind === 2 /* AssertsThis */  || typePredicate.kind === 3 /* AssertsIdentifier */  ? factory.createToken(131 /* AssertsKeyword */ ) : void 0;
                const parameterName = typePredicate.kind === 1 /* Identifier */  || typePredicate.kind === 3 /* AssertsIdentifier */  ? setEmitFlags(factory.createIdentifier(typePredicate.parameterName), 16777216 /* NoAsciiEscaping */ ) : factory.createThisTypeNode();
                const typeNode = typePredicate.type && typeToTypeNodeHelper(typePredicate.type, context);
                return factory.createTypePredicateNode(assertsModifier, parameterName, typeNode);
            }
            function getEffectiveParameterDeclaration(parameterSymbol) {
                const parameterDeclaration = getDeclarationOfKind(parameterSymbol, 170 /* Parameter */ );
                if (parameterDeclaration) return parameterDeclaration;
                if (!isTransientSymbol(parameterSymbol)) return getDeclarationOfKind(parameterSymbol, 342 /* JSDocParameterTag */ );
            }
            function symbolToParameterDeclaration(parameterSymbol, context, preserveModifierFlags) {
                const parameterDeclaration = getEffectiveParameterDeclaration(parameterSymbol);
                const parameterType = getTypeOfSymbol(parameterSymbol);
                const parameterTypeNode = serializeTypeForDeclaration(context, parameterDeclaration, parameterType, parameterSymbol);
                const modifiers = !(context.flags & 8192 /* OmitParameterModifiers */ ) && preserveModifierFlags && parameterDeclaration && canHaveModifiers(parameterDeclaration) ? map(getModifiers(parameterDeclaration), factory.cloneNode) : void 0;
                const isRest = parameterDeclaration && isRestParameter(parameterDeclaration) || getCheckFlags(parameterSymbol) & 32768 /* RestParameter */ ;
                const dotDotDotToken = isRest ? factory.createToken(26 /* DotDotDotToken */ ) : void 0;
                const name = parameterToParameterDeclarationName(parameterSymbol, parameterDeclaration, context);
                const isOptional = parameterDeclaration && isOptionalParameter(parameterDeclaration) || getCheckFlags(parameterSymbol) & 16384 /* OptionalParameter */ ;
                const questionToken = isOptional ? factory.createToken(58 /* QuestionToken */ ) : void 0;
                const parameterNode = factory.createParameterDeclaration(modifiers, dotDotDotToken, name, questionToken, parameterTypeNode, /*initializer*/ void 0);
                context.approximateLength += symbolName(parameterSymbol).length + 3;
                return parameterNode;
            }
            function parameterToParameterDeclarationName(parameterSymbol, parameterDeclaration, context) {
                return parameterDeclaration ? parameterDeclaration.name ? parameterDeclaration.name.kind === 80 /* Identifier */  ? setEmitFlags(factory.cloneNode(parameterDeclaration.name), 16777216 /* NoAsciiEscaping */ ) : parameterDeclaration.name.kind === 167 /* QualifiedName */  ? setEmitFlags(factory.cloneNode(parameterDeclaration.name.right), 16777216 /* NoAsciiEscaping */ ) : cloneBindingName(parameterDeclaration.name) : symbolName(parameterSymbol) : symbolName(parameterSymbol);
                function cloneBindingName(node) {
                    return elideInitializerAndSetEmitFlags(node);
                    function elideInitializerAndSetEmitFlags(node2) {
                        if (context.tracker.canTrackSymbol && isComputedPropertyName(node2) && isLateBindableName(node2)) trackComputedName(node2.expression, context.enclosingDeclaration, context);
                        let visited = visitEachChild(node2, elideInitializerAndSetEmitFlags, /*context*/ void 0, /*nodesVisitor*/ void 0, elideInitializerAndSetEmitFlags);
                        if (isBindingElement(visited)) visited = factory.updateBindingElement(visited, visited.dotDotDotToken, visited.propertyName, visited.name, /*initializer*/ void 0);
                        if (!nodeIsSynthesized(visited)) visited = factory.cloneNode(visited);
                        return setEmitFlags(visited, 16777217 /* NoAsciiEscaping */ );
                    }
                }
            }
            function trackComputedName(accessExpression, enclosingDeclaration, context) {
                if (!context.tracker.canTrackSymbol) return;
                const firstIdentifier = getFirstIdentifier(accessExpression);
                const name = resolveName(enclosingDeclaration, firstIdentifier.escapedText, 1160127 /* ExportValue */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
                if (name) context.tracker.trackSymbol(name, enclosingDeclaration, 111551 /* Value */ );
                else {
                    const fallback = resolveName(firstIdentifier, firstIdentifier.escapedText, 1160127 /* ExportValue */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
                    if (fallback) context.tracker.trackSymbol(fallback, enclosingDeclaration, 111551 /* Value */ );
                }
            }
            function lookupSymbolChain(symbol, context, meaning, yieldModuleSymbol) {
                context.tracker.trackSymbol(symbol, context.enclosingDeclaration, meaning);
                return lookupSymbolChainWorker(symbol, context, meaning, yieldModuleSymbol);
            }
            function lookupSymbolChainWorker(symbol, context, meaning, yieldModuleSymbol) {
                let chain;
                const isTypeParameter = symbol.flags & 262144 /* TypeParameter */ ;
                if (!isTypeParameter && (context.enclosingDeclaration || context.flags & 64 /* UseFullyQualifiedType */ ) && !(context.internalFlags & 4 /* DoNotIncludeSymbolChain */ )) {
                    chain = Debug.checkDefined(getSymbolChain(symbol, meaning, /*endOfChain*/ true));
                    Debug.assert(chain && chain.length > 0);
                } else chain = [
                    symbol
                ];
                return chain;
                function getSymbolChain(symbol2, meaning2, endOfChain) {
                    let accessibleSymbolChain = getAccessibleSymbolChain(symbol2, context.enclosingDeclaration, meaning2, !!(context.flags & 128 /* UseOnlyExternalAliasing */ ));
                    let parentSpecifiers;
                    if (!accessibleSymbolChain || needsQualification(accessibleSymbolChain[0], context.enclosingDeclaration, accessibleSymbolChain.length === 1 ? meaning2 : getQualifiedLeftMeaning(meaning2))) {
                        const parents = getContainersOfSymbol(accessibleSymbolChain ? accessibleSymbolChain[0] : symbol2, context.enclosingDeclaration, meaning2);
                        if (length(parents)) {
                            parentSpecifiers = parents.map((symbol3)=>some(symbol3.declarations, hasNonGlobalAugmentationExternalModuleSymbol) ? getSpecifierForModuleSymbol(symbol3, context) : void 0);
                            const indices = parents.map((_, i)=>i);
                            indices.sort(sortByBestName);
                            const sortedParents = indices.map((i)=>parents[i]);
                            for (const parent2 of sortedParents){
                                const parentChain = getSymbolChain(parent2, getQualifiedLeftMeaning(meaning2), /*endOfChain*/ false);
                                if (parentChain) {
                                    if (parent2.exports && parent2.exports.get("export=" /* ExportEquals */ ) && getSymbolIfSameReference(parent2.exports.get("export=" /* ExportEquals */ ), symbol2)) {
                                        accessibleSymbolChain = parentChain;
                                        break;
                                    }
                                    accessibleSymbolChain = parentChain.concat(accessibleSymbolChain || [
                                        getAliasForSymbolInContainer(parent2, symbol2) || symbol2
                                    ]);
                                    break;
                                }
                            }
                        }
                    }
                    if (accessibleSymbolChain) return accessibleSymbolChain;
                    if (// If this is the last part of outputting the symbol, always output. The cases apply only to parent symbols.
                    endOfChain || // If a parent symbol is an anonymous type, don't write it.
                    !(symbol2.flags & 6144 /* ObjectLiteral */ )) {
                        if (!endOfChain && !yieldModuleSymbol && !!forEach(symbol2.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) return;
                        return [
                            symbol2
                        ];
                    }
                    function sortByBestName(a, b) {
                        const specifierA = parentSpecifiers[a];
                        const specifierB = parentSpecifiers[b];
                        if (specifierA && specifierB) {
                            const isBRelative = pathIsRelative(specifierB);
                            if (pathIsRelative(specifierA) === isBRelative) return countPathComponents(specifierA) - countPathComponents(specifierB);
                            if (isBRelative) return -1;
                            return 1;
                        }
                        return 0;
                    }
                }
            }
            function typeParametersToTypeParameterDeclarations(symbol, context) {
                let typeParameterNodes;
                const targetSymbol = getTargetSymbol(symbol);
                if (targetSymbol.flags & 524384 /* TypeAlias */ ) typeParameterNodes = factory.createNodeArray(map(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol), (tp)=>typeParameterToDeclaration(tp, context)));
                return typeParameterNodes;
            }
            function lookupTypeParameterNodes(chain, index, context) {
                var _a;
                Debug.assert(chain && 0 <= index && index < chain.length);
                const symbol = chain[index];
                const symbolId = getSymbolId(symbol);
                if ((_a = context.typeParameterSymbolList) == null ? void 0 : _a.has(symbolId)) return void 0;
                if (context.mustCreateTypeParameterSymbolList) {
                    context.mustCreateTypeParameterSymbolList = false;
                    context.typeParameterSymbolList = new Set(context.typeParameterSymbolList);
                }
                context.typeParameterSymbolList.add(symbolId);
                let typeParameterNodes;
                if (context.flags & 512 /* WriteTypeParametersInQualifiedName */  && index < chain.length - 1) {
                    const parentSymbol = symbol;
                    const nextSymbol = chain[index + 1];
                    if (getCheckFlags(nextSymbol) & 1 /* Instantiated */ ) {
                        const params = getTypeParametersOfClassOrInterface(parentSymbol.flags & 2097152 /* Alias */  ? resolveAlias(parentSymbol) : parentSymbol);
                        typeParameterNodes = mapToTypeNodes(map(params, (t)=>getMappedType(t, nextSymbol.links.mapper)), context);
                    } else typeParameterNodes = typeParametersToTypeParameterDeclarations(symbol, context);
                }
                return typeParameterNodes;
            }
            function getTopmostIndexedAccessType(top) {
                if (isIndexedAccessTypeNode(top.objectType)) return getTopmostIndexedAccessType(top.objectType);
                return top;
            }
            function getSpecifierForModuleSymbol(symbol, context, overrideImportMode) {
                let file = getDeclarationOfKind(symbol, 308 /* SourceFile */ );
                if (!file) {
                    const equivalentFileSymbol = firstDefined(symbol.declarations, (d)=>getFileSymbolIfFileSymbolExportEqualsContainer(d, symbol));
                    if (equivalentFileSymbol) file = getDeclarationOfKind(equivalentFileSymbol, 308 /* SourceFile */ );
                }
                if (file && file.moduleName !== void 0) return file.moduleName;
                if (!file) {
                    if (ambientModuleSymbolRegex.test(symbol.escapedName)) return symbol.escapedName.substring(1, symbol.escapedName.length - 1);
                }
                if (!context.enclosingFile || !context.tracker.moduleResolverHost) {
                    if (ambientModuleSymbolRegex.test(symbol.escapedName)) return symbol.escapedName.substring(1, symbol.escapedName.length - 1);
                    return getSourceFileOfNode(getNonAugmentationDeclaration(symbol)).fileName;
                }
                const enclosingDeclaration = getOriginalNode(context.enclosingDeclaration);
                const originalModuleSpecifier = canHaveModuleSpecifier(enclosingDeclaration) ? tryGetModuleSpecifierFromDeclaration(enclosingDeclaration) : void 0;
                const contextFile = context.enclosingFile;
                const resolutionMode = overrideImportMode || originalModuleSpecifier && host.getModeForUsageLocation(contextFile, originalModuleSpecifier) || contextFile && host.getDefaultResolutionModeForFile(contextFile);
                const cacheKey = createModeAwareCacheKey(contextFile.path, resolutionMode);
                const links = getSymbolLinks(symbol);
                let specifier = links.specifierCache && links.specifierCache.get(cacheKey);
                if (!specifier) {
                    const isBundle2 = !!compilerOptions.outFile;
                    const { moduleResolverHost } = context.tracker;
                    const specifierCompilerOptions = isBundle2 ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, compilerOptions), {
                        baseUrl: moduleResolverHost.getCommonSourceDirectory()
                    }) : compilerOptions;
                    specifier = first(getModuleSpecifiers(symbol, checker, specifierCompilerOptions, contextFile, moduleResolverHost, {
                        importModuleSpecifierPreference: isBundle2 ? "non-relative" : "project-relative",
                        importModuleSpecifierEnding: isBundle2 ? "minimal" : resolutionMode === 99 /* ESNext */  ? "js" : void 0
                    }, {
                        overrideImportMode
                    }));
                    var _links_specifierCache;
                    (_links_specifierCache = links.specifierCache) !== null && _links_specifierCache !== void 0 ? _links_specifierCache : links.specifierCache = /* @__PURE__ */ new Map();
                    links.specifierCache.set(cacheKey, specifier);
                }
                return specifier;
            }
            function symbolToEntityNameNode(symbol) {
                const identifier = factory.createIdentifier(unescapeLeadingUnderscores(symbol.escapedName));
                return symbol.parent ? factory.createQualifiedName(symbolToEntityNameNode(symbol.parent), identifier) : identifier;
            }
            function symbolToTypeNode(symbol, context, meaning, overrideTypeArguments) {
                const chain = lookupSymbolChain(symbol, context, meaning, !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */ ));
                const isTypeOf = meaning === 111551 /* Value */ ;
                if (some(chain[0].declarations, hasNonGlobalAugmentationExternalModuleSymbol)) {
                    const nonRootParts = chain.length > 1 ? createAccessFromSymbolChain(chain, chain.length - 1, 1) : void 0;
                    const typeParameterNodes = overrideTypeArguments || lookupTypeParameterNodes(chain, 0, context);
                    const contextFile = getSourceFileOfNode(getOriginalNode(context.enclosingDeclaration));
                    const targetFile = getSourceFileOfModule(chain[0]);
                    let specifier;
                    let attributes;
                    if (getEmitModuleResolutionKind(compilerOptions) === 3 /* Node16 */  || getEmitModuleResolutionKind(compilerOptions) === 99 /* NodeNext */ ) {
                        if ((targetFile == null ? void 0 : targetFile.impliedNodeFormat) === 99 /* ESNext */  && targetFile.impliedNodeFormat !== (contextFile == null ? void 0 : contextFile.impliedNodeFormat)) {
                            specifier = getSpecifierForModuleSymbol(chain[0], context, 99 /* ESNext */ );
                            attributes = factory.createImportAttributes(factory.createNodeArray([
                                factory.createImportAttribute(factory.createStringLiteral("resolution-mode"), factory.createStringLiteral("import"))
                            ]));
                        }
                    }
                    if (!specifier) specifier = getSpecifierForModuleSymbol(chain[0], context);
                    if (!(context.flags & 67108864 /* AllowNodeModulesRelativePaths */ ) && getEmitModuleResolutionKind(compilerOptions) !== 1 /* Classic */  && specifier.includes("/node_modules/")) {
                        const oldSpecifier = specifier;
                        if (getEmitModuleResolutionKind(compilerOptions) === 3 /* Node16 */  || getEmitModuleResolutionKind(compilerOptions) === 99 /* NodeNext */ ) {
                            const swappedMode = (contextFile == null ? void 0 : contextFile.impliedNodeFormat) === 99 /* ESNext */  ? 1 /* CommonJS */  : 99 /* ESNext */ ;
                            specifier = getSpecifierForModuleSymbol(chain[0], context, swappedMode);
                            if (specifier.includes("/node_modules/")) specifier = oldSpecifier;
                            else attributes = factory.createImportAttributes(factory.createNodeArray([
                                factory.createImportAttribute(factory.createStringLiteral("resolution-mode"), factory.createStringLiteral(swappedMode === 99 /* ESNext */  ? "import" : "require"))
                            ]));
                        }
                        if (!attributes) {
                            context.encounteredError = true;
                            if (context.tracker.reportLikelyUnsafeImportRequiredError) context.tracker.reportLikelyUnsafeImportRequiredError(oldSpecifier);
                        }
                    }
                    const lit = factory.createLiteralTypeNode(factory.createStringLiteral(specifier));
                    context.approximateLength += specifier.length + 10;
                    if (!nonRootParts || isEntityName(nonRootParts)) {
                        if (nonRootParts) {
                            const lastId = isIdentifier(nonRootParts) ? nonRootParts : nonRootParts.right;
                            setIdentifierTypeArguments(lastId, /*typeArguments*/ void 0);
                        }
                        return factory.createImportTypeNode(lit, attributes, nonRootParts, typeParameterNodes, isTypeOf);
                    } else {
                        const splitNode = getTopmostIndexedAccessType(nonRootParts);
                        const qualifier = splitNode.objectType.typeName;
                        return factory.createIndexedAccessTypeNode(factory.createImportTypeNode(lit, attributes, qualifier, typeParameterNodes, isTypeOf), splitNode.indexType);
                    }
                }
                const entityName = createAccessFromSymbolChain(chain, chain.length - 1, 0);
                if (isIndexedAccessTypeNode(entityName)) return entityName;
                if (isTypeOf) return factory.createTypeQueryNode(entityName);
                else {
                    const lastId = isIdentifier(entityName) ? entityName : entityName.right;
                    const lastTypeArgs = getIdentifierTypeArguments(lastId);
                    setIdentifierTypeArguments(lastId, /*typeArguments*/ void 0);
                    return factory.createTypeReferenceNode(entityName, lastTypeArgs);
                }
                function createAccessFromSymbolChain(chain2, index, stopper) {
                    const typeParameterNodes = index === chain2.length - 1 ? overrideTypeArguments : lookupTypeParameterNodes(chain2, index, context);
                    const symbol2 = chain2[index];
                    const parent2 = chain2[index - 1];
                    let symbolName2;
                    if (index === 0) {
                        context.flags |= 16777216 /* InInitialEntityName */ ;
                        symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                        context.approximateLength += (symbolName2 ? symbolName2.length : 0) + 1;
                        context.flags ^= 16777216 /* InInitialEntityName */ ;
                    } else if (parent2 && getExportsOfSymbol(parent2)) {
                        const exports2 = getExportsOfSymbol(parent2);
                        forEachEntry(exports2, (ex, name)=>{
                            if (getSymbolIfSameReference(ex, symbol2) && !isLateBoundName(name) && name !== "export=" /* ExportEquals */ ) {
                                symbolName2 = unescapeLeadingUnderscores(name);
                                return true;
                            }
                        });
                    }
                    if (symbolName2 === void 0) {
                        const name = firstDefined(symbol2.declarations, getNameOfDeclaration);
                        if (name && isComputedPropertyName(name) && isEntityName(name.expression)) {
                            const LHS = createAccessFromSymbolChain(chain2, index - 1, stopper);
                            if (isEntityName(LHS)) return factory.createIndexedAccessTypeNode(factory.createParenthesizedType(factory.createTypeQueryNode(LHS)), factory.createTypeQueryNode(name.expression));
                            return LHS;
                        }
                        symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                    }
                    context.approximateLength += symbolName2.length + 1;
                    if (!(context.flags & 16 /* ForbidIndexedAccessSymbolReferences */ ) && parent2 && getMembersOfSymbol(parent2) && getMembersOfSymbol(parent2).get(symbol2.escapedName) && getSymbolIfSameReference(getMembersOfSymbol(parent2).get(symbol2.escapedName), symbol2)) {
                        const LHS = createAccessFromSymbolChain(chain2, index - 1, stopper);
                        if (isIndexedAccessTypeNode(LHS)) return factory.createIndexedAccessTypeNode(LHS, factory.createLiteralTypeNode(factory.createStringLiteral(symbolName2)));
                        else return factory.createIndexedAccessTypeNode(factory.createTypeReferenceNode(LHS, typeParameterNodes), factory.createLiteralTypeNode(factory.createStringLiteral(symbolName2)));
                    }
                    const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                    if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                    identifier.symbol = symbol2;
                    if (index > stopper) {
                        const LHS = createAccessFromSymbolChain(chain2, index - 1, stopper);
                        if (!isEntityName(LHS)) return Debug.fail("Impossible construct - an export of an indexed access cannot be reachable");
                        return factory.createQualifiedName(LHS, identifier);
                    }
                    return identifier;
                }
            }
            function typeParameterShadowsOtherTypeParameterInScope(escapedName, context, type) {
                const result = resolveName(context.enclosingDeclaration, escapedName, 788968 /* Type */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
                if (result && result.flags & 262144 /* TypeParameter */ ) return result !== type.symbol;
                return false;
            }
            function typeParameterToName(type, context) {
                var _a, _b, _c, _d;
                if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */  && context.typeParameterNames) {
                    const cached = context.typeParameterNames.get(getTypeId(type));
                    if (cached) return cached;
                }
                let result = symbolToName(type.symbol, context, 788968 /* Type */ , /*expectsIdentifier*/ true);
                if (!(result.kind & 80 /* Identifier */ )) return factory.createIdentifier("(Missing type parameter)");
                const decl = (_b = (_a = type.symbol) == null ? void 0 : _a.declarations) == null ? void 0 : _b[0];
                if (decl && isTypeParameterDeclaration(decl)) result = setTextRange2(context, result, decl.name);
                if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */ ) {
                    const rawtext = result.escapedText;
                    let i = ((_c = context.typeParameterNamesByTextNextNameCount) == null ? void 0 : _c.get(rawtext)) || 0;
                    let text = rawtext;
                    while(((_d = context.typeParameterNamesByText) == null ? void 0 : _d.has(text)) || typeParameterShadowsOtherTypeParameterInScope(text, context, type)){
                        i++;
                        text = `${rawtext}_${i}`;
                    }
                    if (text !== rawtext) {
                        const typeArguments = getIdentifierTypeArguments(result);
                        result = factory.createIdentifier(text);
                        setIdentifierTypeArguments(result, typeArguments);
                    }
                    if (context.mustCreateTypeParametersNamesLookups) {
                        context.mustCreateTypeParametersNamesLookups = false;
                        context.typeParameterNames = new Map(context.typeParameterNames);
                        context.typeParameterNamesByTextNextNameCount = new Map(context.typeParameterNamesByTextNextNameCount);
                        context.typeParameterNamesByText = new Set(context.typeParameterNamesByText);
                    }
                    context.typeParameterNamesByTextNextNameCount.set(rawtext, i);
                    context.typeParameterNames.set(getTypeId(type), result);
                    context.typeParameterNamesByText.add(text);
                }
                return result;
            }
            function symbolToName(symbol, context, meaning, expectsIdentifier) {
                const chain = lookupSymbolChain(symbol, context, meaning);
                if (expectsIdentifier && chain.length !== 1 && !context.encounteredError && !(context.flags & 65536 /* AllowQualifiedNameInPlaceOfIdentifier */ )) context.encounteredError = true;
                return createEntityNameFromSymbolChain(chain, chain.length - 1);
                function createEntityNameFromSymbolChain(chain2, index) {
                    const typeParameterNodes = lookupTypeParameterNodes(chain2, index, context);
                    const symbol2 = chain2[index];
                    if (index === 0) context.flags |= 16777216 /* InInitialEntityName */ ;
                    const symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                    if (index === 0) context.flags ^= 16777216 /* InInitialEntityName */ ;
                    const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                    if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                    identifier.symbol = symbol2;
                    return index > 0 ? factory.createQualifiedName(createEntityNameFromSymbolChain(chain2, index - 1), identifier) : identifier;
                }
            }
            function symbolToExpression(symbol, context, meaning) {
                const chain = lookupSymbolChain(symbol, context, meaning);
                return createExpressionFromSymbolChain(chain, chain.length - 1);
                function createExpressionFromSymbolChain(chain2, index) {
                    const typeParameterNodes = lookupTypeParameterNodes(chain2, index, context);
                    const symbol2 = chain2[index];
                    if (index === 0) context.flags |= 16777216 /* InInitialEntityName */ ;
                    let symbolName2 = getNameOfSymbolAsWritten(symbol2, context);
                    if (index === 0) context.flags ^= 16777216 /* InInitialEntityName */ ;
                    let firstChar = symbolName2.charCodeAt(0);
                    if (isSingleOrDoubleQuote(firstChar) && some(symbol2.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) {
                        const specifier = getSpecifierForModuleSymbol(symbol2, context);
                        context.approximateLength += 2 + specifier.length;
                        return factory.createStringLiteral(specifier);
                    }
                    if (index === 0 || canUsePropertyAccess(symbolName2, languageVersion)) {
                        const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                        if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                        identifier.symbol = symbol2;
                        context.approximateLength += 1 + symbolName2.length;
                        return index > 0 ? factory.createPropertyAccessExpression(createExpressionFromSymbolChain(chain2, index - 1), identifier) : identifier;
                    } else {
                        if (firstChar === 91 /* openBracket */ ) {
                            symbolName2 = symbolName2.substring(1, symbolName2.length - 1);
                            firstChar = symbolName2.charCodeAt(0);
                        }
                        let expression;
                        if (isSingleOrDoubleQuote(firstChar) && !(symbol2.flags & 8 /* EnumMember */ )) {
                            const literalText = stripQuotes(symbolName2).replace(/\\./g, (s)=>s.substring(1));
                            context.approximateLength += literalText.length + 2;
                            expression = factory.createStringLiteral(literalText, firstChar === 39 /* singleQuote */ );
                        } else if ("" + +symbolName2 === symbolName2) {
                            context.approximateLength += symbolName2.length;
                            expression = factory.createNumericLiteral(+symbolName2);
                        }
                        if (!expression) {
                            const identifier = setEmitFlags(factory.createIdentifier(symbolName2), 16777216 /* NoAsciiEscaping */ );
                            if (typeParameterNodes) setIdentifierTypeArguments(identifier, factory.createNodeArray(typeParameterNodes));
                            identifier.symbol = symbol2;
                            context.approximateLength += symbolName2.length;
                            expression = identifier;
                        }
                        context.approximateLength += 2;
                        return factory.createElementAccessExpression(createExpressionFromSymbolChain(chain2, index - 1), expression);
                    }
                }
            }
            function isStringNamed(d) {
                const name = getNameOfDeclaration(d);
                if (!name) return false;
                if (isComputedPropertyName(name)) {
                    const type = checkExpression(name.expression);
                    return !!(type.flags & 402653316 /* StringLike */ );
                }
                if (isElementAccessExpression(name)) {
                    const type = checkExpression(name.argumentExpression);
                    return !!(type.flags & 402653316 /* StringLike */ );
                }
                return isStringLiteral(name);
            }
            function isSingleQuotedStringNamed(d) {
                const name = getNameOfDeclaration(d);
                return !!(name && isStringLiteral(name) && (name.singleQuote || !nodeIsSynthesized(name) && startsWith(getTextOfNode(name, /*includeTrivia*/ false), "'")));
            }
            function getPropertyNameNodeForSymbol(symbol, context) {
                const hashPrivateName = getClonedHashPrivateName(symbol);
                if (hashPrivateName) return hashPrivateName;
                const stringNamed = !!length(symbol.declarations) && every(symbol.declarations, isStringNamed);
                const singleQuote = !!length(symbol.declarations) && every(symbol.declarations, isSingleQuotedStringNamed);
                const isMethod = !!(symbol.flags & 8192 /* Method */ );
                const fromNameType = getPropertyNameNodeForSymbolFromNameType(symbol, context, singleQuote, stringNamed, isMethod);
                if (fromNameType) return fromNameType;
                const rawName = unescapeLeadingUnderscores(symbol.escapedName);
                return createPropertyNameNodeForIdentifierOrLiteral(rawName, getEmitScriptTarget(compilerOptions), singleQuote, stringNamed, isMethod);
            }
            function getPropertyNameNodeForSymbolFromNameType(symbol, context, singleQuote, stringNamed, isMethod) {
                const nameType = getSymbolLinks(symbol).nameType;
                if (nameType) {
                    if (nameType.flags & 384 /* StringOrNumberLiteral */ ) {
                        const name = "" + nameType.value;
                        if (!isIdentifierText(name, getEmitScriptTarget(compilerOptions)) && (stringNamed || !isNumericLiteralName(name))) return factory.createStringLiteral(name, !!singleQuote);
                        if (isNumericLiteralName(name) && startsWith(name, "-")) return factory.createComputedPropertyName(factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createNumericLiteral(-name)));
                        return createPropertyNameNodeForIdentifierOrLiteral(name, getEmitScriptTarget(compilerOptions), singleQuote, stringNamed, isMethod);
                    }
                    if (nameType.flags & 8192 /* UniqueESSymbol */ ) return factory.createComputedPropertyName(symbolToExpression(nameType.symbol, context, 111551 /* Value */ ));
                }
            }
            function cloneNodeBuilderContext(context) {
                const oldMustCreateTypeParameterSymbolList = context.mustCreateTypeParameterSymbolList;
                const oldMustCreateTypeParametersNamesLookups = context.mustCreateTypeParametersNamesLookups;
                context.mustCreateTypeParameterSymbolList = true;
                context.mustCreateTypeParametersNamesLookups = true;
                const oldTypeParameterNames = context.typeParameterNames;
                const oldTypeParameterNamesByText = context.typeParameterNamesByText;
                const oldTypeParameterNamesByTextNextNameCount = context.typeParameterNamesByTextNextNameCount;
                const oldTypeParameterSymbolList = context.typeParameterSymbolList;
                return ()=>{
                    context.typeParameterNames = oldTypeParameterNames;
                    context.typeParameterNamesByText = oldTypeParameterNamesByText;
                    context.typeParameterNamesByTextNextNameCount = oldTypeParameterNamesByTextNextNameCount;
                    context.typeParameterSymbolList = oldTypeParameterSymbolList;
                    context.mustCreateTypeParameterSymbolList = oldMustCreateTypeParameterSymbolList;
                    context.mustCreateTypeParametersNamesLookups = oldMustCreateTypeParametersNamesLookups;
                };
            }
            function getDeclarationWithTypeAnnotation(symbol, enclosingDeclaration) {
                return symbol.declarations && find(symbol.declarations, (s)=>!!getNonlocalEffectiveTypeAnnotationNode(s) && (!enclosingDeclaration || !!findAncestor(s, (n)=>n === enclosingDeclaration)));
            }
            function existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(existing, type) {
                if (!(getObjectFlags(type) & 4 /* Reference */ )) return true;
                if (!isTypeReferenceNode(existing)) return true;
                getTypeFromTypeReference(existing);
                const symbol = getNodeLinks(existing).resolvedSymbol;
                const existingTarget = symbol && getDeclaredTypeOfSymbol(symbol);
                if (!existingTarget || existingTarget !== type.target) return true;
                return length(existing.typeArguments) >= getMinTypeArgumentCount(type.target.typeParameters);
            }
            function getEnclosingDeclarationIgnoringFakeScope(enclosingDeclaration) {
                while(getNodeLinks(enclosingDeclaration).fakeScopeForSignatureDeclaration)enclosingDeclaration = enclosingDeclaration.parent;
                return enclosingDeclaration;
            }
            function serializeInferredTypeForDeclaration(symbol, context, type) {
                if (type.flags & 8192 /* UniqueESSymbol */  && type.symbol === symbol && (!context.enclosingDeclaration || some(symbol.declarations, (d)=>getSourceFileOfNode(d) === context.enclosingFile))) context.flags |= 1048576 /* AllowUniqueESSymbolType */ ;
                const result = typeToTypeNodeHelper(type, context);
                return result;
            }
            function serializeTypeForDeclaration(context, declaration, type, symbol) {
                var _a;
                let result;
                const addUndefinedForParameter = declaration && (isParameter(declaration) || isJSDocParameterTag(declaration)) && requiresAddingImplicitUndefined(declaration, context.enclosingDeclaration);
                var _ref, _ref1;
                const decl = (_ref1 = (_ref = declaration !== null && declaration !== void 0 ? declaration : symbol.valueDeclaration) !== null && _ref !== void 0 ? _ref : getDeclarationWithTypeAnnotation(symbol)) !== null && _ref1 !== void 0 ? _ref1 : (_a = symbol.declarations) == null ? void 0 : _a[0];
                if (!canPossiblyExpandType(type, context) && decl) {
                    const restore = addSymbolTypeToContext(context, symbol, type);
                    if (isAccessor(decl)) result = syntacticNodeBuilder.serializeTypeOfAccessor(decl, symbol, context);
                    else if (hasInferredType(decl) && !nodeIsSynthesized(decl) && !(getObjectFlags(type) & 196608 /* RequiresWidening */ )) result = syntacticNodeBuilder.serializeTypeOfDeclaration(decl, symbol, context);
                    restore();
                }
                if (!result) {
                    if (addUndefinedForParameter) type = getOptionalType(type);
                    result = serializeInferredTypeForDeclaration(symbol, context, type);
                }
                return result !== null && result !== void 0 ? result : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
            }
            function typeNodeIsEquivalentToType(annotatedDeclaration, type, typeFromTypeNode) {
                if (typeFromTypeNode === type) return true;
                if (!annotatedDeclaration) return false;
                if ((isPropertySignature(annotatedDeclaration) || isPropertyDeclaration(annotatedDeclaration)) && annotatedDeclaration.questionToken) return getTypeWithFacts(type, 524288 /* NEUndefined */ ) === typeFromTypeNode;
                if (isParameter(annotatedDeclaration) && hasEffectiveQuestionToken(annotatedDeclaration)) return getTypeWithFacts(type, 524288 /* NEUndefined */ ) === typeFromTypeNode;
                return false;
            }
            function serializeReturnTypeForSignature(context, signature) {
                const suppressAny = context.flags & 256 /* SuppressAnyReturnType */ ;
                const restoreFlags = saveRestoreFlags(context);
                if (suppressAny) context.flags &= -257 /* SuppressAnyReturnType */ ;
                let returnTypeNode;
                const returnType = getReturnTypeOfSignature(signature);
                if (!(suppressAny && isTypeAny(returnType))) {
                    if (signature.declaration && !nodeIsSynthesized(signature.declaration) && !canPossiblyExpandType(returnType, context)) {
                        const declarationSymbol = getSymbolOfDeclaration(signature.declaration);
                        const restore = addSymbolTypeToContext(context, declarationSymbol, returnType);
                        returnTypeNode = syntacticNodeBuilder.serializeReturnTypeForSignature(signature.declaration, declarationSymbol, context);
                        restore();
                    }
                    if (!returnTypeNode) returnTypeNode = serializeInferredReturnTypeForSignature(context, signature, returnType);
                }
                if (!returnTypeNode && !suppressAny) returnTypeNode = factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                restoreFlags();
                return returnTypeNode;
            }
            function serializeInferredReturnTypeForSignature(context, signature, returnType) {
                const oldSuppressReportInferenceFallback = context.suppressReportInferenceFallback;
                context.suppressReportInferenceFallback = true;
                const typePredicate = getTypePredicateOfSignature(signature);
                const returnTypeNode = typePredicate ? typePredicateToTypePredicateNodeHelper(context.mapper ? instantiateTypePredicate(typePredicate, context.mapper) : typePredicate, context) : typeToTypeNodeHelper(returnType, context);
                context.suppressReportInferenceFallback = oldSuppressReportInferenceFallback;
                return returnTypeNode;
            }
            function trackExistingEntityName(node, context, enclosingDeclaration = context.enclosingDeclaration) {
                let introducesError = false;
                const leftmost = getFirstIdentifier(node);
                if (isInJSFile(node) && (isExportsIdentifier(leftmost) || isModuleExportsAccessExpression(leftmost.parent) || isQualifiedName(leftmost.parent) && isModuleIdentifier(leftmost.parent.left) && isExportsIdentifier(leftmost.parent.right))) {
                    introducesError = true;
                    return {
                        introducesError,
                        node
                    };
                }
                const meaning = getMeaningOfEntityNameReference(node);
                let sym;
                if (isThisIdentifier(leftmost)) {
                    sym = getSymbolOfDeclaration(getThisContainer(leftmost, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false));
                    if (isSymbolAccessible(sym, leftmost, meaning, /*shouldComputeAliasesToMakeVisible*/ false).accessibility !== 0 /* Accessible */ ) {
                        introducesError = true;
                        context.tracker.reportInaccessibleThisError();
                    }
                    return {
                        introducesError,
                        node: attachSymbolToLeftmostIdentifier(node)
                    };
                }
                sym = resolveEntityName(leftmost, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true);
                if (context.enclosingDeclaration && !(sym && sym.flags & 262144 /* TypeParameter */ )) {
                    sym = getExportSymbolOfValueSymbolIfExported(sym);
                    const symAtLocation = resolveEntityName(leftmost, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true, context.enclosingDeclaration);
                    if (// Check for unusable parameters symbols
                    symAtLocation === unknownSymbol || // If the symbol is not found, but was not found in the original scope either we probably have an error, don't reuse the node
                    symAtLocation === void 0 && sym !== void 0 || // If the symbol is found both in declaration scope and in current scope then it should point to the same reference
                    symAtLocation && sym && !getSymbolIfSameReference(getExportSymbolOfValueSymbolIfExported(symAtLocation), sym)) {
                        if (symAtLocation !== unknownSymbol) context.tracker.reportInferenceFallback(node);
                        introducesError = true;
                        return {
                            introducesError,
                            node,
                            sym
                        };
                    } else sym = symAtLocation;
                }
                if (sym) {
                    if (sym.flags & 1 /* FunctionScopedVariable */  && sym.valueDeclaration) {
                        if (isPartOfParameterDeclaration(sym.valueDeclaration) || isJSDocParameterTag(sym.valueDeclaration)) return {
                            introducesError,
                            node: attachSymbolToLeftmostIdentifier(node)
                        };
                    }
                    if (!(sym.flags & 262144 /* TypeParameter */ ) && // Type parameters are visible in the current context if they are are resolvable
                    !isDeclarationName(node) && isSymbolAccessible(sym, enclosingDeclaration, meaning, /*shouldComputeAliasesToMakeVisible*/ false).accessibility !== 0 /* Accessible */ ) {
                        context.tracker.reportInferenceFallback(node);
                        introducesError = true;
                    } else context.tracker.trackSymbol(sym, enclosingDeclaration, meaning);
                    return {
                        introducesError,
                        node: attachSymbolToLeftmostIdentifier(node)
                    };
                }
                return {
                    introducesError,
                    node
                };
                function attachSymbolToLeftmostIdentifier(node2) {
                    if (node2 === leftmost) {
                        const type = getDeclaredTypeOfSymbol(sym);
                        const name = sym.flags & 262144 /* TypeParameter */  ? typeParameterToName(type, context) : factory.cloneNode(node2);
                        name.symbol = sym;
                        return setTextRange2(context, setEmitFlags(name, 16777216 /* NoAsciiEscaping */ ), node2);
                    }
                    const updated = visitEachChild(node2, (c)=>attachSymbolToLeftmostIdentifier(c), /*context*/ void 0);
                    return setTextRange2(context, updated, node2);
                }
            }
            function serializeTypeName(context, node, isTypeOf, typeArguments) {
                const meaning = isTypeOf ? 111551 /* Value */  : 788968 /* Type */ ;
                const symbol = resolveEntityName(node, meaning, /*ignoreErrors*/ true);
                if (!symbol) return void 0;
                const resolvedSymbol = symbol.flags & 2097152 /* Alias */  ? resolveAlias(symbol) : symbol;
                if (isSymbolAccessible(symbol, context.enclosingDeclaration, meaning, /*shouldComputeAliasesToMakeVisible*/ false).accessibility !== 0 /* Accessible */ ) return void 0;
                return symbolToTypeNode(resolvedSymbol, context, meaning, typeArguments);
            }
            function canReuseTypeNode(context, existing) {
                const type = getTypeFromTypeNode2(context, existing, /*noMappedTypes*/ true);
                if (!type) return false;
                if (isInJSFile(existing)) {
                    if (isLiteralImportTypeNode(existing)) {
                        getTypeFromImportTypeNode(existing);
                        const nodeSymbol = getNodeLinks(existing).resolvedSymbol;
                        return !nodeSymbol || !(!existing.isTypeOf && !(nodeSymbol.flags & 788968 /* Type */ ) || // The import type had type arguments autofilled by js fallback logic
                        !(length(existing.typeArguments) >= getMinTypeArgumentCount(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(nodeSymbol))));
                    }
                }
                if (isTypeReferenceNode(existing)) {
                    if (isConstTypeReference(existing)) return false;
                    const symbol = getNodeLinks(existing).resolvedSymbol;
                    if (!symbol) return false;
                    if (symbol.flags & 262144 /* TypeParameter */ ) {
                        const declaredType = getDeclaredTypeOfSymbol(symbol);
                        return !(context.mapper && getMappedType(declaredType, context.mapper) !== declaredType);
                    }
                    if (isInJSDoc(existing)) return existingTypeNodeIsNotReferenceOrIsReferenceWithCompatibleTypeArgumentCount(existing, type) && !getIntendedTypeFromJSDocTypeReference(existing) && !!(symbol.flags & 788968 /* Type */ );
                }
                if (isTypeOperatorNode(existing) && existing.operator === 158 /* UniqueKeyword */  && existing.type.kind === 155 /* SymbolKeyword */ ) {
                    const effectiveEnclosingContext = context.enclosingDeclaration && getEnclosingDeclarationIgnoringFakeScope(context.enclosingDeclaration);
                    return !!findAncestor(existing, (n)=>n === effectiveEnclosingContext);
                }
                return true;
            }
            function serializeExistingTypeNode(context, typeNode, addUndefined) {
                const type = getTypeFromTypeNode2(context, typeNode);
                if (addUndefined && !someType(type, (t)=>!!(t.flags & 32768 /* Undefined */ )) && canReuseTypeNode(context, typeNode)) {
                    const clone2 = syntacticNodeBuilder.tryReuseExistingTypeNode(context, typeNode);
                    if (clone2) return factory.createUnionTypeNode([
                        clone2,
                        factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
                    ]);
                }
                return typeToTypeNodeHelper(type, context);
            }
            function symbolTableToDeclarationStatements(symbolTable, context) {
                var _a;
                const serializePropertySymbolForClass = makeSerializePropertySymbol(factory.createPropertyDeclaration, 175 /* MethodDeclaration */ , /*useAccessors*/ true);
                const serializePropertySymbolForInterfaceWorker = makeSerializePropertySymbol((mods, name, question, type)=>factory.createPropertySignature(mods, name, question, type), 174 /* MethodSignature */ , /*useAccessors*/ false);
                const enclosingDeclaration = context.enclosingDeclaration;
                let results = [];
                const visitedSymbols = /* @__PURE__ */ new Set();
                const deferredPrivatesStack = [];
                const oldcontext = context;
                context = (0, _objectSpreadProps._)((0, _objectSpread._)({}, oldcontext), {
                    usedSymbolNames: new Set(oldcontext.usedSymbolNames),
                    remappedSymbolNames: /* @__PURE__ */ new Map(),
                    remappedSymbolReferences: new Map((_a = oldcontext.remappedSymbolReferences) == null ? void 0 : _a.entries()),
                    tracker: void 0
                });
                const tracker = (0, _objectSpreadProps._)((0, _objectSpread._)({}, oldcontext.tracker.inner), {
                    trackSymbol: (sym, decl, meaning)=>{
                        var _a2, _b;
                        if ((_a2 = context.remappedSymbolNames) == null ? void 0 : _a2.has(getSymbolId(sym))) return false;
                        const accessibleResult = isSymbolAccessible(sym, decl, meaning, /*shouldComputeAliasesToMakeVisible*/ false);
                        if (accessibleResult.accessibility === 0 /* Accessible */ ) {
                            const chain = lookupSymbolChainWorker(sym, context, meaning);
                            if (!(sym.flags & 4 /* Property */ )) {
                                const root = chain[0];
                                const contextFile = getSourceFileOfNode(oldcontext.enclosingDeclaration);
                                if (some(root.declarations, (d)=>getSourceFileOfNode(d) === contextFile)) includePrivateSymbol(root);
                            }
                        } else if ((_b = oldcontext.tracker.inner) == null ? void 0 : _b.trackSymbol) return oldcontext.tracker.inner.trackSymbol(sym, decl, meaning);
                        return false;
                    }
                });
                context.tracker = new SymbolTrackerImpl(context, tracker, oldcontext.tracker.moduleResolverHost);
                forEachEntry(symbolTable, (symbol, name)=>{
                    const baseName = unescapeLeadingUnderscores(name);
                    getInternalSymbolName(symbol, baseName);
                });
                let addingDeclare = !context.bundled;
                const exportEquals = symbolTable.get("export=" /* ExportEquals */ );
                if (exportEquals && symbolTable.size > 1 && exportEquals.flags & 2098688 /* Module */ ) {
                    symbolTable = createSymbolTable();
                    symbolTable.set("export=" /* ExportEquals */ , exportEquals);
                }
                visitSymbolTable(symbolTable);
                return mergeRedundantStatements(results);
                function isIdentifierAndNotUndefined(node) {
                    return !!node && node.kind === 80 /* Identifier */ ;
                }
                function getNamesOfDeclaration(statement) {
                    if (isVariableStatement(statement)) return filter(map(statement.declarationList.declarations, getNameOfDeclaration), isIdentifierAndNotUndefined);
                    return filter([
                        getNameOfDeclaration(statement)
                    ], isIdentifierAndNotUndefined);
                }
                function flattenExportAssignedNamespace(statements) {
                    const exportAssignment = find(statements, isExportAssignment);
                    const nsIndex = findIndex(statements, isModuleDeclaration);
                    let ns = nsIndex !== -1 ? statements[nsIndex] : void 0;
                    if (ns && exportAssignment && exportAssignment.isExportEquals && isIdentifier(exportAssignment.expression) && isIdentifier(ns.name) && idText(ns.name) === idText(exportAssignment.expression) && ns.body && isModuleBlock(ns.body)) {
                        const excessExports = filter(statements, (s)=>!!(getEffectiveModifierFlags(s) & 32 /* Export */ ));
                        const name = ns.name;
                        let body = ns.body;
                        if (length(excessExports)) {
                            ns = factory.updateModuleDeclaration(ns, ns.modifiers, ns.name, body = factory.updateModuleBlock(body, factory.createNodeArray([
                                ...ns.body.statements,
                                factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(map(flatMap(excessExports, (e)=>getNamesOfDeclaration(e)), (id)=>factory.createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, id))), /*moduleSpecifier*/ void 0)
                            ])));
                            statements = [
                                ...statements.slice(0, nsIndex),
                                ns,
                                ...statements.slice(nsIndex + 1)
                            ];
                        }
                        if (!find(statements, (s)=>s !== ns && nodeHasName(s, name))) {
                            results = [];
                            const mixinExportFlag = !some(body.statements, (s)=>hasSyntacticModifier(s, 32 /* Export */ ) || isExportAssignment(s) || isExportDeclaration(s));
                            forEach(body.statements, (s)=>{
                                addResult(s, mixinExportFlag ? 32 /* Export */  : 0 /* None */ );
                            });
                            statements = [
                                ...filter(statements, (s)=>s !== ns && s !== exportAssignment),
                                ...results
                            ];
                        }
                    }
                    return statements;
                }
                function mergeExportDeclarations(statements) {
                    const exports2 = filter(statements, (d)=>isExportDeclaration(d) && !d.moduleSpecifier && !!d.exportClause && isNamedExports(d.exportClause));
                    if (length(exports2) > 1) {
                        const nonExports = filter(statements, (d)=>!isExportDeclaration(d) || !!d.moduleSpecifier || !d.exportClause);
                        statements = [
                            ...nonExports,
                            factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(flatMap(exports2, (e)=>cast(e.exportClause, isNamedExports).elements)), /*moduleSpecifier*/ void 0)
                        ];
                    }
                    const reexports = filter(statements, (d)=>isExportDeclaration(d) && !!d.moduleSpecifier && !!d.exportClause && isNamedExports(d.exportClause));
                    if (length(reexports) > 1) {
                        const groups = group(reexports, (decl)=>isStringLiteral(decl.moduleSpecifier) ? ">" + decl.moduleSpecifier.text : ">");
                        if (groups.length !== reexports.length) {
                            for (const group2 of groups)if (group2.length > 1) statements = [
                                ...filter(statements, (s)=>!group2.includes(s)),
                                factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(flatMap(group2, (e)=>cast(e.exportClause, isNamedExports).elements)), group2[0].moduleSpecifier)
                            ];
                        }
                    }
                    return statements;
                }
                function inlineExportModifiers(statements) {
                    const index = findIndex(statements, (d)=>isExportDeclaration(d) && !d.moduleSpecifier && !d.attributes && !!d.exportClause && isNamedExports(d.exportClause));
                    if (index >= 0) {
                        const exportDecl = statements[index];
                        const replacements = mapDefined(exportDecl.exportClause.elements, (e)=>{
                            if (!e.propertyName && e.name.kind !== 11 /* StringLiteral */ ) {
                                const name = e.name;
                                const indices = indicesOf(statements);
                                const associatedIndices = filter(indices, (i)=>nodeHasName(statements[i], name));
                                if (length(associatedIndices) && every(associatedIndices, (i)=>canHaveExportModifier(statements[i]))) {
                                    for (const index2 of associatedIndices)statements[index2] = addExportModifier(statements[index2]);
                                    return void 0;
                                }
                            }
                            return e;
                        });
                        if (!length(replacements)) orderedRemoveItemAt(statements, index);
                        else statements[index] = factory.updateExportDeclaration(exportDecl, exportDecl.modifiers, exportDecl.isTypeOnly, factory.updateNamedExports(exportDecl.exportClause, replacements), exportDecl.moduleSpecifier, exportDecl.attributes);
                    }
                    return statements;
                }
                function mergeRedundantStatements(statements) {
                    statements = flattenExportAssignedNamespace(statements);
                    statements = mergeExportDeclarations(statements);
                    statements = inlineExportModifiers(statements);
                    if (enclosingDeclaration && (isSourceFile(enclosingDeclaration) && isExternalOrCommonJsModule(enclosingDeclaration) || isModuleDeclaration(enclosingDeclaration)) && (!some(statements, isExternalModuleIndicator) || !hasScopeMarker(statements) && some(statements, needsScopeMarker))) statements.push(createEmptyExports(factory));
                    return statements;
                }
                function addExportModifier(node) {
                    const flags = (getEffectiveModifierFlags(node) | 32 /* Export */ ) & -129 /* Ambient */ ;
                    return factory.replaceModifiers(node, flags);
                }
                function removeExportModifier(node) {
                    const flags = getEffectiveModifierFlags(node) & -33 /* Export */ ;
                    return factory.replaceModifiers(node, flags);
                }
                function visitSymbolTable(symbolTable2, suppressNewPrivateContext, propertyAsAlias) {
                    if (!suppressNewPrivateContext) deferredPrivatesStack.push(/* @__PURE__ */ new Map());
                    let i = 0;
                    const symbols = Array.from(symbolTable2.values());
                    for (const symbol of symbols){
                        i++;
                        if (checkTruncationLengthIfExpanding(context) && i + 2 < symbolTable2.size - 1) {
                            context.out.truncated = true;
                            results.push(createTruncationStatement(`... (${symbolTable2.size - i} more ...)`));
                            serializeSymbol(symbols[symbols.length - 1], /*isPrivate*/ false, !!propertyAsAlias);
                            break;
                        }
                        serializeSymbol(symbol, /*isPrivate*/ false, !!propertyAsAlias);
                    }
                    if (!suppressNewPrivateContext) {
                        deferredPrivatesStack[deferredPrivatesStack.length - 1].forEach((symbol)=>{
                            serializeSymbol(symbol, /*isPrivate*/ true, !!propertyAsAlias);
                        });
                        deferredPrivatesStack.pop();
                    }
                }
                function serializeSymbol(symbol, isPrivate, propertyAsAlias) {
                    getPropertiesOfType(getTypeOfSymbol(symbol));
                    const visitedSym = getMergedSymbol(symbol);
                    if (visitedSymbols.has(getSymbolId(visitedSym))) return;
                    visitedSymbols.add(getSymbolId(visitedSym));
                    const skipMembershipCheck = !isPrivate;
                    if (skipMembershipCheck || !!length(symbol.declarations) && some(symbol.declarations, (d)=>!!findAncestor(d, (n)=>n === enclosingDeclaration))) {
                        const scopeCleanup = cloneNodeBuilderContext(context);
                        context.tracker.pushErrorFallbackNode(find(symbol.declarations, (d)=>getSourceFileOfNode(d) === context.enclosingFile));
                        serializeSymbolWorker(symbol, isPrivate, propertyAsAlias);
                        context.tracker.popErrorFallbackNode();
                        scopeCleanup();
                    }
                }
                function serializeSymbolWorker(symbol, isPrivate, propertyAsAlias, escapedSymbolName = symbol.escapedName) {
                    var _a2, _b, _c, _d, _e, _f, _g;
                    const symbolName2 = unescapeLeadingUnderscores(escapedSymbolName);
                    const isDefault = escapedSymbolName === "default" /* Default */ ;
                    if (isPrivate && !(context.flags & 131072 /* AllowAnonymousIdentifier */ ) && isStringANonContextualKeyword(symbolName2) && !isDefault) {
                        context.encounteredError = true;
                        return;
                    }
                    let needsPostExportDefault = isDefault && !!(symbol.flags & -113 /* ExportDoesNotSupportDefaultModifier */  || symbol.flags & 16 /* Function */  && length(getPropertiesOfType(getTypeOfSymbol(symbol)))) && !(symbol.flags & 2097152 /* Alias */ );
                    let needsExportDeclaration = !needsPostExportDefault && !isPrivate && isStringANonContextualKeyword(symbolName2) && !isDefault;
                    if (needsPostExportDefault || needsExportDeclaration) isPrivate = true;
                    const modifierFlags = (!isPrivate ? 32 /* Export */  : 0) | (isDefault && !needsPostExportDefault ? 2048 /* Default */  : 0);
                    const isConstMergedWithNS = symbol.flags & 1536 /* Module */  && symbol.flags & 7 /* Property */  && escapedSymbolName !== "export=" /* ExportEquals */ ;
                    const isConstMergedWithNSPrintableAsSignatureMerge = isConstMergedWithNS && isTypeRepresentableAsFunctionNamespaceMerge(getTypeOfSymbol(symbol), symbol);
                    if (symbol.flags & 8208 /* Method */  || isConstMergedWithNSPrintableAsSignatureMerge) serializeAsFunctionNamespaceMerge(getTypeOfSymbol(symbol), symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                    if (symbol.flags & 524288 /* TypeAlias */ ) serializeTypeAlias(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 98311 /* Accessor */  && escapedSymbolName !== "export=" /* ExportEquals */  && !(symbol.flags & 4194304 /* Prototype */ ) && !(symbol.flags & 32 /* Class */ ) && !(symbol.flags & 8192 /* Method */ ) && !isConstMergedWithNSPrintableAsSignatureMerge) {
                        if (propertyAsAlias) {
                            const createdExport = serializeMaybeAliasAssignment(symbol);
                            if (createdExport) {
                                needsExportDeclaration = false;
                                needsPostExportDefault = false;
                            }
                        } else {
                            const type = getTypeOfSymbol(symbol);
                            const localName = getInternalSymbolName(symbol, symbolName2);
                            if (type.symbol && type.symbol !== symbol && type.symbol.flags & 16 /* Function */  && some(type.symbol.declarations, isFunctionExpressionOrArrowFunction) && (((_a2 = type.symbol.members) == null ? void 0 : _a2.size) || ((_b = type.symbol.exports) == null ? void 0 : _b.size))) {
                                if (!context.remappedSymbolReferences) context.remappedSymbolReferences = /* @__PURE__ */ new Map();
                                context.remappedSymbolReferences.set(getSymbolId(type.symbol), symbol);
                                serializeSymbolWorker(type.symbol, isPrivate, propertyAsAlias, escapedSymbolName);
                                context.remappedSymbolReferences.delete(getSymbolId(type.symbol));
                            } else if (!(symbol.flags & 16 /* Function */ ) && isTypeRepresentableAsFunctionNamespaceMerge(type, symbol)) serializeAsFunctionNamespaceMerge(type, symbol, localName, modifierFlags);
                            else {
                                const flags = !(symbol.flags & 2 /* BlockScopedVariable */ ) ? ((_c = symbol.parent) == null ? void 0 : _c.valueDeclaration) && isSourceFile((_d = symbol.parent) == null ? void 0 : _d.valueDeclaration) ? 2 /* Const */  : void 0 : isConstantVariable(symbol) ? 2 /* Const */  : 1 /* Let */ ;
                                const name = needsPostExportDefault || !(symbol.flags & 4 /* Property */ ) ? localName : getUnusedName(localName, symbol);
                                let textRange = symbol.declarations && find(symbol.declarations, (d)=>isVariableDeclaration(d));
                                if (textRange && isVariableDeclarationList(textRange.parent) && textRange.parent.declarations.length === 1) textRange = textRange.parent.parent;
                                const propertyAccessRequire = (_e = symbol.declarations) == null ? void 0 : _e.find(isPropertyAccessExpression);
                                if (propertyAccessRequire && isBinaryExpression(propertyAccessRequire.parent) && isIdentifier(propertyAccessRequire.parent.right) && ((_f = type.symbol) == null ? void 0 : _f.valueDeclaration) && isSourceFile(type.symbol.valueDeclaration)) {
                                    const alias = localName === propertyAccessRequire.parent.right.escapedText ? void 0 : propertyAccessRequire.parent.right;
                                    var _ref;
                                    context.approximateLength += 12 + ((_ref = (_g = alias == null ? void 0 : alias.escapedText) == null ? void 0 : _g.length) !== null && _ref !== void 0 ? _ref : 0);
                                    addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                                        factory.createExportSpecifier(/*isTypeOnly*/ false, alias, localName)
                                    ])), 0 /* None */ );
                                    context.tracker.trackSymbol(type.symbol, context.enclosingDeclaration, 111551 /* Value */ );
                                } else {
                                    const statement = setTextRange2(context, factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                                        factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, serializeTypeForDeclaration(context, /*declaration*/ void 0, type, symbol))
                                    ], flags)), textRange);
                                    context.approximateLength += 7 + name.length;
                                    addResult(statement, name !== localName ? modifierFlags & -33 /* Export */  : modifierFlags);
                                    if (name !== localName && !isPrivate) {
                                        context.approximateLength += 16 + name.length + localName.length;
                                        addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                                            factory.createExportSpecifier(/*isTypeOnly*/ false, name, localName)
                                        ])), 0 /* None */ );
                                        needsExportDeclaration = false;
                                        needsPostExportDefault = false;
                                    }
                                }
                            }
                        }
                    }
                    if (symbol.flags & 384 /* Enum */ ) serializeEnum(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 32 /* Class */ ) {
                        if (symbol.flags & 4 /* Property */  && symbol.valueDeclaration && isBinaryExpression(symbol.valueDeclaration.parent) && isClassExpression(symbol.valueDeclaration.parent.right)) serializeAsAlias(symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                        else serializeAsClass(symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                    }
                    if (symbol.flags & 1536 /* NamespaceModule */  && (!isConstMergedWithNS || isTypeOnlyNamespace(symbol)) || isConstMergedWithNSPrintableAsSignatureMerge) serializeModule(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 64 /* Interface */  && !(symbol.flags & 32 /* Class */ )) serializeInterface(symbol, symbolName2, modifierFlags);
                    if (symbol.flags & 2097152 /* Alias */ ) serializeAsAlias(symbol, getInternalSymbolName(symbol, symbolName2), modifierFlags);
                    if (symbol.flags & 4 /* Property */  && symbol.escapedName === "export=" /* ExportEquals */ ) serializeMaybeAliasAssignment(symbol);
                    if (symbol.flags & 8388608 /* ExportStar */ ) {
                        if (symbol.declarations) for (const node of symbol.declarations){
                            const resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
                            if (!resolvedModule) continue;
                            const isTypeOnly = node.isTypeOnly;
                            const specifier = getSpecifierForModuleSymbol(resolvedModule, context);
                            context.approximateLength += 17 + specifier.length;
                            addResult(factory.createExportDeclaration(/*modifiers*/ void 0, isTypeOnly, /*exportClause*/ void 0, factory.createStringLiteral(specifier)), 0 /* None */ );
                        }
                    }
                    if (needsPostExportDefault) {
                        const internalSymbolName = getInternalSymbolName(symbol, symbolName2);
                        context.approximateLength += 16 + internalSymbolName.length;
                        addResult(factory.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, factory.createIdentifier(internalSymbolName)), 0 /* None */ );
                    } else if (needsExportDeclaration) {
                        const internalSymbolName = getInternalSymbolName(symbol, symbolName2);
                        context.approximateLength += 22 + symbolName2.length + internalSymbolName.length;
                        addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                            factory.createExportSpecifier(/*isTypeOnly*/ false, internalSymbolName, symbolName2)
                        ])), 0 /* None */ );
                    }
                }
                function includePrivateSymbol(symbol) {
                    if (some(symbol.declarations, isPartOfParameterDeclaration)) return;
                    Debug.assertIsDefined(deferredPrivatesStack[deferredPrivatesStack.length - 1]);
                    getUnusedName(unescapeLeadingUnderscores(symbol.escapedName), symbol);
                    const isExternalImportAlias = !!(symbol.flags & 2097152 /* Alias */ ) && !some(symbol.declarations, (d)=>!!findAncestor(d, isExportDeclaration) || isNamespaceExport(d) || isImportEqualsDeclaration(d) && !isExternalModuleReference(d.moduleReference));
                    deferredPrivatesStack[isExternalImportAlias ? 0 : deferredPrivatesStack.length - 1].set(getSymbolId(symbol), symbol);
                }
                function isExportingScope(enclosingDeclaration2) {
                    return isSourceFile(enclosingDeclaration2) && (isExternalOrCommonJsModule(enclosingDeclaration2) || isJsonSourceFile(enclosingDeclaration2)) || isAmbientModule(enclosingDeclaration2) && !isGlobalScopeAugmentation(enclosingDeclaration2);
                }
                function addResult(node, additionalModifierFlags) {
                    if (canHaveModifiers(node)) {
                        const oldModifierFlags = getEffectiveModifierFlags(node);
                        let newModifierFlags = 0 /* None */ ;
                        const enclosingDeclaration2 = context.enclosingDeclaration && (isJSDocTypeAlias(context.enclosingDeclaration) ? getSourceFileOfNode(context.enclosingDeclaration) : context.enclosingDeclaration);
                        if (additionalModifierFlags & 32 /* Export */  && enclosingDeclaration2 && (isExportingScope(enclosingDeclaration2) || isModuleDeclaration(enclosingDeclaration2)) && canHaveExportModifier(node)) newModifierFlags |= 32 /* Export */ ;
                        if (addingDeclare && !(newModifierFlags & 32 /* Export */ ) && (!enclosingDeclaration2 || !(enclosingDeclaration2.flags & 33554432 /* Ambient */ )) && (isEnumDeclaration(node) || isVariableStatement(node) || isFunctionDeclaration(node) || isClassDeclaration(node) || isModuleDeclaration(node))) newModifierFlags |= 128 /* Ambient */ ;
                        if (additionalModifierFlags & 2048 /* Default */  && (isClassDeclaration(node) || isInterfaceDeclaration(node) || isFunctionDeclaration(node))) newModifierFlags |= 2048 /* Default */ ;
                        if (newModifierFlags) node = factory.replaceModifiers(node, newModifierFlags | oldModifierFlags);
                        context.approximateLength += modifiersLength(newModifierFlags | oldModifierFlags);
                    }
                    results.push(node);
                }
                function serializeTypeAlias(symbol, symbolName2, modifierFlags) {
                    var _a2;
                    const aliasType = getDeclaredTypeOfTypeAlias(symbol);
                    const typeParams = getSymbolLinks(symbol).typeParameters;
                    const typeParamDecls = map(typeParams, (p)=>typeParameterToDeclaration(p, context));
                    const jsdocAliasDecl = (_a2 = symbol.declarations) == null ? void 0 : _a2.find(isJSDocTypeAlias);
                    const commentText = getTextOfJSDocComment(jsdocAliasDecl ? jsdocAliasDecl.comment || jsdocAliasDecl.parent.comment : void 0);
                    const restoreFlags = saveRestoreFlags(context);
                    context.flags |= 8388608 /* InTypeAlias */ ;
                    const oldEnclosingDecl = context.enclosingDeclaration;
                    context.enclosingDeclaration = jsdocAliasDecl;
                    const typeNode = jsdocAliasDecl && jsdocAliasDecl.typeExpression && isJSDocTypeExpression(jsdocAliasDecl.typeExpression) && syntacticNodeBuilder.tryReuseExistingTypeNode(context, jsdocAliasDecl.typeExpression.type) || typeToTypeNodeHelper(aliasType, context);
                    const internalSymbolName = getInternalSymbolName(symbol, symbolName2);
                    var _ref;
                    context.approximateLength += 8 + ((_ref = commentText == null ? void 0 : commentText.length) !== null && _ref !== void 0 ? _ref : 0) + internalSymbolName.length;
                    addResult(setSyntheticLeadingComments(factory.createTypeAliasDeclaration(/*modifiers*/ void 0, internalSymbolName, typeParamDecls, typeNode), !commentText ? [] : [
                        {
                            kind: 3 /* MultiLineCommentTrivia */ ,
                            text: "*\n * " + commentText.replace(/\n/g, "\n * ") + "\n ",
                            pos: -1,
                            end: -1,
                            hasTrailingNewLine: true
                        }
                    ]), modifierFlags);
                    restoreFlags();
                    context.enclosingDeclaration = oldEnclosingDecl;
                }
                function serializeInterface(symbol, symbolName2, modifierFlags) {
                    const internalSymbolName = getInternalSymbolName(symbol, symbolName2);
                    context.approximateLength += 14 + internalSymbolName.length;
                    const interfaceType = getDeclaredTypeOfClassOrInterface(symbol);
                    const localParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                    const typeParamDecls = map(localParams, (p)=>typeParameterToDeclaration(p, context));
                    const baseTypes = getBaseTypes(interfaceType);
                    const baseType = length(baseTypes) ? getIntersectionType(baseTypes) : void 0;
                    const members = serializePropertySymbolsForClassOrInterface(getPropertiesOfType(interfaceType), /*isClass*/ false, baseType);
                    const callSignatures = serializeSignatures(0 /* Call */ , interfaceType, baseType, 180 /* CallSignature */ );
                    const constructSignatures = serializeSignatures(1 /* Construct */ , interfaceType, baseType, 181 /* ConstructSignature */ );
                    const indexSignatures = serializeIndexSignatures(interfaceType, baseType);
                    const heritageClauses = !length(baseTypes) ? void 0 : [
                        factory.createHeritageClause(96 /* ExtendsKeyword */ , mapDefined(baseTypes, (b)=>trySerializeAsTypeReference(b, 111551 /* Value */ )))
                    ];
                    addResult(factory.createInterfaceDeclaration(/*modifiers*/ void 0, internalSymbolName, typeParamDecls, heritageClauses, [
                        ...indexSignatures,
                        ...constructSignatures,
                        ...callSignatures,
                        ...members
                    ]), modifierFlags);
                }
                function serializePropertySymbolsForClassOrInterface(props, isClass, baseType, isStatic2) {
                    const elements = [];
                    let i = 0;
                    for (const prop of props){
                        i++;
                        if (checkTruncationLengthIfExpanding(context) && i + 2 < props.length - 1) {
                            context.out.truncated = true;
                            const placeholder = createTruncationProperty(`... ${props.length - i} more ... `, isClass);
                            elements.push(placeholder);
                            const result2 = isClass ? serializePropertySymbolForClass(props[props.length - 1], isStatic2, baseType) : serializePropertySymbolForInterface(props[props.length - 1], baseType);
                            if (isArray(result2)) elements.push(...result2);
                            else elements.push(result2);
                            break;
                        }
                        context.approximateLength += 1;
                        const result = isClass ? serializePropertySymbolForClass(prop, isStatic2, baseType) : serializePropertySymbolForInterface(prop, baseType);
                        if (isArray(result)) elements.push(...result);
                        else elements.push(result);
                    }
                    return elements;
                }
                function createTruncationProperty(dotDotDotText, isClass) {
                    if (context.flags & 1 /* NoTruncation */ ) return addSyntheticLeadingComment(factory.createNotEmittedTypeElement(), 3 /* MultiLineCommentTrivia */ , dotDotDotText);
                    return isClass ? factory.createPropertyDeclaration(/*modifiers*/ void 0, dotDotDotText, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0) : factory.createPropertySignature(/*modifiers*/ void 0, dotDotDotText, /*questionToken*/ void 0, /*type*/ void 0);
                }
                function getNamespaceMembersForSerialization(symbol) {
                    let exports2 = arrayFrom(getExportsOfSymbol(symbol).values());
                    const merged = getMergedSymbol(symbol);
                    if (merged !== symbol) {
                        const membersSet = new Set(exports2);
                        for (const exported of getExportsOfSymbol(merged).values())if (!(getSymbolFlags(resolveSymbol(exported)) & 111551 /* Value */ )) membersSet.add(exported);
                        exports2 = arrayFrom(membersSet);
                    }
                    return filter(exports2, (m)=>isNamespaceMember(m) && isIdentifierText(m.escapedName, 99 /* ESNext */ ));
                }
                function isTypeOnlyNamespace(symbol) {
                    return every(getNamespaceMembersForSerialization(symbol), (m)=>!(getSymbolFlags(resolveSymbol(m)) & 111551 /* Value */ ));
                }
                function serializeModule(symbol, symbolName2, modifierFlags) {
                    const members = getNamespaceMembersForSerialization(symbol);
                    const expanding = isExpanding(context);
                    const locationMap = arrayToMultiMap(members, (m)=>m.parent && m.parent === symbol || expanding ? "real" : "merged");
                    const realMembers = locationMap.get("real") || emptyArray;
                    const mergedMembers = locationMap.get("merged") || emptyArray;
                    if (length(realMembers) || expanding) {
                        let localName;
                        if (expanding) {
                            const oldFlags = context.flags;
                            context.flags |= 514 /* UseOnlyExternalAliasing */ ;
                            localName = symbolToNode(symbol, context, /*meaning*/ -1 /* All */ );
                            context.flags = oldFlags;
                        } else {
                            const localText = getInternalSymbolName(symbol, symbolName2);
                            localName = factory.createIdentifier(localText);
                            context.approximateLength += localText.length;
                        }
                        serializeAsNamespaceDeclaration(realMembers, localName, modifierFlags, !!(symbol.flags & 67108880 /* Assignment */ ));
                    }
                    if (length(mergedMembers)) {
                        const containingFile = getSourceFileOfNode(context.enclosingDeclaration);
                        const localName = getInternalSymbolName(symbol, symbolName2);
                        const nsBody = factory.createModuleBlock([
                            factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(mapDefined(filter(mergedMembers, (n)=>n.escapedName !== "export=" /* ExportEquals */ ), (s)=>{
                                var _a2, _b;
                                const name = unescapeLeadingUnderscores(s.escapedName);
                                const localName2 = getInternalSymbolName(s, name);
                                const aliasDecl = s.declarations && getDeclarationOfAliasSymbol(s);
                                if (containingFile && (aliasDecl ? containingFile !== getSourceFileOfNode(aliasDecl) : !some(s.declarations, (d)=>getSourceFileOfNode(d) === containingFile))) {
                                    (_b = (_a2 = context.tracker) == null ? void 0 : _a2.reportNonlocalAugmentation) == null || _b.call(_a2, containingFile, symbol, s);
                                    return void 0;
                                }
                                const target = aliasDecl && getTargetOfAliasDeclaration(aliasDecl, /*dontRecursivelyResolve*/ true);
                                includePrivateSymbol(target || s);
                                const targetName = target ? getInternalSymbolName(target, unescapeLeadingUnderscores(target.escapedName)) : localName2;
                                return factory.createExportSpecifier(/*isTypeOnly*/ false, name === targetName ? void 0 : targetName, name);
                            })))
                        ]);
                        addResult(factory.createModuleDeclaration(/*modifiers*/ void 0, factory.createIdentifier(localName), nsBody, 32 /* Namespace */ ), 0 /* None */ );
                    }
                }
                function serializeEnum(symbol, symbolName2, modifierFlags) {
                    const internalSymbolName = getInternalSymbolName(symbol, symbolName2);
                    context.approximateLength += 9 + internalSymbolName.length;
                    const members = [];
                    const memberProps = filter(getPropertiesOfType(getTypeOfSymbol(symbol)), (p)=>!!(p.flags & 8 /* EnumMember */ ));
                    let i = 0;
                    for (const p of memberProps){
                        i++;
                        if (checkTruncationLengthIfExpanding(context) && i + 2 < memberProps.length - 1) {
                            context.out.truncated = true;
                            members.push(factory.createEnumMember(` ... ${memberProps.length - i} more ... `));
                            const last2 = memberProps[memberProps.length - 1];
                            const initializedValue = last2.declarations && last2.declarations[0] && isEnumMember(last2.declarations[0]) ? getConstantValue2(last2.declarations[0]) : void 0;
                            const initializer2 = initializedValue === void 0 ? void 0 : typeof initializedValue === "string" ? factory.createStringLiteral(initializedValue) : factory.createNumericLiteral(initializedValue);
                            const memberName2 = unescapeLeadingUnderscores(last2.escapedName);
                            const member2 = factory.createEnumMember(memberName2, initializer2);
                            members.push(member2);
                            break;
                        }
                        const memberDecl = p.declarations && p.declarations[0] && isEnumMember(p.declarations[0]) ? p.declarations[0] : void 0;
                        let initializer;
                        let initializerLength;
                        if (isExpanding(context) && memberDecl && memberDecl.initializer) {
                            initializer = getSynthesizedDeepClone(memberDecl.initializer);
                            initializerLength = memberDecl.initializer.end - memberDecl.initializer.pos;
                        } else {
                            const initializedValue = memberDecl && getConstantValue2(memberDecl);
                            initializer = initializedValue === void 0 ? void 0 : typeof initializedValue === "string" ? factory.createStringLiteral(initializedValue) : factory.createNumericLiteral(initializedValue);
                            var _ref;
                            initializerLength = (_ref = initializer == null ? void 0 : initializer.text.length) !== null && _ref !== void 0 ? _ref : 0;
                        }
                        const memberName = unescapeLeadingUnderscores(p.escapedName);
                        context.approximateLength += 4 + memberName.length + initializerLength;
                        const member = factory.createEnumMember(memberName, initializer);
                        members.push(member);
                    }
                    addResult(factory.createEnumDeclaration(factory.createModifiersFromModifierFlags(isConstEnumSymbol(symbol) ? 4096 /* Const */  : 0), internalSymbolName, members), modifierFlags);
                }
                function serializeAsFunctionNamespaceMerge(type, symbol, localName, modifierFlags) {
                    const signatures = getSignaturesOfType(type, 0 /* Call */ );
                    for (const sig of signatures){
                        context.approximateLength += 1;
                        const decl = signatureToSignatureDeclarationHelper(sig, 263 /* FunctionDeclaration */ , context, {
                            name: factory.createIdentifier(localName)
                        });
                        addResult(setTextRange2(context, decl, getSignatureTextRangeLocation(sig)), modifierFlags);
                    }
                    if (!(symbol.flags & 1536 /* NamespaceModule */  && !!symbol.exports && !!symbol.exports.size)) {
                        const props = filter(getPropertiesOfType(type), isNamespaceMember);
                        context.approximateLength += localName.length;
                        serializeAsNamespaceDeclaration(props, factory.createIdentifier(localName), modifierFlags, /*suppressNewPrivateContext*/ true);
                    }
                }
                function createTruncationStatement(dotDotDotText) {
                    if (context.flags & 1 /* NoTruncation */ ) return addSyntheticLeadingComment(factory.createEmptyStatement(), 3 /* MultiLineCommentTrivia */ , dotDotDotText);
                    return factory.createExpressionStatement(factory.createIdentifier(dotDotDotText));
                }
                function getSignatureTextRangeLocation(signature) {
                    if (signature.declaration && signature.declaration.parent) {
                        if (isBinaryExpression(signature.declaration.parent) && getAssignmentDeclarationKind(signature.declaration.parent) === 5 /* Property */ ) return signature.declaration.parent;
                        if (isVariableDeclaration(signature.declaration.parent) && signature.declaration.parent.parent) return signature.declaration.parent.parent;
                    }
                    return signature.declaration;
                }
                function serializeAsNamespaceDeclaration(props, localName, modifierFlags, suppressNewPrivateContext) {
                    const nodeFlags = isIdentifier(localName) ? 32 /* Namespace */  : 0 /* None */ ;
                    const expanding = isExpanding(context);
                    if (length(props)) {
                        context.approximateLength += 14;
                        const localVsRemoteMap = arrayToMultiMap(props, (p)=>!length(p.declarations) || some(p.declarations, (d)=>getSourceFileOfNode(d) === getSourceFileOfNode(context.enclosingDeclaration)) || expanding ? "local" : "remote");
                        const localProps = localVsRemoteMap.get("local") || emptyArray;
                        let fakespace = parseNodeFactory.createModuleDeclaration(/*modifiers*/ void 0, localName, factory.createModuleBlock([]), nodeFlags);
                        setParent(fakespace, enclosingDeclaration);
                        fakespace.locals = createSymbolTable(props);
                        fakespace.symbol = props[0].parent;
                        const oldResults = results;
                        results = [];
                        const oldAddingDeclare = addingDeclare;
                        addingDeclare = false;
                        const subcontext = (0, _objectSpreadProps._)((0, _objectSpread._)({}, context), {
                            enclosingDeclaration: fakespace
                        });
                        const oldContext = context;
                        context = subcontext;
                        visitSymbolTable(createSymbolTable(localProps), suppressNewPrivateContext, /*propertyAsAlias*/ true);
                        context = oldContext;
                        addingDeclare = oldAddingDeclare;
                        const declarations = results;
                        results = oldResults;
                        const defaultReplaced = map(declarations, (d)=>isExportAssignment(d) && !d.isExportEquals && isIdentifier(d.expression) ? factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                                factory.createExportSpecifier(/*isTypeOnly*/ false, d.expression, factory.createIdentifier("default" /* Default */ ))
                            ])) : d);
                        const exportModifierStripped = every(defaultReplaced, (d)=>hasSyntacticModifier(d, 32 /* Export */ )) ? map(defaultReplaced, removeExportModifier) : defaultReplaced;
                        fakespace = factory.updateModuleDeclaration(fakespace, fakespace.modifiers, fakespace.name, factory.createModuleBlock(exportModifierStripped));
                        addResult(fakespace, modifierFlags);
                    } else if (expanding) {
                        context.approximateLength += 14;
                        addResult(factory.createModuleDeclaration(/*modifiers*/ void 0, localName, factory.createModuleBlock([]), nodeFlags), modifierFlags);
                    }
                }
                function isNamespaceMember(p) {
                    return !!(p.flags & 2887656 /* Alias */ ) || !(p.flags & 4194304 /* Prototype */  || p.escapedName === "prototype" || p.valueDeclaration && isStatic(p.valueDeclaration) && isClassLike(p.valueDeclaration.parent));
                }
                function sanitizeJSDocImplements(clauses) {
                    const result = mapDefined(clauses, (e)=>{
                        const oldEnclosing = context.enclosingDeclaration;
                        context.enclosingDeclaration = e;
                        let expr = e.expression;
                        if (isEntityNameExpression(expr)) {
                            if (isIdentifier(expr) && idText(expr) === "") return cleanup(/*result*/ void 0);
                            let introducesError;
                            ({ introducesError, node: expr } = trackExistingEntityName(expr, context));
                            if (introducesError) return cleanup(/*result*/ void 0);
                        }
                        return cleanup(factory.createExpressionWithTypeArguments(expr, map(e.typeArguments, (a)=>syntacticNodeBuilder.tryReuseExistingTypeNode(context, a) || typeToTypeNodeHelper(getTypeFromTypeNode2(context, a), context))));
                        function cleanup(result2) {
                            context.enclosingDeclaration = oldEnclosing;
                            return result2;
                        }
                    });
                    if (result.length === clauses.length) return result;
                    return void 0;
                }
                function serializeAsClass(symbol, localName, modifierFlags) {
                    var _a2, _b;
                    context.approximateLength += 9 + localName.length;
                    const originalDecl = (_a2 = symbol.declarations) == null ? void 0 : _a2.find(isClassLike);
                    const oldEnclosing = context.enclosingDeclaration;
                    context.enclosingDeclaration = originalDecl || oldEnclosing;
                    const localParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                    const typeParamDecls = map(localParams, (p)=>typeParameterToDeclaration(p, context));
                    forEach(localParams, (p)=>context.approximateLength += symbolName(p.symbol).length);
                    const classType = getTypeWithThisArgument(getDeclaredTypeOfClassOrInterface(symbol));
                    const baseTypes = getBaseTypes(classType);
                    const originalImplements = originalDecl && getEffectiveImplementsTypeNodes(originalDecl);
                    const implementsExpressions = originalImplements && sanitizeJSDocImplements(originalImplements) || mapDefined(getImplementsTypes(classType), serializeImplementedType);
                    const staticType = getTypeOfSymbol(symbol);
                    const isClass = !!((_b = staticType.symbol) == null ? void 0 : _b.valueDeclaration) && isClassLike(staticType.symbol.valueDeclaration);
                    const staticBaseType = isClass ? getBaseConstructorTypeOfClass(staticType) : anyType;
                    context.approximateLength += (length(baseTypes) ? 8 : 0) + (length(implementsExpressions) ? 11 : 0);
                    const heritageClauses = [
                        ...!length(baseTypes) ? [] : [
                            factory.createHeritageClause(96 /* ExtendsKeyword */ , map(baseTypes, (b)=>serializeBaseType(b, staticBaseType, localName)))
                        ],
                        ...!length(implementsExpressions) ? [] : [
                            factory.createHeritageClause(119 /* ImplementsKeyword */ , implementsExpressions)
                        ]
                    ];
                    const symbolProps = getNonInheritedProperties(classType, baseTypes, getPropertiesOfType(classType));
                    const publicSymbolProps = filter(symbolProps, (s)=>!isHashPrivate(s));
                    const hasPrivateIdentifier = some(symbolProps, isHashPrivate);
                    const privateProperties = hasPrivateIdentifier ? isExpanding(context) ? serializePropertySymbolsForClassOrInterface(filter(symbolProps, isHashPrivate), /*isClass*/ true, baseTypes[0], /*isStatic*/ false) : [
                        factory.createPropertyDeclaration(/*modifiers*/ void 0, factory.createPrivateIdentifier("#private"), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
                    ] : emptyArray;
                    if (hasPrivateIdentifier && !isExpanding(context)) context.approximateLength += 9;
                    const publicProperties = serializePropertySymbolsForClassOrInterface(publicSymbolProps, /*isClass*/ true, baseTypes[0], /*isStatic*/ false);
                    const staticMembers = serializePropertySymbolsForClassOrInterface(filter(getPropertiesOfType(staticType), (p)=>!(p.flags & 4194304 /* Prototype */ ) && p.escapedName !== "prototype" && !isNamespaceMember(p)), /*isClass*/ true, staticBaseType, /*isStatic*/ true);
                    const isNonConstructableClassLikeInJsFile = !isClass && !!symbol.valueDeclaration && isInJSFile(symbol.valueDeclaration) && !some(getSignaturesOfType(staticType, 1 /* Construct */ ));
                    if (isNonConstructableClassLikeInJsFile) context.approximateLength += 21;
                    const constructors = isNonConstructableClassLikeInJsFile ? [
                        factory.createConstructorDeclaration(factory.createModifiersFromModifierFlags(2 /* Private */ ), [], /*body*/ void 0)
                    ] : serializeSignatures(1 /* Construct */ , staticType, staticBaseType, 177 /* Constructor */ );
                    const indexSignatures = serializeIndexSignatures(classType, baseTypes[0]);
                    context.enclosingDeclaration = oldEnclosing;
                    addResult(setTextRange2(context, factory.createClassDeclaration(/*modifiers*/ void 0, localName, typeParamDecls, heritageClauses, [
                        ...indexSignatures,
                        ...staticMembers,
                        ...constructors,
                        ...publicProperties,
                        ...privateProperties
                    ]), symbol.declarations && filter(symbol.declarations, (d)=>isClassDeclaration(d) || isClassExpression(d))[0]), modifierFlags);
                }
                function getSomeTargetNameFromDeclarations(declarations) {
                    return firstDefined(declarations, (d)=>{
                        if (isImportSpecifier(d) || isExportSpecifier(d)) return moduleExportNameTextUnescaped(d.propertyName || d.name);
                        if (isBinaryExpression(d) || isExportAssignment(d)) {
                            const expression = isExportAssignment(d) ? d.expression : d.right;
                            if (isPropertyAccessExpression(expression)) return idText(expression.name);
                        }
                        if (isAliasSymbolDeclaration(d)) {
                            const name = getNameOfDeclaration(d);
                            if (name && isIdentifier(name)) return idText(name);
                        }
                        return void 0;
                    });
                }
                function serializeAsAlias(symbol, localName, modifierFlags) {
                    var _a2, _b, _c, _d, _e;
                    const node = getDeclarationOfAliasSymbol(symbol);
                    if (!node) return Debug.fail();
                    const target = getMergedSymbol(getTargetOfAliasDeclaration(node, /*dontRecursivelyResolve*/ true));
                    if (!target) return;
                    let verbatimTargetName = isShorthandAmbientModuleSymbol(target) && getSomeTargetNameFromDeclarations(symbol.declarations) || unescapeLeadingUnderscores(target.escapedName);
                    if (verbatimTargetName === "export=" /* ExportEquals */  && allowSyntheticDefaultImports) verbatimTargetName = "default" /* Default */ ;
                    const targetName = getInternalSymbolName(target, verbatimTargetName);
                    includePrivateSymbol(target);
                    switch(node.kind){
                        case 209 /* BindingElement */ :
                            if (((_b = (_a2 = node.parent) == null ? void 0 : _a2.parent) == null ? void 0 : _b.kind) === 261 /* VariableDeclaration */ ) {
                                const specifier2 = getSpecifierForModuleSymbol(target.parent || target, context);
                                const { propertyName } = node;
                                const propertyNameText = propertyName && isIdentifier(propertyName) ? idText(propertyName) : void 0;
                                var _ref;
                                context.approximateLength += 24 + localName.length + specifier2.length + ((_ref = propertyNameText == null ? void 0 : propertyNameText.length) !== null && _ref !== void 0 ? _ref : 0);
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*phaseModifier*/ void 0, /*name*/ void 0, factory.createNamedImports([
                                    factory.createImportSpecifier(/*isTypeOnly*/ false, propertyNameText ? factory.createIdentifier(propertyNameText) : void 0, factory.createIdentifier(localName))
                                ])), factory.createStringLiteral(specifier2), /*attributes*/ void 0), 0 /* None */ );
                                break;
                            }
                            Debug.failBadSyntaxKind(((_c = node.parent) == null ? void 0 : _c.parent) || node, "Unhandled binding element grandparent kind in declaration serialization");
                            break;
                        case 305 /* ShorthandPropertyAssignment */ :
                            if (((_e = (_d = node.parent) == null ? void 0 : _d.parent) == null ? void 0 : _e.kind) === 227 /* BinaryExpression */ ) serializeExportSpecifier(unescapeLeadingUnderscores(symbol.escapedName), targetName);
                            break;
                        case 261 /* VariableDeclaration */ :
                            if (isPropertyAccessExpression(node.initializer)) {
                                const initializer = node.initializer;
                                const uniqueName = factory.createUniqueName(localName);
                                const specifier2 = getSpecifierForModuleSymbol(target.parent || target, context);
                                context.approximateLength += 22 + specifier2.length + idText(uniqueName).length;
                                addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, uniqueName, factory.createExternalModuleReference(factory.createStringLiteral(specifier2))), 0 /* None */ );
                                context.approximateLength += 12 + localName.length + idText(uniqueName).length + idText(initializer.name).length;
                                addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createIdentifier(localName), factory.createQualifiedName(uniqueName, initializer.name)), modifierFlags);
                                break;
                            }
                        // else fall through and treat commonjs require just like import=
                        case 272 /* ImportEqualsDeclaration */ :
                            if (target.escapedName === "export=" /* ExportEquals */  && some(target.declarations, (d)=>isSourceFile(d) && isJsonSourceFile(d))) {
                                serializeMaybeAliasAssignment(symbol);
                                break;
                            }
                            const isLocalImport = !(target.flags & 512 /* ValueModule */ ) && !isVariableDeclaration(node);
                            context.approximateLength += 11 + localName.length + unescapeLeadingUnderscores(target.escapedName).length;
                            addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createIdentifier(localName), isLocalImport ? symbolToName(target, context, -1 /* All */ , /*expectsIdentifier*/ false) : factory.createExternalModuleReference(factory.createStringLiteral(getSpecifierForModuleSymbol(target, context)))), isLocalImport ? modifierFlags : 0 /* None */ );
                            break;
                        case 271 /* NamespaceExportDeclaration */ :
                            addResult(factory.createNamespaceExportDeclaration(idText(node.name)), 0 /* None */ );
                            break;
                        case 274 /* ImportClause */ :
                            {
                                const generatedSpecifier = getSpecifierForModuleSymbol(target.parent || target, context);
                                const specifier2 = context.bundled ? factory.createStringLiteral(generatedSpecifier) : node.parent.moduleSpecifier;
                                const attributes = isImportDeclaration(node.parent) ? node.parent.attributes : void 0;
                                const isTypeOnly = isJSDocImportTag(node.parent);
                                context.approximateLength += 14 + localName.length + 3 + (isTypeOnly ? 4 : 0);
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/* phaseModifier */ isTypeOnly ? 156 /* TypeKeyword */  : void 0, factory.createIdentifier(localName), /*namedBindings*/ void 0), specifier2, attributes), 0 /* None */ );
                                break;
                            }
                        case 275 /* NamespaceImport */ :
                            {
                                const generatedSpecifier = getSpecifierForModuleSymbol(target.parent || target, context);
                                const specifier2 = context.bundled ? factory.createStringLiteral(generatedSpecifier) : node.parent.parent.moduleSpecifier;
                                const isTypeOnly = isJSDocImportTag(node.parent.parent);
                                context.approximateLength += 19 + localName.length + 3 + (isTypeOnly ? 4 : 0);
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/* phaseModifier */ isTypeOnly ? 156 /* TypeKeyword */  : void 0, /*name*/ void 0, factory.createNamespaceImport(factory.createIdentifier(localName))), specifier2, node.parent.attributes), 0 /* None */ );
                                break;
                            }
                        case 281 /* NamespaceExport */ :
                            context.approximateLength += 19 + localName.length + 3;
                            addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamespaceExport(factory.createIdentifier(localName)), factory.createStringLiteral(getSpecifierForModuleSymbol(target, context))), 0 /* None */ );
                            break;
                        case 277 /* ImportSpecifier */ :
                            {
                                const generatedSpecifier = getSpecifierForModuleSymbol(target.parent || target, context);
                                const specifier2 = context.bundled ? factory.createStringLiteral(generatedSpecifier) : node.parent.parent.parent.moduleSpecifier;
                                const isTypeOnly = isJSDocImportTag(node.parent.parent.parent);
                                context.approximateLength += 19 + localName.length + 3 + (isTypeOnly ? 4 : 0);
                                addResult(factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/* phaseModifier */ isTypeOnly ? 156 /* TypeKeyword */  : void 0, /*name*/ void 0, factory.createNamedImports([
                                    factory.createImportSpecifier(/*isTypeOnly*/ false, localName !== verbatimTargetName ? factory.createIdentifier(verbatimTargetName) : void 0, factory.createIdentifier(localName))
                                ])), specifier2, node.parent.parent.parent.attributes), 0 /* None */ );
                                break;
                            }
                        case 282 /* ExportSpecifier */ :
                            const specifier = node.parent.parent.moduleSpecifier;
                            if (specifier) {
                                const propertyName = node.propertyName;
                                if (propertyName && moduleExportNameIsDefault(propertyName)) verbatimTargetName = "default" /* Default */ ;
                            }
                            serializeExportSpecifier(unescapeLeadingUnderscores(symbol.escapedName), specifier ? verbatimTargetName : targetName, specifier && isStringLiteralLike(specifier) ? factory.createStringLiteral(specifier.text) : void 0);
                            break;
                        case 278 /* ExportAssignment */ :
                            serializeMaybeAliasAssignment(symbol);
                            break;
                        case 227 /* BinaryExpression */ :
                        case 212 /* PropertyAccessExpression */ :
                        case 213 /* ElementAccessExpression */ :
                            if (symbol.escapedName === "default" /* Default */  || symbol.escapedName === "export=" /* ExportEquals */ ) serializeMaybeAliasAssignment(symbol);
                            else serializeExportSpecifier(localName, targetName);
                            break;
                        default:
                            return Debug.failBadSyntaxKind(node, "Unhandled alias declaration kind in symbol serializer!");
                    }
                }
                function serializeExportSpecifier(localName, targetName, specifier) {
                    context.approximateLength += 16 + localName.length + (localName !== targetName ? targetName.length : 0);
                    addResult(factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                        factory.createExportSpecifier(/*isTypeOnly*/ false, localName !== targetName ? targetName : void 0, localName)
                    ]), specifier), 0 /* None */ );
                }
                function serializeMaybeAliasAssignment(symbol) {
                    var _a2;
                    if (symbol.flags & 4194304 /* Prototype */ ) return false;
                    const name = unescapeLeadingUnderscores(symbol.escapedName);
                    const isExportEquals = name === "export=" /* ExportEquals */ ;
                    const isDefault = name === "default" /* Default */ ;
                    const isExportAssignmentCompatibleSymbolName = isExportEquals || isDefault;
                    const aliasDecl = symbol.declarations && getDeclarationOfAliasSymbol(symbol);
                    const target = aliasDecl && getTargetOfAliasDeclaration(aliasDecl, /*dontRecursivelyResolve*/ true);
                    if (target && length(target.declarations) && some(target.declarations, (d)=>getSourceFileOfNode(d) === getSourceFileOfNode(enclosingDeclaration))) {
                        const expr = aliasDecl && (isExportAssignment(aliasDecl) || isBinaryExpression(aliasDecl) ? getExportAssignmentExpression(aliasDecl) : getPropertyAssignmentAliasLikeExpression(aliasDecl));
                        const first2 = expr && isEntityNameExpression(expr) ? getFirstNonModuleExportsIdentifier(expr) : void 0;
                        const referenced = first2 && resolveEntityName(first2, -1 /* All */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, enclosingDeclaration);
                        if (referenced || target) includePrivateSymbol(referenced || target);
                        const prevDisableTrackSymbol = context.tracker.disableTrackSymbol;
                        context.tracker.disableTrackSymbol = true;
                        if (isExportAssignmentCompatibleSymbolName) {
                            context.approximateLength += 10;
                            results.push(factory.createExportAssignment(/*modifiers*/ void 0, isExportEquals, symbolToExpression(target, context, -1 /* All */ )));
                        } else {
                            if (first2 === expr && first2) serializeExportSpecifier(name, idText(first2));
                            else if (expr && isClassExpression(expr)) serializeExportSpecifier(name, getInternalSymbolName(target, symbolName(target)));
                            else {
                                const varName = getUnusedName(name, symbol);
                                context.approximateLength += varName.length + 10;
                                addResult(factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createIdentifier(varName), symbolToName(target, context, -1 /* All */ , /*expectsIdentifier*/ false)), 0 /* None */ );
                                serializeExportSpecifier(name, varName);
                            }
                        }
                        context.tracker.disableTrackSymbol = prevDisableTrackSymbol;
                        return true;
                    } else {
                        const varName = getUnusedName(name, symbol);
                        const typeToSerialize = getWidenedType(getTypeOfSymbol(getMergedSymbol(symbol)));
                        if (isTypeRepresentableAsFunctionNamespaceMerge(typeToSerialize, symbol)) serializeAsFunctionNamespaceMerge(typeToSerialize, symbol, varName, isExportAssignmentCompatibleSymbolName ? 0 /* None */  : 32 /* Export */ );
                        else {
                            const flags = ((_a2 = context.enclosingDeclaration) == null ? void 0 : _a2.kind) === 268 /* ModuleDeclaration */  && (!(symbol.flags & 98304 /* Accessor */ ) || symbol.flags & 65536 /* SetAccessor */ ) ? 1 /* Let */  : 2 /* Const */ ;
                            context.approximateLength += varName.length + 5;
                            const statement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                                factory.createVariableDeclaration(varName, /*exclamationToken*/ void 0, serializeTypeForDeclaration(context, /*declaration*/ void 0, typeToSerialize, symbol))
                            ], flags));
                            addResult(statement, target && target.flags & 4 /* Property */  && target.escapedName === "export=" /* ExportEquals */  ? 128 /* Ambient */  : name === varName ? 32 /* Export */  : 0 /* None */ );
                        }
                        if (isExportAssignmentCompatibleSymbolName) {
                            context.approximateLength += varName.length + 10;
                            results.push(factory.createExportAssignment(/*modifiers*/ void 0, isExportEquals, factory.createIdentifier(varName)));
                            return true;
                        } else if (name !== varName) {
                            serializeExportSpecifier(name, varName);
                            return true;
                        }
                        return false;
                    }
                }
                function isTypeRepresentableAsFunctionNamespaceMerge(typeToSerialize, hostSymbol) {
                    var _a2;
                    const ctxSrc = getSourceFileOfNode(context.enclosingDeclaration);
                    return getObjectFlags(typeToSerialize) & 48 /* Mapped */  && !some((_a2 = typeToSerialize.symbol) == null ? void 0 : _a2.declarations, isTypeNode) && // If the type comes straight from a type node, we shouldn't try to break it up
                    !length(getIndexInfosOfType(typeToSerialize)) && !isClassInstanceSide(typeToSerialize) && // While a class instance is potentially representable as a NS, prefer printing a reference to the instance type and serializing the class
                    !!(length(filter(getPropertiesOfType(typeToSerialize), isNamespaceMember)) || length(getSignaturesOfType(typeToSerialize, 0 /* Call */ ))) && !length(getSignaturesOfType(typeToSerialize, 1 /* Construct */ )) && // TODO: could probably serialize as function + ns + class, now that that's OK
                    !getDeclarationWithTypeAnnotation(hostSymbol, enclosingDeclaration) && !(typeToSerialize.symbol && some(typeToSerialize.symbol.declarations, (d)=>getSourceFileOfNode(d) !== ctxSrc)) && !some(getPropertiesOfType(typeToSerialize), (p)=>isLateBoundName(p.escapedName)) && !some(getPropertiesOfType(typeToSerialize), (p)=>some(p.declarations, (d)=>getSourceFileOfNode(d) !== ctxSrc)) && every(getPropertiesOfType(typeToSerialize), (p)=>{
                        if (!isIdentifierText(symbolName(p), languageVersion)) return false;
                        if (!(p.flags & 98304 /* Accessor */ )) return true;
                        return getNonMissingTypeOfSymbol(p) === getWriteTypeOfSymbol(p);
                    });
                }
                function makeSerializePropertySymbol(createProperty2, methodKind, useAccessors) {
                    return function serializePropertySymbol(p, isStatic2, baseType) {
                        var _a2, _b, _c, _d, _e, _f;
                        const modifierFlags = getDeclarationModifierFlagsFromSymbol(p);
                        const omitType = !!(modifierFlags & 2 /* Private */ ) && !isExpanding(context);
                        if (isStatic2 && p.flags & 2887656 /* Alias */ ) return [];
                        if (p.flags & 4194304 /* Prototype */  || p.escapedName === "constructor" || baseType && getPropertyOfType(baseType, p.escapedName) && isReadonlySymbol(getPropertyOfType(baseType, p.escapedName)) === isReadonlySymbol(p) && (p.flags & 16777216 /* Optional */ ) === (getPropertyOfType(baseType, p.escapedName).flags & 16777216 /* Optional */ ) && isTypeIdenticalTo(getTypeOfSymbol(p), getTypeOfPropertyOfType(baseType, p.escapedName))) return [];
                        const flag = modifierFlags & -1025 /* Async */  | (isStatic2 ? 256 /* Static */  : 0);
                        const name = getPropertyNameNodeForSymbol(p, context);
                        const firstPropertyLikeDecl = (_a2 = p.declarations) == null ? void 0 : _a2.find(or(isPropertyDeclaration, isAccessor, isVariableDeclaration, isPropertySignature, isBinaryExpression, isPropertyAccessExpression));
                        if (p.flags & 98304 /* Accessor */  && useAccessors) {
                            const result = [];
                            if (p.flags & 65536 /* SetAccessor */ ) {
                                const setter = p.declarations && forEach(p.declarations, (d)=>{
                                    if (d.kind === 179 /* SetAccessor */ ) return d;
                                    if (isCallExpression(d) && isBindableObjectDefinePropertyCall(d)) return forEach(d.arguments[2].properties, (propDecl)=>{
                                        const id = getNameOfDeclaration(propDecl);
                                        if (!!id && isIdentifier(id) && idText(id) === "set") return propDecl;
                                    });
                                });
                                Debug.assert(!!setter);
                                const paramSymbol = isFunctionLikeDeclaration(setter) ? getSignatureFromDeclaration(setter).parameters[0] : void 0;
                                const setterDeclaration = (_b = p.declarations) == null ? void 0 : _b.find(isSetAccessor);
                                context.approximateLength += modifiersLength(flag) + 7 + (paramSymbol ? symbolName(paramSymbol).length : 5) + (omitType ? 0 : 2);
                                result.push(setTextRange2(context, factory.createSetAccessorDeclaration(factory.createModifiersFromModifierFlags(flag), name, [
                                    factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, paramSymbol ? parameterToParameterDeclarationName(paramSymbol, getEffectiveParameterDeclaration(paramSymbol), context) : "value", /*questionToken*/ void 0, omitType ? void 0 : serializeTypeForDeclaration(context, setterDeclaration, getWriteTypeOfSymbol(p), p))
                                ], /*body*/ void 0), setterDeclaration !== null && setterDeclaration !== void 0 ? setterDeclaration : firstPropertyLikeDecl));
                            }
                            if (p.flags & 32768 /* GetAccessor */ ) {
                                const getterDeclaration = (_c = p.declarations) == null ? void 0 : _c.find(isGetAccessor);
                                context.approximateLength += modifiersLength(flag) + 8 + (omitType ? 0 : 2);
                                result.push(setTextRange2(context, factory.createGetAccessorDeclaration(factory.createModifiersFromModifierFlags(flag), name, [], omitType ? void 0 : serializeTypeForDeclaration(context, getterDeclaration, getTypeOfSymbol(p), p), /*body*/ void 0), getterDeclaration !== null && getterDeclaration !== void 0 ? getterDeclaration : firstPropertyLikeDecl));
                            }
                            return result;
                        } else if (p.flags & 98311 /* Accessor */ ) {
                            const modifierFlags2 = (isReadonlySymbol(p) ? 8 /* Readonly */  : 0) | flag;
                            context.approximateLength += 2 + (omitType ? 0 : 2) + modifiersLength(modifierFlags2);
                            return setTextRange2(context, createProperty2(factory.createModifiersFromModifierFlags(modifierFlags2), name, p.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, omitType ? void 0 : serializeTypeForDeclaration(context, (_d = p.declarations) == null ? void 0 : _d.find(isSetAccessorDeclaration), getWriteTypeOfSymbol(p), p), // TODO: https://github.com/microsoft/TypeScript/pull/32372#discussion_r328386357
                            // interface members can't have initializers, however class members _can_
                            /*initializer*/ void 0), ((_e = p.declarations) == null ? void 0 : _e.find(or(isPropertyDeclaration, isVariableDeclaration))) || firstPropertyLikeDecl);
                        }
                        if (p.flags & 8208 /* Function */ ) {
                            const type = getTypeOfSymbol(p);
                            const signatures = getSignaturesOfType(type, 0 /* Call */ );
                            if (omitType) {
                                const modifierFlags2 = (isReadonlySymbol(p) ? 8 /* Readonly */  : 0) | flag;
                                context.approximateLength += 1 + modifiersLength(modifierFlags2);
                                return setTextRange2(context, createProperty2(factory.createModifiersFromModifierFlags(modifierFlags2), name, p.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, /*type*/ void 0, /*initializer*/ void 0), ((_f = p.declarations) == null ? void 0 : _f.find(isFunctionLikeDeclaration)) || signatures[0] && signatures[0].declaration || p.declarations && p.declarations[0]);
                            }
                            const results2 = [];
                            for (const sig of signatures){
                                context.approximateLength += 1;
                                const decl = signatureToSignatureDeclarationHelper(sig, methodKind, context, {
                                    name,
                                    questionToken: p.flags & 16777216 /* Optional */  ? factory.createToken(58 /* QuestionToken */ ) : void 0,
                                    modifiers: flag ? factory.createModifiersFromModifierFlags(flag) : void 0
                                });
                                const location = sig.declaration && isPrototypePropertyAssignment(sig.declaration.parent) ? sig.declaration.parent : sig.declaration;
                                results2.push(setTextRange2(context, decl, location));
                            }
                            return results2;
                        }
                        return Debug.fail(`Unhandled class member kind! ${p.__debugFlags || p.flags}`);
                    };
                }
                function modifiersLength(flags) {
                    let result = 0;
                    if (flags & 32 /* Export */ ) result += 7;
                    if (flags & 128 /* Ambient */ ) result += 8;
                    if (flags & 2048 /* Default */ ) result += 8;
                    if (flags & 4096 /* Const */ ) result += 6;
                    if (flags & 1 /* Public */ ) result += 7;
                    if (flags & 2 /* Private */ ) result += 8;
                    if (flags & 4 /* Protected */ ) result += 10;
                    if (flags & 64 /* Abstract */ ) result += 9;
                    if (flags & 256 /* Static */ ) result += 7;
                    if (flags & 16 /* Override */ ) result += 9;
                    if (flags & 8 /* Readonly */ ) result += 9;
                    if (flags & 512 /* Accessor */ ) result += 9;
                    if (flags & 1024 /* Async */ ) result += 6;
                    if (flags & 8192 /* In */ ) result += 3;
                    if (flags & 16384 /* Out */ ) result += 4;
                    return result;
                }
                function serializePropertySymbolForInterface(p, baseType) {
                    return serializePropertySymbolForInterfaceWorker(p, /*isStatic*/ false, baseType);
                }
                function serializeSignatures(kind, input, baseType, outputKind) {
                    const signatures = getSignaturesOfType(input, kind);
                    if (kind === 1 /* Construct */ ) {
                        if (!baseType && every(signatures, (s)=>length(s.parameters) === 0)) return [];
                        if (baseType) {
                            const baseSigs = getSignaturesOfType(baseType, 1 /* Construct */ );
                            if (!length(baseSigs) && every(signatures, (s)=>length(s.parameters) === 0)) return [];
                            if (baseSigs.length === signatures.length) {
                                let failed2 = false;
                                for(let i = 0; i < baseSigs.length; i++)if (!compareSignaturesIdentical(signatures[i], baseSigs[i], /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true, compareTypesIdentical)) {
                                    failed2 = true;
                                    break;
                                }
                                if (!failed2) return [];
                            }
                        }
                        let privateProtected = 0;
                        for (const s of signatures)if (s.declaration) privateProtected |= getSelectedEffectiveModifierFlags(s.declaration, 6 /* Protected */ );
                        if (privateProtected) return [
                            setTextRange2(context, factory.createConstructorDeclaration(factory.createModifiersFromModifierFlags(privateProtected), /*parameters*/ [], /*body*/ void 0), signatures[0].declaration)
                        ];
                    }
                    const results2 = [];
                    for (const sig of signatures){
                        context.approximateLength += 1;
                        const decl = signatureToSignatureDeclarationHelper(sig, outputKind, context);
                        results2.push(setTextRange2(context, decl, sig.declaration));
                    }
                    return results2;
                }
                function serializeIndexSignatures(input, baseType) {
                    const results2 = [];
                    for (const info of getIndexInfosOfType(input)){
                        if (baseType) {
                            const baseInfo = getIndexInfoOfType(baseType, info.keyType);
                            if (baseInfo) {
                                if (isTypeIdenticalTo(info.type, baseInfo.type)) continue;
                            }
                        }
                        results2.push(indexInfoToIndexSignatureDeclarationHelper(info, context, /*typeNode*/ void 0));
                    }
                    return results2;
                }
                function serializeBaseType(t, staticType, rootName) {
                    const ref = trySerializeAsTypeReference(t, 111551 /* Value */ );
                    if (ref) return ref;
                    const tempName = getUnusedName(`${rootName}_base`);
                    const statement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                        factory.createVariableDeclaration(tempName, /*exclamationToken*/ void 0, typeToTypeNodeHelper(staticType, context))
                    ], 2 /* Const */ ));
                    addResult(statement, 0 /* None */ );
                    return factory.createExpressionWithTypeArguments(factory.createIdentifier(tempName), /*typeArguments*/ void 0);
                }
                function trySerializeAsTypeReference(t, flags) {
                    let typeArgs;
                    let reference;
                    if (t.target && isSymbolAccessibleByFlags(t.target.symbol, enclosingDeclaration, flags)) {
                        typeArgs = map(getTypeArguments(t), (t2)=>typeToTypeNodeHelper(t2, context));
                        reference = symbolToExpression(t.target.symbol, context, 788968 /* Type */ );
                    } else if (t.symbol && isSymbolAccessibleByFlags(t.symbol, enclosingDeclaration, flags)) reference = symbolToExpression(t.symbol, context, 788968 /* Type */ );
                    if (reference) return factory.createExpressionWithTypeArguments(reference, typeArgs);
                }
                function serializeImplementedType(t) {
                    const ref = trySerializeAsTypeReference(t, 788968 /* Type */ );
                    if (ref) return ref;
                    if (t.symbol) return factory.createExpressionWithTypeArguments(symbolToExpression(t.symbol, context, 788968 /* Type */ ), /*typeArguments*/ void 0);
                }
                function getUnusedName(input, symbol) {
                    var _a2, _b;
                    const id = symbol ? getSymbolId(symbol) : void 0;
                    if (id) {
                        if (context.remappedSymbolNames.has(id)) return context.remappedSymbolNames.get(id);
                    }
                    if (symbol) input = getNameCandidateWorker(symbol, input);
                    let i = 0;
                    const original = input;
                    while((_a2 = context.usedSymbolNames) == null ? void 0 : _a2.has(input)){
                        i++;
                        input = `${original}_${i}`;
                    }
                    (_b = context.usedSymbolNames) == null || _b.add(input);
                    if (id) context.remappedSymbolNames.set(id, input);
                    return input;
                }
                function getNameCandidateWorker(symbol, localName) {
                    if (localName === "default" /* Default */  || localName === "__class" /* Class */  || localName === "__function" /* Function */ ) {
                        const restoreFlags = saveRestoreFlags(context);
                        context.flags |= 16777216 /* InInitialEntityName */ ;
                        const nameCandidate = getNameOfSymbolAsWritten(symbol, context);
                        restoreFlags();
                        localName = nameCandidate.length > 0 && isSingleOrDoubleQuote(nameCandidate.charCodeAt(0)) ? stripQuotes(nameCandidate) : nameCandidate;
                    }
                    if (localName === "default" /* Default */ ) localName = "_default";
                    else if (localName === "export=" /* ExportEquals */ ) localName = "_exports";
                    localName = isIdentifierText(localName, languageVersion) && !isStringANonContextualKeyword(localName) ? localName : "_" + localName.replace(/[^a-z0-9]/gi, "_");
                    return localName;
                }
                function getInternalSymbolName(symbol, localName) {
                    const id = getSymbolId(symbol);
                    if (context.remappedSymbolNames.has(id)) return context.remappedSymbolNames.get(id);
                    localName = getNameCandidateWorker(symbol, localName);
                    context.remappedSymbolNames.set(id, localName);
                    return localName;
                }
            }
            function isExpanding(context) {
                return context.maxExpansionDepth !== -1;
            }
            function isHashPrivate(s) {
                return !!s.valueDeclaration && isNamedDeclaration(s.valueDeclaration) && isPrivateIdentifier(s.valueDeclaration.name);
            }
            function getClonedHashPrivateName(s) {
                if (s.valueDeclaration && isNamedDeclaration(s.valueDeclaration) && isPrivateIdentifier(s.valueDeclaration.name)) return factory.cloneNode(s.valueDeclaration.name);
                return void 0;
            }
        }
        function isLibType(type) {
            var _a;
            const symbol = (getObjectFlags(type) & 4 /* Reference */ ) !== 0 ? type.target.symbol : type.symbol;
            return isTupleType(type) || !!((_a = symbol == null ? void 0 : symbol.declarations) == null ? void 0 : _a.some((decl)=>host.isSourceFileDefaultLibrary(getSourceFileOfNode(decl))));
        }
        function typePredicateToString(typePredicate, enclosingDeclaration, flags = 16384 /* UseAliasDefinedOutsideCurrentScope */ , writer) {
            return writer ? typePredicateToStringWorker(writer).getText() : usingSingleLineStringWriter(typePredicateToStringWorker);
            function typePredicateToStringWorker(writer2) {
                const nodeBuilderFlags = toNodeBuilderFlags(flags) | 70222336 /* WriteTypeParametersInQualifiedName */ ;
                const predicate = nodeBuilder.typePredicateToTypePredicateNode(typePredicate, enclosingDeclaration, nodeBuilderFlags);
                const printer = createPrinterWithRemoveComments();
                const sourceFile = enclosingDeclaration && getSourceFileOfNode(enclosingDeclaration);
                printer.writeNode(4 /* Unspecified */ , predicate, /*sourceFile*/ sourceFile, writer2);
                return writer2;
            }
        }
        function formatUnionTypes(types, expandingEnum) {
            const result = [];
            let flags = 0;
            for(let i = 0; i < types.length; i++){
                const t = types[i];
                flags |= t.flags;
                if (!(t.flags & 98304 /* Nullable */ )) {
                    if (t.flags & 512 /* BooleanLiteral */  || !expandingEnum && t.flags | 1056 /* EnumLike */ ) {
                        const baseType = t.flags & 512 /* BooleanLiteral */  ? booleanType : getBaseTypeOfEnumLikeType(t);
                        if (baseType.flags & 1048576 /* Union */ ) {
                            const count = baseType.types.length;
                            if (i + count <= types.length && getRegularTypeOfLiteralType(types[i + count - 1]) === getRegularTypeOfLiteralType(baseType.types[count - 1])) {
                                result.push(baseType);
                                i += count - 1;
                                continue;
                            }
                        }
                    }
                    result.push(t);
                }
            }
            if (flags & 65536 /* Null */ ) result.push(nullType);
            if (flags & 32768 /* Undefined */ ) result.push(undefinedType);
            return result || types;
        }
        function visibilityToString(flags) {
            if (flags === 2 /* Private */ ) return "private";
            if (flags === 4 /* Protected */ ) return "protected";
            return "public";
        }
        function getTypeAliasForTypeLiteral(type) {
            if (type.symbol && type.symbol.flags & 2048 /* TypeLiteral */  && type.symbol.declarations) {
                const node = walkUpParenthesizedTypes(type.symbol.declarations[0].parent);
                if (isTypeAliasDeclaration(node)) return getSymbolOfDeclaration(node);
            }
            return void 0;
        }
        function isTopLevelInExternalModuleAugmentation(node) {
            return node && node.parent && node.parent.kind === 269 /* ModuleBlock */  && isExternalModuleAugmentation(node.parent.parent);
        }
        function isDefaultBindingContext(location) {
            return location.kind === 308 /* SourceFile */  || isAmbientModule(location);
        }
        function getNameOfSymbolFromNameType(symbol, context) {
            const nameType = getSymbolLinks(symbol).nameType;
            if (nameType) {
                if (nameType.flags & 384 /* StringOrNumberLiteral */ ) {
                    const name = "" + nameType.value;
                    if (!isIdentifierText(name, getEmitScriptTarget(compilerOptions)) && !isNumericLiteralName(name)) return `"${escapeString(name, 34 /* doubleQuote */ )}"`;
                    if (isNumericLiteralName(name) && startsWith(name, "-")) return `[${name}]`;
                    return name;
                }
                if (nameType.flags & 8192 /* UniqueESSymbol */ ) return `[${getNameOfSymbolAsWritten(nameType.symbol, context)}]`;
            }
        }
        function getNameOfSymbolAsWritten(symbol, context) {
            var _a;
            if ((_a = context == null ? void 0 : context.remappedSymbolReferences) == null ? void 0 : _a.has(getSymbolId(symbol))) symbol = context.remappedSymbolReferences.get(getSymbolId(symbol));
            if (context && symbol.escapedName === "default" /* Default */  && !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */ ) && // If it's not the first part of an entity name, it must print as `default`
            (!(context.flags & 16777216 /* InInitialEntityName */ ) || // if the symbol is synthesized, it will only be referenced externally it must print as `default`
            !symbol.declarations || // if not in the same binding context (source file, module declaration), it must print as `default`
            context.enclosingDeclaration && findAncestor(symbol.declarations[0], isDefaultBindingContext) !== findAncestor(context.enclosingDeclaration, isDefaultBindingContext))) return "default";
            if (symbol.declarations && symbol.declarations.length) {
                let declaration = firstDefined(symbol.declarations, (d)=>getNameOfDeclaration(d) ? d : void 0);
                const name2 = declaration && getNameOfDeclaration(declaration);
                if (declaration && name2) {
                    if (isCallExpression(declaration) && isBindableObjectDefinePropertyCall(declaration)) return symbolName(symbol);
                    if (isComputedPropertyName(name2) && !(getCheckFlags(symbol) & 4096 /* Late */ )) {
                        const nameType = getSymbolLinks(symbol).nameType;
                        if (nameType && nameType.flags & 384 /* StringOrNumberLiteral */ ) {
                            const result = getNameOfSymbolFromNameType(symbol, context);
                            if (result !== void 0) return result;
                        }
                    }
                    return declarationNameToString(name2);
                }
                if (!declaration) declaration = symbol.declarations[0];
                if (declaration.parent && declaration.parent.kind === 261 /* VariableDeclaration */ ) return declarationNameToString(declaration.parent.name);
                switch(declaration.kind){
                    case 232 /* ClassExpression */ :
                    case 219 /* FunctionExpression */ :
                    case 220 /* ArrowFunction */ :
                        if (context && !context.encounteredError && !(context.flags & 131072 /* AllowAnonymousIdentifier */ )) context.encounteredError = true;
                        return declaration.kind === 232 /* ClassExpression */  ? "(Anonymous class)" : "(Anonymous function)";
                }
            }
            const name = getNameOfSymbolFromNameType(symbol, context);
            return name !== void 0 ? name : symbolName(symbol);
        }
        function isDeclarationVisible(node) {
            if (node) {
                const links = getNodeLinks(node);
                if (links.isVisible === void 0) links.isVisible = !!determineIfDeclarationIsVisible();
                return links.isVisible;
            }
            return false;
            function determineIfDeclarationIsVisible() {
                switch(node.kind){
                    case 339 /* JSDocCallbackTag */ :
                    case 347 /* JSDocTypedefTag */ :
                    case 341 /* JSDocEnumTag */ :
                        return !!(node.parent && node.parent.parent && node.parent.parent.parent && isSourceFile(node.parent.parent.parent));
                    case 209 /* BindingElement */ :
                        return isDeclarationVisible(node.parent.parent);
                    case 261 /* VariableDeclaration */ :
                        if (isBindingPattern(node.name) && !node.name.elements.length) return false;
                    // falls through
                    case 268 /* ModuleDeclaration */ :
                    case 264 /* ClassDeclaration */ :
                    case 265 /* InterfaceDeclaration */ :
                    case 266 /* TypeAliasDeclaration */ :
                    case 263 /* FunctionDeclaration */ :
                    case 267 /* EnumDeclaration */ :
                    case 272 /* ImportEqualsDeclaration */ :
                        if (isExternalModuleAugmentation(node)) return true;
                        const parent2 = getDeclarationContainer(node);
                        if (!(getCombinedModifierFlagsCached(node) & 32 /* Export */ ) && !(node.kind !== 272 /* ImportEqualsDeclaration */  && parent2.kind !== 308 /* SourceFile */  && parent2.flags & 33554432 /* Ambient */ )) return isGlobalSourceFile(parent2);
                        return isDeclarationVisible(parent2);
                    case 173 /* PropertyDeclaration */ :
                    case 172 /* PropertySignature */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 175 /* MethodDeclaration */ :
                    case 174 /* MethodSignature */ :
                        if (hasEffectiveModifier(node, 6 /* Protected */ )) return false;
                    // Public properties/methods are visible if its parents are visible, so:
                    // falls through
                    case 177 /* Constructor */ :
                    case 181 /* ConstructSignature */ :
                    case 180 /* CallSignature */ :
                    case 182 /* IndexSignature */ :
                    case 170 /* Parameter */ :
                    case 269 /* ModuleBlock */ :
                    case 185 /* FunctionType */ :
                    case 186 /* ConstructorType */ :
                    case 188 /* TypeLiteral */ :
                    case 184 /* TypeReference */ :
                    case 189 /* ArrayType */ :
                    case 190 /* TupleType */ :
                    case 193 /* UnionType */ :
                    case 194 /* IntersectionType */ :
                    case 197 /* ParenthesizedType */ :
                    case 203 /* NamedTupleMember */ :
                        return isDeclarationVisible(node.parent);
                    // Default binding, import specifier and namespace import is visible
                    // only on demand so by default it is not visible
                    case 274 /* ImportClause */ :
                    case 275 /* NamespaceImport */ :
                    case 277 /* ImportSpecifier */ :
                        return false;
                    // Type parameters are always visible
                    case 169 /* TypeParameter */ :
                    // Source file and namespace export are always visible
                    // falls through
                    case 308 /* SourceFile */ :
                    case 271 /* NamespaceExportDeclaration */ :
                        return true;
                    // Export assignments do not create name bindings outside the module
                    case 278 /* ExportAssignment */ :
                        return false;
                    default:
                        return false;
                }
            }
        }
        function collectLinkedAliases(node, setVisibility) {
            let exportSymbol;
            if (node.kind !== 11 /* StringLiteral */  && node.parent && node.parent.kind === 278 /* ExportAssignment */ ) exportSymbol = resolveName(node, node, 2998271 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
            else if (node.parent.kind === 282 /* ExportSpecifier */ ) exportSymbol = getTargetOfExportSpecifier(node.parent, 2998271 /* Alias */ );
            let result;
            let visited;
            if (exportSymbol) {
                visited = /* @__PURE__ */ new Set();
                visited.add(getSymbolId(exportSymbol));
                buildVisibleNodeList(exportSymbol.declarations);
            }
            return result;
            function buildVisibleNodeList(declarations) {
                forEach(declarations, (declaration)=>{
                    const resultNode = getAnyImportSyntax(declaration) || declaration;
                    if (setVisibility) getNodeLinks(declaration).isVisible = true;
                    else {
                        result = result || [];
                        pushIfUnique(result, resultNode);
                    }
                    if (isInternalModuleImportEqualsDeclaration(declaration)) {
                        const internalModuleReference = declaration.moduleReference;
                        const firstIdentifier = getFirstIdentifier(internalModuleReference);
                        const importSymbol = resolveName(declaration, firstIdentifier.escapedText, 901119 /* Namespace */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
                        if (importSymbol && visited) {
                            if (tryAddToSet(visited, getSymbolId(importSymbol))) buildVisibleNodeList(importSymbol.declarations);
                        }
                    }
                });
            }
        }
        function pushTypeResolution(target, propertyName) {
            const resolutionCycleStartIndex = findResolutionCycleStartIndex(target, propertyName);
            if (resolutionCycleStartIndex >= 0) {
                const { length: length2 } = resolutionTargets;
                for(let i = resolutionCycleStartIndex; i < length2; i++)resolutionResults[i] = false;
                return false;
            }
            resolutionTargets.push(target);
            resolutionResults.push(/*items*/ true);
            resolutionPropertyNames.push(propertyName);
            return true;
        }
        function findResolutionCycleStartIndex(target, propertyName) {
            for(let i = resolutionTargets.length - 1; i >= resolutionStart; i--){
                if (resolutionTargetHasProperty(resolutionTargets[i], resolutionPropertyNames[i])) return -1;
                if (resolutionTargets[i] === target && resolutionPropertyNames[i] === propertyName) return i;
            }
            return -1;
        }
        function resolutionTargetHasProperty(target, propertyName) {
            switch(propertyName){
                case 0 /* Type */ :
                    return !!getSymbolLinks(target).type;
                case 2 /* DeclaredType */ :
                    return !!getSymbolLinks(target).declaredType;
                case 1 /* ResolvedBaseConstructorType */ :
                    return !!target.resolvedBaseConstructorType;
                case 3 /* ResolvedReturnType */ :
                    return !!target.resolvedReturnType;
                case 4 /* ImmediateBaseConstraint */ :
                    return !!target.immediateBaseConstraint;
                case 5 /* ResolvedTypeArguments */ :
                    return !!target.resolvedTypeArguments;
                case 6 /* ResolvedBaseTypes */ :
                    return !!target.baseTypesResolved;
                case 7 /* WriteType */ :
                    return !!getSymbolLinks(target).writeType;
                case 8 /* ParameterInitializerContainsUndefined */ :
                    return getNodeLinks(target).parameterInitializerContainsUndefined !== void 0;
            }
            return Debug.assertNever(propertyName);
        }
        function popTypeResolution() {
            resolutionTargets.pop();
            resolutionPropertyNames.pop();
            return resolutionResults.pop();
        }
        function getDeclarationContainer(node) {
            return findAncestor(getRootDeclaration(node), (node2)=>{
                switch(node2.kind){
                    case 261 /* VariableDeclaration */ :
                    case 262 /* VariableDeclarationList */ :
                    case 277 /* ImportSpecifier */ :
                    case 276 /* NamedImports */ :
                    case 275 /* NamespaceImport */ :
                    case 274 /* ImportClause */ :
                        return false;
                    default:
                        return true;
                }
            }).parent;
        }
        function getTypeOfPrototypeProperty(prototype) {
            const classType = getDeclaredTypeOfSymbol(getParentOfSymbol(prototype));
            return classType.typeParameters ? createTypeReference(classType, map(classType.typeParameters, (_)=>anyType)) : classType;
        }
        function getTypeOfPropertyOfType(type, name) {
            const prop = getPropertyOfType(type, name);
            return prop ? getTypeOfSymbol(prop) : void 0;
        }
        function getTypeOfPropertyOrIndexSignatureOfType(type, name) {
            var _a;
            let propType;
            return getTypeOfPropertyOfType(type, name) || (propType = (_a = getApplicableIndexInfoForName(type, name)) == null ? void 0 : _a.type) && addOptionality(propType, /*isProperty*/ true, /*isOptional*/ true);
        }
        function isTypeAny(type) {
            return type && (type.flags & 1 /* Any */ ) !== 0;
        }
        function isErrorType(type) {
            return type === errorType || !!(type.flags & 1 /* Any */  && type.aliasSymbol);
        }
        function getTypeForBindingElementParent(node, checkMode) {
            if (checkMode !== 0 /* Normal */ ) return getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ false, checkMode);
            const symbol = getSymbolOfDeclaration(node);
            return symbol && getSymbolLinks(symbol).type || getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ false, checkMode);
        }
        function getRestType(source, properties, symbol) {
            source = filterType(source, (t)=>!(t.flags & 98304 /* Nullable */ ));
            if (source.flags & 131072 /* Never */ ) return emptyObjectType;
            if (source.flags & 1048576 /* Union */ ) return mapType(source, (t)=>getRestType(t, properties, symbol));
            let omitKeyType = getUnionType(map(properties, getLiteralTypeFromPropertyName));
            const spreadableProperties = [];
            const unspreadableToRestKeys = [];
            for (const prop of getPropertiesOfType(source)){
                const literalTypeFromProperty = getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ );
                if (!isTypeAssignableTo(literalTypeFromProperty, omitKeyType) && !(getDeclarationModifierFlagsFromSymbol(prop) & 6 /* Protected */ ) && isSpreadableProperty(prop)) spreadableProperties.push(prop);
                else unspreadableToRestKeys.push(literalTypeFromProperty);
            }
            if (isGenericObjectType(source) || isGenericIndexType(omitKeyType)) {
                if (unspreadableToRestKeys.length) omitKeyType = getUnionType([
                    omitKeyType,
                    ...unspreadableToRestKeys
                ]);
                if (omitKeyType.flags & 131072 /* Never */ ) return source;
                const omitTypeAlias = getGlobalOmitSymbol();
                if (!omitTypeAlias) return errorType;
                return getTypeAliasInstantiation(omitTypeAlias, [
                    source,
                    omitKeyType
                ]);
            }
            const members = createSymbolTable();
            for (const prop of spreadableProperties)members.set(prop.escapedName, getSpreadSymbol(prop, /*readonly*/ false));
            const result = createAnonymousType(symbol, members, emptyArray, emptyArray, getIndexInfosOfType(source));
            result.objectFlags |= 4194304 /* ObjectRestType */ ;
            return result;
        }
        function isGenericTypeWithUndefinedConstraint(type) {
            return !!(type.flags & 465829888 /* Instantiable */ ) && maybeTypeOfKind(getBaseConstraintOfType(type) || unknownType, 32768 /* Undefined */ );
        }
        function getNonUndefinedType(type) {
            const typeOrConstraint = someType(type, isGenericTypeWithUndefinedConstraint) ? mapType(type, (t)=>t.flags & 465829888 /* Instantiable */  ? getBaseConstraintOrType(t) : t) : type;
            return getTypeWithFacts(typeOrConstraint, 524288 /* NEUndefined */ );
        }
        function getFlowTypeOfDestructuring(node, declaredType) {
            const reference = getSyntheticElementAccess(node);
            return reference ? getFlowTypeOfReference(reference, declaredType) : declaredType;
        }
        function getSyntheticElementAccess(node) {
            const parentAccess = getParentElementAccess(node);
            if (parentAccess && canHaveFlowNode(parentAccess) && parentAccess.flowNode) {
                const propName = getDestructuringPropertyName(node);
                if (propName) {
                    const literal = setTextRange(parseNodeFactory.createStringLiteral(propName), node);
                    const lhsExpr = isLeftHandSideExpression(parentAccess) ? parentAccess : parseNodeFactory.createParenthesizedExpression(parentAccess);
                    const result = setTextRange(parseNodeFactory.createElementAccessExpression(lhsExpr, literal), node);
                    setParent(literal, result);
                    setParent(result, node);
                    if (lhsExpr !== parentAccess) setParent(lhsExpr, result);
                    result.flowNode = parentAccess.flowNode;
                    return result;
                }
            }
        }
        function getParentElementAccess(node) {
            const ancestor = node.parent.parent;
            switch(ancestor.kind){
                case 209 /* BindingElement */ :
                case 304 /* PropertyAssignment */ :
                    return getSyntheticElementAccess(ancestor);
                case 210 /* ArrayLiteralExpression */ :
                    return getSyntheticElementAccess(node.parent);
                case 261 /* VariableDeclaration */ :
                    return ancestor.initializer;
                case 227 /* BinaryExpression */ :
                    return ancestor.right;
            }
        }
        function getDestructuringPropertyName(node) {
            const parent2 = node.parent;
            if (node.kind === 209 /* BindingElement */  && parent2.kind === 207 /* ObjectBindingPattern */ ) return getLiteralPropertyNameText(node.propertyName || node.name);
            if (node.kind === 304 /* PropertyAssignment */  || node.kind === 305 /* ShorthandPropertyAssignment */ ) return getLiteralPropertyNameText(node.name);
            return "" + parent2.elements.indexOf(node);
        }
        function getLiteralPropertyNameText(name) {
            const type = getLiteralTypeFromPropertyName(name);
            return type.flags & 384 /* NumberLiteral */  ? "" + type.value : void 0;
        }
        function getTypeForBindingElement(declaration) {
            const checkMode = declaration.dotDotDotToken ? 32 /* RestBindingElement */  : 0 /* Normal */ ;
            const parentType = getTypeForBindingElementParent(declaration.parent.parent, checkMode);
            return parentType && getBindingElementTypeFromParentType(declaration, parentType, /*noTupleBoundsCheck*/ false);
        }
        function getBindingElementTypeFromParentType(declaration, parentType, noTupleBoundsCheck) {
            if (isTypeAny(parentType)) return parentType;
            const pattern = declaration.parent;
            if (strictNullChecks && declaration.flags & 33554432 /* Ambient */  && isPartOfParameterDeclaration(declaration)) parentType = getNonNullableType(parentType);
            else if (strictNullChecks && pattern.parent.initializer && !hasTypeFacts(getTypeOfInitializer(pattern.parent.initializer), 65536 /* EQUndefined */ )) parentType = getTypeWithFacts(parentType, 524288 /* NEUndefined */ );
            const accessFlags = 32 /* ExpressionPosition */  | (noTupleBoundsCheck || hasDefaultValue(declaration) ? 16 /* AllowMissing */  : 0);
            let type;
            if (pattern.kind === 207 /* ObjectBindingPattern */ ) {
                if (declaration.dotDotDotToken) {
                    parentType = getReducedType(parentType);
                    if (parentType.flags & 2 /* Unknown */  || !isValidSpreadType(parentType)) {
                        error2(declaration, Diagnostics.Rest_types_may_only_be_created_from_object_types);
                        return errorType;
                    }
                    const literalMembers = [];
                    for (const element of pattern.elements)if (!element.dotDotDotToken) literalMembers.push(element.propertyName || element.name);
                    type = getRestType(parentType, literalMembers, declaration.symbol);
                } else {
                    const name = declaration.propertyName || declaration.name;
                    const indexType = getLiteralTypeFromPropertyName(name);
                    const declaredType = getIndexedAccessType(parentType, indexType, accessFlags, name);
                    type = getFlowTypeOfDestructuring(declaration, declaredType);
                }
            } else {
                const elementType = checkIteratedTypeOrElementType(65 /* Destructuring */  | (declaration.dotDotDotToken ? 0 : 128 /* PossiblyOutOfBounds */ ), parentType, undefinedType, pattern);
                const index = pattern.elements.indexOf(declaration);
                if (declaration.dotDotDotToken) {
                    const baseConstraint = mapType(parentType, (t)=>t.flags & 58982400 /* InstantiableNonPrimitive */  ? getBaseConstraintOrType(t) : t);
                    type = everyType(baseConstraint, isTupleType) ? mapType(baseConstraint, (t)=>sliceTupleType(t, index)) : createArrayType(elementType);
                } else if (isArrayLikeType(parentType)) {
                    const indexType = getNumberLiteralType(index);
                    const declaredType = getIndexedAccessTypeOrUndefined(parentType, indexType, accessFlags, declaration.name) || errorType;
                    type = getFlowTypeOfDestructuring(declaration, declaredType);
                } else type = elementType;
            }
            if (!declaration.initializer) return type;
            if (getEffectiveTypeAnnotationNode(walkUpBindingElementsAndPatterns(declaration))) return strictNullChecks && !hasTypeFacts(checkDeclarationInitializer(declaration, 0 /* Normal */ ), 16777216 /* IsUndefined */ ) ? getNonUndefinedType(type) : type;
            return widenTypeInferredFromInitializer(declaration, getUnionType([
                getNonUndefinedType(type),
                checkDeclarationInitializer(declaration, 0 /* Normal */ )
            ], 2 /* Subtype */ ));
        }
        function getTypeForDeclarationFromJSDocComment(declaration) {
            const jsdocType = getJSDocType(declaration);
            if (jsdocType) return getTypeFromTypeNode(jsdocType);
            return void 0;
        }
        function isNullOrUndefined3(node) {
            const expr = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            return expr.kind === 106 /* NullKeyword */  || expr.kind === 80 /* Identifier */  && getResolvedSymbol(expr) === undefinedSymbol;
        }
        function isEmptyArrayLiteral2(node) {
            const expr = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            return expr.kind === 210 /* ArrayLiteralExpression */  && expr.elements.length === 0;
        }
        function addOptionality(type, isProperty = false, isOptional = true) {
            return strictNullChecks && isOptional ? getOptionalType(type, isProperty) : type;
        }
        function getTypeForVariableLikeDeclaration(declaration, includeOptionality, checkMode) {
            if (isVariableDeclaration(declaration) && declaration.parent.parent.kind === 250 /* ForInStatement */ ) {
                const indexType = getIndexType(getNonNullableTypeIfNeeded(checkExpression(declaration.parent.parent.expression, /*checkMode*/ checkMode)));
                return indexType.flags & 4456448 /* Index */  ? getExtractStringType(indexType) : stringType;
            }
            if (isVariableDeclaration(declaration) && declaration.parent.parent.kind === 251 /* ForOfStatement */ ) {
                const forOfStatement = declaration.parent.parent;
                return checkRightHandSideOfForOf(forOfStatement) || anyType;
            }
            if (isBindingPattern(declaration.parent)) return getTypeForBindingElement(declaration);
            const isProperty = isPropertyDeclaration(declaration) && !hasAccessorModifier(declaration) || isPropertySignature(declaration) || isJSDocPropertyTag(declaration);
            const isOptional = includeOptionality && isOptionalDeclaration(declaration);
            const declaredType = tryGetTypeFromEffectiveTypeNode(declaration);
            if (isCatchClauseVariableDeclarationOrBindingElement(declaration)) {
                if (declaredType) return isTypeAny(declaredType) || declaredType === unknownType ? declaredType : errorType;
                return useUnknownInCatchVariables ? unknownType : anyType;
            }
            if (declaredType) return addOptionality(declaredType, isProperty, isOptional);
            if ((noImplicitAny || isInJSFile(declaration)) && isVariableDeclaration(declaration) && !isBindingPattern(declaration.name) && !(getCombinedModifierFlagsCached(declaration) & 32 /* Export */ ) && !(declaration.flags & 33554432 /* Ambient */ )) {
                if (!(getCombinedNodeFlagsCached(declaration) & 6 /* Constant */ ) && (!declaration.initializer || isNullOrUndefined3(declaration.initializer))) return autoType;
                if (declaration.initializer && isEmptyArrayLiteral2(declaration.initializer)) return autoArrayType;
            }
            if (isParameter(declaration)) {
                if (!declaration.symbol) return;
                const func = declaration.parent;
                if (func.kind === 179 /* SetAccessor */  && hasBindableName(func)) {
                    const getter = getDeclarationOfKind(getSymbolOfDeclaration(declaration.parent), 178 /* GetAccessor */ );
                    if (getter) {
                        const getterSignature = getSignatureFromDeclaration(getter);
                        const thisParameter = getAccessorThisParameter(func);
                        if (thisParameter && declaration === thisParameter) {
                            Debug.assert(!thisParameter.type);
                            return getTypeOfSymbol(getterSignature.thisParameter);
                        }
                        return getReturnTypeOfSignature(getterSignature);
                    }
                }
                const parameterTypeOfTypeTag = getParameterTypeOfTypeTag(func, declaration);
                if (parameterTypeOfTypeTag) return parameterTypeOfTypeTag;
                const type = declaration.symbol.escapedName === "this" /* This */  ? getContextualThisParameterType(func) : getContextuallyTypedParameterType(declaration);
                if (type) return addOptionality(type, /*isProperty*/ false, isOptional);
            }
            if (hasOnlyExpressionInitializer(declaration) && !!declaration.initializer) {
                if (isInJSFile(declaration) && !isParameter(declaration)) {
                    const containerObjectType = getJSContainerObjectType(declaration, getSymbolOfDeclaration(declaration), getDeclaredExpandoInitializer(declaration));
                    if (containerObjectType) return containerObjectType;
                }
                const type = widenTypeInferredFromInitializer(declaration, checkDeclarationInitializer(declaration, checkMode));
                return addOptionality(type, isProperty, isOptional);
            }
            if (isPropertyDeclaration(declaration) && (noImplicitAny || isInJSFile(declaration))) {
                if (!hasStaticModifier(declaration)) {
                    const constructor = findConstructorDeclaration(declaration.parent);
                    const type = constructor ? getFlowTypeInConstructor(declaration.symbol, constructor) : getEffectiveModifierFlags(declaration) & 128 /* Ambient */  ? getTypeOfPropertyInBaseClass(declaration.symbol) : void 0;
                    return type && addOptionality(type, /*isProperty*/ true, isOptional);
                } else {
                    const staticBlocks = filter(declaration.parent.members, isClassStaticBlockDeclaration);
                    const type = staticBlocks.length ? getFlowTypeInStaticBlocks(declaration.symbol, staticBlocks) : getEffectiveModifierFlags(declaration) & 128 /* Ambient */  ? getTypeOfPropertyInBaseClass(declaration.symbol) : void 0;
                    return type && addOptionality(type, /*isProperty*/ true, isOptional);
                }
            }
            if (isJsxAttribute(declaration)) return trueType;
            if (isBindingPattern(declaration.name)) return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ false, /*reportErrors*/ true);
            return void 0;
        }
        function isConstructorDeclaredProperty(symbol) {
            if (symbol.valueDeclaration && isBinaryExpression(symbol.valueDeclaration)) {
                const links = getSymbolLinks(symbol);
                if (links.isConstructorDeclaredProperty === void 0) {
                    links.isConstructorDeclaredProperty = false;
                    links.isConstructorDeclaredProperty = !!getDeclaringConstructor(symbol) && every(symbol.declarations, (declaration)=>isBinaryExpression(declaration) && isPossiblyAliasedThisProperty(declaration) && (declaration.left.kind !== 213 /* ElementAccessExpression */  || isStringOrNumericLiteralLike(declaration.left.argumentExpression)) && !getAnnotatedTypeForAssignmentDeclaration(/*declaredType*/ void 0, declaration, symbol, declaration));
                }
                return links.isConstructorDeclaredProperty;
            }
            return false;
        }
        function isAutoTypedProperty(symbol) {
            const declaration = symbol.valueDeclaration;
            return declaration && isPropertyDeclaration(declaration) && !getEffectiveTypeAnnotationNode(declaration) && !declaration.initializer && (noImplicitAny || isInJSFile(declaration));
        }
        function getDeclaringConstructor(symbol) {
            if (!symbol.declarations) return;
            for (const declaration of symbol.declarations){
                const container = getThisContainer(declaration, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (container && (container.kind === 177 /* Constructor */  || isJSConstructor(container))) return container;
            }
        }
        function getFlowTypeFromCommonJSExport(symbol) {
            const file = getSourceFileOfNode(symbol.declarations[0]);
            const accessName = unescapeLeadingUnderscores(symbol.escapedName);
            const areAllModuleExports = symbol.declarations.every((d)=>isInJSFile(d) && isAccessExpression(d) && isModuleExportsAccessExpression(d.expression));
            const reference = areAllModuleExports ? factory.createPropertyAccessExpression(factory.createPropertyAccessExpression(factory.createIdentifier("module"), factory.createIdentifier("exports")), accessName) : factory.createPropertyAccessExpression(factory.createIdentifier("exports"), accessName);
            if (areAllModuleExports) setParent(reference.expression.expression, reference.expression);
            setParent(reference.expression, reference);
            setParent(reference, file);
            reference.flowNode = file.endFlowNode;
            return getFlowTypeOfReference(reference, autoType, undefinedType);
        }
        function getFlowTypeInStaticBlocks(symbol, staticBlocks) {
            const accessName = startsWith(symbol.escapedName, "__#") ? factory.createPrivateIdentifier(symbol.escapedName.split("@")[1]) : unescapeLeadingUnderscores(symbol.escapedName);
            for (const staticBlock of staticBlocks){
                const reference = factory.createPropertyAccessExpression(factory.createThis(), accessName);
                setParent(reference.expression, reference);
                setParent(reference, staticBlock);
                reference.flowNode = staticBlock.returnFlowNode;
                const flowType = getFlowTypeOfProperty(reference, symbol);
                if (noImplicitAny && (flowType === autoType || flowType === autoArrayType)) error2(symbol.valueDeclaration, Diagnostics.Member_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
                if (everyType(flowType, isNullableType)) continue;
                return convertAutoToAny(flowType);
            }
        }
        function getFlowTypeInConstructor(symbol, constructor) {
            const accessName = startsWith(symbol.escapedName, "__#") ? factory.createPrivateIdentifier(symbol.escapedName.split("@")[1]) : unescapeLeadingUnderscores(symbol.escapedName);
            const reference = factory.createPropertyAccessExpression(factory.createThis(), accessName);
            setParent(reference.expression, reference);
            setParent(reference, constructor);
            reference.flowNode = constructor.returnFlowNode;
            const flowType = getFlowTypeOfProperty(reference, symbol);
            if (noImplicitAny && (flowType === autoType || flowType === autoArrayType)) error2(symbol.valueDeclaration, Diagnostics.Member_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
            return everyType(flowType, isNullableType) ? void 0 : convertAutoToAny(flowType);
        }
        function getFlowTypeOfProperty(reference, prop) {
            const initialType = (prop == null ? void 0 : prop.valueDeclaration) && (!isAutoTypedProperty(prop) || getEffectiveModifierFlags(prop.valueDeclaration) & 128 /* Ambient */ ) && getTypeOfPropertyInBaseClass(prop) || undefinedType;
            return getFlowTypeOfReference(reference, autoType, initialType);
        }
        function getWidenedTypeForAssignmentDeclaration(symbol, resolvedSymbol) {
            const container = getAssignedExpandoInitializer(symbol.valueDeclaration);
            if (container) {
                const tag = isInJSFile(container) ? getJSDocTypeTag(container) : void 0;
                if (tag && tag.typeExpression) return getTypeFromTypeNode(tag.typeExpression);
                const containerObjectType = symbol.valueDeclaration && getJSContainerObjectType(symbol.valueDeclaration, symbol, container);
                return containerObjectType || getWidenedLiteralType(checkExpressionCached(container));
            }
            let type;
            let definedInConstructor = false;
            let definedInMethod = false;
            if (isConstructorDeclaredProperty(symbol)) type = getFlowTypeInConstructor(symbol, getDeclaringConstructor(symbol));
            if (!type) {
                let types;
                if (symbol.declarations) {
                    let jsdocType;
                    for (const declaration of symbol.declarations){
                        const expression = isBinaryExpression(declaration) || isCallExpression(declaration) ? declaration : isAccessExpression(declaration) ? isBinaryExpression(declaration.parent) ? declaration.parent : declaration : void 0;
                        if (!expression) continue;
                        const kind = isAccessExpression(expression) ? getAssignmentDeclarationPropertyAccessKind(expression) : getAssignmentDeclarationKind(expression);
                        if (kind === 4 /* ThisProperty */  || isBinaryExpression(expression) && isPossiblyAliasedThisProperty(expression, kind)) {
                            if (isDeclarationInConstructor(expression)) definedInConstructor = true;
                            else definedInMethod = true;
                        }
                        if (!isCallExpression(expression)) jsdocType = getAnnotatedTypeForAssignmentDeclaration(jsdocType, expression, symbol, declaration);
                        if (!jsdocType) (types || (types = [])).push(isBinaryExpression(expression) || isCallExpression(expression) ? getInitializerTypeFromAssignmentDeclaration(symbol, resolvedSymbol, expression, kind) : neverType);
                    }
                    type = jsdocType;
                }
                if (!type) {
                    if (!length(types)) return errorType;
                    let constructorTypes = definedInConstructor && symbol.declarations ? getConstructorDefinedThisAssignmentTypes(types, symbol.declarations) : void 0;
                    if (definedInMethod) {
                        const propType = getTypeOfPropertyInBaseClass(symbol);
                        if (propType) {
                            (constructorTypes || (constructorTypes = [])).push(propType);
                            definedInConstructor = true;
                        }
                    }
                    const sourceTypes = some(constructorTypes, (t)=>!!(t.flags & -98305 /* Nullable */ )) ? constructorTypes : types;
                    type = getUnionType(sourceTypes);
                }
            }
            const widened = getWidenedType(addOptionality(type, /*isProperty*/ false, definedInMethod && !definedInConstructor));
            if (symbol.valueDeclaration && isInJSFile(symbol.valueDeclaration) && filterType(widened, (t)=>!!(t.flags & -98305 /* Nullable */ )) === neverType) {
                reportImplicitAny(symbol.valueDeclaration, anyType);
                return anyType;
            }
            return widened;
        }
        function getJSContainerObjectType(decl, symbol, init) {
            var _a, _b;
            if (!isInJSFile(decl) || !init || !isObjectLiteralExpression(init) || init.properties.length) return void 0;
            const exports2 = createSymbolTable();
            while(isBinaryExpression(decl) || isPropertyAccessExpression(decl)){
                const s2 = getSymbolOfNode(decl);
                if ((_a = s2 == null ? void 0 : s2.exports) == null ? void 0 : _a.size) mergeSymbolTable(exports2, s2.exports);
                decl = isBinaryExpression(decl) ? decl.parent : decl.parent.parent;
            }
            const s = getSymbolOfNode(decl);
            if ((_b = s == null ? void 0 : s.exports) == null ? void 0 : _b.size) mergeSymbolTable(exports2, s.exports);
            const type = createAnonymousType(symbol, exports2, emptyArray, emptyArray, emptyArray);
            type.objectFlags |= 4096 /* JSLiteral */ ;
            return type;
        }
        function getAnnotatedTypeForAssignmentDeclaration(declaredType, expression, symbol, declaration) {
            var _a;
            const typeNode = getEffectiveTypeAnnotationNode(expression.parent);
            if (typeNode) {
                const type = getWidenedType(getTypeFromTypeNode(typeNode));
                if (!declaredType) return type;
                else if (!isErrorType(declaredType) && !isErrorType(type) && !isTypeIdenticalTo(declaredType, type)) errorNextVariableOrPropertyDeclarationMustHaveSameType(/*firstDeclaration*/ void 0, declaredType, declaration, type);
            }
            if ((_a = symbol.parent) == null ? void 0 : _a.valueDeclaration) {
                const possiblyAnnotatedSymbol = getFunctionExpressionParentSymbolOrSymbol(symbol.parent);
                if (possiblyAnnotatedSymbol.valueDeclaration) {
                    const typeNode2 = getEffectiveTypeAnnotationNode(possiblyAnnotatedSymbol.valueDeclaration);
                    if (typeNode2) {
                        const annotationSymbol = getPropertyOfType(getTypeFromTypeNode(typeNode2), symbol.escapedName);
                        if (annotationSymbol) return getNonMissingTypeOfSymbol(annotationSymbol);
                    }
                }
            }
            return declaredType;
        }
        function getInitializerTypeFromAssignmentDeclaration(symbol, resolvedSymbol, expression, kind) {
            if (isCallExpression(expression)) {
                if (resolvedSymbol) return getTypeOfSymbol(resolvedSymbol);
                const objectLitType = checkExpressionCached(expression.arguments[2]);
                const valueType = getTypeOfPropertyOfType(objectLitType, "value");
                if (valueType) return valueType;
                const getFunc = getTypeOfPropertyOfType(objectLitType, "get");
                if (getFunc) {
                    const getSig = getSingleCallSignature(getFunc);
                    if (getSig) return getReturnTypeOfSignature(getSig);
                }
                const setFunc = getTypeOfPropertyOfType(objectLitType, "set");
                if (setFunc) {
                    const setSig = getSingleCallSignature(setFunc);
                    if (setSig) return getTypeOfFirstParameterOfSignature(setSig);
                }
                return anyType;
            }
            if (containsSameNamedThisProperty(expression.left, expression.right)) return anyType;
            const isDirectExport = kind === 1 /* ExportsProperty */  && (isPropertyAccessExpression(expression.left) || isElementAccessExpression(expression.left)) && (isModuleExportsAccessExpression(expression.left.expression) || isIdentifier(expression.left.expression) && isExportsIdentifier(expression.left.expression));
            const type = resolvedSymbol ? getTypeOfSymbol(resolvedSymbol) : isDirectExport ? getRegularTypeOfLiteralType(checkExpressionCached(expression.right)) : getWidenedLiteralType(checkExpressionCached(expression.right));
            if (type.flags & 524288 /* Object */  && kind === 2 /* ModuleExports */  && symbol.escapedName === "export=" /* ExportEquals */ ) {
                const exportedType = resolveStructuredTypeMembers(type);
                const members = createSymbolTable();
                copyEntries(exportedType.members, members);
                const initialSize = members.size;
                if (resolvedSymbol && !resolvedSymbol.exports) resolvedSymbol.exports = createSymbolTable();
                (resolvedSymbol || symbol).exports.forEach((s, name)=>{
                    var _a;
                    const exportedMember = members.get(name);
                    if (exportedMember && exportedMember !== s && !(s.flags & 2097152 /* Alias */ )) {
                        if (s.flags & 111551 /* Value */  && exportedMember.flags & 111551 /* Value */ ) {
                            if (s.valueDeclaration && exportedMember.valueDeclaration && getSourceFileOfNode(s.valueDeclaration) !== getSourceFileOfNode(exportedMember.valueDeclaration)) {
                                const unescapedName = unescapeLeadingUnderscores(s.escapedName);
                                const exportedMemberName = ((_a = tryCast(exportedMember.valueDeclaration, isNamedDeclaration)) == null ? void 0 : _a.name) || exportedMember.valueDeclaration;
                                addRelatedInfo(error2(s.valueDeclaration, Diagnostics.Duplicate_identifier_0, unescapedName), createDiagnosticForNode(exportedMemberName, Diagnostics._0_was_also_declared_here, unescapedName));
                                addRelatedInfo(error2(exportedMemberName, Diagnostics.Duplicate_identifier_0, unescapedName), createDiagnosticForNode(s.valueDeclaration, Diagnostics._0_was_also_declared_here, unescapedName));
                            }
                            const union = createSymbol(s.flags | exportedMember.flags, name);
                            union.links.type = getUnionType([
                                getTypeOfSymbol(s),
                                getTypeOfSymbol(exportedMember)
                            ]);
                            union.valueDeclaration = exportedMember.valueDeclaration;
                            union.declarations = concatenate(exportedMember.declarations, s.declarations);
                            members.set(name, union);
                        } else members.set(name, mergeSymbol(s, exportedMember));
                    } else members.set(name, s);
                });
                const result = createAnonymousType(initialSize !== members.size ? void 0 : exportedType.symbol, // Only set the type's symbol if it looks to be the same as the original type
                members, exportedType.callSignatures, exportedType.constructSignatures, exportedType.indexInfos);
                if (initialSize === members.size) {
                    if (type.aliasSymbol) {
                        result.aliasSymbol = type.aliasSymbol;
                        result.aliasTypeArguments = type.aliasTypeArguments;
                    }
                    if (getObjectFlags(type) & 4 /* Reference */ ) {
                        result.aliasSymbol = type.symbol;
                        const args = getTypeArguments(type);
                        result.aliasTypeArguments = length(args) ? args : void 0;
                    }
                }
                result.objectFlags |= getPropagatingFlagsOfTypes([
                    type
                ]) | getObjectFlags(type) & 20608 /* ObjectLiteral */ ;
                if (result.symbol && result.symbol.flags & 32 /* Class */  && type === getDeclaredTypeOfClassOrInterface(result.symbol)) result.objectFlags |= 16777216 /* IsClassInstanceClone */ ;
                return result;
            }
            if (isEmptyArrayLiteralType(type)) {
                reportImplicitAny(expression, anyArrayType);
                return anyArrayType;
            }
            return type;
        }
        function containsSameNamedThisProperty(thisProperty, expression) {
            return isPropertyAccessExpression(thisProperty) && thisProperty.expression.kind === 110 /* ThisKeyword */  && forEachChildRecursively(expression, (n)=>isMatchingReference(thisProperty, n));
        }
        function isDeclarationInConstructor(expression) {
            const thisContainer = getThisContainer(expression, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            return thisContainer.kind === 177 /* Constructor */  || thisContainer.kind === 263 /* FunctionDeclaration */  || thisContainer.kind === 219 /* FunctionExpression */  && !isPrototypePropertyAssignment(thisContainer.parent);
        }
        function getConstructorDefinedThisAssignmentTypes(types, declarations) {
            Debug.assert(types.length === declarations.length);
            return types.filter((_, i)=>{
                const declaration = declarations[i];
                const expression = isBinaryExpression(declaration) ? declaration : isBinaryExpression(declaration.parent) ? declaration.parent : void 0;
                return expression && isDeclarationInConstructor(expression);
            });
        }
        function getTypeFromBindingElement(element, includePatternInType, reportErrors2) {
            if (element.initializer) {
                const contextualType = isBindingPattern(element.name) ? getTypeFromBindingPattern(element.name, /*includePatternInType*/ true, /*reportErrors*/ false) : unknownType;
                return addOptionality(getWidenedLiteralTypeForInitializer(element, checkDeclarationInitializer(element, 0 /* Normal */ , contextualType)));
            }
            if (isBindingPattern(element.name)) return getTypeFromBindingPattern(element.name, includePatternInType, reportErrors2);
            if (reportErrors2 && !declarationBelongsToPrivateAmbientMember(element)) reportImplicitAny(element, anyType);
            return includePatternInType ? nonInferrableAnyType : anyType;
        }
        function getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors2) {
            const members = createSymbolTable();
            let stringIndexInfo;
            let objectFlags = 131200 /* ContainsObjectOrArrayLiteral */ ;
            forEach(pattern.elements, (e)=>{
                const name = e.propertyName || e.name;
                if (e.dotDotDotToken) {
                    stringIndexInfo = createIndexInfo(stringType, anyType, /*isReadonly*/ false);
                    return;
                }
                const exprType = getLiteralTypeFromPropertyName(name);
                if (!isTypeUsableAsPropertyName(exprType)) {
                    objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */ ;
                    return;
                }
                const text = getPropertyNameFromType(exprType);
                const flags = 4 /* Property */  | (e.initializer ? 16777216 /* Optional */  : 0);
                const symbol = createSymbol(flags, text);
                symbol.links.type = getTypeFromBindingElement(e, includePatternInType, reportErrors2);
                members.set(symbol.escapedName, symbol);
            });
            const result = createAnonymousType(/*symbol*/ void 0, members, emptyArray, emptyArray, stringIndexInfo ? [
                stringIndexInfo
            ] : emptyArray);
            result.objectFlags |= objectFlags;
            if (includePatternInType) {
                result.pattern = pattern;
                result.objectFlags |= 131072 /* ContainsObjectOrArrayLiteral */ ;
            }
            return result;
        }
        function getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors2) {
            const elements = pattern.elements;
            const lastElement = lastOrUndefined(elements);
            const restElement = lastElement && lastElement.kind === 209 /* BindingElement */  && lastElement.dotDotDotToken ? lastElement : void 0;
            if (elements.length === 0 || elements.length === 1 && restElement) return languageVersion >= 2 /* ES2015 */  ? createIterableType(anyType) : anyArrayType;
            const elementTypes = map(elements, (e)=>isOmittedExpression(e) ? anyType : getTypeFromBindingElement(e, includePatternInType, reportErrors2));
            const minLength = findLastIndex(elements, (e)=>!(e === restElement || isOmittedExpression(e) || hasDefaultValue(e)), elements.length - 1) + 1;
            const elementFlags = map(elements, (e, i)=>e === restElement ? 4 /* Rest */  : i >= minLength ? 2 /* Optional */  : 1 /* Required */ );
            let result = createTupleType(elementTypes, elementFlags);
            if (includePatternInType) {
                result = cloneTypeReference(result);
                result.pattern = pattern;
                result.objectFlags |= 131072 /* ContainsObjectOrArrayLiteral */ ;
            }
            return result;
        }
        function getTypeFromBindingPattern(pattern, includePatternInType = false, reportErrors2 = false) {
            if (includePatternInType) contextualBindingPatterns.push(pattern);
            const result = pattern.kind === 207 /* ObjectBindingPattern */  ? getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors2) : getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors2);
            if (includePatternInType) contextualBindingPatterns.pop();
            return result;
        }
        function getWidenedTypeForVariableLikeDeclaration(declaration, reportErrors2) {
            return widenTypeForVariableLikeDeclaration(getTypeForVariableLikeDeclaration(declaration, /*includeOptionality*/ true, 0 /* Normal */ ), declaration, reportErrors2);
        }
        function getTypeFromImportAttributes(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const symbol = createSymbol(4096 /* ObjectLiteral */ , "__importAttributes" /* ImportAttributes */ );
                const members = createSymbolTable();
                forEach(node.elements, (attr)=>{
                    const member = createSymbol(4 /* Property */ , getNameFromImportAttribute(attr));
                    member.parent = symbol;
                    member.links.type = checkImportAttribute(attr);
                    member.links.target = member;
                    members.set(member.escapedName, member);
                });
                const type = createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
                type.objectFlags |= 262272 /* NonInferrableType */ ;
                links.resolvedType = type;
            }
            return links.resolvedType;
        }
        function isGlobalSymbolConstructor(node) {
            const symbol = getSymbolOfNode(node);
            const globalSymbol = getGlobalESSymbolConstructorTypeSymbol(/*reportErrors*/ false);
            return globalSymbol && symbol && symbol === globalSymbol;
        }
        function widenTypeForVariableLikeDeclaration(type, declaration, reportErrors2) {
            if (type) {
                if (type.flags & 4096 /* ESSymbol */  && isGlobalSymbolConstructor(declaration.parent)) type = getESSymbolLikeTypeForNode(declaration);
                if (reportErrors2) reportErrorsFromWidening(declaration, type);
                if (type.flags & 8192 /* UniqueESSymbol */  && (isBindingElement(declaration) || !tryGetTypeFromEffectiveTypeNode(declaration)) && type.symbol !== getSymbolOfDeclaration(declaration)) type = esSymbolType;
                return getWidenedType(type);
            }
            type = isParameter(declaration) && declaration.dotDotDotToken ? anyArrayType : anyType;
            if (reportErrors2) {
                if (!declarationBelongsToPrivateAmbientMember(declaration)) reportImplicitAny(declaration, type);
            }
            return type;
        }
        function declarationBelongsToPrivateAmbientMember(declaration) {
            const root = getRootDeclaration(declaration);
            const memberDeclaration = root.kind === 170 /* Parameter */  ? root.parent : root;
            return isPrivateWithinAmbient(memberDeclaration);
        }
        function tryGetTypeFromEffectiveTypeNode(node) {
            const typeNode = getEffectiveTypeAnnotationNode(node);
            if (typeNode) return getTypeFromTypeNode(typeNode);
        }
        function isParameterOfContextSensitiveSignature(symbol) {
            let decl = symbol.valueDeclaration;
            if (!decl) return false;
            if (isBindingElement(decl)) decl = walkUpBindingElementsAndPatterns(decl);
            if (isParameter(decl)) return isContextSensitiveFunctionOrObjectLiteralMethod(decl.parent);
            return false;
        }
        function getTypeOfVariableOrParameterOrProperty(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                const type = getTypeOfVariableOrParameterOrPropertyWorker(symbol);
                if (!links.type && !isParameterOfContextSensitiveSignature(symbol)) links.type = type;
                return type;
            }
            return links.type;
        }
        function getTypeOfVariableOrParameterOrPropertyWorker(symbol) {
            if (symbol.flags & 4194304 /* Prototype */ ) return getTypeOfPrototypeProperty(symbol);
            if (symbol === requireSymbol) return anyType;
            if (symbol.flags & 134217728 /* ModuleExports */  && symbol.valueDeclaration) {
                const fileSymbol = getSymbolOfDeclaration(getSourceFileOfNode(symbol.valueDeclaration));
                const result = createSymbol(fileSymbol.flags, "exports");
                result.declarations = fileSymbol.declarations ? fileSymbol.declarations.slice() : [];
                result.parent = symbol;
                result.links.target = fileSymbol;
                if (fileSymbol.valueDeclaration) result.valueDeclaration = fileSymbol.valueDeclaration;
                if (fileSymbol.members) result.members = new Map(fileSymbol.members);
                if (fileSymbol.exports) result.exports = new Map(fileSymbol.exports);
                const members = createSymbolTable();
                members.set("exports", result);
                return createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
            }
            Debug.assertIsDefined(symbol.valueDeclaration);
            const declaration = symbol.valueDeclaration;
            if (isSourceFile(declaration) && isJsonSourceFile(declaration)) {
                if (!declaration.statements.length) return emptyObjectType;
                return getWidenedType(getWidenedLiteralType(checkExpression(declaration.statements[0].expression)));
            }
            if (isAccessor(declaration)) return getTypeOfAccessors(symbol);
            if (!pushTypeResolution(symbol, 0 /* Type */ )) {
                if (symbol.flags & 512 /* ValueModule */  && !(symbol.flags & 67108864 /* Assignment */ )) return getTypeOfFuncClassEnumModule(symbol);
                return reportCircularityError(symbol);
            }
            let type;
            if (declaration.kind === 278 /* ExportAssignment */ ) type = widenTypeForVariableLikeDeclaration(tryGetTypeFromEffectiveTypeNode(declaration) || checkExpressionCached(declaration.expression), declaration);
            else if (isBinaryExpression(declaration) || isInJSFile(declaration) && (isCallExpression(declaration) || (isPropertyAccessExpression(declaration) || isBindableStaticElementAccessExpression(declaration)) && isBinaryExpression(declaration.parent))) type = getWidenedTypeForAssignmentDeclaration(symbol);
            else if (isPropertyAccessExpression(declaration) || isElementAccessExpression(declaration) || isIdentifier(declaration) || isStringLiteralLike(declaration) || isNumericLiteral(declaration) || isClassDeclaration(declaration) || isFunctionDeclaration(declaration) || isMethodDeclaration(declaration) && !isObjectLiteralMethod(declaration) || isMethodSignature(declaration) || isSourceFile(declaration)) {
                if (symbol.flags & 9136 /* ValueModule */ ) return getTypeOfFuncClassEnumModule(symbol);
                type = isBinaryExpression(declaration.parent) ? getWidenedTypeForAssignmentDeclaration(symbol) : tryGetTypeFromEffectiveTypeNode(declaration) || anyType;
            } else if (isPropertyAssignment(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkPropertyAssignment(declaration);
            else if (isJsxAttribute(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkJsxAttribute(declaration);
            else if (isShorthandPropertyAssignment(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkExpressionForMutableLocation(declaration.name, 0 /* Normal */ );
            else if (isObjectLiteralMethod(declaration)) type = tryGetTypeFromEffectiveTypeNode(declaration) || checkObjectLiteralMethod(declaration, 0 /* Normal */ );
            else if (isParameter(declaration) || isPropertyDeclaration(declaration) || isPropertySignature(declaration) || isVariableDeclaration(declaration) || isBindingElement(declaration) || isJSDocPropertyLikeTag(declaration)) type = getWidenedTypeForVariableLikeDeclaration(declaration, /*reportErrors*/ true);
            else if (isEnumDeclaration(declaration)) type = getTypeOfFuncClassEnumModule(symbol);
            else if (isEnumMember(declaration)) type = getTypeOfEnumMember(symbol);
            else return Debug.fail("Unhandled declaration kind! " + Debug.formatSyntaxKind(declaration.kind) + " for " + Debug.formatSymbol(symbol));
            if (!popTypeResolution()) {
                if (symbol.flags & 512 /* ValueModule */  && !(symbol.flags & 67108864 /* Assignment */ )) return getTypeOfFuncClassEnumModule(symbol);
                return reportCircularityError(symbol);
            }
            return type;
        }
        function getAnnotatedAccessorTypeNode(accessor) {
            if (accessor) switch(accessor.kind){
                case 178 /* GetAccessor */ :
                    const getterTypeAnnotation = getEffectiveReturnTypeNode(accessor);
                    return getterTypeAnnotation;
                case 179 /* SetAccessor */ :
                    const setterTypeAnnotation = getEffectiveSetAccessorTypeAnnotationNode(accessor);
                    return setterTypeAnnotation;
                case 173 /* PropertyDeclaration */ :
                    Debug.assert(hasAccessorModifier(accessor));
                    const accessorTypeAnnotation = getEffectiveTypeAnnotationNode(accessor);
                    return accessorTypeAnnotation;
            }
            return void 0;
        }
        function getAnnotatedAccessorType(accessor) {
            const node = getAnnotatedAccessorTypeNode(accessor);
            return node && getTypeFromTypeNode(node);
        }
        function getAnnotatedAccessorThisParameter(accessor) {
            const parameter = getAccessorThisParameter(accessor);
            return parameter && parameter.symbol;
        }
        function getThisTypeOfDeclaration(declaration) {
            return getThisTypeOfSignature(getSignatureFromDeclaration(declaration));
        }
        function getTypeOfAccessors(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                if (!pushTypeResolution(symbol, 0 /* Type */ )) return errorType;
                const getter = getDeclarationOfKind(symbol, 178 /* GetAccessor */ );
                const setter = getDeclarationOfKind(symbol, 179 /* SetAccessor */ );
                const accessor = tryCast(getDeclarationOfKind(symbol, 173 /* PropertyDeclaration */ ), isAutoAccessorPropertyDeclaration);
                let type = getter && isInJSFile(getter) && getTypeForDeclarationFromJSDocComment(getter) || getAnnotatedAccessorType(getter) || getAnnotatedAccessorType(setter) || getAnnotatedAccessorType(accessor) || getter && getter.body && getReturnTypeFromBody(getter) || accessor && getWidenedTypeForVariableLikeDeclaration(accessor, /*reportErrors*/ true);
                if (!type) {
                    if (setter && !isPrivateWithinAmbient(setter)) errorOrSuggestion(noImplicitAny, setter, Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation, symbolToString(symbol));
                    else if (getter && !isPrivateWithinAmbient(getter)) errorOrSuggestion(noImplicitAny, getter, Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation, symbolToString(symbol));
                    else if (accessor && !isPrivateWithinAmbient(accessor)) errorOrSuggestion(noImplicitAny, accessor, Diagnostics.Member_0_implicitly_has_an_1_type, symbolToString(symbol), "any");
                    type = anyType;
                }
                if (!popTypeResolution()) {
                    if (getAnnotatedAccessorTypeNode(getter)) error2(getter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    else if (getAnnotatedAccessorTypeNode(setter)) error2(setter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    else if (getAnnotatedAccessorTypeNode(accessor)) error2(setter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    else if (getter && noImplicitAny) error2(getter, Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, symbolToString(symbol));
                    type = anyType;
                }
                var _links_type;
                (_links_type = links.type) !== null && _links_type !== void 0 ? _links_type : links.type = type;
            }
            return links.type;
        }
        function getWriteTypeOfAccessors(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.writeType) {
                if (!pushTypeResolution(symbol, 7 /* WriteType */ )) return errorType;
                var _getDeclarationOfKind;
                const setter = (_getDeclarationOfKind = getDeclarationOfKind(symbol, 179 /* SetAccessor */ )) !== null && _getDeclarationOfKind !== void 0 ? _getDeclarationOfKind : tryCast(getDeclarationOfKind(symbol, 173 /* PropertyDeclaration */ ), isAutoAccessorPropertyDeclaration);
                let writeType = getAnnotatedAccessorType(setter);
                if (!popTypeResolution()) {
                    if (getAnnotatedAccessorTypeNode(setter)) error2(setter, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    writeType = anyType;
                }
                var _links_writeType;
                (_links_writeType = links.writeType) !== null && _links_writeType !== void 0 ? _links_writeType : links.writeType = writeType || getTypeOfAccessors(symbol);
            }
            return links.writeType;
        }
        function getBaseTypeVariableOfClass(symbol) {
            const baseConstructorType = getBaseConstructorTypeOfClass(getDeclaredTypeOfClassOrInterface(symbol));
            return baseConstructorType.flags & 8650752 /* TypeVariable */  ? baseConstructorType : baseConstructorType.flags & 2097152 /* Intersection */  ? find(baseConstructorType.types, (t)=>!!(t.flags & 8650752 /* TypeVariable */ )) : void 0;
        }
        function getTypeOfFuncClassEnumModule(symbol) {
            let links = getSymbolLinks(symbol);
            const originalLinks = links;
            if (!links.type) {
                const expando = symbol.valueDeclaration && getSymbolOfExpando(symbol.valueDeclaration, /*allowDeclaration*/ false);
                if (expando) {
                    const merged = mergeJSSymbols(symbol, expando);
                    if (merged) {
                        symbol = merged;
                        links = merged.links;
                    }
                }
                originalLinks.type = links.type = getTypeOfFuncClassEnumModuleWorker(symbol);
            }
            return links.type;
        }
        function getTypeOfFuncClassEnumModuleWorker(symbol) {
            const declaration = symbol.valueDeclaration;
            if (symbol.flags & 1536 /* Module */  && isShorthandAmbientModuleSymbol(symbol)) return anyType;
            else if (declaration && (declaration.kind === 227 /* BinaryExpression */  || isAccessExpression(declaration) && declaration.parent.kind === 227 /* BinaryExpression */ )) return getWidenedTypeForAssignmentDeclaration(symbol);
            else if (symbol.flags & 512 /* ValueModule */  && declaration && isSourceFile(declaration) && declaration.commonJsModuleIndicator) {
                const resolvedModule = resolveExternalModuleSymbol(symbol);
                if (resolvedModule !== symbol) {
                    if (!pushTypeResolution(symbol, 0 /* Type */ )) return errorType;
                    const exportEquals = getMergedSymbol(symbol.exports.get("export=" /* ExportEquals */ ));
                    const type2 = getWidenedTypeForAssignmentDeclaration(exportEquals, exportEquals === resolvedModule ? void 0 : resolvedModule);
                    if (!popTypeResolution()) return reportCircularityError(symbol);
                    return type2;
                }
            }
            const type = createObjectType(16 /* Anonymous */ , symbol);
            if (symbol.flags & 32 /* Class */ ) {
                const baseTypeVariable = getBaseTypeVariableOfClass(symbol);
                return baseTypeVariable ? getIntersectionType([
                    type,
                    baseTypeVariable
                ]) : type;
            } else return strictNullChecks && symbol.flags & 16777216 /* Optional */  ? getOptionalType(type, /*isProperty*/ true) : type;
        }
        function getTypeOfEnumMember(symbol) {
            const links = getSymbolLinks(symbol);
            return links.type || (links.type = getDeclaredTypeOfEnumMember(symbol));
        }
        function getTypeOfAlias(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                if (!pushTypeResolution(symbol, 0 /* Type */ )) return errorType;
                const targetSymbol = resolveAlias(symbol);
                const exportSymbol = symbol.declarations && getTargetOfAliasDeclaration(getDeclarationOfAliasSymbol(symbol), /*dontRecursivelyResolve*/ true);
                const declaredType = firstDefined(exportSymbol == null ? void 0 : exportSymbol.declarations, (d)=>isExportAssignment(d) ? tryGetTypeFromEffectiveTypeNode(d) : void 0);
                var _links_type;
                (_links_type = links.type) !== null && _links_type !== void 0 ? _links_type : links.type = (exportSymbol == null ? void 0 : exportSymbol.declarations) && isDuplicatedCommonJSExport(exportSymbol.declarations) && symbol.declarations.length ? getFlowTypeFromCommonJSExport(exportSymbol) : isDuplicatedCommonJSExport(symbol.declarations) ? autoType : declaredType ? declaredType : getSymbolFlags(targetSymbol) & 111551 /* Value */  ? getTypeOfSymbol(targetSymbol) : errorType;
                if (!popTypeResolution()) {
                    reportCircularityError(exportSymbol !== null && exportSymbol !== void 0 ? exportSymbol : symbol);
                    var _links_type1;
                    return (_links_type1 = links.type) !== null && _links_type1 !== void 0 ? _links_type1 : links.type = errorType;
                }
            }
            return links.type;
        }
        function getTypeOfInstantiatedSymbol(symbol) {
            const links = getSymbolLinks(symbol);
            return links.type || (links.type = instantiateType(getTypeOfSymbol(links.target), links.mapper));
        }
        function getWriteTypeOfInstantiatedSymbol(symbol) {
            const links = getSymbolLinks(symbol);
            return links.writeType || (links.writeType = instantiateType(getWriteTypeOfSymbol(links.target), links.mapper));
        }
        function reportCircularityError(symbol) {
            const declaration = symbol.valueDeclaration;
            if (declaration) {
                if (getEffectiveTypeAnnotationNode(declaration)) {
                    error2(symbol.valueDeclaration, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
                    return errorType;
                }
                if (noImplicitAny && (declaration.kind !== 170 /* Parameter */  || declaration.initializer)) error2(symbol.valueDeclaration, Diagnostics._0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer, symbolToString(symbol));
            } else if (symbol.flags & 2097152 /* Alias */ ) {
                const node = getDeclarationOfAliasSymbol(symbol);
                if (node) error2(node, Diagnostics.Circular_definition_of_import_alias_0, symbolToString(symbol));
            }
            return anyType;
        }
        function getTypeOfSymbolWithDeferredType(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) {
                Debug.assertIsDefined(links.deferralParent);
                Debug.assertIsDefined(links.deferralConstituents);
                links.type = links.deferralParent.flags & 1048576 /* Union */  ? getUnionType(links.deferralConstituents) : getIntersectionType(links.deferralConstituents);
            }
            return links.type;
        }
        function getWriteTypeOfSymbolWithDeferredType(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.writeType && links.deferralWriteConstituents) {
                Debug.assertIsDefined(links.deferralParent);
                Debug.assertIsDefined(links.deferralConstituents);
                links.writeType = links.deferralParent.flags & 1048576 /* Union */  ? getUnionType(links.deferralWriteConstituents) : getIntersectionType(links.deferralWriteConstituents);
            }
            return links.writeType;
        }
        function getWriteTypeOfSymbol(symbol) {
            const checkFlags = getCheckFlags(symbol);
            if (checkFlags & 2 /* SyntheticProperty */ ) return checkFlags & 65536 /* DeferredType */  ? getWriteTypeOfSymbolWithDeferredType(symbol) || getTypeOfSymbolWithDeferredType(symbol) : // NOTE: cast to TransientSymbol should be safe because only TransientSymbols can have CheckFlags.SyntheticProperty
            symbol.links.writeType || symbol.links.type;
            if (symbol.flags & 4 /* Property */ ) return removeMissingType(getTypeOfSymbol(symbol), !!(symbol.flags & 16777216 /* Optional */ ));
            if (symbol.flags & 98304 /* Accessor */ ) return checkFlags & 1 /* Instantiated */  ? getWriteTypeOfInstantiatedSymbol(symbol) : getWriteTypeOfAccessors(symbol);
            return getTypeOfSymbol(symbol);
        }
        function getTypeOfSymbol(symbol) {
            const checkFlags = getCheckFlags(symbol);
            if (checkFlags & 65536 /* DeferredType */ ) return getTypeOfSymbolWithDeferredType(symbol);
            if (checkFlags & 1 /* Instantiated */ ) return getTypeOfInstantiatedSymbol(symbol);
            if (checkFlags & 262144 /* Mapped */ ) return getTypeOfMappedSymbol(symbol);
            if (checkFlags & 8192 /* ReverseMapped */ ) return getTypeOfReverseMappedSymbol(symbol);
            if (symbol.flags & 7 /* Property */ ) return getTypeOfVariableOrParameterOrProperty(symbol);
            if (symbol.flags & 9136 /* ValueModule */ ) return getTypeOfFuncClassEnumModule(symbol);
            if (symbol.flags & 8 /* EnumMember */ ) return getTypeOfEnumMember(symbol);
            if (symbol.flags & 98304 /* Accessor */ ) return getTypeOfAccessors(symbol);
            if (symbol.flags & 2097152 /* Alias */ ) return getTypeOfAlias(symbol);
            return errorType;
        }
        function getNonMissingTypeOfSymbol(symbol) {
            return removeMissingType(getTypeOfSymbol(symbol), !!(symbol.flags & 16777216 /* Optional */ ));
        }
        function isReferenceToSomeType(type, targets) {
            if (type === void 0 || (getObjectFlags(type) & 4 /* Reference */ ) === 0) return false;
            for (const target of targets){
                if (type.target === target) return true;
            }
            return false;
        }
        function isReferenceToType2(type, target) {
            return type !== void 0 && target !== void 0 && (getObjectFlags(type) & 4 /* Reference */ ) !== 0 && type.target === target;
        }
        function getTargetType(type) {
            return getObjectFlags(type) & 4 /* Reference */  ? type.target : type;
        }
        function hasBaseType(type, checkBase) {
            return check(type);
            function check(type2) {
                if (getObjectFlags(type2) & 7 /* Reference */ ) {
                    const target = getTargetType(type2);
                    return target === checkBase || some(getBaseTypes(target), check);
                } else if (type2.flags & 2097152 /* Intersection */ ) return some(type2.types, check);
                return false;
            }
        }
        function appendTypeParameters(typeParameters, declarations) {
            for (const declaration of declarations)typeParameters = appendIfUnique(typeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(declaration)));
            return typeParameters;
        }
        function getOuterTypeParameters(node, includeThisTypes) {
            while(true){
                node = node.parent;
                if (node && isBinaryExpression(node)) {
                    const assignmentKind = getAssignmentDeclarationKind(node);
                    if (assignmentKind === 6 /* Prototype */  || assignmentKind === 3 /* PrototypeProperty */ ) {
                        const symbol = getSymbolOfDeclaration(node.left);
                        if (symbol && symbol.parent && !findAncestor(symbol.parent.valueDeclaration, (d)=>node === d)) node = symbol.parent.valueDeclaration;
                    }
                }
                if (!node) return void 0;
                const kind = node.kind;
                switch(kind){
                    case 264 /* ClassDeclaration */ :
                    case 232 /* ClassExpression */ :
                    case 265 /* InterfaceDeclaration */ :
                    case 180 /* CallSignature */ :
                    case 181 /* ConstructSignature */ :
                    case 174 /* MethodSignature */ :
                    case 185 /* FunctionType */ :
                    case 186 /* ConstructorType */ :
                    case 318 /* JSDocFunctionType */ :
                    case 263 /* FunctionDeclaration */ :
                    case 175 /* MethodDeclaration */ :
                    case 219 /* FunctionExpression */ :
                    case 220 /* ArrowFunction */ :
                    case 266 /* TypeAliasDeclaration */ :
                    case 346 /* JSDocTemplateTag */ :
                    case 347 /* JSDocTypedefTag */ :
                    case 341 /* JSDocEnumTag */ :
                    case 339 /* JSDocCallbackTag */ :
                    case 201 /* MappedType */ :
                    case 195 /* ConditionalType */ :
                        {
                            const outerTypeParameters = getOuterTypeParameters(node, includeThisTypes);
                            if ((kind === 219 /* FunctionExpression */  || kind === 220 /* ArrowFunction */  || isObjectLiteralMethod(node)) && isContextSensitive(node)) {
                                const signature = firstOrUndefined(getSignaturesOfType(getTypeOfSymbol(getSymbolOfDeclaration(node)), 0 /* Call */ ));
                                if (signature && signature.typeParameters) return [
                                    ...outerTypeParameters || emptyArray,
                                    ...signature.typeParameters
                                ];
                            }
                            if (kind === 201 /* MappedType */ ) return append(outerTypeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node.typeParameter)));
                            else if (kind === 195 /* ConditionalType */ ) return concatenate(outerTypeParameters, getInferTypeParameters(node));
                            const outerAndOwnTypeParameters = appendTypeParameters(outerTypeParameters, getEffectiveTypeParameterDeclarations(node));
                            const thisType = includeThisTypes && (kind === 264 /* ClassDeclaration */  || kind === 232 /* ClassExpression */  || kind === 265 /* InterfaceDeclaration */  || isJSConstructor(node)) && getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(node)).thisType;
                            return thisType ? append(outerAndOwnTypeParameters, thisType) : outerAndOwnTypeParameters;
                        }
                    case 342 /* JSDocParameterTag */ :
                        const paramSymbol = getParameterSymbolFromJSDoc(node);
                        if (paramSymbol) node = paramSymbol.valueDeclaration;
                        break;
                    case 321 /* JSDoc */ :
                        {
                            const outerTypeParameters = getOuterTypeParameters(node, includeThisTypes);
                            return node.tags ? appendTypeParameters(outerTypeParameters, flatMap(node.tags, (t)=>isJSDocTemplateTag(t) ? t.typeParameters : void 0)) : outerTypeParameters;
                        }
                }
            }
        }
        function getOuterTypeParametersOfClassOrInterface(symbol) {
            var _a;
            const declaration = symbol.flags & 32 /* Class */  || symbol.flags & 16 /* Function */  ? symbol.valueDeclaration : (_a = symbol.declarations) == null ? void 0 : _a.find((decl)=>{
                if (decl.kind === 265 /* InterfaceDeclaration */ ) return true;
                if (decl.kind !== 261 /* VariableDeclaration */ ) return false;
                const initializer = decl.initializer;
                return !!initializer && (initializer.kind === 219 /* FunctionExpression */  || initializer.kind === 220 /* ArrowFunction */ );
            });
            Debug.assert(!!declaration, "Class was missing valueDeclaration -OR- non-class had no interface declarations");
            return getOuterTypeParameters(declaration);
        }
        function getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) {
            if (!symbol.declarations) return;
            let result;
            for (const node of symbol.declarations)if (node.kind === 265 /* InterfaceDeclaration */  || node.kind === 264 /* ClassDeclaration */  || node.kind === 232 /* ClassExpression */  || isJSConstructor(node) || isTypeAlias(node)) {
                const declaration = node;
                result = appendTypeParameters(result, getEffectiveTypeParameterDeclarations(declaration));
            }
            return result;
        }
        function getTypeParametersOfClassOrInterface(symbol) {
            return concatenate(getOuterTypeParametersOfClassOrInterface(symbol), getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol));
        }
        function isMixinConstructorType(type) {
            const signatures = getSignaturesOfType(type, 1 /* Construct */ );
            if (signatures.length === 1) {
                const s = signatures[0];
                if (!s.typeParameters && s.parameters.length === 1 && signatureHasRestParameter(s)) {
                    const paramType = getTypeOfParameter(s.parameters[0]);
                    return isTypeAny(paramType) || getElementTypeOfArrayType(paramType) === anyType;
                }
            }
            return false;
        }
        function isConstructorType(type) {
            if (getSignaturesOfType(type, 1 /* Construct */ ).length > 0) return true;
            if (type.flags & 8650752 /* TypeVariable */ ) {
                const constraint = getBaseConstraintOfType(type);
                return !!constraint && isMixinConstructorType(constraint);
            }
            return false;
        }
        function getBaseTypeNodeOfClass(type) {
            const decl = getClassLikeDeclarationOfSymbol(type.symbol);
            return decl && getEffectiveBaseTypeNode(decl);
        }
        function getConstructorsForTypeArguments(type, typeArgumentNodes, location) {
            const typeArgCount = length(typeArgumentNodes);
            const isJavascript = isInJSFile(location);
            return filter(getSignaturesOfType(type, 1 /* Construct */ ), (sig)=>(isJavascript || typeArgCount >= getMinTypeArgumentCount(sig.typeParameters)) && typeArgCount <= length(sig.typeParameters));
        }
        function getInstantiatedConstructorsForTypeArguments(type, typeArgumentNodes, location) {
            const signatures = getConstructorsForTypeArguments(type, typeArgumentNodes, location);
            const typeArguments = map(typeArgumentNodes, getTypeFromTypeNode);
            return sameMap(signatures, (sig)=>some(sig.typeParameters) ? getSignatureInstantiation(sig, typeArguments, isInJSFile(location)) : sig);
        }
        function getBaseConstructorTypeOfClass(type) {
            if (!type.resolvedBaseConstructorType) {
                const decl = getClassLikeDeclarationOfSymbol(type.symbol);
                const extended = decl && getEffectiveBaseTypeNode(decl);
                const baseTypeNode = getBaseTypeNodeOfClass(type);
                if (!baseTypeNode) return type.resolvedBaseConstructorType = undefinedType;
                if (!pushTypeResolution(type, 1 /* ResolvedBaseConstructorType */ )) return errorType;
                const baseConstructorType = checkExpression(baseTypeNode.expression);
                if (extended && baseTypeNode !== extended) {
                    Debug.assert(!extended.typeArguments);
                    checkExpression(extended.expression);
                }
                if (baseConstructorType.flags & 2621440 /* Intersection */ ) resolveStructuredTypeMembers(baseConstructorType);
                if (!popTypeResolution()) {
                    error2(type.symbol.valueDeclaration, Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_base_expression, symbolToString(type.symbol));
                    var _type_resolvedBaseConstructorType;
                    return (_type_resolvedBaseConstructorType = type.resolvedBaseConstructorType) !== null && _type_resolvedBaseConstructorType !== void 0 ? _type_resolvedBaseConstructorType : type.resolvedBaseConstructorType = errorType;
                }
                if (!(baseConstructorType.flags & 1 /* Any */ ) && baseConstructorType !== nullWideningType && !isConstructorType(baseConstructorType)) {
                    const err = error2(baseTypeNode.expression, Diagnostics.Type_0_is_not_a_constructor_function_type, typeToString(baseConstructorType));
                    if (baseConstructorType.flags & 262144 /* TypeParameter */ ) {
                        const constraint = getConstraintFromTypeParameter(baseConstructorType);
                        let ctorReturn = unknownType;
                        if (constraint) {
                            const ctorSig = getSignaturesOfType(constraint, 1 /* Construct */ );
                            if (ctorSig[0]) ctorReturn = getReturnTypeOfSignature(ctorSig[0]);
                        }
                        if (baseConstructorType.symbol.declarations) addRelatedInfo(err, createDiagnosticForNode(baseConstructorType.symbol.declarations[0], Diagnostics.Did_you_mean_for_0_to_be_constrained_to_type_new_args_Colon_any_1, symbolToString(baseConstructorType.symbol), typeToString(ctorReturn)));
                    }
                    var _type_resolvedBaseConstructorType1;
                    return (_type_resolvedBaseConstructorType1 = type.resolvedBaseConstructorType) !== null && _type_resolvedBaseConstructorType1 !== void 0 ? _type_resolvedBaseConstructorType1 : type.resolvedBaseConstructorType = errorType;
                }
                var _type_resolvedBaseConstructorType2;
                (_type_resolvedBaseConstructorType2 = type.resolvedBaseConstructorType) !== null && _type_resolvedBaseConstructorType2 !== void 0 ? _type_resolvedBaseConstructorType2 : type.resolvedBaseConstructorType = baseConstructorType;
            }
            return type.resolvedBaseConstructorType;
        }
        function getImplementsTypes(type) {
            let resolvedImplementsTypes = emptyArray;
            if (type.symbol.declarations) for (const declaration of type.symbol.declarations){
                const implementsTypeNodes = getEffectiveImplementsTypeNodes(declaration);
                if (!implementsTypeNodes) continue;
                for (const node of implementsTypeNodes){
                    const implementsType = getTypeFromTypeNode(node);
                    if (!isErrorType(implementsType)) {
                        if (resolvedImplementsTypes === emptyArray) resolvedImplementsTypes = [
                            implementsType
                        ];
                        else resolvedImplementsTypes.push(implementsType);
                    }
                }
            }
            return resolvedImplementsTypes;
        }
        function reportCircularBaseType(node, type) {
            error2(node, Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ void 0, 2 /* WriteArrayAsGenericType */ ));
        }
        function getBaseTypes(type) {
            if (!type.baseTypesResolved) {
                if (pushTypeResolution(type, 6 /* ResolvedBaseTypes */ )) {
                    if (type.objectFlags & 8 /* Tuple */ ) type.resolvedBaseTypes = [
                        getTupleBaseType(type)
                    ];
                    else if (type.symbol.flags & 96 /* Interface */ ) {
                        if (type.symbol.flags & 32 /* Class */ ) resolveBaseTypesOfClass(type);
                        if (type.symbol.flags & 64 /* Interface */ ) resolveBaseTypesOfInterface(type);
                    } else Debug.fail("type must be class or interface");
                    if (!popTypeResolution() && type.symbol.declarations) {
                        for (const declaration of type.symbol.declarations)if (declaration.kind === 264 /* ClassDeclaration */  || declaration.kind === 265 /* InterfaceDeclaration */ ) reportCircularBaseType(declaration, type);
                    }
                }
                type.baseTypesResolved = true;
            }
            return type.resolvedBaseTypes;
        }
        function getTupleBaseType(type) {
            const elementTypes = sameMap(type.typeParameters, (t, i)=>type.elementFlags[i] & 8 /* Variadic */  ? getIndexedAccessType(t, numberType) : t);
            return createArrayType(getUnionType(elementTypes || emptyArray), type.readonly);
        }
        function resolveBaseTypesOfClass(type) {
            type.resolvedBaseTypes = resolvingEmptyArray;
            const baseConstructorType = getApparentType(getBaseConstructorTypeOfClass(type));
            if (!(baseConstructorType.flags & 2621441 /* Any */ )) return type.resolvedBaseTypes = emptyArray;
            const baseTypeNode = getBaseTypeNodeOfClass(type);
            let baseType;
            const originalBaseType = baseConstructorType.symbol ? getDeclaredTypeOfSymbol(baseConstructorType.symbol) : void 0;
            if (baseConstructorType.symbol && baseConstructorType.symbol.flags & 32 /* Class */  && areAllOuterTypeParametersApplied(originalBaseType)) baseType = getTypeFromClassOrInterfaceReference(baseTypeNode, baseConstructorType.symbol);
            else if (baseConstructorType.flags & 1 /* Any */ ) baseType = baseConstructorType;
            else {
                const constructors = getInstantiatedConstructorsForTypeArguments(baseConstructorType, baseTypeNode.typeArguments, baseTypeNode);
                if (!constructors.length) {
                    error2(baseTypeNode.expression, Diagnostics.No_base_constructor_has_the_specified_number_of_type_arguments);
                    return type.resolvedBaseTypes = emptyArray;
                }
                baseType = getReturnTypeOfSignature(constructors[0]);
            }
            if (isErrorType(baseType)) return type.resolvedBaseTypes = emptyArray;
            const reducedBaseType = getReducedType(baseType);
            if (!isValidBaseType(reducedBaseType)) {
                const elaboration = elaborateNeverIntersection(/*errorInfo*/ void 0, baseType);
                const diagnostic = chainDiagnosticMessages(elaboration, Diagnostics.Base_constructor_return_type_0_is_not_an_object_type_or_intersection_of_object_types_with_statically_known_members, typeToString(reducedBaseType));
                diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(baseTypeNode.expression), baseTypeNode.expression, diagnostic));
                return type.resolvedBaseTypes = emptyArray;
            }
            if (type === reducedBaseType || hasBaseType(reducedBaseType, type)) {
                error2(type.symbol.valueDeclaration, Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ void 0, 2 /* WriteArrayAsGenericType */ ));
                return type.resolvedBaseTypes = emptyArray;
            }
            if (type.resolvedBaseTypes === resolvingEmptyArray) type.members = void 0;
            return type.resolvedBaseTypes = [
                reducedBaseType
            ];
        }
        function areAllOuterTypeParametersApplied(type) {
            const outerTypeParameters = type.outerTypeParameters;
            if (outerTypeParameters) {
                const last2 = outerTypeParameters.length - 1;
                const typeArguments = getTypeArguments(type);
                return outerTypeParameters[last2].symbol !== typeArguments[last2].symbol;
            }
            return true;
        }
        function isValidBaseType(type) {
            if (type.flags & 262144 /* TypeParameter */ ) {
                const constraint = getBaseConstraintOfType(type);
                if (constraint) return isValidBaseType(constraint);
            }
            return !!(type.flags & 67633153 /* Any */  && !isGenericMappedType(type) || type.flags & 2097152 /* Intersection */  && every(type.types, isValidBaseType));
        }
        function resolveBaseTypesOfInterface(type) {
            type.resolvedBaseTypes = type.resolvedBaseTypes || emptyArray;
            if (type.symbol.declarations) for (const declaration of type.symbol.declarations){
                if (declaration.kind === 265 /* InterfaceDeclaration */  && getInterfaceBaseTypeNodes(declaration)) for (const node of getInterfaceBaseTypeNodes(declaration)){
                    const baseType = getReducedType(getTypeFromTypeNode(node));
                    if (!isErrorType(baseType)) {
                        if (isValidBaseType(baseType)) {
                            if (type !== baseType && !hasBaseType(baseType, type)) {
                                if (type.resolvedBaseTypes === emptyArray) type.resolvedBaseTypes = [
                                    baseType
                                ];
                                else type.resolvedBaseTypes.push(baseType);
                            } else reportCircularBaseType(declaration, type);
                        } else error2(node, Diagnostics.An_interface_can_only_extend_an_object_type_or_intersection_of_object_types_with_statically_known_members);
                    }
                }
            }
        }
        function isThislessInterface(symbol) {
            if (!symbol.declarations) return true;
            for (const declaration of symbol.declarations)if (declaration.kind === 265 /* InterfaceDeclaration */ ) {
                if (declaration.flags & 256 /* ContainsThis */ ) return false;
                const baseTypeNodes = getInterfaceBaseTypeNodes(declaration);
                if (baseTypeNodes) {
                    for (const node of baseTypeNodes)if (isEntityNameExpression(node.expression)) {
                        const baseSymbol = resolveEntityName(node.expression, 788968 /* Type */ , /*ignoreErrors*/ true);
                        if (!baseSymbol || !(baseSymbol.flags & 64 /* Interface */ ) || getDeclaredTypeOfClassOrInterface(baseSymbol).thisType) return false;
                    }
                }
            }
            return true;
        }
        function getDeclaredTypeOfClassOrInterface(symbol) {
            let links = getSymbolLinks(symbol);
            const originalLinks = links;
            if (!links.declaredType) {
                const kind = symbol.flags & 32 /* Class */  ? 1 /* Class */  : 2 /* Interface */ ;
                const merged = mergeJSSymbols(symbol, symbol.valueDeclaration && getAssignedClassSymbol(symbol.valueDeclaration));
                if (merged) {
                    symbol = merged;
                    links = merged.links;
                }
                const type = originalLinks.declaredType = links.declaredType = createObjectType(kind, symbol);
                const outerTypeParameters = getOuterTypeParametersOfClassOrInterface(symbol);
                const localTypeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                if (outerTypeParameters || localTypeParameters || kind === 1 /* Class */  || !isThislessInterface(symbol)) {
                    type.objectFlags |= 4 /* Reference */ ;
                    type.typeParameters = concatenate(outerTypeParameters, localTypeParameters);
                    type.outerTypeParameters = outerTypeParameters;
                    type.localTypeParameters = localTypeParameters;
                    type.instantiations = /* @__PURE__ */ new Map();
                    type.instantiations.set(getTypeListId(type.typeParameters), type);
                    type.target = type;
                    type.resolvedTypeArguments = type.typeParameters;
                    type.thisType = createTypeParameter(symbol);
                    type.thisType.isThisType = true;
                    type.thisType.constraint = type;
                }
            }
            return links.declaredType;
        }
        function getDeclaredTypeOfTypeAlias(symbol) {
            var _a;
            const links = getSymbolLinks(symbol);
            if (!links.declaredType) {
                if (!pushTypeResolution(symbol, 2 /* DeclaredType */ )) return errorType;
                const declaration = Debug.checkDefined((_a = symbol.declarations) == null ? void 0 : _a.find(isTypeAlias), "Type alias symbol with no valid declaration found");
                const typeNode = isJSDocTypeAlias(declaration) ? declaration.typeExpression : declaration.type;
                let type = typeNode ? getTypeFromTypeNode(typeNode) : errorType;
                if (popTypeResolution()) {
                    const typeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
                    if (typeParameters) {
                        links.typeParameters = typeParameters;
                        links.instantiations = /* @__PURE__ */ new Map();
                        links.instantiations.set(getTypeListId(typeParameters), type);
                    }
                    if (type === intrinsicMarkerType && symbol.escapedName === "BuiltinIteratorReturn") type = getBuiltinIteratorReturnType();
                } else {
                    type = errorType;
                    if (declaration.kind === 341 /* JSDocEnumTag */ ) error2(declaration.typeExpression.type, Diagnostics.Type_alias_0_circularly_references_itself, symbolToString(symbol));
                    else error2(isNamedDeclaration(declaration) ? declaration.name || declaration : declaration, Diagnostics.Type_alias_0_circularly_references_itself, symbolToString(symbol));
                }
                var _links_declaredType;
                (_links_declaredType = links.declaredType) !== null && _links_declaredType !== void 0 ? _links_declaredType : links.declaredType = type;
            }
            return links.declaredType;
        }
        function getBaseTypeOfEnumLikeType(type) {
            return type.flags & 1056 /* EnumLike */  && type.symbol.flags & 8 /* EnumMember */  ? getDeclaredTypeOfSymbol(getParentOfSymbol(type.symbol)) : type;
        }
        function getDeclaredTypeOfEnum(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.declaredType) {
                const memberTypeList = [];
                if (symbol.declarations) {
                    for (const declaration of symbol.declarations)if (declaration.kind === 267 /* EnumDeclaration */ ) {
                        for (const member of declaration.members)if (hasBindableName(member)) {
                            const memberSymbol = getSymbolOfDeclaration(member);
                            const value1 = getEnumMemberValue(member).value;
                            const memberType = getFreshTypeOfLiteralType(value1 !== void 0 ? getEnumLiteralType(value1, getSymbolId(symbol), memberSymbol) : createComputedEnumType(memberSymbol));
                            getSymbolLinks(memberSymbol).declaredType = memberType;
                            memberTypeList.push(getRegularTypeOfLiteralType(memberType));
                        }
                    }
                }
                const enumType = memberTypeList.length ? getUnionType(memberTypeList, 1 /* Literal */ , symbol, /*aliasTypeArguments*/ void 0) : createComputedEnumType(symbol);
                if (enumType.flags & 1048576 /* Union */ ) {
                    enumType.flags |= 1024 /* EnumLiteral */ ;
                    enumType.symbol = symbol;
                }
                links.declaredType = enumType;
            }
            return links.declaredType;
        }
        function createComputedEnumType(symbol) {
            const regularType = createTypeWithSymbol(32 /* Enum */ , symbol);
            const freshType = createTypeWithSymbol(32 /* Enum */ , symbol);
            regularType.regularType = regularType;
            regularType.freshType = freshType;
            freshType.regularType = regularType;
            freshType.freshType = freshType;
            return regularType;
        }
        function getDeclaredTypeOfEnumMember(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.declaredType) {
                const enumType = getDeclaredTypeOfEnum(getParentOfSymbol(symbol));
                if (!links.declaredType) links.declaredType = enumType;
            }
            return links.declaredType;
        }
        function getDeclaredTypeOfTypeParameter(symbol) {
            const links = getSymbolLinks(symbol);
            return links.declaredType || (links.declaredType = createTypeParameter(symbol));
        }
        function getDeclaredTypeOfAlias(symbol) {
            const links = getSymbolLinks(symbol);
            return links.declaredType || (links.declaredType = getDeclaredTypeOfSymbol(resolveAlias(symbol)));
        }
        function getDeclaredTypeOfSymbol(symbol) {
            return tryGetDeclaredTypeOfSymbol(symbol) || errorType;
        }
        function tryGetDeclaredTypeOfSymbol(symbol) {
            if (symbol.flags & 96 /* Interface */ ) return getDeclaredTypeOfClassOrInterface(symbol);
            if (symbol.flags & 524288 /* TypeAlias */ ) return getDeclaredTypeOfTypeAlias(symbol);
            if (symbol.flags & 262144 /* TypeParameter */ ) return getDeclaredTypeOfTypeParameter(symbol);
            if (symbol.flags & 384 /* Enum */ ) return getDeclaredTypeOfEnum(symbol);
            if (symbol.flags & 8 /* EnumMember */ ) return getDeclaredTypeOfEnumMember(symbol);
            if (symbol.flags & 2097152 /* Alias */ ) return getDeclaredTypeOfAlias(symbol);
            return void 0;
        }
        function isThislessType(node) {
            switch(node.kind){
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 154 /* StringKeyword */ :
                case 150 /* NumberKeyword */ :
                case 163 /* BigIntKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 151 /* ObjectKeyword */ :
                case 116 /* VoidKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 146 /* NeverKeyword */ :
                case 202 /* LiteralType */ :
                    return true;
                case 189 /* ArrayType */ :
                    return isThislessType(node.elementType);
                case 184 /* TypeReference */ :
                    return !node.typeArguments || node.typeArguments.every(isThislessType);
            }
            return false;
        }
        function isThislessTypeParameter(node) {
            const constraint = getEffectiveConstraintOfTypeParameter(node);
            return !constraint || isThislessType(constraint);
        }
        function isThislessVariableLikeDeclaration(node) {
            const typeNode = getEffectiveTypeAnnotationNode(node);
            return typeNode ? isThislessType(typeNode) : !hasInitializer(node);
        }
        function isThislessFunctionLikeDeclaration(node) {
            const returnType = getEffectiveReturnTypeNode(node);
            const typeParameters = getEffectiveTypeParameterDeclarations(node);
            return (node.kind === 177 /* Constructor */  || !!returnType && isThislessType(returnType)) && node.parameters.every(isThislessVariableLikeDeclaration) && typeParameters.every(isThislessTypeParameter);
        }
        function isThisless(symbol) {
            if (symbol.declarations && symbol.declarations.length === 1) {
                const declaration = symbol.declarations[0];
                if (declaration) switch(declaration.kind){
                    case 173 /* PropertyDeclaration */ :
                    case 172 /* PropertySignature */ :
                        return isThislessVariableLikeDeclaration(declaration);
                    case 175 /* MethodDeclaration */ :
                    case 174 /* MethodSignature */ :
                    case 177 /* Constructor */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        return isThislessFunctionLikeDeclaration(declaration);
                }
            }
            return false;
        }
        function createInstantiatedSymbolTable(symbols, mapper, mappingThisOnly) {
            const result = createSymbolTable();
            for (const symbol of symbols)result.set(symbol.escapedName, mappingThisOnly && isThisless(symbol) ? symbol : instantiateSymbol(symbol, mapper));
            return result;
        }
        function addInheritedMembers(symbols, baseSymbols) {
            for (const base of baseSymbols){
                if (isStaticPrivateIdentifierProperty(base)) continue;
                const derived = symbols.get(base.escapedName);
                if (!derived || derived.valueDeclaration && isBinaryExpression(derived.valueDeclaration) && !isConstructorDeclaredProperty(derived) && !getContainingClassStaticBlock(derived.valueDeclaration)) {
                    symbols.set(base.escapedName, base);
                    symbols.set(base.escapedName, base);
                }
            }
        }
        function isStaticPrivateIdentifierProperty(s) {
            return !!s.valueDeclaration && isPrivateIdentifierClassElementDeclaration(s.valueDeclaration) && isStatic(s.valueDeclaration);
        }
        function resolveDeclaredMembers(type) {
            if (!type.declaredProperties) {
                const symbol = type.symbol;
                const members = getMembersOfSymbol(symbol);
                type.declaredProperties = getNamedMembers(members);
                type.declaredCallSignatures = emptyArray;
                type.declaredConstructSignatures = emptyArray;
                type.declaredIndexInfos = emptyArray;
                type.declaredCallSignatures = getSignaturesOfSymbol(members.get("__call" /* Call */ ));
                type.declaredConstructSignatures = getSignaturesOfSymbol(members.get("__new" /* New */ ));
                type.declaredIndexInfos = getIndexInfosOfSymbol(symbol);
            }
            return type;
        }
        function isLateBindableName(node) {
            return isLateBindableAST(node) && isTypeUsableAsPropertyName(isComputedPropertyName(node) ? checkComputedPropertyName(node) : checkExpressionCached(node.argumentExpression));
        }
        function isLateBindableIndexSignature(node) {
            return isLateBindableAST(node) && isTypeUsableAsIndexSignature(isComputedPropertyName(node) ? checkComputedPropertyName(node) : checkExpressionCached(node.argumentExpression));
        }
        function isLateBindableAST(node) {
            if (!isComputedPropertyName(node) && !isElementAccessExpression(node)) return false;
            const expr = isComputedPropertyName(node) ? node.expression : node.argumentExpression;
            return isEntityNameExpression(expr);
        }
        function isTypeUsableAsIndexSignature(type) {
            return isTypeAssignableTo(type, stringNumberSymbolType);
        }
        function isLateBoundName(name) {
            return name.charCodeAt(0) === 95 /* _ */  && name.charCodeAt(1) === 95 /* _ */  && name.charCodeAt(2) === 64 /* at */ ;
        }
        function hasLateBindableName(node) {
            const name = getNameOfDeclaration(node);
            return !!name && isLateBindableName(name);
        }
        function hasLateBindableIndexSignature(node) {
            const name = getNameOfDeclaration(node);
            return !!name && isLateBindableIndexSignature(name);
        }
        function hasBindableName(node) {
            return !hasDynamicName(node) || hasLateBindableName(node);
        }
        function isNonBindableDynamicName(node) {
            return isDynamicName(node) && !isLateBindableName(node);
        }
        function addDeclarationToLateBoundSymbol(symbol, member, symbolFlags) {
            Debug.assert(!!(getCheckFlags(symbol) & 4096 /* Late */ ), "Expected a late-bound symbol.");
            symbol.flags |= symbolFlags;
            getSymbolLinks(member.symbol).lateSymbol = symbol;
            if (!symbol.declarations) symbol.declarations = [
                member
            ];
            else if (!member.symbol.isReplaceableByMethod) symbol.declarations.push(member);
            if (symbolFlags & 111551 /* Value */ ) setValueDeclaration(symbol, member);
        }
        function lateBindMember(parent2, earlySymbols, lateSymbols, decl) {
            Debug.assert(!!decl.symbol, "The member is expected to have a symbol.");
            const links = getNodeLinks(decl);
            if (!links.resolvedSymbol) {
                links.resolvedSymbol = decl.symbol;
                const declName = isBinaryExpression(decl) ? decl.left : decl.name;
                const type = isElementAccessExpression(declName) ? checkExpressionCached(declName.argumentExpression) : checkComputedPropertyName(declName);
                if (isTypeUsableAsPropertyName(type)) {
                    const memberName = getPropertyNameFromType(type);
                    const symbolFlags = decl.symbol.flags;
                    let lateSymbol = lateSymbols.get(memberName);
                    if (!lateSymbol) lateSymbols.set(memberName, lateSymbol = createSymbol(0 /* None */ , memberName, 4096 /* Late */ ));
                    const earlySymbol = earlySymbols && earlySymbols.get(memberName);
                    if (!(parent2.flags & 32 /* Class */ ) && lateSymbol.flags & getExcludedSymbolFlags(symbolFlags)) {
                        const declarations = earlySymbol ? concatenate(earlySymbol.declarations, lateSymbol.declarations) : lateSymbol.declarations;
                        const name = !(type.flags & 8192 /* UniqueESSymbol */ ) && unescapeLeadingUnderscores(memberName) || declarationNameToString(declName);
                        forEach(declarations, (declaration)=>error2(getNameOfDeclaration(declaration) || declaration, Diagnostics.Property_0_was_also_declared_here, name));
                        error2(declName || decl, Diagnostics.Duplicate_property_0, name);
                        lateSymbol = createSymbol(0 /* None */ , memberName, 4096 /* Late */ );
                    }
                    lateSymbol.links.nameType = type;
                    addDeclarationToLateBoundSymbol(lateSymbol, decl, symbolFlags);
                    if (lateSymbol.parent) Debug.assert(lateSymbol.parent === parent2, "Existing symbol parent should match new one");
                    else lateSymbol.parent = parent2;
                    return links.resolvedSymbol = lateSymbol;
                }
            }
            return links.resolvedSymbol;
        }
        function lateBindIndexSignature(parent2, earlySymbols, lateSymbols, decl) {
            let indexSymbol = lateSymbols.get("__index" /* Index */ );
            if (!indexSymbol) {
                const early = earlySymbols == null ? void 0 : earlySymbols.get("__index" /* Index */ );
                if (!early) indexSymbol = createSymbol(0 /* None */ , "__index" /* Index */ , 4096 /* Late */ );
                else {
                    indexSymbol = cloneSymbol(early);
                    indexSymbol.links.checkFlags |= 4096 /* Late */ ;
                }
                lateSymbols.set("__index" /* Index */ , indexSymbol);
            }
            if (!indexSymbol.declarations) indexSymbol.declarations = [
                decl
            ];
            else if (!decl.symbol.isReplaceableByMethod) indexSymbol.declarations.push(decl);
        }
        function getResolvedMembersOrExportsOfSymbol(symbol, resolutionKind) {
            const links = getSymbolLinks(symbol);
            if (!links[resolutionKind]) {
                const isStatic2 = resolutionKind === "resolvedExports" /* resolvedExports */ ;
                const earlySymbols = !isStatic2 ? symbol.members : symbol.flags & 1536 /* Module */  ? getExportsOfModuleWorker(symbol).exports : symbol.exports;
                links[resolutionKind] = earlySymbols || emptySymbols;
                const lateSymbols = createSymbolTable();
                for (const decl of symbol.declarations || emptyArray){
                    const members = getMembersOfDeclaration(decl);
                    if (members) {
                        for (const member of members)if (isStatic2 === hasStaticModifier(member)) {
                            if (hasLateBindableName(member)) lateBindMember(symbol, earlySymbols, lateSymbols, member);
                            else if (hasLateBindableIndexSignature(member)) lateBindIndexSignature(symbol, earlySymbols, lateSymbols, member);
                        }
                    }
                }
                const assignments = getFunctionExpressionParentSymbolOrSymbol(symbol).assignmentDeclarationMembers;
                if (assignments) {
                    const decls = arrayFrom(assignments.values());
                    for (const member of decls){
                        const assignmentKind = getAssignmentDeclarationKind(member);
                        const isInstanceMember = assignmentKind === 3 /* PrototypeProperty */  || isBinaryExpression(member) && isPossiblyAliasedThisProperty(member, assignmentKind) || assignmentKind === 9 /* ObjectDefinePrototypeProperty */  || assignmentKind === 6 /* Prototype */ ;
                        if (isStatic2 === !isInstanceMember) {
                            if (hasLateBindableName(member)) lateBindMember(symbol, earlySymbols, lateSymbols, member);
                        }
                    }
                }
                let resolved = combineSymbolTables(earlySymbols, lateSymbols);
                if (symbol.flags & 33554432 /* Transient */  && links.cjsExportMerged && symbol.declarations) for (const decl of symbol.declarations){
                    const original = getSymbolLinks(decl.symbol)[resolutionKind];
                    if (!resolved) {
                        resolved = original;
                        continue;
                    }
                    if (!original) continue;
                    original.forEach((s, name)=>{
                        const existing = resolved.get(name);
                        if (!existing) resolved.set(name, s);
                        else if (existing === s) return;
                        else resolved.set(name, mergeSymbol(existing, s));
                    });
                }
                links[resolutionKind] = resolved || emptySymbols;
            }
            return links[resolutionKind];
        }
        function getMembersOfSymbol(symbol) {
            return symbol.flags & 6256 /* LateBindingContainer */  ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedMembers" /* resolvedMembers */ ) : symbol.members || emptySymbols;
        }
        function getLateBoundSymbol(symbol) {
            if (symbol.flags & 106500 /* ClassMember */  && symbol.escapedName === "__computed" /* Computed */ ) {
                const links = getSymbolLinks(symbol);
                if (!links.lateSymbol && some(symbol.declarations, hasLateBindableName)) {
                    const parent2 = getMergedSymbol(symbol.parent);
                    if (some(symbol.declarations, hasStaticModifier)) getExportsOfSymbol(parent2);
                    else getMembersOfSymbol(parent2);
                }
                return links.lateSymbol || (links.lateSymbol = symbol);
            }
            return symbol;
        }
        function getTypeWithThisArgument(type, thisArgument, needApparentType) {
            if (getObjectFlags(type) & 4 /* Reference */ ) {
                const target = type.target;
                const typeArguments = getTypeArguments(type);
                return length(target.typeParameters) === length(typeArguments) ? createTypeReference(target, concatenate(typeArguments, [
                    thisArgument || target.thisType
                ])) : type;
            } else if (type.flags & 2097152 /* Intersection */ ) {
                const types = sameMap(type.types, (t)=>getTypeWithThisArgument(t, thisArgument, needApparentType));
                return types !== type.types ? getIntersectionType(types) : type;
            }
            return needApparentType ? getApparentType(type) : type;
        }
        function resolveObjectTypeMembers(type, source, typeParameters, typeArguments) {
            let mapper;
            let members;
            let callSignatures;
            let constructSignatures;
            let indexInfos;
            if (rangeEquals(typeParameters, typeArguments, 0, typeParameters.length)) {
                members = source.symbol ? getMembersOfSymbol(source.symbol) : createSymbolTable(source.declaredProperties);
                callSignatures = source.declaredCallSignatures;
                constructSignatures = source.declaredConstructSignatures;
                indexInfos = source.declaredIndexInfos;
            } else {
                mapper = createTypeMapper(typeParameters, typeArguments);
                members = createInstantiatedSymbolTable(source.declaredProperties, mapper, /*mappingThisOnly*/ typeParameters.length === 1);
                callSignatures = instantiateSignatures(source.declaredCallSignatures, mapper);
                constructSignatures = instantiateSignatures(source.declaredConstructSignatures, mapper);
                indexInfos = instantiateIndexInfos(source.declaredIndexInfos, mapper);
            }
            const baseTypes = getBaseTypes(source);
            if (baseTypes.length) {
                if (source.symbol && members === getMembersOfSymbol(source.symbol)) {
                    const symbolTable = createSymbolTable(source.declaredProperties);
                    const sourceIndex = getIndexSymbol(source.symbol);
                    if (sourceIndex) symbolTable.set("__index" /* Index */ , sourceIndex);
                    members = symbolTable;
                }
                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, indexInfos);
                const thisArgument = lastOrUndefined(typeArguments);
                for (const baseType of baseTypes){
                    const instantiatedBaseType = thisArgument ? getTypeWithThisArgument(instantiateType(baseType, mapper), thisArgument) : baseType;
                    addInheritedMembers(members, getPropertiesOfType(instantiatedBaseType));
                    callSignatures = concatenate(callSignatures, getSignaturesOfType(instantiatedBaseType, 0 /* Call */ ));
                    constructSignatures = concatenate(constructSignatures, getSignaturesOfType(instantiatedBaseType, 1 /* Construct */ ));
                    const inheritedIndexInfos = instantiatedBaseType !== anyType ? getIndexInfosOfType(instantiatedBaseType) : [
                        anyBaseTypeIndexInfo
                    ];
                    indexInfos = concatenate(indexInfos, filter(inheritedIndexInfos, (info)=>!findIndexInfo(indexInfos, info.keyType)));
                }
            }
            setStructuredTypeMembers(type, members, callSignatures, constructSignatures, indexInfos);
        }
        function resolveClassOrInterfaceMembers(type) {
            resolveObjectTypeMembers(type, resolveDeclaredMembers(type), emptyArray, emptyArray);
        }
        function resolveTypeReferenceMembers(type) {
            const source = resolveDeclaredMembers(type.target);
            const typeParameters = concatenate(source.typeParameters, [
                source.thisType
            ]);
            const typeArguments = getTypeArguments(type);
            const paddedTypeArguments = typeArguments.length === typeParameters.length ? typeArguments : concatenate(typeArguments, [
                type
            ]);
            resolveObjectTypeMembers(type, source, typeParameters, paddedTypeArguments);
        }
        function createSignature(declaration, typeParameters, thisParameter, parameters, resolvedReturnType, resolvedTypePredicate, minArgumentCount, flags) {
            const sig = new Signature13(checker, flags);
            sig.declaration = declaration;
            sig.typeParameters = typeParameters;
            sig.parameters = parameters;
            sig.thisParameter = thisParameter;
            sig.resolvedReturnType = resolvedReturnType;
            sig.resolvedTypePredicate = resolvedTypePredicate;
            sig.minArgumentCount = minArgumentCount;
            sig.resolvedMinArgumentCount = void 0;
            sig.target = void 0;
            sig.mapper = void 0;
            sig.compositeSignatures = void 0;
            sig.compositeKind = void 0;
            return sig;
        }
        function cloneSignature(sig) {
            const result = createSignature(sig.declaration, sig.typeParameters, sig.thisParameter, sig.parameters, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, sig.minArgumentCount, sig.flags & 167 /* PropagatingFlags */ );
            result.target = sig.target;
            result.mapper = sig.mapper;
            result.compositeSignatures = sig.compositeSignatures;
            result.compositeKind = sig.compositeKind;
            return result;
        }
        function createUnionSignature(signature, unionSignatures) {
            const result = cloneSignature(signature);
            result.compositeSignatures = unionSignatures;
            result.compositeKind = 1048576 /* Union */ ;
            result.target = void 0;
            result.mapper = void 0;
            return result;
        }
        function getOptionalCallSignature(signature, callChainFlags) {
            if ((signature.flags & 24 /* CallChainFlags */ ) === callChainFlags) return signature;
            if (!signature.optionalCallSignatureCache) signature.optionalCallSignatureCache = {};
            const key = callChainFlags === 8 /* IsInnerCallChain */  ? "inner" : "outer";
            return signature.optionalCallSignatureCache[key] || (signature.optionalCallSignatureCache[key] = createOptionalCallSignature(signature, callChainFlags));
        }
        function createOptionalCallSignature(signature, callChainFlags) {
            Debug.assert(callChainFlags === 8 /* IsInnerCallChain */  || callChainFlags === 16 /* IsOuterCallChain */ , "An optional call signature can either be for an inner call chain or an outer call chain, but not both.");
            const result = cloneSignature(signature);
            result.flags |= callChainFlags;
            return result;
        }
        function getExpandedParameters(sig, skipUnionExpanding) {
            if (signatureHasRestParameter(sig)) {
                const restIndex = sig.parameters.length - 1;
                const restSymbol = sig.parameters[restIndex];
                const restType = getTypeOfSymbol(restSymbol);
                if (isTupleType(restType)) return [
                    expandSignatureParametersWithTupleMembers(restType, restIndex, restSymbol)
                ];
                else if (!skipUnionExpanding && restType.flags & 1048576 /* Union */  && every(restType.types, isTupleType)) return map(restType.types, (t)=>expandSignatureParametersWithTupleMembers(t, restIndex, restSymbol));
            }
            return [
                sig.parameters
            ];
            function expandSignatureParametersWithTupleMembers(restType, restIndex, restSymbol) {
                const elementTypes = getTypeArguments(restType);
                const associatedNames = getUniqAssociatedNamesFromTupleType(restType, restSymbol);
                const restParams = map(elementTypes, (t, i)=>{
                    const name = associatedNames && associatedNames[i] ? associatedNames[i] : getParameterNameAtPosition(sig, restIndex + i, restType);
                    const flags = restType.target.elementFlags[i];
                    const checkFlags = flags & 12 /* Variable */  ? 32768 /* RestParameter */  : flags & 2 /* Optional */  ? 16384 /* OptionalParameter */  : 0;
                    const symbol = createSymbol(1 /* FunctionScopedVariable */ , name, checkFlags);
                    symbol.links.type = flags & 4 /* Rest */  ? createArrayType(t) : t;
                    return symbol;
                });
                return concatenate(sig.parameters.slice(0, restIndex), restParams);
            }
            function getUniqAssociatedNamesFromTupleType(type, restSymbol) {
                const names = map(type.target.labeledElementDeclarations, (labeledElement, i)=>getTupleElementLabel(labeledElement, i, type.target.elementFlags[i], restSymbol));
                if (names) {
                    const duplicates = [];
                    const uniqueNames = /* @__PURE__ */ new Set();
                    for(let i = 0; i < names.length; i++){
                        const name = names[i];
                        if (!tryAddToSet(uniqueNames, name)) duplicates.push(i);
                    }
                    const counters = /* @__PURE__ */ new Map();
                    for (const i of duplicates){
                        var _counters_get;
                        let counter = (_counters_get = counters.get(names[i])) !== null && _counters_get !== void 0 ? _counters_get : 1;
                        let name;
                        while(!tryAddToSet(uniqueNames, name = `${names[i]}_${counter}`))counter++;
                        names[i] = name;
                        counters.set(names[i], counter + 1);
                    }
                }
                return names;
            }
        }
        function getDefaultConstructSignatures(classType) {
            const baseConstructorType = getBaseConstructorTypeOfClass(classType);
            const baseSignatures = getSignaturesOfType(baseConstructorType, 1 /* Construct */ );
            const declaration = getClassLikeDeclarationOfSymbol(classType.symbol);
            const isAbstract = !!declaration && hasSyntacticModifier(declaration, 64 /* Abstract */ );
            if (baseSignatures.length === 0) return [
                createSignature(/*declaration*/ void 0, classType.localTypeParameters, /*thisParameter*/ void 0, emptyArray, classType, /*resolvedTypePredicate*/ void 0, 0, isAbstract ? 4 /* Abstract */  : 0 /* None */ )
            ];
            const baseTypeNode = getBaseTypeNodeOfClass(classType);
            const isJavaScript = isInJSFile(baseTypeNode);
            const typeArguments = typeArgumentsFromTypeReferenceNode(baseTypeNode);
            const typeArgCount = length(typeArguments);
            const result = [];
            for (const baseSig of baseSignatures){
                const minTypeArgumentCount = getMinTypeArgumentCount(baseSig.typeParameters);
                const typeParamCount = length(baseSig.typeParameters);
                if (isJavaScript || typeArgCount >= minTypeArgumentCount && typeArgCount <= typeParamCount) {
                    const sig = typeParamCount ? createSignatureInstantiation(baseSig, fillMissingTypeArguments(typeArguments, baseSig.typeParameters, minTypeArgumentCount, isJavaScript)) : cloneSignature(baseSig);
                    sig.typeParameters = classType.localTypeParameters;
                    sig.resolvedReturnType = classType;
                    sig.flags = isAbstract ? sig.flags | 4 /* Abstract */  : sig.flags & -5 /* Abstract */ ;
                    result.push(sig);
                }
            }
            return result;
        }
        function findMatchingSignature(signatureList, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes) {
            for (const s of signatureList){
                if (compareSignaturesIdentical(s, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes, partialMatch ? compareTypesSubtypeOf : compareTypesIdentical)) return s;
            }
        }
        function findMatchingSignatures(signatureLists, signature, listIndex) {
            if (signature.typeParameters) {
                if (listIndex > 0) return void 0;
                for(let i = 1; i < signatureLists.length; i++){
                    if (!findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false)) return void 0;
                }
                return [
                    signature
                ];
            }
            let result;
            for(let i = 0; i < signatureLists.length; i++){
                const match = i === listIndex ? signature : findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true) || findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ true, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true);
                if (!match) return void 0;
                result = appendIfUnique(result, match);
            }
            return result;
        }
        function getUnionSignatures(signatureLists) {
            let result;
            let indexWithLengthOverOne;
            for(let i = 0; i < signatureLists.length; i++){
                if (signatureLists[i].length === 0) return emptyArray;
                if (signatureLists[i].length > 1) indexWithLengthOverOne = indexWithLengthOverOne === void 0 ? i : -1;
                for (const signature of signatureLists[i])if (!result || !findMatchingSignature(result, signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ true)) {
                    const unionSignatures = findMatchingSignatures(signatureLists, signature, i);
                    if (unionSignatures) {
                        let s = signature;
                        if (unionSignatures.length > 1) {
                            let thisParameter = signature.thisParameter;
                            const firstThisParameterOfUnionSignatures = forEach(unionSignatures, (sig)=>sig.thisParameter);
                            if (firstThisParameterOfUnionSignatures) {
                                const thisType = getIntersectionType(mapDefined(unionSignatures, (sig)=>sig.thisParameter && getTypeOfSymbol(sig.thisParameter)));
                                thisParameter = createSymbolWithType(firstThisParameterOfUnionSignatures, thisType);
                            }
                            s = createUnionSignature(signature, unionSignatures);
                            s.thisParameter = thisParameter;
                        }
                        (result || (result = [])).push(s);
                    }
                }
            }
            if (!length(result) && indexWithLengthOverOne !== -1) {
                const masterList = signatureLists[indexWithLengthOverOne !== void 0 ? indexWithLengthOverOne : 0];
                let results = masterList.slice();
                for (const signatures of signatureLists)if (signatures !== masterList) {
                    const signature = signatures[0];
                    Debug.assert(!!signature, "getUnionSignatures bails early on empty signature lists and should not have empty lists on second pass");
                    results = !!signature.typeParameters && some(results, (s)=>!!s.typeParameters && !compareTypeParametersIdentical(signature.typeParameters, s.typeParameters)) ? void 0 : map(results, (sig)=>combineSignaturesOfUnionMembers(sig, signature));
                    if (!results) break;
                }
                result = results;
            }
            return result || emptyArray;
        }
        function compareTypeParametersIdentical(sourceParams, targetParams) {
            if (length(sourceParams) !== length(targetParams)) return false;
            if (!sourceParams || !targetParams) return true;
            const mapper = createTypeMapper(targetParams, sourceParams);
            for(let i = 0; i < sourceParams.length; i++){
                const source = sourceParams[i];
                const target = targetParams[i];
                if (source === target) continue;
                if (!isTypeIdenticalTo(getConstraintFromTypeParameter(source) || unknownType, instantiateType(getConstraintFromTypeParameter(target) || unknownType, mapper))) return false;
            }
            return true;
        }
        function combineUnionThisParam(left, right, mapper) {
            if (!left || !right) return left || right;
            const thisType = getIntersectionType([
                getTypeOfSymbol(left),
                instantiateType(getTypeOfSymbol(right), mapper)
            ]);
            return createSymbolWithType(left, thisType);
        }
        function combineUnionParameters(left, right, mapper) {
            const leftCount = getParameterCount(left);
            const rightCount = getParameterCount(right);
            const longest = leftCount >= rightCount ? left : right;
            const shorter = longest === left ? right : left;
            const longestCount = longest === left ? leftCount : rightCount;
            const eitherHasEffectiveRest = hasEffectiveRestParameter(left) || hasEffectiveRestParameter(right);
            const needsExtraRestElement = eitherHasEffectiveRest && !hasEffectiveRestParameter(longest);
            const params = new Array(longestCount + (needsExtraRestElement ? 1 : 0));
            for(let i = 0; i < longestCount; i++){
                let longestParamType = tryGetTypeAtPosition(longest, i);
                if (longest === right) longestParamType = instantiateType(longestParamType, mapper);
                let shorterParamType = tryGetTypeAtPosition(shorter, i) || unknownType;
                if (shorter === right) shorterParamType = instantiateType(shorterParamType, mapper);
                const unionParamType = getIntersectionType([
                    longestParamType,
                    shorterParamType
                ]);
                const isRestParam = eitherHasEffectiveRest && !needsExtraRestElement && i === longestCount - 1;
                const isOptional = i >= getMinArgumentCount(longest) && i >= getMinArgumentCount(shorter);
                const leftName = i >= leftCount ? void 0 : getParameterNameAtPosition(left, i);
                const rightName = i >= rightCount ? void 0 : getParameterNameAtPosition(right, i);
                const paramName = leftName === rightName ? leftName : !leftName ? rightName : !rightName ? leftName : void 0;
                const paramSymbol = createSymbol(1 /* FunctionScopedVariable */  | (isOptional && !isRestParam ? 16777216 /* Optional */  : 0), paramName || `arg${i}`, isRestParam ? 32768 /* RestParameter */  : isOptional ? 16384 /* OptionalParameter */  : 0);
                paramSymbol.links.type = isRestParam ? createArrayType(unionParamType) : unionParamType;
                params[i] = paramSymbol;
            }
            if (needsExtraRestElement) {
                const restParamSymbol = createSymbol(1 /* FunctionScopedVariable */ , "args", 32768 /* RestParameter */ );
                restParamSymbol.links.type = createArrayType(getTypeAtPosition(shorter, longestCount));
                if (shorter === right) restParamSymbol.links.type = instantiateType(restParamSymbol.links.type, mapper);
                params[longestCount] = restParamSymbol;
            }
            return params;
        }
        function combineSignaturesOfUnionMembers(left, right) {
            const typeParams = left.typeParameters || right.typeParameters;
            let paramMapper;
            if (left.typeParameters && right.typeParameters) paramMapper = createTypeMapper(right.typeParameters, left.typeParameters);
            let flags = (left.flags | right.flags) & 166 /* HasRestParameter */ ;
            const declaration = left.declaration;
            const params = combineUnionParameters(left, right, paramMapper);
            const lastParam = lastOrUndefined(params);
            if (lastParam && getCheckFlags(lastParam) & 32768 /* RestParameter */ ) flags |= 1 /* HasRestParameter */ ;
            const thisParam = combineUnionThisParam(left.thisParameter, right.thisParameter, paramMapper);
            const minArgCount = Math.max(left.minArgumentCount, right.minArgumentCount);
            const result = createSignature(declaration, typeParams, thisParam, params, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, minArgCount, flags);
            result.compositeKind = 1048576 /* Union */ ;
            result.compositeSignatures = concatenate(left.compositeKind !== 2097152 /* Intersection */  && left.compositeSignatures || [
                left
            ], [
                right
            ]);
            if (paramMapper) result.mapper = left.compositeKind !== 2097152 /* Intersection */  && left.mapper && left.compositeSignatures ? combineTypeMappers(left.mapper, paramMapper) : paramMapper;
            else if (left.compositeKind !== 2097152 /* Intersection */  && left.mapper && left.compositeSignatures) result.mapper = left.mapper;
            return result;
        }
        function getUnionIndexInfos(types) {
            const sourceInfos = getIndexInfosOfType(types[0]);
            if (sourceInfos) {
                const result = [];
                for (const info of sourceInfos){
                    const indexType = info.keyType;
                    if (every(types, (t)=>!!getIndexInfoOfType(t, indexType))) result.push(createIndexInfo(indexType, getUnionType(map(types, (t)=>getIndexTypeOfType(t, indexType))), some(types, (t)=>getIndexInfoOfType(t, indexType).isReadonly)));
                }
                return result;
            }
            return emptyArray;
        }
        function resolveUnionTypeMembers(type) {
            const callSignatures = getUnionSignatures(map(type.types, (t)=>t === globalFunctionType ? [
                    unknownSignature
                ] : getSignaturesOfType(t, 0 /* Call */ )));
            const constructSignatures = getUnionSignatures(map(type.types, (t)=>getSignaturesOfType(t, 1 /* Construct */ )));
            const indexInfos = getUnionIndexInfos(type.types);
            setStructuredTypeMembers(type, emptySymbols, callSignatures, constructSignatures, indexInfos);
        }
        function intersectTypes(type1, type2) {
            return !type1 ? type2 : !type2 ? type1 : getIntersectionType([
                type1,
                type2
            ]);
        }
        function findMixins(types) {
            const constructorTypeCount = countWhere(types, (t)=>getSignaturesOfType(t, 1 /* Construct */ ).length > 0);
            const mixinFlags = map(types, isMixinConstructorType);
            if (constructorTypeCount > 0 && constructorTypeCount === countWhere(mixinFlags, (b)=>b)) {
                const firstMixinIndex = mixinFlags.indexOf(/*searchElement*/ true);
                mixinFlags[firstMixinIndex] = false;
            }
            return mixinFlags;
        }
        function includeMixinType(type, types, mixinFlags, index) {
            const mixedTypes = [];
            for(let i = 0; i < types.length; i++){
                if (i === index) mixedTypes.push(type);
                else if (mixinFlags[i]) mixedTypes.push(getReturnTypeOfSignature(getSignaturesOfType(types[i], 1 /* Construct */ )[0]));
            }
            return getIntersectionType(mixedTypes);
        }
        function resolveIntersectionTypeMembers(type) {
            let callSignatures;
            let constructSignatures;
            let indexInfos;
            const types = type.types;
            const mixinFlags = findMixins(types);
            const mixinCount = countWhere(mixinFlags, (b)=>b);
            for(let i = 0; i < types.length; i++){
                const t = type.types[i];
                if (!mixinFlags[i]) {
                    let signatures = getSignaturesOfType(t, 1 /* Construct */ );
                    if (signatures.length && mixinCount > 0) signatures = map(signatures, (s)=>{
                        const clone2 = cloneSignature(s);
                        clone2.resolvedReturnType = includeMixinType(getReturnTypeOfSignature(s), types, mixinFlags, i);
                        return clone2;
                    });
                    constructSignatures = appendSignatures(constructSignatures, signatures);
                }
                callSignatures = appendSignatures(callSignatures, getSignaturesOfType(t, 0 /* Call */ ));
                indexInfos = reduceLeft(getIndexInfosOfType(t), (infos, newInfo)=>appendIndexInfo(infos, newInfo, /*union*/ false), indexInfos);
            }
            setStructuredTypeMembers(type, emptySymbols, callSignatures || emptyArray, constructSignatures || emptyArray, indexInfos || emptyArray);
        }
        function appendSignatures(signatures, newSignatures) {
            for (const sig of newSignatures)if (!signatures || every(signatures, (s)=>!compareSignaturesIdentical(s, sig, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false, compareTypesIdentical))) signatures = append(signatures, sig);
            return signatures;
        }
        function appendIndexInfo(indexInfos, newInfo, union) {
            if (indexInfos) for(let i = 0; i < indexInfos.length; i++){
                const info = indexInfos[i];
                if (info.keyType === newInfo.keyType) {
                    indexInfos[i] = createIndexInfo(info.keyType, union ? getUnionType([
                        info.type,
                        newInfo.type
                    ]) : getIntersectionType([
                        info.type,
                        newInfo.type
                    ]), union ? info.isReadonly || newInfo.isReadonly : info.isReadonly && newInfo.isReadonly);
                    return indexInfos;
                }
            }
            return append(indexInfos, newInfo);
        }
        function resolveAnonymousTypeMembers(type) {
            if (type.target) {
                setStructuredTypeMembers(type, emptySymbols, emptyArray, emptyArray, emptyArray);
                const members2 = createInstantiatedSymbolTable(getPropertiesOfObjectType(type.target), type.mapper, /*mappingThisOnly*/ false);
                const callSignatures = instantiateSignatures(getSignaturesOfType(type.target, 0 /* Call */ ), type.mapper);
                const constructSignatures = instantiateSignatures(getSignaturesOfType(type.target, 1 /* Construct */ ), type.mapper);
                const indexInfos2 = instantiateIndexInfos(getIndexInfosOfType(type.target), type.mapper);
                setStructuredTypeMembers(type, members2, callSignatures, constructSignatures, indexInfos2);
                return;
            }
            const symbol = getMergedSymbol(type.symbol);
            if (symbol.flags & 2048 /* TypeLiteral */ ) {
                setStructuredTypeMembers(type, emptySymbols, emptyArray, emptyArray, emptyArray);
                const members2 = getMembersOfSymbol(symbol);
                const callSignatures = getSignaturesOfSymbol(members2.get("__call" /* Call */ ));
                const constructSignatures = getSignaturesOfSymbol(members2.get("__new" /* New */ ));
                const indexInfos2 = getIndexInfosOfSymbol(symbol);
                setStructuredTypeMembers(type, members2, callSignatures, constructSignatures, indexInfos2);
                return;
            }
            let members = getExportsOfSymbol(symbol);
            let indexInfos;
            if (symbol === globalThisSymbol) {
                const varsOnly = /* @__PURE__ */ new Map();
                members.forEach((p)=>{
                    var _a;
                    if (!(p.flags & 418 /* BlockScoped */ ) && !(p.flags & 512 /* ValueModule */  && ((_a = p.declarations) == null ? void 0 : _a.length) && every(p.declarations, isAmbientModule))) varsOnly.set(p.escapedName, p);
                });
                members = varsOnly;
            }
            let baseConstructorIndexInfo;
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, emptyArray);
            if (symbol.flags & 32 /* Class */ ) {
                const classType = getDeclaredTypeOfClassOrInterface(symbol);
                const baseConstructorType = getBaseConstructorTypeOfClass(classType);
                if (baseConstructorType.flags & 11272192 /* TypeVariable */ ) {
                    members = createSymbolTable(getNamedOrIndexSignatureMembers(members));
                    addInheritedMembers(members, getPropertiesOfType(baseConstructorType));
                } else if (baseConstructorType === anyType) baseConstructorIndexInfo = anyBaseTypeIndexInfo;
            }
            const indexSymbol = getIndexSymbolFromSymbolTable(members);
            if (indexSymbol) indexInfos = getIndexInfosOfIndexSymbol(indexSymbol, arrayFrom(members.values()));
            else {
                if (baseConstructorIndexInfo) indexInfos = append(indexInfos, baseConstructorIndexInfo);
                if (symbol.flags & 384 /* Enum */  && (getDeclaredTypeOfSymbol(symbol).flags & 32 /* Enum */  || some(type.properties, (prop)=>!!(getTypeOfSymbol(prop).flags & 296 /* NumberLike */ )))) indexInfos = append(indexInfos, enumNumberIndexInfo);
            }
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, indexInfos || emptyArray);
            if (symbol.flags & 8208 /* Method */ ) type.callSignatures = getSignaturesOfSymbol(symbol);
            if (symbol.flags & 32 /* Class */ ) {
                const classType = getDeclaredTypeOfClassOrInterface(symbol);
                let constructSignatures = symbol.members ? getSignaturesOfSymbol(symbol.members.get("__constructor" /* Constructor */ )) : emptyArray;
                if (symbol.flags & 16 /* Function */ ) constructSignatures = addRange(constructSignatures.slice(), mapDefined(type.callSignatures, (sig)=>isJSConstructor(sig.declaration) ? createSignature(sig.declaration, sig.typeParameters, sig.thisParameter, sig.parameters, classType, /*resolvedTypePredicate*/ void 0, sig.minArgumentCount, sig.flags & 167 /* PropagatingFlags */ ) : void 0));
                if (!constructSignatures.length) constructSignatures = getDefaultConstructSignatures(classType);
                type.constructSignatures = constructSignatures;
            }
        }
        function replaceIndexedAccess(instantiable, type, replacement) {
            return instantiateType(instantiable, createTypeMapper([
                type.indexType,
                type.objectType
            ], [
                getNumberLiteralType(0),
                createTupleType([
                    replacement
                ])
            ]));
        }
        function getLimitedConstraint(type) {
            const constraint = getConstraintTypeFromMappedType(type.mappedType);
            if (!(constraint.flags & 1048576 /* Union */  || constraint.flags & 2097152 /* Intersection */ )) return;
            const origin = constraint.flags & 1048576 /* Union */  ? constraint.origin : constraint;
            if (!origin || !(origin.flags & 2097152 /* Intersection */ )) return;
            const limitedConstraint = getIntersectionType(origin.types.filter((t)=>t !== type.constraintType));
            return limitedConstraint !== neverType ? limitedConstraint : void 0;
        }
        function resolveReverseMappedTypeMembers(type) {
            const indexInfo = getIndexInfoOfType(type.source, stringType);
            const modifiers = getMappedTypeModifiers(type.mappedType);
            const readonlyMask = modifiers & 1 /* IncludeReadonly */  ? false : true;
            const optionalMask = modifiers & 4 /* IncludeOptional */  ? 0 : 16777216 /* Optional */ ;
            const indexInfos = indexInfo ? [
                createIndexInfo(stringType, inferReverseMappedType(indexInfo.type, type.mappedType, type.constraintType) || unknownType, readonlyMask && indexInfo.isReadonly)
            ] : emptyArray;
            const members = createSymbolTable();
            const limitedConstraint = getLimitedConstraint(type);
            for (const prop of getPropertiesOfType(type.source)){
                if (limitedConstraint) {
                    const propertyNameType = getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ );
                    if (!isTypeAssignableTo(propertyNameType, limitedConstraint)) continue;
                }
                const checkFlags = 8192 /* ReverseMapped */  | (readonlyMask && isReadonlySymbol(prop) ? 8 /* Readonly */  : 0);
                const inferredProp = createSymbol(4 /* Property */  | prop.flags & optionalMask, prop.escapedName, checkFlags);
                inferredProp.declarations = prop.declarations;
                inferredProp.links.nameType = getSymbolLinks(prop).nameType;
                inferredProp.links.propertyType = getTypeOfSymbol(prop);
                if (type.constraintType.type.flags & 8388608 /* IndexedAccess */  && type.constraintType.type.objectType.flags & 262144 /* TypeParameter */  && type.constraintType.type.indexType.flags & 262144 /* TypeParameter */ ) {
                    const newTypeParam = type.constraintType.type.objectType;
                    const newMappedType = replaceIndexedAccess(type.mappedType, type.constraintType.type, newTypeParam);
                    inferredProp.links.mappedType = newMappedType;
                    inferredProp.links.constraintType = getIndexType(newTypeParam);
                } else {
                    inferredProp.links.mappedType = type.mappedType;
                    inferredProp.links.constraintType = type.constraintType;
                }
                members.set(prop.escapedName, inferredProp);
            }
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, indexInfos);
        }
        function getLowerBoundOfKeyType(type) {
            if (type.flags & 4194304 /* Index */ ) {
                const t = getApparentType(type.type);
                return isGenericTupleType(t) ? getKnownKeysOfTupleType(t) : getIndexType(t);
            }
            if (type.flags & 16777216 /* Conditional */ ) {
                if (type.root.isDistributive) {
                    const checkType = type.checkType;
                    const constraint = getLowerBoundOfKeyType(checkType);
                    if (constraint !== checkType) return getConditionalTypeInstantiation(type, prependTypeMapping(type.root.checkType, constraint, type.mapper), /*forConstraint*/ false);
                }
                return type;
            }
            if (type.flags & 1048576 /* Union */ ) return mapType(type, getLowerBoundOfKeyType, /*noReductions*/ true);
            if (type.flags & 2097152 /* Intersection */ ) {
                const types = type.types;
                if (types.length === 2 && !!(types[0].flags & 76 /* BigInt */ ) && types[1] === emptyTypeLiteralType) return type;
                return getIntersectionType(sameMap(type.types, getLowerBoundOfKeyType));
            }
            return type;
        }
        function getIsLateCheckFlag(s) {
            return getCheckFlags(s) & 4096 /* Late */ ;
        }
        function forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(type, include, stringsOnly, cb) {
            for (const prop of getPropertiesOfType(type))cb(getLiteralTypeFromProperty(prop, include));
            if (type.flags & 1 /* Any */ ) cb(stringType);
            else {
                for (const info of getIndexInfosOfType(type))if (!stringsOnly || info.keyType.flags & 134217732 /* TemplateLiteral */ ) cb(info.keyType);
            }
        }
        function resolveMappedTypeMembers(type) {
            const members = createSymbolTable();
            let indexInfos;
            setStructuredTypeMembers(type, emptySymbols, emptyArray, emptyArray, emptyArray);
            const typeParameter = getTypeParameterFromMappedType(type);
            const constraintType = getConstraintTypeFromMappedType(type);
            const mappedType = type.target || type;
            const nameType = getNameTypeFromMappedType(mappedType);
            const shouldLinkPropDeclarations = getMappedTypeNameTypeKind(mappedType) !== 2 /* Remapping */ ;
            const templateType = getTemplateTypeFromMappedType(mappedType);
            const modifiersType = getApparentType(getModifiersTypeFromMappedType(type));
            const templateModifiers = getMappedTypeModifiers(type);
            const include = 8576 /* StringOrNumberLiteralOrUnique */ ;
            if (isMappedTypeWithKeyofConstraintDeclaration(type)) forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(modifiersType, include, /*stringsOnly*/ false, addMemberForKeyType);
            else forEachType(getLowerBoundOfKeyType(constraintType), addMemberForKeyType);
            setStructuredTypeMembers(type, members, emptyArray, emptyArray, indexInfos || emptyArray);
            function addMemberForKeyType(keyType) {
                const propNameType = nameType ? instantiateType(nameType, appendTypeMapping(type.mapper, typeParameter, keyType)) : keyType;
                forEachType(propNameType, (t)=>addMemberForKeyTypeWorker(keyType, t));
            }
            function addMemberForKeyTypeWorker(keyType, propNameType) {
                if (isTypeUsableAsPropertyName(propNameType)) {
                    const propName = getPropertyNameFromType(propNameType);
                    const existingProp = members.get(propName);
                    if (existingProp) {
                        existingProp.links.nameType = getUnionType([
                            existingProp.links.nameType,
                            propNameType
                        ]);
                        existingProp.links.keyType = getUnionType([
                            existingProp.links.keyType,
                            keyType
                        ]);
                    } else {
                        const modifiersProp = isTypeUsableAsPropertyName(keyType) ? getPropertyOfType(modifiersType, getPropertyNameFromType(keyType)) : void 0;
                        const isOptional = !!(templateModifiers & 4 /* IncludeOptional */  || !(templateModifiers & 8 /* ExcludeOptional */ ) && modifiersProp && modifiersProp.flags & 16777216 /* Optional */ );
                        const isReadonly = !!(templateModifiers & 1 /* IncludeReadonly */  || !(templateModifiers & 2 /* ExcludeReadonly */ ) && modifiersProp && isReadonlySymbol(modifiersProp));
                        const stripOptional = strictNullChecks && !isOptional && modifiersProp && modifiersProp.flags & 16777216 /* Optional */ ;
                        const lateFlag = modifiersProp ? getIsLateCheckFlag(modifiersProp) : 0;
                        const prop = createSymbol(4 /* Property */  | (isOptional ? 16777216 /* Optional */  : 0), propName, lateFlag | 262144 /* Mapped */  | (isReadonly ? 8 /* Readonly */  : 0) | (stripOptional ? 524288 /* StripOptional */  : 0));
                        prop.links.mappedType = type;
                        prop.links.nameType = propNameType;
                        prop.links.keyType = keyType;
                        if (modifiersProp) {
                            prop.links.syntheticOrigin = modifiersProp;
                            prop.declarations = shouldLinkPropDeclarations ? modifiersProp.declarations : void 0;
                        }
                        members.set(propName, prop);
                    }
                } else if (isValidIndexKeyType(propNameType) || propNameType.flags & 33 /* Enum */ ) {
                    const indexKeyType = propNameType.flags & 5 /* String */  ? stringType : propNameType.flags & 40 /* Enum */  ? numberType : propNameType;
                    const propType = instantiateType(templateType, appendTypeMapping(type.mapper, typeParameter, keyType));
                    const modifiersIndexInfo = getApplicableIndexInfo(modifiersType, propNameType);
                    const isReadonly = !!(templateModifiers & 1 /* IncludeReadonly */  || !(templateModifiers & 2 /* ExcludeReadonly */ ) && (modifiersIndexInfo == null ? void 0 : modifiersIndexInfo.isReadonly));
                    const indexInfo = createIndexInfo(indexKeyType, propType, isReadonly);
                    indexInfos = appendIndexInfo(indexInfos, indexInfo, /*union*/ true);
                }
            }
        }
        function getTypeOfMappedSymbol(symbol) {
            var _a;
            if (!symbol.links.type) {
                const mappedType = symbol.links.mappedType;
                if (!pushTypeResolution(symbol, 0 /* Type */ )) {
                    mappedType.containsError = true;
                    return errorType;
                }
                const templateType = getTemplateTypeFromMappedType(mappedType.target || mappedType);
                const mapper = appendTypeMapping(mappedType.mapper, getTypeParameterFromMappedType(mappedType), symbol.links.keyType);
                const propType = instantiateType(templateType, mapper);
                let type = strictNullChecks && symbol.flags & 16777216 /* Optional */  && !maybeTypeOfKind(propType, 49152 /* Void */ ) ? getOptionalType(propType, /*isProperty*/ true) : symbol.links.checkFlags & 524288 /* StripOptional */  ? removeMissingOrUndefinedType(propType) : propType;
                if (!popTypeResolution()) {
                    error2(currentNode, Diagnostics.Type_of_property_0_circularly_references_itself_in_mapped_type_1, symbolToString(symbol), typeToString(mappedType));
                    type = errorType;
                }
                var _type;
                (_type = (_a = symbol.links).type) !== null && _type !== void 0 ? _type : _a.type = type;
            }
            return symbol.links.type;
        }
        function getTypeParameterFromMappedType(type) {
            return type.typeParameter || (type.typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(type.declaration.typeParameter)));
        }
        function getConstraintTypeFromMappedType(type) {
            return type.constraintType || (type.constraintType = getConstraintOfTypeParameter(getTypeParameterFromMappedType(type)) || errorType);
        }
        function getNameTypeFromMappedType(type) {
            return type.declaration.nameType ? type.nameType || (type.nameType = instantiateType(getTypeFromTypeNode(type.declaration.nameType), type.mapper)) : void 0;
        }
        function getTemplateTypeFromMappedType(type) {
            return type.templateType || (type.templateType = type.declaration.type ? instantiateType(addOptionality(getTypeFromTypeNode(type.declaration.type), /*isProperty*/ true, !!(getMappedTypeModifiers(type) & 4 /* IncludeOptional */ )), type.mapper) : errorType);
        }
        function getConstraintDeclarationForMappedType(type) {
            return getEffectiveConstraintOfTypeParameter(type.declaration.typeParameter);
        }
        function isMappedTypeWithKeyofConstraintDeclaration(type) {
            const constraintDeclaration = getConstraintDeclarationForMappedType(type);
            return constraintDeclaration.kind === 199 /* TypeOperator */  && constraintDeclaration.operator === 143 /* KeyOfKeyword */ ;
        }
        function getModifiersTypeFromMappedType(type) {
            if (!type.modifiersType) {
                if (isMappedTypeWithKeyofConstraintDeclaration(type)) type.modifiersType = instantiateType(getTypeFromTypeNode(getConstraintDeclarationForMappedType(type).type), type.mapper);
                else {
                    const declaredType = getTypeFromMappedTypeNode(type.declaration);
                    const constraint = getConstraintTypeFromMappedType(declaredType);
                    const extendedConstraint = constraint && constraint.flags & 262144 /* TypeParameter */  ? getConstraintOfTypeParameter(constraint) : constraint;
                    type.modifiersType = extendedConstraint && extendedConstraint.flags & 4194304 /* Index */  ? instantiateType(extendedConstraint.type, type.mapper) : unknownType;
                }
            }
            return type.modifiersType;
        }
        function getMappedTypeModifiers(type) {
            const declaration = type.declaration;
            return (declaration.readonlyToken ? declaration.readonlyToken.kind === 41 /* MinusToken */  ? 2 /* ExcludeReadonly */  : 1 /* IncludeReadonly */  : 0) | (declaration.questionToken ? declaration.questionToken.kind === 41 /* MinusToken */  ? 8 /* ExcludeOptional */  : 4 /* IncludeOptional */  : 0);
        }
        function getMappedTypeOptionality(type) {
            const modifiers = getMappedTypeModifiers(type);
            return modifiers & 8 /* ExcludeOptional */  ? -1 : modifiers & 4 /* IncludeOptional */  ? 1 : 0;
        }
        function getCombinedMappedTypeOptionality(type) {
            if (getObjectFlags(type) & 32 /* Mapped */ ) return getMappedTypeOptionality(type) || getCombinedMappedTypeOptionality(getModifiersTypeFromMappedType(type));
            if (type.flags & 2097152 /* Intersection */ ) {
                const optionality = getCombinedMappedTypeOptionality(type.types[0]);
                return every(type.types, (t, i)=>i === 0 || getCombinedMappedTypeOptionality(t) === optionality) ? optionality : 0;
            }
            return 0;
        }
        function isPartialMappedType(type) {
            return !!(getObjectFlags(type) & 32 /* Mapped */  && getMappedTypeModifiers(type) & 4 /* IncludeOptional */ );
        }
        function isGenericMappedType(type) {
            if (getObjectFlags(type) & 32 /* Mapped */ ) {
                const constraint = getConstraintTypeFromMappedType(type);
                if (isGenericIndexType(constraint)) return true;
                const nameType = getNameTypeFromMappedType(type);
                if (nameType && isGenericIndexType(instantiateType(nameType, makeUnaryTypeMapper(getTypeParameterFromMappedType(type), constraint)))) return true;
            }
            return false;
        }
        function getMappedTypeNameTypeKind(type) {
            const nameType = getNameTypeFromMappedType(type);
            if (!nameType) return 0 /* None */ ;
            return isTypeAssignableTo(nameType, getTypeParameterFromMappedType(type)) ? 1 /* Filtering */  : 2 /* Remapping */ ;
        }
        function resolveStructuredTypeMembers(type) {
            if (!type.members) {
                if (type.flags & 524288 /* Object */ ) {
                    if (type.objectFlags & 4 /* Reference */ ) resolveTypeReferenceMembers(type);
                    else if (type.objectFlags & 3 /* ClassOrInterface */ ) resolveClassOrInterfaceMembers(type);
                    else if (type.objectFlags & 1024 /* ReverseMapped */ ) resolveReverseMappedTypeMembers(type);
                    else if (type.objectFlags & 16 /* Anonymous */ ) resolveAnonymousTypeMembers(type);
                    else if (type.objectFlags & 32 /* Mapped */ ) resolveMappedTypeMembers(type);
                    else Debug.fail("Unhandled object type " + Debug.formatObjectFlags(type.objectFlags));
                } else if (type.flags & 1048576 /* Union */ ) resolveUnionTypeMembers(type);
                else if (type.flags & 2097152 /* Intersection */ ) resolveIntersectionTypeMembers(type);
                else Debug.fail("Unhandled type " + Debug.formatTypeFlags(type.flags));
            }
            return type;
        }
        function getPropertiesOfObjectType(type) {
            if (type.flags & 524288 /* Object */ ) return resolveStructuredTypeMembers(type).properties;
            return emptyArray;
        }
        function getPropertyOfObjectType(type, name) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                const symbol = resolved.members.get(name);
                if (symbol && symbolIsValue(symbol)) return symbol;
            }
        }
        function getPropertiesOfUnionOrIntersectionType(type) {
            if (!type.resolvedProperties) {
                const members = createSymbolTable();
                for (const current of type.types){
                    for (const prop of getPropertiesOfType(current))if (!members.has(prop.escapedName)) {
                        const combinedProp = getPropertyOfUnionOrIntersectionType(type, prop.escapedName, /*skipObjectFunctionPropertyAugment*/ !!(type.flags & 2097152 /* Intersection */ ));
                        if (combinedProp) members.set(prop.escapedName, combinedProp);
                    }
                    if (type.flags & 1048576 /* Union */  && getIndexInfosOfType(current).length === 0) break;
                }
                type.resolvedProperties = getNamedMembers(members);
            }
            return type.resolvedProperties;
        }
        function getPropertiesOfType(type) {
            type = getReducedApparentType(type);
            return type.flags & 3145728 /* UnionOrIntersection */  ? getPropertiesOfUnionOrIntersectionType(type) : getPropertiesOfObjectType(type);
        }
        function forEachPropertyOfType(type, action) {
            type = getReducedApparentType(type);
            if (type.flags & 3670016 /* StructuredType */ ) resolveStructuredTypeMembers(type).members.forEach((symbol, escapedName)=>{
                if (isNamedMember(symbol, escapedName)) action(symbol, escapedName);
            });
        }
        function isTypeInvalidDueToUnionDiscriminant(contextualType, obj) {
            const list = obj.properties;
            return list.some((property)=>{
                const nameType = property.name && (isJsxNamespacedName(property.name) ? getStringLiteralType(getTextOfJsxAttributeName(property.name)) : getLiteralTypeFromPropertyName(property.name));
                const name = nameType && isTypeUsableAsPropertyName(nameType) ? getPropertyNameFromType(nameType) : void 0;
                const expected = name === void 0 ? void 0 : getTypeOfPropertyOfType(contextualType, name);
                return !!expected && isLiteralType(expected) && !isTypeAssignableTo(getTypeOfNode(property), expected);
            });
        }
        function getAllPossiblePropertiesOfTypes(types) {
            const unionType = getUnionType(types);
            if (!(unionType.flags & 1048576 /* Union */ )) return getAugmentedPropertiesOfType(unionType);
            const props = createSymbolTable();
            for (const memberType of types){
                for (const { escapedName } of getAugmentedPropertiesOfType(memberType))if (!props.has(escapedName)) {
                    const prop = createUnionOrIntersectionProperty(unionType, escapedName);
                    if (prop) props.set(escapedName, prop);
                }
            }
            return arrayFrom(props.values());
        }
        function getConstraintOfType(type) {
            return type.flags & 262144 /* TypeParameter */  ? getConstraintOfTypeParameter(type) : type.flags & 8388608 /* IndexedAccess */  ? getConstraintOfIndexedAccess(type) : type.flags & 16777216 /* Conditional */  ? getConstraintOfConditionalType(type) : getBaseConstraintOfType(type);
        }
        function getConstraintOfTypeParameter(typeParameter) {
            return hasNonCircularBaseConstraint(typeParameter) ? getConstraintFromTypeParameter(typeParameter) : void 0;
        }
        function isConstMappedType(type, depth) {
            const typeVariable = getHomomorphicTypeVariable(type);
            return !!typeVariable && isConstTypeVariable(typeVariable, depth);
        }
        function isConstTypeVariable(type, depth = 0) {
            var _a;
            return depth < 5 && !!(type && (type.flags & 262144 /* TypeParameter */  && some((_a = type.symbol) == null ? void 0 : _a.declarations, (d)=>hasSyntacticModifier(d, 4096 /* Const */ )) || type.flags & 3145728 /* UnionOrIntersection */  && some(type.types, (t)=>isConstTypeVariable(t, depth)) || type.flags & 8388608 /* IndexedAccess */  && isConstTypeVariable(type.objectType, depth + 1) || type.flags & 16777216 /* Conditional */  && isConstTypeVariable(getConstraintOfConditionalType(type), depth + 1) || type.flags & 33554432 /* Substitution */  && isConstTypeVariable(type.baseType, depth) || getObjectFlags(type) & 32 /* Mapped */  && isConstMappedType(type, depth) || isGenericTupleType(type) && findIndex(getElementTypes(type), (t, i)=>!!(type.target.elementFlags[i] & 8 /* Variadic */ ) && isConstTypeVariable(t, depth)) >= 0));
        }
        function getConstraintOfIndexedAccess(type) {
            return hasNonCircularBaseConstraint(type) ? getConstraintFromIndexedAccess(type) : void 0;
        }
        function getSimplifiedTypeOrConstraint(type) {
            const simplified = getSimplifiedType(type, /*writing*/ false);
            return simplified !== type ? simplified : getConstraintOfType(type);
        }
        function getConstraintFromIndexedAccess(type) {
            if (isMappedTypeGenericIndexedAccess(type)) return substituteIndexedMappedType(type.objectType, type.indexType);
            const indexConstraint = getSimplifiedTypeOrConstraint(type.indexType);
            if (indexConstraint && indexConstraint !== type.indexType) {
                const indexedAccess = getIndexedAccessTypeOrUndefined(type.objectType, indexConstraint, type.accessFlags);
                if (indexedAccess) return indexedAccess;
            }
            const objectConstraint = getSimplifiedTypeOrConstraint(type.objectType);
            if (objectConstraint && objectConstraint !== type.objectType) return getIndexedAccessTypeOrUndefined(objectConstraint, type.indexType, type.accessFlags);
            return void 0;
        }
        function getDefaultConstraintOfConditionalType(type) {
            if (!type.resolvedDefaultConstraint) {
                const trueConstraint = getInferredTrueTypeFromConditionalType(type);
                const falseConstraint = getFalseTypeFromConditionalType(type);
                type.resolvedDefaultConstraint = isTypeAny(trueConstraint) ? falseConstraint : isTypeAny(falseConstraint) ? trueConstraint : getUnionType([
                    trueConstraint,
                    falseConstraint
                ]);
            }
            return type.resolvedDefaultConstraint;
        }
        function getConstraintOfDistributiveConditionalType(type) {
            if (type.resolvedConstraintOfDistributive !== void 0) return type.resolvedConstraintOfDistributive || void 0;
            if (type.root.isDistributive && type.restrictiveInstantiation !== type) {
                const simplified = getSimplifiedType(type.checkType, /*writing*/ false);
                const constraint = simplified === type.checkType ? getConstraintOfType(simplified) : simplified;
                if (constraint && constraint !== type.checkType) {
                    const instantiated = getConditionalTypeInstantiation(type, prependTypeMapping(type.root.checkType, constraint, type.mapper), /*forConstraint*/ true);
                    if (!(instantiated.flags & 131072 /* Never */ )) {
                        type.resolvedConstraintOfDistributive = instantiated;
                        return instantiated;
                    }
                }
            }
            type.resolvedConstraintOfDistributive = false;
            return void 0;
        }
        function getConstraintFromConditionalType(type) {
            return getConstraintOfDistributiveConditionalType(type) || getDefaultConstraintOfConditionalType(type);
        }
        function getConstraintOfConditionalType(type) {
            return hasNonCircularBaseConstraint(type) ? getConstraintFromConditionalType(type) : void 0;
        }
        function getEffectiveConstraintOfIntersection(types, targetIsUnion) {
            let constraints;
            let hasDisjointDomainType = false;
            for (const t of types){
                if (t.flags & 465829888 /* Instantiable */ ) {
                    let constraint = getConstraintOfType(t);
                    while(constraint && constraint.flags & 21233664 /* Conditional */ )constraint = getConstraintOfType(constraint);
                    if (constraint) {
                        constraints = append(constraints, constraint);
                        if (targetIsUnion) constraints = append(constraints, t);
                    }
                } else if (t.flags & 469892092 /* DisjointDomains */  || isEmptyAnonymousObjectType(t)) hasDisjointDomainType = true;
            }
            if (constraints && (targetIsUnion || hasDisjointDomainType)) {
                if (hasDisjointDomainType) {
                    for (const t of types)if (t.flags & 469892092 /* DisjointDomains */  || isEmptyAnonymousObjectType(t)) constraints = append(constraints, t);
                }
                return getNormalizedType(getIntersectionType(constraints, 2 /* NoConstraintReduction */ ), /*writing*/ false);
            }
            return void 0;
        }
        function getBaseConstraintOfType(type) {
            if (type.flags & 464781312 /* StringMapping */  || isGenericTupleType(type)) {
                const constraint = getResolvedBaseConstraint(type);
                return constraint !== noConstraintType && constraint !== circularConstraintType ? constraint : void 0;
            }
            return type.flags & 4194304 /* Index */  ? stringNumberSymbolType : void 0;
        }
        function getBaseConstraintOrType(type) {
            return getBaseConstraintOfType(type) || type;
        }
        function hasNonCircularBaseConstraint(type) {
            return getResolvedBaseConstraint(type) !== circularConstraintType;
        }
        function getResolvedBaseConstraint(type) {
            if (type.resolvedBaseConstraint) return type.resolvedBaseConstraint;
            const stack = [];
            return type.resolvedBaseConstraint = getImmediateBaseConstraint(type);
            function getImmediateBaseConstraint(t) {
                if (!t.immediateBaseConstraint) {
                    if (!pushTypeResolution(t, 4 /* ImmediateBaseConstraint */ )) return circularConstraintType;
                    let result;
                    const identity2 = getRecursionIdentity(t);
                    if (stack.length < 10 || stack.length < 50 && !contains(stack, identity2)) {
                        stack.push(identity2);
                        result = computeBaseConstraint(getSimplifiedType(t, /*writing*/ false));
                        stack.pop();
                    }
                    if (!popTypeResolution()) {
                        if (t.flags & 262144 /* TypeParameter */ ) {
                            const errorNode = getConstraintDeclaration(t);
                            if (errorNode) {
                                const diagnostic = error2(errorNode, Diagnostics.Type_parameter_0_has_a_circular_constraint, typeToString(t));
                                if (currentNode && !isNodeDescendantOf(errorNode, currentNode) && !isNodeDescendantOf(currentNode, errorNode)) addRelatedInfo(diagnostic, createDiagnosticForNode(currentNode, Diagnostics.Circularity_originates_in_type_at_this_location));
                            }
                        }
                        result = circularConstraintType;
                    }
                    var _t_immediateBaseConstraint;
                    (_t_immediateBaseConstraint = t.immediateBaseConstraint) !== null && _t_immediateBaseConstraint !== void 0 ? _t_immediateBaseConstraint : t.immediateBaseConstraint = result || noConstraintType;
                }
                return t.immediateBaseConstraint;
            }
            function getBaseConstraint(t) {
                const c = getImmediateBaseConstraint(t);
                return c !== noConstraintType && c !== circularConstraintType ? c : void 0;
            }
            function computeBaseConstraint(t) {
                if (t.flags & 262144 /* TypeParameter */ ) {
                    const constraint = getConstraintFromTypeParameter(t);
                    return t.isThisType || !constraint ? constraint : getBaseConstraint(constraint);
                }
                if (t.flags & 3145728 /* UnionOrIntersection */ ) {
                    const types = t.types;
                    const baseTypes = [];
                    let different = false;
                    for (const type2 of types){
                        const baseType = getBaseConstraint(type2);
                        if (baseType) {
                            if (baseType !== type2) different = true;
                            baseTypes.push(baseType);
                        } else different = true;
                    }
                    if (!different) return t;
                    return t.flags & 1048576 /* Union */  && baseTypes.length === types.length ? getUnionType(baseTypes) : t.flags & 2097152 /* Intersection */  && baseTypes.length ? getIntersectionType(baseTypes) : void 0;
                }
                if (t.flags & 4194304 /* Index */ ) return stringNumberSymbolType;
                if (t.flags & 134217728 /* TemplateLiteral */ ) {
                    const types = t.types;
                    const constraints = mapDefined(types, getBaseConstraint);
                    return constraints.length === types.length ? getTemplateLiteralType(t.texts, constraints) : stringType;
                }
                if (t.flags & 268435456 /* StringMapping */ ) {
                    const constraint = getBaseConstraint(t.type);
                    return constraint && constraint !== t.type ? getStringMappingType(t.symbol, constraint) : stringType;
                }
                if (t.flags & 8388608 /* IndexedAccess */ ) {
                    if (isMappedTypeGenericIndexedAccess(t)) return getBaseConstraint(substituteIndexedMappedType(t.objectType, t.indexType));
                    const baseObjectType = getBaseConstraint(t.objectType);
                    const baseIndexType = getBaseConstraint(t.indexType);
                    const baseIndexedAccess = baseObjectType && baseIndexType && getIndexedAccessTypeOrUndefined(baseObjectType, baseIndexType, t.accessFlags);
                    return baseIndexedAccess && getBaseConstraint(baseIndexedAccess);
                }
                if (t.flags & 16777216 /* Conditional */ ) {
                    const constraint = getConstraintFromConditionalType(t);
                    return constraint && getBaseConstraint(constraint);
                }
                if (t.flags & 33554432 /* Substitution */ ) return getBaseConstraint(getSubstitutionIntersection(t));
                if (isGenericTupleType(t)) {
                    const newElements = map(getElementTypes(t), (v1, i)=>{
                        const constraint = v1.flags & 262144 /* TypeParameter */  && t.target.elementFlags[i] & 8 /* Variadic */  && getBaseConstraint(v1) || v1;
                        return constraint !== v1 && everyType(constraint, (c)=>isArrayOrTupleType(c) && !isGenericTupleType(c)) ? constraint : v1;
                    });
                    return createTupleType(newElements, t.target.elementFlags, t.target.readonly, t.target.labeledElementDeclarations);
                }
                return t;
            }
        }
        function getApparentTypeOfIntersectionType(type, thisArgument) {
            if (type === thisArgument) return type.resolvedApparentType || (type.resolvedApparentType = getTypeWithThisArgument(type, thisArgument, /*needApparentType*/ true));
            const key = `I${getTypeId(type)},${getTypeId(thisArgument)}`;
            var _getCachedType;
            return (_getCachedType = getCachedType(key)) !== null && _getCachedType !== void 0 ? _getCachedType : setCachedType(key, getTypeWithThisArgument(type, thisArgument, /*needApparentType*/ true));
        }
        function getResolvedTypeParameterDefault(typeParameter) {
            if (!typeParameter.default) {
                if (typeParameter.target) {
                    const targetDefault = getResolvedTypeParameterDefault(typeParameter.target);
                    typeParameter.default = targetDefault ? instantiateType(targetDefault, typeParameter.mapper) : noConstraintType;
                } else {
                    typeParameter.default = resolvingDefaultType;
                    const defaultDeclaration = typeParameter.symbol && forEach(typeParameter.symbol.declarations, (decl)=>isTypeParameterDeclaration(decl) && decl.default);
                    const defaultType = defaultDeclaration ? getTypeFromTypeNode(defaultDeclaration) : noConstraintType;
                    if (typeParameter.default === resolvingDefaultType) typeParameter.default = defaultType;
                }
            } else if (typeParameter.default === resolvingDefaultType) typeParameter.default = circularConstraintType;
            return typeParameter.default;
        }
        function getDefaultFromTypeParameter(typeParameter) {
            const defaultType = getResolvedTypeParameterDefault(typeParameter);
            return defaultType !== noConstraintType && defaultType !== circularConstraintType ? defaultType : void 0;
        }
        function hasNonCircularTypeParameterDefault(typeParameter) {
            return getResolvedTypeParameterDefault(typeParameter) !== circularConstraintType;
        }
        function hasTypeParameterDefault(typeParameter) {
            return !!(typeParameter.symbol && forEach(typeParameter.symbol.declarations, (decl)=>isTypeParameterDeclaration(decl) && decl.default));
        }
        function getApparentTypeOfMappedType(type) {
            return type.resolvedApparentType || (type.resolvedApparentType = getResolvedApparentTypeOfMappedType(type));
        }
        function getResolvedApparentTypeOfMappedType(type) {
            var _type_target;
            const target = (_type_target = type.target) !== null && _type_target !== void 0 ? _type_target : type;
            const typeVariable = getHomomorphicTypeVariable(target);
            if (typeVariable && !target.declaration.nameType) {
                const modifiersType = getModifiersTypeFromMappedType(type);
                const baseConstraint = isGenericMappedType(modifiersType) ? getApparentTypeOfMappedType(modifiersType) : getBaseConstraintOfType(modifiersType);
                if (baseConstraint && everyType(baseConstraint, (t)=>isArrayOrTupleType(t) || isArrayOrTupleOrIntersection(t))) return instantiateType(target, prependTypeMapping(typeVariable, baseConstraint, type.mapper));
            }
            return type;
        }
        function isArrayOrTupleOrIntersection(type) {
            return !!(type.flags & 2097152 /* Intersection */ ) && every(type.types, isArrayOrTupleType);
        }
        function isMappedTypeGenericIndexedAccess(type) {
            let objectType;
            return !!(type.flags & 8388608 /* IndexedAccess */  && getObjectFlags(objectType = type.objectType) & 32 /* Mapped */  && !isGenericMappedType(objectType) && isGenericIndexType(type.indexType) && !(getMappedTypeModifiers(objectType) & 8 /* ExcludeOptional */ ) && !objectType.declaration.nameType);
        }
        function getApparentType(type) {
            const t = type.flags & 465829888 /* Instantiable */  ? getBaseConstraintOfType(type) || unknownType : type;
            const objectFlags = getObjectFlags(t);
            return objectFlags & 32 /* Mapped */  ? getApparentTypeOfMappedType(t) : objectFlags & 4 /* Reference */  && t !== type ? getTypeWithThisArgument(t, type) : t.flags & 2097152 /* Intersection */  ? getApparentTypeOfIntersectionType(t, type) : t.flags & 402653316 /* StringLike */  ? globalStringType : t.flags & 296 /* NumberLike */  ? globalNumberType : t.flags & 2112 /* BigIntLike */  ? getGlobalBigIntType() : t.flags & 528 /* BooleanLike */  ? globalBooleanType : t.flags & 12288 /* ESSymbolLike */  ? getGlobalESSymbolType() : t.flags & 67108864 /* NonPrimitive */  ? emptyObjectType : t.flags & 4194304 /* Index */  ? stringNumberSymbolType : t.flags & 2 /* Unknown */  && !strictNullChecks ? emptyObjectType : t;
        }
        function getReducedApparentType(type) {
            return getReducedType(getApparentType(getReducedType(type)));
        }
        function createUnionOrIntersectionProperty(containingType, name, skipObjectFunctionPropertyAugment) {
            var _a, _b, _c;
            let propFlags = 0 /* None */ ;
            let singleProp;
            let propSet;
            let indexTypes;
            const isUnion = containingType.flags & 1048576 /* Union */ ;
            let optionalFlag;
            let syntheticFlag = 4 /* SyntheticMethod */ ;
            let checkFlags = isUnion ? 0 : 8 /* Readonly */ ;
            let mergedInstantiations = false;
            for (const current of containingType.types){
                const type = getApparentType(current);
                if (!(isErrorType(type) || type.flags & 131072 /* Never */ )) {
                    const prop = getPropertyOfType(type, name, skipObjectFunctionPropertyAugment);
                    const modifiers = prop ? getDeclarationModifierFlagsFromSymbol(prop) : 0;
                    if (prop) {
                        if (prop.flags & 106500 /* ClassMember */ ) {
                            optionalFlag !== null && optionalFlag !== void 0 ? optionalFlag : optionalFlag = isUnion ? 0 /* None */  : 16777216 /* Optional */ ;
                            if (isUnion) optionalFlag |= prop.flags & 16777216 /* Optional */ ;
                            else optionalFlag &= prop.flags;
                        }
                        if (!singleProp) {
                            singleProp = prop;
                            propFlags = prop.flags & 98304 /* Accessor */  || 4 /* Property */ ;
                        } else if (prop !== singleProp) {
                            const isInstantiation = (getTargetSymbol(prop) || prop) === (getTargetSymbol(singleProp) || singleProp);
                            if (isInstantiation && compareProperties2(singleProp, prop, (a, b)=>a === b ? -1 /* True */  : 0 /* False */ ) === -1 /* True */ ) mergedInstantiations = !!singleProp.parent && !!length(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(singleProp.parent));
                            else {
                                if (!propSet) {
                                    propSet = /* @__PURE__ */ new Map();
                                    propSet.set(getSymbolId(singleProp), singleProp);
                                }
                                const id = getSymbolId(prop);
                                if (!propSet.has(id)) propSet.set(id, prop);
                            }
                            if (propFlags & 98304 /* Accessor */  && (prop.flags & 98304 /* Accessor */ ) !== (propFlags & 98304 /* Accessor */ )) propFlags = propFlags & -98305 /* Accessor */  | 4 /* Property */ ;
                        }
                        if (isUnion && isReadonlySymbol(prop)) checkFlags |= 8 /* Readonly */ ;
                        else if (!isUnion && !isReadonlySymbol(prop)) checkFlags &= -9 /* Readonly */ ;
                        checkFlags |= (!(modifiers & 6 /* NonPublicAccessibilityModifier */ ) ? 256 /* ContainsPublic */  : 0) | (modifiers & 4 /* Protected */  ? 512 /* ContainsProtected */  : 0) | (modifiers & 2 /* Private */  ? 1024 /* ContainsPrivate */  : 0) | (modifiers & 256 /* Static */  ? 2048 /* ContainsStatic */  : 0);
                        if (!isPrototypeProperty(prop)) syntheticFlag = 2 /* SyntheticProperty */ ;
                    } else if (isUnion) {
                        const indexInfo = !isLateBoundName(name) && getApplicableIndexInfoForName(type, name);
                        if (indexInfo) {
                            propFlags = propFlags & -98305 /* Accessor */  | 4 /* Property */ ;
                            checkFlags |= 32 /* WritePartial */  | (indexInfo.isReadonly ? 8 /* Readonly */  : 0);
                            indexTypes = append(indexTypes, isTupleType(type) ? getRestTypeOfTupleType(type) || undefinedType : indexInfo.type);
                        } else if (isObjectLiteralType2(type) && !(getObjectFlags(type) & 2097152 /* ContainsSpread */ )) {
                            checkFlags |= 32 /* WritePartial */ ;
                            indexTypes = append(indexTypes, undefinedType);
                        } else checkFlags |= 16 /* ReadPartial */ ;
                    }
                }
            }
            if (!singleProp || isUnion && (propSet || checkFlags & 48 /* Partial */ ) && checkFlags & 1536 /* ContainsProtected */  && !(propSet && getCommonDeclarationsOfSymbols(propSet.values()))) return void 0;
            if (!propSet && !(checkFlags & 16 /* ReadPartial */ ) && !indexTypes) {
                if (mergedInstantiations) {
                    const links = (_a = tryCast(singleProp, isTransientSymbol)) == null ? void 0 : _a.links;
                    const clone2 = createSymbolWithType(singleProp, links == null ? void 0 : links.type);
                    clone2.parent = (_c = (_b = singleProp.valueDeclaration) == null ? void 0 : _b.symbol) == null ? void 0 : _c.parent;
                    clone2.links.containingType = containingType;
                    clone2.links.mapper = links == null ? void 0 : links.mapper;
                    clone2.links.writeType = getWriteTypeOfSymbol(singleProp);
                    return clone2;
                } else return singleProp;
            }
            const props = propSet ? arrayFrom(propSet.values()) : [
                singleProp
            ];
            let declarations;
            let firstType;
            let nameType;
            const propTypes = [];
            let writeTypes;
            let firstValueDeclaration;
            let hasNonUniformValueDeclaration = false;
            for (const prop of props){
                if (!firstValueDeclaration) firstValueDeclaration = prop.valueDeclaration;
                else if (prop.valueDeclaration && prop.valueDeclaration !== firstValueDeclaration) hasNonUniformValueDeclaration = true;
                declarations = addRange(declarations, prop.declarations);
                const type = getTypeOfSymbol(prop);
                if (!firstType) {
                    firstType = type;
                    nameType = getSymbolLinks(prop).nameType;
                }
                const writeType = getWriteTypeOfSymbol(prop);
                if (writeTypes || writeType !== type) writeTypes = append(!writeTypes ? propTypes.slice() : writeTypes, writeType);
                if (type !== firstType) checkFlags |= 64 /* HasNonUniformType */ ;
                if (isLiteralType(type) || isPatternLiteralType(type)) checkFlags |= 128 /* HasLiteralType */ ;
                if (type.flags & 131072 /* Never */  && type !== uniqueLiteralType) checkFlags |= 131072 /* HasNeverType */ ;
                propTypes.push(type);
            }
            addRange(propTypes, indexTypes);
            const result = createSymbol(propFlags | (optionalFlag !== null && optionalFlag !== void 0 ? optionalFlag : 0), name, syntheticFlag | checkFlags);
            result.links.containingType = containingType;
            if (!hasNonUniformValueDeclaration && firstValueDeclaration) {
                result.valueDeclaration = firstValueDeclaration;
                if (firstValueDeclaration.symbol.parent) result.parent = firstValueDeclaration.symbol.parent;
            }
            result.declarations = declarations;
            result.links.nameType = nameType;
            if (propTypes.length > 2) {
                result.links.checkFlags |= 65536 /* DeferredType */ ;
                result.links.deferralParent = containingType;
                result.links.deferralConstituents = propTypes;
                result.links.deferralWriteConstituents = writeTypes;
            } else {
                result.links.type = isUnion ? getUnionType(propTypes) : getIntersectionType(propTypes);
                if (writeTypes) result.links.writeType = isUnion ? getUnionType(writeTypes) : getIntersectionType(writeTypes);
            }
            return result;
        }
        function getUnionOrIntersectionProperty(type, name, skipObjectFunctionPropertyAugment) {
            var _a, _b, _c;
            let property = skipObjectFunctionPropertyAugment ? (_a = type.propertyCacheWithoutObjectFunctionPropertyAugment) == null ? void 0 : _a.get(name) : (_b = type.propertyCache) == null ? void 0 : _b.get(name);
            if (!property) {
                property = createUnionOrIntersectionProperty(type, name, skipObjectFunctionPropertyAugment);
                if (property) {
                    const properties = skipObjectFunctionPropertyAugment ? type.propertyCacheWithoutObjectFunctionPropertyAugment || (type.propertyCacheWithoutObjectFunctionPropertyAugment = createSymbolTable()) : type.propertyCache || (type.propertyCache = createSymbolTable());
                    properties.set(name, property);
                    if (skipObjectFunctionPropertyAugment && !(getCheckFlags(property) & 48 /* Partial */ ) && !((_c = type.propertyCache) == null ? void 0 : _c.get(name))) {
                        const properties2 = type.propertyCache || (type.propertyCache = createSymbolTable());
                        properties2.set(name, property);
                    }
                }
            }
            return property;
        }
        function getCommonDeclarationsOfSymbols(symbols) {
            let commonDeclarations;
            for (const symbol of symbols){
                if (!symbol.declarations) return void 0;
                if (!commonDeclarations) {
                    commonDeclarations = new Set(symbol.declarations);
                    continue;
                }
                commonDeclarations.forEach((declaration)=>{
                    if (!contains(symbol.declarations, declaration)) commonDeclarations.delete(declaration);
                });
                if (commonDeclarations.size === 0) return void 0;
            }
            return commonDeclarations;
        }
        function getPropertyOfUnionOrIntersectionType(type, name, skipObjectFunctionPropertyAugment) {
            const property = getUnionOrIntersectionProperty(type, name, skipObjectFunctionPropertyAugment);
            return property && !(getCheckFlags(property) & 16 /* ReadPartial */ ) ? property : void 0;
        }
        function getReducedType(type) {
            if (type.flags & 1048576 /* Union */  && type.objectFlags & 16777216 /* ContainsIntersections */ ) return type.resolvedReducedType || (type.resolvedReducedType = getReducedUnionType(type));
            else if (type.flags & 2097152 /* Intersection */ ) {
                if (!(type.objectFlags & 16777216 /* IsNeverIntersectionComputed */ )) type.objectFlags |= 16777216 /* IsNeverIntersectionComputed */  | (some(getPropertiesOfUnionOrIntersectionType(type), isNeverReducedProperty) ? 33554432 /* IsNeverIntersection */  : 0);
                return type.objectFlags & 33554432 /* IsNeverIntersection */  ? neverType : type;
            }
            return type;
        }
        function getReducedUnionType(unionType) {
            const reducedTypes = sameMap(unionType.types, getReducedType);
            if (reducedTypes === unionType.types) return unionType;
            const reduced = getUnionType(reducedTypes);
            if (reduced.flags & 1048576 /* Union */ ) reduced.resolvedReducedType = reduced;
            return reduced;
        }
        function isNeverReducedProperty(prop) {
            return isDiscriminantWithNeverType(prop) || isConflictingPrivateProperty(prop);
        }
        function isDiscriminantWithNeverType(prop) {
            return !(prop.flags & 16777216 /* Optional */ ) && (getCheckFlags(prop) & 131264 /* HasNeverType */ ) === 192 /* Discriminant */  && !!(getTypeOfSymbol(prop).flags & 131072 /* Never */ );
        }
        function isConflictingPrivateProperty(prop) {
            return !prop.valueDeclaration && !!(getCheckFlags(prop) & 1024 /* ContainsPrivate */ );
        }
        function isGenericReducibleType(type) {
            return !!(type.flags & 1048576 /* Union */  && type.objectFlags & 16777216 /* ContainsIntersections */  && some(type.types, isGenericReducibleType) || type.flags & 2097152 /* Intersection */  && isReducibleIntersection(type));
        }
        function isReducibleIntersection(type) {
            const uniqueFilled = type.uniqueLiteralFilledInstantiation || (type.uniqueLiteralFilledInstantiation = instantiateType(type, uniqueLiteralMapper));
            return getReducedType(uniqueFilled) !== uniqueFilled;
        }
        function elaborateNeverIntersection(errorInfo, type) {
            if (type.flags & 2097152 /* Intersection */  && getObjectFlags(type) & 33554432 /* IsNeverIntersection */ ) {
                const neverProp = find(getPropertiesOfUnionOrIntersectionType(type), isDiscriminantWithNeverType);
                if (neverProp) return chainDiagnosticMessages(errorInfo, Diagnostics.The_intersection_0_was_reduced_to_never_because_property_1_has_conflicting_types_in_some_constituents, typeToString(type, /*enclosingDeclaration*/ void 0, 536870912 /* NoTypeReduction */ ), symbolToString(neverProp));
                const privateProp = find(getPropertiesOfUnionOrIntersectionType(type), isConflictingPrivateProperty);
                if (privateProp) return chainDiagnosticMessages(errorInfo, Diagnostics.The_intersection_0_was_reduced_to_never_because_property_1_exists_in_multiple_constituents_and_is_private_in_some, typeToString(type, /*enclosingDeclaration*/ void 0, 536870912 /* NoTypeReduction */ ), symbolToString(privateProp));
            }
            return errorInfo;
        }
        function getPropertyOfType(type, name, skipObjectFunctionPropertyAugment, includeTypeOnlyMembers) {
            var _a, _b;
            type = getReducedApparentType(type);
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                const symbol = resolved.members.get(name);
                if (symbol && !includeTypeOnlyMembers && ((_a = type.symbol) == null ? void 0 : _a.flags) & 512 /* ValueModule */  && ((_b = getSymbolLinks(type.symbol).typeOnlyExportStarMap) == null ? void 0 : _b.has(name))) return void 0;
                if (symbol && symbolIsValue(symbol, includeTypeOnlyMembers)) return symbol;
                if (skipObjectFunctionPropertyAugment) return void 0;
                const functionType = resolved === anyFunctionType ? globalFunctionType : resolved.callSignatures.length ? globalCallableFunctionType : resolved.constructSignatures.length ? globalNewableFunctionType : void 0;
                if (functionType) {
                    const symbol2 = getPropertyOfObjectType(functionType, name);
                    if (symbol2) return symbol2;
                }
                return getPropertyOfObjectType(globalObjectType, name);
            }
            if (type.flags & 2097152 /* Intersection */ ) {
                const prop = getPropertyOfUnionOrIntersectionType(type, name, /*skipObjectFunctionPropertyAugment*/ true);
                if (prop) return prop;
                if (!skipObjectFunctionPropertyAugment) return getPropertyOfUnionOrIntersectionType(type, name, skipObjectFunctionPropertyAugment);
                return void 0;
            }
            if (type.flags & 1048576 /* Union */ ) return getPropertyOfUnionOrIntersectionType(type, name, skipObjectFunctionPropertyAugment);
            return void 0;
        }
        function getSignaturesOfStructuredType(type, kind) {
            if (type.flags & 3670016 /* StructuredType */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                return kind === 0 /* Call */  ? resolved.callSignatures : resolved.constructSignatures;
            }
            return emptyArray;
        }
        function getSignaturesOfType(type, kind) {
            const result = getSignaturesOfStructuredType(getReducedApparentType(type), kind);
            if (kind === 0 /* Call */  && !length(result) && type.flags & 1048576 /* Union */ ) {
                if (type.arrayFallbackSignatures) return type.arrayFallbackSignatures;
                let memberName;
                if (everyType(type, (t)=>{
                    var _a;
                    return !!((_a = t.symbol) == null ? void 0 : _a.parent) && isArrayOrTupleSymbol(t.symbol.parent) && (!memberName ? (memberName = t.symbol.escapedName, true) : memberName === t.symbol.escapedName);
                })) {
                    const arrayArg = mapType(type, (t)=>getMappedType((isReadonlyArraySymbol(t.symbol.parent) ? globalReadonlyArrayType : globalArrayType).typeParameters[0], t.mapper));
                    const arrayType = createArrayType(arrayArg, someType(type, (t)=>isReadonlyArraySymbol(t.symbol.parent)));
                    return type.arrayFallbackSignatures = getSignaturesOfType(getTypeOfPropertyOfType(arrayType, memberName), kind);
                }
                type.arrayFallbackSignatures = result;
            }
            return result;
        }
        function isArrayOrTupleSymbol(symbol) {
            if (!symbol || !globalArrayType.symbol || !globalReadonlyArrayType.symbol) return false;
            return !!getSymbolIfSameReference(symbol, globalArrayType.symbol) || !!getSymbolIfSameReference(symbol, globalReadonlyArrayType.symbol);
        }
        function isReadonlyArraySymbol(symbol) {
            if (!symbol || !globalReadonlyArrayType.symbol) return false;
            return !!getSymbolIfSameReference(symbol, globalReadonlyArrayType.symbol);
        }
        function findIndexInfo(indexInfos, keyType) {
            return find(indexInfos, (info)=>info.keyType === keyType);
        }
        function findApplicableIndexInfo(indexInfos, keyType) {
            let stringIndexInfo;
            let applicableInfo;
            let applicableInfos;
            for (const info of indexInfos){
                if (info.keyType === stringType) stringIndexInfo = info;
                else if (isApplicableIndexType(keyType, info.keyType)) {
                    if (!applicableInfo) applicableInfo = info;
                    else (applicableInfos || (applicableInfos = [
                        applicableInfo
                    ])).push(info);
                }
            }
            return applicableInfos ? createIndexInfo(unknownType, getIntersectionType(map(applicableInfos, (info)=>info.type)), reduceLeft(applicableInfos, (isReadonly, info)=>isReadonly && info.isReadonly, /*initial*/ true)) : applicableInfo ? applicableInfo : stringIndexInfo && isApplicableIndexType(keyType, stringType) ? stringIndexInfo : void 0;
        }
        function isApplicableIndexType(source, target) {
            return isTypeAssignableTo(source, target) || target === stringType && isTypeAssignableTo(source, numberType) || target === numberType && (source === numericStringType || !!(source.flags & 128 /* StringLiteral */ ) && isNumericLiteralName(source.value));
        }
        function getIndexInfosOfStructuredType(type) {
            if (type.flags & 3670016 /* StructuredType */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                return resolved.indexInfos;
            }
            return emptyArray;
        }
        function getIndexInfosOfType(type) {
            return getIndexInfosOfStructuredType(getReducedApparentType(type));
        }
        function getIndexInfoOfType(type, keyType) {
            return findIndexInfo(getIndexInfosOfType(type), keyType);
        }
        function getIndexTypeOfType(type, keyType) {
            var _a;
            return (_a = getIndexInfoOfType(type, keyType)) == null ? void 0 : _a.type;
        }
        function getApplicableIndexInfos(type, keyType) {
            return getIndexInfosOfType(type).filter((info)=>isApplicableIndexType(keyType, info.keyType));
        }
        function getApplicableIndexInfo(type, keyType) {
            return findApplicableIndexInfo(getIndexInfosOfType(type), keyType);
        }
        function getApplicableIndexInfoForName(type, name) {
            return getApplicableIndexInfo(type, isLateBoundName(name) ? esSymbolType : getStringLiteralType(unescapeLeadingUnderscores(name)));
        }
        function getTypeParametersFromDeclaration(declaration) {
            var _a;
            let result;
            for (const node of getEffectiveTypeParameterDeclarations(declaration))result = appendIfUnique(result, getDeclaredTypeOfTypeParameter(node.symbol));
            return (result == null ? void 0 : result.length) ? result : isFunctionDeclaration(declaration) ? (_a = getSignatureOfTypeTag(declaration)) == null ? void 0 : _a.typeParameters : void 0;
        }
        function symbolsToArray(symbols) {
            const result = [];
            symbols.forEach((symbol, id)=>{
                if (!isReservedMemberName(id)) result.push(symbol);
            });
            return result;
        }
        function tryFindAmbientModule(moduleName, withAugmentations) {
            if (isExternalModuleNameRelative(moduleName)) return void 0;
            const symbol = getSymbol2(globals, '"' + moduleName + '"', 512 /* ValueModule */ );
            return symbol && withAugmentations ? getMergedSymbol(symbol) : symbol;
        }
        function hasEffectiveQuestionToken(node) {
            return hasQuestionToken(node) || isOptionalJSDocPropertyLikeTag(node) || isParameter(node) && isJSDocOptionalParameter(node);
        }
        function isOptionalParameter(node) {
            if (hasEffectiveQuestionToken(node)) return true;
            if (!isParameter(node)) return false;
            if (node.initializer) {
                const signature = getSignatureFromDeclaration(node.parent);
                const parameterIndex = node.parent.parameters.indexOf(node);
                Debug.assert(parameterIndex >= 0);
                return parameterIndex >= getMinArgumentCount(signature, 3 /* VoidIsNonOptional */ );
            }
            const iife = getImmediatelyInvokedFunctionExpression(node.parent);
            if (iife) return !node.type && !node.dotDotDotToken && node.parent.parameters.indexOf(node) >= getEffectiveCallArguments(iife).length;
            return false;
        }
        function isOptionalPropertyDeclaration(node) {
            return isPropertyDeclaration(node) && !hasAccessorModifier(node) && node.questionToken;
        }
        function createTypePredicate(kind, parameterName, parameterIndex, type) {
            return {
                kind,
                parameterName,
                parameterIndex,
                type
            };
        }
        function getMinTypeArgumentCount(typeParameters) {
            let minTypeArgumentCount = 0;
            if (typeParameters) {
                for(let i = 0; i < typeParameters.length; i++)if (!hasTypeParameterDefault(typeParameters[i])) minTypeArgumentCount = i + 1;
            }
            return minTypeArgumentCount;
        }
        function fillMissingTypeArguments(typeArguments, typeParameters, minTypeArgumentCount, isJavaScriptImplicitAny) {
            const numTypeParameters = length(typeParameters);
            if (!numTypeParameters) return [];
            const numTypeArguments = length(typeArguments);
            if (isJavaScriptImplicitAny || numTypeArguments >= minTypeArgumentCount && numTypeArguments <= numTypeParameters) {
                const result = typeArguments ? typeArguments.slice() : [];
                for(let i = numTypeArguments; i < numTypeParameters; i++)result[i] = errorType;
                const baseDefaultType = getDefaultTypeArgumentType(isJavaScriptImplicitAny);
                for(let i = numTypeArguments; i < numTypeParameters; i++){
                    let defaultType = getDefaultFromTypeParameter(typeParameters[i]);
                    if (isJavaScriptImplicitAny && defaultType && (isTypeIdenticalTo(defaultType, unknownType) || isTypeIdenticalTo(defaultType, emptyObjectType))) defaultType = anyType;
                    result[i] = defaultType ? instantiateType(defaultType, createTypeMapper(typeParameters, result)) : baseDefaultType;
                }
                result.length = typeParameters.length;
                return result;
            }
            return typeArguments && typeArguments.slice();
        }
        function getSignatureFromDeclaration(declaration) {
            const links = getNodeLinks(declaration);
            if (!links.resolvedSignature) {
                const parameters = [];
                let flags = 0 /* None */ ;
                let minArgumentCount = 0;
                let thisParameter;
                let thisTag = isInJSFile(declaration) ? getJSDocThisTag(declaration) : void 0;
                let hasThisParameter2 = false;
                const iife = getImmediatelyInvokedFunctionExpression(declaration);
                const isJSConstructSignature = isJSDocConstructSignature(declaration);
                const isUntypedSignatureInJSFile = !iife && isInJSFile(declaration) && isValueSignatureDeclaration(declaration) && !hasJSDocParameterTags(declaration) && !some(declaration.parameters, (p)=>!!getJSDocType(p)) && !getJSDocType(declaration) && !getContextualSignatureForFunctionLikeDeclaration(declaration);
                if (isUntypedSignatureInJSFile) flags |= 32 /* IsUntypedSignatureInJSFile */ ;
                for(let i = isJSConstructSignature ? 1 : 0; i < declaration.parameters.length; i++){
                    const param = declaration.parameters[i];
                    if (isInJSFile(param) && isJSDocThisTag(param)) {
                        thisTag = param;
                        continue;
                    }
                    let paramSymbol = param.symbol;
                    const type = isJSDocParameterTag(param) ? param.typeExpression && param.typeExpression.type : param.type;
                    if (paramSymbol && !!(paramSymbol.flags & 4 /* Property */ ) && !isBindingPattern(param.name)) {
                        const resolvedSymbol = resolveName(param, paramSymbol.escapedName, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
                        paramSymbol = resolvedSymbol;
                    }
                    if (i === 0 && paramSymbol.escapedName === "this" /* This */ ) {
                        hasThisParameter2 = true;
                        thisParameter = param.symbol;
                    } else parameters.push(paramSymbol);
                    if (type && type.kind === 202 /* LiteralType */ ) flags |= 2 /* HasLiteralTypes */ ;
                    const isOptionalParameter2 = hasEffectiveQuestionToken(param) || isParameter(param) && param.initializer || isRestParameter(param) || iife && parameters.length > iife.arguments.length && !type;
                    if (!isOptionalParameter2) minArgumentCount = parameters.length;
                }
                if ((declaration.kind === 178 /* GetAccessor */  || declaration.kind === 179 /* SetAccessor */ ) && hasBindableName(declaration) && (!hasThisParameter2 || !thisParameter)) {
                    const otherKind = declaration.kind === 178 /* GetAccessor */  ? 179 /* SetAccessor */  : 178 /* GetAccessor */ ;
                    const other = getDeclarationOfKind(getSymbolOfDeclaration(declaration), otherKind);
                    if (other) thisParameter = getAnnotatedAccessorThisParameter(other);
                }
                if (thisTag && thisTag.typeExpression) thisParameter = createSymbolWithType(createSymbol(1 /* FunctionScopedVariable */ , "this" /* This */ ), getTypeFromTypeNode(thisTag.typeExpression));
                const hostDeclaration = isJSDocSignature(declaration) ? getEffectiveJSDocHost(declaration) : declaration;
                const classType = hostDeclaration && isConstructorDeclaration(hostDeclaration) ? getDeclaredTypeOfClassOrInterface(getMergedSymbol(hostDeclaration.parent.symbol)) : void 0;
                const typeParameters = classType ? classType.localTypeParameters : getTypeParametersFromDeclaration(declaration);
                if (hasRestParameter(declaration) || isInJSFile(declaration) && maybeAddJsSyntheticRestParameter(declaration, parameters)) flags |= 1 /* HasRestParameter */ ;
                if (isConstructorTypeNode(declaration) && hasSyntacticModifier(declaration, 64 /* Abstract */ ) || isConstructorDeclaration(declaration) && hasSyntacticModifier(declaration.parent, 64 /* Abstract */ )) flags |= 4 /* Abstract */ ;
                links.resolvedSignature = createSignature(declaration, typeParameters, thisParameter, parameters, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, minArgumentCount, flags);
            }
            return links.resolvedSignature;
        }
        function maybeAddJsSyntheticRestParameter(declaration, parameters) {
            if (isJSDocSignature(declaration) || !containsArgumentsReference(declaration)) return false;
            const lastParam = lastOrUndefined(declaration.parameters);
            const lastParamTags = lastParam ? getJSDocParameterTags(lastParam) : getJSDocTags(declaration).filter(isJSDocParameterTag);
            const lastParamVariadicType = firstDefined(lastParamTags, (p)=>p.typeExpression && isJSDocVariadicType(p.typeExpression.type) ? p.typeExpression.type : void 0);
            const syntheticArgsSymbol = createSymbol(3 /* Variable */ , "args", 32768 /* RestParameter */ );
            if (lastParamVariadicType) syntheticArgsSymbol.links.type = createArrayType(getTypeFromTypeNode(lastParamVariadicType.type));
            else {
                syntheticArgsSymbol.links.checkFlags |= 65536 /* DeferredType */ ;
                syntheticArgsSymbol.links.deferralParent = neverType;
                syntheticArgsSymbol.links.deferralConstituents = [
                    anyArrayType
                ];
                syntheticArgsSymbol.links.deferralWriteConstituents = [
                    anyArrayType
                ];
            }
            if (lastParamVariadicType) parameters.pop();
            parameters.push(syntheticArgsSymbol);
            return true;
        }
        function getSignatureOfTypeTag(node) {
            if (!(isInJSFile(node) && isFunctionLikeDeclaration(node))) return void 0;
            const typeTag = getJSDocTypeTag(node);
            return (typeTag == null ? void 0 : typeTag.typeExpression) && getSingleCallSignature(getTypeFromTypeNode(typeTag.typeExpression));
        }
        function getParameterTypeOfTypeTag(func, parameter) {
            const signature = getSignatureOfTypeTag(func);
            if (!signature) return void 0;
            const pos = func.parameters.indexOf(parameter);
            return parameter.dotDotDotToken ? getRestTypeAtPosition(signature, pos) : getTypeAtPosition(signature, pos);
        }
        function getReturnTypeOfTypeTag(node) {
            const signature = getSignatureOfTypeTag(node);
            return signature && getReturnTypeOfSignature(signature);
        }
        function containsArgumentsReference(declaration) {
            const links = getNodeLinks(declaration);
            if (links.containsArgumentsReference === void 0) {
                if (links.flags & 512 /* CaptureArguments */ ) links.containsArgumentsReference = true;
                else links.containsArgumentsReference = traverse(declaration.body);
            }
            return links.containsArgumentsReference;
            function traverse(node) {
                if (!node) return false;
                switch(node.kind){
                    case 80 /* Identifier */ :
                        return node.escapedText === argumentsSymbol.escapedName && getReferencedValueSymbol(node) === argumentsSymbol;
                    case 173 /* PropertyDeclaration */ :
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        return node.name.kind === 168 /* ComputedPropertyName */  && traverse(node.name);
                    case 212 /* PropertyAccessExpression */ :
                    case 213 /* ElementAccessExpression */ :
                        return traverse(node.expression);
                    case 304 /* PropertyAssignment */ :
                        return traverse(node.initializer);
                    default:
                        return !nodeStartsNewLexicalEnvironment(node) && !isPartOfTypeNode(node) && !!forEachChild(node, traverse);
                }
            }
        }
        function getSignaturesOfSymbol(symbol) {
            if (!symbol || !symbol.declarations) return emptyArray;
            const result = [];
            for(let i = 0; i < symbol.declarations.length; i++){
                const decl = symbol.declarations[i];
                if (!isFunctionLike(decl)) continue;
                if (i > 0 && decl.body) {
                    const previous = symbol.declarations[i - 1];
                    if (decl.parent === previous.parent && decl.kind === previous.kind && decl.pos === previous.end) continue;
                }
                if (isInJSFile(decl) && decl.jsDoc) {
                    const tags = getJSDocOverloadTags(decl);
                    if (length(tags)) {
                        for (const tag of tags){
                            const jsDocSignature = tag.typeExpression;
                            if (jsDocSignature.type === void 0 && !isConstructorDeclaration(decl)) reportImplicitAny(jsDocSignature, anyType);
                            result.push(getSignatureFromDeclaration(jsDocSignature));
                        }
                        continue;
                    }
                }
                result.push(!isFunctionExpressionOrArrowFunction(decl) && !isObjectLiteralMethod(decl) && getSignatureOfTypeTag(decl) || getSignatureFromDeclaration(decl));
            }
            return result;
        }
        function resolveExternalModuleTypeByLiteral(name) {
            const moduleSym = resolveExternalModuleName(name, name);
            if (moduleSym) {
                const resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
                if (resolvedModuleSymbol) return getTypeOfSymbol(resolvedModuleSymbol);
            }
            return anyType;
        }
        function getThisTypeOfSignature(signature) {
            if (signature.thisParameter) return getTypeOfSymbol(signature.thisParameter);
        }
        function getTypePredicateOfSignature(signature) {
            if (!signature.resolvedTypePredicate) {
                if (signature.target) {
                    const targetTypePredicate = getTypePredicateOfSignature(signature.target);
                    signature.resolvedTypePredicate = targetTypePredicate ? instantiateTypePredicate(targetTypePredicate, signature.mapper) : noTypePredicate;
                } else if (signature.compositeSignatures) signature.resolvedTypePredicate = getUnionOrIntersectionTypePredicate(signature.compositeSignatures, signature.compositeKind) || noTypePredicate;
                else {
                    const type = signature.declaration && getEffectiveReturnTypeNode(signature.declaration);
                    let jsdocPredicate;
                    if (!type) {
                        const jsdocSignature = getSignatureOfTypeTag(signature.declaration);
                        if (jsdocSignature && signature !== jsdocSignature) jsdocPredicate = getTypePredicateOfSignature(jsdocSignature);
                    }
                    if (type || jsdocPredicate) signature.resolvedTypePredicate = type && isTypePredicateNode(type) ? createTypePredicateFromTypePredicateNode(type, signature) : jsdocPredicate || noTypePredicate;
                    else if (signature.declaration && isFunctionLikeDeclaration(signature.declaration) && (!signature.resolvedReturnType || signature.resolvedReturnType.flags & 16 /* Boolean */ ) && getParameterCount(signature) > 0) {
                        const { declaration } = signature;
                        signature.resolvedTypePredicate = noTypePredicate;
                        signature.resolvedTypePredicate = getTypePredicateFromBody(declaration) || noTypePredicate;
                    } else signature.resolvedTypePredicate = noTypePredicate;
                }
                Debug.assert(!!signature.resolvedTypePredicate);
            }
            return signature.resolvedTypePredicate === noTypePredicate ? void 0 : signature.resolvedTypePredicate;
        }
        function createTypePredicateFromTypePredicateNode(node, signature) {
            const parameterName = node.parameterName;
            const type = node.type && getTypeFromTypeNode(node.type);
            return parameterName.kind === 198 /* ThisType */  ? createTypePredicate(node.assertsModifier ? 2 /* AssertsThis */  : 0 /* This */ , /*parameterName*/ void 0, /*parameterIndex*/ void 0, type) : createTypePredicate(node.assertsModifier ? 3 /* AssertsIdentifier */  : 1 /* Identifier */ , parameterName.escapedText, findIndex(signature.parameters, (p)=>p.escapedName === parameterName.escapedText), type);
        }
        function getUnionOrIntersectionType(types, kind, unionReduction) {
            return kind !== 2097152 /* Intersection */  ? getUnionType(types, unionReduction) : getIntersectionType(types);
        }
        function getReturnTypeOfSignature(signature) {
            if (!signature.resolvedReturnType) {
                if (!pushTypeResolution(signature, 3 /* ResolvedReturnType */ )) return errorType;
                let type = signature.target ? instantiateType(getReturnTypeOfSignature(signature.target), signature.mapper) : signature.compositeSignatures ? instantiateType(getUnionOrIntersectionType(map(signature.compositeSignatures, getReturnTypeOfSignature), signature.compositeKind, 2 /* Subtype */ ), signature.mapper) : getReturnTypeFromAnnotation(signature.declaration) || (nodeIsMissing(signature.declaration.body) ? anyType : getReturnTypeFromBody(signature.declaration));
                if (signature.flags & 8 /* IsInnerCallChain */ ) type = addOptionalTypeMarker(type);
                else if (signature.flags & 16 /* IsOuterCallChain */ ) type = getOptionalType(type);
                if (!popTypeResolution()) {
                    if (signature.declaration) {
                        const typeNode = getEffectiveReturnTypeNode(signature.declaration);
                        if (typeNode) error2(typeNode, Diagnostics.Return_type_annotation_circularly_references_itself);
                        else if (noImplicitAny) {
                            const declaration = signature.declaration;
                            const name = getNameOfDeclaration(declaration);
                            if (name) error2(name, Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, declarationNameToString(name));
                            else error2(declaration, Diagnostics.Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions);
                        }
                    }
                    type = anyType;
                }
                var _signature_resolvedReturnType;
                (_signature_resolvedReturnType = signature.resolvedReturnType) !== null && _signature_resolvedReturnType !== void 0 ? _signature_resolvedReturnType : signature.resolvedReturnType = type;
            }
            return signature.resolvedReturnType;
        }
        function getReturnTypeFromAnnotation(declaration) {
            if (declaration.kind === 177 /* Constructor */ ) return getDeclaredTypeOfClassOrInterface(getMergedSymbol(declaration.parent.symbol));
            const typeNode = getEffectiveReturnTypeNode(declaration);
            if (isJSDocSignature(declaration)) {
                const root = getJSDocRoot(declaration);
                if (root && isConstructorDeclaration(root.parent) && !typeNode) return getDeclaredTypeOfClassOrInterface(getMergedSymbol(root.parent.parent.symbol));
            }
            if (isJSDocConstructSignature(declaration)) return getTypeFromTypeNode(declaration.parameters[0].type);
            if (typeNode) return getTypeFromTypeNode(typeNode);
            if (declaration.kind === 178 /* GetAccessor */  && hasBindableName(declaration)) {
                const jsDocType = isInJSFile(declaration) && getTypeForDeclarationFromJSDocComment(declaration);
                if (jsDocType) return jsDocType;
                const setter = getDeclarationOfKind(getSymbolOfDeclaration(declaration), 179 /* SetAccessor */ );
                const setterType = getAnnotatedAccessorType(setter);
                if (setterType) return setterType;
            }
            return getReturnTypeOfTypeTag(declaration);
        }
        function isResolvingReturnTypeOfSignature(signature) {
            return signature.compositeSignatures && some(signature.compositeSignatures, isResolvingReturnTypeOfSignature) || !signature.resolvedReturnType && findResolutionCycleStartIndex(signature, 3 /* ResolvedReturnType */ ) >= 0;
        }
        function getRestTypeOfSignature(signature) {
            return tryGetRestTypeOfSignature(signature) || anyType;
        }
        function tryGetRestTypeOfSignature(signature) {
            if (signatureHasRestParameter(signature)) {
                const sigRestType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                const restType = isTupleType(sigRestType) ? getRestTypeOfTupleType(sigRestType) : sigRestType;
                return restType && getIndexTypeOfType(restType, numberType);
            }
            return void 0;
        }
        function getSignatureInstantiation(signature, typeArguments, isJavascript, inferredTypeParameters) {
            const instantiatedSignature = getSignatureInstantiationWithoutFillingInTypeArguments(signature, fillMissingTypeArguments(typeArguments, signature.typeParameters, getMinTypeArgumentCount(signature.typeParameters), isJavascript));
            if (inferredTypeParameters) {
                const returnSignature = getSingleCallOrConstructSignature(getReturnTypeOfSignature(instantiatedSignature));
                if (returnSignature) {
                    const newReturnSignature = cloneSignature(returnSignature);
                    newReturnSignature.typeParameters = inferredTypeParameters;
                    const newReturnType = getOrCreateTypeFromSignature(newReturnSignature);
                    newReturnType.mapper = instantiatedSignature.mapper;
                    const newInstantiatedSignature = cloneSignature(instantiatedSignature);
                    newInstantiatedSignature.resolvedReturnType = newReturnType;
                    return newInstantiatedSignature;
                }
            }
            return instantiatedSignature;
        }
        function getSignatureInstantiationWithoutFillingInTypeArguments(signature, typeArguments) {
            const instantiations = signature.instantiations || (signature.instantiations = /* @__PURE__ */ new Map());
            const id = getTypeListId(typeArguments);
            let instantiation = instantiations.get(id);
            if (!instantiation) instantiations.set(id, instantiation = createSignatureInstantiation(signature, typeArguments));
            return instantiation;
        }
        function createSignatureInstantiation(signature, typeArguments) {
            return instantiateSignature(signature, createSignatureTypeMapper(signature, typeArguments), /*eraseTypeParameters*/ true);
        }
        function getTypeParametersForMapper(signature) {
            return sameMap(signature.typeParameters, (tp)=>tp.mapper ? instantiateType(tp, tp.mapper) : tp);
        }
        function createSignatureTypeMapper(signature, typeArguments) {
            return createTypeMapper(getTypeParametersForMapper(signature), typeArguments);
        }
        function getErasedSignature(signature) {
            return signature.typeParameters ? signature.erasedSignatureCache || (signature.erasedSignatureCache = createErasedSignature(signature)) : signature;
        }
        function createErasedSignature(signature) {
            return instantiateSignature(signature, createTypeEraser(signature.typeParameters), /*eraseTypeParameters*/ true);
        }
        function getCanonicalSignature(signature) {
            return signature.typeParameters ? signature.canonicalSignatureCache || (signature.canonicalSignatureCache = createCanonicalSignature(signature)) : signature;
        }
        function createCanonicalSignature(signature) {
            return getSignatureInstantiation(signature, map(signature.typeParameters, (tp)=>tp.target && !getConstraintOfTypeParameter(tp.target) ? tp.target : tp), isInJSFile(signature.declaration));
        }
        function getBaseSignature(signature) {
            const typeParameters = signature.typeParameters;
            if (typeParameters) {
                if (signature.baseSignatureCache) return signature.baseSignatureCache;
                const typeEraser = createTypeEraser(typeParameters);
                const baseConstraintMapper = createTypeMapper(typeParameters, map(typeParameters, (tp)=>getConstraintOfTypeParameter(tp) || unknownType));
                let baseConstraints = map(typeParameters, (tp)=>instantiateType(tp, baseConstraintMapper) || unknownType);
                for(let i = 0; i < typeParameters.length - 1; i++)baseConstraints = instantiateTypes(baseConstraints, baseConstraintMapper);
                baseConstraints = instantiateTypes(baseConstraints, typeEraser);
                return signature.baseSignatureCache = instantiateSignature(signature, createTypeMapper(typeParameters, baseConstraints), /*eraseTypeParameters*/ true);
            }
            return signature;
        }
        function getOrCreateTypeFromSignature(signature) {
            var _a, _b;
            if (!signature.isolatedSignatureType) {
                const kind = (_a = signature.declaration) == null ? void 0 : _a.kind;
                const isConstructor = kind === void 0 || kind === 177 /* Constructor */  || kind === 181 /* ConstructSignature */  || kind === 186 /* ConstructorType */ ;
                const type = createObjectType(134217744 /* SingleSignatureType */ , (_b = signature.declaration) == null ? void 0 : _b.symbol);
                type.members = emptySymbols;
                type.properties = emptyArray;
                type.callSignatures = !isConstructor ? [
                    signature
                ] : emptyArray;
                type.constructSignatures = isConstructor ? [
                    signature
                ] : emptyArray;
                type.indexInfos = emptyArray;
                signature.isolatedSignatureType = type;
            }
            return signature.isolatedSignatureType;
        }
        function getIndexSymbol(symbol) {
            return symbol.members ? getIndexSymbolFromSymbolTable(getMembersOfSymbol(symbol)) : void 0;
        }
        function getIndexSymbolFromSymbolTable(symbolTable) {
            return symbolTable.get("__index" /* Index */ );
        }
        function createIndexInfo(keyType, type, isReadonly, declaration, components) {
            return {
                keyType,
                type,
                isReadonly,
                declaration,
                components
            };
        }
        function getIndexInfosOfSymbol(symbol) {
            const indexSymbol = getIndexSymbol(symbol);
            return indexSymbol ? getIndexInfosOfIndexSymbol(indexSymbol, arrayFrom(getMembersOfSymbol(symbol).values())) : emptyArray;
        }
        function getIndexInfosOfIndexSymbol(indexSymbol, siblingSymbols = indexSymbol.parent ? arrayFrom(getMembersOfSymbol(indexSymbol.parent).values()) : void 0) {
            if (indexSymbol.declarations) {
                const indexInfos = [];
                let hasComputedNumberProperty = false;
                let readonlyComputedNumberProperty = true;
                let hasComputedSymbolProperty = false;
                let readonlyComputedSymbolProperty = true;
                let hasComputedStringProperty = false;
                let readonlyComputedStringProperty = true;
                const computedPropertySymbols = [];
                for (const declaration of indexSymbol.declarations){
                    if (isIndexSignatureDeclaration(declaration)) {
                        if (declaration.parameters.length === 1) {
                            const parameter = declaration.parameters[0];
                            if (parameter.type) forEachType(getTypeFromTypeNode(parameter.type), (keyType)=>{
                                if (isValidIndexKeyType(keyType) && !findIndexInfo(indexInfos, keyType)) indexInfos.push(createIndexInfo(keyType, declaration.type ? getTypeFromTypeNode(declaration.type) : anyType, hasEffectiveModifier(declaration, 8 /* Readonly */ ), declaration));
                            });
                        }
                    } else if (hasLateBindableIndexSignature(declaration)) {
                        const declName = isBinaryExpression(declaration) ? declaration.left : declaration.name;
                        const keyType = isElementAccessExpression(declName) ? checkExpressionCached(declName.argumentExpression) : checkComputedPropertyName(declName);
                        if (findIndexInfo(indexInfos, keyType)) continue;
                        if (isTypeAssignableTo(keyType, stringNumberSymbolType)) {
                            if (isTypeAssignableTo(keyType, numberType)) {
                                hasComputedNumberProperty = true;
                                if (!hasEffectiveReadonlyModifier(declaration)) readonlyComputedNumberProperty = false;
                            } else if (isTypeAssignableTo(keyType, esSymbolType)) {
                                hasComputedSymbolProperty = true;
                                if (!hasEffectiveReadonlyModifier(declaration)) readonlyComputedSymbolProperty = false;
                            } else {
                                hasComputedStringProperty = true;
                                if (!hasEffectiveReadonlyModifier(declaration)) readonlyComputedStringProperty = false;
                            }
                            computedPropertySymbols.push(declaration.symbol);
                        }
                    }
                }
                const allPropertySymbols = concatenate(computedPropertySymbols, filter(siblingSymbols, (s)=>s !== indexSymbol));
                if (hasComputedStringProperty && !findIndexInfo(indexInfos, stringType)) indexInfos.push(getObjectLiteralIndexInfo(readonlyComputedStringProperty, 0, allPropertySymbols, stringType));
                if (hasComputedNumberProperty && !findIndexInfo(indexInfos, numberType)) indexInfos.push(getObjectLiteralIndexInfo(readonlyComputedNumberProperty, 0, allPropertySymbols, numberType));
                if (hasComputedSymbolProperty && !findIndexInfo(indexInfos, esSymbolType)) indexInfos.push(getObjectLiteralIndexInfo(readonlyComputedSymbolProperty, 0, allPropertySymbols, esSymbolType));
                return indexInfos;
            }
            return emptyArray;
        }
        function isValidIndexKeyType(type) {
            return !!(type.flags & 4108 /* ESSymbol */ ) || isPatternLiteralType(type) || !!(type.flags & 2097152 /* Intersection */ ) && !isGenericType(type) && some(type.types, isValidIndexKeyType);
        }
        function getConstraintDeclaration(type) {
            return mapDefined(filter(type.symbol && type.symbol.declarations, isTypeParameterDeclaration), getEffectiveConstraintOfTypeParameter)[0];
        }
        function getInferredTypeParameterConstraint(typeParameter, omitTypeReferences) {
            var _a;
            let inferences;
            if ((_a = typeParameter.symbol) == null ? void 0 : _a.declarations) {
                for (const declaration of typeParameter.symbol.declarations)if (declaration.parent.kind === 196 /* InferType */ ) {
                    const [childTypeParameter = declaration.parent, grandParent] = walkUpParenthesizedTypesAndGetParentAndChild(declaration.parent.parent);
                    if (grandParent.kind === 184 /* TypeReference */  && !omitTypeReferences) {
                        const typeReference = grandParent;
                        const typeParameters = getTypeParametersForTypeReferenceOrImport(typeReference);
                        if (typeParameters) {
                            const index = typeReference.typeArguments.indexOf(childTypeParameter);
                            if (index < typeParameters.length) {
                                const declaredConstraint = getConstraintOfTypeParameter(typeParameters[index]);
                                if (declaredConstraint) {
                                    const mapper = makeDeferredTypeMapper(typeParameters, typeParameters.map((_, index2)=>()=>{
                                            return getEffectiveTypeArgumentAtIndex(typeReference, typeParameters, index2);
                                        }));
                                    const constraint = instantiateType(declaredConstraint, mapper);
                                    if (constraint !== typeParameter) inferences = append(inferences, constraint);
                                }
                            }
                        }
                    } else if (grandParent.kind === 170 /* Parameter */  && grandParent.dotDotDotToken || grandParent.kind === 192 /* RestType */  || grandParent.kind === 203 /* NamedTupleMember */  && grandParent.dotDotDotToken) inferences = append(inferences, createArrayType(unknownType));
                    else if (grandParent.kind === 205 /* TemplateLiteralTypeSpan */ ) inferences = append(inferences, stringType);
                    else if (grandParent.kind === 169 /* TypeParameter */  && grandParent.parent.kind === 201 /* MappedType */ ) inferences = append(inferences, stringNumberSymbolType);
                    else if (grandParent.kind === 201 /* MappedType */  && grandParent.type && skipParentheses(grandParent.type) === declaration.parent && grandParent.parent.kind === 195 /* ConditionalType */  && grandParent.parent.extendsType === grandParent && grandParent.parent.checkType.kind === 201 /* MappedType */  && grandParent.parent.checkType.type) {
                        const checkMappedType2 = grandParent.parent.checkType;
                        const nodeType = getTypeFromTypeNode(checkMappedType2.type);
                        inferences = append(inferences, instantiateType(nodeType, makeUnaryTypeMapper(getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(checkMappedType2.typeParameter)), checkMappedType2.typeParameter.constraint ? getTypeFromTypeNode(checkMappedType2.typeParameter.constraint) : stringNumberSymbolType)));
                    }
                }
            }
            return inferences && getIntersectionType(inferences);
        }
        function getConstraintFromTypeParameter(typeParameter) {
            if (!typeParameter.constraint) {
                if (typeParameter.target) {
                    const targetConstraint = getConstraintOfTypeParameter(typeParameter.target);
                    typeParameter.constraint = targetConstraint ? instantiateType(targetConstraint, typeParameter.mapper) : noConstraintType;
                } else {
                    const constraintDeclaration = getConstraintDeclaration(typeParameter);
                    if (!constraintDeclaration) typeParameter.constraint = getInferredTypeParameterConstraint(typeParameter) || noConstraintType;
                    else {
                        let type = getTypeFromTypeNode(constraintDeclaration);
                        if (type.flags & 1 /* Any */  && !isErrorType(type)) type = constraintDeclaration.parent.parent.kind === 201 /* MappedType */  ? stringNumberSymbolType : unknownType;
                        typeParameter.constraint = type;
                    }
                }
            }
            return typeParameter.constraint === noConstraintType ? void 0 : typeParameter.constraint;
        }
        function getParentSymbolOfTypeParameter(typeParameter) {
            const tp = getDeclarationOfKind(typeParameter.symbol, 169 /* TypeParameter */ );
            const host2 = isJSDocTemplateTag(tp.parent) ? getEffectiveContainerForJSDocTemplateTag(tp.parent) : tp.parent;
            return host2 && getSymbolOfNode(host2);
        }
        function getTypeListId(types) {
            let result = "";
            if (types) {
                const length2 = types.length;
                let i = 0;
                while(i < length2){
                    const startId = types[i].id;
                    let count = 1;
                    while(i + count < length2 && types[i + count].id === startId + count)count++;
                    if (result.length) result += ",";
                    result += startId;
                    if (count > 1) result += ":" + count;
                    i += count;
                }
            }
            return result;
        }
        function getAliasId(aliasSymbol, aliasTypeArguments) {
            return aliasSymbol ? `@${getSymbolId(aliasSymbol)}` + (aliasTypeArguments ? `:${getTypeListId(aliasTypeArguments)}` : "") : "";
        }
        function getPropagatingFlagsOfTypes(types, excludeKinds) {
            let result = 0;
            for (const type of types)if (excludeKinds === void 0 || !(type.flags & excludeKinds)) result |= getObjectFlags(type);
            return result & 458752 /* PropagatingFlags */ ;
        }
        function tryCreateTypeReference(target, typeArguments) {
            if (some(typeArguments) && target === emptyGenericType) return unknownType;
            return createTypeReference(target, typeArguments);
        }
        function createTypeReference(target, typeArguments) {
            const id = getTypeListId(typeArguments);
            let type = target.instantiations.get(id);
            if (!type) {
                type = createObjectType(4 /* Reference */ , target.symbol);
                target.instantiations.set(id, type);
                type.objectFlags |= typeArguments ? getPropagatingFlagsOfTypes(typeArguments) : 0;
                type.target = target;
                type.resolvedTypeArguments = typeArguments;
            }
            return type;
        }
        function cloneTypeReference(source) {
            const type = createTypeWithSymbol(source.flags, source.symbol);
            type.objectFlags = source.objectFlags;
            type.target = source.target;
            type.resolvedTypeArguments = source.resolvedTypeArguments;
            return type;
        }
        function createDeferredTypeReference(target, node, mapper, aliasSymbol, aliasTypeArguments) {
            if (!aliasSymbol) {
                aliasSymbol = getAliasSymbolForTypeNode(node);
                const localAliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
                aliasTypeArguments = mapper ? instantiateTypes(localAliasTypeArguments, mapper) : localAliasTypeArguments;
            }
            const type = createObjectType(4 /* Reference */ , target.symbol);
            type.target = target;
            type.node = node;
            type.mapper = mapper;
            type.aliasSymbol = aliasSymbol;
            type.aliasTypeArguments = aliasTypeArguments;
            return type;
        }
        function getTypeArguments(type) {
            var _a, _b;
            if (!type.resolvedTypeArguments) {
                if (!pushTypeResolution(type, 5 /* ResolvedTypeArguments */ )) return concatenate(type.target.outerTypeParameters, (_a = type.target.localTypeParameters) == null ? void 0 : _a.map(()=>errorType)) || emptyArray;
                const node = type.node;
                const typeArguments = !node ? emptyArray : node.kind === 184 /* TypeReference */  ? concatenate(type.target.outerTypeParameters, getEffectiveTypeArguments2(node, type.target.localTypeParameters)) : node.kind === 189 /* ArrayType */  ? [
                    getTypeFromTypeNode(node.elementType)
                ] : map(node.elements, getTypeFromTypeNode);
                var _type_resolvedTypeArguments;
                if (popTypeResolution()) (_type_resolvedTypeArguments = type.resolvedTypeArguments) !== null && _type_resolvedTypeArguments !== void 0 ? _type_resolvedTypeArguments : type.resolvedTypeArguments = type.mapper ? instantiateTypes(typeArguments, type.mapper) : typeArguments;
                else {
                    var _type_resolvedTypeArguments1;
                    (_type_resolvedTypeArguments1 = type.resolvedTypeArguments) !== null && _type_resolvedTypeArguments1 !== void 0 ? _type_resolvedTypeArguments1 : type.resolvedTypeArguments = concatenate(type.target.outerTypeParameters, ((_b = type.target.localTypeParameters) == null ? void 0 : _b.map(()=>errorType)) || emptyArray);
                    error2(type.node || currentNode, type.target.symbol ? Diagnostics.Type_arguments_for_0_circularly_reference_themselves : Diagnostics.Tuple_type_arguments_circularly_reference_themselves, type.target.symbol && symbolToString(type.target.symbol));
                }
            }
            return type.resolvedTypeArguments;
        }
        function getTypeReferenceArity(type) {
            return length(type.target.typeParameters);
        }
        function getTypeFromClassOrInterfaceReference(node, symbol) {
            const type = getDeclaredTypeOfSymbol(getMergedSymbol(symbol));
            const typeParameters = type.localTypeParameters;
            if (typeParameters) {
                const numTypeArguments = length(node.typeArguments);
                const minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
                const isJs = isInJSFile(node);
                const isJsImplicitAny = !noImplicitAny && isJs;
                if (!isJsImplicitAny && (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length)) {
                    const missingAugmentsTag = isJs && isExpressionWithTypeArguments(node) && !isJSDocAugmentsTag(node.parent);
                    const diag2 = minTypeArgumentCount === typeParameters.length ? missingAugmentsTag ? Diagnostics.Expected_0_type_arguments_provide_these_with_an_extends_tag : Diagnostics.Generic_type_0_requires_1_type_argument_s : missingAugmentsTag ? Diagnostics.Expected_0_1_type_arguments_provide_these_with_an_extends_tag : Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments;
                    const typeStr = typeToString(type, /*enclosingDeclaration*/ void 0, 2 /* WriteArrayAsGenericType */ );
                    error2(node, diag2, typeStr, minTypeArgumentCount, typeParameters.length);
                    if (!isJs) return errorType;
                }
                if (node.kind === 184 /* TypeReference */  && isDeferredTypeReferenceNode(node, length(node.typeArguments) !== typeParameters.length)) return createDeferredTypeReference(type, node, /*mapper*/ void 0);
                const typeArguments = concatenate(type.outerTypeParameters, fillMissingTypeArguments(typeArgumentsFromTypeReferenceNode(node), typeParameters, minTypeArgumentCount, isJs));
                return createTypeReference(type, typeArguments);
            }
            return checkNoTypeArguments(node, symbol) ? type : errorType;
        }
        function getTypeAliasInstantiation(symbol, typeArguments, aliasSymbol, aliasTypeArguments) {
            const type = getDeclaredTypeOfSymbol(symbol);
            if (type === intrinsicMarkerType) {
                const typeKind = intrinsicTypeKinds.get(symbol.escapedName);
                if (typeKind !== void 0 && typeArguments && typeArguments.length === 1) return typeKind === 4 /* NoInfer */  ? getNoInferType(typeArguments[0]) : getStringMappingType(symbol, typeArguments[0]);
            }
            const links = getSymbolLinks(symbol);
            const typeParameters = links.typeParameters;
            const id = getTypeListId(typeArguments) + getAliasId(aliasSymbol, aliasTypeArguments);
            let instantiation = links.instantiations.get(id);
            if (!instantiation) links.instantiations.set(id, instantiation = instantiateTypeWithAlias(type, createTypeMapper(typeParameters, fillMissingTypeArguments(typeArguments, typeParameters, getMinTypeArgumentCount(typeParameters), isInJSFile(symbol.valueDeclaration))), aliasSymbol, aliasTypeArguments));
            return instantiation;
        }
        function getTypeFromTypeAliasReference(node, symbol) {
            if (getCheckFlags(symbol) & 1048576 /* Unresolved */ ) {
                const typeArguments = typeArgumentsFromTypeReferenceNode(node);
                const id = getAliasId(symbol, typeArguments);
                let errorType2 = errorTypes.get(id);
                if (!errorType2) {
                    errorType2 = createIntrinsicType(1 /* Any */ , "error", /*objectFlags*/ void 0, `alias ${id}`);
                    errorType2.aliasSymbol = symbol;
                    errorType2.aliasTypeArguments = typeArguments;
                    errorTypes.set(id, errorType2);
                }
                return errorType2;
            }
            const type = getDeclaredTypeOfSymbol(symbol);
            const typeParameters = getSymbolLinks(symbol).typeParameters;
            if (typeParameters) {
                const numTypeArguments = length(node.typeArguments);
                const minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
                if (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length) {
                    error2(node, minTypeArgumentCount === typeParameters.length ? Diagnostics.Generic_type_0_requires_1_type_argument_s : Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments, symbolToString(symbol), minTypeArgumentCount, typeParameters.length);
                    return errorType;
                }
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                let newAliasSymbol = aliasSymbol && (isLocalTypeAlias(symbol) || !isLocalTypeAlias(aliasSymbol)) ? aliasSymbol : void 0;
                let aliasTypeArguments;
                if (newAliasSymbol) aliasTypeArguments = getTypeArgumentsForAliasSymbol(newAliasSymbol);
                else if (isTypeReferenceType(node)) {
                    const aliasSymbol2 = resolveTypeReferenceName(node, 2097152 /* Alias */ , /*ignoreErrors*/ true);
                    if (aliasSymbol2 && aliasSymbol2 !== unknownSymbol) {
                        const resolved = resolveAlias(aliasSymbol2);
                        if (resolved && resolved.flags & 524288 /* TypeAlias */ ) {
                            newAliasSymbol = resolved;
                            aliasTypeArguments = typeArgumentsFromTypeReferenceNode(node) || (typeParameters ? [] : void 0);
                        }
                    }
                }
                return getTypeAliasInstantiation(symbol, typeArgumentsFromTypeReferenceNode(node), newAliasSymbol, aliasTypeArguments);
            }
            return checkNoTypeArguments(node, symbol) ? type : errorType;
        }
        function isLocalTypeAlias(symbol) {
            var _a;
            const declaration = (_a = symbol.declarations) == null ? void 0 : _a.find(isTypeAlias);
            return !!(declaration && getContainingFunction(declaration));
        }
        function getTypeReferenceName(node) {
            switch(node.kind){
                case 184 /* TypeReference */ :
                    return node.typeName;
                case 234 /* ExpressionWithTypeArguments */ :
                    const expr = node.expression;
                    if (isEntityNameExpression(expr)) return expr;
            }
            return void 0;
        }
        function getSymbolPath(symbol) {
            return symbol.parent ? `${getSymbolPath(symbol.parent)}.${symbol.escapedName}` : symbol.escapedName;
        }
        function getUnresolvedSymbolForEntityName(name) {
            const identifier = name.kind === 167 /* QualifiedName */  ? name.right : name.kind === 212 /* PropertyAccessExpression */  ? name.name : name;
            const text = identifier.escapedText;
            if (text) {
                const parentSymbol = name.kind === 167 /* QualifiedName */  ? getUnresolvedSymbolForEntityName(name.left) : name.kind === 212 /* PropertyAccessExpression */  ? getUnresolvedSymbolForEntityName(name.expression) : void 0;
                const path = parentSymbol ? `${getSymbolPath(parentSymbol)}.${text}` : text;
                let result = unresolvedSymbols.get(path);
                if (!result) {
                    unresolvedSymbols.set(path, result = createSymbol(524288 /* TypeAlias */ , text, 1048576 /* Unresolved */ ));
                    result.parent = parentSymbol;
                    result.links.declaredType = unresolvedType;
                }
                return result;
            }
            return unknownSymbol;
        }
        function resolveTypeReferenceName(typeReference, meaning, ignoreErrors) {
            const name = getTypeReferenceName(typeReference);
            if (!name) return unknownSymbol;
            const symbol = resolveEntityName(name, meaning, ignoreErrors);
            return symbol && symbol !== unknownSymbol ? symbol : ignoreErrors ? unknownSymbol : getUnresolvedSymbolForEntityName(name);
        }
        function getTypeReferenceType(node, symbol) {
            if (symbol === unknownSymbol) return errorType;
            symbol = getExpandoSymbol(symbol) || symbol;
            if (symbol.flags & 96 /* Interface */ ) return getTypeFromClassOrInterfaceReference(node, symbol);
            if (symbol.flags & 524288 /* TypeAlias */ ) return getTypeFromTypeAliasReference(node, symbol);
            const res = tryGetDeclaredTypeOfSymbol(symbol);
            if (res) return checkNoTypeArguments(node, symbol) ? getRegularTypeOfLiteralType(res) : errorType;
            if (symbol.flags & 111551 /* Value */  && isJSDocTypeReference(node)) {
                const jsdocType = getTypeFromJSDocValueReference(node, symbol);
                if (jsdocType) return jsdocType;
                else {
                    resolveTypeReferenceName(node, 788968 /* Type */ );
                    return getTypeOfSymbol(symbol);
                }
            }
            return errorType;
        }
        function getTypeFromJSDocValueReference(node, symbol) {
            const links = getNodeLinks(node);
            if (!links.resolvedJSDocType) {
                const valueType = getTypeOfSymbol(symbol);
                let typeType = valueType;
                if (symbol.valueDeclaration) {
                    const isImportTypeWithQualifier = node.kind === 206 /* ImportType */  && node.qualifier;
                    if (valueType.symbol && valueType.symbol !== symbol && isImportTypeWithQualifier) typeType = getTypeReferenceType(node, valueType.symbol);
                }
                links.resolvedJSDocType = typeType;
            }
            return links.resolvedJSDocType;
        }
        function getNoInferType(type) {
            return isNoInferTargetType(type) ? getOrCreateSubstitutionType(type, unknownType) : type;
        }
        function isNoInferTargetType(type) {
            return !!(type.flags & 3145728 /* UnionOrIntersection */  && some(type.types, isNoInferTargetType) || type.flags & 33554432 /* Substitution */  && !isNoInferType(type) && isNoInferTargetType(type.baseType) || type.flags & 524288 /* Object */  && !isEmptyAnonymousObjectType(type) || type.flags & 432275456 /* Substitution */  && !isPatternLiteralType(type));
        }
        function isNoInferType(type) {
            return !!(type.flags & 33554432 /* Substitution */  && type.constraint.flags & 2 /* Unknown */ );
        }
        function getSubstitutionType(baseType, constraint) {
            return constraint.flags & 3 /* AnyOrUnknown */  || constraint === baseType || baseType.flags & 1 /* Any */  ? baseType : getOrCreateSubstitutionType(baseType, constraint);
        }
        function getOrCreateSubstitutionType(baseType, constraint) {
            const id = `${getTypeId(baseType)}>${getTypeId(constraint)}`;
            const cached = substitutionTypes.get(id);
            if (cached) return cached;
            const result = createType(33554432 /* Substitution */ );
            result.baseType = baseType;
            result.constraint = constraint;
            substitutionTypes.set(id, result);
            return result;
        }
        function getSubstitutionIntersection(substitutionType) {
            return isNoInferType(substitutionType) ? substitutionType.baseType : getIntersectionType([
                substitutionType.constraint,
                substitutionType.baseType
            ]);
        }
        function isUnaryTupleTypeNode(node) {
            return node.kind === 190 /* TupleType */  && node.elements.length === 1;
        }
        function getImpliedConstraint(type, checkNode, extendsNode) {
            return isUnaryTupleTypeNode(checkNode) && isUnaryTupleTypeNode(extendsNode) ? getImpliedConstraint(type, checkNode.elements[0], extendsNode.elements[0]) : getActualTypeVariable(getTypeFromTypeNode(checkNode)) === getActualTypeVariable(type) ? getTypeFromTypeNode(extendsNode) : void 0;
        }
        function getConditionalFlowTypeOfType(type, node) {
            let constraints;
            let covariant = true;
            while(node && !isStatement(node) && node.kind !== 321 /* JSDoc */ ){
                const parent2 = node.parent;
                if (parent2.kind === 170 /* Parameter */ ) covariant = !covariant;
                if ((covariant || type.flags & 8650752 /* TypeVariable */ ) && parent2.kind === 195 /* ConditionalType */  && node === parent2.trueType) {
                    const constraint = getImpliedConstraint(type, parent2.checkType, parent2.extendsType);
                    if (constraint) constraints = append(constraints, constraint);
                } else if (type.flags & 262144 /* TypeParameter */  && parent2.kind === 201 /* MappedType */  && !parent2.nameType && node === parent2.type) {
                    const mappedType = getTypeFromTypeNode(parent2);
                    if (getTypeParameterFromMappedType(mappedType) === getActualTypeVariable(type)) {
                        const typeParameter = getHomomorphicTypeVariable(mappedType);
                        if (typeParameter) {
                            const constraint = getConstraintOfTypeParameter(typeParameter);
                            if (constraint && everyType(constraint, isArrayOrTupleType)) constraints = append(constraints, getUnionType([
                                numberType,
                                numericStringType
                            ]));
                        }
                    }
                }
                node = parent2;
            }
            return constraints ? getSubstitutionType(type, getIntersectionType(constraints)) : type;
        }
        function isJSDocTypeReference(node) {
            return !!(node.flags & 16777216 /* JSDoc */ ) && (node.kind === 184 /* TypeReference */  || node.kind === 206 /* ImportType */ );
        }
        function checkNoTypeArguments(node, symbol) {
            if (node.typeArguments) {
                error2(node, Diagnostics.Type_0_is_not_generic, symbol ? symbolToString(symbol) : node.typeName ? declarationNameToString(node.typeName) : anon);
                return false;
            }
            return true;
        }
        function getIntendedTypeFromJSDocTypeReference(node) {
            if (isIdentifier(node.typeName)) {
                const typeArgs = node.typeArguments;
                switch(node.typeName.escapedText){
                    case "String":
                        checkNoTypeArguments(node);
                        return stringType;
                    case "Number":
                        checkNoTypeArguments(node);
                        return numberType;
                    case "BigInt":
                        checkNoTypeArguments(node);
                        return bigintType;
                    case "Boolean":
                        checkNoTypeArguments(node);
                        return booleanType;
                    case "Void":
                        checkNoTypeArguments(node);
                        return voidType;
                    case "Undefined":
                        checkNoTypeArguments(node);
                        return undefinedType;
                    case "Null":
                        checkNoTypeArguments(node);
                        return nullType;
                    case "Function":
                    case "function":
                        checkNoTypeArguments(node);
                        return globalFunctionType;
                    case "array":
                        return (!typeArgs || !typeArgs.length) && !noImplicitAny ? anyArrayType : void 0;
                    case "promise":
                        return (!typeArgs || !typeArgs.length) && !noImplicitAny ? createPromiseType(anyType) : void 0;
                    case "Object":
                        if (typeArgs && typeArgs.length === 2) {
                            if (isJSDocIndexSignature(node)) {
                                const indexed = getTypeFromTypeNode(typeArgs[0]);
                                const target = getTypeFromTypeNode(typeArgs[1]);
                                const indexInfo = indexed === stringType || indexed === numberType ? [
                                    createIndexInfo(indexed, target, /*isReadonly*/ false)
                                ] : emptyArray;
                                return createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, indexInfo);
                            }
                            return anyType;
                        }
                        checkNoTypeArguments(node);
                        return !noImplicitAny ? anyType : void 0;
                }
            }
        }
        function getTypeFromJSDocNullableTypeNode(node) {
            const type = getTypeFromTypeNode(node.type);
            return strictNullChecks ? getNullableType(type, 65536 /* Null */ ) : type;
        }
        function getTypeFromTypeReference(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                if (isConstTypeReference(node) && isAssertionExpression(node.parent)) {
                    links.resolvedSymbol = unknownSymbol;
                    return links.resolvedType = checkExpressionCached(node.parent.expression);
                }
                let symbol;
                let type;
                const meaning = 788968 /* Type */ ;
                if (isJSDocTypeReference(node)) {
                    type = getIntendedTypeFromJSDocTypeReference(node);
                    if (!type) {
                        symbol = resolveTypeReferenceName(node, meaning, /*ignoreErrors*/ true);
                        if (symbol === unknownSymbol) symbol = resolveTypeReferenceName(node, meaning | 111551 /* Value */ );
                        else resolveTypeReferenceName(node, meaning);
                        type = getTypeReferenceType(node, symbol);
                    }
                }
                if (!type) {
                    symbol = resolveTypeReferenceName(node, meaning);
                    type = getTypeReferenceType(node, symbol);
                }
                links.resolvedSymbol = symbol;
                links.resolvedType = type;
            }
            return links.resolvedType;
        }
        function typeArgumentsFromTypeReferenceNode(node) {
            return map(node.typeArguments, getTypeFromTypeNode);
        }
        function getTypeFromTypeQueryNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const type = checkExpressionWithTypeArguments(node);
                links.resolvedType = getRegularTypeOfLiteralType(getWidenedType(type));
            }
            return links.resolvedType;
        }
        function getTypeOfGlobalSymbol(symbol, arity) {
            function getTypeDeclaration(symbol2) {
                const declarations = symbol2.declarations;
                if (declarations) for (const declaration of declarations)switch(declaration.kind){
                    case 264 /* ClassDeclaration */ :
                    case 265 /* InterfaceDeclaration */ :
                    case 267 /* EnumDeclaration */ :
                        return declaration;
                }
            }
            if (!symbol) return arity ? emptyGenericType : emptyObjectType;
            const type = getDeclaredTypeOfSymbol(symbol);
            if (!(type.flags & 524288 /* Object */ )) {
                error2(getTypeDeclaration(symbol), Diagnostics.Global_type_0_must_be_a_class_or_interface_type, symbolName(symbol));
                return arity ? emptyGenericType : emptyObjectType;
            }
            if (length(type.typeParameters) !== arity) {
                error2(getTypeDeclaration(symbol), Diagnostics.Global_type_0_must_have_1_type_parameter_s, symbolName(symbol), arity);
                return arity ? emptyGenericType : emptyObjectType;
            }
            return type;
        }
        function getGlobalValueSymbol(name, reportErrors2) {
            return getGlobalSymbol(name, 111551 /* Value */ , reportErrors2 ? Diagnostics.Cannot_find_global_value_0 : void 0);
        }
        function getGlobalTypeSymbol(name, reportErrors2) {
            return getGlobalSymbol(name, 788968 /* Type */ , reportErrors2 ? Diagnostics.Cannot_find_global_type_0 : void 0);
        }
        function getGlobalTypeAliasSymbol(name, arity, reportErrors2) {
            const symbol = getGlobalSymbol(name, 788968 /* Type */ , reportErrors2 ? Diagnostics.Cannot_find_global_type_0 : void 0);
            if (symbol) {
                getDeclaredTypeOfSymbol(symbol);
                if (length(getSymbolLinks(symbol).typeParameters) !== arity) {
                    const decl = symbol.declarations && find(symbol.declarations, isTypeAliasDeclaration);
                    error2(decl, Diagnostics.Global_type_0_must_have_1_type_parameter_s, symbolName(symbol), arity);
                    return void 0;
                }
            }
            return symbol;
        }
        function getGlobalSymbol(name, meaning, diagnostic) {
            return resolveName(/*location*/ void 0, name, meaning, diagnostic, /*isUse*/ false, /*excludeGlobals*/ false);
        }
        function getGlobalType(name, arity, reportErrors2) {
            const symbol = getGlobalTypeSymbol(name, reportErrors2);
            return symbol || reportErrors2 ? getTypeOfGlobalSymbol(symbol, arity) : void 0;
        }
        function getGlobalBuiltinTypes(typeNames, arity) {
            let types;
            for (const typeName of typeNames)types = append(types, getGlobalType(typeName, arity, /*reportErrors*/ false));
            return types !== null && types !== void 0 ? types : emptyArray;
        }
        function getGlobalTypedPropertyDescriptorType() {
            return deferredGlobalTypedPropertyDescriptorType || (deferredGlobalTypedPropertyDescriptorType = getGlobalType("TypedPropertyDescriptor", /*arity*/ 1, /*reportErrors*/ true) || emptyGenericType);
        }
        function getGlobalTemplateStringsArrayType() {
            return deferredGlobalTemplateStringsArrayType || (deferredGlobalTemplateStringsArrayType = getGlobalType("TemplateStringsArray", /*arity*/ 0, /*reportErrors*/ true) || emptyObjectType);
        }
        function getGlobalImportMetaType() {
            return deferredGlobalImportMetaType || (deferredGlobalImportMetaType = getGlobalType("ImportMeta", /*arity*/ 0, /*reportErrors*/ true) || emptyObjectType);
        }
        function getGlobalImportMetaExpressionType() {
            if (!deferredGlobalImportMetaExpressionType) {
                const symbol = createSymbol(0 /* None */ , "ImportMetaExpression");
                const importMetaType = getGlobalImportMetaType();
                const metaPropertySymbol = createSymbol(4 /* Property */ , "meta", 8 /* Readonly */ );
                metaPropertySymbol.parent = symbol;
                metaPropertySymbol.links.type = importMetaType;
                const members = createSymbolTable([
                    metaPropertySymbol
                ]);
                symbol.members = members;
                deferredGlobalImportMetaExpressionType = createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
            }
            return deferredGlobalImportMetaExpressionType;
        }
        function getGlobalImportCallOptionsType(reportErrors2) {
            return deferredGlobalImportCallOptionsType || (deferredGlobalImportCallOptionsType = getGlobalType("ImportCallOptions", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalImportAttributesType(reportErrors2) {
            return deferredGlobalImportAttributesType || (deferredGlobalImportAttributesType = getGlobalType("ImportAttributes", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalESSymbolConstructorSymbol(reportErrors2) {
            return deferredGlobalESSymbolConstructorSymbol || (deferredGlobalESSymbolConstructorSymbol = getGlobalValueSymbol("Symbol", reportErrors2));
        }
        function getGlobalESSymbolConstructorTypeSymbol(reportErrors2) {
            return deferredGlobalESSymbolConstructorTypeSymbol || (deferredGlobalESSymbolConstructorTypeSymbol = getGlobalTypeSymbol("SymbolConstructor", reportErrors2));
        }
        function getGlobalESSymbolType() {
            return deferredGlobalESSymbolType || (deferredGlobalESSymbolType = getGlobalType("Symbol", /*arity*/ 0, /*reportErrors*/ false)) || emptyObjectType;
        }
        function getGlobalPromiseType(reportErrors2) {
            return deferredGlobalPromiseType || (deferredGlobalPromiseType = getGlobalType("Promise", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalPromiseLikeType(reportErrors2) {
            return deferredGlobalPromiseLikeType || (deferredGlobalPromiseLikeType = getGlobalType("PromiseLike", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalPromiseConstructorSymbol(reportErrors2) {
            return deferredGlobalPromiseConstructorSymbol || (deferredGlobalPromiseConstructorSymbol = getGlobalValueSymbol("Promise", reportErrors2));
        }
        function getGlobalPromiseConstructorLikeType(reportErrors2) {
            return deferredGlobalPromiseConstructorLikeType || (deferredGlobalPromiseConstructorLikeType = getGlobalType("PromiseConstructorLike", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalAsyncIterableType(reportErrors2) {
            return deferredGlobalAsyncIterableType || (deferredGlobalAsyncIterableType = getGlobalType("AsyncIterable", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalAsyncIteratorType(reportErrors2) {
            return deferredGlobalAsyncIteratorType || (deferredGlobalAsyncIteratorType = getGlobalType("AsyncIterator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalAsyncIterableIteratorType(reportErrors2) {
            return deferredGlobalAsyncIterableIteratorType || (deferredGlobalAsyncIterableIteratorType = getGlobalType("AsyncIterableIterator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalBuiltinAsyncIteratorTypes() {
            return deferredGlobalBuiltinAsyncIteratorTypes !== null && deferredGlobalBuiltinAsyncIteratorTypes !== void 0 ? deferredGlobalBuiltinAsyncIteratorTypes : deferredGlobalBuiltinAsyncIteratorTypes = getGlobalBuiltinTypes([
                "ReadableStreamAsyncIterator"
            ], 1);
        }
        function getGlobalAsyncIteratorObjectType(reportErrors2) {
            return deferredGlobalAsyncIteratorObjectType || (deferredGlobalAsyncIteratorObjectType = getGlobalType("AsyncIteratorObject", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalAsyncGeneratorType(reportErrors2) {
            return deferredGlobalAsyncGeneratorType || (deferredGlobalAsyncGeneratorType = getGlobalType("AsyncGenerator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIterableType(reportErrors2) {
            return deferredGlobalIterableType || (deferredGlobalIterableType = getGlobalType("Iterable", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIteratorType(reportErrors2) {
            return deferredGlobalIteratorType || (deferredGlobalIteratorType = getGlobalType("Iterator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIterableIteratorType(reportErrors2) {
            return deferredGlobalIterableIteratorType || (deferredGlobalIterableIteratorType = getGlobalType("IterableIterator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getBuiltinIteratorReturnType() {
            return strictBuiltinIteratorReturn ? undefinedType : anyType;
        }
        function getGlobalBuiltinIteratorTypes() {
            return deferredGlobalBuiltinIteratorTypes !== null && deferredGlobalBuiltinIteratorTypes !== void 0 ? deferredGlobalBuiltinIteratorTypes : deferredGlobalBuiltinIteratorTypes = getGlobalBuiltinTypes([
                "ArrayIterator",
                "MapIterator",
                "SetIterator",
                "StringIterator"
            ], 1);
        }
        function getGlobalIteratorObjectType(reportErrors2) {
            return deferredGlobalIteratorObjectType || (deferredGlobalIteratorObjectType = getGlobalType("IteratorObject", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalGeneratorType(reportErrors2) {
            return deferredGlobalGeneratorType || (deferredGlobalGeneratorType = getGlobalType("Generator", /*arity*/ 3, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIteratorYieldResultType(reportErrors2) {
            return deferredGlobalIteratorYieldResultType || (deferredGlobalIteratorYieldResultType = getGlobalType("IteratorYieldResult", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalIteratorReturnResultType(reportErrors2) {
            return deferredGlobalIteratorReturnResultType || (deferredGlobalIteratorReturnResultType = getGlobalType("IteratorReturnResult", /*arity*/ 1, reportErrors2)) || emptyGenericType;
        }
        function getGlobalDisposableType(reportErrors2) {
            return deferredGlobalDisposableType || (deferredGlobalDisposableType = getGlobalType("Disposable", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalAsyncDisposableType(reportErrors2) {
            return deferredGlobalAsyncDisposableType || (deferredGlobalAsyncDisposableType = getGlobalType("AsyncDisposable", /*arity*/ 0, reportErrors2)) || emptyObjectType;
        }
        function getGlobalTypeOrUndefined(name, arity = 0) {
            const symbol = getGlobalSymbol(name, 788968 /* Type */ , /*diagnostic*/ void 0);
            return symbol && getTypeOfGlobalSymbol(symbol, arity);
        }
        function getGlobalExtractSymbol() {
            deferredGlobalExtractSymbol || (deferredGlobalExtractSymbol = getGlobalTypeAliasSymbol("Extract", /*arity*/ 2, /*reportErrors*/ true) || unknownSymbol);
            return deferredGlobalExtractSymbol === unknownSymbol ? void 0 : deferredGlobalExtractSymbol;
        }
        function getGlobalOmitSymbol() {
            deferredGlobalOmitSymbol || (deferredGlobalOmitSymbol = getGlobalTypeAliasSymbol("Omit", /*arity*/ 2, /*reportErrors*/ true) || unknownSymbol);
            return deferredGlobalOmitSymbol === unknownSymbol ? void 0 : deferredGlobalOmitSymbol;
        }
        function getGlobalAwaitedSymbol(reportErrors2) {
            deferredGlobalAwaitedSymbol || (deferredGlobalAwaitedSymbol = getGlobalTypeAliasSymbol("Awaited", /*arity*/ 1, reportErrors2) || (reportErrors2 ? unknownSymbol : void 0));
            return deferredGlobalAwaitedSymbol === unknownSymbol ? void 0 : deferredGlobalAwaitedSymbol;
        }
        function getGlobalBigIntType() {
            return deferredGlobalBigIntType || (deferredGlobalBigIntType = getGlobalType("BigInt", /*arity*/ 0, /*reportErrors*/ false)) || emptyObjectType;
        }
        function getGlobalClassDecoratorContextType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassDecoratorContextType !== null && deferredGlobalClassDecoratorContextType !== void 0 ? deferredGlobalClassDecoratorContextType : deferredGlobalClassDecoratorContextType = getGlobalType("ClassDecoratorContext", /*arity*/ 1, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassMethodDecoratorContextType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassMethodDecoratorContextType !== null && deferredGlobalClassMethodDecoratorContextType !== void 0 ? deferredGlobalClassMethodDecoratorContextType : deferredGlobalClassMethodDecoratorContextType = getGlobalType("ClassMethodDecoratorContext", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassGetterDecoratorContextType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassGetterDecoratorContextType !== null && deferredGlobalClassGetterDecoratorContextType !== void 0 ? deferredGlobalClassGetterDecoratorContextType : deferredGlobalClassGetterDecoratorContextType = getGlobalType("ClassGetterDecoratorContext", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassSetterDecoratorContextType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassSetterDecoratorContextType !== null && deferredGlobalClassSetterDecoratorContextType !== void 0 ? deferredGlobalClassSetterDecoratorContextType : deferredGlobalClassSetterDecoratorContextType = getGlobalType("ClassSetterDecoratorContext", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassAccessorDecoratorContextType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassAccessorDecoratorContextType !== null && deferredGlobalClassAccessorDecoratorContextType !== void 0 ? deferredGlobalClassAccessorDecoratorContextType : deferredGlobalClassAccessorDecoratorContextType = getGlobalType("ClassAccessorDecoratorContext", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassAccessorDecoratorTargetType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassAccessorDecoratorTargetType !== null && deferredGlobalClassAccessorDecoratorTargetType !== void 0 ? deferredGlobalClassAccessorDecoratorTargetType : deferredGlobalClassAccessorDecoratorTargetType = getGlobalType("ClassAccessorDecoratorTarget", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassAccessorDecoratorResultType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassAccessorDecoratorResultType !== null && deferredGlobalClassAccessorDecoratorResultType !== void 0 ? deferredGlobalClassAccessorDecoratorResultType : deferredGlobalClassAccessorDecoratorResultType = getGlobalType("ClassAccessorDecoratorResult", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalClassFieldDecoratorContextType(reportErrors2) {
            var _ref;
            return (_ref = deferredGlobalClassFieldDecoratorContextType !== null && deferredGlobalClassFieldDecoratorContextType !== void 0 ? deferredGlobalClassFieldDecoratorContextType : deferredGlobalClassFieldDecoratorContextType = getGlobalType("ClassFieldDecoratorContext", /*arity*/ 2, reportErrors2)) !== null && _ref !== void 0 ? _ref : emptyGenericType;
        }
        function getGlobalNaNSymbol() {
            return deferredGlobalNaNSymbol || (deferredGlobalNaNSymbol = getGlobalValueSymbol("NaN", /*reportErrors*/ false));
        }
        function getGlobalRecordSymbol() {
            deferredGlobalRecordSymbol || (deferredGlobalRecordSymbol = getGlobalTypeAliasSymbol("Record", /*arity*/ 2, /*reportErrors*/ true) || unknownSymbol);
            return deferredGlobalRecordSymbol === unknownSymbol ? void 0 : deferredGlobalRecordSymbol;
        }
        function createTypeFromGenericGlobalType(genericGlobalType, typeArguments) {
            return genericGlobalType !== emptyGenericType ? createTypeReference(genericGlobalType, typeArguments) : emptyObjectType;
        }
        function createTypedPropertyDescriptorType(propertyType) {
            return createTypeFromGenericGlobalType(getGlobalTypedPropertyDescriptorType(), [
                propertyType
            ]);
        }
        function createIterableType(iteratedType) {
            return createTypeFromGenericGlobalType(getGlobalIterableType(/*reportErrors*/ true), [
                iteratedType,
                voidType,
                undefinedType
            ]);
        }
        function createArrayType(elementType, readonly) {
            return createTypeFromGenericGlobalType(readonly ? globalReadonlyArrayType : globalArrayType, [
                elementType
            ]);
        }
        function getTupleElementFlags(node) {
            switch(node.kind){
                case 191 /* OptionalType */ :
                    return 2 /* Optional */ ;
                case 192 /* RestType */ :
                    return getRestTypeElementFlags(node);
                case 203 /* NamedTupleMember */ :
                    return node.questionToken ? 2 /* Optional */  : node.dotDotDotToken ? getRestTypeElementFlags(node) : 1 /* Required */ ;
                default:
                    return 1 /* Required */ ;
            }
        }
        function getRestTypeElementFlags(node) {
            return getArrayElementTypeNode(node.type) ? 4 /* Rest */  : 8 /* Variadic */ ;
        }
        function getArrayOrTupleTargetType(node) {
            const readonly = isReadonlyTypeOperator(node.parent);
            const elementType = getArrayElementTypeNode(node);
            if (elementType) return readonly ? globalReadonlyArrayType : globalArrayType;
            const elementFlags = map(node.elements, getTupleElementFlags);
            return getTupleTargetType(elementFlags, readonly, map(node.elements, memberIfLabeledElementDeclaration));
        }
        function memberIfLabeledElementDeclaration(member) {
            return isNamedTupleMember(member) || isParameter(member) ? member : void 0;
        }
        function isDeferredTypeReferenceNode(node, hasDefaultTypeArguments) {
            return !!getAliasSymbolForTypeNode(node) || isResolvedByTypeAlias(node) && (node.kind === 189 /* ArrayType */  ? mayResolveTypeAlias(node.elementType) : node.kind === 190 /* TupleType */  ? some(node.elements, mayResolveTypeAlias) : hasDefaultTypeArguments || some(node.typeArguments, mayResolveTypeAlias));
        }
        function isResolvedByTypeAlias(node) {
            const parent2 = node.parent;
            switch(parent2.kind){
                case 197 /* ParenthesizedType */ :
                case 203 /* NamedTupleMember */ :
                case 184 /* TypeReference */ :
                case 193 /* UnionType */ :
                case 194 /* IntersectionType */ :
                case 200 /* IndexedAccessType */ :
                case 195 /* ConditionalType */ :
                case 199 /* TypeOperator */ :
                case 189 /* ArrayType */ :
                case 190 /* TupleType */ :
                    return isResolvedByTypeAlias(parent2);
                case 266 /* TypeAliasDeclaration */ :
                    return true;
            }
            return false;
        }
        function mayResolveTypeAlias(node) {
            switch(node.kind){
                case 184 /* TypeReference */ :
                    return isJSDocTypeReference(node) || !!(resolveTypeReferenceName(node, 788968 /* Type */ ).flags & 524288 /* TypeAlias */ );
                case 187 /* TypeQuery */ :
                    return true;
                case 199 /* TypeOperator */ :
                    return node.operator !== 158 /* UniqueKeyword */  && mayResolveTypeAlias(node.type);
                case 197 /* ParenthesizedType */ :
                case 191 /* OptionalType */ :
                case 203 /* NamedTupleMember */ :
                case 317 /* JSDocOptionalType */ :
                case 315 /* JSDocNullableType */ :
                case 316 /* JSDocNonNullableType */ :
                case 310 /* JSDocTypeExpression */ :
                    return mayResolveTypeAlias(node.type);
                case 192 /* RestType */ :
                    return node.type.kind !== 189 /* ArrayType */  || mayResolveTypeAlias(node.type.elementType);
                case 193 /* UnionType */ :
                case 194 /* IntersectionType */ :
                    return some(node.types, mayResolveTypeAlias);
                case 200 /* IndexedAccessType */ :
                    return mayResolveTypeAlias(node.objectType) || mayResolveTypeAlias(node.indexType);
                case 195 /* ConditionalType */ :
                    return mayResolveTypeAlias(node.checkType) || mayResolveTypeAlias(node.extendsType) || mayResolveTypeAlias(node.trueType) || mayResolveTypeAlias(node.falseType);
            }
            return false;
        }
        function getTypeFromArrayOrTupleTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const target = getArrayOrTupleTargetType(node);
                if (target === emptyGenericType) links.resolvedType = emptyObjectType;
                else if (!(node.kind === 190 /* TupleType */  && some(node.elements, (e)=>!!(getTupleElementFlags(e) & 8 /* Variadic */ ))) && isDeferredTypeReferenceNode(node)) links.resolvedType = node.kind === 190 /* TupleType */  && node.elements.length === 0 ? target : createDeferredTypeReference(target, node, /*mapper*/ void 0);
                else {
                    const elementTypes = node.kind === 189 /* ArrayType */  ? [
                        getTypeFromTypeNode(node.elementType)
                    ] : map(node.elements, getTypeFromTypeNode);
                    links.resolvedType = createNormalizedTypeReference(target, elementTypes);
                }
            }
            return links.resolvedType;
        }
        function isReadonlyTypeOperator(node) {
            return isTypeOperatorNode(node) && node.operator === 148 /* ReadonlyKeyword */ ;
        }
        function createTupleType(elementTypes, elementFlags, readonly = false, namedMemberDeclarations = []) {
            const tupleTarget = getTupleTargetType(elementFlags || map(elementTypes, (_)=>1 /* Required */ ), readonly, namedMemberDeclarations);
            return tupleTarget === emptyGenericType ? emptyObjectType : elementTypes.length ? createNormalizedTypeReference(tupleTarget, elementTypes) : tupleTarget;
        }
        function getTupleTargetType(elementFlags, readonly, namedMemberDeclarations) {
            if (elementFlags.length === 1 && elementFlags[0] & 4 /* Rest */ ) return readonly ? globalReadonlyArrayType : globalArrayType;
            const key = map(elementFlags, (f)=>f & 1 /* Required */  ? "#" : f & 2 /* Optional */  ? "?" : f & 4 /* Rest */  ? "." : "*").join() + (readonly ? "R" : "") + (some(namedMemberDeclarations, (node)=>!!node) ? "," + map(namedMemberDeclarations, (node)=>node ? getNodeId(node) : "_").join(",") : "");
            let type = tupleTypes.get(key);
            if (!type) tupleTypes.set(key, type = createTupleTargetType(elementFlags, readonly, namedMemberDeclarations));
            return type;
        }
        function createTupleTargetType(elementFlags, readonly, namedMemberDeclarations) {
            const arity = elementFlags.length;
            const minLength = countWhere(elementFlags, (f)=>!!(f & 9 /* Variadic */ ));
            let typeParameters;
            const properties = [];
            let combinedFlags = 0;
            if (arity) {
                typeParameters = new Array(arity);
                for(let i = 0; i < arity; i++){
                    const typeParameter = typeParameters[i] = createTypeParameter();
                    const flags = elementFlags[i];
                    combinedFlags |= flags;
                    if (!(combinedFlags & 12 /* Variable */ )) {
                        const property = createSymbol(4 /* Property */  | (flags & 2 /* Optional */  ? 16777216 /* Optional */  : 0), "" + i, readonly ? 8 /* Readonly */  : 0);
                        property.links.tupleLabelDeclaration = namedMemberDeclarations == null ? void 0 : namedMemberDeclarations[i];
                        property.links.type = typeParameter;
                        properties.push(property);
                    }
                }
            }
            const fixedLength = properties.length;
            const lengthSymbol = createSymbol(4 /* Property */ , "length", readonly ? 8 /* Readonly */  : 0);
            if (combinedFlags & 12 /* Variable */ ) lengthSymbol.links.type = numberType;
            else {
                const literalTypes = [];
                for(let i = minLength; i <= arity; i++)literalTypes.push(getNumberLiteralType(i));
                lengthSymbol.links.type = getUnionType(literalTypes);
            }
            properties.push(lengthSymbol);
            const type = createObjectType(12 /* Reference */ );
            type.typeParameters = typeParameters;
            type.outerTypeParameters = void 0;
            type.localTypeParameters = typeParameters;
            type.instantiations = /* @__PURE__ */ new Map();
            type.instantiations.set(getTypeListId(type.typeParameters), type);
            type.target = type;
            type.resolvedTypeArguments = type.typeParameters;
            type.thisType = createTypeParameter();
            type.thisType.isThisType = true;
            type.thisType.constraint = type;
            type.declaredProperties = properties;
            type.declaredCallSignatures = emptyArray;
            type.declaredConstructSignatures = emptyArray;
            type.declaredIndexInfos = emptyArray;
            type.elementFlags = elementFlags;
            type.minLength = minLength;
            type.fixedLength = fixedLength;
            type.hasRestElement = !!(combinedFlags & 12 /* Variable */ );
            type.combinedFlags = combinedFlags;
            type.readonly = readonly;
            type.labeledElementDeclarations = namedMemberDeclarations;
            return type;
        }
        function createNormalizedTypeReference(target, typeArguments) {
            return target.objectFlags & 8 /* Tuple */  ? createNormalizedTupleType(target, typeArguments) : createTypeReference(target, typeArguments);
        }
        function createNormalizedTupleType(target, elementTypes) {
            var _a, _b, _c, _d;
            if (!(target.combinedFlags & 14 /* NonRequired */ )) return createTypeReference(target, elementTypes);
            if (target.combinedFlags & 8 /* Variadic */ ) {
                const unionIndex = findIndex(elementTypes, (t, i)=>!!(target.elementFlags[i] & 8 /* Variadic */  && t.flags & 1179648 /* Union */ ));
                if (unionIndex >= 0) return checkCrossProductUnion(map(elementTypes, (t, i)=>target.elementFlags[i] & 8 /* Variadic */  ? t : unknownType)) ? mapType(elementTypes[unionIndex], (t)=>createNormalizedTupleType(target, replaceElement(elementTypes, unionIndex, t))) : errorType;
            }
            const expandedTypes = [];
            const expandedFlags = [];
            const expandedDeclarations = [];
            let lastRequiredIndex = -1;
            let firstRestIndex = -1;
            let lastOptionalOrRestIndex = -1;
            for(let i = 0; i < elementTypes.length; i++){
                const type = elementTypes[i];
                const flags = target.elementFlags[i];
                if (flags & 8 /* Variadic */ ) {
                    if (type.flags & 1 /* Any */ ) addElement(type, 4 /* Rest */ , (_a = target.labeledElementDeclarations) == null ? void 0 : _a[i]);
                    else if (type.flags & 58982400 /* InstantiableNonPrimitive */  || isGenericMappedType(type)) addElement(type, 8 /* Variadic */ , (_b = target.labeledElementDeclarations) == null ? void 0 : _b[i]);
                    else if (isTupleType(type)) {
                        const elements = getElementTypes(type);
                        if (elements.length + expandedTypes.length >= 1e4) {
                            error2(currentNode, isPartOfTypeNode(currentNode) ? Diagnostics.Type_produces_a_tuple_type_that_is_too_large_to_represent : Diagnostics.Expression_produces_a_tuple_type_that_is_too_large_to_represent);
                            return errorType;
                        }
                        forEach(elements, (t, n)=>{
                            var _a2;
                            return addElement(t, type.target.elementFlags[n], (_a2 = type.target.labeledElementDeclarations) == null ? void 0 : _a2[n]);
                        });
                    } else addElement(isArrayLikeType(type) && getIndexTypeOfType(type, numberType) || errorType, 4 /* Rest */ , (_c = target.labeledElementDeclarations) == null ? void 0 : _c[i]);
                } else addElement(type, flags, (_d = target.labeledElementDeclarations) == null ? void 0 : _d[i]);
            }
            for(let i = 0; i < lastRequiredIndex; i++)if (expandedFlags[i] & 2 /* Optional */ ) expandedFlags[i] = 1 /* Required */ ;
            if (firstRestIndex >= 0 && firstRestIndex < lastOptionalOrRestIndex) {
                expandedTypes[firstRestIndex] = getUnionType(sameMap(expandedTypes.slice(firstRestIndex, lastOptionalOrRestIndex + 1), (t, i)=>expandedFlags[firstRestIndex + i] & 8 /* Variadic */  ? getIndexedAccessType(t, numberType) : t));
                expandedTypes.splice(firstRestIndex + 1, lastOptionalOrRestIndex - firstRestIndex);
                expandedFlags.splice(firstRestIndex + 1, lastOptionalOrRestIndex - firstRestIndex);
                expandedDeclarations.splice(firstRestIndex + 1, lastOptionalOrRestIndex - firstRestIndex);
            }
            const tupleTarget = getTupleTargetType(expandedFlags, target.readonly, expandedDeclarations);
            return tupleTarget === emptyGenericType ? emptyObjectType : expandedFlags.length ? createTypeReference(tupleTarget, expandedTypes) : tupleTarget;
            function addElement(type, flags, declaration) {
                if (flags & 1 /* Required */ ) lastRequiredIndex = expandedFlags.length;
                if (flags & 4 /* Rest */  && firstRestIndex < 0) firstRestIndex = expandedFlags.length;
                if (flags & 6 /* Rest */ ) lastOptionalOrRestIndex = expandedFlags.length;
                expandedTypes.push(flags & 2 /* Optional */  ? addOptionality(type, /*isProperty*/ true) : type);
                expandedFlags.push(flags);
                expandedDeclarations.push(declaration);
            }
        }
        function sliceTupleType(type, index, endSkipCount = 0) {
            const target = type.target;
            const endIndex = getTypeReferenceArity(type) - endSkipCount;
            return index > target.fixedLength ? getRestArrayTypeOfTupleType(type) || createTupleType(emptyArray) : createTupleType(getTypeArguments(type).slice(index, endIndex), target.elementFlags.slice(index, endIndex), /*readonly*/ false, target.labeledElementDeclarations && target.labeledElementDeclarations.slice(index, endIndex));
        }
        function getKnownKeysOfTupleType(type) {
            return getUnionType(append(arrayOf(type.target.fixedLength, (i)=>getStringLiteralType("" + i)), getIndexType(type.target.readonly ? globalReadonlyArrayType : globalArrayType)));
        }
        function getStartElementCount(type, flags) {
            const index = findIndex(type.elementFlags, (f)=>!(f & flags));
            return index >= 0 ? index : type.elementFlags.length;
        }
        function getEndElementCount(type, flags) {
            return type.elementFlags.length - findLastIndex(type.elementFlags, (f)=>!(f & flags)) - 1;
        }
        function getTotalFixedElementCount(type) {
            return type.fixedLength + getEndElementCount(type, 3 /* Fixed */ );
        }
        function getElementTypes(type) {
            const typeArguments = getTypeArguments(type);
            const arity = getTypeReferenceArity(type);
            return typeArguments.length === arity ? typeArguments : typeArguments.slice(0, arity);
        }
        function getTypeFromOptionalTypeNode(node) {
            return addOptionality(getTypeFromTypeNode(node.type), /*isProperty*/ true);
        }
        function getTypeId(type) {
            return type.id;
        }
        function containsType(types, type) {
            return binarySearch(types, type, getTypeId, compareValues) >= 0;
        }
        function insertType(types, type) {
            const index = binarySearch(types, type, getTypeId, compareValues);
            if (index < 0) {
                types.splice(~index, 0, type);
                return true;
            }
            return false;
        }
        function addTypeToUnion(typeSet, includes, type) {
            const flags = type.flags;
            if (!(flags & 131072 /* Never */ )) {
                includes |= flags & 473694207 /* IncludesMask */ ;
                if (flags & 465829888 /* Instantiable */ ) includes |= 33554432 /* IncludesInstantiable */ ;
                if (flags & 2097152 /* Intersection */  && getObjectFlags(type) & 67108864 /* IsConstrainedTypeVariable */ ) includes |= 536870912 /* IncludesConstrainedTypeVariable */ ;
                if (type === wildcardType) includes |= 8388608 /* IncludesWildcard */ ;
                if (isErrorType(type)) includes |= 1073741824 /* IncludesError */ ;
                if (!strictNullChecks && flags & 98304 /* Nullable */ ) {
                    if (!(getObjectFlags(type) & 65536 /* ContainsWideningType */ )) includes |= 4194304 /* IncludesNonWideningType */ ;
                } else {
                    const len = typeSet.length;
                    const index = len && type.id > typeSet[len - 1].id ? ~len : binarySearch(typeSet, type, getTypeId, compareValues);
                    if (index < 0) typeSet.splice(~index, 0, type);
                }
            }
            return includes;
        }
        function addTypesToUnion(typeSet, includes, types) {
            let lastType;
            for (const type of types)if (type !== lastType) {
                includes = type.flags & 1048576 /* Union */  ? addTypesToUnion(typeSet, includes | (isNamedUnionType(type) ? 1048576 /* Union */  : 0), type.types) : addTypeToUnion(typeSet, includes, type);
                lastType = type;
            }
            return includes;
        }
        function removeSubtypes(types, hasObjectTypes) {
            var _a;
            if (types.length < 2) return types;
            const id = getTypeListId(types);
            const match = subtypeReductionCache.get(id);
            if (match) return match;
            const hasEmptyObject = hasObjectTypes && some(types, (t)=>!!(t.flags & 524288 /* Object */ ) && !isGenericMappedType(t) && isEmptyResolvedType(resolveStructuredTypeMembers(t)));
            const len = types.length;
            let i = len;
            let count = 0;
            while(i > 0){
                i--;
                const source = types[i];
                if (hasEmptyObject || source.flags & 469499904 /* StructuredOrInstantiable */ ) {
                    if (source.flags & 262144 /* TypeParameter */  && getBaseConstraintOrType(source).flags & 1048576 /* Union */ ) {
                        if (isTypeRelatedTo(source, getUnionType(map(types, (t)=>t === source ? neverType : t)), strictSubtypeRelation)) orderedRemoveItemAt(types, i);
                        continue;
                    }
                    const keyProperty = source.flags & 61603840 /* InstantiableNonPrimitive */  ? find(getPropertiesOfType(source), (p)=>isUnitType(getTypeOfSymbol(p))) : void 0;
                    const keyPropertyType = keyProperty && getRegularTypeOfLiteralType(getTypeOfSymbol(keyProperty));
                    for (const target of types)if (source !== target) {
                        if (count === 1e5) {
                            const estimatedCount = count / (len - i) * len;
                            if (estimatedCount > 1e6) {
                                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "removeSubtypes_DepthLimit", {
                                    typeIds: types.map((t)=>t.id)
                                });
                                error2(currentNode, Diagnostics.Expression_produces_a_union_type_that_is_too_complex_to_represent);
                                return void 0;
                            }
                        }
                        count++;
                        if (keyProperty && target.flags & 61603840 /* InstantiableNonPrimitive */ ) {
                            const t = getTypeOfPropertyOfType(target, keyProperty.escapedName);
                            if (t && isUnitType(t) && getRegularTypeOfLiteralType(t) !== keyPropertyType) continue;
                        }
                        if (isTypeRelatedTo(source, target, strictSubtypeRelation) && (!(getObjectFlags(getTargetType(source)) & 1 /* Class */ ) || !(getObjectFlags(getTargetType(target)) & 1 /* Class */ ) || isTypeDerivedFrom(source, target))) {
                            orderedRemoveItemAt(types, i);
                            break;
                        }
                    }
                }
            }
            subtypeReductionCache.set(id, types);
            return types;
        }
        function removeRedundantLiteralTypes(types, includes, reduceVoidUndefined) {
            let i = types.length;
            while(i > 0){
                i--;
                const t = types[i];
                const flags = t.flags;
                const remove = flags & 402653312 /* StringMapping */  && includes & 4 /* String */  || flags & 256 /* NumberLiteral */  && includes & 8 /* Number */  || flags & 2048 /* BigIntLiteral */  && includes & 64 /* BigInt */  || flags & 8192 /* UniqueESSymbol */  && includes & 4096 /* ESSymbol */  || reduceVoidUndefined && flags & 32768 /* Undefined */  && includes & 16384 /* Void */  || isFreshLiteralType(t) && containsType(types, t.regularType);
                if (remove) orderedRemoveItemAt(types, i);
            }
        }
        function removeStringLiteralsMatchedByTemplateLiterals(types) {
            const templates = filter(types, isPatternLiteralType);
            if (templates.length) {
                let i = types.length;
                while(i > 0){
                    i--;
                    const t = types[i];
                    if (t.flags & 128 /* StringLiteral */  && some(templates, (template)=>isTypeMatchedByTemplateLiteralOrStringMapping(t, template))) orderedRemoveItemAt(types, i);
                }
            }
        }
        function isTypeMatchedByTemplateLiteralOrStringMapping(type, template) {
            return template.flags & 134217728 /* TemplateLiteral */  ? isTypeMatchedByTemplateLiteralType(type, template) : isMemberOfStringMapping(type, template);
        }
        function removeConstrainedTypeVariables(types) {
            const typeVariables = [];
            for (const type of types)if (type.flags & 2097152 /* Intersection */  && getObjectFlags(type) & 67108864 /* IsConstrainedTypeVariable */ ) {
                const index = type.types[0].flags & 8650752 /* TypeVariable */  ? 0 : 1;
                pushIfUnique(typeVariables, type.types[index]);
            }
            for (const typeVariable of typeVariables){
                const primitives = [];
                for (const type of types)if (type.flags & 2097152 /* Intersection */  && getObjectFlags(type) & 67108864 /* IsConstrainedTypeVariable */ ) {
                    const index = type.types[0].flags & 8650752 /* TypeVariable */  ? 0 : 1;
                    if (type.types[index] === typeVariable) insertType(primitives, type.types[1 - index]);
                }
                const constraint = getBaseConstraintOfType(typeVariable);
                if (everyType(constraint, (t)=>containsType(primitives, t))) {
                    let i = types.length;
                    while(i > 0){
                        i--;
                        const type = types[i];
                        if (type.flags & 2097152 /* Intersection */  && getObjectFlags(type) & 67108864 /* IsConstrainedTypeVariable */ ) {
                            const index = type.types[0].flags & 8650752 /* TypeVariable */  ? 0 : 1;
                            if (type.types[index] === typeVariable && containsType(primitives, type.types[1 - index])) orderedRemoveItemAt(types, i);
                        }
                    }
                    insertType(types, typeVariable);
                }
            }
        }
        function isNamedUnionType(type) {
            return !!(type.flags & 1048576 /* Union */  && (type.aliasSymbol || type.origin));
        }
        function addNamedUnions(namedUnions, types) {
            for (const t of types)if (t.flags & 1048576 /* Union */ ) {
                const origin = t.origin;
                if (t.aliasSymbol || origin && !(origin.flags & 1048576 /* Union */ )) pushIfUnique(namedUnions, t);
                else if (origin && origin.flags & 1048576 /* Union */ ) addNamedUnions(namedUnions, origin.types);
            }
        }
        function createOriginUnionOrIntersectionType(flags, types) {
            const result = createOriginType(flags);
            result.types = types;
            return result;
        }
        function getUnionType(types, unionReduction = 1 /* Literal */ , aliasSymbol, aliasTypeArguments, origin) {
            if (types.length === 0) return neverType;
            if (types.length === 1) return types[0];
            if (types.length === 2 && !origin && (types[0].flags & 1048576 /* Union */  || types[1].flags & 1048576 /* Union */ )) {
                const infix = unionReduction === 0 /* None */  ? "N" : unionReduction === 2 /* Subtype */  ? "S" : "L";
                const index = types[0].id < types[1].id ? 0 : 1;
                const id = types[index].id + infix + types[1 - index].id + getAliasId(aliasSymbol, aliasTypeArguments);
                let type = unionOfUnionTypes.get(id);
                if (!type) {
                    type = getUnionTypeWorker(types, unionReduction, aliasSymbol, aliasTypeArguments, /*origin*/ void 0);
                    unionOfUnionTypes.set(id, type);
                }
                return type;
            }
            return getUnionTypeWorker(types, unionReduction, aliasSymbol, aliasTypeArguments, origin);
        }
        function getUnionTypeWorker(types, unionReduction, aliasSymbol, aliasTypeArguments, origin) {
            let typeSet = [];
            const includes = addTypesToUnion(typeSet, 0, types);
            if (unionReduction !== 0 /* None */ ) {
                if (includes & 3 /* AnyOrUnknown */ ) return includes & 1 /* Any */  ? includes & 8388608 /* IncludesWildcard */  ? wildcardType : includes & 1073741824 /* IncludesError */  ? errorType : anyType : unknownType;
                if (includes & 32768 /* Undefined */ ) {
                    if (typeSet.length >= 2 && typeSet[0] === undefinedType && typeSet[1] === missingType) orderedRemoveItemAt(typeSet, 1);
                }
                if (includes & 402664352 /* StringMapping */  || includes & 16384 /* Void */  && includes & 32768 /* Undefined */ ) removeRedundantLiteralTypes(typeSet, includes, !!(unionReduction & 2 /* Subtype */ ));
                if (includes & 128 /* StringLiteral */  && includes & 402653184 /* StringMapping */ ) removeStringLiteralsMatchedByTemplateLiterals(typeSet);
                if (includes & 536870912 /* IncludesConstrainedTypeVariable */ ) removeConstrainedTypeVariables(typeSet);
                if (unionReduction === 2 /* Subtype */ ) {
                    typeSet = removeSubtypes(typeSet, !!(includes & 524288 /* Object */ ));
                    if (!typeSet) return errorType;
                }
                if (typeSet.length === 0) return includes & 65536 /* Null */  ? includes & 4194304 /* IncludesNonWideningType */  ? nullType : nullWideningType : includes & 32768 /* Undefined */  ? includes & 4194304 /* IncludesNonWideningType */  ? undefinedType : undefinedWideningType : neverType;
            }
            if (!origin && includes & 1048576 /* Union */ ) {
                const namedUnions = [];
                addNamedUnions(namedUnions, types);
                const reducedTypes = [];
                for (const t of typeSet)if (!some(namedUnions, (union)=>containsType(union.types, t))) reducedTypes.push(t);
                if (!aliasSymbol && namedUnions.length === 1 && reducedTypes.length === 0) return namedUnions[0];
                const namedTypesCount = reduceLeft(namedUnions, (sum, union)=>sum + union.types.length, 0);
                if (namedTypesCount + reducedTypes.length === typeSet.length) {
                    for (const t of namedUnions)insertType(reducedTypes, t);
                    origin = createOriginUnionOrIntersectionType(1048576 /* Union */ , reducedTypes);
                }
            }
            const objectFlags = (includes & 36323331 /* NotPrimitiveUnion */  ? 0 : 32768 /* PrimitiveUnion */ ) | (includes & 2097152 /* Intersection */  ? 16777216 /* ContainsIntersections */  : 0);
            return getUnionTypeFromSortedList(typeSet, objectFlags, aliasSymbol, aliasTypeArguments, origin);
        }
        function getUnionOrIntersectionTypePredicate(signatures, kind) {
            let last2;
            const types = [];
            for (const sig of signatures){
                const pred = getTypePredicateOfSignature(sig);
                if (pred) {
                    if (pred.kind !== 0 /* This */  && pred.kind !== 1 /* Identifier */  || last2 && !typePredicateKindsMatch(last2, pred)) return void 0;
                    last2 = pred;
                    types.push(pred.type);
                } else {
                    const returnType = kind !== 2097152 /* Intersection */  ? getReturnTypeOfSignature(sig) : void 0;
                    if (returnType !== falseType && returnType !== regularFalseType) return void 0;
                }
            }
            if (!last2) return void 0;
            const compositeType = getUnionOrIntersectionType(types, kind);
            return createTypePredicate(last2.kind, last2.parameterName, last2.parameterIndex, compositeType);
        }
        function typePredicateKindsMatch(a, b) {
            return a.kind === b.kind && a.parameterIndex === b.parameterIndex;
        }
        function getUnionTypeFromSortedList(types, precomputedObjectFlags, aliasSymbol, aliasTypeArguments, origin) {
            if (types.length === 0) return neverType;
            if (types.length === 1) return types[0];
            const typeKey = !origin ? getTypeListId(types) : origin.flags & 1048576 /* Union */  ? `|${getTypeListId(origin.types)}` : origin.flags & 2097152 /* Intersection */  ? `&${getTypeListId(origin.types)}` : `#${origin.type.id}|${getTypeListId(types)}`;
            const id = typeKey + getAliasId(aliasSymbol, aliasTypeArguments);
            let type = unionTypes.get(id);
            if (!type) {
                type = createType(1048576 /* Union */ );
                type.objectFlags = precomputedObjectFlags | getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 98304 /* Nullable */ );
                type.types = types;
                type.origin = origin;
                type.aliasSymbol = aliasSymbol;
                type.aliasTypeArguments = aliasTypeArguments;
                if (types.length === 2 && types[0].flags & 512 /* BooleanLiteral */  && types[1].flags & 512 /* BooleanLiteral */ ) {
                    type.flags |= 16 /* Boolean */ ;
                    type.intrinsicName = "boolean";
                }
                unionTypes.set(id, type);
            }
            return type;
        }
        function getTypeFromUnionTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                links.resolvedType = getUnionType(map(node.types, getTypeFromTypeNode), 1 /* Literal */ , aliasSymbol, getTypeArgumentsForAliasSymbol(aliasSymbol));
            }
            return links.resolvedType;
        }
        function addTypeToIntersection(typeSet, includes, type) {
            const flags = type.flags;
            if (flags & 2097152 /* Intersection */ ) return addTypesToIntersection(typeSet, includes, type.types);
            if (isEmptyAnonymousObjectType(type)) {
                if (!(includes & 16777216 /* IncludesEmptyObject */ )) {
                    includes |= 16777216 /* IncludesEmptyObject */ ;
                    typeSet.set(type.id.toString(), type);
                }
            } else {
                if (flags & 3 /* AnyOrUnknown */ ) {
                    if (type === wildcardType) includes |= 8388608 /* IncludesWildcard */ ;
                    if (isErrorType(type)) includes |= 1073741824 /* IncludesError */ ;
                } else if (strictNullChecks || !(flags & 98304 /* Nullable */ )) {
                    if (type === missingType) {
                        includes |= 262144 /* IncludesMissingType */ ;
                        type = undefinedType;
                    }
                    if (!typeSet.has(type.id.toString())) {
                        if (type.flags & 109472 /* Unit */  && includes & 109472 /* Unit */ ) includes |= 67108864 /* NonPrimitive */ ;
                        typeSet.set(type.id.toString(), type);
                    }
                }
                includes |= flags & 473694207 /* IncludesMask */ ;
            }
            return includes;
        }
        function addTypesToIntersection(typeSet, includes, types) {
            for (const type of types)includes = addTypeToIntersection(typeSet, includes, getRegularTypeOfLiteralType(type));
            return includes;
        }
        function removeRedundantSupertypes(types, includes) {
            let i = types.length;
            while(i > 0){
                i--;
                const t = types[i];
                const remove = t.flags & 4 /* String */  && includes & 402653312 /* StringMapping */  || t.flags & 8 /* Number */  && includes & 256 /* NumberLiteral */  || t.flags & 64 /* BigInt */  && includes & 2048 /* BigIntLiteral */  || t.flags & 4096 /* ESSymbol */  && includes & 8192 /* UniqueESSymbol */  || t.flags & 16384 /* Void */  && includes & 32768 /* Undefined */  || isEmptyAnonymousObjectType(t) && includes & 470302716 /* DefinitelyNonNullable */ ;
                if (remove) orderedRemoveItemAt(types, i);
            }
        }
        function eachUnionContains(unionTypes2, type) {
            for (const u of unionTypes2)if (!containsType(u.types, type)) {
                if (type === missingType) return containsType(u.types, undefinedType);
                if (type === undefinedType) return containsType(u.types, missingType);
                const primitive = type.flags & 128 /* StringLiteral */  ? stringType : type.flags & 288 /* NumberLiteral */  ? numberType : type.flags & 2048 /* BigIntLiteral */  ? bigintType : type.flags & 8192 /* UniqueESSymbol */  ? esSymbolType : void 0;
                if (!primitive || !containsType(u.types, primitive)) return false;
            }
            return true;
        }
        function extractRedundantTemplateLiterals(types) {
            let i = types.length;
            const literals = filter(types, (t)=>!!(t.flags & 128 /* StringLiteral */ ));
            while(i > 0){
                i--;
                const t = types[i];
                if (!(t.flags & 402653184 /* StringMapping */ )) continue;
                for (const t2 of literals){
                    if (isTypeSubtypeOf(t2, t)) {
                        orderedRemoveItemAt(types, i);
                        break;
                    } else if (isPatternLiteralType(t)) return true;
                }
            }
            return false;
        }
        function removeFromEach(types, flag) {
            for(let i = 0; i < types.length; i++)types[i] = filterType(types[i], (t)=>!(t.flags & flag));
        }
        function intersectUnionsOfPrimitiveTypes(types) {
            let unionTypes2;
            const index = findIndex(types, (t)=>!!(getObjectFlags(t) & 32768 /* PrimitiveUnion */ ));
            if (index < 0) return false;
            let i = index + 1;
            while(i < types.length){
                const t = types[i];
                if (getObjectFlags(t) & 32768 /* PrimitiveUnion */ ) {
                    (unionTypes2 || (unionTypes2 = [
                        types[index]
                    ])).push(t);
                    orderedRemoveItemAt(types, i);
                } else i++;
            }
            if (!unionTypes2) return false;
            const checked = [];
            const result = [];
            for (const u of unionTypes2)for (const t of u.types){
                if (insertType(checked, t)) {
                    if (eachUnionContains(unionTypes2, t)) {
                        if (t === undefinedType && result.length && result[0] === missingType) continue;
                        if (t === missingType && result.length && result[0] === undefinedType) {
                            result[0] = missingType;
                            continue;
                        }
                        insertType(result, t);
                    }
                }
            }
            types[index] = getUnionTypeFromSortedList(result, 32768 /* PrimitiveUnion */ );
            return true;
        }
        function createIntersectionType(types, objectFlags, aliasSymbol, aliasTypeArguments) {
            const result = createType(2097152 /* Intersection */ );
            result.objectFlags = objectFlags | getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 98304 /* Nullable */ );
            result.types = types;
            result.aliasSymbol = aliasSymbol;
            result.aliasTypeArguments = aliasTypeArguments;
            return result;
        }
        function getIntersectionType(types, flags = 0 /* None */ , aliasSymbol, aliasTypeArguments) {
            const typeMembershipMap = /* @__PURE__ */ new Map();
            const includes = addTypesToIntersection(typeMembershipMap, 0, types);
            const typeSet = arrayFrom(typeMembershipMap.values());
            let objectFlags = 0 /* None */ ;
            if (includes & 131072 /* Never */ ) return contains(typeSet, silentNeverType) ? silentNeverType : neverType;
            if (strictNullChecks && includes & 98304 /* Nullable */  && includes & 84410368 /* IncludesEmptyObject */  || includes & 67108864 /* NonPrimitive */  && includes & 402783228 /* NonPrimitive */  || includes & 402653316 /* StringLike */  && includes & 67238776 /* StringLike */  || includes & 296 /* NumberLike */  && includes & 469891796 /* NumberLike */  || includes & 2112 /* BigIntLike */  && includes & 469889980 /* BigIntLike */  || includes & 12288 /* ESSymbolLike */  && includes & 469879804 /* ESSymbolLike */  || includes & 49152 /* VoidLike */  && includes & 469842940 /* VoidLike */ ) return neverType;
            if (includes & 402653184 /* StringMapping */  && includes & 128 /* StringLiteral */  && extractRedundantTemplateLiterals(typeSet)) return neverType;
            if (includes & 1 /* Any */ ) return includes & 8388608 /* IncludesWildcard */  ? wildcardType : includes & 1073741824 /* IncludesError */  ? errorType : anyType;
            if (!strictNullChecks && includes & 98304 /* Nullable */ ) return includes & 16777216 /* IncludesEmptyObject */  ? neverType : includes & 32768 /* Undefined */  ? undefinedType : nullType;
            if (includes & 4 /* String */  && includes & 402653312 /* StringMapping */  || includes & 8 /* Number */  && includes & 256 /* NumberLiteral */  || includes & 64 /* BigInt */  && includes & 2048 /* BigIntLiteral */  || includes & 4096 /* ESSymbol */  && includes & 8192 /* UniqueESSymbol */  || includes & 16384 /* Void */  && includes & 32768 /* Undefined */  || includes & 16777216 /* IncludesEmptyObject */  && includes & 470302716 /* DefinitelyNonNullable */ ) {
                if (!(flags & 1 /* NoSupertypeReduction */ )) removeRedundantSupertypes(typeSet, includes);
            }
            if (includes & 262144 /* IncludesMissingType */ ) typeSet[typeSet.indexOf(undefinedType)] = missingType;
            if (typeSet.length === 0) return unknownType;
            if (typeSet.length === 1) return typeSet[0];
            if (typeSet.length === 2 && !(flags & 2 /* NoConstraintReduction */ )) {
                const typeVarIndex = typeSet[0].flags & 8650752 /* TypeVariable */  ? 0 : 1;
                const typeVariable = typeSet[typeVarIndex];
                const primitiveType = typeSet[1 - typeVarIndex];
                if (typeVariable.flags & 8650752 /* TypeVariable */  && (primitiveType.flags & 469893116 /* NonPrimitive */  && !isGenericStringLikeType(primitiveType) || includes & 16777216 /* IncludesEmptyObject */ )) {
                    const constraint = getBaseConstraintOfType(typeVariable);
                    if (constraint && everyType(constraint, (t)=>!!(t.flags & 469893116 /* NonPrimitive */ ) || isEmptyAnonymousObjectType(t))) {
                        if (isTypeStrictSubtypeOf(constraint, primitiveType)) return typeVariable;
                        if (!(constraint.flags & 1048576 /* Union */  && someType(constraint, (c)=>isTypeStrictSubtypeOf(c, primitiveType)))) {
                            if (!isTypeStrictSubtypeOf(primitiveType, constraint)) return neverType;
                        }
                        objectFlags = 67108864 /* IsConstrainedTypeVariable */ ;
                    }
                }
            }
            const id = getTypeListId(typeSet) + (flags & 2 /* NoConstraintReduction */  ? "*" : getAliasId(aliasSymbol, aliasTypeArguments));
            let result = intersectionTypes.get(id);
            if (!result) {
                if (includes & 1048576 /* Union */ ) {
                    if (intersectUnionsOfPrimitiveTypes(typeSet)) result = getIntersectionType(typeSet, flags, aliasSymbol, aliasTypeArguments);
                    else if (every(typeSet, (t)=>!!(t.flags & 1048576 /* Union */  && t.types[0].flags & 32768 /* Undefined */ ))) {
                        const containedUndefinedType = some(typeSet, containsMissingType) ? missingType : undefinedType;
                        removeFromEach(typeSet, 32768 /* Undefined */ );
                        result = getUnionType([
                            getIntersectionType(typeSet, flags),
                            containedUndefinedType
                        ], 1 /* Literal */ , aliasSymbol, aliasTypeArguments);
                    } else if (every(typeSet, (t)=>!!(t.flags & 1048576 /* Union */  && (t.types[0].flags & 65536 /* Null */  || t.types[1].flags & 65536 /* Null */ )))) {
                        removeFromEach(typeSet, 65536 /* Null */ );
                        result = getUnionType([
                            getIntersectionType(typeSet, flags),
                            nullType
                        ], 1 /* Literal */ , aliasSymbol, aliasTypeArguments);
                    } else if (typeSet.length >= 3 && types.length > 2) {
                        const middle = Math.floor(typeSet.length / 2);
                        result = getIntersectionType([
                            getIntersectionType(typeSet.slice(0, middle), flags),
                            getIntersectionType(typeSet.slice(middle), flags)
                        ], flags, aliasSymbol, aliasTypeArguments);
                    } else {
                        if (!checkCrossProductUnion(typeSet)) return errorType;
                        const constituents = getCrossProductIntersections(typeSet, flags);
                        const origin = some(constituents, (t)=>!!(t.flags & 2097152 /* Intersection */ )) && getConstituentCountOfTypes(constituents) > getConstituentCountOfTypes(typeSet) ? createOriginUnionOrIntersectionType(2097152 /* Intersection */ , typeSet) : void 0;
                        result = getUnionType(constituents, 1 /* Literal */ , aliasSymbol, aliasTypeArguments, origin);
                    }
                } else result = createIntersectionType(typeSet, objectFlags, aliasSymbol, aliasTypeArguments);
                intersectionTypes.set(id, result);
            }
            return result;
        }
        function getCrossProductUnionSize(types) {
            return reduceLeft(types, (n, t)=>t.flags & 1048576 /* Union */  ? n * t.types.length : t.flags & 131072 /* Never */  ? 0 : n, 1);
        }
        function checkCrossProductUnion(types) {
            var _a;
            const size = getCrossProductUnionSize(types);
            if (size >= 1e5) {
                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "checkCrossProductUnion_DepthLimit", {
                    typeIds: types.map((t)=>t.id),
                    size
                });
                error2(currentNode, Diagnostics.Expression_produces_a_union_type_that_is_too_complex_to_represent);
                return false;
            }
            return true;
        }
        function getCrossProductIntersections(types, flags) {
            const count = getCrossProductUnionSize(types);
            const intersections = [];
            for(let i = 0; i < count; i++){
                const constituents = types.slice();
                let n = i;
                for(let j = types.length - 1; j >= 0; j--)if (types[j].flags & 1048576 /* Union */ ) {
                    const sourceTypes = types[j].types;
                    const length2 = sourceTypes.length;
                    constituents[j] = sourceTypes[n % length2];
                    n = Math.floor(n / length2);
                }
                const t = getIntersectionType(constituents, flags);
                if (!(t.flags & 131072 /* Never */ )) intersections.push(t);
            }
            return intersections;
        }
        function getConstituentCount(type) {
            return !(type.flags & 3145728 /* UnionOrIntersection */ ) || type.aliasSymbol ? 1 : type.flags & 1048576 /* Union */  && type.origin ? getConstituentCount(type.origin) : getConstituentCountOfTypes(type.types);
        }
        function getConstituentCountOfTypes(types) {
            return reduceLeft(types, (n, t)=>n + getConstituentCount(t), 0);
        }
        function getTypeFromIntersectionTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                const types = map(node.types, getTypeFromTypeNode);
                const emptyIndex = types.length === 2 ? types.indexOf(emptyTypeLiteralType) : -1;
                const t = emptyIndex >= 0 ? types[1 - emptyIndex] : unknownType;
                const noSupertypeReduction = !!(t.flags & 76 /* BigInt */  || t.flags & 134217728 /* TemplateLiteral */  && isPatternLiteralType(t));
                links.resolvedType = getIntersectionType(types, noSupertypeReduction ? 1 /* NoSupertypeReduction */  : 0, aliasSymbol, getTypeArgumentsForAliasSymbol(aliasSymbol));
            }
            return links.resolvedType;
        }
        function createIndexType(type, indexFlags) {
            const result = createType(4194304 /* Index */ );
            result.type = type;
            result.indexFlags = indexFlags;
            return result;
        }
        function createOriginIndexType(type) {
            const result = createOriginType(4194304 /* Index */ );
            result.type = type;
            return result;
        }
        function getIndexTypeForGenericType(type, indexFlags) {
            return indexFlags & 1 /* StringsOnly */  ? type.resolvedStringIndexType || (type.resolvedStringIndexType = createIndexType(type, 1 /* StringsOnly */ )) : type.resolvedIndexType || (type.resolvedIndexType = createIndexType(type, 0 /* None */ ));
        }
        function getIndexTypeForMappedType(type, indexFlags) {
            const typeParameter = getTypeParameterFromMappedType(type);
            const constraintType = getConstraintTypeFromMappedType(type);
            const nameType = getNameTypeFromMappedType(type.target || type);
            if (!nameType && !(indexFlags & 2 /* NoIndexSignatures */ )) return constraintType;
            const keyTypes = [];
            if (isGenericIndexType(constraintType)) {
                if (isMappedTypeWithKeyofConstraintDeclaration(type)) return getIndexTypeForGenericType(type, indexFlags);
                forEachType(constraintType, addMemberForKeyType);
            } else if (isMappedTypeWithKeyofConstraintDeclaration(type)) {
                const modifiersType = getApparentType(getModifiersTypeFromMappedType(type));
                forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(modifiersType, 8576 /* StringOrNumberLiteralOrUnique */ , !!(indexFlags & 1 /* StringsOnly */ ), addMemberForKeyType);
            } else forEachType(getLowerBoundOfKeyType(constraintType), addMemberForKeyType);
            const result = indexFlags & 2 /* NoIndexSignatures */  ? filterType(getUnionType(keyTypes), (t)=>!(t.flags & 5 /* String */ )) : getUnionType(keyTypes);
            if (result.flags & 1048576 /* Union */  && constraintType.flags & 1048576 /* Union */  && getTypeListId(result.types) === getTypeListId(constraintType.types)) return constraintType;
            return result;
            function addMemberForKeyType(keyType) {
                const propNameType = nameType ? instantiateType(nameType, appendTypeMapping(type.mapper, typeParameter, keyType)) : keyType;
                keyTypes.push(propNameType === stringType ? stringOrNumberType : propNameType);
            }
        }
        function hasDistributiveNameType(mappedType) {
            const typeVariable = getTypeParameterFromMappedType(mappedType);
            return isDistributive(getNameTypeFromMappedType(mappedType) || typeVariable);
            function isDistributive(type) {
                return type.flags & 470810623 /* NonPrimitive */  ? true : type.flags & 16777216 /* Conditional */  ? type.root.isDistributive && type.checkType === typeVariable : type.flags & 137363456 /* TemplateLiteral */  ? every(type.types, isDistributive) : type.flags & 8388608 /* IndexedAccess */  ? isDistributive(type.objectType) && isDistributive(type.indexType) : type.flags & 33554432 /* Substitution */  ? isDistributive(type.baseType) && isDistributive(type.constraint) : type.flags & 268435456 /* StringMapping */  ? isDistributive(type.type) : false;
            }
        }
        function getLiteralTypeFromPropertyName(name) {
            if (isPrivateIdentifier(name)) return neverType;
            if (isNumericLiteral(name)) return getRegularTypeOfLiteralType(checkExpression(name));
            if (isComputedPropertyName(name)) return getRegularTypeOfLiteralType(checkComputedPropertyName(name));
            const propertyName = getPropertyNameForPropertyNameNode(name);
            if (propertyName !== void 0) return getStringLiteralType(unescapeLeadingUnderscores(propertyName));
            if (isExpression(name)) return getRegularTypeOfLiteralType(checkExpression(name));
            return neverType;
        }
        function getLiteralTypeFromProperty(prop, include, includeNonPublic) {
            if (includeNonPublic || !(getDeclarationModifierFlagsFromSymbol(prop) & 6 /* NonPublicAccessibilityModifier */ )) {
                let type = getSymbolLinks(getLateBoundSymbol(prop)).nameType;
                if (!type) {
                    const name = getNameOfDeclaration(prop.valueDeclaration);
                    type = prop.escapedName === "default" /* Default */  ? getStringLiteralType("default") : name && getLiteralTypeFromPropertyName(name) || (!isKnownSymbol(prop) ? getStringLiteralType(symbolName(prop)) : void 0);
                }
                if (type && type.flags & include) return type;
            }
            return neverType;
        }
        function isKeyTypeIncluded(keyType, include) {
            return !!(keyType.flags & include || keyType.flags & 2097152 /* Intersection */  && some(keyType.types, (t)=>isKeyTypeIncluded(t, include)));
        }
        function getLiteralTypeFromProperties(type, include, includeOrigin) {
            const origin = includeOrigin && (getObjectFlags(type) & 7 /* Reference */  || type.aliasSymbol) ? createOriginIndexType(type) : void 0;
            const propertyTypes = map(getPropertiesOfType(type), (prop)=>getLiteralTypeFromProperty(prop, include));
            const indexKeyTypes = map(getIndexInfosOfType(type), (info)=>info !== enumNumberIndexInfo && isKeyTypeIncluded(info.keyType, include) ? info.keyType === stringType && include & 8 /* Number */  ? stringOrNumberType : info.keyType : neverType);
            return getUnionType(concatenate(propertyTypes, indexKeyTypes), 1 /* Literal */ , /*aliasSymbol*/ void 0, /*aliasTypeArguments*/ void 0, origin);
        }
        function shouldDeferIndexType(type, indexFlags = 0 /* None */ ) {
            return !!(type.flags & 58982400 /* InstantiableNonPrimitive */  || isGenericTupleType(type) || isGenericMappedType(type) && (!hasDistributiveNameType(type) || getMappedTypeNameTypeKind(type) === 2 /* Remapping */ ) || type.flags & 1048576 /* Union */  && !(indexFlags & 4 /* NoReducibleCheck */ ) && isGenericReducibleType(type) || type.flags & 2097152 /* Intersection */  && maybeTypeOfKind(type, 465829888 /* Instantiable */ ) && some(type.types, isEmptyAnonymousObjectType));
        }
        function getIndexType(type, indexFlags = 0 /* None */ ) {
            type = getReducedType(type);
            return isNoInferType(type) ? getNoInferType(getIndexType(type.baseType, indexFlags)) : shouldDeferIndexType(type, indexFlags) ? getIndexTypeForGenericType(type, indexFlags) : type.flags & 1048576 /* Union */  ? getIntersectionType(map(type.types, (t)=>getIndexType(t, indexFlags))) : type.flags & 2097152 /* Intersection */  ? getUnionType(map(type.types, (t)=>getIndexType(t, indexFlags))) : getObjectFlags(type) & 32 /* Mapped */  ? getIndexTypeForMappedType(type, indexFlags) : type === wildcardType ? wildcardType : type.flags & 2 /* Unknown */  ? neverType : type.flags & 131073 /* Never */  ? stringNumberSymbolType : getLiteralTypeFromProperties(type, (indexFlags & 2 /* NoIndexSignatures */  ? 128 /* StringLiteral */  : 402653316 /* StringLike */ ) | (indexFlags & 1 /* StringsOnly */  ? 0 : 12584 /* ESSymbolLike */ ), indexFlags === 0 /* None */ );
        }
        function getExtractStringType(type) {
            const extractTypeAlias = getGlobalExtractSymbol();
            return extractTypeAlias ? getTypeAliasInstantiation(extractTypeAlias, [
                type,
                stringType
            ]) : stringType;
        }
        function getIndexTypeOrString(type) {
            const indexType = getExtractStringType(getIndexType(type));
            return indexType.flags & 131072 /* Never */  ? stringType : indexType;
        }
        function getTypeFromTypeOperatorNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) switch(node.operator){
                case 143 /* KeyOfKeyword */ :
                    links.resolvedType = getIndexType(getTypeFromTypeNode(node.type));
                    break;
                case 158 /* UniqueKeyword */ :
                    links.resolvedType = node.type.kind === 155 /* SymbolKeyword */  ? getESSymbolLikeTypeForNode(walkUpParenthesizedTypes(node.parent)) : errorType;
                    break;
                case 148 /* ReadonlyKeyword */ :
                    links.resolvedType = getTypeFromTypeNode(node.type);
                    break;
                default:
                    Debug.assertNever(node.operator);
            }
            return links.resolvedType;
        }
        function getTypeFromTemplateTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getTemplateLiteralType([
                node.head.text,
                ...map(node.templateSpans, (span)=>span.literal.text)
            ], map(node.templateSpans, (span)=>getTypeFromTypeNode(span.type)));
            return links.resolvedType;
        }
        function getTemplateLiteralType(texts, types) {
            const unionIndex = findIndex(types, (t)=>!!(t.flags & 1179648 /* Union */ ));
            if (unionIndex >= 0) return checkCrossProductUnion(types) ? mapType(types[unionIndex], (t)=>getTemplateLiteralType(texts, replaceElement(types, unionIndex, t))) : errorType;
            if (contains(types, wildcardType)) return wildcardType;
            const newTypes = [];
            const newTexts = [];
            let text = texts[0];
            if (!addSpans(texts, types)) return stringType;
            if (newTypes.length === 0) return getStringLiteralType(text);
            newTexts.push(text);
            if (every(newTexts, (t)=>t === "")) {
                if (every(newTypes, (t)=>!!(t.flags & 4 /* String */ ))) return stringType;
                if (newTypes.length === 1 && isPatternLiteralType(newTypes[0])) return newTypes[0];
            }
            const id = `${getTypeListId(newTypes)}|${map(newTexts, (t)=>t.length).join(",")}|${newTexts.join("")}`;
            let type = templateLiteralTypes.get(id);
            if (!type) templateLiteralTypes.set(id, type = createTemplateLiteralType(newTexts, newTypes));
            return type;
            function addSpans(texts2, types2) {
                for(let i = 0; i < types2.length; i++){
                    const t = types2[i];
                    if (t.flags & 101248 /* Undefined */ ) {
                        text += getTemplateStringForType(t) || "";
                        text += texts2[i + 1];
                    } else if (t.flags & 134217728 /* TemplateLiteral */ ) {
                        text += t.texts[0];
                        if (!addSpans(t.texts, t.types)) return false;
                        text += texts2[i + 1];
                    } else if (isGenericIndexType(t) || isPatternLiteralPlaceholderType(t)) {
                        newTypes.push(t);
                        newTexts.push(text);
                        text = texts2[i + 1];
                    } else return false;
                }
                return true;
            }
        }
        function getTemplateStringForType(type) {
            return type.flags & 128 /* StringLiteral */  ? type.value : type.flags & 256 /* NumberLiteral */  ? "" + type.value : type.flags & 2048 /* BigIntLiteral */  ? pseudoBigIntToString(type.value) : type.flags & 98816 /* Nullable */  ? type.intrinsicName : void 0;
        }
        function createTemplateLiteralType(texts, types) {
            const type = createType(134217728 /* TemplateLiteral */ );
            type.texts = texts;
            type.types = types;
            return type;
        }
        function getStringMappingType(symbol, type) {
            return type.flags & 1179648 /* Never */  ? mapType(type, (t)=>getStringMappingType(symbol, t)) : type.flags & 128 /* StringLiteral */  ? getStringLiteralType(applyStringMapping(symbol, type.value)) : type.flags & 134217728 /* TemplateLiteral */  ? getTemplateLiteralType(...applyTemplateStringMapping(symbol, type.texts, type.types)) : // Mapping<Mapping<T>> === Mapping<T>
            type.flags & 268435456 /* StringMapping */  && symbol === type.symbol ? type : type.flags & 268435461 /* StringMapping */  || isGenericIndexType(type) ? getStringMappingTypeForGenericType(symbol, type) : // This handles Mapping<`${number}`> and Mapping<`${bigint}`>
            isPatternLiteralPlaceholderType(type) ? getStringMappingTypeForGenericType(symbol, getTemplateLiteralType([
                "",
                ""
            ], [
                type
            ])) : type;
        }
        function applyStringMapping(symbol, str) {
            switch(intrinsicTypeKinds.get(symbol.escapedName)){
                case 0 /* Uppercase */ :
                    return str.toUpperCase();
                case 1 /* Lowercase */ :
                    return str.toLowerCase();
                case 2 /* Capitalize */ :
                    return str.charAt(0).toUpperCase() + str.slice(1);
                case 3 /* Uncapitalize */ :
                    return str.charAt(0).toLowerCase() + str.slice(1);
            }
            return str;
        }
        function applyTemplateStringMapping(symbol, texts, types) {
            switch(intrinsicTypeKinds.get(symbol.escapedName)){
                case 0 /* Uppercase */ :
                    return [
                        texts.map((t)=>t.toUpperCase()),
                        types.map((t)=>getStringMappingType(symbol, t))
                    ];
                case 1 /* Lowercase */ :
                    return [
                        texts.map((t)=>t.toLowerCase()),
                        types.map((t)=>getStringMappingType(symbol, t))
                    ];
                case 2 /* Capitalize */ :
                    return [
                        texts[0] === "" ? texts : [
                            texts[0].charAt(0).toUpperCase() + texts[0].slice(1),
                            ...texts.slice(1)
                        ],
                        texts[0] === "" ? [
                            getStringMappingType(symbol, types[0]),
                            ...types.slice(1)
                        ] : types
                    ];
                case 3 /* Uncapitalize */ :
                    return [
                        texts[0] === "" ? texts : [
                            texts[0].charAt(0).toLowerCase() + texts[0].slice(1),
                            ...texts.slice(1)
                        ],
                        texts[0] === "" ? [
                            getStringMappingType(symbol, types[0]),
                            ...types.slice(1)
                        ] : types
                    ];
            }
            return [
                texts,
                types
            ];
        }
        function getStringMappingTypeForGenericType(symbol, type) {
            const id = `${getSymbolId(symbol)},${getTypeId(type)}`;
            let result = stringMappingTypes.get(id);
            if (!result) stringMappingTypes.set(id, result = createStringMappingType(symbol, type));
            return result;
        }
        function createStringMappingType(symbol, type) {
            const result = createTypeWithSymbol(268435456 /* StringMapping */ , symbol);
            result.type = type;
            return result;
        }
        function createIndexedAccessType(objectType, indexType, accessFlags, aliasSymbol, aliasTypeArguments) {
            const type = createType(8388608 /* IndexedAccess */ );
            type.objectType = objectType;
            type.indexType = indexType;
            type.accessFlags = accessFlags;
            type.aliasSymbol = aliasSymbol;
            type.aliasTypeArguments = aliasTypeArguments;
            return type;
        }
        function isJSLiteralType(type) {
            if (noImplicitAny) return false;
            if (getObjectFlags(type) & 4096 /* JSLiteral */ ) return true;
            if (type.flags & 1048576 /* Union */ ) return every(type.types, isJSLiteralType);
            if (type.flags & 2097152 /* Intersection */ ) return some(type.types, isJSLiteralType);
            if (type.flags & 465829888 /* Instantiable */ ) {
                const constraint = getResolvedBaseConstraint(type);
                return constraint !== type && isJSLiteralType(constraint);
            }
            return false;
        }
        function getPropertyNameFromIndex(indexType, accessNode) {
            return isTypeUsableAsPropertyName(indexType) ? getPropertyNameFromType(indexType) : accessNode && isPropertyName(accessNode) ? // late bound names are handled in the first branch, so here we only need to handle normal names
            getPropertyNameForPropertyNameNode(accessNode) : void 0;
        }
        function isUncalledFunctionReference(node, symbol) {
            if (symbol.flags & 8208 /* Method */ ) {
                const parent2 = findAncestor(node.parent, (n)=>!isAccessExpression(n)) || node.parent;
                if (isCallLikeExpression(parent2)) return isCallOrNewExpression(parent2) && isIdentifier(node) && hasMatchingArgument(parent2, node);
                return every(symbol.declarations, (d)=>!isFunctionLike(d) || isDeprecatedDeclaration2(d));
            }
            return true;
        }
        function getPropertyTypeForIndexType(originalObjectType, objectType, indexType, fullIndexType, accessNode, accessFlags) {
            const accessExpression = accessNode && accessNode.kind === 213 /* ElementAccessExpression */  ? accessNode : void 0;
            const propName = accessNode && isPrivateIdentifier(accessNode) ? void 0 : getPropertyNameFromIndex(indexType, accessNode);
            if (propName !== void 0) {
                if (accessFlags & 256 /* Contextual */ ) return getTypeOfPropertyOfContextualType(objectType, propName) || anyType;
                const prop = getPropertyOfType(objectType, propName);
                if (prop) {
                    if (accessFlags & 64 /* ReportDeprecated */  && accessNode && prop.declarations && isDeprecatedSymbol(prop) && isUncalledFunctionReference(accessNode, prop)) {
                        var _ref;
                        const deprecatedNode = (_ref = accessExpression == null ? void 0 : accessExpression.argumentExpression) !== null && _ref !== void 0 ? _ref : isIndexedAccessTypeNode(accessNode) ? accessNode.indexType : accessNode;
                        addDeprecatedSuggestion(deprecatedNode, prop.declarations, propName);
                    }
                    if (accessExpression) {
                        markPropertyAsReferenced(prop, accessExpression, isSelfTypeAccess(accessExpression.expression, objectType.symbol));
                        if (isAssignmentToReadonlyEntity(accessExpression, prop, getAssignmentTargetKind(accessExpression))) {
                            error2(accessExpression.argumentExpression, Diagnostics.Cannot_assign_to_0_because_it_is_a_read_only_property, symbolToString(prop));
                            return void 0;
                        }
                        if (accessFlags & 8 /* CacheSymbol */ ) getNodeLinks(accessNode).resolvedSymbol = prop;
                        if (isThisPropertyAccessInConstructor(accessExpression, prop)) return autoType;
                    }
                    const propType = accessFlags & 4 /* Writing */  ? getWriteTypeOfSymbol(prop) : getTypeOfSymbol(prop);
                    return accessExpression && getAssignmentTargetKind(accessExpression) !== 1 /* Definite */  ? getFlowTypeOfReference(accessExpression, propType) : accessNode && isIndexedAccessTypeNode(accessNode) && containsMissingType(propType) ? getUnionType([
                        propType,
                        undefinedType
                    ]) : propType;
                }
                if (everyType(objectType, isTupleType) && isNumericLiteralName(propName)) {
                    const index = +propName;
                    if (accessNode && everyType(objectType, (t)=>!(t.target.combinedFlags & 12 /* Variable */ )) && !(accessFlags & 16 /* AllowMissing */ )) {
                        const indexNode = getIndexNodeForAccessExpression(accessNode);
                        if (isTupleType(objectType)) {
                            if (index < 0) {
                                error2(indexNode, Diagnostics.A_tuple_type_cannot_be_indexed_with_a_negative_value);
                                return undefinedType;
                            }
                            error2(indexNode, Diagnostics.Tuple_type_0_of_length_1_has_no_element_at_index_2, typeToString(objectType), getTypeReferenceArity(objectType), unescapeLeadingUnderscores(propName));
                        } else error2(indexNode, Diagnostics.Property_0_does_not_exist_on_type_1, unescapeLeadingUnderscores(propName), typeToString(objectType));
                    }
                    if (index >= 0) {
                        errorIfWritingToReadonlyIndex(getIndexInfoOfType(objectType, numberType));
                        return getTupleElementTypeOutOfStartCount(objectType, index, accessFlags & 1 /* IncludeUndefined */  ? missingType : void 0);
                    }
                }
            }
            if (!(indexType.flags & 98304 /* Nullable */ ) && isTypeAssignableToKind(indexType, 402665900 /* ESSymbolLike */ )) {
                if (objectType.flags & 131073 /* Never */ ) return objectType;
                const indexInfo = getApplicableIndexInfo(objectType, indexType) || getIndexInfoOfType(objectType, stringType);
                if (indexInfo) {
                    if (accessFlags & 2 /* NoIndexSignatures */  && indexInfo.keyType !== numberType) {
                        if (accessExpression) {
                            if (accessFlags & 4 /* Writing */ ) error2(accessExpression, Diagnostics.Type_0_is_generic_and_can_only_be_indexed_for_reading, typeToString(originalObjectType));
                            else error2(accessExpression, Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(indexType), typeToString(originalObjectType));
                        }
                        return void 0;
                    }
                    if (accessNode && indexInfo.keyType === stringType && !isTypeAssignableToKind(indexType, 12 /* Number */ )) {
                        const indexNode = getIndexNodeForAccessExpression(accessNode);
                        error2(indexNode, Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeToString(indexType));
                        return accessFlags & 1 /* IncludeUndefined */  ? getUnionType([
                            indexInfo.type,
                            missingType
                        ]) : indexInfo.type;
                    }
                    errorIfWritingToReadonlyIndex(indexInfo);
                    if (accessFlags & 1 /* IncludeUndefined */  && !(objectType.symbol && objectType.symbol.flags & 384 /* ConstEnum */  && indexType.symbol && indexType.flags & 1024 /* EnumLiteral */  && getParentOfSymbol(indexType.symbol) === objectType.symbol)) return getUnionType([
                        indexInfo.type,
                        missingType
                    ]);
                    return indexInfo.type;
                }
                if (indexType.flags & 131072 /* Never */ ) return neverType;
                if (isJSLiteralType(objectType)) return anyType;
                if (accessExpression && !isConstEnumObjectType(objectType)) {
                    if (isObjectLiteralType2(objectType)) {
                        if (noImplicitAny && indexType.flags & 384 /* NumberLiteral */ ) {
                            diagnostics.add(createDiagnosticForNode(accessExpression, Diagnostics.Property_0_does_not_exist_on_type_1, indexType.value, typeToString(objectType)));
                            return undefinedType;
                        } else if (indexType.flags & 12 /* String */ ) {
                            const types = map(objectType.properties, (property)=>{
                                return getTypeOfSymbol(property);
                            });
                            return getUnionType(append(types, undefinedType));
                        }
                    }
                    if (objectType.symbol === globalThisSymbol && propName !== void 0 && globalThisSymbol.exports.has(propName) && globalThisSymbol.exports.get(propName).flags & 418 /* BlockScoped */ ) error2(accessExpression, Diagnostics.Property_0_does_not_exist_on_type_1, unescapeLeadingUnderscores(propName), typeToString(objectType));
                    else if (noImplicitAny && !(accessFlags & 128 /* SuppressNoImplicitAnyError */ )) {
                        if (propName !== void 0 && typeHasStaticProperty(propName, objectType)) {
                            const typeName = typeToString(objectType);
                            error2(accessExpression, Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead, propName, typeName, typeName + "[" + getTextOfNode(accessExpression.argumentExpression) + "]");
                        } else if (getIndexTypeOfType(objectType, numberType)) error2(accessExpression.argumentExpression, Diagnostics.Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number);
                        else {
                            let suggestion;
                            if (propName !== void 0 && (suggestion = getSuggestionForNonexistentProperty(propName, objectType))) {
                                if (suggestion !== void 0) error2(accessExpression.argumentExpression, Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2, propName, typeToString(objectType), suggestion);
                            } else {
                                const suggestion2 = getSuggestionForNonexistentIndexSignature(objectType, accessExpression, indexType);
                                if (suggestion2 !== void 0) error2(accessExpression, Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_Did_you_mean_to_call_1, typeToString(objectType), suggestion2);
                                else {
                                    let errorInfo;
                                    if (indexType.flags & 1024 /* EnumLiteral */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, "[" + typeToString(indexType) + "]", typeToString(objectType));
                                    else if (indexType.flags & 8192 /* UniqueESSymbol */ ) {
                                        const symbolName2 = getFullyQualifiedName(indexType.symbol, accessExpression);
                                        errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, "[" + symbolName2 + "]", typeToString(objectType));
                                    } else if (indexType.flags & 128 /* StringLiteral */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, indexType.value, typeToString(objectType));
                                    else if (indexType.flags & 256 /* NumberLiteral */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_does_not_exist_on_type_1, indexType.value, typeToString(objectType));
                                    else if (indexType.flags & 12 /* String */ ) errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.No_index_signature_with_a_parameter_of_type_0_was_found_on_type_1, typeToString(indexType), typeToString(objectType));
                                    errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Element_implicitly_has_an_any_type_because_expression_of_type_0_can_t_be_used_to_index_type_1, typeToString(fullIndexType), typeToString(objectType));
                                    diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(accessExpression), accessExpression, errorInfo));
                                }
                            }
                        }
                    }
                    return void 0;
                }
            }
            if (accessFlags & 16 /* AllowMissing */  && isObjectLiteralType2(objectType)) return undefinedType;
            if (isJSLiteralType(objectType)) return anyType;
            if (accessNode) {
                const indexNode = getIndexNodeForAccessExpression(accessNode);
                if (indexNode.kind !== 10 /* BigIntLiteral */  && indexType.flags & 384 /* NumberLiteral */ ) error2(indexNode, Diagnostics.Property_0_does_not_exist_on_type_1, "" + indexType.value, typeToString(objectType));
                else if (indexType.flags & 12 /* Number */ ) error2(indexNode, Diagnostics.Type_0_has_no_matching_index_signature_for_type_1, typeToString(objectType), typeToString(indexType));
                else {
                    const typeString = indexNode.kind === 10 /* BigIntLiteral */  ? "bigint" : typeToString(indexType);
                    error2(indexNode, Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeString);
                }
            }
            if (isTypeAny(indexType)) return indexType;
            return void 0;
            function errorIfWritingToReadonlyIndex(indexInfo) {
                if (indexInfo && indexInfo.isReadonly && accessExpression && (isAssignmentTarget(accessExpression) || isDeleteTarget(accessExpression))) error2(accessExpression, Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
            }
        }
        function getIndexNodeForAccessExpression(accessNode) {
            return accessNode.kind === 213 /* ElementAccessExpression */  ? accessNode.argumentExpression : accessNode.kind === 200 /* IndexedAccessType */  ? accessNode.indexType : accessNode.kind === 168 /* ComputedPropertyName */  ? accessNode.expression : accessNode;
        }
        function isPatternLiteralPlaceholderType(type) {
            if (type.flags & 2097152 /* Intersection */ ) {
                let seenPlaceholder = false;
                for (const t of type.types){
                    if (t.flags & 101248 /* Nullable */  || isPatternLiteralPlaceholderType(t)) seenPlaceholder = true;
                    else if (!(t.flags & 524288 /* Object */ )) return false;
                }
                return seenPlaceholder;
            }
            return !!(type.flags & 77 /* BigInt */ ) || isPatternLiteralType(type);
        }
        function isPatternLiteralType(type) {
            return !!(type.flags & 134217728 /* TemplateLiteral */ ) && every(type.types, isPatternLiteralPlaceholderType) || !!(type.flags & 268435456 /* StringMapping */ ) && isPatternLiteralPlaceholderType(type.type);
        }
        function isGenericStringLikeType(type) {
            return !!(type.flags & 402653184 /* StringMapping */ ) && !isPatternLiteralType(type);
        }
        function isGenericType(type) {
            return !!getGenericObjectFlags(type);
        }
        function isGenericObjectType(type) {
            return !!(getGenericObjectFlags(type) & 4194304 /* IsGenericObjectType */ );
        }
        function isGenericIndexType(type) {
            return !!(getGenericObjectFlags(type) & 8388608 /* IsGenericIndexType */ );
        }
        function getGenericObjectFlags(type) {
            if (type.flags & 3145728 /* UnionOrIntersection */ ) {
                if (!(type.objectFlags & 2097152 /* IsGenericTypeComputed */ )) type.objectFlags |= 2097152 /* IsGenericTypeComputed */  | reduceLeft(type.types, (flags, t)=>flags | getGenericObjectFlags(t), 0);
                return type.objectFlags & 12582912 /* IsGenericType */ ;
            }
            if (type.flags & 33554432 /* Substitution */ ) {
                if (!(type.objectFlags & 2097152 /* IsGenericTypeComputed */ )) type.objectFlags |= 2097152 /* IsGenericTypeComputed */  | getGenericObjectFlags(type.baseType) | getGenericObjectFlags(type.constraint);
                return type.objectFlags & 12582912 /* IsGenericType */ ;
            }
            return (type.flags & 58982400 /* InstantiableNonPrimitive */  || isGenericMappedType(type) || isGenericTupleType(type) ? 4194304 /* IsGenericObjectType */  : 0) | (type.flags & 63176704 /* Index */  || isGenericStringLikeType(type) ? 8388608 /* IsGenericIndexType */  : 0);
        }
        function getSimplifiedType(type, writing) {
            return type.flags & 8388608 /* IndexedAccess */  ? getSimplifiedIndexedAccessType(type, writing) : type.flags & 16777216 /* Conditional */  ? getSimplifiedConditionalType(type, writing) : type;
        }
        function distributeIndexOverObjectType(objectType, indexType, writing) {
            if (objectType.flags & 1048576 /* Union */  || objectType.flags & 2097152 /* Intersection */  && !shouldDeferIndexType(objectType)) {
                const types = map(objectType.types, (t)=>getSimplifiedType(getIndexedAccessType(t, indexType), writing));
                return objectType.flags & 2097152 /* Intersection */  || writing ? getIntersectionType(types) : getUnionType(types);
            }
        }
        function distributeObjectOverIndexType(objectType, indexType, writing) {
            if (indexType.flags & 1048576 /* Union */ ) {
                const types = map(indexType.types, (t)=>getSimplifiedType(getIndexedAccessType(objectType, t), writing));
                return writing ? getIntersectionType(types) : getUnionType(types);
            }
        }
        function getSimplifiedIndexedAccessType(type, writing) {
            const cache = writing ? "simplifiedForWriting" : "simplifiedForReading";
            if (type[cache]) return type[cache] === circularConstraintType ? type : type[cache];
            type[cache] = circularConstraintType;
            const objectType = getSimplifiedType(type.objectType, writing);
            const indexType = getSimplifiedType(type.indexType, writing);
            const distributedOverIndex = distributeObjectOverIndexType(objectType, indexType, writing);
            if (distributedOverIndex) return type[cache] = distributedOverIndex;
            if (!(indexType.flags & 465829888 /* Instantiable */ )) {
                const distributedOverObject = distributeIndexOverObjectType(objectType, indexType, writing);
                if (distributedOverObject) return type[cache] = distributedOverObject;
            }
            if (isGenericTupleType(objectType) && indexType.flags & 296 /* NumberLike */ ) {
                const elementType = getElementTypeOfSliceOfTupleType(objectType, indexType.flags & 8 /* Number */  ? 0 : objectType.target.fixedLength, /*endSkipCount*/ 0, writing);
                if (elementType) return type[cache] = elementType;
            }
            if (isGenericMappedType(objectType)) {
                if (getMappedTypeNameTypeKind(objectType) !== 2 /* Remapping */ ) return type[cache] = mapType(substituteIndexedMappedType(objectType, type.indexType), (t)=>getSimplifiedType(t, writing));
            }
            return type[cache] = type;
        }
        function getSimplifiedConditionalType(type, writing) {
            const checkType = type.checkType;
            const extendsType = type.extendsType;
            const trueType2 = getTrueTypeFromConditionalType(type);
            const falseType2 = getFalseTypeFromConditionalType(type);
            if (falseType2.flags & 131072 /* Never */  && getActualTypeVariable(trueType2) === getActualTypeVariable(checkType)) {
                if (checkType.flags & 1 /* Any */  || isTypeAssignableTo(getRestrictiveInstantiation(checkType), getRestrictiveInstantiation(extendsType))) return getSimplifiedType(trueType2, writing);
                else if (isIntersectionEmpty(checkType, extendsType)) return neverType;
            } else if (trueType2.flags & 131072 /* Never */  && getActualTypeVariable(falseType2) === getActualTypeVariable(checkType)) {
                if (!(checkType.flags & 1 /* Any */ ) && isTypeAssignableTo(getRestrictiveInstantiation(checkType), getRestrictiveInstantiation(extendsType))) return neverType;
                else if (checkType.flags & 1 /* Any */  || isIntersectionEmpty(checkType, extendsType)) return getSimplifiedType(falseType2, writing);
            }
            return type;
        }
        function isIntersectionEmpty(type1, type2) {
            return !!(getUnionType([
                intersectTypes(type1, type2),
                neverType
            ]).flags & 131072 /* Never */ );
        }
        function substituteIndexedMappedType(objectType, index) {
            const mapper = createTypeMapper([
                getTypeParameterFromMappedType(objectType)
            ], [
                index
            ]);
            const templateMapper = combineTypeMappers(objectType.mapper, mapper);
            const instantiatedTemplateType = instantiateType(getTemplateTypeFromMappedType(objectType.target || objectType), templateMapper);
            const isOptional = getMappedTypeOptionality(objectType) > 0 || (isGenericType(objectType) ? getCombinedMappedTypeOptionality(getModifiersTypeFromMappedType(objectType)) > 0 : couldAccessOptionalProperty(objectType, index));
            return addOptionality(instantiatedTemplateType, /*isProperty*/ true, isOptional);
        }
        function couldAccessOptionalProperty(objectType, indexType) {
            const indexConstraint = getBaseConstraintOfType(indexType);
            return !!indexConstraint && some(getPropertiesOfType(objectType), (p)=>!!(p.flags & 16777216 /* Optional */ ) && isTypeAssignableTo(getLiteralTypeFromProperty(p, 8576 /* StringOrNumberLiteralOrUnique */ ), indexConstraint));
        }
        function getIndexedAccessType(objectType, indexType, accessFlags = 0 /* None */ , accessNode, aliasSymbol, aliasTypeArguments) {
            return getIndexedAccessTypeOrUndefined(objectType, indexType, accessFlags, accessNode, aliasSymbol, aliasTypeArguments) || (accessNode ? errorType : unknownType);
        }
        function indexTypeLessThan(indexType, limit) {
            return everyType(indexType, (t)=>{
                if (t.flags & 384 /* StringOrNumberLiteral */ ) {
                    const propName = getPropertyNameFromType(t);
                    if (isNumericLiteralName(propName)) {
                        const index = +propName;
                        return index >= 0 && index < limit;
                    }
                }
                return false;
            });
        }
        function getIndexedAccessTypeOrUndefined(objectType, indexType, accessFlags = 0 /* None */ , accessNode, aliasSymbol, aliasTypeArguments) {
            if (objectType === wildcardType || indexType === wildcardType) return wildcardType;
            objectType = getReducedType(objectType);
            if (isStringIndexSignatureOnlyType(objectType) && !(indexType.flags & 98304 /* Nullable */ ) && isTypeAssignableToKind(indexType, 12 /* Number */ )) indexType = stringType;
            if (compilerOptions.noUncheckedIndexedAccess && accessFlags & 32 /* ExpressionPosition */ ) accessFlags |= 1 /* IncludeUndefined */ ;
            if (isGenericIndexType(indexType) || (accessNode && accessNode.kind !== 200 /* IndexedAccessType */  ? isGenericTupleType(objectType) && !indexTypeLessThan(indexType, getTotalFixedElementCount(objectType.target)) : isGenericObjectType(objectType) && !(isTupleType(objectType) && indexTypeLessThan(indexType, getTotalFixedElementCount(objectType.target))) || isGenericReducibleType(objectType))) {
                if (objectType.flags & 3 /* AnyOrUnknown */ ) return objectType;
                const persistentAccessFlags = accessFlags & 1 /* Persistent */ ;
                const id = objectType.id + "," + indexType.id + "," + persistentAccessFlags + getAliasId(aliasSymbol, aliasTypeArguments);
                let type = indexedAccessTypes.get(id);
                if (!type) indexedAccessTypes.set(id, type = createIndexedAccessType(objectType, indexType, persistentAccessFlags, aliasSymbol, aliasTypeArguments));
                return type;
            }
            const apparentObjectType = getReducedApparentType(objectType);
            if (indexType.flags & 1048576 /* Union */  && !(indexType.flags & 16 /* Boolean */ )) {
                const propTypes = [];
                let wasMissingProp = false;
                for (const t of indexType.types){
                    const propType = getPropertyTypeForIndexType(objectType, apparentObjectType, t, indexType, accessNode, accessFlags | (wasMissingProp ? 128 /* SuppressNoImplicitAnyError */  : 0));
                    if (propType) propTypes.push(propType);
                    else if (!accessNode) return void 0;
                    else wasMissingProp = true;
                }
                if (wasMissingProp) return void 0;
                return accessFlags & 4 /* Writing */  ? getIntersectionType(propTypes, 0 /* None */ , aliasSymbol, aliasTypeArguments) : getUnionType(propTypes, 1 /* Literal */ , aliasSymbol, aliasTypeArguments);
            }
            return getPropertyTypeForIndexType(objectType, apparentObjectType, indexType, indexType, accessNode, accessFlags | 72 /* ReportDeprecated */ );
        }
        function getTypeFromIndexedAccessTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const objectType = getTypeFromTypeNode(node.objectType);
                const indexType = getTypeFromTypeNode(node.indexType);
                const potentialAlias = getAliasSymbolForTypeNode(node);
                links.resolvedType = getIndexedAccessType(objectType, indexType, 0 /* None */ , node, potentialAlias, getTypeArgumentsForAliasSymbol(potentialAlias));
            }
            return links.resolvedType;
        }
        function getTypeFromMappedTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const type = createObjectType(32 /* Mapped */ , node.symbol);
                type.declaration = node;
                type.aliasSymbol = getAliasSymbolForTypeNode(node);
                type.aliasTypeArguments = getTypeArgumentsForAliasSymbol(type.aliasSymbol);
                links.resolvedType = type;
                getConstraintTypeFromMappedType(type);
            }
            return links.resolvedType;
        }
        function getActualTypeVariable(type) {
            if (type.flags & 33554432 /* Substitution */ ) return getActualTypeVariable(type.baseType);
            if (type.flags & 8388608 /* IndexedAccess */  && (type.objectType.flags & 33554432 /* Substitution */  || type.indexType.flags & 33554432 /* Substitution */ )) return getIndexedAccessType(getActualTypeVariable(type.objectType), getActualTypeVariable(type.indexType));
            return type;
        }
        function isSimpleTupleType(node) {
            return isTupleTypeNode(node) && length(node.elements) > 0 && !some(node.elements, (e)=>isOptionalTypeNode(e) || isRestTypeNode(e) || isNamedTupleMember(e) && !!(e.questionToken || e.dotDotDotToken));
        }
        function isDeferredType(type, checkTuples) {
            return isGenericType(type) || checkTuples && isTupleType(type) && some(getElementTypes(type), isGenericType);
        }
        function getConditionalType(root, mapper, forConstraint, aliasSymbol, aliasTypeArguments) {
            let result;
            let extraTypes;
            let tailCount = 0;
            while(true){
                if (tailCount === 1e3) {
                    error2(currentNode, Diagnostics.Type_instantiation_is_excessively_deep_and_possibly_infinite);
                    return errorType;
                }
                const checkType = instantiateType(getActualTypeVariable(root.checkType), mapper);
                const extendsType = instantiateType(root.extendsType, mapper);
                if (checkType === errorType || extendsType === errorType) return errorType;
                if (checkType === wildcardType || extendsType === wildcardType) return wildcardType;
                const checkTypeNode = skipTypeParentheses(root.node.checkType);
                const extendsTypeNode = skipTypeParentheses(root.node.extendsType);
                const checkTuples = isSimpleTupleType(checkTypeNode) && isSimpleTupleType(extendsTypeNode) && length(checkTypeNode.elements) === length(extendsTypeNode.elements);
                const checkTypeDeferred = isDeferredType(checkType, checkTuples);
                let combinedMapper;
                if (root.inferTypeParameters) {
                    const context = createInferenceContext(root.inferTypeParameters, /*signature*/ void 0, 0 /* None */ );
                    if (mapper) context.nonFixingMapper = combineTypeMappers(context.nonFixingMapper, mapper);
                    if (!checkTypeDeferred) inferTypes(context.inferences, checkType, extendsType, 1536 /* AlwaysStrict */ );
                    combinedMapper = mapper ? combineTypeMappers(context.mapper, mapper) : context.mapper;
                }
                const inferredExtendsType = combinedMapper ? instantiateType(root.extendsType, combinedMapper) : extendsType;
                if (!checkTypeDeferred && !isDeferredType(inferredExtendsType, checkTuples)) {
                    if (!(inferredExtendsType.flags & 3 /* AnyOrUnknown */ ) && (checkType.flags & 1 /* Any */  || !isTypeAssignableTo(getPermissiveInstantiation(checkType), getPermissiveInstantiation(inferredExtendsType)))) {
                        if (checkType.flags & 1 /* Any */  || forConstraint && !(inferredExtendsType.flags & 131072 /* Never */ ) && someType(getPermissiveInstantiation(inferredExtendsType), (t)=>isTypeAssignableTo(t, getPermissiveInstantiation(checkType)))) (extraTypes || (extraTypes = [])).push(instantiateType(getTypeFromTypeNode(root.node.trueType), combinedMapper || mapper));
                        const falseType2 = getTypeFromTypeNode(root.node.falseType);
                        if (falseType2.flags & 16777216 /* Conditional */ ) {
                            const newRoot = falseType2.root;
                            if (newRoot.node.parent === root.node && (!newRoot.isDistributive || newRoot.checkType === root.checkType)) {
                                root = newRoot;
                                continue;
                            }
                            if (canTailRecurse(falseType2, mapper)) continue;
                        }
                        result = instantiateType(falseType2, mapper);
                        break;
                    }
                    if (inferredExtendsType.flags & 3 /* AnyOrUnknown */  || isTypeAssignableTo(getRestrictiveInstantiation(checkType), getRestrictiveInstantiation(inferredExtendsType))) {
                        const trueType2 = getTypeFromTypeNode(root.node.trueType);
                        const trueMapper = combinedMapper || mapper;
                        if (canTailRecurse(trueType2, trueMapper)) continue;
                        result = instantiateType(trueType2, trueMapper);
                        break;
                    }
                }
                result = createType(16777216 /* Conditional */ );
                result.root = root;
                result.checkType = instantiateType(root.checkType, mapper);
                result.extendsType = instantiateType(root.extendsType, mapper);
                result.mapper = mapper;
                result.combinedMapper = combinedMapper;
                result.aliasSymbol = aliasSymbol || root.aliasSymbol;
                result.aliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(root.aliasTypeArguments, mapper);
                break;
            }
            return extraTypes ? getUnionType(append(extraTypes, result)) : result;
            function canTailRecurse(newType, newMapper) {
                if (newType.flags & 16777216 /* Conditional */  && newMapper) {
                    const newRoot = newType.root;
                    if (newRoot.outerTypeParameters) {
                        const typeParamMapper = combineTypeMappers(newType.mapper, newMapper);
                        const typeArguments = map(newRoot.outerTypeParameters, (t)=>getMappedType(t, typeParamMapper));
                        const newRootMapper = createTypeMapper(newRoot.outerTypeParameters, typeArguments);
                        const newCheckType = newRoot.isDistributive ? getMappedType(newRoot.checkType, newRootMapper) : void 0;
                        if (!newCheckType || newCheckType === newRoot.checkType || !(newCheckType.flags & 1179648 /* Never */ )) {
                            root = newRoot;
                            mapper = newRootMapper;
                            aliasSymbol = void 0;
                            aliasTypeArguments = void 0;
                            if (newRoot.aliasSymbol) tailCount++;
                            return true;
                        }
                    }
                }
                return false;
            }
        }
        function getTrueTypeFromConditionalType(type) {
            return type.resolvedTrueType || (type.resolvedTrueType = instantiateType(getTypeFromTypeNode(type.root.node.trueType), type.mapper));
        }
        function getFalseTypeFromConditionalType(type) {
            return type.resolvedFalseType || (type.resolvedFalseType = instantiateType(getTypeFromTypeNode(type.root.node.falseType), type.mapper));
        }
        function getInferredTrueTypeFromConditionalType(type) {
            return type.resolvedInferredTrueType || (type.resolvedInferredTrueType = type.combinedMapper ? instantiateType(getTypeFromTypeNode(type.root.node.trueType), type.combinedMapper) : getTrueTypeFromConditionalType(type));
        }
        function getInferTypeParameters(node) {
            let result;
            if (node.locals) node.locals.forEach((symbol)=>{
                if (symbol.flags & 262144 /* TypeParameter */ ) result = append(result, getDeclaredTypeOfSymbol(symbol));
            });
            return result;
        }
        function isDistributionDependent(root) {
            return root.isDistributive && (isTypeParameterPossiblyReferenced(root.checkType, root.node.trueType) || isTypeParameterPossiblyReferenced(root.checkType, root.node.falseType));
        }
        function getTypeFromConditionalTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const checkType = getTypeFromTypeNode(node.checkType);
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                const aliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
                const allOuterTypeParameters = getOuterTypeParameters(node, /*includeThisTypes*/ true);
                const outerTypeParameters = aliasTypeArguments ? allOuterTypeParameters : filter(allOuterTypeParameters, (tp)=>isTypeParameterPossiblyReferenced(tp, node));
                const root = {
                    node,
                    checkType,
                    extendsType: getTypeFromTypeNode(node.extendsType),
                    isDistributive: !!(checkType.flags & 262144 /* TypeParameter */ ),
                    inferTypeParameters: getInferTypeParameters(node),
                    outerTypeParameters,
                    instantiations: void 0,
                    aliasSymbol,
                    aliasTypeArguments
                };
                links.resolvedType = getConditionalType(root, /*mapper*/ void 0, /*forConstraint*/ false);
                if (outerTypeParameters) {
                    root.instantiations = /* @__PURE__ */ new Map();
                    root.instantiations.set(getTypeListId(outerTypeParameters), links.resolvedType);
                }
            }
            return links.resolvedType;
        }
        function getTypeFromInferTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node.typeParameter));
            return links.resolvedType;
        }
        function getIdentifierChain(node) {
            if (isIdentifier(node)) return [
                node
            ];
            else return append(getIdentifierChain(node.left), node.right);
        }
        function getTypeFromImportTypeNode(node) {
            var _a;
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                if (!isLiteralImportTypeNode(node)) {
                    error2(node.argument, Diagnostics.String_literal_expected);
                    links.resolvedSymbol = unknownSymbol;
                    return links.resolvedType = errorType;
                }
                const targetMeaning = node.isTypeOf ? 111551 /* Value */  : node.flags & 16777216 /* JSDoc */  ? 900095 /* Type */  : 788968 /* Type */ ;
                const innerModuleSymbol = resolveExternalModuleName(node, node.argument.literal);
                if (!innerModuleSymbol) {
                    links.resolvedSymbol = unknownSymbol;
                    return links.resolvedType = errorType;
                }
                const isExportEquals = !!((_a = innerModuleSymbol.exports) == null ? void 0 : _a.get("export=" /* ExportEquals */ ));
                const moduleSymbol = resolveExternalModuleSymbol(innerModuleSymbol, /*dontResolveAlias*/ false);
                if (!nodeIsMissing(node.qualifier)) {
                    const nameStack = getIdentifierChain(node.qualifier);
                    let currentNamespace = moduleSymbol;
                    let current;
                    while(current = nameStack.shift()){
                        const meaning = nameStack.length ? 1920 /* Namespace */  : targetMeaning;
                        const mergedResolvedSymbol = getMergedSymbol(resolveSymbol(currentNamespace));
                        const symbolFromVariable = node.isTypeOf || isInJSFile(node) && isExportEquals ? getPropertyOfType(getTypeOfSymbol(mergedResolvedSymbol), current.escapedText, /*skipObjectFunctionPropertyAugment*/ false, /*includeTypeOnlyMembers*/ true) : void 0;
                        const symbolFromModule = node.isTypeOf ? void 0 : getSymbol2(getExportsOfSymbol(mergedResolvedSymbol), current.escapedText, meaning);
                        const next = symbolFromModule !== null && symbolFromModule !== void 0 ? symbolFromModule : symbolFromVariable;
                        if (!next) {
                            error2(current, Diagnostics.Namespace_0_has_no_exported_member_1, getFullyQualifiedName(currentNamespace), declarationNameToString(current));
                            return links.resolvedType = errorType;
                        }
                        getNodeLinks(current).resolvedSymbol = next;
                        getNodeLinks(current.parent).resolvedSymbol = next;
                        currentNamespace = next;
                    }
                    links.resolvedType = resolveImportSymbolType(node, links, currentNamespace, targetMeaning);
                } else if (moduleSymbol.flags & targetMeaning) links.resolvedType = resolveImportSymbolType(node, links, moduleSymbol, targetMeaning);
                else {
                    const errorMessage = targetMeaning === 111551 /* Value */  ? Diagnostics.Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here : Diagnostics.Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0;
                    error2(node, errorMessage, node.argument.literal.text);
                    links.resolvedSymbol = unknownSymbol;
                    links.resolvedType = errorType;
                }
            }
            return links.resolvedType;
        }
        function resolveImportSymbolType(node, links, symbol, meaning) {
            const resolvedSymbol = resolveSymbol(symbol);
            links.resolvedSymbol = resolvedSymbol;
            if (meaning === 111551 /* Value */ ) return getInstantiationExpressionType(getTypeOfSymbol(symbol), node);
            else return getTypeReferenceType(node, resolvedSymbol);
        }
        function getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const aliasSymbol = getAliasSymbolForTypeNode(node);
                if (!node.symbol || getMembersOfSymbol(node.symbol).size === 0 && !aliasSymbol) links.resolvedType = emptyTypeLiteralType;
                else {
                    let type = createObjectType(16 /* Anonymous */ , node.symbol);
                    type.aliasSymbol = aliasSymbol;
                    type.aliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
                    if (isJSDocTypeLiteral(node) && node.isArrayType) type = createArrayType(type);
                    links.resolvedType = type;
                }
            }
            return links.resolvedType;
        }
        function getAliasSymbolForTypeNode(node) {
            let host2 = node.parent;
            while(isParenthesizedTypeNode(host2) || isJSDocTypeExpression(host2) || isTypeOperatorNode(host2) && host2.operator === 148 /* ReadonlyKeyword */ )host2 = host2.parent;
            return isTypeAlias(host2) ? getSymbolOfDeclaration(host2) : void 0;
        }
        function getTypeArgumentsForAliasSymbol(symbol) {
            return symbol ? getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) : void 0;
        }
        function isNonGenericObjectType(type) {
            return !!(type.flags & 524288 /* Object */ ) && !isGenericMappedType(type);
        }
        function isEmptyObjectTypeOrSpreadsIntoEmptyObject(type) {
            return isEmptyObjectType(type) || !!(type.flags & 474058748 /* Index */ );
        }
        function tryMergeUnionOfObjectTypeAndEmptyObject(type, readonly) {
            if (!(type.flags & 1048576 /* Union */ )) return type;
            if (every(type.types, isEmptyObjectTypeOrSpreadsIntoEmptyObject)) return find(type.types, isEmptyObjectType) || emptyObjectType;
            const firstType = find(type.types, (t)=>!isEmptyObjectTypeOrSpreadsIntoEmptyObject(t));
            if (!firstType) return type;
            const secondType = find(type.types, (t)=>t !== firstType && !isEmptyObjectTypeOrSpreadsIntoEmptyObject(t));
            if (secondType) return type;
            return getAnonymousPartialType(firstType);
            function getAnonymousPartialType(type2) {
                const members = createSymbolTable();
                for (const prop of getPropertiesOfType(type2)){
                    if (getDeclarationModifierFlagsFromSymbol(prop) & 6 /* Protected */ ) ;
                    else if (isSpreadableProperty(prop)) {
                        const isSetonlyAccessor = prop.flags & 65536 /* SetAccessor */  && !(prop.flags & 32768 /* GetAccessor */ );
                        const flags = 16777220 /* Optional */ ;
                        const result = createSymbol(flags, prop.escapedName, getIsLateCheckFlag(prop) | (readonly ? 8 /* Readonly */  : 0));
                        result.links.type = isSetonlyAccessor ? undefinedType : addOptionality(getTypeOfSymbol(prop), /*isProperty*/ true);
                        result.declarations = prop.declarations;
                        result.links.nameType = getSymbolLinks(prop).nameType;
                        result.links.syntheticOrigin = prop;
                        members.set(prop.escapedName, result);
                    }
                }
                const spread = createAnonymousType(type2.symbol, members, emptyArray, emptyArray, getIndexInfosOfType(type2));
                spread.objectFlags |= 131200 /* ContainsObjectOrArrayLiteral */ ;
                return spread;
            }
        }
        function getSpreadType(left, right, symbol, objectFlags, readonly) {
            if (left.flags & 1 /* Any */  || right.flags & 1 /* Any */ ) return anyType;
            if (left.flags & 2 /* Unknown */  || right.flags & 2 /* Unknown */ ) return unknownType;
            if (left.flags & 131072 /* Never */ ) return right;
            if (right.flags & 131072 /* Never */ ) return left;
            left = tryMergeUnionOfObjectTypeAndEmptyObject(left, readonly);
            if (left.flags & 1048576 /* Union */ ) return checkCrossProductUnion([
                left,
                right
            ]) ? mapType(left, (t)=>getSpreadType(t, right, symbol, objectFlags, readonly)) : errorType;
            right = tryMergeUnionOfObjectTypeAndEmptyObject(right, readonly);
            if (right.flags & 1048576 /* Union */ ) return checkCrossProductUnion([
                left,
                right
            ]) ? mapType(right, (t)=>getSpreadType(left, t, symbol, objectFlags, readonly)) : errorType;
            if (right.flags & 473960444 /* Index */ ) return left;
            if (isGenericObjectType(left) || isGenericObjectType(right)) {
                if (isEmptyObjectType(left)) return right;
                if (left.flags & 2097152 /* Intersection */ ) {
                    const types = left.types;
                    const lastLeft = types[types.length - 1];
                    if (isNonGenericObjectType(lastLeft) && isNonGenericObjectType(right)) return getIntersectionType(concatenate(types.slice(0, types.length - 1), [
                        getSpreadType(lastLeft, right, symbol, objectFlags, readonly)
                    ]));
                }
                return getIntersectionType([
                    left,
                    right
                ]);
            }
            const members = createSymbolTable();
            const skippedPrivateMembers = /* @__PURE__ */ new Set();
            const indexInfos = left === emptyObjectType ? getIndexInfosOfType(right) : getUnionIndexInfos([
                left,
                right
            ]);
            for (const rightProp of getPropertiesOfType(right)){
                if (getDeclarationModifierFlagsFromSymbol(rightProp) & 6 /* Protected */ ) skippedPrivateMembers.add(rightProp.escapedName);
                else if (isSpreadableProperty(rightProp)) members.set(rightProp.escapedName, getSpreadSymbol(rightProp, readonly));
            }
            for (const leftProp of getPropertiesOfType(left)){
                if (skippedPrivateMembers.has(leftProp.escapedName) || !isSpreadableProperty(leftProp)) continue;
                if (members.has(leftProp.escapedName)) {
                    const rightProp = members.get(leftProp.escapedName);
                    const rightType = getTypeOfSymbol(rightProp);
                    if (rightProp.flags & 16777216 /* Optional */ ) {
                        const declarations = concatenate(leftProp.declarations, rightProp.declarations);
                        const flags = 4 /* Property */  | leftProp.flags & 16777216 /* Optional */ ;
                        const result = createSymbol(flags, leftProp.escapedName);
                        const leftType = getTypeOfSymbol(leftProp);
                        const leftTypeWithoutUndefined = removeMissingOrUndefinedType(leftType);
                        const rightTypeWithoutUndefined = removeMissingOrUndefinedType(rightType);
                        result.links.type = leftTypeWithoutUndefined === rightTypeWithoutUndefined ? leftType : getUnionType([
                            leftType,
                            rightTypeWithoutUndefined
                        ], 2 /* Subtype */ );
                        result.links.leftSpread = leftProp;
                        result.links.rightSpread = rightProp;
                        result.declarations = declarations;
                        result.links.nameType = getSymbolLinks(leftProp).nameType;
                        members.set(leftProp.escapedName, result);
                    }
                } else members.set(leftProp.escapedName, getSpreadSymbol(leftProp, readonly));
            }
            const spread = createAnonymousType(symbol, members, emptyArray, emptyArray, sameMap(indexInfos, (info)=>getIndexInfoWithReadonly(info, readonly)));
            spread.objectFlags |= 2228352 /* ContainsSpread */  | objectFlags;
            return spread;
        }
        function isSpreadableProperty(prop) {
            var _a;
            return !some(prop.declarations, isPrivateIdentifierClassElementDeclaration) && (!(prop.flags & 106496 /* SetAccessor */ ) || !((_a = prop.declarations) == null ? void 0 : _a.some((decl)=>isClassLike(decl.parent))));
        }
        function getSpreadSymbol(prop, readonly) {
            const isSetonlyAccessor = prop.flags & 65536 /* SetAccessor */  && !(prop.flags & 32768 /* GetAccessor */ );
            if (!isSetonlyAccessor && readonly === isReadonlySymbol(prop)) return prop;
            const flags = 4 /* Property */  | prop.flags & 16777216 /* Optional */ ;
            const result = createSymbol(flags, prop.escapedName, getIsLateCheckFlag(prop) | (readonly ? 8 /* Readonly */  : 0));
            result.links.type = isSetonlyAccessor ? undefinedType : getTypeOfSymbol(prop);
            result.declarations = prop.declarations;
            result.links.nameType = getSymbolLinks(prop).nameType;
            result.links.syntheticOrigin = prop;
            return result;
        }
        function getIndexInfoWithReadonly(info, readonly) {
            return info.isReadonly !== readonly ? createIndexInfo(info.keyType, info.type, readonly, info.declaration, info.components) : info;
        }
        function createLiteralType(flags, value1, symbol, regularType) {
            const type = createTypeWithSymbol(flags, symbol);
            type.value = value1;
            type.regularType = regularType || type;
            return type;
        }
        function getFreshTypeOfLiteralType(type) {
            if (type.flags & 2976 /* Freshable */ ) {
                if (!type.freshType) {
                    const freshType = createLiteralType(type.flags, type.value, type.symbol, type);
                    freshType.freshType = freshType;
                    type.freshType = freshType;
                }
                return type.freshType;
            }
            return type;
        }
        function getRegularTypeOfLiteralType(type) {
            return type.flags & 2976 /* Freshable */  ? type.regularType : type.flags & 1048576 /* Union */  ? type.regularType || (type.regularType = mapType(type, getRegularTypeOfLiteralType)) : type;
        }
        function isFreshLiteralType(type) {
            return !!(type.flags & 2976 /* Freshable */ ) && type.freshType === type;
        }
        function getStringLiteralType(value1) {
            let type;
            return stringLiteralTypes.get(value1) || (stringLiteralTypes.set(value1, type = createLiteralType(128 /* StringLiteral */ , value1)), type);
        }
        function getNumberLiteralType(value1) {
            let type;
            return numberLiteralTypes.get(value1) || (numberLiteralTypes.set(value1, type = createLiteralType(256 /* NumberLiteral */ , value1)), type);
        }
        function getBigIntLiteralType(value1) {
            let type;
            const key = pseudoBigIntToString(value1);
            return bigIntLiteralTypes.get(key) || (bigIntLiteralTypes.set(key, type = createLiteralType(2048 /* BigIntLiteral */ , value1)), type);
        }
        function getEnumLiteralType(value1, enumId, symbol) {
            let type;
            const key = `${enumId}${typeof value1 === "string" ? "@" : "#"}${value1}`;
            const flags = 1024 /* EnumLiteral */  | (typeof value1 === "string" ? 128 /* StringLiteral */  : 256 /* NumberLiteral */ );
            return enumLiteralTypes.get(key) || (enumLiteralTypes.set(key, type = createLiteralType(flags, value1, symbol)), type);
        }
        function getTypeFromLiteralTypeNode(node) {
            if (node.literal.kind === 106 /* NullKeyword */ ) return nullType;
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getRegularTypeOfLiteralType(checkExpression(node.literal));
            return links.resolvedType;
        }
        function createUniqueESSymbolType(symbol) {
            const type = createTypeWithSymbol(8192 /* UniqueESSymbol */ , symbol);
            type.escapedName = `__@${type.symbol.escapedName}@${getSymbolId(type.symbol)}`;
            return type;
        }
        function getESSymbolLikeTypeForNode(node) {
            if (isInJSFile(node) && isJSDocTypeExpression(node)) {
                const host2 = getJSDocHost(node);
                if (host2) node = getSingleVariableOfVariableStatement(host2) || host2;
            }
            if (isValidESSymbolDeclaration(node)) {
                const symbol = isCommonJsExportPropertyAssignment(node) ? getSymbolOfNode(node.left) : getSymbolOfNode(node);
                if (symbol) {
                    const links = getSymbolLinks(symbol);
                    return links.uniqueESSymbolType || (links.uniqueESSymbolType = createUniqueESSymbolType(symbol));
                }
            }
            return esSymbolType;
        }
        function getThisType(node) {
            const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            const parent2 = container && container.parent;
            if (parent2 && (isClassLike(parent2) || parent2.kind === 265 /* InterfaceDeclaration */ )) {
                if (!isStatic(container) && (!isConstructorDeclaration(container) || isNodeDescendantOf(node, container.body))) return getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(parent2)).thisType;
            }
            if (parent2 && isObjectLiteralExpression(parent2) && isBinaryExpression(parent2.parent) && getAssignmentDeclarationKind(parent2.parent) === 6 /* Prototype */ ) return getDeclaredTypeOfClassOrInterface(getSymbolOfNode(parent2.parent.left).parent).thisType;
            const host2 = node.flags & 16777216 /* JSDoc */  ? getHostSignatureFromJSDoc(node) : void 0;
            if (host2 && isFunctionExpression(host2) && isBinaryExpression(host2.parent) && getAssignmentDeclarationKind(host2.parent) === 3 /* PrototypeProperty */ ) return getDeclaredTypeOfClassOrInterface(getSymbolOfNode(host2.parent.left).parent).thisType;
            if (isJSConstructor(container) && isNodeDescendantOf(node, container.body)) return getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(container)).thisType;
            error2(node, Diagnostics.A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface);
            return errorType;
        }
        function getTypeFromThisTypeNode(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedType) links.resolvedType = getThisType(node);
            return links.resolvedType;
        }
        function getTypeFromRestTypeNode(node) {
            return getTypeFromTypeNode(getArrayElementTypeNode(node.type) || node.type);
        }
        function getArrayElementTypeNode(node) {
            switch(node.kind){
                case 197 /* ParenthesizedType */ :
                    return getArrayElementTypeNode(node.type);
                case 190 /* TupleType */ :
                    if (node.elements.length === 1) {
                        node = node.elements[0];
                        if (node.kind === 192 /* RestType */  || node.kind === 203 /* NamedTupleMember */  && node.dotDotDotToken) return getArrayElementTypeNode(node.type);
                    }
                    break;
                case 189 /* ArrayType */ :
                    return node.elementType;
            }
            return void 0;
        }
        function getTypeFromNamedTupleTypeNode(node) {
            const links = getNodeLinks(node);
            return links.resolvedType || (links.resolvedType = node.dotDotDotToken ? getTypeFromRestTypeNode(node) : addOptionality(getTypeFromTypeNode(node.type), /*isProperty*/ true, !!node.questionToken));
        }
        function getTypeFromTypeNode(node) {
            return getConditionalFlowTypeOfType(getTypeFromTypeNodeWorker(node), node);
        }
        function getTypeFromTypeNodeWorker(node) {
            switch(node.kind){
                case 133 /* AnyKeyword */ :
                case 313 /* JSDocAllType */ :
                case 314 /* JSDocUnknownType */ :
                    return anyType;
                case 159 /* UnknownKeyword */ :
                    return unknownType;
                case 154 /* StringKeyword */ :
                    return stringType;
                case 150 /* NumberKeyword */ :
                    return numberType;
                case 163 /* BigIntKeyword */ :
                    return bigintType;
                case 136 /* BooleanKeyword */ :
                    return booleanType;
                case 155 /* SymbolKeyword */ :
                    return esSymbolType;
                case 116 /* VoidKeyword */ :
                    return voidType;
                case 157 /* UndefinedKeyword */ :
                    return undefinedType;
                case 106 /* NullKeyword */ :
                    return nullType;
                case 146 /* NeverKeyword */ :
                    return neverType;
                case 151 /* ObjectKeyword */ :
                    return node.flags & 524288 /* JavaScriptFile */  && !noImplicitAny ? anyType : nonPrimitiveType;
                case 141 /* IntrinsicKeyword */ :
                    return intrinsicMarkerType;
                case 198 /* ThisType */ :
                case 110 /* ThisKeyword */ :
                    return getTypeFromThisTypeNode(node);
                case 202 /* LiteralType */ :
                    return getTypeFromLiteralTypeNode(node);
                case 184 /* TypeReference */ :
                    return getTypeFromTypeReference(node);
                case 183 /* TypePredicate */ :
                    return node.assertsModifier ? voidType : booleanType;
                case 234 /* ExpressionWithTypeArguments */ :
                    return getTypeFromTypeReference(node);
                case 187 /* TypeQuery */ :
                    return getTypeFromTypeQueryNode(node);
                case 189 /* ArrayType */ :
                case 190 /* TupleType */ :
                    return getTypeFromArrayOrTupleTypeNode(node);
                case 191 /* OptionalType */ :
                    return getTypeFromOptionalTypeNode(node);
                case 193 /* UnionType */ :
                    return getTypeFromUnionTypeNode(node);
                case 194 /* IntersectionType */ :
                    return getTypeFromIntersectionTypeNode(node);
                case 315 /* JSDocNullableType */ :
                    return getTypeFromJSDocNullableTypeNode(node);
                case 317 /* JSDocOptionalType */ :
                    return addOptionality(getTypeFromTypeNode(node.type));
                case 203 /* NamedTupleMember */ :
                    return getTypeFromNamedTupleTypeNode(node);
                case 197 /* ParenthesizedType */ :
                case 316 /* JSDocNonNullableType */ :
                case 310 /* JSDocTypeExpression */ :
                    return getTypeFromTypeNode(node.type);
                case 192 /* RestType */ :
                    return getTypeFromRestTypeNode(node);
                case 319 /* JSDocVariadicType */ :
                    return getTypeFromJSDocVariadicType(node);
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                case 188 /* TypeLiteral */ :
                case 323 /* JSDocTypeLiteral */ :
                case 318 /* JSDocFunctionType */ :
                case 324 /* JSDocSignature */ :
                    return getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
                case 199 /* TypeOperator */ :
                    return getTypeFromTypeOperatorNode(node);
                case 200 /* IndexedAccessType */ :
                    return getTypeFromIndexedAccessTypeNode(node);
                case 201 /* MappedType */ :
                    return getTypeFromMappedTypeNode(node);
                case 195 /* ConditionalType */ :
                    return getTypeFromConditionalTypeNode(node);
                case 196 /* InferType */ :
                    return getTypeFromInferTypeNode(node);
                case 204 /* TemplateLiteralType */ :
                    return getTypeFromTemplateTypeNode(node);
                case 206 /* ImportType */ :
                    return getTypeFromImportTypeNode(node);
                // This function assumes that an identifier, qualified name, or property access expression is a type expression
                // Callers should first ensure this by calling `isPartOfTypeNode`
                // TODO(rbuckton): These aren't valid TypeNodes, but we treat them as such because of `isPartOfTypeNode`, which returns `true` for things that aren't `TypeNode`s.
                case 80 /* Identifier */ :
                case 167 /* QualifiedName */ :
                case 212 /* PropertyAccessExpression */ :
                    const symbol = getSymbolAtLocation(node);
                    return symbol ? getDeclaredTypeOfSymbol(symbol) : errorType;
                default:
                    return errorType;
            }
        }
        function instantiateList(items, mapper, instantiator) {
            if (items && items.length) for(let i = 0; i < items.length; i++){
                const item = items[i];
                const mapped = instantiator(item, mapper);
                if (item !== mapped) {
                    const result = i === 0 ? [] : items.slice(0, i);
                    result.push(mapped);
                    for(i++; i < items.length; i++)result.push(instantiator(items[i], mapper));
                    return result;
                }
            }
            return items;
        }
        function instantiateTypes(types, mapper) {
            return instantiateList(types, mapper, instantiateType);
        }
        function instantiateSignatures(signatures, mapper) {
            return instantiateList(signatures, mapper, instantiateSignature);
        }
        function instantiateIndexInfos(indexInfos, mapper) {
            return instantiateList(indexInfos, mapper, instantiateIndexInfo);
        }
        function createTypeMapper(sources, targets) {
            return sources.length === 1 ? makeUnaryTypeMapper(sources[0], targets ? targets[0] : anyType) : makeArrayTypeMapper(sources, targets);
        }
        function getMappedType(type, mapper) {
            switch(mapper.kind){
                case 0 /* Simple */ :
                    return type === mapper.source ? mapper.target : type;
                case 1 /* Array */ :
                    {
                        const sources = mapper.sources;
                        const targets = mapper.targets;
                        for(let i = 0; i < sources.length; i++){
                            if (type === sources[i]) return targets ? targets[i] : anyType;
                        }
                        return type;
                    }
                case 2 /* Deferred */ :
                    {
                        const sources = mapper.sources;
                        const targets = mapper.targets;
                        for(let i = 0; i < sources.length; i++){
                            if (type === sources[i]) return targets[i]();
                        }
                        return type;
                    }
                case 3 /* Function */ :
                    return mapper.func(type);
                case 4 /* Composite */ :
                case 5 /* Merged */ :
                    const t1 = getMappedType(type, mapper.mapper1);
                    return t1 !== type && mapper.kind === 4 /* Composite */  ? instantiateType(t1, mapper.mapper2) : getMappedType(t1, mapper.mapper2);
            }
        }
        function makeUnaryTypeMapper(source, target) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 0 /* Simple */ ,
                source,
                target
            });
        }
        function makeArrayTypeMapper(sources, targets) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 1 /* Array */ ,
                sources,
                targets
            });
        }
        function makeFunctionTypeMapper(func, debugInfo) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 3 /* Function */ ,
                func,
                debugInfo: Debug.isDebugging ? debugInfo : void 0
            });
        }
        function makeDeferredTypeMapper(sources, targets) {
            return Debug.attachDebugPrototypeIfDebug({
                kind: 2 /* Deferred */ ,
                sources,
                targets
            });
        }
        function makeCompositeTypeMapper(kind, mapper1, mapper2) {
            return Debug.attachDebugPrototypeIfDebug({
                kind,
                mapper1,
                mapper2
            });
        }
        function createTypeEraser(sources) {
            return createTypeMapper(sources, /*targets*/ void 0);
        }
        function createBackreferenceMapper(context, index) {
            const forwardInferences = context.inferences.slice(index);
            return createTypeMapper(map(forwardInferences, (i)=>i.typeParameter), map(forwardInferences, ()=>unknownType));
        }
        function createOuterReturnMapper(context) {
            var _context_outerReturnMapper;
            return (_context_outerReturnMapper = context.outerReturnMapper) !== null && _context_outerReturnMapper !== void 0 ? _context_outerReturnMapper : context.outerReturnMapper = mergeTypeMappers(context.returnMapper, cloneInferenceContext(context).mapper);
        }
        function combineTypeMappers(mapper1, mapper2) {
            return mapper1 ? makeCompositeTypeMapper(4 /* Composite */ , mapper1, mapper2) : mapper2;
        }
        function mergeTypeMappers(mapper1, mapper2) {
            return mapper1 ? makeCompositeTypeMapper(5 /* Merged */ , mapper1, mapper2) : mapper2;
        }
        function prependTypeMapping(source, target, mapper) {
            return !mapper ? makeUnaryTypeMapper(source, target) : makeCompositeTypeMapper(5 /* Merged */ , makeUnaryTypeMapper(source, target), mapper);
        }
        function appendTypeMapping(mapper, source, target) {
            return !mapper ? makeUnaryTypeMapper(source, target) : makeCompositeTypeMapper(5 /* Merged */ , mapper, makeUnaryTypeMapper(source, target));
        }
        function getRestrictiveTypeParameter(tp) {
            return !tp.constraint && !getConstraintDeclaration(tp) || tp.constraint === noConstraintType ? tp : tp.restrictiveInstantiation || (tp.restrictiveInstantiation = createTypeParameter(tp.symbol), tp.restrictiveInstantiation.constraint = noConstraintType, tp.restrictiveInstantiation);
        }
        function cloneTypeParameter(typeParameter) {
            const result = createTypeParameter(typeParameter.symbol);
            result.target = typeParameter;
            return result;
        }
        function instantiateTypePredicate(predicate, mapper) {
            return createTypePredicate(predicate.kind, predicate.parameterName, predicate.parameterIndex, instantiateType(predicate.type, mapper));
        }
        function instantiateSignature(signature, mapper, eraseTypeParameters) {
            let freshTypeParameters;
            if (signature.typeParameters && !eraseTypeParameters) {
                freshTypeParameters = map(signature.typeParameters, cloneTypeParameter);
                mapper = combineTypeMappers(createTypeMapper(signature.typeParameters, freshTypeParameters), mapper);
                for (const tp of freshTypeParameters)tp.mapper = mapper;
            }
            const result = createSignature(signature.declaration, freshTypeParameters, signature.thisParameter && instantiateSymbol(signature.thisParameter, mapper), instantiateList(signature.parameters, mapper, instantiateSymbol), /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, signature.minArgumentCount, signature.flags & 167 /* PropagatingFlags */ );
            result.target = signature;
            result.mapper = mapper;
            return result;
        }
        function instantiateSymbol(symbol, mapper) {
            const links = getSymbolLinks(symbol);
            if (links.type && !couldContainTypeVariables(links.type)) {
                if (!(symbol.flags & 65536 /* SetAccessor */ )) return symbol;
                if (links.writeType && !couldContainTypeVariables(links.writeType)) return symbol;
            }
            if (getCheckFlags(symbol) & 1 /* Instantiated */ ) {
                symbol = links.target;
                mapper = combineTypeMappers(links.mapper, mapper);
            }
            const result = createSymbol(symbol.flags, symbol.escapedName, 1 /* Instantiated */  | getCheckFlags(symbol) & 53256 /* RestParameter */ );
            result.declarations = symbol.declarations;
            result.parent = symbol.parent;
            result.links.target = symbol;
            result.links.mapper = mapper;
            if (symbol.valueDeclaration) result.valueDeclaration = symbol.valueDeclaration;
            if (links.nameType) result.links.nameType = links.nameType;
            return result;
        }
        function getObjectTypeInstantiation(type, mapper, aliasSymbol, aliasTypeArguments) {
            const declaration = type.objectFlags & 4 /* Reference */  ? type.node : type.objectFlags & 8388608 /* InstantiationExpressionType */  ? type.node : type.symbol.declarations[0];
            const links = getNodeLinks(declaration);
            const target = type.objectFlags & 4 /* Reference */  ? links.resolvedType : type.objectFlags & 64 /* Instantiated */  ? type.target : type;
            let typeParameters = links.outerTypeParameters;
            if (!typeParameters) {
                let outerTypeParameters = getOuterTypeParameters(declaration, /*includeThisTypes*/ true);
                if (isJSConstructor(declaration)) {
                    const templateTagParameters = getTypeParametersFromDeclaration(declaration);
                    outerTypeParameters = addRange(outerTypeParameters, templateTagParameters);
                }
                typeParameters = outerTypeParameters || emptyArray;
                const allDeclarations = type.objectFlags & 8388612 /* InstantiationExpressionType */  ? [
                    declaration
                ] : type.symbol.declarations;
                typeParameters = (target.objectFlags & 8388612 /* InstantiationExpressionType */  || target.symbol.flags & 8192 /* Method */  || target.symbol.flags & 2048 /* TypeLiteral */ ) && !target.aliasTypeArguments ? filter(typeParameters, (tp)=>some(allDeclarations, (d)=>isTypeParameterPossiblyReferenced(tp, d))) : typeParameters;
                links.outerTypeParameters = typeParameters;
            }
            if (typeParameters.length) {
                const combinedMapper = combineTypeMappers(type.mapper, mapper);
                const typeArguments = map(typeParameters, (t)=>getMappedType(t, combinedMapper));
                const newAliasSymbol = aliasSymbol || type.aliasSymbol;
                const newAliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
                const id = getTypeListId(typeArguments) + getAliasId(newAliasSymbol, newAliasTypeArguments);
                if (!target.instantiations) {
                    target.instantiations = /* @__PURE__ */ new Map();
                    target.instantiations.set(getTypeListId(typeParameters) + getAliasId(target.aliasSymbol, target.aliasTypeArguments), target);
                }
                let result = target.instantiations.get(id);
                if (!result) {
                    let newMapper = createTypeMapper(typeParameters, typeArguments);
                    if (target.objectFlags & 134217728 /* SingleSignatureType */  && mapper) newMapper = combineTypeMappers(newMapper, mapper);
                    result = target.objectFlags & 4 /* Reference */  ? createDeferredTypeReference(type.target, type.node, newMapper, newAliasSymbol, newAliasTypeArguments) : target.objectFlags & 32 /* Mapped */  ? instantiateMappedType(target, newMapper, newAliasSymbol, newAliasTypeArguments) : instantiateAnonymousType(target, newMapper, newAliasSymbol, newAliasTypeArguments);
                    target.instantiations.set(id, result);
                    const resultObjectFlags = getObjectFlags(result);
                    if (result.flags & 3899393 /* ObjectFlagsType */  && !(resultObjectFlags & 524288 /* CouldContainTypeVariablesComputed */ )) {
                        const resultCouldContainTypeVariables = some(typeArguments, couldContainTypeVariables);
                        if (!(getObjectFlags(result) & 524288 /* CouldContainTypeVariablesComputed */ )) {
                            if (resultObjectFlags & 52 /* Reference */ ) result.objectFlags |= 524288 /* CouldContainTypeVariablesComputed */  | (resultCouldContainTypeVariables ? 1048576 /* CouldContainTypeVariables */  : 0);
                            else result.objectFlags |= !resultCouldContainTypeVariables ? 524288 /* CouldContainTypeVariablesComputed */  : 0;
                        }
                    }
                }
                return result;
            }
            return type;
        }
        function maybeTypeParameterReference(node) {
            return !(node.parent.kind === 184 /* TypeReference */  && node.parent.typeArguments && node === node.parent.typeName || node.parent.kind === 206 /* ImportType */  && node.parent.typeArguments && node === node.parent.qualifier);
        }
        function isTypeParameterPossiblyReferenced(tp, node) {
            if (tp.symbol && tp.symbol.declarations && tp.symbol.declarations.length === 1) {
                const container = tp.symbol.declarations[0].parent;
                for(let n = node; n !== container; n = n.parent){
                    if (!n || n.kind === 242 /* Block */  || n.kind === 195 /* ConditionalType */  && forEachChild(n.extendsType, containsReference)) return true;
                }
                return containsReference(node);
            }
            return true;
            function containsReference(node2) {
                switch(node2.kind){
                    case 198 /* ThisType */ :
                        return !!tp.isThisType;
                    case 80 /* Identifier */ :
                        return !tp.isThisType && isPartOfTypeNode(node2) && maybeTypeParameterReference(node2) && getTypeFromTypeNodeWorker(node2) === tp;
                    // use worker because we're looking for === equality
                    case 187 /* TypeQuery */ :
                        const entityName = node2.exprName;
                        const firstIdentifier = getFirstIdentifier(entityName);
                        if (!isThisIdentifier(firstIdentifier)) {
                            const firstIdentifierSymbol = getResolvedSymbol(firstIdentifier);
                            const tpDeclaration = tp.symbol.declarations[0];
                            const tpScope = tpDeclaration.kind === 169 /* TypeParameter */  ? tpDeclaration.parent : // Type parameter is a regular type parameter, e.g. foo<T>
                            tp.isThisType ? tpDeclaration : // Type parameter is the this type, and its declaration is the class declaration.
                            void 0;
                            if (firstIdentifierSymbol.declarations && tpScope) return some(firstIdentifierSymbol.declarations, (idDecl)=>isNodeDescendantOf(idDecl, tpScope)) || some(node2.typeArguments, containsReference);
                        }
                        return true;
                    case 175 /* MethodDeclaration */ :
                    case 174 /* MethodSignature */ :
                        return !node2.type && !!node2.body || some(node2.typeParameters, containsReference) || some(node2.parameters, containsReference) || !!node2.type && containsReference(node2.type);
                }
                return !!forEachChild(node2, containsReference);
            }
        }
        function getHomomorphicTypeVariable(type) {
            const constraintType = getConstraintTypeFromMappedType(type);
            if (constraintType.flags & 4194304 /* Index */ ) {
                const typeVariable = getActualTypeVariable(constraintType.type);
                if (typeVariable.flags & 262144 /* TypeParameter */ ) return typeVariable;
            }
            return void 0;
        }
        function instantiateMappedType(type, mapper, aliasSymbol, aliasTypeArguments) {
            const typeVariable = getHomomorphicTypeVariable(type);
            if (typeVariable) {
                const mappedTypeVariable = instantiateType(typeVariable, mapper);
                if (typeVariable !== mappedTypeVariable) return mapTypeWithAlias(getReducedType(mappedTypeVariable), instantiateConstituent, aliasSymbol, aliasTypeArguments);
            }
            return instantiateType(getConstraintTypeFromMappedType(type), mapper) === wildcardType ? wildcardType : instantiateAnonymousType(type, mapper, aliasSymbol, aliasTypeArguments);
            function instantiateConstituent(t) {
                if (t.flags & 61603843 /* Intersection */  && t !== wildcardType && !isErrorType(t)) {
                    if (!type.declaration.nameType) {
                        let constraint;
                        if (isArrayType(t) || t.flags & 1 /* Any */  && findResolutionCycleStartIndex(typeVariable, 4 /* ImmediateBaseConstraint */ ) < 0 && (constraint = getConstraintOfTypeParameter(typeVariable)) && everyType(constraint, isArrayOrTupleType)) return instantiateMappedArrayType(t, type, prependTypeMapping(typeVariable, t, mapper));
                        if (isTupleType(t)) return instantiateMappedTupleType(t, type, typeVariable, mapper);
                        if (isArrayOrTupleOrIntersection(t)) return getIntersectionType(map(t.types, instantiateConstituent));
                    }
                    return instantiateAnonymousType(type, prependTypeMapping(typeVariable, t, mapper));
                }
                return t;
            }
        }
        function getModifiedReadonlyState(state, modifiers) {
            return modifiers & 1 /* IncludeReadonly */  ? true : modifiers & 2 /* ExcludeReadonly */  ? false : state;
        }
        function instantiateMappedTupleType(tupleType, mappedType, typeVariable, mapper) {
            const elementFlags = tupleType.target.elementFlags;
            const fixedLength = tupleType.target.fixedLength;
            const fixedMapper = fixedLength ? prependTypeMapping(typeVariable, tupleType, mapper) : mapper;
            const newElementTypes = map(getElementTypes(tupleType), (type, i)=>{
                const flags = elementFlags[i];
                var _getElementTypeOfArrayType;
                return i < fixedLength ? instantiateMappedTypeTemplate(mappedType, getStringLiteralType("" + i), !!(flags & 2 /* Optional */ ), fixedMapper) : flags & 8 /* Variadic */  ? instantiateType(mappedType, prependTypeMapping(typeVariable, type, mapper)) : (_getElementTypeOfArrayType = getElementTypeOfArrayType(instantiateType(mappedType, prependTypeMapping(typeVariable, createArrayType(type), mapper)))) !== null && _getElementTypeOfArrayType !== void 0 ? _getElementTypeOfArrayType : unknownType;
            });
            const modifiers = getMappedTypeModifiers(mappedType);
            const newElementFlags = modifiers & 4 /* IncludeOptional */  ? map(elementFlags, (f)=>f & 1 /* Required */  ? 2 /* Optional */  : f) : modifiers & 8 /* ExcludeOptional */  ? map(elementFlags, (f)=>f & 2 /* Optional */  ? 1 /* Required */  : f) : elementFlags;
            const newReadonly = getModifiedReadonlyState(tupleType.target.readonly, getMappedTypeModifiers(mappedType));
            return contains(newElementTypes, errorType) ? errorType : createTupleType(newElementTypes, newElementFlags, newReadonly, tupleType.target.labeledElementDeclarations);
        }
        function instantiateMappedArrayType(arrayType, mappedType, mapper) {
            const elementType = instantiateMappedTypeTemplate(mappedType, numberType, /*isOptional*/ true, mapper);
            return isErrorType(elementType) ? errorType : createArrayType(elementType, getModifiedReadonlyState(isReadonlyArrayType(arrayType), getMappedTypeModifiers(mappedType)));
        }
        function instantiateMappedTypeTemplate(type, key, isOptional, mapper) {
            const templateMapper = appendTypeMapping(mapper, getTypeParameterFromMappedType(type), key);
            const propType = instantiateType(getTemplateTypeFromMappedType(type.target || type), templateMapper);
            const modifiers = getMappedTypeModifiers(type);
            return strictNullChecks && modifiers & 4 /* IncludeOptional */  && !maybeTypeOfKind(propType, 49152 /* Void */ ) ? getOptionalType(propType, /*isProperty*/ true) : strictNullChecks && modifiers & 8 /* ExcludeOptional */  && isOptional ? getTypeWithFacts(propType, 524288 /* NEUndefined */ ) : propType;
        }
        function instantiateAnonymousType(type, mapper, aliasSymbol, aliasTypeArguments) {
            Debug.assert(type.symbol, "anonymous type must have symbol to be instantiated");
            const result = createObjectType(type.objectFlags & -1572865 | 64 /* Instantiated */ , type.symbol);
            if (type.objectFlags & 32 /* Mapped */ ) {
                result.declaration = type.declaration;
                const origTypeParameter = getTypeParameterFromMappedType(type);
                const freshTypeParameter = cloneTypeParameter(origTypeParameter);
                result.typeParameter = freshTypeParameter;
                mapper = combineTypeMappers(makeUnaryTypeMapper(origTypeParameter, freshTypeParameter), mapper);
                freshTypeParameter.mapper = mapper;
            }
            if (type.objectFlags & 8388608 /* InstantiationExpressionType */ ) result.node = type.node;
            result.target = type;
            result.mapper = mapper;
            result.aliasSymbol = aliasSymbol || type.aliasSymbol;
            result.aliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
            result.objectFlags |= result.aliasTypeArguments ? getPropagatingFlagsOfTypes(result.aliasTypeArguments) : 0;
            return result;
        }
        function getConditionalTypeInstantiation(type, mapper, forConstraint, aliasSymbol, aliasTypeArguments) {
            const root = type.root;
            if (root.outerTypeParameters) {
                const typeArguments = map(root.outerTypeParameters, (t)=>getMappedType(t, mapper));
                const id = (forConstraint ? "C" : "") + getTypeListId(typeArguments) + getAliasId(aliasSymbol, aliasTypeArguments);
                let result = root.instantiations.get(id);
                if (!result) {
                    const newMapper = createTypeMapper(root.outerTypeParameters, typeArguments);
                    const checkType = root.checkType;
                    const distributionType = root.isDistributive ? getReducedType(getMappedType(checkType, newMapper)) : void 0;
                    result = distributionType && checkType !== distributionType && distributionType.flags & 1179648 /* Never */  ? mapTypeWithAlias(distributionType, (t)=>getConditionalType(root, prependTypeMapping(checkType, t, newMapper), forConstraint), aliasSymbol, aliasTypeArguments) : getConditionalType(root, newMapper, forConstraint, aliasSymbol, aliasTypeArguments);
                    root.instantiations.set(id, result);
                }
                return result;
            }
            return type;
        }
        function instantiateType(type, mapper) {
            return type && mapper ? instantiateTypeWithAlias(type, mapper, /*aliasSymbol*/ void 0, /*aliasTypeArguments*/ void 0) : type;
        }
        function instantiateTypeWithAlias(type, mapper, aliasSymbol, aliasTypeArguments) {
            var _a;
            if (!couldContainTypeVariables(type)) return type;
            if (instantiationDepth === 100 || instantiationCount >= 5e6) {
                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "instantiateType_DepthLimit", {
                    typeId: type.id,
                    instantiationDepth,
                    instantiationCount
                });
                error2(currentNode, Diagnostics.Type_instantiation_is_excessively_deep_and_possibly_infinite);
                return errorType;
            }
            const index = findActiveMapper(mapper);
            if (index === -1) pushActiveMapper(mapper);
            const key = type.id + getAliasId(aliasSymbol, aliasTypeArguments);
            const mapperCache = activeTypeMappersCaches[index !== -1 ? index : activeTypeMappersCount - 1];
            const cached = mapperCache.get(key);
            if (cached) return cached;
            totalInstantiationCount++;
            instantiationCount++;
            instantiationDepth++;
            const result = instantiateTypeWorker(type, mapper, aliasSymbol, aliasTypeArguments);
            if (index === -1) popActiveMapper();
            else mapperCache.set(key, result);
            instantiationDepth--;
            return result;
        }
        function instantiateTypeWorker(type, mapper, aliasSymbol, aliasTypeArguments) {
            const flags = type.flags;
            if (flags & 262144 /* TypeParameter */ ) return getMappedType(type, mapper);
            if (flags & 524288 /* Object */ ) {
                const objectFlags = type.objectFlags;
                if (objectFlags & 52 /* Mapped */ ) {
                    if (objectFlags & 4 /* Reference */  && !type.node) {
                        const resolvedTypeArguments = type.resolvedTypeArguments;
                        const newTypeArguments = instantiateTypes(resolvedTypeArguments, mapper);
                        return newTypeArguments !== resolvedTypeArguments ? createNormalizedTypeReference(type.target, newTypeArguments) : type;
                    }
                    if (objectFlags & 1024 /* ReverseMapped */ ) return instantiateReverseMappedType(type, mapper);
                    return getObjectTypeInstantiation(type, mapper, aliasSymbol, aliasTypeArguments);
                }
                return type;
            }
            if (flags & 3145728 /* UnionOrIntersection */ ) {
                const origin = type.flags & 1048576 /* Union */  ? type.origin : void 0;
                const types = origin && origin.flags & 3145728 /* UnionOrIntersection */  ? origin.types : type.types;
                const newTypes = instantiateTypes(types, mapper);
                if (newTypes === types && aliasSymbol === type.aliasSymbol) return type;
                const newAliasSymbol = aliasSymbol || type.aliasSymbol;
                const newAliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
                return flags & 2097152 /* Intersection */  || origin && origin.flags & 2097152 /* Intersection */  ? getIntersectionType(newTypes, 0 /* None */ , newAliasSymbol, newAliasTypeArguments) : getUnionType(newTypes, 1 /* Literal */ , newAliasSymbol, newAliasTypeArguments);
            }
            if (flags & 4194304 /* Index */ ) return getIndexType(instantiateType(type.type, mapper));
            if (flags & 134217728 /* TemplateLiteral */ ) return getTemplateLiteralType(type.texts, instantiateTypes(type.types, mapper));
            if (flags & 268435456 /* StringMapping */ ) return getStringMappingType(type.symbol, instantiateType(type.type, mapper));
            if (flags & 8388608 /* IndexedAccess */ ) {
                const newAliasSymbol = aliasSymbol || type.aliasSymbol;
                const newAliasTypeArguments = aliasSymbol ? aliasTypeArguments : instantiateTypes(type.aliasTypeArguments, mapper);
                return getIndexedAccessType(instantiateType(type.objectType, mapper), instantiateType(type.indexType, mapper), type.accessFlags, /*accessNode*/ void 0, newAliasSymbol, newAliasTypeArguments);
            }
            if (flags & 16777216 /* Conditional */ ) return getConditionalTypeInstantiation(type, combineTypeMappers(type.mapper, mapper), /*forConstraint*/ false, aliasSymbol, aliasTypeArguments);
            if (flags & 33554432 /* Substitution */ ) {
                const newBaseType = instantiateType(type.baseType, mapper);
                if (isNoInferType(type)) return getNoInferType(newBaseType);
                const newConstraint = instantiateType(type.constraint, mapper);
                if (newBaseType.flags & 8650752 /* TypeVariable */  && isGenericType(newConstraint)) return getSubstitutionType(newBaseType, newConstraint);
                if (newConstraint.flags & 3 /* AnyOrUnknown */  || isTypeAssignableTo(getRestrictiveInstantiation(newBaseType), getRestrictiveInstantiation(newConstraint))) return newBaseType;
                return newBaseType.flags & 8650752 /* TypeVariable */  ? getSubstitutionType(newBaseType, newConstraint) : getIntersectionType([
                    newConstraint,
                    newBaseType
                ]);
            }
            return type;
        }
        function instantiateReverseMappedType(type, mapper) {
            const innerMappedType = instantiateType(type.mappedType, mapper);
            if (!(getObjectFlags(innerMappedType) & 32 /* Mapped */ )) return type;
            const innerIndexType = instantiateType(type.constraintType, mapper);
            if (!(innerIndexType.flags & 4194304 /* Index */ )) return type;
            const instantiated = inferTypeForHomomorphicMappedType(instantiateType(type.source, mapper), innerMappedType, innerIndexType);
            if (instantiated) return instantiated;
            return type;
        }
        function getPermissiveInstantiation(type) {
            return type.flags & 402915327 /* Never */  ? type : type.permissiveInstantiation || (type.permissiveInstantiation = instantiateType(type, permissiveMapper));
        }
        function getRestrictiveInstantiation(type) {
            if (type.flags & 402915327 /* Never */ ) return type;
            if (type.restrictiveInstantiation) return type.restrictiveInstantiation;
            type.restrictiveInstantiation = instantiateType(type, restrictiveMapper);
            type.restrictiveInstantiation.restrictiveInstantiation = type.restrictiveInstantiation;
            return type.restrictiveInstantiation;
        }
        function instantiateIndexInfo(info, mapper) {
            return createIndexInfo(info.keyType, instantiateType(info.type, mapper), info.isReadonly, info.declaration, info.components);
        }
        function isContextSensitive(node) {
            Debug.assert(node.kind !== 175 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            switch(node.kind){
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 175 /* MethodDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                    return isContextSensitiveFunctionLikeDeclaration(node);
                case 211 /* ObjectLiteralExpression */ :
                    return some(node.properties, isContextSensitive);
                case 210 /* ArrayLiteralExpression */ :
                    return some(node.elements, isContextSensitive);
                case 228 /* ConditionalExpression */ :
                    return isContextSensitive(node.whenTrue) || isContextSensitive(node.whenFalse);
                case 227 /* BinaryExpression */ :
                    return (node.operatorToken.kind === 57 /* BarBarToken */  || node.operatorToken.kind === 61 /* QuestionQuestionToken */ ) && (isContextSensitive(node.left) || isContextSensitive(node.right));
                case 304 /* PropertyAssignment */ :
                    return isContextSensitive(node.initializer);
                case 218 /* ParenthesizedExpression */ :
                    return isContextSensitive(node.expression);
                case 293 /* JsxAttributes */ :
                    return some(node.properties, isContextSensitive) || isJsxOpeningElement(node.parent) && some(node.parent.parent.children, isContextSensitive);
                case 292 /* JsxAttribute */ :
                    {
                        const { initializer } = node;
                        return !!initializer && isContextSensitive(initializer);
                    }
                case 295 /* JsxExpression */ :
                    {
                        const { expression } = node;
                        return !!expression && isContextSensitive(expression);
                    }
            }
            return false;
        }
        function isContextSensitiveFunctionLikeDeclaration(node) {
            return hasContextSensitiveParameters(node) || hasContextSensitiveReturnExpression(node);
        }
        function hasContextSensitiveReturnExpression(node) {
            if (node.typeParameters || getEffectiveReturnTypeNode(node) || !node.body) return false;
            if (node.body.kind !== 242 /* Block */ ) return isContextSensitive(node.body);
            return !!forEachReturnStatement(node.body, (statement)=>!!statement.expression && isContextSensitive(statement.expression));
        }
        function isContextSensitiveFunctionOrObjectLiteralMethod(func) {
            return (isFunctionExpressionOrArrowFunction(func) || isObjectLiteralMethod(func)) && isContextSensitiveFunctionLikeDeclaration(func);
        }
        function getTypeWithoutSignatures(type) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                if (resolved.constructSignatures.length || resolved.callSignatures.length) {
                    const result = createObjectType(16 /* Anonymous */ , type.symbol);
                    result.members = resolved.members;
                    result.properties = resolved.properties;
                    result.callSignatures = emptyArray;
                    result.constructSignatures = emptyArray;
                    result.indexInfos = emptyArray;
                    return result;
                }
            } else if (type.flags & 2097152 /* Intersection */ ) return getIntersectionType(map(type.types, getTypeWithoutSignatures));
            return type;
        }
        function isTypeIdenticalTo(source, target) {
            return isTypeRelatedTo(source, target, identityRelation);
        }
        function compareTypesIdentical(source, target) {
            return isTypeRelatedTo(source, target, identityRelation) ? -1 /* True */  : 0 /* False */ ;
        }
        function compareTypesAssignable(source, target) {
            return isTypeRelatedTo(source, target, assignableRelation) ? -1 /* True */  : 0 /* False */ ;
        }
        function compareTypesSubtypeOf(source, target) {
            return isTypeRelatedTo(source, target, subtypeRelation) ? -1 /* True */  : 0 /* False */ ;
        }
        function isTypeSubtypeOf(source, target) {
            return isTypeRelatedTo(source, target, subtypeRelation);
        }
        function isTypeStrictSubtypeOf(source, target) {
            return isTypeRelatedTo(source, target, strictSubtypeRelation);
        }
        function isTypeAssignableTo(source, target) {
            return isTypeRelatedTo(source, target, assignableRelation);
        }
        function isTypeDerivedFrom(source, target) {
            return source.flags & 1048576 /* Union */  ? every(source.types, (t)=>isTypeDerivedFrom(t, target)) : target.flags & 1048576 /* Union */  ? some(target.types, (t)=>isTypeDerivedFrom(source, t)) : source.flags & 2097152 /* Intersection */  ? some(source.types, (t)=>isTypeDerivedFrom(t, target)) : source.flags & 58982400 /* InstantiableNonPrimitive */  ? isTypeDerivedFrom(getBaseConstraintOfType(source) || unknownType, target) : isEmptyAnonymousObjectType(target) ? !!(source.flags & 67633152 /* NonPrimitive */ ) : target === globalObjectType ? !!(source.flags & 67633152 /* NonPrimitive */ ) && !isEmptyAnonymousObjectType(source) : target === globalFunctionType ? !!(source.flags & 524288 /* Object */ ) && isFunctionObjectType(source) : hasBaseType(source, getTargetType(target)) || isArrayType(target) && !isReadonlyArrayType(target) && isTypeDerivedFrom(source, globalReadonlyArrayType);
        }
        function isTypeComparableTo(source, target) {
            return isTypeRelatedTo(source, target, comparableRelation);
        }
        function areTypesComparable(type1, type2) {
            return isTypeComparableTo(type1, type2) || isTypeComparableTo(type2, type1);
        }
        function checkTypeAssignableTo(source, target, errorNode, headMessage, containingMessageChain, errorOutputObject) {
            return checkTypeRelatedTo(source, target, assignableRelation, errorNode, headMessage, containingMessageChain, errorOutputObject);
        }
        function checkTypeAssignableToAndOptionallyElaborate(source, target, errorNode, expr, headMessage, containingMessageChain) {
            return checkTypeRelatedToAndOptionallyElaborate(source, target, assignableRelation, errorNode, expr, headMessage, containingMessageChain, /*errorOutputContainer*/ void 0);
        }
        function checkTypeRelatedToAndOptionallyElaborate(source, target, relation, errorNode, expr, headMessage, containingMessageChain, errorOutputContainer) {
            if (isTypeRelatedTo(source, target, relation)) return true;
            if (!errorNode || !elaborateError(expr, source, target, relation, headMessage, containingMessageChain, errorOutputContainer)) return checkTypeRelatedTo(source, target, relation, errorNode, headMessage, containingMessageChain, errorOutputContainer);
            return false;
        }
        function isOrHasGenericConditional(type) {
            return !!(type.flags & 16777216 /* Conditional */  || type.flags & 2097152 /* Intersection */  && some(type.types, isOrHasGenericConditional));
        }
        function elaborateError(node, source, target, relation, headMessage, containingMessageChain, errorOutputContainer) {
            if (!node || isOrHasGenericConditional(target)) return false;
            if (!checkTypeRelatedTo(source, target, relation, /*errorNode*/ void 0) && elaborateDidYouMeanToCallOrConstruct(node, source, target, relation, headMessage, containingMessageChain, errorOutputContainer)) return true;
            switch(node.kind){
                case 235 /* AsExpression */ :
                    if (!isConstAssertion(node)) break;
                // fallthrough
                case 295 /* JsxExpression */ :
                case 218 /* ParenthesizedExpression */ :
                    return elaborateError(node.expression, source, target, relation, headMessage, containingMessageChain, errorOutputContainer);
                case 227 /* BinaryExpression */ :
                    switch(node.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                        case 28 /* CommaToken */ :
                            return elaborateError(node.right, source, target, relation, headMessage, containingMessageChain, errorOutputContainer);
                    }
                    break;
                case 211 /* ObjectLiteralExpression */ :
                    return elaborateObjectLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer);
                case 210 /* ArrayLiteralExpression */ :
                    return elaborateArrayLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer);
                case 293 /* JsxAttributes */ :
                    return elaborateJsxComponents(node, source, target, relation, containingMessageChain, errorOutputContainer);
                case 220 /* ArrowFunction */ :
                    return elaborateArrowFunction(node, source, target, relation, containingMessageChain, errorOutputContainer);
            }
            return false;
        }
        function elaborateDidYouMeanToCallOrConstruct(node, source, target, relation, headMessage, containingMessageChain, errorOutputContainer) {
            const callSignatures = getSignaturesOfType(source, 0 /* Call */ );
            const constructSignatures = getSignaturesOfType(source, 1 /* Construct */ );
            for (const signatures of [
                constructSignatures,
                callSignatures
            ])if (some(signatures, (s)=>{
                const returnType = getReturnTypeOfSignature(s);
                return !(returnType.flags & 131073 /* Never */ ) && checkTypeRelatedTo(returnType, target, relation, /*errorNode*/ void 0);
            })) {
                const resultObj = errorOutputContainer || {};
                checkTypeAssignableTo(source, target, node, headMessage, containingMessageChain, resultObj);
                const diagnostic = resultObj.errors[resultObj.errors.length - 1];
                addRelatedInfo(diagnostic, createDiagnosticForNode(node, signatures === constructSignatures ? Diagnostics.Did_you_mean_to_use_new_with_this_expression : Diagnostics.Did_you_mean_to_call_this_expression));
                return true;
            }
            return false;
        }
        function elaborateArrowFunction(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            if (isBlock(node.body)) return false;
            if (some(node.parameters, hasType)) return false;
            const sourceSig = getSingleCallSignature(source);
            if (!sourceSig) return false;
            const targetSignatures = getSignaturesOfType(target, 0 /* Call */ );
            if (!length(targetSignatures)) return false;
            const returnExpression = node.body;
            const sourceReturn = getReturnTypeOfSignature(sourceSig);
            const targetReturn = getUnionType(map(targetSignatures, getReturnTypeOfSignature));
            if (!checkTypeRelatedTo(sourceReturn, targetReturn, relation, /*errorNode*/ void 0)) {
                const elaborated = returnExpression && elaborateError(returnExpression, sourceReturn, targetReturn, relation, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
                if (elaborated) return elaborated;
                const resultObj = errorOutputContainer || {};
                checkTypeRelatedTo(sourceReturn, targetReturn, relation, returnExpression, /*headMessage*/ void 0, containingMessageChain, resultObj);
                if (resultObj.errors) {
                    if (target.symbol && length(target.symbol.declarations)) addRelatedInfo(resultObj.errors[resultObj.errors.length - 1], createDiagnosticForNode(target.symbol.declarations[0], Diagnostics.The_expected_type_comes_from_the_return_type_of_this_signature));
                    if ((getFunctionFlags(node) & 2 /* Async */ ) === 0 && !getTypeOfPropertyOfType(sourceReturn, "then") && checkTypeRelatedTo(createPromiseType(sourceReturn), targetReturn, relation, /*errorNode*/ void 0)) addRelatedInfo(resultObj.errors[resultObj.errors.length - 1], createDiagnosticForNode(node, Diagnostics.Did_you_mean_to_mark_this_function_as_async));
                    return true;
                }
            }
            return false;
        }
        function getBestMatchIndexedAccessTypeOrUndefined(source, target, nameType) {
            const idx = getIndexedAccessTypeOrUndefined(target, nameType);
            if (idx) return idx;
            if (target.flags & 1048576 /* Union */ ) {
                const best = getBestMatchingType(source, target);
                if (best) return getIndexedAccessTypeOrUndefined(best, nameType);
            }
        }
        function checkExpressionForMutableLocationWithContextualType(next, sourcePropType) {
            pushContextualType(next, sourcePropType, /*isCache*/ false);
            const result = checkExpressionForMutableLocation(next, 1 /* Contextual */ );
            popContextualType();
            return result;
        }
        function elaborateElementwise(iterator, source, target, relation, containingMessageChain, errorOutputContainer) {
            let reportedError = false;
            for (const value1 of iterator){
                const { errorNode: prop, innerExpression: next, nameType, errorMessage } = value1;
                let targetPropType = getBestMatchIndexedAccessTypeOrUndefined(source, target, nameType);
                if (!targetPropType || targetPropType.flags & 8388608 /* IndexedAccess */ ) continue;
                let sourcePropType = getIndexedAccessTypeOrUndefined(source, nameType);
                if (!sourcePropType) continue;
                const propName = getPropertyNameFromIndex(nameType, /*accessNode*/ void 0);
                if (!checkTypeRelatedTo(sourcePropType, targetPropType, relation, /*errorNode*/ void 0)) {
                    const elaborated = next && elaborateError(next, sourcePropType, targetPropType, relation, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
                    reportedError = true;
                    if (!elaborated) {
                        const resultObj = errorOutputContainer || {};
                        const specificSource = next ? checkExpressionForMutableLocationWithContextualType(next, sourcePropType) : sourcePropType;
                        if (exactOptionalPropertyTypes && isExactOptionalPropertyMismatch(specificSource, targetPropType)) {
                            const diag2 = createDiagnosticForNode(prop, Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target, typeToString(specificSource), typeToString(targetPropType));
                            diagnostics.add(diag2);
                            resultObj.errors = [
                                diag2
                            ];
                        } else {
                            const targetIsOptional = !!(propName && (getPropertyOfType(target, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            const sourceIsOptional = !!(propName && (getPropertyOfType(source, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            targetPropType = removeMissingType(targetPropType, targetIsOptional);
                            sourcePropType = removeMissingType(sourcePropType, targetIsOptional && sourceIsOptional);
                            const result = checkTypeRelatedTo(specificSource, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                            if (result && specificSource !== sourcePropType) checkTypeRelatedTo(sourcePropType, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                        }
                        if (resultObj.errors) {
                            const reportedDiag = resultObj.errors[resultObj.errors.length - 1];
                            const propertyName = isTypeUsableAsPropertyName(nameType) ? getPropertyNameFromType(nameType) : void 0;
                            const targetProp = propertyName !== void 0 ? getPropertyOfType(target, propertyName) : void 0;
                            let issuedElaboration = false;
                            if (!targetProp) {
                                const indexInfo = getApplicableIndexInfo(target, nameType);
                                if (indexInfo && indexInfo.declaration && !getSourceFileOfNode(indexInfo.declaration).hasNoDefaultLib) {
                                    issuedElaboration = true;
                                    addRelatedInfo(reportedDiag, createDiagnosticForNode(indexInfo.declaration, Diagnostics.The_expected_type_comes_from_this_index_signature));
                                }
                            }
                            if (!issuedElaboration && (targetProp && length(targetProp.declarations) || target.symbol && length(target.symbol.declarations))) {
                                const targetNode = targetProp && length(targetProp.declarations) ? targetProp.declarations[0] : target.symbol.declarations[0];
                                if (!getSourceFileOfNode(targetNode).hasNoDefaultLib) addRelatedInfo(reportedDiag, createDiagnosticForNode(targetNode, Diagnostics.The_expected_type_comes_from_property_0_which_is_declared_here_on_type_1, propertyName && !(nameType.flags & 8192 /* UniqueESSymbol */ ) ? unescapeLeadingUnderscores(propertyName) : typeToString(nameType), typeToString(target)));
                            }
                        }
                    }
                }
            }
            return reportedError;
        }
        function elaborateIterableOrArrayLikeTargetElementwise(iterator, source, target, relation, containingMessageChain, errorOutputContainer) {
            const tupleOrArrayLikeTargetParts = filterType(target, isArrayOrTupleLikeType);
            const nonTupleOrArrayLikeTargetParts = filterType(target, (t)=>!isArrayOrTupleLikeType(t));
            const iterationType = nonTupleOrArrayLikeTargetParts !== neverType ? getIterationTypeOfIterable(13 /* ForOf */ , 0 /* Yield */ , nonTupleOrArrayLikeTargetParts, /*errorNode*/ void 0) : void 0;
            let reportedError = false;
            for(let status = iterator.next(); !status.done; status = iterator.next()){
                const { errorNode: prop, innerExpression: next, nameType, errorMessage } = status.value;
                let targetPropType = iterationType;
                const targetIndexedPropType = tupleOrArrayLikeTargetParts !== neverType ? getBestMatchIndexedAccessTypeOrUndefined(source, tupleOrArrayLikeTargetParts, nameType) : void 0;
                if (targetIndexedPropType && !(targetIndexedPropType.flags & 8388608 /* IndexedAccess */ )) targetPropType = iterationType ? getUnionType([
                    iterationType,
                    targetIndexedPropType
                ]) : targetIndexedPropType;
                if (!targetPropType) continue;
                let sourcePropType = getIndexedAccessTypeOrUndefined(source, nameType);
                if (!sourcePropType) continue;
                const propName = getPropertyNameFromIndex(nameType, /*accessNode*/ void 0);
                if (!checkTypeRelatedTo(sourcePropType, targetPropType, relation, /*errorNode*/ void 0)) {
                    const elaborated = next && elaborateError(next, sourcePropType, targetPropType, relation, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
                    reportedError = true;
                    if (!elaborated) {
                        const resultObj = errorOutputContainer || {};
                        const specificSource = next ? checkExpressionForMutableLocationWithContextualType(next, sourcePropType) : sourcePropType;
                        if (exactOptionalPropertyTypes && isExactOptionalPropertyMismatch(specificSource, targetPropType)) {
                            const diag2 = createDiagnosticForNode(prop, Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target, typeToString(specificSource), typeToString(targetPropType));
                            diagnostics.add(diag2);
                            resultObj.errors = [
                                diag2
                            ];
                        } else {
                            const targetIsOptional = !!(propName && (getPropertyOfType(tupleOrArrayLikeTargetParts, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            const sourceIsOptional = !!(propName && (getPropertyOfType(source, propName) || unknownSymbol).flags & 16777216 /* Optional */ );
                            targetPropType = removeMissingType(targetPropType, targetIsOptional);
                            sourcePropType = removeMissingType(sourcePropType, targetIsOptional && sourceIsOptional);
                            const result = checkTypeRelatedTo(specificSource, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                            if (result && specificSource !== sourcePropType) checkTypeRelatedTo(sourcePropType, targetPropType, relation, prop, errorMessage, containingMessageChain, resultObj);
                        }
                    }
                }
            }
            return reportedError;
        }
        function* generateJsxAttributes(node) {
            if (!length(node.properties)) return;
            for (const prop of node.properties){
                if (isJsxSpreadAttribute(prop) || isHyphenatedJsxName(getTextOfJsxAttributeName(prop.name))) continue;
                yield {
                    errorNode: prop.name,
                    innerExpression: prop.initializer,
                    nameType: getStringLiteralType(getTextOfJsxAttributeName(prop.name))
                };
            }
        }
        function* generateJsxChildren(node, getInvalidTextDiagnostic) {
            if (!length(node.children)) return;
            let memberOffset = 0;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                const nameType = getNumberLiteralType(i - memberOffset);
                const elem = getElaborationElementForJsxChild(child, nameType, getInvalidTextDiagnostic);
                if (elem) yield elem;
                else memberOffset++;
            }
        }
        function getElaborationElementForJsxChild(child, nameType, getInvalidTextDiagnostic) {
            switch(child.kind){
                case 295 /* JsxExpression */ :
                    return {
                        errorNode: child,
                        innerExpression: child.expression,
                        nameType
                    };
                case 12 /* JsxText */ :
                    if (child.containsOnlyTriviaWhiteSpaces) break;
                    return {
                        errorNode: child,
                        innerExpression: void 0,
                        nameType,
                        errorMessage: getInvalidTextDiagnostic()
                    };
                case 285 /* JsxElement */ :
                case 286 /* JsxSelfClosingElement */ :
                case 289 /* JsxFragment */ :
                    return {
                        errorNode: child,
                        innerExpression: child,
                        nameType
                    };
                default:
                    return Debug.assertNever(child, "Found invalid jsx child");
            }
        }
        function elaborateJsxComponents(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            let result = elaborateElementwise(generateJsxAttributes(node), source, target, relation, containingMessageChain, errorOutputContainer);
            let invalidTextDiagnostic;
            if (isJsxOpeningElement(node.parent) && isJsxElement(node.parent.parent)) {
                const containingElement = node.parent.parent;
                const childPropName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
                const childrenPropName = childPropName === void 0 ? "children" : unescapeLeadingUnderscores(childPropName);
                const childrenNameType = getStringLiteralType(childrenPropName);
                const childrenTargetType = getIndexedAccessType(target, childrenNameType);
                const validChildren = getSemanticJsxChildren(containingElement.children);
                if (!length(validChildren)) return result;
                const moreThanOneRealChildren = length(validChildren) > 1;
                let arrayLikeTargetParts;
                let nonArrayLikeTargetParts;
                const iterableType = getGlobalIterableType(/*reportErrors*/ false);
                if (iterableType !== emptyGenericType) {
                    const anyIterable = createIterableType(anyType);
                    arrayLikeTargetParts = filterType(childrenTargetType, (t)=>isTypeAssignableTo(t, anyIterable));
                    nonArrayLikeTargetParts = filterType(childrenTargetType, (t)=>!isTypeAssignableTo(t, anyIterable));
                } else {
                    arrayLikeTargetParts = filterType(childrenTargetType, isArrayOrTupleLikeType);
                    nonArrayLikeTargetParts = filterType(childrenTargetType, (t)=>!isArrayOrTupleLikeType(t));
                }
                if (moreThanOneRealChildren) {
                    if (arrayLikeTargetParts !== neverType) {
                        const realSource = createTupleType(checkJsxChildren(containingElement, 0 /* Normal */ ));
                        const children = generateJsxChildren(containingElement, getInvalidTextualChildDiagnostic);
                        result = elaborateIterableOrArrayLikeTargetElementwise(children, realSource, arrayLikeTargetParts, relation, containingMessageChain, errorOutputContainer) || result;
                    } else if (!isTypeRelatedTo(getIndexedAccessType(source, childrenNameType), childrenTargetType, relation)) {
                        result = true;
                        const diag2 = error2(containingElement.openingElement.tagName, Diagnostics.This_JSX_tag_s_0_prop_expects_a_single_child_of_type_1_but_multiple_children_were_provided, childrenPropName, typeToString(childrenTargetType));
                        if (errorOutputContainer && errorOutputContainer.skipLogging) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                    }
                } else {
                    if (nonArrayLikeTargetParts !== neverType) {
                        const child = validChildren[0];
                        const elem = getElaborationElementForJsxChild(child, childrenNameType, getInvalidTextualChildDiagnostic);
                        if (elem) result = elaborateElementwise(function*() {
                            yield elem;
                        }(), source, target, relation, containingMessageChain, errorOutputContainer) || result;
                    } else if (!isTypeRelatedTo(getIndexedAccessType(source, childrenNameType), childrenTargetType, relation)) {
                        result = true;
                        const diag2 = error2(containingElement.openingElement.tagName, Diagnostics.This_JSX_tag_s_0_prop_expects_type_1_which_requires_multiple_children_but_only_a_single_child_was_provided, childrenPropName, typeToString(childrenTargetType));
                        if (errorOutputContainer && errorOutputContainer.skipLogging) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                    }
                }
            }
            return result;
            function getInvalidTextualChildDiagnostic() {
                if (!invalidTextDiagnostic) {
                    const tagNameText = getTextOfNode(node.parent.tagName);
                    const childPropName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
                    const childrenPropName = childPropName === void 0 ? "children" : unescapeLeadingUnderscores(childPropName);
                    const childrenTargetType = getIndexedAccessType(target, getStringLiteralType(childrenPropName));
                    const diagnostic = Diagnostics._0_components_don_t_accept_text_as_child_elements_Text_in_JSX_has_the_type_string_but_the_expected_type_of_1_is_2;
                    invalidTextDiagnostic = (0, _objectSpreadProps._)((0, _objectSpread._)({}, diagnostic), {
                        key: "!!ALREADY FORMATTED!!",
                        message: formatMessage(diagnostic, tagNameText, childrenPropName, typeToString(childrenTargetType))
                    });
                }
                return invalidTextDiagnostic;
            }
        }
        function* generateLimitedTupleElements(node, target) {
            const len = length(node.elements);
            if (!len) return;
            for(let i = 0; i < len; i++){
                if (isTupleLikeType(target) && !getPropertyOfType(target, "" + i)) continue;
                const elem = node.elements[i];
                if (isOmittedExpression(elem)) continue;
                const nameType = getNumberLiteralType(i);
                const checkNode = getEffectiveCheckNode(elem);
                yield {
                    errorNode: checkNode,
                    innerExpression: checkNode,
                    nameType
                };
            }
        }
        function elaborateArrayLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            if (target.flags & 402915324 /* Never */ ) return false;
            if (isTupleLikeType(source)) return elaborateElementwise(generateLimitedTupleElements(node, target), source, target, relation, containingMessageChain, errorOutputContainer);
            pushContextualType(node, target, /*isCache*/ false);
            const tupleizedType = checkArrayLiteral(node, 1 /* Contextual */ , /*forceTuple*/ true);
            popContextualType();
            if (isTupleLikeType(tupleizedType)) return elaborateElementwise(generateLimitedTupleElements(node, target), tupleizedType, target, relation, containingMessageChain, errorOutputContainer);
            return false;
        }
        function* generateObjectLiteralElements(node) {
            if (!length(node.properties)) return;
            for (const prop of node.properties){
                if (isSpreadAssignment(prop)) continue;
                const type = getLiteralTypeFromProperty(getSymbolOfDeclaration(prop), 8576 /* StringOrNumberLiteralOrUnique */ );
                if (!type || type.flags & 131072 /* Never */ ) continue;
                switch(prop.kind){
                    case 179 /* SetAccessor */ :
                    case 178 /* GetAccessor */ :
                    case 175 /* MethodDeclaration */ :
                    case 305 /* ShorthandPropertyAssignment */ :
                        yield {
                            errorNode: prop.name,
                            innerExpression: void 0,
                            nameType: type
                        };
                        break;
                    case 304 /* PropertyAssignment */ :
                        yield {
                            errorNode: prop.name,
                            innerExpression: prop.initializer,
                            nameType: type,
                            errorMessage: isComputedNonLiteralName(prop.name) ? Diagnostics.Type_of_computed_property_s_value_is_0_which_is_not_assignable_to_type_1 : void 0
                        };
                        break;
                    default:
                        Debug.assertNever(prop);
                }
            }
        }
        function elaborateObjectLiteral(node, source, target, relation, containingMessageChain, errorOutputContainer) {
            if (target.flags & 402915324 /* Never */ ) return false;
            return elaborateElementwise(generateObjectLiteralElements(node), source, target, relation, containingMessageChain, errorOutputContainer);
        }
        function checkTypeComparableTo(source, target, errorNode, headMessage, containingMessageChain) {
            return checkTypeRelatedTo(source, target, comparableRelation, errorNode, headMessage, containingMessageChain);
        }
        function isSignatureAssignableTo(source, target, ignoreReturnTypes) {
            return compareSignaturesRelated(source, target, ignoreReturnTypes ? 4 /* IgnoreReturnTypes */  : 0 /* None */ , /*reportErrors*/ false, /*errorReporter*/ void 0, /*incompatibleErrorReporter*/ void 0, compareTypesAssignable, /*reportUnreliableMarkers*/ void 0) !== 0 /* False */ ;
        }
        function isTopSignature(s) {
            if (!s.typeParameters && (!s.thisParameter || isTypeAny(getTypeOfParameter(s.thisParameter))) && s.parameters.length === 1 && signatureHasRestParameter(s)) {
                const paramType = getTypeOfParameter(s.parameters[0]);
                const restType = isArrayType(paramType) ? getTypeArguments(paramType)[0] : paramType;
                return !!(restType.flags & 131073 /* Never */  && getReturnTypeOfSignature(s).flags & 3 /* AnyOrUnknown */ );
            }
            return false;
        }
        function compareSignaturesRelated(source, target, checkMode, reportErrors2, errorReporter, incompatibleErrorReporter, compareTypes, reportUnreliableMarkers) {
            if (source === target) return -1 /* True */ ;
            if (!(checkMode & 16 /* StrictTopSignature */  && isTopSignature(source)) && isTopSignature(target)) return -1 /* True */ ;
            if (checkMode & 16 /* StrictTopSignature */  && isTopSignature(source) && !isTopSignature(target)) return 0 /* False */ ;
            const targetCount = getParameterCount(target);
            const sourceHasMoreParameters = !hasEffectiveRestParameter(target) && (checkMode & 8 /* StrictArity */  ? hasEffectiveRestParameter(source) || getParameterCount(source) > targetCount : getMinArgumentCount(source) > targetCount);
            if (sourceHasMoreParameters) {
                if (reportErrors2 && !(checkMode & 8 /* StrictArity */ )) errorReporter(Diagnostics.Target_signature_provides_too_few_arguments_Expected_0_or_more_but_got_1, getMinArgumentCount(source), targetCount);
                return 0 /* False */ ;
            }
            if (source.typeParameters && source.typeParameters !== target.typeParameters) {
                target = getCanonicalSignature(target);
                source = instantiateSignatureInContextOf(source, target, /*inferenceContext*/ void 0, compareTypes);
            }
            const sourceCount = getParameterCount(source);
            const sourceRestType = getNonArrayRestType(source);
            const targetRestType = getNonArrayRestType(target);
            if (sourceRestType || targetRestType) instantiateType(sourceRestType || targetRestType, reportUnreliableMarkers);
            const kind = target.declaration ? target.declaration.kind : 0 /* Unknown */ ;
            const strictVariance = !(checkMode & 3 /* Callback */ ) && strictFunctionTypes && kind !== 175 /* MethodDeclaration */  && kind !== 174 /* MethodSignature */  && kind !== 177 /* Constructor */ ;
            let result = -1 /* True */ ;
            const sourceThisType = getThisTypeOfSignature(source);
            if (sourceThisType && sourceThisType !== voidType) {
                const targetThisType = getThisTypeOfSignature(target);
                if (targetThisType) {
                    const related = !strictVariance && compareTypes(sourceThisType, targetThisType, /*reportErrors*/ false) || compareTypes(targetThisType, sourceThisType, reportErrors2);
                    if (!related) {
                        if (reportErrors2) errorReporter(Diagnostics.The_this_types_of_each_signature_are_incompatible);
                        return 0 /* False */ ;
                    }
                    result &= related;
                }
            }
            const paramCount = sourceRestType || targetRestType ? Math.min(sourceCount, targetCount) : Math.max(sourceCount, targetCount);
            const restIndex = sourceRestType || targetRestType ? paramCount - 1 : -1;
            for(let i = 0; i < paramCount; i++){
                const sourceType = i === restIndex ? getRestOrAnyTypeAtPosition(source, i) : tryGetTypeAtPosition(source, i);
                const targetType = i === restIndex ? getRestOrAnyTypeAtPosition(target, i) : tryGetTypeAtPosition(target, i);
                if (sourceType && targetType && (sourceType !== targetType || checkMode & 8 /* StrictArity */ )) {
                    const sourceSig = checkMode & 3 /* Callback */  || isInstantiatedGenericParameter(source, i) ? void 0 : getSingleCallSignature(getNonNullableType(sourceType));
                    const targetSig = checkMode & 3 /* Callback */  || isInstantiatedGenericParameter(target, i) ? void 0 : getSingleCallSignature(getNonNullableType(targetType));
                    const callbacks = sourceSig && targetSig && !getTypePredicateOfSignature(sourceSig) && !getTypePredicateOfSignature(targetSig) && getTypeFacts(sourceType, 50331648 /* IsUndefinedOrNull */ ) === getTypeFacts(targetType, 50331648 /* IsUndefinedOrNull */ );
                    let related = callbacks ? compareSignaturesRelated(targetSig, sourceSig, checkMode & 8 /* StrictArity */  | (strictVariance ? 2 /* StrictCallback */  : 1 /* BivariantCallback */ ), reportErrors2, errorReporter, incompatibleErrorReporter, compareTypes, reportUnreliableMarkers) : !(checkMode & 3 /* Callback */ ) && !strictVariance && compareTypes(sourceType, targetType, /*reportErrors*/ false) || compareTypes(targetType, sourceType, reportErrors2);
                    if (related && checkMode & 8 /* StrictArity */  && i >= getMinArgumentCount(source) && i < getMinArgumentCount(target) && compareTypes(sourceType, targetType, /*reportErrors*/ false)) related = 0 /* False */ ;
                    if (!related) {
                        if (reportErrors2) errorReporter(Diagnostics.Types_of_parameters_0_and_1_are_incompatible, unescapeLeadingUnderscores(getParameterNameAtPosition(source, i)), unescapeLeadingUnderscores(getParameterNameAtPosition(target, i)));
                        return 0 /* False */ ;
                    }
                    result &= related;
                }
            }
            if (!(checkMode & 4 /* IgnoreReturnTypes */ )) {
                const targetReturnType = isResolvingReturnTypeOfSignature(target) ? anyType : target.declaration && isJSConstructor(target.declaration) ? getDeclaredTypeOfClassOrInterface(getMergedSymbol(target.declaration.symbol)) : getReturnTypeOfSignature(target);
                if (targetReturnType === voidType || targetReturnType === anyType) return result;
                const sourceReturnType = isResolvingReturnTypeOfSignature(source) ? anyType : source.declaration && isJSConstructor(source.declaration) ? getDeclaredTypeOfClassOrInterface(getMergedSymbol(source.declaration.symbol)) : getReturnTypeOfSignature(source);
                const targetTypePredicate = getTypePredicateOfSignature(target);
                if (targetTypePredicate) {
                    const sourceTypePredicate = getTypePredicateOfSignature(source);
                    if (sourceTypePredicate) result &= compareTypePredicateRelatedTo(sourceTypePredicate, targetTypePredicate, reportErrors2, errorReporter, compareTypes);
                    else if (isIdentifierTypePredicate(targetTypePredicate) || isThisTypePredicate(targetTypePredicate)) {
                        if (reportErrors2) errorReporter(Diagnostics.Signature_0_must_be_a_type_predicate, signatureToString(source));
                        return 0 /* False */ ;
                    }
                } else {
                    result &= checkMode & 1 /* BivariantCallback */  && compareTypes(targetReturnType, sourceReturnType, /*reportErrors*/ false) || compareTypes(sourceReturnType, targetReturnType, reportErrors2);
                    if (!result && reportErrors2 && incompatibleErrorReporter) incompatibleErrorReporter(sourceReturnType, targetReturnType);
                }
            }
            return result;
        }
        function compareTypePredicateRelatedTo(source, target, reportErrors2, errorReporter, compareTypes) {
            if (source.kind !== target.kind) {
                if (reportErrors2) {
                    errorReporter(Diagnostics.A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard);
                    errorReporter(Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
                }
                return 0 /* False */ ;
            }
            if (source.kind === 1 /* Identifier */  || source.kind === 3 /* AssertsIdentifier */ ) {
                if (source.parameterIndex !== target.parameterIndex) {
                    if (reportErrors2) {
                        errorReporter(Diagnostics.Parameter_0_is_not_in_the_same_position_as_parameter_1, source.parameterName, target.parameterName);
                        errorReporter(Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
                    }
                    return 0 /* False */ ;
                }
            }
            const related = source.type === target.type ? -1 /* True */  : source.type && target.type ? compareTypes(source.type, target.type, reportErrors2) : 0 /* False */ ;
            if (related === 0 /* False */  && reportErrors2) errorReporter(Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
            return related;
        }
        function isImplementationCompatibleWithOverload(implementation, overload) {
            const erasedSource = getErasedSignature(implementation);
            const erasedTarget = getErasedSignature(overload);
            const sourceReturnType = getReturnTypeOfSignature(erasedSource);
            const targetReturnType = getReturnTypeOfSignature(erasedTarget);
            if (targetReturnType === voidType || isTypeRelatedTo(targetReturnType, sourceReturnType, assignableRelation) || isTypeRelatedTo(sourceReturnType, targetReturnType, assignableRelation)) return isSignatureAssignableTo(erasedSource, erasedTarget, /*ignoreReturnTypes*/ true);
            return false;
        }
        function isEmptyResolvedType(t) {
            return t !== anyFunctionType && t.properties.length === 0 && t.callSignatures.length === 0 && t.constructSignatures.length === 0 && t.indexInfos.length === 0;
        }
        function isEmptyObjectType(type) {
            return type.flags & 524288 /* Object */  ? !isGenericMappedType(type) && isEmptyResolvedType(resolveStructuredTypeMembers(type)) : type.flags & 67108864 /* NonPrimitive */  ? true : type.flags & 1048576 /* Union */  ? some(type.types, isEmptyObjectType) : type.flags & 2097152 /* Intersection */  ? every(type.types, isEmptyObjectType) : false;
        }
        function isEmptyAnonymousObjectType(type) {
            return !!(getObjectFlags(type) & 16 /* Anonymous */  && (type.members && isEmptyResolvedType(type) || type.symbol && type.symbol.flags & 2048 /* TypeLiteral */  && getMembersOfSymbol(type.symbol).size === 0));
        }
        function isUnknownLikeUnionType(type) {
            if (strictNullChecks && type.flags & 1048576 /* Union */ ) {
                if (!(type.objectFlags & 33554432 /* IsUnknownLikeUnionComputed */ )) {
                    const types = type.types;
                    type.objectFlags |= 33554432 /* IsUnknownLikeUnionComputed */  | (types.length >= 3 && types[0].flags & 32768 /* Undefined */  && types[1].flags & 65536 /* Null */  && some(types, isEmptyAnonymousObjectType) ? 67108864 /* IsUnknownLikeUnion */  : 0);
                }
                return !!(type.objectFlags & 67108864 /* IsUnknownLikeUnion */ );
            }
            return false;
        }
        function containsUndefinedType(type) {
            return !!((type.flags & 1048576 /* Union */  ? type.types[0] : type).flags & 32768 /* Undefined */ );
        }
        function containsNonMissingUndefinedType(type) {
            const candidate = type.flags & 1048576 /* Union */  ? type.types[0] : type;
            return !!(candidate.flags & 32768 /* Undefined */ ) && candidate !== missingType;
        }
        function isStringIndexSignatureOnlyType(type) {
            return type.flags & 524288 /* Object */  && !isGenericMappedType(type) && getPropertiesOfType(type).length === 0 && getIndexInfosOfType(type).length === 1 && !!getIndexInfoOfType(type, stringType) || type.flags & 3145728 /* UnionOrIntersection */  && every(type.types, isStringIndexSignatureOnlyType) || false;
        }
        function isEnumTypeRelatedTo(source, target, errorReporter) {
            const sourceSymbol = source.flags & 8 /* EnumMember */  ? getParentOfSymbol(source) : source;
            const targetSymbol = target.flags & 8 /* EnumMember */  ? getParentOfSymbol(target) : target;
            if (sourceSymbol === targetSymbol) return true;
            if (sourceSymbol.escapedName !== targetSymbol.escapedName || !(sourceSymbol.flags & 256 /* RegularEnum */ ) || !(targetSymbol.flags & 256 /* RegularEnum */ )) return false;
            const id = getSymbolId(sourceSymbol) + "," + getSymbolId(targetSymbol);
            const entry = enumRelation.get(id);
            if (entry !== void 0 && !(entry & 2 /* Failed */  && errorReporter)) return !!(entry & 1 /* Succeeded */ );
            const targetEnumType = getTypeOfSymbol(targetSymbol);
            for (const sourceProperty of getPropertiesOfType(getTypeOfSymbol(sourceSymbol)))if (sourceProperty.flags & 8 /* EnumMember */ ) {
                const targetProperty = getPropertyOfType(targetEnumType, sourceProperty.escapedName);
                if (!targetProperty || !(targetProperty.flags & 8 /* EnumMember */ )) {
                    if (errorReporter) errorReporter(Diagnostics.Property_0_is_missing_in_type_1, symbolName(sourceProperty), typeToString(getDeclaredTypeOfSymbol(targetSymbol), /*enclosingDeclaration*/ void 0, 64 /* UseFullyQualifiedType */ ));
                    enumRelation.set(id, 2 /* Failed */ );
                    return false;
                }
                const sourceValue = getEnumMemberValue(getDeclarationOfKind(sourceProperty, 307 /* EnumMember */ )).value;
                const targetValue = getEnumMemberValue(getDeclarationOfKind(targetProperty, 307 /* EnumMember */ )).value;
                if (sourceValue !== targetValue) {
                    const sourceIsString = typeof sourceValue === "string";
                    const targetIsString = typeof targetValue === "string";
                    if (sourceValue !== void 0 && targetValue !== void 0) {
                        if (errorReporter) {
                            const escapedSource = sourceIsString ? `"${escapeString(sourceValue)}"` : sourceValue;
                            const escapedTarget = targetIsString ? `"${escapeString(targetValue)}"` : targetValue;
                            errorReporter(Diagnostics.Each_declaration_of_0_1_differs_in_its_value_where_2_was_expected_but_3_was_given, symbolName(targetSymbol), symbolName(targetProperty), escapedTarget, escapedSource);
                        }
                        enumRelation.set(id, 2 /* Failed */ );
                        return false;
                    }
                    if (sourceIsString || targetIsString) {
                        if (errorReporter) {
                            const knownStringValue = sourceValue !== null && sourceValue !== void 0 ? sourceValue : targetValue;
                            Debug.assert(typeof knownStringValue === "string");
                            const escapedValue = `"${escapeString(knownStringValue)}"`;
                            errorReporter(Diagnostics.One_value_of_0_1_is_the_string_2_and_the_other_is_assumed_to_be_an_unknown_numeric_value, symbolName(targetSymbol), symbolName(targetProperty), escapedValue);
                        }
                        enumRelation.set(id, 2 /* Failed */ );
                        return false;
                    }
                }
            }
            enumRelation.set(id, 1 /* Succeeded */ );
            return true;
        }
        function isSimpleTypeRelatedTo(source, target, relation, errorReporter) {
            const s = source.flags;
            const t = target.flags;
            if (t & 1 /* Any */  || s & 131072 /* Never */  || source === wildcardType) return true;
            if (t & 2 /* Unknown */  && !(relation === strictSubtypeRelation && s & 1 /* Any */ )) return true;
            if (t & 131072 /* Never */ ) return false;
            if (s & 402653316 /* StringLike */  && t & 4 /* String */ ) return true;
            if (s & 128 /* StringLiteral */  && s & 1024 /* EnumLiteral */  && t & 128 /* StringLiteral */  && !(t & 1024 /* EnumLiteral */ ) && source.value === target.value) return true;
            if (s & 296 /* NumberLike */  && t & 8 /* Number */ ) return true;
            if (s & 256 /* NumberLiteral */  && s & 1024 /* EnumLiteral */  && t & 256 /* NumberLiteral */  && !(t & 1024 /* EnumLiteral */ ) && source.value === target.value) return true;
            if (s & 2112 /* BigIntLike */  && t & 64 /* BigInt */ ) return true;
            if (s & 528 /* BooleanLike */  && t & 16 /* Boolean */ ) return true;
            if (s & 12288 /* ESSymbolLike */  && t & 4096 /* ESSymbol */ ) return true;
            if (s & 32 /* Enum */  && t & 32 /* Enum */  && source.symbol.escapedName === target.symbol.escapedName && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter)) return true;
            if (s & 1024 /* EnumLiteral */  && t & 1024 /* EnumLiteral */ ) {
                if (s & 1048576 /* Union */  && t & 1048576 /* Union */  && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter)) return true;
                if (s & 2944 /* Literal */  && t & 2944 /* Literal */  && source.value === target.value && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter)) return true;
            }
            if (s & 32768 /* Undefined */  && (!strictNullChecks && !(t & 3145728 /* UnionOrIntersection */ ) || t & 49152 /* Void */ )) return true;
            if (s & 65536 /* Null */  && (!strictNullChecks && !(t & 3145728 /* UnionOrIntersection */ ) || t & 65536 /* Null */ )) return true;
            if (s & 524288 /* Object */  && t & 67108864 /* NonPrimitive */  && !(relation === strictSubtypeRelation && isEmptyAnonymousObjectType(source) && !(getObjectFlags(source) & 8192 /* FreshLiteral */ ))) return true;
            if (relation === assignableRelation || relation === comparableRelation) {
                if (s & 1 /* Any */ ) return true;
                if (s & 8 /* Number */  && (t & 32 /* Enum */  || t & 256 /* NumberLiteral */  && t & 1024 /* EnumLiteral */ )) return true;
                if (s & 256 /* NumberLiteral */  && !(s & 1024 /* EnumLiteral */ ) && (t & 32 /* Enum */  || t & 256 /* NumberLiteral */  && t & 1024 /* EnumLiteral */  && source.value === target.value)) return true;
                if (isUnknownLikeUnionType(target)) return true;
            }
            return false;
        }
        function isTypeRelatedTo(source, target, relation) {
            if (isFreshLiteralType(source)) source = source.regularType;
            if (isFreshLiteralType(target)) target = target.regularType;
            if (source === target) return true;
            if (relation !== identityRelation) {
                if (relation === comparableRelation && !(target.flags & 131072 /* Never */ ) && isSimpleTypeRelatedTo(target, source, relation) || isSimpleTypeRelatedTo(source, target, relation)) return true;
            } else if (!((source.flags | target.flags) & 61865984 /* Substitution */ )) {
                if (source.flags !== target.flags) return false;
                if (source.flags & 67358815 /* Singleton */ ) return true;
            }
            if (source.flags & 524288 /* Object */  && target.flags & 524288 /* Object */ ) {
                const related = relation.get(getRelationKey(source, target, 0 /* None */ , relation, /*ignoreConstraints*/ false));
                if (related !== void 0) return !!(related & 1 /* Succeeded */ );
            }
            if (source.flags & 469499904 /* StructuredOrInstantiable */  || target.flags & 469499904 /* StructuredOrInstantiable */ ) return checkTypeRelatedTo(source, target, relation, /*errorNode*/ void 0);
            return false;
        }
        function isIgnoredJsxProperty(source, sourceProp) {
            return getObjectFlags(source) & 2048 /* JsxAttributes */  && isHyphenatedJsxName(sourceProp.escapedName);
        }
        function getNormalizedType(type, writing) {
            while(true){
                const t = isFreshLiteralType(type) ? type.regularType : isGenericTupleType(type) ? getNormalizedTupleType(type, writing) : getObjectFlags(type) & 4 /* Reference */  ? type.node ? createTypeReference(type.target, getTypeArguments(type)) : getSingleBaseForNonAugmentingSubtype(type) || type : type.flags & 3145728 /* UnionOrIntersection */  ? getNormalizedUnionOrIntersectionType(type, writing) : type.flags & 33554432 /* Substitution */  ? writing ? type.baseType : getSubstitutionIntersection(type) : type.flags & 25165824 /* Simplifiable */  ? getSimplifiedType(type, writing) : type;
                if (t === type) return t;
                type = t;
            }
        }
        function getNormalizedUnionOrIntersectionType(type, writing) {
            const reduced = getReducedType(type);
            if (reduced !== type) return reduced;
            if (type.flags & 2097152 /* Intersection */  && shouldNormalizeIntersection(type)) {
                const normalizedTypes = sameMap(type.types, (t)=>getNormalizedType(t, writing));
                if (normalizedTypes !== type.types) return getIntersectionType(normalizedTypes);
            }
            return type;
        }
        function shouldNormalizeIntersection(type) {
            let hasInstantiable = false;
            let hasNullableOrEmpty = false;
            for (const t of type.types){
                hasInstantiable || (hasInstantiable = !!(t.flags & 465829888 /* Instantiable */ ));
                hasNullableOrEmpty || (hasNullableOrEmpty = !!(t.flags & 98304 /* Nullable */ ) || isEmptyAnonymousObjectType(t));
                if (hasInstantiable && hasNullableOrEmpty) return true;
            }
            return false;
        }
        function getNormalizedTupleType(type, writing) {
            const elements = getElementTypes(type);
            const normalizedElements = sameMap(elements, (t)=>t.flags & 25165824 /* Simplifiable */  ? getSimplifiedType(t, writing) : t);
            return elements !== normalizedElements ? createNormalizedTupleType(type.target, normalizedElements) : type;
        }
        function checkTypeRelatedTo(source, target, relation, errorNode, headMessage, containingMessageChain, errorOutputContainer) {
            var _a;
            let errorInfo;
            let relatedInfo;
            let maybeKeys;
            let maybeKeysSet;
            let sourceStack;
            let targetStack;
            let maybeCount = 0;
            let sourceDepth = 0;
            let targetDepth = 0;
            let expandingFlags = 0 /* None */ ;
            let overflow = false;
            let overrideNextErrorInfo = 0;
            let skipParentCounter = 0;
            let lastSkippedInfo;
            let incompatibleStack;
            let relationCount = 16e6 - relation.size >> 3;
            Debug.assert(relation !== identityRelation || !errorNode, "no error reporting in identity checking");
            const result = isRelatedTo(source, target, 3 /* Both */ , /*reportErrors*/ !!errorNode, headMessage);
            if (incompatibleStack) reportIncompatibleStack();
            if (overflow) {
                const id = getRelationKey(source, target, /*intersectionState*/ 0 /* None */ , relation, /*ignoreConstraints*/ false);
                relation.set(id, 2 /* Failed */  | (relationCount <= 0 ? 32 /* ComplexityOverflow */  : 64 /* StackDepthOverflow */ ));
                (_a = tracing) == null || _a.instant(tracing.Phase.CheckTypes, "checkTypeRelatedTo_DepthLimit", {
                    sourceId: source.id,
                    targetId: target.id,
                    depth: sourceDepth,
                    targetDepth
                });
                const message = relationCount <= 0 ? Diagnostics.Excessive_complexity_comparing_types_0_and_1 : Diagnostics.Excessive_stack_depth_comparing_types_0_and_1;
                const diag2 = error2(errorNode || currentNode, message, typeToString(source), typeToString(target));
                if (errorOutputContainer) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
            } else if (errorInfo) {
                if (containingMessageChain) {
                    const chain = containingMessageChain();
                    if (chain) {
                        concatenateDiagnosticMessageChains(chain, errorInfo);
                        errorInfo = chain;
                    }
                }
                let relatedInformation;
                if (headMessage && errorNode && !result && source.symbol) {
                    const links = getSymbolLinks(source.symbol);
                    if (links.originatingImport && !isImportCall(links.originatingImport)) {
                        const helpfulRetry = checkTypeRelatedTo(getTypeOfSymbol(links.target), target, relation, /*errorNode*/ void 0);
                        if (helpfulRetry) {
                            const diag3 = createDiagnosticForNode(links.originatingImport, Diagnostics.Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_Consider_using_a_default_import_or_import_require_here_instead);
                            relatedInformation = append(relatedInformation, diag3);
                        }
                    }
                }
                const diag2 = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorNode), errorNode, errorInfo, relatedInformation);
                if (relatedInfo) addRelatedInfo(diag2, ...relatedInfo);
                if (errorOutputContainer) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                if (!errorOutputContainer || !errorOutputContainer.skipLogging) diagnostics.add(diag2);
            }
            if (errorNode && errorOutputContainer && errorOutputContainer.skipLogging && result === 0 /* False */ ) Debug.assert(!!errorOutputContainer.errors, "missed opportunity to interact with error.");
            return result !== 0 /* False */ ;
            function resetErrorInfo(saved) {
                errorInfo = saved.errorInfo;
                lastSkippedInfo = saved.lastSkippedInfo;
                incompatibleStack = saved.incompatibleStack;
                overrideNextErrorInfo = saved.overrideNextErrorInfo;
                skipParentCounter = saved.skipParentCounter;
                relatedInfo = saved.relatedInfo;
            }
            function captureErrorCalculationState() {
                return {
                    errorInfo,
                    lastSkippedInfo,
                    incompatibleStack: incompatibleStack == null ? void 0 : incompatibleStack.slice(),
                    overrideNextErrorInfo,
                    skipParentCounter,
                    relatedInfo: relatedInfo == null ? void 0 : relatedInfo.slice()
                };
            }
            function reportIncompatibleError(message, ...args) {
                overrideNextErrorInfo++;
                lastSkippedInfo = void 0;
                (incompatibleStack || (incompatibleStack = [])).push([
                    message,
                    ...args
                ]);
            }
            function reportIncompatibleStack() {
                const stack = incompatibleStack || [];
                incompatibleStack = void 0;
                const info = lastSkippedInfo;
                lastSkippedInfo = void 0;
                if (stack.length === 1) {
                    reportError(...stack[0]);
                    if (info) reportRelationError(/*message*/ void 0, ...info);
                    return;
                }
                let path = "";
                const secondaryRootErrors = [];
                while(stack.length){
                    const [msg, ...args] = stack.pop();
                    switch(msg.code){
                        case Diagnostics.Types_of_property_0_are_incompatible.code:
                            {
                                if (path.indexOf("new ") === 0) path = `(${path})`;
                                const str = "" + args[0];
                                if (path.length === 0) path = `${str}`;
                                else if (isIdentifierText(str, getEmitScriptTarget(compilerOptions))) path = `${path}.${str}`;
                                else if (str[0] === "[" && str[str.length - 1] === "]") path = `${path}${str}`;
                                else path = `${path}[${str}]`;
                                break;
                            }
                        case Diagnostics.Call_signature_return_types_0_and_1_are_incompatible.code:
                        case Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible.code:
                        case Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code:
                        case Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code:
                            if (path.length === 0) {
                                let mappedMsg = msg;
                                if (msg.code === Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code) mappedMsg = Diagnostics.Call_signature_return_types_0_and_1_are_incompatible;
                                else if (msg.code === Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code) mappedMsg = Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible;
                                secondaryRootErrors.unshift([
                                    mappedMsg,
                                    args[0],
                                    args[1]
                                ]);
                            } else {
                                const prefix = msg.code === Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible.code || msg.code === Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code ? "new " : "";
                                const params = msg.code === Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code || msg.code === Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1.code ? "" : "...";
                                path = `${prefix}${path}(${params})`;
                            }
                            break;
                        case Diagnostics.Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target.code:
                            secondaryRootErrors.unshift([
                                Diagnostics.Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target,
                                args[0],
                                args[1]
                            ]);
                            break;
                        case Diagnostics.Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target.code:
                            secondaryRootErrors.unshift([
                                Diagnostics.Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target,
                                args[0],
                                args[1],
                                args[2]
                            ]);
                            break;
                        default:
                            return Debug.fail(`Unhandled Diagnostic: ${msg.code}`);
                    }
                }
                if (path) reportError(path[path.length - 1] === ")" ? Diagnostics.The_types_returned_by_0_are_incompatible_between_these_types : Diagnostics.The_types_of_0_are_incompatible_between_these_types, path);
                else secondaryRootErrors.shift();
                for (const [msg, ...args] of secondaryRootErrors){
                    const originalValue = msg.elidedInCompatabilityPyramid;
                    msg.elidedInCompatabilityPyramid = false;
                    reportError(msg, ...args);
                    msg.elidedInCompatabilityPyramid = originalValue;
                }
                if (info) reportRelationError(/*message*/ void 0, ...info);
            }
            function reportError(message, ...args) {
                Debug.assert(!!errorNode);
                if (incompatibleStack) reportIncompatibleStack();
                if (message.elidedInCompatabilityPyramid) return;
                if (skipParentCounter === 0) errorInfo = chainDiagnosticMessages(errorInfo, message, ...args);
                else skipParentCounter--;
            }
            function reportParentSkippedError(message, ...args) {
                reportError(message, ...args);
                skipParentCounter++;
            }
            function associateRelatedInfo(info) {
                Debug.assert(!!errorInfo);
                if (!relatedInfo) relatedInfo = [
                    info
                ];
                else relatedInfo.push(info);
            }
            function reportRelationError(message, source2, target2) {
                if (incompatibleStack) reportIncompatibleStack();
                const [sourceType, targetType] = getTypeNamesForErrorDisplay(source2, target2);
                let generalizedSource = source2;
                let generalizedSourceType = sourceType;
                if (!(target2.flags & 131072 /* Never */ ) && isLiteralType(source2) && !typeCouldHaveTopLevelSingletonTypes(target2)) {
                    generalizedSource = getBaseTypeOfLiteralType(source2);
                    Debug.assert(!isTypeAssignableTo(generalizedSource, target2), "generalized source shouldn't be assignable");
                    generalizedSourceType = getTypeNameForErrorDisplay(generalizedSource);
                }
                const targetFlags = target2.flags & 8388608 /* IndexedAccess */  && !(source2.flags & 8388608 /* IndexedAccess */ ) ? target2.objectType.flags : target2.flags;
                if (targetFlags & 262144 /* TypeParameter */  && target2 !== markerSuperTypeForCheck && target2 !== markerSubTypeForCheck) {
                    const constraint = getBaseConstraintOfType(target2);
                    let needsOriginalSource;
                    if (constraint && (isTypeAssignableTo(generalizedSource, constraint) || (needsOriginalSource = isTypeAssignableTo(source2, constraint)))) reportError(Diagnostics._0_is_assignable_to_the_constraint_of_type_1_but_1_could_be_instantiated_with_a_different_subtype_of_constraint_2, needsOriginalSource ? sourceType : generalizedSourceType, targetType, typeToString(constraint));
                    else {
                        errorInfo = void 0;
                        reportError(Diagnostics._0_could_be_instantiated_with_an_arbitrary_type_which_could_be_unrelated_to_1, targetType, generalizedSourceType);
                    }
                }
                if (!message) {
                    if (relation === comparableRelation) message = Diagnostics.Type_0_is_not_comparable_to_type_1;
                    else if (sourceType === targetType) message = Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated;
                    else if (exactOptionalPropertyTypes && getExactOptionalUnassignableProperties(source2, target2).length) message = Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties;
                    else {
                        if (source2.flags & 128 /* StringLiteral */  && target2.flags & 1048576 /* Union */ ) {
                            const suggestedType = getSuggestedTypeForNonexistentStringLiteralType(source2, target2);
                            if (suggestedType) {
                                reportError(Diagnostics.Type_0_is_not_assignable_to_type_1_Did_you_mean_2, generalizedSourceType, targetType, typeToString(suggestedType));
                                return;
                            }
                        }
                        message = Diagnostics.Type_0_is_not_assignable_to_type_1;
                    }
                } else if (message === Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1 && exactOptionalPropertyTypes && getExactOptionalUnassignableProperties(source2, target2).length) message = Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties;
                reportError(message, generalizedSourceType, targetType);
            }
            function tryElaborateErrorsForPrimitivesAndObjects(source2, target2) {
                const sourceType = symbolValueDeclarationIsContextSensitive(source2.symbol) ? typeToString(source2, source2.symbol.valueDeclaration) : typeToString(source2);
                const targetType = symbolValueDeclarationIsContextSensitive(target2.symbol) ? typeToString(target2, target2.symbol.valueDeclaration) : typeToString(target2);
                if (globalStringType === source2 && stringType === target2 || globalNumberType === source2 && numberType === target2 || globalBooleanType === source2 && booleanType === target2 || getGlobalESSymbolType() === source2 && esSymbolType === target2) reportError(Diagnostics._0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible, targetType, sourceType);
            }
            function tryElaborateArrayLikeErrors(source2, target2, reportErrors2) {
                if (isTupleType(source2)) {
                    if (source2.target.readonly && isMutableArrayOrTuple(target2)) {
                        if (reportErrors2) reportError(Diagnostics.The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1, typeToString(source2), typeToString(target2));
                        return false;
                    }
                    return isArrayOrTupleType(target2);
                }
                if (isReadonlyArrayType(source2) && isMutableArrayOrTuple(target2)) {
                    if (reportErrors2) reportError(Diagnostics.The_type_0_is_readonly_and_cannot_be_assigned_to_the_mutable_type_1, typeToString(source2), typeToString(target2));
                    return false;
                }
                if (isTupleType(target2)) return isArrayType(source2);
                return true;
            }
            function isRelatedToWorker(source2, target2, reportErrors2) {
                return isRelatedTo(source2, target2, 3 /* Both */ , reportErrors2);
            }
            function isRelatedTo(originalSource, originalTarget, recursionFlags = 3 /* Both */ , reportErrors2 = false, headMessage2, intersectionState = 0 /* None */ ) {
                if (originalSource === originalTarget) return -1 /* True */ ;
                if (originalSource.flags & 524288 /* Object */  && originalTarget.flags & 402784252 /* Primitive */ ) {
                    if (relation === comparableRelation && !(originalTarget.flags & 131072 /* Never */ ) && isSimpleTypeRelatedTo(originalTarget, originalSource, relation) || isSimpleTypeRelatedTo(originalSource, originalTarget, relation, reportErrors2 ? reportError : void 0)) return -1 /* True */ ;
                    if (reportErrors2) reportErrorResults(originalSource, originalTarget, originalSource, originalTarget, headMessage2);
                    return 0 /* False */ ;
                }
                const source2 = getNormalizedType(originalSource, /*writing*/ false);
                let target2 = getNormalizedType(originalTarget, /*writing*/ true);
                if (source2 === target2) return -1 /* True */ ;
                if (relation === identityRelation) {
                    if (source2.flags !== target2.flags) return 0 /* False */ ;
                    if (source2.flags & 67358815 /* Singleton */ ) return -1 /* True */ ;
                    traceUnionsOrIntersectionsTooLarge(source2, target2);
                    return recursiveTypeRelatedTo(source2, target2, /*reportErrors*/ false, 0 /* None */ , recursionFlags);
                }
                if (source2.flags & 262144 /* TypeParameter */  && getConstraintOfType(source2) === target2) return -1 /* True */ ;
                if (source2.flags & 470302716 /* DefinitelyNonNullable */  && target2.flags & 1048576 /* Union */ ) {
                    const types = target2.types;
                    const candidate = types.length === 2 && types[0].flags & 98304 /* Nullable */  ? types[1] : types.length === 3 && types[0].flags & 98304 /* Nullable */  && types[1].flags & 98304 /* Nullable */  ? types[2] : void 0;
                    if (candidate && !(candidate.flags & 98304 /* Nullable */ )) {
                        target2 = getNormalizedType(candidate, /*writing*/ true);
                        if (source2 === target2) return -1 /* True */ ;
                    }
                }
                if (relation === comparableRelation && !(target2.flags & 131072 /* Never */ ) && isSimpleTypeRelatedTo(target2, source2, relation) || isSimpleTypeRelatedTo(source2, target2, relation, reportErrors2 ? reportError : void 0)) return -1 /* True */ ;
                if (source2.flags & 469499904 /* StructuredOrInstantiable */  || target2.flags & 469499904 /* StructuredOrInstantiable */ ) {
                    const isPerformingExcessPropertyChecks = !(intersectionState & 2 /* Target */ ) && isObjectLiteralType2(source2) && getObjectFlags(source2) & 8192 /* FreshLiteral */ ;
                    if (isPerformingExcessPropertyChecks) {
                        if (hasExcessProperties(source2, target2, reportErrors2)) {
                            if (reportErrors2) reportRelationError(headMessage2, source2, originalTarget.aliasSymbol ? originalTarget : target2);
                            return 0 /* False */ ;
                        }
                    }
                    const isPerformingCommonPropertyChecks = (relation !== comparableRelation || isUnitType(source2)) && !(intersectionState & 2 /* Target */ ) && source2.flags & 405405692 /* Intersection */  && source2 !== globalObjectType && target2.flags & 2621440 /* Intersection */  && isWeakType(target2) && (getPropertiesOfType(source2).length > 0 || typeHasCallOrConstructSignatures(source2));
                    const isComparingJsxAttributes = !!(getObjectFlags(source2) & 2048 /* JsxAttributes */ );
                    if (isPerformingCommonPropertyChecks && !hasCommonProperties(source2, target2, isComparingJsxAttributes)) {
                        if (reportErrors2) {
                            const sourceString = typeToString(originalSource.aliasSymbol ? originalSource : source2);
                            const targetString = typeToString(originalTarget.aliasSymbol ? originalTarget : target2);
                            const calls = getSignaturesOfType(source2, 0 /* Call */ );
                            const constructs = getSignaturesOfType(source2, 1 /* Construct */ );
                            if (calls.length > 0 && isRelatedTo(getReturnTypeOfSignature(calls[0]), target2, 1 /* Source */ , /*reportErrors*/ false) || constructs.length > 0 && isRelatedTo(getReturnTypeOfSignature(constructs[0]), target2, 1 /* Source */ , /*reportErrors*/ false)) reportError(Diagnostics.Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it, sourceString, targetString);
                            else reportError(Diagnostics.Type_0_has_no_properties_in_common_with_type_1, sourceString, targetString);
                        }
                        return 0 /* False */ ;
                    }
                    traceUnionsOrIntersectionsTooLarge(source2, target2);
                    const skipCaching = source2.flags & 1048576 /* Union */  && source2.types.length < 4 && !(target2.flags & 1048576 /* Union */ ) || target2.flags & 1048576 /* Union */  && target2.types.length < 4 && !(source2.flags & 469499904 /* StructuredOrInstantiable */ );
                    const result2 = skipCaching ? unionOrIntersectionRelatedTo(source2, target2, reportErrors2, intersectionState) : recursiveTypeRelatedTo(source2, target2, reportErrors2, intersectionState, recursionFlags);
                    if (result2) return result2;
                }
                if (reportErrors2) reportErrorResults(originalSource, originalTarget, source2, target2, headMessage2);
                return 0 /* False */ ;
            }
            function reportErrorResults(originalSource, originalTarget, source2, target2, headMessage2) {
                var _a2, _b;
                const sourceHasBase = !!getSingleBaseForNonAugmentingSubtype(originalSource);
                const targetHasBase = !!getSingleBaseForNonAugmentingSubtype(originalTarget);
                source2 = originalSource.aliasSymbol || sourceHasBase ? originalSource : source2;
                target2 = originalTarget.aliasSymbol || targetHasBase ? originalTarget : target2;
                let maybeSuppress = overrideNextErrorInfo > 0;
                if (maybeSuppress) overrideNextErrorInfo--;
                if (source2.flags & 524288 /* Object */  && target2.flags & 524288 /* Object */ ) {
                    const currentError = errorInfo;
                    tryElaborateArrayLikeErrors(source2, target2, /*reportErrors*/ true);
                    if (errorInfo !== currentError) maybeSuppress = !!errorInfo;
                }
                if (source2.flags & 524288 /* Object */  && target2.flags & 402784252 /* Primitive */ ) tryElaborateErrorsForPrimitivesAndObjects(source2, target2);
                else if (source2.symbol && source2.flags & 524288 /* Object */  && globalObjectType === source2) reportError(Diagnostics.The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead);
                else if (getObjectFlags(source2) & 2048 /* JsxAttributes */  && target2.flags & 2097152 /* Intersection */ ) {
                    const targetTypes = target2.types;
                    const intrinsicAttributes = getJsxType(JsxNames.IntrinsicAttributes, errorNode);
                    const intrinsicClassAttributes = getJsxType(JsxNames.IntrinsicClassAttributes, errorNode);
                    if (!isErrorType(intrinsicAttributes) && !isErrorType(intrinsicClassAttributes) && (contains(targetTypes, intrinsicAttributes) || contains(targetTypes, intrinsicClassAttributes))) return;
                } else errorInfo = elaborateNeverIntersection(errorInfo, originalTarget);
                if (!headMessage2 && maybeSuppress) {
                    const savedErrorState = captureErrorCalculationState();
                    reportRelationError(headMessage2, source2, target2);
                    let canonical;
                    if (errorInfo && errorInfo !== savedErrorState.errorInfo) canonical = {
                        code: errorInfo.code,
                        messageText: errorInfo.messageText
                    };
                    resetErrorInfo(savedErrorState);
                    if (canonical && errorInfo) errorInfo.canonicalHead = canonical;
                    lastSkippedInfo = [
                        source2,
                        target2
                    ];
                    return;
                }
                reportRelationError(headMessage2, source2, target2);
                if (source2.flags & 262144 /* TypeParameter */  && ((_b = (_a2 = source2.symbol) == null ? void 0 : _a2.declarations) == null ? void 0 : _b[0]) && !getConstraintOfType(source2)) {
                    const syntheticParam = cloneTypeParameter(source2);
                    syntheticParam.constraint = instantiateType(target2, makeUnaryTypeMapper(source2, syntheticParam));
                    if (hasNonCircularBaseConstraint(syntheticParam)) {
                        const targetConstraintString = typeToString(target2, source2.symbol.declarations[0]);
                        associateRelatedInfo(createDiagnosticForNode(source2.symbol.declarations[0], Diagnostics.This_type_parameter_might_need_an_extends_0_constraint, targetConstraintString));
                    }
                }
            }
            function traceUnionsOrIntersectionsTooLarge(source2, target2) {
                if (!tracing) return;
                if (source2.flags & 3145728 /* UnionOrIntersection */  && target2.flags & 3145728 /* UnionOrIntersection */ ) {
                    const sourceUnionOrIntersection = source2;
                    const targetUnionOrIntersection = target2;
                    if (sourceUnionOrIntersection.objectFlags & targetUnionOrIntersection.objectFlags & 32768 /* PrimitiveUnion */ ) return;
                    const sourceSize = sourceUnionOrIntersection.types.length;
                    const targetSize = targetUnionOrIntersection.types.length;
                    if (sourceSize * targetSize > 1e6) tracing.instant(tracing.Phase.CheckTypes, "traceUnionsOrIntersectionsTooLarge_DepthLimit", {
                        sourceId: source2.id,
                        sourceSize,
                        targetId: target2.id,
                        targetSize,
                        pos: errorNode == null ? void 0 : errorNode.pos,
                        end: errorNode == null ? void 0 : errorNode.end
                    });
                }
            }
            function getTypeOfPropertyInTypes(types, name) {
                const appendPropType = (propTypes, type)=>{
                    var _a2;
                    type = getApparentType(type);
                    const prop = type.flags & 3145728 /* UnionOrIntersection */  ? getPropertyOfUnionOrIntersectionType(type, name) : getPropertyOfObjectType(type, name);
                    const propType = prop && getTypeOfSymbol(prop) || ((_a2 = getApplicableIndexInfoForName(type, name)) == null ? void 0 : _a2.type) || undefinedType;
                    return append(propTypes, propType);
                };
                return getUnionType(reduceLeft(types, appendPropType, /*initial*/ void 0) || emptyArray);
            }
            function hasExcessProperties(source2, target2, reportErrors2) {
                var _a2;
                if (!isExcessPropertyCheckTarget(target2) || !noImplicitAny && getObjectFlags(target2) & 4096 /* JSLiteral */ ) return false;
                const isComparingJsxAttributes = !!(getObjectFlags(source2) & 2048 /* JsxAttributes */ );
                if ((relation === assignableRelation || relation === comparableRelation) && (isTypeSubsetOf(globalObjectType, target2) || !isComparingJsxAttributes && isEmptyObjectType(target2))) return false;
                let reducedTarget = target2;
                let checkTypes;
                if (target2.flags & 1048576 /* Union */ ) {
                    reducedTarget = findMatchingDiscriminantType(source2, target2, isRelatedTo) || filterPrimitivesIfContainsNonPrimitive(target2);
                    checkTypes = reducedTarget.flags & 1048576 /* Union */  ? reducedTarget.types : [
                        reducedTarget
                    ];
                }
                for (const prop of getPropertiesOfType(source2))if (shouldCheckAsExcessProperty(prop, source2.symbol) && !isIgnoredJsxProperty(source2, prop)) {
                    if (!isKnownProperty(reducedTarget, prop.escapedName, isComparingJsxAttributes)) {
                        if (reportErrors2) {
                            const errorTarget = filterType(reducedTarget, isExcessPropertyCheckTarget);
                            if (!errorNode) return Debug.fail();
                            if (isJsxAttributes(errorNode) || isJsxOpeningLikeElement(errorNode) || isJsxOpeningLikeElement(errorNode.parent)) {
                                if (prop.valueDeclaration && isJsxAttribute(prop.valueDeclaration) && getSourceFileOfNode(errorNode) === getSourceFileOfNode(prop.valueDeclaration.name)) errorNode = prop.valueDeclaration.name;
                                const propName = symbolToString(prop);
                                const suggestionSymbol = getSuggestedSymbolForNonexistentJSXAttribute(propName, errorTarget);
                                const suggestion = suggestionSymbol ? symbolToString(suggestionSymbol) : void 0;
                                if (suggestion) reportError(Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2, propName, typeToString(errorTarget), suggestion);
                                else reportError(Diagnostics.Property_0_does_not_exist_on_type_1, propName, typeToString(errorTarget));
                            } else {
                                const objectLiteralDeclaration = ((_a2 = source2.symbol) == null ? void 0 : _a2.declarations) && firstOrUndefined(source2.symbol.declarations);
                                let suggestion;
                                if (prop.valueDeclaration && findAncestor(prop.valueDeclaration, (d)=>d === objectLiteralDeclaration) && getSourceFileOfNode(objectLiteralDeclaration) === getSourceFileOfNode(errorNode)) {
                                    const propDeclaration = prop.valueDeclaration;
                                    Debug.assertNode(propDeclaration, isObjectLiteralElementLike);
                                    const name = propDeclaration.name;
                                    errorNode = name;
                                    if (isIdentifier(name)) suggestion = getSuggestionForNonexistentProperty(name, errorTarget);
                                }
                                if (suggestion !== void 0) reportParentSkippedError(Diagnostics.Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2, symbolToString(prop), typeToString(errorTarget), suggestion);
                                else reportParentSkippedError(Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(prop), typeToString(errorTarget));
                            }
                        }
                        return true;
                    }
                    if (checkTypes && !isRelatedTo(getTypeOfSymbol(prop), getTypeOfPropertyInTypes(checkTypes, prop.escapedName), 3 /* Both */ , reportErrors2)) {
                        if (reportErrors2) reportIncompatibleError(Diagnostics.Types_of_property_0_are_incompatible, symbolToString(prop));
                        return true;
                    }
                }
                return false;
            }
            function shouldCheckAsExcessProperty(prop, container) {
                return prop.valueDeclaration && container.valueDeclaration && prop.valueDeclaration.parent === container.valueDeclaration;
            }
            function unionOrIntersectionRelatedTo(source2, target2, reportErrors2, intersectionState) {
                if (source2.flags & 1048576 /* Union */ ) {
                    if (target2.flags & 1048576 /* Union */ ) {
                        const sourceOrigin = source2.origin;
                        if (sourceOrigin && sourceOrigin.flags & 2097152 /* Intersection */  && target2.aliasSymbol && contains(sourceOrigin.types, target2)) return -1 /* True */ ;
                        const targetOrigin = target2.origin;
                        if (targetOrigin && targetOrigin.flags & 1048576 /* Union */  && source2.aliasSymbol && contains(targetOrigin.types, source2)) return -1 /* True */ ;
                    }
                    return relation === comparableRelation ? someTypeRelatedToType(source2, target2, reportErrors2 && !(source2.flags & 402784252 /* Primitive */ ), intersectionState) : eachTypeRelatedToType(source2, target2, reportErrors2 && !(source2.flags & 402784252 /* Primitive */ ), intersectionState);
                }
                if (target2.flags & 1048576 /* Union */ ) return typeRelatedToSomeType(getRegularTypeOfObjectLiteral(source2), target2, reportErrors2 && !(source2.flags & 402784252 /* Primitive */ ) && !(target2.flags & 402784252 /* Primitive */ ), intersectionState);
                if (target2.flags & 2097152 /* Intersection */ ) return typeRelatedToEachType(source2, target2, reportErrors2, 2 /* Target */ );
                if (relation === comparableRelation && target2.flags & 402784252 /* Primitive */ ) {
                    const constraints = sameMap(source2.types, (t)=>t.flags & 465829888 /* Instantiable */  ? getBaseConstraintOfType(t) || unknownType : t);
                    if (constraints !== source2.types) {
                        source2 = getIntersectionType(constraints);
                        if (source2.flags & 131072 /* Never */ ) return 0 /* False */ ;
                        if (!(source2.flags & 2097152 /* Intersection */ )) return isRelatedTo(source2, target2, 1 /* Source */ , /*reportErrors*/ false) || isRelatedTo(target2, source2, 1 /* Source */ , /*reportErrors*/ false);
                    }
                }
                return someTypeRelatedToType(source2, target2, /*reportErrors*/ false, 1 /* Source */ );
            }
            function eachTypeRelatedToSomeType(source2, target2) {
                let result2 = -1 /* True */ ;
                const sourceTypes = source2.types;
                for (const sourceType of sourceTypes){
                    const related = typeRelatedToSomeType(sourceType, target2, /*reportErrors*/ false, 0 /* None */ );
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function typeRelatedToSomeType(source2, target2, reportErrors2, intersectionState) {
                const targetTypes = target2.types;
                if (target2.flags & 1048576 /* Union */ ) {
                    if (containsType(targetTypes, source2)) return -1 /* True */ ;
                    if (relation !== comparableRelation && getObjectFlags(target2) & 32768 /* PrimitiveUnion */  && !(source2.flags & 1024 /* EnumLiteral */ ) && (source2.flags & 2688 /* BigIntLiteral */  || (relation === subtypeRelation || relation === strictSubtypeRelation) && source2.flags & 256 /* NumberLiteral */ )) {
                        const alternateForm = source2 === source2.regularType ? source2.freshType : source2.regularType;
                        const primitive = source2.flags & 128 /* StringLiteral */  ? stringType : source2.flags & 256 /* NumberLiteral */  ? numberType : source2.flags & 2048 /* BigIntLiteral */  ? bigintType : void 0;
                        return primitive && containsType(targetTypes, primitive) || alternateForm && containsType(targetTypes, alternateForm) ? -1 /* True */  : 0 /* False */ ;
                    }
                    const match = getMatchingUnionConstituentForType(target2, source2);
                    if (match) {
                        const related = isRelatedTo(source2, match, 2 /* Target */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                        if (related) return related;
                    }
                }
                for (const type of targetTypes){
                    const related = isRelatedTo(source2, type, 2 /* Target */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                    if (related) return related;
                }
                if (reportErrors2) {
                    const bestMatchingType = getBestMatchingType(source2, target2, isRelatedTo);
                    if (bestMatchingType) isRelatedTo(source2, bestMatchingType, 2 /* Target */ , /*reportErrors*/ true, /*headMessage*/ void 0, intersectionState);
                }
                return 0 /* False */ ;
            }
            function typeRelatedToEachType(source2, target2, reportErrors2, intersectionState) {
                let result2 = -1 /* True */ ;
                const targetTypes = target2.types;
                for (const targetType of targetTypes){
                    const related = isRelatedTo(source2, targetType, 2 /* Target */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function someTypeRelatedToType(source2, target2, reportErrors2, intersectionState) {
                const sourceTypes = source2.types;
                if (source2.flags & 1048576 /* Union */  && containsType(sourceTypes, target2)) return -1 /* True */ ;
                const len = sourceTypes.length;
                for(let i = 0; i < len; i++){
                    const related = isRelatedTo(sourceTypes[i], target2, 1 /* Source */ , reportErrors2 && i === len - 1, /*headMessage*/ void 0, intersectionState);
                    if (related) return related;
                }
                return 0 /* False */ ;
            }
            function getUndefinedStrippedTargetIfNeeded(source2, target2) {
                if (source2.flags & 1048576 /* Union */  && target2.flags & 1048576 /* Union */  && !(source2.types[0].flags & 32768 /* Undefined */ ) && target2.types[0].flags & 32768 /* Undefined */ ) return extractTypesOfKind(target2, -32769 /* Undefined */ );
                return target2;
            }
            function eachTypeRelatedToType(source2, target2, reportErrors2, intersectionState) {
                let result2 = -1 /* True */ ;
                const sourceTypes = source2.types;
                const undefinedStrippedTarget = getUndefinedStrippedTargetIfNeeded(source2, target2);
                for(let i = 0; i < sourceTypes.length; i++){
                    const sourceType = sourceTypes[i];
                    if (undefinedStrippedTarget.flags & 1048576 /* Union */  && sourceTypes.length >= undefinedStrippedTarget.types.length && sourceTypes.length % undefinedStrippedTarget.types.length === 0) {
                        const related2 = isRelatedTo(sourceType, undefinedStrippedTarget.types[i % undefinedStrippedTarget.types.length], 3 /* Both */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                        if (related2) {
                            result2 &= related2;
                            continue;
                        }
                    }
                    const related = isRelatedTo(sourceType, target2, 1 /* Source */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function typeArgumentsRelatedTo(sources = emptyArray, targets = emptyArray, variances = emptyArray, reportErrors2, intersectionState) {
                if (sources.length !== targets.length && relation === identityRelation) return 0 /* False */ ;
                const length2 = sources.length <= targets.length ? sources.length : targets.length;
                let result2 = -1 /* True */ ;
                for(let i = 0; i < length2; i++){
                    const varianceFlags = i < variances.length ? variances[i] : 1 /* Covariant */ ;
                    const variance = varianceFlags & 7 /* VarianceMask */ ;
                    if (variance !== 4 /* Independent */ ) {
                        const s = sources[i];
                        const t = targets[i];
                        let related = -1 /* True */ ;
                        if (varianceFlags & 8 /* Unmeasurable */ ) related = relation === identityRelation ? isRelatedTo(s, t, 3 /* Both */ , /*reportErrors*/ false) : compareTypesIdentical(s, t);
                        else if (variance === 1 /* Covariant */ ) related = isRelatedTo(s, t, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        else if (variance === 2 /* Contravariant */ ) related = isRelatedTo(t, s, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        else if (variance === 3 /* Bivariant */ ) {
                            related = isRelatedTo(t, s, 3 /* Both */ , /*reportErrors*/ false);
                            if (!related) related = isRelatedTo(s, t, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        } else {
                            related = isRelatedTo(s, t, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                            if (related) related &= isRelatedTo(t, s, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        }
                        if (!related) return 0 /* False */ ;
                        result2 &= related;
                    }
                }
                return result2;
            }
            function recursiveTypeRelatedTo(source2, target2, reportErrors2, intersectionState, recursionFlags) {
                var _a2, _b, _c;
                if (overflow) return 0 /* False */ ;
                const id = getRelationKey(source2, target2, intersectionState, relation, /*ignoreConstraints*/ false);
                const entry = relation.get(id);
                if (entry !== void 0) {
                    if (reportErrors2 && entry & 2 /* Failed */  && !(entry & 96 /* Overflow */ )) ;
                    else {
                        if (outofbandVarianceMarkerHandler) {
                            const saved = entry & 24 /* ReportsMask */ ;
                            if (saved & 8 /* ReportsUnmeasurable */ ) instantiateType(source2, reportUnmeasurableMapper);
                            if (saved & 16 /* ReportsUnreliable */ ) instantiateType(source2, reportUnreliableMapper);
                        }
                        if (reportErrors2 && entry & 96 /* Overflow */ ) {
                            const message = entry & 32 /* ComplexityOverflow */  ? Diagnostics.Excessive_complexity_comparing_types_0_and_1 : Diagnostics.Excessive_stack_depth_comparing_types_0_and_1;
                            reportError(message, typeToString(source2), typeToString(target2));
                            overrideNextErrorInfo++;
                        }
                        return entry & 1 /* Succeeded */  ? -1 /* True */  : 0 /* False */ ;
                    }
                }
                if (relationCount <= 0) {
                    overflow = true;
                    return 0 /* False */ ;
                }
                if (!maybeKeys) {
                    maybeKeys = [];
                    maybeKeysSet = /* @__PURE__ */ new Set();
                    sourceStack = [];
                    targetStack = [];
                } else {
                    if (maybeKeysSet.has(id)) return 3 /* Maybe */ ;
                    const broadestEquivalentId = id.startsWith("*") ? getRelationKey(source2, target2, intersectionState, relation, /*ignoreConstraints*/ true) : void 0;
                    if (broadestEquivalentId && maybeKeysSet.has(broadestEquivalentId)) return 3 /* Maybe */ ;
                    if (sourceDepth === 100 || targetDepth === 100) {
                        overflow = true;
                        return 0 /* False */ ;
                    }
                }
                const maybeStart = maybeCount;
                maybeKeys[maybeCount] = id;
                maybeKeysSet.add(id);
                maybeCount++;
                const saveExpandingFlags = expandingFlags;
                if (recursionFlags & 1 /* Source */ ) {
                    sourceStack[sourceDepth] = source2;
                    sourceDepth++;
                    if (!(expandingFlags & 1 /* Source */ ) && isDeeplyNestedType(source2, sourceStack, sourceDepth)) expandingFlags |= 1 /* Source */ ;
                }
                if (recursionFlags & 2 /* Target */ ) {
                    targetStack[targetDepth] = target2;
                    targetDepth++;
                    if (!(expandingFlags & 2 /* Target */ ) && isDeeplyNestedType(target2, targetStack, targetDepth)) expandingFlags |= 2 /* Target */ ;
                }
                let originalHandler;
                let propagatingVarianceFlags = 0;
                if (outofbandVarianceMarkerHandler) {
                    originalHandler = outofbandVarianceMarkerHandler;
                    outofbandVarianceMarkerHandler = (onlyUnreliable)=>{
                        propagatingVarianceFlags |= onlyUnreliable ? 16 /* ReportsUnreliable */  : 8 /* ReportsUnmeasurable */ ;
                        return originalHandler(onlyUnreliable);
                    };
                }
                let result2;
                if (expandingFlags === 3 /* Both */ ) {
                    (_a2 = tracing) == null || _a2.instant(tracing.Phase.CheckTypes, "recursiveTypeRelatedTo_DepthLimit", {
                        sourceId: source2.id,
                        sourceIdStack: sourceStack.map((t)=>t.id),
                        targetId: target2.id,
                        targetIdStack: targetStack.map((t)=>t.id),
                        depth: sourceDepth,
                        targetDepth
                    });
                    result2 = 3 /* Maybe */ ;
                } else {
                    (_b = tracing) == null || _b.push(tracing.Phase.CheckTypes, "structuredTypeRelatedTo", {
                        sourceId: source2.id,
                        targetId: target2.id
                    });
                    result2 = structuredTypeRelatedTo(source2, target2, reportErrors2, intersectionState);
                    (_c = tracing) == null || _c.pop();
                }
                if (outofbandVarianceMarkerHandler) outofbandVarianceMarkerHandler = originalHandler;
                if (recursionFlags & 1 /* Source */ ) sourceDepth--;
                if (recursionFlags & 2 /* Target */ ) targetDepth--;
                expandingFlags = saveExpandingFlags;
                if (result2) {
                    if (result2 === -1 /* True */  || sourceDepth === 0 && targetDepth === 0) {
                        if (result2 === -1 /* True */  || result2 === 3 /* Maybe */ ) resetMaybeStack(/*markAllAsSucceeded*/ true);
                        else resetMaybeStack(/*markAllAsSucceeded*/ false);
                    }
                } else {
                    relation.set(id, 2 /* Failed */  | propagatingVarianceFlags);
                    relationCount--;
                    resetMaybeStack(/*markAllAsSucceeded*/ false);
                }
                return result2;
                function resetMaybeStack(markAllAsSucceeded) {
                    for(let i = maybeStart; i < maybeCount; i++){
                        maybeKeysSet.delete(maybeKeys[i]);
                        if (markAllAsSucceeded) {
                            relation.set(maybeKeys[i], 1 /* Succeeded */  | propagatingVarianceFlags);
                            relationCount--;
                        }
                    }
                    maybeCount = maybeStart;
                }
            }
            function structuredTypeRelatedTo(source2, target2, reportErrors2, intersectionState) {
                const saveErrorInfo = captureErrorCalculationState();
                let result2 = structuredTypeRelatedToWorker(source2, target2, reportErrors2, intersectionState, saveErrorInfo);
                if (relation !== identityRelation) {
                    if (!result2 && (source2.flags & 2097152 /* Intersection */  || source2.flags & 262144 /* TypeParameter */  && target2.flags & 1048576 /* Union */ )) {
                        const constraint = getEffectiveConstraintOfIntersection(source2.flags & 2097152 /* Intersection */  ? source2.types : [
                            source2
                        ], !!(target2.flags & 1048576 /* Union */ ));
                        if (constraint && everyType(constraint, (c)=>c !== source2)) result2 = isRelatedTo(constraint, target2, 1 /* Source */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                    }
                    if (result2 && !(intersectionState & 2 /* Target */ ) && target2.flags & 2097152 /* Intersection */  && !isGenericObjectType(target2) && source2.flags & 2621440 /* Intersection */ ) {
                        result2 &= propertiesRelatedTo(source2, target2, reportErrors2, /*excludedProperties*/ void 0, /*optionalsOnly*/ false, 0 /* None */ );
                        if (result2 && isObjectLiteralType2(source2) && getObjectFlags(source2) & 8192 /* FreshLiteral */ ) result2 &= indexSignaturesRelatedTo(source2, target2, /*sourceIsPrimitive*/ false, reportErrors2, 0 /* None */ );
                    } else if (result2 && isNonGenericObjectType(target2) && !isArrayOrTupleType(target2) && source2.flags & 2097152 /* Intersection */  && getApparentType(source2).flags & 3670016 /* StructuredType */  && !some(source2.types, (t)=>t === target2 || !!(getObjectFlags(t) & 262144 /* NonInferrableType */ ))) result2 &= propertiesRelatedTo(source2, target2, reportErrors2, /*excludedProperties*/ void 0, /*optionalsOnly*/ true, intersectionState);
                }
                if (result2) resetErrorInfo(saveErrorInfo);
                return result2;
            }
            function getApparentMappedTypeKeys(nameType, targetType) {
                const modifiersType = getApparentType(getModifiersTypeFromMappedType(targetType));
                const mappedKeys = [];
                forEachMappedTypePropertyKeyTypeAndIndexSignatureKeyType(modifiersType, 8576 /* StringOrNumberLiteralOrUnique */ , /*stringsOnly*/ false, (t)=>void mappedKeys.push(instantiateType(nameType, appendTypeMapping(targetType.mapper, getTypeParameterFromMappedType(targetType), t))));
                return getUnionType(mappedKeys);
            }
            function structuredTypeRelatedToWorker(source2, target2, reportErrors2, intersectionState, saveErrorInfo) {
                let result2;
                let originalErrorInfo;
                let varianceCheckFailed = false;
                let sourceFlags = source2.flags;
                const targetFlags = target2.flags;
                if (relation === identityRelation) {
                    if (sourceFlags & 3145728 /* UnionOrIntersection */ ) {
                        let result3 = eachTypeRelatedToSomeType(source2, target2);
                        if (result3) result3 &= eachTypeRelatedToSomeType(target2, source2);
                        return result3;
                    }
                    if (sourceFlags & 4194304 /* Index */ ) return isRelatedTo(source2.type, target2.type, 3 /* Both */ , /*reportErrors*/ false);
                    if (sourceFlags & 8388608 /* IndexedAccess */ ) {
                        if (result2 = isRelatedTo(source2.objectType, target2.objectType, 3 /* Both */ , /*reportErrors*/ false)) {
                            if (result2 &= isRelatedTo(source2.indexType, target2.indexType, 3 /* Both */ , /*reportErrors*/ false)) return result2;
                        }
                    }
                    if (sourceFlags & 16777216 /* Conditional */ ) {
                        if (source2.root.isDistributive === target2.root.isDistributive) {
                            if (result2 = isRelatedTo(source2.checkType, target2.checkType, 3 /* Both */ , /*reportErrors*/ false)) {
                                if (result2 &= isRelatedTo(source2.extendsType, target2.extendsType, 3 /* Both */ , /*reportErrors*/ false)) {
                                    if (result2 &= isRelatedTo(getTrueTypeFromConditionalType(source2), getTrueTypeFromConditionalType(target2), 3 /* Both */ , /*reportErrors*/ false)) {
                                        if (result2 &= isRelatedTo(getFalseTypeFromConditionalType(source2), getFalseTypeFromConditionalType(target2), 3 /* Both */ , /*reportErrors*/ false)) return result2;
                                    }
                                }
                            }
                        }
                    }
                    if (sourceFlags & 33554432 /* Substitution */ ) {
                        if (result2 = isRelatedTo(source2.baseType, target2.baseType, 3 /* Both */ , /*reportErrors*/ false)) {
                            if (result2 &= isRelatedTo(source2.constraint, target2.constraint, 3 /* Both */ , /*reportErrors*/ false)) return result2;
                        }
                    }
                    if (sourceFlags & 134217728 /* TemplateLiteral */ ) {
                        if (arrayIsEqualTo(source2.texts, target2.texts)) {
                            const sourceTypes = source2.types;
                            const targetTypes = target2.types;
                            result2 = -1 /* True */ ;
                            for(let i = 0; i < sourceTypes.length; i++){
                                if (!(result2 &= isRelatedTo(sourceTypes[i], targetTypes[i], 3 /* Both */ , /*reportErrors*/ false))) break;
                            }
                            return result2;
                        }
                    }
                    if (sourceFlags & 268435456 /* StringMapping */ ) {
                        if (source2.symbol === target2.symbol) return isRelatedTo(source2.type, target2.type, 3 /* Both */ , /*reportErrors*/ false);
                    }
                    if (!(sourceFlags & 524288 /* Object */ )) return 0 /* False */ ;
                } else if (sourceFlags & 3145728 /* UnionOrIntersection */  || targetFlags & 3145728 /* UnionOrIntersection */ ) {
                    if (result2 = unionOrIntersectionRelatedTo(source2, target2, reportErrors2, intersectionState)) return result2;
                    if (!(sourceFlags & 465829888 /* Instantiable */  || sourceFlags & 524288 /* Object */  && targetFlags & 1048576 /* Union */  || sourceFlags & 2097152 /* Intersection */  && targetFlags & 467402752 /* Instantiable */ )) return 0 /* False */ ;
                }
                if (sourceFlags & 17301504 /* Conditional */  && source2.aliasSymbol && source2.aliasTypeArguments && source2.aliasSymbol === target2.aliasSymbol && !(isMarkerType(source2) || isMarkerType(target2))) {
                    const variances = getAliasVariances(source2.aliasSymbol);
                    if (variances === emptyArray) return 1 /* Unknown */ ;
                    const params = getSymbolLinks(source2.aliasSymbol).typeParameters;
                    const minParams = getMinTypeArgumentCount(params);
                    const sourceTypes = fillMissingTypeArguments(source2.aliasTypeArguments, params, minParams, isInJSFile(source2.aliasSymbol.valueDeclaration));
                    const targetTypes = fillMissingTypeArguments(target2.aliasTypeArguments, params, minParams, isInJSFile(source2.aliasSymbol.valueDeclaration));
                    const varianceResult = relateVariances(sourceTypes, targetTypes, variances, intersectionState);
                    if (varianceResult !== void 0) return varianceResult;
                }
                if (isSingleElementGenericTupleType(source2) && !source2.target.readonly && (result2 = isRelatedTo(getTypeArguments(source2)[0], target2, 1 /* Source */ )) || isSingleElementGenericTupleType(target2) && (target2.target.readonly || isMutableArrayOrTuple(getBaseConstraintOfType(source2) || source2)) && (result2 = isRelatedTo(source2, getTypeArguments(target2)[0], 2 /* Target */ ))) return result2;
                if (targetFlags & 262144 /* TypeParameter */ ) {
                    if (getObjectFlags(source2) & 32 /* Mapped */  && !source2.declaration.nameType && isRelatedTo(getIndexType(target2), getConstraintTypeFromMappedType(source2), 3 /* Both */ )) {
                        if (!(getMappedTypeModifiers(source2) & 4 /* IncludeOptional */ )) {
                            const templateType = getTemplateTypeFromMappedType(source2);
                            const indexedAccessType = getIndexedAccessType(target2, getTypeParameterFromMappedType(source2));
                            if (result2 = isRelatedTo(templateType, indexedAccessType, 3 /* Both */ , reportErrors2)) return result2;
                        }
                    }
                    if (relation === comparableRelation && sourceFlags & 262144 /* TypeParameter */ ) {
                        let constraint = getConstraintOfTypeParameter(source2);
                        if (constraint) while(constraint && someType(constraint, (c)=>!!(c.flags & 262144 /* TypeParameter */ ))){
                            if (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , /*reportErrors*/ false)) return result2;
                            constraint = getConstraintOfTypeParameter(constraint);
                        }
                        return 0 /* False */ ;
                    }
                } else if (targetFlags & 4194304 /* Index */ ) {
                    const targetType = target2.type;
                    if (sourceFlags & 4194304 /* Index */ ) {
                        if (result2 = isRelatedTo(targetType, source2.type, 3 /* Both */ , /*reportErrors*/ false)) return result2;
                    }
                    if (isTupleType(targetType)) {
                        if (result2 = isRelatedTo(source2, getKnownKeysOfTupleType(targetType), 2 /* Target */ , reportErrors2)) return result2;
                    } else {
                        const constraint = getSimplifiedTypeOrConstraint(targetType);
                        if (constraint) {
                            if (isRelatedTo(source2, getIndexType(constraint, target2.indexFlags | 4 /* NoReducibleCheck */ ), 2 /* Target */ , reportErrors2) === -1 /* True */ ) return -1 /* True */ ;
                        } else if (isGenericMappedType(targetType)) {
                            const nameType = getNameTypeFromMappedType(targetType);
                            const constraintType = getConstraintTypeFromMappedType(targetType);
                            let targetKeys;
                            if (nameType && isMappedTypeWithKeyofConstraintDeclaration(targetType)) {
                                const mappedKeys = getApparentMappedTypeKeys(nameType, targetType);
                                targetKeys = getUnionType([
                                    mappedKeys,
                                    nameType
                                ]);
                            } else targetKeys = nameType || constraintType;
                            if (isRelatedTo(source2, targetKeys, 2 /* Target */ , reportErrors2) === -1 /* True */ ) return -1 /* True */ ;
                        }
                    }
                } else if (targetFlags & 8388608 /* IndexedAccess */ ) {
                    if (sourceFlags & 8388608 /* IndexedAccess */ ) {
                        if (result2 = isRelatedTo(source2.objectType, target2.objectType, 3 /* Both */ , reportErrors2)) result2 &= isRelatedTo(source2.indexType, target2.indexType, 3 /* Both */ , reportErrors2);
                        if (result2) return result2;
                        if (reportErrors2) originalErrorInfo = errorInfo;
                    }
                    if (relation === assignableRelation || relation === comparableRelation) {
                        const objectType = target2.objectType;
                        const indexType = target2.indexType;
                        const baseObjectType = getBaseConstraintOfType(objectType) || objectType;
                        const baseIndexType = getBaseConstraintOfType(indexType) || indexType;
                        if (!isGenericObjectType(baseObjectType) && !isGenericIndexType(baseIndexType)) {
                            const accessFlags = 4 /* Writing */  | (baseObjectType !== objectType ? 2 /* NoIndexSignatures */  : 0);
                            const constraint = getIndexedAccessTypeOrUndefined(baseObjectType, baseIndexType, accessFlags);
                            if (constraint) {
                                if (reportErrors2 && originalErrorInfo) resetErrorInfo(saveErrorInfo);
                                if (result2 = isRelatedTo(source2, constraint, 2 /* Target */ , reportErrors2, /*headMessage*/ void 0, intersectionState)) return result2;
                                if (reportErrors2 && originalErrorInfo && errorInfo) errorInfo = countMessageChainBreadth([
                                    originalErrorInfo
                                ]) <= countMessageChainBreadth([
                                    errorInfo
                                ]) ? originalErrorInfo : errorInfo;
                            }
                        }
                    }
                    if (reportErrors2) originalErrorInfo = void 0;
                } else if (isGenericMappedType(target2) && relation !== identityRelation) {
                    const keysRemapped = !!target2.declaration.nameType;
                    const templateType = getTemplateTypeFromMappedType(target2);
                    const modifiers = getMappedTypeModifiers(target2);
                    if (!(modifiers & 8 /* ExcludeOptional */ )) {
                        if (!keysRemapped && templateType.flags & 8388608 /* IndexedAccess */  && templateType.objectType === source2 && templateType.indexType === getTypeParameterFromMappedType(target2)) return -1 /* True */ ;
                        if (!isGenericMappedType(source2)) {
                            const targetKeys = keysRemapped ? getNameTypeFromMappedType(target2) : getConstraintTypeFromMappedType(target2);
                            const sourceKeys = getIndexType(source2, 2 /* NoIndexSignatures */ );
                            const includeOptional = modifiers & 4 /* IncludeOptional */ ;
                            const filteredByApplicability = includeOptional ? intersectTypes(targetKeys, sourceKeys) : void 0;
                            if (includeOptional ? !(filteredByApplicability.flags & 131072 /* Never */ ) : isRelatedTo(targetKeys, sourceKeys, 3 /* Both */ )) {
                                const templateType2 = getTemplateTypeFromMappedType(target2);
                                const typeParameter = getTypeParameterFromMappedType(target2);
                                const nonNullComponent = extractTypesOfKind(templateType2, -98305 /* Nullable */ );
                                if (!keysRemapped && nonNullComponent.flags & 8388608 /* IndexedAccess */  && nonNullComponent.indexType === typeParameter) {
                                    if (result2 = isRelatedTo(source2, nonNullComponent.objectType, 2 /* Target */ , reportErrors2)) return result2;
                                } else {
                                    const indexingType = keysRemapped ? filteredByApplicability || targetKeys : filteredByApplicability ? getIntersectionType([
                                        filteredByApplicability,
                                        typeParameter
                                    ]) : typeParameter;
                                    const indexedAccessType = getIndexedAccessType(source2, indexingType);
                                    if (result2 = isRelatedTo(indexedAccessType, templateType2, 3 /* Both */ , reportErrors2)) return result2;
                                }
                            }
                            originalErrorInfo = errorInfo;
                            resetErrorInfo(saveErrorInfo);
                        }
                    }
                } else if (targetFlags & 16777216 /* Conditional */ ) {
                    if (isDeeplyNestedType(target2, targetStack, targetDepth, 10)) return 3 /* Maybe */ ;
                    const c = target2;
                    if (!c.root.inferTypeParameters && !isDistributionDependent(c.root) && !(source2.flags & 16777216 /* Conditional */  && source2.root === c.root)) {
                        const skipTrue = !isTypeAssignableTo(getPermissiveInstantiation(c.checkType), getPermissiveInstantiation(c.extendsType));
                        const skipFalse = !skipTrue && isTypeAssignableTo(getRestrictiveInstantiation(c.checkType), getRestrictiveInstantiation(c.extendsType));
                        if (result2 = skipTrue ? -1 /* True */  : isRelatedTo(source2, getTrueTypeFromConditionalType(c), 2 /* Target */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState)) {
                            result2 &= skipFalse ? -1 /* True */  : isRelatedTo(source2, getFalseTypeFromConditionalType(c), 2 /* Target */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState);
                            if (result2) return result2;
                        }
                    }
                } else if (targetFlags & 134217728 /* TemplateLiteral */ ) {
                    if (sourceFlags & 134217728 /* TemplateLiteral */ ) {
                        if (relation === comparableRelation) return templateLiteralTypesDefinitelyUnrelated(source2, target2) ? 0 /* False */  : -1 /* True */ ;
                        instantiateType(source2, reportUnreliableMapper);
                    }
                    if (isTypeMatchedByTemplateLiteralType(source2, target2)) return -1 /* True */ ;
                } else if (target2.flags & 268435456 /* StringMapping */ ) {
                    if (!(source2.flags & 268435456 /* StringMapping */ )) {
                        if (isMemberOfStringMapping(source2, target2)) return -1 /* True */ ;
                    }
                }
                if (sourceFlags & 8650752 /* TypeVariable */ ) {
                    if (!(sourceFlags & 8388608 /* IndexedAccess */  && targetFlags & 8388608 /* IndexedAccess */ )) {
                        const constraint = getConstraintOfType(source2) || unknownType;
                        if (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , /*reportErrors*/ false, /*headMessage*/ void 0, intersectionState)) return result2;
                        else if (result2 = isRelatedTo(getTypeWithThisArgument(constraint, source2), target2, 1 /* Source */ , reportErrors2 && constraint !== unknownType && !(targetFlags & sourceFlags & 262144 /* TypeParameter */ ), /*headMessage*/ void 0, intersectionState)) return result2;
                        if (isMappedTypeGenericIndexedAccess(source2)) {
                            const indexConstraint = getConstraintOfType(source2.indexType);
                            if (indexConstraint) {
                                if (result2 = isRelatedTo(getIndexedAccessType(source2.objectType, indexConstraint), target2, 1 /* Source */ , reportErrors2)) return result2;
                            }
                        }
                    }
                } else if (sourceFlags & 4194304 /* Index */ ) {
                    const isDeferredMappedIndex = shouldDeferIndexType(source2.type, source2.indexFlags) && getObjectFlags(source2.type) & 32 /* Mapped */ ;
                    if (result2 = isRelatedTo(stringNumberSymbolType, target2, 1 /* Source */ , reportErrors2 && !isDeferredMappedIndex)) return result2;
                    if (isDeferredMappedIndex) {
                        const mappedType = source2.type;
                        const nameType = getNameTypeFromMappedType(mappedType);
                        const sourceMappedKeys = nameType && isMappedTypeWithKeyofConstraintDeclaration(mappedType) ? getApparentMappedTypeKeys(nameType, mappedType) : nameType || getConstraintTypeFromMappedType(mappedType);
                        if (result2 = isRelatedTo(sourceMappedKeys, target2, 1 /* Source */ , reportErrors2)) return result2;
                    }
                } else if (sourceFlags & 134217728 /* TemplateLiteral */  && !(targetFlags & 524288 /* Object */ )) {
                    if (!(targetFlags & 134217728 /* TemplateLiteral */ )) {
                        const constraint = getBaseConstraintOfType(source2);
                        if (constraint && constraint !== source2 && (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , reportErrors2))) return result2;
                    }
                } else if (sourceFlags & 268435456 /* StringMapping */ ) {
                    if (targetFlags & 268435456 /* StringMapping */ ) {
                        if (source2.symbol !== target2.symbol) return 0 /* False */ ;
                        if (result2 = isRelatedTo(source2.type, target2.type, 3 /* Both */ , reportErrors2)) return result2;
                    } else {
                        const constraint = getBaseConstraintOfType(source2);
                        if (constraint && (result2 = isRelatedTo(constraint, target2, 1 /* Source */ , reportErrors2))) return result2;
                    }
                } else if (sourceFlags & 16777216 /* Conditional */ ) {
                    if (isDeeplyNestedType(source2, sourceStack, sourceDepth, 10)) return 3 /* Maybe */ ;
                    if (targetFlags & 16777216 /* Conditional */ ) {
                        const sourceParams = source2.root.inferTypeParameters;
                        let sourceExtends = source2.extendsType;
                        let mapper;
                        if (sourceParams) {
                            const ctx = createInferenceContext(sourceParams, /*signature*/ void 0, 0 /* None */ , isRelatedToWorker);
                            inferTypes(ctx.inferences, target2.extendsType, sourceExtends, 1536 /* AlwaysStrict */ );
                            sourceExtends = instantiateType(sourceExtends, ctx.mapper);
                            mapper = ctx.mapper;
                        }
                        if (isTypeIdenticalTo(sourceExtends, target2.extendsType) && (isRelatedTo(source2.checkType, target2.checkType, 3 /* Both */ ) || isRelatedTo(target2.checkType, source2.checkType, 3 /* Both */ ))) {
                            if (result2 = isRelatedTo(instantiateType(getTrueTypeFromConditionalType(source2), mapper), getTrueTypeFromConditionalType(target2), 3 /* Both */ , reportErrors2)) result2 &= isRelatedTo(getFalseTypeFromConditionalType(source2), getFalseTypeFromConditionalType(target2), 3 /* Both */ , reportErrors2);
                            if (result2) return result2;
                        }
                    }
                    const defaultConstraint = getDefaultConstraintOfConditionalType(source2);
                    if (defaultConstraint) {
                        if (result2 = isRelatedTo(defaultConstraint, target2, 1 /* Source */ , reportErrors2)) return result2;
                    }
                    const distributiveConstraint = !(targetFlags & 16777216 /* Conditional */ ) && hasNonCircularBaseConstraint(source2) ? getConstraintOfDistributiveConditionalType(source2) : void 0;
                    if (distributiveConstraint) {
                        resetErrorInfo(saveErrorInfo);
                        if (result2 = isRelatedTo(distributiveConstraint, target2, 1 /* Source */ , reportErrors2)) return result2;
                    }
                } else {
                    if (relation !== subtypeRelation && relation !== strictSubtypeRelation && isPartialMappedType(target2) && isEmptyObjectType(source2)) return -1 /* True */ ;
                    if (isGenericMappedType(target2)) {
                        if (isGenericMappedType(source2)) {
                            if (result2 = mappedTypeRelatedTo(source2, target2, reportErrors2)) return result2;
                        }
                        return 0 /* False */ ;
                    }
                    const sourceIsPrimitive = !!(sourceFlags & 402784252 /* Primitive */ );
                    if (relation !== identityRelation) {
                        source2 = getApparentType(source2);
                        sourceFlags = source2.flags;
                    } else if (isGenericMappedType(source2)) return 0 /* False */ ;
                    if (getObjectFlags(source2) & 4 /* Reference */  && getObjectFlags(target2) & 4 /* Reference */  && source2.target === target2.target && !isTupleType(source2) && !(isMarkerType(source2) || isMarkerType(target2))) {
                        if (isEmptyArrayLiteralType(source2)) return -1 /* True */ ;
                        const variances = getVariances(source2.target);
                        if (variances === emptyArray) return 1 /* Unknown */ ;
                        const varianceResult = relateVariances(getTypeArguments(source2), getTypeArguments(target2), variances, intersectionState);
                        if (varianceResult !== void 0) return varianceResult;
                    } else if (isReadonlyArrayType(target2) ? everyType(source2, isArrayOrTupleType) : isArrayType(target2) && everyType(source2, (t)=>isTupleType(t) && !t.target.readonly)) {
                        if (relation !== identityRelation) return isRelatedTo(getIndexTypeOfType(source2, numberType) || anyType, getIndexTypeOfType(target2, numberType) || anyType, 3 /* Both */ , reportErrors2);
                        else return 0 /* False */ ;
                    } else if (isGenericTupleType(source2) && isTupleType(target2) && !isGenericTupleType(target2)) {
                        const constraint = getBaseConstraintOrType(source2);
                        if (constraint !== source2) return isRelatedTo(constraint, target2, 1 /* Source */ , reportErrors2);
                    } else if ((relation === subtypeRelation || relation === strictSubtypeRelation) && isEmptyObjectType(target2) && getObjectFlags(target2) & 8192 /* FreshLiteral */  && !isEmptyObjectType(source2)) return 0 /* False */ ;
                    if (sourceFlags & 2621440 /* Intersection */  && targetFlags & 524288 /* Object */ ) {
                        const reportStructuralErrors = reportErrors2 && errorInfo === saveErrorInfo.errorInfo && !sourceIsPrimitive;
                        result2 = propertiesRelatedTo(source2, target2, reportStructuralErrors, /*excludedProperties*/ void 0, /*optionalsOnly*/ false, intersectionState);
                        if (result2) {
                            result2 &= signaturesRelatedTo(source2, target2, 0 /* Call */ , reportStructuralErrors, intersectionState);
                            if (result2) {
                                result2 &= signaturesRelatedTo(source2, target2, 1 /* Construct */ , reportStructuralErrors, intersectionState);
                                if (result2) result2 &= indexSignaturesRelatedTo(source2, target2, sourceIsPrimitive, reportStructuralErrors, intersectionState);
                            }
                        }
                        if (varianceCheckFailed && result2) errorInfo = originalErrorInfo || errorInfo || saveErrorInfo.errorInfo;
                        else if (result2) return result2;
                    }
                    if (sourceFlags & 2621440 /* Intersection */  && targetFlags & 1048576 /* Union */ ) {
                        const objectOnlyTarget = extractTypesOfKind(target2, 36175872 /* Substitution */ );
                        if (objectOnlyTarget.flags & 1048576 /* Union */ ) {
                            const result3 = typeRelatedToDiscriminatedType(source2, objectOnlyTarget);
                            if (result3) return result3;
                        }
                    }
                }
                return 0 /* False */ ;
                function countMessageChainBreadth(info) {
                    if (!info) return 0;
                    return reduceLeft(info, (value1, chain)=>value1 + 1 + countMessageChainBreadth(chain.next), 0);
                }
                function relateVariances(sourceTypeArguments, targetTypeArguments, variances, intersectionState2) {
                    if (result2 = typeArgumentsRelatedTo(sourceTypeArguments, targetTypeArguments, variances, reportErrors2, intersectionState2)) return result2;
                    if (some(variances, (v1)=>!!(v1 & 24 /* AllowsStructuralFallback */ ))) {
                        originalErrorInfo = void 0;
                        resetErrorInfo(saveErrorInfo);
                        return void 0;
                    }
                    const allowStructuralFallback = targetTypeArguments && hasCovariantVoidArgument(targetTypeArguments, variances);
                    varianceCheckFailed = !allowStructuralFallback;
                    if (variances !== emptyArray && !allowStructuralFallback) {
                        if (varianceCheckFailed && !(reportErrors2 && some(variances, (v1)=>(v1 & 7 /* VarianceMask */ ) === 0 /* Invariant */ ))) return 0 /* False */ ;
                        originalErrorInfo = errorInfo;
                        resetErrorInfo(saveErrorInfo);
                    }
                }
            }
            function mappedTypeRelatedTo(source2, target2, reportErrors2) {
                const modifiersRelated = relation === comparableRelation || (relation === identityRelation ? getMappedTypeModifiers(source2) === getMappedTypeModifiers(target2) : getCombinedMappedTypeOptionality(source2) <= getCombinedMappedTypeOptionality(target2));
                if (modifiersRelated) {
                    let result2;
                    const targetConstraint = getConstraintTypeFromMappedType(target2);
                    const sourceConstraint = instantiateType(getConstraintTypeFromMappedType(source2), getCombinedMappedTypeOptionality(source2) < 0 ? reportUnmeasurableMapper : reportUnreliableMapper);
                    if (result2 = isRelatedTo(targetConstraint, sourceConstraint, 3 /* Both */ , reportErrors2)) {
                        const mapper = createTypeMapper([
                            getTypeParameterFromMappedType(source2)
                        ], [
                            getTypeParameterFromMappedType(target2)
                        ]);
                        if (instantiateType(getNameTypeFromMappedType(source2), mapper) === instantiateType(getNameTypeFromMappedType(target2), mapper)) return result2 & isRelatedTo(instantiateType(getTemplateTypeFromMappedType(source2), mapper), getTemplateTypeFromMappedType(target2), 3 /* Both */ , reportErrors2);
                    }
                }
                return 0 /* False */ ;
            }
            function typeRelatedToDiscriminatedType(source2, target2) {
                var _a2;
                const sourceProperties = getPropertiesOfType(source2);
                const sourcePropertiesFiltered = findDiscriminantProperties(sourceProperties, target2);
                if (!sourcePropertiesFiltered) return 0 /* False */ ;
                let numCombinations = 1;
                for (const sourceProperty of sourcePropertiesFiltered){
                    numCombinations *= countTypes(getNonMissingTypeOfSymbol(sourceProperty));
                    if (numCombinations > 25) {
                        (_a2 = tracing) == null || _a2.instant(tracing.Phase.CheckTypes, "typeRelatedToDiscriminatedType_DepthLimit", {
                            sourceId: source2.id,
                            targetId: target2.id,
                            numCombinations
                        });
                        return 0 /* False */ ;
                    }
                }
                const sourceDiscriminantTypes = new Array(sourcePropertiesFiltered.length);
                const excludedProperties = /* @__PURE__ */ new Set();
                for(let i = 0; i < sourcePropertiesFiltered.length; i++){
                    const sourceProperty = sourcePropertiesFiltered[i];
                    const sourcePropertyType = getNonMissingTypeOfSymbol(sourceProperty);
                    sourceDiscriminantTypes[i] = sourcePropertyType.flags & 1048576 /* Union */  ? sourcePropertyType.types : [
                        sourcePropertyType
                    ];
                    excludedProperties.add(sourceProperty.escapedName);
                }
                const discriminantCombinations = cartesianProduct(sourceDiscriminantTypes);
                const matchingTypes = [];
                for (const combination of discriminantCombinations){
                    let hasMatch = false;
                    outer: for (const type of target2.types){
                        for(let i = 0; i < sourcePropertiesFiltered.length; i++){
                            const sourceProperty = sourcePropertiesFiltered[i];
                            const targetProperty = getPropertyOfType(type, sourceProperty.escapedName);
                            if (!targetProperty) continue outer;
                            if (sourceProperty === targetProperty) continue;
                            const related = propertyRelatedTo(source2, target2, sourceProperty, targetProperty, (_)=>combination[i], /*reportErrors*/ false, 0 /* None */ , /*skipOptional*/ strictNullChecks || relation === comparableRelation);
                            if (!related) continue outer;
                        }
                        pushIfUnique(matchingTypes, type, equateValues);
                        hasMatch = true;
                    }
                    if (!hasMatch) return 0 /* False */ ;
                }
                let result2 = -1 /* True */ ;
                for (const type of matchingTypes){
                    result2 &= propertiesRelatedTo(source2, type, /*reportErrors*/ false, excludedProperties, /*optionalsOnly*/ false, 0 /* None */ );
                    if (result2) {
                        result2 &= signaturesRelatedTo(source2, type, 0 /* Call */ , /*reportErrors*/ false, 0 /* None */ );
                        if (result2) {
                            result2 &= signaturesRelatedTo(source2, type, 1 /* Construct */ , /*reportErrors*/ false, 0 /* None */ );
                            if (result2 && !(isTupleType(source2) && isTupleType(type))) result2 &= indexSignaturesRelatedTo(source2, type, /*sourceIsPrimitive*/ false, /*reportErrors*/ false, 0 /* None */ );
                        }
                    }
                    if (!result2) return result2;
                }
                return result2;
            }
            function excludeProperties(properties, excludedProperties) {
                if (!excludedProperties || properties.length === 0) return properties;
                let result2;
                for(let i = 0; i < properties.length; i++){
                    if (!excludedProperties.has(properties[i].escapedName)) {
                        if (result2) result2.push(properties[i]);
                    } else if (!result2) result2 = properties.slice(0, i);
                }
                return result2 || properties;
            }
            function isPropertySymbolTypeRelated(sourceProp, targetProp, getTypeOfSourceProperty, reportErrors2, intersectionState) {
                const targetIsOptional = strictNullChecks && !!(getCheckFlags(targetProp) & 48 /* Partial */ );
                const effectiveTarget = addOptionality(getNonMissingTypeOfSymbol(targetProp), /*isProperty*/ false, targetIsOptional);
                if (effectiveTarget.flags & (relation === strictSubtypeRelation ? 1 /* Any */  : 3 /* AnyOrUnknown */ )) return -1 /* True */ ;
                const effectiveSource = getTypeOfSourceProperty(sourceProp);
                return isRelatedTo(effectiveSource, effectiveTarget, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
            }
            function propertyRelatedTo(source2, target2, sourceProp, targetProp, getTypeOfSourceProperty, reportErrors2, intersectionState, skipOptional) {
                const sourcePropFlags = getDeclarationModifierFlagsFromSymbol(sourceProp);
                const targetPropFlags = getDeclarationModifierFlagsFromSymbol(targetProp);
                if (sourcePropFlags & 2 /* Private */  || targetPropFlags & 2 /* Private */ ) {
                    if (sourceProp.valueDeclaration !== targetProp.valueDeclaration) {
                        if (reportErrors2) {
                            if (sourcePropFlags & 2 /* Private */  && targetPropFlags & 2 /* Private */ ) reportError(Diagnostics.Types_have_separate_declarations_of_a_private_property_0, symbolToString(targetProp));
                            else reportError(Diagnostics.Property_0_is_private_in_type_1_but_not_in_type_2, symbolToString(targetProp), typeToString(sourcePropFlags & 2 /* Private */  ? source2 : target2), typeToString(sourcePropFlags & 2 /* Private */  ? target2 : source2));
                        }
                        return 0 /* False */ ;
                    }
                } else if (targetPropFlags & 4 /* Protected */ ) {
                    if (!isValidOverrideOf(sourceProp, targetProp)) {
                        if (reportErrors2) reportError(Diagnostics.Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2, symbolToString(targetProp), typeToString(getDeclaringClass(sourceProp) || source2), typeToString(getDeclaringClass(targetProp) || target2));
                        return 0 /* False */ ;
                    }
                } else if (sourcePropFlags & 4 /* Protected */ ) {
                    if (reportErrors2) reportError(Diagnostics.Property_0_is_protected_in_type_1_but_public_in_type_2, symbolToString(targetProp), typeToString(source2), typeToString(target2));
                    return 0 /* False */ ;
                }
                if (relation === strictSubtypeRelation && isReadonlySymbol(sourceProp) && !isReadonlySymbol(targetProp)) return 0 /* False */ ;
                const related = isPropertySymbolTypeRelated(sourceProp, targetProp, getTypeOfSourceProperty, reportErrors2, intersectionState);
                if (!related) {
                    if (reportErrors2) reportIncompatibleError(Diagnostics.Types_of_property_0_are_incompatible, symbolToString(targetProp));
                    return 0 /* False */ ;
                }
                if (!skipOptional && sourceProp.flags & 16777216 /* Optional */  && targetProp.flags & 106500 /* ClassMember */  && !(targetProp.flags & 16777216 /* Optional */ )) {
                    if (reportErrors2) reportError(Diagnostics.Property_0_is_optional_in_type_1_but_required_in_type_2, symbolToString(targetProp), typeToString(source2), typeToString(target2));
                    return 0 /* False */ ;
                }
                return related;
            }
            function reportUnmatchedProperty(source2, target2, unmatchedProperty, requireOptionalProperties) {
                let shouldSkipElaboration = false;
                if (unmatchedProperty.valueDeclaration && isNamedDeclaration(unmatchedProperty.valueDeclaration) && isPrivateIdentifier(unmatchedProperty.valueDeclaration.name) && source2.symbol && source2.symbol.flags & 32 /* Class */ ) {
                    const privateIdentifierDescription = unmatchedProperty.valueDeclaration.name.escapedText;
                    const symbolTableKey = getSymbolNameForPrivateIdentifier(source2.symbol, privateIdentifierDescription);
                    if (symbolTableKey && getPropertyOfType(source2, symbolTableKey)) {
                        const sourceName = factory.getDeclarationName(source2.symbol.valueDeclaration);
                        const targetName = factory.getDeclarationName(target2.symbol.valueDeclaration);
                        reportError(Diagnostics.Property_0_in_type_1_refers_to_a_different_member_that_cannot_be_accessed_from_within_type_2, diagnosticName(privateIdentifierDescription), diagnosticName(sourceName.escapedText === "" ? anon : sourceName), diagnosticName(targetName.escapedText === "" ? anon : targetName));
                        return;
                    }
                }
                const props = arrayFrom(getUnmatchedProperties(source2, target2, requireOptionalProperties, /*matchDiscriminantProperties*/ false));
                if (!headMessage || headMessage.code !== Diagnostics.Class_0_incorrectly_implements_interface_1.code && headMessage.code !== Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass.code) shouldSkipElaboration = true;
                if (props.length === 1) {
                    const propName = symbolToString(unmatchedProperty, /*enclosingDeclaration*/ void 0, 0 /* None */ , 20 /* WriteComputedProps */ );
                    reportError(Diagnostics.Property_0_is_missing_in_type_1_but_required_in_type_2, propName, ...getTypeNamesForErrorDisplay(source2, target2));
                    if (length(unmatchedProperty.declarations)) associateRelatedInfo(createDiagnosticForNode(unmatchedProperty.declarations[0], Diagnostics._0_is_declared_here, propName));
                    if (shouldSkipElaboration && errorInfo) overrideNextErrorInfo++;
                } else if (tryElaborateArrayLikeErrors(source2, target2, /*reportErrors*/ false)) {
                    if (props.length > 5) reportError(Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more, typeToString(source2), typeToString(target2), map(props.slice(0, 4), (p)=>symbolToString(p)).join(", "), props.length - 4);
                    else reportError(Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2, typeToString(source2), typeToString(target2), map(props, (p)=>symbolToString(p)).join(", "));
                    if (shouldSkipElaboration && errorInfo) overrideNextErrorInfo++;
                }
            }
            function propertiesRelatedTo(source2, target2, reportErrors2, excludedProperties, optionalsOnly, intersectionState) {
                if (relation === identityRelation) return propertiesIdenticalTo(source2, target2, excludedProperties);
                let result2 = -1 /* True */ ;
                if (isTupleType(target2)) {
                    if (isArrayOrTupleType(source2)) {
                        if (!target2.target.readonly && (isReadonlyArrayType(source2) || isTupleType(source2) && source2.target.readonly)) return 0 /* False */ ;
                        const sourceArity = getTypeReferenceArity(source2);
                        const targetArity = getTypeReferenceArity(target2);
                        const sourceRestFlag = isTupleType(source2) ? source2.target.combinedFlags & 4 /* Rest */  : 4 /* Rest */ ;
                        const targetHasRestElement = !!(target2.target.combinedFlags & 12 /* Variable */ );
                        const sourceMinLength = isTupleType(source2) ? source2.target.minLength : 0;
                        const targetMinLength = target2.target.minLength;
                        if (!sourceRestFlag && sourceArity < targetMinLength) {
                            if (reportErrors2) reportError(Diagnostics.Source_has_0_element_s_but_target_requires_1, sourceArity, targetMinLength);
                            return 0 /* False */ ;
                        }
                        if (!targetHasRestElement && targetArity < sourceMinLength) {
                            if (reportErrors2) reportError(Diagnostics.Source_has_0_element_s_but_target_allows_only_1, sourceMinLength, targetArity);
                            return 0 /* False */ ;
                        }
                        if (!targetHasRestElement && (sourceRestFlag || targetArity < sourceArity)) {
                            if (reportErrors2) {
                                if (sourceMinLength < targetMinLength) reportError(Diagnostics.Target_requires_0_element_s_but_source_may_have_fewer, targetMinLength);
                                else reportError(Diagnostics.Target_allows_only_0_element_s_but_source_may_have_more, targetArity);
                            }
                            return 0 /* False */ ;
                        }
                        const sourceTypeArguments = getTypeArguments(source2);
                        const targetTypeArguments = getTypeArguments(target2);
                        const targetStartCount = getStartElementCount(target2.target, 11 /* NonRest */ );
                        const targetEndCount = getEndElementCount(target2.target, 11 /* NonRest */ );
                        let canExcludeDiscriminants = !!excludedProperties;
                        for(let sourcePosition = 0; sourcePosition < sourceArity; sourcePosition++){
                            const sourceFlags = isTupleType(source2) ? source2.target.elementFlags[sourcePosition] : 4 /* Rest */ ;
                            const sourcePositionFromEnd = sourceArity - 1 - sourcePosition;
                            const targetPosition = targetHasRestElement && sourcePosition >= targetStartCount ? targetArity - 1 - Math.min(sourcePositionFromEnd, targetEndCount) : sourcePosition;
                            const targetFlags = target2.target.elementFlags[targetPosition];
                            if (targetFlags & 8 /* Variadic */  && !(sourceFlags & 8 /* Variadic */ )) {
                                if (reportErrors2) reportError(Diagnostics.Source_provides_no_match_for_variadic_element_at_position_0_in_target, targetPosition);
                                return 0 /* False */ ;
                            }
                            if (sourceFlags & 8 /* Variadic */  && !(targetFlags & 12 /* Variable */ )) {
                                if (reportErrors2) reportError(Diagnostics.Variadic_element_at_position_0_in_source_does_not_match_element_at_position_1_in_target, sourcePosition, targetPosition);
                                return 0 /* False */ ;
                            }
                            if (targetFlags & 1 /* Required */  && !(sourceFlags & 1 /* Required */ )) {
                                if (reportErrors2) reportError(Diagnostics.Source_provides_no_match_for_required_element_at_position_0_in_target, targetPosition);
                                return 0 /* False */ ;
                            }
                            if (canExcludeDiscriminants) {
                                if (sourceFlags & 12 /* Variable */  || targetFlags & 12 /* Variable */ ) canExcludeDiscriminants = false;
                                if (canExcludeDiscriminants && (excludedProperties == null ? void 0 : excludedProperties.has("" + sourcePosition))) continue;
                            }
                            const sourceType = removeMissingType(sourceTypeArguments[sourcePosition], !!(sourceFlags & targetFlags & 2 /* Optional */ ));
                            const targetType = targetTypeArguments[targetPosition];
                            const targetCheckType = sourceFlags & 8 /* Variadic */  && targetFlags & 4 /* Rest */  ? createArrayType(targetType) : removeMissingType(targetType, !!(targetFlags & 2 /* Optional */ ));
                            const related = isRelatedTo(sourceType, targetCheckType, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                            if (!related) {
                                if (reportErrors2 && (targetArity > 1 || sourceArity > 1)) {
                                    if (targetHasRestElement && sourcePosition >= targetStartCount && sourcePositionFromEnd >= targetEndCount && targetStartCount !== sourceArity - targetEndCount - 1) reportIncompatibleError(Diagnostics.Type_at_positions_0_through_1_in_source_is_not_compatible_with_type_at_position_2_in_target, targetStartCount, sourceArity - targetEndCount - 1, targetPosition);
                                    else reportIncompatibleError(Diagnostics.Type_at_position_0_in_source_is_not_compatible_with_type_at_position_1_in_target, sourcePosition, targetPosition);
                                }
                                return 0 /* False */ ;
                            }
                            result2 &= related;
                        }
                        return result2;
                    }
                    if (target2.target.combinedFlags & 12 /* Variable */ ) return 0 /* False */ ;
                }
                const requireOptionalProperties = (relation === subtypeRelation || relation === strictSubtypeRelation) && !isObjectLiteralType2(source2) && !isEmptyArrayLiteralType(source2) && !isTupleType(source2);
                const unmatchedProperty = getUnmatchedProperty(source2, target2, requireOptionalProperties, /*matchDiscriminantProperties*/ false);
                if (unmatchedProperty) {
                    if (reportErrors2 && shouldReportUnmatchedPropertyError(source2, target2)) reportUnmatchedProperty(source2, target2, unmatchedProperty, requireOptionalProperties);
                    return 0 /* False */ ;
                }
                if (isObjectLiteralType2(target2)) {
                    for (const sourceProp of excludeProperties(getPropertiesOfType(source2), excludedProperties))if (!getPropertyOfObjectType(target2, sourceProp.escapedName)) {
                        const sourceType = getTypeOfSymbol(sourceProp);
                        if (!(sourceType.flags & 32768 /* Undefined */ )) {
                            if (reportErrors2) reportError(Diagnostics.Property_0_does_not_exist_on_type_1, symbolToString(sourceProp), typeToString(target2));
                            return 0 /* False */ ;
                        }
                    }
                }
                const properties = getPropertiesOfType(target2);
                const numericNamesOnly = isTupleType(source2) && isTupleType(target2);
                for (const targetProp of excludeProperties(properties, excludedProperties)){
                    const name = targetProp.escapedName;
                    if (!(targetProp.flags & 4194304 /* Prototype */ ) && (!numericNamesOnly || isNumericLiteralName(name) || name === "length") && (!optionalsOnly || targetProp.flags & 16777216 /* Optional */ )) {
                        const sourceProp = getPropertyOfType(source2, name);
                        if (sourceProp && sourceProp !== targetProp) {
                            const related = propertyRelatedTo(source2, target2, sourceProp, targetProp, getNonMissingTypeOfSymbol, reportErrors2, intersectionState, relation === comparableRelation);
                            if (!related) return 0 /* False */ ;
                            result2 &= related;
                        }
                    }
                }
                return result2;
            }
            function propertiesIdenticalTo(source2, target2, excludedProperties) {
                if (!(source2.flags & 524288 /* Object */  && target2.flags & 524288 /* Object */ )) return 0 /* False */ ;
                const sourceProperties = excludeProperties(getPropertiesOfObjectType(source2), excludedProperties);
                const targetProperties = excludeProperties(getPropertiesOfObjectType(target2), excludedProperties);
                if (sourceProperties.length !== targetProperties.length) return 0 /* False */ ;
                let result2 = -1 /* True */ ;
                for (const sourceProp of sourceProperties){
                    const targetProp = getPropertyOfObjectType(target2, sourceProp.escapedName);
                    if (!targetProp) return 0 /* False */ ;
                    const related = compareProperties2(sourceProp, targetProp, isRelatedTo);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function signaturesRelatedTo(source2, target2, kind, reportErrors2, intersectionState) {
                var _a2, _b;
                if (relation === identityRelation) return signaturesIdenticalTo(source2, target2, kind);
                if (target2 === anyFunctionType || source2 === anyFunctionType) return -1 /* True */ ;
                const sourceIsJSConstructor = source2.symbol && isJSConstructor(source2.symbol.valueDeclaration);
                const targetIsJSConstructor = target2.symbol && isJSConstructor(target2.symbol.valueDeclaration);
                const sourceSignatures = getSignaturesOfType(source2, sourceIsJSConstructor && kind === 1 /* Construct */  ? 0 /* Call */  : kind);
                const targetSignatures = getSignaturesOfType(target2, targetIsJSConstructor && kind === 1 /* Construct */  ? 0 /* Call */  : kind);
                if (kind === 1 /* Construct */  && sourceSignatures.length && targetSignatures.length) {
                    const sourceIsAbstract = !!(sourceSignatures[0].flags & 4 /* Abstract */ );
                    const targetIsAbstract = !!(targetSignatures[0].flags & 4 /* Abstract */ );
                    if (sourceIsAbstract && !targetIsAbstract) {
                        if (reportErrors2) reportError(Diagnostics.Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type);
                        return 0 /* False */ ;
                    }
                    if (!constructorVisibilitiesAreCompatible(sourceSignatures[0], targetSignatures[0], reportErrors2)) return 0 /* False */ ;
                }
                let result2 = -1 /* True */ ;
                const incompatibleReporter = kind === 1 /* Construct */  ? reportIncompatibleConstructSignatureReturn : reportIncompatibleCallSignatureReturn;
                const sourceObjectFlags = getObjectFlags(source2);
                const targetObjectFlags = getObjectFlags(target2);
                if (sourceObjectFlags & 64 /* Instantiated */  && targetObjectFlags & 64 /* Instantiated */  && source2.symbol === target2.symbol || sourceObjectFlags & 4 /* Reference */  && targetObjectFlags & 4 /* Reference */  && source2.target === target2.target) {
                    Debug.assertEqual(sourceSignatures.length, targetSignatures.length);
                    for(let i = 0; i < targetSignatures.length; i++){
                        const related = signatureRelatedTo(sourceSignatures[i], targetSignatures[i], /*erase*/ true, reportErrors2, intersectionState, incompatibleReporter(sourceSignatures[i], targetSignatures[i]));
                        if (!related) return 0 /* False */ ;
                        result2 &= related;
                    }
                } else if (sourceSignatures.length === 1 && targetSignatures.length === 1) {
                    const eraseGenerics = relation === comparableRelation;
                    const sourceSignature = first(sourceSignatures);
                    const targetSignature = first(targetSignatures);
                    result2 = signatureRelatedTo(sourceSignature, targetSignature, eraseGenerics, reportErrors2, intersectionState, incompatibleReporter(sourceSignature, targetSignature));
                    if (!result2 && reportErrors2 && kind === 1 /* Construct */  && sourceObjectFlags & targetObjectFlags && (((_a2 = targetSignature.declaration) == null ? void 0 : _a2.kind) === 177 /* Constructor */  || ((_b = sourceSignature.declaration) == null ? void 0 : _b.kind) === 177 /* Constructor */ )) {
                        const constructSignatureToString = (signature)=>signatureToString(signature, /*enclosingDeclaration*/ void 0, 262144 /* WriteArrowStyleSignature */ , kind);
                        reportError(Diagnostics.Type_0_is_not_assignable_to_type_1, constructSignatureToString(sourceSignature), constructSignatureToString(targetSignature));
                        reportError(Diagnostics.Types_of_construct_signatures_are_incompatible);
                        return result2;
                    }
                } else outer: for (const t of targetSignatures){
                    const saveErrorInfo = captureErrorCalculationState();
                    let shouldElaborateErrors = reportErrors2;
                    for (const s of sourceSignatures){
                        const related = signatureRelatedTo(s, t, /*erase*/ true, shouldElaborateErrors, intersectionState, incompatibleReporter(s, t));
                        if (related) {
                            result2 &= related;
                            resetErrorInfo(saveErrorInfo);
                            continue outer;
                        }
                        shouldElaborateErrors = false;
                    }
                    if (shouldElaborateErrors) reportError(Diagnostics.Type_0_provides_no_match_for_the_signature_1, typeToString(source2), signatureToString(t, /*enclosingDeclaration*/ void 0, /*flags*/ void 0, kind));
                    return 0 /* False */ ;
                }
                return result2;
            }
            function shouldReportUnmatchedPropertyError(source2, target2) {
                const typeCallSignatures = getSignaturesOfStructuredType(source2, 0 /* Call */ );
                const typeConstructSignatures = getSignaturesOfStructuredType(source2, 1 /* Construct */ );
                const typeProperties = getPropertiesOfObjectType(source2);
                if ((typeCallSignatures.length || typeConstructSignatures.length) && !typeProperties.length) {
                    if (getSignaturesOfType(target2, 0 /* Call */ ).length && typeCallSignatures.length || getSignaturesOfType(target2, 1 /* Construct */ ).length && typeConstructSignatures.length) return true;
                    return false;
                }
                return true;
            }
            function reportIncompatibleCallSignatureReturn(siga, sigb) {
                if (siga.parameters.length === 0 && sigb.parameters.length === 0) return (source2, target2)=>reportIncompatibleError(Diagnostics.Call_signatures_with_no_arguments_have_incompatible_return_types_0_and_1, typeToString(source2), typeToString(target2));
                return (source2, target2)=>reportIncompatibleError(Diagnostics.Call_signature_return_types_0_and_1_are_incompatible, typeToString(source2), typeToString(target2));
            }
            function reportIncompatibleConstructSignatureReturn(siga, sigb) {
                if (siga.parameters.length === 0 && sigb.parameters.length === 0) return (source2, target2)=>reportIncompatibleError(Diagnostics.Construct_signatures_with_no_arguments_have_incompatible_return_types_0_and_1, typeToString(source2), typeToString(target2));
                return (source2, target2)=>reportIncompatibleError(Diagnostics.Construct_signature_return_types_0_and_1_are_incompatible, typeToString(source2), typeToString(target2));
            }
            function signatureRelatedTo(source2, target2, erase, reportErrors2, intersectionState, incompatibleReporter) {
                const checkMode = relation === subtypeRelation ? 16 /* StrictTopSignature */  : relation === strictSubtypeRelation ? 24 /* StrictArity */  : 0 /* None */ ;
                return compareSignaturesRelated(erase ? getErasedSignature(source2) : source2, erase ? getErasedSignature(target2) : target2, checkMode, reportErrors2, reportError, incompatibleReporter, isRelatedToWorker2, reportUnreliableMapper);
                function isRelatedToWorker2(source3, target3, reportErrors3) {
                    return isRelatedTo(source3, target3, 3 /* Both */ , reportErrors3, /*headMessage*/ void 0, intersectionState);
                }
            }
            function signaturesIdenticalTo(source2, target2, kind) {
                const sourceSignatures = getSignaturesOfType(source2, kind);
                const targetSignatures = getSignaturesOfType(target2, kind);
                if (sourceSignatures.length !== targetSignatures.length) return 0 /* False */ ;
                let result2 = -1 /* True */ ;
                for(let i = 0; i < sourceSignatures.length; i++){
                    const related = compareSignaturesIdentical(sourceSignatures[i], targetSignatures[i], /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false, isRelatedTo);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function membersRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState) {
                let result2 = -1 /* True */ ;
                const keyType = targetInfo.keyType;
                const props = source2.flags & 2097152 /* Intersection */  ? getPropertiesOfUnionOrIntersectionType(source2) : getPropertiesOfObjectType(source2);
                for (const prop of props){
                    if (isIgnoredJsxProperty(source2, prop)) continue;
                    if (isApplicableIndexType(getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ ), keyType)) {
                        const propType = getNonMissingTypeOfSymbol(prop);
                        const type = exactOptionalPropertyTypes || propType.flags & 32768 /* Undefined */  || keyType === numberType || !(prop.flags & 16777216 /* Optional */ ) ? propType : getTypeWithFacts(propType, 524288 /* NEUndefined */ );
                        const related = isRelatedTo(type, targetInfo.type, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                        if (!related) {
                            if (reportErrors2) reportError(Diagnostics.Property_0_is_incompatible_with_index_signature, symbolToString(prop));
                            return 0 /* False */ ;
                        }
                        result2 &= related;
                    }
                }
                for (const info of getIndexInfosOfType(source2))if (isApplicableIndexType(info.keyType, keyType)) {
                    const related = indexInfoRelatedTo(info, targetInfo, reportErrors2, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors2, intersectionState) {
                const related = isRelatedTo(sourceInfo.type, targetInfo.type, 3 /* Both */ , reportErrors2, /*headMessage*/ void 0, intersectionState);
                if (!related && reportErrors2) {
                    if (sourceInfo.keyType === targetInfo.keyType) reportError(Diagnostics._0_index_signatures_are_incompatible, typeToString(sourceInfo.keyType));
                    else reportError(Diagnostics._0_and_1_index_signatures_are_incompatible, typeToString(sourceInfo.keyType), typeToString(targetInfo.keyType));
                }
                return related;
            }
            function indexSignaturesRelatedTo(source2, target2, sourceIsPrimitive, reportErrors2, intersectionState) {
                if (relation === identityRelation) return indexSignaturesIdenticalTo(source2, target2);
                const indexInfos = getIndexInfosOfType(target2);
                const targetHasStringIndex = some(indexInfos, (info)=>info.keyType === stringType);
                let result2 = -1 /* True */ ;
                for (const targetInfo of indexInfos){
                    const related = relation !== strictSubtypeRelation && !sourceIsPrimitive && targetHasStringIndex && targetInfo.type.flags & 1 /* Any */  ? -1 /* True */  : isGenericMappedType(source2) && targetHasStringIndex ? isRelatedTo(getTemplateTypeFromMappedType(source2), targetInfo.type, 3 /* Both */ , reportErrors2) : typeRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState);
                    if (!related) return 0 /* False */ ;
                    result2 &= related;
                }
                return result2;
            }
            function typeRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState) {
                const sourceInfo = getApplicableIndexInfo(source2, targetInfo.keyType);
                if (sourceInfo) return indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors2, intersectionState);
                if (!(intersectionState & 1 /* Source */ ) && (relation !== strictSubtypeRelation || getObjectFlags(source2) & 8192 /* FreshLiteral */ ) && isObjectTypeWithInferableIndex(source2)) return membersRelatedToIndexInfo(source2, targetInfo, reportErrors2, intersectionState);
                if (reportErrors2) reportError(Diagnostics.Index_signature_for_type_0_is_missing_in_type_1, typeToString(targetInfo.keyType), typeToString(source2));
                return 0 /* False */ ;
            }
            function indexSignaturesIdenticalTo(source2, target2) {
                const sourceInfos = getIndexInfosOfType(source2);
                const targetInfos = getIndexInfosOfType(target2);
                if (sourceInfos.length !== targetInfos.length) return 0 /* False */ ;
                for (const targetInfo of targetInfos){
                    const sourceInfo = getIndexInfoOfType(source2, targetInfo.keyType);
                    if (!(sourceInfo && isRelatedTo(sourceInfo.type, targetInfo.type, 3 /* Both */ ) && sourceInfo.isReadonly === targetInfo.isReadonly)) return 0 /* False */ ;
                }
                return -1 /* True */ ;
            }
            function constructorVisibilitiesAreCompatible(sourceSignature, targetSignature, reportErrors2) {
                if (!sourceSignature.declaration || !targetSignature.declaration) return true;
                const sourceAccessibility = getSelectedEffectiveModifierFlags(sourceSignature.declaration, 6 /* NonPublicAccessibilityModifier */ );
                const targetAccessibility = getSelectedEffectiveModifierFlags(targetSignature.declaration, 6 /* NonPublicAccessibilityModifier */ );
                if (targetAccessibility === 2 /* Private */ ) return true;
                if (targetAccessibility === 4 /* Protected */  && sourceAccessibility !== 2 /* Private */ ) return true;
                if (targetAccessibility !== 4 /* Protected */  && !sourceAccessibility) return true;
                if (reportErrors2) reportError(Diagnostics.Cannot_assign_a_0_constructor_type_to_a_1_constructor_type, visibilityToString(sourceAccessibility), visibilityToString(targetAccessibility));
                return false;
            }
        }
        function typeCouldHaveTopLevelSingletonTypes(type) {
            if (type.flags & 16 /* Boolean */ ) return false;
            if (type.flags & 3145728 /* UnionOrIntersection */ ) return !!forEach(type.types, typeCouldHaveTopLevelSingletonTypes);
            if (type.flags & 465829888 /* Instantiable */ ) {
                const constraint = getConstraintOfType(type);
                if (constraint && constraint !== type) return typeCouldHaveTopLevelSingletonTypes(constraint);
            }
            return isUnitType(type) || !!(type.flags & 134217728 /* TemplateLiteral */ ) || !!(type.flags & 268435456 /* StringMapping */ );
        }
        function getExactOptionalUnassignableProperties(source, target) {
            if (isTupleType(source) && isTupleType(target)) return emptyArray;
            return getPropertiesOfType(target).filter((targetProp)=>isExactOptionalPropertyMismatch(getTypeOfPropertyOfType(source, targetProp.escapedName), getTypeOfSymbol(targetProp)));
        }
        function isExactOptionalPropertyMismatch(source, target) {
            return !!source && !!target && maybeTypeOfKind(source, 32768 /* Undefined */ ) && !!containsMissingType(target);
        }
        function getExactOptionalProperties(type) {
            return getPropertiesOfType(type).filter((targetProp)=>containsMissingType(getTypeOfSymbol(targetProp)));
        }
        function getBestMatchingType(source, target, isRelatedTo = compareTypesAssignable) {
            return findMatchingDiscriminantType(source, target, isRelatedTo) || findMatchingTypeReferenceOrTypeAliasReference(source, target) || findBestTypeForObjectLiteral(source, target) || findBestTypeForInvokable(source, target) || findMostOverlappyType(source, target);
        }
        function discriminateTypeByDiscriminableItems(target, discriminators, related) {
            const types = target.types;
            const include = types.map((t)=>t.flags & 402784252 /* Primitive */  ? 0 /* False */  : -1 /* True */ );
            for (const [getDiscriminatingType, propertyName] of discriminators){
                let matched = false;
                for(let i = 0; i < types.length; i++)if (include[i]) {
                    const targetType = getTypeOfPropertyOrIndexSignatureOfType(types[i], propertyName);
                    if (targetType) {
                        if (someType(getDiscriminatingType(), (t)=>!!related(t, targetType))) matched = true;
                        else include[i] = 3 /* Maybe */ ;
                    }
                }
                for(let i = 0; i < types.length; i++)if (include[i] === 3 /* Maybe */ ) include[i] = matched ? 0 /* False */  : -1 /* True */ ;
            }
            const filtered = contains(include, 0 /* False */ ) ? getUnionType(types.filter((_, i)=>include[i]), 0 /* None */ ) : target;
            return filtered.flags & 131072 /* Never */  ? target : filtered;
        }
        function isWeakType(type) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                return resolved.callSignatures.length === 0 && resolved.constructSignatures.length === 0 && resolved.indexInfos.length === 0 && resolved.properties.length > 0 && every(resolved.properties, (p)=>!!(p.flags & 16777216 /* Optional */ ));
            }
            if (type.flags & 33554432 /* Substitution */ ) return isWeakType(type.baseType);
            if (type.flags & 2097152 /* Intersection */ ) return every(type.types, isWeakType);
            return false;
        }
        function hasCommonProperties(source, target, isComparingJsxAttributes) {
            for (const prop of getPropertiesOfType(source)){
                if (isKnownProperty(target, prop.escapedName, isComparingJsxAttributes)) return true;
            }
            return false;
        }
        function getVariances(type) {
            return type === globalArrayType || type === globalReadonlyArrayType || type.objectFlags & 8 /* Tuple */  ? arrayVariances : getVariancesWorker(type.symbol, type.typeParameters);
        }
        function getAliasVariances(symbol) {
            return getVariancesWorker(symbol, getSymbolLinks(symbol).typeParameters);
        }
        function getVariancesWorker(symbol, typeParameters = emptyArray) {
            var _a, _b;
            const links = getSymbolLinks(symbol);
            if (!links.variances) {
                (_a = tracing) == null || _a.push(tracing.Phase.CheckTypes, "getVariancesWorker", {
                    arity: typeParameters.length,
                    id: getTypeId(getDeclaredTypeOfSymbol(symbol))
                });
                const oldVarianceComputation = inVarianceComputation;
                const saveResolutionStart = resolutionStart;
                if (!inVarianceComputation) {
                    inVarianceComputation = true;
                    resolutionStart = resolutionTargets.length;
                }
                links.variances = emptyArray;
                const variances = [];
                for (const tp of typeParameters){
                    const modifiers = getTypeParameterModifiers(tp);
                    let variance = modifiers & 16384 /* Out */  ? modifiers & 8192 /* In */  ? 0 /* Invariant */  : 1 /* Covariant */  : modifiers & 8192 /* In */  ? 2 /* Contravariant */  : void 0;
                    if (variance === void 0) {
                        let unmeasurable = false;
                        let unreliable = false;
                        const oldHandler = outofbandVarianceMarkerHandler;
                        outofbandVarianceMarkerHandler = (onlyUnreliable)=>onlyUnreliable ? unreliable = true : unmeasurable = true;
                        const typeWithSuper = createMarkerType(symbol, tp, markerSuperType);
                        const typeWithSub = createMarkerType(symbol, tp, markerSubType);
                        variance = (isTypeAssignableTo(typeWithSub, typeWithSuper) ? 1 /* Covariant */  : 0) | (isTypeAssignableTo(typeWithSuper, typeWithSub) ? 2 /* Contravariant */  : 0);
                        if (variance === 3 /* Bivariant */  && isTypeAssignableTo(createMarkerType(symbol, tp, markerOtherType), typeWithSuper)) variance = 4 /* Independent */ ;
                        outofbandVarianceMarkerHandler = oldHandler;
                        if (unmeasurable || unreliable) {
                            if (unmeasurable) variance |= 8 /* Unmeasurable */ ;
                            if (unreliable) variance |= 16 /* Unreliable */ ;
                        }
                    }
                    variances.push(variance);
                }
                if (!oldVarianceComputation) {
                    inVarianceComputation = false;
                    resolutionStart = saveResolutionStart;
                }
                links.variances = variances;
                (_b = tracing) == null || _b.pop({
                    variances: variances.map(Debug.formatVariance)
                });
            }
            return links.variances;
        }
        function createMarkerType(symbol, source, target) {
            const mapper = makeUnaryTypeMapper(source, target);
            const type = getDeclaredTypeOfSymbol(symbol);
            if (isErrorType(type)) return type;
            const result = symbol.flags & 524288 /* TypeAlias */  ? getTypeAliasInstantiation(symbol, instantiateTypes(getSymbolLinks(symbol).typeParameters, mapper)) : createTypeReference(type, instantiateTypes(type.typeParameters, mapper));
            markerTypes.add(getTypeId(result));
            return result;
        }
        function isMarkerType(type) {
            return markerTypes.has(getTypeId(type));
        }
        function getTypeParameterModifiers(tp) {
            var _a;
            return reduceLeft((_a = tp.symbol) == null ? void 0 : _a.declarations, (modifiers, d)=>modifiers | getEffectiveModifierFlags(d), 0 /* None */ ) & 28672 /* Const */ ;
        }
        function hasCovariantVoidArgument(typeArguments, variances) {
            for(let i = 0; i < variances.length; i++){
                if ((variances[i] & 7 /* VarianceMask */ ) === 1 /* Covariant */  && typeArguments[i].flags & 16384 /* Void */ ) return true;
            }
            return false;
        }
        function isUnconstrainedTypeParameter(type) {
            return type.flags & 262144 /* TypeParameter */  && !getConstraintOfTypeParameter(type);
        }
        function isNonDeferredTypeReference(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */ ) && !type.node;
        }
        function isTypeReferenceWithGenericArguments(type) {
            return isNonDeferredTypeReference(type) && some(getTypeArguments(type), (t)=>!!(t.flags & 262144 /* TypeParameter */ ) || isTypeReferenceWithGenericArguments(t));
        }
        function getGenericTypeReferenceRelationKey(source, target, postFix, ignoreConstraints) {
            const typeParameters = [];
            let constraintMarker = "";
            const sourceId = getTypeReferenceId(source, 0);
            const targetId = getTypeReferenceId(target, 0);
            return `${constraintMarker}${sourceId},${targetId}${postFix}`;
            function getTypeReferenceId(type, depth = 0) {
                let result = "" + type.target.id;
                for (const t of getTypeArguments(type)){
                    if (t.flags & 262144 /* TypeParameter */ ) {
                        if (ignoreConstraints || isUnconstrainedTypeParameter(t)) {
                            let index = typeParameters.indexOf(t);
                            if (index < 0) {
                                index = typeParameters.length;
                                typeParameters.push(t);
                            }
                            result += "=" + index;
                            continue;
                        }
                        constraintMarker = "*";
                    } else if (depth < 4 && isTypeReferenceWithGenericArguments(t)) {
                        result += "<" + getTypeReferenceId(t, depth + 1) + ">";
                        continue;
                    }
                    result += "-" + t.id;
                }
                return result;
            }
        }
        function getRelationKey(source, target, intersectionState, relation, ignoreConstraints) {
            if (relation === identityRelation && source.id > target.id) {
                const temp = source;
                source = target;
                target = temp;
            }
            const postFix = intersectionState ? ":" + intersectionState : "";
            return isTypeReferenceWithGenericArguments(source) && isTypeReferenceWithGenericArguments(target) ? getGenericTypeReferenceRelationKey(source, target, postFix, ignoreConstraints) : `${source.id},${target.id}${postFix}`;
        }
        function forEachProperty2(prop, callback) {
            if (getCheckFlags(prop) & 6 /* Synthetic */ ) {
                for (const t of prop.links.containingType.types){
                    const p = getPropertyOfType(t, prop.escapedName);
                    const result = p && forEachProperty2(p, callback);
                    if (result) return result;
                }
                return void 0;
            }
            return callback(prop);
        }
        function getDeclaringClass(prop) {
            return prop.parent && prop.parent.flags & 32 /* Class */  ? getDeclaredTypeOfSymbol(getParentOfSymbol(prop)) : void 0;
        }
        function getTypeOfPropertyInBaseClass(property) {
            const classType = getDeclaringClass(property);
            const baseClassType = classType && getBaseTypes(classType)[0];
            return baseClassType && getTypeOfPropertyOfType(baseClassType, property.escapedName);
        }
        function isPropertyInClassDerivedFrom(prop, baseClass) {
            return forEachProperty2(prop, (sp)=>{
                const sourceClass = getDeclaringClass(sp);
                return sourceClass ? hasBaseType(sourceClass, baseClass) : false;
            });
        }
        function isValidOverrideOf(sourceProp, targetProp) {
            return !forEachProperty2(targetProp, (tp)=>getDeclarationModifierFlagsFromSymbol(tp) & 4 /* Protected */  ? !isPropertyInClassDerivedFrom(sourceProp, getDeclaringClass(tp)) : false);
        }
        function isClassDerivedFromDeclaringClasses(checkClass, prop, writing) {
            return forEachProperty2(prop, (p)=>getDeclarationModifierFlagsFromSymbol(p, writing) & 4 /* Protected */  ? !hasBaseType(checkClass, getDeclaringClass(p)) : false) ? void 0 : checkClass;
        }
        function isDeeplyNestedType(type, stack, depth, maxDepth = 3) {
            if (depth >= maxDepth) {
                if ((getObjectFlags(type) & 96 /* InstantiatedMapped */ ) === 96 /* InstantiatedMapped */ ) type = getMappedTargetWithSymbol(type);
                if (type.flags & 2097152 /* Intersection */ ) return some(type.types, (t)=>isDeeplyNestedType(t, stack, depth, maxDepth));
                const identity2 = getRecursionIdentity(type);
                let count = 0;
                let lastTypeId = 0;
                for(let i = 0; i < depth; i++){
                    const t = stack[i];
                    if (hasMatchingRecursionIdentity(t, identity2)) {
                        if (t.id >= lastTypeId) {
                            count++;
                            if (count >= maxDepth) return true;
                        }
                        lastTypeId = t.id;
                    }
                }
            }
            return false;
        }
        function getMappedTargetWithSymbol(type) {
            let target;
            while((getObjectFlags(type) & 96 /* InstantiatedMapped */ ) === 96 /* InstantiatedMapped */  && (target = getModifiersTypeFromMappedType(type)) && (target.symbol || target.flags & 2097152 /* Intersection */  && some(target.types, (t)=>!!t.symbol)))type = target;
            return type;
        }
        function hasMatchingRecursionIdentity(type, identity2) {
            if ((getObjectFlags(type) & 96 /* InstantiatedMapped */ ) === 96 /* InstantiatedMapped */ ) type = getMappedTargetWithSymbol(type);
            if (type.flags & 2097152 /* Intersection */ ) return some(type.types, (t)=>hasMatchingRecursionIdentity(t, identity2));
            return getRecursionIdentity(type) === identity2;
        }
        function getRecursionIdentity(type) {
            if (type.flags & 524288 /* Object */  && !isObjectOrArrayLiteralType(type)) {
                if (getObjectFlags(type) & 4 /* Reference */  && type.node) return type.node;
                if (type.symbol && !(getObjectFlags(type) & 16 /* Anonymous */  && type.symbol.flags & 32 /* Class */ )) return type.symbol;
                if (isTupleType(type)) return type.target;
            }
            if (type.flags & 262144 /* TypeParameter */ ) return type.symbol;
            if (type.flags & 8388608 /* IndexedAccess */ ) {
                do type = type.objectType;
                while (type.flags & 8388608 /* IndexedAccess */ );
                return type;
            }
            if (type.flags & 16777216 /* Conditional */ ) return type.root;
            return type;
        }
        function isPropertyIdenticalTo(sourceProp, targetProp) {
            return compareProperties2(sourceProp, targetProp, compareTypesIdentical) !== 0 /* False */ ;
        }
        function compareProperties2(sourceProp, targetProp, compareTypes) {
            if (sourceProp === targetProp) return -1 /* True */ ;
            const sourcePropAccessibility = getDeclarationModifierFlagsFromSymbol(sourceProp) & 6 /* NonPublicAccessibilityModifier */ ;
            const targetPropAccessibility = getDeclarationModifierFlagsFromSymbol(targetProp) & 6 /* NonPublicAccessibilityModifier */ ;
            if (sourcePropAccessibility !== targetPropAccessibility) return 0 /* False */ ;
            if (sourcePropAccessibility) {
                if (getTargetSymbol(sourceProp) !== getTargetSymbol(targetProp)) return 0 /* False */ ;
            } else {
                if ((sourceProp.flags & 16777216 /* Optional */ ) !== (targetProp.flags & 16777216 /* Optional */ )) return 0 /* False */ ;
            }
            if (isReadonlySymbol(sourceProp) !== isReadonlySymbol(targetProp)) return 0 /* False */ ;
            return compareTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
        }
        function isMatchingSignature(source, target, partialMatch) {
            const sourceParameterCount = getParameterCount(source);
            const targetParameterCount = getParameterCount(target);
            const sourceMinArgumentCount = getMinArgumentCount(source);
            const targetMinArgumentCount = getMinArgumentCount(target);
            const sourceHasRestParameter = hasEffectiveRestParameter(source);
            const targetHasRestParameter = hasEffectiveRestParameter(target);
            if (sourceParameterCount === targetParameterCount && sourceMinArgumentCount === targetMinArgumentCount && sourceHasRestParameter === targetHasRestParameter) return true;
            if (partialMatch && sourceMinArgumentCount <= targetMinArgumentCount) return true;
            return false;
        }
        function compareSignaturesIdentical(source, target, partialMatch, ignoreThisTypes, ignoreReturnTypes, compareTypes) {
            if (source === target) return -1 /* True */ ;
            if (!isMatchingSignature(source, target, partialMatch)) return 0 /* False */ ;
            if (length(source.typeParameters) !== length(target.typeParameters)) return 0 /* False */ ;
            if (target.typeParameters) {
                const mapper = createTypeMapper(source.typeParameters, target.typeParameters);
                for(let i = 0; i < target.typeParameters.length; i++){
                    const s = source.typeParameters[i];
                    const t = target.typeParameters[i];
                    if (!(s === t || compareTypes(instantiateType(getConstraintFromTypeParameter(s), mapper) || unknownType, getConstraintFromTypeParameter(t) || unknownType) && compareTypes(instantiateType(getDefaultFromTypeParameter(s), mapper) || unknownType, getDefaultFromTypeParameter(t) || unknownType))) return 0 /* False */ ;
                }
                source = instantiateSignature(source, mapper, /*eraseTypeParameters*/ true);
            }
            let result = -1 /* True */ ;
            if (!ignoreThisTypes) {
                const sourceThisType = getThisTypeOfSignature(source);
                if (sourceThisType) {
                    const targetThisType = getThisTypeOfSignature(target);
                    if (targetThisType) {
                        const related = compareTypes(sourceThisType, targetThisType);
                        if (!related) return 0 /* False */ ;
                        result &= related;
                    }
                }
            }
            const targetLen = getParameterCount(target);
            for(let i = 0; i < targetLen; i++){
                const s = getTypeAtPosition(source, i);
                const t = getTypeAtPosition(target, i);
                const related = compareTypes(t, s);
                if (!related) return 0 /* False */ ;
                result &= related;
            }
            if (!ignoreReturnTypes) {
                const sourceTypePredicate = getTypePredicateOfSignature(source);
                const targetTypePredicate = getTypePredicateOfSignature(target);
                result &= sourceTypePredicate || targetTypePredicate ? compareTypePredicatesIdentical(sourceTypePredicate, targetTypePredicate, compareTypes) : compareTypes(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
            }
            return result;
        }
        function compareTypePredicatesIdentical(source, target, compareTypes) {
            return !(source && target && typePredicateKindsMatch(source, target)) ? 0 /* False */  : source.type === target.type ? -1 /* True */  : source.type && target.type ? compareTypes(source.type, target.type) : 0 /* False */ ;
        }
        function literalTypesWithSameBaseType(types) {
            let commonBaseType;
            for (const t of types)if (!(t.flags & 131072 /* Never */ )) {
                const baseType = getBaseTypeOfLiteralType(t);
                commonBaseType !== null && commonBaseType !== void 0 ? commonBaseType : commonBaseType = baseType;
                if (baseType === t || baseType !== commonBaseType) return false;
            }
            return true;
        }
        function getCombinedTypeFlags(types) {
            return reduceLeft(types, (flags, t)=>flags | (t.flags & 1048576 /* Union */  ? getCombinedTypeFlags(t.types) : t.flags), 0);
        }
        function getCommonSupertype(types) {
            if (types.length === 1) return types[0];
            const primaryTypes = strictNullChecks ? sameMap(types, (t)=>filterType(t, (u)=>!(u.flags & 98304 /* Nullable */ ))) : types;
            const superTypeOrUnion = literalTypesWithSameBaseType(primaryTypes) ? getUnionType(primaryTypes) : getSingleCommonSupertype(primaryTypes);
            return primaryTypes === types ? superTypeOrUnion : getNullableType(superTypeOrUnion, getCombinedTypeFlags(types) & 98304 /* Nullable */ );
        }
        function getSingleCommonSupertype(types) {
            const candidate = reduceLeft(types, (s, t)=>isTypeStrictSubtypeOf(s, t) ? t : s);
            return every(types, (t)=>t === candidate || isTypeStrictSubtypeOf(t, candidate)) ? candidate : reduceLeft(types, (s, t)=>isTypeSubtypeOf(s, t) ? t : s);
        }
        function getCommonSubtype(types) {
            return reduceLeft(types, (s, t)=>isTypeSubtypeOf(t, s) ? t : s);
        }
        function isArrayType(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */ ) && (type.target === globalArrayType || type.target === globalReadonlyArrayType);
        }
        function isReadonlyArrayType(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */ ) && type.target === globalReadonlyArrayType;
        }
        function isArrayOrTupleType(type) {
            return isArrayType(type) || isTupleType(type);
        }
        function isMutableArrayOrTuple(type) {
            return isArrayType(type) && !isReadonlyArrayType(type) || isTupleType(type) && !type.target.readonly;
        }
        function getElementTypeOfArrayType(type) {
            return isArrayType(type) ? getTypeArguments(type)[0] : void 0;
        }
        function isArrayLikeType(type) {
            return isArrayType(type) || !(type.flags & 98304 /* Nullable */ ) && isTypeAssignableTo(type, anyReadonlyArrayType);
        }
        function isMutableArrayLikeType(type) {
            return isMutableArrayOrTuple(type) || !(type.flags & 98305 /* Nullable */ ) && isTypeAssignableTo(type, anyArrayType);
        }
        function getSingleBaseForNonAugmentingSubtype(type) {
            if (!(getObjectFlags(type) & 4 /* Reference */ ) || !(getObjectFlags(type.target) & 3 /* ClassOrInterface */ )) return void 0;
            if (getObjectFlags(type) & 33554432 /* IdenticalBaseTypeCalculated */ ) return getObjectFlags(type) & 67108864 /* IdenticalBaseTypeExists */  ? type.cachedEquivalentBaseType : void 0;
            type.objectFlags |= 33554432 /* IdenticalBaseTypeCalculated */ ;
            const target = type.target;
            if (getObjectFlags(target) & 1 /* Class */ ) {
                const baseTypeNode = getBaseTypeNodeOfClass(target);
                if (baseTypeNode && baseTypeNode.expression.kind !== 80 /* Identifier */  && baseTypeNode.expression.kind !== 212 /* PropertyAccessExpression */ ) return void 0;
            }
            const bases = getBaseTypes(target);
            if (bases.length !== 1) return void 0;
            if (getMembersOfSymbol(type.symbol).size) return void 0;
            let instantiatedBase = !length(target.typeParameters) ? bases[0] : instantiateType(bases[0], createTypeMapper(target.typeParameters, getTypeArguments(type).slice(0, target.typeParameters.length)));
            if (length(getTypeArguments(type)) > length(target.typeParameters)) instantiatedBase = getTypeWithThisArgument(instantiatedBase, last(getTypeArguments(type)));
            type.objectFlags |= 67108864 /* IdenticalBaseTypeExists */ ;
            return type.cachedEquivalentBaseType = instantiatedBase;
        }
        function isEmptyLiteralType(type) {
            return strictNullChecks ? type === implicitNeverType : type === undefinedWideningType;
        }
        function isEmptyArrayLiteralType(type) {
            const elementType = getElementTypeOfArrayType(type);
            return !!elementType && isEmptyLiteralType(elementType);
        }
        function isTupleLikeType(type) {
            let lengthType;
            return isTupleType(type) || !!getPropertyOfType(type, "0") || isArrayLikeType(type) && !!(lengthType = getTypeOfPropertyOfType(type, "length")) && everyType(lengthType, (t)=>!!(t.flags & 256 /* NumberLiteral */ ));
        }
        function isArrayOrTupleLikeType(type) {
            return isArrayLikeType(type) || isTupleLikeType(type);
        }
        function getTupleElementType(type, index) {
            const propType = getTypeOfPropertyOfType(type, "" + index);
            if (propType) return propType;
            if (everyType(type, isTupleType)) return getTupleElementTypeOutOfStartCount(type, index, compilerOptions.noUncheckedIndexedAccess ? undefinedType : void 0);
            return void 0;
        }
        function isNeitherUnitTypeNorNever(type) {
            return !(type.flags & 240544 /* Never */ );
        }
        function isUnitType(type) {
            return !!(type.flags & 109472 /* Unit */ );
        }
        function isUnitLikeType(type) {
            const t = getBaseConstraintOrType(type);
            return t.flags & 2097152 /* Intersection */  ? some(t.types, isUnitType) : isUnitType(t);
        }
        function extractUnitType(type) {
            return type.flags & 2097152 /* Intersection */  ? find(type.types, isUnitType) || type : type;
        }
        function isLiteralType(type) {
            return type.flags & 16 /* Boolean */  ? true : type.flags & 1048576 /* Union */  ? type.flags & 1024 /* EnumLiteral */  ? true : every(type.types, isUnitType) : isUnitType(type);
        }
        function getBaseTypeOfLiteralType(type) {
            return type.flags & 1056 /* EnumLike */  ? getBaseTypeOfEnumLikeType(type) : type.flags & 402653312 /* StringMapping */  ? stringType : type.flags & 256 /* NumberLiteral */  ? numberType : type.flags & 2048 /* BigIntLiteral */  ? bigintType : type.flags & 512 /* BooleanLiteral */  ? booleanType : type.flags & 1048576 /* Union */  ? getBaseTypeOfLiteralTypeUnion(type) : type;
        }
        function getBaseTypeOfLiteralTypeUnion(type) {
            const key = `B${getTypeId(type)}`;
            var _getCachedType;
            return (_getCachedType = getCachedType(key)) !== null && _getCachedType !== void 0 ? _getCachedType : setCachedType(key, mapType(type, getBaseTypeOfLiteralType));
        }
        function getBaseTypeOfLiteralTypeForComparison(type) {
            return type.flags & 402653312 /* StringMapping */  ? stringType : type.flags & 288 /* Enum */  ? numberType : type.flags & 2048 /* BigIntLiteral */  ? bigintType : type.flags & 512 /* BooleanLiteral */  ? booleanType : type.flags & 1048576 /* Union */  ? mapType(type, getBaseTypeOfLiteralTypeForComparison) : type;
        }
        function getWidenedLiteralType(type) {
            return type.flags & 1056 /* EnumLike */  && isFreshLiteralType(type) ? getBaseTypeOfEnumLikeType(type) : type.flags & 128 /* StringLiteral */  && isFreshLiteralType(type) ? stringType : type.flags & 256 /* NumberLiteral */  && isFreshLiteralType(type) ? numberType : type.flags & 2048 /* BigIntLiteral */  && isFreshLiteralType(type) ? bigintType : type.flags & 512 /* BooleanLiteral */  && isFreshLiteralType(type) ? booleanType : type.flags & 1048576 /* Union */  ? mapType(type, getWidenedLiteralType) : type;
        }
        function getWidenedUniqueESSymbolType(type) {
            return type.flags & 8192 /* UniqueESSymbol */  ? esSymbolType : type.flags & 1048576 /* Union */  ? mapType(type, getWidenedUniqueESSymbolType) : type;
        }
        function getWidenedLiteralLikeTypeForContextualType(type, contextualType) {
            if (!isLiteralOfContextualType(type, contextualType)) type = getWidenedUniqueESSymbolType(getWidenedLiteralType(type));
            return getRegularTypeOfLiteralType(type);
        }
        function getWidenedLiteralLikeTypeForContextualReturnTypeIfNeeded(type, contextualSignatureReturnType, isAsync) {
            if (type && isUnitType(type)) {
                const contextualType = !contextualSignatureReturnType ? void 0 : isAsync ? getPromisedTypeOfPromise(contextualSignatureReturnType) : contextualSignatureReturnType;
                type = getWidenedLiteralLikeTypeForContextualType(type, contextualType);
            }
            return type;
        }
        function getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(type, contextualSignatureReturnType, kind, isAsyncGenerator) {
            if (type && isUnitType(type)) {
                const contextualType = !contextualSignatureReturnType ? void 0 : getIterationTypeOfGeneratorFunctionReturnType(kind, contextualSignatureReturnType, isAsyncGenerator);
                type = getWidenedLiteralLikeTypeForContextualType(type, contextualType);
            }
            return type;
        }
        function isTupleType(type) {
            return !!(getObjectFlags(type) & 4 /* Reference */  && type.target.objectFlags & 8 /* Tuple */ );
        }
        function isGenericTupleType(type) {
            return isTupleType(type) && !!(type.target.combinedFlags & 8 /* Variadic */ );
        }
        function isSingleElementGenericTupleType(type) {
            return isGenericTupleType(type) && type.target.elementFlags.length === 1;
        }
        function getRestTypeOfTupleType(type) {
            return getElementTypeOfSliceOfTupleType(type, type.target.fixedLength);
        }
        function getTupleElementTypeOutOfStartCount(type, index, undefinedOrMissingType2) {
            return mapType(type, (t)=>{
                const tupleType = t;
                const restType = getRestTypeOfTupleType(tupleType);
                if (!restType) return undefinedType;
                if (undefinedOrMissingType2 && index >= getTotalFixedElementCount(tupleType.target)) return getUnionType([
                    restType,
                    undefinedOrMissingType2
                ]);
                return restType;
            });
        }
        function getRestArrayTypeOfTupleType(type) {
            const restType = getRestTypeOfTupleType(type);
            return restType && createArrayType(restType);
        }
        function getElementTypeOfSliceOfTupleType(type, index, endSkipCount = 0, writing = false, noReductions = false) {
            const length2 = getTypeReferenceArity(type) - endSkipCount;
            if (index < length2) {
                const typeArguments = getTypeArguments(type);
                const elementTypes = [];
                for(let i = index; i < length2; i++){
                    const t = typeArguments[i];
                    elementTypes.push(type.target.elementFlags[i] & 8 /* Variadic */  ? getIndexedAccessType(t, numberType) : t);
                }
                return writing ? getIntersectionType(elementTypes) : getUnionType(elementTypes, noReductions ? 0 /* None */  : 1 /* Literal */ );
            }
            return void 0;
        }
        function isTupleTypeStructureMatching(t1, t2) {
            return getTypeReferenceArity(t1) === getTypeReferenceArity(t2) && every(t1.target.elementFlags, (f, i)=>(f & 12 /* Variable */ ) === (t2.target.elementFlags[i] & 12 /* Variable */ ));
        }
        function isZeroBigInt({ value: value1 }) {
            return value1.base10Value === "0";
        }
        function removeDefinitelyFalsyTypes(type) {
            return filterType(type, (t)=>hasTypeFacts(t, 4194304 /* Truthy */ ));
        }
        function extractDefinitelyFalsyTypes(type) {
            return mapType(type, getDefinitelyFalsyPartOfType);
        }
        function getDefinitelyFalsyPartOfType(type) {
            return type.flags & 4 /* String */  ? emptyStringType : type.flags & 8 /* Number */  ? zeroType : type.flags & 64 /* BigInt */  ? zeroBigIntType : type === regularFalseType || type === falseType || type.flags & 114691 /* AnyOrUnknown */  || type.flags & 128 /* StringLiteral */  && type.value === "" || type.flags & 256 /* NumberLiteral */  && type.value === 0 || type.flags & 2048 /* BigIntLiteral */  && isZeroBigInt(type) ? type : neverType;
        }
        function getNullableType(type, flags) {
            const missing = flags & ~type.flags & 98304 /* Null */ ;
            return missing === 0 ? type : missing === 32768 /* Undefined */  ? getUnionType([
                type,
                undefinedType
            ]) : missing === 65536 /* Null */  ? getUnionType([
                type,
                nullType
            ]) : getUnionType([
                type,
                undefinedType,
                nullType
            ]);
        }
        function getOptionalType(type, isProperty = false) {
            Debug.assert(strictNullChecks);
            const missingOrUndefined = isProperty ? undefinedOrMissingType : undefinedType;
            return type === missingOrUndefined || type.flags & 1048576 /* Union */  && type.types[0] === missingOrUndefined ? type : getUnionType([
                type,
                missingOrUndefined
            ]);
        }
        function getGlobalNonNullableTypeInstantiation(type) {
            if (!deferredGlobalNonNullableTypeAlias) deferredGlobalNonNullableTypeAlias = getGlobalSymbol("NonNullable", 524288 /* TypeAlias */ , /*diagnostic*/ void 0) || unknownSymbol;
            return deferredGlobalNonNullableTypeAlias !== unknownSymbol ? getTypeAliasInstantiation(deferredGlobalNonNullableTypeAlias, [
                type
            ]) : getIntersectionType([
                type,
                emptyObjectType
            ]);
        }
        function getNonNullableType(type) {
            return strictNullChecks ? getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type;
        }
        function addOptionalTypeMarker(type) {
            return strictNullChecks ? getUnionType([
                type,
                optionalType
            ]) : type;
        }
        function removeOptionalTypeMarker(type) {
            return strictNullChecks ? removeType(type, optionalType) : type;
        }
        function propagateOptionalTypeMarker(type, node, wasOptional) {
            return wasOptional ? isOutermostOptionalChain(node) ? getOptionalType(type) : addOptionalTypeMarker(type) : type;
        }
        function getOptionalExpressionType(exprType, expression) {
            return isExpressionOfOptionalChainRoot(expression) ? getNonNullableType(exprType) : isOptionalChain(expression) ? removeOptionalTypeMarker(exprType) : exprType;
        }
        function removeMissingType(type, isOptional) {
            return exactOptionalPropertyTypes && isOptional ? removeType(type, missingType) : type;
        }
        function containsMissingType(type) {
            return type === missingType || !!(type.flags & 1048576 /* Union */ ) && type.types[0] === missingType;
        }
        function removeMissingOrUndefinedType(type) {
            return exactOptionalPropertyTypes ? removeType(type, missingType) : getTypeWithFacts(type, 524288 /* NEUndefined */ );
        }
        function isCoercibleUnderDoubleEquals(source, target) {
            return (source.flags & 524 /* BooleanLiteral */ ) !== 0 && (target.flags & 28 /* Boolean */ ) !== 0;
        }
        function isObjectTypeWithInferableIndex(type) {
            const objectFlags = getObjectFlags(type);
            return type.flags & 2097152 /* Intersection */  ? every(type.types, isObjectTypeWithInferableIndex) : !!(type.symbol && (type.symbol.flags & 7040 /* ValueModule */ ) !== 0 && !(type.symbol.flags & 32 /* Class */ ) && !typeHasCallOrConstructSignatures(type)) || !!(objectFlags & 4194304 /* ObjectRestType */ ) || !!(objectFlags & 1024 /* ReverseMapped */  && isObjectTypeWithInferableIndex(type.source));
        }
        function createSymbolWithType(source, type) {
            const symbol = createSymbol(source.flags, source.escapedName, getCheckFlags(source) & 8 /* Readonly */ );
            symbol.declarations = source.declarations;
            symbol.parent = source.parent;
            symbol.links.type = type;
            symbol.links.target = source;
            if (source.valueDeclaration) symbol.valueDeclaration = source.valueDeclaration;
            const nameType = getSymbolLinks(source).nameType;
            if (nameType) symbol.links.nameType = nameType;
            return symbol;
        }
        function transformTypeOfMembers(type, f) {
            const members = createSymbolTable();
            for (const property of getPropertiesOfObjectType(type)){
                const original = getTypeOfSymbol(property);
                const updated = f(original);
                members.set(property.escapedName, updated === original ? property : createSymbolWithType(property, updated));
            }
            return members;
        }
        function getRegularTypeOfObjectLiteral(type) {
            if (!(isObjectLiteralType2(type) && getObjectFlags(type) & 8192 /* FreshLiteral */ )) return type;
            const regularType = type.regularType;
            if (regularType) return regularType;
            const resolved = type;
            const members = transformTypeOfMembers(type, getRegularTypeOfObjectLiteral);
            const regularNew = createAnonymousType(resolved.symbol, members, resolved.callSignatures, resolved.constructSignatures, resolved.indexInfos);
            regularNew.flags = resolved.flags;
            regularNew.objectFlags |= resolved.objectFlags & -8193 /* FreshLiteral */ ;
            type.regularType = regularNew;
            return regularNew;
        }
        function createWideningContext(parent2, propertyName, siblings) {
            return {
                parent: parent2,
                propertyName,
                siblings,
                resolvedProperties: void 0
            };
        }
        function getSiblingsOfContext(context) {
            if (!context.siblings) {
                const siblings = [];
                for (const type of getSiblingsOfContext(context.parent))if (isObjectLiteralType2(type)) {
                    const prop = getPropertyOfObjectType(type, context.propertyName);
                    if (prop) forEachType(getTypeOfSymbol(prop), (t)=>{
                        siblings.push(t);
                    });
                }
                context.siblings = siblings;
            }
            return context.siblings;
        }
        function getPropertiesOfContext(context) {
            if (!context.resolvedProperties) {
                const names = /* @__PURE__ */ new Map();
                for (const t of getSiblingsOfContext(context)){
                    if (isObjectLiteralType2(t) && !(getObjectFlags(t) & 2097152 /* ContainsSpread */ )) for (const prop of getPropertiesOfType(t))names.set(prop.escapedName, prop);
                }
                context.resolvedProperties = arrayFrom(names.values());
            }
            return context.resolvedProperties;
        }
        function getWidenedProperty(prop, context) {
            if (!(prop.flags & 4 /* Property */ )) return prop;
            const original = getTypeOfSymbol(prop);
            const propContext = context && createWideningContext(context, prop.escapedName, /*siblings*/ void 0);
            const widened = getWidenedTypeWithContext(original, propContext);
            return widened === original ? prop : createSymbolWithType(prop, widened);
        }
        function getUndefinedProperty(prop) {
            const cached = undefinedProperties.get(prop.escapedName);
            if (cached) return cached;
            const result = createSymbolWithType(prop, undefinedOrMissingType);
            result.flags |= 16777216 /* Optional */ ;
            undefinedProperties.set(prop.escapedName, result);
            return result;
        }
        function getWidenedTypeOfObjectLiteral(type, context) {
            const members = createSymbolTable();
            for (const prop of getPropertiesOfObjectType(type))members.set(prop.escapedName, getWidenedProperty(prop, context));
            if (context) {
                for (const prop of getPropertiesOfContext(context))if (!members.has(prop.escapedName)) members.set(prop.escapedName, getUndefinedProperty(prop));
            }
            const result = createAnonymousType(type.symbol, members, emptyArray, emptyArray, sameMap(getIndexInfosOfType(type), (info)=>createIndexInfo(info.keyType, getWidenedType(info.type), info.isReadonly, info.declaration, info.components)));
            result.objectFlags |= getObjectFlags(type) & 266240 /* NonInferrableType */ ;
            return result;
        }
        function getWidenedType(type) {
            return getWidenedTypeWithContext(type, /*context*/ void 0);
        }
        function getWidenedTypeWithContext(type, context) {
            if (getObjectFlags(type) & 196608 /* RequiresWidening */ ) {
                if (context === void 0 && type.widened) return type.widened;
                let result;
                if (type.flags & 98305 /* Nullable */ ) result = anyType;
                else if (isObjectLiteralType2(type)) result = getWidenedTypeOfObjectLiteral(type, context);
                else if (type.flags & 1048576 /* Union */ ) {
                    const unionContext = context || createWideningContext(/*parent*/ void 0, /*propertyName*/ void 0, type.types);
                    const widenedTypes = sameMap(type.types, (t)=>t.flags & 98304 /* Nullable */  ? t : getWidenedTypeWithContext(t, unionContext));
                    result = getUnionType(widenedTypes, some(widenedTypes, isEmptyObjectType) ? 2 /* Subtype */  : 1 /* Literal */ );
                } else if (type.flags & 2097152 /* Intersection */ ) result = getIntersectionType(sameMap(type.types, getWidenedType));
                else if (isArrayOrTupleType(type)) result = createTypeReference(type.target, sameMap(getTypeArguments(type), getWidenedType));
                if (result && context === void 0) type.widened = result;
                return result || type;
            }
            return type;
        }
        function reportWideningErrorsInType(type) {
            var _a;
            let errorReported = false;
            if (getObjectFlags(type) & 65536 /* ContainsWideningType */ ) {
                if (type.flags & 1048576 /* Union */ ) {
                    if (some(type.types, isEmptyObjectType)) errorReported = true;
                    else for (const t of type.types)errorReported || (errorReported = reportWideningErrorsInType(t));
                } else if (isArrayOrTupleType(type)) for (const t of getTypeArguments(type))errorReported || (errorReported = reportWideningErrorsInType(t));
                else if (isObjectLiteralType2(type)) for (const p of getPropertiesOfObjectType(type)){
                    const t = getTypeOfSymbol(p);
                    if (getObjectFlags(t) & 65536 /* ContainsWideningType */ ) {
                        errorReported = reportWideningErrorsInType(t);
                        if (!errorReported) {
                            const valueDeclaration = (_a = p.declarations) == null ? void 0 : _a.find((d)=>{
                                var _a2;
                                return ((_a2 = d.symbol.valueDeclaration) == null ? void 0 : _a2.parent) === type.symbol.valueDeclaration;
                            });
                            if (valueDeclaration) {
                                error2(valueDeclaration, Diagnostics.Object_literal_s_property_0_implicitly_has_an_1_type, symbolToString(p), typeToString(getWidenedType(t)));
                                errorReported = true;
                            }
                        }
                    }
                }
            }
            return errorReported;
        }
        function reportImplicitAny(declaration, type, wideningKind) {
            const typeAsString = typeToString(getWidenedType(type));
            if (isInJSFile(declaration) && !isCheckJsEnabledForFile(getSourceFileOfNode(declaration), compilerOptions)) return;
            let diagnostic;
            switch(declaration.kind){
                case 227 /* BinaryExpression */ :
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                    diagnostic = noImplicitAny ? Diagnostics.Member_0_implicitly_has_an_1_type : Diagnostics.Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage;
                    break;
                case 170 /* Parameter */ :
                    const param = declaration;
                    if (isIdentifier(param.name)) {
                        const originalKeywordKind = identifierToKeywordKind(param.name);
                        if ((isCallSignatureDeclaration(param.parent) || isMethodSignature(param.parent) || isFunctionTypeNode(param.parent)) && param.parent.parameters.includes(param) && (resolveName(param, param.name.escapedText, 788968 /* Type */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true) || originalKeywordKind && isTypeNodeKind(originalKeywordKind))) {
                            const newName = "arg" + param.parent.parameters.indexOf(param);
                            const typeName = declarationNameToString(param.name) + (param.dotDotDotToken ? "[]" : "");
                            errorOrSuggestion(noImplicitAny, declaration, Diagnostics.Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1, newName, typeName);
                            return;
                        }
                    }
                    diagnostic = declaration.dotDotDotToken ? noImplicitAny ? Diagnostics.Rest_parameter_0_implicitly_has_an_any_type : Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage : noImplicitAny ? Diagnostics.Parameter_0_implicitly_has_an_1_type : Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage;
                    break;
                case 209 /* BindingElement */ :
                    diagnostic = Diagnostics.Binding_element_0_implicitly_has_an_1_type;
                    if (!noImplicitAny) return;
                    break;
                case 318 /* JSDocFunctionType */ :
                    error2(declaration, Diagnostics.Function_type_which_lacks_return_type_annotation_implicitly_has_an_0_return_type, typeAsString);
                    return;
                case 324 /* JSDocSignature */ :
                    if (noImplicitAny && isJSDocOverloadTag(declaration.parent)) error2(declaration.parent.tagName, Diagnostics.This_overload_implicitly_returns_the_type_0_because_it_lacks_a_return_type_annotation, typeAsString);
                    return;
                case 263 /* FunctionDeclaration */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    if (noImplicitAny && !declaration.name) {
                        if (wideningKind === 3 /* GeneratorYield */ ) error2(declaration, Diagnostics.Generator_implicitly_has_yield_type_0_Consider_supplying_a_return_type_annotation, typeAsString);
                        else error2(declaration, Diagnostics.Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type, typeAsString);
                        return;
                    }
                    diagnostic = !noImplicitAny ? Diagnostics._0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage : wideningKind === 3 /* GeneratorYield */  ? Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_yield_type : Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type;
                    break;
                case 201 /* MappedType */ :
                    if (noImplicitAny) error2(declaration, Diagnostics.Mapped_object_type_implicitly_has_an_any_template_type);
                    return;
                default:
                    diagnostic = noImplicitAny ? Diagnostics.Variable_0_implicitly_has_an_1_type : Diagnostics.Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage;
            }
            errorOrSuggestion(noImplicitAny, declaration, diagnostic, declarationNameToString(getNameOfDeclaration(declaration)), typeAsString);
        }
        function shouldReportErrorsFromWideningWithContextualSignature(declaration, wideningKind) {
            const signature = getContextualSignatureForFunctionLikeDeclaration(declaration);
            if (!signature) return true;
            let returnType = getReturnTypeOfSignature(signature);
            const flags = getFunctionFlags(declaration);
            switch(wideningKind){
                case 1 /* FunctionReturn */ :
                    var _getIterationTypeOfGeneratorFunctionReturnType, _getAwaitedTypeNoAlias;
                    if (flags & 1 /* Generator */ ) returnType = (_getIterationTypeOfGeneratorFunctionReturnType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , returnType, !!(flags & 2 /* Async */ ))) !== null && _getIterationTypeOfGeneratorFunctionReturnType !== void 0 ? _getIterationTypeOfGeneratorFunctionReturnType : returnType;
                    else if (flags & 2 /* Async */ ) returnType = (_getAwaitedTypeNoAlias = getAwaitedTypeNoAlias(returnType)) !== null && _getAwaitedTypeNoAlias !== void 0 ? _getAwaitedTypeNoAlias : returnType;
                    return isGenericType(returnType);
                case 3 /* GeneratorYield */ :
                    const yieldType = getIterationTypeOfGeneratorFunctionReturnType(0 /* Yield */ , returnType, !!(flags & 2 /* Async */ ));
                    return !!yieldType && isGenericType(yieldType);
                case 2 /* GeneratorNext */ :
                    const nextType = getIterationTypeOfGeneratorFunctionReturnType(2 /* Next */ , returnType, !!(flags & 2 /* Async */ ));
                    return !!nextType && isGenericType(nextType);
            }
            return false;
        }
        function reportErrorsFromWidening(declaration, type, wideningKind) {
            addLazyDiagnostic(()=>{
                if (noImplicitAny && getObjectFlags(type) & 65536 /* ContainsWideningType */ ) {
                    if (!wideningKind || isFunctionLikeDeclaration(declaration) && shouldReportErrorsFromWideningWithContextualSignature(declaration, wideningKind)) {
                        if (!reportWideningErrorsInType(type)) reportImplicitAny(declaration, type, wideningKind);
                    }
                }
            });
        }
        function applyToParameterTypes(source, target, callback) {
            const sourceCount = getParameterCount(source);
            const targetCount = getParameterCount(target);
            const sourceRestType = getEffectiveRestType(source);
            const targetRestType = getEffectiveRestType(target);
            const targetNonRestCount = targetRestType ? targetCount - 1 : targetCount;
            const paramCount = sourceRestType ? targetNonRestCount : Math.min(sourceCount, targetNonRestCount);
            const sourceThisType = getThisTypeOfSignature(source);
            if (sourceThisType) {
                const targetThisType = getThisTypeOfSignature(target);
                if (targetThisType) callback(sourceThisType, targetThisType);
            }
            for(let i = 0; i < paramCount; i++)callback(getTypeAtPosition(source, i), getTypeAtPosition(target, i));
            if (targetRestType) callback(getRestTypeAtPosition(source, paramCount, /*readonly*/ isConstTypeVariable(targetRestType) && !someType(targetRestType, isMutableArrayLikeType)), targetRestType);
        }
        function applyToReturnTypes(source, target, callback) {
            const targetTypePredicate = getTypePredicateOfSignature(target);
            if (targetTypePredicate) {
                const sourceTypePredicate = getTypePredicateOfSignature(source);
                if (sourceTypePredicate && typePredicateKindsMatch(sourceTypePredicate, targetTypePredicate) && sourceTypePredicate.type && targetTypePredicate.type) {
                    callback(sourceTypePredicate.type, targetTypePredicate.type);
                    return;
                }
            }
            const targetReturnType = getReturnTypeOfSignature(target);
            if (couldContainTypeVariables(targetReturnType)) callback(getReturnTypeOfSignature(source), targetReturnType);
        }
        function createInferenceContext(typeParameters, signature, flags, compareTypes) {
            return createInferenceContextWorker(typeParameters.map(createInferenceInfo), signature, flags, compareTypes || compareTypesAssignable);
        }
        function cloneInferenceContext(context, extraFlags = 0) {
            return context && createInferenceContextWorker(map(context.inferences, cloneInferenceInfo), context.signature, context.flags | extraFlags, context.compareTypes);
        }
        function createInferenceContextWorker(inferences, signature, flags, compareTypes) {
            const context = {
                inferences,
                signature,
                flags,
                compareTypes,
                mapper: reportUnmeasurableMapper,
                // initialize to a noop mapper so the context object is available, but the underlying object shape is right upon construction
                nonFixingMapper: reportUnmeasurableMapper
            };
            context.mapper = makeFixingMapperForContext(context);
            context.nonFixingMapper = makeNonFixingMapperForContext(context);
            return context;
        }
        function makeFixingMapperForContext(context) {
            return makeDeferredTypeMapper(map(context.inferences, (i)=>i.typeParameter), map(context.inferences, (inference, i)=>()=>{
                    if (!inference.isFixed) {
                        inferFromIntraExpressionSites(context);
                        clearCachedInferences(context.inferences);
                        inference.isFixed = true;
                    }
                    return getInferredType(context, i);
                }));
        }
        function makeNonFixingMapperForContext(context) {
            return makeDeferredTypeMapper(map(context.inferences, (i)=>i.typeParameter), map(context.inferences, (_, i)=>()=>{
                    return getInferredType(context, i);
                }));
        }
        function clearCachedInferences(inferences) {
            for (const inference of inferences)if (!inference.isFixed) inference.inferredType = void 0;
        }
        function addIntraExpressionInferenceSite(context, node, type) {
            var _context_intraExpressionInferenceSites;
            ((_context_intraExpressionInferenceSites = context.intraExpressionInferenceSites) !== null && _context_intraExpressionInferenceSites !== void 0 ? _context_intraExpressionInferenceSites : context.intraExpressionInferenceSites = []).push({
                node,
                type
            });
        }
        function inferFromIntraExpressionSites(context) {
            if (context.intraExpressionInferenceSites) {
                for (const { node, type } of context.intraExpressionInferenceSites){
                    const contextualType = node.kind === 175 /* MethodDeclaration */  ? getContextualTypeForObjectLiteralMethod(node, 2 /* NoConstraints */ ) : getContextualType2(node, 2 /* NoConstraints */ );
                    if (contextualType) inferTypes(context.inferences, type, contextualType);
                }
                context.intraExpressionInferenceSites = void 0;
            }
        }
        function createInferenceInfo(typeParameter) {
            return {
                typeParameter,
                candidates: void 0,
                contraCandidates: void 0,
                inferredType: void 0,
                priority: void 0,
                topLevel: true,
                isFixed: false,
                impliedArity: void 0
            };
        }
        function cloneInferenceInfo(inference) {
            return {
                typeParameter: inference.typeParameter,
                candidates: inference.candidates && inference.candidates.slice(),
                contraCandidates: inference.contraCandidates && inference.contraCandidates.slice(),
                inferredType: inference.inferredType,
                priority: inference.priority,
                topLevel: inference.topLevel,
                isFixed: inference.isFixed,
                impliedArity: inference.impliedArity
            };
        }
        function cloneInferredPartOfContext(context) {
            const inferences = filter(context.inferences, hasInferenceCandidates);
            return inferences.length ? createInferenceContextWorker(map(inferences, cloneInferenceInfo), context.signature, context.flags, context.compareTypes) : void 0;
        }
        function getMapperFromContext(context) {
            return context && context.mapper;
        }
        function couldContainTypeVariables(type) {
            const objectFlags = getObjectFlags(type);
            if (objectFlags & 524288 /* CouldContainTypeVariablesComputed */ ) return !!(objectFlags & 1048576 /* CouldContainTypeVariables */ );
            const result = !!(type.flags & 465829888 /* Instantiable */  || type.flags & 524288 /* Object */  && !isNonGenericTopLevelType(type) && (objectFlags & 4 /* Reference */  && (type.node || some(getTypeArguments(type), couldContainTypeVariables)) || objectFlags & 16 /* Anonymous */  && type.symbol && type.symbol.flags & 14384 /* ObjectLiteral */  && type.symbol.declarations || objectFlags & 12583968 /* InstantiationExpressionType */ ) || type.flags & 3145728 /* UnionOrIntersection */  && !(type.flags & 1024 /* EnumLiteral */ ) && !isNonGenericTopLevelType(type) && some(type.types, couldContainTypeVariables));
            if (type.flags & 3899393 /* ObjectFlagsType */ ) type.objectFlags |= 524288 /* CouldContainTypeVariablesComputed */  | (result ? 1048576 /* CouldContainTypeVariables */  : 0);
            return result;
        }
        function isNonGenericTopLevelType(type) {
            if (type.aliasSymbol && !type.aliasTypeArguments) {
                const declaration = getDeclarationOfKind(type.aliasSymbol, 266 /* TypeAliasDeclaration */ );
                return !!(declaration && findAncestor(declaration.parent, (n)=>n.kind === 308 /* SourceFile */  ? true : n.kind === 268 /* ModuleDeclaration */  ? false : "quit"));
            }
            return false;
        }
        function isTypeParameterAtTopLevel(type, tp, depth = 0) {
            return !!(type === tp || type.flags & 3145728 /* UnionOrIntersection */  && some(type.types, (t)=>isTypeParameterAtTopLevel(t, tp, depth)) || depth < 3 && type.flags & 16777216 /* Conditional */  && (isTypeParameterAtTopLevel(getTrueTypeFromConditionalType(type), tp, depth + 1) || isTypeParameterAtTopLevel(getFalseTypeFromConditionalType(type), tp, depth + 1)));
        }
        function isTypeParameterAtTopLevelInReturnType(signature, typeParameter) {
            const typePredicate = getTypePredicateOfSignature(signature);
            return typePredicate ? !!typePredicate.type && isTypeParameterAtTopLevel(typePredicate.type, typeParameter) : isTypeParameterAtTopLevel(getReturnTypeOfSignature(signature), typeParameter);
        }
        function createEmptyObjectTypeFromStringLiteral(type) {
            const members = createSymbolTable();
            forEachType(type, (t)=>{
                if (!(t.flags & 128 /* StringLiteral */ )) return;
                const name = escapeLeadingUnderscores(t.value);
                const literalProp = createSymbol(4 /* Property */ , name);
                literalProp.links.type = anyType;
                if (t.symbol) {
                    literalProp.declarations = t.symbol.declarations;
                    literalProp.valueDeclaration = t.symbol.valueDeclaration;
                }
                members.set(name, literalProp);
            });
            const indexInfos = type.flags & 4 /* String */  ? [
                createIndexInfo(stringType, emptyObjectType, /*isReadonly*/ false)
            ] : emptyArray;
            return createAnonymousType(/*symbol*/ void 0, members, emptyArray, emptyArray, indexInfos);
        }
        function inferTypeForHomomorphicMappedType(source, target, constraint) {
            const cacheKey = source.id + "," + target.id + "," + constraint.id;
            if (reverseHomomorphicMappedCache.has(cacheKey)) return reverseHomomorphicMappedCache.get(cacheKey);
            const type = createReverseMappedType(source, target, constraint);
            reverseHomomorphicMappedCache.set(cacheKey, type);
            return type;
        }
        function isPartiallyInferableType(type) {
            return !(getObjectFlags(type) & 262144 /* NonInferrableType */ ) || isObjectLiteralType2(type) && some(getPropertiesOfType(type), (prop)=>isPartiallyInferableType(getTypeOfSymbol(prop))) || isTupleType(type) && some(getElementTypes(type), isPartiallyInferableType);
        }
        function createReverseMappedType(source, target, constraint) {
            if (!(getIndexInfoOfType(source, stringType) || getPropertiesOfType(source).length !== 0 && isPartiallyInferableType(source))) return void 0;
            if (isArrayType(source)) {
                const elementType = inferReverseMappedType(getTypeArguments(source)[0], target, constraint);
                if (!elementType) return void 0;
                return createArrayType(elementType, isReadonlyArrayType(source));
            }
            if (isTupleType(source)) {
                const elementTypes = map(getElementTypes(source), (t)=>inferReverseMappedType(t, target, constraint));
                if (!every(elementTypes, (t)=>!!t)) return void 0;
                const elementFlags = getMappedTypeModifiers(target) & 4 /* IncludeOptional */  ? sameMap(source.target.elementFlags, (f)=>f & 2 /* Optional */  ? 1 /* Required */  : f) : source.target.elementFlags;
                return createTupleType(elementTypes, elementFlags, source.target.readonly, source.target.labeledElementDeclarations);
            }
            const reversed = createObjectType(1040 /* Anonymous */ , /*symbol*/ void 0);
            reversed.source = source;
            reversed.mappedType = target;
            reversed.constraintType = constraint;
            return reversed;
        }
        function getTypeOfReverseMappedSymbol(symbol) {
            const links = getSymbolLinks(symbol);
            if (!links.type) links.type = inferReverseMappedType(symbol.links.propertyType, symbol.links.mappedType, symbol.links.constraintType) || unknownType;
            return links.type;
        }
        function inferReverseMappedTypeWorker(sourceType, target, constraint) {
            const typeParameter = getIndexedAccessType(constraint.type, getTypeParameterFromMappedType(target));
            const templateType = getTemplateTypeFromMappedType(target);
            const inference = createInferenceInfo(typeParameter);
            inferTypes([
                inference
            ], sourceType, templateType);
            return getTypeFromInference(inference) || unknownType;
        }
        function inferReverseMappedType(source, target, constraint) {
            const cacheKey = source.id + "," + target.id + "," + constraint.id;
            if (reverseMappedCache.has(cacheKey)) return reverseMappedCache.get(cacheKey) || unknownType;
            reverseMappedSourceStack.push(source);
            reverseMappedTargetStack.push(target);
            const saveExpandingFlags = reverseExpandingFlags;
            if (isDeeplyNestedType(source, reverseMappedSourceStack, reverseMappedSourceStack.length, 2)) reverseExpandingFlags |= 1 /* Source */ ;
            if (isDeeplyNestedType(target, reverseMappedTargetStack, reverseMappedTargetStack.length, 2)) reverseExpandingFlags |= 2 /* Target */ ;
            let type;
            if (reverseExpandingFlags !== 3 /* Both */ ) type = inferReverseMappedTypeWorker(source, target, constraint);
            reverseMappedSourceStack.pop();
            reverseMappedTargetStack.pop();
            reverseExpandingFlags = saveExpandingFlags;
            reverseMappedCache.set(cacheKey, type);
            return type;
        }
        function* getUnmatchedProperties(source, target, requireOptionalProperties, matchDiscriminantProperties) {
            const properties = getPropertiesOfType(target);
            for (const targetProp of properties){
                if (isStaticPrivateIdentifierProperty(targetProp)) continue;
                if (requireOptionalProperties || !(targetProp.flags & 16777216 /* Optional */  || getCheckFlags(targetProp) & 48 /* Partial */ )) {
                    const sourceProp = getPropertyOfType(source, targetProp.escapedName);
                    if (!sourceProp) yield targetProp;
                    else if (matchDiscriminantProperties) {
                        const targetType = getTypeOfSymbol(targetProp);
                        if (targetType.flags & 109472 /* Unit */ ) {
                            const sourceType = getTypeOfSymbol(sourceProp);
                            if (!(sourceType.flags & 1 /* Any */  || getRegularTypeOfLiteralType(sourceType) === getRegularTypeOfLiteralType(targetType))) yield targetProp;
                        }
                    }
                }
            }
        }
        function getUnmatchedProperty(source, target, requireOptionalProperties, matchDiscriminantProperties) {
            return firstOrUndefinedIterator(getUnmatchedProperties(source, target, requireOptionalProperties, matchDiscriminantProperties));
        }
        function tupleTypesDefinitelyUnrelated(source, target) {
            return !(target.target.combinedFlags & 8 /* Variadic */ ) && target.target.minLength > source.target.minLength || !(target.target.combinedFlags & 12 /* Variable */ ) && (!!(source.target.combinedFlags & 12 /* Variable */ ) || target.target.fixedLength < source.target.fixedLength);
        }
        function typesDefinitelyUnrelated(source, target) {
            return isTupleType(source) && isTupleType(target) ? tupleTypesDefinitelyUnrelated(source, target) : !!getUnmatchedProperty(source, target, /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ true) && !!getUnmatchedProperty(target, source, /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false);
        }
        function getTypeFromInference(inference) {
            return inference.candidates ? getUnionType(inference.candidates, 2 /* Subtype */ ) : inference.contraCandidates ? getIntersectionType(inference.contraCandidates) : void 0;
        }
        function hasSkipDirectInferenceFlag(node) {
            return !!getNodeLinks(node).skipDirectInference;
        }
        function isFromInferenceBlockedSource(type) {
            return !!(type.symbol && some(type.symbol.declarations, hasSkipDirectInferenceFlag));
        }
        function templateLiteralTypesDefinitelyUnrelated(source, target) {
            const sourceStart = source.texts[0];
            const targetStart = target.texts[0];
            const sourceEnd = source.texts[source.texts.length - 1];
            const targetEnd = target.texts[target.texts.length - 1];
            const startLen = Math.min(sourceStart.length, targetStart.length);
            const endLen = Math.min(sourceEnd.length, targetEnd.length);
            return sourceStart.slice(0, startLen) !== targetStart.slice(0, startLen) || sourceEnd.slice(sourceEnd.length - endLen) !== targetEnd.slice(targetEnd.length - endLen);
        }
        function isValidNumberString(s, roundTripOnly) {
            if (s === "") return false;
            const n = +s;
            return isFinite(n) && (!roundTripOnly || "" + n === s);
        }
        function parseBigIntLiteralType(text) {
            return getBigIntLiteralType(parseValidBigInt(text));
        }
        function isMemberOfStringMapping(source, target) {
            if (target.flags & 1 /* Any */ ) return true;
            if (target.flags & 134217732 /* TemplateLiteral */ ) return isTypeAssignableTo(source, target);
            if (target.flags & 268435456 /* StringMapping */ ) {
                const mappingStack = [];
                while(target.flags & 268435456 /* StringMapping */ ){
                    mappingStack.unshift(target.symbol);
                    target = target.type;
                }
                const mappedSource = reduceLeft(mappingStack, (memo, value1)=>getStringMappingType(value1, memo), source);
                return mappedSource === source && isMemberOfStringMapping(source, target);
            }
            return false;
        }
        function isValidTypeForTemplateLiteralPlaceholder(source, target) {
            if (target.flags & 2097152 /* Intersection */ ) return every(target.types, (t)=>t === emptyTypeLiteralType || isValidTypeForTemplateLiteralPlaceholder(source, t));
            if (target.flags & 4 /* String */  || isTypeAssignableTo(source, target)) return true;
            if (source.flags & 128 /* StringLiteral */ ) {
                const value1 = source.value;
                return !!(target.flags & 8 /* Number */  && isValidNumberString(value1, /*roundTripOnly*/ false) || target.flags & 64 /* BigInt */  && isValidBigIntString(value1, /*roundTripOnly*/ false) || target.flags & 98816 /* Nullable */  && value1 === target.intrinsicName || target.flags & 268435456 /* StringMapping */  && isMemberOfStringMapping(source, target) || target.flags & 134217728 /* TemplateLiteral */  && isTypeMatchedByTemplateLiteralType(source, target));
            }
            if (source.flags & 134217728 /* TemplateLiteral */ ) {
                const texts = source.texts;
                return texts.length === 2 && texts[0] === "" && texts[1] === "" && isTypeAssignableTo(source.types[0], target);
            }
            return false;
        }
        function inferTypesFromTemplateLiteralType(source, target) {
            return source.flags & 128 /* StringLiteral */  ? inferFromLiteralPartsToTemplateLiteral([
                source.value
            ], emptyArray, target) : source.flags & 134217728 /* TemplateLiteral */  ? arrayIsEqualTo(source.texts, target.texts) ? map(source.types, (s, i)=>{
                return isTypeAssignableTo(getBaseConstraintOrType(s), getBaseConstraintOrType(target.types[i])) ? s : getStringLikeTypeForType(s);
            }) : inferFromLiteralPartsToTemplateLiteral(source.texts, source.types, target) : void 0;
        }
        function isTypeMatchedByTemplateLiteralType(source, target) {
            const inferences = inferTypesFromTemplateLiteralType(source, target);
            return !!inferences && every(inferences, (r, i)=>isValidTypeForTemplateLiteralPlaceholder(r, target.types[i]));
        }
        function getStringLikeTypeForType(type) {
            return type.flags & 402653317 /* StringLike */  ? type : getTemplateLiteralType([
                "",
                ""
            ], [
                type
            ]);
        }
        function inferFromLiteralPartsToTemplateLiteral(sourceTexts, sourceTypes, target) {
            const lastSourceIndex = sourceTexts.length - 1;
            const sourceStartText = sourceTexts[0];
            const sourceEndText = sourceTexts[lastSourceIndex];
            const targetTexts = target.texts;
            const lastTargetIndex = targetTexts.length - 1;
            const targetStartText = targetTexts[0];
            const targetEndText = targetTexts[lastTargetIndex];
            if (lastSourceIndex === 0 && sourceStartText.length < targetStartText.length + targetEndText.length || !sourceStartText.startsWith(targetStartText) || !sourceEndText.endsWith(targetEndText)) return void 0;
            const remainingEndText = sourceEndText.slice(0, sourceEndText.length - targetEndText.length);
            const matches = [];
            let seg = 0;
            let pos = targetStartText.length;
            for(let i = 1; i < lastTargetIndex; i++){
                const delim = targetTexts[i];
                if (delim.length > 0) {
                    let s = seg;
                    let p = pos;
                    while(true){
                        p = getSourceText(s).indexOf(delim, p);
                        if (p >= 0) break;
                        s++;
                        if (s === sourceTexts.length) return void 0;
                        p = 0;
                    }
                    addMatch(s, p);
                    pos += delim.length;
                } else if (pos < getSourceText(seg).length) addMatch(seg, pos + 1);
                else if (seg < lastSourceIndex) addMatch(seg + 1, 0);
                else return void 0;
            }
            addMatch(lastSourceIndex, getSourceText(lastSourceIndex).length);
            return matches;
            function getSourceText(index) {
                return index < lastSourceIndex ? sourceTexts[index] : remainingEndText;
            }
            function addMatch(s, p) {
                const matchType = s === seg ? getStringLiteralType(getSourceText(s).slice(pos, p)) : getTemplateLiteralType([
                    sourceTexts[seg].slice(pos),
                    ...sourceTexts.slice(seg + 1, s),
                    getSourceText(s).slice(0, p)
                ], sourceTypes.slice(seg, s));
                matches.push(matchType);
                seg = s;
                pos = p;
            }
        }
        function inferTypes(inferences, originalSource, originalTarget, priority = 0 /* None */ , contravariant = false) {
            let bivariant = false;
            let propagationType;
            let inferencePriority = 2048 /* MaxValue */ ;
            let visited;
            let sourceStack;
            let targetStack;
            let expandingFlags = 0 /* None */ ;
            inferFromTypes(originalSource, originalTarget);
            function inferFromTypes(source, target) {
                if (!couldContainTypeVariables(target) || isNoInferType(target)) return;
                if (source === wildcardType || source === blockedStringType) {
                    const savePropagationType = propagationType;
                    propagationType = source;
                    inferFromTypes(target, target);
                    propagationType = savePropagationType;
                    return;
                }
                if (source.aliasSymbol && source.aliasSymbol === target.aliasSymbol) {
                    if (source.aliasTypeArguments) {
                        const params = getSymbolLinks(source.aliasSymbol).typeParameters;
                        const minParams = getMinTypeArgumentCount(params);
                        const sourceTypes = fillMissingTypeArguments(source.aliasTypeArguments, params, minParams, isInJSFile(source.aliasSymbol.valueDeclaration));
                        const targetTypes = fillMissingTypeArguments(target.aliasTypeArguments, params, minParams, isInJSFile(source.aliasSymbol.valueDeclaration));
                        inferFromTypeArguments(sourceTypes, targetTypes, getAliasVariances(source.aliasSymbol));
                    }
                    return;
                }
                if (source === target && source.flags & 3145728 /* UnionOrIntersection */ ) {
                    for (const t of source.types)inferFromTypes(t, t);
                    return;
                }
                if (target.flags & 1048576 /* Union */ ) {
                    const [tempSources, tempTargets] = inferFromMatchingTypes(source.flags & 1048576 /* Union */  ? source.types : [
                        source
                    ], target.types, isTypeOrBaseIdenticalTo);
                    const [sources, targets] = inferFromMatchingTypes(tempSources, tempTargets, isTypeCloselyMatchedBy);
                    if (targets.length === 0) return;
                    target = getUnionType(targets);
                    if (sources.length === 0) {
                        inferWithPriority(source, target, 1 /* NakedTypeVariable */ );
                        return;
                    }
                    source = getUnionType(sources);
                } else if (target.flags & 2097152 /* Intersection */  && !every(target.types, isNonGenericObjectType)) {
                    if (!(source.flags & 1048576 /* Union */ )) {
                        const [sources, targets] = inferFromMatchingTypes(source.flags & 2097152 /* Intersection */  ? source.types : [
                            source
                        ], target.types, isTypeIdenticalTo);
                        if (sources.length === 0 || targets.length === 0) return;
                        source = getIntersectionType(sources);
                        target = getIntersectionType(targets);
                    }
                }
                if (target.flags & 41943040 /* Substitution */ ) {
                    if (isNoInferType(target)) return;
                    target = getActualTypeVariable(target);
                }
                if (target.flags & 8650752 /* TypeVariable */ ) {
                    if (isFromInferenceBlockedSource(source)) return;
                    const inference = getInferenceInfoForType(target);
                    if (inference) {
                        if (getObjectFlags(source) & 262144 /* NonInferrableType */  || source === nonInferrableAnyType) return;
                        if (!inference.isFixed) {
                            const candidate = propagationType || source;
                            if (candidate === blockedStringType) return;
                            if (inference.priority === void 0 || priority < inference.priority) {
                                inference.candidates = void 0;
                                inference.contraCandidates = void 0;
                                inference.topLevel = true;
                                inference.priority = priority;
                            }
                            if (priority === inference.priority) {
                                if (contravariant && !bivariant) {
                                    if (!contains(inference.contraCandidates, candidate)) {
                                        inference.contraCandidates = append(inference.contraCandidates, candidate);
                                        clearCachedInferences(inferences);
                                    }
                                } else if (!contains(inference.candidates, candidate)) {
                                    inference.candidates = append(inference.candidates, candidate);
                                    clearCachedInferences(inferences);
                                }
                            }
                            if (!(priority & 128 /* ReturnType */ ) && target.flags & 262144 /* TypeParameter */  && inference.topLevel && !isTypeParameterAtTopLevel(originalTarget, target)) {
                                inference.topLevel = false;
                                clearCachedInferences(inferences);
                            }
                        }
                        inferencePriority = Math.min(inferencePriority, priority);
                        return;
                    }
                    const simplified = getSimplifiedType(target, /*writing*/ false);
                    if (simplified !== target) inferFromTypes(source, simplified);
                    else if (target.flags & 8388608 /* IndexedAccess */ ) {
                        const indexType = getSimplifiedType(target.indexType, /*writing*/ false);
                        if (indexType.flags & 465829888 /* Instantiable */ ) {
                            const simplified2 = distributeIndexOverObjectType(getSimplifiedType(target.objectType, /*writing*/ false), indexType, /*writing*/ false);
                            if (simplified2 && simplified2 !== target) inferFromTypes(source, simplified2);
                        }
                    }
                }
                if (getObjectFlags(source) & 4 /* Reference */  && getObjectFlags(target) & 4 /* Reference */  && (source.target === target.target || isArrayType(source) && isArrayType(target)) && !(source.node && target.node)) inferFromTypeArguments(getTypeArguments(source), getTypeArguments(target), getVariances(source.target));
                else if (source.flags & 4194304 /* Index */  && target.flags & 4194304 /* Index */ ) inferFromContravariantTypes(source.type, target.type);
                else if ((isLiteralType(source) || source.flags & 4 /* String */ ) && target.flags & 4194304 /* Index */ ) {
                    const empty = createEmptyObjectTypeFromStringLiteral(source);
                    inferFromContravariantTypesWithPriority(empty, target.type, 256 /* LiteralKeyof */ );
                } else if (source.flags & 8388608 /* IndexedAccess */  && target.flags & 8388608 /* IndexedAccess */ ) {
                    inferFromTypes(source.objectType, target.objectType);
                    inferFromTypes(source.indexType, target.indexType);
                } else if (source.flags & 268435456 /* StringMapping */  && target.flags & 268435456 /* StringMapping */ ) {
                    if (source.symbol === target.symbol) inferFromTypes(source.type, target.type);
                } else if (source.flags & 33554432 /* Substitution */ ) {
                    inferFromTypes(source.baseType, target);
                    inferWithPriority(getSubstitutionIntersection(source), target, 4 /* SubstituteSource */ );
                } else if (target.flags & 16777216 /* Conditional */ ) invokeOnce(source, target, inferToConditionalType);
                else if (target.flags & 3145728 /* UnionOrIntersection */ ) inferToMultipleTypes(source, target.types, target.flags);
                else if (source.flags & 1048576 /* Union */ ) {
                    const sourceTypes = source.types;
                    for (const sourceType of sourceTypes)inferFromTypes(sourceType, target);
                } else if (target.flags & 134217728 /* TemplateLiteral */ ) inferToTemplateLiteralType(source, target);
                else {
                    source = getReducedType(source);
                    if (isGenericMappedType(source) && isGenericMappedType(target)) invokeOnce(source, target, inferFromGenericMappedTypes);
                    if (!(priority & 512 /* NoConstraints */  && source.flags & 467927040 /* Instantiable */ )) {
                        const apparentSource = getApparentType(source);
                        if (apparentSource !== source && !(apparentSource.flags & 2621440 /* Intersection */ )) return inferFromTypes(apparentSource, target);
                        source = apparentSource;
                    }
                    if (source.flags & 2621440 /* Intersection */ ) invokeOnce(source, target, inferFromObjectTypes);
                }
            }
            function inferWithPriority(source, target, newPriority) {
                const savePriority = priority;
                priority |= newPriority;
                inferFromTypes(source, target);
                priority = savePriority;
            }
            function inferFromContravariantTypesWithPriority(source, target, newPriority) {
                const savePriority = priority;
                priority |= newPriority;
                inferFromContravariantTypes(source, target);
                priority = savePriority;
            }
            function inferToMultipleTypesWithPriority(source, targets, targetFlags, newPriority) {
                const savePriority = priority;
                priority |= newPriority;
                inferToMultipleTypes(source, targets, targetFlags);
                priority = savePriority;
            }
            function invokeOnce(source, target, action) {
                const key = source.id + "," + target.id;
                const status = visited && visited.get(key);
                if (status !== void 0) {
                    inferencePriority = Math.min(inferencePriority, status);
                    return;
                }
                (visited || (visited = /* @__PURE__ */ new Map())).set(key, -1 /* Circularity */ );
                const saveInferencePriority = inferencePriority;
                inferencePriority = 2048 /* MaxValue */ ;
                const saveExpandingFlags = expandingFlags;
                (sourceStack !== null && sourceStack !== void 0 ? sourceStack : sourceStack = []).push(source);
                (targetStack !== null && targetStack !== void 0 ? targetStack : targetStack = []).push(target);
                if (isDeeplyNestedType(source, sourceStack, sourceStack.length, 2)) expandingFlags |= 1 /* Source */ ;
                if (isDeeplyNestedType(target, targetStack, targetStack.length, 2)) expandingFlags |= 2 /* Target */ ;
                if (expandingFlags !== 3 /* Both */ ) action(source, target);
                else inferencePriority = -1 /* Circularity */ ;
                targetStack.pop();
                sourceStack.pop();
                expandingFlags = saveExpandingFlags;
                visited.set(key, inferencePriority);
                inferencePriority = Math.min(inferencePriority, saveInferencePriority);
            }
            function inferFromMatchingTypes(sources, targets, matches) {
                let matchedSources;
                let matchedTargets;
                for (const t of targets){
                    for (const s of sources)if (matches(s, t)) {
                        inferFromTypes(s, t);
                        matchedSources = appendIfUnique(matchedSources, s);
                        matchedTargets = appendIfUnique(matchedTargets, t);
                    }
                }
                return [
                    matchedSources ? filter(sources, (t)=>!contains(matchedSources, t)) : sources,
                    matchedTargets ? filter(targets, (t)=>!contains(matchedTargets, t)) : targets
                ];
            }
            function inferFromTypeArguments(sourceTypes, targetTypes, variances) {
                const count = sourceTypes.length < targetTypes.length ? sourceTypes.length : targetTypes.length;
                for(let i = 0; i < count; i++)if (i < variances.length && (variances[i] & 7 /* VarianceMask */ ) === 2 /* Contravariant */ ) inferFromContravariantTypes(sourceTypes[i], targetTypes[i]);
                else inferFromTypes(sourceTypes[i], targetTypes[i]);
            }
            function inferFromContravariantTypes(source, target) {
                contravariant = !contravariant;
                inferFromTypes(source, target);
                contravariant = !contravariant;
            }
            function inferFromContravariantTypesIfStrictFunctionTypes(source, target) {
                if (strictFunctionTypes || priority & 1024 /* AlwaysStrict */ ) inferFromContravariantTypes(source, target);
                else inferFromTypes(source, target);
            }
            function getInferenceInfoForType(type) {
                if (type.flags & 8650752 /* TypeVariable */ ) for (const inference of inferences){
                    if (type === inference.typeParameter) return inference;
                }
                return void 0;
            }
            function getSingleTypeVariableFromIntersectionTypes(types) {
                let typeVariable;
                for (const type of types){
                    const t = type.flags & 2097152 /* Intersection */  && find(type.types, (t2)=>!!getInferenceInfoForType(t2));
                    if (!t || typeVariable && t !== typeVariable) return void 0;
                    typeVariable = t;
                }
                return typeVariable;
            }
            function inferToMultipleTypes(source, targets, targetFlags) {
                let typeVariableCount = 0;
                if (targetFlags & 1048576 /* Union */ ) {
                    let nakedTypeVariable;
                    const sources = source.flags & 1048576 /* Union */  ? source.types : [
                        source
                    ];
                    const matched = new Array(sources.length);
                    let inferenceCircularity = false;
                    for (const t of targets){
                        if (getInferenceInfoForType(t)) {
                            nakedTypeVariable = t;
                            typeVariableCount++;
                        } else for(let i = 0; i < sources.length; i++){
                            const saveInferencePriority = inferencePriority;
                            inferencePriority = 2048 /* MaxValue */ ;
                            inferFromTypes(sources[i], t);
                            if (inferencePriority === priority) matched[i] = true;
                            inferenceCircularity = inferenceCircularity || inferencePriority === -1 /* Circularity */ ;
                            inferencePriority = Math.min(inferencePriority, saveInferencePriority);
                        }
                    }
                    if (typeVariableCount === 0) {
                        const intersectionTypeVariable = getSingleTypeVariableFromIntersectionTypes(targets);
                        if (intersectionTypeVariable) inferWithPriority(source, intersectionTypeVariable, 1 /* NakedTypeVariable */ );
                        return;
                    }
                    if (typeVariableCount === 1 && !inferenceCircularity) {
                        const unmatched = flatMap(sources, (s, i)=>matched[i] ? void 0 : s);
                        if (unmatched.length) {
                            inferFromTypes(getUnionType(unmatched), nakedTypeVariable);
                            return;
                        }
                    }
                } else {
                    for (const t of targets)if (getInferenceInfoForType(t)) typeVariableCount++;
                    else inferFromTypes(source, t);
                }
                if (targetFlags & 2097152 /* Intersection */  ? typeVariableCount === 1 : typeVariableCount > 0) {
                    for (const t of targets)if (getInferenceInfoForType(t)) inferWithPriority(source, t, 1 /* NakedTypeVariable */ );
                }
            }
            function inferToMappedType(source, target, constraintType) {
                if (constraintType.flags & 1048576 /* Union */  || constraintType.flags & 2097152 /* Intersection */ ) {
                    let result = false;
                    for (const type of constraintType.types)result = inferToMappedType(source, target, type) || result;
                    return result;
                }
                if (constraintType.flags & 4194304 /* Index */ ) {
                    const inference = getInferenceInfoForType(constraintType.type);
                    if (inference && !inference.isFixed && !isFromInferenceBlockedSource(source)) {
                        const inferredType = inferTypeForHomomorphicMappedType(source, target, constraintType);
                        if (inferredType) inferWithPriority(inferredType, inference.typeParameter, getObjectFlags(source) & 262144 /* NonInferrableType */  ? 16 /* PartialHomomorphicMappedType */  : 8 /* HomomorphicMappedType */ );
                    }
                    return true;
                }
                if (constraintType.flags & 262144 /* TypeParameter */ ) {
                    inferWithPriority(getIndexType(source, /*indexFlags*/ !!source.pattern ? 2 /* NoIndexSignatures */  : 0 /* None */ ), constraintType, 32 /* MappedTypeConstraint */ );
                    const extendedConstraint = getConstraintOfType(constraintType);
                    if (extendedConstraint && inferToMappedType(source, target, extendedConstraint)) return true;
                    const propTypes = map(getPropertiesOfType(source), getTypeOfSymbol);
                    const indexTypes = map(getIndexInfosOfType(source), (info)=>info !== enumNumberIndexInfo ? info.type : neverType);
                    inferFromTypes(getUnionType(concatenate(propTypes, indexTypes)), getTemplateTypeFromMappedType(target));
                    return true;
                }
                return false;
            }
            function inferToConditionalType(source, target) {
                if (source.flags & 16777216 /* Conditional */ ) {
                    inferFromTypes(source.checkType, target.checkType);
                    inferFromTypes(source.extendsType, target.extendsType);
                    inferFromTypes(getTrueTypeFromConditionalType(source), getTrueTypeFromConditionalType(target));
                    inferFromTypes(getFalseTypeFromConditionalType(source), getFalseTypeFromConditionalType(target));
                } else {
                    const targetTypes = [
                        getTrueTypeFromConditionalType(target),
                        getFalseTypeFromConditionalType(target)
                    ];
                    inferToMultipleTypesWithPriority(source, targetTypes, target.flags, contravariant ? 64 /* ContravariantConditional */  : 0);
                }
            }
            function inferToTemplateLiteralType(source, target) {
                const matches = inferTypesFromTemplateLiteralType(source, target);
                const types = target.types;
                if (matches || every(target.texts, (s)=>s.length === 0)) for(let i = 0; i < types.length; i++){
                    const source2 = matches ? matches[i] : neverType;
                    const target2 = types[i];
                    if (source2.flags & 128 /* StringLiteral */  && target2.flags & 8650752 /* TypeVariable */ ) {
                        const inferenceContext = getInferenceInfoForType(target2);
                        const constraint = inferenceContext ? getBaseConstraintOfType(inferenceContext.typeParameter) : void 0;
                        if (constraint && !isTypeAny(constraint)) {
                            const constraintTypes = constraint.flags & 1048576 /* Union */  ? constraint.types : [
                                constraint
                            ];
                            let allTypeFlags = reduceLeft(constraintTypes, (flags, t)=>flags | t.flags, 0);
                            if (!(allTypeFlags & 4 /* String */ )) {
                                const str = source2.value;
                                if (allTypeFlags & 296 /* NumberLike */  && !isValidNumberString(str, /*roundTripOnly*/ true)) allTypeFlags &= -297 /* NumberLike */ ;
                                if (allTypeFlags & 2112 /* BigIntLike */  && !isValidBigIntString(str, /*roundTripOnly*/ true)) allTypeFlags &= -2113 /* BigIntLike */ ;
                                const matchingType = reduceLeft(constraintTypes, (left, right)=>!(right.flags & allTypeFlags) ? left : left.flags & 4 /* String */  ? left : right.flags & 4 /* String */  ? source2 : left.flags & 134217728 /* TemplateLiteral */  ? left : right.flags & 134217728 /* TemplateLiteral */  && isTypeMatchedByTemplateLiteralType(source2, right) ? source2 : left.flags & 268435456 /* StringMapping */  ? left : right.flags & 268435456 /* StringMapping */  && str === applyStringMapping(right.symbol, str) ? source2 : left.flags & 128 /* StringLiteral */  ? left : right.flags & 128 /* StringLiteral */  && right.value === str ? right : left.flags & 8 /* Number */  ? left : right.flags & 8 /* Number */  ? getNumberLiteralType(+str) : left.flags & 32 /* Enum */  ? left : right.flags & 32 /* Enum */  ? getNumberLiteralType(+str) : left.flags & 256 /* NumberLiteral */  ? left : right.flags & 256 /* NumberLiteral */  && right.value === +str ? right : left.flags & 64 /* BigInt */  ? left : right.flags & 64 /* BigInt */  ? parseBigIntLiteralType(str) : left.flags & 2048 /* BigIntLiteral */  ? left : right.flags & 2048 /* BigIntLiteral */  && pseudoBigIntToString(right.value) === str ? right : left.flags & 16 /* Boolean */  ? left : right.flags & 16 /* Boolean */  ? str === "true" ? trueType : str === "false" ? falseType : booleanType : left.flags & 512 /* BooleanLiteral */  ? left : right.flags & 512 /* BooleanLiteral */  && right.intrinsicName === str ? right : left.flags & 32768 /* Undefined */  ? left : right.flags & 32768 /* Undefined */  && right.intrinsicName === str ? right : left.flags & 65536 /* Null */  ? left : right.flags & 65536 /* Null */  && right.intrinsicName === str ? right : left, neverType);
                                if (!(matchingType.flags & 131072 /* Never */ )) {
                                    inferFromTypes(matchingType, target2);
                                    continue;
                                }
                            }
                        }
                    }
                    inferFromTypes(source2, target2);
                }
            }
            function inferFromGenericMappedTypes(source, target) {
                inferFromTypes(getConstraintTypeFromMappedType(source), getConstraintTypeFromMappedType(target));
                inferFromTypes(getTemplateTypeFromMappedType(source), getTemplateTypeFromMappedType(target));
                const sourceNameType = getNameTypeFromMappedType(source);
                const targetNameType = getNameTypeFromMappedType(target);
                if (sourceNameType && targetNameType) inferFromTypes(sourceNameType, targetNameType);
            }
            function inferFromObjectTypes(source, target) {
                var _a, _b;
                if (getObjectFlags(source) & 4 /* Reference */  && getObjectFlags(target) & 4 /* Reference */  && (source.target === target.target || isArrayType(source) && isArrayType(target))) {
                    inferFromTypeArguments(getTypeArguments(source), getTypeArguments(target), getVariances(source.target));
                    return;
                }
                if (isGenericMappedType(source) && isGenericMappedType(target)) inferFromGenericMappedTypes(source, target);
                if (getObjectFlags(target) & 32 /* Mapped */  && !target.declaration.nameType) {
                    const constraintType = getConstraintTypeFromMappedType(target);
                    if (inferToMappedType(source, target, constraintType)) return;
                }
                if (!typesDefinitelyUnrelated(source, target)) {
                    if (isArrayOrTupleType(source)) {
                        if (isTupleType(target)) {
                            const sourceArity = getTypeReferenceArity(source);
                            const targetArity = getTypeReferenceArity(target);
                            const elementTypes = getTypeArguments(target);
                            const elementFlags = target.target.elementFlags;
                            if (isTupleType(source) && isTupleTypeStructureMatching(source, target)) {
                                for(let i = 0; i < targetArity; i++)inferFromTypes(getTypeArguments(source)[i], elementTypes[i]);
                                return;
                            }
                            const startLength = isTupleType(source) ? Math.min(source.target.fixedLength, target.target.fixedLength) : 0;
                            const endLength = Math.min(isTupleType(source) ? getEndElementCount(source.target, 3 /* Fixed */ ) : 0, target.target.combinedFlags & 12 /* Variable */  ? getEndElementCount(target.target, 3 /* Fixed */ ) : 0);
                            for(let i = 0; i < startLength; i++)inferFromTypes(getTypeArguments(source)[i], elementTypes[i]);
                            if (!isTupleType(source) || sourceArity - startLength - endLength === 1 && source.target.elementFlags[startLength] & 4 /* Rest */ ) {
                                const restType = getTypeArguments(source)[startLength];
                                for(let i = startLength; i < targetArity - endLength; i++)inferFromTypes(elementFlags[i] & 8 /* Variadic */  ? createArrayType(restType) : restType, elementTypes[i]);
                            } else {
                                const middleLength = targetArity - startLength - endLength;
                                if (middleLength === 2) {
                                    if (elementFlags[startLength] & elementFlags[startLength + 1] & 8 /* Variadic */ ) {
                                        const targetInfo = getInferenceInfoForType(elementTypes[startLength]);
                                        if (targetInfo && targetInfo.impliedArity !== void 0) {
                                            inferFromTypes(sliceTupleType(source, startLength, endLength + sourceArity - targetInfo.impliedArity), elementTypes[startLength]);
                                            inferFromTypes(sliceTupleType(source, startLength + targetInfo.impliedArity, endLength), elementTypes[startLength + 1]);
                                        }
                                    } else if (elementFlags[startLength] & 8 /* Variadic */  && elementFlags[startLength + 1] & 4 /* Rest */ ) {
                                        const param = (_a = getInferenceInfoForType(elementTypes[startLength])) == null ? void 0 : _a.typeParameter;
                                        const constraint = param && getBaseConstraintOfType(param);
                                        if (constraint && isTupleType(constraint) && !(constraint.target.combinedFlags & 12 /* Variable */ )) {
                                            const impliedArity = constraint.target.fixedLength;
                                            inferFromTypes(sliceTupleType(source, startLength, sourceArity - (startLength + impliedArity)), elementTypes[startLength]);
                                            inferFromTypes(getElementTypeOfSliceOfTupleType(source, startLength + impliedArity, endLength), elementTypes[startLength + 1]);
                                        }
                                    } else if (elementFlags[startLength] & 4 /* Rest */  && elementFlags[startLength + 1] & 8 /* Variadic */ ) {
                                        const param = (_b = getInferenceInfoForType(elementTypes[startLength + 1])) == null ? void 0 : _b.typeParameter;
                                        const constraint = param && getBaseConstraintOfType(param);
                                        if (constraint && isTupleType(constraint) && !(constraint.target.combinedFlags & 12 /* Variable */ )) {
                                            const impliedArity = constraint.target.fixedLength;
                                            const endIndex = sourceArity - getEndElementCount(target.target, 3 /* Fixed */ );
                                            const startIndex = endIndex - impliedArity;
                                            const trailingSlice = createTupleType(getTypeArguments(source).slice(startIndex, endIndex), source.target.elementFlags.slice(startIndex, endIndex), /*readonly*/ false, source.target.labeledElementDeclarations && source.target.labeledElementDeclarations.slice(startIndex, endIndex));
                                            inferFromTypes(getElementTypeOfSliceOfTupleType(source, startLength, endLength + impliedArity), elementTypes[startLength]);
                                            inferFromTypes(trailingSlice, elementTypes[startLength + 1]);
                                        }
                                    }
                                } else if (middleLength === 1 && elementFlags[startLength] & 8 /* Variadic */ ) {
                                    const endsInOptional = target.target.elementFlags[targetArity - 1] & 2 /* Optional */ ;
                                    const sourceSlice = sliceTupleType(source, startLength, endLength);
                                    inferWithPriority(sourceSlice, elementTypes[startLength], endsInOptional ? 2 /* SpeculativeTuple */  : 0);
                                } else if (middleLength === 1 && elementFlags[startLength] & 4 /* Rest */ ) {
                                    const restType = getElementTypeOfSliceOfTupleType(source, startLength, endLength);
                                    if (restType) inferFromTypes(restType, elementTypes[startLength]);
                                }
                            }
                            for(let i = 0; i < endLength; i++)inferFromTypes(getTypeArguments(source)[sourceArity - i - 1], elementTypes[targetArity - i - 1]);
                            return;
                        }
                        if (isArrayType(target)) {
                            inferFromIndexTypes(source, target);
                            return;
                        }
                    }
                    inferFromProperties(source, target);
                    inferFromSignatures(source, target, 0 /* Call */ );
                    inferFromSignatures(source, target, 1 /* Construct */ );
                    inferFromIndexTypes(source, target);
                }
            }
            function inferFromProperties(source, target) {
                const properties = getPropertiesOfObjectType(target);
                for (const targetProp of properties){
                    const sourceProp = getPropertyOfType(source, targetProp.escapedName);
                    if (sourceProp && !some(sourceProp.declarations, hasSkipDirectInferenceFlag)) inferFromTypes(removeMissingType(getTypeOfSymbol(sourceProp), !!(sourceProp.flags & 16777216 /* Optional */ )), removeMissingType(getTypeOfSymbol(targetProp), !!(targetProp.flags & 16777216 /* Optional */ )));
                }
            }
            function inferFromSignatures(source, target, kind) {
                const sourceSignatures = getSignaturesOfType(source, kind);
                const sourceLen = sourceSignatures.length;
                if (sourceLen > 0) {
                    const targetSignatures = getSignaturesOfType(target, kind);
                    const targetLen = targetSignatures.length;
                    for(let i = 0; i < targetLen; i++){
                        const sourceIndex = Math.max(sourceLen - targetLen + i, 0);
                        inferFromSignature(getBaseSignature(sourceSignatures[sourceIndex]), getErasedSignature(targetSignatures[i]));
                    }
                }
            }
            function inferFromSignature(source, target) {
                if (!(source.flags & 64 /* IsNonInferrable */ )) {
                    const saveBivariant = bivariant;
                    const kind = target.declaration ? target.declaration.kind : 0 /* Unknown */ ;
                    bivariant = bivariant || kind === 175 /* MethodDeclaration */  || kind === 174 /* MethodSignature */  || kind === 177 /* Constructor */ ;
                    applyToParameterTypes(source, target, inferFromContravariantTypesIfStrictFunctionTypes);
                    bivariant = saveBivariant;
                }
                applyToReturnTypes(source, target, inferFromTypes);
            }
            function inferFromIndexTypes(source, target) {
                const priority2 = getObjectFlags(source) & getObjectFlags(target) & 32 /* Mapped */  ? 8 /* HomomorphicMappedType */  : 0;
                const indexInfos = getIndexInfosOfType(target);
                if (isObjectTypeWithInferableIndex(source)) for (const targetInfo of indexInfos){
                    const propTypes = [];
                    for (const prop of getPropertiesOfType(source))if (isApplicableIndexType(getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ ), targetInfo.keyType)) {
                        const propType = getTypeOfSymbol(prop);
                        propTypes.push(prop.flags & 16777216 /* Optional */  ? removeMissingOrUndefinedType(propType) : propType);
                    }
                    for (const info of getIndexInfosOfType(source))if (isApplicableIndexType(info.keyType, targetInfo.keyType)) propTypes.push(info.type);
                    if (propTypes.length) inferWithPriority(getUnionType(propTypes), targetInfo.type, priority2);
                }
                for (const targetInfo of indexInfos){
                    const sourceInfo = getApplicableIndexInfo(source, targetInfo.keyType);
                    if (sourceInfo) inferWithPriority(sourceInfo.type, targetInfo.type, priority2);
                }
            }
        }
        function isTypeOrBaseIdenticalTo(s, t) {
            return t === missingType ? s === t : isTypeIdenticalTo(s, t) || !!(t.flags & 4 /* String */  && s.flags & 128 /* StringLiteral */  || t.flags & 8 /* Number */  && s.flags & 256 /* NumberLiteral */ );
        }
        function isTypeCloselyMatchedBy(s, t) {
            return !!(s.flags & 524288 /* Object */  && t.flags & 524288 /* Object */  && s.symbol && s.symbol === t.symbol || s.aliasSymbol && s.aliasTypeArguments && s.aliasSymbol === t.aliasSymbol);
        }
        function hasPrimitiveConstraint(type) {
            const constraint = getConstraintOfTypeParameter(type);
            return !!constraint && maybeTypeOfKind(constraint.flags & 16777216 /* Conditional */  ? getDefaultConstraintOfConditionalType(constraint) : constraint, 406978556 /* StringMapping */ );
        }
        function isObjectLiteralType2(type) {
            return !!(getObjectFlags(type) & 128 /* ObjectLiteral */ );
        }
        function isObjectOrArrayLiteralType(type) {
            return !!(getObjectFlags(type) & 16512 /* ArrayLiteral */ );
        }
        function unionObjectAndArrayLiteralCandidates(candidates) {
            if (candidates.length > 1) {
                const objectLiterals = filter(candidates, isObjectOrArrayLiteralType);
                if (objectLiterals.length) {
                    const literalsType = getUnionType(objectLiterals, 2 /* Subtype */ );
                    return concatenate(filter(candidates, (t)=>!isObjectOrArrayLiteralType(t)), [
                        literalsType
                    ]);
                }
            }
            return candidates;
        }
        function getContravariantInference(inference) {
            return inference.priority & 416 /* PriorityImpliesCombination */  ? getIntersectionType(inference.contraCandidates) : getCommonSubtype(inference.contraCandidates);
        }
        function getCovariantInference(inference, signature) {
            const candidates = unionObjectAndArrayLiteralCandidates(inference.candidates);
            const primitiveConstraint = hasPrimitiveConstraint(inference.typeParameter) || isConstTypeVariable(inference.typeParameter);
            const widenLiteralTypes = !primitiveConstraint && inference.topLevel && (inference.isFixed || !isTypeParameterAtTopLevelInReturnType(signature, inference.typeParameter));
            const baseCandidates = primitiveConstraint ? sameMap(candidates, getRegularTypeOfLiteralType) : widenLiteralTypes ? sameMap(candidates, getWidenedLiteralType) : candidates;
            const unwidenedType = inference.priority & 416 /* PriorityImpliesCombination */  ? getUnionType(baseCandidates, 2 /* Subtype */ ) : getCommonSupertype(baseCandidates);
            return getWidenedType(unwidenedType);
        }
        function getInferredType(context, index) {
            const inference = context.inferences[index];
            if (!inference.inferredType) {
                let inferredType;
                let fallbackType;
                if (context.signature) {
                    const inferredCovariantType = inference.candidates ? getCovariantInference(inference, context.signature) : void 0;
                    const inferredContravariantType = inference.contraCandidates ? getContravariantInference(inference) : void 0;
                    if (inferredCovariantType || inferredContravariantType) {
                        const preferCovariantType = inferredCovariantType && (!inferredContravariantType || !(inferredCovariantType.flags & 131073 /* Any */ ) && some(inference.contraCandidates, (t)=>isTypeAssignableTo(inferredCovariantType, t)) && every(context.inferences, (other)=>other !== inference && getConstraintOfTypeParameter(other.typeParameter) !== inference.typeParameter || every(other.candidates, (t)=>isTypeAssignableTo(t, inferredCovariantType))));
                        inferredType = preferCovariantType ? inferredCovariantType : inferredContravariantType;
                        fallbackType = preferCovariantType ? inferredContravariantType : inferredCovariantType;
                    } else if (context.flags & 1 /* NoDefault */ ) inferredType = silentNeverType;
                    else {
                        const defaultType = getDefaultFromTypeParameter(inference.typeParameter);
                        if (defaultType) inferredType = instantiateType(defaultType, mergeTypeMappers(createBackreferenceMapper(context, index), context.nonFixingMapper));
                    }
                } else inferredType = getTypeFromInference(inference);
                inference.inferredType = inferredType || getDefaultTypeArgumentType(!!(context.flags & 2 /* AnyDefault */ ));
                const constraint = getConstraintOfTypeParameter(inference.typeParameter);
                if (constraint) {
                    const instantiatedConstraint = instantiateType(constraint, context.nonFixingMapper);
                    if (!inferredType || !context.compareTypes(inferredType, getTypeWithThisArgument(instantiatedConstraint, inferredType))) inference.inferredType = fallbackType && context.compareTypes(fallbackType, getTypeWithThisArgument(instantiatedConstraint, fallbackType)) ? fallbackType : instantiatedConstraint;
                }
                clearActiveMapperCaches();
            }
            return inference.inferredType;
        }
        function getDefaultTypeArgumentType(isInJavaScriptFile) {
            return isInJavaScriptFile ? anyType : unknownType;
        }
        function getInferredTypes(context) {
            const result = [];
            for(let i = 0; i < context.inferences.length; i++)result.push(getInferredType(context, i));
            return result;
        }
        function getCannotFindNameDiagnosticForName(node) {
            switch(node.escapedText){
                case "document":
                case "console":
                    return Diagnostics.Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_include_dom;
                case "$":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery_and_then_add_jquery_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery;
                case "describe":
                case "suite":
                case "it":
                case "test":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha_and_then_add_jest_or_mocha_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha;
                case "process":
                case "require":
                case "Buffer":
                case "module":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode_and_then_add_node_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode;
                case "Bun":
                    return compilerOptions.types ? Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_Bun_Try_npm_i_save_dev_types_Slashbun_and_then_add_bun_to_the_types_field_in_your_tsconfig : Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_Bun_Try_npm_i_save_dev_types_Slashbun;
                case "Map":
                case "Set":
                case "Promise":
                case "Symbol":
                case "WeakMap":
                case "WeakSet":
                case "Iterator":
                case "AsyncIterator":
                case "SharedArrayBuffer":
                case "Atomics":
                case "AsyncIterable":
                case "AsyncIterableIterator":
                case "AsyncGenerator":
                case "AsyncGeneratorFunction":
                case "BigInt":
                case "Reflect":
                case "BigInt64Array":
                case "BigUint64Array":
                    return Diagnostics.Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_1_or_later;
                case "await":
                    if (isCallExpression(node.parent)) return Diagnostics.Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function;
                // falls through
                default:
                    if (node.parent.kind === 305 /* ShorthandPropertyAssignment */ ) return Diagnostics.No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer;
                    else return Diagnostics.Cannot_find_name_0;
            }
        }
        function getResolvedSymbol(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedSymbol) links.resolvedSymbol = !nodeIsMissing(node) && resolveName(node, node, 1160127 /* ExportValue */ , getCannotFindNameDiagnosticForName(node), !isWriteOnlyAccess(node), /*excludeGlobals*/ false) || unknownSymbol;
            return links.resolvedSymbol;
        }
        function isInAmbientOrTypeNode(node) {
            return !!(node.flags & 33554432 /* Ambient */  || findAncestor(node, (n)=>isInterfaceDeclaration(n) || isTypeAliasDeclaration(n) || isTypeLiteralNode(n)));
        }
        function getFlowCacheKey(node, declaredType, initialType, flowContainer) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    if (!isThisInTypeQuery(node)) {
                        const symbol = getResolvedSymbol(node);
                        return symbol !== unknownSymbol ? `${flowContainer ? getNodeId(flowContainer) : "-1"}|${getTypeId(declaredType)}|${getTypeId(initialType)}|${getSymbolId(symbol)}` : void 0;
                    }
                // falls through
                case 110 /* ThisKeyword */ :
                    return `0|${flowContainer ? getNodeId(flowContainer) : "-1"}|${getTypeId(declaredType)}|${getTypeId(initialType)}`;
                case 236 /* NonNullExpression */ :
                case 218 /* ParenthesizedExpression */ :
                    return getFlowCacheKey(node.expression, declaredType, initialType, flowContainer);
                case 167 /* QualifiedName */ :
                    const left = getFlowCacheKey(node.left, declaredType, initialType, flowContainer);
                    return left && `${left}.${node.right.escapedText}`;
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    const propName = getAccessedPropertyName(node);
                    if (propName !== void 0) {
                        const key = getFlowCacheKey(node.expression, declaredType, initialType, flowContainer);
                        return key && `${key}.${propName}`;
                    }
                    if (isElementAccessExpression(node) && isIdentifier(node.argumentExpression)) {
                        const symbol = getResolvedSymbol(node.argumentExpression);
                        if (isConstantVariable(symbol) || isParameterOrMutableLocalVariable(symbol) && !isSymbolAssigned(symbol)) {
                            const key = getFlowCacheKey(node.expression, declaredType, initialType, flowContainer);
                            return key && `${key}.@${getSymbolId(symbol)}`;
                        }
                    }
                    break;
                case 207 /* ObjectBindingPattern */ :
                case 208 /* ArrayBindingPattern */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 175 /* MethodDeclaration */ :
                    return `${getNodeId(node)}#${getTypeId(declaredType)}`;
            }
            return void 0;
        }
        function isMatchingReference(source, target) {
            switch(target.kind){
                case 218 /* ParenthesizedExpression */ :
                case 236 /* NonNullExpression */ :
                    return isMatchingReference(source, target.expression);
                case 227 /* BinaryExpression */ :
                    return isAssignmentExpression(target) && isMatchingReference(source, target.left) || isBinaryExpression(target) && target.operatorToken.kind === 28 /* CommaToken */  && isMatchingReference(source, target.right);
            }
            switch(source.kind){
                case 237 /* MetaProperty */ :
                    return target.kind === 237 /* MetaProperty */  && source.keywordToken === target.keywordToken && source.name.escapedText === target.name.escapedText;
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                    return isThisInTypeQuery(source) ? target.kind === 110 /* ThisKeyword */  : target.kind === 80 /* Identifier */  && getResolvedSymbol(source) === getResolvedSymbol(target) || (isVariableDeclaration(target) || isBindingElement(target)) && getExportSymbolOfValueSymbolIfExported(getResolvedSymbol(source)) === getSymbolOfDeclaration(target);
                case 110 /* ThisKeyword */ :
                    return target.kind === 110 /* ThisKeyword */ ;
                case 108 /* SuperKeyword */ :
                    return target.kind === 108 /* SuperKeyword */ ;
                case 236 /* NonNullExpression */ :
                case 218 /* ParenthesizedExpression */ :
                case 239 /* SatisfiesExpression */ :
                    return isMatchingReference(source.expression, target);
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    const sourcePropertyName = getAccessedPropertyName(source);
                    if (sourcePropertyName !== void 0) {
                        const targetPropertyName = isAccessExpression(target) ? getAccessedPropertyName(target) : void 0;
                        if (targetPropertyName !== void 0) return targetPropertyName === sourcePropertyName && isMatchingReference(source.expression, target.expression);
                    }
                    if (isElementAccessExpression(source) && isElementAccessExpression(target) && isIdentifier(source.argumentExpression) && isIdentifier(target.argumentExpression)) {
                        const symbol = getResolvedSymbol(source.argumentExpression);
                        if (symbol === getResolvedSymbol(target.argumentExpression) && (isConstantVariable(symbol) || isParameterOrMutableLocalVariable(symbol) && !isSymbolAssigned(symbol))) return isMatchingReference(source.expression, target.expression);
                    }
                    break;
                case 167 /* QualifiedName */ :
                    return isAccessExpression(target) && source.right.escapedText === getAccessedPropertyName(target) && isMatchingReference(source.left, target.expression);
                case 227 /* BinaryExpression */ :
                    return isBinaryExpression(source) && source.operatorToken.kind === 28 /* CommaToken */  && isMatchingReference(source.right, target);
            }
            return false;
        }
        function getAccessedPropertyName(access) {
            if (isPropertyAccessExpression(access)) return access.name.escapedText;
            if (isElementAccessExpression(access)) return tryGetElementAccessExpressionName(access);
            if (isBindingElement(access)) {
                const name = getDestructuringPropertyName(access);
                return name ? escapeLeadingUnderscores(name) : void 0;
            }
            if (isParameter(access)) return "" + access.parent.parameters.indexOf(access);
            return void 0;
        }
        function tryGetNameFromType(type) {
            return type.flags & 8192 /* UniqueESSymbol */  ? type.escapedName : type.flags & 384 /* StringOrNumberLiteral */  ? escapeLeadingUnderscores("" + type.value) : void 0;
        }
        function tryGetElementAccessExpressionName(node) {
            return isStringOrNumericLiteralLike(node.argumentExpression) ? escapeLeadingUnderscores(node.argumentExpression.text) : isEntityNameExpression(node.argumentExpression) ? tryGetNameFromEntityNameExpression(node.argumentExpression) : void 0;
        }
        function tryGetNameFromEntityNameExpression(node) {
            const symbol = resolveEntityName(node, 111551 /* Value */ , /*ignoreErrors*/ true);
            if (!symbol || !(isConstantVariable(symbol) || symbol.flags & 8 /* EnumMember */ )) return void 0;
            const declaration = symbol.valueDeclaration;
            if (declaration === void 0) return void 0;
            const type = tryGetTypeFromEffectiveTypeNode(declaration);
            if (type) {
                const name = tryGetNameFromType(type);
                if (name !== void 0) return name;
            }
            if (hasOnlyExpressionInitializer(declaration) && isBlockScopedNameDeclaredBeforeUse(declaration, node)) {
                const initializer = getEffectiveInitializer(declaration);
                if (initializer) {
                    const initializerType = isBindingPattern(declaration.parent) ? getTypeForBindingElement(declaration) : getTypeOfExpression(initializer);
                    return initializerType && tryGetNameFromType(initializerType);
                }
                if (isEnumMember(declaration)) return getTextOfPropertyName(declaration.name);
            }
            return void 0;
        }
        function containsMatchingReference(source, target) {
            while(isAccessExpression(source)){
                source = source.expression;
                if (isMatchingReference(source, target)) return true;
            }
            return false;
        }
        function optionalChainContainsReference(source, target) {
            while(isOptionalChain(source)){
                source = source.expression;
                if (isMatchingReference(source, target)) return true;
            }
            return false;
        }
        function isDiscriminantProperty(type, name) {
            if (type && type.flags & 1048576 /* Union */ ) {
                const prop = getUnionOrIntersectionProperty(type, name);
                if (prop && getCheckFlags(prop) & 2 /* SyntheticProperty */ ) {
                    if (prop.links.isDiscriminantProperty === void 0) prop.links.isDiscriminantProperty = (prop.links.checkFlags & 192 /* Discriminant */ ) === 192 /* Discriminant */  && !isGenericType(getTypeOfSymbol(prop));
                    return !!prop.links.isDiscriminantProperty;
                }
            }
            return false;
        }
        function findDiscriminantProperties(sourceProperties, target) {
            let result;
            for (const sourceProperty of sourceProperties)if (isDiscriminantProperty(target, sourceProperty.escapedName)) {
                if (result) {
                    result.push(sourceProperty);
                    continue;
                }
                result = [
                    sourceProperty
                ];
            }
            return result;
        }
        function mapTypesByKeyProperty(types, name) {
            const map2 = /* @__PURE__ */ new Map();
            let count = 0;
            for (const type of types)if (type.flags & 61603840 /* InstantiableNonPrimitive */ ) {
                const discriminant = getTypeOfPropertyOfType(type, name);
                if (discriminant) {
                    if (!isLiteralType(discriminant)) return void 0;
                    let duplicate = false;
                    forEachType(discriminant, (t)=>{
                        const id = getTypeId(getRegularTypeOfLiteralType(t));
                        const existing = map2.get(id);
                        if (!existing) map2.set(id, type);
                        else if (existing !== unknownType) {
                            map2.set(id, unknownType);
                            duplicate = true;
                        }
                    });
                    if (!duplicate) count++;
                }
            }
            return count >= 10 && count * 2 >= types.length ? map2 : void 0;
        }
        function getKeyPropertyName(unionType) {
            const types = unionType.types;
            if (types.length < 10 || getObjectFlags(unionType) & 32768 /* PrimitiveUnion */  || countWhere(types, (t)=>!!(t.flags & 59506688 /* InstantiableNonPrimitive */ )) < 10) return void 0;
            if (unionType.keyPropertyName === void 0) {
                const keyPropertyName = forEach(types, (t)=>t.flags & 59506688 /* InstantiableNonPrimitive */  ? forEach(getPropertiesOfType(t), (p)=>isUnitType(getTypeOfSymbol(p)) ? p.escapedName : void 0) : void 0);
                const mapByKeyProperty = keyPropertyName && mapTypesByKeyProperty(types, keyPropertyName);
                unionType.keyPropertyName = mapByKeyProperty ? keyPropertyName : "";
                unionType.constituentMap = mapByKeyProperty;
            }
            return unionType.keyPropertyName.length ? unionType.keyPropertyName : void 0;
        }
        function getConstituentTypeForKeyType(unionType, keyType) {
            var _a;
            const result = (_a = unionType.constituentMap) == null ? void 0 : _a.get(getTypeId(getRegularTypeOfLiteralType(keyType)));
            return result !== unknownType ? result : void 0;
        }
        function getMatchingUnionConstituentForType(unionType, type) {
            const keyPropertyName = getKeyPropertyName(unionType);
            const propType = keyPropertyName && getTypeOfPropertyOfType(type, keyPropertyName);
            return propType && getConstituentTypeForKeyType(unionType, propType);
        }
        function getMatchingUnionConstituentForObjectLiteral(unionType, node) {
            const keyPropertyName = getKeyPropertyName(unionType);
            const propNode = keyPropertyName && find(node.properties, (p)=>p.symbol && p.kind === 304 /* PropertyAssignment */  && p.symbol.escapedName === keyPropertyName && isPossiblyDiscriminantValue(p.initializer));
            const propType = propNode && getContextFreeTypeOfExpression(propNode.initializer);
            return propType && getConstituentTypeForKeyType(unionType, propType);
        }
        function isOrContainsMatchingReference(source, target) {
            return isMatchingReference(source, target) || containsMatchingReference(source, target);
        }
        function hasMatchingArgument(expression, reference) {
            if (expression.arguments) for (const argument of expression.arguments){
                if (isOrContainsMatchingReference(reference, argument) || optionalChainContainsReference(argument, reference)) return true;
            }
            if (expression.expression.kind === 212 /* PropertyAccessExpression */  && isOrContainsMatchingReference(reference, expression.expression.expression)) return true;
            return false;
        }
        function getFlowNodeId(flow) {
            if (flow.id <= 0) {
                flow.id = nextFlowId;
                nextFlowId++;
            }
            return flow.id;
        }
        function typeMaybeAssignableTo(source, target) {
            if (!(source.flags & 1048576 /* Union */ )) return isTypeAssignableTo(source, target);
            for (const t of source.types){
                if (isTypeAssignableTo(t, target)) return true;
            }
            return false;
        }
        function getAssignmentReducedType(declaredType, assignedType) {
            if (declaredType === assignedType) return declaredType;
            if (assignedType.flags & 131072 /* Never */ ) return assignedType;
            const key = `A${getTypeId(declaredType)},${getTypeId(assignedType)}`;
            var _getCachedType;
            return (_getCachedType = getCachedType(key)) !== null && _getCachedType !== void 0 ? _getCachedType : setCachedType(key, getAssignmentReducedTypeWorker(declaredType, assignedType));
        }
        function getAssignmentReducedTypeWorker(declaredType, assignedType) {
            const filteredType = filterType(declaredType, (t)=>typeMaybeAssignableTo(assignedType, t));
            const reducedType = assignedType.flags & 512 /* BooleanLiteral */  && isFreshLiteralType(assignedType) ? mapType(filteredType, getFreshTypeOfLiteralType) : filteredType;
            return isTypeAssignableTo(assignedType, reducedType) ? reducedType : declaredType;
        }
        function isFunctionObjectType(type) {
            if (getObjectFlags(type) & 256 /* EvolvingArray */ ) return false;
            const resolved = resolveStructuredTypeMembers(type);
            return !!(resolved.callSignatures.length || resolved.constructSignatures.length || resolved.members.get("bind") && isTypeSubtypeOf(type, globalFunctionType));
        }
        function getTypeFacts(type, mask2) {
            return getTypeFactsWorker(type, mask2) & mask2;
        }
        function hasTypeFacts(type, mask2) {
            return getTypeFacts(type, mask2) !== 0;
        }
        function getTypeFactsWorker(type, callerOnlyNeeds) {
            if (type.flags & 467927040 /* Instantiable */ ) type = getBaseConstraintOfType(type) || unknownType;
            const flags = type.flags;
            if (flags & 268435460 /* StringMapping */ ) return strictNullChecks ? 16317953 /* StringStrictFacts */  : 16776705 /* StringFacts */ ;
            if (flags & 134217856 /* TemplateLiteral */ ) {
                const isEmpty = flags & 128 /* StringLiteral */  && type.value === "";
                return strictNullChecks ? isEmpty ? 12123649 /* EmptyStringStrictFacts */  : 7929345 /* NonEmptyStringStrictFacts */  : isEmpty ? 12582401 /* EmptyStringFacts */  : 16776705 /* NonEmptyStringFacts */ ;
            }
            if (flags & 40 /* Enum */ ) return strictNullChecks ? 16317698 /* NumberStrictFacts */  : 16776450 /* NumberFacts */ ;
            if (flags & 256 /* NumberLiteral */ ) {
                const isZero = type.value === 0;
                return strictNullChecks ? isZero ? 12123394 /* ZeroNumberStrictFacts */  : 7929090 /* NonZeroNumberStrictFacts */  : isZero ? 12582146 /* ZeroNumberFacts */  : 16776450 /* NonZeroNumberFacts */ ;
            }
            if (flags & 64 /* BigInt */ ) return strictNullChecks ? 16317188 /* BigIntStrictFacts */  : 16775940 /* BigIntFacts */ ;
            if (flags & 2048 /* BigIntLiteral */ ) {
                const isZero = isZeroBigInt(type);
                return strictNullChecks ? isZero ? 12122884 /* ZeroBigIntStrictFacts */  : 7928580 /* NonZeroBigIntStrictFacts */  : isZero ? 12581636 /* ZeroBigIntFacts */  : 16775940 /* NonZeroBigIntFacts */ ;
            }
            if (flags & 16 /* Boolean */ ) return strictNullChecks ? 16316168 /* BooleanStrictFacts */  : 16774920 /* BooleanFacts */ ;
            if (flags & 528 /* BooleanLike */ ) return strictNullChecks ? type === falseType || type === regularFalseType ? 12121864 /* FalseStrictFacts */  : 7927560 /* TrueStrictFacts */  : type === falseType || type === regularFalseType ? 12580616 /* FalseFacts */  : 16774920 /* TrueFacts */ ;
            if (flags & 524288 /* Object */ ) {
                const possibleFacts = strictNullChecks ? 83427327 /* ObjectStrictFacts */  : 83886079 /* ObjectFacts */ ;
                if ((callerOnlyNeeds & possibleFacts) === 0) return 0;
                return getObjectFlags(type) & 16 /* Anonymous */  && isEmptyObjectType(type) ? strictNullChecks ? 83427327 /* EmptyObjectStrictFacts */  : 83886079 /* EmptyObjectFacts */  : isFunctionObjectType(type) ? strictNullChecks ? 7880640 /* FunctionStrictFacts */  : 16728e3 /* FunctionFacts */  : strictNullChecks ? 7888800 /* ObjectStrictFacts */  : 16736160 /* ObjectFacts */ ;
            }
            if (flags & 16384 /* Void */ ) return 9830144 /* VoidFacts */ ;
            if (flags & 32768 /* Undefined */ ) return 26607360 /* UndefinedFacts */ ;
            if (flags & 65536 /* Null */ ) return 42917664 /* NullFacts */ ;
            if (flags & 12288 /* ESSymbolLike */ ) return strictNullChecks ? 7925520 /* SymbolStrictFacts */  : 16772880 /* SymbolFacts */ ;
            if (flags & 67108864 /* NonPrimitive */ ) return strictNullChecks ? 7888800 /* ObjectStrictFacts */  : 16736160 /* ObjectFacts */ ;
            if (flags & 131072 /* Never */ ) return 0 /* None */ ;
            if (flags & 1048576 /* Union */ ) return reduceLeft(type.types, (facts, t)=>facts | getTypeFactsWorker(t, callerOnlyNeeds), 0 /* None */ );
            if (flags & 2097152 /* Intersection */ ) return getIntersectionTypeFacts(type, callerOnlyNeeds);
            return 83886079 /* UnknownFacts */ ;
        }
        function getIntersectionTypeFacts(type, callerOnlyNeeds) {
            const ignoreObjects = maybeTypeOfKind(type, 402784252 /* Primitive */ );
            let oredFacts = 0 /* None */ ;
            let andedFacts = 134217727 /* All */ ;
            for (const t of type.types)if (!(ignoreObjects && t.flags & 524288 /* Object */ )) {
                const f = getTypeFactsWorker(t, callerOnlyNeeds);
                oredFacts |= f;
                andedFacts &= f;
            }
            return oredFacts & 8256 /* OrFactsMask */  | andedFacts & 134209471 /* AndFactsMask */ ;
        }
        function getTypeWithFacts(type, include) {
            return filterType(type, (t)=>hasTypeFacts(t, include));
        }
        function getAdjustedTypeWithFacts(type, facts) {
            const reduced = recombineUnknownType(getTypeWithFacts(strictNullChecks && type.flags & 2 /* Unknown */  ? unknownUnionType : type, facts));
            if (strictNullChecks) switch(facts){
                case 524288 /* NEUndefined */ :
                    return removeNullableByIntersection(reduced, 65536 /* EQUndefined */ , 131072 /* EQNull */ , 33554432 /* IsNull */ , nullType);
                case 1048576 /* NENull */ :
                    return removeNullableByIntersection(reduced, 131072 /* EQNull */ , 65536 /* EQUndefined */ , 16777216 /* IsUndefined */ , undefinedType);
                case 2097152 /* NEUndefinedOrNull */ :
                case 4194304 /* Truthy */ :
                    return mapType(reduced, (t)=>hasTypeFacts(t, 262144 /* EQUndefinedOrNull */ ) ? getGlobalNonNullableTypeInstantiation(t) : t);
            }
            return reduced;
        }
        function removeNullableByIntersection(type, targetFacts, otherFacts, otherIncludesFacts, otherType) {
            const facts = getTypeFacts(type, 50528256 /* IsNull */ );
            if (!(facts & targetFacts)) return type;
            const emptyAndOtherUnion = getUnionType([
                emptyObjectType,
                otherType
            ]);
            return mapType(type, (t)=>hasTypeFacts(t, targetFacts) ? getIntersectionType([
                    t,
                    !(facts & otherIncludesFacts) && hasTypeFacts(t, otherFacts) ? emptyAndOtherUnion : emptyObjectType
                ]) : t);
        }
        function recombineUnknownType(type) {
            return type === unknownUnionType ? unknownType : type;
        }
        function getTypeWithDefault(type, defaultExpression) {
            return defaultExpression ? getUnionType([
                getNonUndefinedType(type),
                getTypeOfExpression(defaultExpression)
            ]) : type;
        }
        function getTypeOfDestructuredProperty(type, name) {
            var _a;
            const nameType = getLiteralTypeFromPropertyName(name);
            if (!isTypeUsableAsPropertyName(nameType)) return errorType;
            const text = getPropertyNameFromType(nameType);
            return getTypeOfPropertyOfType(type, text) || includeUndefinedInIndexSignature((_a = getApplicableIndexInfoForName(type, text)) == null ? void 0 : _a.type) || errorType;
        }
        function getTypeOfDestructuredArrayElement(type, index) {
            return everyType(type, isTupleLikeType) && getTupleElementType(type, index) || includeUndefinedInIndexSignature(checkIteratedTypeOrElementType(65 /* Destructuring */ , type, undefinedType, /*errorNode*/ void 0)) || errorType;
        }
        function includeUndefinedInIndexSignature(type) {
            if (!type) return type;
            return compilerOptions.noUncheckedIndexedAccess ? getUnionType([
                type,
                missingType
            ]) : type;
        }
        function getTypeOfDestructuredSpreadExpression(type) {
            return createArrayType(checkIteratedTypeOrElementType(65 /* Destructuring */ , type, undefinedType, /*errorNode*/ void 0) || errorType);
        }
        function getAssignedTypeOfBinaryExpression(node) {
            const isDestructuringDefaultAssignment = node.parent.kind === 210 /* ArrayLiteralExpression */  && isDestructuringAssignmentTarget(node.parent) || node.parent.kind === 304 /* PropertyAssignment */  && isDestructuringAssignmentTarget(node.parent.parent);
            return isDestructuringDefaultAssignment ? getTypeWithDefault(getAssignedType(node), node.right) : getTypeOfExpression(node.right);
        }
        function isDestructuringAssignmentTarget(parent2) {
            return parent2.parent.kind === 227 /* BinaryExpression */  && parent2.parent.left === parent2 || parent2.parent.kind === 251 /* ForOfStatement */  && parent2.parent.initializer === parent2;
        }
        function getAssignedTypeOfArrayLiteralElement(node, element) {
            return getTypeOfDestructuredArrayElement(getAssignedType(node), node.elements.indexOf(element));
        }
        function getAssignedTypeOfSpreadExpression(node) {
            return getTypeOfDestructuredSpreadExpression(getAssignedType(node.parent));
        }
        function getAssignedTypeOfPropertyAssignment(node) {
            return getTypeOfDestructuredProperty(getAssignedType(node.parent), node.name);
        }
        function getAssignedTypeOfShorthandPropertyAssignment(node) {
            return getTypeWithDefault(getAssignedTypeOfPropertyAssignment(node), node.objectAssignmentInitializer);
        }
        function getAssignedType(node) {
            const { parent: parent2 } = node;
            switch(parent2.kind){
                case 250 /* ForInStatement */ :
                    return stringType;
                case 251 /* ForOfStatement */ :
                    return checkRightHandSideOfForOf(parent2) || errorType;
                case 227 /* BinaryExpression */ :
                    return getAssignedTypeOfBinaryExpression(parent2);
                case 221 /* DeleteExpression */ :
                    return undefinedType;
                case 210 /* ArrayLiteralExpression */ :
                    return getAssignedTypeOfArrayLiteralElement(parent2, node);
                case 231 /* SpreadElement */ :
                    return getAssignedTypeOfSpreadExpression(parent2);
                case 304 /* PropertyAssignment */ :
                    return getAssignedTypeOfPropertyAssignment(parent2);
                case 305 /* ShorthandPropertyAssignment */ :
                    return getAssignedTypeOfShorthandPropertyAssignment(parent2);
            }
            return errorType;
        }
        function getInitialTypeOfBindingElement(node) {
            const pattern = node.parent;
            const parentType = getInitialType(pattern.parent);
            const type = pattern.kind === 207 /* ObjectBindingPattern */  ? getTypeOfDestructuredProperty(parentType, node.propertyName || node.name) : !node.dotDotDotToken ? getTypeOfDestructuredArrayElement(parentType, pattern.elements.indexOf(node)) : getTypeOfDestructuredSpreadExpression(parentType);
            return getTypeWithDefault(type, node.initializer);
        }
        function getTypeOfInitializer(node) {
            const links = getNodeLinks(node);
            return links.resolvedType || getTypeOfExpression(node);
        }
        function getInitialTypeOfVariableDeclaration(node) {
            if (node.initializer) return getTypeOfInitializer(node.initializer);
            if (node.parent.parent.kind === 250 /* ForInStatement */ ) return stringType;
            if (node.parent.parent.kind === 251 /* ForOfStatement */ ) return checkRightHandSideOfForOf(node.parent.parent) || errorType;
            return errorType;
        }
        function getInitialType(node) {
            return node.kind === 261 /* VariableDeclaration */  ? getInitialTypeOfVariableDeclaration(node) : getInitialTypeOfBindingElement(node);
        }
        function isEmptyArrayAssignment(node) {
            return node.kind === 261 /* VariableDeclaration */  && node.initializer && isEmptyArrayLiteral2(node.initializer) || node.kind !== 209 /* BindingElement */  && node.parent.kind === 227 /* BinaryExpression */  && isEmptyArrayLiteral2(node.parent.right);
        }
        function getReferenceCandidate(node) {
            switch(node.kind){
                case 218 /* ParenthesizedExpression */ :
                    return getReferenceCandidate(node.expression);
                case 227 /* BinaryExpression */ :
                    switch(node.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                        case 76 /* BarBarEqualsToken */ :
                        case 77 /* AmpersandAmpersandEqualsToken */ :
                        case 78 /* QuestionQuestionEqualsToken */ :
                            return getReferenceCandidate(node.left);
                        case 28 /* CommaToken */ :
                            return getReferenceCandidate(node.right);
                    }
            }
            return node;
        }
        function getReferenceRoot(node) {
            const { parent: parent2 } = node;
            return parent2.kind === 218 /* ParenthesizedExpression */  || parent2.kind === 227 /* BinaryExpression */  && parent2.operatorToken.kind === 64 /* EqualsToken */  && parent2.left === node || parent2.kind === 227 /* BinaryExpression */  && parent2.operatorToken.kind === 28 /* CommaToken */  && parent2.right === node ? getReferenceRoot(parent2) : node;
        }
        function getTypeOfSwitchClause(clause) {
            if (clause.kind === 297 /* CaseClause */ ) return getRegularTypeOfLiteralType(getTypeOfExpression(clause.expression));
            return neverType;
        }
        function getSwitchClauseTypes(switchStatement) {
            const links = getNodeLinks(switchStatement);
            if (!links.switchTypes) {
                links.switchTypes = [];
                for (const clause of switchStatement.caseBlock.clauses)links.switchTypes.push(getTypeOfSwitchClause(clause));
            }
            return links.switchTypes;
        }
        function getSwitchClauseTypeOfWitnesses(switchStatement) {
            if (some(switchStatement.caseBlock.clauses, (clause)=>clause.kind === 297 /* CaseClause */  && !isStringLiteralLike(clause.expression))) return void 0;
            const witnesses = [];
            for (const clause of switchStatement.caseBlock.clauses){
                const text = clause.kind === 297 /* CaseClause */  ? clause.expression.text : void 0;
                witnesses.push(text && !contains(witnesses, text) ? text : void 0);
            }
            return witnesses;
        }
        function eachTypeContainedIn(source, types) {
            return source.flags & 1048576 /* Union */  ? !forEach(source.types, (t)=>!contains(types, t)) : contains(types, source);
        }
        function isTypeSubsetOf(source, target) {
            return !!(source === target || source.flags & 131072 /* Never */  || target.flags & 1048576 /* Union */  && isTypeSubsetOfUnion(source, target));
        }
        function isTypeSubsetOfUnion(source, target) {
            if (source.flags & 1048576 /* Union */ ) {
                for (const t of source.types){
                    if (!containsType(target.types, t)) return false;
                }
                return true;
            }
            if (source.flags & 1056 /* EnumLike */  && getBaseTypeOfEnumLikeType(source) === target) return true;
            return containsType(target.types, source);
        }
        function forEachType(type, f) {
            return type.flags & 1048576 /* Union */  ? forEach(type.types, f) : f(type);
        }
        function someType(type, f) {
            return type.flags & 1048576 /* Union */  ? some(type.types, f) : f(type);
        }
        function everyType(type, f) {
            return type.flags & 1048576 /* Union */  ? every(type.types, f) : f(type);
        }
        function everyContainedType(type, f) {
            return type.flags & 3145728 /* UnionOrIntersection */  ? every(type.types, f) : f(type);
        }
        function filterType(type, f) {
            if (type.flags & 1048576 /* Union */ ) {
                const types = type.types;
                const filtered = filter(types, f);
                if (filtered === types) return type;
                const origin = type.origin;
                let newOrigin;
                if (origin && origin.flags & 1048576 /* Union */ ) {
                    const originTypes = origin.types;
                    const originFiltered = filter(originTypes, (t)=>!!(t.flags & 1048576 /* Union */ ) || f(t));
                    if (originTypes.length - originFiltered.length === types.length - filtered.length) {
                        if (originFiltered.length === 1) return originFiltered[0];
                        newOrigin = createOriginUnionOrIntersectionType(1048576 /* Union */ , originFiltered);
                    }
                }
                return getUnionTypeFromSortedList(filtered, type.objectFlags & 16809984 /* ContainsIntersections */ , /*aliasSymbol*/ void 0, /*aliasTypeArguments*/ void 0, newOrigin);
            }
            return type.flags & 131072 /* Never */  || f(type) ? type : neverType;
        }
        function removeType(type, targetType) {
            return filterType(type, (t)=>t !== targetType);
        }
        function countTypes(type) {
            return type.flags & 1048576 /* Union */  ? type.types.length : 1;
        }
        function mapType(type, mapper, noReductions) {
            if (type.flags & 131072 /* Never */ ) return type;
            if (!(type.flags & 1048576 /* Union */ )) return mapper(type);
            const origin = type.origin;
            const types = origin && origin.flags & 1048576 /* Union */  ? origin.types : type.types;
            let mappedTypes;
            let changed = false;
            for (const t of types){
                const mapped = t.flags & 1048576 /* Union */  ? mapType(t, mapper, noReductions) : mapper(t);
                changed || (changed = t !== mapped);
                if (mapped) {
                    if (!mappedTypes) mappedTypes = [
                        mapped
                    ];
                    else mappedTypes.push(mapped);
                }
            }
            return changed ? mappedTypes && getUnionType(mappedTypes, noReductions ? 0 /* None */  : 1 /* Literal */ ) : type;
        }
        function mapTypeWithAlias(type, mapper, aliasSymbol, aliasTypeArguments) {
            return type.flags & 1048576 /* Union */  && aliasSymbol ? getUnionType(map(type.types, mapper), 1 /* Literal */ , aliasSymbol, aliasTypeArguments) : mapType(type, mapper);
        }
        function extractTypesOfKind(type, kind) {
            return filterType(type, (t)=>(t.flags & kind) !== 0);
        }
        function replacePrimitivesWithLiterals(typeWithPrimitives, typeWithLiterals) {
            if (maybeTypeOfKind(typeWithPrimitives, 134217804 /* BigInt */ ) && maybeTypeOfKind(typeWithLiterals, 402655616 /* BigIntLiteral */ )) return mapType(typeWithPrimitives, (t)=>t.flags & 4 /* String */  ? extractTypesOfKind(typeWithLiterals, 402653316 /* StringMapping */ ) : isPatternLiteralType(t) && !maybeTypeOfKind(typeWithLiterals, 402653188 /* StringMapping */ ) ? extractTypesOfKind(typeWithLiterals, 128 /* StringLiteral */ ) : t.flags & 8 /* Number */  ? extractTypesOfKind(typeWithLiterals, 264 /* NumberLiteral */ ) : t.flags & 64 /* BigInt */  ? extractTypesOfKind(typeWithLiterals, 2112 /* BigIntLiteral */ ) : t);
            return typeWithPrimitives;
        }
        function isIncomplete(flowType) {
            return flowType.flags === 0;
        }
        function getTypeFromFlowType(flowType) {
            return flowType.flags === 0 ? flowType.type : flowType;
        }
        function createFlowType(type, incomplete) {
            return incomplete ? {
                flags: 0,
                type: type.flags & 131072 /* Never */  ? silentNeverType : type
            } : type;
        }
        function createEvolvingArrayType(elementType) {
            const result = createObjectType(256 /* EvolvingArray */ );
            result.elementType = elementType;
            return result;
        }
        function getEvolvingArrayType(elementType) {
            return evolvingArrayTypes[elementType.id] || (evolvingArrayTypes[elementType.id] = createEvolvingArrayType(elementType));
        }
        function addEvolvingArrayElementType(evolvingArrayType, node) {
            const elementType = getRegularTypeOfObjectLiteral(getBaseTypeOfLiteralType(getContextFreeTypeOfExpression(node)));
            return isTypeSubsetOf(elementType, evolvingArrayType.elementType) ? evolvingArrayType : getEvolvingArrayType(getUnionType([
                evolvingArrayType.elementType,
                elementType
            ]));
        }
        function createFinalArrayType(elementType) {
            return elementType.flags & 131072 /* Never */  ? autoArrayType : createArrayType(elementType.flags & 1048576 /* Union */  ? getUnionType(elementType.types, 2 /* Subtype */ ) : elementType);
        }
        function getFinalArrayType(evolvingArrayType) {
            return evolvingArrayType.finalArrayType || (evolvingArrayType.finalArrayType = createFinalArrayType(evolvingArrayType.elementType));
        }
        function finalizeEvolvingArrayType(type) {
            return getObjectFlags(type) & 256 /* EvolvingArray */  ? getFinalArrayType(type) : type;
        }
        function getElementTypeOfEvolvingArrayType(type) {
            return getObjectFlags(type) & 256 /* EvolvingArray */  ? type.elementType : neverType;
        }
        function isEvolvingArrayTypeList(types) {
            let hasEvolvingArrayType = false;
            for (const t of types)if (!(t.flags & 131072 /* Never */ )) {
                if (!(getObjectFlags(t) & 256 /* EvolvingArray */ )) return false;
                hasEvolvingArrayType = true;
            }
            return hasEvolvingArrayType;
        }
        function isEvolvingArrayOperationTarget(node) {
            const root = getReferenceRoot(node);
            const parent2 = root.parent;
            const isLengthPushOrUnshift = isPropertyAccessExpression(parent2) && (parent2.name.escapedText === "length" || parent2.parent.kind === 214 /* CallExpression */  && isIdentifier(parent2.name) && isPushOrUnshiftIdentifier(parent2.name));
            const isElementAssignment = parent2.kind === 213 /* ElementAccessExpression */  && parent2.expression === root && parent2.parent.kind === 227 /* BinaryExpression */  && parent2.parent.operatorToken.kind === 64 /* EqualsToken */  && parent2.parent.left === parent2 && !isAssignmentTarget(parent2.parent) && isTypeAssignableToKind(getTypeOfExpression(parent2.argumentExpression), 296 /* NumberLike */ );
            return isLengthPushOrUnshift || isElementAssignment;
        }
        function isDeclarationWithExplicitTypeAnnotation(node) {
            return (isVariableDeclaration(node) || isPropertyDeclaration(node) || isPropertySignature(node) || isParameter(node)) && !!(getEffectiveTypeAnnotationNode(node) || isInJSFile(node) && hasInitializer(node) && node.initializer && isFunctionExpressionOrArrowFunction(node.initializer) && getEffectiveReturnTypeNode(node.initializer));
        }
        function getExplicitTypeOfSymbol(symbol, diagnostic) {
            symbol = resolveSymbol(symbol);
            if (symbol.flags & 8752 /* ValueModule */ ) return getTypeOfSymbol(symbol);
            if (symbol.flags & 7 /* Property */ ) {
                if (getCheckFlags(symbol) & 262144 /* Mapped */ ) {
                    const origin = symbol.links.syntheticOrigin;
                    if (origin && getExplicitTypeOfSymbol(origin)) return getTypeOfSymbol(symbol);
                }
                const declaration = symbol.valueDeclaration;
                if (declaration) {
                    if (isDeclarationWithExplicitTypeAnnotation(declaration)) return getTypeOfSymbol(symbol);
                    if (isVariableDeclaration(declaration) && declaration.parent.parent.kind === 251 /* ForOfStatement */ ) {
                        const statement = declaration.parent.parent;
                        const expressionType = getTypeOfDottedName(statement.expression, /*diagnostic*/ void 0);
                        if (expressionType) {
                            const use = statement.awaitModifier ? 15 /* ForAwaitOf */  : 13 /* ForOf */ ;
                            return checkIteratedTypeOrElementType(use, expressionType, undefinedType, /*errorNode*/ void 0);
                        }
                    }
                    if (diagnostic) addRelatedInfo(diagnostic, createDiagnosticForNode(declaration, Diagnostics._0_needs_an_explicit_type_annotation, symbolToString(symbol)));
                }
            }
        }
        function getTypeOfDottedName(node, diagnostic) {
            if (!(node.flags & 67108864 /* InWithStatement */ )) switch(node.kind){
                case 80 /* Identifier */ :
                    const symbol = getExportSymbolOfValueSymbolIfExported(getResolvedSymbol(node));
                    return getExplicitTypeOfSymbol(symbol, diagnostic);
                case 110 /* ThisKeyword */ :
                    return getExplicitThisType(node);
                case 108 /* SuperKeyword */ :
                    return checkSuperExpression(node);
                case 212 /* PropertyAccessExpression */ :
                    {
                        const type = getTypeOfDottedName(node.expression, diagnostic);
                        if (type) {
                            const name = node.name;
                            let prop;
                            if (isPrivateIdentifier(name)) {
                                if (!type.symbol) return void 0;
                                prop = getPropertyOfType(type, getSymbolNameForPrivateIdentifier(type.symbol, name.escapedText));
                            } else prop = getPropertyOfType(type, name.escapedText);
                            return prop && getExplicitTypeOfSymbol(prop, diagnostic);
                        }
                        return void 0;
                    }
                case 218 /* ParenthesizedExpression */ :
                    return getTypeOfDottedName(node.expression, diagnostic);
            }
        }
        function getEffectsSignature(node) {
            const links = getNodeLinks(node);
            let signature = links.effectsSignature;
            if (signature === void 0) {
                let funcType;
                if (isBinaryExpression(node)) {
                    const rightType = checkNonNullExpression(node.right);
                    funcType = getSymbolHasInstanceMethodOfObjectType(rightType);
                } else if (node.parent.kind === 245 /* ExpressionStatement */ ) funcType = getTypeOfDottedName(node.expression, /*diagnostic*/ void 0);
                else if (node.expression.kind !== 108 /* SuperKeyword */ ) {
                    if (isOptionalChain(node)) funcType = checkNonNullType(getOptionalExpressionType(checkExpression(node.expression), node.expression), node.expression);
                    else funcType = checkNonNullExpression(node.expression);
                }
                const signatures = getSignaturesOfType(funcType && getApparentType(funcType) || unknownType, 0 /* Call */ );
                const candidate = signatures.length === 1 && !signatures[0].typeParameters ? signatures[0] : some(signatures, hasTypePredicateOrNeverReturnType) ? getResolvedSignature(node) : void 0;
                signature = links.effectsSignature = candidate && hasTypePredicateOrNeverReturnType(candidate) ? candidate : unknownSignature;
            }
            return signature === unknownSignature ? void 0 : signature;
        }
        function hasTypePredicateOrNeverReturnType(signature) {
            return !!(getTypePredicateOfSignature(signature) || signature.declaration && (getReturnTypeFromAnnotation(signature.declaration) || unknownType).flags & 131072 /* Never */ );
        }
        function getTypePredicateArgument(predicate, callExpression) {
            if (predicate.kind === 1 /* Identifier */  || predicate.kind === 3 /* AssertsIdentifier */ ) return callExpression.arguments[predicate.parameterIndex];
            const invokedExpression = skipParentheses(callExpression.expression);
            return isAccessExpression(invokedExpression) ? skipParentheses(invokedExpression.expression) : void 0;
        }
        function reportFlowControlError(node) {
            const block = findAncestor(node, isFunctionOrModuleBlock);
            const sourceFile = getSourceFileOfNode(node);
            const span = getSpanOfTokenAtPosition(sourceFile, block.statements.pos);
            diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.The_containing_function_or_module_body_is_too_large_for_control_flow_analysis));
        }
        function isReachableFlowNode(flow) {
            const result = isReachableFlowNodeWorker(flow, /*noCacheCheck*/ false);
            lastFlowNode = flow;
            lastFlowNodeReachable = result;
            return result;
        }
        function isFalseExpression(expr) {
            const node = skipParentheses(expr, /*excludeJSDocTypeAssertions*/ true);
            return node.kind === 97 /* FalseKeyword */  || node.kind === 227 /* BinaryExpression */  && (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */  && (isFalseExpression(node.left) || isFalseExpression(node.right)) || node.operatorToken.kind === 57 /* BarBarToken */  && isFalseExpression(node.left) && isFalseExpression(node.right));
        }
        function isReachableFlowNodeWorker(flow, noCacheCheck) {
            while(true){
                if (flow === lastFlowNode) return lastFlowNodeReachable;
                const flags = flow.flags;
                if (flags & 4096 /* Shared */ ) {
                    if (!noCacheCheck) {
                        const id = getFlowNodeId(flow);
                        const reachable = flowNodeReachable[id];
                        return reachable !== void 0 ? reachable : flowNodeReachable[id] = isReachableFlowNodeWorker(flow, /*noCacheCheck*/ true);
                    }
                    noCacheCheck = false;
                }
                if (flags & 368 /* ArrayMutation */ ) flow = flow.antecedent;
                else if (flags & 512 /* Call */ ) {
                    const signature = getEffectsSignature(flow.node);
                    if (signature) {
                        const predicate = getTypePredicateOfSignature(signature);
                        if (predicate && predicate.kind === 3 /* AssertsIdentifier */  && !predicate.type) {
                            const predicateArgument = flow.node.arguments[predicate.parameterIndex];
                            if (predicateArgument && isFalseExpression(predicateArgument)) return false;
                        }
                        if (getReturnTypeOfSignature(signature).flags & 131072 /* Never */ ) return false;
                    }
                    flow = flow.antecedent;
                } else if (flags & 4 /* BranchLabel */ ) return some(flow.antecedent, (f)=>isReachableFlowNodeWorker(f, /*noCacheCheck*/ false));
                else if (flags & 8 /* LoopLabel */ ) {
                    const antecedents = flow.antecedent;
                    if (antecedents === void 0 || antecedents.length === 0) return false;
                    flow = antecedents[0];
                } else if (flags & 128 /* SwitchClause */ ) {
                    const data = flow.node;
                    if (data.clauseStart === data.clauseEnd && isExhaustiveSwitchStatement(data.switchStatement)) return false;
                    flow = flow.antecedent;
                } else if (flags & 1024 /* ReduceLabel */ ) {
                    lastFlowNode = void 0;
                    const target = flow.node.target;
                    const saveAntecedents = target.antecedent;
                    target.antecedent = flow.node.antecedents;
                    const result = isReachableFlowNodeWorker(flow.antecedent, /*noCacheCheck*/ false);
                    target.antecedent = saveAntecedents;
                    return result;
                } else return !(flags & 1 /* Unreachable */ );
            }
        }
        function isPostSuperFlowNode(flow, noCacheCheck) {
            while(true){
                const flags = flow.flags;
                if (flags & 4096 /* Shared */ ) {
                    if (!noCacheCheck) {
                        const id = getFlowNodeId(flow);
                        const postSuper = flowNodePostSuper[id];
                        return postSuper !== void 0 ? postSuper : flowNodePostSuper[id] = isPostSuperFlowNode(flow, /*noCacheCheck*/ true);
                    }
                    noCacheCheck = false;
                }
                if (flags & 496 /* SwitchClause */ ) flow = flow.antecedent;
                else if (flags & 512 /* Call */ ) {
                    if (flow.node.expression.kind === 108 /* SuperKeyword */ ) return true;
                    flow = flow.antecedent;
                } else if (flags & 4 /* BranchLabel */ ) return every(flow.antecedent, (f)=>isPostSuperFlowNode(f, /*noCacheCheck*/ false));
                else if (flags & 8 /* LoopLabel */ ) flow = flow.antecedent[0];
                else if (flags & 1024 /* ReduceLabel */ ) {
                    const target = flow.node.target;
                    const saveAntecedents = target.antecedent;
                    target.antecedent = flow.node.antecedents;
                    const result = isPostSuperFlowNode(flow.antecedent, /*noCacheCheck*/ false);
                    target.antecedent = saveAntecedents;
                    return result;
                } else return !!(flags & 1 /* Unreachable */ );
            }
        }
        function isConstantReference(node) {
            switch(node.kind){
                case 110 /* ThisKeyword */ :
                    return true;
                case 80 /* Identifier */ :
                    if (!isThisInTypeQuery(node)) {
                        const symbol = getResolvedSymbol(node);
                        return isConstantVariable(symbol) || isParameterOrMutableLocalVariable(symbol) && !isSymbolAssigned(symbol) || !!symbol.valueDeclaration && isFunctionExpression(symbol.valueDeclaration);
                    }
                    break;
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    return isConstantReference(node.expression) && isReadonlySymbol(getNodeLinks(node).resolvedSymbol || unknownSymbol);
                case 207 /* ObjectBindingPattern */ :
                case 208 /* ArrayBindingPattern */ :
                    const rootDeclaration = getRootDeclaration(node.parent);
                    return isParameter(rootDeclaration) || isCatchClauseVariableDeclaration(rootDeclaration) ? !isSomeSymbolAssigned(rootDeclaration) : isVariableDeclaration(rootDeclaration) && isVarConstLike2(rootDeclaration);
            }
            return false;
        }
        function getFlowTypeOfReference(reference, declaredType, initialType = declaredType, flowContainer, flowNode = ((_a)=>(_a = tryCast(reference, canHaveFlowNode)) == null ? void 0 : _a.flowNode)()) {
            let key;
            let isKeySet = false;
            let flowDepth = 0;
            if (flowAnalysisDisabled) return errorType;
            if (!flowNode) return declaredType;
            flowInvocationCount++;
            const sharedFlowStart = sharedFlowCount;
            const evolvedType = getTypeFromFlowType(getTypeAtFlowNode(flowNode));
            sharedFlowCount = sharedFlowStart;
            const resultType = getObjectFlags(evolvedType) & 256 /* EvolvingArray */  && isEvolvingArrayOperationTarget(reference) ? autoArrayType : finalizeEvolvingArrayType(evolvedType);
            if (resultType === unreachableNeverType || reference.parent && reference.parent.kind === 236 /* NonNullExpression */  && !(resultType.flags & 131072 /* Never */ ) && getTypeWithFacts(resultType, 2097152 /* NEUndefinedOrNull */ ).flags & 131072 /* Never */ ) return declaredType;
            return resultType;
            function getOrSetCacheKey() {
                if (isKeySet) return key;
                isKeySet = true;
                return key = getFlowCacheKey(reference, declaredType, initialType, flowContainer);
            }
            function getTypeAtFlowNode(flow) {
                var _a2;
                if (flowDepth === 2e3) {
                    (_a2 = tracing) == null || _a2.instant(tracing.Phase.CheckTypes, "getTypeAtFlowNode_DepthLimit", {
                        flowId: flow.id
                    });
                    flowAnalysisDisabled = true;
                    reportFlowControlError(reference);
                    return errorType;
                }
                flowDepth++;
                let sharedFlow;
                while(true){
                    const flags = flow.flags;
                    if (flags & 4096 /* Shared */ ) {
                        for(let i = sharedFlowStart; i < sharedFlowCount; i++)if (sharedFlowNodes[i] === flow) {
                            flowDepth--;
                            return sharedFlowTypes[i];
                        }
                        sharedFlow = flow;
                    }
                    let type;
                    if (flags & 16 /* Assignment */ ) {
                        type = getTypeAtFlowAssignment(flow);
                        if (!type) {
                            flow = flow.antecedent;
                            continue;
                        }
                    } else if (flags & 512 /* Call */ ) {
                        type = getTypeAtFlowCall(flow);
                        if (!type) {
                            flow = flow.antecedent;
                            continue;
                        }
                    } else if (flags & 96 /* Condition */ ) type = getTypeAtFlowCondition(flow);
                    else if (flags & 128 /* SwitchClause */ ) type = getTypeAtSwitchClause(flow);
                    else if (flags & 12 /* Label */ ) {
                        if (flow.antecedent.length === 1) {
                            flow = flow.antecedent[0];
                            continue;
                        }
                        type = flags & 4 /* BranchLabel */  ? getTypeAtFlowBranchLabel(flow) : getTypeAtFlowLoopLabel(flow);
                    } else if (flags & 256 /* ArrayMutation */ ) {
                        type = getTypeAtFlowArrayMutation(flow);
                        if (!type) {
                            flow = flow.antecedent;
                            continue;
                        }
                    } else if (flags & 1024 /* ReduceLabel */ ) {
                        const target = flow.node.target;
                        const saveAntecedents = target.antecedent;
                        target.antecedent = flow.node.antecedents;
                        type = getTypeAtFlowNode(flow.antecedent);
                        target.antecedent = saveAntecedents;
                    } else if (flags & 2 /* Start */ ) {
                        const container = flow.node;
                        if (container && container !== flowContainer && reference.kind !== 212 /* PropertyAccessExpression */  && reference.kind !== 213 /* ElementAccessExpression */  && !(reference.kind === 110 /* ThisKeyword */  && container.kind !== 220 /* ArrowFunction */ )) {
                            flow = container.flowNode;
                            continue;
                        }
                        type = initialType;
                    } else type = convertAutoToAny(declaredType);
                    if (sharedFlow) {
                        sharedFlowNodes[sharedFlowCount] = sharedFlow;
                        sharedFlowTypes[sharedFlowCount] = type;
                        sharedFlowCount++;
                    }
                    flowDepth--;
                    return type;
                }
            }
            function getInitialOrAssignedType(flow) {
                const node = flow.node;
                return getNarrowableTypeForReference(node.kind === 261 /* VariableDeclaration */  || node.kind === 209 /* BindingElement */  ? getInitialType(node) : getAssignedType(node), reference);
            }
            function getTypeAtFlowAssignment(flow) {
                const node = flow.node;
                if (isMatchingReference(reference, node)) {
                    if (!isReachableFlowNode(flow)) return unreachableNeverType;
                    if (getAssignmentTargetKind(node) === 2 /* Compound */ ) {
                        const flowType = getTypeAtFlowNode(flow.antecedent);
                        return createFlowType(getBaseTypeOfLiteralType(getTypeFromFlowType(flowType)), isIncomplete(flowType));
                    }
                    if (declaredType === autoType || declaredType === autoArrayType) {
                        if (isEmptyArrayAssignment(node)) return getEvolvingArrayType(neverType);
                        const assignedType = getWidenedLiteralType(getInitialOrAssignedType(flow));
                        return isTypeAssignableTo(assignedType, declaredType) ? assignedType : anyArrayType;
                    }
                    const t = isInCompoundLikeAssignment(node) ? getBaseTypeOfLiteralType(declaredType) : declaredType;
                    if (t.flags & 1048576 /* Union */ ) return getAssignmentReducedType(t, getInitialOrAssignedType(flow));
                    return t;
                }
                if (containsMatchingReference(reference, node)) {
                    if (!isReachableFlowNode(flow)) return unreachableNeverType;
                    if (isVariableDeclaration(node) && (isInJSFile(node) || isVarConstLike2(node))) {
                        const init = getDeclaredExpandoInitializer(node);
                        if (init && (init.kind === 219 /* FunctionExpression */  || init.kind === 220 /* ArrowFunction */ )) return getTypeAtFlowNode(flow.antecedent);
                    }
                    return declaredType;
                }
                if (isVariableDeclaration(node) && node.parent.parent.kind === 250 /* ForInStatement */  && (isMatchingReference(reference, node.parent.parent.expression) || optionalChainContainsReference(node.parent.parent.expression, reference))) return getNonNullableTypeIfNeeded(finalizeEvolvingArrayType(getTypeFromFlowType(getTypeAtFlowNode(flow.antecedent))));
                return void 0;
            }
            function narrowTypeByAssertion(type, expr) {
                const node = skipParentheses(expr, /*excludeJSDocTypeAssertions*/ true);
                if (node.kind === 97 /* FalseKeyword */ ) return unreachableNeverType;
                if (node.kind === 227 /* BinaryExpression */ ) {
                    if (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ) return narrowTypeByAssertion(narrowTypeByAssertion(type, node.left), node.right);
                    if (node.operatorToken.kind === 57 /* BarBarToken */ ) return getUnionType([
                        narrowTypeByAssertion(type, node.left),
                        narrowTypeByAssertion(type, node.right)
                    ]);
                }
                return narrowType(type, node, /*assumeTrue*/ true);
            }
            function getTypeAtFlowCall(flow) {
                const signature = getEffectsSignature(flow.node);
                if (signature) {
                    const predicate = getTypePredicateOfSignature(signature);
                    if (predicate && (predicate.kind === 2 /* AssertsThis */  || predicate.kind === 3 /* AssertsIdentifier */ )) {
                        const flowType = getTypeAtFlowNode(flow.antecedent);
                        const type = finalizeEvolvingArrayType(getTypeFromFlowType(flowType));
                        const narrowedType = predicate.type ? narrowTypeByTypePredicate(type, predicate, flow.node, /*assumeTrue*/ true) : predicate.kind === 3 /* AssertsIdentifier */  && predicate.parameterIndex >= 0 && predicate.parameterIndex < flow.node.arguments.length ? narrowTypeByAssertion(type, flow.node.arguments[predicate.parameterIndex]) : type;
                        return narrowedType === type ? flowType : createFlowType(narrowedType, isIncomplete(flowType));
                    }
                    if (getReturnTypeOfSignature(signature).flags & 131072 /* Never */ ) return unreachableNeverType;
                }
                return void 0;
            }
            function getTypeAtFlowArrayMutation(flow) {
                if (declaredType === autoType || declaredType === autoArrayType) {
                    const node = flow.node;
                    const expr = node.kind === 214 /* CallExpression */  ? node.expression.expression : node.left.expression;
                    if (isMatchingReference(reference, getReferenceCandidate(expr))) {
                        const flowType = getTypeAtFlowNode(flow.antecedent);
                        const type = getTypeFromFlowType(flowType);
                        if (getObjectFlags(type) & 256 /* EvolvingArray */ ) {
                            let evolvedType2 = type;
                            if (node.kind === 214 /* CallExpression */ ) for (const arg of node.arguments)evolvedType2 = addEvolvingArrayElementType(evolvedType2, arg);
                            else {
                                const indexType = getContextFreeTypeOfExpression(node.left.argumentExpression);
                                if (isTypeAssignableToKind(indexType, 296 /* NumberLike */ )) evolvedType2 = addEvolvingArrayElementType(evolvedType2, node.right);
                            }
                            return evolvedType2 === type ? flowType : createFlowType(evolvedType2, isIncomplete(flowType));
                        }
                        return flowType;
                    }
                }
                return void 0;
            }
            function getTypeAtFlowCondition(flow) {
                const flowType = getTypeAtFlowNode(flow.antecedent);
                const type = getTypeFromFlowType(flowType);
                if (type.flags & 131072 /* Never */ ) return flowType;
                const assumeTrue = (flow.flags & 32 /* TrueCondition */ ) !== 0;
                const nonEvolvingType = finalizeEvolvingArrayType(type);
                const narrowedType = narrowType(nonEvolvingType, flow.node, assumeTrue);
                if (narrowedType === nonEvolvingType) return flowType;
                return createFlowType(narrowedType, isIncomplete(flowType));
            }
            function getTypeAtSwitchClause(flow) {
                const expr = skipParentheses(flow.node.switchStatement.expression);
                const flowType = getTypeAtFlowNode(flow.antecedent);
                let type = getTypeFromFlowType(flowType);
                if (isMatchingReference(reference, expr)) type = narrowTypeBySwitchOnDiscriminant(type, flow.node);
                else if (expr.kind === 222 /* TypeOfExpression */  && isMatchingReference(reference, expr.expression)) type = narrowTypeBySwitchOnTypeOf(type, flow.node);
                else if (expr.kind === 112 /* TrueKeyword */ ) type = narrowTypeBySwitchOnTrue(type, flow.node);
                else {
                    if (strictNullChecks) {
                        if (optionalChainContainsReference(expr, reference)) type = narrowTypeBySwitchOptionalChainContainment(type, flow.node, (t)=>!(t.flags & 163840 /* Never */ ));
                        else if (expr.kind === 222 /* TypeOfExpression */  && optionalChainContainsReference(expr.expression, reference)) type = narrowTypeBySwitchOptionalChainContainment(type, flow.node, (t)=>!(t.flags & 131072 /* Never */  || t.flags & 128 /* StringLiteral */  && t.value === "undefined"));
                    }
                    const access = getDiscriminantPropertyAccess(expr, type);
                    if (access) type = narrowTypeBySwitchOnDiscriminantProperty(type, access, flow.node);
                }
                return createFlowType(type, isIncomplete(flowType));
            }
            function getTypeAtFlowBranchLabel(flow) {
                const antecedentTypes = [];
                let subtypeReduction = false;
                let seenIncomplete = false;
                let bypassFlow;
                for (const antecedent of flow.antecedent){
                    if (!bypassFlow && antecedent.flags & 128 /* SwitchClause */  && antecedent.node.clauseStart === antecedent.node.clauseEnd) {
                        bypassFlow = antecedent;
                        continue;
                    }
                    const flowType = getTypeAtFlowNode(antecedent);
                    const type = getTypeFromFlowType(flowType);
                    if (type === declaredType && declaredType === initialType) return type;
                    pushIfUnique(antecedentTypes, type);
                    if (!isTypeSubsetOf(type, initialType)) subtypeReduction = true;
                    if (isIncomplete(flowType)) seenIncomplete = true;
                }
                if (bypassFlow) {
                    const flowType = getTypeAtFlowNode(bypassFlow);
                    const type = getTypeFromFlowType(flowType);
                    if (!(type.flags & 131072 /* Never */ ) && !contains(antecedentTypes, type) && !isExhaustiveSwitchStatement(bypassFlow.node.switchStatement)) {
                        if (type === declaredType && declaredType === initialType) return type;
                        antecedentTypes.push(type);
                        if (!isTypeSubsetOf(type, initialType)) subtypeReduction = true;
                        if (isIncomplete(flowType)) seenIncomplete = true;
                    }
                }
                return createFlowType(getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */  : 1 /* Literal */ ), seenIncomplete);
            }
            function getTypeAtFlowLoopLabel(flow) {
                const id = getFlowNodeId(flow);
                const cache = flowLoopCaches[id] || (flowLoopCaches[id] = /* @__PURE__ */ new Map());
                const key2 = getOrSetCacheKey();
                if (!key2) return declaredType;
                const cached = cache.get(key2);
                if (cached) return cached;
                for(let i = flowLoopStart; i < flowLoopCount; i++){
                    if (flowLoopNodes[i] === flow && flowLoopKeys[i] === key2 && flowLoopTypes[i].length) return createFlowType(getUnionOrEvolvingArrayType(flowLoopTypes[i], 1 /* Literal */ ), /*incomplete*/ true);
                }
                const antecedentTypes = [];
                let subtypeReduction = false;
                let firstAntecedentType;
                for (const antecedent of flow.antecedent){
                    let flowType;
                    if (!firstAntecedentType) flowType = firstAntecedentType = getTypeAtFlowNode(antecedent);
                    else {
                        flowLoopNodes[flowLoopCount] = flow;
                        flowLoopKeys[flowLoopCount] = key2;
                        flowLoopTypes[flowLoopCount] = antecedentTypes;
                        flowLoopCount++;
                        const saveFlowTypeCache = flowTypeCache;
                        flowTypeCache = void 0;
                        flowType = getTypeAtFlowNode(antecedent);
                        flowTypeCache = saveFlowTypeCache;
                        flowLoopCount--;
                        const cached2 = cache.get(key2);
                        if (cached2) return cached2;
                    }
                    const type = getTypeFromFlowType(flowType);
                    pushIfUnique(antecedentTypes, type);
                    if (!isTypeSubsetOf(type, initialType)) subtypeReduction = true;
                    if (type === declaredType) break;
                }
                const result = getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */  : 1 /* Literal */ );
                if (isIncomplete(firstAntecedentType)) return createFlowType(result, /*incomplete*/ true);
                cache.set(key2, result);
                return result;
            }
            function getUnionOrEvolvingArrayType(types, subtypeReduction) {
                if (isEvolvingArrayTypeList(types)) return getEvolvingArrayType(getUnionType(map(types, getElementTypeOfEvolvingArrayType)));
                const result = recombineUnknownType(getUnionType(sameMap(types, finalizeEvolvingArrayType), subtypeReduction));
                if (result !== declaredType && result.flags & declaredType.flags & 1048576 /* Union */  && arrayIsEqualTo(result.types, declaredType.types)) return declaredType;
                return result;
            }
            function getCandidateDiscriminantPropertyAccess(expr) {
                if (isBindingPattern(reference) || isFunctionExpressionOrArrowFunction(reference) || isObjectLiteralMethod(reference)) {
                    if (isIdentifier(expr)) {
                        const symbol = getResolvedSymbol(expr);
                        const declaration = getExportSymbolOfValueSymbolIfExported(symbol).valueDeclaration;
                        if (declaration && (isBindingElement(declaration) || isParameter(declaration)) && reference === declaration.parent && !declaration.initializer && !declaration.dotDotDotToken) return declaration;
                    }
                } else if (isAccessExpression(expr)) {
                    if (isMatchingReference(reference, expr.expression)) return expr;
                } else if (isIdentifier(expr)) {
                    const symbol = getResolvedSymbol(expr);
                    if (isConstantVariable(symbol)) {
                        const declaration = symbol.valueDeclaration;
                        if (isVariableDeclaration(declaration) && !declaration.type && declaration.initializer && isAccessExpression(declaration.initializer) && isMatchingReference(reference, declaration.initializer.expression)) return declaration.initializer;
                        if (isBindingElement(declaration) && !declaration.initializer) {
                            const parent2 = declaration.parent.parent;
                            if (isVariableDeclaration(parent2) && !parent2.type && parent2.initializer && (isIdentifier(parent2.initializer) || isAccessExpression(parent2.initializer)) && isMatchingReference(reference, parent2.initializer)) return declaration;
                        }
                    }
                }
                return void 0;
            }
            function getDiscriminantPropertyAccess(expr, computedType) {
                if (declaredType.flags & 1048576 /* Union */  || computedType.flags & 1048576 /* Union */ ) {
                    const access = getCandidateDiscriminantPropertyAccess(expr);
                    if (access) {
                        const name = getAccessedPropertyName(access);
                        if (name) {
                            const type = declaredType.flags & 1048576 /* Union */  && isTypeSubsetOf(computedType, declaredType) ? declaredType : computedType;
                            if (isDiscriminantProperty(type, name)) return access;
                        }
                    }
                }
                return void 0;
            }
            function narrowTypeByDiscriminant(type, access, narrowType2) {
                const propName = getAccessedPropertyName(access);
                if (propName === void 0) return type;
                const optionalChain = isOptionalChain(access);
                const removeNullable = strictNullChecks && (optionalChain || isNonNullAccess(access)) && maybeTypeOfKind(type, 98304 /* Nullable */ );
                let propType = getTypeOfPropertyOfType(removeNullable ? getTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type, propName);
                if (!propType) return type;
                propType = removeNullable && optionalChain ? getOptionalType(propType) : propType;
                const narrowedPropType = narrowType2(propType);
                return filterType(type, (t)=>{
                    const discriminantType = getTypeOfPropertyOrIndexSignatureOfType(t, propName) || unknownType;
                    return !(discriminantType.flags & 131072 /* Never */ ) && !(narrowedPropType.flags & 131072 /* Never */ ) && areTypesComparable(narrowedPropType, discriminantType);
                });
            }
            function narrowTypeByDiscriminantProperty(type, access, operator, value1, assumeTrue) {
                if ((operator === 37 /* EqualsEqualsEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ ) && type.flags & 1048576 /* Union */ ) {
                    const keyPropertyName = getKeyPropertyName(type);
                    if (keyPropertyName && keyPropertyName === getAccessedPropertyName(access)) {
                        const candidate = getConstituentTypeForKeyType(type, getTypeOfExpression(value1));
                        if (candidate) return operator === (assumeTrue ? 37 /* EqualsEqualsEqualsToken */  : 38 /* ExclamationEqualsEqualsToken */ ) ? candidate : isUnitType(getTypeOfPropertyOfType(candidate, keyPropertyName) || unknownType) ? removeType(type, candidate) : type;
                    }
                }
                return narrowTypeByDiscriminant(type, access, (t)=>narrowTypeByEquality(t, operator, value1, assumeTrue));
            }
            function narrowTypeBySwitchOnDiscriminantProperty(type, access, data) {
                if (data.clauseStart < data.clauseEnd && type.flags & 1048576 /* Union */  && getKeyPropertyName(type) === getAccessedPropertyName(access)) {
                    const clauseTypes = getSwitchClauseTypes(data.switchStatement).slice(data.clauseStart, data.clauseEnd);
                    const candidate = getUnionType(map(clauseTypes, (t)=>getConstituentTypeForKeyType(type, t) || unknownType));
                    if (candidate !== unknownType) return candidate;
                }
                return narrowTypeByDiscriminant(type, access, (t)=>narrowTypeBySwitchOnDiscriminant(t, data));
            }
            function narrowTypeByTruthiness(type, expr, assumeTrue) {
                if (isMatchingReference(reference, expr)) return getAdjustedTypeWithFacts(type, assumeTrue ? 4194304 /* Truthy */  : 8388608 /* Falsy */ );
                if (strictNullChecks && assumeTrue && optionalChainContainsReference(expr, reference)) type = getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                const access = getDiscriminantPropertyAccess(expr, type);
                if (access) return narrowTypeByDiscriminant(type, access, (t)=>getTypeWithFacts(t, assumeTrue ? 4194304 /* Truthy */  : 8388608 /* Falsy */ ));
                return type;
            }
            function isTypePresencePossible(type, propName, assumeTrue) {
                const prop = getPropertyOfType(type, propName);
                return prop ? !!(prop.flags & 16777216 /* Optional */  || getCheckFlags(prop) & 48 /* Partial */ ) || assumeTrue : !!getApplicableIndexInfoForName(type, propName) || !assumeTrue;
            }
            function narrowTypeByInKeyword(type, nameType, assumeTrue) {
                const name = getPropertyNameFromType(nameType);
                const isKnownProperty2 = someType(type, (t)=>isTypePresencePossible(t, name, /*assumeTrue*/ true));
                if (isKnownProperty2) return filterType(type, (t)=>isTypePresencePossible(t, name, assumeTrue));
                if (assumeTrue) {
                    const recordSymbol = getGlobalRecordSymbol();
                    if (recordSymbol) return getIntersectionType([
                        type,
                        getTypeAliasInstantiation(recordSymbol, [
                            nameType,
                            unknownType
                        ])
                    ]);
                }
                return type;
            }
            function narrowTypeByBooleanComparison(type, expr, bool, operator, assumeTrue) {
                assumeTrue = assumeTrue !== (bool.kind === 112 /* TrueKeyword */ ) !== (operator !== 38 /* ExclamationEqualsEqualsToken */  && operator !== 36 /* ExclamationEqualsToken */ );
                return narrowType(type, expr, assumeTrue);
            }
            function narrowTypeByBinaryExpression(type, expr, assumeTrue) {
                switch(expr.operatorToken.kind){
                    case 64 /* EqualsToken */ :
                    case 76 /* BarBarEqualsToken */ :
                    case 77 /* AmpersandAmpersandEqualsToken */ :
                    case 78 /* QuestionQuestionEqualsToken */ :
                        return narrowTypeByTruthiness(narrowType(type, expr.right, assumeTrue), expr.left, assumeTrue);
                    case 35 /* EqualsEqualsToken */ :
                    case 36 /* ExclamationEqualsToken */ :
                    case 37 /* EqualsEqualsEqualsToken */ :
                    case 38 /* ExclamationEqualsEqualsToken */ :
                        const operator = expr.operatorToken.kind;
                        const left = getReferenceCandidate(expr.left);
                        const right = getReferenceCandidate(expr.right);
                        if (left.kind === 222 /* TypeOfExpression */  && isStringLiteralLike(right)) return narrowTypeByTypeof(type, left, operator, right, assumeTrue);
                        if (right.kind === 222 /* TypeOfExpression */  && isStringLiteralLike(left)) return narrowTypeByTypeof(type, right, operator, left, assumeTrue);
                        if (isMatchingReference(reference, left)) return narrowTypeByEquality(type, operator, right, assumeTrue);
                        if (isMatchingReference(reference, right)) return narrowTypeByEquality(type, operator, left, assumeTrue);
                        if (strictNullChecks) {
                            if (optionalChainContainsReference(left, reference)) type = narrowTypeByOptionalChainContainment(type, operator, right, assumeTrue);
                            else if (optionalChainContainsReference(right, reference)) type = narrowTypeByOptionalChainContainment(type, operator, left, assumeTrue);
                        }
                        const leftAccess = getDiscriminantPropertyAccess(left, type);
                        if (leftAccess) return narrowTypeByDiscriminantProperty(type, leftAccess, operator, right, assumeTrue);
                        const rightAccess = getDiscriminantPropertyAccess(right, type);
                        if (rightAccess) return narrowTypeByDiscriminantProperty(type, rightAccess, operator, left, assumeTrue);
                        if (isMatchingConstructorReference(left)) return narrowTypeByConstructor(type, operator, right, assumeTrue);
                        if (isMatchingConstructorReference(right)) return narrowTypeByConstructor(type, operator, left, assumeTrue);
                        if (isBooleanLiteral(right) && !isAccessExpression(left)) return narrowTypeByBooleanComparison(type, left, right, operator, assumeTrue);
                        if (isBooleanLiteral(left) && !isAccessExpression(right)) return narrowTypeByBooleanComparison(type, right, left, operator, assumeTrue);
                        break;
                    case 104 /* InstanceOfKeyword */ :
                        return narrowTypeByInstanceof(type, expr, assumeTrue);
                    case 103 /* InKeyword */ :
                        if (isPrivateIdentifier(expr.left)) return narrowTypeByPrivateIdentifierInInExpression(type, expr, assumeTrue);
                        const target = getReferenceCandidate(expr.right);
                        if (containsMissingType(type) && isAccessExpression(reference) && isMatchingReference(reference.expression, target)) {
                            const leftType = getTypeOfExpression(expr.left);
                            if (isTypeUsableAsPropertyName(leftType) && getAccessedPropertyName(reference) === getPropertyNameFromType(leftType)) return getTypeWithFacts(type, assumeTrue ? 524288 /* NEUndefined */  : 65536 /* EQUndefined */ );
                        }
                        if (isMatchingReference(reference, target)) {
                            const leftType = getTypeOfExpression(expr.left);
                            if (isTypeUsableAsPropertyName(leftType)) return narrowTypeByInKeyword(type, leftType, assumeTrue);
                        }
                        break;
                    case 28 /* CommaToken */ :
                        return narrowType(type, expr.right, assumeTrue);
                    // Ordinarily we won't see && and || expressions in control flow analysis because the Binder breaks those
                    // expressions down to individual conditional control flows. However, we may encounter them when analyzing
                    // aliased conditional expressions.
                    case 56 /* AmpersandAmpersandToken */ :
                        return assumeTrue ? narrowType(narrowType(type, expr.left, /*assumeTrue*/ true), expr.right, /*assumeTrue*/ true) : getUnionType([
                            narrowType(type, expr.left, /*assumeTrue*/ false),
                            narrowType(type, expr.right, /*assumeTrue*/ false)
                        ]);
                    case 57 /* BarBarToken */ :
                        return assumeTrue ? getUnionType([
                            narrowType(type, expr.left, /*assumeTrue*/ true),
                            narrowType(type, expr.right, /*assumeTrue*/ true)
                        ]) : narrowType(narrowType(type, expr.left, /*assumeTrue*/ false), expr.right, /*assumeTrue*/ false);
                }
                return type;
            }
            function narrowTypeByPrivateIdentifierInInExpression(type, expr, assumeTrue) {
                const target = getReferenceCandidate(expr.right);
                if (!isMatchingReference(reference, target)) return type;
                Debug.assertNode(expr.left, isPrivateIdentifier);
                const symbol = getSymbolForPrivateIdentifierExpression(expr.left);
                if (symbol === void 0) return type;
                const classSymbol = symbol.parent;
                const targetType = hasStaticModifier(Debug.checkDefined(symbol.valueDeclaration, "should always have a declaration")) ? getTypeOfSymbol(classSymbol) : getDeclaredTypeOfSymbol(classSymbol);
                return getNarrowedType(type, targetType, assumeTrue, /*checkDerived*/ true);
            }
            function narrowTypeByOptionalChainContainment(type, operator, value1, assumeTrue) {
                const equalsOperator = operator === 35 /* EqualsEqualsToken */  || operator === 37 /* EqualsEqualsEqualsToken */ ;
                const nullableFlags = operator === 35 /* EqualsEqualsToken */  || operator === 36 /* ExclamationEqualsToken */  ? 98304 /* Nullable */  : 32768 /* Undefined */ ;
                const valueType = getTypeOfExpression(value1);
                const removeNullable = equalsOperator !== assumeTrue && everyType(valueType, (t)=>!!(t.flags & nullableFlags)) || equalsOperator === assumeTrue && everyType(valueType, (t)=>!(t.flags & (3 /* AnyOrUnknown */  | nullableFlags)));
                return removeNullable ? getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type;
            }
            function narrowTypeByEquality(type, operator, value1, assumeTrue) {
                if (type.flags & 1 /* Any */ ) return type;
                if (operator === 36 /* ExclamationEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ ) assumeTrue = !assumeTrue;
                const valueType = getTypeOfExpression(value1);
                const doubleEquals = operator === 35 /* EqualsEqualsToken */  || operator === 36 /* ExclamationEqualsToken */ ;
                if (valueType.flags & 98304 /* Nullable */ ) {
                    if (!strictNullChecks) return type;
                    const facts = doubleEquals ? assumeTrue ? 262144 /* EQUndefinedOrNull */  : 2097152 /* NEUndefinedOrNull */  : valueType.flags & 65536 /* Null */  ? assumeTrue ? 131072 /* EQNull */  : 1048576 /* NENull */  : assumeTrue ? 65536 /* EQUndefined */  : 524288 /* NEUndefined */ ;
                    return getAdjustedTypeWithFacts(type, facts);
                }
                if (assumeTrue) {
                    if (!doubleEquals && (type.flags & 2 /* Unknown */  || someType(type, isEmptyAnonymousObjectType))) {
                        if (valueType.flags & 469893116 /* NonPrimitive */  || isEmptyAnonymousObjectType(valueType)) return valueType;
                        if (valueType.flags & 524288 /* Object */ ) return nonPrimitiveType;
                    }
                    const filteredType = filterType(type, (t)=>areTypesComparable(t, valueType) || doubleEquals && isCoercibleUnderDoubleEquals(t, valueType));
                    return replacePrimitivesWithLiterals(filteredType, valueType);
                }
                if (isUnitType(valueType)) return filterType(type, (t)=>!(isUnitLikeType(t) && areTypesComparable(t, valueType)));
                return type;
            }
            function narrowTypeByTypeof(type, typeOfExpr, operator, literal, assumeTrue) {
                if (operator === 36 /* ExclamationEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ ) assumeTrue = !assumeTrue;
                const target = getReferenceCandidate(typeOfExpr.expression);
                if (!isMatchingReference(reference, target)) {
                    if (strictNullChecks && optionalChainContainsReference(target, reference) && assumeTrue === (literal.text !== "undefined")) type = getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                    const propertyAccess = getDiscriminantPropertyAccess(target, type);
                    if (propertyAccess) return narrowTypeByDiscriminant(type, propertyAccess, (t)=>narrowTypeByLiteralExpression(t, literal, assumeTrue));
                    return type;
                }
                return narrowTypeByLiteralExpression(type, literal, assumeTrue);
            }
            function narrowTypeByLiteralExpression(type, literal, assumeTrue) {
                return assumeTrue ? narrowTypeByTypeName(type, literal.text) : getAdjustedTypeWithFacts(type, typeofNEFacts.get(literal.text) || 32768 /* TypeofNEHostObject */ );
            }
            function narrowTypeBySwitchOptionalChainContainment(type, { switchStatement, clauseStart, clauseEnd }, clauseCheck) {
                const everyClauseChecks = clauseStart !== clauseEnd && every(getSwitchClauseTypes(switchStatement).slice(clauseStart, clauseEnd), clauseCheck);
                return everyClauseChecks ? getTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ ) : type;
            }
            function narrowTypeBySwitchOnDiscriminant(type, { switchStatement, clauseStart, clauseEnd }) {
                const switchTypes = getSwitchClauseTypes(switchStatement);
                if (!switchTypes.length) return type;
                const clauseTypes = switchTypes.slice(clauseStart, clauseEnd);
                const hasDefaultClause = clauseStart === clauseEnd || contains(clauseTypes, neverType);
                if (type.flags & 2 /* Unknown */  && !hasDefaultClause) {
                    let groundClauseTypes;
                    for(let i = 0; i < clauseTypes.length; i += 1){
                        const t = clauseTypes[i];
                        if (t.flags & 469893116 /* NonPrimitive */ ) {
                            if (groundClauseTypes !== void 0) groundClauseTypes.push(t);
                        } else if (t.flags & 524288 /* Object */ ) {
                            if (groundClauseTypes === void 0) groundClauseTypes = clauseTypes.slice(0, i);
                            groundClauseTypes.push(nonPrimitiveType);
                        } else return type;
                    }
                    return getUnionType(groundClauseTypes === void 0 ? clauseTypes : groundClauseTypes);
                }
                const discriminantType = getUnionType(clauseTypes);
                const caseType = discriminantType.flags & 131072 /* Never */  ? neverType : replacePrimitivesWithLiterals(filterType(type, (t)=>areTypesComparable(discriminantType, t)), discriminantType);
                if (!hasDefaultClause) return caseType;
                const defaultType = filterType(type, (t)=>!(isUnitLikeType(t) && contains(switchTypes, t.flags & 32768 /* Undefined */  ? undefinedType : getRegularTypeOfLiteralType(extractUnitType(t)))));
                return caseType.flags & 131072 /* Never */  ? defaultType : getUnionType([
                    caseType,
                    defaultType
                ]);
            }
            function narrowTypeByTypeName(type, typeName) {
                switch(typeName){
                    case "string":
                        return narrowTypeByTypeFacts(type, stringType, 1 /* TypeofEQString */ );
                    case "number":
                        return narrowTypeByTypeFacts(type, numberType, 2 /* TypeofEQNumber */ );
                    case "bigint":
                        return narrowTypeByTypeFacts(type, bigintType, 4 /* TypeofEQBigInt */ );
                    case "boolean":
                        return narrowTypeByTypeFacts(type, booleanType, 8 /* TypeofEQBoolean */ );
                    case "symbol":
                        return narrowTypeByTypeFacts(type, esSymbolType, 16 /* TypeofEQSymbol */ );
                    case "object":
                        return type.flags & 1 /* Any */  ? type : getUnionType([
                            narrowTypeByTypeFacts(type, nonPrimitiveType, 32 /* TypeofEQObject */ ),
                            narrowTypeByTypeFacts(type, nullType, 131072 /* EQNull */ )
                        ]);
                    case "function":
                        return type.flags & 1 /* Any */  ? type : narrowTypeByTypeFacts(type, globalFunctionType, 64 /* TypeofEQFunction */ );
                    case "undefined":
                        return narrowTypeByTypeFacts(type, undefinedType, 65536 /* EQUndefined */ );
                }
                return narrowTypeByTypeFacts(type, nonPrimitiveType, 128 /* TypeofEQHostObject */ );
            }
            function narrowTypeByTypeFacts(type, impliedType, facts) {
                return mapType(type, (t)=>// We first check if a constituent is a subtype of the implied type. If so, we either keep or eliminate
                    // the constituent based on its type facts. We use the strict subtype relation because it treats `object`
                    // as a subtype of `{}`, and we need the type facts check because function types are subtypes of `object`,
                    // but are classified as "function" according to `typeof`.
                    isTypeRelatedTo(t, impliedType, strictSubtypeRelation) ? hasTypeFacts(t, facts) ? t : neverType : // We next check if the consituent is a supertype of the implied type. If so, we substitute the implied
                    // type. This handles top types like `unknown` and `{}`, and supertypes like `{ toString(): string }`.
                    isTypeSubtypeOf(impliedType, t) ? impliedType : // Neither the constituent nor the implied type is a subtype of the other, however their domains may still
                    // overlap. For example, an unconstrained type parameter and type `string`. If the type facts indicate
                    // possible overlap, we form an intersection. Otherwise, we eliminate the constituent.
                    hasTypeFacts(t, facts) ? getIntersectionType([
                        t,
                        impliedType
                    ]) : neverType);
            }
            function narrowTypeBySwitchOnTypeOf(type, { switchStatement, clauseStart, clauseEnd }) {
                const witnesses = getSwitchClauseTypeOfWitnesses(switchStatement);
                if (!witnesses) return type;
                const defaultIndex = findIndex(switchStatement.caseBlock.clauses, (clause)=>clause.kind === 298 /* DefaultClause */ );
                const hasDefaultClause = clauseStart === clauseEnd || defaultIndex >= clauseStart && defaultIndex < clauseEnd;
                if (hasDefaultClause) {
                    const notEqualFacts = getNotEqualFactsFromTypeofSwitch(clauseStart, clauseEnd, witnesses);
                    return filterType(type, (t)=>getTypeFacts(t, notEqualFacts) === notEqualFacts);
                }
                const clauseWitnesses = witnesses.slice(clauseStart, clauseEnd);
                return getUnionType(map(clauseWitnesses, (text)=>text ? narrowTypeByTypeName(type, text) : neverType));
            }
            function narrowTypeBySwitchOnTrue(type, { switchStatement, clauseStart, clauseEnd }) {
                const defaultIndex = findIndex(switchStatement.caseBlock.clauses, (clause)=>clause.kind === 298 /* DefaultClause */ );
                const hasDefaultClause = clauseStart === clauseEnd || defaultIndex >= clauseStart && defaultIndex < clauseEnd;
                for(let i = 0; i < clauseStart; i++){
                    const clause = switchStatement.caseBlock.clauses[i];
                    if (clause.kind === 297 /* CaseClause */ ) type = narrowType(type, clause.expression, /*assumeTrue*/ false);
                }
                if (hasDefaultClause) {
                    for(let i = clauseEnd; i < switchStatement.caseBlock.clauses.length; i++){
                        const clause = switchStatement.caseBlock.clauses[i];
                        if (clause.kind === 297 /* CaseClause */ ) type = narrowType(type, clause.expression, /*assumeTrue*/ false);
                    }
                    return type;
                }
                const clauses = switchStatement.caseBlock.clauses.slice(clauseStart, clauseEnd);
                return getUnionType(map(clauses, (clause)=>clause.kind === 297 /* CaseClause */  ? narrowType(type, clause.expression, /*assumeTrue*/ true) : neverType));
            }
            function isMatchingConstructorReference(expr) {
                return (isPropertyAccessExpression(expr) && idText(expr.name) === "constructor" || isElementAccessExpression(expr) && isStringLiteralLike(expr.argumentExpression) && expr.argumentExpression.text === "constructor") && isMatchingReference(reference, expr.expression);
            }
            function narrowTypeByConstructor(type, operator, identifier, assumeTrue) {
                if (assumeTrue ? operator !== 35 /* EqualsEqualsToken */  && operator !== 37 /* EqualsEqualsEqualsToken */  : operator !== 36 /* ExclamationEqualsToken */  && operator !== 38 /* ExclamationEqualsEqualsToken */ ) return type;
                const identifierType = getTypeOfExpression(identifier);
                if (!isFunctionType(identifierType) && !isConstructorType(identifierType)) return type;
                const prototypeProperty = getPropertyOfType(identifierType, "prototype");
                if (!prototypeProperty) return type;
                const prototypeType = getTypeOfSymbol(prototypeProperty);
                const candidate = !isTypeAny(prototypeType) ? prototypeType : void 0;
                if (!candidate || candidate === globalObjectType || candidate === globalFunctionType) return type;
                if (isTypeAny(type)) return candidate;
                return filterType(type, (t)=>isConstructedBy(t, candidate));
                function isConstructedBy(source, target) {
                    if (source.flags & 524288 /* Object */  && getObjectFlags(source) & 1 /* Class */  || target.flags & 524288 /* Object */  && getObjectFlags(target) & 1 /* Class */ ) return source.symbol === target.symbol;
                    return isTypeSubtypeOf(source, target);
                }
            }
            function narrowTypeByInstanceof(type, expr, assumeTrue) {
                const left = getReferenceCandidate(expr.left);
                if (!isMatchingReference(reference, left)) {
                    if (assumeTrue && strictNullChecks && optionalChainContainsReference(left, reference)) return getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                    return type;
                }
                const right = expr.right;
                const rightType = getTypeOfExpression(right);
                if (!isTypeDerivedFrom(rightType, globalObjectType)) return type;
                const signature = getEffectsSignature(expr);
                const predicate = signature && getTypePredicateOfSignature(signature);
                if (predicate && predicate.kind === 1 /* Identifier */  && predicate.parameterIndex === 0) return getNarrowedType(type, predicate.type, assumeTrue, /*checkDerived*/ true);
                if (!isTypeDerivedFrom(rightType, globalFunctionType)) return type;
                const instanceType = mapType(rightType, getInstanceType);
                if (isTypeAny(type) && (instanceType === globalObjectType || instanceType === globalFunctionType) || !assumeTrue && !(instanceType.flags & 524288 /* Object */  && !isEmptyAnonymousObjectType(instanceType))) return type;
                return getNarrowedType(type, instanceType, assumeTrue, /*checkDerived*/ true);
            }
            function getInstanceType(constructorType) {
                const prototypePropertyType = getTypeOfPropertyOfType(constructorType, "prototype");
                if (prototypePropertyType && !isTypeAny(prototypePropertyType)) return prototypePropertyType;
                const constructSignatures = getSignaturesOfType(constructorType, 1 /* Construct */ );
                if (constructSignatures.length) return getUnionType(map(constructSignatures, (signature)=>getReturnTypeOfSignature(getErasedSignature(signature))));
                return emptyObjectType;
            }
            function getNarrowedType(type, candidate, assumeTrue, checkDerived) {
                const key2 = type.flags & 1048576 /* Union */  ? `N${getTypeId(type)},${getTypeId(candidate)},${(assumeTrue ? 1 : 0) | (checkDerived ? 2 : 0)}` : void 0;
                var _getCachedType;
                return (_getCachedType = getCachedType(key2)) !== null && _getCachedType !== void 0 ? _getCachedType : setCachedType(key2, getNarrowedTypeWorker(type, candidate, assumeTrue, checkDerived));
            }
            function getNarrowedTypeWorker(type, candidate, assumeTrue, checkDerived) {
                if (!assumeTrue) {
                    if (type === candidate) return neverType;
                    if (checkDerived) return filterType(type, (t)=>!isTypeDerivedFrom(t, candidate));
                    type = type.flags & 2 /* Unknown */  ? unknownUnionType : type;
                    const trueType2 = getNarrowedType(type, candidate, /*assumeTrue*/ true, /*checkDerived*/ false);
                    return recombineUnknownType(filterType(type, (t)=>!isTypeSubsetOf(t, trueType2)));
                }
                if (type.flags & 3 /* AnyOrUnknown */ ) return candidate;
                if (type === candidate) return candidate;
                const isRelated = checkDerived ? isTypeDerivedFrom : isTypeSubtypeOf;
                const keyPropertyName = type.flags & 1048576 /* Union */  ? getKeyPropertyName(type) : void 0;
                const narrowedType = mapType(candidate, (c)=>{
                    const discriminant = keyPropertyName && getTypeOfPropertyOfType(c, keyPropertyName);
                    const matching = discriminant && getConstituentTypeForKeyType(type, discriminant);
                    const directlyRelated = mapType(matching || type, checkDerived ? (t)=>isTypeDerivedFrom(t, c) ? t : isTypeDerivedFrom(c, t) ? c : neverType : (t)=>isTypeStrictSubtypeOf(t, c) ? t : isTypeStrictSubtypeOf(c, t) ? c : isTypeSubtypeOf(t, c) ? t : isTypeSubtypeOf(c, t) ? c : neverType);
                    return directlyRelated.flags & 131072 /* Never */  ? mapType(type, (t)=>maybeTypeOfKind(t, 465829888 /* Instantiable */ ) && isRelated(c, getBaseConstraintOfType(t) || unknownType) ? getIntersectionType([
                            t,
                            c
                        ]) : neverType) : directlyRelated;
                });
                return !(narrowedType.flags & 131072 /* Never */ ) ? narrowedType : isTypeSubtypeOf(candidate, type) ? candidate : isTypeAssignableTo(type, candidate) ? type : isTypeAssignableTo(candidate, type) ? candidate : getIntersectionType([
                    type,
                    candidate
                ]);
            }
            function narrowTypeByCallExpression(type, callExpression, assumeTrue) {
                if (hasMatchingArgument(callExpression, reference)) {
                    const signature = assumeTrue || !isCallChain(callExpression) ? getEffectsSignature(callExpression) : void 0;
                    const predicate = signature && getTypePredicateOfSignature(signature);
                    if (predicate && (predicate.kind === 0 /* This */  || predicate.kind === 1 /* Identifier */ )) return narrowTypeByTypePredicate(type, predicate, callExpression, assumeTrue);
                }
                if (containsMissingType(type) && isAccessExpression(reference) && isPropertyAccessExpression(callExpression.expression)) {
                    const callAccess = callExpression.expression;
                    if (isMatchingReference(reference.expression, getReferenceCandidate(callAccess.expression)) && isIdentifier(callAccess.name) && callAccess.name.escapedText === "hasOwnProperty" && callExpression.arguments.length === 1) {
                        const argument = callExpression.arguments[0];
                        if (isStringLiteralLike(argument) && getAccessedPropertyName(reference) === escapeLeadingUnderscores(argument.text)) return getTypeWithFacts(type, assumeTrue ? 524288 /* NEUndefined */  : 65536 /* EQUndefined */ );
                    }
                }
                return type;
            }
            function narrowTypeByTypePredicate(type, predicate, callExpression, assumeTrue) {
                if (predicate.type && !(isTypeAny(type) && (predicate.type === globalObjectType || predicate.type === globalFunctionType))) {
                    const predicateArgument = getTypePredicateArgument(predicate, callExpression);
                    if (predicateArgument) {
                        if (isMatchingReference(reference, predicateArgument)) return getNarrowedType(type, predicate.type, assumeTrue, /*checkDerived*/ false);
                        if (strictNullChecks && optionalChainContainsReference(predicateArgument, reference) && (assumeTrue && !hasTypeFacts(predicate.type, 65536 /* EQUndefined */ ) || !assumeTrue && everyType(predicate.type, isNullableType))) type = getAdjustedTypeWithFacts(type, 2097152 /* NEUndefinedOrNull */ );
                        const access = getDiscriminantPropertyAccess(predicateArgument, type);
                        if (access) return narrowTypeByDiscriminant(type, access, (t)=>getNarrowedType(t, predicate.type, assumeTrue, /*checkDerived*/ false));
                    }
                }
                return type;
            }
            function narrowType(type, expr, assumeTrue) {
                if (isExpressionOfOptionalChainRoot(expr) || isBinaryExpression(expr.parent) && (expr.parent.operatorToken.kind === 61 /* QuestionQuestionToken */  || expr.parent.operatorToken.kind === 78 /* QuestionQuestionEqualsToken */ ) && expr.parent.left === expr) return narrowTypeByOptionality(type, expr, assumeTrue);
                switch(expr.kind){
                    case 80 /* Identifier */ :
                        if (!isMatchingReference(reference, expr) && inlineLevel < 5) {
                            const symbol = getResolvedSymbol(expr);
                            if (isConstantVariable(symbol)) {
                                const declaration = symbol.valueDeclaration;
                                if (declaration && isVariableDeclaration(declaration) && !declaration.type && declaration.initializer && isConstantReference(reference)) {
                                    inlineLevel++;
                                    const result = narrowType(type, declaration.initializer, assumeTrue);
                                    inlineLevel--;
                                    return result;
                                }
                            }
                        }
                    // falls through
                    case 110 /* ThisKeyword */ :
                    case 108 /* SuperKeyword */ :
                    case 212 /* PropertyAccessExpression */ :
                    case 213 /* ElementAccessExpression */ :
                        return narrowTypeByTruthiness(type, expr, assumeTrue);
                    case 214 /* CallExpression */ :
                        return narrowTypeByCallExpression(type, expr, assumeTrue);
                    case 218 /* ParenthesizedExpression */ :
                    case 236 /* NonNullExpression */ :
                    case 239 /* SatisfiesExpression */ :
                        return narrowType(type, expr.expression, assumeTrue);
                    case 227 /* BinaryExpression */ :
                        return narrowTypeByBinaryExpression(type, expr, assumeTrue);
                    case 225 /* PrefixUnaryExpression */ :
                        if (expr.operator === 54 /* ExclamationToken */ ) return narrowType(type, expr.operand, !assumeTrue);
                        break;
                }
                return type;
            }
            function narrowTypeByOptionality(type, expr, assumePresent) {
                if (isMatchingReference(reference, expr)) return getAdjustedTypeWithFacts(type, assumePresent ? 2097152 /* NEUndefinedOrNull */  : 262144 /* EQUndefinedOrNull */ );
                const access = getDiscriminantPropertyAccess(expr, type);
                if (access) return narrowTypeByDiscriminant(type, access, (t)=>getTypeWithFacts(t, assumePresent ? 2097152 /* NEUndefinedOrNull */  : 262144 /* EQUndefinedOrNull */ ));
                return type;
            }
        }
        function getTypeOfSymbolAtLocation(symbol, location) {
            symbol = getExportSymbolOfValueSymbolIfExported(symbol);
            if (location.kind === 80 /* Identifier */  || location.kind === 81 /* PrivateIdentifier */ ) {
                if (isRightSideOfQualifiedNameOrPropertyAccess(location)) location = location.parent;
                if (isExpressionNode(location) && (!isAssignmentTarget(location) || isWriteAccess(location))) {
                    const type = removeOptionalTypeMarker(isWriteAccess(location) && location.kind === 212 /* PropertyAccessExpression */  ? checkPropertyAccessExpression(location, /*checkMode*/ void 0, /*writeOnly*/ true) : getTypeOfExpression(location));
                    if (getExportSymbolOfValueSymbolIfExported(getNodeLinks(location).resolvedSymbol) === symbol) return type;
                }
            }
            if (isDeclarationName(location) && isSetAccessor(location.parent) && getAnnotatedAccessorTypeNode(location.parent)) return getWriteTypeOfAccessors(location.parent.symbol);
            return isRightSideOfAccessExpression(location) && isWriteAccess(location.parent) ? getWriteTypeOfSymbol(symbol) : getNonMissingTypeOfSymbol(symbol);
        }
        function getControlFlowContainer(node) {
            return findAncestor(node.parent, (node2)=>isFunctionLike(node2) && !getImmediatelyInvokedFunctionExpression(node2) || node2.kind === 269 /* ModuleBlock */  || node2.kind === 308 /* SourceFile */  || node2.kind === 173 /* PropertyDeclaration */ );
        }
        function isSymbolAssignedDefinitely(symbol) {
            if (symbol.lastAssignmentPos !== void 0) return symbol.lastAssignmentPos < 0;
            return isSymbolAssigned(symbol) && symbol.lastAssignmentPos !== void 0 && symbol.lastAssignmentPos < 0;
        }
        function isSymbolAssigned(symbol) {
            return !isPastLastAssignment(symbol, /*location*/ void 0);
        }
        function isPastLastAssignment(symbol, location) {
            const parent2 = findAncestor(symbol.valueDeclaration, isFunctionOrSourceFile);
            if (!parent2) return false;
            const links = getNodeLinks(parent2);
            if (!(links.flags & 131072 /* AssignmentsMarked */ )) {
                links.flags |= 131072 /* AssignmentsMarked */ ;
                if (!hasParentWithAssignmentsMarked(parent2)) markNodeAssignments(parent2);
            }
            return !symbol.lastAssignmentPos || location && Math.abs(symbol.lastAssignmentPos) < location.pos;
        }
        function isSomeSymbolAssigned(rootDeclaration) {
            Debug.assert(isVariableDeclaration(rootDeclaration) || isParameter(rootDeclaration));
            return isSomeSymbolAssignedWorker(rootDeclaration.name);
        }
        function isSomeSymbolAssignedWorker(node) {
            if (node.kind === 80 /* Identifier */ ) return isSymbolAssigned(getSymbolOfDeclaration(node.parent));
            return some(node.elements, (e)=>e.kind !== 233 /* OmittedExpression */  && isSomeSymbolAssignedWorker(e.name));
        }
        function hasParentWithAssignmentsMarked(node) {
            return !!findAncestor(node.parent, (node2)=>isFunctionOrSourceFile(node2) && !!(getNodeLinks(node2).flags & 131072 /* AssignmentsMarked */ ));
        }
        function isFunctionOrSourceFile(node) {
            return isFunctionLikeDeclaration(node) || isSourceFile(node);
        }
        function markNodeAssignments(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    const assigmentTarget = getAssignmentTargetKind(node);
                    if (assigmentTarget !== 0 /* None */ ) {
                        const symbol = getResolvedSymbol(node);
                        const hasDefiniteAssignment = assigmentTarget === 1 /* Definite */  || symbol.lastAssignmentPos !== void 0 && symbol.lastAssignmentPos < 0;
                        if (isParameterOrMutableLocalVariable(symbol)) {
                            if (symbol.lastAssignmentPos === void 0 || Math.abs(symbol.lastAssignmentPos) !== Number.MAX_VALUE) {
                                const referencingFunction = findAncestor(node, isFunctionOrSourceFile);
                                const declaringFunction = findAncestor(symbol.valueDeclaration, isFunctionOrSourceFile);
                                symbol.lastAssignmentPos = referencingFunction === declaringFunction ? extendAssignmentPosition(node, symbol.valueDeclaration) : Number.MAX_VALUE;
                            }
                            if (hasDefiniteAssignment && symbol.lastAssignmentPos > 0) symbol.lastAssignmentPos *= -1;
                        }
                    }
                    return;
                case 282 /* ExportSpecifier */ :
                    const exportDeclaration = node.parent.parent;
                    const name = node.propertyName || node.name;
                    if (!node.isTypeOnly && !exportDeclaration.isTypeOnly && !exportDeclaration.moduleSpecifier && name.kind !== 11 /* StringLiteral */ ) {
                        const symbol = resolveEntityName(name, 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true);
                        if (symbol && isParameterOrMutableLocalVariable(symbol)) {
                            const sign = symbol.lastAssignmentPos !== void 0 && symbol.lastAssignmentPos < 0 ? -1 : 1;
                            symbol.lastAssignmentPos = sign * Number.MAX_VALUE;
                        }
                    }
                    return;
                case 265 /* InterfaceDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 267 /* EnumDeclaration */ :
                    return;
            }
            if (isTypeNode(node)) return;
            forEachChild(node, markNodeAssignments);
        }
        function extendAssignmentPosition(node, declaration) {
            let pos = node.pos;
            while(node && node.pos > declaration.pos){
                switch(node.kind){
                    case 244 /* VariableStatement */ :
                    case 245 /* ExpressionStatement */ :
                    case 246 /* IfStatement */ :
                    case 247 /* DoStatement */ :
                    case 248 /* WhileStatement */ :
                    case 249 /* ForStatement */ :
                    case 250 /* ForInStatement */ :
                    case 251 /* ForOfStatement */ :
                    case 255 /* WithStatement */ :
                    case 256 /* SwitchStatement */ :
                    case 259 /* TryStatement */ :
                    case 264 /* ClassDeclaration */ :
                        pos = node.end;
                }
                node = node.parent;
            }
            return pos;
        }
        function isConstantVariable(symbol) {
            return symbol.flags & 3 /* Variable */  && (getDeclarationNodeFlagsFromSymbol(symbol) & 6 /* Constant */ ) !== 0;
        }
        function isParameterOrMutableLocalVariable(symbol) {
            const declaration = symbol.valueDeclaration && getRootDeclaration(symbol.valueDeclaration);
            return !!declaration && (isParameter(declaration) || isVariableDeclaration(declaration) && (isCatchClause(declaration.parent) || isMutableLocalVariableDeclaration(declaration)));
        }
        function isMutableLocalVariableDeclaration(declaration) {
            return !!(declaration.parent.flags & 1 /* Let */ ) && !(getCombinedModifierFlags(declaration) & 32 /* Export */  || declaration.parent.parent.kind === 244 /* VariableStatement */  && isGlobalSourceFile(declaration.parent.parent.parent));
        }
        function parameterInitializerContainsUndefined(declaration) {
            const links = getNodeLinks(declaration);
            if (links.parameterInitializerContainsUndefined === void 0) {
                if (!pushTypeResolution(declaration, 8 /* ParameterInitializerContainsUndefined */ )) {
                    reportCircularityError(declaration.symbol);
                    return true;
                }
                const containsUndefined = !!hasTypeFacts(checkDeclarationInitializer(declaration, 0 /* Normal */ ), 16777216 /* IsUndefined */ );
                if (!popTypeResolution()) {
                    reportCircularityError(declaration.symbol);
                    return true;
                }
                var _links_parameterInitializerContainsUndefined;
                (_links_parameterInitializerContainsUndefined = links.parameterInitializerContainsUndefined) !== null && _links_parameterInitializerContainsUndefined !== void 0 ? _links_parameterInitializerContainsUndefined : links.parameterInitializerContainsUndefined = containsUndefined;
            }
            return links.parameterInitializerContainsUndefined;
        }
        function removeOptionalityFromDeclaredType(declaredType, declaration) {
            const removeUndefined = strictNullChecks && declaration.kind === 170 /* Parameter */  && declaration.initializer && hasTypeFacts(declaredType, 16777216 /* IsUndefined */ ) && !parameterInitializerContainsUndefined(declaration);
            return removeUndefined ? getTypeWithFacts(declaredType, 524288 /* NEUndefined */ ) : declaredType;
        }
        function isConstraintPosition(type, node) {
            const parent2 = node.parent;
            return parent2.kind === 212 /* PropertyAccessExpression */  || parent2.kind === 167 /* QualifiedName */  || parent2.kind === 214 /* CallExpression */  && parent2.expression === node || parent2.kind === 215 /* NewExpression */  && parent2.expression === node || parent2.kind === 213 /* ElementAccessExpression */  && parent2.expression === node && !(someType(type, isGenericTypeWithoutNullableConstraint) && isGenericIndexType(getTypeOfExpression(parent2.argumentExpression)));
        }
        function isGenericTypeWithUnionConstraint(type) {
            return type.flags & 2097152 /* Intersection */  ? some(type.types, isGenericTypeWithUnionConstraint) : !!(type.flags & 465829888 /* Instantiable */  && getBaseConstraintOrType(type).flags & 1146880 /* Union */ );
        }
        function isGenericTypeWithoutNullableConstraint(type) {
            return type.flags & 2097152 /* Intersection */  ? some(type.types, isGenericTypeWithoutNullableConstraint) : !!(type.flags & 465829888 /* Instantiable */  && !maybeTypeOfKind(getBaseConstraintOrType(type), 98304 /* Nullable */ ));
        }
        function hasContextualTypeWithNoGenericTypes(node, checkMode) {
            const contextualType = (isIdentifier(node) || isPropertyAccessExpression(node) || isElementAccessExpression(node)) && !((isJsxOpeningElement(node.parent) || isJsxSelfClosingElement(node.parent)) && node.parent.tagName === node) && (checkMode && checkMode & 32 /* RestBindingElement */  ? getContextualType2(node, 8 /* SkipBindingPatterns */ ) : getContextualType2(node, /*contextFlags*/ void 0));
            return contextualType && !isGenericType(contextualType);
        }
        function getNarrowableTypeForReference(type, reference, checkMode) {
            if (isNoInferType(type)) type = type.baseType;
            const substituteConstraints = !(checkMode && checkMode & 2 /* Inferential */ ) && someType(type, isGenericTypeWithUnionConstraint) && (isConstraintPosition(type, reference) || hasContextualTypeWithNoGenericTypes(reference, checkMode));
            return substituteConstraints ? mapType(type, getBaseConstraintOrType) : type;
        }
        function isExportOrExportExpression(location) {
            return !!findAncestor(location, (n)=>{
                const parent2 = n.parent;
                if (parent2 === void 0) return "quit";
                if (isExportAssignment(parent2)) return parent2.expression === n && isEntityNameExpression(n);
                if (isExportSpecifier(parent2)) return parent2.name === n || parent2.propertyName === n;
                return false;
            });
        }
        function markLinkedReferences(location, hint, propSymbol, parentType) {
            if (!canCollectSymbolAliasAccessabilityData) return;
            if (location.flags & 33554432 /* Ambient */  && !isPropertySignature(location) && !isPropertyDeclaration(location)) return;
            switch(hint){
                case 1 /* Identifier */ :
                    return markIdentifierAliasReferenced(location);
                case 2 /* Property */ :
                    return markPropertyAliasReferenced(location, propSymbol, parentType);
                case 3 /* ExportAssignment */ :
                    return markExportAssignmentAliasReferenced(location);
                case 4 /* Jsx */ :
                    return markJsxAliasReferenced(location);
                case 5 /* AsyncFunction */ :
                    return markAsyncFunctionAliasReferenced(location);
                case 6 /* ExportImportEquals */ :
                    return markImportEqualsAliasReferenced(location);
                case 7 /* ExportSpecifier */ :
                    return markExportSpecifierAliasReferenced(location);
                case 8 /* Decorator */ :
                    return markDecoratorAliasReferenced(location);
                case 0 /* Unspecified */ :
                    if (isIdentifier(location) && (isExpressionNode(location) || isShorthandPropertyAssignment(location.parent) || isImportEqualsDeclaration(location.parent) && location.parent.moduleReference === location) && shouldMarkIdentifierAliasReferenced(location)) {
                        if (isPropertyAccessOrQualifiedName(location.parent)) {
                            const left = isPropertyAccessExpression(location.parent) ? location.parent.expression : location.parent.left;
                            if (left !== location) return;
                        }
                        markIdentifierAliasReferenced(location);
                        return;
                    }
                    if (isPropertyAccessOrQualifiedName(location)) {
                        let topProp = location;
                        while(isPropertyAccessOrQualifiedName(topProp)){
                            if (isPartOfTypeNode(topProp)) return;
                            topProp = topProp.parent;
                        }
                        return markPropertyAliasReferenced(location);
                    }
                    if (isExportAssignment(location)) return markExportAssignmentAliasReferenced(location);
                    if (isJsxOpeningLikeElement(location) || isJsxOpeningFragment(location)) return markJsxAliasReferenced(location);
                    if (isImportEqualsDeclaration(location)) {
                        if (isInternalModuleImportEqualsDeclaration(location) || checkExternalImportOrExportDeclaration(location)) return markImportEqualsAliasReferenced(location);
                        return;
                    }
                    if (isExportSpecifier(location)) return markExportSpecifierAliasReferenced(location);
                    if (isFunctionLikeDeclaration(location) || isMethodSignature(location)) markAsyncFunctionAliasReferenced(location);
                    if (!compilerOptions.emitDecoratorMetadata) return;
                    if (!canHaveDecorators(location) || !hasDecorators(location) || !location.modifiers || !nodeCanBeDecorated(legacyDecorators, location, location.parent, location.parent.parent)) return;
                    return markDecoratorAliasReferenced(location);
                default:
                    Debug.assertNever(hint, `Unhandled reference hint: ${hint}`);
            }
        }
        function markIdentifierAliasReferenced(location) {
            const symbol = getResolvedSymbol(location);
            if (symbol && symbol !== argumentsSymbol && symbol !== unknownSymbol && !isThisInTypeQuery(location)) markAliasReferenced(symbol, location);
        }
        function markPropertyAliasReferenced(location, propSymbol, parentType) {
            const left = isPropertyAccessExpression(location) ? location.expression : location.left;
            if (isThisIdentifier(left) || !isIdentifier(left)) return;
            const parentSymbol = getResolvedSymbol(left);
            if (!parentSymbol || parentSymbol === unknownSymbol) return;
            if (getIsolatedModules(compilerOptions) || shouldPreserveConstEnums(compilerOptions) && isExportOrExportExpression(location)) {
                markAliasReferenced(parentSymbol, location);
                return;
            }
            const leftType = parentType || checkExpressionCached(left);
            if (isTypeAny(leftType) || leftType === silentNeverType) {
                markAliasReferenced(parentSymbol, location);
                return;
            }
            let prop = propSymbol;
            if (!prop && !parentType) {
                const right = isPropertyAccessExpression(location) ? location.name : location.right;
                const lexicallyScopedSymbol = isPrivateIdentifier(right) && lookupSymbolForPrivateIdentifierDeclaration(right.escapedText, right);
                const assignmentKind = getAssignmentTargetKind(location);
                const apparentType = getApparentType(assignmentKind !== 0 /* None */  || isMethodAccessForCall(location) ? getWidenedType(leftType) : leftType);
                prop = isPrivateIdentifier(right) ? lexicallyScopedSymbol && getPrivateIdentifierPropertyOfType(apparentType, lexicallyScopedSymbol) || void 0 : getPropertyOfType(apparentType, right.escapedText);
            }
            if (!(prop && (isConstEnumOrConstEnumOnlyModule(prop) || prop.flags & 8 /* EnumMember */  && location.parent.kind === 307 /* EnumMember */ ))) markAliasReferenced(parentSymbol, location);
            return;
        }
        function markExportAssignmentAliasReferenced(location) {
            if (isIdentifier(location.expression)) {
                const id = location.expression;
                const sym = getExportSymbolOfValueSymbolIfExported(resolveEntityName(id, -1 /* All */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, location));
                if (sym) markAliasReferenced(sym, id);
            }
        }
        function markJsxAliasReferenced(node) {
            if (!getJsxNamespaceContainerForImplicitImport(node)) {
                const jsxFactoryRefErr = diagnostics && compilerOptions.jsx === 2 /* React */  ? Diagnostics.This_JSX_tag_requires_0_to_be_in_scope_but_it_could_not_be_found : void 0;
                const jsxFactoryNamespace = getJsxNamespace(node);
                const jsxFactoryLocation = isJsxOpeningLikeElement(node) ? node.tagName : node;
                const shouldFactoryRefErr = compilerOptions.jsx !== 1 /* Preserve */  && compilerOptions.jsx !== 3 /* ReactNative */ ;
                let jsxFactorySym;
                if (!(isJsxOpeningFragment(node) && jsxFactoryNamespace === "null")) jsxFactorySym = resolveName(jsxFactoryLocation, jsxFactoryNamespace, shouldFactoryRefErr ? 111551 /* Value */  : 111167 /* Enum */ , jsxFactoryRefErr, /*isUse*/ true);
                if (jsxFactorySym) {
                    jsxFactorySym.isReferenced = -1 /* All */ ;
                    if (canCollectSymbolAliasAccessabilityData && jsxFactorySym.flags & 2097152 /* Alias */  && !getTypeOnlyAliasDeclaration(jsxFactorySym)) markAliasSymbolAsReferenced(jsxFactorySym);
                }
                if (isJsxOpeningFragment(node)) {
                    const file = getSourceFileOfNode(node);
                    const entity = getJsxFactoryEntity(file);
                    if (entity) {
                        const localJsxNamespace = getFirstIdentifier(entity).escapedText;
                        resolveName(jsxFactoryLocation, localJsxNamespace, shouldFactoryRefErr ? 111551 /* Value */  : 111167 /* Enum */ , jsxFactoryRefErr, /*isUse*/ true);
                    }
                }
            }
            return;
        }
        function markAsyncFunctionAliasReferenced(location) {
            if (languageVersion < 2 /* ES2015 */ ) {
                if (getFunctionFlags(location) & 2 /* Async */ ) {
                    const returnTypeNode = getEffectiveReturnTypeNode(location);
                    markTypeNodeAsReferenced(returnTypeNode);
                }
            }
        }
        function markImportEqualsAliasReferenced(location) {
            if (hasSyntacticModifier(location, 32 /* Export */ )) markExportAsReferenced(location);
        }
        function markExportSpecifierAliasReferenced(location) {
            if (!location.parent.parent.moduleSpecifier && !location.isTypeOnly && !location.parent.parent.isTypeOnly) {
                const exportedName = location.propertyName || location.name;
                if (exportedName.kind === 11 /* StringLiteral */ ) return;
                const symbol = resolveName(exportedName, exportedName.escapedText, 2998271 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
                if (symbol && (symbol === undefinedSymbol || symbol === globalThisSymbol || symbol.declarations && isGlobalSourceFile(getDeclarationContainer(symbol.declarations[0])))) ;
                else {
                    const target = symbol && (symbol.flags & 2097152 /* Alias */  ? resolveAlias(symbol) : symbol);
                    if (!target || getSymbolFlags(target) & 111551 /* Value */ ) {
                        markExportAsReferenced(location);
                        markIdentifierAliasReferenced(exportedName);
                    }
                }
                return;
            }
        }
        function markDecoratorAliasReferenced(node) {
            if (compilerOptions.emitDecoratorMetadata) {
                const firstDecorator = find(node.modifiers, isDecorator);
                if (!firstDecorator) return;
                checkExternalEmitHelpers(firstDecorator, 16 /* Metadata */ );
                switch(node.kind){
                    case 264 /* ClassDeclaration */ :
                        const constructor = getFirstConstructorWithBody(node);
                        if (constructor) for (const parameter of constructor.parameters)markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
                        break;
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        const otherKind = node.kind === 178 /* GetAccessor */  ? 179 /* SetAccessor */  : 178 /* GetAccessor */ ;
                        const otherAccessor = getDeclarationOfKind(getSymbolOfDeclaration(node), otherKind);
                        markDecoratorMedataDataTypeNodeAsReferenced(getAnnotatedAccessorTypeNode(node) || otherAccessor && getAnnotatedAccessorTypeNode(otherAccessor));
                        break;
                    case 175 /* MethodDeclaration */ :
                        for (const parameter of node.parameters)markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
                        markDecoratorMedataDataTypeNodeAsReferenced(getEffectiveReturnTypeNode(node));
                        break;
                    case 173 /* PropertyDeclaration */ :
                        markDecoratorMedataDataTypeNodeAsReferenced(getEffectiveTypeAnnotationNode(node));
                        break;
                    case 170 /* Parameter */ :
                        markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(node));
                        const containingSignature = node.parent;
                        for (const parameter of containingSignature.parameters)markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
                        markDecoratorMedataDataTypeNodeAsReferenced(getEffectiveReturnTypeNode(containingSignature));
                        break;
                }
            }
        }
        function markAliasReferenced(symbol, location) {
            if (!canCollectSymbolAliasAccessabilityData) return;
            if (isNonLocalAlias(symbol, /*excludes*/ 111551 /* Value */ ) && !isInTypeQuery(location)) {
                const target = resolveAlias(symbol);
                if (getSymbolFlags(symbol, /*excludeTypeOnlyMeanings*/ true) & 1160127 /* ExportValue */ ) {
                    if (getIsolatedModules(compilerOptions) || shouldPreserveConstEnums(compilerOptions) && isExportOrExportExpression(location) || !isConstEnumOrConstEnumOnlyModule(getExportSymbolOfValueSymbolIfExported(target))) markAliasSymbolAsReferenced(symbol);
                }
            }
        }
        function markAliasSymbolAsReferenced(symbol) {
            Debug.assert(canCollectSymbolAliasAccessabilityData);
            const links = getSymbolLinks(symbol);
            if (!links.referenced) {
                links.referenced = true;
                const node = getDeclarationOfAliasSymbol(symbol);
                if (!node) return Debug.fail();
                if (isInternalModuleImportEqualsDeclaration(node)) {
                    if (getSymbolFlags(resolveSymbol(symbol)) & 111551 /* Value */ ) {
                        const left = getFirstIdentifier(node.moduleReference);
                        markIdentifierAliasReferenced(left);
                    }
                }
            }
        }
        function markExportAsReferenced(node) {
            const symbol = getSymbolOfDeclaration(node);
            const target = resolveAlias(symbol);
            if (target) {
                const markAlias = target === unknownSymbol || getSymbolFlags(symbol, /*excludeTypeOnlyMeanings*/ true) & 111551 /* Value */  && !isConstEnumOrConstEnumOnlyModule(target);
                if (markAlias) markAliasSymbolAsReferenced(symbol);
            }
        }
        function markEntityNameOrEntityExpressionAsReference(typeName, forDecoratorMetadata) {
            if (!typeName) return;
            const rootName = getFirstIdentifier(typeName);
            const meaning = (typeName.kind === 80 /* Identifier */  ? 788968 /* Type */  : 1920 /* Namespace */ ) | 2097152 /* Alias */ ;
            const rootSymbol = resolveName(rootName, rootName.escapedText, meaning, /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
            if (rootSymbol && rootSymbol.flags & 2097152 /* Alias */ ) {
                if (canCollectSymbolAliasAccessabilityData && symbolIsValue(rootSymbol) && !isConstEnumOrConstEnumOnlyModule(resolveAlias(rootSymbol)) && !getTypeOnlyAliasDeclaration(rootSymbol)) markAliasSymbolAsReferenced(rootSymbol);
                else if (forDecoratorMetadata && getIsolatedModules(compilerOptions) && getEmitModuleKind(compilerOptions) >= 5 /* ES2015 */  && !symbolIsValue(rootSymbol) && !some(rootSymbol.declarations, isTypeOnlyImportOrExportDeclaration)) {
                    const diag2 = error2(typeName, Diagnostics.A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_when_isolatedModules_and_emitDecoratorMetadata_are_enabled);
                    const aliasDeclaration = find(rootSymbol.declarations || emptyArray, isAliasSymbolDeclaration);
                    if (aliasDeclaration) addRelatedInfo(diag2, createDiagnosticForNode(aliasDeclaration, Diagnostics._0_was_imported_here, idText(rootName)));
                }
            }
        }
        function markTypeNodeAsReferenced(node) {
            markEntityNameOrEntityExpressionAsReference(node && getEntityNameFromTypeNode(node), /*forDecoratorMetadata*/ false);
        }
        function markDecoratorMedataDataTypeNodeAsReferenced(node) {
            const entityName = getEntityNameForDecoratorMetadata(node);
            if (entityName && isEntityName(entityName)) markEntityNameOrEntityExpressionAsReference(entityName, /*forDecoratorMetadata*/ true);
        }
        function getNarrowedTypeOfSymbol(symbol, location) {
            var _a;
            const type = getTypeOfSymbol(symbol);
            const declaration = symbol.valueDeclaration;
            if (declaration) {
                if (isBindingElement(declaration) && !declaration.initializer && !declaration.dotDotDotToken && declaration.parent.elements.length >= 2) {
                    const parent2 = declaration.parent.parent;
                    const rootDeclaration = getRootDeclaration(parent2);
                    if (rootDeclaration.kind === 261 /* VariableDeclaration */  && getCombinedNodeFlagsCached(rootDeclaration) & 6 /* Constant */  || rootDeclaration.kind === 170 /* Parameter */ ) {
                        const links = getNodeLinks(parent2);
                        if (!(links.flags & 4194304 /* InCheckIdentifier */ )) {
                            links.flags |= 4194304 /* InCheckIdentifier */ ;
                            const parentType = getTypeForBindingElementParent(parent2, 0 /* Normal */ );
                            const parentTypeConstraint = parentType && mapType(parentType, getBaseConstraintOrType);
                            links.flags &= -4194305 /* InCheckIdentifier */ ;
                            if (parentTypeConstraint && parentTypeConstraint.flags & 1048576 /* Union */  && !(rootDeclaration.kind === 170 /* Parameter */  && isSomeSymbolAssigned(rootDeclaration))) {
                                const pattern = declaration.parent;
                                const narrowedType = getFlowTypeOfReference(pattern, parentTypeConstraint, parentTypeConstraint, /*flowContainer*/ void 0, location.flowNode);
                                if (narrowedType.flags & 131072 /* Never */ ) return neverType;
                                return getBindingElementTypeFromParentType(declaration, narrowedType, /*noTupleBoundsCheck*/ true);
                            }
                        }
                    }
                }
                if (isParameter(declaration) && !declaration.type && !declaration.initializer && !declaration.dotDotDotToken) {
                    const func = declaration.parent;
                    if (func.parameters.length >= 2 && isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
                        const contextualSignature = getContextualSignature(func);
                        if (contextualSignature && contextualSignature.parameters.length === 1 && signatureHasRestParameter(contextualSignature)) {
                            const restType = getReducedApparentType(instantiateType(getTypeOfSymbol(contextualSignature.parameters[0]), (_a = getInferenceContext(func)) == null ? void 0 : _a.nonFixingMapper));
                            if (restType.flags & 1048576 /* Union */  && everyType(restType, isTupleType) && !some(func.parameters, isSomeSymbolAssigned)) {
                                const narrowedType = getFlowTypeOfReference(func, restType, restType, /*flowContainer*/ void 0, location.flowNode);
                                const index = func.parameters.indexOf(declaration) - (getThisParameter(func) ? 1 : 0);
                                return getIndexedAccessType(narrowedType, getNumberLiteralType(index));
                            }
                        }
                    }
                }
            }
            return type;
        }
        function checkIdentifierCalculateNodeCheckFlags(node, symbol) {
            if (isThisInTypeQuery(node)) return;
            if (symbol === argumentsSymbol) {
                if (isInPropertyInitializerOrClassStaticBlock(node, /*ignoreArrowFunctions*/ true)) {
                    error2(node, Diagnostics.arguments_cannot_be_referenced_in_property_initializers_or_class_static_initialization_blocks);
                    return;
                }
                let container = getContainingFunction(node);
                if (container) {
                    if (languageVersion < 2 /* ES2015 */ ) {
                        if (container.kind === 220 /* ArrowFunction */ ) error2(node, Diagnostics.The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES5_Consider_using_a_standard_function_expression);
                        else if (hasSyntacticModifier(container, 1024 /* Async */ )) error2(node, Diagnostics.The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES5_Consider_using_a_standard_function_or_method);
                    }
                    getNodeLinks(container).flags |= 512 /* CaptureArguments */ ;
                    while(container && isArrowFunction(container)){
                        container = getContainingFunction(container);
                        if (container) getNodeLinks(container).flags |= 512 /* CaptureArguments */ ;
                    }
                }
                return;
            }
            const localOrExportSymbol = getExportSymbolOfValueSymbolIfExported(symbol);
            const targetSymbol = resolveAliasWithDeprecationCheck(localOrExportSymbol, node);
            if (isDeprecatedSymbol(targetSymbol) && isUncalledFunctionReference(node, targetSymbol) && targetSymbol.declarations) addDeprecatedSuggestion(node, targetSymbol.declarations, node.escapedText);
            const declaration = localOrExportSymbol.valueDeclaration;
            if (declaration && localOrExportSymbol.flags & 32 /* Class */ ) {
                if (isClassLike(declaration) && declaration.name !== node) {
                    let container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    while(container.kind !== 308 /* SourceFile */  && container.parent !== declaration)container = getThisContainer(container, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    if (container.kind !== 308 /* SourceFile */ ) {
                        getNodeLinks(declaration).flags |= 262144 /* ContainsConstructorReference */ ;
                        getNodeLinks(container).flags |= 262144 /* ContainsConstructorReference */ ;
                        getNodeLinks(node).flags |= 536870912 /* ConstructorReference */ ;
                    }
                }
            }
            checkNestedBlockScopedBinding(node, symbol);
        }
        function checkIdentifier(node, checkMode) {
            if (isThisInTypeQuery(node)) return checkThisExpression(node);
            const symbol = getResolvedSymbol(node);
            if (symbol === unknownSymbol) return errorType;
            checkIdentifierCalculateNodeCheckFlags(node, symbol);
            if (symbol === argumentsSymbol) {
                if (isInPropertyInitializerOrClassStaticBlock(node)) return errorType;
                return getTypeOfSymbol(symbol);
            }
            if (shouldMarkIdentifierAliasReferenced(node)) markLinkedReferences(node, 1 /* Identifier */ );
            const localOrExportSymbol = getExportSymbolOfValueSymbolIfExported(symbol);
            let declaration = localOrExportSymbol.valueDeclaration;
            const immediateDeclaration = declaration;
            if (declaration && declaration.kind === 209 /* BindingElement */  && contains(contextualBindingPatterns, declaration.parent) && findAncestor(node, (parent2)=>parent2 === declaration.parent)) return nonInferrableAnyType;
            let type = getNarrowedTypeOfSymbol(localOrExportSymbol, node);
            const assignmentKind = getAssignmentTargetKind(node);
            if (assignmentKind) {
                if (!(localOrExportSymbol.flags & 3 /* Variable */ ) && !(isInJSFile(node) && localOrExportSymbol.flags & 512 /* ValueModule */ )) {
                    const assignmentError = localOrExportSymbol.flags & 384 /* Enum */  ? Diagnostics.Cannot_assign_to_0_because_it_is_an_enum : localOrExportSymbol.flags & 32 /* Class */  ? Diagnostics.Cannot_assign_to_0_because_it_is_a_class : localOrExportSymbol.flags & 1536 /* Module */  ? Diagnostics.Cannot_assign_to_0_because_it_is_a_namespace : localOrExportSymbol.flags & 16 /* Function */  ? Diagnostics.Cannot_assign_to_0_because_it_is_a_function : localOrExportSymbol.flags & 2097152 /* Alias */  ? Diagnostics.Cannot_assign_to_0_because_it_is_an_import : Diagnostics.Cannot_assign_to_0_because_it_is_not_a_variable;
                    error2(node, assignmentError, symbolToString(symbol));
                    return errorType;
                }
                if (isReadonlySymbol(localOrExportSymbol)) {
                    if (localOrExportSymbol.flags & 3 /* Variable */ ) error2(node, Diagnostics.Cannot_assign_to_0_because_it_is_a_constant, symbolToString(symbol));
                    else error2(node, Diagnostics.Cannot_assign_to_0_because_it_is_a_read_only_property, symbolToString(symbol));
                    return errorType;
                }
            }
            const isAlias = localOrExportSymbol.flags & 2097152 /* Alias */ ;
            if (localOrExportSymbol.flags & 3 /* Variable */ ) {
                if (assignmentKind === 1 /* Definite */ ) return isInCompoundLikeAssignment(node) ? getBaseTypeOfLiteralType(type) : type;
            } else if (isAlias) declaration = getDeclarationOfAliasSymbol(symbol);
            else return type;
            if (!declaration) return type;
            type = getNarrowableTypeForReference(type, node, checkMode);
            const isParameter2 = getRootDeclaration(declaration).kind === 170 /* Parameter */ ;
            const declarationContainer = getControlFlowContainer(declaration);
            let flowContainer = getControlFlowContainer(node);
            const isOuterVariable = flowContainer !== declarationContainer;
            const isSpreadDestructuringAssignmentTarget = node.parent && node.parent.parent && isSpreadAssignment(node.parent) && isDestructuringAssignmentTarget(node.parent.parent);
            const isModuleExports = symbol.flags & 134217728 /* ModuleExports */ ;
            const typeIsAutomatic = type === autoType || type === autoArrayType;
            const isAutomaticTypeInNonNull = typeIsAutomatic && node.parent.kind === 236 /* NonNullExpression */ ;
            while(flowContainer !== declarationContainer && (flowContainer.kind === 219 /* FunctionExpression */  || flowContainer.kind === 220 /* ArrowFunction */  || isObjectLiteralOrClassExpressionMethodOrAccessor(flowContainer)) && (isConstantVariable(localOrExportSymbol) && type !== autoArrayType || isParameterOrMutableLocalVariable(localOrExportSymbol) && isPastLastAssignment(localOrExportSymbol, node)))flowContainer = getControlFlowContainer(flowContainer);
            const isNeverInitialized = immediateDeclaration && isVariableDeclaration(immediateDeclaration) && !immediateDeclaration.initializer && !immediateDeclaration.exclamationToken && isMutableLocalVariableDeclaration(immediateDeclaration) && !isSymbolAssignedDefinitely(symbol);
            const assumeInitialized = isParameter2 || isAlias || isOuterVariable && !isNeverInitialized || isSpreadDestructuringAssignmentTarget || isModuleExports || isSameScopedBindingElement(node, declaration) || type !== autoType && type !== autoArrayType && (!strictNullChecks || (type.flags & 16387 /* Void */ ) !== 0 || isInTypeQuery(node) || isInAmbientOrTypeNode(node) || node.parent.kind === 282 /* ExportSpecifier */ ) || node.parent.kind === 236 /* NonNullExpression */  || declaration.kind === 261 /* VariableDeclaration */  && declaration.exclamationToken || declaration.flags & 33554432 /* Ambient */ ;
            const initialType = isAutomaticTypeInNonNull ? undefinedType : assumeInitialized ? isParameter2 ? removeOptionalityFromDeclaredType(type, declaration) : type : typeIsAutomatic ? undefinedType : getOptionalType(type);
            const flowType = isAutomaticTypeInNonNull ? getNonNullableType(getFlowTypeOfReference(node, type, initialType, flowContainer)) : getFlowTypeOfReference(node, type, initialType, flowContainer);
            if (!isEvolvingArrayOperationTarget(node) && (type === autoType || type === autoArrayType)) {
                if (flowType === autoType || flowType === autoArrayType) {
                    if (noImplicitAny) {
                        error2(getNameOfDeclaration(declaration), Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined, symbolToString(symbol), typeToString(flowType));
                        error2(node, Diagnostics.Variable_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
                    }
                    return convertAutoToAny(flowType);
                }
            } else if (!assumeInitialized && !containsUndefinedType(type) && containsUndefinedType(flowType)) {
                error2(node, Diagnostics.Variable_0_is_used_before_being_assigned, symbolToString(symbol));
                return type;
            }
            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
        }
        function isSameScopedBindingElement(node, declaration) {
            if (isBindingElement(declaration)) {
                const bindingElement = findAncestor(node, isBindingElement);
                return bindingElement && getRootDeclaration(bindingElement) === getRootDeclaration(declaration);
            }
        }
        function shouldMarkIdentifierAliasReferenced(node) {
            var _a;
            const parent2 = node.parent;
            if (parent2) {
                if (isPropertyAccessExpression(parent2) && parent2.expression === node) return false;
                if (isExportSpecifier(parent2) && parent2.isTypeOnly) return false;
                const greatGrandparent = (_a = parent2.parent) == null ? void 0 : _a.parent;
                if (greatGrandparent && isExportDeclaration(greatGrandparent) && greatGrandparent.isTypeOnly) return false;
            }
            return true;
        }
        function isInsideFunctionOrInstancePropertyInitializer(node, threshold) {
            return !!findAncestor(node, (n)=>n === threshold ? "quit" : isFunctionLike(n) || n.parent && isPropertyDeclaration(n.parent) && !hasStaticModifier(n.parent) && n.parent.initializer === n);
        }
        function getPartOfForStatementContainingNode(node, container) {
            return findAncestor(node, (n)=>n === container ? "quit" : n === container.initializer || n === container.condition || n === container.incrementor || n === container.statement);
        }
        function getEnclosingIterationStatement(node) {
            return findAncestor(node, (n)=>!n || nodeStartsNewLexicalEnvironment(n) ? "quit" : isIterationStatement(n, /*lookInLabeledStatements*/ false));
        }
        function checkNestedBlockScopedBinding(node, symbol) {
            if (languageVersion >= 2 /* ES2015 */  || (symbol.flags & 34 /* Class */ ) === 0 || !symbol.valueDeclaration || isSourceFile(symbol.valueDeclaration) || symbol.valueDeclaration.parent.kind === 300 /* CatchClause */ ) return;
            const container = getEnclosingBlockScopeContainer(symbol.valueDeclaration);
            const isCaptured = isInsideFunctionOrInstancePropertyInitializer(node, container);
            const enclosingIterationStatement = getEnclosingIterationStatement(container);
            if (enclosingIterationStatement) {
                if (isCaptured) {
                    let capturesBlockScopeBindingInLoopBody = true;
                    if (isForStatement(container)) {
                        const varDeclList = getAncestor(symbol.valueDeclaration, 262 /* VariableDeclarationList */ );
                        if (varDeclList && varDeclList.parent === container) {
                            const part = getPartOfForStatementContainingNode(node.parent, container);
                            if (part) {
                                const links = getNodeLinks(part);
                                links.flags |= 8192 /* ContainsCapturedBlockScopeBinding */ ;
                                const capturedBindings = links.capturedBlockScopeBindings || (links.capturedBlockScopeBindings = []);
                                pushIfUnique(capturedBindings, symbol);
                                if (part === container.initializer) capturesBlockScopeBindingInLoopBody = false;
                            }
                        }
                    }
                    if (capturesBlockScopeBindingInLoopBody) getNodeLinks(enclosingIterationStatement).flags |= 4096 /* LoopWithCapturedBlockScopedBinding */ ;
                }
                if (isForStatement(container)) {
                    const varDeclList = getAncestor(symbol.valueDeclaration, 262 /* VariableDeclarationList */ );
                    if (varDeclList && varDeclList.parent === container && isAssignedInBodyOfForStatement(node, container)) getNodeLinks(symbol.valueDeclaration).flags |= 65536 /* NeedsLoopOutParameter */ ;
                }
                getNodeLinks(symbol.valueDeclaration).flags |= 32768 /* BlockScopedBindingInLoop */ ;
            }
            if (isCaptured) getNodeLinks(symbol.valueDeclaration).flags |= 16384 /* CapturedBlockScopedBinding */ ;
        }
        function isBindingCapturedByNode(node, decl) {
            const links = getNodeLinks(node);
            return !!links && contains(links.capturedBlockScopeBindings, getSymbolOfDeclaration(decl));
        }
        function isAssignedInBodyOfForStatement(node, container) {
            let current = node;
            while(current.parent.kind === 218 /* ParenthesizedExpression */ )current = current.parent;
            let isAssigned = false;
            if (isAssignmentTarget(current)) isAssigned = true;
            else if (current.parent.kind === 225 /* PrefixUnaryExpression */  || current.parent.kind === 226 /* PostfixUnaryExpression */ ) {
                const expr = current.parent;
                isAssigned = expr.operator === 46 /* PlusPlusToken */  || expr.operator === 47 /* MinusMinusToken */ ;
            }
            if (!isAssigned) return false;
            return !!findAncestor(current, (n)=>n === container ? "quit" : n === container.statement);
        }
        function captureLexicalThis(node, container) {
            getNodeLinks(node).flags |= 2 /* LexicalThis */ ;
            if (container.kind === 173 /* PropertyDeclaration */  || container.kind === 177 /* Constructor */ ) {
                const classNode = container.parent;
                getNodeLinks(classNode).flags |= 4 /* CaptureThis */ ;
            } else getNodeLinks(container).flags |= 4 /* CaptureThis */ ;
        }
        function findFirstSuperCall(node) {
            return isSuperCall(node) ? node : isFunctionLike(node) ? void 0 : forEachChild(node, findFirstSuperCall);
        }
        function classDeclarationExtendsNull(classDecl) {
            const classSymbol = getSymbolOfDeclaration(classDecl);
            const classInstanceType = getDeclaredTypeOfSymbol(classSymbol);
            const baseConstructorType = getBaseConstructorTypeOfClass(classInstanceType);
            return baseConstructorType === nullWideningType;
        }
        function checkThisBeforeSuper(node, container, diagnosticMessage) {
            const containingClassDecl = container.parent;
            const baseTypeNode = getClassExtendsHeritageElement(containingClassDecl);
            if (baseTypeNode && !classDeclarationExtendsNull(containingClassDecl)) {
                if (canHaveFlowNode(node) && node.flowNode && !isPostSuperFlowNode(node.flowNode, /*noCacheCheck*/ false)) error2(node, diagnosticMessage);
            }
        }
        function checkThisInStaticClassFieldInitializerInDecoratedClass(thisExpression, container) {
            if (isPropertyDeclaration(container) && hasStaticModifier(container) && legacyDecorators && container.initializer && textRangeContainsPositionInclusive(container.initializer, thisExpression.pos) && hasDecorators(container.parent)) error2(thisExpression, Diagnostics.Cannot_use_this_in_a_static_property_initializer_of_a_decorated_class);
        }
        function checkThisExpression(node) {
            const isNodeInTypeQuery = isInTypeQuery(node);
            let container = getThisContainer(node, /*includeArrowFunctions*/ true, /*includeClassComputedPropertyName*/ true);
            let capturedByArrowFunction = false;
            let thisInComputedPropertyName = false;
            if (container.kind === 177 /* Constructor */ ) checkThisBeforeSuper(node, container, Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class);
            while(true){
                if (container.kind === 220 /* ArrowFunction */ ) {
                    container = getThisContainer(container, /*includeArrowFunctions*/ false, !thisInComputedPropertyName);
                    capturedByArrowFunction = true;
                }
                if (container.kind === 168 /* ComputedPropertyName */ ) {
                    container = getThisContainer(container, !capturedByArrowFunction, /*includeClassComputedPropertyName*/ false);
                    thisInComputedPropertyName = true;
                    continue;
                }
                break;
            }
            checkThisInStaticClassFieldInitializerInDecoratedClass(node, container);
            if (thisInComputedPropertyName) error2(node, Diagnostics.this_cannot_be_referenced_in_a_computed_property_name);
            else switch(container.kind){
                case 268 /* ModuleDeclaration */ :
                    error2(node, Diagnostics.this_cannot_be_referenced_in_a_module_or_namespace_body);
                    break;
                case 267 /* EnumDeclaration */ :
                    error2(node, Diagnostics.this_cannot_be_referenced_in_current_location);
                    break;
            }
            if (!isNodeInTypeQuery && capturedByArrowFunction && languageVersion < 2 /* ES2015 */ ) captureLexicalThis(node, container);
            const type = tryGetThisTypeAt(node, /*includeGlobalThis*/ true, container);
            if (noImplicitThis) {
                const globalThisType2 = getTypeOfSymbol(globalThisSymbol);
                if (type === globalThisType2 && capturedByArrowFunction) error2(node, Diagnostics.The_containing_arrow_function_captures_the_global_value_of_this);
                else if (!type) {
                    const diag2 = error2(node, Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation);
                    if (!isSourceFile(container)) {
                        const outsideThis = tryGetThisTypeAt(container);
                        if (outsideThis && outsideThis !== globalThisType2) addRelatedInfo(diag2, createDiagnosticForNode(container, Diagnostics.An_outer_value_of_this_is_shadowed_by_this_container));
                    }
                }
            }
            return type || anyType;
        }
        function tryGetThisTypeAt(node, includeGlobalThis = true, container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false)) {
            const isInJS = isInJSFile(node);
            if (isFunctionLike(container) && (!isInParameterInitializerBeforeContainingFunction(node) || getThisParameter(container))) {
                let thisType = getThisTypeOfDeclaration(container) || isInJS && getTypeForThisExpressionFromJSDoc(container);
                if (!thisType) {
                    const className = getClassNameFromPrototypeMethod(container);
                    if (isInJS && className) {
                        const classSymbol = checkExpression(className).symbol;
                        if (classSymbol && classSymbol.members && classSymbol.flags & 16 /* Function */ ) thisType = getDeclaredTypeOfSymbol(classSymbol).thisType;
                    } else if (isJSConstructor(container)) thisType = getDeclaredTypeOfSymbol(getMergedSymbol(container.symbol)).thisType;
                    thisType || (thisType = getContextualThisParameterType(container));
                }
                if (thisType) return getFlowTypeOfReference(node, thisType);
            }
            if (isClassLike(container.parent)) {
                const symbol = getSymbolOfDeclaration(container.parent);
                const type = isStatic(container) ? getTypeOfSymbol(symbol) : getDeclaredTypeOfSymbol(symbol).thisType;
                return getFlowTypeOfReference(node, type);
            }
            if (isSourceFile(container)) {
                if (container.commonJsModuleIndicator) {
                    const fileSymbol = getSymbolOfDeclaration(container);
                    return fileSymbol && getTypeOfSymbol(fileSymbol);
                } else if (container.externalModuleIndicator) return undefinedType;
                else if (includeGlobalThis) return getTypeOfSymbol(globalThisSymbol);
            }
        }
        function getExplicitThisType(node) {
            const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            if (isFunctionLike(container)) {
                const signature = getSignatureFromDeclaration(container);
                if (signature.thisParameter) return getExplicitTypeOfSymbol(signature.thisParameter);
            }
            if (isClassLike(container.parent)) {
                const symbol = getSymbolOfDeclaration(container.parent);
                return isStatic(container) ? getTypeOfSymbol(symbol) : getDeclaredTypeOfSymbol(symbol).thisType;
            }
        }
        function getClassNameFromPrototypeMethod(container) {
            if (container.kind === 219 /* FunctionExpression */  && isBinaryExpression(container.parent) && getAssignmentDeclarationKind(container.parent) === 3 /* PrototypeProperty */ ) return container.parent.left.expression.expression;
            else if (container.kind === 175 /* MethodDeclaration */  && container.parent.kind === 211 /* ObjectLiteralExpression */  && isBinaryExpression(container.parent.parent) && getAssignmentDeclarationKind(container.parent.parent) === 6 /* Prototype */ ) return container.parent.parent.left.expression;
            else if (container.kind === 219 /* FunctionExpression */  && container.parent.kind === 304 /* PropertyAssignment */  && container.parent.parent.kind === 211 /* ObjectLiteralExpression */  && isBinaryExpression(container.parent.parent.parent) && getAssignmentDeclarationKind(container.parent.parent.parent) === 6 /* Prototype */ ) return container.parent.parent.parent.left.expression;
            else if (container.kind === 219 /* FunctionExpression */  && isPropertyAssignment(container.parent) && isIdentifier(container.parent.name) && (container.parent.name.escapedText === "value" || container.parent.name.escapedText === "get" || container.parent.name.escapedText === "set") && isObjectLiteralExpression(container.parent.parent) && isCallExpression(container.parent.parent.parent) && container.parent.parent.parent.arguments[2] === container.parent.parent && getAssignmentDeclarationKind(container.parent.parent.parent) === 9 /* ObjectDefinePrototypeProperty */ ) return container.parent.parent.parent.arguments[0].expression;
            else if (isMethodDeclaration(container) && isIdentifier(container.name) && (container.name.escapedText === "value" || container.name.escapedText === "get" || container.name.escapedText === "set") && isObjectLiteralExpression(container.parent) && isCallExpression(container.parent.parent) && container.parent.parent.arguments[2] === container.parent && getAssignmentDeclarationKind(container.parent.parent) === 9 /* ObjectDefinePrototypeProperty */ ) return container.parent.parent.arguments[0].expression;
        }
        function getTypeForThisExpressionFromJSDoc(node) {
            const thisTag = getJSDocThisTag(node);
            if (thisTag && thisTag.typeExpression) return getTypeFromTypeNode(thisTag.typeExpression);
            const signature = getSignatureOfTypeTag(node);
            if (signature) return getThisTypeOfSignature(signature);
        }
        function isInConstructorArgumentInitializer(node, constructorDecl) {
            return !!findAncestor(node, (n)=>isFunctionLikeDeclaration(n) ? "quit" : n.kind === 170 /* Parameter */  && n.parent === constructorDecl);
        }
        function checkSuperExpression(node) {
            const isCallExpression2 = node.parent.kind === 214 /* CallExpression */  && node.parent.expression === node;
            const immediateContainer = getSuperContainer(node, /*stopOnFunctions*/ true);
            let container = immediateContainer;
            let needToCaptureLexicalThis = false;
            let inAsyncFunction = false;
            if (!isCallExpression2) {
                while(container && container.kind === 220 /* ArrowFunction */ ){
                    if (hasSyntacticModifier(container, 1024 /* Async */ )) inAsyncFunction = true;
                    container = getSuperContainer(container, /*stopOnFunctions*/ true);
                    needToCaptureLexicalThis = languageVersion < 2 /* ES2015 */ ;
                }
                if (container && hasSyntacticModifier(container, 1024 /* Async */ )) inAsyncFunction = true;
            }
            let nodeCheckFlag = 0;
            if (!container || !isLegalUsageOfSuperExpression(container)) {
                const current = findAncestor(node, (n)=>n === container ? "quit" : n.kind === 168 /* ComputedPropertyName */ );
                if (current && current.kind === 168 /* ComputedPropertyName */ ) error2(node, Diagnostics.super_cannot_be_referenced_in_a_computed_property_name);
                else if (isCallExpression2) error2(node, Diagnostics.Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors);
                else if (!container || !container.parent || !(isClassLike(container.parent) || container.parent.kind === 211 /* ObjectLiteralExpression */ )) error2(node, Diagnostics.super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions);
                else error2(node, Diagnostics.super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class);
                return errorType;
            }
            if (!isCallExpression2 && immediateContainer.kind === 177 /* Constructor */ ) checkThisBeforeSuper(node, container, Diagnostics.super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class);
            if (isStatic(container) || isCallExpression2) {
                nodeCheckFlag = 32 /* SuperStatic */ ;
                if (!isCallExpression2 && languageVersion >= 2 /* ES2015 */  && languageVersion <= 8 /* ES2021 */  && (isPropertyDeclaration(container) || isClassStaticBlockDeclaration(container))) forEachEnclosingBlockScopeContainer(node.parent, (current)=>{
                    if (!isSourceFile(current) || isExternalOrCommonJsModule(current)) getNodeLinks(current).flags |= 2097152 /* ContainsSuperPropertyInStaticInitializer */ ;
                });
            } else nodeCheckFlag = 16 /* SuperInstance */ ;
            getNodeLinks(node).flags |= nodeCheckFlag;
            if (container.kind === 175 /* MethodDeclaration */  && inAsyncFunction) {
                if (isSuperProperty(node.parent) && isAssignmentTarget(node.parent)) getNodeLinks(container).flags |= 256 /* MethodWithSuperPropertyAssignmentInAsync */ ;
                else getNodeLinks(container).flags |= 128 /* MethodWithSuperPropertyAccessInAsync */ ;
            }
            if (needToCaptureLexicalThis) captureLexicalThis(node.parent, container);
            if (container.parent.kind === 211 /* ObjectLiteralExpression */ ) {
                if (languageVersion < 2 /* ES2015 */ ) {
                    error2(node, Diagnostics.super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher);
                    return errorType;
                } else return anyType;
            }
            const classLikeDeclaration = container.parent;
            if (!getClassExtendsHeritageElement(classLikeDeclaration)) {
                error2(node, Diagnostics.super_can_only_be_referenced_in_a_derived_class);
                return errorType;
            }
            if (classDeclarationExtendsNull(classLikeDeclaration)) return isCallExpression2 ? errorType : nullWideningType;
            const classType = getDeclaredTypeOfSymbol(getSymbolOfDeclaration(classLikeDeclaration));
            const baseClassType = classType && getBaseTypes(classType)[0];
            if (!baseClassType) return errorType;
            if (container.kind === 177 /* Constructor */  && isInConstructorArgumentInitializer(node, container)) {
                error2(node, Diagnostics.super_cannot_be_referenced_in_constructor_arguments);
                return errorType;
            }
            return nodeCheckFlag === 32 /* SuperStatic */  ? getBaseConstructorTypeOfClass(classType) : getTypeWithThisArgument(baseClassType, classType.thisType);
            function isLegalUsageOfSuperExpression(container2) {
                if (isCallExpression2) return container2.kind === 177 /* Constructor */ ;
                else if (isClassLike(container2.parent) || container2.parent.kind === 211 /* ObjectLiteralExpression */ ) {
                    if (isStatic(container2)) return container2.kind === 175 /* MethodDeclaration */  || container2.kind === 174 /* MethodSignature */  || container2.kind === 178 /* GetAccessor */  || container2.kind === 179 /* SetAccessor */  || container2.kind === 173 /* PropertyDeclaration */  || container2.kind === 176 /* ClassStaticBlockDeclaration */ ;
                    else return container2.kind === 175 /* MethodDeclaration */  || container2.kind === 174 /* MethodSignature */  || container2.kind === 178 /* GetAccessor */  || container2.kind === 179 /* SetAccessor */  || container2.kind === 173 /* PropertyDeclaration */  || container2.kind === 172 /* PropertySignature */  || container2.kind === 177 /* Constructor */ ;
                }
                return false;
            }
        }
        function getContainingObjectLiteral(func) {
            return (func.kind === 175 /* MethodDeclaration */  || func.kind === 178 /* GetAccessor */  || func.kind === 179 /* SetAccessor */ ) && func.parent.kind === 211 /* ObjectLiteralExpression */  ? func.parent : func.kind === 219 /* FunctionExpression */  && func.parent.kind === 304 /* PropertyAssignment */  ? func.parent.parent : void 0;
        }
        function getThisTypeArgument(type) {
            return getObjectFlags(type) & 4 /* Reference */  && type.target === globalThisType ? getTypeArguments(type)[0] : void 0;
        }
        function getThisTypeFromContextualType(type) {
            return mapType(type, (t)=>{
                return t.flags & 2097152 /* Intersection */  ? forEach(t.types, getThisTypeArgument) : getThisTypeArgument(t);
            });
        }
        function getThisTypeOfObjectLiteralFromContextualType(containingLiteral, contextualType) {
            let literal = containingLiteral;
            let type = contextualType;
            while(type){
                const thisType = getThisTypeFromContextualType(type);
                if (thisType) return thisType;
                if (literal.parent.kind !== 304 /* PropertyAssignment */ ) break;
                literal = literal.parent.parent;
                type = getApparentTypeOfContextualType(literal, /*contextFlags*/ void 0);
            }
        }
        function getContextualThisParameterType(func) {
            if (func.kind === 220 /* ArrowFunction */ ) return void 0;
            if (isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
                const contextualSignature = getContextualSignature(func);
                if (contextualSignature) {
                    const thisParameter = contextualSignature.thisParameter;
                    if (thisParameter) return getTypeOfSymbol(thisParameter);
                }
            }
            const inJs = isInJSFile(func);
            if (noImplicitThis || inJs) {
                const containingLiteral = getContainingObjectLiteral(func);
                if (containingLiteral) {
                    const contextualType = getApparentTypeOfContextualType(containingLiteral, /*contextFlags*/ void 0);
                    const thisType = getThisTypeOfObjectLiteralFromContextualType(containingLiteral, contextualType);
                    if (thisType) return instantiateType(thisType, getMapperFromContext(getInferenceContext(containingLiteral)));
                    return getWidenedType(contextualType ? getNonNullableType(contextualType) : checkExpressionCached(containingLiteral));
                }
                const parent2 = walkUpParenthesizedExpressions(func.parent);
                if (isAssignmentExpression(parent2)) {
                    const target = parent2.left;
                    if (isAccessExpression(target)) {
                        const { expression } = target;
                        if (inJs && isIdentifier(expression)) {
                            const sourceFile = getSourceFileOfNode(parent2);
                            if (sourceFile.commonJsModuleIndicator && getResolvedSymbol(expression) === sourceFile.symbol) return void 0;
                        }
                        return getWidenedType(checkExpressionCached(expression));
                    }
                }
            }
            return void 0;
        }
        function getContextuallyTypedParameterType(parameter) {
            const func = parameter.parent;
            if (!isContextSensitiveFunctionOrObjectLiteralMethod(func)) return void 0;
            const iife = getImmediatelyInvokedFunctionExpression(func);
            if (iife && iife.arguments) {
                const args = getEffectiveCallArguments(iife);
                const indexOfParameter = func.parameters.indexOf(parameter);
                if (parameter.dotDotDotToken) return getSpreadArgumentType(args, indexOfParameter, args.length, anyType, /*context*/ void 0, 0 /* Normal */ );
                const links = getNodeLinks(iife);
                const cached = links.resolvedSignature;
                links.resolvedSignature = anySignature;
                const type = indexOfParameter < args.length ? getWidenedLiteralType(checkExpression(args[indexOfParameter])) : parameter.initializer ? void 0 : undefinedWideningType;
                links.resolvedSignature = cached;
                return type;
            }
            const contextualSignature = getContextualSignature(func);
            if (contextualSignature) {
                const index = func.parameters.indexOf(parameter) - (getThisParameter(func) ? 1 : 0);
                return parameter.dotDotDotToken && lastOrUndefined(func.parameters) === parameter ? getRestTypeAtPosition(contextualSignature, index) : tryGetTypeAtPosition(contextualSignature, index);
            }
        }
        function getContextualTypeForVariableLikeDeclaration(declaration, contextFlags) {
            const typeNode = getEffectiveTypeAnnotationNode(declaration) || (isInJSFile(declaration) ? tryGetJSDocSatisfiesTypeNode(declaration) : void 0);
            if (typeNode) return getTypeFromTypeNode(typeNode);
            switch(declaration.kind){
                case 170 /* Parameter */ :
                    return getContextuallyTypedParameterType(declaration);
                case 209 /* BindingElement */ :
                    return getContextualTypeForBindingElement(declaration, contextFlags);
                case 173 /* PropertyDeclaration */ :
                    if (isStatic(declaration)) return getContextualTypeForStaticPropertyDeclaration(declaration, contextFlags);
            }
        }
        function getContextualTypeForBindingElement(declaration, contextFlags) {
            const parent2 = declaration.parent.parent;
            const name = declaration.propertyName || declaration.name;
            const parentType = getContextualTypeForVariableLikeDeclaration(parent2, contextFlags) || parent2.kind !== 209 /* BindingElement */  && parent2.initializer && checkDeclarationInitializer(parent2, declaration.dotDotDotToken ? 32 /* RestBindingElement */  : 0 /* Normal */ );
            if (!parentType || isBindingPattern(name) || isComputedNonLiteralName(name)) return void 0;
            if (parent2.name.kind === 208 /* ArrayBindingPattern */ ) {
                const index = indexOfNode(declaration.parent.elements, declaration);
                if (index < 0) return void 0;
                return getContextualTypeForElementExpression(parentType, index);
            }
            const nameType = getLiteralTypeFromPropertyName(name);
            if (isTypeUsableAsPropertyName(nameType)) {
                const text = getPropertyNameFromType(nameType);
                return getTypeOfPropertyOfType(parentType, text);
            }
        }
        function getContextualTypeForStaticPropertyDeclaration(declaration, contextFlags) {
            const parentType = isExpression(declaration.parent) && getContextualType2(declaration.parent, contextFlags);
            if (!parentType) return void 0;
            return getTypeOfPropertyOfContextualType(parentType, getSymbolOfDeclaration(declaration).escapedName);
        }
        function getContextualTypeForInitializerExpression(node, contextFlags) {
            const declaration = node.parent;
            if (hasInitializer(declaration) && node === declaration.initializer) {
                const result = getContextualTypeForVariableLikeDeclaration(declaration, contextFlags);
                if (result) return result;
                if (!(contextFlags & 8 /* SkipBindingPatterns */ ) && isBindingPattern(declaration.name) && declaration.name.elements.length > 0) return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ true, /*reportErrors*/ false);
            }
            return void 0;
        }
        function getContextualTypeForReturnExpression(node, contextFlags) {
            const func = getContainingFunction(node);
            if (func) {
                let contextualReturnType = getContextualReturnType(func, contextFlags);
                if (contextualReturnType) {
                    const functionFlags = getFunctionFlags(func);
                    if (functionFlags & 1 /* Generator */ ) {
                        const isAsyncGenerator = (functionFlags & 2 /* Async */ ) !== 0;
                        if (contextualReturnType.flags & 1048576 /* Union */ ) contextualReturnType = filterType(contextualReturnType, (type)=>!!getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , type, isAsyncGenerator));
                        const iterationReturnType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , contextualReturnType, (functionFlags & 2 /* Async */ ) !== 0);
                        if (!iterationReturnType) return void 0;
                        contextualReturnType = iterationReturnType;
                    }
                    if (functionFlags & 2 /* Async */ ) {
                        const contextualAwaitedType = mapType(contextualReturnType, getAwaitedTypeNoAlias);
                        return contextualAwaitedType && getUnionType([
                            contextualAwaitedType,
                            createPromiseLikeType(contextualAwaitedType)
                        ]);
                    }
                    return contextualReturnType;
                }
            }
            return void 0;
        }
        function getContextualTypeForAwaitOperand(node, contextFlags) {
            const contextualType = getContextualType2(node, contextFlags);
            if (contextualType) {
                const contextualAwaitedType = getAwaitedTypeNoAlias(contextualType);
                return contextualAwaitedType && getUnionType([
                    contextualAwaitedType,
                    createPromiseLikeType(contextualAwaitedType)
                ]);
            }
            return void 0;
        }
        function getContextualTypeForYieldOperand(node, contextFlags) {
            const func = getContainingFunction(node);
            if (func) {
                const functionFlags = getFunctionFlags(func);
                let contextualReturnType = getContextualReturnType(func, contextFlags);
                if (contextualReturnType) {
                    const isAsyncGenerator = (functionFlags & 2 /* Async */ ) !== 0;
                    if (!node.asteriskToken && contextualReturnType.flags & 1048576 /* Union */ ) contextualReturnType = filterType(contextualReturnType, (type)=>!!getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , type, isAsyncGenerator));
                    if (node.asteriskToken) {
                        const iterationTypes = getIterationTypesOfGeneratorFunctionReturnType(contextualReturnType, isAsyncGenerator);
                        var _ref;
                        const yieldType = (_ref = iterationTypes == null ? void 0 : iterationTypes.yieldType) !== null && _ref !== void 0 ? _ref : silentNeverType;
                        var _getContextualType2;
                        const returnType = (_getContextualType2 = getContextualType2(node, contextFlags)) !== null && _getContextualType2 !== void 0 ? _getContextualType2 : silentNeverType;
                        var _ref1;
                        const nextType = (_ref1 = iterationTypes == null ? void 0 : iterationTypes.nextType) !== null && _ref1 !== void 0 ? _ref1 : unknownType;
                        const generatorType = createGeneratorType(yieldType, returnType, nextType, /*isAsyncGenerator*/ false);
                        if (isAsyncGenerator) {
                            const asyncGeneratorType = createGeneratorType(yieldType, returnType, nextType, /*isAsyncGenerator*/ true);
                            return getUnionType([
                                generatorType,
                                asyncGeneratorType
                            ]);
                        }
                        return generatorType;
                    }
                    return getIterationTypeOfGeneratorFunctionReturnType(0 /* Yield */ , contextualReturnType, isAsyncGenerator);
                }
            }
            return void 0;
        }
        function isInParameterInitializerBeforeContainingFunction(node) {
            let inBindingInitializer = false;
            while(node.parent && !isFunctionLike(node.parent)){
                if (isParameter(node.parent) && (inBindingInitializer || node.parent.initializer === node)) return true;
                if (isBindingElement(node.parent) && node.parent.initializer === node) inBindingInitializer = true;
                node = node.parent;
            }
            return false;
        }
        function getContextualIterationType(kind, functionDecl) {
            const isAsync = !!(getFunctionFlags(functionDecl) & 2 /* Async */ );
            const contextualReturnType = getContextualReturnType(functionDecl, /*contextFlags*/ void 0);
            if (contextualReturnType) return getIterationTypeOfGeneratorFunctionReturnType(kind, contextualReturnType, isAsync) || void 0;
            return void 0;
        }
        function getContextualReturnType(functionDecl, contextFlags) {
            const returnType = getReturnTypeFromAnnotation(functionDecl);
            if (returnType) return returnType;
            const signature = getContextualSignatureForFunctionLikeDeclaration(functionDecl);
            if (signature && !isResolvingReturnTypeOfSignature(signature)) {
                const returnType2 = getReturnTypeOfSignature(signature);
                const functionFlags = getFunctionFlags(functionDecl);
                if (functionFlags & 1 /* Generator */ ) return filterType(returnType2, (t)=>{
                    return !!(t.flags & 58998787 /* InstantiableNonPrimitive */ ) || checkGeneratorInstantiationAssignabilityToReturnType(t, functionFlags, /*errorNode*/ void 0);
                });
                if (functionFlags & 2 /* Async */ ) return filterType(returnType2, (t)=>{
                    return !!(t.flags & 58998787 /* InstantiableNonPrimitive */ ) || !!getAwaitedTypeOfPromise(t);
                });
                return returnType2;
            }
            const iife = getImmediatelyInvokedFunctionExpression(functionDecl);
            if (iife) return getContextualType2(iife, contextFlags);
            return void 0;
        }
        function getContextualTypeForArgument(callTarget, arg) {
            const args = getEffectiveCallArguments(callTarget);
            const argIndex = args.indexOf(arg);
            return argIndex === -1 ? void 0 : getContextualTypeForArgumentAtIndex(callTarget, argIndex);
        }
        function getContextualTypeForArgumentAtIndex(callTarget, argIndex) {
            if (isImportCall(callTarget)) return argIndex === 0 ? stringType : argIndex === 1 ? getGlobalImportCallOptionsType(/*reportErrors*/ false) : anyType;
            const signature = getNodeLinks(callTarget).resolvedSignature === resolvingSignature ? resolvingSignature : getResolvedSignature(callTarget);
            if (isJsxOpeningLikeElement(callTarget) && argIndex === 0) return getEffectiveFirstArgumentForJsxSignature(signature, callTarget);
            const restIndex = signature.parameters.length - 1;
            return signatureHasRestParameter(signature) && argIndex >= restIndex ? getIndexedAccessType(getTypeOfSymbol(signature.parameters[restIndex]), getNumberLiteralType(argIndex - restIndex), 256 /* Contextual */ ) : getTypeAtPosition(signature, argIndex);
        }
        function getContextualTypeForDecorator(decorator) {
            const signature = getDecoratorCallSignature(decorator);
            return signature ? getOrCreateTypeFromSignature(signature) : void 0;
        }
        function getContextualTypeForSubstitutionExpression(template, substitutionExpression) {
            if (template.parent.kind === 216 /* TaggedTemplateExpression */ ) return getContextualTypeForArgument(template.parent, substitutionExpression);
            return void 0;
        }
        function getContextualTypeForBinaryOperand(node, contextFlags) {
            const binaryExpression = node.parent;
            const { left, operatorToken, right } = binaryExpression;
            switch(operatorToken.kind){
                case 64 /* EqualsToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                case 76 /* BarBarEqualsToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                    return node === right ? getContextualTypeForAssignmentDeclaration(binaryExpression) : void 0;
                case 57 /* BarBarToken */ :
                case 61 /* QuestionQuestionToken */ :
                    const type = getContextualType2(binaryExpression, contextFlags);
                    return node === right && (type && type.pattern || !type && !isDefaultedExpandoInitializer(binaryExpression)) ? getTypeOfExpression(left) : type;
                case 56 /* AmpersandAmpersandToken */ :
                case 28 /* CommaToken */ :
                    return node === right ? getContextualType2(binaryExpression, contextFlags) : void 0;
                default:
                    return void 0;
            }
        }
        function getSymbolForExpression(e) {
            if (canHaveSymbol(e) && e.symbol) return e.symbol;
            if (isIdentifier(e)) return getResolvedSymbol(e);
            if (isPropertyAccessExpression(e)) {
                const lhsType = getTypeOfExpression(e.expression);
                return isPrivateIdentifier(e.name) ? tryGetPrivateIdentifierPropertyOfType(lhsType, e.name) : getPropertyOfType(lhsType, e.name.escapedText);
            }
            if (isElementAccessExpression(e)) {
                const propType = checkExpressionCached(e.argumentExpression);
                if (!isTypeUsableAsPropertyName(propType)) return void 0;
                const lhsType = getTypeOfExpression(e.expression);
                return getPropertyOfType(lhsType, getPropertyNameFromType(propType));
            }
            return void 0;
            function tryGetPrivateIdentifierPropertyOfType(type, id) {
                const lexicallyScopedSymbol = lookupSymbolForPrivateIdentifierDeclaration(id.escapedText, id);
                return lexicallyScopedSymbol && getPrivateIdentifierPropertyOfType(type, lexicallyScopedSymbol);
            }
        }
        function getContextualTypeForAssignmentDeclaration(binaryExpression) {
            var _a, _b;
            const kind = getAssignmentDeclarationKind(binaryExpression);
            switch(kind){
                case 0 /* None */ :
                case 4 /* ThisProperty */ :
                    const lhsSymbol = getSymbolForExpression(binaryExpression.left);
                    const decl = lhsSymbol && lhsSymbol.valueDeclaration;
                    if (decl && (isPropertyDeclaration(decl) || isPropertySignature(decl))) {
                        const overallAnnotation = getEffectiveTypeAnnotationNode(decl);
                        return overallAnnotation && instantiateType(getTypeFromTypeNode(overallAnnotation), getSymbolLinks(lhsSymbol).mapper) || (isPropertyDeclaration(decl) ? decl.initializer && getTypeOfExpression(binaryExpression.left) : void 0);
                    }
                    if (kind === 0 /* None */ ) return getTypeOfExpression(binaryExpression.left);
                    return getContextualTypeForThisPropertyAssignment(binaryExpression);
                case 5 /* Property */ :
                    if (isPossiblyAliasedThisProperty(binaryExpression, kind)) return getContextualTypeForThisPropertyAssignment(binaryExpression);
                    else if (!canHaveSymbol(binaryExpression.left) || !binaryExpression.left.symbol) return getTypeOfExpression(binaryExpression.left);
                    else {
                        const decl2 = binaryExpression.left.symbol.valueDeclaration;
                        if (!decl2) return void 0;
                        const lhs = cast(binaryExpression.left, isAccessExpression);
                        const overallAnnotation = getEffectiveTypeAnnotationNode(decl2);
                        if (overallAnnotation) return getTypeFromTypeNode(overallAnnotation);
                        else if (isIdentifier(lhs.expression)) {
                            const id = lhs.expression;
                            const parentSymbol = resolveName(id, id.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
                            if (parentSymbol) {
                                const annotated2 = parentSymbol.valueDeclaration && getEffectiveTypeAnnotationNode(parentSymbol.valueDeclaration);
                                if (annotated2) {
                                    const nameStr = getElementOrPropertyAccessName(lhs);
                                    if (nameStr !== void 0) return getTypeOfPropertyOfContextualType(getTypeFromTypeNode(annotated2), nameStr);
                                }
                                return void 0;
                            }
                        }
                        return isInJSFile(decl2) || decl2 === binaryExpression.left ? void 0 : getTypeOfExpression(binaryExpression.left);
                    }
                case 1 /* ExportsProperty */ :
                case 6 /* Prototype */ :
                case 3 /* PrototypeProperty */ :
                case 2 /* ModuleExports */ :
                    let valueDeclaration;
                    if (kind !== 2 /* ModuleExports */ ) valueDeclaration = canHaveSymbol(binaryExpression.left) ? (_a = binaryExpression.left.symbol) == null ? void 0 : _a.valueDeclaration : void 0;
                    valueDeclaration || (valueDeclaration = (_b = binaryExpression.symbol) == null ? void 0 : _b.valueDeclaration);
                    const annotated = valueDeclaration && getEffectiveTypeAnnotationNode(valueDeclaration);
                    return annotated ? getTypeFromTypeNode(annotated) : void 0;
                case 7 /* ObjectDefinePropertyValue */ :
                case 8 /* ObjectDefinePropertyExports */ :
                case 9 /* ObjectDefinePrototypeProperty */ :
                    return Debug.fail("Does not apply");
                default:
                    return Debug.assertNever(kind);
            }
        }
        function isPossiblyAliasedThisProperty(declaration, kind = getAssignmentDeclarationKind(declaration)) {
            if (kind === 4 /* ThisProperty */ ) return true;
            if (!isInJSFile(declaration) || kind !== 5 /* Property */  || !isIdentifier(declaration.left.expression)) return false;
            const name = declaration.left.expression.escapedText;
            const symbol = resolveName(declaration.left, name, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true, /*excludeGlobals*/ true);
            return isThisInitializedDeclaration(symbol == null ? void 0 : symbol.valueDeclaration);
        }
        function getContextualTypeForThisPropertyAssignment(binaryExpression) {
            if (!binaryExpression.symbol) return getTypeOfExpression(binaryExpression.left);
            if (binaryExpression.symbol.valueDeclaration) {
                const annotated = getEffectiveTypeAnnotationNode(binaryExpression.symbol.valueDeclaration);
                if (annotated) {
                    const type = getTypeFromTypeNode(annotated);
                    if (type) return type;
                }
            }
            const thisAccess = cast(binaryExpression.left, isAccessExpression);
            if (!isObjectLiteralMethod(getThisContainer(thisAccess.expression, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false))) return void 0;
            const thisType = checkThisExpression(thisAccess.expression);
            const nameStr = getElementOrPropertyAccessName(thisAccess);
            return nameStr !== void 0 && getTypeOfPropertyOfContextualType(thisType, nameStr) || void 0;
        }
        function isCircularMappedProperty(symbol) {
            return !!(getCheckFlags(symbol) & 262144 /* Mapped */  && !symbol.links.type && findResolutionCycleStartIndex(symbol, 0 /* Type */ ) >= 0);
        }
        function isExcludedMappedPropertyName(constraint, propertyNameType) {
            if (constraint.flags & 16777216 /* Conditional */ ) {
                const type = constraint;
                return !!(getReducedType(getTrueTypeFromConditionalType(type)).flags & 131072 /* Never */ ) && getActualTypeVariable(getFalseTypeFromConditionalType(type)) === getActualTypeVariable(type.checkType) && isTypeAssignableTo(propertyNameType, type.extendsType);
            }
            if (constraint.flags & 2097152 /* Intersection */ ) return some(constraint.types, (t)=>isExcludedMappedPropertyName(t, propertyNameType));
            return false;
        }
        function getTypeOfPropertyOfContextualType(type, name, nameType) {
            return mapType(type, (t)=>{
                if (t.flags & 2097152 /* Intersection */ ) {
                    let types;
                    let indexInfoCandidates;
                    let ignoreIndexInfos = false;
                    for (const constituentType of t.types){
                        if (!(constituentType.flags & 524288 /* Object */ )) continue;
                        if (isGenericMappedType(constituentType) && getMappedTypeNameTypeKind(constituentType) !== 2 /* Remapping */ ) {
                            const substitutedType = getIndexedMappedTypeSubstitutedTypeOfContextualType(constituentType, name, nameType);
                            types = appendContextualPropertyTypeConstituent(types, substitutedType);
                            continue;
                        }
                        const propertyType = getTypeOfConcretePropertyOfContextualType(constituentType, name);
                        if (!propertyType) {
                            if (!ignoreIndexInfos) indexInfoCandidates = append(indexInfoCandidates, constituentType);
                            continue;
                        }
                        ignoreIndexInfos = true;
                        indexInfoCandidates = void 0;
                        types = appendContextualPropertyTypeConstituent(types, propertyType);
                    }
                    if (indexInfoCandidates) for (const candidate of indexInfoCandidates){
                        const indexInfoType = getTypeFromIndexInfosOfContextualType(candidate, name, nameType);
                        types = appendContextualPropertyTypeConstituent(types, indexInfoType);
                    }
                    if (!types) return;
                    if (types.length === 1) return types[0];
                    return getIntersectionType(types);
                }
                if (!(t.flags & 524288 /* Object */ )) return;
                var _getTypeOfConcretePropertyOfContextualType;
                return isGenericMappedType(t) && getMappedTypeNameTypeKind(t) !== 2 /* Remapping */  ? getIndexedMappedTypeSubstitutedTypeOfContextualType(t, name, nameType) : (_getTypeOfConcretePropertyOfContextualType = getTypeOfConcretePropertyOfContextualType(t, name)) !== null && _getTypeOfConcretePropertyOfContextualType !== void 0 ? _getTypeOfConcretePropertyOfContextualType : getTypeFromIndexInfosOfContextualType(t, name, nameType);
            }, /*noReductions*/ true);
        }
        function appendContextualPropertyTypeConstituent(types, type) {
            return type ? append(types, type.flags & 1 /* Any */  ? unknownType : type) : types;
        }
        function getIndexedMappedTypeSubstitutedTypeOfContextualType(type, name, nameType) {
            const propertyNameType = nameType || getStringLiteralType(unescapeLeadingUnderscores(name));
            const constraint = getConstraintTypeFromMappedType(type);
            if (type.nameType && isExcludedMappedPropertyName(type.nameType, propertyNameType) || isExcludedMappedPropertyName(constraint, propertyNameType)) return;
            const constraintOfConstraint = getBaseConstraintOfType(constraint) || constraint;
            if (!isTypeAssignableTo(propertyNameType, constraintOfConstraint)) return;
            return substituteIndexedMappedType(type, propertyNameType);
        }
        function getTypeOfConcretePropertyOfContextualType(type, name) {
            const prop = getPropertyOfType(type, name);
            if (!prop || isCircularMappedProperty(prop)) return;
            return removeMissingType(getTypeOfSymbol(prop), !!(prop.flags & 16777216 /* Optional */ ));
        }
        function getTypeFromIndexInfosOfContextualType(type, name, nameType) {
            var _a;
            if (isTupleType(type) && isNumericLiteralName(name) && +name >= 0) {
                const restType = getElementTypeOfSliceOfTupleType(type, type.target.fixedLength, /*endSkipCount*/ 0, /*writing*/ false, /*noReductions*/ true);
                if (restType) return restType;
            }
            return (_a = findApplicableIndexInfo(getIndexInfosOfStructuredType(type), nameType || getStringLiteralType(unescapeLeadingUnderscores(name)))) == null ? void 0 : _a.type;
        }
        function getContextualTypeForObjectLiteralMethod(node, contextFlags) {
            Debug.assert(isObjectLiteralMethod(node));
            if (node.flags & 67108864 /* InWithStatement */ ) return void 0;
            return getContextualTypeForObjectLiteralElement(node, contextFlags);
        }
        function getContextualTypeForObjectLiteralElement(element, contextFlags) {
            const objectLiteral = element.parent;
            const propertyAssignmentType = isPropertyAssignment(element) && getContextualTypeForVariableLikeDeclaration(element, contextFlags);
            if (propertyAssignmentType) return propertyAssignmentType;
            const type = getApparentTypeOfContextualType(objectLiteral, contextFlags);
            if (type) {
                if (hasBindableName(element)) {
                    const symbol = getSymbolOfDeclaration(element);
                    return getTypeOfPropertyOfContextualType(type, symbol.escapedName, getSymbolLinks(symbol).nameType);
                }
                if (hasDynamicName(element)) {
                    const name = getNameOfDeclaration(element);
                    if (name && isComputedPropertyName(name)) {
                        const exprType = checkExpression(name.expression);
                        const propType = isTypeUsableAsPropertyName(exprType) && getTypeOfPropertyOfContextualType(type, getPropertyNameFromType(exprType));
                        if (propType) return propType;
                    }
                }
                if (element.name) {
                    const nameType = getLiteralTypeFromPropertyName(element.name);
                    return mapType(type, (t)=>{
                        var _a;
                        return (_a = findApplicableIndexInfo(getIndexInfosOfStructuredType(t), nameType)) == null ? void 0 : _a.type;
                    }, /*noReductions*/ true);
                }
            }
            return void 0;
        }
        function getSpreadIndices(elements) {
            let first2, last2;
            for(let i = 0; i < elements.length; i++)if (isSpreadElement(elements[i])) {
                first2 !== null && first2 !== void 0 ? first2 : first2 = i;
                last2 = i;
            }
            return {
                first: first2,
                last: last2
            };
        }
        function getContextualTypeForElementExpression(type, index, length2, firstSpreadIndex, lastSpreadIndex) {
            return type && mapType(type, (t)=>{
                if (isTupleType(t)) {
                    if ((firstSpreadIndex === void 0 || index < firstSpreadIndex) && index < t.target.fixedLength) return removeMissingType(getTypeArguments(t)[index], !!(t.target.elementFlags[index] && 2 /* Optional */ ));
                    const offset = length2 !== void 0 && (lastSpreadIndex === void 0 || index > lastSpreadIndex) ? length2 - index : 0;
                    const fixedEndLength = offset > 0 && t.target.combinedFlags & 12 /* Variable */  ? getEndElementCount(t.target, 3 /* Fixed */ ) : 0;
                    if (offset > 0 && offset <= fixedEndLength) return getTypeArguments(t)[getTypeReferenceArity(t) - offset];
                    return getElementTypeOfSliceOfTupleType(t, firstSpreadIndex === void 0 ? t.target.fixedLength : Math.min(t.target.fixedLength, firstSpreadIndex), length2 === void 0 || lastSpreadIndex === void 0 ? fixedEndLength : Math.min(fixedEndLength, length2 - lastSpreadIndex), /*writing*/ false, /*noReductions*/ true);
                }
                return (!firstSpreadIndex || index < firstSpreadIndex) && getTypeOfPropertyOfContextualType(t, "" + index) || getIteratedTypeOrElementType(1 /* Element */ , t, undefinedType, /*errorNode*/ void 0, /*checkAssignability*/ false);
            }, /*noReductions*/ true);
        }
        function getContextualTypeForConditionalOperand(node, contextFlags) {
            const conditional = node.parent;
            return node === conditional.whenTrue || node === conditional.whenFalse ? getContextualType2(conditional, contextFlags) : void 0;
        }
        function getContextualTypeForChildJsxExpression(node, child, contextFlags) {
            const attributesType = getApparentTypeOfContextualType(node.openingElement.attributes, contextFlags);
            const jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
            if (!(attributesType && !isTypeAny(attributesType) && jsxChildrenPropertyName && jsxChildrenPropertyName !== "")) return void 0;
            const realChildren = getSemanticJsxChildren(node.children);
            const childIndex = realChildren.indexOf(child);
            const childFieldType = getTypeOfPropertyOfContextualType(attributesType, jsxChildrenPropertyName);
            return childFieldType && (realChildren.length === 1 ? childFieldType : mapType(childFieldType, (t)=>{
                if (isArrayLikeType(t)) return getIndexedAccessType(t, getNumberLiteralType(childIndex));
                else return t;
            }, /*noReductions*/ true));
        }
        function getContextualTypeForJsxExpression(node, contextFlags) {
            const exprParent = node.parent;
            return isJsxAttributeLike(exprParent) ? getContextualType2(node, contextFlags) : isJsxElement(exprParent) ? getContextualTypeForChildJsxExpression(exprParent, node, contextFlags) : void 0;
        }
        function getContextualTypeForJsxAttribute(attribute, contextFlags) {
            if (isJsxAttribute(attribute)) {
                const attributesType = getApparentTypeOfContextualType(attribute.parent, contextFlags);
                if (!attributesType || isTypeAny(attributesType)) return void 0;
                return getTypeOfPropertyOfContextualType(attributesType, getEscapedTextOfJsxAttributeName(attribute.name));
            } else return getContextualType2(attribute.parent, contextFlags);
        }
        function isPossiblyDiscriminantValue(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 229 /* TemplateExpression */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                case 80 /* Identifier */ :
                case 157 /* UndefinedKeyword */ :
                    return true;
                case 212 /* PropertyAccessExpression */ :
                case 218 /* ParenthesizedExpression */ :
                    return isPossiblyDiscriminantValue(node.expression);
                case 295 /* JsxExpression */ :
                    return !node.expression || isPossiblyDiscriminantValue(node.expression);
            }
            return false;
        }
        function discriminateContextualTypeByObjectMembers(node, contextualType) {
            const key = `D${getNodeId(node)},${getTypeId(contextualType)}`;
            var _getMatchingUnionConstituentForObjectLiteral, _getCachedType;
            return (_getCachedType = getCachedType(key)) !== null && _getCachedType !== void 0 ? _getCachedType : setCachedType(key, (_getMatchingUnionConstituentForObjectLiteral = getMatchingUnionConstituentForObjectLiteral(contextualType, node)) !== null && _getMatchingUnionConstituentForObjectLiteral !== void 0 ? _getMatchingUnionConstituentForObjectLiteral : discriminateTypeByDiscriminableItems(contextualType, concatenate(map(filter(node.properties, (p)=>{
                if (!p.symbol) return false;
                if (p.kind === 304 /* PropertyAssignment */ ) return isPossiblyDiscriminantValue(p.initializer) && isDiscriminantProperty(contextualType, p.symbol.escapedName);
                if (p.kind === 305 /* ShorthandPropertyAssignment */ ) return isDiscriminantProperty(contextualType, p.symbol.escapedName);
                return false;
            }), (prop)=>[
                    ()=>getContextFreeTypeOfExpression(prop.kind === 304 /* PropertyAssignment */  ? prop.initializer : prop.name),
                    prop.symbol.escapedName
                ]), map(filter(getPropertiesOfType(contextualType), (s)=>{
                var _a;
                return !!(s.flags & 16777216 /* Optional */ ) && !!((_a = node == null ? void 0 : node.symbol) == null ? void 0 : _a.members) && !node.symbol.members.has(s.escapedName) && isDiscriminantProperty(contextualType, s.escapedName);
            }), (s)=>[
                    ()=>undefinedType,
                    s.escapedName
                ])), isTypeAssignableTo));
        }
        function discriminateContextualTypeByJSXAttributes(node, contextualType) {
            const key = `D${getNodeId(node)},${getTypeId(contextualType)}`;
            const cached = getCachedType(key);
            if (cached) return cached;
            const jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
            return setCachedType(key, discriminateTypeByDiscriminableItems(contextualType, concatenate(map(filter(node.properties, (p)=>!!p.symbol && p.kind === 292 /* JsxAttribute */  && isDiscriminantProperty(contextualType, p.symbol.escapedName) && (!p.initializer || isPossiblyDiscriminantValue(p.initializer))), (prop)=>[
                    !prop.initializer ? ()=>trueType : ()=>getContextFreeTypeOfExpression(prop.initializer),
                    prop.symbol.escapedName
                ]), map(filter(getPropertiesOfType(contextualType), (s)=>{
                var _a;
                if (!(s.flags & 16777216 /* Optional */ ) || !((_a = node == null ? void 0 : node.symbol) == null ? void 0 : _a.members)) return false;
                const element = node.parent.parent;
                if (s.escapedName === jsxChildrenPropertyName && isJsxElement(element) && getSemanticJsxChildren(element.children).length) return false;
                return !node.symbol.members.has(s.escapedName) && isDiscriminantProperty(contextualType, s.escapedName);
            }), (s)=>[
                    ()=>undefinedType,
                    s.escapedName
                ])), isTypeAssignableTo));
        }
        function getApparentTypeOfContextualType(node, contextFlags) {
            const contextualType = isObjectLiteralMethod(node) ? getContextualTypeForObjectLiteralMethod(node, contextFlags) : getContextualType2(node, contextFlags);
            const instantiatedType = instantiateContextualType(contextualType, node, contextFlags);
            if (instantiatedType && !(contextFlags && contextFlags & 2 /* NoConstraints */  && instantiatedType.flags & 8650752 /* TypeVariable */ )) {
                const apparentType = mapType(instantiatedType, // When obtaining apparent type of *contextual* type we don't want to get apparent type of mapped types.
                // That would evaluate mapped types with array or tuple type constraints too eagerly
                // and thus it would prevent `getTypeOfPropertyOfContextualType` from obtaining per-position contextual type for elements of array literal expressions.
                // Apparent type of other mapped types is already the mapped type itself so we can just avoid calling `getApparentType` here for all mapped types.
                (t)=>getObjectFlags(t) & 32 /* Mapped */  ? t : getApparentType(t), /*noReductions*/ true);
                return apparentType.flags & 1048576 /* Union */  && isObjectLiteralExpression(node) ? discriminateContextualTypeByObjectMembers(node, apparentType) : apparentType.flags & 1048576 /* Union */  && isJsxAttributes(node) ? discriminateContextualTypeByJSXAttributes(node, apparentType) : apparentType;
            }
        }
        function instantiateContextualType(contextualType, node, contextFlags) {
            if (contextualType && maybeTypeOfKind(contextualType, 465829888 /* Instantiable */ )) {
                const inferenceContext = getInferenceContext(node);
                if (inferenceContext && contextFlags & 1 /* Signature */  && some(inferenceContext.inferences, hasInferenceCandidatesOrDefault)) return instantiateInstantiableTypes(contextualType, inferenceContext.nonFixingMapper);
                if (inferenceContext == null ? void 0 : inferenceContext.returnMapper) {
                    const type = instantiateInstantiableTypes(contextualType, inferenceContext.returnMapper);
                    return type.flags & 1048576 /* Union */  && containsType(type.types, regularFalseType) && containsType(type.types, regularTrueType) ? filterType(type, (t)=>t !== regularFalseType && t !== regularTrueType) : type;
                }
            }
            return contextualType;
        }
        function instantiateInstantiableTypes(type, mapper) {
            if (type.flags & 465829888 /* Instantiable */ ) return instantiateType(type, mapper);
            if (type.flags & 1048576 /* Union */ ) return getUnionType(map(type.types, (t)=>instantiateInstantiableTypes(t, mapper)), 0 /* None */ );
            if (type.flags & 2097152 /* Intersection */ ) return getIntersectionType(map(type.types, (t)=>instantiateInstantiableTypes(t, mapper)));
            return type;
        }
        function getContextualType2(node, contextFlags) {
            var _a;
            if (node.flags & 67108864 /* InWithStatement */ ) return void 0;
            const index = findContextualNode(node, /*includeCaches*/ !contextFlags);
            if (index >= 0) return contextualTypes[index];
            const { parent: parent2 } = node;
            switch(parent2.kind){
                case 261 /* VariableDeclaration */ :
                case 170 /* Parameter */ :
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 209 /* BindingElement */ :
                    return getContextualTypeForInitializerExpression(node, contextFlags);
                case 220 /* ArrowFunction */ :
                case 254 /* ReturnStatement */ :
                    return getContextualTypeForReturnExpression(node, contextFlags);
                case 230 /* YieldExpression */ :
                    return getContextualTypeForYieldOperand(parent2, contextFlags);
                case 224 /* AwaitExpression */ :
                    return getContextualTypeForAwaitOperand(parent2, contextFlags);
                case 214 /* CallExpression */ :
                case 215 /* NewExpression */ :
                    return getContextualTypeForArgument(parent2, node);
                case 171 /* Decorator */ :
                    return getContextualTypeForDecorator(parent2);
                case 217 /* TypeAssertionExpression */ :
                case 235 /* AsExpression */ :
                    return isConstTypeReference(parent2.type) ? getContextualType2(parent2, contextFlags) : getTypeFromTypeNode(parent2.type);
                case 227 /* BinaryExpression */ :
                    return getContextualTypeForBinaryOperand(node, contextFlags);
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                    return getContextualTypeForObjectLiteralElement(parent2, contextFlags);
                case 306 /* SpreadAssignment */ :
                    return getContextualType2(parent2.parent, contextFlags);
                case 210 /* ArrayLiteralExpression */ :
                    {
                        const arrayLiteral = parent2;
                        const type = getApparentTypeOfContextualType(arrayLiteral, contextFlags);
                        const elementIndex = indexOfNode(arrayLiteral.elements, node);
                        var _spreadIndices;
                        const spreadIndices = (_spreadIndices = (_a = getNodeLinks(arrayLiteral)).spreadIndices) !== null && _spreadIndices !== void 0 ? _spreadIndices : _a.spreadIndices = getSpreadIndices(arrayLiteral.elements);
                        return getContextualTypeForElementExpression(type, elementIndex, arrayLiteral.elements.length, spreadIndices.first, spreadIndices.last);
                    }
                case 228 /* ConditionalExpression */ :
                    return getContextualTypeForConditionalOperand(node, contextFlags);
                case 240 /* TemplateSpan */ :
                    Debug.assert(parent2.parent.kind === 229 /* TemplateExpression */ );
                    return getContextualTypeForSubstitutionExpression(parent2.parent, node);
                case 218 /* ParenthesizedExpression */ :
                    if (isInJSFile(parent2)) {
                        if (isJSDocSatisfiesExpression(parent2)) return getTypeFromTypeNode(getJSDocSatisfiesExpressionType(parent2));
                        const typeTag = getJSDocTypeTag(parent2);
                        if (typeTag && !isConstTypeReference(typeTag.typeExpression.type)) return getTypeFromTypeNode(typeTag.typeExpression.type);
                    }
                    return getContextualType2(parent2, contextFlags);
                case 236 /* NonNullExpression */ :
                    return getContextualType2(parent2, contextFlags);
                case 239 /* SatisfiesExpression */ :
                    return getTypeFromTypeNode(parent2.type);
                case 278 /* ExportAssignment */ :
                    return tryGetTypeFromEffectiveTypeNode(parent2);
                case 295 /* JsxExpression */ :
                    return getContextualTypeForJsxExpression(parent2, contextFlags);
                case 292 /* JsxAttribute */ :
                case 294 /* JsxSpreadAttribute */ :
                    return getContextualTypeForJsxAttribute(parent2, contextFlags);
                case 287 /* JsxOpeningElement */ :
                case 286 /* JsxSelfClosingElement */ :
                    return getContextualJsxElementAttributesType(parent2, contextFlags);
                case 302 /* ImportAttribute */ :
                    return getContextualImportAttributeType(parent2);
            }
            return void 0;
        }
        function pushCachedContextualType(node) {
            pushContextualType(node, getContextualType2(node, /*contextFlags*/ void 0), /*isCache*/ true);
        }
        function pushContextualType(node, type, isCache) {
            contextualTypeNodes[contextualTypeCount] = node;
            contextualTypes[contextualTypeCount] = type;
            contextualIsCache[contextualTypeCount] = isCache;
            contextualTypeCount++;
        }
        function popContextualType() {
            contextualTypeCount--;
            contextualTypeNodes[contextualTypeCount] = void 0;
            contextualTypes[contextualTypeCount] = void 0;
            contextualIsCache[contextualTypeCount] = void 0;
        }
        function findContextualNode(node, includeCaches) {
            for(let i = contextualTypeCount - 1; i >= 0; i--){
                if (node === contextualTypeNodes[i] && (includeCaches || !contextualIsCache[i])) return i;
            }
            return -1;
        }
        function pushInferenceContext(node, inferenceContext) {
            inferenceContextNodes[inferenceContextCount] = node;
            inferenceContexts[inferenceContextCount] = inferenceContext;
            inferenceContextCount++;
        }
        function popInferenceContext() {
            inferenceContextCount--;
            inferenceContextNodes[inferenceContextCount] = void 0;
            inferenceContexts[inferenceContextCount] = void 0;
        }
        function getInferenceContext(node) {
            for(let i = inferenceContextCount - 1; i >= 0; i--){
                if (isNodeDescendantOf(node, inferenceContextNodes[i])) return inferenceContexts[i];
            }
        }
        function pushActiveMapper(mapper) {
            activeTypeMappers[activeTypeMappersCount] = mapper;
            var _activeTypeMappersCaches_activeTypeMappersCount;
            (_activeTypeMappersCaches_activeTypeMappersCount = activeTypeMappersCaches[activeTypeMappersCount]) !== null && _activeTypeMappersCaches_activeTypeMappersCount !== void 0 ? _activeTypeMappersCaches_activeTypeMappersCount : activeTypeMappersCaches[activeTypeMappersCount] = /* @__PURE__ */ new Map();
            activeTypeMappersCount++;
        }
        function popActiveMapper() {
            activeTypeMappersCount--;
            activeTypeMappers[activeTypeMappersCount] = void 0;
            activeTypeMappersCaches[activeTypeMappersCount].clear();
        }
        function findActiveMapper(mapper) {
            for(let i = activeTypeMappersCount - 1; i >= 0; i--){
                if (mapper === activeTypeMappers[i]) return i;
            }
            return -1;
        }
        function clearActiveMapperCaches() {
            for(let i = activeTypeMappersCount - 1; i >= 0; i--)activeTypeMappersCaches[i].clear();
        }
        function getContextualImportAttributeType(node) {
            return getTypeOfPropertyOfContextualType(getGlobalImportAttributesType(/*reportErrors*/ false), getNameFromImportAttribute(node));
        }
        function getContextualJsxElementAttributesType(node, contextFlags) {
            if (isJsxOpeningElement(node) && contextFlags !== 4 /* Completions */ ) {
                const index = findContextualNode(node.parent, /*includeCaches*/ !contextFlags);
                if (index >= 0) return contextualTypes[index];
            }
            return getContextualTypeForArgumentAtIndex(node, 0);
        }
        function getEffectiveFirstArgumentForJsxSignature(signature, node) {
            return isJsxOpeningFragment(node) || getJsxReferenceKind(node) !== 0 /* Component */  ? getJsxPropsTypeFromCallSignature(signature, node) : getJsxPropsTypeFromClassType(signature, node);
        }
        function getJsxPropsTypeFromCallSignature(sig, context) {
            let propsType = getTypeOfFirstParameterOfSignatureWithFallback(sig, unknownType);
            propsType = getJsxManagedAttributesFromLocatedAttributes(context, getJsxNamespaceAt(context), propsType);
            const intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes, context);
            if (!isErrorType(intrinsicAttribs)) propsType = intersectTypes(intrinsicAttribs, propsType);
            return propsType;
        }
        function getJsxPropsTypeForSignatureFromMember(sig, forcedLookupLocation) {
            if (sig.compositeSignatures) {
                const results = [];
                for (const signature of sig.compositeSignatures){
                    const instance = getReturnTypeOfSignature(signature);
                    if (isTypeAny(instance)) return instance;
                    const propType = getTypeOfPropertyOfType(instance, forcedLookupLocation);
                    if (!propType) return;
                    results.push(propType);
                }
                return getIntersectionType(results);
            }
            const instanceType = getReturnTypeOfSignature(sig);
            return isTypeAny(instanceType) ? instanceType : getTypeOfPropertyOfType(instanceType, forcedLookupLocation);
        }
        function getStaticTypeOfReferencedJsxConstructor(context) {
            if (isJsxOpeningFragment(context)) return getJSXFragmentType(context);
            if (isJsxIntrinsicTagName(context.tagName)) {
                const result = getIntrinsicAttributesTypeFromJsxOpeningLikeElement(context);
                const fakeSignature = createSignatureForJSXIntrinsic(context, result);
                return getOrCreateTypeFromSignature(fakeSignature);
            }
            const tagType = checkExpressionCached(context.tagName);
            if (tagType.flags & 128 /* StringLiteral */ ) {
                const result = getIntrinsicAttributesTypeFromStringLiteralType(tagType, context);
                if (!result) return errorType;
                const fakeSignature = createSignatureForJSXIntrinsic(context, result);
                return getOrCreateTypeFromSignature(fakeSignature);
            }
            return tagType;
        }
        function getJsxManagedAttributesFromLocatedAttributes(context, ns, attributesType) {
            const managedSym = getJsxLibraryManagedAttributes(ns);
            if (managedSym) {
                const ctorType = getStaticTypeOfReferencedJsxConstructor(context);
                const result = instantiateAliasOrInterfaceWithDefaults(managedSym, isInJSFile(context), ctorType, attributesType);
                if (result) return result;
            }
            return attributesType;
        }
        function getJsxPropsTypeFromClassType(sig, context) {
            const ns = getJsxNamespaceAt(context);
            const forcedLookupLocation = getJsxElementPropertiesName(ns);
            let attributesType = forcedLookupLocation === void 0 ? getTypeOfFirstParameterOfSignatureWithFallback(sig, unknownType) : forcedLookupLocation === "" ? getReturnTypeOfSignature(sig) : getJsxPropsTypeForSignatureFromMember(sig, forcedLookupLocation);
            if (!attributesType) {
                if (!!forcedLookupLocation && !!length(context.attributes.properties)) error2(context, Diagnostics.JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property, unescapeLeadingUnderscores(forcedLookupLocation));
                return unknownType;
            }
            attributesType = getJsxManagedAttributesFromLocatedAttributes(context, ns, attributesType);
            if (isTypeAny(attributesType)) return attributesType;
            else {
                let apparentAttributesType = attributesType;
                const intrinsicClassAttribs = getJsxType(JsxNames.IntrinsicClassAttributes, context);
                if (!isErrorType(intrinsicClassAttribs)) {
                    const typeParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(intrinsicClassAttribs.symbol);
                    const hostClassType = getReturnTypeOfSignature(sig);
                    let libraryManagedAttributeType;
                    if (typeParams) {
                        const inferredArgs = fillMissingTypeArguments([
                            hostClassType
                        ], typeParams, getMinTypeArgumentCount(typeParams), isInJSFile(context));
                        libraryManagedAttributeType = instantiateType(intrinsicClassAttribs, createTypeMapper(typeParams, inferredArgs));
                    } else libraryManagedAttributeType = intrinsicClassAttribs;
                    apparentAttributesType = intersectTypes(libraryManagedAttributeType, apparentAttributesType);
                }
                const intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes, context);
                if (!isErrorType(intrinsicAttribs)) apparentAttributesType = intersectTypes(intrinsicAttribs, apparentAttributesType);
                return apparentAttributesType;
            }
        }
        function getIntersectedSignatures(signatures) {
            return getStrictOptionValue(compilerOptions, "noImplicitAny") ? reduceLeft(signatures, (left, right)=>left === right || !left ? left : compareTypeParametersIdentical(left.typeParameters, right.typeParameters) ? combineSignaturesOfIntersectionMembers(left, right) : void 0) : void 0;
        }
        function combineIntersectionThisParam(left, right, mapper) {
            if (!left || !right) return left || right;
            const thisType = getUnionType([
                getTypeOfSymbol(left),
                instantiateType(getTypeOfSymbol(right), mapper)
            ]);
            return createSymbolWithType(left, thisType);
        }
        function combineIntersectionParameters(left, right, mapper) {
            const leftCount = getParameterCount(left);
            const rightCount = getParameterCount(right);
            const longest = leftCount >= rightCount ? left : right;
            const shorter = longest === left ? right : left;
            const longestCount = longest === left ? leftCount : rightCount;
            const eitherHasEffectiveRest = hasEffectiveRestParameter(left) || hasEffectiveRestParameter(right);
            const needsExtraRestElement = eitherHasEffectiveRest && !hasEffectiveRestParameter(longest);
            const params = new Array(longestCount + (needsExtraRestElement ? 1 : 0));
            for(let i = 0; i < longestCount; i++){
                let longestParamType = tryGetTypeAtPosition(longest, i);
                if (longest === right) longestParamType = instantiateType(longestParamType, mapper);
                let shorterParamType = tryGetTypeAtPosition(shorter, i) || unknownType;
                if (shorter === right) shorterParamType = instantiateType(shorterParamType, mapper);
                const unionParamType = getUnionType([
                    longestParamType,
                    shorterParamType
                ]);
                const isRestParam = eitherHasEffectiveRest && !needsExtraRestElement && i === longestCount - 1;
                const isOptional = i >= getMinArgumentCount(longest) && i >= getMinArgumentCount(shorter);
                const leftName = i >= leftCount ? void 0 : getParameterNameAtPosition(left, i);
                const rightName = i >= rightCount ? void 0 : getParameterNameAtPosition(right, i);
                const paramName = leftName === rightName ? leftName : !leftName ? rightName : !rightName ? leftName : void 0;
                const paramSymbol = createSymbol(1 /* FunctionScopedVariable */  | (isOptional && !isRestParam ? 16777216 /* Optional */  : 0), paramName || `arg${i}`, isRestParam ? 32768 /* RestParameter */  : isOptional ? 16384 /* OptionalParameter */  : 0);
                paramSymbol.links.type = isRestParam ? createArrayType(unionParamType) : unionParamType;
                params[i] = paramSymbol;
            }
            if (needsExtraRestElement) {
                const restParamSymbol = createSymbol(1 /* FunctionScopedVariable */ , "args", 32768 /* RestParameter */ );
                restParamSymbol.links.type = createArrayType(getTypeAtPosition(shorter, longestCount));
                if (shorter === right) restParamSymbol.links.type = instantiateType(restParamSymbol.links.type, mapper);
                params[longestCount] = restParamSymbol;
            }
            return params;
        }
        function combineSignaturesOfIntersectionMembers(left, right) {
            const typeParams = left.typeParameters || right.typeParameters;
            let paramMapper;
            if (left.typeParameters && right.typeParameters) paramMapper = createTypeMapper(right.typeParameters, left.typeParameters);
            let flags = (left.flags | right.flags) & 166 /* HasRestParameter */ ;
            const declaration = left.declaration;
            const params = combineIntersectionParameters(left, right, paramMapper);
            const lastParam = lastOrUndefined(params);
            if (lastParam && getCheckFlags(lastParam) & 32768 /* RestParameter */ ) flags |= 1 /* HasRestParameter */ ;
            const thisParam = combineIntersectionThisParam(left.thisParameter, right.thisParameter, paramMapper);
            const minArgCount = Math.max(left.minArgumentCount, right.minArgumentCount);
            const result = createSignature(declaration, typeParams, thisParam, params, /*resolvedReturnType*/ void 0, /*resolvedTypePredicate*/ void 0, minArgCount, flags);
            result.compositeKind = 2097152 /* Intersection */ ;
            result.compositeSignatures = concatenate(left.compositeKind === 2097152 /* Intersection */  && left.compositeSignatures || [
                left
            ], [
                right
            ]);
            if (paramMapper) result.mapper = left.compositeKind === 2097152 /* Intersection */  && left.mapper && left.compositeSignatures ? combineTypeMappers(left.mapper, paramMapper) : paramMapper;
            return result;
        }
        function getContextualCallSignature(type, node) {
            const signatures = getSignaturesOfType(type, 0 /* Call */ );
            const applicableByArity = filter(signatures, (s)=>!isAritySmaller(s, node));
            return applicableByArity.length === 1 ? applicableByArity[0] : getIntersectedSignatures(applicableByArity);
        }
        function isAritySmaller(signature, target) {
            let targetParameterCount = 0;
            for(; targetParameterCount < target.parameters.length; targetParameterCount++){
                const param = target.parameters[targetParameterCount];
                if (param.initializer || param.questionToken || param.dotDotDotToken || isJSDocOptionalParameter(param)) break;
            }
            if (target.parameters.length && parameterIsThisKeyword(target.parameters[0])) targetParameterCount--;
            return !hasEffectiveRestParameter(signature) && getParameterCount(signature) < targetParameterCount;
        }
        function getContextualSignatureForFunctionLikeDeclaration(node) {
            return isFunctionExpressionOrArrowFunction(node) || isObjectLiteralMethod(node) ? getContextualSignature(node) : void 0;
        }
        function getContextualSignature(node) {
            Debug.assert(node.kind !== 175 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            const typeTagSignature = getSignatureOfTypeTag(node);
            if (typeTagSignature) return typeTagSignature;
            const type = getApparentTypeOfContextualType(node, 1 /* Signature */ );
            if (!type) return void 0;
            if (!(type.flags & 1048576 /* Union */ )) return getContextualCallSignature(type, node);
            let signatureList;
            const types = type.types;
            for (const current of types){
                const signature = getContextualCallSignature(current, node);
                if (signature) {
                    if (!signatureList) signatureList = [
                        signature
                    ];
                    else if (!compareSignaturesIdentical(signatureList[0], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true, compareTypesIdentical)) return void 0;
                    else signatureList.push(signature);
                }
            }
            if (signatureList) return signatureList.length === 1 ? signatureList[0] : createUnionSignature(signatureList[0], signatureList);
        }
        function checkGrammarRegularExpressionLiteral(node) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile) && !node.isUnterminated) {
                let lastError;
                scanner2 !== null && scanner2 !== void 0 ? scanner2 : scanner2 = createScanner(99 /* ESNext */ , /*skipTrivia*/ true);
                scanner2.setScriptTarget(sourceFile.languageVersion);
                scanner2.setLanguageVariant(sourceFile.languageVariant);
                scanner2.setOnError((message, length2, arg0)=>{
                    const start = scanner2.getTokenEnd();
                    if (message.category === 3 /* Message */  && lastError && start === lastError.start && length2 === lastError.length) {
                        const error3 = createDetachedDiagnostic(sourceFile.fileName, sourceFile.text, start, length2, message, arg0);
                        addRelatedInfo(lastError, error3);
                    } else if (!lastError || start !== lastError.start) {
                        lastError = createFileDiagnostic(sourceFile, start, length2, message, arg0);
                        diagnostics.add(lastError);
                    }
                });
                scanner2.setText(sourceFile.text, node.pos, node.end - node.pos);
                try {
                    scanner2.scan();
                    Debug.assert(scanner2.reScanSlashToken(/*reportErrors*/ true) === 14 /* RegularExpressionLiteral */ , "Expected scanner to rescan RegularExpressionLiteral");
                    return !!lastError;
                } finally{
                    scanner2.setText("");
                    scanner2.setOnError(/*onError*/ void 0);
                }
            }
            return false;
        }
        function checkRegularExpressionLiteral(node) {
            const nodeLinks2 = getNodeLinks(node);
            if (!(nodeLinks2.flags & 1 /* TypeChecked */ )) {
                nodeLinks2.flags |= 1 /* TypeChecked */ ;
                addLazyDiagnostic(()=>checkGrammarRegularExpressionLiteral(node));
            }
            return globalRegExpType;
        }
        function checkSpreadExpression(node, checkMode) {
            if (languageVersion < LanguageFeatureMinimumTarget.SpreadElements) checkExternalEmitHelpers(node, compilerOptions.downlevelIteration ? 1536 /* SpreadIncludes */  : 1024 /* SpreadArray */ );
            const arrayOrIterableType = checkExpression(node.expression, checkMode);
            return checkIteratedTypeOrElementType(33 /* Spread */ , arrayOrIterableType, undefinedType, node.expression);
        }
        function checkSyntheticExpression(node) {
            return node.isSpread ? getIndexedAccessType(node.type, numberType) : node.type;
        }
        function hasDefaultValue(node) {
            return node.kind === 209 /* BindingElement */  && !!node.initializer || node.kind === 304 /* PropertyAssignment */  && hasDefaultValue(node.initializer) || node.kind === 305 /* ShorthandPropertyAssignment */  && !!node.objectAssignmentInitializer || node.kind === 227 /* BinaryExpression */  && node.operatorToken.kind === 64 /* EqualsToken */ ;
        }
        function isSpreadIntoCallOrNew(node) {
            const parent2 = walkUpParenthesizedExpressions(node.parent);
            return isSpreadElement(parent2) && isCallOrNewExpression(parent2.parent);
        }
        function checkArrayLiteral(node, checkMode, forceTuple) {
            const elements = node.elements;
            const elementCount = elements.length;
            const elementTypes = [];
            const elementFlags = [];
            pushCachedContextualType(node);
            const inDestructuringPattern = isAssignmentTarget(node);
            const inConstContext = isConstContext(node);
            const contextualType = getApparentTypeOfContextualType(node, /*contextFlags*/ void 0);
            const inTupleContext = isSpreadIntoCallOrNew(node) || !!contextualType && someType(contextualType, (t)=>isTupleLikeType(t) || isGenericMappedType(t) && !t.nameType && !!getHomomorphicTypeVariable(t.target || t));
            let hasOmittedExpression = false;
            for(let i = 0; i < elementCount; i++){
                const e = elements[i];
                if (e.kind === 231 /* SpreadElement */ ) {
                    if (languageVersion < LanguageFeatureMinimumTarget.SpreadElements) checkExternalEmitHelpers(e, compilerOptions.downlevelIteration ? 1536 /* SpreadIncludes */  : 1024 /* SpreadArray */ );
                    const spreadType = checkExpression(e.expression, checkMode, forceTuple);
                    if (isArrayLikeType(spreadType)) {
                        elementTypes.push(spreadType);
                        elementFlags.push(8 /* Variadic */ );
                    } else if (inDestructuringPattern) {
                        const restElementType = getIndexTypeOfType(spreadType, numberType) || getIteratedTypeOrElementType(65 /* Destructuring */ , spreadType, undefinedType, /*errorNode*/ void 0, /*checkAssignability*/ false) || unknownType;
                        elementTypes.push(restElementType);
                        elementFlags.push(4 /* Rest */ );
                    } else {
                        elementTypes.push(checkIteratedTypeOrElementType(33 /* Spread */ , spreadType, undefinedType, e.expression));
                        elementFlags.push(4 /* Rest */ );
                    }
                } else if (exactOptionalPropertyTypes && e.kind === 233 /* OmittedExpression */ ) {
                    hasOmittedExpression = true;
                    elementTypes.push(undefinedOrMissingType);
                    elementFlags.push(2 /* Optional */ );
                } else {
                    const type = checkExpressionForMutableLocation(e, checkMode, forceTuple);
                    elementTypes.push(addOptionality(type, /*isProperty*/ true, hasOmittedExpression));
                    elementFlags.push(hasOmittedExpression ? 2 /* Optional */  : 1 /* Required */ );
                    if (inTupleContext && checkMode && checkMode & 2 /* Inferential */  && !(checkMode & 4 /* SkipContextSensitive */ ) && isContextSensitive(e)) {
                        const inferenceContext = getInferenceContext(node);
                        Debug.assert(inferenceContext);
                        addIntraExpressionInferenceSite(inferenceContext, e, type);
                    }
                }
            }
            popContextualType();
            if (inDestructuringPattern) return createTupleType(elementTypes, elementFlags);
            if (forceTuple || inConstContext || inTupleContext) return createArrayLiteralType(createTupleType(elementTypes, elementFlags, /*readonly*/ inConstContext && !(contextualType && someType(contextualType, isMutableArrayLikeType))));
            return createArrayLiteralType(createArrayType(elementTypes.length ? getUnionType(sameMap(elementTypes, (t, i)=>elementFlags[i] & 8 /* Variadic */  ? getIndexedAccessTypeOrUndefined(t, numberType) || anyType : t), 2 /* Subtype */ ) : strictNullChecks ? implicitNeverType : undefinedWideningType, inConstContext));
        }
        function createArrayLiteralType(type) {
            if (!(getObjectFlags(type) & 4 /* Reference */ )) return type;
            let literalType = type.literalType;
            if (!literalType) {
                literalType = type.literalType = cloneTypeReference(type);
                literalType.objectFlags |= 147456 /* ContainsObjectOrArrayLiteral */ ;
            }
            return literalType;
        }
        function isNumericName(name) {
            switch(name.kind){
                case 168 /* ComputedPropertyName */ :
                    return isNumericComputedName(name);
                case 80 /* Identifier */ :
                    return isNumericLiteralName(name.escapedText);
                case 9 /* NumericLiteral */ :
                case 11 /* StringLiteral */ :
                    return isNumericLiteralName(name.text);
                default:
                    return false;
            }
        }
        function isNumericComputedName(name) {
            return isTypeAssignableToKind(checkComputedPropertyName(name), 296 /* NumberLike */ );
        }
        function checkComputedPropertyName(node) {
            const links = getNodeLinks(node.expression);
            if (!links.resolvedType) {
                if ((isTypeLiteralNode(node.parent.parent) || isClassLike(node.parent.parent) || isInterfaceDeclaration(node.parent.parent)) && isBinaryExpression(node.expression) && node.expression.operatorToken.kind === 103 /* InKeyword */  && node.parent.kind !== 178 /* GetAccessor */  && node.parent.kind !== 179 /* SetAccessor */ ) return links.resolvedType = errorType;
                links.resolvedType = checkExpression(node.expression);
                if (isPropertyDeclaration(node.parent) && !hasStaticModifier(node.parent) && isClassExpression(node.parent.parent)) {
                    const container = getEnclosingBlockScopeContainer(node.parent.parent);
                    const enclosingIterationStatement = getEnclosingIterationStatement(container);
                    if (enclosingIterationStatement) {
                        getNodeLinks(enclosingIterationStatement).flags |= 4096 /* LoopWithCapturedBlockScopedBinding */ ;
                        getNodeLinks(node).flags |= 32768 /* BlockScopedBindingInLoop */ ;
                        getNodeLinks(node.parent.parent).flags |= 32768 /* BlockScopedBindingInLoop */ ;
                    }
                }
                if (links.resolvedType.flags & 98304 /* Nullable */  || !isTypeAssignableToKind(links.resolvedType, 402665900 /* ESSymbolLike */ ) && !isTypeAssignableTo(links.resolvedType, stringNumberSymbolType)) error2(node, Diagnostics.A_computed_property_name_must_be_of_type_string_number_symbol_or_any);
            }
            return links.resolvedType;
        }
        function isSymbolWithNumericName(symbol) {
            var _a;
            const firstDecl = (_a = symbol.declarations) == null ? void 0 : _a[0];
            return isNumericLiteralName(symbol.escapedName) || firstDecl && isNamedDeclaration(firstDecl) && isNumericName(firstDecl.name);
        }
        function isSymbolWithSymbolName(symbol) {
            var _a;
            const firstDecl = (_a = symbol.declarations) == null ? void 0 : _a[0];
            return isKnownSymbol(symbol) || firstDecl && isNamedDeclaration(firstDecl) && isComputedPropertyName(firstDecl.name) && isTypeAssignableToKind(checkComputedPropertyName(firstDecl.name), 4096 /* ESSymbol */ );
        }
        function isSymbolWithComputedName(symbol) {
            var _a;
            const firstDecl = (_a = symbol.declarations) == null ? void 0 : _a[0];
            return firstDecl && isNamedDeclaration(firstDecl) && isComputedPropertyName(firstDecl.name);
        }
        function getObjectLiteralIndexInfo(isReadonly, offset, properties, keyType) {
            var _a;
            const propTypes = [];
            let components;
            for(let i = offset; i < properties.length; i++){
                const prop = properties[i];
                if (keyType === stringType && !isSymbolWithSymbolName(prop) || keyType === numberType && isSymbolWithNumericName(prop) || keyType === esSymbolType && isSymbolWithSymbolName(prop)) {
                    propTypes.push(getTypeOfSymbol(properties[i]));
                    if (isSymbolWithComputedName(properties[i])) components = append(components, (_a = properties[i].declarations) == null ? void 0 : _a[0]);
                }
            }
            const unionType = propTypes.length ? getUnionType(propTypes, 2 /* Subtype */ ) : undefinedType;
            return createIndexInfo(keyType, unionType, isReadonly, /*declaration*/ void 0, components);
        }
        function getImmediateAliasedSymbol(symbol) {
            Debug.assert((symbol.flags & 2097152 /* Alias */ ) !== 0, "Should only get Alias here.");
            const links = getSymbolLinks(symbol);
            if (!links.immediateTarget) {
                const node = getDeclarationOfAliasSymbol(symbol);
                if (!node) return Debug.fail();
                links.immediateTarget = getTargetOfAliasDeclaration(node, /*dontRecursivelyResolve*/ true);
            }
            return links.immediateTarget;
        }
        function checkObjectLiteral(node, checkMode = 0 /* Normal */ ) {
            const inDestructuringPattern = isAssignmentTarget(node);
            checkGrammarObjectLiteralExpression(node, inDestructuringPattern);
            const allPropertiesTable = strictNullChecks ? createSymbolTable() : void 0;
            let propertiesTable = createSymbolTable();
            let propertiesArray = [];
            let spread = emptyObjectType;
            pushCachedContextualType(node);
            const contextualType = getApparentTypeOfContextualType(node, /*contextFlags*/ void 0);
            const contextualTypeHasPattern = contextualType && contextualType.pattern && (contextualType.pattern.kind === 207 /* ObjectBindingPattern */  || contextualType.pattern.kind === 211 /* ObjectLiteralExpression */ );
            const inConstContext = isConstContext(node);
            const checkFlags = inConstContext ? 8 /* Readonly */  : 0;
            const isInJavascript = isInJSFile(node) && !isInJsonFile(node);
            const enumTag = isInJavascript ? getJSDocEnumTag(node) : void 0;
            const isJSObjectLiteral = !contextualType && isInJavascript && !enumTag;
            let objectFlags = 8192 /* FreshLiteral */ ;
            let patternWithComputedProperties = false;
            let hasComputedStringProperty = false;
            let hasComputedNumberProperty = false;
            let hasComputedSymbolProperty = false;
            for (const elem of node.properties)if (elem.name && isComputedPropertyName(elem.name)) checkComputedPropertyName(elem.name);
            let offset = 0;
            for (const memberDecl of node.properties){
                let member = getSymbolOfDeclaration(memberDecl);
                const computedNameType = memberDecl.name && memberDecl.name.kind === 168 /* ComputedPropertyName */  ? checkComputedPropertyName(memberDecl.name) : void 0;
                if (memberDecl.kind === 304 /* PropertyAssignment */  || memberDecl.kind === 305 /* ShorthandPropertyAssignment */  || isObjectLiteralMethod(memberDecl)) {
                    let type = memberDecl.kind === 304 /* PropertyAssignment */  ? checkPropertyAssignment(memberDecl, checkMode) : // avoid resolving the left side of the ShorthandPropertyAssignment outside of the destructuring
                    // for error recovery purposes. For example, if a user wrote `{ a = 100 }` instead of `{ a: 100 }`.
                    // we don't want to say "could not find 'a'".
                    memberDecl.kind === 305 /* ShorthandPropertyAssignment */  ? checkExpressionForMutableLocation(!inDestructuringPattern && memberDecl.objectAssignmentInitializer ? memberDecl.objectAssignmentInitializer : memberDecl.name, checkMode) : checkObjectLiteralMethod(memberDecl, checkMode);
                    if (isInJavascript) {
                        const jsDocType = getTypeForDeclarationFromJSDocComment(memberDecl);
                        if (jsDocType) {
                            checkTypeAssignableTo(type, jsDocType, memberDecl);
                            type = jsDocType;
                        } else if (enumTag && enumTag.typeExpression) checkTypeAssignableTo(type, getTypeFromTypeNode(enumTag.typeExpression), memberDecl);
                    }
                    objectFlags |= getObjectFlags(type) & 458752 /* PropagatingFlags */ ;
                    const nameType = computedNameType && isTypeUsableAsPropertyName(computedNameType) ? computedNameType : void 0;
                    const prop = nameType ? createSymbol(4 /* Property */  | member.flags, getPropertyNameFromType(nameType), checkFlags | 4096 /* Late */ ) : createSymbol(4 /* Property */  | member.flags, member.escapedName, checkFlags);
                    if (nameType) prop.links.nameType = nameType;
                    if (inDestructuringPattern && hasDefaultValue(memberDecl)) prop.flags |= 16777216 /* Optional */ ;
                    else if (contextualTypeHasPattern && !(getObjectFlags(contextualType) & 512 /* ObjectLiteralPatternWithComputedProperties */ )) {
                        const impliedProp = getPropertyOfType(contextualType, member.escapedName);
                        if (impliedProp) prop.flags |= impliedProp.flags & 16777216 /* Optional */ ;
                        else if (!getIndexInfoOfType(contextualType, stringType)) error2(memberDecl.name, Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(member), typeToString(contextualType));
                    }
                    prop.declarations = member.declarations;
                    prop.parent = member.parent;
                    if (member.valueDeclaration) prop.valueDeclaration = member.valueDeclaration;
                    prop.links.type = type;
                    prop.links.target = member;
                    member = prop;
                    allPropertiesTable == null || allPropertiesTable.set(prop.escapedName, prop);
                    if (contextualType && checkMode & 2 /* Inferential */  && !(checkMode & 4 /* SkipContextSensitive */ ) && (memberDecl.kind === 304 /* PropertyAssignment */  || memberDecl.kind === 175 /* MethodDeclaration */ ) && isContextSensitive(memberDecl)) {
                        const inferenceContext = getInferenceContext(node);
                        Debug.assert(inferenceContext);
                        const inferenceNode = memberDecl.kind === 304 /* PropertyAssignment */  ? memberDecl.initializer : memberDecl;
                        addIntraExpressionInferenceSite(inferenceContext, inferenceNode, type);
                    }
                } else if (memberDecl.kind === 306 /* SpreadAssignment */ ) {
                    if (languageVersion < LanguageFeatureMinimumTarget.ObjectAssign) checkExternalEmitHelpers(memberDecl, 2 /* Assign */ );
                    if (propertiesArray.length > 0) {
                        spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, objectFlags, inConstContext);
                        propertiesArray = [];
                        propertiesTable = createSymbolTable();
                        hasComputedStringProperty = false;
                        hasComputedNumberProperty = false;
                        hasComputedSymbolProperty = false;
                    }
                    const type = getReducedType(checkExpression(memberDecl.expression, checkMode & 2 /* Inferential */ ));
                    if (isValidSpreadType(type)) {
                        const mergedType = tryMergeUnionOfObjectTypeAndEmptyObject(type, inConstContext);
                        if (allPropertiesTable) checkSpreadPropOverrides(mergedType, allPropertiesTable, memberDecl);
                        offset = propertiesArray.length;
                        if (isErrorType(spread)) continue;
                        spread = getSpreadType(spread, mergedType, node.symbol, objectFlags, inConstContext);
                    } else {
                        error2(memberDecl, Diagnostics.Spread_types_may_only_be_created_from_object_types);
                        spread = errorType;
                    }
                    continue;
                } else {
                    Debug.assert(memberDecl.kind === 178 /* GetAccessor */  || memberDecl.kind === 179 /* SetAccessor */ );
                    checkNodeDeferred(memberDecl);
                }
                if (computedNameType && !(computedNameType.flags & 8576 /* StringOrNumberLiteralOrUnique */ )) {
                    if (isTypeAssignableTo(computedNameType, stringNumberSymbolType)) {
                        if (isTypeAssignableTo(computedNameType, numberType)) hasComputedNumberProperty = true;
                        else if (isTypeAssignableTo(computedNameType, esSymbolType)) hasComputedSymbolProperty = true;
                        else hasComputedStringProperty = true;
                        if (inDestructuringPattern) patternWithComputedProperties = true;
                    }
                } else propertiesTable.set(member.escapedName, member);
                propertiesArray.push(member);
            }
            popContextualType();
            if (isErrorType(spread)) return errorType;
            if (spread !== emptyObjectType) {
                if (propertiesArray.length > 0) {
                    spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, objectFlags, inConstContext);
                    propertiesArray = [];
                    propertiesTable = createSymbolTable();
                    hasComputedStringProperty = false;
                    hasComputedNumberProperty = false;
                }
                return mapType(spread, (t)=>t === emptyObjectType ? createObjectLiteralType() : t);
            }
            return createObjectLiteralType();
            function createObjectLiteralType() {
                const indexInfos = [];
                const isReadonly = isConstContext(node);
                if (hasComputedStringProperty) indexInfos.push(getObjectLiteralIndexInfo(isReadonly, offset, propertiesArray, stringType));
                if (hasComputedNumberProperty) indexInfos.push(getObjectLiteralIndexInfo(isReadonly, offset, propertiesArray, numberType));
                if (hasComputedSymbolProperty) indexInfos.push(getObjectLiteralIndexInfo(isReadonly, offset, propertiesArray, esSymbolType));
                const result = createAnonymousType(node.symbol, propertiesTable, emptyArray, emptyArray, indexInfos);
                result.objectFlags |= objectFlags | 131200 /* ContainsObjectOrArrayLiteral */ ;
                if (isJSObjectLiteral) result.objectFlags |= 4096 /* JSLiteral */ ;
                if (patternWithComputedProperties) result.objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */ ;
                if (inDestructuringPattern) result.pattern = node;
                return result;
            }
        }
        function isValidSpreadType(type) {
            const t = removeDefinitelyFalsyTypes(mapType(type, getBaseConstraintOrType));
            return !!(t.flags & 126615553 /* InstantiableNonPrimitive */  || t.flags & 3145728 /* UnionOrIntersection */  && every(t.types, isValidSpreadType));
        }
        function checkJsxSelfClosingElementDeferred(node) {
            checkJsxOpeningLikeElementOrOpeningFragment(node);
        }
        function checkJsxSelfClosingElement(node, _checkMode) {
            checkNodeDeferred(node);
            return getJsxElementTypeAt(node) || anyType;
        }
        function checkJsxElementDeferred(node) {
            checkJsxOpeningLikeElementOrOpeningFragment(node.openingElement);
            if (isJsxIntrinsicTagName(node.closingElement.tagName)) getIntrinsicTagSymbol(node.closingElement);
            else checkExpression(node.closingElement.tagName);
            checkJsxChildren(node);
        }
        function checkJsxElement(node, _checkMode) {
            checkNodeDeferred(node);
            return getJsxElementTypeAt(node) || anyType;
        }
        function checkJsxFragment(node) {
            checkJsxOpeningLikeElementOrOpeningFragment(node.openingFragment);
            const nodeSourceFile = getSourceFileOfNode(node);
            if (getJSXTransformEnabled(compilerOptions) && (compilerOptions.jsxFactory || nodeSourceFile.pragmas.has("jsx")) && !compilerOptions.jsxFragmentFactory && !nodeSourceFile.pragmas.has("jsxfrag")) error2(node, compilerOptions.jsxFactory ? Diagnostics.The_jsxFragmentFactory_compiler_option_must_be_provided_to_use_JSX_fragments_with_the_jsxFactory_compiler_option : Diagnostics.An_jsxFrag_pragma_is_required_when_using_an_jsx_pragma_with_JSX_fragments);
            checkJsxChildren(node);
            const jsxElementType = getJsxElementTypeAt(node);
            return isErrorType(jsxElementType) ? anyType : jsxElementType;
        }
        function isHyphenatedJsxName(name) {
            return name.includes("-");
        }
        function isJsxIntrinsicTagName(tagName) {
            return isIdentifier(tagName) && isIntrinsicJsxName(tagName.escapedText) || isJsxNamespacedName(tagName);
        }
        function checkJsxAttribute(node, checkMode) {
            return node.initializer ? checkExpressionForMutableLocation(node.initializer, checkMode) : trueType;
        }
        function createJsxAttributesTypeFromAttributesProperty(openingLikeElement, checkMode = 0 /* Normal */ ) {
            const allAttributesTable = strictNullChecks ? createSymbolTable() : void 0;
            let attributesTable = createSymbolTable();
            let spread = emptyJsxObjectType;
            let hasSpreadAnyType = false;
            let typeToIntersect;
            let explicitlySpecifyChildrenAttribute = false;
            let objectFlags = 2048 /* JsxAttributes */ ;
            const jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(openingLikeElement));
            const isJsxOpenFragment = isJsxOpeningFragment(openingLikeElement);
            let attributesSymbol;
            let attributeParent = openingLikeElement;
            if (!isJsxOpenFragment) {
                const attributes = openingLikeElement.attributes;
                attributesSymbol = attributes.symbol;
                attributeParent = attributes;
                const contextualType = getContextualType2(attributes, 0 /* None */ );
                for (const attributeDecl of attributes.properties){
                    const member = attributeDecl.symbol;
                    if (isJsxAttribute(attributeDecl)) {
                        const exprType = checkJsxAttribute(attributeDecl, checkMode);
                        objectFlags |= getObjectFlags(exprType) & 458752 /* PropagatingFlags */ ;
                        const attributeSymbol = createSymbol(4 /* Property */  | member.flags, member.escapedName);
                        attributeSymbol.declarations = member.declarations;
                        attributeSymbol.parent = member.parent;
                        if (member.valueDeclaration) attributeSymbol.valueDeclaration = member.valueDeclaration;
                        attributeSymbol.links.type = exprType;
                        attributeSymbol.links.target = member;
                        attributesTable.set(attributeSymbol.escapedName, attributeSymbol);
                        allAttributesTable == null || allAttributesTable.set(attributeSymbol.escapedName, attributeSymbol);
                        if (getEscapedTextOfJsxAttributeName(attributeDecl.name) === jsxChildrenPropertyName) explicitlySpecifyChildrenAttribute = true;
                        if (contextualType) {
                            const prop = getPropertyOfType(contextualType, member.escapedName);
                            if (prop && prop.declarations && isDeprecatedSymbol(prop) && isIdentifier(attributeDecl.name)) addDeprecatedSuggestion(attributeDecl.name, prop.declarations, attributeDecl.name.escapedText);
                        }
                        if (contextualType && checkMode & 2 /* Inferential */  && !(checkMode & 4 /* SkipContextSensitive */ ) && isContextSensitive(attributeDecl)) {
                            const inferenceContext = getInferenceContext(attributes);
                            Debug.assert(inferenceContext);
                            const inferenceNode = attributeDecl.initializer.expression;
                            addIntraExpressionInferenceSite(inferenceContext, inferenceNode, exprType);
                        }
                    } else {
                        Debug.assert(attributeDecl.kind === 294 /* JsxSpreadAttribute */ );
                        if (attributesTable.size > 0) {
                            spread = getSpreadType(spread, createJsxAttributesTypeHelper(), attributes.symbol, objectFlags, /*readonly*/ false);
                            attributesTable = createSymbolTable();
                        }
                        const exprType = getReducedType(checkExpression(attributeDecl.expression, checkMode & 2 /* Inferential */ ));
                        if (isTypeAny(exprType)) hasSpreadAnyType = true;
                        if (isValidSpreadType(exprType)) {
                            spread = getSpreadType(spread, exprType, attributes.symbol, objectFlags, /*readonly*/ false);
                            if (allAttributesTable) checkSpreadPropOverrides(exprType, allAttributesTable, attributeDecl);
                        } else {
                            error2(attributeDecl.expression, Diagnostics.Spread_types_may_only_be_created_from_object_types);
                            typeToIntersect = typeToIntersect ? getIntersectionType([
                                typeToIntersect,
                                exprType
                            ]) : exprType;
                        }
                    }
                }
                if (!hasSpreadAnyType) {
                    if (attributesTable.size > 0) spread = getSpreadType(spread, createJsxAttributesTypeHelper(), attributes.symbol, objectFlags, /*readonly*/ false);
                }
            }
            const parent2 = openingLikeElement.parent;
            if ((isJsxElement(parent2) && parent2.openingElement === openingLikeElement || isJsxFragment(parent2) && parent2.openingFragment === openingLikeElement) && getSemanticJsxChildren(parent2.children).length > 0) {
                const childrenTypes = checkJsxChildren(parent2, checkMode);
                if (!hasSpreadAnyType && jsxChildrenPropertyName && jsxChildrenPropertyName !== "") {
                    if (explicitlySpecifyChildrenAttribute) error2(attributeParent, Diagnostics._0_are_specified_twice_The_attribute_named_0_will_be_overwritten, unescapeLeadingUnderscores(jsxChildrenPropertyName));
                    const contextualType = isJsxOpeningElement(openingLikeElement) ? getApparentTypeOfContextualType(openingLikeElement.attributes, /*contextFlags*/ void 0) : void 0;
                    const childrenContextualType = contextualType && getTypeOfPropertyOfContextualType(contextualType, jsxChildrenPropertyName);
                    const childrenPropSymbol = createSymbol(4 /* Property */ , jsxChildrenPropertyName);
                    childrenPropSymbol.links.type = childrenTypes.length === 1 ? childrenTypes[0] : childrenContextualType && someType(childrenContextualType, isTupleLikeType) ? createTupleType(childrenTypes) : createArrayType(getUnionType(childrenTypes));
                    childrenPropSymbol.valueDeclaration = factory.createPropertySignature(/*modifiers*/ void 0, unescapeLeadingUnderscores(jsxChildrenPropertyName), /*questionToken*/ void 0, /*type*/ void 0);
                    setParent(childrenPropSymbol.valueDeclaration, attributeParent);
                    childrenPropSymbol.valueDeclaration.symbol = childrenPropSymbol;
                    const childPropMap = createSymbolTable();
                    childPropMap.set(jsxChildrenPropertyName, childrenPropSymbol);
                    spread = getSpreadType(spread, createAnonymousType(attributesSymbol, childPropMap, emptyArray, emptyArray, emptyArray), attributesSymbol, objectFlags, /*readonly*/ false);
                }
            }
            if (hasSpreadAnyType) return anyType;
            if (typeToIntersect && spread !== emptyJsxObjectType) return getIntersectionType([
                typeToIntersect,
                spread
            ]);
            return typeToIntersect || (spread === emptyJsxObjectType ? createJsxAttributesTypeHelper() : spread);
            function createJsxAttributesTypeHelper() {
                objectFlags |= 8192 /* FreshLiteral */ ;
                return createJsxAttributesType(objectFlags, attributesSymbol, attributesTable);
            }
        }
        function createJsxAttributesType(objectFlags, attributesSymbol, attributesTable) {
            const result = createAnonymousType(attributesSymbol, attributesTable, emptyArray, emptyArray, emptyArray);
            result.objectFlags |= objectFlags | 139392 /* ContainsObjectOrArrayLiteral */ ;
            return result;
        }
        function checkJsxChildren(node, checkMode) {
            const childrenTypes = [];
            for (const child of node.children){
                if (child.kind === 12 /* JsxText */ ) {
                    if (!child.containsOnlyTriviaWhiteSpaces) childrenTypes.push(stringType);
                } else if (child.kind === 295 /* JsxExpression */  && !child.expression) continue;
                else childrenTypes.push(checkExpressionForMutableLocation(child, checkMode));
            }
            return childrenTypes;
        }
        function checkSpreadPropOverrides(type, props, spread) {
            for (const right of getPropertiesOfType(type))if (!(right.flags & 16777216 /* Optional */ )) {
                const left = props.get(right.escapedName);
                if (left) {
                    const diagnostic = error2(left.valueDeclaration, Diagnostics._0_is_specified_more_than_once_so_this_usage_will_be_overwritten, unescapeLeadingUnderscores(left.escapedName));
                    addRelatedInfo(diagnostic, createDiagnosticForNode(spread, Diagnostics.This_spread_always_overwrites_this_property));
                }
            }
        }
        function checkJsxAttributes(node, checkMode) {
            return createJsxAttributesTypeFromAttributesProperty(node.parent, checkMode);
        }
        function getJsxType(name, location) {
            const namespace = getJsxNamespaceAt(location);
            const exports2 = namespace && getExportsOfSymbol(namespace);
            const typeSymbol = exports2 && getSymbol2(exports2, name, 788968 /* Type */ );
            return typeSymbol ? getDeclaredTypeOfSymbol(typeSymbol) : errorType;
        }
        function getIntrinsicTagSymbol(node) {
            const links = getNodeLinks(node);
            if (!links.resolvedSymbol) {
                const intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, node);
                if (!isErrorType(intrinsicElementsType)) {
                    if (!isIdentifier(node.tagName) && !isJsxNamespacedName(node.tagName)) return Debug.fail();
                    const propName = isJsxNamespacedName(node.tagName) ? getEscapedTextOfJsxNamespacedName(node.tagName) : node.tagName.escapedText;
                    const intrinsicProp = getPropertyOfType(intrinsicElementsType, propName);
                    if (intrinsicProp) {
                        links.jsxFlags |= 1 /* IntrinsicNamedElement */ ;
                        return links.resolvedSymbol = intrinsicProp;
                    }
                    const indexSymbol = getApplicableIndexSymbol(intrinsicElementsType, getStringLiteralType(unescapeLeadingUnderscores(propName)));
                    if (indexSymbol) {
                        links.jsxFlags |= 2 /* IntrinsicIndexedElement */ ;
                        return links.resolvedSymbol = indexSymbol;
                    }
                    if (getTypeOfPropertyOrIndexSignatureOfType(intrinsicElementsType, propName)) {
                        links.jsxFlags |= 2 /* IntrinsicIndexedElement */ ;
                        return links.resolvedSymbol = intrinsicElementsType.symbol;
                    }
                    error2(node, Diagnostics.Property_0_does_not_exist_on_type_1, intrinsicTagNameToString(node.tagName), "JSX." + JsxNames.IntrinsicElements);
                    return links.resolvedSymbol = unknownSymbol;
                } else {
                    if (noImplicitAny) error2(node, Diagnostics.JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists, unescapeLeadingUnderscores(JsxNames.IntrinsicElements));
                    return links.resolvedSymbol = unknownSymbol;
                }
            }
            return links.resolvedSymbol;
        }
        function getJsxNamespaceContainerForImplicitImport(location) {
            const file = location && getSourceFileOfNode(location);
            const links = file && getNodeLinks(file);
            if (links && links.jsxImplicitImportContainer === false) return void 0;
            if (links && links.jsxImplicitImportContainer) return links.jsxImplicitImportContainer;
            const runtimeImportSpecifier = getJSXRuntimeImport(getJSXImplicitImportBase(compilerOptions, file), compilerOptions);
            if (!runtimeImportSpecifier) return void 0;
            const isClassic = getEmitModuleResolutionKind(compilerOptions) === 1 /* Classic */ ;
            const errorMessage = isClassic ? Diagnostics.Cannot_find_module_0_Did_you_mean_to_set_the_moduleResolution_option_to_nodenext_or_to_add_aliases_to_the_paths_option : Diagnostics.This_JSX_tag_requires_the_module_path_0_to_exist_but_none_could_be_found_Make_sure_you_have_types_for_the_appropriate_package_installed;
            const specifier = getJSXRuntimeImportSpecifier(file, runtimeImportSpecifier);
            const mod = resolveExternalModule(specifier || location, runtimeImportSpecifier, errorMessage, location);
            const result = mod && mod !== unknownSymbol ? getMergedSymbol(resolveSymbol(mod)) : void 0;
            if (links) links.jsxImplicitImportContainer = result || false;
            return result;
        }
        function getJsxNamespaceAt(location) {
            const links = location && getNodeLinks(location);
            if (links && links.jsxNamespace) return links.jsxNamespace;
            if (!links || links.jsxNamespace !== false) {
                let resolvedNamespace = getJsxNamespaceContainerForImplicitImport(location);
                if (!resolvedNamespace || resolvedNamespace === unknownSymbol) {
                    const namespaceName = getJsxNamespace(location);
                    resolvedNamespace = resolveName(location, namespaceName, 1920 /* Namespace */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
                }
                if (resolvedNamespace) {
                    const candidate = resolveSymbol(getSymbol2(getExportsOfSymbol(resolveSymbol(resolvedNamespace)), JsxNames.JSX, 1920 /* Namespace */ ));
                    if (candidate && candidate !== unknownSymbol) {
                        if (links) links.jsxNamespace = candidate;
                        return candidate;
                    }
                }
                if (links) links.jsxNamespace = false;
            }
            const s = resolveSymbol(getGlobalSymbol(JsxNames.JSX, 1920 /* Namespace */ , /*diagnostic*/ void 0));
            if (s === unknownSymbol) return void 0;
            return s;
        }
        function getNameFromJsxElementAttributesContainer(nameOfAttribPropContainer, jsxNamespace) {
            const jsxElementAttribPropInterfaceSym = jsxNamespace && getSymbol2(jsxNamespace.exports, nameOfAttribPropContainer, 788968 /* Type */ );
            const jsxElementAttribPropInterfaceType = jsxElementAttribPropInterfaceSym && getDeclaredTypeOfSymbol(jsxElementAttribPropInterfaceSym);
            const propertiesOfJsxElementAttribPropInterface = jsxElementAttribPropInterfaceType && getPropertiesOfType(jsxElementAttribPropInterfaceType);
            if (propertiesOfJsxElementAttribPropInterface) {
                if (propertiesOfJsxElementAttribPropInterface.length === 0) return "";
                else if (propertiesOfJsxElementAttribPropInterface.length === 1) return propertiesOfJsxElementAttribPropInterface[0].escapedName;
                else if (propertiesOfJsxElementAttribPropInterface.length > 1 && jsxElementAttribPropInterfaceSym.declarations) error2(jsxElementAttribPropInterfaceSym.declarations[0], Diagnostics.The_global_type_JSX_0_may_not_have_more_than_one_property, unescapeLeadingUnderscores(nameOfAttribPropContainer));
            }
            return void 0;
        }
        function getJsxLibraryManagedAttributes(jsxNamespace) {
            return jsxNamespace && getSymbol2(jsxNamespace.exports, JsxNames.LibraryManagedAttributes, 788968 /* Type */ );
        }
        function getJsxElementTypeSymbol(jsxNamespace) {
            return jsxNamespace && getSymbol2(jsxNamespace.exports, JsxNames.ElementType, 788968 /* Type */ );
        }
        function getJsxElementPropertiesName(jsxNamespace) {
            return getNameFromJsxElementAttributesContainer(JsxNames.ElementAttributesPropertyNameContainer, jsxNamespace);
        }
        function getJsxElementChildrenPropertyName(jsxNamespace) {
            if (compilerOptions.jsx === 4 /* ReactJSX */  || compilerOptions.jsx === 5 /* ReactJSXDev */ ) return "children";
            return getNameFromJsxElementAttributesContainer(JsxNames.ElementChildrenAttributeNameContainer, jsxNamespace);
        }
        function getUninstantiatedJsxSignaturesOfType(elementType, caller) {
            if (elementType.flags & 4 /* String */ ) return [
                anySignature
            ];
            else if (elementType.flags & 128 /* StringLiteral */ ) {
                const intrinsicType = getIntrinsicAttributesTypeFromStringLiteralType(elementType, caller);
                if (!intrinsicType) {
                    error2(caller, Diagnostics.Property_0_does_not_exist_on_type_1, elementType.value, "JSX." + JsxNames.IntrinsicElements);
                    return emptyArray;
                } else {
                    const fakeSignature = createSignatureForJSXIntrinsic(caller, intrinsicType);
                    return [
                        fakeSignature
                    ];
                }
            }
            const apparentElemType = getApparentType(elementType);
            let signatures = getSignaturesOfType(apparentElemType, 1 /* Construct */ );
            if (signatures.length === 0) signatures = getSignaturesOfType(apparentElemType, 0 /* Call */ );
            if (signatures.length === 0 && apparentElemType.flags & 1048576 /* Union */ ) signatures = getUnionSignatures(map(apparentElemType.types, (t)=>getUninstantiatedJsxSignaturesOfType(t, caller)));
            return signatures;
        }
        function getIntrinsicAttributesTypeFromStringLiteralType(type, location) {
            const intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, location);
            if (!isErrorType(intrinsicElementsType)) {
                const stringLiteralTypeName = type.value;
                const intrinsicProp = getPropertyOfType(intrinsicElementsType, escapeLeadingUnderscores(stringLiteralTypeName));
                if (intrinsicProp) return getTypeOfSymbol(intrinsicProp);
                const indexSignatureType = getIndexTypeOfType(intrinsicElementsType, stringType);
                if (indexSignatureType) return indexSignatureType;
                return void 0;
            }
            return anyType;
        }
        function checkJsxReturnAssignableToAppropriateBound(refKind, elemInstanceType, openingLikeElement) {
            if (refKind === 1 /* Function */ ) {
                const sfcReturnConstraint = getJsxStatelessElementTypeAt(openingLikeElement);
                if (sfcReturnConstraint) checkTypeRelatedTo(elemInstanceType, sfcReturnConstraint, assignableRelation, openingLikeElement.tagName, Diagnostics.Its_return_type_0_is_not_a_valid_JSX_element, generateInitialErrorChain);
            } else if (refKind === 0 /* Component */ ) {
                const classConstraint = getJsxElementClassTypeAt(openingLikeElement);
                if (classConstraint) checkTypeRelatedTo(elemInstanceType, classConstraint, assignableRelation, openingLikeElement.tagName, Diagnostics.Its_instance_type_0_is_not_a_valid_JSX_element, generateInitialErrorChain);
            } else {
                const sfcReturnConstraint = getJsxStatelessElementTypeAt(openingLikeElement);
                const classConstraint = getJsxElementClassTypeAt(openingLikeElement);
                if (!sfcReturnConstraint || !classConstraint) return;
                const combined = getUnionType([
                    sfcReturnConstraint,
                    classConstraint
                ]);
                checkTypeRelatedTo(elemInstanceType, combined, assignableRelation, openingLikeElement.tagName, Diagnostics.Its_element_type_0_is_not_a_valid_JSX_element, generateInitialErrorChain);
            }
            function generateInitialErrorChain() {
                const componentName = getTextOfNode(openingLikeElement.tagName);
                return chainDiagnosticMessages(/*details*/ void 0, Diagnostics._0_cannot_be_used_as_a_JSX_component, componentName);
            }
        }
        function getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node) {
            var _a;
            Debug.assert(isJsxIntrinsicTagName(node.tagName));
            const links = getNodeLinks(node);
            if (!links.resolvedJsxElementAttributesType) {
                const symbol = getIntrinsicTagSymbol(node);
                if (links.jsxFlags & 1 /* IntrinsicNamedElement */ ) return links.resolvedJsxElementAttributesType = getTypeOfSymbol(symbol) || errorType;
                else if (links.jsxFlags & 2 /* IntrinsicIndexedElement */ ) {
                    const propName = isJsxNamespacedName(node.tagName) ? getEscapedTextOfJsxNamespacedName(node.tagName) : node.tagName.escapedText;
                    return links.resolvedJsxElementAttributesType = ((_a = getApplicableIndexInfoForName(getJsxType(JsxNames.IntrinsicElements, node), propName)) == null ? void 0 : _a.type) || errorType;
                } else return links.resolvedJsxElementAttributesType = errorType;
            }
            return links.resolvedJsxElementAttributesType;
        }
        function getJsxElementClassTypeAt(location) {
            const type = getJsxType(JsxNames.ElementClass, location);
            if (isErrorType(type)) return void 0;
            return type;
        }
        function getJsxElementTypeAt(location) {
            return getJsxType(JsxNames.Element, location);
        }
        function getJsxStatelessElementTypeAt(location) {
            const jsxElementType = getJsxElementTypeAt(location);
            if (jsxElementType) return getUnionType([
                jsxElementType,
                nullType
            ]);
        }
        function getJsxElementTypeTypeAt(location) {
            const ns = getJsxNamespaceAt(location);
            if (!ns) return void 0;
            const sym = getJsxElementTypeSymbol(ns);
            if (!sym) return void 0;
            const type = instantiateAliasOrInterfaceWithDefaults(sym, isInJSFile(location));
            if (!type || isErrorType(type)) return void 0;
            return type;
        }
        function instantiateAliasOrInterfaceWithDefaults(managedSym, inJs, ...typeArguments) {
            const declaredManagedType = getDeclaredTypeOfSymbol(managedSym);
            if (managedSym.flags & 524288 /* TypeAlias */ ) {
                const params = getSymbolLinks(managedSym).typeParameters;
                if (length(params) >= typeArguments.length) {
                    const args = fillMissingTypeArguments(typeArguments, params, typeArguments.length, inJs);
                    return length(args) === 0 ? declaredManagedType : getTypeAliasInstantiation(managedSym, args);
                }
            }
            if (length(declaredManagedType.typeParameters) >= typeArguments.length) {
                const args = fillMissingTypeArguments(typeArguments, declaredManagedType.typeParameters, typeArguments.length, inJs);
                return createTypeReference(declaredManagedType, args);
            }
            return void 0;
        }
        function getJsxIntrinsicTagNamesAt(location) {
            const intrinsics = getJsxType(JsxNames.IntrinsicElements, location);
            return intrinsics ? getPropertiesOfType(intrinsics) : emptyArray;
        }
        function checkJsxPreconditions(errorNode) {
            if ((compilerOptions.jsx || 0 /* None */ ) === 0 /* None */ ) error2(errorNode, Diagnostics.Cannot_use_JSX_unless_the_jsx_flag_is_provided);
            if (getJsxElementTypeAt(errorNode) === void 0) {
                if (noImplicitAny) error2(errorNode, Diagnostics.JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist);
            }
        }
        function checkJsxOpeningLikeElementOrOpeningFragment(node) {
            const isNodeOpeningLikeElement = isJsxOpeningLikeElement(node);
            if (isNodeOpeningLikeElement) checkGrammarJsxElement(node);
            checkJsxPreconditions(node);
            markJsxAliasReferenced(node);
            const sig = getResolvedSignature(node);
            checkDeprecatedSignature(sig, node);
            if (isNodeOpeningLikeElement) {
                const jsxOpeningLikeNode = node;
                const elementTypeConstraint = getJsxElementTypeTypeAt(jsxOpeningLikeNode);
                if (elementTypeConstraint !== void 0) {
                    const tagName = jsxOpeningLikeNode.tagName;
                    const tagType = isJsxIntrinsicTagName(tagName) ? getStringLiteralType(intrinsicTagNameToString(tagName)) : checkExpression(tagName);
                    checkTypeRelatedTo(tagType, elementTypeConstraint, assignableRelation, tagName, Diagnostics.Its_type_0_is_not_a_valid_JSX_element_type, ()=>{
                        const componentName = getTextOfNode(tagName);
                        return chainDiagnosticMessages(/*details*/ void 0, Diagnostics._0_cannot_be_used_as_a_JSX_component, componentName);
                    });
                } else checkJsxReturnAssignableToAppropriateBound(getJsxReferenceKind(jsxOpeningLikeNode), getReturnTypeOfSignature(sig), jsxOpeningLikeNode);
            }
        }
        function isKnownProperty(targetType, name, isComparingJsxAttributes) {
            if (targetType.flags & 524288 /* Object */ ) {
                if (getPropertyOfObjectType(targetType, name) || getApplicableIndexInfoForName(targetType, name) || isLateBoundName(name) && getIndexInfoOfType(targetType, stringType) || isComparingJsxAttributes && isHyphenatedJsxName(name)) return true;
            }
            if (targetType.flags & 33554432 /* Substitution */ ) return isKnownProperty(targetType.baseType, name, isComparingJsxAttributes);
            if (targetType.flags & 3145728 /* UnionOrIntersection */  && isExcessPropertyCheckTarget(targetType)) for (const t of targetType.types){
                if (isKnownProperty(t, name, isComparingJsxAttributes)) return true;
            }
            return false;
        }
        function isExcessPropertyCheckTarget(type) {
            return !!(type.flags & 524288 /* Object */  && !(getObjectFlags(type) & 512 /* ObjectLiteralPatternWithComputedProperties */ ) || type.flags & 67108864 /* NonPrimitive */  || type.flags & 33554432 /* Substitution */  && isExcessPropertyCheckTarget(type.baseType) || type.flags & 1048576 /* Union */  && some(type.types, isExcessPropertyCheckTarget) || type.flags & 2097152 /* Intersection */  && every(type.types, isExcessPropertyCheckTarget));
        }
        function checkJsxExpression(node, checkMode) {
            checkGrammarJsxExpression(node);
            if (node.expression) {
                const type = checkExpression(node.expression, checkMode);
                if (node.dotDotDotToken && type !== anyType && !isArrayType(type)) error2(node, Diagnostics.JSX_spread_child_must_be_an_array_type);
                return type;
            } else return errorType;
        }
        function getDeclarationNodeFlagsFromSymbol(s) {
            return s.valueDeclaration ? getCombinedNodeFlagsCached(s.valueDeclaration) : 0;
        }
        function isPrototypeProperty(symbol) {
            if (symbol.flags & 8192 /* Method */  || getCheckFlags(symbol) & 4 /* SyntheticMethod */ ) return true;
            if (isInJSFile(symbol.valueDeclaration)) {
                const parent2 = symbol.valueDeclaration.parent;
                return parent2 && isBinaryExpression(parent2) && getAssignmentDeclarationKind(parent2) === 3 /* PrototypeProperty */ ;
            }
        }
        function checkPropertyAccessibility(node, isSuper, writing, type, prop, reportError = true) {
            const errorNode = !reportError ? void 0 : node.kind === 167 /* QualifiedName */  ? node.right : node.kind === 206 /* ImportType */  ? node : node.kind === 209 /* BindingElement */  && node.propertyName ? node.propertyName : node.name;
            return checkPropertyAccessibilityAtLocation(node, isSuper, writing, type, prop, errorNode);
        }
        function checkPropertyAccessibilityAtLocation(location, isSuper, writing, containingType, prop, errorNode) {
            var _a;
            const flags = getDeclarationModifierFlagsFromSymbol(prop, writing);
            if (isSuper) {
                if (languageVersion < 2 /* ES2015 */ ) {
                    if (symbolHasNonMethodDeclaration(prop)) {
                        if (errorNode) error2(errorNode, Diagnostics.Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword);
                        return false;
                    }
                }
                if (flags & 64 /* Abstract */ ) {
                    if (errorNode) error2(errorNode, Diagnostics.Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression, symbolToString(prop), typeToString(getDeclaringClass(prop)));
                    return false;
                }
                if (!(flags & 256 /* Static */ ) && ((_a = prop.declarations) == null ? void 0 : _a.some(isClassInstanceProperty))) {
                    if (errorNode) error2(errorNode, Diagnostics.Class_field_0_defined_by_the_parent_class_is_not_accessible_in_the_child_class_via_super, symbolToString(prop));
                    return false;
                }
            }
            if (flags & 64 /* Abstract */  && symbolHasNonMethodDeclaration(prop) && (isThisProperty(location) || isThisInitializedObjectBindingExpression(location) || isObjectBindingPattern(location.parent) && isThisInitializedDeclaration(location.parent.parent))) {
                const declaringClassDeclaration = getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
                if (declaringClassDeclaration && isNodeUsedDuringClassInitialization(location)) {
                    if (errorNode) error2(errorNode, Diagnostics.Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor, symbolToString(prop), getTextOfIdentifierOrLiteral(declaringClassDeclaration.name));
                    return false;
                }
            }
            if (!(flags & 6 /* NonPublicAccessibilityModifier */ )) return true;
            if (flags & 2 /* Private */ ) {
                const declaringClassDeclaration = getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
                if (!isNodeWithinClass(location, declaringClassDeclaration)) {
                    if (errorNode) error2(errorNode, Diagnostics.Property_0_is_private_and_only_accessible_within_class_1, symbolToString(prop), typeToString(getDeclaringClass(prop)));
                    return false;
                }
                return true;
            }
            if (isSuper) return true;
            let enclosingClass = forEachEnclosingClass(location, (enclosingDeclaration)=>{
                const enclosingClass2 = getDeclaredTypeOfSymbol(getSymbolOfDeclaration(enclosingDeclaration));
                return isClassDerivedFromDeclaringClasses(enclosingClass2, prop, writing);
            });
            if (!enclosingClass) {
                enclosingClass = getEnclosingClassFromThisParameter(location);
                enclosingClass = enclosingClass && isClassDerivedFromDeclaringClasses(enclosingClass, prop, writing);
                if (flags & 256 /* Static */  || !enclosingClass) {
                    if (errorNode) error2(errorNode, Diagnostics.Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses, symbolToString(prop), typeToString(getDeclaringClass(prop) || containingType));
                    return false;
                }
            }
            if (flags & 256 /* Static */ ) return true;
            if (containingType.flags & 262144 /* TypeParameter */ ) containingType = containingType.isThisType ? getConstraintOfTypeParameter(containingType) : getBaseConstraintOfType(containingType);
            if (!containingType || !hasBaseType(containingType, enclosingClass)) {
                if (errorNode) error2(errorNode, Diagnostics.Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_This_is_an_instance_of_class_2, symbolToString(prop), typeToString(enclosingClass), typeToString(containingType));
                return false;
            }
            return true;
        }
        function getEnclosingClassFromThisParameter(node) {
            const thisParameter = getThisParameterFromNodeContext(node);
            let thisType = (thisParameter == null ? void 0 : thisParameter.type) && getTypeFromTypeNode(thisParameter.type);
            if (thisType) {
                if (thisType.flags & 262144 /* TypeParameter */ ) thisType = getConstraintOfTypeParameter(thisType);
            } else {
                const thisContainer = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (isFunctionLike(thisContainer)) thisType = getContextualThisParameterType(thisContainer);
            }
            if (thisType && getObjectFlags(thisType) & 7 /* Reference */ ) return getTargetType(thisType);
            return void 0;
        }
        function getThisParameterFromNodeContext(node) {
            const thisContainer = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            return thisContainer && isFunctionLike(thisContainer) ? getThisParameter(thisContainer) : void 0;
        }
        function symbolHasNonMethodDeclaration(symbol) {
            return !!forEachProperty2(symbol, (prop)=>!(prop.flags & 8192 /* Method */ ));
        }
        function checkNonNullExpression(node) {
            return checkNonNullType(checkExpression(node), node);
        }
        function isNullableType(type) {
            return hasTypeFacts(type, 50331648 /* IsUndefinedOrNull */ );
        }
        function getNonNullableTypeIfNeeded(type) {
            return isNullableType(type) ? getNonNullableType(type) : type;
        }
        function reportObjectPossiblyNullOrUndefinedError(node, facts) {
            const nodeText2 = isEntityNameExpression(node) ? entityNameToString(node) : void 0;
            if (node.kind === 106 /* NullKeyword */ ) {
                error2(node, Diagnostics.The_value_0_cannot_be_used_here, "null");
                return;
            }
            if (nodeText2 !== void 0 && nodeText2.length < 100) {
                if (isIdentifier(node) && nodeText2 === "undefined") {
                    error2(node, Diagnostics.The_value_0_cannot_be_used_here, "undefined");
                    return;
                }
                error2(node, facts & 16777216 /* IsUndefined */  ? facts & 33554432 /* IsNull */  ? Diagnostics._0_is_possibly_null_or_undefined : Diagnostics._0_is_possibly_undefined : Diagnostics._0_is_possibly_null, nodeText2);
            } else error2(node, facts & 16777216 /* IsUndefined */  ? facts & 33554432 /* IsNull */  ? Diagnostics.Object_is_possibly_null_or_undefined : Diagnostics.Object_is_possibly_undefined : Diagnostics.Object_is_possibly_null);
        }
        function reportCannotInvokePossiblyNullOrUndefinedError(node, facts) {
            error2(node, facts & 16777216 /* IsUndefined */  ? facts & 33554432 /* IsNull */  ? Diagnostics.Cannot_invoke_an_object_which_is_possibly_null_or_undefined : Diagnostics.Cannot_invoke_an_object_which_is_possibly_undefined : Diagnostics.Cannot_invoke_an_object_which_is_possibly_null);
        }
        function checkNonNullTypeWithReporter(type, node, reportError) {
            if (strictNullChecks && type.flags & 2 /* Unknown */ ) {
                if (isEntityNameExpression(node)) {
                    const nodeText2 = entityNameToString(node);
                    if (nodeText2.length < 100) {
                        error2(node, Diagnostics._0_is_of_type_unknown, nodeText2);
                        return errorType;
                    }
                }
                error2(node, Diagnostics.Object_is_of_type_unknown);
                return errorType;
            }
            const facts = getTypeFacts(type, 50331648 /* IsUndefinedOrNull */ );
            if (facts & 50331648 /* IsUndefinedOrNull */ ) {
                reportError(node, facts);
                const t = getNonNullableType(type);
                return t.flags & 229376 /* Never */  ? errorType : t;
            }
            return type;
        }
        function checkNonNullType(type, node) {
            return checkNonNullTypeWithReporter(type, node, reportObjectPossiblyNullOrUndefinedError);
        }
        function checkNonNullNonVoidType(type, node) {
            const nonNullType = checkNonNullType(type, node);
            if (nonNullType.flags & 16384 /* Void */ ) {
                if (isEntityNameExpression(node)) {
                    const nodeText2 = entityNameToString(node);
                    if (isIdentifier(node) && nodeText2 === "undefined") {
                        error2(node, Diagnostics.The_value_0_cannot_be_used_here, nodeText2);
                        return nonNullType;
                    }
                    if (nodeText2.length < 100) {
                        error2(node, Diagnostics._0_is_possibly_undefined, nodeText2);
                        return nonNullType;
                    }
                }
                error2(node, Diagnostics.Object_is_possibly_undefined);
            }
            return nonNullType;
        }
        function checkPropertyAccessExpression(node, checkMode, writeOnly) {
            return node.flags & 64 /* OptionalChain */  ? checkPropertyAccessChain(node, checkMode) : checkPropertyAccessExpressionOrQualifiedName(node, node.expression, checkNonNullExpression(node.expression), node.name, checkMode, writeOnly);
        }
        function checkPropertyAccessChain(node, checkMode) {
            const leftType = checkExpression(node.expression);
            const nonOptionalType = getOptionalExpressionType(leftType, node.expression);
            return propagateOptionalTypeMarker(checkPropertyAccessExpressionOrQualifiedName(node, node.expression, checkNonNullType(nonOptionalType, node.expression), node.name, checkMode), node, nonOptionalType !== leftType);
        }
        function checkQualifiedName(node, checkMode) {
            const leftType = isPartOfTypeQuery(node) && isThisIdentifier(node.left) ? checkNonNullType(checkThisExpression(node.left), node.left) : checkNonNullExpression(node.left);
            return checkPropertyAccessExpressionOrQualifiedName(node, node.left, leftType, node.right, checkMode);
        }
        function isMethodAccessForCall(node) {
            while(node.parent.kind === 218 /* ParenthesizedExpression */ )node = node.parent;
            return isCallOrNewExpression(node.parent) && node.parent.expression === node;
        }
        function lookupSymbolForPrivateIdentifierDeclaration(propName, location) {
            for(let containingClass = getContainingClassExcludingClassDecorators(location); !!containingClass; containingClass = getContainingClass(containingClass)){
                const { symbol } = containingClass;
                const name = getSymbolNameForPrivateIdentifier(symbol, propName);
                const prop = symbol.members && symbol.members.get(name) || symbol.exports && symbol.exports.get(name);
                if (prop) return prop;
            }
        }
        function checkGrammarPrivateIdentifierExpression(privId) {
            if (!getContainingClass(privId)) return grammarErrorOnNode(privId, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
            if (!isForInStatement(privId.parent)) {
                if (!isExpressionNode(privId)) return grammarErrorOnNode(privId, Diagnostics.Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression);
                const isInOperation = isBinaryExpression(privId.parent) && privId.parent.operatorToken.kind === 103 /* InKeyword */ ;
                if (!getSymbolForPrivateIdentifierExpression(privId) && !isInOperation) return grammarErrorOnNode(privId, Diagnostics.Cannot_find_name_0, idText(privId));
            }
            return false;
        }
        function checkPrivateIdentifierExpression(privId) {
            checkGrammarPrivateIdentifierExpression(privId);
            const symbol = getSymbolForPrivateIdentifierExpression(privId);
            if (symbol) markPropertyAsReferenced(symbol, /*nodeForCheckWriteOnly*/ void 0, /*isSelfTypeAccess*/ false);
            return anyType;
        }
        function getSymbolForPrivateIdentifierExpression(privId) {
            if (!isExpressionNode(privId)) return void 0;
            const links = getNodeLinks(privId);
            if (links.resolvedSymbol === void 0) links.resolvedSymbol = lookupSymbolForPrivateIdentifierDeclaration(privId.escapedText, privId);
            return links.resolvedSymbol;
        }
        function getPrivateIdentifierPropertyOfType(leftType, lexicallyScopedIdentifier) {
            return getPropertyOfType(leftType, lexicallyScopedIdentifier.escapedName);
        }
        function checkPrivateIdentifierPropertyAccess(leftType, right, lexicallyScopedIdentifier) {
            let propertyOnType;
            const properties = getPropertiesOfType(leftType);
            if (properties) forEach(properties, (symbol)=>{
                const decl = symbol.valueDeclaration;
                if (decl && isNamedDeclaration(decl) && isPrivateIdentifier(decl.name) && decl.name.escapedText === right.escapedText) {
                    propertyOnType = symbol;
                    return true;
                }
            });
            const diagName = diagnosticName(right);
            if (propertyOnType) {
                const typeValueDecl = Debug.checkDefined(propertyOnType.valueDeclaration);
                const typeClass = Debug.checkDefined(getContainingClass(typeValueDecl));
                if (lexicallyScopedIdentifier == null ? void 0 : lexicallyScopedIdentifier.valueDeclaration) {
                    const lexicalValueDecl = lexicallyScopedIdentifier.valueDeclaration;
                    const lexicalClass = getContainingClass(lexicalValueDecl);
                    Debug.assert(!!lexicalClass);
                    if (findAncestor(lexicalClass, (n)=>typeClass === n)) {
                        const diagnostic = error2(right, Diagnostics.The_property_0_cannot_be_accessed_on_type_1_within_this_class_because_it_is_shadowed_by_another_private_identifier_with_the_same_spelling, diagName, typeToString(leftType));
                        addRelatedInfo(diagnostic, createDiagnosticForNode(lexicalValueDecl, Diagnostics.The_shadowing_declaration_of_0_is_defined_here, diagName), createDiagnosticForNode(typeValueDecl, Diagnostics.The_declaration_of_0_that_you_probably_intended_to_use_is_defined_here, diagName));
                        return true;
                    }
                }
                error2(right, Diagnostics.Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier, diagName, diagnosticName(typeClass.name || anon));
                return true;
            }
            return false;
        }
        function isThisPropertyAccessInConstructor(node, prop) {
            return (isConstructorDeclaredProperty(prop) || isThisProperty(node) && isAutoTypedProperty(prop)) && getThisContainer(node, /*includeArrowFunctions*/ true, /*includeClassComputedPropertyName*/ false) === getDeclaringConstructor(prop);
        }
        function checkPropertyAccessExpressionOrQualifiedName(node, left, leftType, right, checkMode, writeOnly) {
            const parentSymbol = getNodeLinks(left).resolvedSymbol;
            const assignmentKind = getAssignmentTargetKind(node);
            const apparentType = getApparentType(assignmentKind !== 0 /* None */  || isMethodAccessForCall(node) ? getWidenedType(leftType) : leftType);
            const isAnyLike = isTypeAny(apparentType) || apparentType === silentNeverType;
            let prop;
            if (isPrivateIdentifier(right)) {
                if (languageVersion < LanguageFeatureMinimumTarget.PrivateNamesAndClassStaticBlocks || languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators || !useDefineForClassFields) {
                    if (assignmentKind !== 0 /* None */ ) checkExternalEmitHelpers(node, 1048576 /* ClassPrivateFieldSet */ );
                    if (assignmentKind !== 1 /* Definite */ ) checkExternalEmitHelpers(node, 524288 /* ClassPrivateFieldGet */ );
                }
                const lexicallyScopedSymbol = lookupSymbolForPrivateIdentifierDeclaration(right.escapedText, right);
                if (assignmentKind && lexicallyScopedSymbol && lexicallyScopedSymbol.valueDeclaration && isMethodDeclaration(lexicallyScopedSymbol.valueDeclaration)) grammarErrorOnNode(right, Diagnostics.Cannot_assign_to_private_method_0_Private_methods_are_not_writable, idText(right));
                if (isAnyLike) {
                    if (lexicallyScopedSymbol) return isErrorType(apparentType) ? errorType : apparentType;
                    if (getContainingClassExcludingClassDecorators(right) === void 0) {
                        grammarErrorOnNode(right, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
                        return anyType;
                    }
                }
                prop = lexicallyScopedSymbol && getPrivateIdentifierPropertyOfType(leftType, lexicallyScopedSymbol);
                if (prop === void 0) {
                    if (checkPrivateIdentifierPropertyAccess(leftType, right, lexicallyScopedSymbol)) return errorType;
                    const containingClass = getContainingClassExcludingClassDecorators(right);
                    if (containingClass && isPlainJsFile(getSourceFileOfNode(containingClass), compilerOptions.checkJs)) grammarErrorOnNode(right, Diagnostics.Private_field_0_must_be_declared_in_an_enclosing_class, idText(right));
                } else {
                    const isSetonlyAccessor = prop.flags & 65536 /* SetAccessor */  && !(prop.flags & 32768 /* GetAccessor */ );
                    if (isSetonlyAccessor && assignmentKind !== 1 /* Definite */ ) error2(node, Diagnostics.Private_accessor_was_defined_without_a_getter);
                }
            } else {
                if (isAnyLike) {
                    if (isIdentifier(left) && parentSymbol) markLinkedReferences(node, 2 /* Property */ , /*propSymbol*/ void 0, leftType);
                    return isErrorType(apparentType) ? errorType : apparentType;
                }
                prop = getPropertyOfType(apparentType, right.escapedText, /*skipObjectFunctionPropertyAugment*/ isConstEnumObjectType(apparentType), /*includeTypeOnlyMembers*/ node.kind === 167 /* QualifiedName */ );
            }
            markLinkedReferences(node, 2 /* Property */ , prop, leftType);
            let propType;
            if (!prop) {
                const indexInfo = !isPrivateIdentifier(right) && (assignmentKind === 0 /* None */  || !isGenericObjectType(leftType) || isThisTypeParameter(leftType)) ? getApplicableIndexInfoForName(apparentType, right.escapedText) : void 0;
                if (!(indexInfo && indexInfo.type)) {
                    const isUncheckedJS = isUncheckedJSSuggestion(node, leftType.symbol, /*excludeClasses*/ true);
                    if (!isUncheckedJS && isJSLiteralType(leftType)) return anyType;
                    if (leftType.symbol === globalThisSymbol) {
                        if (globalThisSymbol.exports.has(right.escapedText) && globalThisSymbol.exports.get(right.escapedText).flags & 418 /* BlockScoped */ ) error2(right, Diagnostics.Property_0_does_not_exist_on_type_1, unescapeLeadingUnderscores(right.escapedText), typeToString(leftType));
                        else if (noImplicitAny) error2(right, Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature, typeToString(leftType));
                        return anyType;
                    }
                    if (right.escapedText && !checkAndReportErrorForExtendingInterface(node)) reportNonexistentProperty(right, isThisTypeParameter(leftType) ? apparentType : leftType, isUncheckedJS);
                    return errorType;
                }
                if (indexInfo.isReadonly && (isAssignmentTarget(node) || isDeleteTarget(node))) error2(node, Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(apparentType));
                propType = indexInfo.type;
                if (compilerOptions.noUncheckedIndexedAccess && getAssignmentTargetKind(node) !== 1 /* Definite */ ) propType = getUnionType([
                    propType,
                    missingType
                ]);
                if (compilerOptions.noPropertyAccessFromIndexSignature && isPropertyAccessExpression(node)) error2(right, Diagnostics.Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0, unescapeLeadingUnderscores(right.escapedText));
                if (indexInfo.declaration && isDeprecatedDeclaration2(indexInfo.declaration)) addDeprecatedSuggestion(right, [
                    indexInfo.declaration
                ], right.escapedText);
            } else {
                const targetPropSymbol = resolveAliasWithDeprecationCheck(prop, right);
                if (isDeprecatedSymbol(targetPropSymbol) && isUncalledFunctionReference(node, targetPropSymbol) && targetPropSymbol.declarations) addDeprecatedSuggestion(right, targetPropSymbol.declarations, right.escapedText);
                checkPropertyNotUsedBeforeDeclaration(prop, node, right);
                markPropertyAsReferenced(prop, node, isSelfTypeAccess(left, parentSymbol));
                getNodeLinks(node).resolvedSymbol = prop;
                checkPropertyAccessibility(node, left.kind === 108 /* SuperKeyword */ , isWriteAccess(node), apparentType, prop);
                if (isAssignmentToReadonlyEntity(node, prop, assignmentKind)) {
                    error2(right, Diagnostics.Cannot_assign_to_0_because_it_is_a_read_only_property, idText(right));
                    return errorType;
                }
                propType = isThisPropertyAccessInConstructor(node, prop) ? autoType : writeOnly || isWriteOnlyAccess(node) ? getWriteTypeOfSymbol(prop) : getTypeOfSymbol(prop);
            }
            return getFlowTypeOfAccessExpression(node, prop, propType, right, checkMode);
        }
        function isUncheckedJSSuggestion(node, suggestion, excludeClasses) {
            var _a;
            const file = getSourceFileOfNode(node);
            if (file) {
                if (compilerOptions.checkJs === void 0 && file.checkJsDirective === void 0 && (file.scriptKind === 1 /* JS */  || file.scriptKind === 2 /* JSX */ )) {
                    const declarationFile = forEach(suggestion == null ? void 0 : suggestion.declarations, getSourceFileOfNode);
                    const suggestionHasNoExtendsOrDecorators = !(suggestion == null ? void 0 : suggestion.valueDeclaration) || !isClassLike(suggestion.valueDeclaration) || ((_a = suggestion.valueDeclaration.heritageClauses) == null ? void 0 : _a.length) || classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, suggestion.valueDeclaration);
                    return !(file !== declarationFile && !!declarationFile && isGlobalSourceFile(declarationFile)) && !(excludeClasses && suggestion && suggestion.flags & 32 /* Class */  && suggestionHasNoExtendsOrDecorators) && !(!!node && excludeClasses && isPropertyAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */  && suggestionHasNoExtendsOrDecorators);
                }
            }
            return false;
        }
        function getFlowTypeOfAccessExpression(node, prop, propType, errorNode, checkMode) {
            const assignmentKind = getAssignmentTargetKind(node);
            if (assignmentKind === 1 /* Definite */ ) return removeMissingType(propType, !!(prop && prop.flags & 16777216 /* Optional */ ));
            if (prop && !(prop.flags & 98311 /* Accessor */ ) && !(prop.flags & 8192 /* Method */  && propType.flags & 1048576 /* Union */ ) && !isDuplicatedCommonJSExport(prop.declarations)) return propType;
            if (propType === autoType) return getFlowTypeOfProperty(node, prop);
            propType = getNarrowableTypeForReference(propType, node, checkMode);
            let assumeUninitialized = false;
            if (strictNullChecks && strictPropertyInitialization && isAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */ ) {
                const declaration = prop && prop.valueDeclaration;
                if (declaration && isPropertyWithoutInitializer(declaration)) {
                    if (!isStatic(declaration)) {
                        const flowContainer = getControlFlowContainer(node);
                        if (flowContainer.kind === 177 /* Constructor */  && flowContainer.parent === declaration.parent && !(declaration.flags & 33554432 /* Ambient */ )) assumeUninitialized = true;
                    }
                }
            } else if (strictNullChecks && prop && prop.valueDeclaration && isPropertyAccessExpression(prop.valueDeclaration) && getAssignmentDeclarationPropertyAccessKind(prop.valueDeclaration) && getControlFlowContainer(node) === getControlFlowContainer(prop.valueDeclaration)) assumeUninitialized = true;
            const flowType = getFlowTypeOfReference(node, propType, assumeUninitialized ? getOptionalType(propType) : propType);
            if (assumeUninitialized && !containsUndefinedType(propType) && containsUndefinedType(flowType)) {
                error2(errorNode, Diagnostics.Property_0_is_used_before_being_assigned, symbolToString(prop));
                return propType;
            }
            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
        }
        function checkPropertyNotUsedBeforeDeclaration(prop, node, right) {
            const { valueDeclaration } = prop;
            if (!valueDeclaration || getSourceFileOfNode(node).isDeclarationFile) return;
            let diagnosticMessage;
            const declarationName = idText(right);
            if (isInPropertyInitializerOrClassStaticBlock(node) && !isOptionalPropertyDeclaration(valueDeclaration) && !(isAccessExpression(node) && isAccessExpression(node.expression)) && !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right) && !(isMethodDeclaration(valueDeclaration) && getCombinedModifierFlagsCached(valueDeclaration) & 256 /* Static */ ) && (useDefineForClassFields || !isPropertyDeclaredInAncestorClass(prop))) diagnosticMessage = error2(right, Diagnostics.Property_0_is_used_before_its_initialization, declarationName);
            else if (valueDeclaration.kind === 264 /* ClassDeclaration */  && node.parent.kind !== 184 /* TypeReference */  && !(valueDeclaration.flags & 33554432 /* Ambient */ ) && !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right)) diagnosticMessage = error2(right, Diagnostics.Class_0_used_before_its_declaration, declarationName);
            if (diagnosticMessage) addRelatedInfo(diagnosticMessage, createDiagnosticForNode(valueDeclaration, Diagnostics._0_is_declared_here, declarationName));
        }
        function isInPropertyInitializerOrClassStaticBlock(node, ignoreArrowFunctions) {
            return !!findAncestor(node, (node2)=>{
                switch(node2.kind){
                    case 173 /* PropertyDeclaration */ :
                    case 176 /* ClassStaticBlockDeclaration */ :
                        return true;
                    case 187 /* TypeQuery */ :
                    case 288 /* JsxClosingElement */ :
                        return "quit";
                    case 220 /* ArrowFunction */ :
                        return ignoreArrowFunctions ? false : "quit";
                    case 242 /* Block */ :
                        return isFunctionLikeDeclaration(node2.parent) && node2.parent.kind !== 220 /* ArrowFunction */  ? "quit" : false;
                    default:
                        return false;
                }
            });
        }
        function isPropertyDeclaredInAncestorClass(prop) {
            if (!(prop.parent.flags & 32 /* Class */ )) return false;
            let classType = getTypeOfSymbol(prop.parent);
            while(true){
                classType = classType.symbol && getSuperClass(classType);
                if (!classType) return false;
                const superProperty = getPropertyOfType(classType, prop.escapedName);
                if (superProperty && superProperty.valueDeclaration) return true;
            }
        }
        function getSuperClass(classType) {
            const x = getBaseTypes(classType);
            if (x.length === 0) return void 0;
            return getIntersectionType(x);
        }
        function reportNonexistentProperty(propNode, containingType, isUncheckedJS) {
            const links = getNodeLinks(propNode);
            const cache = links.nonExistentPropCheckCache || (links.nonExistentPropCheckCache = /* @__PURE__ */ new Set());
            const key = `${getTypeId(containingType)}|${isUncheckedJS}`;
            if (cache.has(key)) return;
            cache.add(key);
            let errorInfo;
            let relatedInfo;
            if (!isPrivateIdentifier(propNode) && containingType.flags & 1048576 /* Union */  && !(containingType.flags & 402784252 /* Primitive */ )) {
                for (const subtype of containingType.types)if (!getPropertyOfType(subtype, propNode.escapedText) && !getApplicableIndexInfoForName(subtype, propNode.escapedText)) {
                    errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1, declarationNameToString(propNode), typeToString(subtype));
                    break;
                }
            }
            if (typeHasStaticProperty(propNode.escapedText, containingType)) {
                const propName = declarationNameToString(propNode);
                const typeName = typeToString(containingType);
                errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_to_access_the_static_member_2_instead, propName, typeName, typeName + "." + propName);
            } else {
                const promisedType = getPromisedTypeOfPromise(containingType);
                if (promisedType && getPropertyOfType(promisedType, propNode.escapedText)) {
                    errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1, declarationNameToString(propNode), typeToString(containingType));
                    relatedInfo = createDiagnosticForNode(propNode, Diagnostics.Did_you_forget_to_use_await);
                } else {
                    const missingProperty = declarationNameToString(propNode);
                    const container = typeToString(containingType);
                    const libSuggestion = getSuggestedLibForNonExistentProperty(missingProperty, containingType);
                    if (libSuggestion !== void 0) errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Property_0_does_not_exist_on_type_1_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_2_or_later, missingProperty, container, libSuggestion);
                    else {
                        const suggestion = getSuggestedSymbolForNonexistentProperty(propNode, containingType);
                        if (suggestion !== void 0) {
                            const suggestedName = symbolName(suggestion);
                            const message = isUncheckedJS ? Diagnostics.Property_0_may_not_exist_on_type_1_Did_you_mean_2 : Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2;
                            errorInfo = chainDiagnosticMessages(errorInfo, message, missingProperty, container, suggestedName);
                            relatedInfo = suggestion.valueDeclaration && createDiagnosticForNode(suggestion.valueDeclaration, Diagnostics._0_is_declared_here, suggestedName);
                        } else {
                            const diagnostic = containerSeemsToBeEmptyDomElement(containingType) ? Diagnostics.Property_0_does_not_exist_on_type_1_Try_changing_the_lib_compiler_option_to_include_dom : Diagnostics.Property_0_does_not_exist_on_type_1;
                            errorInfo = chainDiagnosticMessages(elaborateNeverIntersection(errorInfo, containingType), diagnostic, missingProperty, container);
                        }
                    }
                }
            }
            const resultDiagnostic = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(propNode), propNode, errorInfo);
            if (relatedInfo) addRelatedInfo(resultDiagnostic, relatedInfo);
            addErrorOrSuggestion(!isUncheckedJS || errorInfo.code !== Diagnostics.Property_0_may_not_exist_on_type_1_Did_you_mean_2.code, resultDiagnostic);
        }
        function containerSeemsToBeEmptyDomElement(containingType) {
            return compilerOptions.lib && !compilerOptions.lib.includes("lib.dom.d.ts") && everyContainedType(containingType, (type)=>type.symbol && /^(?:EventTarget|Node|(?:HTML[a-zA-Z]*)?Element)$/.test(unescapeLeadingUnderscores(type.symbol.escapedName))) && isEmptyObjectType(containingType);
        }
        function typeHasStaticProperty(propName, containingType) {
            const prop = containingType.symbol && getPropertyOfType(getTypeOfSymbol(containingType.symbol), propName);
            return prop !== void 0 && !!prop.valueDeclaration && isStatic(prop.valueDeclaration);
        }
        function getSuggestedLibForNonExistentName(name) {
            const missingName = diagnosticName(name);
            const allFeatures = getScriptTargetFeatures();
            const typeFeatures = allFeatures.get(missingName);
            return typeFeatures && firstIterator(typeFeatures.keys());
        }
        function getSuggestedLibForNonExistentProperty(missingProperty, containingType) {
            const container = getApparentType(containingType).symbol;
            if (!container) return void 0;
            const containingTypeName = symbolName(container);
            const allFeatures = getScriptTargetFeatures();
            const typeFeatures = allFeatures.get(containingTypeName);
            if (typeFeatures) for (const [libTarget, featuresOfType] of typeFeatures){
                if (contains(featuresOfType, missingProperty)) return libTarget;
            }
        }
        function getSuggestedSymbolForNonexistentClassMember(name, baseType) {
            return getSpellingSuggestionForName(name, getPropertiesOfType(baseType), 106500 /* ClassMember */ );
        }
        function getSuggestedSymbolForNonexistentProperty(name, containingType) {
            let props = getPropertiesOfType(containingType);
            if (typeof name !== "string") {
                const parent2 = name.parent;
                if (isPropertyAccessExpression(parent2)) props = filter(props, (prop)=>isValidPropertyAccessForCompletions(parent2, containingType, prop));
                name = idText(name);
            }
            return getSpellingSuggestionForName(name, props, 111551 /* Value */ );
        }
        function getSuggestedSymbolForNonexistentJSXAttribute(name, containingType) {
            const strName = isString(name) ? name : idText(name);
            const properties = getPropertiesOfType(containingType);
            const jsxSpecific = strName === "for" ? find(properties, (x)=>symbolName(x) === "htmlFor") : strName === "class" ? find(properties, (x)=>symbolName(x) === "className") : void 0;
            return jsxSpecific !== null && jsxSpecific !== void 0 ? jsxSpecific : getSpellingSuggestionForName(strName, properties, 111551 /* Value */ );
        }
        function getSuggestionForNonexistentProperty(name, containingType) {
            const suggestion = getSuggestedSymbolForNonexistentProperty(name, containingType);
            return suggestion && symbolName(suggestion);
        }
        function getSuggestionForSymbolNameLookup(symbols, name, meaning) {
            const symbol = getSymbol2(symbols, name, meaning);
            if (symbol) return symbol;
            let candidates;
            if (symbols === globals) {
                const primitives = mapDefined([
                    "string",
                    "number",
                    "boolean",
                    "object",
                    "bigint",
                    "symbol"
                ], (s)=>symbols.has(s.charAt(0).toUpperCase() + s.slice(1)) ? createSymbol(524288 /* TypeAlias */ , s) : void 0);
                candidates = primitives.concat(arrayFrom(symbols.values()));
            } else candidates = arrayFrom(symbols.values());
            return getSpellingSuggestionForName(unescapeLeadingUnderscores(name), candidates, meaning);
        }
        function getSuggestedSymbolForNonexistentSymbol(location, outerName, meaning) {
            Debug.assert(outerName !== void 0, "outername should always be defined");
            const result = resolveNameForSymbolSuggestion(location, outerName, meaning, /*nameNotFoundMessage*/ void 0, /*isUse*/ false, /*excludeGlobals*/ false);
            return result;
        }
        function getSuggestedSymbolForNonexistentModule(name, targetModule) {
            return targetModule.exports && getSpellingSuggestionForName(idText(name), getExportsOfModuleAsArray(targetModule), 2623475 /* ModuleMember */ );
        }
        function getSuggestionForNonexistentIndexSignature(objectType, expr, keyedType) {
            function hasProp(name) {
                const prop = getPropertyOfObjectType(objectType, name);
                if (prop) {
                    const s = getSingleCallSignature(getTypeOfSymbol(prop));
                    return !!s && getMinArgumentCount(s) >= 1 && isTypeAssignableTo(keyedType, getTypeAtPosition(s, 0));
                }
                return false;
            }
            const suggestedMethod = isAssignmentTarget(expr) ? "set" : "get";
            if (!hasProp(suggestedMethod)) return void 0;
            let suggestion = tryGetPropertyAccessOrIdentifierToString(expr.expression);
            if (suggestion === void 0) suggestion = suggestedMethod;
            else suggestion += "." + suggestedMethod;
            return suggestion;
        }
        function getSuggestedTypeForNonexistentStringLiteralType(source, target) {
            const candidates = target.types.filter((type)=>!!(type.flags & 128 /* StringLiteral */ ));
            return getSpellingSuggestion(source.value, candidates, (type)=>type.value);
        }
        function getSpellingSuggestionForName(name, symbols, meaning) {
            return getSpellingSuggestion(name, symbols, getCandidateName);
            function getCandidateName(candidate) {
                const candidateName = symbolName(candidate);
                if (startsWith(candidateName, '"')) return void 0;
                if (candidate.flags & meaning) return candidateName;
                if (candidate.flags & 2097152 /* Alias */ ) {
                    const alias = tryResolveAlias(candidate);
                    if (alias && alias.flags & meaning) return candidateName;
                }
                return void 0;
            }
        }
        function markPropertyAsReferenced(prop, nodeForCheckWriteOnly, isSelfTypeAccess2) {
            const valueDeclaration = prop && prop.flags & 106500 /* ClassMember */  && prop.valueDeclaration;
            if (!valueDeclaration) return;
            const hasPrivateModifier = hasEffectiveModifier(valueDeclaration, 2 /* Private */ );
            const hasPrivateIdentifier = prop.valueDeclaration && isNamedDeclaration(prop.valueDeclaration) && isPrivateIdentifier(prop.valueDeclaration.name);
            if (!hasPrivateModifier && !hasPrivateIdentifier) return;
            if (nodeForCheckWriteOnly && isWriteOnlyAccess(nodeForCheckWriteOnly) && !(prop.flags & 65536 /* SetAccessor */ )) return;
            if (isSelfTypeAccess2) {
                const containingMethod = findAncestor(nodeForCheckWriteOnly, isFunctionLikeDeclaration);
                if (containingMethod && containingMethod.symbol === prop) return;
            }
            (getCheckFlags(prop) & 1 /* Instantiated */  ? getSymbolLinks(prop).target : prop).isReferenced = -1 /* All */ ;
        }
        function isSelfTypeAccess(name, parent2) {
            return name.kind === 110 /* ThisKeyword */  || !!parent2 && isEntityNameExpression(name) && parent2 === getResolvedSymbol(getFirstIdentifier(name));
        }
        function isValidPropertyAccess(node, propertyName) {
            switch(node.kind){
                case 212 /* PropertyAccessExpression */ :
                    return isValidPropertyAccessWithType(node, node.expression.kind === 108 /* SuperKeyword */ , propertyName, getWidenedType(checkExpression(node.expression)));
                case 167 /* QualifiedName */ :
                    return isValidPropertyAccessWithType(node, /*isSuper*/ false, propertyName, getWidenedType(checkExpression(node.left)));
                case 206 /* ImportType */ :
                    return isValidPropertyAccessWithType(node, /*isSuper*/ false, propertyName, getTypeFromTypeNode(node));
            }
        }
        function isValidPropertyAccessForCompletions(node, type, property) {
            return isPropertyAccessible(node, node.kind === 212 /* PropertyAccessExpression */  && node.expression.kind === 108 /* SuperKeyword */ , /*isWrite*/ false, type, property);
        }
        function isValidPropertyAccessWithType(node, isSuper, propertyName, type) {
            if (isTypeAny(type)) return true;
            const prop = getPropertyOfType(type, propertyName);
            return !!prop && isPropertyAccessible(node, isSuper, /*isWrite*/ false, type, prop);
        }
        function isPropertyAccessible(node, isSuper, isWrite, containingType, property) {
            if (isTypeAny(containingType)) return true;
            if (property.valueDeclaration && isPrivateIdentifierClassElementDeclaration(property.valueDeclaration)) {
                const declClass = getContainingClass(property.valueDeclaration);
                return !isOptionalChain(node) && !!findAncestor(node, (parent2)=>parent2 === declClass);
            }
            return checkPropertyAccessibilityAtLocation(node, isSuper, isWrite, containingType, property);
        }
        function getForInVariableSymbol(node) {
            const initializer = node.initializer;
            if (initializer.kind === 262 /* VariableDeclarationList */ ) {
                const variable = initializer.declarations[0];
                if (variable && !isBindingPattern(variable.name)) return getSymbolOfDeclaration(variable);
            } else if (initializer.kind === 80 /* Identifier */ ) return getResolvedSymbol(initializer);
            return void 0;
        }
        function hasNumericPropertyNames(type) {
            return getIndexInfosOfType(type).length === 1 && !!getIndexInfoOfType(type, numberType);
        }
        function isForInVariableForNumericPropertyNames(expr) {
            const e = skipParentheses(expr);
            if (e.kind === 80 /* Identifier */ ) {
                const symbol = getResolvedSymbol(e);
                if (symbol.flags & 3 /* Variable */ ) {
                    let child = expr;
                    let node = expr.parent;
                    while(node){
                        if (node.kind === 250 /* ForInStatement */  && child === node.statement && getForInVariableSymbol(node) === symbol && hasNumericPropertyNames(getTypeOfExpression(node.expression))) return true;
                        child = node;
                        node = node.parent;
                    }
                }
            }
            return false;
        }
        function checkIndexedAccess(node, checkMode) {
            return node.flags & 64 /* OptionalChain */  ? checkElementAccessChain(node, checkMode) : checkElementAccessExpression(node, checkNonNullExpression(node.expression), checkMode);
        }
        function checkElementAccessChain(node, checkMode) {
            const exprType = checkExpression(node.expression);
            const nonOptionalType = getOptionalExpressionType(exprType, node.expression);
            return propagateOptionalTypeMarker(checkElementAccessExpression(node, checkNonNullType(nonOptionalType, node.expression), checkMode), node, nonOptionalType !== exprType);
        }
        function checkElementAccessExpression(node, exprType, checkMode) {
            const objectType = getAssignmentTargetKind(node) !== 0 /* None */  || isMethodAccessForCall(node) ? getWidenedType(exprType) : exprType;
            const indexExpression = node.argumentExpression;
            const indexType = checkExpression(indexExpression);
            if (isErrorType(objectType) || objectType === silentNeverType) return objectType;
            if (isConstEnumObjectType(objectType) && !isStringLiteralLike(indexExpression)) {
                error2(indexExpression, Diagnostics.A_const_enum_member_can_only_be_accessed_using_a_string_literal);
                return errorType;
            }
            const effectiveIndexType = isForInVariableForNumericPropertyNames(indexExpression) ? numberType : indexType;
            const assignmentTargetKind = getAssignmentTargetKind(node);
            let accessFlags;
            if (assignmentTargetKind === 0 /* None */ ) accessFlags = 32 /* ExpressionPosition */ ;
            else {
                accessFlags = 4 /* Writing */  | (isGenericObjectType(objectType) && !isThisTypeParameter(objectType) ? 2 /* NoIndexSignatures */  : 0);
                if (assignmentTargetKind === 2 /* Compound */ ) accessFlags |= 32 /* ExpressionPosition */ ;
            }
            const indexedAccessType = getIndexedAccessTypeOrUndefined(objectType, effectiveIndexType, accessFlags, node) || errorType;
            return checkIndexedAccessIndexType(getFlowTypeOfAccessExpression(node, getNodeLinks(node).resolvedSymbol, indexedAccessType, indexExpression, checkMode), node);
        }
        function callLikeExpressionMayHaveTypeArguments(node) {
            return isCallOrNewExpression(node) || isTaggedTemplateExpression(node) || isJsxOpeningLikeElement(node);
        }
        function resolveUntypedCall(node) {
            if (callLikeExpressionMayHaveTypeArguments(node)) forEach(node.typeArguments, checkSourceElement);
            if (node.kind === 216 /* TaggedTemplateExpression */ ) checkExpression(node.template);
            else if (isJsxOpeningLikeElement(node)) checkExpression(node.attributes);
            else if (isBinaryExpression(node)) checkExpression(node.left);
            else if (isCallOrNewExpression(node)) forEach(node.arguments, (argument)=>{
                checkExpression(argument);
            });
            return anySignature;
        }
        function resolveErrorCall(node) {
            resolveUntypedCall(node);
            return unknownSignature;
        }
        function reorderCandidates(signatures, result, callChainFlags) {
            let lastParent;
            let lastSymbol;
            let cutoffIndex = 0;
            let index;
            let specializedIndex = -1;
            let spliceIndex;
            Debug.assert(!result.length);
            for (const signature of signatures){
                const symbol = signature.declaration && getSymbolOfDeclaration(signature.declaration);
                const parent2 = signature.declaration && signature.declaration.parent;
                if (!lastSymbol || symbol === lastSymbol) {
                    if (lastParent && parent2 === lastParent) index = index + 1;
                    else {
                        lastParent = parent2;
                        index = cutoffIndex;
                    }
                } else {
                    index = cutoffIndex = result.length;
                    lastParent = parent2;
                }
                lastSymbol = symbol;
                if (signatureHasLiteralTypes(signature)) {
                    specializedIndex++;
                    spliceIndex = specializedIndex;
                    cutoffIndex++;
                } else spliceIndex = index;
                result.splice(spliceIndex, 0, callChainFlags ? getOptionalCallSignature(signature, callChainFlags) : signature);
            }
        }
        function isSpreadArgument(arg) {
            return !!arg && (arg.kind === 231 /* SpreadElement */  || arg.kind === 238 /* SyntheticExpression */  && arg.isSpread);
        }
        function getSpreadArgumentIndex(args) {
            return findIndex(args, isSpreadArgument);
        }
        function acceptsVoid(t) {
            return !!(t.flags & 16384 /* Void */ );
        }
        function acceptsVoidUndefinedUnknownOrAny(t) {
            return !!(t.flags & 49155 /* Any */ );
        }
        function hasCorrectArity(node, args, signature, signatureHelpTrailingComma = false) {
            if (isJsxOpeningFragment(node)) return true;
            let argCount;
            let callIsIncomplete = false;
            let effectiveParameterCount = getParameterCount(signature);
            let effectiveMinimumArguments = getMinArgumentCount(signature);
            if (node.kind === 216 /* TaggedTemplateExpression */ ) {
                argCount = args.length;
                if (node.template.kind === 229 /* TemplateExpression */ ) {
                    const lastSpan = last(node.template.templateSpans);
                    callIsIncomplete = nodeIsMissing(lastSpan.literal) || !!lastSpan.literal.isUnterminated;
                } else {
                    const templateLiteral = node.template;
                    Debug.assert(templateLiteral.kind === 15 /* NoSubstitutionTemplateLiteral */ );
                    callIsIncomplete = !!templateLiteral.isUnterminated;
                }
            } else if (node.kind === 171 /* Decorator */ ) argCount = getDecoratorArgumentCount(node, signature);
            else if (node.kind === 227 /* BinaryExpression */ ) argCount = 1;
            else if (isJsxOpeningLikeElement(node)) {
                callIsIncomplete = node.attributes.end === node.end;
                if (callIsIncomplete) return true;
                argCount = effectiveMinimumArguments === 0 ? args.length : 1;
                effectiveParameterCount = args.length === 0 ? effectiveParameterCount : 1;
                effectiveMinimumArguments = Math.min(effectiveMinimumArguments, 1);
            } else if (!node.arguments) {
                Debug.assert(node.kind === 215 /* NewExpression */ );
                return getMinArgumentCount(signature) === 0;
            } else {
                argCount = signatureHelpTrailingComma ? args.length + 1 : args.length;
                callIsIncomplete = node.arguments.end === node.end;
                const spreadArgIndex = getSpreadArgumentIndex(args);
                if (spreadArgIndex >= 0) return spreadArgIndex >= getMinArgumentCount(signature) && (hasEffectiveRestParameter(signature) || spreadArgIndex < getParameterCount(signature));
            }
            if (!hasEffectiveRestParameter(signature) && argCount > effectiveParameterCount) return false;
            if (callIsIncomplete || argCount >= effectiveMinimumArguments) return true;
            for(let i = argCount; i < effectiveMinimumArguments; i++){
                const type = getTypeAtPosition(signature, i);
                if (filterType(type, isInJSFile(node) && !strictNullChecks ? acceptsVoidUndefinedUnknownOrAny : acceptsVoid).flags & 131072 /* Never */ ) return false;
            }
            return true;
        }
        function hasCorrectTypeArgumentArity(signature, typeArguments) {
            const numTypeParameters = length(signature.typeParameters);
            const minTypeArgumentCount = getMinTypeArgumentCount(signature.typeParameters);
            return !some(typeArguments) || typeArguments.length >= minTypeArgumentCount && typeArguments.length <= numTypeParameters;
        }
        function isInstantiatedGenericParameter(signature, pos) {
            let type;
            return !!(signature.target && (type = tryGetTypeAtPosition(signature.target, pos)) && isGenericType(type));
        }
        function getSingleCallSignature(type) {
            return getSingleSignature(type, 0 /* Call */ , /*allowMembers*/ false);
        }
        function getSingleCallOrConstructSignature(type) {
            return getSingleSignature(type, 0 /* Call */ , /*allowMembers*/ false) || getSingleSignature(type, 1 /* Construct */ , /*allowMembers*/ false);
        }
        function getSingleSignature(type, kind, allowMembers) {
            if (type.flags & 524288 /* Object */ ) {
                const resolved = resolveStructuredTypeMembers(type);
                if (allowMembers || resolved.properties.length === 0 && resolved.indexInfos.length === 0) {
                    if (kind === 0 /* Call */  && resolved.callSignatures.length === 1 && resolved.constructSignatures.length === 0) return resolved.callSignatures[0];
                    if (kind === 1 /* Construct */  && resolved.constructSignatures.length === 1 && resolved.callSignatures.length === 0) return resolved.constructSignatures[0];
                }
            }
            return void 0;
        }
        function instantiateSignatureInContextOf(signature, contextualSignature, inferenceContext, compareTypes) {
            const context = createInferenceContext(getTypeParametersForMapper(signature), signature, 0 /* None */ , compareTypes);
            const restType = getEffectiveRestType(contextualSignature);
            const mapper = inferenceContext && (restType && restType.flags & 262144 /* TypeParameter */  ? inferenceContext.nonFixingMapper : inferenceContext.mapper);
            const sourceSignature = mapper ? instantiateSignature(contextualSignature, mapper) : contextualSignature;
            applyToParameterTypes(sourceSignature, signature, (source, target)=>{
                inferTypes(context.inferences, source, target);
            });
            if (!inferenceContext) applyToReturnTypes(contextualSignature, signature, (source, target)=>{
                inferTypes(context.inferences, source, target, 128 /* ReturnType */ );
            });
            return getSignatureInstantiation(signature, getInferredTypes(context), isInJSFile(contextualSignature.declaration));
        }
        function inferJsxTypeArguments(node, signature, checkMode, context) {
            const paramType = getEffectiveFirstArgumentForJsxSignature(signature, node);
            const checkAttrType = checkExpressionWithContextualType(node.attributes, paramType, context, checkMode);
            inferTypes(context.inferences, checkAttrType, paramType);
            return getInferredTypes(context);
        }
        function getThisArgumentType(thisArgumentNode) {
            if (!thisArgumentNode) return voidType;
            const thisArgumentType = checkExpression(thisArgumentNode);
            return isRightSideOfInstanceofExpression(thisArgumentNode) ? thisArgumentType : isOptionalChainRoot(thisArgumentNode.parent) ? getNonNullableType(thisArgumentType) : isOptionalChain(thisArgumentNode.parent) ? removeOptionalTypeMarker(thisArgumentType) : thisArgumentType;
        }
        function inferTypeArguments(node, signature, args, checkMode, context) {
            if (isJsxOpeningLikeElement(node)) return inferJsxTypeArguments(node, signature, checkMode, context);
            if (node.kind !== 171 /* Decorator */  && node.kind !== 227 /* BinaryExpression */ ) {
                const skipBindingPatterns = every(signature.typeParameters, (p)=>!!getDefaultFromTypeParameter(p));
                const contextualType = getContextualType2(node, skipBindingPatterns ? 8 /* SkipBindingPatterns */  : 0 /* None */ );
                if (contextualType) {
                    const inferenceTargetType = getReturnTypeOfSignature(signature);
                    if (couldContainTypeVariables(inferenceTargetType)) {
                        const outerContext = getInferenceContext(node);
                        const isFromBindingPattern = !skipBindingPatterns && getContextualType2(node, 8 /* SkipBindingPatterns */ ) !== contextualType;
                        if (!isFromBindingPattern) {
                            const outerMapper = getMapperFromContext(cloneInferenceContext(outerContext, 1 /* NoDefault */ ));
                            const instantiatedType = instantiateType(contextualType, outerMapper);
                            const contextualSignature = getSingleCallSignature(instantiatedType);
                            const inferenceSourceType = contextualSignature && contextualSignature.typeParameters ? getOrCreateTypeFromSignature(getSignatureInstantiationWithoutFillingInTypeArguments(contextualSignature, contextualSignature.typeParameters)) : instantiatedType;
                            inferTypes(context.inferences, inferenceSourceType, inferenceTargetType, 128 /* ReturnType */ );
                        }
                        const returnContext = createInferenceContext(signature.typeParameters, signature, context.flags);
                        const returnSourceType = instantiateType(contextualType, outerContext && createOuterReturnMapper(outerContext));
                        inferTypes(returnContext.inferences, returnSourceType, inferenceTargetType);
                        context.returnMapper = some(returnContext.inferences, hasInferenceCandidates) ? getMapperFromContext(cloneInferredPartOfContext(returnContext)) : void 0;
                    }
                }
            }
            const restType = getNonArrayRestType(signature);
            const argCount = restType ? Math.min(getParameterCount(signature) - 1, args.length) : args.length;
            if (restType && restType.flags & 262144 /* TypeParameter */ ) {
                const info = find(context.inferences, (info2)=>info2.typeParameter === restType);
                if (info) info.impliedArity = findIndex(args, isSpreadArgument, argCount) < 0 ? args.length - argCount : void 0;
            }
            const thisType = getThisTypeOfSignature(signature);
            if (thisType && couldContainTypeVariables(thisType)) {
                const thisArgumentNode = getThisArgumentOfCall(node);
                inferTypes(context.inferences, getThisArgumentType(thisArgumentNode), thisType);
            }
            for(let i = 0; i < argCount; i++){
                const arg = args[i];
                if (arg.kind !== 233 /* OmittedExpression */ ) {
                    const paramType = getTypeAtPosition(signature, i);
                    if (couldContainTypeVariables(paramType)) {
                        const argType = checkExpressionWithContextualType(arg, paramType, context, checkMode);
                        inferTypes(context.inferences, argType, paramType);
                    }
                }
            }
            if (restType && couldContainTypeVariables(restType)) {
                const spreadType = getSpreadArgumentType(args, argCount, args.length, restType, context, checkMode);
                inferTypes(context.inferences, spreadType, restType);
            }
            return getInferredTypes(context);
        }
        function getMutableArrayOrTupleType(type) {
            return type.flags & 1048576 /* Union */  ? mapType(type, getMutableArrayOrTupleType) : type.flags & 1 /* Any */  || isMutableArrayOrTuple(getBaseConstraintOfType(type) || type) ? type : isTupleType(type) ? createTupleType(getElementTypes(type), type.target.elementFlags, /*readonly*/ false, type.target.labeledElementDeclarations) : createTupleType([
                type
            ], [
                8 /* Variadic */ 
            ]);
        }
        function getSpreadArgumentType(args, index, argCount, restType, context, checkMode) {
            const inConstContext = isConstTypeVariable(restType);
            if (index >= argCount - 1) {
                const arg = args[argCount - 1];
                if (isSpreadArgument(arg)) {
                    const spreadType = arg.kind === 238 /* SyntheticExpression */  ? arg.type : checkExpressionWithContextualType(arg.expression, restType, context, checkMode);
                    if (isArrayLikeType(spreadType)) return getMutableArrayOrTupleType(spreadType);
                    return createArrayType(checkIteratedTypeOrElementType(33 /* Spread */ , spreadType, undefinedType, arg.kind === 231 /* SpreadElement */  ? arg.expression : arg), inConstContext);
                }
            }
            const types = [];
            const flags = [];
            const names = [];
            for(let i = index; i < argCount; i++){
                const arg = args[i];
                if (isSpreadArgument(arg)) {
                    const spreadType = arg.kind === 238 /* SyntheticExpression */  ? arg.type : checkExpression(arg.expression);
                    if (isArrayLikeType(spreadType)) {
                        types.push(spreadType);
                        flags.push(8 /* Variadic */ );
                    } else {
                        types.push(checkIteratedTypeOrElementType(33 /* Spread */ , spreadType, undefinedType, arg.kind === 231 /* SpreadElement */  ? arg.expression : arg));
                        flags.push(4 /* Rest */ );
                    }
                } else {
                    const contextualType = isTupleType(restType) ? getContextualTypeForElementExpression(restType, i - index, argCount - index) || unknownType : getIndexedAccessType(restType, getNumberLiteralType(i - index), 256 /* Contextual */ );
                    const argType = checkExpressionWithContextualType(arg, contextualType, context, checkMode);
                    const hasPrimitiveContextualType = inConstContext || maybeTypeOfKind(contextualType, 406978556 /* StringMapping */ );
                    types.push(hasPrimitiveContextualType ? getRegularTypeOfLiteralType(argType) : getWidenedLiteralType(argType));
                    flags.push(1 /* Required */ );
                }
                if (arg.kind === 238 /* SyntheticExpression */  && arg.tupleNameSource) names.push(arg.tupleNameSource);
                else names.push(void 0);
            }
            return createTupleType(types, flags, inConstContext && !someType(restType, isMutableArrayLikeType), names);
        }
        function checkTypeArguments(signature, typeArgumentNodes, reportErrors2, headMessage) {
            const isJavascript = isInJSFile(signature.declaration);
            const typeParameters = signature.typeParameters;
            const typeArgumentTypes = fillMissingTypeArguments(map(typeArgumentNodes, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), isJavascript);
            let mapper;
            for(let i = 0; i < typeArgumentNodes.length; i++){
                Debug.assert(typeParameters[i] !== void 0, "Should not call checkTypeArguments with too many type arguments");
                const constraint = getConstraintOfTypeParameter(typeParameters[i]);
                if (constraint) {
                    const errorInfo = reportErrors2 && headMessage ? ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Type_0_does_not_satisfy_the_constraint_1) : void 0;
                    const typeArgumentHeadMessage = headMessage || Diagnostics.Type_0_does_not_satisfy_the_constraint_1;
                    if (!mapper) mapper = createTypeMapper(typeParameters, typeArgumentTypes);
                    const typeArgument = typeArgumentTypes[i];
                    if (!checkTypeAssignableTo(typeArgument, getTypeWithThisArgument(instantiateType(constraint, mapper), typeArgument), reportErrors2 ? typeArgumentNodes[i] : void 0, typeArgumentHeadMessage, errorInfo)) return void 0;
                }
            }
            return typeArgumentTypes;
        }
        function getJsxReferenceKind(node) {
            if (isJsxIntrinsicTagName(node.tagName)) return 2 /* Mixed */ ;
            const tagType = getApparentType(checkExpression(node.tagName));
            if (length(getSignaturesOfType(tagType, 1 /* Construct */ ))) return 0 /* Component */ ;
            if (length(getSignaturesOfType(tagType, 0 /* Call */ ))) return 1 /* Function */ ;
            return 2 /* Mixed */ ;
        }
        function checkApplicableSignatureForJsxCallLikeElement(node, signature, relation, checkMode, reportErrors2, containingMessageChain, errorOutputContainer) {
            const paramType = getEffectiveFirstArgumentForJsxSignature(signature, node);
            const attributesType = isJsxOpeningFragment(node) ? createJsxAttributesTypeFromAttributesProperty(node) : checkExpressionWithContextualType(node.attributes, paramType, /*inferenceContext*/ void 0, checkMode);
            const checkAttributesType = checkMode & 4 /* SkipContextSensitive */  ? getRegularTypeOfObjectLiteral(attributesType) : attributesType;
            return checkTagNameDoesNotExpectTooManyArguments() && checkTypeRelatedToAndOptionallyElaborate(checkAttributesType, paramType, relation, reportErrors2 ? isJsxOpeningFragment(node) ? node : node.tagName : void 0, isJsxOpeningFragment(node) ? void 0 : node.attributes, /*headMessage*/ void 0, containingMessageChain, errorOutputContainer);
            function checkTagNameDoesNotExpectTooManyArguments() {
                var _a;
                if (getJsxNamespaceContainerForImplicitImport(node)) return true;
                const tagType = (isJsxOpeningElement(node) || isJsxSelfClosingElement(node)) && !(isJsxIntrinsicTagName(node.tagName) || isJsxNamespacedName(node.tagName)) ? checkExpression(node.tagName) : void 0;
                if (!tagType) return true;
                const tagCallSignatures = getSignaturesOfType(tagType, 0 /* Call */ );
                if (!length(tagCallSignatures)) return true;
                const factory2 = getJsxFactoryEntity(node);
                if (!factory2) return true;
                const factorySymbol = resolveEntityName(factory2, 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ false, node);
                if (!factorySymbol) return true;
                const factoryType = getTypeOfSymbol(factorySymbol);
                const callSignatures = getSignaturesOfType(factoryType, 0 /* Call */ );
                if (!length(callSignatures)) return true;
                let hasFirstParamSignatures = false;
                let maxParamCount = 0;
                for (const sig of callSignatures){
                    const firstparam = getTypeAtPosition(sig, 0);
                    const signaturesOfParam = getSignaturesOfType(firstparam, 0 /* Call */ );
                    if (!length(signaturesOfParam)) continue;
                    for (const paramSig of signaturesOfParam){
                        hasFirstParamSignatures = true;
                        if (hasEffectiveRestParameter(paramSig)) return true;
                        const paramCount = getParameterCount(paramSig);
                        if (paramCount > maxParamCount) maxParamCount = paramCount;
                    }
                }
                if (!hasFirstParamSignatures) return true;
                let absoluteMinArgCount = Infinity;
                for (const tagSig of tagCallSignatures){
                    const tagRequiredArgCount = getMinArgumentCount(tagSig);
                    if (tagRequiredArgCount < absoluteMinArgCount) absoluteMinArgCount = tagRequiredArgCount;
                }
                if (absoluteMinArgCount <= maxParamCount) return true;
                if (reportErrors2) {
                    const tagName = node.tagName;
                    const diag2 = createDiagnosticForNode(tagName, Diagnostics.Tag_0_expects_at_least_1_arguments_but_the_JSX_factory_2_provides_at_most_3, entityNameToString(tagName), absoluteMinArgCount, entityNameToString(factory2), maxParamCount);
                    const tagNameDeclaration = (_a = getSymbolAtLocation(tagName)) == null ? void 0 : _a.valueDeclaration;
                    if (tagNameDeclaration) addRelatedInfo(diag2, createDiagnosticForNode(tagNameDeclaration, Diagnostics._0_is_declared_here, entityNameToString(tagName)));
                    if (errorOutputContainer && errorOutputContainer.skipLogging) (errorOutputContainer.errors || (errorOutputContainer.errors = [])).push(diag2);
                    if (!errorOutputContainer.skipLogging) diagnostics.add(diag2);
                }
                return false;
            }
        }
        function getEffectiveCheckNode(argument) {
            const flags = isInJSFile(argument) ? -2147483615 /* ExcludeJSDocTypeAssertion */  : 33 /* Satisfies */ ;
            return skipOuterExpressions(argument, flags);
        }
        function getSignatureApplicabilityError(node, args, signature, relation, checkMode, reportErrors2, containingMessageChain) {
            const errorOutputContainer = {
                errors: void 0,
                skipLogging: true
            };
            if (isJsxCallLike(node)) {
                if (!checkApplicableSignatureForJsxCallLikeElement(node, signature, relation, checkMode, reportErrors2, containingMessageChain, errorOutputContainer)) {
                    Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "jsx should have errors when reporting errors");
                    return errorOutputContainer.errors || emptyArray;
                }
                return void 0;
            }
            const thisType = getThisTypeOfSignature(signature);
            if (thisType && thisType !== voidType && !(isNewExpression(node) || isCallExpression(node) && isSuperProperty(node.expression))) {
                const thisArgumentNode = getThisArgumentOfCall(node);
                const thisArgumentType = getThisArgumentType(thisArgumentNode);
                const errorNode = reportErrors2 ? thisArgumentNode || node : void 0;
                const headMessage2 = Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1;
                if (!checkTypeRelatedTo(thisArgumentType, thisType, relation, errorNode, headMessage2, containingMessageChain, errorOutputContainer)) {
                    Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "this parameter should have errors when reporting errors");
                    return errorOutputContainer.errors || emptyArray;
                }
            }
            const headMessage = Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1;
            const restType = getNonArrayRestType(signature);
            const argCount = restType ? Math.min(getParameterCount(signature) - 1, args.length) : args.length;
            for(let i = 0; i < argCount; i++){
                const arg = args[i];
                if (arg.kind !== 233 /* OmittedExpression */ ) {
                    const paramType = getTypeAtPosition(signature, i);
                    const argType = checkExpressionWithContextualType(arg, paramType, /*inferenceContext*/ void 0, checkMode);
                    const checkArgType = checkMode & 4 /* SkipContextSensitive */  ? getRegularTypeOfObjectLiteral(argType) : argType;
                    const effectiveCheckArgumentNode = getEffectiveCheckNode(arg);
                    if (!checkTypeRelatedToAndOptionallyElaborate(checkArgType, paramType, relation, reportErrors2 ? effectiveCheckArgumentNode : void 0, effectiveCheckArgumentNode, headMessage, containingMessageChain, errorOutputContainer)) {
                        Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "parameter should have errors when reporting errors");
                        maybeAddMissingAwaitInfo(arg, checkArgType, paramType);
                        return errorOutputContainer.errors || emptyArray;
                    }
                }
            }
            if (restType) {
                const spreadType = getSpreadArgumentType(args, argCount, args.length, restType, /*context*/ void 0, checkMode);
                const restArgCount = args.length - argCount;
                const errorNode = !reportErrors2 ? void 0 : restArgCount === 0 ? node : restArgCount === 1 ? getEffectiveCheckNode(args[argCount]) : setTextRangePosEnd(createSyntheticExpression(node, spreadType), args[argCount].pos, args[args.length - 1].end);
                if (!checkTypeRelatedTo(spreadType, restType, relation, errorNode, headMessage, /*containingMessageChain*/ void 0, errorOutputContainer)) {
                    Debug.assert(!reportErrors2 || !!errorOutputContainer.errors, "rest parameter should have errors when reporting errors");
                    maybeAddMissingAwaitInfo(errorNode, spreadType, restType);
                    return errorOutputContainer.errors || emptyArray;
                }
            }
            return void 0;
            function maybeAddMissingAwaitInfo(errorNode, source, target) {
                if (errorNode && reportErrors2 && errorOutputContainer.errors && errorOutputContainer.errors.length) {
                    if (getAwaitedTypeOfPromise(target)) return;
                    const awaitedTypeOfSource = getAwaitedTypeOfPromise(source);
                    if (awaitedTypeOfSource && isTypeRelatedTo(awaitedTypeOfSource, target, relation)) addRelatedInfo(errorOutputContainer.errors[0], createDiagnosticForNode(errorNode, Diagnostics.Did_you_forget_to_use_await));
                }
            }
        }
        function getThisArgumentOfCall(node) {
            if (node.kind === 227 /* BinaryExpression */ ) return node.right;
            const expression = node.kind === 214 /* CallExpression */  ? node.expression : node.kind === 216 /* TaggedTemplateExpression */  ? node.tag : node.kind === 171 /* Decorator */  && !legacyDecorators ? node.expression : void 0;
            if (expression) {
                const callee = skipOuterExpressions(expression);
                if (isAccessExpression(callee)) return callee.expression;
            }
        }
        function createSyntheticExpression(parent2, type, isSpread, tupleNameSource) {
            const result = parseNodeFactory.createSyntheticExpression(type, isSpread, tupleNameSource);
            setTextRange(result, parent2);
            setParent(result, parent2);
            return result;
        }
        function getEffectiveCallArguments(node) {
            if (isJsxOpeningFragment(node)) return [
                createSyntheticExpression(node, emptyFreshJsxObjectType)
            ];
            if (node.kind === 216 /* TaggedTemplateExpression */ ) {
                const template = node.template;
                const args2 = [
                    createSyntheticExpression(template, getGlobalTemplateStringsArrayType())
                ];
                if (template.kind === 229 /* TemplateExpression */ ) forEach(template.templateSpans, (span)=>{
                    args2.push(span.expression);
                });
                return args2;
            }
            if (node.kind === 171 /* Decorator */ ) return getEffectiveDecoratorArguments(node);
            if (node.kind === 227 /* BinaryExpression */ ) return [
                node.left
            ];
            if (isJsxOpeningLikeElement(node)) return node.attributes.properties.length > 0 || isJsxOpeningElement(node) && node.parent.children.length > 0 ? [
                node.attributes
            ] : emptyArray;
            const args = node.arguments || emptyArray;
            const spreadIndex = getSpreadArgumentIndex(args);
            if (spreadIndex >= 0) {
                const effectiveArgs = args.slice(0, spreadIndex);
                for(let i = spreadIndex; i < args.length; i++){
                    const arg = args[i];
                    const spreadType = arg.kind === 231 /* SpreadElement */  && (flowLoopCount ? checkExpression(arg.expression) : checkExpressionCached(arg.expression));
                    if (spreadType && isTupleType(spreadType)) forEach(getElementTypes(spreadType), (t, i2)=>{
                        var _a;
                        const flags = spreadType.target.elementFlags[i2];
                        const syntheticArg = createSyntheticExpression(arg, flags & 4 /* Rest */  ? createArrayType(t) : t, !!(flags & 12 /* Variable */ ), (_a = spreadType.target.labeledElementDeclarations) == null ? void 0 : _a[i2]);
                        effectiveArgs.push(syntheticArg);
                    });
                    else effectiveArgs.push(arg);
                }
                return effectiveArgs;
            }
            return args;
        }
        function getEffectiveDecoratorArguments(node) {
            const expr = node.expression;
            const signature = getDecoratorCallSignature(node);
            if (signature) {
                const args = [];
                for (const param of signature.parameters){
                    const type = getTypeOfSymbol(param);
                    args.push(createSyntheticExpression(expr, type));
                }
                return args;
            }
            return Debug.fail();
        }
        function getDecoratorArgumentCount(node, signature) {
            return compilerOptions.experimentalDecorators ? getLegacyDecoratorArgumentCount(node, signature) : // Allow the runtime to oversupply arguments to an ES decorator as long as there's at least one parameter.
            Math.min(Math.max(getParameterCount(signature), 1), 2);
        }
        function getLegacyDecoratorArgumentCount(node, signature) {
            switch(node.parent.kind){
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    return 1;
                case 173 /* PropertyDeclaration */ :
                    return hasAccessorModifier(node.parent) ? 3 : 2;
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return signature.parameters.length <= 2 ? 2 : 3;
                case 170 /* Parameter */ :
                    return 3;
                default:
                    return Debug.fail();
            }
        }
        function getDiagnosticSpanForCallNode(node) {
            const sourceFile = getSourceFileOfNode(node);
            const { start, length: length2 } = getErrorSpanForNode(sourceFile, isPropertyAccessExpression(node.expression) ? node.expression.name : node.expression);
            return {
                start,
                length: length2,
                sourceFile
            };
        }
        function getDiagnosticForCallNode(node, message, ...args) {
            if (isCallExpression(node)) {
                const { sourceFile, start, length: length2 } = getDiagnosticSpanForCallNode(node);
                if ("message" in message) return createFileDiagnostic(sourceFile, start, length2, message, ...args);
                return createDiagnosticForFileFromMessageChain(sourceFile, message);
            } else {
                if ("message" in message) return createDiagnosticForNode(node, message, ...args);
                return createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(node), node, message);
            }
        }
        function getErrorNodeForCallNode(callLike) {
            if (isCallOrNewExpression(callLike)) return isPropertyAccessExpression(callLike.expression) ? callLike.expression.name : callLike.expression;
            if (isTaggedTemplateExpression(callLike)) return isPropertyAccessExpression(callLike.tag) ? callLike.tag.name : callLike.tag;
            if (isJsxOpeningLikeElement(callLike)) return callLike.tagName;
            return callLike;
        }
        function isPromiseResolveArityError(node) {
            if (!isCallExpression(node) || !isIdentifier(node.expression)) return false;
            const symbol = resolveName(node.expression, node.expression.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
            const decl = symbol == null ? void 0 : symbol.valueDeclaration;
            if (!decl || !isParameter(decl) || !isFunctionExpressionOrArrowFunction(decl.parent) || !isNewExpression(decl.parent.parent) || !isIdentifier(decl.parent.parent.expression)) return false;
            const globalPromiseSymbol = getGlobalPromiseConstructorSymbol(/*reportErrors*/ false);
            if (!globalPromiseSymbol) return false;
            const constructorSymbol = getSymbolAtLocation(decl.parent.parent.expression, /*ignoreErrors*/ true);
            return constructorSymbol === globalPromiseSymbol;
        }
        function getArgumentArityError(node, signatures, args, headMessage) {
            var _a;
            const spreadIndex = getSpreadArgumentIndex(args);
            if (spreadIndex > -1) return createDiagnosticForNode(args[spreadIndex], Diagnostics.A_spread_argument_must_either_have_a_tuple_type_or_be_passed_to_a_rest_parameter);
            let min2 = Number.POSITIVE_INFINITY;
            let max = Number.NEGATIVE_INFINITY;
            let maxBelow = Number.NEGATIVE_INFINITY;
            let minAbove = Number.POSITIVE_INFINITY;
            let closestSignature;
            for (const sig of signatures){
                const minParameter = getMinArgumentCount(sig);
                const maxParameter = getParameterCount(sig);
                if (minParameter < min2) {
                    min2 = minParameter;
                    closestSignature = sig;
                }
                max = Math.max(max, maxParameter);
                if (minParameter < args.length && minParameter > maxBelow) maxBelow = minParameter;
                if (args.length < maxParameter && maxParameter < minAbove) minAbove = maxParameter;
            }
            const hasRestParameter2 = some(signatures, hasEffectiveRestParameter);
            const parameterRange = hasRestParameter2 ? min2 : min2 < max ? min2 + "-" + max : min2;
            const isVoidPromiseError = !hasRestParameter2 && parameterRange === 1 && args.length === 0 && isPromiseResolveArityError(node);
            if (isVoidPromiseError && isInJSFile(node)) return getDiagnosticForCallNode(node, Diagnostics.Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_without_arguments);
            const error3 = isDecorator(node) ? hasRestParameter2 ? Diagnostics.The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_at_least_0 : Diagnostics.The_runtime_will_invoke_the_decorator_with_1_arguments_but_the_decorator_expects_0 : hasRestParameter2 ? Diagnostics.Expected_at_least_0_arguments_but_got_1 : isVoidPromiseError ? Diagnostics.Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise : Diagnostics.Expected_0_arguments_but_got_1;
            if (min2 < args.length && args.length < max) {
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments, args.length, maxBelow, minAbove);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return getDiagnosticForCallNode(node, chain);
                }
                return getDiagnosticForCallNode(node, Diagnostics.No_overload_expects_0_arguments_but_overloads_do_exist_that_expect_either_1_or_2_arguments, args.length, maxBelow, minAbove);
            } else if (args.length < min2) {
                let diagnostic;
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, error3, parameterRange, args.length);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    diagnostic = getDiagnosticForCallNode(node, chain);
                } else diagnostic = getDiagnosticForCallNode(node, error3, parameterRange, args.length);
                const parameter = (_a = closestSignature == null ? void 0 : closestSignature.declaration) == null ? void 0 : _a.parameters[closestSignature.thisParameter ? args.length + 1 : args.length];
                if (parameter) {
                    const messageAndArgs = isBindingPattern(parameter.name) ? [
                        Diagnostics.An_argument_matching_this_binding_pattern_was_not_provided
                    ] : isRestParameter(parameter) ? [
                        Diagnostics.Arguments_for_the_rest_parameter_0_were_not_provided,
                        idText(getFirstIdentifier(parameter.name))
                    ] : [
                        Diagnostics.An_argument_for_0_was_not_provided,
                        !parameter.name ? args.length : idText(getFirstIdentifier(parameter.name))
                    ];
                    const parameterError = createDiagnosticForNode(parameter, ...messageAndArgs);
                    return addRelatedInfo(diagnostic, parameterError);
                }
                return diagnostic;
            } else {
                const errorSpan = factory.createNodeArray(args.slice(max));
                const pos = first(errorSpan).pos;
                let end = last(errorSpan).end;
                if (end === pos) end++;
                setTextRangePosEnd(errorSpan, pos, end);
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, error3, parameterRange, args.length);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), errorSpan, chain);
                }
                return createDiagnosticForNodeArray(getSourceFileOfNode(node), errorSpan, error3, parameterRange, args.length);
            }
        }
        function getTypeArgumentArityError(node, signatures, typeArguments, headMessage) {
            const argCount = typeArguments.length;
            if (signatures.length === 1) {
                const sig = signatures[0];
                const min2 = getMinTypeArgumentCount(sig.typeParameters);
                const max = length(sig.typeParameters);
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Expected_0_type_arguments_but_got_1, min2 < max ? min2 + "-" + max : min2, argCount);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), typeArguments, chain);
                }
                return createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.Expected_0_type_arguments_but_got_1, min2 < max ? min2 + "-" + max : min2, argCount);
            }
            let belowArgCount = -Infinity;
            let aboveArgCount = Infinity;
            for (const sig of signatures){
                const min2 = getMinTypeArgumentCount(sig.typeParameters);
                const max = length(sig.typeParameters);
                if (min2 > argCount) aboveArgCount = Math.min(aboveArgCount, min2);
                else if (max < argCount) belowArgCount = Math.max(belowArgCount, max);
            }
            if (belowArgCount !== -Infinity && aboveArgCount !== Infinity) {
                if (headMessage) {
                    let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments, argCount, belowArgCount, aboveArgCount);
                    chain = chainDiagnosticMessages(chain, headMessage);
                    return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), typeArguments, chain);
                }
                return createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.No_overload_expects_0_type_arguments_but_overloads_do_exist_that_expect_either_1_or_2_type_arguments, argCount, belowArgCount, aboveArgCount);
            }
            if (headMessage) {
                let chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Expected_0_type_arguments_but_got_1, belowArgCount === -Infinity ? aboveArgCount : belowArgCount, argCount);
                chain = chainDiagnosticMessages(chain, headMessage);
                return createDiagnosticForNodeArrayFromMessageChain(getSourceFileOfNode(node), typeArguments, chain);
            }
            return createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.Expected_0_type_arguments_but_got_1, belowArgCount === -Infinity ? aboveArgCount : belowArgCount, argCount);
        }
        function resolveCall(node, signatures, candidatesOutArray, checkMode, callChainFlags, headMessage) {
            const isTaggedTemplate = node.kind === 216 /* TaggedTemplateExpression */ ;
            const isDecorator2 = node.kind === 171 /* Decorator */ ;
            const isJsxOpeningOrSelfClosingElement = isJsxOpeningLikeElement(node);
            const isJsxOpenFragment = isJsxOpeningFragment(node);
            const isInstanceof = node.kind === 227 /* BinaryExpression */ ;
            const reportErrors2 = !isInferencePartiallyBlocked && !candidatesOutArray;
            let candidatesForArgumentError;
            let candidateForArgumentArityError;
            let candidateForTypeArgumentError;
            let result;
            let argCheckMode = 0 /* Normal */ ;
            let candidates = [];
            let typeArguments;
            if (!isDecorator2 && !isInstanceof && !isSuperCall(node) && !isJsxOpenFragment) {
                typeArguments = node.typeArguments;
                if (isTaggedTemplate || isJsxOpeningOrSelfClosingElement || node.expression.kind !== 108 /* SuperKeyword */ ) forEach(typeArguments, checkSourceElement);
            }
            candidates = candidatesOutArray || [];
            reorderCandidates(signatures, candidates, callChainFlags);
            if (!isJsxOpenFragment) {
                if (!candidates.length) {
                    if (reportErrors2) diagnostics.add(getDiagnosticForCallNode(node, Diagnostics.Call_target_does_not_contain_any_signatures));
                    return resolveErrorCall(node);
                }
            }
            const args = getEffectiveCallArguments(node);
            const isSingleNonGenericCandidate = candidates.length === 1 && !candidates[0].typeParameters;
            if (!isDecorator2 && !isSingleNonGenericCandidate && some(args, isContextSensitive)) argCheckMode = 4 /* SkipContextSensitive */ ;
            const signatureHelpTrailingComma = !!(checkMode & 16 /* IsForSignatureHelp */ ) && node.kind === 214 /* CallExpression */  && node.arguments.hasTrailingComma;
            if (candidates.length > 1) result = chooseOverload(candidates, subtypeRelation, isSingleNonGenericCandidate, signatureHelpTrailingComma);
            if (!result) result = chooseOverload(candidates, assignableRelation, isSingleNonGenericCandidate, signatureHelpTrailingComma);
            const links = getNodeLinks(node);
            if (links.resolvedSignature !== resolvingSignature && !candidatesOutArray) {
                Debug.assert(links.resolvedSignature);
                return links.resolvedSignature;
            }
            if (result) return result;
            result = getCandidateForOverloadFailure(node, candidates, args, !!candidatesOutArray, checkMode);
            links.resolvedSignature = result;
            if (reportErrors2) {
                if (!headMessage && isInstanceof) headMessage = Diagnostics.The_left_hand_side_of_an_instanceof_expression_must_be_assignable_to_the_first_argument_of_the_right_hand_side_s_Symbol_hasInstance_method;
                if (candidatesForArgumentError) {
                    if (candidatesForArgumentError.length === 1 || candidatesForArgumentError.length > 3) {
                        const last2 = candidatesForArgumentError[candidatesForArgumentError.length - 1];
                        let chain;
                        if (candidatesForArgumentError.length > 3) {
                            chain = chainDiagnosticMessages(chain, Diagnostics.The_last_overload_gave_the_following_error);
                            chain = chainDiagnosticMessages(chain, Diagnostics.No_overload_matches_this_call);
                        }
                        if (headMessage) chain = chainDiagnosticMessages(chain, headMessage);
                        const diags = getSignatureApplicabilityError(node, args, last2, assignableRelation, 0 /* Normal */ , /*reportErrors*/ true, ()=>chain);
                        if (diags) for (const d of diags){
                            if (last2.declaration && candidatesForArgumentError.length > 3) addRelatedInfo(d, createDiagnosticForNode(last2.declaration, Diagnostics.The_last_overload_is_declared_here));
                            addImplementationSuccessElaboration(last2, d);
                            diagnostics.add(d);
                        }
                        else Debug.fail("No error for last overload signature");
                    } else {
                        const allDiagnostics = [];
                        let max = 0;
                        let min2 = Number.MAX_VALUE;
                        let minIndex = 0;
                        let i = 0;
                        for (const c of candidatesForArgumentError){
                            const chain2 = ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Overload_0_of_1_2_gave_the_following_error, i + 1, candidates.length, signatureToString(c));
                            const diags2 = getSignatureApplicabilityError(node, args, c, assignableRelation, 0 /* Normal */ , /*reportErrors*/ true, chain2);
                            if (diags2) {
                                if (diags2.length <= min2) {
                                    min2 = diags2.length;
                                    minIndex = i;
                                }
                                max = Math.max(max, diags2.length);
                                allDiagnostics.push(diags2);
                            } else Debug.fail("No error for 3 or fewer overload signatures");
                            i++;
                        }
                        const diags = max > 1 ? allDiagnostics[minIndex] : flatten(allDiagnostics);
                        Debug.assert(diags.length > 0, "No errors reported for 3 or fewer overload signatures");
                        let chain = chainDiagnosticMessages(map(diags, createDiagnosticMessageChainFromDiagnostic), Diagnostics.No_overload_matches_this_call);
                        if (headMessage) chain = chainDiagnosticMessages(chain, headMessage);
                        const related = [
                            ...flatMap(diags, (d)=>d.relatedInformation)
                        ];
                        let diag2;
                        if (every(diags, (d)=>d.start === diags[0].start && d.length === diags[0].length && d.file === diags[0].file)) {
                            const { file, start, length: length2 } = diags[0];
                            diag2 = {
                                file,
                                start,
                                length: length2,
                                code: chain.code,
                                category: chain.category,
                                messageText: chain,
                                relatedInformation: related
                            };
                        } else diag2 = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(node), getErrorNodeForCallNode(node), chain, related);
                        addImplementationSuccessElaboration(candidatesForArgumentError[0], diag2);
                        diagnostics.add(diag2);
                    }
                } else if (candidateForArgumentArityError) diagnostics.add(getArgumentArityError(node, [
                    candidateForArgumentArityError
                ], args, headMessage));
                else if (candidateForTypeArgumentError) checkTypeArguments(candidateForTypeArgumentError, node.typeArguments, /*reportErrors*/ true, headMessage);
                else if (!isJsxOpenFragment) {
                    const signaturesWithCorrectTypeArgumentArity = filter(signatures, (s)=>hasCorrectTypeArgumentArity(s, typeArguments));
                    if (signaturesWithCorrectTypeArgumentArity.length === 0) diagnostics.add(getTypeArgumentArityError(node, signatures, typeArguments, headMessage));
                    else diagnostics.add(getArgumentArityError(node, signaturesWithCorrectTypeArgumentArity, args, headMessage));
                }
            }
            return result;
            function addImplementationSuccessElaboration(failed2, diagnostic) {
                var _a, _b;
                const oldCandidatesForArgumentError = candidatesForArgumentError;
                const oldCandidateForArgumentArityError = candidateForArgumentArityError;
                const oldCandidateForTypeArgumentError = candidateForTypeArgumentError;
                const failedSignatureDeclarations = ((_b = (_a = failed2.declaration) == null ? void 0 : _a.symbol) == null ? void 0 : _b.declarations) || emptyArray;
                const isOverload2 = failedSignatureDeclarations.length > 1;
                const implDecl = isOverload2 ? find(failedSignatureDeclarations, (d)=>isFunctionLikeDeclaration(d) && nodeIsPresent(d.body)) : void 0;
                if (implDecl) {
                    const candidate = getSignatureFromDeclaration(implDecl);
                    const isSingleNonGenericCandidate2 = !candidate.typeParameters;
                    if (chooseOverload([
                        candidate
                    ], assignableRelation, isSingleNonGenericCandidate2)) addRelatedInfo(diagnostic, createDiagnosticForNode(implDecl, Diagnostics.The_call_would_have_succeeded_against_this_implementation_but_implementation_signatures_of_overloads_are_not_externally_visible));
                }
                candidatesForArgumentError = oldCandidatesForArgumentError;
                candidateForArgumentArityError = oldCandidateForArgumentArityError;
                candidateForTypeArgumentError = oldCandidateForTypeArgumentError;
            }
            function chooseOverload(candidates2, relation, isSingleNonGenericCandidate2, signatureHelpTrailingComma2 = false) {
                candidatesForArgumentError = void 0;
                candidateForArgumentArityError = void 0;
                candidateForTypeArgumentError = void 0;
                if (isSingleNonGenericCandidate2) {
                    const candidate = candidates2[0];
                    if (some(typeArguments) || !hasCorrectArity(node, args, candidate, signatureHelpTrailingComma2)) return void 0;
                    if (getSignatureApplicabilityError(node, args, candidate, relation, 0 /* Normal */ , /*reportErrors*/ false, /*containingMessageChain*/ void 0)) {
                        candidatesForArgumentError = [
                            candidate
                        ];
                        return void 0;
                    }
                    return candidate;
                }
                for(let candidateIndex = 0; candidateIndex < candidates2.length; candidateIndex++){
                    const candidate = candidates2[candidateIndex];
                    if (!hasCorrectTypeArgumentArity(candidate, typeArguments) || !hasCorrectArity(node, args, candidate, signatureHelpTrailingComma2)) continue;
                    let checkCandidate;
                    let inferenceContext;
                    if (candidate.typeParameters) {
                        let typeArgumentTypes;
                        if (some(typeArguments)) {
                            typeArgumentTypes = checkTypeArguments(candidate, typeArguments, /*reportErrors*/ false);
                            if (!typeArgumentTypes) {
                                candidateForTypeArgumentError = candidate;
                                continue;
                            }
                        } else {
                            inferenceContext = createInferenceContext(candidate.typeParameters, candidate, /*flags*/ isInJSFile(node) ? 2 /* AnyDefault */  : 0 /* None */ );
                            typeArgumentTypes = inferTypeArguments(node, candidate, args, argCheckMode | 8 /* SkipGenericFunctions */ , inferenceContext);
                            argCheckMode |= inferenceContext.flags & 4 /* SkippedGenericFunction */  ? 8 /* SkipGenericFunctions */  : 0 /* Normal */ ;
                        }
                        checkCandidate = getSignatureInstantiation(candidate, typeArgumentTypes, isInJSFile(candidate.declaration), inferenceContext && inferenceContext.inferredTypeParameters);
                        if (getNonArrayRestType(candidate) && !hasCorrectArity(node, args, checkCandidate, signatureHelpTrailingComma2)) {
                            candidateForArgumentArityError = checkCandidate;
                            continue;
                        }
                    } else checkCandidate = candidate;
                    if (getSignatureApplicabilityError(node, args, checkCandidate, relation, argCheckMode, /*reportErrors*/ false, /*containingMessageChain*/ void 0)) {
                        (candidatesForArgumentError || (candidatesForArgumentError = [])).push(checkCandidate);
                        continue;
                    }
                    if (argCheckMode) {
                        argCheckMode = 0 /* Normal */ ;
                        if (inferenceContext) {
                            const typeArgumentTypes = inferTypeArguments(node, candidate, args, argCheckMode, inferenceContext);
                            checkCandidate = getSignatureInstantiation(candidate, typeArgumentTypes, isInJSFile(candidate.declaration), inferenceContext.inferredTypeParameters);
                            if (getNonArrayRestType(candidate) && !hasCorrectArity(node, args, checkCandidate, signatureHelpTrailingComma2)) {
                                candidateForArgumentArityError = checkCandidate;
                                continue;
                            }
                        }
                        if (getSignatureApplicabilityError(node, args, checkCandidate, relation, argCheckMode, /*reportErrors*/ false, /*containingMessageChain*/ void 0)) {
                            (candidatesForArgumentError || (candidatesForArgumentError = [])).push(checkCandidate);
                            continue;
                        }
                    }
                    candidates2[candidateIndex] = checkCandidate;
                    return checkCandidate;
                }
                return void 0;
            }
        }
        function getCandidateForOverloadFailure(node, candidates, args, hasCandidatesOutArray, checkMode) {
            Debug.assert(candidates.length > 0);
            checkNodeDeferred(node);
            return hasCandidatesOutArray || candidates.length === 1 || candidates.some((c)=>!!c.typeParameters) ? pickLongestCandidateSignature(node, candidates, args, checkMode) : createUnionOfSignaturesForOverloadFailure(candidates);
        }
        function createUnionOfSignaturesForOverloadFailure(candidates) {
            const thisParameters = mapDefined(candidates, (c)=>c.thisParameter);
            let thisParameter;
            if (thisParameters.length) thisParameter = createCombinedSymbolFromTypes(thisParameters, thisParameters.map(getTypeOfParameter));
            const { min: minArgumentCount, max: maxNonRestParam } = minAndMax(candidates, getNumNonRestParameters);
            const parameters = [];
            for(let i = 0; i < maxNonRestParam; i++){
                const symbols = mapDefined(candidates, (s)=>signatureHasRestParameter(s) ? i < s.parameters.length - 1 ? s.parameters[i] : last(s.parameters) : i < s.parameters.length ? s.parameters[i] : void 0);
                Debug.assert(symbols.length !== 0);
                parameters.push(createCombinedSymbolFromTypes(symbols, mapDefined(candidates, (candidate)=>tryGetTypeAtPosition(candidate, i))));
            }
            const restParameterSymbols = mapDefined(candidates, (c)=>signatureHasRestParameter(c) ? last(c.parameters) : void 0);
            let flags = 128 /* IsSignatureCandidateForOverloadFailure */ ;
            if (restParameterSymbols.length !== 0) {
                const type = createArrayType(getUnionType(mapDefined(candidates, tryGetRestTypeOfSignature), 2 /* Subtype */ ));
                parameters.push(createCombinedSymbolForOverloadFailure(restParameterSymbols, type));
                flags |= 1 /* HasRestParameter */ ;
            }
            if (candidates.some(signatureHasLiteralTypes)) flags |= 2 /* HasLiteralTypes */ ;
            return createSignature(candidates[0].declaration, /*typeParameters*/ void 0, // Before calling this we tested for `!candidates.some(c => !!c.typeParameters)`.
            thisParameter, parameters, /*resolvedReturnType*/ getIntersectionType(candidates.map(getReturnTypeOfSignature)), /*resolvedTypePredicate*/ void 0, minArgumentCount, flags);
        }
        function getNumNonRestParameters(signature) {
            const numParams = signature.parameters.length;
            return signatureHasRestParameter(signature) ? numParams - 1 : numParams;
        }
        function createCombinedSymbolFromTypes(sources, types) {
            return createCombinedSymbolForOverloadFailure(sources, getUnionType(types, 2 /* Subtype */ ));
        }
        function createCombinedSymbolForOverloadFailure(sources, type) {
            return createSymbolWithType(first(sources), type);
        }
        function pickLongestCandidateSignature(node, candidates, args, checkMode) {
            const bestIndex = getLongestCandidateIndex(candidates, apparentArgumentCount === void 0 ? args.length : apparentArgumentCount);
            const candidate = candidates[bestIndex];
            const { typeParameters } = candidate;
            if (!typeParameters) return candidate;
            const typeArgumentNodes = callLikeExpressionMayHaveTypeArguments(node) ? node.typeArguments : void 0;
            const instantiated = typeArgumentNodes ? createSignatureInstantiation(candidate, getTypeArgumentsFromNodes(typeArgumentNodes, typeParameters, isInJSFile(node))) : inferSignatureInstantiationForOverloadFailure(node, typeParameters, candidate, args, checkMode);
            candidates[bestIndex] = instantiated;
            return instantiated;
        }
        function getTypeArgumentsFromNodes(typeArgumentNodes, typeParameters, isJs) {
            const typeArguments = typeArgumentNodes.map(getTypeOfNode);
            while(typeArguments.length > typeParameters.length)typeArguments.pop();
            while(typeArguments.length < typeParameters.length)typeArguments.push(getDefaultFromTypeParameter(typeParameters[typeArguments.length]) || getConstraintOfTypeParameter(typeParameters[typeArguments.length]) || getDefaultTypeArgumentType(isJs));
            return typeArguments;
        }
        function inferSignatureInstantiationForOverloadFailure(node, typeParameters, candidate, args, checkMode) {
            const inferenceContext = createInferenceContext(typeParameters, candidate, /*flags*/ isInJSFile(node) ? 2 /* AnyDefault */  : 0 /* None */ );
            const typeArgumentTypes = inferTypeArguments(node, candidate, args, checkMode | 12 /* SkipGenericFunctions */ , inferenceContext);
            return createSignatureInstantiation(candidate, typeArgumentTypes);
        }
        function getLongestCandidateIndex(candidates, argsCount) {
            let maxParamsIndex = -1;
            let maxParams = -1;
            for(let i = 0; i < candidates.length; i++){
                const candidate = candidates[i];
                const paramCount = getParameterCount(candidate);
                if (hasEffectiveRestParameter(candidate) || paramCount >= argsCount) return i;
                if (paramCount > maxParams) {
                    maxParams = paramCount;
                    maxParamsIndex = i;
                }
            }
            return maxParamsIndex;
        }
        function resolveCallExpression(node, candidatesOutArray, checkMode) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) {
                const superType = checkSuperExpression(node.expression);
                if (isTypeAny(superType)) {
                    for (const arg of node.arguments)checkExpression(arg);
                    return anySignature;
                }
                if (!isErrorType(superType)) {
                    const baseTypeNode = getEffectiveBaseTypeNode(getContainingClass(node));
                    if (baseTypeNode) {
                        const baseConstructors = getInstantiatedConstructorsForTypeArguments(superType, baseTypeNode.typeArguments, baseTypeNode);
                        return resolveCall(node, baseConstructors, candidatesOutArray, checkMode, 0 /* None */ );
                    }
                }
                return resolveUntypedCall(node);
            }
            let callChainFlags;
            let funcType = checkExpression(node.expression);
            if (isCallChain(node)) {
                const nonOptionalType = getOptionalExpressionType(funcType, node.expression);
                callChainFlags = nonOptionalType === funcType ? 0 /* None */  : isOutermostOptionalChain(node) ? 16 /* IsOuterCallChain */  : 8 /* IsInnerCallChain */ ;
                funcType = nonOptionalType;
            } else callChainFlags = 0 /* None */ ;
            funcType = checkNonNullTypeWithReporter(funcType, node.expression, reportCannotInvokePossiblyNullOrUndefinedError);
            if (funcType === silentNeverType) return silentNeverSignature;
            const apparentType = getApparentType(funcType);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
            const numConstructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ ).length;
            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, numConstructSignatures)) {
                if (!isErrorType(funcType) && node.typeArguments) error2(node, Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
                return resolveUntypedCall(node);
            }
            if (!callSignatures.length) {
                if (numConstructSignatures) error2(node, Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new, typeToString(funcType));
                else {
                    let relatedInformation;
                    if (node.arguments.length === 1) {
                        const text = getSourceFileOfNode(node).text;
                        if (isLineBreak(text.charCodeAt(skipTrivia(text, node.expression.end, /*stopAfterLineBreak*/ true) - 1))) relatedInformation = createDiagnosticForNode(node.expression, Diagnostics.Are_you_missing_a_semicolon);
                    }
                    invocationError(node.expression, apparentType, 0 /* Call */ , relatedInformation);
                }
                return resolveErrorCall(node);
            }
            if (checkMode & 8 /* SkipGenericFunctions */  && !node.typeArguments && callSignatures.some(isGenericFunctionReturningFunction)) {
                skippedGenericFunction(node, checkMode);
                return resolvingSignature;
            }
            if (callSignatures.some((sig)=>isInJSFile(sig.declaration) && !!getJSDocClassTag(sig.declaration))) {
                error2(node, Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new, typeToString(funcType));
                return resolveErrorCall(node);
            }
            return resolveCall(node, callSignatures, candidatesOutArray, checkMode, callChainFlags);
        }
        function isGenericFunctionReturningFunction(signature) {
            return !!(signature.typeParameters && isFunctionType(getReturnTypeOfSignature(signature)));
        }
        function isUntypedFunctionCall(funcType, apparentFuncType, numCallSignatures, numConstructSignatures) {
            return isTypeAny(funcType) || isTypeAny(apparentFuncType) && !!(funcType.flags & 262144 /* TypeParameter */ ) || !numCallSignatures && !numConstructSignatures && !(apparentFuncType.flags & 1048576 /* Union */ ) && !(getReducedType(apparentFuncType).flags & 131072 /* Never */ ) && isTypeAssignableTo(funcType, globalFunctionType);
        }
        function resolveNewExpression(node, candidatesOutArray, checkMode) {
            let expressionType = checkNonNullExpression(node.expression);
            if (expressionType === silentNeverType) return silentNeverSignature;
            expressionType = getApparentType(expressionType);
            if (isErrorType(expressionType)) return resolveErrorCall(node);
            if (isTypeAny(expressionType)) {
                if (node.typeArguments) error2(node, Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
                return resolveUntypedCall(node);
            }
            const constructSignatures = getSignaturesOfType(expressionType, 1 /* Construct */ );
            if (constructSignatures.length) {
                if (!isConstructorAccessible(node, constructSignatures[0])) return resolveErrorCall(node);
                if (someSignature(constructSignatures, (signature)=>!!(signature.flags & 4 /* Abstract */ ))) {
                    error2(node, Diagnostics.Cannot_create_an_instance_of_an_abstract_class);
                    return resolveErrorCall(node);
                }
                const valueDecl = expressionType.symbol && getClassLikeDeclarationOfSymbol(expressionType.symbol);
                if (valueDecl && hasSyntacticModifier(valueDecl, 64 /* Abstract */ )) {
                    error2(node, Diagnostics.Cannot_create_an_instance_of_an_abstract_class);
                    return resolveErrorCall(node);
                }
                return resolveCall(node, constructSignatures, candidatesOutArray, checkMode, 0 /* None */ );
            }
            const callSignatures = getSignaturesOfType(expressionType, 0 /* Call */ );
            if (callSignatures.length) {
                const signature = resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ );
                if (!noImplicitAny) {
                    if (signature.declaration && !isJSConstructor(signature.declaration) && getReturnTypeOfSignature(signature) !== voidType) error2(node, Diagnostics.Only_a_void_function_can_be_called_with_the_new_keyword);
                    if (getThisTypeOfSignature(signature) === voidType) error2(node, Diagnostics.A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void);
                }
                return signature;
            }
            invocationError(node.expression, expressionType, 1 /* Construct */ );
            return resolveErrorCall(node);
        }
        function someSignature(signatures, f) {
            if (isArray(signatures)) return some(signatures, (signature)=>someSignature(signature, f));
            return signatures.compositeKind === 1048576 /* Union */  ? some(signatures.compositeSignatures, f) : f(signatures);
        }
        function typeHasProtectedAccessibleBase(target, type) {
            const baseTypes = getBaseTypes(type);
            if (!length(baseTypes)) return false;
            const firstBase = baseTypes[0];
            if (firstBase.flags & 2097152 /* Intersection */ ) {
                const types = firstBase.types;
                const mixinFlags = findMixins(types);
                let i = 0;
                for (const intersectionMember of firstBase.types){
                    if (!mixinFlags[i]) {
                        if (getObjectFlags(intersectionMember) & 3 /* Interface */ ) {
                            if (intersectionMember.symbol === target) return true;
                            if (typeHasProtectedAccessibleBase(target, intersectionMember)) return true;
                        }
                    }
                    i++;
                }
                return false;
            }
            if (firstBase.symbol === target) return true;
            return typeHasProtectedAccessibleBase(target, firstBase);
        }
        function isConstructorAccessible(node, signature) {
            if (!signature || !signature.declaration) return true;
            const declaration = signature.declaration;
            const modifiers = getSelectedEffectiveModifierFlags(declaration, 6 /* NonPublicAccessibilityModifier */ );
            if (!modifiers || declaration.kind !== 177 /* Constructor */ ) return true;
            const declaringClassDeclaration = getClassLikeDeclarationOfSymbol(declaration.parent.symbol);
            const declaringClass = getDeclaredTypeOfSymbol(declaration.parent.symbol);
            if (!isNodeWithinClass(node, declaringClassDeclaration)) {
                const containingClass = getContainingClass(node);
                if (containingClass && modifiers & 4 /* Protected */ ) {
                    const containingType = getTypeOfNode(containingClass);
                    if (typeHasProtectedAccessibleBase(declaration.parent.symbol, containingType)) return true;
                }
                if (modifiers & 2 /* Private */ ) error2(node, Diagnostics.Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
                if (modifiers & 4 /* Protected */ ) error2(node, Diagnostics.Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
                return false;
            }
            return true;
        }
        function invocationErrorDetails(errorTarget, apparentType, kind) {
            let errorInfo;
            const isCall = kind === 0 /* Call */ ;
            const awaitedType = getAwaitedType(apparentType);
            const maybeMissingAwait = awaitedType && getSignaturesOfType(awaitedType, kind).length > 0;
            if (apparentType.flags & 1048576 /* Union */ ) {
                const types = apparentType.types;
                let hasSignatures2 = false;
                for (const constituent of types){
                    const signatures = getSignaturesOfType(constituent, kind);
                    if (signatures.length !== 0) {
                        hasSignatures2 = true;
                        if (errorInfo) break;
                    } else {
                        if (!errorInfo) {
                            errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Type_0_has_no_call_signatures : Diagnostics.Type_0_has_no_construct_signatures, typeToString(constituent));
                            errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Not_all_constituents_of_type_0_are_callable : Diagnostics.Not_all_constituents_of_type_0_are_constructable, typeToString(apparentType));
                        }
                        if (hasSignatures2) break;
                    }
                }
                if (!hasSignatures2) errorInfo = chainDiagnosticMessages(/*details*/ void 0, isCall ? Diagnostics.No_constituent_of_type_0_is_callable : Diagnostics.No_constituent_of_type_0_is_constructable, typeToString(apparentType));
                if (!errorInfo) errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Each_member_of_the_union_type_0_has_signatures_but_none_of_those_signatures_are_compatible_with_each_other : Diagnostics.Each_member_of_the_union_type_0_has_construct_signatures_but_none_of_those_signatures_are_compatible_with_each_other, typeToString(apparentType));
            } else errorInfo = chainDiagnosticMessages(errorInfo, isCall ? Diagnostics.Type_0_has_no_call_signatures : Diagnostics.Type_0_has_no_construct_signatures, typeToString(apparentType));
            let headMessage = isCall ? Diagnostics.This_expression_is_not_callable : Diagnostics.This_expression_is_not_constructable;
            if (isCallExpression(errorTarget.parent) && errorTarget.parent.arguments.length === 0) {
                const { resolvedSymbol } = getNodeLinks(errorTarget);
                if (resolvedSymbol && resolvedSymbol.flags & 32768 /* GetAccessor */ ) headMessage = Diagnostics.This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without;
            }
            return {
                messageChain: chainDiagnosticMessages(errorInfo, headMessage),
                relatedMessage: maybeMissingAwait ? Diagnostics.Did_you_forget_to_use_await : void 0
            };
        }
        function invocationError(errorTarget, apparentType, kind, relatedInformation) {
            const { messageChain, relatedMessage: relatedInfo } = invocationErrorDetails(errorTarget, apparentType, kind);
            const diagnostic = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorTarget), errorTarget, messageChain);
            if (relatedInfo) addRelatedInfo(diagnostic, createDiagnosticForNode(errorTarget, relatedInfo));
            if (isCallExpression(errorTarget.parent)) {
                const { start, length: length2 } = getDiagnosticSpanForCallNode(errorTarget.parent);
                diagnostic.start = start;
                diagnostic.length = length2;
            }
            diagnostics.add(diagnostic);
            invocationErrorRecovery(apparentType, kind, relatedInformation ? addRelatedInfo(diagnostic, relatedInformation) : diagnostic);
        }
        function invocationErrorRecovery(apparentType, kind, diagnostic) {
            if (!apparentType.symbol) return;
            const importNode = getSymbolLinks(apparentType.symbol).originatingImport;
            if (importNode && !isImportCall(importNode)) {
                const sigs = getSignaturesOfType(getTypeOfSymbol(getSymbolLinks(apparentType.symbol).target), kind);
                if (!sigs || !sigs.length) return;
                addRelatedInfo(diagnostic, createDiagnosticForNode(importNode, Diagnostics.Type_originates_at_this_import_A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_Consider_using_a_default_import_or_import_require_here_instead));
            }
        }
        function resolveTaggedTemplateExpression(node, candidatesOutArray, checkMode) {
            const tagType = checkExpression(node.tag);
            const apparentType = getApparentType(tagType);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
            const numConstructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ ).length;
            if (isUntypedFunctionCall(tagType, apparentType, callSignatures.length, numConstructSignatures)) return resolveUntypedCall(node);
            if (!callSignatures.length) {
                if (isArrayLiteralExpression(node.parent)) {
                    const diagnostic = createDiagnosticForNode(node.tag, Diagnostics.It_is_likely_that_you_are_missing_a_comma_to_separate_these_two_template_expressions_They_form_a_tagged_template_expression_which_cannot_be_invoked);
                    diagnostics.add(diagnostic);
                    return resolveErrorCall(node);
                }
                invocationError(node.tag, apparentType, 0 /* Call */ );
                return resolveErrorCall(node);
            }
            return resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ );
        }
        function getDiagnosticHeadMessageForDecoratorResolution(node) {
            switch(node.parent.kind){
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    return Diagnostics.Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression;
                case 170 /* Parameter */ :
                    return Diagnostics.Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression;
                case 173 /* PropertyDeclaration */ :
                    return Diagnostics.Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression;
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return Diagnostics.Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression;
                default:
                    return Debug.fail();
            }
        }
        function resolveDecorator(node, candidatesOutArray, checkMode) {
            const funcType = checkExpression(node.expression);
            const apparentType = getApparentType(funcType);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
            const numConstructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ ).length;
            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, numConstructSignatures)) return resolveUntypedCall(node);
            if (isPotentiallyUncalledDecorator(node, callSignatures) && !isParenthesizedExpression(node.expression)) {
                const nodeStr = getTextOfNode(node.expression, /*includeTrivia*/ false);
                error2(node, Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0, nodeStr);
                return resolveErrorCall(node);
            }
            const headMessage = getDiagnosticHeadMessageForDecoratorResolution(node);
            if (!callSignatures.length) {
                const errorDetails = invocationErrorDetails(node.expression, apparentType, 0 /* Call */ );
                const messageChain = chainDiagnosticMessages(errorDetails.messageChain, headMessage);
                const diag2 = createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(node.expression), node.expression, messageChain);
                if (errorDetails.relatedMessage) addRelatedInfo(diag2, createDiagnosticForNode(node.expression, errorDetails.relatedMessage));
                diagnostics.add(diag2);
                invocationErrorRecovery(apparentType, 0 /* Call */ , diag2);
                return resolveErrorCall(node);
            }
            return resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ , headMessage);
        }
        function createSignatureForJSXIntrinsic(node, result) {
            const namespace = getJsxNamespaceAt(node);
            const exports2 = namespace && getExportsOfSymbol(namespace);
            const typeSymbol = exports2 && getSymbol2(exports2, JsxNames.Element, 788968 /* Type */ );
            const returnNode = typeSymbol && nodeBuilder.symbolToEntityName(typeSymbol, 788968 /* Type */ , node);
            const declaration = factory.createFunctionTypeNode(/*typeParameters*/ void 0, [
                factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "props", /*questionToken*/ void 0, nodeBuilder.typeToTypeNode(result, node))
            ], returnNode ? factory.createTypeReferenceNode(returnNode, /*typeArguments*/ void 0) : factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
            const parameterSymbol = createSymbol(1 /* FunctionScopedVariable */ , "props");
            parameterSymbol.links.type = result;
            return createSignature(declaration, /*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                parameterSymbol
            ], typeSymbol ? getDeclaredTypeOfSymbol(typeSymbol) : errorType, /*resolvedTypePredicate*/ void 0, 1, 0 /* None */ );
        }
        function getJSXFragmentType(node) {
            const sourceFileLinks = getNodeLinks(getSourceFileOfNode(node));
            if (sourceFileLinks.jsxFragmentType !== void 0) return sourceFileLinks.jsxFragmentType;
            const jsxFragmentFactoryName = getJsxNamespace(node);
            const shouldResolveFactoryReference = (compilerOptions.jsx === 2 /* React */  || compilerOptions.jsxFragmentFactory !== void 0) && jsxFragmentFactoryName !== "null";
            if (!shouldResolveFactoryReference) return sourceFileLinks.jsxFragmentType = anyType;
            const shouldModuleRefErr = compilerOptions.jsx !== 1 /* Preserve */  && compilerOptions.jsx !== 3 /* ReactNative */ ;
            const jsxFactoryRefErr = diagnostics ? Diagnostics.Using_JSX_fragments_requires_fragment_factory_0_to_be_in_scope_but_it_could_not_be_found : void 0;
            var _getJsxNamespaceContainerForImplicitImport;
            const jsxFactorySymbol = (_getJsxNamespaceContainerForImplicitImport = getJsxNamespaceContainerForImplicitImport(node)) !== null && _getJsxNamespaceContainerForImplicitImport !== void 0 ? _getJsxNamespaceContainerForImplicitImport : resolveName(node, jsxFragmentFactoryName, shouldModuleRefErr ? 111551 /* Value */  : 111167 /* Enum */ , /*nameNotFoundMessage*/ jsxFactoryRefErr, /*isUse*/ true);
            if (jsxFactorySymbol === void 0) return sourceFileLinks.jsxFragmentType = errorType;
            if (jsxFactorySymbol.escapedName === ReactNames.Fragment) return sourceFileLinks.jsxFragmentType = getTypeOfSymbol(jsxFactorySymbol);
            const resolvedAlias = (jsxFactorySymbol.flags & 2097152 /* Alias */ ) === 0 ? jsxFactorySymbol : resolveAlias(jsxFactorySymbol);
            const reactExports = jsxFactorySymbol && getExportsOfSymbol(resolvedAlias);
            const typeSymbol = reactExports && getSymbol2(reactExports, ReactNames.Fragment, 2 /* BlockScopedVariable */ );
            const type = typeSymbol && getTypeOfSymbol(typeSymbol);
            return sourceFileLinks.jsxFragmentType = type === void 0 ? errorType : type;
        }
        function resolveJsxOpeningLikeElement(node, candidatesOutArray, checkMode) {
            const isJsxOpenFragment = isJsxOpeningFragment(node);
            let exprTypes;
            if (!isJsxOpenFragment) {
                if (isJsxIntrinsicTagName(node.tagName)) {
                    const result = getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
                    const fakeSignature = createSignatureForJSXIntrinsic(node, result);
                    checkTypeAssignableToAndOptionallyElaborate(checkExpressionWithContextualType(node.attributes, getEffectiveFirstArgumentForJsxSignature(fakeSignature, node), /*inferenceContext*/ void 0, 0 /* Normal */ ), result, node.tagName, node.attributes);
                    if (length(node.typeArguments)) {
                        forEach(node.typeArguments, checkSourceElement);
                        diagnostics.add(createDiagnosticForNodeArray(getSourceFileOfNode(node), node.typeArguments, Diagnostics.Expected_0_type_arguments_but_got_1, 0, length(node.typeArguments)));
                    }
                    return fakeSignature;
                }
                exprTypes = checkExpression(node.tagName);
            } else exprTypes = getJSXFragmentType(node);
            const apparentType = getApparentType(exprTypes);
            if (isErrorType(apparentType)) return resolveErrorCall(node);
            const signatures = getUninstantiatedJsxSignaturesOfType(exprTypes, node);
            if (isUntypedFunctionCall(exprTypes, apparentType, signatures.length, /*constructSignatures*/ 0)) return resolveUntypedCall(node);
            if (signatures.length === 0) {
                if (isJsxOpenFragment) error2(node, Diagnostics.JSX_element_type_0_does_not_have_any_construct_or_call_signatures, getTextOfNode(node));
                else error2(node.tagName, Diagnostics.JSX_element_type_0_does_not_have_any_construct_or_call_signatures, getTextOfNode(node.tagName));
                return resolveErrorCall(node);
            }
            return resolveCall(node, signatures, candidatesOutArray, checkMode, 0 /* None */ );
        }
        function resolveInstanceofExpression(node, candidatesOutArray, checkMode) {
            const rightType = checkExpression(node.right);
            if (!isTypeAny(rightType)) {
                const hasInstanceMethodType = getSymbolHasInstanceMethodOfObjectType(rightType);
                if (hasInstanceMethodType) {
                    const apparentType = getApparentType(hasInstanceMethodType);
                    if (isErrorType(apparentType)) return resolveErrorCall(node);
                    const callSignatures = getSignaturesOfType(apparentType, 0 /* Call */ );
                    const constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */ );
                    if (isUntypedFunctionCall(hasInstanceMethodType, apparentType, callSignatures.length, constructSignatures.length)) return resolveUntypedCall(node);
                    if (callSignatures.length) return resolveCall(node, callSignatures, candidatesOutArray, checkMode, 0 /* None */ );
                } else if (!(typeHasCallOrConstructSignatures(rightType) || isTypeSubtypeOf(rightType, globalFunctionType))) {
                    error2(node.right, Diagnostics.The_right_hand_side_of_an_instanceof_expression_must_be_either_of_type_any_a_class_function_or_other_type_assignable_to_the_Function_interface_type_or_an_object_type_with_a_Symbol_hasInstance_method);
                    return resolveErrorCall(node);
                }
            }
            return anySignature;
        }
        function isPotentiallyUncalledDecorator(decorator, signatures) {
            return signatures.length && every(signatures, (signature)=>signature.minArgumentCount === 0 && !signatureHasRestParameter(signature) && signature.parameters.length < getDecoratorArgumentCount(decorator, signature));
        }
        function resolveSignature(node, candidatesOutArray, checkMode) {
            switch(node.kind){
                case 214 /* CallExpression */ :
                    return resolveCallExpression(node, candidatesOutArray, checkMode);
                case 215 /* NewExpression */ :
                    return resolveNewExpression(node, candidatesOutArray, checkMode);
                case 216 /* TaggedTemplateExpression */ :
                    return resolveTaggedTemplateExpression(node, candidatesOutArray, checkMode);
                case 171 /* Decorator */ :
                    return resolveDecorator(node, candidatesOutArray, checkMode);
                case 290 /* JsxOpeningFragment */ :
                case 287 /* JsxOpeningElement */ :
                case 286 /* JsxSelfClosingElement */ :
                    return resolveJsxOpeningLikeElement(node, candidatesOutArray, checkMode);
                case 227 /* BinaryExpression */ :
                    return resolveInstanceofExpression(node, candidatesOutArray, checkMode);
            }
            Debug.assertNever(node, "Branch in 'resolveSignature' should be unreachable.");
        }
        function getResolvedSignature(node, candidatesOutArray, checkMode) {
            const links = getNodeLinks(node);
            const cached = links.resolvedSignature;
            if (cached && cached !== resolvingSignature && !candidatesOutArray) return cached;
            const saveResolutionStart = resolutionStart;
            if (!cached) resolutionStart = resolutionTargets.length;
            links.resolvedSignature = resolvingSignature;
            const result = resolveSignature(node, candidatesOutArray, checkMode || 0 /* Normal */ );
            resolutionStart = saveResolutionStart;
            if (result !== resolvingSignature) links.resolvedSignature = flowLoopStart === flowLoopCount ? result : cached;
            return result;
        }
        function isJSConstructor(node) {
            var _a;
            if (!node || !isInJSFile(node)) return false;
            const func = isFunctionDeclaration(node) || isFunctionExpression(node) ? node : (isVariableDeclaration(node) || isPropertyAssignment(node)) && node.initializer && isFunctionExpression(node.initializer) ? node.initializer : void 0;
            if (func) {
                if (getJSDocClassTag(node)) return true;
                if (isPropertyAssignment(walkUpParenthesizedExpressions(func.parent))) return false;
                const symbol = getSymbolOfDeclaration(func);
                return !!((_a = symbol == null ? void 0 : symbol.members) == null ? void 0 : _a.size);
            }
            return false;
        }
        function mergeJSSymbols(target, source) {
            var _a, _b;
            if (source) {
                const links = getSymbolLinks(source);
                if (!links.inferredClassSymbol || !links.inferredClassSymbol.has(getSymbolId(target))) {
                    const inferred = isTransientSymbol(target) ? target : cloneSymbol(target);
                    inferred.exports = inferred.exports || createSymbolTable();
                    inferred.members = inferred.members || createSymbolTable();
                    inferred.flags |= source.flags & 32 /* Class */ ;
                    if ((_a = source.exports) == null ? void 0 : _a.size) mergeSymbolTable(inferred.exports, source.exports);
                    if ((_b = source.members) == null ? void 0 : _b.size) mergeSymbolTable(inferred.members, source.members);
                    (links.inferredClassSymbol || (links.inferredClassSymbol = /* @__PURE__ */ new Map())).set(getSymbolId(inferred), inferred);
                    return inferred;
                }
                return links.inferredClassSymbol.get(getSymbolId(target));
            }
        }
        function getAssignedClassSymbol(decl) {
            var _a;
            const assignmentSymbol = decl && getSymbolOfExpando(decl, /*allowDeclaration*/ true);
            const prototype = (_a = assignmentSymbol == null ? void 0 : assignmentSymbol.exports) == null ? void 0 : _a.get("prototype");
            const init = (prototype == null ? void 0 : prototype.valueDeclaration) && getAssignedJSPrototype(prototype.valueDeclaration);
            return init ? getSymbolOfDeclaration(init) : void 0;
        }
        function getSymbolOfExpando(node, allowDeclaration) {
            if (!node.parent) return void 0;
            let name;
            let decl;
            if (isVariableDeclaration(node.parent) && node.parent.initializer === node) {
                if (!isInJSFile(node) && !(isVarConstLike2(node.parent) && isFunctionLikeDeclaration(node))) return void 0;
                name = node.parent.name;
                decl = node.parent;
            } else if (isBinaryExpression(node.parent)) {
                const parentNode = node.parent;
                const parentNodeOperator = node.parent.operatorToken.kind;
                if (parentNodeOperator === 64 /* EqualsToken */  && (allowDeclaration || parentNode.right === node)) {
                    name = parentNode.left;
                    decl = name;
                } else if (parentNodeOperator === 57 /* BarBarToken */  || parentNodeOperator === 61 /* QuestionQuestionToken */ ) {
                    if (isVariableDeclaration(parentNode.parent) && parentNode.parent.initializer === parentNode) {
                        name = parentNode.parent.name;
                        decl = parentNode.parent;
                    } else if (isBinaryExpression(parentNode.parent) && parentNode.parent.operatorToken.kind === 64 /* EqualsToken */  && (allowDeclaration || parentNode.parent.right === parentNode)) {
                        name = parentNode.parent.left;
                        decl = name;
                    }
                    if (!name || !isBindableStaticNameExpression(name) || !isSameEntityName(name, parentNode.left)) return void 0;
                }
            } else if (allowDeclaration && isFunctionDeclaration(node)) {
                name = node.name;
                decl = node;
            }
            if (!decl || !name || !allowDeclaration && !getExpandoInitializer(node, isPrototypeAccess(name))) return void 0;
            return getSymbolOfNode(decl);
        }
        function getAssignedJSPrototype(node) {
            if (!node.parent) return false;
            let parent2 = node.parent;
            while(parent2 && parent2.kind === 212 /* PropertyAccessExpression */ )parent2 = parent2.parent;
            if (parent2 && isBinaryExpression(parent2) && isPrototypeAccess(parent2.left) && parent2.operatorToken.kind === 64 /* EqualsToken */ ) {
                const right = getInitializerOfBinaryExpression(parent2);
                return isObjectLiteralExpression(right) && right;
            }
        }
        function checkCallExpression(node, checkMode) {
            var _a, _b, _c;
            checkGrammarTypeArguments(node, node.typeArguments);
            const signature = getResolvedSignature(node, /*candidatesOutArray*/ void 0, checkMode);
            if (signature === resolvingSignature) return silentNeverType;
            checkDeprecatedSignature(signature, node);
            if (node.expression.kind === 108 /* SuperKeyword */ ) return voidType;
            if (node.kind === 215 /* NewExpression */ ) {
                const declaration = signature.declaration;
                if (declaration && declaration.kind !== 177 /* Constructor */  && declaration.kind !== 181 /* ConstructSignature */  && declaration.kind !== 186 /* ConstructorType */  && !(isJSDocSignature(declaration) && ((_b = (_a = getJSDocRoot(declaration)) == null ? void 0 : _a.parent) == null ? void 0 : _b.kind) === 177 /* Constructor */ ) && !isJSDocConstructSignature(declaration) && !isJSConstructor(declaration)) {
                    if (noImplicitAny) error2(node, Diagnostics.new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type);
                    return anyType;
                }
            }
            if (isInJSFile(node) && isCommonJsRequire(node)) return resolveExternalModuleTypeByLiteral(node.arguments[0]);
            const returnType = getReturnTypeOfSignature(signature);
            if (returnType.flags & 12288 /* ESSymbolLike */  && isSymbolOrSymbolForCall(node)) return getESSymbolLikeTypeForNode(walkUpParenthesizedExpressions(node.parent));
            if (node.kind === 214 /* CallExpression */  && !node.questionDotToken && node.parent.kind === 245 /* ExpressionStatement */  && returnType.flags & 16384 /* Void */  && getTypePredicateOfSignature(signature)) {
                if (!isDottedName(node.expression)) error2(node.expression, Diagnostics.Assertions_require_the_call_target_to_be_an_identifier_or_qualified_name);
                else if (!getEffectsSignature(node)) {
                    const diagnostic = error2(node.expression, Diagnostics.Assertions_require_every_name_in_the_call_target_to_be_declared_with_an_explicit_type_annotation);
                    getTypeOfDottedName(node.expression, diagnostic);
                }
            }
            if (isInJSFile(node)) {
                const jsSymbol = getSymbolOfExpando(node, /*allowDeclaration*/ false);
                if ((_c = jsSymbol == null ? void 0 : jsSymbol.exports) == null ? void 0 : _c.size) {
                    const jsAssignmentType = createAnonymousType(jsSymbol, jsSymbol.exports, emptyArray, emptyArray, emptyArray);
                    jsAssignmentType.objectFlags |= 4096 /* JSLiteral */ ;
                    return getIntersectionType([
                        returnType,
                        jsAssignmentType
                    ]);
                }
            }
            return returnType;
        }
        function checkDeprecatedSignature(signature, node) {
            if (signature.flags & 128 /* IsSignatureCandidateForOverloadFailure */ ) return;
            if (signature.declaration && signature.declaration.flags & 536870912 /* Deprecated */ ) {
                const suggestionNode = getDeprecatedSuggestionNode(node);
                const name = tryGetPropertyAccessOrIdentifierToString(getInvokedExpression(node));
                addDeprecatedSuggestionWithSignature(suggestionNode, signature.declaration, name, signatureToString(signature));
            }
        }
        function getDeprecatedSuggestionNode(node) {
            node = skipParentheses(node);
            switch(node.kind){
                case 214 /* CallExpression */ :
                case 171 /* Decorator */ :
                case 215 /* NewExpression */ :
                    return getDeprecatedSuggestionNode(node.expression);
                case 216 /* TaggedTemplateExpression */ :
                    return getDeprecatedSuggestionNode(node.tag);
                case 287 /* JsxOpeningElement */ :
                case 286 /* JsxSelfClosingElement */ :
                    return getDeprecatedSuggestionNode(node.tagName);
                case 213 /* ElementAccessExpression */ :
                    return node.argumentExpression;
                case 212 /* PropertyAccessExpression */ :
                    return node.name;
                case 184 /* TypeReference */ :
                    const typeReference = node;
                    return isQualifiedName(typeReference.typeName) ? typeReference.typeName.right : typeReference;
                default:
                    return node;
            }
        }
        function isSymbolOrSymbolForCall(node) {
            if (!isCallExpression(node)) return false;
            let left = node.expression;
            if (isPropertyAccessExpression(left) && left.name.escapedText === "for") left = left.expression;
            if (!isIdentifier(left) || left.escapedText !== "Symbol") return false;
            const globalESSymbol = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ false);
            if (!globalESSymbol) return false;
            return globalESSymbol === resolveName(left, "Symbol", 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
        }
        function checkImportCallExpression(node) {
            checkGrammarImportCallExpression(node);
            if (node.arguments.length === 0) return createPromiseReturnType(node, anyType);
            const specifier = node.arguments[0];
            const specifierType = checkExpressionCached(specifier);
            const optionsType = node.arguments.length > 1 ? checkExpressionCached(node.arguments[1]) : void 0;
            for(let i = 2; i < node.arguments.length; ++i)checkExpressionCached(node.arguments[i]);
            if (specifierType.flags & 32768 /* Undefined */  || specifierType.flags & 65536 /* Null */  || !isTypeAssignableTo(specifierType, stringType)) error2(specifier, Diagnostics.Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0, typeToString(specifierType));
            if (optionsType) {
                const importCallOptionsType = getGlobalImportCallOptionsType(/*reportErrors*/ true);
                if (importCallOptionsType !== emptyObjectType) checkTypeAssignableTo(optionsType, getNullableType(importCallOptionsType, 32768 /* Undefined */ ), node.arguments[1]);
            }
            const moduleSymbol = resolveExternalModuleName(node, specifier);
            if (moduleSymbol) {
                const esModuleSymbol = resolveESModuleSymbol(moduleSymbol, specifier, /*dontResolveAlias*/ true, /*suppressInteropError*/ false);
                if (esModuleSymbol) return createPromiseReturnType(node, getTypeWithSyntheticDefaultOnly(getTypeOfSymbol(esModuleSymbol), esModuleSymbol, moduleSymbol, specifier) || getTypeWithSyntheticDefaultImportType(getTypeOfSymbol(esModuleSymbol), esModuleSymbol, moduleSymbol, specifier));
            }
            return createPromiseReturnType(node, anyType);
        }
        function createDefaultPropertyWrapperForModule(symbol, originalSymbol, anonymousSymbol) {
            const memberTable = createSymbolTable();
            const newSymbol = createSymbol(2097152 /* Alias */ , "default" /* Default */ );
            newSymbol.parent = originalSymbol;
            newSymbol.links.nameType = getStringLiteralType("default");
            newSymbol.links.aliasTarget = resolveSymbol(symbol);
            memberTable.set("default" /* Default */ , newSymbol);
            return createAnonymousType(anonymousSymbol, memberTable, emptyArray, emptyArray, emptyArray);
        }
        function getTypeWithSyntheticDefaultOnly(type, symbol, originalSymbol, moduleSpecifier) {
            const hasDefaultOnly = isOnlyImportableAsDefault(moduleSpecifier);
            if (hasDefaultOnly && type && !isErrorType(type)) {
                const synthType = type;
                if (!synthType.defaultOnlyType) {
                    const type2 = createDefaultPropertyWrapperForModule(symbol, originalSymbol);
                    synthType.defaultOnlyType = type2;
                }
                return synthType.defaultOnlyType;
            }
            return void 0;
        }
        function getTypeWithSyntheticDefaultImportType(type, symbol, originalSymbol, moduleSpecifier) {
            var _a;
            if (allowSyntheticDefaultImports && type && !isErrorType(type)) {
                const synthType = type;
                if (!synthType.syntheticType) {
                    const file = (_a = originalSymbol.declarations) == null ? void 0 : _a.find(isSourceFile);
                    const hasSyntheticDefault = canHaveSyntheticDefault(file, originalSymbol, /*dontResolveAlias*/ false, moduleSpecifier);
                    if (hasSyntheticDefault) {
                        const anonymousSymbol = createSymbol(2048 /* TypeLiteral */ , "__type" /* Type */ );
                        const defaultContainingObject = createDefaultPropertyWrapperForModule(symbol, originalSymbol, anonymousSymbol);
                        anonymousSymbol.links.type = defaultContainingObject;
                        synthType.syntheticType = isValidSpreadType(type) ? getSpreadType(type, defaultContainingObject, anonymousSymbol, /*objectFlags*/ 0, /*readonly*/ false) : defaultContainingObject;
                    } else synthType.syntheticType = type;
                }
                return synthType.syntheticType;
            }
            return type;
        }
        function isCommonJsRequire(node) {
            if (!isRequireCall(node, /*requireStringLiteralLikeArgument*/ true)) return false;
            if (!isIdentifier(node.expression)) return Debug.fail();
            const resolvedRequire = resolveName(node.expression, node.expression.escapedText, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
            if (resolvedRequire === requireSymbol) return true;
            if (resolvedRequire.flags & 2097152 /* Alias */ ) return false;
            const targetDeclarationKind = resolvedRequire.flags & 16 /* Function */  ? 263 /* FunctionDeclaration */  : resolvedRequire.flags & 3 /* Variable */  ? 261 /* VariableDeclaration */  : 0 /* Unknown */ ;
            if (targetDeclarationKind !== 0 /* Unknown */ ) {
                const decl = getDeclarationOfKind(resolvedRequire, targetDeclarationKind);
                return !!decl && !!(decl.flags & 33554432 /* Ambient */ );
            }
            return false;
        }
        function checkTaggedTemplateExpression(node) {
            if (!checkGrammarTaggedTemplateChain(node)) checkGrammarTypeArguments(node, node.typeArguments);
            if (languageVersion < LanguageFeatureMinimumTarget.TaggedTemplates) checkExternalEmitHelpers(node, 262144 /* MakeTemplateObject */ );
            const signature = getResolvedSignature(node);
            checkDeprecatedSignature(signature, node);
            return getReturnTypeOfSignature(signature);
        }
        function checkAssertion(node, checkMode) {
            if (node.kind === 217 /* TypeAssertionExpression */ ) {
                const file = getSourceFileOfNode(node);
                if (file && fileExtensionIsOneOf(file.fileName, [
                    ".cts" /* Cts */ ,
                    ".mts" /* Mts */ 
                ])) grammarErrorOnNode(node, Diagnostics.This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Use_an_as_expression_instead);
                if (compilerOptions.erasableSyntaxOnly) {
                    const start = skipTrivia(file.text, node.pos);
                    const end = node.expression.pos;
                    diagnostics.add(createFileDiagnostic(file, start, end - start, Diagnostics.This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled));
                }
            }
            return checkAssertionWorker(node, checkMode);
        }
        function isValidConstAssertionArgument(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 210 /* ArrayLiteralExpression */ :
                case 211 /* ObjectLiteralExpression */ :
                case 229 /* TemplateExpression */ :
                    return true;
                case 218 /* ParenthesizedExpression */ :
                    return isValidConstAssertionArgument(node.expression);
                case 225 /* PrefixUnaryExpression */ :
                    const op = node.operator;
                    const arg = node.operand;
                    return op === 41 /* MinusToken */  && (arg.kind === 9 /* NumericLiteral */  || arg.kind === 10 /* BigIntLiteral */ ) || op === 40 /* PlusToken */  && arg.kind === 9 /* NumericLiteral */ ;
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    const expr = skipParentheses(node.expression);
                    const symbol = isEntityNameExpression(expr) ? resolveEntityName(expr, 111551 /* Value */ , /*ignoreErrors*/ true) : void 0;
                    return !!(symbol && symbol.flags & 384 /* Enum */ );
            }
            return false;
        }
        function checkAssertionWorker(node, checkMode) {
            const { type, expression } = getAssertionTypeAndExpression(node);
            const exprType = checkExpression(expression, checkMode);
            if (isConstTypeReference(type)) {
                if (!isValidConstAssertionArgument(expression)) error2(expression, Diagnostics.A_const_assertions_can_only_be_applied_to_references_to_enum_members_or_string_number_boolean_array_or_object_literals);
                return getRegularTypeOfLiteralType(exprType);
            }
            const links = getNodeLinks(node);
            links.assertionExpressionType = exprType;
            checkSourceElement(type);
            checkNodeDeferred(node);
            return getTypeFromTypeNode(type);
        }
        function getAssertionTypeAndExpression(node) {
            let type;
            let expression;
            switch(node.kind){
                case 235 /* AsExpression */ :
                case 217 /* TypeAssertionExpression */ :
                    type = node.type;
                    expression = node.expression;
                    break;
                case 218 /* ParenthesizedExpression */ :
                    type = getJSDocTypeAssertionType(node);
                    expression = node.expression;
                    break;
            }
            return {
                type,
                expression
            };
        }
        function checkAssertionDeferred(node) {
            const { type } = getAssertionTypeAndExpression(node);
            const errNode = isParenthesizedExpression(node) ? type : node;
            const links = getNodeLinks(node);
            Debug.assertIsDefined(links.assertionExpressionType);
            const exprType = getRegularTypeOfObjectLiteral(getBaseTypeOfLiteralType(links.assertionExpressionType));
            const targetType = getTypeFromTypeNode(type);
            if (!isErrorType(targetType)) addLazyDiagnostic(()=>{
                const widenedType = getWidenedType(exprType);
                if (!isTypeComparableTo(targetType, widenedType)) checkTypeComparableTo(exprType, targetType, errNode, Diagnostics.Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the_other_If_this_was_intentional_convert_the_expression_to_unknown_first);
            });
        }
        function checkNonNullChain(node) {
            const leftType = checkExpression(node.expression);
            const nonOptionalType = getOptionalExpressionType(leftType, node.expression);
            return propagateOptionalTypeMarker(getNonNullableType(nonOptionalType), node, nonOptionalType !== leftType);
        }
        function checkNonNullAssertion(node) {
            return node.flags & 64 /* OptionalChain */  ? checkNonNullChain(node) : getNonNullableType(checkExpression(node.expression));
        }
        function checkExpressionWithTypeArguments(node) {
            checkGrammarExpressionWithTypeArguments(node);
            forEach(node.typeArguments, checkSourceElement);
            if (node.kind === 234 /* ExpressionWithTypeArguments */ ) {
                const parent2 = walkUpParenthesizedExpressions(node.parent);
                if (parent2.kind === 227 /* BinaryExpression */  && parent2.operatorToken.kind === 104 /* InstanceOfKeyword */  && isNodeDescendantOf(node, parent2.right)) error2(node, Diagnostics.The_right_hand_side_of_an_instanceof_expression_must_not_be_an_instantiation_expression);
            }
            const exprType = node.kind === 234 /* ExpressionWithTypeArguments */  ? checkExpression(node.expression) : isThisIdentifier(node.exprName) ? checkThisExpression(node.exprName) : checkExpression(node.exprName);
            return getInstantiationExpressionType(exprType, node);
        }
        function getInstantiationExpressionType(exprType, node) {
            const typeArguments = node.typeArguments;
            if (exprType === silentNeverType || isErrorType(exprType) || !some(typeArguments)) return exprType;
            const links = getNodeLinks(node);
            if (!links.instantiationExpressionTypes) links.instantiationExpressionTypes = /* @__PURE__ */ new Map();
            if (links.instantiationExpressionTypes.has(exprType.id)) return links.instantiationExpressionTypes.get(exprType.id);
            let hasSomeApplicableSignature = false;
            let nonApplicableType;
            const result = getInstantiatedType(exprType);
            links.instantiationExpressionTypes.set(exprType.id, result);
            const errorType2 = hasSomeApplicableSignature ? nonApplicableType : exprType;
            if (errorType2) diagnostics.add(createDiagnosticForNodeArray(getSourceFileOfNode(node), typeArguments, Diagnostics.Type_0_has_no_signatures_for_which_the_type_argument_list_is_applicable, typeToString(errorType2)));
            return result;
            function getInstantiatedType(type) {
                let hasSignatures2 = false;
                let hasApplicableSignature = false;
                const result2 = getInstantiatedTypePart(type);
                hasSomeApplicableSignature || (hasSomeApplicableSignature = hasApplicableSignature);
                if (hasSignatures2 && !hasApplicableSignature) nonApplicableType !== null && nonApplicableType !== void 0 ? nonApplicableType : nonApplicableType = type;
                return result2;
                function getInstantiatedTypePart(type2) {
                    if (type2.flags & 524288 /* Object */ ) {
                        const resolved = resolveStructuredTypeMembers(type2);
                        const callSignatures = getInstantiatedSignatures(resolved.callSignatures);
                        const constructSignatures = getInstantiatedSignatures(resolved.constructSignatures);
                        hasSignatures2 || (hasSignatures2 = resolved.callSignatures.length !== 0 || resolved.constructSignatures.length !== 0);
                        hasApplicableSignature || (hasApplicableSignature = callSignatures.length !== 0 || constructSignatures.length !== 0);
                        if (callSignatures !== resolved.callSignatures || constructSignatures !== resolved.constructSignatures) {
                            const result3 = createAnonymousType(createSymbol(0 /* None */ , "__instantiationExpression" /* InstantiationExpression */ ), resolved.members, callSignatures, constructSignatures, resolved.indexInfos);
                            result3.objectFlags |= 8388608 /* InstantiationExpressionType */ ;
                            result3.node = node;
                            return result3;
                        }
                    } else if (type2.flags & 58982400 /* InstantiableNonPrimitive */ ) {
                        const constraint = getBaseConstraintOfType(type2);
                        if (constraint) {
                            const instantiated = getInstantiatedTypePart(constraint);
                            if (instantiated !== constraint) return instantiated;
                        }
                    } else if (type2.flags & 1048576 /* Union */ ) return mapType(type2, getInstantiatedType);
                    else if (type2.flags & 2097152 /* Intersection */ ) return getIntersectionType(sameMap(type2.types, getInstantiatedTypePart));
                    return type2;
                }
            }
            function getInstantiatedSignatures(signatures) {
                const applicableSignatures = filter(signatures, (sig)=>!!sig.typeParameters && hasCorrectTypeArgumentArity(sig, typeArguments));
                return sameMap(applicableSignatures, (sig)=>{
                    const typeArgumentTypes = checkTypeArguments(sig, typeArguments, /*reportErrors*/ true);
                    return typeArgumentTypes ? getSignatureInstantiation(sig, typeArgumentTypes, isInJSFile(sig.declaration)) : sig;
                });
            }
        }
        function checkSatisfiesExpression(node) {
            checkSourceElement(node.type);
            return checkSatisfiesExpressionWorker(node.expression, node.type);
        }
        function checkSatisfiesExpressionWorker(expression, target, checkMode) {
            const exprType = checkExpression(expression, checkMode);
            const targetType = getTypeFromTypeNode(target);
            if (isErrorType(targetType)) return targetType;
            const errorNode = findAncestor(target.parent, (n)=>n.kind === 239 /* SatisfiesExpression */  || n.kind === 351 /* JSDocSatisfiesTag */ );
            checkTypeAssignableToAndOptionallyElaborate(exprType, targetType, errorNode, expression, Diagnostics.Type_0_does_not_satisfy_the_expected_type_1);
            return exprType;
        }
        function checkMetaProperty(node) {
            checkGrammarMetaProperty(node);
            if (node.keywordToken === 105 /* NewKeyword */ ) return checkNewTargetMetaProperty(node);
            if (node.keywordToken === 102 /* ImportKeyword */ ) {
                if (node.name.escapedText === "defer") {
                    Debug.assert(!isCallExpression(node.parent) || node.parent.expression !== node, "Trying to get the type of `import.defer` in `import.defer(...)`");
                    return errorType;
                }
                return checkImportMetaProperty(node);
            }
            return Debug.assertNever(node.keywordToken);
        }
        function checkMetaPropertyKeyword(node) {
            switch(node.keywordToken){
                case 102 /* ImportKeyword */ :
                    return getGlobalImportMetaExpressionType();
                case 105 /* NewKeyword */ :
                    const type = checkNewTargetMetaProperty(node);
                    return isErrorType(type) ? errorType : createNewTargetExpressionType(type);
                default:
                    Debug.assertNever(node.keywordToken);
            }
        }
        function checkNewTargetMetaProperty(node) {
            const container = getNewTargetContainer(node);
            if (!container) {
                error2(node, Diagnostics.Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor, "new.target");
                return errorType;
            } else if (container.kind === 177 /* Constructor */ ) {
                const symbol = getSymbolOfDeclaration(container.parent);
                return getTypeOfSymbol(symbol);
            } else {
                const symbol = getSymbolOfDeclaration(container);
                return getTypeOfSymbol(symbol);
            }
        }
        function checkImportMetaProperty(node) {
            if (100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ ) {
                if (getSourceFileOfNode(node).impliedNodeFormat !== 99 /* ESNext */ ) error2(node, Diagnostics.The_import_meta_meta_property_is_not_allowed_in_files_which_will_build_into_CommonJS_output);
            } else if (moduleKind < 6 /* ES2020 */  && moduleKind !== 4 /* System */ ) error2(node, Diagnostics.The_import_meta_meta_property_is_only_allowed_when_the_module_option_is_es2020_es2022_esnext_system_node16_node18_node20_or_nodenext);
            const file = getSourceFileOfNode(node);
            Debug.assert(!!(file.flags & 8388608 /* PossiblyContainsImportMeta */ ), "Containing file is missing import meta node flag.");
            return node.name.escapedText === "meta" ? getGlobalImportMetaType() : errorType;
        }
        function getTypeOfParameter(symbol) {
            const declaration = symbol.valueDeclaration;
            return addOptionality(getTypeOfSymbol(symbol), /*isProperty*/ false, /*isOptional*/ !!declaration && (hasInitializer(declaration) || isOptionalDeclaration(declaration)));
        }
        function getTupleElementLabelFromBindingElement(node, index, elementFlags) {
            switch(node.name.kind){
                case 80 /* Identifier */ :
                    {
                        const name = node.name.escapedText;
                        if (node.dotDotDotToken) return elementFlags & 12 /* Variable */  ? name : `${name}_${index}`;
                        else return elementFlags & 3 /* Fixed */  ? name : `${name}_n`;
                    }
                case 208 /* ArrayBindingPattern */ :
                    if (node.dotDotDotToken) {
                        const elements = node.name.elements;
                        const lastElement = tryCast(lastOrUndefined(elements), isBindingElement);
                        const elementCount = elements.length - ((lastElement == null ? void 0 : lastElement.dotDotDotToken) ? 1 : 0);
                        if (index < elementCount) {
                            const element = elements[index];
                            if (isBindingElement(element)) return getTupleElementLabelFromBindingElement(element, index, elementFlags);
                        } else if (lastElement == null ? void 0 : lastElement.dotDotDotToken) return getTupleElementLabelFromBindingElement(lastElement, index - elementCount, elementFlags);
                    }
                    break;
            }
            return `arg_${index}`;
        }
        function getTupleElementLabel(d, index = 0, elementFlags = 3 /* Fixed */ , restSymbol) {
            if (!d) {
                const restParameter = tryCast(restSymbol == null ? void 0 : restSymbol.valueDeclaration, isParameter);
                var _ref;
                return restParameter ? getTupleElementLabelFromBindingElement(restParameter, index, elementFlags) : `${(_ref = restSymbol == null ? void 0 : restSymbol.escapedName) !== null && _ref !== void 0 ? _ref : "arg"}_${index}`;
            }
            Debug.assert(isIdentifier(d.name));
            return d.name.escapedText;
        }
        function getParameterNameAtPosition(signature, pos, overrideRestType) {
            var _a;
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) return signature.parameters[pos].escapedName;
            const restParameter = signature.parameters[paramCount] || unknownSymbol;
            const restType = overrideRestType || getTypeOfSymbol(restParameter);
            if (isTupleType(restType)) {
                const tupleType = restType.target;
                const index = pos - paramCount;
                const associatedName = (_a = tupleType.labeledElementDeclarations) == null ? void 0 : _a[index];
                const elementFlags = tupleType.elementFlags[index];
                return getTupleElementLabel(associatedName, index, elementFlags, restParameter);
            }
            return restParameter.escapedName;
        }
        function getParameterIdentifierInfoAtPosition(signature, pos) {
            var _a;
            if (((_a = signature.declaration) == null ? void 0 : _a.kind) === 318 /* JSDocFunctionType */ ) return void 0;
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) {
                const param = signature.parameters[pos];
                const paramIdent = getParameterDeclarationIdentifier(param);
                return paramIdent ? {
                    parameter: paramIdent,
                    parameterName: param.escapedName,
                    isRestParameter: false
                } : void 0;
            }
            const restParameter = signature.parameters[paramCount] || unknownSymbol;
            const restIdent = getParameterDeclarationIdentifier(restParameter);
            if (!restIdent) return void 0;
            const restType = getTypeOfSymbol(restParameter);
            if (isTupleType(restType)) {
                const associatedNames = restType.target.labeledElementDeclarations;
                const index = pos - paramCount;
                const associatedName = associatedNames == null ? void 0 : associatedNames[index];
                const isRestTupleElement = !!(associatedName == null ? void 0 : associatedName.dotDotDotToken);
                if (associatedName) {
                    Debug.assert(isIdentifier(associatedName.name));
                    return {
                        parameter: associatedName.name,
                        parameterName: associatedName.name.escapedText,
                        isRestParameter: isRestTupleElement
                    };
                }
                return void 0;
            }
            if (pos === paramCount) return {
                parameter: restIdent,
                parameterName: restParameter.escapedName,
                isRestParameter: true
            };
            return void 0;
        }
        function getParameterDeclarationIdentifier(symbol) {
            return symbol.valueDeclaration && isParameter(symbol.valueDeclaration) && isIdentifier(symbol.valueDeclaration.name) && symbol.valueDeclaration.name;
        }
        function isValidDeclarationForTupleLabel(d) {
            return d.kind === 203 /* NamedTupleMember */  || isParameter(d) && d.name && isIdentifier(d.name);
        }
        function getNameableDeclarationAtPosition(signature, pos) {
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) {
                const decl = signature.parameters[pos].valueDeclaration;
                return decl && isValidDeclarationForTupleLabel(decl) ? decl : void 0;
            }
            const restParameter = signature.parameters[paramCount] || unknownSymbol;
            const restType = getTypeOfSymbol(restParameter);
            if (isTupleType(restType)) {
                const associatedNames = restType.target.labeledElementDeclarations;
                const index = pos - paramCount;
                return associatedNames && associatedNames[index];
            }
            return restParameter.valueDeclaration && isValidDeclarationForTupleLabel(restParameter.valueDeclaration) ? restParameter.valueDeclaration : void 0;
        }
        function getTypeAtPosition(signature, pos) {
            return tryGetTypeAtPosition(signature, pos) || anyType;
        }
        function tryGetTypeAtPosition(signature, pos) {
            const paramCount = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            if (pos < paramCount) return getTypeOfParameter(signature.parameters[pos]);
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[paramCount]);
                const index = pos - paramCount;
                if (!isTupleType(restType) || restType.target.combinedFlags & 12 /* Variable */  || index < restType.target.fixedLength) return getIndexedAccessType(restType, getNumberLiteralType(index));
            }
            return void 0;
        }
        function getRestTypeAtPosition(source, pos, readonly) {
            const parameterCount = getParameterCount(source);
            const minArgumentCount = getMinArgumentCount(source);
            const restType = getEffectiveRestType(source);
            if (restType && pos >= parameterCount - 1) return pos === parameterCount - 1 ? restType : createArrayType(getIndexedAccessType(restType, numberType));
            const types = [];
            const flags = [];
            const names = [];
            for(let i = pos; i < parameterCount; i++){
                if (!restType || i < parameterCount - 1) {
                    types.push(getTypeAtPosition(source, i));
                    flags.push(i < minArgumentCount ? 1 /* Required */  : 2 /* Optional */ );
                } else {
                    types.push(restType);
                    flags.push(8 /* Variadic */ );
                }
                names.push(getNameableDeclarationAtPosition(source, i));
            }
            return createTupleType(types, flags, readonly, names);
        }
        function getRestOrAnyTypeAtPosition(source, pos) {
            const restType = getRestTypeAtPosition(source, pos);
            const elementType = restType && getElementTypeOfArrayType(restType);
            return elementType && isTypeAny(elementType) ? anyType : restType;
        }
        function getParameterCount(signature) {
            const length2 = signature.parameters.length;
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[length2 - 1]);
                if (isTupleType(restType)) return length2 + restType.target.fixedLength - (restType.target.combinedFlags & 12 /* Variable */  ? 0 : 1);
            }
            return length2;
        }
        function getMinArgumentCount(signature, flags) {
            const strongArityForUntypedJS = flags & 1 /* StrongArityForUntypedJS */ ;
            const voidIsNonOptional = flags & 2 /* VoidIsNonOptional */ ;
            if (voidIsNonOptional || signature.resolvedMinArgumentCount === void 0) {
                let minArgumentCount;
                if (signatureHasRestParameter(signature)) {
                    const restType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                    if (isTupleType(restType)) {
                        const firstOptionalIndex = findIndex(restType.target.elementFlags, (f)=>!(f & 1 /* Required */ ));
                        const requiredCount = firstOptionalIndex < 0 ? restType.target.fixedLength : firstOptionalIndex;
                        if (requiredCount > 0) minArgumentCount = signature.parameters.length - 1 + requiredCount;
                    }
                }
                if (minArgumentCount === void 0) {
                    if (!strongArityForUntypedJS && signature.flags & 32 /* IsUntypedSignatureInJSFile */ ) return 0;
                    minArgumentCount = signature.minArgumentCount;
                }
                if (voidIsNonOptional) return minArgumentCount;
                for(let i = minArgumentCount - 1; i >= 0; i--){
                    const type = getTypeAtPosition(signature, i);
                    if (filterType(type, acceptsVoid).flags & 131072 /* Never */ ) break;
                    minArgumentCount = i;
                }
                signature.resolvedMinArgumentCount = minArgumentCount;
            }
            return signature.resolvedMinArgumentCount;
        }
        function hasEffectiveRestParameter(signature) {
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                return !isTupleType(restType) || !!(restType.target.combinedFlags & 12 /* Variable */ );
            }
            return false;
        }
        function getEffectiveRestType(signature) {
            if (signatureHasRestParameter(signature)) {
                const restType = getTypeOfSymbol(signature.parameters[signature.parameters.length - 1]);
                if (!isTupleType(restType)) return isTypeAny(restType) ? anyArrayType : restType;
                if (restType.target.combinedFlags & 12 /* Variable */ ) return sliceTupleType(restType, restType.target.fixedLength);
            }
            return void 0;
        }
        function getNonArrayRestType(signature) {
            const restType = getEffectiveRestType(signature);
            return restType && !isArrayType(restType) && !isTypeAny(restType) ? restType : void 0;
        }
        function getTypeOfFirstParameterOfSignature(signature) {
            return getTypeOfFirstParameterOfSignatureWithFallback(signature, neverType);
        }
        function getTypeOfFirstParameterOfSignatureWithFallback(signature, fallbackType) {
            return signature.parameters.length > 0 ? getTypeAtPosition(signature, 0) : fallbackType;
        }
        function inferFromAnnotatedParametersAndReturn(signature, context, inferenceContext) {
            const len = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            for(let i = 0; i < len; i++){
                const declaration = signature.parameters[i].valueDeclaration;
                const typeNode2 = getEffectiveTypeAnnotationNode(declaration);
                if (typeNode2) {
                    const source = addOptionality(getTypeFromTypeNode(typeNode2), /*isProperty*/ false, isOptionalDeclaration(declaration));
                    const target = getTypeAtPosition(context, i);
                    inferTypes(inferenceContext.inferences, source, target);
                }
            }
            const typeNode = signature.declaration && getEffectiveReturnTypeNode(signature.declaration);
            if (typeNode) {
                const source = getTypeFromTypeNode(typeNode);
                const target = getReturnTypeOfSignature(context);
                inferTypes(inferenceContext.inferences, source, target);
            }
        }
        function assignContextualParameterTypes(signature, context) {
            if (context.typeParameters) {
                if (!signature.typeParameters) signature.typeParameters = context.typeParameters;
                else return;
            }
            if (context.thisParameter) {
                const parameter = signature.thisParameter;
                if (!parameter || parameter.valueDeclaration && !parameter.valueDeclaration.type) {
                    if (!parameter) signature.thisParameter = createSymbolWithType(context.thisParameter, /*type*/ void 0);
                    assignParameterType(signature.thisParameter, getTypeOfSymbol(context.thisParameter));
                }
            }
            const len = signature.parameters.length - (signatureHasRestParameter(signature) ? 1 : 0);
            for(let i = 0; i < len; i++){
                const parameter = signature.parameters[i];
                const declaration = parameter.valueDeclaration;
                if (!getEffectiveTypeAnnotationNode(declaration)) {
                    let type = tryGetTypeAtPosition(context, i);
                    if (type && declaration.initializer) {
                        let initializerType = checkDeclarationInitializer(declaration, 0 /* Normal */ );
                        if (!isTypeAssignableTo(initializerType, type) && isTypeAssignableTo(type, initializerType = widenTypeInferredFromInitializer(declaration, initializerType))) type = initializerType;
                    }
                    assignParameterType(parameter, type);
                }
            }
            if (signatureHasRestParameter(signature)) {
                const parameter = last(signature.parameters);
                if (parameter.valueDeclaration ? !getEffectiveTypeAnnotationNode(parameter.valueDeclaration) : !!(getCheckFlags(parameter) & 65536 /* DeferredType */ )) {
                    const contextualParameterType = getRestTypeAtPosition(context, len);
                    assignParameterType(parameter, contextualParameterType);
                }
            }
        }
        function assignNonContextualParameterTypes(signature) {
            if (signature.thisParameter) assignParameterType(signature.thisParameter);
            for (const parameter of signature.parameters)assignParameterType(parameter);
        }
        function assignParameterType(parameter, contextualType) {
            const links = getSymbolLinks(parameter);
            if (!links.type) {
                const declaration = parameter.valueDeclaration;
                links.type = addOptionality(contextualType || (declaration ? getWidenedTypeForVariableLikeDeclaration(declaration, /*reportErrors*/ true) : getTypeOfSymbol(parameter)), /*isProperty*/ false, /*isOptional*/ !!declaration && !declaration.initializer && isOptionalDeclaration(declaration));
                if (declaration && declaration.name.kind !== 80 /* Identifier */ ) {
                    if (links.type === unknownType) links.type = getTypeFromBindingPattern(declaration.name);
                    assignBindingElementTypes(declaration.name, links.type);
                }
            } else if (contextualType) Debug.assertEqual(links.type, contextualType, "Parameter symbol already has a cached type which differs from newly assigned type");
        }
        function assignBindingElementTypes(pattern, parentType) {
            for (const element of pattern.elements)if (!isOmittedExpression(element)) {
                const type = getBindingElementTypeFromParentType(element, parentType, /*noTupleBoundsCheck*/ false);
                if (element.name.kind === 80 /* Identifier */ ) getSymbolLinks(getSymbolOfDeclaration(element)).type = type;
                else assignBindingElementTypes(element.name, type);
            }
        }
        function createClassDecoratorContextType(classType) {
            return tryCreateTypeReference(getGlobalClassDecoratorContextType(/*reportErrors*/ true), [
                classType
            ]);
        }
        function createClassMethodDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassMethodDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassGetterDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassGetterDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassSetterDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassSetterDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassAccessorDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassAccessorDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassFieldDecoratorContextType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassFieldDecoratorContextType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function getClassMemberDecoratorContextOverrideType(nameType, isPrivate, isStatic2) {
            const key = `${isPrivate ? "p" : "P"}${isStatic2 ? "s" : "S"}${nameType.id}`;
            let overrideType = decoratorContextOverrideTypeCache.get(key);
            if (!overrideType) {
                const members = createSymbolTable();
                members.set("name", createProperty("name", nameType));
                members.set("private", createProperty("private", isPrivate ? trueType : falseType));
                members.set("static", createProperty("static", isStatic2 ? trueType : falseType));
                overrideType = createAnonymousType(/*symbol*/ void 0, members, emptyArray, emptyArray, emptyArray);
                decoratorContextOverrideTypeCache.set(key, overrideType);
            }
            return overrideType;
        }
        function createClassMemberDecoratorContextTypeForNode(node, thisType, valueType) {
            const isStatic2 = hasStaticModifier(node);
            const isPrivate = isPrivateIdentifier(node.name);
            const nameType = isPrivate ? getStringLiteralType(idText(node.name)) : getLiteralTypeFromPropertyName(node.name);
            const contextType = isMethodDeclaration(node) ? createClassMethodDecoratorContextType(thisType, valueType) : isGetAccessorDeclaration(node) ? createClassGetterDecoratorContextType(thisType, valueType) : isSetAccessorDeclaration(node) ? createClassSetterDecoratorContextType(thisType, valueType) : isAutoAccessorPropertyDeclaration(node) ? createClassAccessorDecoratorContextType(thisType, valueType) : isPropertyDeclaration(node) ? createClassFieldDecoratorContextType(thisType, valueType) : Debug.failBadSyntaxKind(node);
            const overrideType = getClassMemberDecoratorContextOverrideType(nameType, isPrivate, isStatic2);
            return getIntersectionType([
                contextType,
                overrideType
            ]);
        }
        function createClassAccessorDecoratorTargetType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassAccessorDecoratorTargetType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassAccessorDecoratorResultType(thisType, valueType) {
            return tryCreateTypeReference(getGlobalClassAccessorDecoratorResultType(/*reportErrors*/ true), [
                thisType,
                valueType
            ]);
        }
        function createClassFieldDecoratorInitializerMutatorType(thisType, valueType) {
            const thisParam = createParameter2("this", thisType);
            const valueParam = createParameter2("value", valueType);
            return createFunctionType(/*typeParameters*/ void 0, thisParam, [
                valueParam
            ], valueType, /*typePredicate*/ void 0, 1);
        }
        function createESDecoratorCallSignature(targetType, contextType, nonOptionalReturnType) {
            const targetParam = createParameter2("target", targetType);
            const contextParam = createParameter2("context", contextType);
            const returnType = getUnionType([
                nonOptionalReturnType,
                voidType
            ]);
            return createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                targetParam,
                contextParam
            ], returnType);
        }
        function getESDecoratorCallSignature(decorator) {
            const { parent: parent2 } = decorator;
            const links = getNodeLinks(parent2);
            if (!links.decoratorSignature) {
                links.decoratorSignature = anySignature;
                switch(parent2.kind){
                    case 264 /* ClassDeclaration */ :
                    case 232 /* ClassExpression */ :
                        {
                            const node = parent2;
                            const targetType = getTypeOfSymbol(getSymbolOfDeclaration(node));
                            const contextType = createClassDecoratorContextType(targetType);
                            links.decoratorSignature = createESDecoratorCallSignature(targetType, contextType, targetType);
                            break;
                        }
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        {
                            const node = parent2;
                            if (!isClassLike(node.parent)) break;
                            const valueType = isMethodDeclaration(node) ? getOrCreateTypeFromSignature(getSignatureFromDeclaration(node)) : getTypeOfNode(node);
                            const thisType = hasStaticModifier(node) ? getTypeOfSymbol(getSymbolOfDeclaration(node.parent)) : getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(node.parent));
                            const targetType = isGetAccessorDeclaration(node) ? createGetterFunctionType(valueType) : isSetAccessorDeclaration(node) ? createSetterFunctionType(valueType) : valueType;
                            const contextType = createClassMemberDecoratorContextTypeForNode(node, thisType, valueType);
                            const returnType = isGetAccessorDeclaration(node) ? createGetterFunctionType(valueType) : isSetAccessorDeclaration(node) ? createSetterFunctionType(valueType) : valueType;
                            links.decoratorSignature = createESDecoratorCallSignature(targetType, contextType, returnType);
                            break;
                        }
                    case 173 /* PropertyDeclaration */ :
                        {
                            const node = parent2;
                            if (!isClassLike(node.parent)) break;
                            const valueType = getTypeOfNode(node);
                            const thisType = hasStaticModifier(node) ? getTypeOfSymbol(getSymbolOfDeclaration(node.parent)) : getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(node.parent));
                            const targetType = hasAccessorModifier(node) ? createClassAccessorDecoratorTargetType(thisType, valueType) : undefinedType;
                            const contextType = createClassMemberDecoratorContextTypeForNode(node, thisType, valueType);
                            const returnType = hasAccessorModifier(node) ? createClassAccessorDecoratorResultType(thisType, valueType) : createClassFieldDecoratorInitializerMutatorType(thisType, valueType);
                            links.decoratorSignature = createESDecoratorCallSignature(targetType, contextType, returnType);
                            break;
                        }
                }
            }
            return links.decoratorSignature === anySignature ? void 0 : links.decoratorSignature;
        }
        function getLegacyDecoratorCallSignature(decorator) {
            const { parent: parent2 } = decorator;
            const links = getNodeLinks(parent2);
            if (!links.decoratorSignature) {
                links.decoratorSignature = anySignature;
                switch(parent2.kind){
                    case 264 /* ClassDeclaration */ :
                    case 232 /* ClassExpression */ :
                        {
                            const node = parent2;
                            const targetType = getTypeOfSymbol(getSymbolOfDeclaration(node));
                            const targetParam = createParameter2("target", targetType);
                            links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                targetParam
                            ], getUnionType([
                                targetType,
                                voidType
                            ]));
                            break;
                        }
                    case 170 /* Parameter */ :
                        {
                            const node = parent2;
                            if (!isConstructorDeclaration(node.parent) && !(isMethodDeclaration(node.parent) || isSetAccessorDeclaration(node.parent) && isClassLike(node.parent.parent))) break;
                            if (getThisParameter(node.parent) === node) break;
                            const index = getThisParameter(node.parent) ? node.parent.parameters.indexOf(node) - 1 : node.parent.parameters.indexOf(node);
                            Debug.assert(index >= 0);
                            const targetType = isConstructorDeclaration(node.parent) ? getTypeOfSymbol(getSymbolOfDeclaration(node.parent.parent)) : getParentTypeOfClassElement(node.parent);
                            const keyType = isConstructorDeclaration(node.parent) ? undefinedType : getClassElementPropertyKeyType(node.parent);
                            const indexType = getNumberLiteralType(index);
                            const targetParam = createParameter2("target", targetType);
                            const keyParam = createParameter2("propertyKey", keyType);
                            const indexParam = createParameter2("parameterIndex", indexType);
                            links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                targetParam,
                                keyParam,
                                indexParam
                            ], voidType);
                            break;
                        }
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 173 /* PropertyDeclaration */ :
                        {
                            const node = parent2;
                            if (!isClassLike(node.parent)) break;
                            const targetType = getParentTypeOfClassElement(node);
                            const targetParam = createParameter2("target", targetType);
                            const keyType = getClassElementPropertyKeyType(node);
                            const keyParam = createParameter2("propertyKey", keyType);
                            const returnType = isPropertyDeclaration(node) ? voidType : createTypedPropertyDescriptorType(getTypeOfNode(node));
                            const hasPropDesc = !isPropertyDeclaration(parent2) || hasAccessorModifier(parent2);
                            if (hasPropDesc) {
                                const descriptorType = createTypedPropertyDescriptorType(getTypeOfNode(node));
                                const descriptorParam = createParameter2("descriptor", descriptorType);
                                links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                    targetParam,
                                    keyParam,
                                    descriptorParam
                                ], getUnionType([
                                    returnType,
                                    voidType
                                ]));
                            } else links.decoratorSignature = createCallSignature(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                                targetParam,
                                keyParam
                            ], getUnionType([
                                returnType,
                                voidType
                            ]));
                            break;
                        }
                }
            }
            return links.decoratorSignature === anySignature ? void 0 : links.decoratorSignature;
        }
        function getDecoratorCallSignature(decorator) {
            return legacyDecorators ? getLegacyDecoratorCallSignature(decorator) : getESDecoratorCallSignature(decorator);
        }
        function createPromiseType(promisedType) {
            const globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
            if (globalPromiseType !== emptyGenericType) {
                promisedType = getAwaitedTypeNoAlias(unwrapAwaitedType(promisedType)) || unknownType;
                return createTypeReference(globalPromiseType, [
                    promisedType
                ]);
            }
            return unknownType;
        }
        function createPromiseLikeType(promisedType) {
            const globalPromiseLikeType = getGlobalPromiseLikeType(/*reportErrors*/ true);
            if (globalPromiseLikeType !== emptyGenericType) {
                promisedType = getAwaitedTypeNoAlias(unwrapAwaitedType(promisedType)) || unknownType;
                return createTypeReference(globalPromiseLikeType, [
                    promisedType
                ]);
            }
            return unknownType;
        }
        function createPromiseReturnType(func, promisedType) {
            const promiseType = createPromiseType(promisedType);
            if (promiseType === unknownType) {
                error2(func, isImportCall(func) ? Diagnostics.A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option : Diagnostics.An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option);
                return errorType;
            } else if (!getGlobalPromiseConstructorSymbol(/*reportErrors*/ true)) error2(func, isImportCall(func) ? Diagnostics.A_dynamic_import_call_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option : Diagnostics.An_async_function_or_method_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
            return promiseType;
        }
        function createNewTargetExpressionType(targetType) {
            const symbol = createSymbol(0 /* None */ , "NewTargetExpression");
            const targetPropertySymbol = createSymbol(4 /* Property */ , "target", 8 /* Readonly */ );
            targetPropertySymbol.parent = symbol;
            targetPropertySymbol.links.type = targetType;
            const members = createSymbolTable([
                targetPropertySymbol
            ]);
            symbol.members = members;
            return createAnonymousType(symbol, members, emptyArray, emptyArray, emptyArray);
        }
        function getReturnTypeFromBody(func, checkMode) {
            if (!func.body) return errorType;
            const functionFlags = getFunctionFlags(func);
            const isAsync = (functionFlags & 2 /* Async */ ) !== 0;
            const isGenerator = (functionFlags & 1 /* Generator */ ) !== 0;
            let returnType;
            let yieldType;
            let nextType;
            let fallbackReturnType = voidType;
            if (func.body.kind !== 242 /* Block */ ) {
                returnType = checkExpressionCached(func.body, checkMode && checkMode & -9 /* SkipGenericFunctions */ );
                if (isAsync) returnType = unwrapAwaitedType(checkAwaitedType(returnType, /*withAlias*/ false, /*errorNode*/ func, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member));
            } else if (isGenerator) {
                const returnTypes = checkAndAggregateReturnExpressionTypes(func, checkMode);
                if (!returnTypes) fallbackReturnType = neverType;
                else if (returnTypes.length > 0) returnType = getUnionType(returnTypes, 2 /* Subtype */ );
                const { yieldTypes, nextTypes } = checkAndAggregateYieldOperandTypes(func, checkMode);
                yieldType = some(yieldTypes) ? getUnionType(yieldTypes, 2 /* Subtype */ ) : void 0;
                nextType = some(nextTypes) ? getIntersectionType(nextTypes) : void 0;
            } else {
                const types = checkAndAggregateReturnExpressionTypes(func, checkMode);
                if (!types) return functionFlags & 2 /* Async */  ? createPromiseReturnType(func, neverType) : neverType;
                if (types.length === 0) {
                    const contextualReturnType = getContextualReturnType(func, /*contextFlags*/ void 0);
                    const returnType2 = contextualReturnType && (unwrapReturnType(contextualReturnType, functionFlags) || voidType).flags & 32768 /* Undefined */  ? undefinedType : voidType;
                    return functionFlags & 2 /* Async */  ? createPromiseReturnType(func, returnType2) : // Async function
                    returnType2;
                }
                returnType = getUnionType(types, 2 /* Subtype */ );
            }
            if (returnType || yieldType || nextType) {
                if (yieldType) reportErrorsFromWidening(func, yieldType, 3 /* GeneratorYield */ );
                if (returnType) reportErrorsFromWidening(func, returnType, 1 /* FunctionReturn */ );
                if (nextType) reportErrorsFromWidening(func, nextType, 2 /* GeneratorNext */ );
                if (returnType && isUnitType(returnType) || yieldType && isUnitType(yieldType) || nextType && isUnitType(nextType)) {
                    const contextualSignature = getContextualSignatureForFunctionLikeDeclaration(func);
                    const contextualType = !contextualSignature ? void 0 : contextualSignature === getSignatureFromDeclaration(func) ? isGenerator ? void 0 : returnType : instantiateContextualType(getReturnTypeOfSignature(contextualSignature), func, /*contextFlags*/ void 0);
                    if (isGenerator) {
                        yieldType = getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(yieldType, contextualType, 0 /* Yield */ , isAsync);
                        returnType = getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(returnType, contextualType, 1 /* Return */ , isAsync);
                        nextType = getWidenedLiteralLikeTypeForContextualIterationTypeIfNeeded(nextType, contextualType, 2 /* Next */ , isAsync);
                    } else returnType = getWidenedLiteralLikeTypeForContextualReturnTypeIfNeeded(returnType, contextualType, isAsync);
                }
                if (yieldType) yieldType = getWidenedType(yieldType);
                if (returnType) returnType = getWidenedType(returnType);
                if (nextType) nextType = getWidenedType(nextType);
            }
            if (isGenerator) return createGeneratorType(yieldType || neverType, returnType || fallbackReturnType, nextType || getContextualIterationType(2 /* Next */ , func) || unknownType, isAsync);
            else return isAsync ? createPromiseType(returnType || fallbackReturnType) : returnType || fallbackReturnType;
        }
        function createGeneratorType(yieldType, returnType, nextType, isAsyncGenerator) {
            const resolver = isAsyncGenerator ? asyncIterationTypesResolver : syncIterationTypesResolver;
            const globalGeneratorType = resolver.getGlobalGeneratorType(/*reportErrors*/ false);
            yieldType = resolver.resolveIterationType(yieldType, /*errorNode*/ void 0) || unknownType;
            returnType = resolver.resolveIterationType(returnType, /*errorNode*/ void 0) || unknownType;
            if (globalGeneratorType === emptyGenericType) {
                const globalIterableIteratorType = resolver.getGlobalIterableIteratorType(/*reportErrors*/ false);
                if (globalIterableIteratorType !== emptyGenericType) return createTypeFromGenericGlobalType(globalIterableIteratorType, [
                    yieldType,
                    returnType,
                    nextType
                ]);
                resolver.getGlobalIterableIteratorType(/*reportErrors*/ true);
                return emptyObjectType;
            }
            return createTypeFromGenericGlobalType(globalGeneratorType, [
                yieldType,
                returnType,
                nextType
            ]);
        }
        function checkAndAggregateYieldOperandTypes(func, checkMode) {
            const yieldTypes = [];
            const nextTypes = [];
            const isAsync = (getFunctionFlags(func) & 2 /* Async */ ) !== 0;
            forEachYieldExpression(func.body, (yieldExpression)=>{
                const yieldExpressionType = yieldExpression.expression ? checkExpression(yieldExpression.expression, checkMode) : undefinedWideningType;
                pushIfUnique(yieldTypes, getYieldedTypeOfYieldExpression(yieldExpression, yieldExpressionType, anyType, isAsync));
                let nextType;
                if (yieldExpression.asteriskToken) {
                    const iterationTypes = getIterationTypesOfIterable(yieldExpressionType, isAsync ? 19 /* AsyncYieldStar */  : 17 /* YieldStar */ , yieldExpression.expression);
                    nextType = iterationTypes && iterationTypes.nextType;
                } else nextType = getContextualType2(yieldExpression, /*contextFlags*/ void 0);
                if (nextType) pushIfUnique(nextTypes, nextType);
            });
            return {
                yieldTypes,
                nextTypes
            };
        }
        function getYieldedTypeOfYieldExpression(node, expressionType, sentType, isAsync) {
            if (expressionType === silentNeverType) return silentNeverType;
            const errorNode = node.expression || node;
            const yieldedType = node.asteriskToken ? checkIteratedTypeOrElementType(isAsync ? 19 /* AsyncYieldStar */  : 17 /* YieldStar */ , expressionType, sentType, errorNode) : expressionType;
            return !isAsync ? yieldedType : getAwaitedType(yieldedType, errorNode, node.asteriskToken ? Diagnostics.Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member : Diagnostics.Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
        }
        function getNotEqualFactsFromTypeofSwitch(start, end, witnesses) {
            let facts = 0 /* None */ ;
            for(let i = 0; i < witnesses.length; i++){
                const witness = i < start || i >= end ? witnesses[i] : void 0;
                facts |= witness !== void 0 ? typeofNEFacts.get(witness) || 32768 /* TypeofNEHostObject */  : 0;
            }
            return facts;
        }
        function isExhaustiveSwitchStatement(node) {
            const links = getNodeLinks(node);
            if (links.isExhaustive === void 0) {
                links.isExhaustive = 0;
                const exhaustive = computeExhaustiveSwitchStatement(node);
                if (links.isExhaustive === 0) links.isExhaustive = exhaustive;
            } else if (links.isExhaustive === 0) links.isExhaustive = false;
            return links.isExhaustive;
        }
        function computeExhaustiveSwitchStatement(node) {
            if (node.expression.kind === 222 /* TypeOfExpression */ ) {
                const witnesses = getSwitchClauseTypeOfWitnesses(node);
                if (!witnesses) return false;
                const operandConstraint = getBaseConstraintOrType(checkExpressionCached(node.expression.expression));
                const notEqualFacts = getNotEqualFactsFromTypeofSwitch(0, 0, witnesses);
                if (operandConstraint.flags & 3 /* AnyOrUnknown */ ) return (556800 /* AllTypeofNE */  & notEqualFacts) === 556800 /* AllTypeofNE */ ;
                return !someType(operandConstraint, (t)=>getTypeFacts(t, notEqualFacts) === notEqualFacts);
            }
            const type = getBaseConstraintOrType(checkExpressionCached(node.expression));
            if (!isLiteralType(type)) return false;
            const switchTypes = getSwitchClauseTypes(node);
            if (!switchTypes.length || some(switchTypes, isNeitherUnitTypeNorNever)) return false;
            return eachTypeContainedIn(mapType(type, getRegularTypeOfLiteralType), switchTypes);
        }
        function functionHasImplicitReturn(func) {
            return func.endFlowNode && isReachableFlowNode(func.endFlowNode);
        }
        function checkAndAggregateReturnExpressionTypes(func, checkMode) {
            const functionFlags = getFunctionFlags(func);
            const aggregatedTypes = [];
            let hasReturnWithNoExpression = functionHasImplicitReturn(func);
            let hasReturnOfTypeNever = false;
            forEachReturnStatement(func.body, (returnStatement)=>{
                let expr = returnStatement.expression;
                if (expr) {
                    expr = skipParentheses(expr, /*excludeJSDocTypeAssertions*/ true);
                    if (functionFlags & 2 /* Async */  && expr.kind === 224 /* AwaitExpression */ ) expr = skipParentheses(expr.expression, /*excludeJSDocTypeAssertions*/ true);
                    if (expr.kind === 214 /* CallExpression */  && expr.expression.kind === 80 /* Identifier */  && checkExpressionCached(expr.expression).symbol === getMergedSymbol(func.symbol) && (!isFunctionExpressionOrArrowFunction(func.symbol.valueDeclaration) || isConstantReference(expr.expression))) {
                        hasReturnOfTypeNever = true;
                        return;
                    }
                    let type = checkExpressionCached(expr, checkMode && checkMode & -9 /* SkipGenericFunctions */ );
                    if (functionFlags & 2 /* Async */ ) type = unwrapAwaitedType(checkAwaitedType(type, /*withAlias*/ false, func, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member));
                    if (type.flags & 131072 /* Never */ ) hasReturnOfTypeNever = true;
                    pushIfUnique(aggregatedTypes, type);
                } else hasReturnWithNoExpression = true;
            });
            if (aggregatedTypes.length === 0 && !hasReturnWithNoExpression && (hasReturnOfTypeNever || mayReturnNever(func))) return void 0;
            if (strictNullChecks && aggregatedTypes.length && hasReturnWithNoExpression && !(isJSConstructor(func) && aggregatedTypes.some((t)=>t.symbol === func.symbol))) pushIfUnique(aggregatedTypes, undefinedType);
            return aggregatedTypes;
        }
        function mayReturnNever(func) {
            switch(func.kind){
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    return true;
                case 175 /* MethodDeclaration */ :
                    return func.parent.kind === 211 /* ObjectLiteralExpression */ ;
                default:
                    return false;
            }
        }
        function getTypePredicateFromBody(func) {
            switch(func.kind){
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return void 0;
            }
            const functionFlags = getFunctionFlags(func);
            if (functionFlags !== 0 /* Normal */ ) return void 0;
            let singleReturn;
            if (func.body && func.body.kind !== 242 /* Block */ ) singleReturn = func.body;
            else {
                const bailedEarly = forEachReturnStatement(func.body, (returnStatement)=>{
                    if (singleReturn || !returnStatement.expression) return true;
                    singleReturn = returnStatement.expression;
                });
                if (bailedEarly || !singleReturn || functionHasImplicitReturn(func)) return void 0;
            }
            return checkIfExpressionRefinesAnyParameter(func, singleReturn);
        }
        function checkIfExpressionRefinesAnyParameter(func, expr) {
            expr = skipParentheses(expr, /*excludeJSDocTypeAssertions*/ true);
            const returnType = checkExpressionCached(expr);
            if (!(returnType.flags & 16 /* Boolean */ )) return void 0;
            return forEach(func.parameters, (param, i)=>{
                const initType = getTypeOfSymbol(param.symbol);
                if (!initType || initType.flags & 16 /* Boolean */  || !isIdentifier(param.name) || isSymbolAssigned(param.symbol) || isRestParameter(param)) return;
                const trueType2 = checkIfExpressionRefinesParameter(func, expr, param, initType);
                if (trueType2) return createTypePredicate(1 /* Identifier */ , unescapeLeadingUnderscores(param.name.escapedText), i, trueType2);
            });
        }
        function checkIfExpressionRefinesParameter(func, expr, param, initType) {
            const antecedent = canHaveFlowNode(expr) && expr.flowNode || expr.parent.kind === 254 /* ReturnStatement */  && expr.parent.flowNode || createFlowNode(2 /* Start */ , /*node*/ void 0, /*antecedent*/ void 0);
            const trueCondition = createFlowNode(32 /* TrueCondition */ , expr, antecedent);
            const trueType2 = getFlowTypeOfReference(param.name, initType, initType, func, trueCondition);
            if (trueType2 === initType) return void 0;
            const falseCondition = createFlowNode(64 /* FalseCondition */ , expr, antecedent);
            const falseSubtype = getReducedType(getFlowTypeOfReference(param.name, initType, trueType2, func, falseCondition));
            return falseSubtype.flags & 131072 /* Never */  ? trueType2 : void 0;
        }
        function checkAllCodePathsInNonVoidFunctionReturnOrThrow(func, returnType) {
            addLazyDiagnostic(checkAllCodePathsInNonVoidFunctionReturnOrThrowDiagnostics);
            return;
            function checkAllCodePathsInNonVoidFunctionReturnOrThrowDiagnostics() {
                const functionFlags = getFunctionFlags(func);
                const type = returnType && unwrapReturnType(returnType, functionFlags);
                if (type && (maybeTypeOfKind(type, 16384 /* Void */ ) || type.flags & 32769 /* Undefined */ )) return;
                if (func.kind === 174 /* MethodSignature */  || nodeIsMissing(func.body) || func.body.kind !== 242 /* Block */  || !functionHasImplicitReturn(func)) return;
                const hasExplicitReturn = func.flags & 1024 /* HasExplicitReturn */ ;
                const errorNode = getEffectiveReturnTypeNode(func) || func;
                if (type && type.flags & 131072 /* Never */ ) error2(errorNode, Diagnostics.A_function_returning_never_cannot_have_a_reachable_end_point);
                else if (type && !hasExplicitReturn) error2(errorNode, Diagnostics.A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value);
                else if (type && strictNullChecks && !isTypeAssignableTo(undefinedType, type)) error2(errorNode, Diagnostics.Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined);
                else if (compilerOptions.noImplicitReturns) {
                    if (!type) {
                        if (!hasExplicitReturn) return;
                        const inferredReturnType = getReturnTypeOfSignature(getSignatureFromDeclaration(func));
                        if (isUnwrappedReturnTypeUndefinedVoidOrAny(func, inferredReturnType)) return;
                    }
                    error2(errorNode, Diagnostics.Not_all_code_paths_return_a_value);
                }
            }
        }
        function checkFunctionExpressionOrObjectLiteralMethod(node, checkMode) {
            Debug.assert(node.kind !== 175 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            checkNodeDeferred(node);
            if (isFunctionExpression(node)) checkCollisionsForDeclarationName(node, node.name);
            if (checkMode && checkMode & 4 /* SkipContextSensitive */  && isContextSensitive(node)) {
                if (!getEffectiveReturnTypeNode(node) && !hasContextSensitiveParameters(node)) {
                    const contextualSignature = getContextualSignature(node);
                    if (contextualSignature && couldContainTypeVariables(getReturnTypeOfSignature(contextualSignature))) {
                        const links = getNodeLinks(node);
                        if (links.contextFreeType) return links.contextFreeType;
                        const returnType = getReturnTypeFromBody(node, checkMode);
                        const returnOnlySignature = createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, returnType, /*resolvedTypePredicate*/ void 0, 0, 64 /* IsNonInferrable */ );
                        const returnOnlyType = createAnonymousType(node.symbol, emptySymbols, [
                            returnOnlySignature
                        ], emptyArray, emptyArray);
                        returnOnlyType.objectFlags |= 262144 /* NonInferrableType */ ;
                        return links.contextFreeType = returnOnlyType;
                    }
                }
                return anyFunctionType;
            }
            const hasGrammarError = checkGrammarFunctionLikeDeclaration(node);
            if (!hasGrammarError && node.kind === 219 /* FunctionExpression */ ) checkGrammarForGenerator(node);
            contextuallyCheckFunctionExpressionOrObjectLiteralMethod(node, checkMode);
            return getTypeOfSymbol(getSymbolOfDeclaration(node));
        }
        function contextuallyCheckFunctionExpressionOrObjectLiteralMethod(node, checkMode) {
            const links = getNodeLinks(node);
            if (!(links.flags & 64 /* ContextChecked */ )) {
                const contextualSignature = getContextualSignature(node);
                if (!(links.flags & 64 /* ContextChecked */ )) {
                    links.flags |= 64 /* ContextChecked */ ;
                    const signature = firstOrUndefined(getSignaturesOfType(getTypeOfSymbol(getSymbolOfDeclaration(node)), 0 /* Call */ ));
                    if (!signature) return;
                    if (isContextSensitive(node)) {
                        if (contextualSignature) {
                            const inferenceContext = getInferenceContext(node);
                            let instantiatedContextualSignature;
                            if (checkMode && checkMode & 2 /* Inferential */ ) {
                                inferFromAnnotatedParametersAndReturn(signature, contextualSignature, inferenceContext);
                                const restType = getEffectiveRestType(contextualSignature);
                                if (restType && restType.flags & 262144 /* TypeParameter */ ) instantiatedContextualSignature = instantiateSignature(contextualSignature, inferenceContext.nonFixingMapper);
                            }
                            instantiatedContextualSignature || (instantiatedContextualSignature = inferenceContext ? instantiateSignature(contextualSignature, inferenceContext.mapper) : contextualSignature);
                            assignContextualParameterTypes(signature, instantiatedContextualSignature);
                        } else assignNonContextualParameterTypes(signature);
                    } else if (contextualSignature && !node.typeParameters && contextualSignature.parameters.length > node.parameters.length) {
                        const inferenceContext = getInferenceContext(node);
                        if (checkMode && checkMode & 2 /* Inferential */ ) inferFromAnnotatedParametersAndReturn(signature, contextualSignature, inferenceContext);
                    }
                    if (contextualSignature && !getReturnTypeFromAnnotation(node) && !signature.resolvedReturnType) {
                        const returnType = getReturnTypeFromBody(node, checkMode);
                        if (!signature.resolvedReturnType) signature.resolvedReturnType = returnType;
                    }
                    checkSignatureDeclaration(node);
                }
            }
        }
        function checkFunctionExpressionOrObjectLiteralMethodDeferred(node) {
            Debug.assert(node.kind !== 175 /* MethodDeclaration */  || isObjectLiteralMethod(node));
            const functionFlags = getFunctionFlags(node);
            const returnType = getReturnTypeFromAnnotation(node);
            checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnType);
            if (node.body) {
                if (!getEffectiveReturnTypeNode(node)) getReturnTypeOfSignature(getSignatureFromDeclaration(node));
                if (node.body.kind === 242 /* Block */ ) checkSourceElement(node.body);
                else {
                    const exprType = checkExpression(node.body);
                    const returnOrPromisedType = returnType && unwrapReturnType(returnType, functionFlags);
                    if (returnOrPromisedType) checkReturnExpression(node, returnOrPromisedType, node.body, node.body, exprType);
                }
            }
        }
        function checkArithmeticOperandType(operand, type, diagnostic, isAwaitValid = false) {
            if (!isTypeAssignableTo(type, numberOrBigIntType)) {
                const awaitedType = isAwaitValid && getAwaitedTypeOfPromise(type);
                errorAndMaybeSuggestAwait(operand, !!awaitedType && isTypeAssignableTo(awaitedType, numberOrBigIntType), diagnostic);
                return false;
            }
            return true;
        }
        function isReadonlyAssignmentDeclaration(d) {
            if (!isCallExpression(d)) return false;
            if (!isBindableObjectDefinePropertyCall(d)) return false;
            const objectLitType = checkExpressionCached(d.arguments[2]);
            const valueType = getTypeOfPropertyOfType(objectLitType, "value");
            if (valueType) {
                const writableProp = getPropertyOfType(objectLitType, "writable");
                const writableType = writableProp && getTypeOfSymbol(writableProp);
                if (!writableType || writableType === falseType || writableType === regularFalseType) return true;
                if (writableProp && writableProp.valueDeclaration && isPropertyAssignment(writableProp.valueDeclaration)) {
                    const initializer = writableProp.valueDeclaration.initializer;
                    const rawOriginalType = checkExpression(initializer);
                    if (rawOriginalType === falseType || rawOriginalType === regularFalseType) return true;
                }
                return false;
            }
            const setProp = getPropertyOfType(objectLitType, "set");
            return !setProp;
        }
        function isReadonlySymbol(symbol) {
            return !!(getCheckFlags(symbol) & 8 /* Readonly */  || symbol.flags & 4 /* Property */  && getDeclarationModifierFlagsFromSymbol(symbol) & 8 /* Readonly */  || symbol.flags & 3 /* Variable */  && getDeclarationNodeFlagsFromSymbol(symbol) & 6 /* Constant */  || symbol.flags & 98304 /* Accessor */  && !(symbol.flags & 65536 /* SetAccessor */ ) || symbol.flags & 8 /* EnumMember */  || some(symbol.declarations, isReadonlyAssignmentDeclaration));
        }
        function isAssignmentToReadonlyEntity(expr, symbol, assignmentKind) {
            var _a, _b;
            if (assignmentKind === 0 /* None */ ) return false;
            if (isReadonlySymbol(symbol)) {
                if (symbol.flags & 4 /* Property */  && isAccessExpression(expr) && expr.expression.kind === 110 /* ThisKeyword */ ) {
                    const ctor = getControlFlowContainer(expr);
                    if (!(ctor && (ctor.kind === 177 /* Constructor */  || isJSConstructor(ctor)))) return true;
                    if (symbol.valueDeclaration) {
                        const isAssignmentDeclaration2 = isBinaryExpression(symbol.valueDeclaration);
                        const isLocalPropertyDeclaration = ctor.parent === symbol.valueDeclaration.parent;
                        const isLocalParameterProperty = ctor === symbol.valueDeclaration.parent;
                        const isLocalThisPropertyAssignment = isAssignmentDeclaration2 && ((_a = symbol.parent) == null ? void 0 : _a.valueDeclaration) === ctor.parent;
                        const isLocalThisPropertyAssignmentConstructorFunction = isAssignmentDeclaration2 && ((_b = symbol.parent) == null ? void 0 : _b.valueDeclaration) === ctor;
                        const isWriteableSymbol = isLocalPropertyDeclaration || isLocalParameterProperty || isLocalThisPropertyAssignment || isLocalThisPropertyAssignmentConstructorFunction;
                        return !isWriteableSymbol;
                    }
                }
                return true;
            }
            if (isAccessExpression(expr)) {
                const node = skipParentheses(expr.expression);
                if (node.kind === 80 /* Identifier */ ) {
                    const symbol2 = getNodeLinks(node).resolvedSymbol;
                    if (symbol2.flags & 2097152 /* Alias */ ) {
                        const declaration = getDeclarationOfAliasSymbol(symbol2);
                        return !!declaration && declaration.kind === 275 /* NamespaceImport */ ;
                    }
                }
            }
            return false;
        }
        function checkReferenceExpression(expr, invalidReferenceMessage, invalidOptionalChainMessage) {
            const node = skipOuterExpressions(expr, 39 /* Parentheses */ );
            if (node.kind !== 80 /* Identifier */  && !isAccessExpression(node)) {
                error2(expr, invalidReferenceMessage);
                return false;
            }
            if (node.flags & 64 /* OptionalChain */ ) {
                error2(expr, invalidOptionalChainMessage);
                return false;
            }
            return true;
        }
        function checkDeleteExpression(node) {
            checkExpression(node.expression);
            const expr = skipParentheses(node.expression);
            if (!isAccessExpression(expr)) {
                error2(expr, Diagnostics.The_operand_of_a_delete_operator_must_be_a_property_reference);
                return booleanType;
            }
            if (isPropertyAccessExpression(expr) && isPrivateIdentifier(expr.name)) error2(expr, Diagnostics.The_operand_of_a_delete_operator_cannot_be_a_private_identifier);
            const links = getNodeLinks(expr);
            const symbol = getExportSymbolOfValueSymbolIfExported(links.resolvedSymbol);
            if (symbol) {
                if (isReadonlySymbol(symbol)) error2(expr, Diagnostics.The_operand_of_a_delete_operator_cannot_be_a_read_only_property);
                else checkDeleteExpressionMustBeOptional(expr, symbol);
            }
            return booleanType;
        }
        function checkDeleteExpressionMustBeOptional(expr, symbol) {
            const type = getTypeOfSymbol(symbol);
            if (strictNullChecks && !(type.flags & 131075 /* Never */ ) && !(exactOptionalPropertyTypes ? symbol.flags & 16777216 /* Optional */  : hasTypeFacts(type, 16777216 /* IsUndefined */ ))) error2(expr, Diagnostics.The_operand_of_a_delete_operator_must_be_optional);
        }
        function checkTypeOfExpression(node) {
            checkExpression(node.expression);
            return typeofType;
        }
        function checkVoidExpression(node) {
            checkNodeDeferred(node);
            return undefinedWideningType;
        }
        function checkAwaitGrammar(node) {
            let hasError = false;
            const container = getContainingFunctionOrClassStaticBlock(node);
            if (container && isClassStaticBlockDeclaration(container)) {
                const message = isAwaitExpression(node) ? Diagnostics.await_expression_cannot_be_used_inside_a_class_static_block : Diagnostics.await_using_statements_cannot_be_used_inside_a_class_static_block;
                error2(node, message);
                hasError = true;
            } else if (!(node.flags & 65536 /* AwaitContext */ )) {
                if (isInTopLevelContext(node)) {
                    const sourceFile = getSourceFileOfNode(node);
                    if (!hasParseDiagnostics(sourceFile)) {
                        let span;
                        if (!isEffectiveExternalModule(sourceFile, compilerOptions)) {
                            span !== null && span !== void 0 ? span : span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                            const message = isAwaitExpression(node) ? Diagnostics.await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module : Diagnostics.await_using_statements_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module;
                            const diagnostic = createFileDiagnostic(sourceFile, span.start, span.length, message);
                            diagnostics.add(diagnostic);
                            hasError = true;
                        }
                        switch(moduleKind){
                            case 100 /* Node16 */ :
                            case 101 /* Node18 */ :
                            case 102 /* Node20 */ :
                            case 199 /* NodeNext */ :
                                if (sourceFile.impliedNodeFormat === 1 /* CommonJS */ ) {
                                    span !== null && span !== void 0 ? span : span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                                    diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level));
                                    hasError = true;
                                    break;
                                }
                            // fallthrough
                            case 7 /* ES2022 */ :
                            case 99 /* ESNext */ :
                            case 200 /* Preserve */ :
                            case 4 /* System */ :
                                if (languageVersion >= 4 /* ES2017 */ ) break;
                            // fallthrough
                            default:
                                span !== null && span !== void 0 ? span : span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                                const message = isAwaitExpression(node) ? Diagnostics.Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher : Diagnostics.Top_level_await_using_statements_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher;
                                diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, message));
                                hasError = true;
                                break;
                        }
                    }
                } else {
                    const sourceFile = getSourceFileOfNode(node);
                    if (!hasParseDiagnostics(sourceFile)) {
                        const span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                        const message = isAwaitExpression(node) ? Diagnostics.await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules : Diagnostics.await_using_statements_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules;
                        const diagnostic = createFileDiagnostic(sourceFile, span.start, span.length, message);
                        if (container && container.kind !== 177 /* Constructor */  && (getFunctionFlags(container) & 2 /* Async */ ) === 0) {
                            const relatedInfo = createDiagnosticForNode(container, Diagnostics.Did_you_mean_to_mark_this_function_as_async);
                            addRelatedInfo(diagnostic, relatedInfo);
                        }
                        diagnostics.add(diagnostic);
                        hasError = true;
                    }
                }
            }
            if (isAwaitExpression(node) && isInParameterInitializerBeforeContainingFunction(node)) {
                error2(node, Diagnostics.await_expressions_cannot_be_used_in_a_parameter_initializer);
                hasError = true;
            }
            return hasError;
        }
        function checkAwaitExpression(node) {
            addLazyDiagnostic(()=>checkAwaitGrammar(node));
            const operandType = checkExpression(node.expression);
            const awaitedType = checkAwaitedType(operandType, /*withAlias*/ true, node, Diagnostics.Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
            if (awaitedType === operandType && !isErrorType(awaitedType) && !(operandType.flags & 3 /* AnyOrUnknown */ )) addErrorOrSuggestion(/*isError*/ false, createDiagnosticForNode(node, Diagnostics.await_has_no_effect_on_the_type_of_this_expression));
            return awaitedType;
        }
        function checkPrefixUnaryExpression(node) {
            const operandType = checkExpression(node.operand);
            if (operandType === silentNeverType) return silentNeverType;
            switch(node.operand.kind){
                case 9 /* NumericLiteral */ :
                    switch(node.operator){
                        case 41 /* MinusToken */ :
                            return getFreshTypeOfLiteralType(getNumberLiteralType(-node.operand.text));
                        case 40 /* PlusToken */ :
                            return getFreshTypeOfLiteralType(getNumberLiteralType(+node.operand.text));
                    }
                    break;
                case 10 /* BigIntLiteral */ :
                    if (node.operator === 41 /* MinusToken */ ) return getFreshTypeOfLiteralType(getBigIntLiteralType({
                        negative: true,
                        base10Value: parsePseudoBigInt(node.operand.text)
                    }));
            }
            switch(node.operator){
                case 40 /* PlusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                    checkNonNullType(operandType, node.operand);
                    if (maybeTypeOfKindConsideringBaseConstraint(operandType, 12288 /* ESSymbolLike */ )) error2(node.operand, Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, tokenToString(node.operator));
                    if (node.operator === 40 /* PlusToken */ ) {
                        if (maybeTypeOfKindConsideringBaseConstraint(operandType, 2112 /* BigIntLike */ )) error2(node.operand, Diagnostics.Operator_0_cannot_be_applied_to_type_1, tokenToString(node.operator), typeToString(getBaseTypeOfLiteralType(operandType)));
                        return numberType;
                    }
                    return getUnaryResultType(operandType);
                case 54 /* ExclamationToken */ :
                    checkTruthinessOfType(operandType, node.operand);
                    const facts = getTypeFacts(operandType, 12582912 /* Falsy */ );
                    return facts === 4194304 /* Truthy */  ? falseType : facts === 8388608 /* Falsy */  ? trueType : booleanType;
                case 46 /* PlusPlusToken */ :
                case 47 /* MinusMinusToken */ :
                    const ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type);
                    if (ok) checkReferenceExpression(node.operand, Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access, Diagnostics.The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access);
                    return getUnaryResultType(operandType);
            }
            return errorType;
        }
        function checkPostfixUnaryExpression(node) {
            const operandType = checkExpression(node.operand);
            if (operandType === silentNeverType) return silentNeverType;
            const ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type);
            if (ok) checkReferenceExpression(node.operand, Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access, Diagnostics.The_operand_of_an_increment_or_decrement_operator_may_not_be_an_optional_property_access);
            return getUnaryResultType(operandType);
        }
        function getUnaryResultType(operandType) {
            if (maybeTypeOfKind(operandType, 2112 /* BigIntLike */ )) return isTypeAssignableToKind(operandType, 3 /* AnyOrUnknown */ ) || maybeTypeOfKind(operandType, 296 /* NumberLike */ ) ? numberOrBigIntType : bigintType;
            return numberType;
        }
        function maybeTypeOfKindConsideringBaseConstraint(type, kind) {
            if (maybeTypeOfKind(type, kind)) return true;
            const baseConstraint = getBaseConstraintOrType(type);
            return !!baseConstraint && maybeTypeOfKind(baseConstraint, kind);
        }
        function maybeTypeOfKind(type, kind) {
            if (type.flags & kind) return true;
            if (type.flags & 3145728 /* UnionOrIntersection */ ) {
                const types = type.types;
                for (const t of types){
                    if (maybeTypeOfKind(t, kind)) return true;
                }
            }
            return false;
        }
        function isTypeAssignableToKind(source, kind, strict) {
            if (source.flags & kind) return true;
            if (strict && source.flags & 114691 /* Null */ ) return false;
            return !!(kind & 296 /* NumberLike */ ) && isTypeAssignableTo(source, numberType) || !!(kind & 2112 /* BigIntLike */ ) && isTypeAssignableTo(source, bigintType) || !!(kind & 402653316 /* StringLike */ ) && isTypeAssignableTo(source, stringType) || !!(kind & 528 /* BooleanLike */ ) && isTypeAssignableTo(source, booleanType) || !!(kind & 16384 /* Void */ ) && isTypeAssignableTo(source, voidType) || !!(kind & 131072 /* Never */ ) && isTypeAssignableTo(source, neverType) || !!(kind & 65536 /* Null */ ) && isTypeAssignableTo(source, nullType) || !!(kind & 32768 /* Undefined */ ) && isTypeAssignableTo(source, undefinedType) || !!(kind & 4096 /* ESSymbol */ ) && isTypeAssignableTo(source, esSymbolType) || !!(kind & 67108864 /* NonPrimitive */ ) && isTypeAssignableTo(source, nonPrimitiveType);
        }
        function allTypesAssignableToKind(source, kind, strict) {
            return source.flags & 1048576 /* Union */  ? every(source.types, (subType)=>allTypesAssignableToKind(subType, kind, strict)) : isTypeAssignableToKind(source, kind, strict);
        }
        function isConstEnumObjectType(type) {
            return !!(getObjectFlags(type) & 16 /* Anonymous */ ) && !!type.symbol && isConstEnumSymbol(type.symbol);
        }
        function isConstEnumSymbol(symbol) {
            return (symbol.flags & 128 /* ConstEnum */ ) !== 0;
        }
        function getSymbolHasInstanceMethodOfObjectType(type) {
            const hasInstancePropertyName = getPropertyNameForKnownSymbolName("hasInstance");
            if (allTypesAssignableToKind(type, 67108864 /* NonPrimitive */ )) {
                const hasInstanceProperty = getPropertyOfType(type, hasInstancePropertyName);
                if (hasInstanceProperty) {
                    const hasInstancePropertyType = getTypeOfSymbol(hasInstanceProperty);
                    if (hasInstancePropertyType && getSignaturesOfType(hasInstancePropertyType, 0 /* Call */ ).length !== 0) return hasInstancePropertyType;
                }
            }
        }
        function checkInstanceOfExpression(left, right, leftType, rightType, checkMode) {
            if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
            if (!isTypeAny(leftType) && allTypesAssignableToKind(leftType, 402784252 /* Primitive */ )) error2(left, Diagnostics.The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter);
            Debug.assert(isInstanceOfExpression(left.parent));
            const signature = getResolvedSignature(left.parent, /*candidatesOutArray*/ void 0, checkMode);
            if (signature === resolvingSignature) return silentNeverType;
            const returnType = getReturnTypeOfSignature(signature);
            checkTypeAssignableTo(returnType, booleanType, right, Diagnostics.An_object_s_Symbol_hasInstance_method_must_return_a_boolean_value_for_it_to_be_used_on_the_right_hand_side_of_an_instanceof_expression);
            return booleanType;
        }
        function hasEmptyObjectIntersection(type) {
            return someType(type, (t)=>t === unknownEmptyObjectType || !!(t.flags & 2097152 /* Intersection */ ) && isEmptyAnonymousObjectType(getBaseConstraintOrType(t)));
        }
        function checkInExpression(left, right, leftType, rightType) {
            if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
            if (isPrivateIdentifier(left)) {
                if (languageVersion < LanguageFeatureMinimumTarget.PrivateNamesAndClassStaticBlocks || languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators || !useDefineForClassFields) checkExternalEmitHelpers(left, 2097152 /* ClassPrivateFieldIn */ );
                if (!getNodeLinks(left).resolvedSymbol && getContainingClass(left)) {
                    const isUncheckedJS = isUncheckedJSSuggestion(left, rightType.symbol, /*excludeClasses*/ true);
                    reportNonexistentProperty(left, rightType, isUncheckedJS);
                }
            } else checkTypeAssignableTo(checkNonNullType(leftType, left), stringNumberSymbolType, left);
            if (checkTypeAssignableTo(checkNonNullType(rightType, right), nonPrimitiveType, right)) {
                if (hasEmptyObjectIntersection(rightType)) error2(right, Diagnostics.Type_0_may_represent_a_primitive_value_which_is_not_permitted_as_the_right_operand_of_the_in_operator, typeToString(rightType));
            }
            return booleanType;
        }
        function checkObjectLiteralAssignment(node, sourceType, rightIsThis) {
            const properties = node.properties;
            if (strictNullChecks && properties.length === 0) return checkNonNullType(sourceType, node);
            for(let i = 0; i < properties.length; i++)checkObjectLiteralDestructuringPropertyAssignment(node, sourceType, i, properties, rightIsThis);
            return sourceType;
        }
        function checkObjectLiteralDestructuringPropertyAssignment(node, objectLiteralType, propertyIndex, allProperties, rightIsThis = false) {
            const properties = node.properties;
            const property = properties[propertyIndex];
            if (property.kind === 304 /* PropertyAssignment */  || property.kind === 305 /* ShorthandPropertyAssignment */ ) {
                const name = property.name;
                const exprType = getLiteralTypeFromPropertyName(name);
                if (isTypeUsableAsPropertyName(exprType)) {
                    const text = getPropertyNameFromType(exprType);
                    const prop = getPropertyOfType(objectLiteralType, text);
                    if (prop) {
                        markPropertyAsReferenced(prop, property, rightIsThis);
                        checkPropertyAccessibility(property, /*isSuper*/ false, /*writing*/ true, objectLiteralType, prop);
                    }
                }
                const elementType = getIndexedAccessType(objectLiteralType, exprType, 32 /* ExpressionPosition */  | (hasDefaultValue(property) ? 16 /* AllowMissing */  : 0), name);
                const type = getFlowTypeOfDestructuring(property, elementType);
                return checkDestructuringAssignment(property.kind === 305 /* ShorthandPropertyAssignment */  ? property : property.initializer, type);
            } else if (property.kind === 306 /* SpreadAssignment */ ) {
                if (propertyIndex < properties.length - 1) error2(property, Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
                else {
                    if (languageVersion < LanguageFeatureMinimumTarget.ObjectSpreadRest) checkExternalEmitHelpers(property, 4 /* Rest */ );
                    const nonRestNames = [];
                    if (allProperties) {
                        for (const otherProperty of allProperties)if (!isSpreadAssignment(otherProperty)) nonRestNames.push(otherProperty.name);
                    }
                    const type = getRestType(objectLiteralType, nonRestNames, objectLiteralType.symbol);
                    checkGrammarForDisallowedTrailingComma(allProperties, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                    return checkDestructuringAssignment(property.expression, type);
                }
            } else error2(property, Diagnostics.Property_assignment_expected);
        }
        function checkArrayLiteralAssignment(node, sourceType, checkMode) {
            const elements = node.elements;
            if (languageVersion < LanguageFeatureMinimumTarget.DestructuringAssignment && compilerOptions.downlevelIteration) checkExternalEmitHelpers(node, 512 /* Read */ );
            const possiblyOutOfBoundsType = checkIteratedTypeOrElementType(193 /* PossiblyOutOfBounds */ , sourceType, undefinedType, node) || errorType;
            let inBoundsType = compilerOptions.noUncheckedIndexedAccess ? void 0 : possiblyOutOfBoundsType;
            for(let i = 0; i < elements.length; i++){
                let type = possiblyOutOfBoundsType;
                if (node.elements[i].kind === 231 /* SpreadElement */ ) type = inBoundsType = inBoundsType !== null && inBoundsType !== void 0 ? inBoundsType : checkIteratedTypeOrElementType(65 /* Destructuring */ , sourceType, undefinedType, node) || errorType;
                checkArrayLiteralDestructuringElementAssignment(node, sourceType, i, type, checkMode);
            }
            return sourceType;
        }
        function checkArrayLiteralDestructuringElementAssignment(node, sourceType, elementIndex, elementType, checkMode) {
            const elements = node.elements;
            const element = elements[elementIndex];
            if (element.kind !== 233 /* OmittedExpression */ ) {
                if (element.kind !== 231 /* SpreadElement */ ) {
                    const indexType = getNumberLiteralType(elementIndex);
                    if (isArrayLikeType(sourceType)) {
                        const accessFlags = 32 /* ExpressionPosition */  | (hasDefaultValue(element) ? 16 /* AllowMissing */  : 0);
                        const elementType2 = getIndexedAccessTypeOrUndefined(sourceType, indexType, accessFlags, createSyntheticExpression(element, indexType)) || errorType;
                        const assignedType = hasDefaultValue(element) ? getTypeWithFacts(elementType2, 524288 /* NEUndefined */ ) : elementType2;
                        const type = getFlowTypeOfDestructuring(element, assignedType);
                        return checkDestructuringAssignment(element, type, checkMode);
                    }
                    return checkDestructuringAssignment(element, elementType, checkMode);
                }
                if (elementIndex < elements.length - 1) error2(element, Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
                else {
                    const restExpression = element.expression;
                    if (restExpression.kind === 227 /* BinaryExpression */  && restExpression.operatorToken.kind === 64 /* EqualsToken */ ) error2(restExpression.operatorToken, Diagnostics.A_rest_element_cannot_have_an_initializer);
                    else {
                        checkGrammarForDisallowedTrailingComma(node.elements, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                        const type = everyType(sourceType, isTupleType) ? mapType(sourceType, (t)=>sliceTupleType(t, elementIndex)) : createArrayType(elementType);
                        return checkDestructuringAssignment(restExpression, type, checkMode);
                    }
                }
            }
            return void 0;
        }
        function checkDestructuringAssignment(exprOrAssignment, sourceType, checkMode, rightIsThis) {
            let target;
            if (exprOrAssignment.kind === 305 /* ShorthandPropertyAssignment */ ) {
                const prop = exprOrAssignment;
                if (prop.objectAssignmentInitializer) {
                    if (strictNullChecks && !hasTypeFacts(checkExpression(prop.objectAssignmentInitializer), 16777216 /* IsUndefined */ )) sourceType = getTypeWithFacts(sourceType, 524288 /* NEUndefined */ );
                    checkBinaryLikeExpression(prop.name, prop.equalsToken, prop.objectAssignmentInitializer, checkMode);
                }
                target = exprOrAssignment.name;
            } else target = exprOrAssignment;
            if (target.kind === 227 /* BinaryExpression */  && target.operatorToken.kind === 64 /* EqualsToken */ ) {
                checkBinaryExpression(target, checkMode);
                target = target.left;
                if (strictNullChecks) sourceType = getTypeWithFacts(sourceType, 524288 /* NEUndefined */ );
            }
            if (target.kind === 211 /* ObjectLiteralExpression */ ) return checkObjectLiteralAssignment(target, sourceType, rightIsThis);
            if (target.kind === 210 /* ArrayLiteralExpression */ ) return checkArrayLiteralAssignment(target, sourceType, checkMode);
            return checkReferenceAssignment(target, sourceType, checkMode);
        }
        function checkReferenceAssignment(target, sourceType, checkMode) {
            const targetType = checkExpression(target, checkMode);
            const error3 = target.parent.kind === 306 /* SpreadAssignment */  ? Diagnostics.The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access : Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access;
            const optionalError = target.parent.kind === 306 /* SpreadAssignment */  ? Diagnostics.The_target_of_an_object_rest_assignment_may_not_be_an_optional_property_access : Diagnostics.The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access;
            if (checkReferenceExpression(target, error3, optionalError)) checkTypeAssignableToAndOptionallyElaborate(sourceType, targetType, target, target);
            if (isPrivateIdentifierPropertyAccessExpression(target)) checkExternalEmitHelpers(target.parent, 1048576 /* ClassPrivateFieldSet */ );
            return sourceType;
        }
        function isSideEffectFree(node) {
            node = skipParentheses(node);
            switch(node.kind){
                case 80 /* Identifier */ :
                case 11 /* StringLiteral */ :
                case 14 /* RegularExpressionLiteral */ :
                case 216 /* TaggedTemplateExpression */ :
                case 229 /* TemplateExpression */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 219 /* FunctionExpression */ :
                case 232 /* ClassExpression */ :
                case 220 /* ArrowFunction */ :
                case 210 /* ArrayLiteralExpression */ :
                case 211 /* ObjectLiteralExpression */ :
                case 222 /* TypeOfExpression */ :
                case 236 /* NonNullExpression */ :
                case 286 /* JsxSelfClosingElement */ :
                case 285 /* JsxElement */ :
                    return true;
                case 228 /* ConditionalExpression */ :
                    return isSideEffectFree(node.whenTrue) && isSideEffectFree(node.whenFalse);
                case 227 /* BinaryExpression */ :
                    if (isAssignmentOperator(node.operatorToken.kind)) return false;
                    return isSideEffectFree(node.left) && isSideEffectFree(node.right);
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    switch(node.operator){
                        case 54 /* ExclamationToken */ :
                        case 40 /* PlusToken */ :
                        case 41 /* MinusToken */ :
                        case 55 /* TildeToken */ :
                            return true;
                    }
                    return false;
                // Some forms listed here for clarity
                case 223 /* VoidExpression */ :
                // Explicit opt-out
                case 217 /* TypeAssertionExpression */ :
                // Not SEF, but can produce useful type warnings
                case 235 /* AsExpression */ :
                // Not SEF, but can produce useful type warnings
                default:
                    return false;
            }
        }
        function isTypeEqualityComparableTo(source, target) {
            return (target.flags & 98304 /* Nullable */ ) !== 0 || isTypeComparableTo(source, target);
        }
        function createCheckBinaryExpression() {
            const trampoline = createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, foldState);
            return (node, checkMode)=>{
                const result = trampoline(node, checkMode);
                Debug.assertIsDefined(result);
                return result;
            };
            function onEnter(node, state, checkMode) {
                if (state) {
                    state.stackIndex++;
                    state.skip = false;
                    setLeftType(state, /*type*/ void 0);
                    setLastResult(state, /*type*/ void 0);
                } else state = {
                    checkMode,
                    skip: false,
                    stackIndex: 0,
                    typeStack: [
                        void 0,
                        void 0
                    ]
                };
                if (isInJSFile(node) && getAssignedExpandoInitializer(node)) {
                    state.skip = true;
                    setLastResult(state, checkExpression(node.right, checkMode));
                    return state;
                }
                checkNullishCoalesceOperands(node);
                const operator = node.operatorToken.kind;
                if (operator === 64 /* EqualsToken */  && (node.left.kind === 211 /* ObjectLiteralExpression */  || node.left.kind === 210 /* ArrayLiteralExpression */ )) {
                    state.skip = true;
                    setLastResult(state, checkDestructuringAssignment(node.left, checkExpression(node.right, checkMode), checkMode, node.right.kind === 110 /* ThisKeyword */ ));
                    return state;
                }
                return state;
            }
            function onLeft(left, state, _node) {
                if (!state.skip) return maybeCheckExpression(state, left);
            }
            function onOperator(operatorToken, state, node) {
                if (!state.skip) {
                    const leftType = getLastResult(state);
                    Debug.assertIsDefined(leftType);
                    setLeftType(state, leftType);
                    setLastResult(state, /*type*/ void 0);
                    const operator = operatorToken.kind;
                    if (isLogicalOrCoalescingBinaryOperator(operator)) {
                        let parent2 = node.parent;
                        while(parent2.kind === 218 /* ParenthesizedExpression */  || isLogicalOrCoalescingBinaryExpression(parent2))parent2 = parent2.parent;
                        if (operator === 56 /* AmpersandAmpersandToken */  || isIfStatement(parent2)) checkTestingKnownTruthyCallableOrAwaitableOrEnumMemberType(node.left, leftType, isIfStatement(parent2) ? parent2.thenStatement : void 0);
                        if (isBinaryLogicalOperator(operator)) checkTruthinessOfType(leftType, node.left);
                    }
                }
            }
            function onRight(right, state, _node) {
                if (!state.skip) return maybeCheckExpression(state, right);
            }
            function onExit(node, state) {
                let result;
                if (state.skip) result = getLastResult(state);
                else {
                    const leftType = getLeftType(state);
                    Debug.assertIsDefined(leftType);
                    const rightType = getLastResult(state);
                    Debug.assertIsDefined(rightType);
                    result = checkBinaryLikeExpressionWorker(node.left, node.operatorToken, node.right, leftType, rightType, state.checkMode, node);
                }
                state.skip = false;
                setLeftType(state, /*type*/ void 0);
                setLastResult(state, /*type*/ void 0);
                state.stackIndex--;
                return result;
            }
            function foldState(state, result, _side) {
                setLastResult(state, result);
                return state;
            }
            function maybeCheckExpression(state, node) {
                if (isBinaryExpression(node)) return node;
                setLastResult(state, checkExpression(node, state.checkMode));
            }
            function getLeftType(state) {
                return state.typeStack[state.stackIndex];
            }
            function setLeftType(state, type) {
                state.typeStack[state.stackIndex] = type;
            }
            function getLastResult(state) {
                return state.typeStack[state.stackIndex + 1];
            }
            function setLastResult(state, type) {
                state.typeStack[state.stackIndex + 1] = type;
            }
        }
        function checkNullishCoalesceOperands(node) {
            if (node.operatorToken.kind !== 61 /* QuestionQuestionToken */ ) return;
            if (isBinaryExpression(node.parent)) {
                const { left, operatorToken } = node.parent;
                if (isBinaryExpression(left) && operatorToken.kind === 57 /* BarBarToken */ ) grammarErrorOnNode(left, Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses, tokenToString(61 /* QuestionQuestionToken */ ), tokenToString(operatorToken.kind));
            } else if (isBinaryExpression(node.left)) {
                const { operatorToken } = node.left;
                if (operatorToken.kind === 57 /* BarBarToken */  || operatorToken.kind === 56 /* AmpersandAmpersandToken */ ) grammarErrorOnNode(node.left, Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses, tokenToString(operatorToken.kind), tokenToString(61 /* QuestionQuestionToken */ ));
            } else if (isBinaryExpression(node.right)) {
                const { operatorToken } = node.right;
                if (operatorToken.kind === 56 /* AmpersandAmpersandToken */ ) grammarErrorOnNode(node.right, Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses, tokenToString(61 /* QuestionQuestionToken */ ), tokenToString(operatorToken.kind));
            }
            checkNullishCoalesceOperandLeft(node);
            checkNullishCoalesceOperandRight(node);
        }
        function checkNullishCoalesceOperandLeft(node) {
            const leftTarget = skipOuterExpressions(node.left, 63 /* All */ );
            const nullishSemantics = getSyntacticNullishnessSemantics(leftTarget);
            if (nullishSemantics !== 3 /* Sometimes */ ) {
                if (nullishSemantics === 1 /* Always */ ) error2(leftTarget, Diagnostics.This_expression_is_always_nullish);
                else error2(leftTarget, Diagnostics.Right_operand_of_is_unreachable_because_the_left_operand_is_never_nullish);
            }
        }
        function checkNullishCoalesceOperandRight(node) {
            const rightTarget = skipOuterExpressions(node.right, 63 /* All */ );
            const nullishSemantics = getSyntacticNullishnessSemantics(rightTarget);
            if (isNotWithinNullishCoalesceExpression(node)) return;
            if (nullishSemantics === 1 /* Always */ ) error2(rightTarget, Diagnostics.This_expression_is_always_nullish);
            else if (nullishSemantics === 2 /* Never */ ) error2(rightTarget, Diagnostics.This_expression_is_never_nullish);
        }
        function isNotWithinNullishCoalesceExpression(node) {
            return !isBinaryExpression(node.parent) || node.parent.operatorToken.kind !== 61 /* QuestionQuestionToken */ ;
        }
        function getSyntacticNullishnessSemantics(node) {
            node = skipOuterExpressions(node);
            switch(node.kind){
                case 224 /* AwaitExpression */ :
                case 214 /* CallExpression */ :
                case 216 /* TaggedTemplateExpression */ :
                case 213 /* ElementAccessExpression */ :
                case 237 /* MetaProperty */ :
                case 215 /* NewExpression */ :
                case 212 /* PropertyAccessExpression */ :
                case 230 /* YieldExpression */ :
                case 110 /* ThisKeyword */ :
                    return 3 /* Sometimes */ ;
                case 227 /* BinaryExpression */ :
                    switch(node.operatorToken.kind){
                        case 64 /* EqualsToken */ :
                        case 61 /* QuestionQuestionToken */ :
                        case 78 /* QuestionQuestionEqualsToken */ :
                        case 57 /* BarBarToken */ :
                        case 76 /* BarBarEqualsToken */ :
                        case 56 /* AmpersandAmpersandToken */ :
                        case 77 /* AmpersandAmpersandEqualsToken */ :
                            return 3 /* Sometimes */ ;
                        case 28 /* CommaToken */ :
                            return getSyntacticNullishnessSemantics(node.right);
                    }
                    return 2 /* Never */ ;
                case 228 /* ConditionalExpression */ :
                    return getSyntacticNullishnessSemantics(node.whenTrue) | getSyntacticNullishnessSemantics(node.whenFalse);
                case 106 /* NullKeyword */ :
                    return 1 /* Always */ ;
                case 80 /* Identifier */ :
                    if (getResolvedSymbol(node) === undefinedSymbol) return 1 /* Always */ ;
                    return 3 /* Sometimes */ ;
            }
            return 2 /* Never */ ;
        }
        function checkBinaryLikeExpression(left, operatorToken, right, checkMode, errorNode) {
            const operator = operatorToken.kind;
            if (operator === 64 /* EqualsToken */  && (left.kind === 211 /* ObjectLiteralExpression */  || left.kind === 210 /* ArrayLiteralExpression */ )) return checkDestructuringAssignment(left, checkExpression(right, checkMode), checkMode, right.kind === 110 /* ThisKeyword */ );
            let leftType;
            if (isBinaryLogicalOperator(operator)) leftType = checkTruthinessExpression(left, checkMode);
            else leftType = checkExpression(left, checkMode);
            const rightType = checkExpression(right, checkMode);
            return checkBinaryLikeExpressionWorker(left, operatorToken, right, leftType, rightType, checkMode, errorNode);
        }
        function checkBinaryLikeExpressionWorker(left, operatorToken, right, leftType, rightType, checkMode, errorNode) {
            const operator = operatorToken.kind;
            switch(operator){
                case 42 /* AsteriskToken */ :
                case 43 /* AsteriskAsteriskToken */ :
                case 67 /* AsteriskEqualsToken */ :
                case 68 /* AsteriskAsteriskEqualsToken */ :
                case 44 /* SlashToken */ :
                case 69 /* SlashEqualsToken */ :
                case 45 /* PercentToken */ :
                case 70 /* PercentEqualsToken */ :
                case 41 /* MinusToken */ :
                case 66 /* MinusEqualsToken */ :
                case 48 /* LessThanLessThanToken */ :
                case 71 /* LessThanLessThanEqualsToken */ :
                case 49 /* GreaterThanGreaterThanToken */ :
                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                case 52 /* BarToken */ :
                case 75 /* BarEqualsToken */ :
                case 53 /* CaretToken */ :
                case 79 /* CaretEqualsToken */ :
                case 51 /* AmpersandToken */ :
                case 74 /* AmpersandEqualsToken */ :
                    if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
                    leftType = checkNonNullType(leftType, left);
                    rightType = checkNonNullType(rightType, right);
                    let suggestedOperator;
                    if (leftType.flags & 528 /* BooleanLike */  && rightType.flags & 528 /* BooleanLike */  && (suggestedOperator = getSuggestedBooleanOperator(operatorToken.kind)) !== void 0) {
                        error2(errorNode || operatorToken, Diagnostics.The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead, tokenToString(operatorToken.kind), tokenToString(suggestedOperator));
                        return numberType;
                    } else {
                        const leftOk = checkArithmeticOperandType(left, leftType, Diagnostics.The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type, /*isAwaitValid*/ true);
                        const rightOk = checkArithmeticOperandType(right, rightType, Diagnostics.The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type, /*isAwaitValid*/ true);
                        let resultType2;
                        if (isTypeAssignableToKind(leftType, 3 /* AnyOrUnknown */ ) && isTypeAssignableToKind(rightType, 3 /* AnyOrUnknown */ ) || // Or, if neither could be bigint, implicit coercion results in a number result
                        !(maybeTypeOfKind(leftType, 2112 /* BigIntLike */ ) || maybeTypeOfKind(rightType, 2112 /* BigIntLike */ ))) resultType2 = numberType;
                        else if (bothAreBigIntLike(leftType, rightType)) {
                            switch(operator){
                                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                                    reportOperatorError();
                                    break;
                                case 43 /* AsteriskAsteriskToken */ :
                                case 68 /* AsteriskAsteriskEqualsToken */ :
                                    if (languageVersion < 3 /* ES2016 */ ) error2(errorNode, Diagnostics.Exponentiation_cannot_be_performed_on_bigint_values_unless_the_target_option_is_set_to_es2016_or_later);
                            }
                            resultType2 = bigintType;
                        } else {
                            reportOperatorError(bothAreBigIntLike);
                            resultType2 = errorType;
                        }
                        if (leftOk && rightOk) {
                            checkAssignmentOperator(resultType2);
                            switch(operator){
                                case 48 /* LessThanLessThanToken */ :
                                case 71 /* LessThanLessThanEqualsToken */ :
                                case 49 /* GreaterThanGreaterThanToken */ :
                                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                                    const rhsEval = evaluate(right);
                                    if (typeof rhsEval.value === "number" && Math.abs(rhsEval.value) >= 32) errorOrSuggestion(isEnumMember(walkUpParenthesizedExpressions(right.parent.parent)), // elevate from suggestion to error within an enum member
                                    errorNode || operatorToken, Diagnostics.This_operation_can_be_simplified_This_shift_is_identical_to_0_1_2, getTextOfNode(left), tokenToString(operator), rhsEval.value % 32);
                                    break;
                                default:
                                    break;
                            }
                        }
                        return resultType2;
                    }
                case 40 /* PlusToken */ :
                case 65 /* PlusEqualsToken */ :
                    if (leftType === silentNeverType || rightType === silentNeverType) return silentNeverType;
                    if (!isTypeAssignableToKind(leftType, 402653316 /* StringLike */ ) && !isTypeAssignableToKind(rightType, 402653316 /* StringLike */ )) {
                        leftType = checkNonNullType(leftType, left);
                        rightType = checkNonNullType(rightType, right);
                    }
                    let resultType;
                    if (isTypeAssignableToKind(leftType, 296 /* NumberLike */ , /*strict*/ true) && isTypeAssignableToKind(rightType, 296 /* NumberLike */ , /*strict*/ true)) resultType = numberType;
                    else if (isTypeAssignableToKind(leftType, 2112 /* BigIntLike */ , /*strict*/ true) && isTypeAssignableToKind(rightType, 2112 /* BigIntLike */ , /*strict*/ true)) resultType = bigintType;
                    else if (isTypeAssignableToKind(leftType, 402653316 /* StringLike */ , /*strict*/ true) || isTypeAssignableToKind(rightType, 402653316 /* StringLike */ , /*strict*/ true)) resultType = stringType;
                    else if (isTypeAny(leftType) || isTypeAny(rightType)) resultType = isErrorType(leftType) || isErrorType(rightType) ? errorType : anyType;
                    if (resultType && !checkForDisallowedESSymbolOperand(operator)) return resultType;
                    if (!resultType) {
                        const closeEnoughKind = 402655727 /* AnyOrUnknown */ ;
                        reportOperatorError((left2, right2)=>isTypeAssignableToKind(left2, closeEnoughKind) && isTypeAssignableToKind(right2, closeEnoughKind));
                        return anyType;
                    }
                    if (operator === 65 /* PlusEqualsToken */ ) checkAssignmentOperator(resultType);
                    return resultType;
                case 30 /* LessThanToken */ :
                case 32 /* GreaterThanToken */ :
                case 33 /* LessThanEqualsToken */ :
                case 34 /* GreaterThanEqualsToken */ :
                    if (checkForDisallowedESSymbolOperand(operator)) {
                        leftType = getBaseTypeOfLiteralTypeForComparison(checkNonNullType(leftType, left));
                        rightType = getBaseTypeOfLiteralTypeForComparison(checkNonNullType(rightType, right));
                        reportOperatorErrorUnless((left2, right2)=>{
                            if (isTypeAny(left2) || isTypeAny(right2)) return true;
                            const leftAssignableToNumber = isTypeAssignableTo(left2, numberOrBigIntType);
                            const rightAssignableToNumber = isTypeAssignableTo(right2, numberOrBigIntType);
                            return leftAssignableToNumber && rightAssignableToNumber || !leftAssignableToNumber && !rightAssignableToNumber && areTypesComparable(left2, right2);
                        });
                    }
                    return booleanType;
                case 35 /* EqualsEqualsToken */ :
                case 36 /* ExclamationEqualsToken */ :
                case 37 /* EqualsEqualsEqualsToken */ :
                case 38 /* ExclamationEqualsEqualsToken */ :
                    if (!(checkMode && checkMode & 64 /* TypeOnly */ )) {
                        if ((isLiteralExpressionOfObject(left) || isLiteralExpressionOfObject(right)) && // only report for === and !== in JS, not == or !=
                        (!isInJSFile(left) || operator === 37 /* EqualsEqualsEqualsToken */  || operator === 38 /* ExclamationEqualsEqualsToken */ )) {
                            const eqType = operator === 35 /* EqualsEqualsToken */  || operator === 37 /* EqualsEqualsEqualsToken */ ;
                            error2(errorNode, Diagnostics.This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value, eqType ? "false" : "true");
                        }
                        checkNaNEquality(errorNode, operator, left, right);
                        reportOperatorErrorUnless((left2, right2)=>isTypeEqualityComparableTo(left2, right2) || isTypeEqualityComparableTo(right2, left2));
                    }
                    return booleanType;
                case 104 /* InstanceOfKeyword */ :
                    return checkInstanceOfExpression(left, right, leftType, rightType, checkMode);
                case 103 /* InKeyword */ :
                    return checkInExpression(left, right, leftType, rightType);
                case 56 /* AmpersandAmpersandToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                    {
                        const resultType2 = hasTypeFacts(leftType, 4194304 /* Truthy */ ) ? getUnionType([
                            extractDefinitelyFalsyTypes(strictNullChecks ? leftType : getBaseTypeOfLiteralType(rightType)),
                            rightType
                        ]) : leftType;
                        if (operator === 77 /* AmpersandAmpersandEqualsToken */ ) checkAssignmentOperator(rightType);
                        return resultType2;
                    }
                case 57 /* BarBarToken */ :
                case 76 /* BarBarEqualsToken */ :
                    {
                        const resultType2 = hasTypeFacts(leftType, 8388608 /* Falsy */ ) ? getUnionType([
                            getNonNullableType(removeDefinitelyFalsyTypes(leftType)),
                            rightType
                        ], 2 /* Subtype */ ) : leftType;
                        if (operator === 76 /* BarBarEqualsToken */ ) checkAssignmentOperator(rightType);
                        return resultType2;
                    }
                case 61 /* QuestionQuestionToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                    {
                        const resultType2 = hasTypeFacts(leftType, 262144 /* EQUndefinedOrNull */ ) ? getUnionType([
                            getNonNullableType(leftType),
                            rightType
                        ], 2 /* Subtype */ ) : leftType;
                        if (operator === 78 /* QuestionQuestionEqualsToken */ ) checkAssignmentOperator(rightType);
                        return resultType2;
                    }
                case 64 /* EqualsToken */ :
                    const declKind = isBinaryExpression(left.parent) ? getAssignmentDeclarationKind(left.parent) : 0 /* None */ ;
                    checkAssignmentDeclaration(declKind, rightType);
                    if (isAssignmentDeclaration2(declKind)) {
                        if (!(rightType.flags & 524288 /* Object */ ) || declKind !== 2 /* ModuleExports */  && declKind !== 6 /* Prototype */  && !isEmptyObjectType(rightType) && !isFunctionObjectType(rightType) && !(getObjectFlags(rightType) & 1 /* Class */ )) checkAssignmentOperator(rightType);
                        return leftType;
                    } else {
                        checkAssignmentOperator(rightType);
                        return rightType;
                    }
                case 28 /* CommaToken */ :
                    if (!compilerOptions.allowUnreachableCode && isSideEffectFree(left) && !isIndirectCall(left.parent)) {
                        const sf = getSourceFileOfNode(left);
                        const sourceText = sf.text;
                        const start = skipTrivia(sourceText, left.pos);
                        const isInDiag2657 = sf.parseDiagnostics.some((diag2)=>{
                            if (diag2.code !== Diagnostics.JSX_expressions_must_have_one_parent_element.code) return false;
                            return textSpanContainsPosition(diag2, start);
                        });
                        if (!isInDiag2657) error2(left, Diagnostics.Left_side_of_comma_operator_is_unused_and_has_no_side_effects);
                    }
                    return rightType;
                default:
                    return Debug.fail();
            }
            function bothAreBigIntLike(left2, right2) {
                return isTypeAssignableToKind(left2, 2112 /* BigIntLike */ ) && isTypeAssignableToKind(right2, 2112 /* BigIntLike */ );
            }
            function checkAssignmentDeclaration(kind, rightType2) {
                if (kind === 2 /* ModuleExports */ ) for (const prop of getPropertiesOfObjectType(rightType2)){
                    const propType = getTypeOfSymbol(prop);
                    if (propType.symbol && propType.symbol.flags & 32 /* Class */ ) {
                        const name = prop.escapedName;
                        const symbol = resolveName(prop.valueDeclaration, name, 788968 /* Type */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
                        if ((symbol == null ? void 0 : symbol.declarations) && symbol.declarations.some(isJSDocTypedefTag)) {
                            addDuplicateDeclarationErrorsForSymbols(symbol, Diagnostics.Duplicate_identifier_0, unescapeLeadingUnderscores(name), prop);
                            addDuplicateDeclarationErrorsForSymbols(prop, Diagnostics.Duplicate_identifier_0, unescapeLeadingUnderscores(name), symbol);
                        }
                    }
                }
            }
            function isIndirectCall(node) {
                return node.parent.kind === 218 /* ParenthesizedExpression */  && isNumericLiteral(node.left) && node.left.text === "0" && (isCallExpression(node.parent.parent) && node.parent.parent.expression === node.parent || node.parent.parent.kind === 216 /* TaggedTemplateExpression */ ) && // special-case for "eval" because it's the only non-access case where an indirect call actually affects behavior.
                (isAccessExpression(node.right) || isIdentifier(node.right) && node.right.escapedText === "eval");
            }
            function checkForDisallowedESSymbolOperand(operator2) {
                const offendingSymbolOperand = maybeTypeOfKindConsideringBaseConstraint(leftType, 12288 /* ESSymbolLike */ ) ? left : maybeTypeOfKindConsideringBaseConstraint(rightType, 12288 /* ESSymbolLike */ ) ? right : void 0;
                if (offendingSymbolOperand) {
                    error2(offendingSymbolOperand, Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, tokenToString(operator2));
                    return false;
                }
                return true;
            }
            function getSuggestedBooleanOperator(operator2) {
                switch(operator2){
                    case 52 /* BarToken */ :
                    case 75 /* BarEqualsToken */ :
                        return 57 /* BarBarToken */ ;
                    case 53 /* CaretToken */ :
                    case 79 /* CaretEqualsToken */ :
                        return 38 /* ExclamationEqualsEqualsToken */ ;
                    case 51 /* AmpersandToken */ :
                    case 74 /* AmpersandEqualsToken */ :
                        return 56 /* AmpersandAmpersandToken */ ;
                    default:
                        return void 0;
                }
            }
            function checkAssignmentOperator(valueType) {
                if (isAssignmentOperator(operator)) addLazyDiagnostic(checkAssignmentOperatorWorker);
                function checkAssignmentOperatorWorker() {
                    let assigneeType = leftType;
                    if (isCompoundAssignment(operatorToken.kind) && left.kind === 212 /* PropertyAccessExpression */ ) assigneeType = checkPropertyAccessExpression(left, /*checkMode*/ void 0, /*writeOnly*/ true);
                    if (checkReferenceExpression(left, Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access, Diagnostics.The_left_hand_side_of_an_assignment_expression_may_not_be_an_optional_property_access)) {
                        let headMessage;
                        if (exactOptionalPropertyTypes && isPropertyAccessExpression(left) && maybeTypeOfKind(valueType, 32768 /* Undefined */ )) {
                            const target = getTypeOfPropertyOfType(getTypeOfExpression(left.expression), left.name.escapedText);
                            if (isExactOptionalPropertyMismatch(valueType, target)) headMessage = Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target;
                        }
                        checkTypeAssignableToAndOptionallyElaborate(valueType, assigneeType, left, right, headMessage);
                    }
                }
            }
            function isAssignmentDeclaration2(kind) {
                var _a;
                switch(kind){
                    case 2 /* ModuleExports */ :
                        return true;
                    case 1 /* ExportsProperty */ :
                    case 5 /* Property */ :
                    case 6 /* Prototype */ :
                    case 3 /* PrototypeProperty */ :
                    case 4 /* ThisProperty */ :
                        const symbol = getSymbolOfNode(left);
                        const init = getAssignedExpandoInitializer(right);
                        return !!init && isObjectLiteralExpression(init) && !!((_a = symbol == null ? void 0 : symbol.exports) == null ? void 0 : _a.size);
                    default:
                        return false;
                }
            }
            function reportOperatorErrorUnless(typesAreCompatible) {
                if (!typesAreCompatible(leftType, rightType)) {
                    reportOperatorError(typesAreCompatible);
                    return true;
                }
                return false;
            }
            function reportOperatorError(isRelated) {
                let wouldWorkWithAwait = false;
                const errNode = errorNode || operatorToken;
                if (isRelated) {
                    const awaitedLeftType = getAwaitedTypeNoAlias(leftType);
                    const awaitedRightType = getAwaitedTypeNoAlias(rightType);
                    wouldWorkWithAwait = !(awaitedLeftType === leftType && awaitedRightType === rightType) && !!(awaitedLeftType && awaitedRightType) && isRelated(awaitedLeftType, awaitedRightType);
                }
                let effectiveLeft = leftType;
                let effectiveRight = rightType;
                if (!wouldWorkWithAwait && isRelated) [effectiveLeft, effectiveRight] = getBaseTypesIfUnrelated(leftType, rightType, isRelated);
                const [leftStr, rightStr] = getTypeNamesForErrorDisplay(effectiveLeft, effectiveRight);
                if (!tryGiveBetterPrimaryError(errNode, wouldWorkWithAwait, leftStr, rightStr)) errorAndMaybeSuggestAwait(errNode, wouldWorkWithAwait, Diagnostics.Operator_0_cannot_be_applied_to_types_1_and_2, tokenToString(operatorToken.kind), leftStr, rightStr);
            }
            function tryGiveBetterPrimaryError(errNode, maybeMissingAwait, leftStr, rightStr) {
                switch(operatorToken.kind){
                    case 37 /* EqualsEqualsEqualsToken */ :
                    case 35 /* EqualsEqualsToken */ :
                    case 38 /* ExclamationEqualsEqualsToken */ :
                    case 36 /* ExclamationEqualsToken */ :
                        return errorAndMaybeSuggestAwait(errNode, maybeMissingAwait, Diagnostics.This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap, leftStr, rightStr);
                    default:
                        return void 0;
                }
            }
            function checkNaNEquality(errorNode2, operator2, left2, right2) {
                const isLeftNaN = isGlobalNaN(skipParentheses(left2));
                const isRightNaN = isGlobalNaN(skipParentheses(right2));
                if (isLeftNaN || isRightNaN) {
                    const err = error2(errorNode2, Diagnostics.This_condition_will_always_return_0, tokenToString(operator2 === 37 /* EqualsEqualsEqualsToken */  || operator2 === 35 /* EqualsEqualsToken */  ? 97 /* FalseKeyword */  : 112 /* TrueKeyword */ ));
                    if (isLeftNaN && isRightNaN) return;
                    const operatorString = operator2 === 38 /* ExclamationEqualsEqualsToken */  || operator2 === 36 /* ExclamationEqualsToken */  ? tokenToString(54 /* ExclamationToken */ ) : "";
                    const location = isLeftNaN ? right2 : left2;
                    const expression = skipParentheses(location);
                    addRelatedInfo(err, createDiagnosticForNode(location, Diagnostics.Did_you_mean_0, `${operatorString}Number.isNaN(${isEntityNameExpression(expression) ? entityNameToString(expression) : "..."})`));
                }
            }
            function isGlobalNaN(expr) {
                if (isIdentifier(expr) && expr.escapedText === "NaN") {
                    const globalNaNSymbol = getGlobalNaNSymbol();
                    return !!globalNaNSymbol && globalNaNSymbol === getResolvedSymbol(expr);
                }
                return false;
            }
        }
        function getBaseTypesIfUnrelated(leftType, rightType, isRelated) {
            let effectiveLeft = leftType;
            let effectiveRight = rightType;
            const leftBase = getBaseTypeOfLiteralType(leftType);
            const rightBase = getBaseTypeOfLiteralType(rightType);
            if (!isRelated(leftBase, rightBase)) {
                effectiveLeft = leftBase;
                effectiveRight = rightBase;
            }
            return [
                effectiveLeft,
                effectiveRight
            ];
        }
        function checkYieldExpression(node) {
            addLazyDiagnostic(checkYieldExpressionGrammar);
            const func = getContainingFunction(node);
            if (!func) return anyType;
            const functionFlags = getFunctionFlags(func);
            if (!(functionFlags & 1 /* Generator */ )) return anyType;
            const isAsync = (functionFlags & 2 /* Async */ ) !== 0;
            if (node.asteriskToken) {
                if (isAsync && languageVersion < LanguageFeatureMinimumTarget.AsyncGenerators) checkExternalEmitHelpers(node, 26624 /* AsyncDelegatorIncludes */ );
                if (!isAsync && languageVersion < LanguageFeatureMinimumTarget.Generators && compilerOptions.downlevelIteration) checkExternalEmitHelpers(node, 256 /* Values */ );
            }
            let returnType = getReturnTypeFromAnnotation(func);
            if (returnType && returnType.flags & 1048576 /* Union */ ) returnType = filterType(returnType, (t)=>checkGeneratorInstantiationAssignabilityToReturnType(t, functionFlags, /*errorNode*/ void 0));
            const iterationTypes = returnType && getIterationTypesOfGeneratorFunctionReturnType(returnType, isAsync);
            const signatureYieldType = iterationTypes && iterationTypes.yieldType || anyType;
            const signatureNextType = iterationTypes && iterationTypes.nextType || anyType;
            const yieldExpressionType = node.expression ? checkExpression(node.expression) : undefinedWideningType;
            const yieldedType = getYieldedTypeOfYieldExpression(node, yieldExpressionType, signatureNextType, isAsync);
            if (returnType && yieldedType) checkTypeAssignableToAndOptionallyElaborate(yieldedType, signatureYieldType, node.expression || node, node.expression);
            if (node.asteriskToken) {
                const use = isAsync ? 19 /* AsyncYieldStar */  : 17 /* YieldStar */ ;
                return getIterationTypeOfIterable(use, 1 /* Return */ , yieldExpressionType, node.expression) || anyType;
            } else if (returnType) return getIterationTypeOfGeneratorFunctionReturnType(2 /* Next */ , returnType, isAsync) || anyType;
            let type = getContextualIterationType(2 /* Next */ , func);
            if (!type) {
                type = anyType;
                addLazyDiagnostic(()=>{
                    if (noImplicitAny && !expressionResultIsUnused(node)) {
                        const contextualType = getContextualType2(node, /*contextFlags*/ void 0);
                        if (!contextualType || isTypeAny(contextualType)) error2(node, Diagnostics.yield_expression_implicitly_results_in_an_any_type_because_its_containing_generator_lacks_a_return_type_annotation);
                    }
                });
            }
            return type;
            function checkYieldExpressionGrammar() {
                if (!(node.flags & 16384 /* YieldContext */ )) grammarErrorOnFirstToken(node, Diagnostics.A_yield_expression_is_only_allowed_in_a_generator_body);
                if (isInParameterInitializerBeforeContainingFunction(node)) error2(node, Diagnostics.yield_expressions_cannot_be_used_in_a_parameter_initializer);
            }
        }
        function checkConditionalExpression(node, checkMode) {
            const type = checkTruthinessExpression(node.condition, checkMode);
            checkTestingKnownTruthyCallableOrAwaitableOrEnumMemberType(node.condition, type, node.whenTrue);
            const type1 = checkExpression(node.whenTrue, checkMode);
            const type2 = checkExpression(node.whenFalse, checkMode);
            return getUnionType([
                type1,
                type2
            ], 2 /* Subtype */ );
        }
        function isTemplateLiteralContext(node) {
            const parent2 = node.parent;
            return isParenthesizedExpression(parent2) && isTemplateLiteralContext(parent2) || isElementAccessExpression(parent2) && parent2.argumentExpression === node;
        }
        function checkTemplateExpression(node) {
            const texts = [
                node.head.text
            ];
            const types = [];
            for (const span of node.templateSpans){
                const type = checkExpression(span.expression);
                if (maybeTypeOfKindConsideringBaseConstraint(type, 12288 /* ESSymbolLike */ )) error2(span.expression, Diagnostics.Implicit_conversion_of_a_symbol_to_a_string_will_fail_at_runtime_Consider_wrapping_this_expression_in_String);
                texts.push(span.literal.text);
                types.push(isTypeAssignableTo(type, templateConstraintType) ? type : stringType);
            }
            const evaluated = node.parent.kind !== 216 /* TaggedTemplateExpression */  && evaluate(node).value;
            if (evaluated) return getFreshTypeOfLiteralType(getStringLiteralType(evaluated));
            if (isConstContext(node) || isTemplateLiteralContext(node) || someType(getContextualType2(node, /*contextFlags*/ void 0) || unknownType, isTemplateLiteralContextualType)) return getTemplateLiteralType(texts, types);
            return stringType;
        }
        function isTemplateLiteralContextualType(type) {
            return !!(type.flags & 134217856 /* TemplateLiteral */  || type.flags & 58982400 /* InstantiableNonPrimitive */  && maybeTypeOfKind(getBaseConstraintOfType(type) || unknownType, 402653316 /* StringLike */ ));
        }
        function getContextNode2(node) {
            if (isJsxAttributes(node) && !isJsxSelfClosingElement(node.parent)) return node.parent.parent;
            return node;
        }
        function checkExpressionWithContextualType(node, contextualType, inferenceContext, checkMode) {
            const contextNode = getContextNode2(node);
            pushContextualType(contextNode, contextualType, /*isCache*/ false);
            pushInferenceContext(contextNode, inferenceContext);
            const type = checkExpression(node, checkMode | 1 /* Contextual */  | (inferenceContext ? 2 /* Inferential */  : 0));
            if (inferenceContext && inferenceContext.intraExpressionInferenceSites) inferenceContext.intraExpressionInferenceSites = void 0;
            const result = maybeTypeOfKind(type, 2944 /* Literal */ ) && isLiteralOfContextualType(type, instantiateContextualType(contextualType, node, /*contextFlags*/ void 0)) ? getRegularTypeOfLiteralType(type) : type;
            popInferenceContext();
            popContextualType();
            return result;
        }
        function checkExpressionCached(node, checkMode) {
            if (checkMode) return checkExpression(node, checkMode);
            const links = getNodeLinks(node);
            if (!links.resolvedType) {
                const saveFlowLoopStart = flowLoopStart;
                const saveFlowTypeCache = flowTypeCache;
                flowLoopStart = flowLoopCount;
                flowTypeCache = void 0;
                links.resolvedType = checkExpression(node, checkMode);
                flowTypeCache = saveFlowTypeCache;
                flowLoopStart = saveFlowLoopStart;
            }
            return links.resolvedType;
        }
        function isTypeAssertion(node) {
            node = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            return node.kind === 217 /* TypeAssertionExpression */  || node.kind === 235 /* AsExpression */  || isJSDocTypeAssertion(node);
        }
        function checkDeclarationInitializer(declaration, checkMode, contextualType) {
            const initializer = getEffectiveInitializer(declaration);
            if (isInJSFile(declaration)) {
                const typeNode = tryGetJSDocSatisfiesTypeNode(declaration);
                if (typeNode) return checkSatisfiesExpressionWorker(initializer, typeNode, checkMode);
            }
            const type = getQuickTypeOfExpression(initializer) || (contextualType ? checkExpressionWithContextualType(initializer, contextualType, /*inferenceContext*/ void 0, checkMode || 0 /* Normal */ ) : checkExpressionCached(initializer, checkMode));
            if (isParameter(isBindingElement(declaration) ? walkUpBindingElementsAndPatterns(declaration) : declaration)) {
                if (declaration.name.kind === 207 /* ObjectBindingPattern */  && isObjectLiteralType2(type)) return padObjectLiteralType(type, declaration.name);
                if (declaration.name.kind === 208 /* ArrayBindingPattern */  && isTupleType(type)) return padTupleType(type, declaration.name);
            }
            return type;
        }
        function padObjectLiteralType(type, pattern) {
            let missingElements;
            for (const e of pattern.elements)if (e.initializer) {
                const name = getPropertyNameFromBindingElement(e);
                if (name && !getPropertyOfType(type, name)) missingElements = append(missingElements, e);
            }
            if (!missingElements) return type;
            const members = createSymbolTable();
            for (const prop of getPropertiesOfObjectType(type))members.set(prop.escapedName, prop);
            for (const e of missingElements){
                const symbol = createSymbol(16777220 /* Optional */ , getPropertyNameFromBindingElement(e));
                symbol.links.type = getTypeFromBindingElement(e, /*includePatternInType*/ false, /*reportErrors*/ false);
                members.set(symbol.escapedName, symbol);
            }
            const result = createAnonymousType(type.symbol, members, emptyArray, emptyArray, getIndexInfosOfType(type));
            result.objectFlags = type.objectFlags;
            return result;
        }
        function getPropertyNameFromBindingElement(e) {
            const exprType = getLiteralTypeFromPropertyName(e.propertyName || e.name);
            return isTypeUsableAsPropertyName(exprType) ? getPropertyNameFromType(exprType) : void 0;
        }
        function padTupleType(type, pattern) {
            if (type.target.combinedFlags & 12 /* Variable */  || getTypeReferenceArity(type) >= pattern.elements.length) return type;
            const patternElements = pattern.elements;
            const elementTypes = getElementTypes(type).slice();
            const elementFlags = type.target.elementFlags.slice();
            for(let i = getTypeReferenceArity(type); i < patternElements.length; i++){
                const e = patternElements[i];
                if (i < patternElements.length - 1 || !(e.kind === 209 /* BindingElement */  && e.dotDotDotToken)) {
                    elementTypes.push(!isOmittedExpression(e) && hasDefaultValue(e) ? getTypeFromBindingElement(e, /*includePatternInType*/ false, /*reportErrors*/ false) : anyType);
                    elementFlags.push(2 /* Optional */ );
                    if (!isOmittedExpression(e) && !hasDefaultValue(e)) reportImplicitAny(e, anyType);
                }
            }
            return createTupleType(elementTypes, elementFlags, type.target.readonly);
        }
        function widenTypeInferredFromInitializer(declaration, type) {
            const widened = getWidenedLiteralTypeForInitializer(declaration, type);
            if (isInJSFile(declaration)) {
                if (isEmptyLiteralType(widened)) {
                    reportImplicitAny(declaration, anyType);
                    return anyType;
                } else if (isEmptyArrayLiteralType(widened)) {
                    reportImplicitAny(declaration, anyArrayType);
                    return anyArrayType;
                }
            }
            return widened;
        }
        function getWidenedLiteralTypeForInitializer(declaration, type) {
            return getCombinedNodeFlagsCached(declaration) & 6 /* Constant */  || isDeclarationReadonly(declaration) ? type : getWidenedLiteralType(type);
        }
        function isLiteralOfContextualType(candidateType, contextualType) {
            if (contextualType) {
                if (contextualType.flags & 3145728 /* UnionOrIntersection */ ) {
                    const types = contextualType.types;
                    return some(types, (t)=>isLiteralOfContextualType(candidateType, t));
                }
                if (contextualType.flags & 58982400 /* InstantiableNonPrimitive */ ) {
                    const constraint = getBaseConstraintOfType(contextualType) || unknownType;
                    return maybeTypeOfKind(constraint, 4 /* String */ ) && maybeTypeOfKind(candidateType, 128 /* StringLiteral */ ) || maybeTypeOfKind(constraint, 8 /* Number */ ) && maybeTypeOfKind(candidateType, 256 /* NumberLiteral */ ) || maybeTypeOfKind(constraint, 64 /* BigInt */ ) && maybeTypeOfKind(candidateType, 2048 /* BigIntLiteral */ ) || maybeTypeOfKind(constraint, 4096 /* ESSymbol */ ) && maybeTypeOfKind(candidateType, 8192 /* UniqueESSymbol */ ) || isLiteralOfContextualType(candidateType, constraint);
                }
                return !!(contextualType.flags & 406847616 /* StringMapping */  && maybeTypeOfKind(candidateType, 128 /* StringLiteral */ ) || contextualType.flags & 256 /* NumberLiteral */  && maybeTypeOfKind(candidateType, 256 /* NumberLiteral */ ) || contextualType.flags & 2048 /* BigIntLiteral */  && maybeTypeOfKind(candidateType, 2048 /* BigIntLiteral */ ) || contextualType.flags & 512 /* BooleanLiteral */  && maybeTypeOfKind(candidateType, 512 /* BooleanLiteral */ ) || contextualType.flags & 8192 /* UniqueESSymbol */  && maybeTypeOfKind(candidateType, 8192 /* UniqueESSymbol */ ));
            }
            return false;
        }
        function isConstContext(node) {
            const parent2 = node.parent;
            return isAssertionExpression(parent2) && isConstTypeReference(parent2.type) || isJSDocTypeAssertion(parent2) && isConstTypeReference(getJSDocTypeAssertionType(parent2)) || isValidConstAssertionArgument(node) && isConstTypeVariable(getContextualType2(node, 0 /* None */ )) || (isParenthesizedExpression(parent2) || isArrayLiteralExpression(parent2) || isSpreadElement(parent2)) && isConstContext(parent2) || (isPropertyAssignment(parent2) || isShorthandPropertyAssignment(parent2) || isTemplateSpan(parent2)) && isConstContext(parent2.parent);
        }
        function checkExpressionForMutableLocation(node, checkMode, forceTuple) {
            const type = checkExpression(node, checkMode, forceTuple);
            return isConstContext(node) || isCommonJsExportedExpression(node) ? getRegularTypeOfLiteralType(type) : isTypeAssertion(node) ? type : getWidenedLiteralLikeTypeForContextualType(type, instantiateContextualType(getContextualType2(node, /*contextFlags*/ void 0), node, /*contextFlags*/ void 0));
        }
        function checkPropertyAssignment(node, checkMode) {
            if (node.name.kind === 168 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
            return checkExpressionForMutableLocation(node.initializer, checkMode);
        }
        function checkObjectLiteralMethod(node, checkMode) {
            checkGrammarMethod(node);
            if (node.name.kind === 168 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
            const uninstantiatedType = checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
            return instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
        }
        function instantiateTypeWithSingleGenericCallSignature(node, type, checkMode) {
            if (checkMode && checkMode & 10 /* SkipGenericFunctions */ ) {
                const callSignature = getSingleSignature(type, 0 /* Call */ , /*allowMembers*/ true);
                const constructSignature = getSingleSignature(type, 1 /* Construct */ , /*allowMembers*/ true);
                const signature = callSignature || constructSignature;
                if (signature && signature.typeParameters) {
                    const contextualType = getApparentTypeOfContextualType(node, 2 /* NoConstraints */ );
                    if (contextualType) {
                        const contextualSignature = getSingleSignature(getNonNullableType(contextualType), callSignature ? 0 /* Call */  : 1 /* Construct */ , /*allowMembers*/ false);
                        if (contextualSignature && !contextualSignature.typeParameters) {
                            if (checkMode & 8 /* SkipGenericFunctions */ ) {
                                skippedGenericFunction(node, checkMode);
                                return anyFunctionType;
                            }
                            const context = getInferenceContext(node);
                            const returnType = context.signature && getReturnTypeOfSignature(context.signature);
                            const returnSignature = returnType && getSingleCallOrConstructSignature(returnType);
                            if (returnSignature && !returnSignature.typeParameters && !every(context.inferences, hasInferenceCandidates)) {
                                const uniqueTypeParameters = getUniqueTypeParameters(context, signature.typeParameters);
                                const instantiatedSignature = getSignatureInstantiationWithoutFillingInTypeArguments(signature, uniqueTypeParameters);
                                const inferences = map(context.inferences, (info)=>createInferenceInfo(info.typeParameter));
                                applyToParameterTypes(instantiatedSignature, contextualSignature, (source, target)=>{
                                    inferTypes(inferences, source, target, /*priority*/ 0, /*contravariant*/ true);
                                });
                                if (some(inferences, hasInferenceCandidates)) {
                                    applyToReturnTypes(instantiatedSignature, contextualSignature, (source, target)=>{
                                        inferTypes(inferences, source, target);
                                    });
                                    if (!hasOverlappingInferences(context.inferences, inferences)) {
                                        mergeInferences(context.inferences, inferences);
                                        context.inferredTypeParameters = concatenate(context.inferredTypeParameters, uniqueTypeParameters);
                                        return getOrCreateTypeFromSignature(instantiatedSignature);
                                    }
                                }
                            }
                            return getOrCreateTypeFromSignature(instantiateSignatureInContextOf(signature, contextualSignature, context));
                        }
                    }
                }
            }
            return type;
        }
        function skippedGenericFunction(node, checkMode) {
            if (checkMode & 2 /* Inferential */ ) {
                const context = getInferenceContext(node);
                context.flags |= 4 /* SkippedGenericFunction */ ;
            }
        }
        function hasInferenceCandidates(info) {
            return !!(info.candidates || info.contraCandidates);
        }
        function hasInferenceCandidatesOrDefault(info) {
            return !!(info.candidates || info.contraCandidates || hasTypeParameterDefault(info.typeParameter));
        }
        function hasOverlappingInferences(a, b) {
            for(let i = 0; i < a.length; i++){
                if (hasInferenceCandidates(a[i]) && hasInferenceCandidates(b[i])) return true;
            }
            return false;
        }
        function mergeInferences(target, source) {
            for(let i = 0; i < target.length; i++)if (!hasInferenceCandidates(target[i]) && hasInferenceCandidates(source[i])) target[i] = source[i];
        }
        function getUniqueTypeParameters(context, typeParameters) {
            const result = [];
            let oldTypeParameters;
            let newTypeParameters;
            for (const tp of typeParameters){
                const name = tp.symbol.escapedName;
                if (hasTypeParameterByName(context.inferredTypeParameters, name) || hasTypeParameterByName(result, name)) {
                    const newName = getUniqueTypeParameterName(concatenate(context.inferredTypeParameters, result), name);
                    const symbol = createSymbol(262144 /* TypeParameter */ , newName);
                    const newTypeParameter = createTypeParameter(symbol);
                    newTypeParameter.target = tp;
                    oldTypeParameters = append(oldTypeParameters, tp);
                    newTypeParameters = append(newTypeParameters, newTypeParameter);
                    result.push(newTypeParameter);
                } else result.push(tp);
            }
            if (newTypeParameters) {
                const mapper = createTypeMapper(oldTypeParameters, newTypeParameters);
                for (const tp of newTypeParameters)tp.mapper = mapper;
            }
            return result;
        }
        function hasTypeParameterByName(typeParameters, name) {
            return some(typeParameters, (tp)=>tp.symbol.escapedName === name);
        }
        function getUniqueTypeParameterName(typeParameters, baseName) {
            let len = baseName.length;
            while(len > 1 && baseName.charCodeAt(len - 1) >= 48 /* _0 */  && baseName.charCodeAt(len - 1) <= 57 /* _9 */ )len--;
            const s = baseName.slice(0, len);
            for(let index = 1;; index++){
                const augmentedName = s + index;
                if (!hasTypeParameterByName(typeParameters, augmentedName)) return augmentedName;
            }
        }
        function getReturnTypeOfSingleNonGenericCallSignature(funcType) {
            const signature = getSingleCallSignature(funcType);
            if (signature && !signature.typeParameters) return getReturnTypeOfSignature(signature);
        }
        function getReturnTypeOfSingleNonGenericSignatureOfCallChain(expr) {
            const funcType = checkExpression(expr.expression);
            const nonOptionalType = getOptionalExpressionType(funcType, expr.expression);
            const returnType = getReturnTypeOfSingleNonGenericCallSignature(funcType);
            return returnType && propagateOptionalTypeMarker(returnType, expr, nonOptionalType !== funcType);
        }
        function getTypeOfExpression(node) {
            const quickType = getQuickTypeOfExpression(node);
            if (quickType) return quickType;
            if (node.flags & 268435456 /* TypeCached */  && flowTypeCache) {
                const cachedType = flowTypeCache[getNodeId(node)];
                if (cachedType) return cachedType;
            }
            const startInvocationCount = flowInvocationCount;
            const type = checkExpression(node, 64 /* TypeOnly */ );
            if (flowInvocationCount !== startInvocationCount) {
                const cache = flowTypeCache || (flowTypeCache = []);
                cache[getNodeId(node)] = type;
                setNodeFlags(node, node.flags | 268435456 /* TypeCached */ );
            }
            return type;
        }
        function getQuickTypeOfExpression(node) {
            let expr = skipParentheses(node, /*excludeJSDocTypeAssertions*/ true);
            if (isJSDocTypeAssertion(expr)) {
                const type = getJSDocTypeAssertionType(expr);
                if (!isConstTypeReference(type)) return getTypeFromTypeNode(type);
            }
            expr = skipParentheses(node);
            if (isAwaitExpression(expr)) {
                const type = getQuickTypeOfExpression(expr.expression);
                return type ? getAwaitedType(type) : void 0;
            }
            if (isCallExpression(expr) && expr.expression.kind !== 108 /* SuperKeyword */  && !isRequireCall(expr, /*requireStringLiteralLikeArgument*/ true) && !isSymbolOrSymbolForCall(expr) && !isImportCall(expr)) return isCallChain(expr) ? getReturnTypeOfSingleNonGenericSignatureOfCallChain(expr) : getReturnTypeOfSingleNonGenericCallSignature(checkNonNullExpression(expr.expression));
            else if (isAssertionExpression(expr) && !isConstTypeReference(expr.type)) return getTypeFromTypeNode(expr.type);
            else if (isLiteralExpression(node) || isBooleanLiteral(node)) return checkExpression(node);
            return void 0;
        }
        function getContextFreeTypeOfExpression(node) {
            const links = getNodeLinks(node);
            if (links.contextFreeType) return links.contextFreeType;
            pushContextualType(node, anyType, /*isCache*/ false);
            const type = links.contextFreeType = checkExpression(node, 4 /* SkipContextSensitive */ );
            popContextualType();
            return type;
        }
        function checkExpression(node, checkMode, forceTuple) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkExpression", {
                kind: node.kind,
                pos: node.pos,
                end: node.end,
                path: node.tracingPath
            });
            const saveCurrentNode = currentNode;
            currentNode = node;
            instantiationCount = 0;
            const uninstantiatedType = checkExpressionWorker(node, checkMode, forceTuple);
            const type = instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
            if (isConstEnumObjectType(type)) checkConstEnumAccess(node, type);
            currentNode = saveCurrentNode;
            (_b = tracing) == null || _b.pop();
            return type;
        }
        function checkConstEnumAccess(node, type) {
            var _a;
            const ok = node.parent.kind === 212 /* PropertyAccessExpression */  && node.parent.expression === node || node.parent.kind === 213 /* ElementAccessExpression */  && node.parent.expression === node || (node.kind === 80 /* Identifier */  || node.kind === 167 /* QualifiedName */ ) && isInRightSideOfImportOrExportAssignment(node) || node.parent.kind === 187 /* TypeQuery */  && node.parent.exprName === node || node.parent.kind === 282 /* ExportSpecifier */ ;
            if (!ok) error2(node, Diagnostics.const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query);
            if (compilerOptions.isolatedModules || compilerOptions.verbatimModuleSyntax && ok && !resolveName(node, getFirstIdentifier(node), 2097152 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false, /*excludeGlobals*/ true)) {
                Debug.assert(!!(type.symbol.flags & 128 /* ConstEnum */ ));
                const constEnumDeclaration = type.symbol.valueDeclaration;
                const redirect = (_a = host.getRedirectFromOutput(getSourceFileOfNode(constEnumDeclaration).resolvedPath)) == null ? void 0 : _a.resolvedRef;
                if (constEnumDeclaration.flags & 33554432 /* Ambient */  && !isValidTypeOnlyAliasUseSite(node) && (!redirect || !shouldPreserveConstEnums(redirect.commandLine.options))) error2(node, Diagnostics.Cannot_access_ambient_const_enums_when_0_is_enabled, isolatedModulesLikeFlagName);
            }
        }
        function checkParenthesizedExpression(node, checkMode) {
            if (hasJSDocNodes(node)) {
                if (isJSDocSatisfiesExpression(node)) return checkSatisfiesExpressionWorker(node.expression, getJSDocSatisfiesExpressionType(node), checkMode);
                if (isJSDocTypeAssertion(node)) return checkAssertionWorker(node, checkMode);
            }
            return checkExpression(node.expression, checkMode);
        }
        function checkExpressionWorker(node, checkMode, forceTuple) {
            const kind = node.kind;
            if (cancellationToken) switch(kind){
                case 232 /* ClassExpression */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            switch(kind){
                case 80 /* Identifier */ :
                    return checkIdentifier(node, checkMode);
                case 81 /* PrivateIdentifier */ :
                    return checkPrivateIdentifierExpression(node);
                case 110 /* ThisKeyword */ :
                    return checkThisExpression(node);
                case 108 /* SuperKeyword */ :
                    return checkSuperExpression(node);
                case 106 /* NullKeyword */ :
                    return nullWideningType;
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                    return hasSkipDirectInferenceFlag(node) ? blockedStringType : getFreshTypeOfLiteralType(getStringLiteralType(node.text));
                case 9 /* NumericLiteral */ :
                    checkGrammarNumericLiteral(node);
                    return getFreshTypeOfLiteralType(getNumberLiteralType(+node.text));
                case 10 /* BigIntLiteral */ :
                    checkGrammarBigIntLiteral(node);
                    return getFreshTypeOfLiteralType(getBigIntLiteralType({
                        negative: false,
                        base10Value: parsePseudoBigInt(node.text)
                    }));
                case 112 /* TrueKeyword */ :
                    return trueType;
                case 97 /* FalseKeyword */ :
                    return falseType;
                case 229 /* TemplateExpression */ :
                    return checkTemplateExpression(node);
                case 14 /* RegularExpressionLiteral */ :
                    return checkRegularExpressionLiteral(node);
                case 210 /* ArrayLiteralExpression */ :
                    return checkArrayLiteral(node, checkMode, forceTuple);
                case 211 /* ObjectLiteralExpression */ :
                    return checkObjectLiteral(node, checkMode);
                case 212 /* PropertyAccessExpression */ :
                    return checkPropertyAccessExpression(node, checkMode);
                case 167 /* QualifiedName */ :
                    return checkQualifiedName(node, checkMode);
                case 213 /* ElementAccessExpression */ :
                    return checkIndexedAccess(node, checkMode);
                case 214 /* CallExpression */ :
                    if (isImportCall(node)) return checkImportCallExpression(node);
                // falls through
                case 215 /* NewExpression */ :
                    return checkCallExpression(node, checkMode);
                case 216 /* TaggedTemplateExpression */ :
                    return checkTaggedTemplateExpression(node);
                case 218 /* ParenthesizedExpression */ :
                    return checkParenthesizedExpression(node, checkMode);
                case 232 /* ClassExpression */ :
                    return checkClassExpression(node);
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    return checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
                case 222 /* TypeOfExpression */ :
                    return checkTypeOfExpression(node);
                case 217 /* TypeAssertionExpression */ :
                case 235 /* AsExpression */ :
                    return checkAssertion(node, checkMode);
                case 236 /* NonNullExpression */ :
                    return checkNonNullAssertion(node);
                case 234 /* ExpressionWithTypeArguments */ :
                    return checkExpressionWithTypeArguments(node);
                case 239 /* SatisfiesExpression */ :
                    return checkSatisfiesExpression(node);
                case 237 /* MetaProperty */ :
                    return checkMetaProperty(node);
                case 221 /* DeleteExpression */ :
                    return checkDeleteExpression(node);
                case 223 /* VoidExpression */ :
                    return checkVoidExpression(node);
                case 224 /* AwaitExpression */ :
                    return checkAwaitExpression(node);
                case 225 /* PrefixUnaryExpression */ :
                    return checkPrefixUnaryExpression(node);
                case 226 /* PostfixUnaryExpression */ :
                    return checkPostfixUnaryExpression(node);
                case 227 /* BinaryExpression */ :
                    return checkBinaryExpression(node, checkMode);
                case 228 /* ConditionalExpression */ :
                    return checkConditionalExpression(node, checkMode);
                case 231 /* SpreadElement */ :
                    return checkSpreadExpression(node, checkMode);
                case 233 /* OmittedExpression */ :
                    return undefinedWideningType;
                case 230 /* YieldExpression */ :
                    return checkYieldExpression(node);
                case 238 /* SyntheticExpression */ :
                    return checkSyntheticExpression(node);
                case 295 /* JsxExpression */ :
                    return checkJsxExpression(node, checkMode);
                case 285 /* JsxElement */ :
                    return checkJsxElement(node, checkMode);
                case 286 /* JsxSelfClosingElement */ :
                    return checkJsxSelfClosingElement(node, checkMode);
                case 289 /* JsxFragment */ :
                    return checkJsxFragment(node);
                case 293 /* JsxAttributes */ :
                    return checkJsxAttributes(node, checkMode);
                case 287 /* JsxOpeningElement */ :
                    Debug.fail("Shouldn't ever directly check a JsxOpeningElement");
            }
            return errorType;
        }
        function checkTypeParameter(node) {
            checkGrammarModifiers(node);
            if (node.expression) grammarErrorOnFirstToken(node.expression, Diagnostics.Type_expected);
            checkSourceElement(node.constraint);
            checkSourceElement(node.default);
            const typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node));
            getBaseConstraintOfType(typeParameter);
            if (!hasNonCircularTypeParameterDefault(typeParameter)) error2(node.default, Diagnostics.Type_parameter_0_has_a_circular_default, typeToString(typeParameter));
            const constraintType = getConstraintOfTypeParameter(typeParameter);
            const defaultType = getDefaultFromTypeParameter(typeParameter);
            if (constraintType && defaultType) checkTypeAssignableTo(defaultType, getTypeWithThisArgument(instantiateType(constraintType, makeUnaryTypeMapper(typeParameter, defaultType)), defaultType), node.default, Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
            checkNodeDeferred(node);
            addLazyDiagnostic(()=>checkTypeNameIsReserved(node.name, Diagnostics.Type_parameter_name_cannot_be_0));
        }
        function checkTypeParameterDeferred(node) {
            var _a, _b;
            if (isInterfaceDeclaration(node.parent) || isClassLike(node.parent) || isTypeAliasDeclaration(node.parent)) {
                const typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfDeclaration(node));
                const modifiers = getTypeParameterModifiers(typeParameter) & 24576 /* Out */ ;
                if (modifiers) {
                    const symbol = getSymbolOfDeclaration(node.parent);
                    if (isTypeAliasDeclaration(node.parent) && !(getObjectFlags(getDeclaredTypeOfSymbol(symbol)) & 48 /* Mapped */ )) error2(node, Diagnostics.Variance_annotations_are_only_supported_in_type_aliases_for_object_function_constructor_and_mapped_types);
                    else if (modifiers === 8192 /* In */  || modifiers === 16384 /* Out */ ) {
                        (_a = tracing) == null || _a.push(tracing.Phase.CheckTypes, "checkTypeParameterDeferred", {
                            parent: getTypeId(getDeclaredTypeOfSymbol(symbol)),
                            id: getTypeId(typeParameter)
                        });
                        const source = createMarkerType(symbol, typeParameter, modifiers === 16384 /* Out */  ? markerSubTypeForCheck : markerSuperTypeForCheck);
                        const target = createMarkerType(symbol, typeParameter, modifiers === 16384 /* Out */  ? markerSuperTypeForCheck : markerSubTypeForCheck);
                        const saveVarianceTypeParameter = typeParameter;
                        varianceTypeParameter = typeParameter;
                        checkTypeAssignableTo(source, target, node, Diagnostics.Type_0_is_not_assignable_to_type_1_as_implied_by_variance_annotation);
                        varianceTypeParameter = saveVarianceTypeParameter;
                        (_b = tracing) == null || _b.pop();
                    }
                }
            }
        }
        function checkParameter(node) {
            checkGrammarModifiers(node);
            checkVariableLikeDeclaration(node);
            const func = getContainingFunction(node);
            if (hasSyntacticModifier(node, 31 /* ParameterPropertyModifier */ )) {
                if (compilerOptions.erasableSyntaxOnly) error2(node, Diagnostics.This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled);
                if (!(func.kind === 177 /* Constructor */  && nodeIsPresent(func.body))) error2(node, Diagnostics.A_parameter_property_is_only_allowed_in_a_constructor_implementation);
                if (func.kind === 177 /* Constructor */  && isIdentifier(node.name) && node.name.escapedText === "constructor") error2(node.name, Diagnostics.constructor_cannot_be_used_as_a_parameter_property_name);
            }
            if (!node.initializer && isOptionalDeclaration(node) && isBindingPattern(node.name) && func.body) error2(node, Diagnostics.A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature);
            if (node.name && isIdentifier(node.name) && (node.name.escapedText === "this" || node.name.escapedText === "new")) {
                if (func.parameters.indexOf(node) !== 0) error2(node, Diagnostics.A_0_parameter_must_be_the_first_parameter, node.name.escapedText);
                if (func.kind === 177 /* Constructor */  || func.kind === 181 /* ConstructSignature */  || func.kind === 186 /* ConstructorType */ ) error2(node, Diagnostics.A_constructor_cannot_have_a_this_parameter);
                if (func.kind === 220 /* ArrowFunction */ ) error2(node, Diagnostics.An_arrow_function_cannot_have_a_this_parameter);
                if (func.kind === 178 /* GetAccessor */  || func.kind === 179 /* SetAccessor */ ) error2(node, Diagnostics.get_and_set_accessors_cannot_declare_this_parameters);
            }
            if (node.dotDotDotToken && !isBindingPattern(node.name) && !isTypeAssignableTo(getReducedType(getTypeOfSymbol(node.symbol)), anyReadonlyArrayType)) error2(node, Diagnostics.A_rest_parameter_must_be_of_an_array_type);
        }
        function checkTypePredicate(node) {
            const parent2 = getTypePredicateParent(node);
            if (!parent2) {
                error2(node, Diagnostics.A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods);
                return;
            }
            const signature = getSignatureFromDeclaration(parent2);
            const typePredicate = getTypePredicateOfSignature(signature);
            if (!typePredicate) return;
            checkSourceElement(node.type);
            const { parameterName } = node;
            if (typePredicate.kind !== 0 /* This */  && typePredicate.kind !== 2 /* AssertsThis */ ) {
                if (typePredicate.parameterIndex >= 0) {
                    if (signatureHasRestParameter(signature) && typePredicate.parameterIndex === signature.parameters.length - 1) error2(parameterName, Diagnostics.A_type_predicate_cannot_reference_a_rest_parameter);
                    else if (typePredicate.type) {
                        const leadingError = ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type);
                        checkTypeAssignableTo(typePredicate.type, getTypeOfSymbol(signature.parameters[typePredicate.parameterIndex]), node.type, /*headMessage*/ void 0, leadingError);
                    }
                } else if (parameterName) {
                    let hasReportedError = false;
                    for (const { name } of parent2.parameters)if (isBindingPattern(name) && checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, parameterName, typePredicate.parameterName)) {
                        hasReportedError = true;
                        break;
                    }
                    if (!hasReportedError) error2(node.parameterName, Diagnostics.Cannot_find_parameter_0, typePredicate.parameterName);
                }
            }
        }
        function getTypePredicateParent(node) {
            switch(node.parent.kind){
                case 220 /* ArrowFunction */ :
                case 180 /* CallSignature */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 185 /* FunctionType */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    const parent2 = node.parent;
                    if (node === parent2.type) return parent2;
            }
        }
        function checkIfTypePredicateVariableIsDeclaredInBindingPattern(pattern, predicateVariableNode, predicateVariableName) {
            for (const element of pattern.elements){
                if (isOmittedExpression(element)) continue;
                const name = element.name;
                if (name.kind === 80 /* Identifier */  && name.escapedText === predicateVariableName) {
                    error2(predicateVariableNode, Diagnostics.A_type_predicate_cannot_reference_element_0_in_a_binding_pattern, predicateVariableName);
                    return true;
                } else if (name.kind === 208 /* ArrayBindingPattern */  || name.kind === 207 /* ObjectBindingPattern */ ) {
                    if (checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, predicateVariableNode, predicateVariableName)) return true;
                }
            }
        }
        function checkSignatureDeclaration(node) {
            if (node.kind === 182 /* IndexSignature */ ) checkGrammarIndexSignature(node);
            else if (node.kind === 185 /* FunctionType */  || node.kind === 263 /* FunctionDeclaration */  || node.kind === 186 /* ConstructorType */  || node.kind === 180 /* CallSignature */  || node.kind === 177 /* Constructor */  || node.kind === 181 /* ConstructSignature */ ) checkGrammarFunctionLikeDeclaration(node);
            const functionFlags = getFunctionFlags(node);
            if (!(functionFlags & 4 /* Invalid */ )) {
                if ((functionFlags & 3 /* AsyncGenerator */ ) === 3 /* AsyncGenerator */  && languageVersion < LanguageFeatureMinimumTarget.AsyncGenerators) checkExternalEmitHelpers(node, 6144 /* AsyncGeneratorIncludes */ );
                if ((functionFlags & 3 /* AsyncGenerator */ ) === 2 /* Async */  && languageVersion < LanguageFeatureMinimumTarget.AsyncFunctions) checkExternalEmitHelpers(node, 64 /* Awaiter */ );
                if ((functionFlags & 3 /* AsyncGenerator */ ) !== 0 /* Normal */  && languageVersion < LanguageFeatureMinimumTarget.Generators) checkExternalEmitHelpers(node, 128 /* Generator */ );
            }
            checkTypeParameters(getEffectiveTypeParameterDeclarations(node));
            checkUnmatchedJSDocParameters(node);
            forEach(node.parameters, checkParameter);
            if (node.type) checkSourceElement(node.type);
            addLazyDiagnostic(checkSignatureDeclarationDiagnostics);
            function checkSignatureDeclarationDiagnostics() {
                checkCollisionWithArgumentsInGeneratedCode(node);
                let returnTypeNode = getEffectiveReturnTypeNode(node);
                let returnTypeErrorLocation = returnTypeNode;
                if (isInJSFile(node)) {
                    const typeTag = getJSDocTypeTag(node);
                    if (typeTag && typeTag.typeExpression && isTypeReferenceNode(typeTag.typeExpression.type)) {
                        const signature = getSingleCallSignature(getTypeFromTypeNode(typeTag.typeExpression));
                        if (signature && signature.declaration) {
                            returnTypeNode = getEffectiveReturnTypeNode(signature.declaration);
                            returnTypeErrorLocation = typeTag.typeExpression.type;
                        }
                    }
                }
                if (noImplicitAny && !returnTypeNode) switch(node.kind){
                    case 181 /* ConstructSignature */ :
                        error2(node, Diagnostics.Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
                        break;
                    case 180 /* CallSignature */ :
                        error2(node, Diagnostics.Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
                        break;
                }
                if (returnTypeNode && returnTypeErrorLocation) {
                    const functionFlags2 = getFunctionFlags(node);
                    if ((functionFlags2 & 5 /* Generator */ ) === 1 /* Generator */ ) {
                        const returnType = getTypeFromTypeNode(returnTypeNode);
                        if (returnType === voidType) error2(returnTypeErrorLocation, Diagnostics.A_generator_cannot_have_a_void_type_annotation);
                        else checkGeneratorInstantiationAssignabilityToReturnType(returnType, functionFlags2, returnTypeErrorLocation);
                    } else if ((functionFlags2 & 3 /* AsyncGenerator */ ) === 2 /* Async */ ) checkAsyncFunctionReturnType(node, returnTypeNode, returnTypeErrorLocation);
                }
                if (node.kind !== 182 /* IndexSignature */  && node.kind !== 318 /* JSDocFunctionType */ ) registerForUnusedIdentifiersCheck(node);
            }
        }
        function checkGeneratorInstantiationAssignabilityToReturnType(returnType, functionFlags, errorNode) {
            const generatorYieldType = getIterationTypeOfGeneratorFunctionReturnType(0 /* Yield */ , returnType, (functionFlags & 2 /* Async */ ) !== 0) || anyType;
            const generatorReturnType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , returnType, (functionFlags & 2 /* Async */ ) !== 0) || generatorYieldType;
            const generatorNextType = getIterationTypeOfGeneratorFunctionReturnType(2 /* Next */ , returnType, (functionFlags & 2 /* Async */ ) !== 0) || unknownType;
            const generatorInstantiation = createGeneratorType(generatorYieldType, generatorReturnType, generatorNextType, !!(functionFlags & 2 /* Async */ ));
            return checkTypeAssignableTo(generatorInstantiation, returnType, errorNode);
        }
        function checkClassForDuplicateDeclarations(node) {
            const instanceNames = /* @__PURE__ */ new Map();
            const staticNames = /* @__PURE__ */ new Map();
            const privateIdentifiers = /* @__PURE__ */ new Map();
            for (const member of node.members)if (member.kind === 177 /* Constructor */ ) {
                for (const param of member.parameters)if (isParameterPropertyDeclaration(param, member) && !isBindingPattern(param.name)) addName(instanceNames, param.name, param.name.escapedText, 3 /* GetOrSetAccessor */ );
            } else {
                const isStaticMember = isStatic(member);
                const name = member.name;
                if (!name) continue;
                const isPrivate = isPrivateIdentifier(name);
                const privateStaticFlags = isPrivate && isStaticMember ? 16 /* PrivateStatic */  : 0;
                const names = isPrivate ? privateIdentifiers : isStaticMember ? staticNames : instanceNames;
                const memberName = name && getEffectivePropertyNameForPropertyNameNode(name);
                if (memberName) switch(member.kind){
                    case 178 /* GetAccessor */ :
                        addName(names, name, memberName, 1 /* GetAccessor */  | privateStaticFlags);
                        break;
                    case 179 /* SetAccessor */ :
                        addName(names, name, memberName, 2 /* SetAccessor */  | privateStaticFlags);
                        break;
                    case 173 /* PropertyDeclaration */ :
                        addName(names, name, memberName, 3 /* GetOrSetAccessor */  | privateStaticFlags);
                        break;
                    case 175 /* MethodDeclaration */ :
                        addName(names, name, memberName, 8 /* Method */  | privateStaticFlags);
                        break;
                }
            }
            function addName(names, location, name, meaning) {
                const prev = names.get(name);
                if (prev) {
                    if ((prev & 16 /* PrivateStatic */ ) !== (meaning & 16 /* PrivateStatic */ )) error2(location, Diagnostics.Duplicate_identifier_0_Static_and_instance_elements_cannot_share_the_same_private_name, getTextOfNode(location));
                    else {
                        const prevIsMethod = !!(prev & 8 /* Method */ );
                        const isMethod = !!(meaning & 8 /* Method */ );
                        if (prevIsMethod || isMethod) {
                            if (prevIsMethod !== isMethod) error2(location, Diagnostics.Duplicate_identifier_0, getTextOfNode(location));
                        } else if (prev & meaning & -17 /* PrivateStatic */ ) error2(location, Diagnostics.Duplicate_identifier_0, getTextOfNode(location));
                        else names.set(name, prev | meaning);
                    }
                } else names.set(name, meaning);
            }
        }
        function checkClassForStaticPropertyNameConflicts(node) {
            for (const member of node.members){
                const memberNameNode = member.name;
                const isStaticMember = isStatic(member);
                if (isStaticMember && memberNameNode) {
                    const memberName = getEffectivePropertyNameForPropertyNameNode(memberNameNode);
                    switch(memberName){
                        case "name":
                        case "length":
                        case "caller":
                        case "arguments":
                            if (useDefineForClassFields) break;
                        // fall through
                        case "prototype":
                            const message = Diagnostics.Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1;
                            const className = getNameOfSymbolAsWritten(getSymbolOfDeclaration(node));
                            error2(memberNameNode, message, memberName, className);
                            break;
                    }
                }
            }
        }
        function checkObjectTypeForDuplicateDeclarations(node) {
            const names = /* @__PURE__ */ new Map();
            for (const member of node.members)if (member.kind === 172 /* PropertySignature */ ) {
                let memberName;
                const name = member.name;
                switch(name.kind){
                    case 11 /* StringLiteral */ :
                    case 9 /* NumericLiteral */ :
                        memberName = name.text;
                        break;
                    case 80 /* Identifier */ :
                        memberName = idText(name);
                        break;
                    default:
                        continue;
                }
                if (names.get(memberName)) {
                    error2(getNameOfDeclaration(member.symbol.valueDeclaration), Diagnostics.Duplicate_identifier_0, memberName);
                    error2(member.name, Diagnostics.Duplicate_identifier_0, memberName);
                } else names.set(memberName, true);
            }
        }
        function checkTypeForDuplicateIndexSignatures(node) {
            if (node.kind === 265 /* InterfaceDeclaration */ ) {
                const nodeSymbol = getSymbolOfDeclaration(node);
                if (nodeSymbol.declarations && nodeSymbol.declarations.length > 0 && nodeSymbol.declarations[0] !== node) return;
            }
            const indexSymbol = getIndexSymbol(getSymbolOfDeclaration(node));
            if (indexSymbol == null ? void 0 : indexSymbol.declarations) {
                const indexSignatureMap = /* @__PURE__ */ new Map();
                for (const declaration of indexSymbol.declarations){
                    if (isIndexSignatureDeclaration(declaration)) {
                        if (declaration.parameters.length === 1 && declaration.parameters[0].type) forEachType(getTypeFromTypeNode(declaration.parameters[0].type), (type)=>{
                            const entry = indexSignatureMap.get(getTypeId(type));
                            if (entry) entry.declarations.push(declaration);
                            else indexSignatureMap.set(getTypeId(type), {
                                type,
                                declarations: [
                                    declaration
                                ]
                            });
                        });
                    }
                }
                indexSignatureMap.forEach((entry)=>{
                    if (entry.declarations.length > 1) for (const declaration of entry.declarations)error2(declaration, Diagnostics.Duplicate_index_signature_for_type_0, typeToString(entry.type));
                });
            }
        }
        function checkPropertyDeclaration(node) {
            if (!checkGrammarModifiers(node) && !checkGrammarProperty(node)) checkGrammarComputedPropertyName(node.name);
            checkVariableLikeDeclaration(node);
            setNodeLinksForPrivateIdentifierScope(node);
            if (hasSyntacticModifier(node, 64 /* Abstract */ ) && node.kind === 173 /* PropertyDeclaration */  && node.initializer) error2(node, Diagnostics.Property_0_cannot_have_an_initializer_because_it_is_marked_abstract, declarationNameToString(node.name));
        }
        function checkPropertySignature(node) {
            if (isPrivateIdentifier(node.name)) error2(node, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
            return checkPropertyDeclaration(node);
        }
        function checkMethodDeclaration(node) {
            if (!checkGrammarMethod(node)) checkGrammarComputedPropertyName(node.name);
            if (isMethodDeclaration(node) && node.asteriskToken && isIdentifier(node.name) && idText(node.name) === "constructor") error2(node.name, Diagnostics.Class_constructor_may_not_be_a_generator);
            checkFunctionOrMethodDeclaration(node);
            if (hasSyntacticModifier(node, 64 /* Abstract */ ) && node.kind === 175 /* MethodDeclaration */  && node.body) error2(node, Diagnostics.Method_0_cannot_have_an_implementation_because_it_is_marked_abstract, declarationNameToString(node.name));
            if (isPrivateIdentifier(node.name) && !getContainingClass(node)) error2(node, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
            setNodeLinksForPrivateIdentifierScope(node);
        }
        function setNodeLinksForPrivateIdentifierScope(node) {
            if (isPrivateIdentifier(node.name)) {
                if (languageVersion < LanguageFeatureMinimumTarget.PrivateNamesAndClassStaticBlocks || languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators || !useDefineForClassFields) {
                    for(let lexicalScope = getEnclosingBlockScopeContainer(node); !!lexicalScope; lexicalScope = getEnclosingBlockScopeContainer(lexicalScope))getNodeLinks(lexicalScope).flags |= 1048576 /* ContainsClassWithPrivateIdentifiers */ ;
                    if (isClassExpression(node.parent)) {
                        const enclosingIterationStatement = getEnclosingIterationStatement(node.parent);
                        if (enclosingIterationStatement) {
                            getNodeLinks(node.name).flags |= 32768 /* BlockScopedBindingInLoop */ ;
                            getNodeLinks(enclosingIterationStatement).flags |= 4096 /* LoopWithCapturedBlockScopedBinding */ ;
                        }
                    }
                }
            }
        }
        function checkClassStaticBlockDeclaration(node) {
            checkGrammarModifiers(node);
            forEachChild(node, checkSourceElement);
        }
        function checkConstructorDeclaration(node) {
            checkSignatureDeclaration(node);
            if (!checkGrammarConstructorTypeParameters(node)) checkGrammarConstructorTypeAnnotation(node);
            checkSourceElement(node.body);
            const symbol = getSymbolOfDeclaration(node);
            const firstDeclaration = getDeclarationOfKind(symbol, node.kind);
            if (node === firstDeclaration) checkFunctionOrConstructorSymbol(symbol);
            if (nodeIsMissing(node.body)) return;
            addLazyDiagnostic(checkConstructorDeclarationDiagnostics);
            return;
            function isInstancePropertyWithInitializerOrPrivateIdentifierProperty(n) {
                if (isPrivateIdentifierClassElementDeclaration(n)) return true;
                return n.kind === 173 /* PropertyDeclaration */  && !isStatic(n) && !!n.initializer;
            }
            function checkConstructorDeclarationDiagnostics() {
                const containingClassDecl = node.parent;
                if (getClassExtendsHeritageElement(containingClassDecl)) {
                    captureLexicalThis(node.parent, containingClassDecl);
                    const classExtendsNull = classDeclarationExtendsNull(containingClassDecl);
                    const superCall = findFirstSuperCall(node.body);
                    if (superCall) {
                        if (classExtendsNull) error2(superCall, Diagnostics.A_constructor_cannot_contain_a_super_call_when_its_class_extends_null);
                        const superCallShouldBeRootLevel = !emitStandardClassFields && (some(node.parent.members, isInstancePropertyWithInitializerOrPrivateIdentifierProperty) || some(node.parameters, (p)=>hasSyntacticModifier(p, 31 /* ParameterPropertyModifier */ )));
                        if (superCallShouldBeRootLevel) {
                            if (!superCallIsRootLevelInConstructor(superCall, node.body)) error2(superCall, Diagnostics.A_super_call_must_be_a_root_level_statement_within_a_constructor_of_a_derived_class_that_contains_initialized_properties_parameter_properties_or_private_identifiers);
                            else {
                                let superCallStatement;
                                for (const statement of node.body.statements){
                                    if (isExpressionStatement(statement) && isSuperCall(skipOuterExpressions(statement.expression))) {
                                        superCallStatement = statement;
                                        break;
                                    }
                                    if (nodeImmediatelyReferencesSuperOrThis(statement)) break;
                                }
                                if (superCallStatement === void 0) error2(node, Diagnostics.A_super_call_must_be_the_first_statement_in_the_constructor_to_refer_to_super_or_this_when_a_derived_class_contains_initialized_properties_parameter_properties_or_private_identifiers);
                            }
                        }
                    } else if (!classExtendsNull) error2(node, Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call);
                }
            }
        }
        function superCallIsRootLevelInConstructor(superCall, body) {
            const superCallParent = walkUpParenthesizedExpressions(superCall.parent);
            return isExpressionStatement(superCallParent) && superCallParent.parent === body;
        }
        function nodeImmediatelyReferencesSuperOrThis(node) {
            if (node.kind === 108 /* SuperKeyword */  || node.kind === 110 /* ThisKeyword */ ) return true;
            if (isThisContainerOrFunctionBlock(node)) return false;
            return !!forEachChild(node, nodeImmediatelyReferencesSuperOrThis);
        }
        function checkAccessorDeclaration(node) {
            if (isIdentifier(node.name) && idText(node.name) === "constructor" && isClassLike(node.parent)) error2(node.name, Diagnostics.Class_constructor_may_not_be_an_accessor);
            addLazyDiagnostic(checkAccessorDeclarationDiagnostics);
            checkSourceElement(node.body);
            setNodeLinksForPrivateIdentifierScope(node);
            function checkAccessorDeclarationDiagnostics() {
                if (!checkGrammarFunctionLikeDeclaration(node) && !checkGrammarAccessor(node)) checkGrammarComputedPropertyName(node.name);
                checkDecorators(node);
                checkSignatureDeclaration(node);
                if (node.kind === 178 /* GetAccessor */ ) {
                    if (!(node.flags & 33554432 /* Ambient */ ) && nodeIsPresent(node.body) && node.flags & 512 /* HasImplicitReturn */ ) {
                        if (!(node.flags & 1024 /* HasExplicitReturn */ )) error2(node.name, Diagnostics.A_get_accessor_must_return_a_value);
                    }
                }
                if (node.name.kind === 168 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
                if (hasBindableName(node)) {
                    const symbol = getSymbolOfDeclaration(node);
                    const getter = getDeclarationOfKind(symbol, 178 /* GetAccessor */ );
                    const setter = getDeclarationOfKind(symbol, 179 /* SetAccessor */ );
                    if (getter && setter && !(getNodeCheckFlags(getter) & 1 /* TypeChecked */ )) {
                        getNodeLinks(getter).flags |= 1 /* TypeChecked */ ;
                        const getterFlags = getEffectiveModifierFlags(getter);
                        const setterFlags = getEffectiveModifierFlags(setter);
                        if ((getterFlags & 64 /* Abstract */ ) !== (setterFlags & 64 /* Abstract */ )) {
                            error2(getter.name, Diagnostics.Accessors_must_both_be_abstract_or_non_abstract);
                            error2(setter.name, Diagnostics.Accessors_must_both_be_abstract_or_non_abstract);
                        }
                        if (getterFlags & 4 /* Protected */  && !(setterFlags & 6 /* Private */ ) || getterFlags & 2 /* Private */  && !(setterFlags & 2 /* Private */ )) {
                            error2(getter.name, Diagnostics.A_get_accessor_must_be_at_least_as_accessible_as_the_setter);
                            error2(setter.name, Diagnostics.A_get_accessor_must_be_at_least_as_accessible_as_the_setter);
                        }
                    }
                }
                const returnType = getTypeOfAccessors(getSymbolOfDeclaration(node));
                if (node.kind === 178 /* GetAccessor */ ) checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnType);
            }
        }
        function checkMissingDeclaration(node) {
            checkDecorators(node);
        }
        function getEffectiveTypeArgumentAtIndex(node, typeParameters, index) {
            if (node.typeArguments && index < node.typeArguments.length) return getTypeFromTypeNode(node.typeArguments[index]);
            return getEffectiveTypeArguments2(node, typeParameters)[index];
        }
        function getEffectiveTypeArguments2(node, typeParameters) {
            return fillMissingTypeArguments(map(node.typeArguments, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), isInJSFile(node));
        }
        function checkTypeArgumentConstraints(node, typeParameters) {
            let typeArguments;
            let mapper;
            let result = true;
            for(let i = 0; i < typeParameters.length; i++){
                const constraint = getConstraintOfTypeParameter(typeParameters[i]);
                if (constraint) {
                    if (!typeArguments) {
                        typeArguments = getEffectiveTypeArguments2(node, typeParameters);
                        mapper = createTypeMapper(typeParameters, typeArguments);
                    }
                    result = result && checkTypeAssignableTo(typeArguments[i], instantiateType(constraint, mapper), node.typeArguments[i], Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
                }
            }
            return result;
        }
        function getTypeParametersForTypeAndSymbol(type, symbol) {
            if (!isErrorType(type)) return symbol.flags & 524288 /* TypeAlias */  && getSymbolLinks(symbol).typeParameters || (getObjectFlags(type) & 4 /* Reference */  ? type.target.localTypeParameters : void 0);
            return void 0;
        }
        function getTypeParametersForTypeReferenceOrImport(node) {
            const type = getTypeFromTypeNode(node);
            if (!isErrorType(type)) {
                const symbol = getNodeLinks(node).resolvedSymbol;
                if (symbol) return getTypeParametersForTypeAndSymbol(type, symbol);
            }
            return void 0;
        }
        function checkTypeReferenceNode(node) {
            checkGrammarTypeArguments(node, node.typeArguments);
            if (node.kind === 184 /* TypeReference */  && !isInJSFile(node) && !isInJSDoc(node) && node.typeArguments && node.typeName.end !== node.typeArguments.pos) {
                const sourceFile = getSourceFileOfNode(node);
                if (scanTokenAtPosition(sourceFile, node.typeName.end) === 25 /* DotToken */ ) grammarErrorAtPos(node, skipTrivia(sourceFile.text, node.typeName.end), 1, Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
            }
            forEach(node.typeArguments, checkSourceElement);
            checkTypeReferenceOrImport(node);
        }
        function checkTypeReferenceOrImport(node) {
            const type = getTypeFromTypeNode(node);
            if (!isErrorType(type)) {
                if (node.typeArguments) addLazyDiagnostic(()=>{
                    const typeParameters = getTypeParametersForTypeReferenceOrImport(node);
                    if (typeParameters) checkTypeArgumentConstraints(node, typeParameters);
                });
                const symbol = getNodeLinks(node).resolvedSymbol;
                if (symbol) {
                    if (some(symbol.declarations, (d)=>isTypeDeclaration(d) && !!(d.flags & 536870912 /* Deprecated */ ))) addDeprecatedSuggestion(getDeprecatedSuggestionNode(node), symbol.declarations, symbol.escapedName);
                }
            }
        }
        function getTypeArgumentConstraint(node) {
            const typeReferenceNode = tryCast(node.parent, isTypeReferenceType);
            if (!typeReferenceNode) return void 0;
            const typeParameters = getTypeParametersForTypeReferenceOrImport(typeReferenceNode);
            if (!typeParameters) return void 0;
            const constraint = getConstraintOfTypeParameter(typeParameters[typeReferenceNode.typeArguments.indexOf(node)]);
            return constraint && instantiateType(constraint, createTypeMapper(typeParameters, getEffectiveTypeArguments2(typeReferenceNode, typeParameters)));
        }
        function checkTypeQuery(node) {
            getTypeFromTypeQueryNode(node);
        }
        function checkTypeLiteral(node) {
            forEach(node.members, checkSourceElement);
            addLazyDiagnostic(checkTypeLiteralDiagnostics);
            function checkTypeLiteralDiagnostics() {
                const type = getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
                checkIndexConstraints(type, type.symbol);
                checkTypeForDuplicateIndexSignatures(node);
                checkObjectTypeForDuplicateDeclarations(node);
            }
        }
        function checkArrayType(node) {
            checkSourceElement(node.elementType);
        }
        function checkTupleType(node) {
            let seenOptionalElement = false;
            let seenRestElement = false;
            for (const e of node.elements){
                let flags = getTupleElementFlags(e);
                if (flags & 8 /* Variadic */ ) {
                    const type = getTypeFromTypeNode(e.type);
                    if (!isArrayLikeType(type)) {
                        error2(e, Diagnostics.A_rest_element_type_must_be_an_array_type);
                        break;
                    }
                    if (isArrayType(type) || isTupleType(type) && type.target.combinedFlags & 4 /* Rest */ ) flags |= 4 /* Rest */ ;
                }
                if (flags & 4 /* Rest */ ) {
                    if (seenRestElement) {
                        grammarErrorOnNode(e, Diagnostics.A_rest_element_cannot_follow_another_rest_element);
                        break;
                    }
                    seenRestElement = true;
                } else if (flags & 2 /* Optional */ ) {
                    if (seenRestElement) {
                        grammarErrorOnNode(e, Diagnostics.An_optional_element_cannot_follow_a_rest_element);
                        break;
                    }
                    seenOptionalElement = true;
                } else if (flags & 1 /* Required */  && seenOptionalElement) {
                    grammarErrorOnNode(e, Diagnostics.A_required_element_cannot_follow_an_optional_element);
                    break;
                }
            }
            forEach(node.elements, checkSourceElement);
            getTypeFromTypeNode(node);
        }
        function checkUnionOrIntersectionType(node) {
            forEach(node.types, checkSourceElement);
            getTypeFromTypeNode(node);
        }
        function checkIndexedAccessIndexType(type, accessNode) {
            if (!(type.flags & 8388608 /* IndexedAccess */ )) return type;
            const objectType = type.objectType;
            const indexType = type.indexType;
            const objectIndexType = isGenericMappedType(objectType) && getMappedTypeNameTypeKind(objectType) === 2 /* Remapping */  ? getIndexTypeForMappedType(objectType, 0 /* None */ ) : getIndexType(objectType, 0 /* None */ );
            const hasNumberIndexInfo = !!getIndexInfoOfType(objectType, numberType);
            if (everyType(indexType, (t)=>isTypeAssignableTo(t, objectIndexType) || hasNumberIndexInfo && isApplicableIndexType(t, numberType))) {
                if (accessNode.kind === 213 /* ElementAccessExpression */  && isAssignmentTarget(accessNode) && getObjectFlags(objectType) & 32 /* Mapped */  && getMappedTypeModifiers(objectType) & 1 /* IncludeReadonly */ ) error2(accessNode, Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
                return type;
            }
            if (isGenericObjectType(objectType)) {
                const propertyName = getPropertyNameFromIndex(indexType, accessNode);
                if (propertyName) {
                    const propertySymbol = forEachType(getApparentType(objectType), (t)=>getPropertyOfType(t, propertyName));
                    if (propertySymbol && getDeclarationModifierFlagsFromSymbol(propertySymbol) & 6 /* NonPublicAccessibilityModifier */ ) {
                        error2(accessNode, Diagnostics.Private_or_protected_member_0_cannot_be_accessed_on_a_type_parameter, unescapeLeadingUnderscores(propertyName));
                        return errorType;
                    }
                }
            }
            error2(accessNode, Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(indexType), typeToString(objectType));
            return errorType;
        }
        function checkIndexedAccessType(node) {
            checkSourceElement(node.objectType);
            checkSourceElement(node.indexType);
            checkIndexedAccessIndexType(getTypeFromIndexedAccessTypeNode(node), node);
        }
        function checkMappedType(node) {
            checkGrammarMappedType(node);
            checkSourceElement(node.typeParameter);
            checkSourceElement(node.nameType);
            checkSourceElement(node.type);
            if (!node.type) reportImplicitAny(node, anyType);
            const type = getTypeFromMappedTypeNode(node);
            const nameType = getNameTypeFromMappedType(type);
            if (nameType) checkTypeAssignableTo(nameType, stringNumberSymbolType, node.nameType);
            else {
                const constraintType = getConstraintTypeFromMappedType(type);
                checkTypeAssignableTo(constraintType, stringNumberSymbolType, getEffectiveConstraintOfTypeParameter(node.typeParameter));
            }
        }
        function checkGrammarMappedType(node) {
            var _a;
            if ((_a = node.members) == null ? void 0 : _a.length) return grammarErrorOnNode(node.members[0], Diagnostics.A_mapped_type_may_not_declare_properties_or_methods);
        }
        function checkThisType(node) {
            getTypeFromThisTypeNode(node);
        }
        function checkTypeOperator(node) {
            checkGrammarTypeOperatorNode(node);
            checkSourceElement(node.type);
        }
        function checkConditionalType(node) {
            forEachChild(node, checkSourceElement);
        }
        function checkInferType(node) {
            if (!findAncestor(node, (n)=>n.parent && n.parent.kind === 195 /* ConditionalType */  && n.parent.extendsType === n)) grammarErrorOnNode(node, Diagnostics.infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type);
            checkSourceElement(node.typeParameter);
            const symbol = getSymbolOfDeclaration(node.typeParameter);
            if (symbol.declarations && symbol.declarations.length > 1) {
                const links = getSymbolLinks(symbol);
                if (!links.typeParametersChecked) {
                    links.typeParametersChecked = true;
                    const typeParameter = getDeclaredTypeOfTypeParameter(symbol);
                    const declarations = getDeclarationsOfKind(symbol, 169 /* TypeParameter */ );
                    if (!areTypeParametersIdentical(declarations, [
                        typeParameter
                    ], (decl)=>[
                            decl
                        ])) {
                        const name = symbolToString(symbol);
                        for (const declaration of declarations)error2(declaration.name, Diagnostics.All_declarations_of_0_must_have_identical_constraints, name);
                    }
                }
            }
            registerForUnusedIdentifiersCheck(node);
        }
        function checkTemplateLiteralType(node) {
            for (const span of node.templateSpans){
                checkSourceElement(span.type);
                const type = getTypeFromTypeNode(span.type);
                checkTypeAssignableTo(type, templateConstraintType, span.type);
            }
            getTypeFromTypeNode(node);
        }
        function checkImportType(node) {
            checkSourceElement(node.argument);
            if (node.attributes) getResolutionModeOverride(node.attributes, grammarErrorOnNode);
            checkTypeReferenceOrImport(node);
        }
        function checkNamedTupleMember(node) {
            if (node.dotDotDotToken && node.questionToken) grammarErrorOnNode(node, Diagnostics.A_tuple_member_cannot_be_both_optional_and_rest);
            if (node.type.kind === 191 /* OptionalType */ ) grammarErrorOnNode(node.type, Diagnostics.A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_colon_rather_than_after_the_type);
            if (node.type.kind === 192 /* RestType */ ) grammarErrorOnNode(node.type, Diagnostics.A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type);
            checkSourceElement(node.type);
            getTypeFromTypeNode(node);
        }
        function isPrivateWithinAmbient(node) {
            return (hasEffectiveModifier(node, 2 /* Private */ ) || isPrivateIdentifierClassElementDeclaration(node)) && !!(node.flags & 33554432 /* Ambient */ );
        }
        function getEffectiveDeclarationFlags(n, flagsToCheck) {
            let flags = getCombinedModifierFlagsCached(n);
            if (n.parent.kind !== 265 /* InterfaceDeclaration */  && n.parent.kind !== 264 /* ClassDeclaration */  && n.parent.kind !== 232 /* ClassExpression */  && n.flags & 33554432 /* Ambient */ ) {
                const container = getEnclosingContainer(n);
                if (container && container.flags & 128 /* ExportContext */  && !(flags & 128 /* Ambient */ ) && !(isModuleBlock(n.parent) && isModuleDeclaration(n.parent.parent) && isGlobalScopeAugmentation(n.parent.parent))) flags |= 32 /* Export */ ;
                flags |= 128 /* Ambient */ ;
            }
            return flags & flagsToCheck;
        }
        function checkFunctionOrConstructorSymbol(symbol) {
            addLazyDiagnostic(()=>checkFunctionOrConstructorSymbolWorker(symbol));
        }
        function checkFunctionOrConstructorSymbolWorker(symbol) {
            function getCanonicalOverload(overloads, implementation) {
                const implementationSharesContainerWithFirstOverload = implementation !== void 0 && implementation.parent === overloads[0].parent;
                return implementationSharesContainerWithFirstOverload ? implementation : overloads[0];
            }
            function checkFlagAgreementBetweenOverloads(overloads, implementation, flagsToCheck2, someOverloadFlags, allOverloadFlags) {
                const someButNotAllOverloadFlags = someOverloadFlags ^ allOverloadFlags;
                if (someButNotAllOverloadFlags !== 0) {
                    const canonicalFlags = getEffectiveDeclarationFlags(getCanonicalOverload(overloads, implementation), flagsToCheck2);
                    group(overloads, (o)=>getSourceFileOfNode(o).fileName).forEach((overloadsInFile)=>{
                        const canonicalFlagsForFile = getEffectiveDeclarationFlags(getCanonicalOverload(overloadsInFile, implementation), flagsToCheck2);
                        for (const o of overloadsInFile){
                            const deviation = getEffectiveDeclarationFlags(o, flagsToCheck2) ^ canonicalFlags;
                            const deviationInFile = getEffectiveDeclarationFlags(o, flagsToCheck2) ^ canonicalFlagsForFile;
                            if (deviationInFile & 32 /* Export */ ) error2(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_exported_or_non_exported);
                            else if (deviationInFile & 128 /* Ambient */ ) error2(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_ambient_or_non_ambient);
                            else if (deviation & 6 /* Protected */ ) error2(getNameOfDeclaration(o) || o, Diagnostics.Overload_signatures_must_all_be_public_private_or_protected);
                            else if (deviation & 64 /* Abstract */ ) error2(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_abstract_or_non_abstract);
                        }
                    });
                }
            }
            function checkQuestionTokenAgreementBetweenOverloads(overloads, implementation, someHaveQuestionToken2, allHaveQuestionToken2) {
                if (someHaveQuestionToken2 !== allHaveQuestionToken2) {
                    const canonicalHasQuestionToken = hasQuestionToken(getCanonicalOverload(overloads, implementation));
                    forEach(overloads, (o)=>{
                        const deviation = hasQuestionToken(o) !== canonicalHasQuestionToken;
                        if (deviation) error2(getNameOfDeclaration(o), Diagnostics.Overload_signatures_must_all_be_optional_or_required);
                    });
                }
            }
            const flagsToCheck = 230 /* Abstract */ ;
            let someNodeFlags = 0 /* None */ ;
            let allNodeFlags = flagsToCheck;
            let someHaveQuestionToken = false;
            let allHaveQuestionToken = true;
            let hasOverloads = false;
            let bodyDeclaration;
            let lastSeenNonAmbientDeclaration;
            let previousDeclaration;
            const declarations = symbol.declarations;
            const isConstructor = (symbol.flags & 16384 /* Constructor */ ) !== 0;
            function reportImplementationExpectedError(node) {
                if (node.name && nodeIsMissing(node.name)) return;
                let seen = false;
                const subsequentNode = forEachChild(node.parent, (c)=>{
                    if (seen) return c;
                    else seen = c === node;
                });
                if (subsequentNode && subsequentNode.pos === node.end) {
                    if (subsequentNode.kind === node.kind) {
                        const errorNode2 = subsequentNode.name || subsequentNode;
                        const subsequentName = subsequentNode.name;
                        if (node.name && subsequentName && // both are private identifiers
                        (isPrivateIdentifier(node.name) && isPrivateIdentifier(subsequentName) && node.name.escapedText === subsequentName.escapedText || // Both are computed property names
                        isComputedPropertyName(node.name) && isComputedPropertyName(subsequentName) && isTypeIdenticalTo(checkComputedPropertyName(node.name), checkComputedPropertyName(subsequentName)) || // Both are literal property names that are the same.
                        isPropertyNameLiteral(node.name) && isPropertyNameLiteral(subsequentName) && getEscapedTextOfIdentifierOrLiteral(node.name) === getEscapedTextOfIdentifierOrLiteral(subsequentName))) {
                            const reportError = (node.kind === 175 /* MethodDeclaration */  || node.kind === 174 /* MethodSignature */ ) && isStatic(node) !== isStatic(subsequentNode);
                            if (reportError) {
                                const diagnostic = isStatic(node) ? Diagnostics.Function_overload_must_be_static : Diagnostics.Function_overload_must_not_be_static;
                                error2(errorNode2, diagnostic);
                            }
                            return;
                        }
                        if (nodeIsPresent(subsequentNode.body)) {
                            error2(errorNode2, Diagnostics.Function_implementation_name_must_be_0, declarationNameToString(node.name));
                            return;
                        }
                    }
                }
                const errorNode = node.name || node;
                if (isConstructor) error2(errorNode, Diagnostics.Constructor_implementation_is_missing);
                else if (hasSyntacticModifier(node, 64 /* Abstract */ )) error2(errorNode, Diagnostics.All_declarations_of_an_abstract_method_must_be_consecutive);
                else error2(errorNode, Diagnostics.Function_implementation_is_missing_or_not_immediately_following_the_declaration);
            }
            let duplicateFunctionDeclaration = false;
            let multipleConstructorImplementation = false;
            let hasNonAmbientClass = false;
            const functionDeclarations = [];
            if (declarations) for (const current of declarations){
                const node = current;
                const inAmbientContext = node.flags & 33554432 /* Ambient */ ;
                const inAmbientContextOrInterface = node.parent && (node.parent.kind === 265 /* InterfaceDeclaration */  || node.parent.kind === 188 /* TypeLiteral */ ) || inAmbientContext;
                if (inAmbientContextOrInterface) previousDeclaration = void 0;
                if ((node.kind === 264 /* ClassDeclaration */  || node.kind === 232 /* ClassExpression */ ) && !inAmbientContext) hasNonAmbientClass = true;
                if (node.kind === 263 /* FunctionDeclaration */  || node.kind === 175 /* MethodDeclaration */  || node.kind === 174 /* MethodSignature */  || node.kind === 177 /* Constructor */ ) {
                    functionDeclarations.push(node);
                    const currentNodeFlags = getEffectiveDeclarationFlags(node, flagsToCheck);
                    someNodeFlags |= currentNodeFlags;
                    allNodeFlags &= currentNodeFlags;
                    someHaveQuestionToken = someHaveQuestionToken || hasQuestionToken(node);
                    allHaveQuestionToken = allHaveQuestionToken && hasQuestionToken(node);
                    const bodyIsPresent = nodeIsPresent(node.body);
                    if (bodyIsPresent && bodyDeclaration) {
                        if (isConstructor) multipleConstructorImplementation = true;
                        else duplicateFunctionDeclaration = true;
                    } else if ((previousDeclaration == null ? void 0 : previousDeclaration.parent) === node.parent && previousDeclaration.end !== node.pos) reportImplementationExpectedError(previousDeclaration);
                    if (bodyIsPresent) {
                        if (!bodyDeclaration) bodyDeclaration = node;
                    } else hasOverloads = true;
                    previousDeclaration = node;
                    if (!inAmbientContextOrInterface) lastSeenNonAmbientDeclaration = node;
                }
                if (isInJSFile(current) && isFunctionLike(current) && current.jsDoc) hasOverloads = length(getJSDocOverloadTags(current)) > 0;
            }
            if (multipleConstructorImplementation) forEach(functionDeclarations, (declaration)=>{
                error2(declaration, Diagnostics.Multiple_constructor_implementations_are_not_allowed);
            });
            if (duplicateFunctionDeclaration) forEach(functionDeclarations, (declaration)=>{
                error2(getNameOfDeclaration(declaration) || declaration, Diagnostics.Duplicate_function_implementation);
            });
            if (hasNonAmbientClass && !isConstructor && symbol.flags & 16 /* Function */  && declarations) {
                const relatedDiagnostics = filter(declarations, (d)=>d.kind === 264 /* ClassDeclaration */ ).map((d)=>createDiagnosticForNode(d, Diagnostics.Consider_adding_a_declare_modifier_to_this_class));
                forEach(declarations, (declaration)=>{
                    const diagnostic = declaration.kind === 264 /* ClassDeclaration */  ? Diagnostics.Class_declaration_cannot_implement_overload_list_for_0 : declaration.kind === 263 /* FunctionDeclaration */  ? Diagnostics.Function_with_bodies_can_only_merge_with_classes_that_are_ambient : void 0;
                    if (diagnostic) addRelatedInfo(error2(getNameOfDeclaration(declaration) || declaration, diagnostic, symbolName(symbol)), ...relatedDiagnostics);
                });
            }
            if (lastSeenNonAmbientDeclaration && !lastSeenNonAmbientDeclaration.body && !hasSyntacticModifier(lastSeenNonAmbientDeclaration, 64 /* Abstract */ ) && !lastSeenNonAmbientDeclaration.questionToken) reportImplementationExpectedError(lastSeenNonAmbientDeclaration);
            if (hasOverloads) {
                if (declarations) {
                    checkFlagAgreementBetweenOverloads(declarations, bodyDeclaration, flagsToCheck, someNodeFlags, allNodeFlags);
                    checkQuestionTokenAgreementBetweenOverloads(declarations, bodyDeclaration, someHaveQuestionToken, allHaveQuestionToken);
                }
                if (bodyDeclaration) {
                    const signatures = getSignaturesOfSymbol(symbol);
                    const bodySignature = getSignatureFromDeclaration(bodyDeclaration);
                    for (const signature of signatures)if (!isImplementationCompatibleWithOverload(bodySignature, signature)) {
                        const errorNode = signature.declaration && isJSDocSignature(signature.declaration) ? signature.declaration.parent.tagName : signature.declaration;
                        addRelatedInfo(error2(errorNode, Diagnostics.This_overload_signature_is_not_compatible_with_its_implementation_signature), createDiagnosticForNode(bodyDeclaration, Diagnostics.The_implementation_signature_is_declared_here));
                        break;
                    }
                }
            }
        }
        function checkExportsOnMergedDeclarations(node) {
            addLazyDiagnostic(()=>checkExportsOnMergedDeclarationsWorker(node));
        }
        function checkExportsOnMergedDeclarationsWorker(node) {
            let symbol = node.localSymbol;
            if (!symbol) {
                symbol = getSymbolOfDeclaration(node);
                if (!symbol.exportSymbol) return;
            }
            if (getDeclarationOfKind(symbol, node.kind) !== node) return;
            let exportedDeclarationSpaces = 0 /* None */ ;
            let nonExportedDeclarationSpaces = 0 /* None */ ;
            let defaultExportedDeclarationSpaces = 0 /* None */ ;
            for (const d of symbol.declarations){
                const declarationSpaces = getDeclarationSpaces(d);
                const effectiveDeclarationFlags = getEffectiveDeclarationFlags(d, 2080 /* Default */ );
                if (effectiveDeclarationFlags & 32 /* Export */ ) {
                    if (effectiveDeclarationFlags & 2048 /* Default */ ) defaultExportedDeclarationSpaces |= declarationSpaces;
                    else exportedDeclarationSpaces |= declarationSpaces;
                } else nonExportedDeclarationSpaces |= declarationSpaces;
            }
            const nonDefaultExportedDeclarationSpaces = exportedDeclarationSpaces | nonExportedDeclarationSpaces;
            const commonDeclarationSpacesForExportsAndLocals = exportedDeclarationSpaces & nonExportedDeclarationSpaces;
            const commonDeclarationSpacesForDefaultAndNonDefault = defaultExportedDeclarationSpaces & nonDefaultExportedDeclarationSpaces;
            if (commonDeclarationSpacesForExportsAndLocals || commonDeclarationSpacesForDefaultAndNonDefault) for (const d of symbol.declarations){
                const declarationSpaces = getDeclarationSpaces(d);
                const name = getNameOfDeclaration(d);
                if (declarationSpaces & commonDeclarationSpacesForDefaultAndNonDefault) error2(name, Diagnostics.Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead, declarationNameToString(name));
                else if (declarationSpaces & commonDeclarationSpacesForExportsAndLocals) error2(name, Diagnostics.Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local, declarationNameToString(name));
            }
            function getDeclarationSpaces(decl) {
                let d = decl;
                switch(d.kind){
                    case 265 /* InterfaceDeclaration */ :
                    case 266 /* TypeAliasDeclaration */ :
                    // A jsdoc typedef and callback are, by definition, type aliases.
                    // falls through
                    case 347 /* JSDocTypedefTag */ :
                    case 339 /* JSDocCallbackTag */ :
                    case 341 /* JSDocEnumTag */ :
                        return 2 /* ExportType */ ;
                    case 268 /* ModuleDeclaration */ :
                        return isAmbientModule(d) || getModuleInstanceState(d) !== 0 /* NonInstantiated */  ? 5 /* ExportValue */  : 4 /* ExportNamespace */ ;
                    case 264 /* ClassDeclaration */ :
                    case 267 /* EnumDeclaration */ :
                    case 307 /* EnumMember */ :
                        return 3 /* ExportValue */ ;
                    case 308 /* SourceFile */ :
                        return 7 /* ExportNamespace */ ;
                    case 278 /* ExportAssignment */ :
                    case 227 /* BinaryExpression */ :
                        const node2 = d;
                        const expression = isExportAssignment(node2) ? node2.expression : node2.right;
                        if (!isEntityNameExpression(expression)) return 1 /* ExportValue */ ;
                        d = expression;
                    // The below options all declare an Alias, which is allowed to merge with other values within the importing module.
                    // falls through
                    case 272 /* ImportEqualsDeclaration */ :
                    case 275 /* NamespaceImport */ :
                    case 274 /* ImportClause */ :
                        let result = 0 /* None */ ;
                        const target = resolveAlias(getSymbolOfDeclaration(d));
                        forEach(target.declarations, (d2)=>{
                            result |= getDeclarationSpaces(d2);
                        });
                        return result;
                    case 261 /* VariableDeclaration */ :
                    case 209 /* BindingElement */ :
                    case 263 /* FunctionDeclaration */ :
                    case 277 /* ImportSpecifier */ :
                    // https://github.com/Microsoft/TypeScript/pull/7591
                    case 80 /* Identifier */ :
                        return 1 /* ExportValue */ ;
                    case 174 /* MethodSignature */ :
                    case 172 /* PropertySignature */ :
                        return 2 /* ExportType */ ;
                    default:
                        return Debug.failBadSyntaxKind(d);
                }
            }
        }
        function getAwaitedTypeOfPromise(type, errorNode, diagnosticMessage, ...args) {
            const promisedType = getPromisedTypeOfPromise(type, errorNode);
            return promisedType && getAwaitedType(promisedType, errorNode, diagnosticMessage, ...args);
        }
        function getPromisedTypeOfPromise(type, errorNode, thisTypeForErrorOut) {
            if (isTypeAny(type)) return void 0;
            const typeAsPromise = type;
            if (typeAsPromise.promisedTypeOfPromise) return typeAsPromise.promisedTypeOfPromise;
            if (isReferenceToType2(type, getGlobalPromiseType(/*reportErrors*/ false))) return typeAsPromise.promisedTypeOfPromise = getTypeArguments(type)[0];
            if (allTypesAssignableToKind(getBaseConstraintOrType(type), 402915324 /* Never */ )) return void 0;
            const thenFunction = getTypeOfPropertyOfType(type, "then");
            if (isTypeAny(thenFunction)) return void 0;
            const thenSignatures = thenFunction ? getSignaturesOfType(thenFunction, 0 /* Call */ ) : emptyArray;
            if (thenSignatures.length === 0) {
                if (errorNode) error2(errorNode, Diagnostics.A_promise_must_have_a_then_method);
                return void 0;
            }
            let thisTypeForError;
            let candidates;
            for (const thenSignature of thenSignatures){
                const thisType = getThisTypeOfSignature(thenSignature);
                if (thisType && thisType !== voidType && !isTypeRelatedTo(type, thisType, subtypeRelation)) thisTypeForError = thisType;
                else candidates = append(candidates, thenSignature);
            }
            if (!candidates) {
                Debug.assertIsDefined(thisTypeForError);
                if (thisTypeForErrorOut) thisTypeForErrorOut.value = thisTypeForError;
                if (errorNode) error2(errorNode, Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1, typeToString(type), typeToString(thisTypeForError));
                return void 0;
            }
            const onfulfilledParameterType = getTypeWithFacts(getUnionType(map(candidates, getTypeOfFirstParameterOfSignature)), 2097152 /* NEUndefinedOrNull */ );
            if (isTypeAny(onfulfilledParameterType)) return void 0;
            const onfulfilledParameterSignatures = getSignaturesOfType(onfulfilledParameterType, 0 /* Call */ );
            if (onfulfilledParameterSignatures.length === 0) {
                if (errorNode) error2(errorNode, Diagnostics.The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback);
                return void 0;
            }
            return typeAsPromise.promisedTypeOfPromise = getUnionType(map(onfulfilledParameterSignatures, getTypeOfFirstParameterOfSignature), 2 /* Subtype */ );
        }
        function checkAwaitedType(type, withAlias, errorNode, diagnosticMessage, ...args) {
            const awaitedType = withAlias ? getAwaitedType(type, errorNode, diagnosticMessage, ...args) : getAwaitedTypeNoAlias(type, errorNode, diagnosticMessage, ...args);
            return awaitedType || errorType;
        }
        function isThenableType(type) {
            if (allTypesAssignableToKind(getBaseConstraintOrType(type), 402915324 /* Never */ )) return false;
            const thenFunction = getTypeOfPropertyOfType(type, "then");
            return !!thenFunction && getSignaturesOfType(getTypeWithFacts(thenFunction, 2097152 /* NEUndefinedOrNull */ ), 0 /* Call */ ).length > 0;
        }
        function isAwaitedTypeInstantiation(type) {
            var _a;
            if (type.flags & 16777216 /* Conditional */ ) {
                const awaitedSymbol = getGlobalAwaitedSymbol(/*reportErrors*/ false);
                return !!awaitedSymbol && type.aliasSymbol === awaitedSymbol && ((_a = type.aliasTypeArguments) == null ? void 0 : _a.length) === 1;
            }
            return false;
        }
        function unwrapAwaitedType(type) {
            return type.flags & 1048576 /* Union */  ? mapType(type, unwrapAwaitedType) : isAwaitedTypeInstantiation(type) ? type.aliasTypeArguments[0] : type;
        }
        function isAwaitedTypeNeeded(type) {
            if (isTypeAny(type) || isAwaitedTypeInstantiation(type)) return false;
            if (isGenericObjectType(type)) {
                const baseConstraint = getBaseConstraintOfType(type);
                if (baseConstraint ? baseConstraint.flags & 3 /* AnyOrUnknown */  || isEmptyObjectType(baseConstraint) || someType(baseConstraint, isThenableType) : maybeTypeOfKind(type, 8650752 /* TypeVariable */ )) return true;
            }
            return false;
        }
        function tryCreateAwaitedType(type) {
            const awaitedSymbol = getGlobalAwaitedSymbol(/*reportErrors*/ true);
            if (awaitedSymbol) return getTypeAliasInstantiation(awaitedSymbol, [
                unwrapAwaitedType(type)
            ]);
            return void 0;
        }
        function createAwaitedTypeIfNeeded(type) {
            var _tryCreateAwaitedType;
            if (isAwaitedTypeNeeded(type)) return (_tryCreateAwaitedType = tryCreateAwaitedType(type)) !== null && _tryCreateAwaitedType !== void 0 ? _tryCreateAwaitedType : type;
            Debug.assert(isAwaitedTypeInstantiation(type) || getPromisedTypeOfPromise(type) === void 0, "type provided should not be a non-generic 'promise'-like.");
            return type;
        }
        function getAwaitedType(type, errorNode, diagnosticMessage, ...args) {
            const awaitedType = getAwaitedTypeNoAlias(type, errorNode, diagnosticMessage, ...args);
            return awaitedType && createAwaitedTypeIfNeeded(awaitedType);
        }
        function getAwaitedTypeNoAlias(type, errorNode, diagnosticMessage, ...args) {
            if (isTypeAny(type)) return type;
            if (isAwaitedTypeInstantiation(type)) return type;
            const typeAsAwaitable = type;
            if (typeAsAwaitable.awaitedTypeOfType) return typeAsAwaitable.awaitedTypeOfType;
            if (type.flags & 1048576 /* Union */ ) {
                if (awaitedTypeStack.lastIndexOf(type.id) >= 0) {
                    if (errorNode) error2(errorNode, Diagnostics.Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method);
                    return void 0;
                }
                const mapper = errorNode ? (constituentType)=>getAwaitedTypeNoAlias(constituentType, errorNode, diagnosticMessage, ...args) : getAwaitedTypeNoAlias;
                awaitedTypeStack.push(type.id);
                const mapped = mapType(type, mapper);
                awaitedTypeStack.pop();
                return typeAsAwaitable.awaitedTypeOfType = mapped;
            }
            if (isAwaitedTypeNeeded(type)) return typeAsAwaitable.awaitedTypeOfType = type;
            const thisTypeForErrorOut = {
                value: void 0
            };
            const promisedType = getPromisedTypeOfPromise(type, /*errorNode*/ void 0, thisTypeForErrorOut);
            if (promisedType) {
                if (type.id === promisedType.id || awaitedTypeStack.lastIndexOf(promisedType.id) >= 0) {
                    if (errorNode) error2(errorNode, Diagnostics.Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method);
                    return void 0;
                }
                awaitedTypeStack.push(type.id);
                const awaitedType = getAwaitedTypeNoAlias(promisedType, errorNode, diagnosticMessage, ...args);
                awaitedTypeStack.pop();
                if (!awaitedType) return void 0;
                return typeAsAwaitable.awaitedTypeOfType = awaitedType;
            }
            if (isThenableType(type)) {
                if (errorNode) {
                    Debug.assertIsDefined(diagnosticMessage);
                    let chain;
                    if (thisTypeForErrorOut.value) chain = chainDiagnosticMessages(chain, Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1, typeToString(type), typeToString(thisTypeForErrorOut.value));
                    chain = chainDiagnosticMessages(chain, diagnosticMessage, ...args);
                    diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(errorNode), errorNode, chain));
                }
                return void 0;
            }
            return typeAsAwaitable.awaitedTypeOfType = type;
        }
        function checkAsyncFunctionReturnType(node, returnTypeNode, returnTypeErrorLocation) {
            const returnType = getTypeFromTypeNode(returnTypeNode);
            if (languageVersion >= 2 /* ES2015 */ ) {
                if (isErrorType(returnType)) return;
                const globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
                if (globalPromiseType !== emptyGenericType && !isReferenceToType2(returnType, globalPromiseType)) {
                    reportErrorForInvalidReturnType(Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_write_Promise_0, returnTypeNode, returnTypeErrorLocation, typeToString(getAwaitedTypeNoAlias(returnType) || voidType));
                    return;
                }
            } else {
                markLinkedReferences(node, 5 /* AsyncFunction */ );
                if (isErrorType(returnType)) return;
                const promiseConstructorName = getEntityNameFromTypeNode(returnTypeNode);
                if (promiseConstructorName === void 0) {
                    reportErrorForInvalidReturnType(Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, returnTypeNode, returnTypeErrorLocation, typeToString(returnType));
                    return;
                }
                const promiseConstructorSymbol = resolveEntityName(promiseConstructorName, 111551 /* Value */ , /*ignoreErrors*/ true);
                const promiseConstructorType = promiseConstructorSymbol ? getTypeOfSymbol(promiseConstructorSymbol) : errorType;
                if (isErrorType(promiseConstructorType)) {
                    if (promiseConstructorName.kind === 80 /* Identifier */  && promiseConstructorName.escapedText === "Promise" && getTargetType(returnType) === getGlobalPromiseType(/*reportErrors*/ false)) error2(returnTypeErrorLocation, Diagnostics.An_async_function_or_method_in_ES5_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
                    else reportErrorForInvalidReturnType(Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, returnTypeNode, returnTypeErrorLocation, entityNameToString(promiseConstructorName));
                    return;
                }
                const globalPromiseConstructorLikeType = getGlobalPromiseConstructorLikeType(/*reportErrors*/ true);
                if (globalPromiseConstructorLikeType === emptyObjectType) {
                    reportErrorForInvalidReturnType(Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, returnTypeNode, returnTypeErrorLocation, entityNameToString(promiseConstructorName));
                    return;
                }
                const headMessage = Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_because_it_does_not_refer_to_a_Promise_compatible_constructor_value;
                const errorInfo = ()=>returnTypeNode === returnTypeErrorLocation ? void 0 : chainDiagnosticMessages(/*details*/ void 0, Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type);
                if (!checkTypeAssignableTo(promiseConstructorType, globalPromiseConstructorLikeType, returnTypeErrorLocation, headMessage, errorInfo)) return;
                const rootName = promiseConstructorName && getFirstIdentifier(promiseConstructorName);
                const collidingSymbol = getSymbol2(node.locals, rootName.escapedText, 111551 /* Value */ );
                if (collidingSymbol) {
                    error2(collidingSymbol.valueDeclaration, Diagnostics.Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions, idText(rootName), entityNameToString(promiseConstructorName));
                    return;
                }
            }
            checkAwaitedType(returnType, /*withAlias*/ false, node, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
            function reportErrorForInvalidReturnType(message, returnTypeNode2, returnTypeErrorLocation2, typeName) {
                if (returnTypeNode2 === returnTypeErrorLocation2) error2(returnTypeErrorLocation2, message, typeName);
                else {
                    const diag2 = error2(returnTypeErrorLocation2, Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type);
                    addRelatedInfo(diag2, createDiagnosticForNode(returnTypeNode2, message, typeName));
                }
            }
        }
        function checkGrammarDecorator(decorator) {
            const sourceFile = getSourceFileOfNode(decorator);
            if (!hasParseDiagnostics(sourceFile)) {
                let node = decorator.expression;
                if (isParenthesizedExpression(node)) return false;
                let canHaveCallExpression = true;
                let errorNode;
                while(true){
                    if (isExpressionWithTypeArguments(node) || isNonNullExpression(node)) {
                        node = node.expression;
                        continue;
                    }
                    if (isCallExpression(node)) {
                        if (!canHaveCallExpression) errorNode = node;
                        if (node.questionDotToken) errorNode = node.questionDotToken;
                        node = node.expression;
                        canHaveCallExpression = false;
                        continue;
                    }
                    if (isPropertyAccessExpression(node)) {
                        if (node.questionDotToken) errorNode = node.questionDotToken;
                        node = node.expression;
                        canHaveCallExpression = false;
                        continue;
                    }
                    if (!isIdentifier(node)) errorNode = node;
                    break;
                }
                if (errorNode) {
                    addRelatedInfo(error2(decorator.expression, Diagnostics.Expression_must_be_enclosed_in_parentheses_to_be_used_as_a_decorator), createDiagnosticForNode(errorNode, Diagnostics.Invalid_syntax_in_decorator));
                    return true;
                }
            }
            return false;
        }
        function checkDecorator(node) {
            checkGrammarDecorator(node);
            const signature = getResolvedSignature(node);
            checkDeprecatedSignature(signature, node);
            const returnType = getReturnTypeOfSignature(signature);
            if (returnType.flags & 1 /* Any */ ) return;
            const decoratorSignature = getDecoratorCallSignature(node);
            if (!(decoratorSignature == null ? void 0 : decoratorSignature.resolvedReturnType)) return;
            let headMessage;
            const expectedReturnType = decoratorSignature.resolvedReturnType;
            switch(node.parent.kind){
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    headMessage = Diagnostics.Decorator_function_return_type_0_is_not_assignable_to_type_1;
                    break;
                case 173 /* PropertyDeclaration */ :
                    if (!legacyDecorators) {
                        headMessage = Diagnostics.Decorator_function_return_type_0_is_not_assignable_to_type_1;
                        break;
                    }
                // falls through
                case 170 /* Parameter */ :
                    headMessage = Diagnostics.Decorator_function_return_type_is_0_but_is_expected_to_be_void_or_any;
                    break;
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    headMessage = Diagnostics.Decorator_function_return_type_0_is_not_assignable_to_type_1;
                    break;
                default:
                    return Debug.failBadSyntaxKind(node.parent);
            }
            checkTypeAssignableTo(returnType, expectedReturnType, node.expression, headMessage);
        }
        function createCallSignature(typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount = parameters.length, flags = 0 /* None */ ) {
            const decl = factory.createFunctionTypeNode(/*typeParameters*/ void 0, emptyArray, factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
            return createSignature(decl, typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount, flags);
        }
        function createFunctionType(typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount, flags) {
            const signature = createCallSignature(typeParameters, thisParameter, parameters, returnType, typePredicate, minArgumentCount, flags);
            return getOrCreateTypeFromSignature(signature);
        }
        function createGetterFunctionType(type) {
            return createFunctionType(/*typeParameters*/ void 0, /*thisParameter*/ void 0, emptyArray, type);
        }
        function createSetterFunctionType(type) {
            const valueParam = createParameter2("value", type);
            return createFunctionType(/*typeParameters*/ void 0, /*thisParameter*/ void 0, [
                valueParam
            ], voidType);
        }
        function getEntityNameForDecoratorMetadata(node) {
            if (node) switch(node.kind){
                case 194 /* IntersectionType */ :
                case 193 /* UnionType */ :
                    return getEntityNameForDecoratorMetadataFromTypeList(node.types);
                case 195 /* ConditionalType */ :
                    return getEntityNameForDecoratorMetadataFromTypeList([
                        node.trueType,
                        node.falseType
                    ]);
                case 197 /* ParenthesizedType */ :
                case 203 /* NamedTupleMember */ :
                    return getEntityNameForDecoratorMetadata(node.type);
                case 184 /* TypeReference */ :
                    return node.typeName;
            }
        }
        function getEntityNameForDecoratorMetadataFromTypeList(types) {
            let commonEntityName;
            for (let typeNode of types){
                while(typeNode.kind === 197 /* ParenthesizedType */  || typeNode.kind === 203 /* NamedTupleMember */ )typeNode = typeNode.type;
                if (typeNode.kind === 146 /* NeverKeyword */ ) continue;
                if (!strictNullChecks && (typeNode.kind === 202 /* LiteralType */  && typeNode.literal.kind === 106 /* NullKeyword */  || typeNode.kind === 157 /* UndefinedKeyword */ )) continue;
                const individualEntityName = getEntityNameForDecoratorMetadata(typeNode);
                if (!individualEntityName) return void 0;
                if (commonEntityName) {
                    if (!isIdentifier(commonEntityName) || !isIdentifier(individualEntityName) || commonEntityName.escapedText !== individualEntityName.escapedText) return void 0;
                } else commonEntityName = individualEntityName;
            }
            return commonEntityName;
        }
        function getParameterTypeNodeForDecoratorCheck(node) {
            const typeNode = getEffectiveTypeAnnotationNode(node);
            return isRestParameter(node) ? getRestParameterElementType(typeNode) : typeNode;
        }
        function checkDecorators(node) {
            if (!canHaveDecorators(node) || !hasDecorators(node) || !node.modifiers || !nodeCanBeDecorated(legacyDecorators, node, node.parent, node.parent.parent)) return;
            const firstDecorator = find(node.modifiers, isDecorator);
            if (!firstDecorator) return;
            if (legacyDecorators) {
                checkExternalEmitHelpers(firstDecorator, 8 /* Decorate */ );
                if (node.kind === 170 /* Parameter */ ) checkExternalEmitHelpers(firstDecorator, 32 /* Param */ );
            } else if (languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators) {
                checkExternalEmitHelpers(firstDecorator, 8 /* ESDecorateAndRunInitializers */ );
                if (isClassDeclaration(node)) {
                    if (!node.name) checkExternalEmitHelpers(firstDecorator, 4194304 /* SetFunctionName */ );
                    else {
                        const member = getFirstTransformableStaticClassElement(node);
                        if (member) checkExternalEmitHelpers(firstDecorator, 4194304 /* SetFunctionName */ );
                    }
                } else if (!isClassExpression(node)) {
                    if (isPrivateIdentifier(node.name) && (isMethodDeclaration(node) || isAccessor(node) || isAutoAccessorPropertyDeclaration(node))) checkExternalEmitHelpers(firstDecorator, 4194304 /* SetFunctionName */ );
                    if (isComputedPropertyName(node.name)) checkExternalEmitHelpers(firstDecorator, 8388608 /* PropKey */ );
                }
            }
            markLinkedReferences(node, 8 /* Decorator */ );
            for (const modifier of node.modifiers)if (isDecorator(modifier)) checkDecorator(modifier);
        }
        function checkFunctionDeclaration(node) {
            addLazyDiagnostic(checkFunctionDeclarationDiagnostics);
            function checkFunctionDeclarationDiagnostics() {
                checkFunctionOrMethodDeclaration(node);
                checkGrammarForGenerator(node);
                checkCollisionsForDeclarationName(node, node.name);
            }
        }
        function checkJSDocTypeAliasTag(node) {
            if (!node.typeExpression) error2(node.name, Diagnostics.JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags);
            if (node.name) checkTypeNameIsReserved(node.name, Diagnostics.Type_alias_name_cannot_be_0);
            checkSourceElement(node.typeExpression);
            checkTypeParameters(getEffectiveTypeParameterDeclarations(node));
        }
        function checkJSDocTemplateTag(node) {
            checkSourceElement(node.constraint);
            for (const tp of node.typeParameters)checkSourceElement(tp);
        }
        function checkJSDocTypeTag(node) {
            checkSourceElement(node.typeExpression);
        }
        function checkJSDocSatisfiesTag(node) {
            checkSourceElement(node.typeExpression);
            const host2 = getEffectiveJSDocHost(node);
            if (host2) {
                const tags = getAllJSDocTags(host2, isJSDocSatisfiesTag);
                if (length(tags) > 1) for(let i = 1; i < length(tags); i++){
                    const tagName = tags[i].tagName;
                    error2(tagName, Diagnostics._0_tag_already_specified, idText(tagName));
                }
            }
        }
        function checkJSDocLinkLikeTag(node) {
            if (node.name) resolveJSDocMemberName(node.name, /*ignoreErrors*/ true);
        }
        function checkJSDocParameterTag(node) {
            checkSourceElement(node.typeExpression);
        }
        function checkJSDocPropertyTag(node) {
            checkSourceElement(node.typeExpression);
        }
        function checkJSDocFunctionType(node) {
            addLazyDiagnostic(checkJSDocFunctionTypeImplicitAny);
            checkSignatureDeclaration(node);
            function checkJSDocFunctionTypeImplicitAny() {
                if (!node.type && !isJSDocConstructSignature(node)) reportImplicitAny(node, anyType);
            }
        }
        function checkJSDocThisTag(node) {
            const host2 = getEffectiveJSDocHost(node);
            if (host2 && isArrowFunction(host2)) error2(node.tagName, Diagnostics.An_arrow_function_cannot_have_a_this_parameter);
        }
        function checkJSDocImportTag(node) {
            checkImportAttributes(node);
        }
        function checkJSDocImplementsTag(node) {
            const classLike = getEffectiveJSDocHost(node);
            if (!classLike || !isClassDeclaration(classLike) && !isClassExpression(classLike)) error2(classLike, Diagnostics.JSDoc_0_is_not_attached_to_a_class, idText(node.tagName));
        }
        function checkJSDocAugmentsTag(node) {
            const classLike = getEffectiveJSDocHost(node);
            if (!classLike || !isClassDeclaration(classLike) && !isClassExpression(classLike)) {
                error2(classLike, Diagnostics.JSDoc_0_is_not_attached_to_a_class, idText(node.tagName));
                return;
            }
            const augmentsTags = getJSDocTags(classLike).filter(isJSDocAugmentsTag);
            Debug.assert(augmentsTags.length > 0);
            if (augmentsTags.length > 1) error2(augmentsTags[1], Diagnostics.Class_declarations_cannot_have_more_than_one_augments_or_extends_tag);
            const name = getIdentifierFromEntityNameExpression(node.class.expression);
            const extend2 = getClassExtendsHeritageElement(classLike);
            if (extend2) {
                const className = getIdentifierFromEntityNameExpression(extend2.expression);
                if (className && name.escapedText !== className.escapedText) error2(name, Diagnostics.JSDoc_0_1_does_not_match_the_extends_2_clause, idText(node.tagName), idText(name), idText(className));
            }
        }
        function checkJSDocAccessibilityModifiers(node) {
            const host2 = getJSDocHost(node);
            if (host2 && isPrivateIdentifierClassElementDeclaration(host2)) error2(node, Diagnostics.An_accessibility_modifier_cannot_be_used_with_a_private_identifier);
        }
        function getIdentifierFromEntityNameExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return node;
                case 212 /* PropertyAccessExpression */ :
                    return node.name;
                default:
                    return void 0;
            }
        }
        function checkFunctionOrMethodDeclaration(node) {
            var _a;
            checkDecorators(node);
            checkSignatureDeclaration(node);
            const functionFlags = getFunctionFlags(node);
            if (node.name && node.name.kind === 168 /* ComputedPropertyName */ ) checkComputedPropertyName(node.name);
            if (hasBindableName(node)) {
                const symbol = getSymbolOfDeclaration(node);
                const localSymbol = node.localSymbol || symbol;
                const firstDeclaration = (_a = localSymbol.declarations) == null ? void 0 : _a.find(// Get first non javascript function declaration
                (declaration)=>declaration.kind === node.kind && !(declaration.flags & 524288 /* JavaScriptFile */ ));
                if (node === firstDeclaration) checkFunctionOrConstructorSymbol(localSymbol);
                if (symbol.parent) checkFunctionOrConstructorSymbol(symbol);
            }
            const body = node.kind === 174 /* MethodSignature */  ? void 0 : node.body;
            checkSourceElement(body);
            checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, getReturnTypeFromAnnotation(node));
            addLazyDiagnostic(checkFunctionOrMethodDeclarationDiagnostics);
            if (isInJSFile(node)) {
                const typeTag = getJSDocTypeTag(node);
                if (typeTag && typeTag.typeExpression && !getContextualCallSignature(getTypeFromTypeNode(typeTag.typeExpression), node)) error2(typeTag.typeExpression.type, Diagnostics.The_type_of_a_function_declaration_must_match_the_function_s_signature);
            }
            function checkFunctionOrMethodDeclarationDiagnostics() {
                if (!getEffectiveReturnTypeNode(node)) {
                    if (nodeIsMissing(body) && !isPrivateWithinAmbient(node)) reportImplicitAny(node, anyType);
                    if (functionFlags & 1 /* Generator */  && nodeIsPresent(body)) getReturnTypeOfSignature(getSignatureFromDeclaration(node));
                }
            }
        }
        function registerForUnusedIdentifiersCheck(node) {
            addLazyDiagnostic(registerForUnusedIdentifiersCheckDiagnostics);
            function registerForUnusedIdentifiersCheckDiagnostics() {
                const sourceFile = getSourceFileOfNode(node);
                let potentiallyUnusedIdentifiers = allPotentiallyUnusedIdentifiers.get(sourceFile.path);
                if (!potentiallyUnusedIdentifiers) {
                    potentiallyUnusedIdentifiers = [];
                    allPotentiallyUnusedIdentifiers.set(sourceFile.path, potentiallyUnusedIdentifiers);
                }
                potentiallyUnusedIdentifiers.push(node);
            }
        }
        function checkUnusedIdentifiers(potentiallyUnusedIdentifiers, addDiagnostic) {
            for (const node of potentiallyUnusedIdentifiers)switch(node.kind){
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    checkUnusedClassMembers(node, addDiagnostic);
                    checkUnusedTypeParameters(node, addDiagnostic);
                    break;
                case 308 /* SourceFile */ :
                case 268 /* ModuleDeclaration */ :
                case 242 /* Block */ :
                case 270 /* CaseBlock */ :
                case 249 /* ForStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                    checkUnusedLocalsAndParameters(node, addDiagnostic);
                    break;
                case 177 /* Constructor */ :
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                case 220 /* ArrowFunction */ :
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    if (node.body) checkUnusedLocalsAndParameters(node, addDiagnostic);
                    checkUnusedTypeParameters(node, addDiagnostic);
                    break;
                case 174 /* MethodSignature */ :
                case 180 /* CallSignature */ :
                case 181 /* ConstructSignature */ :
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                case 266 /* TypeAliasDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                    checkUnusedTypeParameters(node, addDiagnostic);
                    break;
                case 196 /* InferType */ :
                    checkUnusedInferTypeParameter(node, addDiagnostic);
                    break;
                default:
                    Debug.assertNever(node, "Node should not have been registered for unused identifiers check");
            }
        }
        function errorUnusedLocal(declaration, name, addDiagnostic) {
            const node = getNameOfDeclaration(declaration) || declaration;
            const message = isTypeDeclaration(declaration) ? Diagnostics._0_is_declared_but_never_used : Diagnostics._0_is_declared_but_its_value_is_never_read;
            addDiagnostic(declaration, 0 /* Local */ , createDiagnosticForNode(node, message, name));
        }
        function isIdentifierThatStartsWithUnderscore(node) {
            return isIdentifier(node) && idText(node).charCodeAt(0) === 95 /* _ */ ;
        }
        function checkUnusedClassMembers(node, addDiagnostic) {
            for (const member of node.members)switch(member.kind){
                case 175 /* MethodDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    if (member.kind === 179 /* SetAccessor */  && member.symbol.flags & 32768 /* GetAccessor */ ) break;
                    const symbol = getSymbolOfDeclaration(member);
                    if (!symbol.isReferenced && (hasEffectiveModifier(member, 2 /* Private */ ) || isNamedDeclaration(member) && isPrivateIdentifier(member.name)) && !(member.flags & 33554432 /* Ambient */ )) addDiagnostic(member, 0 /* Local */ , createDiagnosticForNode(member.name, Diagnostics._0_is_declared_but_its_value_is_never_read, symbolToString(symbol)));
                    break;
                case 177 /* Constructor */ :
                    for (const parameter of member.parameters)if (!parameter.symbol.isReferenced && hasSyntacticModifier(parameter, 2 /* Private */ )) addDiagnostic(parameter, 0 /* Local */ , createDiagnosticForNode(parameter.name, Diagnostics.Property_0_is_declared_but_its_value_is_never_read, symbolName(parameter.symbol)));
                    break;
                case 182 /* IndexSignature */ :
                case 241 /* SemicolonClassElement */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    break;
                default:
                    Debug.fail("Unexpected class member");
            }
        }
        function checkUnusedInferTypeParameter(node, addDiagnostic) {
            const { typeParameter } = node;
            if (isTypeParameterUnused(typeParameter)) addDiagnostic(node, 1 /* Parameter */ , createDiagnosticForNode(node, Diagnostics._0_is_declared_but_its_value_is_never_read, idText(typeParameter.name)));
        }
        function checkUnusedTypeParameters(node, addDiagnostic) {
            const declarations = getSymbolOfDeclaration(node).declarations;
            if (!declarations || last(declarations) !== node) return;
            const typeParameters = getEffectiveTypeParameterDeclarations(node);
            const seenParentsWithEveryUnused = /* @__PURE__ */ new Set();
            for (const typeParameter of typeParameters){
                if (!isTypeParameterUnused(typeParameter)) continue;
                const name = idText(typeParameter.name);
                const { parent: parent2 } = typeParameter;
                if (parent2.kind !== 196 /* InferType */  && parent2.typeParameters.every(isTypeParameterUnused)) {
                    if (tryAddToSet(seenParentsWithEveryUnused, parent2)) {
                        const sourceFile = getSourceFileOfNode(parent2);
                        const range = isJSDocTemplateTag(parent2) ? rangeOfNode(parent2) : rangeOfTypeParameters(sourceFile, parent2.typeParameters);
                        const only = parent2.typeParameters.length === 1;
                        const messageAndArg = only ? [
                            Diagnostics._0_is_declared_but_its_value_is_never_read,
                            name
                        ] : [
                            Diagnostics.All_type_parameters_are_unused
                        ];
                        addDiagnostic(typeParameter, 1 /* Parameter */ , createFileDiagnostic(sourceFile, range.pos, range.end - range.pos, ...messageAndArg));
                    }
                } else addDiagnostic(typeParameter, 1 /* Parameter */ , createDiagnosticForNode(typeParameter, Diagnostics._0_is_declared_but_its_value_is_never_read, name));
            }
        }
        function isTypeParameterUnused(typeParameter) {
            return !(getMergedSymbol(typeParameter.symbol).isReferenced & 262144 /* TypeParameter */ ) && !isIdentifierThatStartsWithUnderscore(typeParameter.name);
        }
        function addToGroup(map2, key, value1, getKey) {
            const keyString = String(getKey(key));
            const group2 = map2.get(keyString);
            if (group2) group2[1].push(value1);
            else map2.set(keyString, [
                key,
                [
                    value1
                ]
            ]);
        }
        function tryGetRootParameterDeclaration(node) {
            return tryCast(getRootDeclaration(node), isParameter);
        }
        function isValidUnusedLocalDeclaration(declaration) {
            if (isBindingElement(declaration)) {
                if (isObjectBindingPattern(declaration.parent)) return !!(declaration.propertyName && isIdentifierThatStartsWithUnderscore(declaration.name));
                return isIdentifierThatStartsWithUnderscore(declaration.name);
            }
            return isAmbientModule(declaration) || (isVariableDeclaration(declaration) && isForInOrOfStatement(declaration.parent.parent) || isImportedDeclaration(declaration)) && isIdentifierThatStartsWithUnderscore(declaration.name);
        }
        function checkUnusedLocalsAndParameters(nodeWithLocals, addDiagnostic) {
            const unusedImports = /* @__PURE__ */ new Map();
            const unusedDestructures = /* @__PURE__ */ new Map();
            const unusedVariables = /* @__PURE__ */ new Map();
            nodeWithLocals.locals.forEach((local)=>{
                if (local.flags & 262144 /* TypeParameter */  ? !(local.flags & 3 /* Variable */  && !(local.isReferenced & 3 /* Variable */ )) : local.isReferenced || local.exportSymbol) return;
                if (local.declarations) for (const declaration of local.declarations){
                    if (isValidUnusedLocalDeclaration(declaration)) continue;
                    if (isImportedDeclaration(declaration)) addToGroup(unusedImports, importClauseFromImported(declaration), declaration, getNodeId);
                    else if (isBindingElement(declaration) && isObjectBindingPattern(declaration.parent)) {
                        const lastElement = last(declaration.parent.elements);
                        if (declaration === lastElement || !last(declaration.parent.elements).dotDotDotToken) addToGroup(unusedDestructures, declaration.parent, declaration, getNodeId);
                    } else if (isVariableDeclaration(declaration)) {
                        const blockScopeKind = getCombinedNodeFlagsCached(declaration) & 7 /* BlockScoped */ ;
                        const name = getNameOfDeclaration(declaration);
                        if (blockScopeKind !== 4 /* Using */  && blockScopeKind !== 6 /* AwaitUsing */  || !name || !isIdentifierThatStartsWithUnderscore(name)) addToGroup(unusedVariables, declaration.parent, declaration, getNodeId);
                    } else {
                        const parameter = local.valueDeclaration && tryGetRootParameterDeclaration(local.valueDeclaration);
                        const name = local.valueDeclaration && getNameOfDeclaration(local.valueDeclaration);
                        if (parameter && name) {
                            if (!isParameterPropertyDeclaration(parameter, parameter.parent) && !parameterIsThisKeyword(parameter) && !isIdentifierThatStartsWithUnderscore(name)) {
                                if (isBindingElement(declaration) && isArrayBindingPattern(declaration.parent)) addToGroup(unusedDestructures, declaration.parent, declaration, getNodeId);
                                else addDiagnostic(parameter, 1 /* Parameter */ , createDiagnosticForNode(name, Diagnostics._0_is_declared_but_its_value_is_never_read, symbolName(local)));
                            }
                        } else errorUnusedLocal(declaration, symbolName(local), addDiagnostic);
                    }
                }
            });
            unusedImports.forEach(([importClause, unuseds])=>{
                const importDecl = importClause.parent;
                const nDeclarations = (importClause.name ? 1 : 0) + (importClause.namedBindings ? importClause.namedBindings.kind === 275 /* NamespaceImport */  ? 1 : importClause.namedBindings.elements.length : 0);
                if (nDeclarations === unuseds.length) addDiagnostic(importDecl, 0 /* Local */ , unuseds.length === 1 ? createDiagnosticForNode(importDecl, Diagnostics._0_is_declared_but_its_value_is_never_read, idText(first(unuseds).name)) : createDiagnosticForNode(importDecl, Diagnostics.All_imports_in_import_declaration_are_unused));
                else for (const unused of unuseds)errorUnusedLocal(unused, idText(unused.name), addDiagnostic);
            });
            unusedDestructures.forEach(([bindingPattern, bindingElements])=>{
                const kind = tryGetRootParameterDeclaration(bindingPattern.parent) ? 1 /* Parameter */  : 0 /* Local */ ;
                if (bindingPattern.elements.length === bindingElements.length) {
                    if (bindingElements.length === 1 && bindingPattern.parent.kind === 261 /* VariableDeclaration */  && bindingPattern.parent.parent.kind === 262 /* VariableDeclarationList */ ) addToGroup(unusedVariables, bindingPattern.parent.parent, bindingPattern.parent, getNodeId);
                    else addDiagnostic(bindingPattern, kind, bindingElements.length === 1 ? createDiagnosticForNode(bindingPattern, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(first(bindingElements).name)) : createDiagnosticForNode(bindingPattern, Diagnostics.All_destructured_elements_are_unused));
                } else for (const e of bindingElements)addDiagnostic(e, kind, createDiagnosticForNode(e, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(e.name)));
            });
            unusedVariables.forEach(([declarationList, declarations])=>{
                if (declarationList.declarations.length === declarations.length) addDiagnostic(declarationList, 0 /* Local */ , declarations.length === 1 ? createDiagnosticForNode(first(declarations).name, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(first(declarations).name)) : createDiagnosticForNode(declarationList.parent.kind === 244 /* VariableStatement */  ? declarationList.parent : declarationList, Diagnostics.All_variables_are_unused));
                else for (const decl of declarations)addDiagnostic(decl, 0 /* Local */ , createDiagnosticForNode(decl, Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(decl.name)));
            });
        }
        function checkPotentialUncheckedRenamedBindingElementsInTypes() {
            var _a;
            for (const node of potentialUnusedRenamedBindingElementsInTypes)if (!((_a = getSymbolOfDeclaration(node)) == null ? void 0 : _a.isReferenced)) {
                const wrappingDeclaration = walkUpBindingElementsAndPatterns(node);
                Debug.assert(isPartOfParameterDeclaration(wrappingDeclaration), "Only parameter declaration should be checked here");
                const diagnostic = createDiagnosticForNode(node.name, Diagnostics._0_is_an_unused_renaming_of_1_Did_you_intend_to_use_it_as_a_type_annotation, declarationNameToString(node.name), declarationNameToString(node.propertyName));
                if (!wrappingDeclaration.type) addRelatedInfo(diagnostic, createFileDiagnostic(getSourceFileOfNode(wrappingDeclaration), wrappingDeclaration.end, 0, Diagnostics.We_can_only_write_a_type_for_0_by_adding_a_type_for_the_entire_parameter_here, declarationNameToString(node.propertyName)));
                diagnostics.add(diagnostic);
            }
        }
        function bindingNameText(name) {
            switch(name.kind){
                case 80 /* Identifier */ :
                    return idText(name);
                case 208 /* ArrayBindingPattern */ :
                case 207 /* ObjectBindingPattern */ :
                    return bindingNameText(cast(first(name.elements), isBindingElement).name);
                default:
                    return Debug.assertNever(name);
            }
        }
        function isImportedDeclaration(node) {
            return node.kind === 274 /* ImportClause */  || node.kind === 277 /* ImportSpecifier */  || node.kind === 275 /* NamespaceImport */ ;
        }
        function importClauseFromImported(decl) {
            return decl.kind === 274 /* ImportClause */  ? decl : decl.kind === 275 /* NamespaceImport */  ? decl.parent : decl.parent.parent;
        }
        function checkBlock(node) {
            if (node.kind === 242 /* Block */ ) checkGrammarStatementInAmbientContext(node);
            if (isFunctionOrModuleBlock(node)) {
                const saveFlowAnalysisDisabled = flowAnalysisDisabled;
                forEach(node.statements, checkSourceElement);
                flowAnalysisDisabled = saveFlowAnalysisDisabled;
            } else forEach(node.statements, checkSourceElement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkCollisionWithArgumentsInGeneratedCode(node) {
            if (languageVersion >= 2 /* ES2015 */  || !hasRestParameter(node) || node.flags & 33554432 /* Ambient */  || nodeIsMissing(node.body)) return;
            forEach(node.parameters, (p)=>{
                if (p.name && !isBindingPattern(p.name) && p.name.escapedText === argumentsSymbol.escapedName) errorSkippedOn("noEmit", p, Diagnostics.Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters);
            });
        }
        function needCollisionCheckForIdentifier(node, identifier, name) {
            if ((identifier == null ? void 0 : identifier.escapedText) !== name) return false;
            if (node.kind === 173 /* PropertyDeclaration */  || node.kind === 172 /* PropertySignature */  || node.kind === 175 /* MethodDeclaration */  || node.kind === 174 /* MethodSignature */  || node.kind === 178 /* GetAccessor */  || node.kind === 179 /* SetAccessor */  || node.kind === 304 /* PropertyAssignment */ ) return false;
            if (node.flags & 33554432 /* Ambient */ ) return false;
            if (isImportClause(node) || isImportEqualsDeclaration(node) || isImportSpecifier(node)) {
                if (isTypeOnlyImportOrExportDeclaration(node)) return false;
            }
            const root = getRootDeclaration(node);
            if (isParameter(root) && nodeIsMissing(root.parent.body)) return false;
            return true;
        }
        function checkIfThisIsCapturedInEnclosingScope(node) {
            findAncestor(node, (current)=>{
                if (getNodeCheckFlags(current) & 4 /* CaptureThis */ ) {
                    const isDeclaration2 = node.kind !== 80 /* Identifier */ ;
                    if (isDeclaration2) error2(getNameOfDeclaration(node), Diagnostics.Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference);
                    else error2(node, Diagnostics.Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference);
                    return true;
                }
                return false;
            });
        }
        function checkIfNewTargetIsCapturedInEnclosingScope(node) {
            findAncestor(node, (current)=>{
                if (getNodeCheckFlags(current) & 8 /* CaptureNewTarget */ ) {
                    const isDeclaration2 = node.kind !== 80 /* Identifier */ ;
                    if (isDeclaration2) error2(getNameOfDeclaration(node), Diagnostics.Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference);
                    else error2(node, Diagnostics.Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference);
                    return true;
                }
                return false;
            });
        }
        function checkCollisionWithRequireExportsInGeneratedCode(node, name) {
            if (host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) >= 5 /* ES2015 */ ) return;
            if (!name || !needCollisionCheckForIdentifier(node, name, "require") && !needCollisionCheckForIdentifier(node, name, "exports")) return;
            if (isModuleDeclaration(node) && getModuleInstanceState(node) !== 1 /* Instantiated */ ) return;
            const parent2 = getDeclarationContainer(node);
            if (parent2.kind === 308 /* SourceFile */  && isExternalOrCommonJsModule(parent2)) errorSkippedOn("noEmit", name, Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module, declarationNameToString(name), declarationNameToString(name));
        }
        function checkCollisionWithGlobalPromiseInGeneratedCode(node, name) {
            if (!name || languageVersion >= 4 /* ES2017 */  || !needCollisionCheckForIdentifier(node, name, "Promise")) return;
            if (isModuleDeclaration(node) && getModuleInstanceState(node) !== 1 /* Instantiated */ ) return;
            const parent2 = getDeclarationContainer(node);
            if (parent2.kind === 308 /* SourceFile */  && isExternalOrCommonJsModule(parent2) && parent2.flags & 4096 /* HasAsyncFunctions */ ) errorSkippedOn("noEmit", name, Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions, declarationNameToString(name), declarationNameToString(name));
        }
        function recordPotentialCollisionWithWeakMapSetInGeneratedCode(node, name) {
            if (languageVersion <= 8 /* ES2021 */  && (needCollisionCheckForIdentifier(node, name, "WeakMap") || needCollisionCheckForIdentifier(node, name, "WeakSet"))) potentialWeakMapSetCollisions.push(node);
        }
        function checkWeakMapSetCollision(node) {
            const enclosingBlockScope = getEnclosingBlockScopeContainer(node);
            if (getNodeCheckFlags(enclosingBlockScope) & 1048576 /* ContainsClassWithPrivateIdentifiers */ ) {
                Debug.assert(isNamedDeclaration(node) && isIdentifier(node.name) && typeof node.name.escapedText === "string", "The target of a WeakMap/WeakSet collision check should be an identifier");
                errorSkippedOn("noEmit", node, Diagnostics.Compiler_reserves_name_0_when_emitting_private_identifier_downlevel, node.name.escapedText);
            }
        }
        function recordPotentialCollisionWithReflectInGeneratedCode(node, name) {
            if (name && languageVersion >= 2 /* ES2015 */  && languageVersion <= 8 /* ES2021 */  && needCollisionCheckForIdentifier(node, name, "Reflect")) potentialReflectCollisions.push(node);
        }
        function checkReflectCollision(node) {
            let hasCollision = false;
            if (isClassExpression(node)) {
                for (const member of node.members)if (getNodeCheckFlags(member) & 2097152 /* ContainsSuperPropertyInStaticInitializer */ ) {
                    hasCollision = true;
                    break;
                }
            } else if (isFunctionExpression(node)) {
                if (getNodeCheckFlags(node) & 2097152 /* ContainsSuperPropertyInStaticInitializer */ ) hasCollision = true;
            } else {
                const container = getEnclosingBlockScopeContainer(node);
                if (container && getNodeCheckFlags(container) & 2097152 /* ContainsSuperPropertyInStaticInitializer */ ) hasCollision = true;
            }
            if (hasCollision) {
                Debug.assert(isNamedDeclaration(node) && isIdentifier(node.name), "The target of a Reflect collision check should be an identifier");
                errorSkippedOn("noEmit", node, Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_when_emitting_super_references_in_static_initializers, declarationNameToString(node.name), "Reflect");
            }
        }
        function checkCollisionsForDeclarationName(node, name) {
            if (!name) return;
            checkCollisionWithRequireExportsInGeneratedCode(node, name);
            checkCollisionWithGlobalPromiseInGeneratedCode(node, name);
            recordPotentialCollisionWithWeakMapSetInGeneratedCode(node, name);
            recordPotentialCollisionWithReflectInGeneratedCode(node, name);
            if (isClassLike(node)) {
                checkTypeNameIsReserved(name, Diagnostics.Class_name_cannot_be_0);
                if (!(node.flags & 33554432 /* Ambient */ )) checkClassNameCollisionWithObject(name);
            } else if (isEnumDeclaration(node)) checkTypeNameIsReserved(name, Diagnostics.Enum_name_cannot_be_0);
        }
        function checkVarDeclaredNamesNotShadowed(node) {
            if ((getCombinedNodeFlagsCached(node) & 7 /* BlockScoped */ ) !== 0 || isPartOfParameterDeclaration(node)) return;
            const symbol = getSymbolOfDeclaration(node);
            if (symbol.flags & 1 /* FunctionScopedVariable */ ) {
                if (!isIdentifier(node.name)) return Debug.fail();
                const localDeclarationSymbol = resolveName(node, node.name.escapedText, 3 /* Variable */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false);
                if (localDeclarationSymbol && localDeclarationSymbol !== symbol && localDeclarationSymbol.flags & 2 /* BlockScopedVariable */ ) {
                    if (getDeclarationNodeFlagsFromSymbol(localDeclarationSymbol) & 7 /* BlockScoped */ ) {
                        const varDeclList = getAncestor(localDeclarationSymbol.valueDeclaration, 262 /* VariableDeclarationList */ );
                        const container = varDeclList.parent.kind === 244 /* VariableStatement */  && varDeclList.parent.parent ? varDeclList.parent.parent : void 0;
                        const namesShareScope = container && (container.kind === 242 /* Block */  && isFunctionLike(container.parent) || container.kind === 269 /* ModuleBlock */  || container.kind === 268 /* ModuleDeclaration */  || container.kind === 308 /* SourceFile */ );
                        if (!namesShareScope) {
                            const name = symbolToString(localDeclarationSymbol);
                            error2(node, Diagnostics.Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1, name, name);
                        }
                    }
                }
            }
        }
        function convertAutoToAny(type) {
            return type === autoType ? anyType : type === autoArrayType ? anyArrayType : type;
        }
        function checkVariableLikeDeclaration(node) {
            var _a;
            checkDecorators(node);
            if (!isBindingElement(node)) checkSourceElement(node.type);
            if (!node.name) return;
            if (node.name.kind === 168 /* ComputedPropertyName */ ) {
                checkComputedPropertyName(node.name);
                if (hasOnlyExpressionInitializer(node) && node.initializer) checkExpressionCached(node.initializer);
            }
            if (isBindingElement(node)) {
                if (node.propertyName && isIdentifier(node.name) && isPartOfParameterDeclaration(node) && nodeIsMissing(getContainingFunction(node).body)) {
                    potentialUnusedRenamedBindingElementsInTypes.push(node);
                    return;
                }
                if (isObjectBindingPattern(node.parent) && node.dotDotDotToken && languageVersion < LanguageFeatureMinimumTarget.ObjectSpreadRest) checkExternalEmitHelpers(node, 4 /* Rest */ );
                if (node.propertyName && node.propertyName.kind === 168 /* ComputedPropertyName */ ) checkComputedPropertyName(node.propertyName);
                const parent2 = node.parent.parent;
                const parentCheckMode = node.dotDotDotToken ? 32 /* RestBindingElement */  : 0 /* Normal */ ;
                const parentType = getTypeForBindingElementParent(parent2, parentCheckMode);
                const name = node.propertyName || node.name;
                if (parentType && !isBindingPattern(name)) {
                    const exprType = getLiteralTypeFromPropertyName(name);
                    if (isTypeUsableAsPropertyName(exprType)) {
                        const nameText = getPropertyNameFromType(exprType);
                        const property = getPropertyOfType(parentType, nameText);
                        if (property) {
                            markPropertyAsReferenced(property, /*nodeForCheckWriteOnly*/ void 0, /*isSelfTypeAccess*/ false);
                            checkPropertyAccessibility(node, !!parent2.initializer && parent2.initializer.kind === 108 /* SuperKeyword */ , /*writing*/ false, parentType, property);
                        }
                    }
                }
            }
            if (isBindingPattern(node.name)) {
                if (node.name.kind === 208 /* ArrayBindingPattern */  && languageVersion < LanguageFeatureMinimumTarget.BindingPatterns && compilerOptions.downlevelIteration) checkExternalEmitHelpers(node, 512 /* Read */ );
                forEach(node.name.elements, checkSourceElement);
            }
            if (node.initializer && isPartOfParameterDeclaration(node) && nodeIsMissing(getContainingFunction(node).body)) {
                error2(node, Diagnostics.A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation);
                return;
            }
            if (isBindingPattern(node.name)) {
                if (isInAmbientOrTypeNode(node)) return;
                const needCheckInitializer = hasOnlyExpressionInitializer(node) && node.initializer && node.parent.parent.kind !== 250 /* ForInStatement */ ;
                const needCheckWidenedType = !some(node.name.elements, not(isOmittedExpression));
                if (needCheckInitializer || needCheckWidenedType) {
                    const widenedType = getWidenedTypeForVariableLikeDeclaration(node);
                    if (needCheckInitializer) {
                        const initializerType = checkExpressionCached(node.initializer);
                        if (strictNullChecks && needCheckWidenedType) checkNonNullNonVoidType(initializerType, node);
                        else checkTypeAssignableToAndOptionallyElaborate(initializerType, getWidenedTypeForVariableLikeDeclaration(node), node, node.initializer);
                    }
                    if (needCheckWidenedType) {
                        if (isArrayBindingPattern(node.name)) checkIteratedTypeOrElementType(65 /* Destructuring */ , widenedType, undefinedType, node);
                        else if (strictNullChecks) checkNonNullNonVoidType(widenedType, node);
                    }
                }
                return;
            }
            const symbol = getSymbolOfDeclaration(node);
            if (symbol.flags & 2097152 /* Alias */  && (isVariableDeclarationInitializedToBareOrAccessedRequire(node) || isBindingElementOfBareOrAccessedRequire(node))) {
                checkAliasSymbol(node);
                return;
            }
            if (node.name.kind === 10 /* BigIntLiteral */ ) error2(node.name, Diagnostics.A_bigint_literal_cannot_be_used_as_a_property_name);
            const type = convertAutoToAny(getTypeOfSymbol(symbol));
            if (node === symbol.valueDeclaration) {
                const initializer = hasOnlyExpressionInitializer(node) && getEffectiveInitializer(node);
                if (initializer) {
                    const isJSObjectLiteralInitializer = isInJSFile(node) && isObjectLiteralExpression(initializer) && (initializer.properties.length === 0 || isPrototypeAccess(node.name)) && !!((_a = symbol.exports) == null ? void 0 : _a.size);
                    if (!isJSObjectLiteralInitializer && node.parent.parent.kind !== 250 /* ForInStatement */ ) {
                        const initializerType = checkExpressionCached(initializer);
                        checkTypeAssignableToAndOptionallyElaborate(initializerType, type, node, initializer, /*headMessage*/ void 0);
                        const blockScopeKind = getCombinedNodeFlagsCached(node) & 7 /* BlockScoped */ ;
                        if (blockScopeKind === 6 /* AwaitUsing */ ) {
                            const globalAsyncDisposableType = getGlobalAsyncDisposableType(/*reportErrors*/ true);
                            const globalDisposableType = getGlobalDisposableType(/*reportErrors*/ true);
                            if (globalAsyncDisposableType !== emptyObjectType && globalDisposableType !== emptyObjectType) {
                                const optionalDisposableType = getUnionType([
                                    globalAsyncDisposableType,
                                    globalDisposableType,
                                    nullType,
                                    undefinedType
                                ]);
                                checkTypeAssignableTo(widenTypeForVariableLikeDeclaration(initializerType, node), optionalDisposableType, initializer, Diagnostics.The_initializer_of_an_await_using_declaration_must_be_either_an_object_with_a_Symbol_asyncDispose_or_Symbol_dispose_method_or_be_null_or_undefined);
                            }
                        } else if (blockScopeKind === 4 /* Using */ ) {
                            const globalDisposableType = getGlobalDisposableType(/*reportErrors*/ true);
                            if (globalDisposableType !== emptyObjectType) {
                                const optionalDisposableType = getUnionType([
                                    globalDisposableType,
                                    nullType,
                                    undefinedType
                                ]);
                                checkTypeAssignableTo(widenTypeForVariableLikeDeclaration(initializerType, node), optionalDisposableType, initializer, Diagnostics.The_initializer_of_a_using_declaration_must_be_either_an_object_with_a_Symbol_dispose_method_or_be_null_or_undefined);
                            }
                        }
                    }
                }
                if (symbol.declarations && symbol.declarations.length > 1) {
                    if (some(symbol.declarations, (d)=>d !== node && isVariableLike(d) && !areDeclarationFlagsIdentical(d, node))) error2(node.name, Diagnostics.All_declarations_of_0_must_have_identical_modifiers, declarationNameToString(node.name));
                }
            } else {
                const declarationType = convertAutoToAny(getWidenedTypeForVariableLikeDeclaration(node));
                if (!isErrorType(type) && !isErrorType(declarationType) && !isTypeIdenticalTo(type, declarationType) && !(symbol.flags & 67108864 /* Assignment */ )) errorNextVariableOrPropertyDeclarationMustHaveSameType(symbol.valueDeclaration, type, node, declarationType);
                if (hasOnlyExpressionInitializer(node) && node.initializer) checkTypeAssignableToAndOptionallyElaborate(checkExpressionCached(node.initializer), declarationType, node, node.initializer, /*headMessage*/ void 0);
                if (symbol.valueDeclaration && !areDeclarationFlagsIdentical(node, symbol.valueDeclaration)) error2(node.name, Diagnostics.All_declarations_of_0_must_have_identical_modifiers, declarationNameToString(node.name));
            }
            if (node.kind !== 173 /* PropertyDeclaration */  && node.kind !== 172 /* PropertySignature */ ) {
                checkExportsOnMergedDeclarations(node);
                if (node.kind === 261 /* VariableDeclaration */  || node.kind === 209 /* BindingElement */ ) checkVarDeclaredNamesNotShadowed(node);
                checkCollisionsForDeclarationName(node, node.name);
            }
        }
        function errorNextVariableOrPropertyDeclarationMustHaveSameType(firstDeclaration, firstType, nextDeclaration, nextType) {
            const nextDeclarationName = getNameOfDeclaration(nextDeclaration);
            const message = nextDeclaration.kind === 173 /* PropertyDeclaration */  || nextDeclaration.kind === 172 /* PropertySignature */  ? Diagnostics.Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2 : Diagnostics.Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2;
            const declName = declarationNameToString(nextDeclarationName);
            const err = error2(nextDeclarationName, message, declName, typeToString(firstType), typeToString(nextType));
            if (firstDeclaration) addRelatedInfo(err, createDiagnosticForNode(firstDeclaration, Diagnostics._0_was_also_declared_here, declName));
        }
        function areDeclarationFlagsIdentical(left, right) {
            if (left.kind === 170 /* Parameter */  && right.kind === 261 /* VariableDeclaration */  || left.kind === 261 /* VariableDeclaration */  && right.kind === 170 /* Parameter */ ) return true;
            if (hasQuestionToken(left) !== hasQuestionToken(right)) return false;
            const interestingFlags = 1358 /* Static */ ;
            return getSelectedEffectiveModifierFlags(left, interestingFlags) === getSelectedEffectiveModifierFlags(right, interestingFlags);
        }
        function checkVariableDeclaration(node) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkVariableDeclaration", {
                kind: node.kind,
                pos: node.pos,
                end: node.end,
                path: node.tracingPath
            });
            checkGrammarVariableDeclaration(node);
            checkVariableLikeDeclaration(node);
            (_b = tracing) == null || _b.pop();
        }
        function checkBindingElement(node) {
            checkGrammarBindingElement(node);
            return checkVariableLikeDeclaration(node);
        }
        function checkVariableDeclarationList(node) {
            const blockScopeKind = getCombinedNodeFlags(node) & 7 /* BlockScoped */ ;
            if ((blockScopeKind === 4 /* Using */  || blockScopeKind === 6 /* AwaitUsing */ ) && languageVersion < LanguageFeatureMinimumTarget.UsingAndAwaitUsing) checkExternalEmitHelpers(node, 16777216 /* AddDisposableResourceAndDisposeResources */ );
            forEach(node.declarations, checkSourceElement);
        }
        function checkVariableStatement(node) {
            if (!checkGrammarModifiers(node) && !checkGrammarVariableDeclarationList(node.declarationList)) checkGrammarForDisallowedBlockScopedVariableStatement(node);
            checkVariableDeclarationList(node.declarationList);
        }
        function checkExpressionStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkExpression(node.expression);
        }
        function checkIfStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            const type = checkTruthinessExpression(node.expression);
            checkTestingKnownTruthyCallableOrAwaitableOrEnumMemberType(node.expression, type, node.thenStatement);
            checkSourceElement(node.thenStatement);
            if (node.thenStatement.kind === 243 /* EmptyStatement */ ) error2(node.thenStatement, Diagnostics.The_body_of_an_if_statement_cannot_be_the_empty_statement);
            checkSourceElement(node.elseStatement);
        }
        function checkTestingKnownTruthyCallableOrAwaitableOrEnumMemberType(condExpr, condType, body) {
            if (!strictNullChecks) return;
            bothHelper(condExpr, body);
            function bothHelper(condExpr2, body2) {
                condExpr2 = skipParentheses(condExpr2);
                helper(condExpr2, body2);
                while(isBinaryExpression(condExpr2) && (condExpr2.operatorToken.kind === 57 /* BarBarToken */  || condExpr2.operatorToken.kind === 61 /* QuestionQuestionToken */ )){
                    condExpr2 = skipParentheses(condExpr2.left);
                    helper(condExpr2, body2);
                }
            }
            function helper(condExpr2, body2) {
                const location = isLogicalOrCoalescingBinaryExpression(condExpr2) ? skipParentheses(condExpr2.right) : condExpr2;
                if (isModuleExportsAccessExpression(location)) return;
                if (isLogicalOrCoalescingBinaryExpression(location)) {
                    bothHelper(location, body2);
                    return;
                }
                const type = location === condExpr2 ? condType : checkExpression(location);
                var _getNodeLinks_resolvedSymbol;
                if (type.flags & 1024 /* EnumLiteral */  && isPropertyAccessExpression(location) && ((_getNodeLinks_resolvedSymbol = getNodeLinks(location.expression).resolvedSymbol) !== null && _getNodeLinks_resolvedSymbol !== void 0 ? _getNodeLinks_resolvedSymbol : unknownSymbol).flags & 384 /* Enum */ ) {
                    error2(location, Diagnostics.This_condition_will_always_return_0, !!type.value ? "true" : "false");
                    return;
                }
                const isPropertyExpressionCast = isPropertyAccessExpression(location) && isTypeAssertion(location.expression);
                if (!hasTypeFacts(type, 4194304 /* Truthy */ ) || isPropertyExpressionCast) return;
                const callSignatures = getSignaturesOfType(type, 0 /* Call */ );
                const isPromise = !!getAwaitedTypeOfPromise(type);
                if (callSignatures.length === 0 && !isPromise) return;
                const testedNode = isIdentifier(location) ? location : isPropertyAccessExpression(location) ? location.name : void 0;
                const testedSymbol = testedNode && getSymbolAtLocation(testedNode);
                if (!testedSymbol && !isPromise) return;
                const isUsed = testedSymbol && isBinaryExpression(condExpr2.parent) && isSymbolUsedInBinaryExpressionChain(condExpr2.parent, testedSymbol) || testedSymbol && body2 && isSymbolUsedInConditionBody(condExpr2, body2, testedNode, testedSymbol);
                if (!isUsed) {
                    if (isPromise) errorAndMaybeSuggestAwait(location, /*maybeMissingAwait*/ true, Diagnostics.This_condition_will_always_return_true_since_this_0_is_always_defined, getTypeNameForErrorDisplay(type));
                    else error2(location, Diagnostics.This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_instead);
                }
            }
        }
        function isSymbolUsedInConditionBody(expr, body, testedNode, testedSymbol) {
            return !!forEachChild(body, function check(childNode) {
                if (isIdentifier(childNode)) {
                    const childSymbol = getSymbolAtLocation(childNode);
                    if (childSymbol && childSymbol === testedSymbol) {
                        if (isIdentifier(expr) || isIdentifier(testedNode) && isBinaryExpression(testedNode.parent)) return true;
                        let testedExpression = testedNode.parent;
                        let childExpression = childNode.parent;
                        while(testedExpression && childExpression){
                            if (isIdentifier(testedExpression) && isIdentifier(childExpression) || testedExpression.kind === 110 /* ThisKeyword */  && childExpression.kind === 110 /* ThisKeyword */ ) return getSymbolAtLocation(testedExpression) === getSymbolAtLocation(childExpression);
                            else if (isPropertyAccessExpression(testedExpression) && isPropertyAccessExpression(childExpression)) {
                                if (getSymbolAtLocation(testedExpression.name) !== getSymbolAtLocation(childExpression.name)) return false;
                                childExpression = childExpression.expression;
                                testedExpression = testedExpression.expression;
                            } else if (isCallExpression(testedExpression) && isCallExpression(childExpression)) {
                                childExpression = childExpression.expression;
                                testedExpression = testedExpression.expression;
                            } else return false;
                        }
                    }
                }
                return forEachChild(childNode, check);
            });
        }
        function isSymbolUsedInBinaryExpressionChain(node, testedSymbol) {
            while(isBinaryExpression(node) && node.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ){
                const isUsed = forEachChild(node.right, function visit(child) {
                    if (isIdentifier(child)) {
                        const symbol = getSymbolAtLocation(child);
                        if (symbol && symbol === testedSymbol) return true;
                    }
                    return forEachChild(child, visit);
                });
                if (isUsed) return true;
                node = node.parent;
            }
            return false;
        }
        function checkDoStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkSourceElement(node.statement);
            checkTruthinessExpression(node.expression);
        }
        function checkWhileStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkTruthinessExpression(node.expression);
            checkSourceElement(node.statement);
        }
        function checkTruthinessOfType(type, node) {
            if (type.flags & 16384 /* Void */ ) error2(node, Diagnostics.An_expression_of_type_void_cannot_be_tested_for_truthiness);
            else {
                const semantics = getSyntacticTruthySemantics(node);
                if (semantics !== 3 /* Sometimes */ ) error2(node, semantics === 1 /* Always */  ? Diagnostics.This_kind_of_expression_is_always_truthy : Diagnostics.This_kind_of_expression_is_always_falsy);
            }
            return type;
        }
        function getSyntacticTruthySemantics(node) {
            node = skipOuterExpressions(node);
            switch(node.kind){
                case 9 /* NumericLiteral */ :
                    if (node.text === "0" || node.text === "1") return 3 /* Sometimes */ ;
                    return 1 /* Always */ ;
                case 210 /* ArrayLiteralExpression */ :
                case 220 /* ArrowFunction */ :
                case 10 /* BigIntLiteral */ :
                case 232 /* ClassExpression */ :
                case 219 /* FunctionExpression */ :
                case 285 /* JsxElement */ :
                case 286 /* JsxSelfClosingElement */ :
                case 211 /* ObjectLiteralExpression */ :
                case 14 /* RegularExpressionLiteral */ :
                    return 1 /* Always */ ;
                case 223 /* VoidExpression */ :
                case 106 /* NullKeyword */ :
                    return 2 /* Never */ ;
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                    return !!node.text ? 1 /* Always */  : 2 /* Never */ ;
                case 228 /* ConditionalExpression */ :
                    return getSyntacticTruthySemantics(node.whenTrue) | getSyntacticTruthySemantics(node.whenFalse);
                case 80 /* Identifier */ :
                    if (getResolvedSymbol(node) === undefinedSymbol) return 2 /* Never */ ;
                    return 3 /* Sometimes */ ;
            }
            return 3 /* Sometimes */ ;
        }
        function checkTruthinessExpression(node, checkMode) {
            return checkTruthinessOfType(checkExpression(node, checkMode), node);
        }
        function checkForStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) {
                if (node.initializer && node.initializer.kind === 262 /* VariableDeclarationList */ ) checkGrammarVariableDeclarationList(node.initializer);
            }
            if (node.initializer) {
                if (node.initializer.kind === 262 /* VariableDeclarationList */ ) checkVariableDeclarationList(node.initializer);
                else checkExpression(node.initializer);
            }
            if (node.condition) checkTruthinessExpression(node.condition);
            if (node.incrementor) checkExpression(node.incrementor);
            checkSourceElement(node.statement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkForOfStatement(node) {
            checkGrammarForInOrForOfStatement(node);
            const container = getContainingFunctionOrClassStaticBlock(node);
            if (node.awaitModifier) {
                if (container && isClassStaticBlockDeclaration(container)) grammarErrorOnNode(node.awaitModifier, Diagnostics.for_await_loops_cannot_be_used_inside_a_class_static_block);
                else {
                    const functionFlags = getFunctionFlags(container);
                    if ((functionFlags & 6 /* Async */ ) === 2 /* Async */  && languageVersion < LanguageFeatureMinimumTarget.ForAwaitOf) checkExternalEmitHelpers(node, 16384 /* ForAwaitOfIncludes */ );
                }
            } else if (compilerOptions.downlevelIteration && languageVersion < LanguageFeatureMinimumTarget.ForOf) checkExternalEmitHelpers(node, 256 /* ForOfIncludes */ );
            if (node.initializer.kind === 262 /* VariableDeclarationList */ ) checkVariableDeclarationList(node.initializer);
            else {
                const varExpr = node.initializer;
                const iteratedType = checkRightHandSideOfForOf(node);
                if (varExpr.kind === 210 /* ArrayLiteralExpression */  || varExpr.kind === 211 /* ObjectLiteralExpression */ ) checkDestructuringAssignment(varExpr, iteratedType || errorType);
                else {
                    const leftType = checkExpression(varExpr);
                    checkReferenceExpression(varExpr, Diagnostics.The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access, Diagnostics.The_left_hand_side_of_a_for_of_statement_may_not_be_an_optional_property_access);
                    if (iteratedType) checkTypeAssignableToAndOptionallyElaborate(iteratedType, leftType, varExpr, node.expression);
                }
            }
            checkSourceElement(node.statement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkForInStatement(node) {
            checkGrammarForInOrForOfStatement(node);
            const rightType = getNonNullableTypeIfNeeded(checkExpression(node.expression));
            if (node.initializer.kind === 262 /* VariableDeclarationList */ ) {
                const variable = node.initializer.declarations[0];
                if (variable && isBindingPattern(variable.name)) error2(variable.name, Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
                checkVariableDeclarationList(node.initializer);
            } else {
                const varExpr = node.initializer;
                const leftType = checkExpression(varExpr);
                if (varExpr.kind === 210 /* ArrayLiteralExpression */  || varExpr.kind === 211 /* ObjectLiteralExpression */ ) error2(varExpr, Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
                else if (!isTypeAssignableTo(getIndexTypeOrString(rightType), leftType)) error2(varExpr, Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any);
                else checkReferenceExpression(varExpr, Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access, Diagnostics.The_left_hand_side_of_a_for_in_statement_may_not_be_an_optional_property_access);
            }
            if (rightType === neverType || !isTypeAssignableToKind(rightType, 126091264 /* InstantiableNonPrimitive */ )) error2(node.expression, Diagnostics.The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_here_has_type_0, typeToString(rightType));
            checkSourceElement(node.statement);
            if (node.locals) registerForUnusedIdentifiersCheck(node);
        }
        function checkRightHandSideOfForOf(statement) {
            const use = statement.awaitModifier ? 15 /* ForAwaitOf */  : 13 /* ForOf */ ;
            return checkIteratedTypeOrElementType(use, checkNonNullExpression(statement.expression), undefinedType, statement.expression);
        }
        function checkIteratedTypeOrElementType(use, inputType, sentType, errorNode) {
            if (isTypeAny(inputType)) return inputType;
            return getIteratedTypeOrElementType(use, inputType, sentType, errorNode, /*checkAssignability*/ true) || anyType;
        }
        function getIteratedTypeOrElementType(use, inputType, sentType, errorNode, checkAssignability) {
            const allowAsyncIterables = (use & 2 /* AllowsAsyncIterablesFlag */ ) !== 0;
            if (inputType === neverType) {
                if (errorNode) reportTypeNotIterableError(errorNode, inputType, allowAsyncIterables);
                return void 0;
            }
            const uplevelIteration = languageVersion >= 2 /* ES2015 */ ;
            const downlevelIteration = !uplevelIteration && compilerOptions.downlevelIteration;
            const possibleOutOfBounds = compilerOptions.noUncheckedIndexedAccess && !!(use & 128 /* PossiblyOutOfBounds */ );
            if (uplevelIteration || downlevelIteration || allowAsyncIterables) {
                const iterationTypes = getIterationTypesOfIterable(inputType, use, uplevelIteration ? errorNode : void 0);
                if (checkAssignability) {
                    if (iterationTypes) {
                        const diagnostic = use & 8 /* ForOfFlag */  ? Diagnostics.Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_for_of_will_always_send_0 : use & 32 /* SpreadFlag */  ? Diagnostics.Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_spread_will_always_send_0 : use & 64 /* DestructuringFlag */  ? Diagnostics.Cannot_iterate_value_because_the_next_method_of_its_iterator_expects_type_1_but_array_destructuring_will_always_send_0 : use & 16 /* YieldStarFlag */  ? Diagnostics.Cannot_delegate_iteration_to_value_because_the_next_method_of_its_iterator_expects_type_1_but_the_containing_generator_will_always_send_0 : void 0;
                        if (diagnostic) checkTypeAssignableTo(sentType, iterationTypes.nextType, errorNode, diagnostic);
                    }
                }
                if (iterationTypes || uplevelIteration) return possibleOutOfBounds ? includeUndefinedInIndexSignature(iterationTypes && iterationTypes.yieldType) : iterationTypes && iterationTypes.yieldType;
            }
            let arrayType = inputType;
            let hasStringConstituent = false;
            if (use & 4 /* AllowsStringInputFlag */ ) {
                if (arrayType.flags & 1048576 /* Union */ ) {
                    const arrayTypes = inputType.types;
                    const filteredTypes = filter(arrayTypes, (t)=>!(t.flags & 402653316 /* StringLike */ ));
                    if (filteredTypes !== arrayTypes) arrayType = getUnionType(filteredTypes, 2 /* Subtype */ );
                } else if (arrayType.flags & 402653316 /* StringLike */ ) arrayType = neverType;
                hasStringConstituent = arrayType !== inputType;
                if (hasStringConstituent) {
                    if (arrayType.flags & 131072 /* Never */ ) return possibleOutOfBounds ? includeUndefinedInIndexSignature(stringType) : stringType;
                }
            }
            if (!isArrayLikeType(arrayType)) {
                if (errorNode) {
                    const allowsStrings = !!(use & 4 /* AllowsStringInputFlag */ ) && !hasStringConstituent;
                    const [defaultDiagnostic, maybeMissingAwait] = getIterationDiagnosticDetails(allowsStrings, downlevelIteration);
                    errorAndMaybeSuggestAwait(errorNode, maybeMissingAwait && !!getAwaitedTypeOfPromise(arrayType), defaultDiagnostic, typeToString(arrayType));
                }
                return hasStringConstituent ? possibleOutOfBounds ? includeUndefinedInIndexSignature(stringType) : stringType : void 0;
            }
            const arrayElementType = getIndexTypeOfType(arrayType, numberType);
            if (hasStringConstituent && arrayElementType) {
                if (arrayElementType.flags & 402653316 /* StringLike */  && !compilerOptions.noUncheckedIndexedAccess) return stringType;
                return getUnionType(possibleOutOfBounds ? [
                    arrayElementType,
                    stringType,
                    undefinedType
                ] : [
                    arrayElementType,
                    stringType
                ], 2 /* Subtype */ );
            }
            return use & 128 /* PossiblyOutOfBounds */  ? includeUndefinedInIndexSignature(arrayElementType) : arrayElementType;
            function getIterationDiagnosticDetails(allowsStrings, downlevelIteration2) {
                var _a;
                if (downlevelIteration2) return allowsStrings ? [
                    Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator,
                    true
                ] : [
                    Diagnostics.Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator,
                    true
                ];
                const yieldType = getIterationTypeOfIterable(use, 0 /* Yield */ , inputType, /*errorNode*/ void 0);
                if (yieldType) return [
                    Diagnostics.Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher,
                    false
                ];
                if (isES2015OrLaterIterable((_a = inputType.symbol) == null ? void 0 : _a.escapedName)) return [
                    Diagnostics.Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher,
                    true
                ];
                return allowsStrings ? [
                    Diagnostics.Type_0_is_not_an_array_type_or_a_string_type,
                    true
                ] : [
                    Diagnostics.Type_0_is_not_an_array_type,
                    true
                ];
            }
        }
        function isES2015OrLaterIterable(n) {
            switch(n){
                case "Float32Array":
                case "Float64Array":
                case "Int16Array":
                case "Int32Array":
                case "Int8Array":
                case "NodeList":
                case "Uint16Array":
                case "Uint32Array":
                case "Uint8Array":
                case "Uint8ClampedArray":
                    return true;
            }
            return false;
        }
        function getIterationTypeOfIterable(use, typeKind, inputType, errorNode) {
            if (isTypeAny(inputType)) return void 0;
            const iterationTypes = getIterationTypesOfIterable(inputType, use, errorNode);
            return iterationTypes && iterationTypes[getIterationTypesKeyFromIterationTypeKind(typeKind)];
        }
        function createIterationTypes(yieldType = neverType, returnType = neverType, nextType = unknownType) {
            if (yieldType.flags & 67359327 /* Intrinsic */  && returnType.flags & 180227 /* Undefined */  && nextType.flags & 180227 /* Undefined */ ) {
                const id = getTypeListId([
                    yieldType,
                    returnType,
                    nextType
                ]);
                let iterationTypes = iterationTypesCache.get(id);
                if (!iterationTypes) {
                    iterationTypes = {
                        yieldType,
                        returnType,
                        nextType
                    };
                    iterationTypesCache.set(id, iterationTypes);
                }
                return iterationTypes;
            }
            return {
                yieldType,
                returnType,
                nextType
            };
        }
        function combineIterationTypes(array) {
            let yieldTypes;
            let returnTypes;
            let nextTypes;
            for (const iterationTypes of array){
                if (iterationTypes === void 0 || iterationTypes === noIterationTypes) continue;
                if (iterationTypes === anyIterationTypes) return anyIterationTypes;
                yieldTypes = append(yieldTypes, iterationTypes.yieldType);
                returnTypes = append(returnTypes, iterationTypes.returnType);
                nextTypes = append(nextTypes, iterationTypes.nextType);
            }
            if (yieldTypes || returnTypes || nextTypes) return createIterationTypes(yieldTypes && getUnionType(yieldTypes), returnTypes && getUnionType(returnTypes), nextTypes && getIntersectionType(nextTypes));
            return noIterationTypes;
        }
        function getCachedIterationTypes(type, cacheKey) {
            return type[cacheKey];
        }
        function setCachedIterationTypes(type, cacheKey, cachedTypes2) {
            return type[cacheKey] = cachedTypes2;
        }
        function getIterationTypesOfIterable(type, use, errorNode) {
            var _a, _b;
            if (type === silentNeverType) return silentNeverIterationTypes;
            if (isTypeAny(type)) return anyIterationTypes;
            if (!(type.flags & 1048576 /* Union */ )) {
                const errorOutputContainer = errorNode ? {
                    errors: void 0,
                    skipLogging: true
                } : void 0;
                const iterationTypes2 = getIterationTypesOfIterableWorker(type, use, errorNode, errorOutputContainer);
                if (iterationTypes2 === noIterationTypes) {
                    if (errorNode) {
                        const rootDiag = reportTypeNotIterableError(errorNode, type, !!(use & 2 /* AllowsAsyncIterablesFlag */ ));
                        if (errorOutputContainer == null ? void 0 : errorOutputContainer.errors) addRelatedInfo(rootDiag, ...errorOutputContainer.errors);
                    }
                    return void 0;
                } else if ((_a = errorOutputContainer == null ? void 0 : errorOutputContainer.errors) == null ? void 0 : _a.length) for (const diag2 of errorOutputContainer.errors)diagnostics.add(diag2);
                return iterationTypes2;
            }
            const cacheKey = use & 2 /* AllowsAsyncIterablesFlag */  ? "iterationTypesOfAsyncIterable" : "iterationTypesOfIterable";
            const cachedTypes2 = getCachedIterationTypes(type, cacheKey);
            if (cachedTypes2) return cachedTypes2 === noIterationTypes ? void 0 : cachedTypes2;
            let allIterationTypes;
            for (const constituent of type.types){
                const errorOutputContainer = errorNode ? {
                    errors: void 0
                } : void 0;
                const iterationTypes2 = getIterationTypesOfIterableWorker(constituent, use, errorNode, errorOutputContainer);
                if (iterationTypes2 === noIterationTypes) {
                    if (errorNode) {
                        const rootDiag = reportTypeNotIterableError(errorNode, type, !!(use & 2 /* AllowsAsyncIterablesFlag */ ));
                        if (errorOutputContainer == null ? void 0 : errorOutputContainer.errors) addRelatedInfo(rootDiag, ...errorOutputContainer.errors);
                    }
                    setCachedIterationTypes(type, cacheKey, noIterationTypes);
                    return void 0;
                } else if ((_b = errorOutputContainer == null ? void 0 : errorOutputContainer.errors) == null ? void 0 : _b.length) for (const diag2 of errorOutputContainer.errors)diagnostics.add(diag2);
                allIterationTypes = append(allIterationTypes, iterationTypes2);
            }
            const iterationTypes = allIterationTypes ? combineIterationTypes(allIterationTypes) : noIterationTypes;
            setCachedIterationTypes(type, cacheKey, iterationTypes);
            return iterationTypes === noIterationTypes ? void 0 : iterationTypes;
        }
        function getAsyncFromSyncIterationTypes(iterationTypes, errorNode) {
            if (iterationTypes === noIterationTypes) return noIterationTypes;
            if (iterationTypes === anyIterationTypes) return anyIterationTypes;
            const { yieldType, returnType, nextType } = iterationTypes;
            if (errorNode) getGlobalAwaitedSymbol(/*reportErrors*/ true);
            return createIterationTypes(getAwaitedType(yieldType, errorNode) || anyType, getAwaitedType(returnType, errorNode) || anyType, nextType);
        }
        function getIterationTypesOfIterableWorker(type, use, errorNode, errorOutputContainer) {
            if (isTypeAny(type)) return anyIterationTypes;
            let noCache = false;
            if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                const iterationTypes = getIterationTypesOfIterableCached(type, asyncIterationTypesResolver) || getIterationTypesOfIterableFast(type, asyncIterationTypesResolver);
                if (iterationTypes) {
                    if (iterationTypes === noIterationTypes && errorNode) noCache = true;
                    else return use & 8 /* ForOfFlag */  ? getAsyncFromSyncIterationTypes(iterationTypes, errorNode) : iterationTypes;
                }
            }
            if (use & 1 /* AllowsSyncIterablesFlag */ ) {
                let iterationTypes = getIterationTypesOfIterableCached(type, syncIterationTypesResolver) || getIterationTypesOfIterableFast(type, syncIterationTypesResolver);
                if (iterationTypes) {
                    if (iterationTypes === noIterationTypes && errorNode) noCache = true;
                    else {
                        if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                            if (iterationTypes !== noIterationTypes) {
                                iterationTypes = getAsyncFromSyncIterationTypes(iterationTypes, errorNode);
                                return noCache ? iterationTypes : setCachedIterationTypes(type, "iterationTypesOfAsyncIterable", iterationTypes);
                            }
                        } else return iterationTypes;
                    }
                }
            }
            if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                const iterationTypes = getIterationTypesOfIterableSlow(type, asyncIterationTypesResolver, errorNode, errorOutputContainer, noCache);
                if (iterationTypes !== noIterationTypes) return iterationTypes;
            }
            if (use & 1 /* AllowsSyncIterablesFlag */ ) {
                let iterationTypes = getIterationTypesOfIterableSlow(type, syncIterationTypesResolver, errorNode, errorOutputContainer, noCache);
                if (iterationTypes !== noIterationTypes) {
                    if (use & 2 /* AllowsAsyncIterablesFlag */ ) {
                        iterationTypes = getAsyncFromSyncIterationTypes(iterationTypes, errorNode);
                        return noCache ? iterationTypes : setCachedIterationTypes(type, "iterationTypesOfAsyncIterable", iterationTypes);
                    } else return iterationTypes;
                }
            }
            return noIterationTypes;
        }
        function getIterationTypesOfIterableCached(type, resolver) {
            return getCachedIterationTypes(type, resolver.iterableCacheKey);
        }
        function getIterationTypesOfIterableFast(type, resolver) {
            if (isReferenceToType2(type, resolver.getGlobalIterableType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalIteratorObjectType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalIterableIteratorType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalGeneratorType(/*reportErrors*/ false))) {
                const [yieldType, returnType, nextType] = getTypeArguments(type);
                return setCachedIterationTypes(type, resolver.iterableCacheKey, createIterationTypes(resolver.resolveIterationType(yieldType, /*errorNode*/ void 0) || yieldType, resolver.resolveIterationType(returnType, /*errorNode*/ void 0) || returnType, nextType));
            }
            if (isReferenceToSomeType(type, resolver.getGlobalBuiltinIteratorTypes())) {
                const [yieldType] = getTypeArguments(type);
                const returnType = getBuiltinIteratorReturnType();
                const nextType = unknownType;
                return setCachedIterationTypes(type, resolver.iterableCacheKey, createIterationTypes(resolver.resolveIterationType(yieldType, /*errorNode*/ void 0) || yieldType, resolver.resolveIterationType(returnType, /*errorNode*/ void 0) || returnType, nextType));
            }
        }
        function getPropertyNameForKnownSymbolName(symbolName2) {
            const ctorType = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ false);
            const uniqueType = ctorType && getTypeOfPropertyOfType(getTypeOfSymbol(ctorType), escapeLeadingUnderscores(symbolName2));
            return uniqueType && isTypeUsableAsPropertyName(uniqueType) ? getPropertyNameFromType(uniqueType) : `__@${symbolName2}`;
        }
        function getIterationTypesOfIterableSlow(type, resolver, errorNode, errorOutputContainer, noCache) {
            const method = getPropertyOfType(type, getPropertyNameForKnownSymbolName(resolver.iteratorSymbolName));
            const methodType = method && !(method.flags & 16777216 /* Optional */ ) ? getTypeOfSymbol(method) : void 0;
            if (isTypeAny(methodType)) return noCache ? anyIterationTypes : setCachedIterationTypes(type, resolver.iterableCacheKey, anyIterationTypes);
            const allSignatures = methodType ? getSignaturesOfType(methodType, 0 /* Call */ ) : void 0;
            const validSignatures = filter(allSignatures, (sig)=>getMinArgumentCount(sig) === 0);
            if (!some(validSignatures)) {
                if (errorNode && some(allSignatures)) checkTypeAssignableTo(type, resolver.getGlobalIterableType(/*reportErrors*/ true), errorNode, /*headMessage*/ void 0, /*containingMessageChain*/ void 0, errorOutputContainer);
                return noCache ? noIterationTypes : setCachedIterationTypes(type, resolver.iterableCacheKey, noIterationTypes);
            }
            const iteratorType = getIntersectionType(map(validSignatures, getReturnTypeOfSignature));
            var _getIterationTypesOfIteratorWorker;
            const iterationTypes = (_getIterationTypesOfIteratorWorker = getIterationTypesOfIteratorWorker(iteratorType, resolver, errorNode, errorOutputContainer, noCache)) !== null && _getIterationTypesOfIteratorWorker !== void 0 ? _getIterationTypesOfIteratorWorker : noIterationTypes;
            return noCache ? iterationTypes : setCachedIterationTypes(type, resolver.iterableCacheKey, iterationTypes);
        }
        function reportTypeNotIterableError(errorNode, type, allowAsyncIterables) {
            const message = allowAsyncIterables ? Diagnostics.Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator : Diagnostics.Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator;
            const suggestAwait = // for (const x of Promise<...>) or [...Promise<...>]
            !!getAwaitedTypeOfPromise(type) || !allowAsyncIterables && isForOfStatement(errorNode.parent) && errorNode.parent.expression === errorNode && getGlobalAsyncIterableType(/*reportErrors*/ false) !== emptyGenericType && isTypeAssignableTo(type, createTypeFromGenericGlobalType(getGlobalAsyncIterableType(/*reportErrors*/ false), [
                anyType,
                anyType,
                anyType
            ]));
            return errorAndMaybeSuggestAwait(errorNode, suggestAwait, message, typeToString(type));
        }
        function getIterationTypesOfIterator(type, resolver, errorNode, errorOutputContainer) {
            return getIterationTypesOfIteratorWorker(type, resolver, errorNode, errorOutputContainer, /*noCache*/ false);
        }
        function getIterationTypesOfIteratorWorker(type, resolver, errorNode, errorOutputContainer, noCache) {
            if (isTypeAny(type)) return anyIterationTypes;
            let iterationTypes = getIterationTypesOfIteratorCached(type, resolver) || getIterationTypesOfIteratorFast(type, resolver);
            if (iterationTypes === noIterationTypes && errorNode) {
                iterationTypes = void 0;
                noCache = true;
            }
            iterationTypes !== null && iterationTypes !== void 0 ? iterationTypes : iterationTypes = getIterationTypesOfIteratorSlow(type, resolver, errorNode, errorOutputContainer, noCache);
            return iterationTypes === noIterationTypes ? void 0 : iterationTypes;
        }
        function getIterationTypesOfIteratorCached(type, resolver) {
            return getCachedIterationTypes(type, resolver.iteratorCacheKey);
        }
        function getIterationTypesOfIteratorFast(type, resolver) {
            if (isReferenceToType2(type, resolver.getGlobalIterableIteratorType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalIteratorType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalIteratorObjectType(/*reportErrors*/ false)) || isReferenceToType2(type, resolver.getGlobalGeneratorType(/*reportErrors*/ false))) {
                const [yieldType, returnType, nextType] = getTypeArguments(type);
                return setCachedIterationTypes(type, resolver.iteratorCacheKey, createIterationTypes(yieldType, returnType, nextType));
            }
            if (isReferenceToSomeType(type, resolver.getGlobalBuiltinIteratorTypes())) {
                const [yieldType] = getTypeArguments(type);
                const returnType = getBuiltinIteratorReturnType();
                const nextType = unknownType;
                return setCachedIterationTypes(type, resolver.iteratorCacheKey, createIterationTypes(yieldType, returnType, nextType));
            }
        }
        function isIteratorResult(type, kind) {
            const doneType = getTypeOfPropertyOfType(type, "done") || falseType;
            return isTypeAssignableTo(kind === 0 /* Yield */  ? falseType : trueType, doneType);
        }
        function isYieldIteratorResult(type) {
            return isIteratorResult(type, 0 /* Yield */ );
        }
        function isReturnIteratorResult(type) {
            return isIteratorResult(type, 1 /* Return */ );
        }
        function getIterationTypesOfIteratorResult(type) {
            if (isTypeAny(type)) return anyIterationTypes;
            const cachedTypes2 = getCachedIterationTypes(type, "iterationTypesOfIteratorResult");
            if (cachedTypes2) return cachedTypes2;
            if (isReferenceToType2(type, getGlobalIteratorYieldResultType(/*reportErrors*/ false))) {
                const yieldType2 = getTypeArguments(type)[0];
                return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", createIterationTypes(yieldType2, /*returnType*/ void 0, /*nextType*/ void 0));
            }
            if (isReferenceToType2(type, getGlobalIteratorReturnResultType(/*reportErrors*/ false))) {
                const returnType2 = getTypeArguments(type)[0];
                return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", createIterationTypes(/*yieldType*/ void 0, returnType2, /*nextType*/ void 0));
            }
            const yieldIteratorResult = filterType(type, isYieldIteratorResult);
            const yieldType = yieldIteratorResult !== neverType ? getTypeOfPropertyOfType(yieldIteratorResult, "value") : void 0;
            const returnIteratorResult = filterType(type, isReturnIteratorResult);
            const returnType = returnIteratorResult !== neverType ? getTypeOfPropertyOfType(returnIteratorResult, "value") : void 0;
            if (!yieldType && !returnType) return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", noIterationTypes);
            return setCachedIterationTypes(type, "iterationTypesOfIteratorResult", createIterationTypes(yieldType, returnType || voidType, /*nextType*/ void 0));
        }
        function getIterationTypesOfMethod(type, resolver, methodName, errorNode, errorOutputContainer) {
            var _a, _b, _c, _d;
            const method = getPropertyOfType(type, methodName);
            if (!method && methodName !== "next") return void 0;
            const methodType = method && !(methodName === "next" && method.flags & 16777216 /* Optional */ ) ? methodName === "next" ? getTypeOfSymbol(method) : getTypeWithFacts(getTypeOfSymbol(method), 2097152 /* NEUndefinedOrNull */ ) : void 0;
            if (isTypeAny(methodType)) return anyIterationTypes;
            const methodSignatures = methodType ? getSignaturesOfType(methodType, 0 /* Call */ ) : emptyArray;
            if (methodSignatures.length === 0) {
                if (errorNode) {
                    const diagnostic = methodName === "next" ? resolver.mustHaveANextMethodDiagnostic : resolver.mustBeAMethodDiagnostic;
                    if (errorOutputContainer) {
                        var _errorOutputContainer_errors;
                        (_errorOutputContainer_errors = errorOutputContainer.errors) !== null && _errorOutputContainer_errors !== void 0 ? _errorOutputContainer_errors : errorOutputContainer.errors = [];
                        errorOutputContainer.errors.push(createDiagnosticForNode(errorNode, diagnostic, methodName));
                    } else error2(errorNode, diagnostic, methodName);
                }
                return methodName === "next" ? noIterationTypes : void 0;
            }
            if ((methodType == null ? void 0 : methodType.symbol) && methodSignatures.length === 1) {
                const globalGeneratorType = resolver.getGlobalGeneratorType(/*reportErrors*/ false);
                const globalIteratorType = resolver.getGlobalIteratorType(/*reportErrors*/ false);
                const isGeneratorMethod = ((_b = (_a = globalGeneratorType.symbol) == null ? void 0 : _a.members) == null ? void 0 : _b.get(methodName)) === methodType.symbol;
                const isIteratorMethod = !isGeneratorMethod && ((_d = (_c = globalIteratorType.symbol) == null ? void 0 : _c.members) == null ? void 0 : _d.get(methodName)) === methodType.symbol;
                if (isGeneratorMethod || isIteratorMethod) {
                    const globalType = isGeneratorMethod ? globalGeneratorType : globalIteratorType;
                    const { mapper } = methodType;
                    return createIterationTypes(getMappedType(globalType.typeParameters[0], mapper), getMappedType(globalType.typeParameters[1], mapper), methodName === "next" ? getMappedType(globalType.typeParameters[2], mapper) : void 0);
                }
            }
            let methodParameterTypes;
            let methodReturnTypes;
            for (const signature of methodSignatures){
                if (methodName !== "throw" && some(signature.parameters)) methodParameterTypes = append(methodParameterTypes, getTypeAtPosition(signature, 0));
                methodReturnTypes = append(methodReturnTypes, getReturnTypeOfSignature(signature));
            }
            let returnTypes;
            let nextType;
            if (methodName !== "throw") {
                const methodParameterType = methodParameterTypes ? getUnionType(methodParameterTypes) : unknownType;
                if (methodName === "next") nextType = methodParameterType;
                else if (methodName === "return") {
                    const resolvedMethodParameterType = resolver.resolveIterationType(methodParameterType, errorNode) || anyType;
                    returnTypes = append(returnTypes, resolvedMethodParameterType);
                }
            }
            let yieldType;
            const methodReturnType = methodReturnTypes ? getIntersectionType(methodReturnTypes) : neverType;
            const resolvedMethodReturnType = resolver.resolveIterationType(methodReturnType, errorNode) || anyType;
            const iterationTypes = getIterationTypesOfIteratorResult(resolvedMethodReturnType);
            if (iterationTypes === noIterationTypes) {
                if (errorNode) {
                    if (errorOutputContainer) {
                        var _errorOutputContainer_errors1;
                        (_errorOutputContainer_errors1 = errorOutputContainer.errors) !== null && _errorOutputContainer_errors1 !== void 0 ? _errorOutputContainer_errors1 : errorOutputContainer.errors = [];
                        errorOutputContainer.errors.push(createDiagnosticForNode(errorNode, resolver.mustHaveAValueDiagnostic, methodName));
                    } else error2(errorNode, resolver.mustHaveAValueDiagnostic, methodName);
                }
                yieldType = anyType;
                returnTypes = append(returnTypes, anyType);
            } else {
                yieldType = iterationTypes.yieldType;
                returnTypes = append(returnTypes, iterationTypes.returnType);
            }
            return createIterationTypes(yieldType, getUnionType(returnTypes), nextType);
        }
        function getIterationTypesOfIteratorSlow(type, resolver, errorNode, errorOutputContainer, noCache) {
            const iterationTypes = combineIterationTypes([
                getIterationTypesOfMethod(type, resolver, "next", errorNode, errorOutputContainer),
                getIterationTypesOfMethod(type, resolver, "return", errorNode, errorOutputContainer),
                getIterationTypesOfMethod(type, resolver, "throw", errorNode, errorOutputContainer)
            ]);
            return noCache ? iterationTypes : setCachedIterationTypes(type, resolver.iteratorCacheKey, iterationTypes);
        }
        function getIterationTypeOfGeneratorFunctionReturnType(kind, returnType, isAsyncGenerator) {
            if (isTypeAny(returnType)) return void 0;
            const iterationTypes = getIterationTypesOfGeneratorFunctionReturnType(returnType, isAsyncGenerator);
            return iterationTypes && iterationTypes[getIterationTypesKeyFromIterationTypeKind(kind)];
        }
        function getIterationTypesOfGeneratorFunctionReturnType(type, isAsyncGenerator) {
            if (isTypeAny(type)) return anyIterationTypes;
            const use = isAsyncGenerator ? 2 /* AsyncGeneratorReturnType */  : 1 /* GeneratorReturnType */ ;
            const resolver = isAsyncGenerator ? asyncIterationTypesResolver : syncIterationTypesResolver;
            return getIterationTypesOfIterable(type, use, /*errorNode*/ void 0) || getIterationTypesOfIterator(type, resolver, /*errorNode*/ void 0, /*errorOutputContainer*/ void 0);
        }
        function checkBreakOrContinueStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) checkGrammarBreakOrContinueStatement(node);
        }
        function unwrapReturnType(returnType, functionFlags) {
            const isGenerator = !!(functionFlags & 1 /* Generator */ );
            const isAsync = !!(functionFlags & 2 /* Async */ );
            if (isGenerator) {
                const returnIterationType = getIterationTypeOfGeneratorFunctionReturnType(1 /* Return */ , returnType, isAsync);
                if (!returnIterationType) return errorType;
                return isAsync ? getAwaitedTypeNoAlias(unwrapAwaitedType(returnIterationType)) : returnIterationType;
            }
            return isAsync ? getAwaitedTypeNoAlias(returnType) || errorType : returnType;
        }
        function isUnwrappedReturnTypeUndefinedVoidOrAny(func, returnType) {
            const type = unwrapReturnType(returnType, getFunctionFlags(func));
            return !!(type && (maybeTypeOfKind(type, 16384 /* Void */ ) || type.flags & 32769 /* Undefined */ ));
        }
        function checkReturnStatement(node) {
            if (checkGrammarStatementInAmbientContext(node)) return;
            const container = getContainingFunctionOrClassStaticBlock(node);
            if (container && isClassStaticBlockDeclaration(container)) {
                grammarErrorOnFirstToken(node, Diagnostics.A_return_statement_cannot_be_used_inside_a_class_static_block);
                return;
            }
            if (!container) {
                grammarErrorOnFirstToken(node, Diagnostics.A_return_statement_can_only_be_used_within_a_function_body);
                return;
            }
            const signature = getSignatureFromDeclaration(container);
            const returnType = getReturnTypeOfSignature(signature);
            if (strictNullChecks || node.expression || returnType.flags & 131072 /* Never */ ) {
                const exprType = node.expression ? checkExpressionCached(node.expression) : undefinedType;
                if (container.kind === 179 /* SetAccessor */ ) {
                    if (node.expression) error2(node, Diagnostics.Setters_cannot_return_a_value);
                } else if (container.kind === 177 /* Constructor */ ) {
                    const exprType2 = node.expression ? checkExpressionCached(node.expression) : undefinedType;
                    if (node.expression && !checkTypeAssignableToAndOptionallyElaborate(exprType2, returnType, node, node.expression)) error2(node, Diagnostics.Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class);
                } else if (getReturnTypeFromAnnotation(container)) {
                    var _unwrapReturnType;
                    const unwrappedReturnType = (_unwrapReturnType = unwrapReturnType(returnType, getFunctionFlags(container))) !== null && _unwrapReturnType !== void 0 ? _unwrapReturnType : returnType;
                    checkReturnExpression(container, unwrappedReturnType, node, node.expression, exprType);
                }
            } else if (container.kind !== 177 /* Constructor */  && compilerOptions.noImplicitReturns && !isUnwrappedReturnTypeUndefinedVoidOrAny(container, returnType)) error2(node, Diagnostics.Not_all_code_paths_return_a_value);
        }
        function checkReturnExpression(container, unwrappedReturnType, node, expr, exprType, inConditionalExpression = false) {
            const excludeJSDocTypeAssertions = isInJSFile(node);
            const functionFlags = getFunctionFlags(container);
            if (expr) {
                const unwrappedExpr = skipParentheses(expr, excludeJSDocTypeAssertions);
                if (isConditionalExpression(unwrappedExpr)) {
                    checkReturnExpression(container, unwrappedReturnType, node, unwrappedExpr.whenTrue, checkExpression(unwrappedExpr.whenTrue), /*inConditionalExpression*/ true);
                    checkReturnExpression(container, unwrappedReturnType, node, unwrappedExpr.whenFalse, checkExpression(unwrappedExpr.whenFalse), /*inConditionalExpression*/ true);
                    return;
                }
            }
            const inReturnStatement = node.kind === 254 /* ReturnStatement */ ;
            const unwrappedExprType = functionFlags & 2 /* Async */  ? checkAwaitedType(exprType, /*withAlias*/ false, node, Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member) : exprType;
            const effectiveExpr = expr && getEffectiveCheckNode(expr);
            const errorNode = inReturnStatement && !inConditionalExpression ? node : effectiveExpr;
            checkTypeAssignableToAndOptionallyElaborate(unwrappedExprType, unwrappedReturnType, errorNode, effectiveExpr);
        }
        function checkWithStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) {
                if (node.flags & 65536 /* AwaitContext */ ) grammarErrorOnFirstToken(node, Diagnostics.with_statements_are_not_allowed_in_an_async_function_block);
            }
            checkExpression(node.expression);
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                const start = getSpanOfTokenAtPosition(sourceFile, node.pos).start;
                const end = node.statement.pos;
                grammarErrorAtPos(sourceFile, start, end - start, Diagnostics.The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any);
            }
        }
        function checkSwitchStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            let firstDefaultClause;
            let hasDuplicateDefaultClause = false;
            const expressionType = checkExpression(node.expression);
            forEach(node.caseBlock.clauses, (clause)=>{
                if (clause.kind === 298 /* DefaultClause */  && !hasDuplicateDefaultClause) {
                    if (firstDefaultClause === void 0) firstDefaultClause = clause;
                    else {
                        grammarErrorOnNode(clause, Diagnostics.A_default_clause_cannot_appear_more_than_once_in_a_switch_statement);
                        hasDuplicateDefaultClause = true;
                    }
                }
                if (clause.kind === 297 /* CaseClause */ ) addLazyDiagnostic(createLazyCaseClauseDiagnostics(clause));
                forEach(clause.statements, checkSourceElement);
                if (compilerOptions.noFallthroughCasesInSwitch && clause.fallthroughFlowNode && isReachableFlowNode(clause.fallthroughFlowNode)) error2(clause, Diagnostics.Fallthrough_case_in_switch);
                function createLazyCaseClauseDiagnostics(clause2) {
                    return ()=>{
                        const caseType = checkExpression(clause2.expression);
                        if (!isTypeEqualityComparableTo(expressionType, caseType)) checkTypeComparableTo(caseType, expressionType, clause2.expression, /*headMessage*/ void 0);
                    };
                }
            });
            if (node.caseBlock.locals) registerForUnusedIdentifiersCheck(node.caseBlock);
        }
        function checkLabeledStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) findAncestor(node.parent, (current)=>{
                if (isFunctionLike(current)) return "quit";
                if (current.kind === 257 /* LabeledStatement */  && current.label.escapedText === node.label.escapedText) {
                    grammarErrorOnNode(node.label, Diagnostics.Duplicate_label_0, getTextOfNode(node.label));
                    return true;
                }
                return false;
            });
            checkSourceElement(node.statement);
        }
        function checkThrowStatement(node) {
            if (!checkGrammarStatementInAmbientContext(node)) {
                if (isIdentifier(node.expression) && !node.expression.escapedText) grammarErrorAfterFirstToken(node, Diagnostics.Line_break_not_permitted_here);
            }
            if (node.expression) checkExpression(node.expression);
        }
        function checkTryStatement(node) {
            checkGrammarStatementInAmbientContext(node);
            checkBlock(node.tryBlock);
            const catchClause = node.catchClause;
            if (catchClause) {
                if (catchClause.variableDeclaration) {
                    const declaration = catchClause.variableDeclaration;
                    checkVariableLikeDeclaration(declaration);
                    const typeNode = getEffectiveTypeAnnotationNode(declaration);
                    if (typeNode) {
                        const type = getTypeFromTypeNode(typeNode);
                        if (type && !(type.flags & 3 /* AnyOrUnknown */ )) grammarErrorOnFirstToken(typeNode, Diagnostics.Catch_clause_variable_type_annotation_must_be_any_or_unknown_if_specified);
                    } else if (declaration.initializer) grammarErrorOnFirstToken(declaration.initializer, Diagnostics.Catch_clause_variable_cannot_have_an_initializer);
                    else {
                        const blockLocals = catchClause.block.locals;
                        if (blockLocals) forEachKey(catchClause.locals, (caughtName)=>{
                            const blockLocal = blockLocals.get(caughtName);
                            if ((blockLocal == null ? void 0 : blockLocal.valueDeclaration) && (blockLocal.flags & 2 /* BlockScopedVariable */ ) !== 0) grammarErrorOnNode(blockLocal.valueDeclaration, Diagnostics.Cannot_redeclare_identifier_0_in_catch_clause, unescapeLeadingUnderscores(caughtName));
                        });
                    }
                }
                checkBlock(catchClause.block);
            }
            if (node.finallyBlock) checkBlock(node.finallyBlock);
        }
        function checkIndexConstraints(type, symbol, isStaticIndex) {
            const indexInfos = getIndexInfosOfType(type);
            if (indexInfos.length === 0) return;
            for (const prop of getPropertiesOfObjectType(type))if (!(isStaticIndex && prop.flags & 4194304 /* Prototype */ )) checkIndexConstraintForProperty(type, prop, getLiteralTypeFromProperty(prop, 8576 /* StringOrNumberLiteralOrUnique */ , /*includeNonPublic*/ true), getNonMissingTypeOfSymbol(prop));
            const typeDeclaration = symbol.valueDeclaration;
            if (typeDeclaration && isClassLike(typeDeclaration)) {
                for (const member of typeDeclaration.members)if ((!isStaticIndex && !isStatic(member) || isStaticIndex && isStatic(member)) && !hasBindableName(member)) {
                    const symbol2 = getSymbolOfDeclaration(member);
                    checkIndexConstraintForProperty(type, symbol2, getTypeOfExpression(member.name.expression), getNonMissingTypeOfSymbol(symbol2));
                }
            }
            if (indexInfos.length > 1) for (const info of indexInfos)checkIndexConstraintForIndexSignature(type, info);
        }
        function checkIndexConstraintForProperty(type, prop, propNameType, propType) {
            const declaration = prop.valueDeclaration;
            const name = getNameOfDeclaration(declaration);
            if (name && isPrivateIdentifier(name)) return;
            const indexInfos = getApplicableIndexInfos(type, propNameType);
            const interfaceDeclaration = getObjectFlags(type) & 2 /* Interface */  ? getDeclarationOfKind(type.symbol, 265 /* InterfaceDeclaration */ ) : void 0;
            const propDeclaration = declaration && declaration.kind === 227 /* BinaryExpression */  || name && name.kind === 168 /* ComputedPropertyName */  ? declaration : void 0;
            const localPropDeclaration = getParentOfSymbol(prop) === type.symbol ? declaration : void 0;
            for (const info of indexInfos){
                const localIndexDeclaration = info.declaration && getParentOfSymbol(getSymbolOfDeclaration(info.declaration)) === type.symbol ? info.declaration : void 0;
                const errorNode = localPropDeclaration || localIndexDeclaration || (interfaceDeclaration && !some(getBaseTypes(type), (base)=>!!getPropertyOfObjectType(base, prop.escapedName) && !!getIndexTypeOfType(base, info.keyType)) ? interfaceDeclaration : void 0);
                if (errorNode && !isTypeAssignableTo(propType, info.type)) {
                    const diagnostic = createError(errorNode, Diagnostics.Property_0_of_type_1_is_not_assignable_to_2_index_type_3, symbolToString(prop), typeToString(propType), typeToString(info.keyType), typeToString(info.type));
                    if (propDeclaration && errorNode !== propDeclaration) addRelatedInfo(diagnostic, createDiagnosticForNode(propDeclaration, Diagnostics._0_is_declared_here, symbolToString(prop)));
                    diagnostics.add(diagnostic);
                }
            }
        }
        function checkIndexConstraintForIndexSignature(type, checkInfo) {
            const declaration = checkInfo.declaration;
            const indexInfos = getApplicableIndexInfos(type, checkInfo.keyType);
            const interfaceDeclaration = getObjectFlags(type) & 2 /* Interface */  ? getDeclarationOfKind(type.symbol, 265 /* InterfaceDeclaration */ ) : void 0;
            const localCheckDeclaration = declaration && getParentOfSymbol(getSymbolOfDeclaration(declaration)) === type.symbol ? declaration : void 0;
            for (const info of indexInfos){
                if (info === checkInfo) continue;
                const localIndexDeclaration = info.declaration && getParentOfSymbol(getSymbolOfDeclaration(info.declaration)) === type.symbol ? info.declaration : void 0;
                const errorNode = localCheckDeclaration || localIndexDeclaration || (interfaceDeclaration && !some(getBaseTypes(type), (base)=>!!getIndexInfoOfType(base, checkInfo.keyType) && !!getIndexTypeOfType(base, info.keyType)) ? interfaceDeclaration : void 0);
                if (errorNode && !isTypeAssignableTo(checkInfo.type, info.type)) error2(errorNode, Diagnostics._0_index_type_1_is_not_assignable_to_2_index_type_3, typeToString(checkInfo.keyType), typeToString(checkInfo.type), typeToString(info.keyType), typeToString(info.type));
            }
        }
        function checkTypeNameIsReserved(name, message) {
            switch(name.escapedText){
                case "any":
                case "unknown":
                case "never":
                case "number":
                case "bigint":
                case "boolean":
                case "string":
                case "symbol":
                case "void":
                case "object":
                case "undefined":
                    error2(name, message, name.escapedText);
            }
        }
        function checkClassNameCollisionWithObject(name) {
            if (languageVersion >= 1 /* ES5 */  && name.escapedText === "Object" && host.getEmitModuleFormatOfFile(getSourceFileOfNode(name)) < 5 /* ES2015 */ ) error2(name, Diagnostics.Class_name_cannot_be_Object_when_targeting_ES5_and_above_with_module_0, ModuleKind[moduleKind]);
        }
        function checkUnmatchedJSDocParameters(node) {
            const jsdocParameters = filter(getJSDocTags(node), isJSDocParameterTag);
            if (!length(jsdocParameters)) return;
            const isJs = isInJSFile(node);
            const parameters = /* @__PURE__ */ new Set();
            const excludedParameters = /* @__PURE__ */ new Set();
            forEach(node.parameters, ({ name }, index)=>{
                if (isIdentifier(name)) parameters.add(name.escapedText);
                if (isBindingPattern(name)) excludedParameters.add(index);
            });
            const containsArguments = containsArgumentsReference(node);
            if (containsArguments) {
                const lastJSDocParamIndex = jsdocParameters.length - 1;
                const lastJSDocParam = jsdocParameters[lastJSDocParamIndex];
                if (isJs && lastJSDocParam && isIdentifier(lastJSDocParam.name) && lastJSDocParam.typeExpression && lastJSDocParam.typeExpression.type && !parameters.has(lastJSDocParam.name.escapedText) && !excludedParameters.has(lastJSDocParamIndex) && !isArrayType(getTypeFromTypeNode(lastJSDocParam.typeExpression.type))) error2(lastJSDocParam.name, Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_had_an_array_type, idText(lastJSDocParam.name));
            } else forEach(jsdocParameters, ({ name, isNameFirst }, index)=>{
                if (excludedParameters.has(index) || isIdentifier(name) && parameters.has(name.escapedText)) return;
                if (isQualifiedName(name)) {
                    if (isJs) error2(name, Diagnostics.Qualified_name_0_is_not_allowed_without_a_leading_param_object_1, entityNameToString(name), entityNameToString(name.left));
                } else if (!isNameFirst) errorOrSuggestion(isJs, name, Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name, idText(name));
            });
        }
        function checkTypeParameters(typeParameterDeclarations) {
            let seenDefault = false;
            if (typeParameterDeclarations) for(let i = 0; i < typeParameterDeclarations.length; i++){
                const node = typeParameterDeclarations[i];
                checkTypeParameter(node);
                addLazyDiagnostic(createCheckTypeParameterDiagnostic(node, i));
            }
            function createCheckTypeParameterDiagnostic(node, i) {
                return ()=>{
                    if (node.default) {
                        seenDefault = true;
                        checkTypeParametersNotReferenced(node.default, typeParameterDeclarations, i);
                    } else if (seenDefault) error2(node, Diagnostics.Required_type_parameters_may_not_follow_optional_type_parameters);
                    for(let j = 0; j < i; j++)if (typeParameterDeclarations[j].symbol === node.symbol) error2(node.name, Diagnostics.Duplicate_identifier_0, declarationNameToString(node.name));
                };
            }
        }
        function checkTypeParametersNotReferenced(root, typeParameters, index) {
            visit(root);
            function visit(node) {
                if (node.kind === 184 /* TypeReference */ ) {
                    const type = getTypeFromTypeReference(node);
                    if (type.flags & 262144 /* TypeParameter */ ) {
                        for(let i = index; i < typeParameters.length; i++)if (type.symbol === getSymbolOfDeclaration(typeParameters[i])) error2(node, Diagnostics.Type_parameter_defaults_can_only_reference_previously_declared_type_parameters);
                    }
                }
                forEachChild(node, visit);
            }
        }
        function checkTypeParameterListsIdentical(symbol) {
            if (symbol.declarations && symbol.declarations.length === 1) return;
            const links = getSymbolLinks(symbol);
            if (!links.typeParametersChecked) {
                links.typeParametersChecked = true;
                const declarations = getClassOrInterfaceDeclarationsOfSymbol(symbol);
                if (!declarations || declarations.length <= 1) return;
                const type = getDeclaredTypeOfSymbol(symbol);
                if (!areTypeParametersIdentical(declarations, type.localTypeParameters, getEffectiveTypeParameterDeclarations)) {
                    const name = symbolToString(symbol);
                    for (const declaration of declarations)error2(declaration.name, Diagnostics.All_declarations_of_0_must_have_identical_type_parameters, name);
                }
            }
        }
        function areTypeParametersIdentical(declarations, targetParameters, getTypeParameterDeclarations) {
            const maxTypeArgumentCount = length(targetParameters);
            const minTypeArgumentCount = getMinTypeArgumentCount(targetParameters);
            for (const declaration of declarations){
                const sourceParameters = getTypeParameterDeclarations(declaration);
                const numTypeParameters = sourceParameters.length;
                if (numTypeParameters < minTypeArgumentCount || numTypeParameters > maxTypeArgumentCount) return false;
                for(let i = 0; i < numTypeParameters; i++){
                    const source = sourceParameters[i];
                    const target = targetParameters[i];
                    if (source.name.escapedText !== target.symbol.escapedName) return false;
                    const constraint = getEffectiveConstraintOfTypeParameter(source);
                    const sourceConstraint = constraint && getTypeFromTypeNode(constraint);
                    const targetConstraint = getConstraintOfTypeParameter(target);
                    if (sourceConstraint && targetConstraint && !isTypeIdenticalTo(sourceConstraint, targetConstraint)) return false;
                    const sourceDefault = source.default && getTypeFromTypeNode(source.default);
                    const targetDefault = getDefaultFromTypeParameter(target);
                    if (sourceDefault && targetDefault && !isTypeIdenticalTo(sourceDefault, targetDefault)) return false;
                }
            }
            return true;
        }
        function getFirstTransformableStaticClassElement(node) {
            const willTransformStaticElementsOfDecoratedClass = !legacyDecorators && languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators && classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node);
            const willTransformPrivateElementsOrClassStaticBlocks = languageVersion < LanguageFeatureMinimumTarget.PrivateNamesAndClassStaticBlocks || languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators;
            const willTransformInitializers = !emitStandardClassFields;
            if (willTransformStaticElementsOfDecoratedClass || willTransformPrivateElementsOrClassStaticBlocks) for (const member of node.members){
                var _firstOrUndefined;
                if (willTransformStaticElementsOfDecoratedClass && classElementOrClassElementParameterIsDecorated(/*useLegacyDecorators*/ false, member, node)) return (_firstOrUndefined = firstOrUndefined(getDecorators(node))) !== null && _firstOrUndefined !== void 0 ? _firstOrUndefined : node;
                else if (willTransformPrivateElementsOrClassStaticBlocks) {
                    if (isClassStaticBlockDeclaration(member)) return member;
                    else if (isStatic(member)) {
                        if (isPrivateIdentifierClassElementDeclaration(member) || willTransformInitializers && isInitializedProperty(member)) return member;
                    }
                }
            }
        }
        function checkClassExpressionExternalHelpers(node) {
            if (node.name) return;
            const parent2 = walkUpOuterExpressions(node);
            if (!isNamedEvaluationSource(parent2)) return;
            const willTransformESDecorators = !legacyDecorators && languageVersion < LanguageFeatureMinimumTarget.ClassAndClassElementDecorators;
            let location;
            var _firstOrUndefined;
            if (willTransformESDecorators && classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node)) location = (_firstOrUndefined = firstOrUndefined(getDecorators(node))) !== null && _firstOrUndefined !== void 0 ? _firstOrUndefined : node;
            else location = getFirstTransformableStaticClassElement(node);
            if (location) {
                checkExternalEmitHelpers(location, 4194304 /* SetFunctionName */ );
                if ((isPropertyAssignment(parent2) || isPropertyDeclaration(parent2) || isBindingElement(parent2)) && isComputedPropertyName(parent2.name)) checkExternalEmitHelpers(location, 8388608 /* PropKey */ );
            }
        }
        function checkClassExpression(node) {
            checkClassLikeDeclaration(node);
            checkNodeDeferred(node);
            checkClassExpressionExternalHelpers(node);
            return getTypeOfSymbol(getSymbolOfDeclaration(node));
        }
        function checkClassExpressionDeferred(node) {
            forEach(node.members, checkSourceElement);
            registerForUnusedIdentifiersCheck(node);
        }
        function checkClassDeclaration(node) {
            const firstDecorator = find(node.modifiers, isDecorator);
            if (legacyDecorators && firstDecorator && some(node.members, (p)=>hasStaticModifier(p) && isPrivateIdentifierClassElementDeclaration(p))) grammarErrorOnNode(firstDecorator, Diagnostics.Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_decorator);
            if (!node.name && !hasSyntacticModifier(node, 2048 /* Default */ )) grammarErrorOnFirstToken(node, Diagnostics.A_class_declaration_without_the_default_modifier_must_have_a_name);
            checkClassLikeDeclaration(node);
            forEach(node.members, checkSourceElement);
            registerForUnusedIdentifiersCheck(node);
        }
        function checkClassLikeDeclaration(node) {
            checkGrammarClassLikeDeclaration(node);
            checkDecorators(node);
            checkCollisionsForDeclarationName(node, node.name);
            checkTypeParameters(getEffectiveTypeParameterDeclarations(node));
            checkExportsOnMergedDeclarations(node);
            const symbol = getSymbolOfDeclaration(node);
            const type = getDeclaredTypeOfSymbol(symbol);
            const typeWithThis = getTypeWithThisArgument(type);
            const staticType = getTypeOfSymbol(symbol);
            checkTypeParameterListsIdentical(symbol);
            checkFunctionOrConstructorSymbol(symbol);
            checkClassForDuplicateDeclarations(node);
            const nodeInAmbientContext = !!(node.flags & 33554432 /* Ambient */ );
            if (!nodeInAmbientContext) checkClassForStaticPropertyNameConflicts(node);
            const baseTypeNode = getEffectiveBaseTypeNode(node);
            if (baseTypeNode) {
                forEach(baseTypeNode.typeArguments, checkSourceElement);
                if (languageVersion < LanguageFeatureMinimumTarget.Classes) checkExternalEmitHelpers(baseTypeNode.parent, 1 /* Extends */ );
                const extendsNode = getClassExtendsHeritageElement(node);
                if (extendsNode && extendsNode !== baseTypeNode) checkExpression(extendsNode.expression);
                const baseTypes = getBaseTypes(type);
                if (baseTypes.length) addLazyDiagnostic(()=>{
                    const baseType = baseTypes[0];
                    const baseConstructorType = getBaseConstructorTypeOfClass(type);
                    const staticBaseType = getApparentType(baseConstructorType);
                    checkBaseTypeAccessibility(staticBaseType, baseTypeNode);
                    checkSourceElement(baseTypeNode.expression);
                    if (some(baseTypeNode.typeArguments)) {
                        forEach(baseTypeNode.typeArguments, checkSourceElement);
                        for (const constructor of getConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode)){
                            if (!checkTypeArgumentConstraints(baseTypeNode, constructor.typeParameters)) break;
                        }
                    }
                    const baseWithThis = getTypeWithThisArgument(baseType, type.thisType);
                    if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ void 0)) issueMemberSpecificError(node, typeWithThis, baseWithThis, Diagnostics.Class_0_incorrectly_extends_base_class_1);
                    else checkTypeAssignableTo(staticType, getTypeWithoutSignatures(staticBaseType), node.name || node, Diagnostics.Class_static_side_0_incorrectly_extends_base_class_static_side_1);
                    if (baseConstructorType.flags & 8650752 /* TypeVariable */ ) {
                        if (!isMixinConstructorType(staticType)) error2(node.name || node, Diagnostics.A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any);
                        else {
                            const constructSignatures = getSignaturesOfType(baseConstructorType, 1 /* Construct */ );
                            if (constructSignatures.some((signature)=>signature.flags & 4 /* Abstract */ ) && !hasSyntacticModifier(node, 64 /* Abstract */ )) error2(node.name || node, Diagnostics.A_mixin_class_that_extends_from_a_type_variable_containing_an_abstract_construct_signature_must_also_be_declared_abstract);
                        }
                    }
                    if (!(staticBaseType.symbol && staticBaseType.symbol.flags & 32 /* Class */ ) && !(baseConstructorType.flags & 8650752 /* TypeVariable */ )) {
                        const constructors = getInstantiatedConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode);
                        if (forEach(constructors, (sig)=>!isJSConstructor(sig.declaration) && !isTypeIdenticalTo(getReturnTypeOfSignature(sig), baseType))) error2(baseTypeNode.expression, Diagnostics.Base_constructors_must_all_have_the_same_return_type);
                    }
                    checkKindsOfPropertyMemberOverrides(type, baseType);
                });
            }
            checkMembersForOverrideModifier(node, type, typeWithThis, staticType);
            const implementedTypeNodes = getEffectiveImplementsTypeNodes(node);
            if (implementedTypeNodes) for (const typeRefNode of implementedTypeNodes){
                if (!isEntityNameExpression(typeRefNode.expression) || isOptionalChain(typeRefNode.expression)) error2(typeRefNode.expression, Diagnostics.A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments);
                checkTypeReferenceNode(typeRefNode);
                addLazyDiagnostic(createImplementsDiagnostics(typeRefNode));
            }
            addLazyDiagnostic(()=>{
                checkIndexConstraints(type, symbol);
                checkIndexConstraints(staticType, symbol, /*isStaticIndex*/ true);
                checkTypeForDuplicateIndexSignatures(node);
                checkPropertyInitialization(node);
            });
            function createImplementsDiagnostics(typeRefNode) {
                return ()=>{
                    const t = getReducedType(getTypeFromTypeNode(typeRefNode));
                    if (!isErrorType(t)) {
                        if (isValidBaseType(t)) {
                            const genericDiag = t.symbol && t.symbol.flags & 32 /* Class */  ? Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass : Diagnostics.Class_0_incorrectly_implements_interface_1;
                            const baseWithThis = getTypeWithThisArgument(t, type.thisType);
                            if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ void 0)) issueMemberSpecificError(node, typeWithThis, baseWithThis, genericDiag);
                        } else error2(typeRefNode, Diagnostics.A_class_can_only_implement_an_object_type_or_intersection_of_object_types_with_statically_known_members);
                    }
                };
            }
        }
        function checkMembersForOverrideModifier(node, type, typeWithThis, staticType) {
            const baseTypeNode = getEffectiveBaseTypeNode(node);
            const baseTypes = baseTypeNode && getBaseTypes(type);
            const baseWithThis = (baseTypes == null ? void 0 : baseTypes.length) ? getTypeWithThisArgument(first(baseTypes), type.thisType) : void 0;
            const baseStaticType = getBaseConstructorTypeOfClass(type);
            for (const member of node.members){
                if (hasAmbientModifier(member)) continue;
                if (isConstructorDeclaration(member)) forEach(member.parameters, (param)=>{
                    if (isParameterPropertyDeclaration(param, member)) checkExistingMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, param, /*memberIsParameterProperty*/ true);
                });
                checkExistingMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, member, /*memberIsParameterProperty*/ false);
            }
        }
        function checkExistingMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, member, memberIsParameterProperty, reportErrors2 = true) {
            const declaredProp = member.name && getSymbolAtLocation(member.name) || getSymbolAtLocation(member);
            if (!declaredProp) return 0 /* Ok */ ;
            return checkMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, hasOverrideModifier(member), hasAbstractModifier(member), isStatic(member), memberIsParameterProperty, declaredProp, reportErrors2 ? member : void 0);
        }
        function checkMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, memberHasOverrideModifier, memberHasAbstractModifier, memberIsStatic, memberIsParameterProperty, member, errorNode) {
            const isJs = isInJSFile(node);
            const nodeInAmbientContext = !!(node.flags & 33554432 /* Ambient */ );
            if (memberHasOverrideModifier && (member == null ? void 0 : member.valueDeclaration) && isClassElement(member.valueDeclaration) && member.valueDeclaration.name && isNonBindableDynamicName(member.valueDeclaration.name)) {
                error2(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_name_is_dynamic : Diagnostics.This_member_cannot_have_an_override_modifier_because_its_name_is_dynamic);
                return 2 /* HasInvalidOverride */ ;
            }
            if (baseWithThis && (memberHasOverrideModifier || compilerOptions.noImplicitOverride)) {
                const thisType = memberIsStatic ? staticType : typeWithThis;
                const baseType = memberIsStatic ? baseStaticType : baseWithThis;
                const prop = getPropertyOfType(thisType, member.escapedName);
                const baseProp = getPropertyOfType(baseType, member.escapedName);
                const baseClassName = typeToString(baseWithThis);
                if (prop && !baseProp && memberHasOverrideModifier) {
                    if (errorNode) {
                        const suggestion = getSuggestedSymbolForNonexistentClassMember(symbolName(member), baseType);
                        suggestion ? error2(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1 : Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1, baseClassName, symbolToString(suggestion)) : error2(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0 : Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0, baseClassName);
                    }
                    return 2 /* HasInvalidOverride */ ;
                } else if (prop && (baseProp == null ? void 0 : baseProp.declarations) && compilerOptions.noImplicitOverride && !nodeInAmbientContext) {
                    const baseHasAbstract = some(baseProp.declarations, hasAbstractModifier);
                    if (memberHasOverrideModifier) return 0 /* Ok */ ;
                    if (!baseHasAbstract) {
                        if (errorNode) {
                            const diag2 = memberIsParameterProperty ? isJs ? Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0 : Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0 : isJs ? Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0 : Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0;
                            error2(errorNode, diag2, baseClassName);
                        }
                        return 1 /* NeedsOverride */ ;
                    } else if (memberHasAbstractModifier && baseHasAbstract) {
                        if (errorNode) error2(errorNode, Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0, baseClassName);
                        return 1 /* NeedsOverride */ ;
                    }
                }
            } else if (memberHasOverrideModifier) {
                if (errorNode) {
                    const className = typeToString(type);
                    error2(errorNode, isJs ? Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class : Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class, className);
                }
                return 2 /* HasInvalidOverride */ ;
            }
            return 0 /* Ok */ ;
        }
        function issueMemberSpecificError(node, typeWithThis, baseWithThis, broadDiag) {
            let issuedMemberError = false;
            for (const member of node.members){
                if (isStatic(member)) continue;
                const declaredProp = member.name && getSymbolAtLocation(member.name) || getSymbolAtLocation(member);
                if (declaredProp) {
                    const prop = getPropertyOfType(typeWithThis, declaredProp.escapedName);
                    const baseProp = getPropertyOfType(baseWithThis, declaredProp.escapedName);
                    if (prop && baseProp) {
                        const rootChain = ()=>chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2, symbolToString(declaredProp), typeToString(typeWithThis), typeToString(baseWithThis));
                        if (!checkTypeAssignableTo(getTypeOfSymbol(prop), getTypeOfSymbol(baseProp), member.name || member, /*headMessage*/ void 0, rootChain)) issuedMemberError = true;
                    }
                }
            }
            if (!issuedMemberError) checkTypeAssignableTo(typeWithThis, baseWithThis, node.name || node, broadDiag);
        }
        function checkBaseTypeAccessibility(type, node) {
            const signatures = getSignaturesOfType(type, 1 /* Construct */ );
            if (signatures.length) {
                const declaration = signatures[0].declaration;
                if (declaration && hasEffectiveModifier(declaration, 2 /* Private */ )) {
                    const typeClassDeclaration = getClassLikeDeclarationOfSymbol(type.symbol);
                    if (!isNodeWithinClass(node, typeClassDeclaration)) error2(node, Diagnostics.Cannot_extend_a_class_0_Class_constructor_is_marked_as_private, getFullyQualifiedName(type.symbol));
                }
            }
        }
        function getMemberOverrideModifierStatus(node, member, memberSymbol) {
            if (!member.name) return 0 /* Ok */ ;
            const classSymbol = getSymbolOfDeclaration(node);
            const type = getDeclaredTypeOfSymbol(classSymbol);
            const typeWithThis = getTypeWithThisArgument(type);
            const staticType = getTypeOfSymbol(classSymbol);
            const baseTypeNode = getEffectiveBaseTypeNode(node);
            const baseTypes = baseTypeNode && getBaseTypes(type);
            const baseWithThis = (baseTypes == null ? void 0 : baseTypes.length) ? getTypeWithThisArgument(first(baseTypes), type.thisType) : void 0;
            const baseStaticType = getBaseConstructorTypeOfClass(type);
            const memberHasOverrideModifier = member.parent ? hasOverrideModifier(member) : hasSyntacticModifier(member, 16 /* Override */ );
            return checkMemberForOverrideModifier(node, staticType, baseStaticType, baseWithThis, type, typeWithThis, memberHasOverrideModifier, hasAbstractModifier(member), isStatic(member), /*memberIsParameterProperty*/ false, memberSymbol);
        }
        function getTargetSymbol(s) {
            return getCheckFlags(s) & 1 /* Instantiated */  ? s.links.target : s;
        }
        function getClassOrInterfaceDeclarationsOfSymbol(symbol) {
            return filter(symbol.declarations, (d)=>d.kind === 264 /* ClassDeclaration */  || d.kind === 265 /* InterfaceDeclaration */ );
        }
        function checkKindsOfPropertyMemberOverrides(type, baseType) {
            var _a, _b, _c, _d, _e;
            const baseProperties = getPropertiesOfType(baseType);
            const notImplementedInfo = /* @__PURE__ */ new Map();
            basePropertyCheck: for (const baseProperty of baseProperties){
                const base = getTargetSymbol(baseProperty);
                if (base.flags & 4194304 /* Prototype */ ) continue;
                const baseSymbol = getPropertyOfObjectType(type, base.escapedName);
                if (!baseSymbol) continue;
                const derived = getTargetSymbol(baseSymbol);
                const baseDeclarationFlags = getDeclarationModifierFlagsFromSymbol(base);
                Debug.assert(!!derived, "derived should point to something, even if it is the base class' declaration.");
                if (derived === base) {
                    const derivedClassDecl = getClassLikeDeclarationOfSymbol(type.symbol);
                    if (baseDeclarationFlags & 64 /* Abstract */  && (!derivedClassDecl || !hasSyntacticModifier(derivedClassDecl, 64 /* Abstract */ ))) {
                        for (const otherBaseType of getBaseTypes(type)){
                            if (otherBaseType === baseType) continue;
                            const baseSymbol2 = getPropertyOfObjectType(otherBaseType, base.escapedName);
                            const derivedElsewhere = baseSymbol2 && getTargetSymbol(baseSymbol2);
                            if (derivedElsewhere && derivedElsewhere !== base) continue basePropertyCheck;
                        }
                        const baseTypeName = typeToString(baseType);
                        const typeName = typeToString(type);
                        const basePropertyName = symbolToString(baseProperty);
                        const missedProperties = append((_a = notImplementedInfo.get(derivedClassDecl)) == null ? void 0 : _a.missedProperties, basePropertyName);
                        notImplementedInfo.set(derivedClassDecl, {
                            baseTypeName,
                            typeName,
                            missedProperties
                        });
                    }
                } else {
                    const derivedDeclarationFlags = getDeclarationModifierFlagsFromSymbol(derived);
                    if (baseDeclarationFlags & 2 /* Private */  || derivedDeclarationFlags & 2 /* Private */ ) continue;
                    let errorMessage;
                    const basePropertyFlags = base.flags & 98308 /* PropertyOrAccessor */ ;
                    const derivedPropertyFlags = derived.flags & 98308 /* PropertyOrAccessor */ ;
                    if (basePropertyFlags && derivedPropertyFlags) {
                        if ((getCheckFlags(base) & 6 /* Synthetic */  ? (_b = base.declarations) == null ? void 0 : _b.some((d)=>isPropertyAbstractOrInterface(d, baseDeclarationFlags)) : (_c = base.declarations) == null ? void 0 : _c.every((d)=>isPropertyAbstractOrInterface(d, baseDeclarationFlags))) || getCheckFlags(base) & 262144 /* Mapped */  || derived.valueDeclaration && isBinaryExpression(derived.valueDeclaration)) continue;
                        const overriddenInstanceProperty = basePropertyFlags !== 4 /* Property */  && derivedPropertyFlags === 4 /* Property */ ;
                        const overriddenInstanceAccessor = basePropertyFlags === 4 /* Property */  && derivedPropertyFlags !== 4 /* Property */ ;
                        if (overriddenInstanceProperty || overriddenInstanceAccessor) {
                            const errorMessage2 = overriddenInstanceProperty ? Diagnostics._0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property : Diagnostics._0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor;
                            error2(getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage2, symbolToString(base), typeToString(baseType), typeToString(type));
                        } else if (useDefineForClassFields) {
                            const uninitialized = (_d = derived.declarations) == null ? void 0 : _d.find((d)=>d.kind === 173 /* PropertyDeclaration */  && !d.initializer);
                            if (uninitialized && !(derived.flags & 33554432 /* Transient */ ) && !(baseDeclarationFlags & 64 /* Abstract */ ) && !(derivedDeclarationFlags & 64 /* Abstract */ ) && !((_e = derived.declarations) == null ? void 0 : _e.some((d)=>!!(d.flags & 33554432 /* Ambient */ )))) {
                                const constructor = findConstructorDeclaration(getClassLikeDeclarationOfSymbol(type.symbol));
                                const propName = uninitialized.name;
                                if (uninitialized.exclamationToken || !constructor || !isIdentifier(propName) || !strictNullChecks || !isPropertyInitializedInConstructor(propName, type, constructor)) {
                                    const errorMessage2 = Diagnostics.Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_add_a_declare_modifier_or_remove_the_redundant_declaration;
                                    error2(getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage2, symbolToString(base), typeToString(baseType));
                                }
                            }
                        }
                        continue;
                    } else if (isPrototypeProperty(base)) {
                        if (isPrototypeProperty(derived) || derived.flags & 4 /* Property */ ) continue;
                        else {
                            Debug.assert(!!(derived.flags & 98304 /* Accessor */ ));
                            errorMessage = Diagnostics.Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor;
                        }
                    } else if (base.flags & 98304 /* Accessor */ ) errorMessage = Diagnostics.Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function;
                    else errorMessage = Diagnostics.Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function;
                    error2(getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage, typeToString(baseType), symbolToString(base), typeToString(type));
                }
            }
            for (const [errorNode, memberInfo] of notImplementedInfo){
                if (length(memberInfo.missedProperties) === 1) {
                    if (isClassExpression(errorNode)) error2(errorNode, Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1, first(memberInfo.missedProperties), memberInfo.baseTypeName);
                    else error2(errorNode, Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2, memberInfo.typeName, first(memberInfo.missedProperties), memberInfo.baseTypeName);
                } else if (length(memberInfo.missedProperties) > 5) {
                    const missedProperties = map(memberInfo.missedProperties.slice(0, 4), (prop)=>`'${prop}'`).join(", ");
                    const remainingMissedProperties = length(memberInfo.missedProperties) - 4;
                    if (isClassExpression(errorNode)) error2(errorNode, Diagnostics.Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1_and_2_more, memberInfo.baseTypeName, missedProperties, remainingMissedProperties);
                    else error2(errorNode, Diagnostics.Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2_and_3_more, memberInfo.typeName, memberInfo.baseTypeName, missedProperties, remainingMissedProperties);
                } else {
                    const missedProperties = map(memberInfo.missedProperties, (prop)=>`'${prop}'`).join(", ");
                    if (isClassExpression(errorNode)) error2(errorNode, Diagnostics.Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1, memberInfo.baseTypeName, missedProperties);
                    else error2(errorNode, Diagnostics.Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2, memberInfo.typeName, memberInfo.baseTypeName, missedProperties);
                }
            }
        }
        function isPropertyAbstractOrInterface(declaration, baseDeclarationFlags) {
            return baseDeclarationFlags & 64 /* Abstract */  && (!isPropertyDeclaration(declaration) || !declaration.initializer) || isInterfaceDeclaration(declaration.parent);
        }
        function getNonInheritedProperties(type, baseTypes, properties) {
            if (!length(baseTypes)) return properties;
            const seen = /* @__PURE__ */ new Map();
            forEach(properties, (p)=>{
                seen.set(p.escapedName, p);
            });
            for (const base of baseTypes){
                const properties2 = getPropertiesOfType(getTypeWithThisArgument(base, type.thisType));
                for (const prop of properties2){
                    const existing = seen.get(prop.escapedName);
                    if (existing && prop.parent === existing.parent) seen.delete(prop.escapedName);
                }
            }
            return arrayFrom(seen.values());
        }
        function checkInheritedPropertiesAreIdentical(type, typeNode) {
            const baseTypes = getBaseTypes(type);
            if (baseTypes.length < 2) return true;
            const seen = /* @__PURE__ */ new Map();
            forEach(resolveDeclaredMembers(type).declaredProperties, (p)=>{
                seen.set(p.escapedName, {
                    prop: p,
                    containingType: type
                });
            });
            let ok = true;
            for (const base of baseTypes){
                const properties = getPropertiesOfType(getTypeWithThisArgument(base, type.thisType));
                for (const prop of properties){
                    const existing = seen.get(prop.escapedName);
                    if (!existing) seen.set(prop.escapedName, {
                        prop,
                        containingType: base
                    });
                    else {
                        const isInheritedProperty = existing.containingType !== type;
                        if (isInheritedProperty && !isPropertyIdenticalTo(existing.prop, prop)) {
                            ok = false;
                            const typeName1 = typeToString(existing.containingType);
                            const typeName2 = typeToString(base);
                            let errorInfo = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Named_property_0_of_types_1_and_2_are_not_identical, symbolToString(prop), typeName1, typeName2);
                            errorInfo = chainDiagnosticMessages(errorInfo, Diagnostics.Interface_0_cannot_simultaneously_extend_types_1_and_2, typeToString(type), typeName1, typeName2);
                            diagnostics.add(createDiagnosticForNodeFromMessageChain(getSourceFileOfNode(typeNode), typeNode, errorInfo));
                        }
                    }
                }
            }
            return ok;
        }
        function checkPropertyInitialization(node) {
            if (!strictNullChecks || !strictPropertyInitialization || node.flags & 33554432 /* Ambient */ ) return;
            const constructor = findConstructorDeclaration(node);
            for (const member of node.members){
                if (getEffectiveModifierFlags(member) & 128 /* Ambient */ ) continue;
                if (!isStatic(member) && isPropertyWithoutInitializer(member)) {
                    const propName = member.name;
                    if (isIdentifier(propName) || isPrivateIdentifier(propName) || isComputedPropertyName(propName)) {
                        const type = getTypeOfSymbol(getSymbolOfDeclaration(member));
                        if (!(type.flags & 3 /* AnyOrUnknown */  || containsUndefinedType(type))) {
                            if (!constructor || !isPropertyInitializedInConstructor(propName, type, constructor)) error2(member.name, Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor, declarationNameToString(propName));
                        }
                    }
                }
            }
        }
        function isPropertyWithoutInitializer(node) {
            return node.kind === 173 /* PropertyDeclaration */  && !hasAbstractModifier(node) && !node.exclamationToken && !node.initializer;
        }
        function isPropertyInitializedInStaticBlocks(propName, propType, staticBlocks, startPos, endPos) {
            for (const staticBlock of staticBlocks)if (staticBlock.pos >= startPos && staticBlock.pos <= endPos) {
                const reference = factory.createPropertyAccessExpression(factory.createThis(), propName);
                setParent(reference.expression, reference);
                setParent(reference, staticBlock);
                reference.flowNode = staticBlock.returnFlowNode;
                const flowType = getFlowTypeOfReference(reference, propType, getOptionalType(propType));
                if (!containsUndefinedType(flowType)) return true;
            }
            return false;
        }
        function isPropertyInitializedInConstructor(propName, propType, constructor) {
            const reference = isComputedPropertyName(propName) ? factory.createElementAccessExpression(factory.createThis(), propName.expression) : factory.createPropertyAccessExpression(factory.createThis(), propName);
            setParent(reference.expression, reference);
            setParent(reference, constructor);
            reference.flowNode = constructor.returnFlowNode;
            const flowType = getFlowTypeOfReference(reference, propType, getOptionalType(propType));
            return !containsUndefinedType(flowType);
        }
        function checkInterfaceDeclaration(node) {
            if (!checkGrammarModifiers(node)) checkGrammarInterfaceDeclaration(node);
            if (!allowBlockDeclarations(node.parent)) grammarErrorOnNode(node, Diagnostics._0_declarations_can_only_be_declared_inside_a_block, "interface");
            checkTypeParameters(node.typeParameters);
            addLazyDiagnostic(()=>{
                checkTypeNameIsReserved(node.name, Diagnostics.Interface_name_cannot_be_0);
                checkExportsOnMergedDeclarations(node);
                const symbol = getSymbolOfDeclaration(node);
                checkTypeParameterListsIdentical(symbol);
                const firstInterfaceDecl = getDeclarationOfKind(symbol, 265 /* InterfaceDeclaration */ );
                if (node === firstInterfaceDecl) {
                    const type = getDeclaredTypeOfSymbol(symbol);
                    const typeWithThis = getTypeWithThisArgument(type);
                    if (checkInheritedPropertiesAreIdentical(type, node.name)) {
                        for (const baseType of getBaseTypes(type))checkTypeAssignableTo(typeWithThis, getTypeWithThisArgument(baseType, type.thisType), node.name, Diagnostics.Interface_0_incorrectly_extends_interface_1);
                        checkIndexConstraints(type, symbol);
                    }
                }
                checkObjectTypeForDuplicateDeclarations(node);
            });
            forEach(getInterfaceBaseTypeNodes(node), (heritageElement)=>{
                if (!isEntityNameExpression(heritageElement.expression) || isOptionalChain(heritageElement.expression)) error2(heritageElement.expression, Diagnostics.An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments);
                checkTypeReferenceNode(heritageElement);
            });
            forEach(node.members, checkSourceElement);
            addLazyDiagnostic(()=>{
                checkTypeForDuplicateIndexSignatures(node);
                registerForUnusedIdentifiersCheck(node);
            });
        }
        function checkTypeAliasDeclaration(node) {
            checkGrammarModifiers(node);
            checkTypeNameIsReserved(node.name, Diagnostics.Type_alias_name_cannot_be_0);
            if (!allowBlockDeclarations(node.parent)) grammarErrorOnNode(node, Diagnostics._0_declarations_can_only_be_declared_inside_a_block, "type");
            checkExportsOnMergedDeclarations(node);
            checkTypeParameters(node.typeParameters);
            if (node.type.kind === 141 /* IntrinsicKeyword */ ) {
                const typeParameterCount = length(node.typeParameters);
                const valid = typeParameterCount === 0 ? node.name.escapedText === "BuiltinIteratorReturn" : typeParameterCount === 1 && intrinsicTypeKinds.has(node.name.escapedText);
                if (!valid) error2(node.type, Diagnostics.The_intrinsic_keyword_can_only_be_used_to_declare_compiler_provided_intrinsic_types);
            } else {
                checkSourceElement(node.type);
                registerForUnusedIdentifiersCheck(node);
            }
        }
        function computeEnumMemberValues(node) {
            const nodeLinks2 = getNodeLinks(node);
            if (!(nodeLinks2.flags & 1024 /* EnumValuesComputed */ )) {
                nodeLinks2.flags |= 1024 /* EnumValuesComputed */ ;
                let autoValue = 0;
                let previous;
                for (const member of node.members){
                    const result = computeEnumMemberValue(member, autoValue, previous);
                    getNodeLinks(member).enumMemberValue = result;
                    autoValue = typeof result.value === "number" ? result.value + 1 : void 0;
                    previous = member;
                }
            }
        }
        function computeEnumMemberValue(member, autoValue, previous) {
            if (isComputedNonLiteralName(member.name)) error2(member.name, Diagnostics.Computed_property_names_are_not_allowed_in_enums);
            else if (isBigIntLiteral(member.name)) error2(member.name, Diagnostics.An_enum_member_cannot_have_a_numeric_name);
            else {
                const text = getTextOfPropertyName(member.name);
                if (isNumericLiteralName(text) && !isInfinityOrNaNString(text)) error2(member.name, Diagnostics.An_enum_member_cannot_have_a_numeric_name);
            }
            if (member.initializer) return computeConstantEnumMemberValue(member);
            if (member.parent.flags & 33554432 /* Ambient */  && !isEnumConst(member.parent)) return evaluatorResult(/*value*/ void 0);
            if (autoValue === void 0) {
                error2(member.name, Diagnostics.Enum_member_must_have_initializer);
                return evaluatorResult(/*value*/ void 0);
            }
            if (getIsolatedModules(compilerOptions) && (previous == null ? void 0 : previous.initializer)) {
                const prevValue = getEnumMemberValue(previous);
                if (!(typeof prevValue.value === "number" && !prevValue.resolvedOtherFiles)) error2(member.name, Diagnostics.Enum_member_following_a_non_literal_numeric_member_must_have_an_initializer_when_isolatedModules_is_enabled);
            }
            return evaluatorResult(autoValue);
        }
        function computeConstantEnumMemberValue(member) {
            const isConstEnum = isEnumConst(member.parent);
            const initializer = member.initializer;
            const result = evaluate(initializer, member);
            if (result.value !== void 0) {
                if (isConstEnum && typeof result.value === "number" && !isFinite(result.value)) error2(initializer, isNaN(result.value) ? Diagnostics.const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN : Diagnostics.const_enum_member_initializer_was_evaluated_to_a_non_finite_value);
                else if (getIsolatedModules(compilerOptions) && typeof result.value === "string" && !result.isSyntacticallyString) error2(initializer, Diagnostics._0_has_a_string_type_but_must_have_syntactically_recognizable_string_syntax_when_isolatedModules_is_enabled, `${idText(member.parent.name)}.${getTextOfPropertyName(member.name)}`);
            } else if (isConstEnum) error2(initializer, Diagnostics.const_enum_member_initializers_must_be_constant_expressions);
            else if (member.parent.flags & 33554432 /* Ambient */ ) error2(initializer, Diagnostics.In_ambient_enum_declarations_member_initializer_must_be_constant_expression);
            else checkTypeAssignableTo(checkExpression(initializer), numberType, initializer, Diagnostics.Type_0_is_not_assignable_to_type_1_as_required_for_computed_enum_member_values);
            return result;
        }
        function evaluateEntityNameExpression(expr, location) {
            const symbol = resolveEntityName(expr, 111551 /* Value */ , /*ignoreErrors*/ true);
            if (!symbol) return evaluatorResult(/*value*/ void 0);
            if (expr.kind === 80 /* Identifier */ ) {
                const identifier = expr;
                if (isInfinityOrNaNString(identifier.escapedText) && symbol === getGlobalSymbol(identifier.escapedText, 111551 /* Value */ , /*diagnostic*/ void 0)) return evaluatorResult(+identifier.escapedText, /*isSyntacticallyString*/ false);
            }
            if (symbol.flags & 8 /* EnumMember */ ) return location ? evaluateEnumMember(expr, symbol, location) : getEnumMemberValue(symbol.valueDeclaration);
            if (isConstantVariable(symbol)) {
                const declaration = symbol.valueDeclaration;
                if (declaration && isVariableDeclaration(declaration) && !declaration.type && declaration.initializer && (!location || declaration !== location && isBlockScopedNameDeclaredBeforeUse(declaration, location))) {
                    const result = evaluate(declaration.initializer, declaration);
                    if (location && getSourceFileOfNode(location) !== getSourceFileOfNode(declaration)) return evaluatorResult(result.value, /*isSyntacticallyString*/ false, /*resolvedOtherFiles*/ true, /*hasExternalReferences*/ true);
                    return evaluatorResult(result.value, result.isSyntacticallyString, result.resolvedOtherFiles, /*hasExternalReferences*/ true);
                }
            }
            return evaluatorResult(/*value*/ void 0);
        }
        function evaluateElementAccessExpression(expr, location) {
            const root = expr.expression;
            if (isEntityNameExpression(root) && isStringLiteralLike(expr.argumentExpression)) {
                const rootSymbol = resolveEntityName(root, 111551 /* Value */ , /*ignoreErrors*/ true);
                if (rootSymbol && rootSymbol.flags & 384 /* Enum */ ) {
                    const name = escapeLeadingUnderscores(expr.argumentExpression.text);
                    const member = rootSymbol.exports.get(name);
                    if (member) {
                        Debug.assert(getSourceFileOfNode(member.valueDeclaration) === getSourceFileOfNode(rootSymbol.valueDeclaration));
                        return location ? evaluateEnumMember(expr, member, location) : getEnumMemberValue(member.valueDeclaration);
                    }
                }
            }
            return evaluatorResult(/*value*/ void 0);
        }
        function evaluateEnumMember(expr, symbol, location) {
            const declaration = symbol.valueDeclaration;
            if (!declaration || declaration === location) {
                error2(expr, Diagnostics.Property_0_is_used_before_being_assigned, symbolToString(symbol));
                return evaluatorResult(/*value*/ void 0);
            }
            if (!isBlockScopedNameDeclaredBeforeUse(declaration, location)) {
                error2(expr, Diagnostics.A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums);
                return evaluatorResult(/*value*/ 0);
            }
            const value1 = getEnumMemberValue(declaration);
            if (location.parent !== declaration.parent) return evaluatorResult(value1.value, value1.isSyntacticallyString, value1.resolvedOtherFiles, /*hasExternalReferences*/ true);
            return value1;
        }
        function checkEnumDeclaration(node) {
            addLazyDiagnostic(()=>checkEnumDeclarationWorker(node));
        }
        function checkEnumDeclarationWorker(node) {
            checkGrammarModifiers(node);
            checkCollisionsForDeclarationName(node, node.name);
            checkExportsOnMergedDeclarations(node);
            node.members.forEach(checkSourceElement);
            if (compilerOptions.erasableSyntaxOnly && !(node.flags & 33554432 /* Ambient */ )) error2(node, Diagnostics.This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled);
            computeEnumMemberValues(node);
            const enumSymbol = getSymbolOfDeclaration(node);
            const firstDeclaration = getDeclarationOfKind(enumSymbol, node.kind);
            if (node === firstDeclaration) {
                if (enumSymbol.declarations && enumSymbol.declarations.length > 1) {
                    const enumIsConst = isEnumConst(node);
                    forEach(enumSymbol.declarations, (decl)=>{
                        if (isEnumDeclaration(decl) && isEnumConst(decl) !== enumIsConst) error2(getNameOfDeclaration(decl), Diagnostics.Enum_declarations_must_all_be_const_or_non_const);
                    });
                }
                let seenEnumMissingInitialInitializer = false;
                forEach(enumSymbol.declarations, (declaration)=>{
                    if (declaration.kind !== 267 /* EnumDeclaration */ ) return false;
                    const enumDeclaration = declaration;
                    if (!enumDeclaration.members.length) return false;
                    const firstEnumMember = enumDeclaration.members[0];
                    if (!firstEnumMember.initializer) {
                        if (seenEnumMissingInitialInitializer) error2(firstEnumMember.name, Diagnostics.In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element);
                        else seenEnumMissingInitialInitializer = true;
                    }
                });
            }
        }
        function checkEnumMember(node) {
            if (isPrivateIdentifier(node.name)) error2(node, Diagnostics.An_enum_member_cannot_be_named_with_a_private_identifier);
            if (node.initializer) checkExpression(node.initializer);
        }
        function getFirstNonAmbientClassOrFunctionDeclaration(symbol) {
            const declarations = symbol.declarations;
            if (declarations) for (const declaration of declarations){
                if ((declaration.kind === 264 /* ClassDeclaration */  || declaration.kind === 263 /* FunctionDeclaration */  && nodeIsPresent(declaration.body)) && !(declaration.flags & 33554432 /* Ambient */ )) return declaration;
            }
            return void 0;
        }
        function inSameLexicalScope(node1, node2) {
            const container1 = getEnclosingBlockScopeContainer(node1);
            const container2 = getEnclosingBlockScopeContainer(node2);
            if (isGlobalSourceFile(container1)) return isGlobalSourceFile(container2);
            else if (isGlobalSourceFile(container2)) return false;
            else return container1 === container2;
        }
        function checkModuleDeclaration(node) {
            if (node.body) {
                checkSourceElement(node.body);
                if (!isGlobalScopeAugmentation(node)) registerForUnusedIdentifiersCheck(node);
            }
            addLazyDiagnostic(checkModuleDeclarationDiagnostics);
            function checkModuleDeclarationDiagnostics() {
                var _a, _b;
                const isGlobalAugmentation = isGlobalScopeAugmentation(node);
                const inAmbientContext = node.flags & 33554432 /* Ambient */ ;
                if (isGlobalAugmentation && !inAmbientContext) error2(node.name, Diagnostics.Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context);
                const isAmbientExternalModule = isAmbientModule(node);
                const contextErrorMessage = isAmbientExternalModule ? Diagnostics.An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file : Diagnostics.A_namespace_declaration_is_only_allowed_at_the_top_level_of_a_namespace_or_module;
                if (checkGrammarModuleElementContext(node, contextErrorMessage)) return;
                if (!checkGrammarModifiers(node)) {
                    if (!inAmbientContext && node.name.kind === 11 /* StringLiteral */ ) grammarErrorOnNode(node.name, Diagnostics.Only_ambient_modules_can_use_quoted_names);
                }
                if (isIdentifier(node.name)) {
                    checkCollisionsForDeclarationName(node, node.name);
                    if (!(node.flags & 2080 /* GlobalAugmentation */ )) {
                        const sourceFile = getSourceFileOfNode(node);
                        const pos = getNonModifierTokenPosOfNode(node);
                        const span = getSpanOfTokenAtPosition(sourceFile, pos);
                        suggestionDiagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, Diagnostics.A_namespace_declaration_should_not_be_declared_using_the_module_keyword_Please_use_the_namespace_keyword_instead));
                    }
                }
                checkExportsOnMergedDeclarations(node);
                const symbol = getSymbolOfDeclaration(node);
                if (symbol.flags & 512 /* ValueModule */  && !inAmbientContext && isInstantiatedModule(node, shouldPreserveConstEnums(compilerOptions))) {
                    if (compilerOptions.erasableSyntaxOnly) error2(node.name, Diagnostics.This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled);
                    if (getIsolatedModules(compilerOptions) && !getSourceFileOfNode(node).externalModuleIndicator) error2(node.name, Diagnostics.Namespaces_are_not_allowed_in_global_script_files_when_0_is_enabled_If_this_file_is_not_intended_to_be_a_global_script_set_moduleDetection_to_force_or_add_an_empty_export_statement, isolatedModulesLikeFlagName);
                    if (((_a = symbol.declarations) == null ? void 0 : _a.length) > 1) {
                        const firstNonAmbientClassOrFunc = getFirstNonAmbientClassOrFunctionDeclaration(symbol);
                        if (firstNonAmbientClassOrFunc) {
                            if (getSourceFileOfNode(node) !== getSourceFileOfNode(firstNonAmbientClassOrFunc)) error2(node.name, Diagnostics.A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged);
                            else if (node.pos < firstNonAmbientClassOrFunc.pos) error2(node.name, Diagnostics.A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged);
                        }
                        const mergedClass = getDeclarationOfKind(symbol, 264 /* ClassDeclaration */ );
                        if (mergedClass && inSameLexicalScope(node, mergedClass)) getNodeLinks(node).flags |= 2048 /* LexicalModuleMergesWithClass */ ;
                    }
                    if (compilerOptions.verbatimModuleSyntax && node.parent.kind === 308 /* SourceFile */  && host.getEmitModuleFormatOfFile(node.parent) === 1 /* CommonJS */ ) {
                        const exportModifier = (_b = node.modifiers) == null ? void 0 : _b.find((m)=>m.kind === 95 /* ExportKeyword */ );
                        if (exportModifier) error2(exportModifier, Diagnostics.A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
                    }
                }
                if (isAmbientExternalModule) {
                    if (isExternalModuleAugmentation(node)) {
                        const checkBody = isGlobalAugmentation || getSymbolOfDeclaration(node).flags & 33554432 /* Transient */ ;
                        if (checkBody && node.body) for (const statement of node.body.statements)checkModuleAugmentationElement(statement, isGlobalAugmentation);
                    } else if (isGlobalSourceFile(node.parent)) {
                        if (isGlobalAugmentation) error2(node.name, Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
                        else if (isExternalModuleNameRelative(getTextOfIdentifierOrLiteral(node.name))) error2(node.name, Diagnostics.Ambient_module_declaration_cannot_specify_relative_module_name);
                    } else if (isGlobalAugmentation) error2(node.name, Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
                    else error2(node.name, Diagnostics.Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces);
                }
            }
        }
        function checkModuleAugmentationElement(node, isGlobalAugmentation) {
            switch(node.kind){
                case 244 /* VariableStatement */ :
                    for (const decl of node.declarationList.declarations)checkModuleAugmentationElement(decl, isGlobalAugmentation);
                    break;
                case 278 /* ExportAssignment */ :
                case 279 /* ExportDeclaration */ :
                    grammarErrorOnFirstToken(node, Diagnostics.Exports_and_export_assignments_are_not_permitted_in_module_augmentations);
                    break;
                case 272 /* ImportEqualsDeclaration */ :
                    if (isInternalModuleImportEqualsDeclaration(node)) break;
                // falls through
                case 273 /* ImportDeclaration */ :
                    grammarErrorOnFirstToken(node, Diagnostics.Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module);
                    break;
                case 209 /* BindingElement */ :
                case 261 /* VariableDeclaration */ :
                    const name = node.name;
                    if (isBindingPattern(name)) {
                        for (const el of name.elements)checkModuleAugmentationElement(el, isGlobalAugmentation);
                        break;
                    }
                // falls through
                case 264 /* ClassDeclaration */ :
                case 267 /* EnumDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                    if (isGlobalAugmentation) return;
                    break;
            }
        }
        function getFirstNonModuleExportsIdentifier(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return node;
                case 167 /* QualifiedName */ :
                    do node = node.left;
                    while (node.kind !== 80 /* Identifier */ );
                    return node;
                case 212 /* PropertyAccessExpression */ :
                    do {
                        if (isModuleExportsAccessExpression(node.expression) && !isPrivateIdentifier(node.name)) return node.name;
                        node = node.expression;
                    }while (node.kind !== 80 /* Identifier */ );
                    return node;
            }
        }
        function checkExternalImportOrExportDeclaration(node) {
            const moduleName = getExternalModuleName(node);
            if (!moduleName || nodeIsMissing(moduleName)) return false;
            if (!isStringLiteral(moduleName)) {
                error2(moduleName, Diagnostics.String_literal_expected);
                return false;
            }
            const inAmbientExternalModule = node.parent.kind === 269 /* ModuleBlock */  && isAmbientModule(node.parent.parent);
            if (node.parent.kind !== 308 /* SourceFile */  && !inAmbientExternalModule) {
                error2(moduleName, node.kind === 279 /* ExportDeclaration */  ? Diagnostics.Export_declarations_are_not_permitted_in_a_namespace : Diagnostics.Import_declarations_in_a_namespace_cannot_reference_a_module);
                return false;
            }
            if (inAmbientExternalModule && isExternalModuleNameRelative(moduleName.text)) {
                if (!isTopLevelInExternalModuleAugmentation(node)) {
                    error2(node, Diagnostics.Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name);
                    return false;
                }
            }
            if (!isImportEqualsDeclaration(node) && node.attributes) {
                const diagnostic = node.attributes.token === 118 /* WithKeyword */  ? Diagnostics.Import_attribute_values_must_be_string_literal_expressions : Diagnostics.Import_assertion_values_must_be_string_literal_expressions;
                let hasError = false;
                for (const attr of node.attributes.elements)if (!isStringLiteral(attr.value)) {
                    hasError = true;
                    error2(attr.value, diagnostic);
                }
                return !hasError;
            }
            return true;
        }
        function checkModuleExportName(name, allowStringLiteral = true) {
            if (name === void 0 || name.kind !== 11 /* StringLiteral */ ) return;
            if (!allowStringLiteral) grammarErrorOnNode(name, Diagnostics.Identifier_expected);
            else if (moduleKind === 5 /* ES2015 */  || moduleKind === 6 /* ES2020 */ ) grammarErrorOnNode(name, Diagnostics.String_literal_import_and_export_names_are_not_supported_when_the_module_flag_is_set_to_es2015_or_es2020);
        }
        function checkAliasSymbol(node) {
            var _a, _b, _c, _d, _e;
            let symbol = getSymbolOfDeclaration(node);
            const target = resolveAlias(symbol);
            if (target !== unknownSymbol) {
                symbol = getMergedSymbol(symbol.exportSymbol || symbol);
                if (isInJSFile(node) && !(target.flags & 111551 /* Value */ ) && !isTypeOnlyImportOrExportDeclaration(node)) {
                    const errorNode = isImportOrExportSpecifier(node) ? node.propertyName || node.name : isNamedDeclaration(node) ? node.name : node;
                    Debug.assert(node.kind !== 281 /* NamespaceExport */ );
                    if (node.kind === 282 /* ExportSpecifier */ ) {
                        const diag2 = error2(errorNode, Diagnostics.Types_cannot_appear_in_export_declarations_in_JavaScript_files);
                        const alreadyExportedSymbol = (_b = (_a = getSourceFileOfNode(node).symbol) == null ? void 0 : _a.exports) == null ? void 0 : _b.get(moduleExportNameTextEscaped(node.propertyName || node.name));
                        if (alreadyExportedSymbol === target) {
                            const exportingDeclaration = (_c = alreadyExportedSymbol.declarations) == null ? void 0 : _c.find(isJSDocNode);
                            if (exportingDeclaration) addRelatedInfo(diag2, createDiagnosticForNode(exportingDeclaration, Diagnostics._0_is_automatically_exported_here, unescapeLeadingUnderscores(alreadyExportedSymbol.escapedName)));
                        }
                    } else {
                        Debug.assert(node.kind !== 261 /* VariableDeclaration */ );
                        const importDeclaration = findAncestor(node, or(isImportDeclaration, isImportEqualsDeclaration));
                        var _ref;
                        const moduleSpecifier = (_ref = importDeclaration && ((_d = tryGetModuleSpecifierFromDeclaration(importDeclaration)) == null ? void 0 : _d.text)) !== null && _ref !== void 0 ? _ref : "...";
                        const importedIdentifier = unescapeLeadingUnderscores(isIdentifier(errorNode) ? errorNode.escapedText : symbol.escapedName);
                        error2(errorNode, Diagnostics._0_is_a_type_and_cannot_be_imported_in_JavaScript_files_Use_1_in_a_JSDoc_type_annotation, importedIdentifier, `import("${moduleSpecifier}").${importedIdentifier}`);
                    }
                    return;
                }
                const targetFlags = getSymbolFlags(target);
                const excludedMeanings = (symbol.flags & 1160127 /* ExportValue */  ? 111551 /* Value */  : 0) | (symbol.flags & 788968 /* Type */  ? 788968 /* Type */  : 0) | (symbol.flags & 1920 /* Namespace */  ? 1920 /* Namespace */  : 0);
                if (targetFlags & excludedMeanings) {
                    const message = node.kind === 282 /* ExportSpecifier */  ? Diagnostics.Export_declaration_conflicts_with_exported_declaration_of_0 : Diagnostics.Import_declaration_conflicts_with_local_declaration_of_0;
                    error2(node, message, symbolToString(symbol));
                } else if (node.kind !== 282 /* ExportSpecifier */ ) {
                    const appearsValueyToTranspiler = compilerOptions.isolatedModules && !findAncestor(node, isTypeOnlyImportOrExportDeclaration);
                    if (appearsValueyToTranspiler && symbol.flags & 1160127 /* ExportValue */ ) error2(node, Diagnostics.Import_0_conflicts_with_local_value_so_must_be_declared_with_a_type_only_import_when_isolatedModules_is_enabled, symbolToString(symbol), isolatedModulesLikeFlagName);
                }
                if (getIsolatedModules(compilerOptions) && !isTypeOnlyImportOrExportDeclaration(node) && !(node.flags & 33554432 /* Ambient */ )) {
                    const typeOnlyAlias = getTypeOnlyAliasDeclaration(symbol);
                    const isType = !(targetFlags & 111551 /* Value */ );
                    if (isType || typeOnlyAlias) switch(node.kind){
                        case 274 /* ImportClause */ :
                        case 277 /* ImportSpecifier */ :
                        case 272 /* ImportEqualsDeclaration */ :
                            if (compilerOptions.verbatimModuleSyntax) {
                                Debug.assertIsDefined(node.name, "An ImportClause with a symbol should have a name");
                                const message = compilerOptions.verbatimModuleSyntax && isInternalModuleImportEqualsDeclaration(node) ? Diagnostics.An_import_alias_cannot_resolve_to_a_type_or_type_only_declaration_when_verbatimModuleSyntax_is_enabled : isType ? Diagnostics._0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled : Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled;
                                const name = moduleExportNameTextUnescaped(node.kind === 277 /* ImportSpecifier */  ? node.propertyName || node.name : node.name);
                                addTypeOnlyDeclarationRelatedInfo(error2(node, message, name), isType ? void 0 : typeOnlyAlias, name);
                            }
                            if (isType && node.kind === 272 /* ImportEqualsDeclaration */  && hasEffectiveModifier(node, 32 /* Export */ )) error2(node, Diagnostics.Cannot_use_export_import_on_a_type_or_type_only_namespace_when_0_is_enabled, isolatedModulesLikeFlagName);
                            break;
                        case 282 /* ExportSpecifier */ :
                            if (compilerOptions.verbatimModuleSyntax || getSourceFileOfNode(typeOnlyAlias) !== getSourceFileOfNode(node)) {
                                const name = moduleExportNameTextUnescaped(node.propertyName || node.name);
                                const diagnostic = isType ? error2(node, Diagnostics.Re_exporting_a_type_when_0_is_enabled_requires_using_export_type, isolatedModulesLikeFlagName) : error2(node, Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_re_exported_using_a_type_only_re_export_when_1_is_enabled, name, isolatedModulesLikeFlagName);
                                addTypeOnlyDeclarationRelatedInfo(diagnostic, isType ? void 0 : typeOnlyAlias, name);
                                break;
                            }
                    }
                    if (compilerOptions.verbatimModuleSyntax && node.kind !== 272 /* ImportEqualsDeclaration */  && !isInJSFile(node) && host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) === 1 /* CommonJS */ ) error2(node, getVerbatimModuleSyntaxErrorMessage(node));
                    else if (moduleKind === 200 /* Preserve */  && node.kind !== 272 /* ImportEqualsDeclaration */  && node.kind !== 261 /* VariableDeclaration */  && host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) === 1 /* CommonJS */ ) error2(node, Diagnostics.ECMAScript_module_syntax_is_not_allowed_in_a_CommonJS_module_when_module_is_set_to_preserve);
                    if (compilerOptions.verbatimModuleSyntax && !isTypeOnlyImportOrExportDeclaration(node) && !(node.flags & 33554432 /* Ambient */ ) && targetFlags & 128 /* ConstEnum */ ) {
                        const constEnumDeclaration = target.valueDeclaration;
                        const redirect = (_e = host.getRedirectFromOutput(getSourceFileOfNode(constEnumDeclaration).resolvedPath)) == null ? void 0 : _e.resolvedRef;
                        if (constEnumDeclaration.flags & 33554432 /* Ambient */  && (!redirect || !shouldPreserveConstEnums(redirect.commandLine.options))) error2(node, Diagnostics.Cannot_access_ambient_const_enums_when_0_is_enabled, isolatedModulesLikeFlagName);
                    }
                }
                if (isImportSpecifier(node)) {
                    const targetSymbol = resolveAliasWithDeprecationCheck(symbol, node);
                    if (isDeprecatedSymbol(targetSymbol) && targetSymbol.declarations) addDeprecatedSuggestion(node, targetSymbol.declarations, targetSymbol.escapedName);
                }
            }
        }
        function resolveAliasWithDeprecationCheck(symbol, location) {
            if (!(symbol.flags & 2097152 /* Alias */ ) || isDeprecatedSymbol(symbol) || !getDeclarationOfAliasSymbol(symbol)) return symbol;
            const targetSymbol = resolveAlias(symbol);
            if (targetSymbol === unknownSymbol) return targetSymbol;
            while(symbol.flags & 2097152 /* Alias */ ){
                const target = getImmediateAliasedSymbol(symbol);
                if (target) {
                    if (target === targetSymbol) break;
                    if (target.declarations && length(target.declarations)) {
                        if (isDeprecatedSymbol(target)) {
                            addDeprecatedSuggestion(location, target.declarations, target.escapedName);
                            break;
                        } else {
                            if (symbol === targetSymbol) break;
                            symbol = target;
                        }
                    }
                } else break;
            }
            return targetSymbol;
        }
        function checkImportBinding(node) {
            checkCollisionsForDeclarationName(node, node.name);
            checkAliasSymbol(node);
            if (node.kind === 277 /* ImportSpecifier */ ) {
                checkModuleExportName(node.propertyName);
                if (moduleExportNameIsDefault(node.propertyName || node.name) && getESModuleInterop(compilerOptions) && host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) < 4 /* System */ ) checkExternalEmitHelpers(node, 131072 /* ImportDefault */ );
            }
        }
        function checkImportAttributes(declaration) {
            var _a;
            const node = declaration.attributes;
            if (node) {
                const importAttributesType = getGlobalImportAttributesType(/*reportErrors*/ true);
                if (importAttributesType !== emptyObjectType) checkTypeAssignableTo(getTypeFromImportAttributes(node), getNullableType(importAttributesType, 32768 /* Undefined */ ), node);
                const validForTypeAttributes = isExclusivelyTypeOnlyImportOrExport(declaration);
                const override = getResolutionModeOverride(node, validForTypeAttributes ? grammarErrorOnNode : void 0);
                const isImportAttributes2 = declaration.attributes.token === 118 /* WithKeyword */ ;
                if (validForTypeAttributes && override) return;
                if (!moduleSupportsImportAttributes(moduleKind)) return grammarErrorOnNode(node, isImportAttributes2 ? Diagnostics.Import_attributes_are_only_supported_when_the_module_option_is_set_to_esnext_node18_node20_nodenext_or_preserve : Diagnostics.Import_assertions_are_only_supported_when_the_module_option_is_set_to_esnext_node18_node20_nodenext_or_preserve);
                if (102 /* Node20 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  && !isImportAttributes2) return grammarErrorOnFirstToken(node, Diagnostics.Import_assertions_have_been_replaced_by_import_attributes_Use_with_instead_of_assert);
                if (declaration.moduleSpecifier && getEmitSyntaxForModuleSpecifierExpression(declaration.moduleSpecifier) === 1 /* CommonJS */ ) return grammarErrorOnNode(node, isImportAttributes2 ? Diagnostics.Import_attributes_are_not_allowed_on_statements_that_compile_to_CommonJS_require_calls : Diagnostics.Import_assertions_are_not_allowed_on_statements_that_compile_to_CommonJS_require_calls);
                const isTypeOnly = isJSDocImportTag(declaration) || (isImportDeclaration(declaration) ? (_a = declaration.importClause) == null ? void 0 : _a.isTypeOnly : declaration.isTypeOnly);
                if (isTypeOnly) return grammarErrorOnNode(node, isImportAttributes2 ? Diagnostics.Import_attributes_cannot_be_used_with_type_only_imports_or_exports : Diagnostics.Import_assertions_cannot_be_used_with_type_only_imports_or_exports);
                if (override) return grammarErrorOnNode(node, Diagnostics.resolution_mode_can_only_be_set_for_type_only_imports);
            }
        }
        function checkImportAttribute(node) {
            return getRegularTypeOfLiteralType(checkExpressionCached(node.value));
        }
        function checkImportDeclaration(node) {
            if (checkGrammarModuleElementContext(node, isInJSFile(node) ? Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_module : Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module)) return;
            if (!checkGrammarModifiers(node) && node.modifiers) grammarErrorOnFirstToken(node, Diagnostics.An_import_declaration_cannot_have_modifiers);
            if (checkExternalImportOrExportDeclaration(node)) {
                let resolvedModule;
                const importClause = node.importClause;
                if (importClause && !checkGrammarImportClause(importClause)) {
                    if (importClause.name) checkImportBinding(importClause);
                    if (importClause.namedBindings) {
                        if (importClause.namedBindings.kind === 275 /* NamespaceImport */ ) {
                            checkImportBinding(importClause.namedBindings);
                            if (host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) < 4 /* System */  && getESModuleInterop(compilerOptions)) checkExternalEmitHelpers(node, 65536 /* ImportStar */ );
                        } else {
                            resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
                            if (resolvedModule) forEach(importClause.namedBindings.elements, checkImportBinding);
                        }
                    }
                    if (!importClause.isTypeOnly && 101 /* Node18 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  && isOnlyImportableAsDefault(node.moduleSpecifier, resolvedModule) && !hasTypeJsonImportAttribute(node)) error2(node.moduleSpecifier, Diagnostics.Importing_a_JSON_file_into_an_ECMAScript_module_requires_a_type_Colon_json_import_attribute_when_module_is_set_to_0, ModuleKind[moduleKind]);
                } else if (noUncheckedSideEffectImports && !importClause) resolveExternalModuleName(node, node.moduleSpecifier);
            }
            checkImportAttributes(node);
        }
        function hasTypeJsonImportAttribute(node) {
            return !!node.attributes && node.attributes.elements.some((attr)=>{
                var _a;
                return getTextOfIdentifierOrLiteral(attr.name) === "type" && ((_a = tryCast(attr.value, isStringLiteralLike)) == null ? void 0 : _a.text) === "json";
            });
        }
        function checkImportEqualsDeclaration(node) {
            if (checkGrammarModuleElementContext(node, isInJSFile(node) ? Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_module : Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module)) return;
            checkGrammarModifiers(node);
            if (compilerOptions.erasableSyntaxOnly && !(node.flags & 33554432 /* Ambient */ )) error2(node, Diagnostics.This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled);
            if (isInternalModuleImportEqualsDeclaration(node) || checkExternalImportOrExportDeclaration(node)) {
                checkImportBinding(node);
                markLinkedReferences(node, 6 /* ExportImportEquals */ );
                if (node.moduleReference.kind !== 284 /* ExternalModuleReference */ ) {
                    const target = resolveAlias(getSymbolOfDeclaration(node));
                    if (target !== unknownSymbol) {
                        const targetFlags = getSymbolFlags(target);
                        if (targetFlags & 111551 /* Value */ ) {
                            const moduleName = getFirstIdentifier(node.moduleReference);
                            if (!(resolveEntityName(moduleName, 112575 /* Namespace */ ).flags & 1920 /* Namespace */ )) error2(moduleName, Diagnostics.Module_0_is_hidden_by_a_local_declaration_with_the_same_name, declarationNameToString(moduleName));
                        }
                        if (targetFlags & 788968 /* Type */ ) checkTypeNameIsReserved(node.name, Diagnostics.Import_name_cannot_be_0);
                    }
                    if (node.isTypeOnly) grammarErrorOnNode(node, Diagnostics.An_import_alias_cannot_use_import_type);
                } else if (5 /* ES2015 */  <= moduleKind && moduleKind <= 99 /* ESNext */  && !node.isTypeOnly && !(node.flags & 33554432 /* Ambient */ )) grammarErrorOnNode(node, Diagnostics.Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead);
            }
        }
        function checkExportDeclaration(node) {
            if (checkGrammarModuleElementContext(node, isInJSFile(node) ? Diagnostics.An_export_declaration_can_only_be_used_at_the_top_level_of_a_module : Diagnostics.An_export_declaration_can_only_be_used_at_the_top_level_of_a_namespace_or_module)) return;
            if (!checkGrammarModifiers(node) && hasSyntacticModifiers(node)) grammarErrorOnFirstToken(node, Diagnostics.An_export_declaration_cannot_have_modifiers);
            checkGrammarExportDeclaration(node);
            if (!node.moduleSpecifier || checkExternalImportOrExportDeclaration(node)) {
                if (node.exportClause && !isNamespaceExport(node.exportClause)) {
                    forEach(node.exportClause.elements, checkExportSpecifier);
                    const inAmbientExternalModule = node.parent.kind === 269 /* ModuleBlock */  && isAmbientModule(node.parent.parent);
                    const inAmbientNamespaceDeclaration = !inAmbientExternalModule && node.parent.kind === 269 /* ModuleBlock */  && !node.moduleSpecifier && node.flags & 33554432 /* Ambient */ ;
                    if (node.parent.kind !== 308 /* SourceFile */  && !inAmbientExternalModule && !inAmbientNamespaceDeclaration) error2(node, Diagnostics.Export_declarations_are_not_permitted_in_a_namespace);
                } else {
                    const moduleSymbol = resolveExternalModuleName(node, node.moduleSpecifier);
                    if (moduleSymbol && hasExportAssignmentSymbol(moduleSymbol)) error2(node.moduleSpecifier, Diagnostics.Module_0_uses_export_and_cannot_be_used_with_export_Asterisk, symbolToString(moduleSymbol));
                    else if (node.exportClause) {
                        checkAliasSymbol(node.exportClause);
                        checkModuleExportName(node.exportClause.name);
                    }
                    if (host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) < 4 /* System */ ) {
                        if (node.exportClause) {
                            if (getESModuleInterop(compilerOptions)) checkExternalEmitHelpers(node, 65536 /* ImportStar */ );
                        } else checkExternalEmitHelpers(node, 32768 /* ExportStar */ );
                    }
                }
            }
            checkImportAttributes(node);
        }
        function checkGrammarExportDeclaration(node) {
            var _a;
            if (node.isTypeOnly && ((_a = node.exportClause) == null ? void 0 : _a.kind) === 280 /* NamedExports */ ) return checkGrammarNamedImportsOrExports(node.exportClause);
            return false;
        }
        function checkGrammarModuleElementContext(node, errorMessage) {
            const isInAppropriateContext = node.parent.kind === 308 /* SourceFile */  || node.parent.kind === 269 /* ModuleBlock */  || node.parent.kind === 268 /* ModuleDeclaration */ ;
            if (!isInAppropriateContext) grammarErrorOnFirstToken(node, errorMessage);
            return !isInAppropriateContext;
        }
        function checkExportSpecifier(node) {
            checkAliasSymbol(node);
            const hasModuleSpecifier = node.parent.parent.moduleSpecifier !== void 0;
            checkModuleExportName(node.propertyName, hasModuleSpecifier);
            checkModuleExportName(node.name);
            if (getEmitDeclarations(compilerOptions)) collectLinkedAliases(node.propertyName || node.name, /*setVisibility*/ true);
            if (!hasModuleSpecifier) {
                const exportedName = node.propertyName || node.name;
                if (exportedName.kind === 11 /* StringLiteral */ ) return;
                const symbol = resolveName(exportedName, exportedName.escapedText, 2998271 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
                if (symbol && (symbol === undefinedSymbol || symbol === globalThisSymbol || symbol.declarations && isGlobalSourceFile(getDeclarationContainer(symbol.declarations[0])))) error2(exportedName, Diagnostics.Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module, idText(exportedName));
                else markLinkedReferences(node, 7 /* ExportSpecifier */ );
            } else if (getESModuleInterop(compilerOptions) && host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) < 4 /* System */  && moduleExportNameIsDefault(node.propertyName || node.name)) checkExternalEmitHelpers(node, 131072 /* ImportDefault */ );
        }
        function checkExportAssignment(node) {
            const illegalContextMessage = node.isExportEquals ? Diagnostics.An_export_assignment_must_be_at_the_top_level_of_a_file_or_module_declaration : Diagnostics.A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration;
            if (checkGrammarModuleElementContext(node, illegalContextMessage)) return;
            if (compilerOptions.erasableSyntaxOnly && node.isExportEquals && !(node.flags & 33554432 /* Ambient */ )) error2(node, Diagnostics.This_syntax_is_not_allowed_when_erasableSyntaxOnly_is_enabled);
            const container = node.parent.kind === 308 /* SourceFile */  ? node.parent : node.parent.parent;
            if (container.kind === 268 /* ModuleDeclaration */  && !isAmbientModule(container)) {
                if (node.isExportEquals) error2(node, Diagnostics.An_export_assignment_cannot_be_used_in_a_namespace);
                else error2(node, Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
                return;
            }
            if (!checkGrammarModifiers(node) && hasEffectiveModifiers(node)) grammarErrorOnFirstToken(node, Diagnostics.An_export_assignment_cannot_have_modifiers);
            const typeAnnotationNode = getEffectiveTypeAnnotationNode(node);
            if (typeAnnotationNode) checkTypeAssignableTo(checkExpressionCached(node.expression), getTypeFromTypeNode(typeAnnotationNode), node.expression);
            const isIllegalExportDefaultInCJS = !node.isExportEquals && !(node.flags & 33554432 /* Ambient */ ) && compilerOptions.verbatimModuleSyntax && host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) === 1 /* CommonJS */ ;
            if (node.expression.kind === 80 /* Identifier */ ) {
                const id = node.expression;
                const sym = getExportSymbolOfValueSymbolIfExported(resolveEntityName(id, -1 /* All */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, node));
                if (sym) {
                    markLinkedReferences(node, 3 /* ExportAssignment */ );
                    const typeOnlyDeclaration = getTypeOnlyAliasDeclaration(sym, 111551 /* Value */ );
                    if (getSymbolFlags(sym) & 111551 /* Value */ ) {
                        checkExpressionCached(id);
                        if (!isIllegalExportDefaultInCJS && !(node.flags & 33554432 /* Ambient */ ) && compilerOptions.verbatimModuleSyntax && typeOnlyDeclaration) error2(id, node.isExportEquals ? Diagnostics.An_export_declaration_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration : Diagnostics.An_export_default_must_reference_a_real_value_when_verbatimModuleSyntax_is_enabled_but_0_resolves_to_a_type_only_declaration, idText(id));
                    } else if (!isIllegalExportDefaultInCJS && !(node.flags & 33554432 /* Ambient */ ) && compilerOptions.verbatimModuleSyntax) error2(id, node.isExportEquals ? Diagnostics.An_export_declaration_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type : Diagnostics.An_export_default_must_reference_a_value_when_verbatimModuleSyntax_is_enabled_but_0_only_refers_to_a_type, idText(id));
                    if (!isIllegalExportDefaultInCJS && !(node.flags & 33554432 /* Ambient */ ) && getIsolatedModules(compilerOptions) && !(sym.flags & 111551 /* Value */ )) {
                        const nonLocalMeanings = getSymbolFlags(sym, /*excludeTypeOnlyMeanings*/ false, /*excludeLocalMeanings*/ true);
                        if (sym.flags & 2097152 /* Alias */  && nonLocalMeanings & 788968 /* Type */  && !(nonLocalMeanings & 111551 /* Value */ ) && (!typeOnlyDeclaration || getSourceFileOfNode(typeOnlyDeclaration) !== getSourceFileOfNode(node))) error2(id, node.isExportEquals ? Diagnostics._0_resolves_to_a_type_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_import_type_where_0_is_imported : Diagnostics._0_resolves_to_a_type_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_export_type_0_as_default, idText(id), isolatedModulesLikeFlagName);
                        else if (typeOnlyDeclaration && getSourceFileOfNode(typeOnlyDeclaration) !== getSourceFileOfNode(node)) addTypeOnlyDeclarationRelatedInfo(error2(id, node.isExportEquals ? Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_import_type_where_0_is_imported : Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_marked_type_only_in_this_file_before_re_exporting_when_1_is_enabled_Consider_using_export_type_0_as_default, idText(id), isolatedModulesLikeFlagName), typeOnlyDeclaration, idText(id));
                    }
                } else checkExpressionCached(id);
                if (getEmitDeclarations(compilerOptions)) collectLinkedAliases(id, /*setVisibility*/ true);
            } else checkExpressionCached(node.expression);
            if (isIllegalExportDefaultInCJS) error2(node, getVerbatimModuleSyntaxErrorMessage(node));
            checkExternalModuleExports(container);
            if (node.flags & 33554432 /* Ambient */  && !isEntityNameExpression(node.expression)) grammarErrorOnNode(node.expression, Diagnostics.The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context);
            if (node.isExportEquals) {
                if (moduleKind >= 5 /* ES2015 */  && moduleKind !== 200 /* Preserve */  && (node.flags & 33554432 /* Ambient */  && host.getImpliedNodeFormatForEmit(getSourceFileOfNode(node)) === 99 /* ESNext */  || !(node.flags & 33554432 /* Ambient */ ) && host.getImpliedNodeFormatForEmit(getSourceFileOfNode(node)) !== 1 /* CommonJS */ )) grammarErrorOnNode(node, Diagnostics.Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead);
                else if (moduleKind === 4 /* System */  && !(node.flags & 33554432 /* Ambient */ )) grammarErrorOnNode(node, Diagnostics.Export_assignment_is_not_supported_when_module_flag_is_system);
            }
        }
        function hasExportedMembers(moduleSymbol) {
            return forEachEntry(moduleSymbol.exports, (_, id)=>id !== "export=");
        }
        function checkExternalModuleExports(node) {
            const moduleSymbol = getSymbolOfDeclaration(node);
            const links = getSymbolLinks(moduleSymbol);
            if (!links.exportsChecked) {
                const exportEqualsSymbol = moduleSymbol.exports.get("export=");
                if (exportEqualsSymbol && hasExportedMembers(moduleSymbol)) {
                    const declaration = getDeclarationOfAliasSymbol(exportEqualsSymbol) || exportEqualsSymbol.valueDeclaration;
                    if (declaration && !isTopLevelInExternalModuleAugmentation(declaration) && !isInJSFile(declaration)) error2(declaration, Diagnostics.An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements);
                }
                const exports2 = getExportsOfModule(moduleSymbol);
                if (exports2) exports2.forEach(({ declarations, flags }, id)=>{
                    if (id === "__export") return;
                    if (flags & 1920 /* Enum */ ) return;
                    const exportedDeclarationsCount = countWhere(declarations, and(isNotOverloadAndNotAccessor, not(isInterfaceDeclaration)));
                    if (flags & 524288 /* TypeAlias */  && exportedDeclarationsCount <= 2) return;
                    if (exportedDeclarationsCount > 1) {
                        if (!isDuplicatedCommonJSExport(declarations)) {
                            for (const declaration of declarations)if (isNotOverload(declaration)) diagnostics.add(createDiagnosticForNode(declaration, Diagnostics.Cannot_redeclare_exported_variable_0, unescapeLeadingUnderscores(id)));
                        }
                    }
                });
                links.exportsChecked = true;
            }
        }
        function isDuplicatedCommonJSExport(declarations) {
            return declarations && declarations.length > 1 && declarations.every((d)=>isInJSFile(d) && isAccessExpression(d) && (isExportsIdentifier(d.expression) || isModuleExportsAccessExpression(d.expression)));
        }
        function checkSourceElement(node) {
            if (node) {
                const saveCurrentNode = currentNode;
                currentNode = node;
                instantiationCount = 0;
                checkSourceElementWorker(node);
                currentNode = saveCurrentNode;
            }
        }
        function checkSourceElementWorker(node) {
            if (getNodeCheckFlags(node) & 8388608 /* PartiallyTypeChecked */ ) return;
            if (canHaveJSDoc(node)) forEach(node.jsDoc, ({ comment, tags })=>{
                checkJSDocCommentWorker(comment);
                forEach(tags, (tag)=>{
                    checkJSDocCommentWorker(tag.comment);
                    if (isInJSFile(node)) checkSourceElement(tag);
                });
            });
            const kind = node.kind;
            if (cancellationToken) switch(kind){
                case 268 /* ModuleDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            if (kind >= 244 /* FirstStatement */  && kind <= 260 /* LastStatement */  && canHaveFlowNode(node) && node.flowNode && !isReachableFlowNode(node.flowNode)) errorOrSuggestion(compilerOptions.allowUnreachableCode === false, node, Diagnostics.Unreachable_code_detected);
            switch(kind){
                case 169 /* TypeParameter */ :
                    return checkTypeParameter(node);
                case 170 /* Parameter */ :
                    return checkParameter(node);
                case 173 /* PropertyDeclaration */ :
                    return checkPropertyDeclaration(node);
                case 172 /* PropertySignature */ :
                    return checkPropertySignature(node);
                case 186 /* ConstructorType */ :
                case 185 /* FunctionType */ :
                case 180 /* CallSignature */ :
                case 181 /* ConstructSignature */ :
                case 182 /* IndexSignature */ :
                    return checkSignatureDeclaration(node);
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    return checkMethodDeclaration(node);
                case 176 /* ClassStaticBlockDeclaration */ :
                    return checkClassStaticBlockDeclaration(node);
                case 177 /* Constructor */ :
                    return checkConstructorDeclaration(node);
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return checkAccessorDeclaration(node);
                case 184 /* TypeReference */ :
                    return checkTypeReferenceNode(node);
                case 183 /* TypePredicate */ :
                    return checkTypePredicate(node);
                case 187 /* TypeQuery */ :
                    return checkTypeQuery(node);
                case 188 /* TypeLiteral */ :
                    return checkTypeLiteral(node);
                case 189 /* ArrayType */ :
                    return checkArrayType(node);
                case 190 /* TupleType */ :
                    return checkTupleType(node);
                case 193 /* UnionType */ :
                case 194 /* IntersectionType */ :
                    return checkUnionOrIntersectionType(node);
                case 197 /* ParenthesizedType */ :
                case 191 /* OptionalType */ :
                case 192 /* RestType */ :
                    return checkSourceElement(node.type);
                case 198 /* ThisType */ :
                    return checkThisType(node);
                case 199 /* TypeOperator */ :
                    return checkTypeOperator(node);
                case 195 /* ConditionalType */ :
                    return checkConditionalType(node);
                case 196 /* InferType */ :
                    return checkInferType(node);
                case 204 /* TemplateLiteralType */ :
                    return checkTemplateLiteralType(node);
                case 206 /* ImportType */ :
                    return checkImportType(node);
                case 203 /* NamedTupleMember */ :
                    return checkNamedTupleMember(node);
                case 329 /* JSDocAugmentsTag */ :
                    return checkJSDocAugmentsTag(node);
                case 330 /* JSDocImplementsTag */ :
                    return checkJSDocImplementsTag(node);
                case 347 /* JSDocTypedefTag */ :
                case 339 /* JSDocCallbackTag */ :
                case 341 /* JSDocEnumTag */ :
                    return checkJSDocTypeAliasTag(node);
                case 346 /* JSDocTemplateTag */ :
                    return checkJSDocTemplateTag(node);
                case 345 /* JSDocTypeTag */ :
                    return checkJSDocTypeTag(node);
                case 325 /* JSDocLink */ :
                case 326 /* JSDocLinkCode */ :
                case 327 /* JSDocLinkPlain */ :
                    return checkJSDocLinkLikeTag(node);
                case 342 /* JSDocParameterTag */ :
                    return checkJSDocParameterTag(node);
                case 349 /* JSDocPropertyTag */ :
                    return checkJSDocPropertyTag(node);
                case 318 /* JSDocFunctionType */ :
                    checkJSDocFunctionType(node);
                // falls through
                case 316 /* JSDocNonNullableType */ :
                case 315 /* JSDocNullableType */ :
                case 313 /* JSDocAllType */ :
                case 314 /* JSDocUnknownType */ :
                case 323 /* JSDocTypeLiteral */ :
                    checkJSDocTypeIsInJsFile(node);
                    forEachChild(node, checkSourceElement);
                    return;
                case 319 /* JSDocVariadicType */ :
                    checkJSDocVariadicType(node);
                    return;
                case 310 /* JSDocTypeExpression */ :
                    return checkSourceElement(node.type);
                case 334 /* JSDocPublicTag */ :
                case 336 /* JSDocProtectedTag */ :
                case 335 /* JSDocPrivateTag */ :
                    return checkJSDocAccessibilityModifiers(node);
                case 351 /* JSDocSatisfiesTag */ :
                    return checkJSDocSatisfiesTag(node);
                case 344 /* JSDocThisTag */ :
                    return checkJSDocThisTag(node);
                case 352 /* JSDocImportTag */ :
                    return checkJSDocImportTag(node);
                case 200 /* IndexedAccessType */ :
                    return checkIndexedAccessType(node);
                case 201 /* MappedType */ :
                    return checkMappedType(node);
                case 263 /* FunctionDeclaration */ :
                    return checkFunctionDeclaration(node);
                case 242 /* Block */ :
                case 269 /* ModuleBlock */ :
                    return checkBlock(node);
                case 244 /* VariableStatement */ :
                    return checkVariableStatement(node);
                case 245 /* ExpressionStatement */ :
                    return checkExpressionStatement(node);
                case 246 /* IfStatement */ :
                    return checkIfStatement(node);
                case 247 /* DoStatement */ :
                    return checkDoStatement(node);
                case 248 /* WhileStatement */ :
                    return checkWhileStatement(node);
                case 249 /* ForStatement */ :
                    return checkForStatement(node);
                case 250 /* ForInStatement */ :
                    return checkForInStatement(node);
                case 251 /* ForOfStatement */ :
                    return checkForOfStatement(node);
                case 252 /* ContinueStatement */ :
                case 253 /* BreakStatement */ :
                    return checkBreakOrContinueStatement(node);
                case 254 /* ReturnStatement */ :
                    return checkReturnStatement(node);
                case 255 /* WithStatement */ :
                    return checkWithStatement(node);
                case 256 /* SwitchStatement */ :
                    return checkSwitchStatement(node);
                case 257 /* LabeledStatement */ :
                    return checkLabeledStatement(node);
                case 258 /* ThrowStatement */ :
                    return checkThrowStatement(node);
                case 259 /* TryStatement */ :
                    return checkTryStatement(node);
                case 261 /* VariableDeclaration */ :
                    return checkVariableDeclaration(node);
                case 209 /* BindingElement */ :
                    return checkBindingElement(node);
                case 264 /* ClassDeclaration */ :
                    return checkClassDeclaration(node);
                case 265 /* InterfaceDeclaration */ :
                    return checkInterfaceDeclaration(node);
                case 266 /* TypeAliasDeclaration */ :
                    return checkTypeAliasDeclaration(node);
                case 267 /* EnumDeclaration */ :
                    return checkEnumDeclaration(node);
                case 307 /* EnumMember */ :
                    return checkEnumMember(node);
                case 268 /* ModuleDeclaration */ :
                    return checkModuleDeclaration(node);
                case 273 /* ImportDeclaration */ :
                    return checkImportDeclaration(node);
                case 272 /* ImportEqualsDeclaration */ :
                    return checkImportEqualsDeclaration(node);
                case 279 /* ExportDeclaration */ :
                    return checkExportDeclaration(node);
                case 278 /* ExportAssignment */ :
                    return checkExportAssignment(node);
                case 243 /* EmptyStatement */ :
                case 260 /* DebuggerStatement */ :
                    checkGrammarStatementInAmbientContext(node);
                    return;
                case 283 /* MissingDeclaration */ :
                    return checkMissingDeclaration(node);
            }
        }
        function checkJSDocCommentWorker(node) {
            if (isArray(node)) forEach(node, (tag)=>{
                if (isJSDocLinkLike(tag)) checkSourceElement(tag);
            });
        }
        function checkJSDocTypeIsInJsFile(node) {
            if (!isInJSFile(node)) {
                if (isJSDocNonNullableType(node) || isJSDocNullableType(node)) {
                    const token = tokenToString(isJSDocNonNullableType(node) ? 54 /* ExclamationToken */  : 58 /* QuestionToken */ );
                    const diagnostic = node.postfix ? Diagnostics._0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1 : Diagnostics._0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1;
                    const typeNode = node.type;
                    const type = getTypeFromTypeNode(typeNode);
                    grammarErrorOnNode(node, diagnostic, token, typeToString(isJSDocNullableType(node) && !(type === neverType || type === voidType) ? getUnionType(append([
                        type,
                        undefinedType
                    ], node.postfix ? void 0 : nullType)) : type));
                } else grammarErrorOnNode(node, Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
            }
        }
        function checkJSDocVariadicType(node) {
            checkJSDocTypeIsInJsFile(node);
            checkSourceElement(node.type);
            const { parent: parent2 } = node;
            if (isParameter(parent2) && isJSDocFunctionType(parent2.parent)) {
                if (last(parent2.parent.parameters) !== parent2) error2(node, Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
                return;
            }
            if (!isJSDocTypeExpression(parent2)) error2(node, Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
            const paramTag = node.parent.parent;
            if (!isJSDocParameterTag(paramTag)) {
                error2(node, Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
                return;
            }
            const param = getParameterSymbolFromJSDoc(paramTag);
            if (!param) return;
            const host2 = getHostSignatureFromJSDoc(paramTag);
            if (!host2 || last(host2.parameters).symbol !== param) error2(node, Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
        }
        function getTypeFromJSDocVariadicType(node) {
            const type = getTypeFromTypeNode(node.type);
            const { parent: parent2 } = node;
            const paramTag = node.parent.parent;
            if (isJSDocTypeExpression(node.parent) && isJSDocParameterTag(paramTag)) {
                const host2 = getHostSignatureFromJSDoc(paramTag);
                const isCallbackTag = isJSDocCallbackTag(paramTag.parent.parent);
                if (host2 || isCallbackTag) {
                    const lastParamDeclaration = isCallbackTag ? lastOrUndefined(paramTag.parent.parent.typeExpression.parameters) : lastOrUndefined(host2.parameters);
                    const symbol = getParameterSymbolFromJSDoc(paramTag);
                    if (!lastParamDeclaration || symbol && lastParamDeclaration.symbol === symbol && isRestParameter(lastParamDeclaration)) return createArrayType(type);
                }
            }
            if (isParameter(parent2) && isJSDocFunctionType(parent2.parent)) return createArrayType(type);
            return addOptionality(type);
        }
        function checkNodeDeferred(node) {
            const enclosingFile = getSourceFileOfNode(node);
            const links = getNodeLinks(enclosingFile);
            if (!(links.flags & 1 /* TypeChecked */ )) {
                links.deferredNodes || (links.deferredNodes = /* @__PURE__ */ new Set());
                links.deferredNodes.add(node);
            } else Debug.assert(!links.deferredNodes, "A type-checked file should have no deferred nodes.");
        }
        function checkDeferredNodes(context) {
            const links = getNodeLinks(context);
            if (links.deferredNodes) links.deferredNodes.forEach(checkDeferredNode);
            links.deferredNodes = void 0;
        }
        function checkDeferredNode(node) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, "checkDeferredNode", {
                kind: node.kind,
                pos: node.pos,
                end: node.end,
                path: node.tracingPath
            });
            const saveCurrentNode = currentNode;
            currentNode = node;
            instantiationCount = 0;
            switch(node.kind){
                case 214 /* CallExpression */ :
                case 215 /* NewExpression */ :
                case 216 /* TaggedTemplateExpression */ :
                case 171 /* Decorator */ :
                case 287 /* JsxOpeningElement */ :
                    resolveUntypedCall(node);
                    break;
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    checkFunctionExpressionOrObjectLiteralMethodDeferred(node);
                    break;
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    checkAccessorDeclaration(node);
                    break;
                case 232 /* ClassExpression */ :
                    checkClassExpressionDeferred(node);
                    break;
                case 169 /* TypeParameter */ :
                    checkTypeParameterDeferred(node);
                    break;
                case 286 /* JsxSelfClosingElement */ :
                    checkJsxSelfClosingElementDeferred(node);
                    break;
                case 285 /* JsxElement */ :
                    checkJsxElementDeferred(node);
                    break;
                case 217 /* TypeAssertionExpression */ :
                case 235 /* AsExpression */ :
                case 218 /* ParenthesizedExpression */ :
                    checkAssertionDeferred(node);
                    break;
                case 223 /* VoidExpression */ :
                    checkExpression(node.expression);
                    break;
                case 227 /* BinaryExpression */ :
                    if (isInstanceOfExpression(node)) resolveUntypedCall(node);
                    break;
            }
            currentNode = saveCurrentNode;
            (_b = tracing) == null || _b.pop();
        }
        function checkSourceFile(node, nodesToCheck) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Check, nodesToCheck ? "checkSourceFileNodes" : "checkSourceFile", {
                path: node.path
            }, /*separateBeginAndEnd*/ true);
            const beforeMark = nodesToCheck ? "beforeCheckNodes" : "beforeCheck";
            const afterMark = nodesToCheck ? "afterCheckNodes" : "afterCheck";
            mark(beforeMark);
            nodesToCheck ? checkSourceFileNodesWorker(node, nodesToCheck) : checkSourceFileWorker(node);
            mark(afterMark);
            measure("Check", beforeMark, afterMark);
            (_b = tracing) == null || _b.pop();
        }
        function unusedIsError(kind, isAmbient) {
            if (isAmbient) return false;
            switch(kind){
                case 0 /* Local */ :
                    return !!compilerOptions.noUnusedLocals;
                case 1 /* Parameter */ :
                    return !!compilerOptions.noUnusedParameters;
                default:
                    return Debug.assertNever(kind);
            }
        }
        function getPotentiallyUnusedIdentifiers(sourceFile) {
            return allPotentiallyUnusedIdentifiers.get(sourceFile.path) || emptyArray;
        }
        function checkSourceFileWorker(node) {
            const links = getNodeLinks(node);
            if (!(links.flags & 1 /* TypeChecked */ )) {
                if (skipTypeChecking(node, compilerOptions, host)) return;
                checkGrammarSourceFile(node);
                clear(potentialThisCollisions);
                clear(potentialNewTargetCollisions);
                clear(potentialWeakMapSetCollisions);
                clear(potentialReflectCollisions);
                clear(potentialUnusedRenamedBindingElementsInTypes);
                if (links.flags & 8388608 /* PartiallyTypeChecked */ ) {
                    potentialThisCollisions = links.potentialThisCollisions;
                    potentialNewTargetCollisions = links.potentialNewTargetCollisions;
                    potentialWeakMapSetCollisions = links.potentialWeakMapSetCollisions;
                    potentialReflectCollisions = links.potentialReflectCollisions;
                    potentialUnusedRenamedBindingElementsInTypes = links.potentialUnusedRenamedBindingElementsInTypes;
                }
                forEach(node.statements, checkSourceElement);
                checkSourceElement(node.endOfFileToken);
                checkDeferredNodes(node);
                if (isExternalOrCommonJsModule(node)) registerForUnusedIdentifiersCheck(node);
                addLazyDiagnostic(()=>{
                    if (!node.isDeclarationFile && (compilerOptions.noUnusedLocals || compilerOptions.noUnusedParameters)) checkUnusedIdentifiers(getPotentiallyUnusedIdentifiers(node), (containingNode, kind, diag2)=>{
                        if (!containsParseError(containingNode) && unusedIsError(kind, !!(containingNode.flags & 33554432 /* Ambient */ ))) diagnostics.add(diag2);
                    });
                    if (!node.isDeclarationFile) checkPotentialUncheckedRenamedBindingElementsInTypes();
                });
                if (isExternalOrCommonJsModule(node)) checkExternalModuleExports(node);
                if (potentialThisCollisions.length) {
                    forEach(potentialThisCollisions, checkIfThisIsCapturedInEnclosingScope);
                    clear(potentialThisCollisions);
                }
                if (potentialNewTargetCollisions.length) {
                    forEach(potentialNewTargetCollisions, checkIfNewTargetIsCapturedInEnclosingScope);
                    clear(potentialNewTargetCollisions);
                }
                if (potentialWeakMapSetCollisions.length) {
                    forEach(potentialWeakMapSetCollisions, checkWeakMapSetCollision);
                    clear(potentialWeakMapSetCollisions);
                }
                if (potentialReflectCollisions.length) {
                    forEach(potentialReflectCollisions, checkReflectCollision);
                    clear(potentialReflectCollisions);
                }
                links.flags |= 1 /* TypeChecked */ ;
            }
        }
        function checkSourceFileNodesWorker(file, nodes) {
            const links = getNodeLinks(file);
            if (!(links.flags & 1 /* TypeChecked */ )) {
                if (skipTypeChecking(file, compilerOptions, host)) return;
                checkGrammarSourceFile(file);
                clear(potentialThisCollisions);
                clear(potentialNewTargetCollisions);
                clear(potentialWeakMapSetCollisions);
                clear(potentialReflectCollisions);
                clear(potentialUnusedRenamedBindingElementsInTypes);
                forEach(nodes, checkSourceElement);
                checkDeferredNodes(file);
                (links.potentialThisCollisions || (links.potentialThisCollisions = [])).push(...potentialThisCollisions);
                (links.potentialNewTargetCollisions || (links.potentialNewTargetCollisions = [])).push(...potentialNewTargetCollisions);
                (links.potentialWeakMapSetCollisions || (links.potentialWeakMapSetCollisions = [])).push(...potentialWeakMapSetCollisions);
                (links.potentialReflectCollisions || (links.potentialReflectCollisions = [])).push(...potentialReflectCollisions);
                (links.potentialUnusedRenamedBindingElementsInTypes || (links.potentialUnusedRenamedBindingElementsInTypes = [])).push(...potentialUnusedRenamedBindingElementsInTypes);
                links.flags |= 8388608 /* PartiallyTypeChecked */ ;
                for (const node of nodes){
                    const nodeLinks2 = getNodeLinks(node);
                    nodeLinks2.flags |= 8388608 /* PartiallyTypeChecked */ ;
                }
            }
        }
        function getDiagnostics2(sourceFile, ct, nodesToCheck) {
            try {
                cancellationToken = ct;
                return getDiagnosticsWorker(sourceFile, nodesToCheck);
            } finally{
                cancellationToken = void 0;
            }
        }
        function ensurePendingDiagnosticWorkComplete() {
            for (const cb of deferredDiagnosticsCallbacks)cb();
            deferredDiagnosticsCallbacks = [];
        }
        function checkSourceFileWithEagerDiagnostics(sourceFile, nodesToCheck) {
            ensurePendingDiagnosticWorkComplete();
            const oldAddLazyDiagnostics = addLazyDiagnostic;
            addLazyDiagnostic = (cb)=>cb();
            checkSourceFile(sourceFile, nodesToCheck);
            addLazyDiagnostic = oldAddLazyDiagnostics;
        }
        function getDiagnosticsWorker(sourceFile, nodesToCheck) {
            if (sourceFile) {
                ensurePendingDiagnosticWorkComplete();
                const previousGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
                const previousGlobalDiagnosticsSize = previousGlobalDiagnostics.length;
                checkSourceFileWithEagerDiagnostics(sourceFile, nodesToCheck);
                const semanticDiagnostics = diagnostics.getDiagnostics(sourceFile.fileName);
                if (nodesToCheck) return semanticDiagnostics;
                const currentGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
                if (currentGlobalDiagnostics !== previousGlobalDiagnostics) {
                    const deferredGlobalDiagnostics = relativeComplement(previousGlobalDiagnostics, currentGlobalDiagnostics, compareDiagnostics);
                    return concatenate(deferredGlobalDiagnostics, semanticDiagnostics);
                } else if (previousGlobalDiagnosticsSize === 0 && currentGlobalDiagnostics.length > 0) return concatenate(currentGlobalDiagnostics, semanticDiagnostics);
                return semanticDiagnostics;
            }
            forEach(host.getSourceFiles(), (file)=>checkSourceFileWithEagerDiagnostics(file));
            return diagnostics.getDiagnostics();
        }
        function getGlobalDiagnostics() {
            ensurePendingDiagnosticWorkComplete();
            return diagnostics.getGlobalDiagnostics();
        }
        function getSymbolsInScope(location, meaning) {
            if (location.flags & 67108864 /* InWithStatement */ ) return [];
            const symbols = createSymbolTable();
            let isStaticSymbol = false;
            populateSymbols();
            symbols.delete("this" /* This */ );
            return symbolsToArray(symbols);
            function populateSymbols() {
                while(location){
                    if (canHaveLocals(location) && location.locals && !isGlobalSourceFile(location)) copySymbols(location.locals, meaning);
                    switch(location.kind){
                        case 308 /* SourceFile */ :
                            if (!isExternalModule(location)) break;
                        // falls through
                        case 268 /* ModuleDeclaration */ :
                            copyLocallyVisibleExportSymbols(getSymbolOfDeclaration(location).exports, meaning & 2623475 /* ModuleMember */ );
                            break;
                        case 267 /* EnumDeclaration */ :
                            copySymbols(getSymbolOfDeclaration(location).exports, meaning & 8 /* EnumMember */ );
                            break;
                        case 232 /* ClassExpression */ :
                            const className = location.name;
                            if (className) copySymbol(location.symbol, meaning);
                        // this fall-through is necessary because we would like to handle
                        // type parameter inside class expression similar to how we handle it in classDeclaration and interface Declaration.
                        // falls through
                        case 264 /* ClassDeclaration */ :
                        case 265 /* InterfaceDeclaration */ :
                            if (!isStaticSymbol) copySymbols(getMembersOfSymbol(getSymbolOfDeclaration(location)), meaning & 788968 /* Type */ );
                            break;
                        case 219 /* FunctionExpression */ :
                            const funcName = location.name;
                            if (funcName) copySymbol(location.symbol, meaning);
                            break;
                    }
                    if (introducesArgumentsExoticObject(location)) copySymbol(argumentsSymbol, meaning);
                    isStaticSymbol = isStatic(location);
                    location = location.parent;
                }
                copySymbols(globals, meaning);
            }
            function copySymbol(symbol, meaning2) {
                if (getCombinedLocalAndExportSymbolFlags(symbol) & meaning2) {
                    const id = symbol.escapedName;
                    if (!symbols.has(id)) symbols.set(id, symbol);
                }
            }
            function copySymbols(source, meaning2) {
                if (meaning2) source.forEach((symbol)=>{
                    copySymbol(symbol, meaning2);
                });
            }
            function copyLocallyVisibleExportSymbols(source, meaning2) {
                if (meaning2) source.forEach((symbol)=>{
                    if (!getDeclarationOfKind(symbol, 282 /* ExportSpecifier */ ) && !getDeclarationOfKind(symbol, 281 /* NamespaceExport */ ) && symbol.escapedName !== "default" /* Default */ ) copySymbol(symbol, meaning2);
                });
            }
        }
        function isTypeDeclarationName(name) {
            return name.kind === 80 /* Identifier */  && isTypeDeclaration(name.parent) && getNameOfDeclaration(name.parent) === name;
        }
        function isTypeReferenceIdentifier(node) {
            while(node.parent.kind === 167 /* QualifiedName */ )node = node.parent;
            return node.parent.kind === 184 /* TypeReference */ ;
        }
        function isInNameOfExpressionWithTypeArguments(node) {
            while(node.parent.kind === 212 /* PropertyAccessExpression */ )node = node.parent;
            return node.parent.kind === 234 /* ExpressionWithTypeArguments */ ;
        }
        function forEachEnclosingClass(node, callback) {
            let result;
            let containingClass = getContainingClass(node);
            while(containingClass){
                if (result = callback(containingClass)) break;
                containingClass = getContainingClass(containingClass);
            }
            return result;
        }
        function isNodeUsedDuringClassInitialization(node) {
            return !!findAncestor(node, (element)=>{
                if (isConstructorDeclaration(element) && nodeIsPresent(element.body) || isPropertyDeclaration(element)) return true;
                else if (isClassLike(element) || isFunctionLikeDeclaration(element)) return "quit";
                return false;
            });
        }
        function isNodeWithinClass(node, classDeclaration) {
            return !!forEachEnclosingClass(node, (n)=>n === classDeclaration);
        }
        function getLeftSideOfImportEqualsOrExportAssignment(nodeOnRightSide) {
            while(nodeOnRightSide.parent.kind === 167 /* QualifiedName */ )nodeOnRightSide = nodeOnRightSide.parent;
            if (nodeOnRightSide.parent.kind === 272 /* ImportEqualsDeclaration */ ) return nodeOnRightSide.parent.moduleReference === nodeOnRightSide ? nodeOnRightSide.parent : void 0;
            if (nodeOnRightSide.parent.kind === 278 /* ExportAssignment */ ) return nodeOnRightSide.parent.expression === nodeOnRightSide ? nodeOnRightSide.parent : void 0;
            return void 0;
        }
        function isInRightSideOfImportOrExportAssignment(node) {
            return getLeftSideOfImportEqualsOrExportAssignment(node) !== void 0;
        }
        function getSpecialPropertyAssignmentSymbolFromEntityName(entityName) {
            const specialPropertyAssignmentKind = getAssignmentDeclarationKind(entityName.parent.parent);
            switch(specialPropertyAssignmentKind){
                case 1 /* ExportsProperty */ :
                case 3 /* PrototypeProperty */ :
                    return getSymbolOfNode(entityName.parent);
                case 5 /* Property */ :
                    if (isPropertyAccessExpression(entityName.parent) && getLeftmostAccessExpression(entityName.parent) === entityName) return void 0;
                // falls through
                case 4 /* ThisProperty */ :
                case 2 /* ModuleExports */ :
                    return getSymbolOfDeclaration(entityName.parent.parent);
            }
        }
        function isImportTypeQualifierPart(node) {
            let parent2 = node.parent;
            while(isQualifiedName(parent2)){
                node = parent2;
                parent2 = parent2.parent;
            }
            if (parent2 && parent2.kind === 206 /* ImportType */  && parent2.qualifier === node) return parent2;
            return void 0;
        }
        function isThisPropertyAndThisTyped(node) {
            if (node.expression.kind === 110 /* ThisKeyword */ ) {
                const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (isFunctionLike(container)) {
                    const containingLiteral = getContainingObjectLiteral(container);
                    if (containingLiteral) {
                        const contextualType = getApparentTypeOfContextualType(containingLiteral, /*contextFlags*/ void 0);
                        const type = getThisTypeOfObjectLiteralFromContextualType(containingLiteral, contextualType);
                        return type && !isTypeAny(type);
                    }
                }
            }
        }
        function getSymbolOfNameOrPropertyAccessExpression(name) {
            if (isDeclarationName(name)) return getSymbolOfNode(name.parent);
            if (isInJSFile(name) && name.parent.kind === 212 /* PropertyAccessExpression */  && name.parent === name.parent.parent.left) {
                if (!isPrivateIdentifier(name) && !isJSDocMemberName(name) && !isThisPropertyAndThisTyped(name.parent)) {
                    const specialPropertyAssignmentSymbol = getSpecialPropertyAssignmentSymbolFromEntityName(name);
                    if (specialPropertyAssignmentSymbol) return specialPropertyAssignmentSymbol;
                }
            }
            if (name.parent.kind === 278 /* ExportAssignment */  && isEntityNameExpression(name)) {
                const success = resolveEntityName(name, /*all meanings*/ 2998271 /* Alias */ , /*ignoreErrors*/ true);
                if (success && success !== unknownSymbol) return success;
            } else if (isEntityName(name) && isInRightSideOfImportOrExportAssignment(name)) {
                const importEqualsDeclaration = getAncestor(name, 272 /* ImportEqualsDeclaration */ );
                Debug.assert(importEqualsDeclaration !== void 0);
                return getSymbolOfPartOfRightHandSideOfImportEquals(name, /*dontResolveAlias*/ true);
            }
            if (isEntityName(name)) {
                const possibleImportNode = isImportTypeQualifierPart(name);
                if (possibleImportNode) {
                    getTypeFromTypeNode(possibleImportNode);
                    const sym = getNodeLinks(name).resolvedSymbol;
                    return sym === unknownSymbol ? void 0 : sym;
                }
            }
            while(isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName(name))name = name.parent;
            if (isInNameOfExpressionWithTypeArguments(name)) {
                let meaning = 0 /* None */ ;
                if (name.parent.kind === 234 /* ExpressionWithTypeArguments */ ) {
                    meaning = isPartOfTypeNode(name) ? 788968 /* Type */  : 111551 /* Value */ ;
                    if (isExpressionWithTypeArgumentsInClassExtendsClause(name.parent)) meaning |= 111551 /* Value */ ;
                } else meaning = 1920 /* Namespace */ ;
                meaning |= 2097152 /* Alias */ ;
                const entityNameSymbol = isEntityNameExpression(name) ? resolveEntityName(name, meaning, /*ignoreErrors*/ true) : void 0;
                if (entityNameSymbol) return entityNameSymbol;
            }
            if (name.parent.kind === 342 /* JSDocParameterTag */ ) return getParameterSymbolFromJSDoc(name.parent);
            if (name.parent.kind === 169 /* TypeParameter */  && name.parent.parent.kind === 346 /* JSDocTemplateTag */ ) {
                Debug.assert(!isInJSFile(name));
                const typeParameter = getTypeParameterFromJsDoc(name.parent);
                return typeParameter && typeParameter.symbol;
            }
            if (isExpressionNode(name)) {
                if (nodeIsMissing(name)) return void 0;
                const isJSDoc2 = findAncestor(name, or(isJSDocLinkLike, isJSDocNameReference, isJSDocMemberName));
                const meaning = isJSDoc2 ? 901119 /* Value */  : 111551 /* Value */ ;
                if (name.kind === 80 /* Identifier */ ) {
                    if (isJSXTagName(name) && isJsxIntrinsicTagName(name)) {
                        const symbol = getIntrinsicTagSymbol(name.parent);
                        return symbol === unknownSymbol ? void 0 : symbol;
                    }
                    const result = resolveEntityName(name, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true, getHostSignatureFromJSDoc(name));
                    if (!result && isJSDoc2) {
                        const container = findAncestor(name, or(isClassLike, isInterfaceDeclaration));
                        if (container) return resolveJSDocMemberName(name, /*ignoreErrors*/ true, getSymbolOfDeclaration(container));
                    }
                    if (result && isJSDoc2) {
                        const container = getJSDocHost(name);
                        if (container && isEnumMember(container) && container === result.valueDeclaration) return resolveEntityName(name, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true, getSourceFileOfNode(container)) || result;
                    }
                    return result;
                } else if (isPrivateIdentifier(name)) return getSymbolForPrivateIdentifierExpression(name);
                else if (name.kind === 212 /* PropertyAccessExpression */  || name.kind === 167 /* QualifiedName */ ) {
                    const links = getNodeLinks(name);
                    if (links.resolvedSymbol) return links.resolvedSymbol;
                    if (name.kind === 212 /* PropertyAccessExpression */ ) {
                        checkPropertyAccessExpression(name, 0 /* Normal */ );
                        if (!links.resolvedSymbol) links.resolvedSymbol = getApplicableIndexSymbol(checkExpressionCached(name.expression), getLiteralTypeFromPropertyName(name.name));
                    } else checkQualifiedName(name, 0 /* Normal */ );
                    if (!links.resolvedSymbol && isJSDoc2 && isQualifiedName(name)) return resolveJSDocMemberName(name);
                    return links.resolvedSymbol;
                } else if (isJSDocMemberName(name)) return resolveJSDocMemberName(name);
            } else if (isEntityName(name) && isTypeReferenceIdentifier(name)) {
                const meaning = name.parent.kind === 184 /* TypeReference */  ? 788968 /* Type */  : 1920 /* Namespace */ ;
                const symbol = resolveEntityName(name, meaning, /*ignoreErrors*/ true, /*dontResolveAlias*/ true);
                return symbol && symbol !== unknownSymbol ? symbol : getUnresolvedSymbolForEntityName(name);
            }
            if (name.parent.kind === 183 /* TypePredicate */ ) return resolveEntityName(name, /*meaning*/ 1 /* FunctionScopedVariable */ , /*ignoreErrors*/ true);
            return void 0;
        }
        function getApplicableIndexSymbol(type, keyType) {
            const infos = getApplicableIndexInfos(type, keyType);
            if (infos.length && type.members) {
                const symbol = getIndexSymbolFromSymbolTable(resolveStructuredTypeMembers(type).members);
                if (infos === getIndexInfosOfType(type)) return symbol;
                else if (symbol) {
                    const symbolLinks2 = getSymbolLinks(symbol);
                    const declarationList = mapDefined(infos, (i)=>i.declaration);
                    const nodeListId = map(declarationList, getNodeId).join(",");
                    if (!symbolLinks2.filteredIndexSymbolCache) symbolLinks2.filteredIndexSymbolCache = /* @__PURE__ */ new Map();
                    if (symbolLinks2.filteredIndexSymbolCache.has(nodeListId)) return symbolLinks2.filteredIndexSymbolCache.get(nodeListId);
                    else {
                        const copy = createSymbol(131072 /* Signature */ , "__index" /* Index */ );
                        copy.declarations = mapDefined(infos, (i)=>i.declaration);
                        copy.parent = type.aliasSymbol ? type.aliasSymbol : type.symbol ? type.symbol : getSymbolAtLocation(copy.declarations[0].parent);
                        symbolLinks2.filteredIndexSymbolCache.set(nodeListId, copy);
                        return copy;
                    }
                }
            }
        }
        function resolveJSDocMemberName(name, ignoreErrors, container) {
            if (isEntityName(name)) {
                const meaning = 901119 /* Value */ ;
                let symbol = resolveEntityName(name, meaning, ignoreErrors, /*dontResolveAlias*/ true, getHostSignatureFromJSDoc(name));
                if (!symbol && isIdentifier(name) && container) symbol = getMergedSymbol(getSymbol2(getExportsOfSymbol(container), name.escapedText, meaning));
                if (symbol) return symbol;
            }
            const left = isIdentifier(name) ? container : resolveJSDocMemberName(name.left, ignoreErrors, container);
            const right = isIdentifier(name) ? name.escapedText : name.right.escapedText;
            if (left) {
                const proto = left.flags & 111551 /* Value */  && getPropertyOfType(getTypeOfSymbol(left), "prototype");
                const t = proto ? getTypeOfSymbol(proto) : getDeclaredTypeOfSymbol(left);
                return getPropertyOfType(t, right);
            }
        }
        function getSymbolAtLocation(node, ignoreErrors) {
            if (isSourceFile(node)) return isExternalModule(node) ? getMergedSymbol(node.symbol) : void 0;
            const { parent: parent2 } = node;
            const grandParent = parent2.parent;
            if (node.flags & 67108864 /* InWithStatement */ ) return void 0;
            if (isDeclarationNameOrImportPropertyName(node)) {
                const parentSymbol = getSymbolOfDeclaration(parent2);
                return isImportOrExportSpecifier(node.parent) && node.parent.propertyName === node ? getImmediateAliasedSymbol(parentSymbol) : parentSymbol;
            } else if (isLiteralComputedPropertyDeclarationName(node)) return getSymbolOfDeclaration(parent2.parent);
            if (node.kind === 80 /* Identifier */ ) {
                if (isInRightSideOfImportOrExportAssignment(node)) return getSymbolOfNameOrPropertyAccessExpression(node);
                else if (parent2.kind === 209 /* BindingElement */  && grandParent.kind === 207 /* ObjectBindingPattern */  && node === parent2.propertyName) {
                    const typeOfPattern = getTypeOfNode(grandParent);
                    const propertyDeclaration = getPropertyOfType(typeOfPattern, node.escapedText);
                    if (propertyDeclaration) return propertyDeclaration;
                } else if (isMetaProperty(parent2) && parent2.name === node) {
                    if (parent2.keywordToken === 105 /* NewKeyword */  && idText(node) === "target") return checkNewTargetMetaProperty(parent2).symbol;
                    if (parent2.keywordToken === 102 /* ImportKeyword */  && idText(node) === "meta") return getGlobalImportMetaExpressionType().members.get("meta");
                    return void 0;
                }
            }
            switch(node.kind){
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                case 212 /* PropertyAccessExpression */ :
                case 167 /* QualifiedName */ :
                    if (!isThisInTypeQuery(node)) return getSymbolOfNameOrPropertyAccessExpression(node);
                // falls through
                case 110 /* ThisKeyword */ :
                    const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    if (isFunctionLike(container)) {
                        const sig = getSignatureFromDeclaration(container);
                        if (sig.thisParameter) return sig.thisParameter;
                    }
                    if (isInExpressionContext(node)) return checkExpression(node).symbol;
                // falls through
                case 198 /* ThisType */ :
                    return getTypeFromThisTypeNode(node).symbol;
                case 108 /* SuperKeyword */ :
                    return checkExpression(node).symbol;
                case 137 /* ConstructorKeyword */ :
                    const constructorDeclaration = node.parent;
                    if (constructorDeclaration && constructorDeclaration.kind === 177 /* Constructor */ ) return constructorDeclaration.parent.symbol;
                    return void 0;
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    if (isExternalModuleImportEqualsDeclaration(node.parent.parent) && getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node || (node.parent.kind === 273 /* ImportDeclaration */  || node.parent.kind === 279 /* ExportDeclaration */ ) && node.parent.moduleSpecifier === node || isInJSFile(node) && isJSDocImportTag(node.parent) && node.parent.moduleSpecifier === node || isInJSFile(node) && isRequireCall(node.parent, /*requireStringLiteralLikeArgument*/ false) || isImportCall(node.parent) || isLiteralTypeNode(node.parent) && isLiteralImportTypeNode(node.parent.parent) && node.parent.parent.argument === node.parent) return resolveExternalModuleName(node, node, ignoreErrors);
                    if (isCallExpression(parent2) && isBindableObjectDefinePropertyCall(parent2) && parent2.arguments[1] === node) return getSymbolOfDeclaration(parent2);
                // falls through
                case 9 /* NumericLiteral */ :
                    const objectType = isElementAccessExpression(parent2) ? parent2.argumentExpression === node ? getTypeOfExpression(parent2.expression) : void 0 : isLiteralTypeNode(parent2) && isIndexedAccessTypeNode(grandParent) ? getTypeFromTypeNode(grandParent.objectType) : void 0;
                    return objectType && getPropertyOfType(objectType, escapeLeadingUnderscores(node.text));
                case 90 /* DefaultKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 39 /* EqualsGreaterThanToken */ :
                case 86 /* ClassKeyword */ :
                    return getSymbolOfNode(node.parent);
                case 206 /* ImportType */ :
                    return isLiteralImportTypeNode(node) ? getSymbolAtLocation(node.argument.literal, ignoreErrors) : void 0;
                case 95 /* ExportKeyword */ :
                    return isExportAssignment(node.parent) ? Debug.checkDefined(node.parent.symbol) : void 0;
                case 102 /* ImportKeyword */ :
                    if (isMetaProperty(node.parent) && node.parent.name.escapedText === "defer") return void 0;
                // falls through
                case 105 /* NewKeyword */ :
                    return isMetaProperty(node.parent) ? checkMetaPropertyKeyword(node.parent).symbol : void 0;
                case 104 /* InstanceOfKeyword */ :
                    if (isBinaryExpression(node.parent)) {
                        const type = getTypeOfExpression(node.parent.right);
                        const hasInstanceMethodType = getSymbolHasInstanceMethodOfObjectType(type);
                        var _ref;
                        return (_ref = hasInstanceMethodType == null ? void 0 : hasInstanceMethodType.symbol) !== null && _ref !== void 0 ? _ref : type.symbol;
                    }
                    return void 0;
                case 237 /* MetaProperty */ :
                    return checkExpression(node).symbol;
                case 296 /* JsxNamespacedName */ :
                    if (isJSXTagName(node) && isJsxIntrinsicTagName(node)) {
                        const symbol = getIntrinsicTagSymbol(node.parent);
                        return symbol === unknownSymbol ? void 0 : symbol;
                    }
                // falls through
                default:
                    return void 0;
            }
        }
        function getIndexInfosAtLocation(node) {
            if (isIdentifier(node) && isPropertyAccessExpression(node.parent) && node.parent.name === node) {
                const keyType = getLiteralTypeFromPropertyName(node);
                const objectType = getTypeOfExpression(node.parent.expression);
                const objectTypes = objectType.flags & 1048576 /* Union */  ? objectType.types : [
                    objectType
                ];
                return flatMap(objectTypes, (t)=>filter(getIndexInfosOfType(t), (info)=>isApplicableIndexType(keyType, info.keyType)));
            }
            return void 0;
        }
        function getShorthandAssignmentValueSymbol(location) {
            if (location && location.kind === 305 /* ShorthandPropertyAssignment */ ) return resolveEntityName(location.name, 2208703 /* Alias */ , /*ignoreErrors*/ true);
            return void 0;
        }
        function getExportSpecifierLocalTargetSymbol(node) {
            if (isExportSpecifier(node)) {
                const name = node.propertyName || node.name;
                return node.parent.parent.moduleSpecifier ? getExternalModuleMember(node.parent.parent, node) : name.kind === 11 /* StringLiteral */  ? void 0 : // Skip for invalid syntax like this: export { "x" }
                resolveEntityName(name, 2998271 /* Alias */ , /*ignoreErrors*/ true);
            } else return resolveEntityName(node, 2998271 /* Alias */ , /*ignoreErrors*/ true);
        }
        function getTypeOfNode(node) {
            if (isSourceFile(node) && !isExternalModule(node)) return errorType;
            if (node.flags & 67108864 /* InWithStatement */ ) return errorType;
            const classDecl = tryGetClassImplementingOrExtendingExpressionWithTypeArguments(node);
            const classType = classDecl && getDeclaredTypeOfClassOrInterface(getSymbolOfDeclaration(classDecl.class));
            if (isPartOfTypeNode(node)) {
                const typeFromTypeNode = getTypeFromTypeNode(node);
                return classType ? getTypeWithThisArgument(typeFromTypeNode, classType.thisType) : typeFromTypeNode;
            }
            if (isExpressionNode(node)) return getRegularTypeOfExpression(node);
            if (classType && !classDecl.isImplements) {
                const baseType = firstOrUndefined(getBaseTypes(classType));
                return baseType ? getTypeWithThisArgument(baseType, classType.thisType) : errorType;
            }
            if (isTypeDeclaration(node)) {
                const symbol = getSymbolOfDeclaration(node);
                return getDeclaredTypeOfSymbol(symbol);
            }
            if (isTypeDeclarationName(node)) {
                const symbol = getSymbolAtLocation(node);
                return symbol ? getDeclaredTypeOfSymbol(symbol) : errorType;
            }
            if (isBindingElement(node)) return getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ true, 0 /* Normal */ ) || errorType;
            if (isDeclaration(node)) {
                const symbol = getSymbolOfDeclaration(node);
                return symbol ? getTypeOfSymbol(symbol) : errorType;
            }
            if (isDeclarationNameOrImportPropertyName(node)) {
                const symbol = getSymbolAtLocation(node);
                if (symbol) return getTypeOfSymbol(symbol);
                return errorType;
            }
            if (isBindingPattern(node)) return getTypeForVariableLikeDeclaration(node.parent, /*includeOptionality*/ true, 0 /* Normal */ ) || errorType;
            if (isInRightSideOfImportOrExportAssignment(node)) {
                const symbol = getSymbolAtLocation(node);
                if (symbol) {
                    const declaredType = getDeclaredTypeOfSymbol(symbol);
                    return !isErrorType(declaredType) ? declaredType : getTypeOfSymbol(symbol);
                }
            }
            if (isMetaProperty(node.parent) && node.parent.keywordToken === node.kind) return checkMetaPropertyKeyword(node.parent);
            if (isImportAttributes(node)) return getGlobalImportAttributesType(/*reportErrors*/ false);
            return errorType;
        }
        function getTypeOfAssignmentPattern(expr) {
            Debug.assert(expr.kind === 211 /* ObjectLiteralExpression */  || expr.kind === 210 /* ArrayLiteralExpression */ );
            if (expr.parent.kind === 251 /* ForOfStatement */ ) {
                const iteratedType = checkRightHandSideOfForOf(expr.parent);
                return checkDestructuringAssignment(expr, iteratedType || errorType);
            }
            if (expr.parent.kind === 227 /* BinaryExpression */ ) {
                const iteratedType = getTypeOfExpression(expr.parent.right);
                return checkDestructuringAssignment(expr, iteratedType || errorType);
            }
            if (expr.parent.kind === 304 /* PropertyAssignment */ ) {
                const node2 = cast(expr.parent.parent, isObjectLiteralExpression);
                const typeOfParentObjectLiteral = getTypeOfAssignmentPattern(node2) || errorType;
                const propertyIndex = indexOfNode(node2.properties, expr.parent);
                return checkObjectLiteralDestructuringPropertyAssignment(node2, typeOfParentObjectLiteral, propertyIndex);
            }
            const node = cast(expr.parent, isArrayLiteralExpression);
            const typeOfArrayLiteral = getTypeOfAssignmentPattern(node) || errorType;
            const elementType = checkIteratedTypeOrElementType(65 /* Destructuring */ , typeOfArrayLiteral, undefinedType, expr.parent) || errorType;
            return checkArrayLiteralDestructuringElementAssignment(node, typeOfArrayLiteral, node.elements.indexOf(expr), elementType);
        }
        function getPropertySymbolOfDestructuringAssignment(location) {
            const typeOfObjectLiteral = getTypeOfAssignmentPattern(cast(location.parent.parent, isAssignmentPattern));
            return typeOfObjectLiteral && getPropertyOfType(typeOfObjectLiteral, location.escapedText);
        }
        function getRegularTypeOfExpression(expr) {
            if (isRightSideOfQualifiedNameOrPropertyAccess(expr)) expr = expr.parent;
            return getRegularTypeOfLiteralType(getTypeOfExpression(expr));
        }
        function getParentTypeOfClassElement(node) {
            const classSymbol = getSymbolOfNode(node.parent);
            return isStatic(node) ? getTypeOfSymbol(classSymbol) : getDeclaredTypeOfSymbol(classSymbol);
        }
        function getClassElementPropertyKeyType(element) {
            const name = element.name;
            switch(name.kind){
                case 80 /* Identifier */ :
                    return getStringLiteralType(idText(name));
                case 9 /* NumericLiteral */ :
                case 11 /* StringLiteral */ :
                    return getStringLiteralType(name.text);
                case 168 /* ComputedPropertyName */ :
                    const nameType = checkComputedPropertyName(name);
                    return isTypeAssignableToKind(nameType, 12288 /* ESSymbolLike */ ) ? nameType : stringType;
                default:
                    return Debug.fail("Unsupported property name.");
            }
        }
        function getAugmentedPropertiesOfType(type) {
            type = getApparentType(type);
            const propsByName = createSymbolTable(getPropertiesOfType(type));
            const functionType = getSignaturesOfType(type, 0 /* Call */ ).length ? globalCallableFunctionType : getSignaturesOfType(type, 1 /* Construct */ ).length ? globalNewableFunctionType : void 0;
            if (functionType) forEach(getPropertiesOfType(functionType), (p)=>{
                if (!propsByName.has(p.escapedName)) propsByName.set(p.escapedName, p);
            });
            return getNamedMembers(propsByName);
        }
        function typeHasCallOrConstructSignatures(type) {
            return getSignaturesOfType(type, 0 /* Call */ ).length !== 0 || getSignaturesOfType(type, 1 /* Construct */ ).length !== 0;
        }
        function getRootSymbols(symbol) {
            const roots = getImmediateRootSymbols(symbol);
            return roots ? flatMap(roots, getRootSymbols) : [
                symbol
            ];
        }
        function getImmediateRootSymbols(symbol) {
            if (getCheckFlags(symbol) & 6 /* Synthetic */ ) return mapDefined(getSymbolLinks(symbol).containingType.types, (type)=>getPropertyOfType(type, symbol.escapedName));
            else if (symbol.flags & 33554432 /* Transient */ ) {
                const { links: { leftSpread, rightSpread, syntheticOrigin } } = symbol;
                return leftSpread ? [
                    leftSpread,
                    rightSpread
                ] : syntheticOrigin ? [
                    syntheticOrigin
                ] : singleElementArray(tryGetTarget(symbol));
            }
            return void 0;
        }
        function tryGetTarget(symbol) {
            let target;
            let next = symbol;
            while(next = getSymbolLinks(next).target)target = next;
            return target;
        }
        function isArgumentsLocalBinding(nodeIn) {
            if (isGeneratedIdentifier(nodeIn)) return false;
            const node = getParseTreeNode(nodeIn, isIdentifier);
            if (!node) return false;
            const parent2 = node.parent;
            if (!parent2) return false;
            const isPropertyName2 = (isPropertyAccessExpression(parent2) || isPropertyAssignment(parent2)) && parent2.name === node;
            return !isPropertyName2 && getReferencedValueSymbol(node) === argumentsSymbol;
        }
        function isNameOfModuleOrEnumDeclaration(node) {
            return isModuleOrEnumDeclaration(node.parent) && node === node.parent.name;
        }
        function getReferencedExportContainer(nodeIn, prefixLocals) {
            var _a;
            const node = getParseTreeNode(nodeIn, isIdentifier);
            if (node) {
                let symbol = getReferencedValueSymbol(node, /*startInDeclarationContainer*/ isNameOfModuleOrEnumDeclaration(node));
                if (symbol) {
                    if (symbol.flags & 1048576 /* ExportValue */ ) {
                        const exportSymbol = getMergedSymbol(symbol.exportSymbol);
                        if (!prefixLocals && exportSymbol.flags & 944 /* ExportHasLocal */  && !(exportSymbol.flags & 3 /* Variable */ )) return void 0;
                        symbol = exportSymbol;
                    }
                    const parentSymbol = getParentOfSymbol(symbol);
                    if (parentSymbol) {
                        if (parentSymbol.flags & 512 /* ValueModule */  && ((_a = parentSymbol.valueDeclaration) == null ? void 0 : _a.kind) === 308 /* SourceFile */ ) {
                            const symbolFile = parentSymbol.valueDeclaration;
                            const referenceFile = getSourceFileOfNode(node);
                            const symbolIsUmdExport = symbolFile !== referenceFile;
                            return symbolIsUmdExport ? void 0 : symbolFile;
                        }
                        return findAncestor(node.parent, (n)=>isModuleOrEnumDeclaration(n) && getSymbolOfDeclaration(n) === parentSymbol);
                    }
                }
            }
        }
        function getReferencedImportDeclaration(nodeIn) {
            const specifier = getIdentifierGeneratedImportReference(nodeIn);
            if (specifier) return specifier;
            const node = getParseTreeNode(nodeIn, isIdentifier);
            if (node) {
                const symbol = getReferencedValueOrAliasSymbol(node);
                if (isNonLocalAlias(symbol, /*excludes*/ 111551 /* Value */ ) && !getTypeOnlyAliasDeclaration(symbol, 111551 /* Value */ )) return getDeclarationOfAliasSymbol(symbol);
            }
            return void 0;
        }
        function isSymbolOfDestructuredElementOfCatchBinding(symbol) {
            return symbol.valueDeclaration && isBindingElement(symbol.valueDeclaration) && walkUpBindingElementsAndPatterns(symbol.valueDeclaration).parent.kind === 300 /* CatchClause */ ;
        }
        function isSymbolOfDeclarationWithCollidingName(symbol) {
            if (symbol.flags & 418 /* BlockScoped */  && symbol.valueDeclaration && !isSourceFile(symbol.valueDeclaration)) {
                const links = getSymbolLinks(symbol);
                if (links.isDeclarationWithCollidingName === void 0) {
                    const container = getEnclosingBlockScopeContainer(symbol.valueDeclaration);
                    if (isStatementWithLocals(container) || isSymbolOfDestructuredElementOfCatchBinding(symbol)) {
                        if (resolveName(container.parent, symbol.escapedName, 111551 /* Value */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ false)) links.isDeclarationWithCollidingName = true;
                        else if (hasNodeCheckFlag(symbol.valueDeclaration, 16384 /* CapturedBlockScopedBinding */ )) {
                            const isDeclaredInLoop = hasNodeCheckFlag(symbol.valueDeclaration, 32768 /* BlockScopedBindingInLoop */ );
                            const inLoopInitializer = isIterationStatement(container, /*lookInLabeledStatements*/ false);
                            const inLoopBodyBlock = container.kind === 242 /* Block */  && isIterationStatement(container.parent, /*lookInLabeledStatements*/ false);
                            links.isDeclarationWithCollidingName = !isBlockScopedContainerTopLevel(container) && (!isDeclaredInLoop || !inLoopInitializer && !inLoopBodyBlock);
                        } else links.isDeclarationWithCollidingName = false;
                    }
                }
                return links.isDeclarationWithCollidingName;
            }
            return false;
        }
        function getReferencedDeclarationWithCollidingName(nodeIn) {
            if (!isGeneratedIdentifier(nodeIn)) {
                const node = getParseTreeNode(nodeIn, isIdentifier);
                if (node) {
                    const symbol = getReferencedValueSymbol(node);
                    if (symbol && isSymbolOfDeclarationWithCollidingName(symbol)) return symbol.valueDeclaration;
                }
            }
            return void 0;
        }
        function isDeclarationWithCollidingName(nodeIn) {
            const node = getParseTreeNode(nodeIn, isDeclaration);
            if (node) {
                const symbol = getSymbolOfDeclaration(node);
                if (symbol) return isSymbolOfDeclarationWithCollidingName(symbol);
            }
            return false;
        }
        function isValueAliasDeclaration(node) {
            Debug.assert(canCollectSymbolAliasAccessabilityData);
            switch(node.kind){
                case 272 /* ImportEqualsDeclaration */ :
                    return isAliasResolvedToValue(getSymbolOfDeclaration(node));
                case 274 /* ImportClause */ :
                case 275 /* NamespaceImport */ :
                case 277 /* ImportSpecifier */ :
                case 282 /* ExportSpecifier */ :
                    const symbol = getSymbolOfDeclaration(node);
                    return !!symbol && isAliasResolvedToValue(symbol, /*excludeTypeOnlyValues*/ true);
                case 279 /* ExportDeclaration */ :
                    const exportClause = node.exportClause;
                    return !!exportClause && (isNamespaceExport(exportClause) || some(exportClause.elements, isValueAliasDeclaration));
                case 278 /* ExportAssignment */ :
                    return node.expression && node.expression.kind === 80 /* Identifier */  ? isAliasResolvedToValue(getSymbolOfDeclaration(node), /*excludeTypeOnlyValues*/ true) : true;
            }
            return false;
        }
        function isTopLevelValueImportEqualsWithEntityName(nodeIn) {
            const node = getParseTreeNode(nodeIn, isImportEqualsDeclaration);
            if (node === void 0 || node.parent.kind !== 308 /* SourceFile */  || !isInternalModuleImportEqualsDeclaration(node)) return false;
            const isValue = isAliasResolvedToValue(getSymbolOfDeclaration(node));
            return isValue && node.moduleReference && !nodeIsMissing(node.moduleReference);
        }
        function isAliasResolvedToValue(symbol, excludeTypeOnlyValues) {
            if (!symbol) return false;
            const container = getSourceFileOfNode(symbol.valueDeclaration);
            const fileSymbol = container && getSymbolOfDeclaration(container);
            resolveExternalModuleSymbol(fileSymbol);
            const target = getExportSymbolOfValueSymbolIfExported(resolveAlias(symbol));
            if (target === unknownSymbol) return !excludeTypeOnlyValues || !getTypeOnlyAliasDeclaration(symbol);
            return !!(getSymbolFlags(symbol, excludeTypeOnlyValues, /*excludeLocalMeanings*/ true) & 111551 /* Value */ ) && (shouldPreserveConstEnums(compilerOptions) || !isConstEnumOrConstEnumOnlyModule(target));
        }
        function isConstEnumOrConstEnumOnlyModule(s) {
            return isConstEnumSymbol(s) || !!s.constEnumOnlyModule;
        }
        function isReferencedAliasDeclaration(node, checkChildren) {
            Debug.assert(canCollectSymbolAliasAccessabilityData);
            if (isAliasSymbolDeclaration(node)) {
                const symbol = getSymbolOfDeclaration(node);
                const links = symbol && getSymbolLinks(symbol);
                if (links == null ? void 0 : links.referenced) return true;
                const target = getSymbolLinks(symbol).aliasTarget;
                if (target && getEffectiveModifierFlags(node) & 32 /* Export */  && getSymbolFlags(target) & 111551 /* Value */  && (shouldPreserveConstEnums(compilerOptions) || !isConstEnumOrConstEnumOnlyModule(target))) return true;
            }
            if (checkChildren) return !!forEachChild(node, (node2)=>isReferencedAliasDeclaration(node2, checkChildren));
            return false;
        }
        function isImplementationOfOverload(node) {
            if (nodeIsPresent(node.body)) {
                if (isGetAccessor(node) || isSetAccessor(node)) return false;
                const symbol = getSymbolOfDeclaration(node);
                const signaturesOfSymbol = getSignaturesOfSymbol(symbol);
                return signaturesOfSymbol.length > 1 || // If there is single signature for the symbol, it is overload if that signature isn't coming from the node
                // e.g.: function foo(a: string): string;
                //       function foo(a: any) { // This is implementation of the overloads
                //           return a;
                //       }
                signaturesOfSymbol.length === 1 && signaturesOfSymbol[0].declaration !== node;
            }
            return false;
        }
        function declaredParameterTypeContainsUndefined(parameter) {
            const typeNode = getNonlocalEffectiveTypeAnnotationNode(parameter);
            if (!typeNode) return false;
            const type = getTypeFromTypeNode(typeNode);
            return isErrorType(type) || containsUndefinedType(type);
        }
        function requiresAddingImplicitUndefined(parameter, enclosingDeclaration) {
            return (isRequiredInitializedParameter(parameter, enclosingDeclaration) || isOptionalUninitializedParameterProperty(parameter)) && !declaredParameterTypeContainsUndefined(parameter);
        }
        function isRequiredInitializedParameter(parameter, enclosingDeclaration) {
            if (!strictNullChecks || isOptionalParameter(parameter) || isJSDocParameterTag(parameter) || !parameter.initializer) return false;
            if (hasSyntacticModifier(parameter, 31 /* ParameterPropertyModifier */ )) return !!enclosingDeclaration && isFunctionLikeDeclaration(enclosingDeclaration);
            return true;
        }
        function isOptionalUninitializedParameterProperty(parameter) {
            return strictNullChecks && isOptionalParameter(parameter) && (isJSDocParameterTag(parameter) || !parameter.initializer) && hasSyntacticModifier(parameter, 31 /* ParameterPropertyModifier */ );
        }
        function isExpandoFunctionDeclaration(node) {
            const declaration = getParseTreeNode(node, (n)=>isFunctionDeclaration(n) || isVariableDeclaration(n));
            if (!declaration) return false;
            let symbol;
            if (isVariableDeclaration(declaration)) {
                if (declaration.type || !isInJSFile(declaration) && !isVarConstLike2(declaration)) return false;
                const initializer = getDeclaredExpandoInitializer(declaration);
                if (!initializer || !canHaveSymbol(initializer)) return false;
                symbol = getSymbolOfDeclaration(initializer);
            } else symbol = getSymbolOfDeclaration(declaration);
            if (!symbol || !(symbol.flags & 16 /* Function */  | 3 /* Variable */ )) return false;
            return !!forEachEntry(getExportsOfSymbol(symbol), (p)=>p.flags & 111551 /* Value */  && isExpandoPropertyDeclaration(p.valueDeclaration));
        }
        function getPropertiesOfContainerFunction(node) {
            const declaration = getParseTreeNode(node, isFunctionDeclaration);
            if (!declaration) return emptyArray;
            const symbol = getSymbolOfDeclaration(declaration);
            return symbol && getPropertiesOfType(getTypeOfSymbol(symbol)) || emptyArray;
        }
        function getNodeCheckFlags(node) {
            var _a;
            const nodeId = node.id || 0;
            if (nodeId < 0 || nodeId >= nodeLinks.length) return 0;
            return ((_a = nodeLinks[nodeId]) == null ? void 0 : _a.flags) || 0;
        }
        function hasNodeCheckFlag(node, flag) {
            calculateNodeCheckFlagWorker(node, flag);
            return !!(getNodeCheckFlags(node) & flag);
        }
        function calculateNodeCheckFlagWorker(node, flag) {
            if (!compilerOptions.noCheck && canIncludeBindAndCheckDiagnostics(getSourceFileOfNode(node), compilerOptions)) return;
            const links = getNodeLinks(node);
            if (links.calculatedFlags & flag) return;
            switch(flag){
                case 16 /* SuperInstance */ :
                case 32 /* SuperStatic */ :
                    return checkSingleSuperExpression(node);
                case 128 /* MethodWithSuperPropertyAccessInAsync */ :
                case 256 /* MethodWithSuperPropertyAssignmentInAsync */ :
                case 2097152 /* ContainsSuperPropertyInStaticInitializer */ :
                    return checkChildSuperExpressions(node);
                case 512 /* CaptureArguments */ :
                case 8192 /* ContainsCapturedBlockScopeBinding */ :
                case 65536 /* NeedsLoopOutParameter */ :
                case 262144 /* ContainsConstructorReference */ :
                    return checkChildIdentifiers(node);
                case 536870912 /* ConstructorReference */ :
                    return checkSingleIdentifier(node);
                case 4096 /* LoopWithCapturedBlockScopedBinding */ :
                case 32768 /* BlockScopedBindingInLoop */ :
                case 16384 /* CapturedBlockScopedBinding */ :
                    return checkContainingBlockScopeBindingUses(node);
                default:
                    return Debug.assertNever(flag, `Unhandled node check flag calculation: ${Debug.formatNodeCheckFlags(flag)}`);
            }
            function forEachNodeRecursively(root, cb) {
                const rootResult = cb(root, root.parent);
                if (rootResult === "skip") return void 0;
                if (rootResult) return rootResult;
                return forEachChildRecursively(root, cb);
            }
            function checkSuperExpressions(node2) {
                const links2 = getNodeLinks(node2);
                if (links2.calculatedFlags & flag) return "skip";
                links2.calculatedFlags |= 2097536 /* ContainsSuperPropertyInStaticInitializer */ ;
                checkSingleSuperExpression(node2);
                return void 0;
            }
            function checkChildSuperExpressions(node2) {
                forEachNodeRecursively(node2, checkSuperExpressions);
            }
            function checkSingleSuperExpression(node2) {
                const nodeLinks2 = getNodeLinks(node2);
                nodeLinks2.calculatedFlags |= 48 /* SuperStatic */ ;
                if (node2.kind === 108 /* SuperKeyword */ ) checkSuperExpression(node2);
            }
            function checkIdentifiers(node2) {
                const links2 = getNodeLinks(node2);
                if (links2.calculatedFlags & flag) return "skip";
                links2.calculatedFlags |= 336384 /* ContainsConstructorReference */ ;
                checkSingleIdentifier(node2);
                return void 0;
            }
            function checkChildIdentifiers(node2) {
                forEachNodeRecursively(node2, checkIdentifiers);
            }
            function isExpressionNodeOrShorthandPropertyAssignmentName(node2) {
                var _node2_parent_objectAssignmentInitializer;
                return isExpressionNode(node2) || isShorthandPropertyAssignment(node2.parent) && ((_node2_parent_objectAssignmentInitializer = node2.parent.objectAssignmentInitializer) !== null && _node2_parent_objectAssignmentInitializer !== void 0 ? _node2_parent_objectAssignmentInitializer : node2.parent.name) === node2;
            }
            function checkSingleIdentifier(node2) {
                const nodeLinks2 = getNodeLinks(node2);
                nodeLinks2.calculatedFlags |= 536870912 /* ConstructorReference */ ;
                if (isIdentifier(node2)) {
                    nodeLinks2.calculatedFlags |= 49152 /* CapturedBlockScopedBinding */ ;
                    if (isExpressionNodeOrShorthandPropertyAssignmentName(node2) && !(isPropertyAccessExpression(node2.parent) && node2.parent.name === node2)) {
                        const s = getResolvedSymbol(node2);
                        if (s && s !== unknownSymbol) checkIdentifierCalculateNodeCheckFlags(node2, s);
                    }
                }
            }
            function checkBlockScopeBindings(node2) {
                const links2 = getNodeLinks(node2);
                if (links2.calculatedFlags & flag) return "skip";
                links2.calculatedFlags |= 53248 /* CapturedBlockScopedBinding */ ;
                checkSingleBlockScopeBinding(node2);
                return void 0;
            }
            function checkContainingBlockScopeBindingUses(node2) {
                const scope = getEnclosingBlockScopeContainer(isDeclarationName(node2) ? node2.parent : node2);
                forEachNodeRecursively(scope, checkBlockScopeBindings);
            }
            function checkSingleBlockScopeBinding(node2) {
                checkSingleIdentifier(node2);
                if (isComputedPropertyName(node2)) checkComputedPropertyName(node2);
                if (isPrivateIdentifier(node2) && isClassElement(node2.parent)) setNodeLinksForPrivateIdentifierScope(node2.parent);
            }
        }
        function getEnumMemberValue(node) {
            computeEnumMemberValues(node.parent);
            var _getNodeLinks_enumMemberValue;
            return (_getNodeLinks_enumMemberValue = getNodeLinks(node).enumMemberValue) !== null && _getNodeLinks_enumMemberValue !== void 0 ? _getNodeLinks_enumMemberValue : evaluatorResult(/*value*/ void 0);
        }
        function canHaveConstantValue(node) {
            switch(node.kind){
                case 307 /* EnumMember */ :
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    return true;
            }
            return false;
        }
        function getConstantValue2(node) {
            if (node.kind === 307 /* EnumMember */ ) return getEnumMemberValue(node).value;
            if (!getNodeLinks(node).resolvedSymbol) checkExpressionCached(node);
            const symbol = getNodeLinks(node).resolvedSymbol || (isEntityNameExpression(node) ? resolveEntityName(node, 111551 /* Value */ , /*ignoreErrors*/ true) : void 0);
            if (symbol && symbol.flags & 8 /* EnumMember */ ) {
                const member = symbol.valueDeclaration;
                if (isEnumConst(member.parent)) return getEnumMemberValue(member).value;
            }
            return void 0;
        }
        function isFunctionType(type) {
            return !!(type.flags & 524288 /* Object */ ) && getSignaturesOfType(type, 0 /* Call */ ).length > 0;
        }
        function getTypeReferenceSerializationKind(typeNameIn, location) {
            var _a;
            const typeName = getParseTreeNode(typeNameIn, isEntityName);
            if (!typeName) return 0 /* Unknown */ ;
            if (location) {
                location = getParseTreeNode(location);
                if (!location) return 0 /* Unknown */ ;
            }
            let isTypeOnly = false;
            if (isQualifiedName(typeName)) {
                const rootValueSymbol = resolveEntityName(getFirstIdentifier(typeName), 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, location);
                isTypeOnly = !!((_a = rootValueSymbol == null ? void 0 : rootValueSymbol.declarations) == null ? void 0 : _a.every(isTypeOnlyImportOrExportDeclaration));
            }
            const valueSymbol = resolveEntityName(typeName, 111551 /* Value */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, location);
            const resolvedValueSymbol = valueSymbol && valueSymbol.flags & 2097152 /* Alias */  ? resolveAlias(valueSymbol) : valueSymbol;
            isTypeOnly || (isTypeOnly = !!(valueSymbol && getTypeOnlyAliasDeclaration(valueSymbol, 111551 /* Value */ )));
            const typeSymbol = resolveEntityName(typeName, 788968 /* Type */ , /*ignoreErrors*/ true, /*dontResolveAlias*/ true, location);
            const resolvedTypeSymbol = typeSymbol && typeSymbol.flags & 2097152 /* Alias */  ? resolveAlias(typeSymbol) : typeSymbol;
            if (!valueSymbol) isTypeOnly || (isTypeOnly = !!(typeSymbol && getTypeOnlyAliasDeclaration(typeSymbol, 788968 /* Type */ )));
            if (resolvedValueSymbol && resolvedValueSymbol === resolvedTypeSymbol) {
                const globalPromiseSymbol = getGlobalPromiseConstructorSymbol(/*reportErrors*/ false);
                if (globalPromiseSymbol && resolvedValueSymbol === globalPromiseSymbol) return 9 /* Promise */ ;
                const constructorType = getTypeOfSymbol(resolvedValueSymbol);
                if (constructorType && isConstructorType(constructorType)) return isTypeOnly ? 10 /* TypeWithCallSignature */  : 1 /* TypeWithConstructSignatureAndValue */ ;
            }
            if (!resolvedTypeSymbol) return isTypeOnly ? 11 /* ObjectType */  : 0 /* Unknown */ ;
            const type = getDeclaredTypeOfSymbol(resolvedTypeSymbol);
            if (isErrorType(type)) return isTypeOnly ? 11 /* ObjectType */  : 0 /* Unknown */ ;
            else if (type.flags & 3 /* AnyOrUnknown */ ) return 11 /* ObjectType */ ;
            else if (isTypeAssignableToKind(type, 245760 /* Never */ )) return 2 /* VoidNullableOrNeverType */ ;
            else if (isTypeAssignableToKind(type, 528 /* BooleanLike */ )) return 6 /* BooleanType */ ;
            else if (isTypeAssignableToKind(type, 296 /* NumberLike */ )) return 3 /* NumberLikeType */ ;
            else if (isTypeAssignableToKind(type, 2112 /* BigIntLike */ )) return 4 /* BigIntLikeType */ ;
            else if (isTypeAssignableToKind(type, 402653316 /* StringLike */ )) return 5 /* StringLikeType */ ;
            else if (isTupleType(type)) return 7 /* ArrayLikeType */ ;
            else if (isTypeAssignableToKind(type, 12288 /* ESSymbolLike */ )) return 8 /* ESSymbolType */ ;
            else if (isFunctionType(type)) return 10 /* TypeWithCallSignature */ ;
            else if (isArrayType(type)) return 7 /* ArrayLikeType */ ;
            else return 11 /* ObjectType */ ;
        }
        function createTypeOfDeclaration(declarationIn, enclosingDeclaration, flags, internalFlags, tracker) {
            const declaration = getParseTreeNode(declarationIn, hasInferredType);
            if (!declaration) return factory.createToken(133 /* AnyKeyword */ );
            const symbol = getSymbolOfDeclaration(declaration);
            return nodeBuilder.serializeTypeForDeclaration(declaration, symbol, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ , internalFlags, tracker);
        }
        function getAllAccessorDeclarationsForDeclaration(accessor) {
            accessor = getParseTreeNode(accessor, isGetOrSetAccessorDeclaration);
            const otherKind = accessor.kind === 179 /* SetAccessor */  ? 178 /* GetAccessor */  : 179 /* SetAccessor */ ;
            const otherAccessor = getDeclarationOfKind(getSymbolOfDeclaration(accessor), otherKind);
            const firstAccessor = otherAccessor && otherAccessor.pos < accessor.pos ? otherAccessor : accessor;
            const secondAccessor = otherAccessor && otherAccessor.pos < accessor.pos ? accessor : otherAccessor;
            const setAccessor = accessor.kind === 179 /* SetAccessor */  ? accessor : otherAccessor;
            const getAccessor = accessor.kind === 178 /* GetAccessor */  ? accessor : otherAccessor;
            return {
                firstAccessor,
                secondAccessor,
                setAccessor,
                getAccessor
            };
        }
        function createReturnTypeOfSignatureDeclaration(signatureDeclarationIn, enclosingDeclaration, flags, internalFlags, tracker) {
            const signatureDeclaration = getParseTreeNode(signatureDeclarationIn, isFunctionLike);
            if (!signatureDeclaration) return factory.createToken(133 /* AnyKeyword */ );
            return nodeBuilder.serializeReturnTypeForSignature(signatureDeclaration, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ , internalFlags, tracker);
        }
        function createTypeOfExpression(exprIn, enclosingDeclaration, flags, internalFlags, tracker) {
            const expr = getParseTreeNode(exprIn, isExpression);
            if (!expr) return factory.createToken(133 /* AnyKeyword */ );
            return nodeBuilder.serializeTypeForExpression(expr, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ , internalFlags, tracker);
        }
        function hasGlobalName(name) {
            return globals.has(escapeLeadingUnderscores(name));
        }
        function getReferencedValueSymbol(reference, startInDeclarationContainer) {
            const resolvedSymbol = getNodeLinks(reference).resolvedSymbol;
            if (resolvedSymbol) return resolvedSymbol;
            let location = reference;
            if (startInDeclarationContainer) {
                const parent2 = reference.parent;
                if (isDeclaration(parent2) && reference === parent2.name) location = getDeclarationContainer(parent2);
            }
            return resolveName(location, reference.escapedText, 3257279 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
        }
        function getReferencedValueOrAliasSymbol(reference) {
            const resolvedSymbol = getNodeLinks(reference).resolvedSymbol;
            if (resolvedSymbol && resolvedSymbol !== unknownSymbol) return resolvedSymbol;
            return resolveName(reference, reference.escapedText, 3257279 /* Alias */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true, /*excludeGlobals*/ void 0);
        }
        function getReferencedValueDeclaration(referenceIn) {
            if (!isGeneratedIdentifier(referenceIn)) {
                const reference = getParseTreeNode(referenceIn, isIdentifier);
                if (reference) {
                    const symbol = getReferencedValueSymbol(reference);
                    if (symbol) return getExportSymbolOfValueSymbolIfExported(symbol).valueDeclaration;
                }
            }
            return void 0;
        }
        function getReferencedValueDeclarations(referenceIn) {
            if (!isGeneratedIdentifier(referenceIn)) {
                const reference = getParseTreeNode(referenceIn, isIdentifier);
                if (reference) {
                    const symbol = getReferencedValueSymbol(reference);
                    if (symbol) return filter(getExportSymbolOfValueSymbolIfExported(symbol).declarations, (declaration)=>{
                        switch(declaration.kind){
                            case 261 /* VariableDeclaration */ :
                            case 170 /* Parameter */ :
                            case 209 /* BindingElement */ :
                            case 173 /* PropertyDeclaration */ :
                            case 304 /* PropertyAssignment */ :
                            case 305 /* ShorthandPropertyAssignment */ :
                            case 307 /* EnumMember */ :
                            case 211 /* ObjectLiteralExpression */ :
                            case 263 /* FunctionDeclaration */ :
                            case 219 /* FunctionExpression */ :
                            case 220 /* ArrowFunction */ :
                            case 264 /* ClassDeclaration */ :
                            case 232 /* ClassExpression */ :
                            case 267 /* EnumDeclaration */ :
                            case 175 /* MethodDeclaration */ :
                            case 178 /* GetAccessor */ :
                            case 179 /* SetAccessor */ :
                            case 268 /* ModuleDeclaration */ :
                                return true;
                        }
                        return false;
                    });
                }
            }
            return void 0;
        }
        function isLiteralConstDeclaration(node) {
            if (isDeclarationReadonly(node) || isVariableDeclaration(node) && isVarConstLike2(node)) return isFreshLiteralType(getTypeOfSymbol(getSymbolOfDeclaration(node)));
            return false;
        }
        function literalTypeToNode(type, enclosing, tracker) {
            const enumResult = type.flags & 1056 /* EnumLike */  ? nodeBuilder.symbolToExpression(type.symbol, 111551 /* Value */ , enclosing, /*flags*/ void 0, /*internalFlags*/ void 0, tracker) : type === trueType ? factory.createTrue() : type === falseType && factory.createFalse();
            if (enumResult) return enumResult;
            const literalValue = type.value;
            return typeof literalValue === "object" ? factory.createBigIntLiteral(literalValue) : typeof literalValue === "string" ? factory.createStringLiteral(literalValue) : literalValue < 0 ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createNumericLiteral(-literalValue)) : factory.createNumericLiteral(literalValue);
        }
        function createLiteralConstValue(node, tracker) {
            const type = getTypeOfSymbol(getSymbolOfDeclaration(node));
            return literalTypeToNode(type, node, tracker);
        }
        function getJsxFactoryEntity(location) {
            return location ? (getJsxNamespace(location), getSourceFileOfNode(location).localJsxFactory || _jsxFactoryEntity) : _jsxFactoryEntity;
        }
        function getJsxFragmentFactoryEntity(location) {
            if (location) {
                const file = getSourceFileOfNode(location);
                if (file) {
                    if (file.localJsxFragmentFactory) return file.localJsxFragmentFactory;
                    const jsxFragPragmas = file.pragmas.get("jsxfrag");
                    const jsxFragPragma = isArray(jsxFragPragmas) ? jsxFragPragmas[0] : jsxFragPragmas;
                    if (jsxFragPragma) {
                        file.localJsxFragmentFactory = parseIsolatedEntityName(jsxFragPragma.arguments.factory, languageVersion);
                        return file.localJsxFragmentFactory;
                    }
                }
            }
            if (compilerOptions.jsxFragmentFactory) return parseIsolatedEntityName(compilerOptions.jsxFragmentFactory, languageVersion);
        }
        function getNonlocalEffectiveTypeAnnotationNode(node) {
            const direct = getEffectiveTypeAnnotationNode(node);
            if (direct) return direct;
            if (node.kind === 170 /* Parameter */  && node.parent.kind === 179 /* SetAccessor */ ) {
                const other = getAllAccessorDeclarationsForDeclaration(node.parent).getAccessor;
                if (other) return getEffectiveReturnTypeNode(other);
            }
            return void 0;
        }
        function createResolver() {
            return {
                getReferencedExportContainer,
                getReferencedImportDeclaration,
                getReferencedDeclarationWithCollidingName,
                isDeclarationWithCollidingName,
                isValueAliasDeclaration: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn);
                    return node && canCollectSymbolAliasAccessabilityData ? isValueAliasDeclaration(node) : true;
                },
                hasGlobalName,
                isReferencedAliasDeclaration: (nodeIn, checkChildren)=>{
                    const node = getParseTreeNode(nodeIn);
                    return node && canCollectSymbolAliasAccessabilityData ? isReferencedAliasDeclaration(node, checkChildren) : true;
                },
                hasNodeCheckFlag: (nodeIn, flag)=>{
                    const node = getParseTreeNode(nodeIn);
                    if (!node) return false;
                    return hasNodeCheckFlag(node, flag);
                },
                isTopLevelValueImportEqualsWithEntityName,
                isDeclarationVisible,
                isImplementationOfOverload,
                requiresAddingImplicitUndefined,
                isExpandoFunctionDeclaration,
                getPropertiesOfContainerFunction,
                createTypeOfDeclaration,
                createReturnTypeOfSignatureDeclaration,
                createTypeOfExpression,
                createLiteralConstValue,
                isSymbolAccessible,
                isEntityNameVisible,
                getConstantValue: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, canHaveConstantValue);
                    return node ? getConstantValue2(node) : void 0;
                },
                getEnumMemberValue: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, isEnumMember);
                    return node ? getEnumMemberValue(node) : void 0;
                },
                collectLinkedAliases,
                markLinkedReferences: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn);
                    return node && markLinkedReferences(node, 0 /* Unspecified */ );
                },
                getReferencedValueDeclaration,
                getReferencedValueDeclarations,
                getTypeReferenceSerializationKind,
                isOptionalParameter,
                isArgumentsLocalBinding,
                getExternalModuleFileFromDeclaration: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, hasPossibleExternalModuleReference);
                    return node && getExternalModuleFileFromDeclaration(node);
                },
                isLiteralConstDeclaration,
                isLateBound: (nodeIn)=>{
                    const node = getParseTreeNode(nodeIn, isDeclaration);
                    const symbol = node && getSymbolOfDeclaration(node);
                    return !!(symbol && getCheckFlags(symbol) & 4096 /* Late */ );
                },
                getJsxFactoryEntity,
                getJsxFragmentFactoryEntity,
                isBindingCapturedByNode: (node, decl)=>{
                    const parseNode = getParseTreeNode(node);
                    const parseDecl = getParseTreeNode(decl);
                    return !!parseNode && !!parseDecl && (isVariableDeclaration(parseDecl) || isBindingElement(parseDecl)) && isBindingCapturedByNode(parseNode, parseDecl);
                },
                getDeclarationStatementsForSourceFile: (node, flags, internalFlags, tracker)=>{
                    const n = getParseTreeNode(node);
                    Debug.assert(n && n.kind === 308 /* SourceFile */ , "Non-sourcefile node passed into getDeclarationsForSourceFile");
                    const sym = getSymbolOfDeclaration(node);
                    if (!sym) return !node.locals ? [] : nodeBuilder.symbolTableToDeclarationStatements(node.locals, node, flags, internalFlags, tracker);
                    resolveExternalModuleSymbol(sym);
                    return !sym.exports ? [] : nodeBuilder.symbolTableToDeclarationStatements(sym.exports, node, flags, internalFlags, tracker);
                },
                isImportRequiredByAugmentation,
                isDefinitelyReferenceToGlobalSymbolObject,
                createLateBoundIndexSignatures: (cls, enclosing, flags, internalFlags, tracker)=>{
                    const sym = cls.symbol;
                    const staticInfos = getIndexInfosOfType(getTypeOfSymbol(sym));
                    const instanceIndexSymbol = getIndexSymbol(sym);
                    const instanceInfos = instanceIndexSymbol && getIndexInfosOfIndexSymbol(instanceIndexSymbol, arrayFrom(getMembersOfSymbol(sym).values()));
                    let result;
                    for (const infoList of [
                        staticInfos,
                        instanceInfos
                    ]){
                        if (!length(infoList)) continue;
                        result || (result = []);
                        for (const info of infoList){
                            if (info.declaration) continue;
                            if (info === anyBaseTypeIndexInfo) continue;
                            if (info.components) {
                                const allComponentComputedNamesSerializable = every(info.components, (e)=>{
                                    var _a;
                                    return !!(e.name && isComputedPropertyName(e.name) && isEntityNameExpression(e.name.expression) && enclosing && ((_a = isEntityNameVisible(e.name.expression, enclosing, /*shouldComputeAliasToMakeVisible*/ false)) == null ? void 0 : _a.accessibility) === 0 /* Accessible */ );
                                });
                                if (allComponentComputedNamesSerializable) {
                                    const newComponents = filter(info.components, (e)=>{
                                        return !hasLateBindableName(e);
                                    });
                                    result.push(...map(newComponents, (e)=>{
                                        trackComputedName(e.name.expression);
                                        const mods = infoList === staticInfos ? [
                                            factory.createModifier(126 /* StaticKeyword */ )
                                        ] : void 0;
                                        return factory.createPropertyDeclaration(append(mods, info.isReadonly ? factory.createModifier(148 /* ReadonlyKeyword */ ) : void 0), e.name, (isPropertySignature(e) || isPropertyDeclaration(e) || isMethodSignature(e) || isMethodDeclaration(e) || isGetAccessor(e) || isSetAccessor(e)) && e.questionToken ? factory.createToken(58 /* QuestionToken */ ) : void 0, nodeBuilder.typeToTypeNode(getTypeOfSymbol(e.symbol), enclosing, flags, internalFlags, tracker), /*initializer*/ void 0);
                                    }));
                                    continue;
                                }
                            }
                            const node = nodeBuilder.indexInfoToIndexSignatureDeclaration(info, enclosing, flags, internalFlags, tracker);
                            if (node && infoList === staticInfos) (node.modifiers || (node.modifiers = factory.createNodeArray())).unshift(factory.createModifier(126 /* StaticKeyword */ ));
                            if (node) result.push(node);
                        }
                    }
                    return result;
                    function trackComputedName(accessExpression) {
                        if (!tracker.trackSymbol) return;
                        const firstIdentifier = getFirstIdentifier(accessExpression);
                        const name = resolveName(firstIdentifier, firstIdentifier.escapedText, 1160127 /* ExportValue */ , /*nameNotFoundMessage*/ void 0, /*isUse*/ true);
                        if (name) tracker.trackSymbol(name, enclosing, 111551 /* Value */ );
                    }
                },
                symbolToDeclarations: (symbol, meaning, flags, maximumLength, verbosityLevel, out)=>{
                    return nodeBuilder.symbolToDeclarations(symbol, meaning, flags, maximumLength, verbosityLevel, out);
                }
            };
            function isImportRequiredByAugmentation(node) {
                const file = getSourceFileOfNode(node);
                if (!file.symbol) return false;
                const importTarget = getExternalModuleFileFromDeclaration(node);
                if (!importTarget) return false;
                if (importTarget === file) return false;
                const exports2 = getExportsOfModule(file.symbol);
                for (const s of arrayFrom(exports2.values()))if (s.mergeId) {
                    const merged = getMergedSymbol(s);
                    if (merged.declarations) for (const d of merged.declarations){
                        const declFile = getSourceFileOfNode(d);
                        if (declFile === importTarget) return true;
                    }
                }
                return false;
            }
        }
        function getExternalModuleFileFromDeclaration(declaration) {
            const specifier = declaration.kind === 268 /* ModuleDeclaration */  ? tryCast(declaration.name, isStringLiteral) : getExternalModuleName(declaration);
            const moduleSymbol = resolveExternalModuleNameWorker(specifier, specifier, /*moduleNotFoundError*/ void 0);
            if (!moduleSymbol) return void 0;
            return getDeclarationOfKind(moduleSymbol, 308 /* SourceFile */ );
        }
        function initializeTypeChecker() {
            for (const file of host.getSourceFiles())bindSourceFile(file, compilerOptions);
            amalgamatedDuplicates = /* @__PURE__ */ new Map();
            let augmentations;
            for (const file of host.getSourceFiles()){
                if (file.redirectInfo) continue;
                if (!isExternalOrCommonJsModule(file)) {
                    const fileGlobalThisSymbol = file.locals.get("globalThis");
                    if (fileGlobalThisSymbol == null ? void 0 : fileGlobalThisSymbol.declarations) for (const declaration of fileGlobalThisSymbol.declarations)diagnostics.add(createDiagnosticForNode(declaration, Diagnostics.Declaration_name_conflicts_with_built_in_global_identifier_0, "globalThis"));
                    mergeSymbolTable(globals, file.locals);
                }
                if (file.jsGlobalAugmentations) mergeSymbolTable(globals, file.jsGlobalAugmentations);
                if (file.patternAmbientModules && file.patternAmbientModules.length) patternAmbientModules = concatenate(patternAmbientModules, file.patternAmbientModules);
                if (file.moduleAugmentations.length) (augmentations || (augmentations = [])).push(file.moduleAugmentations);
                if (file.symbol && file.symbol.globalExports) {
                    const source = file.symbol.globalExports;
                    source.forEach((sourceSymbol, id)=>{
                        if (!globals.has(id)) globals.set(id, sourceSymbol);
                    });
                }
            }
            if (augmentations) {
                for (const list of augmentations)for (const augmentation of list){
                    if (!isGlobalScopeAugmentation(augmentation.parent)) continue;
                    mergeModuleAugmentation(augmentation);
                }
            }
            addUndefinedToGlobalsOrErrorOnRedeclaration();
            getSymbolLinks(undefinedSymbol).type = undefinedWideningType;
            getSymbolLinks(argumentsSymbol).type = getGlobalType("IArguments", /*arity*/ 0, /*reportErrors*/ true);
            getSymbolLinks(unknownSymbol).type = errorType;
            getSymbolLinks(globalThisSymbol).type = createObjectType(16 /* Anonymous */ , globalThisSymbol);
            globalArrayType = getGlobalType("Array", /*arity*/ 1, /*reportErrors*/ true);
            globalObjectType = getGlobalType("Object", /*arity*/ 0, /*reportErrors*/ true);
            globalFunctionType = getGlobalType("Function", /*arity*/ 0, /*reportErrors*/ true);
            globalCallableFunctionType = strictBindCallApply && getGlobalType("CallableFunction", /*arity*/ 0, /*reportErrors*/ true) || globalFunctionType;
            globalNewableFunctionType = strictBindCallApply && getGlobalType("NewableFunction", /*arity*/ 0, /*reportErrors*/ true) || globalFunctionType;
            globalStringType = getGlobalType("String", /*arity*/ 0, /*reportErrors*/ true);
            globalNumberType = getGlobalType("Number", /*arity*/ 0, /*reportErrors*/ true);
            globalBooleanType = getGlobalType("Boolean", /*arity*/ 0, /*reportErrors*/ true);
            globalRegExpType = getGlobalType("RegExp", /*arity*/ 0, /*reportErrors*/ true);
            anyArrayType = createArrayType(anyType);
            autoArrayType = createArrayType(autoType);
            if (autoArrayType === emptyObjectType) autoArrayType = createAnonymousType(/*symbol*/ void 0, emptySymbols, emptyArray, emptyArray, emptyArray);
            globalReadonlyArrayType = getGlobalTypeOrUndefined("ReadonlyArray", /*arity*/ 1) || globalArrayType;
            anyReadonlyArrayType = globalReadonlyArrayType ? createTypeFromGenericGlobalType(globalReadonlyArrayType, [
                anyType
            ]) : anyArrayType;
            globalThisType = getGlobalTypeOrUndefined("ThisType", /*arity*/ 1);
            if (augmentations) {
                for (const list of augmentations)for (const augmentation of list){
                    if (isGlobalScopeAugmentation(augmentation.parent)) continue;
                    mergeModuleAugmentation(augmentation);
                }
            }
            amalgamatedDuplicates.forEach(({ firstFile, secondFile, conflictingSymbols })=>{
                if (conflictingSymbols.size < 8) conflictingSymbols.forEach(({ isBlockScoped, firstFileLocations, secondFileLocations }, symbolName2)=>{
                    const message = isBlockScoped ? Diagnostics.Cannot_redeclare_block_scoped_variable_0 : Diagnostics.Duplicate_identifier_0;
                    for (const node of firstFileLocations)addDuplicateDeclarationError(node, message, symbolName2, secondFileLocations);
                    for (const node of secondFileLocations)addDuplicateDeclarationError(node, message, symbolName2, firstFileLocations);
                });
                else {
                    const list = arrayFrom(conflictingSymbols.keys()).join(", ");
                    diagnostics.add(addRelatedInfo(createDiagnosticForNode(firstFile, Diagnostics.Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0, list), createDiagnosticForNode(secondFile, Diagnostics.Conflicts_are_in_this_file)));
                    diagnostics.add(addRelatedInfo(createDiagnosticForNode(secondFile, Diagnostics.Definitions_of_the_following_identifiers_conflict_with_those_in_another_file_Colon_0, list), createDiagnosticForNode(firstFile, Diagnostics.Conflicts_are_in_this_file)));
                }
            });
            amalgamatedDuplicates = void 0;
        }
        function checkExternalEmitHelpers(location, helpers) {
            if (compilerOptions.importHelpers) {
                const sourceFile = getSourceFileOfNode(location);
                if (isEffectiveExternalModule(sourceFile, compilerOptions) && !(location.flags & 33554432 /* Ambient */ )) {
                    const helpersModule = resolveHelpersModule(sourceFile, location);
                    if (helpersModule !== unknownSymbol) {
                        const links = getSymbolLinks(helpersModule);
                        var _links_requestedExternalEmitHelpers;
                        (_links_requestedExternalEmitHelpers = links.requestedExternalEmitHelpers) !== null && _links_requestedExternalEmitHelpers !== void 0 ? _links_requestedExternalEmitHelpers : links.requestedExternalEmitHelpers = 0;
                        if ((links.requestedExternalEmitHelpers & helpers) !== helpers) {
                            const uncheckedHelpers = helpers & ~links.requestedExternalEmitHelpers;
                            for(let helper = 1 /* FirstEmitHelper */ ; helper <= 16777216 /* LastEmitHelper */ ; helper <<= 1){
                                if (uncheckedHelpers & helper) for (const name of getHelperNames(helper)){
                                    const symbol = resolveSymbol(getSymbol2(getExportsOfModule(helpersModule), escapeLeadingUnderscores(name), 111551 /* Value */ ));
                                    if (!symbol) error2(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_which_does_not_exist_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name);
                                    else if (helper & 524288 /* ClassPrivateFieldGet */ ) {
                                        if (!some(getSignaturesOfSymbol(symbol), (signature)=>getParameterCount(signature) > 3)) error2(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name, 4);
                                    } else if (helper & 1048576 /* ClassPrivateFieldSet */ ) {
                                        if (!some(getSignaturesOfSymbol(symbol), (signature)=>getParameterCount(signature) > 4)) error2(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name, 5);
                                    } else if (helper & 1024 /* SpreadArray */ ) {
                                        if (!some(getSignaturesOfSymbol(symbol), (signature)=>getParameterCount(signature) > 2)) error2(location, Diagnostics.This_syntax_requires_an_imported_helper_named_1_with_2_parameters_which_is_not_compatible_with_the_one_in_0_Consider_upgrading_your_version_of_0, externalHelpersModuleNameText, name, 3);
                                    }
                                }
                            }
                        }
                        links.requestedExternalEmitHelpers |= helpers;
                    }
                }
            }
        }
        function getHelperNames(helper) {
            switch(helper){
                case 1 /* Extends */ :
                    return [
                        "__extends"
                    ];
                case 2 /* Assign */ :
                    return [
                        "__assign"
                    ];
                case 4 /* Rest */ :
                    return [
                        "__rest"
                    ];
                case 8 /* Decorate */ :
                    return legacyDecorators ? [
                        "__decorate"
                    ] : [
                        "__esDecorate",
                        "__runInitializers"
                    ];
                case 16 /* Metadata */ :
                    return [
                        "__metadata"
                    ];
                case 32 /* Param */ :
                    return [
                        "__param"
                    ];
                case 64 /* Awaiter */ :
                    return [
                        "__awaiter"
                    ];
                case 128 /* Generator */ :
                    return [
                        "__generator"
                    ];
                case 256 /* Values */ :
                    return [
                        "__values"
                    ];
                case 512 /* Read */ :
                    return [
                        "__read"
                    ];
                case 1024 /* SpreadArray */ :
                    return [
                        "__spreadArray"
                    ];
                case 2048 /* Await */ :
                    return [
                        "__await"
                    ];
                case 4096 /* AsyncGenerator */ :
                    return [
                        "__asyncGenerator"
                    ];
                case 8192 /* AsyncDelegator */ :
                    return [
                        "__asyncDelegator"
                    ];
                case 16384 /* AsyncValues */ :
                    return [
                        "__asyncValues"
                    ];
                case 32768 /* ExportStar */ :
                    return [
                        "__exportStar"
                    ];
                case 65536 /* ImportStar */ :
                    return [
                        "__importStar"
                    ];
                case 131072 /* ImportDefault */ :
                    return [
                        "__importDefault"
                    ];
                case 262144 /* MakeTemplateObject */ :
                    return [
                        "__makeTemplateObject"
                    ];
                case 524288 /* ClassPrivateFieldGet */ :
                    return [
                        "__classPrivateFieldGet"
                    ];
                case 1048576 /* ClassPrivateFieldSet */ :
                    return [
                        "__classPrivateFieldSet"
                    ];
                case 2097152 /* ClassPrivateFieldIn */ :
                    return [
                        "__classPrivateFieldIn"
                    ];
                case 4194304 /* SetFunctionName */ :
                    return [
                        "__setFunctionName"
                    ];
                case 8388608 /* PropKey */ :
                    return [
                        "__propKey"
                    ];
                case 16777216 /* AddDisposableResourceAndDisposeResources */ :
                    return [
                        "__addDisposableResource",
                        "__disposeResources"
                    ];
                case 33554432 /* RewriteRelativeImportExtension */ :
                    return [
                        "__rewriteRelativeImportExtension"
                    ];
                default:
                    return Debug.fail("Unrecognized helper");
            }
        }
        function resolveHelpersModule(file, errorNode) {
            const links = getNodeLinks(file);
            if (!links.externalHelpersModule) links.externalHelpersModule = resolveExternalModule(getImportHelpersImportSpecifier(file), externalHelpersModuleNameText, Diagnostics.This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found, errorNode) || unknownSymbol;
            return links.externalHelpersModule;
        }
        function checkGrammarModifiers(node) {
            var _a;
            const quickResult = reportObviousDecoratorErrors(node) || reportObviousModifierErrors(node);
            if (quickResult !== void 0) return quickResult;
            if (isParameter(node) && parameterIsThisKeyword(node)) return grammarErrorOnFirstToken(node, Diagnostics.Neither_decorators_nor_modifiers_may_be_applied_to_this_parameters);
            const blockScopeKind = isVariableStatement(node) ? node.declarationList.flags & 7 /* BlockScoped */  : 0 /* None */ ;
            let lastStatic, lastDeclare, lastAsync, lastOverride, firstDecorator;
            let flags = 0 /* None */ ;
            let sawExportBeforeDecorators = false;
            let hasLeadingDecorators = false;
            for (const modifier of node.modifiers)if (isDecorator(modifier)) {
                if (!nodeCanBeDecorated(legacyDecorators, node, node.parent, node.parent.parent)) {
                    if (node.kind === 175 /* MethodDeclaration */  && !nodeIsPresent(node.body)) return grammarErrorOnFirstToken(node, Diagnostics.A_decorator_can_only_decorate_a_method_implementation_not_an_overload);
                    else return grammarErrorOnFirstToken(node, Diagnostics.Decorators_are_not_valid_here);
                } else if (legacyDecorators && (node.kind === 178 /* GetAccessor */  || node.kind === 179 /* SetAccessor */ )) {
                    const accessors = getAllAccessorDeclarationsForDeclaration(node);
                    if (hasDecorators(accessors.firstAccessor) && node === accessors.secondAccessor) return grammarErrorOnFirstToken(node, Diagnostics.Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name);
                }
                if (flags & -34849) return grammarErrorOnNode(modifier, Diagnostics.Decorators_are_not_valid_here);
                if (hasLeadingDecorators && flags & 98303 /* Modifier */ ) {
                    Debug.assertIsDefined(firstDecorator);
                    const sourceFile = getSourceFileOfNode(modifier);
                    if (!hasParseDiagnostics(sourceFile)) {
                        addRelatedInfo(error2(modifier, Diagnostics.Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export), createDiagnosticForNode(firstDecorator, Diagnostics.Decorator_used_before_export_here));
                        return true;
                    }
                    return false;
                }
                flags |= 32768 /* Decorator */ ;
                if (!(flags & 98303 /* Modifier */ )) hasLeadingDecorators = true;
                else if (flags & 32 /* Export */ ) sawExportBeforeDecorators = true;
                firstDecorator !== null && firstDecorator !== void 0 ? firstDecorator : firstDecorator = modifier;
            } else {
                if (modifier.kind !== 148 /* ReadonlyKeyword */ ) {
                    if (node.kind === 172 /* PropertySignature */  || node.kind === 174 /* MethodSignature */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_type_member, tokenToString(modifier.kind));
                    if (node.kind === 182 /* IndexSignature */  && (modifier.kind !== 126 /* StaticKeyword */  || !isClassLike(node.parent))) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_an_index_signature, tokenToString(modifier.kind));
                }
                if (modifier.kind !== 103 /* InKeyword */  && modifier.kind !== 147 /* OutKeyword */  && modifier.kind !== 87 /* ConstKeyword */ ) {
                    if (node.kind === 169 /* TypeParameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_type_parameter, tokenToString(modifier.kind));
                }
                switch(modifier.kind){
                    case 87 /* ConstKeyword */ :
                        {
                            if (node.kind !== 267 /* EnumDeclaration */  && node.kind !== 169 /* TypeParameter */ ) return grammarErrorOnNode(node, Diagnostics.A_class_member_cannot_have_the_0_keyword, tokenToString(87 /* ConstKeyword */ ));
                            const parent2 = isJSDocTemplateTag(node.parent) && getEffectiveJSDocHost(node.parent) || node.parent;
                            if (node.kind === 169 /* TypeParameter */  && !(isFunctionLikeDeclaration(parent2) || isClassLike(parent2) || isFunctionTypeNode(parent2) || isConstructorTypeNode(parent2) || isCallSignatureDeclaration(parent2) || isConstructSignatureDeclaration(parent2) || isMethodSignature(parent2))) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_can_only_appear_on_a_type_parameter_of_a_function_method_or_class, tokenToString(modifier.kind));
                            break;
                        }
                    case 164 /* OverrideKeyword */ :
                        if (flags & 16 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "override");
                        else if (flags & 128 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "override", "declare");
                        else if (flags & 8 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "override", "readonly");
                        else if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "override", "accessor");
                        else if (flags & 1024 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "override", "async");
                        flags |= 16 /* Override */ ;
                        lastOverride = modifier;
                        break;
                    case 125 /* PublicKeyword */ :
                    case 124 /* ProtectedKeyword */ :
                    case 123 /* PrivateKeyword */ :
                        const text = visibilityToString(modifierToFlag(modifier.kind));
                        if (flags & 7 /* AccessibilityModifier */ ) return grammarErrorOnNode(modifier, Diagnostics.Accessibility_modifier_already_seen);
                        else if (flags & 16 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "override");
                        else if (flags & 256 /* Static */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "static");
                        else if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "accessor");
                        else if (flags & 8 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "readonly");
                        else if (flags & 1024 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "async");
                        else if (node.parent.kind === 269 /* ModuleBlock */  || node.parent.kind === 308 /* SourceFile */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, text);
                        else if (flags & 64 /* Abstract */ ) {
                            if (modifier.kind === 123 /* PrivateKeyword */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, text, "abstract");
                            else return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, text, "abstract");
                        } else if (isPrivateIdentifierClassElementDeclaration(node)) return grammarErrorOnNode(modifier, Diagnostics.An_accessibility_modifier_cannot_be_used_with_a_private_identifier);
                        flags |= modifierToFlag(modifier.kind);
                        break;
                    case 126 /* StaticKeyword */ :
                        if (flags & 256 /* Static */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "static");
                        else if (flags & 8 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "readonly");
                        else if (flags & 1024 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "async");
                        else if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "accessor");
                        else if (node.parent.kind === 269 /* ModuleBlock */  || node.parent.kind === 308 /* SourceFile */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, "static");
                        else if (node.kind === 170 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "static");
                        else if (flags & 64 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
                        else if (flags & 16 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "static", "override");
                        flags |= 256 /* Static */ ;
                        lastStatic = modifier;
                        break;
                    case 129 /* AccessorKeyword */ :
                        if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "accessor");
                        else if (flags & 8 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "accessor", "readonly");
                        else if (flags & 128 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "accessor", "declare");
                        else if (node.kind !== 173 /* PropertyDeclaration */ ) return grammarErrorOnNode(modifier, Diagnostics.accessor_modifier_can_only_appear_on_a_property_declaration);
                        flags |= 512 /* Accessor */ ;
                        break;
                    case 148 /* ReadonlyKeyword */ :
                        if (flags & 8 /* Readonly */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "readonly");
                        else if (node.kind !== 173 /* PropertyDeclaration */  && node.kind !== 172 /* PropertySignature */  && node.kind !== 182 /* IndexSignature */  && node.kind !== 170 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics.readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature);
                        else if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "readonly", "accessor");
                        flags |= 8 /* Readonly */ ;
                        break;
                    case 95 /* ExportKeyword */ :
                        if (compilerOptions.verbatimModuleSyntax && !(node.flags & 33554432 /* Ambient */ ) && node.kind !== 266 /* TypeAliasDeclaration */  && node.kind !== 265 /* InterfaceDeclaration */  && // ModuleDeclaration needs to be checked that it is uninstantiated later
                        node.kind !== 268 /* ModuleDeclaration */  && node.parent.kind === 308 /* SourceFile */  && host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) === 1 /* CommonJS */ ) return grammarErrorOnNode(modifier, Diagnostics.A_top_level_export_modifier_cannot_be_used_on_value_declarations_in_a_CommonJS_module_when_verbatimModuleSyntax_is_enabled);
                        if (flags & 32 /* Export */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "export");
                        else if (flags & 128 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "declare");
                        else if (flags & 64 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "abstract");
                        else if (flags & 1024 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "async");
                        else if (isClassLike(node.parent)) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_class_elements_of_this_kind, "export");
                        else if (node.kind === 170 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "export");
                        else if (blockScopeKind === 4 /* Using */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_using_declaration, "export");
                        else if (blockScopeKind === 6 /* AwaitUsing */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_an_await_using_declaration, "export");
                        flags |= 32 /* Export */ ;
                        break;
                    case 90 /* DefaultKeyword */ :
                        const container = node.parent.kind === 308 /* SourceFile */  ? node.parent : node.parent.parent;
                        if (container.kind === 268 /* ModuleDeclaration */  && !isAmbientModule(container)) return grammarErrorOnNode(modifier, Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
                        else if (blockScopeKind === 4 /* Using */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_using_declaration, "default");
                        else if (blockScopeKind === 6 /* AwaitUsing */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_an_await_using_declaration, "default");
                        else if (!(flags & 32 /* Export */ )) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "export", "default");
                        else if (sawExportBeforeDecorators) return grammarErrorOnNode(firstDecorator, Diagnostics.Decorators_are_not_valid_here);
                        flags |= 2048 /* Default */ ;
                        break;
                    case 138 /* DeclareKeyword */ :
                        if (flags & 128 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "declare");
                        else if (flags & 1024 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
                        else if (flags & 16 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "override");
                        else if (isClassLike(node.parent) && !isPropertyDeclaration(node)) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_class_elements_of_this_kind, "declare");
                        else if (node.kind === 170 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "declare");
                        else if (blockScopeKind === 4 /* Using */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_using_declaration, "declare");
                        else if (blockScopeKind === 6 /* AwaitUsing */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_an_await_using_declaration, "declare");
                        else if (node.parent.flags & 33554432 /* Ambient */  && node.parent.kind === 269 /* ModuleBlock */ ) return grammarErrorOnNode(modifier, Diagnostics.A_declare_modifier_cannot_be_used_in_an_already_ambient_context);
                        else if (isPrivateIdentifierClassElementDeclaration(node)) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_a_private_identifier, "declare");
                        else if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "declare", "accessor");
                        flags |= 128 /* Ambient */ ;
                        lastDeclare = modifier;
                        break;
                    case 128 /* AbstractKeyword */ :
                        if (flags & 64 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "abstract");
                        if (node.kind !== 264 /* ClassDeclaration */  && node.kind !== 186 /* ConstructorType */ ) {
                            if (node.kind !== 175 /* MethodDeclaration */  && node.kind !== 173 /* PropertyDeclaration */  && node.kind !== 178 /* GetAccessor */  && node.kind !== 179 /* SetAccessor */ ) return grammarErrorOnNode(modifier, Diagnostics.abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration);
                            if (!(node.parent.kind === 264 /* ClassDeclaration */  && hasSyntacticModifier(node.parent, 64 /* Abstract */ ))) {
                                const message = node.kind === 173 /* PropertyDeclaration */  ? Diagnostics.Abstract_properties_can_only_appear_within_an_abstract_class : Diagnostics.Abstract_methods_can_only_appear_within_an_abstract_class;
                                return grammarErrorOnNode(modifier, message);
                            }
                            if (flags & 256 /* Static */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
                            if (flags & 2 /* Private */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "private", "abstract");
                            if (flags & 1024 /* Async */  && lastAsync) return grammarErrorOnNode(lastAsync, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "async", "abstract");
                            if (flags & 16 /* Override */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "abstract", "override");
                            if (flags & 512 /* Accessor */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "abstract", "accessor");
                        }
                        if (isNamedDeclaration(node) && node.name.kind === 81 /* PrivateIdentifier */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_a_private_identifier, "abstract");
                        flags |= 64 /* Abstract */ ;
                        break;
                    case 134 /* AsyncKeyword */ :
                        if (flags & 1024 /* Async */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, "async");
                        else if (flags & 128 /* Ambient */  || node.parent.flags & 33554432 /* Ambient */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
                        else if (node.kind === 170 /* Parameter */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_appear_on_a_parameter, "async");
                        if (flags & 64 /* Abstract */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "async", "abstract");
                        flags |= 1024 /* Async */ ;
                        lastAsync = modifier;
                        break;
                    case 103 /* InKeyword */ :
                    case 147 /* OutKeyword */ :
                        {
                            const inOutFlag = modifier.kind === 103 /* InKeyword */  ? 8192 /* In */  : 16384 /* Out */ ;
                            const inOutText = modifier.kind === 103 /* InKeyword */  ? "in" : "out";
                            const parent2 = isJSDocTemplateTag(node.parent) && (getEffectiveJSDocHost(node.parent) || find((_a = getJSDocRoot(node.parent)) == null ? void 0 : _a.tags, isJSDocTypedefTag)) || node.parent;
                            if (node.kind !== 169 /* TypeParameter */  || parent2 && !(isInterfaceDeclaration(parent2) || isClassLike(parent2) || isTypeAliasDeclaration(parent2) || isJSDocTypedefTag(parent2))) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_can_only_appear_on_a_type_parameter_of_a_class_interface_or_type_alias, inOutText);
                            if (flags & inOutFlag) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_already_seen, inOutText);
                            if (inOutFlag & 8192 /* In */  && flags & 16384 /* Out */ ) return grammarErrorOnNode(modifier, Diagnostics._0_modifier_must_precede_1_modifier, "in", "out");
                            flags |= inOutFlag;
                            break;
                        }
                }
            }
            if (node.kind === 177 /* Constructor */ ) {
                if (flags & 256 /* Static */ ) return grammarErrorOnNode(lastStatic, Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "static");
                if (flags & 16 /* Override */ ) return grammarErrorOnNode(lastOverride, Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "override");
                if (flags & 1024 /* Async */ ) return grammarErrorOnNode(lastAsync, Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "async");
                return false;
            } else if ((node.kind === 273 /* ImportDeclaration */  || node.kind === 272 /* ImportEqualsDeclaration */ ) && flags & 128 /* Ambient */ ) return grammarErrorOnNode(lastDeclare, Diagnostics.A_0_modifier_cannot_be_used_with_an_import_declaration, "declare");
            else if (node.kind === 170 /* Parameter */  && flags & 31 /* ParameterPropertyModifier */  && isBindingPattern(node.name)) return grammarErrorOnNode(node, Diagnostics.A_parameter_property_may_not_be_declared_using_a_binding_pattern);
            else if (node.kind === 170 /* Parameter */  && flags & 31 /* ParameterPropertyModifier */  && node.dotDotDotToken) return grammarErrorOnNode(node, Diagnostics.A_parameter_property_cannot_be_declared_using_a_rest_parameter);
            if (flags & 1024 /* Async */ ) return checkGrammarAsyncModifier(node, lastAsync);
            return false;
        }
        function reportObviousModifierErrors(node) {
            if (!node.modifiers) return false;
            const modifier = findFirstIllegalModifier(node);
            return modifier && grammarErrorOnFirstToken(modifier, Diagnostics.Modifiers_cannot_appear_here);
        }
        function findFirstModifierExcept(node, allowedModifier) {
            const modifier = find(node.modifiers, isModifier);
            return modifier && modifier.kind !== allowedModifier ? modifier : void 0;
        }
        function findFirstIllegalModifier(node) {
            switch(node.kind){
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 177 /* Constructor */ :
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 182 /* IndexSignature */ :
                case 268 /* ModuleDeclaration */ :
                case 273 /* ImportDeclaration */ :
                case 272 /* ImportEqualsDeclaration */ :
                case 279 /* ExportDeclaration */ :
                case 278 /* ExportAssignment */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 170 /* Parameter */ :
                case 169 /* TypeParameter */ :
                    return void 0;
                case 176 /* ClassStaticBlockDeclaration */ :
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                case 271 /* NamespaceExportDeclaration */ :
                case 283 /* MissingDeclaration */ :
                    return find(node.modifiers, isModifier);
                default:
                    if (node.parent.kind === 269 /* ModuleBlock */  || node.parent.kind === 308 /* SourceFile */ ) return void 0;
                    switch(node.kind){
                        case 263 /* FunctionDeclaration */ :
                            return findFirstModifierExcept(node, 134 /* AsyncKeyword */ );
                        case 264 /* ClassDeclaration */ :
                        case 186 /* ConstructorType */ :
                            return findFirstModifierExcept(node, 128 /* AbstractKeyword */ );
                        case 232 /* ClassExpression */ :
                        case 265 /* InterfaceDeclaration */ :
                        case 266 /* TypeAliasDeclaration */ :
                            return find(node.modifiers, isModifier);
                        case 244 /* VariableStatement */ :
                            return node.declarationList.flags & 4 /* Using */  ? findFirstModifierExcept(node, 135 /* AwaitKeyword */ ) : find(node.modifiers, isModifier);
                        case 267 /* EnumDeclaration */ :
                            return findFirstModifierExcept(node, 87 /* ConstKeyword */ );
                        default:
                            Debug.assertNever(node);
                    }
            }
        }
        function reportObviousDecoratorErrors(node) {
            const decorator = findFirstIllegalDecorator(node);
            return decorator && grammarErrorOnFirstToken(decorator, Diagnostics.Decorators_are_not_valid_here);
        }
        function findFirstIllegalDecorator(node) {
            return canHaveIllegalDecorators(node) ? find(node.modifiers, isDecorator) : void 0;
        }
        function checkGrammarAsyncModifier(node, asyncModifier) {
            switch(node.kind){
                case 175 /* MethodDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    return false;
            }
            return grammarErrorOnNode(asyncModifier, Diagnostics._0_modifier_cannot_be_used_here, "async");
        }
        function checkGrammarForDisallowedTrailingComma(list, diag2 = Diagnostics.Trailing_comma_not_allowed) {
            if (list && list.hasTrailingComma) return grammarErrorAtPos(list[0], list.end - 1, 1, diag2);
            return false;
        }
        function checkGrammarTypeParameterList(typeParameters, file) {
            if (typeParameters && typeParameters.length === 0) {
                const start = typeParameters.pos - 1;
                const end = skipTrivia(file.text, typeParameters.end) + 1;
                return grammarErrorAtPos(file, start, end - start, Diagnostics.Type_parameter_list_cannot_be_empty);
            }
            return false;
        }
        function checkGrammarParameterList(parameters) {
            let seenOptionalParameter = false;
            const parameterCount = parameters.length;
            for(let i = 0; i < parameterCount; i++){
                const parameter = parameters[i];
                if (parameter.dotDotDotToken) {
                    if (i !== parameterCount - 1) return grammarErrorOnNode(parameter.dotDotDotToken, Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
                    if (!(parameter.flags & 33554432 /* Ambient */ )) checkGrammarForDisallowedTrailingComma(parameters, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                    if (parameter.questionToken) return grammarErrorOnNode(parameter.questionToken, Diagnostics.A_rest_parameter_cannot_be_optional);
                    if (parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.A_rest_parameter_cannot_have_an_initializer);
                } else if (hasEffectiveQuestionToken(parameter)) {
                    seenOptionalParameter = true;
                    if (parameter.questionToken && parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.Parameter_cannot_have_question_mark_and_initializer);
                } else if (seenOptionalParameter && !parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.A_required_parameter_cannot_follow_an_optional_parameter);
            }
        }
        function getNonSimpleParameters(parameters) {
            return filter(parameters, (parameter)=>!!parameter.initializer || isBindingPattern(parameter.name) || isRestParameter(parameter));
        }
        function checkGrammarForUseStrictSimpleParameterList(node) {
            if (languageVersion >= 3 /* ES2016 */ ) {
                const useStrictDirective = node.body && isBlock(node.body) && findUseStrictPrologue(node.body.statements);
                if (useStrictDirective) {
                    const nonSimpleParameters = getNonSimpleParameters(node.parameters);
                    if (length(nonSimpleParameters)) {
                        forEach(nonSimpleParameters, (parameter)=>{
                            addRelatedInfo(error2(parameter, Diagnostics.This_parameter_is_not_allowed_with_use_strict_directive), createDiagnosticForNode(useStrictDirective, Diagnostics.use_strict_directive_used_here));
                        });
                        const diagnostics2 = nonSimpleParameters.map((parameter, index)=>index === 0 ? createDiagnosticForNode(parameter, Diagnostics.Non_simple_parameter_declared_here) : createDiagnosticForNode(parameter, Diagnostics.and_here));
                        addRelatedInfo(error2(useStrictDirective, Diagnostics.use_strict_directive_cannot_be_used_with_non_simple_parameter_list), ...diagnostics2);
                        return true;
                    }
                }
            }
            return false;
        }
        function checkGrammarFunctionLikeDeclaration(node) {
            const file = getSourceFileOfNode(node);
            return checkGrammarModifiers(node) || checkGrammarTypeParameterList(node.typeParameters, file) || checkGrammarParameterList(node.parameters) || checkGrammarArrowFunction(node, file) || isFunctionLikeDeclaration(node) && checkGrammarForUseStrictSimpleParameterList(node);
        }
        function checkGrammarClassLikeDeclaration(node) {
            const file = getSourceFileOfNode(node);
            return checkGrammarClassDeclarationHeritageClauses(node) || checkGrammarTypeParameterList(node.typeParameters, file);
        }
        function checkGrammarArrowFunction(node, file) {
            if (!isArrowFunction(node)) return false;
            if (node.typeParameters && !(length(node.typeParameters) > 1 || node.typeParameters.hasTrailingComma || node.typeParameters[0].constraint)) {
                if (file && fileExtensionIsOneOf(file.fileName, [
                    ".mts" /* Mts */ ,
                    ".cts" /* Cts */ 
                ])) grammarErrorOnNode(node.typeParameters[0], Diagnostics.This_syntax_is_reserved_in_files_with_the_mts_or_cts_extension_Add_a_trailing_comma_or_explicit_constraint);
            }
            const { equalsGreaterThanToken } = node;
            const startLine = getLineAndCharacterOfPosition(file, equalsGreaterThanToken.pos).line;
            const endLine = getLineAndCharacterOfPosition(file, equalsGreaterThanToken.end).line;
            return startLine !== endLine && grammarErrorOnNode(equalsGreaterThanToken, Diagnostics.Line_terminator_not_permitted_before_arrow);
        }
        function checkGrammarIndexSignatureParameters(node) {
            const parameter = node.parameters[0];
            if (node.parameters.length !== 1) {
                if (parameter) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_must_have_exactly_one_parameter);
                else return grammarErrorOnNode(node, Diagnostics.An_index_signature_must_have_exactly_one_parameter);
            }
            checkGrammarForDisallowedTrailingComma(node.parameters, Diagnostics.An_index_signature_cannot_have_a_trailing_comma);
            if (parameter.dotDotDotToken) return grammarErrorOnNode(parameter.dotDotDotToken, Diagnostics.An_index_signature_cannot_have_a_rest_parameter);
            if (hasEffectiveModifiers(parameter)) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_cannot_have_an_accessibility_modifier);
            if (parameter.questionToken) return grammarErrorOnNode(parameter.questionToken, Diagnostics.An_index_signature_parameter_cannot_have_a_question_mark);
            if (parameter.initializer) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_cannot_have_an_initializer);
            if (!parameter.type) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_must_have_a_type_annotation);
            const type = getTypeFromTypeNode(parameter.type);
            if (someType(type, (t)=>!!(t.flags & 8576 /* StringOrNumberLiteralOrUnique */ )) || isGenericType(type)) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_object_type_instead);
            if (!everyType(type, isValidIndexKeyType)) return grammarErrorOnNode(parameter.name, Diagnostics.An_index_signature_parameter_type_must_be_string_number_symbol_or_a_template_literal_type);
            if (!node.type) return grammarErrorOnNode(node, Diagnostics.An_index_signature_must_have_a_type_annotation);
            return false;
        }
        function checkGrammarIndexSignature(node) {
            return checkGrammarModifiers(node) || checkGrammarIndexSignatureParameters(node);
        }
        function checkGrammarForAtLeastOneTypeArgument(node, typeArguments) {
            if (typeArguments && typeArguments.length === 0) {
                const sourceFile = getSourceFileOfNode(node);
                const start = typeArguments.pos - 1;
                const end = skipTrivia(sourceFile.text, typeArguments.end) + 1;
                return grammarErrorAtPos(sourceFile, start, end - start, Diagnostics.Type_argument_list_cannot_be_empty);
            }
            return false;
        }
        function checkGrammarTypeArguments(node, typeArguments) {
            return checkGrammarForDisallowedTrailingComma(typeArguments) || checkGrammarForAtLeastOneTypeArgument(node, typeArguments);
        }
        function checkGrammarTaggedTemplateChain(node) {
            if (node.questionDotToken || node.flags & 64 /* OptionalChain */ ) return grammarErrorOnNode(node.template, Diagnostics.Tagged_template_expressions_are_not_permitted_in_an_optional_chain);
            return false;
        }
        function checkGrammarHeritageClause(node) {
            const types = node.types;
            if (checkGrammarForDisallowedTrailingComma(types)) return true;
            if (types && types.length === 0) {
                const listType = tokenToString(node.token);
                return grammarErrorAtPos(node, types.pos, 0, Diagnostics._0_list_cannot_be_empty, listType);
            }
            return some(types, checkGrammarExpressionWithTypeArguments);
        }
        function checkGrammarExpressionWithTypeArguments(node) {
            if (isExpressionWithTypeArguments(node) && isImportKeyword(node.expression) && node.typeArguments) return grammarErrorOnNode(node, Diagnostics.This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot_have_type_arguments);
            return checkGrammarTypeArguments(node, node.typeArguments);
        }
        function checkGrammarClassDeclarationHeritageClauses(node) {
            let seenExtendsClause = false;
            let seenImplementsClause = false;
            if (!checkGrammarModifiers(node) && node.heritageClauses) for (const heritageClause of node.heritageClauses){
                if (heritageClause.token === 96 /* ExtendsKeyword */ ) {
                    if (seenExtendsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.extends_clause_already_seen);
                    if (seenImplementsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.extends_clause_must_precede_implements_clause);
                    if (heritageClause.types.length > 1) return grammarErrorOnFirstToken(heritageClause.types[1], Diagnostics.Classes_can_only_extend_a_single_class);
                    seenExtendsClause = true;
                } else {
                    Debug.assert(heritageClause.token === 119 /* ImplementsKeyword */ );
                    if (seenImplementsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.implements_clause_already_seen);
                    seenImplementsClause = true;
                }
                checkGrammarHeritageClause(heritageClause);
            }
        }
        function checkGrammarInterfaceDeclaration(node) {
            let seenExtendsClause = false;
            if (node.heritageClauses) for (const heritageClause of node.heritageClauses){
                if (heritageClause.token === 96 /* ExtendsKeyword */ ) {
                    if (seenExtendsClause) return grammarErrorOnFirstToken(heritageClause, Diagnostics.extends_clause_already_seen);
                    seenExtendsClause = true;
                } else {
                    Debug.assert(heritageClause.token === 119 /* ImplementsKeyword */ );
                    return grammarErrorOnFirstToken(heritageClause, Diagnostics.Interface_declaration_cannot_have_implements_clause);
                }
                checkGrammarHeritageClause(heritageClause);
            }
            return false;
        }
        function checkGrammarComputedPropertyName(node) {
            if (node.kind !== 168 /* ComputedPropertyName */ ) return false;
            const computedPropertyName = node;
            if (computedPropertyName.expression.kind === 227 /* BinaryExpression */  && computedPropertyName.expression.operatorToken.kind === 28 /* CommaToken */ ) return grammarErrorOnNode(computedPropertyName.expression, Diagnostics.A_comma_expression_is_not_allowed_in_a_computed_property_name);
            return false;
        }
        function checkGrammarForGenerator(node) {
            if (node.asteriskToken) {
                Debug.assert(node.kind === 263 /* FunctionDeclaration */  || node.kind === 219 /* FunctionExpression */  || node.kind === 175 /* MethodDeclaration */ );
                if (node.flags & 33554432 /* Ambient */ ) return grammarErrorOnNode(node.asteriskToken, Diagnostics.Generators_are_not_allowed_in_an_ambient_context);
                if (!node.body) return grammarErrorOnNode(node.asteriskToken, Diagnostics.An_overload_signature_cannot_be_declared_as_a_generator);
            }
        }
        function checkGrammarForInvalidQuestionMark(questionToken, message) {
            return !!questionToken && grammarErrorOnNode(questionToken, message);
        }
        function checkGrammarForInvalidExclamationToken(exclamationToken, message) {
            return !!exclamationToken && grammarErrorOnNode(exclamationToken, message);
        }
        function checkGrammarObjectLiteralExpression(node, inDestructuring) {
            const seen = /* @__PURE__ */ new Map();
            for (const prop of node.properties){
                if (prop.kind === 306 /* SpreadAssignment */ ) {
                    if (inDestructuring) {
                        const expression = skipParentheses(prop.expression);
                        if (isArrayLiteralExpression(expression) || isObjectLiteralExpression(expression)) return grammarErrorOnNode(prop.expression, Diagnostics.A_rest_element_cannot_contain_a_binding_pattern);
                    }
                    continue;
                }
                const name = prop.name;
                if (name.kind === 168 /* ComputedPropertyName */ ) checkGrammarComputedPropertyName(name);
                if (prop.kind === 305 /* ShorthandPropertyAssignment */  && !inDestructuring && prop.objectAssignmentInitializer) grammarErrorOnNode(prop.equalsToken, Diagnostics.Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern);
                if (name.kind === 81 /* PrivateIdentifier */ ) grammarErrorOnNode(name, Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies);
                if (canHaveModifiers(prop) && prop.modifiers) {
                    for (const mod of prop.modifiers)if (isModifier(mod) && (mod.kind !== 134 /* AsyncKeyword */  || prop.kind !== 175 /* MethodDeclaration */ )) grammarErrorOnNode(mod, Diagnostics._0_modifier_cannot_be_used_here, getTextOfNode(mod));
                } else if (canHaveIllegalModifiers(prop) && prop.modifiers) {
                    for (const mod of prop.modifiers)if (isModifier(mod)) grammarErrorOnNode(mod, Diagnostics._0_modifier_cannot_be_used_here, getTextOfNode(mod));
                }
                let currentKind;
                switch(prop.kind){
                    case 305 /* ShorthandPropertyAssignment */ :
                    case 304 /* PropertyAssignment */ :
                        checkGrammarForInvalidExclamationToken(prop.exclamationToken, Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context);
                        checkGrammarForInvalidQuestionMark(prop.questionToken, Diagnostics.An_object_member_cannot_be_declared_optional);
                        if (name.kind === 9 /* NumericLiteral */ ) checkGrammarNumericLiteral(name);
                        if (name.kind === 10 /* BigIntLiteral */ ) addErrorOrSuggestion(/*isError*/ true, createDiagnosticForNode(name, Diagnostics.A_bigint_literal_cannot_be_used_as_a_property_name));
                        currentKind = 4 /* PropertyAssignment */ ;
                        break;
                    case 175 /* MethodDeclaration */ :
                        currentKind = 8 /* Method */ ;
                        break;
                    case 178 /* GetAccessor */ :
                        currentKind = 1 /* GetAccessor */ ;
                        break;
                    case 179 /* SetAccessor */ :
                        currentKind = 2 /* SetAccessor */ ;
                        break;
                    default:
                        Debug.assertNever(prop, "Unexpected syntax kind:" + prop.kind);
                }
                if (!inDestructuring) {
                    const effectiveName = getEffectivePropertyNameForPropertyNameNode(name);
                    if (effectiveName === void 0) continue;
                    const existingKind = seen.get(effectiveName);
                    if (!existingKind) seen.set(effectiveName, currentKind);
                    else {
                        if (currentKind & 8 /* Method */  && existingKind & 8 /* Method */ ) grammarErrorOnNode(name, Diagnostics.Duplicate_identifier_0, getTextOfNode(name));
                        else if (currentKind & 4 /* PropertyAssignment */  && existingKind & 4 /* PropertyAssignment */ ) grammarErrorOnNode(name, Diagnostics.An_object_literal_cannot_have_multiple_properties_with_the_same_name, getTextOfNode(name));
                        else if (currentKind & 3 /* GetOrSetAccessor */  && existingKind & 3 /* GetOrSetAccessor */ ) {
                            if (existingKind !== 3 /* GetOrSetAccessor */  && currentKind !== existingKind) seen.set(effectiveName, currentKind | existingKind);
                            else return grammarErrorOnNode(name, Diagnostics.An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name);
                        } else return grammarErrorOnNode(name, Diagnostics.An_object_literal_cannot_have_property_and_accessor_with_the_same_name);
                    }
                }
            }
        }
        function checkGrammarJsxElement(node) {
            checkGrammarJsxName(node.tagName);
            checkGrammarTypeArguments(node, node.typeArguments);
            const seen = /* @__PURE__ */ new Map();
            for (const attr of node.attributes.properties){
                if (attr.kind === 294 /* JsxSpreadAttribute */ ) continue;
                const { name, initializer } = attr;
                const escapedText = getEscapedTextOfJsxAttributeName(name);
                if (!seen.get(escapedText)) seen.set(escapedText, true);
                else return grammarErrorOnNode(name, Diagnostics.JSX_elements_cannot_have_multiple_attributes_with_the_same_name);
                if (initializer && initializer.kind === 295 /* JsxExpression */  && !initializer.expression) return grammarErrorOnNode(initializer, Diagnostics.JSX_attributes_must_only_be_assigned_a_non_empty_expression);
            }
        }
        function checkGrammarJsxName(node) {
            if (isPropertyAccessExpression(node) && isJsxNamespacedName(node.expression)) return grammarErrorOnNode(node.expression, Diagnostics.JSX_property_access_expressions_cannot_include_JSX_namespace_names);
            if (isJsxNamespacedName(node) && getJSXTransformEnabled(compilerOptions) && !isIntrinsicJsxName(node.namespace.escapedText)) return grammarErrorOnNode(node, Diagnostics.React_components_cannot_include_JSX_namespace_names);
        }
        function checkGrammarJsxExpression(node) {
            if (node.expression && isCommaSequence(node.expression)) return grammarErrorOnNode(node.expression, Diagnostics.JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array);
        }
        function checkGrammarForInOrForOfStatement(forInOrOfStatement) {
            if (checkGrammarStatementInAmbientContext(forInOrOfStatement)) return true;
            if (forInOrOfStatement.kind === 251 /* ForOfStatement */  && forInOrOfStatement.awaitModifier) {
                if (!(forInOrOfStatement.flags & 65536 /* AwaitContext */ )) {
                    const sourceFile = getSourceFileOfNode(forInOrOfStatement);
                    if (isInTopLevelContext(forInOrOfStatement)) {
                        if (!hasParseDiagnostics(sourceFile)) {
                            if (!isEffectiveExternalModule(sourceFile, compilerOptions)) diagnostics.add(createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module));
                            switch(moduleKind){
                                case 100 /* Node16 */ :
                                case 101 /* Node18 */ :
                                case 102 /* Node20 */ :
                                case 199 /* NodeNext */ :
                                    if (sourceFile.impliedNodeFormat === 1 /* CommonJS */ ) {
                                        diagnostics.add(createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.The_current_file_is_a_CommonJS_module_and_cannot_use_await_at_the_top_level));
                                        break;
                                    }
                                // fallthrough
                                case 7 /* ES2022 */ :
                                case 99 /* ESNext */ :
                                case 200 /* Preserve */ :
                                case 4 /* System */ :
                                    if (languageVersion >= 4 /* ES2017 */ ) break;
                                // fallthrough
                                default:
                                    diagnostics.add(createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher));
                                    break;
                            }
                        }
                    } else if (!hasParseDiagnostics(sourceFile)) {
                        const diagnostic = createDiagnosticForNode(forInOrOfStatement.awaitModifier, Diagnostics.for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules);
                        const func = getContainingFunction(forInOrOfStatement);
                        if (func && func.kind !== 177 /* Constructor */ ) {
                            Debug.assert((getFunctionFlags(func) & 2 /* Async */ ) === 0, "Enclosing function should never be an async function.");
                            const relatedInfo = createDiagnosticForNode(func, Diagnostics.Did_you_mean_to_mark_this_function_as_async);
                            addRelatedInfo(diagnostic, relatedInfo);
                        }
                        diagnostics.add(diagnostic);
                        return true;
                    }
                }
            }
            if (isForOfStatement(forInOrOfStatement) && !(forInOrOfStatement.flags & 65536 /* AwaitContext */ ) && isIdentifier(forInOrOfStatement.initializer) && forInOrOfStatement.initializer.escapedText === "async") {
                grammarErrorOnNode(forInOrOfStatement.initializer, Diagnostics.The_left_hand_side_of_a_for_of_statement_may_not_be_async);
                return false;
            }
            if (forInOrOfStatement.initializer.kind === 262 /* VariableDeclarationList */ ) {
                const variableList = forInOrOfStatement.initializer;
                if (!checkGrammarVariableDeclarationList(variableList)) {
                    const declarations = variableList.declarations;
                    if (!declarations.length) return false;
                    if (declarations.length > 1) {
                        const diagnostic = forInOrOfStatement.kind === 250 /* ForInStatement */  ? Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement : Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement;
                        return grammarErrorOnFirstToken(variableList.declarations[1], diagnostic);
                    }
                    const firstDeclaration = declarations[0];
                    if (firstDeclaration.initializer) {
                        const diagnostic = forInOrOfStatement.kind === 250 /* ForInStatement */  ? Diagnostics.The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer : Diagnostics.The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer;
                        return grammarErrorOnNode(firstDeclaration.name, diagnostic);
                    }
                    if (firstDeclaration.type) {
                        const diagnostic = forInOrOfStatement.kind === 250 /* ForInStatement */  ? Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation : Diagnostics.The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation;
                        return grammarErrorOnNode(firstDeclaration, diagnostic);
                    }
                }
            }
            return false;
        }
        function checkGrammarAccessor(accessor) {
            if (!(accessor.flags & 33554432 /* Ambient */ ) && accessor.parent.kind !== 188 /* TypeLiteral */  && accessor.parent.kind !== 265 /* InterfaceDeclaration */ ) {
                if (languageVersion < 2 /* ES2015 */  && isPrivateIdentifier(accessor.name)) return grammarErrorOnNode(accessor.name, Diagnostics.Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (accessor.body === void 0 && !hasSyntacticModifier(accessor, 64 /* Abstract */ )) return grammarErrorAtPos(accessor, accessor.end - 1, 1, Diagnostics._0_expected, "{");
            }
            if (accessor.body) {
                if (hasSyntacticModifier(accessor, 64 /* Abstract */ )) return grammarErrorOnNode(accessor, Diagnostics.An_abstract_accessor_cannot_have_an_implementation);
                if (accessor.parent.kind === 188 /* TypeLiteral */  || accessor.parent.kind === 265 /* InterfaceDeclaration */ ) return grammarErrorOnNode(accessor.body, Diagnostics.An_implementation_cannot_be_declared_in_ambient_contexts);
            }
            if (accessor.typeParameters) return grammarErrorOnNode(accessor.name, Diagnostics.An_accessor_cannot_have_type_parameters);
            if (!doesAccessorHaveCorrectParameterCount(accessor)) return grammarErrorOnNode(accessor.name, accessor.kind === 178 /* GetAccessor */  ? Diagnostics.A_get_accessor_cannot_have_parameters : Diagnostics.A_set_accessor_must_have_exactly_one_parameter);
            if (accessor.kind === 179 /* SetAccessor */ ) {
                if (accessor.type) return grammarErrorOnNode(accessor.name, Diagnostics.A_set_accessor_cannot_have_a_return_type_annotation);
                const parameter = Debug.checkDefined(getSetAccessorValueParameter(accessor), "Return value does not match parameter count assertion.");
                if (parameter.dotDotDotToken) return grammarErrorOnNode(parameter.dotDotDotToken, Diagnostics.A_set_accessor_cannot_have_rest_parameter);
                if (parameter.questionToken) return grammarErrorOnNode(parameter.questionToken, Diagnostics.A_set_accessor_cannot_have_an_optional_parameter);
                if (parameter.initializer) return grammarErrorOnNode(accessor.name, Diagnostics.A_set_accessor_parameter_cannot_have_an_initializer);
            }
            return false;
        }
        function doesAccessorHaveCorrectParameterCount(accessor) {
            return getAccessorThisParameter(accessor) || accessor.parameters.length === (accessor.kind === 178 /* GetAccessor */  ? 0 : 1);
        }
        function getAccessorThisParameter(accessor) {
            if (accessor.parameters.length === (accessor.kind === 178 /* GetAccessor */  ? 1 : 2)) return getThisParameter(accessor);
        }
        function checkGrammarTypeOperatorNode(node) {
            if (node.operator === 158 /* UniqueKeyword */ ) {
                if (node.type.kind !== 155 /* SymbolKeyword */ ) return grammarErrorOnNode(node.type, Diagnostics._0_expected, tokenToString(155 /* SymbolKeyword */ ));
                let parent2 = walkUpParenthesizedTypes(node.parent);
                if (isInJSFile(parent2) && isJSDocTypeExpression(parent2)) {
                    const host2 = getJSDocHost(parent2);
                    if (host2) parent2 = getSingleVariableOfVariableStatement(host2) || host2;
                }
                switch(parent2.kind){
                    case 261 /* VariableDeclaration */ :
                        const decl = parent2;
                        if (decl.name.kind !== 80 /* Identifier */ ) return grammarErrorOnNode(node, Diagnostics.unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name);
                        if (!isVariableDeclarationInVariableStatement(decl)) return grammarErrorOnNode(node, Diagnostics.unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement);
                        if (!(decl.parent.flags & 2 /* Const */ )) return grammarErrorOnNode(parent2.name, Diagnostics.A_variable_whose_type_is_a_unique_symbol_type_must_be_const);
                        break;
                    case 173 /* PropertyDeclaration */ :
                        if (!isStatic(parent2) || !hasEffectiveReadonlyModifier(parent2)) return grammarErrorOnNode(parent2.name, Diagnostics.A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly);
                        break;
                    case 172 /* PropertySignature */ :
                        if (!hasSyntacticModifier(parent2, 8 /* Readonly */ )) return grammarErrorOnNode(parent2.name, Diagnostics.A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly);
                        break;
                    default:
                        return grammarErrorOnNode(node, Diagnostics.unique_symbol_types_are_not_allowed_here);
                }
            } else if (node.operator === 148 /* ReadonlyKeyword */ ) {
                if (node.type.kind !== 189 /* ArrayType */  && node.type.kind !== 190 /* TupleType */ ) return grammarErrorOnFirstToken(node, Diagnostics.readonly_type_modifier_is_only_permitted_on_array_and_tuple_literal_types, tokenToString(155 /* SymbolKeyword */ ));
            }
        }
        function checkGrammarForInvalidDynamicName(node, message) {
            if (isNonBindableDynamicName(node) && !isEntityNameExpression(isElementAccessExpression(node) ? skipParentheses(node.argumentExpression) : node.expression)) return grammarErrorOnNode(node, message);
        }
        function checkGrammarMethod(node) {
            if (checkGrammarFunctionLikeDeclaration(node)) return true;
            if (node.kind === 175 /* MethodDeclaration */ ) {
                if (node.parent.kind === 211 /* ObjectLiteralExpression */ ) {
                    if (node.modifiers && !(node.modifiers.length === 1 && first(node.modifiers).kind === 134 /* AsyncKeyword */ )) return grammarErrorOnFirstToken(node, Diagnostics.Modifiers_cannot_appear_here);
                    else if (checkGrammarForInvalidQuestionMark(node.questionToken, Diagnostics.An_object_member_cannot_be_declared_optional)) return true;
                    else if (checkGrammarForInvalidExclamationToken(node.exclamationToken, Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context)) return true;
                    else if (node.body === void 0) return grammarErrorAtPos(node, node.end - 1, 1, Diagnostics._0_expected, "{");
                }
                if (checkGrammarForGenerator(node)) return true;
            }
            if (isClassLike(node.parent)) {
                if (languageVersion < 2 /* ES2015 */  && isPrivateIdentifier(node.name)) return grammarErrorOnNode(node.name, Diagnostics.Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (node.flags & 33554432 /* Ambient */ ) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
                else if (node.kind === 175 /* MethodDeclaration */  && !node.body) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
            } else if (node.parent.kind === 265 /* InterfaceDeclaration */ ) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
            else if (node.parent.kind === 188 /* TypeLiteral */ ) return checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
        }
        function checkGrammarBreakOrContinueStatement(node) {
            let current = node;
            while(current){
                if (isFunctionLikeOrClassStaticBlockDeclaration(current)) return grammarErrorOnNode(node, Diagnostics.Jump_target_cannot_cross_function_boundary);
                switch(current.kind){
                    case 257 /* LabeledStatement */ :
                        if (node.label && current.label.escapedText === node.label.escapedText) {
                            const isMisplacedContinueLabel = node.kind === 252 /* ContinueStatement */  && !isIterationStatement(current.statement, /*lookInLabeledStatements*/ true);
                            if (isMisplacedContinueLabel) return grammarErrorOnNode(node, Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement);
                            return false;
                        }
                        break;
                    case 256 /* SwitchStatement */ :
                        if (node.kind === 253 /* BreakStatement */  && !node.label) return false;
                        break;
                    default:
                        if (isIterationStatement(current, /*lookInLabeledStatements*/ false) && !node.label) return false;
                        break;
                }
                current = current.parent;
            }
            if (node.label) {
                const message = node.kind === 253 /* BreakStatement */  ? Diagnostics.A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement : Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement;
                return grammarErrorOnNode(node, message);
            } else {
                const message = node.kind === 253 /* BreakStatement */  ? Diagnostics.A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement : Diagnostics.A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement;
                return grammarErrorOnNode(node, message);
            }
        }
        function checkGrammarBindingElement(node) {
            if (node.dotDotDotToken) {
                const elements = node.parent.elements;
                if (node !== last(elements)) return grammarErrorOnNode(node, Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
                checkGrammarForDisallowedTrailingComma(elements, Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
                if (node.propertyName) return grammarErrorOnNode(node.name, Diagnostics.A_rest_element_cannot_have_a_property_name);
            }
            if (node.dotDotDotToken && node.initializer) return grammarErrorAtPos(node, node.initializer.pos - 1, 1, Diagnostics.A_rest_element_cannot_have_an_initializer);
        }
        function isStringOrNumberLiteralExpression(expr) {
            return isStringOrNumericLiteralLike(expr) || expr.kind === 225 /* PrefixUnaryExpression */  && expr.operator === 41 /* MinusToken */  && expr.operand.kind === 9 /* NumericLiteral */ ;
        }
        function isBigIntLiteralExpression(expr) {
            return expr.kind === 10 /* BigIntLiteral */  || expr.kind === 225 /* PrefixUnaryExpression */  && expr.operator === 41 /* MinusToken */  && expr.operand.kind === 10 /* BigIntLiteral */ ;
        }
        function isSimpleLiteralEnumReference(expr) {
            if ((isPropertyAccessExpression(expr) || isElementAccessExpression(expr) && isStringOrNumberLiteralExpression(expr.argumentExpression)) && isEntityNameExpression(expr.expression)) return !!(checkExpressionCached(expr).flags & 1056 /* EnumLike */ );
        }
        function checkAmbientInitializer(node) {
            const initializer = node.initializer;
            if (initializer) {
                const isInvalidInitializer = !(isStringOrNumberLiteralExpression(initializer) || isSimpleLiteralEnumReference(initializer) || initializer.kind === 112 /* TrueKeyword */  || initializer.kind === 97 /* FalseKeyword */  || isBigIntLiteralExpression(initializer));
                const isConstOrReadonly = isDeclarationReadonly(node) || isVariableDeclaration(node) && isVarConstLike2(node);
                if (isConstOrReadonly && !node.type) {
                    if (isInvalidInitializer) return grammarErrorOnNode(initializer, Diagnostics.A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_or_literal_enum_reference);
                } else return grammarErrorOnNode(initializer, Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
            }
        }
        function checkGrammarVariableDeclaration(node) {
            const nodeFlags = getCombinedNodeFlagsCached(node);
            const blockScopeKind = nodeFlags & 7 /* BlockScoped */ ;
            if (isBindingPattern(node.name)) switch(blockScopeKind){
                case 6 /* AwaitUsing */ :
                    return grammarErrorOnNode(node, Diagnostics._0_declarations_may_not_have_binding_patterns, "await using");
                case 4 /* Using */ :
                    return grammarErrorOnNode(node, Diagnostics._0_declarations_may_not_have_binding_patterns, "using");
            }
            if (node.parent.parent.kind !== 250 /* ForInStatement */  && node.parent.parent.kind !== 251 /* ForOfStatement */ ) {
                if (nodeFlags & 33554432 /* Ambient */ ) checkAmbientInitializer(node);
                else if (!node.initializer) {
                    if (isBindingPattern(node.name) && !isBindingPattern(node.parent)) return grammarErrorOnNode(node, Diagnostics.A_destructuring_declaration_must_have_an_initializer);
                    switch(blockScopeKind){
                        case 6 /* AwaitUsing */ :
                            return grammarErrorOnNode(node, Diagnostics._0_declarations_must_be_initialized, "await using");
                        case 4 /* Using */ :
                            return grammarErrorOnNode(node, Diagnostics._0_declarations_must_be_initialized, "using");
                        case 2 /* Const */ :
                            return grammarErrorOnNode(node, Diagnostics._0_declarations_must_be_initialized, "const");
                    }
                }
            }
            if (node.exclamationToken && (node.parent.parent.kind !== 244 /* VariableStatement */  || !node.type || node.initializer || nodeFlags & 33554432 /* Ambient */ )) {
                const message = node.initializer ? Diagnostics.Declarations_with_initializers_cannot_also_have_definite_assignment_assertions : !node.type ? Diagnostics.Declarations_with_definite_assignment_assertions_must_also_have_type_annotations : Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context;
                return grammarErrorOnNode(node.exclamationToken, message);
            }
            if (host.getEmitModuleFormatOfFile(getSourceFileOfNode(node)) < 4 /* System */  && !(node.parent.parent.flags & 33554432 /* Ambient */ ) && hasSyntacticModifier(node.parent.parent, 32 /* Export */ )) checkESModuleMarker(node.name);
            return !!blockScopeKind && checkGrammarNameInLetOrConstDeclarations(node.name);
        }
        function checkESModuleMarker(name) {
            if (name.kind === 80 /* Identifier */ ) {
                if (idText(name) === "__esModule") return grammarErrorOnNodeSkippedOn("noEmit", name, Diagnostics.Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules);
            } else {
                const elements = name.elements;
                for (const element of elements){
                    if (!isOmittedExpression(element)) return checkESModuleMarker(element.name);
                }
            }
            return false;
        }
        function checkGrammarNameInLetOrConstDeclarations(name) {
            if (name.kind === 80 /* Identifier */ ) {
                if (name.escapedText === "let") return grammarErrorOnNode(name, Diagnostics.let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations);
            } else {
                const elements = name.elements;
                for (const element of elements)if (!isOmittedExpression(element)) checkGrammarNameInLetOrConstDeclarations(element.name);
            }
            return false;
        }
        function checkGrammarVariableDeclarationList(declarationList) {
            const declarations = declarationList.declarations;
            if (checkGrammarForDisallowedTrailingComma(declarationList.declarations)) return true;
            if (!declarationList.declarations.length) return grammarErrorAtPos(declarationList, declarations.pos, declarations.end - declarations.pos, Diagnostics.Variable_declaration_list_cannot_be_empty);
            const blockScopeFlags = declarationList.flags & 7 /* BlockScoped */ ;
            if (blockScopeFlags === 4 /* Using */  || blockScopeFlags === 6 /* AwaitUsing */ ) {
                if (isForInStatement(declarationList.parent)) return grammarErrorOnNode(declarationList, blockScopeFlags === 4 /* Using */  ? Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_using_declaration : Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_an_await_using_declaration);
                if (declarationList.flags & 33554432 /* Ambient */ ) return grammarErrorOnNode(declarationList, blockScopeFlags === 4 /* Using */  ? Diagnostics.using_declarations_are_not_allowed_in_ambient_contexts : Diagnostics.await_using_declarations_are_not_allowed_in_ambient_contexts);
                if (blockScopeFlags === 6 /* AwaitUsing */ ) return checkAwaitGrammar(declarationList);
            }
            return false;
        }
        function allowBlockDeclarations(parent2) {
            switch(parent2.kind){
                case 246 /* IfStatement */ :
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                case 255 /* WithStatement */ :
                case 249 /* ForStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                    return false;
                case 257 /* LabeledStatement */ :
                    return allowBlockDeclarations(parent2.parent);
            }
            return true;
        }
        function checkGrammarForDisallowedBlockScopedVariableStatement(node) {
            if (!allowBlockDeclarations(node.parent)) {
                const blockScopeKind = getCombinedNodeFlagsCached(node.declarationList) & 7 /* BlockScoped */ ;
                if (blockScopeKind) {
                    const keyword = blockScopeKind === 1 /* Let */  ? "let" : blockScopeKind === 2 /* Const */  ? "const" : blockScopeKind === 4 /* Using */  ? "using" : blockScopeKind === 6 /* AwaitUsing */  ? "await using" : Debug.fail("Unknown BlockScope flag");
                    error2(node, Diagnostics._0_declarations_can_only_be_declared_inside_a_block, keyword);
                }
            }
        }
        function checkGrammarMetaProperty(node) {
            const escapedText = node.name.escapedText;
            switch(node.keywordToken){
                case 105 /* NewKeyword */ :
                    if (escapedText !== "target") return grammarErrorOnNode(node.name, Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, unescapeLeadingUnderscores(node.name.escapedText), tokenToString(node.keywordToken), "target");
                    break;
                case 102 /* ImportKeyword */ :
                    if (escapedText !== "meta") {
                        const isCallee = isCallExpression(node.parent) && node.parent.expression === node;
                        if (escapedText === "defer") {
                            if (!isCallee) return grammarErrorAtPos(node, node.end, 0, Diagnostics._0_expected, "(");
                        } else {
                            if (isCallee) return grammarErrorOnNode(node.name, Diagnostics._0_is_not_a_valid_meta_property_for_keyword_import_Did_you_mean_meta_or_defer, unescapeLeadingUnderscores(node.name.escapedText));
                            return grammarErrorOnNode(node.name, Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, unescapeLeadingUnderscores(node.name.escapedText), tokenToString(node.keywordToken), "meta");
                        }
                    }
                    break;
            }
        }
        function hasParseDiagnostics(sourceFile) {
            return sourceFile.parseDiagnostics.length > 0;
        }
        function grammarErrorOnFirstToken(node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                const span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                diagnostics.add(createFileDiagnostic(sourceFile, span.start, span.length, message, ...args));
                return true;
            }
            return false;
        }
        function grammarErrorAtPos(nodeForSourceFile, start, length2, message, ...args) {
            const sourceFile = getSourceFileOfNode(nodeForSourceFile);
            if (!hasParseDiagnostics(sourceFile)) {
                diagnostics.add(createFileDiagnostic(sourceFile, start, length2, message, ...args));
                return true;
            }
            return false;
        }
        function grammarErrorOnNodeSkippedOn(key, node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                errorSkippedOn(key, node, message, ...args);
                return true;
            }
            return false;
        }
        function grammarErrorOnNode(node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                error2(node, message, ...args);
                return true;
            }
            return false;
        }
        function checkGrammarConstructorTypeParameters(node) {
            const jsdocTypeParameters = isInJSFile(node) ? getJSDocTypeParameterDeclarations(node) : void 0;
            const range = node.typeParameters || jsdocTypeParameters && firstOrUndefined(jsdocTypeParameters);
            if (range) {
                const pos = range.pos === range.end ? range.pos : skipTrivia(getSourceFileOfNode(node).text, range.pos);
                return grammarErrorAtPos(node, pos, range.end - pos, Diagnostics.Type_parameters_cannot_appear_on_a_constructor_declaration);
            }
        }
        function checkGrammarConstructorTypeAnnotation(node) {
            const type = node.type || getEffectiveReturnTypeNode(node);
            if (type) return grammarErrorOnNode(type, Diagnostics.Type_annotation_cannot_appear_on_a_constructor_declaration);
        }
        function checkGrammarProperty(node) {
            if (isComputedPropertyName(node.name) && isBinaryExpression(node.name.expression) && node.name.expression.operatorToken.kind === 103 /* InKeyword */ ) return grammarErrorOnNode(node.parent.members[0], Diagnostics.A_mapped_type_may_not_declare_properties_or_methods);
            if (isClassLike(node.parent)) {
                if (isStringLiteral(node.name) && node.name.text === "constructor") return grammarErrorOnNode(node.name, Diagnostics.Classes_may_not_have_a_field_named_constructor);
                if (checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_class_property_declaration_must_have_a_simple_literal_type_or_a_unique_symbol_type)) return true;
                if (languageVersion < 2 /* ES2015 */  && isPrivateIdentifier(node.name)) return grammarErrorOnNode(node.name, Diagnostics.Private_identifiers_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (languageVersion < 2 /* ES2015 */  && isAutoAccessorPropertyDeclaration(node) && !(node.flags & 33554432 /* Ambient */ )) return grammarErrorOnNode(node.name, Diagnostics.Properties_with_the_accessor_modifier_are_only_available_when_targeting_ECMAScript_2015_and_higher);
                if (isAutoAccessorPropertyDeclaration(node) && checkGrammarForInvalidQuestionMark(node.questionToken, Diagnostics.An_accessor_property_cannot_be_declared_optional)) return true;
            } else if (node.parent.kind === 265 /* InterfaceDeclaration */ ) {
                if (checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) return true;
                Debug.assertNode(node, isPropertySignature);
                if (node.initializer) return grammarErrorOnNode(node.initializer, Diagnostics.An_interface_property_cannot_have_an_initializer);
            } else if (isTypeLiteralNode(node.parent)) {
                if (checkGrammarForInvalidDynamicName(node.name, Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) return true;
                Debug.assertNode(node, isPropertySignature);
                if (node.initializer) return grammarErrorOnNode(node.initializer, Diagnostics.A_type_literal_property_cannot_have_an_initializer);
            }
            if (node.flags & 33554432 /* Ambient */ ) checkAmbientInitializer(node);
            if (isPropertyDeclaration(node) && node.exclamationToken && (!isClassLike(node.parent) || !node.type || node.initializer || node.flags & 33554432 /* Ambient */  || isStatic(node) || hasAbstractModifier(node))) {
                const message = node.initializer ? Diagnostics.Declarations_with_initializers_cannot_also_have_definite_assignment_assertions : !node.type ? Diagnostics.Declarations_with_definite_assignment_assertions_must_also_have_type_annotations : Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context;
                return grammarErrorOnNode(node.exclamationToken, message);
            }
        }
        function checkGrammarTopLevelElementForRequiredDeclareModifier(node) {
            if (node.kind === 265 /* InterfaceDeclaration */  || node.kind === 266 /* TypeAliasDeclaration */  || node.kind === 273 /* ImportDeclaration */  || node.kind === 272 /* ImportEqualsDeclaration */  || node.kind === 279 /* ExportDeclaration */  || node.kind === 278 /* ExportAssignment */  || node.kind === 271 /* NamespaceExportDeclaration */  || hasSyntacticModifier(node, 2208 /* Default */ )) return false;
            return grammarErrorOnFirstToken(node, Diagnostics.Top_level_declarations_in_d_ts_files_must_start_with_either_a_declare_or_export_modifier);
        }
        function checkGrammarTopLevelElementsForRequiredDeclareModifier(file) {
            for (const decl of file.statements)if (isDeclaration(decl) || decl.kind === 244 /* VariableStatement */ ) {
                if (checkGrammarTopLevelElementForRequiredDeclareModifier(decl)) return true;
            }
            return false;
        }
        function checkGrammarSourceFile(node) {
            return !!(node.flags & 33554432 /* Ambient */ ) && checkGrammarTopLevelElementsForRequiredDeclareModifier(node);
        }
        function checkGrammarStatementInAmbientContext(node) {
            if (node.flags & 33554432 /* Ambient */ ) {
                const links = getNodeLinks(node);
                if (!links.hasReportedStatementInAmbientContext && (isFunctionLike(node.parent) || isAccessor(node.parent))) return getNodeLinks(node).hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, Diagnostics.An_implementation_cannot_be_declared_in_ambient_contexts);
                if (node.parent.kind === 242 /* Block */  || node.parent.kind === 269 /* ModuleBlock */  || node.parent.kind === 308 /* SourceFile */ ) {
                    const links2 = getNodeLinks(node.parent);
                    if (!links2.hasReportedStatementInAmbientContext) return links2.hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, Diagnostics.Statements_are_not_allowed_in_ambient_contexts);
                }
            }
            return false;
        }
        function checkGrammarNumericLiteral(node) {
            const isFractional = getTextOfNode(node).includes(".");
            const isScientific = node.numericLiteralFlags & 16 /* Scientific */ ;
            if (isFractional || isScientific) return;
            const value1 = +node.text;
            if (value1 <= 2 ** 53 - 1) return;
            addErrorOrSuggestion(/*isError*/ false, createDiagnosticForNode(node, Diagnostics.Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accurately_as_integers));
        }
        function checkGrammarBigIntLiteral(node) {
            const literalType = isLiteralTypeNode(node.parent) || isPrefixUnaryExpression(node.parent) && isLiteralTypeNode(node.parent.parent);
            if (!literalType) {
                if (!(node.flags & 33554432 /* Ambient */ ) && languageVersion < 7 /* ES2020 */ ) {
                    if (grammarErrorOnNode(node, Diagnostics.BigInt_literals_are_not_available_when_targeting_lower_than_ES2020)) return true;
                }
            }
            return false;
        }
        function grammarErrorAfterFirstToken(node, message, ...args) {
            const sourceFile = getSourceFileOfNode(node);
            if (!hasParseDiagnostics(sourceFile)) {
                const span = getSpanOfTokenAtPosition(sourceFile, node.pos);
                diagnostics.add(createFileDiagnostic(sourceFile, textSpanEnd(span), /*length*/ 0, message, ...args));
                return true;
            }
            return false;
        }
        function getAmbientModules() {
            if (!ambientModulesCache) {
                ambientModulesCache = [];
                globals.forEach((global2, sym)=>{
                    if (ambientModuleSymbolRegex.test(sym)) ambientModulesCache.push(global2);
                });
            }
            return ambientModulesCache;
        }
        function checkGrammarImportClause(node) {
            var _a, _b;
            if (node.phaseModifier === 156 /* TypeKeyword */ ) {
                if (node.name && node.namedBindings) return grammarErrorOnNode(node, Diagnostics.A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both);
                if (((_a = node.namedBindings) == null ? void 0 : _a.kind) === 276 /* NamedImports */ ) return checkGrammarNamedImportsOrExports(node.namedBindings);
            } else if (node.phaseModifier === 166 /* DeferKeyword */ ) {
                if (node.name) return grammarErrorOnNode(node, Diagnostics.Default_imports_are_not_allowed_in_a_deferred_import);
                if (((_b = node.namedBindings) == null ? void 0 : _b.kind) === 276 /* NamedImports */ ) return grammarErrorOnNode(node, Diagnostics.Named_imports_are_not_allowed_in_a_deferred_import);
                if (moduleKind !== 99 /* ESNext */  && moduleKind !== 200 /* Preserve */ ) return grammarErrorOnNode(node, Diagnostics.Deferred_imports_are_only_supported_when_the_module_flag_is_set_to_esnext_or_preserve);
            }
            return false;
        }
        function checkGrammarNamedImportsOrExports(namedBindings) {
            return !!forEach(namedBindings.elements, (specifier)=>{
                if (specifier.isTypeOnly) return grammarErrorOnFirstToken(specifier, specifier.kind === 277 /* ImportSpecifier */  ? Diagnostics.The_type_modifier_cannot_be_used_on_a_named_import_when_import_type_is_used_on_its_import_statement : Diagnostics.The_type_modifier_cannot_be_used_on_a_named_export_when_export_type_is_used_on_its_export_statement);
            });
        }
        function checkGrammarImportCallExpression(node) {
            if (compilerOptions.verbatimModuleSyntax && moduleKind === 1 /* CommonJS */ ) return grammarErrorOnNode(node, getVerbatimModuleSyntaxErrorMessage(node));
            if (node.expression.kind === 237 /* MetaProperty */ ) {
                if (moduleKind !== 99 /* ESNext */  && moduleKind !== 200 /* Preserve */ ) return grammarErrorOnNode(node, Diagnostics.Deferred_imports_are_only_supported_when_the_module_flag_is_set_to_esnext_or_preserve);
            } else if (moduleKind === 5 /* ES2015 */ ) return grammarErrorOnNode(node, Diagnostics.Dynamic_imports_are_only_supported_when_the_module_flag_is_set_to_es2020_es2022_esnext_commonjs_amd_system_umd_node16_node18_node20_or_nodenext);
            if (node.typeArguments) return grammarErrorOnNode(node, Diagnostics.This_use_of_import_is_invalid_import_calls_can_be_written_but_they_must_have_parentheses_and_cannot_have_type_arguments);
            const nodeArguments = node.arguments;
            if (!(100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ ) && moduleKind !== 99 /* ESNext */  && moduleKind !== 200 /* Preserve */ ) {
                checkGrammarForDisallowedTrailingComma(nodeArguments);
                if (nodeArguments.length > 1) {
                    const importAttributesArgument = nodeArguments[1];
                    return grammarErrorOnNode(importAttributesArgument, Diagnostics.Dynamic_imports_only_support_a_second_argument_when_the_module_option_is_set_to_esnext_node16_node18_node20_nodenext_or_preserve);
                }
            }
            if (nodeArguments.length === 0 || nodeArguments.length > 2) return grammarErrorOnNode(node, Diagnostics.Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_set_of_attributes_as_arguments);
            const spreadElement = find(nodeArguments, isSpreadElement);
            if (spreadElement) return grammarErrorOnNode(spreadElement, Diagnostics.Argument_of_dynamic_import_cannot_be_spread_element);
            return false;
        }
        function findMatchingTypeReferenceOrTypeAliasReference(source, unionTarget) {
            const sourceObjectFlags = getObjectFlags(source);
            if (sourceObjectFlags & 20 /* Anonymous */  && unionTarget.flags & 1048576 /* Union */ ) return find(unionTarget.types, (target)=>{
                if (target.flags & 524288 /* Object */ ) {
                    const overlapObjFlags = sourceObjectFlags & getObjectFlags(target);
                    if (overlapObjFlags & 4 /* Reference */ ) return source.target === target.target;
                    if (overlapObjFlags & 16 /* Anonymous */ ) return !!source.aliasSymbol && source.aliasSymbol === target.aliasSymbol;
                }
                return false;
            });
        }
        function findBestTypeForObjectLiteral(source, unionTarget) {
            if (getObjectFlags(source) & 128 /* ObjectLiteral */  && someType(unionTarget, isArrayLikeType)) return find(unionTarget.types, (t)=>!isArrayLikeType(t));
        }
        function findBestTypeForInvokable(source, unionTarget) {
            let signatureKind = 0 /* Call */ ;
            const hasSignatures2 = getSignaturesOfType(source, signatureKind).length > 0 || (signatureKind = 1 /* Construct */ , getSignaturesOfType(source, signatureKind).length > 0);
            if (hasSignatures2) return find(unionTarget.types, (t)=>getSignaturesOfType(t, signatureKind).length > 0);
        }
        function findMostOverlappyType(source, unionTarget) {
            let bestMatch;
            if (!(source.flags & 406978556 /* InstantiablePrimitive */ )) {
                let matchingCount = 0;
                for (const target of unionTarget.types)if (!(target.flags & 406978556 /* InstantiablePrimitive */ )) {
                    const overlap = getIntersectionType([
                        getIndexType(source),
                        getIndexType(target)
                    ]);
                    if (overlap.flags & 4194304 /* Index */ ) return target;
                    else if (isUnitType(overlap) || overlap.flags & 1048576 /* Union */ ) {
                        const len = overlap.flags & 1048576 /* Union */  ? countWhere(overlap.types, isUnitType) : 1;
                        if (len >= matchingCount) {
                            bestMatch = target;
                            matchingCount = len;
                        }
                    }
                }
            }
            return bestMatch;
        }
        function filterPrimitivesIfContainsNonPrimitive(type) {
            if (maybeTypeOfKind(type, 67108864 /* NonPrimitive */ )) {
                const result = filterType(type, (t)=>!(t.flags & 402784252 /* Primitive */ ));
                if (!(result.flags & 131072 /* Never */ )) return result;
            }
            return type;
        }
        function findMatchingDiscriminantType(source, target, isRelatedTo) {
            if (target.flags & 1048576 /* Union */  && source.flags & 2621440 /* Object */ ) {
                const match = getMatchingUnionConstituentForType(target, source);
                if (match) return match;
                const sourceProperties = getPropertiesOfType(source);
                if (sourceProperties) {
                    const sourcePropertiesFiltered = findDiscriminantProperties(sourceProperties, target);
                    if (sourcePropertiesFiltered) {
                        const discriminated = discriminateTypeByDiscriminableItems(target, map(sourcePropertiesFiltered, (p)=>[
                                ()=>getTypeOfSymbol(p),
                                p.escapedName
                            ]), isRelatedTo);
                        if (discriminated !== target) return discriminated;
                    }
                }
            }
            return void 0;
        }
        function getEffectivePropertyNameForPropertyNameNode(node) {
            const name = getPropertyNameForPropertyNameNode(node);
            return name ? name : isComputedPropertyName(node) ? tryGetNameFromType(getTypeOfExpression(node.expression)) : void 0;
        }
        function getCombinedModifierFlagsCached(node) {
            if (lastGetCombinedModifierFlagsNode === node) return lastGetCombinedModifierFlagsResult;
            lastGetCombinedModifierFlagsNode = node;
            lastGetCombinedModifierFlagsResult = getCombinedModifierFlags(node);
            return lastGetCombinedModifierFlagsResult;
        }
        function getCombinedNodeFlagsCached(node) {
            if (lastGetCombinedNodeFlagsNode === node) return lastGetCombinedNodeFlagsResult;
            lastGetCombinedNodeFlagsNode = node;
            lastGetCombinedNodeFlagsResult = getCombinedNodeFlags(node);
            return lastGetCombinedNodeFlagsResult;
        }
        function isVarConstLike2(node) {
            const blockScopeKind = getCombinedNodeFlagsCached(node) & 7 /* BlockScoped */ ;
            return blockScopeKind === 2 /* Const */  || blockScopeKind === 4 /* Using */  || blockScopeKind === 6 /* AwaitUsing */ ;
        }
        function getJSXRuntimeImportSpecifier(file, specifierText) {
            const jsxImportIndex = compilerOptions.importHelpers ? 1 : 0;
            const specifier = file == null ? void 0 : file.imports[jsxImportIndex];
            if (specifier) Debug.assert(nodeIsSynthesized(specifier) && specifier.text === specifierText, `Expected sourceFile.imports[${jsxImportIndex}] to be the synthesized JSX runtime import`);
            return specifier;
        }
        function getImportHelpersImportSpecifier(file) {
            Debug.assert(compilerOptions.importHelpers, "Expected importHelpers to be enabled");
            const specifier = file.imports[0];
            Debug.assert(specifier && nodeIsSynthesized(specifier) && specifier.text === "tslib", `Expected sourceFile.imports[0] to be the synthesized tslib import`);
            return specifier;
        }
    }
    function isNotAccessor(declaration) {
        return !isAccessor(declaration);
    }
    function isNotOverload(declaration) {
        return declaration.kind !== 263 /* FunctionDeclaration */  && declaration.kind !== 175 /* MethodDeclaration */  || !!declaration.body;
    }
    function isDeclarationNameOrImportPropertyName(name) {
        switch(name.parent.kind){
            case 277 /* ImportSpecifier */ :
            case 282 /* ExportSpecifier */ :
                return isIdentifier(name) || name.kind === 11 /* StringLiteral */ ;
            default:
                return isDeclarationName(name);
        }
    }
    var JsxNames;
    ((JsxNames2)=>{
        JsxNames2.JSX = "JSX";
        JsxNames2.IntrinsicElements = "IntrinsicElements";
        JsxNames2.ElementClass = "ElementClass";
        JsxNames2.ElementAttributesPropertyNameContainer = "ElementAttributesProperty";
        JsxNames2.ElementChildrenAttributeNameContainer = "ElementChildrenAttribute";
        JsxNames2.Element = "Element";
        JsxNames2.ElementType = "ElementType";
        JsxNames2.IntrinsicAttributes = "IntrinsicAttributes";
        JsxNames2.IntrinsicClassAttributes = "IntrinsicClassAttributes";
        JsxNames2.LibraryManagedAttributes = "LibraryManagedAttributes";
    })(JsxNames || (JsxNames = {}));
    var ReactNames;
    ((ReactNames2)=>{
        ReactNames2.Fragment = "Fragment";
    })(ReactNames || (ReactNames = {}));
    function getIterationTypesKeyFromIterationTypeKind(typeKind) {
        switch(typeKind){
            case 0 /* Yield */ :
                return "yieldType";
            case 1 /* Return */ :
                return "returnType";
            case 2 /* Next */ :
                return "nextType";
        }
    }
    function signatureHasRestParameter(s) {
        return !!(s.flags & 1 /* HasRestParameter */ );
    }
    function signatureHasLiteralTypes(s) {
        return !!(s.flags & 2 /* HasLiteralTypes */ );
    }
    function createBasicNodeBuilderModuleSpecifierResolutionHost(host) {
        return {
            getCommonSourceDirectory: !!host.getCommonSourceDirectory ? ()=>host.getCommonSourceDirectory() : ()=>"",
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            getSymlinkCache: maybeBind(host, host.getSymlinkCache),
            getPackageJsonInfoCache: ()=>{
                var _a;
                return (_a = host.getPackageJsonInfoCache) == null ? void 0 : _a.call(host);
            },
            useCaseSensitiveFileNames: ()=>host.useCaseSensitiveFileNames(),
            redirectTargetsMap: host.redirectTargetsMap,
            getRedirectFromSourceFile: (fileName)=>host.getRedirectFromSourceFile(fileName),
            isSourceOfProjectReferenceRedirect: (fileName)=>host.isSourceOfProjectReferenceRedirect(fileName),
            fileExists: (fileName)=>host.fileExists(fileName),
            getFileIncludeReasons: ()=>host.getFileIncludeReasons(),
            readFile: host.readFile ? (fileName)=>host.readFile(fileName) : void 0,
            getDefaultResolutionModeForFile: (file)=>host.getDefaultResolutionModeForFile(file),
            getModeForResolutionAtIndex: (file, index)=>host.getModeForResolutionAtIndex(file, index),
            getGlobalTypingsCacheLocation: maybeBind(host, host.getGlobalTypingsCacheLocation)
        };
    }
    var SymbolTrackerImpl = class _SymbolTrackerImpl {
        trackSymbol(symbol, enclosingDeclaration, meaning) {
            var _a, _b;
            if (((_a = this.inner) == null ? void 0 : _a.trackSymbol) && !this.disableTrackSymbol) {
                if (this.inner.trackSymbol(symbol, enclosingDeclaration, meaning)) {
                    this.onDiagnosticReported();
                    return true;
                }
                var _trackedSymbols;
                if (!(symbol.flags & 262144 /* TypeParameter */ )) ((_trackedSymbols = (_b = this.context).trackedSymbols) !== null && _trackedSymbols !== void 0 ? _trackedSymbols : _b.trackedSymbols = []).push([
                    symbol,
                    enclosingDeclaration,
                    meaning
                ]);
            }
            return false;
        }
        reportInaccessibleThisError() {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportInaccessibleThisError) {
                this.onDiagnosticReported();
                this.inner.reportInaccessibleThisError();
            }
        }
        reportPrivateInBaseOfClassExpression(propertyName) {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportPrivateInBaseOfClassExpression) {
                this.onDiagnosticReported();
                this.inner.reportPrivateInBaseOfClassExpression(propertyName);
            }
        }
        reportInaccessibleUniqueSymbolError() {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportInaccessibleUniqueSymbolError) {
                this.onDiagnosticReported();
                this.inner.reportInaccessibleUniqueSymbolError();
            }
        }
        reportCyclicStructureError() {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportCyclicStructureError) {
                this.onDiagnosticReported();
                this.inner.reportCyclicStructureError();
            }
        }
        reportLikelyUnsafeImportRequiredError(specifier) {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportLikelyUnsafeImportRequiredError) {
                this.onDiagnosticReported();
                this.inner.reportLikelyUnsafeImportRequiredError(specifier);
            }
        }
        reportTruncationError() {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportTruncationError) {
                this.onDiagnosticReported();
                this.inner.reportTruncationError();
            }
        }
        reportNonlocalAugmentation(containingFile, parentSymbol, augmentingSymbol) {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportNonlocalAugmentation) {
                this.onDiagnosticReported();
                this.inner.reportNonlocalAugmentation(containingFile, parentSymbol, augmentingSymbol);
            }
        }
        reportNonSerializableProperty(propertyName) {
            var _a;
            if ((_a = this.inner) == null ? void 0 : _a.reportNonSerializableProperty) {
                this.onDiagnosticReported();
                this.inner.reportNonSerializableProperty(propertyName);
            }
        }
        onDiagnosticReported() {
            this.context.reportedDiagnostic = true;
        }
        reportInferenceFallback(node) {
            var _a;
            if (((_a = this.inner) == null ? void 0 : _a.reportInferenceFallback) && !this.context.suppressReportInferenceFallback) {
                this.onDiagnosticReported();
                this.inner.reportInferenceFallback(node);
            }
        }
        pushErrorFallbackNode(node) {
            var _a, _b;
            return (_b = (_a = this.inner) == null ? void 0 : _a.pushErrorFallbackNode) == null ? void 0 : _b.call(_a, node);
        }
        popErrorFallbackNode() {
            var _a, _b;
            return (_b = (_a = this.inner) == null ? void 0 : _a.popErrorFallbackNode) == null ? void 0 : _b.call(_a);
        }
        constructor(context, tracker, moduleResolverHost){
            this.moduleResolverHost = void 0;
            this.inner = void 0;
            this.disableTrackSymbol = false;
            var _a;
            while(tracker instanceof _SymbolTrackerImpl)tracker = tracker.inner;
            this.inner = tracker;
            this.moduleResolverHost = moduleResolverHost;
            this.context = context;
            this.canTrackSymbol = !!((_a = this.inner) == null ? void 0 : _a.trackSymbol);
        }
    };
    // src/compiler/visitorPublic.ts
    function visitNode(node, visitor, test, lift) {
        if (node === void 0) return node;
        const visited = visitor(node);
        let visitedNode;
        if (visited === void 0) return void 0;
        else if (isArray(visited)) visitedNode = (lift || extractSingleNode)(visited);
        else visitedNode = visited;
        Debug.assertNode(visitedNode, test);
        return visitedNode;
    }
    function visitNodes2(nodes, visitor, test, start, count) {
        if (nodes === void 0) return nodes;
        const length2 = nodes.length;
        if (start === void 0 || start < 0) start = 0;
        if (count === void 0 || count > length2 - start) count = length2 - start;
        let hasTrailingComma;
        let pos = -1;
        let end = -1;
        if (start > 0 || count < length2) hasTrailingComma = nodes.hasTrailingComma && start + count === length2;
        else {
            pos = nodes.pos;
            end = nodes.end;
            hasTrailingComma = nodes.hasTrailingComma;
        }
        const updated = visitArrayWorker(nodes, visitor, test, start, count);
        if (updated !== nodes) {
            const updatedArray = factory.createNodeArray(updated, hasTrailingComma);
            setTextRangePosEnd(updatedArray, pos, end);
            return updatedArray;
        }
        return nodes;
    }
    function visitArray(nodes, visitor, test, start, count) {
        if (nodes === void 0) return nodes;
        const length2 = nodes.length;
        if (start === void 0 || start < 0) start = 0;
        if (count === void 0 || count > length2 - start) count = length2 - start;
        return visitArrayWorker(nodes, visitor, test, start, count);
    }
    function visitArrayWorker(nodes, visitor, test, start, count) {
        let updated;
        const length2 = nodes.length;
        if (start > 0 || count < length2) updated = [];
        for(let i = 0; i < count; i++){
            const node = nodes[i + start];
            const visited = node !== void 0 ? visitor ? visitor(node) : node : void 0;
            if (updated !== void 0 || visited === void 0 || visited !== node) {
                if (updated === void 0) {
                    updated = nodes.slice(0, i);
                    Debug.assertEachNode(updated, test);
                }
                if (visited) {
                    if (isArray(visited)) for (const visitedNode of visited){
                        Debug.assertNode(visitedNode, test);
                        updated.push(visitedNode);
                    }
                    else {
                        Debug.assertNode(visited, test);
                        updated.push(visited);
                    }
                }
            }
        }
        if (updated) return updated;
        Debug.assertEachNode(nodes, test);
        return nodes;
    }
    function visitLexicalEnvironment(statements, visitor, context, start, ensureUseStrict, nodesVisitor = visitNodes2) {
        context.startLexicalEnvironment();
        statements = nodesVisitor(statements, visitor, isStatement, start);
        if (ensureUseStrict) statements = context.factory.ensureUseStrict(statements);
        return factory.mergeLexicalEnvironment(statements, context.endLexicalEnvironment());
    }
    function visitParameterList(nodes, visitor, context, nodesVisitor = visitNodes2) {
        let updated;
        context.startLexicalEnvironment();
        if (nodes) {
            context.setLexicalEnvironmentFlags(1 /* InParameters */ , true);
            updated = nodesVisitor(nodes, visitor, isParameter);
            if (context.getLexicalEnvironmentFlags() & 2 /* VariablesHoistedInParameters */  && getEmitScriptTarget(context.getCompilerOptions()) >= 2 /* ES2015 */ ) updated = addDefaultValueAssignmentsIfNeeded(updated, context);
            context.setLexicalEnvironmentFlags(1 /* InParameters */ , false);
        }
        context.suspendLexicalEnvironment();
        return updated;
    }
    function addDefaultValueAssignmentsIfNeeded(parameters, context) {
        let result;
        for(let i = 0; i < parameters.length; i++){
            const parameter = parameters[i];
            const updated = addDefaultValueAssignmentIfNeeded(parameter, context);
            if (result || updated !== parameter) {
                if (!result) result = parameters.slice(0, i);
                result[i] = updated;
            }
        }
        if (result) return setTextRange(context.factory.createNodeArray(result, parameters.hasTrailingComma), parameters);
        return parameters;
    }
    function addDefaultValueAssignmentIfNeeded(parameter, context) {
        return parameter.dotDotDotToken ? parameter : isBindingPattern(parameter.name) ? addDefaultValueAssignmentForBindingPattern(parameter, context) : parameter.initializer ? addDefaultValueAssignmentForInitializer(parameter, parameter.name, parameter.initializer, context) : parameter;
    }
    function addDefaultValueAssignmentForBindingPattern(parameter, context) {
        const { factory: factory2 } = context;
        context.addInitializationStatement(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
            factory2.createVariableDeclaration(parameter.name, /*exclamationToken*/ void 0, parameter.type, parameter.initializer ? factory2.createConditionalExpression(factory2.createStrictEquality(factory2.getGeneratedNameForNode(parameter), factory2.createVoidZero()), /*questionToken*/ void 0, parameter.initializer, /*colonToken*/ void 0, factory2.getGeneratedNameForNode(parameter)) : factory2.getGeneratedNameForNode(parameter))
        ])));
        return factory2.updateParameterDeclaration(parameter, parameter.modifiers, parameter.dotDotDotToken, factory2.getGeneratedNameForNode(parameter), parameter.questionToken, parameter.type, /*initializer*/ void 0);
    }
    function addDefaultValueAssignmentForInitializer(parameter, name, initializer, context) {
        const factory2 = context.factory;
        context.addInitializationStatement(factory2.createIfStatement(factory2.createTypeCheck(factory2.cloneNode(name), "undefined"), setEmitFlags(setTextRange(factory2.createBlock([
            factory2.createExpressionStatement(setEmitFlags(setTextRange(factory2.createAssignment(setEmitFlags(factory2.cloneNode(name), 96 /* NoSourceMap */ ), setEmitFlags(initializer, 96 /* NoSourceMap */  | getEmitFlags(initializer) | 3072 /* NoComments */ )), parameter), 3072 /* NoComments */ ))
        ]), parameter), 3905 /* NoComments */ )));
        return factory2.updateParameterDeclaration(parameter, parameter.modifiers, parameter.dotDotDotToken, parameter.name, parameter.questionToken, parameter.type, /*initializer*/ void 0);
    }
    function visitFunctionBody(node, visitor, context, nodeVisitor = visitNode) {
        context.resumeLexicalEnvironment();
        const updated = nodeVisitor(node, visitor, isConciseBody);
        const declarations = context.endLexicalEnvironment();
        if (some(declarations)) {
            if (!updated) return context.factory.createBlock(declarations);
            const block = context.factory.converters.convertToFunctionBlock(updated);
            const statements = factory.mergeLexicalEnvironment(block.statements, declarations);
            return context.factory.updateBlock(block, statements);
        }
        return updated;
    }
    function visitIterationBody(body, visitor, context, nodeVisitor = visitNode) {
        context.startBlockScope();
        const updated = nodeVisitor(body, visitor, isStatement, context.factory.liftToBlock);
        Debug.assert(updated);
        const declarations = context.endBlockScope();
        if (some(declarations)) {
            if (isBlock(updated)) {
                declarations.push(...updated.statements);
                return context.factory.updateBlock(updated, declarations);
            }
            declarations.push(updated);
            return context.factory.createBlock(declarations);
        }
        return updated;
    }
    function visitCommaListElements(elements, visitor, discardVisitor = visitor) {
        if (discardVisitor === visitor || elements.length <= 1) return visitNodes2(elements, visitor, isExpression);
        let i = 0;
        const length2 = elements.length;
        return visitNodes2(elements, (node)=>{
            const discarded = i < length2 - 1;
            i++;
            return discarded ? discardVisitor(node) : visitor(node);
        }, isExpression);
    }
    function visitEachChild(node, visitor, context = nullTransformationContext, nodesVisitor = visitNodes2, tokenVisitor, nodeVisitor = visitNode) {
        if (node === void 0) return void 0;
        const fn = visitEachChildTable[node.kind];
        return fn === void 0 ? node : fn(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor);
    }
    var visitEachChildTable = {
        [167 /* QualifiedName */ ]: function visitEachChildOfQualifiedName(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateQualifiedName(node, Debug.checkDefined(nodeVisitor(node.left, visitor, isEntityName)), Debug.checkDefined(nodeVisitor(node.right, visitor, isIdentifier)));
        },
        [168 /* ComputedPropertyName */ ]: function visitEachChildOfComputedPropertyName(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateComputedPropertyName(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        // Signature elements
        [169 /* TypeParameter */ ]: function visitEachChildOfTypeParameterDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeParameterDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodeVisitor(node.constraint, visitor, isTypeNode), nodeVisitor(node.default, visitor, isTypeNode));
        },
        [170 /* Parameter */ ]: function visitEachChildOfParameterDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateParameterDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), tokenVisitor ? nodeVisitor(node.dotDotDotToken, tokenVisitor, isDotDotDotToken) : node.dotDotDotToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isBindingName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodeVisitor(node.type, visitor, isTypeNode), nodeVisitor(node.initializer, visitor, isExpression));
        },
        [171 /* Decorator */ ]: function visitEachChildOfDecorator(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateDecorator(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        // Type elements
        [172 /* PropertySignature */ ]: function visitEachChildOfPropertySignature(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updatePropertySignature(node, nodesVisitor(node.modifiers, visitor, isModifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodeVisitor(node.type, visitor, isTypeNode));
        },
        [173 /* PropertyDeclaration */ ]: function visitEachChildOfPropertyDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            var _node_questionToken, _node_questionToken1;
            return context.factory.updatePropertyDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), // QuestionToken and ExclamationToken are mutually exclusive in PropertyDeclaration
            tokenVisitor ? nodeVisitor((_node_questionToken = node.questionToken) !== null && _node_questionToken !== void 0 ? _node_questionToken : node.exclamationToken, tokenVisitor, isQuestionOrExclamationToken) : (_node_questionToken1 = node.questionToken) !== null && _node_questionToken1 !== void 0 ? _node_questionToken1 : node.exclamationToken, nodeVisitor(node.type, visitor, isTypeNode), nodeVisitor(node.initializer, visitor, isExpression));
        },
        [174 /* MethodSignature */ ]: function visitEachChildOfMethodSignature(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateMethodSignature(node, nodesVisitor(node.modifiers, visitor, isModifier), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), nodeVisitor(node.type, visitor, isTypeNode));
        },
        [175 /* MethodDeclaration */ ]: function visitEachChildOfMethodDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateMethodDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [177 /* Constructor */ ]: function visitEachChildOfConstructorDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateConstructorDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [178 /* GetAccessor */ ]: function visitEachChildOfGetAccessorDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateGetAccessorDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [179 /* SetAccessor */ ]: function visitEachChildOfSetAccessorDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateSetAccessorDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [176 /* ClassStaticBlockDeclaration */ ]: function visitEachChildOfClassStaticBlockDeclaration(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            context.startLexicalEnvironment();
            context.suspendLexicalEnvironment();
            return context.factory.updateClassStaticBlockDeclaration(node, visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [180 /* CallSignature */ ]: function visitEachChildOfCallSignatureDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateCallSignature(node, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), nodeVisitor(node.type, visitor, isTypeNode));
        },
        [181 /* ConstructSignature */ ]: function visitEachChildOfConstructSignatureDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateConstructSignature(node, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), nodeVisitor(node.type, visitor, isTypeNode));
        },
        [182 /* IndexSignature */ ]: function visitEachChildOfIndexSignatureDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateIndexSignature(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodesVisitor(node.parameters, visitor, isParameter), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        // Types
        [183 /* TypePredicate */ ]: function visitEachChildOfTypePredicateNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypePredicateNode(node, nodeVisitor(node.assertsModifier, visitor, isAssertsKeyword), Debug.checkDefined(nodeVisitor(node.parameterName, visitor, isIdentifierOrThisTypeNode)), nodeVisitor(node.type, visitor, isTypeNode));
        },
        [184 /* TypeReference */ ]: function visitEachChildOfTypeReferenceNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeReferenceNode(node, Debug.checkDefined(nodeVisitor(node.typeName, visitor, isEntityName)), nodesVisitor(node.typeArguments, visitor, isTypeNode));
        },
        [185 /* FunctionType */ ]: function visitEachChildOfFunctionTypeNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateFunctionTypeNode(node, nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [186 /* ConstructorType */ ]: function visitEachChildOfConstructorTypeNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateConstructorTypeNode(node, nodesVisitor(node.modifiers, visitor, isModifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, isParameter), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [187 /* TypeQuery */ ]: function visitEachChildOfTypeQueryNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeQueryNode(node, Debug.checkDefined(nodeVisitor(node.exprName, visitor, isEntityName)), nodesVisitor(node.typeArguments, visitor, isTypeNode));
        },
        [188 /* TypeLiteral */ ]: function visitEachChildOfTypeLiteralNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeLiteralNode(node, nodesVisitor(node.members, visitor, isTypeElement));
        },
        [189 /* ArrayType */ ]: function visitEachChildOfArrayTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateArrayTypeNode(node, Debug.checkDefined(nodeVisitor(node.elementType, visitor, isTypeNode)));
        },
        [190 /* TupleType */ ]: function visitEachChildOfTupleTypeNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateTupleTypeNode(node, nodesVisitor(node.elements, visitor, isTypeNode));
        },
        [191 /* OptionalType */ ]: function visitEachChildOfOptionalTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateOptionalTypeNode(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [192 /* RestType */ ]: function visitEachChildOfRestTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateRestTypeNode(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [193 /* UnionType */ ]: function visitEachChildOfUnionTypeNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateUnionTypeNode(node, nodesVisitor(node.types, visitor, isTypeNode));
        },
        [194 /* IntersectionType */ ]: function visitEachChildOfIntersectionTypeNode(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateIntersectionTypeNode(node, nodesVisitor(node.types, visitor, isTypeNode));
        },
        [195 /* ConditionalType */ ]: function visitEachChildOfConditionalTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateConditionalTypeNode(node, Debug.checkDefined(nodeVisitor(node.checkType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.extendsType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.trueType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.falseType, visitor, isTypeNode)));
        },
        [196 /* InferType */ ]: function visitEachChildOfInferTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateInferTypeNode(node, Debug.checkDefined(nodeVisitor(node.typeParameter, visitor, isTypeParameterDeclaration)));
        },
        [206 /* ImportType */ ]: function visitEachChildOfImportTypeNode(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportTypeNode(node, Debug.checkDefined(nodeVisitor(node.argument, visitor, isTypeNode)), nodeVisitor(node.attributes, visitor, isImportAttributes), nodeVisitor(node.qualifier, visitor, isEntityName), nodesVisitor(node.typeArguments, visitor, isTypeNode), node.isTypeOf);
        },
        [303 /* ImportTypeAssertionContainer */ ]: function visitEachChildOfImportTypeAssertionContainer(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportTypeAssertionContainer(node, Debug.checkDefined(nodeVisitor(node.assertClause, visitor, isAssertClause)), node.multiLine);
        },
        [203 /* NamedTupleMember */ ]: function visitEachChildOfNamedTupleMember(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateNamedTupleMember(node, tokenVisitor ? nodeVisitor(node.dotDotDotToken, tokenVisitor, isDotDotDotToken) : node.dotDotDotToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken) : node.questionToken, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [197 /* ParenthesizedType */ ]: function visitEachChildOfParenthesizedType(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateParenthesizedType(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [199 /* TypeOperator */ ]: function visitEachChildOfTypeOperatorNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeOperatorNode(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [200 /* IndexedAccessType */ ]: function visitEachChildOfIndexedAccessType(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateIndexedAccessTypeNode(node, Debug.checkDefined(nodeVisitor(node.objectType, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.indexType, visitor, isTypeNode)));
        },
        [201 /* MappedType */ ]: function visitEachChildOfMappedType(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateMappedTypeNode(node, tokenVisitor ? nodeVisitor(node.readonlyToken, tokenVisitor, isReadonlyKeywordOrPlusOrMinusToken) : node.readonlyToken, Debug.checkDefined(nodeVisitor(node.typeParameter, visitor, isTypeParameterDeclaration)), nodeVisitor(node.nameType, visitor, isTypeNode), tokenVisitor ? nodeVisitor(node.questionToken, tokenVisitor, isQuestionOrPlusOrMinusToken) : node.questionToken, nodeVisitor(node.type, visitor, isTypeNode), nodesVisitor(node.members, visitor, isTypeElement));
        },
        [202 /* LiteralType */ ]: function visitEachChildOfLiteralTypeNode(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateLiteralTypeNode(node, Debug.checkDefined(nodeVisitor(node.literal, visitor, isLiteralTypeLiteral)));
        },
        [204 /* TemplateLiteralType */ ]: function visitEachChildOfTemplateLiteralType(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTemplateLiteralType(node, Debug.checkDefined(nodeVisitor(node.head, visitor, isTemplateHead)), nodesVisitor(node.templateSpans, visitor, isTemplateLiteralTypeSpan));
        },
        [205 /* TemplateLiteralTypeSpan */ ]: function visitEachChildOfTemplateLiteralTypeSpan(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTemplateLiteralTypeSpan(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.literal, visitor, isTemplateMiddleOrTemplateTail)));
        },
        // Binding patterns
        [207 /* ObjectBindingPattern */ ]: function visitEachChildOfObjectBindingPattern(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateObjectBindingPattern(node, nodesVisitor(node.elements, visitor, isBindingElement));
        },
        [208 /* ArrayBindingPattern */ ]: function visitEachChildOfArrayBindingPattern(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateArrayBindingPattern(node, nodesVisitor(node.elements, visitor, isArrayBindingElement));
        },
        [209 /* BindingElement */ ]: function visitEachChildOfBindingElement(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateBindingElement(node, tokenVisitor ? nodeVisitor(node.dotDotDotToken, tokenVisitor, isDotDotDotToken) : node.dotDotDotToken, nodeVisitor(node.propertyName, visitor, isPropertyName), Debug.checkDefined(nodeVisitor(node.name, visitor, isBindingName)), nodeVisitor(node.initializer, visitor, isExpression));
        },
        // Expression
        [210 /* ArrayLiteralExpression */ ]: function visitEachChildOfArrayLiteralExpression(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateArrayLiteralExpression(node, nodesVisitor(node.elements, visitor, isExpression));
        },
        [211 /* ObjectLiteralExpression */ ]: function visitEachChildOfObjectLiteralExpression(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateObjectLiteralExpression(node, nodesVisitor(node.properties, visitor, isObjectLiteralElementLike));
        },
        [212 /* PropertyAccessExpression */ ]: function visitEachChildOfPropertyAccessExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return isPropertyAccessChain(node) ? context.factory.updatePropertyAccessChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), tokenVisitor ? nodeVisitor(node.questionDotToken, tokenVisitor, isQuestionDotToken) : node.questionDotToken, Debug.checkDefined(nodeVisitor(node.name, visitor, isMemberName))) : context.factory.updatePropertyAccessExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.name, visitor, isMemberName)));
        },
        [213 /* ElementAccessExpression */ ]: function visitEachChildOfElementAccessExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return isElementAccessChain(node) ? context.factory.updateElementAccessChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), tokenVisitor ? nodeVisitor(node.questionDotToken, tokenVisitor, isQuestionDotToken) : node.questionDotToken, Debug.checkDefined(nodeVisitor(node.argumentExpression, visitor, isExpression))) : context.factory.updateElementAccessExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.argumentExpression, visitor, isExpression)));
        },
        [214 /* CallExpression */ ]: function visitEachChildOfCallExpression(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return isCallChain(node) ? context.factory.updateCallChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), tokenVisitor ? nodeVisitor(node.questionDotToken, tokenVisitor, isQuestionDotToken) : node.questionDotToken, nodesVisitor(node.typeArguments, visitor, isTypeNode), nodesVisitor(node.arguments, visitor, isExpression)) : context.factory.updateCallExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), nodesVisitor(node.arguments, visitor, isExpression));
        },
        [215 /* NewExpression */ ]: function visitEachChildOfNewExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateNewExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), nodesVisitor(node.arguments, visitor, isExpression));
        },
        [216 /* TaggedTemplateExpression */ ]: function visitEachChildOfTaggedTemplateExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTaggedTemplateExpression(node, Debug.checkDefined(nodeVisitor(node.tag, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), Debug.checkDefined(nodeVisitor(node.template, visitor, isTemplateLiteral)));
        },
        [217 /* TypeAssertionExpression */ ]: function visitEachChildOfTypeAssertionExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeAssertion(node, Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [218 /* ParenthesizedExpression */ ]: function visitEachChildOfParenthesizedExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateParenthesizedExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [219 /* FunctionExpression */ ]: function visitEachChildOfFunctionExpression(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateFunctionExpression(node, nodesVisitor(node.modifiers, visitor, isModifier), tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [220 /* ArrowFunction */ ]: function visitEachChildOfArrowFunction(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateArrowFunction(node, nodesVisitor(node.modifiers, visitor, isModifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.equalsGreaterThanToken, tokenVisitor, isEqualsGreaterThanToken)) : node.equalsGreaterThanToken, visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [221 /* DeleteExpression */ ]: function visitEachChildOfDeleteExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateDeleteExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [222 /* TypeOfExpression */ ]: function visitEachChildOfTypeOfExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeOfExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [223 /* VoidExpression */ ]: function visitEachChildOfVoidExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateVoidExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [224 /* AwaitExpression */ ]: function visitEachChildOfAwaitExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateAwaitExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [225 /* PrefixUnaryExpression */ ]: function visitEachChildOfPrefixUnaryExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updatePrefixUnaryExpression(node, Debug.checkDefined(nodeVisitor(node.operand, visitor, isExpression)));
        },
        [226 /* PostfixUnaryExpression */ ]: function visitEachChildOfPostfixUnaryExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updatePostfixUnaryExpression(node, Debug.checkDefined(nodeVisitor(node.operand, visitor, isExpression)));
        },
        [227 /* BinaryExpression */ ]: function visitEachChildOfBinaryExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateBinaryExpression(node, Debug.checkDefined(nodeVisitor(node.left, visitor, isExpression)), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.operatorToken, tokenVisitor, isBinaryOperatorToken)) : node.operatorToken, Debug.checkDefined(nodeVisitor(node.right, visitor, isExpression)));
        },
        [228 /* ConditionalExpression */ ]: function visitEachChildOfConditionalExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateConditionalExpression(node, Debug.checkDefined(nodeVisitor(node.condition, visitor, isExpression)), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.questionToken, tokenVisitor, isQuestionToken)) : node.questionToken, Debug.checkDefined(nodeVisitor(node.whenTrue, visitor, isExpression)), tokenVisitor ? Debug.checkDefined(nodeVisitor(node.colonToken, tokenVisitor, isColonToken)) : node.colonToken, Debug.checkDefined(nodeVisitor(node.whenFalse, visitor, isExpression)));
        },
        [229 /* TemplateExpression */ ]: function visitEachChildOfTemplateExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTemplateExpression(node, Debug.checkDefined(nodeVisitor(node.head, visitor, isTemplateHead)), nodesVisitor(node.templateSpans, visitor, isTemplateSpan));
        },
        [230 /* YieldExpression */ ]: function visitEachChildOfYieldExpression(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateYieldExpression(node, tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, nodeVisitor(node.expression, visitor, isExpression));
        },
        [231 /* SpreadElement */ ]: function visitEachChildOfSpreadElement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateSpreadElement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [232 /* ClassExpression */ ]: function visitEachChildOfClassExpression(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateClassExpression(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, isHeritageClause), nodesVisitor(node.members, visitor, isClassElement));
        },
        [234 /* ExpressionWithTypeArguments */ ]: function visitEachChildOfExpressionWithTypeArguments(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateExpressionWithTypeArguments(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode));
        },
        [235 /* AsExpression */ ]: function visitEachChildOfAsExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateAsExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [239 /* SatisfiesExpression */ ]: function visitEachChildOfSatisfiesExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateSatisfiesExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [236 /* NonNullExpression */ ]: function visitEachChildOfNonNullExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return isOptionalChain(node) ? context.factory.updateNonNullChain(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression))) : context.factory.updateNonNullExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [237 /* MetaProperty */ ]: function visitEachChildOfMetaProperty(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateMetaProperty(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
        },
        // Misc
        [240 /* TemplateSpan */ ]: function visitEachChildOfTemplateSpan(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTemplateSpan(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.literal, visitor, isTemplateMiddleOrTemplateTail)));
        },
        // Element
        [242 /* Block */ ]: function visitEachChildOfBlock(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateBlock(node, nodesVisitor(node.statements, visitor, isStatement));
        },
        [244 /* VariableStatement */ ]: function visitEachChildOfVariableStatement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateVariableStatement(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.declarationList, visitor, isVariableDeclarationList)));
        },
        [245 /* ExpressionStatement */ ]: function visitEachChildOfExpressionStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateExpressionStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [246 /* IfStatement */ ]: function visitEachChildOfIfStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateIfStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.thenStatement, visitor, isStatement, context.factory.liftToBlock)), nodeVisitor(node.elseStatement, visitor, isStatement, context.factory.liftToBlock));
        },
        [247 /* DoStatement */ ]: function visitEachChildOfDoStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateDoStatement(node, visitIterationBody(node.statement, visitor, context, nodeVisitor), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [248 /* WhileStatement */ ]: function visitEachChildOfWhileStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateWhileStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), visitIterationBody(node.statement, visitor, context, nodeVisitor));
        },
        [249 /* ForStatement */ ]: function visitEachChildOfForStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateForStatement(node, nodeVisitor(node.initializer, visitor, isForInitializer), nodeVisitor(node.condition, visitor, isExpression), nodeVisitor(node.incrementor, visitor, isExpression), visitIterationBody(node.statement, visitor, context, nodeVisitor));
        },
        [250 /* ForInStatement */ ]: function visitEachChildOfForInStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateForInStatement(node, Debug.checkDefined(nodeVisitor(node.initializer, visitor, isForInitializer)), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), visitIterationBody(node.statement, visitor, context, nodeVisitor));
        },
        [251 /* ForOfStatement */ ]: function visitEachChildOfForOfStatement(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateForOfStatement(node, tokenVisitor ? nodeVisitor(node.awaitModifier, tokenVisitor, isAwaitKeyword) : node.awaitModifier, Debug.checkDefined(nodeVisitor(node.initializer, visitor, isForInitializer)), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), visitIterationBody(node.statement, visitor, context, nodeVisitor));
        },
        [252 /* ContinueStatement */ ]: function visitEachChildOfContinueStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateContinueStatement(node, nodeVisitor(node.label, visitor, isIdentifier));
        },
        [253 /* BreakStatement */ ]: function visitEachChildOfBreakStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateBreakStatement(node, nodeVisitor(node.label, visitor, isIdentifier));
        },
        [254 /* ReturnStatement */ ]: function visitEachChildOfReturnStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateReturnStatement(node, nodeVisitor(node.expression, visitor, isExpression));
        },
        [255 /* WithStatement */ ]: function visitEachChildOfWithStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateWithStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.statement, visitor, isStatement, context.factory.liftToBlock)));
        },
        [256 /* SwitchStatement */ ]: function visitEachChildOfSwitchStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateSwitchStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), Debug.checkDefined(nodeVisitor(node.caseBlock, visitor, isCaseBlock)));
        },
        [257 /* LabeledStatement */ ]: function visitEachChildOfLabeledStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateLabeledStatement(node, Debug.checkDefined(nodeVisitor(node.label, visitor, isIdentifier)), Debug.checkDefined(nodeVisitor(node.statement, visitor, isStatement, context.factory.liftToBlock)));
        },
        [258 /* ThrowStatement */ ]: function visitEachChildOfThrowStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateThrowStatement(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [259 /* TryStatement */ ]: function visitEachChildOfTryStatement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTryStatement(node, Debug.checkDefined(nodeVisitor(node.tryBlock, visitor, isBlock)), nodeVisitor(node.catchClause, visitor, isCatchClause), nodeVisitor(node.finallyBlock, visitor, isBlock));
        },
        [261 /* VariableDeclaration */ ]: function visitEachChildOfVariableDeclaration(node, visitor, context, _nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateVariableDeclaration(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isBindingName)), tokenVisitor ? nodeVisitor(node.exclamationToken, tokenVisitor, isExclamationToken) : node.exclamationToken, nodeVisitor(node.type, visitor, isTypeNode), nodeVisitor(node.initializer, visitor, isExpression));
        },
        [262 /* VariableDeclarationList */ ]: function visitEachChildOfVariableDeclarationList(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateVariableDeclarationList(node, nodesVisitor(node.declarations, visitor, isVariableDeclaration));
        },
        [263 /* FunctionDeclaration */ ]: function visitEachChildOfFunctionDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, tokenVisitor) {
            return context.factory.updateFunctionDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifier), tokenVisitor ? nodeVisitor(node.asteriskToken, tokenVisitor, isAsteriskToken) : node.asteriskToken, nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), nodeVisitor(node.type, visitor, isTypeNode), visitFunctionBody(node.body, visitor, context, nodeVisitor));
        },
        [264 /* ClassDeclaration */ ]: function visitEachChildOfClassDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateClassDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodeVisitor(node.name, visitor, isIdentifier), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, isHeritageClause), nodesVisitor(node.members, visitor, isClassElement));
        },
        [265 /* InterfaceDeclaration */ ]: function visitEachChildOfInterfaceDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateInterfaceDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, isHeritageClause), nodesVisitor(node.members, visitor, isTypeElement));
        },
        [266 /* TypeAliasDeclaration */ ]: function visitEachChildOfTypeAliasDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateTypeAliasDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodesVisitor(node.typeParameters, visitor, isTypeParameterDeclaration), Debug.checkDefined(nodeVisitor(node.type, visitor, isTypeNode)));
        },
        [267 /* EnumDeclaration */ ]: function visitEachChildOfEnumDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateEnumDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodesVisitor(node.members, visitor, isEnumMember));
        },
        [268 /* ModuleDeclaration */ ]: function visitEachChildOfModuleDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateModuleDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.name, visitor, isModuleName)), nodeVisitor(node.body, visitor, isModuleBody));
        },
        [269 /* ModuleBlock */ ]: function visitEachChildOfModuleBlock(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateModuleBlock(node, nodesVisitor(node.statements, visitor, isStatement));
        },
        [270 /* CaseBlock */ ]: function visitEachChildOfCaseBlock(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateCaseBlock(node, nodesVisitor(node.clauses, visitor, isCaseOrDefaultClause));
        },
        [271 /* NamespaceExportDeclaration */ ]: function visitEachChildOfNamespaceExportDeclaration(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateNamespaceExportDeclaration(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
        },
        [272 /* ImportEqualsDeclaration */ ]: function visitEachChildOfImportEqualsDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportEqualsDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), node.isTypeOnly, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), Debug.checkDefined(nodeVisitor(node.moduleReference, visitor, isModuleReference)));
        },
        [273 /* ImportDeclaration */ ]: function visitEachChildOfImportDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), nodeVisitor(node.importClause, visitor, isImportClause), Debug.checkDefined(nodeVisitor(node.moduleSpecifier, visitor, isExpression)), nodeVisitor(node.attributes, visitor, isImportAttributes));
        },
        [301 /* ImportAttributes */ ]: function visitEachChildOfImportAttributes(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportAttributes(node, nodesVisitor(node.elements, visitor, isImportAttribute), node.multiLine);
        },
        [302 /* ImportAttribute */ ]: function visitEachChildOfImportAttribute(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportAttribute(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isImportAttributeName)), Debug.checkDefined(nodeVisitor(node.value, visitor, isExpression)));
        },
        [274 /* ImportClause */ ]: function visitEachChildOfImportClause(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportClause(node, node.phaseModifier, nodeVisitor(node.name, visitor, isIdentifier), nodeVisitor(node.namedBindings, visitor, isNamedImportBindings));
        },
        [275 /* NamespaceImport */ ]: function visitEachChildOfNamespaceImport(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateNamespaceImport(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
        },
        [281 /* NamespaceExport */ ]: function visitEachChildOfNamespaceExport(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateNamespaceExport(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
        },
        [276 /* NamedImports */ ]: function visitEachChildOfNamedImports(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateNamedImports(node, nodesVisitor(node.elements, visitor, isImportSpecifier));
        },
        [277 /* ImportSpecifier */ ]: function visitEachChildOfImportSpecifier(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateImportSpecifier(node, node.isTypeOnly, nodeVisitor(node.propertyName, visitor, isModuleExportName), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
        },
        [278 /* ExportAssignment */ ]: function visitEachChildOfExportAssignment(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateExportAssignment(node, nodesVisitor(node.modifiers, visitor, isModifierLike), Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [279 /* ExportDeclaration */ ]: function visitEachChildOfExportDeclaration(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateExportDeclaration(node, nodesVisitor(node.modifiers, visitor, isModifierLike), node.isTypeOnly, nodeVisitor(node.exportClause, visitor, isNamedExportBindings), nodeVisitor(node.moduleSpecifier, visitor, isExpression), nodeVisitor(node.attributes, visitor, isImportAttributes));
        },
        [280 /* NamedExports */ ]: function visitEachChildOfNamedExports(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateNamedExports(node, nodesVisitor(node.elements, visitor, isExportSpecifier));
        },
        [282 /* ExportSpecifier */ ]: function visitEachChildOfExportSpecifier(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateExportSpecifier(node, node.isTypeOnly, nodeVisitor(node.propertyName, visitor, isModuleExportName), Debug.checkDefined(nodeVisitor(node.name, visitor, isModuleExportName)));
        },
        // Module references
        [284 /* ExternalModuleReference */ ]: function visitEachChildOfExternalModuleReference(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateExternalModuleReference(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        // JSX
        [285 /* JsxElement */ ]: function visitEachChildOfJsxElement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxElement(node, Debug.checkDefined(nodeVisitor(node.openingElement, visitor, isJsxOpeningElement)), nodesVisitor(node.children, visitor, isJsxChild), Debug.checkDefined(nodeVisitor(node.closingElement, visitor, isJsxClosingElement)));
        },
        [286 /* JsxSelfClosingElement */ ]: function visitEachChildOfJsxSelfClosingElement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxSelfClosingElement(node, Debug.checkDefined(nodeVisitor(node.tagName, visitor, isJsxTagNameExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), Debug.checkDefined(nodeVisitor(node.attributes, visitor, isJsxAttributes)));
        },
        [287 /* JsxOpeningElement */ ]: function visitEachChildOfJsxOpeningElement(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxOpeningElement(node, Debug.checkDefined(nodeVisitor(node.tagName, visitor, isJsxTagNameExpression)), nodesVisitor(node.typeArguments, visitor, isTypeNode), Debug.checkDefined(nodeVisitor(node.attributes, visitor, isJsxAttributes)));
        },
        [288 /* JsxClosingElement */ ]: function visitEachChildOfJsxClosingElement(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxClosingElement(node, Debug.checkDefined(nodeVisitor(node.tagName, visitor, isJsxTagNameExpression)));
        },
        [296 /* JsxNamespacedName */ ]: function forEachChildInJsxNamespacedName2(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxNamespacedName(node, Debug.checkDefined(nodeVisitor(node.namespace, visitor, isIdentifier)), Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)));
        },
        [289 /* JsxFragment */ ]: function visitEachChildOfJsxFragment(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxFragment(node, Debug.checkDefined(nodeVisitor(node.openingFragment, visitor, isJsxOpeningFragment)), nodesVisitor(node.children, visitor, isJsxChild), Debug.checkDefined(nodeVisitor(node.closingFragment, visitor, isJsxClosingFragment)));
        },
        [292 /* JsxAttribute */ ]: function visitEachChildOfJsxAttribute(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxAttribute(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isJsxAttributeName)), nodeVisitor(node.initializer, visitor, isStringLiteralOrJsxExpression));
        },
        [293 /* JsxAttributes */ ]: function visitEachChildOfJsxAttributes(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxAttributes(node, nodesVisitor(node.properties, visitor, isJsxAttributeLike));
        },
        [294 /* JsxSpreadAttribute */ ]: function visitEachChildOfJsxSpreadAttribute(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxSpreadAttribute(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [295 /* JsxExpression */ ]: function visitEachChildOfJsxExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateJsxExpression(node, nodeVisitor(node.expression, visitor, isExpression));
        },
        // Clauses
        [297 /* CaseClause */ ]: function visitEachChildOfCaseClause(node, visitor, context, nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateCaseClause(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)), nodesVisitor(node.statements, visitor, isStatement));
        },
        [298 /* DefaultClause */ ]: function visitEachChildOfDefaultClause(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateDefaultClause(node, nodesVisitor(node.statements, visitor, isStatement));
        },
        [299 /* HeritageClause */ ]: function visitEachChildOfHeritageClause(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateHeritageClause(node, nodesVisitor(node.types, visitor, isExpressionWithTypeArguments));
        },
        [300 /* CatchClause */ ]: function visitEachChildOfCatchClause(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateCatchClause(node, nodeVisitor(node.variableDeclaration, visitor, isVariableDeclaration), Debug.checkDefined(nodeVisitor(node.block, visitor, isBlock)));
        },
        // Property assignments
        [304 /* PropertyAssignment */ ]: function visitEachChildOfPropertyAssignment(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updatePropertyAssignment(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), Debug.checkDefined(nodeVisitor(node.initializer, visitor, isExpression)));
        },
        [305 /* ShorthandPropertyAssignment */ ]: function visitEachChildOfShorthandPropertyAssignment(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateShorthandPropertyAssignment(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isIdentifier)), nodeVisitor(node.objectAssignmentInitializer, visitor, isExpression));
        },
        [306 /* SpreadAssignment */ ]: function visitEachChildOfSpreadAssignment(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateSpreadAssignment(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        // Enum
        [307 /* EnumMember */ ]: function visitEachChildOfEnumMember(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updateEnumMember(node, Debug.checkDefined(nodeVisitor(node.name, visitor, isPropertyName)), nodeVisitor(node.initializer, visitor, isExpression));
        },
        // Top-level nodes
        [308 /* SourceFile */ ]: function visitEachChildOfSourceFile(node, visitor, context, _nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateSourceFile(node, visitLexicalEnvironment(node.statements, visitor, context));
        },
        // Transformation nodes
        [356 /* PartiallyEmittedExpression */ ]: function visitEachChildOfPartiallyEmittedExpression(node, visitor, context, _nodesVisitor, nodeVisitor, _tokenVisitor) {
            return context.factory.updatePartiallyEmittedExpression(node, Debug.checkDefined(nodeVisitor(node.expression, visitor, isExpression)));
        },
        [357 /* CommaListExpression */ ]: function visitEachChildOfCommaListExpression(node, visitor, context, nodesVisitor, _nodeVisitor, _tokenVisitor) {
            return context.factory.updateCommaListExpression(node, nodesVisitor(node.elements, visitor, isExpression));
        }
    };
    function extractSingleNode(nodes) {
        Debug.assert(nodes.length <= 1, "Too many nodes written to output.");
        return singleOrUndefined(nodes);
    }
    // src/compiler/sourcemap.ts
    function createSourceMapGenerator(host, file, sourceRoot, sourcesDirectoryPath, generatorOptions) {
        var { enter, exit } = generatorOptions.extendedDiagnostics ? createTimer("Source Map", "beforeSourcemap", "afterSourcemap") : nullTimer;
        var rawSources = [];
        var sources = [];
        var sourceToSourceIndexMap = /* @__PURE__ */ new Map();
        var sourcesContent;
        var names = [];
        var nameToNameIndexMap;
        var mappingCharCodes = [];
        var mappings = "";
        var lastGeneratedLine = 0;
        var lastGeneratedCharacter = 0;
        var lastSourceIndex = 0;
        var lastSourceLine = 0;
        var lastSourceCharacter = 0;
        var lastNameIndex = 0;
        var hasLast = false;
        var pendingGeneratedLine = 0;
        var pendingGeneratedCharacter = 0;
        var pendingSourceIndex = 0;
        var pendingSourceLine = 0;
        var pendingSourceCharacter = 0;
        var pendingNameIndex = 0;
        var hasPending = false;
        var hasPendingSource = false;
        var hasPendingName = false;
        return {
            getSources: ()=>rawSources,
            addSource,
            setSourceContent,
            addName,
            addMapping,
            appendSourceMap,
            toJSON,
            toString: ()=>JSON.stringify(toJSON())
        };
        function addSource(fileName) {
            enter();
            const source = getRelativePathToDirectoryOrUrl(sourcesDirectoryPath, fileName, host.getCurrentDirectory(), host.getCanonicalFileName, /*isAbsolutePathAnUrl*/ true);
            let sourceIndex = sourceToSourceIndexMap.get(source);
            if (sourceIndex === void 0) {
                sourceIndex = sources.length;
                sources.push(source);
                rawSources.push(fileName);
                sourceToSourceIndexMap.set(source, sourceIndex);
            }
            exit();
            return sourceIndex;
        }
        function setSourceContent(sourceIndex, content) {
            enter();
            if (content !== null) {
                if (!sourcesContent) sourcesContent = [];
                while(sourcesContent.length < sourceIndex)sourcesContent.push(null);
                sourcesContent[sourceIndex] = content;
            }
            exit();
        }
        function addName(name) {
            enter();
            if (!nameToNameIndexMap) nameToNameIndexMap = /* @__PURE__ */ new Map();
            let nameIndex = nameToNameIndexMap.get(name);
            if (nameIndex === void 0) {
                nameIndex = names.length;
                names.push(name);
                nameToNameIndexMap.set(name, nameIndex);
            }
            exit();
            return nameIndex;
        }
        function isNewGeneratedPosition(generatedLine, generatedCharacter) {
            return !hasPending || pendingGeneratedLine !== generatedLine || pendingGeneratedCharacter !== generatedCharacter;
        }
        function isBacktrackingSourcePosition(sourceIndex, sourceLine, sourceCharacter) {
            return sourceIndex !== void 0 && sourceLine !== void 0 && sourceCharacter !== void 0 && pendingSourceIndex === sourceIndex && (pendingSourceLine > sourceLine || pendingSourceLine === sourceLine && pendingSourceCharacter > sourceCharacter);
        }
        function addMapping(generatedLine, generatedCharacter, sourceIndex, sourceLine, sourceCharacter, nameIndex) {
            Debug.assert(generatedLine >= pendingGeneratedLine, "generatedLine cannot backtrack");
            Debug.assert(generatedCharacter >= 0, "generatedCharacter cannot be negative");
            Debug.assert(sourceIndex === void 0 || sourceIndex >= 0, "sourceIndex cannot be negative");
            Debug.assert(sourceLine === void 0 || sourceLine >= 0, "sourceLine cannot be negative");
            Debug.assert(sourceCharacter === void 0 || sourceCharacter >= 0, "sourceCharacter cannot be negative");
            enter();
            if (isNewGeneratedPosition(generatedLine, generatedCharacter) || isBacktrackingSourcePosition(sourceIndex, sourceLine, sourceCharacter)) {
                commitPendingMapping();
                pendingGeneratedLine = generatedLine;
                pendingGeneratedCharacter = generatedCharacter;
                hasPendingSource = false;
                hasPendingName = false;
                hasPending = true;
            }
            if (sourceIndex !== void 0 && sourceLine !== void 0 && sourceCharacter !== void 0) {
                pendingSourceIndex = sourceIndex;
                pendingSourceLine = sourceLine;
                pendingSourceCharacter = sourceCharacter;
                hasPendingSource = true;
                if (nameIndex !== void 0) {
                    pendingNameIndex = nameIndex;
                    hasPendingName = true;
                }
            }
            exit();
        }
        function appendSourceMap(generatedLine, generatedCharacter, map2, sourceMapPath, start, end) {
            Debug.assert(generatedLine >= pendingGeneratedLine, "generatedLine cannot backtrack");
            Debug.assert(generatedCharacter >= 0, "generatedCharacter cannot be negative");
            enter();
            const sourceIndexToNewSourceIndexMap = [];
            let nameIndexToNewNameIndexMap;
            const mappingIterator = decodeMappings(map2.mappings);
            for (const raw of mappingIterator){
                if (end && (raw.generatedLine > end.line || raw.generatedLine === end.line && raw.generatedCharacter > end.character)) break;
                if (start && (raw.generatedLine < start.line || start.line === raw.generatedLine && raw.generatedCharacter < start.character)) continue;
                let newSourceIndex;
                let newSourceLine;
                let newSourceCharacter;
                let newNameIndex;
                if (raw.sourceIndex !== void 0) {
                    newSourceIndex = sourceIndexToNewSourceIndexMap[raw.sourceIndex];
                    if (newSourceIndex === void 0) {
                        const rawPath = map2.sources[raw.sourceIndex];
                        const relativePath = map2.sourceRoot ? combinePaths(map2.sourceRoot, rawPath) : rawPath;
                        const combinedPath = combinePaths(getDirectoryPath(sourceMapPath), relativePath);
                        sourceIndexToNewSourceIndexMap[raw.sourceIndex] = newSourceIndex = addSource(combinedPath);
                        if (map2.sourcesContent && typeof map2.sourcesContent[raw.sourceIndex] === "string") setSourceContent(newSourceIndex, map2.sourcesContent[raw.sourceIndex]);
                    }
                    newSourceLine = raw.sourceLine;
                    newSourceCharacter = raw.sourceCharacter;
                    if (map2.names && raw.nameIndex !== void 0) {
                        if (!nameIndexToNewNameIndexMap) nameIndexToNewNameIndexMap = [];
                        newNameIndex = nameIndexToNewNameIndexMap[raw.nameIndex];
                        if (newNameIndex === void 0) nameIndexToNewNameIndexMap[raw.nameIndex] = newNameIndex = addName(map2.names[raw.nameIndex]);
                    }
                }
                const rawGeneratedLine = raw.generatedLine - (start ? start.line : 0);
                const newGeneratedLine = rawGeneratedLine + generatedLine;
                const rawGeneratedCharacter = start && start.line === raw.generatedLine ? raw.generatedCharacter - start.character : raw.generatedCharacter;
                const newGeneratedCharacter = rawGeneratedLine === 0 ? rawGeneratedCharacter + generatedCharacter : rawGeneratedCharacter;
                addMapping(newGeneratedLine, newGeneratedCharacter, newSourceIndex, newSourceLine, newSourceCharacter, newNameIndex);
            }
            exit();
        }
        function shouldCommitMapping() {
            return !hasLast || lastGeneratedLine !== pendingGeneratedLine || lastGeneratedCharacter !== pendingGeneratedCharacter || lastSourceIndex !== pendingSourceIndex || lastSourceLine !== pendingSourceLine || lastSourceCharacter !== pendingSourceCharacter || lastNameIndex !== pendingNameIndex;
        }
        function appendMappingCharCode(charCode) {
            mappingCharCodes.push(charCode);
            if (mappingCharCodes.length >= 1024) flushMappingBuffer();
        }
        function commitPendingMapping() {
            if (!hasPending || !shouldCommitMapping()) return;
            enter();
            if (lastGeneratedLine < pendingGeneratedLine) {
                do {
                    appendMappingCharCode(59 /* semicolon */ );
                    lastGeneratedLine++;
                }while (lastGeneratedLine < pendingGeneratedLine);
                lastGeneratedCharacter = 0;
            } else {
                Debug.assertEqual(lastGeneratedLine, pendingGeneratedLine, "generatedLine cannot backtrack");
                if (hasLast) appendMappingCharCode(44 /* comma */ );
            }
            appendBase64VLQ(pendingGeneratedCharacter - lastGeneratedCharacter);
            lastGeneratedCharacter = pendingGeneratedCharacter;
            if (hasPendingSource) {
                appendBase64VLQ(pendingSourceIndex - lastSourceIndex);
                lastSourceIndex = pendingSourceIndex;
                appendBase64VLQ(pendingSourceLine - lastSourceLine);
                lastSourceLine = pendingSourceLine;
                appendBase64VLQ(pendingSourceCharacter - lastSourceCharacter);
                lastSourceCharacter = pendingSourceCharacter;
                if (hasPendingName) {
                    appendBase64VLQ(pendingNameIndex - lastNameIndex);
                    lastNameIndex = pendingNameIndex;
                }
            }
            hasLast = true;
            exit();
        }
        function flushMappingBuffer() {
            if (mappingCharCodes.length > 0) {
                mappings += String.fromCharCode.apply(void 0, mappingCharCodes);
                mappingCharCodes.length = 0;
            }
        }
        function toJSON() {
            commitPendingMapping();
            flushMappingBuffer();
            return {
                version: 3,
                file,
                sourceRoot,
                sources,
                names,
                mappings,
                sourcesContent
            };
        }
        function appendBase64VLQ(inValue) {
            if (inValue < 0) inValue = (-inValue << 1) + 1;
            else inValue = inValue << 1;
            do {
                let currentDigit = inValue & 31;
                inValue = inValue >> 5;
                if (inValue > 0) currentDigit = currentDigit | 32;
                appendMappingCharCode(base64FormatEncode(currentDigit));
            }while (inValue > 0);
        }
    }
    var sourceMapCommentRegExpDontCareLineStart = /\/\/[@#] source[M]appingURL=(.+)\r?\n?$/;
    var sourceMapCommentRegExp = /^\/\/[@#] source[M]appingURL=(.+)\r?\n?$/;
    var whitespaceOrMapCommentRegExp = /^\s*(\/\/[@#] .*)?$/;
    function getLineInfo(text, lineStarts) {
        return {
            getLineCount: ()=>lineStarts.length,
            getLineText: (line)=>text.substring(lineStarts[line], lineStarts[line + 1])
        };
    }
    function tryGetSourceMappingURL(lineInfo) {
        for(let index = lineInfo.getLineCount() - 1; index >= 0; index--){
            const line = lineInfo.getLineText(index);
            const comment = sourceMapCommentRegExp.exec(line);
            if (comment) return comment[1].trimEnd();
            else if (!line.match(whitespaceOrMapCommentRegExp)) break;
        }
    }
    function isStringOrNull(x) {
        return typeof x === "string" || x === null;
    }
    function isRawSourceMap(x) {
        return x !== null && typeof x === "object" && x.version === 3 && typeof x.file === "string" && typeof x.mappings === "string" && isArray(x.sources) && every(x.sources, isString) && (x.sourceRoot === void 0 || x.sourceRoot === null || typeof x.sourceRoot === "string") && (x.sourcesContent === void 0 || x.sourcesContent === null || isArray(x.sourcesContent) && every(x.sourcesContent, isStringOrNull)) && (x.names === void 0 || x.names === null || isArray(x.names) && every(x.names, isString));
    }
    function tryParseRawSourceMap(text) {
        try {
            const parsed = JSON.parse(text);
            if (isRawSourceMap(parsed)) return parsed;
        } catch (e) {}
        return void 0;
    }
    function decodeMappings(mappings) {
        let done = false;
        let pos = 0;
        let generatedLine = 0;
        let generatedCharacter = 0;
        let sourceIndex = 0;
        let sourceLine = 0;
        let sourceCharacter = 0;
        let nameIndex = 0;
        let error2;
        return {
            get pos () {
                return pos;
            },
            get error () {
                return error2;
            },
            get state () {
                return captureMapping(/*hasSource*/ true, /*hasName*/ true);
            },
            next () {
                while(!done && pos < mappings.length){
                    const ch = mappings.charCodeAt(pos);
                    if (ch === 59 /* semicolon */ ) {
                        generatedLine++;
                        generatedCharacter = 0;
                        pos++;
                        continue;
                    }
                    if (ch === 44 /* comma */ ) {
                        pos++;
                        continue;
                    }
                    let hasSource = false;
                    let hasName = false;
                    generatedCharacter += base64VLQFormatDecode();
                    if (hasReportedError()) return stopIterating();
                    if (generatedCharacter < 0) return setErrorAndStopIterating("Invalid generatedCharacter found");
                    if (!isSourceMappingSegmentEnd()) {
                        hasSource = true;
                        sourceIndex += base64VLQFormatDecode();
                        if (hasReportedError()) return stopIterating();
                        if (sourceIndex < 0) return setErrorAndStopIterating("Invalid sourceIndex found");
                        if (isSourceMappingSegmentEnd()) return setErrorAndStopIterating("Unsupported Format: No entries after sourceIndex");
                        sourceLine += base64VLQFormatDecode();
                        if (hasReportedError()) return stopIterating();
                        if (sourceLine < 0) return setErrorAndStopIterating("Invalid sourceLine found");
                        if (isSourceMappingSegmentEnd()) return setErrorAndStopIterating("Unsupported Format: No entries after sourceLine");
                        sourceCharacter += base64VLQFormatDecode();
                        if (hasReportedError()) return stopIterating();
                        if (sourceCharacter < 0) return setErrorAndStopIterating("Invalid sourceCharacter found");
                        if (!isSourceMappingSegmentEnd()) {
                            hasName = true;
                            nameIndex += base64VLQFormatDecode();
                            if (hasReportedError()) return stopIterating();
                            if (nameIndex < 0) return setErrorAndStopIterating("Invalid nameIndex found");
                            if (!isSourceMappingSegmentEnd()) return setErrorAndStopIterating("Unsupported Error Format: Entries after nameIndex");
                        }
                    }
                    return {
                        value: captureMapping(hasSource, hasName),
                        done
                    };
                }
                return stopIterating();
            },
            [Symbol.iterator] () {
                return this;
            }
        };
        function captureMapping(hasSource, hasName) {
            return {
                generatedLine,
                generatedCharacter,
                sourceIndex: hasSource ? sourceIndex : void 0,
                sourceLine: hasSource ? sourceLine : void 0,
                sourceCharacter: hasSource ? sourceCharacter : void 0,
                nameIndex: hasName ? nameIndex : void 0
            };
        }
        function stopIterating() {
            done = true;
            return {
                value: void 0,
                done: true
            };
        }
        function setError(message) {
            if (error2 === void 0) error2 = message;
        }
        function setErrorAndStopIterating(message) {
            setError(message);
            return stopIterating();
        }
        function hasReportedError() {
            return error2 !== void 0;
        }
        function isSourceMappingSegmentEnd() {
            return pos === mappings.length || mappings.charCodeAt(pos) === 44 /* comma */  || mappings.charCodeAt(pos) === 59 /* semicolon */ ;
        }
        function base64VLQFormatDecode() {
            let moreDigits = true;
            let shiftCount = 0;
            let value1 = 0;
            for(; moreDigits; pos++){
                if (pos >= mappings.length) return setError("Error in decoding base64VLQFormatDecode, past the mapping string"), -1;
                const currentByte = base64FormatDecode(mappings.charCodeAt(pos));
                if (currentByte === -1) return setError("Invalid character in VLQ"), -1;
                moreDigits = (currentByte & 32) !== 0;
                value1 = value1 | (currentByte & 31) << shiftCount;
                shiftCount += 5;
            }
            if ((value1 & 1) === 0) value1 = value1 >> 1;
            else {
                value1 = value1 >> 1;
                value1 = -value1;
            }
            return value1;
        }
    }
    function sameMapping(left, right) {
        return left === right || left.generatedLine === right.generatedLine && left.generatedCharacter === right.generatedCharacter && left.sourceIndex === right.sourceIndex && left.sourceLine === right.sourceLine && left.sourceCharacter === right.sourceCharacter && left.nameIndex === right.nameIndex;
    }
    function isSourceMapping(mapping) {
        return mapping.sourceIndex !== void 0 && mapping.sourceLine !== void 0 && mapping.sourceCharacter !== void 0;
    }
    function base64FormatEncode(value1) {
        return value1 >= 0 && value1 < 26 ? 65 /* A */  + value1 : value1 >= 26 && value1 < 52 ? 97 /* a */  + value1 - 26 : value1 >= 52 && value1 < 62 ? 48 /* _0 */  + value1 - 52 : value1 === 62 ? 43 /* plus */  : value1 === 63 ? 47 /* slash */  : Debug.fail(`${value1}: not a base64 value`);
    }
    function base64FormatDecode(ch) {
        return ch >= 65 /* A */  && ch <= 90 /* Z */  ? ch - 65 /* A */  : ch >= 97 /* a */  && ch <= 122 /* z */  ? ch - 97 /* a */  + 26 : ch >= 48 /* _0 */  && ch <= 57 /* _9 */  ? ch - 48 /* _0 */  + 52 : ch === 43 /* plus */  ? 62 : ch === 47 /* slash */  ? 63 : -1;
    }
    function isSourceMappedPosition(value1) {
        return value1.sourceIndex !== void 0 && value1.sourcePosition !== void 0;
    }
    function sameMappedPosition(left, right) {
        return left.generatedPosition === right.generatedPosition && left.sourceIndex === right.sourceIndex && left.sourcePosition === right.sourcePosition;
    }
    function compareSourcePositions(left, right) {
        Debug.assert(left.sourceIndex === right.sourceIndex);
        return compareValues(left.sourcePosition, right.sourcePosition);
    }
    function compareGeneratedPositions(left, right) {
        return compareValues(left.generatedPosition, right.generatedPosition);
    }
    function getSourcePositionOfMapping(value1) {
        return value1.sourcePosition;
    }
    function getGeneratedPositionOfMapping(value1) {
        return value1.generatedPosition;
    }
    function createDocumentPositionMapper(host, map2, mapPath) {
        const mapDirectory = getDirectoryPath(mapPath);
        const sourceRoot = map2.sourceRoot ? getNormalizedAbsolutePath(map2.sourceRoot, mapDirectory) : mapDirectory;
        const generatedAbsoluteFilePath = getNormalizedAbsolutePath(map2.file, mapDirectory);
        const generatedFile = host.getSourceFileLike(generatedAbsoluteFilePath);
        const sourceFileAbsolutePaths = map2.sources.map((source)=>getNormalizedAbsolutePath(source, sourceRoot));
        const sourceToSourceIndexMap = new Map(sourceFileAbsolutePaths.map((source, i)=>[
                host.getCanonicalFileName(source),
                i
            ]));
        let decodedMappings;
        let generatedMappings;
        let sourceMappings;
        return {
            getSourcePosition,
            getGeneratedPosition
        };
        function processMapping(mapping) {
            const generatedPosition = generatedFile !== void 0 ? getPositionOfLineAndCharacter(generatedFile, mapping.generatedLine, mapping.generatedCharacter, /*allowEdits*/ true) : -1;
            let source;
            let sourcePosition;
            if (isSourceMapping(mapping)) {
                const sourceFile = host.getSourceFileLike(sourceFileAbsolutePaths[mapping.sourceIndex]);
                source = map2.sources[mapping.sourceIndex];
                sourcePosition = sourceFile !== void 0 ? getPositionOfLineAndCharacter(sourceFile, mapping.sourceLine, mapping.sourceCharacter, /*allowEdits*/ true) : -1;
            }
            return {
                generatedPosition,
                source,
                sourceIndex: mapping.sourceIndex,
                sourcePosition,
                nameIndex: mapping.nameIndex
            };
        }
        function getDecodedMappings() {
            if (decodedMappings === void 0) {
                const decoder = decodeMappings(map2.mappings);
                const mappings = arrayFrom(decoder, processMapping);
                if (decoder.error !== void 0) {
                    if (host.log) host.log(`Encountered error while decoding sourcemap: ${decoder.error}`);
                    decodedMappings = emptyArray;
                } else decodedMappings = mappings;
            }
            return decodedMappings;
        }
        function getSourceMappings(sourceIndex) {
            if (sourceMappings === void 0) {
                const lists = [];
                for (const mapping of getDecodedMappings()){
                    if (!isSourceMappedPosition(mapping)) continue;
                    let list = lists[mapping.sourceIndex];
                    if (!list) lists[mapping.sourceIndex] = list = [];
                    list.push(mapping);
                }
                sourceMappings = lists.map((list)=>sortAndDeduplicate(list, compareSourcePositions, sameMappedPosition));
            }
            return sourceMappings[sourceIndex];
        }
        function getGeneratedMappings() {
            if (generatedMappings === void 0) {
                const list = [];
                for (const mapping of getDecodedMappings())list.push(mapping);
                generatedMappings = sortAndDeduplicate(list, compareGeneratedPositions, sameMappedPosition);
            }
            return generatedMappings;
        }
        function getGeneratedPosition(loc) {
            const sourceIndex = sourceToSourceIndexMap.get(host.getCanonicalFileName(loc.fileName));
            if (sourceIndex === void 0) return loc;
            const sourceMappings2 = getSourceMappings(sourceIndex);
            if (!some(sourceMappings2)) return loc;
            let targetIndex = binarySearchKey(sourceMappings2, loc.pos, getSourcePositionOfMapping, compareValues);
            if (targetIndex < 0) targetIndex = ~targetIndex;
            const mapping = sourceMappings2[targetIndex];
            if (mapping === void 0 || mapping.sourceIndex !== sourceIndex) return loc;
            return {
                fileName: generatedAbsoluteFilePath,
                pos: mapping.generatedPosition
            };
        }
        function getSourcePosition(loc) {
            const generatedMappings2 = getGeneratedMappings();
            if (!some(generatedMappings2)) return loc;
            let targetIndex = binarySearchKey(generatedMappings2, loc.pos, getGeneratedPositionOfMapping, compareValues);
            if (targetIndex < 0) targetIndex = ~targetIndex;
            const mapping = generatedMappings2[targetIndex];
            if (mapping === void 0 || !isSourceMappedPosition(mapping)) return loc;
            return {
                fileName: sourceFileAbsolutePaths[mapping.sourceIndex],
                pos: mapping.sourcePosition
            };
        }
    }
    var identitySourceMapConsumer = {
        getSourcePosition: identity,
        getGeneratedPosition: identity
    };
    // src/compiler/transformers/utilities.ts
    function getOriginalNodeId(node) {
        node = getOriginalNode(node);
        return node ? getNodeId(node) : 0;
    }
    function containsDefaultReference(node) {
        if (!node) return false;
        if (!isNamedImports(node) && !isNamedExports(node)) return false;
        return some(node.elements, isNamedDefaultReference);
    }
    function isNamedDefaultReference(e) {
        return moduleExportNameIsDefault(e.propertyName || e.name);
    }
    function chainBundle(context, transformSourceFile) {
        return transformSourceFileOrBundle;
        function transformSourceFileOrBundle(node) {
            return node.kind === 308 /* SourceFile */  ? transformSourceFile(node) : transformBundle(node);
        }
        function transformBundle(node) {
            return context.factory.createBundle(map(node.sourceFiles, transformSourceFile));
        }
    }
    function getExportNeedsImportStarHelper(node) {
        return !!getNamespaceDeclarationNode(node);
    }
    function getImportNeedsImportStarHelper(node) {
        if (!!getNamespaceDeclarationNode(node)) return true;
        const bindings = node.importClause && node.importClause.namedBindings;
        if (!bindings) return false;
        if (!isNamedImports(bindings)) return false;
        let defaultRefCount = 0;
        for (const binding of bindings.elements)if (isNamedDefaultReference(binding)) defaultRefCount++;
        return defaultRefCount > 0 && defaultRefCount !== bindings.elements.length || !!(bindings.elements.length - defaultRefCount) && isDefaultImport(node);
    }
    function getImportNeedsImportDefaultHelper(node) {
        return !getImportNeedsImportStarHelper(node) && (isDefaultImport(node) || !!node.importClause && isNamedImports(node.importClause.namedBindings) && containsDefaultReference(node.importClause.namedBindings));
    }
    function collectExternalModuleInfo(context, sourceFile) {
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const externalImports = [];
        const exportSpecifiers = new IdentifierNameMultiMap();
        const exportedBindings = [];
        const uniqueExports = /* @__PURE__ */ new Map();
        const exportedFunctions = /* @__PURE__ */ new Set();
        let exportedNames;
        let hasExportDefault = false;
        let exportEquals;
        let hasExportStarsToExportValues = false;
        let hasImportStar = false;
        let hasImportDefault = false;
        for (const node of sourceFile.statements)switch(node.kind){
            case 273 /* ImportDeclaration */ :
                externalImports.push(node);
                if (!hasImportStar && getImportNeedsImportStarHelper(node)) hasImportStar = true;
                if (!hasImportDefault && getImportNeedsImportDefaultHelper(node)) hasImportDefault = true;
                break;
            case 272 /* ImportEqualsDeclaration */ :
                if (node.moduleReference.kind === 284 /* ExternalModuleReference */ ) externalImports.push(node);
                break;
            case 279 /* ExportDeclaration */ :
                if (node.moduleSpecifier) {
                    if (!node.exportClause) {
                        externalImports.push(node);
                        hasExportStarsToExportValues = true;
                    } else {
                        externalImports.push(node);
                        if (isNamedExports(node.exportClause)) {
                            addExportedNamesForExportDeclaration(node);
                            hasImportDefault || (hasImportDefault = containsDefaultReference(node.exportClause));
                        } else {
                            const name = node.exportClause.name;
                            const nameText = moduleExportNameTextUnescaped(name);
                            if (!uniqueExports.get(nameText)) {
                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
                                uniqueExports.set(nameText, true);
                                exportedNames = append(exportedNames, name);
                            }
                            hasImportStar = true;
                        }
                    }
                } else addExportedNamesForExportDeclaration(node);
                break;
            case 278 /* ExportAssignment */ :
                if (node.isExportEquals && !exportEquals) exportEquals = node;
                break;
            case 244 /* VariableStatement */ :
                if (hasSyntacticModifier(node, 32 /* Export */ )) for (const decl of node.declarationList.declarations)exportedNames = collectExportedVariableInfo(decl, uniqueExports, exportedNames, exportedBindings);
                break;
            case 263 /* FunctionDeclaration */ :
                if (hasSyntacticModifier(node, 32 /* Export */ )) addExportedFunctionDeclaration(node, /*name*/ void 0, hasSyntacticModifier(node, 2048 /* Default */ ));
                break;
            case 264 /* ClassDeclaration */ :
                if (hasSyntacticModifier(node, 32 /* Export */ )) {
                    if (hasSyntacticModifier(node, 2048 /* Default */ )) {
                        if (!hasExportDefault) {
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), context.factory.getDeclarationName(node));
                            hasExportDefault = true;
                        }
                    } else {
                        const name = node.name;
                        if (name && !uniqueExports.get(idText(name))) {
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
                            uniqueExports.set(idText(name), true);
                            exportedNames = append(exportedNames, name);
                        }
                    }
                }
                break;
        }
        const externalHelpersImportDeclaration = createExternalHelpersImportDeclarationIfNeeded(context.factory, context.getEmitHelperFactory(), sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStar, hasImportDefault);
        if (externalHelpersImportDeclaration) externalImports.unshift(externalHelpersImportDeclaration);
        return {
            externalImports,
            exportSpecifiers,
            exportEquals,
            hasExportStarsToExportValues,
            exportedBindings,
            exportedNames,
            exportedFunctions,
            externalHelpersImportDeclaration
        };
        function addExportedNamesForExportDeclaration(node) {
            for (const specifier of cast(node.exportClause, isNamedExports).elements){
                const specifierNameText = moduleExportNameTextUnescaped(specifier.name);
                if (!uniqueExports.get(specifierNameText)) {
                    const name = specifier.propertyName || specifier.name;
                    if (name.kind !== 11 /* StringLiteral */ ) {
                        if (!node.moduleSpecifier) exportSpecifiers.add(name, specifier);
                        const decl = resolver.getReferencedImportDeclaration(name) || resolver.getReferencedValueDeclaration(name);
                        if (decl) {
                            if (decl.kind === 263 /* FunctionDeclaration */ ) {
                                addExportedFunctionDeclaration(decl, specifier.name, moduleExportNameIsDefault(specifier.name));
                                continue;
                            }
                            multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(decl), specifier.name);
                        }
                    }
                    uniqueExports.set(specifierNameText, true);
                    exportedNames = append(exportedNames, specifier.name);
                }
            }
        }
        function addExportedFunctionDeclaration(node, name, isDefault) {
            exportedFunctions.add(getOriginalNode(node, isFunctionDeclaration));
            if (isDefault) {
                if (!hasExportDefault) {
                    multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name !== null && name !== void 0 ? name : context.factory.getDeclarationName(node));
                    hasExportDefault = true;
                }
            } else {
                name !== null && name !== void 0 ? name : name = node.name;
                const nameText = moduleExportNameTextUnescaped(name);
                if (!uniqueExports.get(nameText)) {
                    multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
                    uniqueExports.set(nameText, true);
                }
            }
        }
    }
    function collectExportedVariableInfo(decl, uniqueExports, exportedNames, exportedBindings) {
        if (isBindingPattern(decl.name)) {
            for (const element of decl.name.elements)if (!isOmittedExpression(element)) exportedNames = collectExportedVariableInfo(element, uniqueExports, exportedNames, exportedBindings);
        } else if (!isGeneratedIdentifier(decl.name)) {
            const text = idText(decl.name);
            if (!uniqueExports.get(text)) {
                uniqueExports.set(text, true);
                exportedNames = append(exportedNames, decl.name);
                if (isLocalName(decl.name)) multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(decl), decl.name);
            }
        }
        return exportedNames;
    }
    function multiMapSparseArrayAdd(map2, key, value1) {
        let values = map2[key];
        if (values) values.push(value1);
        else map2[key] = values = [
            value1
        ];
        return values;
    }
    var IdentifierNameMap = class _IdentifierNameMap {
        get size() {
            return this._map.size;
        }
        has(key) {
            return this._map.has(_IdentifierNameMap.toKey(key));
        }
        get(key) {
            return this._map.get(_IdentifierNameMap.toKey(key));
        }
        set(key, value1) {
            this._map.set(_IdentifierNameMap.toKey(key), value1);
            return this;
        }
        delete(key) {
            var _a;
            var _ref;
            return (_ref = (_a = this._map) == null ? void 0 : _a.delete(_IdentifierNameMap.toKey(key))) !== null && _ref !== void 0 ? _ref : false;
        }
        clear() {
            this._map.clear();
        }
        values() {
            return this._map.values();
        }
        static toKey(name) {
            if (isGeneratedPrivateIdentifier(name) || isGeneratedIdentifier(name)) {
                const autoGenerate = name.emitNode.autoGenerate;
                if ((autoGenerate.flags & 7 /* KindMask */ ) === 4 /* Node */ ) {
                    const node = getNodeForGeneratedName(name);
                    const baseName = isMemberName(node) && node !== name ? _IdentifierNameMap.toKey(node) : `(generated@${getNodeId(node)})`;
                    return formatGeneratedName(/*privateName*/ false, autoGenerate.prefix, baseName, autoGenerate.suffix, _IdentifierNameMap.toKey);
                } else {
                    const baseName = `(auto@${autoGenerate.id})`;
                    return formatGeneratedName(/*privateName*/ false, autoGenerate.prefix, baseName, autoGenerate.suffix, _IdentifierNameMap.toKey);
                }
            }
            if (isPrivateIdentifier(name)) return idText(name).slice(1);
            return idText(name);
        }
        constructor(){
            this._map = /* @__PURE__ */ new Map();
        }
    };
    var IdentifierNameMultiMap = class extends IdentifierNameMap {
        add(key, value1) {
            let values = this.get(key);
            if (values) values.push(value1);
            else this.set(key, values = [
                value1
            ]);
            return values;
        }
        remove(key, value1) {
            const values = this.get(key);
            if (values) {
                unorderedRemoveItem(values, value1);
                if (!values.length) this.delete(key);
            }
        }
    };
    function isSimpleCopiableExpression(expression) {
        return isStringLiteralLike(expression) || expression.kind === 9 /* NumericLiteral */  || isKeyword(expression.kind) || isIdentifier(expression);
    }
    function isSimpleInlineableExpression(expression) {
        return !isIdentifier(expression) && isSimpleCopiableExpression(expression);
    }
    function isCompoundAssignment(kind) {
        return kind >= 65 /* FirstCompoundAssignment */  && kind <= 79 /* LastCompoundAssignment */ ;
    }
    function getNonAssignmentOperatorForCompoundAssignment(kind) {
        switch(kind){
            case 65 /* PlusEqualsToken */ :
                return 40 /* PlusToken */ ;
            case 66 /* MinusEqualsToken */ :
                return 41 /* MinusToken */ ;
            case 67 /* AsteriskEqualsToken */ :
                return 42 /* AsteriskToken */ ;
            case 68 /* AsteriskAsteriskEqualsToken */ :
                return 43 /* AsteriskAsteriskToken */ ;
            case 69 /* SlashEqualsToken */ :
                return 44 /* SlashToken */ ;
            case 70 /* PercentEqualsToken */ :
                return 45 /* PercentToken */ ;
            case 71 /* LessThanLessThanEqualsToken */ :
                return 48 /* LessThanLessThanToken */ ;
            case 72 /* GreaterThanGreaterThanEqualsToken */ :
                return 49 /* GreaterThanGreaterThanToken */ ;
            case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                return 50 /* GreaterThanGreaterThanGreaterThanToken */ ;
            case 74 /* AmpersandEqualsToken */ :
                return 51 /* AmpersandToken */ ;
            case 75 /* BarEqualsToken */ :
                return 52 /* BarToken */ ;
            case 79 /* CaretEqualsToken */ :
                return 53 /* CaretToken */ ;
            case 76 /* BarBarEqualsToken */ :
                return 57 /* BarBarToken */ ;
            case 77 /* AmpersandAmpersandEqualsToken */ :
                return 56 /* AmpersandAmpersandToken */ ;
            case 78 /* QuestionQuestionEqualsToken */ :
                return 61 /* QuestionQuestionToken */ ;
        }
    }
    function getSuperCallFromStatement(statement) {
        if (!isExpressionStatement(statement)) return void 0;
        const expression = skipParentheses(statement.expression);
        return isSuperCall(expression) ? expression : void 0;
    }
    function findSuperStatementIndexPathWorker(statements, start, indices) {
        for(let i = start; i < statements.length; i += 1){
            const statement = statements[i];
            if (getSuperCallFromStatement(statement)) {
                indices.unshift(i);
                return true;
            } else if (isTryStatement(statement) && findSuperStatementIndexPathWorker(statement.tryBlock.statements, 0, indices)) {
                indices.unshift(i);
                return true;
            }
        }
        return false;
    }
    function findSuperStatementIndexPath(statements, start) {
        const indices = [];
        findSuperStatementIndexPathWorker(statements, start, indices);
        return indices;
    }
    function getProperties(node, requireInitializer, isStatic2) {
        return filter(node.members, (m)=>isInitializedOrStaticProperty(m, requireInitializer, isStatic2));
    }
    function isStaticPropertyDeclarationOrClassStaticBlockDeclaration(element) {
        return isStaticPropertyDeclaration(element) || isClassStaticBlockDeclaration(element);
    }
    function getStaticPropertiesAndClassStaticBlock(node) {
        return filter(node.members, isStaticPropertyDeclarationOrClassStaticBlockDeclaration);
    }
    function isInitializedOrStaticProperty(member, requireInitializer, isStatic2) {
        return isPropertyDeclaration(member) && (!!member.initializer || !requireInitializer) && hasStaticModifier(member) === isStatic2;
    }
    function isStaticPropertyDeclaration(member) {
        return isPropertyDeclaration(member) && hasStaticModifier(member);
    }
    function isInitializedProperty(member) {
        return member.kind === 173 /* PropertyDeclaration */  && member.initializer !== void 0;
    }
    function isNonStaticMethodOrAccessorWithPrivateName(member) {
        return !isStatic(member) && (isMethodOrAccessor(member) || isAutoAccessorPropertyDeclaration(member)) && isPrivateIdentifier(member.name);
    }
    function getDecoratorsOfParameters(node) {
        let decorators;
        if (node) {
            const parameters = node.parameters;
            const firstParameterIsThis = parameters.length > 0 && parameterIsThisKeyword(parameters[0]);
            const firstParameterOffset = firstParameterIsThis ? 1 : 0;
            const numParameters = firstParameterIsThis ? parameters.length - 1 : parameters.length;
            for(let i = 0; i < numParameters; i++){
                const parameter = parameters[i + firstParameterOffset];
                if (decorators || hasDecorators(parameter)) {
                    if (!decorators) decorators = new Array(numParameters);
                    decorators[i] = getDecorators(parameter);
                }
            }
        }
        return decorators;
    }
    function getAllDecoratorsOfClass(node, useLegacyDecorators) {
        const decorators = getDecorators(node);
        const parameters = useLegacyDecorators ? getDecoratorsOfParameters(getFirstConstructorWithBody(node)) : void 0;
        if (!some(decorators) && !some(parameters)) return void 0;
        return {
            decorators,
            parameters
        };
    }
    function getAllDecoratorsOfClassElement(member, parent2, useLegacyDecorators) {
        switch(member.kind){
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                if (!useLegacyDecorators) return getAllDecoratorsOfMethod(member, /*useLegacyDecorators*/ false);
                return getAllDecoratorsOfAccessors(member, parent2, /*useLegacyDecorators*/ true);
            case 175 /* MethodDeclaration */ :
                return getAllDecoratorsOfMethod(member, useLegacyDecorators);
            case 173 /* PropertyDeclaration */ :
                return getAllDecoratorsOfProperty(member);
            default:
                return void 0;
        }
    }
    function getAllDecoratorsOfAccessors(accessor, parent2, useLegacyDecorators) {
        if (!accessor.body) return void 0;
        const { firstAccessor, secondAccessor, getAccessor, setAccessor } = getAllAccessorDeclarations(parent2.members, accessor);
        const firstAccessorWithDecorators = hasDecorators(firstAccessor) ? firstAccessor : secondAccessor && hasDecorators(secondAccessor) ? secondAccessor : void 0;
        if (!firstAccessorWithDecorators || accessor !== firstAccessorWithDecorators) return void 0;
        const decorators = getDecorators(firstAccessorWithDecorators);
        const parameters = useLegacyDecorators ? getDecoratorsOfParameters(setAccessor) : void 0;
        if (!some(decorators) && !some(parameters)) return void 0;
        return {
            decorators,
            parameters,
            getDecorators: getAccessor && getDecorators(getAccessor),
            setDecorators: setAccessor && getDecorators(setAccessor)
        };
    }
    function getAllDecoratorsOfMethod(method, useLegacyDecorators) {
        if (!method.body) return void 0;
        const decorators = getDecorators(method);
        const parameters = useLegacyDecorators ? getDecoratorsOfParameters(method) : void 0;
        if (!some(decorators) && !some(parameters)) return void 0;
        return {
            decorators,
            parameters
        };
    }
    function getAllDecoratorsOfProperty(property) {
        const decorators = getDecorators(property);
        if (!some(decorators)) return void 0;
        return {
            decorators
        };
    }
    function walkUpLexicalEnvironments(env, cb) {
        while(env){
            const result = cb(env);
            if (result !== void 0) return result;
            env = env.previous;
        }
    }
    function newPrivateEnvironment(data) {
        return {
            data
        };
    }
    function getPrivateIdentifier(privateEnv, name) {
        var _a, _b;
        return isGeneratedPrivateIdentifier(name) ? (_a = privateEnv == null ? void 0 : privateEnv.generatedIdentifiers) == null ? void 0 : _a.get(getNodeForGeneratedName(name)) : (_b = privateEnv == null ? void 0 : privateEnv.identifiers) == null ? void 0 : _b.get(name.escapedText);
    }
    function setPrivateIdentifier(privateEnv, name, entry) {
        if (isGeneratedPrivateIdentifier(name)) {
            var _privateEnv_generatedIdentifiers;
            (_privateEnv_generatedIdentifiers = privateEnv.generatedIdentifiers) !== null && _privateEnv_generatedIdentifiers !== void 0 ? _privateEnv_generatedIdentifiers : privateEnv.generatedIdentifiers = /* @__PURE__ */ new Map();
            privateEnv.generatedIdentifiers.set(getNodeForGeneratedName(name), entry);
        } else {
            var _privateEnv_identifiers;
            (_privateEnv_identifiers = privateEnv.identifiers) !== null && _privateEnv_identifiers !== void 0 ? _privateEnv_identifiers : privateEnv.identifiers = /* @__PURE__ */ new Map();
            privateEnv.identifiers.set(name.escapedText, entry);
        }
    }
    function accessPrivateIdentifier(env, name) {
        return walkUpLexicalEnvironments(env, (env2)=>getPrivateIdentifier(env2.privateEnv, name));
    }
    function isSimpleParameter(node) {
        return !node.initializer && isIdentifier(node.name);
    }
    function isSimpleParameterList(nodes) {
        return every(nodes, isSimpleParameter);
    }
    function rewriteModuleSpecifier(node, compilerOptions) {
        if (!node || !isStringLiteral(node) || !shouldRewriteModuleSpecifier(node.text, compilerOptions)) return node;
        const updatedText = changeExtension(node.text, getOutputExtension(node.text, compilerOptions));
        return updatedText !== node.text ? setOriginalNode(setTextRange(factory.createStringLiteral(updatedText, node.singleQuote), node), node) : node;
    }
    // src/compiler/transformers/destructuring.ts
    var FlattenLevel = /* @__PURE__ */ ((FlattenLevel2)=>{
        FlattenLevel2[FlattenLevel2["All"] = 0] = "All";
        FlattenLevel2[FlattenLevel2["ObjectRest"] = 1] = "ObjectRest";
        return FlattenLevel2;
    })(FlattenLevel || {});
    function flattenDestructuringAssignment(node, visitor, context, level, needsValue, createAssignmentCallback) {
        let location = node;
        let value1;
        if (isDestructuringAssignment(node)) {
            value1 = node.right;
            while(isEmptyArrayLiteral(node.left) || isEmptyObjectLiteral(node.left)){
                if (isDestructuringAssignment(value1)) {
                    location = node = value1;
                    value1 = node.right;
                } else return Debug.checkDefined(visitNode(value1, visitor, isExpression));
            }
        }
        let expressions;
        const flattenContext = {
            context,
            level,
            downlevelIteration: !!context.getCompilerOptions().downlevelIteration,
            hoistTempVariables: true,
            emitExpression,
            emitBindingOrAssignment,
            createArrayBindingOrAssignmentPattern: (elements)=>makeArrayAssignmentPattern(context.factory, elements),
            createObjectBindingOrAssignmentPattern: (elements)=>makeObjectAssignmentPattern(context.factory, elements),
            createArrayBindingOrAssignmentElement: makeAssignmentElement,
            visitor
        };
        if (value1) {
            value1 = visitNode(value1, visitor, isExpression);
            Debug.assert(value1);
            if (isIdentifier(value1) && bindingOrAssignmentElementAssignsToName(node, value1.escapedText) || bindingOrAssignmentElementContainsNonLiteralComputedName(node)) value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ false, location);
            else if (needsValue) value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ true, location);
            else if (nodeIsSynthesized(node)) location = value1;
        }
        flattenBindingOrAssignmentElement(flattenContext, node, value1, location, /*skipInitializer*/ isDestructuringAssignment(node));
        if (value1 && needsValue) {
            if (!some(expressions)) return value1;
            expressions.push(value1);
        }
        return context.factory.inlineExpressions(expressions) || context.factory.createOmittedExpression();
        function emitExpression(expression) {
            expressions = append(expressions, expression);
        }
        function emitBindingOrAssignment(target, value2, location2, original) {
            Debug.assertNode(target, createAssignmentCallback ? isIdentifier : isExpression);
            const expression = createAssignmentCallback ? createAssignmentCallback(target, value2, location2) : setTextRange(context.factory.createAssignment(Debug.checkDefined(visitNode(target, visitor, isExpression)), value2), location2);
            expression.original = original;
            emitExpression(expression);
        }
    }
    function bindingOrAssignmentElementAssignsToName(element, escapedName) {
        const target = getTargetOfBindingOrAssignmentElement(element);
        if (isBindingOrAssignmentPattern(target)) return bindingOrAssignmentPatternAssignsToName(target, escapedName);
        else if (isIdentifier(target)) return target.escapedText === escapedName;
        return false;
    }
    function bindingOrAssignmentPatternAssignsToName(pattern, escapedName) {
        const elements = getElementsOfBindingOrAssignmentPattern(pattern);
        for (const element of elements){
            if (bindingOrAssignmentElementAssignsToName(element, escapedName)) return true;
        }
        return false;
    }
    function bindingOrAssignmentElementContainsNonLiteralComputedName(element) {
        const propertyName = tryGetPropertyNameOfBindingOrAssignmentElement(element);
        if (propertyName && isComputedPropertyName(propertyName) && !isLiteralExpression(propertyName.expression)) return true;
        const target = getTargetOfBindingOrAssignmentElement(element);
        return !!target && isBindingOrAssignmentPattern(target) && bindingOrAssignmentPatternContainsNonLiteralComputedName(target);
    }
    function bindingOrAssignmentPatternContainsNonLiteralComputedName(pattern) {
        return !!forEach(getElementsOfBindingOrAssignmentPattern(pattern), bindingOrAssignmentElementContainsNonLiteralComputedName);
    }
    function flattenDestructuringBinding(node, visitor, context, level, rval, hoistTempVariables = false, skipInitializer) {
        let pendingExpressions;
        const pendingDeclarations = [];
        const declarations = [];
        const flattenContext = {
            context,
            level,
            downlevelIteration: !!context.getCompilerOptions().downlevelIteration,
            hoistTempVariables,
            emitExpression,
            emitBindingOrAssignment,
            createArrayBindingOrAssignmentPattern: (elements)=>makeArrayBindingPattern(context.factory, elements),
            createObjectBindingOrAssignmentPattern: (elements)=>makeObjectBindingPattern(context.factory, elements),
            createArrayBindingOrAssignmentElement: (name)=>makeBindingElement(context.factory, name),
            visitor
        };
        if (isVariableDeclaration(node)) {
            let initializer = getInitializerOfBindingOrAssignmentElement(node);
            if (initializer && (isIdentifier(initializer) && bindingOrAssignmentElementAssignsToName(node, initializer.escapedText) || bindingOrAssignmentElementContainsNonLiteralComputedName(node))) {
                initializer = ensureIdentifier(flattenContext, Debug.checkDefined(visitNode(initializer, flattenContext.visitor, isExpression)), /*reuseIdentifierExpressions*/ false, initializer);
                node = context.factory.updateVariableDeclaration(node, node.name, /*exclamationToken*/ void 0, /*type*/ void 0, initializer);
            }
        }
        flattenBindingOrAssignmentElement(flattenContext, node, rval, node, skipInitializer);
        if (pendingExpressions) {
            const temp = context.factory.createTempVariable(/*recordTempVariable*/ void 0);
            if (hoistTempVariables) {
                const value1 = context.factory.inlineExpressions(pendingExpressions);
                pendingExpressions = void 0;
                emitBindingOrAssignment(temp, value1, /*location*/ void 0, /*original*/ void 0);
            } else {
                context.hoistVariableDeclaration(temp);
                const pendingDeclaration = last(pendingDeclarations);
                pendingDeclaration.pendingExpressions = append(pendingDeclaration.pendingExpressions, context.factory.createAssignment(temp, pendingDeclaration.value));
                addRange(pendingDeclaration.pendingExpressions, pendingExpressions);
                pendingDeclaration.value = temp;
            }
        }
        for (const { pendingExpressions: pendingExpressions2, name, value: value1, location, original } of pendingDeclarations){
            const variable = context.factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, pendingExpressions2 ? context.factory.inlineExpressions(append(pendingExpressions2, value1)) : value1);
            variable.original = original;
            setTextRange(variable, location);
            declarations.push(variable);
        }
        return declarations;
        function emitExpression(value1) {
            pendingExpressions = append(pendingExpressions, value1);
        }
        function emitBindingOrAssignment(target, value1, location, original) {
            Debug.assertNode(target, isBindingName);
            if (pendingExpressions) {
                value1 = context.factory.inlineExpressions(append(pendingExpressions, value1));
                pendingExpressions = void 0;
            }
            pendingDeclarations.push({
                pendingExpressions,
                name: target,
                value: value1,
                location,
                original
            });
        }
    }
    function flattenBindingOrAssignmentElement(flattenContext, element, value1, location, skipInitializer) {
        const bindingTarget = getTargetOfBindingOrAssignmentElement(element);
        if (!skipInitializer) {
            const initializer = visitNode(getInitializerOfBindingOrAssignmentElement(element), flattenContext.visitor, isExpression);
            if (initializer) {
                if (value1) {
                    value1 = createDefaultValueCheck(flattenContext, value1, initializer, location);
                    if (!isSimpleInlineableExpression(initializer) && isBindingOrAssignmentPattern(bindingTarget)) value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ true, location);
                } else value1 = initializer;
            } else if (!value1) value1 = flattenContext.context.factory.createVoidZero();
        }
        if (isObjectBindingOrAssignmentPattern(bindingTarget)) flattenObjectBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value1, location);
        else if (isArrayBindingOrAssignmentPattern(bindingTarget)) flattenArrayBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value1, location);
        else flattenContext.emitBindingOrAssignment(bindingTarget, value1, location, /*original*/ element);
    }
    function flattenObjectBindingOrAssignmentPattern(flattenContext, parent2, pattern, value1, location) {
        const elements = getElementsOfBindingOrAssignmentPattern(pattern);
        const numElements = elements.length;
        if (numElements !== 1) {
            const reuseIdentifierExpressions = !isDeclarationBindingElement(parent2) || numElements !== 0;
            value1 = ensureIdentifier(flattenContext, value1, reuseIdentifierExpressions, location);
        }
        let bindingElements;
        let computedTempVariables;
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            if (!getRestIndicatorOfBindingOrAssignmentElement(element)) {
                const propertyName = getPropertyNameOfBindingOrAssignmentElement(element);
                if (flattenContext.level >= 1 /* ObjectRest */  && !(element.transformFlags & 98304 /* ContainsObjectRestOrSpread */ ) && !(getTargetOfBindingOrAssignmentElement(element).transformFlags & 98304 /* ContainsObjectRestOrSpread */ ) && !isComputedPropertyName(propertyName)) bindingElements = append(bindingElements, visitNode(element, flattenContext.visitor, isBindingOrAssignmentElement));
                else {
                    if (bindingElements) {
                        flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
                        bindingElements = void 0;
                    }
                    const rhsValue = createDestructuringPropertyAccess(flattenContext, value1, propertyName);
                    if (isComputedPropertyName(propertyName)) computedTempVariables = append(computedTempVariables, rhsValue.argumentExpression);
                    flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
                }
            } else if (i === numElements - 1) {
                if (bindingElements) {
                    flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
                    bindingElements = void 0;
                }
                const rhsValue = flattenContext.context.getEmitHelperFactory().createRestHelper(value1, elements, computedTempVariables, pattern);
                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, element);
            }
        }
        if (bindingElements) flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
    }
    function flattenArrayBindingOrAssignmentPattern(flattenContext, parent2, pattern, value1, location) {
        const elements = getElementsOfBindingOrAssignmentPattern(pattern);
        const numElements = elements.length;
        if (flattenContext.level < 1 /* ObjectRest */  && flattenContext.downlevelIteration) value1 = ensureIdentifier(flattenContext, setTextRange(flattenContext.context.getEmitHelperFactory().createReadHelper(value1, numElements > 0 && getRestIndicatorOfBindingOrAssignmentElement(elements[numElements - 1]) ? void 0 : numElements), location), /*reuseIdentifierExpressions*/ false, location);
        else if (numElements !== 1 && (flattenContext.level < 1 /* ObjectRest */  || numElements === 0) || every(elements, isOmittedExpression)) {
            const reuseIdentifierExpressions = !isDeclarationBindingElement(parent2) || numElements !== 0;
            value1 = ensureIdentifier(flattenContext, value1, reuseIdentifierExpressions, location);
        }
        let bindingElements;
        let restContainingElements;
        for(let i = 0; i < numElements; i++){
            const element = elements[i];
            if (flattenContext.level >= 1 /* ObjectRest */ ) {
                if (element.transformFlags & 65536 /* ContainsObjectRestOrSpread */  || flattenContext.hasTransformedPriorElement && !isSimpleBindingOrAssignmentElement(element)) {
                    flattenContext.hasTransformedPriorElement = true;
                    const temp = flattenContext.context.factory.createTempVariable(/*recordTempVariable*/ void 0);
                    if (flattenContext.hoistTempVariables) flattenContext.context.hoistVariableDeclaration(temp);
                    restContainingElements = append(restContainingElements, [
                        temp,
                        element
                    ]);
                    bindingElements = append(bindingElements, flattenContext.createArrayBindingOrAssignmentElement(temp));
                } else bindingElements = append(bindingElements, element);
            } else if (isOmittedExpression(element)) continue;
            else if (!getRestIndicatorOfBindingOrAssignmentElement(element)) {
                const rhsValue = flattenContext.context.factory.createElementAccessExpression(value1, i);
                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
            } else if (i === numElements - 1) {
                const rhsValue = flattenContext.context.factory.createArraySliceCall(value1, i);
                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
            }
        }
        if (bindingElements) flattenContext.emitBindingOrAssignment(flattenContext.createArrayBindingOrAssignmentPattern(bindingElements), value1, location, pattern);
        if (restContainingElements) for (const [id, element] of restContainingElements)flattenBindingOrAssignmentElement(flattenContext, element, id, element);
    }
    function isSimpleBindingOrAssignmentElement(element) {
        const target = getTargetOfBindingOrAssignmentElement(element);
        if (!target || isOmittedExpression(target)) return true;
        const propertyName = tryGetPropertyNameOfBindingOrAssignmentElement(element);
        if (propertyName && !isPropertyNameLiteral(propertyName)) return false;
        const initializer = getInitializerOfBindingOrAssignmentElement(element);
        if (initializer && !isSimpleInlineableExpression(initializer)) return false;
        if (isBindingOrAssignmentPattern(target)) return every(getElementsOfBindingOrAssignmentPattern(target), isSimpleBindingOrAssignmentElement);
        return isIdentifier(target);
    }
    function createDefaultValueCheck(flattenContext, value1, defaultValue, location) {
        value1 = ensureIdentifier(flattenContext, value1, /*reuseIdentifierExpressions*/ true, location);
        return flattenContext.context.factory.createConditionalExpression(flattenContext.context.factory.createTypeCheck(value1, "undefined"), /*questionToken*/ void 0, defaultValue, /*colonToken*/ void 0, value1);
    }
    function createDestructuringPropertyAccess(flattenContext, value1, propertyName) {
        const { factory: factory2 } = flattenContext.context;
        if (isComputedPropertyName(propertyName)) {
            const argumentExpression = ensureIdentifier(flattenContext, Debug.checkDefined(visitNode(propertyName.expression, flattenContext.visitor, isExpression)), /*reuseIdentifierExpressions*/ false, /*location*/ propertyName);
            return flattenContext.context.factory.createElementAccessExpression(value1, argumentExpression);
        } else if (isStringOrNumericLiteralLike(propertyName) || isBigIntLiteral(propertyName)) {
            const argumentExpression = factory2.cloneNode(propertyName);
            return flattenContext.context.factory.createElementAccessExpression(value1, argumentExpression);
        } else {
            const name = flattenContext.context.factory.createIdentifier(idText(propertyName));
            return flattenContext.context.factory.createPropertyAccessExpression(value1, name);
        }
    }
    function ensureIdentifier(flattenContext, value1, reuseIdentifierExpressions, location) {
        if (isIdentifier(value1) && reuseIdentifierExpressions) return value1;
        else {
            const temp = flattenContext.context.factory.createTempVariable(/*recordTempVariable*/ void 0);
            if (flattenContext.hoistTempVariables) {
                flattenContext.context.hoistVariableDeclaration(temp);
                flattenContext.emitExpression(setTextRange(flattenContext.context.factory.createAssignment(temp, value1), location));
            } else flattenContext.emitBindingOrAssignment(temp, value1, location, /*original*/ void 0);
            return temp;
        }
    }
    function makeArrayBindingPattern(factory2, elements) {
        Debug.assertEachNode(elements, isArrayBindingElement);
        return factory2.createArrayBindingPattern(elements);
    }
    function makeArrayAssignmentPattern(factory2, elements) {
        Debug.assertEachNode(elements, isArrayBindingOrAssignmentElement);
        return factory2.createArrayLiteralExpression(map(elements, factory2.converters.convertToArrayAssignmentElement));
    }
    function makeObjectBindingPattern(factory2, elements) {
        Debug.assertEachNode(elements, isBindingElement);
        return factory2.createObjectBindingPattern(elements);
    }
    function makeObjectAssignmentPattern(factory2, elements) {
        Debug.assertEachNode(elements, isObjectBindingOrAssignmentElement);
        return factory2.createObjectLiteralExpression(map(elements, factory2.converters.convertToObjectAssignmentElement));
    }
    function makeBindingElement(factory2, name) {
        return factory2.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, name);
    }
    function makeAssignmentElement(name) {
        return name;
    }
    // src/compiler/transformers/classThis.ts
    function createClassThisAssignmentBlock(factory2, classThis, thisExpression = factory2.createThis()) {
        const expression = factory2.createAssignment(classThis, thisExpression);
        const statement = factory2.createExpressionStatement(expression);
        const body = factory2.createBlock([
            statement
        ], /*multiLine*/ false);
        const block = factory2.createClassStaticBlockDeclaration(body);
        getOrCreateEmitNode(block).classThis = classThis;
        return block;
    }
    function isClassThisAssignmentBlock(node) {
        var _a;
        if (!isClassStaticBlockDeclaration(node) || node.body.statements.length !== 1) return false;
        const statement = node.body.statements[0];
        return isExpressionStatement(statement) && isAssignmentExpression(statement.expression, /*excludeCompoundAssignment*/ true) && isIdentifier(statement.expression.left) && ((_a = node.emitNode) == null ? void 0 : _a.classThis) === statement.expression.left && statement.expression.right.kind === 110 /* ThisKeyword */ ;
    }
    function classHasClassThisAssignment(node) {
        var _a;
        return !!((_a = node.emitNode) == null ? void 0 : _a.classThis) && some(node.members, isClassThisAssignmentBlock);
    }
    function injectClassThisAssignmentIfMissing(factory2, node, classThis, thisExpression) {
        if (classHasClassThisAssignment(node)) return node;
        const staticBlock = createClassThisAssignmentBlock(factory2, classThis, thisExpression);
        if (node.name) setSourceMapRange(staticBlock.body.statements[0], node.name);
        const members = factory2.createNodeArray([
            staticBlock,
            ...node.members
        ]);
        setTextRange(members, node.members);
        const updatedNode = isClassDeclaration(node) ? factory2.updateClassDeclaration(node, node.modifiers, node.name, node.typeParameters, node.heritageClauses, members) : factory2.updateClassExpression(node, node.modifiers, node.name, node.typeParameters, node.heritageClauses, members);
        getOrCreateEmitNode(updatedNode).classThis = classThis;
        return updatedNode;
    }
    // src/compiler/transformers/namedEvaluation.ts
    function getAssignedNameOfIdentifier(factory2, name, expression) {
        const original = getOriginalNode(skipOuterExpressions(expression));
        if ((isClassDeclaration(original) || isFunctionDeclaration(original)) && !original.name && hasSyntacticModifier(original, 2048 /* Default */ )) return factory2.createStringLiteral("default");
        return factory2.createStringLiteralFromNode(name);
    }
    function getAssignedNameOfPropertyName(context, name, assignedNameText) {
        const { factory: factory2 } = context;
        if (assignedNameText !== void 0) {
            const assignedName2 = factory2.createStringLiteral(assignedNameText);
            return {
                assignedName: assignedName2,
                name
            };
        }
        if (isPropertyNameLiteral(name) || isPrivateIdentifier(name)) {
            const assignedName2 = factory2.createStringLiteralFromNode(name);
            return {
                assignedName: assignedName2,
                name
            };
        }
        if (isPropertyNameLiteral(name.expression) && !isIdentifier(name.expression)) {
            const assignedName2 = factory2.createStringLiteralFromNode(name.expression);
            return {
                assignedName: assignedName2,
                name
            };
        }
        const assignedName = factory2.getGeneratedNameForNode(name);
        context.hoistVariableDeclaration(assignedName);
        const key = context.getEmitHelperFactory().createPropKeyHelper(name.expression);
        const assignment = factory2.createAssignment(assignedName, key);
        const updatedName = factory2.updateComputedPropertyName(name, assignment);
        return {
            assignedName,
            name: updatedName
        };
    }
    function createClassNamedEvaluationHelperBlock(context, assignedName, thisExpression = context.factory.createThis()) {
        const { factory: factory2 } = context;
        const expression = context.getEmitHelperFactory().createSetFunctionNameHelper(thisExpression, assignedName);
        const statement = factory2.createExpressionStatement(expression);
        const body = factory2.createBlock([
            statement
        ], /*multiLine*/ false);
        const block = factory2.createClassStaticBlockDeclaration(body);
        getOrCreateEmitNode(block).assignedName = assignedName;
        return block;
    }
    function isClassNamedEvaluationHelperBlock(node) {
        var _a;
        if (!isClassStaticBlockDeclaration(node) || node.body.statements.length !== 1) return false;
        const statement = node.body.statements[0];
        return isExpressionStatement(statement) && isCallToHelper(statement.expression, "___setFunctionName") && statement.expression.arguments.length >= 2 && statement.expression.arguments[1] === ((_a = node.emitNode) == null ? void 0 : _a.assignedName);
    }
    function classHasExplicitlyAssignedName(node) {
        var _a;
        return !!((_a = node.emitNode) == null ? void 0 : _a.assignedName) && some(node.members, isClassNamedEvaluationHelperBlock);
    }
    function classHasDeclaredOrExplicitlyAssignedName(node) {
        return !!node.name || classHasExplicitlyAssignedName(node);
    }
    function injectClassNamedEvaluationHelperBlockIfMissing(context, node, assignedName, thisExpression) {
        if (classHasExplicitlyAssignedName(node)) return node;
        const { factory: factory2 } = context;
        const namedEvaluationBlock = createClassNamedEvaluationHelperBlock(context, assignedName, thisExpression);
        if (node.name) setSourceMapRange(namedEvaluationBlock.body.statements[0], node.name);
        const insertionIndex = findIndex(node.members, isClassThisAssignmentBlock) + 1;
        const leading = node.members.slice(0, insertionIndex);
        const trailing = node.members.slice(insertionIndex);
        const members = factory2.createNodeArray([
            ...leading,
            namedEvaluationBlock,
            ...trailing
        ]);
        setTextRange(members, node.members);
        node = isClassDeclaration(node) ? factory2.updateClassDeclaration(node, node.modifiers, node.name, node.typeParameters, node.heritageClauses, members) : factory2.updateClassExpression(node, node.modifiers, node.name, node.typeParameters, node.heritageClauses, members);
        getOrCreateEmitNode(node).assignedName = assignedName;
        return node;
    }
    function finishTransformNamedEvaluation(context, expression, assignedName, ignoreEmptyStringLiteral) {
        if (ignoreEmptyStringLiteral && isStringLiteral(assignedName) && isEmptyStringLiteral(assignedName)) return expression;
        const { factory: factory2 } = context;
        const innerExpression = skipOuterExpressions(expression);
        const updatedExpression = isClassExpression(innerExpression) ? cast(injectClassNamedEvaluationHelperBlockIfMissing(context, innerExpression, assignedName), isClassExpression) : context.getEmitHelperFactory().createSetFunctionNameHelper(innerExpression, assignedName);
        return factory2.restoreOuterExpressions(expression, updatedExpression);
    }
    function transformNamedEvaluationOfPropertyAssignment(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const { assignedName, name } = getAssignedNameOfPropertyName(context, node.name, assignedNameText);
        const initializer = finishTransformNamedEvaluation(context, node.initializer, assignedName, ignoreEmptyStringLiteral);
        return factory2.updatePropertyAssignment(node, name, initializer);
    }
    function transformNamedEvaluationOfShorthandAssignmentProperty(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const assignedName = assignedNameText !== void 0 ? factory2.createStringLiteral(assignedNameText) : getAssignedNameOfIdentifier(factory2, node.name, node.objectAssignmentInitializer);
        const objectAssignmentInitializer = finishTransformNamedEvaluation(context, node.objectAssignmentInitializer, assignedName, ignoreEmptyStringLiteral);
        return factory2.updateShorthandPropertyAssignment(node, node.name, objectAssignmentInitializer);
    }
    function transformNamedEvaluationOfVariableDeclaration(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const assignedName = assignedNameText !== void 0 ? factory2.createStringLiteral(assignedNameText) : getAssignedNameOfIdentifier(factory2, node.name, node.initializer);
        const initializer = finishTransformNamedEvaluation(context, node.initializer, assignedName, ignoreEmptyStringLiteral);
        return factory2.updateVariableDeclaration(node, node.name, node.exclamationToken, node.type, initializer);
    }
    function transformNamedEvaluationOfParameterDeclaration(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const assignedName = assignedNameText !== void 0 ? factory2.createStringLiteral(assignedNameText) : getAssignedNameOfIdentifier(factory2, node.name, node.initializer);
        const initializer = finishTransformNamedEvaluation(context, node.initializer, assignedName, ignoreEmptyStringLiteral);
        return factory2.updateParameterDeclaration(node, node.modifiers, node.dotDotDotToken, node.name, node.questionToken, node.type, initializer);
    }
    function transformNamedEvaluationOfBindingElement(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const assignedName = assignedNameText !== void 0 ? factory2.createStringLiteral(assignedNameText) : getAssignedNameOfIdentifier(factory2, node.name, node.initializer);
        const initializer = finishTransformNamedEvaluation(context, node.initializer, assignedName, ignoreEmptyStringLiteral);
        return factory2.updateBindingElement(node, node.dotDotDotToken, node.propertyName, node.name, initializer);
    }
    function transformNamedEvaluationOfPropertyDeclaration(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const { assignedName, name } = getAssignedNameOfPropertyName(context, node.name, assignedNameText);
        const initializer = finishTransformNamedEvaluation(context, node.initializer, assignedName, ignoreEmptyStringLiteral);
        var _node_questionToken;
        return factory2.updatePropertyDeclaration(node, node.modifiers, name, (_node_questionToken = node.questionToken) !== null && _node_questionToken !== void 0 ? _node_questionToken : node.exclamationToken, node.type, initializer);
    }
    function transformNamedEvaluationOfAssignmentExpression(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const assignedName = assignedNameText !== void 0 ? factory2.createStringLiteral(assignedNameText) : getAssignedNameOfIdentifier(factory2, node.left, node.right);
        const right = finishTransformNamedEvaluation(context, node.right, assignedName, ignoreEmptyStringLiteral);
        return factory2.updateBinaryExpression(node, node.left, node.operatorToken, right);
    }
    function transformNamedEvaluationOfExportAssignment(context, node, ignoreEmptyStringLiteral, assignedNameText) {
        const { factory: factory2 } = context;
        const assignedName = assignedNameText !== void 0 ? factory2.createStringLiteral(assignedNameText) : factory2.createStringLiteral(node.isExportEquals ? "" : "default");
        const expression = finishTransformNamedEvaluation(context, node.expression, assignedName, ignoreEmptyStringLiteral);
        return factory2.updateExportAssignment(node, node.modifiers, expression);
    }
    function transformNamedEvaluation(context, node, ignoreEmptyStringLiteral, assignedName) {
        switch(node.kind){
            case 304 /* PropertyAssignment */ :
                return transformNamedEvaluationOfPropertyAssignment(context, node, ignoreEmptyStringLiteral, assignedName);
            case 305 /* ShorthandPropertyAssignment */ :
                return transformNamedEvaluationOfShorthandAssignmentProperty(context, node, ignoreEmptyStringLiteral, assignedName);
            case 261 /* VariableDeclaration */ :
                return transformNamedEvaluationOfVariableDeclaration(context, node, ignoreEmptyStringLiteral, assignedName);
            case 170 /* Parameter */ :
                return transformNamedEvaluationOfParameterDeclaration(context, node, ignoreEmptyStringLiteral, assignedName);
            case 209 /* BindingElement */ :
                return transformNamedEvaluationOfBindingElement(context, node, ignoreEmptyStringLiteral, assignedName);
            case 173 /* PropertyDeclaration */ :
                return transformNamedEvaluationOfPropertyDeclaration(context, node, ignoreEmptyStringLiteral, assignedName);
            case 227 /* BinaryExpression */ :
                return transformNamedEvaluationOfAssignmentExpression(context, node, ignoreEmptyStringLiteral, assignedName);
            case 278 /* ExportAssignment */ :
                return transformNamedEvaluationOfExportAssignment(context, node, ignoreEmptyStringLiteral, assignedName);
        }
    }
    // src/compiler/transformers/taggedTemplate.ts
    var ProcessLevel = /* @__PURE__ */ ((ProcessLevel2)=>{
        ProcessLevel2[ProcessLevel2["LiftRestriction"] = 0] = "LiftRestriction";
        ProcessLevel2[ProcessLevel2["All"] = 1] = "All";
        return ProcessLevel2;
    })(ProcessLevel || {});
    function processTaggedTemplateExpression(context, node, visitor, currentSourceFile, recordTaggedTemplateString, level) {
        const tag = visitNode(node.tag, visitor, isExpression);
        Debug.assert(tag);
        const templateArguments = [
            void 0
        ];
        const cookedStrings = [];
        const rawStrings = [];
        const template = node.template;
        if (level === 0 /* LiftRestriction */  && !hasInvalidEscape(template)) return visitEachChild(node, visitor, context);
        const { factory: factory2 } = context;
        if (isNoSubstitutionTemplateLiteral(template)) {
            cookedStrings.push(createTemplateCooked(factory2, template));
            rawStrings.push(getRawLiteral(factory2, template, currentSourceFile));
        } else {
            cookedStrings.push(createTemplateCooked(factory2, template.head));
            rawStrings.push(getRawLiteral(factory2, template.head, currentSourceFile));
            for (const templateSpan of template.templateSpans){
                cookedStrings.push(createTemplateCooked(factory2, templateSpan.literal));
                rawStrings.push(getRawLiteral(factory2, templateSpan.literal, currentSourceFile));
                templateArguments.push(Debug.checkDefined(visitNode(templateSpan.expression, visitor, isExpression)));
            }
        }
        const helperCall = context.getEmitHelperFactory().createTemplateObjectHelper(factory2.createArrayLiteralExpression(cookedStrings), factory2.createArrayLiteralExpression(rawStrings));
        if (isExternalModule(currentSourceFile)) {
            const tempVar = factory2.createUniqueName("templateObject");
            recordTaggedTemplateString(tempVar);
            templateArguments[0] = factory2.createLogicalOr(tempVar, factory2.createAssignment(tempVar, helperCall));
        } else templateArguments[0] = helperCall;
        return factory2.createCallExpression(tag, /*typeArguments*/ void 0, templateArguments);
    }
    function createTemplateCooked(factory2, template) {
        return template.templateFlags & 26656 /* IsInvalid */  ? factory2.createVoidZero() : factory2.createStringLiteral(template.text);
    }
    function getRawLiteral(factory2, node, currentSourceFile) {
        let text = node.rawText;
        if (text === void 0) {
            Debug.assertIsDefined(currentSourceFile, "Template literal node is missing 'rawText' and does not have a source file. Possibly bad transform.");
            text = getSourceTextOfNodeFromSourceFile(currentSourceFile, node);
            const isLast = node.kind === 15 /* NoSubstitutionTemplateLiteral */  || node.kind === 18 /* TemplateTail */ ;
            text = text.substring(1, text.length - (isLast ? 1 : 2));
        }
        text = text.replace(/\r\n?/g, "\n");
        return setTextRange(factory2.createStringLiteral(text), node);
    }
    // src/compiler/transformers/ts.ts
    var USE_NEW_TYPE_METADATA_FORMAT = false;
    function transformTypeScript(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, startLexicalEnvironment, resumeLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const legacyDecorators = !!compilerOptions.experimentalDecorators;
        const typeSerializer = compilerOptions.emitDecoratorMetadata ? createRuntimeTypeSerializer(context) : void 0;
        const previousOnEmitNode = context.onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.enableSubstitution(212 /* PropertyAccessExpression */ );
        context.enableSubstitution(213 /* ElementAccessExpression */ );
        let currentSourceFile;
        let currentNamespace;
        let currentNamespaceContainerName;
        let currentLexicalScope;
        let currentScopeFirstDeclarationsOfName;
        let enabledSubstitutions = 0 /* None */ ;
        let applicableSubstitutions;
        return transformSourceFileOrBundle;
        function transformSourceFileOrBundle(node) {
            if (node.kind === 309 /* Bundle */ ) return transformBundle(node);
            return transformSourceFile(node);
        }
        function transformBundle(node) {
            return factory2.createBundle(node.sourceFiles.map(transformSourceFile));
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            const visited = saveStateAndInvoke(node, visitSourceFile);
            addEmitHelpers(visited, context.readEmitHelpers());
            currentSourceFile = void 0;
            return visited;
        }
        function saveStateAndInvoke(node, f) {
            const savedCurrentScope = currentLexicalScope;
            const savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
            onBeforeVisitNode(node);
            const visited = f(node);
            if (currentLexicalScope !== savedCurrentScope) currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
            currentLexicalScope = savedCurrentScope;
            return visited;
        }
        function onBeforeVisitNode(node) {
            switch(node.kind){
                case 308 /* SourceFile */ :
                case 270 /* CaseBlock */ :
                case 269 /* ModuleBlock */ :
                case 242 /* Block */ :
                    currentLexicalScope = node;
                    currentScopeFirstDeclarationsOfName = void 0;
                    break;
                case 264 /* ClassDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                    if (hasSyntacticModifier(node, 128 /* Ambient */ )) break;
                    if (node.name) recordEmittedDeclarationInScope(node);
                    else Debug.assert(node.kind === 264 /* ClassDeclaration */  || hasSyntacticModifier(node, 2048 /* Default */ ));
                    break;
            }
        }
        function visitor(node) {
            return saveStateAndInvoke(node, visitorWorker);
        }
        function visitorWorker(node) {
            if (node.transformFlags & 1 /* ContainsTypeScript */ ) return visitTypeScript(node);
            return node;
        }
        function sourceElementVisitor(node) {
            return saveStateAndInvoke(node, sourceElementVisitorWorker);
        }
        function sourceElementVisitorWorker(node) {
            switch(node.kind){
                case 273 /* ImportDeclaration */ :
                case 272 /* ImportEqualsDeclaration */ :
                case 278 /* ExportAssignment */ :
                case 279 /* ExportDeclaration */ :
                    return visitElidableStatement(node);
                default:
                    return visitorWorker(node);
            }
        }
        function isElisionBlocked(node) {
            const parsed = getParseTreeNode(node);
            if (parsed === node || isExportAssignment(node)) return false;
            if (!parsed || parsed.kind !== node.kind) return true;
            switch(node.kind){
                case 273 /* ImportDeclaration */ :
                    Debug.assertNode(parsed, isImportDeclaration);
                    if (node.importClause !== parsed.importClause) return true;
                    if (node.attributes !== parsed.attributes) return true;
                    break;
                case 272 /* ImportEqualsDeclaration */ :
                    Debug.assertNode(parsed, isImportEqualsDeclaration);
                    if (node.name !== parsed.name) return true;
                    if (node.isTypeOnly !== parsed.isTypeOnly) return true;
                    if (node.moduleReference !== parsed.moduleReference && (isEntityName(node.moduleReference) || isEntityName(parsed.moduleReference))) return true;
                    break;
                case 279 /* ExportDeclaration */ :
                    Debug.assertNode(parsed, isExportDeclaration);
                    if (node.exportClause !== parsed.exportClause) return true;
                    if (node.attributes !== parsed.attributes) return true;
                    break;
            }
            return false;
        }
        function visitElidableStatement(node) {
            if (isElisionBlocked(node)) {
                if (node.transformFlags & 1 /* ContainsTypeScript */ ) return visitEachChild(node, visitor, context);
                return node;
            }
            switch(node.kind){
                case 273 /* ImportDeclaration */ :
                    return visitImportDeclaration(node);
                case 272 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 278 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 279 /* ExportDeclaration */ :
                    return visitExportDeclaration(node);
                default:
                    Debug.fail("Unhandled ellided statement");
            }
        }
        function namespaceElementVisitor(node) {
            return saveStateAndInvoke(node, namespaceElementVisitorWorker);
        }
        function namespaceElementVisitorWorker(node) {
            if (node.kind === 279 /* ExportDeclaration */  || node.kind === 273 /* ImportDeclaration */  || node.kind === 274 /* ImportClause */  || node.kind === 272 /* ImportEqualsDeclaration */  && node.moduleReference.kind === 284 /* ExternalModuleReference */ ) return void 0;
            else if (node.transformFlags & 1 /* ContainsTypeScript */  || hasSyntacticModifier(node, 32 /* Export */ )) return visitTypeScript(node);
            return node;
        }
        function getClassElementVisitor(parent2) {
            return (node)=>saveStateAndInvoke(node, (n)=>classElementVisitorWorker(n, parent2));
        }
        function classElementVisitorWorker(node, parent2) {
            switch(node.kind){
                case 177 /* Constructor */ :
                    return visitConstructor(node);
                case 173 /* PropertyDeclaration */ :
                    return visitPropertyDeclaration(node, parent2);
                case 178 /* GetAccessor */ :
                    return visitGetAccessor(node, parent2);
                case 179 /* SetAccessor */ :
                    return visitSetAccessor(node, parent2);
                case 175 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node, parent2);
                case 176 /* ClassStaticBlockDeclaration */ :
                    return visitEachChild(node, visitor, context);
                case 241 /* SemicolonClassElement */ :
                    return node;
                case 182 /* IndexSignature */ :
                    return;
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function getObjectLiteralElementVisitor(parent2) {
            return (node)=>saveStateAndInvoke(node, (n)=>objectLiteralElementVisitorWorker(n, parent2));
        }
        function objectLiteralElementVisitorWorker(node, parent2) {
            switch(node.kind){
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                case 306 /* SpreadAssignment */ :
                    return visitor(node);
                case 178 /* GetAccessor */ :
                    return visitGetAccessor(node, parent2);
                case 179 /* SetAccessor */ :
                    return visitSetAccessor(node, parent2);
                case 175 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node, parent2);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function decoratorElidingVisitor(node) {
            return isDecorator(node) ? void 0 : visitor(node);
        }
        function modifierElidingVisitor(node) {
            return isModifier(node) ? void 0 : visitor(node);
        }
        function modifierVisitor(node) {
            if (isDecorator(node)) return void 0;
            if (modifierToFlag(node.kind) & 28895 /* TypeScriptModifier */ ) return void 0;
            else if (currentNamespace && node.kind === 95 /* ExportKeyword */ ) return void 0;
            return node;
        }
        function visitTypeScript(node) {
            if (isStatement(node) && hasSyntacticModifier(node, 128 /* Ambient */ )) return factory2.createNotEmittedStatement(node);
            switch(node.kind){
                case 95 /* ExportKeyword */ :
                case 90 /* DefaultKeyword */ :
                    return currentNamespace ? void 0 : node;
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 128 /* AbstractKeyword */ :
                case 164 /* OverrideKeyword */ :
                case 87 /* ConstKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 148 /* ReadonlyKeyword */ :
                case 103 /* InKeyword */ :
                case 147 /* OutKeyword */ :
                // TypeScript accessibility and readonly modifiers are elided
                // falls through
                case 189 /* ArrayType */ :
                case 190 /* TupleType */ :
                case 191 /* OptionalType */ :
                case 192 /* RestType */ :
                case 188 /* TypeLiteral */ :
                case 183 /* TypePredicate */ :
                case 169 /* TypeParameter */ :
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 136 /* BooleanKeyword */ :
                case 154 /* StringKeyword */ :
                case 150 /* NumberKeyword */ :
                case 146 /* NeverKeyword */ :
                case 116 /* VoidKeyword */ :
                case 155 /* SymbolKeyword */ :
                case 186 /* ConstructorType */ :
                case 185 /* FunctionType */ :
                case 187 /* TypeQuery */ :
                case 184 /* TypeReference */ :
                case 193 /* UnionType */ :
                case 194 /* IntersectionType */ :
                case 195 /* ConditionalType */ :
                case 197 /* ParenthesizedType */ :
                case 198 /* ThisType */ :
                case 199 /* TypeOperator */ :
                case 200 /* IndexedAccessType */ :
                case 201 /* MappedType */ :
                case 202 /* LiteralType */ :
                // TypeScript type nodes are elided.
                // falls through
                case 182 /* IndexSignature */ :
                    return void 0;
                case 266 /* TypeAliasDeclaration */ :
                    return factory2.createNotEmittedStatement(node);
                case 271 /* NamespaceExportDeclaration */ :
                    return void 0;
                case 265 /* InterfaceDeclaration */ :
                    return factory2.createNotEmittedStatement(node);
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 232 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 299 /* HeritageClause */ :
                    return visitHeritageClause(node);
                case 234 /* ExpressionWithTypeArguments */ :
                    return visitExpressionWithTypeArguments(node);
                case 211 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 177 /* Constructor */ :
                case 173 /* PropertyDeclaration */ :
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    return Debug.fail("Class and object literal elements must be visited with their respective visitors");
                case 263 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 219 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                case 220 /* ArrowFunction */ :
                    return visitArrowFunction(node);
                case 170 /* Parameter */ :
                    return visitParameter(node);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node);
                case 217 /* TypeAssertionExpression */ :
                case 235 /* AsExpression */ :
                    return visitAssertionExpression(node);
                case 239 /* SatisfiesExpression */ :
                    return visitSatisfiesExpression(node);
                case 214 /* CallExpression */ :
                    return visitCallExpression(node);
                case 215 /* NewExpression */ :
                    return visitNewExpression(node);
                case 216 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 236 /* NonNullExpression */ :
                    return visitNonNullExpression(node);
                case 267 /* EnumDeclaration */ :
                    return visitEnumDeclaration(node);
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 261 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 268 /* ModuleDeclaration */ :
                    return visitModuleDeclaration(node);
                case 272 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 286 /* JsxSelfClosingElement */ :
                    return visitJsxSelfClosingElement(node);
                case 287 /* JsxOpeningElement */ :
                    return visitJsxJsxOpeningElement(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitSourceFile(node) {
            const alwaysStrict = getStrictOptionValue(compilerOptions, "alwaysStrict") && !(isExternalModule(node) && moduleKind >= 5 /* ES2015 */ ) && !isJsonSourceFile(node);
            return factory2.updateSourceFile(node, visitLexicalEnvironment(node.statements, sourceElementVisitor, context, /*start*/ 0, alwaysStrict));
        }
        function visitObjectLiteralExpression(node) {
            return factory2.updateObjectLiteralExpression(node, visitNodes2(node.properties, getObjectLiteralElementVisitor(node), isObjectLiteralElementLike));
        }
        function getClassFacts(node) {
            let facts = 0 /* None */ ;
            if (some(getProperties(node, /*requireInitializer*/ true, /*isStatic*/ true))) facts |= 1 /* HasStaticInitializedProperties */ ;
            const extendsClauseElement = getEffectiveBaseTypeNode(node);
            if (extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ ) facts |= 64 /* IsDerivedClass */ ;
            if (classOrConstructorParameterIsDecorated(legacyDecorators, node)) facts |= 2 /* HasClassOrConstructorParameterDecorators */ ;
            if (childIsDecorated(legacyDecorators, node)) facts |= 4 /* HasMemberDecorators */ ;
            if (isExportOfNamespace(node)) facts |= 8 /* IsExportOfNamespace */ ;
            else if (isDefaultExternalModuleExport(node)) facts |= 32 /* IsDefaultExternalExport */ ;
            else if (isNamedExternalModuleExport(node)) facts |= 16 /* IsNamedExternalExport */ ;
            return facts;
        }
        function hasTypeScriptClassSyntax(node) {
            return !!(node.transformFlags & 8192 /* ContainsTypeScriptClassSyntax */ );
        }
        function isClassLikeDeclarationWithTypeScriptSyntax(node) {
            return hasDecorators(node) || some(node.typeParameters) || some(node.heritageClauses, hasTypeScriptClassSyntax) || some(node.members, hasTypeScriptClassSyntax);
        }
        function visitClassDeclaration(node) {
            const facts = getClassFacts(node);
            const promoteToIIFE = languageVersion <= 1 /* ES5 */  && !!(facts & 7 /* MayNeedImmediatelyInvokedFunctionExpression */ );
            if (!isClassLikeDeclarationWithTypeScriptSyntax(node) && !classOrConstructorParameterIsDecorated(legacyDecorators, node) && !isExportOfNamespace(node)) return factory2.updateClassDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, getClassElementVisitor(node), isClassElement));
            if (promoteToIIFE) context.startLexicalEnvironment();
            const moveModifiers = promoteToIIFE || facts & 8 /* IsExportOfNamespace */ ;
            let modifiers = moveModifiers ? visitNodes2(node.modifiers, modifierElidingVisitor, isModifierLike) : visitNodes2(node.modifiers, visitor, isModifierLike);
            if (facts & 2 /* HasClassOrConstructorParameterDecorators */ ) modifiers = injectClassTypeMetadata(modifiers, node);
            const needsName = moveModifiers && !node.name || facts & 4 /* HasMemberDecorators */  || facts & 1 /* HasStaticInitializedProperties */ ;
            var _node_name;
            const name = needsName ? (_node_name = node.name) !== null && _node_name !== void 0 ? _node_name : factory2.getGeneratedNameForNode(node) : node.name;
            const classDeclaration = factory2.updateClassDeclaration(node, modifiers, name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), transformClassMembers(node));
            let emitFlags = getEmitFlags(node);
            if (facts & 1 /* HasStaticInitializedProperties */ ) emitFlags |= 64 /* NoTrailingSourceMap */ ;
            setEmitFlags(classDeclaration, emitFlags);
            let statement;
            if (promoteToIIFE) {
                const statements = [
                    classDeclaration
                ];
                const closingBraceLocation = createTokenRange(skipTrivia(currentSourceFile.text, node.members.end), 20 /* CloseBraceToken */ );
                const localName = factory2.getInternalName(node);
                const outer = factory2.createPartiallyEmittedExpression(localName);
                setTextRangeEnd(outer, closingBraceLocation.end);
                setEmitFlags(outer, 3072 /* NoComments */ );
                const returnStatement = factory2.createReturnStatement(outer);
                setTextRangePos(returnStatement, closingBraceLocation.pos);
                setEmitFlags(returnStatement, 3840 /* NoTokenSourceMaps */ );
                statements.push(returnStatement);
                insertStatementsAfterStandardPrologue(statements, context.endLexicalEnvironment());
                const iife = factory2.createImmediatelyInvokedArrowFunction(statements);
                setInternalEmitFlags(iife, 1 /* TypeScriptClassWrapper */ );
                const varDecl = factory2.createVariableDeclaration(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ false), /*exclamationToken*/ void 0, /*type*/ void 0, iife);
                setOriginalNode(varDecl, node);
                const varStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    varDecl
                ], 1 /* Let */ ));
                setOriginalNode(varStatement, node);
                setCommentRange(varStatement, node);
                setSourceMapRange(varStatement, moveRangePastDecorators(node));
                startOnNewLine(varStatement);
                statement = varStatement;
            } else statement = classDeclaration;
            if (moveModifiers) {
                if (facts & 8 /* IsExportOfNamespace */ ) return [
                    statement,
                    createExportMemberAssignmentStatement(node)
                ];
                if (facts & 32 /* IsDefaultExternalExport */ ) return [
                    statement,
                    factory2.createExportDefault(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true))
                ];
                if (facts & 16 /* IsNamedExternalExport */ ) return [
                    statement,
                    factory2.createExternalModuleExport(factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true))
                ];
            }
            return statement;
        }
        function visitClassExpression(node) {
            let modifiers = visitNodes2(node.modifiers, modifierElidingVisitor, isModifierLike);
            if (classOrConstructorParameterIsDecorated(legacyDecorators, node)) modifiers = injectClassTypeMetadata(modifiers, node);
            return factory2.updateClassExpression(node, modifiers, node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), transformClassMembers(node));
        }
        function transformClassMembers(node) {
            const members = visitNodes2(node.members, getClassElementVisitor(node), isClassElement);
            let newMembers;
            const constructor = getFirstConstructorWithBody(node);
            const parametersWithPropertyAssignments = constructor && filter(constructor.parameters, (p)=>isParameterPropertyDeclaration(p, constructor));
            if (parametersWithPropertyAssignments) for (const parameter of parametersWithPropertyAssignments){
                const parameterProperty = factory2.createPropertyDeclaration(/*modifiers*/ void 0, parameter.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
                setOriginalNode(parameterProperty, parameter);
                newMembers = append(newMembers, parameterProperty);
            }
            if (newMembers) {
                newMembers = addRange(newMembers, members);
                return setTextRange(factory2.createNodeArray(newMembers), /*location*/ node.members);
            }
            return members;
        }
        function injectClassTypeMetadata(modifiers, node) {
            const metadata = getTypeMetadata(node, node);
            if (some(metadata)) {
                const modifiersArray = [];
                addRange(modifiersArray, takeWhile(modifiers, isExportOrDefaultModifier));
                addRange(modifiersArray, filter(modifiers, isDecorator));
                addRange(modifiersArray, metadata);
                addRange(modifiersArray, filter(skipWhile(modifiers, isExportOrDefaultModifier), isModifier));
                modifiers = setTextRange(factory2.createNodeArray(modifiersArray), modifiers);
            }
            return modifiers;
        }
        function injectClassElementTypeMetadata(modifiers, node, container) {
            if (isClassLike(container) && classElementOrClassElementParameterIsDecorated(legacyDecorators, node, container)) {
                const metadata = getTypeMetadata(node, container);
                if (some(metadata)) {
                    const modifiersArray = [];
                    addRange(modifiersArray, filter(modifiers, isDecorator));
                    addRange(modifiersArray, metadata);
                    addRange(modifiersArray, filter(modifiers, isModifier));
                    modifiers = setTextRange(factory2.createNodeArray(modifiersArray), modifiers);
                }
            }
            return modifiers;
        }
        function getTypeMetadata(node, container) {
            if (!legacyDecorators) return void 0;
            return USE_NEW_TYPE_METADATA_FORMAT ? getNewTypeMetadata(node, container) : getOldTypeMetadata(node, container);
        }
        function getOldTypeMetadata(node, container) {
            if (typeSerializer) {
                let decorators;
                if (shouldAddTypeMetadata(node)) {
                    const typeMetadata = emitHelpers().createMetadataHelper("design:type", typeSerializer.serializeTypeOfNode({
                        currentLexicalScope,
                        currentNameScope: container
                    }, node, container));
                    decorators = append(decorators, factory2.createDecorator(typeMetadata));
                }
                if (shouldAddParamTypesMetadata(node)) {
                    const paramTypesMetadata = emitHelpers().createMetadataHelper("design:paramtypes", typeSerializer.serializeParameterTypesOfNode({
                        currentLexicalScope,
                        currentNameScope: container
                    }, node, container));
                    decorators = append(decorators, factory2.createDecorator(paramTypesMetadata));
                }
                if (shouldAddReturnTypeMetadata(node)) {
                    const returnTypeMetadata = emitHelpers().createMetadataHelper("design:returntype", typeSerializer.serializeReturnTypeOfNode({
                        currentLexicalScope,
                        currentNameScope: container
                    }, node));
                    decorators = append(decorators, factory2.createDecorator(returnTypeMetadata));
                }
                return decorators;
            }
        }
        function getNewTypeMetadata(node, container) {
            if (typeSerializer) {
                let properties;
                if (shouldAddTypeMetadata(node)) {
                    const typeProperty = factory2.createPropertyAssignment("type", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [], /*type*/ void 0, factory2.createToken(39 /* EqualsGreaterThanToken */ ), typeSerializer.serializeTypeOfNode({
                        currentLexicalScope,
                        currentNameScope: container
                    }, node, container)));
                    properties = append(properties, typeProperty);
                }
                if (shouldAddParamTypesMetadata(node)) {
                    const paramTypeProperty = factory2.createPropertyAssignment("paramTypes", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [], /*type*/ void 0, factory2.createToken(39 /* EqualsGreaterThanToken */ ), typeSerializer.serializeParameterTypesOfNode({
                        currentLexicalScope,
                        currentNameScope: container
                    }, node, container)));
                    properties = append(properties, paramTypeProperty);
                }
                if (shouldAddReturnTypeMetadata(node)) {
                    const returnTypeProperty = factory2.createPropertyAssignment("returnType", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, [], /*type*/ void 0, factory2.createToken(39 /* EqualsGreaterThanToken */ ), typeSerializer.serializeReturnTypeOfNode({
                        currentLexicalScope,
                        currentNameScope: container
                    }, node)));
                    properties = append(properties, returnTypeProperty);
                }
                if (properties) {
                    const typeInfoMetadata = emitHelpers().createMetadataHelper("design:typeinfo", factory2.createObjectLiteralExpression(properties, /*multiLine*/ true));
                    return [
                        factory2.createDecorator(typeInfoMetadata)
                    ];
                }
            }
        }
        function shouldAddTypeMetadata(node) {
            const kind = node.kind;
            return kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */  || kind === 173 /* PropertyDeclaration */ ;
        }
        function shouldAddReturnTypeMetadata(node) {
            return node.kind === 175 /* MethodDeclaration */ ;
        }
        function shouldAddParamTypesMetadata(node) {
            switch(node.kind){
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    return getFirstConstructorWithBody(node) !== void 0;
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return true;
            }
            return false;
        }
        function getExpressionForPropertyName(member, generateNameForComputedPropertyName) {
            const name = member.name;
            if (isPrivateIdentifier(name)) return factory2.createIdentifier("");
            else if (isComputedPropertyName(name)) return generateNameForComputedPropertyName && !isSimpleInlineableExpression(name.expression) ? factory2.getGeneratedNameForNode(name) : name.expression;
            else if (isIdentifier(name)) return factory2.createStringLiteral(idText(name));
            else return factory2.cloneNode(name);
        }
        function visitPropertyNameOfClassElement(member) {
            const name = member.name;
            if (legacyDecorators && isComputedPropertyName(name) && hasDecorators(member)) {
                const expression = visitNode(name.expression, visitor, isExpression);
                Debug.assert(expression);
                const innerExpression = skipPartiallyEmittedExpressions(expression);
                if (!isSimpleInlineableExpression(innerExpression)) {
                    const generatedName = factory2.getGeneratedNameForNode(name);
                    hoistVariableDeclaration(generatedName);
                    return factory2.updateComputedPropertyName(name, factory2.createAssignment(generatedName, expression));
                }
            }
            return Debug.checkDefined(visitNode(name, visitor, isPropertyName));
        }
        function visitHeritageClause(node) {
            if (node.token === 119 /* ImplementsKeyword */ ) return void 0;
            return visitEachChild(node, visitor, context);
        }
        function visitExpressionWithTypeArguments(node) {
            return factory2.updateExpressionWithTypeArguments(node, Debug.checkDefined(visitNode(node.expression, visitor, isLeftHandSideExpression)), /*typeArguments*/ void 0);
        }
        function shouldEmitFunctionLikeDeclaration(node) {
            return !nodeIsMissing(node.body);
        }
        function visitPropertyDeclaration(node, parent2) {
            const isAmbient = node.flags & 33554432 /* Ambient */  || hasSyntacticModifier(node, 64 /* Abstract */ );
            if (isAmbient && !(legacyDecorators && hasDecorators(node))) return void 0;
            let modifiers = isClassLike(parent2) ? !isAmbient ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, modifierElidingVisitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            if (isAmbient) return factory2.updatePropertyDeclaration(node, concatenate(modifiers, factory2.createModifiersFromModifierFlags(128 /* Ambient */ )), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            return factory2.updatePropertyDeclaration(node, modifiers, visitPropertyNameOfClassElement(node), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
        }
        function visitConstructor(node) {
            if (!shouldEmitFunctionLikeDeclaration(node)) return void 0;
            return factory2.updateConstructorDeclaration(node, /*modifiers*/ void 0, visitParameterList(node.parameters, visitor, context), transformConstructorBody(node.body, node));
        }
        function transformConstructorBodyWorker(statementsOut, statementsIn, statementOffset, superPath, superPathDepth, initializerStatements) {
            const superStatementIndex = superPath[superPathDepth];
            const superStatement = statementsIn[superStatementIndex];
            addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, statementOffset, superStatementIndex - statementOffset));
            if (isTryStatement(superStatement)) {
                const tryBlockStatements = [];
                transformConstructorBodyWorker(tryBlockStatements, superStatement.tryBlock.statements, /*statementOffset*/ 0, superPath, superPathDepth + 1, initializerStatements);
                const tryBlockStatementsArray = factory2.createNodeArray(tryBlockStatements);
                setTextRange(tryBlockStatementsArray, superStatement.tryBlock.statements);
                statementsOut.push(factory2.updateTryStatement(superStatement, factory2.updateBlock(superStatement.tryBlock, tryBlockStatements), visitNode(superStatement.catchClause, visitor, isCatchClause), visitNode(superStatement.finallyBlock, visitor, isBlock)));
            } else {
                addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, superStatementIndex, 1));
                addRange(statementsOut, initializerStatements);
            }
            addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, superStatementIndex + 1));
        }
        function transformConstructorBody(body, constructor) {
            const parametersWithPropertyAssignments = constructor && filter(constructor.parameters, (p)=>isParameterPropertyDeclaration(p, constructor));
            if (!some(parametersWithPropertyAssignments)) return visitFunctionBody(body, visitor, context);
            let statements = [];
            resumeLexicalEnvironment();
            const prologueStatementCount = factory2.copyPrologue(body.statements, statements, /*ensureUseStrict*/ false, visitor);
            const superPath = findSuperStatementIndexPath(body.statements, prologueStatementCount);
            const parameterPropertyAssignments = mapDefined(parametersWithPropertyAssignments, transformParameterWithPropertyAssignment);
            if (superPath.length) transformConstructorBodyWorker(statements, body.statements, prologueStatementCount, superPath, /*superPathDepth*/ 0, parameterPropertyAssignments);
            else {
                addRange(statements, parameterPropertyAssignments);
                addRange(statements, visitNodes2(body.statements, visitor, isStatement, prologueStatementCount));
            }
            statements = factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), body.statements), /*multiLine*/ true);
            setTextRange(block, /*location*/ body);
            setOriginalNode(block, body);
            return block;
        }
        function transformParameterWithPropertyAssignment(node) {
            const name = node.name;
            if (!isIdentifier(name)) return void 0;
            const propertyName = setParent(setTextRange(factory2.cloneNode(name), name), name.parent);
            setEmitFlags(propertyName, 3168 /* NoSourceMap */ );
            const localName = setParent(setTextRange(factory2.cloneNode(name), name), name.parent);
            setEmitFlags(localName, 3072 /* NoComments */ );
            return startOnNewLine(removeAllComments(setTextRange(setOriginalNode(factory2.createExpressionStatement(factory2.createAssignment(setTextRange(factory2.createPropertyAccessExpression(factory2.createThis(), propertyName), node.name), localName)), node), moveRangePos(node, -1))));
        }
        function visitMethodDeclaration(node, parent2) {
            if (!(node.transformFlags & 1 /* ContainsTypeScript */ )) return node;
            if (!shouldEmitFunctionLikeDeclaration(node)) return void 0;
            let modifiers = isClassLike(parent2) ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            return factory2.updateMethodDeclaration(node, modifiers, node.asteriskToken, visitPropertyNameOfClassElement(node), /*questionToken*/ void 0, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context));
        }
        function shouldEmitAccessorDeclaration(node) {
            return !(nodeIsMissing(node.body) && hasSyntacticModifier(node, 64 /* Abstract */ ));
        }
        function visitGetAccessor(node, parent2) {
            if (!(node.transformFlags & 1 /* ContainsTypeScript */ )) return node;
            if (!shouldEmitAccessorDeclaration(node)) return void 0;
            let modifiers = isClassLike(parent2) ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            return factory2.updateGetAccessorDeclaration(node, modifiers, visitPropertyNameOfClassElement(node), visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
        }
        function visitSetAccessor(node, parent2) {
            if (!(node.transformFlags & 1 /* ContainsTypeScript */ )) return node;
            if (!shouldEmitAccessorDeclaration(node)) return void 0;
            let modifiers = isClassLike(parent2) ? visitNodes2(node.modifiers, visitor, isModifierLike) : visitNodes2(node.modifiers, decoratorElidingVisitor, isModifierLike);
            modifiers = injectClassElementTypeMetadata(modifiers, node, parent2);
            return factory2.updateSetAccessorDeclaration(node, modifiers, visitPropertyNameOfClassElement(node), visitParameterList(node.parameters, visitor, context), visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
        }
        function visitFunctionDeclaration(node) {
            if (!shouldEmitFunctionLikeDeclaration(node)) return factory2.createNotEmittedStatement(node);
            const updated = factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
            if (isExportOfNamespace(node)) {
                const statements = [
                    updated
                ];
                addExportMemberAssignment(statements, node);
                return statements;
            }
            return updated;
        }
        function visitFunctionExpression(node) {
            if (!shouldEmitFunctionLikeDeclaration(node)) return factory2.createOmittedExpression();
            const updated = factory2.updateFunctionExpression(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context) || factory2.createBlock([]));
            return updated;
        }
        function visitArrowFunction(node) {
            const updated = factory2.updateArrowFunction(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, node.equalsGreaterThanToken, visitFunctionBody(node.body, visitor, context));
            return updated;
        }
        function visitParameter(node) {
            if (parameterIsThisKeyword(node)) return void 0;
            const updated = factory2.updateParameterDeclaration(node, visitNodes2(node.modifiers, (node2)=>isDecorator(node2) ? visitor(node2) : void 0, isModifierLike), node.dotDotDotToken, Debug.checkDefined(visitNode(node.name, visitor, isBindingName)), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (updated !== node) {
                setCommentRange(updated, node);
                setTextRange(updated, moveRangePastModifiers(node));
                setSourceMapRange(updated, moveRangePastModifiers(node));
                setEmitFlags(updated.name, 64 /* NoTrailingSourceMap */ );
            }
            return updated;
        }
        function visitVariableStatement(node) {
            if (isExportOfNamespace(node)) {
                const variables = getInitializedVariables(node.declarationList);
                if (variables.length === 0) return void 0;
                return setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(map(variables, transformInitializedVariable))), node);
            } else return visitEachChild(node, visitor, context);
        }
        function transformInitializedVariable(node) {
            const name = node.name;
            if (isBindingPattern(name)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , /*needsValue*/ false, createNamespaceExportExpression);
            else return setTextRange(factory2.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(name), Debug.checkDefined(visitNode(node.initializer, visitor, isExpression))), /*location*/ node);
        }
        function visitVariableDeclaration(node) {
            const updated = factory2.updateVariableDeclaration(node, Debug.checkDefined(visitNode(node.name, visitor, isBindingName)), /*exclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (node.type) setTypeNode(updated.name, node.type);
            return updated;
        }
        function visitParenthesizedExpression(node) {
            const innerExpression = skipOuterExpressions(node.expression, -55);
            if (isAssertionExpression(innerExpression) || isSatisfiesExpression(innerExpression)) {
                const expression = visitNode(node.expression, visitor, isExpression);
                Debug.assert(expression);
                return factory2.createPartiallyEmittedExpression(expression, node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssertionExpression(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            return factory2.createPartiallyEmittedExpression(expression, node);
        }
        function visitNonNullExpression(node) {
            const expression = visitNode(node.expression, visitor, isLeftHandSideExpression);
            Debug.assert(expression);
            return factory2.createPartiallyEmittedExpression(expression, node);
        }
        function visitSatisfiesExpression(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            return factory2.createPartiallyEmittedExpression(expression, node);
        }
        function visitCallExpression(node) {
            return factory2.updateCallExpression(node, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), /*typeArguments*/ void 0, visitNodes2(node.arguments, visitor, isExpression));
        }
        function visitNewExpression(node) {
            return factory2.updateNewExpression(node, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), /*typeArguments*/ void 0, visitNodes2(node.arguments, visitor, isExpression));
        }
        function visitTaggedTemplateExpression(node) {
            return factory2.updateTaggedTemplateExpression(node, Debug.checkDefined(visitNode(node.tag, visitor, isExpression)), /*typeArguments*/ void 0, Debug.checkDefined(visitNode(node.template, visitor, isTemplateLiteral)));
        }
        function visitJsxSelfClosingElement(node) {
            return factory2.updateJsxSelfClosingElement(node, Debug.checkDefined(visitNode(node.tagName, visitor, isJsxTagNameExpression)), /*typeArguments*/ void 0, Debug.checkDefined(visitNode(node.attributes, visitor, isJsxAttributes)));
        }
        function visitJsxJsxOpeningElement(node) {
            return factory2.updateJsxOpeningElement(node, Debug.checkDefined(visitNode(node.tagName, visitor, isJsxTagNameExpression)), /*typeArguments*/ void 0, Debug.checkDefined(visitNode(node.attributes, visitor, isJsxAttributes)));
        }
        function shouldEmitEnumDeclaration(node) {
            return !isEnumConst(node) || shouldPreserveConstEnums(compilerOptions);
        }
        function visitEnumDeclaration(node) {
            if (!shouldEmitEnumDeclaration(node)) return factory2.createNotEmittedStatement(node);
            const statements = [];
            let emitFlags = 4 /* AdviseOnEmitNode */ ;
            const varAdded = addVarForEnumOrModuleDeclaration(statements, node);
            if (varAdded) {
                if (moduleKind !== 4 /* System */  || currentLexicalScope !== currentSourceFile) emitFlags |= 1024 /* NoLeadingComments */ ;
            }
            const parameterName = getNamespaceParameterName(node);
            const containerName = getNamespaceContainerName(node);
            const exportName = isExportOfNamespace(node) ? factory2.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            let moduleArg = factory2.createLogicalOr(exportName, factory2.createAssignment(exportName, factory2.createObjectLiteralExpression()));
            if (isExportOfNamespace(node)) {
                const localName = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
                moduleArg = factory2.createAssignment(localName, moduleArg);
            }
            const enumStatement = factory2.createExpressionStatement(factory2.createCallExpression(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, parameterName)
            ], /*type*/ void 0, transformEnumBody(node, containerName)), /*typeArguments*/ void 0, [
                moduleArg
            ]));
            setOriginalNode(enumStatement, node);
            if (varAdded) {
                setSyntheticLeadingComments(enumStatement, void 0);
                setSyntheticTrailingComments(enumStatement, void 0);
            }
            setTextRange(enumStatement, node);
            addEmitFlags(enumStatement, emitFlags);
            statements.push(enumStatement);
            return statements;
        }
        function transformEnumBody(node, localName) {
            const savedCurrentNamespaceLocalName = currentNamespaceContainerName;
            currentNamespaceContainerName = localName;
            const statements = [];
            startLexicalEnvironment();
            const members = map(node.members, transformEnumMember);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            addRange(statements, members);
            currentNamespaceContainerName = savedCurrentNamespaceLocalName;
            return factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ node.members), /*multiLine*/ true);
        }
        function transformEnumMember(member) {
            const name = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ false);
            const evaluated = resolver.getEnumMemberValue(member);
            const valueExpression = transformEnumMemberDeclarationValue(member, evaluated == null ? void 0 : evaluated.value);
            const innerAssignment = factory2.createAssignment(factory2.createElementAccessExpression(currentNamespaceContainerName, name), valueExpression);
            const outerAssignment = typeof (evaluated == null ? void 0 : evaluated.value) === "string" || (evaluated == null ? void 0 : evaluated.isSyntacticallyString) ? innerAssignment : factory2.createAssignment(factory2.createElementAccessExpression(currentNamespaceContainerName, innerAssignment), name);
            return setTextRange(factory2.createExpressionStatement(setTextRange(outerAssignment, member)), member);
        }
        function transformEnumMemberDeclarationValue(member, constantValue) {
            if (constantValue !== void 0) return typeof constantValue === "string" ? factory2.createStringLiteral(constantValue) : constantValue < 0 ? factory2.createPrefixUnaryExpression(41 /* MinusToken */ , factory2.createNumericLiteral(-constantValue)) : factory2.createNumericLiteral(constantValue);
            else {
                enableSubstitutionForNonQualifiedEnumMembers();
                if (member.initializer) return Debug.checkDefined(visitNode(member.initializer, visitor, isExpression));
                else return factory2.createVoidZero();
            }
        }
        function shouldEmitModuleDeclaration(nodeIn) {
            const node = getParseTreeNode(nodeIn, isModuleDeclaration);
            if (!node) return true;
            return isInstantiatedModule(node, shouldPreserveConstEnums(compilerOptions));
        }
        function recordEmittedDeclarationInScope(node) {
            if (!currentScopeFirstDeclarationsOfName) currentScopeFirstDeclarationsOfName = /* @__PURE__ */ new Map();
            const name = declaredNameInScope(node);
            if (!currentScopeFirstDeclarationsOfName.has(name)) currentScopeFirstDeclarationsOfName.set(name, node);
        }
        function isFirstEmittedDeclarationInScope(node) {
            if (currentScopeFirstDeclarationsOfName) {
                const name = declaredNameInScope(node);
                return currentScopeFirstDeclarationsOfName.get(name) === node;
            }
            return true;
        }
        function declaredNameInScope(node) {
            Debug.assertNode(node.name, isIdentifier);
            return node.name.escapedText;
        }
        function addVarForEnumOrModuleDeclaration(statements, node) {
            const varDecl = factory2.createVariableDeclaration(factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true));
            const varFlags = currentLexicalScope.kind === 308 /* SourceFile */  ? 0 /* None */  : 1 /* Let */ ;
            const statement = factory2.createVariableStatement(visitNodes2(node.modifiers, modifierVisitor, isModifier), factory2.createVariableDeclarationList([
                varDecl
            ], varFlags));
            setOriginalNode(varDecl, node);
            setSyntheticLeadingComments(varDecl, void 0);
            setSyntheticTrailingComments(varDecl, void 0);
            setOriginalNode(statement, node);
            recordEmittedDeclarationInScope(node);
            if (isFirstEmittedDeclarationInScope(node)) {
                if (node.kind === 267 /* EnumDeclaration */ ) setSourceMapRange(statement.declarationList, node);
                else setSourceMapRange(statement, node);
                setCommentRange(statement, node);
                addEmitFlags(statement, 2048 /* NoTrailingComments */ );
                statements.push(statement);
                return true;
            }
            return false;
        }
        function visitModuleDeclaration(node) {
            if (!shouldEmitModuleDeclaration(node)) return factory2.createNotEmittedStatement(node);
            Debug.assertNode(node.name, isIdentifier, "A TypeScript namespace should have an Identifier name.");
            enableSubstitutionForNamespaceExports();
            const statements = [];
            let emitFlags = 4 /* AdviseOnEmitNode */ ;
            const varAdded = addVarForEnumOrModuleDeclaration(statements, node);
            if (varAdded) {
                if (moduleKind !== 4 /* System */  || currentLexicalScope !== currentSourceFile) emitFlags |= 1024 /* NoLeadingComments */ ;
            }
            const parameterName = getNamespaceParameterName(node);
            const containerName = getNamespaceContainerName(node);
            const exportName = isExportOfNamespace(node) ? factory2.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            let moduleArg = factory2.createLogicalOr(exportName, factory2.createAssignment(exportName, factory2.createObjectLiteralExpression()));
            if (isExportOfNamespace(node)) {
                const localName = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
                moduleArg = factory2.createAssignment(localName, moduleArg);
            }
            const moduleStatement = factory2.createExpressionStatement(factory2.createCallExpression(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, parameterName)
            ], /*type*/ void 0, transformModuleBody(node, containerName)), /*typeArguments*/ void 0, [
                moduleArg
            ]));
            setOriginalNode(moduleStatement, node);
            if (varAdded) {
                setSyntheticLeadingComments(moduleStatement, void 0);
                setSyntheticTrailingComments(moduleStatement, void 0);
            }
            setTextRange(moduleStatement, node);
            addEmitFlags(moduleStatement, emitFlags);
            statements.push(moduleStatement);
            return statements;
        }
        function transformModuleBody(node, namespaceLocalName) {
            const savedCurrentNamespaceContainerName = currentNamespaceContainerName;
            const savedCurrentNamespace = currentNamespace;
            const savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
            currentNamespaceContainerName = namespaceLocalName;
            currentNamespace = node;
            currentScopeFirstDeclarationsOfName = void 0;
            const statements = [];
            startLexicalEnvironment();
            let statementsLocation;
            let blockLocation;
            if (node.body) {
                if (node.body.kind === 269 /* ModuleBlock */ ) {
                    saveStateAndInvoke(node.body, (body)=>addRange(statements, visitNodes2(body.statements, namespaceElementVisitor, isStatement)));
                    statementsLocation = node.body.statements;
                    blockLocation = node.body;
                } else {
                    const result = visitModuleDeclaration(node.body);
                    if (result) {
                        if (isArray(result)) addRange(statements, result);
                        else statements.push(result);
                    }
                    const moduleBlock = getInnerMostModuleDeclarationFromDottedModule(node).body;
                    statementsLocation = moveRangePos(moduleBlock.statements, -1);
                }
            }
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            currentNamespaceContainerName = savedCurrentNamespaceContainerName;
            currentNamespace = savedCurrentNamespace;
            currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ statementsLocation), /*multiLine*/ true);
            setTextRange(block, blockLocation);
            if (!node.body || node.body.kind !== 269 /* ModuleBlock */ ) setEmitFlags(block, getEmitFlags(block) | 3072 /* NoComments */ );
            return block;
        }
        function getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration) {
            if (moduleDeclaration.body.kind === 268 /* ModuleDeclaration */ ) {
                const recursiveInnerModule = getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration.body);
                return recursiveInnerModule || moduleDeclaration.body;
            }
        }
        function visitImportDeclaration(node) {
            if (!node.importClause) return node;
            if (node.importClause.isTypeOnly) return void 0;
            const importClause = visitNode(node.importClause, visitImportClause, isImportClause);
            return importClause ? factory2.updateImportDeclaration(node, /*modifiers*/ void 0, importClause, node.moduleSpecifier, node.attributes) : void 0;
        }
        function visitImportClause(node) {
            Debug.assert(node.phaseModifier !== 156 /* TypeKeyword */ );
            const name = shouldEmitAliasDeclaration(node) ? node.name : void 0;
            const namedBindings = visitNode(node.namedBindings, visitNamedImportBindings, isNamedImportBindings);
            return name || namedBindings ? factory2.updateImportClause(node, node.phaseModifier, name, namedBindings) : void 0;
        }
        function visitNamedImportBindings(node) {
            if (node.kind === 275 /* NamespaceImport */ ) return shouldEmitAliasDeclaration(node) ? node : void 0;
            else {
                const allowEmpty = compilerOptions.verbatimModuleSyntax;
                const elements = visitNodes2(node.elements, visitImportSpecifier, isImportSpecifier);
                return allowEmpty || some(elements) ? factory2.updateNamedImports(node, elements) : void 0;
            }
        }
        function visitImportSpecifier(node) {
            return !node.isTypeOnly && shouldEmitAliasDeclaration(node) ? node : void 0;
        }
        function visitExportAssignment(node) {
            return compilerOptions.verbatimModuleSyntax || resolver.isValueAliasDeclaration(node) ? visitEachChild(node, visitor, context) : void 0;
        }
        function visitExportDeclaration(node) {
            if (node.isTypeOnly) return void 0;
            if (!node.exportClause || isNamespaceExport(node.exportClause)) return factory2.updateExportDeclaration(node, node.modifiers, node.isTypeOnly, node.exportClause, node.moduleSpecifier, node.attributes);
            const allowEmpty = !!compilerOptions.verbatimModuleSyntax;
            const exportClause = visitNode(node.exportClause, (bindings)=>visitNamedExportBindings(bindings, allowEmpty), isNamedExportBindings);
            return exportClause ? factory2.updateExportDeclaration(node, /*modifiers*/ void 0, node.isTypeOnly, exportClause, node.moduleSpecifier, node.attributes) : void 0;
        }
        function visitNamedExports(node, allowEmpty) {
            const elements = visitNodes2(node.elements, visitExportSpecifier, isExportSpecifier);
            return allowEmpty || some(elements) ? factory2.updateNamedExports(node, elements) : void 0;
        }
        function visitNamespaceExports(node) {
            return factory2.updateNamespaceExport(node, Debug.checkDefined(visitNode(node.name, visitor, isIdentifier)));
        }
        function visitNamedExportBindings(node, allowEmpty) {
            return isNamespaceExport(node) ? visitNamespaceExports(node) : visitNamedExports(node, allowEmpty);
        }
        function visitExportSpecifier(node) {
            return !node.isTypeOnly && (compilerOptions.verbatimModuleSyntax || resolver.isValueAliasDeclaration(node)) ? node : void 0;
        }
        function shouldEmitImportEqualsDeclaration(node) {
            return shouldEmitAliasDeclaration(node) || !isExternalModule(currentSourceFile) && resolver.isTopLevelValueImportEqualsWithEntityName(node);
        }
        function visitImportEqualsDeclaration(node) {
            if (node.isTypeOnly) return void 0;
            if (isExternalModuleImportEqualsDeclaration(node)) {
                if (!shouldEmitAliasDeclaration(node)) return void 0;
                return visitEachChild(node, visitor, context);
            }
            if (!shouldEmitImportEqualsDeclaration(node)) return void 0;
            const moduleReference = createExpressionFromEntityName(factory2, node.moduleReference);
            setEmitFlags(moduleReference, 7168 /* NoNestedComments */ );
            if (isNamedExternalModuleExport(node) || !isExportOfNamespace(node)) return setOriginalNode(setTextRange(factory2.createVariableStatement(visitNodes2(node.modifiers, modifierVisitor, isModifier), factory2.createVariableDeclarationList([
                setOriginalNode(factory2.createVariableDeclaration(node.name, /*exclamationToken*/ void 0, /*type*/ void 0, moduleReference), node)
            ])), node), node);
            else return setOriginalNode(createNamespaceExport(node.name, moduleReference, node), node);
        }
        function isExportOfNamespace(node) {
            return currentNamespace !== void 0 && hasSyntacticModifier(node, 32 /* Export */ );
        }
        function isExternalModuleExport(node) {
            return currentNamespace === void 0 && hasSyntacticModifier(node, 32 /* Export */ );
        }
        function isNamedExternalModuleExport(node) {
            return isExternalModuleExport(node) && !hasSyntacticModifier(node, 2048 /* Default */ );
        }
        function isDefaultExternalModuleExport(node) {
            return isExternalModuleExport(node) && hasSyntacticModifier(node, 2048 /* Default */ );
        }
        function createExportMemberAssignmentStatement(node) {
            const expression = factory2.createAssignment(factory2.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true), factory2.getLocalName(node));
            setSourceMapRange(expression, createRange(node.name ? node.name.pos : node.pos, node.end));
            const statement = factory2.createExpressionStatement(expression);
            setSourceMapRange(statement, createRange(-1, node.end));
            return statement;
        }
        function addExportMemberAssignment(statements, node) {
            statements.push(createExportMemberAssignmentStatement(node));
        }
        function createNamespaceExport(exportName, exportValue, location) {
            return setTextRange(factory2.createExpressionStatement(factory2.createAssignment(factory2.getNamespaceMemberName(currentNamespaceContainerName, exportName, /*allowComments*/ false, /*allowSourceMaps*/ true), exportValue)), location);
        }
        function createNamespaceExportExpression(exportName, exportValue, location) {
            return setTextRange(factory2.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(exportName), exportValue), location);
        }
        function getNamespaceMemberNameWithSourceMapsAndWithoutComments(name) {
            return factory2.getNamespaceMemberName(currentNamespaceContainerName, name, /*allowComments*/ false, /*allowSourceMaps*/ true);
        }
        function getNamespaceParameterName(node) {
            const name = factory2.getGeneratedNameForNode(node);
            setSourceMapRange(name, node.name);
            return name;
        }
        function getNamespaceContainerName(node) {
            return factory2.getGeneratedNameForNode(node);
        }
        function enableSubstitutionForNonQualifiedEnumMembers() {
            if ((enabledSubstitutions & 8 /* NonQualifiedEnumMembers */ ) === 0) {
                enabledSubstitutions |= 8 /* NonQualifiedEnumMembers */ ;
                context.enableSubstitution(80 /* Identifier */ );
            }
        }
        function enableSubstitutionForNamespaceExports() {
            if ((enabledSubstitutions & 2 /* NamespaceExports */ ) === 0) {
                enabledSubstitutions |= 2 /* NamespaceExports */ ;
                context.enableSubstitution(80 /* Identifier */ );
                context.enableSubstitution(305 /* ShorthandPropertyAssignment */ );
                context.enableEmitNotification(268 /* ModuleDeclaration */ );
            }
        }
        function isTransformedModuleDeclaration(node) {
            return getOriginalNode(node).kind === 268 /* ModuleDeclaration */ ;
        }
        function isTransformedEnumDeclaration(node) {
            return getOriginalNode(node).kind === 267 /* EnumDeclaration */ ;
        }
        function onEmitNode(hint, node, emitCallback) {
            const savedApplicableSubstitutions = applicableSubstitutions;
            const savedCurrentSourceFile = currentSourceFile;
            if (isSourceFile(node)) currentSourceFile = node;
            if (enabledSubstitutions & 2 /* NamespaceExports */  && isTransformedModuleDeclaration(node)) applicableSubstitutions |= 2 /* NamespaceExports */ ;
            if (enabledSubstitutions & 8 /* NonQualifiedEnumMembers */  && isTransformedEnumDeclaration(node)) applicableSubstitutions |= 8 /* NonQualifiedEnumMembers */ ;
            previousOnEmitNode(hint, node, emitCallback);
            applicableSubstitutions = savedApplicableSubstitutions;
            currentSourceFile = savedCurrentSourceFile;
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            else if (isShorthandPropertyAssignment(node)) return substituteShorthandPropertyAssignment(node);
            return node;
        }
        function substituteShorthandPropertyAssignment(node) {
            if (enabledSubstitutions & 2 /* NamespaceExports */ ) {
                const name = node.name;
                const exportedName = trySubstituteNamespaceExportedName(name);
                if (exportedName) {
                    if (node.objectAssignmentInitializer) {
                        const initializer = factory2.createAssignment(exportedName, node.objectAssignmentInitializer);
                        return setTextRange(factory2.createPropertyAssignment(name, initializer), node);
                    }
                    return setTextRange(factory2.createPropertyAssignment(name, exportedName), node);
                }
            }
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 212 /* PropertyAccessExpression */ :
                    return substitutePropertyAccessExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return substituteElementAccessExpression(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            return trySubstituteNamespaceExportedName(node) || node;
        }
        function trySubstituteNamespaceExportedName(node) {
            if (enabledSubstitutions & applicableSubstitutions && !isGeneratedIdentifier(node) && !isLocalName(node)) {
                const container = resolver.getReferencedExportContainer(node, /*prefixLocals*/ false);
                if (container && container.kind !== 308 /* SourceFile */ ) {
                    const substitute = applicableSubstitutions & 2 /* NamespaceExports */  && container.kind === 268 /* ModuleDeclaration */  || applicableSubstitutions & 8 /* NonQualifiedEnumMembers */  && container.kind === 267 /* EnumDeclaration */ ;
                    if (substitute) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(container), node), /*location*/ node);
                }
            }
            return void 0;
        }
        function substitutePropertyAccessExpression(node) {
            return substituteConstantValue(node);
        }
        function substituteElementAccessExpression(node) {
            return substituteConstantValue(node);
        }
        function safeMultiLineComment(value1) {
            return value1.replace(/\*\//g, "*_/");
        }
        function substituteConstantValue(node) {
            const constantValue = tryGetConstEnumValue(node);
            if (constantValue !== void 0) {
                setConstantValue(node, constantValue);
                const substitute = typeof constantValue === "string" ? factory2.createStringLiteral(constantValue) : constantValue < 0 ? factory2.createPrefixUnaryExpression(41 /* MinusToken */ , factory2.createNumericLiteral(-constantValue)) : factory2.createNumericLiteral(constantValue);
                if (!compilerOptions.removeComments) {
                    const originalNode = getOriginalNode(node, isAccessExpression);
                    addSyntheticTrailingComment(substitute, 3 /* MultiLineCommentTrivia */ , ` ${safeMultiLineComment(getTextOfNode(originalNode))} `);
                }
                return substitute;
            }
            return node;
        }
        function tryGetConstEnumValue(node) {
            if (getIsolatedModules(compilerOptions)) return void 0;
            return isPropertyAccessExpression(node) || isElementAccessExpression(node) ? resolver.getConstantValue(node) : void 0;
        }
        function shouldEmitAliasDeclaration(node) {
            return compilerOptions.verbatimModuleSyntax || isInJSFile(node) || resolver.isReferencedAliasDeclaration(node);
        }
    }
    // src/compiler/transformers/classFields.ts
    function transformClassFields(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, hoistVariableDeclaration, endLexicalEnvironment, startLexicalEnvironment, resumeLexicalEnvironment, addBlockScopedVariable } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const useDefineForClassFields = getUseDefineForClassFields(compilerOptions);
        const legacyDecorators = !!compilerOptions.experimentalDecorators;
        const shouldTransformInitializersUsingSet = !useDefineForClassFields;
        const shouldTransformInitializersUsingDefine = useDefineForClassFields && languageVersion < 9 /* ES2022 */ ;
        const shouldTransformInitializers = shouldTransformInitializersUsingSet || shouldTransformInitializersUsingDefine;
        const shouldTransformPrivateElementsOrClassStaticBlocks = languageVersion < 9 /* ES2022 */ ;
        const shouldTransformAutoAccessors = languageVersion < 99 /* ESNext */  ? -1 /* True */  : !useDefineForClassFields ? 3 /* Maybe */  : 0 /* False */ ;
        const shouldTransformThisInStaticInitializers = languageVersion < 9 /* ES2022 */ ;
        const shouldTransformSuperInStaticInitializers = shouldTransformThisInStaticInitializers && languageVersion >= 2 /* ES2015 */ ;
        const shouldTransformAnything = shouldTransformInitializers || shouldTransformPrivateElementsOrClassStaticBlocks || shouldTransformAutoAccessors === -1 /* True */ ;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onEmitNode = onEmitNode;
        let shouldTransformPrivateStaticElementsInFile = false;
        let enabledSubstitutions = 0 /* None */ ;
        let classAliases;
        let pendingExpressions;
        let pendingStatements;
        let lexicalEnvironment;
        const lexicalEnvironmentMap = /* @__PURE__ */ new Map();
        const noSubstitution = /* @__PURE__ */ new Set();
        let currentClassContainer;
        let currentClassElement;
        let shouldSubstituteThisWithClassThis = false;
        let previousShouldSubstituteThisWithClassThis = false;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            lexicalEnvironment = void 0;
            shouldTransformPrivateStaticElementsInFile = !!(getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ );
            if (!shouldTransformAnything && !shouldTransformPrivateStaticElementsInFile) return node;
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 129 /* AccessorKeyword */ :
                    return shouldTransformAutoAccessorsInCurrentClass() ? void 0 : node;
                default:
                    return tryCast(node, isModifier);
            }
        }
        function visitor(node) {
            if (!(node.transformFlags & 16777216 /* ContainsClassFields */ ) && !(node.transformFlags & 134234112 /* ContainsLexicalThisOrSuper */ )) return node;
            switch(node.kind){
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 232 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 176 /* ClassStaticBlockDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                    return Debug.fail("Use `classElementVisitor` instead.");
                case 304 /* PropertyAssignment */ :
                    return visitPropertyAssignment(node);
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 261 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 170 /* Parameter */ :
                    return visitParameterDeclaration(node);
                case 209 /* BindingElement */ :
                    return visitBindingElement(node);
                case 278 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 81 /* PrivateIdentifier */ :
                    return visitPrivateIdentifier(node);
                case 212 /* PropertyAccessExpression */ :
                    return visitPropertyAccessExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return visitElementAccessExpression(node);
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ false);
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ false);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ false);
                case 214 /* CallExpression */ :
                    return visitCallExpression(node);
                case 245 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 216 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 249 /* ForStatement */ :
                    return visitForStatement(node);
                case 110 /* ThisKeyword */ :
                    return visitThisExpression(node);
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                    return setCurrentClassElementAnd(/*classElement*/ void 0, fallbackVisitor, node);
                case 177 /* Constructor */ :
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return setCurrentClassElementAnd(node, fallbackVisitor, node);
                default:
                    return fallbackVisitor(node);
            }
        }
        function fallbackVisitor(node) {
            return visitEachChild(node, visitor, context);
        }
        function discardedValueVisitor(node) {
            switch(node.kind){
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ true);
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ true);
                case 357 /* CommaListExpression */ :
                    return visitCommaListExpression(node, /*discarded*/ true);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ true);
                default:
                    return visitor(node);
            }
        }
        function heritageClauseVisitor(node) {
            switch(node.kind){
                case 299 /* HeritageClause */ :
                    return visitEachChild(node, heritageClauseVisitor, context);
                case 234 /* ExpressionWithTypeArguments */ :
                    return visitExpressionWithTypeArgumentsInHeritageClause(node);
                default:
                    return visitor(node);
            }
        }
        function assignmentTargetVisitor(node) {
            switch(node.kind){
                case 211 /* ObjectLiteralExpression */ :
                case 210 /* ArrayLiteralExpression */ :
                    return visitAssignmentPattern(node);
                default:
                    return visitor(node);
            }
        }
        function classElementVisitor(node) {
            switch(node.kind){
                case 177 /* Constructor */ :
                    return setCurrentClassElementAnd(node, visitConstructorDeclaration, node);
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 175 /* MethodDeclaration */ :
                    return setCurrentClassElementAnd(node, visitMethodOrAccessorDeclaration, node);
                case 173 /* PropertyDeclaration */ :
                    return setCurrentClassElementAnd(node, visitPropertyDeclaration, node);
                case 176 /* ClassStaticBlockDeclaration */ :
                    return setCurrentClassElementAnd(node, visitClassStaticBlockDeclaration, node);
                case 168 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                case 241 /* SemicolonClassElement */ :
                    return node;
                default:
                    return isModifierLike(node) ? modifierVisitor(node) : visitor(node);
            }
        }
        function propertyNameVisitor(node) {
            switch(node.kind){
                case 168 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                default:
                    return visitor(node);
            }
        }
        function accessorFieldResultVisitor(node) {
            switch(node.kind){
                case 173 /* PropertyDeclaration */ :
                    return transformFieldInitializer(node);
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return classElementVisitor(node);
                default:
                    Debug.assertMissingNode(node, "Expected node to either be a PropertyDeclaration, GetAccessorDeclaration, or SetAccessorDeclaration");
                    break;
            }
        }
        function visitPrivateIdentifier(node) {
            if (!shouldTransformPrivateElementsOrClassStaticBlocks) return node;
            if (isStatement(node.parent)) return node;
            return setOriginalNode(factory2.createIdentifier(""), node);
        }
        function transformPrivateIdentifierInInExpression(node) {
            const info = accessPrivateIdentifier2(node.left);
            if (info) {
                const receiver = visitNode(node.right, visitor, isExpression);
                return setOriginalNode(emitHelpers().createClassPrivateFieldInHelper(info.brandCheckIdentifier, receiver), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPropertyAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            return visitEachChild(node, visitor, context);
        }
        function visitVariableStatement(node) {
            const savedPendingStatements = pendingStatements;
            pendingStatements = [];
            const visitedNode = visitEachChild(node, visitor, context);
            const statement = some(pendingStatements) ? [
                visitedNode,
                ...pendingStatements
            ] : visitedNode;
            pendingStatements = savedPendingStatements;
            return statement;
        }
        function visitVariableDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            return visitEachChild(node, visitor, context);
        }
        function visitParameterDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            return visitEachChild(node, visitor, context);
        }
        function visitBindingElement(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            return visitEachChild(node, visitor, context);
        }
        function visitExportAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, /*ignoreEmptyStringLiteral*/ true, node.isExportEquals ? "" : "default");
            return visitEachChild(node, visitor, context);
        }
        function injectPendingExpressions(expression) {
            if (some(pendingExpressions)) {
                if (isParenthesizedExpression(expression)) {
                    pendingExpressions.push(expression.expression);
                    expression = factory2.updateParenthesizedExpression(expression, factory2.inlineExpressions(pendingExpressions));
                } else {
                    pendingExpressions.push(expression);
                    expression = factory2.inlineExpressions(pendingExpressions);
                }
                pendingExpressions = void 0;
            }
            return expression;
        }
        function visitComputedPropertyName(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            return factory2.updateComputedPropertyName(node, injectPendingExpressions(expression));
        }
        function visitConstructorDeclaration(node) {
            if (currentClassContainer) return transformConstructor(node, currentClassContainer);
            return fallbackVisitor(node);
        }
        function shouldTransformClassElementToWeakMap(node) {
            if (shouldTransformPrivateElementsOrClassStaticBlocks) return true;
            if (hasStaticModifier(node) && getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ) return true;
            return false;
        }
        function visitMethodOrAccessorDeclaration(node) {
            Debug.assert(!hasDecorators(node));
            if (!isPrivateIdentifierClassElementDeclaration(node) || !shouldTransformClassElementToWeakMap(node)) return visitEachChild(node, classElementVisitor, context);
            const info = accessPrivateIdentifier2(node.name);
            Debug.assert(info, "Undeclared private name for property declaration.");
            if (!info.isValid) return node;
            const functionName = getHoistedFunctionName(node);
            if (functionName) getPendingExpressions().push(factory2.createAssignment(functionName, factory2.createFunctionExpression(filter(node.modifiers, (m)=>isModifier(m) && !isStaticModifier(m) && !isAccessorModifier(m)), node.asteriskToken, functionName, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, visitFunctionBody(node.body, visitor, context))));
            return void 0;
        }
        function setCurrentClassElementAnd(classElement, visitor2, arg) {
            if (classElement !== currentClassElement) {
                const savedCurrentClassElement = currentClassElement;
                currentClassElement = classElement;
                const result = visitor2(arg);
                currentClassElement = savedCurrentClassElement;
                return result;
            }
            return visitor2(arg);
        }
        function getHoistedFunctionName(node) {
            Debug.assert(isPrivateIdentifier(node.name));
            const info = accessPrivateIdentifier2(node.name);
            Debug.assert(info, "Undeclared private name for property declaration.");
            if (info.kind === "m" /* Method */ ) return info.methodName;
            if (info.kind === "a" /* Accessor */ ) {
                if (isGetAccessor(node)) return info.getterName;
                if (isSetAccessor(node)) return info.setterName;
            }
        }
        function tryGetClassThis() {
            const lex = getClassLexicalEnvironment();
            var _lex_classThis, _ref;
            return (_ref = (_lex_classThis = lex.classThis) !== null && _lex_classThis !== void 0 ? _lex_classThis : lex.classConstructor) !== null && _ref !== void 0 ? _ref : currentClassContainer == null ? void 0 : currentClassContainer.name;
        }
        function transformAutoAccessor(node) {
            const commentRange = getCommentRange(node);
            const sourceMapRange = getSourceMapRange(node);
            const name = node.name;
            let getterName = name;
            let setterName = name;
            if (isComputedPropertyName(name) && !isSimpleInlineableExpression(name.expression)) {
                const cacheAssignment = findComputedPropertyNameCacheAssignment(name);
                if (cacheAssignment) {
                    getterName = factory2.updateComputedPropertyName(name, visitNode(name.expression, visitor, isExpression));
                    setterName = factory2.updateComputedPropertyName(name, cacheAssignment.left);
                } else {
                    const temp = factory2.createTempVariable(hoistVariableDeclaration);
                    setSourceMapRange(temp, name.expression);
                    const expression = visitNode(name.expression, visitor, isExpression);
                    const assignment = factory2.createAssignment(temp, expression);
                    setSourceMapRange(assignment, name.expression);
                    getterName = factory2.updateComputedPropertyName(name, assignment);
                    setterName = factory2.updateComputedPropertyName(name, temp);
                }
            }
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const backingField = createAccessorPropertyBackingField(factory2, node, modifiers, node.initializer);
            setOriginalNode(backingField, node);
            setEmitFlags(backingField, 3072 /* NoComments */ );
            setSourceMapRange(backingField, sourceMapRange);
            var _tryGetClassThis;
            const receiver = isStatic(node) ? (_tryGetClassThis = tryGetClassThis()) !== null && _tryGetClassThis !== void 0 ? _tryGetClassThis : factory2.createThis() : factory2.createThis();
            const getter = createAccessorPropertyGetRedirector(factory2, node, modifiers, getterName, receiver);
            setOriginalNode(getter, node);
            setCommentRange(getter, commentRange);
            setSourceMapRange(getter, sourceMapRange);
            const setterModifiers = factory2.createModifiersFromModifierFlags(modifiersToFlags(modifiers));
            const setter = createAccessorPropertySetRedirector(factory2, node, setterModifiers, setterName, receiver);
            setOriginalNode(setter, node);
            setEmitFlags(setter, 3072 /* NoComments */ );
            setSourceMapRange(setter, sourceMapRange);
            return visitArray([
                backingField,
                getter,
                setter
            ], accessorFieldResultVisitor, isClassElement);
        }
        function transformPrivateFieldInitializer(node) {
            if (shouldTransformClassElementToWeakMap(node)) {
                const info = accessPrivateIdentifier2(node.name);
                Debug.assert(info, "Undeclared private name for property declaration.");
                if (!info.isValid) return node;
                if (info.isStatic && !shouldTransformPrivateElementsOrClassStaticBlocks) {
                    const statement = transformPropertyOrClassStaticBlock(node, factory2.createThis());
                    if (statement) return factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                        statement
                    ], /*multiLine*/ true));
                }
                return void 0;
            }
            if (shouldTransformInitializersUsingSet && !isStatic(node) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) && lexicalEnvironment.data.facts & 16 /* WillHoistInitializersToConstructor */ ) return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), visitNode(node.name, propertyNameVisitor, isPropertyName), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
        }
        function transformPublicFieldInitializer(node) {
            if (shouldTransformInitializers && !isAutoAccessorPropertyDeclaration(node)) {
                const expr = getPropertyNameExpressionIfNeeded(node.name, /*shouldHoist*/ !!node.initializer || useDefineForClassFields);
                if (expr) getPendingExpressions().push(...flattenCommaList(expr));
                if (isStatic(node) && !shouldTransformPrivateElementsOrClassStaticBlocks) {
                    const initializerStatement = transformPropertyOrClassStaticBlock(node, factory2.createThis());
                    if (initializerStatement) {
                        const staticBlock = factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                            initializerStatement
                        ]));
                        setOriginalNode(staticBlock, node);
                        setCommentRange(staticBlock, node);
                        setCommentRange(initializerStatement, {
                            pos: -1,
                            end: -1
                        });
                        setSyntheticLeadingComments(initializerStatement, void 0);
                        setSyntheticTrailingComments(initializerStatement, void 0);
                        return staticBlock;
                    }
                }
                return void 0;
            }
            return factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), visitNode(node.name, propertyNameVisitor, isPropertyName), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
        }
        function transformFieldInitializer(node) {
            Debug.assert(!hasDecorators(node), "Decorators should already have been transformed and elided.");
            return isPrivateIdentifierClassElementDeclaration(node) ? transformPrivateFieldInitializer(node) : transformPublicFieldInitializer(node);
        }
        function shouldTransformAutoAccessorsInCurrentClass() {
            return shouldTransformAutoAccessors === -1 /* True */  || shouldTransformAutoAccessors === 3 /* Maybe */  && !!(lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) && !!(lexicalEnvironment.data.facts & 16 /* WillHoistInitializersToConstructor */ );
        }
        function visitPropertyDeclaration(node) {
            if (isAutoAccessorPropertyDeclaration(node) && (shouldTransformAutoAccessorsInCurrentClass() || hasStaticModifier(node) && getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ )) return transformAutoAccessor(node);
            return transformFieldInitializer(node);
        }
        function shouldForceDynamicThis() {
            return !!currentClassElement && hasStaticModifier(currentClassElement) && isAccessor(currentClassElement) && isAutoAccessorPropertyDeclaration(getOriginalNode(currentClassElement));
        }
        function ensureDynamicThisIfNeeded(node) {
            if (shouldForceDynamicThis()) {
                const innerExpression = skipOuterExpressions(node);
                if (innerExpression.kind === 110 /* ThisKeyword */ ) noSubstitution.add(innerExpression);
            }
        }
        function createPrivateIdentifierAccess(info, receiver) {
            receiver = visitNode(receiver, visitor, isExpression);
            ensureDynamicThisIfNeeded(receiver);
            return createPrivateIdentifierAccessHelper(info, receiver);
        }
        function createPrivateIdentifierAccessHelper(info, receiver) {
            setCommentRange(receiver, moveRangePos(receiver, -1));
            switch(info.kind){
                case "a" /* Accessor */ :
                    return emitHelpers().createClassPrivateFieldGetHelper(receiver, info.brandCheckIdentifier, info.kind, info.getterName);
                case "m" /* Method */ :
                    return emitHelpers().createClassPrivateFieldGetHelper(receiver, info.brandCheckIdentifier, info.kind, info.methodName);
                case "f" /* Field */ :
                    return emitHelpers().createClassPrivateFieldGetHelper(receiver, info.brandCheckIdentifier, info.kind, info.isStatic ? info.variableName : void 0);
                case "untransformed":
                    return Debug.fail("Access helpers should not be created for untransformed private elements");
                default:
                    Debug.assertNever(info, "Unknown private element type");
            }
        }
        function visitPropertyAccessExpression(node) {
            if (isPrivateIdentifier(node.name)) {
                const privateIdentifierInfo = accessPrivateIdentifier2(node.name);
                if (privateIdentifierInfo) return setTextRange(setOriginalNode(createPrivateIdentifierAccess(privateIdentifierInfo, node.expression), node), node);
            }
            if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(node) && isIdentifier(node.name) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classConstructor, superClassReference, facts } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */ ) return visitInvalidSuperProperty(node);
                if (classConstructor && superClassReference) {
                    const superProperty = factory2.createReflectGetCall(superClassReference, factory2.createStringLiteralFromNode(node.name), classConstructor);
                    setOriginalNode(superProperty, node.expression);
                    setTextRange(superProperty, node.expression);
                    return superProperty;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitElementAccessExpression(node) {
            if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(node) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classConstructor, superClassReference, facts } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */ ) return visitInvalidSuperProperty(node);
                if (classConstructor && superClassReference) {
                    const superProperty = factory2.createReflectGetCall(superClassReference, visitNode(node.argumentExpression, visitor, isExpression), classConstructor);
                    setOriginalNode(superProperty, node.expression);
                    setTextRange(superProperty, node.expression);
                    return superProperty;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPreOrPostfixUnaryExpression(node, discarded) {
            if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) {
                const operand = skipParentheses(node.operand);
                if (isPrivateIdentifierPropertyAccessExpression(operand)) {
                    let info;
                    if (info = accessPrivateIdentifier2(operand.name)) {
                        const receiver = visitNode(operand.expression, visitor, isExpression);
                        ensureDynamicThisIfNeeded(receiver);
                        const { readExpression, initializeExpression } = createCopiableReceiverExpr(receiver);
                        let expression = createPrivateIdentifierAccess(info, readExpression);
                        const temp = isPrefixUnaryExpression(node) || discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                        expression = expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, hoistVariableDeclaration, temp);
                        expression = createPrivateIdentifierAssignment(info, initializeExpression || readExpression, expression, 64 /* EqualsToken */ );
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        if (temp) {
                            expression = factory2.createComma(expression, temp);
                            setTextRange(expression, node);
                        }
                        return expression;
                    }
                } else if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(operand) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                    const { classConstructor, superClassReference, facts } = lexicalEnvironment.data;
                    if (facts & 1 /* ClassWasDecorated */ ) {
                        const expression = visitInvalidSuperProperty(operand);
                        return isPrefixUnaryExpression(node) ? factory2.updatePrefixUnaryExpression(node, expression) : factory2.updatePostfixUnaryExpression(node, expression);
                    }
                    if (classConstructor && superClassReference) {
                        let setterName;
                        let getterName;
                        if (isPropertyAccessExpression(operand)) {
                            if (isIdentifier(operand.name)) getterName = setterName = factory2.createStringLiteralFromNode(operand.name);
                        } else if (isSimpleInlineableExpression(operand.argumentExpression)) getterName = setterName = operand.argumentExpression;
                        else {
                            getterName = factory2.createTempVariable(hoistVariableDeclaration);
                            setterName = factory2.createAssignment(getterName, visitNode(operand.argumentExpression, visitor, isExpression));
                        }
                        if (setterName && getterName) {
                            let expression = factory2.createReflectGetCall(superClassReference, getterName, classConstructor);
                            setTextRange(expression, operand);
                            const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                            expression = expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, hoistVariableDeclaration, temp);
                            expression = factory2.createReflectSetCall(superClassReference, setterName, expression, classConstructor);
                            setOriginalNode(expression, node);
                            setTextRange(expression, node);
                            if (temp) {
                                expression = factory2.createComma(expression, temp);
                                setTextRange(expression, node);
                            }
                            return expression;
                        }
                    }
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, visitor, context));
        }
        function visitExpressionStatement(node) {
            return factory2.updateExpressionStatement(node, visitNode(node.expression, discardedValueVisitor, isExpression));
        }
        function createCopiableReceiverExpr(receiver) {
            const clone2 = nodeIsSynthesized(receiver) ? receiver : factory2.cloneNode(receiver);
            if (receiver.kind === 110 /* ThisKeyword */  && noSubstitution.has(receiver)) noSubstitution.add(clone2);
            if (isSimpleInlineableExpression(receiver)) return {
                readExpression: clone2,
                initializeExpression: void 0
            };
            const readExpression = factory2.createTempVariable(hoistVariableDeclaration);
            const initializeExpression = factory2.createAssignment(readExpression, clone2);
            return {
                readExpression,
                initializeExpression
            };
        }
        function visitCallExpression(node) {
            var _a;
            if (isPrivateIdentifierPropertyAccessExpression(node.expression) && accessPrivateIdentifier2(node.expression.name)) {
                const { thisArg, target } = factory2.createCallBinding(node.expression, hoistVariableDeclaration, languageVersion);
                if (isCallChain(node)) return factory2.updateCallChain(node, factory2.createPropertyAccessChain(visitNode(target, visitor, isExpression), node.questionDotToken, "call"), /*questionDotToken*/ void 0, /*typeArguments*/ void 0, [
                    visitNode(thisArg, visitor, isExpression),
                    ...visitNodes2(node.arguments, visitor, isExpression)
                ]);
                return factory2.updateCallExpression(node, factory2.createPropertyAccessExpression(visitNode(target, visitor, isExpression), "call"), /*typeArguments*/ void 0, [
                    visitNode(thisArg, visitor, isExpression),
                    ...visitNodes2(node.arguments, visitor, isExpression)
                ]);
            }
            if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(node.expression) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.classConstructor)) {
                const invocation = factory2.createFunctionCallCall(visitNode(node.expression, visitor, isExpression), lexicalEnvironment.data.classConstructor, visitNodes2(node.arguments, visitor, isExpression));
                setOriginalNode(invocation, node);
                setTextRange(invocation, node);
                return invocation;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitTaggedTemplateExpression(node) {
            var _a;
            if (isPrivateIdentifierPropertyAccessExpression(node.tag) && accessPrivateIdentifier2(node.tag.name)) {
                const { thisArg, target } = factory2.createCallBinding(node.tag, hoistVariableDeclaration, languageVersion);
                return factory2.updateTaggedTemplateExpression(node, factory2.createCallExpression(factory2.createPropertyAccessExpression(visitNode(target, visitor, isExpression), "bind"), /*typeArguments*/ void 0, [
                    visitNode(thisArg, visitor, isExpression)
                ]), /*typeArguments*/ void 0, visitNode(node.template, visitor, isTemplateLiteral));
            }
            if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(node.tag) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.classConstructor)) {
                const invocation = factory2.createFunctionBindCall(visitNode(node.tag, visitor, isExpression), lexicalEnvironment.data.classConstructor, []);
                setOriginalNode(invocation, node);
                setTextRange(invocation, node);
                return factory2.updateTaggedTemplateExpression(node, invocation, /*typeArguments*/ void 0, visitNode(node.template, visitor, isTemplateLiteral));
            }
            return visitEachChild(node, visitor, context);
        }
        function transformClassStaticBlockDeclaration(node) {
            if (lexicalEnvironment) lexicalEnvironmentMap.set(getOriginalNode(node), lexicalEnvironment);
            if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                if (isClassThisAssignmentBlock(node)) {
                    const result = visitNode(node.body.statements[0].expression, visitor, isExpression);
                    if (isAssignmentExpression(result, /*excludeCompoundAssignment*/ true) && result.left === result.right) return void 0;
                    return result;
                }
                if (isClassNamedEvaluationHelperBlock(node)) return visitNode(node.body.statements[0].expression, visitor, isExpression);
                startLexicalEnvironment();
                let statements = setCurrentClassElementAnd(node, (statements2)=>visitNodes2(statements2, visitor, isStatement), node.body.statements);
                statements = factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
                const iife = factory2.createImmediatelyInvokedArrowFunction(statements);
                setOriginalNode(skipParentheses(iife.expression), node);
                addEmitFlags(skipParentheses(iife.expression), 4 /* AdviseOnEmitNode */ );
                setOriginalNode(iife, node);
                setTextRange(iife, node);
                return iife;
            }
        }
        function isAnonymousClassNeedingAssignedName(node) {
            if (isClassExpression(node) && !node.name) {
                const staticPropertiesOrClassStaticBlocks = getStaticPropertiesAndClassStaticBlock(node);
                if (some(staticPropertiesOrClassStaticBlocks, isClassNamedEvaluationHelperBlock)) return false;
                const hasTransformableStatics = (shouldTransformPrivateElementsOrClassStaticBlocks || !!(getInternalEmitFlags(node) && 32 /* TransformPrivateStaticElements */ )) && some(staticPropertiesOrClassStaticBlocks, (node2)=>isClassStaticBlockDeclaration(node2) || isPrivateIdentifierClassElementDeclaration(node2) || shouldTransformInitializers && isInitializedProperty(node2));
                return hasTransformableStatics;
            }
            return false;
        }
        function visitBinaryExpression(node, discarded) {
            if (isDestructuringAssignment(node)) {
                const savedPendingExpressions = pendingExpressions;
                pendingExpressions = void 0;
                node = factory2.updateBinaryExpression(node, visitNode(node.left, assignmentTargetVisitor, isExpression), node.operatorToken, visitNode(node.right, visitor, isExpression));
                const expr = some(pendingExpressions) ? factory2.inlineExpressions(compact([
                    ...pendingExpressions,
                    node
                ])) : node;
                pendingExpressions = savedPendingExpressions;
                return expr;
            }
            if (isAssignmentExpression(node)) {
                if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                    node = transformNamedEvaluation(context, node);
                    Debug.assertNode(node, isAssignmentExpression);
                }
                const left = skipOuterExpressions(node.left, 9 /* Parentheses */ );
                if (isPrivateIdentifierPropertyAccessExpression(left)) {
                    const info = accessPrivateIdentifier2(left.name);
                    if (info) return setTextRange(setOriginalNode(createPrivateIdentifierAssignment(info, left.expression, node.right, node.operatorToken.kind), node), node);
                } else if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(node.left) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                    const { classConstructor, superClassReference, facts } = lexicalEnvironment.data;
                    if (facts & 1 /* ClassWasDecorated */ ) return factory2.updateBinaryExpression(node, visitInvalidSuperProperty(node.left), node.operatorToken, visitNode(node.right, visitor, isExpression));
                    if (classConstructor && superClassReference) {
                        let setterName = isElementAccessExpression(node.left) ? visitNode(node.left.argumentExpression, visitor, isExpression) : isIdentifier(node.left.name) ? factory2.createStringLiteralFromNode(node.left.name) : void 0;
                        if (setterName) {
                            let expression = visitNode(node.right, visitor, isExpression);
                            if (isCompoundAssignment(node.operatorToken.kind)) {
                                let getterName = setterName;
                                if (!isSimpleInlineableExpression(setterName)) {
                                    getterName = factory2.createTempVariable(hoistVariableDeclaration);
                                    setterName = factory2.createAssignment(getterName, setterName);
                                }
                                const superPropertyGet = factory2.createReflectGetCall(superClassReference, getterName, classConstructor);
                                setOriginalNode(superPropertyGet, node.left);
                                setTextRange(superPropertyGet, node.left);
                                expression = factory2.createBinaryExpression(superPropertyGet, getNonAssignmentOperatorForCompoundAssignment(node.operatorToken.kind), expression);
                                setTextRange(expression, node);
                            }
                            const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                            if (temp) {
                                expression = factory2.createAssignment(temp, expression);
                                setTextRange(temp, node);
                            }
                            expression = factory2.createReflectSetCall(superClassReference, setterName, expression, classConstructor);
                            setOriginalNode(expression, node);
                            setTextRange(expression, node);
                            if (temp) {
                                expression = factory2.createComma(expression, temp);
                                setTextRange(expression, node);
                            }
                            return expression;
                        }
                    }
                }
            }
            if (isPrivateIdentifierInExpression(node)) return transformPrivateIdentifierInInExpression(node);
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, discarded) {
            const elements = discarded ? visitCommaListElements(node.elements, discardedValueVisitor) : visitCommaListElements(node.elements, visitor, discardedValueVisitor);
            return factory2.updateCommaListExpression(node, elements);
        }
        function visitParenthesizedExpression(node, discarded) {
            const visitorFunc = discarded ? discardedValueVisitor : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updateParenthesizedExpression(node, expression);
        }
        function createPrivateIdentifierAssignment(info, receiver, right, operator) {
            receiver = visitNode(receiver, visitor, isExpression);
            right = visitNode(right, visitor, isExpression);
            ensureDynamicThisIfNeeded(receiver);
            if (isCompoundAssignment(operator)) {
                const { readExpression, initializeExpression } = createCopiableReceiverExpr(receiver);
                receiver = initializeExpression || readExpression;
                right = factory2.createBinaryExpression(createPrivateIdentifierAccessHelper(info, readExpression), getNonAssignmentOperatorForCompoundAssignment(operator), right);
            }
            setCommentRange(receiver, moveRangePos(receiver, -1));
            switch(info.kind){
                case "a" /* Accessor */ :
                    return emitHelpers().createClassPrivateFieldSetHelper(receiver, info.brandCheckIdentifier, right, info.kind, info.setterName);
                case "m" /* Method */ :
                    return emitHelpers().createClassPrivateFieldSetHelper(receiver, info.brandCheckIdentifier, right, info.kind, /*f*/ void 0);
                case "f" /* Field */ :
                    return emitHelpers().createClassPrivateFieldSetHelper(receiver, info.brandCheckIdentifier, right, info.kind, info.isStatic ? info.variableName : void 0);
                case "untransformed":
                    return Debug.fail("Access helpers should not be created for untransformed private elements");
                default:
                    Debug.assertNever(info, "Unknown private element type");
            }
        }
        function getPrivateInstanceMethodsAndAccessors(node) {
            return filter(node.members, isNonStaticMethodOrAccessorWithPrivateName);
        }
        function getClassFacts(node) {
            var _a;
            let facts = 0 /* None */ ;
            const original = getOriginalNode(node);
            if (isClassLike(original) && classOrConstructorParameterIsDecorated(legacyDecorators, original)) facts |= 1 /* ClassWasDecorated */ ;
            if (shouldTransformPrivateElementsOrClassStaticBlocks && (classHasClassThisAssignment(node) || classHasExplicitlyAssignedName(node))) facts |= 2 /* NeedsClassConstructorReference */ ;
            let containsPublicInstanceFields = false;
            let containsInitializedPublicInstanceFields = false;
            let containsInstancePrivateElements = false;
            let containsInstanceAutoAccessors = false;
            for (const member of node.members){
                if (isStatic(member)) {
                    if (member.name && (isPrivateIdentifier(member.name) || isAutoAccessorPropertyDeclaration(member)) && shouldTransformPrivateElementsOrClassStaticBlocks) facts |= 2 /* NeedsClassConstructorReference */ ;
                    else if (isAutoAccessorPropertyDeclaration(member) && shouldTransformAutoAccessors === -1 /* True */  && !node.name && !((_a = node.emitNode) == null ? void 0 : _a.classThis)) facts |= 2 /* NeedsClassConstructorReference */ ;
                    if (isPropertyDeclaration(member) || isClassStaticBlockDeclaration(member)) {
                        if (shouldTransformThisInStaticInitializers && member.transformFlags & 16384 /* ContainsLexicalThis */ ) {
                            facts |= 8 /* NeedsSubstitutionForThisInClassStaticField */ ;
                            if (!(facts & 1 /* ClassWasDecorated */ )) facts |= 2 /* NeedsClassConstructorReference */ ;
                        }
                        if (shouldTransformSuperInStaticInitializers && member.transformFlags & 134217728 /* ContainsLexicalSuper */ ) {
                            if (!(facts & 1 /* ClassWasDecorated */ )) facts |= 6 /* NeedsClassSuperReference */ ;
                        }
                    }
                } else if (!hasAbstractModifier(getOriginalNode(member))) {
                    if (isAutoAccessorPropertyDeclaration(member)) {
                        containsInstanceAutoAccessors = true;
                        containsInstancePrivateElements || (containsInstancePrivateElements = isPrivateIdentifierClassElementDeclaration(member));
                    } else if (isPrivateIdentifierClassElementDeclaration(member)) {
                        containsInstancePrivateElements = true;
                        if (resolver.hasNodeCheckFlag(member, 262144 /* ContainsConstructorReference */ )) facts |= 2 /* NeedsClassConstructorReference */ ;
                    } else if (isPropertyDeclaration(member)) {
                        containsPublicInstanceFields = true;
                        containsInitializedPublicInstanceFields || (containsInitializedPublicInstanceFields = !!member.initializer);
                    }
                }
            }
            const willHoistInitializersToConstructor = shouldTransformInitializersUsingDefine && containsPublicInstanceFields || shouldTransformInitializersUsingSet && containsInitializedPublicInstanceFields || shouldTransformPrivateElementsOrClassStaticBlocks && containsInstancePrivateElements || shouldTransformPrivateElementsOrClassStaticBlocks && containsInstanceAutoAccessors && shouldTransformAutoAccessors === -1 /* True */ ;
            if (willHoistInitializersToConstructor) facts |= 16 /* WillHoistInitializersToConstructor */ ;
            return facts;
        }
        function visitExpressionWithTypeArgumentsInHeritageClause(node) {
            var _a;
            const facts = ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.facts) || 0 /* None */ ;
            if (facts & 4 /* NeedsClassSuperReference */ ) {
                const temp = factory2.createTempVariable(hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                getClassLexicalEnvironment().superClassReference = temp;
                return factory2.updateExpressionWithTypeArguments(node, factory2.createAssignment(temp, visitNode(node.expression, visitor, isExpression)), /*typeArguments*/ void 0);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitInNewClassLexicalEnvironment(node, visitor2) {
            var _a;
            const savedCurrentClassContainer = currentClassContainer;
            const savedPendingExpressions = pendingExpressions;
            const savedLexicalEnvironment = lexicalEnvironment;
            currentClassContainer = node;
            pendingExpressions = void 0;
            startClassLexicalEnvironment();
            const shouldAlwaysTransformPrivateStaticElements = getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ;
            if (shouldTransformPrivateElementsOrClassStaticBlocks || shouldAlwaysTransformPrivateStaticElements) {
                const name = getNameOfDeclaration(node);
                if (name && isIdentifier(name)) getPrivateIdentifierEnvironment().data.className = name;
                else if ((_a = node.emitNode) == null ? void 0 : _a.assignedName) {
                    if (isStringLiteral(node.emitNode.assignedName)) {
                        if (node.emitNode.assignedName.textSourceNode && isIdentifier(node.emitNode.assignedName.textSourceNode)) getPrivateIdentifierEnvironment().data.className = node.emitNode.assignedName.textSourceNode;
                        else if (isIdentifierText(node.emitNode.assignedName.text, languageVersion)) {
                            const prefixName = factory2.createIdentifier(node.emitNode.assignedName.text);
                            getPrivateIdentifierEnvironment().data.className = prefixName;
                        }
                    }
                }
            }
            if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                const privateInstanceMethodsAndAccessors = getPrivateInstanceMethodsAndAccessors(node);
                if (some(privateInstanceMethodsAndAccessors)) getPrivateIdentifierEnvironment().data.weakSetName = createHoistedVariableForClass("instances", privateInstanceMethodsAndAccessors[0].name);
            }
            const facts = getClassFacts(node);
            if (facts) getClassLexicalEnvironment().facts = facts;
            if (facts & 8 /* NeedsSubstitutionForThisInClassStaticField */ ) enableSubstitutionForClassStaticThisOrSuperReference();
            const result = visitor2(node, facts);
            endClassLexicalEnvironment();
            Debug.assert(lexicalEnvironment === savedLexicalEnvironment);
            currentClassContainer = savedCurrentClassContainer;
            pendingExpressions = savedPendingExpressions;
            return result;
        }
        function visitClassDeclaration(node) {
            return visitInNewClassLexicalEnvironment(node, visitClassDeclarationInNewClassLexicalEnvironment);
        }
        function visitClassDeclarationInNewClassLexicalEnvironment(node, facts) {
            var _a, _b;
            let pendingClassReferenceAssignment;
            if (facts & 2 /* NeedsClassConstructorReference */ ) {
                if (shouldTransformPrivateElementsOrClassStaticBlocks && ((_a = node.emitNode) == null ? void 0 : _a.classThis)) {
                    getClassLexicalEnvironment().classConstructor = node.emitNode.classThis;
                    pendingClassReferenceAssignment = factory2.createAssignment(node.emitNode.classThis, factory2.getInternalName(node));
                } else {
                    const temp = factory2.createTempVariable(hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                    getClassLexicalEnvironment().classConstructor = factory2.cloneNode(temp);
                    pendingClassReferenceAssignment = factory2.createAssignment(temp, factory2.getInternalName(node));
                }
            }
            if ((_b = node.emitNode) == null ? void 0 : _b.classThis) getClassLexicalEnvironment().classThis = node.emitNode.classThis;
            const isClassWithConstructorReference = resolver.hasNodeCheckFlag(node, 262144 /* ContainsConstructorReference */ );
            const isExport = hasSyntacticModifier(node, 32 /* Export */ );
            const isDefault = hasSyntacticModifier(node, 2048 /* Default */ );
            let modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const heritageClauses = visitNodes2(node.heritageClauses, heritageClauseVisitor, isHeritageClause);
            const { members, prologue } = transformClassMembers(node);
            const statements = [];
            if (pendingClassReferenceAssignment) getPendingExpressions().unshift(pendingClassReferenceAssignment);
            if (some(pendingExpressions)) statements.push(factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions)));
            if (shouldTransformInitializersUsingSet || shouldTransformPrivateElementsOrClassStaticBlocks || getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ) {
                const staticProperties = getStaticPropertiesAndClassStaticBlock(node);
                if (some(staticProperties)) addPropertyOrClassStaticBlockStatements(statements, staticProperties, factory2.getInternalName(node));
            }
            if (statements.length > 0 && isExport && isDefault) {
                modifiers = visitNodes2(modifiers, (node2)=>isExportOrDefaultModifier(node2) ? void 0 : node2, isModifier);
                statements.push(factory2.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true)));
            }
            const alias = getClassLexicalEnvironment().classConstructor;
            if (isClassWithConstructorReference && alias) {
                enableSubstitutionForClassAliases();
                classAliases[getOriginalNodeId(node)] = alias;
            }
            const classDecl = factory2.updateClassDeclaration(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            statements.unshift(classDecl);
            if (prologue) statements.unshift(factory2.createExpressionStatement(prologue));
            return statements;
        }
        function visitClassExpression(node) {
            return visitInNewClassLexicalEnvironment(node, visitClassExpressionInNewClassLexicalEnvironment);
        }
        function visitClassExpressionInNewClassLexicalEnvironment(node, facts) {
            var _a, _b, _c;
            const isDecoratedClassDeclaration = !!(facts & 1 /* ClassWasDecorated */ );
            const staticPropertiesOrClassStaticBlocks = getStaticPropertiesAndClassStaticBlock(node);
            const isClassWithConstructorReference = resolver.hasNodeCheckFlag(node, 262144 /* ContainsConstructorReference */ );
            const requiresBlockScopedVar = resolver.hasNodeCheckFlag(node, 32768 /* BlockScopedBindingInLoop */ );
            let temp;
            function createClassTempVar() {
                var _a2;
                if (shouldTransformPrivateElementsOrClassStaticBlocks && ((_a2 = node.emitNode) == null ? void 0 : _a2.classThis)) return getClassLexicalEnvironment().classConstructor = node.emitNode.classThis;
                const temp2 = factory2.createTempVariable(requiresBlockScopedVar ? addBlockScopedVariable : hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                getClassLexicalEnvironment().classConstructor = factory2.cloneNode(temp2);
                return temp2;
            }
            if ((_a = node.emitNode) == null ? void 0 : _a.classThis) getClassLexicalEnvironment().classThis = node.emitNode.classThis;
            if (facts & 2 /* NeedsClassConstructorReference */ ) temp !== null && temp !== void 0 ? temp : temp = createClassTempVar();
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const heritageClauses = visitNodes2(node.heritageClauses, heritageClauseVisitor, isHeritageClause);
            const { members, prologue } = transformClassMembers(node);
            const classExpression = factory2.updateClassExpression(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            const expressions = [];
            if (prologue) expressions.push(prologue);
            const hasTransformableStatics = (shouldTransformPrivateElementsOrClassStaticBlocks || getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ ) && some(staticPropertiesOrClassStaticBlocks, (node2)=>isClassStaticBlockDeclaration(node2) || isPrivateIdentifierClassElementDeclaration(node2) || shouldTransformInitializers && isInitializedProperty(node2));
            if (hasTransformableStatics || some(pendingExpressions)) {
                if (isDecoratedClassDeclaration) {
                    Debug.assertIsDefined(pendingStatements, "Decorated classes transformed by TypeScript are expected to be within a variable declaration.");
                    if (some(pendingExpressions)) addRange(pendingStatements, map(pendingExpressions, factory2.createExpressionStatement));
                    var _ref;
                    if (some(staticPropertiesOrClassStaticBlocks)) addPropertyOrClassStaticBlockStatements(pendingStatements, staticPropertiesOrClassStaticBlocks, (_ref = (_b = node.emitNode) == null ? void 0 : _b.classThis) !== null && _ref !== void 0 ? _ref : factory2.getInternalName(node));
                    if (temp) expressions.push(factory2.createAssignment(temp, classExpression));
                    else if (shouldTransformPrivateElementsOrClassStaticBlocks && ((_c = node.emitNode) == null ? void 0 : _c.classThis)) expressions.push(factory2.createAssignment(node.emitNode.classThis, classExpression));
                    else expressions.push(classExpression);
                } else {
                    temp !== null && temp !== void 0 ? temp : temp = createClassTempVar();
                    if (isClassWithConstructorReference) {
                        enableSubstitutionForClassAliases();
                        const alias = factory2.cloneNode(temp);
                        alias.emitNode.autoGenerate.flags &= -9 /* ReservedInNestedScopes */ ;
                        classAliases[getOriginalNodeId(node)] = alias;
                    }
                    expressions.push(factory2.createAssignment(temp, classExpression));
                    addRange(expressions, pendingExpressions);
                    addRange(expressions, generateInitializedPropertyExpressionsOrClassStaticBlock(staticPropertiesOrClassStaticBlocks, temp));
                    expressions.push(factory2.cloneNode(temp));
                }
            } else expressions.push(classExpression);
            if (expressions.length > 1) {
                addEmitFlags(classExpression, 131072 /* Indented */ );
                expressions.forEach(startOnNewLine);
            }
            return factory2.inlineExpressions(expressions);
        }
        function visitClassStaticBlockDeclaration(node) {
            if (!shouldTransformPrivateElementsOrClassStaticBlocks) return visitEachChild(node, visitor, context);
            return void 0;
        }
        function visitThisExpression(node) {
            if (shouldTransformThisInStaticInitializers && currentClassElement && isClassStaticBlockDeclaration(currentClassElement) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classThis, classConstructor } = lexicalEnvironment.data;
                var _ref;
                return (_ref = classThis !== null && classThis !== void 0 ? classThis : classConstructor) !== null && _ref !== void 0 ? _ref : node;
            }
            return node;
        }
        function transformClassMembers(node) {
            const shouldTransformPrivateStaticElementsInClass = !!(getInternalEmitFlags(node) & 32 /* TransformPrivateStaticElements */ );
            if (shouldTransformPrivateElementsOrClassStaticBlocks || shouldTransformPrivateStaticElementsInFile) {
                for (const member of node.members)if (isPrivateIdentifierClassElementDeclaration(member)) {
                    if (shouldTransformClassElementToWeakMap(member)) addPrivateIdentifierToEnvironment(member, member.name, addPrivateIdentifierClassElementToEnvironment);
                    else {
                        const privateEnv = getPrivateIdentifierEnvironment();
                        setPrivateIdentifier(privateEnv, member.name, {
                            kind: "untransformed"
                        });
                    }
                }
                if (shouldTransformPrivateElementsOrClassStaticBlocks) {
                    if (some(getPrivateInstanceMethodsAndAccessors(node))) createBrandCheckWeakSetForPrivateMethods();
                }
                if (shouldTransformAutoAccessorsInCurrentClass()) {
                    for (const member of node.members)if (isAutoAccessorPropertyDeclaration(member)) {
                        const storageName = factory2.getGeneratedPrivateNameForNode(member.name, /*prefix*/ void 0, "_accessor_storage");
                        if (shouldTransformPrivateElementsOrClassStaticBlocks || shouldTransformPrivateStaticElementsInClass && hasStaticModifier(member)) addPrivateIdentifierToEnvironment(member, storageName, addPrivateIdentifierPropertyDeclarationToEnvironment);
                        else {
                            const privateEnv = getPrivateIdentifierEnvironment();
                            setPrivateIdentifier(privateEnv, storageName, {
                                kind: "untransformed"
                            });
                        }
                    }
                }
            }
            let members = visitNodes2(node.members, classElementVisitor, isClassElement);
            let syntheticConstructor;
            if (!some(members, isConstructorDeclaration)) syntheticConstructor = transformConstructor(/*constructor*/ void 0, node);
            let prologue;
            let syntheticStaticBlock;
            if (!shouldTransformPrivateElementsOrClassStaticBlocks && some(pendingExpressions)) {
                let statement = factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions));
                if (statement.transformFlags & 134234112 /* ContainsLexicalThisOrSuper */ ) {
                    const temp = factory2.createTempVariable(hoistVariableDeclaration);
                    const arrow = factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createBlock([
                        statement
                    ]));
                    prologue = factory2.createAssignment(temp, arrow);
                    statement = factory2.createExpressionStatement(factory2.createCallExpression(temp, /*typeArguments*/ void 0, []));
                }
                const block = factory2.createBlock([
                    statement
                ]);
                syntheticStaticBlock = factory2.createClassStaticBlockDeclaration(block);
                pendingExpressions = void 0;
            }
            if (syntheticConstructor || syntheticStaticBlock) {
                let membersArray;
                const classThisAssignmentBlock = find(members, isClassThisAssignmentBlock);
                const classNamedEvaluationHelperBlock = find(members, isClassNamedEvaluationHelperBlock);
                membersArray = append(membersArray, classThisAssignmentBlock);
                membersArray = append(membersArray, classNamedEvaluationHelperBlock);
                membersArray = append(membersArray, syntheticConstructor);
                membersArray = append(membersArray, syntheticStaticBlock);
                const remainingMembers = classThisAssignmentBlock || classNamedEvaluationHelperBlock ? filter(members, (member)=>member !== classThisAssignmentBlock && member !== classNamedEvaluationHelperBlock) : members;
                membersArray = addRange(membersArray, remainingMembers);
                members = setTextRange(factory2.createNodeArray(membersArray), /*location*/ node.members);
            }
            return {
                members,
                prologue
            };
        }
        function createBrandCheckWeakSetForPrivateMethods() {
            const { weakSetName } = getPrivateIdentifierEnvironment().data;
            Debug.assert(weakSetName, "weakSetName should be set in private identifier environment");
            getPendingExpressions().push(factory2.createAssignment(weakSetName, factory2.createNewExpression(factory2.createIdentifier("WeakSet"), /*typeArguments*/ void 0, [])));
        }
        function transformConstructor(constructor, container) {
            constructor = visitNode(constructor, visitor, isConstructorDeclaration);
            if (!(lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) || !(lexicalEnvironment.data.facts & 16 /* WillHoistInitializersToConstructor */ )) return constructor;
            const extendsClauseElement = getEffectiveBaseTypeNode(container);
            const isDerivedClass = !!(extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ );
            const parameters = visitParameterList(constructor ? constructor.parameters : void 0, visitor, context);
            const body = transformConstructorBody(container, constructor, isDerivedClass);
            if (!body) return constructor;
            if (constructor) {
                Debug.assert(parameters);
                return factory2.updateConstructorDeclaration(constructor, /*modifiers*/ void 0, parameters, body);
            }
            return startOnNewLine(setOriginalNode(setTextRange(factory2.createConstructorDeclaration(/*modifiers*/ void 0, parameters !== null && parameters !== void 0 ? parameters : [], body), constructor || container), constructor));
        }
        function transformConstructorBodyWorker(statementsOut, statementsIn, statementOffset, superPath, superPathDepth, initializerStatements, constructor) {
            const superStatementIndex = superPath[superPathDepth];
            const superStatement = statementsIn[superStatementIndex];
            addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, statementOffset, superStatementIndex - statementOffset));
            statementOffset = superStatementIndex + 1;
            if (isTryStatement(superStatement)) {
                const tryBlockStatements = [];
                transformConstructorBodyWorker(tryBlockStatements, superStatement.tryBlock.statements, /*statementOffset*/ 0, superPath, superPathDepth + 1, initializerStatements, constructor);
                const tryBlockStatementsArray = factory2.createNodeArray(tryBlockStatements);
                setTextRange(tryBlockStatementsArray, superStatement.tryBlock.statements);
                statementsOut.push(factory2.updateTryStatement(superStatement, factory2.updateBlock(superStatement.tryBlock, tryBlockStatements), visitNode(superStatement.catchClause, visitor, isCatchClause), visitNode(superStatement.finallyBlock, visitor, isBlock)));
            } else {
                addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, superStatementIndex, 1));
                while(statementOffset < statementsIn.length){
                    const statement = statementsIn[statementOffset];
                    if (isParameterPropertyDeclaration(getOriginalNode(statement), constructor)) statementOffset++;
                    else break;
                }
                addRange(statementsOut, initializerStatements);
            }
            addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, statementOffset));
        }
        function transformConstructorBody(node, constructor, isDerivedClass) {
            var _a;
            const instanceProperties = getProperties(node, /*requireInitializer*/ false, /*isStatic*/ false);
            let properties = instanceProperties;
            if (!useDefineForClassFields) properties = filter(properties, (property)=>!!property.initializer || isPrivateIdentifier(property.name) || hasAccessorModifier(property));
            const privateMethodsAndAccessors = getPrivateInstanceMethodsAndAccessors(node);
            const needsConstructorBody = some(properties) || some(privateMethodsAndAccessors);
            if (!constructor && !needsConstructorBody) return visitFunctionBody(/*node*/ void 0, visitor, context);
            resumeLexicalEnvironment();
            const needsSyntheticConstructor = !constructor && isDerivedClass;
            let statementOffset = 0;
            let statements = [];
            const initializerStatements = [];
            const receiver = factory2.createThis();
            addInstanceMethodStatements(initializerStatements, privateMethodsAndAccessors, receiver);
            if (constructor) {
                const parameterProperties = filter(instanceProperties, (prop)=>isParameterPropertyDeclaration(getOriginalNode(prop), constructor));
                const nonParameterProperties = filter(properties, (prop)=>!isParameterPropertyDeclaration(getOriginalNode(prop), constructor));
                addPropertyOrClassStaticBlockStatements(initializerStatements, parameterProperties, receiver);
                addPropertyOrClassStaticBlockStatements(initializerStatements, nonParameterProperties, receiver);
            } else addPropertyOrClassStaticBlockStatements(initializerStatements, properties, receiver);
            if (constructor == null ? void 0 : constructor.body) {
                statementOffset = factory2.copyPrologue(constructor.body.statements, statements, /*ensureUseStrict*/ false, visitor);
                const superStatementIndices = findSuperStatementIndexPath(constructor.body.statements, statementOffset);
                if (superStatementIndices.length) transformConstructorBodyWorker(statements, constructor.body.statements, statementOffset, superStatementIndices, /*superPathDepth*/ 0, initializerStatements, constructor);
                else {
                    while(statementOffset < constructor.body.statements.length){
                        const statement = constructor.body.statements[statementOffset];
                        if (isParameterPropertyDeclaration(getOriginalNode(statement), constructor)) statementOffset++;
                        else break;
                    }
                    addRange(statements, initializerStatements);
                    addRange(statements, visitNodes2(constructor.body.statements, visitor, isStatement, statementOffset));
                }
            } else {
                if (needsSyntheticConstructor) statements.push(factory2.createExpressionStatement(factory2.createCallExpression(factory2.createSuper(), /*typeArguments*/ void 0, [
                    factory2.createSpreadElement(factory2.createIdentifier("arguments"))
                ])));
                addRange(statements, initializerStatements);
            }
            statements = factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
            if (statements.length === 0 && !constructor) return void 0;
            var _constructor_body_multiLine;
            const multiLine = (constructor == null ? void 0 : constructor.body) && constructor.body.statements.length >= statements.length ? (_constructor_body_multiLine = constructor.body.multiLine) !== null && _constructor_body_multiLine !== void 0 ? _constructor_body_multiLine : statements.length > 0 : statements.length > 0;
            var /*location*/ _ref;
            return setTextRange(factory2.createBlock(setTextRange(factory2.createNodeArray(statements), (_ref = (_a = constructor == null ? void 0 : constructor.body) == null ? void 0 : _a.statements) !== null && _ref !== void 0 ? _ref : node.members), multiLine), /*location*/ constructor == null ? void 0 : constructor.body);
        }
        function addPropertyOrClassStaticBlockStatements(statements, properties, receiver) {
            for (const property of properties){
                if (isStatic(property) && !shouldTransformPrivateElementsOrClassStaticBlocks) continue;
                const statement = transformPropertyOrClassStaticBlock(property, receiver);
                if (!statement) continue;
                statements.push(statement);
            }
        }
        function transformPropertyOrClassStaticBlock(property, receiver) {
            const expression = isClassStaticBlockDeclaration(property) ? setCurrentClassElementAnd(property, transformClassStaticBlockDeclaration, property) : transformProperty(property, receiver);
            if (!expression) return void 0;
            const statement = factory2.createExpressionStatement(expression);
            setOriginalNode(statement, property);
            addEmitFlags(statement, getEmitFlags(property) & 3072 /* NoComments */ );
            setCommentRange(statement, property);
            const propertyOriginalNode = getOriginalNode(property);
            if (isParameter(propertyOriginalNode)) {
                setSourceMapRange(statement, propertyOriginalNode);
                removeAllComments(statement);
            } else setSourceMapRange(statement, moveRangePastModifiers(property));
            setSyntheticLeadingComments(expression, void 0);
            setSyntheticTrailingComments(expression, void 0);
            if (hasAccessorModifier(propertyOriginalNode)) addEmitFlags(statement, 3072 /* NoComments */ );
            return statement;
        }
        function generateInitializedPropertyExpressionsOrClassStaticBlock(propertiesOrClassStaticBlocks, receiver) {
            const expressions = [];
            for (const property of propertiesOrClassStaticBlocks){
                const expression = isClassStaticBlockDeclaration(property) ? setCurrentClassElementAnd(property, transformClassStaticBlockDeclaration, property) : setCurrentClassElementAnd(property, ()=>transformProperty(property, receiver), /*arg*/ void 0);
                if (!expression) continue;
                startOnNewLine(expression);
                setOriginalNode(expression, property);
                addEmitFlags(expression, getEmitFlags(property) & 3072 /* NoComments */ );
                setSourceMapRange(expression, moveRangePastModifiers(property));
                setCommentRange(expression, property);
                expressions.push(expression);
            }
            return expressions;
        }
        function transformProperty(property, receiver) {
            var _a;
            const savedCurrentClassElement = currentClassElement;
            const transformed = transformPropertyWorker(property, receiver);
            if (transformed && hasStaticModifier(property) && ((_a = lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) == null ? void 0 : _a.facts)) {
                setOriginalNode(transformed, property);
                addEmitFlags(transformed, 4 /* AdviseOnEmitNode */ );
                setSourceMapRange(transformed, getSourceMapRange(property.name));
                lexicalEnvironmentMap.set(getOriginalNode(property), lexicalEnvironment);
            }
            currentClassElement = savedCurrentClassElement;
            return transformed;
        }
        function transformPropertyWorker(property, receiver) {
            const emitAssignment = !useDefineForClassFields;
            if (isNamedEvaluation(property, isAnonymousClassNeedingAssignedName)) property = transformNamedEvaluation(context, property);
            const propertyName = hasAccessorModifier(property) ? factory2.getGeneratedPrivateNameForNode(property.name) : isComputedPropertyName(property.name) && !isSimpleInlineableExpression(property.name.expression) ? factory2.updateComputedPropertyName(property.name, factory2.getGeneratedNameForNode(property.name)) : property.name;
            if (hasStaticModifier(property)) currentClassElement = property;
            if (isPrivateIdentifier(propertyName) && shouldTransformClassElementToWeakMap(property)) {
                const privateIdentifierInfo = accessPrivateIdentifier2(propertyName);
                if (privateIdentifierInfo) {
                    if (privateIdentifierInfo.kind === "f" /* Field */ ) {
                        if (!privateIdentifierInfo.isStatic) return createPrivateInstanceFieldInitializer(factory2, receiver, visitNode(property.initializer, visitor, isExpression), privateIdentifierInfo.brandCheckIdentifier);
                        else return createPrivateStaticFieldInitializer(factory2, privateIdentifierInfo.variableName, visitNode(property.initializer, visitor, isExpression));
                    } else return void 0;
                } else Debug.fail("Undeclared private name for property declaration.");
            }
            if ((isPrivateIdentifier(propertyName) || hasStaticModifier(property)) && !property.initializer) return void 0;
            const propertyOriginalNode = getOriginalNode(property);
            if (hasSyntacticModifier(propertyOriginalNode, 64 /* Abstract */ )) return void 0;
            let initializer = visitNode(property.initializer, visitor, isExpression);
            if (isParameterPropertyDeclaration(propertyOriginalNode, propertyOriginalNode.parent) && isIdentifier(propertyName)) {
                const localName = factory2.cloneNode(propertyName);
                if (initializer) {
                    if (isParenthesizedExpression(initializer) && isCommaExpression(initializer.expression) && isCallToHelper(initializer.expression.left, "___runInitializers") && isVoidExpression(initializer.expression.right) && isNumericLiteral(initializer.expression.right.expression)) initializer = initializer.expression.left;
                    initializer = factory2.inlineExpressions([
                        initializer,
                        localName
                    ]);
                } else initializer = localName;
                setEmitFlags(propertyName, 3168 /* NoSourceMap */ );
                setSourceMapRange(localName, propertyOriginalNode.name);
                setEmitFlags(localName, 3072 /* NoComments */ );
            } else initializer !== null && initializer !== void 0 ? initializer : initializer = factory2.createVoidZero();
            if (emitAssignment || isPrivateIdentifier(propertyName)) {
                const memberAccess = createMemberAccessForPropertyName(factory2, receiver, propertyName, /*location*/ propertyName);
                addEmitFlags(memberAccess, 1024 /* NoLeadingComments */ );
                const expression = factory2.createAssignment(memberAccess, initializer);
                return expression;
            } else {
                const name = isComputedPropertyName(propertyName) ? propertyName.expression : isIdentifier(propertyName) ? factory2.createStringLiteral(unescapeLeadingUnderscores(propertyName.escapedText)) : propertyName;
                const descriptor = factory2.createPropertyDescriptor({
                    value: initializer,
                    configurable: true,
                    writable: true,
                    enumerable: true
                });
                return factory2.createObjectDefinePropertyCall(receiver, name, descriptor);
            }
        }
        function enableSubstitutionForClassAliases() {
            if ((enabledSubstitutions & 1 /* ClassAliases */ ) === 0) {
                enabledSubstitutions |= 1 /* ClassAliases */ ;
                context.enableSubstitution(80 /* Identifier */ );
                classAliases = [];
            }
        }
        function enableSubstitutionForClassStaticThisOrSuperReference() {
            if ((enabledSubstitutions & 2 /* ClassStaticThisOrSuperReference */ ) === 0) {
                enabledSubstitutions |= 2 /* ClassStaticThisOrSuperReference */ ;
                context.enableSubstitution(110 /* ThisKeyword */ );
                context.enableEmitNotification(263 /* FunctionDeclaration */ );
                context.enableEmitNotification(219 /* FunctionExpression */ );
                context.enableEmitNotification(177 /* Constructor */ );
                context.enableEmitNotification(178 /* GetAccessor */ );
                context.enableEmitNotification(179 /* SetAccessor */ );
                context.enableEmitNotification(175 /* MethodDeclaration */ );
                context.enableEmitNotification(173 /* PropertyDeclaration */ );
                context.enableEmitNotification(168 /* ComputedPropertyName */ );
            }
        }
        function addInstanceMethodStatements(statements, methods, receiver) {
            if (!shouldTransformPrivateElementsOrClassStaticBlocks || !some(methods)) return;
            const { weakSetName } = getPrivateIdentifierEnvironment().data;
            Debug.assert(weakSetName, "weakSetName should be set in private identifier environment");
            statements.push(factory2.createExpressionStatement(createPrivateInstanceMethodInitializer(factory2, receiver, weakSetName)));
        }
        function visitInvalidSuperProperty(node) {
            return isPropertyAccessExpression(node) ? factory2.updatePropertyAccessExpression(node, factory2.createVoidZero(), node.name) : factory2.updateElementAccessExpression(node, factory2.createVoidZero(), visitNode(node.argumentExpression, visitor, isExpression));
        }
        function getPropertyNameExpressionIfNeeded(name, shouldHoist) {
            if (isComputedPropertyName(name)) {
                const cacheAssignment = findComputedPropertyNameCacheAssignment(name);
                const expression = visitNode(name.expression, visitor, isExpression);
                const innerExpression = skipPartiallyEmittedExpressions(expression);
                const inlinable = isSimpleInlineableExpression(innerExpression);
                const alreadyTransformed = !!cacheAssignment || isAssignmentExpression(innerExpression) && isGeneratedIdentifier(innerExpression.left);
                if (!alreadyTransformed && !inlinable && shouldHoist) {
                    const generatedName = factory2.getGeneratedNameForNode(name);
                    if (resolver.hasNodeCheckFlag(name, 32768 /* BlockScopedBindingInLoop */ )) addBlockScopedVariable(generatedName);
                    else hoistVariableDeclaration(generatedName);
                    return factory2.createAssignment(generatedName, expression);
                }
                return inlinable || isIdentifier(innerExpression) ? void 0 : expression;
            }
        }
        function startClassLexicalEnvironment() {
            lexicalEnvironment = {
                previous: lexicalEnvironment,
                data: void 0
            };
        }
        function endClassLexicalEnvironment() {
            lexicalEnvironment = lexicalEnvironment == null ? void 0 : lexicalEnvironment.previous;
        }
        function getClassLexicalEnvironment() {
            Debug.assert(lexicalEnvironment);
            var _lexicalEnvironment_data;
            return (_lexicalEnvironment_data = lexicalEnvironment.data) !== null && _lexicalEnvironment_data !== void 0 ? _lexicalEnvironment_data : lexicalEnvironment.data = {
                facts: 0 /* None */ ,
                classConstructor: void 0,
                classThis: void 0,
                superClassReference: void 0
            };
        }
        function getPrivateIdentifierEnvironment() {
            Debug.assert(lexicalEnvironment);
            var _lexicalEnvironment_privateEnv;
            return (_lexicalEnvironment_privateEnv = lexicalEnvironment.privateEnv) !== null && _lexicalEnvironment_privateEnv !== void 0 ? _lexicalEnvironment_privateEnv : lexicalEnvironment.privateEnv = newPrivateEnvironment({
                className: void 0,
                weakSetName: void 0
            });
        }
        function getPendingExpressions() {
            return pendingExpressions !== null && pendingExpressions !== void 0 ? pendingExpressions : pendingExpressions = [];
        }
        function addPrivateIdentifierClassElementToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo) {
            if (isAutoAccessorPropertyDeclaration(node)) addPrivateIdentifierAutoAccessorPropertyDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isPropertyDeclaration(node)) addPrivateIdentifierPropertyDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isMethodDeclaration(node)) addPrivateIdentifierMethodDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isGetAccessorDeclaration(node)) addPrivateIdentifierGetAccessorDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
            else if (isSetAccessorDeclaration(node)) addPrivateIdentifierSetAccessorDeclarationToEnvironment(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
        }
        function addPrivateIdentifierPropertyDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, _previousInfo) {
            if (isStatic2) {
                var _lex_classThis;
                const brandCheckIdentifier = Debug.checkDefined((_lex_classThis = lex.classThis) !== null && _lex_classThis !== void 0 ? _lex_classThis : lex.classConstructor, "classConstructor should be set in private identifier environment");
                const variableName = createHoistedVariableForPrivateName(name);
                setPrivateIdentifier(privateEnv, name, {
                    kind: "f" /* Field */ ,
                    isStatic: true,
                    brandCheckIdentifier,
                    variableName,
                    isValid
                });
            } else {
                const weakMapName = createHoistedVariableForPrivateName(name);
                setPrivateIdentifier(privateEnv, name, {
                    kind: "f" /* Field */ ,
                    isStatic: false,
                    brandCheckIdentifier: weakMapName,
                    isValid
                });
                getPendingExpressions().push(factory2.createAssignment(weakMapName, factory2.createNewExpression(factory2.createIdentifier("WeakMap"), /*typeArguments*/ void 0, [])));
            }
        }
        function addPrivateIdentifierMethodDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, _previousInfo) {
            const methodName = createHoistedVariableForPrivateName(name);
            var _lex_classThis;
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined((_lex_classThis = lex.classThis) !== null && _lex_classThis !== void 0 ? _lex_classThis : lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            setPrivateIdentifier(privateEnv, name, {
                kind: "m" /* Method */ ,
                methodName,
                brandCheckIdentifier,
                isStatic: isStatic2,
                isValid
            });
        }
        function addPrivateIdentifierGetAccessorDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, previousInfo) {
            const getterName = createHoistedVariableForPrivateName(name, "_get");
            var _lex_classThis;
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined((_lex_classThis = lex.classThis) !== null && _lex_classThis !== void 0 ? _lex_classThis : lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            if ((previousInfo == null ? void 0 : previousInfo.kind) === "a" /* Accessor */  && previousInfo.isStatic === isStatic2 && !previousInfo.getterName) previousInfo.getterName = getterName;
            else setPrivateIdentifier(privateEnv, name, {
                kind: "a" /* Accessor */ ,
                getterName,
                setterName: void 0,
                brandCheckIdentifier,
                isStatic: isStatic2,
                isValid
            });
        }
        function addPrivateIdentifierSetAccessorDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, previousInfo) {
            const setterName = createHoistedVariableForPrivateName(name, "_set");
            var _lex_classThis;
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined((_lex_classThis = lex.classThis) !== null && _lex_classThis !== void 0 ? _lex_classThis : lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            if ((previousInfo == null ? void 0 : previousInfo.kind) === "a" /* Accessor */  && previousInfo.isStatic === isStatic2 && !previousInfo.setterName) previousInfo.setterName = setterName;
            else setPrivateIdentifier(privateEnv, name, {
                kind: "a" /* Accessor */ ,
                getterName: void 0,
                setterName,
                brandCheckIdentifier,
                isStatic: isStatic2,
                isValid
            });
        }
        function addPrivateIdentifierAutoAccessorPropertyDeclarationToEnvironment(_node, name, lex, privateEnv, isStatic2, isValid, _previousInfo) {
            const getterName = createHoistedVariableForPrivateName(name, "_get");
            const setterName = createHoistedVariableForPrivateName(name, "_set");
            var _lex_classThis;
            const brandCheckIdentifier = isStatic2 ? Debug.checkDefined((_lex_classThis = lex.classThis) !== null && _lex_classThis !== void 0 ? _lex_classThis : lex.classConstructor, "classConstructor should be set in private identifier environment") : Debug.checkDefined(privateEnv.data.weakSetName, "weakSetName should be set in private identifier environment");
            setPrivateIdentifier(privateEnv, name, {
                kind: "a" /* Accessor */ ,
                getterName,
                setterName,
                brandCheckIdentifier,
                isStatic: isStatic2,
                isValid
            });
        }
        function addPrivateIdentifierToEnvironment(node, name, addDeclaration) {
            const lex = getClassLexicalEnvironment();
            const privateEnv = getPrivateIdentifierEnvironment();
            const previousInfo = getPrivateIdentifier(privateEnv, name);
            const isStatic2 = hasStaticModifier(node);
            const isValid = !isReservedPrivateName(name) && previousInfo === void 0;
            addDeclaration(node, name, lex, privateEnv, isStatic2, isValid, previousInfo);
        }
        function createHoistedVariableForClass(name, node, suffix) {
            const { className } = getPrivateIdentifierEnvironment().data;
            const prefix = className ? {
                prefix: "_",
                node: className,
                suffix: "_"
            } : "_";
            const identifier = typeof name === "object" ? factory2.getGeneratedNameForNode(name, 24 /* ReservedInNestedScopes */ , prefix, suffix) : typeof name === "string" ? factory2.createUniqueName(name, 16 /* Optimistic */ , prefix, suffix) : factory2.createTempVariable(/*recordTempVariable*/ void 0, /*reservedInNestedScopes*/ true, prefix, suffix);
            if (resolver.hasNodeCheckFlag(node, 32768 /* BlockScopedBindingInLoop */ )) addBlockScopedVariable(identifier);
            else hoistVariableDeclaration(identifier);
            return identifier;
        }
        function createHoistedVariableForPrivateName(name, suffix) {
            const text = tryGetTextOfPropertyName(name);
            var _ref;
            return createHoistedVariableForClass((_ref = text == null ? void 0 : text.substring(1)) !== null && _ref !== void 0 ? _ref : name, name, suffix);
        }
        function accessPrivateIdentifier2(name) {
            const info = accessPrivateIdentifier(lexicalEnvironment, name);
            return (info == null ? void 0 : info.kind) === "untransformed" ? void 0 : info;
        }
        function wrapPrivateIdentifierForDestructuringTarget(node) {
            const parameter = factory2.getGeneratedNameForNode(node);
            const info = accessPrivateIdentifier2(node.name);
            if (!info) return visitEachChild(node, visitor, context);
            let receiver = node.expression;
            if (isThisProperty(node) || isSuperProperty(node) || !isSimpleCopiableExpression(node.expression)) {
                receiver = factory2.createTempVariable(hoistVariableDeclaration, /*reservedInNestedScopes*/ true);
                getPendingExpressions().push(factory2.createBinaryExpression(receiver, 64 /* EqualsToken */ , visitNode(node.expression, visitor, isExpression)));
            }
            return factory2.createAssignmentTargetWrapper(parameter, createPrivateIdentifierAssignment(info, receiver, parameter, 64 /* EqualsToken */ ));
        }
        function visitDestructuringAssignmentTarget(node) {
            if (isObjectLiteralExpression(node) || isArrayLiteralExpression(node)) return visitAssignmentPattern(node);
            if (isPrivateIdentifierPropertyAccessExpression(node)) return wrapPrivateIdentifierForDestructuringTarget(node);
            else if (shouldTransformSuperInStaticInitializers && currentClassElement && isSuperProperty(node) && isStaticPropertyDeclarationOrClassStaticBlock(currentClassElement) && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data)) {
                const { classConstructor, superClassReference, facts } = lexicalEnvironment.data;
                if (facts & 1 /* ClassWasDecorated */ ) return visitInvalidSuperProperty(node);
                else if (classConstructor && superClassReference) {
                    const name = isElementAccessExpression(node) ? visitNode(node.argumentExpression, visitor, isExpression) : isIdentifier(node.name) ? factory2.createStringLiteralFromNode(node.name) : void 0;
                    if (name) {
                        const temp = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                        return factory2.createAssignmentTargetWrapper(temp, factory2.createReflectSetCall(superClassReference, name, temp, classConstructor));
                    }
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentElement(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
                const left = visitDestructuringAssignmentTarget(node.left);
                const right = visitNode(node.right, visitor, isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            return visitDestructuringAssignmentTarget(node);
        }
        function visitAssignmentRestElement(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadElement(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitArrayAssignmentElement(node) {
            if (isArrayBindingOrAssignmentElement(node)) {
                if (isSpreadElement(node)) return visitAssignmentRestElement(node);
                if (!isOmittedExpression(node)) return visitAssignmentElement(node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentProperty(node) {
            const name = visitNode(node.name, visitor, isPropertyName);
            if (isAssignmentExpression(node.initializer, /*excludeCompoundAssignment*/ true)) {
                const assignmentElement = visitAssignmentElement(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            if (isLeftHandSideExpression(node.initializer)) {
                const assignmentElement = visitDestructuringAssignmentTarget(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitShorthandAssignmentProperty(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentRestProperty(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadAssignment(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitObjectAssignmentElement(node) {
            Debug.assertNode(node, isObjectBindingOrAssignmentElement);
            if (isSpreadAssignment(node)) return visitAssignmentRestProperty(node);
            if (isShorthandPropertyAssignment(node)) return visitShorthandAssignmentProperty(node);
            if (isPropertyAssignment(node)) return visitAssignmentProperty(node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentPattern(node) {
            if (isArrayLiteralExpression(node)) return factory2.updateArrayLiteralExpression(node, visitNodes2(node.elements, visitArrayAssignmentElement, isExpression));
            else return factory2.updateObjectLiteralExpression(node, visitNodes2(node.properties, visitObjectAssignmentElement, isObjectLiteralElementLike));
        }
        function onEmitNode(hint, node, emitCallback) {
            const original = getOriginalNode(node);
            const lex = lexicalEnvironmentMap.get(original);
            if (lex) {
                const savedLexicalEnvironment = lexicalEnvironment;
                const savedPreviousShouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                lexicalEnvironment = lex;
                previousShouldSubstituteThisWithClassThis = shouldSubstituteThisWithClassThis;
                shouldSubstituteThisWithClassThis = !isClassStaticBlockDeclaration(original) || !(getInternalEmitFlags(original) & 32 /* TransformPrivateStaticElements */ );
                previousOnEmitNode(hint, node, emitCallback);
                shouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                previousShouldSubstituteThisWithClassThis = savedPreviousShouldSubstituteThisWithClassThis;
                lexicalEnvironment = savedLexicalEnvironment;
                return;
            }
            switch(node.kind){
                case 219 /* FunctionExpression */ :
                    if (isArrowFunction(original) || getEmitFlags(node) & 524288 /* AsyncFunctionBody */ ) break;
                // falls through
                case 263 /* FunctionDeclaration */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 175 /* MethodDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                    {
                        const savedLexicalEnvironment = lexicalEnvironment;
                        const savedPreviousShouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                        lexicalEnvironment = void 0;
                        previousShouldSubstituteThisWithClassThis = shouldSubstituteThisWithClassThis;
                        shouldSubstituteThisWithClassThis = false;
                        previousOnEmitNode(hint, node, emitCallback);
                        shouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                        previousShouldSubstituteThisWithClassThis = savedPreviousShouldSubstituteThisWithClassThis;
                        lexicalEnvironment = savedLexicalEnvironment;
                        return;
                    }
                case 168 /* ComputedPropertyName */ :
                    {
                        const savedLexicalEnvironment = lexicalEnvironment;
                        const savedShouldSubstituteThisWithClassThis = shouldSubstituteThisWithClassThis;
                        lexicalEnvironment = lexicalEnvironment == null ? void 0 : lexicalEnvironment.previous;
                        shouldSubstituteThisWithClassThis = previousShouldSubstituteThisWithClassThis;
                        previousOnEmitNode(hint, node, emitCallback);
                        shouldSubstituteThisWithClassThis = savedShouldSubstituteThisWithClassThis;
                        lexicalEnvironment = savedLexicalEnvironment;
                        return;
                    }
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 110 /* ThisKeyword */ :
                    return substituteThisExpression(node);
            }
            return node;
        }
        function substituteThisExpression(node) {
            if (enabledSubstitutions & 2 /* ClassStaticThisOrSuperReference */  && (lexicalEnvironment == null ? void 0 : lexicalEnvironment.data) && !noSubstitution.has(node)) {
                const { facts, classConstructor, classThis } = lexicalEnvironment.data;
                const substituteThis = shouldSubstituteThisWithClassThis ? classThis !== null && classThis !== void 0 ? classThis : classConstructor : classConstructor;
                if (substituteThis) return setTextRange(setOriginalNode(factory2.cloneNode(substituteThis), node), node);
                if (facts & 1 /* ClassWasDecorated */  && legacyDecorators) return factory2.createParenthesizedExpression(factory2.createVoidZero());
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            return trySubstituteClassAlias(node) || node;
        }
        function trySubstituteClassAlias(node) {
            if (enabledSubstitutions & 1 /* ClassAliases */ ) {
                if (resolver.hasNodeCheckFlag(node, 536870912 /* ConstructorReference */ )) {
                    const declaration = resolver.getReferencedValueDeclaration(node);
                    if (declaration) {
                        const classAlias = classAliases[declaration.id];
                        if (classAlias) {
                            const clone2 = factory2.cloneNode(classAlias);
                            setSourceMapRange(clone2, node);
                            setCommentRange(clone2, node);
                            return clone2;
                        }
                    }
                }
            }
            return void 0;
        }
    }
    function createPrivateStaticFieldInitializer(factory2, variableName, initializer) {
        return factory2.createAssignment(variableName, factory2.createObjectLiteralExpression([
            factory2.createPropertyAssignment("value", initializer || factory2.createVoidZero())
        ]));
    }
    function createPrivateInstanceFieldInitializer(factory2, receiver, initializer, weakMapName) {
        return factory2.createCallExpression(factory2.createPropertyAccessExpression(weakMapName, "set"), /*typeArguments*/ void 0, [
            receiver,
            initializer || factory2.createVoidZero()
        ]);
    }
    function createPrivateInstanceMethodInitializer(factory2, receiver, weakSetName) {
        return factory2.createCallExpression(factory2.createPropertyAccessExpression(weakSetName, "add"), /*typeArguments*/ void 0, [
            receiver
        ]);
    }
    function isReservedPrivateName(node) {
        return !isGeneratedPrivateIdentifier(node) && node.escapedText === "#constructor";
    }
    function isPrivateIdentifierInExpression(node) {
        return isPrivateIdentifier(node.left) && node.operatorToken.kind === 103 /* InKeyword */ ;
    }
    function isStaticPropertyDeclaration2(node) {
        return isPropertyDeclaration(node) && hasStaticModifier(node);
    }
    function isStaticPropertyDeclarationOrClassStaticBlock(node) {
        return isClassStaticBlockDeclaration(node) || isStaticPropertyDeclaration2(node);
    }
    // src/compiler/transformers/typeSerializer.ts
    function createRuntimeTypeSerializer(context) {
        const { factory: factory2, hoistVariableDeclaration } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const strictNullChecks = getStrictOptionValue(compilerOptions, "strictNullChecks");
        let currentLexicalScope;
        let currentNameScope;
        return {
            serializeTypeNode: (serializerContext, node)=>setSerializerContextAnd(serializerContext, serializeTypeNode, node),
            serializeTypeOfNode: (serializerContext, node, container)=>setSerializerContextAnd(serializerContext, serializeTypeOfNode, node, container),
            serializeParameterTypesOfNode: (serializerContext, node, container)=>setSerializerContextAnd(serializerContext, serializeParameterTypesOfNode, node, container),
            serializeReturnTypeOfNode: (serializerContext, node)=>setSerializerContextAnd(serializerContext, serializeReturnTypeOfNode, node)
        };
        function setSerializerContextAnd(serializerContext, cb, node, arg) {
            const savedCurrentLexicalScope = currentLexicalScope;
            const savedCurrentNameScope = currentNameScope;
            currentLexicalScope = serializerContext.currentLexicalScope;
            currentNameScope = serializerContext.currentNameScope;
            const result = arg === void 0 ? cb(node) : cb(node, arg);
            currentLexicalScope = savedCurrentLexicalScope;
            currentNameScope = savedCurrentNameScope;
            return result;
        }
        function getAccessorTypeNode(node, container) {
            const accessors = getAllAccessorDeclarations(container.members, node);
            return accessors.setAccessor && getSetAccessorTypeAnnotationNode(accessors.setAccessor) || accessors.getAccessor && getEffectiveReturnTypeNode(accessors.getAccessor);
        }
        function serializeTypeOfNode(node, container) {
            switch(node.kind){
                case 173 /* PropertyDeclaration */ :
                case 170 /* Parameter */ :
                    return serializeTypeNode(node.type);
                case 179 /* SetAccessor */ :
                case 178 /* GetAccessor */ :
                    return serializeTypeNode(getAccessorTypeNode(node, container));
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                case 175 /* MethodDeclaration */ :
                    return factory2.createIdentifier("Function");
                default:
                    return factory2.createVoidZero();
            }
        }
        function serializeParameterTypesOfNode(node, container) {
            const valueDeclaration = isClassLike(node) ? getFirstConstructorWithBody(node) : isFunctionLike(node) && nodeIsPresent(node.body) ? node : void 0;
            const expressions = [];
            if (valueDeclaration) {
                const parameters = getParametersOfDecoratedDeclaration(valueDeclaration, container);
                const numParameters = parameters.length;
                for(let i = 0; i < numParameters; i++){
                    const parameter = parameters[i];
                    if (i === 0 && isIdentifier(parameter.name) && parameter.name.escapedText === "this") continue;
                    if (parameter.dotDotDotToken) expressions.push(serializeTypeNode(getRestParameterElementType(parameter.type)));
                    else expressions.push(serializeTypeOfNode(parameter, container));
                }
            }
            return factory2.createArrayLiteralExpression(expressions);
        }
        function getParametersOfDecoratedDeclaration(node, container) {
            if (container && node.kind === 178 /* GetAccessor */ ) {
                const { setAccessor } = getAllAccessorDeclarations(container.members, node);
                if (setAccessor) return setAccessor.parameters;
            }
            return node.parameters;
        }
        function serializeReturnTypeOfNode(node) {
            if (isFunctionLike(node) && node.type) return serializeTypeNode(node.type);
            else if (isAsyncFunction(node)) return factory2.createIdentifier("Promise");
            return factory2.createVoidZero();
        }
        function serializeTypeNode(node) {
            if (node === void 0) return factory2.createIdentifier("Object");
            node = skipTypeParentheses(node);
            switch(node.kind){
                case 116 /* VoidKeyword */ :
                case 157 /* UndefinedKeyword */ :
                case 146 /* NeverKeyword */ :
                    return factory2.createVoidZero();
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                    return factory2.createIdentifier("Function");
                case 189 /* ArrayType */ :
                case 190 /* TupleType */ :
                    return factory2.createIdentifier("Array");
                case 183 /* TypePredicate */ :
                    return node.assertsModifier ? factory2.createVoidZero() : factory2.createIdentifier("Boolean");
                case 136 /* BooleanKeyword */ :
                    return factory2.createIdentifier("Boolean");
                case 204 /* TemplateLiteralType */ :
                case 154 /* StringKeyword */ :
                    return factory2.createIdentifier("String");
                case 151 /* ObjectKeyword */ :
                    return factory2.createIdentifier("Object");
                case 202 /* LiteralType */ :
                    return serializeLiteralOfLiteralTypeNode(node.literal);
                case 150 /* NumberKeyword */ :
                    return factory2.createIdentifier("Number");
                case 163 /* BigIntKeyword */ :
                    return getGlobalConstructor("BigInt", 7 /* ES2020 */ );
                case 155 /* SymbolKeyword */ :
                    return getGlobalConstructor("Symbol", 2 /* ES2015 */ );
                case 184 /* TypeReference */ :
                    return serializeTypeReferenceNode(node);
                case 194 /* IntersectionType */ :
                    return serializeUnionOrIntersectionConstituents(node.types, /*isIntersection*/ true);
                case 193 /* UnionType */ :
                    return serializeUnionOrIntersectionConstituents(node.types, /*isIntersection*/ false);
                case 195 /* ConditionalType */ :
                    return serializeUnionOrIntersectionConstituents([
                        node.trueType,
                        node.falseType
                    ], /*isIntersection*/ false);
                case 199 /* TypeOperator */ :
                    if (node.operator === 148 /* ReadonlyKeyword */ ) return serializeTypeNode(node.type);
                    break;
                case 187 /* TypeQuery */ :
                case 200 /* IndexedAccessType */ :
                case 201 /* MappedType */ :
                case 188 /* TypeLiteral */ :
                case 133 /* AnyKeyword */ :
                case 159 /* UnknownKeyword */ :
                case 198 /* ThisType */ :
                case 206 /* ImportType */ :
                    break;
                // handle JSDoc types from an invalid parse
                case 313 /* JSDocAllType */ :
                case 314 /* JSDocUnknownType */ :
                case 318 /* JSDocFunctionType */ :
                case 319 /* JSDocVariadicType */ :
                case 320 /* JSDocNamepathType */ :
                    break;
                case 315 /* JSDocNullableType */ :
                case 316 /* JSDocNonNullableType */ :
                case 317 /* JSDocOptionalType */ :
                    return serializeTypeNode(node.type);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
            return factory2.createIdentifier("Object");
        }
        function serializeLiteralOfLiteralTypeNode(node) {
            switch(node.kind){
                case 11 /* StringLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return factory2.createIdentifier("String");
                case 225 /* PrefixUnaryExpression */ :
                    {
                        const operand = node.operand;
                        switch(operand.kind){
                            case 9 /* NumericLiteral */ :
                            case 10 /* BigIntLiteral */ :
                                return serializeLiteralOfLiteralTypeNode(operand);
                            default:
                                return Debug.failBadSyntaxKind(operand);
                        }
                    }
                case 9 /* NumericLiteral */ :
                    return factory2.createIdentifier("Number");
                case 10 /* BigIntLiteral */ :
                    return getGlobalConstructor("BigInt", 7 /* ES2020 */ );
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                    return factory2.createIdentifier("Boolean");
                case 106 /* NullKeyword */ :
                    return factory2.createVoidZero();
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function serializeUnionOrIntersectionConstituents(types, isIntersection) {
            let serializedType;
            for (let typeNode of types){
                typeNode = skipTypeParentheses(typeNode);
                if (typeNode.kind === 146 /* NeverKeyword */ ) {
                    if (isIntersection) return factory2.createVoidZero();
                    continue;
                }
                if (typeNode.kind === 159 /* UnknownKeyword */ ) {
                    if (!isIntersection) return factory2.createIdentifier("Object");
                    continue;
                }
                if (typeNode.kind === 133 /* AnyKeyword */ ) return factory2.createIdentifier("Object");
                if (!strictNullChecks && (isLiteralTypeNode(typeNode) && typeNode.literal.kind === 106 /* NullKeyword */  || typeNode.kind === 157 /* UndefinedKeyword */ )) continue;
                const serializedConstituent = serializeTypeNode(typeNode);
                if (isIdentifier(serializedConstituent) && serializedConstituent.escapedText === "Object") return serializedConstituent;
                if (serializedType) {
                    if (!equateSerializedTypeNodes(serializedType, serializedConstituent)) return factory2.createIdentifier("Object");
                } else serializedType = serializedConstituent;
            }
            return serializedType !== null && serializedType !== void 0 ? serializedType : factory2.createVoidZero();
        }
        function equateSerializedTypeNodes(left, right) {
            return(// temp vars used in fallback
            isGeneratedIdentifier(left) ? isGeneratedIdentifier(right) : // entity names
            isIdentifier(left) ? isIdentifier(right) && left.escapedText === right.escapedText : isPropertyAccessExpression(left) ? isPropertyAccessExpression(right) && equateSerializedTypeNodes(left.expression, right.expression) && equateSerializedTypeNodes(left.name, right.name) : // `void 0`
            isVoidExpression(left) ? isVoidExpression(right) && isNumericLiteral(left.expression) && left.expression.text === "0" && isNumericLiteral(right.expression) && right.expression.text === "0" : // `"undefined"` or `"function"` in `typeof` checks
            isStringLiteral(left) ? isStringLiteral(right) && left.text === right.text : // used in `typeof` checks for fallback
            isTypeOfExpression(left) ? isTypeOfExpression(right) && equateSerializedTypeNodes(left.expression, right.expression) : // parens in `typeof` checks with temps
            isParenthesizedExpression(left) ? isParenthesizedExpression(right) && equateSerializedTypeNodes(left.expression, right.expression) : // conditionals used in fallback
            isConditionalExpression(left) ? isConditionalExpression(right) && equateSerializedTypeNodes(left.condition, right.condition) && equateSerializedTypeNodes(left.whenTrue, right.whenTrue) && equateSerializedTypeNodes(left.whenFalse, right.whenFalse) : // logical binary and assignments used in fallback
            isBinaryExpression(left) ? isBinaryExpression(right) && left.operatorToken.kind === right.operatorToken.kind && equateSerializedTypeNodes(left.left, right.left) && equateSerializedTypeNodes(left.right, right.right) : false);
        }
        function serializeTypeReferenceNode(node) {
            const kind = resolver.getTypeReferenceSerializationKind(node.typeName, currentNameScope !== null && currentNameScope !== void 0 ? currentNameScope : currentLexicalScope);
            switch(kind){
                case 0 /* Unknown */ :
                    if (findAncestor(node, (n)=>n.parent && isConditionalTypeNode(n.parent) && (n.parent.trueType === n || n.parent.falseType === n))) return factory2.createIdentifier("Object");
                    const serialized = serializeEntityNameAsExpressionFallback(node.typeName);
                    const temp = factory2.createTempVariable(hoistVariableDeclaration);
                    return factory2.createConditionalExpression(factory2.createTypeCheck(factory2.createAssignment(temp, serialized), "function"), /*questionToken*/ void 0, temp, /*colonToken*/ void 0, factory2.createIdentifier("Object"));
                case 1 /* TypeWithConstructSignatureAndValue */ :
                    return serializeEntityNameAsExpression(node.typeName);
                case 2 /* VoidNullableOrNeverType */ :
                    return factory2.createVoidZero();
                case 4 /* BigIntLikeType */ :
                    return getGlobalConstructor("BigInt", 7 /* ES2020 */ );
                case 6 /* BooleanType */ :
                    return factory2.createIdentifier("Boolean");
                case 3 /* NumberLikeType */ :
                    return factory2.createIdentifier("Number");
                case 5 /* StringLikeType */ :
                    return factory2.createIdentifier("String");
                case 7 /* ArrayLikeType */ :
                    return factory2.createIdentifier("Array");
                case 8 /* ESSymbolType */ :
                    return getGlobalConstructor("Symbol", 2 /* ES2015 */ );
                case 10 /* TypeWithCallSignature */ :
                    return factory2.createIdentifier("Function");
                case 9 /* Promise */ :
                    return factory2.createIdentifier("Promise");
                case 11 /* ObjectType */ :
                    return factory2.createIdentifier("Object");
                default:
                    return Debug.assertNever(kind);
            }
        }
        function createCheckedValue(left, right) {
            return factory2.createLogicalAnd(factory2.createStrictInequality(factory2.createTypeOfExpression(left), factory2.createStringLiteral("undefined")), right);
        }
        function serializeEntityNameAsExpressionFallback(node) {
            if (node.kind === 80 /* Identifier */ ) {
                const copied = serializeEntityNameAsExpression(node);
                return createCheckedValue(copied, copied);
            }
            if (node.left.kind === 80 /* Identifier */ ) return createCheckedValue(serializeEntityNameAsExpression(node.left), serializeEntityNameAsExpression(node));
            const left = serializeEntityNameAsExpressionFallback(node.left);
            const temp = factory2.createTempVariable(hoistVariableDeclaration);
            return factory2.createLogicalAnd(factory2.createLogicalAnd(left.left, factory2.createStrictInequality(factory2.createAssignment(temp, left.right), factory2.createVoidZero())), factory2.createPropertyAccessExpression(temp, node.right));
        }
        function serializeEntityNameAsExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    const name = setParent(setTextRange(parseNodeFactory.cloneNode(node), node), node.parent);
                    name.original = void 0;
                    setParent(name, getParseTreeNode(currentLexicalScope));
                    return name;
                case 167 /* QualifiedName */ :
                    return serializeQualifiedNameAsExpression(node);
            }
        }
        function serializeQualifiedNameAsExpression(node) {
            return factory2.createPropertyAccessExpression(serializeEntityNameAsExpression(node.left), node.right);
        }
        function getGlobalConstructorWithFallback(name) {
            return factory2.createConditionalExpression(factory2.createTypeCheck(factory2.createIdentifier(name), "function"), /*questionToken*/ void 0, factory2.createIdentifier(name), /*colonToken*/ void 0, factory2.createIdentifier("Object"));
        }
        function getGlobalConstructor(name, minLanguageVersion) {
            return languageVersion < minLanguageVersion ? getGlobalConstructorWithFallback(name) : factory2.createIdentifier(name);
        }
    }
    // src/compiler/transformers/legacyDecorators.ts
    function transformLegacyDecorators(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, hoistVariableDeclaration } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        let classAliases;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function modifierVisitor(node) {
            return isDecorator(node) ? void 0 : node;
        }
        function visitor(node) {
            if (!(node.transformFlags & 33554432 /* ContainsDecorators */ )) return node;
            switch(node.kind){
                case 171 /* Decorator */ :
                    return void 0;
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 232 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 177 /* Constructor */ :
                    return visitConstructorDeclaration(node);
                case 175 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node);
                case 179 /* SetAccessor */ :
                    return visitSetAccessorDeclaration(node);
                case 178 /* GetAccessor */ :
                    return visitGetAccessorDeclaration(node);
                case 173 /* PropertyDeclaration */ :
                    return visitPropertyDeclaration(node);
                case 170 /* Parameter */ :
                    return visitParameterDeclaration(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitClassDeclaration(node) {
            if (!(classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ true, node) || childIsDecorated(/*useLegacyDecorators*/ true, node))) return visitEachChild(node, visitor, context);
            const statements = classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ true, node) ? transformClassDeclarationWithClassDecorators(node, node.name) : transformClassDeclarationWithoutClassDecorators(node, node.name);
            return singleOrMany(statements);
        }
        function decoratorContainsPrivateIdentifierInExpression(decorator) {
            return !!(decorator.transformFlags & 536870912 /* ContainsPrivateIdentifierInExpression */ );
        }
        function parameterDecoratorsContainPrivateIdentifierInExpression(parameterDecorators) {
            return some(parameterDecorators, decoratorContainsPrivateIdentifierInExpression);
        }
        function hasClassElementWithDecoratorContainingPrivateIdentifierInExpression(node) {
            for (const member of node.members){
                if (!canHaveDecorators(member)) continue;
                const allDecorators = getAllDecoratorsOfClassElement(member, node, /*useLegacyDecorators*/ true);
                if (some(allDecorators == null ? void 0 : allDecorators.decorators, decoratorContainsPrivateIdentifierInExpression)) return true;
                if (some(allDecorators == null ? void 0 : allDecorators.parameters, parameterDecoratorsContainPrivateIdentifierInExpression)) return true;
            }
            return false;
        }
        function transformDecoratorsOfClassElements(node, members) {
            let decorationStatements = [];
            addClassElementDecorationStatements(decorationStatements, node, /*isStatic*/ false);
            addClassElementDecorationStatements(decorationStatements, node, /*isStatic*/ true);
            if (hasClassElementWithDecoratorContainingPrivateIdentifierInExpression(node)) {
                members = setTextRange(factory2.createNodeArray([
                    ...members,
                    factory2.createClassStaticBlockDeclaration(factory2.createBlock(decorationStatements, /*multiLine*/ true))
                ]), members);
                decorationStatements = void 0;
            }
            return {
                decorationStatements,
                members
            };
        }
        function transformClassDeclarationWithoutClassDecorators(node, name) {
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
            let members = visitNodes2(node.members, visitor, isClassElement);
            let decorationStatements = [];
            ({ members, decorationStatements } = transformDecoratorsOfClassElements(node, members));
            const updated = factory2.updateClassDeclaration(node, modifiers, name, /*typeParameters*/ void 0, heritageClauses, members);
            return addRange([
                updated
            ], decorationStatements);
        }
        function transformClassDeclarationWithClassDecorators(node, name) {
            const isExport = hasSyntacticModifier(node, 32 /* Export */ );
            const isDefault = hasSyntacticModifier(node, 2048 /* Default */ );
            const modifiers = visitNodes2(node.modifiers, (node2)=>isExportOrDefaultModifier(node2) || isDecorator(node2) ? void 0 : node2, isModifierLike);
            const location = moveRangePastModifiers(node);
            const classAlias = getClassAliasIfNeeded(node);
            const declName = languageVersion < 2 /* ES2015 */  ? factory2.getInternalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
            let members = visitNodes2(node.members, visitor, isClassElement);
            let decorationStatements = [];
            ({ members, decorationStatements } = transformDecoratorsOfClassElements(node, members));
            const assignClassAliasInStaticBlock = languageVersion >= 9 /* ES2022 */  && !!classAlias && some(members, (member)=>isPropertyDeclaration(member) && hasSyntacticModifier(member, 256 /* Static */ ) || isClassStaticBlockDeclaration(member));
            if (assignClassAliasInStaticBlock) members = setTextRange(factory2.createNodeArray([
                factory2.createClassStaticBlockDeclaration(factory2.createBlock([
                    factory2.createExpressionStatement(factory2.createAssignment(classAlias, factory2.createThis()))
                ])),
                ...members
            ]), members);
            const classExpression = factory2.createClassExpression(modifiers, name && isGeneratedIdentifier(name) ? void 0 : name, /*typeParameters*/ void 0, heritageClauses, members);
            setOriginalNode(classExpression, node);
            setTextRange(classExpression, location);
            const varInitializer = classAlias && !assignClassAliasInStaticBlock ? factory2.createAssignment(classAlias, classExpression) : classExpression;
            const varDecl = factory2.createVariableDeclaration(declName, /*exclamationToken*/ void 0, /*type*/ void 0, varInitializer);
            setOriginalNode(varDecl, node);
            const varDeclList = factory2.createVariableDeclarationList([
                varDecl
            ], 1 /* Let */ );
            const varStatement = factory2.createVariableStatement(/*modifiers*/ void 0, varDeclList);
            setOriginalNode(varStatement, node);
            setTextRange(varStatement, location);
            setCommentRange(varStatement, node);
            const statements = [
                varStatement
            ];
            addRange(statements, decorationStatements);
            addConstructorDecorationStatement(statements, node);
            if (isExport) {
                if (isDefault) {
                    const exportStatement = factory2.createExportDefault(declName);
                    statements.push(exportStatement);
                } else {
                    const exportStatement = factory2.createExternalModuleExport(factory2.getDeclarationName(node));
                    statements.push(exportStatement);
                }
            }
            return statements;
        }
        function visitClassExpression(node) {
            return factory2.updateClassExpression(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, visitor, isClassElement));
        }
        function visitConstructorDeclaration(node) {
            return factory2.updateConstructorDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock));
        }
        function finishClassElement(updated, original) {
            if (updated !== original) {
                setCommentRange(updated, original);
                setSourceMapRange(updated, moveRangePastModifiers(original));
            }
            return updated;
        }
        function visitMethodDeclaration(node) {
            return finishClassElement(factory2.updateMethodDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), /*questionToken*/ void 0, /*typeParameters*/ void 0, visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitNode(node.body, visitor, isBlock)), node);
        }
        function visitGetAccessorDeclaration(node) {
            return finishClassElement(factory2.updateGetAccessorDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitNode(node.body, visitor, isBlock)), node);
        }
        function visitSetAccessorDeclaration(node) {
            return finishClassElement(factory2.updateSetAccessorDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock)), node);
        }
        function visitPropertyDeclaration(node) {
            if (node.flags & 33554432 /* Ambient */  || hasSyntacticModifier(node, 128 /* Ambient */ )) return void 0;
            return finishClassElement(factory2.updatePropertyDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifier), Debug.checkDefined(visitNode(node.name, visitor, isPropertyName)), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression)), node);
        }
        function visitParameterDeclaration(node) {
            const updated = factory2.updateParameterDeclaration(node, elideNodes(factory2, node.modifiers), node.dotDotDotToken, Debug.checkDefined(visitNode(node.name, visitor, isBindingName)), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (updated !== node) {
                setCommentRange(updated, node);
                setTextRange(updated, moveRangePastModifiers(node));
                setSourceMapRange(updated, moveRangePastModifiers(node));
                setEmitFlags(updated.name, 64 /* NoTrailingSourceMap */ );
            }
            return updated;
        }
        function isSyntheticMetadataDecorator(node) {
            return isCallToHelper(node.expression, "___metadata");
        }
        function transformAllDecoratorsOfDeclaration(allDecorators) {
            if (!allDecorators) return void 0;
            const { false: decorators, true: metadata } = groupBy(allDecorators.decorators, isSyntheticMetadataDecorator);
            const decoratorExpressions = [];
            addRange(decoratorExpressions, map(decorators, transformDecorator));
            addRange(decoratorExpressions, flatMap(allDecorators.parameters, transformDecoratorsOfParameter));
            addRange(decoratorExpressions, map(metadata, transformDecorator));
            return decoratorExpressions;
        }
        function addClassElementDecorationStatements(statements, node, isStatic2) {
            addRange(statements, map(generateClassElementDecorationExpressions(node, isStatic2), (expr)=>factory2.createExpressionStatement(expr)));
        }
        function isDecoratedClassElement(member, isStaticElement, parent2) {
            return nodeOrChildIsDecorated(/*useLegacyDecorators*/ true, member, parent2) && isStaticElement === isStatic(member);
        }
        function getDecoratedClassElements(node, isStatic2) {
            return filter(node.members, (m)=>isDecoratedClassElement(m, isStatic2, node));
        }
        function generateClassElementDecorationExpressions(node, isStatic2) {
            const members = getDecoratedClassElements(node, isStatic2);
            let expressions;
            for (const member of members)expressions = append(expressions, generateClassElementDecorationExpression(node, member));
            return expressions;
        }
        function generateClassElementDecorationExpression(node, member) {
            const allDecorators = getAllDecoratorsOfClassElement(member, node, /*useLegacyDecorators*/ true);
            const decoratorExpressions = transformAllDecoratorsOfDeclaration(allDecorators);
            if (!decoratorExpressions) return void 0;
            const prefix = getClassMemberPrefix(node, member);
            const memberName = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ !hasSyntacticModifier(member, 128 /* Ambient */ ));
            const descriptor = isPropertyDeclaration(member) && !hasAccessorModifier(member) ? factory2.createVoidZero() : factory2.createNull();
            const helper = emitHelpers().createDecorateHelper(decoratorExpressions, prefix, memberName, descriptor);
            setEmitFlags(helper, 3072 /* NoComments */ );
            setSourceMapRange(helper, moveRangePastModifiers(member));
            return helper;
        }
        function addConstructorDecorationStatement(statements, node) {
            const expression = generateConstructorDecorationExpression(node);
            if (expression) statements.push(setOriginalNode(factory2.createExpressionStatement(expression), node));
        }
        function generateConstructorDecorationExpression(node) {
            const allDecorators = getAllDecoratorsOfClass(node, /*useLegacyDecorators*/ true);
            const decoratorExpressions = transformAllDecoratorsOfDeclaration(allDecorators);
            if (!decoratorExpressions) return void 0;
            const classAlias = classAliases && classAliases[getOriginalNodeId(node)];
            const localName = languageVersion < 2 /* ES2015 */  ? factory2.getInternalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true) : factory2.getDeclarationName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
            const decorate = emitHelpers().createDecorateHelper(decoratorExpressions, localName);
            const expression = factory2.createAssignment(localName, classAlias ? factory2.createAssignment(classAlias, decorate) : decorate);
            setEmitFlags(expression, 3072 /* NoComments */ );
            setSourceMapRange(expression, moveRangePastModifiers(node));
            return expression;
        }
        function transformDecorator(decorator) {
            return Debug.checkDefined(visitNode(decorator.expression, visitor, isExpression));
        }
        function transformDecoratorsOfParameter(decorators, parameterOffset) {
            let expressions;
            if (decorators) {
                expressions = [];
                for (const decorator of decorators){
                    const helper = emitHelpers().createParamHelper(transformDecorator(decorator), parameterOffset);
                    setTextRange(helper, decorator.expression);
                    setEmitFlags(helper, 3072 /* NoComments */ );
                    expressions.push(helper);
                }
            }
            return expressions;
        }
        function getExpressionForPropertyName(member, generateNameForComputedPropertyName) {
            const name = member.name;
            if (isPrivateIdentifier(name)) return factory2.createIdentifier("");
            else if (isComputedPropertyName(name)) return generateNameForComputedPropertyName && !isSimpleInlineableExpression(name.expression) ? factory2.getGeneratedNameForNode(name) : name.expression;
            else if (isIdentifier(name)) return factory2.createStringLiteral(idText(name));
            else return factory2.cloneNode(name);
        }
        function enableSubstitutionForClassAliases() {
            if (!classAliases) {
                context.enableSubstitution(80 /* Identifier */ );
                classAliases = [];
            }
        }
        function getClassAliasIfNeeded(node) {
            if (resolver.hasNodeCheckFlag(node, 262144 /* ContainsConstructorReference */ )) {
                enableSubstitutionForClassAliases();
                const classAlias = factory2.createUniqueName(node.name && !isGeneratedIdentifier(node.name) ? idText(node.name) : "default");
                classAliases[getOriginalNodeId(node)] = classAlias;
                hoistVariableDeclaration(classAlias);
                return classAlias;
            }
        }
        function getClassPrototype(node) {
            return factory2.createPropertyAccessExpression(factory2.getDeclarationName(node), "prototype");
        }
        function getClassMemberPrefix(node, member) {
            return isStatic(member) ? factory2.getDeclarationName(node) : getClassPrototype(node);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            var _trySubstituteClassAlias;
            return (_trySubstituteClassAlias = trySubstituteClassAlias(node)) !== null && _trySubstituteClassAlias !== void 0 ? _trySubstituteClassAlias : node;
        }
        function trySubstituteClassAlias(node) {
            if (classAliases) {
                if (resolver.hasNodeCheckFlag(node, 536870912 /* ConstructorReference */ )) {
                    const declaration = resolver.getReferencedValueDeclaration(node);
                    if (declaration) {
                        const classAlias = classAliases[declaration.id];
                        if (classAlias) {
                            const clone2 = factory2.cloneNode(classAlias);
                            setSourceMapRange(clone2, node);
                            setCommentRange(clone2, node);
                            return clone2;
                        }
                    }
                }
            }
            return void 0;
        }
    }
    // src/compiler/transformers/esDecorators.ts
    function transformESDecorators(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, startLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const languageVersion = getEmitScriptTarget(context.getCompilerOptions());
        let top;
        let classInfo;
        let classThis;
        let classSuper;
        let pendingExpressions;
        let shouldTransformPrivateStaticElementsInFile;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            top = void 0;
            shouldTransformPrivateStaticElementsInFile = false;
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            if (shouldTransformPrivateStaticElementsInFile) {
                addInternalEmitFlags(visited, 32 /* TransformPrivateStaticElements */ );
                shouldTransformPrivateStaticElementsInFile = false;
            }
            return visited;
        }
        function updateState() {
            classInfo = void 0;
            classThis = void 0;
            classSuper = void 0;
            switch(top == null ? void 0 : top.kind){
                case "class":
                    classInfo = top.classInfo;
                    break;
                case "class-element":
                    classInfo = top.next.classInfo;
                    classThis = top.classThis;
                    classSuper = top.classSuper;
                    break;
                case "name":
                    const grandparent = top.next.next.next;
                    if ((grandparent == null ? void 0 : grandparent.kind) === "class-element") {
                        classInfo = grandparent.next.classInfo;
                        classThis = grandparent.classThis;
                        classSuper = grandparent.classSuper;
                    }
                    break;
            }
        }
        function enterClass(classInfo2) {
            top = {
                kind: "class",
                next: top,
                classInfo: classInfo2,
                savedPendingExpressions: pendingExpressions
            };
            pendingExpressions = void 0;
            updateState();
        }
        function exitClass() {
            Debug.assert((top == null ? void 0 : top.kind) === "class", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class' but got '${top == null ? void 0 : top.kind}' instead.`);
            pendingExpressions = top.savedPendingExpressions;
            top = top.next;
            updateState();
        }
        function enterClassElement(node) {
            var _a, _b;
            Debug.assert((top == null ? void 0 : top.kind) === "class", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class' but got '${top == null ? void 0 : top.kind}' instead.`);
            top = {
                kind: "class-element",
                next: top
            };
            if (isClassStaticBlockDeclaration(node) || isPropertyDeclaration(node) && hasStaticModifier(node)) {
                top.classThis = (_a = top.next.classInfo) == null ? void 0 : _a.classThis;
                top.classSuper = (_b = top.next.classInfo) == null ? void 0 : _b.classSuper;
            }
            updateState();
        }
        function exitClassElement() {
            var _a;
            Debug.assert((top == null ? void 0 : top.kind) === "class-element", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class-element' but got '${top == null ? void 0 : top.kind}' instead.`);
            Debug.assert(((_a = top.next) == null ? void 0 : _a.kind) === "class", "Incorrect value for top.next.kind.", ()=>{
                var _a2;
                return `Expected top.next.kind to be 'class' but got '${(_a2 = top.next) == null ? void 0 : _a2.kind}' instead.`;
            });
            top = top.next;
            updateState();
        }
        function enterName() {
            Debug.assert((top == null ? void 0 : top.kind) === "class-element", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'class-element' but got '${top == null ? void 0 : top.kind}' instead.`);
            top = {
                kind: "name",
                next: top
            };
            updateState();
        }
        function exitName() {
            Debug.assert((top == null ? void 0 : top.kind) === "name", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'name' but got '${top == null ? void 0 : top.kind}' instead.`);
            top = top.next;
            updateState();
        }
        function enterOther() {
            if ((top == null ? void 0 : top.kind) === "other") {
                Debug.assert(!pendingExpressions);
                top.depth++;
            } else {
                top = {
                    kind: "other",
                    next: top,
                    depth: 0,
                    savedPendingExpressions: pendingExpressions
                };
                pendingExpressions = void 0;
                updateState();
            }
        }
        function exitOther() {
            Debug.assert((top == null ? void 0 : top.kind) === "other", "Incorrect value for top.kind.", ()=>`Expected top.kind to be 'other' but got '${top == null ? void 0 : top.kind}' instead.`);
            if (top.depth > 0) {
                Debug.assert(!pendingExpressions);
                top.depth--;
            } else {
                pendingExpressions = top.savedPendingExpressions;
                top = top.next;
                updateState();
            }
        }
        function shouldVisitNode(node) {
            return !!(node.transformFlags & 33554432 /* ContainsDecorators */ ) || !!classThis && !!(node.transformFlags & 16384 /* ContainsLexicalThis */ ) || !!classThis && !!classSuper && !!(node.transformFlags & 134217728 /* ContainsLexicalSuper */ );
        }
        function visitor(node) {
            if (!shouldVisitNode(node)) return node;
            switch(node.kind){
                case 171 /* Decorator */ :
                    return Debug.fail("Use `modifierVisitor` instead.");
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 232 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 177 /* Constructor */ :
                case 173 /* PropertyDeclaration */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    return Debug.fail("Not supported outside of a class. Use 'classElementVisitor' instead.");
                case 170 /* Parameter */ :
                    return visitParameterDeclaration(node);
                // Support NamedEvaluation to ensure the correct class name for class expressions.
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ false);
                case 304 /* PropertyAssignment */ :
                    return visitPropertyAssignment(node);
                case 261 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 209 /* BindingElement */ :
                    return visitBindingElement(node);
                case 278 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 110 /* ThisKeyword */ :
                    return visitThisExpression(node);
                case 249 /* ForStatement */ :
                    return visitForStatement(node);
                case 245 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 357 /* CommaListExpression */ :
                    return visitCommaListExpression(node, /*discarded*/ false);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ false);
                case 356 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, /*discarded*/ false);
                case 214 /* CallExpression */ :
                    return visitCallExpression(node);
                case 216 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ false);
                case 212 /* PropertyAccessExpression */ :
                    return visitPropertyAccessExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return visitElementAccessExpression(node);
                case 168 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                case 175 /* MethodDeclaration */ :
                // object literal methods and accessors
                case 179 /* SetAccessor */ :
                case 178 /* GetAccessor */ :
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                    {
                        enterOther();
                        const result = visitEachChild(node, fallbackVisitor, context);
                        exitOther();
                        return result;
                    }
                default:
                    return visitEachChild(node, fallbackVisitor, context);
            }
        }
        function fallbackVisitor(node) {
            switch(node.kind){
                case 171 /* Decorator */ :
                    return void 0;
                default:
                    return visitor(node);
            }
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 171 /* Decorator */ :
                    return void 0;
                default:
                    return node;
            }
        }
        function classElementVisitor(node) {
            switch(node.kind){
                case 177 /* Constructor */ :
                    return visitConstructorDeclaration(node);
                case 175 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node);
                case 178 /* GetAccessor */ :
                    return visitGetAccessorDeclaration(node);
                case 179 /* SetAccessor */ :
                    return visitSetAccessorDeclaration(node);
                case 173 /* PropertyDeclaration */ :
                    return visitPropertyDeclaration(node);
                case 176 /* ClassStaticBlockDeclaration */ :
                    return visitClassStaticBlockDeclaration(node);
                default:
                    return visitor(node);
            }
        }
        function discardedValueVisitor(node) {
            switch(node.kind){
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, /*discarded*/ true);
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node, /*discarded*/ true);
                case 357 /* CommaListExpression */ :
                    return visitCommaListExpression(node, /*discarded*/ true);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, /*discarded*/ true);
                default:
                    return visitor(node);
            }
        }
        function getHelperVariableName(node) {
            let declarationName = node.name && isIdentifier(node.name) && !isGeneratedIdentifier(node.name) ? idText(node.name) : node.name && isPrivateIdentifier(node.name) && !isGeneratedIdentifier(node.name) ? idText(node.name).slice(1) : node.name && isStringLiteral(node.name) && isIdentifierText(node.name.text, 99 /* ESNext */ ) ? node.name.text : isClassLike(node) ? "class" : "member";
            if (isGetAccessor(node)) declarationName = `get_${declarationName}`;
            if (isSetAccessor(node)) declarationName = `set_${declarationName}`;
            if (node.name && isPrivateIdentifier(node.name)) declarationName = `private_${declarationName}`;
            if (isStatic(node)) declarationName = `static_${declarationName}`;
            return "_" + declarationName;
        }
        function createHelperVariable(node, suffix) {
            return factory2.createUniqueName(`${getHelperVariableName(node)}_${suffix}`, 24 /* ReservedInNestedScopes */ );
        }
        function createLet(name, initializer) {
            return factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, initializer)
            ], 1 /* Let */ ));
        }
        function createClassInfo(node) {
            const metadataReference = factory2.createUniqueName("_metadata", 48 /* FileLevel */ );
            let instanceMethodExtraInitializersName;
            let staticMethodExtraInitializersName;
            let hasStaticInitializers = false;
            let hasNonAmbientInstanceFields = false;
            let hasStaticPrivateClassElements = false;
            let classThis2;
            let pendingStaticInitializers;
            let pendingInstanceInitializers;
            if (nodeIsDecorated(/*useLegacyDecorators*/ false, node)) {
                const needsUniqueClassThis = some(node.members, (member)=>(isPrivateIdentifierClassElementDeclaration(member) || isAutoAccessorPropertyDeclaration(member)) && hasStaticModifier(member));
                classThis2 = factory2.createUniqueName("_classThis", needsUniqueClassThis ? 24 /* ReservedInNestedScopes */  : 48 /* FileLevel */ );
            }
            for (const member of node.members){
                if (isMethodOrAccessor(member) && nodeOrChildIsDecorated(/*useLegacyDecorators*/ false, member, node)) {
                    if (hasStaticModifier(member)) {
                        if (!staticMethodExtraInitializersName) {
                            staticMethodExtraInitializersName = factory2.createUniqueName("_staticExtraInitializers", 48 /* FileLevel */ );
                            const initializer = emitHelpers().createRunInitializersHelper(classThis2 !== null && classThis2 !== void 0 ? classThis2 : factory2.createThis(), staticMethodExtraInitializersName);
                            var _node_name;
                            setSourceMapRange(initializer, (_node_name = node.name) !== null && _node_name !== void 0 ? _node_name : moveRangePastDecorators(node));
                            pendingStaticInitializers !== null && pendingStaticInitializers !== void 0 ? pendingStaticInitializers : pendingStaticInitializers = [];
                            pendingStaticInitializers.push(initializer);
                        }
                    } else {
                        if (!instanceMethodExtraInitializersName) {
                            instanceMethodExtraInitializersName = factory2.createUniqueName("_instanceExtraInitializers", 48 /* FileLevel */ );
                            const initializer = emitHelpers().createRunInitializersHelper(factory2.createThis(), instanceMethodExtraInitializersName);
                            var _node_name1;
                            setSourceMapRange(initializer, (_node_name1 = node.name) !== null && _node_name1 !== void 0 ? _node_name1 : moveRangePastDecorators(node));
                            pendingInstanceInitializers !== null && pendingInstanceInitializers !== void 0 ? pendingInstanceInitializers : pendingInstanceInitializers = [];
                            pendingInstanceInitializers.push(initializer);
                        }
                        instanceMethodExtraInitializersName !== null && instanceMethodExtraInitializersName !== void 0 ? instanceMethodExtraInitializersName : instanceMethodExtraInitializersName = factory2.createUniqueName("_instanceExtraInitializers", 48 /* FileLevel */ );
                    }
                }
                if (isClassStaticBlockDeclaration(member)) {
                    if (!isClassNamedEvaluationHelperBlock(member)) hasStaticInitializers = true;
                } else if (isPropertyDeclaration(member)) {
                    if (hasStaticModifier(member)) hasStaticInitializers || (hasStaticInitializers = !!member.initializer || hasDecorators(member));
                    else hasNonAmbientInstanceFields || (hasNonAmbientInstanceFields = !isAmbientPropertyDeclaration(member));
                }
                if ((isPrivateIdentifierClassElementDeclaration(member) || isAutoAccessorPropertyDeclaration(member)) && hasStaticModifier(member)) hasStaticPrivateClassElements = true;
                if (staticMethodExtraInitializersName && instanceMethodExtraInitializersName && hasStaticInitializers && hasNonAmbientInstanceFields && hasStaticPrivateClassElements) break;
            }
            return {
                class: node,
                classThis: classThis2,
                metadataReference,
                instanceMethodExtraInitializersName,
                staticMethodExtraInitializersName,
                hasStaticInitializers,
                hasNonAmbientInstanceFields,
                hasStaticPrivateClassElements,
                pendingStaticInitializers,
                pendingInstanceInitializers
            };
        }
        function transformClassLike(node) {
            startLexicalEnvironment();
            if (!classHasDeclaredOrExplicitlyAssignedName(node) && classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node)) node = injectClassNamedEvaluationHelperBlockIfMissing(context, node, factory2.createStringLiteral(""));
            const classReference = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ false, /*ignoreAssignedName*/ true);
            const classInfo2 = createClassInfo(node);
            const classDefinitionStatements = [];
            let leadingBlockStatements;
            let trailingBlockStatements;
            let syntheticConstructor;
            let heritageClauses;
            let shouldTransformPrivateStaticElementsInClass = false;
            const classDecorators = transformAllDecoratorsOfDeclaration(getAllDecoratorsOfClass(node, /*useLegacyDecorators*/ false));
            if (classDecorators) {
                classInfo2.classDecoratorsName = factory2.createUniqueName("_classDecorators", 48 /* FileLevel */ );
                classInfo2.classDescriptorName = factory2.createUniqueName("_classDescriptor", 48 /* FileLevel */ );
                classInfo2.classExtraInitializersName = factory2.createUniqueName("_classExtraInitializers", 48 /* FileLevel */ );
                Debug.assertIsDefined(classInfo2.classThis);
                classDefinitionStatements.push(createLet(classInfo2.classDecoratorsName, factory2.createArrayLiteralExpression(classDecorators)), createLet(classInfo2.classDescriptorName), createLet(classInfo2.classExtraInitializersName, factory2.createArrayLiteralExpression()), createLet(classInfo2.classThis));
                if (classInfo2.hasStaticPrivateClassElements) {
                    shouldTransformPrivateStaticElementsInClass = true;
                    shouldTransformPrivateStaticElementsInFile = true;
                }
            }
            const extendsClause = getHeritageClause(node.heritageClauses, 96 /* ExtendsKeyword */ );
            const extendsElement = extendsClause && firstOrUndefined(extendsClause.types);
            const extendsExpression = extendsElement && visitNode(extendsElement.expression, visitor, isExpression);
            if (extendsExpression) {
                classInfo2.classSuper = factory2.createUniqueName("_classSuper", 48 /* FileLevel */ );
                const unwrapped = skipOuterExpressions(extendsExpression);
                const safeExtendsExpression = isClassExpression(unwrapped) && !unwrapped.name || isFunctionExpression(unwrapped) && !unwrapped.name || isArrowFunction(unwrapped) ? factory2.createComma(factory2.createNumericLiteral(0), extendsExpression) : extendsExpression;
                classDefinitionStatements.push(createLet(classInfo2.classSuper, safeExtendsExpression));
                const updatedExtendsElement = factory2.updateExpressionWithTypeArguments(extendsElement, classInfo2.classSuper, /*typeArguments*/ void 0);
                const updatedExtendsClause = factory2.updateHeritageClause(extendsClause, [
                    updatedExtendsElement
                ]);
                heritageClauses = factory2.createNodeArray([
                    updatedExtendsClause
                ]);
            }
            var _classInfo2_classThis;
            const renamedClassThis = (_classInfo2_classThis = classInfo2.classThis) !== null && _classInfo2_classThis !== void 0 ? _classInfo2_classThis : factory2.createThis();
            enterClass(classInfo2);
            leadingBlockStatements = append(leadingBlockStatements, createMetadata(classInfo2.metadataReference, classInfo2.classSuper));
            let members = node.members;
            members = visitNodes2(members, (node2)=>isConstructorDeclaration(node2) ? node2 : classElementVisitor(node2), isClassElement);
            members = visitNodes2(members, (node2)=>isConstructorDeclaration(node2) ? classElementVisitor(node2) : node2, isClassElement);
            if (pendingExpressions) {
                let outerThis;
                for (let expression of pendingExpressions){
                    expression = visitNode(expression, function thisVisitor(node2) {
                        if (!(node2.transformFlags & 16384 /* ContainsLexicalThis */ )) return node2;
                        switch(node2.kind){
                            case 110 /* ThisKeyword */ :
                                if (!outerThis) {
                                    outerThis = factory2.createUniqueName("_outerThis", 16 /* Optimistic */ );
                                    classDefinitionStatements.unshift(createLet(outerThis, factory2.createThis()));
                                }
                                return outerThis;
                            default:
                                return visitEachChild(node2, thisVisitor, context);
                        }
                    }, isExpression);
                    const statement = factory2.createExpressionStatement(expression);
                    leadingBlockStatements = append(leadingBlockStatements, statement);
                }
                pendingExpressions = void 0;
            }
            exitClass();
            if (some(classInfo2.pendingInstanceInitializers) && !getFirstConstructorWithBody(node)) {
                const initializerStatements = prepareConstructor(node, classInfo2);
                if (initializerStatements) {
                    const extendsClauseElement = getEffectiveBaseTypeNode(node);
                    const isDerivedClass = !!(extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ );
                    const constructorStatements = [];
                    if (isDerivedClass) {
                        const spreadArguments = factory2.createSpreadElement(factory2.createIdentifier("arguments"));
                        const superCall = factory2.createCallExpression(factory2.createSuper(), /*typeArguments*/ void 0, [
                            spreadArguments
                        ]);
                        constructorStatements.push(factory2.createExpressionStatement(superCall));
                    }
                    addRange(constructorStatements, initializerStatements);
                    const constructorBody = factory2.createBlock(constructorStatements, /*multiLine*/ true);
                    syntheticConstructor = factory2.createConstructorDeclaration(/*modifiers*/ void 0, [], constructorBody);
                }
            }
            if (classInfo2.staticMethodExtraInitializersName) classDefinitionStatements.push(createLet(classInfo2.staticMethodExtraInitializersName, factory2.createArrayLiteralExpression()));
            if (classInfo2.instanceMethodExtraInitializersName) classDefinitionStatements.push(createLet(classInfo2.instanceMethodExtraInitializersName, factory2.createArrayLiteralExpression()));
            if (classInfo2.memberInfos) forEachEntry(classInfo2.memberInfos, (memberInfo, member)=>{
                if (isStatic(member)) {
                    classDefinitionStatements.push(createLet(memberInfo.memberDecoratorsName));
                    if (memberInfo.memberInitializersName) classDefinitionStatements.push(createLet(memberInfo.memberInitializersName, factory2.createArrayLiteralExpression()));
                    if (memberInfo.memberExtraInitializersName) classDefinitionStatements.push(createLet(memberInfo.memberExtraInitializersName, factory2.createArrayLiteralExpression()));
                    if (memberInfo.memberDescriptorName) classDefinitionStatements.push(createLet(memberInfo.memberDescriptorName));
                }
            });
            if (classInfo2.memberInfos) forEachEntry(classInfo2.memberInfos, (memberInfo, member)=>{
                if (!isStatic(member)) {
                    classDefinitionStatements.push(createLet(memberInfo.memberDecoratorsName));
                    if (memberInfo.memberInitializersName) classDefinitionStatements.push(createLet(memberInfo.memberInitializersName, factory2.createArrayLiteralExpression()));
                    if (memberInfo.memberExtraInitializersName) classDefinitionStatements.push(createLet(memberInfo.memberExtraInitializersName, factory2.createArrayLiteralExpression()));
                    if (memberInfo.memberDescriptorName) classDefinitionStatements.push(createLet(memberInfo.memberDescriptorName));
                }
            });
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.staticNonFieldDecorationStatements);
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.nonStaticNonFieldDecorationStatements);
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.staticFieldDecorationStatements);
            leadingBlockStatements = addRange(leadingBlockStatements, classInfo2.nonStaticFieldDecorationStatements);
            if (classInfo2.classDescriptorName && classInfo2.classDecoratorsName && classInfo2.classExtraInitializersName && classInfo2.classThis) {
                leadingBlockStatements !== null && leadingBlockStatements !== void 0 ? leadingBlockStatements : leadingBlockStatements = [];
                const valueProperty = factory2.createPropertyAssignment("value", renamedClassThis);
                const classDescriptor = factory2.createObjectLiteralExpression([
                    valueProperty
                ]);
                const classDescriptorAssignment = factory2.createAssignment(classInfo2.classDescriptorName, classDescriptor);
                const classNameReference = factory2.createPropertyAccessExpression(renamedClassThis, "name");
                const esDecorateHelper2 = emitHelpers().createESDecorateHelper(factory2.createNull(), classDescriptorAssignment, classInfo2.classDecoratorsName, {
                    kind: "class",
                    name: classNameReference,
                    metadata: classInfo2.metadataReference
                }, factory2.createNull(), classInfo2.classExtraInitializersName);
                const esDecorateStatement = factory2.createExpressionStatement(esDecorateHelper2);
                setSourceMapRange(esDecorateStatement, moveRangePastDecorators(node));
                leadingBlockStatements.push(esDecorateStatement);
                const classDescriptorValueReference = factory2.createPropertyAccessExpression(classInfo2.classDescriptorName, "value");
                const classThisAssignment = factory2.createAssignment(classInfo2.classThis, classDescriptorValueReference);
                const classReferenceAssignment = factory2.createAssignment(classReference, classThisAssignment);
                leadingBlockStatements.push(factory2.createExpressionStatement(classReferenceAssignment));
            }
            leadingBlockStatements.push(createSymbolMetadata(renamedClassThis, classInfo2.metadataReference));
            if (some(classInfo2.pendingStaticInitializers)) {
                for (const initializer of classInfo2.pendingStaticInitializers){
                    const initializerStatement = factory2.createExpressionStatement(initializer);
                    setSourceMapRange(initializerStatement, getSourceMapRange(initializer));
                    trailingBlockStatements = append(trailingBlockStatements, initializerStatement);
                }
                classInfo2.pendingStaticInitializers = void 0;
            }
            if (classInfo2.classExtraInitializersName) {
                const runClassInitializersHelper = emitHelpers().createRunInitializersHelper(renamedClassThis, classInfo2.classExtraInitializersName);
                const runClassInitializersStatement = factory2.createExpressionStatement(runClassInitializersHelper);
                var _node_name;
                setSourceMapRange(runClassInitializersStatement, (_node_name = node.name) !== null && _node_name !== void 0 ? _node_name : moveRangePastDecorators(node));
                trailingBlockStatements = append(trailingBlockStatements, runClassInitializersStatement);
            }
            if (leadingBlockStatements && trailingBlockStatements && !classInfo2.hasStaticInitializers) {
                addRange(leadingBlockStatements, trailingBlockStatements);
                trailingBlockStatements = void 0;
            }
            const leadingStaticBlock = leadingBlockStatements && factory2.createClassStaticBlockDeclaration(factory2.createBlock(leadingBlockStatements, /*multiLine*/ true));
            if (leadingStaticBlock && shouldTransformPrivateStaticElementsInClass) setInternalEmitFlags(leadingStaticBlock, 32 /* TransformPrivateStaticElements */ );
            const trailingStaticBlock = trailingBlockStatements && factory2.createClassStaticBlockDeclaration(factory2.createBlock(trailingBlockStatements, /*multiLine*/ true));
            if (leadingStaticBlock || syntheticConstructor || trailingStaticBlock) {
                const newMembers = [];
                const existingNamedEvaluationHelperBlockIndex = members.findIndex(isClassNamedEvaluationHelperBlock);
                if (leadingStaticBlock) {
                    addRange(newMembers, members, 0, existingNamedEvaluationHelperBlockIndex + 1);
                    newMembers.push(leadingStaticBlock);
                    addRange(newMembers, members, existingNamedEvaluationHelperBlockIndex + 1);
                } else addRange(newMembers, members);
                if (syntheticConstructor) newMembers.push(syntheticConstructor);
                if (trailingStaticBlock) newMembers.push(trailingStaticBlock);
                members = setTextRange(factory2.createNodeArray(newMembers), members);
            }
            const lexicalEnvironment = endLexicalEnvironment();
            let classExpression;
            if (classDecorators) {
                classExpression = factory2.createClassExpression(/*modifiers*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, heritageClauses, members);
                if (classInfo2.classThis) classExpression = injectClassThisAssignmentIfMissing(factory2, classExpression, classInfo2.classThis);
                const classReferenceDeclaration = factory2.createVariableDeclaration(classReference, /*exclamationToken*/ void 0, /*type*/ void 0, classExpression);
                const classReferenceVarDeclList = factory2.createVariableDeclarationList([
                    classReferenceDeclaration
                ]);
                const returnExpr = classInfo2.classThis ? factory2.createAssignment(classReference, classInfo2.classThis) : classReference;
                classDefinitionStatements.push(factory2.createVariableStatement(/*modifiers*/ void 0, classReferenceVarDeclList), factory2.createReturnStatement(returnExpr));
            } else {
                classExpression = factory2.createClassExpression(/*modifiers*/ void 0, node.name, /*typeParameters*/ void 0, heritageClauses, members);
                classDefinitionStatements.push(factory2.createReturnStatement(classExpression));
            }
            if (shouldTransformPrivateStaticElementsInClass) {
                addInternalEmitFlags(classExpression, 32 /* TransformPrivateStaticElements */ );
                for (const member of classExpression.members)if ((isPrivateIdentifierClassElementDeclaration(member) || isAutoAccessorPropertyDeclaration(member)) && hasStaticModifier(member)) addInternalEmitFlags(member, 32 /* TransformPrivateStaticElements */ );
            }
            setOriginalNode(classExpression, node);
            return factory2.createImmediatelyInvokedArrowFunction(factory2.mergeLexicalEnvironment(classDefinitionStatements, lexicalEnvironment));
        }
        function isDecoratedClassLike(node) {
            return classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, node) || childIsDecorated(/*useLegacyDecorators*/ false, node);
        }
        function visitClassDeclaration(node) {
            if (isDecoratedClassLike(node)) {
                const statements = [];
                var _getOriginalNode;
                const originalClass = (_getOriginalNode = getOriginalNode(node, isClassLike)) !== null && _getOriginalNode !== void 0 ? _getOriginalNode : node;
                const className = originalClass.name ? factory2.createStringLiteralFromNode(originalClass.name) : factory2.createStringLiteral("default");
                const isExport = hasSyntacticModifier(node, 32 /* Export */ );
                const isDefault = hasSyntacticModifier(node, 2048 /* Default */ );
                if (!node.name) node = injectClassNamedEvaluationHelperBlockIfMissing(context, node, className);
                if (isExport && isDefault) {
                    const iife = transformClassLike(node);
                    if (node.name) {
                        const varDecl = factory2.createVariableDeclaration(factory2.getLocalName(node), /*exclamationToken*/ void 0, /*type*/ void 0, iife);
                        setOriginalNode(varDecl, node);
                        const varDecls = factory2.createVariableDeclarationList([
                            varDecl
                        ], 1 /* Let */ );
                        const varStatement = factory2.createVariableStatement(/*modifiers*/ void 0, varDecls);
                        statements.push(varStatement);
                        const exportStatement = factory2.createExportDefault(factory2.getDeclarationName(node));
                        setOriginalNode(exportStatement, node);
                        setCommentRange(exportStatement, getCommentRange(node));
                        setSourceMapRange(exportStatement, moveRangePastDecorators(node));
                        statements.push(exportStatement);
                    } else {
                        const exportStatement = factory2.createExportDefault(iife);
                        setOriginalNode(exportStatement, node);
                        setCommentRange(exportStatement, getCommentRange(node));
                        setSourceMapRange(exportStatement, moveRangePastDecorators(node));
                        statements.push(exportStatement);
                    }
                } else {
                    Debug.assertIsDefined(node.name, "A class declaration that is not a default export must have a name.");
                    const iife = transformClassLike(node);
                    const modifierVisitorNoExport = isExport ? (node2)=>isExportModifier(node2) ? void 0 : modifierVisitor(node2) : modifierVisitor;
                    const modifiers = visitNodes2(node.modifiers, modifierVisitorNoExport, isModifier);
                    const declName = factory2.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
                    const varDecl = factory2.createVariableDeclaration(declName, /*exclamationToken*/ void 0, /*type*/ void 0, iife);
                    setOriginalNode(varDecl, node);
                    const varDecls = factory2.createVariableDeclarationList([
                        varDecl
                    ], 1 /* Let */ );
                    const varStatement = factory2.createVariableStatement(modifiers, varDecls);
                    setOriginalNode(varStatement, node);
                    setCommentRange(varStatement, getCommentRange(node));
                    statements.push(varStatement);
                    if (isExport) {
                        const exportStatement = factory2.createExternalModuleExport(declName);
                        setOriginalNode(exportStatement, node);
                        statements.push(exportStatement);
                    }
                }
                return singleOrMany(statements);
            } else {
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
                enterClass(/*classInfo*/ void 0);
                const members = visitNodes2(node.members, classElementVisitor, isClassElement);
                exitClass();
                return factory2.updateClassDeclaration(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            }
        }
        function visitClassExpression(node) {
            if (isDecoratedClassLike(node)) {
                const iife = transformClassLike(node);
                setOriginalNode(iife, node);
                return iife;
            } else {
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                const heritageClauses = visitNodes2(node.heritageClauses, visitor, isHeritageClause);
                enterClass(/*classInfo*/ void 0);
                const members = visitNodes2(node.members, classElementVisitor, isClassElement);
                exitClass();
                return factory2.updateClassExpression(node, modifiers, node.name, /*typeParameters*/ void 0, heritageClauses, members);
            }
        }
        function prepareConstructor(_parent, classInfo2) {
            if (some(classInfo2.pendingInstanceInitializers)) {
                const statements = [];
                statements.push(factory2.createExpressionStatement(factory2.inlineExpressions(classInfo2.pendingInstanceInitializers)));
                classInfo2.pendingInstanceInitializers = void 0;
                return statements;
            }
        }
        function transformConstructorBodyWorker(statementsOut, statementsIn, statementOffset, superPath, superPathDepth, initializerStatements) {
            const superStatementIndex = superPath[superPathDepth];
            const superStatement = statementsIn[superStatementIndex];
            addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, statementOffset, superStatementIndex - statementOffset));
            if (isTryStatement(superStatement)) {
                const tryBlockStatements = [];
                transformConstructorBodyWorker(tryBlockStatements, superStatement.tryBlock.statements, /*statementOffset*/ 0, superPath, superPathDepth + 1, initializerStatements);
                const tryBlockStatementsArray = factory2.createNodeArray(tryBlockStatements);
                setTextRange(tryBlockStatementsArray, superStatement.tryBlock.statements);
                statementsOut.push(factory2.updateTryStatement(superStatement, factory2.updateBlock(superStatement.tryBlock, tryBlockStatements), visitNode(superStatement.catchClause, visitor, isCatchClause), visitNode(superStatement.finallyBlock, visitor, isBlock)));
            } else {
                addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, superStatementIndex, 1));
                addRange(statementsOut, initializerStatements);
            }
            addRange(statementsOut, visitNodes2(statementsIn, visitor, isStatement, superStatementIndex + 1));
        }
        function visitConstructorDeclaration(node) {
            enterClassElement(node);
            const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
            const parameters = visitNodes2(node.parameters, visitor, isParameter);
            let body;
            if (node.body && classInfo) {
                const initializerStatements = prepareConstructor(classInfo.class, classInfo);
                if (initializerStatements) {
                    const statements = [];
                    const nonPrologueStart = factory2.copyPrologue(node.body.statements, statements, /*ensureUseStrict*/ false, visitor);
                    const superStatementIndices = findSuperStatementIndexPath(node.body.statements, nonPrologueStart);
                    if (superStatementIndices.length > 0) transformConstructorBodyWorker(statements, node.body.statements, nonPrologueStart, superStatementIndices, 0, initializerStatements);
                    else {
                        addRange(statements, initializerStatements);
                        addRange(statements, visitNodes2(node.body.statements, visitor, isStatement));
                    }
                    body = factory2.createBlock(statements, /*multiLine*/ true);
                    setOriginalNode(body, node.body);
                    setTextRange(body, node.body);
                }
            }
            body !== null && body !== void 0 ? body : body = visitNode(node.body, visitor, isBlock);
            exitClassElement();
            return factory2.updateConstructorDeclaration(node, modifiers, parameters, body);
        }
        function finishClassElement(updated, original) {
            if (updated !== original) {
                setCommentRange(updated, original);
                setSourceMapRange(updated, moveRangePastDecorators(original));
            }
            return updated;
        }
        function partialTransformClassElement(member, classInfo2, createDescriptor) {
            let referencedName;
            let name;
            let initializersName;
            let extraInitializersName;
            let thisArg;
            let descriptorName;
            if (!classInfo2) {
                const modifiers2 = visitNodes2(member.modifiers, modifierVisitor, isModifier);
                enterName();
                name = visitPropertyName(member.name);
                exitName();
                return {
                    modifiers: modifiers2,
                    referencedName,
                    name,
                    initializersName,
                    descriptorName,
                    thisArg
                };
            }
            const memberDecorators = transformAllDecoratorsOfDeclaration(getAllDecoratorsOfClassElement(member, classInfo2.class, /*useLegacyDecorators*/ false));
            const modifiers = visitNodes2(member.modifiers, modifierVisitor, isModifier);
            if (memberDecorators) {
                const memberDecoratorsName = createHelperVariable(member, "decorators");
                const memberDecoratorsArray = factory2.createArrayLiteralExpression(memberDecorators);
                const memberDecoratorsAssignment = factory2.createAssignment(memberDecoratorsName, memberDecoratorsArray);
                const memberInfo = {
                    memberDecoratorsName
                };
                var _classInfo2_memberInfos;
                (_classInfo2_memberInfos = classInfo2.memberInfos) !== null && _classInfo2_memberInfos !== void 0 ? _classInfo2_memberInfos : classInfo2.memberInfos = /* @__PURE__ */ new Map();
                classInfo2.memberInfos.set(member, memberInfo);
                pendingExpressions !== null && pendingExpressions !== void 0 ? pendingExpressions : pendingExpressions = [];
                pendingExpressions.push(memberDecoratorsAssignment);
                var _classInfo2_staticNonFieldDecorationStatements, _classInfo2_nonStaticNonFieldDecorationStatements, _classInfo2_staticFieldDecorationStatements, _classInfo2_nonStaticFieldDecorationStatements;
                const statements = isMethodOrAccessor(member) || isAutoAccessorPropertyDeclaration(member) ? isStatic(member) ? (_classInfo2_staticNonFieldDecorationStatements = classInfo2.staticNonFieldDecorationStatements) !== null && _classInfo2_staticNonFieldDecorationStatements !== void 0 ? _classInfo2_staticNonFieldDecorationStatements : classInfo2.staticNonFieldDecorationStatements = [] : (_classInfo2_nonStaticNonFieldDecorationStatements = classInfo2.nonStaticNonFieldDecorationStatements) !== null && _classInfo2_nonStaticNonFieldDecorationStatements !== void 0 ? _classInfo2_nonStaticNonFieldDecorationStatements : classInfo2.nonStaticNonFieldDecorationStatements = [] : isPropertyDeclaration(member) && !isAutoAccessorPropertyDeclaration(member) ? isStatic(member) ? (_classInfo2_staticFieldDecorationStatements = classInfo2.staticFieldDecorationStatements) !== null && _classInfo2_staticFieldDecorationStatements !== void 0 ? _classInfo2_staticFieldDecorationStatements : classInfo2.staticFieldDecorationStatements = [] : (_classInfo2_nonStaticFieldDecorationStatements = classInfo2.nonStaticFieldDecorationStatements) !== null && _classInfo2_nonStaticFieldDecorationStatements !== void 0 ? _classInfo2_nonStaticFieldDecorationStatements : classInfo2.nonStaticFieldDecorationStatements = [] : Debug.fail();
                const kind = isGetAccessorDeclaration(member) ? "getter" : isSetAccessorDeclaration(member) ? "setter" : isMethodDeclaration(member) ? "method" : isAutoAccessorPropertyDeclaration(member) ? "accessor" : isPropertyDeclaration(member) ? "field" : Debug.fail();
                let propertyName;
                if (isIdentifier(member.name) || isPrivateIdentifier(member.name)) propertyName = {
                    computed: false,
                    name: member.name
                };
                else if (isPropertyNameLiteral(member.name)) propertyName = {
                    computed: true,
                    name: factory2.createStringLiteralFromNode(member.name)
                };
                else {
                    const expression = member.name.expression;
                    if (isPropertyNameLiteral(expression) && !isIdentifier(expression)) propertyName = {
                        computed: true,
                        name: factory2.createStringLiteralFromNode(expression)
                    };
                    else {
                        enterName();
                        ({ referencedName, name } = visitReferencedPropertyName(member.name));
                        propertyName = {
                            computed: true,
                            name: referencedName
                        };
                        exitName();
                    }
                }
                const context2 = {
                    kind,
                    name: propertyName,
                    static: isStatic(member),
                    private: isPrivateIdentifier(member.name),
                    access: {
                        // 15.7.3 CreateDecoratorAccessObject (kind, name)
                        // 2. If _kind_ is ~field~, ~method~, ~accessor~, or ~getter~, then ...
                        get: isPropertyDeclaration(member) || isGetAccessorDeclaration(member) || isMethodDeclaration(member),
                        // 3. If _kind_ is ~field~, ~accessor~, or ~setter~, then ...
                        set: isPropertyDeclaration(member) || isSetAccessorDeclaration(member)
                    },
                    metadata: classInfo2.metadataReference
                };
                if (isMethodOrAccessor(member)) {
                    const methodExtraInitializersName = isStatic(member) ? classInfo2.staticMethodExtraInitializersName : classInfo2.instanceMethodExtraInitializersName;
                    Debug.assertIsDefined(methodExtraInitializersName);
                    let descriptor;
                    if (isPrivateIdentifierClassElementDeclaration(member) && createDescriptor) {
                        descriptor = createDescriptor(member, visitNodes2(modifiers, (node)=>tryCast(node, isAsyncModifier), isModifier));
                        memberInfo.memberDescriptorName = descriptorName = createHelperVariable(member, "descriptor");
                        descriptor = factory2.createAssignment(descriptorName, descriptor);
                    }
                    const esDecorateExpression = emitHelpers().createESDecorateHelper(factory2.createThis(), descriptor !== null && descriptor !== void 0 ? descriptor : factory2.createNull(), memberDecoratorsName, context2, factory2.createNull(), methodExtraInitializersName);
                    const esDecorateStatement = factory2.createExpressionStatement(esDecorateExpression);
                    setSourceMapRange(esDecorateStatement, moveRangePastDecorators(member));
                    statements.push(esDecorateStatement);
                } else if (isPropertyDeclaration(member)) {
                    var _memberInfo_memberInitializersName;
                    initializersName = (_memberInfo_memberInitializersName = memberInfo.memberInitializersName) !== null && _memberInfo_memberInitializersName !== void 0 ? _memberInfo_memberInitializersName : memberInfo.memberInitializersName = createHelperVariable(member, "initializers");
                    var _memberInfo_memberExtraInitializersName;
                    extraInitializersName = (_memberInfo_memberExtraInitializersName = memberInfo.memberExtraInitializersName) !== null && _memberInfo_memberExtraInitializersName !== void 0 ? _memberInfo_memberExtraInitializersName : memberInfo.memberExtraInitializersName = createHelperVariable(member, "extraInitializers");
                    if (isStatic(member)) thisArg = classInfo2.classThis;
                    let descriptor;
                    if (isPrivateIdentifierClassElementDeclaration(member) && hasAccessorModifier(member) && createDescriptor) {
                        descriptor = createDescriptor(member, /*modifiers*/ void 0);
                        memberInfo.memberDescriptorName = descriptorName = createHelperVariable(member, "descriptor");
                        descriptor = factory2.createAssignment(descriptorName, descriptor);
                    }
                    const esDecorateExpression = emitHelpers().createESDecorateHelper(isAutoAccessorPropertyDeclaration(member) ? factory2.createThis() : factory2.createNull(), descriptor !== null && descriptor !== void 0 ? descriptor : factory2.createNull(), memberDecoratorsName, context2, initializersName, extraInitializersName);
                    const esDecorateStatement = factory2.createExpressionStatement(esDecorateExpression);
                    setSourceMapRange(esDecorateStatement, moveRangePastDecorators(member));
                    statements.push(esDecorateStatement);
                }
            }
            if (name === void 0) {
                enterName();
                name = visitPropertyName(member.name);
                exitName();
            }
            if (!some(modifiers) && (isMethodDeclaration(member) || isPropertyDeclaration(member))) setEmitFlags(name, 1024 /* NoLeadingComments */ );
            return {
                modifiers,
                referencedName,
                name,
                initializersName,
                extraInitializersName,
                descriptorName,
                thisArg
            };
        }
        function visitMethodDeclaration(node) {
            enterClassElement(node);
            const { modifiers, name, descriptorName } = partialTransformClassElement(node, classInfo, createMethodDescriptorObject);
            if (descriptorName) {
                exitClassElement();
                return finishClassElement(createMethodDescriptorForwarder(modifiers, name, descriptorName), node);
            } else {
                const parameters = visitNodes2(node.parameters, visitor, isParameter);
                const body = visitNode(node.body, visitor, isBlock);
                exitClassElement();
                return finishClassElement(factory2.updateMethodDeclaration(node, modifiers, node.asteriskToken, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body), node);
            }
        }
        function visitGetAccessorDeclaration(node) {
            enterClassElement(node);
            const { modifiers, name, descriptorName } = partialTransformClassElement(node, classInfo, createGetAccessorDescriptorObject);
            if (descriptorName) {
                exitClassElement();
                return finishClassElement(createGetAccessorDescriptorForwarder(modifiers, name, descriptorName), node);
            } else {
                const parameters = visitNodes2(node.parameters, visitor, isParameter);
                const body = visitNode(node.body, visitor, isBlock);
                exitClassElement();
                return finishClassElement(factory2.updateGetAccessorDeclaration(node, modifiers, name, parameters, /*type*/ void 0, body), node);
            }
        }
        function visitSetAccessorDeclaration(node) {
            enterClassElement(node);
            const { modifiers, name, descriptorName } = partialTransformClassElement(node, classInfo, createSetAccessorDescriptorObject);
            if (descriptorName) {
                exitClassElement();
                return finishClassElement(createSetAccessorDescriptorForwarder(modifiers, name, descriptorName), node);
            } else {
                const parameters = visitNodes2(node.parameters, visitor, isParameter);
                const body = visitNode(node.body, visitor, isBlock);
                exitClassElement();
                return finishClassElement(factory2.updateSetAccessorDeclaration(node, modifiers, name, parameters, body), node);
            }
        }
        function visitClassStaticBlockDeclaration(node) {
            enterClassElement(node);
            let result;
            if (isClassNamedEvaluationHelperBlock(node)) result = visitEachChild(node, visitor, context);
            else if (isClassThisAssignmentBlock(node)) {
                const savedClassThis = classThis;
                classThis = void 0;
                result = visitEachChild(node, visitor, context);
                classThis = savedClassThis;
            } else {
                node = visitEachChild(node, visitor, context);
                result = node;
                if (classInfo) {
                    classInfo.hasStaticInitializers = true;
                    if (some(classInfo.pendingStaticInitializers)) {
                        const statements = [];
                        for (const initializer of classInfo.pendingStaticInitializers){
                            const initializerStatement = factory2.createExpressionStatement(initializer);
                            setSourceMapRange(initializerStatement, getSourceMapRange(initializer));
                            statements.push(initializerStatement);
                        }
                        const body = factory2.createBlock(statements, /*multiLine*/ true);
                        const staticBlock = factory2.createClassStaticBlockDeclaration(body);
                        result = [
                            staticBlock,
                            result
                        ];
                        classInfo.pendingStaticInitializers = void 0;
                    }
                }
            }
            exitClassElement();
            return result;
        }
        function visitPropertyDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.initializer));
            enterClassElement(node);
            Debug.assert(!isAmbientPropertyDeclaration(node), "Not yet implemented.");
            const { modifiers, name, initializersName, extraInitializersName, descriptorName, thisArg } = partialTransformClassElement(node, classInfo, hasAccessorModifier(node) ? createAccessorPropertyDescriptorObject : void 0);
            startLexicalEnvironment();
            let initializer = visitNode(node.initializer, visitor, isExpression);
            if (initializersName) initializer = emitHelpers().createRunInitializersHelper(thisArg !== null && thisArg !== void 0 ? thisArg : factory2.createThis(), initializersName, initializer !== null && initializer !== void 0 ? initializer : factory2.createVoidZero());
            if (isStatic(node) && classInfo && initializer) classInfo.hasStaticInitializers = true;
            const declarations = endLexicalEnvironment();
            if (some(declarations)) initializer = factory2.createImmediatelyInvokedArrowFunction([
                ...declarations,
                factory2.createReturnStatement(initializer)
            ]);
            if (classInfo) {
                if (isStatic(node)) {
                    initializer = injectPendingInitializers(classInfo, /*isStatic*/ true, initializer);
                    if (extraInitializersName) {
                        var _classInfo_pendingStaticInitializers;
                        (_classInfo_pendingStaticInitializers = classInfo.pendingStaticInitializers) !== null && _classInfo_pendingStaticInitializers !== void 0 ? _classInfo_pendingStaticInitializers : classInfo.pendingStaticInitializers = [];
                        var _classInfo_classThis;
                        classInfo.pendingStaticInitializers.push(emitHelpers().createRunInitializersHelper((_classInfo_classThis = classInfo.classThis) !== null && _classInfo_classThis !== void 0 ? _classInfo_classThis : factory2.createThis(), extraInitializersName));
                    }
                } else {
                    initializer = injectPendingInitializers(classInfo, /*isStatic*/ false, initializer);
                    if (extraInitializersName) {
                        var _classInfo_pendingInstanceInitializers;
                        (_classInfo_pendingInstanceInitializers = classInfo.pendingInstanceInitializers) !== null && _classInfo_pendingInstanceInitializers !== void 0 ? _classInfo_pendingInstanceInitializers : classInfo.pendingInstanceInitializers = [];
                        classInfo.pendingInstanceInitializers.push(emitHelpers().createRunInitializersHelper(factory2.createThis(), extraInitializersName));
                    }
                }
            }
            exitClassElement();
            if (hasAccessorModifier(node) && descriptorName) {
                const commentRange = getCommentRange(node);
                const sourceMapRange = getSourceMapRange(node);
                const name2 = node.name;
                let getterName = name2;
                let setterName = name2;
                if (isComputedPropertyName(name2) && !isSimpleInlineableExpression(name2.expression)) {
                    const cacheAssignment = findComputedPropertyNameCacheAssignment(name2);
                    if (cacheAssignment) {
                        getterName = factory2.updateComputedPropertyName(name2, visitNode(name2.expression, visitor, isExpression));
                        setterName = factory2.updateComputedPropertyName(name2, cacheAssignment.left);
                    } else {
                        const temp = factory2.createTempVariable(hoistVariableDeclaration);
                        setSourceMapRange(temp, name2.expression);
                        const expression = visitNode(name2.expression, visitor, isExpression);
                        const assignment = factory2.createAssignment(temp, expression);
                        setSourceMapRange(assignment, name2.expression);
                        getterName = factory2.updateComputedPropertyName(name2, assignment);
                        setterName = factory2.updateComputedPropertyName(name2, temp);
                    }
                }
                const modifiersWithoutAccessor = visitNodes2(modifiers, (node2)=>node2.kind !== 129 /* AccessorKeyword */  ? node2 : void 0, isModifier);
                const backingField = createAccessorPropertyBackingField(factory2, node, modifiersWithoutAccessor, initializer);
                setOriginalNode(backingField, node);
                setEmitFlags(backingField, 3072 /* NoComments */ );
                setSourceMapRange(backingField, sourceMapRange);
                setSourceMapRange(backingField.name, node.name);
                const getter = createGetAccessorDescriptorForwarder(modifiersWithoutAccessor, getterName, descriptorName);
                setOriginalNode(getter, node);
                setCommentRange(getter, commentRange);
                setSourceMapRange(getter, sourceMapRange);
                const setter = createSetAccessorDescriptorForwarder(modifiersWithoutAccessor, setterName, descriptorName);
                setOriginalNode(setter, node);
                setEmitFlags(setter, 3072 /* NoComments */ );
                setSourceMapRange(setter, sourceMapRange);
                return [
                    backingField,
                    getter,
                    setter
                ];
            }
            return finishClassElement(factory2.updatePropertyDeclaration(node, modifiers, name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, initializer), node);
        }
        function visitThisExpression(node) {
            return classThis !== null && classThis !== void 0 ? classThis : node;
        }
        function visitCallExpression(node) {
            if (isSuperProperty(node.expression) && classThis) {
                const expression = visitNode(node.expression, visitor, isExpression);
                const argumentsList = visitNodes2(node.arguments, visitor, isExpression);
                const invocation = factory2.createFunctionCallCall(expression, classThis, argumentsList);
                setOriginalNode(invocation, node);
                setTextRange(invocation, node);
                return invocation;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitTaggedTemplateExpression(node) {
            if (isSuperProperty(node.tag) && classThis) {
                const tag = visitNode(node.tag, visitor, isExpression);
                const boundTag = factory2.createFunctionBindCall(tag, classThis, []);
                setOriginalNode(boundTag, node);
                setTextRange(boundTag, node);
                const template = visitNode(node.template, visitor, isTemplateLiteral);
                return factory2.updateTaggedTemplateExpression(node, boundTag, /*typeArguments*/ void 0, template);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPropertyAccessExpression(node) {
            if (isSuperProperty(node) && isIdentifier(node.name) && classThis && classSuper) {
                const propertyName = factory2.createStringLiteralFromNode(node.name);
                const superProperty = factory2.createReflectGetCall(classSuper, propertyName, classThis);
                setOriginalNode(superProperty, node.expression);
                setTextRange(superProperty, node.expression);
                return superProperty;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitElementAccessExpression(node) {
            if (isSuperProperty(node) && classThis && classSuper) {
                const propertyName = visitNode(node.argumentExpression, visitor, isExpression);
                const superProperty = factory2.createReflectGetCall(classSuper, propertyName, classThis);
                setOriginalNode(superProperty, node.expression);
                setTextRange(superProperty, node.expression);
                return superProperty;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitParameterDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.initializer));
            const updated = factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, node.dotDotDotToken, visitNode(node.name, visitor, isBindingName), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            if (updated !== node) {
                setCommentRange(updated, node);
                setTextRange(updated, moveRangePastModifiers(node));
                setSourceMapRange(updated, moveRangePastModifiers(node));
                setEmitFlags(updated.name, 64 /* NoTrailingSourceMap */ );
            }
            return updated;
        }
        function isAnonymousClassNeedingAssignedName(node) {
            return isClassExpression(node) && !node.name && isDecoratedClassLike(node);
        }
        function canIgnoreEmptyStringLiteralInAssignedName(node) {
            const innerExpression = skipOuterExpressions(node);
            return isClassExpression(innerExpression) && !innerExpression.name && !classOrConstructorParameterIsDecorated(/*useLegacyDecorators*/ false, innerExpression);
        }
        function visitForStatement(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, visitor, context));
        }
        function visitExpressionStatement(node) {
            return visitEachChild(node, discardedValueVisitor, context);
        }
        function visitBinaryExpression(node, discarded) {
            if (isDestructuringAssignment(node)) {
                const left = visitAssignmentPattern(node.left);
                const right = visitNode(node.right, visitor, isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            if (isAssignmentExpression(node)) {
                if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) {
                    node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.right));
                    return visitEachChild(node, visitor, context);
                }
                if (isSuperProperty(node.left) && classThis && classSuper) {
                    let setterName = isElementAccessExpression(node.left) ? visitNode(node.left.argumentExpression, visitor, isExpression) : isIdentifier(node.left.name) ? factory2.createStringLiteralFromNode(node.left.name) : void 0;
                    if (setterName) {
                        let expression = visitNode(node.right, visitor, isExpression);
                        if (isCompoundAssignment(node.operatorToken.kind)) {
                            let getterName = setterName;
                            if (!isSimpleInlineableExpression(setterName)) {
                                getterName = factory2.createTempVariable(hoistVariableDeclaration);
                                setterName = factory2.createAssignment(getterName, setterName);
                            }
                            const superPropertyGet = factory2.createReflectGetCall(classSuper, getterName, classThis);
                            setOriginalNode(superPropertyGet, node.left);
                            setTextRange(superPropertyGet, node.left);
                            expression = factory2.createBinaryExpression(superPropertyGet, getNonAssignmentOperatorForCompoundAssignment(node.operatorToken.kind), expression);
                            setTextRange(expression, node);
                        }
                        const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                        if (temp) {
                            expression = factory2.createAssignment(temp, expression);
                            setTextRange(temp, node);
                        }
                        expression = factory2.createReflectSetCall(classSuper, setterName, expression, classThis);
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        if (temp) {
                            expression = factory2.createComma(expression, temp);
                            setTextRange(expression, node);
                        }
                        return expression;
                    }
                }
            }
            if (node.operatorToken.kind === 28 /* CommaToken */ ) {
                const left = visitNode(node.left, discardedValueVisitor, isExpression);
                const right = visitNode(node.right, discarded ? discardedValueVisitor : visitor, isExpression);
                return factory2.updateBinaryExpression(node, left, node.operatorToken, right);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitPreOrPostfixUnaryExpression(node, discarded) {
            if (node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) {
                const operand = skipParentheses(node.operand);
                if (isSuperProperty(operand) && classThis && classSuper) {
                    let setterName = isElementAccessExpression(operand) ? visitNode(operand.argumentExpression, visitor, isExpression) : isIdentifier(operand.name) ? factory2.createStringLiteralFromNode(operand.name) : void 0;
                    if (setterName) {
                        let getterName = setterName;
                        if (!isSimpleInlineableExpression(setterName)) {
                            getterName = factory2.createTempVariable(hoistVariableDeclaration);
                            setterName = factory2.createAssignment(getterName, setterName);
                        }
                        let expression = factory2.createReflectGetCall(classSuper, getterName, classThis);
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        const temp = discarded ? void 0 : factory2.createTempVariable(hoistVariableDeclaration);
                        expression = expandPreOrPostfixIncrementOrDecrementExpression(factory2, node, expression, hoistVariableDeclaration, temp);
                        expression = factory2.createReflectSetCall(classSuper, setterName, expression, classThis);
                        setOriginalNode(expression, node);
                        setTextRange(expression, node);
                        if (temp) {
                            expression = factory2.createComma(expression, temp);
                            setTextRange(expression, node);
                        }
                        return expression;
                    }
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, discarded) {
            const elements = discarded ? visitCommaListElements(node.elements, discardedValueVisitor) : visitCommaListElements(node.elements, visitor, discardedValueVisitor);
            return factory2.updateCommaListExpression(node, elements);
        }
        function visitReferencedPropertyName(node) {
            if (isPropertyNameLiteral(node) || isPrivateIdentifier(node)) {
                const referencedName2 = factory2.createStringLiteralFromNode(node);
                const name2 = visitNode(node, visitor, isPropertyName);
                return {
                    referencedName: referencedName2,
                    name: name2
                };
            }
            if (isPropertyNameLiteral(node.expression) && !isIdentifier(node.expression)) {
                const referencedName2 = factory2.createStringLiteralFromNode(node.expression);
                const name2 = visitNode(node, visitor, isPropertyName);
                return {
                    referencedName: referencedName2,
                    name: name2
                };
            }
            const referencedName = factory2.getGeneratedNameForNode(node);
            hoistVariableDeclaration(referencedName);
            const key = emitHelpers().createPropKeyHelper(visitNode(node.expression, visitor, isExpression));
            const assignment = factory2.createAssignment(referencedName, key);
            const name = factory2.updateComputedPropertyName(node, injectPendingExpressions(assignment));
            return {
                referencedName,
                name
            };
        }
        function visitPropertyName(node) {
            if (isComputedPropertyName(node)) return visitComputedPropertyName(node);
            return visitNode(node, visitor, isPropertyName);
        }
        function visitComputedPropertyName(node) {
            let expression = visitNode(node.expression, visitor, isExpression);
            if (!isSimpleInlineableExpression(expression)) expression = injectPendingExpressions(expression);
            return factory2.updateComputedPropertyName(node, expression);
        }
        function visitPropertyAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.initializer));
            return visitEachChild(node, visitor, context);
        }
        function visitVariableDeclaration(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.initializer));
            return visitEachChild(node, visitor, context);
        }
        function visitBindingElement(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.initializer));
            return visitEachChild(node, visitor, context);
        }
        function visitDestructuringAssignmentTarget(node) {
            if (isObjectLiteralExpression(node) || isArrayLiteralExpression(node)) return visitAssignmentPattern(node);
            if (isSuperProperty(node) && classThis && classSuper) {
                const propertyName = isElementAccessExpression(node) ? visitNode(node.argumentExpression, visitor, isExpression) : isIdentifier(node.name) ? factory2.createStringLiteralFromNode(node.name) : void 0;
                if (propertyName) {
                    const paramName = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                    const expression = factory2.createAssignmentTargetWrapper(paramName, factory2.createReflectSetCall(classSuper, propertyName, paramName, classThis));
                    setOriginalNode(expression, node);
                    setTextRange(expression, node);
                    return expression;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentElement(node) {
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
                if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.right));
                const assignmentTarget = visitDestructuringAssignmentTarget(node.left);
                const initializer = visitNode(node.right, visitor, isExpression);
                return factory2.updateBinaryExpression(node, assignmentTarget, node.operatorToken, initializer);
            } else return visitDestructuringAssignmentTarget(node);
        }
        function visitAssignmentRestElement(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadElement(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitArrayAssignmentElement(node) {
            Debug.assertNode(node, isArrayBindingOrAssignmentElement);
            if (isSpreadElement(node)) return visitAssignmentRestElement(node);
            if (!isOmittedExpression(node)) return visitAssignmentElement(node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentProperty(node) {
            const name = visitNode(node.name, visitor, isPropertyName);
            if (isAssignmentExpression(node.initializer, /*excludeCompoundAssignment*/ true)) {
                const assignmentElement = visitAssignmentElement(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            if (isLeftHandSideExpression(node.initializer)) {
                const assignmentElement = visitDestructuringAssignmentTarget(node.initializer);
                return factory2.updatePropertyAssignment(node, name, assignmentElement);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitShorthandAssignmentProperty(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.objectAssignmentInitializer));
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentRestProperty(node) {
            if (isLeftHandSideExpression(node.expression)) {
                const expression = visitDestructuringAssignmentTarget(node.expression);
                return factory2.updateSpreadAssignment(node, expression);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitObjectAssignmentElement(node) {
            Debug.assertNode(node, isObjectBindingOrAssignmentElement);
            if (isSpreadAssignment(node)) return visitAssignmentRestProperty(node);
            if (isShorthandPropertyAssignment(node)) return visitShorthandAssignmentProperty(node);
            if (isPropertyAssignment(node)) return visitAssignmentProperty(node);
            return visitEachChild(node, visitor, context);
        }
        function visitAssignmentPattern(node) {
            if (isArrayLiteralExpression(node)) {
                const elements = visitNodes2(node.elements, visitArrayAssignmentElement, isExpression);
                return factory2.updateArrayLiteralExpression(node, elements);
            } else {
                const properties = visitNodes2(node.properties, visitObjectAssignmentElement, isObjectLiteralElementLike);
                return factory2.updateObjectLiteralExpression(node, properties);
            }
        }
        function visitExportAssignment(node) {
            if (isNamedEvaluation(node, isAnonymousClassNeedingAssignedName)) node = transformNamedEvaluation(context, node, canIgnoreEmptyStringLiteralInAssignedName(node.expression));
            return visitEachChild(node, visitor, context);
        }
        function visitParenthesizedExpression(node, discarded) {
            const visitorFunc = discarded ? discardedValueVisitor : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updateParenthesizedExpression(node, expression);
        }
        function visitPartiallyEmittedExpression(node, discarded) {
            const visitorFunc = discarded ? discardedValueVisitor : visitor;
            const expression = visitNode(node.expression, visitorFunc, isExpression);
            return factory2.updatePartiallyEmittedExpression(node, expression);
        }
        function injectPendingExpressionsCommon(pendingExpressions2, expression) {
            if (some(pendingExpressions2)) {
                if (expression) {
                    if (isParenthesizedExpression(expression)) {
                        pendingExpressions2.push(expression.expression);
                        expression = factory2.updateParenthesizedExpression(expression, factory2.inlineExpressions(pendingExpressions2));
                    } else {
                        pendingExpressions2.push(expression);
                        expression = factory2.inlineExpressions(pendingExpressions2);
                    }
                } else expression = factory2.inlineExpressions(pendingExpressions2);
            }
            return expression;
        }
        function injectPendingExpressions(expression) {
            const result = injectPendingExpressionsCommon(pendingExpressions, expression);
            Debug.assertIsDefined(result);
            if (result !== expression) pendingExpressions = void 0;
            return result;
        }
        function injectPendingInitializers(classInfo2, isStatic2, expression) {
            const result = injectPendingExpressionsCommon(isStatic2 ? classInfo2.pendingStaticInitializers : classInfo2.pendingInstanceInitializers, expression);
            if (result !== expression) {
                if (isStatic2) classInfo2.pendingStaticInitializers = void 0;
                else classInfo2.pendingInstanceInitializers = void 0;
            }
            return result;
        }
        function transformAllDecoratorsOfDeclaration(allDecorators) {
            if (!allDecorators) return void 0;
            const decoratorExpressions = [];
            addRange(decoratorExpressions, map(allDecorators.decorators, transformDecorator));
            return decoratorExpressions;
        }
        function transformDecorator(decorator) {
            const expression = visitNode(decorator.expression, visitor, isExpression);
            setEmitFlags(expression, 3072 /* NoComments */ );
            const innerExpression = skipOuterExpressions(expression);
            if (isAccessExpression(innerExpression)) {
                const { target, thisArg } = factory2.createCallBinding(expression, hoistVariableDeclaration, languageVersion, /*cacheIdentifiers*/ true);
                return factory2.restoreOuterExpressions(expression, factory2.createFunctionBindCall(target, thisArg, []));
            }
            return expression;
        }
        function createDescriptorMethod(original, name, modifiers, asteriskToken, kind, parameters, body) {
            const func = factory2.createFunctionExpression(modifiers, asteriskToken, /*name*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body !== null && body !== void 0 ? body : factory2.createBlock([]));
            setOriginalNode(func, original);
            setSourceMapRange(func, moveRangePastDecorators(original));
            setEmitFlags(func, 3072 /* NoComments */ );
            const prefix = kind === "get" || kind === "set" ? kind : void 0;
            const functionName = factory2.createStringLiteralFromNode(name, /*isSingleQuote*/ void 0);
            const namedFunction = emitHelpers().createSetFunctionNameHelper(func, functionName, prefix);
            const method = factory2.createPropertyAssignment(factory2.createIdentifier(kind), namedFunction);
            setOriginalNode(method, original);
            setSourceMapRange(method, moveRangePastDecorators(original));
            setEmitFlags(method, 3072 /* NoComments */ );
            return method;
        }
        function createMethodDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, node.asteriskToken, "value", visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock))
            ]);
        }
        function createGetAccessorDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "get", [], visitNode(node.body, visitor, isBlock))
            ]);
        }
        function createSetAccessorDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "set", visitNodes2(node.parameters, visitor, isParameter), visitNode(node.body, visitor, isBlock))
            ]);
        }
        function createAccessorPropertyDescriptorObject(node, modifiers) {
            return factory2.createObjectLiteralExpression([
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "get", [], factory2.createBlock([
                    factory2.createReturnStatement(factory2.createPropertyAccessExpression(factory2.createThis(), factory2.getGeneratedPrivateNameForNode(node.name)))
                ])),
                createDescriptorMethod(node, node.name, modifiers, /*asteriskToken*/ void 0, "set", [
                    factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value")
                ], factory2.createBlock([
                    factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createThis(), factory2.getGeneratedPrivateNameForNode(node.name)), factory2.createIdentifier("value")))
                ]))
            ]);
        }
        function createMethodDescriptorForwarder(modifiers, name, descriptorName) {
            modifiers = visitNodes2(modifiers, (node)=>isStaticModifier(node) ? node : void 0, isModifier);
            return factory2.createGetAccessorDeclaration(modifiers, name, [], /*type*/ void 0, factory2.createBlock([
                factory2.createReturnStatement(factory2.createPropertyAccessExpression(descriptorName, factory2.createIdentifier("value")))
            ]));
        }
        function createGetAccessorDescriptorForwarder(modifiers, name, descriptorName) {
            modifiers = visitNodes2(modifiers, (node)=>isStaticModifier(node) ? node : void 0, isModifier);
            return factory2.createGetAccessorDeclaration(modifiers, name, [], /*type*/ void 0, factory2.createBlock([
                factory2.createReturnStatement(factory2.createFunctionCallCall(factory2.createPropertyAccessExpression(descriptorName, factory2.createIdentifier("get")), factory2.createThis(), []))
            ]));
        }
        function createSetAccessorDescriptorForwarder(modifiers, name, descriptorName) {
            modifiers = visitNodes2(modifiers, (node)=>isStaticModifier(node) ? node : void 0, isModifier);
            return factory2.createSetAccessorDeclaration(modifiers, name, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value")
            ], factory2.createBlock([
                factory2.createReturnStatement(factory2.createFunctionCallCall(factory2.createPropertyAccessExpression(descriptorName, factory2.createIdentifier("set")), factory2.createThis(), [
                    factory2.createIdentifier("value")
                ]))
            ]));
        }
        function createMetadata(name, classSuper2) {
            const varDecl = factory2.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createConditionalExpression(factory2.createLogicalAnd(factory2.createTypeCheck(factory2.createIdentifier("Symbol"), "function"), factory2.createPropertyAccessExpression(factory2.createIdentifier("Symbol"), "metadata")), factory2.createToken(58 /* QuestionToken */ ), factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "create"), /*typeArguments*/ void 0, [
                classSuper2 ? createSymbolMetadataReference(classSuper2) : factory2.createNull()
            ]), factory2.createToken(59 /* ColonToken */ ), factory2.createVoidZero()));
            return factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                varDecl
            ], 2 /* Const */ ));
        }
        function createSymbolMetadata(target, value1) {
            const defineProperty = factory2.createObjectDefinePropertyCall(target, factory2.createPropertyAccessExpression(factory2.createIdentifier("Symbol"), "metadata"), factory2.createPropertyDescriptor({
                configurable: true,
                writable: true,
                enumerable: true,
                value: value1
            }, /*singleLine*/ true));
            return setEmitFlags(factory2.createIfStatement(value1, factory2.createExpressionStatement(defineProperty)), 1 /* SingleLine */ );
        }
        function createSymbolMetadataReference(classSuper2) {
            return factory2.createBinaryExpression(factory2.createElementAccessExpression(classSuper2, factory2.createPropertyAccessExpression(factory2.createIdentifier("Symbol"), "metadata")), 61 /* QuestionQuestionToken */ , factory2.createNull());
        }
    }
    // src/compiler/transformers/es2017.ts
    function transformES2017(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, resumeLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        let enabledSubstitutions = 0 /* None */ ;
        let enclosingSuperContainerFlags = 0;
        let enclosingFunctionParameterNames;
        let capturedSuperProperties;
        let hasSuperElementAccess;
        let lexicalArgumentsBinding;
        const substitutedSuperAccessors = [];
        let contextFlags = 0 /* None */ ;
        const previousOnEmitNode = context.onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            setContextFlag(1 /* NonTopLevel */ , false);
            setContextFlag(2 /* HasLexicalThis */ , !isEffectiveStrictModeSourceFile(node, compilerOptions));
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function setContextFlag(flag, val) {
            contextFlags = val ? contextFlags | flag : contextFlags & ~flag;
        }
        function inContext(flags) {
            return (contextFlags & flags) !== 0;
        }
        function inTopLevelContext() {
            return !inContext(1 /* NonTopLevel */ );
        }
        function inHasLexicalThisContext() {
            return inContext(2 /* HasLexicalThis */ );
        }
        function doWithContext(flags, cb, value1) {
            const contextFlagsToSet = flags & ~contextFlags;
            if (contextFlagsToSet) {
                setContextFlag(contextFlagsToSet, /*val*/ true);
                const result = cb(value1);
                setContextFlag(contextFlagsToSet, /*val*/ false);
                return result;
            }
            return cb(value1);
        }
        function visitDefault(node) {
            return visitEachChild(node, visitor, context);
        }
        function argumentsVisitor(node) {
            switch(node.kind){
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 177 /* Constructor */ :
                    return node;
                case 170 /* Parameter */ :
                case 209 /* BindingElement */ :
                case 261 /* VariableDeclaration */ :
                    break;
                case 80 /* Identifier */ :
                    if (lexicalArgumentsBinding && resolver.isArgumentsLocalBinding(node)) return lexicalArgumentsBinding;
                    break;
            }
            return visitEachChild(node, argumentsVisitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 256 /* ContainsES2017 */ ) === 0) return lexicalArgumentsBinding ? argumentsVisitor(node) : node;
            switch(node.kind){
                case 134 /* AsyncKeyword */ :
                    return void 0;
                case 224 /* AwaitExpression */ :
                    return visitAwaitExpression(node);
                case 175 /* MethodDeclaration */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitMethodDeclaration, node);
                case 263 /* FunctionDeclaration */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitFunctionDeclaration, node);
                case 219 /* FunctionExpression */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitFunctionExpression, node);
                case 220 /* ArrowFunction */ :
                    return doWithContext(1 /* NonTopLevel */ , visitArrowFunction, node);
                case 212 /* PropertyAccessExpression */ :
                    if (capturedSuperProperties && isPropertyAccessExpression(node) && node.expression.kind === 108 /* SuperKeyword */ ) capturedSuperProperties.add(node.name.escapedText);
                    return visitEachChild(node, visitor, context);
                case 213 /* ElementAccessExpression */ :
                    if (capturedSuperProperties && node.expression.kind === 108 /* SuperKeyword */ ) hasSuperElementAccess = true;
                    return visitEachChild(node, visitor, context);
                case 178 /* GetAccessor */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitGetAccessorDeclaration, node);
                case 179 /* SetAccessor */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitSetAccessorDeclaration, node);
                case 177 /* Constructor */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitConstructorDeclaration, node);
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    return doWithContext(3 /* HasLexicalThis */ , visitDefault, node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function asyncBodyVisitor(node) {
            if (isNodeWithPossibleHoistedDeclaration(node)) switch(node.kind){
                case 244 /* VariableStatement */ :
                    return visitVariableStatementInAsyncBody(node);
                case 249 /* ForStatement */ :
                    return visitForStatementInAsyncBody(node);
                case 250 /* ForInStatement */ :
                    return visitForInStatementInAsyncBody(node);
                case 251 /* ForOfStatement */ :
                    return visitForOfStatementInAsyncBody(node);
                case 300 /* CatchClause */ :
                    return visitCatchClauseInAsyncBody(node);
                case 242 /* Block */ :
                case 256 /* SwitchStatement */ :
                case 270 /* CaseBlock */ :
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                case 259 /* TryStatement */ :
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                case 246 /* IfStatement */ :
                case 255 /* WithStatement */ :
                case 257 /* LabeledStatement */ :
                    return visitEachChild(node, asyncBodyVisitor, context);
                default:
                    return Debug.assertNever(node, "Unhandled node.");
            }
            return visitor(node);
        }
        function visitCatchClauseInAsyncBody(node) {
            const catchClauseNames = /* @__PURE__ */ new Set();
            recordDeclarationName(node.variableDeclaration, catchClauseNames);
            let catchClauseUnshadowedNames;
            catchClauseNames.forEach((_, escapedName)=>{
                if (enclosingFunctionParameterNames.has(escapedName)) {
                    if (!catchClauseUnshadowedNames) catchClauseUnshadowedNames = new Set(enclosingFunctionParameterNames);
                    catchClauseUnshadowedNames.delete(escapedName);
                }
            });
            if (catchClauseUnshadowedNames) {
                const savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
                enclosingFunctionParameterNames = catchClauseUnshadowedNames;
                const result = visitEachChild(node, asyncBodyVisitor, context);
                enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
                return result;
            } else return visitEachChild(node, asyncBodyVisitor, context);
        }
        function visitVariableStatementInAsyncBody(node) {
            if (isVariableDeclarationListWithCollidingName(node.declarationList)) {
                const expression = visitVariableDeclarationListWithCollidingNames(node.declarationList, /*hasReceiver*/ false);
                return expression ? factory2.createExpressionStatement(expression) : void 0;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitForInStatementInAsyncBody(node) {
            return factory2.updateForInStatement(node, isVariableDeclarationListWithCollidingName(node.initializer) ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true) : Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), visitIterationBody(node.statement, asyncBodyVisitor, context));
        }
        function visitForOfStatementInAsyncBody(node) {
            return factory2.updateForOfStatement(node, visitNode(node.awaitModifier, visitor, isAwaitKeyword), isVariableDeclarationListWithCollidingName(node.initializer) ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true) : Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), visitIterationBody(node.statement, asyncBodyVisitor, context));
        }
        function visitForStatementInAsyncBody(node) {
            const initializer = node.initializer;
            return factory2.updateForStatement(node, isVariableDeclarationListWithCollidingName(initializer) ? visitVariableDeclarationListWithCollidingNames(initializer, /*hasReceiver*/ false) : visitNode(node.initializer, visitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitor, isExpression), visitIterationBody(node.statement, asyncBodyVisitor, context));
        }
        function visitAwaitExpression(node) {
            if (inTopLevelContext()) return visitEachChild(node, visitor, context);
            return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, visitNode(node.expression, visitor, isExpression)), node), node);
        }
        function visitConstructorDeclaration(node) {
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            lexicalArgumentsBinding = void 0;
            const updated = factory2.updateConstructorDeclaration(node, visitNodes2(node.modifiers, visitor, isModifier), visitParameterList(node.parameters, visitor, context), transformMethodBody(node));
            lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            return updated;
        }
        function visitMethodDeclaration(node) {
            let parameters;
            const functionFlags = getFunctionFlags(node);
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            lexicalArgumentsBinding = void 0;
            const updated = factory2.updateMethodDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.asteriskToken, node.name, /*questionToken*/ void 0, /*typeParameters*/ void 0, parameters = functionFlags & 2 /* Async */  ? transformAsyncFunctionParameterList(node) : visitParameterList(node.parameters, visitor, context), /*type*/ void 0, functionFlags & 2 /* Async */  ? transformAsyncFunctionBody(node, parameters) : transformMethodBody(node));
            lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            return updated;
        }
        function visitGetAccessorDeclaration(node) {
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            lexicalArgumentsBinding = void 0;
            const updated = factory2.updateGetAccessorDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.name, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformMethodBody(node));
            lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            return updated;
        }
        function visitSetAccessorDeclaration(node) {
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            lexicalArgumentsBinding = void 0;
            const updated = factory2.updateSetAccessorDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.name, visitParameterList(node.parameters, visitor, context), transformMethodBody(node));
            lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            return updated;
        }
        function visitFunctionDeclaration(node) {
            let parameters;
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            lexicalArgumentsBinding = void 0;
            const functionFlags = getFunctionFlags(node);
            const updated = factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, visitor, isModifierLike), node.asteriskToken, node.name, /*typeParameters*/ void 0, parameters = functionFlags & 2 /* Async */  ? transformAsyncFunctionParameterList(node) : visitParameterList(node.parameters, visitor, context), /*type*/ void 0, functionFlags & 2 /* Async */  ? transformAsyncFunctionBody(node, parameters) : visitFunctionBody(node.body, visitor, context));
            lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            return updated;
        }
        function visitFunctionExpression(node) {
            let parameters;
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            lexicalArgumentsBinding = void 0;
            const functionFlags = getFunctionFlags(node);
            const updated = factory2.updateFunctionExpression(node, visitNodes2(node.modifiers, visitor, isModifier), node.asteriskToken, node.name, /*typeParameters*/ void 0, parameters = functionFlags & 2 /* Async */  ? transformAsyncFunctionParameterList(node) : visitParameterList(node.parameters, visitor, context), /*type*/ void 0, functionFlags & 2 /* Async */  ? transformAsyncFunctionBody(node, parameters) : visitFunctionBody(node.body, visitor, context));
            lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            return updated;
        }
        function visitArrowFunction(node) {
            let parameters;
            const functionFlags = getFunctionFlags(node);
            return factory2.updateArrowFunction(node, visitNodes2(node.modifiers, visitor, isModifier), /*typeParameters*/ void 0, parameters = functionFlags & 2 /* Async */  ? transformAsyncFunctionParameterList(node) : visitParameterList(node.parameters, visitor, context), /*type*/ void 0, node.equalsGreaterThanToken, functionFlags & 2 /* Async */  ? transformAsyncFunctionBody(node, parameters) : visitFunctionBody(node.body, visitor, context));
        }
        function recordDeclarationName({ name }, names) {
            if (isIdentifier(name)) names.add(name.escapedText);
            else {
                for (const element of name.elements)if (!isOmittedExpression(element)) recordDeclarationName(element, names);
            }
        }
        function isVariableDeclarationListWithCollidingName(node) {
            return !!node && isVariableDeclarationList(node) && !(node.flags & 7 /* BlockScoped */ ) && node.declarations.some(collidesWithParameterName);
        }
        function visitVariableDeclarationListWithCollidingNames(node, hasReceiver) {
            hoistVariableDeclarationList(node);
            const variables = getInitializedVariables(node);
            if (variables.length === 0) {
                if (hasReceiver) return visitNode(factory2.converters.convertToAssignmentElementTarget(node.declarations[0].name), visitor, isExpression);
                return void 0;
            }
            return factory2.inlineExpressions(map(variables, transformInitializedVariable));
        }
        function hoistVariableDeclarationList(node) {
            forEach(node.declarations, hoistVariable);
        }
        function hoistVariable({ name }) {
            if (isIdentifier(name)) hoistVariableDeclaration(name);
            else {
                for (const element of name.elements)if (!isOmittedExpression(element)) hoistVariable(element);
            }
        }
        function transformInitializedVariable(node) {
            const converted = setSourceMapRange(factory2.createAssignment(factory2.converters.convertToAssignmentElementTarget(node.name), node.initializer), node);
            return Debug.checkDefined(visitNode(converted, visitor, isExpression));
        }
        function collidesWithParameterName({ name }) {
            if (isIdentifier(name)) return enclosingFunctionParameterNames.has(name.escapedText);
            else for (const element of name.elements){
                if (!isOmittedExpression(element) && collidesWithParameterName(element)) return true;
            }
            return false;
        }
        function transformMethodBody(node) {
            Debug.assertIsDefined(node.body);
            const savedCapturedSuperProperties = capturedSuperProperties;
            const savedHasSuperElementAccess = hasSuperElementAccess;
            capturedSuperProperties = /* @__PURE__ */ new Set();
            hasSuperElementAccess = false;
            let updated = visitFunctionBody(node.body, visitor, context);
            const originalMethod = getOriginalNode(node, isFunctionLikeDeclaration);
            const emitSuperHelpers = languageVersion >= 2 /* ES2015 */  && (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) || resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ )) && (getFunctionFlags(originalMethod) & 3 /* AsyncGenerator */ ) !== 3 /* AsyncGenerator */ ;
            if (emitSuperHelpers) {
                enableSubstitutionForAsyncMethodsWithSuper();
                if (capturedSuperProperties.size) {
                    const variableStatement = createSuperAccessVariableStatement(factory2, resolver, node, capturedSuperProperties);
                    substitutedSuperAccessors[getNodeId(variableStatement)] = true;
                    const statements = updated.statements.slice();
                    insertStatementsAfterStandardPrologue(statements, [
                        variableStatement
                    ]);
                    updated = factory2.updateBlock(updated, statements);
                }
                if (hasSuperElementAccess) {
                    if (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ )) addEmitHelper(updated, advancedAsyncSuperHelper);
                    else if (resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ )) addEmitHelper(updated, asyncSuperHelper);
                }
            }
            capturedSuperProperties = savedCapturedSuperProperties;
            hasSuperElementAccess = savedHasSuperElementAccess;
            return updated;
        }
        function createCaptureArgumentsStatement() {
            Debug.assert(lexicalArgumentsBinding);
            const variable = factory2.createVariableDeclaration(lexicalArgumentsBinding, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createIdentifier("arguments"));
            const statement = factory2.createVariableStatement(/*modifiers*/ void 0, [
                variable
            ]);
            startOnNewLine(statement);
            addEmitFlags(statement, 2097152 /* CustomPrologue */ );
            return statement;
        }
        function transformAsyncFunctionParameterList(node) {
            if (isSimpleParameterList(node.parameters)) return visitParameterList(node.parameters, visitor, context);
            const newParameters = [];
            for (const parameter of node.parameters){
                if (parameter.initializer || parameter.dotDotDotToken) {
                    if (node.kind === 220 /* ArrowFunction */ ) {
                        const restParameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, factory2.createToken(26 /* DotDotDotToken */ ), factory2.createUniqueName("args", 8 /* ReservedInNestedScopes */ ));
                        newParameters.push(restParameter);
                    }
                    break;
                }
                const newParameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.getGeneratedNameForNode(parameter.name, 8 /* ReservedInNestedScopes */ ));
                newParameters.push(newParameter);
            }
            const newParametersArray = factory2.createNodeArray(newParameters);
            setTextRange(newParametersArray, node.parameters);
            return newParametersArray;
        }
        function transformAsyncFunctionBody(node, outerParameters) {
            const innerParameters = !isSimpleParameterList(node.parameters) ? visitParameterList(node.parameters, visitor, context) : void 0;
            resumeLexicalEnvironment();
            const original = getOriginalNode(node, isFunctionLike);
            const nodeType = original.type;
            const promiseConstructor = languageVersion < 2 /* ES2015 */  ? getPromiseConstructor(nodeType) : void 0;
            const isArrowFunction2 = node.kind === 220 /* ArrowFunction */ ;
            const savedLexicalArgumentsBinding = lexicalArgumentsBinding;
            const hasLexicalArguments = resolver.hasNodeCheckFlag(node, 512 /* CaptureArguments */ );
            const captureLexicalArguments = hasLexicalArguments && !lexicalArgumentsBinding;
            if (captureLexicalArguments) lexicalArgumentsBinding = factory2.createUniqueName("arguments");
            let argumentsExpression;
            if (innerParameters) {
                if (isArrowFunction2) {
                    const parameterBindings = [];
                    Debug.assert(outerParameters.length <= node.parameters.length);
                    for(let i = 0; i < node.parameters.length; i++){
                        Debug.assert(i < outerParameters.length);
                        const originalParameter = node.parameters[i];
                        const outerParameter = outerParameters[i];
                        Debug.assertNode(outerParameter.name, isIdentifier);
                        if (originalParameter.initializer || originalParameter.dotDotDotToken) {
                            Debug.assert(i === outerParameters.length - 1);
                            parameterBindings.push(factory2.createSpreadElement(outerParameter.name));
                            break;
                        }
                        parameterBindings.push(outerParameter.name);
                    }
                    argumentsExpression = factory2.createArrayLiteralExpression(parameterBindings);
                } else argumentsExpression = factory2.createIdentifier("arguments");
            }
            const savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
            enclosingFunctionParameterNames = /* @__PURE__ */ new Set();
            for (const parameter of node.parameters)recordDeclarationName(parameter, enclosingFunctionParameterNames);
            const savedCapturedSuperProperties = capturedSuperProperties;
            const savedHasSuperElementAccess = hasSuperElementAccess;
            if (!isArrowFunction2) {
                capturedSuperProperties = /* @__PURE__ */ new Set();
                hasSuperElementAccess = false;
            }
            const hasLexicalThis = inHasLexicalThisContext();
            let asyncBody = transformAsyncFunctionBodyWorker(node.body);
            asyncBody = factory2.updateBlock(asyncBody, factory2.mergeLexicalEnvironment(asyncBody.statements, endLexicalEnvironment()));
            let result;
            if (!isArrowFunction2) {
                const statements = [];
                statements.push(factory2.createReturnStatement(emitHelpers().createAwaiterHelper(hasLexicalThis, argumentsExpression, promiseConstructor, innerParameters, asyncBody)));
                const emitSuperHelpers = languageVersion >= 2 /* ES2015 */  && (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) || resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ ));
                if (emitSuperHelpers) {
                    enableSubstitutionForAsyncMethodsWithSuper();
                    if (capturedSuperProperties.size) {
                        const variableStatement = createSuperAccessVariableStatement(factory2, resolver, node, capturedSuperProperties);
                        substitutedSuperAccessors[getNodeId(variableStatement)] = true;
                        insertStatementsAfterStandardPrologue(statements, [
                            variableStatement
                        ]);
                    }
                }
                if (captureLexicalArguments) insertStatementsAfterStandardPrologue(statements, [
                    createCaptureArgumentsStatement()
                ]);
                const block = factory2.createBlock(statements, /*multiLine*/ true);
                setTextRange(block, node.body);
                if (emitSuperHelpers && hasSuperElementAccess) {
                    if (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ )) addEmitHelper(block, advancedAsyncSuperHelper);
                    else if (resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ )) addEmitHelper(block, asyncSuperHelper);
                }
                result = block;
            } else {
                result = emitHelpers().createAwaiterHelper(hasLexicalThis, argumentsExpression, promiseConstructor, innerParameters, asyncBody);
                if (captureLexicalArguments) {
                    const block = factory2.converters.convertToFunctionBlock(result);
                    result = factory2.updateBlock(block, factory2.mergeLexicalEnvironment(block.statements, [
                        createCaptureArgumentsStatement()
                    ]));
                }
            }
            enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
            if (!isArrowFunction2) {
                capturedSuperProperties = savedCapturedSuperProperties;
                hasSuperElementAccess = savedHasSuperElementAccess;
                lexicalArgumentsBinding = savedLexicalArgumentsBinding;
            }
            return result;
        }
        function transformAsyncFunctionBodyWorker(body, start) {
            if (isBlock(body)) return factory2.updateBlock(body, visitNodes2(body.statements, asyncBodyVisitor, isStatement, start));
            else return factory2.converters.convertToFunctionBlock(Debug.checkDefined(visitNode(body, asyncBodyVisitor, isConciseBody)));
        }
        function getPromiseConstructor(type) {
            const typeName = type && getEntityNameFromTypeNode(type);
            if (typeName && isEntityName(typeName)) {
                const serializationKind = resolver.getTypeReferenceSerializationKind(typeName);
                if (serializationKind === 1 /* TypeWithConstructSignatureAndValue */  || serializationKind === 0 /* Unknown */ ) return typeName;
            }
            return void 0;
        }
        function enableSubstitutionForAsyncMethodsWithSuper() {
            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ ) === 0) {
                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */ ;
                context.enableSubstitution(214 /* CallExpression */ );
                context.enableSubstitution(212 /* PropertyAccessExpression */ );
                context.enableSubstitution(213 /* ElementAccessExpression */ );
                context.enableEmitNotification(264 /* ClassDeclaration */ );
                context.enableEmitNotification(175 /* MethodDeclaration */ );
                context.enableEmitNotification(178 /* GetAccessor */ );
                context.enableEmitNotification(179 /* SetAccessor */ );
                context.enableEmitNotification(177 /* Constructor */ );
                context.enableEmitNotification(244 /* VariableStatement */ );
            }
        }
        function onEmitNode(hint, node, emitCallback) {
            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */  && isSuperContainer(node)) {
                const superContainerFlags = (resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ ) ? 128 /* MethodWithSuperPropertyAccessInAsync */  : 0) | (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) ? 256 /* MethodWithSuperPropertyAssignmentInAsync */  : 0);
                if (superContainerFlags !== enclosingSuperContainerFlags) {
                    const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                    enclosingSuperContainerFlags = superContainerFlags;
                    previousOnEmitNode(hint, node, emitCallback);
                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                    return;
                }
            } else if (enabledSubstitutions && substitutedSuperAccessors[getNodeId(node)]) {
                const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                enclosingSuperContainerFlags = 0;
                previousOnEmitNode(hint, node, emitCallback);
                enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                return;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */  && enclosingSuperContainerFlags) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 212 /* PropertyAccessExpression */ :
                    return substitutePropertyAccessExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return substituteElementAccessExpression(node);
                case 214 /* CallExpression */ :
                    return substituteCallExpression(node);
            }
            return node;
        }
        function substitutePropertyAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createUniqueName("_super", 48 /* FileLevel */ ), node.name), node);
            return node;
        }
        function substituteElementAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return createSuperElementAccessInAsyncMethod(node.argumentExpression, node);
            return node;
        }
        function substituteCallExpression(node) {
            const expression = node.expression;
            if (isSuperProperty(expression)) {
                const argumentExpression = isPropertyAccessExpression(expression) ? substitutePropertyAccessExpression(expression) : substituteElementAccessExpression(expression);
                return factory2.createCallExpression(factory2.createPropertyAccessExpression(argumentExpression, "call"), /*typeArguments*/ void 0, [
                    factory2.createThis(),
                    ...node.arguments
                ]);
            }
            return node;
        }
        function isSuperContainer(node) {
            const kind = node.kind;
            return kind === 264 /* ClassDeclaration */  || kind === 177 /* Constructor */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */ ;
        }
        function createSuperElementAccessInAsyncMethod(argumentExpression, location) {
            if (enclosingSuperContainerFlags & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createCallExpression(factory2.createUniqueName("_superIndex", 48 /* FileLevel */ ), /*typeArguments*/ void 0, [
                argumentExpression
            ]), "value"), location);
            else return setTextRange(factory2.createCallExpression(factory2.createUniqueName("_superIndex", 48 /* FileLevel */ ), /*typeArguments*/ void 0, [
                argumentExpression
            ]), location);
        }
    }
    function createSuperAccessVariableStatement(factory2, resolver, node, names) {
        const hasBinding = resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ );
        const accessors = [];
        names.forEach((_, key)=>{
            const name = unescapeLeadingUnderscores(key);
            const getterAndSetter = [];
            getterAndSetter.push(factory2.createPropertyAssignment("get", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /* parameters */ [], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, setEmitFlags(factory2.createPropertyAccessExpression(setEmitFlags(factory2.createSuper(), 8 /* NoSubstitution */ ), name), 8 /* NoSubstitution */ ))));
            if (hasBinding) getterAndSetter.push(factory2.createPropertyAssignment("set", factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /* parameters */ [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "v", /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
            ], /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, factory2.createAssignment(setEmitFlags(factory2.createPropertyAccessExpression(setEmitFlags(factory2.createSuper(), 8 /* NoSubstitution */ ), name), 8 /* NoSubstitution */ ), factory2.createIdentifier("v")))));
            accessors.push(factory2.createPropertyAssignment(name, factory2.createObjectLiteralExpression(getterAndSetter)));
        });
        return factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
            factory2.createVariableDeclaration(factory2.createUniqueName("_super", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "create"), /*typeArguments*/ void 0, [
                factory2.createNull(),
                factory2.createObjectLiteralExpression(accessors, /*multiLine*/ true)
            ]))
        ], 2 /* Const */ ));
    }
    // src/compiler/transformers/es2018.ts
    function transformES2018(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, resumeLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const previousOnEmitNode = context.onEmitNode;
        context.onEmitNode = onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        let exportedVariableStatement = false;
        let enabledSubstitutions = 0 /* None */ ;
        let enclosingFunctionFlags;
        let parametersWithPrecedingObjectRestOrSpread;
        let enclosingSuperContainerFlags = 0;
        let hierarchyFacts = 0;
        let currentSourceFile;
        let taggedTemplateStringDeclarations;
        let capturedSuperProperties;
        let hasSuperElementAccess;
        const substitutedSuperAccessors = [];
        return chainBundle(context, transformSourceFile);
        function affectsSubtree(excludeFacts, includeFacts) {
            return hierarchyFacts !== (hierarchyFacts & ~excludeFacts | includeFacts);
        }
        function enterSubtree(excludeFacts, includeFacts) {
            const ancestorFacts = hierarchyFacts;
            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & 3 /* AncestorFactsMask */ ;
            return ancestorFacts;
        }
        function exitSubtree(ancestorFacts) {
            hierarchyFacts = ancestorFacts;
        }
        function recordTaggedTemplateString(temp) {
            taggedTemplateStringDeclarations = append(taggedTemplateStringDeclarations, factory2.createVariableDeclaration(temp));
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            const visited = visitSourceFile(node);
            addEmitHelpers(visited, context.readEmitHelpers());
            currentSourceFile = void 0;
            taggedTemplateStringDeclarations = void 0;
            return visited;
        }
        function visitor(node) {
            return visitorWorker(node, /*expressionResultIsUnused*/ false);
        }
        function visitorWithUnusedExpressionResult(node) {
            return visitorWorker(node, /*expressionResultIsUnused*/ true);
        }
        function visitorNoAsyncModifier(node) {
            if (node.kind === 134 /* AsyncKeyword */ ) return void 0;
            return node;
        }
        function doWithHierarchyFacts(cb, value1, excludeFacts, includeFacts) {
            if (affectsSubtree(excludeFacts, includeFacts)) {
                const ancestorFacts = enterSubtree(excludeFacts, includeFacts);
                const result = cb(value1);
                exitSubtree(ancestorFacts);
                return result;
            }
            return cb(value1);
        }
        function visitDefault(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitorWorker(node, expressionResultIsUnused2) {
            if ((node.transformFlags & 128 /* ContainsES2018 */ ) === 0) return node;
            switch(node.kind){
                case 224 /* AwaitExpression */ :
                    return visitAwaitExpression(node);
                case 230 /* YieldExpression */ :
                    return visitYieldExpression(node);
                case 254 /* ReturnStatement */ :
                    return visitReturnStatement(node);
                case 257 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 211 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node, expressionResultIsUnused2);
                case 357 /* CommaListExpression */ :
                    return visitCommaListExpression(node, expressionResultIsUnused2);
                case 300 /* CatchClause */ :
                    return visitCatchClause(node);
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 261 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                case 250 /* ForInStatement */ :
                    return doWithHierarchyFacts(visitDefault, node, 0 /* IterationStatementExcludes */ , 2 /* IterationStatementIncludes */ );
                case 251 /* ForOfStatement */ :
                    return visitForOfStatement(node, /*outermostLabeledStatement*/ void 0);
                case 249 /* ForStatement */ :
                    return doWithHierarchyFacts(visitForStatement, node, 0 /* IterationStatementExcludes */ , 2 /* IterationStatementIncludes */ );
                case 223 /* VoidExpression */ :
                    return visitVoidExpression(node);
                case 177 /* Constructor */ :
                    return doWithHierarchyFacts(visitConstructorDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 175 /* MethodDeclaration */ :
                    return doWithHierarchyFacts(visitMethodDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 178 /* GetAccessor */ :
                    return doWithHierarchyFacts(visitGetAccessorDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 179 /* SetAccessor */ :
                    return doWithHierarchyFacts(visitSetAccessorDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 263 /* FunctionDeclaration */ :
                    return doWithHierarchyFacts(visitFunctionDeclaration, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 219 /* FunctionExpression */ :
                    return doWithHierarchyFacts(visitFunctionExpression, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                case 220 /* ArrowFunction */ :
                    return doWithHierarchyFacts(visitArrowFunction, node, 2 /* ArrowFunctionExcludes */ , 0 /* ArrowFunctionIncludes */ );
                case 170 /* Parameter */ :
                    return visitParameter(node);
                case 245 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, expressionResultIsUnused2);
                case 216 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 212 /* PropertyAccessExpression */ :
                    if (capturedSuperProperties && isPropertyAccessExpression(node) && node.expression.kind === 108 /* SuperKeyword */ ) capturedSuperProperties.add(node.name.escapedText);
                    return visitEachChild(node, visitor, context);
                case 213 /* ElementAccessExpression */ :
                    if (capturedSuperProperties && node.expression.kind === 108 /* SuperKeyword */ ) hasSuperElementAccess = true;
                    return visitEachChild(node, visitor, context);
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                    return doWithHierarchyFacts(visitDefault, node, 2 /* ClassOrFunctionExcludes */ , 1 /* ClassOrFunctionIncludes */ );
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitAwaitExpression(node) {
            if (enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */ ) return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, emitHelpers().createAwaitHelper(visitNode(node.expression, visitor, isExpression))), /*location*/ node), node);
            return visitEachChild(node, visitor, context);
        }
        function visitYieldExpression(node) {
            if (enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */ ) {
                if (node.asteriskToken) {
                    const expression = visitNode(Debug.checkDefined(node.expression), visitor, isExpression);
                    return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, emitHelpers().createAwaitHelper(factory2.updateYieldExpression(node, node.asteriskToken, setTextRange(emitHelpers().createAsyncDelegatorHelper(setTextRange(emitHelpers().createAsyncValuesHelper(expression), expression)), expression)))), node), node);
                }
                return setOriginalNode(setTextRange(factory2.createYieldExpression(/*asteriskToken*/ void 0, createDownlevelAwait(node.expression ? visitNode(node.expression, visitor, isExpression) : factory2.createVoidZero())), node), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitReturnStatement(node) {
            if (enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */ ) return factory2.updateReturnStatement(node, createDownlevelAwait(node.expression ? visitNode(node.expression, visitor, isExpression) : factory2.createVoidZero()));
            return visitEachChild(node, visitor, context);
        }
        function visitLabeledStatement(node) {
            if (enclosingFunctionFlags & 2 /* Async */ ) {
                const statement = unwrapInnermostStatementOfLabel(node);
                if (statement.kind === 251 /* ForOfStatement */  && statement.awaitModifier) return visitForOfStatement(statement, node);
                return factory2.restoreEnclosingLabel(visitNode(statement, visitor, isStatement, factory2.liftToBlock), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function chunkObjectLiteralElements(elements) {
            let chunkObject;
            const objects = [];
            for (const e of elements)if (e.kind === 306 /* SpreadAssignment */ ) {
                if (chunkObject) {
                    objects.push(factory2.createObjectLiteralExpression(chunkObject));
                    chunkObject = void 0;
                }
                const target = e.expression;
                objects.push(visitNode(target, visitor, isExpression));
            } else chunkObject = append(chunkObject, e.kind === 304 /* PropertyAssignment */  ? factory2.createPropertyAssignment(e.name, visitNode(e.initializer, visitor, isExpression)) : visitNode(e, visitor, isObjectLiteralElementLike));
            if (chunkObject) objects.push(factory2.createObjectLiteralExpression(chunkObject));
            return objects;
        }
        function visitObjectLiteralExpression(node) {
            if (node.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) {
                const objects = chunkObjectLiteralElements(node.properties);
                if (objects.length && objects[0].kind !== 211 /* ObjectLiteralExpression */ ) objects.unshift(factory2.createObjectLiteralExpression());
                let expression = objects[0];
                if (objects.length > 1) {
                    for(let i = 1; i < objects.length; i++)expression = emitHelpers().createAssignHelper([
                        expression,
                        objects[i]
                    ]);
                    return expression;
                } else return emitHelpers().createAssignHelper(objects);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitExpressionStatement(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitParenthesizedExpression(node, expressionResultIsUnused2) {
            return visitEachChild(node, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, context);
        }
        function visitSourceFile(node) {
            const ancestorFacts = enterSubtree(2 /* SourceFileExcludes */ , isEffectiveStrictModeSourceFile(node, compilerOptions) ? 0 /* StrictModeSourceFileIncludes */  : 1 /* SourceFileIncludes */ );
            exportedVariableStatement = false;
            const visited = visitEachChild(node, visitor, context);
            const statement = concatenate(visited.statements, taggedTemplateStringDeclarations && [
                factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(taggedTemplateStringDeclarations))
            ]);
            const result = factory2.updateSourceFile(visited, setTextRange(factory2.createNodeArray(statement), node.statements));
            exitSubtree(ancestorFacts);
            return result;
        }
        function visitTaggedTemplateExpression(node) {
            return processTaggedTemplateExpression(context, node, visitor, currentSourceFile, recordTaggedTemplateString, 0 /* LiftRestriction */ );
        }
        function visitBinaryExpression(node, expressionResultIsUnused2) {
            if (isDestructuringAssignment(node) && containsObjectRestOrSpread(node.left)) return flattenDestructuringAssignment(node, visitor, context, 1 /* ObjectRest */ , !expressionResultIsUnused2);
            if (node.operatorToken.kind === 28 /* CommaToken */ ) return factory2.updateBinaryExpression(node, visitNode(node.left, visitorWithUnusedExpressionResult, isExpression), node.operatorToken, visitNode(node.right, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, isExpression));
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, expressionResultIsUnused2) {
            if (expressionResultIsUnused2) return visitEachChild(node, visitorWithUnusedExpressionResult, context);
            let result;
            for(let i = 0; i < node.elements.length; i++){
                const element = node.elements[i];
                const visited = visitNode(element, i < node.elements.length - 1 ? visitorWithUnusedExpressionResult : visitor, isExpression);
                if (result || visited !== element) {
                    result || (result = node.elements.slice(0, i));
                    result.push(visited);
                }
            }
            const elements = result ? setTextRange(factory2.createNodeArray(result), node.elements) : node.elements;
            return factory2.updateCommaListExpression(node, elements);
        }
        function visitCatchClause(node) {
            if (node.variableDeclaration && isBindingPattern(node.variableDeclaration.name) && node.variableDeclaration.name.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) {
                const name = factory2.getGeneratedNameForNode(node.variableDeclaration.name);
                const updatedDecl = factory2.updateVariableDeclaration(node.variableDeclaration, node.variableDeclaration.name, /*exclamationToken*/ void 0, /*type*/ void 0, name);
                const visitedBindings = flattenDestructuringBinding(updatedDecl, visitor, context, 1 /* ObjectRest */ );
                let block = visitNode(node.block, visitor, isBlock);
                if (some(visitedBindings)) block = factory2.updateBlock(block, [
                    factory2.createVariableStatement(/*modifiers*/ void 0, visitedBindings),
                    ...block.statements
                ]);
                return factory2.updateCatchClause(node, factory2.updateVariableDeclaration(node.variableDeclaration, name, /*exclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0), block);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitVariableStatement(node) {
            if (hasSyntacticModifier(node, 32 /* Export */ )) {
                const savedExportedVariableStatement = exportedVariableStatement;
                exportedVariableStatement = true;
                const visited = visitEachChild(node, visitor, context);
                exportedVariableStatement = savedExportedVariableStatement;
                return visited;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitVariableDeclaration(node) {
            if (exportedVariableStatement) {
                const savedExportedVariableStatement = exportedVariableStatement;
                exportedVariableStatement = false;
                const visited = visitVariableDeclarationWorker(node, /*exportedVariableStatement*/ true);
                exportedVariableStatement = savedExportedVariableStatement;
                return visited;
            }
            return visitVariableDeclarationWorker(node, /*exportedVariableStatement*/ false);
        }
        function visitVariableDeclarationWorker(node, exportedVariableStatement2) {
            if (isBindingPattern(node.name) && node.name.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return flattenDestructuringBinding(node, visitor, context, 1 /* ObjectRest */ , /*rval*/ void 0, exportedVariableStatement2);
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, visitorWithUnusedExpressionResult, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitorWithUnusedExpressionResult, isExpression), visitIterationBody(node.statement, visitor, context));
        }
        function visitVoidExpression(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitForOfStatement(node, outermostLabeledStatement) {
            const ancestorFacts = enterSubtree(0 /* IterationStatementExcludes */ , 2 /* IterationStatementIncludes */ );
            if (node.initializer.transformFlags & 65536 /* ContainsObjectRestOrSpread */  || isAssignmentPattern(node.initializer) && containsObjectRestOrSpread(node.initializer)) node = transformForOfStatementWithObjectRest(node);
            const result = node.awaitModifier ? transformForAwaitOfStatement(node, outermostLabeledStatement, ancestorFacts) : factory2.restoreEnclosingLabel(visitEachChild(node, visitor, context), outermostLabeledStatement);
            exitSubtree(ancestorFacts);
            return result;
        }
        function transformForOfStatementWithObjectRest(node) {
            const initializerWithoutParens = skipParentheses(node.initializer);
            if (isVariableDeclarationList(initializerWithoutParens) || isAssignmentPattern(initializerWithoutParens)) {
                let bodyLocation;
                let statementsLocation;
                const temp = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                const statements = [
                    createForOfBindingStatement(factory2, initializerWithoutParens, temp)
                ];
                if (isBlock(node.statement)) {
                    addRange(statements, node.statement.statements);
                    bodyLocation = node.statement;
                    statementsLocation = node.statement.statements;
                } else if (node.statement) {
                    append(statements, node.statement);
                    bodyLocation = node.statement;
                    statementsLocation = node.statement;
                }
                return factory2.updateForOfStatement(node, node.awaitModifier, setTextRange(factory2.createVariableDeclarationList([
                    setTextRange(factory2.createVariableDeclaration(temp), node.initializer)
                ], 1 /* Let */ ), node.initializer), node.expression, setTextRange(factory2.createBlock(setTextRange(factory2.createNodeArray(statements), statementsLocation), /*multiLine*/ true), bodyLocation));
            }
            return node;
        }
        function convertForOfStatementHead(node, boundValue, nonUserCode) {
            const value1 = factory2.createTempVariable(hoistVariableDeclaration);
            const iteratorValueExpression = factory2.createAssignment(value1, boundValue);
            const iteratorValueStatement = factory2.createExpressionStatement(iteratorValueExpression);
            setSourceMapRange(iteratorValueStatement, node.expression);
            const exitNonUserCodeExpression = factory2.createAssignment(nonUserCode, factory2.createFalse());
            const exitNonUserCodeStatement = factory2.createExpressionStatement(exitNonUserCodeExpression);
            setSourceMapRange(exitNonUserCodeStatement, node.expression);
            const statements = [
                iteratorValueStatement,
                exitNonUserCodeStatement
            ];
            const binding = createForOfBindingStatement(factory2, node.initializer, value1);
            statements.push(visitNode(binding, visitor, isStatement));
            let bodyLocation;
            let statementsLocation;
            const statement = visitIterationBody(node.statement, visitor, context);
            if (isBlock(statement)) {
                addRange(statements, statement.statements);
                bodyLocation = statement;
                statementsLocation = statement.statements;
            } else statements.push(statement);
            return setTextRange(factory2.createBlock(setTextRange(factory2.createNodeArray(statements), statementsLocation), /*multiLine*/ true), bodyLocation);
        }
        function createDownlevelAwait(expression) {
            return enclosingFunctionFlags & 1 /* Generator */  ? factory2.createYieldExpression(/*asteriskToken*/ void 0, emitHelpers().createAwaitHelper(expression)) : factory2.createAwaitExpression(expression);
        }
        function transformForAwaitOfStatement(node, outermostLabeledStatement, ancestorFacts) {
            const expression = visitNode(node.expression, visitor, isExpression);
            const iterator = isIdentifier(expression) ? factory2.getGeneratedNameForNode(expression) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const result = isIdentifier(expression) ? factory2.getGeneratedNameForNode(iterator) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const nonUserCode = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const done = factory2.createTempVariable(hoistVariableDeclaration);
            const errorRecord = factory2.createUniqueName("e");
            const catchVariable = factory2.getGeneratedNameForNode(errorRecord);
            const returnMethod = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const callValues = setTextRange(emitHelpers().createAsyncValuesHelper(expression), node.expression);
            const callNext = factory2.createCallExpression(factory2.createPropertyAccessExpression(iterator, "next"), /*typeArguments*/ void 0, []);
            const getDone = factory2.createPropertyAccessExpression(result, "done");
            const getValue = factory2.createPropertyAccessExpression(result, "value");
            const callReturn = factory2.createFunctionCallCall(returnMethod, iterator, []);
            hoistVariableDeclaration(errorRecord);
            hoistVariableDeclaration(returnMethod);
            const initializer = ancestorFacts & 2 /* IterationContainer */  ? factory2.inlineExpressions([
                factory2.createAssignment(errorRecord, factory2.createVoidZero()),
                callValues
            ]) : callValues;
            const forStatement = setEmitFlags(setTextRange(factory2.createForStatement(/*initializer*/ setEmitFlags(setTextRange(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(nonUserCode, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createTrue()),
                setTextRange(factory2.createVariableDeclaration(iterator, /*exclamationToken*/ void 0, /*type*/ void 0, initializer), node.expression),
                factory2.createVariableDeclaration(result)
            ]), node.expression), 4194304 /* NoHoisting */ ), /*condition*/ factory2.inlineExpressions([
                factory2.createAssignment(result, createDownlevelAwait(callNext)),
                factory2.createAssignment(done, getDone),
                factory2.createLogicalNot(done)
            ]), /*incrementor*/ factory2.createAssignment(nonUserCode, factory2.createTrue()), /*statement*/ convertForOfStatementHead(node, getValue, nonUserCode)), /*location*/ node), 512 /* NoTokenTrailingSourceMaps */ );
            setOriginalNode(forStatement, node);
            return factory2.createTryStatement(factory2.createBlock([
                factory2.restoreEnclosingLabel(forStatement, outermostLabeledStatement)
            ]), factory2.createCatchClause(factory2.createVariableDeclaration(catchVariable), setEmitFlags(factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(errorRecord, factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("error", catchVariable)
                ])))
            ]), 1 /* SingleLine */ )), factory2.createBlock([
                factory2.createTryStatement(/*tryBlock*/ factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(factory2.createLogicalAnd(factory2.createLogicalAnd(factory2.createLogicalNot(nonUserCode), factory2.createLogicalNot(done)), factory2.createAssignment(returnMethod, factory2.createPropertyAccessExpression(iterator, "return"))), factory2.createExpressionStatement(createDownlevelAwait(callReturn))), 1 /* SingleLine */ )
                ]), /*catchClause*/ void 0, /*finallyBlock*/ setEmitFlags(factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(errorRecord, factory2.createThrowStatement(factory2.createPropertyAccessExpression(errorRecord, "error"))), 1 /* SingleLine */ )
                ]), 1 /* SingleLine */ ))
            ]));
        }
        function parameterVisitor(node) {
            Debug.assertNode(node, isParameter);
            return visitParameter(node);
        }
        function visitParameter(node) {
            if (parametersWithPrecedingObjectRestOrSpread == null ? void 0 : parametersWithPrecedingObjectRestOrSpread.has(node)) return factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, node.dotDotDotToken, isBindingPattern(node.name) ? factory2.getGeneratedNameForNode(node) : node.name, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            if (node.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) return factory2.updateParameterDeclaration(node, /*modifiers*/ void 0, node.dotDotDotToken, factory2.getGeneratedNameForNode(node), /*questionToken*/ void 0, /*type*/ void 0, visitNode(node.initializer, visitor, isExpression));
            return visitEachChild(node, visitor, context);
        }
        function collectParametersWithPrecedingObjectRestOrSpread(node) {
            let parameters;
            for (const parameter of node.parameters){
                if (parameters) parameters.add(parameter);
                else if (parameter.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) parameters = /* @__PURE__ */ new Set();
            }
            return parameters;
        }
        function visitConstructorDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateConstructorDeclaration(node, node.modifiers, visitParameterList(node.parameters, parameterVisitor, context), transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitGetAccessorDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateGetAccessorDeclaration(node, node.modifiers, visitNode(node.name, visitor, isPropertyName), visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitSetAccessorDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateSetAccessorDeclaration(node, node.modifiers, visitNode(node.name, visitor, isPropertyName), visitParameterList(node.parameters, parameterVisitor, context), transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitMethodDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateMethodDeclaration(node, enclosingFunctionFlags & 1 /* Generator */  ? visitNodes2(node.modifiers, visitorNoAsyncModifier, isModifierLike) : node.modifiers, enclosingFunctionFlags & 2 /* Async */  ? void 0 : node.asteriskToken, visitNode(node.name, visitor, isPropertyName), visitNode(/*node*/ void 0, visitor, isQuestionToken), /*typeParameters*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionParameterList(node) : visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionBody(node) : transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitFunctionDeclaration(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateFunctionDeclaration(node, enclosingFunctionFlags & 1 /* Generator */  ? visitNodes2(node.modifiers, visitorNoAsyncModifier, isModifier) : node.modifiers, enclosingFunctionFlags & 2 /* Async */  ? void 0 : node.asteriskToken, node.name, /*typeParameters*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionParameterList(node) : visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionBody(node) : transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitArrowFunction(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateArrowFunction(node, node.modifiers, /*typeParameters*/ void 0, visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, node.equalsGreaterThanToken, transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function visitFunctionExpression(node) {
            const savedEnclosingFunctionFlags = enclosingFunctionFlags;
            const savedParametersWithPrecedingObjectRestOrSpread = parametersWithPrecedingObjectRestOrSpread;
            enclosingFunctionFlags = getFunctionFlags(node);
            parametersWithPrecedingObjectRestOrSpread = collectParametersWithPrecedingObjectRestOrSpread(node);
            const updated = factory2.updateFunctionExpression(node, enclosingFunctionFlags & 1 /* Generator */  ? visitNodes2(node.modifiers, visitorNoAsyncModifier, isModifier) : node.modifiers, enclosingFunctionFlags & 2 /* Async */  ? void 0 : node.asteriskToken, node.name, /*typeParameters*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionParameterList(node) : visitParameterList(node.parameters, parameterVisitor, context), /*type*/ void 0, enclosingFunctionFlags & 2 /* Async */  && enclosingFunctionFlags & 1 /* Generator */  ? transformAsyncGeneratorFunctionBody(node) : transformFunctionBody2(node));
            enclosingFunctionFlags = savedEnclosingFunctionFlags;
            parametersWithPrecedingObjectRestOrSpread = savedParametersWithPrecedingObjectRestOrSpread;
            return updated;
        }
        function transformAsyncGeneratorFunctionParameterList(node) {
            if (isSimpleParameterList(node.parameters)) return visitParameterList(node.parameters, visitor, context);
            const newParameters = [];
            for (const parameter of node.parameters){
                if (parameter.initializer || parameter.dotDotDotToken) break;
                const newParameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.getGeneratedNameForNode(parameter.name, 8 /* ReservedInNestedScopes */ ));
                newParameters.push(newParameter);
            }
            const newParametersArray = factory2.createNodeArray(newParameters);
            setTextRange(newParametersArray, node.parameters);
            return newParametersArray;
        }
        function transformAsyncGeneratorFunctionBody(node) {
            const innerParameters = !isSimpleParameterList(node.parameters) ? visitParameterList(node.parameters, visitor, context) : void 0;
            resumeLexicalEnvironment();
            const savedCapturedSuperProperties = capturedSuperProperties;
            const savedHasSuperElementAccess = hasSuperElementAccess;
            capturedSuperProperties = /* @__PURE__ */ new Set();
            hasSuperElementAccess = false;
            const outerStatements = [];
            let asyncBody = factory2.updateBlock(node.body, visitNodes2(node.body.statements, visitor, isStatement));
            asyncBody = factory2.updateBlock(asyncBody, factory2.mergeLexicalEnvironment(asyncBody.statements, appendObjectRestAssignmentsIfNeeded(endLexicalEnvironment(), node)));
            const returnStatement = factory2.createReturnStatement(emitHelpers().createAsyncGeneratorHelper(factory2.createFunctionExpression(/*modifiers*/ void 0, factory2.createToken(42 /* AsteriskToken */ ), node.name && factory2.getGeneratedNameForNode(node.name), /*typeParameters*/ void 0, innerParameters !== null && innerParameters !== void 0 ? innerParameters : [], /*type*/ void 0, asyncBody), !!(hierarchyFacts & 1 /* HasLexicalThis */ )));
            const emitSuperHelpers = languageVersion >= 2 /* ES2015 */  && (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) || resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ ));
            if (emitSuperHelpers) {
                enableSubstitutionForAsyncMethodsWithSuper();
                const variableStatement = createSuperAccessVariableStatement(factory2, resolver, node, capturedSuperProperties);
                substitutedSuperAccessors[getNodeId(variableStatement)] = true;
                insertStatementsAfterStandardPrologue(outerStatements, [
                    variableStatement
                ]);
            }
            outerStatements.push(returnStatement);
            const block = factory2.updateBlock(node.body, outerStatements);
            if (emitSuperHelpers && hasSuperElementAccess) {
                if (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ )) addEmitHelper(block, advancedAsyncSuperHelper);
                else if (resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ )) addEmitHelper(block, asyncSuperHelper);
            }
            capturedSuperProperties = savedCapturedSuperProperties;
            hasSuperElementAccess = savedHasSuperElementAccess;
            return block;
        }
        function transformFunctionBody2(node) {
            resumeLexicalEnvironment();
            let statementOffset = 0;
            const statements = [];
            var _visitNode;
            const body = (_visitNode = visitNode(node.body, visitor, isConciseBody)) !== null && _visitNode !== void 0 ? _visitNode : factory2.createBlock([]);
            if (isBlock(body)) statementOffset = factory2.copyPrologue(body.statements, statements, /*ensureUseStrict*/ false, visitor);
            addRange(statements, appendObjectRestAssignmentsIfNeeded(/*statements*/ void 0, node));
            const leadingStatements = endLexicalEnvironment();
            if (statementOffset > 0 || some(statements) || some(leadingStatements)) {
                const block = factory2.converters.convertToFunctionBlock(body, /*multiLine*/ true);
                insertStatementsAfterStandardPrologue(statements, leadingStatements);
                addRange(statements, block.statements.slice(statementOffset));
                return factory2.updateBlock(block, setTextRange(factory2.createNodeArray(statements), block.statements));
            }
            return body;
        }
        function appendObjectRestAssignmentsIfNeeded(statements, node) {
            let containsPrecedingObjectRestOrSpread = false;
            for (const parameter of node.parameters){
                if (containsPrecedingObjectRestOrSpread) {
                    if (isBindingPattern(parameter.name)) {
                        if (parameter.name.elements.length > 0) {
                            const declarations = flattenDestructuringBinding(parameter, visitor, context, 0 /* All */ , factory2.getGeneratedNameForNode(parameter));
                            if (some(declarations)) {
                                const declarationList = factory2.createVariableDeclarationList(declarations);
                                const statement = factory2.createVariableStatement(/*modifiers*/ void 0, declarationList);
                                setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                                statements = append(statements, statement);
                            }
                        } else if (parameter.initializer) {
                            const name = factory2.getGeneratedNameForNode(parameter);
                            const initializer = visitNode(parameter.initializer, visitor, isExpression);
                            const assignment = factory2.createAssignment(name, initializer);
                            const statement = factory2.createExpressionStatement(assignment);
                            setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                            statements = append(statements, statement);
                        }
                    } else if (parameter.initializer) {
                        const name = factory2.cloneNode(parameter.name);
                        setTextRange(name, parameter.name);
                        setEmitFlags(name, 96 /* NoSourceMap */ );
                        const initializer = visitNode(parameter.initializer, visitor, isExpression);
                        addEmitFlags(initializer, 3168 /* NoComments */ );
                        const assignment = factory2.createAssignment(name, initializer);
                        setTextRange(assignment, parameter);
                        setEmitFlags(assignment, 3072 /* NoComments */ );
                        const block = factory2.createBlock([
                            factory2.createExpressionStatement(assignment)
                        ]);
                        setTextRange(block, parameter);
                        setEmitFlags(block, 3905 /* NoComments */ );
                        const typeCheck = factory2.createTypeCheck(factory2.cloneNode(parameter.name), "undefined");
                        const statement = factory2.createIfStatement(typeCheck, block);
                        startOnNewLine(statement);
                        setTextRange(statement, parameter);
                        setEmitFlags(statement, 2101056 /* NoComments */ );
                        statements = append(statements, statement);
                    }
                } else if (parameter.transformFlags & 65536 /* ContainsObjectRestOrSpread */ ) {
                    containsPrecedingObjectRestOrSpread = true;
                    const declarations = flattenDestructuringBinding(parameter, visitor, context, 1 /* ObjectRest */ , factory2.getGeneratedNameForNode(parameter), /*hoistTempVariables*/ false, /*skipInitializer*/ true);
                    if (some(declarations)) {
                        const declarationList = factory2.createVariableDeclarationList(declarations);
                        const statement = factory2.createVariableStatement(/*modifiers*/ void 0, declarationList);
                        setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                        statements = append(statements, statement);
                    }
                }
            }
            return statements;
        }
        function enableSubstitutionForAsyncMethodsWithSuper() {
            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ ) === 0) {
                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */ ;
                context.enableSubstitution(214 /* CallExpression */ );
                context.enableSubstitution(212 /* PropertyAccessExpression */ );
                context.enableSubstitution(213 /* ElementAccessExpression */ );
                context.enableEmitNotification(264 /* ClassDeclaration */ );
                context.enableEmitNotification(175 /* MethodDeclaration */ );
                context.enableEmitNotification(178 /* GetAccessor */ );
                context.enableEmitNotification(179 /* SetAccessor */ );
                context.enableEmitNotification(177 /* Constructor */ );
                context.enableEmitNotification(244 /* VariableStatement */ );
            }
        }
        function onEmitNode(hint, node, emitCallback) {
            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */  && isSuperContainer(node)) {
                const superContainerFlags = (resolver.hasNodeCheckFlag(node, 128 /* MethodWithSuperPropertyAccessInAsync */ ) ? 128 /* MethodWithSuperPropertyAccessInAsync */  : 0) | (resolver.hasNodeCheckFlag(node, 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) ? 256 /* MethodWithSuperPropertyAssignmentInAsync */  : 0);
                if (superContainerFlags !== enclosingSuperContainerFlags) {
                    const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                    enclosingSuperContainerFlags = superContainerFlags;
                    previousOnEmitNode(hint, node, emitCallback);
                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                    return;
                }
            } else if (enabledSubstitutions && substitutedSuperAccessors[getNodeId(node)]) {
                const savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
                enclosingSuperContainerFlags = 0;
                previousOnEmitNode(hint, node, emitCallback);
                enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
                return;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */  && enclosingSuperContainerFlags) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 212 /* PropertyAccessExpression */ :
                    return substitutePropertyAccessExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return substituteElementAccessExpression(node);
                case 214 /* CallExpression */ :
                    return substituteCallExpression(node);
            }
            return node;
        }
        function substitutePropertyAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createUniqueName("_super", 48 /* FileLevel */ ), node.name), node);
            return node;
        }
        function substituteElementAccessExpression(node) {
            if (node.expression.kind === 108 /* SuperKeyword */ ) return createSuperElementAccessInAsyncMethod(node.argumentExpression, node);
            return node;
        }
        function substituteCallExpression(node) {
            const expression = node.expression;
            if (isSuperProperty(expression)) {
                const argumentExpression = isPropertyAccessExpression(expression) ? substitutePropertyAccessExpression(expression) : substituteElementAccessExpression(expression);
                return factory2.createCallExpression(factory2.createPropertyAccessExpression(argumentExpression, "call"), /*typeArguments*/ void 0, [
                    factory2.createThis(),
                    ...node.arguments
                ]);
            }
            return node;
        }
        function isSuperContainer(node) {
            const kind = node.kind;
            return kind === 264 /* ClassDeclaration */  || kind === 177 /* Constructor */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */ ;
        }
        function createSuperElementAccessInAsyncMethod(argumentExpression, location) {
            if (enclosingSuperContainerFlags & 256 /* MethodWithSuperPropertyAssignmentInAsync */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createCallExpression(factory2.createIdentifier("_superIndex"), /*typeArguments*/ void 0, [
                argumentExpression
            ]), "value"), location);
            else return setTextRange(factory2.createCallExpression(factory2.createIdentifier("_superIndex"), /*typeArguments*/ void 0, [
                argumentExpression
            ]), location);
        }
    }
    // src/compiler/transformers/es2019.ts
    function transformES2019(context) {
        const factory2 = context.factory;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 64 /* ContainsES2019 */ ) === 0) return node;
            switch(node.kind){
                case 300 /* CatchClause */ :
                    return visitCatchClause(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitCatchClause(node) {
            if (!node.variableDeclaration) return factory2.updateCatchClause(node, factory2.createVariableDeclaration(factory2.createTempVariable(/*recordTempVariable*/ void 0)), visitNode(node.block, visitor, isBlock));
            return visitEachChild(node, visitor, context);
        }
    }
    // src/compiler/transformers/es2020.ts
    function transformES2020(context) {
        const { factory: factory2, hoistVariableDeclaration } = context;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 32 /* ContainsES2020 */ ) === 0) return node;
            switch(node.kind){
                case 214 /* CallExpression */ :
                    {
                        const updated = visitNonOptionalCallExpression(node, /*captureThisArg*/ false);
                        Debug.assertNotNode(updated, isSyntheticReference);
                        return updated;
                    }
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    if (isOptionalChain(node)) {
                        const updated = visitOptionalExpression(node, /*captureThisArg*/ false, /*isDelete*/ false);
                        Debug.assertNotNode(updated, isSyntheticReference);
                        return updated;
                    }
                    return visitEachChild(node, visitor, context);
                case 227 /* BinaryExpression */ :
                    if (node.operatorToken.kind === 61 /* QuestionQuestionToken */ ) return transformNullishCoalescingExpression(node);
                    return visitEachChild(node, visitor, context);
                case 221 /* DeleteExpression */ :
                    return visitDeleteExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function flattenChain(chain) {
            Debug.assertNotNode(chain, isNonNullChain);
            const links = [
                chain
            ];
            while(!chain.questionDotToken && !isTaggedTemplateExpression(chain)){
                chain = cast(skipPartiallyEmittedExpressions(chain.expression), isOptionalChain);
                Debug.assertNotNode(chain, isNonNullChain);
                links.unshift(chain);
            }
            return {
                expression: chain.expression,
                chain: links
            };
        }
        function visitNonOptionalParenthesizedExpression(node, captureThisArg, isDelete) {
            const expression = visitNonOptionalExpression(node.expression, captureThisArg, isDelete);
            if (isSyntheticReference(expression)) return factory2.createSyntheticReferenceExpression(factory2.updateParenthesizedExpression(node, expression.expression), expression.thisArg);
            return factory2.updateParenthesizedExpression(node, expression);
        }
        function visitNonOptionalPropertyOrElementAccessExpression(node, captureThisArg, isDelete) {
            if (isOptionalChain(node)) return visitOptionalExpression(node, captureThisArg, isDelete);
            let expression = visitNode(node.expression, visitor, isExpression);
            Debug.assertNotNode(expression, isSyntheticReference);
            let thisArg;
            if (captureThisArg) {
                if (!isSimpleCopiableExpression(expression)) {
                    thisArg = factory2.createTempVariable(hoistVariableDeclaration);
                    expression = factory2.createAssignment(thisArg, expression);
                } else thisArg = expression;
            }
            expression = node.kind === 212 /* PropertyAccessExpression */  ? factory2.updatePropertyAccessExpression(node, expression, visitNode(node.name, visitor, isIdentifier)) : factory2.updateElementAccessExpression(node, expression, visitNode(node.argumentExpression, visitor, isExpression));
            return thisArg ? factory2.createSyntheticReferenceExpression(expression, thisArg) : expression;
        }
        function visitNonOptionalCallExpression(node, captureThisArg) {
            if (isOptionalChain(node)) return visitOptionalExpression(node, captureThisArg, /*isDelete*/ false);
            if (isParenthesizedExpression(node.expression) && isOptionalChain(skipParentheses(node.expression))) {
                const expression = visitNonOptionalParenthesizedExpression(node.expression, /*captureThisArg*/ true, /*isDelete*/ false);
                const args = visitNodes2(node.arguments, visitor, isExpression);
                if (isSyntheticReference(expression)) return setTextRange(factory2.createFunctionCallCall(expression.expression, expression.thisArg, args), node);
                return factory2.updateCallExpression(node, expression, /*typeArguments*/ void 0, args);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitNonOptionalExpression(node, captureThisArg, isDelete) {
            switch(node.kind){
                case 218 /* ParenthesizedExpression */ :
                    return visitNonOptionalParenthesizedExpression(node, captureThisArg, isDelete);
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    return visitNonOptionalPropertyOrElementAccessExpression(node, captureThisArg, isDelete);
                case 214 /* CallExpression */ :
                    return visitNonOptionalCallExpression(node, captureThisArg);
                default:
                    return visitNode(node, visitor, isExpression);
            }
        }
        function visitOptionalExpression(node, captureThisArg, isDelete) {
            const { expression, chain } = flattenChain(node);
            const left = visitNonOptionalExpression(skipPartiallyEmittedExpressions(expression), isCallChain(chain[0]), /*isDelete*/ false);
            let leftThisArg = isSyntheticReference(left) ? left.thisArg : void 0;
            let capturedLeft = isSyntheticReference(left) ? left.expression : left;
            let leftExpression = factory2.restoreOuterExpressions(expression, capturedLeft, 8 /* PartiallyEmittedExpressions */ );
            if (!isSimpleCopiableExpression(capturedLeft)) {
                capturedLeft = factory2.createTempVariable(hoistVariableDeclaration);
                leftExpression = factory2.createAssignment(capturedLeft, leftExpression);
            }
            let rightExpression = capturedLeft;
            let thisArg;
            for(let i = 0; i < chain.length; i++){
                const segment = chain[i];
                switch(segment.kind){
                    case 212 /* PropertyAccessExpression */ :
                    case 213 /* ElementAccessExpression */ :
                        if (i === chain.length - 1 && captureThisArg) {
                            if (!isSimpleCopiableExpression(rightExpression)) {
                                thisArg = factory2.createTempVariable(hoistVariableDeclaration);
                                rightExpression = factory2.createAssignment(thisArg, rightExpression);
                            } else thisArg = rightExpression;
                        }
                        rightExpression = segment.kind === 212 /* PropertyAccessExpression */  ? factory2.createPropertyAccessExpression(rightExpression, visitNode(segment.name, visitor, isIdentifier)) : factory2.createElementAccessExpression(rightExpression, visitNode(segment.argumentExpression, visitor, isExpression));
                        break;
                    case 214 /* CallExpression */ :
                        if (i === 0 && leftThisArg) {
                            if (!isGeneratedIdentifier(leftThisArg)) {
                                leftThisArg = factory2.cloneNode(leftThisArg);
                                addEmitFlags(leftThisArg, 3072 /* NoComments */ );
                            }
                            rightExpression = factory2.createFunctionCallCall(rightExpression, leftThisArg.kind === 108 /* SuperKeyword */  ? factory2.createThis() : leftThisArg, visitNodes2(segment.arguments, visitor, isExpression));
                        } else rightExpression = factory2.createCallExpression(rightExpression, /*typeArguments*/ void 0, visitNodes2(segment.arguments, visitor, isExpression));
                        break;
                }
                setOriginalNode(rightExpression, segment);
            }
            const target = isDelete ? factory2.createConditionalExpression(createNotNullCondition(leftExpression, capturedLeft, /*invert*/ true), /*questionToken*/ void 0, factory2.createTrue(), /*colonToken*/ void 0, factory2.createDeleteExpression(rightExpression)) : factory2.createConditionalExpression(createNotNullCondition(leftExpression, capturedLeft, /*invert*/ true), /*questionToken*/ void 0, factory2.createVoidZero(), /*colonToken*/ void 0, rightExpression);
            setTextRange(target, node);
            return thisArg ? factory2.createSyntheticReferenceExpression(target, thisArg) : target;
        }
        function createNotNullCondition(left, right, invert) {
            return factory2.createBinaryExpression(factory2.createBinaryExpression(left, factory2.createToken(invert ? 37 /* EqualsEqualsEqualsToken */  : 38 /* ExclamationEqualsEqualsToken */ ), factory2.createNull()), factory2.createToken(invert ? 57 /* BarBarToken */  : 56 /* AmpersandAmpersandToken */ ), factory2.createBinaryExpression(right, factory2.createToken(invert ? 37 /* EqualsEqualsEqualsToken */  : 38 /* ExclamationEqualsEqualsToken */ ), factory2.createVoidZero()));
        }
        function transformNullishCoalescingExpression(node) {
            let left = visitNode(node.left, visitor, isExpression);
            let right = left;
            if (!isSimpleCopiableExpression(left)) {
                right = factory2.createTempVariable(hoistVariableDeclaration);
                left = factory2.createAssignment(right, left);
            }
            return setTextRange(factory2.createConditionalExpression(createNotNullCondition(left, right), /*questionToken*/ void 0, right, /*colonToken*/ void 0, visitNode(node.right, visitor, isExpression)), node);
        }
        function visitDeleteExpression(node) {
            return isOptionalChain(skipParentheses(node.expression)) ? setOriginalNode(visitNonOptionalExpression(node.expression, /*captureThisArg*/ false, /*isDelete*/ true), node) : factory2.updateDeleteExpression(node, visitNode(node.expression, visitor, isExpression));
        }
    }
    // src/compiler/transformers/es2021.ts
    function transformES2021(context) {
        const { hoistVariableDeclaration, factory: factory2 } = context;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 16 /* ContainsES2021 */ ) === 0) return node;
            if (isLogicalOrCoalescingAssignmentExpression(node)) return transformLogicalAssignment(node);
            return visitEachChild(node, visitor, context);
        }
        function transformLogicalAssignment(binaryExpression) {
            const operator = binaryExpression.operatorToken;
            const nonAssignmentOperator = getNonAssignmentOperatorForCompoundAssignment(operator.kind);
            let left = skipParentheses(visitNode(binaryExpression.left, visitor, isLeftHandSideExpression));
            let assignmentTarget = left;
            const right = skipParentheses(visitNode(binaryExpression.right, visitor, isExpression));
            if (isAccessExpression(left)) {
                const propertyAccessTargetSimpleCopiable = isSimpleCopiableExpression(left.expression);
                const propertyAccessTarget = propertyAccessTargetSimpleCopiable ? left.expression : factory2.createTempVariable(hoistVariableDeclaration);
                const propertyAccessTargetAssignment = propertyAccessTargetSimpleCopiable ? left.expression : factory2.createAssignment(propertyAccessTarget, left.expression);
                if (isPropertyAccessExpression(left)) {
                    assignmentTarget = factory2.createPropertyAccessExpression(propertyAccessTarget, left.name);
                    left = factory2.createPropertyAccessExpression(propertyAccessTargetAssignment, left.name);
                } else {
                    const elementAccessArgumentSimpleCopiable = isSimpleCopiableExpression(left.argumentExpression);
                    const elementAccessArgument = elementAccessArgumentSimpleCopiable ? left.argumentExpression : factory2.createTempVariable(hoistVariableDeclaration);
                    assignmentTarget = factory2.createElementAccessExpression(propertyAccessTarget, elementAccessArgument);
                    left = factory2.createElementAccessExpression(propertyAccessTargetAssignment, elementAccessArgumentSimpleCopiable ? left.argumentExpression : factory2.createAssignment(elementAccessArgument, left.argumentExpression));
                }
            }
            return factory2.createBinaryExpression(left, nonAssignmentOperator, factory2.createParenthesizedExpression(factory2.createAssignment(assignmentTarget, right)));
        }
    }
    // src/compiler/transformers/esnext.ts
    function transformESNext(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, hoistVariableDeclaration, startLexicalEnvironment, endLexicalEnvironment } = context;
        let exportBindings;
        let exportVars;
        let defaultExportBinding;
        let exportEqualsBinding;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            const visited = visitNode(node, visitor, isSourceFile);
            addEmitHelpers(visited, context.readEmitHelpers());
            exportVars = void 0;
            exportBindings = void 0;
            defaultExportBinding = void 0;
            return visited;
        }
        function visitor(node) {
            if ((node.transformFlags & 4 /* ContainsESNext */ ) === 0) return node;
            switch(node.kind){
                case 308 /* SourceFile */ :
                    return visitSourceFile(node);
                case 242 /* Block */ :
                    return visitBlock(node);
                case 249 /* ForStatement */ :
                    return visitForStatement(node);
                case 251 /* ForOfStatement */ :
                    return visitForOfStatement(node);
                case 256 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitSourceFile(node) {
            const usingKind = getUsingKindOfStatements(node.statements);
            if (usingKind) {
                startLexicalEnvironment();
                exportBindings = new IdentifierNameMap();
                exportVars = [];
                const prologueCount = countPrologueStatements(node.statements);
                const topLevelStatements = [];
                addRange(topLevelStatements, visitArray(node.statements, visitor, isStatement, 0, prologueCount));
                let pos = prologueCount;
                while(pos < node.statements.length){
                    const statement = node.statements[pos];
                    if (getUsingKind(statement) !== 0 /* None */ ) {
                        if (pos > prologueCount) addRange(topLevelStatements, visitNodes2(node.statements, visitor, isStatement, prologueCount, pos - prologueCount));
                        break;
                    }
                    pos++;
                }
                Debug.assert(pos < node.statements.length, "Should have encountered at least one 'using' statement.");
                const envBinding = createEnvBinding();
                const bodyStatements = transformUsingDeclarations(node.statements, pos, node.statements.length, envBinding, topLevelStatements);
                if (exportBindings.size) append(topLevelStatements, factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports(arrayFrom(exportBindings.values()))));
                addRange(topLevelStatements, endLexicalEnvironment());
                if (exportVars.length) topLevelStatements.push(factory2.createVariableStatement(factory2.createModifiersFromModifierFlags(32 /* Export */ ), factory2.createVariableDeclarationList(exportVars, 1 /* Let */ )));
                addRange(topLevelStatements, createDownlevelUsingStatements(bodyStatements, envBinding, usingKind === 2 /* Async */ ));
                if (exportEqualsBinding) topLevelStatements.push(factory2.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ true, exportEqualsBinding));
                return factory2.updateSourceFile(node, topLevelStatements);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitBlock(node) {
            const usingKind = getUsingKindOfStatements(node.statements);
            if (usingKind) {
                const prologueCount = countPrologueStatements(node.statements);
                const envBinding = createEnvBinding();
                return factory2.updateBlock(node, [
                    ...visitArray(node.statements, visitor, isStatement, 0, prologueCount),
                    ...createDownlevelUsingStatements(transformUsingDeclarations(node.statements, prologueCount, node.statements.length, envBinding, /*topLevelStatements*/ void 0), envBinding, usingKind === 2 /* Async */ )
                ]);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node) {
            if (node.initializer && isUsingVariableDeclarationList(node.initializer)) return visitNode(factory2.createBlock([
                factory2.createVariableStatement(/*modifiers*/ void 0, node.initializer),
                factory2.updateForStatement(node, /*initializer*/ void 0, node.condition, node.incrementor, node.statement)
            ]), visitor, isStatement);
            return visitEachChild(node, visitor, context);
        }
        function visitForOfStatement(node) {
            if (isUsingVariableDeclarationList(node.initializer)) {
                const forInitializer = node.initializer;
                const forDecl = firstOrUndefined(forInitializer.declarations) || factory2.createVariableDeclaration(factory2.createTempVariable(/*recordTempVariable*/ void 0));
                const isAwaitUsing = getUsingKindOfVariableDeclarationList(forInitializer) === 2 /* Async */ ;
                const temp = factory2.getGeneratedNameForNode(forDecl.name);
                const usingVar = factory2.updateVariableDeclaration(forDecl, forDecl.name, /*exclamationToken*/ void 0, /*type*/ void 0, temp);
                const usingVarList = factory2.createVariableDeclarationList([
                    usingVar
                ], isAwaitUsing ? 6 /* AwaitUsing */  : 4 /* Using */ );
                const usingVarStatement = factory2.createVariableStatement(/*modifiers*/ void 0, usingVarList);
                return visitNode(factory2.updateForOfStatement(node, node.awaitModifier, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(temp)
                ], 2 /* Const */ ), node.expression, isBlock(node.statement) ? factory2.updateBlock(node.statement, [
                    usingVarStatement,
                    ...node.statement.statements
                ]) : factory2.createBlock([
                    usingVarStatement,
                    node.statement
                ], /*multiLine*/ true)), visitor, isStatement);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCaseOrDefaultClause(node, envBinding) {
            if (getUsingKindOfStatements(node.statements) !== 0 /* None */ ) {
                if (isCaseClause(node)) return factory2.updateCaseClause(node, visitNode(node.expression, visitor, isExpression), transformUsingDeclarations(node.statements, /*start*/ 0, node.statements.length, envBinding, /*topLevelStatements*/ void 0));
                else return factory2.updateDefaultClause(node, transformUsingDeclarations(node.statements, /*start*/ 0, node.statements.length, envBinding, /*topLevelStatements*/ void 0));
            }
            return visitEachChild(node, visitor, context);
        }
        function visitSwitchStatement(node) {
            const usingKind = getUsingKindOfCaseOrDefaultClauses(node.caseBlock.clauses);
            if (usingKind) {
                const envBinding = createEnvBinding();
                return createDownlevelUsingStatements([
                    factory2.updateSwitchStatement(node, visitNode(node.expression, visitor, isExpression), factory2.updateCaseBlock(node.caseBlock, node.caseBlock.clauses.map((clause)=>visitCaseOrDefaultClause(clause, envBinding))))
                ], envBinding, usingKind === 2 /* Async */ );
            }
            return visitEachChild(node, visitor, context);
        }
        function transformUsingDeclarations(statementsIn, start, end, envBinding, topLevelStatements) {
            const statements = [];
            for(let i = start; i < end; i++){
                const statement = statementsIn[i];
                const usingKind = getUsingKind(statement);
                if (usingKind) {
                    Debug.assertNode(statement, isVariableStatement);
                    const declarations = [];
                    for (let declaration of statement.declarationList.declarations){
                        if (!isIdentifier(declaration.name)) {
                            declarations.length = 0;
                            break;
                        }
                        if (isNamedEvaluation(declaration)) declaration = transformNamedEvaluation(context, declaration);
                        var _visitNode;
                        const initializer = (_visitNode = visitNode(declaration.initializer, visitor, isExpression)) !== null && _visitNode !== void 0 ? _visitNode : factory2.createVoidZero();
                        declarations.push(factory2.updateVariableDeclaration(declaration, declaration.name, /*exclamationToken*/ void 0, /*type*/ void 0, emitHelpers().createAddDisposableResourceHelper(envBinding, initializer, usingKind === 2 /* Async */ )));
                    }
                    if (declarations.length) {
                        const varList = factory2.createVariableDeclarationList(declarations, 2 /* Const */ );
                        setOriginalNode(varList, statement.declarationList);
                        setTextRange(varList, statement.declarationList);
                        hoistOrAppendNode(factory2.updateVariableStatement(statement, /*modifiers*/ void 0, varList));
                        continue;
                    }
                }
                const result = visitor(statement);
                if (isArray(result)) result.forEach(hoistOrAppendNode);
                else if (result) hoistOrAppendNode(result);
            }
            return statements;
            function hoistOrAppendNode(node) {
                Debug.assertNode(node, isStatement);
                append(statements, hoist(node));
            }
            function hoist(node) {
                if (!topLevelStatements) return node;
                switch(node.kind){
                    case 273 /* ImportDeclaration */ :
                    case 272 /* ImportEqualsDeclaration */ :
                    case 279 /* ExportDeclaration */ :
                    case 263 /* FunctionDeclaration */ :
                        return hoistImportOrExportOrHoistedDeclaration(node, topLevelStatements);
                    case 278 /* ExportAssignment */ :
                        return hoistExportAssignment(node);
                    case 264 /* ClassDeclaration */ :
                        return hoistClassDeclaration(node);
                    case 244 /* VariableStatement */ :
                        return hoistVariableStatement(node);
                }
                return node;
            }
        }
        function hoistImportOrExportOrHoistedDeclaration(node, topLevelStatements) {
            topLevelStatements.push(node);
            return void 0;
        }
        function hoistExportAssignment(node) {
            return node.isExportEquals ? hoistExportEquals(node) : hoistExportDefault(node);
        }
        function hoistExportDefault(node) {
            if (defaultExportBinding) return node;
            defaultExportBinding = factory2.createUniqueName("_default", 56 /* Optimistic */ );
            hoistBindingIdentifier(defaultExportBinding, /*isExport*/ true, "default", node);
            let expression = node.expression;
            let innerExpression = skipOuterExpressions(expression);
            if (isNamedEvaluation(innerExpression)) {
                innerExpression = transformNamedEvaluation(context, innerExpression, /*ignoreEmptyStringLiteral*/ false, "default");
                expression = factory2.restoreOuterExpressions(expression, innerExpression);
            }
            const assignment = factory2.createAssignment(defaultExportBinding, expression);
            return factory2.createExpressionStatement(assignment);
        }
        function hoistExportEquals(node) {
            if (exportEqualsBinding) return node;
            exportEqualsBinding = factory2.createUniqueName("_default", 56 /* Optimistic */ );
            hoistVariableDeclaration(exportEqualsBinding);
            const assignment = factory2.createAssignment(exportEqualsBinding, node.expression);
            return factory2.createExpressionStatement(assignment);
        }
        function hoistClassDeclaration(node) {
            if (!node.name && defaultExportBinding) return node;
            const isExported2 = hasSyntacticModifier(node, 32 /* Export */ );
            const isDefault = hasSyntacticModifier(node, 2048 /* Default */ );
            let expression = factory2.converters.convertToClassExpression(node);
            if (node.name) {
                hoistBindingIdentifier(factory2.getLocalName(node), isExported2 && !isDefault, /*exportAlias*/ void 0, node);
                expression = factory2.createAssignment(factory2.getDeclarationName(node), expression);
                if (isNamedEvaluation(expression)) expression = transformNamedEvaluation(context, expression, /*ignoreEmptyStringLiteral*/ false);
                setOriginalNode(expression, node);
                setSourceMapRange(expression, node);
                setCommentRange(expression, node);
            }
            if (isDefault && !defaultExportBinding) {
                defaultExportBinding = factory2.createUniqueName("_default", 56 /* Optimistic */ );
                hoistBindingIdentifier(defaultExportBinding, /*isExport*/ true, "default", node);
                expression = factory2.createAssignment(defaultExportBinding, expression);
                if (isNamedEvaluation(expression)) expression = transformNamedEvaluation(context, expression, /*ignoreEmptyStringLiteral*/ false, "default");
                setOriginalNode(expression, node);
            }
            return factory2.createExpressionStatement(expression);
        }
        function hoistVariableStatement(node) {
            let expressions;
            const isExported2 = hasSyntacticModifier(node, 32 /* Export */ );
            for (const variable of node.declarationList.declarations){
                hoistBindingElement(variable, isExported2, variable);
                if (variable.initializer) expressions = append(expressions, hoistInitializedVariable(variable));
            }
            if (expressions) {
                const statement = factory2.createExpressionStatement(factory2.inlineExpressions(expressions));
                setOriginalNode(statement, node);
                setCommentRange(statement, node);
                setSourceMapRange(statement, node);
                return statement;
            }
            return void 0;
        }
        function hoistInitializedVariable(node) {
            Debug.assertIsDefined(node.initializer);
            let target;
            if (isIdentifier(node.name)) {
                target = factory2.cloneNode(node.name);
                setEmitFlags(target, getEmitFlags(target) & -114689);
            } else target = factory2.converters.convertToAssignmentPattern(node.name);
            const assignment = factory2.createAssignment(target, node.initializer);
            setOriginalNode(assignment, node);
            setCommentRange(assignment, node);
            setSourceMapRange(assignment, node);
            return assignment;
        }
        function hoistBindingElement(node, isExportedDeclaration, original) {
            if (isBindingPattern(node.name)) {
                for (const element of node.name.elements)if (!isOmittedExpression(element)) hoistBindingElement(element, isExportedDeclaration, original);
            } else hoistBindingIdentifier(node.name, isExportedDeclaration, /*exportAlias*/ void 0, original);
        }
        function hoistBindingIdentifier(node, isExport, exportAlias, original) {
            const name = isGeneratedIdentifier(node) ? node : factory2.cloneNode(node);
            if (isExport) {
                if (exportAlias === void 0 && !isLocalName(name)) {
                    const varDecl = factory2.createVariableDeclaration(name);
                    if (original) setOriginalNode(varDecl, original);
                    exportVars.push(varDecl);
                    return;
                }
                const localName = exportAlias !== void 0 ? name : void 0;
                const exportName = exportAlias !== void 0 ? exportAlias : name;
                const specifier = factory2.createExportSpecifier(/*isTypeOnly*/ false, localName, exportName);
                if (original) setOriginalNode(specifier, original);
                exportBindings.set(name, specifier);
            }
            hoistVariableDeclaration(name);
        }
        function createEnvBinding() {
            return factory2.createUniqueName("env");
        }
        function createDownlevelUsingStatements(bodyStatements, envBinding, async) {
            const statements = [];
            const envObject = factory2.createObjectLiteralExpression([
                factory2.createPropertyAssignment("stack", factory2.createArrayLiteralExpression()),
                factory2.createPropertyAssignment("error", factory2.createVoidZero()),
                factory2.createPropertyAssignment("hasError", factory2.createFalse())
            ]);
            const envVar = factory2.createVariableDeclaration(envBinding, /*exclamationToken*/ void 0, /*type*/ void 0, envObject);
            const envVarList = factory2.createVariableDeclarationList([
                envVar
            ], 2 /* Const */ );
            const envVarStatement = factory2.createVariableStatement(/*modifiers*/ void 0, envVarList);
            statements.push(envVarStatement);
            const tryBlock = factory2.createBlock(bodyStatements, /*multiLine*/ true);
            const bodyCatchBinding = factory2.createUniqueName("e");
            const catchClause = factory2.createCatchClause(bodyCatchBinding, factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(envBinding, "error"), bodyCatchBinding)),
                factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(envBinding, "hasError"), factory2.createTrue()))
            ], /*multiLine*/ true));
            let finallyBlock;
            if (async) {
                const result = factory2.createUniqueName("result");
                finallyBlock = factory2.createBlock([
                    factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                        factory2.createVariableDeclaration(result, /*exclamationToken*/ void 0, /*type*/ void 0, emitHelpers().createDisposeResourcesHelper(envBinding))
                    ], 2 /* Const */ )),
                    factory2.createIfStatement(result, factory2.createExpressionStatement(factory2.createAwaitExpression(result)))
                ], /*multiLine*/ true);
            } else finallyBlock = factory2.createBlock([
                factory2.createExpressionStatement(emitHelpers().createDisposeResourcesHelper(envBinding))
            ], /*multiLine*/ true);
            const tryStatement = factory2.createTryStatement(tryBlock, catchClause, finallyBlock);
            statements.push(tryStatement);
            return statements;
        }
    }
    function countPrologueStatements(statements) {
        for(let i = 0; i < statements.length; i++){
            if (!isPrologueDirective(statements[i]) && !isCustomPrologue(statements[i])) return i;
        }
        return 0;
    }
    function isUsingVariableDeclarationList(node) {
        return isVariableDeclarationList(node) && getUsingKindOfVariableDeclarationList(node) !== 0 /* None */ ;
    }
    function getUsingKindOfVariableDeclarationList(node) {
        return (node.flags & 7 /* BlockScoped */ ) === 6 /* AwaitUsing */  ? 2 /* Async */  : (node.flags & 7 /* BlockScoped */ ) === 4 /* Using */  ? 1 /* Sync */  : 0 /* None */ ;
    }
    function getUsingKindOfVariableStatement(node) {
        return getUsingKindOfVariableDeclarationList(node.declarationList);
    }
    function getUsingKind(statement) {
        return isVariableStatement(statement) ? getUsingKindOfVariableStatement(statement) : 0 /* None */ ;
    }
    function getUsingKindOfStatements(statements) {
        let result = 0 /* None */ ;
        for (const statement of statements){
            const usingKind = getUsingKind(statement);
            if (usingKind === 2 /* Async */ ) return 2 /* Async */ ;
            if (usingKind > result) result = usingKind;
        }
        return result;
    }
    function getUsingKindOfCaseOrDefaultClauses(clauses) {
        let result = 0 /* None */ ;
        for (const clause of clauses){
            const usingKind = getUsingKindOfStatements(clause.statements);
            if (usingKind === 2 /* Async */ ) return 2 /* Async */ ;
            if (usingKind > result) result = usingKind;
        }
        return result;
    }
    // src/compiler/transformers/jsx.ts
    function transformJsx(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers } = context;
        const compilerOptions = context.getCompilerOptions();
        let currentSourceFile;
        let currentFileState;
        return chainBundle(context, transformSourceFile);
        function getCurrentFileNameExpression() {
            if (currentFileState.filenameDeclaration) return currentFileState.filenameDeclaration.name;
            const declaration = factory2.createVariableDeclaration(factory2.createUniqueName("_jsxFileName", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createStringLiteral(currentSourceFile.fileName));
            currentFileState.filenameDeclaration = declaration;
            return currentFileState.filenameDeclaration.name;
        }
        function getJsxFactoryCalleePrimitive(isStaticChildren) {
            return compilerOptions.jsx === 5 /* ReactJSXDev */  ? "jsxDEV" : isStaticChildren ? "jsxs" : "jsx";
        }
        function getJsxFactoryCallee(isStaticChildren) {
            const type = getJsxFactoryCalleePrimitive(isStaticChildren);
            return getImplicitImportForName(type);
        }
        function getImplicitJsxFragmentReference() {
            return getImplicitImportForName("Fragment");
        }
        function getImplicitImportForName(name) {
            var _a, _b;
            const importSource = name === "createElement" ? currentFileState.importSpecifier : getJSXRuntimeImport(currentFileState.importSpecifier, compilerOptions);
            const existing = (_b = (_a = currentFileState.utilizedImplicitRuntimeImports) == null ? void 0 : _a.get(importSource)) == null ? void 0 : _b.get(name);
            if (existing) return existing.name;
            if (!currentFileState.utilizedImplicitRuntimeImports) currentFileState.utilizedImplicitRuntimeImports = /* @__PURE__ */ new Map();
            let specifierSourceImports = currentFileState.utilizedImplicitRuntimeImports.get(importSource);
            if (!specifierSourceImports) {
                specifierSourceImports = /* @__PURE__ */ new Map();
                currentFileState.utilizedImplicitRuntimeImports.set(importSource, specifierSourceImports);
            }
            const generatedName = factory2.createUniqueName(`_${name}`, 112 /* AllowNameSubstitution */ );
            const specifier = factory2.createImportSpecifier(/*isTypeOnly*/ false, factory2.createIdentifier(name), generatedName);
            setIdentifierGeneratedImportReference(generatedName, specifier);
            specifierSourceImports.set(name, specifier);
            return generatedName;
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            currentFileState = {};
            currentFileState.importSpecifier = getJSXImplicitImportBase(compilerOptions, node);
            let visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            let statements = visited.statements;
            if (currentFileState.filenameDeclaration) statements = insertStatementAfterCustomPrologue(statements.slice(), factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                currentFileState.filenameDeclaration
            ], 2 /* Const */ )));
            if (currentFileState.utilizedImplicitRuntimeImports) for (const [importSource, importSpecifiersMap] of arrayFrom(currentFileState.utilizedImplicitRuntimeImports.entries())){
                if (isExternalModule(node)) {
                    const importStatement = factory2.createImportDeclaration(/*modifiers*/ void 0, factory2.createImportClause(/*phaseModifier*/ void 0, /*name*/ void 0, factory2.createNamedImports(arrayFrom(importSpecifiersMap.values()))), factory2.createStringLiteral(importSource), /*attributes*/ void 0);
                    setParentRecursive(importStatement, /*incremental*/ false);
                    statements = insertStatementAfterCustomPrologue(statements.slice(), importStatement);
                } else if (isExternalOrCommonJsModule(node)) {
                    const requireStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                        factory2.createVariableDeclaration(factory2.createObjectBindingPattern(arrayFrom(importSpecifiersMap.values(), (s)=>factory2.createBindingElement(/*dotDotDotToken*/ void 0, s.propertyName, s.name))), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, [
                            factory2.createStringLiteral(importSource)
                        ]))
                    ], 2 /* Const */ ));
                    setParentRecursive(requireStatement, /*incremental*/ false);
                    statements = insertStatementAfterCustomPrologue(statements.slice(), requireStatement);
                }
            }
            if (statements !== visited.statements) visited = factory2.updateSourceFile(visited, statements);
            currentFileState = void 0;
            return visited;
        }
        function visitor(node) {
            if (node.transformFlags & 2 /* ContainsJsx */ ) return visitorWorker(node);
            else return node;
        }
        function visitorWorker(node) {
            switch(node.kind){
                case 285 /* JsxElement */ :
                    return visitJsxElement(node, /*isChild*/ false);
                case 286 /* JsxSelfClosingElement */ :
                    return visitJsxSelfClosingElement(node, /*isChild*/ false);
                case 289 /* JsxFragment */ :
                    return visitJsxFragment(node, /*isChild*/ false);
                case 295 /* JsxExpression */ :
                    return visitJsxExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function transformJsxChildToExpression(node) {
            switch(node.kind){
                case 12 /* JsxText */ :
                    return visitJsxText(node);
                case 295 /* JsxExpression */ :
                    return visitJsxExpression(node);
                case 285 /* JsxElement */ :
                    return visitJsxElement(node, /*isChild*/ true);
                case 286 /* JsxSelfClosingElement */ :
                    return visitJsxSelfClosingElement(node, /*isChild*/ true);
                case 289 /* JsxFragment */ :
                    return visitJsxFragment(node, /*isChild*/ true);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function hasProto(obj) {
            return obj.properties.some((p)=>isPropertyAssignment(p) && (isIdentifier(p.name) && idText(p.name) === "__proto__" || isStringLiteral(p.name) && p.name.text === "__proto__"));
        }
        function hasKeyAfterPropsSpread(node) {
            let spread = false;
            for (const elem of node.attributes.properties){
                if (isJsxSpreadAttribute(elem) && (!isObjectLiteralExpression(elem.expression) || elem.expression.properties.some(isSpreadAssignment))) spread = true;
                else if (spread && isJsxAttribute(elem) && isIdentifier(elem.name) && elem.name.escapedText === "key") return true;
            }
            return false;
        }
        function shouldUseCreateElement(node) {
            return currentFileState.importSpecifier === void 0 || hasKeyAfterPropsSpread(node);
        }
        function visitJsxElement(node, isChild) {
            const tagTransform = shouldUseCreateElement(node.openingElement) ? visitJsxOpeningLikeElementCreateElement : visitJsxOpeningLikeElementJSX;
            return tagTransform(node.openingElement, node.children, isChild, /*location*/ node);
        }
        function visitJsxSelfClosingElement(node, isChild) {
            const tagTransform = shouldUseCreateElement(node) ? visitJsxOpeningLikeElementCreateElement : visitJsxOpeningLikeElementJSX;
            return tagTransform(node, /*children*/ void 0, isChild, /*location*/ node);
        }
        function visitJsxFragment(node, isChild) {
            const tagTransform = currentFileState.importSpecifier === void 0 ? visitJsxOpeningFragmentCreateElement : visitJsxOpeningFragmentJSX;
            return tagTransform(node.openingFragment, node.children, isChild, /*location*/ node);
        }
        function convertJsxChildrenToChildrenPropObject(children) {
            const prop = convertJsxChildrenToChildrenPropAssignment(children);
            return prop && factory2.createObjectLiteralExpression([
                prop
            ]);
        }
        function convertJsxChildrenToChildrenPropAssignment(children) {
            const nonWhitespaceChildren = getSemanticJsxChildren(children);
            if (length(nonWhitespaceChildren) === 1 && !nonWhitespaceChildren[0].dotDotDotToken) {
                const result2 = transformJsxChildToExpression(nonWhitespaceChildren[0]);
                return result2 && factory2.createPropertyAssignment("children", result2);
            }
            const result = mapDefined(children, transformJsxChildToExpression);
            return length(result) ? factory2.createPropertyAssignment("children", factory2.createArrayLiteralExpression(result)) : void 0;
        }
        function visitJsxOpeningLikeElementJSX(node, children, isChild, location) {
            const tagName = getTagName(node);
            const childrenProp = children && children.length ? convertJsxChildrenToChildrenPropAssignment(children) : void 0;
            const keyAttr = find(node.attributes.properties, (p)=>!!p.name && isIdentifier(p.name) && p.name.escapedText === "key");
            const attrs = keyAttr ? filter(node.attributes.properties, (p)=>p !== keyAttr) : node.attributes.properties;
            const objectProperties = length(attrs) ? transformJsxAttributesToObjectProps(attrs, childrenProp) : factory2.createObjectLiteralExpression(childrenProp ? [
                childrenProp
            ] : emptyArray);
            return visitJsxOpeningLikeElementOrFragmentJSX(tagName, objectProperties, keyAttr, children || emptyArray, isChild, location);
        }
        function visitJsxOpeningLikeElementOrFragmentJSX(tagName, objectProperties, keyAttr, children, isChild, location) {
            var _a;
            const nonWhitespaceChildren = getSemanticJsxChildren(children);
            const isStaticChildren = length(nonWhitespaceChildren) > 1 || !!((_a = nonWhitespaceChildren[0]) == null ? void 0 : _a.dotDotDotToken);
            const args = [
                tagName,
                objectProperties
            ];
            if (keyAttr) args.push(transformJsxAttributeInitializer(keyAttr.initializer));
            if (compilerOptions.jsx === 5 /* ReactJSXDev */ ) {
                const originalFile = getOriginalNode(currentSourceFile);
                if (originalFile && isSourceFile(originalFile)) {
                    if (keyAttr === void 0) args.push(factory2.createVoidZero());
                    args.push(isStaticChildren ? factory2.createTrue() : factory2.createFalse());
                    const lineCol = getLineAndCharacterOfPosition(originalFile, location.pos);
                    args.push(factory2.createObjectLiteralExpression([
                        factory2.createPropertyAssignment("fileName", getCurrentFileNameExpression()),
                        factory2.createPropertyAssignment("lineNumber", factory2.createNumericLiteral(lineCol.line + 1)),
                        factory2.createPropertyAssignment("columnNumber", factory2.createNumericLiteral(lineCol.character + 1))
                    ]));
                    args.push(factory2.createThis());
                }
            }
            const element = setTextRange(factory2.createCallExpression(getJsxFactoryCallee(isStaticChildren), /*typeArguments*/ void 0, args), location);
            if (isChild) startOnNewLine(element);
            return element;
        }
        function visitJsxOpeningLikeElementCreateElement(node, children, isChild, location) {
            const tagName = getTagName(node);
            const attrs = node.attributes.properties;
            const objectProperties = length(attrs) ? transformJsxAttributesToObjectProps(attrs) : factory2.createNull();
            const callee = currentFileState.importSpecifier === void 0 ? createJsxFactoryExpression(factory2, context.getEmitResolver().getJsxFactoryEntity(currentSourceFile), compilerOptions.reactNamespace, // TODO: GH#18217
            node) : getImplicitImportForName("createElement");
            const element = createExpressionForJsxElement(factory2, callee, tagName, objectProperties, mapDefined(children, transformJsxChildToExpression), location);
            if (isChild) startOnNewLine(element);
            return element;
        }
        function visitJsxOpeningFragmentJSX(_node, children, isChild, location) {
            let childrenProps;
            if (children && children.length) {
                const result = convertJsxChildrenToChildrenPropObject(children);
                if (result) childrenProps = result;
            }
            return visitJsxOpeningLikeElementOrFragmentJSX(getImplicitJsxFragmentReference(), childrenProps || factory2.createObjectLiteralExpression([]), /*keyAttr*/ void 0, children, isChild, location);
        }
        function visitJsxOpeningFragmentCreateElement(node, children, isChild, location) {
            const element = createExpressionForJsxFragment(factory2, context.getEmitResolver().getJsxFactoryEntity(currentSourceFile), context.getEmitResolver().getJsxFragmentFactoryEntity(currentSourceFile), compilerOptions.reactNamespace, // TODO: GH#18217
            mapDefined(children, transformJsxChildToExpression), node, location);
            if (isChild) startOnNewLine(element);
            return element;
        }
        function transformJsxSpreadAttributeToProps(node) {
            if (isObjectLiteralExpression(node.expression) && !hasProto(node.expression)) return sameMap(node.expression.properties, (p)=>Debug.checkDefined(visitNode(p, visitor, isObjectLiteralElementLike)));
            return factory2.createSpreadAssignment(Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
        }
        function transformJsxAttributesToObjectProps(attrs, children) {
            const target = getEmitScriptTarget(compilerOptions);
            return target && target >= 5 /* ES2018 */  ? factory2.createObjectLiteralExpression(transformJsxAttributesToProps(attrs, children)) : transformJsxAttributesToExpression(attrs, children);
        }
        function transformJsxAttributesToProps(attrs, children) {
            const props = flatten(spanMap(attrs, isJsxSpreadAttribute, (attrs2, isSpread)=>flatten(map(attrs2, (attr)=>isSpread ? transformJsxSpreadAttributeToProps(attr) : transformJsxAttributeToObjectLiteralElement(attr)))));
            if (children) props.push(children);
            return props;
        }
        function transformJsxAttributesToExpression(attrs, children) {
            const expressions = [];
            let properties = [];
            for (const attr of attrs){
                if (isJsxSpreadAttribute(attr)) {
                    if (isObjectLiteralExpression(attr.expression) && !hasProto(attr.expression)) {
                        for (const prop of attr.expression.properties){
                            if (isSpreadAssignment(prop)) {
                                finishObjectLiteralIfNeeded();
                                expressions.push(Debug.checkDefined(visitNode(prop.expression, visitor, isExpression)));
                                continue;
                            }
                            properties.push(Debug.checkDefined(visitNode(prop, visitor)));
                        }
                        continue;
                    }
                    finishObjectLiteralIfNeeded();
                    expressions.push(Debug.checkDefined(visitNode(attr.expression, visitor, isExpression)));
                    continue;
                }
                properties.push(transformJsxAttributeToObjectLiteralElement(attr));
            }
            if (children) properties.push(children);
            finishObjectLiteralIfNeeded();
            if (expressions.length && !isObjectLiteralExpression(expressions[0])) expressions.unshift(factory2.createObjectLiteralExpression());
            return singleOrUndefined(expressions) || emitHelpers().createAssignHelper(expressions);
            function finishObjectLiteralIfNeeded() {
                if (properties.length) {
                    expressions.push(factory2.createObjectLiteralExpression(properties));
                    properties = [];
                }
            }
        }
        function transformJsxAttributeToObjectLiteralElement(node) {
            const name = getAttributeName(node);
            const expression = transformJsxAttributeInitializer(node.initializer);
            return factory2.createPropertyAssignment(name, expression);
        }
        function transformJsxAttributeInitializer(node) {
            if (node === void 0) return factory2.createTrue();
            if (node.kind === 11 /* StringLiteral */ ) {
                const singleQuote = node.singleQuote !== void 0 ? node.singleQuote : !isStringDoubleQuoted(node, currentSourceFile);
                const literal = factory2.createStringLiteral(tryDecodeEntities(node.text) || node.text, singleQuote);
                return setTextRange(literal, node);
            }
            if (node.kind === 295 /* JsxExpression */ ) {
                if (node.expression === void 0) return factory2.createTrue();
                return Debug.checkDefined(visitNode(node.expression, visitor, isExpression));
            }
            if (isJsxElement(node)) return visitJsxElement(node, /*isChild*/ false);
            if (isJsxSelfClosingElement(node)) return visitJsxSelfClosingElement(node, /*isChild*/ false);
            if (isJsxFragment(node)) return visitJsxFragment(node, /*isChild*/ false);
            return Debug.failBadSyntaxKind(node);
        }
        function visitJsxText(node) {
            const fixed = fixupWhitespaceAndDecodeEntities(node.text);
            return fixed === void 0 ? void 0 : factory2.createStringLiteral(fixed);
        }
        function fixupWhitespaceAndDecodeEntities(text) {
            let acc;
            let firstNonWhitespace = 0;
            let lastNonWhitespace = -1;
            for(let i = 0; i < text.length; i++){
                const c = text.charCodeAt(i);
                if (isLineBreak(c)) {
                    if (firstNonWhitespace !== -1 && lastNonWhitespace !== -1) acc = addLineOfJsxText(acc, text.substr(firstNonWhitespace, lastNonWhitespace - firstNonWhitespace + 1));
                    firstNonWhitespace = -1;
                } else if (!isWhiteSpaceSingleLine(c)) {
                    lastNonWhitespace = i;
                    if (firstNonWhitespace === -1) firstNonWhitespace = i;
                }
            }
            return firstNonWhitespace !== -1 ? addLineOfJsxText(acc, text.substr(firstNonWhitespace)) : acc;
        }
        function addLineOfJsxText(acc, trimmedLine) {
            const decoded = decodeEntities(trimmedLine);
            return acc === void 0 ? decoded : acc + " " + decoded;
        }
        function decodeEntities(text) {
            return text.replace(/&((#((\d+)|x([\da-fA-F]+)))|(\w+));/g, (match, _all, _number, _digits, decimal, hex, word)=>{
                if (decimal) return utf16EncodeAsString(parseInt(decimal, 10));
                else if (hex) return utf16EncodeAsString(parseInt(hex, 16));
                else {
                    const ch = entities.get(word);
                    return ch ? utf16EncodeAsString(ch) : match;
                }
            });
        }
        function tryDecodeEntities(text) {
            const decoded = decodeEntities(text);
            return decoded === text ? void 0 : decoded;
        }
        function getTagName(node) {
            if (node.kind === 285 /* JsxElement */ ) return getTagName(node.openingElement);
            else {
                const tagName = node.tagName;
                if (isIdentifier(tagName) && isIntrinsicJsxName(tagName.escapedText)) return factory2.createStringLiteral(idText(tagName));
                else if (isJsxNamespacedName(tagName)) return factory2.createStringLiteral(idText(tagName.namespace) + ":" + idText(tagName.name));
                else return createExpressionFromEntityName(factory2, tagName);
            }
        }
        function getAttributeName(node) {
            const name = node.name;
            if (isIdentifier(name)) {
                const text = idText(name);
                return /^[A-Z_]\w*$/i.test(text) ? name : factory2.createStringLiteral(text);
            }
            return factory2.createStringLiteral(idText(name.namespace) + ":" + idText(name.name));
        }
        function visitJsxExpression(node) {
            const expression = visitNode(node.expression, visitor, isExpression);
            return node.dotDotDotToken ? factory2.createSpreadElement(expression) : expression;
        }
    }
    var entities = new Map(Object.entries({
        quot: 34,
        amp: 38,
        apos: 39,
        lt: 60,
        gt: 62,
        nbsp: 160,
        iexcl: 161,
        cent: 162,
        pound: 163,
        curren: 164,
        yen: 165,
        brvbar: 166,
        sect: 167,
        uml: 168,
        copy: 169,
        ordf: 170,
        laquo: 171,
        not: 172,
        shy: 173,
        reg: 174,
        macr: 175,
        deg: 176,
        plusmn: 177,
        sup2: 178,
        sup3: 179,
        acute: 180,
        micro: 181,
        para: 182,
        middot: 183,
        cedil: 184,
        sup1: 185,
        ordm: 186,
        raquo: 187,
        frac14: 188,
        frac12: 189,
        frac34: 190,
        iquest: 191,
        Agrave: 192,
        Aacute: 193,
        Acirc: 194,
        Atilde: 195,
        Auml: 196,
        Aring: 197,
        AElig: 198,
        Ccedil: 199,
        Egrave: 200,
        Eacute: 201,
        Ecirc: 202,
        Euml: 203,
        Igrave: 204,
        Iacute: 205,
        Icirc: 206,
        Iuml: 207,
        ETH: 208,
        Ntilde: 209,
        Ograve: 210,
        Oacute: 211,
        Ocirc: 212,
        Otilde: 213,
        Ouml: 214,
        times: 215,
        Oslash: 216,
        Ugrave: 217,
        Uacute: 218,
        Ucirc: 219,
        Uuml: 220,
        Yacute: 221,
        THORN: 222,
        szlig: 223,
        agrave: 224,
        aacute: 225,
        acirc: 226,
        atilde: 227,
        auml: 228,
        aring: 229,
        aelig: 230,
        ccedil: 231,
        egrave: 232,
        eacute: 233,
        ecirc: 234,
        euml: 235,
        igrave: 236,
        iacute: 237,
        icirc: 238,
        iuml: 239,
        eth: 240,
        ntilde: 241,
        ograve: 242,
        oacute: 243,
        ocirc: 244,
        otilde: 245,
        ouml: 246,
        divide: 247,
        oslash: 248,
        ugrave: 249,
        uacute: 250,
        ucirc: 251,
        uuml: 252,
        yacute: 253,
        thorn: 254,
        yuml: 255,
        OElig: 338,
        oelig: 339,
        Scaron: 352,
        scaron: 353,
        Yuml: 376,
        fnof: 402,
        circ: 710,
        tilde: 732,
        Alpha: 913,
        Beta: 914,
        Gamma: 915,
        Delta: 916,
        Epsilon: 917,
        Zeta: 918,
        Eta: 919,
        Theta: 920,
        Iota: 921,
        Kappa: 922,
        Lambda: 923,
        Mu: 924,
        Nu: 925,
        Xi: 926,
        Omicron: 927,
        Pi: 928,
        Rho: 929,
        Sigma: 931,
        Tau: 932,
        Upsilon: 933,
        Phi: 934,
        Chi: 935,
        Psi: 936,
        Omega: 937,
        alpha: 945,
        beta: 946,
        gamma: 947,
        delta: 948,
        epsilon: 949,
        zeta: 950,
        eta: 951,
        theta: 952,
        iota: 953,
        kappa: 954,
        lambda: 955,
        mu: 956,
        nu: 957,
        xi: 958,
        omicron: 959,
        pi: 960,
        rho: 961,
        sigmaf: 962,
        sigma: 963,
        tau: 964,
        upsilon: 965,
        phi: 966,
        chi: 967,
        psi: 968,
        omega: 969,
        thetasym: 977,
        upsih: 978,
        piv: 982,
        ensp: 8194,
        emsp: 8195,
        thinsp: 8201,
        zwnj: 8204,
        zwj: 8205,
        lrm: 8206,
        rlm: 8207,
        ndash: 8211,
        mdash: 8212,
        lsquo: 8216,
        rsquo: 8217,
        sbquo: 8218,
        ldquo: 8220,
        rdquo: 8221,
        bdquo: 8222,
        dagger: 8224,
        Dagger: 8225,
        bull: 8226,
        hellip: 8230,
        permil: 8240,
        prime: 8242,
        Prime: 8243,
        lsaquo: 8249,
        rsaquo: 8250,
        oline: 8254,
        frasl: 8260,
        euro: 8364,
        image: 8465,
        weierp: 8472,
        real: 8476,
        trade: 8482,
        alefsym: 8501,
        larr: 8592,
        uarr: 8593,
        rarr: 8594,
        darr: 8595,
        harr: 8596,
        crarr: 8629,
        lArr: 8656,
        uArr: 8657,
        rArr: 8658,
        dArr: 8659,
        hArr: 8660,
        forall: 8704,
        part: 8706,
        exist: 8707,
        empty: 8709,
        nabla: 8711,
        isin: 8712,
        notin: 8713,
        ni: 8715,
        prod: 8719,
        sum: 8721,
        minus: 8722,
        lowast: 8727,
        radic: 8730,
        prop: 8733,
        infin: 8734,
        ang: 8736,
        and: 8743,
        or: 8744,
        cap: 8745,
        cup: 8746,
        int: 8747,
        there4: 8756,
        sim: 8764,
        cong: 8773,
        asymp: 8776,
        ne: 8800,
        equiv: 8801,
        le: 8804,
        ge: 8805,
        sub: 8834,
        sup: 8835,
        nsub: 8836,
        sube: 8838,
        supe: 8839,
        oplus: 8853,
        otimes: 8855,
        perp: 8869,
        sdot: 8901,
        lceil: 8968,
        rceil: 8969,
        lfloor: 8970,
        rfloor: 8971,
        lang: 9001,
        rang: 9002,
        loz: 9674,
        spades: 9824,
        clubs: 9827,
        hearts: 9829,
        diams: 9830
    }));
    // src/compiler/transformers/es2016.ts
    function transformES2016(context) {
        const { factory: factory2, hoistVariableDeclaration } = context;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            if ((node.transformFlags & 512 /* ContainsES2016 */ ) === 0) return node;
            switch(node.kind){
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitBinaryExpression(node) {
            switch(node.operatorToken.kind){
                case 68 /* AsteriskAsteriskEqualsToken */ :
                    return visitExponentiationAssignmentExpression(node);
                case 43 /* AsteriskAsteriskToken */ :
                    return visitExponentiationExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitExponentiationAssignmentExpression(node) {
            let target;
            let value1;
            const left = visitNode(node.left, visitor, isExpression);
            const right = visitNode(node.right, visitor, isExpression);
            if (isElementAccessExpression(left)) {
                const expressionTemp = factory2.createTempVariable(hoistVariableDeclaration);
                const argumentExpressionTemp = factory2.createTempVariable(hoistVariableDeclaration);
                target = setTextRange(factory2.createElementAccessExpression(setTextRange(factory2.createAssignment(expressionTemp, left.expression), left.expression), setTextRange(factory2.createAssignment(argumentExpressionTemp, left.argumentExpression), left.argumentExpression)), left);
                value1 = setTextRange(factory2.createElementAccessExpression(expressionTemp, argumentExpressionTemp), left);
            } else if (isPropertyAccessExpression(left)) {
                const expressionTemp = factory2.createTempVariable(hoistVariableDeclaration);
                target = setTextRange(factory2.createPropertyAccessExpression(setTextRange(factory2.createAssignment(expressionTemp, left.expression), left.expression), left.name), left);
                value1 = setTextRange(factory2.createPropertyAccessExpression(expressionTemp, left.name), left);
            } else {
                target = left;
                value1 = left;
            }
            return setTextRange(factory2.createAssignment(target, setTextRange(factory2.createGlobalMethodCall("Math", "pow", [
                value1,
                right
            ]), node)), node);
        }
        function visitExponentiationExpression(node) {
            const left = visitNode(node.left, visitor, isExpression);
            const right = visitNode(node.right, visitor, isExpression);
            return setTextRange(factory2.createGlobalMethodCall("Math", "pow", [
                left,
                right
            ]), node);
        }
    }
    // src/compiler/transformers/es2015.ts
    function createSpreadSegment(kind, expression) {
        return {
            kind,
            expression
        };
    }
    function transformES2015(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, startLexicalEnvironment, resumeLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const compilerOptions = context.getCompilerOptions();
        const resolver = context.getEmitResolver();
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        let currentSourceFile;
        let currentText;
        let hierarchyFacts;
        let taggedTemplateStringDeclarations;
        function recordTaggedTemplateString(temp) {
            taggedTemplateStringDeclarations = append(taggedTemplateStringDeclarations, factory2.createVariableDeclaration(temp));
        }
        let convertedLoopState;
        let enabledSubstitutions = 0 /* None */ ;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            currentText = node.text;
            const visited = visitSourceFile(node);
            addEmitHelpers(visited, context.readEmitHelpers());
            currentSourceFile = void 0;
            currentText = void 0;
            taggedTemplateStringDeclarations = void 0;
            hierarchyFacts = 0 /* None */ ;
            return visited;
        }
        function enterSubtree(excludeFacts, includeFacts) {
            const ancestorFacts = hierarchyFacts;
            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & 32767 /* AncestorFactsMask */ ;
            return ancestorFacts;
        }
        function exitSubtree(ancestorFacts, excludeFacts, includeFacts) {
            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & -32768 /* SubtreeFactsMask */  | ancestorFacts;
        }
        function isReturnVoidStatementInConstructorWithCapturedSuper(node) {
            return (hierarchyFacts & 8192 /* ConstructorWithSuperCall */ ) !== 0 && node.kind === 254 /* ReturnStatement */  && !node.expression;
        }
        function isOrMayContainReturnCompletion(node) {
            return node.transformFlags & 4194304 /* ContainsHoistedDeclarationOrCompletion */  && (isReturnStatement(node) || isIfStatement(node) || isWithStatement(node) || isSwitchStatement(node) || isCaseBlock(node) || isCaseClause(node) || isDefaultClause(node) || isTryStatement(node) || isCatchClause(node) || isLabeledStatement(node) || isIterationStatement(node, /*lookInLabeledStatements*/ false) || isBlock(node));
        }
        function shouldVisitNode(node) {
            return (node.transformFlags & 1024 /* ContainsES2015 */ ) !== 0 || convertedLoopState !== void 0 || hierarchyFacts & 8192 /* ConstructorWithSuperCall */  && isOrMayContainReturnCompletion(node) || isIterationStatement(node, /*lookInLabeledStatements*/ false) && shouldConvertIterationStatement(node) || (getInternalEmitFlags(node) & 1 /* TypeScriptClassWrapper */ ) !== 0;
        }
        function visitor(node) {
            return shouldVisitNode(node) ? visitorWorker(node, /*expressionResultIsUnused*/ false) : node;
        }
        function visitorWithUnusedExpressionResult(node) {
            return shouldVisitNode(node) ? visitorWorker(node, /*expressionResultIsUnused*/ true) : node;
        }
        function classWrapperStatementVisitor(node) {
            if (shouldVisitNode(node)) {
                const original = getOriginalNode(node);
                if (isPropertyDeclaration(original) && hasStaticModifier(original)) {
                    const ancestorFacts = enterSubtree(32670 /* StaticInitializerExcludes */ , 16449 /* StaticInitializerIncludes */ );
                    const result = visitorWorker(node, /*expressionResultIsUnused*/ false);
                    exitSubtree(ancestorFacts, 229376 /* FunctionSubtreeExcludes */ , 0 /* None */ );
                    return result;
                }
                return visitorWorker(node, /*expressionResultIsUnused*/ false);
            }
            return node;
        }
        function callExpressionVisitor(node) {
            if (node.kind === 108 /* SuperKeyword */ ) return visitSuperKeyword(node, /*isExpressionOfCall*/ true);
            return visitor(node);
        }
        function visitorWorker(node, expressionResultIsUnused2) {
            switch(node.kind){
                case 126 /* StaticKeyword */ :
                    return void 0;
                // elide static keyword
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 232 /* ClassExpression */ :
                    return visitClassExpression(node);
                case 170 /* Parameter */ :
                    return visitParameter(node);
                case 263 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 220 /* ArrowFunction */ :
                    return visitArrowFunction(node);
                case 219 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                case 261 /* VariableDeclaration */ :
                    return visitVariableDeclaration(node);
                case 80 /* Identifier */ :
                    return visitIdentifier(node);
                case 262 /* VariableDeclarationList */ :
                    return visitVariableDeclarationList(node);
                case 256 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 270 /* CaseBlock */ :
                    return visitCaseBlock(node);
                case 242 /* Block */ :
                    return visitBlock(node, /*isFunctionBody*/ false);
                case 253 /* BreakStatement */ :
                case 252 /* ContinueStatement */ :
                    return visitBreakOrContinueStatement(node);
                case 257 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                    return visitDoOrWhileStatement(node, /*outermostLabeledStatement*/ void 0);
                case 249 /* ForStatement */ :
                    return visitForStatement(node, /*outermostLabeledStatement*/ void 0);
                case 250 /* ForInStatement */ :
                    return visitForInStatement(node, /*outermostLabeledStatement*/ void 0);
                case 251 /* ForOfStatement */ :
                    return visitForOfStatement(node, /*outermostLabeledStatement*/ void 0);
                case 245 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 211 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 300 /* CatchClause */ :
                    return visitCatchClause(node);
                case 305 /* ShorthandPropertyAssignment */ :
                    return visitShorthandPropertyAssignment(node);
                case 168 /* ComputedPropertyName */ :
                    return visitComputedPropertyName(node);
                case 210 /* ArrayLiteralExpression */ :
                    return visitArrayLiteralExpression(node);
                case 214 /* CallExpression */ :
                    return visitCallExpression(node);
                case 215 /* NewExpression */ :
                    return visitNewExpression(node);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, expressionResultIsUnused2);
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node, expressionResultIsUnused2);
                case 357 /* CommaListExpression */ :
                    return visitCommaListExpression(node, expressionResultIsUnused2);
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 16 /* TemplateHead */ :
                case 17 /* TemplateMiddle */ :
                case 18 /* TemplateTail */ :
                    return visitTemplateLiteral(node);
                case 11 /* StringLiteral */ :
                    return visitStringLiteral(node);
                case 9 /* NumericLiteral */ :
                    return visitNumericLiteral(node);
                case 216 /* TaggedTemplateExpression */ :
                    return visitTaggedTemplateExpression(node);
                case 229 /* TemplateExpression */ :
                    return visitTemplateExpression(node);
                case 230 /* YieldExpression */ :
                    return visitYieldExpression(node);
                case 231 /* SpreadElement */ :
                    return visitSpreadElement(node);
                case 108 /* SuperKeyword */ :
                    return visitSuperKeyword(node, /*isExpressionOfCall*/ false);
                case 110 /* ThisKeyword */ :
                    return visitThisKeyword(node);
                case 237 /* MetaProperty */ :
                    return visitMetaProperty(node);
                case 175 /* MethodDeclaration */ :
                    return visitMethodDeclaration(node);
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return visitAccessorDeclaration(node);
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 254 /* ReturnStatement */ :
                    return visitReturnStatement(node);
                case 223 /* VoidExpression */ :
                    return visitVoidExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitSourceFile(node) {
            const ancestorFacts = enterSubtree(8064 /* SourceFileExcludes */ , 64 /* SourceFileIncludes */ );
            const prologue = [];
            const statements = [];
            startLexicalEnvironment();
            const statementOffset = factory2.copyPrologue(node.statements, prologue, /*ensureUseStrict*/ false, visitor);
            addRange(statements, visitNodes2(node.statements, visitor, isStatement, statementOffset));
            if (taggedTemplateStringDeclarations) statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(taggedTemplateStringDeclarations)));
            factory2.mergeLexicalEnvironment(prologue, endLexicalEnvironment());
            insertCaptureThisForNodeIfNeeded(prologue, node);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray(concatenate(prologue, statements)), node.statements));
        }
        function visitSwitchStatement(node) {
            if (convertedLoopState !== void 0) {
                const savedAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
                convertedLoopState.allowedNonLabeledJumps |= 2 /* Break */ ;
                const result = visitEachChild(node, visitor, context);
                convertedLoopState.allowedNonLabeledJumps = savedAllowedNonLabeledJumps;
                return result;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCaseBlock(node) {
            const ancestorFacts = enterSubtree(7104 /* BlockScopeExcludes */ , 0 /* BlockScopeIncludes */ );
            const updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function returnCapturedThis(node) {
            return setOriginalNode(factory2.createReturnStatement(createCapturedThis()), node);
        }
        function createCapturedThis() {
            return factory2.createUniqueName("_this", 48 /* FileLevel */ );
        }
        function visitReturnStatement(node) {
            if (convertedLoopState) {
                convertedLoopState.nonLocalJumps |= 8 /* Return */ ;
                if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) node = returnCapturedThis(node);
                return factory2.createReturnStatement(factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment(factory2.createIdentifier("value"), node.expression ? Debug.checkDefined(visitNode(node.expression, visitor, isExpression)) : factory2.createVoidZero())
                ]));
            } else if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) return returnCapturedThis(node);
            return visitEachChild(node, visitor, context);
        }
        function visitThisKeyword(node) {
            hierarchyFacts |= 65536 /* LexicalThis */ ;
            if (hierarchyFacts & 2 /* ArrowFunction */  && !(hierarchyFacts & 16384 /* StaticInitializer */ )) hierarchyFacts |= 131072 /* CapturedLexicalThis */ ;
            if (convertedLoopState) {
                if (hierarchyFacts & 2 /* ArrowFunction */ ) {
                    convertedLoopState.containsLexicalThis = true;
                    return node;
                }
                return convertedLoopState.thisName || (convertedLoopState.thisName = factory2.createUniqueName("this"));
            }
            return node;
        }
        function visitVoidExpression(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitIdentifier(node) {
            if (convertedLoopState) {
                if (resolver.isArgumentsLocalBinding(node)) return convertedLoopState.argumentsName || (convertedLoopState.argumentsName = factory2.createUniqueName("arguments"));
            }
            if (node.flags & 256 /* IdentifierHasExtendedUnicodeEscape */ ) return setOriginalNode(setTextRange(factory2.createIdentifier(unescapeLeadingUnderscores(node.escapedText)), node), node);
            return node;
        }
        function visitBreakOrContinueStatement(node) {
            if (convertedLoopState) {
                const jump = node.kind === 253 /* BreakStatement */  ? 2 /* Break */  : 4 /* Continue */ ;
                const canUseBreakOrContinue = node.label && convertedLoopState.labels && convertedLoopState.labels.get(idText(node.label)) || !node.label && convertedLoopState.allowedNonLabeledJumps & jump;
                if (!canUseBreakOrContinue) {
                    let labelMarker;
                    const label = node.label;
                    if (!label) {
                        if (node.kind === 253 /* BreakStatement */ ) {
                            convertedLoopState.nonLocalJumps |= 2 /* Break */ ;
                            labelMarker = "break";
                        } else {
                            convertedLoopState.nonLocalJumps |= 4 /* Continue */ ;
                            labelMarker = "continue";
                        }
                    } else if (node.kind === 253 /* BreakStatement */ ) {
                        labelMarker = `break-${label.escapedText}`;
                        setLabeledJump(convertedLoopState, /*isBreak*/ true, idText(label), labelMarker);
                    } else {
                        labelMarker = `continue-${label.escapedText}`;
                        setLabeledJump(convertedLoopState, /*isBreak*/ false, idText(label), labelMarker);
                    }
                    let returnExpression = factory2.createStringLiteral(labelMarker);
                    if (convertedLoopState.loopOutParameters.length) {
                        const outParams = convertedLoopState.loopOutParameters;
                        let expr;
                        for(let i = 0; i < outParams.length; i++){
                            const copyExpr = copyOutParameter(outParams[i], 1 /* ToOutParameter */ );
                            if (i === 0) expr = copyExpr;
                            else expr = factory2.createBinaryExpression(expr, 28 /* CommaToken */ , copyExpr);
                        }
                        returnExpression = factory2.createBinaryExpression(expr, 28 /* CommaToken */ , returnExpression);
                    }
                    return factory2.createReturnStatement(returnExpression);
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function visitClassDeclaration(node) {
            const variable = factory2.createVariableDeclaration(factory2.getLocalName(node, /*allowComments*/ true), /*exclamationToken*/ void 0, /*type*/ void 0, transformClassLikeDeclarationToExpression(node));
            setOriginalNode(variable, node);
            const statements = [];
            const statement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                variable
            ]));
            setOriginalNode(statement, node);
            setTextRange(statement, node);
            startOnNewLine(statement);
            statements.push(statement);
            if (hasSyntacticModifier(node, 32 /* Export */ )) {
                const exportStatement = hasSyntacticModifier(node, 2048 /* Default */ ) ? factory2.createExportDefault(factory2.getLocalName(node)) : factory2.createExternalModuleExport(factory2.getLocalName(node));
                setOriginalNode(exportStatement, statement);
                statements.push(exportStatement);
            }
            return singleOrMany(statements);
        }
        function visitClassExpression(node) {
            return transformClassLikeDeclarationToExpression(node);
        }
        function transformClassLikeDeclarationToExpression(node) {
            if (node.name) enableSubstitutionsForBlockScopedBindings();
            const extendsClauseElement = getClassExtendsHeritageElement(node);
            const classFunction = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, extendsClauseElement ? [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, createSyntheticSuper())
            ] : [], /*type*/ void 0, transformClassBody(node, extendsClauseElement));
            setEmitFlags(classFunction, getEmitFlags(node) & 131072 /* Indented */  | 1048576 /* ReuseTempVariableScope */ );
            const inner = factory2.createPartiallyEmittedExpression(classFunction);
            setTextRangeEnd(inner, node.end);
            setEmitFlags(inner, 3072 /* NoComments */ );
            const outer = factory2.createPartiallyEmittedExpression(inner);
            setTextRangeEnd(outer, skipTrivia(currentText, node.pos));
            setEmitFlags(outer, 3072 /* NoComments */ );
            const result = factory2.createParenthesizedExpression(factory2.createCallExpression(outer, /*typeArguments*/ void 0, extendsClauseElement ? [
                Debug.checkDefined(visitNode(extendsClauseElement.expression, visitor, isExpression))
            ] : []));
            addSyntheticLeadingComment(result, 3 /* MultiLineCommentTrivia */ , "* @class ");
            return result;
        }
        function transformClassBody(node, extendsClauseElement) {
            const statements = [];
            const name = factory2.getInternalName(node);
            const constructorLikeName = isIdentifierANonContextualKeyword(name) ? factory2.getGeneratedNameForNode(name) : name;
            startLexicalEnvironment();
            addExtendsHelperIfNeeded(statements, node, extendsClauseElement);
            addConstructor(statements, node, constructorLikeName, extendsClauseElement);
            addClassMembers(statements, node);
            const closingBraceLocation = createTokenRange(skipTrivia(currentText, node.members.end), 20 /* CloseBraceToken */ );
            const outer = factory2.createPartiallyEmittedExpression(constructorLikeName);
            setTextRangeEnd(outer, closingBraceLocation.end);
            setEmitFlags(outer, 3072 /* NoComments */ );
            const statement = factory2.createReturnStatement(outer);
            setTextRangePos(statement, closingBraceLocation.pos);
            setEmitFlags(statement, 3840 /* NoTokenSourceMaps */ );
            statements.push(statement);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), /*location*/ node.members), /*multiLine*/ true);
            setEmitFlags(block, 3072 /* NoComments */ );
            return block;
        }
        function addExtendsHelperIfNeeded(statements, node, extendsClauseElement) {
            if (extendsClauseElement) statements.push(setTextRange(factory2.createExpressionStatement(emitHelpers().createExtendsHelper(factory2.getInternalName(node))), /*location*/ extendsClauseElement));
        }
        function addConstructor(statements, node, name, extendsClauseElement) {
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(32662 /* ConstructorExcludes */ , 73 /* ConstructorIncludes */ );
            const constructor = getFirstConstructorWithBody(node);
            const hasSynthesizedSuper = hasSynthesizedDefaultSuperCall(constructor, extendsClauseElement !== void 0);
            const constructorFunction = factory2.createFunctionDeclaration(/*modifiers*/ void 0, /*asteriskToken*/ void 0, name, /*typeParameters*/ void 0, transformConstructorParameters(constructor, hasSynthesizedSuper), /*type*/ void 0, transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper));
            setTextRange(constructorFunction, constructor || node);
            if (extendsClauseElement) setEmitFlags(constructorFunction, 16 /* CapturesThis */ );
            statements.push(constructorFunction);
            exitSubtree(ancestorFacts, 229376 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
        }
        function transformConstructorParameters(constructor, hasSynthesizedSuper) {
            return visitParameterList(constructor && !hasSynthesizedSuper ? constructor.parameters : void 0, visitor, context) || [];
        }
        function createDefaultConstructorBody(node, isDerivedClass) {
            const statements = [];
            resumeLexicalEnvironment();
            factory2.mergeLexicalEnvironment(statements, endLexicalEnvironment());
            if (isDerivedClass) statements.push(factory2.createReturnStatement(createDefaultSuperCallOrThis()));
            const statementsArray = factory2.createNodeArray(statements);
            setTextRange(statementsArray, node.members);
            const block = factory2.createBlock(statementsArray, /*multiLine*/ true);
            setTextRange(block, node);
            setEmitFlags(block, 3072 /* NoComments */ );
            return block;
        }
        function isUninitializedVariableStatement(node) {
            return isVariableStatement(node) && every(node.declarationList.declarations, (decl)=>isIdentifier(decl.name) && !decl.initializer);
        }
        function containsSuperCall(node) {
            if (isSuperCall(node)) return true;
            if (!(node.transformFlags & 134217728 /* ContainsLexicalSuper */ )) return false;
            switch(node.kind){
                // stop at function boundaries
                case 220 /* ArrowFunction */ :
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                case 177 /* Constructor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    return false;
                // only step into computed property names for class and object literal elements
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 175 /* MethodDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                    {
                        const named = node;
                        if (isComputedPropertyName(named.name)) return !!forEachChild(named.name, containsSuperCall);
                        return false;
                    }
            }
            return !!forEachChild(node, containsSuperCall);
        }
        function transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper) {
            const isDerivedClass = !!extendsClauseElement && skipOuterExpressions(extendsClauseElement.expression).kind !== 106 /* NullKeyword */ ;
            if (!constructor) return createDefaultConstructorBody(node, isDerivedClass);
            const prologue = [];
            const statements = [];
            resumeLexicalEnvironment();
            const standardPrologueEnd = factory2.copyStandardPrologue(constructor.body.statements, prologue, /*statementOffset*/ 0);
            if (hasSynthesizedSuper || containsSuperCall(constructor.body)) hierarchyFacts |= 8192 /* ConstructorWithSuperCall */ ;
            addRange(statements, visitNodes2(constructor.body.statements, visitor, isStatement, standardPrologueEnd));
            const mayReplaceThis = isDerivedClass || hierarchyFacts & 8192 /* ConstructorWithSuperCall */ ;
            addDefaultValueAssignmentsIfNeeded2(prologue, constructor);
            addRestParameterIfNeeded(prologue, constructor, hasSynthesizedSuper);
            insertCaptureNewTargetIfNeeded(prologue, constructor);
            if (mayReplaceThis) insertCaptureThisForNode(prologue, constructor, createActualThis());
            else insertCaptureThisForNodeIfNeeded(prologue, constructor);
            factory2.mergeLexicalEnvironment(prologue, endLexicalEnvironment());
            if (mayReplaceThis && !isSufficientlyCoveredByReturnStatements(constructor.body)) statements.push(factory2.createReturnStatement(createCapturedThis()));
            const body = factory2.createBlock(setTextRange(factory2.createNodeArray([
                ...prologue,
                ...statements
            ]), /*location*/ constructor.body.statements), /*multiLine*/ true);
            setTextRange(body, constructor.body);
            return simplifyConstructor(body, constructor.body, hasSynthesizedSuper);
        }
        function isCapturedThis(node) {
            return isGeneratedIdentifier(node) && idText(node) === "_this";
        }
        function isSyntheticSuper(node) {
            return isGeneratedIdentifier(node) && idText(node) === "_super";
        }
        function isThisCapturingVariableStatement(node) {
            return isVariableStatement(node) && node.declarationList.declarations.length === 1 && isThisCapturingVariableDeclaration(node.declarationList.declarations[0]);
        }
        function isThisCapturingVariableDeclaration(node) {
            return isVariableDeclaration(node) && isCapturedThis(node.name) && !!node.initializer;
        }
        function isThisCapturingAssignment(node) {
            return isAssignmentExpression(node, /*excludeCompoundAssignment*/ true) && isCapturedThis(node.left);
        }
        function isTransformedSuperCall(node) {
            return isCallExpression(node) && isPropertyAccessExpression(node.expression) && isSyntheticSuper(node.expression.expression) && isIdentifier(node.expression.name) && (idText(node.expression.name) === "call" || idText(node.expression.name) === "apply") && node.arguments.length >= 1 && node.arguments[0].kind === 110 /* ThisKeyword */ ;
        }
        function isTransformedSuperCallWithFallback(node) {
            return isBinaryExpression(node) && node.operatorToken.kind === 57 /* BarBarToken */  && node.right.kind === 110 /* ThisKeyword */  && isTransformedSuperCall(node.left);
        }
        function isImplicitSuperCall(node) {
            return isBinaryExpression(node) && node.operatorToken.kind === 56 /* AmpersandAmpersandToken */  && isBinaryExpression(node.left) && node.left.operatorToken.kind === 38 /* ExclamationEqualsEqualsToken */  && isSyntheticSuper(node.left.left) && node.left.right.kind === 106 /* NullKeyword */  && isTransformedSuperCall(node.right) && idText(node.right.expression.name) === "apply";
        }
        function isImplicitSuperCallWithFallback(node) {
            return isBinaryExpression(node) && node.operatorToken.kind === 57 /* BarBarToken */  && node.right.kind === 110 /* ThisKeyword */  && isImplicitSuperCall(node.left);
        }
        function isThisCapturingTransformedSuperCallWithFallback(node) {
            return isThisCapturingAssignment(node) && isTransformedSuperCallWithFallback(node.right);
        }
        function isThisCapturingImplicitSuperCallWithFallback(node) {
            return isThisCapturingAssignment(node) && isImplicitSuperCallWithFallback(node.right);
        }
        function isTransformedSuperCallLike(node) {
            return isTransformedSuperCall(node) || isTransformedSuperCallWithFallback(node) || isThisCapturingTransformedSuperCallWithFallback(node) || isImplicitSuperCall(node) || isImplicitSuperCallWithFallback(node) || isThisCapturingImplicitSuperCallWithFallback(node);
        }
        function simplifyConstructorInlineSuperInThisCaptureVariable(body) {
            for(let i = 0; i < body.statements.length - 1; i++){
                const statement = body.statements[i];
                if (!isThisCapturingVariableStatement(statement)) continue;
                const varDecl = statement.declarationList.declarations[0];
                if (varDecl.initializer.kind !== 110 /* ThisKeyword */ ) continue;
                const thisCaptureStatementIndex = i;
                let superCallIndex = i + 1;
                while(superCallIndex < body.statements.length){
                    const statement2 = body.statements[superCallIndex];
                    if (isExpressionStatement(statement2)) {
                        if (isTransformedSuperCallLike(skipOuterExpressions(statement2.expression))) break;
                    }
                    if (isUninitializedVariableStatement(statement2)) {
                        superCallIndex++;
                        continue;
                    }
                    return body;
                }
                const following = body.statements[superCallIndex];
                let expression = following.expression;
                if (isThisCapturingAssignment(expression)) expression = expression.right;
                const newVarDecl = factory2.updateVariableDeclaration(varDecl, varDecl.name, /*exclamationToken*/ void 0, /*type*/ void 0, expression);
                const newDeclList = factory2.updateVariableDeclarationList(statement.declarationList, [
                    newVarDecl
                ]);
                const newVarStatement = factory2.createVariableStatement(statement.modifiers, newDeclList);
                setOriginalNode(newVarStatement, following);
                setTextRange(newVarStatement, following);
                const newStatements = factory2.createNodeArray([
                    ...body.statements.slice(0, thisCaptureStatementIndex),
                    // copy statements preceding to `var _this`
                    ...body.statements.slice(thisCaptureStatementIndex + 1, superCallIndex),
                    // copy intervening temp variables
                    newVarStatement,
                    ...body.statements.slice(superCallIndex + 1)
                ]);
                setTextRange(newStatements, body.statements);
                return factory2.updateBlock(body, newStatements);
            }
            return body;
        }
        function simplifyConstructorInlineSuperReturn(body, original) {
            for (const statement of original.statements){
                if (statement.transformFlags & 134217728 /* ContainsLexicalSuper */  && !getSuperCallFromStatement(statement)) return body;
            }
            const canElideThisCapturingVariable = !(original.transformFlags & 16384 /* ContainsLexicalThis */ ) && !(hierarchyFacts & 65536 /* LexicalThis */ ) && !(hierarchyFacts & 131072 /* CapturedLexicalThis */ );
            for(let i = body.statements.length - 1; i > 0; i--){
                const statement = body.statements[i];
                if (isReturnStatement(statement) && statement.expression && isCapturedThis(statement.expression)) {
                    const preceding = body.statements[i - 1];
                    let expression;
                    if (isExpressionStatement(preceding) && isThisCapturingTransformedSuperCallWithFallback(skipOuterExpressions(preceding.expression))) expression = preceding.expression;
                    else if (canElideThisCapturingVariable && isThisCapturingVariableStatement(preceding)) {
                        const varDecl = preceding.declarationList.declarations[0];
                        if (isTransformedSuperCallLike(skipOuterExpressions(varDecl.initializer))) expression = factory2.createAssignment(createCapturedThis(), varDecl.initializer);
                    }
                    if (!expression) break;
                    const newReturnStatement = factory2.createReturnStatement(expression);
                    setOriginalNode(newReturnStatement, preceding);
                    setTextRange(newReturnStatement, preceding);
                    const newStatements = factory2.createNodeArray([
                        ...body.statements.slice(0, i - 1),
                        // copy all statements preceding `_super.call(this, ...)`
                        newReturnStatement,
                        ...body.statements.slice(i + 1)
                    ]);
                    setTextRange(newStatements, body.statements);
                    return factory2.updateBlock(body, newStatements);
                }
            }
            return body;
        }
        function elideUnusedThisCaptureWorker(node) {
            if (isThisCapturingVariableStatement(node)) {
                const varDecl = node.declarationList.declarations[0];
                if (varDecl.initializer.kind === 110 /* ThisKeyword */ ) return void 0;
            } else if (isThisCapturingAssignment(node)) return factory2.createPartiallyEmittedExpression(node.right, node);
            switch(node.kind){
                // stop at function boundaries
                case 220 /* ArrowFunction */ :
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                case 177 /* Constructor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    return node;
                // only step into computed property names for class and object literal elements
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 175 /* MethodDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                    {
                        const named = node;
                        if (isComputedPropertyName(named.name)) return factory2.replacePropertyName(named, visitEachChild(named.name, elideUnusedThisCaptureWorker, /*context*/ void 0));
                        return node;
                    }
            }
            return visitEachChild(node, elideUnusedThisCaptureWorker, /*context*/ void 0);
        }
        function simplifyConstructorElideUnusedThisCapture(body, original) {
            if (original.transformFlags & 16384 /* ContainsLexicalThis */  || hierarchyFacts & 65536 /* LexicalThis */  || hierarchyFacts & 131072 /* CapturedLexicalThis */ ) return body;
            for (const statement of original.statements){
                if (statement.transformFlags & 134217728 /* ContainsLexicalSuper */  && !getSuperCallFromStatement(statement)) return body;
            }
            return factory2.updateBlock(body, visitNodes2(body.statements, elideUnusedThisCaptureWorker, isStatement));
        }
        function injectSuperPresenceCheckWorker(node) {
            if (isTransformedSuperCall(node) && node.arguments.length === 2 && isIdentifier(node.arguments[1]) && idText(node.arguments[1]) === "arguments") return factory2.createLogicalAnd(factory2.createStrictInequality(createSyntheticSuper(), factory2.createNull()), node);
            switch(node.kind){
                // stop at function boundaries
                case 220 /* ArrowFunction */ :
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                case 177 /* Constructor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    return node;
                // only step into computed property names for class and object literal elements
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 175 /* MethodDeclaration */ :
                case 173 /* PropertyDeclaration */ :
                    {
                        const named = node;
                        if (isComputedPropertyName(named.name)) return factory2.replacePropertyName(named, visitEachChild(named.name, injectSuperPresenceCheckWorker, /*context*/ void 0));
                        return node;
                    }
            }
            return visitEachChild(node, injectSuperPresenceCheckWorker, /*context*/ void 0);
        }
        function complicateConstructorInjectSuperPresenceCheck(body) {
            return factory2.updateBlock(body, visitNodes2(body.statements, injectSuperPresenceCheckWorker, isStatement));
        }
        function simplifyConstructor(body, original, hasSynthesizedSuper) {
            const inputBody = body;
            body = simplifyConstructorInlineSuperInThisCaptureVariable(body);
            body = simplifyConstructorInlineSuperReturn(body, original);
            if (body !== inputBody) body = simplifyConstructorElideUnusedThisCapture(body, original);
            if (hasSynthesizedSuper) body = complicateConstructorInjectSuperPresenceCheck(body);
            return body;
        }
        function isSufficientlyCoveredByReturnStatements(statement) {
            if (statement.kind === 254 /* ReturnStatement */ ) return true;
            else if (statement.kind === 246 /* IfStatement */ ) {
                const ifStatement = statement;
                if (ifStatement.elseStatement) return isSufficientlyCoveredByReturnStatements(ifStatement.thenStatement) && isSufficientlyCoveredByReturnStatements(ifStatement.elseStatement);
            } else if (statement.kind === 242 /* Block */ ) {
                const lastStatement = lastOrUndefined(statement.statements);
                if (lastStatement && isSufficientlyCoveredByReturnStatements(lastStatement)) return true;
            }
            return false;
        }
        function createActualThis() {
            return setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ );
        }
        function createDefaultSuperCallOrThis() {
            return factory2.createLogicalOr(factory2.createLogicalAnd(factory2.createStrictInequality(createSyntheticSuper(), factory2.createNull()), factory2.createFunctionApplyCall(createSyntheticSuper(), createActualThis(), factory2.createIdentifier("arguments"))), createActualThis());
        }
        function visitParameter(node) {
            if (node.dotDotDotToken) return void 0;
            else if (isBindingPattern(node.name)) return setOriginalNode(setTextRange(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory2.getGeneratedNameForNode(node), /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0), /*location*/ node), /*original*/ node);
            else if (node.initializer) return setOriginalNode(setTextRange(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, node.name, /*questionToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0), /*location*/ node), /*original*/ node);
            else return node;
        }
        function hasDefaultValueOrBindingPattern(node) {
            return node.initializer !== void 0 || isBindingPattern(node.name);
        }
        function addDefaultValueAssignmentsIfNeeded2(statements, node) {
            if (!some(node.parameters, hasDefaultValueOrBindingPattern)) return false;
            let added = false;
            for (const parameter of node.parameters){
                const { name, initializer, dotDotDotToken } = parameter;
                if (dotDotDotToken) continue;
                if (isBindingPattern(name)) added = insertDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer) || added;
                else if (initializer) {
                    insertDefaultValueAssignmentForInitializer(statements, parameter, name, initializer);
                    added = true;
                }
            }
            return added;
        }
        function insertDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer) {
            if (name.elements.length > 0) {
                insertStatementAfterCustomPrologue(statements, setEmitFlags(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(flattenDestructuringBinding(parameter, visitor, context, 0 /* All */ , factory2.getGeneratedNameForNode(parameter)))), 2097152 /* CustomPrologue */ ));
                return true;
            } else if (initializer) {
                insertStatementAfterCustomPrologue(statements, setEmitFlags(factory2.createExpressionStatement(factory2.createAssignment(factory2.getGeneratedNameForNode(parameter), Debug.checkDefined(visitNode(initializer, visitor, isExpression)))), 2097152 /* CustomPrologue */ ));
                return true;
            }
            return false;
        }
        function insertDefaultValueAssignmentForInitializer(statements, parameter, name, initializer) {
            initializer = Debug.checkDefined(visitNode(initializer, visitor, isExpression));
            const statement = factory2.createIfStatement(factory2.createTypeCheck(factory2.cloneNode(name), "undefined"), setEmitFlags(setTextRange(factory2.createBlock([
                factory2.createExpressionStatement(setEmitFlags(setTextRange(factory2.createAssignment(// TODO(rbuckton): Does this need to be parented?
                setEmitFlags(setParent(setTextRange(factory2.cloneNode(name), name), name.parent), 96 /* NoSourceMap */ ), setEmitFlags(initializer, 96 /* NoSourceMap */  | getEmitFlags(initializer) | 3072 /* NoComments */ )), parameter), 3072 /* NoComments */ ))
            ]), parameter), 3905 /* NoComments */ ));
            startOnNewLine(statement);
            setTextRange(statement, parameter);
            setEmitFlags(statement, 2101056 /* NoComments */ );
            insertStatementAfterCustomPrologue(statements, statement);
        }
        function shouldAddRestParameter(node, inConstructorWithSynthesizedSuper) {
            return !!(node && node.dotDotDotToken && !inConstructorWithSynthesizedSuper);
        }
        function addRestParameterIfNeeded(statements, node, inConstructorWithSynthesizedSuper) {
            const prologueStatements = [];
            const parameter = lastOrUndefined(node.parameters);
            if (!shouldAddRestParameter(parameter, inConstructorWithSynthesizedSuper)) return false;
            const declarationName = parameter.name.kind === 80 /* Identifier */  ? setParent(setTextRange(factory2.cloneNode(parameter.name), parameter.name), parameter.name.parent) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            setEmitFlags(declarationName, 96 /* NoSourceMap */ );
            const expressionName = parameter.name.kind === 80 /* Identifier */  ? factory2.cloneNode(parameter.name) : declarationName;
            const restIndex = node.parameters.length - 1;
            const temp = factory2.createLoopVariable();
            prologueStatements.push(setEmitFlags(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(declarationName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createArrayLiteralExpression([]))
            ])), /*location*/ parameter), 2097152 /* CustomPrologue */ ));
            const forStatement = factory2.createForStatement(setTextRange(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(temp, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createNumericLiteral(restIndex))
            ]), parameter), setTextRange(factory2.createLessThan(temp, factory2.createPropertyAccessExpression(factory2.createIdentifier("arguments"), "length")), parameter), setTextRange(factory2.createPostfixIncrement(temp), parameter), factory2.createBlock([
                startOnNewLine(setTextRange(factory2.createExpressionStatement(factory2.createAssignment(factory2.createElementAccessExpression(expressionName, restIndex === 0 ? temp : factory2.createSubtract(temp, factory2.createNumericLiteral(restIndex))), factory2.createElementAccessExpression(factory2.createIdentifier("arguments"), temp))), /*location*/ parameter))
            ]));
            setEmitFlags(forStatement, 2097152 /* CustomPrologue */ );
            startOnNewLine(forStatement);
            prologueStatements.push(forStatement);
            if (parameter.name.kind !== 80 /* Identifier */ ) prologueStatements.push(setEmitFlags(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(flattenDestructuringBinding(parameter, visitor, context, 0 /* All */ , expressionName))), parameter), 2097152 /* CustomPrologue */ ));
            insertStatementsAfterCustomPrologue(statements, prologueStatements);
            return true;
        }
        function insertCaptureThisForNodeIfNeeded(statements, node) {
            if (hierarchyFacts & 131072 /* CapturedLexicalThis */  && node.kind !== 220 /* ArrowFunction */ ) {
                insertCaptureThisForNode(statements, node, factory2.createThis());
                return true;
            }
            return false;
        }
        function insertCaptureThisForNode(statements, node, initializer) {
            enableSubstitutionsForCapturedThis();
            const captureThisStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(createCapturedThis(), /*exclamationToken*/ void 0, /*type*/ void 0, initializer)
            ]));
            setEmitFlags(captureThisStatement, 2100224 /* CustomPrologue */ );
            setSourceMapRange(captureThisStatement, node);
            insertStatementAfterCustomPrologue(statements, captureThisStatement);
        }
        function insertCaptureNewTargetIfNeeded(statements, node) {
            if (hierarchyFacts & 32768 /* NewTarget */ ) {
                let newTarget;
                switch(node.kind){
                    case 220 /* ArrowFunction */ :
                        return statements;
                    case 175 /* MethodDeclaration */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        newTarget = factory2.createVoidZero();
                        break;
                    case 177 /* Constructor */ :
                        newTarget = factory2.createPropertyAccessExpression(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), "constructor");
                        break;
                    case 263 /* FunctionDeclaration */ :
                    case 219 /* FunctionExpression */ :
                        newTarget = factory2.createConditionalExpression(factory2.createLogicalAnd(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), factory2.createBinaryExpression(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), 104 /* InstanceOfKeyword */ , factory2.getLocalName(node))), /*questionToken*/ void 0, factory2.createPropertyAccessExpression(setEmitFlags(factory2.createThis(), 8 /* NoSubstitution */ ), "constructor"), /*colonToken*/ void 0, factory2.createVoidZero());
                        break;
                    default:
                        return Debug.failBadSyntaxKind(node);
                }
                const captureNewTargetStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(factory2.createUniqueName("_newTarget", 48 /* FileLevel */ ), /*exclamationToken*/ void 0, /*type*/ void 0, newTarget)
                ]));
                setEmitFlags(captureNewTargetStatement, 2100224 /* CustomPrologue */ );
                insertStatementAfterCustomPrologue(statements, captureNewTargetStatement);
            }
            return statements;
        }
        function addClassMembers(statements, node) {
            for (const member of node.members)switch(member.kind){
                case 241 /* SemicolonClassElement */ :
                    statements.push(transformSemicolonClassElementToStatement(member));
                    break;
                case 175 /* MethodDeclaration */ :
                    statements.push(transformClassMethodDeclarationToStatement(getClassMemberPrefix(node, member), member, node));
                    break;
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    const accessors = getAllAccessorDeclarations(node.members, member);
                    if (member === accessors.firstAccessor) statements.push(transformAccessorsToStatement(getClassMemberPrefix(node, member), accessors, node));
                    break;
                case 177 /* Constructor */ :
                case 176 /* ClassStaticBlockDeclaration */ :
                    break;
                default:
                    Debug.failBadSyntaxKind(member, currentSourceFile && currentSourceFile.fileName);
                    break;
            }
        }
        function transformSemicolonClassElementToStatement(member) {
            return setTextRange(factory2.createEmptyStatement(), member);
        }
        function transformClassMethodDeclarationToStatement(receiver, member, container) {
            const commentRange = getCommentRange(member);
            const sourceMapRange = getSourceMapRange(member);
            const memberFunction = transformFunctionLikeToExpression(member, /*location*/ member, /*name*/ void 0, container);
            const propertyName = visitNode(member.name, visitor, isPropertyName);
            Debug.assert(propertyName);
            let e;
            if (!isPrivateIdentifier(propertyName) && getUseDefineForClassFields(context.getCompilerOptions())) {
                const name = isComputedPropertyName(propertyName) ? propertyName.expression : isIdentifier(propertyName) ? factory2.createStringLiteral(unescapeLeadingUnderscores(propertyName.escapedText)) : propertyName;
                e = factory2.createObjectDefinePropertyCall(receiver, name, factory2.createPropertyDescriptor({
                    value: memberFunction,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }));
            } else {
                const memberName = createMemberAccessForPropertyName(factory2, receiver, propertyName, /*location*/ member.name);
                e = factory2.createAssignment(memberName, memberFunction);
            }
            setEmitFlags(memberFunction, 3072 /* NoComments */ );
            setSourceMapRange(memberFunction, sourceMapRange);
            const statement = setTextRange(factory2.createExpressionStatement(e), /*location*/ member);
            setOriginalNode(statement, member);
            setCommentRange(statement, commentRange);
            setEmitFlags(statement, 96 /* NoSourceMap */ );
            return statement;
        }
        function transformAccessorsToStatement(receiver, accessors, container) {
            const statement = factory2.createExpressionStatement(transformAccessorsToExpression(receiver, accessors, container, /*startsOnNewLine*/ false));
            setEmitFlags(statement, 3072 /* NoComments */ );
            setSourceMapRange(statement, getSourceMapRange(accessors.firstAccessor));
            return statement;
        }
        function transformAccessorsToExpression(receiver, { firstAccessor, getAccessor, setAccessor }, container, startsOnNewLine) {
            const target = setParent(setTextRange(factory2.cloneNode(receiver), receiver), receiver.parent);
            setEmitFlags(target, 3136 /* NoTrailingSourceMap */ );
            setSourceMapRange(target, firstAccessor.name);
            const visitedAccessorName = visitNode(firstAccessor.name, visitor, isPropertyName);
            Debug.assert(visitedAccessorName);
            if (isPrivateIdentifier(visitedAccessorName)) return Debug.failBadSyntaxKind(visitedAccessorName, "Encountered unhandled private identifier while transforming ES2015.");
            const propertyName = createExpressionForPropertyName(factory2, visitedAccessorName);
            setEmitFlags(propertyName, 3104 /* NoLeadingSourceMap */ );
            setSourceMapRange(propertyName, firstAccessor.name);
            const properties = [];
            if (getAccessor) {
                const getterFunction = transformFunctionLikeToExpression(getAccessor, /*location*/ void 0, /*name*/ void 0, container);
                setSourceMapRange(getterFunction, getSourceMapRange(getAccessor));
                setEmitFlags(getterFunction, 1024 /* NoLeadingComments */ );
                const getter = factory2.createPropertyAssignment("get", getterFunction);
                setCommentRange(getter, getCommentRange(getAccessor));
                properties.push(getter);
            }
            if (setAccessor) {
                const setterFunction = transformFunctionLikeToExpression(setAccessor, /*location*/ void 0, /*name*/ void 0, container);
                setSourceMapRange(setterFunction, getSourceMapRange(setAccessor));
                setEmitFlags(setterFunction, 1024 /* NoLeadingComments */ );
                const setter = factory2.createPropertyAssignment("set", setterFunction);
                setCommentRange(setter, getCommentRange(setAccessor));
                properties.push(setter);
            }
            properties.push(factory2.createPropertyAssignment("enumerable", getAccessor || setAccessor ? factory2.createFalse() : factory2.createTrue()), factory2.createPropertyAssignment("configurable", factory2.createTrue()));
            const call = factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "defineProperty"), /*typeArguments*/ void 0, [
                target,
                propertyName,
                factory2.createObjectLiteralExpression(properties, /*multiLine*/ true)
            ]);
            if (startsOnNewLine) startOnNewLine(call);
            return call;
        }
        function visitArrowFunction(node) {
            if (node.transformFlags & 16384 /* ContainsLexicalThis */  && !(hierarchyFacts & 16384 /* StaticInitializer */ )) hierarchyFacts |= 131072 /* CapturedLexicalThis */ ;
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(15232 /* ArrowFunctionExcludes */ , 66 /* ArrowFunctionIncludes */ );
            const func = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformFunctionBody2(node));
            setTextRange(func, node);
            setOriginalNode(func, node);
            setEmitFlags(func, 16 /* CapturesThis */ );
            exitSubtree(ancestorFacts, 0 /* ArrowFunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return func;
        }
        function visitFunctionExpression(node) {
            const ancestorFacts = getEmitFlags(node) & 524288 /* AsyncFunctionBody */  ? enterSubtree(32662 /* AsyncFunctionBodyExcludes */ , 69 /* AsyncFunctionBodyIncludes */ ) : enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            const name = hierarchyFacts & 32768 /* NewTarget */  ? factory2.getLocalName(node) : node.name;
            exitSubtree(ancestorFacts, 229376 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return factory2.updateFunctionExpression(node, /*modifiers*/ void 0, node.asteriskToken, name, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
        }
        function visitFunctionDeclaration(node) {
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            const name = hierarchyFacts & 32768 /* NewTarget */  ? factory2.getLocalName(node) : node.name;
            exitSubtree(ancestorFacts, 229376 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, visitor, isModifier), node.asteriskToken, name, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
        }
        function transformFunctionLikeToExpression(node, location, name, container) {
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = container && isClassLike(container) && !isStatic(node) ? enterSubtree(32670 /* FunctionExcludes */ , 73 /* NonStaticClassElement */ ) : enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            if (hierarchyFacts & 32768 /* NewTarget */  && !name && (node.kind === 263 /* FunctionDeclaration */  || node.kind === 219 /* FunctionExpression */ )) name = factory2.getGeneratedNameForNode(node);
            exitSubtree(ancestorFacts, 229376 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return setOriginalNode(setTextRange(factory2.createFunctionExpression(/*modifiers*/ void 0, node.asteriskToken, name, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body), location), /*original*/ node);
        }
        function transformFunctionBody2(node) {
            let multiLine = false;
            let singleLine = false;
            let statementsLocation;
            let closeBraceLocation;
            const prologue = [];
            const statements = [];
            const body = node.body;
            let statementOffset;
            resumeLexicalEnvironment();
            if (isBlock(body)) {
                statementOffset = factory2.copyStandardPrologue(body.statements, prologue, 0, /*ensureUseStrict*/ false);
                statementOffset = factory2.copyCustomPrologue(body.statements, statements, statementOffset, visitor, isHoistedFunction);
                statementOffset = factory2.copyCustomPrologue(body.statements, statements, statementOffset, visitor, isHoistedVariableStatement);
            }
            multiLine = addDefaultValueAssignmentsIfNeeded2(statements, node) || multiLine;
            multiLine = addRestParameterIfNeeded(statements, node, /*inConstructorWithSynthesizedSuper*/ false) || multiLine;
            if (isBlock(body)) {
                statementOffset = factory2.copyCustomPrologue(body.statements, statements, statementOffset, visitor);
                statementsLocation = body.statements;
                addRange(statements, visitNodes2(body.statements, visitor, isStatement, statementOffset));
                if (!multiLine && body.multiLine) multiLine = true;
            } else {
                Debug.assert(node.kind === 220 /* ArrowFunction */ );
                statementsLocation = moveRangeEnd(body, -1);
                const equalsGreaterThanToken = node.equalsGreaterThanToken;
                if (!nodeIsSynthesized(equalsGreaterThanToken) && !nodeIsSynthesized(body)) {
                    if (rangeEndIsOnSameLineAsRangeStart(equalsGreaterThanToken, body, currentSourceFile)) singleLine = true;
                    else multiLine = true;
                }
                const expression = visitNode(body, visitor, isExpression);
                const returnStatement = factory2.createReturnStatement(expression);
                setTextRange(returnStatement, body);
                moveSyntheticComments(returnStatement, body);
                setEmitFlags(returnStatement, 2880 /* NoTrailingComments */ );
                statements.push(returnStatement);
                closeBraceLocation = body;
            }
            factory2.mergeLexicalEnvironment(prologue, endLexicalEnvironment());
            insertCaptureNewTargetIfNeeded(prologue, node);
            insertCaptureThisForNodeIfNeeded(prologue, node);
            if (some(prologue)) multiLine = true;
            statements.unshift(...prologue);
            if (isBlock(body) && arrayIsEqualTo(statements, body.statements)) return body;
            const block = factory2.createBlock(setTextRange(factory2.createNodeArray(statements), statementsLocation), multiLine);
            setTextRange(block, node.body);
            if (!multiLine && singleLine) setEmitFlags(block, 1 /* SingleLine */ );
            if (closeBraceLocation) setTokenSourceMapRange(block, 20 /* CloseBraceToken */ , closeBraceLocation);
            setOriginalNode(block, node.body);
            return block;
        }
        function visitBlock(node, isFunctionBody2) {
            if (isFunctionBody2) return visitEachChild(node, visitor, context);
            const ancestorFacts = hierarchyFacts & 256 /* IterationStatement */  ? enterSubtree(7104 /* IterationStatementBlockExcludes */ , 512 /* IterationStatementBlockIncludes */ ) : enterSubtree(6976 /* BlockExcludes */ , 128 /* BlockIncludes */ );
            const updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function visitExpressionStatement(node) {
            return visitEachChild(node, visitorWithUnusedExpressionResult, context);
        }
        function visitParenthesizedExpression(node, expressionResultIsUnused2) {
            return visitEachChild(node, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, context);
        }
        function visitBinaryExpression(node, expressionResultIsUnused2) {
            if (isDestructuringAssignment(node)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , !expressionResultIsUnused2);
            if (node.operatorToken.kind === 28 /* CommaToken */ ) return factory2.updateBinaryExpression(node, Debug.checkDefined(visitNode(node.left, visitorWithUnusedExpressionResult, isExpression)), node.operatorToken, Debug.checkDefined(visitNode(node.right, expressionResultIsUnused2 ? visitorWithUnusedExpressionResult : visitor, isExpression)));
            return visitEachChild(node, visitor, context);
        }
        function visitCommaListExpression(node, expressionResultIsUnused2) {
            if (expressionResultIsUnused2) return visitEachChild(node, visitorWithUnusedExpressionResult, context);
            let result;
            for(let i = 0; i < node.elements.length; i++){
                const element = node.elements[i];
                const visited = visitNode(element, i < node.elements.length - 1 ? visitorWithUnusedExpressionResult : visitor, isExpression);
                if (result || visited !== element) {
                    result || (result = node.elements.slice(0, i));
                    Debug.assert(visited);
                    result.push(visited);
                }
            }
            const elements = result ? setTextRange(factory2.createNodeArray(result), node.elements) : node.elements;
            return factory2.updateCommaListExpression(node, elements);
        }
        function isVariableStatementOfTypeScriptClassWrapper(node) {
            return node.declarationList.declarations.length === 1 && !!node.declarationList.declarations[0].initializer && !!(getInternalEmitFlags(node.declarationList.declarations[0].initializer) & 1 /* TypeScriptClassWrapper */ );
        }
        function visitVariableStatement(node) {
            const ancestorFacts = enterSubtree(0 /* None */ , hasSyntacticModifier(node, 32 /* Export */ ) ? 32 /* ExportedVariableStatement */  : 0 /* None */ );
            let updated;
            if (convertedLoopState && (node.declarationList.flags & 7 /* BlockScoped */ ) === 0 && !isVariableStatementOfTypeScriptClassWrapper(node)) {
                let assignments;
                for (const decl of node.declarationList.declarations){
                    hoistVariableDeclarationDeclaredInConvertedLoop(convertedLoopState, decl);
                    if (decl.initializer) {
                        let assignment;
                        if (isBindingPattern(decl.name)) assignment = flattenDestructuringAssignment(decl, visitor, context, 0 /* All */ );
                        else {
                            assignment = factory2.createBinaryExpression(decl.name, 64 /* EqualsToken */ , Debug.checkDefined(visitNode(decl.initializer, visitor, isExpression)));
                            setTextRange(assignment, decl);
                        }
                        assignments = append(assignments, assignment);
                    }
                }
                if (assignments) updated = setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(assignments)), node);
                else updated = void 0;
            } else updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function visitVariableDeclarationList(node) {
            if (node.flags & 7 /* BlockScoped */  || node.transformFlags & 524288 /* ContainsBindingPattern */ ) {
                if (node.flags & 7 /* BlockScoped */ ) enableSubstitutionsForBlockScopedBindings();
                const declarations = visitNodes2(node.declarations, node.flags & 1 /* Let */  ? visitVariableDeclarationInLetDeclarationList : visitVariableDeclaration, isVariableDeclaration);
                const declarationList = factory2.createVariableDeclarationList(declarations);
                setOriginalNode(declarationList, node);
                setTextRange(declarationList, node);
                setCommentRange(declarationList, node);
                if (node.transformFlags & 524288 /* ContainsBindingPattern */  && (isBindingPattern(node.declarations[0].name) || isBindingPattern(last(node.declarations).name))) setSourceMapRange(declarationList, getRangeUnion(declarations));
                return declarationList;
            }
            return visitEachChild(node, visitor, context);
        }
        function getRangeUnion(declarations) {
            let pos = -1, end = -1;
            for (const node of declarations){
                pos = pos === -1 ? node.pos : node.pos === -1 ? pos : Math.min(pos, node.pos);
                end = Math.max(end, node.end);
            }
            return createRange(pos, end);
        }
        function shouldEmitExplicitInitializerForLetDeclaration(node) {
            const isCapturedInFunction = resolver.hasNodeCheckFlag(node, 16384 /* CapturedBlockScopedBinding */ );
            const isDeclaredInLoop = resolver.hasNodeCheckFlag(node, 32768 /* BlockScopedBindingInLoop */ );
            const emittedAsTopLevel = (hierarchyFacts & 64 /* TopLevel */ ) !== 0 || isCapturedInFunction && isDeclaredInLoop && (hierarchyFacts & 512 /* IterationStatementBlock */ ) !== 0;
            const emitExplicitInitializer = !emittedAsTopLevel && (hierarchyFacts & 4096 /* ForInOrForOfStatement */ ) === 0 && (!resolver.isDeclarationWithCollidingName(node) || isDeclaredInLoop && !isCapturedInFunction && (hierarchyFacts & 6144 /* ForInOrForOfStatement */ ) === 0);
            return emitExplicitInitializer;
        }
        function visitVariableDeclarationInLetDeclarationList(node) {
            const name = node.name;
            if (isBindingPattern(name)) return visitVariableDeclaration(node);
            if (!node.initializer && shouldEmitExplicitInitializerForLetDeclaration(node)) return factory2.updateVariableDeclaration(node, node.name, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createVoidZero());
            return visitEachChild(node, visitor, context);
        }
        function visitVariableDeclaration(node) {
            const ancestorFacts = enterSubtree(32 /* ExportedVariableStatement */ , 0 /* None */ );
            let updated;
            if (isBindingPattern(node.name)) updated = flattenDestructuringBinding(node, visitor, context, 0 /* All */ , /*rval*/ void 0, (ancestorFacts & 32 /* ExportedVariableStatement */ ) !== 0);
            else updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function recordLabel(node) {
            convertedLoopState.labels.set(idText(node.label), true);
        }
        function resetLabel(node) {
            convertedLoopState.labels.set(idText(node.label), false);
        }
        function visitLabeledStatement(node) {
            if (convertedLoopState && !convertedLoopState.labels) convertedLoopState.labels = /* @__PURE__ */ new Map();
            const statement = unwrapInnermostStatementOfLabel(node, convertedLoopState && recordLabel);
            var _visitNode;
            return isIterationStatement(statement, /*lookInLabeledStatements*/ false) ? visitIterationStatement(statement, /*outermostLabeledStatement*/ node) : factory2.restoreEnclosingLabel((_visitNode = visitNode(statement, visitor, isStatement, factory2.liftToBlock)) !== null && _visitNode !== void 0 ? _visitNode : setTextRange(factory2.createEmptyStatement(), statement), node, convertedLoopState && resetLabel);
        }
        function visitIterationStatement(node, outermostLabeledStatement) {
            switch(node.kind){
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                    return visitDoOrWhileStatement(node, outermostLabeledStatement);
                case 249 /* ForStatement */ :
                    return visitForStatement(node, outermostLabeledStatement);
                case 250 /* ForInStatement */ :
                    return visitForInStatement(node, outermostLabeledStatement);
                case 251 /* ForOfStatement */ :
                    return visitForOfStatement(node, outermostLabeledStatement);
            }
        }
        function visitIterationStatementWithFacts(excludeFacts, includeFacts, node, outermostLabeledStatement, convert) {
            const ancestorFacts = enterSubtree(excludeFacts, includeFacts);
            const updated = convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, ancestorFacts, convert);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function visitDoOrWhileStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(0 /* DoOrWhileStatementExcludes */ , 1280 /* DoOrWhileStatementIncludes */ , node, outermostLabeledStatement);
        }
        function visitForStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(5056 /* ForStatementExcludes */ , 3328 /* ForStatementIncludes */ , node, outermostLabeledStatement);
        }
        function visitEachChildOfForStatement2(node) {
            return factory2.updateForStatement(node, visitNode(node.initializer, visitorWithUnusedExpressionResult, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitorWithUnusedExpressionResult, isExpression), Debug.checkDefined(visitNode(node.statement, visitor, isStatement, factory2.liftToBlock)));
        }
        function visitForInStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(3008 /* ForInOrForOfStatementExcludes */ , 5376 /* ForInOrForOfStatementIncludes */ , node, outermostLabeledStatement);
        }
        function visitForOfStatement(node, outermostLabeledStatement) {
            return visitIterationStatementWithFacts(3008 /* ForInOrForOfStatementExcludes */ , 5376 /* ForInOrForOfStatementIncludes */ , node, outermostLabeledStatement, compilerOptions.downlevelIteration ? convertForOfStatementForIterable : convertForOfStatementForArray);
        }
        function convertForOfStatementHead(node, boundValue, convertedLoopBodyStatements) {
            const statements = [];
            const initializer = node.initializer;
            if (isVariableDeclarationList(initializer)) {
                if (node.initializer.flags & 7 /* BlockScoped */ ) enableSubstitutionsForBlockScopedBindings();
                const firstOriginalDeclaration = firstOrUndefined(initializer.declarations);
                if (firstOriginalDeclaration && isBindingPattern(firstOriginalDeclaration.name)) {
                    const declarations = flattenDestructuringBinding(firstOriginalDeclaration, visitor, context, 0 /* All */ , boundValue);
                    const declarationList = setTextRange(factory2.createVariableDeclarationList(declarations), node.initializer);
                    setOriginalNode(declarationList, node.initializer);
                    setSourceMapRange(declarationList, createRange(declarations[0].pos, last(declarations).end));
                    statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, declarationList));
                } else statements.push(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, setOriginalNode(setTextRange(factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(firstOriginalDeclaration ? firstOriginalDeclaration.name : factory2.createTempVariable(/*recordTempVariable*/ void 0), /*exclamationToken*/ void 0, /*type*/ void 0, boundValue)
                ]), moveRangePos(initializer, -1)), initializer)), moveRangeEnd(initializer, -1)));
            } else {
                const assignment = factory2.createAssignment(initializer, boundValue);
                if (isDestructuringAssignment(assignment)) statements.push(factory2.createExpressionStatement(visitBinaryExpression(assignment, /*expressionResultIsUnused*/ true)));
                else {
                    setTextRangeEnd(assignment, initializer.end);
                    statements.push(setTextRange(factory2.createExpressionStatement(Debug.checkDefined(visitNode(assignment, visitor, isExpression))), moveRangeEnd(initializer, -1)));
                }
            }
            if (convertedLoopBodyStatements) return createSyntheticBlockForConvertedStatements(addRange(statements, convertedLoopBodyStatements));
            else {
                const statement = visitNode(node.statement, visitor, isStatement, factory2.liftToBlock);
                Debug.assert(statement);
                if (isBlock(statement)) return factory2.updateBlock(statement, setTextRange(factory2.createNodeArray(concatenate(statements, statement.statements)), statement.statements));
                else {
                    statements.push(statement);
                    return createSyntheticBlockForConvertedStatements(statements);
                }
            }
        }
        function createSyntheticBlockForConvertedStatements(statements) {
            return setEmitFlags(factory2.createBlock(factory2.createNodeArray(statements), /*multiLine*/ true), 864 /* NoTokenSourceMaps */ );
        }
        function convertForOfStatementForArray(node, outermostLabeledStatement, convertedLoopBodyStatements) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            const counter = factory2.createLoopVariable();
            const rhsReference = isIdentifier(expression) ? factory2.getGeneratedNameForNode(expression) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            setEmitFlags(expression, 96 /* NoSourceMap */  | getEmitFlags(expression));
            const forStatement = setTextRange(factory2.createForStatement(/*initializer*/ setEmitFlags(setTextRange(factory2.createVariableDeclarationList([
                setTextRange(factory2.createVariableDeclaration(counter, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createNumericLiteral(0)), moveRangePos(node.expression, -1)),
                setTextRange(factory2.createVariableDeclaration(rhsReference, /*exclamationToken*/ void 0, /*type*/ void 0, expression), node.expression)
            ]), node.expression), 4194304 /* NoHoisting */ ), /*condition*/ setTextRange(factory2.createLessThan(counter, factory2.createPropertyAccessExpression(rhsReference, "length")), node.expression), /*incrementor*/ setTextRange(factory2.createPostfixIncrement(counter), node.expression), /*statement*/ convertForOfStatementHead(node, factory2.createElementAccessExpression(rhsReference, counter), convertedLoopBodyStatements)), /*location*/ node);
            setEmitFlags(forStatement, 512 /* NoTokenTrailingSourceMaps */ );
            setTextRange(forStatement, node);
            return factory2.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel);
        }
        function convertForOfStatementForIterable(node, outermostLabeledStatement, convertedLoopBodyStatements, ancestorFacts) {
            const expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            const iterator = isIdentifier(expression) ? factory2.getGeneratedNameForNode(expression) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const result = isIdentifier(expression) ? factory2.getGeneratedNameForNode(iterator) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const errorRecord = factory2.createUniqueName("e");
            const catchVariable = factory2.getGeneratedNameForNode(errorRecord);
            const returnMethod = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            const values = setTextRange(emitHelpers().createValuesHelper(expression), node.expression);
            const next = factory2.createCallExpression(factory2.createPropertyAccessExpression(iterator, "next"), /*typeArguments*/ void 0, []);
            hoistVariableDeclaration(errorRecord);
            hoistVariableDeclaration(returnMethod);
            const initializer = ancestorFacts & 1024 /* IterationContainer */  ? factory2.inlineExpressions([
                factory2.createAssignment(errorRecord, factory2.createVoidZero()),
                values
            ]) : values;
            const forStatement = setEmitFlags(setTextRange(factory2.createForStatement(/*initializer*/ setEmitFlags(setTextRange(factory2.createVariableDeclarationList([
                setTextRange(factory2.createVariableDeclaration(iterator, /*exclamationToken*/ void 0, /*type*/ void 0, initializer), node.expression),
                factory2.createVariableDeclaration(result, /*exclamationToken*/ void 0, /*type*/ void 0, next)
            ]), node.expression), 4194304 /* NoHoisting */ ), /*condition*/ factory2.createLogicalNot(factory2.createPropertyAccessExpression(result, "done")), /*incrementor*/ factory2.createAssignment(result, next), /*statement*/ convertForOfStatementHead(node, factory2.createPropertyAccessExpression(result, "value"), convertedLoopBodyStatements)), /*location*/ node), 512 /* NoTokenTrailingSourceMaps */ );
            return factory2.createTryStatement(factory2.createBlock([
                factory2.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel)
            ]), factory2.createCatchClause(factory2.createVariableDeclaration(catchVariable), setEmitFlags(factory2.createBlock([
                factory2.createExpressionStatement(factory2.createAssignment(errorRecord, factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("error", catchVariable)
                ])))
            ]), 1 /* SingleLine */ )), factory2.createBlock([
                factory2.createTryStatement(/*tryBlock*/ factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(factory2.createLogicalAnd(factory2.createLogicalAnd(result, factory2.createLogicalNot(factory2.createPropertyAccessExpression(result, "done"))), factory2.createAssignment(returnMethod, factory2.createPropertyAccessExpression(iterator, "return"))), factory2.createExpressionStatement(factory2.createFunctionCallCall(returnMethod, iterator, []))), 1 /* SingleLine */ )
                ]), /*catchClause*/ void 0, /*finallyBlock*/ setEmitFlags(factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(errorRecord, factory2.createThrowStatement(factory2.createPropertyAccessExpression(errorRecord, "error"))), 1 /* SingleLine */ )
                ]), 1 /* SingleLine */ ))
            ]));
        }
        function visitObjectLiteralExpression(node) {
            const properties = node.properties;
            let numInitialProperties = -1, hasComputed = false;
            for(let i = 0; i < properties.length; i++){
                const property = properties[i];
                if (property.transformFlags & 1048576 /* ContainsYield */  && hierarchyFacts & 4 /* AsyncFunctionBody */  || (hasComputed = Debug.checkDefined(property.name).kind === 168 /* ComputedPropertyName */ )) {
                    numInitialProperties = i;
                    break;
                }
            }
            if (numInitialProperties < 0) return visitEachChild(node, visitor, context);
            const temp = factory2.createTempVariable(hoistVariableDeclaration);
            const expressions = [];
            const assignment = factory2.createAssignment(temp, setEmitFlags(factory2.createObjectLiteralExpression(visitNodes2(properties, visitor, isObjectLiteralElementLike, 0, numInitialProperties), node.multiLine), hasComputed ? 131072 /* Indented */  : 0));
            if (node.multiLine) startOnNewLine(assignment);
            expressions.push(assignment);
            addObjectLiteralMembers(expressions, node, temp, numInitialProperties);
            expressions.push(node.multiLine ? startOnNewLine(setParent(setTextRange(factory2.cloneNode(temp), temp), temp.parent)) : temp);
            return factory2.inlineExpressions(expressions);
        }
        function shouldConvertPartOfIterationStatement(node) {
            return resolver.hasNodeCheckFlag(node, 8192 /* ContainsCapturedBlockScopeBinding */ );
        }
        function shouldConvertInitializerOfForStatement(node) {
            return isForStatement(node) && !!node.initializer && shouldConvertPartOfIterationStatement(node.initializer);
        }
        function shouldConvertConditionOfForStatement(node) {
            return isForStatement(node) && !!node.condition && shouldConvertPartOfIterationStatement(node.condition);
        }
        function shouldConvertIncrementorOfForStatement(node) {
            return isForStatement(node) && !!node.incrementor && shouldConvertPartOfIterationStatement(node.incrementor);
        }
        function shouldConvertIterationStatement(node) {
            return shouldConvertBodyOfIterationStatement(node) || shouldConvertInitializerOfForStatement(node);
        }
        function shouldConvertBodyOfIterationStatement(node) {
            return resolver.hasNodeCheckFlag(node, 4096 /* LoopWithCapturedBlockScopedBinding */ );
        }
        function hoistVariableDeclarationDeclaredInConvertedLoop(state, node) {
            if (!state.hoistedLocalVariables) state.hoistedLocalVariables = [];
            visit(node.name);
            function visit(node2) {
                if (node2.kind === 80 /* Identifier */ ) state.hoistedLocalVariables.push(node2);
                else {
                    for (const element of node2.elements)if (!isOmittedExpression(element)) visit(element.name);
                }
            }
        }
        function convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, ancestorFacts, convert) {
            if (!shouldConvertIterationStatement(node)) {
                let saveAllowedNonLabeledJumps;
                if (convertedLoopState) {
                    saveAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
                    convertedLoopState.allowedNonLabeledJumps = 6 /* Continue */ ;
                }
                const result = convert ? convert(node, outermostLabeledStatement, /*convertedLoopBodyStatements*/ void 0, ancestorFacts) : factory2.restoreEnclosingLabel(isForStatement(node) ? visitEachChildOfForStatement2(node) : visitEachChild(node, visitor, context), outermostLabeledStatement, convertedLoopState && resetLabel);
                if (convertedLoopState) convertedLoopState.allowedNonLabeledJumps = saveAllowedNonLabeledJumps;
                return result;
            }
            const currentState = createConvertedLoopState(node);
            const statements = [];
            const outerConvertedLoopState = convertedLoopState;
            convertedLoopState = currentState;
            const initializerFunction = shouldConvertInitializerOfForStatement(node) ? createFunctionForInitializerOfForStatement(node, currentState) : void 0;
            const bodyFunction = shouldConvertBodyOfIterationStatement(node) ? createFunctionForBodyOfIterationStatement(node, currentState, outerConvertedLoopState) : void 0;
            convertedLoopState = outerConvertedLoopState;
            if (initializerFunction) statements.push(initializerFunction.functionDeclaration);
            if (bodyFunction) statements.push(bodyFunction.functionDeclaration);
            addExtraDeclarationsForConvertedLoop(statements, currentState, outerConvertedLoopState);
            if (initializerFunction) statements.push(generateCallToConvertedLoopInitializer(initializerFunction.functionName, initializerFunction.containsYield));
            let loop;
            if (bodyFunction) {
                if (convert) loop = convert(node, outermostLabeledStatement, bodyFunction.part, ancestorFacts);
                else {
                    const clone2 = convertIterationStatementCore(node, initializerFunction, factory2.createBlock(bodyFunction.part, /*multiLine*/ true));
                    loop = factory2.restoreEnclosingLabel(clone2, outermostLabeledStatement, convertedLoopState && resetLabel);
                }
            } else {
                const clone2 = convertIterationStatementCore(node, initializerFunction, Debug.checkDefined(visitNode(node.statement, visitor, isStatement, factory2.liftToBlock)));
                loop = factory2.restoreEnclosingLabel(clone2, outermostLabeledStatement, convertedLoopState && resetLabel);
            }
            statements.push(loop);
            return statements;
        }
        function convertIterationStatementCore(node, initializerFunction, convertedLoopBody) {
            switch(node.kind){
                case 249 /* ForStatement */ :
                    return convertForStatement(node, initializerFunction, convertedLoopBody);
                case 250 /* ForInStatement */ :
                    return convertForInStatement(node, convertedLoopBody);
                case 251 /* ForOfStatement */ :
                    return convertForOfStatement(node, convertedLoopBody);
                case 247 /* DoStatement */ :
                    return convertDoStatement(node, convertedLoopBody);
                case 248 /* WhileStatement */ :
                    return convertWhileStatement(node, convertedLoopBody);
                default:
                    return Debug.failBadSyntaxKind(node, "IterationStatement expected");
            }
        }
        function convertForStatement(node, initializerFunction, convertedLoopBody) {
            const shouldConvertCondition = node.condition && shouldConvertPartOfIterationStatement(node.condition);
            const shouldConvertIncrementor = shouldConvertCondition || node.incrementor && shouldConvertPartOfIterationStatement(node.incrementor);
            return factory2.updateForStatement(node, visitNode(initializerFunction ? initializerFunction.part : node.initializer, visitorWithUnusedExpressionResult, isForInitializer), visitNode(shouldConvertCondition ? void 0 : node.condition, visitor, isExpression), visitNode(shouldConvertIncrementor ? void 0 : node.incrementor, visitorWithUnusedExpressionResult, isExpression), convertedLoopBody);
        }
        function convertForOfStatement(node, convertedLoopBody) {
            return factory2.updateForOfStatement(node, /*awaitModifier*/ void 0, Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), convertedLoopBody);
        }
        function convertForInStatement(node, convertedLoopBody) {
            return factory2.updateForInStatement(node, Debug.checkDefined(visitNode(node.initializer, visitor, isForInitializer)), Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), convertedLoopBody);
        }
        function convertDoStatement(node, convertedLoopBody) {
            return factory2.updateDoStatement(node, convertedLoopBody, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
        }
        function convertWhileStatement(node, convertedLoopBody) {
            return factory2.updateWhileStatement(node, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), convertedLoopBody);
        }
        function createConvertedLoopState(node) {
            let loopInitializer;
            switch(node.kind){
                case 249 /* ForStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                    const initializer = node.initializer;
                    if (initializer && initializer.kind === 262 /* VariableDeclarationList */ ) loopInitializer = initializer;
                    break;
            }
            const loopParameters = [];
            const loopOutParameters = [];
            if (loopInitializer && getCombinedNodeFlags(loopInitializer) & 7 /* BlockScoped */ ) {
                const hasCapturedBindingsInForHead = shouldConvertInitializerOfForStatement(node) || shouldConvertConditionOfForStatement(node) || shouldConvertIncrementorOfForStatement(node);
                for (const decl of loopInitializer.declarations)processLoopVariableDeclaration(node, decl, loopParameters, loopOutParameters, hasCapturedBindingsInForHead);
            }
            const currentState = {
                loopParameters,
                loopOutParameters
            };
            if (convertedLoopState) {
                if (convertedLoopState.argumentsName) currentState.argumentsName = convertedLoopState.argumentsName;
                if (convertedLoopState.thisName) currentState.thisName = convertedLoopState.thisName;
                if (convertedLoopState.hoistedLocalVariables) currentState.hoistedLocalVariables = convertedLoopState.hoistedLocalVariables;
            }
            return currentState;
        }
        function addExtraDeclarationsForConvertedLoop(statements, state, outerState) {
            let extraVariableDeclarations;
            if (state.argumentsName) {
                if (outerState) outerState.argumentsName = state.argumentsName;
                else (extraVariableDeclarations || (extraVariableDeclarations = [])).push(factory2.createVariableDeclaration(state.argumentsName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createIdentifier("arguments")));
            }
            if (state.thisName) {
                if (outerState) outerState.thisName = state.thisName;
                else (extraVariableDeclarations || (extraVariableDeclarations = [])).push(factory2.createVariableDeclaration(state.thisName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createIdentifier("this")));
            }
            if (state.hoistedLocalVariables) {
                if (outerState) outerState.hoistedLocalVariables = state.hoistedLocalVariables;
                else {
                    if (!extraVariableDeclarations) extraVariableDeclarations = [];
                    for (const identifier of state.hoistedLocalVariables)extraVariableDeclarations.push(factory2.createVariableDeclaration(identifier));
                }
            }
            if (state.loopOutParameters.length) {
                if (!extraVariableDeclarations) extraVariableDeclarations = [];
                for (const outParam of state.loopOutParameters)extraVariableDeclarations.push(factory2.createVariableDeclaration(outParam.outParamName));
            }
            if (state.conditionVariable) {
                if (!extraVariableDeclarations) extraVariableDeclarations = [];
                extraVariableDeclarations.push(factory2.createVariableDeclaration(state.conditionVariable, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createFalse()));
            }
            if (extraVariableDeclarations) statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(extraVariableDeclarations)));
        }
        function createOutVariable(p) {
            return factory2.createVariableDeclaration(p.originalName, /*exclamationToken*/ void 0, /*type*/ void 0, p.outParamName);
        }
        function createFunctionForInitializerOfForStatement(node, currentState) {
            const functionName = factory2.createUniqueName("_loop_init");
            const containsYield = (node.initializer.transformFlags & 1048576 /* ContainsYield */ ) !== 0;
            let emitFlags = 0 /* None */ ;
            if (currentState.containsLexicalThis) emitFlags |= 16 /* CapturesThis */ ;
            if (containsYield && hierarchyFacts & 4 /* AsyncFunctionBody */ ) emitFlags |= 524288 /* AsyncFunctionBody */ ;
            const statements = [];
            statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, node.initializer));
            copyOutParameters(currentState.loopOutParameters, 2 /* Initializer */ , 1 /* ToOutParameter */ , statements);
            const functionDeclaration = factory2.createVariableStatement(/*modifiers*/ void 0, setEmitFlags(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(functionName, /*exclamationToken*/ void 0, /*type*/ void 0, setEmitFlags(factory2.createFunctionExpression(/*modifiers*/ void 0, containsYield ? factory2.createToken(42 /* AsteriskToken */ ) : void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ void 0, /*type*/ void 0, Debug.checkDefined(visitNode(factory2.createBlock(statements, /*multiLine*/ true), visitor, isBlock))), emitFlags))
            ]), 4194304 /* NoHoisting */ ));
            const part = factory2.createVariableDeclarationList(map(currentState.loopOutParameters, createOutVariable));
            return {
                functionName,
                containsYield,
                functionDeclaration,
                part
            };
        }
        function createFunctionForBodyOfIterationStatement(node, currentState, outerState) {
            const functionName = factory2.createUniqueName("_loop");
            startLexicalEnvironment();
            const statement = visitNode(node.statement, visitor, isStatement, factory2.liftToBlock);
            const lexicalEnvironment = endLexicalEnvironment();
            const statements = [];
            if (shouldConvertConditionOfForStatement(node) || shouldConvertIncrementorOfForStatement(node)) {
                currentState.conditionVariable = factory2.createUniqueName("inc");
                if (node.incrementor) statements.push(factory2.createIfStatement(currentState.conditionVariable, factory2.createExpressionStatement(Debug.checkDefined(visitNode(node.incrementor, visitor, isExpression))), factory2.createExpressionStatement(factory2.createAssignment(currentState.conditionVariable, factory2.createTrue()))));
                else statements.push(factory2.createIfStatement(factory2.createLogicalNot(currentState.conditionVariable), factory2.createExpressionStatement(factory2.createAssignment(currentState.conditionVariable, factory2.createTrue()))));
                if (shouldConvertConditionOfForStatement(node)) statements.push(factory2.createIfStatement(factory2.createPrefixUnaryExpression(54 /* ExclamationToken */ , Debug.checkDefined(visitNode(node.condition, visitor, isExpression))), Debug.checkDefined(visitNode(factory2.createBreakStatement(), visitor, isStatement))));
            }
            Debug.assert(statement);
            if (isBlock(statement)) addRange(statements, statement.statements);
            else statements.push(statement);
            copyOutParameters(currentState.loopOutParameters, 1 /* Body */ , 1 /* ToOutParameter */ , statements);
            insertStatementsAfterStandardPrologue(statements, lexicalEnvironment);
            const loopBody = factory2.createBlock(statements, /*multiLine*/ true);
            if (isBlock(statement)) setOriginalNode(loopBody, statement);
            const containsYield = (node.statement.transformFlags & 1048576 /* ContainsYield */ ) !== 0;
            let emitFlags = 1048576 /* ReuseTempVariableScope */ ;
            if (currentState.containsLexicalThis) emitFlags |= 16 /* CapturesThis */ ;
            if (containsYield && (hierarchyFacts & 4 /* AsyncFunctionBody */ ) !== 0) emitFlags |= 524288 /* AsyncFunctionBody */ ;
            const functionDeclaration = factory2.createVariableStatement(/*modifiers*/ void 0, setEmitFlags(factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(functionName, /*exclamationToken*/ void 0, /*type*/ void 0, setEmitFlags(factory2.createFunctionExpression(/*modifiers*/ void 0, containsYield ? factory2.createToken(42 /* AsteriskToken */ ) : void 0, /*name*/ void 0, /*typeParameters*/ void 0, currentState.loopParameters, /*type*/ void 0, loopBody), emitFlags))
            ]), 4194304 /* NoHoisting */ ));
            const part = generateCallToConvertedLoop(functionName, currentState, outerState, containsYield);
            return {
                functionName,
                containsYield,
                functionDeclaration,
                part
            };
        }
        function copyOutParameter(outParam, copyDirection) {
            const source = copyDirection === 0 /* ToOriginal */  ? outParam.outParamName : outParam.originalName;
            const target = copyDirection === 0 /* ToOriginal */  ? outParam.originalName : outParam.outParamName;
            return factory2.createBinaryExpression(target, 64 /* EqualsToken */ , source);
        }
        function copyOutParameters(outParams, partFlags, copyDirection, statements) {
            for (const outParam of outParams)if (outParam.flags & partFlags) statements.push(factory2.createExpressionStatement(copyOutParameter(outParam, copyDirection)));
        }
        function generateCallToConvertedLoopInitializer(initFunctionExpressionName, containsYield) {
            const call = factory2.createCallExpression(initFunctionExpressionName, /*typeArguments*/ void 0, []);
            const callResult = containsYield ? factory2.createYieldExpression(factory2.createToken(42 /* AsteriskToken */ ), setEmitFlags(call, 8388608 /* Iterator */ )) : call;
            return factory2.createExpressionStatement(callResult);
        }
        function generateCallToConvertedLoop(loopFunctionExpressionName, state, outerState, containsYield) {
            const statements = [];
            const isSimpleLoop = !(state.nonLocalJumps & -5 /* Continue */ ) && !state.labeledNonLocalBreaks && !state.labeledNonLocalContinues;
            const call = factory2.createCallExpression(loopFunctionExpressionName, /*typeArguments*/ void 0, map(state.loopParameters, (p)=>p.name));
            const callResult = containsYield ? factory2.createYieldExpression(factory2.createToken(42 /* AsteriskToken */ ), setEmitFlags(call, 8388608 /* Iterator */ )) : call;
            if (isSimpleLoop) {
                statements.push(factory2.createExpressionStatement(callResult));
                copyOutParameters(state.loopOutParameters, 1 /* Body */ , 0 /* ToOriginal */ , statements);
            } else {
                const loopResultName = factory2.createUniqueName("state");
                const stateVariable = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(loopResultName, /*exclamationToken*/ void 0, /*type*/ void 0, callResult)
                ]));
                statements.push(stateVariable);
                copyOutParameters(state.loopOutParameters, 1 /* Body */ , 0 /* ToOriginal */ , statements);
                if (state.nonLocalJumps & 8 /* Return */ ) {
                    let returnStatement;
                    if (outerState) {
                        outerState.nonLocalJumps |= 8 /* Return */ ;
                        returnStatement = factory2.createReturnStatement(loopResultName);
                    } else returnStatement = factory2.createReturnStatement(factory2.createPropertyAccessExpression(loopResultName, "value"));
                    statements.push(factory2.createIfStatement(factory2.createTypeCheck(loopResultName, "object"), returnStatement));
                }
                if (state.nonLocalJumps & 2 /* Break */ ) statements.push(factory2.createIfStatement(factory2.createStrictEquality(loopResultName, factory2.createStringLiteral("break")), factory2.createBreakStatement()));
                if (state.labeledNonLocalBreaks || state.labeledNonLocalContinues) {
                    const caseClauses = [];
                    processLabeledJumps(state.labeledNonLocalBreaks, /*isBreak*/ true, loopResultName, outerState, caseClauses);
                    processLabeledJumps(state.labeledNonLocalContinues, /*isBreak*/ false, loopResultName, outerState, caseClauses);
                    statements.push(factory2.createSwitchStatement(loopResultName, factory2.createCaseBlock(caseClauses)));
                }
            }
            return statements;
        }
        function setLabeledJump(state, isBreak, labelText, labelMarker) {
            if (isBreak) {
                if (!state.labeledNonLocalBreaks) state.labeledNonLocalBreaks = /* @__PURE__ */ new Map();
                state.labeledNonLocalBreaks.set(labelText, labelMarker);
            } else {
                if (!state.labeledNonLocalContinues) state.labeledNonLocalContinues = /* @__PURE__ */ new Map();
                state.labeledNonLocalContinues.set(labelText, labelMarker);
            }
        }
        function processLabeledJumps(table, isBreak, loopResultName, outerLoop, caseClauses) {
            if (!table) return;
            table.forEach((labelMarker, labelText)=>{
                const statements = [];
                if (!outerLoop || outerLoop.labels && outerLoop.labels.get(labelText)) {
                    const label = factory2.createIdentifier(labelText);
                    statements.push(isBreak ? factory2.createBreakStatement(label) : factory2.createContinueStatement(label));
                } else {
                    setLabeledJump(outerLoop, isBreak, labelText, labelMarker);
                    statements.push(factory2.createReturnStatement(loopResultName));
                }
                caseClauses.push(factory2.createCaseClause(factory2.createStringLiteral(labelMarker), statements));
            });
        }
        function processLoopVariableDeclaration(container, decl, loopParameters, loopOutParameters, hasCapturedBindingsInForHead) {
            const name = decl.name;
            if (isBindingPattern(name)) {
                for (const element of name.elements)if (!isOmittedExpression(element)) processLoopVariableDeclaration(container, element, loopParameters, loopOutParameters, hasCapturedBindingsInForHead);
            } else {
                loopParameters.push(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name));
                const needsOutParam = resolver.hasNodeCheckFlag(decl, 65536 /* NeedsLoopOutParameter */ );
                if (needsOutParam || hasCapturedBindingsInForHead) {
                    const outParamName = factory2.createUniqueName("out_" + idText(name));
                    let flags = 0 /* None */ ;
                    if (needsOutParam) flags |= 1 /* Body */ ;
                    if (isForStatement(container)) {
                        if (container.initializer && resolver.isBindingCapturedByNode(container.initializer, decl)) flags |= 2 /* Initializer */ ;
                        if (container.condition && resolver.isBindingCapturedByNode(container.condition, decl) || container.incrementor && resolver.isBindingCapturedByNode(container.incrementor, decl)) flags |= 1 /* Body */ ;
                    }
                    loopOutParameters.push({
                        flags,
                        originalName: name,
                        outParamName
                    });
                }
            }
        }
        function addObjectLiteralMembers(expressions, node, receiver, start) {
            const properties = node.properties;
            const numProperties = properties.length;
            for(let i = start; i < numProperties; i++){
                const property = properties[i];
                switch(property.kind){
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        const accessors = getAllAccessorDeclarations(node.properties, property);
                        if (property === accessors.firstAccessor) expressions.push(transformAccessorsToExpression(receiver, accessors, node, !!node.multiLine));
                        break;
                    case 175 /* MethodDeclaration */ :
                        expressions.push(transformObjectLiteralMethodDeclarationToExpression(property, receiver, node, node.multiLine));
                        break;
                    case 304 /* PropertyAssignment */ :
                        expressions.push(transformPropertyAssignmentToExpression(property, receiver, node.multiLine));
                        break;
                    case 305 /* ShorthandPropertyAssignment */ :
                        expressions.push(transformShorthandPropertyAssignmentToExpression(property, receiver, node.multiLine));
                        break;
                    default:
                        Debug.failBadSyntaxKind(node);
                        break;
                }
            }
        }
        function transformPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
            const expression = factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, Debug.checkDefined(visitNode(property.name, visitor, isPropertyName))), Debug.checkDefined(visitNode(property.initializer, visitor, isExpression)));
            setTextRange(expression, property);
            if (startsOnNewLine) startOnNewLine(expression);
            return expression;
        }
        function transformShorthandPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
            const expression = factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, Debug.checkDefined(visitNode(property.name, visitor, isPropertyName))), factory2.cloneNode(property.name));
            setTextRange(expression, property);
            if (startsOnNewLine) startOnNewLine(expression);
            return expression;
        }
        function transformObjectLiteralMethodDeclarationToExpression(method, receiver, container, startsOnNewLine) {
            const expression = factory2.createAssignment(createMemberAccessForPropertyName(factory2, receiver, Debug.checkDefined(visitNode(method.name, visitor, isPropertyName))), transformFunctionLikeToExpression(method, /*location*/ method, /*name*/ void 0, container));
            setTextRange(expression, method);
            if (startsOnNewLine) startOnNewLine(expression);
            return expression;
        }
        function visitCatchClause(node) {
            const ancestorFacts = enterSubtree(7104 /* BlockScopeExcludes */ , 0 /* BlockScopeIncludes */ );
            let updated;
            Debug.assert(!!node.variableDeclaration, "Catch clause variable should always be present when downleveling ES2015.");
            if (isBindingPattern(node.variableDeclaration.name)) {
                const temp = factory2.createTempVariable(/*recordTempVariable*/ void 0);
                const newVariableDeclaration = factory2.createVariableDeclaration(temp);
                setTextRange(newVariableDeclaration, node.variableDeclaration);
                const vars = flattenDestructuringBinding(node.variableDeclaration, visitor, context, 0 /* All */ , temp);
                const list = factory2.createVariableDeclarationList(vars);
                setTextRange(list, node.variableDeclaration);
                const destructure = factory2.createVariableStatement(/*modifiers*/ void 0, list);
                updated = factory2.updateCatchClause(node, newVariableDeclaration, addStatementToStartOfBlock(node.block, destructure));
            } else updated = visitEachChild(node, visitor, context);
            exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
            return updated;
        }
        function addStatementToStartOfBlock(block, statement) {
            const transformedStatements = visitNodes2(block.statements, visitor, isStatement);
            return factory2.updateBlock(block, [
                statement,
                ...transformedStatements
            ]);
        }
        function visitMethodDeclaration(node) {
            Debug.assert(!isComputedPropertyName(node.name));
            const functionExpression = transformFunctionLikeToExpression(node, /*location*/ moveRangePos(node, -1), /*name*/ void 0, /*container*/ void 0);
            setEmitFlags(functionExpression, 1024 /* NoLeadingComments */  | getEmitFlags(functionExpression));
            return setTextRange(factory2.createPropertyAssignment(node.name, functionExpression), /*location*/ node);
        }
        function visitAccessorDeclaration(node) {
            Debug.assert(!isComputedPropertyName(node.name));
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const ancestorFacts = enterSubtree(32670 /* FunctionExcludes */ , 65 /* FunctionIncludes */ );
            let updated;
            const parameters = visitParameterList(node.parameters, visitor, context);
            const body = transformFunctionBody2(node);
            if (node.kind === 178 /* GetAccessor */ ) updated = factory2.updateGetAccessorDeclaration(node, node.modifiers, node.name, parameters, node.type, body);
            else updated = factory2.updateSetAccessorDeclaration(node, node.modifiers, node.name, parameters, body);
            exitSubtree(ancestorFacts, 229376 /* FunctionSubtreeExcludes */ , 0 /* None */ );
            convertedLoopState = savedConvertedLoopState;
            return updated;
        }
        function visitShorthandPropertyAssignment(node) {
            return setTextRange(factory2.createPropertyAssignment(node.name, visitIdentifier(factory2.cloneNode(node.name))), /*location*/ node);
        }
        function visitComputedPropertyName(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitYieldExpression(node) {
            return visitEachChild(node, visitor, context);
        }
        function visitArrayLiteralExpression(node) {
            if (some(node.elements, isSpreadElement)) return transformAndSpreadElements(node.elements, /*isArgumentList*/ false, !!node.multiLine, /*hasTrailingComma*/ !!node.elements.hasTrailingComma);
            return visitEachChild(node, visitor, context);
        }
        function visitCallExpression(node) {
            if (getInternalEmitFlags(node) & 1 /* TypeScriptClassWrapper */ ) return visitTypeScriptClassWrapper(node);
            const expression = skipOuterExpressions(node.expression);
            if (expression.kind === 108 /* SuperKeyword */  || isSuperProperty(expression) || some(node.arguments, isSpreadElement)) return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ true);
            return factory2.updateCallExpression(node, Debug.checkDefined(visitNode(node.expression, callExpressionVisitor, isExpression)), /*typeArguments*/ void 0, visitNodes2(node.arguments, visitor, isExpression));
        }
        function visitTypeScriptClassWrapper(node) {
            const body = cast(cast(skipOuterExpressions(node.expression), isArrowFunction).body, isBlock);
            const isVariableStatementWithInitializer = (stmt)=>isVariableStatement(stmt) && !!first(stmt.declarationList.declarations).initializer;
            const savedConvertedLoopState = convertedLoopState;
            convertedLoopState = void 0;
            const bodyStatements = visitNodes2(body.statements, classWrapperStatementVisitor, isStatement);
            convertedLoopState = savedConvertedLoopState;
            const classStatements = filter(bodyStatements, isVariableStatementWithInitializer);
            const remainingStatements = filter(bodyStatements, (stmt)=>!isVariableStatementWithInitializer(stmt));
            const varStatement = cast(first(classStatements), isVariableStatement);
            const variable = varStatement.declarationList.declarations[0];
            const initializer = skipOuterExpressions(variable.initializer);
            let aliasAssignment = tryCast(initializer, isAssignmentExpression);
            if (!aliasAssignment && isBinaryExpression(initializer) && initializer.operatorToken.kind === 28 /* CommaToken */ ) aliasAssignment = tryCast(initializer.left, isAssignmentExpression);
            const call = cast(aliasAssignment ? skipOuterExpressions(aliasAssignment.right) : initializer, isCallExpression);
            const func = cast(skipOuterExpressions(call.expression), isFunctionExpression);
            const funcStatements = func.body.statements;
            let classBodyStart = 0;
            let classBodyEnd = -1;
            const statements = [];
            if (aliasAssignment) {
                const extendsCall = tryCast(funcStatements[classBodyStart], isExpressionStatement);
                if (extendsCall) {
                    statements.push(extendsCall);
                    classBodyStart++;
                }
                statements.push(funcStatements[classBodyStart]);
                classBodyStart++;
                statements.push(factory2.createExpressionStatement(factory2.createAssignment(aliasAssignment.left, cast(variable.name, isIdentifier))));
            }
            while(!isReturnStatement(elementAt(funcStatements, classBodyEnd)))classBodyEnd--;
            addRange(statements, funcStatements, classBodyStart, classBodyEnd);
            if (classBodyEnd < -1) addRange(statements, funcStatements, classBodyEnd + 1);
            const returnStatement = tryCast(elementAt(funcStatements, classBodyEnd), isReturnStatement);
            for (const statement of remainingStatements)if (isReturnStatement(statement) && (returnStatement == null ? void 0 : returnStatement.expression) && !isIdentifier(returnStatement.expression)) statements.push(returnStatement);
            else statements.push(statement);
            addRange(statements, classStatements, /*start*/ 1);
            return factory2.restoreOuterExpressions(node.expression, factory2.restoreOuterExpressions(variable.initializer, factory2.restoreOuterExpressions(aliasAssignment && aliasAssignment.right, factory2.updateCallExpression(call, factory2.restoreOuterExpressions(call.expression, factory2.updateFunctionExpression(func, /*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, func.parameters, /*type*/ void 0, factory2.updateBlock(func.body, statements))), /*typeArguments*/ void 0, call.arguments))));
        }
        function visitCallExpressionWithPotentialCapturedThisAssignment(node, assignToCapturedThis) {
            if (node.transformFlags & 32768 /* ContainsRestOrSpread */  || node.expression.kind === 108 /* SuperKeyword */  || isSuperProperty(skipOuterExpressions(node.expression))) {
                const { target, thisArg } = factory2.createCallBinding(node.expression, hoistVariableDeclaration);
                if (node.expression.kind === 108 /* SuperKeyword */ ) setEmitFlags(thisArg, 8 /* NoSubstitution */ );
                let resultingCall;
                if (node.transformFlags & 32768 /* ContainsRestOrSpread */ ) resultingCall = factory2.createFunctionApplyCall(Debug.checkDefined(visitNode(target, callExpressionVisitor, isExpression)), node.expression.kind === 108 /* SuperKeyword */  ? thisArg : Debug.checkDefined(visitNode(thisArg, visitor, isExpression)), transformAndSpreadElements(node.arguments, /*isArgumentList*/ true, /*multiLine*/ false, /*hasTrailingComma*/ false));
                else resultingCall = setTextRange(factory2.createFunctionCallCall(Debug.checkDefined(visitNode(target, callExpressionVisitor, isExpression)), node.expression.kind === 108 /* SuperKeyword */  ? thisArg : Debug.checkDefined(visitNode(thisArg, visitor, isExpression)), visitNodes2(node.arguments, visitor, isExpression)), node);
                if (node.expression.kind === 108 /* SuperKeyword */ ) {
                    const initializer = factory2.createLogicalOr(resultingCall, createActualThis());
                    resultingCall = assignToCapturedThis ? factory2.createAssignment(createCapturedThis(), initializer) : initializer;
                }
                return setOriginalNode(resultingCall, node);
            }
            if (isSuperCall(node)) hierarchyFacts |= 131072 /* CapturedLexicalThis */ ;
            return visitEachChild(node, visitor, context);
        }
        function visitNewExpression(node) {
            if (some(node.arguments, isSpreadElement)) {
                const { target, thisArg } = factory2.createCallBinding(factory2.createPropertyAccessExpression(node.expression, "bind"), hoistVariableDeclaration);
                return factory2.createNewExpression(factory2.createFunctionApplyCall(Debug.checkDefined(visitNode(target, visitor, isExpression)), thisArg, transformAndSpreadElements(factory2.createNodeArray([
                    factory2.createVoidZero(),
                    ...node.arguments
                ]), /*isArgumentList*/ true, /*multiLine*/ false, /*hasTrailingComma*/ false)), /*typeArguments*/ void 0, []);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndSpreadElements(elements, isArgumentList, multiLine, hasTrailingComma) {
            const numElements = elements.length;
            const segments = flatten(// As we visit each element, we return one of two functions to use as the "key":
            // - `visitSpanOfSpreads` for one or more contiguous `...` spread expressions, i.e. `...a, ...b` in `[1, 2, ...a, ...b]`
            // - `visitSpanOfNonSpreads` for one or more contiguous non-spread elements, i.e. `1, 2`, in `[1, 2, ...a, ...b]`
            spanMap(elements, partitionSpread, (partition, visitPartition, _start, end)=>visitPartition(partition, multiLine, hasTrailingComma && end === numElements)));
            if (segments.length === 1) {
                const firstSegment = segments[0];
                if (isArgumentList && !compilerOptions.downlevelIteration || isPackedArrayLiteral(firstSegment.expression) || isCallToHelper(firstSegment.expression, "___spreadArray")) return firstSegment.expression;
            }
            const helpers = emitHelpers();
            const startsWithSpread = segments[0].kind !== 0 /* None */ ;
            let expression = startsWithSpread ? factory2.createArrayLiteralExpression() : segments[0].expression;
            for(let i = startsWithSpread ? 0 : 1; i < segments.length; i++){
                const segment = segments[i];
                expression = helpers.createSpreadArrayHelper(expression, segment.expression, segment.kind === 1 /* UnpackedSpread */  && !isArgumentList);
            }
            return expression;
        }
        function partitionSpread(node) {
            return isSpreadElement(node) ? visitSpanOfSpreads : visitSpanOfNonSpreads;
        }
        function visitSpanOfSpreads(chunk) {
            return map(chunk, visitExpressionOfSpread);
        }
        function visitExpressionOfSpread(node) {
            Debug.assertNode(node, isSpreadElement);
            let expression = visitNode(node.expression, visitor, isExpression);
            Debug.assert(expression);
            const isCallToReadHelper = isCallToHelper(expression, "___read");
            let kind = isCallToReadHelper || isPackedArrayLiteral(expression) ? 2 /* PackedSpread */  : 1 /* UnpackedSpread */ ;
            if (compilerOptions.downlevelIteration && kind === 1 /* UnpackedSpread */  && !isArrayLiteralExpression(expression) && !isCallToReadHelper) {
                expression = emitHelpers().createReadHelper(expression, /*count*/ void 0);
                kind = 2 /* PackedSpread */ ;
            }
            return createSpreadSegment(kind, expression);
        }
        function visitSpanOfNonSpreads(chunk, multiLine, hasTrailingComma) {
            const expression = factory2.createArrayLiteralExpression(visitNodes2(factory2.createNodeArray(chunk, hasTrailingComma), visitor, isExpression), multiLine);
            return createSpreadSegment(0 /* None */ , expression);
        }
        function visitSpreadElement(node) {
            return visitNode(node.expression, visitor, isExpression);
        }
        function visitTemplateLiteral(node) {
            return setTextRange(factory2.createStringLiteral(node.text), node);
        }
        function visitStringLiteral(node) {
            if (node.hasExtendedUnicodeEscape) return setTextRange(factory2.createStringLiteral(node.text), node);
            return node;
        }
        function visitNumericLiteral(node) {
            if (node.numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */ ) return setTextRange(factory2.createNumericLiteral(node.text), node);
            return node;
        }
        function visitTaggedTemplateExpression(node) {
            return processTaggedTemplateExpression(context, node, visitor, currentSourceFile, recordTaggedTemplateString, 1 /* All */ );
        }
        function visitTemplateExpression(node) {
            let expression = factory2.createStringLiteral(node.head.text);
            for (const span of node.templateSpans){
                const args = [
                    Debug.checkDefined(visitNode(span.expression, visitor, isExpression))
                ];
                if (span.literal.text.length > 0) args.push(factory2.createStringLiteral(span.literal.text));
                expression = factory2.createCallExpression(factory2.createPropertyAccessExpression(expression, "concat"), /*typeArguments*/ void 0, args);
            }
            return setTextRange(expression, node);
        }
        function createSyntheticSuper() {
            return factory2.createUniqueName("_super", 48 /* FileLevel */ );
        }
        function visitSuperKeyword(node, isExpressionOfCall) {
            const expression = hierarchyFacts & 8 /* NonStaticClassElement */  && !isExpressionOfCall ? factory2.createPropertyAccessExpression(setOriginalNode(createSyntheticSuper(), node), "prototype") : createSyntheticSuper();
            setOriginalNode(expression, node);
            setCommentRange(expression, node);
            setSourceMapRange(expression, node);
            return expression;
        }
        function visitMetaProperty(node) {
            if (node.keywordToken === 105 /* NewKeyword */  && node.name.escapedText === "target") {
                hierarchyFacts |= 32768 /* NewTarget */ ;
                return factory2.createUniqueName("_newTarget", 48 /* FileLevel */ );
            }
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            if (enabledSubstitutions & 1 /* CapturedThis */  && isFunctionLike(node)) {
                const ancestorFacts = enterSubtree(32670 /* FunctionExcludes */ , getEmitFlags(node) & 16 /* CapturesThis */  ? 81 /* CapturesThis */  : 65 /* FunctionIncludes */ );
                previousOnEmitNode(hint, node, emitCallback);
                exitSubtree(ancestorFacts, 0 /* None */ , 0 /* None */ );
                return;
            }
            previousOnEmitNode(hint, node, emitCallback);
        }
        function enableSubstitutionsForBlockScopedBindings() {
            if ((enabledSubstitutions & 2 /* BlockScopedBindings */ ) === 0) {
                enabledSubstitutions |= 2 /* BlockScopedBindings */ ;
                context.enableSubstitution(80 /* Identifier */ );
            }
        }
        function enableSubstitutionsForCapturedThis() {
            if ((enabledSubstitutions & 1 /* CapturedThis */ ) === 0) {
                enabledSubstitutions |= 1 /* CapturedThis */ ;
                context.enableSubstitution(110 /* ThisKeyword */ );
                context.enableEmitNotification(177 /* Constructor */ );
                context.enableEmitNotification(175 /* MethodDeclaration */ );
                context.enableEmitNotification(178 /* GetAccessor */ );
                context.enableEmitNotification(179 /* SetAccessor */ );
                context.enableEmitNotification(220 /* ArrowFunction */ );
                context.enableEmitNotification(219 /* FunctionExpression */ );
                context.enableEmitNotification(263 /* FunctionDeclaration */ );
            }
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            if (isIdentifier(node)) return substituteIdentifier(node);
            return node;
        }
        function substituteIdentifier(node) {
            if (enabledSubstitutions & 2 /* BlockScopedBindings */  && !isInternalName(node)) {
                const original = getParseTreeNode(node, isIdentifier);
                if (original && isNameOfDeclarationWithCollidingName(original)) return setTextRange(factory2.getGeneratedNameForNode(original), node);
            }
            return node;
        }
        function isNameOfDeclarationWithCollidingName(node) {
            switch(node.parent.kind){
                case 209 /* BindingElement */ :
                case 264 /* ClassDeclaration */ :
                case 267 /* EnumDeclaration */ :
                case 261 /* VariableDeclaration */ :
                    return node.parent.name === node && resolver.isDeclarationWithCollidingName(node.parent);
            }
            return false;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 110 /* ThisKeyword */ :
                    return substituteThisKeyword(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            if (enabledSubstitutions & 2 /* BlockScopedBindings */  && !isInternalName(node)) {
                const declaration = resolver.getReferencedDeclarationWithCollidingName(node);
                if (declaration && !(isClassLike(declaration) && isPartOfClassBody(declaration, node))) return setTextRange(factory2.getGeneratedNameForNode(getNameOfDeclaration(declaration)), node);
            }
            return node;
        }
        function isPartOfClassBody(declaration, node) {
            let currentNode = getParseTreeNode(node);
            if (!currentNode || currentNode === declaration || currentNode.end <= declaration.pos || currentNode.pos >= declaration.end) return false;
            const blockScope = getEnclosingBlockScopeContainer(declaration);
            while(currentNode){
                if (currentNode === blockScope || currentNode === declaration) return false;
                if (isClassElement(currentNode) && currentNode.parent === declaration) return true;
                currentNode = currentNode.parent;
            }
            return false;
        }
        function substituteThisKeyword(node) {
            if (enabledSubstitutions & 1 /* CapturedThis */  && hierarchyFacts & 16 /* CapturesThis */ ) return setTextRange(createCapturedThis(), node);
            return node;
        }
        function getClassMemberPrefix(node, member) {
            return isStatic(member) ? factory2.getInternalName(node) : factory2.createPropertyAccessExpression(factory2.getInternalName(node), "prototype");
        }
        function hasSynthesizedDefaultSuperCall(constructor, hasExtendsClause) {
            if (!constructor || !hasExtendsClause) return false;
            if (some(constructor.parameters)) return false;
            const statement = firstOrUndefined(constructor.body.statements);
            if (!statement || !nodeIsSynthesized(statement) || statement.kind !== 245 /* ExpressionStatement */ ) return false;
            const statementExpression = statement.expression;
            if (!nodeIsSynthesized(statementExpression) || statementExpression.kind !== 214 /* CallExpression */ ) return false;
            const callTarget = statementExpression.expression;
            if (!nodeIsSynthesized(callTarget) || callTarget.kind !== 108 /* SuperKeyword */ ) return false;
            const callArgument = singleOrUndefined(statementExpression.arguments);
            if (!callArgument || !nodeIsSynthesized(callArgument) || callArgument.kind !== 231 /* SpreadElement */ ) return false;
            const expression = callArgument.expression;
            return isIdentifier(expression) && expression.escapedText === "arguments";
        }
    }
    // src/compiler/transformers/generators.ts
    function getInstructionName(instruction) {
        switch(instruction){
            case 2 /* Return */ :
                return "return";
            case 3 /* Break */ :
                return "break";
            case 4 /* Yield */ :
                return "yield";
            case 5 /* YieldStar */ :
                return "yield*";
            case 7 /* Endfinally */ :
                return "endfinally";
            default:
                return void 0;
        }
    }
    function transformGenerators(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers, resumeLexicalEnvironment, endLexicalEnvironment, hoistFunctionDeclaration, hoistVariableDeclaration } = context;
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const resolver = context.getEmitResolver();
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onSubstituteNode = onSubstituteNode;
        let renamedCatchVariables;
        let renamedCatchVariableDeclarations;
        let inGeneratorFunctionBody;
        let inStatementContainingYield;
        let blocks;
        let blockOffsets;
        let blockActions;
        let blockStack;
        let labelOffsets;
        let labelExpressions;
        let nextLabelId = 1;
        let operations;
        let operationArguments;
        let operationLocations;
        let state;
        let blockIndex = 0;
        let labelNumber = 0;
        let labelNumbers;
        let lastOperationWasAbrupt;
        let lastOperationWasCompletion;
        let clauses;
        let statements;
        let exceptionBlockStack;
        let currentExceptionBlock;
        let withBlockStack;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile || (node.transformFlags & 2048 /* ContainsGenerator */ ) === 0) return node;
            const visited = visitEachChild(node, visitor, context);
            addEmitHelpers(visited, context.readEmitHelpers());
            return visited;
        }
        function visitor(node) {
            const transformFlags = node.transformFlags;
            if (inStatementContainingYield) return visitJavaScriptInStatementContainingYield(node);
            else if (inGeneratorFunctionBody) return visitJavaScriptInGeneratorFunctionBody(node);
            else if (isFunctionLikeDeclaration(node) && node.asteriskToken) return visitGenerator(node);
            else if (transformFlags & 2048 /* ContainsGenerator */ ) return visitEachChild(node, visitor, context);
            else return node;
        }
        function visitJavaScriptInStatementContainingYield(node) {
            switch(node.kind){
                case 247 /* DoStatement */ :
                    return visitDoStatement(node);
                case 248 /* WhileStatement */ :
                    return visitWhileStatement(node);
                case 256 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 257 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                default:
                    return visitJavaScriptInGeneratorFunctionBody(node);
            }
        }
        function visitJavaScriptInGeneratorFunctionBody(node) {
            switch(node.kind){
                case 263 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 219 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return visitAccessorDeclaration(node);
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 249 /* ForStatement */ :
                    return visitForStatement(node);
                case 250 /* ForInStatement */ :
                    return visitForInStatement(node);
                case 253 /* BreakStatement */ :
                    return visitBreakStatement(node);
                case 252 /* ContinueStatement */ :
                    return visitContinueStatement(node);
                case 254 /* ReturnStatement */ :
                    return visitReturnStatement(node);
                default:
                    if (node.transformFlags & 1048576 /* ContainsYield */ ) return visitJavaScriptContainingYield(node);
                    else if (node.transformFlags & 4196352 /* ContainsHoistedDeclarationOrCompletion */ ) return visitEachChild(node, visitor, context);
                    else return node;
            }
        }
        function visitJavaScriptContainingYield(node) {
            switch(node.kind){
                case 227 /* BinaryExpression */ :
                    return visitBinaryExpression(node);
                case 357 /* CommaListExpression */ :
                    return visitCommaListExpression(node);
                case 228 /* ConditionalExpression */ :
                    return visitConditionalExpression(node);
                case 230 /* YieldExpression */ :
                    return visitYieldExpression(node);
                case 210 /* ArrayLiteralExpression */ :
                    return visitArrayLiteralExpression(node);
                case 211 /* ObjectLiteralExpression */ :
                    return visitObjectLiteralExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return visitElementAccessExpression(node);
                case 214 /* CallExpression */ :
                    return visitCallExpression(node);
                case 215 /* NewExpression */ :
                    return visitNewExpression(node);
                default:
                    return visitEachChild(node, visitor, context);
            }
        }
        function visitGenerator(node) {
            switch(node.kind){
                case 263 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 219 /* FunctionExpression */ :
                    return visitFunctionExpression(node);
                default:
                    return Debug.failBadSyntaxKind(node);
            }
        }
        function visitFunctionDeclaration(node) {
            if (node.asteriskToken) node = setOriginalNode(setTextRange(factory2.createFunctionDeclaration(node.modifiers, /*asteriskToken*/ void 0, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformGeneratorFunctionBody(node.body)), /*location*/ node), node);
            else {
                const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
                const savedInStatementContainingYield = inStatementContainingYield;
                inGeneratorFunctionBody = false;
                inStatementContainingYield = false;
                node = visitEachChild(node, visitor, context);
                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
                inStatementContainingYield = savedInStatementContainingYield;
            }
            if (inGeneratorFunctionBody) {
                hoistFunctionDeclaration(node);
                return void 0;
            } else return node;
        }
        function visitFunctionExpression(node) {
            if (node.asteriskToken) node = setOriginalNode(setTextRange(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, node.name, /*typeParameters*/ void 0, visitParameterList(node.parameters, visitor, context), /*type*/ void 0, transformGeneratorFunctionBody(node.body)), /*location*/ node), node);
            else {
                const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
                const savedInStatementContainingYield = inStatementContainingYield;
                inGeneratorFunctionBody = false;
                inStatementContainingYield = false;
                node = visitEachChild(node, visitor, context);
                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
                inStatementContainingYield = savedInStatementContainingYield;
            }
            return node;
        }
        function visitAccessorDeclaration(node) {
            const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
            const savedInStatementContainingYield = inStatementContainingYield;
            inGeneratorFunctionBody = false;
            inStatementContainingYield = false;
            node = visitEachChild(node, visitor, context);
            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
            inStatementContainingYield = savedInStatementContainingYield;
            return node;
        }
        function transformGeneratorFunctionBody(body) {
            const statements2 = [];
            const savedInGeneratorFunctionBody = inGeneratorFunctionBody;
            const savedInStatementContainingYield = inStatementContainingYield;
            const savedBlocks = blocks;
            const savedBlockOffsets = blockOffsets;
            const savedBlockActions = blockActions;
            const savedBlockStack = blockStack;
            const savedLabelOffsets = labelOffsets;
            const savedLabelExpressions = labelExpressions;
            const savedNextLabelId = nextLabelId;
            const savedOperations = operations;
            const savedOperationArguments = operationArguments;
            const savedOperationLocations = operationLocations;
            const savedState = state;
            inGeneratorFunctionBody = true;
            inStatementContainingYield = false;
            blocks = void 0;
            blockOffsets = void 0;
            blockActions = void 0;
            blockStack = void 0;
            labelOffsets = void 0;
            labelExpressions = void 0;
            nextLabelId = 1;
            operations = void 0;
            operationArguments = void 0;
            operationLocations = void 0;
            state = factory2.createTempVariable(/*recordTempVariable*/ void 0);
            resumeLexicalEnvironment();
            const statementOffset = factory2.copyPrologue(body.statements, statements2, /*ensureUseStrict*/ false, visitor);
            transformAndEmitStatements(body.statements, statementOffset);
            const buildResult = build2();
            insertStatementsAfterStandardPrologue(statements2, endLexicalEnvironment());
            statements2.push(factory2.createReturnStatement(buildResult));
            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
            inStatementContainingYield = savedInStatementContainingYield;
            blocks = savedBlocks;
            blockOffsets = savedBlockOffsets;
            blockActions = savedBlockActions;
            blockStack = savedBlockStack;
            labelOffsets = savedLabelOffsets;
            labelExpressions = savedLabelExpressions;
            nextLabelId = savedNextLabelId;
            operations = savedOperations;
            operationArguments = savedOperationArguments;
            operationLocations = savedOperationLocations;
            state = savedState;
            return setTextRange(factory2.createBlock(statements2, body.multiLine), body);
        }
        function visitVariableStatement(node) {
            if (node.transformFlags & 1048576 /* ContainsYield */ ) {
                transformAndEmitVariableDeclarationList(node.declarationList);
                return void 0;
            } else {
                if (getEmitFlags(node) & 2097152 /* CustomPrologue */ ) return node;
                for (const variable of node.declarationList.declarations)hoistVariableDeclaration(variable.name);
                const variables = getInitializedVariables(node.declarationList);
                if (variables.length === 0) return void 0;
                return setSourceMapRange(factory2.createExpressionStatement(factory2.inlineExpressions(map(variables, transformInitializedVariable))), node);
            }
        }
        function visitBinaryExpression(node) {
            const assoc = getExpressionAssociativity(node);
            switch(assoc){
                case 0 /* Left */ :
                    return visitLeftAssociativeBinaryExpression(node);
                case 1 /* Right */ :
                    return visitRightAssociativeBinaryExpression(node);
                default:
                    return Debug.assertNever(assoc);
            }
        }
        function visitRightAssociativeBinaryExpression(node) {
            const { left, right } = node;
            if (containsYield(right)) {
                let target;
                switch(left.kind){
                    case 212 /* PropertyAccessExpression */ :
                        target = factory2.updatePropertyAccessExpression(left, cacheExpression(Debug.checkDefined(visitNode(left.expression, visitor, isLeftHandSideExpression))), left.name);
                        break;
                    case 213 /* ElementAccessExpression */ :
                        target = factory2.updateElementAccessExpression(left, cacheExpression(Debug.checkDefined(visitNode(left.expression, visitor, isLeftHandSideExpression))), cacheExpression(Debug.checkDefined(visitNode(left.argumentExpression, visitor, isExpression))));
                        break;
                    default:
                        target = Debug.checkDefined(visitNode(left, visitor, isExpression));
                        break;
                }
                const operator = node.operatorToken.kind;
                if (isCompoundAssignment(operator)) return setTextRange(factory2.createAssignment(target, setTextRange(factory2.createBinaryExpression(cacheExpression(target), getNonAssignmentOperatorForCompoundAssignment(operator), Debug.checkDefined(visitNode(right, visitor, isExpression))), node)), node);
                else return factory2.updateBinaryExpression(node, target, node.operatorToken, Debug.checkDefined(visitNode(right, visitor, isExpression)));
            }
            return visitEachChild(node, visitor, context);
        }
        function visitLeftAssociativeBinaryExpression(node) {
            if (containsYield(node.right)) {
                if (isLogicalOperator(node.operatorToken.kind)) return visitLogicalBinaryExpression(node);
                else if (node.operatorToken.kind === 28 /* CommaToken */ ) return visitCommaExpression(node);
                return factory2.updateBinaryExpression(node, cacheExpression(Debug.checkDefined(visitNode(node.left, visitor, isExpression))), node.operatorToken, Debug.checkDefined(visitNode(node.right, visitor, isExpression)));
            }
            return visitEachChild(node, visitor, context);
        }
        function visitCommaExpression(node) {
            let pendingExpressions = [];
            visit(node.left);
            visit(node.right);
            return factory2.inlineExpressions(pendingExpressions);
            function visit(node2) {
                if (isBinaryExpression(node2) && node2.operatorToken.kind === 28 /* CommaToken */ ) {
                    visit(node2.left);
                    visit(node2.right);
                } else {
                    if (containsYield(node2) && pendingExpressions.length > 0) {
                        emitWorker(1 /* Statement */ , [
                            factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions))
                        ]);
                        pendingExpressions = [];
                    }
                    pendingExpressions.push(Debug.checkDefined(visitNode(node2, visitor, isExpression)));
                }
            }
        }
        function visitCommaListExpression(node) {
            let pendingExpressions = [];
            for (const elem of node.elements)if (isBinaryExpression(elem) && elem.operatorToken.kind === 28 /* CommaToken */ ) pendingExpressions.push(visitCommaExpression(elem));
            else {
                if (containsYield(elem) && pendingExpressions.length > 0) {
                    emitWorker(1 /* Statement */ , [
                        factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions))
                    ]);
                    pendingExpressions = [];
                }
                pendingExpressions.push(Debug.checkDefined(visitNode(elem, visitor, isExpression)));
            }
            return factory2.inlineExpressions(pendingExpressions);
        }
        function visitLogicalBinaryExpression(node) {
            const resultLabel = defineLabel();
            const resultLocal = declareLocal();
            emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.left, visitor, isExpression)), /*location*/ node.left);
            if (node.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ) emitBreakWhenFalse(resultLabel, resultLocal, /*location*/ node.left);
            else emitBreakWhenTrue(resultLabel, resultLocal, /*location*/ node.left);
            emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.right, visitor, isExpression)), /*location*/ node.right);
            markLabel(resultLabel);
            return resultLocal;
        }
        function visitConditionalExpression(node) {
            if (containsYield(node.whenTrue) || containsYield(node.whenFalse)) {
                const whenFalseLabel = defineLabel();
                const resultLabel = defineLabel();
                const resultLocal = declareLocal();
                emitBreakWhenFalse(whenFalseLabel, Debug.checkDefined(visitNode(node.condition, visitor, isExpression)), /*location*/ node.condition);
                emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.whenTrue, visitor, isExpression)), /*location*/ node.whenTrue);
                emitBreak(resultLabel);
                markLabel(whenFalseLabel);
                emitAssignment(resultLocal, Debug.checkDefined(visitNode(node.whenFalse, visitor, isExpression)), /*location*/ node.whenFalse);
                markLabel(resultLabel);
                return resultLocal;
            }
            return visitEachChild(node, visitor, context);
        }
        function visitYieldExpression(node) {
            const resumeLabel = defineLabel();
            const expression = visitNode(node.expression, visitor, isExpression);
            if (node.asteriskToken) {
                const iterator = (getEmitFlags(node.expression) & 8388608 /* Iterator */ ) === 0 ? setTextRange(emitHelpers().createValuesHelper(expression), node) : expression;
                emitYieldStar(iterator, /*location*/ node);
            } else emitYield(expression, /*location*/ node);
            markLabel(resumeLabel);
            return createGeneratorResume(/*location*/ node);
        }
        function visitArrayLiteralExpression(node) {
            return visitElements(node.elements, /*leadingElement*/ void 0, /*location*/ void 0, node.multiLine);
        }
        function visitElements(elements, leadingElement, location, multiLine) {
            const numInitialElements = countInitialNodesWithoutYield(elements);
            let temp;
            if (numInitialElements > 0) {
                temp = declareLocal();
                const initialElements = visitNodes2(elements, visitor, isExpression, 0, numInitialElements);
                emitAssignment(temp, factory2.createArrayLiteralExpression(leadingElement ? [
                    leadingElement,
                    ...initialElements
                ] : initialElements));
                leadingElement = void 0;
            }
            const expressions = reduceLeft(elements, reduceElement, [], numInitialElements);
            return temp ? factory2.createArrayConcatCall(temp, [
                factory2.createArrayLiteralExpression(expressions, multiLine)
            ]) : setTextRange(factory2.createArrayLiteralExpression(leadingElement ? [
                leadingElement,
                ...expressions
            ] : expressions, multiLine), location);
            function reduceElement(expressions2, element) {
                if (containsYield(element) && expressions2.length > 0) {
                    const hasAssignedTemp = temp !== void 0;
                    if (!temp) temp = declareLocal();
                    emitAssignment(temp, hasAssignedTemp ? factory2.createArrayConcatCall(temp, [
                        factory2.createArrayLiteralExpression(expressions2, multiLine)
                    ]) : factory2.createArrayLiteralExpression(leadingElement ? [
                        leadingElement,
                        ...expressions2
                    ] : expressions2, multiLine));
                    leadingElement = void 0;
                    expressions2 = [];
                }
                expressions2.push(Debug.checkDefined(visitNode(element, visitor, isExpression)));
                return expressions2;
            }
        }
        function visitObjectLiteralExpression(node) {
            const properties = node.properties;
            const multiLine = node.multiLine;
            const numInitialProperties = countInitialNodesWithoutYield(properties);
            const temp = declareLocal();
            emitAssignment(temp, factory2.createObjectLiteralExpression(visitNodes2(properties, visitor, isObjectLiteralElementLike, 0, numInitialProperties), multiLine));
            const expressions = reduceLeft(properties, reduceProperty, [], numInitialProperties);
            expressions.push(multiLine ? startOnNewLine(setParent(setTextRange(factory2.cloneNode(temp), temp), temp.parent)) : temp);
            return factory2.inlineExpressions(expressions);
            function reduceProperty(expressions2, property) {
                if (containsYield(property) && expressions2.length > 0) {
                    emitStatement(factory2.createExpressionStatement(factory2.inlineExpressions(expressions2)));
                    expressions2 = [];
                }
                const expression = createExpressionForObjectLiteralElementLike(factory2, node, property, temp);
                const visited = visitNode(expression, visitor, isExpression);
                if (visited) {
                    if (multiLine) startOnNewLine(visited);
                    expressions2.push(visited);
                }
                return expressions2;
            }
        }
        function visitElementAccessExpression(node) {
            if (containsYield(node.argumentExpression)) return factory2.updateElementAccessExpression(node, cacheExpression(Debug.checkDefined(visitNode(node.expression, visitor, isLeftHandSideExpression))), Debug.checkDefined(visitNode(node.argumentExpression, visitor, isExpression)));
            return visitEachChild(node, visitor, context);
        }
        function visitCallExpression(node) {
            if (!isImportCall(node) && forEach(node.arguments, containsYield)) {
                const { target, thisArg } = factory2.createCallBinding(node.expression, hoistVariableDeclaration, languageVersion, /*cacheIdentifiers*/ true);
                return setOriginalNode(setTextRange(factory2.createFunctionApplyCall(cacheExpression(Debug.checkDefined(visitNode(target, visitor, isLeftHandSideExpression))), thisArg, visitElements(node.arguments)), node), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitNewExpression(node) {
            if (forEach(node.arguments, containsYield)) {
                const { target, thisArg } = factory2.createCallBinding(factory2.createPropertyAccessExpression(node.expression, "bind"), hoistVariableDeclaration);
                return setOriginalNode(setTextRange(factory2.createNewExpression(factory2.createFunctionApplyCall(cacheExpression(Debug.checkDefined(visitNode(target, visitor, isExpression))), thisArg, visitElements(node.arguments, /*leadingElement*/ factory2.createVoidZero())), /*typeArguments*/ void 0, []), node), node);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndEmitStatements(statements2, start = 0) {
            const numStatements = statements2.length;
            for(let i = start; i < numStatements; i++)transformAndEmitStatement(statements2[i]);
        }
        function transformAndEmitEmbeddedStatement(node) {
            if (isBlock(node)) transformAndEmitStatements(node.statements);
            else transformAndEmitStatement(node);
        }
        function transformAndEmitStatement(node) {
            const savedInStatementContainingYield = inStatementContainingYield;
            if (!inStatementContainingYield) inStatementContainingYield = containsYield(node);
            transformAndEmitStatementWorker(node);
            inStatementContainingYield = savedInStatementContainingYield;
        }
        function transformAndEmitStatementWorker(node) {
            switch(node.kind){
                case 242 /* Block */ :
                    return transformAndEmitBlock(node);
                case 245 /* ExpressionStatement */ :
                    return transformAndEmitExpressionStatement(node);
                case 246 /* IfStatement */ :
                    return transformAndEmitIfStatement(node);
                case 247 /* DoStatement */ :
                    return transformAndEmitDoStatement(node);
                case 248 /* WhileStatement */ :
                    return transformAndEmitWhileStatement(node);
                case 249 /* ForStatement */ :
                    return transformAndEmitForStatement(node);
                case 250 /* ForInStatement */ :
                    return transformAndEmitForInStatement(node);
                case 252 /* ContinueStatement */ :
                    return transformAndEmitContinueStatement(node);
                case 253 /* BreakStatement */ :
                    return transformAndEmitBreakStatement(node);
                case 254 /* ReturnStatement */ :
                    return transformAndEmitReturnStatement(node);
                case 255 /* WithStatement */ :
                    return transformAndEmitWithStatement(node);
                case 256 /* SwitchStatement */ :
                    return transformAndEmitSwitchStatement(node);
                case 257 /* LabeledStatement */ :
                    return transformAndEmitLabeledStatement(node);
                case 258 /* ThrowStatement */ :
                    return transformAndEmitThrowStatement(node);
                case 259 /* TryStatement */ :
                    return transformAndEmitTryStatement(node);
                default:
                    return emitStatement(visitNode(node, visitor, isStatement));
            }
        }
        function transformAndEmitBlock(node) {
            if (containsYield(node)) transformAndEmitStatements(node.statements);
            else emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitExpressionStatement(node) {
            emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitVariableDeclarationList(node) {
            for (const variable of node.declarations){
                const name = factory2.cloneNode(variable.name);
                setCommentRange(name, variable.name);
                hoistVariableDeclaration(name);
            }
            const variables = getInitializedVariables(node);
            const numVariables = variables.length;
            let variablesWritten = 0;
            let pendingExpressions = [];
            while(variablesWritten < numVariables){
                for(let i = variablesWritten; i < numVariables; i++){
                    const variable = variables[i];
                    if (containsYield(variable.initializer) && pendingExpressions.length > 0) break;
                    pendingExpressions.push(transformInitializedVariable(variable));
                }
                if (pendingExpressions.length) {
                    emitStatement(factory2.createExpressionStatement(factory2.inlineExpressions(pendingExpressions)));
                    variablesWritten += pendingExpressions.length;
                    pendingExpressions = [];
                }
            }
            return void 0;
        }
        function transformInitializedVariable(node) {
            return setSourceMapRange(factory2.createAssignment(setSourceMapRange(factory2.cloneNode(node.name), node.name), Debug.checkDefined(visitNode(node.initializer, visitor, isExpression))), node);
        }
        function transformAndEmitIfStatement(node) {
            if (containsYield(node)) {
                if (containsYield(node.thenStatement) || containsYield(node.elseStatement)) {
                    const endLabel = defineLabel();
                    const elseLabel = node.elseStatement ? defineLabel() : void 0;
                    emitBreakWhenFalse(node.elseStatement ? elseLabel : endLabel, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), /*location*/ node.expression);
                    transformAndEmitEmbeddedStatement(node.thenStatement);
                    if (node.elseStatement) {
                        emitBreak(endLabel);
                        markLabel(elseLabel);
                        transformAndEmitEmbeddedStatement(node.elseStatement);
                    }
                    markLabel(endLabel);
                } else emitStatement(visitNode(node, visitor, isStatement));
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitDoStatement(node) {
            if (containsYield(node)) {
                const conditionLabel = defineLabel();
                const loopLabel = defineLabel();
                beginLoopBlock(/*continueLabel*/ conditionLabel);
                markLabel(loopLabel);
                transformAndEmitEmbeddedStatement(node.statement);
                markLabel(conditionLabel);
                emitBreakWhenTrue(loopLabel, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitDoStatement(node) {
            if (inStatementContainingYield) {
                beginScriptLoopBlock();
                node = visitEachChild(node, visitor, context);
                endLoopBlock();
                return node;
            } else return visitEachChild(node, visitor, context);
        }
        function transformAndEmitWhileStatement(node) {
            if (containsYield(node)) {
                const loopLabel = defineLabel();
                const endLabel = beginLoopBlock(loopLabel);
                markLabel(loopLabel);
                emitBreakWhenFalse(endLabel, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                transformAndEmitEmbeddedStatement(node.statement);
                emitBreak(loopLabel);
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitWhileStatement(node) {
            if (inStatementContainingYield) {
                beginScriptLoopBlock();
                node = visitEachChild(node, visitor, context);
                endLoopBlock();
                return node;
            } else return visitEachChild(node, visitor, context);
        }
        function transformAndEmitForStatement(node) {
            if (containsYield(node)) {
                const conditionLabel = defineLabel();
                const incrementLabel = defineLabel();
                const endLabel = beginLoopBlock(incrementLabel);
                if (node.initializer) {
                    const initializer = node.initializer;
                    if (isVariableDeclarationList(initializer)) transformAndEmitVariableDeclarationList(initializer);
                    else emitStatement(setTextRange(factory2.createExpressionStatement(Debug.checkDefined(visitNode(initializer, visitor, isExpression))), initializer));
                }
                markLabel(conditionLabel);
                if (node.condition) emitBreakWhenFalse(endLabel, Debug.checkDefined(visitNode(node.condition, visitor, isExpression)));
                transformAndEmitEmbeddedStatement(node.statement);
                markLabel(incrementLabel);
                if (node.incrementor) emitStatement(setTextRange(factory2.createExpressionStatement(Debug.checkDefined(visitNode(node.incrementor, visitor, isExpression))), node.incrementor));
                emitBreak(conditionLabel);
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitForStatement(node) {
            if (inStatementContainingYield) beginScriptLoopBlock();
            const initializer = node.initializer;
            if (initializer && isVariableDeclarationList(initializer)) {
                for (const variable of initializer.declarations)hoistVariableDeclaration(variable.name);
                const variables = getInitializedVariables(initializer);
                node = factory2.updateForStatement(node, variables.length > 0 ? factory2.inlineExpressions(map(variables, transformInitializedVariable)) : void 0, visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, visitor, isExpression), visitIterationBody(node.statement, visitor, context));
            } else node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endLoopBlock();
            return node;
        }
        function transformAndEmitForInStatement(node) {
            if (containsYield(node)) {
                const obj = declareLocal();
                const keysArray = declareLocal();
                const key = declareLocal();
                const keysIndex = factory2.createLoopVariable();
                const initializer = node.initializer;
                hoistVariableDeclaration(keysIndex);
                emitAssignment(obj, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                emitAssignment(keysArray, factory2.createArrayLiteralExpression());
                emitStatement(factory2.createForInStatement(key, obj, factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(keysArray, "push"), /*typeArguments*/ void 0, [
                    key
                ]))));
                emitAssignment(keysIndex, factory2.createNumericLiteral(0));
                const conditionLabel = defineLabel();
                const incrementLabel = defineLabel();
                const endLoopLabel = beginLoopBlock(incrementLabel);
                markLabel(conditionLabel);
                emitBreakWhenFalse(endLoopLabel, factory2.createLessThan(keysIndex, factory2.createPropertyAccessExpression(keysArray, "length")));
                emitAssignment(key, factory2.createElementAccessExpression(keysArray, keysIndex));
                emitBreakWhenFalse(incrementLabel, factory2.createBinaryExpression(key, 103 /* InKeyword */ , obj));
                let variable;
                if (isVariableDeclarationList(initializer)) {
                    for (const variable2 of initializer.declarations)hoistVariableDeclaration(variable2.name);
                    variable = factory2.cloneNode(initializer.declarations[0].name);
                } else {
                    variable = Debug.checkDefined(visitNode(initializer, visitor, isExpression));
                    Debug.assert(isLeftHandSideExpression(variable));
                }
                emitAssignment(variable, key);
                transformAndEmitEmbeddedStatement(node.statement);
                markLabel(incrementLabel);
                emitStatement(factory2.createExpressionStatement(factory2.createPostfixIncrement(keysIndex)));
                emitBreak(conditionLabel);
                endLoopBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitForInStatement(node) {
            if (inStatementContainingYield) beginScriptLoopBlock();
            const initializer = node.initializer;
            if (isVariableDeclarationList(initializer)) {
                for (const variable of initializer.declarations)hoistVariableDeclaration(variable.name);
                node = factory2.updateForInStatement(node, initializer.declarations[0].name, Debug.checkDefined(visitNode(node.expression, visitor, isExpression)), Debug.checkDefined(visitNode(node.statement, visitor, isStatement, factory2.liftToBlock)));
            } else node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endLoopBlock();
            return node;
        }
        function transformAndEmitContinueStatement(node) {
            const label = findContinueTarget(node.label ? idText(node.label) : void 0);
            if (label > 0) emitBreak(label, /*location*/ node);
            else emitStatement(node);
        }
        function visitContinueStatement(node) {
            if (inStatementContainingYield) {
                const label = findContinueTarget(node.label && idText(node.label));
                if (label > 0) return createInlineBreak(label, /*location*/ node);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndEmitBreakStatement(node) {
            const label = findBreakTarget(node.label ? idText(node.label) : void 0);
            if (label > 0) emitBreak(label, /*location*/ node);
            else emitStatement(node);
        }
        function visitBreakStatement(node) {
            if (inStatementContainingYield) {
                const label = findBreakTarget(node.label && idText(node.label));
                if (label > 0) return createInlineBreak(label, /*location*/ node);
            }
            return visitEachChild(node, visitor, context);
        }
        function transformAndEmitReturnStatement(node) {
            emitReturn(visitNode(node.expression, visitor, isExpression), /*location*/ node);
        }
        function visitReturnStatement(node) {
            return createInlineReturn(visitNode(node.expression, visitor, isExpression), /*location*/ node);
        }
        function transformAndEmitWithStatement(node) {
            if (containsYield(node)) {
                beginWithBlock(cacheExpression(Debug.checkDefined(visitNode(node.expression, visitor, isExpression))));
                transformAndEmitEmbeddedStatement(node.statement);
                endWithBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function transformAndEmitSwitchStatement(node) {
            if (containsYield(node.caseBlock)) {
                const caseBlock = node.caseBlock;
                const numClauses = caseBlock.clauses.length;
                const endLabel = beginSwitchBlock();
                const expression = cacheExpression(Debug.checkDefined(visitNode(node.expression, visitor, isExpression)));
                const clauseLabels = [];
                let defaultClauseIndex = -1;
                for(let i = 0; i < numClauses; i++){
                    const clause = caseBlock.clauses[i];
                    clauseLabels.push(defineLabel());
                    if (clause.kind === 298 /* DefaultClause */  && defaultClauseIndex === -1) defaultClauseIndex = i;
                }
                let clausesWritten = 0;
                let pendingClauses = [];
                while(clausesWritten < numClauses){
                    let defaultClausesSkipped = 0;
                    for(let i = clausesWritten; i < numClauses; i++){
                        const clause = caseBlock.clauses[i];
                        if (clause.kind === 297 /* CaseClause */ ) {
                            if (containsYield(clause.expression) && pendingClauses.length > 0) break;
                            pendingClauses.push(factory2.createCaseClause(Debug.checkDefined(visitNode(clause.expression, visitor, isExpression)), [
                                createInlineBreak(clauseLabels[i], /*location*/ clause.expression)
                            ]));
                        } else defaultClausesSkipped++;
                    }
                    if (pendingClauses.length) {
                        emitStatement(factory2.createSwitchStatement(expression, factory2.createCaseBlock(pendingClauses)));
                        clausesWritten += pendingClauses.length;
                        pendingClauses = [];
                    }
                    if (defaultClausesSkipped > 0) {
                        clausesWritten += defaultClausesSkipped;
                        defaultClausesSkipped = 0;
                    }
                }
                if (defaultClauseIndex >= 0) emitBreak(clauseLabels[defaultClauseIndex]);
                else emitBreak(endLabel);
                for(let i = 0; i < numClauses; i++){
                    markLabel(clauseLabels[i]);
                    transformAndEmitStatements(caseBlock.clauses[i].statements);
                }
                endSwitchBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitSwitchStatement(node) {
            if (inStatementContainingYield) beginScriptSwitchBlock();
            node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endSwitchBlock();
            return node;
        }
        function transformAndEmitLabeledStatement(node) {
            if (containsYield(node)) {
                beginLabeledBlock(idText(node.label));
                transformAndEmitEmbeddedStatement(node.statement);
                endLabeledBlock();
            } else emitStatement(visitNode(node, visitor, isStatement));
        }
        function visitLabeledStatement(node) {
            if (inStatementContainingYield) beginScriptLabeledBlock(idText(node.label));
            node = visitEachChild(node, visitor, context);
            if (inStatementContainingYield) endLabeledBlock();
            return node;
        }
        function transformAndEmitThrowStatement(node) {
            var _node_expression;
            emitThrow(Debug.checkDefined(visitNode((_node_expression = node.expression) !== null && _node_expression !== void 0 ? _node_expression : factory2.createVoidZero(), visitor, isExpression)), /*location*/ node);
        }
        function transformAndEmitTryStatement(node) {
            if (containsYield(node)) {
                beginExceptionBlock();
                transformAndEmitEmbeddedStatement(node.tryBlock);
                if (node.catchClause) {
                    beginCatchBlock(node.catchClause.variableDeclaration);
                    transformAndEmitEmbeddedStatement(node.catchClause.block);
                }
                if (node.finallyBlock) {
                    beginFinallyBlock();
                    transformAndEmitEmbeddedStatement(node.finallyBlock);
                }
                endExceptionBlock();
            } else emitStatement(visitEachChild(node, visitor, context));
        }
        function containsYield(node) {
            return !!node && (node.transformFlags & 1048576 /* ContainsYield */ ) !== 0;
        }
        function countInitialNodesWithoutYield(nodes) {
            const numNodes = nodes.length;
            for(let i = 0; i < numNodes; i++){
                if (containsYield(nodes[i])) return i;
            }
            return -1;
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            return node;
        }
        function substituteExpression(node) {
            if (isIdentifier(node)) return substituteExpressionIdentifier(node);
            return node;
        }
        function substituteExpressionIdentifier(node) {
            if (!isGeneratedIdentifier(node) && renamedCatchVariables && renamedCatchVariables.has(idText(node))) {
                const original = getOriginalNode(node);
                if (isIdentifier(original) && original.parent) {
                    const declaration = resolver.getReferencedValueDeclaration(original);
                    if (declaration) {
                        const name = renamedCatchVariableDeclarations[getOriginalNodeId(declaration)];
                        if (name) {
                            const clone2 = setParent(setTextRange(factory2.cloneNode(name), name), name.parent);
                            setSourceMapRange(clone2, node);
                            setCommentRange(clone2, node);
                            return clone2;
                        }
                    }
                }
            }
            return node;
        }
        function cacheExpression(node) {
            if (isGeneratedIdentifier(node) || getEmitFlags(node) & 8192 /* HelperName */ ) return node;
            const temp = factory2.createTempVariable(hoistVariableDeclaration);
            emitAssignment(temp, node, /*location*/ node);
            return temp;
        }
        function declareLocal(name) {
            const temp = name ? factory2.createUniqueName(name) : factory2.createTempVariable(/*recordTempVariable*/ void 0);
            hoistVariableDeclaration(temp);
            return temp;
        }
        function defineLabel() {
            if (!labelOffsets) labelOffsets = [];
            const label = nextLabelId;
            nextLabelId++;
            labelOffsets[label] = -1;
            return label;
        }
        function markLabel(label) {
            Debug.assert(labelOffsets !== void 0, "No labels were defined.");
            labelOffsets[label] = operations ? operations.length : 0;
        }
        function beginBlock(block) {
            if (!blocks) {
                blocks = [];
                blockActions = [];
                blockOffsets = [];
                blockStack = [];
            }
            const index = blockActions.length;
            blockActions[index] = 0 /* Open */ ;
            blockOffsets[index] = operations ? operations.length : 0;
            blocks[index] = block;
            blockStack.push(block);
            return index;
        }
        function endBlock() {
            const block = peekBlock();
            if (block === void 0) return Debug.fail("beginBlock was never called.");
            const index = blockActions.length;
            blockActions[index] = 1 /* Close */ ;
            blockOffsets[index] = operations ? operations.length : 0;
            blocks[index] = block;
            blockStack.pop();
            return block;
        }
        function peekBlock() {
            return lastOrUndefined(blockStack);
        }
        function peekBlockKind() {
            const block = peekBlock();
            return block && block.kind;
        }
        function beginWithBlock(expression) {
            const startLabel = defineLabel();
            const endLabel = defineLabel();
            markLabel(startLabel);
            beginBlock({
                kind: 1 /* With */ ,
                expression,
                startLabel,
                endLabel
            });
        }
        function endWithBlock() {
            Debug.assert(peekBlockKind() === 1 /* With */ );
            const block = endBlock();
            markLabel(block.endLabel);
        }
        function beginExceptionBlock() {
            const startLabel = defineLabel();
            const endLabel = defineLabel();
            markLabel(startLabel);
            beginBlock({
                kind: 0 /* Exception */ ,
                state: 0 /* Try */ ,
                startLabel,
                endLabel
            });
            emitNop();
            return endLabel;
        }
        function beginCatchBlock(variable) {
            Debug.assert(peekBlockKind() === 0 /* Exception */ );
            let name;
            if (isGeneratedIdentifier(variable.name)) {
                name = variable.name;
                hoistVariableDeclaration(variable.name);
            } else {
                const text = idText(variable.name);
                name = declareLocal(text);
                if (!renamedCatchVariables) {
                    renamedCatchVariables = /* @__PURE__ */ new Map();
                    renamedCatchVariableDeclarations = [];
                    context.enableSubstitution(80 /* Identifier */ );
                }
                renamedCatchVariables.set(text, true);
                renamedCatchVariableDeclarations[getOriginalNodeId(variable)] = name;
            }
            const exception = peekBlock();
            Debug.assert(exception.state < 1 /* Catch */ );
            const endLabel = exception.endLabel;
            emitBreak(endLabel);
            const catchLabel = defineLabel();
            markLabel(catchLabel);
            exception.state = 1 /* Catch */ ;
            exception.catchVariable = name;
            exception.catchLabel = catchLabel;
            emitAssignment(name, factory2.createCallExpression(factory2.createPropertyAccessExpression(state, "sent"), /*typeArguments*/ void 0, []));
            emitNop();
        }
        function beginFinallyBlock() {
            Debug.assert(peekBlockKind() === 0 /* Exception */ );
            const exception = peekBlock();
            Debug.assert(exception.state < 2 /* Finally */ );
            const endLabel = exception.endLabel;
            emitBreak(endLabel);
            const finallyLabel = defineLabel();
            markLabel(finallyLabel);
            exception.state = 2 /* Finally */ ;
            exception.finallyLabel = finallyLabel;
        }
        function endExceptionBlock() {
            Debug.assert(peekBlockKind() === 0 /* Exception */ );
            const exception = endBlock();
            const state2 = exception.state;
            if (state2 < 2 /* Finally */ ) emitBreak(exception.endLabel);
            else emitEndfinally();
            markLabel(exception.endLabel);
            emitNop();
            exception.state = 3 /* Done */ ;
        }
        function beginScriptLoopBlock() {
            beginBlock({
                kind: 3 /* Loop */ ,
                isScript: true,
                breakLabel: -1,
                continueLabel: -1
            });
        }
        function beginLoopBlock(continueLabel) {
            const breakLabel = defineLabel();
            beginBlock({
                kind: 3 /* Loop */ ,
                isScript: false,
                breakLabel,
                continueLabel
            });
            return breakLabel;
        }
        function endLoopBlock() {
            Debug.assert(peekBlockKind() === 3 /* Loop */ );
            const block = endBlock();
            const breakLabel = block.breakLabel;
            if (!block.isScript) markLabel(breakLabel);
        }
        function beginScriptSwitchBlock() {
            beginBlock({
                kind: 2 /* Switch */ ,
                isScript: true,
                breakLabel: -1
            });
        }
        function beginSwitchBlock() {
            const breakLabel = defineLabel();
            beginBlock({
                kind: 2 /* Switch */ ,
                isScript: false,
                breakLabel
            });
            return breakLabel;
        }
        function endSwitchBlock() {
            Debug.assert(peekBlockKind() === 2 /* Switch */ );
            const block = endBlock();
            const breakLabel = block.breakLabel;
            if (!block.isScript) markLabel(breakLabel);
        }
        function beginScriptLabeledBlock(labelText) {
            beginBlock({
                kind: 4 /* Labeled */ ,
                isScript: true,
                labelText,
                breakLabel: -1
            });
        }
        function beginLabeledBlock(labelText) {
            const breakLabel = defineLabel();
            beginBlock({
                kind: 4 /* Labeled */ ,
                isScript: false,
                labelText,
                breakLabel
            });
        }
        function endLabeledBlock() {
            Debug.assert(peekBlockKind() === 4 /* Labeled */ );
            const block = endBlock();
            if (!block.isScript) markLabel(block.breakLabel);
        }
        function supportsUnlabeledBreak(block) {
            return block.kind === 2 /* Switch */  || block.kind === 3 /* Loop */ ;
        }
        function supportsLabeledBreakOrContinue(block) {
            return block.kind === 4 /* Labeled */ ;
        }
        function supportsUnlabeledContinue(block) {
            return block.kind === 3 /* Loop */ ;
        }
        function hasImmediateContainingLabeledBlock(labelText, start) {
            for(let j = start; j >= 0; j--){
                const containingBlock = blockStack[j];
                if (supportsLabeledBreakOrContinue(containingBlock)) {
                    if (containingBlock.labelText === labelText) return true;
                } else break;
            }
            return false;
        }
        function findBreakTarget(labelText) {
            if (blockStack) {
                if (labelText) for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsLabeledBreakOrContinue(block) && block.labelText === labelText) return block.breakLabel;
                    else if (supportsUnlabeledBreak(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) return block.breakLabel;
                }
                else for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsUnlabeledBreak(block)) return block.breakLabel;
                }
            }
            return 0;
        }
        function findContinueTarget(labelText) {
            if (blockStack) {
                if (labelText) for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsUnlabeledContinue(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) return block.continueLabel;
                }
                else for(let i = blockStack.length - 1; i >= 0; i--){
                    const block = blockStack[i];
                    if (supportsUnlabeledContinue(block)) return block.continueLabel;
                }
            }
            return 0;
        }
        function createLabel(label) {
            if (label !== void 0 && label > 0) {
                if (labelExpressions === void 0) labelExpressions = [];
                const expression = factory2.createNumericLiteral(Number.MAX_SAFE_INTEGER);
                if (labelExpressions[label] === void 0) labelExpressions[label] = [
                    expression
                ];
                else labelExpressions[label].push(expression);
                return expression;
            }
            return factory2.createOmittedExpression();
        }
        function createInstruction(instruction) {
            const literal = factory2.createNumericLiteral(instruction);
            addSyntheticTrailingComment(literal, 3 /* MultiLineCommentTrivia */ , getInstructionName(instruction));
            return literal;
        }
        function createInlineBreak(label, location) {
            Debug.assertLessThan(0, label, "Invalid label");
            return setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), location);
        }
        function createInlineReturn(expression, location) {
            return setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression(expression ? [
                createInstruction(2 /* Return */ ),
                expression
            ] : [
                createInstruction(2 /* Return */ )
            ])), location);
        }
        function createGeneratorResume(location) {
            return setTextRange(factory2.createCallExpression(factory2.createPropertyAccessExpression(state, "sent"), /*typeArguments*/ void 0, []), location);
        }
        function emitNop() {
            emitWorker(0 /* Nop */ );
        }
        function emitStatement(node) {
            if (node) emitWorker(1 /* Statement */ , [
                node
            ]);
            else emitNop();
        }
        function emitAssignment(left, right, location) {
            emitWorker(2 /* Assign */ , [
                left,
                right
            ], location);
        }
        function emitBreak(label, location) {
            emitWorker(3 /* Break */ , [
                label
            ], location);
        }
        function emitBreakWhenTrue(label, condition, location) {
            emitWorker(4 /* BreakWhenTrue */ , [
                label,
                condition
            ], location);
        }
        function emitBreakWhenFalse(label, condition, location) {
            emitWorker(5 /* BreakWhenFalse */ , [
                label,
                condition
            ], location);
        }
        function emitYieldStar(expression, location) {
            emitWorker(7 /* YieldStar */ , [
                expression
            ], location);
        }
        function emitYield(expression, location) {
            emitWorker(6 /* Yield */ , [
                expression
            ], location);
        }
        function emitReturn(expression, location) {
            emitWorker(8 /* Return */ , [
                expression
            ], location);
        }
        function emitThrow(expression, location) {
            emitWorker(9 /* Throw */ , [
                expression
            ], location);
        }
        function emitEndfinally() {
            emitWorker(10 /* Endfinally */ );
        }
        function emitWorker(code, args, location) {
            if (operations === void 0) {
                operations = [];
                operationArguments = [];
                operationLocations = [];
            }
            if (labelOffsets === void 0) markLabel(defineLabel());
            const operationIndex = operations.length;
            operations[operationIndex] = code;
            operationArguments[operationIndex] = args;
            operationLocations[operationIndex] = location;
        }
        function build2() {
            blockIndex = 0;
            labelNumber = 0;
            labelNumbers = void 0;
            lastOperationWasAbrupt = false;
            lastOperationWasCompletion = false;
            clauses = void 0;
            statements = void 0;
            exceptionBlockStack = void 0;
            currentExceptionBlock = void 0;
            withBlockStack = void 0;
            const buildResult = buildStatements();
            return emitHelpers().createGeneratorHelper(setEmitFlags(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, state)
            ], /*type*/ void 0, factory2.createBlock(buildResult, /*multiLine*/ buildResult.length > 0)), 1048576 /* ReuseTempVariableScope */ ));
        }
        function buildStatements() {
            if (operations) {
                for(let operationIndex = 0; operationIndex < operations.length; operationIndex++)writeOperation(operationIndex);
                flushFinalLabel(operations.length);
            } else flushFinalLabel(0);
            if (clauses) {
                const labelExpression = factory2.createPropertyAccessExpression(state, "label");
                const switchStatement = factory2.createSwitchStatement(labelExpression, factory2.createCaseBlock(clauses));
                return [
                    startOnNewLine(switchStatement)
                ];
            }
            if (statements) return statements;
            return [];
        }
        function flushLabel() {
            if (!statements) return;
            appendLabel(/*markLabelEnd*/ !lastOperationWasAbrupt);
            lastOperationWasAbrupt = false;
            lastOperationWasCompletion = false;
            labelNumber++;
        }
        function flushFinalLabel(operationIndex) {
            if (isFinalLabelReachable(operationIndex)) {
                tryEnterLabel(operationIndex);
                withBlockStack = void 0;
                writeReturn(/*expression*/ void 0, /*operationLocation*/ void 0);
            }
            if (statements && clauses) appendLabel(/*markLabelEnd*/ false);
            updateLabelExpressions();
        }
        function isFinalLabelReachable(operationIndex) {
            if (!lastOperationWasCompletion) return true;
            if (!labelOffsets || !labelExpressions) return false;
            for(let label = 0; label < labelOffsets.length; label++){
                if (labelOffsets[label] === operationIndex && labelExpressions[label]) return true;
            }
            return false;
        }
        function appendLabel(markLabelEnd) {
            if (!clauses) clauses = [];
            if (statements) {
                if (withBlockStack) for(let i = withBlockStack.length - 1; i >= 0; i--){
                    const withBlock = withBlockStack[i];
                    statements = [
                        factory2.createWithStatement(withBlock.expression, factory2.createBlock(statements))
                    ];
                }
                if (currentExceptionBlock) {
                    const { startLabel, catchLabel, finallyLabel, endLabel } = currentExceptionBlock;
                    statements.unshift(factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createPropertyAccessExpression(state, "trys"), "push"), /*typeArguments*/ void 0, [
                        factory2.createArrayLiteralExpression([
                            createLabel(startLabel),
                            createLabel(catchLabel),
                            createLabel(finallyLabel),
                            createLabel(endLabel)
                        ])
                    ])));
                    currentExceptionBlock = void 0;
                }
                if (markLabelEnd) statements.push(factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(state, "label"), factory2.createNumericLiteral(labelNumber + 1))));
            }
            clauses.push(factory2.createCaseClause(factory2.createNumericLiteral(labelNumber), statements || []));
            statements = void 0;
        }
        function tryEnterLabel(operationIndex) {
            if (!labelOffsets) return;
            for(let label = 0; label < labelOffsets.length; label++)if (labelOffsets[label] === operationIndex) {
                flushLabel();
                if (labelNumbers === void 0) labelNumbers = [];
                if (labelNumbers[labelNumber] === void 0) labelNumbers[labelNumber] = [
                    label
                ];
                else labelNumbers[labelNumber].push(label);
            }
        }
        function updateLabelExpressions() {
            if (labelExpressions !== void 0 && labelNumbers !== void 0) for(let labelNumber2 = 0; labelNumber2 < labelNumbers.length; labelNumber2++){
                const labels = labelNumbers[labelNumber2];
                if (labels !== void 0) for (const label of labels){
                    const expressions = labelExpressions[label];
                    if (expressions !== void 0) for (const expression of expressions)expression.text = String(labelNumber2);
                }
            }
        }
        function tryEnterOrLeaveBlock(operationIndex) {
            if (blocks) for(; blockIndex < blockActions.length && blockOffsets[blockIndex] <= operationIndex; blockIndex++){
                const block = blocks[blockIndex];
                const blockAction = blockActions[blockIndex];
                switch(block.kind){
                    case 0 /* Exception */ :
                        if (blockAction === 0 /* Open */ ) {
                            if (!exceptionBlockStack) exceptionBlockStack = [];
                            if (!statements) statements = [];
                            exceptionBlockStack.push(currentExceptionBlock);
                            currentExceptionBlock = block;
                        } else if (blockAction === 1 /* Close */ ) currentExceptionBlock = exceptionBlockStack.pop();
                        break;
                    case 1 /* With */ :
                        if (blockAction === 0 /* Open */ ) {
                            if (!withBlockStack) withBlockStack = [];
                            withBlockStack.push(block);
                        } else if (blockAction === 1 /* Close */ ) withBlockStack.pop();
                        break;
                }
            }
        }
        function writeOperation(operationIndex) {
            tryEnterLabel(operationIndex);
            tryEnterOrLeaveBlock(operationIndex);
            if (lastOperationWasAbrupt) return;
            lastOperationWasAbrupt = false;
            lastOperationWasCompletion = false;
            const opcode = operations[operationIndex];
            if (opcode === 0 /* Nop */ ) return;
            else if (opcode === 10 /* Endfinally */ ) return writeEndfinally();
            const args = operationArguments[operationIndex];
            if (opcode === 1 /* Statement */ ) return writeStatement(args[0]);
            const location = operationLocations[operationIndex];
            switch(opcode){
                case 2 /* Assign */ :
                    return writeAssign(args[0], args[1], location);
                case 3 /* Break */ :
                    return writeBreak(args[0], location);
                case 4 /* BreakWhenTrue */ :
                    return writeBreakWhenTrue(args[0], args[1], location);
                case 5 /* BreakWhenFalse */ :
                    return writeBreakWhenFalse(args[0], args[1], location);
                case 6 /* Yield */ :
                    return writeYield(args[0], location);
                case 7 /* YieldStar */ :
                    return writeYieldStar(args[0], location);
                case 8 /* Return */ :
                    return writeReturn(args[0], location);
                case 9 /* Throw */ :
                    return writeThrow(args[0], location);
            }
        }
        function writeStatement(statement) {
            if (statement) {
                if (!statements) statements = [
                    statement
                ];
                else statements.push(statement);
            }
        }
        function writeAssign(left, right, operationLocation) {
            writeStatement(setTextRange(factory2.createExpressionStatement(factory2.createAssignment(left, right)), operationLocation));
        }
        function writeThrow(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            lastOperationWasCompletion = true;
            writeStatement(setTextRange(factory2.createThrowStatement(expression), operationLocation));
        }
        function writeReturn(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            lastOperationWasCompletion = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression(expression ? [
                createInstruction(2 /* Return */ ),
                expression
            ] : [
                createInstruction(2 /* Return */ )
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeBreak(label, operationLocation) {
            lastOperationWasAbrupt = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeBreakWhenTrue(label, condition, operationLocation) {
            writeStatement(setEmitFlags(factory2.createIfStatement(condition, setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), operationLocation), 768 /* NoTokenSourceMaps */ )), 1 /* SingleLine */ ));
        }
        function writeBreakWhenFalse(label, condition, operationLocation) {
            writeStatement(setEmitFlags(factory2.createIfStatement(factory2.createLogicalNot(condition), setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(3 /* Break */ ),
                createLabel(label)
            ])), operationLocation), 768 /* NoTokenSourceMaps */ )), 1 /* SingleLine */ ));
        }
        function writeYield(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression(expression ? [
                createInstruction(4 /* Yield */ ),
                expression
            ] : [
                createInstruction(4 /* Yield */ )
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeYieldStar(expression, operationLocation) {
            lastOperationWasAbrupt = true;
            writeStatement(setEmitFlags(setTextRange(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(5 /* YieldStar */ ),
                expression
            ])), operationLocation), 768 /* NoTokenSourceMaps */ ));
        }
        function writeEndfinally() {
            lastOperationWasAbrupt = true;
            writeStatement(factory2.createReturnStatement(factory2.createArrayLiteralExpression([
                createInstruction(7 /* Endfinally */ )
            ])));
        }
    }
    // src/compiler/transformers/module/module.ts
    function transformModule(context) {
        function getTransformModuleDelegate(moduleKind2) {
            switch(moduleKind2){
                case 2 /* AMD */ :
                    return transformAMDModule;
                case 3 /* UMD */ :
                    return transformUMDModule;
                default:
                    return transformCommonJSModule;
            }
        }
        const { factory: factory2, getEmitHelperFactory: emitHelpers, startLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const compilerOptions = context.getCompilerOptions();
        const resolver = context.getEmitResolver();
        const host = context.getEmitHost();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.enableSubstitution(214 /* CallExpression */ );
        context.enableSubstitution(216 /* TaggedTemplateExpression */ );
        context.enableSubstitution(80 /* Identifier */ );
        context.enableSubstitution(227 /* BinaryExpression */ );
        context.enableSubstitution(305 /* ShorthandPropertyAssignment */ );
        context.enableEmitNotification(308 /* SourceFile */ );
        const moduleInfoMap = [];
        let currentSourceFile;
        let currentModuleInfo;
        let importsAndRequiresToRewriteOrShim;
        const noSubstitution = [];
        let needUMDDynamicImportHelper;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile || !(isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 8388608 /* ContainsDynamicImport */  || isJsonSourceFile(node) && hasJsonModuleEmitEnabled(compilerOptions) && compilerOptions.outFile)) return node;
            currentSourceFile = node;
            currentModuleInfo = collectExternalModuleInfo(context, node);
            moduleInfoMap[getOriginalNodeId(node)] = currentModuleInfo;
            if (compilerOptions.rewriteRelativeImportExtensions) forEachDynamicImportOrRequireCall(node, /*includeTypeSpaceImports*/ false, /*requireStringLiteralLikeArgument*/ false, (node2)=>{
                if (!isStringLiteralLike(node2.arguments[0]) || shouldRewriteModuleSpecifier(node2.arguments[0].text, compilerOptions)) importsAndRequiresToRewriteOrShim = append(importsAndRequiresToRewriteOrShim, node2);
            });
            const transformModule2 = getTransformModuleDelegate(moduleKind);
            const updated = transformModule2(node);
            currentSourceFile = void 0;
            currentModuleInfo = void 0;
            needUMDDynamicImportHelper = false;
            return updated;
        }
        function shouldEmitUnderscoreUnderscoreESModule() {
            if (hasJSFileExtension(currentSourceFile.fileName) && currentSourceFile.commonJsModuleIndicator && (!currentSourceFile.externalModuleIndicator || currentSourceFile.externalModuleIndicator === true)) return false;
            if (!currentModuleInfo.exportEquals && isExternalModule(currentSourceFile)) return true;
            return false;
        }
        function transformCommonJSModule(node) {
            startLexicalEnvironment();
            const statements = [];
            const ensureUseStrict = getStrictOptionValue(compilerOptions, "alwaysStrict") || isExternalModule(currentSourceFile);
            const statementOffset = factory2.copyPrologue(node.statements, statements, ensureUseStrict && !isJsonSourceFile(node), topLevelVisitor);
            if (shouldEmitUnderscoreUnderscoreESModule()) append(statements, createUnderscoreUnderscoreESModule());
            if (some(currentModuleInfo.exportedNames)) {
                const chunkSize = 50;
                for(let i = 0; i < currentModuleInfo.exportedNames.length; i += chunkSize)append(statements, factory2.createExpressionStatement(reduceLeft(currentModuleInfo.exportedNames.slice(i, i + chunkSize), (prev, nextId)=>nextId.kind === 11 /* StringLiteral */  ? factory2.createAssignment(factory2.createElementAccessExpression(factory2.createIdentifier("exports"), factory2.createStringLiteral(nextId.text)), prev) : factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.createIdentifier(idText(nextId))), prev), factory2.createVoidZero())));
            }
            for (const f of currentModuleInfo.exportedFunctions)appendExportsOfHoistedDeclaration(statements, f);
            append(statements, visitNode(currentModuleInfo.externalHelpersImportDeclaration, topLevelVisitor, isStatement));
            addRange(statements, visitNodes2(node.statements, topLevelVisitor, isStatement, statementOffset));
            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ false);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const updated = factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray(statements), node.statements));
            addEmitHelpers(updated, context.readEmitHelpers());
            return updated;
        }
        function transformAMDModule(node) {
            const define = factory2.createIdentifier("define");
            const moduleName = tryGetModuleNameFromFile(factory2, node, host, compilerOptions);
            const jsonSourceFile = isJsonSourceFile(node) && node;
            const { aliasedModuleNames, unaliasedModuleNames, importAliasNames } = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ true);
            const updated = factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray([
                factory2.createExpressionStatement(factory2.createCallExpression(define, /*typeArguments*/ void 0, [
                    // Add the module name (if provided).
                    ...moduleName ? [
                        moduleName
                    ] : [],
                    // Add the dependency array argument:
                    //
                    //     ["require", "exports", module1", "module2", ...]
                    factory2.createArrayLiteralExpression(jsonSourceFile ? emptyArray : [
                        factory2.createStringLiteral("require"),
                        factory2.createStringLiteral("exports"),
                        ...aliasedModuleNames,
                        ...unaliasedModuleNames
                    ]),
                    // Add the module body function argument:
                    //
                    //     function (require, exports, module1, module2) ...
                    jsonSourceFile ? jsonSourceFile.statements.length ? jsonSourceFile.statements[0].expression : factory2.createObjectLiteralExpression() : factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "require"),
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "exports"),
                        ...importAliasNames
                    ], /*type*/ void 0, transformAsynchronousModuleBody(node))
                ]))
            ]), /*location*/ node.statements));
            addEmitHelpers(updated, context.readEmitHelpers());
            return updated;
        }
        function transformUMDModule(node) {
            const { aliasedModuleNames, unaliasedModuleNames, importAliasNames } = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ false);
            const moduleName = tryGetModuleNameFromFile(factory2, node, host, compilerOptions);
            const umdHeader = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "factory")
            ], /*type*/ void 0, setTextRange(factory2.createBlock([
                factory2.createIfStatement(factory2.createLogicalAnd(factory2.createTypeCheck(factory2.createIdentifier("module"), "object"), factory2.createTypeCheck(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), "object")), factory2.createBlock([
                    factory2.createVariableStatement(/*modifiers*/ void 0, [
                        factory2.createVariableDeclaration("v", /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.createIdentifier("factory"), /*typeArguments*/ void 0, [
                            factory2.createIdentifier("require"),
                            factory2.createIdentifier("exports")
                        ]))
                    ]),
                    setEmitFlags(factory2.createIfStatement(factory2.createStrictInequality(factory2.createIdentifier("v"), factory2.createIdentifier("undefined")), factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), factory2.createIdentifier("v")))), 1 /* SingleLine */ )
                ]), factory2.createIfStatement(factory2.createLogicalAnd(factory2.createTypeCheck(factory2.createIdentifier("define"), "function"), factory2.createPropertyAccessExpression(factory2.createIdentifier("define"), "amd")), factory2.createBlock([
                    factory2.createExpressionStatement(factory2.createCallExpression(factory2.createIdentifier("define"), /*typeArguments*/ void 0, [
                        // Add the module name (if provided).
                        ...moduleName ? [
                            moduleName
                        ] : [],
                        factory2.createArrayLiteralExpression([
                            factory2.createStringLiteral("require"),
                            factory2.createStringLiteral("exports"),
                            ...aliasedModuleNames,
                            ...unaliasedModuleNames
                        ]),
                        factory2.createIdentifier("factory")
                    ]))
                ])))
            ], /*multiLine*/ true), /*location*/ void 0));
            const updated = factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray([
                factory2.createExpressionStatement(factory2.createCallExpression(umdHeader, /*typeArguments*/ void 0, [
                    // Add the module body function argument:
                    //
                    //     function (require, exports) ...
                    factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "require"),
                        factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "exports"),
                        ...importAliasNames
                    ], /*type*/ void 0, transformAsynchronousModuleBody(node))
                ]))
            ]), /*location*/ node.statements));
            addEmitHelpers(updated, context.readEmitHelpers());
            return updated;
        }
        function collectAsynchronousDependencies(node, includeNonAmdDependencies) {
            const aliasedModuleNames = [];
            const unaliasedModuleNames = [];
            const importAliasNames = [];
            for (const amdDependency of node.amdDependencies)if (amdDependency.name) {
                aliasedModuleNames.push(factory2.createStringLiteral(amdDependency.path));
                importAliasNames.push(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, amdDependency.name));
            } else unaliasedModuleNames.push(factory2.createStringLiteral(amdDependency.path));
            for (const importNode of currentModuleInfo.externalImports){
                const externalModuleName = getExternalModuleNameLiteral(factory2, importNode, currentSourceFile, host, resolver, compilerOptions);
                const importAliasName = getLocalNameForExternalImport(factory2, importNode, currentSourceFile);
                if (externalModuleName) {
                    if (includeNonAmdDependencies && importAliasName) {
                        setEmitFlags(importAliasName, 8 /* NoSubstitution */ );
                        aliasedModuleNames.push(externalModuleName);
                        importAliasNames.push(factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, importAliasName));
                    } else unaliasedModuleNames.push(externalModuleName);
                }
            }
            return {
                aliasedModuleNames,
                unaliasedModuleNames,
                importAliasNames
            };
        }
        function getAMDImportExpressionForImport(node) {
            if (isImportEqualsDeclaration(node) || isExportDeclaration(node) || !getExternalModuleNameLiteral(factory2, node, currentSourceFile, host, resolver, compilerOptions)) return void 0;
            const name = getLocalNameForExternalImport(factory2, node, currentSourceFile);
            const expr = getHelperExpressionForImport(node, name);
            if (expr === name) return void 0;
            return factory2.createExpressionStatement(factory2.createAssignment(name, expr));
        }
        function transformAsynchronousModuleBody(node) {
            startLexicalEnvironment();
            const statements = [];
            const statementOffset = factory2.copyPrologue(node.statements, statements, /*ensureUseStrict*/ true, topLevelVisitor);
            if (shouldEmitUnderscoreUnderscoreESModule()) append(statements, createUnderscoreUnderscoreESModule());
            if (some(currentModuleInfo.exportedNames)) append(statements, factory2.createExpressionStatement(reduceLeft(currentModuleInfo.exportedNames, (prev, nextId)=>nextId.kind === 11 /* StringLiteral */  ? factory2.createAssignment(factory2.createElementAccessExpression(factory2.createIdentifier("exports"), factory2.createStringLiteral(nextId.text)), prev) : factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.createIdentifier(idText(nextId))), prev), factory2.createVoidZero())));
            for (const f of currentModuleInfo.exportedFunctions)appendExportsOfHoistedDeclaration(statements, f);
            append(statements, visitNode(currentModuleInfo.externalHelpersImportDeclaration, topLevelVisitor, isStatement));
            if (moduleKind === 2 /* AMD */ ) addRange(statements, mapDefined(currentModuleInfo.externalImports, getAMDImportExpressionForImport));
            addRange(statements, visitNodes2(node.statements, topLevelVisitor, isStatement, statementOffset));
            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ true);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const body = factory2.createBlock(statements, /*multiLine*/ true);
            if (needUMDDynamicImportHelper) addEmitHelper(body, dynamicImportUMDHelper);
            return body;
        }
        function addExportEqualsIfNeeded(statements, emitAsReturn) {
            if (currentModuleInfo.exportEquals) {
                const expressionResult = visitNode(currentModuleInfo.exportEquals.expression, visitor, isExpression);
                if (expressionResult) {
                    if (emitAsReturn) {
                        const statement = factory2.createReturnStatement(expressionResult);
                        setTextRange(statement, currentModuleInfo.exportEquals);
                        setEmitFlags(statement, 3840 /* NoComments */ );
                        statements.push(statement);
                    } else {
                        const statement = factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), expressionResult));
                        setTextRange(statement, currentModuleInfo.exportEquals);
                        setEmitFlags(statement, 3072 /* NoComments */ );
                        statements.push(statement);
                    }
                }
            }
        }
        function topLevelVisitor(node) {
            switch(node.kind){
                case 273 /* ImportDeclaration */ :
                    return visitTopLevelImportDeclaration(node);
                case 272 /* ImportEqualsDeclaration */ :
                    return visitTopLevelImportEqualsDeclaration(node);
                case 279 /* ExportDeclaration */ :
                    return visitTopLevelExportDeclaration(node);
                case 278 /* ExportAssignment */ :
                    return visitTopLevelExportAssignment(node);
                default:
                    return topLevelNestedVisitor(node);
            }
        }
        function topLevelNestedVisitor(node) {
            switch(node.kind){
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 263 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 249 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ true);
                case 250 /* ForInStatement */ :
                    return visitForInStatement(node);
                case 251 /* ForOfStatement */ :
                    return visitForOfStatement(node);
                case 247 /* DoStatement */ :
                    return visitDoStatement(node);
                case 248 /* WhileStatement */ :
                    return visitWhileStatement(node);
                case 257 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 255 /* WithStatement */ :
                    return visitWithStatement(node);
                case 246 /* IfStatement */ :
                    return visitIfStatement(node);
                case 256 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 270 /* CaseBlock */ :
                    return visitCaseBlock(node);
                case 297 /* CaseClause */ :
                    return visitCaseClause(node);
                case 298 /* DefaultClause */ :
                    return visitDefaultClause(node);
                case 259 /* TryStatement */ :
                    return visitTryStatement(node);
                case 300 /* CatchClause */ :
                    return visitCatchClause(node);
                case 242 /* Block */ :
                    return visitBlock(node);
                default:
                    return visitor(node);
            }
        }
        function visitorWorker(node, valueIsDiscarded) {
            if (!(node.transformFlags & 276828160 /* ContainsUpdateExpressionForIdentifier */ ) && !(importsAndRequiresToRewriteOrShim == null ? void 0 : importsAndRequiresToRewriteOrShim.length)) return node;
            switch(node.kind){
                case 249 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ false);
                case 245 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, valueIsDiscarded);
                case 356 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, valueIsDiscarded);
                case 214 /* CallExpression */ :
                    const needsRewrite = node === firstOrUndefined(importsAndRequiresToRewriteOrShim);
                    if (needsRewrite) importsAndRequiresToRewriteOrShim.shift();
                    if (isImportCall(node) && host.shouldTransformImportCall(currentSourceFile)) return visitImportCallExpression(node, needsRewrite);
                    else if (needsRewrite) return shimOrRewriteImportOrRequireCall(node);
                    break;
                case 227 /* BinaryExpression */ :
                    if (isDestructuringAssignment(node)) return visitDestructuringAssignment(node, valueIsDiscarded);
                    break;
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    return visitPreOrPostfixUnaryExpression(node, valueIsDiscarded);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ false);
        }
        function discardedValueVisitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ true);
        }
        function destructuringNeedsFlattening(node) {
            if (isObjectLiteralExpression(node)) for (const elem of node.properties)switch(elem.kind){
                case 304 /* PropertyAssignment */ :
                    if (destructuringNeedsFlattening(elem.initializer)) return true;
                    break;
                case 305 /* ShorthandPropertyAssignment */ :
                    if (destructuringNeedsFlattening(elem.name)) return true;
                    break;
                case 306 /* SpreadAssignment */ :
                    if (destructuringNeedsFlattening(elem.expression)) return true;
                    break;
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return false;
                default:
                    Debug.assertNever(elem, "Unhandled object member kind");
            }
            else if (isArrayLiteralExpression(node)) for (const elem of node.elements){
                if (isSpreadElement(elem)) {
                    if (destructuringNeedsFlattening(elem.expression)) return true;
                } else if (destructuringNeedsFlattening(elem)) return true;
            }
            else if (isIdentifier(node)) return length(getExports(node)) > (isExportName(node) ? 1 : 0);
            return false;
        }
        function visitDestructuringAssignment(node, valueIsDiscarded) {
            if (destructuringNeedsFlattening(node.left)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , !valueIsDiscarded, createAllExportExpressions);
            return visitEachChild(node, visitor, context);
        }
        function visitForStatement(node, isTopLevel) {
            if (isTopLevel && node.initializer && isVariableDeclarationList(node.initializer) && !(node.initializer.flags & 7 /* BlockScoped */ )) {
                const exportStatements = appendExportsOfVariableDeclarationList(/*statements*/ void 0, node.initializer, /*isForInOrOfInitializer*/ false);
                if (exportStatements) {
                    const statements = [];
                    const varDeclList = visitNode(node.initializer, discardedValueVisitor, isVariableDeclarationList);
                    const varStatement = factory2.createVariableStatement(/*modifiers*/ void 0, varDeclList);
                    statements.push(varStatement);
                    addRange(statements, exportStatements);
                    const condition = visitNode(node.condition, visitor, isExpression);
                    const incrementor = visitNode(node.incrementor, discardedValueVisitor, isExpression);
                    const body = visitIterationBody(node.statement, isTopLevel ? topLevelNestedVisitor : visitor, context);
                    statements.push(factory2.updateForStatement(node, /*initializer*/ void 0, condition, incrementor, body));
                    return statements;
                }
            }
            return factory2.updateForStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, isTopLevel ? topLevelNestedVisitor : visitor, context));
        }
        function visitForInStatement(node) {
            if (isVariableDeclarationList(node.initializer) && !(node.initializer.flags & 7 /* BlockScoped */ )) {
                const exportStatements = appendExportsOfVariableDeclarationList(/*statements*/ void 0, node.initializer, /*isForInOrOfInitializer*/ true);
                if (some(exportStatements)) {
                    const initializer = visitNode(node.initializer, discardedValueVisitor, isForInitializer);
                    const expression = visitNode(node.expression, visitor, isExpression);
                    const body = visitIterationBody(node.statement, topLevelNestedVisitor, context);
                    const mergedBody = isBlock(body) ? factory2.updateBlock(body, [
                        ...exportStatements,
                        ...body.statements
                    ]) : factory2.createBlock([
                        ...exportStatements,
                        body
                    ], /*multiLine*/ true);
                    return factory2.updateForInStatement(node, initializer, expression, mergedBody);
                }
            }
            return factory2.updateForInStatement(node, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitForOfStatement(node) {
            if (isVariableDeclarationList(node.initializer) && !(node.initializer.flags & 7 /* BlockScoped */ )) {
                const exportStatements = appendExportsOfVariableDeclarationList(/*statements*/ void 0, node.initializer, /*isForInOrOfInitializer*/ true);
                const initializer = visitNode(node.initializer, discardedValueVisitor, isForInitializer);
                const expression = visitNode(node.expression, visitor, isExpression);
                let body = visitIterationBody(node.statement, topLevelNestedVisitor, context);
                if (some(exportStatements)) body = isBlock(body) ? factory2.updateBlock(body, [
                    ...exportStatements,
                    ...body.statements
                ]) : factory2.createBlock([
                    ...exportStatements,
                    body
                ], /*multiLine*/ true);
                return factory2.updateForOfStatement(node, node.awaitModifier, initializer, expression, body);
            }
            return factory2.updateForOfStatement(node, node.awaitModifier, visitNode(node.initializer, discardedValueVisitor, isForInitializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitDoStatement(node) {
            return factory2.updateDoStatement(node, visitIterationBody(node.statement, topLevelNestedVisitor, context), visitNode(node.expression, visitor, isExpression));
        }
        function visitWhileStatement(node) {
            return factory2.updateWhileStatement(node, visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitLabeledStatement(node) {
            var _visitNode;
            return factory2.updateLabeledStatement(node, node.label, (_visitNode = visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)) !== null && _visitNode !== void 0 ? _visitNode : setTextRange(factory2.createEmptyStatement(), node.statement));
        }
        function visitWithStatement(node) {
            return factory2.updateWithStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)));
        }
        function visitIfStatement(node) {
            var _visitNode;
            return factory2.updateIfStatement(node, visitNode(node.expression, visitor, isExpression), (_visitNode = visitNode(node.thenStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)) !== null && _visitNode !== void 0 ? _visitNode : factory2.createBlock([]), visitNode(node.elseStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock));
        }
        function visitSwitchStatement(node) {
            return factory2.updateSwitchStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.caseBlock, topLevelNestedVisitor, isCaseBlock)));
        }
        function visitCaseBlock(node) {
            return factory2.updateCaseBlock(node, visitNodes2(node.clauses, topLevelNestedVisitor, isCaseOrDefaultClause));
        }
        function visitCaseClause(node) {
            return factory2.updateCaseClause(node, visitNode(node.expression, visitor, isExpression), visitNodes2(node.statements, topLevelNestedVisitor, isStatement));
        }
        function visitDefaultClause(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitTryStatement(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitCatchClause(node) {
            return factory2.updateCatchClause(node, node.variableDeclaration, Debug.checkDefined(visitNode(node.block, topLevelNestedVisitor, isBlock)));
        }
        function visitBlock(node) {
            node = visitEachChild(node, topLevelNestedVisitor, context);
            return node;
        }
        function visitExpressionStatement(node) {
            return factory2.updateExpressionStatement(node, visitNode(node.expression, discardedValueVisitor, isExpression));
        }
        function visitParenthesizedExpression(node, valueIsDiscarded) {
            return factory2.updateParenthesizedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitPartiallyEmittedExpression(node, valueIsDiscarded) {
            return factory2.updatePartiallyEmittedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitPreOrPostfixUnaryExpression(node, valueIsDiscarded) {
            if ((node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) && isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand) && !isDeclarationNameOfEnumOrNamespace(node.operand)) {
                const exportedNames = getExports(node.operand);
                if (exportedNames) {
                    let temp;
                    let expression = visitNode(node.operand, visitor, isExpression);
                    if (isPrefixUnaryExpression(node)) expression = factory2.updatePrefixUnaryExpression(node, expression);
                    else {
                        expression = factory2.updatePostfixUnaryExpression(node, expression);
                        if (!valueIsDiscarded) {
                            temp = factory2.createTempVariable(hoistVariableDeclaration);
                            expression = factory2.createAssignment(temp, expression);
                            setTextRange(expression, node);
                        }
                        expression = factory2.createComma(expression, factory2.cloneNode(node.operand));
                        setTextRange(expression, node);
                    }
                    for (const exportName of exportedNames){
                        noSubstitution[getNodeId(expression)] = true;
                        expression = createExportExpression(exportName, expression);
                        setTextRange(expression, node);
                    }
                    if (temp) {
                        noSubstitution[getNodeId(expression)] = true;
                        expression = factory2.createComma(expression, temp);
                        setTextRange(expression, node);
                    }
                    return expression;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function shimOrRewriteImportOrRequireCall(node) {
            return factory2.updateCallExpression(node, node.expression, /*typeArguments*/ void 0, visitNodes2(node.arguments, (arg)=>{
                if (arg === node.arguments[0]) return isStringLiteralLike(arg) ? rewriteModuleSpecifier(arg, compilerOptions) : emitHelpers().createRewriteRelativeImportExtensionsHelper(arg);
                return visitor(arg);
            }, isExpression));
        }
        function visitImportCallExpression(node, rewriteOrShim) {
            if (moduleKind === 0 /* None */  && languageVersion >= 7 /* ES2020 */ ) return visitEachChild(node, visitor, context);
            const externalModuleName = getExternalModuleNameLiteral(factory2, node, currentSourceFile, host, resolver, compilerOptions);
            const firstArgument = visitNode(firstOrUndefined(node.arguments), visitor, isExpression);
            const argument = externalModuleName && (!firstArgument || !isStringLiteral(firstArgument) || firstArgument.text !== externalModuleName.text) ? externalModuleName : firstArgument && rewriteOrShim ? isStringLiteral(firstArgument) ? rewriteModuleSpecifier(firstArgument, compilerOptions) : emitHelpers().createRewriteRelativeImportExtensionsHelper(firstArgument) : firstArgument;
            const containsLexicalThis = !!(node.transformFlags & 16384 /* ContainsLexicalThis */ );
            switch(compilerOptions.module){
                case 2 /* AMD */ :
                    return createImportCallExpressionAMD(argument, containsLexicalThis);
                case 3 /* UMD */ :
                    return createImportCallExpressionUMD(argument !== null && argument !== void 0 ? argument : factory2.createVoidZero(), containsLexicalThis);
                case 1 /* CommonJS */ :
                default:
                    return createImportCallExpressionCommonJS(argument);
            }
        }
        function createImportCallExpressionUMD(arg, containsLexicalThis) {
            needUMDDynamicImportHelper = true;
            if (isSimpleCopiableExpression(arg)) {
                const argClone = isGeneratedIdentifier(arg) ? arg : isStringLiteral(arg) ? factory2.createStringLiteralFromNode(arg) : setEmitFlags(setTextRange(factory2.cloneNode(arg), arg), 3072 /* NoComments */ );
                return factory2.createConditionalExpression(/*condition*/ factory2.createIdentifier("__syncRequire"), /*questionToken*/ void 0, /*whenTrue*/ createImportCallExpressionCommonJS(arg), /*colonToken*/ void 0, /*whenFalse*/ createImportCallExpressionAMD(argClone, containsLexicalThis));
            } else {
                const temp = factory2.createTempVariable(hoistVariableDeclaration);
                return factory2.createComma(factory2.createAssignment(temp, arg), factory2.createConditionalExpression(/*condition*/ factory2.createIdentifier("__syncRequire"), /*questionToken*/ void 0, /*whenTrue*/ createImportCallExpressionCommonJS(temp, /*isInlineable*/ true), /*colonToken*/ void 0, /*whenFalse*/ createImportCallExpressionAMD(temp, containsLexicalThis)));
            }
        }
        function createImportCallExpressionAMD(arg, containsLexicalThis) {
            const resolve = factory2.createUniqueName("resolve");
            const reject = factory2.createUniqueName("reject");
            const parameters = [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ resolve),
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ reject)
            ];
            const body = factory2.createBlock([
                factory2.createExpressionStatement(factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, [
                    factory2.createArrayLiteralExpression([
                        arg || factory2.createOmittedExpression()
                    ]),
                    resolve,
                    reject
                ]))
            ]);
            let func;
            if (languageVersion >= 2 /* ES2015 */ ) func = factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, body);
            else {
                func = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
                if (containsLexicalThis) setEmitFlags(func, 16 /* CapturesThis */ );
            }
            const promise = factory2.createNewExpression(factory2.createIdentifier("Promise"), /*typeArguments*/ void 0, [
                func
            ]);
            if (getESModuleInterop(compilerOptions)) return factory2.createCallExpression(factory2.createPropertyAccessExpression(promise, factory2.createIdentifier("then")), /*typeArguments*/ void 0, [
                emitHelpers().createImportStarCallbackHelper()
            ]);
            return promise;
        }
        function createImportCallExpressionCommonJS(arg, isInlineable) {
            const needSyncEval = arg && !isSimpleInlineableExpression(arg) && !isInlineable;
            const promiseResolveCall = factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Promise"), "resolve"), /*typeArguments*/ void 0, /*argumentsArray*/ needSyncEval ? languageVersion >= 2 /* ES2015 */  ? [
                factory2.createTemplateExpression(factory2.createTemplateHead(""), [
                    factory2.createTemplateSpan(arg, factory2.createTemplateTail(""))
                ])
            ] : [
                factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createStringLiteral(""), "concat"), /*typeArguments*/ void 0, [
                    arg
                ])
            ] : []);
            let requireCall = factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, needSyncEval ? [
                factory2.createIdentifier("s")
            ] : arg ? [
                arg
            ] : []);
            if (getESModuleInterop(compilerOptions)) requireCall = emitHelpers().createImportStarHelper(requireCall);
            const parameters = needSyncEval ? [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ "s")
            ] : [];
            let func;
            if (languageVersion >= 2 /* ES2015 */ ) func = factory2.createArrowFunction(/*modifiers*/ void 0, /*typeParameters*/ void 0, /*parameters*/ parameters, /*type*/ void 0, /*equalsGreaterThanToken*/ void 0, requireCall);
            else func = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ parameters, /*type*/ void 0, factory2.createBlock([
                factory2.createReturnStatement(requireCall)
            ]));
            const downleveledImport = factory2.createCallExpression(factory2.createPropertyAccessExpression(promiseResolveCall, "then"), /*typeArguments*/ void 0, [
                func
            ]);
            return downleveledImport;
        }
        function getHelperExpressionForExport(node, innerExpr) {
            if (!getESModuleInterop(compilerOptions) || getInternalEmitFlags(node) & 2 /* NeverApplyImportHelper */ ) return innerExpr;
            if (getExportNeedsImportStarHelper(node)) return emitHelpers().createImportStarHelper(innerExpr);
            return innerExpr;
        }
        function getHelperExpressionForImport(node, innerExpr) {
            if (!getESModuleInterop(compilerOptions) || getInternalEmitFlags(node) & 2 /* NeverApplyImportHelper */ ) return innerExpr;
            if (getImportNeedsImportStarHelper(node)) return emitHelpers().createImportStarHelper(innerExpr);
            if (getImportNeedsImportDefaultHelper(node)) return emitHelpers().createImportDefaultHelper(innerExpr);
            return innerExpr;
        }
        function visitTopLevelImportDeclaration(node) {
            let statements;
            const namespaceDeclaration = getNamespaceDeclarationNode(node);
            if (moduleKind !== 2 /* AMD */ ) {
                if (!node.importClause) return setOriginalNode(setTextRange(factory2.createExpressionStatement(createRequireCall2(node)), node), node);
                else {
                    const variables = [];
                    if (namespaceDeclaration && !isDefaultImport(node)) variables.push(factory2.createVariableDeclaration(factory2.cloneNode(namespaceDeclaration.name), /*exclamationToken*/ void 0, /*type*/ void 0, getHelperExpressionForImport(node, createRequireCall2(node))));
                    else {
                        variables.push(factory2.createVariableDeclaration(factory2.getGeneratedNameForNode(node), /*exclamationToken*/ void 0, /*type*/ void 0, getHelperExpressionForImport(node, createRequireCall2(node))));
                        if (namespaceDeclaration && isDefaultImport(node)) variables.push(factory2.createVariableDeclaration(factory2.cloneNode(namespaceDeclaration.name), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.getGeneratedNameForNode(node)));
                    }
                    statements = append(statements, setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(variables, languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )), /*location*/ node), /*original*/ node));
                }
            } else if (namespaceDeclaration && isDefaultImport(node)) statements = append(statements, factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                setOriginalNode(setTextRange(factory2.createVariableDeclaration(factory2.cloneNode(namespaceDeclaration.name), /*exclamationToken*/ void 0, /*type*/ void 0, factory2.getGeneratedNameForNode(node)), /*location*/ node), /*original*/ node)
            ], languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )));
            statements = appendExportsOfImportDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function createRequireCall2(importNode) {
            const moduleName = getExternalModuleNameLiteral(factory2, importNode, currentSourceFile, host, resolver, compilerOptions);
            const args = [];
            if (moduleName) args.push(rewriteModuleSpecifier(moduleName, compilerOptions));
            return factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, args);
        }
        function visitTopLevelImportEqualsDeclaration(node) {
            Debug.assert(isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
            let statements;
            if (moduleKind !== 2 /* AMD */ ) {
                if (hasSyntacticModifier(node, 32 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(node.name, createRequireCall2(node))), node), node));
                else statements = append(statements, setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(factory2.cloneNode(node.name), /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall2(node))
                ], /*flags*/ languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )), node), node));
            } else if (hasSyntacticModifier(node, 32 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(factory2.getExportName(node), factory2.getLocalName(node))), node), node));
            statements = appendExportsOfImportEqualsDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitTopLevelExportDeclaration(node) {
            if (!node.moduleSpecifier) return void 0;
            const generatedName = factory2.getGeneratedNameForNode(node);
            if (node.exportClause && isNamedExports(node.exportClause)) {
                const statements = [];
                if (moduleKind !== 2 /* AMD */ ) statements.push(setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(generatedName, /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall2(node))
                ])), /*location*/ node), /* original */ node));
                for (const specifier of node.exportClause.elements){
                    const specifierName = specifier.propertyName || specifier.name;
                    const exportNeedsImportDefault = !!getESModuleInterop(compilerOptions) && !(getInternalEmitFlags(node) & 2 /* NeverApplyImportHelper */ ) && moduleExportNameIsDefault(specifierName);
                    const target = exportNeedsImportDefault ? emitHelpers().createImportDefaultHelper(generatedName) : generatedName;
                    const exportedValue = specifierName.kind === 11 /* StringLiteral */  ? factory2.createElementAccessExpression(target, specifierName) : factory2.createPropertyAccessExpression(target, specifierName);
                    statements.push(setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(specifier.name.kind === 11 /* StringLiteral */  ? factory2.cloneNode(specifier.name) : factory2.getExportName(specifier), exportedValue, /*location*/ void 0, /*liveBinding*/ true)), specifier), specifier));
                }
                return singleOrMany(statements);
            } else if (node.exportClause) {
                const statements = [];
                statements.push(setOriginalNode(setTextRange(factory2.createExpressionStatement(createExportExpression(factory2.cloneNode(node.exportClause.name), getHelperExpressionForExport(node, moduleKind !== 2 /* AMD */  ? createRequireCall2(node) : isExportNamespaceAsDefaultDeclaration(node) ? generatedName : node.exportClause.name.kind === 11 /* StringLiteral */  ? generatedName : factory2.createIdentifier(idText(node.exportClause.name))))), node), node));
                return singleOrMany(statements);
            } else return setOriginalNode(setTextRange(factory2.createExpressionStatement(emitHelpers().createExportStarHelper(moduleKind !== 2 /* AMD */  ? createRequireCall2(node) : generatedName)), node), node);
        }
        function visitTopLevelExportAssignment(node) {
            if (node.isExportEquals) return void 0;
            return createExportStatement(factory2.createIdentifier("default"), visitNode(node.expression, visitor, isExpression), /*location*/ node, /*allowComments*/ true);
        }
        function visitFunctionDeclaration(node) {
            let statements;
            if (hasSyntacticModifier(node, 32 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createFunctionDeclaration(visitNodes2(node.modifiers, modifierVisitor, isModifier), node.asteriskToken, factory2.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), /*typeParameters*/ void 0, visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitEachChild(node.body, visitor, context)), /*location*/ node), /*original*/ node));
            else statements = append(statements, visitEachChild(node, visitor, context));
            return singleOrMany(statements);
        }
        function visitClassDeclaration(node) {
            let statements;
            if (hasSyntacticModifier(node, 32 /* Export */ )) statements = append(statements, setOriginalNode(setTextRange(factory2.createClassDeclaration(visitNodes2(node.modifiers, modifierVisitor, isModifierLike), factory2.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, visitor, isClassElement)), node), node));
            else statements = append(statements, visitEachChild(node, visitor, context));
            statements = appendExportsOfHoistedDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitVariableStatement(node) {
            let statements;
            let variables;
            let expressions;
            if (hasSyntacticModifier(node, 32 /* Export */ )) {
                let modifiers;
                let removeCommentsOnExpressions = false;
                for (const variable of node.declarationList.declarations){
                    if (isIdentifier(variable.name) && isLocalName(variable.name)) {
                        if (!modifiers) modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifier);
                        if (variable.initializer) {
                            const updatedVariable = factory2.updateVariableDeclaration(variable, variable.name, /*exclamationToken*/ void 0, /*type*/ void 0, createExportExpression(variable.name, visitNode(variable.initializer, visitor, isExpression)));
                            variables = append(variables, updatedVariable);
                        } else variables = append(variables, variable);
                    } else if (variable.initializer) {
                        if (!isBindingPattern(variable.name) && (isArrowFunction(variable.initializer) || isFunctionExpression(variable.initializer) || isClassExpression(variable.initializer))) {
                            const expression = factory2.createAssignment(setTextRange(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), variable.name), /*location*/ variable.name), factory2.createIdentifier(getTextOfIdentifierOrLiteral(variable.name)));
                            const updatedVariable = factory2.createVariableDeclaration(variable.name, variable.exclamationToken, variable.type, visitNode(variable.initializer, visitor, isExpression));
                            variables = append(variables, updatedVariable);
                            expressions = append(expressions, expression);
                            removeCommentsOnExpressions = true;
                        } else expressions = append(expressions, transformInitializedVariable(variable));
                    }
                }
                if (variables) statements = append(statements, factory2.updateVariableStatement(node, modifiers, factory2.updateVariableDeclarationList(node.declarationList, variables)));
                if (expressions) {
                    const statement = setOriginalNode(setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(expressions)), node), node);
                    if (removeCommentsOnExpressions) removeAllComments(statement);
                    statements = append(statements, statement);
                }
            } else statements = append(statements, visitEachChild(node, visitor, context));
            statements = appendExportsOfVariableStatement(statements, node);
            return singleOrMany(statements);
        }
        function createAllExportExpressions(name, value1, location) {
            const exportedNames = getExports(name);
            if (exportedNames) {
                let expression = isExportName(name) ? value1 : factory2.createAssignment(name, value1);
                for (const exportName of exportedNames){
                    setEmitFlags(expression, 8 /* NoSubstitution */ );
                    expression = createExportExpression(exportName, expression, /*location*/ location);
                }
                return expression;
            }
            return factory2.createAssignment(name, value1);
        }
        function transformInitializedVariable(node) {
            if (isBindingPattern(node.name)) return flattenDestructuringAssignment(visitNode(node, visitor, isInitializedVariable), visitor, context, 0 /* All */ , /*needsValue*/ false, createAllExportExpressions);
            else return factory2.createAssignment(setTextRange(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), node.name), /*location*/ node.name), node.initializer ? visitNode(node.initializer, visitor, isExpression) : factory2.createVoidZero());
        }
        function appendExportsOfImportDeclaration(statements, decl) {
            if (currentModuleInfo.exportEquals) return statements;
            const importClause = decl.importClause;
            if (!importClause) return statements;
            const seen = new IdentifierNameMap();
            if (importClause.name) statements = appendExportsOfDeclaration(statements, seen, importClause);
            const namedBindings = importClause.namedBindings;
            if (namedBindings) switch(namedBindings.kind){
                case 275 /* NamespaceImport */ :
                    statements = appendExportsOfDeclaration(statements, seen, namedBindings);
                    break;
                case 276 /* NamedImports */ :
                    for (const importBinding of namedBindings.elements)statements = appendExportsOfDeclaration(statements, seen, importBinding, /*liveBinding*/ true);
                    break;
            }
            return statements;
        }
        function appendExportsOfImportEqualsDeclaration(statements, decl) {
            if (currentModuleInfo.exportEquals) return statements;
            return appendExportsOfDeclaration(statements, new IdentifierNameMap(), decl);
        }
        function appendExportsOfVariableStatement(statements, node) {
            return appendExportsOfVariableDeclarationList(statements, node.declarationList, /*isForInOrOfInitializer*/ false);
        }
        function appendExportsOfVariableDeclarationList(statements, node, isForInOrOfInitializer) {
            if (currentModuleInfo.exportEquals) return statements;
            for (const decl of node.declarations)statements = appendExportsOfBindingElement(statements, decl, isForInOrOfInitializer);
            return statements;
        }
        function appendExportsOfBindingElement(statements, decl, isForInOrOfInitializer) {
            if (currentModuleInfo.exportEquals) return statements;
            if (isBindingPattern(decl.name)) {
                for (const element of decl.name.elements)if (!isOmittedExpression(element)) statements = appendExportsOfBindingElement(statements, element, isForInOrOfInitializer);
            } else if (!isGeneratedIdentifier(decl.name) && (!isVariableDeclaration(decl) || decl.initializer || isForInOrOfInitializer)) statements = appendExportsOfDeclaration(statements, new IdentifierNameMap(), decl);
            return statements;
        }
        function appendExportsOfHoistedDeclaration(statements, decl) {
            if (currentModuleInfo.exportEquals) return statements;
            const seen = new IdentifierNameMap();
            if (hasSyntacticModifier(decl, 32 /* Export */ )) {
                const exportName = hasSyntacticModifier(decl, 2048 /* Default */ ) ? factory2.createIdentifier("default") : factory2.getDeclarationName(decl);
                statements = appendExportStatement(statements, seen, exportName, factory2.getLocalName(decl), /*location*/ decl);
            }
            if (decl.name) statements = appendExportsOfDeclaration(statements, seen, decl);
            return statements;
        }
        function appendExportsOfDeclaration(statements, seen, decl, liveBinding) {
            const name = factory2.getDeclarationName(decl);
            const exportSpecifiers = currentModuleInfo.exportSpecifiers.get(name);
            if (exportSpecifiers) for (const exportSpecifier of exportSpecifiers)statements = appendExportStatement(statements, seen, exportSpecifier.name, name, /*location*/ exportSpecifier.name, /*allowComments*/ void 0, liveBinding);
            return statements;
        }
        function appendExportStatement(statements, seen, exportName, expression, location, allowComments, liveBinding) {
            if (exportName.kind !== 11 /* StringLiteral */ ) {
                if (seen.has(exportName)) return statements;
                seen.set(exportName, true);
            }
            statements = append(statements, createExportStatement(exportName, expression, location, allowComments, liveBinding));
            return statements;
        }
        function createUnderscoreUnderscoreESModule() {
            const statement = factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "defineProperty"), /*typeArguments*/ void 0, [
                factory2.createIdentifier("exports"),
                factory2.createStringLiteral("__esModule"),
                factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("value", factory2.createTrue())
                ])
            ]));
            setEmitFlags(statement, 2097152 /* CustomPrologue */ );
            return statement;
        }
        function createExportStatement(name, value1, location, allowComments, liveBinding) {
            const statement = setTextRange(factory2.createExpressionStatement(createExportExpression(name, value1, /*location*/ void 0, liveBinding)), location);
            startOnNewLine(statement);
            if (!allowComments) setEmitFlags(statement, 3072 /* NoComments */ );
            return statement;
        }
        function createExportExpression(name, value1, location, liveBinding) {
            return setTextRange(liveBinding ? factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("Object"), "defineProperty"), /*typeArguments*/ void 0, [
                factory2.createIdentifier("exports"),
                factory2.createStringLiteralFromNode(name),
                factory2.createObjectLiteralExpression([
                    factory2.createPropertyAssignment("enumerable", factory2.createTrue()),
                    factory2.createPropertyAssignment("get", factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, factory2.createBlock([
                        factory2.createReturnStatement(value1)
                    ])))
                ])
            ]) : factory2.createAssignment(name.kind === 11 /* StringLiteral */  ? factory2.createElementAccessExpression(factory2.createIdentifier("exports"), factory2.cloneNode(name)) : factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.cloneNode(name)), value1), location);
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 95 /* ExportKeyword */ :
                case 90 /* DefaultKeyword */ :
                    return void 0;
            }
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            if (node.kind === 308 /* SourceFile */ ) {
                currentSourceFile = node;
                currentModuleInfo = moduleInfoMap[getOriginalNodeId(currentSourceFile)];
                previousOnEmitNode(hint, node, emitCallback);
                currentSourceFile = void 0;
                currentModuleInfo = void 0;
            } else previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (node.id && noSubstitution[node.id]) return node;
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            else if (isShorthandPropertyAssignment(node)) return substituteShorthandPropertyAssignment(node);
            return node;
        }
        function substituteShorthandPropertyAssignment(node) {
            const name = node.name;
            const exportedOrImportedName = substituteExpressionIdentifier(name);
            if (exportedOrImportedName !== name) {
                if (node.objectAssignmentInitializer) {
                    const initializer = factory2.createAssignment(exportedOrImportedName, node.objectAssignmentInitializer);
                    return setTextRange(factory2.createPropertyAssignment(name, initializer), node);
                }
                return setTextRange(factory2.createPropertyAssignment(name, exportedOrImportedName), node);
            }
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 214 /* CallExpression */ :
                    return substituteCallExpression(node);
                case 216 /* TaggedTemplateExpression */ :
                    return substituteTaggedTemplateExpression(node);
                case 227 /* BinaryExpression */ :
                    return substituteBinaryExpression(node);
            }
            return node;
        }
        function substituteCallExpression(node) {
            if (isIdentifier(node.expression)) {
                const expression = substituteExpressionIdentifier(node.expression);
                noSubstitution[getNodeId(expression)] = true;
                if (!isIdentifier(expression) && !(getEmitFlags(node.expression) & 8192 /* HelperName */ )) return addInternalEmitFlags(factory2.updateCallExpression(node, expression, /*typeArguments*/ void 0, node.arguments), 16 /* IndirectCall */ );
            }
            return node;
        }
        function substituteTaggedTemplateExpression(node) {
            if (isIdentifier(node.tag)) {
                const tag = substituteExpressionIdentifier(node.tag);
                noSubstitution[getNodeId(tag)] = true;
                if (!isIdentifier(tag) && !(getEmitFlags(node.tag) & 8192 /* HelperName */ )) return addInternalEmitFlags(factory2.updateTaggedTemplateExpression(node, tag, /*typeArguments*/ void 0, node.template), 16 /* IndirectCall */ );
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            var _a, _b;
            if (getEmitFlags(node) & 8192 /* HelperName */ ) {
                const externalHelpersModuleName = getExternalHelpersModuleName(currentSourceFile);
                if (externalHelpersModuleName) return factory2.createPropertyAccessExpression(externalHelpersModuleName, node);
                return node;
            } else if (!(isGeneratedIdentifier(node) && !(node.emitNode.autoGenerate.flags & 64 /* AllowNameSubstitution */ )) && !isLocalName(node)) {
                const exportContainer = resolver.getReferencedExportContainer(node, isExportName(node));
                if (exportContainer && exportContainer.kind === 308 /* SourceFile */ ) return setTextRange(factory2.createPropertyAccessExpression(factory2.createIdentifier("exports"), factory2.cloneNode(node)), /*location*/ node);
                const importDeclaration = resolver.getReferencedImportDeclaration(node);
                if (importDeclaration) {
                    if (isImportClause(importDeclaration)) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(importDeclaration.parent), factory2.createIdentifier("default")), /*location*/ node);
                    else if (isImportSpecifier(importDeclaration)) {
                        const name = importDeclaration.propertyName || importDeclaration.name;
                        const target = factory2.getGeneratedNameForNode(((_b = (_a = importDeclaration.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent) || importDeclaration);
                        return setTextRange(name.kind === 11 /* StringLiteral */  ? factory2.createElementAccessExpression(target, factory2.cloneNode(name)) : factory2.createPropertyAccessExpression(target, factory2.cloneNode(name)), /*location*/ node);
                    }
                }
            }
            return node;
        }
        function substituteBinaryExpression(node) {
            if (isAssignmentOperator(node.operatorToken.kind) && isIdentifier(node.left) && (!isGeneratedIdentifier(node.left) || isFileLevelReservedGeneratedIdentifier(node.left)) && !isLocalName(node.left)) {
                const exportedNames = getExports(node.left);
                if (exportedNames) {
                    let expression = node;
                    for (const exportName of exportedNames){
                        noSubstitution[getNodeId(expression)] = true;
                        expression = createExportExpression(exportName, expression, /*location*/ node);
                    }
                    return expression;
                }
            }
            return node;
        }
        function getExports(name) {
            if (!isGeneratedIdentifier(name)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(name);
                if (importDeclaration) return currentModuleInfo == null ? void 0 : currentModuleInfo.exportedBindings[getOriginalNodeId(importDeclaration)];
                const bindingsSet = /* @__PURE__ */ new Set();
                const declarations = resolver.getReferencedValueDeclarations(name);
                if (declarations) {
                    for (const declaration of declarations){
                        const bindings = currentModuleInfo == null ? void 0 : currentModuleInfo.exportedBindings[getOriginalNodeId(declaration)];
                        if (bindings) for (const binding of bindings)bindingsSet.add(binding);
                    }
                    if (bindingsSet.size) return arrayFrom(bindingsSet);
                }
            } else if (isFileLevelReservedGeneratedIdentifier(name)) {
                const exportSpecifiers = currentModuleInfo == null ? void 0 : currentModuleInfo.exportSpecifiers.get(name);
                if (exportSpecifiers) {
                    const exportedNames = [];
                    for (const exportSpecifier of exportSpecifiers)exportedNames.push(exportSpecifier.name);
                    return exportedNames;
                }
            }
        }
    }
    var dynamicImportUMDHelper = {
        name: "typescript:dynamicimport-sync-require",
        scoped: true,
        text: `
            var __syncRequire = typeof module === "object" && typeof module.exports === "object";`
    };
    // src/compiler/transformers/module/system.ts
    function transformSystemModule(context) {
        const { factory: factory2, startLexicalEnvironment, endLexicalEnvironment, hoistVariableDeclaration } = context;
        const compilerOptions = context.getCompilerOptions();
        const resolver = context.getEmitResolver();
        const host = context.getEmitHost();
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.enableSubstitution(80 /* Identifier */ );
        context.enableSubstitution(305 /* ShorthandPropertyAssignment */ );
        context.enableSubstitution(227 /* BinaryExpression */ );
        context.enableSubstitution(237 /* MetaProperty */ );
        context.enableEmitNotification(308 /* SourceFile */ );
        const moduleInfoMap = [];
        const exportFunctionsMap = [];
        const noSubstitutionMap = [];
        const contextObjectMap = [];
        let currentSourceFile;
        let moduleInfo;
        let exportFunction;
        let contextObject;
        let hoistedStatements;
        let enclosingBlockScopedContainer;
        let noSubstitution;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile || !(isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 8388608 /* ContainsDynamicImport */ )) return node;
            const id = getOriginalNodeId(node);
            currentSourceFile = node;
            enclosingBlockScopedContainer = node;
            moduleInfo = moduleInfoMap[id] = collectExternalModuleInfo(context, node);
            exportFunction = factory2.createUniqueName("exports");
            exportFunctionsMap[id] = exportFunction;
            contextObject = contextObjectMap[id] = factory2.createUniqueName("context");
            const dependencyGroups = collectDependencyGroups(moduleInfo.externalImports);
            const moduleBodyBlock = createSystemModuleBody(node, dependencyGroups);
            const moduleBodyFunction = factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, exportFunction),
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, contextObject)
            ], /*type*/ void 0, moduleBodyBlock);
            const moduleName = tryGetModuleNameFromFile(factory2, node, host, compilerOptions);
            const dependencies = factory2.createArrayLiteralExpression(map(dependencyGroups, (dependencyGroup)=>dependencyGroup.name));
            const updated = setEmitFlags(factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray([
                factory2.createExpressionStatement(factory2.createCallExpression(factory2.createPropertyAccessExpression(factory2.createIdentifier("System"), "register"), /*typeArguments*/ void 0, moduleName ? [
                    moduleName,
                    dependencies,
                    moduleBodyFunction
                ] : [
                    dependencies,
                    moduleBodyFunction
                ]))
            ]), node.statements)), 2048 /* NoTrailingComments */ );
            if (!compilerOptions.outFile) moveEmitHelpers(updated, moduleBodyBlock, (helper)=>!helper.scoped);
            if (noSubstitution) {
                noSubstitutionMap[id] = noSubstitution;
                noSubstitution = void 0;
            }
            currentSourceFile = void 0;
            moduleInfo = void 0;
            exportFunction = void 0;
            contextObject = void 0;
            hoistedStatements = void 0;
            enclosingBlockScopedContainer = void 0;
            return updated;
        }
        function collectDependencyGroups(externalImports) {
            const groupIndices = /* @__PURE__ */ new Map();
            const dependencyGroups = [];
            for (const externalImport of externalImports){
                const externalModuleName = getExternalModuleNameLiteral(factory2, externalImport, currentSourceFile, host, resolver, compilerOptions);
                if (externalModuleName) {
                    const text = externalModuleName.text;
                    const groupIndex = groupIndices.get(text);
                    if (groupIndex !== void 0) dependencyGroups[groupIndex].externalImports.push(externalImport);
                    else {
                        groupIndices.set(text, dependencyGroups.length);
                        dependencyGroups.push({
                            name: externalModuleName,
                            externalImports: [
                                externalImport
                            ]
                        });
                    }
                }
            }
            return dependencyGroups;
        }
        function createSystemModuleBody(node, dependencyGroups) {
            const statements = [];
            startLexicalEnvironment();
            const ensureUseStrict = getStrictOptionValue(compilerOptions, "alwaysStrict") || isExternalModule(currentSourceFile);
            const statementOffset = factory2.copyPrologue(node.statements, statements, ensureUseStrict, topLevelVisitor);
            statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration("__moduleName", /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createLogicalAnd(contextObject, factory2.createPropertyAccessExpression(contextObject, "id")))
            ])));
            visitNode(moduleInfo.externalHelpersImportDeclaration, topLevelVisitor, isStatement);
            const executeStatements = visitNodes2(node.statements, topLevelVisitor, isStatement, statementOffset);
            addRange(statements, hoistedStatements);
            insertStatementsAfterStandardPrologue(statements, endLexicalEnvironment());
            const exportStarFunction = addExportStarIfNeeded(statements);
            const modifiers = node.transformFlags & 2097152 /* ContainsAwait */  ? factory2.createModifiersFromModifierFlags(1024 /* Async */ ) : void 0;
            const moduleObject = factory2.createObjectLiteralExpression([
                factory2.createPropertyAssignment("setters", createSettersArray(exportStarFunction, dependencyGroups)),
                factory2.createPropertyAssignment("execute", factory2.createFunctionExpression(modifiers, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, /*parameters*/ [], /*type*/ void 0, factory2.createBlock(executeStatements, /*multiLine*/ true)))
            ], /*multiLine*/ true);
            statements.push(factory2.createReturnStatement(moduleObject));
            return factory2.createBlock(statements, /*multiLine*/ true);
        }
        function addExportStarIfNeeded(statements) {
            if (!moduleInfo.hasExportStarsToExportValues) return;
            if (!some(moduleInfo.exportedNames) && moduleInfo.exportedFunctions.size === 0 && moduleInfo.exportSpecifiers.size === 0) {
                let hasExportDeclarationWithExportClause = false;
                for (const externalImport of moduleInfo.externalImports)if (externalImport.kind === 279 /* ExportDeclaration */  && externalImport.exportClause) {
                    hasExportDeclarationWithExportClause = true;
                    break;
                }
                if (!hasExportDeclarationWithExportClause) {
                    const exportStarFunction2 = createExportStarFunction(/*localNames*/ void 0);
                    statements.push(exportStarFunction2);
                    return exportStarFunction2.name;
                }
            }
            const exportedNames = [];
            if (moduleInfo.exportedNames) for (const exportedLocalName of moduleInfo.exportedNames){
                if (moduleExportNameIsDefault(exportedLocalName)) continue;
                exportedNames.push(factory2.createPropertyAssignment(factory2.createStringLiteralFromNode(exportedLocalName), factory2.createTrue()));
            }
            for (const f of moduleInfo.exportedFunctions){
                if (hasSyntacticModifier(f, 2048 /* Default */ )) continue;
                Debug.assert(!!f.name);
                exportedNames.push(factory2.createPropertyAssignment(factory2.createStringLiteralFromNode(f.name), factory2.createTrue()));
            }
            const exportedNamesStorageRef = factory2.createUniqueName("exportedNames");
            statements.push(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(exportedNamesStorageRef, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createObjectLiteralExpression(exportedNames, /*multiLine*/ true))
            ])));
            const exportStarFunction = createExportStarFunction(exportedNamesStorageRef);
            statements.push(exportStarFunction);
            return exportStarFunction.name;
        }
        function createExportStarFunction(localNames) {
            const exportStarFunction = factory2.createUniqueName("exportStar");
            const m = factory2.createIdentifier("m");
            const n = factory2.createIdentifier("n");
            const exports2 = factory2.createIdentifier("exports");
            let condition = factory2.createStrictInequality(n, factory2.createStringLiteral("default"));
            if (localNames) condition = factory2.createLogicalAnd(condition, factory2.createLogicalNot(factory2.createCallExpression(factory2.createPropertyAccessExpression(localNames, "hasOwnProperty"), /*typeArguments*/ void 0, [
                n
            ])));
            return factory2.createFunctionDeclaration(/*modifiers*/ void 0, /*asteriskToken*/ void 0, exportStarFunction, /*typeParameters*/ void 0, [
                factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, m)
            ], /*type*/ void 0, factory2.createBlock([
                factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(exports2, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createObjectLiteralExpression([]))
                ])),
                factory2.createForInStatement(factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(n)
                ]), m, factory2.createBlock([
                    setEmitFlags(factory2.createIfStatement(condition, factory2.createExpressionStatement(factory2.createAssignment(factory2.createElementAccessExpression(exports2, n), factory2.createElementAccessExpression(m, n)))), 1 /* SingleLine */ )
                ])),
                factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                    exports2
                ]))
            ], /*multiLine*/ true));
        }
        function createSettersArray(exportStarFunction, dependencyGroups) {
            const setters = [];
            for (const group2 of dependencyGroups){
                const localName = forEach(group2.externalImports, (i)=>getLocalNameForExternalImport(factory2, i, currentSourceFile));
                const parameterName = localName ? factory2.getGeneratedNameForNode(localName) : factory2.createUniqueName("");
                const statements = [];
                for (const entry of group2.externalImports){
                    const importVariableName = getLocalNameForExternalImport(factory2, entry, currentSourceFile);
                    switch(entry.kind){
                        case 273 /* ImportDeclaration */ :
                            if (!entry.importClause) break;
                        // falls through
                        case 272 /* ImportEqualsDeclaration */ :
                            Debug.assert(importVariableName !== void 0);
                            statements.push(factory2.createExpressionStatement(factory2.createAssignment(importVariableName, parameterName)));
                            if (hasSyntacticModifier(entry, 32 /* Export */ )) statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                                factory2.createStringLiteral(idText(importVariableName)),
                                parameterName
                            ])));
                            break;
                        case 279 /* ExportDeclaration */ :
                            Debug.assert(importVariableName !== void 0);
                            if (entry.exportClause) {
                                if (isNamedExports(entry.exportClause)) {
                                    const properties = [];
                                    for (const e of entry.exportClause.elements)properties.push(factory2.createPropertyAssignment(factory2.createStringLiteral(moduleExportNameTextUnescaped(e.name)), factory2.createElementAccessExpression(parameterName, factory2.createStringLiteral(moduleExportNameTextUnescaped(e.propertyName || e.name)))));
                                    statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                                        factory2.createObjectLiteralExpression(properties, /*multiLine*/ true)
                                    ])));
                                } else statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                                    factory2.createStringLiteral(moduleExportNameTextUnescaped(entry.exportClause.name)),
                                    parameterName
                                ])));
                            } else statements.push(factory2.createExpressionStatement(factory2.createCallExpression(exportStarFunction, /*typeArguments*/ void 0, [
                                parameterName
                            ])));
                            break;
                    }
                }
                setters.push(factory2.createFunctionExpression(/*modifiers*/ void 0, /*asteriskToken*/ void 0, /*name*/ void 0, /*typeParameters*/ void 0, [
                    factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, parameterName)
                ], /*type*/ void 0, factory2.createBlock(statements, /*multiLine*/ true)));
            }
            return factory2.createArrayLiteralExpression(setters, /*multiLine*/ true);
        }
        function topLevelVisitor(node) {
            switch(node.kind){
                case 273 /* ImportDeclaration */ :
                    return visitImportDeclaration(node);
                case 272 /* ImportEqualsDeclaration */ :
                    return visitImportEqualsDeclaration(node);
                case 279 /* ExportDeclaration */ :
                    return visitExportDeclaration(node);
                case 278 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                default:
                    return topLevelNestedVisitor(node);
            }
        }
        function visitImportDeclaration(node) {
            let statements;
            if (node.importClause) hoistVariableDeclaration(getLocalNameForExternalImport(factory2, node, currentSourceFile));
            return singleOrMany(appendExportsOfImportDeclaration(statements, node));
        }
        function visitExportDeclaration(node) {
            Debug.assertIsDefined(node);
            return void 0;
        }
        function visitImportEqualsDeclaration(node) {
            Debug.assert(isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
            let statements;
            hoistVariableDeclaration(getLocalNameForExternalImport(factory2, node, currentSourceFile));
            return singleOrMany(appendExportsOfImportEqualsDeclaration(statements, node));
        }
        function visitExportAssignment(node) {
            if (node.isExportEquals) return void 0;
            const expression = visitNode(node.expression, visitor, isExpression);
            return createExportStatement(factory2.createIdentifier("default"), expression, /*allowComments*/ true);
        }
        function visitFunctionDeclaration(node) {
            if (hasSyntacticModifier(node, 32 /* Export */ )) hoistedStatements = append(hoistedStatements, factory2.updateFunctionDeclaration(node, visitNodes2(node.modifiers, modifierVisitor, isModifierLike), node.asteriskToken, factory2.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), /*typeParameters*/ void 0, visitNodes2(node.parameters, visitor, isParameter), /*type*/ void 0, visitNode(node.body, visitor, isBlock)));
            else hoistedStatements = append(hoistedStatements, visitEachChild(node, visitor, context));
            hoistedStatements = appendExportsOfHoistedDeclaration(hoistedStatements, node);
            return void 0;
        }
        function visitClassDeclaration(node) {
            let statements;
            const name = factory2.getLocalName(node);
            hoistVariableDeclaration(name);
            statements = append(statements, setTextRange(factory2.createExpressionStatement(factory2.createAssignment(name, setTextRange(factory2.createClassExpression(visitNodes2(node.modifiers, modifierVisitor, isModifierLike), node.name, /*typeParameters*/ void 0, visitNodes2(node.heritageClauses, visitor, isHeritageClause), visitNodes2(node.members, visitor, isClassElement)), node))), node));
            statements = appendExportsOfHoistedDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function visitVariableStatement(node) {
            if (!shouldHoistVariableDeclarationList(node.declarationList)) return visitNode(node, visitor, isStatement);
            let statements;
            if (isVarUsing(node.declarationList) || isVarAwaitUsing(node.declarationList)) {
                const modifiers = visitNodes2(node.modifiers, modifierVisitor, isModifierLike);
                const declarations = [];
                for (const variable of node.declarationList.declarations)declarations.push(factory2.updateVariableDeclaration(variable, factory2.getGeneratedNameForNode(variable.name), /*exclamationToken*/ void 0, /*type*/ void 0, transformInitializedVariable(variable, /*isExportedDeclaration*/ false)));
                const declarationList = factory2.updateVariableDeclarationList(node.declarationList, declarations);
                statements = append(statements, factory2.updateVariableStatement(node, modifiers, declarationList));
            } else {
                let expressions;
                const isExportedDeclaration = hasSyntacticModifier(node, 32 /* Export */ );
                for (const variable of node.declarationList.declarations)if (variable.initializer) expressions = append(expressions, transformInitializedVariable(variable, isExportedDeclaration));
                else hoistBindingElement(variable);
                if (expressions) statements = append(statements, setTextRange(factory2.createExpressionStatement(factory2.inlineExpressions(expressions)), node));
            }
            statements = appendExportsOfVariableStatement(statements, node, /*exportSelf*/ false);
            return singleOrMany(statements);
        }
        function hoistBindingElement(node) {
            if (isBindingPattern(node.name)) {
                for (const element of node.name.elements)if (!isOmittedExpression(element)) hoistBindingElement(element);
            } else hoistVariableDeclaration(factory2.cloneNode(node.name));
        }
        function shouldHoistVariableDeclarationList(node) {
            return (getEmitFlags(node) & 4194304 /* NoHoisting */ ) === 0 && (enclosingBlockScopedContainer.kind === 308 /* SourceFile */  || (getOriginalNode(node).flags & 7 /* BlockScoped */ ) === 0);
        }
        function transformInitializedVariable(node, isExportedDeclaration) {
            const createAssignment = isExportedDeclaration ? createExportedVariableAssignment : createNonExportedVariableAssignment;
            return isBindingPattern(node.name) ? flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , /*needsValue*/ false, createAssignment) : node.initializer ? createAssignment(node.name, visitNode(node.initializer, visitor, isExpression)) : node.name;
        }
        function createExportedVariableAssignment(name, value1, location) {
            return createVariableAssignment(name, value1, location, /*isExportedDeclaration*/ true);
        }
        function createNonExportedVariableAssignment(name, value1, location) {
            return createVariableAssignment(name, value1, location, /*isExportedDeclaration*/ false);
        }
        function createVariableAssignment(name, value1, location, isExportedDeclaration) {
            hoistVariableDeclaration(factory2.cloneNode(name));
            return isExportedDeclaration ? createExportExpression(name, preventSubstitution(setTextRange(factory2.createAssignment(name, value1), location))) : preventSubstitution(setTextRange(factory2.createAssignment(name, value1), location));
        }
        function appendExportsOfImportDeclaration(statements, decl) {
            if (moduleInfo.exportEquals) return statements;
            const importClause = decl.importClause;
            if (!importClause) return statements;
            if (importClause.name) statements = appendExportsOfDeclaration(statements, importClause);
            const namedBindings = importClause.namedBindings;
            if (namedBindings) switch(namedBindings.kind){
                case 275 /* NamespaceImport */ :
                    statements = appendExportsOfDeclaration(statements, namedBindings);
                    break;
                case 276 /* NamedImports */ :
                    for (const importBinding of namedBindings.elements)statements = appendExportsOfDeclaration(statements, importBinding);
                    break;
            }
            return statements;
        }
        function appendExportsOfImportEqualsDeclaration(statements, decl) {
            if (moduleInfo.exportEquals) return statements;
            return appendExportsOfDeclaration(statements, decl);
        }
        function appendExportsOfVariableStatement(statements, node, exportSelf) {
            if (moduleInfo.exportEquals) return statements;
            for (const decl of node.declarationList.declarations)if (decl.initializer || exportSelf) statements = appendExportsOfBindingElement(statements, decl, exportSelf);
            return statements;
        }
        function appendExportsOfBindingElement(statements, decl, exportSelf) {
            if (moduleInfo.exportEquals) return statements;
            if (isBindingPattern(decl.name)) {
                for (const element of decl.name.elements)if (!isOmittedExpression(element)) statements = appendExportsOfBindingElement(statements, element, exportSelf);
            } else if (!isGeneratedIdentifier(decl.name)) {
                let excludeName;
                if (exportSelf) {
                    statements = appendExportStatement(statements, decl.name, factory2.getLocalName(decl));
                    excludeName = idText(decl.name);
                }
                statements = appendExportsOfDeclaration(statements, decl, excludeName);
            }
            return statements;
        }
        function appendExportsOfHoistedDeclaration(statements, decl) {
            if (moduleInfo.exportEquals) return statements;
            let excludeName;
            if (hasSyntacticModifier(decl, 32 /* Export */ )) {
                const exportName = hasSyntacticModifier(decl, 2048 /* Default */ ) ? factory2.createStringLiteral("default") : decl.name;
                statements = appendExportStatement(statements, exportName, factory2.getLocalName(decl));
                excludeName = getTextOfIdentifierOrLiteral(exportName);
            }
            if (decl.name) statements = appendExportsOfDeclaration(statements, decl, excludeName);
            return statements;
        }
        function appendExportsOfDeclaration(statements, decl, excludeName) {
            if (moduleInfo.exportEquals) return statements;
            const name = factory2.getDeclarationName(decl);
            const exportSpecifiers = moduleInfo.exportSpecifiers.get(name);
            if (exportSpecifiers) {
                for (const exportSpecifier of exportSpecifiers)if (moduleExportNameTextUnescaped(exportSpecifier.name) !== excludeName) statements = appendExportStatement(statements, exportSpecifier.name, name);
            }
            return statements;
        }
        function appendExportStatement(statements, exportName, expression, allowComments) {
            statements = append(statements, createExportStatement(exportName, expression, allowComments));
            return statements;
        }
        function createExportStatement(name, value1, allowComments) {
            const statement = factory2.createExpressionStatement(createExportExpression(name, value1));
            startOnNewLine(statement);
            if (!allowComments) setEmitFlags(statement, 3072 /* NoComments */ );
            return statement;
        }
        function createExportExpression(name, value1) {
            const exportName = isIdentifier(name) ? factory2.createStringLiteralFromNode(name) : name;
            setEmitFlags(value1, getEmitFlags(value1) | 3072 /* NoComments */ );
            return setCommentRange(factory2.createCallExpression(exportFunction, /*typeArguments*/ void 0, [
                exportName,
                value1
            ]), value1);
        }
        function topLevelNestedVisitor(node) {
            switch(node.kind){
                case 244 /* VariableStatement */ :
                    return visitVariableStatement(node);
                case 263 /* FunctionDeclaration */ :
                    return visitFunctionDeclaration(node);
                case 264 /* ClassDeclaration */ :
                    return visitClassDeclaration(node);
                case 249 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ true);
                case 250 /* ForInStatement */ :
                    return visitForInStatement(node);
                case 251 /* ForOfStatement */ :
                    return visitForOfStatement(node);
                case 247 /* DoStatement */ :
                    return visitDoStatement(node);
                case 248 /* WhileStatement */ :
                    return visitWhileStatement(node);
                case 257 /* LabeledStatement */ :
                    return visitLabeledStatement(node);
                case 255 /* WithStatement */ :
                    return visitWithStatement(node);
                case 246 /* IfStatement */ :
                    return visitIfStatement(node);
                case 256 /* SwitchStatement */ :
                    return visitSwitchStatement(node);
                case 270 /* CaseBlock */ :
                    return visitCaseBlock(node);
                case 297 /* CaseClause */ :
                    return visitCaseClause(node);
                case 298 /* DefaultClause */ :
                    return visitDefaultClause(node);
                case 259 /* TryStatement */ :
                    return visitTryStatement(node);
                case 300 /* CatchClause */ :
                    return visitCatchClause(node);
                case 242 /* Block */ :
                    return visitBlock(node);
                default:
                    return visitor(node);
            }
        }
        function visitForStatement(node, isTopLevel) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateForStatement(node, visitNode(node.initializer, isTopLevel ? visitForInitializer : discardedValueVisitor, isForInitializer), visitNode(node.condition, visitor, isExpression), visitNode(node.incrementor, discardedValueVisitor, isExpression), visitIterationBody(node.statement, isTopLevel ? topLevelNestedVisitor : visitor, context));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitForInStatement(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateForInStatement(node, visitForInitializer(node.initializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitForOfStatement(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateForOfStatement(node, node.awaitModifier, visitForInitializer(node.initializer), visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function shouldHoistForInitializer(node) {
            return isVariableDeclarationList(node) && shouldHoistVariableDeclarationList(node);
        }
        function visitForInitializer(node) {
            if (shouldHoistForInitializer(node)) {
                let expressions;
                for (const variable of node.declarations){
                    expressions = append(expressions, transformInitializedVariable(variable, /*isExportedDeclaration*/ false));
                    if (!variable.initializer) hoistBindingElement(variable);
                }
                return expressions ? factory2.inlineExpressions(expressions) : factory2.createOmittedExpression();
            } else return visitNode(node, discardedValueVisitor, isForInitializer);
        }
        function visitDoStatement(node) {
            return factory2.updateDoStatement(node, visitIterationBody(node.statement, topLevelNestedVisitor, context), visitNode(node.expression, visitor, isExpression));
        }
        function visitWhileStatement(node) {
            return factory2.updateWhileStatement(node, visitNode(node.expression, visitor, isExpression), visitIterationBody(node.statement, topLevelNestedVisitor, context));
        }
        function visitLabeledStatement(node) {
            var _visitNode;
            return factory2.updateLabeledStatement(node, node.label, (_visitNode = visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)) !== null && _visitNode !== void 0 ? _visitNode : factory2.createExpressionStatement(factory2.createIdentifier("")));
        }
        function visitWithStatement(node) {
            return factory2.updateWithStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.statement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)));
        }
        function visitIfStatement(node) {
            var _visitNode;
            return factory2.updateIfStatement(node, visitNode(node.expression, visitor, isExpression), (_visitNode = visitNode(node.thenStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock)) !== null && _visitNode !== void 0 ? _visitNode : factory2.createBlock([]), visitNode(node.elseStatement, topLevelNestedVisitor, isStatement, factory2.liftToBlock));
        }
        function visitSwitchStatement(node) {
            return factory2.updateSwitchStatement(node, visitNode(node.expression, visitor, isExpression), Debug.checkDefined(visitNode(node.caseBlock, topLevelNestedVisitor, isCaseBlock)));
        }
        function visitCaseBlock(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateCaseBlock(node, visitNodes2(node.clauses, topLevelNestedVisitor, isCaseOrDefaultClause));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitCaseClause(node) {
            return factory2.updateCaseClause(node, visitNode(node.expression, visitor, isExpression), visitNodes2(node.statements, topLevelNestedVisitor, isStatement));
        }
        function visitDefaultClause(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitTryStatement(node) {
            return visitEachChild(node, topLevelNestedVisitor, context);
        }
        function visitCatchClause(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = factory2.updateCatchClause(node, node.variableDeclaration, Debug.checkDefined(visitNode(node.block, topLevelNestedVisitor, isBlock)));
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitBlock(node) {
            const savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
            enclosingBlockScopedContainer = node;
            node = visitEachChild(node, topLevelNestedVisitor, context);
            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
            return node;
        }
        function visitorWorker(node, valueIsDiscarded) {
            if (!(node.transformFlags & 276828160 /* ContainsUpdateExpressionForIdentifier */ )) return node;
            switch(node.kind){
                case 249 /* ForStatement */ :
                    return visitForStatement(node, /*isTopLevel*/ false);
                case 245 /* ExpressionStatement */ :
                    return visitExpressionStatement(node);
                case 218 /* ParenthesizedExpression */ :
                    return visitParenthesizedExpression(node, valueIsDiscarded);
                case 356 /* PartiallyEmittedExpression */ :
                    return visitPartiallyEmittedExpression(node, valueIsDiscarded);
                case 227 /* BinaryExpression */ :
                    if (isDestructuringAssignment(node)) return visitDestructuringAssignment(node, valueIsDiscarded);
                    break;
                case 214 /* CallExpression */ :
                    if (isImportCall(node)) return visitImportCallExpression(node);
                    break;
                case 225 /* PrefixUnaryExpression */ :
                case 226 /* PostfixUnaryExpression */ :
                    return visitPrefixOrPostfixUnaryExpression(node, valueIsDiscarded);
            }
            return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ false);
        }
        function discardedValueVisitor(node) {
            return visitorWorker(node, /*valueIsDiscarded*/ true);
        }
        function visitExpressionStatement(node) {
            return factory2.updateExpressionStatement(node, visitNode(node.expression, discardedValueVisitor, isExpression));
        }
        function visitParenthesizedExpression(node, valueIsDiscarded) {
            return factory2.updateParenthesizedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitPartiallyEmittedExpression(node, valueIsDiscarded) {
            return factory2.updatePartiallyEmittedExpression(node, visitNode(node.expression, valueIsDiscarded ? discardedValueVisitor : visitor, isExpression));
        }
        function visitImportCallExpression(node) {
            const externalModuleName = getExternalModuleNameLiteral(factory2, node, currentSourceFile, host, resolver, compilerOptions);
            const firstArgument = visitNode(firstOrUndefined(node.arguments), visitor, isExpression);
            const argument = externalModuleName && (!firstArgument || !isStringLiteral(firstArgument) || firstArgument.text !== externalModuleName.text) ? externalModuleName : firstArgument;
            return factory2.createCallExpression(factory2.createPropertyAccessExpression(contextObject, factory2.createIdentifier("import")), /*typeArguments*/ void 0, argument ? [
                argument
            ] : []);
        }
        function visitDestructuringAssignment(node, valueIsDiscarded) {
            if (hasExportedReferenceInDestructuringTarget(node.left)) return flattenDestructuringAssignment(node, visitor, context, 0 /* All */ , !valueIsDiscarded);
            return visitEachChild(node, visitor, context);
        }
        function hasExportedReferenceInDestructuringTarget(node) {
            if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) return hasExportedReferenceInDestructuringTarget(node.left);
            else if (isSpreadElement(node)) return hasExportedReferenceInDestructuringTarget(node.expression);
            else if (isObjectLiteralExpression(node)) return some(node.properties, hasExportedReferenceInDestructuringTarget);
            else if (isArrayLiteralExpression(node)) return some(node.elements, hasExportedReferenceInDestructuringTarget);
            else if (isShorthandPropertyAssignment(node)) return hasExportedReferenceInDestructuringTarget(node.name);
            else if (isPropertyAssignment(node)) return hasExportedReferenceInDestructuringTarget(node.initializer);
            else if (isIdentifier(node)) {
                const container = resolver.getReferencedExportContainer(node);
                return container !== void 0 && container.kind === 308 /* SourceFile */ ;
            } else return false;
        }
        function visitPrefixOrPostfixUnaryExpression(node, valueIsDiscarded) {
            if ((node.operator === 46 /* PlusPlusToken */  || node.operator === 47 /* MinusMinusToken */ ) && isIdentifier(node.operand) && !isGeneratedIdentifier(node.operand) && !isLocalName(node.operand) && !isDeclarationNameOfEnumOrNamespace(node.operand)) {
                const exportedNames = getExports(node.operand);
                if (exportedNames) {
                    let temp;
                    let expression = visitNode(node.operand, visitor, isExpression);
                    if (isPrefixUnaryExpression(node)) expression = factory2.updatePrefixUnaryExpression(node, expression);
                    else {
                        expression = factory2.updatePostfixUnaryExpression(node, expression);
                        if (!valueIsDiscarded) {
                            temp = factory2.createTempVariable(hoistVariableDeclaration);
                            expression = factory2.createAssignment(temp, expression);
                            setTextRange(expression, node);
                        }
                        expression = factory2.createComma(expression, factory2.cloneNode(node.operand));
                        setTextRange(expression, node);
                    }
                    for (const exportName of exportedNames)expression = createExportExpression(exportName, preventSubstitution(expression));
                    if (temp) {
                        expression = factory2.createComma(expression, temp);
                        setTextRange(expression, node);
                    }
                    return expression;
                }
            }
            return visitEachChild(node, visitor, context);
        }
        function modifierVisitor(node) {
            switch(node.kind){
                case 95 /* ExportKeyword */ :
                case 90 /* DefaultKeyword */ :
                    return void 0;
            }
            return node;
        }
        function onEmitNode(hint, node, emitCallback) {
            if (node.kind === 308 /* SourceFile */ ) {
                const id = getOriginalNodeId(node);
                currentSourceFile = node;
                moduleInfo = moduleInfoMap[id];
                exportFunction = exportFunctionsMap[id];
                noSubstitution = noSubstitutionMap[id];
                contextObject = contextObjectMap[id];
                if (noSubstitution) delete noSubstitutionMap[id];
                previousOnEmitNode(hint, node, emitCallback);
                currentSourceFile = void 0;
                moduleInfo = void 0;
                exportFunction = void 0;
                contextObject = void 0;
                noSubstitution = void 0;
            } else previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (isSubstitutionPrevented(node)) return node;
            if (hint === 1 /* Expression */ ) return substituteExpression(node);
            else if (hint === 4 /* Unspecified */ ) return substituteUnspecified(node);
            return node;
        }
        function substituteUnspecified(node) {
            switch(node.kind){
                case 305 /* ShorthandPropertyAssignment */ :
                    return substituteShorthandPropertyAssignment(node);
            }
            return node;
        }
        function substituteShorthandPropertyAssignment(node) {
            var _a, _b;
            const name = node.name;
            if (!isGeneratedIdentifier(name) && !isLocalName(name)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(name);
                if (importDeclaration) {
                    if (isImportClause(importDeclaration)) return setTextRange(factory2.createPropertyAssignment(factory2.cloneNode(name), factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(importDeclaration.parent), factory2.createIdentifier("default"))), /*location*/ node);
                    else if (isImportSpecifier(importDeclaration)) {
                        const importedName = importDeclaration.propertyName || importDeclaration.name;
                        const target = factory2.getGeneratedNameForNode(((_b = (_a = importDeclaration.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent) || importDeclaration);
                        return setTextRange(factory2.createPropertyAssignment(factory2.cloneNode(name), importedName.kind === 11 /* StringLiteral */  ? factory2.createElementAccessExpression(target, factory2.cloneNode(importedName)) : factory2.createPropertyAccessExpression(target, factory2.cloneNode(importedName))), /*location*/ node);
                    }
                }
            }
            return node;
        }
        function substituteExpression(node) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    return substituteExpressionIdentifier(node);
                case 227 /* BinaryExpression */ :
                    return substituteBinaryExpression(node);
                case 237 /* MetaProperty */ :
                    return substituteMetaProperty(node);
            }
            return node;
        }
        function substituteExpressionIdentifier(node) {
            var _a, _b;
            if (getEmitFlags(node) & 8192 /* HelperName */ ) {
                const externalHelpersModuleName = getExternalHelpersModuleName(currentSourceFile);
                if (externalHelpersModuleName) return factory2.createPropertyAccessExpression(externalHelpersModuleName, node);
                return node;
            }
            if (!isGeneratedIdentifier(node) && !isLocalName(node)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(node);
                if (importDeclaration) {
                    if (isImportClause(importDeclaration)) return setTextRange(factory2.createPropertyAccessExpression(factory2.getGeneratedNameForNode(importDeclaration.parent), factory2.createIdentifier("default")), /*location*/ node);
                    else if (isImportSpecifier(importDeclaration)) {
                        const importedName = importDeclaration.propertyName || importDeclaration.name;
                        const target = factory2.getGeneratedNameForNode(((_b = (_a = importDeclaration.parent) == null ? void 0 : _a.parent) == null ? void 0 : _b.parent) || importDeclaration);
                        return setTextRange(importedName.kind === 11 /* StringLiteral */  ? factory2.createElementAccessExpression(target, factory2.cloneNode(importedName)) : factory2.createPropertyAccessExpression(target, factory2.cloneNode(importedName)), /*location*/ node);
                    }
                }
            }
            return node;
        }
        function substituteBinaryExpression(node) {
            if (isAssignmentOperator(node.operatorToken.kind) && isIdentifier(node.left) && (!isGeneratedIdentifier(node.left) || isFileLevelReservedGeneratedIdentifier(node.left)) && !isLocalName(node.left)) {
                const exportedNames = getExports(node.left);
                if (exportedNames) {
                    let expression = node;
                    for (const exportName of exportedNames)expression = createExportExpression(exportName, preventSubstitution(expression));
                    return expression;
                }
            }
            return node;
        }
        function substituteMetaProperty(node) {
            if (isImportMeta(node)) return factory2.createPropertyAccessExpression(contextObject, factory2.createIdentifier("meta"));
            return node;
        }
        function getExports(name) {
            let exportedNames;
            const valueDeclaration = getReferencedDeclaration(name);
            if (valueDeclaration) {
                const exportContainer = resolver.getReferencedExportContainer(name, /*prefixLocals*/ false);
                if (exportContainer && exportContainer.kind === 308 /* SourceFile */ ) exportedNames = append(exportedNames, factory2.getDeclarationName(valueDeclaration));
                exportedNames = addRange(exportedNames, moduleInfo == null ? void 0 : moduleInfo.exportedBindings[getOriginalNodeId(valueDeclaration)]);
            } else if (isGeneratedIdentifier(name) && isFileLevelReservedGeneratedIdentifier(name)) {
                const exportSpecifiers = moduleInfo == null ? void 0 : moduleInfo.exportSpecifiers.get(name);
                if (exportSpecifiers) {
                    const exportedNames2 = [];
                    for (const exportSpecifier of exportSpecifiers)exportedNames2.push(exportSpecifier.name);
                    return exportedNames2;
                }
            }
            return exportedNames;
        }
        function getReferencedDeclaration(name) {
            if (!isGeneratedIdentifier(name)) {
                const importDeclaration = resolver.getReferencedImportDeclaration(name);
                if (importDeclaration) return importDeclaration;
                const valueDeclaration = resolver.getReferencedValueDeclaration(name);
                if (valueDeclaration && (moduleInfo == null ? void 0 : moduleInfo.exportedBindings[getOriginalNodeId(valueDeclaration)])) return valueDeclaration;
                const declarations = resolver.getReferencedValueDeclarations(name);
                if (declarations) for (const declaration of declarations){
                    if (declaration !== valueDeclaration && (moduleInfo == null ? void 0 : moduleInfo.exportedBindings[getOriginalNodeId(declaration)])) return declaration;
                }
                return valueDeclaration;
            }
        }
        function preventSubstitution(node) {
            if (noSubstitution === void 0) noSubstitution = [];
            noSubstitution[getNodeId(node)] = true;
            return node;
        }
        function isSubstitutionPrevented(node) {
            return noSubstitution && node.id && noSubstitution[node.id];
        }
    }
    // src/compiler/transformers/module/esnextAnd2015.ts
    function transformECMAScriptModule(context) {
        const { factory: factory2, getEmitHelperFactory: emitHelpers } = context;
        const host = context.getEmitHost();
        const resolver = context.getEmitResolver();
        const compilerOptions = context.getCompilerOptions();
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const previousOnEmitNode = context.onEmitNode;
        const previousOnSubstituteNode = context.onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.onSubstituteNode = onSubstituteNode;
        context.enableEmitNotification(308 /* SourceFile */ );
        context.enableSubstitution(80 /* Identifier */ );
        const noSubstitution = /* @__PURE__ */ new Set();
        let importsAndRequiresToRewriteOrShim;
        let helperNameSubstitutions;
        let currentSourceFile;
        let importRequireStatements;
        return chainBundle(context, transformSourceFile);
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            if (isExternalModule(node) || getIsolatedModules(compilerOptions)) {
                currentSourceFile = node;
                importRequireStatements = void 0;
                if (compilerOptions.rewriteRelativeImportExtensions && (currentSourceFile.flags & 4194304 /* PossiblyContainsDynamicImport */  || isInJSFile(node))) forEachDynamicImportOrRequireCall(node, /*includeTypeSpaceImports*/ false, /*requireStringLiteralLikeArgument*/ false, (node2)=>{
                    if (!isStringLiteralLike(node2.arguments[0]) || shouldRewriteModuleSpecifier(node2.arguments[0].text, compilerOptions)) importsAndRequiresToRewriteOrShim = append(importsAndRequiresToRewriteOrShim, node2);
                });
                let result = updateExternalModule(node);
                addEmitHelpers(result, context.readEmitHelpers());
                currentSourceFile = void 0;
                if (importRequireStatements) result = factory2.updateSourceFile(result, setTextRange(factory2.createNodeArray(insertStatementsAfterCustomPrologue(result.statements.slice(), importRequireStatements)), result.statements));
                if (!isExternalModule(node) || getEmitModuleKind(compilerOptions) === 200 /* Preserve */  || some(result.statements, isExternalModuleIndicator)) return result;
                return factory2.updateSourceFile(result, setTextRange(factory2.createNodeArray([
                    ...result.statements,
                    createEmptyExports(factory2)
                ]), result.statements));
            }
            return node;
        }
        function updateExternalModule(node) {
            const externalHelpersImportDeclaration = createExternalHelpersImportDeclarationIfNeeded(factory2, emitHelpers(), node, compilerOptions);
            if (externalHelpersImportDeclaration) {
                const statements = [];
                const statementOffset = factory2.copyPrologue(node.statements, statements);
                addRange(statements, visitArray([
                    externalHelpersImportDeclaration
                ], visitor, isStatement));
                addRange(statements, visitNodes2(node.statements, visitor, isStatement, statementOffset));
                return factory2.updateSourceFile(node, setTextRange(factory2.createNodeArray(statements), node.statements));
            } else return visitEachChild(node, visitor, context);
        }
        function visitor(node) {
            switch(node.kind){
                case 272 /* ImportEqualsDeclaration */ :
                    return getEmitModuleKind(compilerOptions) >= 100 /* Node16 */  ? visitImportEqualsDeclaration(node) : void 0;
                case 278 /* ExportAssignment */ :
                    return visitExportAssignment(node);
                case 279 /* ExportDeclaration */ :
                    const exportDecl = node;
                    return visitExportDeclaration(exportDecl);
                case 273 /* ImportDeclaration */ :
                    return visitImportDeclaration(node);
                case 214 /* CallExpression */ :
                    if (node === (importsAndRequiresToRewriteOrShim == null ? void 0 : importsAndRequiresToRewriteOrShim[0])) return visitImportOrRequireCall(importsAndRequiresToRewriteOrShim.shift());
                // fallthrough
                default:
                    if ((importsAndRequiresToRewriteOrShim == null ? void 0 : importsAndRequiresToRewriteOrShim.length) && rangeContainsRange(node, importsAndRequiresToRewriteOrShim[0])) return visitEachChild(node, visitor, context);
            }
            return node;
        }
        function visitImportDeclaration(node) {
            if (!compilerOptions.rewriteRelativeImportExtensions) return node;
            const updatedModuleSpecifier = rewriteModuleSpecifier(node.moduleSpecifier, compilerOptions);
            if (updatedModuleSpecifier === node.moduleSpecifier) return node;
            return factory2.updateImportDeclaration(node, node.modifiers, node.importClause, updatedModuleSpecifier, node.attributes);
        }
        function visitImportOrRequireCall(node) {
            return factory2.updateCallExpression(node, node.expression, node.typeArguments, [
                isStringLiteralLike(node.arguments[0]) ? rewriteModuleSpecifier(node.arguments[0], compilerOptions) : emitHelpers().createRewriteRelativeImportExtensionsHelper(node.arguments[0]),
                ...node.arguments.slice(1)
            ]);
        }
        function createRequireCall2(importNode) {
            const moduleName = getExternalModuleNameLiteral(factory2, importNode, Debug.checkDefined(currentSourceFile), host, resolver, compilerOptions);
            const args = [];
            if (moduleName) args.push(rewriteModuleSpecifier(moduleName, compilerOptions));
            if (getEmitModuleKind(compilerOptions) === 200 /* Preserve */ ) return factory2.createCallExpression(factory2.createIdentifier("require"), /*typeArguments*/ void 0, args);
            if (!importRequireStatements) {
                const createRequireName = factory2.createUniqueName("_createRequire", 48 /* FileLevel */ );
                const importStatement = factory2.createImportDeclaration(/*modifiers*/ void 0, factory2.createImportClause(/*phaseModifier*/ void 0, /*name*/ void 0, factory2.createNamedImports([
                    factory2.createImportSpecifier(/*isTypeOnly*/ false, factory2.createIdentifier("createRequire"), createRequireName)
                ])), factory2.createStringLiteral("module"), /*attributes*/ void 0);
                const requireHelperName = factory2.createUniqueName("__require", 48 /* FileLevel */ );
                const requireStatement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                    factory2.createVariableDeclaration(requireHelperName, /*exclamationToken*/ void 0, /*type*/ void 0, factory2.createCallExpression(factory2.cloneNode(createRequireName), /*typeArguments*/ void 0, [
                        factory2.createPropertyAccessExpression(factory2.createMetaProperty(102 /* ImportKeyword */ , factory2.createIdentifier("meta")), factory2.createIdentifier("url"))
                    ]))
                ], /*flags*/ languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ ));
                importRequireStatements = [
                    importStatement,
                    requireStatement
                ];
            }
            const name = importRequireStatements[1].declarationList.declarations[0].name;
            Debug.assertNode(name, isIdentifier);
            return factory2.createCallExpression(factory2.cloneNode(name), /*typeArguments*/ void 0, args);
        }
        function visitImportEqualsDeclaration(node) {
            Debug.assert(isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
            let statements;
            statements = append(statements, setOriginalNode(setTextRange(factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList([
                factory2.createVariableDeclaration(factory2.cloneNode(node.name), /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall2(node))
            ], /*flags*/ languageVersion >= 2 /* ES2015 */  ? 2 /* Const */  : 0 /* None */ )), node), node));
            statements = appendExportsOfImportEqualsDeclaration(statements, node);
            return singleOrMany(statements);
        }
        function appendExportsOfImportEqualsDeclaration(statements, node) {
            if (hasSyntacticModifier(node, 32 /* Export */ )) statements = append(statements, factory2.createExportDeclaration(/*modifiers*/ void 0, node.isTypeOnly, factory2.createNamedExports([
                factory2.createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, idText(node.name))
            ])));
            return statements;
        }
        function visitExportAssignment(node) {
            if (node.isExportEquals) {
                if (getEmitModuleKind(compilerOptions) === 200 /* Preserve */ ) {
                    const statement = setOriginalNode(factory2.createExpressionStatement(factory2.createAssignment(factory2.createPropertyAccessExpression(factory2.createIdentifier("module"), "exports"), node.expression)), node);
                    return statement;
                }
                return void 0;
            }
            return node;
        }
        function visitExportDeclaration(node) {
            const updatedModuleSpecifier = rewriteModuleSpecifier(node.moduleSpecifier, compilerOptions);
            if (compilerOptions.module !== void 0 && compilerOptions.module > 5 /* ES2015 */  || !node.exportClause || !isNamespaceExport(node.exportClause) || !node.moduleSpecifier) return !node.moduleSpecifier || updatedModuleSpecifier === node.moduleSpecifier ? node : factory2.updateExportDeclaration(node, node.modifiers, node.isTypeOnly, node.exportClause, updatedModuleSpecifier, node.attributes);
            const oldIdentifier = node.exportClause.name;
            const synthName = factory2.getGeneratedNameForNode(oldIdentifier);
            const importDecl = factory2.createImportDeclaration(/*modifiers*/ void 0, factory2.createImportClause(/*phaseModifier*/ void 0, /*name*/ void 0, factory2.createNamespaceImport(synthName)), updatedModuleSpecifier, node.attributes);
            setOriginalNode(importDecl, node.exportClause);
            const exportDecl = isExportNamespaceAsDefaultDeclaration(node) ? factory2.createExportDefault(synthName) : factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports([
                factory2.createExportSpecifier(/*isTypeOnly*/ false, synthName, oldIdentifier)
            ]));
            setOriginalNode(exportDecl, node);
            return [
                importDecl,
                exportDecl
            ];
        }
        function onEmitNode(hint, node, emitCallback) {
            if (isSourceFile(node)) {
                if ((isExternalModule(node) || getIsolatedModules(compilerOptions)) && compilerOptions.importHelpers) helperNameSubstitutions = /* @__PURE__ */ new Map();
                currentSourceFile = node;
                previousOnEmitNode(hint, node, emitCallback);
                currentSourceFile = void 0;
                helperNameSubstitutions = void 0;
            } else previousOnEmitNode(hint, node, emitCallback);
        }
        function onSubstituteNode(hint, node) {
            node = previousOnSubstituteNode(hint, node);
            if (node.id && noSubstitution.has(node.id)) return node;
            if (isIdentifier(node) && getEmitFlags(node) & 8192 /* HelperName */ ) return substituteHelperName(node);
            return node;
        }
        function substituteHelperName(node) {
            const externalHelpersModuleName = currentSourceFile && getExternalHelpersModuleName(currentSourceFile);
            if (externalHelpersModuleName) {
                noSubstitution.add(getNodeId(node));
                return factory2.createPropertyAccessExpression(externalHelpersModuleName, node);
            }
            if (helperNameSubstitutions) {
                const name = idText(node);
                let substitution = helperNameSubstitutions.get(name);
                if (!substitution) helperNameSubstitutions.set(name, substitution = factory2.createUniqueName(name, 48 /* FileLevel */ ));
                return substitution;
            }
            return node;
        }
    }
    // src/compiler/transformers/module/impliedNodeFormatDependent.ts
    function transformImpliedNodeFormatDependentModule(context) {
        const previousOnSubstituteNode = context.onSubstituteNode;
        const previousOnEmitNode = context.onEmitNode;
        const esmTransform = transformECMAScriptModule(context);
        const esmOnSubstituteNode = context.onSubstituteNode;
        const esmOnEmitNode = context.onEmitNode;
        context.onSubstituteNode = previousOnSubstituteNode;
        context.onEmitNode = previousOnEmitNode;
        const cjsTransform = transformModule(context);
        const cjsOnSubstituteNode = context.onSubstituteNode;
        const cjsOnEmitNode = context.onEmitNode;
        const getEmitModuleFormatOfFile2 = (file)=>context.getEmitHost().getEmitModuleFormatOfFile(file);
        context.onSubstituteNode = onSubstituteNode;
        context.onEmitNode = onEmitNode;
        context.enableSubstitution(308 /* SourceFile */ );
        context.enableEmitNotification(308 /* SourceFile */ );
        let currentSourceFile;
        return transformSourceFileOrBundle;
        function onSubstituteNode(hint, node) {
            if (isSourceFile(node)) {
                currentSourceFile = node;
                return previousOnSubstituteNode(hint, node);
            } else {
                if (!currentSourceFile) return previousOnSubstituteNode(hint, node);
                if (getEmitModuleFormatOfFile2(currentSourceFile) >= 5 /* ES2015 */ ) return esmOnSubstituteNode(hint, node);
                return cjsOnSubstituteNode(hint, node);
            }
        }
        function onEmitNode(hint, node, emitCallback) {
            if (isSourceFile(node)) currentSourceFile = node;
            if (!currentSourceFile) return previousOnEmitNode(hint, node, emitCallback);
            if (getEmitModuleFormatOfFile2(currentSourceFile) >= 5 /* ES2015 */ ) return esmOnEmitNode(hint, node, emitCallback);
            return cjsOnEmitNode(hint, node, emitCallback);
        }
        function getModuleTransformForFile(file) {
            return getEmitModuleFormatOfFile2(file) >= 5 /* ES2015 */  ? esmTransform : cjsTransform;
        }
        function transformSourceFile(node) {
            if (node.isDeclarationFile) return node;
            currentSourceFile = node;
            const result = getModuleTransformForFile(node)(node);
            currentSourceFile = void 0;
            Debug.assert(isSourceFile(result));
            return result;
        }
        function transformSourceFileOrBundle(node) {
            return node.kind === 308 /* SourceFile */  ? transformSourceFile(node) : transformBundle(node);
        }
        function transformBundle(node) {
            return context.factory.createBundle(map(node.sourceFiles, transformSourceFile));
        }
    }
    // src/compiler/transformers/declarations/diagnostics.ts
    function canProduceDiagnostics(node) {
        return isVariableDeclaration(node) || isPropertyDeclaration(node) || isPropertySignature(node) || isBindingElement(node) || isSetAccessor(node) || isGetAccessor(node) || isConstructSignatureDeclaration(node) || isCallSignatureDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isFunctionDeclaration(node) || isParameter(node) || isTypeParameterDeclaration(node) || isExpressionWithTypeArguments(node) || isImportEqualsDeclaration(node) || isTypeAliasDeclaration(node) || isConstructorDeclaration(node) || isIndexSignatureDeclaration(node) || isPropertyAccessExpression(node) || isElementAccessExpression(node) || isBinaryExpression(node) || isJSDocTypeAlias(node);
    }
    function createGetSymbolAccessibilityDiagnosticForNodeName(node) {
        if (isSetAccessor(node) || isGetAccessor(node)) return getAccessorNameVisibilityError;
        else if (isMethodSignature(node) || isMethodDeclaration(node)) return getMethodNameVisibilityError;
        else return createGetSymbolAccessibilityDiagnosticForNode(node);
        function getAccessorNameVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            if (isStatic(node)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
            else if (node.parent.kind === 264 /* ClassDeclaration */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
            else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
        }
        function getMethodNameVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            if (isStatic(node)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_private_name_1;
            else if (node.parent.kind === 264 /* ClassDeclaration */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_method_0_of_exported_class_has_or_is_using_private_name_1;
            else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Method_0_of_exported_interface_has_or_is_using_private_name_1;
        }
    }
    function createGetSymbolAccessibilityDiagnosticForNode(node) {
        if (isVariableDeclaration(node) || isPropertyDeclaration(node) || isPropertySignature(node) || isPropertyAccessExpression(node) || isElementAccessExpression(node) || isBinaryExpression(node) || isBindingElement(node) || isConstructorDeclaration(node)) return getVariableDeclarationTypeVisibilityError;
        else if (isSetAccessor(node) || isGetAccessor(node)) return getAccessorDeclarationTypeVisibilityError;
        else if (isConstructSignatureDeclaration(node) || isCallSignatureDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isFunctionDeclaration(node) || isIndexSignatureDeclaration(node)) return getReturnTypeVisibilityError;
        else if (isParameter(node)) {
            if (isParameterPropertyDeclaration(node, node.parent) && hasSyntacticModifier(node.parent, 2 /* Private */ )) return getVariableDeclarationTypeVisibilityError;
            return getParameterDeclarationTypeVisibilityError;
        } else if (isTypeParameterDeclaration(node)) return getTypeParameterConstraintVisibilityError;
        else if (isExpressionWithTypeArguments(node)) return getHeritageClauseVisibilityError;
        else if (isImportEqualsDeclaration(node)) return getImportEntityNameVisibilityError;
        else if (isTypeAliasDeclaration(node) || isJSDocTypeAlias(node)) return getTypeAliasDeclarationVisibilityError;
        else return Debug.assertNever(node, `Attempted to set a declaration diagnostic context for unhandled node kind: ${Debug.formatSyntaxKind(node.kind)}`);
        function getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            if (node.kind === 261 /* VariableDeclaration */  || node.kind === 209 /* BindingElement */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Exported_variable_0_has_or_is_using_private_name_1;
            else if (node.kind === 173 /* PropertyDeclaration */  || node.kind === 212 /* PropertyAccessExpression */  || node.kind === 213 /* ElementAccessExpression */  || node.kind === 227 /* BinaryExpression */  || node.kind === 172 /* PropertySignature */  || node.kind === 170 /* Parameter */  && hasSyntacticModifier(node.parent, 2 /* Private */ )) {
                if (isStatic(node)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
                else if (node.parent.kind === 264 /* ClassDeclaration */  || node.kind === 170 /* Parameter */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
                else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
            }
        }
        function getVariableDeclarationTypeVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getAccessorDeclarationTypeVisibilityError(symbolAccessibilityResult) {
            let diagnosticMessage;
            if (node.kind === 179 /* SetAccessor */ ) {
                if (isStatic(node)) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1;
                else diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1;
            } else if (isStatic(node)) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1;
            else diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1;
            return {
                diagnosticMessage,
                errorNode: node.name,
                typeName: node.name
            };
        }
        function getReturnTypeVisibilityError(symbolAccessibilityResult) {
            let diagnosticMessage;
            switch(node.kind){
                case 181 /* ConstructSignature */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 180 /* CallSignature */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 182 /* IndexSignature */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    if (isStatic(node)) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named : Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0;
                    else if (node.parent.kind === 264 /* ClassDeclaration */ ) diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named : Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0;
                    else diagnosticMessage = symbolAccessibilityResult.errorModuleName ? Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0;
                    break;
                case 263 /* FunctionDeclaration */ :
                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named : Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1 : Diagnostics.Return_type_of_exported_function_has_or_is_using_private_name_0;
                    break;
                default:
                    return Debug.fail("This is unknown kind for signature: " + node.kind);
            }
            return {
                diagnosticMessage,
                errorNode: node.name || node
            };
        }
        function getParameterDeclarationTypeVisibilityError(symbolAccessibilityResult) {
            const diagnosticMessage = getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
            return diagnosticMessage !== void 0 ? {
                diagnosticMessage,
                errorNode: node,
                typeName: node.name
            } : void 0;
        }
        function getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
            switch(node.parent.kind){
                case 177 /* Constructor */ :
                    return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1;
                case 181 /* ConstructSignature */ :
                case 186 /* ConstructorType */ :
                    return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
                case 180 /* CallSignature */ :
                    return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
                case 182 /* IndexSignature */ :
                    return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1;
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    if (isStatic(node.parent)) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
                    else if (node.parent.parent.kind === 264 /* ClassDeclaration */ ) return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
                    else return symbolAccessibilityResult.errorModuleName ? Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
                case 263 /* FunctionDeclaration */ :
                case 185 /* FunctionType */ :
                    return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_exported_function_has_or_is_using_private_name_1;
                case 179 /* SetAccessor */ :
                case 178 /* GetAccessor */ :
                    return symbolAccessibilityResult.errorModuleName ? symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */  ? Diagnostics.Parameter_0_of_accessor_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named : Diagnostics.Parameter_0_of_accessor_has_or_is_using_name_1_from_private_module_2 : Diagnostics.Parameter_0_of_accessor_has_or_is_using_private_name_1;
                default:
                    return Debug.fail(`Unknown parent for parameter: ${Debug.formatSyntaxKind(node.parent.kind)}`);
            }
        }
        function getTypeParameterConstraintVisibilityError() {
            let diagnosticMessage;
            switch(node.parent.kind){
                case 264 /* ClassDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_class_has_or_is_using_private_name_1;
                    break;
                case 265 /* InterfaceDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 201 /* MappedType */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_mapped_object_type_is_using_private_name_1;
                    break;
                case 186 /* ConstructorType */ :
                case 181 /* ConstructSignature */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 180 /* CallSignature */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    if (isStatic(node.parent)) diagnosticMessage = Diagnostics.Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
                    else if (node.parent.parent.kind === 264 /* ClassDeclaration */ ) diagnosticMessage = Diagnostics.Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
                    else diagnosticMessage = Diagnostics.Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
                    break;
                case 185 /* FunctionType */ :
                case 263 /* FunctionDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_function_has_or_is_using_private_name_1;
                    break;
                case 196 /* InferType */ :
                    diagnosticMessage = Diagnostics.Extends_clause_for_inferred_type_0_has_or_is_using_private_name_1;
                    break;
                case 266 /* TypeAliasDeclaration */ :
                    diagnosticMessage = Diagnostics.Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1;
                    break;
                default:
                    return Debug.fail("This is unknown parent for type parameter: " + node.parent.kind);
            }
            return {
                diagnosticMessage,
                errorNode: node,
                typeName: node.name
            };
        }
        function getHeritageClauseVisibilityError() {
            let diagnosticMessage;
            if (isClassDeclaration(node.parent.parent)) diagnosticMessage = isHeritageClause(node.parent) && node.parent.token === 119 /* ImplementsKeyword */  ? Diagnostics.Implements_clause_of_exported_class_0_has_or_is_using_private_name_1 : node.parent.parent.name ? Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1 : Diagnostics.extends_clause_of_exported_class_has_or_is_using_private_name_0;
            else diagnosticMessage = Diagnostics.extends_clause_of_exported_interface_0_has_or_is_using_private_name_1;
            return {
                diagnosticMessage,
                errorNode: node,
                typeName: getNameOfDeclaration(node.parent.parent)
            };
        }
        function getImportEntityNameVisibilityError() {
            return {
                diagnosticMessage: Diagnostics.Import_declaration_0_is_using_private_name_1,
                errorNode: node,
                typeName: node.name
            };
        }
        function getTypeAliasDeclarationVisibilityError(symbolAccessibilityResult) {
            return {
                diagnosticMessage: symbolAccessibilityResult.errorModuleName ? Diagnostics.Exported_type_alias_0_has_or_is_using_private_name_1_from_module_2 : Diagnostics.Exported_type_alias_0_has_or_is_using_private_name_1,
                errorNode: isJSDocTypeAlias(node) ? Debug.checkDefined(node.typeExpression) : node.type,
                typeName: isJSDocTypeAlias(node) ? getNameOfDeclaration(node) : node.name
            };
        }
    }
    function createGetIsolatedDeclarationErrors(resolver) {
        const relatedSuggestionByDeclarationKind = {
            [220 /* ArrowFunction */ ]: Diagnostics.Add_a_return_type_to_the_function_expression,
            [219 /* FunctionExpression */ ]: Diagnostics.Add_a_return_type_to_the_function_expression,
            [175 /* MethodDeclaration */ ]: Diagnostics.Add_a_return_type_to_the_method,
            [178 /* GetAccessor */ ]: Diagnostics.Add_a_return_type_to_the_get_accessor_declaration,
            [179 /* SetAccessor */ ]: Diagnostics.Add_a_type_to_parameter_of_the_set_accessor_declaration,
            [263 /* FunctionDeclaration */ ]: Diagnostics.Add_a_return_type_to_the_function_declaration,
            [181 /* ConstructSignature */ ]: Diagnostics.Add_a_return_type_to_the_function_declaration,
            [170 /* Parameter */ ]: Diagnostics.Add_a_type_annotation_to_the_parameter_0,
            [261 /* VariableDeclaration */ ]: Diagnostics.Add_a_type_annotation_to_the_variable_0,
            [173 /* PropertyDeclaration */ ]: Diagnostics.Add_a_type_annotation_to_the_property_0,
            [172 /* PropertySignature */ ]: Diagnostics.Add_a_type_annotation_to_the_property_0,
            [278 /* ExportAssignment */ ]: Diagnostics.Move_the_expression_in_default_export_to_a_variable_and_add_a_type_annotation_to_it
        };
        const errorByDeclarationKind = {
            [219 /* FunctionExpression */ ]: Diagnostics.Function_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations,
            [263 /* FunctionDeclaration */ ]: Diagnostics.Function_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations,
            [220 /* ArrowFunction */ ]: Diagnostics.Function_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations,
            [175 /* MethodDeclaration */ ]: Diagnostics.Method_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations,
            [181 /* ConstructSignature */ ]: Diagnostics.Method_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations,
            [178 /* GetAccessor */ ]: Diagnostics.At_least_one_accessor_must_have_an_explicit_type_annotation_with_isolatedDeclarations,
            [179 /* SetAccessor */ ]: Diagnostics.At_least_one_accessor_must_have_an_explicit_type_annotation_with_isolatedDeclarations,
            [170 /* Parameter */ ]: Diagnostics.Parameter_must_have_an_explicit_type_annotation_with_isolatedDeclarations,
            [261 /* VariableDeclaration */ ]: Diagnostics.Variable_must_have_an_explicit_type_annotation_with_isolatedDeclarations,
            [173 /* PropertyDeclaration */ ]: Diagnostics.Property_must_have_an_explicit_type_annotation_with_isolatedDeclarations,
            [172 /* PropertySignature */ ]: Diagnostics.Property_must_have_an_explicit_type_annotation_with_isolatedDeclarations,
            [168 /* ComputedPropertyName */ ]: Diagnostics.Computed_property_names_on_class_or_object_literals_cannot_be_inferred_with_isolatedDeclarations,
            [306 /* SpreadAssignment */ ]: Diagnostics.Objects_that_contain_spread_assignments_can_t_be_inferred_with_isolatedDeclarations,
            [305 /* ShorthandPropertyAssignment */ ]: Diagnostics.Objects_that_contain_shorthand_properties_can_t_be_inferred_with_isolatedDeclarations,
            [210 /* ArrayLiteralExpression */ ]: Diagnostics.Only_const_arrays_can_be_inferred_with_isolatedDeclarations,
            [278 /* ExportAssignment */ ]: Diagnostics.Default_exports_can_t_be_inferred_with_isolatedDeclarations,
            [231 /* SpreadElement */ ]: Diagnostics.Arrays_with_spread_elements_can_t_inferred_with_isolatedDeclarations
        };
        return getDiagnostic2;
        function getDiagnostic2(node) {
            const heritageClause = findAncestor(node, isHeritageClause);
            if (heritageClause) return createDiagnosticForNode(node, Diagnostics.Extends_clause_can_t_contain_an_expression_with_isolatedDeclarations);
            if ((isPartOfTypeNode(node) || isTypeQueryNode(node.parent)) && (isEntityName(node) || isEntityNameExpression(node))) return createEntityInTypeNodeError(node);
            Debug.type(node);
            switch(node.kind){
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return createAccessorTypeError(node);
                case 168 /* ComputedPropertyName */ :
                case 305 /* ShorthandPropertyAssignment */ :
                case 306 /* SpreadAssignment */ :
                    return createObjectLiteralError(node);
                case 210 /* ArrayLiteralExpression */ :
                case 231 /* SpreadElement */ :
                    return createArrayLiteralError(node);
                case 175 /* MethodDeclaration */ :
                case 181 /* ConstructSignature */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 263 /* FunctionDeclaration */ :
                    return createReturnTypeError(node);
                case 209 /* BindingElement */ :
                    return createBindingElementError(node);
                case 173 /* PropertyDeclaration */ :
                case 261 /* VariableDeclaration */ :
                    return createVariableOrPropertyError(node);
                case 170 /* Parameter */ :
                    return createParameterError(node);
                case 304 /* PropertyAssignment */ :
                    return createExpressionError(node.initializer);
                case 232 /* ClassExpression */ :
                    return createClassExpressionError(node);
                default:
                    assertType(node);
                    return createExpressionError(node);
            }
        }
        function findNearestDeclaration(node) {
            const result = findAncestor(node, (n)=>isExportAssignment(n) || isStatement(n) || isVariableDeclaration(n) || isPropertyDeclaration(n) || isParameter(n));
            if (!result) return void 0;
            if (isExportAssignment(result)) return result;
            if (isReturnStatement(result)) return findAncestor(result, (n)=>isFunctionLikeDeclaration(n) && !isConstructorDeclaration(n));
            return isStatement(result) ? void 0 : result;
        }
        function createAccessorTypeError(node) {
            const { getAccessor, setAccessor } = getAllAccessorDeclarations(node.symbol.declarations, node);
            var _ref;
            const targetNode = (_ref = isSetAccessor(node) ? node.parameters[0] : node) !== null && _ref !== void 0 ? _ref : node;
            const diag2 = createDiagnosticForNode(targetNode, errorByDeclarationKind[node.kind]);
            if (setAccessor) addRelatedInfo(diag2, createDiagnosticForNode(setAccessor, relatedSuggestionByDeclarationKind[setAccessor.kind]));
            if (getAccessor) addRelatedInfo(diag2, createDiagnosticForNode(getAccessor, relatedSuggestionByDeclarationKind[getAccessor.kind]));
            return diag2;
        }
        function addParentDeclarationRelatedInfo(node, diag2) {
            const parentDeclaration = findNearestDeclaration(node);
            if (parentDeclaration) {
                const targetStr = isExportAssignment(parentDeclaration) || !parentDeclaration.name ? "" : getTextOfNode(parentDeclaration.name, /*includeTrivia*/ false);
                addRelatedInfo(diag2, createDiagnosticForNode(parentDeclaration, relatedSuggestionByDeclarationKind[parentDeclaration.kind], targetStr));
            }
            return diag2;
        }
        function createObjectLiteralError(node) {
            const diag2 = createDiagnosticForNode(node, errorByDeclarationKind[node.kind]);
            addParentDeclarationRelatedInfo(node, diag2);
            return diag2;
        }
        function createArrayLiteralError(node) {
            const diag2 = createDiagnosticForNode(node, errorByDeclarationKind[node.kind]);
            addParentDeclarationRelatedInfo(node, diag2);
            return diag2;
        }
        function createReturnTypeError(node) {
            const diag2 = createDiagnosticForNode(node, errorByDeclarationKind[node.kind]);
            addParentDeclarationRelatedInfo(node, diag2);
            addRelatedInfo(diag2, createDiagnosticForNode(node, relatedSuggestionByDeclarationKind[node.kind]));
            return diag2;
        }
        function createBindingElementError(node) {
            return createDiagnosticForNode(node, Diagnostics.Binding_elements_can_t_be_exported_directly_with_isolatedDeclarations);
        }
        function createVariableOrPropertyError(node) {
            const diag2 = createDiagnosticForNode(node, errorByDeclarationKind[node.kind]);
            const targetStr = getTextOfNode(node.name, /*includeTrivia*/ false);
            addRelatedInfo(diag2, createDiagnosticForNode(node, relatedSuggestionByDeclarationKind[node.kind], targetStr));
            return diag2;
        }
        function createParameterError(node) {
            if (isSetAccessor(node.parent)) return createAccessorTypeError(node.parent);
            const addUndefined = resolver.requiresAddingImplicitUndefined(node, node.parent);
            if (!addUndefined && node.initializer) return createExpressionError(node.initializer);
            const message = addUndefined ? Diagnostics.Declaration_emit_for_this_parameter_requires_implicitly_adding_undefined_to_its_type_This_is_not_supported_with_isolatedDeclarations : errorByDeclarationKind[node.kind];
            const diag2 = createDiagnosticForNode(node, message);
            const targetStr = getTextOfNode(node.name, /*includeTrivia*/ false);
            addRelatedInfo(diag2, createDiagnosticForNode(node, relatedSuggestionByDeclarationKind[node.kind], targetStr));
            return diag2;
        }
        function createClassExpressionError(node) {
            return createExpressionError(node, Diagnostics.Inference_from_class_expressions_is_not_supported_with_isolatedDeclarations);
        }
        function createEntityInTypeNodeError(node) {
            const diag2 = createDiagnosticForNode(node, Diagnostics.Type_containing_private_name_0_can_t_be_used_with_isolatedDeclarations, getTextOfNode(node, /*includeTrivia*/ false));
            addParentDeclarationRelatedInfo(node, diag2);
            return diag2;
        }
        function createExpressionError(node, diagnosticMessage) {
            const parentDeclaration = findNearestDeclaration(node);
            let diag2;
            if (parentDeclaration) {
                const targetStr = isExportAssignment(parentDeclaration) || !parentDeclaration.name ? "" : getTextOfNode(parentDeclaration.name, /*includeTrivia*/ false);
                const parent2 = findAncestor(node.parent, (n)=>isExportAssignment(n) || (isStatement(n) ? "quit" : !isParenthesizedExpression(n) && !isTypeAssertionExpression(n) && !isAsExpression(n)));
                if (parentDeclaration === parent2) {
                    diag2 = createDiagnosticForNode(node, diagnosticMessage !== null && diagnosticMessage !== void 0 ? diagnosticMessage : errorByDeclarationKind[parentDeclaration.kind]);
                    addRelatedInfo(diag2, createDiagnosticForNode(parentDeclaration, relatedSuggestionByDeclarationKind[parentDeclaration.kind], targetStr));
                } else {
                    diag2 = createDiagnosticForNode(node, diagnosticMessage !== null && diagnosticMessage !== void 0 ? diagnosticMessage : Diagnostics.Expression_type_can_t_be_inferred_with_isolatedDeclarations);
                    addRelatedInfo(diag2, createDiagnosticForNode(parentDeclaration, relatedSuggestionByDeclarationKind[parentDeclaration.kind], targetStr));
                    addRelatedInfo(diag2, createDiagnosticForNode(node, Diagnostics.Add_satisfies_and_a_type_assertion_to_this_expression_satisfies_T_as_T_to_make_the_type_explicit));
                }
            } else diag2 = createDiagnosticForNode(node, diagnosticMessage !== null && diagnosticMessage !== void 0 ? diagnosticMessage : Diagnostics.Expression_type_can_t_be_inferred_with_isolatedDeclarations);
            return diag2;
        }
    }
    // src/compiler/transformers/declarations.ts
    function getDeclarationDiagnostics(host, resolver, file) {
        const compilerOptions = host.getCompilerOptions();
        const files = filter(getSourceFilesToEmit(host, file), isSourceFileNotJson);
        return contains(files, file) ? transformNodes(resolver, host, factory, compilerOptions, [
            file
        ], [
            transformDeclarations
        ], /*allowDtsFiles*/ false).diagnostics : void 0;
    }
    var declarationEmitNodeBuilderFlags = 531469 /* NoTruncation */ ;
    var declarationEmitInternalNodeBuilderFlags = 8 /* AllowUnresolvedNames */ ;
    function transformDeclarations(context) {
        const throwDiagnostic = ()=>Debug.fail("Diagnostic emitted without context");
        let getSymbolAccessibilityDiagnostic = throwDiagnostic;
        let needsDeclare = true;
        let isBundledEmit = false;
        let resultHasExternalModuleIndicator = false;
        let needsScopeFixMarker = false;
        let resultHasScopeMarker = false;
        let enclosingDeclaration;
        let lateMarkedStatements;
        let lateStatementReplacementMap;
        let suppressNewDiagnosticContexts;
        const { factory: factory2 } = context;
        const host = context.getEmitHost();
        let restoreFallbackNode = ()=>void 0;
        const symbolTracker = {
            trackSymbol,
            reportInaccessibleThisError,
            reportInaccessibleUniqueSymbolError,
            reportCyclicStructureError,
            reportPrivateInBaseOfClassExpression,
            reportLikelyUnsafeImportRequiredError,
            reportTruncationError,
            moduleResolverHost: host,
            reportNonlocalAugmentation,
            reportNonSerializableProperty,
            reportInferenceFallback,
            pushErrorFallbackNode (node) {
                const currentFallback = errorFallbackNode;
                const currentRestore = restoreFallbackNode;
                restoreFallbackNode = ()=>{
                    restoreFallbackNode = currentRestore;
                    errorFallbackNode = currentFallback;
                };
                errorFallbackNode = node;
            },
            popErrorFallbackNode () {
                restoreFallbackNode();
            }
        };
        let errorNameNode;
        let errorFallbackNode;
        let currentSourceFile;
        let rawReferencedFiles;
        let rawTypeReferenceDirectives;
        let rawLibReferenceDirectives;
        const resolver = context.getEmitResolver();
        const options = context.getCompilerOptions();
        const getIsolatedDeclarationError = createGetIsolatedDeclarationErrors(resolver);
        const { stripInternal, isolatedDeclarations } = options;
        return transformRoot;
        function reportExpandoFunctionErrors(node) {
            resolver.getPropertiesOfContainerFunction(node).forEach((p)=>{
                if (isExpandoPropertyDeclaration(p.valueDeclaration)) {
                    const errorTarget = isBinaryExpression(p.valueDeclaration) ? p.valueDeclaration.left : p.valueDeclaration;
                    context.addDiagnostic(createDiagnosticForNode(errorTarget, Diagnostics.Assigning_properties_to_functions_without_declaring_them_is_not_supported_with_isolatedDeclarations_Add_an_explicit_declaration_for_the_properties_assigned_to_this_function));
                }
            });
        }
        function reportInferenceFallback(node) {
            if (!isolatedDeclarations || isSourceFileJS(currentSourceFile)) return;
            if (getSourceFileOfNode(node) !== currentSourceFile) return;
            if (isVariableDeclaration(node) && resolver.isExpandoFunctionDeclaration(node)) reportExpandoFunctionErrors(node);
            else context.addDiagnostic(getIsolatedDeclarationError(node));
        }
        function handleSymbolAccessibilityError(symbolAccessibilityResult) {
            if (symbolAccessibilityResult.accessibility === 0 /* Accessible */ ) {
                if (symbolAccessibilityResult.aliasesToMakeVisible) {
                    if (!lateMarkedStatements) lateMarkedStatements = symbolAccessibilityResult.aliasesToMakeVisible;
                    else for (const ref of symbolAccessibilityResult.aliasesToMakeVisible)pushIfUnique(lateMarkedStatements, ref);
                }
            } else if (symbolAccessibilityResult.accessibility !== 3 /* NotResolved */ ) {
                const errorInfo = getSymbolAccessibilityDiagnostic(symbolAccessibilityResult);
                if (errorInfo) {
                    if (errorInfo.typeName) context.addDiagnostic(createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, getTextOfNode(errorInfo.typeName), symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
                    else context.addDiagnostic(createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
                    return true;
                }
            }
            return false;
        }
        function trackSymbol(symbol, enclosingDeclaration2, meaning) {
            if (symbol.flags & 262144 /* TypeParameter */ ) return false;
            const issuedDiagnostic = handleSymbolAccessibilityError(resolver.isSymbolAccessible(symbol, enclosingDeclaration2, meaning, /*shouldComputeAliasToMarkVisible*/ true));
            return issuedDiagnostic;
        }
        function reportPrivateInBaseOfClassExpression(propertyName) {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(addRelatedInfo(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.Property_0_of_exported_anonymous_class_type_may_not_be_private_or_protected, propertyName), ...isVariableDeclaration((errorNameNode || errorFallbackNode).parent) ? [
                createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.Add_a_type_annotation_to_the_variable_0, errorDeclarationNameWithFallback())
            ] : []));
        }
        function errorDeclarationNameWithFallback() {
            return errorNameNode ? declarationNameToString(errorNameNode) : errorFallbackNode && getNameOfDeclaration(errorFallbackNode) ? declarationNameToString(getNameOfDeclaration(errorFallbackNode)) : errorFallbackNode && isExportAssignment(errorFallbackNode) ? errorFallbackNode.isExportEquals ? "export=" : "default" : "(Missing)";
        }
        function reportInaccessibleUniqueSymbolError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, errorDeclarationNameWithFallback(), "unique symbol"));
        }
        function reportCyclicStructureError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_references_a_type_with_a_cyclic_structure_which_cannot_be_trivially_serialized_A_type_annotation_is_necessary, errorDeclarationNameWithFallback()));
        }
        function reportInaccessibleThisError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, errorDeclarationNameWithFallback(), "this"));
        }
        function reportLikelyUnsafeImportRequiredError(specifier) {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_0_cannot_be_named_without_a_reference_to_1_This_is_likely_not_portable_A_type_annotation_is_necessary, errorDeclarationNameWithFallback(), specifier));
        }
        function reportTruncationError() {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_inferred_type_of_this_node_exceeds_the_maximum_length_the_compiler_will_serialize_An_explicit_type_annotation_is_needed));
        }
        function reportNonlocalAugmentation(containingFile, parentSymbol, symbol) {
            var _a;
            const primaryDeclaration = (_a = parentSymbol.declarations) == null ? void 0 : _a.find((d)=>getSourceFileOfNode(d) === containingFile);
            const augmentingDeclarations = filter(symbol.declarations, (d)=>getSourceFileOfNode(d) !== containingFile);
            if (primaryDeclaration && augmentingDeclarations) for (const augmentations of augmentingDeclarations)context.addDiagnostic(addRelatedInfo(createDiagnosticForNode(augmentations, Diagnostics.Declaration_augments_declaration_in_another_file_This_cannot_be_serialized), createDiagnosticForNode(primaryDeclaration, Diagnostics.This_is_the_declaration_being_augmented_Consider_moving_the_augmenting_declaration_into_the_same_file)));
        }
        function reportNonSerializableProperty(propertyName) {
            if (errorNameNode || errorFallbackNode) context.addDiagnostic(createDiagnosticForNode(errorNameNode || errorFallbackNode, Diagnostics.The_type_of_this_node_cannot_be_serialized_because_its_property_0_cannot_be_serialized, propertyName));
        }
        function transformDeclarationsForJS(sourceFile) {
            const oldDiag = getSymbolAccessibilityDiagnostic;
            getSymbolAccessibilityDiagnostic = (s)=>s.errorNode && canProduceDiagnostics(s.errorNode) ? createGetSymbolAccessibilityDiagnosticForNode(s.errorNode)(s) : {
                    diagnosticMessage: s.errorModuleName ? Diagnostics.Declaration_emit_for_this_file_requires_using_private_name_0_from_module_1_An_explicit_type_annotation_may_unblock_declaration_emit : Diagnostics.Declaration_emit_for_this_file_requires_using_private_name_0_An_explicit_type_annotation_may_unblock_declaration_emit,
                    errorNode: s.errorNode || sourceFile
                };
            const result = resolver.getDeclarationStatementsForSourceFile(sourceFile, declarationEmitNodeBuilderFlags, declarationEmitInternalNodeBuilderFlags, symbolTracker);
            getSymbolAccessibilityDiagnostic = oldDiag;
            return result;
        }
        function transformRoot(node) {
            if (node.kind === 308 /* SourceFile */  && node.isDeclarationFile) return node;
            if (node.kind === 309 /* Bundle */ ) {
                isBundledEmit = true;
                rawReferencedFiles = [];
                rawTypeReferenceDirectives = [];
                rawLibReferenceDirectives = [];
                let hasNoDefaultLib = false;
                const bundle = factory2.createBundle(map(node.sourceFiles, (sourceFile)=>{
                    if (sourceFile.isDeclarationFile) return void 0;
                    hasNoDefaultLib = hasNoDefaultLib || sourceFile.hasNoDefaultLib;
                    currentSourceFile = sourceFile;
                    enclosingDeclaration = sourceFile;
                    lateMarkedStatements = void 0;
                    suppressNewDiagnosticContexts = false;
                    lateStatementReplacementMap = /* @__PURE__ */ new Map();
                    getSymbolAccessibilityDiagnostic = throwDiagnostic;
                    needsScopeFixMarker = false;
                    resultHasScopeMarker = false;
                    collectFileReferences(sourceFile);
                    if (isExternalOrCommonJsModule(sourceFile) || isJsonSourceFile(sourceFile)) {
                        resultHasExternalModuleIndicator = false;
                        needsDeclare = false;
                        const statements = isSourceFileJS(sourceFile) ? factory2.createNodeArray(transformDeclarationsForJS(sourceFile)) : visitNodes2(sourceFile.statements, visitDeclarationStatements, isStatement);
                        const newFile = factory2.updateSourceFile(sourceFile, [
                            factory2.createModuleDeclaration([
                                factory2.createModifier(138 /* DeclareKeyword */ )
                            ], factory2.createStringLiteral(getResolvedExternalModuleName(context.getEmitHost(), sourceFile)), factory2.createModuleBlock(setTextRange(factory2.createNodeArray(transformAndReplaceLatePaintedStatements(statements)), sourceFile.statements)))
                        ], /*isDeclarationFile*/ true, /*referencedFiles*/ [], /*typeReferences*/ [], /*hasNoDefaultLib*/ false, /*libReferences*/ []);
                        return newFile;
                    }
                    needsDeclare = true;
                    const updated = isSourceFileJS(sourceFile) ? factory2.createNodeArray(transformDeclarationsForJS(sourceFile)) : visitNodes2(sourceFile.statements, visitDeclarationStatements, isStatement);
                    return factory2.updateSourceFile(sourceFile, transformAndReplaceLatePaintedStatements(updated), /*isDeclarationFile*/ true, /*referencedFiles*/ [], /*typeReferences*/ [], /*hasNoDefaultLib*/ false, /*libReferences*/ []);
                }));
                const outputFilePath2 = getDirectoryPath(normalizeSlashes(getOutputPathsFor(node, host, /*forceDtsPaths*/ true).declarationFilePath));
                bundle.syntheticFileReferences = getReferencedFiles(outputFilePath2);
                bundle.syntheticTypeReferences = getTypeReferences();
                bundle.syntheticLibReferences = getLibReferences();
                bundle.hasNoDefaultLib = hasNoDefaultLib;
                return bundle;
            }
            needsDeclare = true;
            needsScopeFixMarker = false;
            resultHasScopeMarker = false;
            enclosingDeclaration = node;
            currentSourceFile = node;
            getSymbolAccessibilityDiagnostic = throwDiagnostic;
            isBundledEmit = false;
            resultHasExternalModuleIndicator = false;
            suppressNewDiagnosticContexts = false;
            lateMarkedStatements = void 0;
            lateStatementReplacementMap = /* @__PURE__ */ new Map();
            rawReferencedFiles = [];
            rawTypeReferenceDirectives = [];
            rawLibReferenceDirectives = [];
            collectFileReferences(currentSourceFile);
            let combinedStatements;
            if (isSourceFileJS(currentSourceFile)) combinedStatements = factory2.createNodeArray(transformDeclarationsForJS(node));
            else {
                const statements = visitNodes2(node.statements, visitDeclarationStatements, isStatement);
                combinedStatements = setTextRange(factory2.createNodeArray(transformAndReplaceLatePaintedStatements(statements)), node.statements);
                if (isExternalModule(node) && (!resultHasExternalModuleIndicator || needsScopeFixMarker && !resultHasScopeMarker)) combinedStatements = setTextRange(factory2.createNodeArray([
                    ...combinedStatements,
                    createEmptyExports(factory2)
                ]), combinedStatements);
            }
            const outputFilePath = getDirectoryPath(normalizeSlashes(getOutputPathsFor(node, host, /*forceDtsPaths*/ true).declarationFilePath));
            return factory2.updateSourceFile(node, combinedStatements, /*isDeclarationFile*/ true, getReferencedFiles(outputFilePath), getTypeReferences(), node.hasNoDefaultLib, getLibReferences());
            function collectFileReferences(sourceFile) {
                rawReferencedFiles = concatenate(rawReferencedFiles, map(sourceFile.referencedFiles, (f)=>[
                        sourceFile,
                        f
                    ]));
                rawTypeReferenceDirectives = concatenate(rawTypeReferenceDirectives, sourceFile.typeReferenceDirectives);
                rawLibReferenceDirectives = concatenate(rawLibReferenceDirectives, sourceFile.libReferenceDirectives);
            }
            function copyFileReferenceAsSynthetic(ref) {
                const newRef = (0, _objectSpread._)({}, ref);
                newRef.pos = -1;
                newRef.end = -1;
                return newRef;
            }
            function getTypeReferences() {
                return mapDefined(rawTypeReferenceDirectives, (ref)=>{
                    if (!ref.preserve) return void 0;
                    return copyFileReferenceAsSynthetic(ref);
                });
            }
            function getLibReferences() {
                return mapDefined(rawLibReferenceDirectives, (ref)=>{
                    if (!ref.preserve) return void 0;
                    return copyFileReferenceAsSynthetic(ref);
                });
            }
            function getReferencedFiles(outputFilePath2) {
                return mapDefined(rawReferencedFiles, ([sourceFile, ref])=>{
                    if (!ref.preserve) return void 0;
                    const file = host.getSourceFileFromReference(sourceFile, ref);
                    if (!file) return void 0;
                    let declFileName;
                    if (file.isDeclarationFile) declFileName = file.fileName;
                    else {
                        if (isBundledEmit && contains(node.sourceFiles, file)) return;
                        const paths = getOutputPathsFor(file, host, /*forceDtsPaths*/ true);
                        declFileName = paths.declarationFilePath || paths.jsFilePath || file.fileName;
                    }
                    if (!declFileName) return void 0;
                    const fileName = getRelativePathToDirectoryOrUrl(outputFilePath2, declFileName, host.getCurrentDirectory(), host.getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
                    const newRef = copyFileReferenceAsSynthetic(ref);
                    newRef.fileName = fileName;
                    return newRef;
                });
            }
        }
        function filterBindingPatternInitializers(name) {
            if (name.kind === 80 /* Identifier */ ) return name;
            else {
                if (name.kind === 208 /* ArrayBindingPattern */ ) return factory2.updateArrayBindingPattern(name, visitNodes2(name.elements, visitBindingElement, isArrayBindingElement));
                else return factory2.updateObjectBindingPattern(name, visitNodes2(name.elements, visitBindingElement, isBindingElement));
            }
            function visitBindingElement(elem) {
                if (elem.kind === 233 /* OmittedExpression */ ) return elem;
                if (elem.propertyName && isComputedPropertyName(elem.propertyName) && isEntityNameExpression(elem.propertyName.expression)) checkEntityNameVisibility(elem.propertyName.expression, enclosingDeclaration);
                return factory2.updateBindingElement(elem, elem.dotDotDotToken, elem.propertyName, filterBindingPatternInitializers(elem.name), /*initializer*/ void 0);
            }
        }
        function ensureParameter(p, modifierMask) {
            let oldDiag;
            if (!suppressNewDiagnosticContexts) {
                oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(p);
            }
            const newParam = factory2.updateParameterDeclaration(p, maskModifiers(factory2, p, modifierMask), p.dotDotDotToken, filterBindingPatternInitializers(p.name), resolver.isOptionalParameter(p) ? p.questionToken || factory2.createToken(58 /* QuestionToken */ ) : void 0, ensureType(p, /*ignorePrivate*/ true), // Ignore private param props, since this type is going straight back into a param
            ensureNoInitializer(p));
            if (!suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
            return newParam;
        }
        function shouldPrintWithInitializer(node) {
            return canHaveLiteralInitializer(node) && !!node.initializer && resolver.isLiteralConstDeclaration(getParseTreeNode(node));
        }
        function ensureNoInitializer(node) {
            if (shouldPrintWithInitializer(node)) {
                const unwrappedInitializer = unwrapParenthesizedExpression(node.initializer);
                if (!isPrimitiveLiteralValue(unwrappedInitializer)) reportInferenceFallback(node);
                return resolver.createLiteralConstValue(getParseTreeNode(node, canHaveLiteralInitializer), symbolTracker);
            }
            return void 0;
        }
        function ensureType(node, ignorePrivate) {
            if (!ignorePrivate && hasEffectiveModifier(node, 2 /* Private */ )) return;
            if (shouldPrintWithInitializer(node)) return;
            if (!isExportAssignment(node) && !isBindingElement(node) && node.type && (!isParameter(node) || !resolver.requiresAddingImplicitUndefined(node, enclosingDeclaration))) return visitNode(node.type, visitDeclarationSubtree, isTypeNode);
            const oldErrorNameNode = errorNameNode;
            errorNameNode = node.name;
            let oldDiag;
            if (!suppressNewDiagnosticContexts) {
                oldDiag = getSymbolAccessibilityDiagnostic;
                if (canProduceDiagnostics(node)) getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(node);
            }
            let typeNode;
            if (hasInferredType(node)) typeNode = resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, declarationEmitInternalNodeBuilderFlags, symbolTracker);
            else if (isFunctionLike(node)) typeNode = resolver.createReturnTypeOfSignatureDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, declarationEmitInternalNodeBuilderFlags, symbolTracker);
            else Debug.assertNever(node);
            errorNameNode = oldErrorNameNode;
            if (!suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
            return typeNode !== null && typeNode !== void 0 ? typeNode : factory2.createKeywordTypeNode(133 /* AnyKeyword */ );
        }
        function isDeclarationAndNotVisible(node) {
            node = getParseTreeNode(node);
            switch(node.kind){
                case 263 /* FunctionDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 267 /* EnumDeclaration */ :
                    return !resolver.isDeclarationVisible(node);
                // The following should be doing their own visibility checks based on filtering their members
                case 261 /* VariableDeclaration */ :
                    return !getBindingNameVisible(node);
                case 272 /* ImportEqualsDeclaration */ :
                case 273 /* ImportDeclaration */ :
                case 279 /* ExportDeclaration */ :
                case 278 /* ExportAssignment */ :
                    return false;
                case 176 /* ClassStaticBlockDeclaration */ :
                    return true;
            }
            return false;
        }
        function shouldEmitFunctionProperties(input) {
            var _a;
            if (input.body) return true;
            const overloadSignatures = (_a = input.symbol.declarations) == null ? void 0 : _a.filter((decl)=>isFunctionDeclaration(decl) && !decl.body);
            return !overloadSignatures || overloadSignatures.indexOf(input) === overloadSignatures.length - 1;
        }
        function getBindingNameVisible(elem) {
            if (isOmittedExpression(elem)) return false;
            if (isBindingPattern(elem.name)) return some(elem.name.elements, getBindingNameVisible);
            else return resolver.isDeclarationVisible(elem);
        }
        function updateParamsList(node, params, modifierMask) {
            if (hasEffectiveModifier(node, 2 /* Private */ )) return factory2.createNodeArray();
            const newParams = map(params, (p)=>ensureParameter(p, modifierMask));
            if (!newParams) return factory2.createNodeArray();
            return factory2.createNodeArray(newParams, params.hasTrailingComma);
        }
        function updateAccessorParamsList(input, isPrivate) {
            let newParams;
            if (!isPrivate) {
                const thisParameter = getThisParameter(input);
                if (thisParameter) newParams = [
                    ensureParameter(thisParameter)
                ];
            }
            if (isSetAccessorDeclaration(input)) {
                let newValueParameter;
                if (!isPrivate) {
                    const valueParameter = getSetAccessorValueParameter(input);
                    if (valueParameter) newValueParameter = ensureParameter(valueParameter);
                }
                if (!newValueParameter) newValueParameter = factory2.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "value");
                newParams = append(newParams, newValueParameter);
            }
            return factory2.createNodeArray(newParams || emptyArray);
        }
        function ensureTypeParams(node, params) {
            return hasEffectiveModifier(node, 2 /* Private */ ) ? void 0 : visitNodes2(params, visitDeclarationSubtree, isTypeParameterDeclaration);
        }
        function isEnclosingDeclaration(node) {
            return isSourceFile(node) || isTypeAliasDeclaration(node) || isModuleDeclaration(node) || isClassDeclaration(node) || isInterfaceDeclaration(node) || isFunctionLike(node) || isIndexSignatureDeclaration(node) || isMappedTypeNode(node);
        }
        function checkEntityNameVisibility(entityName, enclosingDeclaration2) {
            const visibilityResult = resolver.isEntityNameVisible(entityName, enclosingDeclaration2);
            handleSymbolAccessibilityError(visibilityResult);
        }
        function preserveJsDoc(updated, original) {
            if (hasJSDocNodes(updated) && hasJSDocNodes(original)) updated.jsDoc = original.jsDoc;
            return setCommentRange(updated, getCommentRange(original));
        }
        function rewriteModuleSpecifier2(parent2, input) {
            if (!input) return void 0;
            resultHasExternalModuleIndicator = resultHasExternalModuleIndicator || parent2.kind !== 268 /* ModuleDeclaration */  && parent2.kind !== 206 /* ImportType */ ;
            if (isStringLiteralLike(input)) {
                if (isBundledEmit) {
                    const newName = getExternalModuleNameFromDeclaration(context.getEmitHost(), resolver, parent2);
                    if (newName) return factory2.createStringLiteral(newName);
                }
            }
            return input;
        }
        function transformImportEqualsDeclaration(decl) {
            if (!resolver.isDeclarationVisible(decl)) return;
            if (decl.moduleReference.kind === 284 /* ExternalModuleReference */ ) {
                const specifier = getExternalModuleImportEqualsDeclarationExpression(decl);
                return factory2.updateImportEqualsDeclaration(decl, decl.modifiers, decl.isTypeOnly, decl.name, factory2.updateExternalModuleReference(decl.moduleReference, rewriteModuleSpecifier2(decl, specifier)));
            } else {
                const oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(decl);
                checkEntityNameVisibility(decl.moduleReference, enclosingDeclaration);
                getSymbolAccessibilityDiagnostic = oldDiag;
                return decl;
            }
        }
        function transformImportDeclaration(decl) {
            if (!decl.importClause) return factory2.updateImportDeclaration(decl, decl.modifiers, decl.importClause, rewriteModuleSpecifier2(decl, decl.moduleSpecifier), tryGetResolutionModeOverride(decl.attributes));
            const phaseModifier = decl.importClause.phaseModifier === 166 /* DeferKeyword */  ? void 0 : decl.importClause.phaseModifier;
            const visibleDefaultBinding = decl.importClause && decl.importClause.name && resolver.isDeclarationVisible(decl.importClause) ? decl.importClause.name : void 0;
            if (!decl.importClause.namedBindings) return visibleDefaultBinding && factory2.updateImportDeclaration(decl, decl.modifiers, factory2.updateImportClause(decl.importClause, phaseModifier, visibleDefaultBinding, /*namedBindings*/ void 0), rewriteModuleSpecifier2(decl, decl.moduleSpecifier), tryGetResolutionModeOverride(decl.attributes));
            if (decl.importClause.namedBindings.kind === 275 /* NamespaceImport */ ) {
                const namedBindings = resolver.isDeclarationVisible(decl.importClause.namedBindings) ? decl.importClause.namedBindings : /*namedBindings*/ void 0;
                return visibleDefaultBinding || namedBindings ? factory2.updateImportDeclaration(decl, decl.modifiers, factory2.updateImportClause(decl.importClause, phaseModifier, visibleDefaultBinding, namedBindings), rewriteModuleSpecifier2(decl, decl.moduleSpecifier), tryGetResolutionModeOverride(decl.attributes)) : void 0;
            }
            const bindingList = mapDefined(decl.importClause.namedBindings.elements, (b)=>resolver.isDeclarationVisible(b) ? b : void 0);
            if (bindingList && bindingList.length || visibleDefaultBinding) return factory2.updateImportDeclaration(decl, decl.modifiers, factory2.updateImportClause(decl.importClause, phaseModifier, visibleDefaultBinding, bindingList && bindingList.length ? factory2.updateNamedImports(decl.importClause.namedBindings, bindingList) : void 0), rewriteModuleSpecifier2(decl, decl.moduleSpecifier), tryGetResolutionModeOverride(decl.attributes));
            if (resolver.isImportRequiredByAugmentation(decl)) {
                if (isolatedDeclarations) context.addDiagnostic(createDiagnosticForNode(decl, Diagnostics.Declaration_emit_for_this_file_requires_preserving_this_import_for_augmentations_This_is_not_supported_with_isolatedDeclarations));
                return factory2.updateImportDeclaration(decl, decl.modifiers, /*importClause*/ void 0, rewriteModuleSpecifier2(decl, decl.moduleSpecifier), tryGetResolutionModeOverride(decl.attributes));
            }
        }
        function tryGetResolutionModeOverride(node) {
            const mode = getResolutionModeOverride(node);
            return node && mode !== void 0 ? node : void 0;
        }
        function transformAndReplaceLatePaintedStatements(statements) {
            while(length(lateMarkedStatements)){
                const i = lateMarkedStatements.shift();
                if (!isLateVisibilityPaintedStatement(i)) return Debug.fail(`Late replaced statement was found which is not handled by the declaration transformer!: ${Debug.formatSyntaxKind(i.kind)}`);
                const priorNeedsDeclare = needsDeclare;
                needsDeclare = i.parent && isSourceFile(i.parent) && !(isExternalModule(i.parent) && isBundledEmit);
                const result = transformTopLevelDeclaration(i);
                needsDeclare = priorNeedsDeclare;
                lateStatementReplacementMap.set(getOriginalNodeId(i), result);
            }
            return visitNodes2(statements, visitLateVisibilityMarkedStatements, isStatement);
            function visitLateVisibilityMarkedStatements(statement) {
                if (isLateVisibilityPaintedStatement(statement)) {
                    const key = getOriginalNodeId(statement);
                    if (lateStatementReplacementMap.has(key)) {
                        const result = lateStatementReplacementMap.get(key);
                        lateStatementReplacementMap.delete(key);
                        if (result) {
                            if (isArray(result) ? some(result, needsScopeMarker) : needsScopeMarker(result)) needsScopeFixMarker = true;
                            if (isSourceFile(statement.parent) && (isArray(result) ? some(result, isExternalModuleIndicator) : isExternalModuleIndicator(result))) resultHasExternalModuleIndicator = true;
                        }
                        return result;
                    }
                }
                return statement;
            }
        }
        function visitDeclarationSubtree(input) {
            if (shouldStripInternal(input)) return;
            if (isDeclaration(input)) {
                if (isDeclarationAndNotVisible(input)) return;
                if (hasDynamicName(input)) {
                    if (isolatedDeclarations) {
                        if (!resolver.isDefinitelyReferenceToGlobalSymbolObject(input.name.expression)) {
                            if (isClassDeclaration(input.parent) || isObjectLiteralExpression(input.parent)) {
                                context.addDiagnostic(createDiagnosticForNode(input, Diagnostics.Computed_property_names_on_class_or_object_literals_cannot_be_inferred_with_isolatedDeclarations));
                                return;
                            } else if (// Type declarations just need to double-check that the input computed name is an entity name expression
                            (isInterfaceDeclaration(input.parent) || isTypeLiteralNode(input.parent)) && !isEntityNameExpression(input.name.expression)) {
                                context.addDiagnostic(createDiagnosticForNode(input, Diagnostics.Computed_properties_must_be_number_or_string_literals_variables_or_dotted_expressions_with_isolatedDeclarations));
                                return;
                            }
                        }
                    } else if (!resolver.isLateBound(getParseTreeNode(input)) || !isEntityNameExpression(input.name.expression)) return;
                }
            }
            if (isFunctionLike(input) && resolver.isImplementationOfOverload(input)) return;
            if (isSemicolonClassElement(input)) return;
            let previousEnclosingDeclaration;
            if (isEnclosingDeclaration(input)) {
                previousEnclosingDeclaration = enclosingDeclaration;
                enclosingDeclaration = input;
            }
            const oldDiag = getSymbolAccessibilityDiagnostic;
            const canProduceDiagnostic = canProduceDiagnostics(input);
            const oldWithinObjectLiteralType = suppressNewDiagnosticContexts;
            let shouldEnterSuppressNewDiagnosticsContextContext = (input.kind === 188 /* TypeLiteral */  || input.kind === 201 /* MappedType */ ) && input.parent.kind !== 266 /* TypeAliasDeclaration */ ;
            if (isMethodDeclaration(input) || isMethodSignature(input)) {
                if (hasEffectiveModifier(input, 2 /* Private */ )) {
                    if (input.symbol && input.symbol.declarations && input.symbol.declarations[0] !== input) return;
                    return cleanup(factory2.createPropertyDeclaration(ensureModifiers(input), input.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0));
                }
            }
            if (canProduceDiagnostic && !suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(input);
            if (isTypeQueryNode(input)) checkEntityNameVisibility(input.exprName, enclosingDeclaration);
            if (shouldEnterSuppressNewDiagnosticsContextContext) suppressNewDiagnosticContexts = true;
            if (isProcessedComponent(input)) switch(input.kind){
                case 234 /* ExpressionWithTypeArguments */ :
                    {
                        if (isEntityName(input.expression) || isEntityNameExpression(input.expression)) checkEntityNameVisibility(input.expression, enclosingDeclaration);
                        const node = visitEachChild(input, visitDeclarationSubtree, context);
                        return cleanup(factory2.updateExpressionWithTypeArguments(node, node.expression, node.typeArguments));
                    }
                case 184 /* TypeReference */ :
                    {
                        checkEntityNameVisibility(input.typeName, enclosingDeclaration);
                        const node = visitEachChild(input, visitDeclarationSubtree, context);
                        return cleanup(factory2.updateTypeReferenceNode(node, node.typeName, node.typeArguments));
                    }
                case 181 /* ConstructSignature */ :
                    return cleanup(factory2.updateConstructSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input)));
                case 177 /* Constructor */ :
                    {
                        const ctor = factory2.createConstructorDeclaration(/*modifiers*/ ensureModifiers(input), updateParamsList(input, input.parameters, 0 /* None */ ), /*body*/ void 0);
                        return cleanup(ctor);
                    }
                case 175 /* MethodDeclaration */ :
                    {
                        if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                        const sig = factory2.createMethodDeclaration(ensureModifiers(input), /*asteriskToken*/ void 0, input.name, input.questionToken, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input), /*body*/ void 0);
                        return cleanup(sig);
                    }
                case 178 /* GetAccessor */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updateGetAccessorDeclaration(input, ensureModifiers(input), input.name, updateAccessorParamsList(input, hasEffectiveModifier(input, 2 /* Private */ )), ensureType(input), /*body*/ void 0));
                case 179 /* SetAccessor */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updateSetAccessorDeclaration(input, ensureModifiers(input), input.name, updateAccessorParamsList(input, hasEffectiveModifier(input, 2 /* Private */ )), /*body*/ void 0));
                case 173 /* PropertyDeclaration */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updatePropertyDeclaration(input, ensureModifiers(input), input.name, input.questionToken, ensureType(input), ensureNoInitializer(input)));
                case 172 /* PropertySignature */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updatePropertySignature(input, ensureModifiers(input), input.name, input.questionToken, ensureType(input)));
                case 174 /* MethodSignature */ :
                    if (isPrivateIdentifier(input.name)) return cleanup(/*returnValue*/ void 0);
                    return cleanup(factory2.updateMethodSignature(input, ensureModifiers(input), input.name, input.questionToken, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input)));
                case 180 /* CallSignature */ :
                    return cleanup(factory2.updateCallSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input)));
                case 182 /* IndexSignature */ :
                    return cleanup(factory2.updateIndexSignature(input, ensureModifiers(input), updateParamsList(input, input.parameters), visitNode(input.type, visitDeclarationSubtree, isTypeNode) || factory2.createKeywordTypeNode(133 /* AnyKeyword */ )));
                case 261 /* VariableDeclaration */ :
                    if (isBindingPattern(input.name)) return recreateBindingPattern(input.name);
                    shouldEnterSuppressNewDiagnosticsContextContext = true;
                    suppressNewDiagnosticContexts = true;
                    return cleanup(factory2.updateVariableDeclaration(input, input.name, /*exclamationToken*/ void 0, ensureType(input), ensureNoInitializer(input)));
                case 169 /* TypeParameter */ :
                    if (isPrivateMethodTypeParameter(input) && (input.default || input.constraint)) return cleanup(factory2.updateTypeParameterDeclaration(input, input.modifiers, input.name, /*constraint*/ void 0, /*defaultType*/ void 0));
                    return cleanup(visitEachChild(input, visitDeclarationSubtree, context));
                case 195 /* ConditionalType */ :
                    {
                        const checkType = visitNode(input.checkType, visitDeclarationSubtree, isTypeNode);
                        const extendsType = visitNode(input.extendsType, visitDeclarationSubtree, isTypeNode);
                        const oldEnclosingDecl = enclosingDeclaration;
                        enclosingDeclaration = input.trueType;
                        const trueType = visitNode(input.trueType, visitDeclarationSubtree, isTypeNode);
                        enclosingDeclaration = oldEnclosingDecl;
                        const falseType = visitNode(input.falseType, visitDeclarationSubtree, isTypeNode);
                        Debug.assert(checkType);
                        Debug.assert(extendsType);
                        Debug.assert(trueType);
                        Debug.assert(falseType);
                        return cleanup(factory2.updateConditionalTypeNode(input, checkType, extendsType, trueType, falseType));
                    }
                case 185 /* FunctionType */ :
                    return cleanup(factory2.updateFunctionTypeNode(input, visitNodes2(input.typeParameters, visitDeclarationSubtree, isTypeParameterDeclaration), updateParamsList(input, input.parameters), Debug.checkDefined(visitNode(input.type, visitDeclarationSubtree, isTypeNode))));
                case 186 /* ConstructorType */ :
                    return cleanup(factory2.updateConstructorTypeNode(input, ensureModifiers(input), visitNodes2(input.typeParameters, visitDeclarationSubtree, isTypeParameterDeclaration), updateParamsList(input, input.parameters), Debug.checkDefined(visitNode(input.type, visitDeclarationSubtree, isTypeNode))));
                case 206 /* ImportType */ :
                    if (!isLiteralImportTypeNode(input)) return cleanup(input);
                    return cleanup(factory2.updateImportTypeNode(input, factory2.updateLiteralTypeNode(input.argument, rewriteModuleSpecifier2(input, input.argument.literal)), input.attributes, input.qualifier, visitNodes2(input.typeArguments, visitDeclarationSubtree, isTypeNode), input.isTypeOf));
                default:
                    Debug.assertNever(input, `Attempted to process unhandled node kind: ${Debug.formatSyntaxKind(input.kind)}`);
            }
            if (isTupleTypeNode(input) && getLineAndCharacterOfPosition(currentSourceFile, input.pos).line === getLineAndCharacterOfPosition(currentSourceFile, input.end).line) setEmitFlags(input, 1 /* SingleLine */ );
            return cleanup(visitEachChild(input, visitDeclarationSubtree, context));
            function cleanup(returnValue) {
                if (returnValue && canProduceDiagnostic && hasDynamicName(input)) checkName(input);
                if (isEnclosingDeclaration(input)) enclosingDeclaration = previousEnclosingDeclaration;
                if (canProduceDiagnostic && !suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
                if (shouldEnterSuppressNewDiagnosticsContextContext) suppressNewDiagnosticContexts = oldWithinObjectLiteralType;
                if (returnValue === input) return returnValue;
                return returnValue && setOriginalNode(preserveJsDoc(returnValue, input), input);
            }
        }
        function isPrivateMethodTypeParameter(node) {
            return node.parent.kind === 175 /* MethodDeclaration */  && hasEffectiveModifier(node.parent, 2 /* Private */ );
        }
        function visitDeclarationStatements(input) {
            if (!isPreservedDeclarationStatement(input)) return;
            if (shouldStripInternal(input)) return;
            switch(input.kind){
                case 279 /* ExportDeclaration */ :
                    if (isSourceFile(input.parent)) resultHasExternalModuleIndicator = true;
                    resultHasScopeMarker = true;
                    return factory2.updateExportDeclaration(input, input.modifiers, input.isTypeOnly, input.exportClause, rewriteModuleSpecifier2(input, input.moduleSpecifier), tryGetResolutionModeOverride(input.attributes));
                case 278 /* ExportAssignment */ :
                    if (isSourceFile(input.parent)) resultHasExternalModuleIndicator = true;
                    resultHasScopeMarker = true;
                    if (input.expression.kind === 80 /* Identifier */ ) return input;
                    else {
                        const newId = factory2.createUniqueName("_default", 16 /* Optimistic */ );
                        getSymbolAccessibilityDiagnostic = ()=>({
                                diagnosticMessage: Diagnostics.Default_export_of_the_module_has_or_is_using_private_name_0,
                                errorNode: input
                            });
                        errorFallbackNode = input;
                        const type = ensureType(input);
                        const varDecl = factory2.createVariableDeclaration(newId, /*exclamationToken*/ void 0, type, /*initializer*/ void 0);
                        errorFallbackNode = void 0;
                        const statement = factory2.createVariableStatement(needsDeclare ? [
                            factory2.createModifier(138 /* DeclareKeyword */ )
                        ] : [], factory2.createVariableDeclarationList([
                            varDecl
                        ], 2 /* Const */ ));
                        preserveJsDoc(statement, input);
                        removeAllComments(input);
                        return [
                            statement,
                            factory2.updateExportAssignment(input, input.modifiers, newId)
                        ];
                    }
            }
            const result = transformTopLevelDeclaration(input);
            lateStatementReplacementMap.set(getOriginalNodeId(input), result);
            return input;
        }
        function stripExportModifiers(statement) {
            if (isImportEqualsDeclaration(statement) || hasEffectiveModifier(statement, 2048 /* Default */ ) || !canHaveModifiers(statement)) return statement;
            const modifiers = factory2.createModifiersFromModifierFlags(getEffectiveModifierFlags(statement) & 131039 /* Export */ );
            return factory2.replaceModifiers(statement, modifiers);
        }
        function updateModuleDeclarationAndKeyword(node, modifiers, name, body) {
            const updated = factory2.updateModuleDeclaration(node, modifiers, name, body);
            if (isAmbientModule(updated) || updated.flags & 32 /* Namespace */ ) return updated;
            const fixed = factory2.createModuleDeclaration(updated.modifiers, updated.name, updated.body, updated.flags | 32 /* Namespace */ );
            setOriginalNode(fixed, updated);
            setTextRange(fixed, updated);
            return fixed;
        }
        function transformTopLevelDeclaration(input) {
            if (lateMarkedStatements) {
                while(orderedRemoveItem(lateMarkedStatements, input));
            }
            if (shouldStripInternal(input)) return;
            switch(input.kind){
                case 272 /* ImportEqualsDeclaration */ :
                    return transformImportEqualsDeclaration(input);
                case 273 /* ImportDeclaration */ :
                    return transformImportDeclaration(input);
            }
            if (isDeclaration(input) && isDeclarationAndNotVisible(input)) return;
            if (isJSDocImportTag(input)) return;
            if (isFunctionLike(input) && resolver.isImplementationOfOverload(input)) return;
            let previousEnclosingDeclaration;
            if (isEnclosingDeclaration(input)) {
                previousEnclosingDeclaration = enclosingDeclaration;
                enclosingDeclaration = input;
            }
            const canProdiceDiagnostic = canProduceDiagnostics(input);
            const oldDiag = getSymbolAccessibilityDiagnostic;
            if (canProdiceDiagnostic) getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(input);
            const previousNeedsDeclare = needsDeclare;
            switch(input.kind){
                case 266 /* TypeAliasDeclaration */ :
                    {
                        needsDeclare = false;
                        const clean2 = cleanup(factory2.updateTypeAliasDeclaration(input, ensureModifiers(input), input.name, visitNodes2(input.typeParameters, visitDeclarationSubtree, isTypeParameterDeclaration), Debug.checkDefined(visitNode(input.type, visitDeclarationSubtree, isTypeNode))));
                        needsDeclare = previousNeedsDeclare;
                        return clean2;
                    }
                case 265 /* InterfaceDeclaration */ :
                    return cleanup(factory2.updateInterfaceDeclaration(input, ensureModifiers(input), input.name, ensureTypeParams(input, input.typeParameters), transformHeritageClauses(input.heritageClauses), visitNodes2(input.members, visitDeclarationSubtree, isTypeElement)));
                case 263 /* FunctionDeclaration */ :
                    {
                        const clean2 = cleanup(factory2.updateFunctionDeclaration(input, ensureModifiers(input), /*asteriskToken*/ void 0, input.name, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input), /*body*/ void 0));
                        if (clean2 && resolver.isExpandoFunctionDeclaration(input) && shouldEmitFunctionProperties(input)) {
                            const props = resolver.getPropertiesOfContainerFunction(input);
                            if (isolatedDeclarations) reportExpandoFunctionErrors(input);
                            const fakespace = parseNodeFactory.createModuleDeclaration(/*modifiers*/ void 0, clean2.name || factory2.createIdentifier("_default"), factory2.createModuleBlock([]), 32 /* Namespace */ );
                            setParent(fakespace, enclosingDeclaration);
                            fakespace.locals = createSymbolTable(props);
                            fakespace.symbol = props[0].parent;
                            const exportMappings = [];
                            let declarations = mapDefined(props, (p)=>{
                                if (!isExpandoPropertyDeclaration(p.valueDeclaration)) return void 0;
                                const nameStr = unescapeLeadingUnderscores(p.escapedName);
                                if (!isIdentifierText(nameStr, 99 /* ESNext */ )) return void 0;
                                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(p.valueDeclaration);
                                const type = resolver.createTypeOfDeclaration(p.valueDeclaration, fakespace, declarationEmitNodeBuilderFlags, declarationEmitInternalNodeBuilderFlags | 2 /* NoSyntacticPrinter */ , symbolTracker);
                                getSymbolAccessibilityDiagnostic = oldDiag;
                                const isNonContextualKeywordName = isStringANonContextualKeyword(nameStr);
                                const name = isNonContextualKeywordName ? factory2.getGeneratedNameForNode(p.valueDeclaration) : factory2.createIdentifier(nameStr);
                                if (isNonContextualKeywordName) exportMappings.push([
                                    name,
                                    nameStr
                                ]);
                                const varDecl = factory2.createVariableDeclaration(name, /*exclamationToken*/ void 0, type, /*initializer*/ void 0);
                                return factory2.createVariableStatement(isNonContextualKeywordName ? void 0 : [
                                    factory2.createToken(95 /* ExportKeyword */ )
                                ], factory2.createVariableDeclarationList([
                                    varDecl
                                ]));
                            });
                            if (!exportMappings.length) declarations = mapDefined(declarations, (declaration)=>factory2.replaceModifiers(declaration, 0 /* None */ ));
                            else declarations.push(factory2.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory2.createNamedExports(map(exportMappings, ([gen, exp])=>{
                                return factory2.createExportSpecifier(/*isTypeOnly*/ false, gen, exp);
                            }))));
                            const namespaceDecl = factory2.createModuleDeclaration(ensureModifiers(input), input.name, factory2.createModuleBlock(declarations), 32 /* Namespace */ );
                            if (!hasEffectiveModifier(clean2, 2048 /* Default */ )) return [
                                clean2,
                                namespaceDecl
                            ];
                            const modifiers = factory2.createModifiersFromModifierFlags(getEffectiveModifierFlags(clean2) & -2081 /* ExportDefault */  | 128 /* Ambient */ );
                            const cleanDeclaration = factory2.updateFunctionDeclaration(clean2, modifiers, /*asteriskToken*/ void 0, clean2.name, clean2.typeParameters, clean2.parameters, clean2.type, /*body*/ void 0);
                            const namespaceDeclaration = factory2.updateModuleDeclaration(namespaceDecl, modifiers, namespaceDecl.name, namespaceDecl.body);
                            const exportDefaultDeclaration = factory2.createExportAssignment(/*modifiers*/ void 0, /*isExportEquals*/ false, namespaceDecl.name);
                            if (isSourceFile(input.parent)) resultHasExternalModuleIndicator = true;
                            resultHasScopeMarker = true;
                            return [
                                cleanDeclaration,
                                namespaceDeclaration,
                                exportDefaultDeclaration
                            ];
                        } else return clean2;
                    }
                case 268 /* ModuleDeclaration */ :
                    {
                        needsDeclare = false;
                        const inner = input.body;
                        if (inner && inner.kind === 269 /* ModuleBlock */ ) {
                            const oldNeedsScopeFix = needsScopeFixMarker;
                            const oldHasScopeFix = resultHasScopeMarker;
                            resultHasScopeMarker = false;
                            needsScopeFixMarker = false;
                            const statements = visitNodes2(inner.statements, visitDeclarationStatements, isStatement);
                            let lateStatements = transformAndReplaceLatePaintedStatements(statements);
                            if (input.flags & 33554432 /* Ambient */ ) needsScopeFixMarker = false;
                            if (!isGlobalScopeAugmentation(input) && !hasScopeMarker2(lateStatements) && !resultHasScopeMarker) {
                                if (needsScopeFixMarker) lateStatements = factory2.createNodeArray([
                                    ...lateStatements,
                                    createEmptyExports(factory2)
                                ]);
                                else lateStatements = visitNodes2(lateStatements, stripExportModifiers, isStatement);
                            }
                            const body = factory2.updateModuleBlock(inner, lateStatements);
                            needsDeclare = previousNeedsDeclare;
                            needsScopeFixMarker = oldNeedsScopeFix;
                            resultHasScopeMarker = oldHasScopeFix;
                            const mods = ensureModifiers(input);
                            return cleanup(updateModuleDeclarationAndKeyword(input, mods, isExternalModuleAugmentation(input) ? rewriteModuleSpecifier2(input, input.name) : input.name, body));
                        } else {
                            needsDeclare = previousNeedsDeclare;
                            const mods = ensureModifiers(input);
                            needsDeclare = false;
                            visitNode(inner, visitDeclarationStatements);
                            const id = getOriginalNodeId(inner);
                            const body = lateStatementReplacementMap.get(id);
                            lateStatementReplacementMap.delete(id);
                            return cleanup(updateModuleDeclarationAndKeyword(input, mods, input.name, body));
                        }
                    }
                case 264 /* ClassDeclaration */ :
                    {
                        errorNameNode = input.name;
                        errorFallbackNode = input;
                        const modifiers = factory2.createNodeArray(ensureModifiers(input));
                        const typeParameters = ensureTypeParams(input, input.typeParameters);
                        const ctor = getFirstConstructorWithBody(input);
                        let parameterProperties;
                        if (ctor) {
                            const oldDiag2 = getSymbolAccessibilityDiagnostic;
                            parameterProperties = compact(flatMap(ctor.parameters, (param)=>{
                                if (!hasSyntacticModifier(param, 31 /* ParameterPropertyModifier */ ) || shouldStripInternal(param)) return;
                                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(param);
                                if (param.name.kind === 80 /* Identifier */ ) return preserveJsDoc(factory2.createPropertyDeclaration(ensureModifiers(param), param.name, param.questionToken, ensureType(param), ensureNoInitializer(param)), param);
                                else return walkBindingPattern(param.name);
                                function walkBindingPattern(pattern) {
                                    let elems;
                                    for (const elem of pattern.elements){
                                        if (isOmittedExpression(elem)) continue;
                                        if (isBindingPattern(elem.name)) elems = concatenate(elems, walkBindingPattern(elem.name));
                                        elems = elems || [];
                                        elems.push(factory2.createPropertyDeclaration(ensureModifiers(param), elem.name, /*questionOrExclamationToken*/ void 0, ensureType(elem), /*initializer*/ void 0));
                                    }
                                    return elems;
                                }
                            }));
                            getSymbolAccessibilityDiagnostic = oldDiag2;
                        }
                        const hasPrivateIdentifier = some(input.members, (member)=>!!member.name && isPrivateIdentifier(member.name));
                        const privateIdentifier = hasPrivateIdentifier ? [
                            factory2.createPropertyDeclaration(/*modifiers*/ void 0, factory2.createPrivateIdentifier("#private"), /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0)
                        ] : void 0;
                        const lateIndexes = resolver.createLateBoundIndexSignatures(input, enclosingDeclaration, declarationEmitNodeBuilderFlags, declarationEmitInternalNodeBuilderFlags, symbolTracker);
                        const memberNodes = concatenate(concatenate(concatenate(privateIdentifier, lateIndexes), parameterProperties), visitNodes2(input.members, visitDeclarationSubtree, isClassElement));
                        const members = factory2.createNodeArray(memberNodes);
                        const extendsClause = getEffectiveBaseTypeNode(input);
                        if (extendsClause && !isEntityNameExpression(extendsClause.expression) && extendsClause.expression.kind !== 106 /* NullKeyword */ ) {
                            const oldId = input.name ? unescapeLeadingUnderscores(input.name.escapedText) : "default";
                            const newId = factory2.createUniqueName(`${oldId}_base`, 16 /* Optimistic */ );
                            getSymbolAccessibilityDiagnostic = ()=>({
                                    diagnosticMessage: Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1,
                                    errorNode: extendsClause,
                                    typeName: input.name
                                });
                            const varDecl = factory2.createVariableDeclaration(newId, /*exclamationToken*/ void 0, resolver.createTypeOfExpression(extendsClause.expression, input, declarationEmitNodeBuilderFlags, declarationEmitInternalNodeBuilderFlags, symbolTracker), /*initializer*/ void 0);
                            const statement = factory2.createVariableStatement(needsDeclare ? [
                                factory2.createModifier(138 /* DeclareKeyword */ )
                            ] : [], factory2.createVariableDeclarationList([
                                varDecl
                            ], 2 /* Const */ ));
                            const heritageClauses = factory2.createNodeArray(map(input.heritageClauses, (clause)=>{
                                if (clause.token === 96 /* ExtendsKeyword */ ) {
                                    const oldDiag2 = getSymbolAccessibilityDiagnostic;
                                    getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNode(clause.types[0]);
                                    const newClause = factory2.updateHeritageClause(clause, map(clause.types, (t)=>factory2.updateExpressionWithTypeArguments(t, newId, visitNodes2(t.typeArguments, visitDeclarationSubtree, isTypeNode))));
                                    getSymbolAccessibilityDiagnostic = oldDiag2;
                                    return newClause;
                                }
                                return factory2.updateHeritageClause(clause, visitNodes2(factory2.createNodeArray(filter(clause.types, (t)=>isEntityNameExpression(t.expression) || t.expression.kind === 106 /* NullKeyword */ )), visitDeclarationSubtree, isExpressionWithTypeArguments));
                            }));
                            return [
                                statement,
                                cleanup(factory2.updateClassDeclaration(input, modifiers, input.name, typeParameters, heritageClauses, members))
                            ];
                        } else {
                            const heritageClauses = transformHeritageClauses(input.heritageClauses);
                            return cleanup(factory2.updateClassDeclaration(input, modifiers, input.name, typeParameters, heritageClauses, members));
                        }
                    }
                case 244 /* VariableStatement */ :
                    return cleanup(transformVariableStatement(input));
                case 267 /* EnumDeclaration */ :
                    return cleanup(factory2.updateEnumDeclaration(input, factory2.createNodeArray(ensureModifiers(input)), input.name, factory2.createNodeArray(mapDefined(input.members, (m)=>{
                        if (shouldStripInternal(m)) return;
                        const enumValue = resolver.getEnumMemberValue(m);
                        const constValue = enumValue == null ? void 0 : enumValue.value;
                        if (isolatedDeclarations && m.initializer && (enumValue == null ? void 0 : enumValue.hasExternalReferences) && // This will be its own compiler error instead, so don't report.
                        !isComputedPropertyName(m.name)) context.addDiagnostic(createDiagnosticForNode(m, Diagnostics.Enum_member_initializers_must_be_computable_without_references_to_external_symbols_with_isolatedDeclarations));
                        const newInitializer = constValue === void 0 ? void 0 : typeof constValue === "string" ? factory2.createStringLiteral(constValue) : constValue < 0 ? factory2.createPrefixUnaryExpression(41 /* MinusToken */ , factory2.createNumericLiteral(-constValue)) : factory2.createNumericLiteral(constValue);
                        return preserveJsDoc(factory2.updateEnumMember(m, m.name, newInitializer), m);
                    }))));
            }
            return Debug.assertNever(input, `Unhandled top-level node in declaration emit: ${Debug.formatSyntaxKind(input.kind)}`);
            function cleanup(node) {
                if (isEnclosingDeclaration(input)) enclosingDeclaration = previousEnclosingDeclaration;
                if (canProdiceDiagnostic) getSymbolAccessibilityDiagnostic = oldDiag;
                if (input.kind === 268 /* ModuleDeclaration */ ) needsDeclare = previousNeedsDeclare;
                if (node === input) return node;
                errorFallbackNode = void 0;
                errorNameNode = void 0;
                return node && setOriginalNode(preserveJsDoc(node, input), input);
            }
        }
        function transformVariableStatement(input) {
            if (!forEach(input.declarationList.declarations, getBindingNameVisible)) return;
            const nodes = visitNodes2(input.declarationList.declarations, visitDeclarationSubtree, isVariableDeclaration);
            if (!length(nodes)) return;
            const modifiers = factory2.createNodeArray(ensureModifiers(input));
            let declList;
            if (isVarUsing(input.declarationList) || isVarAwaitUsing(input.declarationList)) {
                declList = factory2.createVariableDeclarationList(nodes, 2 /* Const */ );
                setOriginalNode(declList, input.declarationList);
                setTextRange(declList, input.declarationList);
                setCommentRange(declList, input.declarationList);
            } else declList = factory2.updateVariableDeclarationList(input.declarationList, nodes);
            return factory2.updateVariableStatement(input, modifiers, declList);
        }
        function recreateBindingPattern(d) {
            return flatten(mapDefined(d.elements, (e)=>recreateBindingElement(e)));
        }
        function recreateBindingElement(e) {
            if (e.kind === 233 /* OmittedExpression */ ) return;
            if (e.name) {
                if (!getBindingNameVisible(e)) return;
                if (isBindingPattern(e.name)) return recreateBindingPattern(e.name);
                else return factory2.createVariableDeclaration(e.name, /*exclamationToken*/ void 0, ensureType(e), /*initializer*/ void 0);
            }
        }
        function checkName(node) {
            let oldDiag;
            if (!suppressNewDiagnosticContexts) {
                oldDiag = getSymbolAccessibilityDiagnostic;
                getSymbolAccessibilityDiagnostic = createGetSymbolAccessibilityDiagnosticForNodeName(node);
            }
            errorNameNode = node.name;
            Debug.assert(hasDynamicName(node));
            const decl = node;
            const entityName = decl.name.expression;
            checkEntityNameVisibility(entityName, enclosingDeclaration);
            if (!suppressNewDiagnosticContexts) getSymbolAccessibilityDiagnostic = oldDiag;
            errorNameNode = void 0;
        }
        function shouldStripInternal(node) {
            return !!stripInternal && !!node && isInternalDeclaration(node, currentSourceFile);
        }
        function isScopeMarker2(node) {
            return isExportAssignment(node) || isExportDeclaration(node);
        }
        function hasScopeMarker2(statements) {
            return some(statements, isScopeMarker2);
        }
        function ensureModifiers(node) {
            const currentFlags = getEffectiveModifierFlags(node);
            const newFlags = ensureModifierFlags(node);
            if (currentFlags === newFlags) return visitArray(node.modifiers, (n)=>tryCast(n, isModifier), isModifier);
            return factory2.createModifiersFromModifierFlags(newFlags);
        }
        function ensureModifierFlags(node) {
            let mask2 = 130030;
            let additions = needsDeclare && !isAlwaysType(node) ? 128 /* Ambient */  : 0 /* None */ ;
            const parentIsFile = node.parent.kind === 308 /* SourceFile */ ;
            if (!parentIsFile || isBundledEmit && parentIsFile && isExternalModule(node.parent)) {
                mask2 ^= 128 /* Ambient */ ;
                additions = 0 /* None */ ;
            }
            return maskModifierFlags(node, mask2, additions);
        }
        function transformHeritageClauses(nodes) {
            return factory2.createNodeArray(filter(map(nodes, (clause)=>factory2.updateHeritageClause(clause, visitNodes2(factory2.createNodeArray(filter(clause.types, (t)=>{
                    return isEntityNameExpression(t.expression) || clause.token === 96 /* ExtendsKeyword */  && t.expression.kind === 106 /* NullKeyword */ ;
                })), visitDeclarationSubtree, isExpressionWithTypeArguments))), (clause)=>clause.types && !!clause.types.length));
        }
    }
    function isAlwaysType(node) {
        if (node.kind === 265 /* InterfaceDeclaration */ ) return true;
        return false;
    }
    function maskModifiers(factory2, node, modifierMask, modifierAdditions) {
        return factory2.createModifiersFromModifierFlags(maskModifierFlags(node, modifierMask, modifierAdditions));
    }
    function maskModifierFlags(node, modifierMask = 131070 /* Public */ , modifierAdditions = 0 /* None */ ) {
        let flags = getEffectiveModifierFlags(node) & modifierMask | modifierAdditions;
        if (flags & 2048 /* Default */  && !(flags & 32 /* Export */ )) flags ^= 32 /* Export */ ;
        if (flags & 2048 /* Default */  && flags & 128 /* Ambient */ ) flags ^= 128 /* Ambient */ ;
        return flags;
    }
    function canHaveLiteralInitializer(node) {
        switch(node.kind){
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
                return !hasEffectiveModifier(node, 2 /* Private */ );
            case 170 /* Parameter */ :
            case 261 /* VariableDeclaration */ :
                return true;
        }
        return false;
    }
    function isPreservedDeclarationStatement(node) {
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 244 /* VariableStatement */ :
            case 273 /* ImportDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 278 /* ExportAssignment */ :
                return true;
        }
        return false;
    }
    function isProcessedComponent(node) {
        switch(node.kind){
            case 181 /* ConstructSignature */ :
            case 177 /* Constructor */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 174 /* MethodSignature */ :
            case 180 /* CallSignature */ :
            case 182 /* IndexSignature */ :
            case 261 /* VariableDeclaration */ :
            case 169 /* TypeParameter */ :
            case 234 /* ExpressionWithTypeArguments */ :
            case 184 /* TypeReference */ :
            case 195 /* ConditionalType */ :
            case 185 /* FunctionType */ :
            case 186 /* ConstructorType */ :
            case 206 /* ImportType */ :
                return true;
        }
        return false;
    }
    // src/compiler/transformer.ts
    function getModuleTransformer(moduleKind) {
        switch(moduleKind){
            case 200 /* Preserve */ :
                return transformECMAScriptModule;
            case 99 /* ESNext */ :
            case 7 /* ES2022 */ :
            case 6 /* ES2020 */ :
            case 5 /* ES2015 */ :
            case 100 /* Node16 */ :
            case 101 /* Node18 */ :
            case 102 /* Node20 */ :
            case 199 /* NodeNext */ :
            case 1 /* CommonJS */ :
                return transformImpliedNodeFormatDependentModule;
            case 4 /* System */ :
                return transformSystemModule;
            default:
                return transformModule;
        }
    }
    var noTransformers = {
        scriptTransformers: emptyArray,
        declarationTransformers: emptyArray
    };
    function getTransformers(compilerOptions, customTransformers, emitOnly) {
        return {
            scriptTransformers: getScriptTransformers(compilerOptions, customTransformers, emitOnly),
            declarationTransformers: getDeclarationTransformers(customTransformers)
        };
    }
    function getScriptTransformers(compilerOptions, customTransformers, emitOnly) {
        if (emitOnly) return emptyArray;
        const languageVersion = getEmitScriptTarget(compilerOptions);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const useDefineForClassFields = getUseDefineForClassFields(compilerOptions);
        const transformers = [];
        addRange(transformers, customTransformers && map(customTransformers.before, wrapScriptTransformerFactory));
        transformers.push(transformTypeScript);
        if (compilerOptions.experimentalDecorators) transformers.push(transformLegacyDecorators);
        if (getJSXTransformEnabled(compilerOptions)) transformers.push(transformJsx);
        if (languageVersion < 99 /* ESNext */ ) transformers.push(transformESNext);
        if (!compilerOptions.experimentalDecorators && (languageVersion < 99 /* ESNext */  || !useDefineForClassFields)) transformers.push(transformESDecorators);
        transformers.push(transformClassFields);
        if (languageVersion < 8 /* ES2021 */ ) transformers.push(transformES2021);
        if (languageVersion < 7 /* ES2020 */ ) transformers.push(transformES2020);
        if (languageVersion < 6 /* ES2019 */ ) transformers.push(transformES2019);
        if (languageVersion < 5 /* ES2018 */ ) transformers.push(transformES2018);
        if (languageVersion < 4 /* ES2017 */ ) transformers.push(transformES2017);
        if (languageVersion < 3 /* ES2016 */ ) transformers.push(transformES2016);
        if (languageVersion < 2 /* ES2015 */ ) {
            transformers.push(transformES2015);
            transformers.push(transformGenerators);
        }
        transformers.push(getModuleTransformer(moduleKind));
        addRange(transformers, customTransformers && map(customTransformers.after, wrapScriptTransformerFactory));
        return transformers;
    }
    function getDeclarationTransformers(customTransformers) {
        const transformers = [];
        transformers.push(transformDeclarations);
        addRange(transformers, customTransformers && map(customTransformers.afterDeclarations, wrapDeclarationTransformerFactory));
        return transformers;
    }
    function wrapCustomTransformer(transformer) {
        return (node)=>isBundle(node) ? transformer.transformBundle(node) : transformer.transformSourceFile(node);
    }
    function wrapCustomTransformerFactory(transformer, handleDefault) {
        return (context)=>{
            const customTransformer = transformer(context);
            return typeof customTransformer === "function" ? handleDefault(context, customTransformer) : wrapCustomTransformer(customTransformer);
        };
    }
    function wrapScriptTransformerFactory(transformer) {
        return wrapCustomTransformerFactory(transformer, chainBundle);
    }
    function wrapDeclarationTransformerFactory(transformer) {
        return wrapCustomTransformerFactory(transformer, (_, node)=>node);
    }
    function noEmitSubstitution(_hint, node) {
        return node;
    }
    function noEmitNotification(hint, node, callback) {
        callback(hint, node);
    }
    function transformNodes(resolver, host, factory2, options, nodes, transformers, allowDtsFiles) {
        var _a, _b;
        const enabledSyntaxKindFeatures = new Array(359 /* Count */ );
        let lexicalEnvironmentVariableDeclarations;
        let lexicalEnvironmentFunctionDeclarations;
        let lexicalEnvironmentStatements;
        let lexicalEnvironmentFlags = 0 /* None */ ;
        let lexicalEnvironmentVariableDeclarationsStack = [];
        let lexicalEnvironmentFunctionDeclarationsStack = [];
        let lexicalEnvironmentStatementsStack = [];
        let lexicalEnvironmentFlagsStack = [];
        let lexicalEnvironmentStackOffset = 0;
        let lexicalEnvironmentSuspended = false;
        let blockScopedVariableDeclarationsStack = [];
        let blockScopeStackOffset = 0;
        let blockScopedVariableDeclarations;
        let emitHelpers;
        let onSubstituteNode = noEmitSubstitution;
        let onEmitNode = noEmitNotification;
        let state = 0 /* Uninitialized */ ;
        const diagnostics = [];
        const context = {
            factory: factory2,
            getCompilerOptions: ()=>options,
            getEmitResolver: ()=>resolver,
            // TODO: GH#18217
            getEmitHost: ()=>host,
            // TODO: GH#18217
            getEmitHelperFactory: memoize(()=>createEmitHelperFactory(context)),
            startLexicalEnvironment,
            suspendLexicalEnvironment,
            resumeLexicalEnvironment,
            endLexicalEnvironment,
            setLexicalEnvironmentFlags,
            getLexicalEnvironmentFlags,
            hoistVariableDeclaration,
            hoistFunctionDeclaration,
            addInitializationStatement,
            startBlockScope,
            endBlockScope,
            addBlockScopedVariable,
            requestEmitHelper,
            readEmitHelpers,
            enableSubstitution,
            enableEmitNotification,
            isSubstitutionEnabled,
            isEmitNotificationEnabled,
            get onSubstituteNode () {
                return onSubstituteNode;
            },
            set onSubstituteNode (value){
                Debug.assert(state < 1 /* Initialized */ , "Cannot modify transformation hooks after initialization has completed.");
                Debug.assert(value !== void 0, "Value must not be 'undefined'");
                onSubstituteNode = value;
            },
            get onEmitNode () {
                return onEmitNode;
            },
            set onEmitNode (value){
                Debug.assert(state < 1 /* Initialized */ , "Cannot modify transformation hooks after initialization has completed.");
                Debug.assert(value !== void 0, "Value must not be 'undefined'");
                onEmitNode = value;
            },
            addDiagnostic (diag2) {
                diagnostics.push(diag2);
            }
        };
        for (const node of nodes)disposeEmitNodes(getSourceFileOfNode(getParseTreeNode(node)));
        mark("beforeTransform");
        const transformersWithContext = transformers.map((t)=>t(context));
        const transformation = (node)=>{
            for (const transform2 of transformersWithContext)node = transform2(node);
            return node;
        };
        state = 1 /* Initialized */ ;
        const transformed = [];
        for (const node of nodes){
            (_a = tracing) == null || _a.push(tracing.Phase.Emit, "transformNodes", node.kind === 308 /* SourceFile */  ? {
                path: node.path
            } : {
                kind: node.kind,
                pos: node.pos,
                end: node.end
            });
            transformed.push((allowDtsFiles ? transformation : transformRoot)(node));
            (_b = tracing) == null || _b.pop();
        }
        state = 2 /* Completed */ ;
        mark("afterTransform");
        measure("transformTime", "beforeTransform", "afterTransform");
        return {
            transformed,
            substituteNode,
            emitNodeWithNotification,
            isEmitNotificationEnabled,
            dispose,
            diagnostics
        };
        function transformRoot(node) {
            return node && (!isSourceFile(node) || !node.isDeclarationFile) ? transformation(node) : node;
        }
        function enableSubstitution(kind) {
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            enabledSyntaxKindFeatures[kind] |= 1 /* Substitution */ ;
        }
        function isSubstitutionEnabled(node) {
            return (enabledSyntaxKindFeatures[node.kind] & 1 /* Substitution */ ) !== 0 && (getEmitFlags(node) & 8 /* NoSubstitution */ ) === 0;
        }
        function substituteNode(hint, node) {
            Debug.assert(state < 3 /* Disposed */ , "Cannot substitute a node after the result is disposed.");
            return node && isSubstitutionEnabled(node) && onSubstituteNode(hint, node) || node;
        }
        function enableEmitNotification(kind) {
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            enabledSyntaxKindFeatures[kind] |= 2 /* EmitNotifications */ ;
        }
        function isEmitNotificationEnabled(node) {
            return (enabledSyntaxKindFeatures[node.kind] & 2 /* EmitNotifications */ ) !== 0 || (getEmitFlags(node) & 4 /* AdviseOnEmitNode */ ) !== 0;
        }
        function emitNodeWithNotification(hint, node, emitCallback) {
            Debug.assert(state < 3 /* Disposed */ , "Cannot invoke TransformationResult callbacks after the result is disposed.");
            if (node) {
                if (isEmitNotificationEnabled(node)) onEmitNode(hint, node, emitCallback);
                else emitCallback(hint, node);
            }
        }
        function hoistVariableDeclaration(name) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            const decl = setEmitFlags(factory2.createVariableDeclaration(name), 128 /* NoNestedSourceMaps */ );
            if (!lexicalEnvironmentVariableDeclarations) lexicalEnvironmentVariableDeclarations = [
                decl
            ];
            else lexicalEnvironmentVariableDeclarations.push(decl);
            if (lexicalEnvironmentFlags & 1 /* InParameters */ ) lexicalEnvironmentFlags |= 2 /* VariablesHoistedInParameters */ ;
        }
        function hoistFunctionDeclaration(func) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            setEmitFlags(func, 2097152 /* CustomPrologue */ );
            if (!lexicalEnvironmentFunctionDeclarations) lexicalEnvironmentFunctionDeclarations = [
                func
            ];
            else lexicalEnvironmentFunctionDeclarations.push(func);
        }
        function addInitializationStatement(node) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            setEmitFlags(node, 2097152 /* CustomPrologue */ );
            if (!lexicalEnvironmentStatements) lexicalEnvironmentStatements = [
                node
            ];
            else lexicalEnvironmentStatements.push(node);
        }
        function startLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
            lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentVariableDeclarations;
            lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentFunctionDeclarations;
            lexicalEnvironmentStatementsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentStatements;
            lexicalEnvironmentFlagsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentFlags;
            lexicalEnvironmentStackOffset++;
            lexicalEnvironmentVariableDeclarations = void 0;
            lexicalEnvironmentFunctionDeclarations = void 0;
            lexicalEnvironmentStatements = void 0;
            lexicalEnvironmentFlags = 0 /* None */ ;
        }
        function suspendLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is already suspended.");
            lexicalEnvironmentSuspended = true;
        }
        function resumeLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(lexicalEnvironmentSuspended, "Lexical environment is not suspended.");
            lexicalEnvironmentSuspended = false;
        }
        function endLexicalEnvironment() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the lexical environment during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the lexical environment after transformation has completed.");
            Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
            let statements;
            if (lexicalEnvironmentVariableDeclarations || lexicalEnvironmentFunctionDeclarations || lexicalEnvironmentStatements) {
                if (lexicalEnvironmentFunctionDeclarations) statements = [
                    ...lexicalEnvironmentFunctionDeclarations
                ];
                if (lexicalEnvironmentVariableDeclarations) {
                    const statement = factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(lexicalEnvironmentVariableDeclarations));
                    setEmitFlags(statement, 2097152 /* CustomPrologue */ );
                    if (!statements) statements = [
                        statement
                    ];
                    else statements.push(statement);
                }
                if (lexicalEnvironmentStatements) {
                    if (!statements) statements = [
                        ...lexicalEnvironmentStatements
                    ];
                    else statements = [
                        ...statements,
                        ...lexicalEnvironmentStatements
                    ];
                }
            }
            lexicalEnvironmentStackOffset--;
            lexicalEnvironmentVariableDeclarations = lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset];
            lexicalEnvironmentFunctionDeclarations = lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset];
            lexicalEnvironmentStatements = lexicalEnvironmentStatementsStack[lexicalEnvironmentStackOffset];
            lexicalEnvironmentFlags = lexicalEnvironmentFlagsStack[lexicalEnvironmentStackOffset];
            if (lexicalEnvironmentStackOffset === 0) {
                lexicalEnvironmentVariableDeclarationsStack = [];
                lexicalEnvironmentFunctionDeclarationsStack = [];
                lexicalEnvironmentStatementsStack = [];
                lexicalEnvironmentFlagsStack = [];
            }
            return statements;
        }
        function setLexicalEnvironmentFlags(flags, value1) {
            lexicalEnvironmentFlags = value1 ? lexicalEnvironmentFlags | flags : lexicalEnvironmentFlags & ~flags;
        }
        function getLexicalEnvironmentFlags() {
            return lexicalEnvironmentFlags;
        }
        function startBlockScope() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot start a block scope during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot start a block scope after transformation has completed.");
            blockScopedVariableDeclarationsStack[blockScopeStackOffset] = blockScopedVariableDeclarations;
            blockScopeStackOffset++;
            blockScopedVariableDeclarations = void 0;
        }
        function endBlockScope() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot end a block scope during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot end a block scope after transformation has completed.");
            const statements = some(blockScopedVariableDeclarations) ? [
                factory2.createVariableStatement(/*modifiers*/ void 0, factory2.createVariableDeclarationList(blockScopedVariableDeclarations.map((identifier)=>factory2.createVariableDeclaration(identifier)), 1 /* Let */ ))
            ] : void 0;
            blockScopeStackOffset--;
            blockScopedVariableDeclarations = blockScopedVariableDeclarationsStack[blockScopeStackOffset];
            if (blockScopeStackOffset === 0) blockScopedVariableDeclarationsStack = [];
            return statements;
        }
        function addBlockScopedVariable(name) {
            Debug.assert(blockScopeStackOffset > 0, "Cannot add a block scoped variable outside of an iteration body.");
            (blockScopedVariableDeclarations || (blockScopedVariableDeclarations = [])).push(name);
        }
        function requestEmitHelper(helper) {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the transformation context during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            Debug.assert(!helper.scoped, "Cannot request a scoped emit helper.");
            if (helper.dependencies) for (const h of helper.dependencies)requestEmitHelper(h);
            emitHelpers = append(emitHelpers, helper);
        }
        function readEmitHelpers() {
            Debug.assert(state > 0 /* Uninitialized */ , "Cannot modify the transformation context during initialization.");
            Debug.assert(state < 2 /* Completed */ , "Cannot modify the transformation context after transformation has completed.");
            const helpers = emitHelpers;
            emitHelpers = void 0;
            return helpers;
        }
        function dispose() {
            if (state < 3 /* Disposed */ ) {
                for (const node of nodes)disposeEmitNodes(getSourceFileOfNode(getParseTreeNode(node)));
                lexicalEnvironmentVariableDeclarations = void 0;
                lexicalEnvironmentVariableDeclarationsStack = void 0;
                lexicalEnvironmentFunctionDeclarations = void 0;
                lexicalEnvironmentFunctionDeclarationsStack = void 0;
                onSubstituteNode = void 0;
                onEmitNode = void 0;
                emitHelpers = void 0;
                state = 3 /* Disposed */ ;
            }
        }
    }
    var nullTransformationContext = {
        factory,
        // eslint-disable-line object-shorthand
        getCompilerOptions: ()=>({}),
        getEmitResolver: notImplemented,
        getEmitHost: notImplemented,
        getEmitHelperFactory: notImplemented,
        startLexicalEnvironment: noop,
        resumeLexicalEnvironment: noop,
        suspendLexicalEnvironment: noop,
        endLexicalEnvironment: returnUndefined,
        setLexicalEnvironmentFlags: noop,
        getLexicalEnvironmentFlags: ()=>0,
        hoistVariableDeclaration: noop,
        hoistFunctionDeclaration: noop,
        addInitializationStatement: noop,
        startBlockScope: noop,
        endBlockScope: returnUndefined,
        addBlockScopedVariable: noop,
        requestEmitHelper: noop,
        readEmitHelpers: notImplemented,
        enableSubstitution: noop,
        enableEmitNotification: noop,
        isSubstitutionEnabled: notImplemented,
        isEmitNotificationEnabled: notImplemented,
        onSubstituteNode: noEmitSubstitution,
        onEmitNode: noEmitNotification,
        addDiagnostic: noop
    };
    // src/compiler/emitter.ts
    var brackets = createBracketsMap();
    function isBuildInfoFile(file) {
        return fileExtensionIs(file, ".tsbuildinfo" /* TsBuildInfo */ );
    }
    function forEachEmittedFile(host, action, sourceFilesOrTargetSourceFile, forceDtsEmit = false, onlyBuildInfo, includeBuildInfo) {
        const sourceFiles = isArray(sourceFilesOrTargetSourceFile) ? sourceFilesOrTargetSourceFile : getSourceFilesToEmit(host, sourceFilesOrTargetSourceFile, forceDtsEmit);
        const options = host.getCompilerOptions();
        if (!onlyBuildInfo) {
            if (options.outFile) {
                if (sourceFiles.length) {
                    const bundle = factory.createBundle(sourceFiles);
                    const result = action(getOutputPathsFor(bundle, host, forceDtsEmit), bundle);
                    if (result) return result;
                }
            } else for (const sourceFile of sourceFiles){
                const result = action(getOutputPathsFor(sourceFile, host, forceDtsEmit), sourceFile);
                if (result) return result;
            }
        }
        if (includeBuildInfo) {
            const buildInfoPath = getTsBuildInfoEmitOutputFilePath(options);
            if (buildInfoPath) return action({
                buildInfoPath
            }, /*sourceFileOrBundle*/ void 0);
        }
    }
    function getTsBuildInfoEmitOutputFilePath(options) {
        const configFile = options.configFilePath;
        if (!canEmitTsBuildInfo(options)) return void 0;
        if (options.tsBuildInfoFile) return options.tsBuildInfoFile;
        const outPath = options.outFile;
        let buildInfoExtensionLess;
        if (outPath) buildInfoExtensionLess = removeFileExtension(outPath);
        else {
            if (!configFile) return void 0;
            const configFileExtensionLess = removeFileExtension(configFile);
            buildInfoExtensionLess = options.outDir ? options.rootDir ? resolvePath(options.outDir, getRelativePathFromDirectory(options.rootDir, configFileExtensionLess, /*ignoreCase*/ true)) : combinePaths(options.outDir, getBaseFileName(configFileExtensionLess)) : configFileExtensionLess;
        }
        return buildInfoExtensionLess + ".tsbuildinfo" /* TsBuildInfo */ ;
    }
    function canEmitTsBuildInfo(options) {
        return isIncrementalCompilation(options) || !!options.tscBuild;
    }
    function getOutputPathsForBundle(options, forceDtsPaths) {
        const outPath = options.outFile;
        const jsFilePath = options.emitDeclarationOnly ? void 0 : outPath;
        const sourceMapFilePath = jsFilePath && getSourceMapFilePath(jsFilePath, options);
        const declarationFilePath = forceDtsPaths || getEmitDeclarations(options) ? removeFileExtension(outPath) + ".d.ts" /* Dts */  : void 0;
        const declarationMapPath = declarationFilePath && getAreDeclarationMapsEnabled(options) ? declarationFilePath + ".map" : void 0;
        return {
            jsFilePath,
            sourceMapFilePath,
            declarationFilePath,
            declarationMapPath
        };
    }
    function getOutputPathsFor(sourceFile, host, forceDtsPaths) {
        const options = host.getCompilerOptions();
        if (sourceFile.kind === 309 /* Bundle */ ) return getOutputPathsForBundle(options, forceDtsPaths);
        else {
            const ownOutputFilePath = getOwnEmitOutputFilePath(sourceFile.fileName, host, getOutputExtension(sourceFile.fileName, options));
            const isJsonFile = isJsonSourceFile(sourceFile);
            const isJsonEmittedToSameLocation = isJsonFile && comparePaths(sourceFile.fileName, ownOutputFilePath, host.getCurrentDirectory(), !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */ ;
            const jsFilePath = options.emitDeclarationOnly || isJsonEmittedToSameLocation ? void 0 : ownOutputFilePath;
            const sourceMapFilePath = !jsFilePath || isJsonSourceFile(sourceFile) ? void 0 : getSourceMapFilePath(jsFilePath, options);
            const declarationFilePath = forceDtsPaths || getEmitDeclarations(options) && !isJsonFile ? getDeclarationEmitOutputFilePath(sourceFile.fileName, host) : void 0;
            const declarationMapPath = declarationFilePath && getAreDeclarationMapsEnabled(options) ? declarationFilePath + ".map" : void 0;
            return {
                jsFilePath,
                sourceMapFilePath,
                declarationFilePath,
                declarationMapPath
            };
        }
    }
    function getSourceMapFilePath(jsFilePath, options) {
        return options.sourceMap && !options.inlineSourceMap ? jsFilePath + ".map" : void 0;
    }
    function getOutputExtension(fileName, options) {
        return fileExtensionIs(fileName, ".json" /* Json */ ) ? ".json" /* Json */  : options.jsx === 1 /* Preserve */  && fileExtensionIsOneOf(fileName, [
            ".jsx" /* Jsx */ ,
            ".tsx" /* Tsx */ 
        ]) ? ".jsx" /* Jsx */  : fileExtensionIsOneOf(fileName, [
            ".mts" /* Mts */ ,
            ".mjs" /* Mjs */ 
        ]) ? ".mjs" /* Mjs */  : fileExtensionIsOneOf(fileName, [
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ]) ? ".cjs" /* Cjs */  : ".js" /* Js */ ;
    }
    function getOutputPathWithoutChangingExt(inputFileName, ignoreCase, outputDir, getCommonSourceDirectory2) {
        return outputDir ? resolvePath(outputDir, getRelativePathFromDirectory(getCommonSourceDirectory2(), inputFileName, ignoreCase)) : inputFileName;
    }
    function getOutputDeclarationFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2 = ()=>getCommonSourceDirectoryOfConfig(configFile, ignoreCase)) {
        return getOutputDeclarationFileNameWorker(inputFileName, configFile.options, ignoreCase, getCommonSourceDirectory2);
    }
    function getOutputDeclarationFileNameWorker(inputFileName, options, ignoreCase, getCommonSourceDirectory2) {
        return changeExtension(getOutputPathWithoutChangingExt(inputFileName, ignoreCase, options.declarationDir || options.outDir, getCommonSourceDirectory2), getDeclarationEmitExtensionForPath(inputFileName));
    }
    function getOutputJSFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2 = ()=>getCommonSourceDirectoryOfConfig(configFile, ignoreCase)) {
        if (configFile.options.emitDeclarationOnly) return void 0;
        const isJsonFile = fileExtensionIs(inputFileName, ".json" /* Json */ );
        const outputFileName = getOutputJSFileNameWorker(inputFileName, configFile.options, ignoreCase, getCommonSourceDirectory2);
        return !isJsonFile || comparePaths(inputFileName, outputFileName, Debug.checkDefined(configFile.options.configFilePath), ignoreCase) !== 0 /* EqualTo */  ? outputFileName : void 0;
    }
    function getOutputJSFileNameWorker(inputFileName, options, ignoreCase, getCommonSourceDirectory2) {
        return changeExtension(getOutputPathWithoutChangingExt(inputFileName, ignoreCase, options.outDir, getCommonSourceDirectory2), getOutputExtension(inputFileName, options));
    }
    function createAddOutput() {
        let outputs;
        return {
            addOutput,
            getOutputs
        };
        function addOutput(path) {
            if (path) (outputs || (outputs = [])).push(path);
        }
        function getOutputs() {
            return outputs || emptyArray;
        }
    }
    function getSingleOutputFileNames(configFile, addOutput) {
        const { jsFilePath, sourceMapFilePath, declarationFilePath, declarationMapPath } = getOutputPathsForBundle(configFile.options, /*forceDtsPaths*/ false);
        addOutput(jsFilePath);
        addOutput(sourceMapFilePath);
        addOutput(declarationFilePath);
        addOutput(declarationMapPath);
    }
    function getOwnOutputFileNames(configFile, inputFileName, ignoreCase, addOutput, getCommonSourceDirectory2) {
        if (isDeclarationFileName(inputFileName)) return;
        const js = getOutputJSFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
        addOutput(js);
        if (fileExtensionIs(inputFileName, ".json" /* Json */ )) return;
        if (js && configFile.options.sourceMap) addOutput(`${js}.map`);
        if (getEmitDeclarations(configFile.options)) {
            const dts = getOutputDeclarationFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
            addOutput(dts);
            if (configFile.options.declarationMap) addOutput(`${dts}.map`);
        }
    }
    function getCommonSourceDirectory(options, emittedFiles, currentDirectory, getCanonicalFileName, checkSourceFilesBelongToPath) {
        let commonSourceDirectory;
        if (options.rootDir) {
            commonSourceDirectory = getNormalizedAbsolutePath(options.rootDir, currentDirectory);
            checkSourceFilesBelongToPath == null || checkSourceFilesBelongToPath(options.rootDir);
        } else if (options.composite && options.configFilePath) {
            commonSourceDirectory = getDirectoryPath(normalizeSlashes(options.configFilePath));
            checkSourceFilesBelongToPath == null || checkSourceFilesBelongToPath(commonSourceDirectory);
        } else commonSourceDirectory = computeCommonSourceDirectoryOfFilenames(emittedFiles(), currentDirectory, getCanonicalFileName);
        if (commonSourceDirectory && commonSourceDirectory[commonSourceDirectory.length - 1] !== directorySeparator) commonSourceDirectory += directorySeparator;
        return commonSourceDirectory;
    }
    function getCommonSourceDirectoryOfConfig({ options, fileNames }, ignoreCase) {
        return getCommonSourceDirectory(options, ()=>filter(fileNames, (file)=>!(options.noEmitForJsFiles && fileExtensionIsOneOf(file, supportedJSExtensionsFlat)) && !isDeclarationFileName(file)), getDirectoryPath(normalizeSlashes(Debug.checkDefined(options.configFilePath))), createGetCanonicalFileName(!ignoreCase));
    }
    function getAllProjectOutputs(configFile, ignoreCase) {
        const { addOutput, getOutputs } = createAddOutput();
        if (configFile.options.outFile) getSingleOutputFileNames(configFile, addOutput);
        else {
            const getCommonSourceDirectory2 = memoize(()=>getCommonSourceDirectoryOfConfig(configFile, ignoreCase));
            for (const inputFileName of configFile.fileNames)getOwnOutputFileNames(configFile, inputFileName, ignoreCase, addOutput, getCommonSourceDirectory2);
        }
        addOutput(getTsBuildInfoEmitOutputFilePath(configFile.options));
        return getOutputs();
    }
    function getOutputFileNames(commandLine, inputFileName, ignoreCase) {
        inputFileName = normalizePath(inputFileName);
        Debug.assert(contains(commandLine.fileNames, inputFileName), `Expected fileName to be present in command line`);
        const { addOutput, getOutputs } = createAddOutput();
        if (commandLine.options.outFile) getSingleOutputFileNames(commandLine, addOutput);
        else getOwnOutputFileNames(commandLine, inputFileName, ignoreCase, addOutput);
        return getOutputs();
    }
    function getFirstProjectOutput(configFile, ignoreCase) {
        if (configFile.options.outFile) {
            const { jsFilePath, declarationFilePath } = getOutputPathsForBundle(configFile.options, /*forceDtsPaths*/ false);
            return Debug.checkDefined(jsFilePath || declarationFilePath, `project ${configFile.options.configFilePath} expected to have at least one output`);
        }
        const getCommonSourceDirectory2 = memoize(()=>getCommonSourceDirectoryOfConfig(configFile, ignoreCase));
        for (const inputFileName of configFile.fileNames){
            if (isDeclarationFileName(inputFileName)) continue;
            const jsFilePath = getOutputJSFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
            if (jsFilePath) return jsFilePath;
            if (fileExtensionIs(inputFileName, ".json" /* Json */ )) continue;
            if (getEmitDeclarations(configFile.options)) return getOutputDeclarationFileName(inputFileName, configFile, ignoreCase, getCommonSourceDirectory2);
        }
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(configFile.options);
        if (buildInfoPath) return buildInfoPath;
        return Debug.fail(`project ${configFile.options.configFilePath} expected to have at least one output`);
    }
    function emitResolverSkipsTypeChecking(emitOnly, forceDtsEmit) {
        return !!forceDtsEmit && !!emitOnly;
    }
    function emitFiles(resolver, host, targetSourceFile, { scriptTransformers, declarationTransformers }, emitOnly, onlyBuildInfo, forceDtsEmit, skipBuildInfo) {
        var compilerOptions = host.getCompilerOptions();
        var sourceMapDataList = compilerOptions.sourceMap || compilerOptions.inlineSourceMap || getAreDeclarationMapsEnabled(compilerOptions) ? [] : void 0;
        var emittedFilesList = compilerOptions.listEmittedFiles ? [] : void 0;
        var emitterDiagnostics = createDiagnosticCollection();
        var newLine = getNewLineCharacter(compilerOptions);
        var writer = createTextWriter(newLine);
        var { enter, exit } = createTimer("printTime", "beforePrint", "afterPrint");
        var emitSkipped = false;
        enter();
        forEachEmittedFile(host, emitSourceFileOrBundle, getSourceFilesToEmit(host, targetSourceFile, forceDtsEmit), forceDtsEmit, onlyBuildInfo, !targetSourceFile && !skipBuildInfo);
        exit();
        return {
            emitSkipped,
            diagnostics: emitterDiagnostics.getDiagnostics(),
            emittedFiles: emittedFilesList,
            sourceMaps: sourceMapDataList
        };
        function emitSourceFileOrBundle({ jsFilePath, sourceMapFilePath, declarationFilePath, declarationMapPath, buildInfoPath }, sourceFileOrBundle) {
            var _a, _b, _c, _d, _e, _f;
            (_a = tracing) == null || _a.push(tracing.Phase.Emit, "emitJsFileOrBundle", {
                jsFilePath
            });
            emitJsFileOrBundle(sourceFileOrBundle, jsFilePath, sourceMapFilePath);
            (_b = tracing) == null || _b.pop();
            (_c = tracing) == null || _c.push(tracing.Phase.Emit, "emitDeclarationFileOrBundle", {
                declarationFilePath
            });
            emitDeclarationFileOrBundle(sourceFileOrBundle, declarationFilePath, declarationMapPath);
            (_d = tracing) == null || _d.pop();
            (_e = tracing) == null || _e.push(tracing.Phase.Emit, "emitBuildInfo", {
                buildInfoPath
            });
            emitBuildInfo(buildInfoPath);
            (_f = tracing) == null || _f.pop();
        }
        function emitBuildInfo(buildInfoPath) {
            if (!buildInfoPath || targetSourceFile) return;
            if (host.isEmitBlocked(buildInfoPath)) {
                emitSkipped = true;
                return;
            }
            const buildInfo = host.getBuildInfo() || {
                version
            };
            writeFile(host, emitterDiagnostics, buildInfoPath, getBuildInfoText(buildInfo), /*writeByteOrderMark*/ false, /*sourceFiles*/ void 0, {
                buildInfo
            });
            emittedFilesList == null || emittedFilesList.push(buildInfoPath);
        }
        function emitJsFileOrBundle(sourceFileOrBundle, jsFilePath, sourceMapFilePath) {
            if (!sourceFileOrBundle || emitOnly || !jsFilePath) return;
            if (host.isEmitBlocked(jsFilePath) || compilerOptions.noEmit) {
                emitSkipped = true;
                return;
            }
            (isSourceFile(sourceFileOrBundle) ? [
                sourceFileOrBundle
            ] : filter(sourceFileOrBundle.sourceFiles, isSourceFileNotJson)).forEach((sourceFile)=>{
                if (compilerOptions.noCheck || !canIncludeBindAndCheckDiagnostics(sourceFile, compilerOptions)) markLinkedReferences(sourceFile);
            });
            const transform2 = transformNodes(resolver, host, factory, compilerOptions, [
                sourceFileOrBundle
            ], scriptTransformers, /*allowDtsFiles*/ false);
            const printerOptions = {
                removeComments: compilerOptions.removeComments,
                newLine: compilerOptions.newLine,
                noEmitHelpers: compilerOptions.noEmitHelpers,
                module: getEmitModuleKind(compilerOptions),
                moduleResolution: getEmitModuleResolutionKind(compilerOptions),
                target: getEmitScriptTarget(compilerOptions),
                sourceMap: compilerOptions.sourceMap,
                inlineSourceMap: compilerOptions.inlineSourceMap,
                inlineSources: compilerOptions.inlineSources,
                extendedDiagnostics: compilerOptions.extendedDiagnostics
            };
            const printer = createPrinter(printerOptions, {
                // resolver hooks
                hasGlobalName: resolver.hasGlobalName,
                // transform hooks
                onEmitNode: transform2.emitNodeWithNotification,
                isEmitNotificationEnabled: transform2.isEmitNotificationEnabled,
                substituteNode: transform2.substituteNode
            });
            Debug.assert(transform2.transformed.length === 1, "Should only see one output from the transform");
            printSourceFileOrBundle(jsFilePath, sourceMapFilePath, transform2, printer, compilerOptions);
            transform2.dispose();
            if (emittedFilesList) {
                emittedFilesList.push(jsFilePath);
                if (sourceMapFilePath) emittedFilesList.push(sourceMapFilePath);
            }
        }
        function emitDeclarationFileOrBundle(sourceFileOrBundle, declarationFilePath, declarationMapPath) {
            if (!sourceFileOrBundle || emitOnly === 0 /* Js */ ) return;
            if (!declarationFilePath) {
                if (emitOnly || compilerOptions.emitDeclarationOnly) emitSkipped = true;
                return;
            }
            const sourceFiles = isSourceFile(sourceFileOrBundle) ? [
                sourceFileOrBundle
            ] : sourceFileOrBundle.sourceFiles;
            const filesForEmit = forceDtsEmit ? sourceFiles : filter(sourceFiles, isSourceFileNotJson);
            const inputListOrBundle = compilerOptions.outFile ? [
                factory.createBundle(filesForEmit)
            ] : filesForEmit;
            filesForEmit.forEach((sourceFile)=>{
                if (emitOnly && !getEmitDeclarations(compilerOptions) || compilerOptions.noCheck || emitResolverSkipsTypeChecking(emitOnly, forceDtsEmit) || !canIncludeBindAndCheckDiagnostics(sourceFile, compilerOptions)) collectLinkedAliases(sourceFile);
            });
            const declarationTransform = transformNodes(resolver, host, factory, compilerOptions, inputListOrBundle, declarationTransformers, /*allowDtsFiles*/ false);
            if (length(declarationTransform.diagnostics)) for (const diagnostic of declarationTransform.diagnostics)emitterDiagnostics.add(diagnostic);
            const declBlocked = !!declarationTransform.diagnostics && !!declarationTransform.diagnostics.length || !!host.isEmitBlocked(declarationFilePath) || !!compilerOptions.noEmit;
            emitSkipped = emitSkipped || declBlocked;
            if (!declBlocked || forceDtsEmit) {
                Debug.assert(declarationTransform.transformed.length === 1, "Should only see one output from the decl transform");
                const printerOptions = {
                    removeComments: compilerOptions.removeComments,
                    newLine: compilerOptions.newLine,
                    noEmitHelpers: true,
                    module: compilerOptions.module,
                    moduleResolution: compilerOptions.moduleResolution,
                    target: compilerOptions.target,
                    sourceMap: emitOnly !== 2 /* BuilderSignature */  && compilerOptions.declarationMap,
                    inlineSourceMap: compilerOptions.inlineSourceMap,
                    extendedDiagnostics: compilerOptions.extendedDiagnostics,
                    onlyPrintJsDocStyle: true,
                    omitBraceSourceMapPositions: true
                };
                const declarationPrinter = createPrinter(printerOptions, {
                    // resolver hooks
                    hasGlobalName: resolver.hasGlobalName,
                    // transform hooks
                    onEmitNode: declarationTransform.emitNodeWithNotification,
                    isEmitNotificationEnabled: declarationTransform.isEmitNotificationEnabled,
                    substituteNode: declarationTransform.substituteNode
                });
                const dtsWritten = printSourceFileOrBundle(declarationFilePath, declarationMapPath, declarationTransform, declarationPrinter, {
                    sourceMap: printerOptions.sourceMap,
                    sourceRoot: compilerOptions.sourceRoot,
                    mapRoot: compilerOptions.mapRoot,
                    extendedDiagnostics: compilerOptions.extendedDiagnostics
                });
                if (emittedFilesList) {
                    if (dtsWritten) emittedFilesList.push(declarationFilePath);
                    if (declarationMapPath) emittedFilesList.push(declarationMapPath);
                }
            }
            declarationTransform.dispose();
        }
        function collectLinkedAliases(node) {
            if (isExportAssignment(node)) {
                if (node.expression.kind === 80 /* Identifier */ ) resolver.collectLinkedAliases(node.expression, /*setVisibility*/ true);
                return;
            } else if (isExportSpecifier(node)) {
                resolver.collectLinkedAliases(node.propertyName || node.name, /*setVisibility*/ true);
                return;
            }
            forEachChild(node, collectLinkedAliases);
        }
        function markLinkedReferences(file) {
            if (isSourceFileJS(file)) return;
            forEachChildRecursively(file, (n)=>{
                if (isImportEqualsDeclaration(n) && !(getSyntacticModifierFlags(n) & 32 /* Export */ )) return "skip";
                if (isImportDeclaration(n)) return "skip";
                resolver.markLinkedReferences(n);
            });
        }
        function printSourceFileOrBundle(jsFilePath, sourceMapFilePath, transform2, printer, mapOptions) {
            const sourceFileOrBundle = transform2.transformed[0];
            const bundle = sourceFileOrBundle.kind === 309 /* Bundle */  ? sourceFileOrBundle : void 0;
            const sourceFile = sourceFileOrBundle.kind === 308 /* SourceFile */  ? sourceFileOrBundle : void 0;
            const sourceFiles = bundle ? bundle.sourceFiles : [
                sourceFile
            ];
            let sourceMapGenerator;
            if (shouldEmitSourceMaps(mapOptions, sourceFileOrBundle)) sourceMapGenerator = createSourceMapGenerator(host, getBaseFileName(normalizeSlashes(jsFilePath)), getSourceRoot(mapOptions), getSourceMapDirectory(mapOptions, jsFilePath, sourceFile), mapOptions);
            if (bundle) printer.writeBundle(bundle, writer, sourceMapGenerator);
            else printer.writeFile(sourceFile, writer, sourceMapGenerator);
            let sourceMapUrlPos;
            if (sourceMapGenerator) {
                if (sourceMapDataList) sourceMapDataList.push({
                    inputSourceFileNames: sourceMapGenerator.getSources(),
                    sourceMap: sourceMapGenerator.toJSON()
                });
                const sourceMappingURL = getSourceMappingURL(mapOptions, sourceMapGenerator, jsFilePath, sourceMapFilePath, sourceFile);
                if (sourceMappingURL) {
                    if (!writer.isAtStartOfLine()) writer.rawWrite(newLine);
                    sourceMapUrlPos = writer.getTextPos();
                    writer.writeComment(`//# ${"sourceMappingURL"}=${sourceMappingURL}`);
                }
                if (sourceMapFilePath) {
                    const sourceMap = sourceMapGenerator.toString();
                    writeFile(host, emitterDiagnostics, sourceMapFilePath, sourceMap, /*writeByteOrderMark*/ false, sourceFiles);
                }
            } else writer.writeLine();
            const text = writer.getText();
            const data = {
                sourceMapUrlPos,
                diagnostics: transform2.diagnostics
            };
            writeFile(host, emitterDiagnostics, jsFilePath, text, !!compilerOptions.emitBOM, sourceFiles, data);
            writer.clear();
            return !data.skippedDtsWrite;
        }
        function shouldEmitSourceMaps(mapOptions, sourceFileOrBundle) {
            return (mapOptions.sourceMap || mapOptions.inlineSourceMap) && (sourceFileOrBundle.kind !== 308 /* SourceFile */  || !fileExtensionIs(sourceFileOrBundle.fileName, ".json" /* Json */ ));
        }
        function getSourceRoot(mapOptions) {
            const sourceRoot = normalizeSlashes(mapOptions.sourceRoot || "");
            return sourceRoot ? ensureTrailingDirectorySeparator(sourceRoot) : sourceRoot;
        }
        function getSourceMapDirectory(mapOptions, filePath, sourceFile) {
            if (mapOptions.sourceRoot) return host.getCommonSourceDirectory();
            if (mapOptions.mapRoot) {
                let sourceMapDir = normalizeSlashes(mapOptions.mapRoot);
                if (sourceFile) sourceMapDir = getDirectoryPath(getSourceFilePathInNewDir(sourceFile.fileName, host, sourceMapDir));
                if (getRootLength(sourceMapDir) === 0) sourceMapDir = combinePaths(host.getCommonSourceDirectory(), sourceMapDir);
                return sourceMapDir;
            }
            return getDirectoryPath(normalizePath(filePath));
        }
        function getSourceMappingURL(mapOptions, sourceMapGenerator, filePath, sourceMapFilePath, sourceFile) {
            if (mapOptions.inlineSourceMap) {
                const sourceMapText = sourceMapGenerator.toString();
                const base64SourceMapText = base64encode(sys, sourceMapText);
                return `data:application/json;base64,${base64SourceMapText}`;
            }
            const sourceMapFile = getBaseFileName(normalizeSlashes(Debug.checkDefined(sourceMapFilePath)));
            if (mapOptions.mapRoot) {
                let sourceMapDir = normalizeSlashes(mapOptions.mapRoot);
                if (sourceFile) sourceMapDir = getDirectoryPath(getSourceFilePathInNewDir(sourceFile.fileName, host, sourceMapDir));
                if (getRootLength(sourceMapDir) === 0) {
                    sourceMapDir = combinePaths(host.getCommonSourceDirectory(), sourceMapDir);
                    return encodeURI(getRelativePathToDirectoryOrUrl(getDirectoryPath(normalizePath(filePath)), // get the relative sourceMapDir path based on jsFilePath
                    combinePaths(sourceMapDir, sourceMapFile), // this is where user expects to see sourceMap
                    host.getCurrentDirectory(), host.getCanonicalFileName, /*isAbsolutePathAnUrl*/ true));
                } else return encodeURI(combinePaths(sourceMapDir, sourceMapFile));
            }
            return encodeURI(sourceMapFile);
        }
    }
    function getBuildInfoText(buildInfo) {
        return JSON.stringify(buildInfo);
    }
    function getBuildInfo(buildInfoFile, buildInfoText) {
        return readJsonOrUndefined(buildInfoFile, buildInfoText);
    }
    var notImplementedResolver = {
        hasGlobalName: notImplemented,
        getReferencedExportContainer: notImplemented,
        getReferencedImportDeclaration: notImplemented,
        getReferencedDeclarationWithCollidingName: notImplemented,
        isDeclarationWithCollidingName: notImplemented,
        isValueAliasDeclaration: notImplemented,
        isReferencedAliasDeclaration: notImplemented,
        isTopLevelValueImportEqualsWithEntityName: notImplemented,
        hasNodeCheckFlag: notImplemented,
        isDeclarationVisible: notImplemented,
        isLateBound: (_node)=>false,
        collectLinkedAliases: notImplemented,
        markLinkedReferences: notImplemented,
        isImplementationOfOverload: notImplemented,
        requiresAddingImplicitUndefined: notImplemented,
        isExpandoFunctionDeclaration: notImplemented,
        getPropertiesOfContainerFunction: notImplemented,
        createTypeOfDeclaration: notImplemented,
        createReturnTypeOfSignatureDeclaration: notImplemented,
        createTypeOfExpression: notImplemented,
        createLiteralConstValue: notImplemented,
        isSymbolAccessible: notImplemented,
        isEntityNameVisible: notImplemented,
        // Returns the constant value this property access resolves to: notImplemented, or 'undefined' for a non-constant
        getConstantValue: notImplemented,
        getEnumMemberValue: notImplemented,
        getReferencedValueDeclaration: notImplemented,
        getReferencedValueDeclarations: notImplemented,
        getTypeReferenceSerializationKind: notImplemented,
        isOptionalParameter: notImplemented,
        isArgumentsLocalBinding: notImplemented,
        getExternalModuleFileFromDeclaration: notImplemented,
        isLiteralConstDeclaration: notImplemented,
        getJsxFactoryEntity: notImplemented,
        getJsxFragmentFactoryEntity: notImplemented,
        isBindingCapturedByNode: notImplemented,
        getDeclarationStatementsForSourceFile: notImplemented,
        isImportRequiredByAugmentation: notImplemented,
        isDefinitelyReferenceToGlobalSymbolObject: notImplemented,
        createLateBoundIndexSignatures: notImplemented,
        symbolToDeclarations: notImplemented
    };
    var createPrinterWithDefaults = /* @__PURE__ */ memoize(()=>createPrinter({}));
    var createPrinterWithRemoveComments = /* @__PURE__ */ memoize(()=>createPrinter({
            removeComments: true
        }));
    var createPrinterWithRemoveCommentsNeverAsciiEscape = /* @__PURE__ */ memoize(()=>createPrinter({
            removeComments: true,
            neverAsciiEscape: true
        }));
    var createPrinterWithRemoveCommentsOmitTrailingSemicolon = /* @__PURE__ */ memoize(()=>createPrinter({
            removeComments: true,
            omitTrailingSemicolon: true
        }));
    function createPrinter(printerOptions = {}, handlers = {}) {
        var { hasGlobalName, onEmitNode = noEmitNotification, isEmitNotificationEnabled, substituteNode = noEmitSubstitution, onBeforeEmitNode, onAfterEmitNode, onBeforeEmitNodeArray, onAfterEmitNodeArray, onBeforeEmitToken, onAfterEmitToken } = handlers;
        var extendedDiagnostics = !!printerOptions.extendedDiagnostics;
        var omitBraceSourcePositions = !!printerOptions.omitBraceSourceMapPositions;
        var newLine = getNewLineCharacter(printerOptions);
        var moduleKind = getEmitModuleKind(printerOptions);
        var bundledHelpers = /* @__PURE__ */ new Map();
        var currentSourceFile;
        var nodeIdToGeneratedName;
        var nodeIdToGeneratedPrivateName;
        var autoGeneratedIdToGeneratedName;
        var generatedNames;
        var formattedNameTempFlagsStack;
        var formattedNameTempFlags;
        var privateNameTempFlagsStack;
        var privateNameTempFlags;
        var tempFlagsStack;
        var tempFlags;
        var reservedNamesStack;
        var reservedNames;
        var reservedPrivateNamesStack;
        var reservedPrivateNames;
        var preserveSourceNewlines = printerOptions.preserveSourceNewlines;
        var nextListElementPos;
        var writer;
        var ownWriter;
        var write = writeBase;
        var isOwnFileEmit;
        var sourceMapsDisabled = true;
        var sourceMapGenerator;
        var sourceMapSource;
        var sourceMapSourceIndex = -1;
        var mostRecentlyAddedSourceMapSource;
        var mostRecentlyAddedSourceMapSourceIndex = -1;
        var containerPos = -1;
        var containerEnd = -1;
        var declarationListContainerEnd = -1;
        var currentLineMap;
        var detachedCommentsInfo;
        var hasWrittenComment = false;
        var commentsDisabled = !!printerOptions.removeComments;
        var lastSubstitution;
        var currentParenthesizerRule;
        var { enter: enterComment, exit: exitComment } = createTimerIf(extendedDiagnostics, "commentTime", "beforeComment", "afterComment");
        var parenthesizer = factory.parenthesizer;
        var typeArgumentParenthesizerRuleSelector = {
            select: (index)=>index === 0 ? parenthesizer.parenthesizeLeadingTypeArgument : void 0
        };
        var emitBinaryExpression = createEmitBinaryExpression();
        reset2();
        return {
            // public API
            printNode,
            printList,
            printFile,
            printBundle,
            // internal API
            writeNode,
            writeList,
            writeFile: writeFile2,
            writeBundle
        };
        function printNode(hint, node, sourceFile) {
            switch(hint){
                case 0 /* SourceFile */ :
                    Debug.assert(isSourceFile(node), "Expected a SourceFile node.");
                    break;
                case 2 /* IdentifierName */ :
                    Debug.assert(isIdentifier(node), "Expected an Identifier node.");
                    break;
                case 1 /* Expression */ :
                    Debug.assert(isExpression(node), "Expected an Expression node.");
                    break;
            }
            switch(node.kind){
                case 308 /* SourceFile */ :
                    return printFile(node);
                case 309 /* Bundle */ :
                    return printBundle(node);
            }
            writeNode(hint, node, sourceFile, beginPrint());
            return endPrint();
        }
        function printList(format, nodes, sourceFile) {
            writeList(format, nodes, sourceFile, beginPrint());
            return endPrint();
        }
        function printBundle(bundle) {
            writeBundle(bundle, beginPrint(), /*sourceMapGenerator*/ void 0);
            return endPrint();
        }
        function printFile(sourceFile) {
            writeFile2(sourceFile, beginPrint(), /*sourceMapGenerator*/ void 0);
            return endPrint();
        }
        function writeNode(hint, node, sourceFile, output) {
            const previousWriter = writer;
            setWriter(output, /*_sourceMapGenerator*/ void 0);
            print(hint, node, sourceFile);
            reset2();
            writer = previousWriter;
        }
        function writeList(format, nodes, sourceFile, output) {
            const previousWriter = writer;
            setWriter(output, /*_sourceMapGenerator*/ void 0);
            if (sourceFile) setSourceFile(sourceFile);
            emitList(/*parentNode*/ void 0, nodes, format);
            reset2();
            writer = previousWriter;
        }
        function writeBundle(bundle, output, sourceMapGenerator2) {
            isOwnFileEmit = false;
            const previousWriter = writer;
            setWriter(output, sourceMapGenerator2);
            emitShebangIfNeeded(bundle);
            emitPrologueDirectivesIfNeeded(bundle);
            emitHelpers(bundle);
            emitSyntheticTripleSlashReferencesIfNeeded(bundle);
            for (const sourceFile of bundle.sourceFiles)print(0 /* SourceFile */ , sourceFile, sourceFile);
            reset2();
            writer = previousWriter;
        }
        function writeFile2(sourceFile, output, sourceMapGenerator2) {
            isOwnFileEmit = true;
            const previousWriter = writer;
            setWriter(output, sourceMapGenerator2);
            emitShebangIfNeeded(sourceFile);
            emitPrologueDirectivesIfNeeded(sourceFile);
            print(0 /* SourceFile */ , sourceFile, sourceFile);
            reset2();
            writer = previousWriter;
        }
        function beginPrint() {
            return ownWriter || (ownWriter = createTextWriter(newLine));
        }
        function endPrint() {
            const text = ownWriter.getText();
            ownWriter.clear();
            return text;
        }
        function print(hint, node, sourceFile) {
            if (sourceFile) setSourceFile(sourceFile);
            pipelineEmit(hint, node, /*parenthesizerRule*/ void 0);
        }
        function setSourceFile(sourceFile) {
            currentSourceFile = sourceFile;
            currentLineMap = void 0;
            detachedCommentsInfo = void 0;
            if (sourceFile) setSourceMapSource(sourceFile);
        }
        function setWriter(_writer, _sourceMapGenerator) {
            if (_writer && printerOptions.omitTrailingSemicolon) _writer = getTrailingSemicolonDeferringWriter(_writer);
            writer = _writer;
            sourceMapGenerator = _sourceMapGenerator;
            sourceMapsDisabled = !writer || !sourceMapGenerator;
        }
        function reset2() {
            nodeIdToGeneratedName = [];
            nodeIdToGeneratedPrivateName = [];
            autoGeneratedIdToGeneratedName = [];
            generatedNames = /* @__PURE__ */ new Set();
            formattedNameTempFlagsStack = [];
            formattedNameTempFlags = /* @__PURE__ */ new Map();
            privateNameTempFlagsStack = [];
            privateNameTempFlags = 0 /* Auto */ ;
            tempFlagsStack = [];
            tempFlags = 0 /* Auto */ ;
            reservedNamesStack = [];
            reservedNames = void 0;
            reservedPrivateNamesStack = [];
            reservedPrivateNames = void 0;
            currentSourceFile = void 0;
            currentLineMap = void 0;
            detachedCommentsInfo = void 0;
            setWriter(/*output*/ void 0, /*_sourceMapGenerator*/ void 0);
        }
        function getCurrentLineMap() {
            return currentLineMap || (currentLineMap = getLineStarts(Debug.checkDefined(currentSourceFile)));
        }
        function emit(node, parenthesizerRule) {
            if (node === void 0) return;
            pipelineEmit(4 /* Unspecified */ , node, parenthesizerRule);
        }
        function emitIdentifierName(node) {
            if (node === void 0) return;
            pipelineEmit(2 /* IdentifierName */ , node, /*parenthesizerRule*/ void 0);
        }
        function emitExpression(node, parenthesizerRule) {
            if (node === void 0) return;
            pipelineEmit(1 /* Expression */ , node, parenthesizerRule);
        }
        function emitJsxAttributeValue(node) {
            pipelineEmit(isStringLiteral(node) ? 6 /* JsxAttributeValue */  : 4 /* Unspecified */ , node);
        }
        function beforeEmitNode(node) {
            if (preserveSourceNewlines && getInternalEmitFlags(node) & 4 /* IgnoreSourceNewlines */ ) preserveSourceNewlines = false;
        }
        function afterEmitNode(savedPreserveSourceNewlines) {
            preserveSourceNewlines = savedPreserveSourceNewlines;
        }
        function pipelineEmit(emitHint, node, parenthesizerRule) {
            currentParenthesizerRule = parenthesizerRule;
            const pipelinePhase = getPipelinePhase(0 /* Notification */ , emitHint, node);
            pipelinePhase(emitHint, node);
            currentParenthesizerRule = void 0;
        }
        function shouldEmitComments(node) {
            return !commentsDisabled && !isSourceFile(node);
        }
        function shouldEmitSourceMaps(node) {
            return !sourceMapsDisabled && !isSourceFile(node) && !isInJsonFile(node);
        }
        function getPipelinePhase(phase, emitHint, node) {
            switch(phase){
                case 0 /* Notification */ :
                    if (onEmitNode !== noEmitNotification && (!isEmitNotificationEnabled || isEmitNotificationEnabled(node))) return pipelineEmitWithNotification;
                // falls through
                case 1 /* Substitution */ :
                    if (substituteNode !== noEmitSubstitution && (lastSubstitution = substituteNode(emitHint, node) || node) !== node) {
                        if (currentParenthesizerRule) lastSubstitution = currentParenthesizerRule(lastSubstitution);
                        return pipelineEmitWithSubstitution;
                    }
                // falls through
                case 2 /* Comments */ :
                    if (shouldEmitComments(node)) return pipelineEmitWithComments;
                // falls through
                case 3 /* SourceMaps */ :
                    if (shouldEmitSourceMaps(node)) return pipelineEmitWithSourceMaps;
                // falls through
                case 4 /* Emit */ :
                    return pipelineEmitWithHint;
                default:
                    return Debug.assertNever(phase);
            }
        }
        function getNextPipelinePhase(currentPhase, emitHint, node) {
            return getPipelinePhase(currentPhase + 1, emitHint, node);
        }
        function pipelineEmitWithNotification(hint, node) {
            const pipelinePhase = getNextPipelinePhase(0 /* Notification */ , hint, node);
            onEmitNode(hint, node, pipelinePhase);
        }
        function pipelineEmitWithHint(hint, node) {
            onBeforeEmitNode == null || onBeforeEmitNode(node);
            if (preserveSourceNewlines) {
                const savedPreserveSourceNewlines = preserveSourceNewlines;
                beforeEmitNode(node);
                pipelineEmitWithHintWorker(hint, node);
                afterEmitNode(savedPreserveSourceNewlines);
            } else pipelineEmitWithHintWorker(hint, node);
            onAfterEmitNode == null || onAfterEmitNode(node);
            currentParenthesizerRule = void 0;
        }
        function pipelineEmitWithHintWorker(hint, node, allowSnippets = true) {
            if (allowSnippets) {
                const snippet = getSnippetElement(node);
                if (snippet) return emitSnippetNode(hint, node, snippet);
            }
            if (hint === 0 /* SourceFile */ ) return emitSourceFile(cast(node, isSourceFile));
            if (hint === 2 /* IdentifierName */ ) return emitIdentifier(cast(node, isIdentifier));
            if (hint === 6 /* JsxAttributeValue */ ) return emitLiteral(cast(node, isStringLiteral), /*jsxAttributeEscape*/ true);
            if (hint === 3 /* MappedTypeParameter */ ) return emitMappedTypeParameter(cast(node, isTypeParameterDeclaration));
            if (hint === 7 /* ImportTypeNodeAttributes */ ) return emitImportTypeNodeAttributes(cast(node, isImportAttributes));
            if (hint === 5 /* EmbeddedStatement */ ) {
                Debug.assertNode(node, isEmptyStatement);
                return emitEmptyStatement(/*isEmbeddedStatement*/ true);
            }
            if (hint === 4 /* Unspecified */ ) {
                switch(node.kind){
                    // Pseudo-literals
                    case 16 /* TemplateHead */ :
                    case 17 /* TemplateMiddle */ :
                    case 18 /* TemplateTail */ :
                        return emitLiteral(node, /*jsxAttributeEscape*/ false);
                    // Identifiers
                    case 80 /* Identifier */ :
                        return emitIdentifier(node);
                    // PrivateIdentifiers
                    case 81 /* PrivateIdentifier */ :
                        return emitPrivateIdentifier(node);
                    // Parse tree nodes
                    // Names
                    case 167 /* QualifiedName */ :
                        return emitQualifiedName(node);
                    case 168 /* ComputedPropertyName */ :
                        return emitComputedPropertyName(node);
                    // Signature elements
                    case 169 /* TypeParameter */ :
                        return emitTypeParameter(node);
                    case 170 /* Parameter */ :
                        return emitParameter(node);
                    case 171 /* Decorator */ :
                        return emitDecorator(node);
                    // Type members
                    case 172 /* PropertySignature */ :
                        return emitPropertySignature(node);
                    case 173 /* PropertyDeclaration */ :
                        return emitPropertyDeclaration(node);
                    case 174 /* MethodSignature */ :
                        return emitMethodSignature(node);
                    case 175 /* MethodDeclaration */ :
                        return emitMethodDeclaration(node);
                    case 176 /* ClassStaticBlockDeclaration */ :
                        return emitClassStaticBlockDeclaration(node);
                    case 177 /* Constructor */ :
                        return emitConstructor(node);
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        return emitAccessorDeclaration(node);
                    case 180 /* CallSignature */ :
                        return emitCallSignature(node);
                    case 181 /* ConstructSignature */ :
                        return emitConstructSignature(node);
                    case 182 /* IndexSignature */ :
                        return emitIndexSignature(node);
                    // Types
                    case 183 /* TypePredicate */ :
                        return emitTypePredicate(node);
                    case 184 /* TypeReference */ :
                        return emitTypeReference(node);
                    case 185 /* FunctionType */ :
                        return emitFunctionType(node);
                    case 186 /* ConstructorType */ :
                        return emitConstructorType(node);
                    case 187 /* TypeQuery */ :
                        return emitTypeQuery(node);
                    case 188 /* TypeLiteral */ :
                        return emitTypeLiteral(node);
                    case 189 /* ArrayType */ :
                        return emitArrayType(node);
                    case 190 /* TupleType */ :
                        return emitTupleType(node);
                    case 191 /* OptionalType */ :
                        return emitOptionalType(node);
                    // SyntaxKind.RestType is handled below
                    case 193 /* UnionType */ :
                        return emitUnionType(node);
                    case 194 /* IntersectionType */ :
                        return emitIntersectionType(node);
                    case 195 /* ConditionalType */ :
                        return emitConditionalType(node);
                    case 196 /* InferType */ :
                        return emitInferType(node);
                    case 197 /* ParenthesizedType */ :
                        return emitParenthesizedType(node);
                    case 234 /* ExpressionWithTypeArguments */ :
                        return emitExpressionWithTypeArguments(node);
                    case 198 /* ThisType */ :
                        return emitThisType();
                    case 199 /* TypeOperator */ :
                        return emitTypeOperator(node);
                    case 200 /* IndexedAccessType */ :
                        return emitIndexedAccessType(node);
                    case 201 /* MappedType */ :
                        return emitMappedType(node);
                    case 202 /* LiteralType */ :
                        return emitLiteralType(node);
                    case 203 /* NamedTupleMember */ :
                        return emitNamedTupleMember(node);
                    case 204 /* TemplateLiteralType */ :
                        return emitTemplateType(node);
                    case 205 /* TemplateLiteralTypeSpan */ :
                        return emitTemplateTypeSpan(node);
                    case 206 /* ImportType */ :
                        return emitImportTypeNode(node);
                    // Binding patterns
                    case 207 /* ObjectBindingPattern */ :
                        return emitObjectBindingPattern(node);
                    case 208 /* ArrayBindingPattern */ :
                        return emitArrayBindingPattern(node);
                    case 209 /* BindingElement */ :
                        return emitBindingElement(node);
                    // Misc
                    case 240 /* TemplateSpan */ :
                        return emitTemplateSpan(node);
                    case 241 /* SemicolonClassElement */ :
                        return emitSemicolonClassElement();
                    // Statements
                    case 242 /* Block */ :
                        return emitBlock(node);
                    case 244 /* VariableStatement */ :
                        return emitVariableStatement(node);
                    case 243 /* EmptyStatement */ :
                        return emitEmptyStatement(/*isEmbeddedStatement*/ false);
                    case 245 /* ExpressionStatement */ :
                        return emitExpressionStatement(node);
                    case 246 /* IfStatement */ :
                        return emitIfStatement(node);
                    case 247 /* DoStatement */ :
                        return emitDoStatement(node);
                    case 248 /* WhileStatement */ :
                        return emitWhileStatement(node);
                    case 249 /* ForStatement */ :
                        return emitForStatement(node);
                    case 250 /* ForInStatement */ :
                        return emitForInStatement(node);
                    case 251 /* ForOfStatement */ :
                        return emitForOfStatement(node);
                    case 252 /* ContinueStatement */ :
                        return emitContinueStatement(node);
                    case 253 /* BreakStatement */ :
                        return emitBreakStatement(node);
                    case 254 /* ReturnStatement */ :
                        return emitReturnStatement(node);
                    case 255 /* WithStatement */ :
                        return emitWithStatement(node);
                    case 256 /* SwitchStatement */ :
                        return emitSwitchStatement(node);
                    case 257 /* LabeledStatement */ :
                        return emitLabeledStatement(node);
                    case 258 /* ThrowStatement */ :
                        return emitThrowStatement(node);
                    case 259 /* TryStatement */ :
                        return emitTryStatement(node);
                    case 260 /* DebuggerStatement */ :
                        return emitDebuggerStatement(node);
                    // Declarations
                    case 261 /* VariableDeclaration */ :
                        return emitVariableDeclaration(node);
                    case 262 /* VariableDeclarationList */ :
                        return emitVariableDeclarationList(node);
                    case 263 /* FunctionDeclaration */ :
                        return emitFunctionDeclaration(node);
                    case 264 /* ClassDeclaration */ :
                        return emitClassDeclaration(node);
                    case 265 /* InterfaceDeclaration */ :
                        return emitInterfaceDeclaration(node);
                    case 266 /* TypeAliasDeclaration */ :
                        return emitTypeAliasDeclaration(node);
                    case 267 /* EnumDeclaration */ :
                        return emitEnumDeclaration(node);
                    case 268 /* ModuleDeclaration */ :
                        return emitModuleDeclaration(node);
                    case 269 /* ModuleBlock */ :
                        return emitModuleBlock(node);
                    case 270 /* CaseBlock */ :
                        return emitCaseBlock(node);
                    case 271 /* NamespaceExportDeclaration */ :
                        return emitNamespaceExportDeclaration(node);
                    case 272 /* ImportEqualsDeclaration */ :
                        return emitImportEqualsDeclaration(node);
                    case 273 /* ImportDeclaration */ :
                        return emitImportDeclaration(node);
                    case 274 /* ImportClause */ :
                        return emitImportClause(node);
                    case 275 /* NamespaceImport */ :
                        return emitNamespaceImport(node);
                    case 281 /* NamespaceExport */ :
                        return emitNamespaceExport(node);
                    case 276 /* NamedImports */ :
                        return emitNamedImports(node);
                    case 277 /* ImportSpecifier */ :
                        return emitImportSpecifier(node);
                    case 278 /* ExportAssignment */ :
                        return emitExportAssignment(node);
                    case 279 /* ExportDeclaration */ :
                        return emitExportDeclaration(node);
                    case 280 /* NamedExports */ :
                        return emitNamedExports(node);
                    case 282 /* ExportSpecifier */ :
                        return emitExportSpecifier(node);
                    case 301 /* ImportAttributes */ :
                        return emitImportAttributes(node);
                    case 302 /* ImportAttribute */ :
                        return emitImportAttribute(node);
                    case 283 /* MissingDeclaration */ :
                        return;
                    // Module references
                    case 284 /* ExternalModuleReference */ :
                        return emitExternalModuleReference(node);
                    // JSX (non-expression)
                    case 12 /* JsxText */ :
                        return emitJsxText(node);
                    case 287 /* JsxOpeningElement */ :
                    case 290 /* JsxOpeningFragment */ :
                        return emitJsxOpeningElementOrFragment(node);
                    case 288 /* JsxClosingElement */ :
                    case 291 /* JsxClosingFragment */ :
                        return emitJsxClosingElementOrFragment(node);
                    case 292 /* JsxAttribute */ :
                        return emitJsxAttribute(node);
                    case 293 /* JsxAttributes */ :
                        return emitJsxAttributes(node);
                    case 294 /* JsxSpreadAttribute */ :
                        return emitJsxSpreadAttribute(node);
                    case 295 /* JsxExpression */ :
                        return emitJsxExpression(node);
                    case 296 /* JsxNamespacedName */ :
                        return emitJsxNamespacedName(node);
                    // Clauses
                    case 297 /* CaseClause */ :
                        return emitCaseClause(node);
                    case 298 /* DefaultClause */ :
                        return emitDefaultClause(node);
                    case 299 /* HeritageClause */ :
                        return emitHeritageClause(node);
                    case 300 /* CatchClause */ :
                        return emitCatchClause(node);
                    // Property assignments
                    case 304 /* PropertyAssignment */ :
                        return emitPropertyAssignment(node);
                    case 305 /* ShorthandPropertyAssignment */ :
                        return emitShorthandPropertyAssignment(node);
                    case 306 /* SpreadAssignment */ :
                        return emitSpreadAssignment(node);
                    // Enum
                    case 307 /* EnumMember */ :
                        return emitEnumMember(node);
                    // Top-level nodes
                    case 308 /* SourceFile */ :
                        return emitSourceFile(node);
                    case 309 /* Bundle */ :
                        return Debug.fail("Bundles should be printed using printBundle");
                    // JSDoc nodes (only used in codefixes currently)
                    case 310 /* JSDocTypeExpression */ :
                        return emitJSDocTypeExpression(node);
                    case 311 /* JSDocNameReference */ :
                        return emitJSDocNameReference(node);
                    case 313 /* JSDocAllType */ :
                        return writePunctuation("*");
                    case 314 /* JSDocUnknownType */ :
                        return writePunctuation("?");
                    case 315 /* JSDocNullableType */ :
                        return emitJSDocNullableType(node);
                    case 316 /* JSDocNonNullableType */ :
                        return emitJSDocNonNullableType(node);
                    case 317 /* JSDocOptionalType */ :
                        return emitJSDocOptionalType(node);
                    case 318 /* JSDocFunctionType */ :
                        return emitJSDocFunctionType(node);
                    case 192 /* RestType */ :
                    case 319 /* JSDocVariadicType */ :
                        return emitRestOrJSDocVariadicType(node);
                    case 320 /* JSDocNamepathType */ :
                        return;
                    case 321 /* JSDoc */ :
                        return emitJSDoc(node);
                    case 323 /* JSDocTypeLiteral */ :
                        return emitJSDocTypeLiteral(node);
                    case 324 /* JSDocSignature */ :
                        return emitJSDocSignature(node);
                    case 328 /* JSDocTag */ :
                    case 333 /* JSDocClassTag */ :
                    case 338 /* JSDocOverrideTag */ :
                        return emitJSDocSimpleTag(node);
                    case 329 /* JSDocAugmentsTag */ :
                    case 330 /* JSDocImplementsTag */ :
                        return emitJSDocHeritageTag(node);
                    case 331 /* JSDocAuthorTag */ :
                    case 332 /* JSDocDeprecatedTag */ :
                        return;
                    // SyntaxKind.JSDocClassTag (see JSDocTag, above)
                    case 334 /* JSDocPublicTag */ :
                    case 335 /* JSDocPrivateTag */ :
                    case 336 /* JSDocProtectedTag */ :
                    case 337 /* JSDocReadonlyTag */ :
                        return;
                    case 339 /* JSDocCallbackTag */ :
                        return emitJSDocCallbackTag(node);
                    case 340 /* JSDocOverloadTag */ :
                        return emitJSDocOverloadTag(node);
                    // SyntaxKind.JSDocEnumTag (see below)
                    case 342 /* JSDocParameterTag */ :
                    case 349 /* JSDocPropertyTag */ :
                        return emitJSDocPropertyLikeTag(node);
                    case 341 /* JSDocEnumTag */ :
                    case 343 /* JSDocReturnTag */ :
                    case 344 /* JSDocThisTag */ :
                    case 345 /* JSDocTypeTag */ :
                    case 350 /* JSDocThrowsTag */ :
                    case 351 /* JSDocSatisfiesTag */ :
                        return emitJSDocSimpleTypedTag(node);
                    case 346 /* JSDocTemplateTag */ :
                        return emitJSDocTemplateTag(node);
                    case 347 /* JSDocTypedefTag */ :
                        return emitJSDocTypedefTag(node);
                    case 348 /* JSDocSeeTag */ :
                        return emitJSDocSeeTag(node);
                    case 352 /* JSDocImportTag */ :
                        return emitJSDocImportTag(node);
                    // SyntaxKind.JSDocPropertyTag (see JSDocParameterTag, above)
                    // Transformation nodes
                    case 354 /* NotEmittedStatement */ :
                    case 355 /* NotEmittedTypeElement */ :
                        return;
                }
                if (isExpression(node)) {
                    hint = 1 /* Expression */ ;
                    if (substituteNode !== noEmitSubstitution) {
                        const substitute = substituteNode(hint, node) || node;
                        if (substitute !== node) {
                            node = substitute;
                            if (currentParenthesizerRule) node = currentParenthesizerRule(node);
                        }
                    }
                }
            }
            if (hint === 1 /* Expression */ ) switch(node.kind){
                // Literals
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                    return emitNumericOrBigIntLiteral(node);
                case 11 /* StringLiteral */ :
                case 14 /* RegularExpressionLiteral */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                    return emitLiteral(node, /*jsxAttributeEscape*/ false);
                // Identifiers
                case 80 /* Identifier */ :
                    return emitIdentifier(node);
                case 81 /* PrivateIdentifier */ :
                    return emitPrivateIdentifier(node);
                // Expressions
                case 210 /* ArrayLiteralExpression */ :
                    return emitArrayLiteralExpression(node);
                case 211 /* ObjectLiteralExpression */ :
                    return emitObjectLiteralExpression(node);
                case 212 /* PropertyAccessExpression */ :
                    return emitPropertyAccessExpression(node);
                case 213 /* ElementAccessExpression */ :
                    return emitElementAccessExpression(node);
                case 214 /* CallExpression */ :
                    return emitCallExpression(node);
                case 215 /* NewExpression */ :
                    return emitNewExpression(node);
                case 216 /* TaggedTemplateExpression */ :
                    return emitTaggedTemplateExpression(node);
                case 217 /* TypeAssertionExpression */ :
                    return emitTypeAssertionExpression(node);
                case 218 /* ParenthesizedExpression */ :
                    return emitParenthesizedExpression(node);
                case 219 /* FunctionExpression */ :
                    return emitFunctionExpression(node);
                case 220 /* ArrowFunction */ :
                    return emitArrowFunction(node);
                case 221 /* DeleteExpression */ :
                    return emitDeleteExpression(node);
                case 222 /* TypeOfExpression */ :
                    return emitTypeOfExpression(node);
                case 223 /* VoidExpression */ :
                    return emitVoidExpression(node);
                case 224 /* AwaitExpression */ :
                    return emitAwaitExpression(node);
                case 225 /* PrefixUnaryExpression */ :
                    return emitPrefixUnaryExpression(node);
                case 226 /* PostfixUnaryExpression */ :
                    return emitPostfixUnaryExpression(node);
                case 227 /* BinaryExpression */ :
                    return emitBinaryExpression(node);
                case 228 /* ConditionalExpression */ :
                    return emitConditionalExpression(node);
                case 229 /* TemplateExpression */ :
                    return emitTemplateExpression(node);
                case 230 /* YieldExpression */ :
                    return emitYieldExpression(node);
                case 231 /* SpreadElement */ :
                    return emitSpreadElement(node);
                case 232 /* ClassExpression */ :
                    return emitClassExpression(node);
                case 233 /* OmittedExpression */ :
                    return;
                case 235 /* AsExpression */ :
                    return emitAsExpression(node);
                case 236 /* NonNullExpression */ :
                    return emitNonNullExpression(node);
                case 234 /* ExpressionWithTypeArguments */ :
                    return emitExpressionWithTypeArguments(node);
                case 239 /* SatisfiesExpression */ :
                    return emitSatisfiesExpression(node);
                case 237 /* MetaProperty */ :
                    return emitMetaProperty(node);
                case 238 /* SyntheticExpression */ :
                    return Debug.fail("SyntheticExpression should never be printed.");
                case 283 /* MissingDeclaration */ :
                    return;
                // JSX
                case 285 /* JsxElement */ :
                    return emitJsxElement(node);
                case 286 /* JsxSelfClosingElement */ :
                    return emitJsxSelfClosingElement(node);
                case 289 /* JsxFragment */ :
                    return emitJsxFragment(node);
                // Synthesized list
                case 353 /* SyntaxList */ :
                    return Debug.fail("SyntaxList should not be printed");
                // Transformation nodes
                case 354 /* NotEmittedStatement */ :
                    return;
                case 356 /* PartiallyEmittedExpression */ :
                    return emitPartiallyEmittedExpression(node);
                case 357 /* CommaListExpression */ :
                    return emitCommaList(node);
                case 358 /* SyntheticReferenceExpression */ :
                    return Debug.fail("SyntheticReferenceExpression should not be printed");
            }
            if (isKeyword(node.kind)) return writeTokenNode(node, writeKeyword);
            if (isTokenKind(node.kind)) return writeTokenNode(node, writePunctuation);
            Debug.fail(`Unhandled SyntaxKind: ${Debug.formatSyntaxKind(node.kind)}.`);
        }
        function emitMappedTypeParameter(node) {
            emit(node.name);
            writeSpace();
            writeKeyword("in");
            writeSpace();
            emit(node.constraint);
        }
        function pipelineEmitWithSubstitution(hint, node) {
            const pipelinePhase = getNextPipelinePhase(1 /* Substitution */ , hint, node);
            Debug.assertIsDefined(lastSubstitution);
            node = lastSubstitution;
            lastSubstitution = void 0;
            pipelinePhase(hint, node);
        }
        function emitHelpers(node) {
            let helpersEmitted = false;
            const bundle = node.kind === 309 /* Bundle */  ? node : void 0;
            if (bundle && moduleKind === 0 /* None */ ) return;
            const numNodes = bundle ? bundle.sourceFiles.length : 1;
            for(let i = 0; i < numNodes; i++){
                const currentNode = bundle ? bundle.sourceFiles[i] : node;
                const sourceFile = isSourceFile(currentNode) ? currentNode : currentSourceFile;
                const shouldSkip = printerOptions.noEmitHelpers || !!sourceFile && hasRecordedExternalHelpers(sourceFile);
                const shouldBundle = isSourceFile(currentNode) && !isOwnFileEmit;
                const helpers = getSortedEmitHelpers(currentNode);
                if (helpers) for (const helper of helpers){
                    if (!helper.scoped) {
                        if (shouldSkip) continue;
                        if (shouldBundle) {
                            if (bundledHelpers.get(helper.name)) continue;
                            bundledHelpers.set(helper.name, true);
                        }
                    } else if (bundle) continue;
                    if (typeof helper.text === "string") writeLines(helper.text);
                    else writeLines(helper.text(makeFileLevelOptimisticUniqueName));
                    helpersEmitted = true;
                }
            }
            return helpersEmitted;
        }
        function getSortedEmitHelpers(node) {
            const helpers = getEmitHelpers(node);
            return helpers && toSorted(helpers, compareEmitHelpers);
        }
        function emitNumericOrBigIntLiteral(node) {
            emitLiteral(node, /*jsxAttributeEscape*/ false);
        }
        function emitLiteral(node, jsxAttributeEscape) {
            const text = getLiteralTextOfNode(node, /*sourceFile*/ void 0, printerOptions.neverAsciiEscape, jsxAttributeEscape);
            if ((printerOptions.sourceMap || printerOptions.inlineSourceMap) && (node.kind === 11 /* StringLiteral */  || isTemplateLiteralKind(node.kind))) writeLiteral(text);
            else writeStringLiteral(text);
        }
        function emitSnippetNode(hint, node, snippet) {
            switch(snippet.kind){
                case 1 /* Placeholder */ :
                    emitPlaceholder(hint, node, snippet);
                    break;
                case 0 /* TabStop */ :
                    emitTabStop(hint, node, snippet);
                    break;
            }
        }
        function emitPlaceholder(hint, node, snippet) {
            nonEscapingWrite(`\${${snippet.order}:`);
            pipelineEmitWithHintWorker(hint, node, /*allowSnippets*/ false);
            nonEscapingWrite(`}`);
        }
        function emitTabStop(hint, node, snippet) {
            Debug.assert(node.kind === 243 /* EmptyStatement */ , `A tab stop cannot be attached to a node of kind ${Debug.formatSyntaxKind(node.kind)}.`);
            Debug.assert(hint !== 5 /* EmbeddedStatement */ , `A tab stop cannot be attached to an embedded statement.`);
            nonEscapingWrite(`$${snippet.order}`);
        }
        function emitIdentifier(node) {
            const writeText = node.symbol ? writeSymbol : write;
            writeText(getTextOfNode2(node, /*includeTrivia*/ false), node.symbol);
            emitList(node, getIdentifierTypeArguments(node), 53776 /* TypeParameters */ );
        }
        function emitPrivateIdentifier(node) {
            write(getTextOfNode2(node, /*includeTrivia*/ false));
        }
        function emitQualifiedName(node) {
            emitEntityName(node.left);
            writePunctuation(".");
            emit(node.right);
        }
        function emitEntityName(node) {
            if (node.kind === 80 /* Identifier */ ) emitExpression(node);
            else emit(node);
        }
        function emitComputedPropertyName(node) {
            writePunctuation("[");
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionOfComputedPropertyName);
            writePunctuation("]");
        }
        function emitTypeParameter(node) {
            emitModifierList(node, node.modifiers);
            emit(node.name);
            if (node.constraint) {
                writeSpace();
                writeKeyword("extends");
                writeSpace();
                emit(node.constraint);
            }
            if (node.default) {
                writeSpace();
                writeOperator("=");
                writeSpace();
                emit(node.default);
            }
        }
        function emitParameter(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emit(node.dotDotDotToken);
            emitNodeWithWriter(node.name, writeParameter);
            emit(node.questionToken);
            if (node.parent && node.parent.kind === 318 /* JSDocFunctionType */  && !node.name) emit(node.type);
            else emitTypeAnnotation(node.type);
            emitInitializer(node.initializer, node.type ? node.type.end : node.questionToken ? node.questionToken.end : node.name ? node.name.end : node.modifiers ? node.modifiers.end : node.pos, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitDecorator(decorator) {
            writePunctuation("@");
            emitExpression(decorator.expression, parenthesizer.parenthesizeLeftSideOfAccess);
        }
        function emitPropertySignature(node) {
            emitModifierList(node, node.modifiers);
            emitNodeWithWriter(node.name, writeProperty);
            emit(node.questionToken);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
        }
        function emitPropertyDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emit(node.name);
            emit(node.questionToken);
            emit(node.exclamationToken);
            emitTypeAnnotation(node.type);
            emitInitializer(node.initializer, node.type ? node.type.end : node.questionToken ? node.questionToken.end : node.name.end, node);
            writeTrailingSemicolon();
        }
        function emitMethodSignature(node) {
            emitModifierList(node, node.modifiers);
            emit(node.name);
            emit(node.questionToken);
            emitSignatureAndBody(node, emitSignatureHead, emitEmptyFunctionBody);
        }
        function emitMethodDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emit(node.asteriskToken);
            emit(node.name);
            emit(node.questionToken);
            emitSignatureAndBody(node, emitSignatureHead, emitFunctionBody);
        }
        function emitClassStaticBlockDeclaration(node) {
            writeKeyword("static");
            pushNameGenerationScope(node);
            emitBlockFunctionBody(node.body);
            popNameGenerationScope(node);
        }
        function emitConstructor(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("constructor");
            emitSignatureAndBody(node, emitSignatureHead, emitFunctionBody);
        }
        function emitAccessorDeclaration(node) {
            const pos = emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            const token = node.kind === 178 /* GetAccessor */  ? 139 /* GetKeyword */  : 153 /* SetKeyword */ ;
            emitTokenWithComment(token, pos, writeKeyword, node);
            writeSpace();
            emit(node.name);
            emitSignatureAndBody(node, emitSignatureHead, emitFunctionBody);
        }
        function emitCallSignature(node) {
            emitSignatureAndBody(node, emitSignatureHead, emitEmptyFunctionBody);
        }
        function emitConstructSignature(node) {
            writeKeyword("new");
            writeSpace();
            emitSignatureAndBody(node, emitSignatureHead, emitEmptyFunctionBody);
        }
        function emitIndexSignature(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emitParametersForIndexSignature(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeTrailingSemicolon();
        }
        function emitTemplateTypeSpan(node) {
            emit(node.type);
            emit(node.literal);
        }
        function emitSemicolonClassElement() {
            writeTrailingSemicolon();
        }
        function emitTypePredicate(node) {
            if (node.assertsModifier) {
                emit(node.assertsModifier);
                writeSpace();
            }
            emit(node.parameterName);
            if (node.type) {
                writeSpace();
                writeKeyword("is");
                writeSpace();
                emit(node.type);
            }
        }
        function emitTypeReference(node) {
            emit(node.typeName);
            emitTypeArguments(node, node.typeArguments);
        }
        function emitFunctionType(node) {
            emitSignatureAndBody(node, emitFunctionTypeHead, emitFunctionTypeBody);
        }
        function emitFunctionTypeHead(node) {
            emitTypeParameters(node, node.typeParameters);
            emitParametersForArrow(node, node.parameters);
            writeSpace();
            writePunctuation("=>");
        }
        function emitFunctionTypeBody(node) {
            writeSpace();
            emit(node.type);
        }
        function emitJSDocFunctionType(node) {
            writeKeyword("function");
            emitParameters(node, node.parameters);
            writePunctuation(":");
            emit(node.type);
        }
        function emitJSDocNullableType(node) {
            writePunctuation("?");
            emit(node.type);
        }
        function emitJSDocNonNullableType(node) {
            writePunctuation("!");
            emit(node.type);
        }
        function emitJSDocOptionalType(node) {
            emit(node.type);
            writePunctuation("=");
        }
        function emitConstructorType(node) {
            emitModifierList(node, node.modifiers);
            writeKeyword("new");
            writeSpace();
            emitSignatureAndBody(node, emitFunctionTypeHead, emitFunctionTypeBody);
        }
        function emitTypeQuery(node) {
            writeKeyword("typeof");
            writeSpace();
            emit(node.exprName);
            emitTypeArguments(node, node.typeArguments);
        }
        function emitTypeLiteral(node) {
            pushNameGenerationScope(node);
            forEach(node.members, generateMemberNames);
            writePunctuation("{");
            const flags = getEmitFlags(node) & 1 /* SingleLine */  ? 768 /* SingleLineTypeLiteralMembers */  : 32897 /* MultiLineTypeLiteralMembers */ ;
            emitList(node, node.members, flags | 524288 /* NoSpaceIfEmpty */ );
            writePunctuation("}");
            popNameGenerationScope(node);
        }
        function emitArrayType(node) {
            emit(node.elementType, parenthesizer.parenthesizeNonArrayTypeOfPostfixType);
            writePunctuation("[");
            writePunctuation("]");
        }
        function emitRestOrJSDocVariadicType(node) {
            writePunctuation("...");
            emit(node.type);
        }
        function emitTupleType(node) {
            emitTokenWithComment(23 /* OpenBracketToken */ , node.pos, writePunctuation, node);
            const flags = getEmitFlags(node) & 1 /* SingleLine */  ? 528 /* SingleLineTupleTypeElements */  : 657 /* MultiLineTupleTypeElements */ ;
            emitList(node, node.elements, flags | 524288 /* NoSpaceIfEmpty */ , parenthesizer.parenthesizeElementTypeOfTupleType);
            emitTokenWithComment(24 /* CloseBracketToken */ , node.elements.end, writePunctuation, node);
        }
        function emitNamedTupleMember(node) {
            emit(node.dotDotDotToken);
            emit(node.name);
            emit(node.questionToken);
            emitTokenWithComment(59 /* ColonToken */ , node.name.end, writePunctuation, node);
            writeSpace();
            emit(node.type);
        }
        function emitOptionalType(node) {
            emit(node.type, parenthesizer.parenthesizeTypeOfOptionalType);
            writePunctuation("?");
        }
        function emitUnionType(node) {
            emitList(node, node.types, 516 /* UnionTypeConstituents */ , parenthesizer.parenthesizeConstituentTypeOfUnionType);
        }
        function emitIntersectionType(node) {
            emitList(node, node.types, 520 /* IntersectionTypeConstituents */ , parenthesizer.parenthesizeConstituentTypeOfIntersectionType);
        }
        function emitConditionalType(node) {
            emit(node.checkType, parenthesizer.parenthesizeCheckTypeOfConditionalType);
            writeSpace();
            writeKeyword("extends");
            writeSpace();
            emit(node.extendsType, parenthesizer.parenthesizeExtendsTypeOfConditionalType);
            writeSpace();
            writePunctuation("?");
            writeSpace();
            emit(node.trueType);
            writeSpace();
            writePunctuation(":");
            writeSpace();
            emit(node.falseType);
        }
        function emitInferType(node) {
            writeKeyword("infer");
            writeSpace();
            emit(node.typeParameter);
        }
        function emitParenthesizedType(node) {
            writePunctuation("(");
            emit(node.type);
            writePunctuation(")");
        }
        function emitThisType() {
            writeKeyword("this");
        }
        function emitTypeOperator(node) {
            writeTokenText(node.operator, writeKeyword);
            writeSpace();
            const parenthesizerRule = node.operator === 148 /* ReadonlyKeyword */  ? parenthesizer.parenthesizeOperandOfReadonlyTypeOperator : parenthesizer.parenthesizeOperandOfTypeOperator;
            emit(node.type, parenthesizerRule);
        }
        function emitIndexedAccessType(node) {
            emit(node.objectType, parenthesizer.parenthesizeNonArrayTypeOfPostfixType);
            writePunctuation("[");
            emit(node.indexType);
            writePunctuation("]");
        }
        function emitMappedType(node) {
            const emitFlags = getEmitFlags(node);
            writePunctuation("{");
            if (emitFlags & 1 /* SingleLine */ ) writeSpace();
            else {
                writeLine();
                increaseIndent();
            }
            if (node.readonlyToken) {
                emit(node.readonlyToken);
                if (node.readonlyToken.kind !== 148 /* ReadonlyKeyword */ ) writeKeyword("readonly");
                writeSpace();
            }
            writePunctuation("[");
            pipelineEmit(3 /* MappedTypeParameter */ , node.typeParameter);
            if (node.nameType) {
                writeSpace();
                writeKeyword("as");
                writeSpace();
                emit(node.nameType);
            }
            writePunctuation("]");
            if (node.questionToken) {
                emit(node.questionToken);
                if (node.questionToken.kind !== 58 /* QuestionToken */ ) writePunctuation("?");
            }
            writePunctuation(":");
            writeSpace();
            emit(node.type);
            writeTrailingSemicolon();
            if (emitFlags & 1 /* SingleLine */ ) writeSpace();
            else {
                writeLine();
                decreaseIndent();
            }
            emitList(node, node.members, 2 /* PreserveLines */ );
            writePunctuation("}");
        }
        function emitLiteralType(node) {
            emitExpression(node.literal);
        }
        function emitTemplateType(node) {
            emit(node.head);
            emitList(node, node.templateSpans, 262144 /* TemplateExpressionSpans */ );
        }
        function emitImportTypeNode(node) {
            if (node.isTypeOf) {
                writeKeyword("typeof");
                writeSpace();
            }
            writeKeyword("import");
            writePunctuation("(");
            emit(node.argument);
            if (node.attributes) {
                writePunctuation(",");
                writeSpace();
                pipelineEmit(7 /* ImportTypeNodeAttributes */ , node.attributes);
            }
            writePunctuation(")");
            if (node.qualifier) {
                writePunctuation(".");
                emit(node.qualifier);
            }
            emitTypeArguments(node, node.typeArguments);
        }
        function emitObjectBindingPattern(node) {
            writePunctuation("{");
            emitList(node, node.elements, 525136 /* ObjectBindingPatternElements */ );
            writePunctuation("}");
        }
        function emitArrayBindingPattern(node) {
            writePunctuation("[");
            emitList(node, node.elements, 524880 /* ArrayBindingPatternElements */ );
            writePunctuation("]");
        }
        function emitBindingElement(node) {
            emit(node.dotDotDotToken);
            if (node.propertyName) {
                emit(node.propertyName);
                writePunctuation(":");
                writeSpace();
            }
            emit(node.name);
            emitInitializer(node.initializer, node.name.end, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitArrayLiteralExpression(node) {
            const elements = node.elements;
            const preferNewLine = node.multiLine ? 65536 /* PreferNewLine */  : 0 /* None */ ;
            emitExpressionList(node, elements, 8914 /* ArrayLiteralExpressionElements */  | preferNewLine, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitObjectLiteralExpression(node) {
            pushNameGenerationScope(node);
            forEach(node.properties, generateMemberNames);
            const indentedFlag = getEmitFlags(node) & 131072 /* Indented */ ;
            if (indentedFlag) increaseIndent();
            const preferNewLine = node.multiLine ? 65536 /* PreferNewLine */  : 0 /* None */ ;
            const allowTrailingComma = currentSourceFile && currentSourceFile.languageVersion >= 1 /* ES5 */  && !isJsonSourceFile(currentSourceFile) ? 64 /* AllowTrailingComma */  : 0 /* None */ ;
            emitList(node, node.properties, 526226 /* ObjectLiteralExpressionProperties */  | allowTrailingComma | preferNewLine);
            if (indentedFlag) decreaseIndent();
            popNameGenerationScope(node);
        }
        function emitPropertyAccessExpression(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            const token = node.questionDotToken || setTextRangePosEnd(factory.createToken(25 /* DotToken */ ), node.expression.end, node.name.pos);
            const linesBeforeDot = getLinesBetweenNodes(node, node.expression, token);
            const linesAfterDot = getLinesBetweenNodes(node, token, node.name);
            writeLinesAndIndent(linesBeforeDot, /*writeSpaceIfNotIndenting*/ false);
            const shouldEmitDotDot = token.kind !== 29 /* QuestionDotToken */  && mayNeedDotDotForPropertyAccess(node.expression) && !writer.hasTrailingComment() && !writer.hasTrailingWhitespace();
            if (shouldEmitDotDot) writePunctuation(".");
            if (node.questionDotToken) emit(token);
            else emitTokenWithComment(token.kind, node.expression.end, writePunctuation, node);
            writeLinesAndIndent(linesAfterDot, /*writeSpaceIfNotIndenting*/ false);
            emit(node.name);
            decreaseIndentIf(linesBeforeDot, linesAfterDot);
        }
        function mayNeedDotDotForPropertyAccess(expression) {
            expression = skipPartiallyEmittedExpressions(expression);
            if (isNumericLiteral(expression)) {
                const text = getLiteralTextOfNode(expression, /*sourceFile*/ void 0, /*neverAsciiEscape*/ true, /*jsxAttributeEscape*/ false);
                return !(expression.numericLiteralFlags & 448 /* WithSpecifier */ ) && !text.includes(tokenToString(25 /* DotToken */ )) && !text.includes(String.fromCharCode(69 /* E */ )) && !text.includes(String.fromCharCode(101 /* e */ ));
            } else if (isAccessExpression(expression)) {
                const constantValue = getConstantValue(expression);
                return typeof constantValue === "number" && isFinite(constantValue) && constantValue >= 0 && Math.floor(constantValue) === constantValue;
            }
        }
        function emitElementAccessExpression(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            emit(node.questionDotToken);
            emitTokenWithComment(23 /* OpenBracketToken */ , node.expression.end, writePunctuation, node);
            emitExpression(node.argumentExpression);
            emitTokenWithComment(24 /* CloseBracketToken */ , node.argumentExpression.end, writePunctuation, node);
        }
        function emitCallExpression(node) {
            const indirectCall = getInternalEmitFlags(node) & 16 /* IndirectCall */ ;
            if (indirectCall) {
                writePunctuation("(");
                writeLiteral("0");
                writePunctuation(",");
                writeSpace();
            }
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            if (indirectCall) writePunctuation(")");
            emit(node.questionDotToken);
            emitTypeArguments(node, node.typeArguments);
            emitExpressionList(node, node.arguments, 2576 /* CallExpressionArguments */ , parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitNewExpression(node) {
            emitTokenWithComment(105 /* NewKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionOfNew);
            emitTypeArguments(node, node.typeArguments);
            emitExpressionList(node, node.arguments, 18960 /* NewExpressionArguments */ , parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitTaggedTemplateExpression(node) {
            const indirectCall = getInternalEmitFlags(node) & 16 /* IndirectCall */ ;
            if (indirectCall) {
                writePunctuation("(");
                writeLiteral("0");
                writePunctuation(",");
                writeSpace();
            }
            emitExpression(node.tag, parenthesizer.parenthesizeLeftSideOfAccess);
            if (indirectCall) writePunctuation(")");
            emitTypeArguments(node, node.typeArguments);
            writeSpace();
            emitExpression(node.template);
        }
        function emitTypeAssertionExpression(node) {
            writePunctuation("<");
            emit(node.type);
            writePunctuation(">");
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitParenthesizedExpression(node) {
            const openParenPos = emitTokenWithComment(21 /* OpenParenToken */ , node.pos, writePunctuation, node);
            const indented = writeLineSeparatorsAndIndentBefore(node.expression, node);
            emitExpression(node.expression, /*parenthesizerRule*/ void 0);
            writeLineSeparatorsAfter(node.expression, node);
            decreaseIndentIf(indented);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression ? node.expression.end : openParenPos, writePunctuation, node);
        }
        function emitFunctionExpression(node) {
            generateNameIfNeeded(node.name);
            emitFunctionDeclarationOrExpression(node);
        }
        function emitArrowFunction(node) {
            emitModifierList(node, node.modifiers);
            emitSignatureAndBody(node, emitArrowFunctionHead, emitArrowFunctionBody);
        }
        function emitArrowFunctionHead(node) {
            emitTypeParameters(node, node.typeParameters);
            emitParametersForArrow(node, node.parameters);
            emitTypeAnnotation(node.type);
            writeSpace();
            emit(node.equalsGreaterThanToken);
        }
        function emitArrowFunctionBody(node) {
            if (isBlock(node.body)) emitBlockFunctionBody(node.body);
            else {
                writeSpace();
                emitExpression(node.body, parenthesizer.parenthesizeConciseBodyOfArrowFunction);
            }
        }
        function emitDeleteExpression(node) {
            emitTokenWithComment(91 /* DeleteKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitTypeOfExpression(node) {
            emitTokenWithComment(114 /* TypeOfKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitVoidExpression(node) {
            emitTokenWithComment(116 /* VoidKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitAwaitExpression(node) {
            emitTokenWithComment(135 /* AwaitKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function emitPrefixUnaryExpression(node) {
            writeTokenText(node.operator, writeOperator);
            if (shouldEmitWhitespaceBeforeOperand(node)) writeSpace();
            emitExpression(node.operand, parenthesizer.parenthesizeOperandOfPrefixUnary);
        }
        function shouldEmitWhitespaceBeforeOperand(node) {
            const operand = node.operand;
            return operand.kind === 225 /* PrefixUnaryExpression */  && (node.operator === 40 /* PlusToken */  && (operand.operator === 40 /* PlusToken */  || operand.operator === 46 /* PlusPlusToken */ ) || node.operator === 41 /* MinusToken */  && (operand.operator === 41 /* MinusToken */  || operand.operator === 47 /* MinusMinusToken */ ));
        }
        function emitPostfixUnaryExpression(node) {
            emitExpression(node.operand, parenthesizer.parenthesizeOperandOfPostfixUnary);
            writeTokenText(node.operator, writeOperator);
        }
        function createEmitBinaryExpression() {
            return createBinaryExpressionTrampoline(onEnter, onLeft, onOperator, onRight, onExit, /*foldState*/ void 0);
            function onEnter(node, state) {
                if (state) {
                    state.stackIndex++;
                    state.preserveSourceNewlinesStack[state.stackIndex] = preserveSourceNewlines;
                    state.containerPosStack[state.stackIndex] = containerPos;
                    state.containerEndStack[state.stackIndex] = containerEnd;
                    state.declarationListContainerEndStack[state.stackIndex] = declarationListContainerEnd;
                    const emitComments2 = state.shouldEmitCommentsStack[state.stackIndex] = shouldEmitComments(node);
                    const emitSourceMaps = state.shouldEmitSourceMapsStack[state.stackIndex] = shouldEmitSourceMaps(node);
                    onBeforeEmitNode == null || onBeforeEmitNode(node);
                    if (emitComments2) emitCommentsBeforeNode(node);
                    if (emitSourceMaps) emitSourceMapsBeforeNode(node);
                    beforeEmitNode(node);
                } else state = {
                    stackIndex: 0,
                    preserveSourceNewlinesStack: [
                        void 0
                    ],
                    containerPosStack: [
                        -1
                    ],
                    containerEndStack: [
                        -1
                    ],
                    declarationListContainerEndStack: [
                        -1
                    ],
                    shouldEmitCommentsStack: [
                        false
                    ],
                    shouldEmitSourceMapsStack: [
                        false
                    ]
                };
                return state;
            }
            function onLeft(next, _workArea, parent2) {
                return maybeEmitExpression(next, parent2, "left");
            }
            function onOperator(operatorToken, _state, node) {
                const isCommaOperator = operatorToken.kind !== 28 /* CommaToken */ ;
                const linesBeforeOperator = getLinesBetweenNodes(node, node.left, operatorToken);
                const linesAfterOperator = getLinesBetweenNodes(node, operatorToken, node.right);
                writeLinesAndIndent(linesBeforeOperator, isCommaOperator);
                emitLeadingCommentsOfPosition(operatorToken.pos);
                writeTokenNode(operatorToken, operatorToken.kind === 103 /* InKeyword */  ? writeKeyword : writeOperator);
                emitTrailingCommentsOfPosition(operatorToken.end, /*prefixSpace*/ true);
                writeLinesAndIndent(linesAfterOperator, /*writeSpaceIfNotIndenting*/ true);
            }
            function onRight(next, _workArea, parent2) {
                return maybeEmitExpression(next, parent2, "right");
            }
            function onExit(node, state) {
                const linesBeforeOperator = getLinesBetweenNodes(node, node.left, node.operatorToken);
                const linesAfterOperator = getLinesBetweenNodes(node, node.operatorToken, node.right);
                decreaseIndentIf(linesBeforeOperator, linesAfterOperator);
                if (state.stackIndex > 0) {
                    const savedPreserveSourceNewlines = state.preserveSourceNewlinesStack[state.stackIndex];
                    const savedContainerPos = state.containerPosStack[state.stackIndex];
                    const savedContainerEnd = state.containerEndStack[state.stackIndex];
                    const savedDeclarationListContainerEnd = state.declarationListContainerEndStack[state.stackIndex];
                    const shouldEmitComments2 = state.shouldEmitCommentsStack[state.stackIndex];
                    const shouldEmitSourceMaps2 = state.shouldEmitSourceMapsStack[state.stackIndex];
                    afterEmitNode(savedPreserveSourceNewlines);
                    if (shouldEmitSourceMaps2) emitSourceMapsAfterNode(node);
                    if (shouldEmitComments2) emitCommentsAfterNode(node, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
                    onAfterEmitNode == null || onAfterEmitNode(node);
                    state.stackIndex--;
                }
            }
            function maybeEmitExpression(next, parent2, side) {
                const parenthesizerRule = side === "left" ? parenthesizer.getParenthesizeLeftSideOfBinaryForOperator(parent2.operatorToken.kind) : parenthesizer.getParenthesizeRightSideOfBinaryForOperator(parent2.operatorToken.kind);
                let pipelinePhase = getPipelinePhase(0 /* Notification */ , 1 /* Expression */ , next);
                if (pipelinePhase === pipelineEmitWithSubstitution) {
                    Debug.assertIsDefined(lastSubstitution);
                    next = parenthesizerRule(cast(lastSubstitution, isExpression));
                    pipelinePhase = getNextPipelinePhase(1 /* Substitution */ , 1 /* Expression */ , next);
                    lastSubstitution = void 0;
                }
                if (pipelinePhase === pipelineEmitWithComments || pipelinePhase === pipelineEmitWithSourceMaps || pipelinePhase === pipelineEmitWithHint) {
                    if (isBinaryExpression(next)) return next;
                }
                currentParenthesizerRule = parenthesizerRule;
                pipelinePhase(1 /* Expression */ , next);
            }
        }
        function emitConditionalExpression(node) {
            const linesBeforeQuestion = getLinesBetweenNodes(node, node.condition, node.questionToken);
            const linesAfterQuestion = getLinesBetweenNodes(node, node.questionToken, node.whenTrue);
            const linesBeforeColon = getLinesBetweenNodes(node, node.whenTrue, node.colonToken);
            const linesAfterColon = getLinesBetweenNodes(node, node.colonToken, node.whenFalse);
            emitExpression(node.condition, parenthesizer.parenthesizeConditionOfConditionalExpression);
            writeLinesAndIndent(linesBeforeQuestion, /*writeSpaceIfNotIndenting*/ true);
            emit(node.questionToken);
            writeLinesAndIndent(linesAfterQuestion, /*writeSpaceIfNotIndenting*/ true);
            emitExpression(node.whenTrue, parenthesizer.parenthesizeBranchOfConditionalExpression);
            decreaseIndentIf(linesBeforeQuestion, linesAfterQuestion);
            writeLinesAndIndent(linesBeforeColon, /*writeSpaceIfNotIndenting*/ true);
            emit(node.colonToken);
            writeLinesAndIndent(linesAfterColon, /*writeSpaceIfNotIndenting*/ true);
            emitExpression(node.whenFalse, parenthesizer.parenthesizeBranchOfConditionalExpression);
            decreaseIndentIf(linesBeforeColon, linesAfterColon);
        }
        function emitTemplateExpression(node) {
            emit(node.head);
            emitList(node, node.templateSpans, 262144 /* TemplateExpressionSpans */ );
        }
        function emitYieldExpression(node) {
            emitTokenWithComment(127 /* YieldKeyword */ , node.pos, writeKeyword, node);
            emit(node.asteriskToken);
            emitExpressionWithLeadingSpace(node.expression && parenthesizeExpressionForNoAsi(node.expression), parenthesizeExpressionForNoAsiAndDisallowedComma);
        }
        function emitSpreadElement(node) {
            emitTokenWithComment(26 /* DotDotDotToken */ , node.pos, writePunctuation, node);
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitClassExpression(node) {
            generateNameIfNeeded(node.name);
            emitClassDeclarationOrExpression(node);
        }
        function emitExpressionWithTypeArguments(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            emitTypeArguments(node, node.typeArguments);
        }
        function emitAsExpression(node) {
            emitExpression(node.expression, /*parenthesizerRule*/ void 0);
            if (node.type) {
                writeSpace();
                writeKeyword("as");
                writeSpace();
                emit(node.type);
            }
        }
        function emitNonNullExpression(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeLeftSideOfAccess);
            writeOperator("!");
        }
        function emitSatisfiesExpression(node) {
            emitExpression(node.expression, /*parenthesizerRule*/ void 0);
            if (node.type) {
                writeSpace();
                writeKeyword("satisfies");
                writeSpace();
                emit(node.type);
            }
        }
        function emitMetaProperty(node) {
            writeToken(node.keywordToken, node.pos, writePunctuation);
            writePunctuation(".");
            emit(node.name);
        }
        function emitTemplateSpan(node) {
            emitExpression(node.expression);
            emit(node.literal);
        }
        function emitBlock(node) {
            emitBlockStatements(node, /*forceSingleLine*/ !node.multiLine && isEmptyBlock(node));
        }
        function emitBlockStatements(node, forceSingleLine) {
            emitTokenWithComment(19 /* OpenBraceToken */ , node.pos, writePunctuation, /*contextNode*/ node);
            const format = forceSingleLine || getEmitFlags(node) & 1 /* SingleLine */  ? 768 /* SingleLineBlockStatements */  : 129 /* MultiLineBlockStatements */ ;
            emitList(node, node.statements, format);
            emitTokenWithComment(20 /* CloseBraceToken */ , node.statements.end, writePunctuation, /*contextNode*/ node, /*indentLeading*/ !!(format & 1 /* MultiLine */ ));
        }
        function emitVariableStatement(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emit(node.declarationList);
            writeTrailingSemicolon();
        }
        function emitEmptyStatement(isEmbeddedStatement) {
            if (isEmbeddedStatement) writePunctuation(";");
            else writeTrailingSemicolon();
        }
        function emitExpressionStatement(node) {
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionOfExpressionStatement);
            if (!currentSourceFile || !isJsonSourceFile(currentSourceFile) || nodeIsSynthesized(node.expression)) writeTrailingSemicolon();
        }
        function emitIfStatement(node) {
            const openParenPos = emitTokenWithComment(101 /* IfKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.thenStatement);
            if (node.elseStatement) {
                writeLineOrSpace(node, node.thenStatement, node.elseStatement);
                emitTokenWithComment(93 /* ElseKeyword */ , node.thenStatement.end, writeKeyword, node);
                if (node.elseStatement.kind === 246 /* IfStatement */ ) {
                    writeSpace();
                    emit(node.elseStatement);
                } else emitEmbeddedStatement(node, node.elseStatement);
            }
        }
        function emitWhileClause(node, startPos) {
            const openParenPos = emitTokenWithComment(117 /* WhileKeyword */ , startPos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
        }
        function emitDoStatement(node) {
            emitTokenWithComment(92 /* DoKeyword */ , node.pos, writeKeyword, node);
            emitEmbeddedStatement(node, node.statement);
            if (isBlock(node.statement) && !preserveSourceNewlines) writeSpace();
            else writeLineOrSpace(node, node.statement, node.expression);
            emitWhileClause(node, node.statement.end);
            writeTrailingSemicolon();
        }
        function emitWhileStatement(node) {
            emitWhileClause(node, node.pos);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForStatement(node) {
            const openParenPos = emitTokenWithComment(99 /* ForKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            let pos = emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, /*contextNode*/ node);
            emitForBinding(node.initializer);
            pos = emitTokenWithComment(27 /* SemicolonToken */ , node.initializer ? node.initializer.end : pos, writePunctuation, node);
            emitExpressionWithLeadingSpace(node.condition);
            pos = emitTokenWithComment(27 /* SemicolonToken */ , node.condition ? node.condition.end : pos, writePunctuation, node);
            emitExpressionWithLeadingSpace(node.incrementor);
            emitTokenWithComment(22 /* CloseParenToken */ , node.incrementor ? node.incrementor.end : pos, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForInStatement(node) {
            const openParenPos = emitTokenWithComment(99 /* ForKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitForBinding(node.initializer);
            writeSpace();
            emitTokenWithComment(103 /* InKeyword */ , node.initializer.end, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForOfStatement(node) {
            const openParenPos = emitTokenWithComment(99 /* ForKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitWithTrailingSpace(node.awaitModifier);
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitForBinding(node.initializer);
            writeSpace();
            emitTokenWithComment(165 /* OfKeyword */ , node.initializer.end, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitForBinding(node) {
            if (node !== void 0) {
                if (node.kind === 262 /* VariableDeclarationList */ ) emit(node);
                else emitExpression(node);
            }
        }
        function emitContinueStatement(node) {
            emitTokenWithComment(88 /* ContinueKeyword */ , node.pos, writeKeyword, node);
            emitWithLeadingSpace(node.label);
            writeTrailingSemicolon();
        }
        function emitBreakStatement(node) {
            emitTokenWithComment(83 /* BreakKeyword */ , node.pos, writeKeyword, node);
            emitWithLeadingSpace(node.label);
            writeTrailingSemicolon();
        }
        function emitTokenWithComment(token, pos, writer2, contextNode, indentLeading) {
            const node = getParseTreeNode(contextNode);
            const isSimilarNode = node && node.kind === contextNode.kind;
            const startPos = pos;
            if (isSimilarNode && currentSourceFile) pos = skipTrivia(currentSourceFile.text, pos);
            if (isSimilarNode && contextNode.pos !== startPos) {
                const needsIndent = indentLeading && currentSourceFile && !positionsAreOnSameLine(startPos, pos, currentSourceFile);
                if (needsIndent) increaseIndent();
                emitLeadingCommentsOfPosition(startPos);
                if (needsIndent) decreaseIndent();
            }
            if (!omitBraceSourcePositions && (token === 19 /* OpenBraceToken */  || token === 20 /* CloseBraceToken */ )) pos = writeToken(token, pos, writer2, contextNode);
            else pos = writeTokenText(token, writer2, pos);
            if (isSimilarNode && contextNode.end !== pos) {
                const isJsxExprContext = contextNode.kind === 295 /* JsxExpression */ ;
                emitTrailingCommentsOfPosition(pos, /*prefixSpace*/ !isJsxExprContext, /*forceNoNewline*/ isJsxExprContext);
            }
            return pos;
        }
        function commentWillEmitNewLine(node) {
            return node.kind === 2 /* SingleLineCommentTrivia */  || !!node.hasTrailingNewLine;
        }
        function willEmitLeadingNewLine(node) {
            if (!currentSourceFile) return false;
            const leadingCommentRanges = getLeadingCommentRanges(currentSourceFile.text, node.pos);
            if (leadingCommentRanges) {
                const parseNode = getParseTreeNode(node);
                if (parseNode && isParenthesizedExpression(parseNode.parent)) return true;
            }
            if (some(leadingCommentRanges, commentWillEmitNewLine)) return true;
            if (some(getSyntheticLeadingComments(node), commentWillEmitNewLine)) return true;
            if (isPartiallyEmittedExpression(node)) {
                if (node.pos !== node.expression.pos) {
                    if (some(getTrailingCommentRanges(currentSourceFile.text, node.expression.pos), commentWillEmitNewLine)) return true;
                }
                return willEmitLeadingNewLine(node.expression);
            }
            return false;
        }
        function parenthesizeExpressionForNoAsi(node) {
            if (!commentsDisabled) switch(node.kind){
                case 356 /* PartiallyEmittedExpression */ :
                    if (willEmitLeadingNewLine(node)) {
                        const parseNode = getParseTreeNode(node);
                        if (parseNode && isParenthesizedExpression(parseNode)) {
                            const parens = factory.createParenthesizedExpression(node.expression);
                            setOriginalNode(parens, node);
                            setTextRange(parens, parseNode);
                            return parens;
                        }
                        return factory.createParenthesizedExpression(node);
                    }
                    return factory.updatePartiallyEmittedExpression(node, parenthesizeExpressionForNoAsi(node.expression));
                case 212 /* PropertyAccessExpression */ :
                    return factory.updatePropertyAccessExpression(node, parenthesizeExpressionForNoAsi(node.expression), node.name);
                case 213 /* ElementAccessExpression */ :
                    return factory.updateElementAccessExpression(node, parenthesizeExpressionForNoAsi(node.expression), node.argumentExpression);
                case 214 /* CallExpression */ :
                    return factory.updateCallExpression(node, parenthesizeExpressionForNoAsi(node.expression), node.typeArguments, node.arguments);
                case 216 /* TaggedTemplateExpression */ :
                    return factory.updateTaggedTemplateExpression(node, parenthesizeExpressionForNoAsi(node.tag), node.typeArguments, node.template);
                case 226 /* PostfixUnaryExpression */ :
                    return factory.updatePostfixUnaryExpression(node, parenthesizeExpressionForNoAsi(node.operand));
                case 227 /* BinaryExpression */ :
                    return factory.updateBinaryExpression(node, parenthesizeExpressionForNoAsi(node.left), node.operatorToken, node.right);
                case 228 /* ConditionalExpression */ :
                    return factory.updateConditionalExpression(node, parenthesizeExpressionForNoAsi(node.condition), node.questionToken, node.whenTrue, node.colonToken, node.whenFalse);
                case 235 /* AsExpression */ :
                    return factory.updateAsExpression(node, parenthesizeExpressionForNoAsi(node.expression), node.type);
                case 239 /* SatisfiesExpression */ :
                    return factory.updateSatisfiesExpression(node, parenthesizeExpressionForNoAsi(node.expression), node.type);
                case 236 /* NonNullExpression */ :
                    return factory.updateNonNullExpression(node, parenthesizeExpressionForNoAsi(node.expression));
            }
            return node;
        }
        function parenthesizeExpressionForNoAsiAndDisallowedComma(node) {
            return parenthesizeExpressionForNoAsi(parenthesizer.parenthesizeExpressionForDisallowedComma(node));
        }
        function emitReturnStatement(node) {
            emitTokenWithComment(107 /* ReturnKeyword */ , node.pos, writeKeyword, /*contextNode*/ node);
            emitExpressionWithLeadingSpace(node.expression && parenthesizeExpressionForNoAsi(node.expression), parenthesizeExpressionForNoAsi);
            writeTrailingSemicolon();
        }
        function emitWithStatement(node) {
            const openParenPos = emitTokenWithComment(118 /* WithKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            emitEmbeddedStatement(node, node.statement);
        }
        function emitSwitchStatement(node) {
            const openParenPos = emitTokenWithComment(109 /* SwitchKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
            emitExpression(node.expression);
            emitTokenWithComment(22 /* CloseParenToken */ , node.expression.end, writePunctuation, node);
            writeSpace();
            emit(node.caseBlock);
        }
        function emitLabeledStatement(node) {
            emit(node.label);
            emitTokenWithComment(59 /* ColonToken */ , node.label.end, writePunctuation, node);
            writeSpace();
            emit(node.statement);
        }
        function emitThrowStatement(node) {
            emitTokenWithComment(111 /* ThrowKeyword */ , node.pos, writeKeyword, node);
            emitExpressionWithLeadingSpace(parenthesizeExpressionForNoAsi(node.expression), parenthesizeExpressionForNoAsi);
            writeTrailingSemicolon();
        }
        function emitTryStatement(node) {
            emitTokenWithComment(113 /* TryKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emit(node.tryBlock);
            if (node.catchClause) {
                writeLineOrSpace(node, node.tryBlock, node.catchClause);
                emit(node.catchClause);
            }
            if (node.finallyBlock) {
                writeLineOrSpace(node, node.catchClause || node.tryBlock, node.finallyBlock);
                emitTokenWithComment(98 /* FinallyKeyword */ , (node.catchClause || node.tryBlock).end, writeKeyword, node);
                writeSpace();
                emit(node.finallyBlock);
            }
        }
        function emitDebuggerStatement(node) {
            writeToken(89 /* DebuggerKeyword */ , node.pos, writeKeyword);
            writeTrailingSemicolon();
        }
        function emitVariableDeclaration(node) {
            var _a, _b, _c;
            emit(node.name);
            emit(node.exclamationToken);
            emitTypeAnnotation(node.type);
            var _ref, _ref1;
            emitInitializer(node.initializer, (_ref1 = (_ref = (_a = node.type) == null ? void 0 : _a.end) !== null && _ref !== void 0 ? _ref : (_c = (_b = node.name.emitNode) == null ? void 0 : _b.typeNode) == null ? void 0 : _c.end) !== null && _ref1 !== void 0 ? _ref1 : node.name.end, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitVariableDeclarationList(node) {
            if (isVarAwaitUsing(node)) {
                writeKeyword("await");
                writeSpace();
                writeKeyword("using");
            } else {
                const head = isLet(node) ? "let" : isVarConst(node) ? "const" : isVarUsing(node) ? "using" : "var";
                writeKeyword(head);
            }
            writeSpace();
            emitList(node, node.declarations, 528 /* VariableDeclarationList */ );
        }
        function emitFunctionDeclaration(node) {
            emitFunctionDeclarationOrExpression(node);
        }
        function emitFunctionDeclarationOrExpression(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("function");
            emit(node.asteriskToken);
            writeSpace();
            emitIdentifierName(node.name);
            emitSignatureAndBody(node, emitSignatureHead, emitFunctionBody);
        }
        function emitSignatureAndBody(node, emitSignatureHead2, emitBody) {
            const indentedFlag = getEmitFlags(node) & 131072 /* Indented */ ;
            if (indentedFlag) increaseIndent();
            pushNameGenerationScope(node);
            forEach(node.parameters, generateNames);
            emitSignatureHead2(node);
            emitBody(node);
            popNameGenerationScope(node);
            if (indentedFlag) decreaseIndent();
        }
        function emitFunctionBody(node) {
            const body = node.body;
            if (body) emitBlockFunctionBody(body);
            else writeTrailingSemicolon();
        }
        function emitEmptyFunctionBody(_node) {
            writeTrailingSemicolon();
        }
        function emitSignatureHead(node) {
            emitTypeParameters(node, node.typeParameters);
            emitParameters(node, node.parameters);
            emitTypeAnnotation(node.type);
        }
        function shouldEmitBlockFunctionBodyOnSingleLine(body) {
            if (getEmitFlags(body) & 1 /* SingleLine */ ) return true;
            if (body.multiLine) return false;
            if (!nodeIsSynthesized(body) && currentSourceFile && !rangeIsOnSingleLine(body, currentSourceFile)) return false;
            if (getLeadingLineTerminatorCount(body, firstOrUndefined(body.statements), 2 /* PreserveLines */ ) || getClosingLineTerminatorCount(body, lastOrUndefined(body.statements), 2 /* PreserveLines */ , body.statements)) return false;
            let previousStatement;
            for (const statement of body.statements){
                if (getSeparatingLineTerminatorCount(previousStatement, statement, 2 /* PreserveLines */ ) > 0) return false;
                previousStatement = statement;
            }
            return true;
        }
        function emitBlockFunctionBody(body) {
            generateNames(body);
            onBeforeEmitNode == null || onBeforeEmitNode(body);
            writeSpace();
            writePunctuation("{");
            increaseIndent();
            const emitBlockFunctionBody2 = shouldEmitBlockFunctionBodyOnSingleLine(body) ? emitBlockFunctionBodyOnSingleLine : emitBlockFunctionBodyWorker;
            emitBodyWithDetachedComments(body, body.statements, emitBlockFunctionBody2);
            decreaseIndent();
            writeToken(20 /* CloseBraceToken */ , body.statements.end, writePunctuation, body);
            onAfterEmitNode == null || onAfterEmitNode(body);
        }
        function emitBlockFunctionBodyOnSingleLine(body) {
            emitBlockFunctionBodyWorker(body, /*emitBlockFunctionBodyOnSingleLine*/ true);
        }
        function emitBlockFunctionBodyWorker(body, emitBlockFunctionBodyOnSingleLine2) {
            const statementOffset = emitPrologueDirectives(body.statements);
            const pos = writer.getTextPos();
            emitHelpers(body);
            if (statementOffset === 0 && pos === writer.getTextPos() && emitBlockFunctionBodyOnSingleLine2) {
                decreaseIndent();
                emitList(body, body.statements, 768 /* SingleLineFunctionBodyStatements */ );
                increaseIndent();
            } else emitList(body, body.statements, 1 /* MultiLineFunctionBodyStatements */ , /*parenthesizerRule*/ void 0, statementOffset);
        }
        function emitClassDeclaration(node) {
            emitClassDeclarationOrExpression(node);
        }
        function emitClassDeclarationOrExpression(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ true);
            emitTokenWithComment(86 /* ClassKeyword */ , moveRangePastModifiers(node).pos, writeKeyword, node);
            if (node.name) {
                writeSpace();
                emitIdentifierName(node.name);
            }
            const indentedFlag = getEmitFlags(node) & 131072 /* Indented */ ;
            if (indentedFlag) increaseIndent();
            emitTypeParameters(node, node.typeParameters);
            emitList(node, node.heritageClauses, 0 /* ClassHeritageClauses */ );
            writeSpace();
            writePunctuation("{");
            pushNameGenerationScope(node);
            forEach(node.members, generateMemberNames);
            emitList(node, node.members, 129 /* ClassMembers */ );
            popNameGenerationScope(node);
            writePunctuation("}");
            if (indentedFlag) decreaseIndent();
        }
        function emitInterfaceDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("interface");
            writeSpace();
            emit(node.name);
            emitTypeParameters(node, node.typeParameters);
            emitList(node, node.heritageClauses, 512 /* HeritageClauses */ );
            writeSpace();
            writePunctuation("{");
            pushNameGenerationScope(node);
            forEach(node.members, generateMemberNames);
            emitList(node, node.members, 129 /* InterfaceMembers */ );
            popNameGenerationScope(node);
            writePunctuation("}");
        }
        function emitTypeAliasDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("type");
            writeSpace();
            emit(node.name);
            emitTypeParameters(node, node.typeParameters);
            writeSpace();
            writePunctuation("=");
            writeSpace();
            emit(node.type);
            writeTrailingSemicolon();
        }
        function emitEnumDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            writeKeyword("enum");
            writeSpace();
            emit(node.name);
            writeSpace();
            writePunctuation("{");
            emitList(node, node.members, 145 /* EnumMembers */ );
            writePunctuation("}");
        }
        function emitModuleDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            if (~node.flags & 2048 /* GlobalAugmentation */ ) {
                writeKeyword(node.flags & 32 /* Namespace */  ? "namespace" : "module");
                writeSpace();
            }
            emit(node.name);
            let body = node.body;
            if (!body) return writeTrailingSemicolon();
            while(body && isModuleDeclaration(body)){
                writePunctuation(".");
                emit(body.name);
                body = body.body;
            }
            writeSpace();
            emit(body);
        }
        function emitModuleBlock(node) {
            pushNameGenerationScope(node);
            forEach(node.statements, generateNames);
            emitBlockStatements(node, /*forceSingleLine*/ isEmptyBlock(node));
            popNameGenerationScope(node);
        }
        function emitCaseBlock(node) {
            emitTokenWithComment(19 /* OpenBraceToken */ , node.pos, writePunctuation, node);
            emitList(node, node.clauses, 129 /* CaseBlockClauses */ );
            emitTokenWithComment(20 /* CloseBraceToken */ , node.clauses.end, writePunctuation, node, /*indentLeading*/ true);
        }
        function emitImportEqualsDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emitTokenWithComment(102 /* ImportKeyword */ , node.modifiers ? node.modifiers.end : node.pos, writeKeyword, node);
            writeSpace();
            if (node.isTypeOnly) {
                emitTokenWithComment(156 /* TypeKeyword */ , node.pos, writeKeyword, node);
                writeSpace();
            }
            emit(node.name);
            writeSpace();
            emitTokenWithComment(64 /* EqualsToken */ , node.name.end, writePunctuation, node);
            writeSpace();
            emitModuleReference(node.moduleReference);
            writeTrailingSemicolon();
        }
        function emitModuleReference(node) {
            if (node.kind === 80 /* Identifier */ ) emitExpression(node);
            else emit(node);
        }
        function emitImportDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            emitTokenWithComment(102 /* ImportKeyword */ , node.modifiers ? node.modifiers.end : node.pos, writeKeyword, node);
            writeSpace();
            if (node.importClause) {
                emit(node.importClause);
                writeSpace();
                emitTokenWithComment(161 /* FromKeyword */ , node.importClause.end, writeKeyword, node);
                writeSpace();
            }
            emitExpression(node.moduleSpecifier);
            if (node.attributes) emitWithLeadingSpace(node.attributes);
            writeTrailingSemicolon();
        }
        function emitImportClause(node) {
            if (node.phaseModifier !== void 0) {
                emitTokenWithComment(node.phaseModifier, node.pos, writeKeyword, node);
                writeSpace();
            }
            emit(node.name);
            if (node.name && node.namedBindings) {
                emitTokenWithComment(28 /* CommaToken */ , node.name.end, writePunctuation, node);
                writeSpace();
            }
            emit(node.namedBindings);
        }
        function emitNamespaceImport(node) {
            const asPos = emitTokenWithComment(42 /* AsteriskToken */ , node.pos, writePunctuation, node);
            writeSpace();
            emitTokenWithComment(130 /* AsKeyword */ , asPos, writeKeyword, node);
            writeSpace();
            emit(node.name);
        }
        function emitNamedImports(node) {
            emitNamedImportsOrExports(node);
        }
        function emitImportSpecifier(node) {
            emitImportOrExportSpecifier(node);
        }
        function emitExportAssignment(node) {
            const nextPos = emitTokenWithComment(95 /* ExportKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            if (node.isExportEquals) emitTokenWithComment(64 /* EqualsToken */ , nextPos, writeOperator, node);
            else emitTokenWithComment(90 /* DefaultKeyword */ , nextPos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, node.isExportEquals ? parenthesizer.getParenthesizeRightSideOfBinaryForOperator(64 /* EqualsToken */ ) : parenthesizer.parenthesizeExpressionOfExportDefault);
            writeTrailingSemicolon();
        }
        function emitExportDeclaration(node) {
            emitDecoratorsAndModifiers(node, node.modifiers, /*allowDecorators*/ false);
            let nextPos = emitTokenWithComment(95 /* ExportKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            if (node.isTypeOnly) {
                nextPos = emitTokenWithComment(156 /* TypeKeyword */ , nextPos, writeKeyword, node);
                writeSpace();
            }
            if (node.exportClause) emit(node.exportClause);
            else nextPos = emitTokenWithComment(42 /* AsteriskToken */ , nextPos, writePunctuation, node);
            if (node.moduleSpecifier) {
                writeSpace();
                const fromPos = node.exportClause ? node.exportClause.end : nextPos;
                emitTokenWithComment(161 /* FromKeyword */ , fromPos, writeKeyword, node);
                writeSpace();
                emitExpression(node.moduleSpecifier);
            }
            if (node.attributes) emitWithLeadingSpace(node.attributes);
            writeTrailingSemicolon();
        }
        function emitImportTypeNodeAttributes(node) {
            writePunctuation("{");
            writeSpace();
            writeKeyword(node.token === 132 /* AssertKeyword */  ? "assert" : "with");
            writePunctuation(":");
            writeSpace();
            const elements = node.elements;
            emitList(node, elements, 526226 /* ImportAttributes */ );
            writeSpace();
            writePunctuation("}");
        }
        function emitImportAttributes(node) {
            emitTokenWithComment(node.token, node.pos, writeKeyword, node);
            writeSpace();
            const elements = node.elements;
            emitList(node, elements, 526226 /* ImportAttributes */ );
        }
        function emitImportAttribute(node) {
            emit(node.name);
            writePunctuation(":");
            writeSpace();
            const value1 = node.value;
            if ((getEmitFlags(value1) & 1024 /* NoLeadingComments */ ) === 0) {
                const commentRange = getCommentRange(value1);
                emitTrailingCommentsOfPosition(commentRange.pos);
            }
            emit(value1);
        }
        function emitNamespaceExportDeclaration(node) {
            let nextPos = emitTokenWithComment(95 /* ExportKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            nextPos = emitTokenWithComment(130 /* AsKeyword */ , nextPos, writeKeyword, node);
            writeSpace();
            nextPos = emitTokenWithComment(145 /* NamespaceKeyword */ , nextPos, writeKeyword, node);
            writeSpace();
            emit(node.name);
            writeTrailingSemicolon();
        }
        function emitNamespaceExport(node) {
            const asPos = emitTokenWithComment(42 /* AsteriskToken */ , node.pos, writePunctuation, node);
            writeSpace();
            emitTokenWithComment(130 /* AsKeyword */ , asPos, writeKeyword, node);
            writeSpace();
            emit(node.name);
        }
        function emitNamedExports(node) {
            emitNamedImportsOrExports(node);
        }
        function emitExportSpecifier(node) {
            emitImportOrExportSpecifier(node);
        }
        function emitNamedImportsOrExports(node) {
            writePunctuation("{");
            emitList(node, node.elements, 525136 /* NamedImportsOrExportsElements */ );
            writePunctuation("}");
        }
        function emitImportOrExportSpecifier(node) {
            if (node.isTypeOnly) {
                writeKeyword("type");
                writeSpace();
            }
            if (node.propertyName) {
                emit(node.propertyName);
                writeSpace();
                emitTokenWithComment(130 /* AsKeyword */ , node.propertyName.end, writeKeyword, node);
                writeSpace();
            }
            emit(node.name);
        }
        function emitExternalModuleReference(node) {
            writeKeyword("require");
            writePunctuation("(");
            emitExpression(node.expression);
            writePunctuation(")");
        }
        function emitJsxElement(node) {
            emit(node.openingElement);
            emitList(node, node.children, 262144 /* JsxElementOrFragmentChildren */ );
            emit(node.closingElement);
        }
        function emitJsxSelfClosingElement(node) {
            writePunctuation("<");
            emitJsxTagName(node.tagName);
            emitTypeArguments(node, node.typeArguments);
            writeSpace();
            emit(node.attributes);
            writePunctuation("/>");
        }
        function emitJsxFragment(node) {
            emit(node.openingFragment);
            emitList(node, node.children, 262144 /* JsxElementOrFragmentChildren */ );
            emit(node.closingFragment);
        }
        function emitJsxOpeningElementOrFragment(node) {
            writePunctuation("<");
            if (isJsxOpeningElement(node)) {
                const indented = writeLineSeparatorsAndIndentBefore(node.tagName, node);
                emitJsxTagName(node.tagName);
                emitTypeArguments(node, node.typeArguments);
                if (node.attributes.properties && node.attributes.properties.length > 0) writeSpace();
                emit(node.attributes);
                writeLineSeparatorsAfter(node.attributes, node);
                decreaseIndentIf(indented);
            }
            writePunctuation(">");
        }
        function emitJsxText(node) {
            writer.writeLiteral(node.text);
        }
        function emitJsxClosingElementOrFragment(node) {
            writePunctuation("</");
            if (isJsxClosingElement(node)) emitJsxTagName(node.tagName);
            writePunctuation(">");
        }
        function emitJsxAttributes(node) {
            emitList(node, node.properties, 262656 /* JsxElementAttributes */ );
        }
        function emitJsxAttribute(node) {
            emit(node.name);
            emitNodeWithPrefix("=", writePunctuation, node.initializer, emitJsxAttributeValue);
        }
        function emitJsxSpreadAttribute(node) {
            writePunctuation("{...");
            emitExpression(node.expression);
            writePunctuation("}");
        }
        function hasTrailingCommentsAtPosition(pos) {
            let result = false;
            forEachTrailingCommentRange((currentSourceFile == null ? void 0 : currentSourceFile.text) || "", pos + 1, ()=>result = true);
            return result;
        }
        function hasLeadingCommentsAtPosition(pos) {
            let result = false;
            forEachLeadingCommentRange((currentSourceFile == null ? void 0 : currentSourceFile.text) || "", pos + 1, ()=>result = true);
            return result;
        }
        function hasCommentsAtPosition(pos) {
            return hasTrailingCommentsAtPosition(pos) || hasLeadingCommentsAtPosition(pos);
        }
        function emitJsxExpression(node) {
            var _a;
            if (node.expression || !commentsDisabled && !nodeIsSynthesized(node) && hasCommentsAtPosition(node.pos)) {
                const isMultiline = currentSourceFile && !nodeIsSynthesized(node) && getLineAndCharacterOfPosition(currentSourceFile, node.pos).line !== getLineAndCharacterOfPosition(currentSourceFile, node.end).line;
                if (isMultiline) writer.increaseIndent();
                const end = emitTokenWithComment(19 /* OpenBraceToken */ , node.pos, writePunctuation, node);
                emit(node.dotDotDotToken);
                emitExpression(node.expression);
                emitTokenWithComment(20 /* CloseBraceToken */ , ((_a = node.expression) == null ? void 0 : _a.end) || end, writePunctuation, node);
                if (isMultiline) writer.decreaseIndent();
            }
        }
        function emitJsxNamespacedName(node) {
            emitIdentifierName(node.namespace);
            writePunctuation(":");
            emitIdentifierName(node.name);
        }
        function emitJsxTagName(node) {
            if (node.kind === 80 /* Identifier */ ) emitExpression(node);
            else emit(node);
        }
        function emitCaseClause(node) {
            emitTokenWithComment(84 /* CaseKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            emitExpression(node.expression, parenthesizer.parenthesizeExpressionForDisallowedComma);
            emitCaseOrDefaultClauseRest(node, node.statements, node.expression.end);
        }
        function emitDefaultClause(node) {
            const pos = emitTokenWithComment(90 /* DefaultKeyword */ , node.pos, writeKeyword, node);
            emitCaseOrDefaultClauseRest(node, node.statements, pos);
        }
        function emitCaseOrDefaultClauseRest(parentNode, statements, colonPos) {
            const emitAsSingleStatement = statements.length === 1 && // treat synthesized nodes as located on the same line for emit purposes
            (!currentSourceFile || nodeIsSynthesized(parentNode) || nodeIsSynthesized(statements[0]) || rangeStartPositionsAreOnSameLine(parentNode, statements[0], currentSourceFile));
            let format = 163969 /* CaseOrDefaultClauseStatements */ ;
            if (emitAsSingleStatement) {
                writeToken(59 /* ColonToken */ , colonPos, writePunctuation, parentNode);
                writeSpace();
                format &= -130;
            } else emitTokenWithComment(59 /* ColonToken */ , colonPos, writePunctuation, parentNode);
            emitList(parentNode, statements, format);
        }
        function emitHeritageClause(node) {
            writeSpace();
            writeTokenText(node.token, writeKeyword);
            writeSpace();
            emitList(node, node.types, 528 /* HeritageClauseTypes */ );
        }
        function emitCatchClause(node) {
            const openParenPos = emitTokenWithComment(85 /* CatchKeyword */ , node.pos, writeKeyword, node);
            writeSpace();
            if (node.variableDeclaration) {
                emitTokenWithComment(21 /* OpenParenToken */ , openParenPos, writePunctuation, node);
                emit(node.variableDeclaration);
                emitTokenWithComment(22 /* CloseParenToken */ , node.variableDeclaration.end, writePunctuation, node);
                writeSpace();
            }
            emit(node.block);
        }
        function emitPropertyAssignment(node) {
            emit(node.name);
            writePunctuation(":");
            writeSpace();
            const initializer = node.initializer;
            if ((getEmitFlags(initializer) & 1024 /* NoLeadingComments */ ) === 0) {
                const commentRange = getCommentRange(initializer);
                emitTrailingCommentsOfPosition(commentRange.pos);
            }
            emitExpression(initializer, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitShorthandPropertyAssignment(node) {
            emit(node.name);
            if (node.objectAssignmentInitializer) {
                writeSpace();
                writePunctuation("=");
                writeSpace();
                emitExpression(node.objectAssignmentInitializer, parenthesizer.parenthesizeExpressionForDisallowedComma);
            }
        }
        function emitSpreadAssignment(node) {
            if (node.expression) {
                emitTokenWithComment(26 /* DotDotDotToken */ , node.pos, writePunctuation, node);
                emitExpression(node.expression, parenthesizer.parenthesizeExpressionForDisallowedComma);
            }
        }
        function emitEnumMember(node) {
            emit(node.name);
            emitInitializer(node.initializer, node.name.end, node, parenthesizer.parenthesizeExpressionForDisallowedComma);
        }
        function emitJSDoc(node) {
            write("/**");
            if (node.comment) {
                const text = getTextOfJSDocComment(node.comment);
                if (text) {
                    const lines = text.split(/\r\n?|\n/);
                    for (const line of lines){
                        writeLine();
                        writeSpace();
                        writePunctuation("*");
                        writeSpace();
                        write(line);
                    }
                }
            }
            if (node.tags) {
                if (node.tags.length === 1 && node.tags[0].kind === 345 /* JSDocTypeTag */  && !node.comment) {
                    writeSpace();
                    emit(node.tags[0]);
                } else emitList(node, node.tags, 33 /* JSDocComment */ );
            }
            writeSpace();
            write("*/");
        }
        function emitJSDocSimpleTypedTag(tag) {
            emitJSDocTagName(tag.tagName);
            emitJSDocTypeExpression(tag.typeExpression);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocSeeTag(tag) {
            emitJSDocTagName(tag.tagName);
            emit(tag.name);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocImportTag(tag) {
            emitJSDocTagName(tag.tagName);
            writeSpace();
            if (tag.importClause) {
                emit(tag.importClause);
                writeSpace();
                emitTokenWithComment(161 /* FromKeyword */ , tag.importClause.end, writeKeyword, tag);
                writeSpace();
            }
            emitExpression(tag.moduleSpecifier);
            if (tag.attributes) emitWithLeadingSpace(tag.attributes);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocNameReference(node) {
            writeSpace();
            writePunctuation("{");
            emit(node.name);
            writePunctuation("}");
        }
        function emitJSDocHeritageTag(tag) {
            emitJSDocTagName(tag.tagName);
            writeSpace();
            writePunctuation("{");
            emit(tag.class);
            writePunctuation("}");
            emitJSDocComment(tag.comment);
        }
        function emitJSDocTemplateTag(tag) {
            emitJSDocTagName(tag.tagName);
            emitJSDocTypeExpression(tag.constraint);
            writeSpace();
            emitList(tag, tag.typeParameters, 528 /* CommaListElements */ );
            emitJSDocComment(tag.comment);
        }
        function emitJSDocTypedefTag(tag) {
            emitJSDocTagName(tag.tagName);
            if (tag.typeExpression) {
                if (tag.typeExpression.kind === 310 /* JSDocTypeExpression */ ) emitJSDocTypeExpression(tag.typeExpression);
                else {
                    writeSpace();
                    writePunctuation("{");
                    write("Object");
                    if (tag.typeExpression.isArrayType) {
                        writePunctuation("[");
                        writePunctuation("]");
                    }
                    writePunctuation("}");
                }
            }
            if (tag.fullName) {
                writeSpace();
                emit(tag.fullName);
            }
            emitJSDocComment(tag.comment);
            if (tag.typeExpression && tag.typeExpression.kind === 323 /* JSDocTypeLiteral */ ) emitJSDocTypeLiteral(tag.typeExpression);
        }
        function emitJSDocCallbackTag(tag) {
            emitJSDocTagName(tag.tagName);
            if (tag.name) {
                writeSpace();
                emit(tag.name);
            }
            emitJSDocComment(tag.comment);
            emitJSDocSignature(tag.typeExpression);
        }
        function emitJSDocOverloadTag(tag) {
            emitJSDocComment(tag.comment);
            emitJSDocSignature(tag.typeExpression);
        }
        function emitJSDocSimpleTag(tag) {
            emitJSDocTagName(tag.tagName);
            emitJSDocComment(tag.comment);
        }
        function emitJSDocTypeLiteral(lit) {
            emitList(lit, factory.createNodeArray(lit.jsDocPropertyTags), 33 /* JSDocComment */ );
        }
        function emitJSDocSignature(sig) {
            if (sig.typeParameters) emitList(sig, factory.createNodeArray(sig.typeParameters), 33 /* JSDocComment */ );
            if (sig.parameters) emitList(sig, factory.createNodeArray(sig.parameters), 33 /* JSDocComment */ );
            if (sig.type) {
                writeLine();
                writeSpace();
                writePunctuation("*");
                writeSpace();
                emit(sig.type);
            }
        }
        function emitJSDocPropertyLikeTag(param) {
            emitJSDocTagName(param.tagName);
            emitJSDocTypeExpression(param.typeExpression);
            writeSpace();
            if (param.isBracketed) writePunctuation("[");
            emit(param.name);
            if (param.isBracketed) writePunctuation("]");
            emitJSDocComment(param.comment);
        }
        function emitJSDocTagName(tagName) {
            writePunctuation("@");
            emit(tagName);
        }
        function emitJSDocComment(comment) {
            const text = getTextOfJSDocComment(comment);
            if (text) {
                writeSpace();
                write(text);
            }
        }
        function emitJSDocTypeExpression(typeExpression) {
            if (typeExpression) {
                writeSpace();
                writePunctuation("{");
                emit(typeExpression.type);
                writePunctuation("}");
            }
        }
        function emitSourceFile(node) {
            writeLine();
            const statements = node.statements;
            const shouldEmitDetachedComment = statements.length === 0 || !isPrologueDirective(statements[0]) || nodeIsSynthesized(statements[0]);
            if (shouldEmitDetachedComment) {
                emitBodyWithDetachedComments(node, statements, emitSourceFileWorker);
                return;
            }
            emitSourceFileWorker(node);
        }
        function emitSyntheticTripleSlashReferencesIfNeeded(node) {
            emitTripleSlashDirectives(!!node.hasNoDefaultLib, node.syntheticFileReferences || [], node.syntheticTypeReferences || [], node.syntheticLibReferences || []);
        }
        function emitTripleSlashDirectivesIfNeeded(node) {
            if (node.isDeclarationFile) emitTripleSlashDirectives(node.hasNoDefaultLib, node.referencedFiles, node.typeReferenceDirectives, node.libReferenceDirectives);
        }
        function emitTripleSlashDirectives(hasNoDefaultLib, files, types, libs2) {
            if (hasNoDefaultLib) {
                writeComment(`/// <reference no-default-lib="true"/>`);
                writeLine();
            }
            if (currentSourceFile && currentSourceFile.moduleName) {
                writeComment(`/// <amd-module name="${currentSourceFile.moduleName}" />`);
                writeLine();
            }
            if (currentSourceFile && currentSourceFile.amdDependencies) for (const dep of currentSourceFile.amdDependencies){
                if (dep.name) writeComment(`/// <amd-dependency name="${dep.name}" path="${dep.path}" />`);
                else writeComment(`/// <amd-dependency path="${dep.path}" />`);
                writeLine();
            }
            function writeDirectives(kind, directives) {
                for (const directive of directives){
                    const resolutionMode = directive.resolutionMode ? `resolution-mode="${directive.resolutionMode === 99 /* ESNext */  ? "import" : "require"}" ` : "";
                    const preserve = directive.preserve ? `preserve="true" ` : "";
                    writeComment(`/// <reference ${kind}="${directive.fileName}" ${resolutionMode}${preserve}/>`);
                    writeLine();
                }
            }
            writeDirectives("path", files);
            writeDirectives("types", types);
            writeDirectives("lib", libs2);
        }
        function emitSourceFileWorker(node) {
            const statements = node.statements;
            pushNameGenerationScope(node);
            forEach(node.statements, generateNames);
            emitHelpers(node);
            const index = findIndex(statements, (statement)=>!isPrologueDirective(statement));
            emitTripleSlashDirectivesIfNeeded(node);
            emitList(node, statements, 1 /* MultiLine */ , /*parenthesizerRule*/ void 0, index === -1 ? statements.length : index);
            popNameGenerationScope(node);
        }
        function emitPartiallyEmittedExpression(node) {
            const emitFlags = getEmitFlags(node);
            if (!(emitFlags & 1024 /* NoLeadingComments */ ) && node.pos !== node.expression.pos) emitTrailingCommentsOfPosition(node.expression.pos);
            emitExpression(node.expression);
            if (!(emitFlags & 2048 /* NoTrailingComments */ ) && node.end !== node.expression.end) emitLeadingCommentsOfPosition(node.expression.end);
        }
        function emitCommaList(node) {
            emitExpressionList(node, node.elements, 528 /* CommaListElements */ , /*parenthesizerRule*/ void 0);
        }
        function emitPrologueDirectives(statements, sourceFile, seenPrologueDirectives) {
            let needsToSetSourceFile = !!sourceFile;
            for(let i = 0; i < statements.length; i++){
                const statement = statements[i];
                if (isPrologueDirective(statement)) {
                    const shouldEmitPrologueDirective = seenPrologueDirectives ? !seenPrologueDirectives.has(statement.expression.text) : true;
                    if (shouldEmitPrologueDirective) {
                        if (needsToSetSourceFile) {
                            needsToSetSourceFile = false;
                            setSourceFile(sourceFile);
                        }
                        writeLine();
                        emit(statement);
                        if (seenPrologueDirectives) seenPrologueDirectives.add(statement.expression.text);
                    }
                } else return i;
            }
            return statements.length;
        }
        function emitPrologueDirectivesIfNeeded(sourceFileOrBundle) {
            if (isSourceFile(sourceFileOrBundle)) emitPrologueDirectives(sourceFileOrBundle.statements, sourceFileOrBundle);
            else {
                const seenPrologueDirectives = /* @__PURE__ */ new Set();
                for (const sourceFile of sourceFileOrBundle.sourceFiles)emitPrologueDirectives(sourceFile.statements, sourceFile, seenPrologueDirectives);
                setSourceFile(void 0);
            }
        }
        function emitShebangIfNeeded(sourceFileOrBundle) {
            if (isSourceFile(sourceFileOrBundle)) {
                const shebang = getShebang(sourceFileOrBundle.text);
                if (shebang) {
                    writeComment(shebang);
                    writeLine();
                    return true;
                }
            } else for (const sourceFile of sourceFileOrBundle.sourceFiles){
                if (emitShebangIfNeeded(sourceFile)) return true;
            }
        }
        function emitNodeWithWriter(node, writer2) {
            if (!node) return;
            const savedWrite = write;
            write = writer2;
            emit(node);
            write = savedWrite;
        }
        function emitDecoratorsAndModifiers(node, modifiers, allowDecorators) {
            if (modifiers == null ? void 0 : modifiers.length) {
                if (every(modifiers, isModifier)) return emitModifierList(node, modifiers);
                if (every(modifiers, isDecorator)) {
                    if (allowDecorators) return emitDecoratorList(node, modifiers);
                    return node.pos;
                }
                onBeforeEmitNodeArray == null || onBeforeEmitNodeArray(modifiers);
                let lastMode;
                let mode;
                let start = 0;
                let pos = 0;
                let lastModifier;
                while(start < modifiers.length){
                    while(pos < modifiers.length){
                        lastModifier = modifiers[pos];
                        mode = isDecorator(lastModifier) ? "decorators" : "modifiers";
                        if (lastMode === void 0) lastMode = mode;
                        else if (mode !== lastMode) break;
                        pos++;
                    }
                    const textRange = {
                        pos: -1,
                        end: -1
                    };
                    if (start === 0) textRange.pos = modifiers.pos;
                    if (pos === modifiers.length - 1) textRange.end = modifiers.end;
                    if (lastMode === "modifiers" || allowDecorators) emitNodeListItems(emit, node, modifiers, lastMode === "modifiers" ? 2359808 /* Modifiers */  : 2146305 /* Decorators */ , /*parenthesizerRule*/ void 0, start, pos - start, /*hasTrailingComma*/ false, textRange);
                    start = pos;
                    lastMode = mode;
                    pos++;
                }
                onAfterEmitNodeArray == null || onAfterEmitNodeArray(modifiers);
                if (lastModifier && !positionIsSynthesized(lastModifier.end)) return lastModifier.end;
            }
            return node.pos;
        }
        function emitModifierList(node, modifiers) {
            emitList(node, modifiers, 2359808 /* Modifiers */ );
            const lastModifier = lastOrUndefined(modifiers);
            return lastModifier && !positionIsSynthesized(lastModifier.end) ? lastModifier.end : node.pos;
        }
        function emitTypeAnnotation(node) {
            if (node) {
                writePunctuation(":");
                writeSpace();
                emit(node);
            }
        }
        function emitInitializer(node, equalCommentStartPos, container, parenthesizerRule) {
            if (node) {
                writeSpace();
                emitTokenWithComment(64 /* EqualsToken */ , equalCommentStartPos, writeOperator, container);
                writeSpace();
                emitExpression(node, parenthesizerRule);
            }
        }
        function emitNodeWithPrefix(prefix, prefixWriter, node, emit2) {
            if (node) {
                prefixWriter(prefix);
                emit2(node);
            }
        }
        function emitWithLeadingSpace(node) {
            if (node) {
                writeSpace();
                emit(node);
            }
        }
        function emitExpressionWithLeadingSpace(node, parenthesizerRule) {
            if (node) {
                writeSpace();
                emitExpression(node, parenthesizerRule);
            }
        }
        function emitWithTrailingSpace(node) {
            if (node) {
                emit(node);
                writeSpace();
            }
        }
        function emitEmbeddedStatement(parent2, node) {
            if (isBlock(node) || getEmitFlags(parent2) & 1 /* SingleLine */  || preserveSourceNewlines && !getLeadingLineTerminatorCount(parent2, node, 0 /* None */ )) {
                writeSpace();
                emit(node);
            } else {
                writeLine();
                increaseIndent();
                if (isEmptyStatement(node)) pipelineEmit(5 /* EmbeddedStatement */ , node);
                else emit(node);
                decreaseIndent();
            }
        }
        function emitDecoratorList(parentNode, decorators) {
            emitList(parentNode, decorators, 2146305 /* Decorators */ );
            const lastDecorator = lastOrUndefined(decorators);
            return lastDecorator && !positionIsSynthesized(lastDecorator.end) ? lastDecorator.end : parentNode.pos;
        }
        function emitTypeArguments(parentNode, typeArguments) {
            emitList(parentNode, typeArguments, 53776 /* TypeArguments */ , typeArgumentParenthesizerRuleSelector);
        }
        function emitTypeParameters(parentNode, typeParameters) {
            if (isFunctionLike(parentNode) && parentNode.typeArguments) return emitTypeArguments(parentNode, parentNode.typeArguments);
            emitList(parentNode, typeParameters, 53776 /* TypeParameters */  | (isArrowFunction(parentNode) ? 64 /* AllowTrailingComma */  : 0 /* None */ ));
        }
        function emitParameters(parentNode, parameters) {
            emitList(parentNode, parameters, 2576 /* Parameters */ );
        }
        function canEmitSimpleArrowHead(parentNode, parameters) {
            const parameter = singleOrUndefined(parameters);
            return parameter && parameter.pos === parentNode.pos && isArrowFunction(parentNode) && !parentNode.type && !some(parentNode.modifiers) && !some(parentNode.typeParameters) && !some(parameter.modifiers) && !parameter.dotDotDotToken && !parameter.questionToken && !parameter.type && !parameter.initializer && isIdentifier(parameter.name);
        }
        function emitParametersForArrow(parentNode, parameters) {
            if (canEmitSimpleArrowHead(parentNode, parameters)) emitList(parentNode, parameters, 528 /* Parenthesis */ );
            else emitParameters(parentNode, parameters);
        }
        function emitParametersForIndexSignature(parentNode, parameters) {
            emitList(parentNode, parameters, 8848 /* IndexSignatureParameters */ );
        }
        function writeDelimiter(format) {
            switch(format & 60 /* DelimitersMask */ ){
                case 0 /* None */ :
                    break;
                case 16 /* CommaDelimited */ :
                    writePunctuation(",");
                    break;
                case 4 /* BarDelimited */ :
                    writeSpace();
                    writePunctuation("|");
                    break;
                case 32 /* AsteriskDelimited */ :
                    writeSpace();
                    writePunctuation("*");
                    writeSpace();
                    break;
                case 8 /* AmpersandDelimited */ :
                    writeSpace();
                    writePunctuation("&");
                    break;
            }
        }
        function emitList(parentNode, children, format, parenthesizerRule, start, count) {
            emitNodeList(emit, parentNode, children, format | (parentNode && getEmitFlags(parentNode) & 2 /* MultiLine */  ? 65536 /* PreferNewLine */  : 0), parenthesizerRule, start, count);
        }
        function emitExpressionList(parentNode, children, format, parenthesizerRule, start, count) {
            emitNodeList(emitExpression, parentNode, children, format, parenthesizerRule, start, count);
        }
        function emitNodeList(emit2, parentNode, children, format, parenthesizerRule, start = 0, count = children ? children.length - start : 0) {
            const isUndefined = children === void 0;
            if (isUndefined && format & 16384 /* OptionalIfUndefined */ ) return;
            const isEmpty = children === void 0 || start >= children.length || count === 0;
            if (isEmpty && format & 32768 /* OptionalIfEmpty */ ) {
                onBeforeEmitNodeArray == null || onBeforeEmitNodeArray(children);
                onAfterEmitNodeArray == null || onAfterEmitNodeArray(children);
                return;
            }
            if (format & 15360 /* BracketsMask */ ) {
                writePunctuation(getOpeningBracket(format));
                if (isEmpty && children) emitTrailingCommentsOfPosition(children.pos, /*prefixSpace*/ true);
            }
            onBeforeEmitNodeArray == null || onBeforeEmitNodeArray(children);
            if (isEmpty) {
                if (format & 1 /* MultiLine */  && !(preserveSourceNewlines && (!parentNode || currentSourceFile && rangeIsOnSingleLine(parentNode, currentSourceFile)))) writeLine();
                else if (format & 256 /* SpaceBetweenBraces */  && !(format & 524288 /* NoSpaceIfEmpty */ )) writeSpace();
            } else emitNodeListItems(emit2, parentNode, children, format, parenthesizerRule, start, count, children.hasTrailingComma, children);
            onAfterEmitNodeArray == null || onAfterEmitNodeArray(children);
            if (format & 15360 /* BracketsMask */ ) {
                if (isEmpty && children) emitLeadingCommentsOfPosition(children.end);
                writePunctuation(getClosingBracket(format));
            }
        }
        function emitNodeListItems(emit2, parentNode, children, format, parenthesizerRule, start, count, hasTrailingComma, childrenTextRange) {
            const mayEmitInterveningComments = (format & 262144 /* NoInterveningComments */ ) === 0;
            let shouldEmitInterveningComments = mayEmitInterveningComments;
            const leadingLineTerminatorCount = getLeadingLineTerminatorCount(parentNode, children[start], format);
            if (leadingLineTerminatorCount) {
                writeLine(leadingLineTerminatorCount);
                shouldEmitInterveningComments = false;
            } else if (format & 256 /* SpaceBetweenBraces */ ) writeSpace();
            if (format & 128 /* Indented */ ) increaseIndent();
            const emitListItem = getEmitListItem(emit2, parenthesizerRule);
            let previousSibling;
            let shouldDecreaseIndentAfterEmit = false;
            for(let i = 0; i < count; i++){
                const child = children[start + i];
                if (format & 32 /* AsteriskDelimited */ ) {
                    writeLine();
                    writeDelimiter(format);
                } else if (previousSibling) {
                    if (format & 60 /* DelimitersMask */  && previousSibling.end !== (parentNode ? parentNode.end : -1)) {
                        const previousSiblingEmitFlags = getEmitFlags(previousSibling);
                        if (!(previousSiblingEmitFlags & 2048 /* NoTrailingComments */ )) emitLeadingCommentsOfPosition(previousSibling.end);
                    }
                    writeDelimiter(format);
                    const separatingLineTerminatorCount = getSeparatingLineTerminatorCount(previousSibling, child, format);
                    if (separatingLineTerminatorCount > 0) {
                        if ((format & 131 /* Indented */ ) === 0 /* SingleLine */ ) {
                            increaseIndent();
                            shouldDecreaseIndentAfterEmit = true;
                        }
                        if (shouldEmitInterveningComments && format & 60 /* DelimitersMask */  && !positionIsSynthesized(child.pos)) {
                            const commentRange = getCommentRange(child);
                            emitTrailingCommentsOfPosition(commentRange.pos, /*prefixSpace*/ !!(format & 512 /* SpaceBetweenSiblings */ ), /*forceNoNewline*/ true);
                        }
                        writeLine(separatingLineTerminatorCount);
                        shouldEmitInterveningComments = false;
                    } else if (previousSibling && format & 512 /* SpaceBetweenSiblings */ ) writeSpace();
                }
                if (shouldEmitInterveningComments) {
                    const commentRange = getCommentRange(child);
                    emitTrailingCommentsOfPosition(commentRange.pos);
                } else shouldEmitInterveningComments = mayEmitInterveningComments;
                nextListElementPos = child.pos;
                emitListItem(child, emit2, parenthesizerRule, i);
                if (shouldDecreaseIndentAfterEmit) {
                    decreaseIndent();
                    shouldDecreaseIndentAfterEmit = false;
                }
                previousSibling = child;
            }
            const emitFlags = previousSibling ? getEmitFlags(previousSibling) : 0;
            const skipTrailingComments = commentsDisabled || !!(emitFlags & 2048 /* NoTrailingComments */ );
            const emitTrailingComma = hasTrailingComma && format & 64 /* AllowTrailingComma */  && format & 16 /* CommaDelimited */ ;
            if (emitTrailingComma) {
                if (previousSibling && !skipTrailingComments) emitTokenWithComment(28 /* CommaToken */ , previousSibling.end, writePunctuation, previousSibling);
                else writePunctuation(",");
            }
            if (previousSibling && (parentNode ? parentNode.end : -1) !== previousSibling.end && format & 60 /* DelimitersMask */  && !skipTrailingComments) emitLeadingCommentsOfPosition(emitTrailingComma && (childrenTextRange == null ? void 0 : childrenTextRange.end) ? childrenTextRange.end : previousSibling.end);
            if (format & 128 /* Indented */ ) decreaseIndent();
            const closingLineTerminatorCount = getClosingLineTerminatorCount(parentNode, children[start + count - 1], format, childrenTextRange);
            if (closingLineTerminatorCount) writeLine(closingLineTerminatorCount);
            else if (format & 2097408 /* SpaceBetweenBraces */ ) writeSpace();
        }
        function writeLiteral(s) {
            writer.writeLiteral(s);
        }
        function writeStringLiteral(s) {
            writer.writeStringLiteral(s);
        }
        function writeBase(s) {
            writer.write(s);
        }
        function writeSymbol(s, sym) {
            writer.writeSymbol(s, sym);
        }
        function writePunctuation(s) {
            writer.writePunctuation(s);
        }
        function writeTrailingSemicolon() {
            writer.writeTrailingSemicolon(";");
        }
        function writeKeyword(s) {
            writer.writeKeyword(s);
        }
        function writeOperator(s) {
            writer.writeOperator(s);
        }
        function writeParameter(s) {
            writer.writeParameter(s);
        }
        function writeComment(s) {
            writer.writeComment(s);
        }
        function writeSpace() {
            writer.writeSpace(" ");
        }
        function writeProperty(s) {
            writer.writeProperty(s);
        }
        function nonEscapingWrite(s) {
            if (writer.nonEscapingWrite) writer.nonEscapingWrite(s);
            else writer.write(s);
        }
        function writeLine(count = 1) {
            for(let i = 0; i < count; i++)writer.writeLine(i > 0);
        }
        function increaseIndent() {
            writer.increaseIndent();
        }
        function decreaseIndent() {
            writer.decreaseIndent();
        }
        function writeToken(token, pos, writer2, contextNode) {
            return !sourceMapsDisabled ? emitTokenWithSourceMap(contextNode, token, writer2, pos, writeTokenText) : writeTokenText(token, writer2, pos);
        }
        function writeTokenNode(node, writer2) {
            if (onBeforeEmitToken) onBeforeEmitToken(node);
            writer2(tokenToString(node.kind));
            if (onAfterEmitToken) onAfterEmitToken(node);
        }
        function writeTokenText(token, writer2, pos) {
            const tokenString = tokenToString(token);
            writer2(tokenString);
            return pos < 0 ? pos : pos + tokenString.length;
        }
        function writeLineOrSpace(parentNode, prevChildNode, nextChildNode) {
            if (getEmitFlags(parentNode) & 1 /* SingleLine */ ) writeSpace();
            else if (preserveSourceNewlines) {
                const lines = getLinesBetweenNodes(parentNode, prevChildNode, nextChildNode);
                if (lines) writeLine(lines);
                else writeSpace();
            } else writeLine();
        }
        function writeLines(text) {
            const lines = text.split(/\r\n?|\n/);
            const indentation = guessIndentation(lines);
            for (const lineText of lines){
                const line = indentation ? lineText.slice(indentation) : lineText;
                if (line.length) {
                    writeLine();
                    write(line);
                }
            }
        }
        function writeLinesAndIndent(lineCount, writeSpaceIfNotIndenting) {
            if (lineCount) {
                increaseIndent();
                writeLine(lineCount);
            } else if (writeSpaceIfNotIndenting) writeSpace();
        }
        function decreaseIndentIf(value1, value2) {
            if (value1) decreaseIndent();
            if (value2) decreaseIndent();
        }
        function getLeadingLineTerminatorCount(parentNode, firstChild, format) {
            if (format & 2 /* PreserveLines */  || preserveSourceNewlines) {
                if (format & 65536 /* PreferNewLine */ ) return 1;
                if (firstChild === void 0) return !parentNode || currentSourceFile && rangeIsOnSingleLine(parentNode, currentSourceFile) ? 0 : 1;
                if (firstChild.pos === nextListElementPos) return 0;
                if (firstChild.kind === 12 /* JsxText */ ) return 0;
                if (currentSourceFile && parentNode && !positionIsSynthesized(parentNode.pos) && !nodeIsSynthesized(firstChild) && (!firstChild.parent || getOriginalNode(firstChild.parent) === getOriginalNode(parentNode))) {
                    if (preserveSourceNewlines) return getEffectiveLines((includeComments)=>getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter(firstChild.pos, parentNode.pos, currentSourceFile, includeComments));
                    return rangeStartPositionsAreOnSameLine(parentNode, firstChild, currentSourceFile) ? 0 : 1;
                }
                if (synthesizedNodeStartsOnNewLine(firstChild, format)) return 1;
            }
            return format & 1 /* MultiLine */  ? 1 : 0;
        }
        function getSeparatingLineTerminatorCount(previousNode, nextNode, format) {
            if (format & 2 /* PreserveLines */  || preserveSourceNewlines) {
                if (previousNode === void 0 || nextNode === void 0) return 0;
                if (nextNode.kind === 12 /* JsxText */ ) return 0;
                else if (currentSourceFile && !nodeIsSynthesized(previousNode) && !nodeIsSynthesized(nextNode)) {
                    if (preserveSourceNewlines && siblingNodePositionsAreComparable(previousNode, nextNode)) return getEffectiveLines((includeComments)=>getLinesBetweenRangeEndAndRangeStart(previousNode, nextNode, currentSourceFile, includeComments));
                    else if (!preserveSourceNewlines && originalNodesHaveSameParent(previousNode, nextNode)) return rangeEndIsOnSameLineAsRangeStart(previousNode, nextNode, currentSourceFile) ? 0 : 1;
                    return format & 65536 /* PreferNewLine */  ? 1 : 0;
                } else if (synthesizedNodeStartsOnNewLine(previousNode, format) || synthesizedNodeStartsOnNewLine(nextNode, format)) return 1;
            } else if (getStartsOnNewLine(nextNode)) return 1;
            return format & 1 /* MultiLine */  ? 1 : 0;
        }
        function getClosingLineTerminatorCount(parentNode, lastChild, format, childrenTextRange) {
            if (format & 2 /* PreserveLines */  || preserveSourceNewlines) {
                if (format & 65536 /* PreferNewLine */ ) return 1;
                if (lastChild === void 0) return !parentNode || currentSourceFile && rangeIsOnSingleLine(parentNode, currentSourceFile) ? 0 : 1;
                if (currentSourceFile && parentNode && !positionIsSynthesized(parentNode.pos) && !nodeIsSynthesized(lastChild) && (!lastChild.parent || lastChild.parent === parentNode)) {
                    if (preserveSourceNewlines) {
                        const end = childrenTextRange && !positionIsSynthesized(childrenTextRange.end) ? childrenTextRange.end : lastChild.end;
                        return getEffectiveLines((includeComments)=>getLinesBetweenPositionAndNextNonWhitespaceCharacter(end, parentNode.end, currentSourceFile, includeComments));
                    }
                    return rangeEndPositionsAreOnSameLine(parentNode, lastChild, currentSourceFile) ? 0 : 1;
                }
                if (synthesizedNodeStartsOnNewLine(lastChild, format)) return 1;
            }
            if (format & 1 /* MultiLine */  && !(format & 131072 /* NoTrailingNewLine */ )) return 1;
            return 0;
        }
        function getEffectiveLines(getLineDifference) {
            Debug.assert(!!preserveSourceNewlines);
            const lines = getLineDifference(/*includeComments*/ true);
            if (lines === 0) return getLineDifference(/*includeComments*/ false);
            return lines;
        }
        function writeLineSeparatorsAndIndentBefore(node, parent2) {
            const leadingNewlines = preserveSourceNewlines && getLeadingLineTerminatorCount(parent2, node, 0 /* None */ );
            if (leadingNewlines) writeLinesAndIndent(leadingNewlines, /*writeSpaceIfNotIndenting*/ false);
            return !!leadingNewlines;
        }
        function writeLineSeparatorsAfter(node, parent2) {
            const trailingNewlines = preserveSourceNewlines && getClosingLineTerminatorCount(parent2, node, 0 /* None */ , /*childrenTextRange*/ void 0);
            if (trailingNewlines) writeLine(trailingNewlines);
        }
        function synthesizedNodeStartsOnNewLine(node, format) {
            if (nodeIsSynthesized(node)) {
                const startsOnNewLine = getStartsOnNewLine(node);
                if (startsOnNewLine === void 0) return (format & 65536 /* PreferNewLine */ ) !== 0;
                return startsOnNewLine;
            }
            return (format & 65536 /* PreferNewLine */ ) !== 0;
        }
        function getLinesBetweenNodes(parent2, node1, node2) {
            if (getEmitFlags(parent2) & 262144 /* NoIndentation */ ) return 0;
            parent2 = skipSynthesizedParentheses(parent2);
            node1 = skipSynthesizedParentheses(node1);
            node2 = skipSynthesizedParentheses(node2);
            if (getStartsOnNewLine(node2)) return 1;
            if (currentSourceFile && !nodeIsSynthesized(parent2) && !nodeIsSynthesized(node1) && !nodeIsSynthesized(node2)) {
                if (preserveSourceNewlines) return getEffectiveLines((includeComments)=>getLinesBetweenRangeEndAndRangeStart(node1, node2, currentSourceFile, includeComments));
                return rangeEndIsOnSameLineAsRangeStart(node1, node2, currentSourceFile) ? 0 : 1;
            }
            return 0;
        }
        function isEmptyBlock(block) {
            return block.statements.length === 0 && (!currentSourceFile || rangeEndIsOnSameLineAsRangeStart(block, block, currentSourceFile));
        }
        function skipSynthesizedParentheses(node) {
            while(node.kind === 218 /* ParenthesizedExpression */  && nodeIsSynthesized(node))node = node.expression;
            return node;
        }
        function getTextOfNode2(node, includeTrivia) {
            if (isGeneratedIdentifier(node) || isGeneratedPrivateIdentifier(node)) return generateName(node);
            if (isStringLiteral(node) && node.textSourceNode) return getTextOfNode2(node.textSourceNode, includeTrivia);
            const sourceFile = currentSourceFile;
            const canUseSourceFile = !!sourceFile && !!node.parent && !nodeIsSynthesized(node);
            if (isMemberName(node)) {
                if (!canUseSourceFile || getSourceFileOfNode(node) !== getOriginalNode(sourceFile)) return idText(node);
            } else if (isJsxNamespacedName(node)) {
                if (!canUseSourceFile || getSourceFileOfNode(node) !== getOriginalNode(sourceFile)) return getTextOfJsxNamespacedName(node);
            } else {
                Debug.assertNode(node, isLiteralExpression);
                if (!canUseSourceFile) return node.text;
            }
            return getSourceTextOfNodeFromSourceFile(sourceFile, node, includeTrivia);
        }
        function getLiteralTextOfNode(node, sourceFile = currentSourceFile, neverAsciiEscape, jsxAttributeEscape) {
            if (node.kind === 11 /* StringLiteral */  && node.textSourceNode) {
                const textSourceNode = node.textSourceNode;
                if (isIdentifier(textSourceNode) || isPrivateIdentifier(textSourceNode) || isNumericLiteral(textSourceNode) || isJsxNamespacedName(textSourceNode)) {
                    const text = isNumericLiteral(textSourceNode) ? textSourceNode.text : getTextOfNode2(textSourceNode);
                    return jsxAttributeEscape ? `"${escapeJsxAttributeString(text)}"` : neverAsciiEscape || getEmitFlags(node) & 16777216 /* NoAsciiEscaping */  ? `"${escapeString(text)}"` : `"${escapeNonAsciiString(text)}"`;
                } else return getLiteralTextOfNode(textSourceNode, getSourceFileOfNode(textSourceNode), neverAsciiEscape, jsxAttributeEscape);
            }
            const flags = (neverAsciiEscape ? 1 /* NeverAsciiEscape */  : 0) | (jsxAttributeEscape ? 2 /* JsxAttributeEscape */  : 0) | (printerOptions.terminateUnterminatedLiterals ? 4 /* TerminateUnterminatedLiterals */  : 0) | (printerOptions.target && printerOptions.target >= 8 /* ES2021 */  ? 8 /* AllowNumericSeparator */  : 0);
            return getLiteralText(node, sourceFile, flags);
        }
        function pushNameGenerationScope(node) {
            privateNameTempFlagsStack.push(privateNameTempFlags);
            privateNameTempFlags = 0 /* Auto */ ;
            reservedPrivateNamesStack.push(reservedPrivateNames);
            if (node && getEmitFlags(node) & 1048576 /* ReuseTempVariableScope */ ) return;
            tempFlagsStack.push(tempFlags);
            tempFlags = 0 /* Auto */ ;
            formattedNameTempFlagsStack.push(formattedNameTempFlags);
            formattedNameTempFlags = void 0;
            reservedNamesStack.push(reservedNames);
        }
        function popNameGenerationScope(node) {
            privateNameTempFlags = privateNameTempFlagsStack.pop();
            reservedPrivateNames = reservedPrivateNamesStack.pop();
            if (node && getEmitFlags(node) & 1048576 /* ReuseTempVariableScope */ ) return;
            tempFlags = tempFlagsStack.pop();
            formattedNameTempFlags = formattedNameTempFlagsStack.pop();
            reservedNames = reservedNamesStack.pop();
        }
        function reserveNameInNestedScopes(name) {
            if (!reservedNames || reservedNames === lastOrUndefined(reservedNamesStack)) reservedNames = /* @__PURE__ */ new Set();
            reservedNames.add(name);
        }
        function reservePrivateNameInNestedScopes(name) {
            if (!reservedPrivateNames || reservedPrivateNames === lastOrUndefined(reservedPrivateNamesStack)) reservedPrivateNames = /* @__PURE__ */ new Set();
            reservedPrivateNames.add(name);
        }
        function generateNames(node) {
            if (!node) return;
            switch(node.kind){
                case 242 /* Block */ :
                    forEach(node.statements, generateNames);
                    break;
                case 257 /* LabeledStatement */ :
                case 255 /* WithStatement */ :
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                    generateNames(node.statement);
                    break;
                case 246 /* IfStatement */ :
                    generateNames(node.thenStatement);
                    generateNames(node.elseStatement);
                    break;
                case 249 /* ForStatement */ :
                case 251 /* ForOfStatement */ :
                case 250 /* ForInStatement */ :
                    generateNames(node.initializer);
                    generateNames(node.statement);
                    break;
                case 256 /* SwitchStatement */ :
                    generateNames(node.caseBlock);
                    break;
                case 270 /* CaseBlock */ :
                    forEach(node.clauses, generateNames);
                    break;
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                    forEach(node.statements, generateNames);
                    break;
                case 259 /* TryStatement */ :
                    generateNames(node.tryBlock);
                    generateNames(node.catchClause);
                    generateNames(node.finallyBlock);
                    break;
                case 300 /* CatchClause */ :
                    generateNames(node.variableDeclaration);
                    generateNames(node.block);
                    break;
                case 244 /* VariableStatement */ :
                    generateNames(node.declarationList);
                    break;
                case 262 /* VariableDeclarationList */ :
                    forEach(node.declarations, generateNames);
                    break;
                case 261 /* VariableDeclaration */ :
                case 170 /* Parameter */ :
                case 209 /* BindingElement */ :
                case 264 /* ClassDeclaration */ :
                    generateNameIfNeeded(node.name);
                    break;
                case 263 /* FunctionDeclaration */ :
                    generateNameIfNeeded(node.name);
                    if (getEmitFlags(node) & 1048576 /* ReuseTempVariableScope */ ) {
                        forEach(node.parameters, generateNames);
                        generateNames(node.body);
                    }
                    break;
                case 207 /* ObjectBindingPattern */ :
                case 208 /* ArrayBindingPattern */ :
                    forEach(node.elements, generateNames);
                    break;
                case 273 /* ImportDeclaration */ :
                    generateNames(node.importClause);
                    break;
                case 274 /* ImportClause */ :
                    generateNameIfNeeded(node.name);
                    generateNames(node.namedBindings);
                    break;
                case 275 /* NamespaceImport */ :
                    generateNameIfNeeded(node.name);
                    break;
                case 281 /* NamespaceExport */ :
                    generateNameIfNeeded(node.name);
                    break;
                case 276 /* NamedImports */ :
                    forEach(node.elements, generateNames);
                    break;
                case 277 /* ImportSpecifier */ :
                    generateNameIfNeeded(node.propertyName || node.name);
                    break;
            }
        }
        function generateMemberNames(node) {
            if (!node) return;
            switch(node.kind){
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    generateNameIfNeeded(node.name);
                    break;
            }
        }
        function generateNameIfNeeded(name) {
            if (name) {
                if (isGeneratedIdentifier(name) || isGeneratedPrivateIdentifier(name)) generateName(name);
                else if (isBindingPattern(name)) generateNames(name);
            }
        }
        function generateName(name) {
            const autoGenerate = name.emitNode.autoGenerate;
            if ((autoGenerate.flags & 7 /* KindMask */ ) === 4 /* Node */ ) return generateNameCached(getNodeForGeneratedName(name), isPrivateIdentifier(name), autoGenerate.flags, autoGenerate.prefix, autoGenerate.suffix);
            else {
                const autoGenerateId = autoGenerate.id;
                return autoGeneratedIdToGeneratedName[autoGenerateId] || (autoGeneratedIdToGeneratedName[autoGenerateId] = makeName(name));
            }
        }
        function generateNameCached(node, privateName, flags, prefix, suffix) {
            const nodeId = getNodeId(node);
            const cache = privateName ? nodeIdToGeneratedPrivateName : nodeIdToGeneratedName;
            return cache[nodeId] || (cache[nodeId] = generateNameForNode(node, privateName, flags !== null && flags !== void 0 ? flags : 0 /* None */ , formatGeneratedNamePart(prefix, generateName), formatGeneratedNamePart(suffix)));
        }
        function isUniqueName(name, privateName) {
            return isFileLevelUniqueNameInCurrentFile(name, privateName) && !isReservedName(name, privateName) && !generatedNames.has(name);
        }
        function isReservedName(name, privateName) {
            let set;
            let stack;
            if (privateName) {
                set = reservedPrivateNames;
                stack = reservedPrivateNamesStack;
            } else {
                set = reservedNames;
                stack = reservedNamesStack;
            }
            if (set == null ? void 0 : set.has(name)) return true;
            for(let i = stack.length - 1; i >= 0; i--){
                if (set === stack[i]) continue;
                set = stack[i];
                if (set == null ? void 0 : set.has(name)) return true;
            }
            return false;
        }
        function isFileLevelUniqueNameInCurrentFile(name, _isPrivate) {
            return currentSourceFile ? isFileLevelUniqueName(currentSourceFile, name, hasGlobalName) : true;
        }
        function isUniqueLocalName(name, container) {
            for(let node = container; node && isNodeDescendantOf(node, container); node = node.nextContainer)if (canHaveLocals(node) && node.locals) {
                const local = node.locals.get(escapeLeadingUnderscores(name));
                if (local && local.flags & 3257279 /* Alias */ ) return false;
            }
            return true;
        }
        function getTempFlags(formattedNameKey) {
            switch(formattedNameKey){
                case "":
                    return tempFlags;
                case "#":
                    return privateNameTempFlags;
                default:
                    var _ref;
                    return (_ref = formattedNameTempFlags == null ? void 0 : formattedNameTempFlags.get(formattedNameKey)) !== null && _ref !== void 0 ? _ref : 0 /* Auto */ ;
            }
        }
        function setTempFlags(formattedNameKey, flags) {
            switch(formattedNameKey){
                case "":
                    tempFlags = flags;
                    break;
                case "#":
                    privateNameTempFlags = flags;
                    break;
                default:
                    formattedNameTempFlags !== null && formattedNameTempFlags !== void 0 ? formattedNameTempFlags : formattedNameTempFlags = /* @__PURE__ */ new Map();
                    formattedNameTempFlags.set(formattedNameKey, flags);
                    break;
            }
        }
        function makeTempVariableName(flags, reservedInNestedScopes, privateName, prefix, suffix) {
            if (prefix.length > 0 && prefix.charCodeAt(0) === 35 /* hash */ ) prefix = prefix.slice(1);
            const key = formatGeneratedName(privateName, prefix, "", suffix);
            let tempFlags2 = getTempFlags(key);
            if (flags && !(tempFlags2 & flags)) {
                const name = flags === 268435456 /* _i */  ? "_i" : "_n";
                const fullName = formatGeneratedName(privateName, prefix, name, suffix);
                if (isUniqueName(fullName, privateName)) {
                    tempFlags2 |= flags;
                    if (privateName) reservePrivateNameInNestedScopes(fullName);
                    else if (reservedInNestedScopes) reserveNameInNestedScopes(fullName);
                    setTempFlags(key, tempFlags2);
                    return fullName;
                }
            }
            while(true){
                const count = tempFlags2 & 268435455 /* CountMask */ ;
                tempFlags2++;
                if (count !== 8 && count !== 13) {
                    const name = count < 26 ? "_" + String.fromCharCode(97 /* a */  + count) : "_" + (count - 26);
                    const fullName = formatGeneratedName(privateName, prefix, name, suffix);
                    if (isUniqueName(fullName, privateName)) {
                        if (privateName) reservePrivateNameInNestedScopes(fullName);
                        else if (reservedInNestedScopes) reserveNameInNestedScopes(fullName);
                        setTempFlags(key, tempFlags2);
                        return fullName;
                    }
                }
            }
        }
        function makeUniqueName2(baseName, checkFn = isUniqueName, optimistic, scoped, privateName, prefix, suffix) {
            if (baseName.length > 0 && baseName.charCodeAt(0) === 35 /* hash */ ) baseName = baseName.slice(1);
            if (prefix.length > 0 && prefix.charCodeAt(0) === 35 /* hash */ ) prefix = prefix.slice(1);
            if (optimistic) {
                const fullName = formatGeneratedName(privateName, prefix, baseName, suffix);
                if (checkFn(fullName, privateName)) {
                    if (privateName) reservePrivateNameInNestedScopes(fullName);
                    else if (scoped) reserveNameInNestedScopes(fullName);
                    else generatedNames.add(fullName);
                    return fullName;
                }
            }
            if (baseName.charCodeAt(baseName.length - 1) !== 95 /* _ */ ) baseName += "_";
            let i = 1;
            while(true){
                const fullName = formatGeneratedName(privateName, prefix, baseName + i, suffix);
                if (checkFn(fullName, privateName)) {
                    if (privateName) reservePrivateNameInNestedScopes(fullName);
                    else if (scoped) reserveNameInNestedScopes(fullName);
                    else generatedNames.add(fullName);
                    return fullName;
                }
                i++;
            }
        }
        function makeFileLevelOptimisticUniqueName(name) {
            return makeUniqueName2(name, isFileLevelUniqueNameInCurrentFile, /*optimistic*/ true, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForModuleOrEnum(node) {
            const name = getTextOfNode2(node.name);
            return isUniqueLocalName(name, tryCast(node, canHaveLocals)) ? name : makeUniqueName2(name, isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForImportOrExportDeclaration(node) {
            const expr = getExternalModuleName(node);
            const baseName = isStringLiteral(expr) ? makeIdentifierFromModuleName(expr.text) : "module";
            return makeUniqueName2(baseName, isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForExportDefault() {
            return makeUniqueName2("default", isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForClassExpression() {
            return makeUniqueName2("class", isUniqueName, /*optimistic*/ false, /*scoped*/ false, /*privateName*/ false, /*prefix*/ "", /*suffix*/ "");
        }
        function generateNameForMethodOrAccessor(node, privateName, prefix, suffix) {
            if (isIdentifier(node.name)) return generateNameCached(node.name, privateName);
            return makeTempVariableName(0 /* Auto */ , /*reservedInNestedScopes*/ false, privateName, prefix, suffix);
        }
        function generateNameForNode(node, privateName, flags, prefix, suffix) {
            switch(node.kind){
                case 80 /* Identifier */ :
                case 81 /* PrivateIdentifier */ :
                    return makeUniqueName2(getTextOfNode2(node), isUniqueName, !!(flags & 16 /* Optimistic */ ), !!(flags & 8 /* ReservedInNestedScopes */ ), privateName, prefix, suffix);
                case 268 /* ModuleDeclaration */ :
                case 267 /* EnumDeclaration */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForModuleOrEnum(node);
                case 273 /* ImportDeclaration */ :
                case 279 /* ExportDeclaration */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForImportOrExportDeclaration(node);
                case 263 /* FunctionDeclaration */ :
                case 264 /* ClassDeclaration */ :
                    {
                        Debug.assert(!prefix && !suffix && !privateName);
                        const name = node.name;
                        if (name && !isGeneratedIdentifier(name)) return generateNameForNode(name, /*privateName*/ false, flags, prefix, suffix);
                        return generateNameForExportDefault();
                    }
                case 278 /* ExportAssignment */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForExportDefault();
                case 232 /* ClassExpression */ :
                    Debug.assert(!prefix && !suffix && !privateName);
                    return generateNameForClassExpression();
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return generateNameForMethodOrAccessor(node, privateName, prefix, suffix);
                case 168 /* ComputedPropertyName */ :
                    return makeTempVariableName(0 /* Auto */ , /*reservedInNestedScopes*/ true, privateName, prefix, suffix);
                default:
                    return makeTempVariableName(0 /* Auto */ , /*reservedInNestedScopes*/ false, privateName, prefix, suffix);
            }
        }
        function makeName(name) {
            const autoGenerate = name.emitNode.autoGenerate;
            const prefix = formatGeneratedNamePart(autoGenerate.prefix, generateName);
            const suffix = formatGeneratedNamePart(autoGenerate.suffix);
            switch(autoGenerate.flags & 7 /* KindMask */ ){
                case 1 /* Auto */ :
                    return makeTempVariableName(0 /* Auto */ , !!(autoGenerate.flags & 8 /* ReservedInNestedScopes */ ), isPrivateIdentifier(name), prefix, suffix);
                case 2 /* Loop */ :
                    Debug.assertNode(name, isIdentifier);
                    return makeTempVariableName(268435456 /* _i */ , !!(autoGenerate.flags & 8 /* ReservedInNestedScopes */ ), /*privateName*/ false, prefix, suffix);
                case 3 /* Unique */ :
                    return makeUniqueName2(idText(name), autoGenerate.flags & 32 /* FileLevel */  ? isFileLevelUniqueNameInCurrentFile : isUniqueName, !!(autoGenerate.flags & 16 /* Optimistic */ ), !!(autoGenerate.flags & 8 /* ReservedInNestedScopes */ ), isPrivateIdentifier(name), prefix, suffix);
            }
            return Debug.fail(`Unsupported GeneratedIdentifierKind: ${Debug.formatEnum(autoGenerate.flags & 7 /* KindMask */ , GeneratedIdentifierFlags, /*isFlags*/ true)}.`);
        }
        function pipelineEmitWithComments(hint, node) {
            const pipelinePhase = getNextPipelinePhase(2 /* Comments */ , hint, node);
            const savedContainerPos = containerPos;
            const savedContainerEnd = containerEnd;
            const savedDeclarationListContainerEnd = declarationListContainerEnd;
            emitCommentsBeforeNode(node);
            pipelinePhase(hint, node);
            emitCommentsAfterNode(node, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
        }
        function emitCommentsBeforeNode(node) {
            const emitFlags = getEmitFlags(node);
            const commentRange = getCommentRange(node);
            emitLeadingCommentsOfNode(node, emitFlags, commentRange.pos, commentRange.end);
            if (emitFlags & 4096 /* NoNestedComments */ ) commentsDisabled = true;
        }
        function emitCommentsAfterNode(node, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd) {
            const emitFlags = getEmitFlags(node);
            const commentRange = getCommentRange(node);
            if (emitFlags & 4096 /* NoNestedComments */ ) commentsDisabled = false;
            emitTrailingCommentsOfNode(node, emitFlags, commentRange.pos, commentRange.end, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
            const typeNode = getTypeNode(node);
            if (typeNode) emitTrailingCommentsOfNode(node, emitFlags, typeNode.pos, typeNode.end, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd);
        }
        function emitLeadingCommentsOfNode(node, emitFlags, pos, end) {
            enterComment();
            hasWrittenComment = false;
            const skipLeadingComments = pos < 0 || (emitFlags & 1024 /* NoLeadingComments */ ) !== 0 || node.kind === 12 /* JsxText */ ;
            const skipTrailingComments = end < 0 || (emitFlags & 2048 /* NoTrailingComments */ ) !== 0 || node.kind === 12 /* JsxText */ ;
            if ((pos > 0 || end > 0) && pos !== end) {
                if (!skipLeadingComments) emitLeadingComments(pos, /*isEmittedNode*/ node.kind !== 354 /* NotEmittedStatement */ );
                if (!skipLeadingComments || pos >= 0 && (emitFlags & 1024 /* NoLeadingComments */ ) !== 0) containerPos = pos;
                if (!skipTrailingComments || end >= 0 && (emitFlags & 2048 /* NoTrailingComments */ ) !== 0) {
                    containerEnd = end;
                    if (node.kind === 262 /* VariableDeclarationList */ ) declarationListContainerEnd = end;
                }
            }
            forEach(getSyntheticLeadingComments(node), emitLeadingSynthesizedComment);
            exitComment();
        }
        function emitTrailingCommentsOfNode(node, emitFlags, pos, end, savedContainerPos, savedContainerEnd, savedDeclarationListContainerEnd) {
            enterComment();
            const skipTrailingComments = end < 0 || (emitFlags & 2048 /* NoTrailingComments */ ) !== 0 || node.kind === 12 /* JsxText */ ;
            forEach(getSyntheticTrailingComments(node), emitTrailingSynthesizedComment);
            if ((pos > 0 || end > 0) && pos !== end) {
                containerPos = savedContainerPos;
                containerEnd = savedContainerEnd;
                declarationListContainerEnd = savedDeclarationListContainerEnd;
                if (!skipTrailingComments && node.kind !== 354 /* NotEmittedStatement */ ) emitTrailingComments(end);
            }
            exitComment();
        }
        function emitLeadingSynthesizedComment(comment) {
            if (comment.hasLeadingNewline || comment.kind === 2 /* SingleLineCommentTrivia */ ) writer.writeLine();
            writeSynthesizedComment(comment);
            if (comment.hasTrailingNewLine || comment.kind === 2 /* SingleLineCommentTrivia */ ) writer.writeLine();
            else writer.writeSpace(" ");
        }
        function emitTrailingSynthesizedComment(comment) {
            if (!writer.isAtStartOfLine()) writer.writeSpace(" ");
            writeSynthesizedComment(comment);
            if (comment.hasTrailingNewLine) writer.writeLine();
        }
        function writeSynthesizedComment(comment) {
            const text = formatSynthesizedComment(comment);
            const lineMap = comment.kind === 3 /* MultiLineCommentTrivia */  ? computeLineStarts(text) : void 0;
            writeCommentRange(text, lineMap, writer, 0, text.length, newLine);
        }
        function formatSynthesizedComment(comment) {
            return comment.kind === 3 /* MultiLineCommentTrivia */  ? `/*${comment.text}*/` : `//${comment.text}`;
        }
        function emitBodyWithDetachedComments(node, detachedRange, emitCallback) {
            enterComment();
            const { pos, end } = detachedRange;
            const emitFlags = getEmitFlags(node);
            const skipLeadingComments = pos < 0 || (emitFlags & 1024 /* NoLeadingComments */ ) !== 0;
            const skipTrailingComments = commentsDisabled || end < 0 || (emitFlags & 2048 /* NoTrailingComments */ ) !== 0;
            if (!skipLeadingComments) emitDetachedCommentsAndUpdateCommentsInfo(detachedRange);
            exitComment();
            if (emitFlags & 4096 /* NoNestedComments */  && !commentsDisabled) {
                commentsDisabled = true;
                emitCallback(node);
                commentsDisabled = false;
            } else emitCallback(node);
            enterComment();
            if (!skipTrailingComments) {
                emitLeadingComments(detachedRange.end, /*isEmittedNode*/ true);
                if (hasWrittenComment && !writer.isAtStartOfLine()) writer.writeLine();
            }
            exitComment();
        }
        function originalNodesHaveSameParent(nodeA, nodeB) {
            nodeA = getOriginalNode(nodeA);
            return nodeA.parent && nodeA.parent === getOriginalNode(nodeB).parent;
        }
        function siblingNodePositionsAreComparable(previousNode, nextNode) {
            if (nextNode.pos < previousNode.end) return false;
            previousNode = getOriginalNode(previousNode);
            nextNode = getOriginalNode(nextNode);
            const parent2 = previousNode.parent;
            if (!parent2 || parent2 !== nextNode.parent) return false;
            const parentNodeArray = getContainingNodeArray(previousNode);
            const prevNodeIndex = parentNodeArray == null ? void 0 : parentNodeArray.indexOf(previousNode);
            return prevNodeIndex !== void 0 && prevNodeIndex > -1 && parentNodeArray.indexOf(nextNode) === prevNodeIndex + 1;
        }
        function emitLeadingComments(pos, isEmittedNode) {
            hasWrittenComment = false;
            if (isEmittedNode) {
                if (pos === 0 && (currentSourceFile == null ? void 0 : currentSourceFile.isDeclarationFile)) forEachLeadingCommentToEmit(pos, emitNonTripleSlashLeadingComment);
                else forEachLeadingCommentToEmit(pos, emitLeadingComment);
            } else if (pos === 0) forEachLeadingCommentToEmit(pos, emitTripleSlashLeadingComment);
        }
        function emitTripleSlashLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
            if (isTripleSlashComment(commentPos, commentEnd)) emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos);
        }
        function emitNonTripleSlashLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
            if (!isTripleSlashComment(commentPos, commentEnd)) emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos);
        }
        function shouldWriteComment(text, pos) {
            if (printerOptions.onlyPrintJsDocStyle) return isJSDocLikeText(text, pos) || isPinnedComment(text, pos);
            return true;
        }
        function emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
            if (!currentSourceFile || !shouldWriteComment(currentSourceFile.text, commentPos)) return;
            if (!hasWrittenComment) {
                emitNewLineBeforeLeadingCommentOfPosition(getCurrentLineMap(), writer, rangePos, commentPos);
                hasWrittenComment = true;
            }
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (hasTrailingNewLine) writer.writeLine();
            else if (kind === 3 /* MultiLineCommentTrivia */ ) writer.writeSpace(" ");
        }
        function emitLeadingCommentsOfPosition(pos) {
            if (commentsDisabled || pos === -1) return;
            emitLeadingComments(pos, /*isEmittedNode*/ true);
        }
        function emitTrailingComments(pos) {
            forEachTrailingCommentToEmit(pos, emitTrailingComment);
        }
        function emitTrailingComment(commentPos, commentEnd, _kind, hasTrailingNewLine) {
            if (!currentSourceFile || !shouldWriteComment(currentSourceFile.text, commentPos)) return;
            if (!writer.isAtStartOfLine()) writer.writeSpace(" ");
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (hasTrailingNewLine) writer.writeLine();
        }
        function emitTrailingCommentsOfPosition(pos, prefixSpace, forceNoNewline) {
            if (commentsDisabled) return;
            enterComment();
            forEachTrailingCommentToEmit(pos, prefixSpace ? emitTrailingComment : forceNoNewline ? emitTrailingCommentOfPositionNoNewline : emitTrailingCommentOfPosition);
            exitComment();
        }
        function emitTrailingCommentOfPositionNoNewline(commentPos, commentEnd, kind) {
            if (!currentSourceFile) return;
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (kind === 2 /* SingleLineCommentTrivia */ ) writer.writeLine();
        }
        function emitTrailingCommentOfPosition(commentPos, commentEnd, _kind, hasTrailingNewLine) {
            if (!currentSourceFile) return;
            emitPos(commentPos);
            writeCommentRange(currentSourceFile.text, getCurrentLineMap(), writer, commentPos, commentEnd, newLine);
            emitPos(commentEnd);
            if (hasTrailingNewLine) writer.writeLine();
            else writer.writeSpace(" ");
        }
        function forEachLeadingCommentToEmit(pos, cb) {
            if (currentSourceFile && (containerPos === -1 || pos !== containerPos)) {
                if (hasDetachedComments(pos)) forEachLeadingCommentWithoutDetachedComments(cb);
                else forEachLeadingCommentRange(currentSourceFile.text, pos, cb, /*state*/ pos);
            }
        }
        function forEachTrailingCommentToEmit(end, cb) {
            if (currentSourceFile && (containerEnd === -1 || end !== containerEnd && end !== declarationListContainerEnd)) forEachTrailingCommentRange(currentSourceFile.text, end, cb);
        }
        function hasDetachedComments(pos) {
            return detachedCommentsInfo !== void 0 && last(detachedCommentsInfo).nodePos === pos;
        }
        function forEachLeadingCommentWithoutDetachedComments(cb) {
            if (!currentSourceFile) return;
            const pos = last(detachedCommentsInfo).detachedCommentEndPos;
            if (detachedCommentsInfo.length - 1) detachedCommentsInfo.pop();
            else detachedCommentsInfo = void 0;
            forEachLeadingCommentRange(currentSourceFile.text, pos, cb, /*state*/ pos);
        }
        function emitDetachedCommentsAndUpdateCommentsInfo(range) {
            const currentDetachedCommentInfo = currentSourceFile && emitDetachedComments(currentSourceFile.text, getCurrentLineMap(), writer, emitComment, range, newLine, commentsDisabled);
            if (currentDetachedCommentInfo) {
                if (detachedCommentsInfo) detachedCommentsInfo.push(currentDetachedCommentInfo);
                else detachedCommentsInfo = [
                    currentDetachedCommentInfo
                ];
            }
        }
        function emitComment(text, lineMap, writer2, commentPos, commentEnd, newLine2) {
            if (!currentSourceFile || !shouldWriteComment(currentSourceFile.text, commentPos)) return;
            emitPos(commentPos);
            writeCommentRange(text, lineMap, writer2, commentPos, commentEnd, newLine2);
            emitPos(commentEnd);
        }
        function isTripleSlashComment(commentPos, commentEnd) {
            return !!currentSourceFile && isRecognizedTripleSlashComment(currentSourceFile.text, commentPos, commentEnd);
        }
        function pipelineEmitWithSourceMaps(hint, node) {
            const pipelinePhase = getNextPipelinePhase(3 /* SourceMaps */ , hint, node);
            emitSourceMapsBeforeNode(node);
            pipelinePhase(hint, node);
            emitSourceMapsAfterNode(node);
        }
        function emitSourceMapsBeforeNode(node) {
            const emitFlags = getEmitFlags(node);
            const sourceMapRange = getSourceMapRange(node);
            const source = sourceMapRange.source || sourceMapSource;
            if (node.kind !== 354 /* NotEmittedStatement */  && (emitFlags & 32 /* NoLeadingSourceMap */ ) === 0 && sourceMapRange.pos >= 0) emitSourcePos(sourceMapRange.source || sourceMapSource, skipSourceTrivia(source, sourceMapRange.pos));
            if (emitFlags & 128 /* NoNestedSourceMaps */ ) sourceMapsDisabled = true;
        }
        function emitSourceMapsAfterNode(node) {
            const emitFlags = getEmitFlags(node);
            const sourceMapRange = getSourceMapRange(node);
            if (emitFlags & 128 /* NoNestedSourceMaps */ ) sourceMapsDisabled = false;
            if (node.kind !== 354 /* NotEmittedStatement */  && (emitFlags & 64 /* NoTrailingSourceMap */ ) === 0 && sourceMapRange.end >= 0) emitSourcePos(sourceMapRange.source || sourceMapSource, sourceMapRange.end);
        }
        function skipSourceTrivia(source, pos) {
            return source.skipTrivia ? source.skipTrivia(pos) : skipTrivia(source.text, pos);
        }
        function emitPos(pos) {
            if (sourceMapsDisabled || positionIsSynthesized(pos) || isJsonSourceMapSource(sourceMapSource)) return;
            const { line: sourceLine, character: sourceCharacter } = getLineAndCharacterOfPosition(sourceMapSource, pos);
            sourceMapGenerator.addMapping(writer.getLine(), writer.getColumn(), sourceMapSourceIndex, sourceLine, sourceCharacter, /*nameIndex*/ void 0);
        }
        function emitSourcePos(source, pos) {
            if (source !== sourceMapSource) {
                const savedSourceMapSource = sourceMapSource;
                const savedSourceMapSourceIndex = sourceMapSourceIndex;
                setSourceMapSource(source);
                emitPos(pos);
                resetSourceMapSource(savedSourceMapSource, savedSourceMapSourceIndex);
            } else emitPos(pos);
        }
        function emitTokenWithSourceMap(node, token, writer2, tokenPos, emitCallback) {
            if (sourceMapsDisabled || node && isInJsonFile(node)) return emitCallback(token, writer2, tokenPos);
            const emitNode = node && node.emitNode;
            const emitFlags = emitNode && emitNode.flags || 0 /* None */ ;
            const range = emitNode && emitNode.tokenSourceMapRanges && emitNode.tokenSourceMapRanges[token];
            const source = range && range.source || sourceMapSource;
            tokenPos = skipSourceTrivia(source, range ? range.pos : tokenPos);
            if ((emitFlags & 256 /* NoTokenLeadingSourceMaps */ ) === 0 && tokenPos >= 0) emitSourcePos(source, tokenPos);
            tokenPos = emitCallback(token, writer2, tokenPos);
            if (range) tokenPos = range.end;
            if ((emitFlags & 512 /* NoTokenTrailingSourceMaps */ ) === 0 && tokenPos >= 0) emitSourcePos(source, tokenPos);
            return tokenPos;
        }
        function setSourceMapSource(source) {
            if (sourceMapsDisabled) return;
            sourceMapSource = source;
            if (source === mostRecentlyAddedSourceMapSource) {
                sourceMapSourceIndex = mostRecentlyAddedSourceMapSourceIndex;
                return;
            }
            if (isJsonSourceMapSource(source)) return;
            sourceMapSourceIndex = sourceMapGenerator.addSource(source.fileName);
            if (printerOptions.inlineSources) sourceMapGenerator.setSourceContent(sourceMapSourceIndex, source.text);
            mostRecentlyAddedSourceMapSource = source;
            mostRecentlyAddedSourceMapSourceIndex = sourceMapSourceIndex;
        }
        function resetSourceMapSource(source, sourceIndex) {
            sourceMapSource = source;
            sourceMapSourceIndex = sourceIndex;
        }
        function isJsonSourceMapSource(sourceFile) {
            return fileExtensionIs(sourceFile.fileName, ".json" /* Json */ );
        }
    }
    function createBracketsMap() {
        const brackets2 = [];
        brackets2[1024 /* Braces */ ] = [
            "{",
            "}"
        ];
        brackets2[2048 /* Parenthesis */ ] = [
            "(",
            ")"
        ];
        brackets2[4096 /* AngleBrackets */ ] = [
            "<",
            ">"
        ];
        brackets2[8192 /* SquareBrackets */ ] = [
            "[",
            "]"
        ];
        return brackets2;
    }
    function getOpeningBracket(format) {
        return brackets[format & 15360 /* BracketsMask */ ][0];
    }
    function getClosingBracket(format) {
        return brackets[format & 15360 /* BracketsMask */ ][1];
    }
    function emitListItemNoParenthesizer(node, emit, _parenthesizerRule, _index) {
        emit(node);
    }
    function emitListItemWithParenthesizerRuleSelector(node, emit, parenthesizerRuleSelector, index) {
        emit(node, parenthesizerRuleSelector.select(index));
    }
    function emitListItemWithParenthesizerRule(node, emit, parenthesizerRule, _index) {
        emit(node, parenthesizerRule);
    }
    function getEmitListItem(emit, parenthesizerRule) {
        return emit.length === 1 ? emitListItemNoParenthesizer : typeof parenthesizerRule === "object" ? emitListItemWithParenthesizerRuleSelector : emitListItemWithParenthesizerRule;
    }
    // src/compiler/watchUtilities.ts
    function createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames2) {
        if (!host.getDirectories || !host.readDirectory) return void 0;
        const cachedReadDirectoryResult = /* @__PURE__ */ new Map();
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        return {
            useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
            fileExists,
            readFile: (path, encoding)=>host.readFile(path, encoding),
            directoryExists: host.directoryExists && directoryExists,
            getDirectories,
            readDirectory,
            createDirectory: host.createDirectory && createDirectory,
            writeFile: host.writeFile && writeFile2,
            addOrDeleteFileOrDirectory,
            addOrDeleteFile,
            clearCache,
            realpath: host.realpath && realpath
        };
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function getCachedFileSystemEntries(rootDirPath) {
            return cachedReadDirectoryResult.get(ensureTrailingDirectorySeparator(rootDirPath));
        }
        function getCachedFileSystemEntriesForBaseDir(path) {
            const entries = getCachedFileSystemEntries(getDirectoryPath(path));
            if (!entries) return entries;
            if (!entries.sortedAndCanonicalizedFiles) {
                entries.sortedAndCanonicalizedFiles = entries.files.map(getCanonicalFileName).sort();
                entries.sortedAndCanonicalizedDirectories = entries.directories.map(getCanonicalFileName).sort();
            }
            return entries;
        }
        function getBaseNameOfFileName(fileName) {
            return getBaseFileName(normalizePath(fileName));
        }
        function createCachedFileSystemEntries(rootDir, rootDirPath) {
            var _a;
            if (!host.realpath || ensureTrailingDirectorySeparator(toPath3(host.realpath(rootDir))) === rootDirPath) {
                const resultFromHost = {
                    files: map(host.readDirectory(rootDir, /*extensions*/ void 0, /*exclude*/ void 0, /*include*/ [
                        "*.*"
                    ]), getBaseNameOfFileName) || [],
                    directories: host.getDirectories(rootDir) || []
                };
                cachedReadDirectoryResult.set(ensureTrailingDirectorySeparator(rootDirPath), resultFromHost);
                return resultFromHost;
            }
            if ((_a = host.directoryExists) == null ? void 0 : _a.call(host, rootDir)) {
                cachedReadDirectoryResult.set(rootDirPath, false);
                return false;
            }
            return void 0;
        }
        function tryReadDirectory2(rootDir, rootDirPath) {
            rootDirPath = ensureTrailingDirectorySeparator(rootDirPath);
            const cachedResult = getCachedFileSystemEntries(rootDirPath);
            if (cachedResult) return cachedResult;
            try {
                return createCachedFileSystemEntries(rootDir, rootDirPath);
            } catch (e) {
                Debug.assert(!cachedReadDirectoryResult.has(ensureTrailingDirectorySeparator(rootDirPath)));
                return void 0;
            }
        }
        function hasEntry(entries, name) {
            const index = binarySearch(entries, name, identity, compareStringsCaseSensitive);
            return index >= 0;
        }
        function writeFile2(fileName, data, writeByteOrderMark) {
            const path = toPath3(fileName);
            const result = getCachedFileSystemEntriesForBaseDir(path);
            if (result) updateFilesOfFileSystemEntry(result, getBaseNameOfFileName(fileName), /*fileExists*/ true);
            return host.writeFile(fileName, data, writeByteOrderMark);
        }
        function fileExists(fileName) {
            const path = toPath3(fileName);
            const result = getCachedFileSystemEntriesForBaseDir(path);
            return result && hasEntry(result.sortedAndCanonicalizedFiles, getCanonicalFileName(getBaseNameOfFileName(fileName))) || host.fileExists(fileName);
        }
        function directoryExists(dirPath) {
            const path = toPath3(dirPath);
            return cachedReadDirectoryResult.has(ensureTrailingDirectorySeparator(path)) || host.directoryExists(dirPath);
        }
        function createDirectory(dirPath) {
            const path = toPath3(dirPath);
            const result = getCachedFileSystemEntriesForBaseDir(path);
            if (result) {
                const baseName = getBaseNameOfFileName(dirPath);
                const canonicalizedBaseName = getCanonicalFileName(baseName);
                const canonicalizedDirectories = result.sortedAndCanonicalizedDirectories;
                if (insertSorted(canonicalizedDirectories, canonicalizedBaseName, compareStringsCaseSensitive)) result.directories.push(baseName);
            }
            host.createDirectory(dirPath);
        }
        function getDirectories(rootDir) {
            const rootDirPath = toPath3(rootDir);
            const result = tryReadDirectory2(rootDir, rootDirPath);
            if (result) return result.directories.slice();
            return host.getDirectories(rootDir);
        }
        function readDirectory(rootDir, extensions, excludes, includes, depth) {
            const rootDirPath = toPath3(rootDir);
            const rootResult = tryReadDirectory2(rootDir, rootDirPath);
            let rootSymLinkResult;
            if (rootResult !== void 0) return matchFiles(rootDir, extensions, excludes, includes, useCaseSensitiveFileNames2, currentDirectory, depth, getFileSystemEntries, realpath);
            return host.readDirectory(rootDir, extensions, excludes, includes, depth);
            function getFileSystemEntries(dir) {
                const path = toPath3(dir);
                if (path === rootDirPath) return rootResult || getFileSystemEntriesFromHost(dir, path);
                const result = tryReadDirectory2(dir, path);
                return result !== void 0 ? result || getFileSystemEntriesFromHost(dir, path) : emptyFileSystemEntries;
            }
            function getFileSystemEntriesFromHost(dir, path) {
                if (rootSymLinkResult && path === rootDirPath) return rootSymLinkResult;
                const result = {
                    files: map(host.readDirectory(dir, /*extensions*/ void 0, /*exclude*/ void 0, /*include*/ [
                        "*.*"
                    ]), getBaseNameOfFileName) || emptyArray,
                    directories: host.getDirectories(dir) || emptyArray
                };
                if (path === rootDirPath) rootSymLinkResult = result;
                return result;
            }
        }
        function realpath(s) {
            return host.realpath ? host.realpath(s) : s;
        }
        function clearFirstAncestorEntry(fileOrDirectoryPath) {
            forEachAncestorDirectory(getDirectoryPath(fileOrDirectoryPath), (ancestor)=>cachedReadDirectoryResult.delete(ensureTrailingDirectorySeparator(ancestor)) ? true : void 0);
        }
        function addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath) {
            const existingResult = getCachedFileSystemEntries(fileOrDirectoryPath);
            if (existingResult !== void 0) {
                clearCache();
                return void 0;
            }
            const parentResult = getCachedFileSystemEntriesForBaseDir(fileOrDirectoryPath);
            if (!parentResult) {
                clearFirstAncestorEntry(fileOrDirectoryPath);
                return void 0;
            }
            if (!host.directoryExists) {
                clearCache();
                return void 0;
            }
            const baseName = getBaseNameOfFileName(fileOrDirectory);
            const fsQueryResult = {
                fileExists: host.fileExists(fileOrDirectory),
                directoryExists: host.directoryExists(fileOrDirectory)
            };
            if (fsQueryResult.directoryExists || hasEntry(parentResult.sortedAndCanonicalizedDirectories, getCanonicalFileName(baseName))) clearCache();
            else updateFilesOfFileSystemEntry(parentResult, baseName, fsQueryResult.fileExists);
            return fsQueryResult;
        }
        function addOrDeleteFile(fileName, filePath, eventKind) {
            if (eventKind === 1 /* Changed */ ) return;
            const parentResult = getCachedFileSystemEntriesForBaseDir(filePath);
            if (parentResult) updateFilesOfFileSystemEntry(parentResult, getBaseNameOfFileName(fileName), eventKind === 0 /* Created */ );
            else clearFirstAncestorEntry(filePath);
        }
        function updateFilesOfFileSystemEntry(parentResult, baseName, fileExists2) {
            const canonicalizedFiles = parentResult.sortedAndCanonicalizedFiles;
            const canonicalizedBaseName = getCanonicalFileName(baseName);
            if (fileExists2) {
                if (insertSorted(canonicalizedFiles, canonicalizedBaseName, compareStringsCaseSensitive)) parentResult.files.push(baseName);
            } else {
                const sortedIndex = binarySearch(canonicalizedFiles, canonicalizedBaseName, identity, compareStringsCaseSensitive);
                if (sortedIndex >= 0) {
                    canonicalizedFiles.splice(sortedIndex, 1);
                    const unsortedIndex = parentResult.files.findIndex((entry)=>getCanonicalFileName(entry) === canonicalizedBaseName);
                    parentResult.files.splice(unsortedIndex, 1);
                }
            }
        }
        function clearCache() {
            cachedReadDirectoryResult.clear();
        }
    }
    var ProgramUpdateLevel = /* @__PURE__ */ ((ProgramUpdateLevel2)=>{
        ProgramUpdateLevel2[ProgramUpdateLevel2["Update"] = 0] = "Update";
        ProgramUpdateLevel2[ProgramUpdateLevel2["RootNamesAndUpdate"] = 1] = "RootNamesAndUpdate";
        ProgramUpdateLevel2[ProgramUpdateLevel2["Full"] = 2] = "Full";
        return ProgramUpdateLevel2;
    })(ProgramUpdateLevel || {});
    function updateSharedExtendedConfigFileWatcher(projectPath, options, extendedConfigFilesMap, createExtendedConfigFileWatch, toPath3) {
        var _a;
        const extendedConfigs = arrayToMap(((_a = options == null ? void 0 : options.configFile) == null ? void 0 : _a.extendedSourceFiles) || emptyArray, toPath3);
        extendedConfigFilesMap.forEach((watcher, extendedConfigFilePath)=>{
            if (!extendedConfigs.has(extendedConfigFilePath)) {
                watcher.projects.delete(projectPath);
                watcher.close();
            }
        });
        extendedConfigs.forEach((extendedConfigFileName, extendedConfigFilePath)=>{
            const existing = extendedConfigFilesMap.get(extendedConfigFilePath);
            if (existing) existing.projects.add(projectPath);
            else extendedConfigFilesMap.set(extendedConfigFilePath, {
                projects: /* @__PURE__ */ new Set([
                    projectPath
                ]),
                watcher: createExtendedConfigFileWatch(extendedConfigFileName, extendedConfigFilePath),
                close: ()=>{
                    const existing2 = extendedConfigFilesMap.get(extendedConfigFilePath);
                    if (!existing2 || existing2.projects.size !== 0) return;
                    existing2.watcher.close();
                    extendedConfigFilesMap.delete(extendedConfigFilePath);
                }
            });
        });
    }
    function clearSharedExtendedConfigFileWatcher(projectPath, extendedConfigFilesMap) {
        extendedConfigFilesMap.forEach((watcher)=>{
            if (watcher.projects.delete(projectPath)) watcher.close();
        });
    }
    function cleanExtendedConfigCache(extendedConfigCache, extendedConfigFilePath, toPath3) {
        if (!extendedConfigCache.delete(extendedConfigFilePath)) return;
        extendedConfigCache.forEach(({ extendedResult }, key)=>{
            var _a;
            if ((_a = extendedResult.extendedSourceFiles) == null ? void 0 : _a.some((extendedFile)=>toPath3(extendedFile) === extendedConfigFilePath)) cleanExtendedConfigCache(extendedConfigCache, key, toPath3);
        });
    }
    function updateMissingFilePathsWatch(program, missingFileWatches, createMissingFileWatch) {
        mutateMap(missingFileWatches, program.getMissingFilePaths(), {
            // Watch the missing files
            createNewValue: createMissingFileWatch,
            // Files that are no longer missing (e.g. because they are no longer required)
            // should no longer be watched.
            onDeleteValue: closeFileWatcher
        });
    }
    function updateWatchingWildcardDirectories(existingWatchedForWildcards, wildcardDirectories, watchDirectory) {
        if (wildcardDirectories) mutateMap(existingWatchedForWildcards, new Map(Object.entries(wildcardDirectories)), {
            // Create new watch and recursive info
            createNewValue: createWildcardDirectoryWatcher,
            // Close existing watch thats not needed any more
            onDeleteValue: closeFileWatcherOf,
            // Close existing watch that doesnt match in the flags
            onExistingValue: updateWildcardDirectoryWatcher
        });
        else clearMap(existingWatchedForWildcards, closeFileWatcherOf);
        function createWildcardDirectoryWatcher(directory, flags) {
            return {
                watcher: watchDirectory(directory, flags),
                flags
            };
        }
        function updateWildcardDirectoryWatcher(existingWatcher, flags, directory) {
            if (existingWatcher.flags === flags) return;
            existingWatcher.watcher.close();
            existingWatchedForWildcards.set(directory, createWildcardDirectoryWatcher(directory, flags));
        }
    }
    function isIgnoredFileFromWildCardWatching({ watchedDirPath, fileOrDirectory, fileOrDirectoryPath, configFileName, options, program, extraFileExtensions, currentDirectory, useCaseSensitiveFileNames: useCaseSensitiveFileNames2, writeLog, toPath: toPath3, getScriptKind: getScriptKind2 }) {
        const newPath = removeIgnoredPath(fileOrDirectoryPath);
        if (!newPath) {
            writeLog(`Project: ${configFileName} Detected ignored path: ${fileOrDirectory}`);
            return true;
        }
        fileOrDirectoryPath = newPath;
        if (fileOrDirectoryPath === watchedDirPath) return false;
        if (hasExtension(fileOrDirectoryPath) && !(isSupportedSourceFileName(fileOrDirectory, options, extraFileExtensions) || isSupportedScriptKind())) {
            writeLog(`Project: ${configFileName} Detected file add/remove of non supported extension: ${fileOrDirectory}`);
            return true;
        }
        if (isExcludedFile(fileOrDirectory, options.configFile.configFileSpecs, getNormalizedAbsolutePath(getDirectoryPath(configFileName), currentDirectory), useCaseSensitiveFileNames2, currentDirectory)) {
            writeLog(`Project: ${configFileName} Detected excluded file: ${fileOrDirectory}`);
            return true;
        }
        if (!program) return false;
        if (options.outFile || options.outDir) return false;
        if (isDeclarationFileName(fileOrDirectoryPath)) {
            if (options.declarationDir) return false;
        } else if (!fileExtensionIsOneOf(fileOrDirectoryPath, supportedJSExtensionsFlat)) return false;
        const filePathWithoutExtension = removeFileExtension(fileOrDirectoryPath);
        const realProgram = isArray(program) ? void 0 : isBuilderProgram(program) ? program.getProgramOrUndefined() : program;
        const builderProgram = !realProgram && !isArray(program) ? program : void 0;
        if (hasSourceFile(filePathWithoutExtension + ".ts" /* Ts */ ) || hasSourceFile(filePathWithoutExtension + ".tsx" /* Tsx */ )) {
            writeLog(`Project: ${configFileName} Detected output file: ${fileOrDirectory}`);
            return true;
        }
        return false;
        function hasSourceFile(file) {
            return realProgram ? !!realProgram.getSourceFileByPath(file) : builderProgram ? builderProgram.state.fileInfos.has(file) : !!find(program, (rootFile)=>toPath3(rootFile) === file);
        }
        function isSupportedScriptKind() {
            if (!getScriptKind2) return false;
            const scriptKind = getScriptKind2(fileOrDirectory);
            switch(scriptKind){
                case 3 /* TS */ :
                case 4 /* TSX */ :
                case 7 /* Deferred */ :
                case 5 /* External */ :
                    return true;
                case 1 /* JS */ :
                case 2 /* JSX */ :
                    return getAllowJSCompilerOption(options);
                case 6 /* JSON */ :
                    return getResolveJsonModule(options);
                case 0 /* Unknown */ :
                    return false;
            }
        }
    }
    function isEmittedFileOfProgram(program, file) {
        if (!program) return false;
        return program.isEmittedFile(file);
    }
    var WatchLogLevel = /* @__PURE__ */ ((WatchLogLevel2)=>{
        WatchLogLevel2[WatchLogLevel2["None"] = 0] = "None";
        WatchLogLevel2[WatchLogLevel2["TriggerOnly"] = 1] = "TriggerOnly";
        WatchLogLevel2[WatchLogLevel2["Verbose"] = 2] = "Verbose";
        return WatchLogLevel2;
    })(WatchLogLevel || {});
    function getWatchFactory(host, watchLogLevel, log, getDetailWatchInfo2) {
        setSysLog(watchLogLevel === 2 /* Verbose */  ? log : noop);
        const plainInvokeFactory = {
            watchFile: (file, callback, pollingInterval, options)=>host.watchFile(file, callback, pollingInterval, options),
            watchDirectory: (directory, callback, flags, options)=>host.watchDirectory(directory, callback, (flags & 1 /* Recursive */ ) !== 0, options)
        };
        const triggerInvokingFactory = watchLogLevel !== 0 /* None */  ? {
            watchFile: createTriggerLoggingAddWatch("watchFile"),
            watchDirectory: createTriggerLoggingAddWatch("watchDirectory")
        } : void 0;
        const factory2 = watchLogLevel === 2 /* Verbose */  ? {
            watchFile: createFileWatcherWithLogging,
            watchDirectory: createDirectoryWatcherWithLogging
        } : triggerInvokingFactory || plainInvokeFactory;
        const excludeWatcherFactory = watchLogLevel === 2 /* Verbose */  ? createExcludeWatcherWithLogging : returnNoopFileWatcher;
        return {
            watchFile: createExcludeHandlingAddWatch("watchFile"),
            watchDirectory: createExcludeHandlingAddWatch("watchDirectory")
        };
        function createExcludeHandlingAddWatch(key) {
            return (file, cb, flags, options, detailInfo1, detailInfo2)=>{
                var _a;
                return !matchesExclude(file, key === "watchFile" ? options == null ? void 0 : options.excludeFiles : options == null ? void 0 : options.excludeDirectories, useCaseSensitiveFileNames2(), ((_a = host.getCurrentDirectory) == null ? void 0 : _a.call(host)) || "") ? factory2[key].call(/*thisArgs*/ void 0, file, cb, flags, options, detailInfo1, detailInfo2) : excludeWatcherFactory(file, flags, options, detailInfo1, detailInfo2);
            };
        }
        function useCaseSensitiveFileNames2() {
            return typeof host.useCaseSensitiveFileNames === "boolean" ? host.useCaseSensitiveFileNames : host.useCaseSensitiveFileNames();
        }
        function createExcludeWatcherWithLogging(file, flags, options, detailInfo1, detailInfo2) {
            log(`ExcludeWatcher:: Added:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`);
            return {
                close: ()=>log(`ExcludeWatcher:: Close:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`)
            };
        }
        function createFileWatcherWithLogging(file, cb, flags, options, detailInfo1, detailInfo2) {
            log(`FileWatcher:: Added:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`);
            const watcher = triggerInvokingFactory.watchFile(file, cb, flags, options, detailInfo1, detailInfo2);
            return {
                close: ()=>{
                    log(`FileWatcher:: Close:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`);
                    watcher.close();
                }
            };
        }
        function createDirectoryWatcherWithLogging(file, cb, flags, options, detailInfo1, detailInfo2) {
            const watchInfo = `DirectoryWatcher:: Added:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`;
            log(watchInfo);
            const start = timestamp();
            const watcher = triggerInvokingFactory.watchDirectory(file, cb, flags, options, detailInfo1, detailInfo2);
            const elapsed = timestamp() - start;
            log(`Elapsed:: ${elapsed}ms ${watchInfo}`);
            return {
                close: ()=>{
                    const watchInfo2 = `DirectoryWatcher:: Close:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`;
                    log(watchInfo2);
                    const start2 = timestamp();
                    watcher.close();
                    const elapsed2 = timestamp() - start2;
                    log(`Elapsed:: ${elapsed2}ms ${watchInfo2}`);
                }
            };
        }
        function createTriggerLoggingAddWatch(key) {
            return (file, cb, flags, options, detailInfo1, detailInfo2)=>plainInvokeFactory[key].call(/*thisArgs*/ void 0, file, (...args)=>{
                    const triggerredInfo = `${key === "watchFile" ? "FileWatcher" : "DirectoryWatcher"}:: Triggered with ${args[0]} ${args[1] !== void 0 ? args[1] : ""}:: ${getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo2)}`;
                    log(triggerredInfo);
                    const start = timestamp();
                    cb.call(/*thisArg*/ void 0, ...args);
                    const elapsed = timestamp() - start;
                    log(`Elapsed:: ${elapsed}ms ${triggerredInfo}`);
                }, flags, options, detailInfo1, detailInfo2);
        }
        function getWatchInfo(file, flags, options, detailInfo1, detailInfo2, getDetailWatchInfo3) {
            return `WatchInfo: ${file} ${flags} ${JSON.stringify(options)} ${getDetailWatchInfo3 ? getDetailWatchInfo3(detailInfo1, detailInfo2) : detailInfo2 === void 0 ? detailInfo1 : `${detailInfo1} ${detailInfo2}`}`;
        }
    }
    function getFallbackOptions(options) {
        const fallbackPolling = options == null ? void 0 : options.fallbackPolling;
        return {
            watchFile: fallbackPolling !== void 0 ? fallbackPolling : 1 /* PriorityPollingInterval */ 
        };
    }
    function closeFileWatcherOf(objWithWatcher) {
        objWithWatcher.watcher.close();
    }
    // src/compiler/program.ts
    function findConfigFile(searchPath, fileExists, configName = "tsconfig.json") {
        return forEachAncestorDirectory(searchPath, (ancestor)=>{
            const fileName = combinePaths(ancestor, configName);
            return fileExists(fileName) ? fileName : void 0;
        });
    }
    function resolveTripleslashReference(moduleName, containingFile) {
        const basePath = getDirectoryPath(containingFile);
        const referencedFileName = isRootedDiskPath(moduleName) ? moduleName : combinePaths(basePath, moduleName);
        return normalizePath(referencedFileName);
    }
    function computeCommonSourceDirectoryOfFilenames(fileNames, currentDirectory, getCanonicalFileName) {
        let commonPathComponents;
        const failed2 = forEach(fileNames, (sourceFile)=>{
            const sourcePathComponents = getNormalizedPathComponents(sourceFile, currentDirectory);
            sourcePathComponents.pop();
            if (!commonPathComponents) {
                commonPathComponents = sourcePathComponents;
                return;
            }
            const n = Math.min(commonPathComponents.length, sourcePathComponents.length);
            for(let i = 0; i < n; i++)if (getCanonicalFileName(commonPathComponents[i]) !== getCanonicalFileName(sourcePathComponents[i])) {
                if (i === 0) return true;
                commonPathComponents.length = i;
                break;
            }
            if (sourcePathComponents.length < commonPathComponents.length) commonPathComponents.length = sourcePathComponents.length;
        });
        if (failed2) return "";
        if (!commonPathComponents) return currentDirectory;
        return getPathFromPathComponents(commonPathComponents);
    }
    function createCompilerHost(options, setParentNodes) {
        return createCompilerHostWorker(options, setParentNodes);
    }
    function createGetSourceFile(readFile, setParentNodes) {
        return (fileName, languageVersionOrOptions, onError)=>{
            let text;
            try {
                mark("beforeIORead");
                text = readFile(fileName);
                mark("afterIORead");
                measure("I/O Read", "beforeIORead", "afterIORead");
            } catch (e) {
                if (onError) onError(e.message);
                text = "";
            }
            return text !== void 0 ? createSourceFile(fileName, text, languageVersionOrOptions, setParentNodes) : void 0;
        };
    }
    function createWriteFileMeasuringIO(actualWriteFile, createDirectory, directoryExists) {
        return (fileName, data, writeByteOrderMark, onError)=>{
            try {
                mark("beforeIOWrite");
                writeFileEnsuringDirectories(fileName, data, writeByteOrderMark, actualWriteFile, createDirectory, directoryExists);
                mark("afterIOWrite");
                measure("I/O Write", "beforeIOWrite", "afterIOWrite");
            } catch (e) {
                if (onError) onError(e.message);
            }
        };
    }
    function createCompilerHostWorker(options, setParentNodes, system = sys) {
        const existingDirectories = /* @__PURE__ */ new Map();
        const getCanonicalFileName = createGetCanonicalFileName(system.useCaseSensitiveFileNames);
        function directoryExists(directoryPath) {
            if (existingDirectories.has(directoryPath)) return true;
            if ((compilerHost.directoryExists || system.directoryExists)(directoryPath)) {
                existingDirectories.set(directoryPath, true);
                return true;
            }
            return false;
        }
        function getDefaultLibLocation() {
            return getDirectoryPath(normalizePath(system.getExecutingFilePath()));
        }
        const newLine = getNewLineCharacter(options);
        const realpath = system.realpath && ((path)=>system.realpath(path));
        const compilerHost = {
            getSourceFile: createGetSourceFile((fileName)=>compilerHost.readFile(fileName), setParentNodes),
            getDefaultLibLocation,
            getDefaultLibFileName: (options2)=>combinePaths(getDefaultLibLocation(), getDefaultLibFileName(options2)),
            writeFile: createWriteFileMeasuringIO((path, data, writeByteOrderMark)=>system.writeFile(path, data, writeByteOrderMark), (path)=>(compilerHost.createDirectory || system.createDirectory)(path), (path)=>directoryExists(path)),
            getCurrentDirectory: memoize(()=>system.getCurrentDirectory()),
            useCaseSensitiveFileNames: ()=>system.useCaseSensitiveFileNames,
            getCanonicalFileName,
            getNewLine: ()=>newLine,
            fileExists: (fileName)=>system.fileExists(fileName),
            readFile: (fileName)=>system.readFile(fileName),
            trace: (s)=>system.write(s + newLine),
            directoryExists: (directoryName)=>system.directoryExists(directoryName),
            getEnvironmentVariable: (name)=>system.getEnvironmentVariable ? system.getEnvironmentVariable(name) : "",
            getDirectories: (path)=>system.getDirectories(path),
            realpath,
            readDirectory: (path, extensions, include, exclude, depth)=>system.readDirectory(path, extensions, include, exclude, depth),
            createDirectory: (d)=>system.createDirectory(d),
            createHash: maybeBind(system, system.createHash)
        };
        return compilerHost;
    }
    function changeCompilerHostLikeToUseCache(host, toPath3, getSourceFile) {
        const originalReadFile = host.readFile;
        const originalFileExists = host.fileExists;
        const originalDirectoryExists = host.directoryExists;
        const originalCreateDirectory = host.createDirectory;
        const originalWriteFile = host.writeFile;
        const readFileCache = /* @__PURE__ */ new Map();
        const fileExistsCache = /* @__PURE__ */ new Map();
        const directoryExistsCache = /* @__PURE__ */ new Map();
        const sourceFileCache = /* @__PURE__ */ new Map();
        const readFileWithCache = (fileName)=>{
            const key = toPath3(fileName);
            const value1 = readFileCache.get(key);
            if (value1 !== void 0) return value1 !== false ? value1 : void 0;
            return setReadFileCache(key, fileName);
        };
        const setReadFileCache = (key, fileName)=>{
            const newValue = originalReadFile.call(host, fileName);
            readFileCache.set(key, newValue !== void 0 ? newValue : false);
            return newValue;
        };
        host.readFile = (fileName)=>{
            const key = toPath3(fileName);
            const value1 = readFileCache.get(key);
            if (value1 !== void 0) return value1 !== false ? value1 : void 0;
            if (!fileExtensionIs(fileName, ".json" /* Json */ ) && !isBuildInfoFile(fileName)) return originalReadFile.call(host, fileName);
            return setReadFileCache(key, fileName);
        };
        const getSourceFileWithCache = getSourceFile ? (fileName, languageVersionOrOptions, onError, shouldCreateNewSourceFile)=>{
            const key = toPath3(fileName);
            const impliedNodeFormat = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions.impliedNodeFormat : void 0;
            const forImpliedNodeFormat = sourceFileCache.get(impliedNodeFormat);
            const value1 = forImpliedNodeFormat == null ? void 0 : forImpliedNodeFormat.get(key);
            if (value1) return value1;
            const sourceFile = getSourceFile(fileName, languageVersionOrOptions, onError, shouldCreateNewSourceFile);
            if (sourceFile && (isDeclarationFileName(fileName) || fileExtensionIs(fileName, ".json" /* Json */ ))) sourceFileCache.set(impliedNodeFormat, (forImpliedNodeFormat || /* @__PURE__ */ new Map()).set(key, sourceFile));
            return sourceFile;
        } : void 0;
        host.fileExists = (fileName)=>{
            const key = toPath3(fileName);
            const value1 = fileExistsCache.get(key);
            if (value1 !== void 0) return value1;
            const newValue = originalFileExists.call(host, fileName);
            fileExistsCache.set(key, !!newValue);
            return newValue;
        };
        if (originalWriteFile) host.writeFile = (fileName, data, ...rest)=>{
            const key = toPath3(fileName);
            fileExistsCache.delete(key);
            const value1 = readFileCache.get(key);
            if (value1 !== void 0 && value1 !== data) {
                readFileCache.delete(key);
                sourceFileCache.forEach((map2)=>map2.delete(key));
            } else if (getSourceFileWithCache) sourceFileCache.forEach((map2)=>{
                const sourceFile = map2.get(key);
                if (sourceFile && sourceFile.text !== data) map2.delete(key);
            });
            originalWriteFile.call(host, fileName, data, ...rest);
        };
        if (originalDirectoryExists) {
            host.directoryExists = (directory)=>{
                const key = toPath3(directory);
                const value1 = directoryExistsCache.get(key);
                if (value1 !== void 0) return value1;
                const newValue = originalDirectoryExists.call(host, directory);
                directoryExistsCache.set(key, !!newValue);
                return newValue;
            };
            if (originalCreateDirectory) host.createDirectory = (directory)=>{
                const key = toPath3(directory);
                directoryExistsCache.delete(key);
                originalCreateDirectory.call(host, directory);
            };
        }
        return {
            originalReadFile,
            originalFileExists,
            originalDirectoryExists,
            originalCreateDirectory,
            originalWriteFile,
            getSourceFileWithCache,
            readFileWithCache
        };
    }
    function getPreEmitDiagnostics(program, sourceFile, cancellationToken) {
        let diagnostics;
        diagnostics = addRange(diagnostics, program.getConfigFileParsingDiagnostics());
        diagnostics = addRange(diagnostics, program.getOptionsDiagnostics(cancellationToken));
        diagnostics = addRange(diagnostics, program.getSyntacticDiagnostics(sourceFile, cancellationToken));
        diagnostics = addRange(diagnostics, program.getGlobalDiagnostics(cancellationToken));
        diagnostics = addRange(diagnostics, program.getSemanticDiagnostics(sourceFile, cancellationToken));
        if (getEmitDeclarations(program.getCompilerOptions())) diagnostics = addRange(diagnostics, program.getDeclarationDiagnostics(sourceFile, cancellationToken));
        return sortAndDeduplicateDiagnostics(diagnostics || emptyArray);
    }
    function formatDiagnostics(diagnostics, host) {
        let output = "";
        for (const diagnostic of diagnostics)output += formatDiagnostic(diagnostic, host);
        return output;
    }
    function formatDiagnostic(diagnostic, host) {
        const errorMessage = `${diagnosticCategoryName(diagnostic)} TS${diagnostic.code}: ${flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine())}${host.getNewLine()}`;
        if (diagnostic.file) {
            const { line, character } = getLineAndCharacterOfPosition(diagnostic.file, diagnostic.start);
            const fileName = diagnostic.file.fileName;
            const relativeFileName = convertToRelativePath(fileName, host.getCurrentDirectory(), (fileName2)=>host.getCanonicalFileName(fileName2));
            return `${relativeFileName}(${line + 1},${character + 1}): ` + errorMessage;
        }
        return errorMessage;
    }
    var ForegroundColorEscapeSequences = /* @__PURE__ */ ((ForegroundColorEscapeSequences2)=>{
        ForegroundColorEscapeSequences2["Grey"] = "\x1B[90m";
        ForegroundColorEscapeSequences2["Red"] = "\x1B[91m";
        ForegroundColorEscapeSequences2["Yellow"] = "\x1B[93m";
        ForegroundColorEscapeSequences2["Blue"] = "\x1B[94m";
        ForegroundColorEscapeSequences2["Cyan"] = "\x1B[96m";
        return ForegroundColorEscapeSequences2;
    })(ForegroundColorEscapeSequences || {});
    var gutterStyleSequence = "\x1B[7m";
    var gutterSeparator = " ";
    var resetEscapeSequence = "\x1B[0m";
    var ellipsis = "...";
    var halfIndent = "  ";
    var indent = "    ";
    function getCategoryFormat(category) {
        switch(category){
            case 1 /* Error */ :
                return "\x1B[91m" /* Red */ ;
            case 0 /* Warning */ :
                return "\x1B[93m" /* Yellow */ ;
            case 2 /* Suggestion */ :
                return Debug.fail("Should never get an Info diagnostic on the command line.");
            case 3 /* Message */ :
                return "\x1B[94m" /* Blue */ ;
        }
    }
    function formatColorAndReset(text, formatStyle) {
        return formatStyle + text + resetEscapeSequence;
    }
    function formatCodeSpan(file, start, length2, indent3, squiggleColor, host) {
        const { line: firstLine, character: firstLineChar } = getLineAndCharacterOfPosition(file, start);
        const { line: lastLine, character: lastLineChar } = getLineAndCharacterOfPosition(file, start + length2);
        const lastLineInFile = getLineAndCharacterOfPosition(file, file.text.length).line;
        const hasMoreThanFiveLines = lastLine - firstLine >= 4;
        let gutterWidth = (lastLine + 1 + "").length;
        if (hasMoreThanFiveLines) gutterWidth = Math.max(ellipsis.length, gutterWidth);
        let context = "";
        for(let i = firstLine; i <= lastLine; i++){
            context += host.getNewLine();
            if (hasMoreThanFiveLines && firstLine + 1 < i && i < lastLine - 1) {
                context += indent3 + formatColorAndReset(ellipsis.padStart(gutterWidth), gutterStyleSequence) + gutterSeparator + host.getNewLine();
                i = lastLine - 1;
            }
            const lineStart = getPositionOfLineAndCharacter(file, i, 0);
            const lineEnd = i < lastLineInFile ? getPositionOfLineAndCharacter(file, i + 1, 0) : file.text.length;
            let lineContent = file.text.slice(lineStart, lineEnd);
            lineContent = lineContent.trimEnd();
            lineContent = lineContent.replace(/\t/g, " ");
            context += indent3 + formatColorAndReset((i + 1 + "").padStart(gutterWidth), gutterStyleSequence) + gutterSeparator;
            context += lineContent + host.getNewLine();
            context += indent3 + formatColorAndReset("".padStart(gutterWidth), gutterStyleSequence) + gutterSeparator;
            context += squiggleColor;
            if (i === firstLine) {
                const lastCharForLine = i === lastLine ? lastLineChar : void 0;
                context += lineContent.slice(0, firstLineChar).replace(/\S/g, " ");
                context += lineContent.slice(firstLineChar, lastCharForLine).replace(/./g, "~");
            } else if (i === lastLine) context += lineContent.slice(0, lastLineChar).replace(/./g, "~");
            else context += lineContent.replace(/./g, "~");
            context += resetEscapeSequence;
        }
        return context;
    }
    function formatLocation(file, start, host, color = formatColorAndReset) {
        const { line: firstLine, character: firstLineChar } = getLineAndCharacterOfPosition(file, start);
        const relativeFileName = host ? convertToRelativePath(file.fileName, host.getCurrentDirectory(), (fileName)=>host.getCanonicalFileName(fileName)) : file.fileName;
        let output = "";
        output += color(relativeFileName, "\x1B[96m" /* Cyan */ );
        output += ":";
        output += color(`${firstLine + 1}`, "\x1B[93m" /* Yellow */ );
        output += ":";
        output += color(`${firstLineChar + 1}`, "\x1B[93m" /* Yellow */ );
        return output;
    }
    function formatDiagnosticsWithColorAndContext(diagnostics, host) {
        let output = "";
        for (const diagnostic of diagnostics){
            if (diagnostic.file) {
                const { file, start } = diagnostic;
                output += formatLocation(file, start, host);
                output += " - ";
            }
            output += formatColorAndReset(diagnosticCategoryName(diagnostic), getCategoryFormat(diagnostic.category));
            output += formatColorAndReset(` TS${diagnostic.code}: `, "\x1B[90m" /* Grey */ );
            output += flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine());
            if (diagnostic.file && diagnostic.code !== Diagnostics.File_appears_to_be_binary.code) {
                output += host.getNewLine();
                output += formatCodeSpan(diagnostic.file, diagnostic.start, diagnostic.length, "", getCategoryFormat(diagnostic.category), host);
            }
            if (diagnostic.relatedInformation) {
                output += host.getNewLine();
                for (const { file, start, length: length2, messageText } of diagnostic.relatedInformation){
                    if (file) {
                        output += host.getNewLine();
                        output += halfIndent + formatLocation(file, start, host);
                        output += formatCodeSpan(file, start, length2, indent, "\x1B[96m" /* Cyan */ , host);
                    }
                    output += host.getNewLine();
                    output += indent + flattenDiagnosticMessageText(messageText, host.getNewLine());
                }
            }
            output += host.getNewLine();
        }
        return output;
    }
    function flattenDiagnosticMessageText(diag2, newLine, indent3 = 0) {
        if (isString(diag2)) return diag2;
        else if (diag2 === void 0) return "";
        let result = "";
        if (indent3) {
            result += newLine;
            for(let i = 0; i < indent3; i++)result += "  ";
        }
        result += diag2.messageText;
        indent3++;
        if (diag2.next) for (const kid of diag2.next)result += flattenDiagnosticMessageText(kid, newLine, indent3);
        return result;
    }
    function getModeForFileReference(ref, containingFileMode) {
        return (isString(ref) ? containingFileMode : ref.resolutionMode) || containingFileMode;
    }
    function getModeForResolutionAtIndex(file, index, compilerOptions) {
        return getModeForUsageLocationWorker(file, getModuleNameStringLiteralAt(file, index), compilerOptions);
    }
    function isExclusivelyTypeOnlyImportOrExport(decl) {
        var _a;
        if (isExportDeclaration(decl)) return decl.isTypeOnly;
        if ((_a = decl.importClause) == null ? void 0 : _a.isTypeOnly) return true;
        return false;
    }
    function getModeForUsageLocation(file, usage, compilerOptions) {
        return getModeForUsageLocationWorker(file, usage, compilerOptions);
    }
    function getModeForUsageLocationWorker(file, usage, compilerOptions) {
        if (isImportDeclaration(usage.parent) || isExportDeclaration(usage.parent) || isJSDocImportTag(usage.parent)) {
            const isTypeOnly = isExclusivelyTypeOnlyImportOrExport(usage.parent);
            if (isTypeOnly) {
                const override = getResolutionModeOverride(usage.parent.attributes);
                if (override) return override;
            }
        }
        if (usage.parent.parent && isImportTypeNode(usage.parent.parent)) {
            const override = getResolutionModeOverride(usage.parent.parent.attributes);
            if (override) return override;
        }
        if (compilerOptions && importSyntaxAffectsModuleResolution(compilerOptions)) return getEmitSyntaxForUsageLocationWorker(file, usage, compilerOptions);
    }
    function getEmitSyntaxForUsageLocationWorker(file, usage, compilerOptions) {
        var _a;
        if (!compilerOptions) return void 0;
        const exprParentParent = (_a = walkUpParenthesizedExpressions(usage.parent)) == null ? void 0 : _a.parent;
        if (exprParentParent && isImportEqualsDeclaration(exprParentParent) || isRequireCall(usage.parent, /*requireStringLiteralLikeArgument*/ false)) return 1 /* CommonJS */ ;
        if (isImportCall(walkUpParenthesizedExpressions(usage.parent))) return shouldTransformImportCallWorker(file, compilerOptions) ? 1 /* CommonJS */  : 99 /* ESNext */ ;
        const fileEmitMode = getEmitModuleFormatOfFileWorker(file, compilerOptions);
        return fileEmitMode === 1 /* CommonJS */  ? 1 /* CommonJS */  : emitModuleKindIsNonNodeESM(fileEmitMode) || fileEmitMode === 200 /* Preserve */  ? 99 /* ESNext */  : void 0;
    }
    function getResolutionModeOverride(node, grammarErrorOnNode) {
        if (!node) return void 0;
        if (length(node.elements) !== 1) {
            grammarErrorOnNode == null || grammarErrorOnNode(node, node.token === 118 /* WithKeyword */  ? Diagnostics.Type_import_attributes_should_have_exactly_one_key_resolution_mode_with_value_import_or_require : Diagnostics.Type_import_assertions_should_have_exactly_one_key_resolution_mode_with_value_import_or_require);
            return void 0;
        }
        const elem = node.elements[0];
        if (!isStringLiteralLike(elem.name)) return void 0;
        if (elem.name.text !== "resolution-mode") {
            grammarErrorOnNode == null || grammarErrorOnNode(elem.name, node.token === 118 /* WithKeyword */  ? Diagnostics.resolution_mode_is_the_only_valid_key_for_type_import_attributes : Diagnostics.resolution_mode_is_the_only_valid_key_for_type_import_assertions);
            return void 0;
        }
        if (!isStringLiteralLike(elem.value)) return void 0;
        if (elem.value.text !== "import" && elem.value.text !== "require") {
            grammarErrorOnNode == null || grammarErrorOnNode(elem.value, Diagnostics.resolution_mode_should_be_either_require_or_import);
            return void 0;
        }
        return elem.value.text === "import" ? 99 /* ESNext */  : 1 /* CommonJS */ ;
    }
    var emptyResolution = {
        resolvedModule: void 0,
        resolvedTypeReferenceDirective: void 0
    };
    function getModuleResolutionName(literal) {
        return literal.text;
    }
    var moduleResolutionNameAndModeGetter = {
        getName: getModuleResolutionName,
        getMode: (entry, file, compilerOptions)=>getModeForUsageLocation(file, entry, compilerOptions)
    };
    function createModuleResolutionLoader(containingFile, redirectedReference, options, host, cache) {
        return {
            nameAndMode: moduleResolutionNameAndModeGetter,
            resolve: (moduleName, resolutionMode)=>resolveModuleName(moduleName, containingFile, options, host, cache, redirectedReference, resolutionMode)
        };
    }
    function getTypeReferenceResolutionName(entry) {
        return !isString(entry) ? entry.fileName : entry;
    }
    var typeReferenceResolutionNameAndModeGetter = {
        getName: getTypeReferenceResolutionName,
        getMode: (entry, file, compilerOptions)=>getModeForFileReference(entry, file && getDefaultResolutionModeForFileWorker(file, compilerOptions))
    };
    function createTypeReferenceResolutionLoader(containingFile, redirectedReference, options, host, cache) {
        return {
            nameAndMode: typeReferenceResolutionNameAndModeGetter,
            resolve: (typeRef, resoluionMode)=>resolveTypeReferenceDirective(typeRef, containingFile, options, host, redirectedReference, cache, resoluionMode)
        };
    }
    function loadWithModeAwareCache(entries, containingFile, redirectedReference, options, containingSourceFile, host, resolutionCache, createLoader) {
        if (entries.length === 0) return emptyArray;
        const resolutions = [];
        const cache = /* @__PURE__ */ new Map();
        const loader = createLoader(containingFile, redirectedReference, options, host, resolutionCache);
        for (const entry of entries){
            const name = loader.nameAndMode.getName(entry);
            const mode = loader.nameAndMode.getMode(entry, containingSourceFile, (redirectedReference == null ? void 0 : redirectedReference.commandLine.options) || options);
            const key = createModeAwareCacheKey(name, mode);
            let result = cache.get(key);
            if (!result) cache.set(key, result = loader.resolve(name, mode));
            resolutions.push(result);
        }
        return resolutions;
    }
    var inferredTypesContainingFile = "__inferred type names__.ts";
    function getInferredLibraryNameResolveFrom(options, currentDirectory, libFileName) {
        const containingDirectory = options.configFilePath ? getDirectoryPath(options.configFilePath) : currentDirectory;
        return combinePaths(containingDirectory, `__lib_node_modules_lookup_${libFileName}__.ts`);
    }
    function getLibraryNameFromLibFileName(libFileName) {
        const components = libFileName.split(".");
        let path = components[1];
        let i = 2;
        while(components[i] && components[i] !== "d"){
            path += (i === 2 ? "/" : "-") + components[i];
            i++;
        }
        return "@typescript/lib-" + path;
    }
    function isReferencedFile(reason) {
        switch(reason == null ? void 0 : reason.kind){
            case 3 /* Import */ :
            case 4 /* ReferenceFile */ :
            case 5 /* TypeReferenceDirective */ :
            case 7 /* LibReferenceDirective */ :
                return true;
            default:
                return false;
        }
    }
    function isReferenceFileLocation(location) {
        return location.pos !== void 0;
    }
    function getReferencedFileLocation(program, ref) {
        var _a, _b, _c, _d;
        const file = Debug.checkDefined(program.getSourceFileByPath(ref.file));
        const { kind, index } = ref;
        let pos, end, packageId;
        switch(kind){
            case 3 /* Import */ :
                const importLiteral = getModuleNameStringLiteralAt(file, index);
                packageId = (_b = (_a = program.getResolvedModuleFromModuleSpecifier(importLiteral, file)) == null ? void 0 : _a.resolvedModule) == null ? void 0 : _b.packageId;
                if (importLiteral.pos === -1) return {
                    file,
                    packageId,
                    text: importLiteral.text
                };
                pos = skipTrivia(file.text, importLiteral.pos);
                end = importLiteral.end;
                break;
            case 4 /* ReferenceFile */ :
                ({ pos, end } = file.referencedFiles[index]);
                break;
            case 5 /* TypeReferenceDirective */ :
                ({ pos, end } = file.typeReferenceDirectives[index]);
                packageId = (_d = (_c = program.getResolvedTypeReferenceDirectiveFromTypeReferenceDirective(file.typeReferenceDirectives[index], file)) == null ? void 0 : _c.resolvedTypeReferenceDirective) == null ? void 0 : _d.packageId;
                break;
            case 7 /* LibReferenceDirective */ :
                ({ pos, end } = file.libReferenceDirectives[index]);
                break;
            default:
                return Debug.assertNever(kind);
        }
        return {
            file,
            pos,
            end,
            packageId
        };
    }
    function isProgramUptoDate(program, rootFileNames, newOptions, getSourceVersion, fileExists, hasInvalidatedResolutions, hasInvalidatedLibResolutions, hasChangedAutomaticTypeDirectiveNames, getParsedCommandLine, projectReferences) {
        if (!program || (hasChangedAutomaticTypeDirectiveNames == null ? void 0 : hasChangedAutomaticTypeDirectiveNames())) return false;
        if (!arrayIsEqualTo(program.getRootFileNames(), rootFileNames)) return false;
        let seenResolvedRefs;
        if (!arrayIsEqualTo(program.getProjectReferences(), projectReferences, projectReferenceUptoDate)) return false;
        if (program.getSourceFiles().some(sourceFileNotUptoDate)) return false;
        const missingPaths = program.getMissingFilePaths();
        if (missingPaths && forEachEntry(missingPaths, fileExists)) return false;
        const currentOptions = program.getCompilerOptions();
        if (!compareDataObjects(currentOptions, newOptions)) return false;
        if (program.resolvedLibReferences && forEachEntry(program.resolvedLibReferences, (_value, libFileName)=>hasInvalidatedLibResolutions(libFileName))) return false;
        if (currentOptions.configFile && newOptions.configFile) return currentOptions.configFile.text === newOptions.configFile.text;
        return true;
        function sourceFileNotUptoDate(sourceFile) {
            return !sourceFileVersionUptoDate(sourceFile) || hasInvalidatedResolutions(sourceFile.path);
        }
        function sourceFileVersionUptoDate(sourceFile) {
            return sourceFile.version === getSourceVersion(sourceFile.resolvedPath, sourceFile.fileName);
        }
        function projectReferenceUptoDate(oldRef, newRef, index) {
            return projectReferenceIsEqualTo(oldRef, newRef) && resolvedProjectReferenceUptoDate(program.getResolvedProjectReferences()[index], oldRef);
        }
        function resolvedProjectReferenceUptoDate(oldResolvedRef, oldRef) {
            if (oldResolvedRef) {
                if (contains(seenResolvedRefs, oldResolvedRef)) return true;
                const refPath2 = resolveProjectReferencePath(oldRef);
                const newParsedCommandLine = getParsedCommandLine(refPath2);
                if (!newParsedCommandLine) return false;
                if (oldResolvedRef.commandLine.options.configFile !== newParsedCommandLine.options.configFile) return false;
                if (!arrayIsEqualTo(oldResolvedRef.commandLine.fileNames, newParsedCommandLine.fileNames)) return false;
                (seenResolvedRefs || (seenResolvedRefs = [])).push(oldResolvedRef);
                return !forEach(oldResolvedRef.references, (childResolvedRef, index)=>!resolvedProjectReferenceUptoDate(childResolvedRef, oldResolvedRef.commandLine.projectReferences[index]));
            }
            const refPath = resolveProjectReferencePath(oldRef);
            return !getParsedCommandLine(refPath);
        }
    }
    function getConfigFileParsingDiagnostics(configFileParseResult) {
        return configFileParseResult.options.configFile ? [
            ...configFileParseResult.options.configFile.parseDiagnostics,
            ...configFileParseResult.errors
        ] : configFileParseResult.errors;
    }
    function getImpliedNodeFormatForFile(fileName, packageJsonInfoCache, host, options) {
        const result = getImpliedNodeFormatForFileWorker(fileName, packageJsonInfoCache, host, options);
        return typeof result === "object" ? result.impliedNodeFormat : result;
    }
    function getImpliedNodeFormatForFileWorker(fileName, packageJsonInfoCache, host, options) {
        const moduleResolution = getEmitModuleResolutionKind(options);
        const shouldLookupFromPackageJson = 3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */  || pathContainsNodeModules(fileName);
        return fileExtensionIsOneOf(fileName, [
            ".d.mts" /* Dmts */ ,
            ".mts" /* Mts */ ,
            ".mjs" /* Mjs */ 
        ]) ? 99 /* ESNext */  : fileExtensionIsOneOf(fileName, [
            ".d.cts" /* Dcts */ ,
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ]) ? 1 /* CommonJS */  : shouldLookupFromPackageJson && fileExtensionIsOneOf(fileName, [
            ".d.ts" /* Dts */ ,
            ".ts" /* Ts */ ,
            ".tsx" /* Tsx */ ,
            ".js" /* Js */ ,
            ".jsx" /* Jsx */ 
        ]) ? lookupFromPackageJson() : void 0;
        function lookupFromPackageJson() {
            const state = getTemporaryModuleResolutionState(packageJsonInfoCache, host, options);
            const packageJsonLocations = [];
            state.failedLookupLocations = packageJsonLocations;
            state.affectingLocations = packageJsonLocations;
            const packageJsonScope = getPackageScopeForPath(getDirectoryPath(fileName), state);
            const impliedNodeFormat = (packageJsonScope == null ? void 0 : packageJsonScope.contents.packageJsonContent.type) === "module" ? 99 /* ESNext */  : 1 /* CommonJS */ ;
            return {
                impliedNodeFormat,
                packageJsonLocations,
                packageJsonScope
            };
        }
    }
    var plainJSErrors = /* @__PURE__ */ new Set([
        // binder errors
        Diagnostics.Cannot_redeclare_block_scoped_variable_0.code,
        Diagnostics.A_module_cannot_have_multiple_default_exports.code,
        Diagnostics.Another_export_default_is_here.code,
        Diagnostics.The_first_export_default_is_here.code,
        Diagnostics.Identifier_expected_0_is_a_reserved_word_at_the_top_level_of_a_module.code,
        Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode.code,
        Diagnostics.Identifier_expected_0_is_a_reserved_word_that_cannot_be_used_here.code,
        Diagnostics.constructor_is_a_reserved_word.code,
        Diagnostics.delete_cannot_be_called_on_an_identifier_in_strict_mode.code,
        Diagnostics.Code_contained_in_a_class_is_evaluated_in_JavaScript_s_strict_mode_which_does_not_allow_this_use_of_0_For_more_information_see_https_Colon_Slash_Slashdeveloper_mozilla_org_Slashen_US_Slashdocs_SlashWeb_SlashJavaScript_SlashReference_SlashStrict_mode.code,
        Diagnostics.Invalid_use_of_0_Modules_are_automatically_in_strict_mode.code,
        Diagnostics.Invalid_use_of_0_in_strict_mode.code,
        Diagnostics.A_label_is_not_allowed_here.code,
        Diagnostics.with_statements_are_not_allowed_in_strict_mode.code,
        // grammar errors
        Diagnostics.A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement.code,
        Diagnostics.A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement.code,
        Diagnostics.A_class_declaration_without_the_default_modifier_must_have_a_name.code,
        Diagnostics.A_class_member_cannot_have_the_0_keyword.code,
        Diagnostics.A_comma_expression_is_not_allowed_in_a_computed_property_name.code,
        Diagnostics.A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement.code,
        Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement.code,
        Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement.code,
        Diagnostics.A_default_clause_cannot_appear_more_than_once_in_a_switch_statement.code,
        Diagnostics.A_default_export_must_be_at_the_top_level_of_a_file_or_module_declaration.code,
        Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context.code,
        Diagnostics.A_destructuring_declaration_must_have_an_initializer.code,
        Diagnostics.A_get_accessor_cannot_have_parameters.code,
        Diagnostics.A_rest_element_cannot_contain_a_binding_pattern.code,
        Diagnostics.A_rest_element_cannot_have_a_property_name.code,
        Diagnostics.A_rest_element_cannot_have_an_initializer.code,
        Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern.code,
        Diagnostics.A_rest_parameter_cannot_have_an_initializer.code,
        Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list.code,
        Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma.code,
        Diagnostics.A_return_statement_cannot_be_used_inside_a_class_static_block.code,
        Diagnostics.A_set_accessor_cannot_have_rest_parameter.code,
        Diagnostics.A_set_accessor_must_have_exactly_one_parameter.code,
        Diagnostics.An_export_declaration_can_only_be_used_at_the_top_level_of_a_module.code,
        Diagnostics.An_export_declaration_cannot_have_modifiers.code,
        Diagnostics.An_import_declaration_can_only_be_used_at_the_top_level_of_a_module.code,
        Diagnostics.An_import_declaration_cannot_have_modifiers.code,
        Diagnostics.An_object_member_cannot_be_declared_optional.code,
        Diagnostics.Argument_of_dynamic_import_cannot_be_spread_element.code,
        Diagnostics.Cannot_assign_to_private_method_0_Private_methods_are_not_writable.code,
        Diagnostics.Cannot_redeclare_identifier_0_in_catch_clause.code,
        Diagnostics.Catch_clause_variable_cannot_have_an_initializer.code,
        Diagnostics.Class_decorators_can_t_be_used_with_static_private_identifier_Consider_removing_the_experimental_decorator.code,
        Diagnostics.Classes_can_only_extend_a_single_class.code,
        Diagnostics.Classes_may_not_have_a_field_named_constructor.code,
        Diagnostics.Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern.code,
        Diagnostics.Duplicate_label_0.code,
        Diagnostics.Dynamic_imports_can_only_accept_a_module_specifier_and_an_optional_set_of_attributes_as_arguments.code,
        Diagnostics.for_await_loops_cannot_be_used_inside_a_class_static_block.code,
        Diagnostics.JSX_attributes_must_only_be_assigned_a_non_empty_expression.code,
        Diagnostics.JSX_elements_cannot_have_multiple_attributes_with_the_same_name.code,
        Diagnostics.JSX_expressions_may_not_use_the_comma_operator_Did_you_mean_to_write_an_array.code,
        Diagnostics.JSX_property_access_expressions_cannot_include_JSX_namespace_names.code,
        Diagnostics.Jump_target_cannot_cross_function_boundary.code,
        Diagnostics.Line_terminator_not_permitted_before_arrow.code,
        Diagnostics.Modifiers_cannot_appear_here.code,
        Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement.code,
        Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement.code,
        Diagnostics.Private_identifiers_are_not_allowed_outside_class_bodies.code,
        Diagnostics.Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression.code,
        Diagnostics.Property_0_is_not_accessible_outside_class_1_because_it_has_a_private_identifier.code,
        Diagnostics.Tagged_template_expressions_are_not_permitted_in_an_optional_chain.code,
        Diagnostics.The_left_hand_side_of_a_for_of_statement_may_not_be_async.code,
        Diagnostics.The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer.code,
        Diagnostics.The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer.code,
        Diagnostics.Trailing_comma_not_allowed.code,
        Diagnostics.Variable_declaration_list_cannot_be_empty.code,
        Diagnostics._0_and_1_operations_cannot_be_mixed_without_parentheses.code,
        Diagnostics._0_expected.code,
        Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2.code,
        Diagnostics._0_list_cannot_be_empty.code,
        Diagnostics._0_modifier_already_seen.code,
        Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration.code,
        Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element.code,
        Diagnostics._0_modifier_cannot_appear_on_a_parameter.code,
        Diagnostics._0_modifier_cannot_appear_on_class_elements_of_this_kind.code,
        Diagnostics._0_modifier_cannot_be_used_here.code,
        Diagnostics._0_modifier_must_precede_1_modifier.code,
        Diagnostics._0_declarations_can_only_be_declared_inside_a_block.code,
        Diagnostics._0_declarations_must_be_initialized.code,
        Diagnostics.extends_clause_already_seen.code,
        Diagnostics.let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations.code,
        Diagnostics.Class_constructor_may_not_be_a_generator.code,
        Diagnostics.Class_constructor_may_not_be_an_accessor.code,
        Diagnostics.await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
        Diagnostics.await_using_statements_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
        Diagnostics.Private_field_0_must_be_declared_in_an_enclosing_class.code,
        // Type errors
        Diagnostics.This_condition_will_always_return_0_since_JavaScript_compares_objects_by_reference_not_value.code
    ]);
    function shouldProgramCreateNewSourceFiles(program, newOptions) {
        if (!program) return false;
        return optionsHaveChanges(program.getCompilerOptions(), newOptions, sourceFileAffectingCompilerOptions);
    }
    function createCreateProgramOptions(rootNames, options, host, oldProgram, configFileParsingDiagnostics, typeScriptVersion3) {
        return {
            rootNames,
            options,
            host,
            oldProgram,
            configFileParsingDiagnostics,
            typeScriptVersion: typeScriptVersion3
        };
    }
    function createProgram(_rootNamesOrOptions, _options, _host, _oldProgram, _configFileParsingDiagnostics) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
        let _createProgramOptions = isArray(_rootNamesOrOptions) ? createCreateProgramOptions(_rootNamesOrOptions, _options, _host, _oldProgram, _configFileParsingDiagnostics) : _rootNamesOrOptions;
        const { rootNames, options, configFileParsingDiagnostics, projectReferences, typeScriptVersion: typeScriptVersion3, host: createProgramOptionsHost } = _createProgramOptions;
        let { oldProgram } = _createProgramOptions;
        _createProgramOptions = void 0;
        _rootNamesOrOptions = void 0;
        for (const option of commandLineOptionOfCustomType)if (hasProperty(options, option.name)) {
            if (typeof options[option.name] === "string") throw new Error(`${option.name} is a string value; tsconfig JSON must be parsed with parseJsonSourceFileConfigFileContent or getParsedCommandLineOfConfigFile before passing to createProgram`);
        }
        const reportInvalidIgnoreDeprecations = memoize(()=>createOptionValueDiagnostic("ignoreDeprecations", Diagnostics.Invalid_value_for_ignoreDeprecations));
        let processingDefaultLibFiles;
        let processingOtherFiles;
        let files;
        let symlinks;
        let typeChecker;
        let classifiableNames;
        let filesWithReferencesProcessed;
        let cachedBindAndCheckDiagnosticsForFile;
        let cachedDeclarationDiagnosticsForFile;
        const programDiagnostics = createProgramDiagnostics(getCompilerOptionsObjectLiteralSyntax);
        let automaticTypeDirectiveNames;
        let automaticTypeDirectiveResolutions;
        let resolvedLibReferences;
        let resolvedLibProcessing;
        let resolvedModules;
        let resolvedModulesProcessing;
        let resolvedTypeReferenceDirectiveNames;
        let resolvedTypeReferenceDirectiveNamesProcessing;
        let packageMap;
        const maxNodeModuleJsDepth = typeof options.maxNodeModuleJsDepth === "number" ? options.maxNodeModuleJsDepth : 0;
        let currentNodeModulesDepth = 0;
        const modulesWithElidedImports = /* @__PURE__ */ new Map();
        const sourceFilesFoundSearchingNodeModules = /* @__PURE__ */ new Map();
        (_a = tracing) == null || _a.push(tracing.Phase.Program, "createProgram", {
            configFilePath: options.configFilePath,
            rootDir: options.rootDir
        }, /*separateBeginAndEnd*/ true);
        mark("beforeProgram");
        const host = createProgramOptionsHost || createCompilerHost(options);
        const configParsingHost = parseConfigHostFromCompilerHostLike(host);
        let skipDefaultLib = options.noLib;
        const getDefaultLibraryFileName = memoize(()=>host.getDefaultLibFileName(options));
        const defaultLibraryPath = host.getDefaultLibLocation ? host.getDefaultLibLocation() : getDirectoryPath(getDefaultLibraryFileName());
        let skipVerifyCompilerOptions = false;
        const currentDirectory = host.getCurrentDirectory();
        const supportedExtensions = getSupportedExtensions(options);
        const supportedExtensionsWithJsonIfResolveJsonModule = getSupportedExtensionsWithJsonIfResolveJsonModule(options, supportedExtensions);
        const hasEmitBlockingDiagnostics = /* @__PURE__ */ new Map();
        let _compilerOptionsObjectLiteralSyntax;
        let _compilerOptionsPropertySyntax;
        let moduleResolutionCache;
        let actualResolveModuleNamesWorker;
        const hasInvalidatedResolutions = host.hasInvalidatedResolutions || returnFalse;
        if (host.resolveModuleNameLiterals) {
            actualResolveModuleNamesWorker = host.resolveModuleNameLiterals.bind(host);
            moduleResolutionCache = (_b = host.getModuleResolutionCache) == null ? void 0 : _b.call(host);
        } else if (host.resolveModuleNames) {
            actualResolveModuleNamesWorker = (moduleNames, containingFile, redirectedReference, options2, containingSourceFile, reusedNames)=>host.resolveModuleNames(moduleNames.map(getModuleResolutionName), containingFile, reusedNames == null ? void 0 : reusedNames.map(getModuleResolutionName), redirectedReference, options2, containingSourceFile).map((resolved)=>resolved ? resolved.extension !== void 0 ? {
                        resolvedModule: resolved
                    } : // An older host may have omitted extension, in which case we should infer it from the file extension of resolvedFileName.
                    {
                        resolvedModule: (0, _objectSpreadProps._)((0, _objectSpread._)({}, resolved), {
                            extension: extensionFromPath(resolved.resolvedFileName)
                        })
                    } : emptyResolution);
            moduleResolutionCache = (_c = host.getModuleResolutionCache) == null ? void 0 : _c.call(host);
        } else {
            moduleResolutionCache = createModuleResolutionCache(currentDirectory, getCanonicalFileName, options);
            actualResolveModuleNamesWorker = (moduleNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(moduleNames, containingFile, redirectedReference, options2, containingSourceFile, host, moduleResolutionCache, createModuleResolutionLoader);
        }
        let actualResolveTypeReferenceDirectiveNamesWorker;
        if (host.resolveTypeReferenceDirectiveReferences) actualResolveTypeReferenceDirectiveNamesWorker = host.resolveTypeReferenceDirectiveReferences.bind(host);
        else if (host.resolveTypeReferenceDirectives) actualResolveTypeReferenceDirectiveNamesWorker = (typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile)=>host.resolveTypeReferenceDirectives(typeDirectiveNames.map(getTypeReferenceResolutionName), containingFile, redirectedReference, options2, containingSourceFile == null ? void 0 : containingSourceFile.impliedNodeFormat).map((resolvedTypeReferenceDirective)=>({
                    resolvedTypeReferenceDirective
                }));
        else {
            const typeReferenceDirectiveResolutionCache = createTypeReferenceDirectiveResolutionCache(currentDirectory, getCanonicalFileName, /*options*/ void 0, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache(), moduleResolutionCache == null ? void 0 : moduleResolutionCache.optionsToRedirectsKey);
            actualResolveTypeReferenceDirectiveNamesWorker = (typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile, host, typeReferenceDirectiveResolutionCache, createTypeReferenceResolutionLoader);
        }
        const hasInvalidatedLibResolutions = host.hasInvalidatedLibResolutions || returnFalse;
        let actualResolveLibrary;
        if (host.resolveLibrary) actualResolveLibrary = host.resolveLibrary.bind(host);
        else {
            const libraryResolutionCache = createModuleResolutionCache(currentDirectory, getCanonicalFileName, options, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache());
            actualResolveLibrary = (libraryName, resolveFrom, options2)=>resolveLibrary(libraryName, resolveFrom, options2, host, libraryResolutionCache);
        }
        const packageIdToSourceFile = /* @__PURE__ */ new Map();
        let sourceFileToPackageName = /* @__PURE__ */ new Map();
        let redirectTargetsMap = createMultiMap();
        let usesUriStyleNodeCoreModules;
        const filesByName = /* @__PURE__ */ new Map();
        let missingFileNames = /* @__PURE__ */ new Map();
        const filesByNameIgnoreCase = host.useCaseSensitiveFileNames() ? /* @__PURE__ */ new Map() : void 0;
        let resolvedProjectReferences;
        let projectReferenceRedirects;
        let mapSourceFileToResolvedRef;
        let mapOutputFileToResolvedRef;
        const useSourceOfProjectReferenceRedirect = !!((_d = host.useSourceOfProjectReferenceRedirect) == null ? void 0 : _d.call(host)) && !options.disableSourceOfProjectReferenceRedirect;
        const { onProgramCreateComplete, fileExists, directoryExists } = updateHostForUseSourceOfProjectReferenceRedirect({
            compilerHost: host,
            getSymlinkCache,
            useSourceOfProjectReferenceRedirect,
            toPath: toPath3,
            getResolvedProjectReferences,
            getRedirectFromOutput,
            forEachResolvedProjectReference: forEachResolvedProjectReference2
        });
        const readFile = host.readFile.bind(host);
        (_e = tracing) == null || _e.push(tracing.Phase.Program, "shouldProgramCreateNewSourceFiles", {
            hasOldProgram: !!oldProgram
        });
        const shouldCreateNewSourceFile = shouldProgramCreateNewSourceFiles(oldProgram, options);
        (_f = tracing) == null || _f.pop();
        let structureIsReused;
        (_g = tracing) == null || _g.push(tracing.Phase.Program, "tryReuseStructureFromOldProgram", {});
        structureIsReused = tryReuseStructureFromOldProgram();
        (_h = tracing) == null || _h.pop();
        if (structureIsReused !== 2 /* Completely */ ) {
            processingDefaultLibFiles = [];
            processingOtherFiles = [];
            if (projectReferences) {
                if (!resolvedProjectReferences) resolvedProjectReferences = projectReferences.map(parseProjectReferenceConfigFile);
                if (rootNames.length) resolvedProjectReferences == null || resolvedProjectReferences.forEach((parsedRef, index)=>{
                    if (!parsedRef) return;
                    const out = parsedRef.commandLine.options.outFile;
                    if (useSourceOfProjectReferenceRedirect) {
                        if (out || getEmitModuleKind(parsedRef.commandLine.options) === 0 /* None */ ) for (const fileName of parsedRef.commandLine.fileNames)processProjectReferenceFile(fileName, {
                            kind: 1 /* SourceFromProjectReference */ ,
                            index
                        });
                    } else {
                        if (out) processProjectReferenceFile(changeExtension(out, ".d.ts"), {
                            kind: 2 /* OutputFromProjectReference */ ,
                            index
                        });
                        else if (getEmitModuleKind(parsedRef.commandLine.options) === 0 /* None */ ) {
                            const getCommonSourceDirectory3 = memoize(()=>getCommonSourceDirectoryOfConfig(parsedRef.commandLine, !host.useCaseSensitiveFileNames()));
                            for (const fileName of parsedRef.commandLine.fileNames)if (!isDeclarationFileName(fileName) && !fileExtensionIs(fileName, ".json" /* Json */ )) processProjectReferenceFile(getOutputDeclarationFileName(fileName, parsedRef.commandLine, !host.useCaseSensitiveFileNames(), getCommonSourceDirectory3), {
                                kind: 2 /* OutputFromProjectReference */ ,
                                index
                            });
                        }
                    }
                });
            }
            (_i = tracing) == null || _i.push(tracing.Phase.Program, "processRootFiles", {
                count: rootNames.length
            });
            forEach(rootNames, (name, index)=>processRootFile(name, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, {
                    kind: 0 /* RootFile */ ,
                    index
                }));
            (_j = tracing) == null || _j.pop();
            automaticTypeDirectiveNames !== null && automaticTypeDirectiveNames !== void 0 ? automaticTypeDirectiveNames : automaticTypeDirectiveNames = rootNames.length ? getAutomaticTypeDirectiveNames(options, host) : emptyArray;
            automaticTypeDirectiveResolutions = createModeAwareCache();
            if (automaticTypeDirectiveNames.length) {
                (_k = tracing) == null || _k.push(tracing.Phase.Program, "processTypeReferences", {
                    count: automaticTypeDirectiveNames.length
                });
                const containingDirectory = options.configFilePath ? getDirectoryPath(options.configFilePath) : currentDirectory;
                const containingFilename = combinePaths(containingDirectory, inferredTypesContainingFile);
                const resolutions = resolveTypeReferenceDirectiveNamesReusingOldState(automaticTypeDirectiveNames, containingFilename);
                for(let i = 0; i < automaticTypeDirectiveNames.length; i++){
                    automaticTypeDirectiveResolutions.set(automaticTypeDirectiveNames[i], /*mode*/ void 0, resolutions[i]);
                    processTypeReferenceDirective(automaticTypeDirectiveNames[i], /*mode*/ void 0, resolutions[i], {
                        kind: 8 /* AutomaticTypeDirectiveFile */ ,
                        typeReference: automaticTypeDirectiveNames[i],
                        packageId: (_m = (_l = resolutions[i]) == null ? void 0 : _l.resolvedTypeReferenceDirective) == null ? void 0 : _m.packageId
                    });
                }
                (_n = tracing) == null || _n.pop();
            }
            if (rootNames.length && !skipDefaultLib) {
                const defaultLibraryFileName = getDefaultLibraryFileName();
                if (!options.lib && defaultLibraryFileName) processRootFile(defaultLibraryFileName, /*isDefaultLib*/ true, /*ignoreNoDefaultLib*/ false, {
                    kind: 6 /* LibFile */ 
                });
                else forEach(options.lib, (libFileName, index)=>{
                    processRootFile(pathForLibFile(libFileName), /*isDefaultLib*/ true, /*ignoreNoDefaultLib*/ false, {
                        kind: 6 /* LibFile */ ,
                        index
                    });
                });
            }
            files = toSorted(processingDefaultLibFiles, compareDefaultLibFiles).concat(processingOtherFiles);
            processingDefaultLibFiles = void 0;
            processingOtherFiles = void 0;
            filesWithReferencesProcessed = void 0;
        }
        if (oldProgram && host.onReleaseOldSourceFile) {
            const oldSourceFiles = oldProgram.getSourceFiles();
            for (const oldSourceFile of oldSourceFiles){
                const newFile = getSourceFileByPath(oldSourceFile.resolvedPath);
                if (shouldCreateNewSourceFile || !newFile || newFile.impliedNodeFormat !== oldSourceFile.impliedNodeFormat || // old file wasn't redirect but new file is
                oldSourceFile.resolvedPath === oldSourceFile.path && newFile.resolvedPath !== oldSourceFile.path) host.onReleaseOldSourceFile(oldSourceFile, oldProgram.getCompilerOptions(), !!getSourceFileByPath(oldSourceFile.path), newFile);
            }
            if (!host.getParsedCommandLine) oldProgram.forEachResolvedProjectReference((resolvedProjectReference)=>{
                if (!getResolvedProjectReferenceByPath(resolvedProjectReference.sourceFile.path)) host.onReleaseOldSourceFile(resolvedProjectReference.sourceFile, oldProgram.getCompilerOptions(), /*hasSourceFileByPath*/ false, /*newSourceFileByResolvedPath*/ void 0);
            });
        }
        if (oldProgram && host.onReleaseParsedCommandLine) forEachProjectReference(oldProgram.getProjectReferences(), oldProgram.getResolvedProjectReferences(), (oldResolvedRef, parent2, index)=>{
            const oldReference = (parent2 == null ? void 0 : parent2.commandLine.projectReferences[index]) || oldProgram.getProjectReferences()[index];
            const oldRefPath = resolveProjectReferencePath(oldReference);
            if (!(projectReferenceRedirects == null ? void 0 : projectReferenceRedirects.has(toPath3(oldRefPath)))) host.onReleaseParsedCommandLine(oldRefPath, oldResolvedRef, oldProgram.getCompilerOptions());
        });
        oldProgram = void 0;
        resolvedLibProcessing = void 0;
        resolvedModulesProcessing = void 0;
        resolvedTypeReferenceDirectiveNamesProcessing = void 0;
        const program = {
            getRootFileNames: ()=>rootNames,
            getSourceFile,
            getSourceFileByPath,
            getSourceFiles: ()=>files,
            getMissingFilePaths: ()=>missingFileNames,
            getModuleResolutionCache: ()=>moduleResolutionCache,
            getFilesByNameMap: ()=>filesByName,
            getCompilerOptions: ()=>options,
            getSyntacticDiagnostics,
            getOptionsDiagnostics,
            getGlobalDiagnostics,
            getSemanticDiagnostics,
            getCachedSemanticDiagnostics,
            getSuggestionDiagnostics,
            getDeclarationDiagnostics: getDeclarationDiagnostics2,
            getBindAndCheckDiagnostics,
            getProgramDiagnostics,
            getTypeChecker,
            getClassifiableNames,
            getCommonSourceDirectory: getCommonSourceDirectory2,
            emit,
            getCurrentDirectory: ()=>currentDirectory,
            getNodeCount: ()=>getTypeChecker().getNodeCount(),
            getIdentifierCount: ()=>getTypeChecker().getIdentifierCount(),
            getSymbolCount: ()=>getTypeChecker().getSymbolCount(),
            getTypeCount: ()=>getTypeChecker().getTypeCount(),
            getInstantiationCount: ()=>getTypeChecker().getInstantiationCount(),
            getRelationCacheSizes: ()=>getTypeChecker().getRelationCacheSizes(),
            getFileProcessingDiagnostics: ()=>programDiagnostics.getFileProcessingDiagnostics(),
            getAutomaticTypeDirectiveNames: ()=>automaticTypeDirectiveNames,
            getAutomaticTypeDirectiveResolutions: ()=>automaticTypeDirectiveResolutions,
            isSourceFileFromExternalLibrary,
            isSourceFileDefaultLibrary,
            getModeForUsageLocation: getModeForUsageLocation2,
            getEmitSyntaxForUsageLocation,
            getModeForResolutionAtIndex: getModeForResolutionAtIndex2,
            getSourceFileFromReference,
            getLibFileFromReference,
            sourceFileToPackageName,
            redirectTargetsMap,
            usesUriStyleNodeCoreModules,
            resolvedModules,
            resolvedTypeReferenceDirectiveNames,
            resolvedLibReferences,
            getProgramDiagnosticsContainer: ()=>programDiagnostics,
            getResolvedModule,
            getResolvedModuleFromModuleSpecifier,
            getResolvedTypeReferenceDirective,
            getResolvedTypeReferenceDirectiveFromTypeReferenceDirective,
            forEachResolvedModule,
            forEachResolvedTypeReferenceDirective,
            getCurrentPackagesMap: ()=>packageMap,
            typesPackageExists,
            packageBundlesTypes,
            isEmittedFile,
            getConfigFileParsingDiagnostics: getConfigFileParsingDiagnostics2,
            getProjectReferences,
            getResolvedProjectReferences,
            getRedirectFromSourceFile,
            getResolvedProjectReferenceByPath,
            forEachResolvedProjectReference: forEachResolvedProjectReference2,
            isSourceOfProjectReferenceRedirect,
            getRedirectFromOutput,
            getCompilerOptionsForFile,
            getDefaultResolutionModeForFile: getDefaultResolutionModeForFile2,
            getEmitModuleFormatOfFile: getEmitModuleFormatOfFile2,
            getImpliedNodeFormatForEmit: getImpliedNodeFormatForEmit2,
            shouldTransformImportCall,
            emitBuildInfo,
            fileExists,
            readFile,
            directoryExists,
            getSymlinkCache,
            realpath: (_o = host.realpath) == null ? void 0 : _o.bind(host),
            useCaseSensitiveFileNames: ()=>host.useCaseSensitiveFileNames(),
            getCanonicalFileName,
            getFileIncludeReasons: ()=>programDiagnostics.getFileReasons(),
            structureIsReused,
            writeFile: writeFile2,
            getGlobalTypingsCacheLocation: maybeBind(host, host.getGlobalTypingsCacheLocation)
        };
        onProgramCreateComplete();
        if (!skipVerifyCompilerOptions) verifyCompilerOptions();
        mark("afterProgram");
        measure("Program", "beforeProgram", "afterProgram");
        (_p = tracing) == null || _p.pop();
        return program;
        function getResolvedModule(file, moduleName, mode) {
            var _a2;
            return (_a2 = resolvedModules == null ? void 0 : resolvedModules.get(file.path)) == null ? void 0 : _a2.get(moduleName, mode);
        }
        function getResolvedModuleFromModuleSpecifier(moduleSpecifier, sourceFile) {
            sourceFile !== null && sourceFile !== void 0 ? sourceFile : sourceFile = getSourceFileOfNode(moduleSpecifier);
            Debug.assertIsDefined(sourceFile, "`moduleSpecifier` must have a `SourceFile` ancestor. Use `program.getResolvedModule` instead to provide the containing file and resolution mode.");
            return getResolvedModule(sourceFile, moduleSpecifier.text, getModeForUsageLocation2(sourceFile, moduleSpecifier));
        }
        function getResolvedTypeReferenceDirective(file, typeDirectiveName, mode) {
            var _a2;
            return (_a2 = resolvedTypeReferenceDirectiveNames == null ? void 0 : resolvedTypeReferenceDirectiveNames.get(file.path)) == null ? void 0 : _a2.get(typeDirectiveName, mode);
        }
        function getResolvedTypeReferenceDirectiveFromTypeReferenceDirective(typeRef, sourceFile) {
            return getResolvedTypeReferenceDirective(sourceFile, typeRef.fileName, getModeForTypeReferenceDirectiveInFile(typeRef, sourceFile));
        }
        function forEachResolvedModule(callback, file) {
            forEachResolution(resolvedModules, callback, file);
        }
        function forEachResolvedTypeReferenceDirective(callback, file) {
            forEachResolution(resolvedTypeReferenceDirectiveNames, callback, file);
        }
        function forEachResolution(resolutionCache, callback, file) {
            var _a2;
            if (file) (_a2 = resolutionCache == null ? void 0 : resolutionCache.get(file.path)) == null || _a2.forEach((resolution, name, mode)=>callback(resolution, name, mode, file.path));
            else resolutionCache == null || resolutionCache.forEach((resolutions, filePath)=>resolutions.forEach((resolution, name, mode)=>callback(resolution, name, mode, filePath)));
        }
        function getPackagesMap() {
            if (packageMap) return packageMap;
            packageMap = /* @__PURE__ */ new Map();
            forEachResolvedModule(({ resolvedModule })=>{
                if (resolvedModule == null ? void 0 : resolvedModule.packageId) packageMap.set(resolvedModule.packageId.name, resolvedModule.extension === ".d.ts" /* Dts */  || !!packageMap.get(resolvedModule.packageId.name));
            });
            return packageMap;
        }
        function typesPackageExists(packageName) {
            return getPackagesMap().has(getTypesPackageName(packageName));
        }
        function packageBundlesTypes(packageName) {
            return !!getPackagesMap().get(packageName);
        }
        function addResolutionDiagnostics(resolution) {
            var _a2;
            if (!((_a2 = resolution.resolutionDiagnostics) == null ? void 0 : _a2.length)) return;
            programDiagnostics.addFileProcessingDiagnostic({
                kind: 2 /* ResolutionDiagnostics */ ,
                diagnostics: resolution.resolutionDiagnostics
            });
        }
        function addResolutionDiagnosticsFromResolutionOrCache(containingFile, name, resolution, mode) {
            if (host.resolveModuleNameLiterals || !host.resolveModuleNames) return addResolutionDiagnostics(resolution);
            if (!moduleResolutionCache || isExternalModuleNameRelative(name)) return;
            const containingFileName = getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory);
            const containingDir = getDirectoryPath(containingFileName);
            const redirectedReference = getRedirectReferenceForResolution(containingFile);
            const fromCache = moduleResolutionCache.getFromNonRelativeNameCache(name, mode, containingDir, redirectedReference);
            if (fromCache) addResolutionDiagnostics(fromCache);
        }
        function resolveModuleNamesWorker(moduleNames, containingFile, reusedNames) {
            var _a2, _b2;
            const containingFileName = getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory);
            const redirectedReference = getRedirectReferenceForResolution(containingFile);
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "resolveModuleNamesWorker", {
                containingFileName
            });
            mark("beforeResolveModule");
            const result = actualResolveModuleNamesWorker(moduleNames, containingFileName, redirectedReference, options, containingFile, reusedNames);
            mark("afterResolveModule");
            measure("ResolveModule", "beforeResolveModule", "afterResolveModule");
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function resolveTypeReferenceDirectiveNamesWorker(typeDirectiveNames, containingFile, reusedNames) {
            var _a2, _b2;
            const containingSourceFile = !isString(containingFile) ? containingFile : void 0;
            const containingFileName = !isString(containingFile) ? getNormalizedAbsolutePath(containingFile.originalFileName, currentDirectory) : containingFile;
            const redirectedReference = containingSourceFile && getRedirectReferenceForResolution(containingSourceFile);
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "resolveTypeReferenceDirectiveNamesWorker", {
                containingFileName
            });
            mark("beforeResolveTypeReference");
            const result = actualResolveTypeReferenceDirectiveNamesWorker(typeDirectiveNames, containingFileName, redirectedReference, options, containingSourceFile, reusedNames);
            mark("afterResolveTypeReference");
            measure("ResolveTypeReference", "beforeResolveTypeReference", "afterResolveTypeReference");
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function getRedirectReferenceForResolution(file) {
            var _a2, _b2;
            const redirect = getRedirectFromSourceFile(file.originalFileName);
            if (redirect || !isDeclarationFileName(file.originalFileName)) return redirect == null ? void 0 : redirect.resolvedRef;
            const resultFromDts = (_a2 = getRedirectFromOutput(file.path)) == null ? void 0 : _a2.resolvedRef;
            if (resultFromDts) return resultFromDts;
            if (!host.realpath || !options.preserveSymlinks || !file.originalFileName.includes(nodeModulesPathPart)) return void 0;
            const realDeclarationPath = toPath3(host.realpath(file.originalFileName));
            return realDeclarationPath === file.path ? void 0 : (_b2 = getRedirectFromOutput(realDeclarationPath)) == null ? void 0 : _b2.resolvedRef;
        }
        function compareDefaultLibFiles(a, b) {
            return compareValues(getDefaultLibFilePriority(a), getDefaultLibFilePriority(b));
        }
        function getDefaultLibFilePriority(a) {
            if (containsPath(defaultLibraryPath, a.fileName, /*ignoreCase*/ false)) {
                const basename = getBaseFileName(a.fileName);
                if (basename === "lib.d.ts" || basename === "lib.es6.d.ts") return 0;
                const name = removeSuffix(removePrefix(basename, "lib."), ".d.ts");
                const index = libs.indexOf(name);
                if (index !== -1) return index + 1;
            }
            return libs.length + 2;
        }
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function getCommonSourceDirectory2() {
            let commonSourceDirectory = programDiagnostics.getCommonSourceDirectory();
            if (commonSourceDirectory !== void 0) return commonSourceDirectory;
            const emittedFiles = filter(files, (file)=>sourceFileMayBeEmitted(file, program));
            commonSourceDirectory = getCommonSourceDirectory(options, ()=>mapDefined(emittedFiles, (file)=>file.isDeclarationFile ? void 0 : file.fileName), currentDirectory, getCanonicalFileName, (commonSourceDirectory2)=>checkSourceFilesBelongToPath(emittedFiles, commonSourceDirectory2));
            programDiagnostics.setCommonSourceDirectory(commonSourceDirectory);
            return commonSourceDirectory;
        }
        function getClassifiableNames() {
            var _a2;
            if (!classifiableNames) {
                getTypeChecker();
                classifiableNames = /* @__PURE__ */ new Set();
                for (const sourceFile of files)(_a2 = sourceFile.classifiableNames) == null || _a2.forEach((value1)=>classifiableNames.add(value1));
            }
            return classifiableNames;
        }
        function resolveModuleNamesReusingOldState(moduleNames, containingFile) {
            return resolveNamesReusingOldState({
                entries: moduleNames,
                containingFile,
                containingSourceFile: containingFile,
                redirectedReference: getRedirectReferenceForResolution(containingFile),
                nameAndModeGetter: moduleResolutionNameAndModeGetter,
                resolutionWorker: resolveModuleNamesWorker,
                getResolutionFromOldProgram: (name, mode)=>oldProgram == null ? void 0 : oldProgram.getResolvedModule(containingFile, name, mode),
                getResolved: getResolvedModuleFromResolution,
                canReuseResolutionsInFile: ()=>containingFile === (oldProgram == null ? void 0 : oldProgram.getSourceFile(containingFile.fileName)) && !hasInvalidatedResolutions(containingFile.path),
                resolveToOwnAmbientModule: true
            });
        }
        function resolveTypeReferenceDirectiveNamesReusingOldState(typeDirectiveNames, containingFile) {
            const containingSourceFile = !isString(containingFile) ? containingFile : void 0;
            return resolveNamesReusingOldState({
                entries: typeDirectiveNames,
                containingFile,
                containingSourceFile,
                redirectedReference: containingSourceFile && getRedirectReferenceForResolution(containingSourceFile),
                nameAndModeGetter: typeReferenceResolutionNameAndModeGetter,
                resolutionWorker: resolveTypeReferenceDirectiveNamesWorker,
                getResolutionFromOldProgram: (name, mode)=>{
                    var _a2;
                    return containingSourceFile ? oldProgram == null ? void 0 : oldProgram.getResolvedTypeReferenceDirective(containingSourceFile, name, mode) : (_a2 = oldProgram == null ? void 0 : oldProgram.getAutomaticTypeDirectiveResolutions()) == null ? void 0 : _a2.get(name, mode);
                },
                getResolved: getResolvedTypeReferenceDirectiveFromResolution,
                canReuseResolutionsInFile: ()=>containingSourceFile ? containingSourceFile === (oldProgram == null ? void 0 : oldProgram.getSourceFile(containingSourceFile.fileName)) && !hasInvalidatedResolutions(containingSourceFile.path) : !hasInvalidatedResolutions(toPath3(containingFile))
            });
        }
        function resolveNamesReusingOldState({ entries, containingFile, containingSourceFile, redirectedReference, nameAndModeGetter, resolutionWorker, getResolutionFromOldProgram, getResolved, canReuseResolutionsInFile, resolveToOwnAmbientModule }) {
            if (!entries.length) return emptyArray;
            if (structureIsReused === 0 /* Not */  && (!resolveToOwnAmbientModule || !containingSourceFile.ambientModuleNames.length)) return resolutionWorker(entries, containingFile, /*reusedNames*/ void 0);
            let unknownEntries;
            let unknownEntryIndices;
            let result;
            let reusedNames;
            const reuseResolutions = canReuseResolutionsInFile();
            for(let i = 0; i < entries.length; i++){
                const entry = entries[i];
                if (reuseResolutions) {
                    const name = nameAndModeGetter.getName(entry);
                    var _ref;
                    const mode = nameAndModeGetter.getMode(entry, containingSourceFile, (_ref = redirectedReference == null ? void 0 : redirectedReference.commandLine.options) !== null && _ref !== void 0 ? _ref : options);
                    const oldResolution = getResolutionFromOldProgram(name, mode);
                    const oldResolved = oldResolution && getResolved(oldResolution);
                    if (oldResolved) {
                        if (isTraceEnabled(options, host)) trace(host, resolutionWorker === resolveModuleNamesWorker ? oldResolved.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : oldResolved.packageId ? Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2, name, containingSourceFile ? getNormalizedAbsolutePath(containingSourceFile.originalFileName, currentDirectory) : containingFile, oldResolved.resolvedFileName, oldResolved.packageId && packageIdToString(oldResolved.packageId));
                        (result !== null && result !== void 0 ? result : result = new Array(entries.length))[i] = oldResolution;
                        (reusedNames !== null && reusedNames !== void 0 ? reusedNames : reusedNames = []).push(entry);
                        continue;
                    }
                }
                if (resolveToOwnAmbientModule) {
                    const name = nameAndModeGetter.getName(entry);
                    if (contains(containingSourceFile.ambientModuleNames, name)) {
                        if (isTraceEnabled(options, host)) trace(host, Diagnostics.Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1, name, getNormalizedAbsolutePath(containingSourceFile.originalFileName, currentDirectory));
                        (result !== null && result !== void 0 ? result : result = new Array(entries.length))[i] = emptyResolution;
                        continue;
                    }
                }
                (unknownEntries !== null && unknownEntries !== void 0 ? unknownEntries : unknownEntries = []).push(entry);
                (unknownEntryIndices !== null && unknownEntryIndices !== void 0 ? unknownEntryIndices : unknownEntryIndices = []).push(i);
            }
            if (!unknownEntries) return result;
            const resolutions = resolutionWorker(unknownEntries, containingFile, reusedNames);
            if (!result) return resolutions;
            resolutions.forEach((resolution, index)=>result[unknownEntryIndices[index]] = resolution);
            return result;
        }
        function canReuseProjectReferences() {
            return !forEachProjectReference(oldProgram.getProjectReferences(), oldProgram.getResolvedProjectReferences(), (oldResolvedRef, parent2, index)=>{
                const newRef = (parent2 ? parent2.commandLine.projectReferences : projectReferences)[index];
                const newResolvedRef = parseProjectReferenceConfigFile(newRef);
                if (oldResolvedRef) return !newResolvedRef || newResolvedRef.sourceFile !== oldResolvedRef.sourceFile || !arrayIsEqualTo(oldResolvedRef.commandLine.fileNames, newResolvedRef.commandLine.fileNames);
                else return newResolvedRef !== void 0;
            }, (oldProjectReferences, parent2)=>{
                const newReferences = parent2 ? getResolvedProjectReferenceByPath(parent2.sourceFile.path).commandLine.projectReferences : projectReferences;
                return !arrayIsEqualTo(oldProjectReferences, newReferences, projectReferenceIsEqualTo);
            });
        }
        function tryReuseStructureFromOldProgram() {
            var _a2;
            if (!oldProgram) return 0 /* Not */ ;
            const oldOptions = oldProgram.getCompilerOptions();
            if (changesAffectModuleResolution(oldOptions, options)) return 0 /* Not */ ;
            const oldRootNames = oldProgram.getRootFileNames();
            if (!arrayIsEqualTo(oldRootNames, rootNames)) return 0 /* Not */ ;
            if (!canReuseProjectReferences()) return 0 /* Not */ ;
            if (projectReferences) resolvedProjectReferences = projectReferences.map(parseProjectReferenceConfigFile);
            const newSourceFiles = [];
            const modifiedSourceFiles = [];
            structureIsReused = 2 /* Completely */ ;
            if (forEachEntry(oldProgram.getMissingFilePaths(), (missingFileName)=>host.fileExists(missingFileName))) return 0 /* Not */ ;
            const oldSourceFiles = oldProgram.getSourceFiles();
            let SeenPackageName;
            ((SeenPackageName2)=>{
                SeenPackageName2[SeenPackageName2["Exists"] = 0] = "Exists";
                SeenPackageName2[SeenPackageName2["Modified"] = 1] = "Modified";
            })(SeenPackageName || (SeenPackageName = {}));
            const seenPackageNames = /* @__PURE__ */ new Map();
            for (const oldSourceFile of oldSourceFiles){
                const sourceFileOptions = getCreateSourceFileOptions(oldSourceFile.fileName, moduleResolutionCache, host, options);
                let newSourceFile = host.getSourceFileByPath ? host.getSourceFileByPath(oldSourceFile.fileName, oldSourceFile.resolvedPath, sourceFileOptions, /*onError*/ void 0, shouldCreateNewSourceFile) : host.getSourceFile(oldSourceFile.fileName, sourceFileOptions, /*onError*/ void 0, shouldCreateNewSourceFile);
                if (!newSourceFile) return 0 /* Not */ ;
                newSourceFile.packageJsonLocations = ((_a2 = sourceFileOptions.packageJsonLocations) == null ? void 0 : _a2.length) ? sourceFileOptions.packageJsonLocations : void 0;
                newSourceFile.packageJsonScope = sourceFileOptions.packageJsonScope;
                Debug.assert(!newSourceFile.redirectInfo, "Host should not return a redirect source file from `getSourceFile`");
                let fileChanged;
                if (oldSourceFile.redirectInfo) {
                    if (newSourceFile !== oldSourceFile.redirectInfo.unredirected) return 0 /* Not */ ;
                    fileChanged = false;
                    newSourceFile = oldSourceFile;
                } else if (oldProgram.redirectTargetsMap.has(oldSourceFile.path)) {
                    if (newSourceFile !== oldSourceFile) return 0 /* Not */ ;
                    fileChanged = false;
                } else fileChanged = newSourceFile !== oldSourceFile;
                newSourceFile.path = oldSourceFile.path;
                newSourceFile.originalFileName = oldSourceFile.originalFileName;
                newSourceFile.resolvedPath = oldSourceFile.resolvedPath;
                newSourceFile.fileName = oldSourceFile.fileName;
                const packageName = oldProgram.sourceFileToPackageName.get(oldSourceFile.path);
                if (packageName !== void 0) {
                    const prevKind = seenPackageNames.get(packageName);
                    const newKind = fileChanged ? 1 /* Modified */  : 0 /* Exists */ ;
                    if (prevKind !== void 0 && newKind === 1 /* Modified */  || prevKind === 1 /* Modified */ ) return 0 /* Not */ ;
                    seenPackageNames.set(packageName, newKind);
                }
                if (fileChanged) {
                    if (oldSourceFile.impliedNodeFormat !== newSourceFile.impliedNodeFormat) structureIsReused = 1 /* SafeModules */ ;
                    else if (!arrayIsEqualTo(oldSourceFile.libReferenceDirectives, newSourceFile.libReferenceDirectives, fileReferenceIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                    else if (oldSourceFile.hasNoDefaultLib !== newSourceFile.hasNoDefaultLib) structureIsReused = 1 /* SafeModules */ ;
                    else if (!arrayIsEqualTo(oldSourceFile.referencedFiles, newSourceFile.referencedFiles, fileReferenceIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                    else {
                        collectExternalModuleReferences(newSourceFile);
                        if (!arrayIsEqualTo(oldSourceFile.imports, newSourceFile.imports, moduleNameIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                        else if (!arrayIsEqualTo(oldSourceFile.moduleAugmentations, newSourceFile.moduleAugmentations, moduleNameIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                        else if ((oldSourceFile.flags & 12582912 /* PermanentlySetIncrementalFlags */ ) !== (newSourceFile.flags & 12582912 /* PermanentlySetIncrementalFlags */ )) structureIsReused = 1 /* SafeModules */ ;
                        else if (!arrayIsEqualTo(oldSourceFile.typeReferenceDirectives, newSourceFile.typeReferenceDirectives, fileReferenceIsEqualTo)) structureIsReused = 1 /* SafeModules */ ;
                    }
                    modifiedSourceFiles.push(newSourceFile);
                } else if (hasInvalidatedResolutions(oldSourceFile.path)) {
                    structureIsReused = 1 /* SafeModules */ ;
                    modifiedSourceFiles.push(newSourceFile);
                }
                newSourceFiles.push(newSourceFile);
            }
            if (structureIsReused !== 2 /* Completely */ ) return structureIsReused;
            for (const newSourceFile of modifiedSourceFiles){
                const moduleNames = getModuleNames(newSourceFile);
                const resolutions = resolveModuleNamesReusingOldState(moduleNames, newSourceFile);
                (resolvedModulesProcessing !== null && resolvedModulesProcessing !== void 0 ? resolvedModulesProcessing : resolvedModulesProcessing = /* @__PURE__ */ new Map()).set(newSourceFile.path, resolutions);
                const optionsForFile = getCompilerOptionsForFile(newSourceFile);
                const resolutionsChanged = hasChangesInResolutions(moduleNames, resolutions, (name)=>oldProgram.getResolvedModule(newSourceFile, name.text, getModeForUsageLocationWorker(newSourceFile, name, optionsForFile)), moduleResolutionIsEqualTo);
                if (resolutionsChanged) structureIsReused = 1 /* SafeModules */ ;
                const typesReferenceDirectives = newSourceFile.typeReferenceDirectives;
                const typeReferenceResolutions = resolveTypeReferenceDirectiveNamesReusingOldState(typesReferenceDirectives, newSourceFile);
                (resolvedTypeReferenceDirectiveNamesProcessing !== null && resolvedTypeReferenceDirectiveNamesProcessing !== void 0 ? resolvedTypeReferenceDirectiveNamesProcessing : resolvedTypeReferenceDirectiveNamesProcessing = /* @__PURE__ */ new Map()).set(newSourceFile.path, typeReferenceResolutions);
                const typeReferenceResolutionsChanged = hasChangesInResolutions(typesReferenceDirectives, typeReferenceResolutions, (name)=>oldProgram.getResolvedTypeReferenceDirective(newSourceFile, getTypeReferenceResolutionName(name), getModeForTypeReferenceDirectiveInFile(name, newSourceFile)), typeDirectiveIsEqualTo);
                if (typeReferenceResolutionsChanged) structureIsReused = 1 /* SafeModules */ ;
            }
            if (structureIsReused !== 2 /* Completely */ ) return structureIsReused;
            if (changesAffectingProgramStructure(oldOptions, options)) return 1 /* SafeModules */ ;
            if (oldProgram.resolvedLibReferences && forEachEntry(oldProgram.resolvedLibReferences, (resolution, libFileName)=>pathForLibFileWorker(libFileName).actual !== resolution.actual)) return 1 /* SafeModules */ ;
            if (host.hasChangedAutomaticTypeDirectiveNames) {
                if (host.hasChangedAutomaticTypeDirectiveNames()) return 1 /* SafeModules */ ;
            } else {
                automaticTypeDirectiveNames = getAutomaticTypeDirectiveNames(options, host);
                if (!arrayIsEqualTo(oldProgram.getAutomaticTypeDirectiveNames(), automaticTypeDirectiveNames)) return 1 /* SafeModules */ ;
            }
            missingFileNames = oldProgram.getMissingFilePaths();
            Debug.assert(newSourceFiles.length === oldProgram.getSourceFiles().length);
            for (const newSourceFile of newSourceFiles)filesByName.set(newSourceFile.path, newSourceFile);
            const oldFilesByNameMap = oldProgram.getFilesByNameMap();
            oldFilesByNameMap.forEach((oldFile, path)=>{
                if (!oldFile) {
                    filesByName.set(path, oldFile);
                    return;
                }
                if (oldFile.path === path) {
                    if (oldProgram.isSourceFileFromExternalLibrary(oldFile)) sourceFilesFoundSearchingNodeModules.set(oldFile.path, true);
                    return;
                }
                filesByName.set(path, filesByName.get(oldFile.path));
            });
            const isConfigIdentical = oldOptions.configFile && oldOptions.configFile === options.configFile || !oldOptions.configFile && !options.configFile && !optionsHaveChanges(oldOptions, options, optionDeclarations);
            programDiagnostics.reuseStateFromOldProgram(oldProgram.getProgramDiagnosticsContainer(), isConfigIdentical);
            skipVerifyCompilerOptions = isConfigIdentical;
            files = newSourceFiles;
            automaticTypeDirectiveNames = oldProgram.getAutomaticTypeDirectiveNames();
            automaticTypeDirectiveResolutions = oldProgram.getAutomaticTypeDirectiveResolutions();
            sourceFileToPackageName = oldProgram.sourceFileToPackageName;
            redirectTargetsMap = oldProgram.redirectTargetsMap;
            usesUriStyleNodeCoreModules = oldProgram.usesUriStyleNodeCoreModules;
            resolvedModules = oldProgram.resolvedModules;
            resolvedTypeReferenceDirectiveNames = oldProgram.resolvedTypeReferenceDirectiveNames;
            resolvedLibReferences = oldProgram.resolvedLibReferences;
            packageMap = oldProgram.getCurrentPackagesMap();
            return 2 /* Completely */ ;
        }
        function getEmitHost(writeFileCallback) {
            return {
                getCanonicalFileName,
                getCommonSourceDirectory: program.getCommonSourceDirectory,
                getCompilerOptions: program.getCompilerOptions,
                getCurrentDirectory: ()=>currentDirectory,
                getSourceFile: program.getSourceFile,
                getSourceFileByPath: program.getSourceFileByPath,
                getSourceFiles: program.getSourceFiles,
                isSourceFileFromExternalLibrary,
                getRedirectFromSourceFile,
                isSourceOfProjectReferenceRedirect,
                getSymlinkCache,
                writeFile: writeFileCallback || writeFile2,
                isEmitBlocked,
                shouldTransformImportCall,
                getEmitModuleFormatOfFile: getEmitModuleFormatOfFile2,
                getDefaultResolutionModeForFile: getDefaultResolutionModeForFile2,
                getModeForResolutionAtIndex: getModeForResolutionAtIndex2,
                readFile: (f)=>host.readFile(f),
                fileExists: (f)=>{
                    const path = toPath3(f);
                    if (getSourceFileByPath(path)) return true;
                    if (missingFileNames.has(path)) return false;
                    return host.fileExists(f);
                },
                realpath: maybeBind(host, host.realpath),
                useCaseSensitiveFileNames: ()=>host.useCaseSensitiveFileNames(),
                getBuildInfo: ()=>{
                    var _a2;
                    return (_a2 = program.getBuildInfo) == null ? void 0 : _a2.call(program);
                },
                getSourceFileFromReference: (file, ref)=>program.getSourceFileFromReference(file, ref),
                redirectTargetsMap,
                getFileIncludeReasons: program.getFileIncludeReasons,
                createHash: maybeBind(host, host.createHash),
                getModuleResolutionCache: ()=>program.getModuleResolutionCache(),
                trace: maybeBind(host, host.trace),
                getGlobalTypingsCacheLocation: program.getGlobalTypingsCacheLocation
            };
        }
        function writeFile2(fileName, text, writeByteOrderMark, onError, sourceFiles, data) {
            host.writeFile(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
        }
        function emitBuildInfo(writeFileCallback) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Emit, "emitBuildInfo", {}, /*separateBeginAndEnd*/ true);
            mark("beforeEmit");
            const emitResult = emitFiles(notImplementedResolver, getEmitHost(writeFileCallback), /*targetSourceFile*/ void 0, /*transformers*/ noTransformers, /*emitOnly*/ false, /*onlyBuildInfo*/ true);
            mark("afterEmit");
            measure("Emit", "beforeEmit", "afterEmit");
            (_b2 = tracing) == null || _b2.pop();
            return emitResult;
        }
        function getResolvedProjectReferences() {
            return resolvedProjectReferences;
        }
        function getProjectReferences() {
            return projectReferences;
        }
        function isSourceFileFromExternalLibrary(file) {
            return !!sourceFilesFoundSearchingNodeModules.get(file.path);
        }
        function isSourceFileDefaultLibrary(file) {
            if (!file.isDeclarationFile) return false;
            if (file.hasNoDefaultLib) return true;
            if (options.noLib) return false;
            const equalityComparer = host.useCaseSensitiveFileNames() ? equateStringsCaseSensitive : equateStringsCaseInsensitive;
            if (!options.lib) return equalityComparer(file.fileName, getDefaultLibraryFileName());
            else return some(options.lib, (libFileName)=>{
                const resolvedLib = resolvedLibReferences.get(libFileName);
                return !!resolvedLib && equalityComparer(file.fileName, resolvedLib.actual);
            });
        }
        function getTypeChecker() {
            return typeChecker || (typeChecker = createTypeChecker(program));
        }
        function emit(sourceFile, writeFileCallback, cancellationToken, emitOnly, transformers, forceDtsEmit, skipBuildInfo) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Emit, "emit", {
                path: sourceFile == null ? void 0 : sourceFile.path
            }, /*separateBeginAndEnd*/ true);
            const result = runWithCancellationToken(()=>emitWorker(program, sourceFile, writeFileCallback, cancellationToken, emitOnly, transformers, forceDtsEmit, skipBuildInfo));
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function isEmitBlocked(emitFileName) {
            return hasEmitBlockingDiagnostics.has(toPath3(emitFileName));
        }
        function emitWorker(program2, sourceFile, writeFileCallback, cancellationToken, emitOnly, customTransformers, forceDtsEmit, skipBuildInfo) {
            if (!forceDtsEmit) {
                const result = handleNoEmitOptions(program2, sourceFile, writeFileCallback, cancellationToken);
                if (result) return result;
            }
            const typeChecker2 = getTypeChecker();
            const emitResolver = typeChecker2.getEmitResolver(options.outFile ? void 0 : sourceFile, cancellationToken, emitResolverSkipsTypeChecking(emitOnly, forceDtsEmit));
            mark("beforeEmit");
            const emitResult = typeChecker2.runWithCancellationToken(cancellationToken, ()=>emitFiles(emitResolver, getEmitHost(writeFileCallback), sourceFile, getTransformers(options, customTransformers, emitOnly), emitOnly, /*onlyBuildInfo*/ false, forceDtsEmit, skipBuildInfo));
            mark("afterEmit");
            measure("Emit", "beforeEmit", "afterEmit");
            return emitResult;
        }
        function getSourceFile(fileName) {
            return getSourceFileByPath(toPath3(fileName));
        }
        function getSourceFileByPath(path) {
            return filesByName.get(path) || void 0;
        }
        function getDiagnosticsHelper(sourceFile, getDiagnostics2, cancellationToken) {
            if (sourceFile) return sortAndDeduplicateDiagnostics(getDiagnostics2(sourceFile, cancellationToken));
            return sortAndDeduplicateDiagnostics(flatMap(program.getSourceFiles(), (sourceFile2)=>{
                if (cancellationToken) cancellationToken.throwIfCancellationRequested();
                return getDiagnostics2(sourceFile2, cancellationToken);
            }));
        }
        function getSyntacticDiagnostics(sourceFile, cancellationToken) {
            return getDiagnosticsHelper(sourceFile, getSyntacticDiagnosticsForFile, cancellationToken);
        }
        function getSemanticDiagnostics(sourceFile, cancellationToken, nodesToCheck) {
            return getDiagnosticsHelper(sourceFile, (sourceFile2, cancellationToken2)=>getSemanticDiagnosticsForFile(sourceFile2, cancellationToken2, nodesToCheck), cancellationToken);
        }
        function getCachedSemanticDiagnostics(sourceFile) {
            return cachedBindAndCheckDiagnosticsForFile == null ? void 0 : cachedBindAndCheckDiagnosticsForFile.get(sourceFile.path);
        }
        function getBindAndCheckDiagnostics(sourceFile, cancellationToken) {
            return getBindAndCheckDiagnosticsForFile(sourceFile, cancellationToken, /*nodesToCheck*/ void 0);
        }
        function getProgramDiagnostics(sourceFile) {
            var _a2;
            if (skipTypeChecking(sourceFile, options, program)) return emptyArray;
            const programDiagnosticsInFile = programDiagnostics.getCombinedDiagnostics(program).getDiagnostics(sourceFile.fileName);
            if (!((_a2 = sourceFile.commentDirectives) == null ? void 0 : _a2.length)) return programDiagnosticsInFile;
            return getDiagnosticsWithPrecedingDirectives(sourceFile, sourceFile.commentDirectives, programDiagnosticsInFile).diagnostics;
        }
        function getDeclarationDiagnostics2(sourceFile, cancellationToken) {
            return getDiagnosticsHelper(sourceFile, getDeclarationDiagnosticsForFile, cancellationToken);
        }
        function getSyntacticDiagnosticsForFile(sourceFile) {
            if (isSourceFileJS(sourceFile)) {
                if (!sourceFile.additionalSyntacticDiagnostics) sourceFile.additionalSyntacticDiagnostics = getJSSyntacticDiagnosticsForFile(sourceFile);
                return concatenate(sourceFile.additionalSyntacticDiagnostics, sourceFile.parseDiagnostics);
            }
            return sourceFile.parseDiagnostics;
        }
        function runWithCancellationToken(func) {
            try {
                return func();
            } catch (e) {
                if (e instanceof OperationCanceledException) typeChecker = void 0;
                throw e;
            }
        }
        function getSemanticDiagnosticsForFile(sourceFile, cancellationToken, nodesToCheck) {
            return concatenate(filterSemanticDiagnostics(getBindAndCheckDiagnosticsForFile(sourceFile, cancellationToken, nodesToCheck), options), getProgramDiagnostics(sourceFile));
        }
        function getBindAndCheckDiagnosticsForFile(sourceFile, cancellationToken, nodesToCheck) {
            if (nodesToCheck) return getBindAndCheckDiagnosticsForFileNoCache(sourceFile, cancellationToken, nodesToCheck);
            let result = cachedBindAndCheckDiagnosticsForFile == null ? void 0 : cachedBindAndCheckDiagnosticsForFile.get(sourceFile.path);
            if (!result) (cachedBindAndCheckDiagnosticsForFile !== null && cachedBindAndCheckDiagnosticsForFile !== void 0 ? cachedBindAndCheckDiagnosticsForFile : cachedBindAndCheckDiagnosticsForFile = /* @__PURE__ */ new Map()).set(sourceFile.path, result = getBindAndCheckDiagnosticsForFileNoCache(sourceFile, cancellationToken));
            return result;
        }
        function getBindAndCheckDiagnosticsForFileNoCache(sourceFile, cancellationToken, nodesToCheck) {
            return runWithCancellationToken(()=>{
                if (skipTypeChecking(sourceFile, options, program)) return emptyArray;
                const typeChecker2 = getTypeChecker();
                Debug.assert(!!sourceFile.bindDiagnostics);
                const isJs = sourceFile.scriptKind === 1 /* JS */  || sourceFile.scriptKind === 2 /* JSX */ ;
                const isPlainJs = isPlainJsFile(sourceFile, options.checkJs);
                const isCheckJs = isJs && isCheckJsEnabledForFile(sourceFile, options);
                let bindDiagnostics = sourceFile.bindDiagnostics;
                let checkDiagnostics = typeChecker2.getDiagnostics(sourceFile, cancellationToken, nodesToCheck);
                if (isPlainJs) {
                    bindDiagnostics = filter(bindDiagnostics, (d)=>plainJSErrors.has(d.code));
                    checkDiagnostics = filter(checkDiagnostics, (d)=>plainJSErrors.has(d.code));
                }
                return getMergedBindAndCheckDiagnostics(sourceFile, !isPlainJs, !!nodesToCheck, bindDiagnostics, checkDiagnostics, isCheckJs ? sourceFile.jsDocDiagnostics : void 0);
            });
        }
        function getMergedBindAndCheckDiagnostics(sourceFile, includeBindAndCheckDiagnostics, partialCheck, ...allDiagnostics) {
            var _a2;
            const flatDiagnostics = flatten(allDiagnostics);
            if (!includeBindAndCheckDiagnostics || !((_a2 = sourceFile.commentDirectives) == null ? void 0 : _a2.length)) return flatDiagnostics;
            const { diagnostics, directives } = getDiagnosticsWithPrecedingDirectives(sourceFile, sourceFile.commentDirectives, flatDiagnostics);
            if (partialCheck) return diagnostics;
            for (const errorExpectation of directives.getUnusedExpectations())diagnostics.push(createDiagnosticForRange(sourceFile, errorExpectation.range, Diagnostics.Unused_ts_expect_error_directive));
            return diagnostics;
        }
        function getDiagnosticsWithPrecedingDirectives(sourceFile, commentDirectives, flatDiagnostics) {
            const directives = createCommentDirectivesMap(sourceFile, commentDirectives);
            const diagnostics = flatDiagnostics.filter((diagnostic)=>markPrecedingCommentDirectiveLine(diagnostic, directives) === -1);
            return {
                diagnostics,
                directives
            };
        }
        function getSuggestionDiagnostics(sourceFile, cancellationToken) {
            return runWithCancellationToken(()=>{
                return getTypeChecker().getSuggestionDiagnostics(sourceFile, cancellationToken);
            });
        }
        function markPrecedingCommentDirectiveLine(diagnostic, directives) {
            const { file, start } = diagnostic;
            if (!file) return -1;
            const lineStarts = getLineStarts(file);
            let line = computeLineAndCharacterOfPosition(lineStarts, start).line - 1;
            while(line >= 0){
                if (directives.markUsed(line)) return line;
                const lineText = file.text.slice(lineStarts[line], lineStarts[line + 1]).trim();
                if (lineText !== "" && !/^\s*\/\/.*$/.test(lineText)) return -1;
                line--;
            }
            return -1;
        }
        function getJSSyntacticDiagnosticsForFile(sourceFile) {
            return runWithCancellationToken(()=>{
                const diagnostics = [];
                walk(sourceFile, sourceFile);
                forEachChildRecursively(sourceFile, walk, walkArray);
                return diagnostics;
                function walk(node, parent2) {
                    switch(parent2.kind){
                        case 170 /* Parameter */ :
                        case 173 /* PropertyDeclaration */ :
                        case 175 /* MethodDeclaration */ :
                            if (parent2.questionToken === node) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, "?"));
                                return "skip";
                            }
                        // falls through
                        case 174 /* MethodSignature */ :
                        case 177 /* Constructor */ :
                        case 178 /* GetAccessor */ :
                        case 179 /* SetAccessor */ :
                        case 219 /* FunctionExpression */ :
                        case 263 /* FunctionDeclaration */ :
                        case 220 /* ArrowFunction */ :
                        case 261 /* VariableDeclaration */ :
                            if (parent2.type === node) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Type_annotations_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                    }
                    switch(node.kind){
                        case 274 /* ImportClause */ :
                            if (node.isTypeOnly) {
                                diagnostics.push(createDiagnosticForNode2(parent2, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, "import type"));
                                return "skip";
                            }
                            break;
                        case 279 /* ExportDeclaration */ :
                            if (node.isTypeOnly) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, "export type"));
                                return "skip";
                            }
                            break;
                        case 277 /* ImportSpecifier */ :
                        case 282 /* ExportSpecifier */ :
                            if (node.isTypeOnly) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, isImportSpecifier(node) ? "import...type" : "export...type"));
                                return "skip";
                            }
                            break;
                        case 272 /* ImportEqualsDeclaration */ :
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics.import_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 278 /* ExportAssignment */ :
                            if (node.isExportEquals) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.export_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                        case 299 /* HeritageClause */ :
                            const heritageClause = node;
                            if (heritageClause.token === 119 /* ImplementsKeyword */ ) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.implements_clauses_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                        case 265 /* InterfaceDeclaration */ :
                            const interfaceKeyword = tokenToString(120 /* InterfaceKeyword */ );
                            Debug.assertIsDefined(interfaceKeyword);
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, interfaceKeyword));
                            return "skip";
                        case 268 /* ModuleDeclaration */ :
                            const moduleKeyword = node.flags & 32 /* Namespace */  ? tokenToString(145 /* NamespaceKeyword */ ) : tokenToString(144 /* ModuleKeyword */ );
                            Debug.assertIsDefined(moduleKeyword);
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, moduleKeyword));
                            return "skip";
                        case 266 /* TypeAliasDeclaration */ :
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Type_aliases_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 177 /* Constructor */ :
                        case 175 /* MethodDeclaration */ :
                        case 263 /* FunctionDeclaration */ :
                            if (!node.body) {
                                diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Signature_declarations_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            return;
                        case 267 /* EnumDeclaration */ :
                            const enumKeyword = Debug.checkDefined(tokenToString(94 /* EnumKeyword */ ));
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics._0_declarations_can_only_be_used_in_TypeScript_files, enumKeyword));
                            return "skip";
                        case 236 /* NonNullExpression */ :
                            diagnostics.push(createDiagnosticForNode2(node, Diagnostics.Non_null_assertions_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 235 /* AsExpression */ :
                            diagnostics.push(createDiagnosticForNode2(node.type, Diagnostics.Type_assertion_expressions_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 239 /* SatisfiesExpression */ :
                            diagnostics.push(createDiagnosticForNode2(node.type, Diagnostics.Type_satisfaction_expressions_can_only_be_used_in_TypeScript_files));
                            return "skip";
                        case 217 /* TypeAssertionExpression */ :
                            Debug.fail();
                    }
                }
                function walkArray(nodes, parent2) {
                    if (canHaveIllegalDecorators(parent2)) {
                        const decorator = find(parent2.modifiers, isDecorator);
                        if (decorator) diagnostics.push(createDiagnosticForNode2(decorator, Diagnostics.Decorators_are_not_valid_here));
                    } else if (canHaveDecorators(parent2) && parent2.modifiers) {
                        const decoratorIndex = findIndex(parent2.modifiers, isDecorator);
                        if (decoratorIndex >= 0) {
                            if (isParameter(parent2) && !options.experimentalDecorators) diagnostics.push(createDiagnosticForNode2(parent2.modifiers[decoratorIndex], Diagnostics.Decorators_are_not_valid_here));
                            else if (isClassDeclaration(parent2)) {
                                const exportIndex = findIndex(parent2.modifiers, isExportModifier);
                                if (exportIndex >= 0) {
                                    const defaultIndex = findIndex(parent2.modifiers, isDefaultModifier);
                                    if (decoratorIndex > exportIndex && defaultIndex >= 0 && decoratorIndex < defaultIndex) diagnostics.push(createDiagnosticForNode2(parent2.modifiers[decoratorIndex], Diagnostics.Decorators_are_not_valid_here));
                                    else if (exportIndex >= 0 && decoratorIndex < exportIndex) {
                                        const trailingDecoratorIndex = findIndex(parent2.modifiers, isDecorator, exportIndex);
                                        if (trailingDecoratorIndex >= 0) diagnostics.push(addRelatedInfo(createDiagnosticForNode2(parent2.modifiers[trailingDecoratorIndex], Diagnostics.Decorators_may_not_appear_after_export_or_export_default_if_they_also_appear_before_export), createDiagnosticForNode2(parent2.modifiers[decoratorIndex], Diagnostics.Decorator_used_before_export_here)));
                                    }
                                }
                            }
                        }
                    }
                    switch(parent2.kind){
                        case 264 /* ClassDeclaration */ :
                        case 232 /* ClassExpression */ :
                        case 175 /* MethodDeclaration */ :
                        case 177 /* Constructor */ :
                        case 178 /* GetAccessor */ :
                        case 179 /* SetAccessor */ :
                        case 219 /* FunctionExpression */ :
                        case 263 /* FunctionDeclaration */ :
                        case 220 /* ArrowFunction */ :
                            if (nodes === parent2.typeParameters) {
                                diagnostics.push(createDiagnosticForNodeArray2(nodes, Diagnostics.Type_parameter_declarations_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                        // falls through
                        case 244 /* VariableStatement */ :
                            if (nodes === parent2.modifiers) {
                                checkModifiers(parent2.modifiers, parent2.kind === 244 /* VariableStatement */ );
                                return "skip";
                            }
                            break;
                        case 173 /* PropertyDeclaration */ :
                            if (nodes === parent2.modifiers) {
                                for (const modifier of nodes)if (isModifier(modifier) && modifier.kind !== 126 /* StaticKeyword */  && modifier.kind !== 129 /* AccessorKeyword */ ) diagnostics.push(createDiagnosticForNode2(modifier, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, tokenToString(modifier.kind)));
                                return "skip";
                            }
                            break;
                        case 170 /* Parameter */ :
                            if (nodes === parent2.modifiers && some(nodes, isModifier)) {
                                diagnostics.push(createDiagnosticForNodeArray2(nodes, Diagnostics.Parameter_modifiers_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                        case 214 /* CallExpression */ :
                        case 215 /* NewExpression */ :
                        case 234 /* ExpressionWithTypeArguments */ :
                        case 286 /* JsxSelfClosingElement */ :
                        case 287 /* JsxOpeningElement */ :
                        case 216 /* TaggedTemplateExpression */ :
                            if (nodes === parent2.typeArguments) {
                                diagnostics.push(createDiagnosticForNodeArray2(nodes, Diagnostics.Type_arguments_can_only_be_used_in_TypeScript_files));
                                return "skip";
                            }
                            break;
                    }
                }
                function checkModifiers(modifiers, isConstValid) {
                    for (const modifier of modifiers)switch(modifier.kind){
                        case 87 /* ConstKeyword */ :
                            if (isConstValid) continue;
                        // to report error,
                        // falls through
                        case 125 /* PublicKeyword */ :
                        case 123 /* PrivateKeyword */ :
                        case 124 /* ProtectedKeyword */ :
                        case 148 /* ReadonlyKeyword */ :
                        case 138 /* DeclareKeyword */ :
                        case 128 /* AbstractKeyword */ :
                        case 164 /* OverrideKeyword */ :
                        case 103 /* InKeyword */ :
                        case 147 /* OutKeyword */ :
                            diagnostics.push(createDiagnosticForNode2(modifier, Diagnostics.The_0_modifier_can_only_be_used_in_TypeScript_files, tokenToString(modifier.kind)));
                            break;
                        // These are all legal modifiers.
                        case 126 /* StaticKeyword */ :
                        case 95 /* ExportKeyword */ :
                        case 90 /* DefaultKeyword */ :
                        case 129 /* AccessorKeyword */ :
                    }
                }
                function createDiagnosticForNodeArray2(nodes, message, ...args) {
                    const start = nodes.pos;
                    return createFileDiagnostic(sourceFile, start, nodes.end - start, message, ...args);
                }
                function createDiagnosticForNode2(node, message, ...args) {
                    return createDiagnosticForNodeInSourceFile(sourceFile, node, message, ...args);
                }
            });
        }
        function getDeclarationDiagnosticsWorker(sourceFile, cancellationToken) {
            let result = cachedDeclarationDiagnosticsForFile == null ? void 0 : cachedDeclarationDiagnosticsForFile.get(sourceFile.path);
            if (!result) (cachedDeclarationDiagnosticsForFile !== null && cachedDeclarationDiagnosticsForFile !== void 0 ? cachedDeclarationDiagnosticsForFile : cachedDeclarationDiagnosticsForFile = /* @__PURE__ */ new Map()).set(sourceFile.path, result = getDeclarationDiagnosticsForFileNoCache(sourceFile, cancellationToken));
            return result;
        }
        function getDeclarationDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
            return runWithCancellationToken(()=>{
                const resolver = getTypeChecker().getEmitResolver(sourceFile, cancellationToken);
                return getDeclarationDiagnostics(getEmitHost(noop), resolver, sourceFile) || emptyArray;
            });
        }
        function getDeclarationDiagnosticsForFile(sourceFile, cancellationToken) {
            return sourceFile.isDeclarationFile ? emptyArray : getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
        }
        function getOptionsDiagnostics() {
            return sortAndDeduplicateDiagnostics(concatenate(programDiagnostics.getCombinedDiagnostics(program).getGlobalDiagnostics(), getOptionsDiagnosticsOfConfigFile()));
        }
        function getOptionsDiagnosticsOfConfigFile() {
            if (!options.configFile) return emptyArray;
            let diagnostics = programDiagnostics.getCombinedDiagnostics(program).getDiagnostics(options.configFile.fileName);
            forEachResolvedProjectReference2((resolvedRef)=>{
                diagnostics = concatenate(diagnostics, programDiagnostics.getCombinedDiagnostics(program).getDiagnostics(resolvedRef.sourceFile.fileName));
            });
            return diagnostics;
        }
        function getGlobalDiagnostics() {
            return rootNames.length ? sortAndDeduplicateDiagnostics(getTypeChecker().getGlobalDiagnostics().slice()) : emptyArray;
        }
        function getConfigFileParsingDiagnostics2() {
            return configFileParsingDiagnostics || emptyArray;
        }
        function processRootFile(fileName, isDefaultLib, ignoreNoDefaultLib, reason) {
            processSourceFile(normalizePath(fileName), isDefaultLib, ignoreNoDefaultLib, /*packageId*/ void 0, reason);
        }
        function fileReferenceIsEqualTo(a, b) {
            return a.fileName === b.fileName;
        }
        function moduleNameIsEqualTo(a, b) {
            return a.kind === 80 /* Identifier */  ? b.kind === 80 /* Identifier */  && a.escapedText === b.escapedText : b.kind === 11 /* StringLiteral */  && a.text === b.text;
        }
        function createSyntheticImport(text, file) {
            const externalHelpersModuleReference = factory.createStringLiteral(text);
            const importDecl = factory.createImportDeclaration(/*modifiers*/ void 0, /*importClause*/ void 0, externalHelpersModuleReference);
            addInternalEmitFlags(importDecl, 2 /* NeverApplyImportHelper */ );
            setParent(externalHelpersModuleReference, importDecl);
            setParent(importDecl, file);
            externalHelpersModuleReference.flags &= -17 /* Synthesized */ ;
            importDecl.flags &= -17 /* Synthesized */ ;
            return externalHelpersModuleReference;
        }
        function collectExternalModuleReferences(file) {
            if (file.imports) return;
            const isJavaScriptFile = isSourceFileJS(file);
            const isExternalModuleFile = isExternalModule(file);
            let imports;
            let moduleAugmentations;
            let ambientModules;
            if (isJavaScriptFile || !file.isDeclarationFile && (getIsolatedModules(options) || isExternalModule(file))) {
                if (options.importHelpers) imports = [
                    createSyntheticImport(externalHelpersModuleNameText, file)
                ];
                const jsxImport = getJSXRuntimeImport(getJSXImplicitImportBase(options, file), options);
                if (jsxImport) (imports || (imports = [])).push(createSyntheticImport(jsxImport, file));
            }
            for (const node of file.statements)collectModuleReferences(node, /*inAmbientModule*/ false);
            if (file.flags & 4194304 /* PossiblyContainsDynamicImport */  || isJavaScriptFile) forEachDynamicImportOrRequireCall(file, /*includeTypeSpaceImports*/ true, /*requireStringLiteralLikeArgument*/ true, (node, moduleSpecifier)=>{
                setParentRecursive(node, /*incremental*/ false);
                imports = append(imports, moduleSpecifier);
            });
            file.imports = imports || emptyArray;
            file.moduleAugmentations = moduleAugmentations || emptyArray;
            file.ambientModuleNames = ambientModules || emptyArray;
            return;
            function collectModuleReferences(node, inAmbientModule) {
                if (isAnyImportOrReExport(node)) {
                    const moduleNameExpr = getExternalModuleName(node);
                    if (moduleNameExpr && isStringLiteral(moduleNameExpr) && moduleNameExpr.text && (!inAmbientModule || !isExternalModuleNameRelative(moduleNameExpr.text))) {
                        setParentRecursive(node, /*incremental*/ false);
                        imports = append(imports, moduleNameExpr);
                        if (!usesUriStyleNodeCoreModules && currentNodeModulesDepth === 0 && !file.isDeclarationFile) {
                            if (startsWith(moduleNameExpr.text, "node:") && !exclusivelyPrefixedNodeCoreModules.has(moduleNameExpr.text)) usesUriStyleNodeCoreModules = true;
                            else if (usesUriStyleNodeCoreModules === void 0 && unprefixedNodeCoreModules.has(moduleNameExpr.text)) usesUriStyleNodeCoreModules = false;
                        }
                    }
                } else if (isModuleDeclaration(node)) {
                    if (isAmbientModule(node) && (inAmbientModule || hasSyntacticModifier(node, 128 /* Ambient */ ) || file.isDeclarationFile)) {
                        node.name.parent = node;
                        const nameText = getTextOfIdentifierOrLiteral(node.name);
                        if (isExternalModuleFile || inAmbientModule && !isExternalModuleNameRelative(nameText)) (moduleAugmentations || (moduleAugmentations = [])).push(node.name);
                        else if (!inAmbientModule) {
                            if (file.isDeclarationFile) (ambientModules || (ambientModules = [])).push(nameText);
                            const body = node.body;
                            if (body) for (const statement of body.statements)collectModuleReferences(statement, /*inAmbientModule*/ true);
                        }
                    }
                }
            }
        }
        function getLibFileFromReference(ref) {
            var _a2;
            const libFileName = getLibFileNameFromLibReference(ref);
            const actualFileName = libFileName && ((_a2 = resolvedLibReferences == null ? void 0 : resolvedLibReferences.get(libFileName)) == null ? void 0 : _a2.actual);
            return actualFileName !== void 0 ? getSourceFile(actualFileName) : void 0;
        }
        function getSourceFileFromReference(referencingFile, ref) {
            return getSourceFileFromReferenceWorker(resolveTripleslashReference(ref.fileName, referencingFile.fileName), getSourceFile);
        }
        function getSourceFileFromReferenceWorker(fileName, getSourceFile2, fail, reason) {
            if (hasExtension(fileName)) {
                const canonicalFileName = host.getCanonicalFileName(fileName);
                if (!options.allowNonTsExtensions && !forEach(flatten(supportedExtensionsWithJsonIfResolveJsonModule), (extension)=>fileExtensionIs(canonicalFileName, extension))) {
                    if (fail) {
                        if (hasJSFileExtension(canonicalFileName)) fail(Diagnostics.File_0_is_a_JavaScript_file_Did_you_mean_to_enable_the_allowJs_option, fileName);
                        else fail(Diagnostics.File_0_has_an_unsupported_extension_The_only_supported_extensions_are_1, fileName, "'" + flatten(supportedExtensions).join("', '") + "'");
                    }
                    return void 0;
                }
                const sourceFile = getSourceFile2(fileName);
                if (fail) {
                    if (!sourceFile) {
                        const redirect = getRedirectFromSourceFile(fileName);
                        if (redirect == null ? void 0 : redirect.outputDts) fail(Diagnostics.Output_file_0_has_not_been_built_from_source_file_1, redirect.outputDts, fileName);
                        else fail(Diagnostics.File_0_not_found, fileName);
                    } else if (isReferencedFile(reason) && canonicalFileName === host.getCanonicalFileName(getSourceFileByPath(reason.file).fileName)) fail(Diagnostics.A_file_cannot_have_a_reference_to_itself);
                }
                return sourceFile;
            } else {
                const sourceFileNoExtension = options.allowNonTsExtensions && getSourceFile2(fileName);
                if (sourceFileNoExtension) return sourceFileNoExtension;
                if (fail && options.allowNonTsExtensions) {
                    fail(Diagnostics.File_0_not_found, fileName);
                    return void 0;
                }
                const sourceFileWithAddedExtension = forEach(supportedExtensions[0], (extension)=>getSourceFile2(fileName + extension));
                if (fail && !sourceFileWithAddedExtension) fail(Diagnostics.Could_not_resolve_the_path_0_with_the_extensions_Colon_1, fileName, "'" + flatten(supportedExtensions).join("', '") + "'");
                return sourceFileWithAddedExtension;
            }
        }
        function processSourceFile(fileName, isDefaultLib, ignoreNoDefaultLib, packageId, reason) {
            getSourceFileFromReferenceWorker(fileName, (fileName2)=>findSourceFile(fileName2, isDefaultLib, ignoreNoDefaultLib, reason, packageId), // TODO: GH#18217
            (diagnostic, ...args)=>addFilePreprocessingFileExplainingDiagnostic(/*file*/ void 0, reason, diagnostic, args), reason);
        }
        function processProjectReferenceFile(fileName, reason) {
            return processSourceFile(fileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, /*packageId*/ void 0, reason);
        }
        function reportFileNamesDifferOnlyInCasingError(fileName, existingFile, reason) {
            const hasExistingReasonToReportErrorOn = !isReferencedFile(reason) && some(programDiagnostics.getFileReasons().get(existingFile.path), isReferencedFile);
            if (hasExistingReasonToReportErrorOn) addFilePreprocessingFileExplainingDiagnostic(existingFile, reason, Diagnostics.Already_included_file_name_0_differs_from_file_name_1_only_in_casing, [
                existingFile.fileName,
                fileName
            ]);
            else addFilePreprocessingFileExplainingDiagnostic(existingFile, reason, Diagnostics.File_name_0_differs_from_already_included_file_name_1_only_in_casing, [
                fileName,
                existingFile.fileName
            ]);
        }
        function createRedirectedSourceFile(redirectTarget, unredirected, fileName, path, resolvedPath, originalFileName, sourceFileOptions) {
            var _a2;
            const redirect = parseNodeFactory.createRedirectedSourceFile({
                redirectTarget,
                unredirected
            });
            redirect.fileName = fileName;
            redirect.path = path;
            redirect.resolvedPath = resolvedPath;
            redirect.originalFileName = originalFileName;
            redirect.packageJsonLocations = ((_a2 = sourceFileOptions.packageJsonLocations) == null ? void 0 : _a2.length) ? sourceFileOptions.packageJsonLocations : void 0;
            redirect.packageJsonScope = sourceFileOptions.packageJsonScope;
            sourceFilesFoundSearchingNodeModules.set(path, currentNodeModulesDepth > 0);
            return redirect;
        }
        function findSourceFile(fileName, isDefaultLib, ignoreNoDefaultLib, reason, packageId) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "findSourceFile", {
                fileName,
                isDefaultLib: isDefaultLib || void 0,
                fileIncludeKind: FileIncludeKind[reason.kind]
            });
            const result = findSourceFileWorker(fileName, isDefaultLib, ignoreNoDefaultLib, reason, packageId);
            (_b2 = tracing) == null || _b2.pop();
            return result;
        }
        function getCreateSourceFileOptions(fileName, moduleResolutionCache2, host2, options2) {
            const result = getImpliedNodeFormatForFileWorker(getNormalizedAbsolutePath(fileName, currentDirectory), moduleResolutionCache2 == null ? void 0 : moduleResolutionCache2.getPackageJsonInfoCache(), host2, options2);
            const languageVersion = getEmitScriptTarget(options2);
            const setExternalModuleIndicator2 = getSetExternalModuleIndicator(options2);
            return typeof result === "object" ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
                languageVersion,
                setExternalModuleIndicator: setExternalModuleIndicator2,
                jsDocParsingMode: host2.jsDocParsingMode
            }) : {
                languageVersion,
                impliedNodeFormat: result,
                setExternalModuleIndicator: setExternalModuleIndicator2,
                jsDocParsingMode: host2.jsDocParsingMode
            };
        }
        function findSourceFileWorker(fileName, isDefaultLib, ignoreNoDefaultLib, reason, packageId) {
            var _a2, _b2;
            const path = toPath3(fileName);
            if (useSourceOfProjectReferenceRedirect) {
                let source = getRedirectFromOutput(path);
                if (!source && host.realpath && options.preserveSymlinks && isDeclarationFileName(fileName) && fileName.includes(nodeModulesPathPart)) {
                    const realPath2 = toPath3(host.realpath(fileName));
                    if (realPath2 !== path) source = getRedirectFromOutput(realPath2);
                }
                if (source == null ? void 0 : source.source) {
                    const file2 = findSourceFile(source.source, isDefaultLib, ignoreNoDefaultLib, reason, packageId);
                    if (file2) addFileToFilesByName(file2, path, fileName, /*redirectedPath*/ void 0);
                    return file2;
                }
            }
            const originalFileName = fileName;
            if (filesByName.has(path)) {
                const file2 = filesByName.get(path);
                const addedReason = addFileIncludeReason(file2 || void 0, reason, /*checkExisting*/ true);
                if (file2 && addedReason && !(options.forceConsistentCasingInFileNames === false)) {
                    const checkedName = file2.fileName;
                    const isRedirect = toPath3(checkedName) !== toPath3(fileName);
                    if (isRedirect) fileName = ((_a2 = getRedirectFromSourceFile(fileName)) == null ? void 0 : _a2.outputDts) || fileName;
                    const checkedAbsolutePath = getNormalizedAbsolutePathWithoutRoot(checkedName, currentDirectory);
                    const inputAbsolutePath = getNormalizedAbsolutePathWithoutRoot(fileName, currentDirectory);
                    if (checkedAbsolutePath !== inputAbsolutePath) reportFileNamesDifferOnlyInCasingError(fileName, file2, reason);
                }
                if (file2 && sourceFilesFoundSearchingNodeModules.get(file2.path) && currentNodeModulesDepth === 0) {
                    sourceFilesFoundSearchingNodeModules.set(file2.path, false);
                    if (!options.noResolve) {
                        processReferencedFiles(file2, isDefaultLib);
                        processTypeReferenceDirectives(file2);
                    }
                    if (!options.noLib) processLibReferenceDirectives(file2);
                    modulesWithElidedImports.set(file2.path, false);
                    processImportedModules(file2);
                } else if (file2 && modulesWithElidedImports.get(file2.path)) {
                    if (currentNodeModulesDepth < maxNodeModuleJsDepth) {
                        modulesWithElidedImports.set(file2.path, false);
                        processImportedModules(file2);
                    }
                }
                return file2 || void 0;
            }
            let redirectedPath;
            if (!useSourceOfProjectReferenceRedirect) {
                const redirectProject = getRedirectFromSourceFile(fileName);
                if (redirectProject == null ? void 0 : redirectProject.outputDts) {
                    if (redirectProject.resolvedRef.commandLine.options.outFile) return void 0;
                    fileName = redirectProject.outputDts;
                    redirectedPath = toPath3(redirectProject.outputDts);
                }
            }
            const sourceFileOptions = getCreateSourceFileOptions(fileName, moduleResolutionCache, host, options);
            const file = host.getSourceFile(fileName, sourceFileOptions, (hostErrorMessage)=>addFilePreprocessingFileExplainingDiagnostic(/*file*/ void 0, reason, Diagnostics.Cannot_read_file_0_Colon_1, [
                    fileName,
                    hostErrorMessage
                ]), shouldCreateNewSourceFile);
            if (packageId) {
                const packageIdKey = packageIdToString(packageId);
                const fileFromPackageId = packageIdToSourceFile.get(packageIdKey);
                if (fileFromPackageId) {
                    const dupFile = createRedirectedSourceFile(fileFromPackageId, file, fileName, path, toPath3(fileName), originalFileName, sourceFileOptions);
                    redirectTargetsMap.add(fileFromPackageId.path, fileName);
                    addFileToFilesByName(dupFile, path, fileName, redirectedPath);
                    addFileIncludeReason(dupFile, reason, /*checkExisting*/ false);
                    sourceFileToPackageName.set(path, packageIdToPackageName(packageId));
                    processingOtherFiles.push(dupFile);
                    return dupFile;
                } else if (file) {
                    packageIdToSourceFile.set(packageIdKey, file);
                    sourceFileToPackageName.set(path, packageIdToPackageName(packageId));
                }
            }
            addFileToFilesByName(file, path, fileName, redirectedPath);
            if (file) {
                sourceFilesFoundSearchingNodeModules.set(path, currentNodeModulesDepth > 0);
                file.fileName = fileName;
                file.path = path;
                file.resolvedPath = toPath3(fileName);
                file.originalFileName = originalFileName;
                file.packageJsonLocations = ((_b2 = sourceFileOptions.packageJsonLocations) == null ? void 0 : _b2.length) ? sourceFileOptions.packageJsonLocations : void 0;
                file.packageJsonScope = sourceFileOptions.packageJsonScope;
                addFileIncludeReason(file, reason, /*checkExisting*/ false);
                if (host.useCaseSensitiveFileNames()) {
                    const pathLowerCase = toFileNameLowerCase(path);
                    const existingFile = filesByNameIgnoreCase.get(pathLowerCase);
                    if (existingFile) reportFileNamesDifferOnlyInCasingError(fileName, existingFile, reason);
                    else filesByNameIgnoreCase.set(pathLowerCase, file);
                }
                skipDefaultLib = skipDefaultLib || file.hasNoDefaultLib && !ignoreNoDefaultLib;
                if (!options.noResolve) {
                    processReferencedFiles(file, isDefaultLib);
                    processTypeReferenceDirectives(file);
                }
                if (!options.noLib) processLibReferenceDirectives(file);
                processImportedModules(file);
                if (isDefaultLib) processingDefaultLibFiles.push(file);
                else processingOtherFiles.push(file);
                (filesWithReferencesProcessed !== null && filesWithReferencesProcessed !== void 0 ? filesWithReferencesProcessed : filesWithReferencesProcessed = /* @__PURE__ */ new Set()).add(file.path);
            }
            return file;
        }
        function addFileIncludeReason(file, reason, checkExisting) {
            if (file && (!checkExisting || !isReferencedFile(reason) || !(filesWithReferencesProcessed == null ? void 0 : filesWithReferencesProcessed.has(reason.file)))) {
                programDiagnostics.getFileReasons().add(file.path, reason);
                return true;
            }
            return false;
        }
        function addFileToFilesByName(file, path, fileName, redirectedPath) {
            if (redirectedPath) {
                updateFilesByNameMap(fileName, redirectedPath, file);
                updateFilesByNameMap(fileName, path, file || false);
            } else updateFilesByNameMap(fileName, path, file);
        }
        function updateFilesByNameMap(fileName, path, file) {
            filesByName.set(path, file);
            if (file !== void 0) missingFileNames.delete(path);
            else missingFileNames.set(path, fileName);
        }
        function getRedirectFromSourceFile(fileName) {
            return mapSourceFileToResolvedRef == null ? void 0 : mapSourceFileToResolvedRef.get(toPath3(fileName));
        }
        function forEachResolvedProjectReference2(cb) {
            return forEachResolvedProjectReference(resolvedProjectReferences, cb);
        }
        function getRedirectFromOutput(path) {
            return mapOutputFileToResolvedRef == null ? void 0 : mapOutputFileToResolvedRef.get(path);
        }
        function isSourceOfProjectReferenceRedirect(fileName) {
            return useSourceOfProjectReferenceRedirect && !!getRedirectFromSourceFile(fileName);
        }
        function getResolvedProjectReferenceByPath(projectReferencePath) {
            if (!projectReferenceRedirects) return void 0;
            return projectReferenceRedirects.get(projectReferencePath) || void 0;
        }
        function processReferencedFiles(file, isDefaultLib) {
            forEach(file.referencedFiles, (ref, index)=>{
                processSourceFile(resolveTripleslashReference(ref.fileName, file.fileName), isDefaultLib, /*ignoreNoDefaultLib*/ false, /*packageId*/ void 0, {
                    kind: 4 /* ReferenceFile */ ,
                    file: file.path,
                    index
                });
            });
        }
        function processTypeReferenceDirectives(file) {
            const typeDirectives = file.typeReferenceDirectives;
            if (!typeDirectives.length) return;
            const resolutions = (resolvedTypeReferenceDirectiveNamesProcessing == null ? void 0 : resolvedTypeReferenceDirectiveNamesProcessing.get(file.path)) || resolveTypeReferenceDirectiveNamesReusingOldState(typeDirectives, file);
            const resolutionsInFile = createModeAwareCache();
            (resolvedTypeReferenceDirectiveNames !== null && resolvedTypeReferenceDirectiveNames !== void 0 ? resolvedTypeReferenceDirectiveNames : resolvedTypeReferenceDirectiveNames = /* @__PURE__ */ new Map()).set(file.path, resolutionsInFile);
            for(let index = 0; index < typeDirectives.length; index++){
                const ref = file.typeReferenceDirectives[index];
                const resolvedTypeReferenceDirective = resolutions[index];
                const fileName = ref.fileName;
                const mode = getModeForTypeReferenceDirectiveInFile(ref, file);
                resolutionsInFile.set(fileName, mode, resolvedTypeReferenceDirective);
                processTypeReferenceDirective(fileName, mode, resolvedTypeReferenceDirective, {
                    kind: 5 /* TypeReferenceDirective */ ,
                    file: file.path,
                    index
                });
            }
        }
        function getCompilerOptionsForFile(file) {
            var _a2;
            return ((_a2 = getRedirectReferenceForResolution(file)) == null ? void 0 : _a2.commandLine.options) || options;
        }
        function processTypeReferenceDirective(typeReferenceDirective, mode, resolution, reason) {
            var _a2, _b2;
            (_a2 = tracing) == null || _a2.push(tracing.Phase.Program, "processTypeReferenceDirective", {
                directive: typeReferenceDirective,
                hasResolved: !!resolution.resolvedTypeReferenceDirective,
                refKind: reason.kind,
                refPath: isReferencedFile(reason) ? reason.file : void 0
            });
            processTypeReferenceDirectiveWorker(typeReferenceDirective, mode, resolution, reason);
            (_b2 = tracing) == null || _b2.pop();
        }
        function processTypeReferenceDirectiveWorker(typeReferenceDirective, mode, resolution, reason) {
            addResolutionDiagnostics(resolution);
            const { resolvedTypeReferenceDirective } = resolution;
            if (resolvedTypeReferenceDirective) {
                if (resolvedTypeReferenceDirective.isExternalLibraryImport) currentNodeModulesDepth++;
                processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, reason);
                if (resolvedTypeReferenceDirective.isExternalLibraryImport) currentNodeModulesDepth--;
            } else addFilePreprocessingFileExplainingDiagnostic(/*file*/ void 0, reason, Diagnostics.Cannot_find_type_definition_file_for_0, [
                typeReferenceDirective
            ]);
        }
        function pathForLibFile(libFileName) {
            const existing = resolvedLibReferences == null ? void 0 : resolvedLibReferences.get(libFileName);
            if (existing) return existing.actual;
            const result = pathForLibFileWorker(libFileName);
            (resolvedLibReferences !== null && resolvedLibReferences !== void 0 ? resolvedLibReferences : resolvedLibReferences = /* @__PURE__ */ new Map()).set(libFileName, result);
            return result.actual;
        }
        function pathForLibFileWorker(libFileName) {
            var _a2, _b2, _c2, _d2, _e2;
            const existing = resolvedLibProcessing == null ? void 0 : resolvedLibProcessing.get(libFileName);
            if (existing) return existing;
            if (options.libReplacement === false) {
                const result2 = {
                    resolution: {
                        resolvedModule: void 0
                    },
                    actual: combinePaths(defaultLibraryPath, libFileName)
                };
                (resolvedLibProcessing !== null && resolvedLibProcessing !== void 0 ? resolvedLibProcessing : resolvedLibProcessing = /* @__PURE__ */ new Map()).set(libFileName, result2);
                return result2;
            }
            if (structureIsReused !== 0 /* Not */  && oldProgram && !hasInvalidatedLibResolutions(libFileName)) {
                const oldResolution = (_a2 = oldProgram.resolvedLibReferences) == null ? void 0 : _a2.get(libFileName);
                if (oldResolution) {
                    if (oldResolution.resolution && isTraceEnabled(options, host)) {
                        const libraryName2 = getLibraryNameFromLibFileName(libFileName);
                        const resolveFrom2 = getInferredLibraryNameResolveFrom(options, currentDirectory, libFileName);
                        trace(host, oldResolution.resolution.resolvedModule ? oldResolution.resolution.resolvedModule.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved, libraryName2, getNormalizedAbsolutePath(resolveFrom2, currentDirectory), (_b2 = oldResolution.resolution.resolvedModule) == null ? void 0 : _b2.resolvedFileName, ((_c2 = oldResolution.resolution.resolvedModule) == null ? void 0 : _c2.packageId) && packageIdToString(oldResolution.resolution.resolvedModule.packageId));
                    }
                    (resolvedLibProcessing !== null && resolvedLibProcessing !== void 0 ? resolvedLibProcessing : resolvedLibProcessing = /* @__PURE__ */ new Map()).set(libFileName, oldResolution);
                    return oldResolution;
                }
            }
            const libraryName = getLibraryNameFromLibFileName(libFileName);
            const resolveFrom = getInferredLibraryNameResolveFrom(options, currentDirectory, libFileName);
            (_d2 = tracing) == null || _d2.push(tracing.Phase.Program, "resolveLibrary", {
                resolveFrom
            });
            mark("beforeResolveLibrary");
            const resolution = actualResolveLibrary(libraryName, resolveFrom, options, libFileName);
            mark("afterResolveLibrary");
            measure("ResolveLibrary", "beforeResolveLibrary", "afterResolveLibrary");
            (_e2 = tracing) == null || _e2.pop();
            const result = {
                resolution,
                actual: resolution.resolvedModule ? resolution.resolvedModule.resolvedFileName : combinePaths(defaultLibraryPath, libFileName)
            };
            (resolvedLibProcessing !== null && resolvedLibProcessing !== void 0 ? resolvedLibProcessing : resolvedLibProcessing = /* @__PURE__ */ new Map()).set(libFileName, result);
            return result;
        }
        function processLibReferenceDirectives(file) {
            forEach(file.libReferenceDirectives, (libReference, index)=>{
                const libFileName = getLibFileNameFromLibReference(libReference);
                if (libFileName) processRootFile(pathForLibFile(libFileName), /*isDefaultLib*/ true, /*ignoreNoDefaultLib*/ true, {
                    kind: 7 /* LibReferenceDirective */ ,
                    file: file.path,
                    index
                });
                else programDiagnostics.addFileProcessingDiagnostic({
                    kind: 0 /* FilePreprocessingLibReferenceDiagnostic */ ,
                    reason: {
                        kind: 7 /* LibReferenceDirective */ ,
                        file: file.path,
                        index
                    }
                });
            });
        }
        function getCanonicalFileName(fileName) {
            return host.getCanonicalFileName(fileName);
        }
        function processImportedModules(file) {
            collectExternalModuleReferences(file);
            if (file.imports.length || file.moduleAugmentations.length) {
                const moduleNames = getModuleNames(file);
                const resolutions = (resolvedModulesProcessing == null ? void 0 : resolvedModulesProcessing.get(file.path)) || resolveModuleNamesReusingOldState(moduleNames, file);
                Debug.assert(resolutions.length === moduleNames.length);
                const optionsForFile = getCompilerOptionsForFile(file);
                const resolutionsInFile = createModeAwareCache();
                (resolvedModules !== null && resolvedModules !== void 0 ? resolvedModules : resolvedModules = /* @__PURE__ */ new Map()).set(file.path, resolutionsInFile);
                for(let index = 0; index < moduleNames.length; index++){
                    const resolution = resolutions[index].resolvedModule;
                    const moduleName = moduleNames[index].text;
                    const mode = getModeForUsageLocationWorker(file, moduleNames[index], optionsForFile);
                    resolutionsInFile.set(moduleName, mode, resolutions[index]);
                    addResolutionDiagnosticsFromResolutionOrCache(file, moduleName, resolutions[index], mode);
                    if (!resolution) continue;
                    const isFromNodeModulesSearch = resolution.isExternalLibraryImport;
                    const isJsFile = !resolutionExtensionIsTSOrJson(resolution.extension) && !getRedirectFromSourceFile(resolution.resolvedFileName);
                    const isJsFileFromNodeModules = isFromNodeModulesSearch && isJsFile && (!resolution.originalPath || pathContainsNodeModules(resolution.resolvedFileName));
                    const resolvedFileName = resolution.resolvedFileName;
                    if (isFromNodeModulesSearch) currentNodeModulesDepth++;
                    const elideImport = isJsFileFromNodeModules && currentNodeModulesDepth > maxNodeModuleJsDepth;
                    const shouldAddFile = resolvedFileName && !getResolutionDiagnostic(optionsForFile, resolution, file) && !optionsForFile.noResolve && index < file.imports.length && !elideImport && !(isJsFile && !getAllowJSCompilerOption(optionsForFile)) && (isInJSFile(file.imports[index]) || !(file.imports[index].flags & 16777216 /* JSDoc */ ));
                    if (elideImport) modulesWithElidedImports.set(file.path, true);
                    else if (shouldAddFile) findSourceFile(resolvedFileName, /*isDefaultLib*/ false, /*ignoreNoDefaultLib*/ false, {
                        kind: 3 /* Import */ ,
                        file: file.path,
                        index
                    }, resolution.packageId);
                    if (isFromNodeModulesSearch) currentNodeModulesDepth--;
                }
            }
        }
        function checkSourceFilesBelongToPath(sourceFiles, rootDirectory) {
            let allFilesBelongToPath = true;
            const absoluteRootDirectoryPath = host.getCanonicalFileName(getNormalizedAbsolutePath(rootDirectory, currentDirectory));
            for (const sourceFile of sourceFiles)if (!sourceFile.isDeclarationFile) {
                const absoluteSourceFilePath = host.getCanonicalFileName(getNormalizedAbsolutePath(sourceFile.fileName, currentDirectory));
                if (absoluteSourceFilePath.indexOf(absoluteRootDirectoryPath) !== 0) {
                    programDiagnostics.addLazyConfigDiagnostic(sourceFile, Diagnostics.File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files, sourceFile.fileName, rootDirectory);
                    allFilesBelongToPath = false;
                }
            }
            return allFilesBelongToPath;
        }
        function parseProjectReferenceConfigFile(ref) {
            if (!projectReferenceRedirects) projectReferenceRedirects = /* @__PURE__ */ new Map();
            const refPath = resolveProjectReferencePath(ref);
            const sourceFilePath = toPath3(refPath);
            const fromCache = projectReferenceRedirects.get(sourceFilePath);
            if (fromCache !== void 0) return fromCache || void 0;
            let commandLine;
            let sourceFile;
            if (host.getParsedCommandLine) {
                commandLine = host.getParsedCommandLine(refPath);
                if (!commandLine) {
                    addFileToFilesByName(/*file*/ void 0, sourceFilePath, refPath, /*redirectedPath*/ void 0);
                    projectReferenceRedirects.set(sourceFilePath, false);
                    return void 0;
                }
                sourceFile = Debug.checkDefined(commandLine.options.configFile);
                Debug.assert(!sourceFile.path || sourceFile.path === sourceFilePath);
                addFileToFilesByName(sourceFile, sourceFilePath, refPath, /*redirectedPath*/ void 0);
            } else {
                const basePath = getNormalizedAbsolutePath(getDirectoryPath(refPath), currentDirectory);
                sourceFile = host.getSourceFile(refPath, 100 /* JSON */ );
                addFileToFilesByName(sourceFile, sourceFilePath, refPath, /*redirectedPath*/ void 0);
                if (sourceFile === void 0) {
                    projectReferenceRedirects.set(sourceFilePath, false);
                    return void 0;
                }
                commandLine = parseJsonSourceFileConfigFileContent(sourceFile, configParsingHost, basePath, /*existingOptions*/ void 0, refPath);
            }
            sourceFile.fileName = refPath;
            sourceFile.path = sourceFilePath;
            sourceFile.resolvedPath = sourceFilePath;
            sourceFile.originalFileName = refPath;
            const resolvedRef = {
                commandLine,
                sourceFile
            };
            projectReferenceRedirects.set(sourceFilePath, resolvedRef);
            if (options.configFile !== sourceFile) {
                mapSourceFileToResolvedRef !== null && mapSourceFileToResolvedRef !== void 0 ? mapSourceFileToResolvedRef : mapSourceFileToResolvedRef = /* @__PURE__ */ new Map();
                mapOutputFileToResolvedRef !== null && mapOutputFileToResolvedRef !== void 0 ? mapOutputFileToResolvedRef : mapOutputFileToResolvedRef = /* @__PURE__ */ new Map();
                let outDts;
                if (commandLine.options.outFile) {
                    outDts = changeExtension(commandLine.options.outFile, ".d.ts" /* Dts */ );
                    mapOutputFileToResolvedRef == null || mapOutputFileToResolvedRef.set(toPath3(outDts), {
                        resolvedRef
                    });
                }
                const getCommonSourceDirectory3 = memoize(()=>getCommonSourceDirectoryOfConfig(resolvedRef.commandLine, !host.useCaseSensitiveFileNames()));
                commandLine.fileNames.forEach((fileName)=>{
                    if (isDeclarationFileName(fileName)) return;
                    const path = toPath3(fileName);
                    let outputDts;
                    if (!fileExtensionIs(fileName, ".json" /* Json */ )) {
                        if (!commandLine.options.outFile) {
                            outputDts = getOutputDeclarationFileName(fileName, resolvedRef.commandLine, !host.useCaseSensitiveFileNames(), getCommonSourceDirectory3);
                            mapOutputFileToResolvedRef.set(toPath3(outputDts), {
                                resolvedRef,
                                source: fileName
                            });
                        } else outputDts = outDts;
                    }
                    mapSourceFileToResolvedRef.set(path, {
                        resolvedRef,
                        outputDts
                    });
                });
            }
            if (commandLine.projectReferences) resolvedRef.references = commandLine.projectReferences.map(parseProjectReferenceConfigFile);
            return resolvedRef;
        }
        function verifyCompilerOptions() {
            if (options.strictPropertyInitialization && !getStrictOptionValue(options, "strictNullChecks")) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "strictPropertyInitialization", "strictNullChecks");
            if (options.exactOptionalPropertyTypes && !getStrictOptionValue(options, "strictNullChecks")) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "exactOptionalPropertyTypes", "strictNullChecks");
            if (options.isolatedModules || options.verbatimModuleSyntax) {
                if (options.outFile) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "outFile", options.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules");
            }
            if (options.isolatedDeclarations) {
                if (getAllowJSCompilerOption(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "allowJs", "isolatedDeclarations");
                if (!getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "isolatedDeclarations", "declaration", "composite");
            }
            if (options.inlineSourceMap) {
                if (options.sourceMap) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "sourceMap", "inlineSourceMap");
                if (options.mapRoot) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "mapRoot", "inlineSourceMap");
            }
            if (options.composite) {
                if (options.declaration === false) createDiagnosticForOptionName(Diagnostics.Composite_projects_may_not_disable_declaration_emit, "declaration");
                if (options.incremental === false) createDiagnosticForOptionName(Diagnostics.Composite_projects_may_not_disable_incremental_compilation, "declaration");
            }
            const outputFile = options.outFile;
            if (!options.tsBuildInfoFile && options.incremental && !outputFile && !options.configFilePath) programDiagnostics.addConfigDiagnostic(createCompilerDiagnostic(Diagnostics.Option_incremental_can_only_be_specified_using_tsconfig_emitting_to_single_file_or_when_option_tsBuildInfoFile_is_specified));
            verifyDeprecatedCompilerOptions();
            verifyProjectReferences();
            if (options.composite) {
                const rootPaths = new Set(rootNames.map(toPath3));
                for (const file of files)if (sourceFileMayBeEmitted(file, program) && !rootPaths.has(file.path)) programDiagnostics.addLazyConfigDiagnostic(file, Diagnostics.File_0_is_not_listed_within_the_file_list_of_project_1_Projects_must_list_all_files_or_use_an_include_pattern, file.fileName, options.configFilePath || "");
            }
            if (options.paths) for(const key in options.paths){
                if (!hasProperty(options.paths, key)) continue;
                if (!hasZeroOrOneAsteriskCharacter(key)) createDiagnosticForOptionPaths(/*onKey*/ true, key, Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, key);
                if (isArray(options.paths[key])) {
                    const len = options.paths[key].length;
                    if (len === 0) createDiagnosticForOptionPaths(/*onKey*/ false, key, Diagnostics.Substitutions_for_pattern_0_shouldn_t_be_an_empty_array, key);
                    for(let i = 0; i < len; i++){
                        const subst = options.paths[key][i];
                        const typeOfSubst = typeof subst;
                        if (typeOfSubst === "string") {
                            if (!hasZeroOrOneAsteriskCharacter(subst)) createDiagnosticForOptionPathKeyValue(key, i, Diagnostics.Substitution_0_in_pattern_1_can_have_at_most_one_Asterisk_character, subst, key);
                            if (!options.baseUrl && !pathIsRelative(subst) && !pathIsAbsolute(subst)) createDiagnosticForOptionPathKeyValue(key, i, Diagnostics.Non_relative_paths_are_not_allowed_when_baseUrl_is_not_set_Did_you_forget_a_leading_Slash);
                        } else createDiagnosticForOptionPathKeyValue(key, i, Diagnostics.Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2, subst, key, typeOfSubst);
                    }
                } else createDiagnosticForOptionPaths(/*onKey*/ false, key, Diagnostics.Substitutions_for_pattern_0_should_be_an_array, key);
            }
            if (!options.sourceMap && !options.inlineSourceMap) {
                if (options.inlineSources) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "inlineSources");
                if (options.sourceRoot) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "sourceRoot");
            }
            if (options.mapRoot && !(options.sourceMap || options.declarationMap)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "mapRoot", "sourceMap", "declarationMap");
            if (options.declarationDir) {
                if (!getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "declarationDir", "declaration", "composite");
                if (outputFile) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "declarationDir", "outFile");
            }
            if (options.declarationMap && !getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "declarationMap", "declaration", "composite");
            if (options.lib && options.noLib) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "lib", "noLib");
            const languageVersion = getEmitScriptTarget(options);
            const firstNonAmbientExternalModuleSourceFile = find(files, (f)=>isExternalModule(f) && !f.isDeclarationFile);
            if (options.isolatedModules || options.verbatimModuleSyntax) {
                if (options.module === 0 /* None */  && languageVersion < 2 /* ES2015 */  && options.isolatedModules) createDiagnosticForOptionName(Diagnostics.Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher, "isolatedModules", "target");
                if (options.preserveConstEnums === false) createDiagnosticForOptionName(Diagnostics.Option_preserveConstEnums_cannot_be_disabled_when_0_is_enabled, options.verbatimModuleSyntax ? "verbatimModuleSyntax" : "isolatedModules", "preserveConstEnums");
            } else if (firstNonAmbientExternalModuleSourceFile && languageVersion < 2 /* ES2015 */  && options.module === 0 /* None */ ) {
                const span = getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, typeof firstNonAmbientExternalModuleSourceFile.externalModuleIndicator === "boolean" ? firstNonAmbientExternalModuleSourceFile : firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
                programDiagnostics.addConfigDiagnostic(createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span.start, span.length, Diagnostics.Cannot_use_imports_exports_or_module_augmentations_when_module_is_none));
            }
            if (outputFile && !options.emitDeclarationOnly) {
                if (options.module && !(options.module === 2 /* AMD */  || options.module === 4 /* System */ )) createDiagnosticForOptionName(Diagnostics.Only_amd_and_system_modules_are_supported_alongside_0, "outFile", "module");
                else if (options.module === void 0 && firstNonAmbientExternalModuleSourceFile) {
                    const span = getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, typeof firstNonAmbientExternalModuleSourceFile.externalModuleIndicator === "boolean" ? firstNonAmbientExternalModuleSourceFile : firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
                    programDiagnostics.addConfigDiagnostic(createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span.start, span.length, Diagnostics.Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system, "outFile"));
                }
            }
            if (getResolveJsonModule(options)) {
                if (getEmitModuleResolutionKind(options) === 1 /* Classic */ ) createDiagnosticForOptionName(Diagnostics.Option_resolveJsonModule_cannot_be_specified_when_moduleResolution_is_set_to_classic, "resolveJsonModule");
                else if (!hasJsonModuleEmitEnabled(options)) createDiagnosticForOptionName(Diagnostics.Option_resolveJsonModule_cannot_be_specified_when_module_is_set_to_none_system_or_umd, "resolveJsonModule", "module");
            }
            if (options.outDir || // there is --outDir specified
            options.rootDir || // there is --rootDir specified
            options.sourceRoot || // there is --sourceRoot specified
            options.mapRoot || // there is --mapRoot specified
            getEmitDeclarations(options) && options.declarationDir) {
                const dir = getCommonSourceDirectory2();
                if (options.outDir && dir === "" && files.some((file)=>getRootLength(file.fileName) > 1)) createDiagnosticForOptionName(Diagnostics.Cannot_find_the_common_subdirectory_path_for_the_input_files, "outDir");
            }
            if (options.checkJs && !getAllowJSCompilerOption(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "checkJs", "allowJs");
            if (options.emitDeclarationOnly) {
                if (!getEmitDeclarations(options)) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "emitDeclarationOnly", "declaration", "composite");
            }
            if (options.emitDecoratorMetadata && !options.experimentalDecorators) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "emitDecoratorMetadata", "experimentalDecorators");
            if (options.jsxFactory) {
                if (options.reactNamespace) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_with_option_1, "reactNamespace", "jsxFactory");
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "jsxFactory", inverseJsxOptionMap.get("" + options.jsx));
                if (!parseIsolatedEntityName(options.jsxFactory, languageVersion)) createOptionValueDiagnostic("jsxFactory", Diagnostics.Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name, options.jsxFactory);
            } else if (options.reactNamespace && !isIdentifierText(options.reactNamespace, languageVersion)) createOptionValueDiagnostic("reactNamespace", Diagnostics.Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier, options.reactNamespace);
            if (options.jsxFragmentFactory) {
                if (!options.jsxFactory) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "jsxFragmentFactory", "jsxFactory");
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "jsxFragmentFactory", inverseJsxOptionMap.get("" + options.jsx));
                if (!parseIsolatedEntityName(options.jsxFragmentFactory, languageVersion)) createOptionValueDiagnostic("jsxFragmentFactory", Diagnostics.Invalid_value_for_jsxFragmentFactory_0_is_not_a_valid_identifier_or_qualified_name, options.jsxFragmentFactory);
            }
            if (options.reactNamespace) {
                if (options.jsx === 4 /* ReactJSX */  || options.jsx === 5 /* ReactJSXDev */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "reactNamespace", inverseJsxOptionMap.get("" + options.jsx));
            }
            if (options.jsxImportSource) {
                if (options.jsx === 2 /* React */ ) createDiagnosticForOptionName(Diagnostics.Option_0_cannot_be_specified_when_option_jsx_is_1, "jsxImportSource", inverseJsxOptionMap.get("" + options.jsx));
            }
            const moduleKind = getEmitModuleKind(options);
            if (options.verbatimModuleSyntax) {
                if (moduleKind === 2 /* AMD */  || moduleKind === 3 /* UMD */  || moduleKind === 4 /* System */ ) createDiagnosticForOptionName(Diagnostics.Option_verbatimModuleSyntax_cannot_be_used_when_module_is_set_to_UMD_AMD_or_System, "verbatimModuleSyntax");
            }
            if (options.allowImportingTsExtensions && !(options.noEmit || options.emitDeclarationOnly || options.rewriteRelativeImportExtensions)) createOptionValueDiagnostic("allowImportingTsExtensions", Diagnostics.Option_allowImportingTsExtensions_can_only_be_used_when_either_noEmit_or_emitDeclarationOnly_is_set);
            const moduleResolution = getEmitModuleResolutionKind(options);
            if (options.resolvePackageJsonExports && !moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler, "resolvePackageJsonExports");
            if (options.resolvePackageJsonImports && !moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler, "resolvePackageJsonImports");
            if (options.customConditions && !moduleResolutionSupportsPackageJsonExportsAndImports(moduleResolution)) createDiagnosticForOptionName(Diagnostics.Option_0_can_only_be_used_when_moduleResolution_is_set_to_node16_nodenext_or_bundler, "customConditions");
            if (moduleResolution === 100 /* Bundler */  && !emitModuleKindIsNonNodeESM(moduleKind) && moduleKind !== 200 /* Preserve */ ) createOptionValueDiagnostic("moduleResolution", Diagnostics.Option_0_can_only_be_used_when_module_is_set_to_preserve_or_to_es2015_or_later, "bundler");
            if (ModuleKind[moduleKind] && 100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  && !(3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */ )) {
                const moduleKindName = ModuleKind[moduleKind];
                const moduleResolutionName = ModuleResolutionKind[moduleKindName] ? moduleKindName : "Node16";
                createOptionValueDiagnostic("moduleResolution", Diagnostics.Option_moduleResolution_must_be_set_to_0_or_left_unspecified_when_option_module_is_set_to_1, moduleResolutionName, moduleKindName);
            } else if (ModuleResolutionKind[moduleResolution] && 3 /* Node16 */  <= moduleResolution && moduleResolution <= 99 /* NodeNext */  && !(100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ )) {
                const moduleResolutionName = ModuleResolutionKind[moduleResolution];
                createOptionValueDiagnostic("module", Diagnostics.Option_module_must_be_set_to_0_when_option_moduleResolution_is_set_to_1, moduleResolutionName, moduleResolutionName);
            }
            if (!options.noEmit && !options.suppressOutputPathCheck) {
                const emitHost = getEmitHost();
                const emitFilesSeen = /* @__PURE__ */ new Set();
                forEachEmittedFile(emitHost, (emitFileNames)=>{
                    if (!options.emitDeclarationOnly) verifyEmitFilePath(emitFileNames.jsFilePath, emitFilesSeen);
                    verifyEmitFilePath(emitFileNames.declarationFilePath, emitFilesSeen);
                });
            }
            function verifyEmitFilePath(emitFileName, emitFilesSeen) {
                if (emitFileName) {
                    const emitFilePath = toPath3(emitFileName);
                    if (filesByName.has(emitFilePath)) {
                        let chain;
                        if (!options.configFilePath) chain = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig);
                        chain = chainDiagnosticMessages(chain, Diagnostics.Cannot_write_file_0_because_it_would_overwrite_input_file, emitFileName);
                        blockEmittingOfFile(emitFileName, createCompilerDiagnosticFromMessageChain(chain));
                    }
                    const emitFileKey = !host.useCaseSensitiveFileNames() ? toFileNameLowerCase(emitFilePath) : emitFilePath;
                    if (emitFilesSeen.has(emitFileKey)) blockEmittingOfFile(emitFileName, createCompilerDiagnostic(Diagnostics.Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files, emitFileName));
                    else emitFilesSeen.add(emitFileKey);
                }
            }
        }
        function getIgnoreDeprecationsVersion() {
            const ignoreDeprecations = options.ignoreDeprecations;
            if (ignoreDeprecations) {
                if (ignoreDeprecations === "5.0") return new Version(ignoreDeprecations);
                reportInvalidIgnoreDeprecations();
            }
            return Version.zero;
        }
        function checkDeprecations(deprecatedIn, removedIn, createDiagnostic, fn) {
            const deprecatedInVersion = new Version(deprecatedIn);
            const removedInVersion = new Version(removedIn);
            const typescriptVersion = new Version(typeScriptVersion3 || versionMajorMinor);
            const ignoreDeprecationsVersion = getIgnoreDeprecationsVersion();
            const mustBeRemoved = !(removedInVersion.compareTo(typescriptVersion) === 1 /* GreaterThan */ );
            const canBeSilenced = !mustBeRemoved && ignoreDeprecationsVersion.compareTo(deprecatedInVersion) === -1 /* LessThan */ ;
            if (mustBeRemoved || canBeSilenced) fn((name, value1, useInstead)=>{
                if (mustBeRemoved) {
                    if (value1 === void 0) createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_has_been_removed_Please_remove_it_from_your_configuration, name);
                    else createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_1_has_been_removed_Please_remove_it_from_your_configuration, name, value1);
                } else if (value1 === void 0) createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_is_deprecated_and_will_stop_functioning_in_TypeScript_1_Specify_compilerOption_ignoreDeprecations_Colon_2_to_silence_this_error, name, removedIn, deprecatedIn);
                else createDiagnostic(name, value1, useInstead, Diagnostics.Option_0_1_is_deprecated_and_will_stop_functioning_in_TypeScript_2_Specify_compilerOption_ignoreDeprecations_Colon_3_to_silence_this_error, name, value1, removedIn, deprecatedIn);
            });
        }
        function verifyDeprecatedCompilerOptions() {
            function createDiagnostic(name, value1, useInstead, message, ...args) {
                if (useInstead) {
                    const details = chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Use_0_instead, useInstead);
                    const chain = chainDiagnosticMessages(details, message, ...args);
                    createDiagnosticForOption(/*onKey*/ !value1, name, /*option2*/ void 0, chain);
                } else createDiagnosticForOption(/*onKey*/ !value1, name, /*option2*/ void 0, message, ...args);
            }
            checkDeprecations("5.0", "5.5", createDiagnostic, (createDeprecatedDiagnostic)=>{
                if (options.target === 0 /* ES3 */ ) createDeprecatedDiagnostic("target", "ES3");
                if (options.noImplicitUseStrict) createDeprecatedDiagnostic("noImplicitUseStrict");
                if (options.keyofStringsOnly) createDeprecatedDiagnostic("keyofStringsOnly");
                if (options.suppressExcessPropertyErrors) createDeprecatedDiagnostic("suppressExcessPropertyErrors");
                if (options.suppressImplicitAnyIndexErrors) createDeprecatedDiagnostic("suppressImplicitAnyIndexErrors");
                if (options.noStrictGenericChecks) createDeprecatedDiagnostic("noStrictGenericChecks");
                if (options.charset) createDeprecatedDiagnostic("charset");
                if (options.out) createDeprecatedDiagnostic("out", /*value*/ void 0, "outFile");
                if (options.importsNotUsedAsValues) createDeprecatedDiagnostic("importsNotUsedAsValues", /*value*/ void 0, "verbatimModuleSyntax");
                if (options.preserveValueImports) createDeprecatedDiagnostic("preserveValueImports", /*value*/ void 0, "verbatimModuleSyntax");
            });
        }
        function verifyDeprecatedProjectReference(ref, parentFile, index) {
            function createDiagnostic(_name, _value, _useInstead, message, ...args) {
                createDiagnosticForReference(parentFile, index, message, ...args);
            }
            checkDeprecations("5.0", "5.5", createDiagnostic, (createDeprecatedDiagnostic)=>{
                if (ref.prepend) createDeprecatedDiagnostic("prepend");
            });
        }
        function addFilePreprocessingFileExplainingDiagnostic(file, fileProcessingReason, diagnostic, args) {
            programDiagnostics.addFileProcessingDiagnostic({
                kind: 1 /* FilePreprocessingFileExplainingDiagnostic */ ,
                file: file && file.path,
                fileProcessingReason,
                diagnostic,
                args
            });
        }
        function verifyProjectReferences() {
            const buildInfoPath = !options.suppressOutputPathCheck ? getTsBuildInfoEmitOutputFilePath(options) : void 0;
            forEachProjectReference(projectReferences, resolvedProjectReferences, (resolvedRef, parent2, index)=>{
                const ref = (parent2 ? parent2.commandLine.projectReferences : projectReferences)[index];
                const parentFile = parent2 && parent2.sourceFile;
                verifyDeprecatedProjectReference(ref, parentFile, index);
                if (!resolvedRef) {
                    createDiagnosticForReference(parentFile, index, Diagnostics.File_0_not_found, ref.path);
                    return;
                }
                const options2 = resolvedRef.commandLine.options;
                if (!options2.composite || options2.noEmit) {
                    const inputs = parent2 ? parent2.commandLine.fileNames : rootNames;
                    if (inputs.length) {
                        if (!options2.composite) createDiagnosticForReference(parentFile, index, Diagnostics.Referenced_project_0_must_have_setting_composite_Colon_true, ref.path);
                        if (options2.noEmit) createDiagnosticForReference(parentFile, index, Diagnostics.Referenced_project_0_may_not_disable_emit, ref.path);
                    }
                }
                if (!parent2 && buildInfoPath && buildInfoPath === getTsBuildInfoEmitOutputFilePath(options2)) {
                    createDiagnosticForReference(parentFile, index, Diagnostics.Cannot_write_file_0_because_it_will_overwrite_tsbuildinfo_file_generated_by_referenced_project_1, buildInfoPath, ref.path);
                    hasEmitBlockingDiagnostics.set(toPath3(buildInfoPath), true);
                }
            });
        }
        function createDiagnosticForOptionPathKeyValue(key, valueIndex, message, ...args) {
            let needCompilerDiagnostic = true;
            forEachOptionPathsSyntax((pathProp)=>{
                if (isObjectLiteralExpression(pathProp.initializer)) forEachPropertyAssignment(pathProp.initializer, key, (keyProps)=>{
                    const initializer = keyProps.initializer;
                    if (isArrayLiteralExpression(initializer) && initializer.elements.length > valueIndex) {
                        programDiagnostics.addConfigDiagnostic(createDiagnosticForNodeInSourceFile(options.configFile, initializer.elements[valueIndex], message, ...args));
                        needCompilerDiagnostic = false;
                    }
                });
            });
            if (needCompilerDiagnostic) createCompilerOptionsDiagnostic(message, ...args);
        }
        function createDiagnosticForOptionPaths(onKey, key, message, ...args) {
            let needCompilerDiagnostic = true;
            forEachOptionPathsSyntax((pathProp)=>{
                if (isObjectLiteralExpression(pathProp.initializer) && createOptionDiagnosticInObjectLiteralSyntax(pathProp.initializer, onKey, key, /*key2*/ void 0, message, ...args)) needCompilerDiagnostic = false;
            });
            if (needCompilerDiagnostic) createCompilerOptionsDiagnostic(message, ...args);
        }
        function forEachOptionPathsSyntax(callback) {
            return forEachOptionsSyntaxByName(getCompilerOptionsObjectLiteralSyntax(), "paths", callback);
        }
        function createDiagnosticForOptionName(message, option1, option2, option3) {
            createDiagnosticForOption(/*onKey*/ true, option1, option2, message, option1, option2, option3);
        }
        function createOptionValueDiagnostic(option1, message, ...args) {
            createDiagnosticForOption(/*onKey*/ false, option1, /*option2*/ void 0, message, ...args);
        }
        function createDiagnosticForReference(sourceFile, index, message, ...args) {
            const referencesSyntax = forEachTsConfigPropArray(sourceFile || options.configFile, "references", (property)=>isArrayLiteralExpression(property.initializer) ? property.initializer : void 0);
            if (referencesSyntax && referencesSyntax.elements.length > index) programDiagnostics.addConfigDiagnostic(createDiagnosticForNodeInSourceFile(sourceFile || options.configFile, referencesSyntax.elements[index], message, ...args));
            else programDiagnostics.addConfigDiagnostic(createCompilerDiagnostic(message, ...args));
        }
        function createDiagnosticForOption(onKey, option1, option2, message, ...args) {
            const compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
            const needCompilerDiagnostic = !compilerOptionsObjectLiteralSyntax || !createOptionDiagnosticInObjectLiteralSyntax(compilerOptionsObjectLiteralSyntax, onKey, option1, option2, message, ...args);
            if (needCompilerDiagnostic) createCompilerOptionsDiagnostic(message, ...args);
        }
        function createCompilerOptionsDiagnostic(message, ...args) {
            const compilerOptionsProperty = getCompilerOptionsPropertySyntax();
            if (compilerOptionsProperty) {
                if ("messageText" in message) programDiagnostics.addConfigDiagnostic(createDiagnosticForNodeFromMessageChain(options.configFile, compilerOptionsProperty.name, message));
                else programDiagnostics.addConfigDiagnostic(createDiagnosticForNodeInSourceFile(options.configFile, compilerOptionsProperty.name, message, ...args));
            } else if ("messageText" in message) programDiagnostics.addConfigDiagnostic(createCompilerDiagnosticFromMessageChain(message));
            else programDiagnostics.addConfigDiagnostic(createCompilerDiagnostic(message, ...args));
        }
        function getCompilerOptionsObjectLiteralSyntax() {
            if (_compilerOptionsObjectLiteralSyntax === void 0) {
                const compilerOptionsProperty = getCompilerOptionsPropertySyntax();
                _compilerOptionsObjectLiteralSyntax = compilerOptionsProperty ? tryCast(compilerOptionsProperty.initializer, isObjectLiteralExpression) || false : false;
            }
            return _compilerOptionsObjectLiteralSyntax || void 0;
        }
        function getCompilerOptionsPropertySyntax() {
            if (_compilerOptionsPropertySyntax === void 0) _compilerOptionsPropertySyntax = forEachPropertyAssignment(getTsConfigObjectLiteralExpression(options.configFile), "compilerOptions", identity) || false;
            return _compilerOptionsPropertySyntax || void 0;
        }
        function createOptionDiagnosticInObjectLiteralSyntax(objectLiteral, onKey, key1, key2, message, ...args) {
            let needsCompilerDiagnostic = false;
            forEachPropertyAssignment(objectLiteral, key1, (prop)=>{
                if ("messageText" in message) programDiagnostics.addConfigDiagnostic(createDiagnosticForNodeFromMessageChain(options.configFile, onKey ? prop.name : prop.initializer, message));
                else programDiagnostics.addConfigDiagnostic(createDiagnosticForNodeInSourceFile(options.configFile, onKey ? prop.name : prop.initializer, message, ...args));
                needsCompilerDiagnostic = true;
            }, key2);
            return needsCompilerDiagnostic;
        }
        function blockEmittingOfFile(emitFileName, diag2) {
            hasEmitBlockingDiagnostics.set(toPath3(emitFileName), true);
            programDiagnostics.addConfigDiagnostic(diag2);
        }
        function isEmittedFile(file) {
            if (options.noEmit) return false;
            const filePath = toPath3(file);
            if (getSourceFileByPath(filePath)) return false;
            const out = options.outFile;
            if (out) return isSameFile(filePath, out) || isSameFile(filePath, removeFileExtension(out) + ".d.ts" /* Dts */ );
            if (options.declarationDir && containsPath(options.declarationDir, filePath, currentDirectory, !host.useCaseSensitiveFileNames())) return true;
            if (options.outDir) return containsPath(options.outDir, filePath, currentDirectory, !host.useCaseSensitiveFileNames());
            if (fileExtensionIsOneOf(filePath, supportedJSExtensionsFlat) || isDeclarationFileName(filePath)) {
                const filePathWithoutExtension = removeFileExtension(filePath);
                return !!getSourceFileByPath(filePathWithoutExtension + ".ts" /* Ts */ ) || !!getSourceFileByPath(filePathWithoutExtension + ".tsx" /* Tsx */ );
            }
            return false;
        }
        function isSameFile(file1, file2) {
            return comparePaths(file1, file2, currentDirectory, !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */ ;
        }
        function getSymlinkCache() {
            if (host.getSymlinkCache) return host.getSymlinkCache();
            if (!symlinks) symlinks = createSymlinkCache(currentDirectory, getCanonicalFileName);
            if (files && !symlinks.hasProcessedResolutions()) symlinks.setSymlinksFromResolutions(forEachResolvedModule, forEachResolvedTypeReferenceDirective, automaticTypeDirectiveResolutions);
            return symlinks;
        }
        function getModeForUsageLocation2(file, usage) {
            return getModeForUsageLocationWorker(file, usage, getCompilerOptionsForFile(file));
        }
        function getEmitSyntaxForUsageLocation(file, usage) {
            return getEmitSyntaxForUsageLocationWorker(file, usage, getCompilerOptionsForFile(file));
        }
        function getModeForResolutionAtIndex2(file, index) {
            return getModeForUsageLocation2(file, getModuleNameStringLiteralAt(file, index));
        }
        function getDefaultResolutionModeForFile2(sourceFile) {
            return getDefaultResolutionModeForFileWorker(sourceFile, getCompilerOptionsForFile(sourceFile));
        }
        function getImpliedNodeFormatForEmit2(sourceFile) {
            return getImpliedNodeFormatForEmitWorker(sourceFile, getCompilerOptionsForFile(sourceFile));
        }
        function getEmitModuleFormatOfFile2(sourceFile) {
            return getEmitModuleFormatOfFileWorker(sourceFile, getCompilerOptionsForFile(sourceFile));
        }
        function shouldTransformImportCall(sourceFile) {
            return shouldTransformImportCallWorker(sourceFile, getCompilerOptionsForFile(sourceFile));
        }
        function getModeForTypeReferenceDirectiveInFile(ref, sourceFile) {
            return ref.resolutionMode || getDefaultResolutionModeForFile2(sourceFile);
        }
    }
    function shouldTransformImportCallWorker(sourceFile, options) {
        const moduleKind = getEmitModuleKind(options);
        if (100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */  || moduleKind === 200 /* Preserve */ ) return false;
        return getEmitModuleFormatOfFileWorker(sourceFile, options) < 5 /* ES2015 */ ;
    }
    function getEmitModuleFormatOfFileWorker(sourceFile, options) {
        var _getImpliedNodeFormatForEmitWorker;
        return (_getImpliedNodeFormatForEmitWorker = getImpliedNodeFormatForEmitWorker(sourceFile, options)) !== null && _getImpliedNodeFormatForEmitWorker !== void 0 ? _getImpliedNodeFormatForEmitWorker : getEmitModuleKind(options);
    }
    function getImpliedNodeFormatForEmitWorker(sourceFile, options) {
        var _a, _b;
        const moduleKind = getEmitModuleKind(options);
        if (100 /* Node16 */  <= moduleKind && moduleKind <= 199 /* NodeNext */ ) return sourceFile.impliedNodeFormat;
        if (sourceFile.impliedNodeFormat === 1 /* CommonJS */  && (((_a = sourceFile.packageJsonScope) == null ? void 0 : _a.contents.packageJsonContent.type) === "commonjs" || fileExtensionIsOneOf(sourceFile.fileName, [
            ".cjs" /* Cjs */ ,
            ".cts" /* Cts */ 
        ]))) return 1 /* CommonJS */ ;
        if (sourceFile.impliedNodeFormat === 99 /* ESNext */  && (((_b = sourceFile.packageJsonScope) == null ? void 0 : _b.contents.packageJsonContent.type) === "module" || fileExtensionIsOneOf(sourceFile.fileName, [
            ".mjs" /* Mjs */ ,
            ".mts" /* Mts */ 
        ]))) return 99 /* ESNext */ ;
        return void 0;
    }
    function getDefaultResolutionModeForFileWorker(sourceFile, options) {
        return importSyntaxAffectsModuleResolution(options) ? getImpliedNodeFormatForEmitWorker(sourceFile, options) : void 0;
    }
    function updateHostForUseSourceOfProjectReferenceRedirect(host) {
        let setOfDeclarationDirectories;
        const originalFileExists = host.compilerHost.fileExists;
        const originalDirectoryExists = host.compilerHost.directoryExists;
        const originalGetDirectories = host.compilerHost.getDirectories;
        const originalRealpath = host.compilerHost.realpath;
        if (!host.useSourceOfProjectReferenceRedirect) return {
            onProgramCreateComplete: noop,
            fileExists
        };
        host.compilerHost.fileExists = fileExists;
        let directoryExists;
        if (originalDirectoryExists) directoryExists = host.compilerHost.directoryExists = (path)=>{
            if (originalDirectoryExists.call(host.compilerHost, path)) {
                handleDirectoryCouldBeSymlink(path);
                return true;
            }
            if (!host.getResolvedProjectReferences()) return false;
            if (!setOfDeclarationDirectories) {
                setOfDeclarationDirectories = /* @__PURE__ */ new Set();
                host.forEachResolvedProjectReference((ref)=>{
                    const out = ref.commandLine.options.outFile;
                    if (out) setOfDeclarationDirectories.add(getDirectoryPath(host.toPath(out)));
                    else {
                        const declarationDir = ref.commandLine.options.declarationDir || ref.commandLine.options.outDir;
                        if (declarationDir) setOfDeclarationDirectories.add(host.toPath(declarationDir));
                    }
                });
            }
            return fileOrDirectoryExistsUsingSource(path, /*isFile*/ false);
        };
        if (originalGetDirectories) host.compilerHost.getDirectories = (path)=>!host.getResolvedProjectReferences() || originalDirectoryExists && originalDirectoryExists.call(host.compilerHost, path) ? originalGetDirectories.call(host.compilerHost, path) : [];
        if (originalRealpath) host.compilerHost.realpath = (s)=>{
            var _a;
            return ((_a = host.getSymlinkCache().getSymlinkedFiles()) == null ? void 0 : _a.get(host.toPath(s))) || originalRealpath.call(host.compilerHost, s);
        };
        return {
            onProgramCreateComplete,
            fileExists,
            directoryExists
        };
        function onProgramCreateComplete() {
            host.compilerHost.fileExists = originalFileExists;
            host.compilerHost.directoryExists = originalDirectoryExists;
            host.compilerHost.getDirectories = originalGetDirectories;
        }
        function fileExists(file) {
            if (originalFileExists.call(host.compilerHost, file)) return true;
            if (!host.getResolvedProjectReferences()) return false;
            if (!isDeclarationFileName(file)) return false;
            return fileOrDirectoryExistsUsingSource(file, /*isFile*/ true);
        }
        function fileExistsIfProjectReferenceDts(file) {
            const source = host.getRedirectFromOutput(host.toPath(file));
            return source !== void 0 ? isString(source.source) ? originalFileExists.call(host.compilerHost, source.source) : true : void 0;
        }
        function directoryExistsIfProjectReferenceDeclDir(dir) {
            const dirPath = host.toPath(dir);
            const dirPathWithTrailingDirectorySeparator = `${dirPath}${directorySeparator}`;
            return forEachKey(setOfDeclarationDirectories, (declDirPath)=>dirPath === declDirPath || // Any parent directory of declaration dir
                startsWith(declDirPath, dirPathWithTrailingDirectorySeparator) || // Any directory inside declaration dir
                startsWith(dirPath, `${declDirPath}/`));
        }
        function handleDirectoryCouldBeSymlink(directory) {
            var _a;
            if (!host.getResolvedProjectReferences() || containsIgnoredPath(directory)) return;
            if (!originalRealpath || !directory.includes(nodeModulesPathPart)) return;
            const symlinkCache = host.getSymlinkCache();
            const directoryPath = ensureTrailingDirectorySeparator(host.toPath(directory));
            if ((_a = symlinkCache.getSymlinkedDirectories()) == null ? void 0 : _a.has(directoryPath)) return;
            const real = normalizePath(originalRealpath.call(host.compilerHost, directory));
            let realPath2;
            if (real === directory || (realPath2 = ensureTrailingDirectorySeparator(host.toPath(real))) === directoryPath) {
                symlinkCache.setSymlinkedDirectory(directoryPath, false);
                return;
            }
            symlinkCache.setSymlinkedDirectory(directory, {
                real: ensureTrailingDirectorySeparator(real),
                realPath: realPath2
            });
        }
        function fileOrDirectoryExistsUsingSource(fileOrDirectory, isFile) {
            var _a;
            const fileOrDirectoryExistsUsingSource2 = isFile ? fileExistsIfProjectReferenceDts : directoryExistsIfProjectReferenceDeclDir;
            const result = fileOrDirectoryExistsUsingSource2(fileOrDirectory);
            if (result !== void 0) return result;
            const symlinkCache = host.getSymlinkCache();
            const symlinkedDirectories = symlinkCache.getSymlinkedDirectories();
            if (!symlinkedDirectories) return false;
            const fileOrDirectoryPath = host.toPath(fileOrDirectory);
            if (!fileOrDirectoryPath.includes(nodeModulesPathPart)) return false;
            if (isFile && ((_a = symlinkCache.getSymlinkedFiles()) == null ? void 0 : _a.has(fileOrDirectoryPath))) return true;
            return firstDefinedIterator(symlinkedDirectories.entries(), ([directoryPath, symlinkedDirectory])=>{
                if (!symlinkedDirectory || !startsWith(fileOrDirectoryPath, directoryPath)) return void 0;
                const result2 = fileOrDirectoryExistsUsingSource2(fileOrDirectoryPath.replace(directoryPath, symlinkedDirectory.realPath));
                if (isFile && result2) {
                    const absolutePath = getNormalizedAbsolutePath(fileOrDirectory, host.compilerHost.getCurrentDirectory());
                    symlinkCache.setSymlinkedFile(fileOrDirectoryPath, `${symlinkedDirectory.real}${absolutePath.replace(new RegExp(directoryPath, "i"), "")}`);
                }
                return result2;
            }) || false;
        }
    }
    var emitSkippedWithNoDiagnostics = {
        diagnostics: emptyArray,
        sourceMaps: void 0,
        emittedFiles: void 0,
        emitSkipped: true
    };
    function handleNoEmitOptions(program, sourceFile, writeFile2, cancellationToken) {
        const options = program.getCompilerOptions();
        if (options.noEmit) return sourceFile ? emitSkippedWithNoDiagnostics : program.emitBuildInfo(writeFile2, cancellationToken);
        if (!options.noEmitOnError) return void 0;
        let diagnostics = [
            ...program.getOptionsDiagnostics(cancellationToken),
            ...program.getSyntacticDiagnostics(sourceFile, cancellationToken),
            ...program.getGlobalDiagnostics(cancellationToken),
            ...program.getSemanticDiagnostics(sourceFile, cancellationToken)
        ];
        if (diagnostics.length === 0 && getEmitDeclarations(program.getCompilerOptions())) diagnostics = program.getDeclarationDiagnostics(/*sourceFile*/ void 0, cancellationToken);
        if (!diagnostics.length) return void 0;
        let emittedFiles;
        if (!sourceFile) {
            const emitResult = program.emitBuildInfo(writeFile2, cancellationToken);
            if (emitResult.diagnostics) diagnostics = [
                ...diagnostics,
                ...emitResult.diagnostics
            ];
            emittedFiles = emitResult.emittedFiles;
        }
        return {
            diagnostics,
            sourceMaps: void 0,
            emittedFiles,
            emitSkipped: true
        };
    }
    function filterSemanticDiagnostics(diagnostic, option) {
        return filter(diagnostic, (d)=>!d.skippedOn || !option[d.skippedOn]);
    }
    function parseConfigHostFromCompilerHostLike(host, directoryStructureHost = host) {
        return {
            fileExists: (f)=>directoryStructureHost.fileExists(f),
            readDirectory (root, extensions, excludes, includes, depth) {
                Debug.assertIsDefined(directoryStructureHost.readDirectory, "'CompilerHost.readDirectory' must be implemented to correctly process 'projectReferences'");
                return directoryStructureHost.readDirectory(root, extensions, excludes, includes, depth);
            },
            readFile: (f)=>directoryStructureHost.readFile(f),
            directoryExists: maybeBind(directoryStructureHost, directoryStructureHost.directoryExists),
            getDirectories: maybeBind(directoryStructureHost, directoryStructureHost.getDirectories),
            realpath: maybeBind(directoryStructureHost, directoryStructureHost.realpath),
            useCaseSensitiveFileNames: host.useCaseSensitiveFileNames(),
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            onUnRecoverableConfigFileDiagnostic: host.onUnRecoverableConfigFileDiagnostic || returnUndefined,
            trace: host.trace ? (s)=>host.trace(s) : void 0
        };
    }
    function resolveProjectReferencePath(ref) {
        return resolveConfigFileProjectName(ref.path);
    }
    function getResolutionDiagnostic(options, { extension }, { isDeclarationFile }) {
        switch(extension){
            case ".ts" /* Ts */ :
            case ".d.ts" /* Dts */ :
            case ".mts" /* Mts */ :
            case ".d.mts" /* Dmts */ :
            case ".cts" /* Cts */ :
            case ".d.cts" /* Dcts */ :
                return void 0;
            case ".tsx" /* Tsx */ :
                return needJsx();
            case ".jsx" /* Jsx */ :
                return needJsx() || needAllowJs();
            case ".js" /* Js */ :
            case ".mjs" /* Mjs */ :
            case ".cjs" /* Cjs */ :
                return needAllowJs();
            case ".json" /* Json */ :
                return needResolveJsonModule();
            default:
                return needAllowArbitraryExtensions();
        }
        function needJsx() {
            return options.jsx ? void 0 : Diagnostics.Module_0_was_resolved_to_1_but_jsx_is_not_set;
        }
        function needAllowJs() {
            return getAllowJSCompilerOption(options) || !getStrictOptionValue(options, "noImplicitAny") ? void 0 : Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type;
        }
        function needResolveJsonModule() {
            return getResolveJsonModule(options) ? void 0 : Diagnostics.Module_0_was_resolved_to_1_but_resolveJsonModule_is_not_used;
        }
        function needAllowArbitraryExtensions() {
            return isDeclarationFile || options.allowArbitraryExtensions ? void 0 : Diagnostics.Module_0_was_resolved_to_1_but_allowArbitraryExtensions_is_not_set;
        }
    }
    function getModuleNames({ imports, moduleAugmentations }) {
        const res = imports.map((i)=>i);
        for (const aug of moduleAugmentations)if (aug.kind === 11 /* StringLiteral */ ) res.push(aug);
        return res;
    }
    function getModuleNameStringLiteralAt({ imports, moduleAugmentations }, index) {
        if (index < imports.length) return imports[index];
        let augIndex = imports.length;
        for (const aug of moduleAugmentations)if (aug.kind === 11 /* StringLiteral */ ) {
            if (index === augIndex) return aug;
            augIndex++;
        }
        Debug.fail("should never ask for module name at index higher than possible module name");
    }
    // src/compiler/programDiagnostics.ts
    function createProgramDiagnostics(getCompilerOptionsObjectLiteralSyntax) {
        let computedDiagnostics;
        let fileReasons = createMultiMap();
        let fileProcessingDiagnostics;
        let commonSourceDirectory;
        let configDiagnostics;
        let lazyConfigDiagnostics;
        let fileReasonsToChain;
        let reasonToRelatedInfo;
        return {
            addConfigDiagnostic (diag2) {
                Debug.assert(computedDiagnostics === void 0, "Cannot modify program diagnostic state after requesting combined diagnostics");
                (configDiagnostics !== null && configDiagnostics !== void 0 ? configDiagnostics : configDiagnostics = createDiagnosticCollection()).add(diag2);
            },
            addLazyConfigDiagnostic (file, message, ...args) {
                Debug.assert(computedDiagnostics === void 0, "Cannot modify program diagnostic state after requesting combined diagnostics");
                (lazyConfigDiagnostics !== null && lazyConfigDiagnostics !== void 0 ? lazyConfigDiagnostics : lazyConfigDiagnostics = []).push({
                    file,
                    diagnostic: message,
                    args
                });
            },
            addFileProcessingDiagnostic (diag2) {
                Debug.assert(computedDiagnostics === void 0, "Cannot modify program diagnostic state after requesting combined diagnostics");
                (fileProcessingDiagnostics !== null && fileProcessingDiagnostics !== void 0 ? fileProcessingDiagnostics : fileProcessingDiagnostics = []).push(diag2);
            },
            setCommonSourceDirectory (directory) {
                commonSourceDirectory = directory;
            },
            reuseStateFromOldProgram (oldProgramDiagnostics, isConfigIdentical) {
                fileReasons = oldProgramDiagnostics.getFileReasons();
                fileProcessingDiagnostics = oldProgramDiagnostics.getFileProcessingDiagnostics();
                if (isConfigIdentical) {
                    commonSourceDirectory = oldProgramDiagnostics.getCommonSourceDirectory();
                    configDiagnostics = oldProgramDiagnostics.getConfigDiagnostics();
                    lazyConfigDiagnostics = oldProgramDiagnostics.getLazyConfigDiagnostics();
                }
            },
            getFileProcessingDiagnostics () {
                return fileProcessingDiagnostics;
            },
            getFileReasons () {
                return fileReasons;
            },
            getCommonSourceDirectory () {
                return commonSourceDirectory;
            },
            getConfigDiagnostics () {
                return configDiagnostics;
            },
            getLazyConfigDiagnostics () {
                return lazyConfigDiagnostics;
            },
            getCombinedDiagnostics (program) {
                if (computedDiagnostics) return computedDiagnostics;
                computedDiagnostics = createDiagnosticCollection();
                configDiagnostics == null || configDiagnostics.getDiagnostics().forEach((d)=>computedDiagnostics.add(d));
                fileProcessingDiagnostics == null || fileProcessingDiagnostics.forEach((diagnostic)=>{
                    switch(diagnostic.kind){
                        case 1 /* FilePreprocessingFileExplainingDiagnostic */ :
                            return computedDiagnostics.add(createDiagnosticExplainingFile(program, diagnostic.file && program.getSourceFileByPath(diagnostic.file), diagnostic.fileProcessingReason, diagnostic.diagnostic, diagnostic.args || emptyArray));
                        case 0 /* FilePreprocessingLibReferenceDiagnostic */ :
                            return computedDiagnostics.add(filePreprocessingLibreferenceDiagnostic(program, diagnostic));
                        case 2 /* ResolutionDiagnostics */ :
                            return diagnostic.diagnostics.forEach((d)=>computedDiagnostics.add(d));
                        default:
                            Debug.assertNever(diagnostic);
                    }
                });
                lazyConfigDiagnostics == null || lazyConfigDiagnostics.forEach(({ file, diagnostic, args })=>computedDiagnostics.add(createDiagnosticExplainingFile(program, file, /*fileProcessingReason*/ void 0, diagnostic, args)));
                fileReasonsToChain = void 0;
                reasonToRelatedInfo = void 0;
                return computedDiagnostics;
            }
        };
        function filePreprocessingLibreferenceDiagnostic(program, { reason }) {
            const { file, pos, end } = getReferencedFileLocation(program, reason);
            const libReference = file.libReferenceDirectives[reason.index];
            const libName = getLibNameFromLibReference(libReference);
            const unqualifiedLibName = removeSuffix(removePrefix(libName, "lib."), ".d.ts");
            const suggestion = getSpellingSuggestion(unqualifiedLibName, libs, identity);
            return createFileDiagnostic(file, Debug.checkDefined(pos), Debug.checkDefined(end) - pos, suggestion ? Diagnostics.Cannot_find_lib_definition_for_0_Did_you_mean_1 : Diagnostics.Cannot_find_lib_definition_for_0, libName, suggestion);
        }
        function createDiagnosticExplainingFile(program, file, fileProcessingReason, diagnostic, args) {
            let seenReasons;
            let fileIncludeReasons;
            let relatedInfo;
            let fileIncludeReasonDetails;
            let redirectInfo;
            let chain;
            const reasons = file && fileReasons.get(file.path);
            let locationReason = isReferencedFile(fileProcessingReason) ? fileProcessingReason : void 0;
            let cachedChain = file && (fileReasonsToChain == null ? void 0 : fileReasonsToChain.get(file.path));
            if (cachedChain) {
                if (cachedChain.fileIncludeReasonDetails) {
                    seenReasons = new Set(reasons);
                    reasons == null || reasons.forEach(populateRelatedInfo);
                } else reasons == null || reasons.forEach(processReason);
                redirectInfo = cachedChain.redirectInfo;
            } else {
                reasons == null || reasons.forEach(processReason);
                redirectInfo = file && explainIfFileIsRedirectAndImpliedFormat(file, program.getCompilerOptionsForFile(file));
            }
            if (fileProcessingReason) processReason(fileProcessingReason);
            const processedExtraReason = (seenReasons == null ? void 0 : seenReasons.size) !== (reasons == null ? void 0 : reasons.length);
            if (locationReason && (seenReasons == null ? void 0 : seenReasons.size) === 1) seenReasons = void 0;
            if (seenReasons && cachedChain) {
                if (cachedChain.details && !processedExtraReason) chain = chainDiagnosticMessages(cachedChain.details, diagnostic, ...args !== null && args !== void 0 ? args : emptyArray);
                else if (cachedChain.fileIncludeReasonDetails) {
                    if (!processedExtraReason) {
                        if (!cachedFileIncludeDetailsHasProcessedExtraReason()) fileIncludeReasonDetails = cachedChain.fileIncludeReasonDetails;
                        else fileIncludeReasons = cachedChain.fileIncludeReasonDetails.next.slice(0, reasons.length);
                    } else if (!cachedFileIncludeDetailsHasProcessedExtraReason()) fileIncludeReasons = [
                        ...cachedChain.fileIncludeReasonDetails.next,
                        fileIncludeReasons[0]
                    ];
                    else fileIncludeReasons = append(cachedChain.fileIncludeReasonDetails.next.slice(0, reasons.length), fileIncludeReasons[0]);
                }
            }
            if (!chain) {
                if (!fileIncludeReasonDetails) fileIncludeReasonDetails = seenReasons && chainDiagnosticMessages(fileIncludeReasons, Diagnostics.The_file_is_in_the_program_because_Colon);
                chain = chainDiagnosticMessages(redirectInfo ? fileIncludeReasonDetails ? [
                    fileIncludeReasonDetails,
                    ...redirectInfo
                ] : redirectInfo : fileIncludeReasonDetails, diagnostic, ...args || emptyArray);
            }
            if (file) {
                if (cachedChain) {
                    if (!cachedChain.fileIncludeReasonDetails || !processedExtraReason && fileIncludeReasonDetails) cachedChain.fileIncludeReasonDetails = fileIncludeReasonDetails;
                } else (fileReasonsToChain !== null && fileReasonsToChain !== void 0 ? fileReasonsToChain : fileReasonsToChain = /* @__PURE__ */ new Map()).set(file.path, cachedChain = {
                    fileIncludeReasonDetails,
                    redirectInfo
                });
                if (!cachedChain.details && !processedExtraReason) cachedChain.details = chain.next;
            }
            const location = locationReason && getReferencedFileLocation(program, locationReason);
            return location && isReferenceFileLocation(location) ? createFileDiagnosticFromMessageChain(location.file, location.pos, location.end - location.pos, chain, relatedInfo) : createCompilerDiagnosticFromMessageChain(chain, relatedInfo);
            function processReason(reason) {
                if (seenReasons == null ? void 0 : seenReasons.has(reason)) return;
                (seenReasons !== null && seenReasons !== void 0 ? seenReasons : seenReasons = /* @__PURE__ */ new Set()).add(reason);
                (fileIncludeReasons !== null && fileIncludeReasons !== void 0 ? fileIncludeReasons : fileIncludeReasons = []).push(fileIncludeReasonToDiagnostics(program, reason));
                populateRelatedInfo(reason);
            }
            function populateRelatedInfo(reason) {
                if (!locationReason && isReferencedFile(reason)) locationReason = reason;
                else if (locationReason !== reason) relatedInfo = append(relatedInfo, getFileIncludeReasonToRelatedInformation(program, reason));
            }
            function cachedFileIncludeDetailsHasProcessedExtraReason() {
                var _a;
                return ((_a = cachedChain.fileIncludeReasonDetails.next) == null ? void 0 : _a.length) !== (reasons == null ? void 0 : reasons.length);
            }
        }
        function getFileIncludeReasonToRelatedInformation(program, reason) {
            let relatedInfo = reasonToRelatedInfo == null ? void 0 : reasonToRelatedInfo.get(reason);
            var _fileIncludeReasonToRelatedInformation;
            if (relatedInfo === void 0) (reasonToRelatedInfo !== null && reasonToRelatedInfo !== void 0 ? reasonToRelatedInfo : reasonToRelatedInfo = /* @__PURE__ */ new Map()).set(reason, relatedInfo = (_fileIncludeReasonToRelatedInformation = fileIncludeReasonToRelatedInformation(program, reason)) !== null && _fileIncludeReasonToRelatedInformation !== void 0 ? _fileIncludeReasonToRelatedInformation : false);
            return relatedInfo || void 0;
        }
        function fileIncludeReasonToRelatedInformation(program, reason) {
            if (isReferencedFile(reason)) {
                const referenceLocation = getReferencedFileLocation(program, reason);
                let message2;
                switch(reason.kind){
                    case 3 /* Import */ :
                        message2 = Diagnostics.File_is_included_via_import_here;
                        break;
                    case 4 /* ReferenceFile */ :
                        message2 = Diagnostics.File_is_included_via_reference_here;
                        break;
                    case 5 /* TypeReferenceDirective */ :
                        message2 = Diagnostics.File_is_included_via_type_library_reference_here;
                        break;
                    case 7 /* LibReferenceDirective */ :
                        message2 = Diagnostics.File_is_included_via_library_reference_here;
                        break;
                    default:
                        Debug.assertNever(reason);
                }
                return isReferenceFileLocation(referenceLocation) ? createFileDiagnostic(referenceLocation.file, referenceLocation.pos, referenceLocation.end - referenceLocation.pos, message2) : void 0;
            }
            const currentDirectory = program.getCurrentDirectory();
            const rootNames = program.getRootFileNames();
            const options = program.getCompilerOptions();
            if (!options.configFile) return void 0;
            let configFileNode;
            let message;
            switch(reason.kind){
                case 0 /* RootFile */ :
                    if (!options.configFile.configFileSpecs) return void 0;
                    const fileName = getNormalizedAbsolutePath(rootNames[reason.index], currentDirectory);
                    const matchedByFiles = getMatchedFileSpec(program, fileName);
                    if (matchedByFiles) {
                        configFileNode = getTsConfigPropArrayElementValue(options.configFile, "files", matchedByFiles);
                        message = Diagnostics.File_is_matched_by_files_list_specified_here;
                        break;
                    }
                    const matchedByInclude = getMatchedIncludeSpec(program, fileName);
                    if (!matchedByInclude || !isString(matchedByInclude)) return void 0;
                    configFileNode = getTsConfigPropArrayElementValue(options.configFile, "include", matchedByInclude);
                    message = Diagnostics.File_is_matched_by_include_pattern_specified_here;
                    break;
                case 1 /* SourceFromProjectReference */ :
                case 2 /* OutputFromProjectReference */ :
                    const resolvedProjectReferences = program.getResolvedProjectReferences();
                    const projectReferences = program.getProjectReferences();
                    const referencedResolvedRef = Debug.checkDefined(resolvedProjectReferences == null ? void 0 : resolvedProjectReferences[reason.index]);
                    const referenceInfo = forEachProjectReference(projectReferences, resolvedProjectReferences, (resolvedRef, parent2, index2)=>resolvedRef === referencedResolvedRef ? {
                            sourceFile: (parent2 == null ? void 0 : parent2.sourceFile) || options.configFile,
                            index: index2
                        } : void 0);
                    if (!referenceInfo) return void 0;
                    const { sourceFile, index } = referenceInfo;
                    const referencesSyntax = forEachTsConfigPropArray(sourceFile, "references", (property)=>isArrayLiteralExpression(property.initializer) ? property.initializer : void 0);
                    return referencesSyntax && referencesSyntax.elements.length > index ? createDiagnosticForNodeInSourceFile(sourceFile, referencesSyntax.elements[index], reason.kind === 2 /* OutputFromProjectReference */  ? Diagnostics.File_is_output_from_referenced_project_specified_here : Diagnostics.File_is_source_from_referenced_project_specified_here) : void 0;
                case 8 /* AutomaticTypeDirectiveFile */ :
                    if (!options.types) return void 0;
                    configFileNode = getOptionsSyntaxByArrayElementValue(getCompilerOptionsObjectLiteralSyntax(), "types", reason.typeReference);
                    message = Diagnostics.File_is_entry_point_of_type_library_specified_here;
                    break;
                case 6 /* LibFile */ :
                    if (reason.index !== void 0) {
                        configFileNode = getOptionsSyntaxByArrayElementValue(getCompilerOptionsObjectLiteralSyntax(), "lib", options.lib[reason.index]);
                        message = Diagnostics.File_is_library_specified_here;
                        break;
                    }
                    const target = getNameOfScriptTarget(getEmitScriptTarget(options));
                    configFileNode = target ? getOptionsSyntaxByValue(getCompilerOptionsObjectLiteralSyntax(), "target", target) : void 0;
                    message = Diagnostics.File_is_default_library_for_target_specified_here;
                    break;
                default:
                    Debug.assertNever(reason);
            }
            return configFileNode && createDiagnosticForNodeInSourceFile(options.configFile, configFileNode, message);
        }
    }
    // src/compiler/builderState.ts
    function getFileEmitOutput(program, sourceFile, emitOnlyDtsFiles, cancellationToken, customTransformers, forceDtsEmit) {
        const outputFiles = [];
        const { emitSkipped, diagnostics } = program.emit(sourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers, forceDtsEmit);
        return {
            outputFiles,
            emitSkipped,
            diagnostics
        };
        function writeFile2(fileName, text, writeByteOrderMark) {
            outputFiles.push({
                name: fileName,
                writeByteOrderMark,
                text
            });
        }
    }
    var SignatureInfo = /* @__PURE__ */ ((SignatureInfo2)=>{
        SignatureInfo2[SignatureInfo2["ComputedDts"] = 0] = "ComputedDts";
        SignatureInfo2[SignatureInfo2["StoredSignatureAtEmit"] = 1] = "StoredSignatureAtEmit";
        SignatureInfo2[SignatureInfo2["UsedVersion"] = 2] = "UsedVersion";
        return SignatureInfo2;
    })(SignatureInfo || {});
    var BuilderState;
    ((BuilderState2)=>{
        function createManyToManyPathMap() {
            function create2(forward, reverse, deleted) {
                const map2 = {
                    getKeys: (v1)=>reverse.get(v1),
                    getValues: (k)=>forward.get(k),
                    keys: ()=>forward.keys(),
                    size: ()=>forward.size,
                    deleteKey: (k)=>{
                        (deleted || (deleted = /* @__PURE__ */ new Set())).add(k);
                        const set = forward.get(k);
                        if (!set) return false;
                        set.forEach((v1)=>deleteFromMultimap(reverse, v1, k));
                        forward.delete(k);
                        return true;
                    },
                    set: (k, vSet)=>{
                        deleted == null || deleted.delete(k);
                        const existingVSet = forward.get(k);
                        forward.set(k, vSet);
                        existingVSet == null || existingVSet.forEach((v1)=>{
                            if (!vSet.has(v1)) deleteFromMultimap(reverse, v1, k);
                        });
                        vSet.forEach((v1)=>{
                            if (!(existingVSet == null ? void 0 : existingVSet.has(v1))) addToMultimap(reverse, v1, k);
                        });
                        return map2;
                    }
                };
                return map2;
            }
            return create2(/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /*deleted*/ void 0);
        }
        BuilderState2.createManyToManyPathMap = createManyToManyPathMap;
        function addToMultimap(map2, k, v1) {
            let set = map2.get(k);
            if (!set) {
                set = /* @__PURE__ */ new Set();
                map2.set(k, set);
            }
            set.add(v1);
        }
        function deleteFromMultimap(map2, k, v1) {
            const set = map2.get(k);
            if (set == null ? void 0 : set.delete(v1)) {
                if (!set.size) map2.delete(k);
                return true;
            }
            return false;
        }
        function getReferencedFilesFromImportedModuleSymbol(symbol) {
            return mapDefined(symbol.declarations, (declaration)=>{
                var _a;
                return (_a = getSourceFileOfNode(declaration)) == null ? void 0 : _a.resolvedPath;
            });
        }
        function getReferencedFilesFromImportLiteral(checker, importName) {
            const symbol = checker.getSymbolAtLocation(importName);
            return symbol && getReferencedFilesFromImportedModuleSymbol(symbol);
        }
        function getReferencedFileFromFileName(program, fileName, sourceFileDirectory, getCanonicalFileName) {
            var _a;
            return toPath(((_a = program.getRedirectFromSourceFile(fileName)) == null ? void 0 : _a.outputDts) || fileName, sourceFileDirectory, getCanonicalFileName);
        }
        function getReferencedFiles(program, sourceFile, getCanonicalFileName) {
            let referencedFiles;
            if (sourceFile.imports && sourceFile.imports.length > 0) {
                const checker = program.getTypeChecker();
                for (const importName of sourceFile.imports){
                    const declarationSourceFilePaths = getReferencedFilesFromImportLiteral(checker, importName);
                    declarationSourceFilePaths == null || declarationSourceFilePaths.forEach(addReferencedFile);
                }
            }
            const sourceFileDirectory = getDirectoryPath(sourceFile.resolvedPath);
            if (sourceFile.referencedFiles && sourceFile.referencedFiles.length > 0) for (const referencedFile of sourceFile.referencedFiles){
                const referencedPath = getReferencedFileFromFileName(program, referencedFile.fileName, sourceFileDirectory, getCanonicalFileName);
                addReferencedFile(referencedPath);
            }
            program.forEachResolvedTypeReferenceDirective(({ resolvedTypeReferenceDirective })=>{
                if (!resolvedTypeReferenceDirective) return;
                const fileName = resolvedTypeReferenceDirective.resolvedFileName;
                const typeFilePath = getReferencedFileFromFileName(program, fileName, sourceFileDirectory, getCanonicalFileName);
                addReferencedFile(typeFilePath);
            }, sourceFile);
            if (sourceFile.moduleAugmentations.length) {
                const checker = program.getTypeChecker();
                for (const moduleName of sourceFile.moduleAugmentations){
                    if (!isStringLiteral(moduleName)) continue;
                    const symbol = checker.getSymbolAtLocation(moduleName);
                    if (!symbol) continue;
                    addReferenceFromAmbientModule(symbol);
                }
            }
            for (const ambientModule of program.getTypeChecker().getAmbientModules())if (ambientModule.declarations && ambientModule.declarations.length > 1) addReferenceFromAmbientModule(ambientModule);
            return referencedFiles;
            function addReferenceFromAmbientModule(symbol) {
                if (!symbol.declarations) return;
                for (const declaration of symbol.declarations){
                    const declarationSourceFile = getSourceFileOfNode(declaration);
                    if (declarationSourceFile && declarationSourceFile !== sourceFile) addReferencedFile(declarationSourceFile.resolvedPath);
                }
            }
            function addReferencedFile(referencedPath) {
                (referencedFiles || (referencedFiles = /* @__PURE__ */ new Set())).add(referencedPath);
            }
        }
        function canReuseOldState(newReferencedMap, oldState) {
            return oldState && !oldState.referencedMap === !newReferencedMap;
        }
        BuilderState2.canReuseOldState = canReuseOldState;
        function createReferencedMap(options) {
            return options.module !== 0 /* None */  && !options.outFile ? createManyToManyPathMap() : void 0;
        }
        BuilderState2.createReferencedMap = createReferencedMap;
        function create(newProgram, oldState, disableUseFileVersionAsSignature) {
            var _a, _b;
            const fileInfos = /* @__PURE__ */ new Map();
            const options = newProgram.getCompilerOptions();
            const referencedMap = createReferencedMap(options);
            const useOldState = canReuseOldState(referencedMap, oldState);
            newProgram.getTypeChecker();
            for (const sourceFile of newProgram.getSourceFiles()){
                const version2 = Debug.checkDefined(sourceFile.version, "Program intended to be used with Builder should have source files with versions set");
                const oldUncommittedSignature = useOldState ? (_a = oldState.oldSignatures) == null ? void 0 : _a.get(sourceFile.resolvedPath) : void 0;
                const signature = oldUncommittedSignature === void 0 ? useOldState ? (_b = oldState.fileInfos.get(sourceFile.resolvedPath)) == null ? void 0 : _b.signature : void 0 : oldUncommittedSignature || void 0;
                if (referencedMap) {
                    const newReferences = getReferencedFiles(newProgram, sourceFile, newProgram.getCanonicalFileName);
                    if (newReferences) referencedMap.set(sourceFile.resolvedPath, newReferences);
                }
                fileInfos.set(sourceFile.resolvedPath, {
                    version: version2,
                    signature,
                    // No need to calculate affectsGlobalScope with --out since its not used at all
                    affectsGlobalScope: !options.outFile ? isFileAffectingGlobalScope(sourceFile) || void 0 : void 0,
                    impliedFormat: sourceFile.impliedNodeFormat
                });
            }
            return {
                fileInfos,
                referencedMap,
                useFileVersionAsSignature: !disableUseFileVersionAsSignature && !useOldState
            };
        }
        BuilderState2.create = create;
        function releaseCache2(state) {
            state.allFilesExcludingDefaultLibraryFile = void 0;
            state.allFileNames = void 0;
        }
        BuilderState2.releaseCache = releaseCache2;
        function getFilesAffectedBy(state, programOfThisState, path, cancellationToken, host) {
            var _a;
            const result = getFilesAffectedByWithOldState(state, programOfThisState, path, cancellationToken, host);
            (_a = state.oldSignatures) == null || _a.clear();
            return result;
        }
        BuilderState2.getFilesAffectedBy = getFilesAffectedBy;
        function getFilesAffectedByWithOldState(state, programOfThisState, path, cancellationToken, host) {
            const sourceFile = programOfThisState.getSourceFileByPath(path);
            if (!sourceFile) return emptyArray;
            if (!updateShapeSignature(state, programOfThisState, sourceFile, cancellationToken, host)) return [
                sourceFile
            ];
            return (state.referencedMap ? getFilesAffectedByUpdatedShapeWhenModuleEmit : getFilesAffectedByUpdatedShapeWhenNonModuleEmit)(state, programOfThisState, sourceFile, cancellationToken, host);
        }
        BuilderState2.getFilesAffectedByWithOldState = getFilesAffectedByWithOldState;
        function updateSignatureOfFile(state, signature, path) {
            state.fileInfos.get(path).signature = signature;
            (state.hasCalledUpdateShapeSignature || (state.hasCalledUpdateShapeSignature = /* @__PURE__ */ new Set())).add(path);
        }
        BuilderState2.updateSignatureOfFile = updateSignatureOfFile;
        function computeDtsSignature(programOfThisState, sourceFile, cancellationToken, host, onNewSignature) {
            programOfThisState.emit(sourceFile, (fileName, text, _writeByteOrderMark, _onError, sourceFiles, data)=>{
                Debug.assert(isDeclarationFileName(fileName), `File extension for signature expected to be dts: Got:: ${fileName}`);
                onNewSignature(computeSignatureWithDiagnostics(programOfThisState, sourceFile, text, host, data), sourceFiles);
            }, cancellationToken, 2 /* BuilderSignature */ , /*customTransformers*/ void 0, /*forceDtsEmit*/ true);
        }
        BuilderState2.computeDtsSignature = computeDtsSignature;
        function updateShapeSignature(state, programOfThisState, sourceFile, cancellationToken, host, useFileVersionAsSignature = state.useFileVersionAsSignature) {
            var _a;
            if ((_a = state.hasCalledUpdateShapeSignature) == null ? void 0 : _a.has(sourceFile.resolvedPath)) return false;
            const info = state.fileInfos.get(sourceFile.resolvedPath);
            const prevSignature = info.signature;
            let latestSignature;
            if (!sourceFile.isDeclarationFile && !useFileVersionAsSignature) computeDtsSignature(programOfThisState, sourceFile, cancellationToken, host, (signature)=>{
                latestSignature = signature;
                var _state_signatureInfo;
                if (host.storeSignatureInfo) ((_state_signatureInfo = state.signatureInfo) !== null && _state_signatureInfo !== void 0 ? _state_signatureInfo : state.signatureInfo = /* @__PURE__ */ new Map()).set(sourceFile.resolvedPath, 0 /* ComputedDts */ );
            });
            if (latestSignature === void 0) {
                latestSignature = sourceFile.version;
                var _state_signatureInfo;
                if (host.storeSignatureInfo) ((_state_signatureInfo = state.signatureInfo) !== null && _state_signatureInfo !== void 0 ? _state_signatureInfo : state.signatureInfo = /* @__PURE__ */ new Map()).set(sourceFile.resolvedPath, 2 /* UsedVersion */ );
            }
            (state.oldSignatures || (state.oldSignatures = /* @__PURE__ */ new Map())).set(sourceFile.resolvedPath, prevSignature || false);
            (state.hasCalledUpdateShapeSignature || (state.hasCalledUpdateShapeSignature = /* @__PURE__ */ new Set())).add(sourceFile.resolvedPath);
            info.signature = latestSignature;
            return latestSignature !== prevSignature;
        }
        BuilderState2.updateShapeSignature = updateShapeSignature;
        function getAllDependencies(state, programOfThisState, sourceFile) {
            const compilerOptions = programOfThisState.getCompilerOptions();
            if (compilerOptions.outFile) return getAllFileNames(state, programOfThisState);
            if (!state.referencedMap || isFileAffectingGlobalScope(sourceFile)) return getAllFileNames(state, programOfThisState);
            const seenMap = /* @__PURE__ */ new Set();
            const queue = [
                sourceFile.resolvedPath
            ];
            while(queue.length){
                const path = queue.pop();
                if (!seenMap.has(path)) {
                    seenMap.add(path);
                    const references = state.referencedMap.getValues(path);
                    if (references) for (const key of references.keys())queue.push(key);
                }
            }
            return arrayFrom(mapDefinedIterator(seenMap.keys(), (path)=>{
                var _a;
                var _ref;
                return (_ref = (_a = programOfThisState.getSourceFileByPath(path)) == null ? void 0 : _a.fileName) !== null && _ref !== void 0 ? _ref : path;
            }));
        }
        BuilderState2.getAllDependencies = getAllDependencies;
        function getAllFileNames(state, programOfThisState) {
            if (!state.allFileNames) {
                const sourceFiles = programOfThisState.getSourceFiles();
                state.allFileNames = sourceFiles === emptyArray ? emptyArray : sourceFiles.map((file)=>file.fileName);
            }
            return state.allFileNames;
        }
        function getReferencedByPaths(state, referencedFilePath) {
            const keys = state.referencedMap.getKeys(referencedFilePath);
            return keys ? arrayFrom(keys.keys()) : [];
        }
        BuilderState2.getReferencedByPaths = getReferencedByPaths;
        function containsOnlyAmbientModules(sourceFile) {
            for (const statement of sourceFile.statements){
                if (!isModuleWithStringLiteralName(statement)) return false;
            }
            return true;
        }
        function containsGlobalScopeAugmentation(sourceFile) {
            return some(sourceFile.moduleAugmentations, (augmentation)=>isGlobalScopeAugmentation(augmentation.parent));
        }
        function isFileAffectingGlobalScope(sourceFile) {
            return containsGlobalScopeAugmentation(sourceFile) || !isExternalOrCommonJsModule(sourceFile) && !isJsonSourceFile(sourceFile) && !containsOnlyAmbientModules(sourceFile);
        }
        function getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, firstSourceFile) {
            if (state.allFilesExcludingDefaultLibraryFile) return state.allFilesExcludingDefaultLibraryFile;
            let result;
            if (firstSourceFile) addSourceFile(firstSourceFile);
            for (const sourceFile of programOfThisState.getSourceFiles())if (sourceFile !== firstSourceFile) addSourceFile(sourceFile);
            state.allFilesExcludingDefaultLibraryFile = result || emptyArray;
            return state.allFilesExcludingDefaultLibraryFile;
            function addSourceFile(sourceFile) {
                if (!programOfThisState.isSourceFileDefaultLibrary(sourceFile)) (result || (result = [])).push(sourceFile);
            }
        }
        BuilderState2.getAllFilesExcludingDefaultLibraryFile = getAllFilesExcludingDefaultLibraryFile;
        function getFilesAffectedByUpdatedShapeWhenNonModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape) {
            const compilerOptions = programOfThisState.getCompilerOptions();
            if (compilerOptions && compilerOptions.outFile) return [
                sourceFileWithUpdatedShape
            ];
            return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
        }
        function getFilesAffectedByUpdatedShapeWhenModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape, cancellationToken, host) {
            if (isFileAffectingGlobalScope(sourceFileWithUpdatedShape)) return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
            const compilerOptions = programOfThisState.getCompilerOptions();
            if (compilerOptions && (getIsolatedModules(compilerOptions) || compilerOptions.outFile)) return [
                sourceFileWithUpdatedShape
            ];
            const seenFileNamesMap = /* @__PURE__ */ new Map();
            seenFileNamesMap.set(sourceFileWithUpdatedShape.resolvedPath, sourceFileWithUpdatedShape);
            const queue = getReferencedByPaths(state, sourceFileWithUpdatedShape.resolvedPath);
            while(queue.length > 0){
                const currentPath = queue.pop();
                if (!seenFileNamesMap.has(currentPath)) {
                    const currentSourceFile = programOfThisState.getSourceFileByPath(currentPath);
                    seenFileNamesMap.set(currentPath, currentSourceFile);
                    if (currentSourceFile && updateShapeSignature(state, programOfThisState, currentSourceFile, cancellationToken, host)) queue.push(...getReferencedByPaths(state, currentSourceFile.resolvedPath));
                }
            }
            return arrayFrom(mapDefinedIterator(seenFileNamesMap.values(), (value1)=>value1));
        }
    })(BuilderState || (BuilderState = {}));
    // src/compiler/builder.ts
    var BuilderFileEmit = /* @__PURE__ */ ((BuilderFileEmit2)=>{
        BuilderFileEmit2[BuilderFileEmit2["None"] = 0] = "None";
        BuilderFileEmit2[BuilderFileEmit2["Js"] = 1] = "Js";
        BuilderFileEmit2[BuilderFileEmit2["JsMap"] = 2] = "JsMap";
        BuilderFileEmit2[BuilderFileEmit2["JsInlineMap"] = 4] = "JsInlineMap";
        BuilderFileEmit2[BuilderFileEmit2["DtsErrors"] = 8] = "DtsErrors";
        BuilderFileEmit2[BuilderFileEmit2["DtsEmit"] = 16] = "DtsEmit";
        BuilderFileEmit2[BuilderFileEmit2["DtsMap"] = 32] = "DtsMap";
        BuilderFileEmit2[BuilderFileEmit2["Dts"] = 24] = "Dts";
        BuilderFileEmit2[BuilderFileEmit2["AllJs"] = 7] = "AllJs";
        BuilderFileEmit2[BuilderFileEmit2["AllDtsEmit"] = 48] = "AllDtsEmit";
        BuilderFileEmit2[BuilderFileEmit2["AllDts"] = 56] = "AllDts";
        BuilderFileEmit2[BuilderFileEmit2["All"] = 63] = "All";
        return BuilderFileEmit2;
    })(BuilderFileEmit || {});
    function isBuilderProgramStateWithDefinedProgram(state) {
        return state.program !== void 0;
    }
    function toBuilderProgramStateWithDefinedProgram(state) {
        Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
        return state;
    }
    function getBuilderFileEmit(options) {
        let result = 1 /* Js */ ;
        if (options.sourceMap) result = result | 2 /* JsMap */ ;
        if (options.inlineSourceMap) result = result | 4 /* JsInlineMap */ ;
        if (getEmitDeclarations(options)) result = result | 24 /* Dts */ ;
        if (options.declarationMap) result = result | 32 /* DtsMap */ ;
        if (options.emitDeclarationOnly) result = result & 56 /* AllDts */ ;
        return result;
    }
    function getPendingEmitKind(optionsOrEmitKind, oldOptionsOrEmitKind) {
        const oldEmitKind = oldOptionsOrEmitKind && (isNumber(oldOptionsOrEmitKind) ? oldOptionsOrEmitKind : getBuilderFileEmit(oldOptionsOrEmitKind));
        const emitKind = isNumber(optionsOrEmitKind) ? optionsOrEmitKind : getBuilderFileEmit(optionsOrEmitKind);
        if (oldEmitKind === emitKind) return 0 /* None */ ;
        if (!oldEmitKind || !emitKind) return emitKind;
        const diff = oldEmitKind ^ emitKind;
        let result = 0 /* None */ ;
        if (diff & 7 /* AllJs */ ) result = emitKind & 7 /* AllJs */ ;
        if (diff & 8 /* DtsErrors */ ) result = result | emitKind & 8 /* DtsErrors */ ;
        if (diff & 48 /* AllDtsEmit */ ) result = result | emitKind & 48 /* AllDtsEmit */ ;
        return result;
    }
    function hasSameKeys(map1, map2) {
        return map1 === map2 || map1 !== void 0 && map2 !== void 0 && map1.size === map2.size && !forEachKey(map1, (key)=>!map2.has(key));
    }
    function createBuilderProgramState(newProgram, oldState) {
        var _a, _b;
        const state = BuilderState.create(newProgram, oldState, /*disableUseFileVersionAsSignature*/ false);
        state.program = newProgram;
        const compilerOptions = newProgram.getCompilerOptions();
        state.compilerOptions = compilerOptions;
        const outFilePath = compilerOptions.outFile;
        state.semanticDiagnosticsPerFile = /* @__PURE__ */ new Map();
        if (outFilePath && compilerOptions.composite && (oldState == null ? void 0 : oldState.outSignature) && outFilePath === oldState.compilerOptions.outFile) state.outSignature = oldState.outSignature && getEmitSignatureFromOldSignature(compilerOptions, oldState.compilerOptions, oldState.outSignature);
        state.changedFilesSet = /* @__PURE__ */ new Set();
        state.latestChangedDtsFile = compilerOptions.composite ? oldState == null ? void 0 : oldState.latestChangedDtsFile : void 0;
        state.checkPending = state.compilerOptions.noCheck ? true : void 0;
        const useOldState = BuilderState.canReuseOldState(state.referencedMap, oldState);
        const oldCompilerOptions = useOldState ? oldState.compilerOptions : void 0;
        let canCopySemanticDiagnostics = useOldState && !compilerOptionsAffectSemanticDiagnostics(compilerOptions, oldCompilerOptions);
        const canCopyEmitSignatures = compilerOptions.composite && (oldState == null ? void 0 : oldState.emitSignatures) && !outFilePath && !compilerOptionsAffectDeclarationPath(compilerOptions, oldState.compilerOptions);
        let canCopyEmitDiagnostics = true;
        if (useOldState) {
            (_a = oldState.changedFilesSet) == null || _a.forEach((value1)=>state.changedFilesSet.add(value1));
            if (!outFilePath && ((_b = oldState.affectedFilesPendingEmit) == null ? void 0 : _b.size)) {
                state.affectedFilesPendingEmit = new Map(oldState.affectedFilesPendingEmit);
                state.seenAffectedFiles = /* @__PURE__ */ new Set();
            }
            state.programEmitPending = oldState.programEmitPending;
            if (outFilePath && state.changedFilesSet.size) {
                canCopySemanticDiagnostics = false;
                canCopyEmitDiagnostics = false;
            }
            state.hasErrorsFromOldState = oldState.hasErrors;
        } else state.buildInfoEmitPending = isIncrementalCompilation(compilerOptions);
        const referencedMap = state.referencedMap;
        const oldReferencedMap = useOldState ? oldState.referencedMap : void 0;
        const copyDeclarationFileDiagnostics = canCopySemanticDiagnostics && !compilerOptions.skipLibCheck === !oldCompilerOptions.skipLibCheck;
        const copyLibFileDiagnostics = copyDeclarationFileDiagnostics && !compilerOptions.skipDefaultLibCheck === !oldCompilerOptions.skipDefaultLibCheck;
        state.fileInfos.forEach((info, sourceFilePath)=>{
            var _a2;
            let oldInfo;
            let newReferences;
            if (!useOldState || // File wasn't present in old state
            !(oldInfo = oldState.fileInfos.get(sourceFilePath)) || // versions dont match
            oldInfo.version !== info.version || // Implied formats dont match
            oldInfo.impliedFormat !== info.impliedFormat || // Referenced files changed
            !hasSameKeys(newReferences = referencedMap && referencedMap.getValues(sourceFilePath), oldReferencedMap && oldReferencedMap.getValues(sourceFilePath)) || // Referenced file was deleted in the new program
            newReferences && forEachKey(newReferences, (path)=>!state.fileInfos.has(path) && oldState.fileInfos.has(path))) addFileToChangeSet(sourceFilePath);
            else {
                const sourceFile = newProgram.getSourceFileByPath(sourceFilePath);
                const emitDiagnostics = canCopyEmitDiagnostics ? (_a2 = oldState.emitDiagnosticsPerFile) == null ? void 0 : _a2.get(sourceFilePath) : void 0;
                var _state_emitDiagnosticsPerFile;
                if (emitDiagnostics) ((_state_emitDiagnosticsPerFile = state.emitDiagnosticsPerFile) !== null && _state_emitDiagnosticsPerFile !== void 0 ? _state_emitDiagnosticsPerFile : state.emitDiagnosticsPerFile = /* @__PURE__ */ new Map()).set(sourceFilePath, oldState.hasReusableDiagnostic ? convertToDiagnostics(emitDiagnostics, sourceFilePath, newProgram) : repopulateDiagnostics(emitDiagnostics, newProgram));
                if (canCopySemanticDiagnostics) {
                    if (sourceFile.isDeclarationFile && !copyDeclarationFileDiagnostics) return;
                    if (sourceFile.hasNoDefaultLib && !copyLibFileDiagnostics) return;
                    const diagnostics = oldState.semanticDiagnosticsPerFile.get(sourceFilePath);
                    if (diagnostics) {
                        state.semanticDiagnosticsPerFile.set(sourceFilePath, oldState.hasReusableDiagnostic ? convertToDiagnostics(diagnostics, sourceFilePath, newProgram) : repopulateDiagnostics(diagnostics, newProgram));
                        var _state_semanticDiagnosticsFromOldState;
                        ((_state_semanticDiagnosticsFromOldState = state.semanticDiagnosticsFromOldState) !== null && _state_semanticDiagnosticsFromOldState !== void 0 ? _state_semanticDiagnosticsFromOldState : state.semanticDiagnosticsFromOldState = /* @__PURE__ */ new Set()).add(sourceFilePath);
                    }
                }
            }
            if (canCopyEmitSignatures) {
                const oldEmitSignature = oldState.emitSignatures.get(sourceFilePath);
                var _state_emitSignatures;
                if (oldEmitSignature) ((_state_emitSignatures = state.emitSignatures) !== null && _state_emitSignatures !== void 0 ? _state_emitSignatures : state.emitSignatures = /* @__PURE__ */ new Map()).set(sourceFilePath, getEmitSignatureFromOldSignature(compilerOptions, oldState.compilerOptions, oldEmitSignature));
            }
        });
        if (useOldState && forEachEntry(oldState.fileInfos, (info, sourceFilePath)=>{
            if (state.fileInfos.has(sourceFilePath)) return false;
            if (info.affectsGlobalScope) return true;
            state.buildInfoEmitPending = true;
            return !!outFilePath;
        })) BuilderState.getAllFilesExcludingDefaultLibraryFile(state, newProgram, /*firstSourceFile*/ void 0).forEach((file)=>addFileToChangeSet(file.resolvedPath));
        else if (oldCompilerOptions) {
            const pendingEmitKind = compilerOptionsAffectEmit(compilerOptions, oldCompilerOptions) ? getBuilderFileEmit(compilerOptions) : getPendingEmitKind(compilerOptions, oldCompilerOptions);
            if (pendingEmitKind !== 0 /* None */ ) {
                if (!outFilePath) {
                    newProgram.getSourceFiles().forEach((f)=>{
                        if (!state.changedFilesSet.has(f.resolvedPath)) addToAffectedFilesPendingEmit(state, f.resolvedPath, pendingEmitKind);
                    });
                    Debug.assert(!state.seenAffectedFiles || !state.seenAffectedFiles.size);
                    state.seenAffectedFiles = state.seenAffectedFiles || /* @__PURE__ */ new Set();
                } else if (!state.changedFilesSet.size) state.programEmitPending = state.programEmitPending ? state.programEmitPending | pendingEmitKind : pendingEmitKind;
                state.buildInfoEmitPending = true;
            }
        }
        if (useOldState && state.semanticDiagnosticsPerFile.size !== state.fileInfos.size && oldState.checkPending !== state.checkPending) state.buildInfoEmitPending = true;
        return state;
        function addFileToChangeSet(path) {
            state.changedFilesSet.add(path);
            if (outFilePath) {
                canCopySemanticDiagnostics = false;
                canCopyEmitDiagnostics = false;
                state.semanticDiagnosticsFromOldState = void 0;
                state.semanticDiagnosticsPerFile.clear();
                state.emitDiagnosticsPerFile = void 0;
            }
            state.buildInfoEmitPending = true;
            state.programEmitPending = void 0;
        }
    }
    function getEmitSignatureFromOldSignature(options, oldOptions, oldEmitSignature) {
        return !!options.declarationMap === !!oldOptions.declarationMap ? // Use same format of signature
        oldEmitSignature : // Convert to different format
        isString(oldEmitSignature) ? [
            oldEmitSignature
        ] : oldEmitSignature[0];
    }
    function repopulateDiagnostics(diagnostics, newProgram) {
        if (!diagnostics.length) return diagnostics;
        return sameMap(diagnostics, (diag2)=>{
            if (isString(diag2.messageText)) return diag2;
            const repopulatedChain = convertOrRepopulateDiagnosticMessageChain(diag2.messageText, diag2.file, newProgram, (chain)=>{
                var _a;
                return (_a = chain.repopulateInfo) == null ? void 0 : _a.call(chain);
            });
            return repopulatedChain === diag2.messageText ? diag2 : (0, _objectSpreadProps._)((0, _objectSpread._)({}, diag2), {
                messageText: repopulatedChain
            });
        });
    }
    function convertOrRepopulateDiagnosticMessageChain(chain, sourceFile, newProgram, repopulateInfo) {
        const info = repopulateInfo(chain);
        if (info === true) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, createModeMismatchDetails(sourceFile)), {
            next: convertOrRepopulateDiagnosticMessageChainArray(chain.next, sourceFile, newProgram, repopulateInfo)
        });
        else if (info) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, createModuleNotFoundChain(sourceFile, newProgram, info.moduleReference, info.mode, info.packageName || info.moduleReference)), {
            next: convertOrRepopulateDiagnosticMessageChainArray(chain.next, sourceFile, newProgram, repopulateInfo)
        });
        const next = convertOrRepopulateDiagnosticMessageChainArray(chain.next, sourceFile, newProgram, repopulateInfo);
        return next === chain.next ? chain : (0, _objectSpreadProps._)((0, _objectSpread._)({}, chain), {
            next
        });
    }
    function convertOrRepopulateDiagnosticMessageChainArray(array, sourceFile, newProgram, repopulateInfo) {
        return sameMap(array, (chain)=>convertOrRepopulateDiagnosticMessageChain(chain, sourceFile, newProgram, repopulateInfo));
    }
    function convertToDiagnostics(diagnostics, diagnosticFilePath, newProgram) {
        if (!diagnostics.length) return emptyArray;
        let buildInfoDirectory;
        return diagnostics.map((diagnostic)=>{
            const result = convertToDiagnosticRelatedInformation(diagnostic, diagnosticFilePath, newProgram, toPathInBuildInfoDirectory);
            result.reportsUnnecessary = diagnostic.reportsUnnecessary;
            result.reportsDeprecated = diagnostic.reportDeprecated;
            result.source = diagnostic.source;
            result.skippedOn = diagnostic.skippedOn;
            const { relatedInformation } = diagnostic;
            result.relatedInformation = relatedInformation ? relatedInformation.length ? relatedInformation.map((r)=>convertToDiagnosticRelatedInformation(r, diagnosticFilePath, newProgram, toPathInBuildInfoDirectory)) : [] : void 0;
            return result;
        });
        function toPathInBuildInfoDirectory(path) {
            buildInfoDirectory !== null && buildInfoDirectory !== void 0 ? buildInfoDirectory : buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(getTsBuildInfoEmitOutputFilePath(newProgram.getCompilerOptions()), newProgram.getCurrentDirectory()));
            return toPath(path, buildInfoDirectory, newProgram.getCanonicalFileName);
        }
    }
    function convertToDiagnosticRelatedInformation(diagnostic, diagnosticFilePath, newProgram, toPath3) {
        const { file } = diagnostic;
        const sourceFile = file !== false ? newProgram.getSourceFileByPath(file ? toPath3(file) : diagnosticFilePath) : void 0;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, diagnostic), {
            file: sourceFile,
            messageText: isString(diagnostic.messageText) ? diagnostic.messageText : convertOrRepopulateDiagnosticMessageChain(diagnostic.messageText, sourceFile, newProgram, (chain)=>chain.info)
        });
    }
    function releaseCache(state) {
        BuilderState.releaseCache(state);
        state.program = void 0;
    }
    function assertSourceFileOkWithoutNextAffectedCall(state, sourceFile) {
        Debug.assert(!sourceFile || !state.affectedFiles || state.affectedFiles[state.affectedFilesIndex - 1] !== sourceFile || !state.semanticDiagnosticsPerFile.has(sourceFile.resolvedPath));
    }
    function getNextAffectedFile(state, cancellationToken, host) {
        var _a;
        while(true){
            const { affectedFiles } = state;
            if (affectedFiles) {
                const seenAffectedFiles = state.seenAffectedFiles;
                let affectedFilesIndex = state.affectedFilesIndex;
                while(affectedFilesIndex < affectedFiles.length){
                    const affectedFile = affectedFiles[affectedFilesIndex];
                    if (!seenAffectedFiles.has(affectedFile.resolvedPath)) {
                        state.affectedFilesIndex = affectedFilesIndex;
                        addToAffectedFilesPendingEmit(state, affectedFile.resolvedPath, getBuilderFileEmit(state.compilerOptions));
                        handleDtsMayChangeOfAffectedFile(state, affectedFile, cancellationToken, host);
                        return affectedFile;
                    }
                    affectedFilesIndex++;
                }
                state.changedFilesSet.delete(state.currentChangedFilePath);
                state.currentChangedFilePath = void 0;
                (_a = state.oldSignatures) == null || _a.clear();
                state.affectedFiles = void 0;
            }
            const nextKey = state.changedFilesSet.keys().next();
            if (nextKey.done) return void 0;
            const compilerOptions = state.program.getCompilerOptions();
            if (compilerOptions.outFile) return state.program;
            state.affectedFiles = BuilderState.getFilesAffectedByWithOldState(state, state.program, nextKey.value, cancellationToken, host);
            state.currentChangedFilePath = nextKey.value;
            state.affectedFilesIndex = 0;
            if (!state.seenAffectedFiles) state.seenAffectedFiles = /* @__PURE__ */ new Set();
        }
    }
    function clearAffectedFilesPendingEmit(state, emitOnlyDtsFiles, isForDtsErrors) {
        var _a, _b;
        if (!((_a = state.affectedFilesPendingEmit) == null ? void 0 : _a.size) && !state.programEmitPending) return;
        if (!emitOnlyDtsFiles && !isForDtsErrors) {
            state.affectedFilesPendingEmit = void 0;
            state.programEmitPending = void 0;
        }
        (_b = state.affectedFilesPendingEmit) == null || _b.forEach((emitKind, path)=>{
            const pending = !isForDtsErrors ? emitKind & 7 /* AllJs */  : emitKind & 55 /* AllDtsEmit */ ;
            if (!pending) state.affectedFilesPendingEmit.delete(path);
            else state.affectedFilesPendingEmit.set(path, pending);
        });
        if (state.programEmitPending) {
            const pending = !isForDtsErrors ? state.programEmitPending & 7 /* AllJs */  : state.programEmitPending & 55 /* AllDtsEmit */ ;
            if (!pending) state.programEmitPending = void 0;
            else state.programEmitPending = pending;
        }
    }
    function getPendingEmitKindWithSeen(optionsOrEmitKind, seenOldOptionsOrEmitKind, emitOnlyDtsFiles, isForDtsErrors) {
        let pendingKind = getPendingEmitKind(optionsOrEmitKind, seenOldOptionsOrEmitKind);
        if (emitOnlyDtsFiles) pendingKind = pendingKind & 56 /* AllDts */ ;
        if (isForDtsErrors) pendingKind = pendingKind & 8 /* DtsErrors */ ;
        return pendingKind;
    }
    function getBuilderFileEmitAllDts(isForDtsErrors) {
        return !isForDtsErrors ? 56 /* AllDts */  : 8 /* DtsErrors */ ;
    }
    function getNextAffectedFilePendingEmit(state, emitOnlyDtsFiles, isForDtsErrors) {
        var _a;
        if (!((_a = state.affectedFilesPendingEmit) == null ? void 0 : _a.size)) return void 0;
        return forEachEntry(state.affectedFilesPendingEmit, (emitKind, path)=>{
            var _a2;
            const affectedFile = state.program.getSourceFileByPath(path);
            if (!affectedFile || !sourceFileMayBeEmitted(affectedFile, state.program)) {
                state.affectedFilesPendingEmit.delete(path);
                return void 0;
            }
            const seenKind = (_a2 = state.seenEmittedFiles) == null ? void 0 : _a2.get(affectedFile.resolvedPath);
            const pendingKind = getPendingEmitKindWithSeen(emitKind, seenKind, emitOnlyDtsFiles, isForDtsErrors);
            if (pendingKind) return {
                affectedFile,
                emitKind: pendingKind
            };
        });
    }
    function getNextPendingEmitDiagnosticsFile(state, isForDtsErrors) {
        var _a;
        if (!((_a = state.emitDiagnosticsPerFile) == null ? void 0 : _a.size)) return void 0;
        return forEachEntry(state.emitDiagnosticsPerFile, (diagnostics, path)=>{
            var _a2;
            const affectedFile = state.program.getSourceFileByPath(path);
            if (!affectedFile || !sourceFileMayBeEmitted(affectedFile, state.program)) {
                state.emitDiagnosticsPerFile.delete(path);
                return void 0;
            }
            const seenKind = ((_a2 = state.seenEmittedFiles) == null ? void 0 : _a2.get(affectedFile.resolvedPath)) || 0 /* None */ ;
            if (!(seenKind & getBuilderFileEmitAllDts(isForDtsErrors))) return {
                affectedFile,
                diagnostics,
                seenKind
            };
        });
    }
    function removeDiagnosticsOfLibraryFiles(state) {
        if (!state.cleanedDiagnosticsOfLibFiles) {
            state.cleanedDiagnosticsOfLibFiles = true;
            const options = state.program.getCompilerOptions();
            forEach(state.program.getSourceFiles(), (f)=>state.program.isSourceFileDefaultLibrary(f) && !skipTypeCheckingIgnoringNoCheck(f, options, state.program) && removeSemanticDiagnosticsOf(state, f.resolvedPath));
        }
    }
    function handleDtsMayChangeOfAffectedFile(state, affectedFile, cancellationToken, host) {
        removeSemanticDiagnosticsOf(state, affectedFile.resolvedPath);
        if (state.allFilesExcludingDefaultLibraryFile === state.affectedFiles) {
            removeDiagnosticsOfLibraryFiles(state);
            BuilderState.updateShapeSignature(state, state.program, affectedFile, cancellationToken, host);
            return;
        }
        if (state.compilerOptions.assumeChangesOnlyAffectDirectDependencies) return;
        handleDtsMayChangeOfReferencingExportOfAffectedFile(state, affectedFile, cancellationToken, host);
    }
    function handleDtsMayChangeOf(state, path, invalidateJsFiles, cancellationToken, host) {
        removeSemanticDiagnosticsOf(state, path);
        if (!state.changedFilesSet.has(path)) {
            const sourceFile = state.program.getSourceFileByPath(path);
            if (sourceFile) {
                BuilderState.updateShapeSignature(state, state.program, sourceFile, cancellationToken, host, /*useFileVersionAsSignature*/ true);
                if (invalidateJsFiles) addToAffectedFilesPendingEmit(state, path, getBuilderFileEmit(state.compilerOptions));
                else if (getEmitDeclarations(state.compilerOptions)) addToAffectedFilesPendingEmit(state, path, state.compilerOptions.declarationMap ? 56 /* AllDts */  : 24 /* Dts */ );
            }
        }
    }
    function removeSemanticDiagnosticsOf(state, path) {
        if (!state.semanticDiagnosticsFromOldState) return true;
        state.semanticDiagnosticsFromOldState.delete(path);
        state.semanticDiagnosticsPerFile.delete(path);
        return !state.semanticDiagnosticsFromOldState.size;
    }
    function isChangedSignature(state, path) {
        const oldSignature = Debug.checkDefined(state.oldSignatures).get(path) || void 0;
        const newSignature = Debug.checkDefined(state.fileInfos.get(path)).signature;
        return newSignature !== oldSignature;
    }
    function handleDtsMayChangeOfGlobalScope(state, filePath, invalidateJsFiles, cancellationToken, host) {
        var _a;
        if (!((_a = state.fileInfos.get(filePath)) == null ? void 0 : _a.affectsGlobalScope)) return false;
        BuilderState.getAllFilesExcludingDefaultLibraryFile(state, state.program, /*firstSourceFile*/ void 0).forEach((file)=>handleDtsMayChangeOf(state, file.resolvedPath, invalidateJsFiles, cancellationToken, host));
        removeDiagnosticsOfLibraryFiles(state);
        return true;
    }
    function handleDtsMayChangeOfReferencingExportOfAffectedFile(state, affectedFile, cancellationToken, host) {
        var _a, _b;
        if (!state.referencedMap || !state.changedFilesSet.has(affectedFile.resolvedPath)) return;
        if (!isChangedSignature(state, affectedFile.resolvedPath)) return;
        if (getIsolatedModules(state.compilerOptions)) {
            const seenFileNamesMap = /* @__PURE__ */ new Map();
            seenFileNamesMap.set(affectedFile.resolvedPath, true);
            const queue = BuilderState.getReferencedByPaths(state, affectedFile.resolvedPath);
            while(queue.length > 0){
                const currentPath = queue.pop();
                if (!seenFileNamesMap.has(currentPath)) {
                    seenFileNamesMap.set(currentPath, true);
                    if (handleDtsMayChangeOfGlobalScope(state, currentPath, /*invalidateJsFiles*/ false, cancellationToken, host)) return;
                    handleDtsMayChangeOf(state, currentPath, /*invalidateJsFiles*/ false, cancellationToken, host);
                    if (isChangedSignature(state, currentPath)) {
                        const currentSourceFile = state.program.getSourceFileByPath(currentPath);
                        queue.push(...BuilderState.getReferencedByPaths(state, currentSourceFile.resolvedPath));
                    }
                }
            }
        }
        const seenFileAndExportsOfFile = /* @__PURE__ */ new Set();
        const invalidateJsFiles = !!((_a = affectedFile.symbol) == null ? void 0 : _a.exports) && !!forEachEntry(affectedFile.symbol.exports, (exported)=>{
            if ((exported.flags & 128 /* ConstEnum */ ) !== 0) return true;
            const aliased = skipAlias(exported, state.program.getTypeChecker());
            if (aliased === exported) return false;
            return (aliased.flags & 128 /* ConstEnum */ ) !== 0 && some(aliased.declarations, (d)=>getSourceFileOfNode(d) === affectedFile);
        });
        (_b = state.referencedMap.getKeys(affectedFile.resolvedPath)) == null || _b.forEach((exportedFromPath)=>{
            if (handleDtsMayChangeOfGlobalScope(state, exportedFromPath, invalidateJsFiles, cancellationToken, host)) return true;
            const references = state.referencedMap.getKeys(exportedFromPath);
            return references && forEachKey(references, (filePath)=>handleDtsMayChangeOfFileAndExportsOfFile(state, filePath, invalidateJsFiles, seenFileAndExportsOfFile, cancellationToken, host));
        });
    }
    function handleDtsMayChangeOfFileAndExportsOfFile(state, filePath, invalidateJsFiles, seenFileAndExportsOfFile, cancellationToken, host) {
        var _a;
        if (!tryAddToSet(seenFileAndExportsOfFile, filePath)) return void 0;
        if (handleDtsMayChangeOfGlobalScope(state, filePath, invalidateJsFiles, cancellationToken, host)) return true;
        handleDtsMayChangeOf(state, filePath, invalidateJsFiles, cancellationToken, host);
        (_a = state.referencedMap.getKeys(filePath)) == null || _a.forEach((referencingFilePath)=>handleDtsMayChangeOfFileAndExportsOfFile(state, referencingFilePath, invalidateJsFiles, seenFileAndExportsOfFile, cancellationToken, host));
        return void 0;
    }
    function getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken, semanticDiagnosticsPerFile) {
        if (state.compilerOptions.noCheck) return emptyArray;
        return concatenate(getBinderAndCheckerDiagnosticsOfFile(state, sourceFile, cancellationToken, semanticDiagnosticsPerFile), state.program.getProgramDiagnostics(sourceFile));
    }
    function getBinderAndCheckerDiagnosticsOfFile(state, sourceFile, cancellationToken, semanticDiagnosticsPerFile) {
        semanticDiagnosticsPerFile !== null && semanticDiagnosticsPerFile !== void 0 ? semanticDiagnosticsPerFile : semanticDiagnosticsPerFile = state.semanticDiagnosticsPerFile;
        const path = sourceFile.resolvedPath;
        const cachedDiagnostics = semanticDiagnosticsPerFile.get(path);
        if (cachedDiagnostics) return filterSemanticDiagnostics(cachedDiagnostics, state.compilerOptions);
        const diagnostics = state.program.getBindAndCheckDiagnostics(sourceFile, cancellationToken);
        semanticDiagnosticsPerFile.set(path, diagnostics);
        state.buildInfoEmitPending = true;
        return filterSemanticDiagnostics(diagnostics, state.compilerOptions);
    }
    function isIncrementalBundleEmitBuildInfo(info) {
        var _a;
        return !!((_a = info.options) == null ? void 0 : _a.outFile);
    }
    function isIncrementalBuildInfo(info) {
        return !!info.fileNames;
    }
    function isNonIncrementalBuildInfo(info) {
        return !isIncrementalBuildInfo(info) && !!info.root;
    }
    function ensureHasErrorsForState(state) {
        if (state.hasErrors !== void 0) return;
        if (isIncrementalCompilation(state.compilerOptions)) state.hasErrors = !some(state.program.getSourceFiles(), (f)=>{
            var _a, _b;
            const bindAndCheckDiagnostics = state.semanticDiagnosticsPerFile.get(f.resolvedPath);
            return bindAndCheckDiagnostics === void 0 || // Missing semantic diagnostics in cache will be encoded in buildInfo
            !!bindAndCheckDiagnostics.length || // cached semantic diagnostics will be encoded in buildInfo
            !!((_b = (_a = state.emitDiagnosticsPerFile) == null ? void 0 : _a.get(f.resolvedPath)) == null ? void 0 : _b.length);
        }) && (hasSyntaxOrGlobalErrors(state) || some(state.program.getSourceFiles(), (f)=>!!state.program.getProgramDiagnostics(f).length));
        else state.hasErrors = some(state.program.getSourceFiles(), (f)=>{
            var _a, _b;
            const bindAndCheckDiagnostics = state.semanticDiagnosticsPerFile.get(f.resolvedPath);
            return !!(bindAndCheckDiagnostics == null ? void 0 : bindAndCheckDiagnostics.length) || // If has semantic diagnostics
            !!((_b = (_a = state.emitDiagnosticsPerFile) == null ? void 0 : _a.get(f.resolvedPath)) == null ? void 0 : _b.length);
        }) || hasSyntaxOrGlobalErrors(state);
    }
    function hasSyntaxOrGlobalErrors(state) {
        return !!state.program.getConfigFileParsingDiagnostics().length || !!state.program.getSyntacticDiagnostics().length || !!state.program.getOptionsDiagnostics().length || !!state.program.getGlobalDiagnostics().length;
    }
    function getBuildInfoEmitPending(state) {
        ensureHasErrorsForState(state);
        var _state_buildInfoEmitPending;
        return (_state_buildInfoEmitPending = state.buildInfoEmitPending) !== null && _state_buildInfoEmitPending !== void 0 ? _state_buildInfoEmitPending : state.buildInfoEmitPending = !!state.hasErrorsFromOldState !== !!state.hasErrors;
    }
    function getBuildInfo2(state) {
        var _a, _b;
        const currentDirectory = state.program.getCurrentDirectory();
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(getTsBuildInfoEmitOutputFilePath(state.compilerOptions), currentDirectory));
        const latestChangedDtsFile = state.latestChangedDtsFile ? relativeToBuildInfoEnsuringAbsolutePath(state.latestChangedDtsFile) : void 0;
        const fileNames = [];
        const fileNameToFileId = /* @__PURE__ */ new Map();
        const rootFileNames = new Set(state.program.getRootFileNames().map((f)=>toPath(f, currentDirectory, state.program.getCanonicalFileName)));
        ensureHasErrorsForState(state);
        if (!isIncrementalCompilation(state.compilerOptions)) {
            const buildInfo2 = {
                root: arrayFrom(rootFileNames, (r)=>relativeToBuildInfo(r)),
                errors: state.hasErrors ? true : void 0,
                checkPending: state.checkPending,
                version
            };
            return buildInfo2;
        }
        const root = [];
        if (state.compilerOptions.outFile) {
            const fileInfos2 = arrayFrom(state.fileInfos.entries(), ([key, value1])=>{
                const fileId = toFileId(key);
                tryAddRoot(key, fileId);
                return value1.impliedFormat ? {
                    version: value1.version,
                    impliedFormat: value1.impliedFormat,
                    signature: void 0,
                    affectsGlobalScope: void 0
                } : value1.version;
            });
            const buildInfo2 = {
                fileNames,
                fileInfos: fileInfos2,
                root,
                resolvedRoot: toResolvedRoot(),
                options: toIncrementalBuildInfoCompilerOptions(state.compilerOptions),
                semanticDiagnosticsPerFile: !state.changedFilesSet.size ? toIncrementalBuildInfoDiagnostics() : void 0,
                emitDiagnosticsPerFile: toIncrementalBuildInfoEmitDiagnostics(),
                changeFileSet: toChangeFileSet(),
                outSignature: state.outSignature,
                latestChangedDtsFile,
                pendingEmit: !state.programEmitPending ? void 0 : // Pending is undefined or None is encoded as undefined
                state.programEmitPending === getBuilderFileEmit(state.compilerOptions) ? false : // Pending emit is same as deteremined by compilerOptions
                state.programEmitPending,
                // Actual value
                errors: state.hasErrors ? true : void 0,
                checkPending: state.checkPending,
                version
            };
            return buildInfo2;
        }
        let fileIdsList;
        let fileNamesToFileIdListId;
        let emitSignatures;
        const fileInfos = arrayFrom(state.fileInfos.entries(), ([key, value1])=>{
            var _a2, _b2;
            const fileId = toFileId(key);
            tryAddRoot(key, fileId);
            Debug.assert(fileNames[fileId - 1] === relativeToBuildInfo(key));
            const oldSignature = (_a2 = state.oldSignatures) == null ? void 0 : _a2.get(key);
            const actualSignature = oldSignature !== void 0 ? oldSignature || void 0 : value1.signature;
            if (state.compilerOptions.composite) {
                const file = state.program.getSourceFileByPath(key);
                if (!isJsonSourceFile(file) && sourceFileMayBeEmitted(file, state.program)) {
                    const emitSignature = (_b2 = state.emitSignatures) == null ? void 0 : _b2.get(key);
                    if (emitSignature !== actualSignature) emitSignatures = append(emitSignatures, emitSignature === void 0 ? fileId : // There is no emit, encode as false
                    // fileId, signature: emptyArray if signature only differs in dtsMap option than our own compilerOptions otherwise EmitSignature
                    [
                        fileId,
                        !isString(emitSignature) && emitSignature[0] === actualSignature ? emptyArray : emitSignature
                    ]);
                }
            }
            return value1.version === actualSignature ? value1.affectsGlobalScope || value1.impliedFormat ? // If file version is same as signature, dont serialize signature
            {
                version: value1.version,
                signature: void 0,
                affectsGlobalScope: value1.affectsGlobalScope,
                impliedFormat: value1.impliedFormat
            } : // If file info only contains version and signature and both are same we can just write string
            value1.version : actualSignature !== void 0 ? // If signature is not same as version, encode signature in the fileInfo
            oldSignature === void 0 ? // If we havent computed signature, use fileInfo as is
            value1 : // Serialize fileInfo with new updated signature
            {
                version: value1.version,
                signature: actualSignature,
                affectsGlobalScope: value1.affectsGlobalScope,
                impliedFormat: value1.impliedFormat
            } : // Signature of the FileInfo is undefined, serialize it as false
            {
                version: value1.version,
                signature: false,
                affectsGlobalScope: value1.affectsGlobalScope,
                impliedFormat: value1.impliedFormat
            };
        });
        let referencedMap;
        if ((_a = state.referencedMap) == null ? void 0 : _a.size()) referencedMap = arrayFrom(state.referencedMap.keys()).sort(compareStringsCaseSensitive).map((key)=>[
                toFileId(key),
                toFileIdListId(state.referencedMap.getValues(key))
            ]);
        const semanticDiagnosticsPerFile = toIncrementalBuildInfoDiagnostics();
        let affectedFilesPendingEmit;
        if ((_b = state.affectedFilesPendingEmit) == null ? void 0 : _b.size) {
            const fullEmitForOptions = getBuilderFileEmit(state.compilerOptions);
            const seenFiles = /* @__PURE__ */ new Set();
            for (const path of arrayFrom(state.affectedFilesPendingEmit.keys()).sort(compareStringsCaseSensitive))if (tryAddToSet(seenFiles, path)) {
                const file = state.program.getSourceFileByPath(path);
                if (!file || !sourceFileMayBeEmitted(file, state.program)) continue;
                const fileId = toFileId(path), pendingEmit = state.affectedFilesPendingEmit.get(path);
                affectedFilesPendingEmit = append(affectedFilesPendingEmit, pendingEmit === fullEmitForOptions ? fileId : // Pending full emit per options
                pendingEmit === 24 /* Dts */  ? [
                    fileId
                ] : // Pending on Dts only
                [
                    fileId,
                    pendingEmit
                ]);
            }
        }
        const buildInfo = {
            fileNames,
            fileIdsList,
            fileInfos,
            root,
            resolvedRoot: toResolvedRoot(),
            options: toIncrementalBuildInfoCompilerOptions(state.compilerOptions),
            referencedMap,
            semanticDiagnosticsPerFile,
            emitDiagnosticsPerFile: toIncrementalBuildInfoEmitDiagnostics(),
            changeFileSet: toChangeFileSet(),
            affectedFilesPendingEmit,
            emitSignatures,
            latestChangedDtsFile,
            errors: state.hasErrors ? true : void 0,
            checkPending: state.checkPending,
            version
        };
        return buildInfo;
        function relativeToBuildInfoEnsuringAbsolutePath(path) {
            return relativeToBuildInfo(getNormalizedAbsolutePath(path, currentDirectory));
        }
        function relativeToBuildInfo(path) {
            return ensurePathIsNonModuleName(getRelativePathFromDirectory(buildInfoDirectory, path, state.program.getCanonicalFileName));
        }
        function toFileId(path) {
            let fileId = fileNameToFileId.get(path);
            if (fileId === void 0) {
                fileNames.push(relativeToBuildInfo(path));
                fileNameToFileId.set(path, fileId = fileNames.length);
            }
            return fileId;
        }
        function toFileIdListId(set) {
            const fileIds = arrayFrom(set.keys(), toFileId).sort(compareValues);
            const key = fileIds.join();
            let fileIdListId = fileNamesToFileIdListId == null ? void 0 : fileNamesToFileIdListId.get(key);
            if (fileIdListId === void 0) {
                fileIdsList = append(fileIdsList, fileIds);
                (fileNamesToFileIdListId !== null && fileNamesToFileIdListId !== void 0 ? fileNamesToFileIdListId : fileNamesToFileIdListId = /* @__PURE__ */ new Map()).set(key, fileIdListId = fileIdsList.length);
            }
            return fileIdListId;
        }
        function tryAddRoot(path, fileId) {
            const file = state.program.getSourceFile(path);
            if (!state.program.getFileIncludeReasons().get(file.path).some((r)=>r.kind === 0 /* RootFile */ )) return;
            if (!root.length) return root.push(fileId);
            const last2 = root[root.length - 1];
            const isLastStartEnd = isArray(last2);
            if (isLastStartEnd && last2[1] === fileId - 1) return last2[1] = fileId;
            if (isLastStartEnd || root.length === 1 || last2 !== fileId - 1) return root.push(fileId);
            const lastButOne = root[root.length - 2];
            if (!isNumber(lastButOne) || lastButOne !== last2 - 1) return root.push(fileId);
            root[root.length - 2] = [
                lastButOne,
                fileId
            ];
            return root.length = root.length - 1;
        }
        function toResolvedRoot() {
            let result;
            rootFileNames.forEach((path)=>{
                const file = state.program.getSourceFileByPath(path);
                if (file && path !== file.resolvedPath) result = append(result, [
                    toFileId(file.resolvedPath),
                    toFileId(path)
                ]);
            });
            return result;
        }
        function toIncrementalBuildInfoCompilerOptions(options) {
            let result;
            const { optionsNameMap } = getOptionsNameMap();
            for (const name of getOwnKeys(options).sort(compareStringsCaseSensitive)){
                const optionInfo = optionsNameMap.get(name.toLowerCase());
                if (optionInfo == null ? void 0 : optionInfo.affectsBuildInfo) (result || (result = {}))[name] = toReusableCompilerOptionValue(optionInfo, options[name]);
            }
            return result;
        }
        function toReusableCompilerOptionValue(option, value1) {
            if (option) {
                Debug.assert(option.type !== "listOrElement");
                if (option.type === "list") {
                    const values = value1;
                    if (option.element.isFilePath && values.length) return values.map(relativeToBuildInfoEnsuringAbsolutePath);
                } else if (option.isFilePath) return relativeToBuildInfoEnsuringAbsolutePath(value1);
            }
            return value1;
        }
        function toIncrementalBuildInfoDiagnostics() {
            let result;
            state.fileInfos.forEach((_value, key)=>{
                const value1 = state.semanticDiagnosticsPerFile.get(key);
                if (!value1) {
                    if (!state.changedFilesSet.has(key)) result = append(result, toFileId(key));
                } else if (value1.length) result = append(result, [
                    toFileId(key),
                    toReusableDiagnostic(value1, key)
                ]);
            });
            return result;
        }
        function toIncrementalBuildInfoEmitDiagnostics() {
            var _a2;
            let result;
            if (!((_a2 = state.emitDiagnosticsPerFile) == null ? void 0 : _a2.size)) return result;
            for (const key of arrayFrom(state.emitDiagnosticsPerFile.keys()).sort(compareStringsCaseSensitive)){
                const value1 = state.emitDiagnosticsPerFile.get(key);
                result = append(result, [
                    toFileId(key),
                    toReusableDiagnostic(value1, key)
                ]);
            }
            return result;
        }
        function toReusableDiagnostic(diagnostics, diagnosticFilePath) {
            Debug.assert(!!diagnostics.length);
            return diagnostics.map((diagnostic)=>{
                const result = toReusableDiagnosticRelatedInformation(diagnostic, diagnosticFilePath);
                result.reportsUnnecessary = diagnostic.reportsUnnecessary;
                result.reportDeprecated = diagnostic.reportsDeprecated;
                result.source = diagnostic.source;
                result.skippedOn = diagnostic.skippedOn;
                const { relatedInformation } = diagnostic;
                result.relatedInformation = relatedInformation ? relatedInformation.length ? relatedInformation.map((r)=>toReusableDiagnosticRelatedInformation(r, diagnosticFilePath)) : [] : void 0;
                return result;
            });
        }
        function toReusableDiagnosticRelatedInformation(diagnostic, diagnosticFilePath) {
            const { file } = diagnostic;
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, diagnostic), {
                file: file ? file.resolvedPath === diagnosticFilePath ? void 0 : relativeToBuildInfo(file.resolvedPath) : false,
                messageText: isString(diagnostic.messageText) ? diagnostic.messageText : toReusableDiagnosticMessageChain(diagnostic.messageText)
            });
        }
        function toReusableDiagnosticMessageChain(chain) {
            if (chain.repopulateInfo) return {
                info: chain.repopulateInfo(),
                next: toReusableDiagnosticMessageChainArray(chain.next)
            };
            const next = toReusableDiagnosticMessageChainArray(chain.next);
            return next === chain.next ? chain : (0, _objectSpreadProps._)((0, _objectSpread._)({}, chain), {
                next
            });
        }
        function toReusableDiagnosticMessageChainArray(array) {
            if (!array) return array;
            return forEach(array, (chain, index)=>{
                const reusable = toReusableDiagnosticMessageChain(chain);
                if (chain === reusable) return void 0;
                const result = index > 0 ? array.slice(0, index - 1) : [];
                result.push(reusable);
                for(let i = index + 1; i < array.length; i++)result.push(toReusableDiagnosticMessageChain(array[i]));
                return result;
            }) || array;
        }
        function toChangeFileSet() {
            let changeFileSet;
            if (state.changedFilesSet.size) for (const path of arrayFrom(state.changedFilesSet.keys()).sort(compareStringsCaseSensitive))changeFileSet = append(changeFileSet, toFileId(path));
            return changeFileSet;
        }
    }
    var BuilderProgramKind = /* @__PURE__ */ ((BuilderProgramKind2)=>{
        BuilderProgramKind2[BuilderProgramKind2["SemanticDiagnosticsBuilderProgram"] = 0] = "SemanticDiagnosticsBuilderProgram";
        BuilderProgramKind2[BuilderProgramKind2["EmitAndSemanticDiagnosticsBuilderProgram"] = 1] = "EmitAndSemanticDiagnosticsBuilderProgram";
        return BuilderProgramKind2;
    })(BuilderProgramKind || {});
    function getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        let host;
        let newProgram;
        let oldProgram;
        if (newProgramOrRootNames === void 0) {
            Debug.assert(hostOrOptions === void 0);
            host = oldProgramOrHost;
            oldProgram = configFileParsingDiagnosticsOrOldProgram;
            Debug.assert(!!oldProgram);
            newProgram = oldProgram.getProgram();
        } else if (isArray(newProgramOrRootNames)) {
            oldProgram = configFileParsingDiagnosticsOrOldProgram;
            newProgram = createProgram({
                rootNames: newProgramOrRootNames,
                options: hostOrOptions,
                host: oldProgramOrHost,
                oldProgram: oldProgram && oldProgram.getProgramOrUndefined(),
                configFileParsingDiagnostics,
                projectReferences
            });
            host = oldProgramOrHost;
        } else {
            newProgram = newProgramOrRootNames;
            host = hostOrOptions;
            oldProgram = oldProgramOrHost;
            configFileParsingDiagnostics = configFileParsingDiagnosticsOrOldProgram;
        }
        return {
            host,
            newProgram,
            oldProgram,
            configFileParsingDiagnostics: configFileParsingDiagnostics || emptyArray
        };
    }
    function getTextHandlingSourceMapForSignature(text, data) {
        return (data == null ? void 0 : data.sourceMapUrlPos) !== void 0 ? text.substring(0, data.sourceMapUrlPos) : text;
    }
    function computeSignatureWithDiagnostics(program, sourceFile, text, host, data) {
        var _a;
        text = getTextHandlingSourceMapForSignature(text, data);
        let sourceFileDirectory;
        if ((_a = data == null ? void 0 : data.diagnostics) == null ? void 0 : _a.length) text += data.diagnostics.map((diagnostic)=>`${locationInfo(diagnostic)}${DiagnosticCategory[diagnostic.category]}${diagnostic.code}: ${flattenDiagnosticMessageText2(diagnostic.messageText)}`).join("\n");
        var _host_createHash;
        return ((_host_createHash = host.createHash) !== null && _host_createHash !== void 0 ? _host_createHash : generateDjb2Hash)(text);
        function flattenDiagnosticMessageText2(diagnostic) {
            return isString(diagnostic) ? diagnostic : diagnostic === void 0 ? "" : !diagnostic.next ? diagnostic.messageText : diagnostic.messageText + diagnostic.next.map(flattenDiagnosticMessageText2).join("\n");
        }
        function locationInfo(diagnostic) {
            if (diagnostic.file.resolvedPath === sourceFile.resolvedPath) return `(${diagnostic.start},${diagnostic.length})`;
            if (sourceFileDirectory === void 0) sourceFileDirectory = getDirectoryPath(sourceFile.resolvedPath);
            return `${ensurePathIsNonModuleName(getRelativePathFromDirectory(sourceFileDirectory, diagnostic.file.resolvedPath, program.getCanonicalFileName))}(${diagnostic.start},${diagnostic.length})`;
        }
    }
    function computeSignature(text, host, data) {
        var _host_createHash;
        return ((_host_createHash = host.createHash) !== null && _host_createHash !== void 0 ? _host_createHash : generateDjb2Hash)(getTextHandlingSourceMapForSignature(text, data));
    }
    function createBuilderProgram(kind, { newProgram, host, oldProgram, configFileParsingDiagnostics }) {
        let oldState = oldProgram && oldProgram.state;
        if (oldState && newProgram === oldState.program && configFileParsingDiagnostics === newProgram.getConfigFileParsingDiagnostics()) {
            newProgram = void 0;
            oldState = void 0;
            return oldProgram;
        }
        const state = createBuilderProgramState(newProgram, oldState);
        newProgram.getBuildInfo = ()=>getBuildInfo2(toBuilderProgramStateWithDefinedProgram(state));
        newProgram = void 0;
        oldProgram = void 0;
        oldState = void 0;
        const builderProgram = createRedirectedBuilderProgram(state, configFileParsingDiagnostics);
        builderProgram.state = state;
        builderProgram.hasChangedEmitSignature = ()=>!!state.hasChangedEmitSignature;
        builderProgram.getAllDependencies = (sourceFile)=>BuilderState.getAllDependencies(state, Debug.checkDefined(state.program), sourceFile);
        builderProgram.getSemanticDiagnostics = getSemanticDiagnostics;
        builderProgram.getDeclarationDiagnostics = getDeclarationDiagnostics2;
        builderProgram.emit = emit;
        builderProgram.releaseProgram = ()=>releaseCache(state);
        if (kind === 0 /* SemanticDiagnosticsBuilderProgram */ ) builderProgram.getSemanticDiagnosticsOfNextAffectedFile = getSemanticDiagnosticsOfNextAffectedFile;
        else if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) {
            builderProgram.getSemanticDiagnosticsOfNextAffectedFile = getSemanticDiagnosticsOfNextAffectedFile;
            builderProgram.emitNextAffectedFile = emitNextAffectedFile;
            builderProgram.emitBuildInfo = emitBuildInfo;
        } else notImplemented();
        return builderProgram;
        function emitBuildInfo(writeFile2, cancellationToken) {
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            if (getBuildInfoEmitPending(state)) {
                const result = state.program.emitBuildInfo(writeFile2 || maybeBind(host, host.writeFile), cancellationToken);
                state.buildInfoEmitPending = false;
                return result;
            }
            return emitSkippedWithNoDiagnostics;
        }
        function emitNextAffectedFileOrDtsErrors(writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers, isForDtsErrors) {
            var _a, _b, _c, _d;
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            let affected = getNextAffectedFile(state, cancellationToken, host);
            const programEmitKind = getBuilderFileEmit(state.compilerOptions);
            let emitKind = !isForDtsErrors ? emitOnlyDtsFiles ? programEmitKind & 56 /* AllDts */  : programEmitKind : 8 /* DtsErrors */ ;
            if (!affected) {
                if (!state.compilerOptions.outFile) {
                    const pendingAffectedFile = getNextAffectedFilePendingEmit(state, emitOnlyDtsFiles, isForDtsErrors);
                    if (pendingAffectedFile) ({ affectedFile: affected, emitKind } = pendingAffectedFile);
                    else {
                        const pendingForDiagnostics = getNextPendingEmitDiagnosticsFile(state, isForDtsErrors);
                        if (pendingForDiagnostics) {
                            var _state_seenEmittedFiles;
                            ((_state_seenEmittedFiles = state.seenEmittedFiles) !== null && _state_seenEmittedFiles !== void 0 ? _state_seenEmittedFiles : state.seenEmittedFiles = /* @__PURE__ */ new Map()).set(pendingForDiagnostics.affectedFile.resolvedPath, pendingForDiagnostics.seenKind | getBuilderFileEmitAllDts(isForDtsErrors));
                            return {
                                result: {
                                    emitSkipped: true,
                                    diagnostics: pendingForDiagnostics.diagnostics
                                },
                                affected: pendingForDiagnostics.affectedFile
                            };
                        }
                    }
                } else {
                    if (state.programEmitPending) {
                        emitKind = getPendingEmitKindWithSeen(state.programEmitPending, state.seenProgramEmit, emitOnlyDtsFiles, isForDtsErrors);
                        if (emitKind) affected = state.program;
                    }
                    if (!affected && ((_a = state.emitDiagnosticsPerFile) == null ? void 0 : _a.size)) {
                        const seenKind = state.seenProgramEmit || 0 /* None */ ;
                        if (!(seenKind & getBuilderFileEmitAllDts(isForDtsErrors))) {
                            state.seenProgramEmit = getBuilderFileEmitAllDts(isForDtsErrors) | seenKind;
                            const diagnostics = [];
                            state.emitDiagnosticsPerFile.forEach((d)=>addRange(diagnostics, d));
                            return {
                                result: {
                                    emitSkipped: true,
                                    diagnostics
                                },
                                affected: state.program
                            };
                        }
                    }
                }
                if (!affected) {
                    if (isForDtsErrors || !getBuildInfoEmitPending(state)) return void 0;
                    const affected2 = state.program;
                    const result2 = affected2.emitBuildInfo(writeFile2 || maybeBind(host, host.writeFile), cancellationToken);
                    state.buildInfoEmitPending = false;
                    return {
                        result: result2,
                        affected: affected2
                    };
                }
            }
            let emitOnly;
            if (emitKind & 7 /* AllJs */ ) emitOnly = 0 /* Js */ ;
            if (emitKind & 56 /* AllDts */ ) emitOnly = emitOnly === void 0 ? 1 /* Dts */  : void 0;
            const result = !isForDtsErrors ? state.program.emit(affected === state.program ? void 0 : affected, getWriteFileCallback(writeFile2, customTransformers), cancellationToken, emitOnly, customTransformers, /*forceDtsEmit*/ void 0, /*skipBuildInfo*/ true) : {
                emitSkipped: true,
                diagnostics: state.program.getDeclarationDiagnostics(affected === state.program ? void 0 : affected, cancellationToken)
            };
            if (affected !== state.program) {
                const affectedSourceFile = affected;
                state.seenAffectedFiles.add(affectedSourceFile.resolvedPath);
                if (state.affectedFilesIndex !== void 0) state.affectedFilesIndex++;
                state.buildInfoEmitPending = true;
                const existing = ((_b = state.seenEmittedFiles) == null ? void 0 : _b.get(affectedSourceFile.resolvedPath)) || 0 /* None */ ;
                var _state_seenEmittedFiles1;
                ((_state_seenEmittedFiles1 = state.seenEmittedFiles) !== null && _state_seenEmittedFiles1 !== void 0 ? _state_seenEmittedFiles1 : state.seenEmittedFiles = /* @__PURE__ */ new Map()).set(affectedSourceFile.resolvedPath, emitKind | existing);
                const existingPending = ((_c = state.affectedFilesPendingEmit) == null ? void 0 : _c.get(affectedSourceFile.resolvedPath)) || programEmitKind;
                const pendingKind = getPendingEmitKind(existingPending, emitKind | existing);
                var _state_affectedFilesPendingEmit;
                if (pendingKind) ((_state_affectedFilesPendingEmit = state.affectedFilesPendingEmit) !== null && _state_affectedFilesPendingEmit !== void 0 ? _state_affectedFilesPendingEmit : state.affectedFilesPendingEmit = /* @__PURE__ */ new Map()).set(affectedSourceFile.resolvedPath, pendingKind);
                else (_d = state.affectedFilesPendingEmit) == null || _d.delete(affectedSourceFile.resolvedPath);
                var _state_emitDiagnosticsPerFile;
                if (result.diagnostics.length) ((_state_emitDiagnosticsPerFile = state.emitDiagnosticsPerFile) !== null && _state_emitDiagnosticsPerFile !== void 0 ? _state_emitDiagnosticsPerFile : state.emitDiagnosticsPerFile = /* @__PURE__ */ new Map()).set(affectedSourceFile.resolvedPath, result.diagnostics);
            } else {
                state.changedFilesSet.clear();
                state.programEmitPending = state.changedFilesSet.size ? getPendingEmitKind(programEmitKind, emitKind) : state.programEmitPending ? getPendingEmitKind(state.programEmitPending, emitKind) : void 0;
                state.seenProgramEmit = emitKind | (state.seenProgramEmit || 0 /* None */ );
                setEmitDiagnosticsPerFile(result.diagnostics);
                state.buildInfoEmitPending = true;
            }
            return {
                result,
                affected
            };
        }
        function setEmitDiagnosticsPerFile(diagnostics) {
            let emitDiagnosticsPerFile;
            diagnostics.forEach((d)=>{
                if (!d.file) return;
                let diagnostics2 = emitDiagnosticsPerFile == null ? void 0 : emitDiagnosticsPerFile.get(d.file.resolvedPath);
                if (!diagnostics2) (emitDiagnosticsPerFile !== null && emitDiagnosticsPerFile !== void 0 ? emitDiagnosticsPerFile : emitDiagnosticsPerFile = /* @__PURE__ */ new Map()).set(d.file.resolvedPath, diagnostics2 = []);
                diagnostics2.push(d);
            });
            if (emitDiagnosticsPerFile) state.emitDiagnosticsPerFile = emitDiagnosticsPerFile;
        }
        function emitNextAffectedFile(writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
            return emitNextAffectedFileOrDtsErrors(writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers, /*isForDtsErrors*/ false);
        }
        function getWriteFileCallback(writeFile2, customTransformers) {
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            if (!getEmitDeclarations(state.compilerOptions)) return writeFile2 || maybeBind(host, host.writeFile);
            return (fileName, text, writeByteOrderMark, onError, sourceFiles, data)=>{
                var _a, _b, _c;
                if (isDeclarationFileName(fileName)) {
                    if (!state.compilerOptions.outFile) {
                        Debug.assert((sourceFiles == null ? void 0 : sourceFiles.length) === 1);
                        let emitSignature;
                        if (!customTransformers) {
                            const file = sourceFiles[0];
                            const info = state.fileInfos.get(file.resolvedPath);
                            if (info.signature === file.version) {
                                const signature = computeSignatureWithDiagnostics(state.program, file, text, host, data);
                                if (!((_a = data == null ? void 0 : data.diagnostics) == null ? void 0 : _a.length)) emitSignature = signature;
                                if (signature !== file.version) {
                                    var _state_signatureInfo;
                                    if (host.storeSignatureInfo) ((_state_signatureInfo = state.signatureInfo) !== null && _state_signatureInfo !== void 0 ? _state_signatureInfo : state.signatureInfo = /* @__PURE__ */ new Map()).set(file.resolvedPath, 1 /* StoredSignatureAtEmit */ );
                                    if (state.affectedFiles) {
                                        const existing = (_b = state.oldSignatures) == null ? void 0 : _b.get(file.resolvedPath);
                                        var _state_oldSignatures;
                                        if (existing === void 0) ((_state_oldSignatures = state.oldSignatures) !== null && _state_oldSignatures !== void 0 ? _state_oldSignatures : state.oldSignatures = /* @__PURE__ */ new Map()).set(file.resolvedPath, info.signature || false);
                                        info.signature = signature;
                                    } else info.signature = signature;
                                }
                            }
                        }
                        if (state.compilerOptions.composite) {
                            const filePath = sourceFiles[0].resolvedPath;
                            emitSignature = handleNewSignature((_c = state.emitSignatures) == null ? void 0 : _c.get(filePath), emitSignature);
                            if (!emitSignature) return data.skippedDtsWrite = true;
                            var _state_emitSignatures;
                            ((_state_emitSignatures = state.emitSignatures) !== null && _state_emitSignatures !== void 0 ? _state_emitSignatures : state.emitSignatures = /* @__PURE__ */ new Map()).set(filePath, emitSignature);
                        }
                    } else if (state.compilerOptions.composite) {
                        const newSignature = handleNewSignature(state.outSignature, /*newSignature*/ void 0);
                        if (!newSignature) return data.skippedDtsWrite = true;
                        state.outSignature = newSignature;
                    }
                }
                if (writeFile2) writeFile2(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
                else if (host.writeFile) host.writeFile(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
                else state.program.writeFile(fileName, text, writeByteOrderMark, onError, sourceFiles, data);
                function handleNewSignature(oldSignatureFormat, newSignature) {
                    const oldSignature = !oldSignatureFormat || isString(oldSignatureFormat) ? oldSignatureFormat : oldSignatureFormat[0];
                    newSignature !== null && newSignature !== void 0 ? newSignature : newSignature = computeSignature(text, host, data);
                    if (newSignature === oldSignature) {
                        if (oldSignatureFormat === oldSignature) return void 0;
                        else if (data) data.differsOnlyInMap = true;
                        else data = {
                            differsOnlyInMap: true
                        };
                    } else {
                        state.hasChangedEmitSignature = true;
                        state.latestChangedDtsFile = fileName;
                    }
                    return newSignature;
                }
            };
        }
        function emit(targetSourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) assertSourceFileOkWithoutNextAffectedCall(state, targetSourceFile);
            const result = handleNoEmitOptions(builderProgram, targetSourceFile, writeFile2, cancellationToken);
            if (result) return result;
            if (!targetSourceFile) {
                if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) {
                    let sourceMaps = [];
                    let emitSkipped = false;
                    let diagnostics;
                    let emittedFiles = [];
                    let affectedEmitResult;
                    while(affectedEmitResult = emitNextAffectedFile(writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers)){
                        emitSkipped = emitSkipped || affectedEmitResult.result.emitSkipped;
                        diagnostics = addRange(diagnostics, affectedEmitResult.result.diagnostics);
                        emittedFiles = addRange(emittedFiles, affectedEmitResult.result.emittedFiles);
                        sourceMaps = addRange(sourceMaps, affectedEmitResult.result.sourceMaps);
                    }
                    return {
                        emitSkipped,
                        diagnostics: diagnostics || emptyArray,
                        emittedFiles,
                        sourceMaps
                    };
                } else clearAffectedFilesPendingEmit(state, emitOnlyDtsFiles, /*isForDtsErrors*/ false);
            }
            const emitResult = state.program.emit(targetSourceFile, getWriteFileCallback(writeFile2, customTransformers), cancellationToken, emitOnlyDtsFiles, customTransformers);
            handleNonEmitBuilderWithEmitOrDtsErrors(targetSourceFile, emitOnlyDtsFiles, /*isForDtsErrors*/ false, emitResult.diagnostics);
            return emitResult;
        }
        function handleNonEmitBuilderWithEmitOrDtsErrors(targetSourceFile, emitOnlyDtsFiles, isForDtsErrors, diagnostics) {
            if (!targetSourceFile && kind !== 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) {
                clearAffectedFilesPendingEmit(state, emitOnlyDtsFiles, isForDtsErrors);
                setEmitDiagnosticsPerFile(diagnostics);
            }
        }
        function getDeclarationDiagnostics2(sourceFile, cancellationToken) {
            var _a;
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            if (kind === 1 /* EmitAndSemanticDiagnosticsBuilderProgram */ ) {
                assertSourceFileOkWithoutNextAffectedCall(state, sourceFile);
                let affectedEmitResult;
                let diagnostics;
                while(affectedEmitResult = emitNextAffectedFileOrDtsErrors(/*writeFile*/ void 0, cancellationToken, /*emitOnlyDtsFiles*/ void 0, /*customTransformers*/ void 0, /*isForDtsErrors*/ true))if (!sourceFile) diagnostics = addRange(diagnostics, affectedEmitResult.result.diagnostics);
                return (!sourceFile ? diagnostics : (_a = state.emitDiagnosticsPerFile) == null ? void 0 : _a.get(sourceFile.resolvedPath)) || emptyArray;
            } else {
                const result = state.program.getDeclarationDiagnostics(sourceFile, cancellationToken);
                handleNonEmitBuilderWithEmitOrDtsErrors(sourceFile, /*emitOnlyDtsFiles*/ void 0, /*isForDtsErrors*/ true, result);
                return result;
            }
        }
        function getSemanticDiagnosticsOfNextAffectedFile(cancellationToken, ignoreSourceFile) {
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            while(true){
                const affected = getNextAffectedFile(state, cancellationToken, host);
                let result;
                if (!affected) {
                    if (state.checkPending && !state.compilerOptions.noCheck) {
                        state.checkPending = void 0;
                        state.buildInfoEmitPending = true;
                    }
                    return void 0;
                } else if (affected !== state.program) {
                    const affectedSourceFile = affected;
                    if (!ignoreSourceFile || !ignoreSourceFile(affectedSourceFile)) result = getSemanticDiagnosticsOfFile(state, affectedSourceFile, cancellationToken);
                    state.seenAffectedFiles.add(affectedSourceFile.resolvedPath);
                    state.affectedFilesIndex++;
                    state.buildInfoEmitPending = true;
                    if (!result) continue;
                } else {
                    let diagnostics;
                    const semanticDiagnosticsPerFile = /* @__PURE__ */ new Map();
                    state.program.getSourceFiles().forEach((sourceFile)=>diagnostics = addRange(diagnostics, getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken, semanticDiagnosticsPerFile)));
                    state.semanticDiagnosticsPerFile = semanticDiagnosticsPerFile;
                    result = diagnostics || emptyArray;
                    state.changedFilesSet.clear();
                    state.programEmitPending = getBuilderFileEmit(state.compilerOptions);
                    if (!state.compilerOptions.noCheck) state.checkPending = void 0;
                    state.buildInfoEmitPending = true;
                }
                return {
                    result,
                    affected
                };
            }
        }
        function getSemanticDiagnostics(sourceFile, cancellationToken) {
            Debug.assert(isBuilderProgramStateWithDefinedProgram(state));
            assertSourceFileOkWithoutNextAffectedCall(state, sourceFile);
            if (sourceFile) return getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken);
            while(true){
                const affectedResult = getSemanticDiagnosticsOfNextAffectedFile(cancellationToken);
                if (!affectedResult) break;
                if (affectedResult.affected === state.program) return affectedResult.result;
            }
            let diagnostics;
            for (const sourceFile2 of state.program.getSourceFiles())diagnostics = addRange(diagnostics, getSemanticDiagnosticsOfFile(state, sourceFile2, cancellationToken));
            if (state.checkPending && !state.compilerOptions.noCheck) {
                state.checkPending = void 0;
                state.buildInfoEmitPending = true;
            }
            return diagnostics || emptyArray;
        }
    }
    function addToAffectedFilesPendingEmit(state, affectedFilePendingEmit, kind) {
        var _a, _b;
        const existingKind = ((_a = state.affectedFilesPendingEmit) == null ? void 0 : _a.get(affectedFilePendingEmit)) || 0 /* None */ ;
        var _state_affectedFilesPendingEmit;
        ((_state_affectedFilesPendingEmit = state.affectedFilesPendingEmit) !== null && _state_affectedFilesPendingEmit !== void 0 ? _state_affectedFilesPendingEmit : state.affectedFilesPendingEmit = /* @__PURE__ */ new Map()).set(affectedFilePendingEmit, existingKind | kind);
        (_b = state.emitDiagnosticsPerFile) == null || _b.delete(affectedFilePendingEmit);
    }
    function toBuilderStateFileInfoForMultiEmit(fileInfo) {
        return isString(fileInfo) ? {
            version: fileInfo,
            signature: fileInfo,
            affectsGlobalScope: void 0,
            impliedFormat: void 0
        } : isString(fileInfo.signature) ? fileInfo : {
            version: fileInfo.version,
            signature: fileInfo.signature === false ? void 0 : fileInfo.version,
            affectsGlobalScope: fileInfo.affectsGlobalScope,
            impliedFormat: fileInfo.impliedFormat
        };
    }
    function toBuilderFileEmit(value1, fullEmitForOptions) {
        return isNumber(value1) ? fullEmitForOptions : value1[1] || 24 /* Dts */ ;
    }
    function toProgramEmitPending(value1, options) {
        return !value1 ? getBuilderFileEmit(options || {}) : value1;
    }
    function createBuilderProgramUsingIncrementalBuildInfo(buildInfo, buildInfoPath, host) {
        var _a, _b, _c, _d;
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        let state;
        const filePaths = (_a = buildInfo.fileNames) == null ? void 0 : _a.map(toPathInBuildInfoDirectory);
        let filePathsSetList;
        const latestChangedDtsFile = buildInfo.latestChangedDtsFile ? toAbsolutePath(buildInfo.latestChangedDtsFile) : void 0;
        const fileInfos = /* @__PURE__ */ new Map();
        const changedFilesSet = new Set(map(buildInfo.changeFileSet, toFilePath));
        if (isIncrementalBundleEmitBuildInfo(buildInfo)) {
            buildInfo.fileInfos.forEach((fileInfo, index)=>{
                const path = toFilePath(index + 1);
                fileInfos.set(path, isString(fileInfo) ? {
                    version: fileInfo,
                    signature: void 0,
                    affectsGlobalScope: void 0,
                    impliedFormat: void 0
                } : fileInfo);
            });
            state = {
                fileInfos,
                compilerOptions: buildInfo.options ? convertToOptionsWithAbsolutePaths(buildInfo.options, toAbsolutePath) : {},
                semanticDiagnosticsPerFile: toPerFileSemanticDiagnostics(buildInfo.semanticDiagnosticsPerFile),
                emitDiagnosticsPerFile: toPerFileEmitDiagnostics(buildInfo.emitDiagnosticsPerFile),
                hasReusableDiagnostic: true,
                changedFilesSet,
                latestChangedDtsFile,
                outSignature: buildInfo.outSignature,
                programEmitPending: buildInfo.pendingEmit === void 0 ? void 0 : toProgramEmitPending(buildInfo.pendingEmit, buildInfo.options),
                hasErrors: buildInfo.errors,
                checkPending: buildInfo.checkPending
            };
        } else {
            filePathsSetList = (_b = buildInfo.fileIdsList) == null ? void 0 : _b.map((fileIds)=>new Set(fileIds.map(toFilePath)));
            const emitSignatures = ((_c = buildInfo.options) == null ? void 0 : _c.composite) && !buildInfo.options.outFile ? /* @__PURE__ */ new Map() : void 0;
            buildInfo.fileInfos.forEach((fileInfo, index)=>{
                const path = toFilePath(index + 1);
                const stateFileInfo = toBuilderStateFileInfoForMultiEmit(fileInfo);
                fileInfos.set(path, stateFileInfo);
                if (emitSignatures && stateFileInfo.signature) emitSignatures.set(path, stateFileInfo.signature);
            });
            (_d = buildInfo.emitSignatures) == null || _d.forEach((value1)=>{
                if (isNumber(value1)) emitSignatures.delete(toFilePath(value1));
                else {
                    const key = toFilePath(value1[0]);
                    emitSignatures.set(key, !isString(value1[1]) && !value1[1].length ? // File signature is emit signature but differs in map
                    [
                        emitSignatures.get(key)
                    ] : value1[1]);
                }
            });
            const fullEmitForOptions = buildInfo.affectedFilesPendingEmit ? getBuilderFileEmit(buildInfo.options || {}) : void 0;
            var _buildInfo_options;
            state = {
                fileInfos,
                compilerOptions: buildInfo.options ? convertToOptionsWithAbsolutePaths(buildInfo.options, toAbsolutePath) : {},
                referencedMap: toManyToManyPathMap(buildInfo.referencedMap, (_buildInfo_options = buildInfo.options) !== null && _buildInfo_options !== void 0 ? _buildInfo_options : {}),
                semanticDiagnosticsPerFile: toPerFileSemanticDiagnostics(buildInfo.semanticDiagnosticsPerFile),
                emitDiagnosticsPerFile: toPerFileEmitDiagnostics(buildInfo.emitDiagnosticsPerFile),
                hasReusableDiagnostic: true,
                changedFilesSet,
                affectedFilesPendingEmit: buildInfo.affectedFilesPendingEmit && arrayToMap(buildInfo.affectedFilesPendingEmit, (value1)=>toFilePath(isNumber(value1) ? value1 : value1[0]), (value1)=>toBuilderFileEmit(value1, fullEmitForOptions)),
                latestChangedDtsFile,
                emitSignatures: (emitSignatures == null ? void 0 : emitSignatures.size) ? emitSignatures : void 0,
                hasErrors: buildInfo.errors,
                checkPending: buildInfo.checkPending
            };
        }
        return {
            state,
            getProgram: notImplemented,
            getProgramOrUndefined: returnUndefined,
            releaseProgram: noop,
            getCompilerOptions: ()=>state.compilerOptions,
            getSourceFile: notImplemented,
            getSourceFiles: notImplemented,
            getOptionsDiagnostics: notImplemented,
            getGlobalDiagnostics: notImplemented,
            getConfigFileParsingDiagnostics: notImplemented,
            getSyntacticDiagnostics: notImplemented,
            getDeclarationDiagnostics: notImplemented,
            getSemanticDiagnostics: notImplemented,
            emit: notImplemented,
            getAllDependencies: notImplemented,
            getCurrentDirectory: notImplemented,
            emitNextAffectedFile: notImplemented,
            getSemanticDiagnosticsOfNextAffectedFile: notImplemented,
            emitBuildInfo: notImplemented,
            close: noop,
            hasChangedEmitSignature: returnFalse
        };
        function toPathInBuildInfoDirectory(path) {
            return toPath(path, buildInfoDirectory, getCanonicalFileName);
        }
        function toAbsolutePath(path) {
            return getNormalizedAbsolutePath(path, buildInfoDirectory);
        }
        function toFilePath(fileId) {
            return filePaths[fileId - 1];
        }
        function toFilePathsSet(fileIdsListId) {
            return filePathsSetList[fileIdsListId - 1];
        }
        function toManyToManyPathMap(referenceMap, options) {
            const map2 = BuilderState.createReferencedMap(options);
            if (!map2 || !referenceMap) return map2;
            referenceMap.forEach(([fileId, fileIdListId])=>map2.set(toFilePath(fileId), toFilePathsSet(fileIdListId)));
            return map2;
        }
        function toPerFileSemanticDiagnostics(diagnostics) {
            const semanticDiagnostics = new Map(mapDefinedIterator(fileInfos.keys(), (key)=>!changedFilesSet.has(key) ? [
                    key,
                    emptyArray
                ] : void 0));
            diagnostics == null || diagnostics.forEach((value1)=>{
                if (isNumber(value1)) semanticDiagnostics.delete(toFilePath(value1));
                else semanticDiagnostics.set(toFilePath(value1[0]), value1[1]);
            });
            return semanticDiagnostics;
        }
        function toPerFileEmitDiagnostics(diagnostics) {
            return diagnostics && arrayToMap(diagnostics, (value1)=>toFilePath(value1[0]), (value1)=>value1[1]);
        }
    }
    function getBuildInfoFileVersionMap(program, buildInfoPath, host) {
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        const fileInfos = /* @__PURE__ */ new Map();
        let rootIndex = 0;
        const roots = /* @__PURE__ */ new Map();
        const resolvedRoots = new Map(program.resolvedRoot);
        program.fileInfos.forEach((fileInfo, index)=>{
            const path = toPath(program.fileNames[index], buildInfoDirectory, getCanonicalFileName);
            const version2 = isString(fileInfo) ? fileInfo : fileInfo.version;
            fileInfos.set(path, version2);
            if (rootIndex < program.root.length) {
                const current = program.root[rootIndex];
                const fileId = index + 1;
                if (isArray(current)) {
                    if (current[0] <= fileId && fileId <= current[1]) {
                        addRoot(fileId, path);
                        if (current[1] === fileId) rootIndex++;
                    }
                } else if (current === fileId) {
                    addRoot(fileId, path);
                    rootIndex++;
                }
            }
        });
        return {
            fileInfos,
            roots
        };
        function addRoot(fileId, path) {
            const root = resolvedRoots.get(fileId);
            if (root) roots.set(toPath(program.fileNames[root - 1], buildInfoDirectory, getCanonicalFileName), path);
            else roots.set(path, void 0);
        }
    }
    function getNonIncrementalBuildInfoRoots(buildInfo, buildInfoPath, host) {
        if (!isNonIncrementalBuildInfo(buildInfo)) return void 0;
        const buildInfoDirectory = getDirectoryPath(getNormalizedAbsolutePath(buildInfoPath, host.getCurrentDirectory()));
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        return buildInfo.root.map((r)=>toPath(r, buildInfoDirectory, getCanonicalFileName));
    }
    function createRedirectedBuilderProgram(state, configFileParsingDiagnostics) {
        return {
            state: void 0,
            getProgram,
            getProgramOrUndefined: ()=>state.program,
            releaseProgram: ()=>state.program = void 0,
            getCompilerOptions: ()=>state.compilerOptions,
            getSourceFile: (fileName)=>getProgram().getSourceFile(fileName),
            getSourceFiles: ()=>getProgram().getSourceFiles(),
            getOptionsDiagnostics: (cancellationToken)=>getProgram().getOptionsDiagnostics(cancellationToken),
            getGlobalDiagnostics: (cancellationToken)=>getProgram().getGlobalDiagnostics(cancellationToken),
            getConfigFileParsingDiagnostics: ()=>configFileParsingDiagnostics,
            getSyntacticDiagnostics: (sourceFile, cancellationToken)=>getProgram().getSyntacticDiagnostics(sourceFile, cancellationToken),
            getDeclarationDiagnostics: (sourceFile, cancellationToken)=>getProgram().getDeclarationDiagnostics(sourceFile, cancellationToken),
            getSemanticDiagnostics: (sourceFile, cancellationToken)=>getProgram().getSemanticDiagnostics(sourceFile, cancellationToken),
            emit: (sourceFile, writeFile2, cancellationToken, emitOnlyDts, customTransformers)=>getProgram().emit(sourceFile, writeFile2, cancellationToken, emitOnlyDts, customTransformers),
            emitBuildInfo: (writeFile2, cancellationToken)=>getProgram().emitBuildInfo(writeFile2, cancellationToken),
            getAllDependencies: notImplemented,
            getCurrentDirectory: ()=>getProgram().getCurrentDirectory(),
            close: noop
        };
        function getProgram() {
            return Debug.checkDefined(state.program);
        }
    }
    // src/compiler/builderPublic.ts
    function createSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        return createBuilderProgram(0 /* SemanticDiagnosticsBuilderProgram */ , getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences));
    }
    function createEmitAndSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        return createBuilderProgram(1 /* EmitAndSemanticDiagnosticsBuilderProgram */ , getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences));
    }
    function createAbstractBuilder(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences) {
        const { newProgram, configFileParsingDiagnostics: newConfigFileParsingDiagnostics } = getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics, projectReferences);
        return createRedirectedBuilderProgram({
            program: newProgram,
            compilerOptions: newProgram.getCompilerOptions()
        }, newConfigFileParsingDiagnostics);
    }
    // src/compiler/resolutionCache.ts
    function removeIgnoredPath(path) {
        if (endsWith(path, "/node_modules/.staging")) return removeSuffix(path, "/.staging");
        return some(ignoredPaths, (searchPath)=>path.includes(searchPath)) ? void 0 : path;
    }
    function perceivedOsRootLengthForWatching(pathComponents2, length2) {
        if (length2 <= 1) return 1;
        let indexAfterOsRoot = 1;
        let isDosStyle = pathComponents2[0].search(/[a-z]:/i) === 0;
        if (pathComponents2[0] !== directorySeparator && !isDosStyle && // Non dos style paths
        pathComponents2[1].search(/[a-z]\$$/i) === 0) {
            if (length2 === 2) return 2;
            indexAfterOsRoot = 2;
            isDosStyle = true;
        }
        if (isDosStyle && !pathComponents2[indexAfterOsRoot].match(/^users$/i)) return indexAfterOsRoot;
        if (pathComponents2[indexAfterOsRoot].match(/^workspaces$/i)) return indexAfterOsRoot + 1;
        return indexAfterOsRoot + 2;
    }
    function canWatchDirectoryOrFile(pathComponents2, length2) {
        if (length2 === void 0) length2 = pathComponents2.length;
        if (length2 <= 2) return false;
        const perceivedOsRootLength = perceivedOsRootLengthForWatching(pathComponents2, length2);
        return length2 > perceivedOsRootLength + 1;
    }
    function canWatchDirectoryOrFilePath(path) {
        return canWatchDirectoryOrFile(getPathComponents(path));
    }
    function canWatchAtTypes(atTypes) {
        return canWatchAffectedPackageJsonOrNodeModulesOfAtTypes(getDirectoryPath(atTypes));
    }
    function isInDirectoryPath(dirComponents, fileOrDirComponents) {
        if (fileOrDirComponents.length < dirComponents.length) return false;
        for(let i = 0; i < dirComponents.length; i++){
            if (fileOrDirComponents[i] !== dirComponents[i]) return false;
        }
        return true;
    }
    function canWatchAffectedPackageJsonOrNodeModulesOfAtTypes(fileOrDirPath) {
        return canWatchDirectoryOrFilePath(fileOrDirPath);
    }
    function canWatchAffectingLocation(filePath) {
        return canWatchAffectedPackageJsonOrNodeModulesOfAtTypes(filePath);
    }
    function getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath, rootDir, rootPath, rootPathComponents, isRootWatchable, getCurrentDirectory, preferNonRecursiveWatch) {
        const failedLookupPathComponents = getPathComponents(failedLookupLocationPath);
        failedLookupLocation = isRootedDiskPath(failedLookupLocation) ? normalizePath(failedLookupLocation) : getNormalizedAbsolutePath(failedLookupLocation, getCurrentDirectory());
        const failedLookupComponents = getPathComponents(failedLookupLocation);
        const perceivedOsRootLength = perceivedOsRootLengthForWatching(failedLookupPathComponents, failedLookupPathComponents.length);
        if (failedLookupPathComponents.length <= perceivedOsRootLength + 1) return void 0;
        const nodeModulesIndex = failedLookupPathComponents.indexOf("node_modules");
        if (nodeModulesIndex !== -1 && nodeModulesIndex + 1 <= perceivedOsRootLength + 1) return void 0;
        const lastNodeModulesIndex = failedLookupPathComponents.lastIndexOf("node_modules");
        if (isRootWatchable && isInDirectoryPath(rootPathComponents, failedLookupPathComponents)) {
            if (failedLookupPathComponents.length > rootPathComponents.length + 1) return getDirectoryOfFailedLookupWatch(failedLookupComponents, failedLookupPathComponents, Math.max(rootPathComponents.length + 1, perceivedOsRootLength + 1), lastNodeModulesIndex);
            else return {
                dir: rootDir,
                dirPath: rootPath,
                nonRecursive: true
            };
        }
        return getDirectoryToWatchFromFailedLookupLocationDirectory(failedLookupComponents, failedLookupPathComponents, failedLookupPathComponents.length - 1, perceivedOsRootLength, nodeModulesIndex, rootPathComponents, lastNodeModulesIndex, preferNonRecursiveWatch);
    }
    function getDirectoryToWatchFromFailedLookupLocationDirectory(dirComponents, dirPathComponents, dirPathComponentsLength, perceivedOsRootLength, nodeModulesIndex, rootPathComponents, lastNodeModulesIndex, preferNonRecursiveWatch) {
        if (nodeModulesIndex !== -1) return getDirectoryOfFailedLookupWatch(dirComponents, dirPathComponents, nodeModulesIndex + 1, lastNodeModulesIndex);
        let nonRecursive = true;
        let length2 = dirPathComponentsLength;
        if (!preferNonRecursiveWatch) {
            for(let i = 0; i < dirPathComponentsLength; i++)if (dirPathComponents[i] !== rootPathComponents[i]) {
                nonRecursive = false;
                length2 = Math.max(i + 1, perceivedOsRootLength + 1);
                break;
            }
        }
        return getDirectoryOfFailedLookupWatch(dirComponents, dirPathComponents, length2, lastNodeModulesIndex, nonRecursive);
    }
    function getDirectoryOfFailedLookupWatch(dirComponents, dirPathComponents, length2, lastNodeModulesIndex, nonRecursive) {
        let packageDirLength;
        if (lastNodeModulesIndex !== -1 && lastNodeModulesIndex + 1 >= length2 && lastNodeModulesIndex + 2 < dirPathComponents.length) {
            if (!startsWith(dirPathComponents[lastNodeModulesIndex + 1], "@")) packageDirLength = lastNodeModulesIndex + 2;
            else if (lastNodeModulesIndex + 3 < dirPathComponents.length) packageDirLength = lastNodeModulesIndex + 3;
        }
        return {
            dir: getPathFromPathComponents(dirComponents, length2),
            dirPath: getPathFromPathComponents(dirPathComponents, length2),
            nonRecursive,
            packageDir: packageDirLength !== void 0 ? getPathFromPathComponents(dirComponents, packageDirLength) : void 0,
            packageDirPath: packageDirLength !== void 0 ? getPathFromPathComponents(dirPathComponents, packageDirLength) : void 0
        };
    }
    function getDirectoryToWatchFailedLookupLocationFromTypeRoot(typeRoot, typeRootPath, rootPath, rootPathComponents, isRootWatchable, getCurrentDirectory, preferNonRecursiveWatch, filterCustomPath) {
        const typeRootPathComponents = getPathComponents(typeRootPath);
        if (isRootWatchable && isInDirectoryPath(rootPathComponents, typeRootPathComponents)) return rootPath;
        typeRoot = isRootedDiskPath(typeRoot) ? normalizePath(typeRoot) : getNormalizedAbsolutePath(typeRoot, getCurrentDirectory());
        const toWatch = getDirectoryToWatchFromFailedLookupLocationDirectory(getPathComponents(typeRoot), typeRootPathComponents, typeRootPathComponents.length, perceivedOsRootLengthForWatching(typeRootPathComponents, typeRootPathComponents.length), typeRootPathComponents.indexOf("node_modules"), rootPathComponents, typeRootPathComponents.lastIndexOf("node_modules"), preferNonRecursiveWatch);
        return toWatch && filterCustomPath(toWatch.dirPath) ? toWatch.dirPath : void 0;
    }
    function getRootDirectoryOfResolutionCache(rootDirForResolution, getCurrentDirectory) {
        const normalized = getNormalizedAbsolutePath(rootDirForResolution, getCurrentDirectory());
        return !isDiskPathRoot(normalized) ? removeTrailingDirectorySeparator(normalized) : normalized;
    }
    function getModuleResolutionHost(resolutionHost) {
        var _a;
        return ((_a = resolutionHost.getCompilerHost) == null ? void 0 : _a.call(resolutionHost)) || resolutionHost;
    }
    function createModuleResolutionLoaderUsingGlobalCache(containingFile, redirectedReference, options, resolutionHost, moduleResolutionCache) {
        return {
            nameAndMode: moduleResolutionNameAndModeGetter,
            resolve: (moduleName, resoluionMode)=>resolveModuleNameUsingGlobalCache(resolutionHost, moduleResolutionCache, moduleName, containingFile, options, redirectedReference, resoluionMode)
        };
    }
    function resolveModuleNameUsingGlobalCache(resolutionHost, moduleResolutionCache, moduleName, containingFile, compilerOptions, redirectedReference, mode) {
        const host = getModuleResolutionHost(resolutionHost);
        const primaryResult = resolveModuleName(moduleName, containingFile, compilerOptions, host, moduleResolutionCache, redirectedReference, mode);
        if (!resolutionHost.getGlobalTypingsCacheLocation) return primaryResult;
        const globalCache = resolutionHost.getGlobalTypingsCacheLocation();
        if (globalCache !== void 0 && !isExternalModuleNameRelative(moduleName) && !(primaryResult.resolvedModule && extensionIsTS(primaryResult.resolvedModule.extension))) {
            const { resolvedModule, failedLookupLocations, affectingLocations, resolutionDiagnostics } = loadModuleFromGlobalCache(Debug.checkDefined(resolutionHost.globalCacheResolutionModuleName)(moduleName), resolutionHost.projectName, compilerOptions, host, globalCache, moduleResolutionCache);
            if (resolvedModule) {
                primaryResult.resolvedModule = resolvedModule;
                primaryResult.failedLookupLocations = updateResolutionField(primaryResult.failedLookupLocations, failedLookupLocations);
                primaryResult.affectingLocations = updateResolutionField(primaryResult.affectingLocations, affectingLocations);
                primaryResult.resolutionDiagnostics = updateResolutionField(primaryResult.resolutionDiagnostics, resolutionDiagnostics);
                return primaryResult;
            }
        }
        return primaryResult;
    }
    function createResolutionCache(resolutionHost, rootDirForResolution, logChangesWhenResolvingModule) {
        let filesWithChangedSetOfUnresolvedImports;
        let filesWithInvalidatedResolutions;
        let filesWithInvalidatedNonRelativeUnresolvedImports;
        const nonRelativeExternalModuleResolutions = /* @__PURE__ */ new Set();
        const resolutionsWithFailedLookups = /* @__PURE__ */ new Set();
        const resolutionsWithOnlyAffectingLocations = /* @__PURE__ */ new Set();
        const resolvedFileToResolution = /* @__PURE__ */ new Map();
        const impliedFormatPackageJsons = /* @__PURE__ */ new Map();
        let hasChangedAutomaticTypeDirectiveNames = false;
        let affectingPathChecksForFile;
        let affectingPathChecks;
        let failedLookupChecks;
        let startsWithPathChecks;
        let isInDirectoryChecks;
        let allModuleAndTypeResolutionsAreInvalidated = false;
        const getCurrentDirectory = memoize(()=>resolutionHost.getCurrentDirectory());
        const cachedDirectoryStructureHost = resolutionHost.getCachedDirectoryStructureHost();
        const resolvedModuleNames = /* @__PURE__ */ new Map();
        const moduleResolutionCache = createModuleResolutionCache(getCurrentDirectory(), resolutionHost.getCanonicalFileName, resolutionHost.getCompilationSettings());
        const resolvedTypeReferenceDirectives = /* @__PURE__ */ new Map();
        const typeReferenceDirectiveResolutionCache = createTypeReferenceDirectiveResolutionCache(getCurrentDirectory(), resolutionHost.getCanonicalFileName, resolutionHost.getCompilationSettings(), moduleResolutionCache.getPackageJsonInfoCache(), moduleResolutionCache.optionsToRedirectsKey);
        const resolvedLibraries = /* @__PURE__ */ new Map();
        const libraryResolutionCache = createModuleResolutionCache(getCurrentDirectory(), resolutionHost.getCanonicalFileName, getOptionsForLibraryResolution(resolutionHost.getCompilationSettings()), moduleResolutionCache.getPackageJsonInfoCache());
        const directoryWatchesOfFailedLookups = /* @__PURE__ */ new Map();
        const fileWatchesOfAffectingLocations = /* @__PURE__ */ new Map();
        const rootDir = getRootDirectoryOfResolutionCache(rootDirForResolution, getCurrentDirectory);
        const rootPath = resolutionHost.toPath(rootDir);
        const rootPathComponents = getPathComponents(rootPath);
        const isRootWatchable = canWatchDirectoryOrFile(rootPathComponents);
        const isSymlinkCache = /* @__PURE__ */ new Map();
        const packageDirWatchers = /* @__PURE__ */ new Map();
        const dirPathToSymlinkPackageRefCount = /* @__PURE__ */ new Map();
        const typeRootsWatches = /* @__PURE__ */ new Map();
        return {
            rootDirForResolution,
            resolvedModuleNames,
            resolvedTypeReferenceDirectives,
            resolvedLibraries,
            resolvedFileToResolution,
            resolutionsWithFailedLookups,
            resolutionsWithOnlyAffectingLocations,
            directoryWatchesOfFailedLookups,
            fileWatchesOfAffectingLocations,
            packageDirWatchers,
            dirPathToSymlinkPackageRefCount,
            watchFailedLookupLocationsOfExternalModuleResolutions,
            getModuleResolutionCache: ()=>moduleResolutionCache,
            startRecordingFilesWithChangedResolutions,
            finishRecordingFilesWithChangedResolutions,
            // perDirectoryResolvedModuleNames and perDirectoryResolvedTypeReferenceDirectives could be non empty if there was exception during program update
            // (between startCachingPerDirectoryResolution and finishCachingPerDirectoryResolution)
            startCachingPerDirectoryResolution,
            finishCachingPerDirectoryResolution,
            resolveModuleNameLiterals,
            resolveTypeReferenceDirectiveReferences,
            resolveLibrary: resolveLibrary2,
            resolveSingleModuleNameWithoutWatching,
            removeResolutionsFromProjectReferenceRedirects,
            removeResolutionsOfFile,
            hasChangedAutomaticTypeDirectiveNames: ()=>hasChangedAutomaticTypeDirectiveNames,
            invalidateResolutionOfFile,
            invalidateResolutionsOfFailedLookupLocations,
            setFilesWithInvalidatedNonRelativeUnresolvedImports,
            createHasInvalidatedResolutions,
            isFileWithInvalidatedNonRelativeUnresolvedImports,
            updateTypeRootsWatch,
            closeTypeRootsWatch,
            clear: clear2,
            onChangesAffectModuleResolution
        };
        function clear2() {
            clearMap(directoryWatchesOfFailedLookups, closeFileWatcherOf);
            clearMap(fileWatchesOfAffectingLocations, closeFileWatcherOf);
            isSymlinkCache.clear();
            packageDirWatchers.clear();
            dirPathToSymlinkPackageRefCount.clear();
            nonRelativeExternalModuleResolutions.clear();
            closeTypeRootsWatch();
            resolvedModuleNames.clear();
            resolvedTypeReferenceDirectives.clear();
            resolvedFileToResolution.clear();
            resolutionsWithFailedLookups.clear();
            resolutionsWithOnlyAffectingLocations.clear();
            failedLookupChecks = void 0;
            startsWithPathChecks = void 0;
            isInDirectoryChecks = void 0;
            affectingPathChecks = void 0;
            affectingPathChecksForFile = void 0;
            allModuleAndTypeResolutionsAreInvalidated = false;
            moduleResolutionCache.clear();
            typeReferenceDirectiveResolutionCache.clear();
            moduleResolutionCache.update(resolutionHost.getCompilationSettings());
            typeReferenceDirectiveResolutionCache.update(resolutionHost.getCompilationSettings());
            libraryResolutionCache.clear();
            impliedFormatPackageJsons.clear();
            resolvedLibraries.clear();
            hasChangedAutomaticTypeDirectiveNames = false;
        }
        function onChangesAffectModuleResolution() {
            allModuleAndTypeResolutionsAreInvalidated = true;
            moduleResolutionCache.clearAllExceptPackageJsonInfoCache();
            typeReferenceDirectiveResolutionCache.clearAllExceptPackageJsonInfoCache();
            moduleResolutionCache.update(resolutionHost.getCompilationSettings());
            typeReferenceDirectiveResolutionCache.update(resolutionHost.getCompilationSettings());
        }
        function startRecordingFilesWithChangedResolutions() {
            filesWithChangedSetOfUnresolvedImports = [];
        }
        function finishRecordingFilesWithChangedResolutions() {
            const collected = filesWithChangedSetOfUnresolvedImports;
            filesWithChangedSetOfUnresolvedImports = void 0;
            return collected;
        }
        function isFileWithInvalidatedNonRelativeUnresolvedImports(path) {
            if (!filesWithInvalidatedNonRelativeUnresolvedImports) return false;
            const value1 = filesWithInvalidatedNonRelativeUnresolvedImports.get(path);
            return !!value1 && !!value1.length;
        }
        function createHasInvalidatedResolutions(customHasInvalidatedResolutions, customHasInvalidatedLibResolutions) {
            invalidateResolutionsOfFailedLookupLocations();
            const collected = filesWithInvalidatedResolutions;
            filesWithInvalidatedResolutions = void 0;
            return {
                hasInvalidatedResolutions: (path)=>customHasInvalidatedResolutions(path) || allModuleAndTypeResolutionsAreInvalidated || !!(collected == null ? void 0 : collected.has(path)) || isFileWithInvalidatedNonRelativeUnresolvedImports(path),
                hasInvalidatedLibResolutions: (libFileName)=>{
                    var _a;
                    return customHasInvalidatedLibResolutions(libFileName) || !!((_a = resolvedLibraries == null ? void 0 : resolvedLibraries.get(libFileName)) == null ? void 0 : _a.isInvalidated);
                }
            };
        }
        function startCachingPerDirectoryResolution() {
            moduleResolutionCache.isReadonly = void 0;
            typeReferenceDirectiveResolutionCache.isReadonly = void 0;
            libraryResolutionCache.isReadonly = void 0;
            moduleResolutionCache.getPackageJsonInfoCache().isReadonly = void 0;
            moduleResolutionCache.clearAllExceptPackageJsonInfoCache();
            typeReferenceDirectiveResolutionCache.clearAllExceptPackageJsonInfoCache();
            libraryResolutionCache.clearAllExceptPackageJsonInfoCache();
            watchFailedLookupLocationOfNonRelativeModuleResolutions();
            isSymlinkCache.clear();
        }
        function cleanupLibResolutionWatching(newProgram) {
            resolvedLibraries.forEach((resolution, libFileName)=>{
                var _a;
                if (!((_a = newProgram == null ? void 0 : newProgram.resolvedLibReferences) == null ? void 0 : _a.has(libFileName))) {
                    stopWatchFailedLookupLocationOfResolution(resolution, resolutionHost.toPath(getInferredLibraryNameResolveFrom(resolutionHost.getCompilationSettings(), getCurrentDirectory(), libFileName)), getResolvedModuleFromResolution);
                    resolvedLibraries.delete(libFileName);
                }
            });
        }
        function finishCachingPerDirectoryResolution(newProgram, oldProgram) {
            filesWithInvalidatedNonRelativeUnresolvedImports = void 0;
            allModuleAndTypeResolutionsAreInvalidated = false;
            watchFailedLookupLocationOfNonRelativeModuleResolutions();
            if (newProgram !== oldProgram) {
                cleanupLibResolutionWatching(newProgram);
                newProgram == null || newProgram.getSourceFiles().forEach((newFile)=>{
                    var _a;
                    var _ref;
                    const expected = (_ref = (_a = newFile.packageJsonLocations) == null ? void 0 : _a.length) !== null && _ref !== void 0 ? _ref : 0;
                    var _impliedFormatPackageJsons_get;
                    const existing = (_impliedFormatPackageJsons_get = impliedFormatPackageJsons.get(newFile.resolvedPath)) !== null && _impliedFormatPackageJsons_get !== void 0 ? _impliedFormatPackageJsons_get : emptyArray;
                    for(let i = existing.length; i < expected; i++)createFileWatcherOfAffectingLocation(newFile.packageJsonLocations[i], /*forResolution*/ false);
                    if (existing.length > expected) for(let i = expected; i < existing.length; i++)fileWatchesOfAffectingLocations.get(existing[i]).files--;
                    if (expected) impliedFormatPackageJsons.set(newFile.resolvedPath, newFile.packageJsonLocations);
                    else impliedFormatPackageJsons.delete(newFile.resolvedPath);
                });
                impliedFormatPackageJsons.forEach((existing, path)=>{
                    const newFile = newProgram == null ? void 0 : newProgram.getSourceFileByPath(path);
                    if (!newFile || newFile.resolvedPath !== path) {
                        existing.forEach((location)=>fileWatchesOfAffectingLocations.get(location).files--);
                        impliedFormatPackageJsons.delete(path);
                    }
                });
            }
            directoryWatchesOfFailedLookups.forEach(closeDirectoryWatchesOfFailedLookup);
            fileWatchesOfAffectingLocations.forEach(closeFileWatcherOfAffectingLocation);
            packageDirWatchers.forEach(closePackageDirWatcher);
            hasChangedAutomaticTypeDirectiveNames = false;
            moduleResolutionCache.isReadonly = true;
            typeReferenceDirectiveResolutionCache.isReadonly = true;
            libraryResolutionCache.isReadonly = true;
            moduleResolutionCache.getPackageJsonInfoCache().isReadonly = true;
            isSymlinkCache.clear();
        }
        function closePackageDirWatcher(watcher, packageDirPath) {
            if (watcher.dirPathToWatcher.size === 0) packageDirWatchers.delete(packageDirPath);
        }
        function closeDirectoryWatchesOfFailedLookup(watcher, path) {
            if (watcher.refCount === 0) {
                directoryWatchesOfFailedLookups.delete(path);
                watcher.watcher.close();
            }
        }
        function closeFileWatcherOfAffectingLocation(watcher, path) {
            var _a;
            if (watcher.files === 0 && watcher.resolutions === 0 && !((_a = watcher.symlinks) == null ? void 0 : _a.size)) {
                fileWatchesOfAffectingLocations.delete(path);
                watcher.watcher.close();
            }
        }
        function resolveNamesWithLocalCache({ entries, containingFile, containingSourceFile, redirectedReference, options, perFileCache, reusedNames, loader, getResolutionWithResolvedFileName, deferWatchingNonRelativeResolution, shouldRetryResolution, logChanges }) {
            var _a;
            const path = resolutionHost.toPath(containingFile);
            const resolutionsInFile = perFileCache.get(path) || perFileCache.set(path, createModeAwareCache()).get(path);
            const resolvedModules = [];
            const hasInvalidatedNonRelativeUnresolvedImport = logChanges && isFileWithInvalidatedNonRelativeUnresolvedImports(path);
            const program = resolutionHost.getCurrentProgram();
            const oldRedirect = program && ((_a = program.getRedirectFromSourceFile(containingFile)) == null ? void 0 : _a.resolvedRef);
            const unmatchedRedirects = oldRedirect ? !redirectedReference || redirectedReference.sourceFile.path !== oldRedirect.sourceFile.path : !!redirectedReference;
            const seenNamesInFile = createModeAwareCache();
            for (const entry of entries){
                const name = loader.nameAndMode.getName(entry);
                const mode = loader.nameAndMode.getMode(entry, containingSourceFile, (redirectedReference == null ? void 0 : redirectedReference.commandLine.options) || options);
                let resolution = resolutionsInFile.get(name, mode);
                if (!seenNamesInFile.has(name, mode) && (allModuleAndTypeResolutionsAreInvalidated || unmatchedRedirects || !resolution || resolution.isInvalidated || // If the name is unresolved import that was invalidated, recalculate
                hasInvalidatedNonRelativeUnresolvedImport && !isExternalModuleNameRelative(name) && shouldRetryResolution(resolution))) {
                    const existingResolution = resolution;
                    resolution = loader.resolve(name, mode);
                    if (resolutionHost.onDiscoveredSymlink && resolutionIsSymlink(resolution)) resolutionHost.onDiscoveredSymlink();
                    resolutionsInFile.set(name, mode, resolution);
                    if (resolution !== existingResolution) {
                        watchFailedLookupLocationsOfExternalModuleResolutions(name, resolution, path, getResolutionWithResolvedFileName, deferWatchingNonRelativeResolution);
                        if (existingResolution) stopWatchFailedLookupLocationOfResolution(existingResolution, path, getResolutionWithResolvedFileName);
                    }
                    if (logChanges && filesWithChangedSetOfUnresolvedImports && !resolutionIsEqualTo(existingResolution, resolution)) {
                        filesWithChangedSetOfUnresolvedImports.push(path);
                        logChanges = false;
                    }
                } else {
                    const host = getModuleResolutionHost(resolutionHost);
                    if (isTraceEnabled(options, host) && !seenNamesInFile.has(name, mode)) {
                        const resolved = getResolutionWithResolvedFileName(resolution);
                        trace(host, perFileCache === resolvedModuleNames ? (resolved == null ? void 0 : resolved.resolvedFileName) ? resolved.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved : (resolved == null ? void 0 : resolved.resolvedFileName) ? resolved.packageId ? Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_type_reference_directive_0_from_1_of_old_program_it_was_not_resolved, name, containingFile, resolved == null ? void 0 : resolved.resolvedFileName, (resolved == null ? void 0 : resolved.packageId) && packageIdToString(resolved.packageId));
                    }
                }
                Debug.assert(resolution !== void 0 && !resolution.isInvalidated);
                seenNamesInFile.set(name, mode, true);
                resolvedModules.push(resolution);
            }
            reusedNames == null || reusedNames.forEach((entry)=>seenNamesInFile.set(loader.nameAndMode.getName(entry), loader.nameAndMode.getMode(entry, containingSourceFile, (redirectedReference == null ? void 0 : redirectedReference.commandLine.options) || options), true));
            if (resolutionsInFile.size() !== seenNamesInFile.size()) resolutionsInFile.forEach((resolution, name, mode)=>{
                if (!seenNamesInFile.has(name, mode)) {
                    stopWatchFailedLookupLocationOfResolution(resolution, path, getResolutionWithResolvedFileName);
                    resolutionsInFile.delete(name, mode);
                }
            });
            return resolvedModules;
            function resolutionIsEqualTo(oldResolution, newResolution) {
                if (oldResolution === newResolution) return true;
                if (!oldResolution || !newResolution) return false;
                const oldResult = getResolutionWithResolvedFileName(oldResolution);
                const newResult = getResolutionWithResolvedFileName(newResolution);
                if (oldResult === newResult) return true;
                if (!oldResult || !newResult) return false;
                return oldResult.resolvedFileName === newResult.resolvedFileName;
            }
        }
        function resolveTypeReferenceDirectiveReferences(typeDirectiveReferences, containingFile, redirectedReference, options, containingSourceFile, reusedNames) {
            return resolveNamesWithLocalCache({
                entries: typeDirectiveReferences,
                containingFile,
                containingSourceFile,
                redirectedReference,
                options,
                reusedNames,
                perFileCache: resolvedTypeReferenceDirectives,
                loader: createTypeReferenceResolutionLoader(containingFile, redirectedReference, options, getModuleResolutionHost(resolutionHost), typeReferenceDirectiveResolutionCache),
                getResolutionWithResolvedFileName: getResolvedTypeReferenceDirectiveFromResolution,
                shouldRetryResolution: (resolution)=>resolution.resolvedTypeReferenceDirective === void 0,
                deferWatchingNonRelativeResolution: false
            });
        }
        function resolveModuleNameLiterals(moduleLiterals, containingFile, redirectedReference, options, containingSourceFile, reusedNames) {
            return resolveNamesWithLocalCache({
                entries: moduleLiterals,
                containingFile,
                containingSourceFile,
                redirectedReference,
                options,
                reusedNames,
                perFileCache: resolvedModuleNames,
                loader: createModuleResolutionLoaderUsingGlobalCache(containingFile, redirectedReference, options, resolutionHost, moduleResolutionCache),
                getResolutionWithResolvedFileName: getResolvedModuleFromResolution,
                shouldRetryResolution: (resolution)=>!resolution.resolvedModule || !resolutionExtensionIsTSOrJson(resolution.resolvedModule.extension),
                logChanges: logChangesWhenResolvingModule,
                deferWatchingNonRelativeResolution: true
            });
        }
        function resolveLibrary2(libraryName, resolveFrom, options, libFileName) {
            const host = getModuleResolutionHost(resolutionHost);
            let resolution = resolvedLibraries == null ? void 0 : resolvedLibraries.get(libFileName);
            if (!resolution || resolution.isInvalidated) {
                const existingResolution = resolution;
                resolution = resolveLibrary(libraryName, resolveFrom, options, host, libraryResolutionCache);
                const path = resolutionHost.toPath(resolveFrom);
                watchFailedLookupLocationsOfExternalModuleResolutions(libraryName, resolution, path, getResolvedModuleFromResolution, /*deferWatchingNonRelativeResolution*/ false);
                resolvedLibraries.set(libFileName, resolution);
                if (existingResolution) stopWatchFailedLookupLocationOfResolution(existingResolution, path, getResolvedModuleFromResolution);
            } else if (isTraceEnabled(options, host)) {
                const resolved = getResolvedModuleFromResolution(resolution);
                trace(host, (resolved == null ? void 0 : resolved.resolvedFileName) ? resolved.packageId ? Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2_with_Package_ID_3 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_successfully_resolved_to_2 : Diagnostics.Reusing_resolution_of_module_0_from_1_of_old_program_it_was_not_resolved, libraryName, resolveFrom, resolved == null ? void 0 : resolved.resolvedFileName, (resolved == null ? void 0 : resolved.packageId) && packageIdToString(resolved.packageId));
            }
            return resolution;
        }
        function resolveSingleModuleNameWithoutWatching(moduleName, containingFile) {
            var _a, _b;
            const path = resolutionHost.toPath(containingFile);
            const resolutionsInFile = resolvedModuleNames.get(path);
            const resolution = resolutionsInFile == null ? void 0 : resolutionsInFile.get(moduleName, /*mode*/ void 0);
            if (resolution && !resolution.isInvalidated) return resolution;
            const data = (_a = resolutionHost.beforeResolveSingleModuleNameWithoutWatching) == null ? void 0 : _a.call(resolutionHost, moduleResolutionCache);
            const host = getModuleResolutionHost(resolutionHost);
            const result = resolveModuleName(moduleName, containingFile, resolutionHost.getCompilationSettings(), host, moduleResolutionCache);
            (_b = resolutionHost.afterResolveSingleModuleNameWithoutWatching) == null || _b.call(resolutionHost, moduleResolutionCache, moduleName, containingFile, result, data);
            return result;
        }
        function isNodeModulesAtTypesDirectory(dirPath) {
            return endsWith(dirPath, "/node_modules/@types");
        }
        function watchFailedLookupLocationsOfExternalModuleResolutions(name, resolution, filePath, getResolutionWithResolvedFileName, deferWatchingNonRelativeResolution) {
            var _resolution_files;
            ((_resolution_files = resolution.files) !== null && _resolution_files !== void 0 ? _resolution_files : resolution.files = /* @__PURE__ */ new Set()).add(filePath);
            if (resolution.files.size !== 1) return;
            if (!deferWatchingNonRelativeResolution || isExternalModuleNameRelative(name)) watchFailedLookupLocationOfResolution(resolution);
            else nonRelativeExternalModuleResolutions.add(resolution);
            const resolved = getResolutionWithResolvedFileName(resolution);
            if (resolved && resolved.resolvedFileName) {
                const key = resolutionHost.toPath(resolved.resolvedFileName);
                let resolutions = resolvedFileToResolution.get(key);
                if (!resolutions) resolvedFileToResolution.set(key, resolutions = /* @__PURE__ */ new Set());
                resolutions.add(resolution);
            }
        }
        function watchFailedLookupLocation(failedLookupLocation, setAtRoot) {
            const failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
            const toWatch = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath, rootDir, rootPath, rootPathComponents, isRootWatchable, getCurrentDirectory, resolutionHost.preferNonRecursiveWatch);
            if (toWatch) {
                const { dir, dirPath, nonRecursive, packageDir, packageDirPath } = toWatch;
                if (dirPath === rootPath) {
                    Debug.assert(nonRecursive);
                    Debug.assert(!packageDir);
                    setAtRoot = true;
                } else setDirectoryWatcher(dir, dirPath, packageDir, packageDirPath, nonRecursive);
            }
            return setAtRoot;
        }
        function watchFailedLookupLocationOfResolution(resolution) {
            var _a;
            Debug.assert(!!((_a = resolution.files) == null ? void 0 : _a.size));
            const { failedLookupLocations, affectingLocations, alternateResult } = resolution;
            if (!(failedLookupLocations == null ? void 0 : failedLookupLocations.length) && !(affectingLocations == null ? void 0 : affectingLocations.length) && !alternateResult) return;
            if ((failedLookupLocations == null ? void 0 : failedLookupLocations.length) || alternateResult) resolutionsWithFailedLookups.add(resolution);
            let setAtRoot = false;
            if (failedLookupLocations) for (const failedLookupLocation of failedLookupLocations)setAtRoot = watchFailedLookupLocation(failedLookupLocation, setAtRoot);
            if (alternateResult) setAtRoot = watchFailedLookupLocation(alternateResult, setAtRoot);
            if (setAtRoot) setDirectoryWatcher(rootDir, rootPath, /*packageDir*/ void 0, /*packageDirPath*/ void 0, /*nonRecursive*/ true);
            watchAffectingLocationsOfResolution(resolution, !(failedLookupLocations == null ? void 0 : failedLookupLocations.length) && !alternateResult);
        }
        function watchAffectingLocationsOfResolution(resolution, addToResolutionsWithOnlyAffectingLocations) {
            var _a;
            Debug.assert(!!((_a = resolution.files) == null ? void 0 : _a.size));
            const { affectingLocations } = resolution;
            if (!(affectingLocations == null ? void 0 : affectingLocations.length)) return;
            if (addToResolutionsWithOnlyAffectingLocations) resolutionsWithOnlyAffectingLocations.add(resolution);
            for (const affectingLocation of affectingLocations)createFileWatcherOfAffectingLocation(affectingLocation, /*forResolution*/ true);
        }
        function createFileWatcherOfAffectingLocation(affectingLocation, forResolution) {
            const fileWatcher = fileWatchesOfAffectingLocations.get(affectingLocation);
            if (fileWatcher) {
                if (forResolution) fileWatcher.resolutions++;
                else fileWatcher.files++;
                return;
            }
            let locationToWatch = affectingLocation;
            let isSymlink = false;
            let symlinkWatcher;
            if (resolutionHost.realpath) {
                locationToWatch = resolutionHost.realpath(affectingLocation);
                if (affectingLocation !== locationToWatch) {
                    isSymlink = true;
                    symlinkWatcher = fileWatchesOfAffectingLocations.get(locationToWatch);
                }
            }
            const resolutions = forResolution ? 1 : 0;
            const files = forResolution ? 0 : 1;
            if (!isSymlink || !symlinkWatcher) {
                const watcher = {
                    watcher: canWatchAffectingLocation(resolutionHost.toPath(locationToWatch)) ? resolutionHost.watchAffectingFileLocation(locationToWatch, (fileName, eventKind)=>{
                        cachedDirectoryStructureHost == null || cachedDirectoryStructureHost.addOrDeleteFile(fileName, resolutionHost.toPath(locationToWatch), eventKind);
                        invalidateAffectingFileWatcher(locationToWatch, moduleResolutionCache.getPackageJsonInfoCache().getInternalMap());
                        resolutionHost.scheduleInvalidateResolutionsOfFailedLookupLocations();
                    }) : noopFileWatcher,
                    resolutions: isSymlink ? 0 : resolutions,
                    files: isSymlink ? 0 : files,
                    symlinks: void 0
                };
                fileWatchesOfAffectingLocations.set(locationToWatch, watcher);
                if (isSymlink) symlinkWatcher = watcher;
            }
            if (isSymlink) {
                Debug.assert(!!symlinkWatcher);
                const watcher = {
                    watcher: {
                        close: ()=>{
                            var _a;
                            const symlinkWatcher2 = fileWatchesOfAffectingLocations.get(locationToWatch);
                            if (((_a = symlinkWatcher2 == null ? void 0 : symlinkWatcher2.symlinks) == null ? void 0 : _a.delete(affectingLocation)) && !symlinkWatcher2.symlinks.size && !symlinkWatcher2.resolutions && !symlinkWatcher2.files) {
                                fileWatchesOfAffectingLocations.delete(locationToWatch);
                                symlinkWatcher2.watcher.close();
                            }
                        }
                    },
                    resolutions,
                    files,
                    symlinks: void 0
                };
                fileWatchesOfAffectingLocations.set(affectingLocation, watcher);
                var _symlinkWatcher_symlinks;
                ((_symlinkWatcher_symlinks = symlinkWatcher.symlinks) !== null && _symlinkWatcher_symlinks !== void 0 ? _symlinkWatcher_symlinks : symlinkWatcher.symlinks = /* @__PURE__ */ new Set()).add(affectingLocation);
            }
        }
        function invalidateAffectingFileWatcher(path, packageJsonMap) {
            var _a;
            const watcher = fileWatchesOfAffectingLocations.get(path);
            if (watcher == null ? void 0 : watcher.resolutions) (affectingPathChecks !== null && affectingPathChecks !== void 0 ? affectingPathChecks : affectingPathChecks = /* @__PURE__ */ new Set()).add(path);
            if (watcher == null ? void 0 : watcher.files) (affectingPathChecksForFile !== null && affectingPathChecksForFile !== void 0 ? affectingPathChecksForFile : affectingPathChecksForFile = /* @__PURE__ */ new Set()).add(path);
            (_a = watcher == null ? void 0 : watcher.symlinks) == null || _a.forEach((path2)=>invalidateAffectingFileWatcher(path2, packageJsonMap));
            packageJsonMap == null || packageJsonMap.delete(resolutionHost.toPath(path));
        }
        function watchFailedLookupLocationOfNonRelativeModuleResolutions() {
            nonRelativeExternalModuleResolutions.forEach(watchFailedLookupLocationOfResolution);
            nonRelativeExternalModuleResolutions.clear();
        }
        function createDirectoryWatcherForPackageDir(dir, dirPath, packageDir, packageDirPath, nonRecursive) {
            Debug.assert(!nonRecursive);
            let isSymlink = isSymlinkCache.get(packageDirPath);
            let packageDirWatcher = packageDirWatchers.get(packageDirPath);
            if (isSymlink === void 0) {
                const realPath2 = resolutionHost.realpath(packageDir);
                isSymlink = realPath2 !== packageDir && resolutionHost.toPath(realPath2) !== packageDirPath;
                isSymlinkCache.set(packageDirPath, isSymlink);
                if (!packageDirWatcher) packageDirWatchers.set(packageDirPath, packageDirWatcher = {
                    dirPathToWatcher: /* @__PURE__ */ new Map(),
                    isSymlink
                });
                else if (packageDirWatcher.isSymlink !== isSymlink) {
                    packageDirWatcher.dirPathToWatcher.forEach((watcher)=>{
                        removeDirectoryWatcher(packageDirWatcher.isSymlink ? packageDirPath : dirPath);
                        watcher.watcher = createDirPathToWatcher();
                    });
                    packageDirWatcher.isSymlink = isSymlink;
                }
            } else {
                Debug.assertIsDefined(packageDirWatcher);
                Debug.assert(isSymlink === packageDirWatcher.isSymlink);
            }
            const forDirPath = packageDirWatcher.dirPathToWatcher.get(dirPath);
            if (forDirPath) forDirPath.refCount++;
            else {
                packageDirWatcher.dirPathToWatcher.set(dirPath, {
                    watcher: createDirPathToWatcher(),
                    refCount: 1
                });
                var _dirPathToSymlinkPackageRefCount_get;
                if (isSymlink) dirPathToSymlinkPackageRefCount.set(dirPath, ((_dirPathToSymlinkPackageRefCount_get = dirPathToSymlinkPackageRefCount.get(dirPath)) !== null && _dirPathToSymlinkPackageRefCount_get !== void 0 ? _dirPathToSymlinkPackageRefCount_get : 0) + 1);
            }
            function createDirPathToWatcher() {
                return isSymlink ? createOrAddRefToDirectoryWatchOfFailedLookups(packageDir, packageDirPath, nonRecursive) : createOrAddRefToDirectoryWatchOfFailedLookups(dir, dirPath, nonRecursive);
            }
        }
        function setDirectoryWatcher(dir, dirPath, packageDir, packageDirPath, nonRecursive) {
            if (!packageDirPath || !resolutionHost.realpath) createOrAddRefToDirectoryWatchOfFailedLookups(dir, dirPath, nonRecursive);
            else createDirectoryWatcherForPackageDir(dir, dirPath, packageDir, packageDirPath, nonRecursive);
        }
        function createOrAddRefToDirectoryWatchOfFailedLookups(dir, dirPath, nonRecursive) {
            let dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
            if (dirWatcher) {
                Debug.assert(!!nonRecursive === !!dirWatcher.nonRecursive);
                dirWatcher.refCount++;
            } else directoryWatchesOfFailedLookups.set(dirPath, dirWatcher = {
                watcher: createDirectoryWatcher(dir, dirPath, nonRecursive),
                refCount: 1,
                nonRecursive
            });
            return dirWatcher;
        }
        function stopWatchFailedLookupLocation(failedLookupLocation, removeAtRoot) {
            const failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
            const toWatch = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath, rootDir, rootPath, rootPathComponents, isRootWatchable, getCurrentDirectory, resolutionHost.preferNonRecursiveWatch);
            if (toWatch) {
                const { dirPath, packageDirPath } = toWatch;
                if (dirPath === rootPath) removeAtRoot = true;
                else if (packageDirPath && resolutionHost.realpath) {
                    const packageDirWatcher = packageDirWatchers.get(packageDirPath);
                    const forDirPath = packageDirWatcher.dirPathToWatcher.get(dirPath);
                    forDirPath.refCount--;
                    if (forDirPath.refCount === 0) {
                        removeDirectoryWatcher(packageDirWatcher.isSymlink ? packageDirPath : dirPath);
                        packageDirWatcher.dirPathToWatcher.delete(dirPath);
                        if (packageDirWatcher.isSymlink) {
                            const refCount = dirPathToSymlinkPackageRefCount.get(dirPath) - 1;
                            if (refCount === 0) dirPathToSymlinkPackageRefCount.delete(dirPath);
                            else dirPathToSymlinkPackageRefCount.set(dirPath, refCount);
                        }
                    }
                } else removeDirectoryWatcher(dirPath);
            }
            return removeAtRoot;
        }
        function stopWatchFailedLookupLocationOfResolution(resolution, filePath, getResolutionWithResolvedFileName) {
            Debug.checkDefined(resolution.files).delete(filePath);
            if (resolution.files.size) return;
            resolution.files = void 0;
            const resolved = getResolutionWithResolvedFileName(resolution);
            if (resolved && resolved.resolvedFileName) {
                const key = resolutionHost.toPath(resolved.resolvedFileName);
                const resolutions = resolvedFileToResolution.get(key);
                if ((resolutions == null ? void 0 : resolutions.delete(resolution)) && !resolutions.size) resolvedFileToResolution.delete(key);
            }
            const { failedLookupLocations, affectingLocations, alternateResult } = resolution;
            if (resolutionsWithFailedLookups.delete(resolution)) {
                let removeAtRoot = false;
                if (failedLookupLocations) for (const failedLookupLocation of failedLookupLocations)removeAtRoot = stopWatchFailedLookupLocation(failedLookupLocation, removeAtRoot);
                if (alternateResult) removeAtRoot = stopWatchFailedLookupLocation(alternateResult, removeAtRoot);
                if (removeAtRoot) removeDirectoryWatcher(rootPath);
            } else if (affectingLocations == null ? void 0 : affectingLocations.length) resolutionsWithOnlyAffectingLocations.delete(resolution);
            if (affectingLocations) for (const affectingLocation of affectingLocations){
                const watcher = fileWatchesOfAffectingLocations.get(affectingLocation);
                watcher.resolutions--;
            }
        }
        function removeDirectoryWatcher(dirPath) {
            const dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
            dirWatcher.refCount--;
        }
        function createDirectoryWatcher(directory, dirPath, nonRecursive) {
            return resolutionHost.watchDirectoryOfFailedLookupLocation(directory, (fileOrDirectory)=>{
                const fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
                if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                scheduleInvalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath);
            }, nonRecursive ? 0 /* None */  : 1 /* Recursive */ );
        }
        function removeResolutionsOfFileFromCache(cache, filePath, getResolutionWithResolvedFileName) {
            const resolutions = cache.get(filePath);
            if (resolutions) {
                resolutions.forEach((resolution)=>stopWatchFailedLookupLocationOfResolution(resolution, filePath, getResolutionWithResolvedFileName));
                cache.delete(filePath);
            }
        }
        function removeResolutionsFromProjectReferenceRedirects(filePath) {
            if (!fileExtensionIs(filePath, ".json" /* Json */ )) return;
            const program = resolutionHost.getCurrentProgram();
            if (!program) return;
            const resolvedProjectReference = program.getResolvedProjectReferenceByPath(filePath);
            if (!resolvedProjectReference) return;
            resolvedProjectReference.commandLine.fileNames.forEach((f)=>removeResolutionsOfFile(resolutionHost.toPath(f)));
        }
        function removeResolutionsOfFile(filePath) {
            removeResolutionsOfFileFromCache(resolvedModuleNames, filePath, getResolvedModuleFromResolution);
            removeResolutionsOfFileFromCache(resolvedTypeReferenceDirectives, filePath, getResolvedTypeReferenceDirectiveFromResolution);
        }
        function invalidateResolutions(resolutions, canInvalidate) {
            if (!resolutions) return false;
            let invalidated = false;
            resolutions.forEach((resolution)=>{
                if (resolution.isInvalidated || !canInvalidate(resolution)) return;
                resolution.isInvalidated = invalidated = true;
                for (const containingFilePath of Debug.checkDefined(resolution.files)){
                    (filesWithInvalidatedResolutions !== null && filesWithInvalidatedResolutions !== void 0 ? filesWithInvalidatedResolutions : filesWithInvalidatedResolutions = /* @__PURE__ */ new Set()).add(containingFilePath);
                    hasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames || endsWith(containingFilePath, inferredTypesContainingFile);
                }
            });
            return invalidated;
        }
        function invalidateResolutionOfFile(filePath) {
            removeResolutionsOfFile(filePath);
            const prevHasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames;
            if (invalidateResolutions(resolvedFileToResolution.get(filePath), returnTrue) && hasChangedAutomaticTypeDirectiveNames && !prevHasChangedAutomaticTypeDirectiveNames) resolutionHost.onChangedAutomaticTypeDirectiveNames();
        }
        function setFilesWithInvalidatedNonRelativeUnresolvedImports(filesMap) {
            Debug.assert(filesWithInvalidatedNonRelativeUnresolvedImports === filesMap || filesWithInvalidatedNonRelativeUnresolvedImports === void 0);
            filesWithInvalidatedNonRelativeUnresolvedImports = filesMap;
        }
        function scheduleInvalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, isCreatingWatchedDirectory) {
            if (isCreatingWatchedDirectory) (isInDirectoryChecks || (isInDirectoryChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
            else {
                const updatedPath = removeIgnoredPath(fileOrDirectoryPath);
                if (!updatedPath) return false;
                fileOrDirectoryPath = updatedPath;
                if (resolutionHost.fileIsOpen(fileOrDirectoryPath)) return false;
                const dirOfFileOrDirectory = getDirectoryPath(fileOrDirectoryPath);
                if (isNodeModulesAtTypesDirectory(fileOrDirectoryPath) || isNodeModulesDirectory(fileOrDirectoryPath) || isNodeModulesAtTypesDirectory(dirOfFileOrDirectory) || isNodeModulesDirectory(dirOfFileOrDirectory)) {
                    (failedLookupChecks || (failedLookupChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                    (startsWithPathChecks || (startsWithPathChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                } else {
                    if (isEmittedFileOfProgram(resolutionHost.getCurrentProgram(), fileOrDirectoryPath)) return false;
                    if (fileExtensionIs(fileOrDirectoryPath, ".map")) return false;
                    (failedLookupChecks || (failedLookupChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                    (startsWithPathChecks || (startsWithPathChecks = /* @__PURE__ */ new Set())).add(fileOrDirectoryPath);
                    const packagePath = parseNodeModuleFromPath(fileOrDirectoryPath, /*isFolder*/ true);
                    if (packagePath) (startsWithPathChecks || (startsWithPathChecks = /* @__PURE__ */ new Set())).add(packagePath);
                }
            }
            resolutionHost.scheduleInvalidateResolutionsOfFailedLookupLocations();
        }
        function invalidatePackageJsonMap() {
            const packageJsonMap = moduleResolutionCache.getPackageJsonInfoCache().getInternalMap();
            if (packageJsonMap && (failedLookupChecks || startsWithPathChecks || isInDirectoryChecks)) packageJsonMap.forEach((_value, path)=>isInvalidatedFailedLookup(path) ? packageJsonMap.delete(path) : void 0);
        }
        function invalidateResolutionsOfFailedLookupLocations() {
            var _a;
            if (allModuleAndTypeResolutionsAreInvalidated) {
                affectingPathChecksForFile = void 0;
                invalidatePackageJsonMap();
                if (failedLookupChecks || startsWithPathChecks || isInDirectoryChecks || affectingPathChecks) invalidateResolutions(resolvedLibraries, canInvalidateFailedLookupResolution);
                failedLookupChecks = void 0;
                startsWithPathChecks = void 0;
                isInDirectoryChecks = void 0;
                affectingPathChecks = void 0;
                return true;
            }
            let invalidated = false;
            if (affectingPathChecksForFile) {
                (_a = resolutionHost.getCurrentProgram()) == null || _a.getSourceFiles().forEach((f)=>{
                    if (some(f.packageJsonLocations, (location)=>affectingPathChecksForFile.has(location))) {
                        (filesWithInvalidatedResolutions !== null && filesWithInvalidatedResolutions !== void 0 ? filesWithInvalidatedResolutions : filesWithInvalidatedResolutions = /* @__PURE__ */ new Set()).add(f.path);
                        invalidated = true;
                    }
                });
                affectingPathChecksForFile = void 0;
            }
            if (!failedLookupChecks && !startsWithPathChecks && !isInDirectoryChecks && !affectingPathChecks) return invalidated;
            invalidated = invalidateResolutions(resolutionsWithFailedLookups, canInvalidateFailedLookupResolution) || invalidated;
            invalidatePackageJsonMap();
            failedLookupChecks = void 0;
            startsWithPathChecks = void 0;
            isInDirectoryChecks = void 0;
            invalidated = invalidateResolutions(resolutionsWithOnlyAffectingLocations, canInvalidatedFailedLookupResolutionWithAffectingLocation) || invalidated;
            affectingPathChecks = void 0;
            return invalidated;
        }
        function canInvalidateFailedLookupResolution(resolution) {
            var _a;
            if (canInvalidatedFailedLookupResolutionWithAffectingLocation(resolution)) return true;
            if (!failedLookupChecks && !startsWithPathChecks && !isInDirectoryChecks) return false;
            return ((_a = resolution.failedLookupLocations) == null ? void 0 : _a.some((location)=>isInvalidatedFailedLookup(resolutionHost.toPath(location)))) || !!resolution.alternateResult && isInvalidatedFailedLookup(resolutionHost.toPath(resolution.alternateResult));
        }
        function isInvalidatedFailedLookup(locationPath) {
            return (failedLookupChecks == null ? void 0 : failedLookupChecks.has(locationPath)) || firstDefinedIterator((startsWithPathChecks == null ? void 0 : startsWithPathChecks.keys()) || [], (fileOrDirectoryPath)=>startsWith(locationPath, fileOrDirectoryPath) ? true : void 0) || firstDefinedIterator((isInDirectoryChecks == null ? void 0 : isInDirectoryChecks.keys()) || [], (dirPath)=>locationPath.length > dirPath.length && startsWith(locationPath, dirPath) && (isDiskPathRoot(dirPath) || locationPath[dirPath.length] === directorySeparator) ? true : void 0);
        }
        function canInvalidatedFailedLookupResolutionWithAffectingLocation(resolution) {
            var _a;
            return !!affectingPathChecks && ((_a = resolution.affectingLocations) == null ? void 0 : _a.some((location)=>affectingPathChecks.has(location)));
        }
        function closeTypeRootsWatch() {
            clearMap(typeRootsWatches, closeFileWatcher);
        }
        function createTypeRootsWatch(typeRoot) {
            return canWatchTypeRootPath(typeRoot) ? resolutionHost.watchTypeRootsDirectory(typeRoot, (fileOrDirectory)=>{
                const fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
                if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                hasChangedAutomaticTypeDirectiveNames = true;
                resolutionHost.onChangedAutomaticTypeDirectiveNames();
                const dirPath = getDirectoryToWatchFailedLookupLocationFromTypeRoot(typeRoot, resolutionHost.toPath(typeRoot), rootPath, rootPathComponents, isRootWatchable, getCurrentDirectory, resolutionHost.preferNonRecursiveWatch, (dirPath2)=>directoryWatchesOfFailedLookups.has(dirPath2) || dirPathToSymlinkPackageRefCount.has(dirPath2));
                if (dirPath) scheduleInvalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath);
            }, 1 /* Recursive */ ) : noopFileWatcher;
        }
        function updateTypeRootsWatch() {
            const options = resolutionHost.getCompilationSettings();
            if (options.types) {
                closeTypeRootsWatch();
                return;
            }
            const typeRoots = getEffectiveTypeRoots(options, {
                getCurrentDirectory
            });
            if (typeRoots) mutateMap(typeRootsWatches, new Set(typeRoots), {
                createNewValue: createTypeRootsWatch,
                onDeleteValue: closeFileWatcher
            });
            else closeTypeRootsWatch();
        }
        function canWatchTypeRootPath(typeRoot) {
            if (resolutionHost.getCompilationSettings().typeRoots) return true;
            return canWatchAtTypes(resolutionHost.toPath(typeRoot));
        }
    }
    function resolutionIsSymlink(resolution) {
        var _a, _b;
        return !!(((_a = resolution.resolvedModule) == null ? void 0 : _a.originalPath) || ((_b = resolution.resolvedTypeReferenceDirective) == null ? void 0 : _b.originalPath));
    }
    // src/compiler/watch.ts
    var sysFormatDiagnosticsHost = sys ? {
        getCurrentDirectory: ()=>sys.getCurrentDirectory(),
        getNewLine: ()=>sys.newLine,
        getCanonicalFileName: createGetCanonicalFileName(sys.useCaseSensitiveFileNames)
    } : void 0;
    function createDiagnosticReporter(system, pretty) {
        const host = system === sys && sysFormatDiagnosticsHost ? sysFormatDiagnosticsHost : {
            getCurrentDirectory: ()=>system.getCurrentDirectory(),
            getNewLine: ()=>system.newLine,
            getCanonicalFileName: createGetCanonicalFileName(system.useCaseSensitiveFileNames)
        };
        if (!pretty) return (diagnostic)=>system.write(formatDiagnostic(diagnostic, host));
        const diagnostics = new Array(1);
        return (diagnostic)=>{
            diagnostics[0] = diagnostic;
            system.write(formatDiagnosticsWithColorAndContext(diagnostics, host) + host.getNewLine());
            diagnostics[0] = void 0;
        };
    }
    function clearScreenIfNotWatchingForFileChanges(system, diagnostic, options) {
        if (system.clearScreen && !options.preserveWatchOutput && !options.extendedDiagnostics && !options.diagnostics && contains(screenStartingMessageCodes, diagnostic.code)) {
            system.clearScreen();
            return true;
        }
        return false;
    }
    var screenStartingMessageCodes = [
        Diagnostics.Starting_compilation_in_watch_mode.code,
        Diagnostics.File_change_detected_Starting_incremental_compilation.code
    ];
    function getPlainDiagnosticFollowingNewLines(diagnostic, newLine) {
        return contains(screenStartingMessageCodes, diagnostic.code) ? newLine + newLine : newLine;
    }
    function getLocaleTimeString(system) {
        return !system.now ? /* @__PURE__ */ new Date().toLocaleTimeString() : // On some systems / builds of Node, there's a non-breaking space between the time and AM/PM.
        // This branch is solely for testing, so just switch it to a normal space for baseline stability.
        // See:
        //     - https://github.com/nodejs/node/issues/45171
        //     - https://github.com/nodejs/node/issues/45753
        system.now().toLocaleTimeString("en-US", {
            timeZone: "UTC"
        }).replace("\u202F", " ");
    }
    function createWatchStatusReporter(system, pretty) {
        return pretty ? (diagnostic, newLine, options)=>{
            clearScreenIfNotWatchingForFileChanges(system, diagnostic, options);
            let output = `[${formatColorAndReset(getLocaleTimeString(system), "\x1B[90m" /* Grey */ )}] `;
            output += `${flattenDiagnosticMessageText(diagnostic.messageText, system.newLine)}${newLine + newLine}`;
            system.write(output);
        } : (diagnostic, newLine, options)=>{
            let output = "";
            if (!clearScreenIfNotWatchingForFileChanges(system, diagnostic, options)) output += newLine;
            output += `${getLocaleTimeString(system)} - `;
            output += `${flattenDiagnosticMessageText(diagnostic.messageText, system.newLine)}${getPlainDiagnosticFollowingNewLines(diagnostic, newLine)}`;
            system.write(output);
        };
    }
    function parseConfigFileWithSystem(configFileName, optionsToExtend, extendedConfigCache, watchOptionsToExtend, system, reportDiagnostic) {
        const host = system;
        host.onUnRecoverableConfigFileDiagnostic = (diagnostic)=>reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic);
        const result = getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host, extendedConfigCache, watchOptionsToExtend);
        host.onUnRecoverableConfigFileDiagnostic = void 0;
        return result;
    }
    function getErrorCountForSummary(diagnostics) {
        return countWhere(diagnostics, (diagnostic)=>diagnostic.category === 1 /* Error */ );
    }
    function getFilesInErrorForSummary(diagnostics) {
        const filesInError = filter(diagnostics, (diagnostic)=>diagnostic.category === 1 /* Error */ ).map((errorDiagnostic)=>{
            if (errorDiagnostic.file === void 0) return;
            return `${errorDiagnostic.file.fileName}`;
        });
        return filesInError.map((fileName)=>{
            if (fileName === void 0) return void 0;
            const diagnosticForFileName = find(diagnostics, (diagnostic)=>diagnostic.file !== void 0 && diagnostic.file.fileName === fileName);
            if (diagnosticForFileName !== void 0) {
                const { line } = getLineAndCharacterOfPosition(diagnosticForFileName.file, diagnosticForFileName.start);
                return {
                    fileName,
                    line: line + 1
                };
            }
        });
    }
    function getWatchErrorSummaryDiagnosticMessage(errorCount) {
        return errorCount === 1 ? Diagnostics.Found_1_error_Watching_for_file_changes : Diagnostics.Found_0_errors_Watching_for_file_changes;
    }
    function prettyPathForFileError(error2, cwd) {
        const line = formatColorAndReset(":" + error2.line, "\x1B[90m" /* Grey */ );
        if (pathIsAbsolute(error2.fileName) && pathIsAbsolute(cwd)) return getRelativePathFromDirectory(cwd, error2.fileName, /*ignoreCase*/ false) + line;
        return error2.fileName + line;
    }
    function getErrorSummaryText(errorCount, filesInError, newLine, host) {
        if (errorCount === 0) return "";
        const nonNilFiles = filesInError.filter((fileInError)=>fileInError !== void 0);
        const distinctFileNamesWithLines = nonNilFiles.map((fileInError)=>`${fileInError.fileName}:${fileInError.line}`).filter((value1, index, self)=>self.indexOf(value1) === index);
        const firstFileReference = nonNilFiles[0] && prettyPathForFileError(nonNilFiles[0], host.getCurrentDirectory());
        let messageAndArgs;
        if (errorCount === 1) messageAndArgs = filesInError[0] !== void 0 ? [
            Diagnostics.Found_1_error_in_0,
            firstFileReference
        ] : [
            Diagnostics.Found_1_error
        ];
        else messageAndArgs = distinctFileNamesWithLines.length === 0 ? [
            Diagnostics.Found_0_errors,
            errorCount
        ] : distinctFileNamesWithLines.length === 1 ? [
            Diagnostics.Found_0_errors_in_the_same_file_starting_at_Colon_1,
            errorCount,
            firstFileReference
        ] : [
            Diagnostics.Found_0_errors_in_1_files,
            errorCount,
            distinctFileNamesWithLines.length
        ];
        const d = createCompilerDiagnostic(...messageAndArgs);
        const suffix = distinctFileNamesWithLines.length > 1 ? createTabularErrorsDisplay(nonNilFiles, host) : "";
        return `${newLine}${flattenDiagnosticMessageText(d.messageText, newLine)}${newLine}${newLine}${suffix}`;
    }
    function createTabularErrorsDisplay(filesInError, host) {
        const distinctFiles = filesInError.filter((value1, index, self)=>index === self.findIndex((file)=>(file == null ? void 0 : file.fileName) === (value1 == null ? void 0 : value1.fileName)));
        if (distinctFiles.length === 0) return "";
        const numberLength = (num)=>Math.log(num) * Math.LOG10E + 1;
        const fileToErrorCount = distinctFiles.map((file)=>[
                file,
                countWhere(filesInError, (fileInError)=>fileInError.fileName === file.fileName)
            ]);
        const maxErrors = maxBy(fileToErrorCount, 0, (value1)=>value1[1]);
        const headerRow = Diagnostics.Errors_Files.message;
        const leftColumnHeadingLength = headerRow.split(" ")[0].length;
        const leftPaddingGoal = Math.max(leftColumnHeadingLength, numberLength(maxErrors));
        const headerPadding = Math.max(numberLength(maxErrors) - leftColumnHeadingLength, 0);
        let tabularData = "";
        tabularData += " ".repeat(headerPadding) + headerRow + "\n";
        fileToErrorCount.forEach((row)=>{
            const [file, errorCount] = row;
            const errorCountDigitsLength = Math.log(errorCount) * Math.LOG10E + 1 | 0;
            const leftPadding = errorCountDigitsLength < leftPaddingGoal ? " ".repeat(leftPaddingGoal - errorCountDigitsLength) : "";
            const fileRef = prettyPathForFileError(file, host.getCurrentDirectory());
            tabularData += `${leftPadding}${errorCount}  ${fileRef}
`;
        });
        return tabularData;
    }
    function isBuilderProgram(program) {
        return !!program.state;
    }
    function listFiles(program, write) {
        const options = program.getCompilerOptions();
        if (options.explainFiles) explainFiles(isBuilderProgram(program) ? program.getProgram() : program, write);
        else if (options.listFiles || options.listFilesOnly) forEach(program.getSourceFiles(), (file)=>{
            write(file.fileName);
        });
    }
    function explainFiles(program, write) {
        var _a, _b;
        const reasons = program.getFileIncludeReasons();
        const relativeFileName = (fileName)=>convertToRelativePath(fileName, program.getCurrentDirectory(), program.getCanonicalFileName);
        for (const file of program.getSourceFiles()){
            write(`${toFileName(file, relativeFileName)}`);
            (_a = reasons.get(file.path)) == null || _a.forEach((reason)=>write(`  ${fileIncludeReasonToDiagnostics(program, reason, relativeFileName).messageText}`));
            (_b = explainIfFileIsRedirectAndImpliedFormat(file, program.getCompilerOptionsForFile(file), relativeFileName)) == null || _b.forEach((d)=>write(`  ${d.messageText}`));
        }
    }
    function explainIfFileIsRedirectAndImpliedFormat(file, options, fileNameConvertor) {
        var _a;
        let result;
        if (file.path !== file.resolvedPath) (result !== null && result !== void 0 ? result : result = []).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_is_output_of_project_reference_source_0, toFileName(file.originalFileName, fileNameConvertor)));
        if (file.redirectInfo) (result !== null && result !== void 0 ? result : result = []).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_redirects_to_file_0, toFileName(file.redirectInfo.redirectTarget, fileNameConvertor)));
        if (isExternalOrCommonJsModule(file)) switch(getImpliedNodeFormatForEmitWorker(file, options)){
            case 99 /* ESNext */ :
                if (file.packageJsonScope) (result !== null && result !== void 0 ? result : result = []).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_is_ECMAScript_module_because_0_has_field_type_with_value_module, toFileName(last(file.packageJsonLocations), fileNameConvertor)));
                break;
            case 1 /* CommonJS */ :
                if (file.packageJsonScope) (result !== null && result !== void 0 ? result : result = []).push(chainDiagnosticMessages(/*details*/ void 0, file.packageJsonScope.contents.packageJsonContent.type ? Diagnostics.File_is_CommonJS_module_because_0_has_field_type_whose_value_is_not_module : Diagnostics.File_is_CommonJS_module_because_0_does_not_have_field_type, toFileName(last(file.packageJsonLocations), fileNameConvertor)));
                else if ((_a = file.packageJsonLocations) == null ? void 0 : _a.length) (result !== null && result !== void 0 ? result : result = []).push(chainDiagnosticMessages(/*details*/ void 0, Diagnostics.File_is_CommonJS_module_because_package_json_was_not_found));
                break;
        }
        return result;
    }
    function getMatchedFileSpec(program, fileName) {
        var _a;
        const configFile = program.getCompilerOptions().configFile;
        if (!((_a = configFile == null ? void 0 : configFile.configFileSpecs) == null ? void 0 : _a.validatedFilesSpec)) return void 0;
        const filePath = program.getCanonicalFileName(fileName);
        const basePath = getDirectoryPath(getNormalizedAbsolutePath(configFile.fileName, program.getCurrentDirectory()));
        const index = findIndex(configFile.configFileSpecs.validatedFilesSpec, (fileSpec)=>program.getCanonicalFileName(getNormalizedAbsolutePath(fileSpec, basePath)) === filePath);
        return index !== -1 ? configFile.configFileSpecs.validatedFilesSpecBeforeSubstitution[index] : void 0;
    }
    function getMatchedIncludeSpec(program, fileName) {
        var _a, _b;
        const configFile = program.getCompilerOptions().configFile;
        if (!((_a = configFile == null ? void 0 : configFile.configFileSpecs) == null ? void 0 : _a.validatedIncludeSpecs)) return void 0;
        if (configFile.configFileSpecs.isDefaultIncludeSpec) return true;
        const isJsonFile = fileExtensionIs(fileName, ".json" /* Json */ );
        const basePath = getDirectoryPath(getNormalizedAbsolutePath(configFile.fileName, program.getCurrentDirectory()));
        const useCaseSensitiveFileNames2 = program.useCaseSensitiveFileNames();
        const index = findIndex((_b = configFile == null ? void 0 : configFile.configFileSpecs) == null ? void 0 : _b.validatedIncludeSpecs, (includeSpec)=>{
            if (isJsonFile && !endsWith(includeSpec, ".json" /* Json */ )) return false;
            const pattern = getPatternFromSpec(includeSpec, basePath, "files");
            return !!pattern && getRegexFromPattern(`(?:${pattern})$`, useCaseSensitiveFileNames2).test(fileName);
        });
        return index !== -1 ? configFile.configFileSpecs.validatedIncludeSpecsBeforeSubstitution[index] : void 0;
    }
    function fileIncludeReasonToDiagnostics(program, reason, fileNameConvertor) {
        var _a, _b;
        const options = program.getCompilerOptions();
        if (isReferencedFile(reason)) {
            const referenceLocation = getReferencedFileLocation(program, reason);
            const referenceText = isReferenceFileLocation(referenceLocation) ? referenceLocation.file.text.substring(referenceLocation.pos, referenceLocation.end) : `"${referenceLocation.text}"`;
            let message;
            Debug.assert(isReferenceFileLocation(referenceLocation) || reason.kind === 3 /* Import */ , "Only synthetic references are imports");
            switch(reason.kind){
                case 3 /* Import */ :
                    if (isReferenceFileLocation(referenceLocation)) message = referenceLocation.packageId ? Diagnostics.Imported_via_0_from_file_1_with_packageId_2 : Diagnostics.Imported_via_0_from_file_1;
                    else if (referenceLocation.text === externalHelpersModuleNameText) message = referenceLocation.packageId ? Diagnostics.Imported_via_0_from_file_1_with_packageId_2_to_import_importHelpers_as_specified_in_compilerOptions : Diagnostics.Imported_via_0_from_file_1_to_import_importHelpers_as_specified_in_compilerOptions;
                    else message = referenceLocation.packageId ? Diagnostics.Imported_via_0_from_file_1_with_packageId_2_to_import_jsx_and_jsxs_factory_functions : Diagnostics.Imported_via_0_from_file_1_to_import_jsx_and_jsxs_factory_functions;
                    break;
                case 4 /* ReferenceFile */ :
                    Debug.assert(!referenceLocation.packageId);
                    message = Diagnostics.Referenced_via_0_from_file_1;
                    break;
                case 5 /* TypeReferenceDirective */ :
                    message = referenceLocation.packageId ? Diagnostics.Type_library_referenced_via_0_from_file_1_with_packageId_2 : Diagnostics.Type_library_referenced_via_0_from_file_1;
                    break;
                case 7 /* LibReferenceDirective */ :
                    Debug.assert(!referenceLocation.packageId);
                    message = Diagnostics.Library_referenced_via_0_from_file_1;
                    break;
                default:
                    Debug.assertNever(reason);
            }
            return chainDiagnosticMessages(/*details*/ void 0, message, referenceText, toFileName(referenceLocation.file, fileNameConvertor), referenceLocation.packageId && packageIdToString(referenceLocation.packageId));
        }
        switch(reason.kind){
            case 0 /* RootFile */ :
                if (!((_a = options.configFile) == null ? void 0 : _a.configFileSpecs)) return chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Root_file_specified_for_compilation);
                const fileName = getNormalizedAbsolutePath(program.getRootFileNames()[reason.index], program.getCurrentDirectory());
                const matchedByFiles = getMatchedFileSpec(program, fileName);
                if (matchedByFiles) return chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Part_of_files_list_in_tsconfig_json);
                const matchedByInclude = getMatchedIncludeSpec(program, fileName);
                return isString(matchedByInclude) ? chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Matched_by_include_pattern_0_in_1, matchedByInclude, toFileName(options.configFile, fileNameConvertor)) : // Could be additional files specified as roots or matched by default include
                chainDiagnosticMessages(/*details*/ void 0, matchedByInclude ? Diagnostics.Matched_by_default_include_pattern_Asterisk_Asterisk_Slash_Asterisk : Diagnostics.Root_file_specified_for_compilation);
            case 1 /* SourceFromProjectReference */ :
            case 2 /* OutputFromProjectReference */ :
                const isOutput = reason.kind === 2 /* OutputFromProjectReference */ ;
                const referencedResolvedRef = Debug.checkDefined((_b = program.getResolvedProjectReferences()) == null ? void 0 : _b[reason.index]);
                return chainDiagnosticMessages(/*details*/ void 0, options.outFile ? isOutput ? Diagnostics.Output_from_referenced_project_0_included_because_1_specified : Diagnostics.Source_from_referenced_project_0_included_because_1_specified : isOutput ? Diagnostics.Output_from_referenced_project_0_included_because_module_is_specified_as_none : Diagnostics.Source_from_referenced_project_0_included_because_module_is_specified_as_none, toFileName(referencedResolvedRef.sourceFile.fileName, fileNameConvertor), options.outFile ? "--outFile" : "--out");
            case 8 /* AutomaticTypeDirectiveFile */ :
                {
                    const messageAndArgs = options.types ? reason.packageId ? [
                        Diagnostics.Entry_point_of_type_library_0_specified_in_compilerOptions_with_packageId_1,
                        reason.typeReference,
                        packageIdToString(reason.packageId)
                    ] : [
                        Diagnostics.Entry_point_of_type_library_0_specified_in_compilerOptions,
                        reason.typeReference
                    ] : reason.packageId ? [
                        Diagnostics.Entry_point_for_implicit_type_library_0_with_packageId_1,
                        reason.typeReference,
                        packageIdToString(reason.packageId)
                    ] : [
                        Diagnostics.Entry_point_for_implicit_type_library_0,
                        reason.typeReference
                    ];
                    return chainDiagnosticMessages(/*details*/ void 0, ...messageAndArgs);
                }
            case 6 /* LibFile */ :
                {
                    if (reason.index !== void 0) return chainDiagnosticMessages(/*details*/ void 0, Diagnostics.Library_0_specified_in_compilerOptions, options.lib[reason.index]);
                    const target = getNameOfScriptTarget(getEmitScriptTarget(options));
                    const messageAndArgs = target ? [
                        Diagnostics.Default_library_for_target_0,
                        target
                    ] : [
                        Diagnostics.Default_library
                    ];
                    return chainDiagnosticMessages(/*details*/ void 0, ...messageAndArgs);
                }
            default:
                Debug.assertNever(reason);
        }
    }
    function toFileName(file, fileNameConvertor) {
        const fileName = isString(file) ? file : file.fileName;
        return fileNameConvertor ? fileNameConvertor(fileName) : fileName;
    }
    function emitFilesAndReportErrors(program, reportDiagnostic, write, reportSummary, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
        const options = program.getCompilerOptions();
        const allDiagnostics = program.getConfigFileParsingDiagnostics().slice();
        const configFileParsingDiagnosticsLength = allDiagnostics.length;
        addRange(allDiagnostics, program.getSyntacticDiagnostics(/*sourceFile*/ void 0, cancellationToken));
        if (allDiagnostics.length === configFileParsingDiagnosticsLength) {
            addRange(allDiagnostics, program.getOptionsDiagnostics(cancellationToken));
            if (!options.listFilesOnly) {
                addRange(allDiagnostics, program.getGlobalDiagnostics(cancellationToken));
                if (allDiagnostics.length === configFileParsingDiagnosticsLength) addRange(allDiagnostics, program.getSemanticDiagnostics(/*sourceFile*/ void 0, cancellationToken));
                if (options.noEmit && getEmitDeclarations(options) && allDiagnostics.length === configFileParsingDiagnosticsLength) addRange(allDiagnostics, program.getDeclarationDiagnostics(/*sourceFile*/ void 0, cancellationToken));
            }
        }
        const emitResult = options.listFilesOnly ? {
            emitSkipped: true,
            diagnostics: emptyArray
        } : program.emit(/*targetSourceFile*/ void 0, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers);
        addRange(allDiagnostics, emitResult.diagnostics);
        const diagnostics = sortAndDeduplicateDiagnostics(allDiagnostics);
        diagnostics.forEach(reportDiagnostic);
        if (write) {
            const currentDir = program.getCurrentDirectory();
            forEach(emitResult.emittedFiles, (file)=>{
                const filepath = getNormalizedAbsolutePath(file, currentDir);
                write(`TSFILE: ${filepath}`);
            });
            listFiles(program, write);
        }
        if (reportSummary) reportSummary(getErrorCountForSummary(diagnostics), getFilesInErrorForSummary(diagnostics));
        return {
            emitResult,
            diagnostics
        };
    }
    function emitFilesAndReportErrorsAndGetExitStatus(program, reportDiagnostic, write, reportSummary, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers) {
        const { emitResult, diagnostics } = emitFilesAndReportErrors(program, reportDiagnostic, write, reportSummary, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers);
        if (emitResult.emitSkipped && diagnostics.length > 0) return 1 /* DiagnosticsPresent_OutputsSkipped */ ;
        else if (diagnostics.length > 0) return 2 /* DiagnosticsPresent_OutputsGenerated */ ;
        return 0 /* Success */ ;
    }
    var noopFileWatcher = {
        close: noop
    };
    var returnNoopFileWatcher = ()=>noopFileWatcher;
    function createWatchHost(system = sys, reportWatchStatus2) {
        const onWatchStatusChange = reportWatchStatus2 || createWatchStatusReporter(system);
        return {
            onWatchStatusChange,
            watchFile: maybeBind(system, system.watchFile) || returnNoopFileWatcher,
            watchDirectory: maybeBind(system, system.watchDirectory) || returnNoopFileWatcher,
            setTimeout: maybeBind(system, system.setTimeout) || noop,
            clearTimeout: maybeBind(system, system.clearTimeout) || noop,
            preferNonRecursiveWatch: system.preferNonRecursiveWatch
        };
    }
    var WatchType = {
        ConfigFile: "Config file",
        ExtendedConfigFile: "Extended config file",
        SourceFile: "Source file",
        MissingFile: "Missing file",
        WildcardDirectory: "Wild card directory",
        FailedLookupLocations: "Failed Lookup Locations",
        AffectingFileLocation: "File location affecting resolution",
        TypeRoots: "Type roots",
        ConfigFileOfReferencedProject: "Config file of referened project",
        ExtendedConfigOfReferencedProject: "Extended config file of referenced project",
        WildcardDirectoryOfReferencedProject: "Wild card directory of referenced project",
        PackageJson: "package.json file",
        ClosedScriptInfo: "Closed Script info",
        ConfigFileForInferredRoot: "Config file for the inferred project root",
        NodeModules: "node_modules for closed script infos and package.jsons affecting module specifier cache",
        MissingSourceMapFile: "Missing source map file",
        NoopConfigFileForInferredRoot: "Noop Config file for the inferred project root",
        MissingGeneratedFile: "Missing generated file",
        NodeModulesForModuleSpecifierCache: "node_modules for module specifier cache invalidation",
        TypingInstallerLocationFile: "File location for typing installer",
        TypingInstallerLocationDirectory: "Directory location for typing installer"
    };
    function createWatchFactory(host, options) {
        const watchLogLevel = host.trace ? options.extendedDiagnostics ? 2 /* Verbose */  : options.diagnostics ? 1 /* TriggerOnly */  : 0 /* None */  : 0 /* None */ ;
        const writeLog = watchLogLevel !== 0 /* None */  ? (s)=>host.trace(s) : noop;
        const result = getWatchFactory(host, watchLogLevel, writeLog);
        result.writeLog = writeLog;
        return result;
    }
    function createCompilerHostFromProgramHost(host, getCompilerOptions, directoryStructureHost = host) {
        const useCaseSensitiveFileNames2 = host.useCaseSensitiveFileNames();
        const compilerHost = {
            getSourceFile: createGetSourceFile((fileName, encoding)=>!encoding ? compilerHost.readFile(fileName) : host.readFile(fileName, encoding), /*setParentNodes*/ void 0),
            getDefaultLibLocation: maybeBind(host, host.getDefaultLibLocation),
            getDefaultLibFileName: (options)=>host.getDefaultLibFileName(options),
            writeFile: createWriteFileMeasuringIO((path, data, writeByteOrderMark)=>host.writeFile(path, data, writeByteOrderMark), (path)=>host.createDirectory(path), (path)=>host.directoryExists(path)),
            getCurrentDirectory: memoize(()=>host.getCurrentDirectory()),
            useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames2,
            getCanonicalFileName: createGetCanonicalFileName(useCaseSensitiveFileNames2),
            getNewLine: ()=>getNewLineCharacter(getCompilerOptions()),
            fileExists: (f)=>host.fileExists(f),
            readFile: (f)=>host.readFile(f),
            trace: maybeBind(host, host.trace),
            directoryExists: maybeBind(directoryStructureHost, directoryStructureHost.directoryExists),
            getDirectories: maybeBind(directoryStructureHost, directoryStructureHost.getDirectories),
            realpath: maybeBind(host, host.realpath),
            getEnvironmentVariable: maybeBind(host, host.getEnvironmentVariable) || (()=>""),
            createHash: maybeBind(host, host.createHash),
            readDirectory: maybeBind(host, host.readDirectory),
            storeSignatureInfo: host.storeSignatureInfo,
            jsDocParsingMode: host.jsDocParsingMode
        };
        return compilerHost;
    }
    function getSourceFileVersionAsHashFromText(host, text) {
        if (text.match(sourceMapCommentRegExpDontCareLineStart)) {
            let lineEnd = text.length;
            let lineStart = lineEnd;
            for(let pos = lineEnd - 1; pos >= 0; pos--){
                const ch = text.charCodeAt(pos);
                switch(ch){
                    case 10 /* lineFeed */ :
                        if (pos && text.charCodeAt(pos - 1) === 13 /* carriageReturn */ ) pos--;
                    // falls through
                    case 13 /* carriageReturn */ :
                        break;
                    default:
                        if (ch < 127 /* maxAsciiCharacter */  || !isLineBreak(ch)) {
                            lineStart = pos;
                            continue;
                        }
                        break;
                }
                const line = text.substring(lineStart, lineEnd);
                if (line.match(sourceMapCommentRegExp)) {
                    text = text.substring(0, lineStart);
                    break;
                } else if (!line.match(whitespaceOrMapCommentRegExp)) break;
                lineEnd = lineStart;
            }
        }
        return (host.createHash || generateDjb2Hash)(text);
    }
    function setGetSourceFileAsHashVersioned(compilerHost) {
        const originalGetSourceFile = compilerHost.getSourceFile;
        compilerHost.getSourceFile = (...args)=>{
            const result = originalGetSourceFile.call(compilerHost, ...args);
            if (result) result.version = getSourceFileVersionAsHashFromText(compilerHost, result.text);
            return result;
        };
    }
    function createProgramHost(system, createProgram2) {
        const getDefaultLibLocation = memoize(()=>getDirectoryPath(normalizePath(system.getExecutingFilePath())));
        return {
            useCaseSensitiveFileNames: ()=>system.useCaseSensitiveFileNames,
            getNewLine: ()=>system.newLine,
            getCurrentDirectory: memoize(()=>system.getCurrentDirectory()),
            getDefaultLibLocation,
            getDefaultLibFileName: (options)=>combinePaths(getDefaultLibLocation(), getDefaultLibFileName(options)),
            fileExists: (path)=>system.fileExists(path),
            readFile: (path, encoding)=>system.readFile(path, encoding),
            directoryExists: (path)=>system.directoryExists(path),
            getDirectories: (path)=>system.getDirectories(path),
            readDirectory: (path, extensions, exclude, include, depth)=>system.readDirectory(path, extensions, exclude, include, depth),
            realpath: maybeBind(system, system.realpath),
            getEnvironmentVariable: maybeBind(system, system.getEnvironmentVariable),
            trace: (s)=>system.write(s + system.newLine),
            createDirectory: (path)=>system.createDirectory(path),
            writeFile: (path, data, writeByteOrderMark)=>system.writeFile(path, data, writeByteOrderMark),
            createHash: maybeBind(system, system.createHash),
            createProgram: createProgram2 || createEmitAndSemanticDiagnosticsBuilderProgram,
            storeSignatureInfo: system.storeSignatureInfo,
            now: maybeBind(system, system.now)
        };
    }
    function createWatchCompilerHost(system = sys, createProgram2, reportDiagnostic, reportWatchStatus2) {
        const write = (s)=>system.write(s + system.newLine);
        const result = createProgramHost(system, createProgram2);
        copyProperties(result, createWatchHost(system, reportWatchStatus2));
        result.afterProgramCreate = (builderProgram)=>{
            const compilerOptions = builderProgram.getCompilerOptions();
            const newLine = getNewLineCharacter(compilerOptions);
            emitFilesAndReportErrors(builderProgram, reportDiagnostic, write, (errorCount)=>result.onWatchStatusChange(createCompilerDiagnostic(getWatchErrorSummaryDiagnosticMessage(errorCount), errorCount), newLine, compilerOptions, errorCount));
        };
        return result;
    }
    function reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic) {
        reportDiagnostic(diagnostic);
        system.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
    }
    function createWatchCompilerHostOfConfigFile({ configFileName, optionsToExtend, watchOptionsToExtend, extraFileExtensions, system, createProgram: createProgram2, reportDiagnostic, reportWatchStatus: reportWatchStatus2 }) {
        const diagnosticReporter = reportDiagnostic || createDiagnosticReporter(system);
        const host = createWatchCompilerHost(system, createProgram2, diagnosticReporter, reportWatchStatus2);
        host.onUnRecoverableConfigFileDiagnostic = (diagnostic)=>reportUnrecoverableDiagnostic(system, diagnosticReporter, diagnostic);
        host.configFileName = configFileName;
        host.optionsToExtend = optionsToExtend;
        host.watchOptionsToExtend = watchOptionsToExtend;
        host.extraFileExtensions = extraFileExtensions;
        return host;
    }
    function createWatchCompilerHostOfFilesAndCompilerOptions({ rootFiles, options, watchOptions, projectReferences, system, createProgram: createProgram2, reportDiagnostic, reportWatchStatus: reportWatchStatus2 }) {
        const host = createWatchCompilerHost(system, createProgram2, reportDiagnostic || createDiagnosticReporter(system), reportWatchStatus2);
        host.rootFiles = rootFiles;
        host.options = options;
        host.watchOptions = watchOptions;
        host.projectReferences = projectReferences;
        return host;
    }
    function performIncrementalCompilation(input) {
        const system = input.system || sys;
        const host = input.host || (input.host = createIncrementalCompilerHost(input.options, system));
        const builderProgram = createIncrementalProgram(input);
        const exitStatus = emitFilesAndReportErrorsAndGetExitStatus(builderProgram, input.reportDiagnostic || createDiagnosticReporter(system), (s)=>host.trace && host.trace(s), input.reportErrorSummary || input.options.pretty ? (errorCount, filesInError)=>system.write(getErrorSummaryText(errorCount, filesInError, system.newLine, host)) : void 0);
        if (input.afterProgramEmitAndDiagnostics) input.afterProgramEmitAndDiagnostics(builderProgram);
        return exitStatus;
    }
    // src/compiler/watchPublic.ts
    function readBuilderProgram(compilerOptions, host) {
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(compilerOptions);
        if (!buildInfoPath) return void 0;
        let buildInfo;
        if (host.getBuildInfo) buildInfo = host.getBuildInfo(buildInfoPath, compilerOptions.configFilePath);
        else {
            const content = host.readFile(buildInfoPath);
            if (!content) return void 0;
            buildInfo = getBuildInfo(buildInfoPath, content);
        }
        if (!buildInfo || buildInfo.version !== version || !isIncrementalBuildInfo(buildInfo)) return void 0;
        return createBuilderProgramUsingIncrementalBuildInfo(buildInfo, buildInfoPath, host);
    }
    function createIncrementalCompilerHost(options, system = sys) {
        const host = createCompilerHostWorker(options, /*setParentNodes*/ void 0, system);
        host.createHash = maybeBind(system, system.createHash);
        host.storeSignatureInfo = system.storeSignatureInfo;
        setGetSourceFileAsHashVersioned(host);
        changeCompilerHostLikeToUseCache(host, (fileName)=>toPath(fileName, host.getCurrentDirectory(), host.getCanonicalFileName));
        return host;
    }
    function createIncrementalProgram({ rootNames, options, configFileParsingDiagnostics, projectReferences, host, createProgram: createProgram2 }) {
        host = host || createIncrementalCompilerHost(options);
        createProgram2 = createProgram2 || createEmitAndSemanticDiagnosticsBuilderProgram;
        const oldProgram = readBuilderProgram(options, host);
        return createProgram2(rootNames, options, host, oldProgram, configFileParsingDiagnostics, projectReferences);
    }
    function createWatchCompilerHost2(rootFilesOrConfigFileName, options, system, createProgram2, reportDiagnostic, reportWatchStatus2, projectReferencesOrWatchOptionsToExtend, watchOptionsOrExtraFileExtensions) {
        if (isArray(rootFilesOrConfigFileName)) return createWatchCompilerHostOfFilesAndCompilerOptions({
            rootFiles: rootFilesOrConfigFileName,
            options,
            watchOptions: watchOptionsOrExtraFileExtensions,
            projectReferences: projectReferencesOrWatchOptionsToExtend,
            system,
            createProgram: createProgram2,
            reportDiagnostic,
            reportWatchStatus: reportWatchStatus2
        });
        else return createWatchCompilerHostOfConfigFile({
            configFileName: rootFilesOrConfigFileName,
            optionsToExtend: options,
            watchOptionsToExtend: projectReferencesOrWatchOptionsToExtend,
            extraFileExtensions: watchOptionsOrExtraFileExtensions,
            system,
            createProgram: createProgram2,
            reportDiagnostic,
            reportWatchStatus: reportWatchStatus2
        });
    }
    function createWatchProgram(host) {
        let builderProgram;
        let updateLevel;
        let missingFilesMap;
        let watchedWildcardDirectories;
        let staleWatches = /* @__PURE__ */ new Map([
            [
                void 0,
                void 0
            ]
        ]);
        let timerToUpdateProgram;
        let timerToInvalidateFailedLookupResolutions;
        let parsedConfigs;
        let sharedExtendedConfigFileWatchers;
        let extendedConfigCache = host.extendedConfigCache;
        let reportFileChangeDetectedOnCreateProgram = false;
        const sourceFilesCache = /* @__PURE__ */ new Map();
        let missingFilePathsRequestedForRelease;
        let hasChangedCompilerOptions = false;
        const useCaseSensitiveFileNames2 = host.useCaseSensitiveFileNames();
        const currentDirectory = host.getCurrentDirectory();
        const { configFileName, optionsToExtend: optionsToExtendForConfigFile = {}, watchOptionsToExtend, extraFileExtensions, createProgram: createProgram2 } = host;
        let { rootFiles: rootFileNames, options: compilerOptions, watchOptions, projectReferences } = host;
        let wildcardDirectories;
        let configFileParsingDiagnostics;
        let canConfigFileJsonReportNoInputFiles = false;
        let hasChangedConfigFileParsingErrors = false;
        const cachedDirectoryStructureHost = configFileName === void 0 ? void 0 : createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames2);
        const directoryStructureHost = cachedDirectoryStructureHost || host;
        const parseConfigFileHost = parseConfigHostFromCompilerHostLike(host, directoryStructureHost);
        let newLine = updateNewLine();
        if (configFileName && host.configFileParsingResult) {
            setConfigFileParsingResult(host.configFileParsingResult);
            newLine = updateNewLine();
        }
        reportWatchDiagnostic(Diagnostics.Starting_compilation_in_watch_mode);
        if (configFileName && !host.configFileParsingResult) {
            newLine = getNewLineCharacter(optionsToExtendForConfigFile);
            Debug.assert(!rootFileNames);
            parseConfigFile2();
            newLine = updateNewLine();
        }
        Debug.assert(compilerOptions);
        Debug.assert(rootFileNames);
        const { watchFile: watchFile2, watchDirectory, writeLog } = createWatchFactory(host, compilerOptions);
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        writeLog(`Current directory: ${currentDirectory} CaseSensitiveFileNames: ${useCaseSensitiveFileNames2}`);
        let configFileWatcher;
        if (configFileName) configFileWatcher = watchFile2(configFileName, scheduleProgramReload, 2e3 /* High */ , watchOptions, WatchType.ConfigFile);
        const compilerHost = createCompilerHostFromProgramHost(host, ()=>compilerOptions, directoryStructureHost);
        setGetSourceFileAsHashVersioned(compilerHost);
        const getNewSourceFile = compilerHost.getSourceFile;
        compilerHost.getSourceFile = (fileName, ...args)=>getVersionedSourceFileByPath(fileName, toPath3(fileName), ...args);
        compilerHost.getSourceFileByPath = getVersionedSourceFileByPath;
        compilerHost.getNewLine = ()=>newLine;
        compilerHost.fileExists = fileExists;
        compilerHost.onReleaseOldSourceFile = onReleaseOldSourceFile;
        compilerHost.onReleaseParsedCommandLine = onReleaseParsedCommandLine;
        compilerHost.toPath = toPath3;
        compilerHost.getCompilationSettings = ()=>compilerOptions;
        compilerHost.useSourceOfProjectReferenceRedirect = maybeBind(host, host.useSourceOfProjectReferenceRedirect);
        compilerHost.preferNonRecursiveWatch = host.preferNonRecursiveWatch;
        compilerHost.watchDirectoryOfFailedLookupLocation = (dir, cb, flags)=>watchDirectory(dir, cb, flags, watchOptions, WatchType.FailedLookupLocations);
        compilerHost.watchAffectingFileLocation = (file, cb)=>watchFile2(file, cb, 2e3 /* High */ , watchOptions, WatchType.AffectingFileLocation);
        compilerHost.watchTypeRootsDirectory = (dir, cb, flags)=>watchDirectory(dir, cb, flags, watchOptions, WatchType.TypeRoots);
        compilerHost.getCachedDirectoryStructureHost = ()=>cachedDirectoryStructureHost;
        compilerHost.scheduleInvalidateResolutionsOfFailedLookupLocations = scheduleInvalidateResolutionsOfFailedLookupLocations;
        compilerHost.onInvalidatedResolution = scheduleProgramUpdate;
        compilerHost.onChangedAutomaticTypeDirectiveNames = scheduleProgramUpdate;
        compilerHost.fileIsOpen = returnFalse;
        compilerHost.getCurrentProgram = getCurrentProgram;
        compilerHost.writeLog = writeLog;
        compilerHost.getParsedCommandLine = getParsedCommandLine;
        const resolutionCache = createResolutionCache(compilerHost, configFileName ? getDirectoryPath(getNormalizedAbsolutePath(configFileName, currentDirectory)) : currentDirectory, /*logChangesWhenResolvingModule*/ false);
        compilerHost.resolveModuleNameLiterals = maybeBind(host, host.resolveModuleNameLiterals);
        compilerHost.resolveModuleNames = maybeBind(host, host.resolveModuleNames);
        if (!compilerHost.resolveModuleNameLiterals && !compilerHost.resolveModuleNames) compilerHost.resolveModuleNameLiterals = resolutionCache.resolveModuleNameLiterals.bind(resolutionCache);
        compilerHost.resolveTypeReferenceDirectiveReferences = maybeBind(host, host.resolveTypeReferenceDirectiveReferences);
        compilerHost.resolveTypeReferenceDirectives = maybeBind(host, host.resolveTypeReferenceDirectives);
        if (!compilerHost.resolveTypeReferenceDirectiveReferences && !compilerHost.resolveTypeReferenceDirectives) compilerHost.resolveTypeReferenceDirectiveReferences = resolutionCache.resolveTypeReferenceDirectiveReferences.bind(resolutionCache);
        compilerHost.resolveLibrary = !host.resolveLibrary ? resolutionCache.resolveLibrary.bind(resolutionCache) : host.resolveLibrary.bind(host);
        compilerHost.getModuleResolutionCache = host.resolveModuleNameLiterals || host.resolveModuleNames ? maybeBind(host, host.getModuleResolutionCache) : ()=>resolutionCache.getModuleResolutionCache();
        const userProvidedResolution = !!host.resolveModuleNameLiterals || !!host.resolveTypeReferenceDirectiveReferences || !!host.resolveModuleNames || !!host.resolveTypeReferenceDirectives;
        const customHasInvalidatedResolutions = userProvidedResolution ? maybeBind(host, host.hasInvalidatedResolutions) || returnTrue : returnFalse;
        const customHasInvalidLibResolutions = host.resolveLibrary ? maybeBind(host, host.hasInvalidatedLibResolutions) || returnTrue : returnFalse;
        builderProgram = readBuilderProgram(compilerOptions, compilerHost);
        synchronizeProgram();
        return configFileName ? {
            getCurrentProgram: getCurrentBuilderProgram,
            getProgram: updateProgram,
            close,
            getResolutionCache
        } : {
            getCurrentProgram: getCurrentBuilderProgram,
            getProgram: updateProgram,
            updateRootFileNames,
            close,
            getResolutionCache
        };
        function close() {
            clearInvalidateResolutionsOfFailedLookupLocations();
            resolutionCache.clear();
            clearMap(sourceFilesCache, (value1)=>{
                if (value1 && value1.fileWatcher) {
                    value1.fileWatcher.close();
                    value1.fileWatcher = void 0;
                }
            });
            if (configFileWatcher) {
                configFileWatcher.close();
                configFileWatcher = void 0;
            }
            extendedConfigCache == null || extendedConfigCache.clear();
            extendedConfigCache = void 0;
            if (sharedExtendedConfigFileWatchers) {
                clearMap(sharedExtendedConfigFileWatchers, closeFileWatcherOf);
                sharedExtendedConfigFileWatchers = void 0;
            }
            if (watchedWildcardDirectories) {
                clearMap(watchedWildcardDirectories, closeFileWatcherOf);
                watchedWildcardDirectories = void 0;
            }
            if (missingFilesMap) {
                clearMap(missingFilesMap, closeFileWatcher);
                missingFilesMap = void 0;
            }
            if (parsedConfigs) {
                clearMap(parsedConfigs, (config)=>{
                    var _a;
                    (_a = config.watcher) == null || _a.close();
                    config.watcher = void 0;
                    if (config.watchedDirectories) clearMap(config.watchedDirectories, closeFileWatcherOf);
                    config.watchedDirectories = void 0;
                });
                parsedConfigs = void 0;
            }
            builderProgram = void 0;
        }
        function getResolutionCache() {
            return resolutionCache;
        }
        function getCurrentBuilderProgram() {
            return builderProgram;
        }
        function getCurrentProgram() {
            return builderProgram && builderProgram.getProgramOrUndefined();
        }
        function synchronizeProgram() {
            writeLog(`Synchronizing program`);
            Debug.assert(compilerOptions);
            Debug.assert(rootFileNames);
            clearInvalidateResolutionsOfFailedLookupLocations();
            const program = getCurrentBuilderProgram();
            if (hasChangedCompilerOptions) {
                newLine = updateNewLine();
                if (program && changesAffectModuleResolution(program.getCompilerOptions(), compilerOptions)) resolutionCache.onChangesAffectModuleResolution();
            }
            const { hasInvalidatedResolutions, hasInvalidatedLibResolutions } = resolutionCache.createHasInvalidatedResolutions(customHasInvalidatedResolutions, customHasInvalidLibResolutions);
            const { originalReadFile, originalFileExists, originalDirectoryExists, originalCreateDirectory, originalWriteFile, readFileWithCache } = changeCompilerHostLikeToUseCache(compilerHost, toPath3);
            if (isProgramUptoDate(getCurrentProgram(), rootFileNames, compilerOptions, (path)=>getSourceVersion(path, readFileWithCache), (fileName)=>compilerHost.fileExists(fileName), hasInvalidatedResolutions, hasInvalidatedLibResolutions, hasChangedAutomaticTypeDirectiveNames, getParsedCommandLine, projectReferences)) {
                if (hasChangedConfigFileParsingErrors) {
                    if (reportFileChangeDetectedOnCreateProgram) reportWatchDiagnostic(Diagnostics.File_change_detected_Starting_incremental_compilation);
                    builderProgram = createProgram2(/*rootNames*/ void 0, /*options*/ void 0, compilerHost, builderProgram, configFileParsingDiagnostics, projectReferences);
                    hasChangedConfigFileParsingErrors = false;
                }
            } else {
                if (reportFileChangeDetectedOnCreateProgram) reportWatchDiagnostic(Diagnostics.File_change_detected_Starting_incremental_compilation);
                createNewProgram(hasInvalidatedResolutions, hasInvalidatedLibResolutions);
            }
            reportFileChangeDetectedOnCreateProgram = false;
            if (host.afterProgramCreate && program !== builderProgram) host.afterProgramCreate(builderProgram);
            compilerHost.readFile = originalReadFile;
            compilerHost.fileExists = originalFileExists;
            compilerHost.directoryExists = originalDirectoryExists;
            compilerHost.createDirectory = originalCreateDirectory;
            compilerHost.writeFile = originalWriteFile;
            staleWatches == null || staleWatches.forEach((configFile, configPath)=>{
                if (!configPath) {
                    watchConfigFileWildCardDirectories();
                    if (configFileName) updateExtendedConfigFilesWatches(toPath3(configFileName), compilerOptions, watchOptions, WatchType.ExtendedConfigFile);
                } else {
                    const config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
                    if (config) watchReferencedProject(configFile, configPath, config);
                }
            });
            staleWatches = void 0;
            return builderProgram;
        }
        function createNewProgram(hasInvalidatedResolutions, hasInvalidatedLibResolutions) {
            writeLog("CreatingProgramWith::");
            writeLog(`  roots: ${JSON.stringify(rootFileNames)}`);
            writeLog(`  options: ${JSON.stringify(compilerOptions)}`);
            if (projectReferences) writeLog(`  projectReferences: ${JSON.stringify(projectReferences)}`);
            const needsUpdateInTypeRootWatch = hasChangedCompilerOptions || !getCurrentProgram();
            hasChangedCompilerOptions = false;
            hasChangedConfigFileParsingErrors = false;
            resolutionCache.startCachingPerDirectoryResolution();
            compilerHost.hasInvalidatedResolutions = hasInvalidatedResolutions;
            compilerHost.hasInvalidatedLibResolutions = hasInvalidatedLibResolutions;
            compilerHost.hasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames;
            const oldProgram = getCurrentProgram();
            builderProgram = createProgram2(rootFileNames, compilerOptions, compilerHost, builderProgram, configFileParsingDiagnostics, projectReferences);
            resolutionCache.finishCachingPerDirectoryResolution(builderProgram.getProgram(), oldProgram);
            updateMissingFilePathsWatch(builderProgram.getProgram(), missingFilesMap || (missingFilesMap = /* @__PURE__ */ new Map()), watchMissingFilePath);
            if (needsUpdateInTypeRootWatch) resolutionCache.updateTypeRootsWatch();
            if (missingFilePathsRequestedForRelease) {
                for (const missingFilePath of missingFilePathsRequestedForRelease)if (!missingFilesMap.has(missingFilePath)) sourceFilesCache.delete(missingFilePath);
                missingFilePathsRequestedForRelease = void 0;
            }
        }
        function updateRootFileNames(files) {
            Debug.assert(!configFileName, "Cannot update root file names with config file watch mode");
            rootFileNames = files;
            scheduleProgramUpdate();
        }
        function updateNewLine() {
            return getNewLineCharacter(compilerOptions || optionsToExtendForConfigFile);
        }
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function isFileMissingOnHost(hostSourceFile) {
            return typeof hostSourceFile === "boolean";
        }
        function isFilePresenceUnknownOnHost(hostSourceFile) {
            return typeof hostSourceFile.version === "boolean";
        }
        function fileExists(fileName) {
            const path = toPath3(fileName);
            if (isFileMissingOnHost(sourceFilesCache.get(path))) return false;
            return directoryStructureHost.fileExists(fileName);
        }
        function getVersionedSourceFileByPath(fileName, path, languageVersionOrOptions, onError, shouldCreateNewSourceFile) {
            const hostSourceFile = sourceFilesCache.get(path);
            if (isFileMissingOnHost(hostSourceFile)) return void 0;
            const impliedNodeFormat = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions.impliedNodeFormat : void 0;
            if (hostSourceFile === void 0 || shouldCreateNewSourceFile || isFilePresenceUnknownOnHost(hostSourceFile) || hostSourceFile.sourceFile.impliedNodeFormat !== impliedNodeFormat) {
                const sourceFile = getNewSourceFile(fileName, languageVersionOrOptions, onError);
                if (hostSourceFile) {
                    if (sourceFile) {
                        hostSourceFile.sourceFile = sourceFile;
                        hostSourceFile.version = sourceFile.version;
                        if (!hostSourceFile.fileWatcher) hostSourceFile.fileWatcher = watchFilePath(path, fileName, onSourceFileChange, 250 /* Low */ , watchOptions, WatchType.SourceFile);
                    } else {
                        if (hostSourceFile.fileWatcher) hostSourceFile.fileWatcher.close();
                        sourceFilesCache.set(path, false);
                    }
                } else if (sourceFile) {
                    const fileWatcher = watchFilePath(path, fileName, onSourceFileChange, 250 /* Low */ , watchOptions, WatchType.SourceFile);
                    sourceFilesCache.set(path, {
                        sourceFile,
                        version: sourceFile.version,
                        fileWatcher
                    });
                } else sourceFilesCache.set(path, false);
                return sourceFile;
            }
            return hostSourceFile.sourceFile;
        }
        function nextSourceFileVersion(path) {
            const hostSourceFile = sourceFilesCache.get(path);
            if (hostSourceFile !== void 0) {
                if (isFileMissingOnHost(hostSourceFile)) sourceFilesCache.set(path, {
                    version: false
                });
                else hostSourceFile.version = false;
            }
        }
        function getSourceVersion(path, readFileWithCache) {
            const hostSourceFile = sourceFilesCache.get(path);
            if (!hostSourceFile) return void 0;
            if (hostSourceFile.version) return hostSourceFile.version;
            const text = readFileWithCache(path);
            return text !== void 0 ? getSourceFileVersionAsHashFromText(compilerHost, text) : void 0;
        }
        function onReleaseOldSourceFile(oldSourceFile, _oldOptions, hasSourceFileByPath) {
            const hostSourceFileInfo = sourceFilesCache.get(oldSourceFile.resolvedPath);
            if (hostSourceFileInfo !== void 0) {
                if (isFileMissingOnHost(hostSourceFileInfo)) (missingFilePathsRequestedForRelease || (missingFilePathsRequestedForRelease = [])).push(oldSourceFile.path);
                else if (hostSourceFileInfo.sourceFile === oldSourceFile) {
                    if (hostSourceFileInfo.fileWatcher) hostSourceFileInfo.fileWatcher.close();
                    sourceFilesCache.delete(oldSourceFile.resolvedPath);
                    if (!hasSourceFileByPath) resolutionCache.removeResolutionsOfFile(oldSourceFile.path);
                }
            }
        }
        function reportWatchDiagnostic(message) {
            if (host.onWatchStatusChange) host.onWatchStatusChange(createCompilerDiagnostic(message), newLine, compilerOptions || optionsToExtendForConfigFile);
        }
        function hasChangedAutomaticTypeDirectiveNames() {
            return resolutionCache.hasChangedAutomaticTypeDirectiveNames();
        }
        function clearInvalidateResolutionsOfFailedLookupLocations() {
            if (!timerToInvalidateFailedLookupResolutions) return false;
            host.clearTimeout(timerToInvalidateFailedLookupResolutions);
            timerToInvalidateFailedLookupResolutions = void 0;
            return true;
        }
        function scheduleInvalidateResolutionsOfFailedLookupLocations() {
            if (!host.setTimeout || !host.clearTimeout) return resolutionCache.invalidateResolutionsOfFailedLookupLocations();
            const pending = clearInvalidateResolutionsOfFailedLookupLocations();
            writeLog(`Scheduling invalidateFailedLookup${pending ? ", Cancelled earlier one" : ""}`);
            timerToInvalidateFailedLookupResolutions = host.setTimeout(invalidateResolutionsOfFailedLookup, 250, "timerToInvalidateFailedLookupResolutions");
        }
        function invalidateResolutionsOfFailedLookup() {
            timerToInvalidateFailedLookupResolutions = void 0;
            if (resolutionCache.invalidateResolutionsOfFailedLookupLocations()) scheduleProgramUpdate();
        }
        function scheduleProgramUpdate() {
            if (!host.setTimeout || !host.clearTimeout) return;
            if (timerToUpdateProgram) host.clearTimeout(timerToUpdateProgram);
            writeLog("Scheduling update");
            timerToUpdateProgram = host.setTimeout(updateProgramWithWatchStatus, 250, "timerToUpdateProgram");
        }
        function scheduleProgramReload() {
            Debug.assert(!!configFileName);
            updateLevel = 2 /* Full */ ;
            scheduleProgramUpdate();
        }
        function updateProgramWithWatchStatus() {
            timerToUpdateProgram = void 0;
            reportFileChangeDetectedOnCreateProgram = true;
            updateProgram();
        }
        function updateProgram() {
            switch(updateLevel){
                case 1 /* RootNamesAndUpdate */ :
                    reloadFileNamesFromConfigFile();
                    break;
                case 2 /* Full */ :
                    reloadConfigFile();
                    break;
                default:
                    synchronizeProgram();
                    break;
            }
            return getCurrentBuilderProgram();
        }
        function reloadFileNamesFromConfigFile() {
            writeLog("Reloading new file names and options");
            Debug.assert(compilerOptions);
            Debug.assert(configFileName);
            updateLevel = 0 /* Update */ ;
            rootFileNames = getFileNamesFromConfigSpecs(compilerOptions.configFile.configFileSpecs, getNormalizedAbsolutePath(getDirectoryPath(configFileName), currentDirectory), compilerOptions, parseConfigFileHost, extraFileExtensions);
            if (updateErrorForNoInputFiles(rootFileNames, getNormalizedAbsolutePath(configFileName, currentDirectory), compilerOptions.configFile.configFileSpecs, configFileParsingDiagnostics, canConfigFileJsonReportNoInputFiles)) hasChangedConfigFileParsingErrors = true;
            synchronizeProgram();
        }
        function reloadConfigFile() {
            Debug.assert(configFileName);
            writeLog(`Reloading config file: ${configFileName}`);
            updateLevel = 0 /* Update */ ;
            if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.clearCache();
            parseConfigFile2();
            hasChangedCompilerOptions = true;
            (staleWatches !== null && staleWatches !== void 0 ? staleWatches : staleWatches = /* @__PURE__ */ new Map()).set(void 0, void 0);
            synchronizeProgram();
        }
        function parseConfigFile2() {
            Debug.assert(configFileName);
            setConfigFileParsingResult(getParsedCommandLineOfConfigFile(configFileName, optionsToExtendForConfigFile, parseConfigFileHost, extendedConfigCache || (extendedConfigCache = /* @__PURE__ */ new Map()), watchOptionsToExtend, extraFileExtensions));
        }
        function setConfigFileParsingResult(configFileParseResult) {
            rootFileNames = configFileParseResult.fileNames;
            compilerOptions = configFileParseResult.options;
            watchOptions = configFileParseResult.watchOptions;
            projectReferences = configFileParseResult.projectReferences;
            wildcardDirectories = configFileParseResult.wildcardDirectories;
            configFileParsingDiagnostics = getConfigFileParsingDiagnostics(configFileParseResult).slice();
            canConfigFileJsonReportNoInputFiles = canJsonReportNoInputFiles(configFileParseResult.raw);
            hasChangedConfigFileParsingErrors = true;
        }
        function getParsedCommandLine(configFileName2) {
            const configPath = toPath3(configFileName2);
            let config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
            if (config) {
                if (!config.updateLevel) return config.parsedCommandLine;
                if (config.parsedCommandLine && config.updateLevel === 1 /* RootNamesAndUpdate */  && !host.getParsedCommandLine) {
                    writeLog("Reloading new file names and options");
                    Debug.assert(compilerOptions);
                    const fileNames = getFileNamesFromConfigSpecs(config.parsedCommandLine.options.configFile.configFileSpecs, getNormalizedAbsolutePath(getDirectoryPath(configFileName2), currentDirectory), compilerOptions, parseConfigFileHost);
                    config.parsedCommandLine = (0, _objectSpreadProps._)((0, _objectSpread._)({}, config.parsedCommandLine), {
                        fileNames
                    });
                    config.updateLevel = void 0;
                    return config.parsedCommandLine;
                }
            }
            writeLog(`Loading config file: ${configFileName2}`);
            const parsedCommandLine = host.getParsedCommandLine ? host.getParsedCommandLine(configFileName2) : getParsedCommandLineFromConfigFileHost(configFileName2);
            if (config) {
                config.parsedCommandLine = parsedCommandLine;
                config.updateLevel = void 0;
            } else (parsedConfigs || (parsedConfigs = /* @__PURE__ */ new Map())).set(configPath, config = {
                parsedCommandLine
            });
            (staleWatches !== null && staleWatches !== void 0 ? staleWatches : staleWatches = /* @__PURE__ */ new Map()).set(configPath, configFileName2);
            return parsedCommandLine;
        }
        function getParsedCommandLineFromConfigFileHost(configFileName2) {
            const onUnRecoverableConfigFileDiagnostic = parseConfigFileHost.onUnRecoverableConfigFileDiagnostic;
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = noop;
            const parsedCommandLine = getParsedCommandLineOfConfigFile(configFileName2, /*optionsToExtend*/ void 0, parseConfigFileHost, extendedConfigCache || (extendedConfigCache = /* @__PURE__ */ new Map()), watchOptionsToExtend);
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = onUnRecoverableConfigFileDiagnostic;
            return parsedCommandLine;
        }
        function onReleaseParsedCommandLine(fileName) {
            var _a;
            const path = toPath3(fileName);
            const config = parsedConfigs == null ? void 0 : parsedConfigs.get(path);
            if (!config) return;
            parsedConfigs.delete(path);
            if (config.watchedDirectories) clearMap(config.watchedDirectories, closeFileWatcherOf);
            (_a = config.watcher) == null || _a.close();
            clearSharedExtendedConfigFileWatcher(path, sharedExtendedConfigFileWatchers);
        }
        function watchFilePath(path, file, callback, pollingInterval, options, watchType) {
            return watchFile2(file, (fileName, eventKind)=>callback(fileName, eventKind, path), pollingInterval, options, watchType);
        }
        function onSourceFileChange(fileName, eventKind, path) {
            updateCachedSystemWithFile(fileName, path, eventKind);
            if (eventKind === 2 /* Deleted */  && sourceFilesCache.has(path)) resolutionCache.invalidateResolutionOfFile(path);
            nextSourceFileVersion(path);
            scheduleProgramUpdate();
        }
        function updateCachedSystemWithFile(fileName, path, eventKind) {
            if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFile(fileName, path, eventKind);
        }
        function watchMissingFilePath(missingFilePath, missingFileName) {
            return (parsedConfigs == null ? void 0 : parsedConfigs.has(missingFilePath)) ? noopFileWatcher : watchFilePath(missingFilePath, missingFileName, onMissingFileChange, 500 /* Medium */ , watchOptions, WatchType.MissingFile);
        }
        function onMissingFileChange(fileName, eventKind, missingFilePath) {
            updateCachedSystemWithFile(fileName, missingFilePath, eventKind);
            if (eventKind === 0 /* Created */  && missingFilesMap.has(missingFilePath)) {
                missingFilesMap.get(missingFilePath).close();
                missingFilesMap.delete(missingFilePath);
                nextSourceFileVersion(missingFilePath);
                scheduleProgramUpdate();
            }
        }
        function watchConfigFileWildCardDirectories() {
            updateWatchingWildcardDirectories(watchedWildcardDirectories || (watchedWildcardDirectories = /* @__PURE__ */ new Map()), wildcardDirectories, watchWildcardDirectory);
        }
        function watchWildcardDirectory(directory, flags) {
            return watchDirectory(directory, (fileOrDirectory)=>{
                Debug.assert(configFileName);
                Debug.assert(compilerOptions);
                const fileOrDirectoryPath = toPath3(fileOrDirectory);
                if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                nextSourceFileVersion(fileOrDirectoryPath);
                if (isIgnoredFileFromWildCardWatching({
                    watchedDirPath: toPath3(directory),
                    fileOrDirectory,
                    fileOrDirectoryPath,
                    configFileName,
                    extraFileExtensions,
                    options: compilerOptions,
                    program: getCurrentBuilderProgram() || rootFileNames,
                    currentDirectory,
                    useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
                    writeLog,
                    toPath: toPath3
                })) return;
                if (updateLevel !== 2 /* Full */ ) {
                    updateLevel = 1 /* RootNamesAndUpdate */ ;
                    scheduleProgramUpdate();
                }
            }, flags, watchOptions, WatchType.WildcardDirectory);
        }
        function updateExtendedConfigFilesWatches(forProjectPath, options, watchOptions2, watchType) {
            updateSharedExtendedConfigFileWatcher(forProjectPath, options, sharedExtendedConfigFileWatchers || (sharedExtendedConfigFileWatchers = /* @__PURE__ */ new Map()), (extendedConfigFileName, extendedConfigFilePath)=>watchFile2(extendedConfigFileName, (_fileName, eventKind)=>{
                    var _a;
                    updateCachedSystemWithFile(extendedConfigFileName, extendedConfigFilePath, eventKind);
                    if (extendedConfigCache) cleanExtendedConfigCache(extendedConfigCache, extendedConfigFilePath, toPath3);
                    const projects = (_a = sharedExtendedConfigFileWatchers.get(extendedConfigFilePath)) == null ? void 0 : _a.projects;
                    if (!(projects == null ? void 0 : projects.size)) return;
                    projects.forEach((projectPath)=>{
                        if (configFileName && toPath3(configFileName) === projectPath) updateLevel = 2 /* Full */ ;
                        else {
                            const config = parsedConfigs == null ? void 0 : parsedConfigs.get(projectPath);
                            if (config) config.updateLevel = 2 /* Full */ ;
                            resolutionCache.removeResolutionsFromProjectReferenceRedirects(projectPath);
                        }
                        scheduleProgramUpdate();
                    });
                }, 2e3 /* High */ , watchOptions2, watchType), toPath3);
        }
        function watchReferencedProject(configFileName2, configPath, commandLine) {
            var _a, _b, _c, _d;
            commandLine.watcher || (commandLine.watcher = watchFile2(configFileName2, (_fileName, eventKind)=>{
                updateCachedSystemWithFile(configFileName2, configPath, eventKind);
                const config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
                if (config) config.updateLevel = 2 /* Full */ ;
                resolutionCache.removeResolutionsFromProjectReferenceRedirects(configPath);
                scheduleProgramUpdate();
            }, 2e3 /* High */ , ((_a = commandLine.parsedCommandLine) == null ? void 0 : _a.watchOptions) || watchOptions, WatchType.ConfigFileOfReferencedProject));
            updateWatchingWildcardDirectories(commandLine.watchedDirectories || (commandLine.watchedDirectories = /* @__PURE__ */ new Map()), (_b = commandLine.parsedCommandLine) == null ? void 0 : _b.wildcardDirectories, (directory, flags)=>{
                var _a2;
                return watchDirectory(directory, (fileOrDirectory)=>{
                    const fileOrDirectoryPath = toPath3(fileOrDirectory);
                    if (cachedDirectoryStructureHost) cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
                    nextSourceFileVersion(fileOrDirectoryPath);
                    const config = parsedConfigs == null ? void 0 : parsedConfigs.get(configPath);
                    if (!(config == null ? void 0 : config.parsedCommandLine)) return;
                    if (isIgnoredFileFromWildCardWatching({
                        watchedDirPath: toPath3(directory),
                        fileOrDirectory,
                        fileOrDirectoryPath,
                        configFileName: configFileName2,
                        options: config.parsedCommandLine.options,
                        program: config.parsedCommandLine.fileNames,
                        currentDirectory,
                        useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
                        writeLog,
                        toPath: toPath3
                    })) return;
                    if (config.updateLevel !== 2 /* Full */ ) {
                        config.updateLevel = 1 /* RootNamesAndUpdate */ ;
                        scheduleProgramUpdate();
                    }
                }, flags, ((_a2 = commandLine.parsedCommandLine) == null ? void 0 : _a2.watchOptions) || watchOptions, WatchType.WildcardDirectoryOfReferencedProject);
            });
            updateExtendedConfigFilesWatches(configPath, (_c = commandLine.parsedCommandLine) == null ? void 0 : _c.options, ((_d = commandLine.parsedCommandLine) == null ? void 0 : _d.watchOptions) || watchOptions, WatchType.ExtendedConfigOfReferencedProject);
        }
    }
    // src/compiler/tsbuild.ts
    var UpToDateStatusType = /* @__PURE__ */ ((UpToDateStatusType2)=>{
        UpToDateStatusType2[UpToDateStatusType2["Unbuildable"] = 0] = "Unbuildable";
        UpToDateStatusType2[UpToDateStatusType2["UpToDate"] = 1] = "UpToDate";
        UpToDateStatusType2[UpToDateStatusType2["UpToDateWithUpstreamTypes"] = 2] = "UpToDateWithUpstreamTypes";
        UpToDateStatusType2[UpToDateStatusType2["OutputMissing"] = 3] = "OutputMissing";
        UpToDateStatusType2[UpToDateStatusType2["ErrorReadingFile"] = 4] = "ErrorReadingFile";
        UpToDateStatusType2[UpToDateStatusType2["OutOfDateWithSelf"] = 5] = "OutOfDateWithSelf";
        UpToDateStatusType2[UpToDateStatusType2["OutOfDateWithUpstream"] = 6] = "OutOfDateWithUpstream";
        UpToDateStatusType2[UpToDateStatusType2["OutOfDateBuildInfoWithPendingEmit"] = 7] = "OutOfDateBuildInfoWithPendingEmit";
        UpToDateStatusType2[UpToDateStatusType2["OutOfDateBuildInfoWithErrors"] = 8] = "OutOfDateBuildInfoWithErrors";
        UpToDateStatusType2[UpToDateStatusType2["OutOfDateOptions"] = 9] = "OutOfDateOptions";
        UpToDateStatusType2[UpToDateStatusType2["OutOfDateRoots"] = 10] = "OutOfDateRoots";
        UpToDateStatusType2[UpToDateStatusType2["UpstreamOutOfDate"] = 11] = "UpstreamOutOfDate";
        UpToDateStatusType2[UpToDateStatusType2["UpstreamBlocked"] = 12] = "UpstreamBlocked";
        UpToDateStatusType2[UpToDateStatusType2["ComputingUpstream"] = 13] = "ComputingUpstream";
        UpToDateStatusType2[UpToDateStatusType2["TsVersionOutputOfDate"] = 14] = "TsVersionOutputOfDate";
        UpToDateStatusType2[UpToDateStatusType2["UpToDateWithInputFileText"] = 15] = "UpToDateWithInputFileText";
        UpToDateStatusType2[UpToDateStatusType2["ContainerOnly"] = 16] = "ContainerOnly";
        UpToDateStatusType2[UpToDateStatusType2["ForceBuild"] = 17] = "ForceBuild";
        return UpToDateStatusType2;
    })(UpToDateStatusType || {});
    function resolveConfigFileProjectName(project) {
        if (fileExtensionIs(project, ".json" /* Json */ )) return project;
        return combinePaths(project, "tsconfig.json");
    }
    // src/compiler/tsbuildPublic.ts
    var minimumDate = /* @__PURE__ */ new Date(-8640000000000000);
    function getOrCreateValueFromConfigFileMap(configFileMap, resolved, createT) {
        const existingValue = configFileMap.get(resolved);
        let newValue;
        if (!existingValue) {
            newValue = createT();
            configFileMap.set(resolved, newValue);
        }
        return existingValue || newValue;
    }
    function getOrCreateValueMapFromConfigFileMap(configFileMap, resolved) {
        return getOrCreateValueFromConfigFileMap(configFileMap, resolved, ()=>/* @__PURE__ */ new Map());
    }
    function getCurrentTime(host) {
        return host.now ? host.now() : /* @__PURE__ */ new Date();
    }
    function isCircularBuildOrder(buildOrder) {
        return !!buildOrder && !!buildOrder.buildOrder;
    }
    function getBuildOrderFromAnyBuildOrder(anyBuildOrder) {
        return isCircularBuildOrder(anyBuildOrder) ? anyBuildOrder.buildOrder : anyBuildOrder;
    }
    function createBuilderStatusReporter(system, pretty) {
        return (diagnostic)=>{
            let output = pretty ? `[${formatColorAndReset(getLocaleTimeString(system), "\x1B[90m" /* Grey */ )}] ` : `${getLocaleTimeString(system)} - `;
            output += `${flattenDiagnosticMessageText(diagnostic.messageText, system.newLine)}${system.newLine + system.newLine}`;
            system.write(output);
        };
    }
    function createSolutionBuilderHostBase(system, createProgram2, reportDiagnostic, reportSolutionBuilderStatus) {
        const host = createProgramHost(system, createProgram2);
        host.getModifiedTime = system.getModifiedTime ? (path)=>system.getModifiedTime(path) : returnUndefined;
        host.setModifiedTime = system.setModifiedTime ? (path, date)=>system.setModifiedTime(path, date) : noop;
        host.deleteFile = system.deleteFile ? (path)=>system.deleteFile(path) : noop;
        host.reportDiagnostic = reportDiagnostic || createDiagnosticReporter(system);
        host.reportSolutionBuilderStatus = reportSolutionBuilderStatus || createBuilderStatusReporter(system);
        host.now = maybeBind(system, system.now);
        return host;
    }
    function createSolutionBuilderHost(system = sys, createProgram2, reportDiagnostic, reportSolutionBuilderStatus, reportErrorSummary2) {
        const host = createSolutionBuilderHostBase(system, createProgram2, reportDiagnostic, reportSolutionBuilderStatus);
        host.reportErrorSummary = reportErrorSummary2;
        return host;
    }
    function createSolutionBuilderWithWatchHost(system = sys, createProgram2, reportDiagnostic, reportSolutionBuilderStatus, reportWatchStatus2) {
        const host = createSolutionBuilderHostBase(system, createProgram2, reportDiagnostic, reportSolutionBuilderStatus);
        const watchHost = createWatchHost(system, reportWatchStatus2);
        copyProperties(host, watchHost);
        return host;
    }
    function getCompilerOptionsOfBuildOptions(buildOptions) {
        const result = {};
        commonOptionsWithBuild.forEach((option)=>{
            if (hasProperty(buildOptions, option.name)) result[option.name] = buildOptions[option.name];
        });
        result.tscBuild = true;
        return result;
    }
    function createSolutionBuilder(host, rootNames, defaultOptions) {
        return createSolutionBuilderWorker(/*watch*/ false, host, rootNames, defaultOptions);
    }
    function createSolutionBuilderWithWatch(host, rootNames, defaultOptions, baseWatchOptions) {
        return createSolutionBuilderWorker(/*watch*/ true, host, rootNames, defaultOptions, baseWatchOptions);
    }
    function createSolutionBuilderState(watch, hostOrHostWithWatch, rootNames, options, baseWatchOptions) {
        const host = hostOrHostWithWatch;
        const hostWithWatch = hostOrHostWithWatch;
        const baseCompilerOptions = getCompilerOptionsOfBuildOptions(options);
        const compilerHost = createCompilerHostFromProgramHost(host, ()=>state.projectCompilerOptions);
        setGetSourceFileAsHashVersioned(compilerHost);
        compilerHost.getParsedCommandLine = (fileName)=>parseConfigFile(state, fileName, toResolvedConfigFilePath(state, fileName));
        compilerHost.resolveModuleNameLiterals = maybeBind(host, host.resolveModuleNameLiterals);
        compilerHost.resolveTypeReferenceDirectiveReferences = maybeBind(host, host.resolveTypeReferenceDirectiveReferences);
        compilerHost.resolveLibrary = maybeBind(host, host.resolveLibrary);
        compilerHost.resolveModuleNames = maybeBind(host, host.resolveModuleNames);
        compilerHost.resolveTypeReferenceDirectives = maybeBind(host, host.resolveTypeReferenceDirectives);
        compilerHost.getModuleResolutionCache = maybeBind(host, host.getModuleResolutionCache);
        let moduleResolutionCache, typeReferenceDirectiveResolutionCache;
        if (!compilerHost.resolveModuleNameLiterals && !compilerHost.resolveModuleNames) {
            moduleResolutionCache = createModuleResolutionCache(compilerHost.getCurrentDirectory(), compilerHost.getCanonicalFileName);
            compilerHost.resolveModuleNameLiterals = (moduleNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(moduleNames, containingFile, redirectedReference, options2, containingSourceFile, host, moduleResolutionCache, createModuleResolutionLoader);
            compilerHost.getModuleResolutionCache = ()=>moduleResolutionCache;
        }
        if (!compilerHost.resolveTypeReferenceDirectiveReferences && !compilerHost.resolveTypeReferenceDirectives) {
            typeReferenceDirectiveResolutionCache = createTypeReferenceDirectiveResolutionCache(compilerHost.getCurrentDirectory(), compilerHost.getCanonicalFileName, /*options*/ void 0, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache(), moduleResolutionCache == null ? void 0 : moduleResolutionCache.optionsToRedirectsKey);
            compilerHost.resolveTypeReferenceDirectiveReferences = (typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile)=>loadWithModeAwareCache(typeDirectiveNames, containingFile, redirectedReference, options2, containingSourceFile, host, typeReferenceDirectiveResolutionCache, createTypeReferenceResolutionLoader);
        }
        let libraryResolutionCache;
        if (!compilerHost.resolveLibrary) {
            libraryResolutionCache = createModuleResolutionCache(compilerHost.getCurrentDirectory(), compilerHost.getCanonicalFileName, /*options*/ void 0, moduleResolutionCache == null ? void 0 : moduleResolutionCache.getPackageJsonInfoCache());
            compilerHost.resolveLibrary = (libraryName, resolveFrom, options2)=>resolveLibrary(libraryName, resolveFrom, options2, host, libraryResolutionCache);
        }
        compilerHost.getBuildInfo = (fileName, configFilePath)=>getBuildInfo3(state, fileName, toResolvedConfigFilePath(state, configFilePath), /*modifiedTime*/ void 0);
        const { watchFile: watchFile2, watchDirectory, writeLog } = createWatchFactory(hostWithWatch, options);
        const state = {
            host,
            hostWithWatch,
            parseConfigFileHost: parseConfigHostFromCompilerHostLike(host),
            write: maybeBind(host, host.trace),
            // State of solution
            options,
            baseCompilerOptions,
            rootNames,
            baseWatchOptions,
            resolvedConfigFilePaths: /* @__PURE__ */ new Map(),
            configFileCache: /* @__PURE__ */ new Map(),
            projectStatus: /* @__PURE__ */ new Map(),
            extendedConfigCache: /* @__PURE__ */ new Map(),
            buildInfoCache: /* @__PURE__ */ new Map(),
            outputTimeStamps: /* @__PURE__ */ new Map(),
            builderPrograms: /* @__PURE__ */ new Map(),
            diagnostics: /* @__PURE__ */ new Map(),
            projectPendingBuild: /* @__PURE__ */ new Map(),
            projectErrorsReported: /* @__PURE__ */ new Map(),
            compilerHost,
            moduleResolutionCache,
            typeReferenceDirectiveResolutionCache,
            libraryResolutionCache,
            // Mutable state
            buildOrder: void 0,
            readFileWithCache: (f)=>host.readFile(f),
            projectCompilerOptions: baseCompilerOptions,
            cache: void 0,
            allProjectBuildPending: true,
            needsSummary: true,
            watchAllProjectsPending: watch,
            // Watch state
            watch,
            allWatchedWildcardDirectories: /* @__PURE__ */ new Map(),
            allWatchedInputFiles: /* @__PURE__ */ new Map(),
            allWatchedConfigFiles: /* @__PURE__ */ new Map(),
            allWatchedExtendedConfigFiles: /* @__PURE__ */ new Map(),
            allWatchedPackageJsonFiles: /* @__PURE__ */ new Map(),
            filesWatched: /* @__PURE__ */ new Map(),
            lastCachedPackageJsonLookups: /* @__PURE__ */ new Map(),
            timerToBuildInvalidatedProject: void 0,
            reportFileChangeDetected: false,
            watchFile: watchFile2,
            watchDirectory,
            writeLog
        };
        return state;
    }
    function toPath2(state, fileName) {
        return toPath(fileName, state.compilerHost.getCurrentDirectory(), state.compilerHost.getCanonicalFileName);
    }
    function toResolvedConfigFilePath(state, fileName) {
        const { resolvedConfigFilePaths } = state;
        const path = resolvedConfigFilePaths.get(fileName);
        if (path !== void 0) return path;
        const resolvedPath = toPath2(state, fileName);
        resolvedConfigFilePaths.set(fileName, resolvedPath);
        return resolvedPath;
    }
    function isParsedCommandLine(entry) {
        return !!entry.options;
    }
    function getCachedParsedConfigFile(state, configFilePath) {
        const value1 = state.configFileCache.get(configFilePath);
        return value1 && isParsedCommandLine(value1) ? value1 : void 0;
    }
    function parseConfigFile(state, configFileName, configFilePath) {
        const { configFileCache } = state;
        const value1 = configFileCache.get(configFilePath);
        if (value1) return isParsedCommandLine(value1) ? value1 : void 0;
        mark("SolutionBuilder::beforeConfigFileParsing");
        let diagnostic;
        const { parseConfigFileHost, baseCompilerOptions, baseWatchOptions, extendedConfigCache, host } = state;
        let parsed;
        if (host.getParsedCommandLine) {
            parsed = host.getParsedCommandLine(configFileName);
            if (!parsed) diagnostic = createCompilerDiagnostic(Diagnostics.File_0_not_found, configFileName);
        } else {
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = (d)=>diagnostic = d;
            parsed = getParsedCommandLineOfConfigFile(configFileName, baseCompilerOptions, parseConfigFileHost, extendedConfigCache, baseWatchOptions);
            parseConfigFileHost.onUnRecoverableConfigFileDiagnostic = noop;
        }
        configFileCache.set(configFilePath, parsed || diagnostic);
        mark("SolutionBuilder::afterConfigFileParsing");
        measure("SolutionBuilder::Config file parsing", "SolutionBuilder::beforeConfigFileParsing", "SolutionBuilder::afterConfigFileParsing");
        return parsed;
    }
    function resolveProjectName(state, name) {
        return resolveConfigFileProjectName(resolvePath(state.compilerHost.getCurrentDirectory(), name));
    }
    function createBuildOrder(state, roots) {
        const temporaryMarks = /* @__PURE__ */ new Map();
        const permanentMarks = /* @__PURE__ */ new Map();
        const circularityReportStack = [];
        let buildOrder;
        let circularDiagnostics;
        for (const root of roots)visit(root);
        return circularDiagnostics ? {
            buildOrder: buildOrder || emptyArray,
            circularDiagnostics
        } : buildOrder || emptyArray;
        function visit(configFileName, inCircularContext) {
            const projPath = toResolvedConfigFilePath(state, configFileName);
            if (permanentMarks.has(projPath)) return;
            if (temporaryMarks.has(projPath)) {
                if (!inCircularContext) (circularDiagnostics || (circularDiagnostics = [])).push(createCompilerDiagnostic(Diagnostics.Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0, circularityReportStack.join("\r\n")));
                return;
            }
            temporaryMarks.set(projPath, true);
            circularityReportStack.push(configFileName);
            const parsed = parseConfigFile(state, configFileName, projPath);
            if (parsed && parsed.projectReferences) for (const ref of parsed.projectReferences){
                const resolvedRefPath = resolveProjectName(state, ref.path);
                visit(resolvedRefPath, inCircularContext || ref.circular);
            }
            circularityReportStack.pop();
            permanentMarks.set(projPath, true);
            (buildOrder || (buildOrder = [])).push(configFileName);
        }
    }
    function getBuildOrder(state) {
        return state.buildOrder || createStateBuildOrder(state);
    }
    function createStateBuildOrder(state) {
        const buildOrder = createBuildOrder(state, state.rootNames.map((f)=>resolveProjectName(state, f)));
        state.resolvedConfigFilePaths.clear();
        const currentProjects = new Set(getBuildOrderFromAnyBuildOrder(buildOrder).map((resolved)=>toResolvedConfigFilePath(state, resolved)));
        const noopOnDelete = {
            onDeleteValue: noop
        };
        mutateMapSkippingNewValues(state.configFileCache, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.projectStatus, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.builderPrograms, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.diagnostics, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.projectPendingBuild, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.projectErrorsReported, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.buildInfoCache, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.outputTimeStamps, currentProjects, noopOnDelete);
        mutateMapSkippingNewValues(state.lastCachedPackageJsonLookups, currentProjects, noopOnDelete);
        if (state.watch) {
            mutateMapSkippingNewValues(state.allWatchedConfigFiles, currentProjects, {
                onDeleteValue: closeFileWatcher
            });
            state.allWatchedExtendedConfigFiles.forEach((watcher)=>{
                watcher.projects.forEach((project)=>{
                    if (!currentProjects.has(project)) watcher.projects.delete(project);
                });
                watcher.close();
            });
            mutateMapSkippingNewValues(state.allWatchedWildcardDirectories, currentProjects, {
                onDeleteValue: (existingMap)=>existingMap.forEach(closeFileWatcherOf)
            });
            mutateMapSkippingNewValues(state.allWatchedInputFiles, currentProjects, {
                onDeleteValue: (existingMap)=>existingMap.forEach(closeFileWatcher)
            });
            mutateMapSkippingNewValues(state.allWatchedPackageJsonFiles, currentProjects, {
                onDeleteValue: (existingMap)=>existingMap.forEach(closeFileWatcher)
            });
        }
        return state.buildOrder = buildOrder;
    }
    function getBuildOrderFor(state, project, onlyReferences) {
        const resolvedProject = project && resolveProjectName(state, project);
        const buildOrderFromState = getBuildOrder(state);
        if (isCircularBuildOrder(buildOrderFromState)) return buildOrderFromState;
        if (resolvedProject) {
            const projectPath = toResolvedConfigFilePath(state, resolvedProject);
            const projectIndex = findIndex(buildOrderFromState, (configFileName)=>toResolvedConfigFilePath(state, configFileName) === projectPath);
            if (projectIndex === -1) return void 0;
        }
        const buildOrder = resolvedProject ? createBuildOrder(state, [
            resolvedProject
        ]) : buildOrderFromState;
        Debug.assert(!isCircularBuildOrder(buildOrder));
        Debug.assert(!onlyReferences || resolvedProject !== void 0);
        Debug.assert(!onlyReferences || buildOrder[buildOrder.length - 1] === resolvedProject);
        return onlyReferences ? buildOrder.slice(0, buildOrder.length - 1) : buildOrder;
    }
    function enableCache(state) {
        if (state.cache) disableCache(state);
        const { compilerHost, host } = state;
        const originalReadFileWithCache = state.readFileWithCache;
        const originalGetSourceFile = compilerHost.getSourceFile;
        const { originalReadFile, originalFileExists, originalDirectoryExists, originalCreateDirectory, originalWriteFile, getSourceFileWithCache, readFileWithCache } = changeCompilerHostLikeToUseCache(host, (fileName)=>toPath2(state, fileName), (...args)=>originalGetSourceFile.call(compilerHost, ...args));
        state.readFileWithCache = readFileWithCache;
        compilerHost.getSourceFile = getSourceFileWithCache;
        state.cache = {
            originalReadFile,
            originalFileExists,
            originalDirectoryExists,
            originalCreateDirectory,
            originalWriteFile,
            originalReadFileWithCache,
            originalGetSourceFile
        };
    }
    function disableCache(state) {
        if (!state.cache) return;
        const { cache, host, compilerHost, extendedConfigCache, moduleResolutionCache, typeReferenceDirectiveResolutionCache, libraryResolutionCache } = state;
        host.readFile = cache.originalReadFile;
        host.fileExists = cache.originalFileExists;
        host.directoryExists = cache.originalDirectoryExists;
        host.createDirectory = cache.originalCreateDirectory;
        host.writeFile = cache.originalWriteFile;
        compilerHost.getSourceFile = cache.originalGetSourceFile;
        state.readFileWithCache = cache.originalReadFileWithCache;
        extendedConfigCache.clear();
        moduleResolutionCache == null || moduleResolutionCache.clear();
        typeReferenceDirectiveResolutionCache == null || typeReferenceDirectiveResolutionCache.clear();
        libraryResolutionCache == null || libraryResolutionCache.clear();
        state.cache = void 0;
    }
    function clearProjectStatus(state, resolved) {
        state.projectStatus.delete(resolved);
        state.diagnostics.delete(resolved);
    }
    function addProjToQueue({ projectPendingBuild }, proj, updateLevel) {
        const value1 = projectPendingBuild.get(proj);
        if (value1 === void 0) projectPendingBuild.set(proj, updateLevel);
        else if (value1 < updateLevel) projectPendingBuild.set(proj, updateLevel);
    }
    function setupInitialBuild(state, cancellationToken) {
        if (!state.allProjectBuildPending) return;
        state.allProjectBuildPending = false;
        if (state.options.watch) reportWatchStatus(state, Diagnostics.Starting_compilation_in_watch_mode);
        enableCache(state);
        const buildOrder = getBuildOrderFromAnyBuildOrder(getBuildOrder(state));
        buildOrder.forEach((configFileName)=>state.projectPendingBuild.set(toResolvedConfigFilePath(state, configFileName), 0 /* Update */ ));
        if (cancellationToken) cancellationToken.throwIfCancellationRequested();
    }
    var InvalidatedProjectKind = /* @__PURE__ */ ((InvalidatedProjectKind2)=>{
        InvalidatedProjectKind2[InvalidatedProjectKind2["Build"] = 0] = "Build";
        InvalidatedProjectKind2[InvalidatedProjectKind2["UpdateOutputFileStamps"] = 1] = "UpdateOutputFileStamps";
        return InvalidatedProjectKind2;
    })(InvalidatedProjectKind || {});
    function doneInvalidatedProject(state, projectPath) {
        state.projectPendingBuild.delete(projectPath);
        return state.diagnostics.has(projectPath) ? 1 /* DiagnosticsPresent_OutputsSkipped */  : 0 /* Success */ ;
    }
    function createUpdateOutputFileStampsProject(state, project, projectPath, config, buildOrder) {
        let updateOutputFileStampsPending = true;
        return {
            kind: 1 /* UpdateOutputFileStamps */ ,
            project,
            projectPath,
            buildOrder,
            getCompilerOptions: ()=>config.options,
            getCurrentDirectory: ()=>state.compilerHost.getCurrentDirectory(),
            updateOutputFileStatmps: ()=>{
                updateOutputTimestamps(state, config, projectPath);
                updateOutputFileStampsPending = false;
            },
            done: ()=>{
                if (updateOutputFileStampsPending) updateOutputTimestamps(state, config, projectPath);
                mark("SolutionBuilder::Timestamps only updates");
                return doneInvalidatedProject(state, projectPath);
            }
        };
    }
    function createBuildOrUpdateInvalidedProject(state, project, projectPath, projectIndex, config, status, buildOrder) {
        let step = 0 /* CreateProgram */ ;
        let program;
        let buildResult;
        return {
            kind: 0 /* Build */ ,
            project,
            projectPath,
            buildOrder,
            getCompilerOptions: ()=>config.options,
            getCurrentDirectory: ()=>state.compilerHost.getCurrentDirectory(),
            getBuilderProgram: ()=>withProgramOrUndefined(identity),
            getProgram: ()=>withProgramOrUndefined((program2)=>program2.getProgramOrUndefined()),
            getSourceFile: (fileName)=>withProgramOrUndefined((program2)=>program2.getSourceFile(fileName)),
            getSourceFiles: ()=>withProgramOrEmptyArray((program2)=>program2.getSourceFiles()),
            getOptionsDiagnostics: (cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getOptionsDiagnostics(cancellationToken)),
            getGlobalDiagnostics: (cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getGlobalDiagnostics(cancellationToken)),
            getConfigFileParsingDiagnostics: ()=>withProgramOrEmptyArray((program2)=>program2.getConfigFileParsingDiagnostics()),
            getSyntacticDiagnostics: (sourceFile, cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getSyntacticDiagnostics(sourceFile, cancellationToken)),
            getAllDependencies: (sourceFile)=>withProgramOrEmptyArray((program2)=>program2.getAllDependencies(sourceFile)),
            getSemanticDiagnostics: (sourceFile, cancellationToken)=>withProgramOrEmptyArray((program2)=>program2.getSemanticDiagnostics(sourceFile, cancellationToken)),
            getSemanticDiagnosticsOfNextAffectedFile: (cancellationToken, ignoreSourceFile)=>withProgramOrUndefined((program2)=>program2.getSemanticDiagnosticsOfNextAffectedFile && program2.getSemanticDiagnosticsOfNextAffectedFile(cancellationToken, ignoreSourceFile)),
            emit: (targetSourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers)=>{
                if (targetSourceFile || emitOnlyDtsFiles) return withProgramOrUndefined((program2)=>{
                    var _a, _b;
                    return program2.emit(targetSourceFile, writeFile2, cancellationToken, emitOnlyDtsFiles, customTransformers || ((_b = (_a = state.host).getCustomTransformers) == null ? void 0 : _b.call(_a, project)));
                });
                executeSteps(0 /* CreateProgram */ , cancellationToken);
                return emit(writeFile2, cancellationToken, customTransformers);
            },
            done
        };
        function done(cancellationToken, writeFile2, customTransformers) {
            executeSteps(3 /* Done */ , cancellationToken, writeFile2, customTransformers);
            mark("SolutionBuilder::Projects built");
            return doneInvalidatedProject(state, projectPath);
        }
        function withProgramOrUndefined(action) {
            executeSteps(0 /* CreateProgram */ );
            return program && action(program);
        }
        function withProgramOrEmptyArray(action) {
            return withProgramOrUndefined(action) || emptyArray;
        }
        function createProgram2() {
            var _a, _b, _c;
            Debug.assert(program === void 0);
            if (state.options.dry) {
                reportStatus(state, Diagnostics.A_non_dry_build_would_build_project_0, project);
                buildResult = 1 /* Success */ ;
                step = 2 /* QueueReferencingProjects */ ;
                return;
            }
            if (state.options.verbose) reportStatus(state, Diagnostics.Building_project_0, project);
            if (config.fileNames.length === 0) {
                reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                buildResult = 0 /* None */ ;
                step = 2 /* QueueReferencingProjects */ ;
                return;
            }
            const { host, compilerHost } = state;
            state.projectCompilerOptions = config.options;
            (_a = state.moduleResolutionCache) == null || _a.update(config.options);
            (_b = state.typeReferenceDirectiveResolutionCache) == null || _b.update(config.options);
            program = host.createProgram(config.fileNames, config.options, compilerHost, getOldProgram(state, projectPath, config), getConfigFileParsingDiagnostics(config), config.projectReferences);
            if (state.watch) {
                const internalMap = (_c = state.moduleResolutionCache) == null ? void 0 : _c.getPackageJsonInfoCache().getInternalMap();
                state.lastCachedPackageJsonLookups.set(projectPath, internalMap && new Set(arrayFrom(internalMap.values(), (data)=>state.host.realpath && (isPackageJsonInfo(data) || data.directoryExists) ? state.host.realpath(combinePaths(data.packageDirectory, "package.json")) : combinePaths(data.packageDirectory, "package.json"))));
                state.builderPrograms.set(projectPath, program);
            }
            step++;
        }
        function emit(writeFileCallback, cancellationToken, customTransformers) {
            var _a, _b, _c;
            Debug.assertIsDefined(program);
            Debug.assert(step === 1 /* Emit */ );
            const { host, compilerHost } = state;
            const emittedOutputs = /* @__PURE__ */ new Map();
            const options = program.getCompilerOptions();
            const isIncremental = isIncrementalCompilation(options);
            let outputTimeStampMap;
            let now;
            const { emitResult, diagnostics } = emitFilesAndReportErrors(program, (d)=>host.reportDiagnostic(d), state.write, /*reportSummary*/ void 0, (name, text, writeByteOrderMark, onError, sourceFiles, data)=>{
                var _a2;
                const path = toPath2(state, name);
                emittedOutputs.set(toPath2(state, name), name);
                if (data == null ? void 0 : data.buildInfo) {
                    now || (now = getCurrentTime(state.host));
                    const isChangedSignature2 = (_a2 = program.hasChangedEmitSignature) == null ? void 0 : _a2.call(program);
                    const existing = getBuildInfoCacheEntry(state, name, projectPath);
                    if (existing) {
                        existing.buildInfo = data.buildInfo;
                        existing.modifiedTime = now;
                        if (isChangedSignature2) existing.latestChangedDtsTime = now;
                    } else state.buildInfoCache.set(projectPath, {
                        path: toPath2(state, name),
                        buildInfo: data.buildInfo,
                        modifiedTime: now,
                        latestChangedDtsTime: isChangedSignature2 ? now : void 0
                    });
                }
                const modifiedTime = (data == null ? void 0 : data.differsOnlyInMap) ? getModifiedTime(state.host, name) : void 0;
                (writeFileCallback || compilerHost.writeFile)(name, text, writeByteOrderMark, onError, sourceFiles, data);
                if (data == null ? void 0 : data.differsOnlyInMap) state.host.setModifiedTime(name, modifiedTime);
                else if (!isIncremental && state.watch) (outputTimeStampMap || (outputTimeStampMap = getOutputTimeStampMap(state, projectPath))).set(path, now || (now = getCurrentTime(state.host)));
            }, cancellationToken, /*emitOnlyDtsFiles*/ void 0, customTransformers || ((_b = (_a = state.host).getCustomTransformers) == null ? void 0 : _b.call(_a, project)));
            if ((!options.noEmitOnError || !diagnostics.length) && (emittedOutputs.size || status.type !== 8 /* OutOfDateBuildInfoWithErrors */ )) updateOutputTimestampsWorker(state, config, projectPath, Diagnostics.Updating_unchanged_output_timestamps_of_project_0, emittedOutputs);
            state.projectErrorsReported.set(projectPath, true);
            buildResult = ((_c = program.hasChangedEmitSignature) == null ? void 0 : _c.call(program)) ? 0 /* None */  : 2 /* DeclarationOutputUnchanged */ ;
            if (!diagnostics.length) {
                state.diagnostics.delete(projectPath);
                var _firstOrUndefinedIterator;
                state.projectStatus.set(projectPath, {
                    type: 1 /* UpToDate */ ,
                    oldestOutputFileName: (_firstOrUndefinedIterator = firstOrUndefinedIterator(emittedOutputs.values())) !== null && _firstOrUndefinedIterator !== void 0 ? _firstOrUndefinedIterator : getFirstProjectOutput(config, !host.useCaseSensitiveFileNames())
                });
            } else {
                state.diagnostics.set(projectPath, diagnostics);
                state.projectStatus.set(projectPath, {
                    type: 0 /* Unbuildable */ ,
                    reason: `it had errors`
                });
                buildResult |= 4 /* AnyErrors */ ;
            }
            afterProgramDone(state, program);
            step = 2 /* QueueReferencingProjects */ ;
            return emitResult;
        }
        function executeSteps(till, cancellationToken, writeFile2, customTransformers) {
            while(step <= till && step < 3 /* Done */ ){
                const currentStep = step;
                switch(step){
                    case 0 /* CreateProgram */ :
                        createProgram2();
                        break;
                    case 1 /* Emit */ :
                        emit(writeFile2, cancellationToken, customTransformers);
                        break;
                    case 2 /* QueueReferencingProjects */ :
                        queueReferencingProjects(state, project, projectPath, projectIndex, config, buildOrder, Debug.checkDefined(buildResult));
                        step++;
                        break;
                    // Should never be done
                    case 3 /* Done */ :
                    default:
                        assertType(step);
                }
                Debug.assert(step > currentStep);
            }
        }
    }
    function getNextInvalidatedProjectCreateInfo(state, buildOrder, reportQueue) {
        if (!state.projectPendingBuild.size) return void 0;
        if (isCircularBuildOrder(buildOrder)) return void 0;
        const { options, projectPendingBuild } = state;
        for(let projectIndex = 0; projectIndex < buildOrder.length; projectIndex++){
            const project = buildOrder[projectIndex];
            const projectPath = toResolvedConfigFilePath(state, project);
            const updateLevel = state.projectPendingBuild.get(projectPath);
            if (updateLevel === void 0) continue;
            if (reportQueue) {
                reportQueue = false;
                reportBuildQueue(state, buildOrder);
            }
            const config = parseConfigFile(state, project, projectPath);
            if (!config) {
                reportParseConfigFileDiagnostic(state, projectPath);
                projectPendingBuild.delete(projectPath);
                continue;
            }
            if (updateLevel === 2 /* Full */ ) {
                watchConfigFile(state, project, projectPath, config);
                watchExtendedConfigFiles(state, projectPath, config);
                watchWildCardDirectories(state, project, projectPath, config);
                watchInputFiles(state, project, projectPath, config);
                watchPackageJsonFiles(state, project, projectPath, config);
            } else if (updateLevel === 1 /* RootNamesAndUpdate */ ) {
                config.fileNames = getFileNamesFromConfigSpecs(config.options.configFile.configFileSpecs, getDirectoryPath(project), config.options, state.parseConfigFileHost);
                updateErrorForNoInputFiles(config.fileNames, project, config.options.configFile.configFileSpecs, config.errors, canJsonReportNoInputFiles(config.raw));
                watchInputFiles(state, project, projectPath, config);
                watchPackageJsonFiles(state, project, projectPath, config);
            }
            const status = getUpToDateStatus(state, config, projectPath);
            if (!options.force) {
                if (status.type === 1 /* UpToDate */ ) {
                    verboseReportProjectStatus(state, project, status);
                    reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                    projectPendingBuild.delete(projectPath);
                    if (options.dry) reportStatus(state, Diagnostics.Project_0_is_up_to_date, project);
                    continue;
                }
                if (status.type === 2 /* UpToDateWithUpstreamTypes */  || status.type === 15 /* UpToDateWithInputFileText */ ) {
                    reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                    return {
                        kind: 1 /* UpdateOutputFileStamps */ ,
                        status,
                        project,
                        projectPath,
                        projectIndex,
                        config
                    };
                }
            }
            if (status.type === 12 /* UpstreamBlocked */ ) {
                verboseReportProjectStatus(state, project, status);
                reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                projectPendingBuild.delete(projectPath);
                if (options.verbose) reportStatus(state, status.upstreamProjectBlocked ? Diagnostics.Skipping_build_of_project_0_because_its_dependency_1_was_not_built : Diagnostics.Skipping_build_of_project_0_because_its_dependency_1_has_errors, project, status.upstreamProjectName);
                continue;
            }
            if (status.type === 16 /* ContainerOnly */ ) {
                verboseReportProjectStatus(state, project, status);
                reportAndStoreErrors(state, projectPath, getConfigFileParsingDiagnostics(config));
                projectPendingBuild.delete(projectPath);
                continue;
            }
            return {
                kind: 0 /* Build */ ,
                status,
                project,
                projectPath,
                projectIndex,
                config
            };
        }
        return void 0;
    }
    function createInvalidatedProjectWithInfo(state, info, buildOrder) {
        verboseReportProjectStatus(state, info.project, info.status);
        return info.kind !== 1 /* UpdateOutputFileStamps */  ? createBuildOrUpdateInvalidedProject(state, info.project, info.projectPath, info.projectIndex, info.config, info.status, buildOrder) : createUpdateOutputFileStampsProject(state, info.project, info.projectPath, info.config, buildOrder);
    }
    function getNextInvalidatedProject(state, buildOrder, reportQueue) {
        const info = getNextInvalidatedProjectCreateInfo(state, buildOrder, reportQueue);
        if (!info) return info;
        return createInvalidatedProjectWithInfo(state, info, buildOrder);
    }
    function getOldProgram({ options, builderPrograms, compilerHost }, proj, parsed) {
        if (options.force) return void 0;
        const value1 = builderPrograms.get(proj);
        if (value1) return value1;
        return readBuilderProgram(parsed.options, compilerHost);
    }
    function afterProgramDone(state, program) {
        if (program) {
            if (state.host.afterProgramEmitAndDiagnostics) state.host.afterProgramEmitAndDiagnostics(program);
            program.releaseProgram();
        }
        state.projectCompilerOptions = state.baseCompilerOptions;
    }
    function isFileWatcherWithModifiedTime(value1) {
        return !!value1.watcher;
    }
    function getModifiedTime2(state, fileName) {
        const path = toPath2(state, fileName);
        const existing = state.filesWatched.get(path);
        if (state.watch && !!existing) {
            if (!isFileWatcherWithModifiedTime(existing)) return existing;
            if (existing.modifiedTime) return existing.modifiedTime;
        }
        const result = getModifiedTime(state.host, fileName);
        if (state.watch) {
            if (existing) existing.modifiedTime = result;
            else state.filesWatched.set(path, result);
        }
        return result;
    }
    function watchFile(state, file, callback, pollingInterval, options, watchType, project) {
        const path = toPath2(state, file);
        const existing = state.filesWatched.get(path);
        if (existing && isFileWatcherWithModifiedTime(existing)) existing.callbacks.push(callback);
        else {
            const watcher = state.watchFile(file, (fileName, eventKind, modifiedTime)=>{
                const existing2 = Debug.checkDefined(state.filesWatched.get(path));
                Debug.assert(isFileWatcherWithModifiedTime(existing2));
                existing2.modifiedTime = modifiedTime;
                existing2.callbacks.forEach((cb)=>cb(fileName, eventKind, modifiedTime));
            }, pollingInterval, options, watchType, project);
            state.filesWatched.set(path, {
                callbacks: [
                    callback
                ],
                watcher,
                modifiedTime: existing
            });
        }
        return {
            close: ()=>{
                const existing2 = Debug.checkDefined(state.filesWatched.get(path));
                Debug.assert(isFileWatcherWithModifiedTime(existing2));
                if (existing2.callbacks.length === 1) {
                    state.filesWatched.delete(path);
                    closeFileWatcherOf(existing2);
                } else unorderedRemoveItem(existing2.callbacks, callback);
            }
        };
    }
    function getOutputTimeStampMap(state, resolvedConfigFilePath) {
        if (!state.watch) return void 0;
        let result = state.outputTimeStamps.get(resolvedConfigFilePath);
        if (!result) state.outputTimeStamps.set(resolvedConfigFilePath, result = /* @__PURE__ */ new Map());
        return result;
    }
    function getBuildInfoCacheEntry(state, buildInfoPath, resolvedConfigPath) {
        const path = toPath2(state, buildInfoPath);
        const existing = state.buildInfoCache.get(resolvedConfigPath);
        return (existing == null ? void 0 : existing.path) === path ? existing : void 0;
    }
    function getBuildInfo3(state, buildInfoPath, resolvedConfigPath, modifiedTime) {
        const path = toPath2(state, buildInfoPath);
        const existing = state.buildInfoCache.get(resolvedConfigPath);
        if (existing !== void 0 && existing.path === path) return existing.buildInfo || void 0;
        const value1 = state.readFileWithCache(buildInfoPath);
        const buildInfo = value1 ? getBuildInfo(buildInfoPath, value1) : void 0;
        state.buildInfoCache.set(resolvedConfigPath, {
            path,
            buildInfo: buildInfo || false,
            modifiedTime: modifiedTime || missingFileModifiedTime
        });
        return buildInfo;
    }
    function checkConfigFileUpToDateStatus(state, configFile, oldestOutputFileTime, oldestOutputFileName) {
        const tsconfigTime = getModifiedTime2(state, configFile);
        if (oldestOutputFileTime < tsconfigTime) return {
            type: 5 /* OutOfDateWithSelf */ ,
            outOfDateOutputFileName: oldestOutputFileName,
            newerInputFileName: configFile
        };
    }
    function getUpToDateStatusWorker(state, project, resolvedPath) {
        var _a, _b, _c, _d, _e;
        if (isSolutionConfig(project)) return {
            type: 16 /* ContainerOnly */ 
        };
        let referenceStatuses;
        const force = !!state.options.force;
        if (project.projectReferences) {
            state.projectStatus.set(resolvedPath, {
                type: 13 /* ComputingUpstream */ 
            });
            for (const ref of project.projectReferences){
                const resolvedRef = resolveProjectReferencePath(ref);
                const resolvedRefPath = toResolvedConfigFilePath(state, resolvedRef);
                const resolvedConfig = parseConfigFile(state, resolvedRef, resolvedRefPath);
                const refStatus = getUpToDateStatus(state, resolvedConfig, resolvedRefPath);
                if (refStatus.type === 13 /* ComputingUpstream */  || refStatus.type === 16 /* ContainerOnly */ ) continue;
                if (state.options.stopBuildOnErrors && (refStatus.type === 0 /* Unbuildable */  || refStatus.type === 12 /* UpstreamBlocked */ )) return {
                    type: 12 /* UpstreamBlocked */ ,
                    upstreamProjectName: ref.path,
                    upstreamProjectBlocked: refStatus.type === 12 /* UpstreamBlocked */ 
                };
                if (!force) (referenceStatuses || (referenceStatuses = [])).push({
                    ref,
                    refStatus,
                    resolvedRefPath,
                    resolvedConfig
                });
            }
        }
        if (force) return {
            type: 17 /* ForceBuild */ 
        };
        const { host } = state;
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(project.options);
        const isIncremental = isIncrementalCompilation(project.options);
        let buildInfoCacheEntry = getBuildInfoCacheEntry(state, buildInfoPath, resolvedPath);
        const buildInfoTime = (buildInfoCacheEntry == null ? void 0 : buildInfoCacheEntry.modifiedTime) || getModifiedTime(host, buildInfoPath);
        if (buildInfoTime === missingFileModifiedTime) {
            if (!buildInfoCacheEntry) state.buildInfoCache.set(resolvedPath, {
                path: toPath2(state, buildInfoPath),
                buildInfo: false,
                modifiedTime: buildInfoTime
            });
            return {
                type: 3 /* OutputMissing */ ,
                missingOutputFileName: buildInfoPath
            };
        }
        const buildInfo = getBuildInfo3(state, buildInfoPath, resolvedPath, buildInfoTime);
        if (!buildInfo) return {
            type: 4 /* ErrorReadingFile */ ,
            fileName: buildInfoPath
        };
        const incrementalBuildInfo = isIncremental && isIncrementalBuildInfo(buildInfo) ? buildInfo : void 0;
        if ((incrementalBuildInfo || !isIncremental) && buildInfo.version !== version) return {
            type: 14 /* TsVersionOutputOfDate */ ,
            version: buildInfo.version
        };
        if (!project.options.noCheck && (buildInfo.errors || // TODO: syntax errors????
        buildInfo.checkPending)) return {
            type: 8 /* OutOfDateBuildInfoWithErrors */ ,
            buildInfoFile: buildInfoPath
        };
        if (incrementalBuildInfo) {
            if (!project.options.noCheck && (((_a = incrementalBuildInfo.changeFileSet) == null ? void 0 : _a.length) || ((_b = incrementalBuildInfo.semanticDiagnosticsPerFile) == null ? void 0 : _b.length) || getEmitDeclarations(project.options) && ((_c = incrementalBuildInfo.emitDiagnosticsPerFile) == null ? void 0 : _c.length))) return {
                type: 8 /* OutOfDateBuildInfoWithErrors */ ,
                buildInfoFile: buildInfoPath
            };
            if (!project.options.noEmit && (((_d = incrementalBuildInfo.changeFileSet) == null ? void 0 : _d.length) || ((_e = incrementalBuildInfo.affectedFilesPendingEmit) == null ? void 0 : _e.length) || incrementalBuildInfo.pendingEmit !== void 0)) return {
                type: 7 /* OutOfDateBuildInfoWithPendingEmit */ ,
                buildInfoFile: buildInfoPath
            };
            if ((!project.options.noEmit || project.options.noEmit && getEmitDeclarations(project.options)) && getPendingEmitKindWithSeen(project.options, incrementalBuildInfo.options || {}, /*emitOnlyDtsFiles*/ void 0, !!project.options.noEmit)) return {
                type: 9 /* OutOfDateOptions */ ,
                buildInfoFile: buildInfoPath
            };
        }
        let oldestOutputFileTime = buildInfoTime;
        let oldestOutputFileName = buildInfoPath;
        let newestInputFileName = void 0;
        let newestInputFileTime = minimumDate;
        let pseudoInputUpToDate = false;
        const seenRoots = /* @__PURE__ */ new Set();
        let buildInfoVersionMap;
        for (const inputFile of project.fileNames){
            const inputTime = getModifiedTime2(state, inputFile);
            if (inputTime === missingFileModifiedTime) return {
                type: 0 /* Unbuildable */ ,
                reason: `${inputFile} does not exist`
            };
            const inputPath = toPath2(state, inputFile);
            if (buildInfoTime < inputTime) {
                let version2;
                let currentVersion;
                if (incrementalBuildInfo) {
                    if (!buildInfoVersionMap) buildInfoVersionMap = getBuildInfoFileVersionMap(incrementalBuildInfo, buildInfoPath, host);
                    const resolvedInputPath = buildInfoVersionMap.roots.get(inputPath);
                    version2 = buildInfoVersionMap.fileInfos.get(resolvedInputPath !== null && resolvedInputPath !== void 0 ? resolvedInputPath : inputPath);
                    const text = version2 ? state.readFileWithCache(resolvedInputPath !== null && resolvedInputPath !== void 0 ? resolvedInputPath : inputFile) : void 0;
                    currentVersion = text !== void 0 ? getSourceFileVersionAsHashFromText(host, text) : void 0;
                    if (version2 && version2 === currentVersion) pseudoInputUpToDate = true;
                }
                if (!version2 || version2 !== currentVersion) return {
                    type: 5 /* OutOfDateWithSelf */ ,
                    outOfDateOutputFileName: buildInfoPath,
                    newerInputFileName: inputFile
                };
            }
            if (inputTime > newestInputFileTime) {
                newestInputFileName = inputFile;
                newestInputFileTime = inputTime;
            }
            seenRoots.add(inputPath);
        }
        let existingRoot;
        if (incrementalBuildInfo) {
            if (!buildInfoVersionMap) buildInfoVersionMap = getBuildInfoFileVersionMap(incrementalBuildInfo, buildInfoPath, host);
            existingRoot = forEachEntry(buildInfoVersionMap.roots, // File was root file when project was built but its not any more
            (_resolved, existingRoot2)=>!seenRoots.has(existingRoot2) ? existingRoot2 : void 0);
        } else existingRoot = forEach(getNonIncrementalBuildInfoRoots(buildInfo, buildInfoPath, host), (root)=>!seenRoots.has(root) ? root : void 0);
        if (existingRoot) return {
            type: 10 /* OutOfDateRoots */ ,
            buildInfoFile: buildInfoPath,
            inputFile: existingRoot
        };
        if (!isIncremental) {
            const outputs = getAllProjectOutputs(project, !host.useCaseSensitiveFileNames());
            const outputTimeStampMap = getOutputTimeStampMap(state, resolvedPath);
            for (const output of outputs){
                if (output === buildInfoPath) continue;
                const path = toPath2(state, output);
                let outputTime = outputTimeStampMap == null ? void 0 : outputTimeStampMap.get(path);
                if (!outputTime) {
                    outputTime = getModifiedTime(state.host, output);
                    outputTimeStampMap == null || outputTimeStampMap.set(path, outputTime);
                }
                if (outputTime === missingFileModifiedTime) return {
                    type: 3 /* OutputMissing */ ,
                    missingOutputFileName: output
                };
                if (outputTime < newestInputFileTime) return {
                    type: 5 /* OutOfDateWithSelf */ ,
                    outOfDateOutputFileName: output,
                    newerInputFileName: newestInputFileName
                };
                if (outputTime < oldestOutputFileTime) {
                    oldestOutputFileTime = outputTime;
                    oldestOutputFileName = output;
                }
            }
        }
        let pseudoUpToDate = false;
        if (referenceStatuses) for (const { ref, refStatus, resolvedConfig, resolvedRefPath } of referenceStatuses){
            if (refStatus.newestInputFileTime && refStatus.newestInputFileTime <= oldestOutputFileTime) continue;
            if (hasSameBuildInfo(state, buildInfoCacheEntry !== null && buildInfoCacheEntry !== void 0 ? buildInfoCacheEntry : buildInfoCacheEntry = state.buildInfoCache.get(resolvedPath), resolvedRefPath)) return {
                type: 6 /* OutOfDateWithUpstream */ ,
                outOfDateOutputFileName: buildInfoPath,
                newerProjectName: ref.path
            };
            const newestDeclarationFileContentChangedTime = getLatestChangedDtsTime(state, resolvedConfig.options, resolvedRefPath);
            if (newestDeclarationFileContentChangedTime && newestDeclarationFileContentChangedTime <= oldestOutputFileTime) {
                pseudoUpToDate = true;
                continue;
            }
            Debug.assert(oldestOutputFileName !== void 0, "Should have an oldest output filename here");
            return {
                type: 6 /* OutOfDateWithUpstream */ ,
                outOfDateOutputFileName: oldestOutputFileName,
                newerProjectName: ref.path
            };
        }
        const configStatus = checkConfigFileUpToDateStatus(state, project.options.configFilePath, oldestOutputFileTime, oldestOutputFileName);
        if (configStatus) return configStatus;
        const extendedConfigStatus = forEach(project.options.configFile.extendedSourceFiles || emptyArray, (configFile)=>checkConfigFileUpToDateStatus(state, configFile, oldestOutputFileTime, oldestOutputFileName));
        if (extendedConfigStatus) return extendedConfigStatus;
        const packageJsonLookups = state.lastCachedPackageJsonLookups.get(resolvedPath);
        const dependentPackageFileStatus = packageJsonLookups && forEachKey(packageJsonLookups, (path)=>checkConfigFileUpToDateStatus(state, path, oldestOutputFileTime, oldestOutputFileName));
        if (dependentPackageFileStatus) return dependentPackageFileStatus;
        return {
            type: pseudoUpToDate ? 2 /* UpToDateWithUpstreamTypes */  : pseudoInputUpToDate ? 15 /* UpToDateWithInputFileText */  : 1 /* UpToDate */ ,
            newestInputFileTime,
            newestInputFileName,
            oldestOutputFileName
        };
    }
    function hasSameBuildInfo(state, buildInfoCacheEntry, resolvedRefPath) {
        const refBuildInfo = state.buildInfoCache.get(resolvedRefPath);
        return refBuildInfo.path === buildInfoCacheEntry.path;
    }
    function getUpToDateStatus(state, project, resolvedPath) {
        if (project === void 0) return {
            type: 0 /* Unbuildable */ ,
            reason: "config file deleted mid-build"
        };
        const prior = state.projectStatus.get(resolvedPath);
        if (prior !== void 0) return prior;
        mark("SolutionBuilder::beforeUpToDateCheck");
        const actual = getUpToDateStatusWorker(state, project, resolvedPath);
        mark("SolutionBuilder::afterUpToDateCheck");
        measure("SolutionBuilder::Up-to-date check", "SolutionBuilder::beforeUpToDateCheck", "SolutionBuilder::afterUpToDateCheck");
        state.projectStatus.set(resolvedPath, actual);
        return actual;
    }
    function updateOutputTimestampsWorker(state, proj, projectPath, verboseMessage, skipOutputs) {
        if (proj.options.noEmit) return;
        let now;
        const buildInfoPath = getTsBuildInfoEmitOutputFilePath(proj.options);
        const isIncremental = isIncrementalCompilation(proj.options);
        if (buildInfoPath && isIncremental) {
            if (!(skipOutputs == null ? void 0 : skipOutputs.has(toPath2(state, buildInfoPath)))) {
                if (!!state.options.verbose) reportStatus(state, verboseMessage, proj.options.configFilePath);
                state.host.setModifiedTime(buildInfoPath, now = getCurrentTime(state.host));
                getBuildInfoCacheEntry(state, buildInfoPath, projectPath).modifiedTime = now;
            }
            state.outputTimeStamps.delete(projectPath);
            return;
        }
        const { host } = state;
        const outputs = getAllProjectOutputs(proj, !host.useCaseSensitiveFileNames());
        const outputTimeStampMap = getOutputTimeStampMap(state, projectPath);
        const modifiedOutputs = outputTimeStampMap ? /* @__PURE__ */ new Set() : void 0;
        if (!skipOutputs || outputs.length !== skipOutputs.size) {
            let reportVerbose = !!state.options.verbose;
            for (const file of outputs){
                const path = toPath2(state, file);
                if (skipOutputs == null ? void 0 : skipOutputs.has(path)) continue;
                if (reportVerbose) {
                    reportVerbose = false;
                    reportStatus(state, verboseMessage, proj.options.configFilePath);
                }
                host.setModifiedTime(file, now || (now = getCurrentTime(state.host)));
                if (file === buildInfoPath) getBuildInfoCacheEntry(state, buildInfoPath, projectPath).modifiedTime = now;
                else if (outputTimeStampMap) {
                    outputTimeStampMap.set(path, now);
                    modifiedOutputs.add(path);
                }
            }
        }
        outputTimeStampMap == null || outputTimeStampMap.forEach((_value, key)=>{
            if (!(skipOutputs == null ? void 0 : skipOutputs.has(key)) && !modifiedOutputs.has(key)) outputTimeStampMap.delete(key);
        });
    }
    function getLatestChangedDtsTime(state, options, resolvedConfigPath) {
        if (!options.composite) return void 0;
        const entry = Debug.checkDefined(state.buildInfoCache.get(resolvedConfigPath));
        if (entry.latestChangedDtsTime !== void 0) return entry.latestChangedDtsTime || void 0;
        const latestChangedDtsTime = entry.buildInfo && isIncrementalBuildInfo(entry.buildInfo) && entry.buildInfo.latestChangedDtsFile ? state.host.getModifiedTime(getNormalizedAbsolutePath(entry.buildInfo.latestChangedDtsFile, getDirectoryPath(entry.path))) : void 0;
        entry.latestChangedDtsTime = latestChangedDtsTime || false;
        return latestChangedDtsTime;
    }
    function updateOutputTimestamps(state, proj, resolvedPath) {
        if (state.options.dry) return reportStatus(state, Diagnostics.A_non_dry_build_would_update_timestamps_for_output_of_project_0, proj.options.configFilePath);
        updateOutputTimestampsWorker(state, proj, resolvedPath, Diagnostics.Updating_output_timestamps_of_project_0);
        state.projectStatus.set(resolvedPath, {
            type: 1 /* UpToDate */ ,
            oldestOutputFileName: getFirstProjectOutput(proj, !state.host.useCaseSensitiveFileNames())
        });
    }
    function queueReferencingProjects(state, project, projectPath, projectIndex, config, buildOrder, buildResult) {
        if (state.options.stopBuildOnErrors && buildResult & 4 /* AnyErrors */ ) return;
        if (!config.options.composite) return;
        for(let index = projectIndex + 1; index < buildOrder.length; index++){
            const nextProject = buildOrder[index];
            const nextProjectPath = toResolvedConfigFilePath(state, nextProject);
            if (state.projectPendingBuild.has(nextProjectPath)) continue;
            const nextProjectConfig = parseConfigFile(state, nextProject, nextProjectPath);
            if (!nextProjectConfig || !nextProjectConfig.projectReferences) continue;
            for (const ref of nextProjectConfig.projectReferences){
                const resolvedRefPath = resolveProjectName(state, ref.path);
                if (toResolvedConfigFilePath(state, resolvedRefPath) !== projectPath) continue;
                const status = state.projectStatus.get(nextProjectPath);
                if (status) switch(status.type){
                    case 1 /* UpToDate */ :
                        if (buildResult & 2 /* DeclarationOutputUnchanged */ ) {
                            status.type = 2 /* UpToDateWithUpstreamTypes */ ;
                            break;
                        }
                    // falls through
                    case 15 /* UpToDateWithInputFileText */ :
                    case 2 /* UpToDateWithUpstreamTypes */ :
                        if (!(buildResult & 2 /* DeclarationOutputUnchanged */ )) state.projectStatus.set(nextProjectPath, {
                            type: 6 /* OutOfDateWithUpstream */ ,
                            outOfDateOutputFileName: status.oldestOutputFileName,
                            newerProjectName: project
                        });
                        break;
                    case 12 /* UpstreamBlocked */ :
                        if (toResolvedConfigFilePath(state, resolveProjectName(state, status.upstreamProjectName)) === projectPath) clearProjectStatus(state, nextProjectPath);
                        break;
                }
                addProjToQueue(state, nextProjectPath, 0 /* Update */ );
                break;
            }
        }
    }
    function build(state, project, cancellationToken, writeFile2, getCustomTransformers, onlyReferences) {
        mark("SolutionBuilder::beforeBuild");
        const result = buildWorker(state, project, cancellationToken, writeFile2, getCustomTransformers, onlyReferences);
        mark("SolutionBuilder::afterBuild");
        measure("SolutionBuilder::Build", "SolutionBuilder::beforeBuild", "SolutionBuilder::afterBuild");
        return result;
    }
    function buildWorker(state, project, cancellationToken, writeFile2, getCustomTransformers, onlyReferences) {
        const buildOrder = getBuildOrderFor(state, project, onlyReferences);
        if (!buildOrder) return 3 /* InvalidProject_OutputsSkipped */ ;
        setupInitialBuild(state, cancellationToken);
        let reportQueue = true;
        let successfulProjects = 0;
        while(true){
            const invalidatedProject = getNextInvalidatedProject(state, buildOrder, reportQueue);
            if (!invalidatedProject) break;
            reportQueue = false;
            invalidatedProject.done(cancellationToken, writeFile2, getCustomTransformers == null ? void 0 : getCustomTransformers(invalidatedProject.project));
            if (!state.diagnostics.has(invalidatedProject.projectPath)) successfulProjects++;
        }
        disableCache(state);
        reportErrorSummary(state, buildOrder);
        startWatching(state, buildOrder);
        return isCircularBuildOrder(buildOrder) ? 4 /* ProjectReferenceCycle_OutputsSkipped */  : !buildOrder.some((p)=>state.diagnostics.has(toResolvedConfigFilePath(state, p))) ? 0 /* Success */  : successfulProjects ? 2 /* DiagnosticsPresent_OutputsGenerated */  : 1 /* DiagnosticsPresent_OutputsSkipped */ ;
    }
    function clean(state, project, onlyReferences) {
        mark("SolutionBuilder::beforeClean");
        const result = cleanWorker(state, project, onlyReferences);
        mark("SolutionBuilder::afterClean");
        measure("SolutionBuilder::Clean", "SolutionBuilder::beforeClean", "SolutionBuilder::afterClean");
        return result;
    }
    function cleanWorker(state, project, onlyReferences) {
        const buildOrder = getBuildOrderFor(state, project, onlyReferences);
        if (!buildOrder) return 3 /* InvalidProject_OutputsSkipped */ ;
        if (isCircularBuildOrder(buildOrder)) {
            reportErrors(state, buildOrder.circularDiagnostics);
            return 4 /* ProjectReferenceCycle_OutputsSkipped */ ;
        }
        const { options, host } = state;
        const filesToDelete = options.dry ? [] : void 0;
        for (const proj of buildOrder){
            const resolvedPath = toResolvedConfigFilePath(state, proj);
            const parsed = parseConfigFile(state, proj, resolvedPath);
            if (parsed === void 0) {
                reportParseConfigFileDiagnostic(state, resolvedPath);
                continue;
            }
            const outputs = getAllProjectOutputs(parsed, !host.useCaseSensitiveFileNames());
            if (!outputs.length) continue;
            const inputFileNames = new Set(parsed.fileNames.map((f)=>toPath2(state, f)));
            for (const output of outputs){
                if (inputFileNames.has(toPath2(state, output))) continue;
                if (host.fileExists(output)) {
                    if (filesToDelete) filesToDelete.push(output);
                    else {
                        host.deleteFile(output);
                        invalidateProject(state, resolvedPath, 0 /* Update */ );
                    }
                }
            }
        }
        if (filesToDelete) reportStatus(state, Diagnostics.A_non_dry_build_would_delete_the_following_files_Colon_0, filesToDelete.map((f)=>`\r
 * ${f}`).join(""));
        return 0 /* Success */ ;
    }
    function invalidateProject(state, resolved, updateLevel) {
        if (state.host.getParsedCommandLine && updateLevel === 1 /* RootNamesAndUpdate */ ) updateLevel = 2 /* Full */ ;
        if (updateLevel === 2 /* Full */ ) {
            state.configFileCache.delete(resolved);
            state.buildOrder = void 0;
        }
        state.needsSummary = true;
        clearProjectStatus(state, resolved);
        addProjToQueue(state, resolved, updateLevel);
        enableCache(state);
    }
    function invalidateProjectAndScheduleBuilds(state, resolvedPath, updateLevel) {
        state.reportFileChangeDetected = true;
        invalidateProject(state, resolvedPath, updateLevel);
        scheduleBuildInvalidatedProject(state, 250, /*changeDetected*/ true);
    }
    function scheduleBuildInvalidatedProject(state, time, changeDetected) {
        const { hostWithWatch } = state;
        if (!hostWithWatch.setTimeout || !hostWithWatch.clearTimeout) return;
        if (state.timerToBuildInvalidatedProject) hostWithWatch.clearTimeout(state.timerToBuildInvalidatedProject);
        state.timerToBuildInvalidatedProject = hostWithWatch.setTimeout(buildNextInvalidatedProject, time, "timerToBuildInvalidatedProject", state, changeDetected);
    }
    function buildNextInvalidatedProject(_timeoutType, state, changeDetected) {
        mark("SolutionBuilder::beforeBuild");
        const buildOrder = buildNextInvalidatedProjectWorker(state, changeDetected);
        mark("SolutionBuilder::afterBuild");
        measure("SolutionBuilder::Build", "SolutionBuilder::beforeBuild", "SolutionBuilder::afterBuild");
        if (buildOrder) reportErrorSummary(state, buildOrder);
    }
    function buildNextInvalidatedProjectWorker(state, changeDetected) {
        state.timerToBuildInvalidatedProject = void 0;
        if (state.reportFileChangeDetected) {
            state.reportFileChangeDetected = false;
            state.projectErrorsReported.clear();
            reportWatchStatus(state, Diagnostics.File_change_detected_Starting_incremental_compilation);
        }
        let projectsBuilt = 0;
        const buildOrder = getBuildOrder(state);
        const invalidatedProject = getNextInvalidatedProject(state, buildOrder, /*reportQueue*/ false);
        if (invalidatedProject) {
            invalidatedProject.done();
            projectsBuilt++;
            while(state.projectPendingBuild.size){
                if (state.timerToBuildInvalidatedProject) return;
                const info = getNextInvalidatedProjectCreateInfo(state, buildOrder, /*reportQueue*/ false);
                if (!info) break;
                if (info.kind !== 1 /* UpdateOutputFileStamps */  && (changeDetected || projectsBuilt === 5)) {
                    scheduleBuildInvalidatedProject(state, 100, /*changeDetected*/ false);
                    return;
                }
                const project = createInvalidatedProjectWithInfo(state, info, buildOrder);
                project.done();
                if (info.kind !== 1 /* UpdateOutputFileStamps */ ) projectsBuilt++;
            }
        }
        disableCache(state);
        return buildOrder;
    }
    function watchConfigFile(state, resolved, resolvedPath, parsed) {
        if (!state.watch || state.allWatchedConfigFiles.has(resolvedPath)) return;
        state.allWatchedConfigFiles.set(resolvedPath, watchFile(state, resolved, ()=>invalidateProjectAndScheduleBuilds(state, resolvedPath, 2 /* Full */ ), 2e3 /* High */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.ConfigFile, resolved));
    }
    function watchExtendedConfigFiles(state, resolvedPath, parsed) {
        updateSharedExtendedConfigFileWatcher(resolvedPath, parsed == null ? void 0 : parsed.options, state.allWatchedExtendedConfigFiles, (extendedConfigFileName, extendedConfigFilePath)=>watchFile(state, extendedConfigFileName, ()=>{
                var _a;
                return (_a = state.allWatchedExtendedConfigFiles.get(extendedConfigFilePath)) == null ? void 0 : _a.projects.forEach((projectConfigFilePath)=>invalidateProjectAndScheduleBuilds(state, projectConfigFilePath, 2 /* Full */ ));
            }, 2e3 /* High */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.ExtendedConfigFile), (fileName)=>toPath2(state, fileName));
    }
    function watchWildCardDirectories(state, resolved, resolvedPath, parsed) {
        if (!state.watch) return;
        updateWatchingWildcardDirectories(getOrCreateValueMapFromConfigFileMap(state.allWatchedWildcardDirectories, resolvedPath), parsed.wildcardDirectories, (dir, flags)=>state.watchDirectory(dir, (fileOrDirectory)=>{
                var _a;
                if (isIgnoredFileFromWildCardWatching({
                    watchedDirPath: toPath2(state, dir),
                    fileOrDirectory,
                    fileOrDirectoryPath: toPath2(state, fileOrDirectory),
                    configFileName: resolved,
                    currentDirectory: state.compilerHost.getCurrentDirectory(),
                    options: parsed.options,
                    program: state.builderPrograms.get(resolvedPath) || ((_a = getCachedParsedConfigFile(state, resolvedPath)) == null ? void 0 : _a.fileNames),
                    useCaseSensitiveFileNames: state.parseConfigFileHost.useCaseSensitiveFileNames,
                    writeLog: (s)=>state.writeLog(s),
                    toPath: (fileName)=>toPath2(state, fileName)
                })) return;
                invalidateProjectAndScheduleBuilds(state, resolvedPath, 1 /* RootNamesAndUpdate */ );
            }, flags, parsed == null ? void 0 : parsed.watchOptions, WatchType.WildcardDirectory, resolved));
    }
    function watchInputFiles(state, resolved, resolvedPath, parsed) {
        if (!state.watch) return;
        mutateMap(getOrCreateValueMapFromConfigFileMap(state.allWatchedInputFiles, resolvedPath), new Set(parsed.fileNames), {
            createNewValue: (input)=>watchFile(state, input, ()=>invalidateProjectAndScheduleBuilds(state, resolvedPath, 0 /* Update */ ), 250 /* Low */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.SourceFile, resolved),
            onDeleteValue: closeFileWatcher
        });
    }
    function watchPackageJsonFiles(state, resolved, resolvedPath, parsed) {
        if (!state.watch || !state.lastCachedPackageJsonLookups) return;
        mutateMap(getOrCreateValueMapFromConfigFileMap(state.allWatchedPackageJsonFiles, resolvedPath), state.lastCachedPackageJsonLookups.get(resolvedPath), {
            createNewValue: (input)=>watchFile(state, input, ()=>invalidateProjectAndScheduleBuilds(state, resolvedPath, 0 /* Update */ ), 2e3 /* High */ , parsed == null ? void 0 : parsed.watchOptions, WatchType.PackageJson, resolved),
            onDeleteValue: closeFileWatcher
        });
    }
    function startWatching(state, buildOrder) {
        if (!state.watchAllProjectsPending) return;
        mark("SolutionBuilder::beforeWatcherCreation");
        state.watchAllProjectsPending = false;
        for (const resolved of getBuildOrderFromAnyBuildOrder(buildOrder)){
            const resolvedPath = toResolvedConfigFilePath(state, resolved);
            const cfg = parseConfigFile(state, resolved, resolvedPath);
            watchConfigFile(state, resolved, resolvedPath, cfg);
            watchExtendedConfigFiles(state, resolvedPath, cfg);
            if (cfg) {
                watchWildCardDirectories(state, resolved, resolvedPath, cfg);
                watchInputFiles(state, resolved, resolvedPath, cfg);
                watchPackageJsonFiles(state, resolved, resolvedPath, cfg);
            }
        }
        mark("SolutionBuilder::afterWatcherCreation");
        measure("SolutionBuilder::Watcher creation", "SolutionBuilder::beforeWatcherCreation", "SolutionBuilder::afterWatcherCreation");
    }
    function stopWatching(state) {
        clearMap(state.allWatchedConfigFiles, closeFileWatcher);
        clearMap(state.allWatchedExtendedConfigFiles, closeFileWatcherOf);
        clearMap(state.allWatchedWildcardDirectories, (watchedWildcardDirectories)=>clearMap(watchedWildcardDirectories, closeFileWatcherOf));
        clearMap(state.allWatchedInputFiles, (watchedWildcardDirectories)=>clearMap(watchedWildcardDirectories, closeFileWatcher));
        clearMap(state.allWatchedPackageJsonFiles, (watchedPacageJsonFiles)=>clearMap(watchedPacageJsonFiles, closeFileWatcher));
    }
    function createSolutionBuilderWorker(watch, hostOrHostWithWatch, rootNames, options, baseWatchOptions) {
        const state = createSolutionBuilderState(watch, hostOrHostWithWatch, rootNames, options, baseWatchOptions);
        return {
            build: (project, cancellationToken, writeFile2, getCustomTransformers)=>build(state, project, cancellationToken, writeFile2, getCustomTransformers),
            clean: (project)=>clean(state, project),
            buildReferences: (project, cancellationToken, writeFile2, getCustomTransformers)=>build(state, project, cancellationToken, writeFile2, getCustomTransformers, /*onlyReferences*/ true),
            cleanReferences: (project)=>clean(state, project, /*onlyReferences*/ true),
            getNextInvalidatedProject: (cancellationToken)=>{
                setupInitialBuild(state, cancellationToken);
                return getNextInvalidatedProject(state, getBuildOrder(state), /*reportQueue*/ false);
            },
            getBuildOrder: ()=>getBuildOrder(state),
            getUpToDateStatusOfProject: (project)=>{
                const configFileName = resolveProjectName(state, project);
                const configFilePath = toResolvedConfigFilePath(state, configFileName);
                return getUpToDateStatus(state, parseConfigFile(state, configFileName, configFilePath), configFilePath);
            },
            invalidateProject: (configFilePath, updateLevel)=>invalidateProject(state, configFilePath, updateLevel || 0 /* Update */ ),
            close: ()=>stopWatching(state)
        };
    }
    function relName(state, path) {
        return convertToRelativePath(path, state.compilerHost.getCurrentDirectory(), state.compilerHost.getCanonicalFileName);
    }
    function reportStatus(state, message, ...args) {
        state.host.reportSolutionBuilderStatus(createCompilerDiagnostic(message, ...args));
    }
    function reportWatchStatus(state, message, ...args) {
        var _a, _b;
        (_b = (_a = state.hostWithWatch).onWatchStatusChange) == null || _b.call(_a, createCompilerDiagnostic(message, ...args), state.host.getNewLine(), state.baseCompilerOptions);
    }
    function reportErrors({ host }, errors) {
        errors.forEach((err)=>host.reportDiagnostic(err));
    }
    function reportAndStoreErrors(state, proj, errors) {
        reportErrors(state, errors);
        state.projectErrorsReported.set(proj, true);
        if (errors.length) state.diagnostics.set(proj, errors);
    }
    function reportParseConfigFileDiagnostic(state, proj) {
        reportAndStoreErrors(state, proj, [
            state.configFileCache.get(proj)
        ]);
    }
    function reportErrorSummary(state, buildOrder) {
        if (!state.needsSummary) return;
        state.needsSummary = false;
        const canReportSummary = state.watch || !!state.host.reportErrorSummary;
        const { diagnostics } = state;
        let totalErrors = 0;
        let filesInError = [];
        if (isCircularBuildOrder(buildOrder)) {
            reportBuildQueue(state, buildOrder.buildOrder);
            reportErrors(state, buildOrder.circularDiagnostics);
            if (canReportSummary) totalErrors += getErrorCountForSummary(buildOrder.circularDiagnostics);
            if (canReportSummary) filesInError = [
                ...filesInError,
                ...getFilesInErrorForSummary(buildOrder.circularDiagnostics)
            ];
        } else {
            buildOrder.forEach((project)=>{
                const projectPath = toResolvedConfigFilePath(state, project);
                if (!state.projectErrorsReported.has(projectPath)) reportErrors(state, diagnostics.get(projectPath) || emptyArray);
            });
            if (canReportSummary) diagnostics.forEach((singleProjectErrors)=>totalErrors += getErrorCountForSummary(singleProjectErrors));
            if (canReportSummary) diagnostics.forEach((singleProjectErrors)=>[
                    ...filesInError,
                    ...getFilesInErrorForSummary(singleProjectErrors)
                ]);
        }
        if (state.watch) reportWatchStatus(state, getWatchErrorSummaryDiagnosticMessage(totalErrors), totalErrors);
        else if (state.host.reportErrorSummary) state.host.reportErrorSummary(totalErrors, filesInError);
    }
    function reportBuildQueue(state, buildQueue) {
        if (state.options.verbose) reportStatus(state, Diagnostics.Projects_in_this_build_Colon_0, buildQueue.map((s)=>"\r\n    * " + relName(state, s)).join(""));
    }
    function reportUpToDateStatus(state, configFileName, status) {
        switch(status.type){
            case 5 /* OutOfDateWithSelf */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_1_is_older_than_input_2, relName(state, configFileName), relName(state, status.outOfDateOutputFileName), relName(state, status.newerInputFileName));
            case 6 /* OutOfDateWithUpstream */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_1_is_older_than_input_2, relName(state, configFileName), relName(state, status.outOfDateOutputFileName), relName(state, status.newerProjectName));
            case 3 /* OutputMissing */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_file_1_does_not_exist, relName(state, configFileName), relName(state, status.missingOutputFileName));
            case 4 /* ErrorReadingFile */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_there_was_error_reading_file_1, relName(state, configFileName), relName(state, status.fileName));
            case 7 /* OutOfDateBuildInfoWithPendingEmit */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_some_of_the_changes_were_not_emitted, relName(state, configFileName), relName(state, status.buildInfoFile));
            case 8 /* OutOfDateBuildInfoWithErrors */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_program_needs_to_report_errors, relName(state, configFileName), relName(state, status.buildInfoFile));
            case 9 /* OutOfDateOptions */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_there_is_change_in_compilerOptions, relName(state, configFileName), relName(state, status.buildInfoFile));
            case 10 /* OutOfDateRoots */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_buildinfo_file_1_indicates_that_file_2_was_root_file_of_compilation_but_not_any_more, relName(state, configFileName), relName(state, status.buildInfoFile), relName(state, status.inputFile));
            case 1 /* UpToDate */ :
                if (status.newestInputFileTime !== void 0) return reportStatus(state, Diagnostics.Project_0_is_up_to_date_because_newest_input_1_is_older_than_output_2, relName(state, configFileName), relName(state, status.newestInputFileName || ""), relName(state, status.oldestOutputFileName || ""));
                break;
            case 2 /* UpToDateWithUpstreamTypes */ :
                return reportStatus(state, Diagnostics.Project_0_is_up_to_date_with_d_ts_files_from_its_dependencies, relName(state, configFileName));
            case 15 /* UpToDateWithInputFileText */ :
                return reportStatus(state, Diagnostics.Project_0_is_up_to_date_but_needs_to_update_timestamps_of_output_files_that_are_older_than_input_files, relName(state, configFileName));
            case 11 /* UpstreamOutOfDate */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_its_dependency_1_is_out_of_date, relName(state, configFileName), relName(state, status.upstreamProjectName));
            case 12 /* UpstreamBlocked */ :
                return reportStatus(state, status.upstreamProjectBlocked ? Diagnostics.Project_0_can_t_be_built_because_its_dependency_1_was_not_built : Diagnostics.Project_0_can_t_be_built_because_its_dependency_1_has_errors, relName(state, configFileName), relName(state, status.upstreamProjectName));
            case 0 /* Unbuildable */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_1, relName(state, configFileName), status.reason);
            case 14 /* TsVersionOutputOfDate */ :
                return reportStatus(state, Diagnostics.Project_0_is_out_of_date_because_output_for_it_was_generated_with_version_1_that_differs_with_current_version_2, relName(state, configFileName), status.version, version);
            case 17 /* ForceBuild */ :
                return reportStatus(state, Diagnostics.Project_0_is_being_forcibly_rebuilt, relName(state, configFileName));
            case 16 /* ContainerOnly */ :
            // Don't report status on "solution" projects
            // falls through
            case 13 /* ComputingUpstream */ :
                break;
            default:
                assertType(status);
        }
    }
    function verboseReportProjectStatus(state, configFileName, status) {
        if (state.options.verbose) reportUpToDateStatus(state, configFileName, status);
    }
    // src/compiler/executeCommandLine.ts
    var StatisticType = /* @__PURE__ */ ((StatisticType2)=>{
        StatisticType2[StatisticType2["time"] = 0] = "time";
        StatisticType2[StatisticType2["count"] = 1] = "count";
        StatisticType2[StatisticType2["memory"] = 2] = "memory";
        return StatisticType2;
    })(StatisticType || {});
    function countLines(program) {
        const counts2 = getCountsMap();
        forEach(program.getSourceFiles(), (file)=>{
            const key = getCountKey(program, file);
            const lineCount = getLineStarts(file).length;
            counts2.set(key, counts2.get(key) + lineCount);
        });
        return counts2;
    }
    function getCountsMap() {
        const counts2 = /* @__PURE__ */ new Map();
        counts2.set("Library", 0);
        counts2.set("Definitions", 0);
        counts2.set("TypeScript", 0);
        counts2.set("JavaScript", 0);
        counts2.set("JSON", 0);
        counts2.set("Other", 0);
        return counts2;
    }
    function getCountKey(program, file) {
        if (program.isSourceFileDefaultLibrary(file)) return "Library";
        else if (file.isDeclarationFile) return "Definitions";
        const path = file.path;
        if (fileExtensionIsOneOf(path, supportedTSExtensionsFlat)) return "TypeScript";
        else if (fileExtensionIsOneOf(path, supportedJSExtensionsFlat)) return "JavaScript";
        else if (fileExtensionIs(path, ".json" /* Json */ )) return "JSON";
        else return "Other";
    }
    function updateReportDiagnostic(sys2, existing, options) {
        return shouldBePretty(sys2, options) ? createDiagnosticReporter(sys2, /*pretty*/ true) : existing;
    }
    function defaultIsPretty(sys2) {
        return !!sys2.writeOutputIsTTY && sys2.writeOutputIsTTY() && !sys2.getEnvironmentVariable("NO_COLOR");
    }
    function shouldBePretty(sys2, options) {
        if (!options || typeof options.pretty === "undefined") return defaultIsPretty(sys2);
        return options.pretty;
    }
    function getOptionsForHelp(commandLine) {
        return !!commandLine.options.all ? toSorted(optionDeclarations.concat(tscBuildOption), (a, b)=>compareStringsCaseInsensitive(a.name, b.name)) : filter(optionDeclarations.concat(tscBuildOption), (v1)=>!!v1.showInSimplifiedHelpView);
    }
    function printVersion(sys2) {
        sys2.write(getDiagnosticText(Diagnostics.Version_0, version) + sys2.newLine);
    }
    function createColors(sys2) {
        const showColors = defaultIsPretty(sys2);
        if (!showColors) return {
            bold: (str)=>str,
            blue: (str)=>str,
            blueBackground: (str)=>str,
            brightWhite: (str)=>str
        };
        function bold(str) {
            return `\x1B[1m${str}\x1B[22m`;
        }
        const isWindows = sys2.getEnvironmentVariable("OS") && sys2.getEnvironmentVariable("OS").toLowerCase().includes("windows");
        const isWindowsTerminal = sys2.getEnvironmentVariable("WT_SESSION");
        const isVSCode = sys2.getEnvironmentVariable("TERM_PROGRAM") && sys2.getEnvironmentVariable("TERM_PROGRAM") === "vscode";
        function blue(str) {
            if (isWindows && !isWindowsTerminal && !isVSCode) return brightWhite(str);
            return `\x1B[94m${str}\x1B[39m`;
        }
        const supportsRicherColors = sys2.getEnvironmentVariable("COLORTERM") === "truecolor" || sys2.getEnvironmentVariable("TERM") === "xterm-256color";
        function blueBackground(str) {
            if (supportsRicherColors) return `\x1B[48;5;68m${str}\x1B[39;49m`;
            else return `\x1B[44m${str}\x1B[39;49m`;
        }
        function brightWhite(str) {
            return `\x1B[97m${str}\x1B[39m`;
        }
        return {
            bold,
            blue,
            brightWhite,
            blueBackground
        };
    }
    function getDisplayNameTextOfOption(option) {
        return `--${option.name}${option.shortName ? `, -${option.shortName}` : ""}`;
    }
    function generateOptionOutput(sys2, option, rightAlignOfLeft, leftAlignOfRight) {
        var _a;
        const text = [];
        const colors = createColors(sys2);
        const name = getDisplayNameTextOfOption(option);
        const valueCandidates = getValueCandidate(option);
        const defaultValueDescription = typeof option.defaultValueDescription === "object" ? getDiagnosticText(option.defaultValueDescription) : formatDefaultValue(option.defaultValueDescription, option.type === "list" || option.type === "listOrElement" ? option.element.type : option.type);
        var _ref;
        const terminalWidth = (_ref = (_a = sys2.getWidthOfTerminal) == null ? void 0 : _a.call(sys2)) !== null && _ref !== void 0 ? _ref : 0;
        if (terminalWidth >= 80) {
            let description3 = "";
            if (option.description) description3 = getDiagnosticText(option.description);
            text.push(...getPrettyOutput(name, description3, rightAlignOfLeft, leftAlignOfRight, terminalWidth, /*colorLeft*/ true), sys2.newLine);
            if (showAdditionalInfoOutput(valueCandidates, option)) {
                if (valueCandidates) text.push(...getPrettyOutput(valueCandidates.valueType, valueCandidates.possibleValues, rightAlignOfLeft, leftAlignOfRight, terminalWidth, /*colorLeft*/ false), sys2.newLine);
                if (defaultValueDescription) text.push(...getPrettyOutput(getDiagnosticText(Diagnostics.default_Colon), defaultValueDescription, rightAlignOfLeft, leftAlignOfRight, terminalWidth, /*colorLeft*/ false), sys2.newLine);
            }
            text.push(sys2.newLine);
        } else {
            text.push(colors.blue(name), sys2.newLine);
            if (option.description) {
                const description3 = getDiagnosticText(option.description);
                text.push(description3);
            }
            text.push(sys2.newLine);
            if (showAdditionalInfoOutput(valueCandidates, option)) {
                if (valueCandidates) text.push(`${valueCandidates.valueType} ${valueCandidates.possibleValues}`);
                if (defaultValueDescription) {
                    if (valueCandidates) text.push(sys2.newLine);
                    const diagType = getDiagnosticText(Diagnostics.default_Colon);
                    text.push(`${diagType} ${defaultValueDescription}`);
                }
                text.push(sys2.newLine);
            }
            text.push(sys2.newLine);
        }
        return text;
        function formatDefaultValue(defaultValue, type) {
            return defaultValue !== void 0 && typeof type === "object" ? arrayFrom(type.entries()).filter(([, value1])=>value1 === defaultValue).map(([name2])=>name2).join("/") : String(defaultValue);
        }
        function showAdditionalInfoOutput(valueCandidates2, option2) {
            const ignoreValues = [
                "string"
            ];
            const ignoredDescriptions = [
                void 0,
                "false",
                "n/a"
            ];
            const defaultValueDescription2 = option2.defaultValueDescription;
            if (option2.category === Diagnostics.Command_line_Options) return false;
            if (contains(ignoreValues, valueCandidates2 == null ? void 0 : valueCandidates2.possibleValues) && contains(ignoredDescriptions, defaultValueDescription2)) return false;
            return true;
        }
        function getPrettyOutput(left, right, rightAlignOfLeft2, leftAlignOfRight2, terminalWidth2, colorLeft) {
            const res = [];
            let isFirstLine = true;
            let remainRight = right;
            const rightCharacterNumber = terminalWidth2 - leftAlignOfRight2;
            while(remainRight.length > 0){
                let curLeft = "";
                if (isFirstLine) {
                    curLeft = left.padStart(rightAlignOfLeft2);
                    curLeft = curLeft.padEnd(leftAlignOfRight2);
                    curLeft = colorLeft ? colors.blue(curLeft) : curLeft;
                } else curLeft = "".padStart(leftAlignOfRight2);
                const curRight = remainRight.substr(0, rightCharacterNumber);
                remainRight = remainRight.slice(rightCharacterNumber);
                res.push(`${curLeft}${curRight}`);
                isFirstLine = false;
            }
            return res;
        }
        function getValueCandidate(option2) {
            if (option2.type === "object") return void 0;
            return {
                valueType: getValueType(option2),
                possibleValues: getPossibleValues(option2)
            };
            function getValueType(option3) {
                Debug.assert(option3.type !== "listOrElement");
                switch(option3.type){
                    case "string":
                    case "number":
                    case "boolean":
                        return getDiagnosticText(Diagnostics.type_Colon);
                    case "list":
                        return getDiagnosticText(Diagnostics.one_or_more_Colon);
                    default:
                        return getDiagnosticText(Diagnostics.one_of_Colon);
                }
            }
            function getPossibleValues(option3) {
                let possibleValues;
                switch(option3.type){
                    case "string":
                    case "number":
                    case "boolean":
                        possibleValues = option3.type;
                        break;
                    case "list":
                    case "listOrElement":
                        possibleValues = getPossibleValues(option3.element);
                        break;
                    case "object":
                        possibleValues = "";
                        break;
                    default:
                        const inverted = {};
                        option3.type.forEach((value1, name2)=>{
                            var _a2;
                            if (!((_a2 = option3.deprecatedKeys) == null ? void 0 : _a2.has(name2))) (inverted[value1] || (inverted[value1] = [])).push(name2);
                        });
                        return Object.entries(inverted).map(([, synonyms])=>synonyms.join("/")).join(", ");
                }
                return possibleValues;
            }
        }
    }
    function generateGroupOptionOutput(sys2, optionsList) {
        let maxLength2 = 0;
        for (const option of optionsList){
            const curLength = getDisplayNameTextOfOption(option).length;
            maxLength2 = maxLength2 > curLength ? maxLength2 : curLength;
        }
        const rightAlignOfLeftPart = maxLength2 + 2;
        const leftAlignOfRightPart = rightAlignOfLeftPart + 2;
        let lines = [];
        for (const option of optionsList){
            const tmp = generateOptionOutput(sys2, option, rightAlignOfLeftPart, leftAlignOfRightPart);
            lines = [
                ...lines,
                ...tmp
            ];
        }
        if (lines[lines.length - 2] !== sys2.newLine) lines.push(sys2.newLine);
        return lines;
    }
    function generateSectionOptionsOutput(sys2, sectionName, options, subCategory, beforeOptionsDescription, afterOptionsDescription) {
        let res = [];
        res.push(createColors(sys2).bold(sectionName) + sys2.newLine + sys2.newLine);
        if (beforeOptionsDescription) res.push(beforeOptionsDescription + sys2.newLine + sys2.newLine);
        if (!subCategory) {
            res = [
                ...res,
                ...generateGroupOptionOutput(sys2, options)
            ];
            if (afterOptionsDescription) res.push(afterOptionsDescription + sys2.newLine + sys2.newLine);
            return res;
        }
        const categoryMap = /* @__PURE__ */ new Map();
        for (const option of options){
            if (!option.category) continue;
            const curCategory = getDiagnosticText(option.category);
            var _categoryMap_get;
            const optionsOfCurCategory = (_categoryMap_get = categoryMap.get(curCategory)) !== null && _categoryMap_get !== void 0 ? _categoryMap_get : [];
            optionsOfCurCategory.push(option);
            categoryMap.set(curCategory, optionsOfCurCategory);
        }
        categoryMap.forEach((value1, key)=>{
            res.push(`### ${key}${sys2.newLine}${sys2.newLine}`);
            res = [
                ...res,
                ...generateGroupOptionOutput(sys2, value1)
            ];
        });
        if (afterOptionsDescription) res.push(afterOptionsDescription + sys2.newLine + sys2.newLine);
        return res;
    }
    function printEasyHelp(sys2, simpleOptions) {
        const colors = createColors(sys2);
        let output = [
            ...getHeader(sys2, `${getDiagnosticText(Diagnostics.tsc_Colon_The_TypeScript_Compiler)} - ${getDiagnosticText(Diagnostics.Version_0, version)}`)
        ];
        output.push(colors.bold(getDiagnosticText(Diagnostics.COMMON_COMMANDS)) + sys2.newLine + sys2.newLine);
        example("tsc", Diagnostics.Compiles_the_current_project_tsconfig_json_in_the_working_directory);
        example("tsc app.ts util.ts", Diagnostics.Ignoring_tsconfig_json_compiles_the_specified_files_with_default_compiler_options);
        example("tsc -b", Diagnostics.Build_a_composite_project_in_the_working_directory);
        example("tsc --init", Diagnostics.Creates_a_tsconfig_json_with_the_recommended_settings_in_the_working_directory);
        example("tsc -p ./path/to/tsconfig.json", Diagnostics.Compiles_the_TypeScript_project_located_at_the_specified_path);
        example("tsc --help --all", Diagnostics.An_expanded_version_of_this_information_showing_all_possible_compiler_options);
        example([
            "tsc --noEmit",
            "tsc --target esnext"
        ], Diagnostics.Compiles_the_current_project_with_additional_settings);
        const cliCommands = simpleOptions.filter((opt)=>opt.isCommandLineOnly || opt.category === Diagnostics.Command_line_Options);
        const configOpts = simpleOptions.filter((opt)=>!contains(cliCommands, opt));
        output = [
            ...output,
            ...generateSectionOptionsOutput(sys2, getDiagnosticText(Diagnostics.COMMAND_LINE_FLAGS), cliCommands, /*subCategory*/ false, /*beforeOptionsDescription*/ void 0, /*afterOptionsDescription*/ void 0),
            ...generateSectionOptionsOutput(sys2, getDiagnosticText(Diagnostics.COMMON_COMPILER_OPTIONS), configOpts, /*subCategory*/ false, /*beforeOptionsDescription*/ void 0, formatMessage(Diagnostics.You_can_learn_about_all_of_the_compiler_options_at_0, "https://aka.ms/tsc"))
        ];
        for (const line of output)sys2.write(line);
        function example(ex, desc) {
            const examples = typeof ex === "string" ? [
                ex
            ] : ex;
            for (const example2 of examples)output.push("  " + colors.blue(example2) + sys2.newLine);
            output.push("  " + getDiagnosticText(desc) + sys2.newLine + sys2.newLine);
        }
    }
    function printAllHelp(sys2, compilerOptions, buildOptions, watchOptions) {
        let output = [
            ...getHeader(sys2, `${getDiagnosticText(Diagnostics.tsc_Colon_The_TypeScript_Compiler)} - ${getDiagnosticText(Diagnostics.Version_0, version)}`)
        ];
        output = [
            ...output,
            ...generateSectionOptionsOutput(sys2, getDiagnosticText(Diagnostics.ALL_COMPILER_OPTIONS), compilerOptions, /*subCategory*/ true, /*beforeOptionsDescription*/ void 0, formatMessage(Diagnostics.You_can_learn_about_all_of_the_compiler_options_at_0, "https://aka.ms/tsc"))
        ];
        output = [
            ...output,
            ...generateSectionOptionsOutput(sys2, getDiagnosticText(Diagnostics.WATCH_OPTIONS), watchOptions, /*subCategory*/ false, getDiagnosticText(Diagnostics.Including_watch_w_will_start_watching_the_current_project_for_the_file_changes_Once_set_you_can_config_watch_mode_with_Colon))
        ];
        output = [
            ...output,
            ...generateSectionOptionsOutput(sys2, getDiagnosticText(Diagnostics.BUILD_OPTIONS), filter(buildOptions, (option)=>option !== tscBuildOption), /*subCategory*/ false, formatMessage(Diagnostics.Using_build_b_will_make_tsc_behave_more_like_a_build_orchestrator_than_a_compiler_This_is_used_to_trigger_building_composite_projects_which_you_can_learn_more_about_at_0, "https://aka.ms/tsc-composite-builds"))
        ];
        for (const line of output)sys2.write(line);
    }
    function printBuildHelp(sys2, buildOptions) {
        let output = [
            ...getHeader(sys2, `${getDiagnosticText(Diagnostics.tsc_Colon_The_TypeScript_Compiler)} - ${getDiagnosticText(Diagnostics.Version_0, version)}`)
        ];
        output = [
            ...output,
            ...generateSectionOptionsOutput(sys2, getDiagnosticText(Diagnostics.BUILD_OPTIONS), filter(buildOptions, (option)=>option !== tscBuildOption), /*subCategory*/ false, formatMessage(Diagnostics.Using_build_b_will_make_tsc_behave_more_like_a_build_orchestrator_than_a_compiler_This_is_used_to_trigger_building_composite_projects_which_you_can_learn_more_about_at_0, "https://aka.ms/tsc-composite-builds"))
        ];
        for (const line of output)sys2.write(line);
    }
    function getHeader(sys2, message) {
        var _a;
        const colors = createColors(sys2);
        const header = [];
        var _ref;
        const terminalWidth = (_ref = (_a = sys2.getWidthOfTerminal) == null ? void 0 : _a.call(sys2)) !== null && _ref !== void 0 ? _ref : 0;
        const tsIconLength = 5;
        const tsIconFirstLine = colors.blueBackground("".padStart(tsIconLength));
        const tsIconSecondLine = colors.blueBackground(colors.brightWhite("TS ".padStart(tsIconLength)));
        if (terminalWidth >= message.length + tsIconLength) {
            const rightAlign = terminalWidth > 120 ? 120 : terminalWidth;
            const leftAlign = rightAlign - tsIconLength;
            header.push(message.padEnd(leftAlign) + tsIconFirstLine + sys2.newLine);
            header.push("".padStart(leftAlign) + tsIconSecondLine + sys2.newLine);
        } else {
            header.push(message + sys2.newLine);
            header.push(sys2.newLine);
        }
        return header;
    }
    function printHelp(sys2, commandLine) {
        if (!commandLine.options.all) printEasyHelp(sys2, getOptionsForHelp(commandLine));
        else printAllHelp(sys2, getOptionsForHelp(commandLine), optionsForBuild, optionsForWatch);
    }
    function executeCommandLineWorker(sys2, cb, commandLine) {
        let reportDiagnostic = createDiagnosticReporter(sys2);
        let configFileName;
        if (commandLine.options.locale) validateLocaleAndSetLanguage(commandLine.options.locale, sys2, commandLine.errors);
        if (commandLine.errors.length > 0) {
            commandLine.errors.forEach(reportDiagnostic);
            return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
        }
        if (commandLine.options.init) {
            writeConfigFile(sys2, reportDiagnostic, commandLine.options);
            return sys2.exit(0 /* Success */ );
        }
        if (commandLine.options.version) {
            printVersion(sys2);
            return sys2.exit(0 /* Success */ );
        }
        if (commandLine.options.help || commandLine.options.all) {
            printHelp(sys2, commandLine);
            return sys2.exit(0 /* Success */ );
        }
        if (commandLine.options.watch && commandLine.options.listFilesOnly) {
            reportDiagnostic(createCompilerDiagnostic(Diagnostics.Options_0_and_1_cannot_be_combined, "watch", "listFilesOnly"));
            return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
        }
        if (commandLine.options.project) {
            if (commandLine.fileNames.length !== 0) {
                reportDiagnostic(createCompilerDiagnostic(Diagnostics.Option_project_cannot_be_mixed_with_source_files_on_a_command_line));
                return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
            }
            const fileOrDirectory = normalizePath(commandLine.options.project);
            if (!fileOrDirectory || sys2.directoryExists(fileOrDirectory)) {
                configFileName = combinePaths(fileOrDirectory, "tsconfig.json");
                if (!sys2.fileExists(configFileName)) {
                    reportDiagnostic(createCompilerDiagnostic(Diagnostics.Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0, commandLine.options.project));
                    return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
                }
            } else {
                configFileName = fileOrDirectory;
                if (!sys2.fileExists(configFileName)) {
                    reportDiagnostic(createCompilerDiagnostic(Diagnostics.The_specified_path_does_not_exist_Colon_0, commandLine.options.project));
                    return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
                }
            }
        } else if (commandLine.fileNames.length === 0) {
            const searchPath = normalizePath(sys2.getCurrentDirectory());
            configFileName = findConfigFile(searchPath, (fileName)=>sys2.fileExists(fileName));
        }
        if (commandLine.fileNames.length === 0 && !configFileName) {
            if (commandLine.options.showConfig) reportDiagnostic(createCompilerDiagnostic(Diagnostics.Cannot_find_a_tsconfig_json_file_at_the_current_directory_Colon_0, normalizePath(sys2.getCurrentDirectory())));
            else {
                printVersion(sys2);
                printHelp(sys2, commandLine);
            }
            return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
        }
        const currentDirectory = sys2.getCurrentDirectory();
        const commandLineOptions = convertToOptionsWithAbsolutePaths(commandLine.options, (fileName)=>getNormalizedAbsolutePath(fileName, currentDirectory));
        if (configFileName) {
            const extendedConfigCache = /* @__PURE__ */ new Map();
            const configParseResult = parseConfigFileWithSystem(configFileName, commandLineOptions, extendedConfigCache, commandLine.watchOptions, sys2, reportDiagnostic);
            if (commandLineOptions.showConfig) {
                if (configParseResult.errors.length !== 0) {
                    reportDiagnostic = updateReportDiagnostic(sys2, reportDiagnostic, configParseResult.options);
                    configParseResult.errors.forEach(reportDiagnostic);
                    return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
                }
                sys2.write(JSON.stringify(convertToTSConfig(configParseResult, configFileName, sys2), null, 4) + sys2.newLine);
                return sys2.exit(0 /* Success */ );
            }
            reportDiagnostic = updateReportDiagnostic(sys2, reportDiagnostic, configParseResult.options);
            if (isWatchSet(configParseResult.options)) {
                if (reportWatchModeWithoutSysSupport(sys2, reportDiagnostic)) return;
                return createWatchOfConfigFile(sys2, cb, reportDiagnostic, configParseResult, commandLineOptions, commandLine.watchOptions, extendedConfigCache);
            } else if (isIncrementalCompilation(configParseResult.options)) performIncrementalCompilation2(sys2, cb, reportDiagnostic, configParseResult);
            else performCompilation(sys2, cb, reportDiagnostic, configParseResult);
        } else {
            if (commandLineOptions.showConfig) {
                sys2.write(JSON.stringify(convertToTSConfig(commandLine, combinePaths(currentDirectory, "tsconfig.json"), sys2), null, 4) + sys2.newLine);
                return sys2.exit(0 /* Success */ );
            }
            reportDiagnostic = updateReportDiagnostic(sys2, reportDiagnostic, commandLineOptions);
            if (isWatchSet(commandLineOptions)) {
                if (reportWatchModeWithoutSysSupport(sys2, reportDiagnostic)) return;
                return createWatchOfFilesAndCompilerOptions(sys2, cb, reportDiagnostic, commandLine.fileNames, commandLineOptions, commandLine.watchOptions);
            } else if (isIncrementalCompilation(commandLineOptions)) performIncrementalCompilation2(sys2, cb, reportDiagnostic, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commandLine), {
                options: commandLineOptions
            }));
            else performCompilation(sys2, cb, reportDiagnostic, (0, _objectSpreadProps._)((0, _objectSpread._)({}, commandLine), {
                options: commandLineOptions
            }));
        }
    }
    function isBuildCommand(commandLineArgs) {
        if (commandLineArgs.length > 0 && commandLineArgs[0].charCodeAt(0) === 45 /* minus */ ) {
            const firstOption = commandLineArgs[0].slice(commandLineArgs[0].charCodeAt(1) === 45 /* minus */  ? 2 : 1).toLowerCase();
            return firstOption === tscBuildOption.name || firstOption === tscBuildOption.shortName;
        }
        return false;
    }
    function executeCommandLine(system, cb, commandLineArgs) {
        if (isBuildCommand(commandLineArgs)) {
            const { buildOptions, watchOptions, projects, errors } = parseBuildCommand(commandLineArgs);
            if (buildOptions.generateCpuProfile && system.enableCPUProfiler) system.enableCPUProfiler(buildOptions.generateCpuProfile, ()=>performBuild(system, cb, buildOptions, watchOptions, projects, errors));
            else return performBuild(system, cb, buildOptions, watchOptions, projects, errors);
        }
        const commandLine = parseCommandLine(commandLineArgs, (path)=>system.readFile(path));
        if (commandLine.options.generateCpuProfile && system.enableCPUProfiler) system.enableCPUProfiler(commandLine.options.generateCpuProfile, ()=>executeCommandLineWorker(system, cb, commandLine));
        else return executeCommandLineWorker(system, cb, commandLine);
    }
    function reportWatchModeWithoutSysSupport(sys2, reportDiagnostic) {
        if (!sys2.watchFile || !sys2.watchDirectory) {
            reportDiagnostic(createCompilerDiagnostic(Diagnostics.The_current_host_does_not_support_the_0_option, "--watch"));
            sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
            return true;
        }
        return false;
    }
    var defaultJSDocParsingMode = 2 /* ParseForTypeErrors */ ;
    function performBuild(sys2, cb, buildOptions, watchOptions, projects, errors) {
        const reportDiagnostic = updateReportDiagnostic(sys2, createDiagnosticReporter(sys2), buildOptions);
        if (buildOptions.locale) validateLocaleAndSetLanguage(buildOptions.locale, sys2, errors);
        if (errors.length > 0) {
            errors.forEach(reportDiagnostic);
            return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
        }
        if (buildOptions.help) {
            printVersion(sys2);
            printBuildHelp(sys2, buildOpts);
            return sys2.exit(0 /* Success */ );
        }
        if (projects.length === 0) {
            printVersion(sys2);
            printBuildHelp(sys2, buildOpts);
            return sys2.exit(0 /* Success */ );
        }
        if (!sys2.getModifiedTime || !sys2.setModifiedTime || buildOptions.clean && !sys2.deleteFile) {
            reportDiagnostic(createCompilerDiagnostic(Diagnostics.The_current_host_does_not_support_the_0_option, "--build"));
            return sys2.exit(1 /* DiagnosticsPresent_OutputsSkipped */ );
        }
        if (buildOptions.watch) {
            if (reportWatchModeWithoutSysSupport(sys2, reportDiagnostic)) return;
            const buildHost2 = createSolutionBuilderWithWatchHost(sys2, /*createProgram*/ void 0, reportDiagnostic, createBuilderStatusReporter(sys2, shouldBePretty(sys2, buildOptions)), createWatchStatusReporter2(sys2, buildOptions));
            buildHost2.jsDocParsingMode = defaultJSDocParsingMode;
            const solutionPerformance2 = enableSolutionPerformance(sys2, buildOptions);
            updateSolutionBuilderHost(sys2, cb, buildHost2, solutionPerformance2);
            const onWatchStatusChange = buildHost2.onWatchStatusChange;
            let reportBuildStatistics = false;
            buildHost2.onWatchStatusChange = (d, newLine, options, errorCount)=>{
                onWatchStatusChange == null || onWatchStatusChange(d, newLine, options, errorCount);
                if (reportBuildStatistics && (d.code === Diagnostics.Found_0_errors_Watching_for_file_changes.code || d.code === Diagnostics.Found_1_error_Watching_for_file_changes.code)) reportSolutionBuilderTimes(builder2, solutionPerformance2);
            };
            const builder2 = createSolutionBuilderWithWatch(buildHost2, projects, buildOptions, watchOptions);
            builder2.build();
            reportSolutionBuilderTimes(builder2, solutionPerformance2);
            reportBuildStatistics = true;
            return builder2;
        }
        const buildHost = createSolutionBuilderHost(sys2, /*createProgram*/ void 0, reportDiagnostic, createBuilderStatusReporter(sys2, shouldBePretty(sys2, buildOptions)), createReportErrorSummary(sys2, buildOptions));
        buildHost.jsDocParsingMode = defaultJSDocParsingMode;
        const solutionPerformance = enableSolutionPerformance(sys2, buildOptions);
        updateSolutionBuilderHost(sys2, cb, buildHost, solutionPerformance);
        const builder = createSolutionBuilder(buildHost, projects, buildOptions);
        const exitStatus = buildOptions.clean ? builder.clean() : builder.build();
        reportSolutionBuilderTimes(builder, solutionPerformance);
        dumpTracingLegend();
        return sys2.exit(exitStatus);
    }
    function createReportErrorSummary(sys2, options) {
        return shouldBePretty(sys2, options) ? (errorCount, filesInError)=>sys2.write(getErrorSummaryText(errorCount, filesInError, sys2.newLine, sys2)) : void 0;
    }
    function performCompilation(sys2, cb, reportDiagnostic, config) {
        const { fileNames, options, projectReferences } = config;
        const host = createCompilerHostWorker(options, /*setParentNodes*/ void 0, sys2);
        host.jsDocParsingMode = defaultJSDocParsingMode;
        const currentDirectory = host.getCurrentDirectory();
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        changeCompilerHostLikeToUseCache(host, (fileName)=>toPath(fileName, currentDirectory, getCanonicalFileName));
        enableStatisticsAndTracing(sys2, options, /*isBuildMode*/ false);
        const programOptions = {
            rootNames: fileNames,
            options,
            projectReferences,
            host,
            configFileParsingDiagnostics: getConfigFileParsingDiagnostics(config)
        };
        const program = createProgram(programOptions);
        const exitStatus = emitFilesAndReportErrorsAndGetExitStatus(program, reportDiagnostic, (s)=>sys2.write(s + sys2.newLine), createReportErrorSummary(sys2, options));
        reportStatistics(sys2, program, /*solutionPerformance*/ void 0);
        cb(program);
        return sys2.exit(exitStatus);
    }
    function performIncrementalCompilation2(sys2, cb, reportDiagnostic, config) {
        const { options, fileNames, projectReferences } = config;
        enableStatisticsAndTracing(sys2, options, /*isBuildMode*/ false);
        const host = createIncrementalCompilerHost(options, sys2);
        host.jsDocParsingMode = defaultJSDocParsingMode;
        const exitStatus = performIncrementalCompilation({
            host,
            system: sys2,
            rootNames: fileNames,
            options,
            configFileParsingDiagnostics: getConfigFileParsingDiagnostics(config),
            projectReferences,
            reportDiagnostic,
            reportErrorSummary: createReportErrorSummary(sys2, options),
            afterProgramEmitAndDiagnostics: (builderProgram)=>{
                reportStatistics(sys2, builderProgram.getProgram(), /*solutionPerformance*/ void 0);
                cb(builderProgram);
            }
        });
        return sys2.exit(exitStatus);
    }
    function updateSolutionBuilderHost(sys2, cb, buildHost, solutionPerformance) {
        updateCreateProgram(sys2, buildHost, /*isBuildMode*/ true);
        buildHost.afterProgramEmitAndDiagnostics = (program)=>{
            reportStatistics(sys2, program.getProgram(), solutionPerformance);
            cb(program);
        };
    }
    function updateCreateProgram(sys2, host, isBuildMode) {
        const compileUsingBuilder = host.createProgram;
        host.createProgram = (rootNames, options, host2, oldProgram, configFileParsingDiagnostics, projectReferences)=>{
            Debug.assert(rootNames !== void 0 || options === void 0 && !!oldProgram);
            if (options !== void 0) enableStatisticsAndTracing(sys2, options, isBuildMode);
            return compileUsingBuilder(rootNames, options, host2, oldProgram, configFileParsingDiagnostics, projectReferences);
        };
    }
    function updateWatchCompilationHost(sys2, cb, watchCompilerHost) {
        watchCompilerHost.jsDocParsingMode = defaultJSDocParsingMode;
        updateCreateProgram(sys2, watchCompilerHost, /*isBuildMode*/ false);
        const emitFilesUsingBuilder = watchCompilerHost.afterProgramCreate;
        watchCompilerHost.afterProgramCreate = (builderProgram)=>{
            emitFilesUsingBuilder(builderProgram);
            reportStatistics(sys2, builderProgram.getProgram(), /*solutionPerformance*/ void 0);
            cb(builderProgram);
        };
    }
    function createWatchStatusReporter2(sys2, options) {
        return createWatchStatusReporter(sys2, shouldBePretty(sys2, options));
    }
    function createWatchOfConfigFile(system, cb, reportDiagnostic, configParseResult, optionsToExtend, watchOptionsToExtend, extendedConfigCache) {
        const watchCompilerHost = createWatchCompilerHostOfConfigFile({
            configFileName: configParseResult.options.configFilePath,
            optionsToExtend,
            watchOptionsToExtend,
            system,
            reportDiagnostic,
            reportWatchStatus: createWatchStatusReporter2(system, configParseResult.options)
        });
        updateWatchCompilationHost(system, cb, watchCompilerHost);
        watchCompilerHost.configFileParsingResult = configParseResult;
        watchCompilerHost.extendedConfigCache = extendedConfigCache;
        return createWatchProgram(watchCompilerHost);
    }
    function createWatchOfFilesAndCompilerOptions(system, cb, reportDiagnostic, rootFiles, options, watchOptions) {
        const watchCompilerHost = createWatchCompilerHostOfFilesAndCompilerOptions({
            rootFiles,
            options,
            watchOptions,
            system,
            reportDiagnostic,
            reportWatchStatus: createWatchStatusReporter2(system, options)
        });
        updateWatchCompilationHost(system, cb, watchCompilerHost);
        return createWatchProgram(watchCompilerHost);
    }
    function enableSolutionPerformance(system, options) {
        if (system === sys && options.extendedDiagnostics) {
            enable();
            return createSolutionPerfomrance();
        }
    }
    function createSolutionPerfomrance() {
        let statistics;
        return {
            addAggregateStatistic,
            forEachAggregateStatistics: forEachAggreateStatistics,
            clear: clear2
        };
        function addAggregateStatistic(s) {
            const existing = statistics == null ? void 0 : statistics.get(s.name);
            if (existing) {
                if (existing.type === 2 /* memory */ ) existing.value = Math.max(existing.value, s.value);
                else existing.value += s.value;
            } else (statistics !== null && statistics !== void 0 ? statistics : statistics = /* @__PURE__ */ new Map()).set(s.name, s);
        }
        function forEachAggreateStatistics(cb) {
            statistics == null || statistics.forEach(cb);
        }
        function clear2() {
            statistics = void 0;
        }
    }
    function reportSolutionBuilderTimes(builder, solutionPerformance) {
        if (!solutionPerformance) return;
        if (!isEnabled()) {
            sys.write(Diagnostics.Performance_timings_for_diagnostics_or_extendedDiagnostics_are_not_available_in_this_session_A_native_implementation_of_the_Web_Performance_API_could_not_be_found.message + "\n");
            return;
        }
        const statistics = [];
        statistics.push({
            name: "Projects in scope",
            value: getBuildOrderFromAnyBuildOrder(builder.getBuildOrder()).length,
            type: 1 /* count */ 
        });
        reportSolutionBuilderCountStatistic("SolutionBuilder::Projects built");
        reportSolutionBuilderCountStatistic("SolutionBuilder::Timestamps only updates");
        reportSolutionBuilderCountStatistic("SolutionBuilder::Bundles updated");
        solutionPerformance.forEachAggregateStatistics((s)=>{
            s.name = `Aggregate ${s.name}`;
            statistics.push(s);
        });
        forEachMeasure((name, duration)=>{
            if (isSolutionMarkOrMeasure(name)) statistics.push({
                name: `${getNameFromSolutionBuilderMarkOrMeasure(name)} time`,
                value: duration,
                type: 0 /* time */ 
            });
        });
        disable();
        enable();
        solutionPerformance.clear();
        reportAllStatistics(sys, statistics);
        function reportSolutionBuilderCountStatistic(name) {
            const value1 = getCount(name);
            if (value1) statistics.push({
                name: getNameFromSolutionBuilderMarkOrMeasure(name),
                value: value1,
                type: 1 /* count */ 
            });
        }
        function getNameFromSolutionBuilderMarkOrMeasure(name) {
            return name.replace("SolutionBuilder::", "");
        }
    }
    function canReportDiagnostics(system, compilerOptions) {
        return system === sys && (compilerOptions.diagnostics || compilerOptions.extendedDiagnostics);
    }
    function canTrace(system, compilerOptions) {
        return system === sys && compilerOptions.generateTrace;
    }
    function enableStatisticsAndTracing(system, compilerOptions, isBuildMode) {
        if (canReportDiagnostics(system, compilerOptions)) enable(system);
        if (canTrace(system, compilerOptions)) startTracing(isBuildMode ? "build" : "project", compilerOptions.generateTrace, compilerOptions.configFilePath);
    }
    function isSolutionMarkOrMeasure(name) {
        return startsWith(name, "SolutionBuilder::");
    }
    function reportStatistics(sys2, program, solutionPerformance) {
        var _a;
        const compilerOptions = program.getCompilerOptions();
        if (canTrace(sys2, compilerOptions)) (_a = tracing) == null || _a.stopTracing();
        let statistics;
        if (canReportDiagnostics(sys2, compilerOptions)) {
            statistics = [];
            const memoryUsed = sys2.getMemoryUsage ? sys2.getMemoryUsage() : -1;
            reportCountStatistic("Files", program.getSourceFiles().length);
            const lineCounts = countLines(program);
            if (compilerOptions.extendedDiagnostics) for (const [key, value1] of lineCounts.entries())reportCountStatistic("Lines of " + key, value1);
            else reportCountStatistic("Lines", reduceLeftIterator(lineCounts.values(), (sum, count)=>sum + count, 0));
            reportCountStatistic("Identifiers", program.getIdentifierCount());
            reportCountStatistic("Symbols", program.getSymbolCount());
            reportCountStatistic("Types", program.getTypeCount());
            reportCountStatistic("Instantiations", program.getInstantiationCount());
            if (memoryUsed >= 0) reportStatisticalValue({
                name: "Memory used",
                value: memoryUsed,
                type: 2 /* memory */ 
            }, /*aggregate*/ true);
            const isPerformanceEnabled = isEnabled();
            const programTime = isPerformanceEnabled ? getDuration("Program") : 0;
            const bindTime = isPerformanceEnabled ? getDuration("Bind") : 0;
            const checkTime = isPerformanceEnabled ? getDuration("Check") : 0;
            const emitTime = isPerformanceEnabled ? getDuration("Emit") : 0;
            if (compilerOptions.extendedDiagnostics) {
                const caches = program.getRelationCacheSizes();
                reportCountStatistic("Assignability cache size", caches.assignable);
                reportCountStatistic("Identity cache size", caches.identity);
                reportCountStatistic("Subtype cache size", caches.subtype);
                reportCountStatistic("Strict subtype cache size", caches.strictSubtype);
                if (isPerformanceEnabled) forEachMeasure((name, duration)=>{
                    if (!isSolutionMarkOrMeasure(name)) reportTimeStatistic(`${name} time`, duration, /*aggregate*/ true);
                });
            } else if (isPerformanceEnabled) {
                reportTimeStatistic("I/O read", getDuration("I/O Read"), /*aggregate*/ true);
                reportTimeStatistic("I/O write", getDuration("I/O Write"), /*aggregate*/ true);
                reportTimeStatistic("Parse time", programTime, /*aggregate*/ true);
                reportTimeStatistic("Bind time", bindTime, /*aggregate*/ true);
                reportTimeStatistic("Check time", checkTime, /*aggregate*/ true);
                reportTimeStatistic("Emit time", emitTime, /*aggregate*/ true);
            }
            if (isPerformanceEnabled) reportTimeStatistic("Total time", programTime + bindTime + checkTime + emitTime, /*aggregate*/ false);
            reportAllStatistics(sys2, statistics);
            if (!isPerformanceEnabled) sys2.write(Diagnostics.Performance_timings_for_diagnostics_or_extendedDiagnostics_are_not_available_in_this_session_A_native_implementation_of_the_Web_Performance_API_could_not_be_found.message + "\n");
            else if (solutionPerformance) {
                forEachMeasure((name)=>{
                    if (!isSolutionMarkOrMeasure(name)) clearMeasures(name);
                });
                forEachMark((name)=>{
                    if (!isSolutionMarkOrMeasure(name)) clearMarks(name);
                });
            } else disable();
        }
        function reportStatisticalValue(s, aggregate) {
            statistics.push(s);
            if (aggregate) solutionPerformance == null || solutionPerformance.addAggregateStatistic(s);
        }
        function reportCountStatistic(name, count) {
            reportStatisticalValue({
                name,
                value: count,
                type: 1 /* count */ 
            }, /*aggregate*/ true);
        }
        function reportTimeStatistic(name, time, aggregate) {
            reportStatisticalValue({
                name,
                value: time,
                type: 0 /* time */ 
            }, aggregate);
        }
    }
    function reportAllStatistics(sys2, statistics) {
        let nameSize = 0;
        let valueSize = 0;
        for (const s of statistics){
            if (s.name.length > nameSize) nameSize = s.name.length;
            const value1 = statisticValue(s);
            if (value1.length > valueSize) valueSize = value1.length;
        }
        for (const s of statistics)sys2.write(`${s.name}:`.padEnd(nameSize + 2) + statisticValue(s).toString().padStart(valueSize) + sys2.newLine);
    }
    function statisticValue(s) {
        switch(s.type){
            case 1 /* count */ :
                return "" + s.value;
            case 0 /* time */ :
                return (s.value / 1e3).toFixed(2) + "s";
            case 2 /* memory */ :
                return Math.round(s.value / 1e3) + "K";
            default:
                Debug.assertNever(s.type);
        }
    }
    function writeConfigFile(sys2, reportDiagnostic, options) {
        const currentDirectory = sys2.getCurrentDirectory();
        const file = normalizePath(combinePaths(currentDirectory, "tsconfig.json"));
        if (sys2.fileExists(file)) reportDiagnostic(createCompilerDiagnostic(Diagnostics.A_tsconfig_json_file_is_already_defined_at_Colon_0, file));
        else {
            sys2.writeFile(file, generateTSConfig(options, sys2.newLine));
            const output = [
                sys2.newLine,
                ...getHeader(sys2, "Created a new tsconfig.json")
            ];
            output.push(`You can learn more at https://aka.ms/tsconfig` + sys2.newLine);
            for (const line of output)sys2.write(line);
        }
        return;
    }
    // src/compiler/expressionToTypeNode.ts
    function syntacticResult(type, reportFallback = true) {
        return {
            type,
            reportFallback
        };
    }
    var notImplemented2 = syntacticResult(/*type*/ void 0, /*reportFallback*/ false);
    var alreadyReported = syntacticResult(/*type*/ void 0, /*reportFallback*/ false);
    var failed = syntacticResult(/*type*/ void 0, /*reportFallback*/ true);
    function createSyntacticTypeNodeBuilder(options, resolver) {
        const strictNullChecks = getStrictOptionValue(options, "strictNullChecks");
        return {
            serializeTypeOfDeclaration,
            serializeReturnTypeForSignature,
            serializeTypeOfExpression,
            serializeTypeOfAccessor,
            tryReuseExistingTypeNode (context, existing) {
                if (!resolver.canReuseTypeNode(context, existing)) return void 0;
                return tryReuseExistingTypeNode(context, existing);
            }
        };
        function reuseNode(context, node, range = node) {
            return node === void 0 ? void 0 : resolver.markNodeReuse(context, node.flags & 16 /* Synthesized */  ? node : factory.cloneNode(node), range !== null && range !== void 0 ? range : node);
        }
        function tryReuseExistingTypeNode(context, existing) {
            const { finalizeBoundary, startRecoveryScope, hadError, markError } = resolver.createRecoveryBoundary(context);
            const transformed = visitNode(existing, visitExistingNodeTreeSymbols, isTypeNode);
            if (!finalizeBoundary()) return void 0;
            context.approximateLength += existing.end - existing.pos;
            return transformed;
            function visitExistingNodeTreeSymbols(node) {
                if (hadError()) return node;
                const recover = startRecoveryScope();
                const onExitNewScope = isNewScopeNode(node) ? resolver.enterNewScope(context, node) : void 0;
                const result = visitExistingNodeTreeSymbolsWorker(node);
                onExitNewScope == null || onExitNewScope();
                if (hadError()) {
                    if (isTypeNode(node) && !isTypePredicateNode(node)) {
                        recover();
                        return resolver.serializeExistingTypeNode(context, node);
                    }
                    return node;
                }
                return result ? resolver.markNodeReuse(context, result, node) : void 0;
            }
            function tryVisitSimpleTypeNode(node) {
                const innerNode = skipTypeParentheses(node);
                switch(innerNode.kind){
                    case 184 /* TypeReference */ :
                        return tryVisitTypeReference(innerNode);
                    case 187 /* TypeQuery */ :
                        return tryVisitTypeQuery(innerNode);
                    case 200 /* IndexedAccessType */ :
                        return tryVisitIndexedAccess(innerNode);
                    case 199 /* TypeOperator */ :
                        const typeOperatorNode = innerNode;
                        if (typeOperatorNode.operator === 143 /* KeyOfKeyword */ ) return tryVisitKeyOf(typeOperatorNode);
                }
                return visitNode(node, visitExistingNodeTreeSymbols, isTypeNode);
            }
            function tryVisitIndexedAccess(node) {
                const resultObjectType = tryVisitSimpleTypeNode(node.objectType);
                if (resultObjectType === void 0) return void 0;
                return factory.updateIndexedAccessTypeNode(node, resultObjectType, visitNode(node.indexType, visitExistingNodeTreeSymbols, isTypeNode));
            }
            function tryVisitKeyOf(node) {
                Debug.assertEqual(node.operator, 143 /* KeyOfKeyword */ );
                const type = tryVisitSimpleTypeNode(node.type);
                if (type === void 0) return void 0;
                return factory.updateTypeOperatorNode(node, type);
            }
            function tryVisitTypeQuery(node) {
                const { introducesError, node: exprName } = resolver.trackExistingEntityName(context, node.exprName);
                if (!introducesError) return factory.updateTypeQueryNode(node, exprName, visitNodes2(node.typeArguments, visitExistingNodeTreeSymbols, isTypeNode));
                const serializedName = resolver.serializeTypeName(context, node.exprName, /*isTypeOf*/ true);
                if (serializedName) return resolver.markNodeReuse(context, serializedName, node.exprName);
            }
            function tryVisitTypeReference(node) {
                if (resolver.canReuseTypeNode(context, node)) {
                    const { introducesError, node: newName } = resolver.trackExistingEntityName(context, node.typeName);
                    const typeArguments = visitNodes2(node.typeArguments, visitExistingNodeTreeSymbols, isTypeNode);
                    if (!introducesError) {
                        const updated = factory.updateTypeReferenceNode(node, newName, typeArguments);
                        return resolver.markNodeReuse(context, updated, node);
                    } else {
                        const serializedName = resolver.serializeTypeName(context, node.typeName, /*isTypeOf*/ false, typeArguments);
                        if (serializedName) return resolver.markNodeReuse(context, serializedName, node.typeName);
                    }
                }
            }
            function visitExistingNodeTreeSymbolsWorker(node) {
                var _a;
                if (isJSDocTypeExpression(node)) return visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode);
                if (isJSDocAllType(node) || node.kind === 320 /* JSDocNamepathType */ ) return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                if (isJSDocUnknownType(node)) return factory.createKeywordTypeNode(159 /* UnknownKeyword */ );
                if (isJSDocNullableType(node)) return factory.createUnionTypeNode([
                    visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode),
                    factory.createLiteralTypeNode(factory.createNull())
                ]);
                if (isJSDocOptionalType(node)) return factory.createUnionTypeNode([
                    visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode),
                    factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
                ]);
                if (isJSDocNonNullableType(node)) return visitNode(node.type, visitExistingNodeTreeSymbols);
                if (isJSDocVariadicType(node)) return factory.createArrayTypeNode(visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode));
                if (isJSDocTypeLiteral(node)) return factory.createTypeLiteralNode(map(node.jsDocPropertyTags, (t)=>{
                    const name = visitNode(isIdentifier(t.name) ? t.name : t.name.right, visitExistingNodeTreeSymbols, isIdentifier);
                    const overrideTypeNode = resolver.getJsDocPropertyOverride(context, node, t);
                    return factory.createPropertySignature(/*modifiers*/ void 0, name, t.isBracketed || t.typeExpression && isJSDocOptionalType(t.typeExpression.type) ? factory.createToken(58 /* QuestionToken */ ) : void 0, overrideTypeNode || t.typeExpression && visitNode(t.typeExpression.type, visitExistingNodeTreeSymbols, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                }));
                if (isTypeReferenceNode(node) && isIdentifier(node.typeName) && node.typeName.escapedText === "") return setOriginalNode(factory.createKeywordTypeNode(133 /* AnyKeyword */ ), node);
                if ((isExpressionWithTypeArguments(node) || isTypeReferenceNode(node)) && isJSDocIndexSignature(node)) return factory.createTypeLiteralNode([
                    factory.createIndexSignature(/*modifiers*/ void 0, [
                        factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "x", /*questionToken*/ void 0, visitNode(node.typeArguments[0], visitExistingNodeTreeSymbols, isTypeNode))
                    ], visitNode(node.typeArguments[1], visitExistingNodeTreeSymbols, isTypeNode))
                ]);
                if (isJSDocFunctionType(node)) {
                    if (isJSDocConstructSignature(node)) {
                        let newTypeNode;
                        return factory.createConstructorTypeNode(/*modifiers*/ void 0, visitNodes2(node.typeParameters, visitExistingNodeTreeSymbols, isTypeParameterDeclaration), mapDefined(node.parameters, (p, i)=>p.name && isIdentifier(p.name) && p.name.escapedText === "new" ? (newTypeNode = p.type, void 0) : factory.createParameterDeclaration(/*modifiers*/ void 0, getEffectiveDotDotDotForParameter(p), resolver.markNodeReuse(context, factory.createIdentifier(getNameForJSDocFunctionParameter(p, i)), p), factory.cloneNode(p.questionToken), visitNode(p.type, visitExistingNodeTreeSymbols, isTypeNode), /*initializer*/ void 0)), visitNode(newTypeNode || node.type, visitExistingNodeTreeSymbols, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                    } else return factory.createFunctionTypeNode(visitNodes2(node.typeParameters, visitExistingNodeTreeSymbols, isTypeParameterDeclaration), map(node.parameters, (p, i)=>factory.createParameterDeclaration(/*modifiers*/ void 0, getEffectiveDotDotDotForParameter(p), resolver.markNodeReuse(context, factory.createIdentifier(getNameForJSDocFunctionParameter(p, i)), p), factory.cloneNode(p.questionToken), visitNode(p.type, visitExistingNodeTreeSymbols, isTypeNode), /*initializer*/ void 0)), visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                }
                if (isThisTypeNode(node)) {
                    if (resolver.canReuseTypeNode(context, node)) return node;
                    markError();
                    return node;
                }
                if (isTypeParameterDeclaration(node)) {
                    const { node: newName } = resolver.trackExistingEntityName(context, node.name);
                    return factory.updateTypeParameterDeclaration(node, visitNodes2(node.modifiers, visitExistingNodeTreeSymbols, isModifier), // resolver.markNodeReuse(context, typeParameterToName(getDeclaredTypeOfSymbol(getSymbolOfDeclaration(node)), context), node),
                    newName, visitNode(node.constraint, visitExistingNodeTreeSymbols, isTypeNode), visitNode(node.default, visitExistingNodeTreeSymbols, isTypeNode));
                }
                if (isIndexedAccessTypeNode(node)) {
                    const result = tryVisitIndexedAccess(node);
                    if (!result) {
                        markError();
                        return node;
                    }
                    return result;
                }
                if (isTypeReferenceNode(node)) {
                    const result = tryVisitTypeReference(node);
                    if (result) return result;
                    markError();
                    return node;
                }
                if (isLiteralImportTypeNode(node)) {
                    if (((_a = node.attributes) == null ? void 0 : _a.token) === 132 /* AssertKeyword */ ) {
                        markError();
                        return node;
                    }
                    if (!resolver.canReuseTypeNode(context, node)) return resolver.serializeExistingTypeNode(context, node);
                    const specifier = rewriteModuleSpecifier2(node, node.argument.literal);
                    const literal = specifier === node.argument.literal ? reuseNode(context, node.argument.literal) : specifier;
                    return factory.updateImportTypeNode(node, literal === node.argument.literal ? reuseNode(context, node.argument) : factory.createLiteralTypeNode(literal), visitNode(node.attributes, visitExistingNodeTreeSymbols, isImportAttributes), visitNode(node.qualifier, visitExistingNodeTreeSymbols, isEntityName), visitNodes2(node.typeArguments, visitExistingNodeTreeSymbols, isTypeNode), node.isTypeOf);
                }
                if (isNamedDeclaration(node) && node.name.kind === 168 /* ComputedPropertyName */  && !resolver.hasLateBindableName(node)) {
                    if (!hasDynamicName(node)) return visitEachChild2(node, visitExistingNodeTreeSymbols);
                    if (resolver.shouldRemoveDeclaration(context, node)) return void 0;
                }
                if (isFunctionLike(node) && !node.type || isPropertyDeclaration(node) && !node.type && !node.initializer || isPropertySignature(node) && !node.type && !node.initializer || isParameter(node) && !node.type && !node.initializer) {
                    let visited = visitEachChild2(node, visitExistingNodeTreeSymbols);
                    if (visited === node) visited = resolver.markNodeReuse(context, factory.cloneNode(node), node);
                    visited.type = factory.createKeywordTypeNode(133 /* AnyKeyword */ );
                    if (isParameter(node)) visited.modifiers = void 0;
                    return visited;
                }
                if (isTypeQueryNode(node)) {
                    const result = tryVisitTypeQuery(node);
                    if (!result) {
                        markError();
                        return node;
                    }
                    return result;
                }
                if (isComputedPropertyName(node) && isEntityNameExpression(node.expression)) {
                    const { node: result, introducesError } = resolver.trackExistingEntityName(context, node.expression);
                    if (!introducesError) return factory.updateComputedPropertyName(node, result);
                    else {
                        const computedPropertyNameType = resolver.serializeTypeOfExpression(context, node.expression);
                        let literal;
                        if (isLiteralTypeNode(computedPropertyNameType)) literal = computedPropertyNameType.literal;
                        else {
                            const evaluated = resolver.evaluateEntityNameExpression(node.expression);
                            const literalNode = typeof evaluated.value === "string" ? factory.createStringLiteral(evaluated.value, /*isSingleQuote*/ void 0) : typeof evaluated.value === "number" ? factory.createNumericLiteral(evaluated.value, /*numericLiteralFlags*/ 0) : void 0;
                            if (!literalNode) {
                                if (isImportTypeNode(computedPropertyNameType)) resolver.trackComputedName(context, node.expression);
                                return node;
                            }
                            literal = literalNode;
                        }
                        if (literal.kind === 11 /* StringLiteral */  && isIdentifierText(literal.text, getEmitScriptTarget(options))) return factory.createIdentifier(literal.text);
                        if (literal.kind === 9 /* NumericLiteral */  && !literal.text.startsWith("-")) return literal;
                        return factory.updateComputedPropertyName(node, literal);
                    }
                }
                if (isTypePredicateNode(node)) {
                    let parameterName;
                    if (isIdentifier(node.parameterName)) {
                        const { node: result, introducesError } = resolver.trackExistingEntityName(context, node.parameterName);
                        if (introducesError) markError();
                        parameterName = result;
                    } else parameterName = factory.cloneNode(node.parameterName);
                    return factory.updateTypePredicateNode(node, factory.cloneNode(node.assertsModifier), parameterName, visitNode(node.type, visitExistingNodeTreeSymbols, isTypeNode));
                }
                if (isTupleTypeNode(node) || isTypeLiteralNode(node) || isMappedTypeNode(node)) {
                    const visited = visitEachChild2(node, visitExistingNodeTreeSymbols);
                    const clone2 = resolver.markNodeReuse(context, visited === node ? factory.cloneNode(node) : visited, node);
                    const flags = getEmitFlags(clone2);
                    setEmitFlags(clone2, flags | (context.flags & 1024 /* MultilineObjectLiterals */  && isTypeLiteralNode(node) ? 0 : 1 /* SingleLine */ ));
                    return clone2;
                }
                if (isStringLiteral(node) && !!(context.flags & 268435456 /* UseSingleQuotesForStringLiteralType */ ) && !node.singleQuote) {
                    const clone2 = factory.cloneNode(node);
                    clone2.singleQuote = true;
                    return clone2;
                }
                if (isConditionalTypeNode(node)) {
                    const checkType = visitNode(node.checkType, visitExistingNodeTreeSymbols, isTypeNode);
                    const disposeScope = resolver.enterNewScope(context, node);
                    const extendType = visitNode(node.extendsType, visitExistingNodeTreeSymbols, isTypeNode);
                    const trueType = visitNode(node.trueType, visitExistingNodeTreeSymbols, isTypeNode);
                    disposeScope();
                    const falseType = visitNode(node.falseType, visitExistingNodeTreeSymbols, isTypeNode);
                    return factory.updateConditionalTypeNode(node, checkType, extendType, trueType, falseType);
                }
                if (isTypeOperatorNode(node)) {
                    if (node.operator === 158 /* UniqueKeyword */  && node.type.kind === 155 /* SymbolKeyword */ ) {
                        if (!resolver.canReuseTypeNode(context, node)) {
                            markError();
                            return node;
                        }
                    } else if (node.operator === 143 /* KeyOfKeyword */ ) {
                        const result = tryVisitKeyOf(node);
                        if (!result) {
                            markError();
                            return node;
                        }
                        return result;
                    }
                }
                return visitEachChild2(node, visitExistingNodeTreeSymbols);
                function visitEachChild2(node2, visitor) {
                    const nonlocalNode = !context.enclosingFile || context.enclosingFile !== getSourceFileOfNode(node2);
                    return visitEachChild(node2, visitor, /*context*/ void 0, nonlocalNode ? visitNodesWithoutCopyingPositions : void 0);
                }
                function visitNodesWithoutCopyingPositions(nodes, visitor, test, start, count) {
                    let result = visitNodes2(nodes, visitor, test, start, count);
                    if (result) {
                        if (result.pos !== -1 || result.end !== -1) {
                            if (result === nodes) result = factory.createNodeArray(nodes.slice(), nodes.hasTrailingComma);
                            setTextRangePosEnd(result, -1, -1);
                        }
                    }
                    return result;
                }
                function getEffectiveDotDotDotForParameter(p) {
                    return p.dotDotDotToken || (p.type && isJSDocVariadicType(p.type) ? factory.createToken(26 /* DotDotDotToken */ ) : void 0);
                }
                function getNameForJSDocFunctionParameter(p, index) {
                    return p.name && isIdentifier(p.name) && p.name.escapedText === "this" ? "this" : getEffectiveDotDotDotForParameter(p) ? `args` : `arg${index}`;
                }
                function rewriteModuleSpecifier2(parent2, lit) {
                    const newName = resolver.getModuleSpecifierOverride(context, parent2, lit);
                    return newName ? setOriginalNode(factory.createStringLiteral(newName), lit) : lit;
                }
            }
        }
        function serializeExistingTypeNode(typeNode, context, addUndefined) {
            if (!typeNode) return void 0;
            let result;
            if ((!addUndefined || canAddUndefined(typeNode)) && resolver.canReuseTypeNode(context, typeNode)) {
                result = tryReuseExistingTypeNode(context, typeNode);
                if (result !== void 0) result = addUndefinedIfNeeded(result, addUndefined, /*owner*/ void 0, context);
            }
            return result;
        }
        function serializeTypeAnnotationOfDeclaration(declaredType, context, node, symbol, requiresAddingUndefined, useFallback = requiresAddingUndefined !== void 0) {
            if (!declaredType) return void 0;
            if (!resolver.canReuseTypeNodeAnnotation(context, node, declaredType, symbol, requiresAddingUndefined)) {
                if (!requiresAddingUndefined || !resolver.canReuseTypeNodeAnnotation(context, node, declaredType, symbol, /*requiresAddingUndefined*/ false)) return void 0;
            }
            let result;
            if (!requiresAddingUndefined || canAddUndefined(declaredType)) result = serializeExistingTypeNode(declaredType, context, requiresAddingUndefined);
            if (result !== void 0 || !useFallback) return result;
            context.tracker.reportInferenceFallback(node);
            var _resolver_serializeExistingTypeNode;
            return (_resolver_serializeExistingTypeNode = resolver.serializeExistingTypeNode(context, declaredType, requiresAddingUndefined)) !== null && _resolver_serializeExistingTypeNode !== void 0 ? _resolver_serializeExistingTypeNode : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
        }
        function serializeExistingTypeNodeWithFallback(typeNode, context, addUndefined, targetNode) {
            if (!typeNode) return void 0;
            const result = serializeExistingTypeNode(typeNode, context, addUndefined);
            if (result !== void 0) return result;
            context.tracker.reportInferenceFallback(targetNode !== null && targetNode !== void 0 ? targetNode : typeNode);
            var _resolver_serializeExistingTypeNode;
            return (_resolver_serializeExistingTypeNode = resolver.serializeExistingTypeNode(context, typeNode, addUndefined)) !== null && _resolver_serializeExistingTypeNode !== void 0 ? _resolver_serializeExistingTypeNode : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
        }
        function serializeTypeOfAccessor(accessor, symbol, context) {
            var _typeFromAccessor;
            return (_typeFromAccessor = typeFromAccessor(accessor, symbol, context)) !== null && _typeFromAccessor !== void 0 ? _typeFromAccessor : inferAccessorType(accessor, resolver.getAllAccessorDeclarations(accessor), context, symbol);
        }
        function serializeTypeOfExpression(expr, context, addUndefined, preserveLiterals) {
            const result = typeFromExpression(expr, context, /*isConstContext*/ false, addUndefined, preserveLiterals);
            return result.type !== void 0 ? result.type : inferExpressionType(expr, context, result.reportFallback);
        }
        function serializeTypeOfDeclaration(node, symbol, context) {
            switch(node.kind){
                case 170 /* Parameter */ :
                case 342 /* JSDocParameterTag */ :
                    return typeFromParameter(node, symbol, context);
                case 261 /* VariableDeclaration */ :
                    return typeFromVariable(node, symbol, context);
                case 172 /* PropertySignature */ :
                case 349 /* JSDocPropertyTag */ :
                case 173 /* PropertyDeclaration */ :
                    return typeFromProperty(node, symbol, context);
                case 209 /* BindingElement */ :
                    return inferTypeOfDeclaration(node, symbol, context);
                case 278 /* ExportAssignment */ :
                    return serializeTypeOfExpression(node.expression, context, /*addUndefined*/ void 0, /*preserveLiterals*/ true);
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                case 227 /* BinaryExpression */ :
                    return typeFromExpandoProperty(node, symbol, context);
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                    return typeFromPropertyAssignment(node, symbol, context);
                default:
                    Debug.assertNever(node, `Node needs to be an inferrable node, found ${Debug.formatSyntaxKind(node.kind)}`);
            }
        }
        function typeFromPropertyAssignment(node, symbol, context) {
            const typeAnnotation = getEffectiveTypeAnnotationNode(node);
            let result;
            if (typeAnnotation && resolver.canReuseTypeNodeAnnotation(context, node, typeAnnotation, symbol)) result = serializeExistingTypeNode(typeAnnotation, context);
            if (!result && node.kind === 304 /* PropertyAssignment */ ) {
                const initializer = node.initializer;
                const assertionNode = isJSDocTypeAssertion(initializer) ? getJSDocTypeAssertionType(initializer) : initializer.kind === 235 /* AsExpression */  || initializer.kind === 217 /* TypeAssertionExpression */  ? initializer.type : void 0;
                if (assertionNode && !isConstTypeReference(assertionNode) && resolver.canReuseTypeNodeAnnotation(context, node, assertionNode, symbol)) result = serializeExistingTypeNode(assertionNode, context);
            }
            return result !== null && result !== void 0 ? result : inferTypeOfDeclaration(node, symbol, context, /*reportFallback*/ false);
        }
        function serializeReturnTypeForSignature(node, symbol, context) {
            switch(node.kind){
                case 178 /* GetAccessor */ :
                    return serializeTypeOfAccessor(node, symbol, context);
                case 175 /* MethodDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                case 181 /* ConstructSignature */ :
                case 174 /* MethodSignature */ :
                case 180 /* CallSignature */ :
                case 177 /* Constructor */ :
                case 179 /* SetAccessor */ :
                case 182 /* IndexSignature */ :
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 318 /* JSDocFunctionType */ :
                case 324 /* JSDocSignature */ :
                    return createReturnFromSignature(node, symbol, context);
                default:
                    Debug.assertNever(node, `Node needs to be an inferrable node, found ${Debug.formatSyntaxKind(node.kind)}`);
            }
        }
        function getTypeAnnotationFromAccessor(accessor) {
            if (accessor) return accessor.kind === 178 /* GetAccessor */  ? isInJSFile(accessor) && getJSDocType(accessor) || getEffectiveReturnTypeNode(accessor) : getEffectiveSetAccessorTypeAnnotationNode(accessor);
        }
        function getTypeAnnotationFromAllAccessorDeclarations(node, accessors) {
            let accessorType = getTypeAnnotationFromAccessor(node);
            if (!accessorType && node !== accessors.firstAccessor) accessorType = getTypeAnnotationFromAccessor(accessors.firstAccessor);
            if (!accessorType && accessors.secondAccessor && node !== accessors.secondAccessor) accessorType = getTypeAnnotationFromAccessor(accessors.secondAccessor);
            return accessorType;
        }
        function typeFromAccessor(node, symbol, context) {
            const accessorDeclarations = resolver.getAllAccessorDeclarations(node);
            const accessorType = getTypeAnnotationFromAllAccessorDeclarations(node, accessorDeclarations);
            if (accessorType && !isTypePredicateNode(accessorType)) return withNewScope(context, node, ()=>{
                var _serializeTypeAnnotationOfDeclaration;
                return (_serializeTypeAnnotationOfDeclaration = serializeTypeAnnotationOfDeclaration(accessorType, context, node, symbol)) !== null && _serializeTypeAnnotationOfDeclaration !== void 0 ? _serializeTypeAnnotationOfDeclaration : inferTypeOfDeclaration(node, symbol, context);
            });
            if (accessorDeclarations.getAccessor) return withNewScope(context, accessorDeclarations.getAccessor, ()=>createReturnFromSignature(accessorDeclarations.getAccessor, symbol, context));
            return void 0;
        }
        function typeFromVariable(node, symbol, context) {
            var _a;
            const declaredType = getEffectiveTypeAnnotationNode(node);
            let resultType = failed;
            if (declaredType) resultType = syntacticResult(serializeTypeAnnotationOfDeclaration(declaredType, context, node, symbol));
            else if (node.initializer && (((_a = symbol.declarations) == null ? void 0 : _a.length) === 1 || countWhere(symbol.declarations, isVariableDeclaration) === 1)) {
                if (!resolver.isExpandoFunctionDeclaration(node) && !isContextuallyTyped(node)) resultType = typeFromExpression(node.initializer, context, /*isConstContext*/ void 0, /*requiresAddingUndefined*/ void 0, isVarConstLike(node));
            }
            return resultType.type !== void 0 ? resultType.type : inferTypeOfDeclaration(node, symbol, context, resultType.reportFallback);
        }
        function typeFromParameter(node, symbol, context) {
            const parent2 = node.parent;
            if (parent2.kind === 179 /* SetAccessor */ ) return serializeTypeOfAccessor(parent2, /*symbol*/ void 0, context);
            const declaredType = getEffectiveTypeAnnotationNode(node);
            const addUndefined = resolver.requiresAddingImplicitUndefined(node, symbol, context.enclosingDeclaration);
            let resultType = failed;
            if (declaredType) resultType = syntacticResult(serializeTypeAnnotationOfDeclaration(declaredType, context, node, symbol, addUndefined));
            else if (isParameter(node) && node.initializer && isIdentifier(node.name) && !isContextuallyTyped(node)) resultType = typeFromExpression(node.initializer, context, /*isConstContext*/ void 0, addUndefined);
            return resultType.type !== void 0 ? resultType.type : inferTypeOfDeclaration(node, symbol, context, resultType.reportFallback);
        }
        function typeFromExpandoProperty(node, symbol, context) {
            const declaredType = getEffectiveTypeAnnotationNode(node);
            let result;
            if (declaredType) result = serializeTypeAnnotationOfDeclaration(declaredType, context, node, symbol);
            const oldSuppressReportInferenceFallback = context.suppressReportInferenceFallback;
            context.suppressReportInferenceFallback = true;
            const resultType = result !== null && result !== void 0 ? result : inferTypeOfDeclaration(node, symbol, context, /*reportFallback*/ false);
            context.suppressReportInferenceFallback = oldSuppressReportInferenceFallback;
            return resultType;
        }
        function typeFromProperty(node, symbol, context) {
            const declaredType = getEffectiveTypeAnnotationNode(node);
            const requiresAddingUndefined = resolver.requiresAddingImplicitUndefined(node, symbol, context.enclosingDeclaration);
            let resultType = failed;
            if (declaredType) resultType = syntacticResult(serializeTypeAnnotationOfDeclaration(declaredType, context, node, symbol, requiresAddingUndefined));
            else {
                const initializer = isPropertyDeclaration(node) ? node.initializer : void 0;
                if (initializer && !isContextuallyTyped(node)) {
                    const isReadonly = isDeclarationReadonly(node);
                    resultType = typeFromExpression(initializer, context, /*isConstContext*/ void 0, requiresAddingUndefined, isReadonly);
                }
            }
            return resultType.type !== void 0 ? resultType.type : inferTypeOfDeclaration(node, symbol, context, resultType.reportFallback);
        }
        function inferTypeOfDeclaration(node, symbol, context, reportFallback = true) {
            if (reportFallback) context.tracker.reportInferenceFallback(node);
            if (context.noInferenceFallback === true) return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
            return resolver.serializeTypeOfDeclaration(context, node, symbol);
        }
        function inferExpressionType(node, context, reportFallback = true, requiresAddingUndefined) {
            Debug.assert(!requiresAddingUndefined);
            if (reportFallback) context.tracker.reportInferenceFallback(node);
            if (context.noInferenceFallback === true) return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
            var _resolver_serializeTypeOfExpression;
            return (_resolver_serializeTypeOfExpression = resolver.serializeTypeOfExpression(context, node)) !== null && _resolver_serializeTypeOfExpression !== void 0 ? _resolver_serializeTypeOfExpression : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
        }
        function inferReturnTypeOfSignatureSignature(node, context, symbol, reportFallback) {
            if (reportFallback) context.tracker.reportInferenceFallback(node);
            if (context.noInferenceFallback === true) return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
            var _resolver_serializeReturnTypeForSignature;
            return (_resolver_serializeReturnTypeForSignature = resolver.serializeReturnTypeForSignature(context, node, symbol)) !== null && _resolver_serializeReturnTypeForSignature !== void 0 ? _resolver_serializeReturnTypeForSignature : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
        }
        function inferAccessorType(node, allAccessors, context, symbol, reportFallback = true) {
            if (node.kind === 178 /* GetAccessor */ ) return createReturnFromSignature(node, symbol, context, reportFallback);
            else {
                if (reportFallback) context.tracker.reportInferenceFallback(node);
                const result = allAccessors.getAccessor && createReturnFromSignature(allAccessors.getAccessor, symbol, context, reportFallback);
                var _ref;
                return (_ref = result !== null && result !== void 0 ? result : resolver.serializeTypeOfDeclaration(context, node, symbol)) !== null && _ref !== void 0 ? _ref : factory.createKeywordTypeNode(133 /* AnyKeyword */ );
            }
        }
        function withNewScope(context, node, fn) {
            const cleanup = resolver.enterNewScope(context, node);
            const result = fn();
            cleanup();
            return result;
        }
        function typeFromTypeAssertion(expression, type, context, requiresAddingUndefined) {
            if (isConstTypeReference(type)) return typeFromExpression(expression, context, /*isConstContext*/ true, requiresAddingUndefined);
            return syntacticResult(serializeExistingTypeNodeWithFallback(type, context, requiresAddingUndefined));
        }
        function typeFromExpression(node, context, isConstContext = false, requiresAddingUndefined = false, preserveLiterals = false) {
            switch(node.kind){
                case 218 /* ParenthesizedExpression */ :
                    if (isJSDocTypeAssertion(node)) return typeFromTypeAssertion(node.expression, getJSDocTypeAssertionType(node), context, requiresAddingUndefined);
                    return typeFromExpression(node.expression, context, isConstContext, requiresAddingUndefined);
                case 80 /* Identifier */ :
                    if (resolver.isUndefinedIdentifierExpression(node)) return syntacticResult(createUndefinedTypeNode());
                    break;
                case 106 /* NullKeyword */ :
                    if (strictNullChecks) return syntacticResult(addUndefinedIfNeeded(factory.createLiteralTypeNode(factory.createNull()), requiresAddingUndefined, node, context));
                    else return syntacticResult(factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
                case 220 /* ArrowFunction */ :
                case 219 /* FunctionExpression */ :
                    Debug.type(node);
                    return withNewScope(context, node, ()=>typeFromFunctionLikeExpression(node, context));
                case 217 /* TypeAssertionExpression */ :
                case 235 /* AsExpression */ :
                    const asExpression = node;
                    return typeFromTypeAssertion(asExpression.expression, asExpression.type, context, requiresAddingUndefined);
                case 225 /* PrefixUnaryExpression */ :
                    const unaryExpression = node;
                    if (isPrimitiveLiteralValue(unaryExpression)) return typeFromPrimitiveLiteral(unaryExpression.operator === 40 /* PlusToken */  ? unaryExpression.operand : unaryExpression, unaryExpression.operand.kind === 10 /* BigIntLiteral */  ? 163 /* BigIntKeyword */  : 150 /* NumberKeyword */ , context, isConstContext || preserveLiterals, requiresAddingUndefined);
                    break;
                case 210 /* ArrayLiteralExpression */ :
                    return typeFromArrayLiteral(node, context, isConstContext, requiresAddingUndefined);
                case 211 /* ObjectLiteralExpression */ :
                    return typeFromObjectLiteral(node, context, isConstContext, requiresAddingUndefined);
                case 232 /* ClassExpression */ :
                    return syntacticResult(inferExpressionType(node, context, /*reportFallback*/ true, requiresAddingUndefined));
                case 229 /* TemplateExpression */ :
                    if (!isConstContext && !preserveLiterals) return syntacticResult(factory.createKeywordTypeNode(154 /* StringKeyword */ ));
                    break;
                default:
                    let typeKind;
                    let primitiveNode = node;
                    switch(node.kind){
                        case 9 /* NumericLiteral */ :
                            typeKind = 150 /* NumberKeyword */ ;
                            break;
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                            primitiveNode = factory.createStringLiteral(node.text);
                            typeKind = 154 /* StringKeyword */ ;
                            break;
                        case 11 /* StringLiteral */ :
                            typeKind = 154 /* StringKeyword */ ;
                            break;
                        case 10 /* BigIntLiteral */ :
                            typeKind = 163 /* BigIntKeyword */ ;
                            break;
                        case 112 /* TrueKeyword */ :
                        case 97 /* FalseKeyword */ :
                            typeKind = 136 /* BooleanKeyword */ ;
                            break;
                    }
                    if (typeKind) return typeFromPrimitiveLiteral(primitiveNode, typeKind, context, isConstContext || preserveLiterals, requiresAddingUndefined);
            }
            return failed;
        }
        function typeFromFunctionLikeExpression(fnNode, context) {
            const returnType = createReturnFromSignature(fnNode, /*symbol*/ void 0, context);
            const typeParameters = reuseTypeParameters(fnNode.typeParameters, context);
            const parameters = fnNode.parameters.map((p)=>ensureParameter(p, context));
            return syntacticResult(factory.createFunctionTypeNode(typeParameters, parameters, returnType));
        }
        function canGetTypeFromArrayLiteral(arrayLiteral, context, isConstContext) {
            if (!isConstContext) {
                context.tracker.reportInferenceFallback(arrayLiteral);
                return false;
            }
            for (const element of arrayLiteral.elements)if (element.kind === 231 /* SpreadElement */ ) {
                context.tracker.reportInferenceFallback(element);
                return false;
            }
            return true;
        }
        function typeFromArrayLiteral(arrayLiteral, context, isConstContext, requiresAddingUndefined) {
            if (!canGetTypeFromArrayLiteral(arrayLiteral, context, isConstContext)) {
                if (requiresAddingUndefined || isDeclaration(walkUpParenthesizedExpressions(arrayLiteral).parent)) return alreadyReported;
                return syntacticResult(inferExpressionType(arrayLiteral, context, /*reportFallback*/ false, requiresAddingUndefined));
            }
            const oldNoInferenceFallback = context.noInferenceFallback;
            context.noInferenceFallback = true;
            const elementTypesInfo = [];
            for (const element of arrayLiteral.elements){
                Debug.assert(element.kind !== 231 /* SpreadElement */ );
                if (element.kind === 233 /* OmittedExpression */ ) elementTypesInfo.push(createUndefinedTypeNode());
                else {
                    const expressionType = typeFromExpression(element, context, isConstContext);
                    const elementType = expressionType.type !== void 0 ? expressionType.type : inferExpressionType(element, context, expressionType.reportFallback);
                    elementTypesInfo.push(elementType);
                }
            }
            const tupleType = factory.createTupleTypeNode(elementTypesInfo);
            tupleType.emitNode = {
                flags: 1,
                autoGenerate: void 0,
                internalFlags: 0
            };
            context.noInferenceFallback = oldNoInferenceFallback;
            return notImplemented2;
        }
        function canGetTypeFromObjectLiteral(objectLiteral, context) {
            let result = true;
            for (const prop of objectLiteral.properties){
                if (prop.flags & 262144 /* ThisNodeHasError */ ) {
                    result = false;
                    break;
                }
                if (prop.kind === 305 /* ShorthandPropertyAssignment */  || prop.kind === 306 /* SpreadAssignment */ ) {
                    context.tracker.reportInferenceFallback(prop);
                    result = false;
                } else if (prop.name.flags & 262144 /* ThisNodeHasError */ ) {
                    result = false;
                    break;
                } else if (prop.name.kind === 81 /* PrivateIdentifier */ ) result = false;
                else if (prop.name.kind === 168 /* ComputedPropertyName */ ) {
                    const expression = prop.name.expression;
                    if (!isPrimitiveLiteralValue(expression, /*includeBigInt*/ false) && !resolver.isDefinitelyReferenceToGlobalSymbolObject(expression)) {
                        context.tracker.reportInferenceFallback(prop.name);
                        result = false;
                    }
                }
            }
            return result;
        }
        function typeFromObjectLiteral(objectLiteral, context, isConstContext, requiresAddingUndefined) {
            if (!canGetTypeFromObjectLiteral(objectLiteral, context)) {
                if (requiresAddingUndefined || isDeclaration(walkUpParenthesizedExpressions(objectLiteral).parent)) return alreadyReported;
                return syntacticResult(inferExpressionType(objectLiteral, context, /*reportFallback*/ false, requiresAddingUndefined));
            }
            const oldNoInferenceFallback = context.noInferenceFallback;
            context.noInferenceFallback = true;
            const properties = [];
            const oldFlags = context.flags;
            context.flags |= 4194304 /* InObjectTypeLiteral */ ;
            for (const prop of objectLiteral.properties){
                Debug.assert(!isShorthandPropertyAssignment(prop) && !isSpreadAssignment(prop));
                const name = prop.name;
                let newProp;
                switch(prop.kind){
                    case 175 /* MethodDeclaration */ :
                        newProp = withNewScope(context, prop, ()=>typeFromObjectLiteralMethod(prop, name, context, isConstContext));
                        break;
                    case 304 /* PropertyAssignment */ :
                        newProp = typeFromObjectLiteralPropertyAssignment(prop, name, context, isConstContext);
                        break;
                    case 179 /* SetAccessor */ :
                    case 178 /* GetAccessor */ :
                        newProp = typeFromObjectLiteralAccessor(prop, name, context);
                        break;
                }
                if (newProp) {
                    setCommentRange(newProp, prop);
                    properties.push(newProp);
                }
            }
            context.flags = oldFlags;
            const typeNode = factory.createTypeLiteralNode(properties);
            if (!(context.flags & 1024 /* MultilineObjectLiterals */ )) setEmitFlags(typeNode, 1 /* SingleLine */ );
            context.noInferenceFallback = oldNoInferenceFallback;
            return notImplemented2;
        }
        function typeFromObjectLiteralPropertyAssignment(prop, name, context, isConstContext) {
            const modifiers = isConstContext ? [
                factory.createModifier(148 /* ReadonlyKeyword */ )
            ] : [];
            const expressionResult = typeFromExpression(prop.initializer, context, isConstContext);
            const typeNode = expressionResult.type !== void 0 ? expressionResult.type : inferTypeOfDeclaration(prop, /*symbol*/ void 0, context, expressionResult.reportFallback);
            return factory.createPropertySignature(modifiers, reuseNode(context, name), /*questionToken*/ void 0, typeNode);
        }
        function ensureParameter(p, context) {
            return factory.updateParameterDeclaration(p, /*modifiers*/ void 0, reuseNode(context, p.dotDotDotToken), resolver.serializeNameOfParameter(context, p), resolver.isOptionalParameter(p) ? factory.createToken(58 /* QuestionToken */ ) : void 0, typeFromParameter(p, /*symbol*/ void 0, context), // Ignore private param props, since this type is going straight back into a param
            /*initializer*/ void 0);
        }
        function reuseTypeParameters(typeParameters, context) {
            return typeParameters == null ? void 0 : typeParameters.map((tp)=>{
                var _a;
                const { node: tpName } = resolver.trackExistingEntityName(context, tp.name);
                return factory.updateTypeParameterDeclaration(tp, (_a = tp.modifiers) == null ? void 0 : _a.map((m)=>reuseNode(context, m)), tpName, serializeExistingTypeNodeWithFallback(tp.constraint, context), serializeExistingTypeNodeWithFallback(tp.default, context));
            });
        }
        function typeFromObjectLiteralMethod(method, name, context, isConstContext) {
            const returnType = createReturnFromSignature(method, /*symbol*/ void 0, context);
            const typeParameters = reuseTypeParameters(method.typeParameters, context);
            const parameters = method.parameters.map((p)=>ensureParameter(p, context));
            if (isConstContext) return factory.createPropertySignature([
                factory.createModifier(148 /* ReadonlyKeyword */ )
            ], reuseNode(context, name), reuseNode(context, method.questionToken), factory.createFunctionTypeNode(typeParameters, parameters, returnType));
            else {
                if (isIdentifier(name) && name.escapedText === "new") name = factory.createStringLiteral("new");
                return factory.createMethodSignature([], reuseNode(context, name), reuseNode(context, method.questionToken), typeParameters, parameters, returnType);
            }
        }
        function typeFromObjectLiteralAccessor(accessor, name, context) {
            const allAccessors = resolver.getAllAccessorDeclarations(accessor);
            const getAccessorType = allAccessors.getAccessor && getTypeAnnotationFromAccessor(allAccessors.getAccessor);
            const setAccessorType = allAccessors.setAccessor && getTypeAnnotationFromAccessor(allAccessors.setAccessor);
            if (getAccessorType !== void 0 && setAccessorType !== void 0) return withNewScope(context, accessor, ()=>{
                const parameters = accessor.parameters.map((p)=>ensureParameter(p, context));
                if (isGetAccessor(accessor)) return factory.updateGetAccessorDeclaration(accessor, [], reuseNode(context, name), parameters, serializeExistingTypeNodeWithFallback(getAccessorType, context), /*body*/ void 0);
                else return factory.updateSetAccessorDeclaration(accessor, [], reuseNode(context, name), parameters, /*body*/ void 0);
            });
            else if (allAccessors.firstAccessor === accessor) {
                const foundType = getAccessorType ? withNewScope(context, allAccessors.getAccessor, ()=>serializeExistingTypeNodeWithFallback(getAccessorType, context)) : setAccessorType ? withNewScope(context, allAccessors.setAccessor, ()=>serializeExistingTypeNodeWithFallback(setAccessorType, context)) : void 0;
                const propertyType = foundType !== null && foundType !== void 0 ? foundType : inferAccessorType(accessor, allAccessors, context, /*symbol*/ void 0);
                const propertySignature = factory.createPropertySignature(allAccessors.setAccessor === void 0 ? [
                    factory.createModifier(148 /* ReadonlyKeyword */ )
                ] : [], reuseNode(context, name), /*questionToken*/ void 0, propertyType);
                return propertySignature;
            }
        }
        function createUndefinedTypeNode() {
            if (strictNullChecks) return factory.createKeywordTypeNode(157 /* UndefinedKeyword */ );
            else return factory.createKeywordTypeNode(133 /* AnyKeyword */ );
        }
        function typeFromPrimitiveLiteral(node, baseType, context, preserveLiterals, requiresAddingUndefined) {
            let result;
            if (preserveLiterals) {
                if (node.kind === 225 /* PrefixUnaryExpression */  && node.operator === 40 /* PlusToken */ ) result = factory.createLiteralTypeNode(reuseNode(context, node.operand));
                result = factory.createLiteralTypeNode(reuseNode(context, node));
            } else result = factory.createKeywordTypeNode(baseType);
            return syntacticResult(addUndefinedIfNeeded(result, requiresAddingUndefined, node, context));
        }
        function addUndefinedIfNeeded(node, addUndefined, owner, context) {
            const parentDeclaration = owner && walkUpParenthesizedExpressions(owner).parent;
            const optionalDeclaration = parentDeclaration && isDeclaration(parentDeclaration) && isOptionalDeclaration(parentDeclaration);
            if (!strictNullChecks || !(addUndefined || optionalDeclaration)) return node;
            if (!canAddUndefined(node)) context.tracker.reportInferenceFallback(node);
            if (isUnionTypeNode(node)) return factory.createUnionTypeNode([
                ...node.types,
                factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
            ]);
            return factory.createUnionTypeNode([
                node,
                factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
            ]);
        }
        function canAddUndefined(node) {
            if (!strictNullChecks) return true;
            if (isKeyword(node.kind) || node.kind === 202 /* LiteralType */  || node.kind === 185 /* FunctionType */  || node.kind === 186 /* ConstructorType */  || node.kind === 189 /* ArrayType */  || node.kind === 190 /* TupleType */  || node.kind === 188 /* TypeLiteral */  || node.kind === 204 /* TemplateLiteralType */  || node.kind === 198 /* ThisType */ ) return true;
            if (node.kind === 197 /* ParenthesizedType */ ) return canAddUndefined(node.type);
            if (node.kind === 193 /* UnionType */  || node.kind === 194 /* IntersectionType */ ) return node.types.every(canAddUndefined);
            return false;
        }
        function createReturnFromSignature(fn, symbol, context, reportFallback = true) {
            let returnType = failed;
            const returnTypeNode = isJSDocConstructSignature(fn) ? getEffectiveTypeAnnotationNode(fn.parameters[0]) : getEffectiveReturnTypeNode(fn);
            if (returnTypeNode) returnType = syntacticResult(serializeTypeAnnotationOfDeclaration(returnTypeNode, context, fn, symbol));
            else if (isValueSignatureDeclaration(fn)) returnType = typeFromSingleReturnExpression(fn, context);
            return returnType.type !== void 0 ? returnType.type : inferReturnTypeOfSignatureSignature(fn, context, symbol, reportFallback && returnType.reportFallback && !returnTypeNode);
        }
        function typeFromSingleReturnExpression(declaration, context) {
            let candidateExpr;
            if (declaration && !nodeIsMissing(declaration.body)) {
                const flags = getFunctionFlags(declaration);
                if (flags & 3 /* AsyncGenerator */ ) return failed;
                const body = declaration.body;
                if (body && isBlock(body)) forEachReturnStatement(body, (s)=>{
                    if (s.parent !== body) {
                        candidateExpr = void 0;
                        return true;
                    }
                    if (!candidateExpr) candidateExpr = s.expression;
                    else {
                        candidateExpr = void 0;
                        return true;
                    }
                });
                else candidateExpr = body;
            }
            if (candidateExpr) {
                if (isContextuallyTyped(candidateExpr)) {
                    const type = isJSDocTypeAssertion(candidateExpr) ? getJSDocTypeAssertionType(candidateExpr) : isAsExpression(candidateExpr) || isTypeAssertionExpression(candidateExpr) ? candidateExpr.type : void 0;
                    if (type && !isConstTypeReference(type)) return syntacticResult(serializeExistingTypeNode(type, context));
                } else return typeFromExpression(candidateExpr, context);
            }
            return failed;
        }
        function isContextuallyTyped(node) {
            return findAncestor(node.parent, (n)=>{
                return isCallExpression(n) || !isFunctionLikeDeclaration(n) && !!getEffectiveTypeAnnotationNode(n) || isJsxElement(n) || isJsxExpression(n);
            });
        }
    }
    // src/jsTyping/_namespaces/ts.JsTyping.ts
    var ts_JsTyping_exports = {};
    __export(ts_JsTyping_exports, {
        NameValidationResult: ()=>NameValidationResult,
        discoverTypings: ()=>discoverTypings,
        isTypingUpToDate: ()=>isTypingUpToDate,
        loadSafeList: ()=>loadSafeList,
        loadTypesMap: ()=>loadTypesMap,
        nonRelativeModuleNameForTypingCache: ()=>nonRelativeModuleNameForTypingCache,
        renderPackageNameValidationFailure: ()=>renderPackageNameValidationFailure,
        validatePackageName: ()=>validatePackageName
    });
    // src/jsTyping/shared.ts
    var ActionSet = "action::set";
    var ActionInvalidate = "action::invalidate";
    var ActionPackageInstalled = "action::packageInstalled";
    var EventTypesRegistry = "event::typesRegistry";
    var EventBeginInstallTypes = "event::beginInstallTypes";
    var EventEndInstallTypes = "event::endInstallTypes";
    var EventInitializationFailed = "event::initializationFailed";
    var ActionWatchTypingLocations = "action::watchTypingLocations";
    var Arguments;
    ((Arguments2)=>{
        Arguments2.GlobalCacheLocation = "--globalTypingsCacheLocation";
        Arguments2.LogFile = "--logFile";
        Arguments2.EnableTelemetry = "--enableTelemetry";
        Arguments2.TypingSafeListLocation = "--typingSafeListLocation";
        Arguments2.TypesMapLocation = "--typesMapLocation";
        Arguments2.NpmLocation = "--npmLocation";
        Arguments2.ValidateDefaultNpmLocation = "--validateDefaultNpmLocation";
    })(Arguments || (Arguments = {}));
    function hasArgument(argumentName) {
        return sys.args.includes(argumentName);
    }
    function findArgument(argumentName) {
        const index = sys.args.indexOf(argumentName);
        return index >= 0 && index < sys.args.length - 1 ? sys.args[index + 1] : void 0;
    }
    function nowString() {
        const d = /* @__PURE__ */ new Date();
        return `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}:${d.getSeconds().toString().padStart(2, "0")}.${d.getMilliseconds().toString().padStart(3, "0")}`;
    }
    var indentStr = "\n    ";
    function indent2(str) {
        return indentStr + str.replace(/\n/g, indentStr);
    }
    function stringifyIndented(json) {
        return indent2(JSON.stringify(json, void 0, 2));
    }
    // src/jsTyping/jsTyping.ts
    function isTypingUpToDate(cachedTyping, availableTypingVersions) {
        const availableVersion = new Version(getProperty(availableTypingVersions, `ts${versionMajorMinor}`) || getProperty(availableTypingVersions, "latest"));
        return availableVersion.compareTo(cachedTyping.version) <= 0;
    }
    function nonRelativeModuleNameForTypingCache(moduleName) {
        return nodeCoreModules.has(moduleName) ? "node" : moduleName;
    }
    function loadSafeList(host, safeListPath) {
        const result = readConfigFile(safeListPath, (path)=>host.readFile(path));
        return new Map(Object.entries(result.config));
    }
    function loadTypesMap(host, typesMapPath) {
        var _a;
        const result = readConfigFile(typesMapPath, (path)=>host.readFile(path));
        if ((_a = result.config) == null ? void 0 : _a.simpleMap) return new Map(Object.entries(result.config.simpleMap));
        return void 0;
    }
    function discoverTypings(host, log, fileNames, projectRootPath, safeList, packageNameToTypingLocation, typeAcquisition, unresolvedImports, typesRegistry, compilerOptions) {
        if (!typeAcquisition || !typeAcquisition.enable) return {
            cachedTypingPaths: [],
            newTypingNames: [],
            filesToWatch: []
        };
        const inferredTypings = /* @__PURE__ */ new Map();
        fileNames = mapDefined(fileNames, (fileName)=>{
            const path = normalizePath(fileName);
            if (hasJSFileExtension(path)) return path;
        });
        const filesToWatch = [];
        if (typeAcquisition.include) addInferredTypings(typeAcquisition.include, "Explicitly included types");
        const exclude = typeAcquisition.exclude || [];
        if (!compilerOptions.types) {
            const possibleSearchDirs = new Set(fileNames.map(getDirectoryPath));
            possibleSearchDirs.add(projectRootPath);
            possibleSearchDirs.forEach((searchDir)=>{
                getTypingNames(searchDir, "bower.json", "bower_components", filesToWatch);
                getTypingNames(searchDir, "package.json", "node_modules", filesToWatch);
            });
        }
        if (!typeAcquisition.disableFilenameBasedTypeAcquisition) getTypingNamesFromSourceFileNames(fileNames);
        if (unresolvedImports) {
            const module2 = deduplicate(unresolvedImports.map(nonRelativeModuleNameForTypingCache), equateStringsCaseSensitive, compareStringsCaseSensitive);
            addInferredTypings(module2, "Inferred typings from unresolved imports");
        }
        for (const excludeTypingName of exclude){
            const didDelete = inferredTypings.delete(excludeTypingName);
            if (didDelete && log) log(`Typing for ${excludeTypingName} is in exclude list, will be ignored.`);
        }
        packageNameToTypingLocation.forEach((typing, name)=>{
            const registryEntry = typesRegistry.get(name);
            if (inferredTypings.get(name) === false && registryEntry !== void 0 && isTypingUpToDate(typing, registryEntry)) inferredTypings.set(name, typing.typingLocation);
        });
        const newTypingNames = [];
        const cachedTypingPaths = [];
        inferredTypings.forEach((inferred, typing)=>{
            if (inferred) cachedTypingPaths.push(inferred);
            else newTypingNames.push(typing);
        });
        const result = {
            cachedTypingPaths,
            newTypingNames,
            filesToWatch
        };
        if (log) log(`Finished typings discovery:${stringifyIndented(result)}`);
        return result;
        function addInferredTyping(typingName) {
            if (!inferredTypings.has(typingName)) inferredTypings.set(typingName, false);
        }
        function addInferredTypings(typingNames, message) {
            if (log) log(`${message}: ${JSON.stringify(typingNames)}`);
            forEach(typingNames, addInferredTyping);
        }
        function getTypingNames(projectRootPath2, manifestName, modulesDirName, filesToWatch2) {
            const manifestPath = combinePaths(projectRootPath2, manifestName);
            let manifest;
            let manifestTypingNames;
            if (host.fileExists(manifestPath)) {
                filesToWatch2.push(manifestPath);
                manifest = readConfigFile(manifestPath, (path)=>host.readFile(path)).config;
                manifestTypingNames = flatMap([
                    manifest.dependencies,
                    manifest.devDependencies,
                    manifest.optionalDependencies,
                    manifest.peerDependencies
                ], getOwnKeys);
                addInferredTypings(manifestTypingNames, `Typing names in '${manifestPath}' dependencies`);
            }
            const packagesFolderPath = combinePaths(projectRootPath2, modulesDirName);
            filesToWatch2.push(packagesFolderPath);
            if (!host.directoryExists(packagesFolderPath)) return;
            const packageNames = [];
            const dependencyManifestNames = manifestTypingNames ? manifestTypingNames.map((typingName)=>combinePaths(packagesFolderPath, typingName, manifestName)) : host.readDirectory(packagesFolderPath, [
                ".json" /* Json */ 
            ], /*excludes*/ void 0, /*includes*/ void 0, /*depth*/ 3).filter((manifestPath2)=>{
                if (getBaseFileName(manifestPath2) !== manifestName) return false;
                const pathComponents2 = getPathComponents(normalizePath(manifestPath2));
                const isScoped = pathComponents2[pathComponents2.length - 3][0] === "@";
                return isScoped && toFileNameLowerCase(pathComponents2[pathComponents2.length - 4]) === modulesDirName || // `node_modules/@foo/bar`
                !isScoped && toFileNameLowerCase(pathComponents2[pathComponents2.length - 3]) === modulesDirName;
            });
            if (log) log(`Searching for typing names in ${packagesFolderPath}; all files: ${JSON.stringify(dependencyManifestNames)}`);
            for (const manifestPath2 of dependencyManifestNames){
                const normalizedFileName = normalizePath(manifestPath2);
                const result2 = readConfigFile(normalizedFileName, (path)=>host.readFile(path));
                const manifest2 = result2.config;
                if (!manifest2.name) continue;
                const ownTypes = manifest2.types || manifest2.typings;
                if (ownTypes) {
                    const absolutePath = getNormalizedAbsolutePath(ownTypes, getDirectoryPath(normalizedFileName));
                    if (host.fileExists(absolutePath)) {
                        if (log) log(`    Package '${manifest2.name}' provides its own types.`);
                        inferredTypings.set(manifest2.name, absolutePath);
                    } else if (log) log(`    Package '${manifest2.name}' provides its own types but they are missing.`);
                } else packageNames.push(manifest2.name);
            }
            addInferredTypings(packageNames, "    Found package names");
        }
        function getTypingNamesFromSourceFileNames(fileNames2) {
            const fromFileNames = mapDefined(fileNames2, (j)=>{
                if (!hasJSFileExtension(j)) return void 0;
                const inferredTypingName = removeFileExtension(toFileNameLowerCase(getBaseFileName(j)));
                const cleanedTypingName = removeMinAndVersionNumbers(inferredTypingName);
                return safeList.get(cleanedTypingName);
            });
            if (fromFileNames.length) addInferredTypings(fromFileNames, "Inferred typings from file names");
            const hasJsxFile = some(fileNames2, (f)=>fileExtensionIs(f, ".jsx" /* Jsx */ ));
            if (hasJsxFile) {
                if (log) log(`Inferred 'react' typings due to presence of '.jsx' extension`);
                addInferredTyping("react");
            }
        }
    }
    var NameValidationResult = /* @__PURE__ */ ((NameValidationResult2)=>{
        NameValidationResult2[NameValidationResult2["Ok"] = 0] = "Ok";
        NameValidationResult2[NameValidationResult2["EmptyName"] = 1] = "EmptyName";
        NameValidationResult2[NameValidationResult2["NameTooLong"] = 2] = "NameTooLong";
        NameValidationResult2[NameValidationResult2["NameStartsWithDot"] = 3] = "NameStartsWithDot";
        NameValidationResult2[NameValidationResult2["NameStartsWithUnderscore"] = 4] = "NameStartsWithUnderscore";
        NameValidationResult2[NameValidationResult2["NameContainsNonURISafeCharacters"] = 5] = "NameContainsNonURISafeCharacters";
        return NameValidationResult2;
    })(NameValidationResult || {});
    var maxPackageNameLength = 214;
    function validatePackageName(packageName) {
        return validatePackageNameWorker(packageName, /*supportScopedPackage*/ true);
    }
    function validatePackageNameWorker(packageName, supportScopedPackage) {
        if (!packageName) return 1 /* EmptyName */ ;
        if (packageName.length > maxPackageNameLength) return 2 /* NameTooLong */ ;
        if (packageName.charCodeAt(0) === 46 /* dot */ ) return 3 /* NameStartsWithDot */ ;
        if (packageName.charCodeAt(0) === 95 /* _ */ ) return 4 /* NameStartsWithUnderscore */ ;
        if (supportScopedPackage) {
            const matches = /^@([^/]+)\/([^/]+)$/.exec(packageName);
            if (matches) {
                const scopeResult = validatePackageNameWorker(matches[1], /*supportScopedPackage*/ false);
                if (scopeResult !== 0 /* Ok */ ) return {
                    name: matches[1],
                    isScopeName: true,
                    result: scopeResult
                };
                const packageResult = validatePackageNameWorker(matches[2], /*supportScopedPackage*/ false);
                if (packageResult !== 0 /* Ok */ ) return {
                    name: matches[2],
                    isScopeName: false,
                    result: packageResult
                };
                return 0 /* Ok */ ;
            }
        }
        if (encodeURIComponent(packageName) !== packageName) return 5 /* NameContainsNonURISafeCharacters */ ;
        return 0 /* Ok */ ;
    }
    function renderPackageNameValidationFailure(result, typing) {
        return typeof result === "object" ? renderPackageNameValidationFailureWorker(typing, result.result, result.name, result.isScopeName) : renderPackageNameValidationFailureWorker(typing, result, typing, /*isScopeName*/ false);
    }
    function renderPackageNameValidationFailureWorker(typing, result, name, isScopeName) {
        const kind = isScopeName ? "Scope" : "Package";
        switch(result){
            case 1 /* EmptyName */ :
                return `'${typing}':: ${kind} name '${name}' cannot be empty`;
            case 2 /* NameTooLong */ :
                return `'${typing}':: ${kind} name '${name}' should be less than ${maxPackageNameLength} characters`;
            case 3 /* NameStartsWithDot */ :
                return `'${typing}':: ${kind} name '${name}' cannot start with '.'`;
            case 4 /* NameStartsWithUnderscore */ :
                return `'${typing}':: ${kind} name '${name}' cannot start with '_'`;
            case 5 /* NameContainsNonURISafeCharacters */ :
                return `'${typing}':: ${kind} name '${name}' contains non URI safe characters`;
            case 0 /* Ok */ :
                return Debug.fail();
            // Shouldn't have called this.
            default:
                Debug.assertNever(result);
        }
    }
    // src/services/types.ts
    var ScriptSnapshot;
    ((ScriptSnapshot2)=>{
        class StringScriptSnapshot {
            getText(start, end) {
                return start === 0 && end === this.text.length ? this.text : this.text.substring(start, end);
            }
            getLength() {
                return this.text.length;
            }
            getChangeRange() {
                return void 0;
            }
            constructor(text){
                this.text = text;
            }
        }
        function fromString(text) {
            return new StringScriptSnapshot(text);
        }
        ScriptSnapshot2.fromString = fromString;
    })(ScriptSnapshot || (ScriptSnapshot = {}));
    var PackageJsonDependencyGroup = /* @__PURE__ */ ((PackageJsonDependencyGroup2)=>{
        PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["Dependencies"] = 1] = "Dependencies";
        PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["DevDependencies"] = 2] = "DevDependencies";
        PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["PeerDependencies"] = 4] = "PeerDependencies";
        PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["OptionalDependencies"] = 8] = "OptionalDependencies";
        PackageJsonDependencyGroup2[PackageJsonDependencyGroup2["All"] = 15] = "All";
        return PackageJsonDependencyGroup2;
    })(PackageJsonDependencyGroup || {});
    var PackageJsonAutoImportPreference = /* @__PURE__ */ ((PackageJsonAutoImportPreference2)=>{
        PackageJsonAutoImportPreference2[PackageJsonAutoImportPreference2["Off"] = 0] = "Off";
        PackageJsonAutoImportPreference2[PackageJsonAutoImportPreference2["On"] = 1] = "On";
        PackageJsonAutoImportPreference2[PackageJsonAutoImportPreference2["Auto"] = 2] = "Auto";
        return PackageJsonAutoImportPreference2;
    })(PackageJsonAutoImportPreference || {});
    var LanguageServiceMode = /* @__PURE__ */ ((LanguageServiceMode2)=>{
        LanguageServiceMode2[LanguageServiceMode2["Semantic"] = 0] = "Semantic";
        LanguageServiceMode2[LanguageServiceMode2["PartialSemantic"] = 1] = "PartialSemantic";
        LanguageServiceMode2[LanguageServiceMode2["Syntactic"] = 2] = "Syntactic";
        return LanguageServiceMode2;
    })(LanguageServiceMode || {});
    var emptyOptions = {};
    var SemanticClassificationFormat = /* @__PURE__ */ ((SemanticClassificationFormat2)=>{
        SemanticClassificationFormat2["Original"] = "original";
        SemanticClassificationFormat2["TwentyTwenty"] = "2020";
        return SemanticClassificationFormat2;
    })(SemanticClassificationFormat || {});
    var OrganizeImportsMode = /* @__PURE__ */ ((OrganizeImportsMode2)=>{
        OrganizeImportsMode2["All"] = "All";
        OrganizeImportsMode2["SortAndCombine"] = "SortAndCombine";
        OrganizeImportsMode2["RemoveUnused"] = "RemoveUnused";
        return OrganizeImportsMode2;
    })(OrganizeImportsMode || {});
    var CompletionTriggerKind = /* @__PURE__ */ ((CompletionTriggerKind2)=>{
        CompletionTriggerKind2[CompletionTriggerKind2["Invoked"] = 1] = "Invoked";
        CompletionTriggerKind2[CompletionTriggerKind2["TriggerCharacter"] = 2] = "TriggerCharacter";
        CompletionTriggerKind2[CompletionTriggerKind2["TriggerForIncompleteCompletions"] = 3] = "TriggerForIncompleteCompletions";
        return CompletionTriggerKind2;
    })(CompletionTriggerKind || {});
    var InlayHintKind2 = /* @__PURE__ */ ((InlayHintKind3)=>{
        InlayHintKind3["Type"] = "Type";
        InlayHintKind3["Parameter"] = "Parameter";
        InlayHintKind3["Enum"] = "Enum";
        return InlayHintKind3;
    })(InlayHintKind2 || {});
    var HighlightSpanKind = /* @__PURE__ */ ((HighlightSpanKind2)=>{
        HighlightSpanKind2["none"] = "none";
        HighlightSpanKind2["definition"] = "definition";
        HighlightSpanKind2["reference"] = "reference";
        HighlightSpanKind2["writtenReference"] = "writtenReference";
        return HighlightSpanKind2;
    })(HighlightSpanKind || {});
    var IndentStyle = /* @__PURE__ */ ((IndentStyle3)=>{
        IndentStyle3[IndentStyle3["None"] = 0] = "None";
        IndentStyle3[IndentStyle3["Block"] = 1] = "Block";
        IndentStyle3[IndentStyle3["Smart"] = 2] = "Smart";
        return IndentStyle3;
    })(IndentStyle || {});
    var SemicolonPreference = /* @__PURE__ */ ((SemicolonPreference2)=>{
        SemicolonPreference2["Ignore"] = "ignore";
        SemicolonPreference2["Insert"] = "insert";
        SemicolonPreference2["Remove"] = "remove";
        return SemicolonPreference2;
    })(SemicolonPreference || {});
    function getDefaultFormatCodeSettings(newLineCharacter) {
        return {
            indentSize: 4,
            tabSize: 4,
            newLineCharacter: newLineCharacter || "\n",
            convertTabsToSpaces: true,
            indentStyle: 2 /* Smart */ ,
            insertSpaceAfterConstructor: false,
            insertSpaceAfterCommaDelimiter: true,
            insertSpaceAfterSemicolonInForStatements: true,
            insertSpaceBeforeAndAfterBinaryOperators: true,
            insertSpaceAfterKeywordsInControlFlowStatements: true,
            insertSpaceAfterFunctionKeywordForAnonymousFunctions: false,
            insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis: false,
            insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets: false,
            insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces: true,
            insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces: false,
            insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces: false,
            insertSpaceBeforeFunctionParenthesis: false,
            placeOpenBraceOnNewLineForFunctions: false,
            placeOpenBraceOnNewLineForControlBlocks: false,
            semicolons: "ignore" /* Ignore */ ,
            trimTrailingWhitespace: true,
            indentSwitchCase: true
        };
    }
    var testFormatSettings = getDefaultFormatCodeSettings("\n");
    var SymbolDisplayPartKind = /* @__PURE__ */ ((SymbolDisplayPartKind2)=>{
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["aliasName"] = 0] = "aliasName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["className"] = 1] = "className";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["enumName"] = 2] = "enumName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["fieldName"] = 3] = "fieldName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["interfaceName"] = 4] = "interfaceName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["keyword"] = 5] = "keyword";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["lineBreak"] = 6] = "lineBreak";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["numericLiteral"] = 7] = "numericLiteral";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["stringLiteral"] = 8] = "stringLiteral";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["localName"] = 9] = "localName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["methodName"] = 10] = "methodName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["moduleName"] = 11] = "moduleName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["operator"] = 12] = "operator";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["parameterName"] = 13] = "parameterName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["propertyName"] = 14] = "propertyName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["punctuation"] = 15] = "punctuation";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["space"] = 16] = "space";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["text"] = 17] = "text";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["typeParameterName"] = 18] = "typeParameterName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["enumMemberName"] = 19] = "enumMemberName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["functionName"] = 20] = "functionName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["regularExpressionLiteral"] = 21] = "regularExpressionLiteral";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["link"] = 22] = "link";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["linkName"] = 23] = "linkName";
        SymbolDisplayPartKind2[SymbolDisplayPartKind2["linkText"] = 24] = "linkText";
        return SymbolDisplayPartKind2;
    })(SymbolDisplayPartKind || {});
    var CompletionInfoFlags = /* @__PURE__ */ ((CompletionInfoFlags2)=>{
        CompletionInfoFlags2[CompletionInfoFlags2["None"] = 0] = "None";
        CompletionInfoFlags2[CompletionInfoFlags2["MayIncludeAutoImports"] = 1] = "MayIncludeAutoImports";
        CompletionInfoFlags2[CompletionInfoFlags2["IsImportStatementCompletion"] = 2] = "IsImportStatementCompletion";
        CompletionInfoFlags2[CompletionInfoFlags2["IsContinuation"] = 4] = "IsContinuation";
        CompletionInfoFlags2[CompletionInfoFlags2["ResolvedModuleSpecifiers"] = 8] = "ResolvedModuleSpecifiers";
        CompletionInfoFlags2[CompletionInfoFlags2["ResolvedModuleSpecifiersBeyondLimit"] = 16] = "ResolvedModuleSpecifiersBeyondLimit";
        CompletionInfoFlags2[CompletionInfoFlags2["MayIncludeMethodSnippets"] = 32] = "MayIncludeMethodSnippets";
        return CompletionInfoFlags2;
    })(CompletionInfoFlags || {});
    var OutliningSpanKind = /* @__PURE__ */ ((OutliningSpanKind2)=>{
        OutliningSpanKind2["Comment"] = "comment";
        OutliningSpanKind2["Region"] = "region";
        OutliningSpanKind2["Code"] = "code";
        OutliningSpanKind2["Imports"] = "imports";
        return OutliningSpanKind2;
    })(OutliningSpanKind || {});
    var OutputFileType = /* @__PURE__ */ ((OutputFileType2)=>{
        OutputFileType2[OutputFileType2["JavaScript"] = 0] = "JavaScript";
        OutputFileType2[OutputFileType2["SourceMap"] = 1] = "SourceMap";
        OutputFileType2[OutputFileType2["Declaration"] = 2] = "Declaration";
        return OutputFileType2;
    })(OutputFileType || {});
    var EndOfLineState = /* @__PURE__ */ ((EndOfLineState2)=>{
        EndOfLineState2[EndOfLineState2["None"] = 0] = "None";
        EndOfLineState2[EndOfLineState2["InMultiLineCommentTrivia"] = 1] = "InMultiLineCommentTrivia";
        EndOfLineState2[EndOfLineState2["InSingleQuoteStringLiteral"] = 2] = "InSingleQuoteStringLiteral";
        EndOfLineState2[EndOfLineState2["InDoubleQuoteStringLiteral"] = 3] = "InDoubleQuoteStringLiteral";
        EndOfLineState2[EndOfLineState2["InTemplateHeadOrNoSubstitutionTemplate"] = 4] = "InTemplateHeadOrNoSubstitutionTemplate";
        EndOfLineState2[EndOfLineState2["InTemplateMiddleOrTail"] = 5] = "InTemplateMiddleOrTail";
        EndOfLineState2[EndOfLineState2["InTemplateSubstitutionPosition"] = 6] = "InTemplateSubstitutionPosition";
        return EndOfLineState2;
    })(EndOfLineState || {});
    var TokenClass = /* @__PURE__ */ ((TokenClass2)=>{
        TokenClass2[TokenClass2["Punctuation"] = 0] = "Punctuation";
        TokenClass2[TokenClass2["Keyword"] = 1] = "Keyword";
        TokenClass2[TokenClass2["Operator"] = 2] = "Operator";
        TokenClass2[TokenClass2["Comment"] = 3] = "Comment";
        TokenClass2[TokenClass2["Whitespace"] = 4] = "Whitespace";
        TokenClass2[TokenClass2["Identifier"] = 5] = "Identifier";
        TokenClass2[TokenClass2["NumberLiteral"] = 6] = "NumberLiteral";
        TokenClass2[TokenClass2["BigIntLiteral"] = 7] = "BigIntLiteral";
        TokenClass2[TokenClass2["StringLiteral"] = 8] = "StringLiteral";
        TokenClass2[TokenClass2["RegExpLiteral"] = 9] = "RegExpLiteral";
        return TokenClass2;
    })(TokenClass || {});
    var ScriptElementKind = /* @__PURE__ */ ((ScriptElementKind2)=>{
        ScriptElementKind2["unknown"] = "";
        ScriptElementKind2["warning"] = "warning";
        ScriptElementKind2["keyword"] = "keyword";
        ScriptElementKind2["scriptElement"] = "script";
        ScriptElementKind2["moduleElement"] = "module";
        ScriptElementKind2["classElement"] = "class";
        ScriptElementKind2["localClassElement"] = "local class";
        ScriptElementKind2["interfaceElement"] = "interface";
        ScriptElementKind2["typeElement"] = "type";
        ScriptElementKind2["enumElement"] = "enum";
        ScriptElementKind2["enumMemberElement"] = "enum member";
        ScriptElementKind2["variableElement"] = "var";
        ScriptElementKind2["localVariableElement"] = "local var";
        ScriptElementKind2["variableUsingElement"] = "using";
        ScriptElementKind2["variableAwaitUsingElement"] = "await using";
        ScriptElementKind2["functionElement"] = "function";
        ScriptElementKind2["localFunctionElement"] = "local function";
        ScriptElementKind2["memberFunctionElement"] = "method";
        ScriptElementKind2["memberGetAccessorElement"] = "getter";
        ScriptElementKind2["memberSetAccessorElement"] = "setter";
        ScriptElementKind2["memberVariableElement"] = "property";
        ScriptElementKind2["memberAccessorVariableElement"] = "accessor";
        ScriptElementKind2["constructorImplementationElement"] = "constructor";
        ScriptElementKind2["callSignatureElement"] = "call";
        ScriptElementKind2["indexSignatureElement"] = "index";
        ScriptElementKind2["constructSignatureElement"] = "construct";
        ScriptElementKind2["parameterElement"] = "parameter";
        ScriptElementKind2["typeParameterElement"] = "type parameter";
        ScriptElementKind2["primitiveType"] = "primitive type";
        ScriptElementKind2["label"] = "label";
        ScriptElementKind2["alias"] = "alias";
        ScriptElementKind2["constElement"] = "const";
        ScriptElementKind2["letElement"] = "let";
        ScriptElementKind2["directory"] = "directory";
        ScriptElementKind2["externalModuleName"] = "external module name";
        ScriptElementKind2["jsxAttribute"] = "JSX attribute";
        ScriptElementKind2["string"] = "string";
        ScriptElementKind2["link"] = "link";
        ScriptElementKind2["linkName"] = "link name";
        ScriptElementKind2["linkText"] = "link text";
        return ScriptElementKind2;
    })(ScriptElementKind || {});
    var ScriptElementKindModifier = /* @__PURE__ */ ((ScriptElementKindModifier2)=>{
        ScriptElementKindModifier2["none"] = "";
        ScriptElementKindModifier2["publicMemberModifier"] = "public";
        ScriptElementKindModifier2["privateMemberModifier"] = "private";
        ScriptElementKindModifier2["protectedMemberModifier"] = "protected";
        ScriptElementKindModifier2["exportedModifier"] = "export";
        ScriptElementKindModifier2["ambientModifier"] = "declare";
        ScriptElementKindModifier2["staticModifier"] = "static";
        ScriptElementKindModifier2["abstractModifier"] = "abstract";
        ScriptElementKindModifier2["optionalModifier"] = "optional";
        ScriptElementKindModifier2["deprecatedModifier"] = "deprecated";
        ScriptElementKindModifier2["dtsModifier"] = ".d.ts";
        ScriptElementKindModifier2["tsModifier"] = ".ts";
        ScriptElementKindModifier2["tsxModifier"] = ".tsx";
        ScriptElementKindModifier2["jsModifier"] = ".js";
        ScriptElementKindModifier2["jsxModifier"] = ".jsx";
        ScriptElementKindModifier2["jsonModifier"] = ".json";
        ScriptElementKindModifier2["dmtsModifier"] = ".d.mts";
        ScriptElementKindModifier2["mtsModifier"] = ".mts";
        ScriptElementKindModifier2["mjsModifier"] = ".mjs";
        ScriptElementKindModifier2["dctsModifier"] = ".d.cts";
        ScriptElementKindModifier2["ctsModifier"] = ".cts";
        ScriptElementKindModifier2["cjsModifier"] = ".cjs";
        return ScriptElementKindModifier2;
    })(ScriptElementKindModifier || {});
    var ClassificationTypeNames = /* @__PURE__ */ ((ClassificationTypeNames2)=>{
        ClassificationTypeNames2["comment"] = "comment";
        ClassificationTypeNames2["identifier"] = "identifier";
        ClassificationTypeNames2["keyword"] = "keyword";
        ClassificationTypeNames2["numericLiteral"] = "number";
        ClassificationTypeNames2["bigintLiteral"] = "bigint";
        ClassificationTypeNames2["operator"] = "operator";
        ClassificationTypeNames2["stringLiteral"] = "string";
        ClassificationTypeNames2["whiteSpace"] = "whitespace";
        ClassificationTypeNames2["text"] = "text";
        ClassificationTypeNames2["punctuation"] = "punctuation";
        ClassificationTypeNames2["className"] = "class name";
        ClassificationTypeNames2["enumName"] = "enum name";
        ClassificationTypeNames2["interfaceName"] = "interface name";
        ClassificationTypeNames2["moduleName"] = "module name";
        ClassificationTypeNames2["typeParameterName"] = "type parameter name";
        ClassificationTypeNames2["typeAliasName"] = "type alias name";
        ClassificationTypeNames2["parameterName"] = "parameter name";
        ClassificationTypeNames2["docCommentTagName"] = "doc comment tag name";
        ClassificationTypeNames2["jsxOpenTagName"] = "jsx open tag name";
        ClassificationTypeNames2["jsxCloseTagName"] = "jsx close tag name";
        ClassificationTypeNames2["jsxSelfClosingTagName"] = "jsx self closing tag name";
        ClassificationTypeNames2["jsxAttribute"] = "jsx attribute";
        ClassificationTypeNames2["jsxText"] = "jsx text";
        ClassificationTypeNames2["jsxAttributeStringLiteralValue"] = "jsx attribute string literal value";
        return ClassificationTypeNames2;
    })(ClassificationTypeNames || {});
    var ClassificationType = /* @__PURE__ */ ((ClassificationType2)=>{
        ClassificationType2[ClassificationType2["comment"] = 1] = "comment";
        ClassificationType2[ClassificationType2["identifier"] = 2] = "identifier";
        ClassificationType2[ClassificationType2["keyword"] = 3] = "keyword";
        ClassificationType2[ClassificationType2["numericLiteral"] = 4] = "numericLiteral";
        ClassificationType2[ClassificationType2["operator"] = 5] = "operator";
        ClassificationType2[ClassificationType2["stringLiteral"] = 6] = "stringLiteral";
        ClassificationType2[ClassificationType2["regularExpressionLiteral"] = 7] = "regularExpressionLiteral";
        ClassificationType2[ClassificationType2["whiteSpace"] = 8] = "whiteSpace";
        ClassificationType2[ClassificationType2["text"] = 9] = "text";
        ClassificationType2[ClassificationType2["punctuation"] = 10] = "punctuation";
        ClassificationType2[ClassificationType2["className"] = 11] = "className";
        ClassificationType2[ClassificationType2["enumName"] = 12] = "enumName";
        ClassificationType2[ClassificationType2["interfaceName"] = 13] = "interfaceName";
        ClassificationType2[ClassificationType2["moduleName"] = 14] = "moduleName";
        ClassificationType2[ClassificationType2["typeParameterName"] = 15] = "typeParameterName";
        ClassificationType2[ClassificationType2["typeAliasName"] = 16] = "typeAliasName";
        ClassificationType2[ClassificationType2["parameterName"] = 17] = "parameterName";
        ClassificationType2[ClassificationType2["docCommentTagName"] = 18] = "docCommentTagName";
        ClassificationType2[ClassificationType2["jsxOpenTagName"] = 19] = "jsxOpenTagName";
        ClassificationType2[ClassificationType2["jsxCloseTagName"] = 20] = "jsxCloseTagName";
        ClassificationType2[ClassificationType2["jsxSelfClosingTagName"] = 21] = "jsxSelfClosingTagName";
        ClassificationType2[ClassificationType2["jsxAttribute"] = 22] = "jsxAttribute";
        ClassificationType2[ClassificationType2["jsxText"] = 23] = "jsxText";
        ClassificationType2[ClassificationType2["jsxAttributeStringLiteralValue"] = 24] = "jsxAttributeStringLiteralValue";
        ClassificationType2[ClassificationType2["bigintLiteral"] = 25] = "bigintLiteral";
        return ClassificationType2;
    })(ClassificationType || {});
    // src/services/utilities.ts
    var scanner = createScanner(99 /* Latest */ , /*skipTrivia*/ true);
    var SemanticMeaning = /* @__PURE__ */ ((SemanticMeaning2)=>{
        SemanticMeaning2[SemanticMeaning2["None"] = 0] = "None";
        SemanticMeaning2[SemanticMeaning2["Value"] = 1] = "Value";
        SemanticMeaning2[SemanticMeaning2["Type"] = 2] = "Type";
        SemanticMeaning2[SemanticMeaning2["Namespace"] = 4] = "Namespace";
        SemanticMeaning2[SemanticMeaning2["All"] = 7] = "All";
        return SemanticMeaning2;
    })(SemanticMeaning || {});
    function getMeaningFromDeclaration(node) {
        switch(node.kind){
            case 261 /* VariableDeclaration */ :
                return isInJSFile(node) && getJSDocEnumTag(node) ? 7 /* All */  : 1 /* Value */ ;
            case 170 /* Parameter */ :
            case 209 /* BindingElement */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 304 /* PropertyAssignment */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 177 /* Constructor */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 300 /* CatchClause */ :
            case 292 /* JsxAttribute */ :
                return 1 /* Value */ ;
            case 169 /* TypeParameter */ :
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 188 /* TypeLiteral */ :
                return 2 /* Type */ ;
            case 347 /* JSDocTypedefTag */ :
                return node.name === void 0 ? 3 /* Type */  : 2 /* Type */ ;
            case 307 /* EnumMember */ :
            case 264 /* ClassDeclaration */ :
                return 3 /* Type */ ;
            case 268 /* ModuleDeclaration */ :
                if (isAmbientModule(node)) return 5 /* Value */ ;
                else if (getModuleInstanceState(node) === 1 /* Instantiated */ ) return 5 /* Value */ ;
                else return 4 /* Namespace */ ;
            case 267 /* EnumDeclaration */ :
            case 276 /* NamedImports */ :
            case 277 /* ImportSpecifier */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 273 /* ImportDeclaration */ :
            case 278 /* ExportAssignment */ :
            case 279 /* ExportDeclaration */ :
                return 7 /* All */ ;
            // An external module can be a Value
            case 308 /* SourceFile */ :
                return 5 /* Value */ ;
        }
        return 7 /* All */ ;
    }
    function getMeaningFromLocation(node) {
        node = getAdjustedReferenceLocation(node);
        const parent2 = node.parent;
        if (node.kind === 308 /* SourceFile */ ) return 1 /* Value */ ;
        else if (isExportAssignment(parent2) || isExportSpecifier(parent2) || isExternalModuleReference(parent2) || isImportSpecifier(parent2) || isImportClause(parent2) || isImportEqualsDeclaration(parent2) && node === parent2.name) return 7 /* All */ ;
        else if (isInRightSideOfInternalImportEqualsDeclaration(node)) return getMeaningFromRightHandSideOfImportEquals(node);
        else if (isDeclarationName(node)) return getMeaningFromDeclaration(parent2);
        else if (isEntityName(node) && findAncestor(node, or(isJSDocNameReference, isJSDocLinkLike, isJSDocMemberName))) return 7 /* All */ ;
        else if (isTypeReference(node)) return 2 /* Type */ ;
        else if (isNamespaceReference(node)) return 4 /* Namespace */ ;
        else if (isTypeParameterDeclaration(parent2)) {
            Debug.assert(isJSDocTemplateTag(parent2.parent));
            return 2 /* Type */ ;
        } else if (isLiteralTypeNode(parent2)) return 3 /* Value */ ;
        else return 1 /* Value */ ;
    }
    function getMeaningFromRightHandSideOfImportEquals(node) {
        const name = node.kind === 167 /* QualifiedName */  ? node : isQualifiedName(node.parent) && node.parent.right === node ? node.parent : void 0;
        return name && name.parent.kind === 272 /* ImportEqualsDeclaration */  ? 7 /* All */  : 4 /* Namespace */ ;
    }
    function isInRightSideOfInternalImportEqualsDeclaration(node) {
        if (!node.parent) return false;
        while(node.parent.kind === 167 /* QualifiedName */ )node = node.parent;
        return isInternalModuleImportEqualsDeclaration(node.parent) && node.parent.moduleReference === node;
    }
    function isNamespaceReference(node) {
        return isQualifiedNameNamespaceReference(node) || isPropertyAccessNamespaceReference(node);
    }
    function isQualifiedNameNamespaceReference(node) {
        let root = node;
        let isLastClause = true;
        if (root.parent.kind === 167 /* QualifiedName */ ) {
            while(root.parent && root.parent.kind === 167 /* QualifiedName */ )root = root.parent;
            isLastClause = root.right === node;
        }
        return root.parent.kind === 184 /* TypeReference */  && !isLastClause;
    }
    function isPropertyAccessNamespaceReference(node) {
        let root = node;
        let isLastClause = true;
        if (root.parent.kind === 212 /* PropertyAccessExpression */ ) {
            while(root.parent && root.parent.kind === 212 /* PropertyAccessExpression */ )root = root.parent;
            isLastClause = root.name === node;
        }
        if (!isLastClause && root.parent.kind === 234 /* ExpressionWithTypeArguments */  && root.parent.parent.kind === 299 /* HeritageClause */ ) {
            const decl = root.parent.parent.parent;
            return decl.kind === 264 /* ClassDeclaration */  && root.parent.parent.token === 119 /* ImplementsKeyword */  || decl.kind === 265 /* InterfaceDeclaration */  && root.parent.parent.token === 96 /* ExtendsKeyword */ ;
        }
        return false;
    }
    function isTypeReference(node) {
        if (isRightSideOfQualifiedNameOrPropertyAccess(node)) node = node.parent;
        switch(node.kind){
            case 110 /* ThisKeyword */ :
                return !isExpressionNode(node);
            case 198 /* ThisType */ :
                return true;
        }
        switch(node.parent.kind){
            case 184 /* TypeReference */ :
                return true;
            case 206 /* ImportType */ :
                return !node.parent.isTypeOf;
            case 234 /* ExpressionWithTypeArguments */ :
                return isPartOfTypeNode(node.parent);
        }
        return false;
    }
    function isCallExpressionTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isCallExpression, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isNewExpressionTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isNewExpression, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isCallOrNewExpressionTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isCallOrNewExpression, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isTaggedTemplateTag(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isTaggedTemplateExpression, selectTagOfTaggedTemplateExpression, includeElementAccess, skipPastOuterExpressions);
    }
    function isDecoratorTarget(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isDecorator, selectExpressionOfCallOrNewExpressionOrDecorator, includeElementAccess, skipPastOuterExpressions);
    }
    function isJsxOpeningLikeElementTagName(node, includeElementAccess = false, skipPastOuterExpressions = false) {
        return isCalleeWorker(node, isJsxOpeningLikeElement, selectTagNameOfJsxOpeningLikeElement, includeElementAccess, skipPastOuterExpressions);
    }
    function selectExpressionOfCallOrNewExpressionOrDecorator(node) {
        return node.expression;
    }
    function selectTagOfTaggedTemplateExpression(node) {
        return node.tag;
    }
    function selectTagNameOfJsxOpeningLikeElement(node) {
        return node.tagName;
    }
    function isCalleeWorker(node, pred, calleeSelector, includeElementAccess, skipPastOuterExpressions) {
        let target = includeElementAccess ? climbPastPropertyOrElementAccess(node) : climbPastPropertyAccess(node);
        if (skipPastOuterExpressions) target = skipOuterExpressions(target);
        return !!target && !!target.parent && pred(target.parent) && calleeSelector(target.parent) === target;
    }
    function climbPastPropertyAccess(node) {
        return isRightSideOfPropertyAccess(node) ? node.parent : node;
    }
    function climbPastPropertyOrElementAccess(node) {
        return isRightSideOfPropertyAccess(node) || isArgumentExpressionOfElementAccess(node) ? node.parent : node;
    }
    function getTargetLabel(referenceNode, labelName) {
        while(referenceNode){
            if (referenceNode.kind === 257 /* LabeledStatement */  && referenceNode.label.escapedText === labelName) return referenceNode.label;
            referenceNode = referenceNode.parent;
        }
        return void 0;
    }
    function hasPropertyAccessExpressionWithName(node, funcName) {
        if (!isPropertyAccessExpression(node.expression)) return false;
        return node.expression.name.text === funcName;
    }
    function isJumpStatementTarget(node) {
        var _a;
        return isIdentifier(node) && ((_a = tryCast(node.parent, isBreakOrContinueStatement)) == null ? void 0 : _a.label) === node;
    }
    function isLabelOfLabeledStatement(node) {
        var _a;
        return isIdentifier(node) && ((_a = tryCast(node.parent, isLabeledStatement)) == null ? void 0 : _a.label) === node;
    }
    function isLabelName(node) {
        return isLabelOfLabeledStatement(node) || isJumpStatementTarget(node);
    }
    function isTagName(node) {
        var _a;
        return ((_a = tryCast(node.parent, isJSDocTag)) == null ? void 0 : _a.tagName) === node;
    }
    function isRightSideOfQualifiedName(node) {
        var _a;
        return ((_a = tryCast(node.parent, isQualifiedName)) == null ? void 0 : _a.right) === node;
    }
    function isRightSideOfPropertyAccess(node) {
        var _a;
        return ((_a = tryCast(node.parent, isPropertyAccessExpression)) == null ? void 0 : _a.name) === node;
    }
    function isArgumentExpressionOfElementAccess(node) {
        var _a;
        return ((_a = tryCast(node.parent, isElementAccessExpression)) == null ? void 0 : _a.argumentExpression) === node;
    }
    function isNameOfModuleDeclaration(node) {
        var _a;
        return ((_a = tryCast(node.parent, isModuleDeclaration)) == null ? void 0 : _a.name) === node;
    }
    function isNameOfFunctionDeclaration(node) {
        var _a;
        return isIdentifier(node) && ((_a = tryCast(node.parent, isFunctionLike)) == null ? void 0 : _a.name) === node;
    }
    function isLiteralNameOfPropertyDeclarationOrIndexAccess(node) {
        switch(node.parent.kind){
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 304 /* PropertyAssignment */ :
            case 307 /* EnumMember */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 268 /* ModuleDeclaration */ :
                return getNameOfDeclaration(node.parent) === node;
            case 213 /* ElementAccessExpression */ :
                return node.parent.argumentExpression === node;
            case 168 /* ComputedPropertyName */ :
                return true;
            case 202 /* LiteralType */ :
                return node.parent.parent.kind === 200 /* IndexedAccessType */ ;
            default:
                return false;
        }
    }
    function isExpressionOfExternalModuleImportEqualsDeclaration(node) {
        return isExternalModuleImportEqualsDeclaration(node.parent.parent) && getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node;
    }
    function getContainerNode(node) {
        if (isJSDocTypeAlias(node)) node = node.parent.parent;
        while(true){
            node = node.parent;
            if (!node) return void 0;
            switch(node.kind){
                case 308 /* SourceFile */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 267 /* EnumDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                    return node;
            }
        }
    }
    function getNodeKind(node) {
        switch(node.kind){
            case 308 /* SourceFile */ :
                return isExternalModule(node) ? "module" /* moduleElement */  : "script" /* scriptElement */ ;
            case 268 /* ModuleDeclaration */ :
                return "module" /* moduleElement */ ;
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
                return "class" /* classElement */ ;
            case 265 /* InterfaceDeclaration */ :
                return "interface" /* interfaceElement */ ;
            case 266 /* TypeAliasDeclaration */ :
            case 339 /* JSDocCallbackTag */ :
            case 347 /* JSDocTypedefTag */ :
                return "type" /* typeElement */ ;
            case 267 /* EnumDeclaration */ :
                return "enum" /* enumElement */ ;
            case 261 /* VariableDeclaration */ :
                return getKindOfVariableDeclaration(node);
            case 209 /* BindingElement */ :
                return getKindOfVariableDeclaration(getRootDeclaration(node));
            case 220 /* ArrowFunction */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
                return "function" /* functionElement */ ;
            case 178 /* GetAccessor */ :
                return "getter" /* memberGetAccessorElement */ ;
            case 179 /* SetAccessor */ :
                return "setter" /* memberSetAccessorElement */ ;
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
                return "method" /* memberFunctionElement */ ;
            case 304 /* PropertyAssignment */ :
                const { initializer } = node;
                return isFunctionLike(initializer) ? "method" /* memberFunctionElement */  : "property" /* memberVariableElement */ ;
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 306 /* SpreadAssignment */ :
                return "property" /* memberVariableElement */ ;
            case 182 /* IndexSignature */ :
                return "index" /* indexSignatureElement */ ;
            case 181 /* ConstructSignature */ :
                return "construct" /* constructSignatureElement */ ;
            case 180 /* CallSignature */ :
                return "call" /* callSignatureElement */ ;
            case 177 /* Constructor */ :
            case 176 /* ClassStaticBlockDeclaration */ :
                return "constructor" /* constructorImplementationElement */ ;
            case 169 /* TypeParameter */ :
                return "type parameter" /* typeParameterElement */ ;
            case 307 /* EnumMember */ :
                return "enum member" /* enumMemberElement */ ;
            case 170 /* Parameter */ :
                return hasSyntacticModifier(node, 31 /* ParameterPropertyModifier */ ) ? "property" /* memberVariableElement */  : "parameter" /* parameterElement */ ;
            case 272 /* ImportEqualsDeclaration */ :
            case 277 /* ImportSpecifier */ :
            case 282 /* ExportSpecifier */ :
            case 275 /* NamespaceImport */ :
            case 281 /* NamespaceExport */ :
                return "alias" /* alias */ ;
            case 227 /* BinaryExpression */ :
                const kind = getAssignmentDeclarationKind(node);
                const { right } = node;
                switch(kind){
                    case 7 /* ObjectDefinePropertyValue */ :
                    case 8 /* ObjectDefinePropertyExports */ :
                    case 9 /* ObjectDefinePrototypeProperty */ :
                    case 0 /* None */ :
                        return "" /* unknown */ ;
                    case 1 /* ExportsProperty */ :
                    case 2 /* ModuleExports */ :
                        const rightKind = getNodeKind(right);
                        return rightKind === "" /* unknown */  ? "const" /* constElement */  : rightKind;
                    case 3 /* PrototypeProperty */ :
                        return isFunctionExpression(right) ? "method" /* memberFunctionElement */  : "property" /* memberVariableElement */ ;
                    case 4 /* ThisProperty */ :
                        return "property" /* memberVariableElement */ ;
                    // property
                    case 5 /* Property */ :
                        return isFunctionExpression(right) ? "method" /* memberFunctionElement */  : "property" /* memberVariableElement */ ;
                    case 6 /* Prototype */ :
                        return "local class" /* localClassElement */ ;
                    default:
                        assertType(kind);
                        return "" /* unknown */ ;
                }
            case 80 /* Identifier */ :
                return isImportClause(node.parent) ? "alias" /* alias */  : "" /* unknown */ ;
            case 278 /* ExportAssignment */ :
                const scriptKind = getNodeKind(node.expression);
                return scriptKind === "" /* unknown */  ? "const" /* constElement */  : scriptKind;
            default:
                return "" /* unknown */ ;
        }
        function getKindOfVariableDeclaration(v1) {
            return isVarConst(v1) ? "const" /* constElement */  : isLet(v1) ? "let" /* letElement */  : "var" /* variableElement */ ;
        }
    }
    function isThis(node) {
        switch(node.kind){
            case 110 /* ThisKeyword */ :
                return true;
            case 80 /* Identifier */ :
                return identifierIsThisKeyword(node) && node.parent.kind === 170 /* Parameter */ ;
            default:
                return false;
        }
    }
    var tripleSlashDirectivePrefixRegex = /^\/\/\/\s*</;
    function getLineStartPositionForPosition(position, sourceFile) {
        const lineStarts = getLineStarts(sourceFile);
        const line = sourceFile.getLineAndCharacterOfPosition(position).line;
        return lineStarts[line];
    }
    function rangeContainsRangeExclusive(r1, r2) {
        return rangeContainsPositionExclusive(r1, r2.pos) && rangeContainsPositionExclusive(r1, r2.end);
    }
    function rangeContainsPosition(r, pos) {
        return r.pos <= pos && pos <= r.end;
    }
    function rangeContainsPositionExclusive(r, pos) {
        return r.pos < pos && pos < r.end;
    }
    function rangeContainsStartEnd(range, start, end) {
        return range.pos <= start && range.end >= end;
    }
    function rangeOverlapsWithStartEnd(r1, start, end) {
        return startEndOverlapsWithStartEnd(r1.pos, r1.end, start, end);
    }
    function nodeOverlapsWithStartEnd(node, sourceFile, start, end) {
        return startEndOverlapsWithStartEnd(node.getStart(sourceFile), node.end, start, end);
    }
    function startEndOverlapsWithStartEnd(start1, end1, start2, end2) {
        const start = Math.max(start1, start2);
        const end = Math.min(end1, end2);
        return start < end;
    }
    function positionBelongsToNode(candidate, position, sourceFile) {
        Debug.assert(candidate.pos <= position);
        return position < candidate.end || !isCompletedNode(candidate, sourceFile);
    }
    function isCompletedNode(n, sourceFile) {
        if (n === void 0 || nodeIsMissing(n)) return false;
        switch(n.kind){
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 211 /* ObjectLiteralExpression */ :
            case 207 /* ObjectBindingPattern */ :
            case 188 /* TypeLiteral */ :
            case 242 /* Block */ :
            case 269 /* ModuleBlock */ :
            case 270 /* CaseBlock */ :
            case 276 /* NamedImports */ :
            case 280 /* NamedExports */ :
                return nodeEndsWith(n, 20 /* CloseBraceToken */ , sourceFile);
            case 300 /* CatchClause */ :
                return isCompletedNode(n.block, sourceFile);
            case 215 /* NewExpression */ :
                if (!n.arguments) return true;
            // falls through
            case 214 /* CallExpression */ :
            case 218 /* ParenthesizedExpression */ :
            case 197 /* ParenthesizedType */ :
                return nodeEndsWith(n, 22 /* CloseParenToken */ , sourceFile);
            case 185 /* FunctionType */ :
            case 186 /* ConstructorType */ :
                return isCompletedNode(n.type, sourceFile);
            case 177 /* Constructor */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 181 /* ConstructSignature */ :
            case 180 /* CallSignature */ :
            case 220 /* ArrowFunction */ :
                if (n.body) return isCompletedNode(n.body, sourceFile);
                if (n.type) return isCompletedNode(n.type, sourceFile);
                return hasChildOfKind(n, 22 /* CloseParenToken */ , sourceFile);
            case 268 /* ModuleDeclaration */ :
                return !!n.body && isCompletedNode(n.body, sourceFile);
            case 246 /* IfStatement */ :
                if (n.elseStatement) return isCompletedNode(n.elseStatement, sourceFile);
                return isCompletedNode(n.thenStatement, sourceFile);
            case 245 /* ExpressionStatement */ :
                return isCompletedNode(n.expression, sourceFile) || hasChildOfKind(n, 27 /* SemicolonToken */ , sourceFile);
            case 210 /* ArrayLiteralExpression */ :
            case 208 /* ArrayBindingPattern */ :
            case 213 /* ElementAccessExpression */ :
            case 168 /* ComputedPropertyName */ :
            case 190 /* TupleType */ :
                return nodeEndsWith(n, 24 /* CloseBracketToken */ , sourceFile);
            case 182 /* IndexSignature */ :
                if (n.type) return isCompletedNode(n.type, sourceFile);
                return hasChildOfKind(n, 24 /* CloseBracketToken */ , sourceFile);
            case 297 /* CaseClause */ :
            case 298 /* DefaultClause */ :
                return false;
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 248 /* WhileStatement */ :
                return isCompletedNode(n.statement, sourceFile);
            case 247 /* DoStatement */ :
                return hasChildOfKind(n, 117 /* WhileKeyword */ , sourceFile) ? nodeEndsWith(n, 22 /* CloseParenToken */ , sourceFile) : isCompletedNode(n.statement, sourceFile);
            case 187 /* TypeQuery */ :
                return isCompletedNode(n.exprName, sourceFile);
            case 222 /* TypeOfExpression */ :
            case 221 /* DeleteExpression */ :
            case 223 /* VoidExpression */ :
            case 230 /* YieldExpression */ :
            case 231 /* SpreadElement */ :
                const unaryWordExpression = n;
                return isCompletedNode(unaryWordExpression.expression, sourceFile);
            case 216 /* TaggedTemplateExpression */ :
                return isCompletedNode(n.template, sourceFile);
            case 229 /* TemplateExpression */ :
                const lastSpan = lastOrUndefined(n.templateSpans);
                return isCompletedNode(lastSpan, sourceFile);
            case 240 /* TemplateSpan */ :
                return nodeIsPresent(n.literal);
            case 279 /* ExportDeclaration */ :
            case 273 /* ImportDeclaration */ :
                return nodeIsPresent(n.moduleSpecifier);
            case 225 /* PrefixUnaryExpression */ :
                return isCompletedNode(n.operand, sourceFile);
            case 227 /* BinaryExpression */ :
                return isCompletedNode(n.right, sourceFile);
            case 228 /* ConditionalExpression */ :
                return isCompletedNode(n.whenFalse, sourceFile);
            default:
                return true;
        }
    }
    function nodeEndsWith(n, expectedLastToken, sourceFile) {
        const children = n.getChildren(sourceFile);
        if (children.length) {
            const lastChild = last(children);
            if (lastChild.kind === expectedLastToken) return true;
            else if (lastChild.kind === 27 /* SemicolonToken */  && children.length !== 1) return children[children.length - 2].kind === expectedLastToken;
        }
        return false;
    }
    function findListItemInfo(node) {
        const list = findContainingList(node);
        if (!list) return void 0;
        const children = list.getChildren();
        const listItemIndex = indexOfNode(children, node);
        return {
            listItemIndex,
            list
        };
    }
    function hasChildOfKind(n, kind, sourceFile) {
        return !!findChildOfKind(n, kind, sourceFile);
    }
    function findChildOfKind(n, kind, sourceFile) {
        return find(n.getChildren(sourceFile), (c)=>c.kind === kind);
    }
    function findContainingList(node) {
        const syntaxList = find(node.parent.getChildren(), (c)=>isSyntaxList(c) && rangeContainsRange(c, node));
        Debug.assert(!syntaxList || contains(syntaxList.getChildren(), node));
        return syntaxList;
    }
    function isDefaultModifier2(node) {
        return node.kind === 90 /* DefaultKeyword */ ;
    }
    function isClassKeyword(node) {
        return node.kind === 86 /* ClassKeyword */ ;
    }
    function isFunctionKeyword(node) {
        return node.kind === 100 /* FunctionKeyword */ ;
    }
    function getAdjustedLocationForClass(node) {
        if (isNamedDeclaration(node)) return node.name;
        if (isClassDeclaration(node)) {
            const defaultModifier = node.modifiers && find(node.modifiers, isDefaultModifier2);
            if (defaultModifier) return defaultModifier;
        }
        if (isClassExpression(node)) {
            const classKeyword = find(node.getChildren(), isClassKeyword);
            if (classKeyword) return classKeyword;
        }
    }
    function getAdjustedLocationForFunction(node) {
        if (isNamedDeclaration(node)) return node.name;
        if (isFunctionDeclaration(node)) {
            const defaultModifier = find(node.modifiers, isDefaultModifier2);
            if (defaultModifier) return defaultModifier;
        }
        if (isFunctionExpression(node)) {
            const functionKeyword = find(node.getChildren(), isFunctionKeyword);
            if (functionKeyword) return functionKeyword;
        }
    }
    function getAncestorTypeNode(node) {
        let lastTypeNode;
        findAncestor(node, (a)=>{
            if (isTypeNode(a)) lastTypeNode = a;
            return !isQualifiedName(a.parent) && !isTypeNode(a.parent) && !isTypeElement(a.parent);
        });
        return lastTypeNode;
    }
    function getContextualTypeFromParentOrAncestorTypeNode(node, checker) {
        if (node.flags & 16777216 /* JavaScriptFile */ ) return void 0;
        const contextualType = getContextualTypeFromParent(node, checker);
        if (contextualType) return contextualType;
        const ancestorTypeNode = getAncestorTypeNode(node);
        return ancestorTypeNode && checker.getTypeAtLocation(ancestorTypeNode);
    }
    function getAdjustedLocationForDeclaration(node, forRename) {
        if (!forRename) switch(node.kind){
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
                return getAdjustedLocationForClass(node);
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
                return getAdjustedLocationForFunction(node);
            case 177 /* Constructor */ :
                return node;
        }
        if (isNamedDeclaration(node)) return node.name;
    }
    function getAdjustedLocationForImportDeclaration(node, forRename) {
        if (node.importClause) {
            if (node.importClause.name && node.importClause.namedBindings) return;
            if (node.importClause.name) return node.importClause.name;
            if (node.importClause.namedBindings) {
                if (isNamedImports(node.importClause.namedBindings)) {
                    const onlyBinding = singleOrUndefined(node.importClause.namedBindings.elements);
                    if (!onlyBinding) return;
                    return onlyBinding.name;
                } else if (isNamespaceImport(node.importClause.namedBindings)) return node.importClause.namedBindings.name;
            }
        }
        if (!forRename) return node.moduleSpecifier;
    }
    function getAdjustedLocationForExportDeclaration(node, forRename) {
        if (node.exportClause) {
            if (isNamedExports(node.exportClause)) {
                const onlyBinding = singleOrUndefined(node.exportClause.elements);
                if (!onlyBinding) return;
                return node.exportClause.elements[0].name;
            } else if (isNamespaceExport(node.exportClause)) return node.exportClause.name;
        }
        if (!forRename) return node.moduleSpecifier;
    }
    function getAdjustedLocationForHeritageClause(node) {
        if (node.types.length === 1) return node.types[0].expression;
    }
    function getAdjustedLocation(node, forRename) {
        const { parent: parent2 } = node;
        if (isModifier(node) && (forRename || node.kind !== 90 /* DefaultKeyword */ ) ? canHaveModifiers(parent2) && contains(parent2.modifiers, node) : node.kind === 86 /* ClassKeyword */  ? isClassDeclaration(parent2) || isClassExpression(node) : node.kind === 100 /* FunctionKeyword */  ? isFunctionDeclaration(parent2) || isFunctionExpression(node) : node.kind === 120 /* InterfaceKeyword */  ? isInterfaceDeclaration(parent2) : node.kind === 94 /* EnumKeyword */  ? isEnumDeclaration(parent2) : node.kind === 156 /* TypeKeyword */  ? isTypeAliasDeclaration(parent2) : node.kind === 145 /* NamespaceKeyword */  || node.kind === 144 /* ModuleKeyword */  ? isModuleDeclaration(parent2) : node.kind === 102 /* ImportKeyword */  ? isImportEqualsDeclaration(parent2) : node.kind === 139 /* GetKeyword */  ? isGetAccessorDeclaration(parent2) : node.kind === 153 /* SetKeyword */  && isSetAccessorDeclaration(parent2)) {
            const location = getAdjustedLocationForDeclaration(parent2, forRename);
            if (location) return location;
        }
        if ((node.kind === 115 /* VarKeyword */  || node.kind === 87 /* ConstKeyword */  || node.kind === 121 /* LetKeyword */ ) && isVariableDeclarationList(parent2) && parent2.declarations.length === 1) {
            const decl = parent2.declarations[0];
            if (isIdentifier(decl.name)) return decl.name;
        }
        if (node.kind === 156 /* TypeKeyword */ ) {
            if (isImportClause(parent2) && parent2.isTypeOnly) {
                const location = getAdjustedLocationForImportDeclaration(parent2.parent, forRename);
                if (location) return location;
            }
            if (isExportDeclaration(parent2) && parent2.isTypeOnly) {
                const location = getAdjustedLocationForExportDeclaration(parent2, forRename);
                if (location) return location;
            }
        }
        if (node.kind === 130 /* AsKeyword */ ) {
            if (isImportSpecifier(parent2) && parent2.propertyName || isExportSpecifier(parent2) && parent2.propertyName || isNamespaceImport(parent2) || isNamespaceExport(parent2)) return parent2.name;
            if (isExportDeclaration(parent2) && parent2.exportClause && isNamespaceExport(parent2.exportClause)) return parent2.exportClause.name;
        }
        if (node.kind === 102 /* ImportKeyword */  && isImportDeclaration(parent2)) {
            const location = getAdjustedLocationForImportDeclaration(parent2, forRename);
            if (location) return location;
        }
        if (node.kind === 95 /* ExportKeyword */ ) {
            if (isExportDeclaration(parent2)) {
                const location = getAdjustedLocationForExportDeclaration(parent2, forRename);
                if (location) return location;
            }
            if (isExportAssignment(parent2)) return skipOuterExpressions(parent2.expression);
        }
        if (node.kind === 149 /* RequireKeyword */  && isExternalModuleReference(parent2)) return parent2.expression;
        if (node.kind === 161 /* FromKeyword */  && (isImportDeclaration(parent2) || isExportDeclaration(parent2)) && parent2.moduleSpecifier) return parent2.moduleSpecifier;
        if ((node.kind === 96 /* ExtendsKeyword */  || node.kind === 119 /* ImplementsKeyword */ ) && isHeritageClause(parent2) && parent2.token === node.kind) {
            const location = getAdjustedLocationForHeritageClause(parent2);
            if (location) return location;
        }
        if (node.kind === 96 /* ExtendsKeyword */ ) {
            if (isTypeParameterDeclaration(parent2) && parent2.constraint && isTypeReferenceNode(parent2.constraint)) return parent2.constraint.typeName;
            if (isConditionalTypeNode(parent2) && isTypeReferenceNode(parent2.extendsType)) return parent2.extendsType.typeName;
        }
        if (node.kind === 140 /* InferKeyword */  && isInferTypeNode(parent2)) return parent2.typeParameter.name;
        if (node.kind === 103 /* InKeyword */  && isTypeParameterDeclaration(parent2) && isMappedTypeNode(parent2.parent)) return parent2.name;
        if (node.kind === 143 /* KeyOfKeyword */  && isTypeOperatorNode(parent2) && parent2.operator === 143 /* KeyOfKeyword */  && isTypeReferenceNode(parent2.type)) return parent2.type.typeName;
        if (node.kind === 148 /* ReadonlyKeyword */  && isTypeOperatorNode(parent2) && parent2.operator === 148 /* ReadonlyKeyword */  && isArrayTypeNode(parent2.type) && isTypeReferenceNode(parent2.type.elementType)) return parent2.type.elementType.typeName;
        if (!forRename) {
            if (node.kind === 105 /* NewKeyword */  && isNewExpression(parent2) || node.kind === 116 /* VoidKeyword */  && isVoidExpression(parent2) || node.kind === 114 /* TypeOfKeyword */  && isTypeOfExpression(parent2) || node.kind === 135 /* AwaitKeyword */  && isAwaitExpression(parent2) || node.kind === 127 /* YieldKeyword */  && isYieldExpression(parent2) || node.kind === 91 /* DeleteKeyword */  && isDeleteExpression(parent2)) {
                if (parent2.expression) return skipOuterExpressions(parent2.expression);
            }
            if ((node.kind === 103 /* InKeyword */  || node.kind === 104 /* InstanceOfKeyword */ ) && isBinaryExpression(parent2) && parent2.operatorToken === node) return skipOuterExpressions(parent2.right);
            if (node.kind === 130 /* AsKeyword */  && isAsExpression(parent2) && isTypeReferenceNode(parent2.type)) return parent2.type.typeName;
            if (node.kind === 103 /* InKeyword */  && isForInStatement(parent2) || node.kind === 165 /* OfKeyword */  && isForOfStatement(parent2)) return skipOuterExpressions(parent2.expression);
        }
        return node;
    }
    function getAdjustedReferenceLocation(node) {
        return getAdjustedLocation(node, /*forRename*/ false);
    }
    function getAdjustedRenameLocation(node) {
        return getAdjustedLocation(node, /*forRename*/ true);
    }
    function getTouchingPropertyName(sourceFile, position) {
        return getTouchingToken(sourceFile, position, (n)=>isPropertyNameLiteral(n) || isKeyword(n.kind) || isPrivateIdentifier(n));
    }
    function getTouchingToken(sourceFile, position, includePrecedingTokenAtEndPosition) {
        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ false, includePrecedingTokenAtEndPosition, /*includeEndPosition*/ false);
    }
    function getTokenAtPosition(sourceFile, position) {
        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ true, /*includePrecedingTokenAtEndPosition*/ void 0, /*includeEndPosition*/ false);
    }
    function getTokenAtPositionWorker(sourceFile, position, allowPositionInLeadingTrivia, includePrecedingTokenAtEndPosition, includeEndPosition) {
        let current = sourceFile;
        let foundToken;
        outer: while(true){
            const children = current.getChildren(sourceFile);
            const i = binarySearchKey(children, position, (_, i2)=>i2, (middle, _)=>{
                const end = children[middle].getEnd();
                if (end < position) return -1 /* LessThan */ ;
                const start = allowPositionInLeadingTrivia ? children[middle].getFullStart() : children[middle].getStart(sourceFile, /*includeJsDocComment*/ true);
                if (start > position) return 1 /* GreaterThan */ ;
                if (nodeContainsPosition(children[middle], start, end)) {
                    if (children[middle - 1]) {
                        if (nodeContainsPosition(children[middle - 1])) return 1 /* GreaterThan */ ;
                    }
                    return 0 /* EqualTo */ ;
                }
                if (includePrecedingTokenAtEndPosition && start === position && children[middle - 1] && children[middle - 1].getEnd() === position && nodeContainsPosition(children[middle - 1])) return 1 /* GreaterThan */ ;
                return -1 /* LessThan */ ;
            });
            if (foundToken) return foundToken;
            if (i >= 0 && children[i]) {
                current = children[i];
                continue outer;
            }
            return current;
        }
        function nodeContainsPosition(node, start, end) {
            end !== null && end !== void 0 ? end : end = node.getEnd();
            if (end < position) return false;
            start !== null && start !== void 0 ? start : start = allowPositionInLeadingTrivia ? node.getFullStart() : node.getStart(sourceFile, /*includeJsDocComment*/ true);
            if (start > position) return false;
            if (position < end || position === end && (node.kind === 1 /* EndOfFileToken */  || includeEndPosition)) return true;
            else if (includePrecedingTokenAtEndPosition && end === position) {
                const previousToken = findPrecedingToken(position, sourceFile, node);
                if (previousToken && includePrecedingTokenAtEndPosition(previousToken)) {
                    foundToken = previousToken;
                    return true;
                }
            }
            return false;
        }
    }
    function findFirstNonJsxWhitespaceToken(sourceFile, position) {
        let tokenAtPosition = getTokenAtPosition(sourceFile, position);
        while(isWhiteSpaceOnlyJsxText(tokenAtPosition)){
            const nextToken = findNextToken(tokenAtPosition, tokenAtPosition.parent, sourceFile);
            if (!nextToken) return;
            tokenAtPosition = nextToken;
        }
        return tokenAtPosition;
    }
    function findTokenOnLeftOfPosition(file, position) {
        const tokenAtPosition = getTokenAtPosition(file, position);
        if (isToken(tokenAtPosition) && position > tokenAtPosition.getStart(file) && position < tokenAtPosition.getEnd()) return tokenAtPosition;
        return findPrecedingToken(position, file);
    }
    function findNextToken(previousToken, parent2, sourceFile) {
        return find2(parent2);
        function find2(n) {
            if (isToken(n) && n.pos === previousToken.end) return n;
            return firstDefined(n.getChildren(sourceFile), (child)=>{
                const shouldDiveInChildNode = // previous token is enclosed somewhere in the child
                child.pos <= previousToken.pos && child.end > previousToken.end || // previous token ends exactly at the beginning of child
                child.pos === previousToken.end;
                return shouldDiveInChildNode && nodeHasTokens(child, sourceFile) ? find2(child) : void 0;
            });
        }
    }
    function findPrecedingToken(position, sourceFile, startNode2, excludeJsdoc) {
        const result = find2(startNode2 || sourceFile);
        Debug.assert(!(result && isWhiteSpaceOnlyJsxText(result)));
        return result;
        function find2(n) {
            if (isNonWhitespaceToken(n) && n.kind !== 1 /* EndOfFileToken */ ) return n;
            const children = n.getChildren(sourceFile);
            const i = binarySearchKey(children, position, (_, i2)=>i2, (middle, _)=>{
                if (position < children[middle].end) {
                    if (!children[middle - 1] || position >= children[middle - 1].end) return 0 /* EqualTo */ ;
                    return 1 /* GreaterThan */ ;
                }
                return -1 /* LessThan */ ;
            });
            if (i >= 0 && children[i]) {
                const child = children[i];
                if (position < child.end) {
                    const start = child.getStart(sourceFile, /*includeJsDoc*/ !excludeJsdoc);
                    const lookInPreviousChild = start >= position || // cursor in the leading trivia
                    !nodeHasTokens(child, sourceFile) || isWhiteSpaceOnlyJsxText(child);
                    if (lookInPreviousChild) {
                        const candidate2 = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ i, sourceFile, n.kind);
                        if (candidate2) {
                            if (!excludeJsdoc && isJSDocCommentContainingNode(candidate2) && candidate2.getChildren(sourceFile).length) return find2(candidate2);
                            return findRightmostToken(candidate2, sourceFile);
                        }
                        return void 0;
                    } else return find2(child);
                }
            }
            Debug.assert(startNode2 !== void 0 || n.kind === 308 /* SourceFile */  || n.kind === 1 /* EndOfFileToken */  || isJSDocCommentContainingNode(n));
            const candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length, sourceFile, n.kind);
            return candidate && findRightmostToken(candidate, sourceFile);
        }
    }
    function isNonWhitespaceToken(n) {
        return isToken(n) && !isWhiteSpaceOnlyJsxText(n);
    }
    function findRightmostToken(n, sourceFile) {
        if (isNonWhitespaceToken(n)) return n;
        const children = n.getChildren(sourceFile);
        if (children.length === 0) return n;
        const candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length, sourceFile, n.kind);
        return candidate && findRightmostToken(candidate, sourceFile);
    }
    function findRightmostChildNodeWithTokens(children, exclusiveStartPosition, sourceFile, parentKind) {
        for(let i = exclusiveStartPosition - 1; i >= 0; i--){
            const child = children[i];
            if (isWhiteSpaceOnlyJsxText(child)) {
                if (i === 0 && (parentKind === 12 /* JsxText */  || parentKind === 286 /* JsxSelfClosingElement */ )) Debug.fail("`JsxText` tokens should not be the first child of `JsxElement | JsxSelfClosingElement`");
            } else if (nodeHasTokens(children[i], sourceFile)) return children[i];
        }
    }
    function isInString(sourceFile, position, previousToken = findPrecedingToken(position, sourceFile)) {
        if (previousToken && isStringTextContainingNode(previousToken)) {
            const start = previousToken.getStart(sourceFile);
            const end = previousToken.getEnd();
            if (start < position && position < end) return true;
            if (position === end) return !!previousToken.isUnterminated;
        }
        return false;
    }
    function isInsideJsxElementOrAttribute(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        if (!token) return false;
        if (token.kind === 12 /* JsxText */ ) return true;
        if (token.kind === 30 /* LessThanToken */  && token.parent.kind === 12 /* JsxText */ ) return true;
        if (token.kind === 30 /* LessThanToken */  && token.parent.kind === 295 /* JsxExpression */ ) return true;
        if (token && token.kind === 20 /* CloseBraceToken */  && token.parent.kind === 295 /* JsxExpression */ ) return true;
        if (token.kind === 31 /* LessThanSlashToken */  && token.parent.kind === 288 /* JsxClosingElement */ ) return true;
        return false;
    }
    function isWhiteSpaceOnlyJsxText(node) {
        return isJsxText(node) && node.containsOnlyTriviaWhiteSpaces;
    }
    function isInTemplateString(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        return isTemplateLiteralKind(token.kind) && position > token.getStart(sourceFile);
    }
    function isInJSXText(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        if (isJsxText(token)) return true;
        if (token.kind === 19 /* OpenBraceToken */  && isJsxExpression(token.parent) && isJsxElement(token.parent.parent)) return true;
        if (token.kind === 30 /* LessThanToken */  && isJsxOpeningLikeElement(token.parent) && isJsxElement(token.parent.parent)) return true;
        return false;
    }
    function isInsideJsxElement(sourceFile, position) {
        function isInsideJsxElementTraversal(node) {
            while(node){
                if (node.kind >= 286 /* JsxSelfClosingElement */  && node.kind <= 295 /* JsxExpression */  || node.kind === 12 /* JsxText */  || node.kind === 30 /* LessThanToken */  || node.kind === 32 /* GreaterThanToken */  || node.kind === 80 /* Identifier */  || node.kind === 20 /* CloseBraceToken */  || node.kind === 19 /* OpenBraceToken */  || node.kind === 44 /* SlashToken */  || node.kind === 31 /* LessThanSlashToken */ ) node = node.parent;
                else if (node.kind === 285 /* JsxElement */ ) {
                    if (position > node.getStart(sourceFile)) return true;
                    node = node.parent;
                } else return false;
            }
            return false;
        }
        return isInsideJsxElementTraversal(getTokenAtPosition(sourceFile, position));
    }
    function findPrecedingMatchingToken(token, matchingTokenKind, sourceFile) {
        const closeTokenText = tokenToString(token.kind);
        const matchingTokenText = tokenToString(matchingTokenKind);
        const tokenFullStart = token.getFullStart();
        const bestGuessIndex = sourceFile.text.lastIndexOf(matchingTokenText, tokenFullStart);
        if (bestGuessIndex === -1) return void 0;
        if (sourceFile.text.lastIndexOf(closeTokenText, tokenFullStart - 1) < bestGuessIndex) {
            const nodeAtGuess = findPrecedingToken(bestGuessIndex + 1, sourceFile);
            if (nodeAtGuess && nodeAtGuess.kind === matchingTokenKind) return nodeAtGuess;
        }
        const tokenKind = token.kind;
        let remainingMatchingTokens = 0;
        while(true){
            const preceding = findPrecedingToken(token.getFullStart(), sourceFile);
            if (!preceding) return void 0;
            token = preceding;
            if (token.kind === matchingTokenKind) {
                if (remainingMatchingTokens === 0) return token;
                remainingMatchingTokens--;
            } else if (token.kind === tokenKind) remainingMatchingTokens++;
        }
    }
    function removeOptionality(type, isOptionalExpression, isOptionalChain2) {
        return isOptionalExpression ? type.getNonNullableType() : isOptionalChain2 ? type.getNonOptionalType() : type;
    }
    function isPossiblyTypeArgumentPosition(token, sourceFile, checker) {
        const info = getPossibleTypeArgumentsInfo(token, sourceFile);
        return info !== void 0 && (isPartOfTypeNode(info.called) || getPossibleGenericSignatures(info.called, info.nTypeArguments, checker).length !== 0 || isPossiblyTypeArgumentPosition(info.called, sourceFile, checker));
    }
    function getPossibleGenericSignatures(called, typeArgumentCount, checker) {
        let type = checker.getTypeAtLocation(called);
        if (isOptionalChain(called.parent)) type = removeOptionality(type, isOptionalChainRoot(called.parent), /*isOptionalChain*/ true);
        const signatures = isNewExpression(called.parent) ? type.getConstructSignatures() : type.getCallSignatures();
        return signatures.filter((candidate)=>!!candidate.typeParameters && candidate.typeParameters.length >= typeArgumentCount);
    }
    function getPossibleTypeArgumentsInfo(tokenIn, sourceFile) {
        if (sourceFile.text.lastIndexOf("<", tokenIn ? tokenIn.pos : sourceFile.text.length) === -1) return void 0;
        let token = tokenIn;
        let remainingLessThanTokens = 0;
        let nTypeArguments = 0;
        while(token){
            switch(token.kind){
                case 30 /* LessThanToken */ :
                    token = findPrecedingToken(token.getFullStart(), sourceFile);
                    if (token && token.kind === 29 /* QuestionDotToken */ ) token = findPrecedingToken(token.getFullStart(), sourceFile);
                    if (!token || !isIdentifier(token)) return void 0;
                    if (!remainingLessThanTokens) return isDeclarationName(token) ? void 0 : {
                        called: token,
                        nTypeArguments
                    };
                    remainingLessThanTokens--;
                    break;
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                    remainingLessThanTokens = 3;
                    break;
                case 49 /* GreaterThanGreaterThanToken */ :
                    remainingLessThanTokens = 2;
                    break;
                case 32 /* GreaterThanToken */ :
                    remainingLessThanTokens++;
                    break;
                case 20 /* CloseBraceToken */ :
                    token = findPrecedingMatchingToken(token, 19 /* OpenBraceToken */ , sourceFile);
                    if (!token) return void 0;
                    break;
                case 22 /* CloseParenToken */ :
                    token = findPrecedingMatchingToken(token, 21 /* OpenParenToken */ , sourceFile);
                    if (!token) return void 0;
                    break;
                case 24 /* CloseBracketToken */ :
                    token = findPrecedingMatchingToken(token, 23 /* OpenBracketToken */ , sourceFile);
                    if (!token) return void 0;
                    break;
                // Valid tokens in a type name. Skip.
                case 28 /* CommaToken */ :
                    nTypeArguments++;
                    break;
                case 39 /* EqualsGreaterThanToken */ :
                // falls through
                case 80 /* Identifier */ :
                case 11 /* StringLiteral */ :
                case 9 /* NumericLiteral */ :
                case 10 /* BigIntLiteral */ :
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                // falls through
                case 114 /* TypeOfKeyword */ :
                case 96 /* ExtendsKeyword */ :
                case 143 /* KeyOfKeyword */ :
                case 25 /* DotToken */ :
                case 52 /* BarToken */ :
                case 58 /* QuestionToken */ :
                case 59 /* ColonToken */ :
                    break;
                default:
                    if (isTypeNode(token)) break;
                    return void 0;
            }
            token = findPrecedingToken(token.getFullStart(), sourceFile);
        }
        return void 0;
    }
    function isInComment(sourceFile, position, tokenAtPosition) {
        return ts_formatting_exports.getRangeOfEnclosingComment(sourceFile, position, /*precedingToken*/ void 0, tokenAtPosition);
    }
    function hasDocComment(sourceFile, position) {
        const token = getTokenAtPosition(sourceFile, position);
        return !!findAncestor(token, isJSDoc);
    }
    function nodeHasTokens(n, sourceFile) {
        return n.kind === 1 /* EndOfFileToken */  ? !!n.jsDoc : n.getWidth(sourceFile) !== 0;
    }
    function getNodeModifiers(node, excludeFlags = 0 /* None */ ) {
        const result = [];
        const flags = isDeclaration(node) ? getCombinedNodeFlagsAlwaysIncludeJSDoc(node) & ~excludeFlags : 0 /* None */ ;
        if (flags & 2 /* Private */ ) result.push("private" /* privateMemberModifier */ );
        if (flags & 4 /* Protected */ ) result.push("protected" /* protectedMemberModifier */ );
        if (flags & 1 /* Public */ ) result.push("public" /* publicMemberModifier */ );
        if (flags & 256 /* Static */  || isClassStaticBlockDeclaration(node)) result.push("static" /* staticModifier */ );
        if (flags & 64 /* Abstract */ ) result.push("abstract" /* abstractModifier */ );
        if (flags & 32 /* Export */ ) result.push("export" /* exportedModifier */ );
        if (flags & 65536 /* Deprecated */ ) result.push("deprecated" /* deprecatedModifier */ );
        if (node.flags & 33554432 /* Ambient */ ) result.push("declare" /* ambientModifier */ );
        if (node.kind === 278 /* ExportAssignment */ ) result.push("export" /* exportedModifier */ );
        return result.length > 0 ? result.join(",") : "" /* none */ ;
    }
    function getTypeArgumentOrTypeParameterList(node) {
        if (node.kind === 184 /* TypeReference */  || node.kind === 214 /* CallExpression */ ) return node.typeArguments;
        if (isFunctionLike(node) || node.kind === 264 /* ClassDeclaration */  || node.kind === 265 /* InterfaceDeclaration */ ) return node.typeParameters;
        return void 0;
    }
    function isComment(kind) {
        return kind === 2 /* SingleLineCommentTrivia */  || kind === 3 /* MultiLineCommentTrivia */ ;
    }
    function isStringOrRegularExpressionOrTemplateLiteral(kind) {
        if (kind === 11 /* StringLiteral */  || kind === 14 /* RegularExpressionLiteral */  || isTemplateLiteralKind(kind)) return true;
        return false;
    }
    function areIntersectedTypesAvoidingStringReduction(checker, t1, t2) {
        return !!(t1.flags & 4 /* String */ ) && checker.isEmptyAnonymousObjectType(t2);
    }
    function isStringAndEmptyAnonymousObjectIntersection(type) {
        if (!type.isIntersection()) return false;
        const { types, checker } = type;
        return types.length === 2 && (areIntersectedTypesAvoidingStringReduction(checker, types[0], types[1]) || areIntersectedTypesAvoidingStringReduction(checker, types[1], types[0]));
    }
    function isInsideTemplateLiteral(node, position, sourceFile) {
        return isTemplateLiteralKind(node.kind) && node.getStart(sourceFile) < position && position < node.end || !!node.isUnterminated && position === node.end;
    }
    function isAccessibilityModifier(kind) {
        switch(kind){
            case 125 /* PublicKeyword */ :
            case 123 /* PrivateKeyword */ :
            case 124 /* ProtectedKeyword */ :
                return true;
        }
        return false;
    }
    function cloneCompilerOptions(options) {
        const result = clone(options);
        setConfigFileInOptions(result, options && options.configFile);
        return result;
    }
    function isArrayLiteralOrObjectLiteralDestructuringPattern(node) {
        if (node.kind === 210 /* ArrayLiteralExpression */  || node.kind === 211 /* ObjectLiteralExpression */ ) {
            if (node.parent.kind === 227 /* BinaryExpression */  && node.parent.left === node && node.parent.operatorToken.kind === 64 /* EqualsToken */ ) return true;
            if (node.parent.kind === 251 /* ForOfStatement */  && node.parent.initializer === node) return true;
            if (isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.kind === 304 /* PropertyAssignment */  ? node.parent.parent : node.parent)) return true;
        }
        return false;
    }
    function isInReferenceComment(sourceFile, position) {
        return isInReferenceCommentWorker(sourceFile, position, /*shouldBeReference*/ true);
    }
    function isInNonReferenceComment(sourceFile, position) {
        return isInReferenceCommentWorker(sourceFile, position, /*shouldBeReference*/ false);
    }
    function isInReferenceCommentWorker(sourceFile, position, shouldBeReference) {
        const range = isInComment(sourceFile, position, /*tokenAtPosition*/ void 0);
        return !!range && shouldBeReference === tripleSlashDirectivePrefixRegex.test(sourceFile.text.substring(range.pos, range.end));
    }
    function getReplacementSpanForContextToken(contextToken, position) {
        if (!contextToken) return void 0;
        switch(contextToken.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return createTextSpanFromStringLiteralLikeContent(contextToken, position);
            default:
                return createTextSpanFromNode(contextToken);
        }
    }
    function createTextSpanFromNode(node, sourceFile, endNode2) {
        return createTextSpanFromBounds(node.getStart(sourceFile), (endNode2 || node).getEnd());
    }
    function createTextSpanFromStringLiteralLikeContent(node, position) {
        let replacementEnd = node.getEnd() - 1;
        if (node.isUnterminated) {
            if (node.getStart() === replacementEnd) return void 0;
            replacementEnd = Math.min(position, node.getEnd());
        }
        return createTextSpanFromBounds(node.getStart() + 1, replacementEnd);
    }
    function createTextRangeFromNode(node, sourceFile) {
        return createRange(node.getStart(sourceFile), node.end);
    }
    function createTextSpanFromRange(range) {
        return createTextSpanFromBounds(range.pos, range.end);
    }
    function createTextRangeFromSpan(span) {
        return createRange(span.start, span.start + span.length);
    }
    function createTextChangeFromStartLength(start, length2, newText) {
        return createTextChange(createTextSpan(start, length2), newText);
    }
    function createTextChange(span, newText) {
        return {
            span,
            newText
        };
    }
    var typeKeywords = [
        133 /* AnyKeyword */ ,
        131 /* AssertsKeyword */ ,
        163 /* BigIntKeyword */ ,
        136 /* BooleanKeyword */ ,
        97 /* FalseKeyword */ ,
        140 /* InferKeyword */ ,
        143 /* KeyOfKeyword */ ,
        146 /* NeverKeyword */ ,
        106 /* NullKeyword */ ,
        150 /* NumberKeyword */ ,
        151 /* ObjectKeyword */ ,
        148 /* ReadonlyKeyword */ ,
        154 /* StringKeyword */ ,
        155 /* SymbolKeyword */ ,
        114 /* TypeOfKeyword */ ,
        112 /* TrueKeyword */ ,
        116 /* VoidKeyword */ ,
        157 /* UndefinedKeyword */ ,
        158 /* UniqueKeyword */ ,
        159 /* UnknownKeyword */ 
    ];
    function isTypeKeyword(kind) {
        return contains(typeKeywords, kind);
    }
    function isTypeKeywordToken(node) {
        return node.kind === 156 /* TypeKeyword */ ;
    }
    function isTypeKeywordTokenOrIdentifier(node) {
        return isTypeKeywordToken(node) || isIdentifier(node) && node.text === "type";
    }
    function nodeSeenTracker() {
        const seen = [];
        return (node)=>{
            const id = getNodeId(node);
            return !seen[id] && (seen[id] = true);
        };
    }
    function getSnapshotText(snap) {
        return snap.getText(0, snap.getLength());
    }
    function repeatString(str, count) {
        let result = "";
        for(let i = 0; i < count; i++)result += str;
        return result;
    }
    function skipConstraint(type) {
        return type.isTypeParameter() ? type.getConstraint() || type : type;
    }
    function getNameFromPropertyName(name) {
        return name.kind === 168 /* ComputedPropertyName */  ? isStringOrNumericLiteralLike(name.expression) ? name.expression.text : void 0 : isPrivateIdentifier(name) ? idText(name) : getTextOfIdentifierOrLiteral(name);
    }
    function programContainsModules(program) {
        return program.getSourceFiles().some((s)=>!s.isDeclarationFile && !program.isSourceFileFromExternalLibrary(s) && !!(s.externalModuleIndicator || s.commonJsModuleIndicator));
    }
    function programContainsEsModules(program) {
        return program.getSourceFiles().some((s)=>!s.isDeclarationFile && !program.isSourceFileFromExternalLibrary(s) && !!s.externalModuleIndicator);
    }
    function compilerOptionsIndicateEsModules(compilerOptions) {
        return !!compilerOptions.module || getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */  || !!compilerOptions.noEmit;
    }
    function createModuleSpecifierResolutionHost(program, host) {
        return {
            fileExists: (fileName)=>program.fileExists(fileName),
            getCurrentDirectory: ()=>host.getCurrentDirectory(),
            readFile: maybeBind(host, host.readFile),
            useCaseSensitiveFileNames: maybeBind(host, host.useCaseSensitiveFileNames) || program.useCaseSensitiveFileNames,
            getSymlinkCache: maybeBind(host, host.getSymlinkCache) || program.getSymlinkCache,
            getModuleSpecifierCache: maybeBind(host, host.getModuleSpecifierCache),
            getPackageJsonInfoCache: ()=>{
                var _a;
                return (_a = program.getModuleResolutionCache()) == null ? void 0 : _a.getPackageJsonInfoCache();
            },
            getGlobalTypingsCacheLocation: maybeBind(host, host.getGlobalTypingsCacheLocation),
            redirectTargetsMap: program.redirectTargetsMap,
            getRedirectFromSourceFile: (fileName)=>program.getRedirectFromSourceFile(fileName),
            isSourceOfProjectReferenceRedirect: (fileName)=>program.isSourceOfProjectReferenceRedirect(fileName),
            getNearestAncestorDirectoryWithPackageJson: maybeBind(host, host.getNearestAncestorDirectoryWithPackageJson),
            getFileIncludeReasons: ()=>program.getFileIncludeReasons(),
            getCommonSourceDirectory: ()=>program.getCommonSourceDirectory(),
            getDefaultResolutionModeForFile: (file)=>program.getDefaultResolutionModeForFile(file),
            getModeForResolutionAtIndex: (file, index)=>program.getModeForResolutionAtIndex(file, index)
        };
    }
    function getModuleSpecifierResolverHost(program, host) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, createModuleSpecifierResolutionHost(program, host)), {
            getCommonSourceDirectory: ()=>program.getCommonSourceDirectory()
        });
    }
    function moduleResolutionUsesNodeModules(moduleResolution) {
        return moduleResolution === 2 /* Node10 */  || moduleResolution >= 3 /* Node16 */  && moduleResolution <= 99 /* NodeNext */  || moduleResolution === 100 /* Bundler */ ;
    }
    function makeImport(defaultImport, namedImports, moduleSpecifier, quotePreference, isTypeOnly) {
        return factory.createImportDeclaration(/*modifiers*/ void 0, defaultImport || namedImports ? factory.createImportClause(isTypeOnly ? 156 /* TypeKeyword */  : void 0, defaultImport, namedImports && namedImports.length ? factory.createNamedImports(namedImports) : void 0) : void 0, typeof moduleSpecifier === "string" ? makeStringLiteral(moduleSpecifier, quotePreference) : moduleSpecifier, /*attributes*/ void 0);
    }
    function makeStringLiteral(text, quotePreference) {
        return factory.createStringLiteral(text, quotePreference === 0 /* Single */ );
    }
    var QuotePreference = /* @__PURE__ */ ((QuotePreference6)=>{
        QuotePreference6[QuotePreference6["Single"] = 0] = "Single";
        QuotePreference6[QuotePreference6["Double"] = 1] = "Double";
        return QuotePreference6;
    })(QuotePreference || {});
    function quotePreferenceFromString(str, sourceFile) {
        return isStringDoubleQuoted(str, sourceFile) ? 1 /* Double */  : 0 /* Single */ ;
    }
    function getQuotePreference(sourceFile, preferences) {
        if (preferences.quotePreference && preferences.quotePreference !== "auto") return preferences.quotePreference === "single" ? 0 /* Single */  : 1 /* Double */ ;
        else {
            const firstModuleSpecifier = isFullSourceFile(sourceFile) && sourceFile.imports && find(sourceFile.imports, (n)=>isStringLiteral(n) && !nodeIsSynthesized(n.parent));
            return firstModuleSpecifier ? quotePreferenceFromString(firstModuleSpecifier, sourceFile) : 1 /* Double */ ;
        }
    }
    function getQuoteFromPreference(qp) {
        switch(qp){
            case 0 /* Single */ :
                return "'";
            case 1 /* Double */ :
                return '"';
            default:
                return Debug.assertNever(qp);
        }
    }
    function symbolNameNoDefault(symbol) {
        const escaped = symbolEscapedNameNoDefault(symbol);
        return escaped === void 0 ? void 0 : unescapeLeadingUnderscores(escaped);
    }
    function symbolEscapedNameNoDefault(symbol) {
        if (symbol.escapedName !== "default" /* Default */ ) return symbol.escapedName;
        return firstDefined(symbol.declarations, (decl)=>{
            const name = getNameOfDeclaration(decl);
            return name && name.kind === 80 /* Identifier */  ? name.escapedText : void 0;
        });
    }
    function isModuleSpecifierLike(node) {
        return isStringLiteralLike(node) && (isExternalModuleReference(node.parent) || isImportDeclaration(node.parent) || isJSDocImportTag(node.parent) || isRequireCall(node.parent, /*requireStringLiteralLikeArgument*/ false) && node.parent.arguments[0] === node || isImportCall(node.parent) && node.parent.arguments[0] === node);
    }
    function isObjectBindingElementWithoutPropertyName(bindingElement) {
        return isBindingElement(bindingElement) && isObjectBindingPattern(bindingElement.parent) && isIdentifier(bindingElement.name) && !bindingElement.propertyName;
    }
    function getPropertySymbolFromBindingElement(checker, bindingElement) {
        const typeOfPattern = checker.getTypeAtLocation(bindingElement.parent);
        return typeOfPattern && checker.getPropertyOfType(typeOfPattern, bindingElement.name.text);
    }
    function getParentNodeInSpan(node, file, span) {
        if (!node) return void 0;
        while(node.parent){
            if (isSourceFile(node.parent) || !spanContainsNode(span, node.parent, file)) return node;
            node = node.parent;
        }
    }
    function spanContainsNode(span, node, file) {
        return textSpanContainsPosition(span, node.getStart(file)) && node.getEnd() <= textSpanEnd(span);
    }
    function findModifier(node, kind) {
        return canHaveModifiers(node) ? find(node.modifiers, (m)=>m.kind === kind) : void 0;
    }
    function insertImports(changes, sourceFile, imports, blankLineBetween, preferences) {
        var _a;
        const decl = isArray(imports) ? imports[0] : imports;
        const importKindPredicate = decl.kind === 244 /* VariableStatement */  ? isRequireVariableStatement : isAnyImportSyntax;
        const existingImportStatements = filter(sourceFile.statements, importKindPredicate);
        const { comparer, isSorted } = ts_OrganizeImports_exports.getOrganizeImportsStringComparerWithDetection(existingImportStatements, preferences);
        const sortedNewImports = isArray(imports) ? toSorted(imports, (a, b)=>ts_OrganizeImports_exports.compareImportsOrRequireStatements(a, b, comparer)) : [
            imports
        ];
        if (!(existingImportStatements == null ? void 0 : existingImportStatements.length)) {
            if (isFullSourceFile(sourceFile)) changes.insertNodesAtTopOfFile(sourceFile, sortedNewImports, blankLineBetween);
            else for (const newImport of sortedNewImports)changes.insertStatementsInNewFile(sourceFile.fileName, [
                newImport
            ], (_a = getOriginalNode(newImport)) == null ? void 0 : _a.getSourceFile());
            return;
        }
        Debug.assert(isFullSourceFile(sourceFile));
        if (existingImportStatements && isSorted) for (const newImport of sortedNewImports){
            const insertionIndex = ts_OrganizeImports_exports.getImportDeclarationInsertionIndex(existingImportStatements, newImport, comparer);
            if (insertionIndex === 0) {
                const options = existingImportStatements[0] === sourceFile.statements[0] ? {
                    leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude
                } : {};
                changes.insertNodeBefore(sourceFile, existingImportStatements[0], newImport, /*blankLineBetween*/ false, options);
            } else {
                const prevImport = existingImportStatements[insertionIndex - 1];
                changes.insertNodeAfter(sourceFile, prevImport, newImport);
            }
        }
        else {
            const lastExistingImport = lastOrUndefined(existingImportStatements);
            if (lastExistingImport) changes.insertNodesAfter(sourceFile, lastExistingImport, sortedNewImports);
            else changes.insertNodesAtTopOfFile(sourceFile, sortedNewImports, blankLineBetween);
        }
    }
    function getTypeKeywordOfTypeOnlyImport(importClause, sourceFile) {
        Debug.assert(importClause.isTypeOnly);
        return cast(importClause.getChildAt(0, sourceFile), isTypeKeywordToken);
    }
    function textSpansEqual(a, b) {
        return !!a && !!b && a.start === b.start && a.length === b.length;
    }
    function documentSpansEqual(a, b, useCaseSensitiveFileNames2) {
        return (useCaseSensitiveFileNames2 ? equateStringsCaseSensitive : equateStringsCaseInsensitive)(a.fileName, b.fileName) && textSpansEqual(a.textSpan, b.textSpan);
    }
    function getDocumentSpansEqualityComparer(useCaseSensitiveFileNames2) {
        return (a, b)=>documentSpansEqual(a, b, useCaseSensitiveFileNames2);
    }
    function forEachUnique(array, callback) {
        if (array) {
            for(let i = 0; i < array.length; i++)if (array.indexOf(array[i]) === i) {
                const result = callback(array[i], i);
                if (result) return result;
            }
        }
        return void 0;
    }
    function isTextWhiteSpaceLike(text, startPos, endPos) {
        for(let i = startPos; i < endPos; i++){
            if (!isWhiteSpaceLike(text.charCodeAt(i))) return false;
        }
        return true;
    }
    function getMappedLocation(location, sourceMapper, fileExists) {
        const mapsTo = sourceMapper.tryGetSourcePosition(location);
        return mapsTo && (!fileExists || fileExists(normalizePath(mapsTo.fileName)) ? mapsTo : void 0);
    }
    function getMappedDocumentSpan(documentSpan, sourceMapper, fileExists) {
        const { fileName, textSpan } = documentSpan;
        const newPosition = getMappedLocation({
            fileName,
            pos: textSpan.start
        }, sourceMapper, fileExists);
        if (!newPosition) return void 0;
        const newEndPosition = getMappedLocation({
            fileName,
            pos: textSpan.start + textSpan.length
        }, sourceMapper, fileExists);
        const newLength = newEndPosition ? newEndPosition.pos - newPosition.pos : textSpan.length;
        return {
            fileName: newPosition.fileName,
            textSpan: {
                start: newPosition.pos,
                length: newLength
            },
            originalFileName: documentSpan.fileName,
            originalTextSpan: documentSpan.textSpan,
            contextSpan: getMappedContextSpan(documentSpan, sourceMapper, fileExists),
            originalContextSpan: documentSpan.contextSpan
        };
    }
    function getMappedContextSpan(documentSpan, sourceMapper, fileExists) {
        const contextSpanStart = documentSpan.contextSpan && getMappedLocation({
            fileName: documentSpan.fileName,
            pos: documentSpan.contextSpan.start
        }, sourceMapper, fileExists);
        const contextSpanEnd = documentSpan.contextSpan && getMappedLocation({
            fileName: documentSpan.fileName,
            pos: documentSpan.contextSpan.start + documentSpan.contextSpan.length
        }, sourceMapper, fileExists);
        return contextSpanStart && contextSpanEnd ? {
            start: contextSpanStart.pos,
            length: contextSpanEnd.pos - contextSpanStart.pos
        } : void 0;
    }
    function isFirstDeclarationOfSymbolParameter(symbol) {
        const declaration = symbol.declarations ? firstOrUndefined(symbol.declarations) : void 0;
        return !!findAncestor(declaration, (n)=>isParameter(n) ? true : isBindingElement(n) || isObjectBindingPattern(n) || isArrayBindingPattern(n) ? false : "quit");
    }
    var displayPartWriterCache = /* @__PURE__ */ new Map();
    function getDisplayPartWriter(maximumLength) {
        maximumLength = maximumLength || defaultMaximumTruncationLength;
        if (!displayPartWriterCache.has(maximumLength)) displayPartWriterCache.set(maximumLength, getDisplayPartWriterWorker(maximumLength));
        return displayPartWriterCache.get(maximumLength);
    }
    function getDisplayPartWriterWorker(maximumLength) {
        const absoluteMaximumLength = maximumLength * 10;
        let displayParts;
        let lineStart;
        let indent3;
        let length2;
        resetWriter();
        const unknownWrite = (text)=>writeKind(text, 17 /* text */ );
        return {
            displayParts: ()=>{
                const finalText = displayParts.length && displayParts[displayParts.length - 1].text;
                if (length2 > absoluteMaximumLength && finalText && finalText !== "...") {
                    if (!isWhiteSpaceLike(finalText.charCodeAt(finalText.length - 1))) displayParts.push(displayPart(" ", 16 /* space */ ));
                    displayParts.push(displayPart("...", 15 /* punctuation */ ));
                }
                return displayParts;
            },
            writeKeyword: (text)=>writeKind(text, 5 /* keyword */ ),
            writeOperator: (text)=>writeKind(text, 12 /* operator */ ),
            writePunctuation: (text)=>writeKind(text, 15 /* punctuation */ ),
            writeTrailingSemicolon: (text)=>writeKind(text, 15 /* punctuation */ ),
            writeSpace: (text)=>writeKind(text, 16 /* space */ ),
            writeStringLiteral: (text)=>writeKind(text, 8 /* stringLiteral */ ),
            writeParameter: (text)=>writeKind(text, 13 /* parameterName */ ),
            writeProperty: (text)=>writeKind(text, 14 /* propertyName */ ),
            writeLiteral: (text)=>writeKind(text, 8 /* stringLiteral */ ),
            writeSymbol,
            writeLine,
            write: unknownWrite,
            writeComment: unknownWrite,
            getText: ()=>"",
            getTextPos: ()=>0,
            getColumn: ()=>0,
            getLine: ()=>0,
            isAtStartOfLine: ()=>false,
            hasTrailingWhitespace: ()=>false,
            hasTrailingComment: ()=>false,
            rawWrite: notImplemented,
            getIndent: ()=>indent3,
            increaseIndent: ()=>{
                indent3++;
            },
            decreaseIndent: ()=>{
                indent3--;
            },
            clear: resetWriter
        };
        function writeIndent() {
            if (length2 > absoluteMaximumLength) return;
            if (lineStart) {
                const indentString = getIndentString(indent3);
                if (indentString) {
                    length2 += indentString.length;
                    displayParts.push(displayPart(indentString, 16 /* space */ ));
                }
                lineStart = false;
            }
        }
        function writeKind(text, kind) {
            if (length2 > absoluteMaximumLength) return;
            writeIndent();
            length2 += text.length;
            displayParts.push(displayPart(text, kind));
        }
        function writeSymbol(text, symbol) {
            if (length2 > absoluteMaximumLength) return;
            writeIndent();
            length2 += text.length;
            displayParts.push(symbolPart(text, symbol));
        }
        function writeLine() {
            if (length2 > absoluteMaximumLength) return;
            length2 += 1;
            displayParts.push(lineBreakPart());
            lineStart = true;
        }
        function resetWriter() {
            displayParts = [];
            lineStart = true;
            indent3 = 0;
            length2 = 0;
        }
    }
    function symbolPart(text, symbol) {
        return displayPart(text, displayPartKind(symbol));
        function displayPartKind(symbol2) {
            const flags = symbol2.flags;
            if (flags & 3 /* Variable */ ) return isFirstDeclarationOfSymbolParameter(symbol2) ? 13 /* parameterName */  : 9 /* localName */ ;
            if (flags & 4 /* Property */ ) return 14 /* propertyName */ ;
            if (flags & 32768 /* GetAccessor */ ) return 14 /* propertyName */ ;
            if (flags & 65536 /* SetAccessor */ ) return 14 /* propertyName */ ;
            if (flags & 8 /* EnumMember */ ) return 19 /* enumMemberName */ ;
            if (flags & 16 /* Function */ ) return 20 /* functionName */ ;
            if (flags & 32 /* Class */ ) return 1 /* className */ ;
            if (flags & 64 /* Interface */ ) return 4 /* interfaceName */ ;
            if (flags & 384 /* Enum */ ) return 2 /* enumName */ ;
            if (flags & 1536 /* Module */ ) return 11 /* moduleName */ ;
            if (flags & 8192 /* Method */ ) return 10 /* methodName */ ;
            if (flags & 262144 /* TypeParameter */ ) return 18 /* typeParameterName */ ;
            if (flags & 524288 /* TypeAlias */ ) return 0 /* aliasName */ ;
            if (flags & 2097152 /* Alias */ ) return 0 /* aliasName */ ;
            return 17 /* text */ ;
        }
    }
    function displayPart(text, kind) {
        return {
            text,
            kind: SymbolDisplayPartKind[kind]
        };
    }
    function spacePart() {
        return displayPart(" ", 16 /* space */ );
    }
    function keywordPart(kind) {
        return displayPart(tokenToString(kind), 5 /* keyword */ );
    }
    function punctuationPart(kind) {
        return displayPart(tokenToString(kind), 15 /* punctuation */ );
    }
    function operatorPart(kind) {
        return displayPart(tokenToString(kind), 12 /* operator */ );
    }
    function parameterNamePart(text) {
        return displayPart(text, 13 /* parameterName */ );
    }
    function propertyNamePart(text) {
        return displayPart(text, 14 /* propertyName */ );
    }
    function textOrKeywordPart(text) {
        const kind = stringToToken(text);
        return kind === void 0 ? textPart(text) : keywordPart(kind);
    }
    function textPart(text) {
        return displayPart(text, 17 /* text */ );
    }
    function typeAliasNamePart(text) {
        return displayPart(text, 0 /* aliasName */ );
    }
    function typeParameterNamePart(text) {
        return displayPart(text, 18 /* typeParameterName */ );
    }
    function linkTextPart(text) {
        return displayPart(text, 24 /* linkText */ );
    }
    function linkNamePart(text, target) {
        return {
            text,
            kind: SymbolDisplayPartKind[23 /* linkName */ ],
            target: {
                fileName: getSourceFileOfNode(target).fileName,
                textSpan: createTextSpanFromNode(target)
            }
        };
    }
    function linkPart(text) {
        return displayPart(text, 22 /* link */ );
    }
    function buildLinkParts(link, checker) {
        var _a;
        const prefix = isJSDocLink(link) ? "link" : isJSDocLinkCode(link) ? "linkcode" : "linkplain";
        const parts = [
            linkPart(`{@${prefix} `)
        ];
        if (!link.name) {
            if (link.text) parts.push(linkTextPart(link.text));
        } else {
            const symbol = checker == null ? void 0 : checker.getSymbolAtLocation(link.name);
            const targetSymbol = symbol && checker ? getSymbolTarget(symbol, checker) : void 0;
            const suffix = findLinkNameEnd(link.text);
            const name = getTextOfNode(link.name) + link.text.slice(0, suffix);
            const text = skipSeparatorFromLinkText(link.text.slice(suffix));
            const decl = (targetSymbol == null ? void 0 : targetSymbol.valueDeclaration) || ((_a = targetSymbol == null ? void 0 : targetSymbol.declarations) == null ? void 0 : _a[0]);
            if (decl) {
                parts.push(linkNamePart(name, decl));
                if (text) parts.push(linkTextPart(text));
            } else {
                const separator = suffix === 0 || link.text.charCodeAt(suffix) === 124 /* bar */  && name.charCodeAt(name.length - 1) !== 32 /* space */  ? " " : "";
                parts.push(linkTextPart(name + separator + text));
            }
        }
        parts.push(linkPart("}"));
        return parts;
    }
    function skipSeparatorFromLinkText(text) {
        let pos = 0;
        if (text.charCodeAt(pos++) === 124 /* bar */ ) {
            while(pos < text.length && text.charCodeAt(pos) === 32 /* space */ )pos++;
            return text.slice(pos);
        }
        return text;
    }
    function findLinkNameEnd(text) {
        let pos = text.indexOf("://");
        if (pos === 0) {
            while(pos < text.length && text.charCodeAt(pos) !== 124 /* bar */ )pos++;
            return pos;
        }
        if (text.indexOf("()") === 0) return 2;
        if (text.charAt(0) === "<") {
            let brackets2 = 0;
            let i = 0;
            while(i < text.length){
                if (text[i] === "<") brackets2++;
                if (text[i] === ">") brackets2--;
                i++;
                if (!brackets2) return i;
            }
        }
        return 0;
    }
    var lineFeed2 = "\n";
    function getNewLineOrDefaultFromHost(host, formatSettings) {
        var _a;
        return (formatSettings == null ? void 0 : formatSettings.newLineCharacter) || ((_a = host.getNewLine) == null ? void 0 : _a.call(host)) || lineFeed2;
    }
    function lineBreakPart() {
        return displayPart("\n", 6 /* lineBreak */ );
    }
    function mapToDisplayParts(writeDisplayParts, maximumLength) {
        const displayPartWriter = getDisplayPartWriter(maximumLength);
        try {
            writeDisplayParts(displayPartWriter);
            return displayPartWriter.displayParts();
        } finally{
            displayPartWriter.clear();
        }
    }
    function typeToDisplayParts(typechecker, type, enclosingDeclaration, flags = 0 /* None */ , maximumLength, verbosityLevel, out) {
        return mapToDisplayParts((writer)=>{
            typechecker.writeType(type, enclosingDeclaration, flags | 17408 /* UseAliasDefinedOutsideCurrentScope */ , writer, maximumLength, verbosityLevel, out);
        }, maximumLength);
    }
    function symbolToDisplayParts(typeChecker, symbol, enclosingDeclaration, meaning, flags = 0 /* None */ ) {
        return mapToDisplayParts((writer)=>{
            typeChecker.writeSymbol(symbol, enclosingDeclaration, meaning, flags | 8 /* UseAliasDefinedOutsideCurrentScope */ , writer);
        });
    }
    function signatureToDisplayParts(typechecker, signature, enclosingDeclaration, flags = 0 /* None */ , maximumLength, verbosityLevel, out) {
        flags |= 25632 /* OmitParameterModifiers */ ;
        return mapToDisplayParts((writer)=>{
            typechecker.writeSignature(signature, enclosingDeclaration, flags, /*kind*/ void 0, writer, maximumLength, verbosityLevel, out);
        }, maximumLength);
    }
    function isImportOrExportSpecifierName(location) {
        return !!location.parent && isImportOrExportSpecifier(location.parent) && location.parent.propertyName === location;
    }
    function getScriptKind(fileName, host) {
        return ensureScriptKind(fileName, host.getScriptKind && host.getScriptKind(fileName));
    }
    function getSymbolTarget(symbol, checker) {
        let next = symbol;
        while(isAliasSymbol(next) || isTransientSymbol(next) && next.links.target)if (isTransientSymbol(next) && next.links.target) next = next.links.target;
        else next = skipAlias(next, checker);
        return next;
    }
    function isAliasSymbol(symbol) {
        return (symbol.flags & 2097152 /* Alias */ ) !== 0;
    }
    function getUniqueSymbolId(symbol, checker) {
        return getSymbolId(skipAlias(symbol, checker));
    }
    function getFirstNonSpaceCharacterPosition(text, position) {
        while(isWhiteSpaceLike(text.charCodeAt(position)))position += 1;
        return position;
    }
    function getPrecedingNonSpaceCharacterPosition(text, position) {
        while(position > -1 && isWhiteSpaceSingleLine(text.charCodeAt(position)))position -= 1;
        return position + 1;
    }
    function copyComments(sourceNode, targetNode) {
        const sourceFile = sourceNode.getSourceFile();
        const text = sourceFile.text;
        if (hasLeadingLineBreak(sourceNode, text)) copyLeadingComments(sourceNode, targetNode, sourceFile);
        else copyTrailingAsLeadingComments(sourceNode, targetNode, sourceFile);
        copyTrailingComments(sourceNode, targetNode, sourceFile);
    }
    function hasLeadingLineBreak(node, text) {
        const start = node.getFullStart();
        const end = node.getStart();
        for(let i = start; i < end; i++){
            if (text.charCodeAt(i) === 10 /* lineFeed */ ) return true;
        }
        return false;
    }
    function getUniqueName(baseName, sourceFile) {
        let nameText = baseName;
        for(let i = 1; !isFileLevelUniqueName(sourceFile, nameText); i++)nameText = `${baseName}_${i}`;
        return nameText;
    }
    function getRenameLocation(edits, renameFilename, name, preferLastLocation) {
        let delta = 0;
        let lastPos = -1;
        for (const { fileName, textChanges: textChanges2 } of edits){
            Debug.assert(fileName === renameFilename);
            for (const change of textChanges2){
                const { span, newText } = change;
                const index = indexInTextChange(newText, escapeString(name));
                if (index !== -1) {
                    lastPos = span.start + delta + index;
                    if (!preferLastLocation) return lastPos;
                }
                delta += newText.length - span.length;
            }
        }
        Debug.assert(preferLastLocation);
        Debug.assert(lastPos >= 0);
        return lastPos;
    }
    function copyLeadingComments(sourceNode, targetNode, sourceFile, commentKind, hasTrailingNewLine) {
        forEachLeadingCommentRange(sourceFile.text, sourceNode.pos, getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, addSyntheticLeadingComment));
    }
    function copyTrailingComments(sourceNode, targetNode, sourceFile, commentKind, hasTrailingNewLine) {
        forEachTrailingCommentRange(sourceFile.text, sourceNode.end, getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, addSyntheticTrailingComment));
    }
    function copyTrailingAsLeadingComments(sourceNode, targetNode, sourceFile, commentKind, hasTrailingNewLine) {
        forEachTrailingCommentRange(sourceFile.text, sourceNode.pos, getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, addSyntheticLeadingComment));
    }
    function getAddCommentsFunction(targetNode, sourceFile, commentKind, hasTrailingNewLine, cb) {
        return (pos, end, kind, htnl)=>{
            if (kind === 3 /* MultiLineCommentTrivia */ ) {
                pos += 2;
                end -= 2;
            } else pos += 2;
            cb(targetNode, commentKind || kind, sourceFile.text.slice(pos, end), hasTrailingNewLine !== void 0 ? hasTrailingNewLine : htnl);
        };
    }
    function indexInTextChange(change, name) {
        if (startsWith(change, name)) return 0;
        let idx = change.indexOf(" " + name);
        if (idx === -1) idx = change.indexOf("." + name);
        if (idx === -1) idx = change.indexOf('"' + name);
        return idx === -1 ? -1 : idx + 1;
    }
    function needsParentheses(expression) {
        return isBinaryExpression(expression) && expression.operatorToken.kind === 28 /* CommaToken */  || isObjectLiteralExpression(expression) || (isAsExpression(expression) || isSatisfiesExpression(expression)) && isObjectLiteralExpression(expression.expression);
    }
    function getContextualTypeFromParent(node, checker, contextFlags) {
        const parent2 = walkUpParenthesizedExpressions(node.parent);
        switch(parent2.kind){
            case 215 /* NewExpression */ :
                return checker.getContextualType(parent2, contextFlags);
            case 227 /* BinaryExpression */ :
                {
                    const { left, operatorToken, right } = parent2;
                    return isEqualityOperatorKind(operatorToken.kind) ? checker.getTypeAtLocation(node === right ? left : right) : checker.getContextualType(node, contextFlags);
                }
            case 297 /* CaseClause */ :
                return getSwitchedType(parent2, checker);
            default:
                return checker.getContextualType(node, contextFlags);
        }
    }
    function quote(sourceFile, preferences, text) {
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const quoted = JSON.stringify(text);
        return quotePreference === 0 /* Single */  ? `'${stripQuotes(quoted).replace(/'/g, ()=>"\\'").replace(/\\"/g, '"')}'` : quoted;
    }
    function isEqualityOperatorKind(kind) {
        switch(kind){
            case 37 /* EqualsEqualsEqualsToken */ :
            case 35 /* EqualsEqualsToken */ :
            case 38 /* ExclamationEqualsEqualsToken */ :
            case 36 /* ExclamationEqualsToken */ :
                return true;
            default:
                return false;
        }
    }
    function isStringLiteralOrTemplate(node) {
        switch(node.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 229 /* TemplateExpression */ :
            case 216 /* TaggedTemplateExpression */ :
                return true;
            default:
                return false;
        }
    }
    function hasIndexSignature(type) {
        return !!type.getStringIndexType() || !!type.getNumberIndexType();
    }
    function getSwitchedType(caseClause, checker) {
        return checker.getTypeAtLocation(caseClause.parent.parent.expression);
    }
    var ANONYMOUS = "anonymous function";
    function getTypeNodeIfAccessible(type, enclosingScope, program, host) {
        const checker = program.getTypeChecker();
        let typeIsAccessible = true;
        const notAccessible = ()=>typeIsAccessible = false;
        const res = checker.typeToTypeNode(type, enclosingScope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ , {
            trackSymbol: (symbol, declaration, meaning)=>{
                typeIsAccessible = typeIsAccessible && checker.isSymbolAccessible(symbol, declaration, meaning, /*shouldComputeAliasToMarkVisible*/ false).accessibility === 0 /* Accessible */ ;
                return !typeIsAccessible;
            },
            reportInaccessibleThisError: notAccessible,
            reportPrivateInBaseOfClassExpression: notAccessible,
            reportInaccessibleUniqueSymbolError: notAccessible,
            moduleResolverHost: getModuleSpecifierResolverHost(program, host)
        });
        return typeIsAccessible ? res : void 0;
    }
    function syntaxRequiresTrailingCommaOrSemicolonOrASI(kind) {
        return kind === 180 /* CallSignature */  || kind === 181 /* ConstructSignature */  || kind === 182 /* IndexSignature */  || kind === 172 /* PropertySignature */  || kind === 174 /* MethodSignature */ ;
    }
    function syntaxRequiresTrailingFunctionBlockOrSemicolonOrASI(kind) {
        return kind === 263 /* FunctionDeclaration */  || kind === 177 /* Constructor */  || kind === 175 /* MethodDeclaration */  || kind === 178 /* GetAccessor */  || kind === 179 /* SetAccessor */ ;
    }
    function syntaxRequiresTrailingModuleBlockOrSemicolonOrASI(kind) {
        return kind === 268 /* ModuleDeclaration */ ;
    }
    function syntaxRequiresTrailingSemicolonOrASI(kind) {
        return kind === 244 /* VariableStatement */  || kind === 245 /* ExpressionStatement */  || kind === 247 /* DoStatement */  || kind === 252 /* ContinueStatement */  || kind === 253 /* BreakStatement */  || kind === 254 /* ReturnStatement */  || kind === 258 /* ThrowStatement */  || kind === 260 /* DebuggerStatement */  || kind === 173 /* PropertyDeclaration */  || kind === 266 /* TypeAliasDeclaration */  || kind === 273 /* ImportDeclaration */  || kind === 272 /* ImportEqualsDeclaration */  || kind === 279 /* ExportDeclaration */  || kind === 271 /* NamespaceExportDeclaration */  || kind === 278 /* ExportAssignment */ ;
    }
    var syntaxMayBeASICandidate = or(syntaxRequiresTrailingCommaOrSemicolonOrASI, syntaxRequiresTrailingFunctionBlockOrSemicolonOrASI, syntaxRequiresTrailingModuleBlockOrSemicolonOrASI, syntaxRequiresTrailingSemicolonOrASI);
    function nodeIsASICandidate(node, sourceFile) {
        const lastToken = node.getLastToken(sourceFile);
        if (lastToken && lastToken.kind === 27 /* SemicolonToken */ ) return false;
        if (syntaxRequiresTrailingCommaOrSemicolonOrASI(node.kind)) {
            if (lastToken && lastToken.kind === 28 /* CommaToken */ ) return false;
        } else if (syntaxRequiresTrailingModuleBlockOrSemicolonOrASI(node.kind)) {
            const lastChild = last(node.getChildren(sourceFile));
            if (lastChild && isModuleBlock(lastChild)) return false;
        } else if (syntaxRequiresTrailingFunctionBlockOrSemicolonOrASI(node.kind)) {
            const lastChild = last(node.getChildren(sourceFile));
            if (lastChild && isFunctionBlock(lastChild)) return false;
        } else if (!syntaxRequiresTrailingSemicolonOrASI(node.kind)) return false;
        if (node.kind === 247 /* DoStatement */ ) return true;
        const topNode = findAncestor(node, (ancestor)=>!ancestor.parent);
        const nextToken = findNextToken(node, topNode, sourceFile);
        if (!nextToken || nextToken.kind === 20 /* CloseBraceToken */ ) return true;
        const startLine = sourceFile.getLineAndCharacterOfPosition(node.getEnd()).line;
        const endLine = sourceFile.getLineAndCharacterOfPosition(nextToken.getStart(sourceFile)).line;
        return startLine !== endLine;
    }
    function positionIsASICandidate(pos, context, sourceFile) {
        const contextAncestor = findAncestor(context, (ancestor)=>{
            if (ancestor.end !== pos) return "quit";
            return syntaxMayBeASICandidate(ancestor.kind);
        });
        return !!contextAncestor && nodeIsASICandidate(contextAncestor, sourceFile);
    }
    function probablyUsesSemicolons(sourceFile) {
        let withSemicolon = 0;
        let withoutSemicolon = 0;
        const nStatementsToObserve = 5;
        forEachChild(sourceFile, function visit(node) {
            if (syntaxRequiresTrailingSemicolonOrASI(node.kind)) {
                const lastToken = node.getLastToken(sourceFile);
                if ((lastToken == null ? void 0 : lastToken.kind) === 27 /* SemicolonToken */ ) withSemicolon++;
                else withoutSemicolon++;
            } else if (syntaxRequiresTrailingCommaOrSemicolonOrASI(node.kind)) {
                const lastToken = node.getLastToken(sourceFile);
                if ((lastToken == null ? void 0 : lastToken.kind) === 27 /* SemicolonToken */ ) withSemicolon++;
                else if (lastToken && lastToken.kind !== 28 /* CommaToken */ ) {
                    const lastTokenLine = getLineAndCharacterOfPosition(sourceFile, lastToken.getStart(sourceFile)).line;
                    const nextTokenLine = getLineAndCharacterOfPosition(sourceFile, getSpanOfTokenAtPosition(sourceFile, lastToken.end).start).line;
                    if (lastTokenLine !== nextTokenLine) withoutSemicolon++;
                }
            }
            if (withSemicolon + withoutSemicolon >= nStatementsToObserve) return true;
            return forEachChild(node, visit);
        });
        if (withSemicolon === 0 && withoutSemicolon <= 1) return true;
        return withSemicolon / withoutSemicolon > 1 / nStatementsToObserve;
    }
    function tryGetDirectories(host, directoryName) {
        return tryIOAndConsumeErrors(host, host.getDirectories, directoryName) || [];
    }
    function tryReadDirectory(host, path, extensions, exclude, include) {
        return tryIOAndConsumeErrors(host, host.readDirectory, path, extensions, exclude, include) || emptyArray;
    }
    function tryFileExists(host, path) {
        return tryIOAndConsumeErrors(host, host.fileExists, path);
    }
    function tryDirectoryExists(host, path) {
        return tryAndIgnoreErrors(()=>directoryProbablyExists(path, host)) || false;
    }
    function tryAndIgnoreErrors(cb) {
        try {
            return cb();
        } catch (e) {
            return void 0;
        }
    }
    function tryIOAndConsumeErrors(host, toApply, ...args) {
        return tryAndIgnoreErrors(()=>toApply && toApply.apply(host, args));
    }
    function findPackageJsons(startDirectory, host) {
        const paths = [];
        forEachAncestorDirectoryStoppingAtGlobalCache(host, startDirectory, (ancestor)=>{
            const currentConfigPath = combinePaths(ancestor, "package.json");
            if (tryFileExists(host, currentConfigPath)) paths.push(currentConfigPath);
        });
        return paths;
    }
    function findPackageJson(directory, host) {
        let packageJson;
        forEachAncestorDirectoryStoppingAtGlobalCache(host, directory, (ancestor)=>{
            if (ancestor === "node_modules") return true;
            packageJson = findConfigFile(ancestor, (f)=>tryFileExists(host, f), "package.json");
            if (packageJson) return true;
        });
        return packageJson;
    }
    function getPackageJsonsVisibleToFile(fileName, host) {
        if (!host.fileExists) return [];
        const packageJsons = [];
        forEachAncestorDirectoryStoppingAtGlobalCache(host, getDirectoryPath(fileName), (ancestor)=>{
            const packageJsonFileName = combinePaths(ancestor, "package.json");
            if (host.fileExists(packageJsonFileName)) {
                const info = createPackageJsonInfo(packageJsonFileName, host);
                if (info) packageJsons.push(info);
            }
        });
        return packageJsons;
    }
    function createPackageJsonInfo(fileName, host) {
        if (!host.readFile) return void 0;
        const dependencyKeys = [
            "dependencies",
            "devDependencies",
            "optionalDependencies",
            "peerDependencies"
        ];
        const stringContent = host.readFile(fileName) || "";
        const content = tryParseJson(stringContent);
        const info = {};
        if (content) for (const key of dependencyKeys){
            const dependencies = content[key];
            if (!dependencies) continue;
            const dependencyMap = /* @__PURE__ */ new Map();
            for(const packageName in dependencies)dependencyMap.set(packageName, dependencies[packageName]);
            info[key] = dependencyMap;
        }
        const dependencyGroups = [
            [
                1 /* Dependencies */ ,
                info.dependencies
            ],
            [
                2 /* DevDependencies */ ,
                info.devDependencies
            ],
            [
                8 /* OptionalDependencies */ ,
                info.optionalDependencies
            ],
            [
                4 /* PeerDependencies */ ,
                info.peerDependencies
            ]
        ];
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, info), {
            parseable: !!content,
            fileName,
            get,
            has (dependencyName, inGroups) {
                return !!get(dependencyName, inGroups);
            }
        });
        function get(dependencyName, inGroups = 15 /* All */ ) {
            for (const [group2, deps] of dependencyGroups)if (deps && inGroups & group2) {
                const dep = deps.get(dependencyName);
                if (dep !== void 0) return dep;
            }
        }
    }
    function createPackageJsonImportFilter(fromFile, preferences, host) {
        const packageJsons = (host.getPackageJsonsVisibleToFile && host.getPackageJsonsVisibleToFile(fromFile.fileName) || getPackageJsonsVisibleToFile(fromFile.fileName, host)).filter((p)=>p.parseable);
        let usesNodeCoreModules;
        let ambientModuleCache;
        let sourceFileCache;
        return {
            allowsImportingAmbientModule,
            getSourceFileInfo,
            allowsImportingSpecifier
        };
        function moduleSpecifierIsCoveredByPackageJson(specifier) {
            const packageName = getNodeModuleRootSpecifier(specifier);
            for (const packageJson of packageJsons){
                if (packageJson.has(packageName) || packageJson.has(getTypesPackageName(packageName))) return true;
            }
            return false;
        }
        function allowsImportingAmbientModule(moduleSymbol, moduleSpecifierResolutionHost) {
            if (!packageJsons.length || !moduleSymbol.valueDeclaration) return true;
            if (!ambientModuleCache) ambientModuleCache = /* @__PURE__ */ new Map();
            else {
                const cached = ambientModuleCache.get(moduleSymbol);
                if (cached !== void 0) return cached;
            }
            const declaredModuleSpecifier = stripQuotes(moduleSymbol.getName());
            if (isAllowedCoreNodeModulesImport(declaredModuleSpecifier)) {
                ambientModuleCache.set(moduleSymbol, true);
                return true;
            }
            const declaringSourceFile = moduleSymbol.valueDeclaration.getSourceFile();
            const declaringNodeModuleName = getNodeModulesPackageNameFromFileName(declaringSourceFile.fileName, moduleSpecifierResolutionHost);
            if (typeof declaringNodeModuleName === "undefined") {
                ambientModuleCache.set(moduleSymbol, true);
                return true;
            }
            const result = moduleSpecifierIsCoveredByPackageJson(declaringNodeModuleName) || moduleSpecifierIsCoveredByPackageJson(declaredModuleSpecifier);
            ambientModuleCache.set(moduleSymbol, result);
            return result;
        }
        function getSourceFileInfo(sourceFile, moduleSpecifierResolutionHost) {
            if (!packageJsons.length) return {
                importable: true,
                packageName: void 0
            };
            if (!sourceFileCache) sourceFileCache = /* @__PURE__ */ new Map();
            else {
                const cached = sourceFileCache.get(sourceFile);
                if (cached !== void 0) return cached;
            }
            const packageName = getNodeModulesPackageNameFromFileName(sourceFile.fileName, moduleSpecifierResolutionHost);
            if (!packageName) {
                const result2 = {
                    importable: true,
                    packageName
                };
                sourceFileCache.set(sourceFile, result2);
                return result2;
            }
            const importable = moduleSpecifierIsCoveredByPackageJson(packageName);
            const result = {
                importable,
                packageName
            };
            sourceFileCache.set(sourceFile, result);
            return result;
        }
        function allowsImportingSpecifier(moduleSpecifier) {
            if (!packageJsons.length || isAllowedCoreNodeModulesImport(moduleSpecifier)) return true;
            if (pathIsRelative(moduleSpecifier) || isRootedDiskPath(moduleSpecifier)) return true;
            return moduleSpecifierIsCoveredByPackageJson(moduleSpecifier);
        }
        function isAllowedCoreNodeModulesImport(moduleSpecifier) {
            if (isFullSourceFile(fromFile) && isSourceFileJS(fromFile) && nodeCoreModules.has(moduleSpecifier)) {
                if (usesNodeCoreModules === void 0) usesNodeCoreModules = consumesNodeCoreModules(fromFile);
                if (usesNodeCoreModules) return true;
            }
            return false;
        }
        function getNodeModulesPackageNameFromFileName(importedFileName, moduleSpecifierResolutionHost) {
            if (!importedFileName.includes("node_modules")) return void 0;
            const specifier = ts_moduleSpecifiers_exports.getNodeModulesPackageName(host.getCompilationSettings(), fromFile, importedFileName, moduleSpecifierResolutionHost, preferences);
            if (!specifier) return void 0;
            if (!pathIsRelative(specifier) && !isRootedDiskPath(specifier)) return getNodeModuleRootSpecifier(specifier);
        }
        function getNodeModuleRootSpecifier(fullSpecifier) {
            const components = getPathComponents(getPackageNameFromTypesPackageName(fullSpecifier)).slice(1);
            if (startsWith(components[0], "@")) return `${components[0]}/${components[1]}`;
            return components[0];
        }
    }
    function consumesNodeCoreModules(sourceFile) {
        return some(sourceFile.imports, ({ text })=>nodeCoreModules.has(text));
    }
    function isInsideNodeModules(fileOrDirectory) {
        return contains(getPathComponents(fileOrDirectory), "node_modules");
    }
    function isDiagnosticWithLocation(diagnostic) {
        return diagnostic.file !== void 0 && diagnostic.start !== void 0 && diagnostic.length !== void 0;
    }
    function findDiagnosticForNode(node, sortedFileDiagnostics) {
        const span = createTextSpanFromNode(node);
        const index = binarySearchKey(sortedFileDiagnostics, span, identity, compareTextSpans);
        if (index >= 0) {
            const diagnostic = sortedFileDiagnostics[index];
            Debug.assertEqual(diagnostic.file, node.getSourceFile(), "Diagnostics proided to 'findDiagnosticForNode' must be from a single SourceFile");
            return cast(diagnostic, isDiagnosticWithLocation);
        }
    }
    function getDiagnosticsWithinSpan(span, sortedFileDiagnostics) {
        var _a;
        let index = binarySearchKey(sortedFileDiagnostics, span.start, (diag2)=>diag2.start, compareValues);
        if (index < 0) index = ~index;
        while(((_a = sortedFileDiagnostics[index - 1]) == null ? void 0 : _a.start) === span.start)index--;
        const result = [];
        const end = textSpanEnd(span);
        while(true){
            const diagnostic = tryCast(sortedFileDiagnostics[index], isDiagnosticWithLocation);
            if (!diagnostic || diagnostic.start > end) break;
            if (textSpanContainsTextSpan(span, diagnostic)) result.push(diagnostic);
            index++;
        }
        return result;
    }
    function getRefactorContextSpan({ startPosition, endPosition }) {
        return createTextSpanFromBounds(startPosition, endPosition === void 0 ? startPosition : endPosition);
    }
    function getFixableErrorSpanExpression(sourceFile, span) {
        const token = getTokenAtPosition(sourceFile, span.start);
        const expression = findAncestor(token, (node)=>{
            if (node.getStart(sourceFile) < span.start || node.getEnd() > textSpanEnd(span)) return "quit";
            return isExpression(node) && textSpansEqual(span, createTextSpanFromNode(node, sourceFile));
        });
        return expression;
    }
    function mapOneOrMany(valueOrArray, f, resultSelector = identity) {
        return valueOrArray ? isArray(valueOrArray) ? resultSelector(map(valueOrArray, f)) : f(valueOrArray, 0) : void 0;
    }
    function firstOrOnly(valueOrArray) {
        return isArray(valueOrArray) ? first(valueOrArray) : valueOrArray;
    }
    function getNameForExportedSymbol(symbol, scriptTarget, preferCapitalized) {
        if (symbol.escapedName === "export=" /* ExportEquals */  || symbol.escapedName === "default" /* Default */ ) return getDefaultLikeExportNameFromDeclaration(symbol) || moduleSymbolToValidIdentifier(getSymbolParentOrFail(symbol), scriptTarget, !!preferCapitalized);
        return symbol.name;
    }
    function getDefaultLikeExportNameFromDeclaration(symbol) {
        return firstDefined(symbol.declarations, (d)=>{
            var _a, _b, _c;
            if (isExportAssignment(d)) return (_a = tryCast(skipOuterExpressions(d.expression), isIdentifier)) == null ? void 0 : _a.text;
            if (isExportSpecifier(d) && d.symbol.flags === 2097152 /* Alias */ ) return (_b = tryCast(d.propertyName, isIdentifier)) == null ? void 0 : _b.text;
            const name = (_c = tryCast(getNameOfDeclaration(d), isIdentifier)) == null ? void 0 : _c.text;
            if (name) return name;
            if (symbol.parent && !isExternalModuleSymbol(symbol.parent)) return symbol.parent.getName();
        });
    }
    function getSymbolParentOrFail(symbol) {
        var _a;
        return Debug.checkDefined(symbol.parent, `Symbol parent was undefined. Flags: ${Debug.formatSymbolFlags(symbol.flags)}. Declarations: ${(_a = symbol.declarations) == null ? void 0 : _a.map((d)=>{
            const kind = Debug.formatSyntaxKind(d.kind);
            const inJS = isInJSFile(d);
            const { expression } = d;
            return (inJS ? "[JS]" : "") + kind + (expression ? ` (expression: ${Debug.formatSyntaxKind(expression.kind)})` : "");
        }).join(", ")}.`);
    }
    function moduleSymbolToValidIdentifier(moduleSymbol, target, forceCapitalize) {
        return moduleSpecifierToValidIdentifier(removeFileExtension(stripQuotes(moduleSymbol.name)), target, forceCapitalize);
    }
    function moduleSpecifierToValidIdentifier(moduleSpecifier, target, forceCapitalize) {
        const baseName = getBaseFileName(removeSuffix(removeFileExtension(moduleSpecifier), "/index"));
        let res = "";
        let lastCharWasValid = true;
        const firstCharCode = baseName.charCodeAt(0);
        if (isIdentifierStart(firstCharCode, target)) {
            res += String.fromCharCode(firstCharCode);
            if (forceCapitalize) res = res.toUpperCase();
        } else lastCharWasValid = false;
        for(let i = 1; i < baseName.length; i++){
            const ch = baseName.charCodeAt(i);
            const isValid = isIdentifierPart(ch, target);
            if (isValid) {
                let char = String.fromCharCode(ch);
                if (!lastCharWasValid) char = char.toUpperCase();
                res += char;
            }
            lastCharWasValid = isValid;
        }
        return !isStringANonContextualKeyword(res) ? res || "_" : `_${res}`;
    }
    function stringContainsAt(haystack, needle, startIndex) {
        const needleLength = needle.length;
        if (needleLength + startIndex > haystack.length) return false;
        for(let i = 0; i < needleLength; i++){
            if (needle.charCodeAt(i) !== haystack.charCodeAt(i + startIndex)) return false;
        }
        return true;
    }
    function startsWithUnderscore(name) {
        return name.charCodeAt(0) === 95 /* _ */ ;
    }
    function isDeprecatedDeclaration(decl) {
        return !!(getCombinedNodeFlagsAlwaysIncludeJSDoc(decl) & 65536 /* Deprecated */ );
    }
    function shouldUseUriStyleNodeCoreModules(file, program) {
        let decisionFromFile;
        for (const node of file.imports)if (nodeCoreModules.has(node.text) && !exclusivelyPrefixedNodeCoreModules.has(node.text)) {
            if (startsWith(node.text, "node:")) return true;
            else decisionFromFile = false;
        }
        return decisionFromFile !== null && decisionFromFile !== void 0 ? decisionFromFile : program.usesUriStyleNodeCoreModules;
    }
    function getNewLineKind(newLineCharacter) {
        return newLineCharacter === "\n" ? 1 /* LineFeed */  : 0 /* CarriageReturnLineFeed */ ;
    }
    function diagnosticToString(diag2) {
        return isArray(diag2) ? formatStringFromArgs(getLocaleSpecificMessage(diag2[0]), diag2.slice(1)) : getLocaleSpecificMessage(diag2);
    }
    function getFormatCodeSettingsForWriting({ options }, sourceFile) {
        const shouldAutoDetectSemicolonPreference = !options.semicolons || options.semicolons === "ignore" /* Ignore */ ;
        const shouldRemoveSemicolons = options.semicolons === "remove" /* Remove */  || shouldAutoDetectSemicolonPreference && !probablyUsesSemicolons(sourceFile);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            semicolons: shouldRemoveSemicolons ? "remove" /* Remove */  : "ignore" /* Ignore */ 
        });
    }
    function jsxModeNeedsExplicitImport(jsx) {
        return jsx === 2 /* React */  || jsx === 3 /* ReactNative */ ;
    }
    function isSourceFileFromLibrary(program, node) {
        return program.isSourceFileFromExternalLibrary(node) || program.isSourceFileDefaultLibrary(node);
    }
    function newCaseClauseTracker(checker, clauses) {
        const existingStrings = /* @__PURE__ */ new Set();
        const existingNumbers = /* @__PURE__ */ new Set();
        const existingBigInts = /* @__PURE__ */ new Set();
        for (const clause of clauses)if (!isDefaultClause(clause)) {
            const expression = skipParentheses(clause.expression);
            if (isLiteralExpression(expression)) switch(expression.kind){
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                    existingStrings.add(expression.text);
                    break;
                case 9 /* NumericLiteral */ :
                    existingNumbers.add(parseInt(expression.text));
                    break;
                case 10 /* BigIntLiteral */ :
                    const parsedBigInt = parseBigInt(endsWith(expression.text, "n") ? expression.text.slice(0, -1) : expression.text);
                    if (parsedBigInt) existingBigInts.add(pseudoBigIntToString(parsedBigInt));
                    break;
            }
            else {
                const symbol = checker.getSymbolAtLocation(clause.expression);
                if (symbol && symbol.valueDeclaration && isEnumMember(symbol.valueDeclaration)) {
                    const enumValue = checker.getConstantValue(symbol.valueDeclaration);
                    if (enumValue !== void 0) addValue(enumValue);
                }
            }
        }
        return {
            addValue,
            hasValue
        };
        function addValue(value1) {
            switch(typeof value1){
                case "string":
                    existingStrings.add(value1);
                    break;
                case "number":
                    existingNumbers.add(value1);
            }
        }
        function hasValue(value1) {
            switch(typeof value1){
                case "string":
                    return existingStrings.has(value1);
                case "number":
                    return existingNumbers.has(value1);
                case "object":
                    return existingBigInts.has(pseudoBigIntToString(value1));
            }
        }
    }
    function fileShouldUseJavaScriptRequire(file, program, host, preferRequire) {
        var _a;
        const fileName = typeof file === "string" ? file : file.fileName;
        if (!hasJSFileExtension(fileName)) return false;
        const compilerOptions = typeof file === "string" ? program.getCompilerOptions() : program.getCompilerOptionsForFile(file);
        const moduleKind = getEmitModuleKind(compilerOptions);
        const sourceFileLike = typeof file === "string" ? {
            fileName: file,
            impliedNodeFormat: getImpliedNodeFormatForFile(toPath(file, host.getCurrentDirectory(), hostGetCanonicalFileName(host)), (_a = program.getPackageJsonInfoCache) == null ? void 0 : _a.call(program), host, compilerOptions)
        } : file;
        const impliedNodeFormat = getImpliedNodeFormatForEmitWorker(sourceFileLike, compilerOptions);
        if (impliedNodeFormat === 99 /* ESNext */ ) return false;
        if (impliedNodeFormat === 1 /* CommonJS */ ) return true;
        if (compilerOptions.verbatimModuleSyntax && moduleKind === 1 /* CommonJS */ ) return true;
        if (compilerOptions.verbatimModuleSyntax && emitModuleKindIsNonNodeESM(moduleKind)) return false;
        if (typeof file === "object") {
            if (file.commonJsModuleIndicator) return true;
            if (file.externalModuleIndicator) return false;
        }
        return preferRequire;
    }
    function isBlockLike(node) {
        switch(node.kind){
            case 242 /* Block */ :
            case 308 /* SourceFile */ :
            case 269 /* ModuleBlock */ :
            case 297 /* CaseClause */ :
                return true;
            default:
                return false;
        }
    }
    function createFutureSourceFile(fileName, syntaxModuleIndicator, program, moduleResolutionHost) {
        var _a;
        const result = getImpliedNodeFormatForFileWorker(fileName, (_a = program.getPackageJsonInfoCache) == null ? void 0 : _a.call(program), moduleResolutionHost, program.getCompilerOptions());
        let impliedNodeFormat, packageJsonScope;
        if (typeof result === "object") {
            impliedNodeFormat = result.impliedNodeFormat;
            packageJsonScope = result.packageJsonScope;
        }
        return {
            path: toPath(fileName, program.getCurrentDirectory(), program.getCanonicalFileName),
            fileName,
            externalModuleIndicator: syntaxModuleIndicator === 99 /* ESNext */  ? true : void 0,
            commonJsModuleIndicator: syntaxModuleIndicator === 1 /* CommonJS */  ? true : void 0,
            impliedNodeFormat,
            packageJsonScope,
            statements: emptyArray,
            imports: emptyArray
        };
    }
    // src/services/exportInfoMap.ts
    var ImportKind = /* @__PURE__ */ ((ImportKind2)=>{
        ImportKind2[ImportKind2["Named"] = 0] = "Named";
        ImportKind2[ImportKind2["Default"] = 1] = "Default";
        ImportKind2[ImportKind2["Namespace"] = 2] = "Namespace";
        ImportKind2[ImportKind2["CommonJS"] = 3] = "CommonJS";
        return ImportKind2;
    })(ImportKind || {});
    var ExportKind = /* @__PURE__ */ ((ExportKind3)=>{
        ExportKind3[ExportKind3["Named"] = 0] = "Named";
        ExportKind3[ExportKind3["Default"] = 1] = "Default";
        ExportKind3[ExportKind3["ExportEquals"] = 2] = "ExportEquals";
        ExportKind3[ExportKind3["UMD"] = 3] = "UMD";
        ExportKind3[ExportKind3["Module"] = 4] = "Module";
        return ExportKind3;
    })(ExportKind || {});
    function createCacheableExportInfoMap(host) {
        let exportInfoId = 1;
        const exportInfo = createMultiMap();
        const symbols = /* @__PURE__ */ new Map();
        const packages = /* @__PURE__ */ new Map();
        let usableByFileName;
        const cache = {
            isUsableByFile: (importingFile)=>importingFile === usableByFileName,
            isEmpty: ()=>!exportInfo.size,
            clear: ()=>{
                exportInfo.clear();
                symbols.clear();
                usableByFileName = void 0;
            },
            add: (importingFile, symbol, symbolTableKey, moduleSymbol, moduleFile, exportKind, isFromPackageJson, checker)=>{
                if (importingFile !== usableByFileName) {
                    cache.clear();
                    usableByFileName = importingFile;
                }
                let packageName;
                if (moduleFile) {
                    const nodeModulesPathParts = getNodeModulePathParts(moduleFile.fileName);
                    if (nodeModulesPathParts) {
                        const { topLevelNodeModulesIndex, topLevelPackageNameIndex, packageRootIndex } = nodeModulesPathParts;
                        packageName = unmangleScopedPackageName(getPackageNameFromTypesPackageName(moduleFile.fileName.substring(topLevelPackageNameIndex + 1, packageRootIndex)));
                        if (startsWith(importingFile, moduleFile.path.substring(0, topLevelNodeModulesIndex))) {
                            const prevDeepestNodeModulesPath = packages.get(packageName);
                            const nodeModulesPath = moduleFile.fileName.substring(0, topLevelPackageNameIndex + 1);
                            if (prevDeepestNodeModulesPath) {
                                const prevDeepestNodeModulesIndex = prevDeepestNodeModulesPath.indexOf(nodeModulesPathPart);
                                if (topLevelNodeModulesIndex > prevDeepestNodeModulesIndex) packages.set(packageName, nodeModulesPath);
                            } else packages.set(packageName, nodeModulesPath);
                        }
                    }
                }
                const isDefault = exportKind === 1 /* Default */ ;
                const namedSymbol = isDefault && getLocalSymbolForExportDefault(symbol) || symbol;
                const names = exportKind === 0 /* Named */  || isExternalModuleSymbol(namedSymbol) ? unescapeLeadingUnderscores(symbolTableKey) : getNamesForExportedSymbol(namedSymbol, checker, /*scriptTarget*/ void 0);
                const symbolName2 = typeof names === "string" ? names : names[0];
                const capitalizedSymbolName = typeof names === "string" ? void 0 : names[1];
                const moduleName = stripQuotes(moduleSymbol.name);
                const id = exportInfoId++;
                const target = skipAlias(symbol, checker);
                const storedSymbol = symbol.flags & 33554432 /* Transient */  ? void 0 : symbol;
                const storedModuleSymbol = moduleSymbol.flags & 33554432 /* Transient */  ? void 0 : moduleSymbol;
                if (!storedSymbol || !storedModuleSymbol) symbols.set(id, [
                    symbol,
                    moduleSymbol
                ]);
                exportInfo.add(key(symbolName2, symbol, isExternalModuleNameRelative(moduleName) ? void 0 : moduleName, checker), {
                    id,
                    symbolTableKey,
                    symbolName: symbolName2,
                    capitalizedSymbolName,
                    moduleName,
                    moduleFile,
                    moduleFileName: moduleFile == null ? void 0 : moduleFile.fileName,
                    packageName,
                    exportKind,
                    targetFlags: target.flags,
                    isFromPackageJson,
                    symbol: storedSymbol,
                    moduleSymbol: storedModuleSymbol
                });
            },
            get: (importingFile, key2)=>{
                if (importingFile !== usableByFileName) return;
                const result = exportInfo.get(key2);
                return result == null ? void 0 : result.map(rehydrateCachedInfo);
            },
            search: (importingFile, preferCapitalized, matches, action)=>{
                if (importingFile !== usableByFileName) return;
                return forEachEntry(exportInfo, (info, key2)=>{
                    const { symbolName: symbolName2, ambientModuleName } = parseKey(key2);
                    const name = preferCapitalized && info[0].capitalizedSymbolName || symbolName2;
                    if (matches(name, info[0].targetFlags)) {
                        const rehydrated = info.map(rehydrateCachedInfo);
                        const filtered = rehydrated.filter((r, i)=>isNotShadowedByDeeperNodeModulesPackage(r, info[i].packageName));
                        if (filtered.length) {
                            const res = action(filtered, name, !!ambientModuleName, key2);
                            if (res !== void 0) return res;
                        }
                    }
                });
            },
            releaseSymbols: ()=>{
                symbols.clear();
            },
            onFileChanged: (oldSourceFile, newSourceFile, typeAcquisitionEnabled)=>{
                if (fileIsGlobalOnly(oldSourceFile) && fileIsGlobalOnly(newSourceFile)) return false;
                if (usableByFileName && usableByFileName !== newSourceFile.path || // If ATA is enabled, auto-imports uses existing imports to guess whether you want auto-imports from node.
                // Adding or removing imports from node could change the outcome of that guess, so could change the suggestions list.
                typeAcquisitionEnabled && consumesNodeCoreModules(oldSourceFile) !== consumesNodeCoreModules(newSourceFile) || // Module agumentation and ambient module changes can add or remove exports available to be auto-imported.
                // Changes elsewhere in the file can change the *type* of an export in a module augmentation,
                // but type info is gathered in getCompletionEntryDetails, which doesn't use the cache.
                !arrayIsEqualTo(oldSourceFile.moduleAugmentations, newSourceFile.moduleAugmentations) || !ambientModuleDeclarationsAreEqual(oldSourceFile, newSourceFile)) {
                    cache.clear();
                    return true;
                }
                usableByFileName = newSourceFile.path;
                return false;
            }
        };
        if (Debug.isDebugging) Object.defineProperty(cache, "__cache", {
            value: exportInfo
        });
        return cache;
        function rehydrateCachedInfo(info) {
            if (info.symbol && info.moduleSymbol) return info;
            const { id, exportKind, targetFlags, isFromPackageJson, moduleFileName } = info;
            const [cachedSymbol, cachedModuleSymbol] = symbols.get(id) || emptyArray;
            if (cachedSymbol && cachedModuleSymbol) return {
                symbol: cachedSymbol,
                moduleSymbol: cachedModuleSymbol,
                moduleFileName,
                exportKind,
                targetFlags,
                isFromPackageJson
            };
            const checker = (isFromPackageJson ? host.getPackageJsonAutoImportProvider() : host.getCurrentProgram()).getTypeChecker();
            const moduleSymbol = info.moduleSymbol || cachedModuleSymbol || Debug.checkDefined(info.moduleFile ? checker.getMergedSymbol(info.moduleFile.symbol) : checker.tryFindAmbientModule(info.moduleName));
            const symbol = info.symbol || cachedSymbol || Debug.checkDefined(exportKind === 2 /* ExportEquals */  ? checker.resolveExternalModuleSymbol(moduleSymbol) : checker.tryGetMemberInModuleExportsAndProperties(unescapeLeadingUnderscores(info.symbolTableKey), moduleSymbol), `Could not find symbol '${info.symbolName}' by key '${info.symbolTableKey}' in module ${moduleSymbol.name}`);
            symbols.set(id, [
                symbol,
                moduleSymbol
            ]);
            return {
                symbol,
                moduleSymbol,
                moduleFileName,
                exportKind,
                targetFlags,
                isFromPackageJson
            };
        }
        function key(importedName, symbol, ambientModuleName, checker) {
            const moduleKey = ambientModuleName || "";
            return `${importedName.length} ${getSymbolId(skipAlias(symbol, checker))} ${importedName} ${moduleKey}`;
        }
        function parseKey(key2) {
            const firstSpace = key2.indexOf(" ");
            const secondSpace = key2.indexOf(" ", firstSpace + 1);
            const symbolNameLength = parseInt(key2.substring(0, firstSpace), 10);
            const data = key2.substring(secondSpace + 1);
            const symbolName2 = data.substring(0, symbolNameLength);
            const moduleKey = data.substring(symbolNameLength + 1);
            const ambientModuleName = moduleKey === "" ? void 0 : moduleKey;
            return {
                symbolName: symbolName2,
                ambientModuleName
            };
        }
        function fileIsGlobalOnly(file) {
            return !file.commonJsModuleIndicator && !file.externalModuleIndicator && !file.moduleAugmentations && !file.ambientModuleNames;
        }
        function ambientModuleDeclarationsAreEqual(oldSourceFile, newSourceFile) {
            if (!arrayIsEqualTo(oldSourceFile.ambientModuleNames, newSourceFile.ambientModuleNames)) return false;
            let oldFileStatementIndex = -1;
            let newFileStatementIndex = -1;
            for (const ambientModuleName of newSourceFile.ambientModuleNames){
                const isMatchingModuleDeclaration = (node)=>isNonGlobalAmbientModule(node) && node.name.text === ambientModuleName;
                oldFileStatementIndex = findIndex(oldSourceFile.statements, isMatchingModuleDeclaration, oldFileStatementIndex + 1);
                newFileStatementIndex = findIndex(newSourceFile.statements, isMatchingModuleDeclaration, newFileStatementIndex + 1);
                if (oldSourceFile.statements[oldFileStatementIndex] !== newSourceFile.statements[newFileStatementIndex]) return false;
            }
            return true;
        }
        function isNotShadowedByDeeperNodeModulesPackage(info, packageName) {
            if (!packageName || !info.moduleFileName) return true;
            const typingsCacheLocation = host.getGlobalTypingsCacheLocation();
            if (typingsCacheLocation && startsWith(info.moduleFileName, typingsCacheLocation)) return true;
            const packageDeepestNodeModulesPath = packages.get(packageName);
            return !packageDeepestNodeModulesPath || startsWith(info.moduleFileName, packageDeepestNodeModulesPath);
        }
    }
    function isImportable(program, fromFile, toFile, toModule, preferences, packageJsonFilter, moduleSpecifierResolutionHost, moduleSpecifierCache) {
        var _a;
        if (!toFile) {
            let useNodePrefix;
            const moduleName = stripQuotes(toModule.name);
            if (nodeCoreModules.has(moduleName) && (useNodePrefix = shouldUseUriStyleNodeCoreModules(fromFile, program)) !== void 0) return useNodePrefix === startsWith(moduleName, "node:");
            return !packageJsonFilter || packageJsonFilter.allowsImportingAmbientModule(toModule, moduleSpecifierResolutionHost) || fileContainsPackageImport(fromFile, moduleName);
        }
        Debug.assertIsDefined(toFile);
        if (fromFile === toFile) return false;
        const cachedResult = moduleSpecifierCache == null ? void 0 : moduleSpecifierCache.get(fromFile.path, toFile.path, preferences, {});
        if ((cachedResult == null ? void 0 : cachedResult.isBlockedByPackageJsonDependencies) !== void 0) return !cachedResult.isBlockedByPackageJsonDependencies || !!cachedResult.packageName && fileContainsPackageImport(fromFile, cachedResult.packageName);
        const getCanonicalFileName = hostGetCanonicalFileName(moduleSpecifierResolutionHost);
        const globalTypingsCache = (_a = moduleSpecifierResolutionHost.getGlobalTypingsCacheLocation) == null ? void 0 : _a.call(moduleSpecifierResolutionHost);
        const hasImportablePath = !!ts_moduleSpecifiers_exports.forEachFileNameOfModule(fromFile.fileName, toFile.fileName, moduleSpecifierResolutionHost, /*preferSymlinks*/ false, (toPath3)=>{
            const file = program.getSourceFile(toPath3);
            return (file === toFile || !file) && isImportablePath(fromFile.fileName, toPath3, getCanonicalFileName, globalTypingsCache, moduleSpecifierResolutionHost);
        });
        if (packageJsonFilter) {
            const importInfo = hasImportablePath ? packageJsonFilter.getSourceFileInfo(toFile, moduleSpecifierResolutionHost) : void 0;
            moduleSpecifierCache == null || moduleSpecifierCache.setBlockedByPackageJsonDependencies(fromFile.path, toFile.path, preferences, {}, importInfo == null ? void 0 : importInfo.packageName, !(importInfo == null ? void 0 : importInfo.importable));
            return !!(importInfo == null ? void 0 : importInfo.importable) || hasImportablePath && !!(importInfo == null ? void 0 : importInfo.packageName) && fileContainsPackageImport(fromFile, importInfo.packageName);
        }
        return hasImportablePath;
    }
    function fileContainsPackageImport(sourceFile, packageName) {
        return sourceFile.imports && sourceFile.imports.some((i)=>i.text === packageName || i.text.startsWith(packageName + "/"));
    }
    function isImportablePath(fromPath, toPath3, getCanonicalFileName, globalCachePath, host) {
        const toNodeModules = forEachAncestorDirectoryStoppingAtGlobalCache(host, toPath3, (ancestor)=>getBaseFileName(ancestor) === "node_modules" ? ancestor : void 0);
        const toNodeModulesParent = toNodeModules && getDirectoryPath(getCanonicalFileName(toNodeModules));
        return toNodeModulesParent === void 0 || startsWith(getCanonicalFileName(fromPath), toNodeModulesParent) || !!globalCachePath && startsWith(getCanonicalFileName(globalCachePath), toNodeModulesParent);
    }
    function forEachExternalModuleToImportFrom(program, host, preferences, useAutoImportProvider, cb) {
        var _a, _b;
        const useCaseSensitiveFileNames2 = hostUsesCaseSensitiveFileNames(host);
        const excludePatterns = preferences.autoImportFileExcludePatterns && getIsExcludedPatterns(preferences, useCaseSensitiveFileNames2);
        forEachExternalModule(program.getTypeChecker(), program.getSourceFiles(), excludePatterns, host, (module2, file)=>cb(module2, file, program, /*isFromPackageJson*/ false));
        const autoImportProvider = useAutoImportProvider && ((_a = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a.call(host));
        if (autoImportProvider) {
            const start = timestamp();
            const checker = program.getTypeChecker();
            forEachExternalModule(autoImportProvider.getTypeChecker(), autoImportProvider.getSourceFiles(), excludePatterns, host, (module2, file)=>{
                if (file && !program.getSourceFile(file.fileName) || !file && !checker.resolveName(module2.name, /*location*/ void 0, 1536 /* Module */ , /*excludeGlobals*/ false)) cb(module2, file, autoImportProvider, /*isFromPackageJson*/ true);
            });
            (_b = host.log) == null || _b.call(host, `forEachExternalModuleToImportFrom autoImportProvider: ${timestamp() - start}`);
        }
    }
    function getIsExcludedPatterns(preferences, useCaseSensitiveFileNames2) {
        return mapDefined(preferences.autoImportFileExcludePatterns, (spec)=>{
            const pattern = getSubPatternFromSpec(spec, "", "exclude");
            return pattern ? getRegexFromPattern(pattern, useCaseSensitiveFileNames2) : void 0;
        });
    }
    function forEachExternalModule(checker, allSourceFiles, excludePatterns, host, cb) {
        var _a;
        const isExcluded = excludePatterns && getIsExcluded(excludePatterns, host);
        for (const ambient of checker.getAmbientModules())if (!ambient.name.includes("*") && !(excludePatterns && ((_a = ambient.declarations) == null ? void 0 : _a.every((d)=>isExcluded(d.getSourceFile()))))) cb(ambient, /*sourceFile*/ void 0);
        for (const sourceFile of allSourceFiles)if (isExternalOrCommonJsModule(sourceFile) && !(isExcluded == null ? void 0 : isExcluded(sourceFile))) cb(checker.getMergedSymbol(sourceFile.symbol), sourceFile);
    }
    function getIsExcluded(excludePatterns, host) {
        var _a;
        const realpathsWithSymlinks = (_a = host.getSymlinkCache) == null ? void 0 : _a.call(host).getSymlinkedDirectoriesByRealpath();
        return ({ fileName, path })=>{
            if (excludePatterns.some((p)=>p.test(fileName))) return true;
            if ((realpathsWithSymlinks == null ? void 0 : realpathsWithSymlinks.size) && pathContainsNodeModules(fileName)) {
                let dir = getDirectoryPath(fileName);
                var _forEachAncestorDirectoryStoppingAtGlobalCache;
                return (_forEachAncestorDirectoryStoppingAtGlobalCache = forEachAncestorDirectoryStoppingAtGlobalCache(host, getDirectoryPath(path), (dirPath)=>{
                    const symlinks = realpathsWithSymlinks.get(ensureTrailingDirectorySeparator(dirPath));
                    if (symlinks) return symlinks.some((s)=>excludePatterns.some((p)=>p.test(fileName.replace(dir, s))));
                    dir = getDirectoryPath(dir);
                })) !== null && _forEachAncestorDirectoryStoppingAtGlobalCache !== void 0 ? _forEachAncestorDirectoryStoppingAtGlobalCache : false;
            }
            return false;
        };
    }
    function getIsFileExcluded(host, preferences) {
        if (!preferences.autoImportFileExcludePatterns) return ()=>false;
        return getIsExcluded(getIsExcludedPatterns(preferences, hostUsesCaseSensitiveFileNames(host)), host);
    }
    function getExportInfoMap(importingFile, host, program, preferences, cancellationToken) {
        var _a, _b, _c, _d, _e;
        const start = timestamp();
        (_a = host.getPackageJsonAutoImportProvider) == null || _a.call(host);
        const cache = ((_b = host.getCachedExportInfoMap) == null ? void 0 : _b.call(host)) || createCacheableExportInfoMap({
            getCurrentProgram: ()=>program,
            getPackageJsonAutoImportProvider: ()=>{
                var _a2;
                return (_a2 = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a2.call(host);
            },
            getGlobalTypingsCacheLocation: ()=>{
                var _a2;
                return (_a2 = host.getGlobalTypingsCacheLocation) == null ? void 0 : _a2.call(host);
            }
        });
        if (cache.isUsableByFile(importingFile.path)) {
            (_c = host.log) == null || _c.call(host, "getExportInfoMap: cache hit");
            return cache;
        }
        (_d = host.log) == null || _d.call(host, "getExportInfoMap: cache miss or empty; calculating new results");
        let moduleCount = 0;
        try {
            forEachExternalModuleToImportFrom(program, host, preferences, /*useAutoImportProvider*/ true, (moduleSymbol, moduleFile, program2, isFromPackageJson)=>{
                if (++moduleCount % 100 === 0) cancellationToken == null || cancellationToken.throwIfCancellationRequested();
                const seenExports = /* @__PURE__ */ new Set();
                const checker = program2.getTypeChecker();
                const defaultInfo = getDefaultLikeExportInfo(moduleSymbol, checker);
                if (defaultInfo && isImportableSymbol(defaultInfo.symbol, checker)) cache.add(importingFile.path, defaultInfo.symbol, defaultInfo.exportKind === 1 /* Default */  ? "default" /* Default */  : "export=" /* ExportEquals */ , moduleSymbol, moduleFile, defaultInfo.exportKind, isFromPackageJson, checker);
                checker.forEachExportAndPropertyOfModule(moduleSymbol, (exported, key)=>{
                    if (exported !== (defaultInfo == null ? void 0 : defaultInfo.symbol) && isImportableSymbol(exported, checker) && addToSeen(seenExports, key)) cache.add(importingFile.path, exported, key, moduleSymbol, moduleFile, 0 /* Named */ , isFromPackageJson, checker);
                });
            });
        } catch (err) {
            cache.clear();
            throw err;
        }
        (_e = host.log) == null || _e.call(host, `getExportInfoMap: done in ${timestamp() - start} ms`);
        return cache;
    }
    function getDefaultLikeExportInfo(moduleSymbol, checker) {
        const exportEquals = checker.resolveExternalModuleSymbol(moduleSymbol);
        if (exportEquals !== moduleSymbol) {
            const defaultExport2 = checker.tryGetMemberInModuleExports("default" /* Default */ , exportEquals);
            if (defaultExport2) return {
                symbol: defaultExport2,
                exportKind: 1 /* Default */ 
            };
            return {
                symbol: exportEquals,
                exportKind: 2 /* ExportEquals */ 
            };
        }
        const defaultExport = checker.tryGetMemberInModuleExports("default" /* Default */ , moduleSymbol);
        if (defaultExport) return {
            symbol: defaultExport,
            exportKind: 1 /* Default */ 
        };
    }
    function isImportableSymbol(symbol, checker) {
        return !checker.isUndefinedSymbol(symbol) && !checker.isUnknownSymbol(symbol) && !isKnownSymbol(symbol) && !isPrivateIdentifierSymbol(symbol);
    }
    function getNamesForExportedSymbol(defaultExport, checker, scriptTarget) {
        let names;
        forEachNameOfDefaultExport(defaultExport, checker, scriptTarget, (name, capitalizedName)=>{
            names = capitalizedName ? [
                name,
                capitalizedName
            ] : name;
            return true;
        });
        return Debug.checkDefined(names);
    }
    function forEachNameOfDefaultExport(defaultExport, checker, scriptTarget, cb) {
        let chain;
        let current = defaultExport;
        const seen = /* @__PURE__ */ new Set();
        while(current){
            const fromDeclaration = getDefaultLikeExportNameFromDeclaration(current);
            if (fromDeclaration) {
                const final = cb(fromDeclaration);
                if (final) return final;
            }
            if (current.escapedName !== "default" /* Default */  && current.escapedName !== "export=" /* ExportEquals */ ) {
                const final = cb(current.name);
                if (final) return final;
            }
            chain = append(chain, current);
            if (!addToSeen(seen, current)) break;
            current = current.flags & 2097152 /* Alias */  ? checker.getImmediateAliasedSymbol(current) : void 0;
        }
        for (const symbol of chain !== null && chain !== void 0 ? chain : emptyArray)if (symbol.parent && isExternalModuleSymbol(symbol.parent)) {
            const final = cb(moduleSymbolToValidIdentifier(symbol.parent, scriptTarget, /*forceCapitalize*/ false), moduleSymbolToValidIdentifier(symbol.parent, scriptTarget, /*forceCapitalize*/ true));
            if (final) return final;
        }
    }
    // src/services/classifier.ts
    function createClassifier() {
        const scanner2 = createScanner(99 /* Latest */ , /*skipTrivia*/ false);
        function getClassificationsForLine(text, lexState, syntacticClassifierAbsent) {
            return convertClassificationsToResult(getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent), text);
        }
        function getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent) {
            let token = 0 /* Unknown */ ;
            let lastNonTriviaToken = 0 /* Unknown */ ;
            const templateStack = [];
            const { prefix, pushTemplate } = getPrefixFromLexState(lexState);
            text = prefix + text;
            const offset = prefix.length;
            if (pushTemplate) templateStack.push(16 /* TemplateHead */ );
            scanner2.setText(text);
            let endOfLineState = 0 /* None */ ;
            const spans = [];
            let angleBracketStack = 0;
            do {
                token = scanner2.scan();
                if (!isTrivia(token)) {
                    handleToken();
                    lastNonTriviaToken = token;
                }
                const end = scanner2.getTokenEnd();
                pushEncodedClassification(scanner2.getTokenStart(), end, offset, classFromKind(token), spans);
                if (end >= text.length) {
                    const end2 = getNewEndOfLineState(scanner2, token, lastOrUndefined(templateStack));
                    if (end2 !== void 0) endOfLineState = end2;
                }
            }while (token !== 1 /* EndOfFileToken */ );
            function handleToken() {
                switch(token){
                    case 44 /* SlashToken */ :
                    case 69 /* SlashEqualsToken */ :
                        if (!noRegexTable[lastNonTriviaToken] && scanner2.reScanSlashToken() === 14 /* RegularExpressionLiteral */ ) token = 14 /* RegularExpressionLiteral */ ;
                        break;
                    case 30 /* LessThanToken */ :
                        if (lastNonTriviaToken === 80 /* Identifier */ ) angleBracketStack++;
                        break;
                    case 32 /* GreaterThanToken */ :
                        if (angleBracketStack > 0) angleBracketStack--;
                        break;
                    case 133 /* AnyKeyword */ :
                    case 154 /* StringKeyword */ :
                    case 150 /* NumberKeyword */ :
                    case 136 /* BooleanKeyword */ :
                    case 155 /* SymbolKeyword */ :
                        if (angleBracketStack > 0 && !syntacticClassifierAbsent) token = 80 /* Identifier */ ;
                        break;
                    case 16 /* TemplateHead */ :
                        templateStack.push(token);
                        break;
                    case 19 /* OpenBraceToken */ :
                        if (templateStack.length > 0) templateStack.push(token);
                        break;
                    case 20 /* CloseBraceToken */ :
                        if (templateStack.length > 0) {
                            const lastTemplateStackToken = lastOrUndefined(templateStack);
                            if (lastTemplateStackToken === 16 /* TemplateHead */ ) {
                                token = scanner2.reScanTemplateToken(/*isTaggedTemplate*/ false);
                                if (token === 18 /* TemplateTail */ ) templateStack.pop();
                                else Debug.assertEqual(token, 17 /* TemplateMiddle */ , "Should have been a template middle.");
                            } else {
                                Debug.assertEqual(lastTemplateStackToken, 19 /* OpenBraceToken */ , "Should have been an open brace");
                                templateStack.pop();
                            }
                        }
                        break;
                    default:
                        if (!isKeyword(token)) break;
                        if (lastNonTriviaToken === 25 /* DotToken */ ) token = 80 /* Identifier */ ;
                        else if (isKeyword(lastNonTriviaToken) && isKeyword(token) && !canFollow(lastNonTriviaToken, token)) token = 80 /* Identifier */ ;
                }
            }
            return {
                endOfLineState,
                spans
            };
        }
        return {
            getClassificationsForLine,
            getEncodedLexicalClassifications
        };
    }
    var noRegexTable = arrayToNumericMap([
        80 /* Identifier */ ,
        11 /* StringLiteral */ ,
        9 /* NumericLiteral */ ,
        10 /* BigIntLiteral */ ,
        14 /* RegularExpressionLiteral */ ,
        110 /* ThisKeyword */ ,
        46 /* PlusPlusToken */ ,
        47 /* MinusMinusToken */ ,
        22 /* CloseParenToken */ ,
        24 /* CloseBracketToken */ ,
        20 /* CloseBraceToken */ ,
        112 /* TrueKeyword */ ,
        97 /* FalseKeyword */ 
    ], (token)=>token, ()=>true);
    function getNewEndOfLineState(scanner2, token, lastOnTemplateStack) {
        switch(token){
            case 11 /* StringLiteral */ :
                {
                    if (!scanner2.isUnterminated()) return void 0;
                    const tokenText = scanner2.getTokenText();
                    const lastCharIndex = tokenText.length - 1;
                    let numBackslashes = 0;
                    while(tokenText.charCodeAt(lastCharIndex - numBackslashes) === 92 /* backslash */ )numBackslashes++;
                    if ((numBackslashes & 1) === 0) return void 0;
                    return tokenText.charCodeAt(0) === 34 /* doubleQuote */  ? 3 /* InDoubleQuoteStringLiteral */  : 2 /* InSingleQuoteStringLiteral */ ;
                }
            case 3 /* MultiLineCommentTrivia */ :
                return scanner2.isUnterminated() ? 1 /* InMultiLineCommentTrivia */  : void 0;
            default:
                if (isTemplateLiteralKind(token)) {
                    if (!scanner2.isUnterminated()) return void 0;
                    switch(token){
                        case 18 /* TemplateTail */ :
                            return 5 /* InTemplateMiddleOrTail */ ;
                        case 15 /* NoSubstitutionTemplateLiteral */ :
                            return 4 /* InTemplateHeadOrNoSubstitutionTemplate */ ;
                        default:
                            return Debug.fail("Only 'NoSubstitutionTemplateLiteral's and 'TemplateTail's can be unterminated; got SyntaxKind #" + token);
                    }
                }
                return lastOnTemplateStack === 16 /* TemplateHead */  ? 6 /* InTemplateSubstitutionPosition */  : void 0;
        }
    }
    function pushEncodedClassification(start, end, offset, classification, result) {
        if (classification === 8 /* whiteSpace */ ) return;
        if (start === 0 && offset > 0) start += offset;
        const length2 = end - start;
        if (length2 > 0) result.push(start - offset, length2, classification);
    }
    function convertClassificationsToResult(classifications, text) {
        const entries = [];
        const dense = classifications.spans;
        let lastEnd = 0;
        for(let i = 0; i < dense.length; i += 3){
            const start = dense[i];
            const length2 = dense[i + 1];
            const type = dense[i + 2];
            if (lastEnd >= 0) {
                const whitespaceLength2 = start - lastEnd;
                if (whitespaceLength2 > 0) entries.push({
                    length: whitespaceLength2,
                    classification: 4 /* Whitespace */ 
                });
            }
            entries.push({
                length: length2,
                classification: convertClassification(type)
            });
            lastEnd = start + length2;
        }
        const whitespaceLength = text.length - lastEnd;
        if (whitespaceLength > 0) entries.push({
            length: whitespaceLength,
            classification: 4 /* Whitespace */ 
        });
        return {
            entries,
            finalLexState: classifications.endOfLineState
        };
    }
    function convertClassification(type) {
        switch(type){
            case 1 /* comment */ :
                return 3 /* Comment */ ;
            case 3 /* keyword */ :
                return 1 /* Keyword */ ;
            case 4 /* numericLiteral */ :
                return 6 /* NumberLiteral */ ;
            case 25 /* bigintLiteral */ :
                return 7 /* BigIntLiteral */ ;
            case 5 /* operator */ :
                return 2 /* Operator */ ;
            case 6 /* stringLiteral */ :
                return 8 /* StringLiteral */ ;
            case 8 /* whiteSpace */ :
                return 4 /* Whitespace */ ;
            case 10 /* punctuation */ :
                return 0 /* Punctuation */ ;
            case 2 /* identifier */ :
            case 11 /* className */ :
            case 12 /* enumName */ :
            case 13 /* interfaceName */ :
            case 14 /* moduleName */ :
            case 15 /* typeParameterName */ :
            case 16 /* typeAliasName */ :
            case 9 /* text */ :
            case 17 /* parameterName */ :
                return 5 /* Identifier */ ;
            default:
                return void 0;
        }
    }
    function canFollow(keyword1, keyword2) {
        if (!isAccessibilityModifier(keyword1)) return true;
        switch(keyword2){
            case 139 /* GetKeyword */ :
            case 153 /* SetKeyword */ :
            case 137 /* ConstructorKeyword */ :
            case 126 /* StaticKeyword */ :
            case 129 /* AccessorKeyword */ :
                return true;
            // Allow things like "public get", "public constructor" and "public static".
            default:
                return false;
        }
    }
    function getPrefixFromLexState(lexState) {
        switch(lexState){
            case 3 /* InDoubleQuoteStringLiteral */ :
                return {
                    prefix: '"\\\n'
                };
            case 2 /* InSingleQuoteStringLiteral */ :
                return {
                    prefix: "'\\\n"
                };
            case 1 /* InMultiLineCommentTrivia */ :
                return {
                    prefix: "/*\n"
                };
            case 4 /* InTemplateHeadOrNoSubstitutionTemplate */ :
                return {
                    prefix: "`\n"
                };
            case 5 /* InTemplateMiddleOrTail */ :
                return {
                    prefix: "}\n",
                    pushTemplate: true
                };
            case 6 /* InTemplateSubstitutionPosition */ :
                return {
                    prefix: "",
                    pushTemplate: true
                };
            case 0 /* None */ :
                return {
                    prefix: ""
                };
            default:
                return Debug.assertNever(lexState);
        }
    }
    function isBinaryExpressionOperatorToken(token) {
        switch(token){
            case 42 /* AsteriskToken */ :
            case 44 /* SlashToken */ :
            case 45 /* PercentToken */ :
            case 40 /* PlusToken */ :
            case 41 /* MinusToken */ :
            case 48 /* LessThanLessThanToken */ :
            case 49 /* GreaterThanGreaterThanToken */ :
            case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
            case 30 /* LessThanToken */ :
            case 32 /* GreaterThanToken */ :
            case 33 /* LessThanEqualsToken */ :
            case 34 /* GreaterThanEqualsToken */ :
            case 104 /* InstanceOfKeyword */ :
            case 103 /* InKeyword */ :
            case 130 /* AsKeyword */ :
            case 152 /* SatisfiesKeyword */ :
            case 35 /* EqualsEqualsToken */ :
            case 36 /* ExclamationEqualsToken */ :
            case 37 /* EqualsEqualsEqualsToken */ :
            case 38 /* ExclamationEqualsEqualsToken */ :
            case 51 /* AmpersandToken */ :
            case 53 /* CaretToken */ :
            case 52 /* BarToken */ :
            case 56 /* AmpersandAmpersandToken */ :
            case 57 /* BarBarToken */ :
            case 75 /* BarEqualsToken */ :
            case 74 /* AmpersandEqualsToken */ :
            case 79 /* CaretEqualsToken */ :
            case 71 /* LessThanLessThanEqualsToken */ :
            case 72 /* GreaterThanGreaterThanEqualsToken */ :
            case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
            case 65 /* PlusEqualsToken */ :
            case 66 /* MinusEqualsToken */ :
            case 67 /* AsteriskEqualsToken */ :
            case 69 /* SlashEqualsToken */ :
            case 70 /* PercentEqualsToken */ :
            case 64 /* EqualsToken */ :
            case 28 /* CommaToken */ :
            case 61 /* QuestionQuestionToken */ :
            case 76 /* BarBarEqualsToken */ :
            case 77 /* AmpersandAmpersandEqualsToken */ :
            case 78 /* QuestionQuestionEqualsToken */ :
                return true;
            default:
                return false;
        }
    }
    function isPrefixUnaryExpressionOperatorToken(token) {
        switch(token){
            case 40 /* PlusToken */ :
            case 41 /* MinusToken */ :
            case 55 /* TildeToken */ :
            case 54 /* ExclamationToken */ :
            case 46 /* PlusPlusToken */ :
            case 47 /* MinusMinusToken */ :
                return true;
            default:
                return false;
        }
    }
    function classFromKind(token) {
        if (isKeyword(token)) return 3 /* keyword */ ;
        else if (isBinaryExpressionOperatorToken(token) || isPrefixUnaryExpressionOperatorToken(token)) return 5 /* operator */ ;
        else if (token >= 19 /* FirstPunctuation */  && token <= 79 /* LastPunctuation */ ) return 10 /* punctuation */ ;
        switch(token){
            case 9 /* NumericLiteral */ :
                return 4 /* numericLiteral */ ;
            case 10 /* BigIntLiteral */ :
                return 25 /* bigintLiteral */ ;
            case 11 /* StringLiteral */ :
                return 6 /* stringLiteral */ ;
            case 14 /* RegularExpressionLiteral */ :
                return 7 /* regularExpressionLiteral */ ;
            case 7 /* ConflictMarkerTrivia */ :
            case 3 /* MultiLineCommentTrivia */ :
            case 2 /* SingleLineCommentTrivia */ :
                return 1 /* comment */ ;
            case 5 /* WhitespaceTrivia */ :
            case 4 /* NewLineTrivia */ :
                return 8 /* whiteSpace */ ;
            case 80 /* Identifier */ :
            default:
                if (isTemplateLiteralKind(token)) return 6 /* stringLiteral */ ;
                return 2 /* identifier */ ;
        }
    }
    function getSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
        return convertClassificationsToSpans(getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span));
    }
    function checkForClassificationCancellation(cancellationToken, kind) {
        switch(kind){
            case 268 /* ModuleDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 263 /* FunctionDeclaration */ :
            case 232 /* ClassExpression */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                cancellationToken.throwIfCancellationRequested();
        }
    }
    function getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
        const spans = [];
        sourceFile.forEachChild(function cb(node) {
            if (!node || !textSpanIntersectsWith(span, node.pos, node.getFullWidth())) return;
            checkForClassificationCancellation(cancellationToken, node.kind);
            if (isIdentifier(node) && !nodeIsMissing(node) && classifiableNames.has(node.escapedText)) {
                const symbol = typeChecker.getSymbolAtLocation(node);
                const type = symbol && classifySymbol(symbol, getMeaningFromLocation(node), typeChecker);
                if (type) pushClassification(node.getStart(sourceFile), node.getEnd(), type);
            }
            node.forEachChild(cb);
        });
        return {
            spans,
            endOfLineState: 0 /* None */ 
        };
        function pushClassification(start, end, type) {
            const length2 = end - start;
            Debug.assert(length2 > 0, `Classification had non-positive length of ${length2}`);
            spans.push(start);
            spans.push(length2);
            spans.push(type);
        }
    }
    function classifySymbol(symbol, meaningAtPosition, checker) {
        const flags = symbol.getFlags();
        if ((flags & 2885600 /* Classifiable */ ) === 0 /* None */ ) return void 0;
        else if (flags & 32 /* Class */ ) return 11 /* className */ ;
        else if (flags & 384 /* Enum */ ) return 12 /* enumName */ ;
        else if (flags & 524288 /* TypeAlias */ ) return 16 /* typeAliasName */ ;
        else if (flags & 1536 /* Module */ ) return meaningAtPosition & 4 /* Namespace */  || meaningAtPosition & 1 /* Value */  && hasValueSideModule(symbol) ? 14 /* moduleName */  : void 0;
        else if (flags & 2097152 /* Alias */ ) return classifySymbol(checker.getAliasedSymbol(symbol), meaningAtPosition, checker);
        else if (meaningAtPosition & 2 /* Type */ ) return flags & 64 /* Interface */  ? 13 /* interfaceName */  : flags & 262144 /* TypeParameter */  ? 15 /* typeParameterName */  : void 0;
        else return void 0;
    }
    function hasValueSideModule(symbol) {
        return some(symbol.declarations, (declaration)=>isModuleDeclaration(declaration) && getModuleInstanceState(declaration) === 1 /* Instantiated */ );
    }
    function getClassificationTypeName(type) {
        switch(type){
            case 1 /* comment */ :
                return "comment" /* comment */ ;
            case 2 /* identifier */ :
                return "identifier" /* identifier */ ;
            case 3 /* keyword */ :
                return "keyword" /* keyword */ ;
            case 4 /* numericLiteral */ :
                return "number" /* numericLiteral */ ;
            case 25 /* bigintLiteral */ :
                return "bigint" /* bigintLiteral */ ;
            case 5 /* operator */ :
                return "operator" /* operator */ ;
            case 6 /* stringLiteral */ :
                return "string" /* stringLiteral */ ;
            case 8 /* whiteSpace */ :
                return "whitespace" /* whiteSpace */ ;
            case 9 /* text */ :
                return "text" /* text */ ;
            case 10 /* punctuation */ :
                return "punctuation" /* punctuation */ ;
            case 11 /* className */ :
                return "class name" /* className */ ;
            case 12 /* enumName */ :
                return "enum name" /* enumName */ ;
            case 13 /* interfaceName */ :
                return "interface name" /* interfaceName */ ;
            case 14 /* moduleName */ :
                return "module name" /* moduleName */ ;
            case 15 /* typeParameterName */ :
                return "type parameter name" /* typeParameterName */ ;
            case 16 /* typeAliasName */ :
                return "type alias name" /* typeAliasName */ ;
            case 17 /* parameterName */ :
                return "parameter name" /* parameterName */ ;
            case 18 /* docCommentTagName */ :
                return "doc comment tag name" /* docCommentTagName */ ;
            case 19 /* jsxOpenTagName */ :
                return "jsx open tag name" /* jsxOpenTagName */ ;
            case 20 /* jsxCloseTagName */ :
                return "jsx close tag name" /* jsxCloseTagName */ ;
            case 21 /* jsxSelfClosingTagName */ :
                return "jsx self closing tag name" /* jsxSelfClosingTagName */ ;
            case 22 /* jsxAttribute */ :
                return "jsx attribute" /* jsxAttribute */ ;
            case 23 /* jsxText */ :
                return "jsx text" /* jsxText */ ;
            case 24 /* jsxAttributeStringLiteralValue */ :
                return "jsx attribute string literal value" /* jsxAttributeStringLiteralValue */ ;
            default:
                return void 0;
        }
    }
    function convertClassificationsToSpans(classifications) {
        Debug.assert(classifications.spans.length % 3 === 0);
        const dense = classifications.spans;
        const result = [];
        for(let i = 0; i < dense.length; i += 3)result.push({
            textSpan: createTextSpan(dense[i], dense[i + 1]),
            classificationType: getClassificationTypeName(dense[i + 2])
        });
        return result;
    }
    function getSyntacticClassifications(cancellationToken, sourceFile, span) {
        return convertClassificationsToSpans(getEncodedSyntacticClassifications(cancellationToken, sourceFile, span));
    }
    function getEncodedSyntacticClassifications(cancellationToken, sourceFile, span) {
        const spanStart = span.start;
        const spanLength = span.length;
        const triviaScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
        const mergeConflictScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
        const result = [];
        processElement(sourceFile);
        return {
            spans: result,
            endOfLineState: 0 /* None */ 
        };
        function pushClassification(start, length2, type) {
            result.push(start);
            result.push(length2);
            result.push(type);
        }
        function classifyLeadingTriviaAndGetTokenStart(token) {
            triviaScanner.resetTokenState(token.pos);
            while(true){
                const start = triviaScanner.getTokenEnd();
                if (!couldStartTrivia(sourceFile.text, start)) return start;
                const kind = triviaScanner.scan();
                const end = triviaScanner.getTokenEnd();
                const width = end - start;
                if (!isTrivia(kind)) return start;
                switch(kind){
                    case 4 /* NewLineTrivia */ :
                    case 5 /* WhitespaceTrivia */ :
                        continue;
                    case 2 /* SingleLineCommentTrivia */ :
                    case 3 /* MultiLineCommentTrivia */ :
                        classifyComment(token, kind, start, width);
                        triviaScanner.resetTokenState(end);
                        continue;
                    case 7 /* ConflictMarkerTrivia */ :
                        const text = sourceFile.text;
                        const ch = text.charCodeAt(start);
                        if (ch === 60 /* lessThan */  || ch === 62 /* greaterThan */ ) {
                            pushClassification(start, width, 1 /* comment */ );
                            continue;
                        }
                        Debug.assert(ch === 124 /* bar */  || ch === 61 /* equals */ );
                        classifyDisabledMergeCode(text, start, end);
                        break;
                    case 6 /* ShebangTrivia */ :
                        break;
                    default:
                        Debug.assertNever(kind);
                }
            }
        }
        function classifyComment(token, kind, start, width) {
            if (kind === 3 /* MultiLineCommentTrivia */ ) {
                const docCommentAndDiagnostics = parseIsolatedJSDocComment(sourceFile.text, start, width);
                if (docCommentAndDiagnostics && docCommentAndDiagnostics.jsDoc) {
                    setParent(docCommentAndDiagnostics.jsDoc, token);
                    classifyJSDocComment(docCommentAndDiagnostics.jsDoc);
                    return;
                }
            } else if (kind === 2 /* SingleLineCommentTrivia */ ) {
                if (tryClassifyTripleSlashComment(start, width)) return;
            }
            pushCommentRange(start, width);
        }
        function pushCommentRange(start, width) {
            pushClassification(start, width, 1 /* comment */ );
        }
        function classifyJSDocComment(docComment) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            let pos = docComment.pos;
            if (docComment.tags) for (const tag of docComment.tags){
                if (tag.pos !== pos) pushCommentRange(pos, tag.pos - pos);
                pushClassification(tag.pos, 1, 10 /* punctuation */ );
                pushClassification(tag.tagName.pos, tag.tagName.end - tag.tagName.pos, 18 /* docCommentTagName */ );
                pos = tag.tagName.end;
                let commentStart = tag.tagName.end;
                switch(tag.kind){
                    case 342 /* JSDocParameterTag */ :
                        const param = tag;
                        processJSDocParameterTag(param);
                        commentStart = param.isNameFirst && ((_a = param.typeExpression) == null ? void 0 : _a.end) || param.name.end;
                        break;
                    case 349 /* JSDocPropertyTag */ :
                        const prop = tag;
                        commentStart = prop.isNameFirst && ((_b = prop.typeExpression) == null ? void 0 : _b.end) || prop.name.end;
                        break;
                    case 346 /* JSDocTemplateTag */ :
                        processJSDocTemplateTag(tag);
                        pos = tag.end;
                        commentStart = tag.typeParameters.end;
                        break;
                    case 347 /* JSDocTypedefTag */ :
                        const type = tag;
                        commentStart = ((_c = type.typeExpression) == null ? void 0 : _c.kind) === 310 /* JSDocTypeExpression */  && ((_d = type.fullName) == null ? void 0 : _d.end) || ((_e = type.typeExpression) == null ? void 0 : _e.end) || commentStart;
                        break;
                    case 339 /* JSDocCallbackTag */ :
                        commentStart = tag.typeExpression.end;
                        break;
                    case 345 /* JSDocTypeTag */ :
                        processElement(tag.typeExpression);
                        pos = tag.end;
                        commentStart = tag.typeExpression.end;
                        break;
                    case 344 /* JSDocThisTag */ :
                    case 341 /* JSDocEnumTag */ :
                        commentStart = tag.typeExpression.end;
                        break;
                    case 343 /* JSDocReturnTag */ :
                        processElement(tag.typeExpression);
                        pos = tag.end;
                        commentStart = ((_f = tag.typeExpression) == null ? void 0 : _f.end) || commentStart;
                        break;
                    case 348 /* JSDocSeeTag */ :
                        commentStart = ((_g = tag.name) == null ? void 0 : _g.end) || commentStart;
                        break;
                    case 329 /* JSDocAugmentsTag */ :
                    case 330 /* JSDocImplementsTag */ :
                        commentStart = tag.class.end;
                        break;
                    case 350 /* JSDocThrowsTag */ :
                        processElement(tag.typeExpression);
                        pos = tag.end;
                        commentStart = ((_h = tag.typeExpression) == null ? void 0 : _h.end) || commentStart;
                        break;
                }
                if (typeof tag.comment === "object") pushCommentRange(tag.comment.pos, tag.comment.end - tag.comment.pos);
                else if (typeof tag.comment === "string") pushCommentRange(commentStart, tag.end - commentStart);
            }
            if (pos !== docComment.end) pushCommentRange(pos, docComment.end - pos);
            return;
            function processJSDocParameterTag(tag) {
                if (tag.isNameFirst) {
                    pushCommentRange(pos, tag.name.pos - pos);
                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */ );
                    pos = tag.name.end;
                }
                if (tag.typeExpression) {
                    pushCommentRange(pos, tag.typeExpression.pos - pos);
                    processElement(tag.typeExpression);
                    pos = tag.typeExpression.end;
                }
                if (!tag.isNameFirst) {
                    pushCommentRange(pos, tag.name.pos - pos);
                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */ );
                    pos = tag.name.end;
                }
            }
        }
        function tryClassifyTripleSlashComment(start, width) {
            const tripleSlashXMLCommentRegEx = /^(\/\/\/\s*)(<)(?:(\S+)((?:[^/]|\/[^>])*)(\/>)?)?/m;
            const attributeRegex = /(\s)(\S+)(\s*)(=)(\s*)('[^']+'|"[^"]+")/g;
            const text = sourceFile.text.substr(start, width);
            const match = tripleSlashXMLCommentRegEx.exec(text);
            if (!match) return false;
            if (!match[3] || !(match[3] in commentPragmas)) return false;
            let pos = start;
            pushCommentRange(pos, match[1].length);
            pos += match[1].length;
            pushClassification(pos, match[2].length, 10 /* punctuation */ );
            pos += match[2].length;
            pushClassification(pos, match[3].length, 21 /* jsxSelfClosingTagName */ );
            pos += match[3].length;
            const attrText = match[4];
            let attrPos = pos;
            while(true){
                const attrMatch = attributeRegex.exec(attrText);
                if (!attrMatch) break;
                const newAttrPos = pos + attrMatch.index + attrMatch[1].length;
                if (newAttrPos > attrPos) {
                    pushCommentRange(attrPos, newAttrPos - attrPos);
                    attrPos = newAttrPos;
                }
                pushClassification(attrPos, attrMatch[2].length, 22 /* jsxAttribute */ );
                attrPos += attrMatch[2].length;
                if (attrMatch[3].length) {
                    pushCommentRange(attrPos, attrMatch[3].length);
                    attrPos += attrMatch[3].length;
                }
                pushClassification(attrPos, attrMatch[4].length, 5 /* operator */ );
                attrPos += attrMatch[4].length;
                if (attrMatch[5].length) {
                    pushCommentRange(attrPos, attrMatch[5].length);
                    attrPos += attrMatch[5].length;
                }
                pushClassification(attrPos, attrMatch[6].length, 24 /* jsxAttributeStringLiteralValue */ );
                attrPos += attrMatch[6].length;
            }
            pos += match[4].length;
            if (pos > attrPos) pushCommentRange(attrPos, pos - attrPos);
            if (match[5]) {
                pushClassification(pos, match[5].length, 10 /* punctuation */ );
                pos += match[5].length;
            }
            const end = start + width;
            if (pos < end) pushCommentRange(pos, end - pos);
            return true;
        }
        function processJSDocTemplateTag(tag) {
            for (const child of tag.getChildren())processElement(child);
        }
        function classifyDisabledMergeCode(text, start, end) {
            let i;
            for(i = start; i < end; i++){
                if (isLineBreak(text.charCodeAt(i))) break;
            }
            pushClassification(start, i - start, 1 /* comment */ );
            mergeConflictScanner.resetTokenState(i);
            while(mergeConflictScanner.getTokenEnd() < end)classifyDisabledCodeToken();
        }
        function classifyDisabledCodeToken() {
            const start = mergeConflictScanner.getTokenEnd();
            const tokenKind = mergeConflictScanner.scan();
            const end = mergeConflictScanner.getTokenEnd();
            const type = classifyTokenType(tokenKind);
            if (type) pushClassification(start, end - start, type);
        }
        function tryClassifyNode(node) {
            if (isJSDoc(node)) return true;
            if (nodeIsMissing(node)) return true;
            const classifiedElementName = tryClassifyJsxElementName(node);
            if (!isToken(node) && node.kind !== 12 /* JsxText */  && classifiedElementName === void 0) return false;
            const tokenStart = node.kind === 12 /* JsxText */  ? node.pos : classifyLeadingTriviaAndGetTokenStart(node);
            const tokenWidth = node.end - tokenStart;
            Debug.assert(tokenWidth >= 0);
            if (tokenWidth > 0) {
                const type = classifiedElementName || classifyTokenType(node.kind, node);
                if (type) pushClassification(tokenStart, tokenWidth, type);
            }
            return true;
        }
        function tryClassifyJsxElementName(token) {
            switch(token.parent && token.parent.kind){
                case 287 /* JsxOpeningElement */ :
                    if (token.parent.tagName === token) return 19 /* jsxOpenTagName */ ;
                    break;
                case 288 /* JsxClosingElement */ :
                    if (token.parent.tagName === token) return 20 /* jsxCloseTagName */ ;
                    break;
                case 286 /* JsxSelfClosingElement */ :
                    if (token.parent.tagName === token) return 21 /* jsxSelfClosingTagName */ ;
                    break;
                case 292 /* JsxAttribute */ :
                    if (token.parent.name === token) return 22 /* jsxAttribute */ ;
                    break;
            }
            return void 0;
        }
        function classifyTokenType(tokenKind, token) {
            if (isKeyword(tokenKind)) return 3 /* keyword */ ;
            if (tokenKind === 30 /* LessThanToken */  || tokenKind === 32 /* GreaterThanToken */ ) {
                if (token && getTypeArgumentOrTypeParameterList(token.parent)) return 10 /* punctuation */ ;
            }
            if (isPunctuation(tokenKind)) {
                if (token) {
                    const parent2 = token.parent;
                    if (tokenKind === 64 /* EqualsToken */ ) {
                        if (parent2.kind === 261 /* VariableDeclaration */  || parent2.kind === 173 /* PropertyDeclaration */  || parent2.kind === 170 /* Parameter */  || parent2.kind === 292 /* JsxAttribute */ ) return 5 /* operator */ ;
                    }
                    if (parent2.kind === 227 /* BinaryExpression */  || parent2.kind === 225 /* PrefixUnaryExpression */  || parent2.kind === 226 /* PostfixUnaryExpression */  || parent2.kind === 228 /* ConditionalExpression */ ) return 5 /* operator */ ;
                }
                return 10 /* punctuation */ ;
            } else if (tokenKind === 9 /* NumericLiteral */ ) return 4 /* numericLiteral */ ;
            else if (tokenKind === 10 /* BigIntLiteral */ ) return 25 /* bigintLiteral */ ;
            else if (tokenKind === 11 /* StringLiteral */ ) return token && token.parent.kind === 292 /* JsxAttribute */  ? 24 /* jsxAttributeStringLiteralValue */  : 6 /* stringLiteral */ ;
            else if (tokenKind === 14 /* RegularExpressionLiteral */ ) return 6 /* stringLiteral */ ;
            else if (isTemplateLiteralKind(tokenKind)) return 6 /* stringLiteral */ ;
            else if (tokenKind === 12 /* JsxText */ ) return 23 /* jsxText */ ;
            else if (tokenKind === 80 /* Identifier */ ) {
                if (token) {
                    switch(token.parent.kind){
                        case 264 /* ClassDeclaration */ :
                            if (token.parent.name === token) return 11 /* className */ ;
                            return;
                        case 169 /* TypeParameter */ :
                            if (token.parent.name === token) return 15 /* typeParameterName */ ;
                            return;
                        case 265 /* InterfaceDeclaration */ :
                            if (token.parent.name === token) return 13 /* interfaceName */ ;
                            return;
                        case 267 /* EnumDeclaration */ :
                            if (token.parent.name === token) return 12 /* enumName */ ;
                            return;
                        case 268 /* ModuleDeclaration */ :
                            if (token.parent.name === token) return 14 /* moduleName */ ;
                            return;
                        case 170 /* Parameter */ :
                            if (token.parent.name === token) return isThisIdentifier(token) ? 3 /* keyword */  : 17 /* parameterName */ ;
                            return;
                    }
                    if (isConstTypeReference(token.parent)) return 3 /* keyword */ ;
                }
                return 2 /* identifier */ ;
            }
        }
        function processElement(element) {
            if (!element) return;
            if (decodedTextSpanIntersectsWith(spanStart, spanLength, element.pos, element.getFullWidth())) {
                checkForClassificationCancellation(cancellationToken, element.kind);
                for (const child of element.getChildren(sourceFile))if (!tryClassifyNode(child)) processElement(child);
            }
        }
    }
    // src/services/documentHighlights.ts
    var DocumentHighlights;
    ((DocumentHighlights3)=>{
        function getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch) {
            const node = getTouchingPropertyName(sourceFile, position);
            if (node.parent && (isJsxOpeningElement(node.parent) && node.parent.tagName === node || isJsxClosingElement(node.parent))) {
                const { openingElement, closingElement } = node.parent.parent;
                const highlightSpans = [
                    openingElement,
                    closingElement
                ].map(({ tagName })=>getHighlightSpanForNode(tagName, sourceFile));
                return [
                    {
                        fileName: sourceFile.fileName,
                        highlightSpans
                    }
                ];
            }
            return getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) || getSyntacticDocumentHighlights(node, sourceFile);
        }
        DocumentHighlights3.getDocumentHighlights = getDocumentHighlights;
        function getHighlightSpanForNode(node, sourceFile) {
            return {
                fileName: sourceFile.fileName,
                textSpan: createTextSpanFromNode(node, sourceFile),
                kind: "none" /* none */ 
            };
        }
        function getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) {
            const sourceFilesSet = new Set(sourceFilesToSearch.map((f)=>f.fileName));
            const referenceEntries = ts_FindAllReferences_exports.getReferenceEntriesForNode(position, node, program, sourceFilesToSearch, cancellationToken, /*options*/ void 0, sourceFilesSet);
            if (!referenceEntries) return void 0;
            const map2 = arrayToMultiMap(referenceEntries.map(ts_FindAllReferences_exports.toHighlightSpan), (e)=>e.fileName, (e)=>e.span);
            const getCanonicalFileName = createGetCanonicalFileName(program.useCaseSensitiveFileNames());
            return arrayFrom(mapDefinedIterator(map2.entries(), ([fileName, highlightSpans])=>{
                if (!sourceFilesSet.has(fileName)) {
                    if (!program.redirectTargetsMap.has(toPath(fileName, program.getCurrentDirectory(), getCanonicalFileName))) return void 0;
                    const redirectTarget = program.getSourceFile(fileName);
                    const redirect = find(sourceFilesToSearch, (f)=>!!f.redirectInfo && f.redirectInfo.redirectTarget === redirectTarget);
                    fileName = redirect.fileName;
                    Debug.assert(sourceFilesSet.has(fileName));
                }
                return {
                    fileName,
                    highlightSpans
                };
            }));
        }
        function getSyntacticDocumentHighlights(node, sourceFile) {
            const highlightSpans = getHighlightSpans(node, sourceFile);
            return highlightSpans && [
                {
                    fileName: sourceFile.fileName,
                    highlightSpans
                }
            ];
        }
        function getHighlightSpans(node, sourceFile) {
            switch(node.kind){
                case 101 /* IfKeyword */ :
                case 93 /* ElseKeyword */ :
                    return isIfStatement(node.parent) ? getIfElseOccurrences(node.parent, sourceFile) : void 0;
                case 107 /* ReturnKeyword */ :
                    return useParent(node.parent, isReturnStatement, getReturnOccurrences);
                case 111 /* ThrowKeyword */ :
                    return useParent(node.parent, isThrowStatement, getThrowOccurrences);
                case 113 /* TryKeyword */ :
                case 85 /* CatchKeyword */ :
                case 98 /* FinallyKeyword */ :
                    const tryStatement = node.kind === 85 /* CatchKeyword */  ? node.parent.parent : node.parent;
                    return useParent(tryStatement, isTryStatement, getTryCatchFinallyOccurrences);
                case 109 /* SwitchKeyword */ :
                    return useParent(node.parent, isSwitchStatement, getSwitchCaseDefaultOccurrences);
                case 84 /* CaseKeyword */ :
                case 90 /* DefaultKeyword */ :
                    if (isDefaultClause(node.parent) || isCaseClause(node.parent)) return useParent(node.parent.parent.parent, isSwitchStatement, getSwitchCaseDefaultOccurrences);
                    return void 0;
                case 83 /* BreakKeyword */ :
                case 88 /* ContinueKeyword */ :
                    return useParent(node.parent, isBreakOrContinueStatement, getBreakOrContinueStatementOccurrences);
                case 99 /* ForKeyword */ :
                case 117 /* WhileKeyword */ :
                case 92 /* DoKeyword */ :
                    return useParent(node.parent, (n)=>isIterationStatement(n, /*lookInLabeledStatements*/ true), getLoopBreakContinueOccurrences);
                case 137 /* ConstructorKeyword */ :
                    return getFromAllDeclarations(isConstructorDeclaration, [
                        137 /* ConstructorKeyword */ 
                    ]);
                case 139 /* GetKeyword */ :
                case 153 /* SetKeyword */ :
                    return getFromAllDeclarations(isAccessor, [
                        139 /* GetKeyword */ ,
                        153 /* SetKeyword */ 
                    ]);
                case 135 /* AwaitKeyword */ :
                    return useParent(node.parent, isAwaitExpression, getAsyncAndAwaitOccurrences);
                case 134 /* AsyncKeyword */ :
                    return highlightSpans(getAsyncAndAwaitOccurrences(node));
                case 127 /* YieldKeyword */ :
                    return highlightSpans(getYieldOccurrences(node));
                case 103 /* InKeyword */ :
                case 147 /* OutKeyword */ :
                    return void 0;
                default:
                    return isModifierKind(node.kind) && (isDeclaration(node.parent) || isVariableStatement(node.parent)) ? highlightSpans(getModifierOccurrences(node.kind, node.parent)) : void 0;
            }
            function getFromAllDeclarations(nodeTest, keywords) {
                return useParent(node.parent, nodeTest, (decl)=>{
                    var _a;
                    return mapDefined((_a = tryCast(decl, canHaveSymbol)) == null ? void 0 : _a.symbol.declarations, (d)=>nodeTest(d) ? find(d.getChildren(sourceFile), (c)=>contains(keywords, c.kind)) : void 0);
                });
            }
            function useParent(node2, nodeTest, getNodes4) {
                return nodeTest(node2) ? highlightSpans(getNodes4(node2, sourceFile)) : void 0;
            }
            function highlightSpans(nodes) {
                return nodes && nodes.map((node2)=>getHighlightSpanForNode(node2, sourceFile));
            }
        }
        function aggregateOwnedThrowStatements(node) {
            if (isThrowStatement(node)) return [
                node
            ];
            else if (isTryStatement(node)) return concatenate(node.catchClause ? aggregateOwnedThrowStatements(node.catchClause) : node.tryBlock && aggregateOwnedThrowStatements(node.tryBlock), node.finallyBlock && aggregateOwnedThrowStatements(node.finallyBlock));
            return isFunctionLike(node) ? void 0 : flatMapChildren(node, aggregateOwnedThrowStatements);
        }
        function getThrowStatementOwner(throwStatement) {
            let child = throwStatement;
            while(child.parent){
                const parent2 = child.parent;
                if (isFunctionBlock(parent2) || parent2.kind === 308 /* SourceFile */ ) return parent2;
                if (isTryStatement(parent2) && parent2.tryBlock === child && parent2.catchClause) return child;
                child = parent2;
            }
            return void 0;
        }
        function aggregateAllBreakAndContinueStatements(node) {
            return isBreakOrContinueStatement(node) ? [
                node
            ] : isFunctionLike(node) ? void 0 : flatMapChildren(node, aggregateAllBreakAndContinueStatements);
        }
        function flatMapChildren(node, cb) {
            const result = [];
            node.forEachChild((child)=>{
                const value1 = cb(child);
                if (value1 !== void 0) result.push(...toArray(value1));
            });
            return result;
        }
        function ownsBreakOrContinueStatement(owner, statement) {
            const actualOwner = getBreakOrContinueOwner(statement);
            return !!actualOwner && actualOwner === owner;
        }
        function getBreakOrContinueOwner(statement) {
            return findAncestor(statement, (node)=>{
                switch(node.kind){
                    case 256 /* SwitchStatement */ :
                        if (statement.kind === 252 /* ContinueStatement */ ) return false;
                    // falls through
                    case 249 /* ForStatement */ :
                    case 250 /* ForInStatement */ :
                    case 251 /* ForOfStatement */ :
                    case 248 /* WhileStatement */ :
                    case 247 /* DoStatement */ :
                        return !statement.label || isLabeledBy(node, statement.label.escapedText);
                    default:
                        return isFunctionLike(node) && "quit";
                }
            });
        }
        function getModifierOccurrences(modifier, declaration) {
            return mapDefined(getNodesToSearchForModifier(declaration, modifierToFlag(modifier)), (node)=>findModifier(node, modifier));
        }
        function getNodesToSearchForModifier(declaration, modifierFlag) {
            const container = declaration.parent;
            switch(container.kind){
                case 269 /* ModuleBlock */ :
                case 308 /* SourceFile */ :
                case 242 /* Block */ :
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                    if (modifierFlag & 64 /* Abstract */  && isClassDeclaration(declaration)) return [
                        ...declaration.members,
                        declaration
                    ];
                    else return container.statements;
                case 177 /* Constructor */ :
                case 175 /* MethodDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                    return [
                        ...container.parameters,
                        ...isClassLike(container.parent) ? container.parent.members : []
                    ];
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                case 265 /* InterfaceDeclaration */ :
                case 188 /* TypeLiteral */ :
                    const nodes = container.members;
                    if (modifierFlag & 15 /* Readonly */ ) {
                        const constructor = find(container.members, isConstructorDeclaration);
                        if (constructor) return [
                            ...nodes,
                            ...constructor.parameters
                        ];
                    } else if (modifierFlag & 64 /* Abstract */ ) return [
                        ...nodes,
                        container
                    ];
                    return nodes;
                // Syntactically invalid positions that the parser might produce anyway
                default:
                    return void 0;
            }
        }
        function pushKeywordIf(keywordList, token, ...expected) {
            if (token && contains(expected, token.kind)) {
                keywordList.push(token);
                return true;
            }
            return false;
        }
        function getLoopBreakContinueOccurrences(loopNode) {
            const keywords = [];
            if (pushKeywordIf(keywords, loopNode.getFirstToken(), 99 /* ForKeyword */ , 117 /* WhileKeyword */ , 92 /* DoKeyword */ )) {
                if (loopNode.kind === 247 /* DoStatement */ ) {
                    const loopTokens = loopNode.getChildren();
                    for(let i = loopTokens.length - 1; i >= 0; i--){
                        if (pushKeywordIf(keywords, loopTokens[i], 117 /* WhileKeyword */ )) break;
                    }
                }
            }
            forEach(aggregateAllBreakAndContinueStatements(loopNode.statement), (statement)=>{
                if (ownsBreakOrContinueStatement(loopNode, statement)) pushKeywordIf(keywords, statement.getFirstToken(), 83 /* BreakKeyword */ , 88 /* ContinueKeyword */ );
            });
            return keywords;
        }
        function getBreakOrContinueStatementOccurrences(breakOrContinueStatement) {
            const owner = getBreakOrContinueOwner(breakOrContinueStatement);
            if (owner) switch(owner.kind){
                case 249 /* ForStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                    return getLoopBreakContinueOccurrences(owner);
                case 256 /* SwitchStatement */ :
                    return getSwitchCaseDefaultOccurrences(owner);
            }
            return void 0;
        }
        function getSwitchCaseDefaultOccurrences(switchStatement) {
            const keywords = [];
            pushKeywordIf(keywords, switchStatement.getFirstToken(), 109 /* SwitchKeyword */ );
            forEach(switchStatement.caseBlock.clauses, (clause)=>{
                pushKeywordIf(keywords, clause.getFirstToken(), 84 /* CaseKeyword */ , 90 /* DefaultKeyword */ );
                forEach(aggregateAllBreakAndContinueStatements(clause), (statement)=>{
                    if (ownsBreakOrContinueStatement(switchStatement, statement)) pushKeywordIf(keywords, statement.getFirstToken(), 83 /* BreakKeyword */ );
                });
            });
            return keywords;
        }
        function getTryCatchFinallyOccurrences(tryStatement, sourceFile) {
            const keywords = [];
            pushKeywordIf(keywords, tryStatement.getFirstToken(), 113 /* TryKeyword */ );
            if (tryStatement.catchClause) pushKeywordIf(keywords, tryStatement.catchClause.getFirstToken(), 85 /* CatchKeyword */ );
            if (tryStatement.finallyBlock) {
                const finallyKeyword = findChildOfKind(tryStatement, 98 /* FinallyKeyword */ , sourceFile);
                pushKeywordIf(keywords, finallyKeyword, 98 /* FinallyKeyword */ );
            }
            return keywords;
        }
        function getThrowOccurrences(throwStatement, sourceFile) {
            const owner = getThrowStatementOwner(throwStatement);
            if (!owner) return void 0;
            const keywords = [];
            forEach(aggregateOwnedThrowStatements(owner), (throwStatement2)=>{
                keywords.push(findChildOfKind(throwStatement2, 111 /* ThrowKeyword */ , sourceFile));
            });
            if (isFunctionBlock(owner)) forEachReturnStatement(owner, (returnStatement)=>{
                keywords.push(findChildOfKind(returnStatement, 107 /* ReturnKeyword */ , sourceFile));
            });
            return keywords;
        }
        function getReturnOccurrences(returnStatement, sourceFile) {
            const func = getContainingFunction(returnStatement);
            if (!func) return void 0;
            const keywords = [];
            forEachReturnStatement(cast(func.body, isBlock), (returnStatement2)=>{
                keywords.push(findChildOfKind(returnStatement2, 107 /* ReturnKeyword */ , sourceFile));
            });
            forEach(aggregateOwnedThrowStatements(func.body), (throwStatement)=>{
                keywords.push(findChildOfKind(throwStatement, 111 /* ThrowKeyword */ , sourceFile));
            });
            return keywords;
        }
        function getAsyncAndAwaitOccurrences(node) {
            const func = getContainingFunction(node);
            if (!func) return void 0;
            const keywords = [];
            if (func.modifiers) func.modifiers.forEach((modifier)=>{
                pushKeywordIf(keywords, modifier, 134 /* AsyncKeyword */ );
            });
            forEachChild(func, (child)=>{
                traverseWithoutCrossingFunction(child, (node2)=>{
                    if (isAwaitExpression(node2)) pushKeywordIf(keywords, node2.getFirstToken(), 135 /* AwaitKeyword */ );
                });
            });
            return keywords;
        }
        function getYieldOccurrences(node) {
            const func = getContainingFunction(node);
            if (!func) return void 0;
            const keywords = [];
            forEachChild(func, (child)=>{
                traverseWithoutCrossingFunction(child, (node2)=>{
                    if (isYieldExpression(node2)) pushKeywordIf(keywords, node2.getFirstToken(), 127 /* YieldKeyword */ );
                });
            });
            return keywords;
        }
        function traverseWithoutCrossingFunction(node, cb) {
            cb(node);
            if (!isFunctionLike(node) && !isClassLike(node) && !isInterfaceDeclaration(node) && !isModuleDeclaration(node) && !isTypeAliasDeclaration(node) && !isTypeNode(node)) forEachChild(node, (child)=>traverseWithoutCrossingFunction(child, cb));
        }
        function getIfElseOccurrences(ifStatement, sourceFile) {
            const keywords = getIfElseKeywords(ifStatement, sourceFile);
            const result = [];
            for(let i = 0; i < keywords.length; i++){
                if (keywords[i].kind === 93 /* ElseKeyword */  && i < keywords.length - 1) {
                    const elseKeyword = keywords[i];
                    const ifKeyword = keywords[i + 1];
                    let shouldCombineElseAndIf = true;
                    for(let j = ifKeyword.getStart(sourceFile) - 1; j >= elseKeyword.end; j--)if (!isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(j))) {
                        shouldCombineElseAndIf = false;
                        break;
                    }
                    if (shouldCombineElseAndIf) {
                        result.push({
                            fileName: sourceFile.fileName,
                            textSpan: createTextSpanFromBounds(elseKeyword.getStart(), ifKeyword.end),
                            kind: "reference" /* reference */ 
                        });
                        i++;
                        continue;
                    }
                }
                result.push(getHighlightSpanForNode(keywords[i], sourceFile));
            }
            return result;
        }
        function getIfElseKeywords(ifStatement, sourceFile) {
            const keywords = [];
            while(isIfStatement(ifStatement.parent) && ifStatement.parent.elseStatement === ifStatement)ifStatement = ifStatement.parent;
            while(true){
                const children = ifStatement.getChildren(sourceFile);
                pushKeywordIf(keywords, children[0], 101 /* IfKeyword */ );
                for(let i = children.length - 1; i >= 0; i--){
                    if (pushKeywordIf(keywords, children[i], 93 /* ElseKeyword */ )) break;
                }
                if (!ifStatement.elseStatement || !isIfStatement(ifStatement.elseStatement)) break;
                ifStatement = ifStatement.elseStatement;
            }
            return keywords;
        }
        function isLabeledBy(node, labelName) {
            return !!findAncestor(node.parent, (owner)=>!isLabeledStatement(owner) ? "quit" : owner.label.escapedText === labelName);
        }
    })(DocumentHighlights || (DocumentHighlights = {}));
    // src/services/documentRegistry.ts
    function isDocumentRegistryEntry(entry) {
        return !!entry.sourceFile;
    }
    function createDocumentRegistry(useCaseSensitiveFileNames2, currentDirectory, jsDocParsingMode) {
        return createDocumentRegistryInternal(useCaseSensitiveFileNames2, currentDirectory, jsDocParsingMode);
    }
    function createDocumentRegistryInternal(useCaseSensitiveFileNames2, currentDirectory = "", jsDocParsingMode, externalCache) {
        const buckets = /* @__PURE__ */ new Map();
        const getCanonicalFileName = createGetCanonicalFileName(!!useCaseSensitiveFileNames2);
        function reportStats() {
            const bucketInfoArray = arrayFrom(buckets.keys()).filter((name)=>name && name.charAt(0) === "_").map((name)=>{
                const entries = buckets.get(name);
                const sourceFiles = [];
                entries.forEach((entry, name2)=>{
                    if (isDocumentRegistryEntry(entry)) sourceFiles.push({
                        name: name2,
                        scriptKind: entry.sourceFile.scriptKind,
                        refCount: entry.languageServiceRefCount
                    });
                    else entry.forEach((value1, scriptKind)=>sourceFiles.push({
                            name: name2,
                            scriptKind,
                            refCount: value1.languageServiceRefCount
                        }));
                });
                sourceFiles.sort((x, y)=>y.refCount - x.refCount);
                return {
                    bucket: name,
                    sourceFiles
                };
            });
            return JSON.stringify(bucketInfoArray, void 0, 2);
        }
        function getCompilationSettings(settingsOrHost) {
            if (typeof settingsOrHost.getCompilationSettings === "function") return settingsOrHost.getCompilationSettings();
            return settingsOrHost;
        }
        function acquireDocument(fileName, compilationSettings, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            const path = toPath(fileName, currentDirectory, getCanonicalFileName);
            const key = getKeyForCompilationSettings(getCompilationSettings(compilationSettings));
            return acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions);
        }
        function acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            return acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version2, /*acquiring*/ true, scriptKind, languageVersionOrOptions);
        }
        function updateDocument(fileName, compilationSettings, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            const path = toPath(fileName, currentDirectory, getCanonicalFileName);
            const key = getKeyForCompilationSettings(getCompilationSettings(compilationSettings));
            return updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions);
        }
        function updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version2, scriptKind, languageVersionOrOptions) {
            return acquireOrUpdateDocument(fileName, path, getCompilationSettings(compilationSettings), key, scriptSnapshot, version2, /*acquiring*/ false, scriptKind, languageVersionOrOptions);
        }
        function getDocumentRegistryEntry(bucketEntry, scriptKind) {
            const entry = isDocumentRegistryEntry(bucketEntry) ? bucketEntry : bucketEntry.get(Debug.checkDefined(scriptKind, "If there are more than one scriptKind's for same document the scriptKind should be provided"));
            Debug.assert(scriptKind === void 0 || !entry || entry.sourceFile.scriptKind === scriptKind, `Script kind should match provided ScriptKind:${scriptKind} and sourceFile.scriptKind: ${entry == null ? void 0 : entry.sourceFile.scriptKind}, !entry: ${!entry}`);
            return entry;
        }
        function acquireOrUpdateDocument(fileName, path, compilationSettingsOrHost, key, scriptSnapshot, version2, acquiring, scriptKind, languageVersionOrOptions) {
            var _a, _b, _c, _d;
            scriptKind = ensureScriptKind(fileName, scriptKind);
            const compilationSettings = getCompilationSettings(compilationSettingsOrHost);
            const host = compilationSettingsOrHost === compilationSettings ? void 0 : compilationSettingsOrHost;
            const scriptTarget = scriptKind === 6 /* JSON */  ? 100 /* JSON */  : getEmitScriptTarget(compilationSettings);
            const sourceFileOptions = typeof languageVersionOrOptions === "object" ? languageVersionOrOptions : {
                languageVersion: scriptTarget,
                impliedNodeFormat: host && getImpliedNodeFormatForFile(path, (_d = (_c = (_b = (_a = host.getCompilerHost) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getModuleResolutionCache) == null ? void 0 : _c.call(_b)) == null ? void 0 : _d.getPackageJsonInfoCache(), host, compilationSettings),
                setExternalModuleIndicator: getSetExternalModuleIndicator(compilationSettings),
                jsDocParsingMode
            };
            sourceFileOptions.languageVersion = scriptTarget;
            Debug.assertEqual(jsDocParsingMode, sourceFileOptions.jsDocParsingMode);
            const oldBucketCount = buckets.size;
            const keyWithMode = getDocumentRegistryBucketKeyWithMode(key, sourceFileOptions.impliedNodeFormat);
            const bucket = getOrUpdate(buckets, keyWithMode, ()=>/* @__PURE__ */ new Map());
            if (tracing) {
                if (buckets.size > oldBucketCount) tracing.instant(tracing.Phase.Session, "createdDocumentRegistryBucket", {
                    configFilePath: compilationSettings.configFilePath,
                    key: keyWithMode
                });
                const otherBucketKey = !isDeclarationFileName(path) && forEachEntry(buckets, (bucket2, bucketKey)=>bucketKey !== keyWithMode && bucket2.has(path) && bucketKey);
                if (otherBucketKey) tracing.instant(tracing.Phase.Session, "documentRegistryBucketOverlap", {
                    path,
                    key1: otherBucketKey,
                    key2: keyWithMode
                });
            }
            const bucketEntry = bucket.get(path);
            let entry = bucketEntry && getDocumentRegistryEntry(bucketEntry, scriptKind);
            if (!entry && externalCache) {
                const sourceFile = externalCache.getDocument(keyWithMode, path);
                if (sourceFile && sourceFile.scriptKind === scriptKind && sourceFile.text === getSnapshotText(scriptSnapshot)) {
                    Debug.assert(acquiring);
                    entry = {
                        sourceFile,
                        languageServiceRefCount: 0
                    };
                    setBucketEntry();
                }
            }
            if (!entry) {
                const sourceFile = createLanguageServiceSourceFile(fileName, scriptSnapshot, sourceFileOptions, version2, /*setNodeParents*/ false, scriptKind);
                if (externalCache) externalCache.setDocument(keyWithMode, path, sourceFile);
                entry = {
                    sourceFile,
                    languageServiceRefCount: 1
                };
                setBucketEntry();
            } else {
                if (entry.sourceFile.version !== version2) {
                    entry.sourceFile = updateLanguageServiceSourceFile(entry.sourceFile, scriptSnapshot, version2, scriptSnapshot.getChangeRange(entry.sourceFile.scriptSnapshot));
                    if (externalCache) externalCache.setDocument(keyWithMode, path, entry.sourceFile);
                }
                if (acquiring) entry.languageServiceRefCount++;
            }
            Debug.assert(entry.languageServiceRefCount !== 0);
            return entry.sourceFile;
            function setBucketEntry() {
                if (!bucketEntry) bucket.set(path, entry);
                else if (isDocumentRegistryEntry(bucketEntry)) {
                    const scriptKindMap = /* @__PURE__ */ new Map();
                    scriptKindMap.set(bucketEntry.sourceFile.scriptKind, bucketEntry);
                    scriptKindMap.set(scriptKind, entry);
                    bucket.set(path, scriptKindMap);
                } else bucketEntry.set(scriptKind, entry);
            }
        }
        function releaseDocument(fileName, compilationSettings, scriptKind, impliedNodeFormat) {
            const path = toPath(fileName, currentDirectory, getCanonicalFileName);
            const key = getKeyForCompilationSettings(compilationSettings);
            return releaseDocumentWithKey(path, key, scriptKind, impliedNodeFormat);
        }
        function releaseDocumentWithKey(path, key, scriptKind, impliedNodeFormat) {
            const bucket = Debug.checkDefined(buckets.get(getDocumentRegistryBucketKeyWithMode(key, impliedNodeFormat)));
            const bucketEntry = bucket.get(path);
            const entry = getDocumentRegistryEntry(bucketEntry, scriptKind);
            entry.languageServiceRefCount--;
            Debug.assert(entry.languageServiceRefCount >= 0);
            if (entry.languageServiceRefCount === 0) {
                if (isDocumentRegistryEntry(bucketEntry)) bucket.delete(path);
                else {
                    bucketEntry.delete(scriptKind);
                    if (bucketEntry.size === 1) bucket.set(path, firstDefinedIterator(bucketEntry.values(), identity));
                }
            }
        }
        return {
            acquireDocument,
            acquireDocumentWithKey,
            updateDocument,
            updateDocumentWithKey,
            releaseDocument,
            releaseDocumentWithKey,
            getKeyForCompilationSettings,
            getDocumentRegistryBucketKeyWithMode,
            reportStats,
            getBuckets: ()=>buckets
        };
    }
    function getKeyForCompilationSettings(settings) {
        return getKeyForCompilerOptions(settings, sourceFileAffectingCompilerOptions);
    }
    function getDocumentRegistryBucketKeyWithMode(key, mode) {
        return mode ? `${key}|${mode}` : key;
    }
    // src/services/getEditsForFileRename.ts
    function getEditsForFileRename(program, oldFileOrDirPath, newFileOrDirPath, host, formatContext, preferences, sourceMapper) {
        const useCaseSensitiveFileNames2 = hostUsesCaseSensitiveFileNames(host);
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        const oldToNew = getPathUpdater(oldFileOrDirPath, newFileOrDirPath, getCanonicalFileName, sourceMapper);
        const newToOld = getPathUpdater(newFileOrDirPath, oldFileOrDirPath, getCanonicalFileName, sourceMapper);
        return ts_textChanges_exports.ChangeTracker.with({
            host,
            formatContext,
            preferences
        }, (changeTracker)=>{
            updateTsconfigFiles(program, changeTracker, oldToNew, oldFileOrDirPath, newFileOrDirPath, host.getCurrentDirectory(), useCaseSensitiveFileNames2);
            updateImports(program, changeTracker, oldToNew, newToOld, host, getCanonicalFileName);
        });
    }
    function getPathUpdater(oldFileOrDirPath, newFileOrDirPath, getCanonicalFileName, sourceMapper) {
        const canonicalOldPath = getCanonicalFileName(oldFileOrDirPath);
        return (path)=>{
            const originalPath = sourceMapper && sourceMapper.tryGetSourcePosition({
                fileName: path,
                pos: 0
            });
            const updatedPath = getUpdatedPath(originalPath ? originalPath.fileName : path);
            return originalPath ? updatedPath === void 0 ? void 0 : makeCorrespondingRelativeChange(originalPath.fileName, updatedPath, path, getCanonicalFileName) : updatedPath;
        };
        function getUpdatedPath(pathToUpdate) {
            if (getCanonicalFileName(pathToUpdate) === canonicalOldPath) return newFileOrDirPath;
            const suffix = tryRemoveDirectoryPrefix(pathToUpdate, canonicalOldPath, getCanonicalFileName);
            return suffix === void 0 ? void 0 : newFileOrDirPath + "/" + suffix;
        }
    }
    function makeCorrespondingRelativeChange(a0, b0, a1, getCanonicalFileName) {
        const rel = getRelativePathFromFile(a0, b0, getCanonicalFileName);
        return combinePathsSafe(getDirectoryPath(a1), rel);
    }
    function updateTsconfigFiles(program, changeTracker, oldToNew, oldFileOrDirPath, newFileOrDirPath, currentDirectory, useCaseSensitiveFileNames2) {
        const { configFile } = program.getCompilerOptions();
        if (!configFile) return;
        const configDir = getDirectoryPath(configFile.fileName);
        const jsonObjectLiteral = getTsConfigObjectLiteralExpression(configFile);
        if (!jsonObjectLiteral) return;
        forEachProperty(jsonObjectLiteral, (property, propertyName)=>{
            switch(propertyName){
                case "files":
                case "include":
                case "exclude":
                    {
                        const foundExactMatch = updatePaths(property);
                        if (foundExactMatch || propertyName !== "include" || !isArrayLiteralExpression(property.initializer)) return;
                        const includes = mapDefined(property.initializer.elements, (e)=>isStringLiteral(e) ? e.text : void 0);
                        if (includes.length === 0) return;
                        const matchers = getFileMatcherPatterns(configDir, /*excludes*/ [], includes, useCaseSensitiveFileNames2, currentDirectory);
                        if (getRegexFromPattern(Debug.checkDefined(matchers.includeFilePattern), useCaseSensitiveFileNames2).test(oldFileOrDirPath) && !getRegexFromPattern(Debug.checkDefined(matchers.includeFilePattern), useCaseSensitiveFileNames2).test(newFileOrDirPath)) changeTracker.insertNodeAfter(configFile, last(property.initializer.elements), factory.createStringLiteral(relativePath(newFileOrDirPath)));
                        return;
                    }
                case "compilerOptions":
                    forEachProperty(property.initializer, (property2, propertyName2)=>{
                        const option = getOptionFromName(propertyName2);
                        Debug.assert((option == null ? void 0 : option.type) !== "listOrElement");
                        if (option && (option.isFilePath || option.type === "list" && option.element.isFilePath)) updatePaths(property2);
                        else if (propertyName2 === "paths") forEachProperty(property2.initializer, (pathsProperty)=>{
                            if (!isArrayLiteralExpression(pathsProperty.initializer)) return;
                            for (const e of pathsProperty.initializer.elements)tryUpdateString(e);
                        });
                    });
                    return;
            }
        });
        function updatePaths(property) {
            const elements = isArrayLiteralExpression(property.initializer) ? property.initializer.elements : [
                property.initializer
            ];
            let foundExactMatch = false;
            for (const element of elements)foundExactMatch = tryUpdateString(element) || foundExactMatch;
            return foundExactMatch;
        }
        function tryUpdateString(element) {
            if (!isStringLiteral(element)) return false;
            const elementFileName = combinePathsSafe(configDir, element.text);
            const updated = oldToNew(elementFileName);
            if (updated !== void 0) {
                changeTracker.replaceRangeWithText(configFile, createStringRange(element, configFile), relativePath(updated));
                return true;
            }
            return false;
        }
        function relativePath(path) {
            return getRelativePathFromDirectory(configDir, path, /*ignoreCase*/ !useCaseSensitiveFileNames2);
        }
    }
    function updateImports(program, changeTracker, oldToNew, newToOld, host, getCanonicalFileName) {
        const allFiles = program.getSourceFiles();
        for (const sourceFile of allFiles){
            const newFromOld = oldToNew(sourceFile.fileName);
            const newImportFromPath = newFromOld !== null && newFromOld !== void 0 ? newFromOld : sourceFile.fileName;
            const newImportFromDirectory = getDirectoryPath(newImportFromPath);
            const oldFromNew = newToOld(sourceFile.fileName);
            const oldImportFromPath = oldFromNew || sourceFile.fileName;
            const oldImportFromDirectory = getDirectoryPath(oldImportFromPath);
            const importingSourceFileMoved = newFromOld !== void 0 || oldFromNew !== void 0;
            updateImportsWorker(sourceFile, changeTracker, (referenceText)=>{
                if (!pathIsRelative(referenceText)) return void 0;
                const oldAbsolute = combinePathsSafe(oldImportFromDirectory, referenceText);
                const newAbsolute = oldToNew(oldAbsolute);
                return newAbsolute === void 0 ? void 0 : ensurePathIsNonModuleName(getRelativePathFromDirectory(newImportFromDirectory, newAbsolute, getCanonicalFileName));
            }, (importLiteral)=>{
                const importedModuleSymbol = program.getTypeChecker().getSymbolAtLocation(importLiteral);
                if ((importedModuleSymbol == null ? void 0 : importedModuleSymbol.declarations) && importedModuleSymbol.declarations.some((d)=>isAmbientModule(d))) return void 0;
                const toImport = oldFromNew !== void 0 ? getSourceFileToImportFromResolved(importLiteral, resolveModuleName(importLiteral.text, oldImportFromPath, program.getCompilerOptions(), host), oldToNew, allFiles) : getSourceFileToImport(importedModuleSymbol, importLiteral, sourceFile, program, host, oldToNew);
                return toImport !== void 0 && (toImport.updated || importingSourceFileMoved && pathIsRelative(importLiteral.text)) ? ts_moduleSpecifiers_exports.updateModuleSpecifier(program.getCompilerOptions(), sourceFile, newImportFromPath, toImport.newFileName, createModuleSpecifierResolutionHost(program, host), importLiteral.text) : void 0;
            });
        }
    }
    function combineNormal(pathA, pathB) {
        return normalizePath(combinePaths(pathA, pathB));
    }
    function combinePathsSafe(pathA, pathB) {
        return ensurePathIsNonModuleName(combineNormal(pathA, pathB));
    }
    function getSourceFileToImport(importedModuleSymbol, importLiteral, importingSourceFile, program, host, oldToNew) {
        if (importedModuleSymbol) {
            const oldFileName = find(importedModuleSymbol.declarations, isSourceFile).fileName;
            const newFileName = oldToNew(oldFileName);
            return newFileName === void 0 ? {
                newFileName: oldFileName,
                updated: false
            } : {
                newFileName,
                updated: true
            };
        } else {
            const mode = program.getModeForUsageLocation(importingSourceFile, importLiteral);
            const resolved = host.resolveModuleNameLiterals || !host.resolveModuleNames ? program.getResolvedModuleFromModuleSpecifier(importLiteral, importingSourceFile) : host.getResolvedModuleWithFailedLookupLocationsFromCache && host.getResolvedModuleWithFailedLookupLocationsFromCache(importLiteral.text, importingSourceFile.fileName, mode);
            return getSourceFileToImportFromResolved(importLiteral, resolved, oldToNew, program.getSourceFiles());
        }
    }
    function getSourceFileToImportFromResolved(importLiteral, resolved, oldToNew, sourceFiles) {
        if (!resolved) return void 0;
        if (resolved.resolvedModule) {
            const result2 = tryChange(resolved.resolvedModule.resolvedFileName);
            if (result2) return result2;
        }
        const result = forEach(resolved.failedLookupLocations, tryChangeWithIgnoringPackageJsonExisting) || pathIsRelative(importLiteral.text) && forEach(resolved.failedLookupLocations, tryChangeWithIgnoringPackageJson);
        if (result) return result;
        return resolved.resolvedModule && {
            newFileName: resolved.resolvedModule.resolvedFileName,
            updated: false
        };
        function tryChangeWithIgnoringPackageJsonExisting(oldFileName) {
            const newFileName = oldToNew(oldFileName);
            return newFileName && find(sourceFiles, (src)=>src.fileName === newFileName) ? tryChangeWithIgnoringPackageJson(oldFileName) : void 0;
        }
        function tryChangeWithIgnoringPackageJson(oldFileName) {
            return !endsWith(oldFileName, "/package.json") ? tryChange(oldFileName) : void 0;
        }
        function tryChange(oldFileName) {
            const newFileName = oldToNew(oldFileName);
            return newFileName && {
                newFileName,
                updated: true
            };
        }
    }
    function updateImportsWorker(sourceFile, changeTracker, updateRef, updateImport) {
        for (const ref of sourceFile.referencedFiles || emptyArray){
            const updated = updateRef(ref.fileName);
            if (updated !== void 0 && updated !== sourceFile.text.slice(ref.pos, ref.end)) changeTracker.replaceRangeWithText(sourceFile, ref, updated);
        }
        for (const importStringLiteral of sourceFile.imports){
            const updated = updateImport(importStringLiteral);
            if (updated !== void 0 && updated !== importStringLiteral.text) changeTracker.replaceRangeWithText(sourceFile, createStringRange(importStringLiteral, sourceFile), updated);
        }
    }
    function createStringRange(node, sourceFile) {
        return createRange(node.getStart(sourceFile) + 1, node.end - 1);
    }
    function forEachProperty(objectLiteral, cb) {
        if (!isObjectLiteralExpression(objectLiteral)) return;
        for (const property of objectLiteral.properties)if (isPropertyAssignment(property) && isStringLiteral(property.name)) cb(property, property.name.text);
    }
    // src/services/patternMatcher.ts
    var PatternMatchKind = /* @__PURE__ */ ((PatternMatchKind2)=>{
        PatternMatchKind2[PatternMatchKind2["exact"] = 0] = "exact";
        PatternMatchKind2[PatternMatchKind2["prefix"] = 1] = "prefix";
        PatternMatchKind2[PatternMatchKind2["substring"] = 2] = "substring";
        PatternMatchKind2[PatternMatchKind2["camelCase"] = 3] = "camelCase";
        return PatternMatchKind2;
    })(PatternMatchKind || {});
    function createPatternMatch(kind, isCaseSensitive) {
        return {
            kind,
            isCaseSensitive
        };
    }
    function createPatternMatcher(pattern) {
        const stringToWordSpans = /* @__PURE__ */ new Map();
        const dotSeparatedSegments = pattern.trim().split(".").map((p)=>createSegment(p.trim()));
        if (dotSeparatedSegments.length === 1 && dotSeparatedSegments[0].totalTextChunk.text === "") return {
            getMatchForLastSegmentOfPattern: ()=>createPatternMatch(2 /* substring */ , /*isCaseSensitive*/ true),
            getFullMatch: ()=>createPatternMatch(2 /* substring */ , /*isCaseSensitive*/ true),
            patternContainsDots: false
        };
        if (dotSeparatedSegments.some((segment)=>!segment.subWordTextChunks.length)) return void 0;
        return {
            getFullMatch: (containers, candidate)=>getFullMatch(containers, candidate, dotSeparatedSegments, stringToWordSpans),
            getMatchForLastSegmentOfPattern: (candidate)=>matchSegment(candidate, last(dotSeparatedSegments), stringToWordSpans),
            patternContainsDots: dotSeparatedSegments.length > 1
        };
    }
    function getFullMatch(candidateContainers, candidate, dotSeparatedSegments, stringToWordSpans) {
        const candidateMatch = matchSegment(candidate, last(dotSeparatedSegments), stringToWordSpans);
        if (!candidateMatch) return void 0;
        if (dotSeparatedSegments.length - 1 > candidateContainers.length) return void 0;
        let bestMatch;
        for(let i = dotSeparatedSegments.length - 2, j = candidateContainers.length - 1; i >= 0; i -= 1, j -= 1)bestMatch = betterMatch(bestMatch, matchSegment(candidateContainers[j], dotSeparatedSegments[i], stringToWordSpans));
        return bestMatch;
    }
    function getWordSpans(word, stringToWordSpans) {
        let spans = stringToWordSpans.get(word);
        if (!spans) stringToWordSpans.set(word, spans = breakIntoWordSpans(word));
        return spans;
    }
    function matchTextChunk(candidate, chunk, stringToWordSpans) {
        const index = indexOfIgnoringCase(candidate, chunk.textLowerCase);
        if (index === 0) return createPatternMatch(chunk.text.length === candidate.length ? 0 /* exact */  : 1 /* prefix */ , /*isCaseSensitive:*/ startsWith(candidate, chunk.text));
        if (chunk.isLowerCase) {
            if (index === -1) return void 0;
            const wordSpans = getWordSpans(candidate, stringToWordSpans);
            for (const span of wordSpans){
                if (partStartsWith(candidate, span, chunk.text, /*ignoreCase*/ true)) return createPatternMatch(2 /* substring */ , /*isCaseSensitive:*/ partStartsWith(candidate, span, chunk.text, /*ignoreCase*/ false));
            }
            if (chunk.text.length < candidate.length && isUpperCaseLetter(candidate.charCodeAt(index))) return createPatternMatch(2 /* substring */ , /*isCaseSensitive*/ false);
        } else {
            if (candidate.indexOf(chunk.text) > 0) return createPatternMatch(2 /* substring */ , /*isCaseSensitive*/ true);
            if (chunk.characterSpans.length > 0) {
                const candidateParts = getWordSpans(candidate, stringToWordSpans);
                const isCaseSensitive = tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase*/ false) ? true : tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase*/ true) ? false : void 0;
                if (isCaseSensitive !== void 0) return createPatternMatch(3 /* camelCase */ , isCaseSensitive);
            }
        }
    }
    function matchSegment(candidate, segment, stringToWordSpans) {
        if (every2(segment.totalTextChunk.text, (ch)=>ch !== 32 /* space */  && ch !== 42 /* asterisk */ )) {
            const match = matchTextChunk(candidate, segment.totalTextChunk, stringToWordSpans);
            if (match) return match;
        }
        const subWordTextChunks = segment.subWordTextChunks;
        let bestMatch;
        for (const subWordTextChunk of subWordTextChunks)bestMatch = betterMatch(bestMatch, matchTextChunk(candidate, subWordTextChunk, stringToWordSpans));
        return bestMatch;
    }
    function betterMatch(a, b) {
        return min([
            a,
            b
        ], compareMatches);
    }
    function compareMatches(a, b) {
        return a === void 0 ? 1 /* GreaterThan */  : b === void 0 ? -1 /* LessThan */  : compareValues(a.kind, b.kind) || compareBooleans(!a.isCaseSensitive, !b.isCaseSensitive);
    }
    function partStartsWith(candidate, candidateSpan, pattern, ignoreCase, patternSpan = {
        start: 0,
        length: pattern.length
    }) {
        return patternSpan.length <= candidateSpan.length && everyInRange(0, patternSpan.length, (i)=>equalChars(pattern.charCodeAt(patternSpan.start + i), candidate.charCodeAt(candidateSpan.start + i), ignoreCase));
    }
    function equalChars(ch1, ch2, ignoreCase) {
        return ignoreCase ? toLowerCase2(ch1) === toLowerCase2(ch2) : ch1 === ch2;
    }
    function tryCamelCaseMatch(candidate, candidateParts, chunk, ignoreCase) {
        const chunkCharacterSpans = chunk.characterSpans;
        let currentCandidate = 0;
        let currentChunkSpan = 0;
        let firstMatch;
        let contiguous;
        while(true){
            if (currentChunkSpan === chunkCharacterSpans.length) return true;
            else if (currentCandidate === candidateParts.length) return false;
            let candidatePart = candidateParts[currentCandidate];
            let gotOneMatchThisCandidate = false;
            for(; currentChunkSpan < chunkCharacterSpans.length; currentChunkSpan++){
                const chunkCharacterSpan = chunkCharacterSpans[currentChunkSpan];
                if (gotOneMatchThisCandidate) {
                    if (!isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan - 1].start)) || !isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan].start))) break;
                }
                if (!partStartsWith(candidate, candidatePart, chunk.text, ignoreCase, chunkCharacterSpan)) break;
                gotOneMatchThisCandidate = true;
                firstMatch = firstMatch === void 0 ? currentCandidate : firstMatch;
                contiguous = contiguous === void 0 ? true : contiguous;
                candidatePart = createTextSpan(candidatePart.start + chunkCharacterSpan.length, candidatePart.length - chunkCharacterSpan.length);
            }
            if (!gotOneMatchThisCandidate && contiguous !== void 0) contiguous = false;
            currentCandidate++;
        }
    }
    function createSegment(text) {
        return {
            totalTextChunk: createTextChunk(text),
            subWordTextChunks: breakPatternIntoTextChunks(text)
        };
    }
    function isUpperCaseLetter(ch) {
        if (ch >= 65 /* A */  && ch <= 90 /* Z */ ) return true;
        if (ch < 127 /* maxAsciiCharacter */  || !isUnicodeIdentifierStart(ch, 99 /* Latest */ )) return false;
        const str = String.fromCharCode(ch);
        return str === str.toUpperCase();
    }
    function isLowerCaseLetter(ch) {
        if (ch >= 97 /* a */  && ch <= 122 /* z */ ) return true;
        if (ch < 127 /* maxAsciiCharacter */  || !isUnicodeIdentifierStart(ch, 99 /* Latest */ )) return false;
        const str = String.fromCharCode(ch);
        return str === str.toLowerCase();
    }
    function indexOfIgnoringCase(str, value1) {
        const n = str.length - value1.length;
        for(let start = 0; start <= n; start++){
            if (every2(value1, (valueChar, i)=>toLowerCase2(str.charCodeAt(i + start)) === valueChar)) return start;
        }
        return -1;
    }
    function toLowerCase2(ch) {
        if (ch >= 65 /* A */  && ch <= 90 /* Z */ ) return 97 /* a */  + (ch - 65 /* A */ );
        if (ch < 127 /* maxAsciiCharacter */ ) return ch;
        return String.fromCharCode(ch).toLowerCase().charCodeAt(0);
    }
    function isDigit2(ch) {
        return ch >= 48 /* _0 */  && ch <= 57 /* _9 */ ;
    }
    function isWordChar(ch) {
        return isUpperCaseLetter(ch) || isLowerCaseLetter(ch) || isDigit2(ch) || ch === 95 /* _ */  || ch === 36 /* $ */ ;
    }
    function breakPatternIntoTextChunks(pattern) {
        const result = [];
        let wordStart = 0;
        let wordLength = 0;
        for(let i = 0; i < pattern.length; i++){
            const ch = pattern.charCodeAt(i);
            if (isWordChar(ch)) {
                if (wordLength === 0) wordStart = i;
                wordLength++;
            } else if (wordLength > 0) {
                result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
                wordLength = 0;
            }
        }
        if (wordLength > 0) result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
        return result;
    }
    function createTextChunk(text) {
        const textLowerCase = text.toLowerCase();
        return {
            text,
            textLowerCase,
            isLowerCase: text === textLowerCase,
            characterSpans: breakIntoCharacterSpans(text)
        };
    }
    function breakIntoCharacterSpans(identifier) {
        return breakIntoSpans(identifier, /*word*/ false);
    }
    function breakIntoWordSpans(identifier) {
        return breakIntoSpans(identifier, /*word*/ true);
    }
    function breakIntoSpans(identifier, word) {
        const result = [];
        let wordStart = 0;
        for(let i = 1; i < identifier.length; i++){
            const lastIsDigit = isDigit2(identifier.charCodeAt(i - 1));
            const currentIsDigit = isDigit2(identifier.charCodeAt(i));
            const hasTransitionFromLowerToUpper = transitionFromLowerToUpper(identifier, word, i);
            const hasTransitionFromUpperToLower = word && transitionFromUpperToLower(identifier, i, wordStart);
            if (charIsPunctuation(identifier.charCodeAt(i - 1)) || charIsPunctuation(identifier.charCodeAt(i)) || lastIsDigit !== currentIsDigit || hasTransitionFromLowerToUpper || hasTransitionFromUpperToLower) {
                if (!isAllPunctuation(identifier, wordStart, i)) result.push(createTextSpan(wordStart, i - wordStart));
                wordStart = i;
            }
        }
        if (!isAllPunctuation(identifier, wordStart, identifier.length)) result.push(createTextSpan(wordStart, identifier.length - wordStart));
        return result;
    }
    function charIsPunctuation(ch) {
        switch(ch){
            case 33 /* exclamation */ :
            case 34 /* doubleQuote */ :
            case 35 /* hash */ :
            case 37 /* percent */ :
            case 38 /* ampersand */ :
            case 39 /* singleQuote */ :
            case 40 /* openParen */ :
            case 41 /* closeParen */ :
            case 42 /* asterisk */ :
            case 44 /* comma */ :
            case 45 /* minus */ :
            case 46 /* dot */ :
            case 47 /* slash */ :
            case 58 /* colon */ :
            case 59 /* semicolon */ :
            case 63 /* question */ :
            case 64 /* at */ :
            case 91 /* openBracket */ :
            case 92 /* backslash */ :
            case 93 /* closeBracket */ :
            case 95 /* _ */ :
            case 123 /* openBrace */ :
            case 125 /* closeBrace */ :
                return true;
        }
        return false;
    }
    function isAllPunctuation(identifier, start, end) {
        return every2(identifier, (ch)=>charIsPunctuation(ch) && ch !== 95 /* _ */ , start, end);
    }
    function transitionFromUpperToLower(identifier, index, wordStart) {
        return index !== wordStart && index + 1 < identifier.length && isUpperCaseLetter(identifier.charCodeAt(index)) && isLowerCaseLetter(identifier.charCodeAt(index + 1)) && every2(identifier, isUpperCaseLetter, wordStart, index);
    }
    function transitionFromLowerToUpper(identifier, word, index) {
        const lastIsUpper = isUpperCaseLetter(identifier.charCodeAt(index - 1));
        const currentIsUpper = isUpperCaseLetter(identifier.charCodeAt(index));
        return currentIsUpper && (!word || !lastIsUpper);
    }
    function everyInRange(start, end, pred) {
        for(let i = start; i < end; i++){
            if (!pred(i)) return false;
        }
        return true;
    }
    function every2(s, pred, start = 0, end = s.length) {
        return everyInRange(start, end, (i)=>pred(s.charCodeAt(i), i));
    }
    // src/services/preProcess.ts
    function preProcessFile(sourceText, readImportFiles = true, detectJavaScriptImports = false) {
        const pragmaContext = {
            languageVersion: 1 /* ES5 */ ,
            // controls whether the token scanner considers unicode identifiers or not - shouldn't matter, since we're only using it for trivia
            pragmas: void 0,
            checkJsDirective: void 0,
            referencedFiles: [],
            typeReferenceDirectives: [],
            libReferenceDirectives: [],
            amdDependencies: [],
            hasNoDefaultLib: void 0,
            moduleName: void 0
        };
        const importedFiles = [];
        let ambientExternalModules;
        let lastToken;
        let currentToken;
        let braceNesting = 0;
        let externalModule = false;
        function nextToken() {
            lastToken = currentToken;
            currentToken = scanner.scan();
            if (currentToken === 19 /* OpenBraceToken */ ) braceNesting++;
            else if (currentToken === 20 /* CloseBraceToken */ ) braceNesting--;
            return currentToken;
        }
        function getFileReference() {
            const fileName = scanner.getTokenValue();
            const pos = scanner.getTokenStart();
            return {
                fileName,
                pos,
                end: pos + fileName.length
            };
        }
        function recordAmbientExternalModule() {
            if (!ambientExternalModules) ambientExternalModules = [];
            ambientExternalModules.push({
                ref: getFileReference(),
                depth: braceNesting
            });
        }
        function recordModuleName() {
            importedFiles.push(getFileReference());
            markAsExternalModuleIfTopLevel();
        }
        function markAsExternalModuleIfTopLevel() {
            if (braceNesting === 0) externalModule = true;
        }
        function tryConsumeDeclare() {
            let token = scanner.getToken();
            if (token === 138 /* DeclareKeyword */ ) {
                token = nextToken();
                if (token === 144 /* ModuleKeyword */ ) {
                    token = nextToken();
                    if (token === 11 /* StringLiteral */ ) recordAmbientExternalModule();
                }
                return true;
            }
            return false;
        }
        function tryConsumeImport() {
            if (lastToken === 25 /* DotToken */ ) return false;
            let token = scanner.getToken();
            if (token === 102 /* ImportKeyword */ ) {
                token = nextToken();
                if (token === 21 /* OpenParenToken */ ) {
                    token = nextToken();
                    if (token === 11 /* StringLiteral */  || token === 15 /* NoSubstitutionTemplateLiteral */ ) {
                        recordModuleName();
                        return true;
                    }
                } else if (token === 11 /* StringLiteral */ ) {
                    recordModuleName();
                    return true;
                } else {
                    if (token === 156 /* TypeKeyword */ ) {
                        const skipTypeKeyword = scanner.lookAhead(()=>{
                            const token2 = scanner.scan();
                            return token2 !== 161 /* FromKeyword */  && (token2 === 42 /* AsteriskToken */  || token2 === 19 /* OpenBraceToken */  || token2 === 80 /* Identifier */  || isKeyword(token2));
                        });
                        if (skipTypeKeyword) token = nextToken();
                    }
                    if (token === 80 /* Identifier */  || isKeyword(token)) {
                        token = nextToken();
                        if (token === 161 /* FromKeyword */ ) {
                            token = nextToken();
                            if (token === 11 /* StringLiteral */ ) {
                                recordModuleName();
                                return true;
                            }
                        } else if (token === 64 /* EqualsToken */ ) {
                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) return true;
                        } else if (token === 28 /* CommaToken */ ) token = nextToken();
                        else return true;
                    }
                    if (token === 19 /* OpenBraceToken */ ) {
                        token = nextToken();
                        while(token !== 20 /* CloseBraceToken */  && token !== 1 /* EndOfFileToken */ )token = nextToken();
                        if (token === 20 /* CloseBraceToken */ ) {
                            token = nextToken();
                            if (token === 161 /* FromKeyword */ ) {
                                token = nextToken();
                                if (token === 11 /* StringLiteral */ ) recordModuleName();
                            }
                        }
                    } else if (token === 42 /* AsteriskToken */ ) {
                        token = nextToken();
                        if (token === 130 /* AsKeyword */ ) {
                            token = nextToken();
                            if (token === 80 /* Identifier */  || isKeyword(token)) {
                                token = nextToken();
                                if (token === 161 /* FromKeyword */ ) {
                                    token = nextToken();
                                    if (token === 11 /* StringLiteral */ ) recordModuleName();
                                }
                            }
                        }
                    }
                }
                return true;
            }
            return false;
        }
        function tryConsumeExport() {
            let token = scanner.getToken();
            if (token === 95 /* ExportKeyword */ ) {
                markAsExternalModuleIfTopLevel();
                token = nextToken();
                if (token === 156 /* TypeKeyword */ ) {
                    const skipTypeKeyword = scanner.lookAhead(()=>{
                        const token2 = scanner.scan();
                        return token2 === 42 /* AsteriskToken */  || token2 === 19 /* OpenBraceToken */ ;
                    });
                    if (skipTypeKeyword) token = nextToken();
                }
                if (token === 19 /* OpenBraceToken */ ) {
                    token = nextToken();
                    while(token !== 20 /* CloseBraceToken */  && token !== 1 /* EndOfFileToken */ )token = nextToken();
                    if (token === 20 /* CloseBraceToken */ ) {
                        token = nextToken();
                        if (token === 161 /* FromKeyword */ ) {
                            token = nextToken();
                            if (token === 11 /* StringLiteral */ ) recordModuleName();
                        }
                    }
                } else if (token === 42 /* AsteriskToken */ ) {
                    token = nextToken();
                    if (token === 161 /* FromKeyword */ ) {
                        token = nextToken();
                        if (token === 11 /* StringLiteral */ ) recordModuleName();
                    }
                } else if (token === 102 /* ImportKeyword */ ) {
                    token = nextToken();
                    if (token === 156 /* TypeKeyword */ ) {
                        const skipTypeKeyword = scanner.lookAhead(()=>{
                            const token2 = scanner.scan();
                            return token2 === 80 /* Identifier */  || isKeyword(token2);
                        });
                        if (skipTypeKeyword) token = nextToken();
                    }
                    if (token === 80 /* Identifier */  || isKeyword(token)) {
                        token = nextToken();
                        if (token === 64 /* EqualsToken */ ) {
                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) return true;
                        }
                    }
                }
                return true;
            }
            return false;
        }
        function tryConsumeRequireCall(skipCurrentToken, allowTemplateLiterals = false) {
            let token = skipCurrentToken ? nextToken() : scanner.getToken();
            if (token === 149 /* RequireKeyword */ ) {
                token = nextToken();
                if (token === 21 /* OpenParenToken */ ) {
                    token = nextToken();
                    if (token === 11 /* StringLiteral */  || allowTemplateLiterals && token === 15 /* NoSubstitutionTemplateLiteral */ ) recordModuleName();
                }
                return true;
            }
            return false;
        }
        function tryConsumeDefine() {
            let token = scanner.getToken();
            if (token === 80 /* Identifier */  && scanner.getTokenValue() === "define") {
                token = nextToken();
                if (token !== 21 /* OpenParenToken */ ) return true;
                token = nextToken();
                if (token === 11 /* StringLiteral */  || token === 15 /* NoSubstitutionTemplateLiteral */ ) {
                    token = nextToken();
                    if (token === 28 /* CommaToken */ ) token = nextToken();
                    else return true;
                }
                if (token !== 23 /* OpenBracketToken */ ) return true;
                token = nextToken();
                while(token !== 24 /* CloseBracketToken */  && token !== 1 /* EndOfFileToken */ ){
                    if (token === 11 /* StringLiteral */  || token === 15 /* NoSubstitutionTemplateLiteral */ ) recordModuleName();
                    token = nextToken();
                }
                return true;
            }
            return false;
        }
        function processImports() {
            scanner.setText(sourceText);
            nextToken();
            while(true){
                if (scanner.getToken() === 1 /* EndOfFileToken */ ) break;
                if (scanner.getToken() === 16 /* TemplateHead */ ) {
                    const stack = [
                        scanner.getToken()
                    ];
                    loop: while(length(stack)){
                        const token = scanner.scan();
                        switch(token){
                            case 1 /* EndOfFileToken */ :
                                break loop;
                            case 102 /* ImportKeyword */ :
                                tryConsumeImport();
                                break;
                            case 16 /* TemplateHead */ :
                                stack.push(token);
                                break;
                            case 19 /* OpenBraceToken */ :
                                if (length(stack)) stack.push(token);
                                break;
                            case 20 /* CloseBraceToken */ :
                                if (length(stack)) {
                                    if (lastOrUndefined(stack) === 16 /* TemplateHead */ ) {
                                        if (scanner.reScanTemplateToken(/*isTaggedTemplate*/ false) === 18 /* TemplateTail */ ) stack.pop();
                                    } else stack.pop();
                                }
                                break;
                        }
                    }
                    nextToken();
                }
                if (tryConsumeDeclare() || tryConsumeImport() || tryConsumeExport() || detectJavaScriptImports && (tryConsumeRequireCall(/*skipCurrentToken*/ false, /*allowTemplateLiterals*/ true) || tryConsumeDefine())) continue;
                else nextToken();
            }
            scanner.setText(void 0);
        }
        if (readImportFiles) processImports();
        processCommentPragmas(pragmaContext, sourceText);
        processPragmasIntoFields(pragmaContext, noop);
        if (externalModule) {
            if (ambientExternalModules) for (const decl of ambientExternalModules)importedFiles.push(decl.ref);
            return {
                referencedFiles: pragmaContext.referencedFiles,
                typeReferenceDirectives: pragmaContext.typeReferenceDirectives,
                libReferenceDirectives: pragmaContext.libReferenceDirectives,
                importedFiles,
                isLibFile: !!pragmaContext.hasNoDefaultLib,
                ambientExternalModules: void 0
            };
        } else {
            let ambientModuleNames;
            if (ambientExternalModules) {
                for (const decl of ambientExternalModules)if (decl.depth === 0) {
                    if (!ambientModuleNames) ambientModuleNames = [];
                    ambientModuleNames.push(decl.ref.fileName);
                } else importedFiles.push(decl.ref);
            }
            return {
                referencedFiles: pragmaContext.referencedFiles,
                typeReferenceDirectives: pragmaContext.typeReferenceDirectives,
                libReferenceDirectives: pragmaContext.libReferenceDirectives,
                importedFiles,
                isLibFile: !!pragmaContext.hasNoDefaultLib,
                ambientExternalModules: ambientModuleNames
            };
        }
    }
    // src/services/sourcemaps.ts
    var base64UrlRegExp = /^data:(?:application\/json;charset=[uU][tT][fF]-8;base64,([A-Za-z0-9+/=]+)$)?/;
    function getSourceMapper(host) {
        const getCanonicalFileName = createGetCanonicalFileName(host.useCaseSensitiveFileNames());
        const currentDirectory = host.getCurrentDirectory();
        const sourceFileLike = /* @__PURE__ */ new Map();
        const documentPositionMappers = /* @__PURE__ */ new Map();
        return {
            tryGetSourcePosition,
            tryGetGeneratedPosition,
            toLineColumnOffset,
            clearCache,
            documentPositionMappers
        };
        function toPath3(fileName) {
            return toPath(fileName, currentDirectory, getCanonicalFileName);
        }
        function getDocumentPositionMapper2(generatedFileName, sourceFileName) {
            const path = toPath3(generatedFileName);
            const value1 = documentPositionMappers.get(path);
            if (value1) return value1;
            let mapper;
            if (host.getDocumentPositionMapper) mapper = host.getDocumentPositionMapper(generatedFileName, sourceFileName);
            else if (host.readFile) {
                const file = getSourceFileLike(generatedFileName);
                mapper = file && getDocumentPositionMapper({
                    getSourceFileLike,
                    getCanonicalFileName,
                    log: (s)=>host.log(s)
                }, generatedFileName, getLineInfo(file.text, getLineStarts(file)), (f)=>!host.fileExists || host.fileExists(f) ? host.readFile(f) : void 0);
            }
            documentPositionMappers.set(path, mapper || identitySourceMapConsumer);
            return mapper || identitySourceMapConsumer;
        }
        function tryGetSourcePosition(info) {
            if (!isDeclarationFileName(info.fileName)) return void 0;
            const file = getSourceFile(info.fileName);
            if (!file) return void 0;
            const newLoc = getDocumentPositionMapper2(info.fileName).getSourcePosition(info);
            return !newLoc || newLoc === info ? void 0 : tryGetSourcePosition(newLoc) || newLoc;
        }
        function tryGetGeneratedPosition(info) {
            if (isDeclarationFileName(info.fileName)) return void 0;
            const sourceFile = getSourceFile(info.fileName);
            if (!sourceFile) return void 0;
            const program = host.getProgram();
            if (program.isSourceOfProjectReferenceRedirect(sourceFile.fileName)) return void 0;
            const options = program.getCompilerOptions();
            const outPath = options.outFile;
            const declarationPath = outPath ? removeFileExtension(outPath) + ".d.ts" /* Dts */  : getDeclarationEmitOutputFilePathWorker(info.fileName, program.getCompilerOptions(), program);
            if (declarationPath === void 0) return void 0;
            const newLoc = getDocumentPositionMapper2(declarationPath, info.fileName).getGeneratedPosition(info);
            return newLoc === info ? void 0 : newLoc;
        }
        function getSourceFile(fileName) {
            const program = host.getProgram();
            if (!program) return void 0;
            const path = toPath3(fileName);
            const file = program.getSourceFileByPath(path);
            return file && file.resolvedPath === path ? file : void 0;
        }
        function getOrCreateSourceFileLike(fileName) {
            const path = toPath3(fileName);
            const fileFromCache = sourceFileLike.get(path);
            if (fileFromCache !== void 0) return fileFromCache ? fileFromCache : void 0;
            if (!host.readFile || host.fileExists && !host.fileExists(fileName)) {
                sourceFileLike.set(path, false);
                return void 0;
            }
            const text = host.readFile(fileName);
            const file = text ? createSourceFileLike(text) : false;
            sourceFileLike.set(path, file);
            return file ? file : void 0;
        }
        function getSourceFileLike(fileName) {
            return !host.getSourceFileLike ? getSourceFile(fileName) || getOrCreateSourceFileLike(fileName) : host.getSourceFileLike(fileName);
        }
        function toLineColumnOffset(fileName, position) {
            const file = getSourceFileLike(fileName);
            return file.getLineAndCharacterOfPosition(position);
        }
        function clearCache() {
            sourceFileLike.clear();
            documentPositionMappers.clear();
        }
    }
    function getDocumentPositionMapper(host, generatedFileName, generatedFileLineInfo, readMapFile) {
        let mapFileName = tryGetSourceMappingURL(generatedFileLineInfo);
        if (mapFileName) {
            const match = base64UrlRegExp.exec(mapFileName);
            if (match) {
                if (match[1]) {
                    const base64Object = match[1];
                    return convertDocumentToSourceMapper(host, base64decode(sys, base64Object), generatedFileName);
                }
                mapFileName = void 0;
            }
        }
        const possibleMapLocations = [];
        if (mapFileName) possibleMapLocations.push(mapFileName);
        possibleMapLocations.push(generatedFileName + ".map");
        const originalMapFileName = mapFileName && getNormalizedAbsolutePath(mapFileName, getDirectoryPath(generatedFileName));
        for (const location of possibleMapLocations){
            const mapFileName2 = getNormalizedAbsolutePath(location, getDirectoryPath(generatedFileName));
            const mapFileContents = readMapFile(mapFileName2, originalMapFileName);
            if (isString(mapFileContents)) return convertDocumentToSourceMapper(host, mapFileContents, mapFileName2);
            if (mapFileContents !== void 0) return mapFileContents || void 0;
        }
        return void 0;
    }
    function convertDocumentToSourceMapper(host, contents, mapFileName) {
        const map2 = tryParseRawSourceMap(contents);
        if (!map2 || !map2.sources || !map2.file || !map2.mappings) return void 0;
        if (map2.sourcesContent && map2.sourcesContent.some(isString)) return void 0;
        return createDocumentPositionMapper(host, map2, mapFileName);
    }
    function createSourceFileLike(text, lineMap) {
        return {
            text,
            lineMap,
            getLineAndCharacterOfPosition (pos) {
                return computeLineAndCharacterOfPosition(getLineStarts(this), pos);
            }
        };
    }
    // src/services/suggestionDiagnostics.ts
    var visitedNestedConvertibleFunctions = /* @__PURE__ */ new Map();
    function computeSuggestionDiagnostics(sourceFile, program, cancellationToken) {
        var _a;
        program.getSemanticDiagnostics(sourceFile, cancellationToken);
        const diags = [];
        const checker = program.getTypeChecker();
        const isCommonJSFile = program.getImpliedNodeFormatForEmit(sourceFile) === 1 /* CommonJS */  || fileExtensionIsOneOf(sourceFile.fileName, [
            ".cts" /* Cts */ ,
            ".cjs" /* Cjs */ 
        ]);
        if (!isCommonJSFile && sourceFile.commonJsModuleIndicator && (programContainsEsModules(program) || compilerOptionsIndicateEsModules(program.getCompilerOptions())) && containsTopLevelCommonjs(sourceFile)) diags.push(createDiagnosticForNode(getErrorNodeFromCommonJsIndicator(sourceFile.commonJsModuleIndicator), Diagnostics.File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module));
        const isJsFile = isSourceFileJS(sourceFile);
        visitedNestedConvertibleFunctions.clear();
        check(sourceFile);
        if (getAllowSyntheticDefaultImports(program.getCompilerOptions())) for (const moduleSpecifier of sourceFile.imports){
            const importNode = importFromModuleSpecifier(moduleSpecifier);
            if (isImportEqualsDeclaration(importNode) && hasSyntacticModifier(importNode, 32 /* Export */ )) continue;
            const name = importNameForConvertToDefaultImport(importNode);
            if (!name) continue;
            const module2 = (_a = program.getResolvedModuleFromModuleSpecifier(moduleSpecifier, sourceFile)) == null ? void 0 : _a.resolvedModule;
            const resolvedFile = module2 && program.getSourceFile(module2.resolvedFileName);
            if (resolvedFile && resolvedFile.externalModuleIndicator && resolvedFile.externalModuleIndicator !== true && isExportAssignment(resolvedFile.externalModuleIndicator) && resolvedFile.externalModuleIndicator.isExportEquals) diags.push(createDiagnosticForNode(name, Diagnostics.Import_may_be_converted_to_a_default_import));
        }
        addRange(diags, sourceFile.bindSuggestionDiagnostics);
        addRange(diags, program.getSuggestionDiagnostics(sourceFile, cancellationToken));
        diags.sort((d1, d2)=>d1.start - d2.start);
        return diags;
        function check(node) {
            if (isJsFile) {
                if (canBeConvertedToClass(node, checker)) diags.push(createDiagnosticForNode(isVariableDeclaration(node.parent) ? node.parent.name : node, Diagnostics.This_constructor_function_may_be_converted_to_a_class_declaration));
            } else {
                if (isVariableStatement(node) && node.parent === sourceFile && node.declarationList.flags & 2 /* Const */  && node.declarationList.declarations.length === 1) {
                    const init = node.declarationList.declarations[0].initializer;
                    if (init && isRequireCall(init, /*requireStringLiteralLikeArgument*/ true)) diags.push(createDiagnosticForNode(init, Diagnostics.require_call_may_be_converted_to_an_import));
                }
                const jsdocTypedefNodes = ts_codefix_exports.getJSDocTypedefNodes(node);
                for (const jsdocTypedefNode of jsdocTypedefNodes)diags.push(createDiagnosticForNode(jsdocTypedefNode, Diagnostics.JSDoc_typedef_may_be_converted_to_TypeScript_type));
                if (ts_codefix_exports.parameterShouldGetTypeFromJSDoc(node)) diags.push(createDiagnosticForNode(node.name || node, Diagnostics.JSDoc_types_may_be_moved_to_TypeScript_types));
            }
            if (canBeConvertedToAsync(node)) addConvertToAsyncFunctionDiagnostics(node, checker, diags);
            node.forEachChild(check);
        }
    }
    function containsTopLevelCommonjs(sourceFile) {
        return sourceFile.statements.some((statement)=>{
            switch(statement.kind){
                case 244 /* VariableStatement */ :
                    return statement.declarationList.declarations.some((decl)=>!!decl.initializer && isRequireCall(propertyAccessLeftHandSide(decl.initializer), /*requireStringLiteralLikeArgument*/ true));
                case 245 /* ExpressionStatement */ :
                    {
                        const { expression } = statement;
                        if (!isBinaryExpression(expression)) return isRequireCall(expression, /*requireStringLiteralLikeArgument*/ true);
                        const kind = getAssignmentDeclarationKind(expression);
                        return kind === 1 /* ExportsProperty */  || kind === 2 /* ModuleExports */ ;
                    }
                default:
                    return false;
            }
        });
    }
    function propertyAccessLeftHandSide(node) {
        return isPropertyAccessExpression(node) ? propertyAccessLeftHandSide(node.expression) : node;
    }
    function importNameForConvertToDefaultImport(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
                const { importClause, moduleSpecifier } = node;
                return importClause && !importClause.name && importClause.namedBindings && importClause.namedBindings.kind === 275 /* NamespaceImport */  && isStringLiteral(moduleSpecifier) ? importClause.namedBindings.name : void 0;
            case 272 /* ImportEqualsDeclaration */ :
                return node.name;
            default:
                return void 0;
        }
    }
    function addConvertToAsyncFunctionDiagnostics(node, checker, diags) {
        if (isConvertibleFunction(node, checker) && !visitedNestedConvertibleFunctions.has(getKeyFromNode(node))) diags.push(createDiagnosticForNode(!node.name && isVariableDeclaration(node.parent) && isIdentifier(node.parent.name) ? node.parent.name : node, Diagnostics.This_may_be_converted_to_an_async_function));
    }
    function isConvertibleFunction(node, checker) {
        return !isAsyncFunction(node) && node.body && isBlock(node.body) && hasReturnStatementWithPromiseHandler(node.body, checker) && returnsPromise(node, checker);
    }
    function returnsPromise(node, checker) {
        const signature = checker.getSignatureFromDeclaration(node);
        const returnType = signature ? checker.getReturnTypeOfSignature(signature) : void 0;
        return !!returnType && !!checker.getPromisedTypeOfPromise(returnType);
    }
    function getErrorNodeFromCommonJsIndicator(commonJsModuleIndicator) {
        return isBinaryExpression(commonJsModuleIndicator) ? commonJsModuleIndicator.left : commonJsModuleIndicator;
    }
    function hasReturnStatementWithPromiseHandler(body, checker) {
        return !!forEachReturnStatement(body, (statement)=>isReturnStatementWithFixablePromiseHandler(statement, checker));
    }
    function isReturnStatementWithFixablePromiseHandler(node, checker) {
        return isReturnStatement(node) && !!node.expression && isFixablePromiseHandler(node.expression, checker);
    }
    function isFixablePromiseHandler(node, checker) {
        if (!isPromiseHandler(node) || !hasSupportedNumberOfArguments(node) || !node.arguments.every((arg)=>isFixablePromiseArgument(arg, checker))) return false;
        let currentNode = node.expression.expression;
        while(isPromiseHandler(currentNode) || isPropertyAccessExpression(currentNode))if (isCallExpression(currentNode)) {
            if (!hasSupportedNumberOfArguments(currentNode) || !currentNode.arguments.every((arg)=>isFixablePromiseArgument(arg, checker))) return false;
            currentNode = currentNode.expression.expression;
        } else currentNode = currentNode.expression;
        return true;
    }
    function isPromiseHandler(node) {
        return isCallExpression(node) && (hasPropertyAccessExpressionWithName(node, "then") || hasPropertyAccessExpressionWithName(node, "catch") || hasPropertyAccessExpressionWithName(node, "finally"));
    }
    function hasSupportedNumberOfArguments(node) {
        const name = node.expression.name.text;
        const maxArguments = name === "then" ? 2 : name === "catch" ? 1 : name === "finally" ? 1 : 0;
        if (node.arguments.length > maxArguments) return false;
        if (node.arguments.length < maxArguments) return true;
        return maxArguments === 1 || some(node.arguments, (arg)=>{
            return arg.kind === 106 /* NullKeyword */  || isIdentifier(arg) && arg.text === "undefined";
        });
    }
    function isFixablePromiseArgument(arg, checker) {
        switch(arg.kind){
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
                const functionFlags = getFunctionFlags(arg);
                if (functionFlags & 1 /* Generator */ ) return false;
            // falls through
            case 220 /* ArrowFunction */ :
                visitedNestedConvertibleFunctions.set(getKeyFromNode(arg), true);
            // falls through
            case 106 /* NullKeyword */ :
                return true;
            case 80 /* Identifier */ :
            case 212 /* PropertyAccessExpression */ :
                {
                    const symbol = checker.getSymbolAtLocation(arg);
                    if (!symbol) return false;
                    return checker.isUndefinedSymbol(symbol) || some(skipAlias(symbol, checker).declarations, (d)=>isFunctionLike(d) || hasInitializer(d) && !!d.initializer && isFunctionLike(d.initializer));
                }
            default:
                return false;
        }
    }
    function getKeyFromNode(exp) {
        return `${exp.pos.toString()}:${exp.end.toString()}`;
    }
    function canBeConvertedToClass(node, checker) {
        var _a, _b, _c, _d;
        if (isFunctionExpression(node)) {
            if (isVariableDeclaration(node.parent) && ((_a = node.symbol.members) == null ? void 0 : _a.size)) return true;
            const symbol = checker.getSymbolOfExpando(node, /*allowDeclaration*/ false);
            return !!(symbol && (((_b = symbol.exports) == null ? void 0 : _b.size) || ((_c = symbol.members) == null ? void 0 : _c.size)));
        }
        if (isFunctionDeclaration(node)) return !!((_d = node.symbol.members) == null ? void 0 : _d.size);
        return false;
    }
    function canBeConvertedToAsync(node) {
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return true;
            default:
                return false;
        }
    }
    // src/services/transpile.ts
    var optionsRedundantWithVerbatimModuleSyntax = /* @__PURE__ */ new Set([
        "isolatedModules"
    ]);
    function transpileModule(input, transpileOptions) {
        return transpileWorker(input, transpileOptions, /*declaration*/ false);
    }
    function transpileDeclaration(input, transpileOptions) {
        return transpileWorker(input, transpileOptions, /*declaration*/ true);
    }
    var barebonesLibContent = `/// <reference no-default-lib="true"/>
interface Boolean {}
interface Function {}
interface CallableFunction {}
interface NewableFunction {}
interface IArguments {}
interface Number {}
interface Object {}
interface RegExp {}
interface String {}
interface Array<T> { length: number; [n: number]: T; }
interface SymbolConstructor {
    (desc?: string | number): symbol;
    for(name: string): symbol;
    readonly toStringTag: symbol;
}
declare var Symbol: SymbolConstructor;
interface Symbol {
    readonly [Symbol.toStringTag]: string;
}`;
    var barebonesLibName = "lib.d.ts";
    var barebonesLibSourceFile;
    function transpileWorker(input, transpileOptions, declaration) {
        barebonesLibSourceFile !== null && barebonesLibSourceFile !== void 0 ? barebonesLibSourceFile : barebonesLibSourceFile = createSourceFile(barebonesLibName, barebonesLibContent, {
            languageVersion: 99 /* Latest */ 
        });
        const diagnostics = [];
        const options = transpileOptions.compilerOptions ? fixupCompilerOptions(transpileOptions.compilerOptions, diagnostics) : {};
        const defaultOptions = getDefaultCompilerOptions2();
        for(const key in defaultOptions)if (hasProperty(defaultOptions, key) && options[key] === void 0) options[key] = defaultOptions[key];
        for (const option of transpileOptionValueCompilerOptions){
            if (options.verbatimModuleSyntax && optionsRedundantWithVerbatimModuleSyntax.has(option.name)) continue;
            options[option.name] = option.transpileOptionValue;
        }
        options.suppressOutputPathCheck = true;
        options.allowNonTsExtensions = true;
        if (declaration) {
            options.declaration = true;
            options.emitDeclarationOnly = true;
            options.isolatedDeclarations = true;
        } else {
            options.declaration = false;
            options.declarationMap = false;
        }
        const newLine = getNewLineCharacter(options);
        const compilerHost = {
            getSourceFile: (fileName)=>fileName === normalizePath(inputFileName) ? sourceFile : fileName === normalizePath(barebonesLibName) ? barebonesLibSourceFile : void 0,
            writeFile: (name, text)=>{
                if (fileExtensionIs(name, ".map")) {
                    Debug.assertEqual(sourceMapText, void 0, "Unexpected multiple source map outputs, file:", name);
                    sourceMapText = text;
                } else {
                    Debug.assertEqual(outputText, void 0, "Unexpected multiple outputs, file:", name);
                    outputText = text;
                }
            },
            getDefaultLibFileName: ()=>barebonesLibName,
            useCaseSensitiveFileNames: ()=>false,
            getCanonicalFileName: (fileName)=>fileName,
            getCurrentDirectory: ()=>"",
            getNewLine: ()=>newLine,
            fileExists: (fileName)=>fileName === inputFileName || !!declaration && fileName === barebonesLibName,
            readFile: ()=>"",
            directoryExists: ()=>true,
            getDirectories: ()=>[]
        };
        const inputFileName = transpileOptions.fileName || (transpileOptions.compilerOptions && transpileOptions.compilerOptions.jsx ? "module.tsx" : "module.ts");
        var _transpileOptions_jsDocParsingMode;
        const sourceFile = createSourceFile(inputFileName, input, {
            languageVersion: getEmitScriptTarget(options),
            impliedNodeFormat: getImpliedNodeFormatForFile(toPath(inputFileName, "", compilerHost.getCanonicalFileName), /*packageJsonInfoCache*/ void 0, compilerHost, options),
            setExternalModuleIndicator: getSetExternalModuleIndicator(options),
            jsDocParsingMode: (_transpileOptions_jsDocParsingMode = transpileOptions.jsDocParsingMode) !== null && _transpileOptions_jsDocParsingMode !== void 0 ? _transpileOptions_jsDocParsingMode : 0 /* ParseAll */ 
        });
        if (transpileOptions.moduleName) sourceFile.moduleName = transpileOptions.moduleName;
        if (transpileOptions.renamedDependencies) sourceFile.renamedDependencies = new Map(Object.entries(transpileOptions.renamedDependencies));
        let outputText;
        let sourceMapText;
        const inputs = declaration ? [
            inputFileName,
            barebonesLibName
        ] : [
            inputFileName
        ];
        const program = createProgram(inputs, options, compilerHost);
        if (transpileOptions.reportDiagnostics) {
            addRange(/*to*/ diagnostics, /*from*/ program.getSyntacticDiagnostics(sourceFile));
            addRange(/*to*/ diagnostics, /*from*/ program.getOptionsDiagnostics());
        }
        const result = program.emit(/*targetSourceFile*/ void 0, /*writeFile*/ void 0, /*cancellationToken*/ void 0, /*emitOnlyDtsFiles*/ declaration, transpileOptions.transformers, /*forceDtsEmit*/ declaration);
        addRange(/*to*/ diagnostics, /*from*/ result.diagnostics);
        if (outputText === void 0) return Debug.fail("Output generation failed");
        return {
            outputText,
            diagnostics,
            sourceMapText
        };
    }
    function transpile(input, compilerOptions, fileName, diagnostics, moduleName) {
        const output = transpileModule(input, {
            compilerOptions,
            fileName,
            reportDiagnostics: !!diagnostics,
            moduleName
        });
        addRange(diagnostics, output.diagnostics);
        return output.outputText;
    }
    var commandLineOptionsStringToEnum;
    function fixupCompilerOptions(options, diagnostics) {
        commandLineOptionsStringToEnum = commandLineOptionsStringToEnum || filter(optionDeclarations, (o)=>typeof o.type === "object" && !forEachEntry(o.type, (v1)=>typeof v1 !== "number"));
        options = cloneCompilerOptions(options);
        for (const opt of commandLineOptionsStringToEnum){
            if (!hasProperty(options, opt.name)) continue;
            const value1 = options[opt.name];
            if (isString(value1)) options[opt.name] = parseCustomTypeOption(opt, value1, diagnostics);
            else if (!forEachEntry(opt.type, (v1)=>v1 === value1)) diagnostics.push(createCompilerDiagnosticForInvalidCustomType(opt));
        }
        return options;
    }
    // src/services/_namespaces/ts.NavigateTo.ts
    var ts_NavigateTo_exports = {};
    __export(ts_NavigateTo_exports, {
        getNavigateToItems: ()=>getNavigateToItems
    });
    // src/services/navigateTo.ts
    function getNavigateToItems(sourceFiles, checker, cancellationToken, searchValue, maxResultCount, excludeDtsFiles, excludeLibFiles) {
        const patternMatcher = createPatternMatcher(searchValue);
        if (!patternMatcher) return emptyArray;
        const rawItems = [];
        const singleCurrentFile = sourceFiles.length === 1 ? sourceFiles[0] : void 0;
        for (const sourceFile of sourceFiles){
            cancellationToken.throwIfCancellationRequested();
            if (excludeDtsFiles && sourceFile.isDeclarationFile) continue;
            if (shouldExcludeFile(sourceFile, !!excludeLibFiles, singleCurrentFile)) continue;
            sourceFile.getNamedDeclarations().forEach((declarations, name)=>{
                getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, sourceFile.fileName, !!excludeLibFiles, singleCurrentFile, rawItems);
            });
        }
        rawItems.sort(compareNavigateToItems);
        return (maxResultCount === void 0 ? rawItems : rawItems.slice(0, maxResultCount)).map(createNavigateToItem);
    }
    function shouldExcludeFile(file, excludeLibFiles, singleCurrentFile) {
        return file !== singleCurrentFile && excludeLibFiles && (isInsideNodeModules(file.path) || file.hasNoDefaultLib);
    }
    function getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, fileName, excludeLibFiles, singleCurrentFile, rawItems) {
        const match = patternMatcher.getMatchForLastSegmentOfPattern(name);
        if (!match) return;
        for (const declaration of declarations){
            if (!shouldKeepItem(declaration, checker, excludeLibFiles, singleCurrentFile)) continue;
            if (patternMatcher.patternContainsDots) {
                const fullMatch = patternMatcher.getFullMatch(getContainers(declaration), name);
                if (fullMatch) rawItems.push({
                    name,
                    fileName,
                    matchKind: fullMatch.kind,
                    isCaseSensitive: fullMatch.isCaseSensitive,
                    declaration
                });
            } else rawItems.push({
                name,
                fileName,
                matchKind: match.kind,
                isCaseSensitive: match.isCaseSensitive,
                declaration
            });
        }
    }
    function shouldKeepItem(declaration, checker, excludeLibFiles, singleCurrentFile) {
        var _a;
        switch(declaration.kind){
            case 274 /* ImportClause */ :
            case 277 /* ImportSpecifier */ :
            case 272 /* ImportEqualsDeclaration */ :
                const importer = checker.getSymbolAtLocation(declaration.name);
                const imported = checker.getAliasedSymbol(importer);
                return importer.escapedName !== imported.escapedName && !((_a = imported.declarations) == null ? void 0 : _a.every((d)=>shouldExcludeFile(d.getSourceFile(), excludeLibFiles, singleCurrentFile)));
            default:
                return true;
        }
    }
    function tryAddSingleDeclarationName(declaration, containers) {
        const name = getNameOfDeclaration(declaration);
        return !!name && (pushLiteral(name, containers) || name.kind === 168 /* ComputedPropertyName */  && tryAddComputedPropertyName(name.expression, containers));
    }
    function tryAddComputedPropertyName(expression, containers) {
        return pushLiteral(expression, containers) || isPropertyAccessExpression(expression) && (containers.push(expression.name.text), true) && tryAddComputedPropertyName(expression.expression, containers);
    }
    function pushLiteral(node, containers) {
        return isPropertyNameLiteral(node) && (containers.push(getTextOfIdentifierOrLiteral(node)), true);
    }
    function getContainers(declaration) {
        const containers = [];
        const name = getNameOfDeclaration(declaration);
        if (name && name.kind === 168 /* ComputedPropertyName */  && !tryAddComputedPropertyName(name.expression, containers)) return emptyArray;
        containers.shift();
        let container = getContainerNode(declaration);
        while(container){
            if (!tryAddSingleDeclarationName(container, containers)) return emptyArray;
            container = getContainerNode(container);
        }
        containers.reverse();
        return containers;
    }
    function compareNavigateToItems(i1, i2) {
        return compareValues(i1.matchKind, i2.matchKind) || compareStringsCaseSensitiveUI(i1.name, i2.name);
    }
    function createNavigateToItem(rawItem) {
        const declaration = rawItem.declaration;
        const container = getContainerNode(declaration);
        const containerName = container && getNameOfDeclaration(container);
        return {
            name: rawItem.name,
            kind: getNodeKind(declaration),
            kindModifiers: getNodeModifiers(declaration),
            matchKind: PatternMatchKind[rawItem.matchKind],
            isCaseSensitive: rawItem.isCaseSensitive,
            fileName: rawItem.fileName,
            textSpan: createTextSpanFromNode(declaration),
            // TODO(jfreeman): What should be the containerName when the container has a computed name?
            containerName: containerName ? containerName.text : "",
            containerKind: containerName ? getNodeKind(container) : "" /* unknown */ 
        };
    }
    // src/services/_namespaces/ts.NavigationBar.ts
    var ts_NavigationBar_exports = {};
    __export(ts_NavigationBar_exports, {
        getNavigationBarItems: ()=>getNavigationBarItems,
        getNavigationTree: ()=>getNavigationTree
    });
    // src/services/navigationBar.ts
    var whiteSpaceRegex = /\s+/g;
    var maxLength = 150;
    var curCancellationToken;
    var curSourceFile;
    var parentsStack = [];
    var parent;
    var trackedEs5ClassesStack = [];
    var trackedEs5Classes;
    var emptyChildItemArray = [];
    function getNavigationBarItems(sourceFile, cancellationToken) {
        curCancellationToken = cancellationToken;
        curSourceFile = sourceFile;
        try {
            return map(primaryNavBarMenuItems(rootNavigationBarNode(sourceFile)), convertToPrimaryNavBarMenuItem);
        } finally{
            reset();
        }
    }
    function getNavigationTree(sourceFile, cancellationToken) {
        curCancellationToken = cancellationToken;
        curSourceFile = sourceFile;
        try {
            return convertToTree(rootNavigationBarNode(sourceFile));
        } finally{
            reset();
        }
    }
    function reset() {
        curSourceFile = void 0;
        curCancellationToken = void 0;
        parentsStack = [];
        parent = void 0;
        emptyChildItemArray = [];
    }
    function nodeText(node) {
        return cleanText(node.getText(curSourceFile));
    }
    function navigationBarNodeKind(n) {
        return n.node.kind;
    }
    function pushChild(parent2, child) {
        if (parent2.children) parent2.children.push(child);
        else parent2.children = [
            child
        ];
    }
    function rootNavigationBarNode(sourceFile) {
        Debug.assert(!parentsStack.length);
        const root = {
            node: sourceFile,
            name: void 0,
            additionalNodes: void 0,
            parent: void 0,
            children: void 0,
            indent: 0
        };
        parent = root;
        for (const statement of sourceFile.statements)addChildrenRecursively(statement);
        endNode();
        Debug.assert(!parent && !parentsStack.length);
        return root;
    }
    function addLeafNode(node, name) {
        pushChild(parent, emptyNavigationBarNode(node, name));
    }
    function emptyNavigationBarNode(node, name) {
        return {
            node,
            name: name || (isDeclaration(node) || isExpression(node) ? getNameOfDeclaration(node) : void 0),
            additionalNodes: void 0,
            parent,
            children: void 0,
            indent: parent.indent + 1
        };
    }
    function addTrackedEs5Class(name) {
        if (!trackedEs5Classes) trackedEs5Classes = /* @__PURE__ */ new Map();
        trackedEs5Classes.set(name, true);
    }
    function endNestedNodes(depth) {
        for(let i = 0; i < depth; i++)endNode();
    }
    function startNestedNodes(targetNode, entityName) {
        const names = [];
        while(!isPropertyNameLiteral(entityName)){
            const name = getNameOrArgument(entityName);
            const nameText = getElementOrPropertyAccessName(entityName);
            entityName = entityName.expression;
            if (nameText === "prototype" || isPrivateIdentifier(name)) continue;
            names.push(name);
        }
        names.push(entityName);
        for(let i = names.length - 1; i > 0; i--){
            const name = names[i];
            startNode(targetNode, name);
        }
        return [
            names.length - 1,
            names[0]
        ];
    }
    function startNode(node, name) {
        const navNode = emptyNavigationBarNode(node, name);
        pushChild(parent, navNode);
        parentsStack.push(parent);
        trackedEs5ClassesStack.push(trackedEs5Classes);
        trackedEs5Classes = void 0;
        parent = navNode;
    }
    function endNode() {
        if (parent.children) {
            mergeChildren(parent.children, parent);
            sortChildren(parent.children);
        }
        parent = parentsStack.pop();
        trackedEs5Classes = trackedEs5ClassesStack.pop();
    }
    function addNodeWithRecursiveChild(node, child, name) {
        startNode(node, name);
        addChildrenRecursively(child);
        endNode();
    }
    function addNodeWithRecursiveInitializer(node) {
        if (node.initializer && isFunctionOrClassExpression(node.initializer)) {
            startNode(node);
            forEachChild(node.initializer, addChildrenRecursively);
            endNode();
        } else addNodeWithRecursiveChild(node, node.initializer);
    }
    function hasNavigationBarName(node) {
        const name = getNameOfDeclaration(node);
        if (name === void 0) return false;
        if (isComputedPropertyName(name)) {
            const expression = name.expression;
            return isEntityNameExpression(expression) || isNumericLiteral(expression) || isStringOrNumericLiteralLike(expression);
        }
        return !!name;
    }
    function addChildrenRecursively(node) {
        curCancellationToken.throwIfCancellationRequested();
        if (!node || isToken(node)) return;
        switch(node.kind){
            case 177 /* Constructor */ :
                const ctr = node;
                addNodeWithRecursiveChild(ctr, ctr.body);
                for (const param of ctr.parameters)if (isParameterPropertyDeclaration(param, ctr)) addLeafNode(param);
                break;
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 174 /* MethodSignature */ :
                if (hasNavigationBarName(node)) addNodeWithRecursiveChild(node, node.body);
                break;
            case 173 /* PropertyDeclaration */ :
                if (hasNavigationBarName(node)) addNodeWithRecursiveInitializer(node);
                break;
            case 172 /* PropertySignature */ :
                if (hasNavigationBarName(node)) addLeafNode(node);
                break;
            case 274 /* ImportClause */ :
                const importClause = node;
                if (importClause.name) addLeafNode(importClause.name);
                const { namedBindings } = importClause;
                if (namedBindings) {
                    if (namedBindings.kind === 275 /* NamespaceImport */ ) addLeafNode(namedBindings);
                    else for (const element of namedBindings.elements)addLeafNode(element);
                }
                break;
            case 305 /* ShorthandPropertyAssignment */ :
                addNodeWithRecursiveChild(node, node.name);
                break;
            case 306 /* SpreadAssignment */ :
                const { expression } = node;
                isIdentifier(expression) ? addLeafNode(node, expression) : addLeafNode(node);
                break;
            case 209 /* BindingElement */ :
            case 304 /* PropertyAssignment */ :
            case 261 /* VariableDeclaration */ :
                {
                    const child = node;
                    if (isBindingPattern(child.name)) addChildrenRecursively(child.name);
                    else addNodeWithRecursiveInitializer(child);
                    break;
                }
            case 263 /* FunctionDeclaration */ :
                const nameNode = node.name;
                if (nameNode && isIdentifier(nameNode)) addTrackedEs5Class(nameNode.text);
                addNodeWithRecursiveChild(node, node.body);
                break;
            case 220 /* ArrowFunction */ :
            case 219 /* FunctionExpression */ :
                addNodeWithRecursiveChild(node, node.body);
                break;
            case 267 /* EnumDeclaration */ :
                startNode(node);
                for (const member of node.members)if (!isComputedProperty(member)) addLeafNode(member);
                endNode();
                break;
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
                startNode(node);
                for (const member of node.members)addChildrenRecursively(member);
                endNode();
                break;
            case 268 /* ModuleDeclaration */ :
                addNodeWithRecursiveChild(node, getInteriorModule(node).body);
                break;
            case 278 /* ExportAssignment */ :
                {
                    const expression2 = node.expression;
                    const child = isObjectLiteralExpression(expression2) || isCallExpression(expression2) ? expression2 : isArrowFunction(expression2) || isFunctionExpression(expression2) ? expression2.body : void 0;
                    if (child) {
                        startNode(node);
                        addChildrenRecursively(child);
                        endNode();
                    } else addLeafNode(node);
                    break;
                }
            case 282 /* ExportSpecifier */ :
            case 272 /* ImportEqualsDeclaration */ :
            case 182 /* IndexSignature */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 266 /* TypeAliasDeclaration */ :
                addLeafNode(node);
                break;
            case 214 /* CallExpression */ :
            case 227 /* BinaryExpression */ :
                {
                    const special = getAssignmentDeclarationKind(node);
                    switch(special){
                        case 1 /* ExportsProperty */ :
                        case 2 /* ModuleExports */ :
                            addNodeWithRecursiveChild(node, node.right);
                            return;
                        case 6 /* Prototype */ :
                        case 3 /* PrototypeProperty */ :
                            {
                                const binaryExpression = node;
                                const assignmentTarget = binaryExpression.left;
                                const prototypeAccess = special === 3 /* PrototypeProperty */  ? assignmentTarget.expression : assignmentTarget;
                                let depth = 0;
                                let className;
                                if (isIdentifier(prototypeAccess.expression)) {
                                    addTrackedEs5Class(prototypeAccess.expression.text);
                                    className = prototypeAccess.expression;
                                } else [depth, className] = startNestedNodes(binaryExpression, prototypeAccess.expression);
                                if (special === 6 /* Prototype */ ) {
                                    if (isObjectLiteralExpression(binaryExpression.right)) {
                                        if (binaryExpression.right.properties.length > 0) {
                                            startNode(binaryExpression, className);
                                            forEachChild(binaryExpression.right, addChildrenRecursively);
                                            endNode();
                                        }
                                    }
                                } else if (isFunctionExpression(binaryExpression.right) || isArrowFunction(binaryExpression.right)) addNodeWithRecursiveChild(node, binaryExpression.right, className);
                                else {
                                    startNode(binaryExpression, className);
                                    addNodeWithRecursiveChild(node, binaryExpression.right, assignmentTarget.name);
                                    endNode();
                                }
                                endNestedNodes(depth);
                                return;
                            }
                        case 7 /* ObjectDefinePropertyValue */ :
                        case 9 /* ObjectDefinePrototypeProperty */ :
                            {
                                const defineCall = node;
                                const className = special === 7 /* ObjectDefinePropertyValue */  ? defineCall.arguments[0] : defineCall.arguments[0].expression;
                                const memberName = defineCall.arguments[1];
                                const [depth, classNameIdentifier] = startNestedNodes(node, className);
                                startNode(node, classNameIdentifier);
                                startNode(node, setTextRange(factory.createIdentifier(memberName.text), memberName));
                                addChildrenRecursively(node.arguments[2]);
                                endNode();
                                endNode();
                                endNestedNodes(depth);
                                return;
                            }
                        case 5 /* Property */ :
                            {
                                const binaryExpression = node;
                                const assignmentTarget = binaryExpression.left;
                                const targetFunction = assignmentTarget.expression;
                                if (isIdentifier(targetFunction) && getElementOrPropertyAccessName(assignmentTarget) !== "prototype" && trackedEs5Classes && trackedEs5Classes.has(targetFunction.text)) {
                                    if (isFunctionExpression(binaryExpression.right) || isArrowFunction(binaryExpression.right)) addNodeWithRecursiveChild(node, binaryExpression.right, targetFunction);
                                    else if (isBindableStaticAccessExpression(assignmentTarget)) {
                                        startNode(binaryExpression, targetFunction);
                                        addNodeWithRecursiveChild(binaryExpression.left, binaryExpression.right, getNameOrArgument(assignmentTarget));
                                        endNode();
                                    }
                                    return;
                                }
                                break;
                            }
                        case 4 /* ThisProperty */ :
                        case 0 /* None */ :
                        case 8 /* ObjectDefinePropertyExports */ :
                            break;
                        default:
                            Debug.assertNever(special);
                    }
                }
            // falls through
            default:
                if (hasJSDocNodes(node)) forEach(node.jsDoc, (jsDoc)=>{
                    forEach(jsDoc.tags, (tag)=>{
                        if (isJSDocTypeAlias(tag)) addLeafNode(tag);
                    });
                });
                forEachChild(node, addChildrenRecursively);
        }
    }
    function mergeChildren(children, node) {
        const nameToItems = /* @__PURE__ */ new Map();
        filterMutate(children, (child, index)=>{
            const declName = child.name || getNameOfDeclaration(child.node);
            const name = declName && nodeText(declName);
            if (!name) return true;
            const itemsWithSameName = nameToItems.get(name);
            if (!itemsWithSameName) {
                nameToItems.set(name, child);
                return true;
            }
            if (itemsWithSameName instanceof Array) {
                for (const itemWithSameName of itemsWithSameName){
                    if (tryMerge(itemWithSameName, child, index, node)) return false;
                }
                itemsWithSameName.push(child);
                return true;
            } else {
                const itemWithSameName = itemsWithSameName;
                if (tryMerge(itemWithSameName, child, index, node)) return false;
                nameToItems.set(name, [
                    itemWithSameName,
                    child
                ]);
                return true;
            }
        });
    }
    var isEs5ClassMember = {
        [5 /* Property */ ]: true,
        [3 /* PrototypeProperty */ ]: true,
        [7 /* ObjectDefinePropertyValue */ ]: true,
        [9 /* ObjectDefinePrototypeProperty */ ]: true,
        [0 /* None */ ]: false,
        [1 /* ExportsProperty */ ]: false,
        [2 /* ModuleExports */ ]: false,
        [8 /* ObjectDefinePropertyExports */ ]: false,
        [6 /* Prototype */ ]: true,
        [4 /* ThisProperty */ ]: false
    };
    function tryMergeEs5Class(a, b, bIndex, parent2) {
        function isPossibleConstructor(node) {
            return isFunctionExpression(node) || isFunctionDeclaration(node) || isVariableDeclaration(node);
        }
        const bAssignmentDeclarationKind = isBinaryExpression(b.node) || isCallExpression(b.node) ? getAssignmentDeclarationKind(b.node) : 0 /* None */ ;
        const aAssignmentDeclarationKind = isBinaryExpression(a.node) || isCallExpression(a.node) ? getAssignmentDeclarationKind(a.node) : 0 /* None */ ;
        if (isEs5ClassMember[bAssignmentDeclarationKind] && isEs5ClassMember[aAssignmentDeclarationKind] || isPossibleConstructor(a.node) && isEs5ClassMember[bAssignmentDeclarationKind] || isPossibleConstructor(b.node) && isEs5ClassMember[aAssignmentDeclarationKind] || isClassDeclaration(a.node) && isSynthesized(a.node) && isEs5ClassMember[bAssignmentDeclarationKind] || isClassDeclaration(b.node) && isEs5ClassMember[aAssignmentDeclarationKind] || isClassDeclaration(a.node) && isSynthesized(a.node) && isPossibleConstructor(b.node) || isClassDeclaration(b.node) && isPossibleConstructor(a.node) && isSynthesized(a.node)) {
            let lastANode = a.additionalNodes && lastOrUndefined(a.additionalNodes) || a.node;
            if (!isClassDeclaration(a.node) && !isClassDeclaration(b.node) || isPossibleConstructor(a.node) || isPossibleConstructor(b.node)) {
                const ctorFunction = isPossibleConstructor(a.node) ? a.node : isPossibleConstructor(b.node) ? b.node : void 0;
                if (ctorFunction !== void 0) {
                    const ctorNode = setTextRange(factory.createConstructorDeclaration(/*modifiers*/ void 0, [], /*body*/ void 0), ctorFunction);
                    const ctor = emptyNavigationBarNode(ctorNode);
                    ctor.indent = a.indent + 1;
                    ctor.children = a.node === ctorFunction ? a.children : b.children;
                    a.children = a.node === ctorFunction ? concatenate([
                        ctor
                    ], b.children || [
                        b
                    ]) : concatenate(a.children || [
                        (0, _objectSpread._)({}, a)
                    ], [
                        ctor
                    ]);
                } else if (a.children || b.children) {
                    a.children = concatenate(a.children || [
                        (0, _objectSpread._)({}, a)
                    ], b.children || [
                        b
                    ]);
                    if (a.children) {
                        mergeChildren(a.children, a);
                        sortChildren(a.children);
                    }
                }
                lastANode = a.node = setTextRange(factory.createClassDeclaration(/*modifiers*/ void 0, a.name || factory.createIdentifier("__class__"), /*typeParameters*/ void 0, /*heritageClauses*/ void 0, []), a.node);
            } else {
                a.children = concatenate(a.children, b.children);
                if (a.children) mergeChildren(a.children, a);
            }
            const bNode = b.node;
            if (parent2.children[bIndex - 1].node.end === lastANode.end) setTextRange(lastANode, {
                pos: lastANode.pos,
                end: bNode.end
            });
            else {
                if (!a.additionalNodes) a.additionalNodes = [];
                a.additionalNodes.push(setTextRange(factory.createClassDeclaration(/*modifiers*/ void 0, a.name || factory.createIdentifier("__class__"), /*typeParameters*/ void 0, /*heritageClauses*/ void 0, []), b.node));
            }
            return true;
        }
        return bAssignmentDeclarationKind === 0 /* None */  ? false : true;
    }
    function tryMerge(a, b, bIndex, parent2) {
        if (tryMergeEs5Class(a, b, bIndex, parent2)) return true;
        if (shouldReallyMerge(a.node, b.node, parent2)) {
            merge(a, b);
            return true;
        }
        return false;
    }
    function shouldReallyMerge(a, b, parent2) {
        if (a.kind !== b.kind || a.parent !== b.parent && !(isOwnChild(a, parent2) && isOwnChild(b, parent2))) return false;
        switch(a.kind){
            case 173 /* PropertyDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return isStatic(a) === isStatic(b);
            case 268 /* ModuleDeclaration */ :
                return areSameModule(a, b) && getFullyQualifiedModuleName(a) === getFullyQualifiedModuleName(b);
            default:
                return true;
        }
    }
    function isSynthesized(node) {
        return !!(node.flags & 16 /* Synthesized */ );
    }
    function isOwnChild(n, parent2) {
        if (n.parent === void 0) return false;
        const par = isModuleBlock(n.parent) ? n.parent.parent : n.parent;
        return par === parent2.node || contains(parent2.additionalNodes, par);
    }
    function areSameModule(a, b) {
        if (!a.body || !b.body) return a.body === b.body;
        return a.body.kind === b.body.kind && (a.body.kind !== 268 /* ModuleDeclaration */  || areSameModule(a.body, b.body));
    }
    function merge(target, source) {
        target.additionalNodes = target.additionalNodes || [];
        target.additionalNodes.push(source.node);
        if (source.additionalNodes) target.additionalNodes.push(...source.additionalNodes);
        target.children = concatenate(target.children, source.children);
        if (target.children) {
            mergeChildren(target.children, target);
            sortChildren(target.children);
        }
    }
    function sortChildren(children) {
        children.sort(compareChildren);
    }
    function compareChildren(child1, child2) {
        return compareStringsCaseSensitiveUI(tryGetName(child1.node), tryGetName(child2.node)) || compareValues(navigationBarNodeKind(child1), navigationBarNodeKind(child2));
    }
    function tryGetName(node) {
        if (node.kind === 268 /* ModuleDeclaration */ ) return getModuleName(node);
        const declName = getNameOfDeclaration(node);
        if (declName && isPropertyName(declName)) {
            const propertyName = getPropertyNameForPropertyNameNode(declName);
            return propertyName && unescapeLeadingUnderscores(propertyName);
        }
        switch(node.kind){
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 232 /* ClassExpression */ :
                return getFunctionOrClassName(node);
            default:
                return void 0;
        }
    }
    function getItemName(node, name) {
        if (node.kind === 268 /* ModuleDeclaration */ ) return cleanText(getModuleName(node));
        if (name) {
            const text = isIdentifier(name) ? name.text : isElementAccessExpression(name) ? `[${nodeText(name.argumentExpression)}]` : nodeText(name);
            if (text.length > 0) return cleanText(text);
        }
        switch(node.kind){
            case 308 /* SourceFile */ :
                const sourceFile = node;
                return isExternalModule(sourceFile) ? `"${escapeString(getBaseFileName(removeFileExtension(normalizePath(sourceFile.fileName))))}"` : "<global>";
            case 278 /* ExportAssignment */ :
                return isExportAssignment(node) && node.isExportEquals ? "export=" /* ExportEquals */  : "default" /* Default */ ;
            case 220 /* ArrowFunction */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
                if (getSyntacticModifierFlags(node) & 2048 /* Default */ ) return "default";
                return getFunctionOrClassName(node);
            case 177 /* Constructor */ :
                return "constructor";
            case 181 /* ConstructSignature */ :
                return "new()";
            case 180 /* CallSignature */ :
                return "()";
            case 182 /* IndexSignature */ :
                return "[]";
            default:
                return "<unknown>";
        }
    }
    function primaryNavBarMenuItems(root) {
        const primaryNavBarMenuItems2 = [];
        function recur(item) {
            if (shouldAppearInPrimaryNavBarMenu(item)) {
                primaryNavBarMenuItems2.push(item);
                if (item.children) for (const child of item.children)recur(child);
            }
        }
        recur(root);
        return primaryNavBarMenuItems2;
        function shouldAppearInPrimaryNavBarMenu(item) {
            if (item.children) return true;
            switch(navigationBarNodeKind(item)){
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                case 267 /* EnumDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                case 308 /* SourceFile */ :
                case 266 /* TypeAliasDeclaration */ :
                case 347 /* JSDocTypedefTag */ :
                case 339 /* JSDocCallbackTag */ :
                    return true;
                case 220 /* ArrowFunction */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                    return isTopLevelFunctionDeclaration(item);
                default:
                    return false;
            }
            function isTopLevelFunctionDeclaration(item2) {
                if (!item2.node.body) return false;
                switch(navigationBarNodeKind(item2.parent)){
                    case 269 /* ModuleBlock */ :
                    case 308 /* SourceFile */ :
                    case 175 /* MethodDeclaration */ :
                    case 177 /* Constructor */ :
                        return true;
                    default:
                        return false;
                }
            }
        }
    }
    function convertToTree(n) {
        return {
            text: getItemName(n.node, n.name),
            kind: getNodeKind(n.node),
            kindModifiers: getModifiers2(n.node),
            spans: getSpans(n),
            nameSpan: n.name && getNodeSpan(n.name),
            childItems: map(n.children, convertToTree)
        };
    }
    function convertToPrimaryNavBarMenuItem(n) {
        return {
            text: getItemName(n.node, n.name),
            kind: getNodeKind(n.node),
            kindModifiers: getModifiers2(n.node),
            spans: getSpans(n),
            childItems: map(n.children, convertToSecondaryNavBarMenuItem) || emptyChildItemArray,
            indent: n.indent,
            bolded: false,
            grayed: false
        };
        function convertToSecondaryNavBarMenuItem(n2) {
            return {
                text: getItemName(n2.node, n2.name),
                kind: getNodeKind(n2.node),
                kindModifiers: getNodeModifiers(n2.node),
                spans: getSpans(n2),
                childItems: emptyChildItemArray,
                indent: 0,
                bolded: false,
                grayed: false
            };
        }
    }
    function getSpans(n) {
        const spans = [
            getNodeSpan(n.node)
        ];
        if (n.additionalNodes) for (const node of n.additionalNodes)spans.push(getNodeSpan(node));
        return spans;
    }
    function getModuleName(moduleDeclaration) {
        if (isAmbientModule(moduleDeclaration)) return getTextOfNode(moduleDeclaration.name);
        return getFullyQualifiedModuleName(moduleDeclaration);
    }
    function getFullyQualifiedModuleName(moduleDeclaration) {
        const result = [
            getTextOfIdentifierOrLiteral(moduleDeclaration.name)
        ];
        while(moduleDeclaration.body && moduleDeclaration.body.kind === 268 /* ModuleDeclaration */ ){
            moduleDeclaration = moduleDeclaration.body;
            result.push(getTextOfIdentifierOrLiteral(moduleDeclaration.name));
        }
        return result.join(".");
    }
    function getInteriorModule(decl) {
        return decl.body && isModuleDeclaration(decl.body) ? getInteriorModule(decl.body) : decl;
    }
    function isComputedProperty(member) {
        return !member.name || member.name.kind === 168 /* ComputedPropertyName */ ;
    }
    function getNodeSpan(node) {
        return node.kind === 308 /* SourceFile */  ? createTextSpanFromRange(node) : createTextSpanFromNode(node, curSourceFile);
    }
    function getModifiers2(node) {
        if (node.parent && node.parent.kind === 261 /* VariableDeclaration */ ) node = node.parent;
        return getNodeModifiers(node);
    }
    function getFunctionOrClassName(node) {
        const { parent: parent2 } = node;
        if (node.name && getFullWidth(node.name) > 0) return cleanText(declarationNameToString(node.name));
        else if (isVariableDeclaration(parent2)) return cleanText(declarationNameToString(parent2.name));
        else if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */ ) return nodeText(parent2.left).replace(whiteSpaceRegex, "");
        else if (isPropertyAssignment(parent2)) return nodeText(parent2.name);
        else if (getSyntacticModifierFlags(node) & 2048 /* Default */ ) return "default";
        else if (isClassLike(node)) return "<class>";
        else if (isCallExpression(parent2)) {
            let name = getCalledExpressionName(parent2.expression);
            if (name !== void 0) {
                name = cleanText(name);
                if (name.length > maxLength) return `${name} callback`;
                const args = cleanText(mapDefined(parent2.arguments, (a)=>isStringLiteralLike(a) || isTemplateLiteral(a) ? a.getText(curSourceFile) : void 0).join(", "));
                return `${name}(${args}) callback`;
            }
        }
        return "<function>";
    }
    function getCalledExpressionName(expr) {
        if (isIdentifier(expr)) return expr.text;
        else if (isPropertyAccessExpression(expr)) {
            const left = getCalledExpressionName(expr.expression);
            const right = expr.name.text;
            return left === void 0 ? right : `${left}.${right}`;
        } else return void 0;
    }
    function isFunctionOrClassExpression(node) {
        switch(node.kind){
            case 220 /* ArrowFunction */ :
            case 219 /* FunctionExpression */ :
            case 232 /* ClassExpression */ :
                return true;
            default:
                return false;
        }
    }
    function cleanText(text) {
        text = text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
        return text.replace(/\\?(?:\r?\n|[\r\u2028\u2029])/g, "");
    }
    // src/services/_namespaces/ts.refactor.ts
    var ts_refactor_exports = {};
    __export(ts_refactor_exports, {
        addExportsInOldFile: ()=>addExportsInOldFile,
        addImportsForMovedSymbols: ()=>addImportsForMovedSymbols,
        addNewFileToTsconfig: ()=>addNewFileToTsconfig,
        addOrRemoveBracesToArrowFunction: ()=>ts_refactor_addOrRemoveBracesToArrowFunction_exports,
        addTargetFileImports: ()=>addTargetFileImports,
        containsJsx: ()=>containsJsx,
        convertArrowFunctionOrFunctionExpression: ()=>ts_refactor_convertArrowFunctionOrFunctionExpression_exports,
        convertParamsToDestructuredObject: ()=>ts_refactor_convertParamsToDestructuredObject_exports,
        convertStringOrTemplateLiteral: ()=>ts_refactor_convertStringOrTemplateLiteral_exports,
        convertToOptionalChainExpression: ()=>ts_refactor_convertToOptionalChainExpression_exports,
        createNewFileName: ()=>createNewFileName,
        doChangeNamedToNamespaceOrDefault: ()=>doChangeNamedToNamespaceOrDefault,
        extractSymbol: ()=>ts_refactor_extractSymbol_exports,
        generateGetAccessorAndSetAccessor: ()=>ts_refactor_generateGetAccessorAndSetAccessor_exports,
        getApplicableRefactors: ()=>getApplicableRefactors,
        getEditsForRefactor: ()=>getEditsForRefactor,
        getExistingLocals: ()=>getExistingLocals,
        getIdentifierForNode: ()=>getIdentifierForNode,
        getNewStatementsAndRemoveFromOldFile: ()=>getNewStatementsAndRemoveFromOldFile,
        getStatementsToMove: ()=>getStatementsToMove,
        getUsageInfo: ()=>getUsageInfo,
        inferFunctionReturnType: ()=>ts_refactor_inferFunctionReturnType_exports,
        isInImport: ()=>isInImport,
        isRefactorErrorInfo: ()=>isRefactorErrorInfo,
        refactorKindBeginsWith: ()=>refactorKindBeginsWith,
        registerRefactor: ()=>registerRefactor
    });
    // src/services/refactorProvider.ts
    var refactors = /* @__PURE__ */ new Map();
    function registerRefactor(name, refactor) {
        refactors.set(name, refactor);
    }
    function getApplicableRefactors(context, includeInteractiveActions) {
        return arrayFrom(flatMapIterator(refactors.values(), (refactor)=>{
            var _a;
            return context.cancellationToken && context.cancellationToken.isCancellationRequested() || !((_a = refactor.kinds) == null ? void 0 : _a.some((kind)=>refactorKindBeginsWith(kind, context.kind))) ? void 0 : refactor.getAvailableActions(context, includeInteractiveActions);
        }));
    }
    function getEditsForRefactor(context, refactorName14, actionName2, interactiveRefactorArguments) {
        const refactor = refactors.get(refactorName14);
        return refactor && refactor.getEditsForAction(context, actionName2, interactiveRefactorArguments);
    }
    // src/services/refactors/convertExport.ts
    var refactorName = "Convert export";
    var defaultToNamedAction = {
        name: "Convert default export to named export",
        description: getLocaleSpecificMessage(Diagnostics.Convert_default_export_to_named_export),
        kind: "refactor.rewrite.export.named"
    };
    var namedToDefaultAction = {
        name: "Convert named export to default export",
        description: getLocaleSpecificMessage(Diagnostics.Convert_named_export_to_default_export),
        kind: "refactor.rewrite.export.default"
    };
    registerRefactor(refactorName, {
        kinds: [
            defaultToNamedAction.kind,
            namedToDefaultAction.kind
        ],
        getAvailableActions: function getRefactorActionsToConvertBetweenNamedAndDefaultExports(context) {
            const info = getInfo2(context, context.triggerReason === "invoked");
            if (!info) return emptyArray;
            if (!isRefactorErrorInfo(info)) {
                const action = info.wasDefault ? defaultToNamedAction : namedToDefaultAction;
                return [
                    {
                        name: refactorName,
                        description: action.description,
                        actions: [
                            action
                        ]
                    }
                ];
            }
            if (context.preferences.provideRefactorNotApplicableReason) return [
                {
                    name: refactorName,
                    description: getLocaleSpecificMessage(Diagnostics.Convert_default_export_to_named_export),
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultToNamedAction), {
                            notApplicableReason: info.error
                        }),
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, namedToDefaultAction), {
                            notApplicableReason: info.error
                        })
                    ]
                }
            ];
            return emptyArray;
        },
        getEditsForAction: function getRefactorEditsToConvertBetweenNamedAndDefaultExports(context, actionName2) {
            Debug.assert(actionName2 === defaultToNamedAction.name || actionName2 === namedToDefaultAction.name, "Unexpected action name");
            const info = getInfo2(context);
            Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange(context.file, context.program, info, t, context.cancellationToken));
            return {
                edits,
                renameFilename: void 0,
                renameLocation: void 0
            };
        }
    });
    function getInfo2(context, considerPartialSpans = true) {
        const { file, program } = context;
        const span = getRefactorContextSpan(context);
        const token = getTokenAtPosition(file, span.start);
        const exportNode = !!(token.parent && getSyntacticModifierFlags(token.parent) & 32 /* Export */ ) && considerPartialSpans ? token.parent : getParentNodeInSpan(token, file, span);
        if (!exportNode || !isSourceFile(exportNode.parent) && !(isModuleBlock(exportNode.parent) && isAmbientModule(exportNode.parent.parent))) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_export_statement)
        };
        const checker = program.getTypeChecker();
        const exportingModuleSymbol = getExportingModuleSymbol(exportNode.parent, checker);
        const flags = getSyntacticModifierFlags(exportNode) || (isExportAssignment(exportNode) && !exportNode.isExportEquals ? 2080 /* ExportDefault */  : 0 /* None */ );
        const wasDefault = !!(flags & 2048 /* Default */ );
        if (!(flags & 32 /* Export */ ) || !wasDefault && exportingModuleSymbol.exports.has("default" /* Default */ )) return {
            error: getLocaleSpecificMessage(Diagnostics.This_file_already_has_a_default_export)
        };
        const noSymbolError = (id)=>isIdentifier(id) && checker.getSymbolAtLocation(id) ? void 0 : {
                error: getLocaleSpecificMessage(Diagnostics.Can_only_convert_named_export)
            };
        switch(exportNode.kind){
            case 263 /* FunctionDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 268 /* ModuleDeclaration */ :
                {
                    const node = exportNode;
                    if (!node.name) return void 0;
                    return noSymbolError(node.name) || {
                        exportNode: node,
                        exportName: node.name,
                        wasDefault,
                        exportingModuleSymbol
                    };
                }
            case 244 /* VariableStatement */ :
                {
                    const vs = exportNode;
                    if (!(vs.declarationList.flags & 2 /* Const */ ) || vs.declarationList.declarations.length !== 1) return void 0;
                    const decl = first(vs.declarationList.declarations);
                    if (!decl.initializer) return void 0;
                    Debug.assert(!wasDefault, "Can't have a default flag here");
                    return noSymbolError(decl.name) || {
                        exportNode: vs,
                        exportName: decl.name,
                        wasDefault,
                        exportingModuleSymbol
                    };
                }
            case 278 /* ExportAssignment */ :
                {
                    const node = exportNode;
                    if (node.isExportEquals) return void 0;
                    return noSymbolError(node.expression) || {
                        exportNode: node,
                        exportName: node.expression,
                        wasDefault,
                        exportingModuleSymbol
                    };
                }
            default:
                return void 0;
        }
    }
    function doChange(exportingSourceFile, program, info, changes, cancellationToken) {
        changeExport(exportingSourceFile, info, changes, program.getTypeChecker());
        changeImports(program, info, changes, cancellationToken);
    }
    function changeExport(exportingSourceFile, { wasDefault, exportNode, exportName }, changes, checker) {
        if (wasDefault) {
            if (isExportAssignment(exportNode) && !exportNode.isExportEquals) {
                const exp = exportNode.expression;
                const spec = makeExportSpecifier(exp.text, exp.text);
                changes.replaceNode(exportingSourceFile, exportNode, factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([
                    spec
                ])));
            } else changes.delete(exportingSourceFile, Debug.checkDefined(findModifier(exportNode, 90 /* DefaultKeyword */ ), "Should find a default keyword in modifier list"));
        } else {
            const exportKeyword = Debug.checkDefined(findModifier(exportNode, 95 /* ExportKeyword */ ), "Should find an export keyword in modifier list");
            switch(exportNode.kind){
                case 263 /* FunctionDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                    changes.insertNodeAfter(exportingSourceFile, exportKeyword, factory.createToken(90 /* DefaultKeyword */ ));
                    break;
                case 244 /* VariableStatement */ :
                    const decl = first(exportNode.declarationList.declarations);
                    if (!ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(exportName, checker, exportingSourceFile) && !decl.type) {
                        changes.replaceNode(exportingSourceFile, exportNode, factory.createExportDefault(Debug.checkDefined(decl.initializer, "Initializer was previously known to be present")));
                        break;
                    }
                // falls through
                case 267 /* EnumDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                    changes.deleteModifier(exportingSourceFile, exportKeyword);
                    changes.insertNodeAfter(exportingSourceFile, exportNode, factory.createExportDefault(factory.createIdentifier(exportName.text)));
                    break;
                default:
                    Debug.fail(`Unexpected exportNode kind ${exportNode.kind}`);
            }
        }
    }
    function changeImports(program, { wasDefault, exportName, exportingModuleSymbol }, changes, cancellationToken) {
        const checker = program.getTypeChecker();
        const exportSymbol = Debug.checkDefined(checker.getSymbolAtLocation(exportName), "Export name should resolve to a symbol");
        ts_FindAllReferences_exports.Core.eachExportReference(program.getSourceFiles(), checker, cancellationToken, exportSymbol, exportingModuleSymbol, exportName.text, wasDefault, (ref)=>{
            if (exportName === ref) return;
            const importingSourceFile = ref.getSourceFile();
            if (wasDefault) changeDefaultToNamedImport(importingSourceFile, ref, changes, exportName.text);
            else changeNamedToDefaultImport(importingSourceFile, ref, changes);
        });
    }
    function changeDefaultToNamedImport(importingSourceFile, ref, changes, exportName) {
        const { parent: parent2 } = ref;
        switch(parent2.kind){
            case 212 /* PropertyAccessExpression */ :
                changes.replaceNode(importingSourceFile, ref, factory.createIdentifier(exportName));
                break;
            case 277 /* ImportSpecifier */ :
            case 282 /* ExportSpecifier */ :
                {
                    const spec = parent2;
                    changes.replaceNode(importingSourceFile, spec, makeImportSpecifier(exportName, spec.name.text));
                    break;
                }
            case 274 /* ImportClause */ :
                {
                    const clause = parent2;
                    Debug.assert(clause.name === ref, "Import clause name should match provided ref");
                    const spec = makeImportSpecifier(exportName, ref.text);
                    const { namedBindings } = clause;
                    if (!namedBindings) changes.replaceNode(importingSourceFile, ref, factory.createNamedImports([
                        spec
                    ]));
                    else if (namedBindings.kind === 275 /* NamespaceImport */ ) {
                        changes.deleteRange(importingSourceFile, {
                            pos: ref.getStart(importingSourceFile),
                            end: namedBindings.getStart(importingSourceFile)
                        });
                        const quotePreference = isStringLiteral(clause.parent.moduleSpecifier) ? quotePreferenceFromString(clause.parent.moduleSpecifier, importingSourceFile) : 1 /* Double */ ;
                        const newImport = makeImport(/*defaultImport*/ void 0, [
                            makeImportSpecifier(exportName, ref.text)
                        ], clause.parent.moduleSpecifier, quotePreference);
                        changes.insertNodeAfter(importingSourceFile, clause.parent, newImport);
                    } else {
                        changes.delete(importingSourceFile, ref);
                        changes.insertNodeAtEndOfList(importingSourceFile, namedBindings.elements, spec);
                    }
                    break;
                }
            case 206 /* ImportType */ :
                const importTypeNode = parent2;
                changes.replaceNode(importingSourceFile, parent2, factory.createImportTypeNode(importTypeNode.argument, importTypeNode.attributes, factory.createIdentifier(exportName), importTypeNode.typeArguments, importTypeNode.isTypeOf));
                break;
            default:
                Debug.failBadSyntaxKind(parent2);
        }
    }
    function changeNamedToDefaultImport(importingSourceFile, ref, changes) {
        const parent2 = ref.parent;
        switch(parent2.kind){
            case 212 /* PropertyAccessExpression */ :
                changes.replaceNode(importingSourceFile, ref, factory.createIdentifier("default"));
                break;
            case 277 /* ImportSpecifier */ :
                {
                    const defaultImport = factory.createIdentifier(parent2.name.text);
                    if (parent2.parent.elements.length === 1) changes.replaceNode(importingSourceFile, parent2.parent, defaultImport);
                    else {
                        changes.delete(importingSourceFile, parent2);
                        changes.insertNodeBefore(importingSourceFile, parent2.parent, defaultImport);
                    }
                    break;
                }
            case 282 /* ExportSpecifier */ :
                changes.replaceNode(importingSourceFile, parent2, makeExportSpecifier("default", parent2.name.text));
                break;
            default:
                Debug.assertNever(parent2, `Unexpected parent kind ${parent2.kind}`);
        }
    }
    function makeImportSpecifier(propertyName, name) {
        return factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName === name ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(name));
    }
    function makeExportSpecifier(propertyName, name) {
        return factory.createExportSpecifier(/*isTypeOnly*/ false, propertyName === name ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(name));
    }
    function getExportingModuleSymbol(parent2, checker) {
        if (isSourceFile(parent2)) return parent2.symbol;
        const symbol = parent2.parent.symbol;
        if (symbol.valueDeclaration && isExternalModuleAugmentation(symbol.valueDeclaration)) return checker.getMergedSymbol(symbol);
        return symbol;
    }
    // src/services/refactors/convertImport.ts
    var refactorName2 = "Convert import";
    var actions = {
        [0 /* Named */ ]: {
            name: "Convert namespace import to named imports",
            description: getLocaleSpecificMessage(Diagnostics.Convert_namespace_import_to_named_imports),
            kind: "refactor.rewrite.import.named"
        },
        [2 /* Namespace */ ]: {
            name: "Convert named imports to namespace import",
            description: getLocaleSpecificMessage(Diagnostics.Convert_named_imports_to_namespace_import),
            kind: "refactor.rewrite.import.namespace"
        },
        [1 /* Default */ ]: {
            name: "Convert named imports to default import",
            description: getLocaleSpecificMessage(Diagnostics.Convert_named_imports_to_default_import),
            kind: "refactor.rewrite.import.default"
        }
    };
    registerRefactor(refactorName2, {
        kinds: getOwnValues(actions).map((a)=>a.kind),
        getAvailableActions: function getRefactorActionsToConvertBetweenNamedAndNamespacedImports(context) {
            const info = getImportConversionInfo(context, context.triggerReason === "invoked");
            if (!info) return emptyArray;
            if (!isRefactorErrorInfo(info)) {
                const action = actions[info.convertTo];
                return [
                    {
                        name: refactorName2,
                        description: action.description,
                        actions: [
                            action
                        ]
                    }
                ];
            }
            if (context.preferences.provideRefactorNotApplicableReason) return getOwnValues(actions).map((action)=>({
                    name: refactorName2,
                    description: action.description,
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, action), {
                            notApplicableReason: info.error
                        })
                    ]
                }));
            return emptyArray;
        },
        getEditsForAction: function getRefactorEditsToConvertBetweenNamedAndNamespacedImports(context, actionName2) {
            Debug.assert(some(getOwnValues(actions), (action)=>action.name === actionName2), "Unexpected action name");
            const info = getImportConversionInfo(context);
            Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange2(context.file, context.program, t, info));
            return {
                edits,
                renameFilename: void 0,
                renameLocation: void 0
            };
        }
    });
    function getImportConversionInfo(context, considerPartialSpans = true) {
        const { file } = context;
        const span = getRefactorContextSpan(context);
        const token = getTokenAtPosition(file, span.start);
        const importDecl = considerPartialSpans ? findAncestor(token, or(isImportDeclaration, isJSDocImportTag)) : getParentNodeInSpan(token, file, span);
        if (importDecl === void 0 || !(isImportDeclaration(importDecl) || isJSDocImportTag(importDecl))) return {
            error: "Selection is not an import declaration."
        };
        const end = span.start + span.length;
        const nextToken = findNextToken(importDecl, importDecl.parent, file);
        if (nextToken && end > nextToken.getStart()) return void 0;
        const { importClause } = importDecl;
        if (!importClause) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_import_clause)
        };
        if (!importClause.namedBindings) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_namespace_import_or_named_imports)
        };
        if (importClause.namedBindings.kind === 275 /* NamespaceImport */ ) return {
            convertTo: 0 /* Named */ ,
            import: importClause.namedBindings
        };
        const shouldUseDefault = getShouldUseDefault(context.program, importClause);
        return shouldUseDefault ? {
            convertTo: 1 /* Default */ ,
            import: importClause.namedBindings
        } : {
            convertTo: 2 /* Namespace */ ,
            import: importClause.namedBindings
        };
    }
    function getShouldUseDefault(program, importClause) {
        return getAllowSyntheticDefaultImports(program.getCompilerOptions()) && isExportEqualsModule(importClause.parent.moduleSpecifier, program.getTypeChecker());
    }
    function doChange2(sourceFile, program, changes, info) {
        const checker = program.getTypeChecker();
        if (info.convertTo === 0 /* Named */ ) doChangeNamespaceToNamed(sourceFile, checker, changes, info.import, getAllowSyntheticDefaultImports(program.getCompilerOptions()));
        else doChangeNamedToNamespaceOrDefault(sourceFile, program, changes, info.import, info.convertTo === 1 /* Default */ );
    }
    function doChangeNamespaceToNamed(sourceFile, checker, changes, toConvert, allowSyntheticDefaultImports) {
        let usedAsNamespaceOrDefault = false;
        const nodesToReplace = [];
        const conflictingNames = /* @__PURE__ */ new Map();
        ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(toConvert.name, checker, sourceFile, (id)=>{
            if (!isPropertyAccessOrQualifiedName(id.parent)) usedAsNamespaceOrDefault = true;
            else {
                const exportName = getRightOfPropertyAccessOrQualifiedName(id.parent).text;
                if (checker.resolveName(exportName, id, -1 /* All */ , /*excludeGlobals*/ true)) conflictingNames.set(exportName, true);
                Debug.assert(getLeftOfPropertyAccessOrQualifiedName(id.parent) === id, "Parent expression should match id");
                nodesToReplace.push(id.parent);
            }
        });
        const exportNameToImportName = /* @__PURE__ */ new Map();
        for (const propertyAccessOrQualifiedName of nodesToReplace){
            const exportName = getRightOfPropertyAccessOrQualifiedName(propertyAccessOrQualifiedName).text;
            let importName = exportNameToImportName.get(exportName);
            if (importName === void 0) exportNameToImportName.set(exportName, importName = conflictingNames.has(exportName) ? getUniqueName(exportName, sourceFile) : exportName);
            changes.replaceNode(sourceFile, propertyAccessOrQualifiedName, factory.createIdentifier(importName));
        }
        const importSpecifiers = [];
        exportNameToImportName.forEach((name, propertyName)=>{
            importSpecifiers.push(factory.createImportSpecifier(/*isTypeOnly*/ false, name === propertyName ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(name)));
        });
        const importDecl = toConvert.parent.parent;
        if (usedAsNamespaceOrDefault && !allowSyntheticDefaultImports && isImportDeclaration(importDecl)) changes.insertNodeAfter(sourceFile, importDecl, createImport(importDecl, /*defaultImportName*/ void 0, importSpecifiers));
        else {
            const defaultImportName = usedAsNamespaceOrDefault ? factory.createIdentifier(toConvert.name.text) : void 0;
            changes.replaceNode(sourceFile, toConvert.parent, createImportClause(defaultImportName, importSpecifiers));
        }
    }
    function getRightOfPropertyAccessOrQualifiedName(propertyAccessOrQualifiedName) {
        return isPropertyAccessExpression(propertyAccessOrQualifiedName) ? propertyAccessOrQualifiedName.name : propertyAccessOrQualifiedName.right;
    }
    function getLeftOfPropertyAccessOrQualifiedName(propertyAccessOrQualifiedName) {
        return isPropertyAccessExpression(propertyAccessOrQualifiedName) ? propertyAccessOrQualifiedName.expression : propertyAccessOrQualifiedName.left;
    }
    function doChangeNamedToNamespaceOrDefault(sourceFile, program, changes, toConvert, shouldUseDefault = getShouldUseDefault(program, toConvert.parent)) {
        const checker = program.getTypeChecker();
        const importDecl = toConvert.parent.parent;
        const { moduleSpecifier } = importDecl;
        const toConvertSymbols = /* @__PURE__ */ new Set();
        toConvert.elements.forEach((namedImport)=>{
            const symbol = checker.getSymbolAtLocation(namedImport.name);
            if (symbol) toConvertSymbols.add(symbol);
        });
        const preferredName = moduleSpecifier && isStringLiteral(moduleSpecifier) ? moduleSpecifierToValidIdentifier(moduleSpecifier.text, 99 /* ESNext */ ) : "module";
        function hasNamespaceNameConflict(namedImport) {
            return !!ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(namedImport.name, checker, sourceFile, (id)=>{
                const symbol = checker.resolveName(preferredName, id, -1 /* All */ , /*excludeGlobals*/ true);
                if (symbol) {
                    if (toConvertSymbols.has(symbol)) return isExportSpecifier(id.parent);
                    return true;
                }
                return false;
            });
        }
        const namespaceNameConflicts = toConvert.elements.some(hasNamespaceNameConflict);
        const namespaceImportName = namespaceNameConflicts ? getUniqueName(preferredName, sourceFile) : preferredName;
        const neededNamedImports = /* @__PURE__ */ new Set();
        for (const element of toConvert.elements){
            const propertyName = element.propertyName || element.name;
            ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(element.name, checker, sourceFile, (id)=>{
                const access = propertyName.kind === 11 /* StringLiteral */  ? factory.createElementAccessExpression(factory.createIdentifier(namespaceImportName), factory.cloneNode(propertyName)) : factory.createPropertyAccessExpression(factory.createIdentifier(namespaceImportName), factory.cloneNode(propertyName));
                if (isShorthandPropertyAssignment(id.parent)) changes.replaceNode(sourceFile, id.parent, factory.createPropertyAssignment(id.text, access));
                else if (isExportSpecifier(id.parent)) neededNamedImports.add(element);
                else changes.replaceNode(sourceFile, id, access);
            });
        }
        changes.replaceNode(sourceFile, toConvert, shouldUseDefault ? factory.createIdentifier(namespaceImportName) : factory.createNamespaceImport(factory.createIdentifier(namespaceImportName)));
        if (neededNamedImports.size && isImportDeclaration(importDecl)) {
            const newNamedImports = arrayFrom(neededNamedImports.values(), (element)=>factory.createImportSpecifier(element.isTypeOnly, element.propertyName && factory.cloneNode(element.propertyName), factory.cloneNode(element.name)));
            changes.insertNodeAfter(sourceFile, toConvert.parent.parent, createImport(importDecl, /*defaultImportName*/ void 0, newNamedImports));
        }
    }
    function isExportEqualsModule(moduleSpecifier, checker) {
        const externalModule = checker.resolveExternalModuleName(moduleSpecifier);
        if (!externalModule) return false;
        const exportEquals = checker.resolveExternalModuleSymbol(externalModule);
        return externalModule !== exportEquals;
    }
    function createImport(node, defaultImportName, elements) {
        return factory.createImportDeclaration(/*modifiers*/ void 0, createImportClause(defaultImportName, elements), node.moduleSpecifier, /*attributes*/ void 0);
    }
    function createImportClause(defaultImportName, elements) {
        return factory.createImportClause(/*phaseModifier*/ void 0, defaultImportName, elements && elements.length ? factory.createNamedImports(elements) : void 0);
    }
    // src/services/refactors/extractType.ts
    var refactorName3 = "Extract type";
    var extractToTypeAliasAction = {
        name: "Extract to type alias",
        description: getLocaleSpecificMessage(Diagnostics.Extract_to_type_alias),
        kind: "refactor.extract.type"
    };
    var extractToInterfaceAction = {
        name: "Extract to interface",
        description: getLocaleSpecificMessage(Diagnostics.Extract_to_interface),
        kind: "refactor.extract.interface"
    };
    var extractToTypeDefAction = {
        name: "Extract to typedef",
        description: getLocaleSpecificMessage(Diagnostics.Extract_to_typedef),
        kind: "refactor.extract.typedef"
    };
    registerRefactor(refactorName3, {
        kinds: [
            extractToTypeAliasAction.kind,
            extractToInterfaceAction.kind,
            extractToTypeDefAction.kind
        ],
        getAvailableActions: function getRefactorActionsToExtractType(context) {
            const { info, affectedTextRange } = getRangeToExtract(context, context.triggerReason === "invoked");
            if (!info) return emptyArray;
            if (!isRefactorErrorInfo(info)) {
                const refactorInfo = [
                    {
                        name: refactorName3,
                        description: getLocaleSpecificMessage(Diagnostics.Extract_type),
                        actions: info.isJS ? [
                            extractToTypeDefAction
                        ] : append([
                            extractToTypeAliasAction
                        ], info.typeElements && extractToInterfaceAction)
                    }
                ];
                return refactorInfo.map((info2)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, info2), {
                        actions: info2.actions.map((action)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, action), {
                                range: affectedTextRange ? {
                                    start: {
                                        line: getLineAndCharacterOfPosition(context.file, affectedTextRange.pos).line,
                                        offset: getLineAndCharacterOfPosition(context.file, affectedTextRange.pos).character
                                    },
                                    end: {
                                        line: getLineAndCharacterOfPosition(context.file, affectedTextRange.end).line,
                                        offset: getLineAndCharacterOfPosition(context.file, affectedTextRange.end).character
                                    }
                                } : void 0
                            }))
                    }));
            }
            if (context.preferences.provideRefactorNotApplicableReason) return [
                {
                    name: refactorName3,
                    description: getLocaleSpecificMessage(Diagnostics.Extract_type),
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, extractToTypeDefAction), {
                            notApplicableReason: info.error
                        }),
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, extractToTypeAliasAction), {
                            notApplicableReason: info.error
                        }),
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, extractToInterfaceAction), {
                            notApplicableReason: info.error
                        })
                    ]
                }
            ];
            return emptyArray;
        },
        getEditsForAction: function getRefactorEditsToExtractType(context, actionName2) {
            const { file } = context;
            const { info } = getRangeToExtract(context);
            Debug.assert(info && !isRefactorErrorInfo(info), "Expected to find a range to extract");
            const name = getUniqueName("NewType", file);
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                switch(actionName2){
                    case extractToTypeAliasAction.name:
                        Debug.assert(!info.isJS, "Invalid actionName/JS combo");
                        return doTypeAliasChange(changes, file, name, info);
                    case extractToTypeDefAction.name:
                        Debug.assert(info.isJS, "Invalid actionName/JS combo");
                        return doTypedefChange(changes, context, file, name, info);
                    case extractToInterfaceAction.name:
                        Debug.assert(!info.isJS && !!info.typeElements, "Invalid actionName/JS combo");
                        return doInterfaceChange(changes, file, name, info);
                    default:
                        Debug.fail("Unexpected action name");
                }
            });
            const renameFilename = file.fileName;
            const renameLocation = getRenameLocation(edits, renameFilename, name, /*preferLastLocation*/ false);
            return {
                edits,
                renameFilename,
                renameLocation
            };
        }
    });
    function getRangeToExtract(context, considerEmptySpans = true) {
        const { file, startPosition } = context;
        const isJS = isSourceFileJS(file);
        const range = createTextRangeFromSpan(getRefactorContextSpan(context));
        const isCursorRequest = range.pos === range.end && considerEmptySpans;
        const firstType = getFirstTypeAt(file, startPosition, range, isCursorRequest);
        if (!firstType || !isTypeNode(firstType)) return {
            info: {
                error: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_type_node)
            },
            affectedTextRange: void 0
        };
        const checker = context.program.getTypeChecker();
        const enclosingNode = getEnclosingNode(firstType, isJS);
        if (enclosingNode === void 0) return {
            info: {
                error: getLocaleSpecificMessage(Diagnostics.No_type_could_be_extracted_from_this_type_node)
            },
            affectedTextRange: void 0
        };
        const expandedFirstType = getExpandedSelectionNode(firstType, enclosingNode);
        if (!isTypeNode(expandedFirstType)) return {
            info: {
                error: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_type_node)
            },
            affectedTextRange: void 0
        };
        const typeList = [];
        if ((isUnionTypeNode(expandedFirstType.parent) || isIntersectionTypeNode(expandedFirstType.parent)) && range.end > firstType.end) addRange(typeList, expandedFirstType.parent.types.filter((type)=>{
            return nodeOverlapsWithStartEnd(type, file, range.pos, range.end);
        }));
        const selection = typeList.length > 1 ? typeList : expandedFirstType;
        const { typeParameters, affectedTextRange } = collectTypeParameters(checker, selection, enclosingNode, file);
        if (!typeParameters) return {
            info: {
                error: getLocaleSpecificMessage(Diagnostics.No_type_could_be_extracted_from_this_type_node)
            },
            affectedTextRange: void 0
        };
        const typeElements = flattenTypeLiteralNodeReference(checker, selection);
        return {
            info: {
                isJS,
                selection,
                enclosingNode,
                typeParameters,
                typeElements
            },
            affectedTextRange
        };
    }
    function getFirstTypeAt(file, startPosition, range, isCursorRequest) {
        const currentNodes = [
            ()=>getTokenAtPosition(file, startPosition),
            ()=>getTouchingToken(file, startPosition, ()=>true)
        ];
        for (const f of currentNodes){
            const current = f();
            const overlappingRange = nodeOverlapsWithStartEnd(current, file, range.pos, range.end);
            const firstType = findAncestor(current, (node)=>node.parent && isTypeNode(node) && !rangeContainsSkipTrivia(range, node.parent, file) && (isCursorRequest || overlappingRange));
            if (firstType) return firstType;
        }
        return void 0;
    }
    function flattenTypeLiteralNodeReference(checker, selection) {
        if (!selection) return void 0;
        if (isArray(selection)) {
            const result = [];
            for (const type of selection){
                const flattenedTypeMembers = flattenTypeLiteralNodeReference(checker, type);
                if (!flattenedTypeMembers) return void 0;
                addRange(result, flattenedTypeMembers);
            }
            return result;
        }
        if (isIntersectionTypeNode(selection)) {
            const result = [];
            const seen = /* @__PURE__ */ new Set();
            for (const type of selection.types){
                const flattenedTypeMembers = flattenTypeLiteralNodeReference(checker, type);
                if (!flattenedTypeMembers || !flattenedTypeMembers.every((type2)=>type2.name && addToSeen(seen, getNameFromPropertyName(type2.name)))) return void 0;
                addRange(result, flattenedTypeMembers);
            }
            return result;
        } else if (isParenthesizedTypeNode(selection)) return flattenTypeLiteralNodeReference(checker, selection.type);
        else if (isTypeLiteralNode(selection)) return selection.members;
        return void 0;
    }
    function rangeContainsSkipTrivia(r1, node, file) {
        return rangeContainsStartEnd(r1, skipTrivia(file.text, node.pos), node.end);
    }
    function collectTypeParameters(checker, selection, enclosingNode, file) {
        const result = [];
        const selectionArray = toArray(selection);
        const selectionRange = {
            pos: selectionArray[0].getStart(file),
            end: selectionArray[selectionArray.length - 1].end
        };
        for (const t of selectionArray){
            if (visitor(t)) return {
                typeParameters: void 0,
                affectedTextRange: void 0
            };
        }
        return {
            typeParameters: result,
            affectedTextRange: selectionRange
        };
        function visitor(node) {
            if (isTypeReferenceNode(node)) {
                if (isIdentifier(node.typeName)) {
                    const typeName = node.typeName;
                    const symbol = checker.resolveName(typeName.text, typeName, 262144 /* TypeParameter */ , /*excludeGlobals*/ true);
                    for (const decl of (symbol == null ? void 0 : symbol.declarations) || emptyArray)if (isTypeParameterDeclaration(decl) && decl.getSourceFile() === file) {
                        if (decl.name.escapedText === typeName.escapedText && rangeContainsSkipTrivia(decl, selectionRange, file)) return true;
                        if (rangeContainsSkipTrivia(enclosingNode, decl, file) && !rangeContainsSkipTrivia(selectionRange, decl, file)) {
                            pushIfUnique(result, decl);
                            break;
                        }
                    }
                }
            } else if (isInferTypeNode(node)) {
                const conditionalTypeNode = findAncestor(node, (n)=>isConditionalTypeNode(n) && rangeContainsSkipTrivia(n.extendsType, node, file));
                if (!conditionalTypeNode || !rangeContainsSkipTrivia(selectionRange, conditionalTypeNode, file)) return true;
            } else if (isTypePredicateNode(node) || isThisTypeNode(node)) {
                const functionLikeNode = findAncestor(node.parent, isFunctionLike);
                if (functionLikeNode && functionLikeNode.type && rangeContainsSkipTrivia(functionLikeNode.type, node, file) && !rangeContainsSkipTrivia(selectionRange, functionLikeNode, file)) return true;
            } else if (isTypeQueryNode(node)) {
                if (isIdentifier(node.exprName)) {
                    const symbol = checker.resolveName(node.exprName.text, node.exprName, 111551 /* Value */ , /*excludeGlobals*/ false);
                    if ((symbol == null ? void 0 : symbol.valueDeclaration) && rangeContainsSkipTrivia(enclosingNode, symbol.valueDeclaration, file) && !rangeContainsSkipTrivia(selectionRange, symbol.valueDeclaration, file)) return true;
                } else {
                    if (isThisIdentifier(node.exprName.left) && !rangeContainsSkipTrivia(selectionRange, node.parent, file)) return true;
                }
            }
            if (file && isTupleTypeNode(node) && getLineAndCharacterOfPosition(file, node.pos).line === getLineAndCharacterOfPosition(file, node.end).line) setEmitFlags(node, 1 /* SingleLine */ );
            return forEachChild(node, visitor);
        }
    }
    function doTypeAliasChange(changes, file, name, info) {
        const { enclosingNode, typeParameters } = info;
        const { firstTypeNode, lastTypeNode, newTypeNode } = getNodesToEdit(info);
        const newTypeDeclaration = factory.createTypeAliasDeclaration(/*modifiers*/ void 0, name, typeParameters.map((id)=>factory.updateTypeParameterDeclaration(id, id.modifiers, id.name, id.constraint, /*defaultType*/ void 0)), newTypeNode);
        changes.insertNodeBefore(file, enclosingNode, ignoreSourceNewlines(newTypeDeclaration), /*blankLineBetween*/ true);
        changes.replaceNodeRange(file, firstTypeNode, lastTypeNode, factory.createTypeReferenceNode(name, typeParameters.map((id)=>factory.createTypeReferenceNode(id.name, /*typeArguments*/ void 0))), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.ExcludeWhitespace
        });
    }
    function doInterfaceChange(changes, file, name, info) {
        var _a;
        const { enclosingNode, typeParameters, typeElements } = info;
        const newTypeNode = factory.createInterfaceDeclaration(/*modifiers*/ void 0, name, typeParameters, /*heritageClauses*/ void 0, typeElements);
        setTextRange(newTypeNode, (_a = typeElements[0]) == null ? void 0 : _a.parent);
        changes.insertNodeBefore(file, enclosingNode, ignoreSourceNewlines(newTypeNode), /*blankLineBetween*/ true);
        const { firstTypeNode, lastTypeNode } = getNodesToEdit(info);
        changes.replaceNodeRange(file, firstTypeNode, lastTypeNode, factory.createTypeReferenceNode(name, typeParameters.map((id)=>factory.createTypeReferenceNode(id.name, /*typeArguments*/ void 0))), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.ExcludeWhitespace
        });
    }
    function doTypedefChange(changes, context, file, name, info) {
        var _a;
        toArray(info.selection).forEach((typeNode)=>{
            setEmitFlags(typeNode, 7168 /* NoNestedComments */ );
        });
        const { enclosingNode, typeParameters } = info;
        const { firstTypeNode, lastTypeNode, newTypeNode } = getNodesToEdit(info);
        const node = factory.createJSDocTypedefTag(factory.createIdentifier("typedef"), factory.createJSDocTypeExpression(newTypeNode), factory.createIdentifier(name));
        const templates = [];
        forEach(typeParameters, (typeParameter)=>{
            const constraint = getEffectiveConstraintOfTypeParameter(typeParameter);
            const parameter = factory.createTypeParameterDeclaration(/*modifiers*/ void 0, typeParameter.name);
            const template = factory.createJSDocTemplateTag(factory.createIdentifier("template"), constraint && cast(constraint, isJSDocTypeExpression), [
                parameter
            ]);
            templates.push(template);
        });
        const jsDoc = factory.createJSDocComment(/*comment*/ void 0, factory.createNodeArray(concatenate(templates, [
            node
        ])));
        if (isJSDoc(enclosingNode)) {
            const pos = enclosingNode.getStart(file);
            const newLineCharacter = getNewLineOrDefaultFromHost(context.host, (_a = context.formatContext) == null ? void 0 : _a.options);
            changes.insertNodeAt(file, enclosingNode.getStart(file), jsDoc, {
                suffix: newLineCharacter + newLineCharacter + file.text.slice(getPrecedingNonSpaceCharacterPosition(file.text, pos - 1), pos)
            });
        } else changes.insertNodeBefore(file, enclosingNode, jsDoc, /*blankLineBetween*/ true);
        changes.replaceNodeRange(file, firstTypeNode, lastTypeNode, factory.createTypeReferenceNode(name, typeParameters.map((id)=>factory.createTypeReferenceNode(id.name, /*typeArguments*/ void 0))));
    }
    function getNodesToEdit(info) {
        if (isArray(info.selection)) return {
            firstTypeNode: info.selection[0],
            lastTypeNode: info.selection[info.selection.length - 1],
            newTypeNode: isUnionTypeNode(info.selection[0].parent) ? factory.createUnionTypeNode(info.selection) : factory.createIntersectionTypeNode(info.selection)
        };
        return {
            firstTypeNode: info.selection,
            lastTypeNode: info.selection,
            newTypeNode: info.selection
        };
    }
    function getEnclosingNode(node, isJS) {
        return findAncestor(node, isStatement) || (isJS ? findAncestor(node, isJSDoc) : void 0);
    }
    function getExpandedSelectionNode(firstType, enclosingNode) {
        var _findAncestor;
        return (_findAncestor = findAncestor(firstType, (node)=>{
            if (node === enclosingNode) return "quit";
            if (isUnionTypeNode(node.parent) || isIntersectionTypeNode(node.parent)) return true;
            return false;
        })) !== null && _findAncestor !== void 0 ? _findAncestor : firstType;
    }
    // src/services/refactors/moveToFile.ts
    var refactorNameForMoveToFile = "Move to file";
    var description = getLocaleSpecificMessage(Diagnostics.Move_to_file);
    var moveToFileAction = {
        name: "Move to file",
        description,
        kind: "refactor.move.file"
    };
    registerRefactor(refactorNameForMoveToFile, {
        kinds: [
            moveToFileAction.kind
        ],
        getAvailableActions: function getRefactorActionsToMoveToFile(context, interactiveRefactorArguments) {
            const file = context.file;
            const statements = getStatementsToMove(context);
            if (!interactiveRefactorArguments) return emptyArray;
            if (context.triggerReason === "implicit" && context.endPosition !== void 0) {
                const startNodeAncestor = findAncestor(getTokenAtPosition(file, context.startPosition), isBlockLike);
                const endNodeAncestor = findAncestor(getTokenAtPosition(file, context.endPosition), isBlockLike);
                if (startNodeAncestor && !isSourceFile(startNodeAncestor) && endNodeAncestor && !isSourceFile(endNodeAncestor)) return emptyArray;
            }
            if (context.preferences.allowTextChangesInNewFiles && statements) {
                const affectedTextRange = {
                    start: {
                        line: getLineAndCharacterOfPosition(file, statements.all[0].getStart(file)).line,
                        offset: getLineAndCharacterOfPosition(file, statements.all[0].getStart(file)).character
                    },
                    end: {
                        line: getLineAndCharacterOfPosition(file, last(statements.all).end).line,
                        offset: getLineAndCharacterOfPosition(file, last(statements.all).end).character
                    }
                };
                return [
                    {
                        name: refactorNameForMoveToFile,
                        description,
                        actions: [
                            (0, _objectSpreadProps._)((0, _objectSpread._)({}, moveToFileAction), {
                                range: affectedTextRange
                            })
                        ]
                    }
                ];
            }
            if (context.preferences.provideRefactorNotApplicableReason) return [
                {
                    name: refactorNameForMoveToFile,
                    description,
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, moveToFileAction), {
                            notApplicableReason: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_statement_or_statements)
                        })
                    ]
                }
            ];
            return emptyArray;
        },
        getEditsForAction: function getRefactorEditsToMoveToFile(context, actionName2, interactiveRefactorArguments) {
            Debug.assert(actionName2 === refactorNameForMoveToFile, "Wrong refactor invoked");
            const statements = Debug.checkDefined(getStatementsToMove(context));
            const { host, program } = context;
            Debug.assert(interactiveRefactorArguments, "No interactive refactor arguments available");
            const targetFile = interactiveRefactorArguments.targetFile;
            if (hasJSFileExtension(targetFile) || hasTSFileExtension(targetFile)) {
                if (host.fileExists(targetFile) && program.getSourceFile(targetFile) === void 0) return error(getLocaleSpecificMessage(Diagnostics.Cannot_move_statements_to_the_selected_file));
                const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange3(context, context.file, interactiveRefactorArguments.targetFile, context.program, statements, t, context.host, context.preferences));
                return {
                    edits,
                    renameFilename: void 0,
                    renameLocation: void 0
                };
            }
            return error(getLocaleSpecificMessage(Diagnostics.Cannot_move_to_file_selected_file_is_invalid));
        }
    });
    function error(notApplicableReason) {
        return {
            edits: [],
            renameFilename: void 0,
            renameLocation: void 0,
            notApplicableReason
        };
    }
    function doChange3(context, oldFile, targetFile, program, toMove, changes, host, preferences) {
        const checker = program.getTypeChecker();
        const isForNewFile = !host.fileExists(targetFile);
        const targetSourceFile = isForNewFile ? createFutureSourceFile(targetFile, oldFile.externalModuleIndicator ? 99 /* ESNext */  : oldFile.commonJsModuleIndicator ? 1 /* CommonJS */  : void 0, program, host) : Debug.checkDefined(program.getSourceFile(targetFile));
        const importAdderForOldFile = ts_codefix_exports.createImportAdder(oldFile, context.program, context.preferences, context.host);
        const importAdderForNewFile = ts_codefix_exports.createImportAdder(targetSourceFile, context.program, context.preferences, context.host);
        getNewStatementsAndRemoveFromOldFile(oldFile, targetSourceFile, getUsageInfo(oldFile, toMove.all, checker, isForNewFile ? void 0 : getExistingLocals(targetSourceFile, toMove.all, checker)), changes, toMove, program, host, preferences, importAdderForNewFile, importAdderForOldFile);
        if (isForNewFile) addNewFileToTsconfig(program, changes, oldFile.fileName, targetFile, hostGetCanonicalFileName(host));
    }
    function getNewStatementsAndRemoveFromOldFile(oldFile, targetFile, usage, changes, toMove, program, host, preferences, importAdderForNewFile, importAdderForOldFile) {
        const checker = program.getTypeChecker();
        const prologueDirectives = takeWhile(oldFile.statements, isPrologueDirective);
        const useEsModuleSyntax = !fileShouldUseJavaScriptRequire(targetFile.fileName, program, host, !!oldFile.commonJsModuleIndicator);
        const quotePreference = getQuotePreference(oldFile, preferences);
        addImportsForMovedSymbols(usage.oldFileImportsFromTargetFile, targetFile.fileName, importAdderForOldFile, program);
        deleteUnusedOldImports(oldFile, toMove.all, usage.unusedImportsFromOldFile, importAdderForOldFile);
        importAdderForOldFile.writeFixes(changes, quotePreference);
        deleteMovedStatements(oldFile, toMove.ranges, changes);
        updateImportsInOtherFiles(changes, program, host, oldFile, usage.movedSymbols, targetFile.fileName, quotePreference);
        addExportsInOldFile(oldFile, usage.targetFileImportsFromOldFile, changes, useEsModuleSyntax);
        addTargetFileImports(oldFile, usage.oldImportsNeededByTargetFile, usage.targetFileImportsFromOldFile, checker, program, importAdderForNewFile);
        if (!isFullSourceFile(targetFile) && prologueDirectives.length) changes.insertStatementsInNewFile(targetFile.fileName, prologueDirectives, oldFile);
        importAdderForNewFile.writeFixes(changes, quotePreference);
        const body = addExports(oldFile, toMove.all, arrayFrom(usage.oldFileImportsFromTargetFile.keys()), useEsModuleSyntax);
        if (isFullSourceFile(targetFile) && targetFile.statements.length > 0) moveStatementsToTargetFile(changes, program, body, targetFile, toMove);
        else if (isFullSourceFile(targetFile)) changes.insertNodesAtEndOfFile(targetFile, body, /*blankLineBetween*/ false);
        else changes.insertStatementsInNewFile(targetFile.fileName, importAdderForNewFile.hasFixes() ? [
            4 /* NewLineTrivia */ ,
            ...body
        ] : body, oldFile);
    }
    function addNewFileToTsconfig(program, changes, oldFileName, newFileNameWithExtension, getCanonicalFileName) {
        const cfg = program.getCompilerOptions().configFile;
        if (!cfg) return;
        const newFileAbsolutePath = normalizePath(combinePaths(oldFileName, "..", newFileNameWithExtension));
        const newFilePath = getRelativePathFromFile(cfg.fileName, newFileAbsolutePath, getCanonicalFileName);
        const cfgObject = cfg.statements[0] && tryCast(cfg.statements[0].expression, isObjectLiteralExpression);
        const filesProp = cfgObject && find(cfgObject.properties, (prop)=>isPropertyAssignment(prop) && isStringLiteral(prop.name) && prop.name.text === "files");
        if (filesProp && isArrayLiteralExpression(filesProp.initializer)) changes.insertNodeInListAfter(cfg, last(filesProp.initializer.elements), factory.createStringLiteral(newFilePath), filesProp.initializer.elements);
    }
    function deleteMovedStatements(sourceFile, moved, changes) {
        for (const { first: first2, afterLast } of moved)changes.deleteNodeRangeExcludingEnd(sourceFile, first2, afterLast);
    }
    function deleteUnusedOldImports(oldFile, toMove, toDelete, importAdder) {
        for (const statement of oldFile.statements){
            if (contains(toMove, statement)) continue;
            forEachImportInStatement(statement, (i)=>{
                forEachAliasDeclarationInImportOrRequire(i, (decl)=>{
                    if (toDelete.has(decl.symbol)) importAdder.removeExistingImport(decl);
                });
            });
        }
    }
    function addExportsInOldFile(oldFile, targetFileImportsFromOldFile, changes, useEsModuleSyntax) {
        const markSeenTop = nodeSeenTracker();
        targetFileImportsFromOldFile.forEach((_, symbol)=>{
            if (!symbol.declarations) return;
            for (const decl of symbol.declarations){
                if (!isTopLevelDeclaration(decl)) continue;
                const name = nameOfTopLevelDeclaration(decl);
                if (!name) continue;
                const top = getTopLevelDeclarationStatement(decl);
                if (markSeenTop(top)) addExportToChanges(oldFile, top, name, changes, useEsModuleSyntax);
            }
        });
    }
    function updateImportsInOtherFiles(changes, program, host, oldFile, movedSymbols, targetFileName, quotePreference) {
        const checker = program.getTypeChecker();
        for (const sourceFile of program.getSourceFiles()){
            if (sourceFile === oldFile) continue;
            for (const statement of sourceFile.statements)forEachImportInStatement(statement, (importNode)=>{
                if (checker.getSymbolAtLocation(moduleSpecifierFromImport(importNode)) !== oldFile.symbol) return;
                const shouldMove = (name)=>{
                    const symbol = isBindingElement(name.parent) ? getPropertySymbolFromBindingElement(checker, name.parent) : skipAlias(checker.getSymbolAtLocation(name), checker);
                    return !!symbol && movedSymbols.has(symbol);
                };
                deleteUnusedImports(sourceFile, importNode, changes, shouldMove);
                const pathToTargetFileWithExtension = resolvePath(getDirectoryPath(getNormalizedAbsolutePath(oldFile.fileName, program.getCurrentDirectory())), targetFileName);
                if (getStringComparer(!program.useCaseSensitiveFileNames())(pathToTargetFileWithExtension, sourceFile.fileName) === 0 /* EqualTo */ ) return;
                const newModuleSpecifier = ts_moduleSpecifiers_exports.getModuleSpecifier(program.getCompilerOptions(), sourceFile, sourceFile.fileName, pathToTargetFileWithExtension, createModuleSpecifierResolutionHost(program, host));
                const newImportDeclaration = filterImport(importNode, makeStringLiteral(newModuleSpecifier, quotePreference), shouldMove);
                if (newImportDeclaration) changes.insertNodeAfter(sourceFile, statement, newImportDeclaration);
                const ns = getNamespaceLikeImport(importNode);
                if (ns) updateNamespaceLikeImport(changes, sourceFile, checker, movedSymbols, newModuleSpecifier, ns, importNode, quotePreference);
            });
        }
    }
    function getNamespaceLikeImport(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
                return node.importClause && node.importClause.namedBindings && node.importClause.namedBindings.kind === 275 /* NamespaceImport */  ? node.importClause.namedBindings.name : void 0;
            case 272 /* ImportEqualsDeclaration */ :
                return node.name;
            case 261 /* VariableDeclaration */ :
                return tryCast(node.name, isIdentifier);
            default:
                return Debug.assertNever(node, `Unexpected node kind ${node.kind}`);
        }
    }
    function updateNamespaceLikeImport(changes, sourceFile, checker, movedSymbols, newModuleSpecifier, oldImportId, oldImportNode, quotePreference) {
        const preferredNewNamespaceName = moduleSpecifierToValidIdentifier(newModuleSpecifier, 99 /* ESNext */ );
        let needUniqueName = false;
        const toChange = [];
        ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(oldImportId, checker, sourceFile, (ref)=>{
            if (!isPropertyAccessExpression(ref.parent)) return;
            needUniqueName = needUniqueName || !!checker.resolveName(preferredNewNamespaceName, ref, -1 /* All */ , /*excludeGlobals*/ true);
            if (movedSymbols.has(checker.getSymbolAtLocation(ref.parent.name))) toChange.push(ref);
        });
        if (toChange.length) {
            const newNamespaceName = needUniqueName ? getUniqueName(preferredNewNamespaceName, sourceFile) : preferredNewNamespaceName;
            for (const ref of toChange)changes.replaceNode(sourceFile, ref, factory.createIdentifier(newNamespaceName));
            changes.insertNodeAfter(sourceFile, oldImportNode, updateNamespaceLikeImportNode(oldImportNode, preferredNewNamespaceName, newModuleSpecifier, quotePreference));
        }
    }
    function updateNamespaceLikeImportNode(node, newNamespaceName, newModuleSpecifier, quotePreference) {
        const newNamespaceId = factory.createIdentifier(newNamespaceName);
        const newModuleString = makeStringLiteral(newModuleSpecifier, quotePreference);
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
                return factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*phaseModifier*/ void 0, /*name*/ void 0, factory.createNamespaceImport(newNamespaceId)), newModuleString, /*attributes*/ void 0);
            case 272 /* ImportEqualsDeclaration */ :
                return factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, newNamespaceId, factory.createExternalModuleReference(newModuleString));
            case 261 /* VariableDeclaration */ :
                return factory.createVariableDeclaration(newNamespaceId, /*exclamationToken*/ void 0, /*type*/ void 0, createRequireCall(newModuleString));
            default:
                return Debug.assertNever(node, `Unexpected node kind ${node.kind}`);
        }
    }
    function createRequireCall(moduleSpecifier) {
        return factory.createCallExpression(factory.createIdentifier("require"), /*typeArguments*/ void 0, [
            moduleSpecifier
        ]);
    }
    function moduleSpecifierFromImport(i) {
        return i.kind === 273 /* ImportDeclaration */  ? i.moduleSpecifier : i.kind === 272 /* ImportEqualsDeclaration */  ? i.moduleReference.expression : i.initializer.arguments[0];
    }
    function forEachImportInStatement(statement, cb) {
        if (isImportDeclaration(statement)) {
            if (isStringLiteral(statement.moduleSpecifier)) cb(statement);
        } else if (isImportEqualsDeclaration(statement)) {
            if (isExternalModuleReference(statement.moduleReference) && isStringLiteralLike(statement.moduleReference.expression)) cb(statement);
        } else if (isVariableStatement(statement)) {
            for (const decl of statement.declarationList.declarations)if (decl.initializer && isRequireCall(decl.initializer, /*requireStringLiteralLikeArgument*/ true)) cb(decl);
        }
    }
    function forEachAliasDeclarationInImportOrRequire(importOrRequire, cb) {
        var _a, _b, _c, _d, _e;
        if (importOrRequire.kind === 273 /* ImportDeclaration */ ) {
            if ((_a = importOrRequire.importClause) == null ? void 0 : _a.name) cb(importOrRequire.importClause);
            if (((_c = (_b = importOrRequire.importClause) == null ? void 0 : _b.namedBindings) == null ? void 0 : _c.kind) === 275 /* NamespaceImport */ ) cb(importOrRequire.importClause.namedBindings);
            if (((_e = (_d = importOrRequire.importClause) == null ? void 0 : _d.namedBindings) == null ? void 0 : _e.kind) === 276 /* NamedImports */ ) for (const element of importOrRequire.importClause.namedBindings.elements)cb(element);
        } else if (importOrRequire.kind === 272 /* ImportEqualsDeclaration */ ) cb(importOrRequire);
        else if (importOrRequire.kind === 261 /* VariableDeclaration */ ) {
            if (importOrRequire.name.kind === 80 /* Identifier */ ) cb(importOrRequire);
            else if (importOrRequire.name.kind === 207 /* ObjectBindingPattern */ ) {
                for (const element of importOrRequire.name.elements)if (isIdentifier(element.name)) cb(element);
            }
        }
    }
    function addImportsForMovedSymbols(symbols, targetFileName, importAdder, program) {
        for (const [symbol, isValidTypeOnlyUseSite] of symbols){
            const symbolName2 = getNameForExportedSymbol(symbol, getEmitScriptTarget(program.getCompilerOptions()));
            const exportKind = symbol.name === "default" && symbol.parent ? 1 /* Default */  : 0 /* Named */ ;
            importAdder.addImportForNonExistentExport(symbolName2, targetFileName, exportKind, symbol.flags, isValidTypeOnlyUseSite);
        }
    }
    function makeVariableStatement(name, type, initializer, flags = 2 /* Const */ ) {
        return factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, type, initializer)
        ], flags));
    }
    function addExports(sourceFile, toMove, needExport, useEs6Exports) {
        return flatMap(toMove, (statement)=>{
            if (isTopLevelDeclarationStatement(statement) && !isExported(sourceFile, statement, useEs6Exports) && forEachTopLevelDeclaration(statement, (d)=>{
                var _a;
                return needExport.includes(Debug.checkDefined((_a = tryCast(d, canHaveSymbol)) == null ? void 0 : _a.symbol));
            })) {
                const exports2 = addExport(getSynthesizedDeepClone(statement), useEs6Exports);
                if (exports2) return exports2;
            }
            return getSynthesizedDeepClone(statement);
        });
    }
    function isExported(sourceFile, decl, useEs6Exports, name) {
        var _a;
        if (useEs6Exports) return !isExpressionStatement(decl) && hasSyntacticModifier(decl, 32 /* Export */ ) || !!(name && sourceFile.symbol && ((_a = sourceFile.symbol.exports) == null ? void 0 : _a.has(name.escapedText)));
        return !!sourceFile.symbol && !!sourceFile.symbol.exports && getNamesToExportInCommonJS(decl).some((name2)=>sourceFile.symbol.exports.has(escapeLeadingUnderscores(name2)));
    }
    function deleteUnusedImports(sourceFile, importDecl, changes, isUnused) {
        if (importDecl.kind === 273 /* ImportDeclaration */  && importDecl.importClause) {
            const { name, namedBindings } = importDecl.importClause;
            if ((!name || isUnused(name)) && (!namedBindings || namedBindings.kind === 276 /* NamedImports */  && namedBindings.elements.length !== 0 && namedBindings.elements.every((e)=>isUnused(e.name)))) return changes.delete(sourceFile, importDecl);
        }
        forEachAliasDeclarationInImportOrRequire(importDecl, (i)=>{
            if (i.name && isIdentifier(i.name) && isUnused(i.name)) changes.delete(sourceFile, i);
        });
    }
    function isTopLevelDeclarationStatement(node) {
        Debug.assert(isSourceFile(node.parent), "Node parent should be a SourceFile");
        return isNonVariableTopLevelDeclaration(node) || isVariableStatement(node);
    }
    function addExport(decl, useEs6Exports) {
        return useEs6Exports ? [
            addEs6Export(decl)
        ] : addCommonjsExport(decl);
    }
    function addEs6Export(d) {
        const modifiers = canHaveModifiers(d) ? concatenate([
            factory.createModifier(95 /* ExportKeyword */ )
        ], getModifiers(d)) : void 0;
        switch(d.kind){
            case 263 /* FunctionDeclaration */ :
                return factory.updateFunctionDeclaration(d, modifiers, d.asteriskToken, d.name, d.typeParameters, d.parameters, d.type, d.body);
            case 264 /* ClassDeclaration */ :
                const decorators = canHaveDecorators(d) ? getDecorators(d) : void 0;
                return factory.updateClassDeclaration(d, concatenate(decorators, modifiers), d.name, d.typeParameters, d.heritageClauses, d.members);
            case 244 /* VariableStatement */ :
                return factory.updateVariableStatement(d, modifiers, d.declarationList);
            case 268 /* ModuleDeclaration */ :
                return factory.updateModuleDeclaration(d, modifiers, d.name, d.body);
            case 267 /* EnumDeclaration */ :
                return factory.updateEnumDeclaration(d, modifiers, d.name, d.members);
            case 266 /* TypeAliasDeclaration */ :
                return factory.updateTypeAliasDeclaration(d, modifiers, d.name, d.typeParameters, d.type);
            case 265 /* InterfaceDeclaration */ :
                return factory.updateInterfaceDeclaration(d, modifiers, d.name, d.typeParameters, d.heritageClauses, d.members);
            case 272 /* ImportEqualsDeclaration */ :
                return factory.updateImportEqualsDeclaration(d, modifiers, d.isTypeOnly, d.name, d.moduleReference);
            case 245 /* ExpressionStatement */ :
                return Debug.fail();
            default:
                return Debug.assertNever(d, `Unexpected declaration kind ${d.kind}`);
        }
    }
    function addCommonjsExport(decl) {
        return [
            decl,
            ...getNamesToExportInCommonJS(decl).map(createExportAssignment)
        ];
    }
    function createExportAssignment(name) {
        return factory.createExpressionStatement(factory.createBinaryExpression(factory.createPropertyAccessExpression(factory.createIdentifier("exports"), factory.createIdentifier(name)), 64 /* EqualsToken */ , factory.createIdentifier(name)));
    }
    function getNamesToExportInCommonJS(decl) {
        switch(decl.kind){
            case 263 /* FunctionDeclaration */ :
            case 264 /* ClassDeclaration */ :
                return [
                    decl.name.text
                ];
            // TODO: GH#18217
            case 244 /* VariableStatement */ :
                return mapDefined(decl.declarationList.declarations, (d)=>isIdentifier(d.name) ? d.name.text : void 0);
            case 268 /* ModuleDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
                return emptyArray;
            case 245 /* ExpressionStatement */ :
                return Debug.fail("Can't export an ExpressionStatement");
            default:
                return Debug.assertNever(decl, `Unexpected decl kind ${decl.kind}`);
        }
    }
    function filterImport(i, moduleSpecifier, keep) {
        switch(i.kind){
            case 273 /* ImportDeclaration */ :
                {
                    const clause = i.importClause;
                    if (!clause) return void 0;
                    const defaultImport = clause.name && keep(clause.name) ? clause.name : void 0;
                    const namedBindings = clause.namedBindings && filterNamedBindings(clause.namedBindings, keep);
                    return defaultImport || namedBindings ? factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(clause.phaseModifier, defaultImport, namedBindings), getSynthesizedDeepClone(moduleSpecifier), /*attributes*/ void 0) : void 0;
                }
            case 272 /* ImportEqualsDeclaration */ :
                return keep(i.name) ? i : void 0;
            case 261 /* VariableDeclaration */ :
                {
                    const name = filterBindingName(i.name, keep);
                    return name ? makeVariableStatement(name, i.type, createRequireCall(moduleSpecifier), i.parent.flags) : void 0;
                }
            default:
                return Debug.assertNever(i, `Unexpected import kind ${i.kind}`);
        }
    }
    function filterNamedBindings(namedBindings, keep) {
        if (namedBindings.kind === 275 /* NamespaceImport */ ) return keep(namedBindings.name) ? namedBindings : void 0;
        else {
            const newElements = namedBindings.elements.filter((e)=>keep(e.name));
            return newElements.length ? factory.createNamedImports(newElements) : void 0;
        }
    }
    function filterBindingName(name, keep) {
        switch(name.kind){
            case 80 /* Identifier */ :
                return keep(name) ? name : void 0;
            case 208 /* ArrayBindingPattern */ :
                return name;
            case 207 /* ObjectBindingPattern */ :
                {
                    const newElements = name.elements.filter((prop)=>prop.propertyName || !isIdentifier(prop.name) || keep(prop.name));
                    return newElements.length ? factory.createObjectBindingPattern(newElements) : void 0;
                }
        }
    }
    function nameOfTopLevelDeclaration(d) {
        return isExpressionStatement(d) ? tryCast(d.expression.left.name, isIdentifier) : tryCast(d.name, isIdentifier);
    }
    function getTopLevelDeclarationStatement(d) {
        switch(d.kind){
            case 261 /* VariableDeclaration */ :
                return d.parent.parent;
            case 209 /* BindingElement */ :
                return getTopLevelDeclarationStatement(cast(d.parent.parent, (p)=>isVariableDeclaration(p) || isBindingElement(p)));
            default:
                return d;
        }
    }
    function addExportToChanges(sourceFile, decl, name, changes, useEs6Exports) {
        if (isExported(sourceFile, decl, useEs6Exports, name)) return;
        if (useEs6Exports) {
            if (!isExpressionStatement(decl)) changes.insertExportModifier(sourceFile, decl);
        } else {
            const names = getNamesToExportInCommonJS(decl);
            if (names.length !== 0) changes.insertNodesAfter(sourceFile, decl, names.map(createExportAssignment));
        }
    }
    function createNewFileName(oldFile, program, host, toMove) {
        const checker = program.getTypeChecker();
        if (toMove) {
            const usage = getUsageInfo(oldFile, toMove.all, checker);
            const currentDirectory = getDirectoryPath(oldFile.fileName);
            const extension = extensionFromPath(oldFile.fileName);
            const newFileName = combinePaths(// new file is always placed in the same directory as the old file
            currentDirectory, // ensures the filename computed below isn't already taken
            makeUniqueFilename(// infers a name for the new file from the symbols being moved
            inferNewFileName(usage.oldFileImportsFromTargetFile, usage.movedSymbols), extension, currentDirectory, host)) + extension;
            return newFileName;
        }
        return "";
    }
    function getRangeToMove(context) {
        const { file } = context;
        const range = createTextRangeFromSpan(getRefactorContextSpan(context));
        const { statements } = file;
        let startNodeIndex = findIndex(statements, (s)=>s.end > range.pos);
        if (startNodeIndex === -1) return void 0;
        const startStatement = statements[startNodeIndex];
        const overloadRangeToMove = getOverloadRangeToMove(file, startStatement);
        if (overloadRangeToMove) startNodeIndex = overloadRangeToMove.start;
        let endNodeIndex = findIndex(statements, (s)=>s.end >= range.end, startNodeIndex);
        if (endNodeIndex !== -1 && range.end <= statements[endNodeIndex].getStart()) endNodeIndex--;
        const endingOverloadRangeToMove = getOverloadRangeToMove(file, statements[endNodeIndex]);
        if (endingOverloadRangeToMove) endNodeIndex = endingOverloadRangeToMove.end;
        return {
            toMove: statements.slice(startNodeIndex, endNodeIndex === -1 ? statements.length : endNodeIndex + 1),
            afterLast: endNodeIndex === -1 ? void 0 : statements[endNodeIndex + 1]
        };
    }
    function getStatementsToMove(context) {
        const rangeToMove = getRangeToMove(context);
        if (rangeToMove === void 0) return void 0;
        const all = [];
        const ranges = [];
        const { toMove, afterLast } = rangeToMove;
        getRangesWhere(toMove, isAllowedStatementToMove, (start, afterEndIndex)=>{
            for(let i = start; i < afterEndIndex; i++)all.push(toMove[i]);
            ranges.push({
                first: toMove[start],
                afterLast
            });
        });
        return all.length === 0 ? void 0 : {
            all,
            ranges
        };
    }
    function containsJsx(statements) {
        return find(statements, (statement)=>!!(statement.transformFlags & 2 /* ContainsJsx */ ));
    }
    function isAllowedStatementToMove(statement) {
        return !isPureImport(statement) && !isPrologueDirective(statement);
    }
    function isPureImport(node) {
        switch(node.kind){
            case 273 /* ImportDeclaration */ :
                return true;
            case 272 /* ImportEqualsDeclaration */ :
                return !hasSyntacticModifier(node, 32 /* Export */ );
            case 244 /* VariableStatement */ :
                return node.declarationList.declarations.every((d)=>!!d.initializer && isRequireCall(d.initializer, /*requireStringLiteralLikeArgument*/ true));
            default:
                return false;
        }
    }
    function getUsageInfo(oldFile, toMove, checker, existingTargetLocals = /* @__PURE__ */ new Set(), enclosingRange) {
        var _a;
        const movedSymbols = /* @__PURE__ */ new Set();
        const oldImportsNeededByTargetFile = /* @__PURE__ */ new Map();
        const targetFileImportsFromOldFile = /* @__PURE__ */ new Map();
        const jsxNamespaceSymbol = getJsxNamespaceSymbol(containsJsx(toMove));
        if (jsxNamespaceSymbol) oldImportsNeededByTargetFile.set(jsxNamespaceSymbol, [
            false,
            tryCast((_a = jsxNamespaceSymbol.declarations) == null ? void 0 : _a[0], (d)=>isImportSpecifier(d) || isImportClause(d) || isNamespaceImport(d) || isImportEqualsDeclaration(d) || isBindingElement(d) || isVariableDeclaration(d))
        ]);
        for (const statement of toMove)forEachTopLevelDeclaration(statement, (decl)=>{
            movedSymbols.add(Debug.checkDefined(isExpressionStatement(decl) ? checker.getSymbolAtLocation(decl.expression.left) : decl.symbol, "Need a symbol here"));
        });
        const unusedImportsFromOldFile = /* @__PURE__ */ new Set();
        for (const statement of toMove)forEachReference(statement, checker, enclosingRange, (symbol, isValidTypeOnlyUseSite)=>{
            if (!some(symbol.declarations)) return;
            if (existingTargetLocals.has(skipAlias(symbol, checker))) {
                unusedImportsFromOldFile.add(symbol);
                return;
            }
            const importedDeclaration = find(symbol.declarations, isInImport);
            if (importedDeclaration) {
                const prevIsTypeOnly = oldImportsNeededByTargetFile.get(symbol);
                oldImportsNeededByTargetFile.set(symbol, [
                    prevIsTypeOnly === void 0 ? isValidTypeOnlyUseSite : prevIsTypeOnly && isValidTypeOnlyUseSite,
                    tryCast(importedDeclaration, (d)=>isImportSpecifier(d) || isImportClause(d) || isNamespaceImport(d) || isImportEqualsDeclaration(d) || isBindingElement(d) || isVariableDeclaration(d))
                ]);
            } else if (!movedSymbols.has(symbol) && every(symbol.declarations, (decl)=>isTopLevelDeclaration(decl) && sourceFileOfTopLevelDeclaration(decl) === oldFile)) targetFileImportsFromOldFile.set(symbol, isValidTypeOnlyUseSite);
        });
        for (const unusedImport of oldImportsNeededByTargetFile.keys())unusedImportsFromOldFile.add(unusedImport);
        const oldFileImportsFromTargetFile = /* @__PURE__ */ new Map();
        for (const statement of oldFile.statements){
            if (contains(toMove, statement)) continue;
            if (jsxNamespaceSymbol && !!(statement.transformFlags & 2 /* ContainsJsx */ )) unusedImportsFromOldFile.delete(jsxNamespaceSymbol);
            forEachReference(statement, checker, enclosingRange, (symbol, isValidTypeOnlyUseSite)=>{
                if (movedSymbols.has(symbol)) oldFileImportsFromTargetFile.set(symbol, isValidTypeOnlyUseSite);
                unusedImportsFromOldFile.delete(symbol);
            });
        }
        return {
            movedSymbols,
            targetFileImportsFromOldFile,
            oldFileImportsFromTargetFile,
            oldImportsNeededByTargetFile,
            unusedImportsFromOldFile
        };
        function getJsxNamespaceSymbol(containsJsx2) {
            if (containsJsx2 === void 0) return void 0;
            const jsxNamespace = checker.getJsxNamespace(containsJsx2);
            const jsxNamespaceSymbol2 = checker.resolveName(jsxNamespace, containsJsx2, 1920 /* Namespace */ , /*excludeGlobals*/ true);
            return !!jsxNamespaceSymbol2 && some(jsxNamespaceSymbol2.declarations, isInImport) ? jsxNamespaceSymbol2 : void 0;
        }
    }
    function makeUniqueFilename(proposedFilename, extension, inDirectory, host) {
        let newFilename = proposedFilename;
        for(let i = 1;; i++){
            const name = combinePaths(inDirectory, newFilename + extension);
            if (!host.fileExists(name)) return newFilename;
            newFilename = `${proposedFilename}.${i}`;
        }
    }
    function inferNewFileName(importsFromNewFile, movedSymbols) {
        return forEachKey(importsFromNewFile, symbolNameNoDefault) || forEachKey(movedSymbols, symbolNameNoDefault) || "newFile";
    }
    function forEachReference(node, checker, enclosingRange, onReference) {
        node.forEachChild(function cb(node2) {
            if (isIdentifier(node2) && !isDeclarationName(node2)) {
                if (enclosingRange && !rangeContainsRange(enclosingRange, node2)) return;
                const sym = checker.getSymbolAtLocation(node2);
                if (sym) onReference(sym, isValidTypeOnlyAliasUseSite(node2));
            } else node2.forEachChild(cb);
        });
    }
    function forEachTopLevelDeclaration(statement, cb) {
        switch(statement.kind){
            case 263 /* FunctionDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
                return cb(statement);
            case 244 /* VariableStatement */ :
                return firstDefined(statement.declarationList.declarations, (decl)=>forEachTopLevelDeclarationInBindingName(decl.name, cb));
            case 245 /* ExpressionStatement */ :
                {
                    const { expression } = statement;
                    return isBinaryExpression(expression) && getAssignmentDeclarationKind(expression) === 1 /* ExportsProperty */  ? cb(statement) : void 0;
                }
        }
    }
    function isInImport(decl) {
        switch(decl.kind){
            case 272 /* ImportEqualsDeclaration */ :
            case 277 /* ImportSpecifier */ :
            case 274 /* ImportClause */ :
            case 275 /* NamespaceImport */ :
                return true;
            case 261 /* VariableDeclaration */ :
                return isVariableDeclarationInImport(decl);
            case 209 /* BindingElement */ :
                return isVariableDeclaration(decl.parent.parent) && isVariableDeclarationInImport(decl.parent.parent);
            default:
                return false;
        }
    }
    function isVariableDeclarationInImport(decl) {
        return isSourceFile(decl.parent.parent.parent) && !!decl.initializer && isRequireCall(decl.initializer, /*requireStringLiteralLikeArgument*/ true);
    }
    function isTopLevelDeclaration(node) {
        return isNonVariableTopLevelDeclaration(node) && isSourceFile(node.parent) || isVariableDeclaration(node) && isSourceFile(node.parent.parent.parent);
    }
    function sourceFileOfTopLevelDeclaration(node) {
        return isVariableDeclaration(node) ? node.parent.parent.parent : node.parent;
    }
    function forEachTopLevelDeclarationInBindingName(name, cb) {
        switch(name.kind){
            case 80 /* Identifier */ :
                return cb(cast(name.parent, (x)=>isVariableDeclaration(x) || isBindingElement(x)));
            case 208 /* ArrayBindingPattern */ :
            case 207 /* ObjectBindingPattern */ :
                return firstDefined(name.elements, (em)=>isOmittedExpression(em) ? void 0 : forEachTopLevelDeclarationInBindingName(em.name, cb));
            default:
                return Debug.assertNever(name, `Unexpected name kind ${name.kind}`);
        }
    }
    function isNonVariableTopLevelDeclaration(node) {
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 272 /* ImportEqualsDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function moveStatementsToTargetFile(changes, program, statements, targetFile, toMove) {
        var _a;
        const removedExports = /* @__PURE__ */ new Set();
        const targetExports = (_a = targetFile.symbol) == null ? void 0 : _a.exports;
        if (targetExports) {
            const checker = program.getTypeChecker();
            const targetToSourceExports = /* @__PURE__ */ new Map();
            for (const node of toMove.all)if (isTopLevelDeclarationStatement(node) && hasSyntacticModifier(node, 32 /* Export */ )) forEachTopLevelDeclaration(node, (declaration)=>{
                var _a2;
                const targetDeclarations = canHaveSymbol(declaration) ? (_a2 = targetExports.get(declaration.symbol.escapedName)) == null ? void 0 : _a2.declarations : void 0;
                const exportDeclaration = firstDefined(targetDeclarations, (d)=>isExportDeclaration(d) ? d : isExportSpecifier(d) ? tryCast(d.parent.parent, isExportDeclaration) : void 0);
                if (exportDeclaration && exportDeclaration.moduleSpecifier) targetToSourceExports.set(exportDeclaration, (targetToSourceExports.get(exportDeclaration) || /* @__PURE__ */ new Set()).add(declaration));
            });
            for (const [exportDeclaration, topLevelDeclarations] of arrayFrom(targetToSourceExports))if (exportDeclaration.exportClause && isNamedExports(exportDeclaration.exportClause) && length(exportDeclaration.exportClause.elements)) {
                const elements = exportDeclaration.exportClause.elements;
                const updatedElements = filter(elements, (elem)=>find(skipAlias(elem.symbol, checker).declarations, (d)=>isTopLevelDeclaration(d) && topLevelDeclarations.has(d)) === void 0);
                if (length(updatedElements) === 0) {
                    changes.deleteNode(targetFile, exportDeclaration);
                    removedExports.add(exportDeclaration);
                    continue;
                }
                if (length(updatedElements) < length(elements)) changes.replaceNode(targetFile, exportDeclaration, factory.updateExportDeclaration(exportDeclaration, exportDeclaration.modifiers, exportDeclaration.isTypeOnly, factory.updateNamedExports(exportDeclaration.exportClause, factory.createNodeArray(updatedElements, elements.hasTrailingComma)), exportDeclaration.moduleSpecifier, exportDeclaration.attributes));
            }
        }
        const lastReExport = findLast(targetFile.statements, (n)=>isExportDeclaration(n) && !!n.moduleSpecifier && !removedExports.has(n));
        if (lastReExport) changes.insertNodesBefore(targetFile, lastReExport, statements, /*blankLineBetween*/ true);
        else changes.insertNodesAfter(targetFile, targetFile.statements[targetFile.statements.length - 1], statements);
    }
    function getOverloadRangeToMove(sourceFile, statement) {
        if (isFunctionLikeDeclaration(statement)) {
            const declarations = statement.symbol.declarations;
            if (declarations === void 0 || length(declarations) <= 1 || !contains(declarations, statement)) return void 0;
            const firstDecl = declarations[0];
            const lastDecl = declarations[length(declarations) - 1];
            const statementsToMove = mapDefined(declarations, (d)=>getSourceFileOfNode(d) === sourceFile && isStatement(d) ? d : void 0);
            const end = findIndex(sourceFile.statements, (s)=>s.end >= lastDecl.end);
            const start = findIndex(sourceFile.statements, (s)=>s.end >= firstDecl.end);
            return {
                toMove: statementsToMove,
                start,
                end
            };
        }
        return void 0;
    }
    function getExistingLocals(sourceFile, statements, checker) {
        const existingLocals = /* @__PURE__ */ new Set();
        for (const moduleSpecifier of sourceFile.imports){
            const declaration = importFromModuleSpecifier(moduleSpecifier);
            if (isImportDeclaration(declaration) && declaration.importClause && declaration.importClause.namedBindings && isNamedImports(declaration.importClause.namedBindings)) for (const e of declaration.importClause.namedBindings.elements){
                const symbol = checker.getSymbolAtLocation(e.propertyName || e.name);
                if (symbol) existingLocals.add(skipAlias(symbol, checker));
            }
            if (isVariableDeclarationInitializedToRequire(declaration.parent) && isObjectBindingPattern(declaration.parent.name)) for (const e of declaration.parent.name.elements){
                const symbol = checker.getSymbolAtLocation(e.propertyName || e.name);
                if (symbol) existingLocals.add(skipAlias(symbol, checker));
            }
        }
        for (const statement of statements)forEachReference(statement, checker, /*enclosingRange*/ void 0, (s)=>{
            const symbol = skipAlias(s, checker);
            if (symbol.valueDeclaration && getSourceFileOfNode(symbol.valueDeclaration).path === sourceFile.path) existingLocals.add(symbol);
        });
        return existingLocals;
    }
    // src/services/refactors/helpers.ts
    function isRefactorErrorInfo(info) {
        return info.error !== void 0;
    }
    function refactorKindBeginsWith(known, requested) {
        if (!requested) return true;
        return known.substr(0, requested.length) === requested;
    }
    function getIdentifierForNode(node, scope, checker, file) {
        return isPropertyAccessExpression(node) && !isClassLike(scope) && !checker.resolveName(node.name.text, node, 111551 /* Value */ , /*excludeGlobals*/ false) && !isPrivateIdentifier(node.name) && !identifierToKeywordKind(node.name) ? node.name.text : getUniqueName(isClassLike(scope) ? "newProperty" : "newLocal", file);
    }
    function addTargetFileImports(oldFile, importsToCopy, targetFileImportsFromOldFile, checker, program, importAdder) {
        importsToCopy.forEach(([isValidTypeOnlyUseSite, declaration], symbol)=>{
            var _a;
            const targetSymbol = skipAlias(symbol, checker);
            if (checker.isUnknownSymbol(targetSymbol)) importAdder.addVerbatimImport(Debug.checkDefined(declaration !== null && declaration !== void 0 ? declaration : findAncestor((_a = symbol.declarations) == null ? void 0 : _a[0], isAnyImportOrRequireStatement)));
            else if (targetSymbol.parent === void 0) {
                Debug.assert(declaration !== void 0, "expected module symbol to have a declaration");
                importAdder.addImportForModuleSymbol(symbol, isValidTypeOnlyUseSite, declaration);
            } else importAdder.addImportFromExportedSymbol(targetSymbol, isValidTypeOnlyUseSite, declaration);
        });
        addImportsForMovedSymbols(targetFileImportsFromOldFile, oldFile.fileName, importAdder, program);
    }
    // src/services/refactors/inlineVariable.ts
    var refactorName4 = "Inline variable";
    var refactorDescription = getLocaleSpecificMessage(Diagnostics.Inline_variable);
    var inlineVariableAction = {
        name: refactorName4,
        description: refactorDescription,
        kind: "refactor.inline.variable"
    };
    registerRefactor(refactorName4, {
        kinds: [
            inlineVariableAction.kind
        ],
        getAvailableActions (context) {
            const { file, program, preferences, startPosition, triggerReason } = context;
            const info = getInliningInfo(file, startPosition, triggerReason === "invoked", program);
            if (!info) return emptyArray;
            if (!ts_refactor_exports.isRefactorErrorInfo(info)) return [
                {
                    name: refactorName4,
                    description: refactorDescription,
                    actions: [
                        inlineVariableAction
                    ]
                }
            ];
            if (preferences.provideRefactorNotApplicableReason) return [
                {
                    name: refactorName4,
                    description: refactorDescription,
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, inlineVariableAction), {
                            notApplicableReason: info.error
                        })
                    ]
                }
            ];
            return emptyArray;
        },
        getEditsForAction (context, actionName2) {
            Debug.assert(actionName2 === refactorName4, "Unexpected refactor invoked");
            const { file, program, startPosition } = context;
            const info = getInliningInfo(file, startPosition, /*tryWithReferenceToken*/ true, program);
            if (!info || ts_refactor_exports.isRefactorErrorInfo(info)) return void 0;
            const { references, declaration, replacement } = info;
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (tracker)=>{
                for (const node of references){
                    const closestStringIdentifierParent = isStringLiteral(replacement) && isIdentifier(node) && walkUpParenthesizedExpressions(node.parent);
                    if (closestStringIdentifierParent && isTemplateSpan(closestStringIdentifierParent) && !isTaggedTemplateExpression(closestStringIdentifierParent.parent.parent)) replaceTemplateStringVariableWithLiteral(tracker, file, closestStringIdentifierParent, replacement);
                    else tracker.replaceNode(file, node, getReplacementExpression(node, replacement));
                }
                tracker.delete(file, declaration);
            });
            return {
                edits
            };
        }
    });
    function getInliningInfo(file, startPosition, tryWithReferenceToken, program) {
        var _a, _b;
        const checker = program.getTypeChecker();
        const token = getTouchingPropertyName(file, startPosition);
        const parent2 = token.parent;
        if (!isIdentifier(token)) return void 0;
        if (isInitializedVariable(parent2) && isVariableDeclarationInVariableStatement(parent2) && isIdentifier(parent2.name)) {
            if (((_a = checker.getMergedSymbol(parent2.symbol).declarations) == null ? void 0 : _a.length) !== 1) return {
                error: getLocaleSpecificMessage(Diagnostics.Variables_with_multiple_declarations_cannot_be_inlined)
            };
            if (isDeclarationExported(parent2)) return void 0;
            const references = getReferenceNodes(parent2, checker, file);
            return references && {
                references,
                declaration: parent2,
                replacement: parent2.initializer
            };
        }
        if (tryWithReferenceToken) {
            let definition = checker.resolveName(token.text, token, 111551 /* Value */ , /*excludeGlobals*/ false);
            definition = definition && checker.getMergedSymbol(definition);
            if (((_b = definition == null ? void 0 : definition.declarations) == null ? void 0 : _b.length) !== 1) return {
                error: getLocaleSpecificMessage(Diagnostics.Variables_with_multiple_declarations_cannot_be_inlined)
            };
            const declaration = definition.declarations[0];
            if (!isInitializedVariable(declaration) || !isVariableDeclarationInVariableStatement(declaration) || !isIdentifier(declaration.name)) return void 0;
            if (isDeclarationExported(declaration)) return void 0;
            const references = getReferenceNodes(declaration, checker, file);
            return references && {
                references,
                declaration,
                replacement: declaration.initializer
            };
        }
        return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_variable_to_inline)
        };
    }
    function isDeclarationExported(declaration) {
        const variableStatement = cast(declaration.parent.parent, isVariableStatement);
        return some(variableStatement.modifiers, isExportModifier);
    }
    function getReferenceNodes(declaration, checker, file) {
        const references = [];
        const cannotInline = ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(declaration.name, checker, file, (ref)=>{
            if (ts_FindAllReferences_exports.isWriteAccessForReference(ref) && !isShorthandPropertyAssignment(ref.parent)) return true;
            if (isExportSpecifier(ref.parent) || isExportAssignment(ref.parent)) return true;
            if (isTypeQueryNode(ref.parent)) return true;
            if (textRangeContainsPositionInclusive(declaration, ref.pos)) return true;
            references.push(ref);
        });
        return references.length === 0 || cannotInline ? void 0 : references;
    }
    function getReplacementExpression(reference, replacement) {
        replacement = getSynthesizedDeepClone(replacement);
        const { parent: parent2 } = reference;
        if (isExpression(parent2) && (getExpressionPrecedence(replacement) < getExpressionPrecedence(parent2) || needsParentheses(parent2))) return factory.createParenthesizedExpression(replacement);
        if (isFunctionLike(replacement) && (isCallLikeExpression(parent2) || isPropertyAccessExpression(parent2))) return factory.createParenthesizedExpression(replacement);
        if (isPropertyAccessExpression(parent2) && (isNumericLiteral(replacement) || isObjectLiteralExpression(replacement))) return factory.createParenthesizedExpression(replacement);
        if (isIdentifier(reference) && isShorthandPropertyAssignment(parent2)) return factory.createPropertyAssignment(reference, replacement);
        return replacement;
    }
    function replaceTemplateStringVariableWithLiteral(tracker, sourceFile, reference, replacement) {
        const templateExpression = reference.parent;
        const index = templateExpression.templateSpans.indexOf(reference);
        const prevNode = index === 0 ? templateExpression.head : templateExpression.templateSpans[index - 1];
        tracker.replaceRangeWithText(sourceFile, {
            pos: prevNode.getEnd() - 2,
            end: reference.literal.getStart() + 1
        }, replacement.text.replace(/\\/g, "\\\\").replace(/`/g, "\\`"));
    }
    // src/services/refactors/moveToNewFile.ts
    var refactorName5 = "Move to a new file";
    var description2 = getLocaleSpecificMessage(Diagnostics.Move_to_a_new_file);
    var moveToNewFileAction = {
        name: refactorName5,
        description: description2,
        kind: "refactor.move.newFile"
    };
    registerRefactor(refactorName5, {
        kinds: [
            moveToNewFileAction.kind
        ],
        getAvailableActions: function getRefactorActionsToMoveToNewFile(context) {
            const statements = getStatementsToMove(context);
            const file = context.file;
            if (context.triggerReason === "implicit" && context.endPosition !== void 0) {
                const startNodeAncestor = findAncestor(getTokenAtPosition(file, context.startPosition), isBlockLike);
                const endNodeAncestor = findAncestor(getTokenAtPosition(file, context.endPosition), isBlockLike);
                if (startNodeAncestor && !isSourceFile(startNodeAncestor) && endNodeAncestor && !isSourceFile(endNodeAncestor)) return emptyArray;
            }
            if (context.preferences.allowTextChangesInNewFiles && statements) {
                const file2 = context.file;
                const affectedTextRange = {
                    start: {
                        line: getLineAndCharacterOfPosition(file2, statements.all[0].getStart(file2)).line,
                        offset: getLineAndCharacterOfPosition(file2, statements.all[0].getStart(file2)).character
                    },
                    end: {
                        line: getLineAndCharacterOfPosition(file2, last(statements.all).end).line,
                        offset: getLineAndCharacterOfPosition(file2, last(statements.all).end).character
                    }
                };
                return [
                    {
                        name: refactorName5,
                        description: description2,
                        actions: [
                            (0, _objectSpreadProps._)((0, _objectSpread._)({}, moveToNewFileAction), {
                                range: affectedTextRange
                            })
                        ]
                    }
                ];
            }
            if (context.preferences.provideRefactorNotApplicableReason) return [
                {
                    name: refactorName5,
                    description: description2,
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, moveToNewFileAction), {
                            notApplicableReason: getLocaleSpecificMessage(Diagnostics.Selection_is_not_a_valid_statement_or_statements)
                        })
                    ]
                }
            ];
            return emptyArray;
        },
        getEditsForAction: function getRefactorEditsToMoveToNewFile(context, actionName2) {
            Debug.assert(actionName2 === refactorName5, "Wrong refactor invoked");
            const statements = Debug.checkDefined(getStatementsToMove(context));
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange4(context.file, context.program, statements, t, context.host, context, context.preferences));
            return {
                edits,
                renameFilename: void 0,
                renameLocation: void 0
            };
        }
    });
    function doChange4(oldFile, program, toMove, changes, host, context, preferences) {
        const checker = program.getTypeChecker();
        const usage = getUsageInfo(oldFile, toMove.all, checker);
        const newFilename = createNewFileName(oldFile, program, host, toMove);
        const newSourceFile = createFutureSourceFile(newFilename, oldFile.externalModuleIndicator ? 99 /* ESNext */  : oldFile.commonJsModuleIndicator ? 1 /* CommonJS */  : void 0, program, host);
        const importAdderForOldFile = ts_codefix_exports.createImportAdder(oldFile, context.program, context.preferences, context.host);
        const importAdderForNewFile = ts_codefix_exports.createImportAdder(newSourceFile, context.program, context.preferences, context.host);
        getNewStatementsAndRemoveFromOldFile(oldFile, newSourceFile, usage, changes, toMove, program, host, preferences, importAdderForNewFile, importAdderForOldFile);
        addNewFileToTsconfig(program, changes, oldFile.fileName, newFilename, hostGetCanonicalFileName(host));
    }
    // src/services/_namespaces/ts.refactor.addOrRemoveBracesToArrowFunction.ts
    var ts_refactor_addOrRemoveBracesToArrowFunction_exports = {};
    // src/services/refactors/convertOverloadListToSingleSignature.ts
    var refactorName6 = "Convert overload list to single signature";
    var refactorDescription2 = getLocaleSpecificMessage(Diagnostics.Convert_overload_list_to_single_signature);
    var functionOverloadAction = {
        name: refactorName6,
        description: refactorDescription2,
        kind: "refactor.rewrite.function.overloadList"
    };
    registerRefactor(refactorName6, {
        kinds: [
            functionOverloadAction.kind
        ],
        getEditsForAction: getRefactorEditsToConvertOverloadsToOneSignature,
        getAvailableActions: getRefactorActionsToConvertOverloadsToOneSignature
    });
    function getRefactorActionsToConvertOverloadsToOneSignature(context) {
        const { file, startPosition, program } = context;
        const info = getConvertableOverloadListAtPosition(file, startPosition, program);
        if (!info) return emptyArray;
        return [
            {
                name: refactorName6,
                description: refactorDescription2,
                actions: [
                    functionOverloadAction
                ]
            }
        ];
    }
    function getRefactorEditsToConvertOverloadsToOneSignature(context) {
        const { file, startPosition, program } = context;
        const signatureDecls = getConvertableOverloadListAtPosition(file, startPosition, program);
        if (!signatureDecls) return void 0;
        const checker = program.getTypeChecker();
        const lastDeclaration = signatureDecls[signatureDecls.length - 1];
        let updated = lastDeclaration;
        switch(lastDeclaration.kind){
            case 174 /* MethodSignature */ :
                updated = factory.updateMethodSignature(lastDeclaration, lastDeclaration.modifiers, lastDeclaration.name, lastDeclaration.questionToken, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type);
                break;
            case 175 /* MethodDeclaration */ :
                updated = factory.updateMethodDeclaration(lastDeclaration, lastDeclaration.modifiers, lastDeclaration.asteriskToken, lastDeclaration.name, lastDeclaration.questionToken, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type, lastDeclaration.body);
                break;
            case 180 /* CallSignature */ :
                updated = factory.updateCallSignature(lastDeclaration, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type);
                break;
            case 177 /* Constructor */ :
                updated = factory.updateConstructorDeclaration(lastDeclaration, lastDeclaration.modifiers, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.body);
                break;
            case 181 /* ConstructSignature */ :
                updated = factory.updateConstructSignature(lastDeclaration, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type);
                break;
            case 263 /* FunctionDeclaration */ :
                updated = factory.updateFunctionDeclaration(lastDeclaration, lastDeclaration.modifiers, lastDeclaration.asteriskToken, lastDeclaration.name, lastDeclaration.typeParameters, getNewParametersForCombinedSignature(signatureDecls), lastDeclaration.type, lastDeclaration.body);
                break;
            default:
                return Debug.failBadSyntaxKind(lastDeclaration, "Unhandled signature kind in overload list conversion refactoring");
        }
        if (updated === lastDeclaration) return;
        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
            t.replaceNodeRange(file, signatureDecls[0], signatureDecls[signatureDecls.length - 1], updated);
        });
        return {
            renameFilename: void 0,
            renameLocation: void 0,
            edits
        };
        function getNewParametersForCombinedSignature(signatureDeclarations) {
            const lastSig = signatureDeclarations[signatureDeclarations.length - 1];
            if (isFunctionLikeDeclaration(lastSig) && lastSig.body) signatureDeclarations = signatureDeclarations.slice(0, signatureDeclarations.length - 1);
            return factory.createNodeArray([
                factory.createParameterDeclaration(/*modifiers*/ void 0, factory.createToken(26 /* DotDotDotToken */ ), "args", /*questionToken*/ void 0, factory.createUnionTypeNode(map(signatureDeclarations, convertSignatureParametersToTuple)))
            ]);
        }
        function convertSignatureParametersToTuple(decl) {
            const members = map(decl.parameters, convertParameterToNamedTupleMember);
            return setEmitFlags(factory.createTupleTypeNode(members), some(members, (m)=>!!length(getSyntheticLeadingComments(m))) ? 0 /* None */  : 1 /* SingleLine */ );
        }
        function convertParameterToNamedTupleMember(p) {
            Debug.assert(isIdentifier(p.name));
            const result = setTextRange(factory.createNamedTupleMember(p.dotDotDotToken, p.name, p.questionToken, p.type || factory.createKeywordTypeNode(133 /* AnyKeyword */ )), p);
            const parameterDocComment = p.symbol && p.symbol.getDocumentationComment(checker);
            if (parameterDocComment) {
                const newComment = displayPartsToString(parameterDocComment);
                if (newComment.length) setSyntheticLeadingComments(result, [
                    {
                        text: `*
${newComment.split("\n").map((c)=>` * ${c}`).join("\n")}
 `,
                        kind: 3 /* MultiLineCommentTrivia */ ,
                        pos: -1,
                        end: -1,
                        hasTrailingNewLine: true,
                        hasLeadingNewline: true
                    }
                ]);
            }
            return result;
        }
    }
    function isConvertableSignatureDeclaration(d) {
        switch(d.kind){
            case 174 /* MethodSignature */ :
            case 175 /* MethodDeclaration */ :
            case 180 /* CallSignature */ :
            case 177 /* Constructor */ :
            case 181 /* ConstructSignature */ :
            case 263 /* FunctionDeclaration */ :
                return true;
        }
        return false;
    }
    function getConvertableOverloadListAtPosition(file, startPosition, program) {
        const node = getTokenAtPosition(file, startPosition);
        const containingDecl = findAncestor(node, isConvertableSignatureDeclaration);
        if (!containingDecl) return;
        if (isFunctionLikeDeclaration(containingDecl) && containingDecl.body && rangeContainsPosition(containingDecl.body, startPosition)) return;
        const checker = program.getTypeChecker();
        const signatureSymbol = containingDecl.symbol;
        if (!signatureSymbol) return;
        const decls = signatureSymbol.declarations;
        if (length(decls) <= 1) return;
        if (!every(decls, (d)=>getSourceFileOfNode(d) === file)) return;
        if (!isConvertableSignatureDeclaration(decls[0])) return;
        const kindOne = decls[0].kind;
        if (!every(decls, (d)=>d.kind === kindOne)) return;
        const signatureDecls = decls;
        if (some(signatureDecls, (d)=>!!d.typeParameters || some(d.parameters, (p)=>!!p.modifiers || !isIdentifier(p.name)))) return;
        const signatures = mapDefined(signatureDecls, (d)=>checker.getSignatureFromDeclaration(d));
        if (length(signatures) !== length(decls)) return;
        const returnOne = checker.getReturnTypeOfSignature(signatures[0]);
        if (!every(signatures, (s)=>checker.getReturnTypeOfSignature(s) === returnOne)) return;
        return signatureDecls;
    }
    // src/services/refactors/addOrRemoveBracesToArrowFunction.ts
    var refactorName7 = "Add or remove braces in an arrow function";
    var refactorDescription3 = getLocaleSpecificMessage(Diagnostics.Add_or_remove_braces_in_an_arrow_function);
    var addBracesAction = {
        name: "Add braces to arrow function",
        description: getLocaleSpecificMessage(Diagnostics.Add_braces_to_arrow_function),
        kind: "refactor.rewrite.arrow.braces.add"
    };
    var removeBracesAction = {
        name: "Remove braces from arrow function",
        description: getLocaleSpecificMessage(Diagnostics.Remove_braces_from_arrow_function),
        kind: "refactor.rewrite.arrow.braces.remove"
    };
    registerRefactor(refactorName7, {
        kinds: [
            removeBracesAction.kind
        ],
        getEditsForAction: getRefactorEditsToRemoveFunctionBraces,
        getAvailableActions: getRefactorActionsToRemoveFunctionBraces
    });
    function getRefactorActionsToRemoveFunctionBraces(context) {
        const { file, startPosition, triggerReason } = context;
        const info = getConvertibleArrowFunctionAtPosition(file, startPosition, triggerReason === "invoked");
        if (!info) return emptyArray;
        if (!isRefactorErrorInfo(info)) return [
            {
                name: refactorName7,
                description: refactorDescription3,
                actions: [
                    info.addBraces ? addBracesAction : removeBracesAction
                ]
            }
        ];
        if (context.preferences.provideRefactorNotApplicableReason) return [
            {
                name: refactorName7,
                description: refactorDescription3,
                actions: [
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, addBracesAction), {
                        notApplicableReason: info.error
                    }),
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, removeBracesAction), {
                        notApplicableReason: info.error
                    })
                ]
            }
        ];
        return emptyArray;
    }
    function getRefactorEditsToRemoveFunctionBraces(context, actionName2) {
        const { file, startPosition } = context;
        const info = getConvertibleArrowFunctionAtPosition(file, startPosition);
        Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
        const { expression, returnStatement, func } = info;
        let body;
        if (actionName2 === addBracesAction.name) {
            const returnStatement2 = factory.createReturnStatement(expression);
            body = factory.createBlock([
                returnStatement2
            ], /*multiLine*/ true);
            copyLeadingComments(expression, returnStatement2, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ true);
        } else if (actionName2 === removeBracesAction.name && returnStatement) {
            const actualExpression = expression || factory.createVoidZero();
            body = needsParentheses(actualExpression) ? factory.createParenthesizedExpression(actualExpression) : actualExpression;
            copyTrailingAsLeadingComments(returnStatement, body, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
            copyLeadingComments(returnStatement, body, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
            copyTrailingComments(returnStatement, body, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
        } else Debug.fail("invalid action");
        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
            t.replaceNode(file, func.body, body);
        });
        return {
            renameFilename: void 0,
            renameLocation: void 0,
            edits
        };
    }
    function getConvertibleArrowFunctionAtPosition(file, startPosition, considerFunctionBodies = true, kind) {
        const node = getTokenAtPosition(file, startPosition);
        const func = getContainingFunction(node);
        if (!func) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_a_containing_arrow_function)
        };
        if (!isArrowFunction(func)) return {
            error: getLocaleSpecificMessage(Diagnostics.Containing_function_is_not_an_arrow_function)
        };
        if (!rangeContainsRange(func, node) || rangeContainsRange(func.body, node) && !considerFunctionBodies) return void 0;
        if (refactorKindBeginsWith(addBracesAction.kind, kind) && isExpression(func.body)) return {
            func,
            addBraces: true,
            expression: func.body
        };
        else if (refactorKindBeginsWith(removeBracesAction.kind, kind) && isBlock(func.body) && func.body.statements.length === 1) {
            const firstStatement = first(func.body.statements);
            if (isReturnStatement(firstStatement)) {
                const expression = firstStatement.expression && isObjectLiteralExpression(getLeftmostExpression(firstStatement.expression, /*stopAtCallExpressions*/ false)) ? factory.createParenthesizedExpression(firstStatement.expression) : firstStatement.expression;
                return {
                    func,
                    addBraces: false,
                    expression,
                    returnStatement: firstStatement
                };
            }
        }
        return void 0;
    }
    // src/services/_namespaces/ts.refactor.convertArrowFunctionOrFunctionExpression.ts
    var ts_refactor_convertArrowFunctionOrFunctionExpression_exports = {};
    // src/services/refactors/convertArrowFunctionOrFunctionExpression.ts
    var refactorName8 = "Convert arrow function or function expression";
    var refactorDescription4 = getLocaleSpecificMessage(Diagnostics.Convert_arrow_function_or_function_expression);
    var toAnonymousFunctionAction = {
        name: "Convert to anonymous function",
        description: getLocaleSpecificMessage(Diagnostics.Convert_to_anonymous_function),
        kind: "refactor.rewrite.function.anonymous"
    };
    var toNamedFunctionAction = {
        name: "Convert to named function",
        description: getLocaleSpecificMessage(Diagnostics.Convert_to_named_function),
        kind: "refactor.rewrite.function.named"
    };
    var toArrowFunctionAction = {
        name: "Convert to arrow function",
        description: getLocaleSpecificMessage(Diagnostics.Convert_to_arrow_function),
        kind: "refactor.rewrite.function.arrow"
    };
    registerRefactor(refactorName8, {
        kinds: [
            toAnonymousFunctionAction.kind,
            toNamedFunctionAction.kind,
            toArrowFunctionAction.kind
        ],
        getEditsForAction: getRefactorEditsToConvertFunctionExpressions,
        getAvailableActions: getRefactorActionsToConvertFunctionExpressions
    });
    function getRefactorActionsToConvertFunctionExpressions(context) {
        const { file, startPosition, program, kind } = context;
        const info = getFunctionInfo(file, startPosition, program);
        if (!info) return emptyArray;
        const { selectedVariableDeclaration, func } = info;
        const possibleActions = [];
        const errors = [];
        if (refactorKindBeginsWith(toNamedFunctionAction.kind, kind)) {
            const error2 = selectedVariableDeclaration || isArrowFunction(func) && isVariableDeclaration(func.parent) ? void 0 : getLocaleSpecificMessage(Diagnostics.Could_not_convert_to_named_function);
            if (error2) errors.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, toNamedFunctionAction), {
                notApplicableReason: error2
            }));
            else possibleActions.push(toNamedFunctionAction);
        }
        if (refactorKindBeginsWith(toAnonymousFunctionAction.kind, kind)) {
            const error2 = !selectedVariableDeclaration && isArrowFunction(func) ? void 0 : getLocaleSpecificMessage(Diagnostics.Could_not_convert_to_anonymous_function);
            if (error2) errors.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, toAnonymousFunctionAction), {
                notApplicableReason: error2
            }));
            else possibleActions.push(toAnonymousFunctionAction);
        }
        if (refactorKindBeginsWith(toArrowFunctionAction.kind, kind)) {
            const error2 = isFunctionExpression(func) ? void 0 : getLocaleSpecificMessage(Diagnostics.Could_not_convert_to_arrow_function);
            if (error2) errors.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, toArrowFunctionAction), {
                notApplicableReason: error2
            }));
            else possibleActions.push(toArrowFunctionAction);
        }
        return [
            {
                name: refactorName8,
                description: refactorDescription4,
                actions: possibleActions.length === 0 && context.preferences.provideRefactorNotApplicableReason ? errors : possibleActions
            }
        ];
    }
    function getRefactorEditsToConvertFunctionExpressions(context, actionName2) {
        const { file, startPosition, program } = context;
        const info = getFunctionInfo(file, startPosition, program);
        if (!info) return void 0;
        const { func } = info;
        const edits = [];
        switch(actionName2){
            case toAnonymousFunctionAction.name:
                edits.push(...getEditInfoForConvertToAnonymousFunction(context, func));
                break;
            case toNamedFunctionAction.name:
                const variableInfo = getVariableInfo(func);
                if (!variableInfo) return void 0;
                edits.push(...getEditInfoForConvertToNamedFunction(context, func, variableInfo));
                break;
            case toArrowFunctionAction.name:
                if (!isFunctionExpression(func)) return void 0;
                edits.push(...getEditInfoForConvertToArrowFunction(context, func));
                break;
            default:
                return Debug.fail("invalid action");
        }
        return {
            renameFilename: void 0,
            renameLocation: void 0,
            edits
        };
    }
    function containingThis(node) {
        let containsThis = false;
        node.forEachChild(function checkThis(child) {
            if (isThis(child)) {
                containsThis = true;
                return;
            }
            if (!isClassLike(child) && !isFunctionDeclaration(child) && !isFunctionExpression(child)) forEachChild(child, checkThis);
        });
        return containsThis;
    }
    function getFunctionInfo(file, startPosition, program) {
        const token = getTokenAtPosition(file, startPosition);
        const typeChecker = program.getTypeChecker();
        const func = tryGetFunctionFromVariableDeclaration(file, typeChecker, token.parent);
        if (func && !containingThis(func.body) && !typeChecker.containsArgumentsReference(func)) return {
            selectedVariableDeclaration: true,
            func
        };
        const maybeFunc = getContainingFunction(token);
        if (maybeFunc && (isFunctionExpression(maybeFunc) || isArrowFunction(maybeFunc)) && !rangeContainsRange(maybeFunc.body, token) && !containingThis(maybeFunc.body) && !typeChecker.containsArgumentsReference(maybeFunc)) {
            if (isFunctionExpression(maybeFunc) && isFunctionReferencedInFile(file, typeChecker, maybeFunc)) return void 0;
            return {
                selectedVariableDeclaration: false,
                func: maybeFunc
            };
        }
        return void 0;
    }
    function isSingleVariableDeclaration(parent2) {
        return isVariableDeclaration(parent2) || isVariableDeclarationList(parent2) && parent2.declarations.length === 1;
    }
    function tryGetFunctionFromVariableDeclaration(sourceFile, typeChecker, parent2) {
        if (!isSingleVariableDeclaration(parent2)) return void 0;
        const variableDeclaration = isVariableDeclaration(parent2) ? parent2 : first(parent2.declarations);
        const initializer = variableDeclaration.initializer;
        if (initializer && (isArrowFunction(initializer) || isFunctionExpression(initializer) && !isFunctionReferencedInFile(sourceFile, typeChecker, initializer))) return initializer;
        return void 0;
    }
    function convertToBlock(body) {
        if (isExpression(body)) {
            const returnStatement = factory.createReturnStatement(body);
            const file = body.getSourceFile();
            setTextRange(returnStatement, body);
            suppressLeadingAndTrailingTrivia(returnStatement);
            copyTrailingAsLeadingComments(body, returnStatement, file, /*commentKind*/ void 0, /*hasTrailingNewLine*/ true);
            return factory.createBlock([
                returnStatement
            ], /*multiLine*/ true);
        } else return body;
    }
    function getVariableInfo(func) {
        const variableDeclaration = func.parent;
        if (!isVariableDeclaration(variableDeclaration) || !isVariableDeclarationInVariableStatement(variableDeclaration)) return void 0;
        const variableDeclarationList = variableDeclaration.parent;
        const statement = variableDeclarationList.parent;
        if (!isVariableDeclarationList(variableDeclarationList) || !isVariableStatement(statement) || !isIdentifier(variableDeclaration.name)) return void 0;
        return {
            variableDeclaration,
            variableDeclarationList,
            statement,
            name: variableDeclaration.name
        };
    }
    function getEditInfoForConvertToAnonymousFunction(context, func) {
        const { file } = context;
        const body = convertToBlock(func.body);
        const newNode = factory.createFunctionExpression(func.modifiers, func.asteriskToken, /*name*/ void 0, func.typeParameters, func.parameters, func.type, body);
        return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, func, newNode));
    }
    function getEditInfoForConvertToNamedFunction(context, func, variableInfo) {
        const { file } = context;
        const body = convertToBlock(func.body);
        const { variableDeclaration, variableDeclarationList, statement, name } = variableInfo;
        suppressLeadingTrivia(statement);
        const modifiersFlags = getCombinedModifierFlags(variableDeclaration) & 32 /* Export */  | getEffectiveModifierFlags(func);
        const modifiers = factory.createModifiersFromModifierFlags(modifiersFlags);
        const newNode = factory.createFunctionDeclaration(length(modifiers) ? modifiers : void 0, func.asteriskToken, name, func.typeParameters, func.parameters, func.type, body);
        if (variableDeclarationList.declarations.length === 1) return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, statement, newNode));
        else return ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
            t.delete(file, variableDeclaration);
            t.insertNodeAfter(file, statement, newNode);
        });
    }
    function getEditInfoForConvertToArrowFunction(context, func) {
        const { file } = context;
        const statements = func.body.statements;
        const head = statements[0];
        let body;
        if (canBeConvertedToExpression(func.body, head)) {
            body = head.expression;
            suppressLeadingAndTrailingTrivia(body);
            copyComments(head, body);
        } else body = func.body;
        const newNode = factory.createArrowFunction(func.modifiers, func.typeParameters, func.parameters, func.type, factory.createToken(39 /* EqualsGreaterThanToken */ ), body);
        return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, func, newNode));
    }
    function canBeConvertedToExpression(body, head) {
        return body.statements.length === 1 && isReturnStatement(head) && !!head.expression;
    }
    function isFunctionReferencedInFile(sourceFile, typeChecker, node) {
        return !!node.name && ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(node.name, typeChecker, sourceFile);
    }
    // src/services/_namespaces/ts.refactor.convertParamsToDestructuredObject.ts
    var ts_refactor_convertParamsToDestructuredObject_exports = {};
    // src/services/refactors/convertParamsToDestructuredObject.ts
    var refactorName9 = "Convert parameters to destructured object";
    var minimumParameterLength = 1;
    var refactorDescription5 = getLocaleSpecificMessage(Diagnostics.Convert_parameters_to_destructured_object);
    var toDestructuredAction = {
        name: refactorName9,
        description: refactorDescription5,
        kind: "refactor.rewrite.parameters.toDestructured"
    };
    registerRefactor(refactorName9, {
        kinds: [
            toDestructuredAction.kind
        ],
        getEditsForAction: getRefactorEditsToConvertParametersToDestructuredObject,
        getAvailableActions: getRefactorActionsToConvertParametersToDestructuredObject
    });
    function getRefactorActionsToConvertParametersToDestructuredObject(context) {
        const { file, startPosition } = context;
        const isJSFile = isSourceFileJS(file);
        if (isJSFile) return emptyArray;
        const functionDeclaration = getFunctionDeclarationAtPosition(file, startPosition, context.program.getTypeChecker());
        if (!functionDeclaration) return emptyArray;
        return [
            {
                name: refactorName9,
                description: refactorDescription5,
                actions: [
                    toDestructuredAction
                ]
            }
        ];
    }
    function getRefactorEditsToConvertParametersToDestructuredObject(context, actionName2) {
        Debug.assert(actionName2 === refactorName9, "Unexpected action name");
        const { file, startPosition, program, cancellationToken, host } = context;
        const functionDeclaration = getFunctionDeclarationAtPosition(file, startPosition, program.getTypeChecker());
        if (!functionDeclaration || !cancellationToken) return void 0;
        const groupedReferences = getGroupedReferences(functionDeclaration, program, cancellationToken);
        if (groupedReferences.valid) {
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange5(file, program, host, t, functionDeclaration, groupedReferences));
            return {
                renameFilename: void 0,
                renameLocation: void 0,
                edits
            };
        }
        return {
            edits: []
        };
    }
    function doChange5(sourceFile, program, host, changes, functionDeclaration, groupedReferences) {
        const signature = groupedReferences.signature;
        const newFunctionDeclarationParams = map(createNewParameters(functionDeclaration, program, host), (param)=>getSynthesizedDeepClone(param));
        if (signature) {
            const newSignatureParams = map(createNewParameters(signature, program, host), (param)=>getSynthesizedDeepClone(param));
            replaceParameters(signature, newSignatureParams);
        }
        replaceParameters(functionDeclaration, newFunctionDeclarationParams);
        const functionCalls = sortAndDeduplicate(groupedReferences.functionCalls, /*comparer*/ (a, b)=>compareValues(a.pos, b.pos));
        for (const call of functionCalls)if (call.arguments && call.arguments.length) {
            const newArgument = getSynthesizedDeepClone(createNewArgument(functionDeclaration, call.arguments), /*includeTrivia*/ true);
            changes.replaceNodeRange(getSourceFileOfNode(call), first(call.arguments), last(call.arguments), newArgument, {
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            });
        }
        function replaceParameters(declarationOrSignature, parameterDeclarations) {
            changes.replaceNodeRangeWithNodes(sourceFile, first(declarationOrSignature.parameters), last(declarationOrSignature.parameters), parameterDeclarations, {
                joiner: ", ",
                // indentation is set to 0 because otherwise the object parameter will be indented if there is a `this` parameter
                indentation: 0,
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            });
        }
    }
    function getGroupedReferences(functionDeclaration, program, cancellationToken) {
        const functionNames = getFunctionNames(functionDeclaration);
        const classNames = isConstructorDeclaration(functionDeclaration) ? getClassNames(functionDeclaration) : [];
        const names = deduplicate([
            ...functionNames,
            ...classNames
        ], equateValues);
        const checker = program.getTypeChecker();
        const references = flatMap(names, /*mapfn*/ (name)=>ts_FindAllReferences_exports.getReferenceEntriesForNode(-1, name, program, program.getSourceFiles(), cancellationToken));
        const groupedReferences = groupReferences(references);
        if (!every(groupedReferences.declarations, /*callback*/ (decl)=>contains(names, decl))) groupedReferences.valid = false;
        return groupedReferences;
        function groupReferences(referenceEntries) {
            const classReferences = {
                accessExpressions: [],
                typeUsages: []
            };
            const groupedReferences2 = {
                functionCalls: [],
                declarations: [],
                classReferences,
                valid: true
            };
            const functionSymbols = map(functionNames, getSymbolTargetAtLocation);
            const classSymbols = map(classNames, getSymbolTargetAtLocation);
            const isConstructor = isConstructorDeclaration(functionDeclaration);
            const contextualSymbols = map(functionNames, (name)=>getSymbolForContextualType(name, checker));
            for (const entry of referenceEntries){
                if (entry.kind === ts_FindAllReferences_exports.EntryKind.Span) {
                    groupedReferences2.valid = false;
                    continue;
                }
                if (contains(contextualSymbols, getSymbolTargetAtLocation(entry.node))) {
                    if (isValidMethodSignature(entry.node.parent)) {
                        groupedReferences2.signature = entry.node.parent;
                        continue;
                    }
                    const call = entryToFunctionCall(entry);
                    if (call) {
                        groupedReferences2.functionCalls.push(call);
                        continue;
                    }
                }
                const contextualSymbol = getSymbolForContextualType(entry.node, checker);
                if (contextualSymbol && contains(contextualSymbols, contextualSymbol)) {
                    const decl = entryToDeclaration(entry);
                    if (decl) {
                        groupedReferences2.declarations.push(decl);
                        continue;
                    }
                }
                if (contains(functionSymbols, getSymbolTargetAtLocation(entry.node)) || isNewExpressionTarget(entry.node)) {
                    const importOrExportReference = entryToImportOrExport(entry);
                    if (importOrExportReference) continue;
                    const decl = entryToDeclaration(entry);
                    if (decl) {
                        groupedReferences2.declarations.push(decl);
                        continue;
                    }
                    const call = entryToFunctionCall(entry);
                    if (call) {
                        groupedReferences2.functionCalls.push(call);
                        continue;
                    }
                }
                if (isConstructor && contains(classSymbols, getSymbolTargetAtLocation(entry.node))) {
                    const importOrExportReference = entryToImportOrExport(entry);
                    if (importOrExportReference) continue;
                    const decl = entryToDeclaration(entry);
                    if (decl) {
                        groupedReferences2.declarations.push(decl);
                        continue;
                    }
                    const accessExpression = entryToAccessExpression(entry);
                    if (accessExpression) {
                        classReferences.accessExpressions.push(accessExpression);
                        continue;
                    }
                    if (isClassDeclaration(functionDeclaration.parent)) {
                        const type = entryToType(entry);
                        if (type) {
                            classReferences.typeUsages.push(type);
                            continue;
                        }
                    }
                }
                groupedReferences2.valid = false;
            }
            return groupedReferences2;
        }
        function getSymbolTargetAtLocation(node) {
            const symbol = checker.getSymbolAtLocation(node);
            return symbol && getSymbolTarget(symbol, checker);
        }
    }
    function getSymbolForContextualType(node, checker) {
        const element = getContainingObjectLiteralElement(node);
        if (element) {
            const contextualType = checker.getContextualTypeForObjectLiteralElement(element);
            const symbol = contextualType == null ? void 0 : contextualType.getSymbol();
            if (symbol && !(getCheckFlags(symbol) & 6 /* Synthetic */ )) return symbol;
        }
    }
    function entryToImportOrExport(entry) {
        const node = entry.node;
        if (isImportSpecifier(node.parent) || isImportClause(node.parent) || isImportEqualsDeclaration(node.parent) || isNamespaceImport(node.parent)) return node;
        if (isExportSpecifier(node.parent) || isExportAssignment(node.parent)) return node;
        return void 0;
    }
    function entryToDeclaration(entry) {
        if (isDeclaration(entry.node.parent)) return entry.node;
        return void 0;
    }
    function entryToFunctionCall(entry) {
        if (entry.node.parent) {
            const functionReference = entry.node;
            const parent2 = functionReference.parent;
            switch(parent2.kind){
                // foo(...) or super(...) or new Foo(...)
                case 214 /* CallExpression */ :
                case 215 /* NewExpression */ :
                    const callOrNewExpression = tryCast(parent2, isCallOrNewExpression);
                    if (callOrNewExpression && callOrNewExpression.expression === functionReference) return callOrNewExpression;
                    break;
                // x.foo(...)
                case 212 /* PropertyAccessExpression */ :
                    const propertyAccessExpression = tryCast(parent2, isPropertyAccessExpression);
                    if (propertyAccessExpression && propertyAccessExpression.parent && propertyAccessExpression.name === functionReference) {
                        const callOrNewExpression2 = tryCast(propertyAccessExpression.parent, isCallOrNewExpression);
                        if (callOrNewExpression2 && callOrNewExpression2.expression === propertyAccessExpression) return callOrNewExpression2;
                    }
                    break;
                // x["foo"](...)
                case 213 /* ElementAccessExpression */ :
                    const elementAccessExpression = tryCast(parent2, isElementAccessExpression);
                    if (elementAccessExpression && elementAccessExpression.parent && elementAccessExpression.argumentExpression === functionReference) {
                        const callOrNewExpression2 = tryCast(elementAccessExpression.parent, isCallOrNewExpression);
                        if (callOrNewExpression2 && callOrNewExpression2.expression === elementAccessExpression) return callOrNewExpression2;
                    }
                    break;
            }
        }
        return void 0;
    }
    function entryToAccessExpression(entry) {
        if (entry.node.parent) {
            const reference = entry.node;
            const parent2 = reference.parent;
            switch(parent2.kind){
                // `C.foo`
                case 212 /* PropertyAccessExpression */ :
                    const propertyAccessExpression = tryCast(parent2, isPropertyAccessExpression);
                    if (propertyAccessExpression && propertyAccessExpression.expression === reference) return propertyAccessExpression;
                    break;
                // `C["foo"]`
                case 213 /* ElementAccessExpression */ :
                    const elementAccessExpression = tryCast(parent2, isElementAccessExpression);
                    if (elementAccessExpression && elementAccessExpression.expression === reference) return elementAccessExpression;
                    break;
            }
        }
        return void 0;
    }
    function entryToType(entry) {
        const reference = entry.node;
        if (getMeaningFromLocation(reference) === 2 /* Type */  || isExpressionWithTypeArgumentsInClassExtendsClause(reference.parent)) return reference;
        return void 0;
    }
    function getFunctionDeclarationAtPosition(file, startPosition, checker) {
        const node = getTouchingToken(file, startPosition);
        const functionDeclaration = getContainingFunctionDeclaration(node);
        if (isTopLevelJSDoc(node)) return void 0;
        if (functionDeclaration && isValidFunctionDeclaration(functionDeclaration, checker) && rangeContainsRange(functionDeclaration, node) && !(functionDeclaration.body && rangeContainsRange(functionDeclaration.body, node))) return functionDeclaration;
        return void 0;
    }
    function isTopLevelJSDoc(node) {
        const containingJSDoc = findAncestor(node, isJSDocNode);
        if (containingJSDoc) {
            const containingNonJSDoc = findAncestor(containingJSDoc, (n)=>!isJSDocNode(n));
            return !!containingNonJSDoc && isFunctionLikeDeclaration(containingNonJSDoc);
        }
        return false;
    }
    function isValidMethodSignature(node) {
        return isMethodSignature(node) && (isInterfaceDeclaration(node.parent) || isTypeLiteralNode(node.parent));
    }
    function isValidFunctionDeclaration(functionDeclaration, checker) {
        var _a;
        if (!isValidParameterNodeArray(functionDeclaration.parameters, checker)) return false;
        switch(functionDeclaration.kind){
            case 263 /* FunctionDeclaration */ :
                return hasNameOrDefault(functionDeclaration) && isSingleImplementation(functionDeclaration, checker);
            case 175 /* MethodDeclaration */ :
                if (isObjectLiteralExpression(functionDeclaration.parent)) {
                    const contextualSymbol = getSymbolForContextualType(functionDeclaration.name, checker);
                    return ((_a = contextualSymbol == null ? void 0 : contextualSymbol.declarations) == null ? void 0 : _a.length) === 1 && isSingleImplementation(functionDeclaration, checker);
                }
                return isSingleImplementation(functionDeclaration, checker);
            case 177 /* Constructor */ :
                if (isClassDeclaration(functionDeclaration.parent)) return hasNameOrDefault(functionDeclaration.parent) && isSingleImplementation(functionDeclaration, checker);
                else return isValidVariableDeclaration(functionDeclaration.parent.parent) && isSingleImplementation(functionDeclaration, checker);
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return isValidVariableDeclaration(functionDeclaration.parent);
        }
        return false;
    }
    function isSingleImplementation(functionDeclaration, checker) {
        return !!functionDeclaration.body && !checker.isImplementationOfOverload(functionDeclaration);
    }
    function hasNameOrDefault(functionOrClassDeclaration) {
        if (!functionOrClassDeclaration.name) {
            const defaultKeyword = findModifier(functionOrClassDeclaration, 90 /* DefaultKeyword */ );
            return !!defaultKeyword;
        }
        return true;
    }
    function isValidParameterNodeArray(parameters, checker) {
        return getRefactorableParametersLength(parameters) >= minimumParameterLength && every(parameters, /*callback*/ (paramDecl)=>isValidParameterDeclaration(paramDecl, checker));
    }
    function isValidParameterDeclaration(parameterDeclaration, checker) {
        if (isRestParameter(parameterDeclaration)) {
            const type = checker.getTypeAtLocation(parameterDeclaration);
            if (!checker.isArrayType(type) && !checker.isTupleType(type)) return false;
        }
        return !parameterDeclaration.modifiers && isIdentifier(parameterDeclaration.name);
    }
    function isValidVariableDeclaration(node) {
        return isVariableDeclaration(node) && isVarConst(node) && isIdentifier(node.name) && !node.type;
    }
    function hasThisParameter(parameters) {
        return parameters.length > 0 && isThis(parameters[0].name);
    }
    function getRefactorableParametersLength(parameters) {
        if (hasThisParameter(parameters)) return parameters.length - 1;
        return parameters.length;
    }
    function getRefactorableParameters(parameters) {
        if (hasThisParameter(parameters)) parameters = factory.createNodeArray(parameters.slice(1), parameters.hasTrailingComma);
        return parameters;
    }
    function createPropertyOrShorthandAssignment(name, initializer) {
        if (isIdentifier(initializer) && getTextOfIdentifierOrLiteral(initializer) === name) return factory.createShorthandPropertyAssignment(name);
        return factory.createPropertyAssignment(name, initializer);
    }
    function createNewArgument(functionDeclaration, functionArguments) {
        const parameters = getRefactorableParameters(functionDeclaration.parameters);
        const hasRestParameter2 = isRestParameter(last(parameters));
        const nonRestArguments = hasRestParameter2 ? functionArguments.slice(0, parameters.length - 1) : functionArguments;
        const properties = map(nonRestArguments, (arg, i)=>{
            const parameterName = getParameterName(parameters[i]);
            const property = createPropertyOrShorthandAssignment(parameterName, arg);
            suppressLeadingAndTrailingTrivia(property.name);
            if (isPropertyAssignment(property)) suppressLeadingAndTrailingTrivia(property.initializer);
            copyComments(arg, property);
            return property;
        });
        if (hasRestParameter2 && functionArguments.length >= parameters.length) {
            const restArguments = functionArguments.slice(parameters.length - 1);
            const restProperty = factory.createPropertyAssignment(getParameterName(last(parameters)), factory.createArrayLiteralExpression(restArguments));
            properties.push(restProperty);
        }
        const objectLiteral = factory.createObjectLiteralExpression(properties, /*multiLine*/ false);
        return objectLiteral;
    }
    function createNewParameters(functionDeclaration, program, host) {
        const checker = program.getTypeChecker();
        const refactorableParameters = getRefactorableParameters(functionDeclaration.parameters);
        const bindingElements = map(refactorableParameters, createBindingElementFromParameterDeclaration);
        const objectParameterName = factory.createObjectBindingPattern(bindingElements);
        const objectParameterType = createParameterTypeNode(refactorableParameters);
        let objectInitializer;
        if (every(refactorableParameters, isOptionalParameter)) objectInitializer = factory.createObjectLiteralExpression();
        const objectParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, objectParameterName, /*questionToken*/ void 0, objectParameterType, objectInitializer);
        if (hasThisParameter(functionDeclaration.parameters)) {
            const thisParameter = functionDeclaration.parameters[0];
            const newThisParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, thisParameter.name, /*questionToken*/ void 0, thisParameter.type);
            suppressLeadingAndTrailingTrivia(newThisParameter.name);
            copyComments(thisParameter.name, newThisParameter.name);
            if (thisParameter.type) {
                suppressLeadingAndTrailingTrivia(newThisParameter.type);
                copyComments(thisParameter.type, newThisParameter.type);
            }
            return factory.createNodeArray([
                newThisParameter,
                objectParameter
            ]);
        }
        return factory.createNodeArray([
            objectParameter
        ]);
        function createBindingElementFromParameterDeclaration(parameterDeclaration) {
            const element = factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, getParameterName(parameterDeclaration), isRestParameter(parameterDeclaration) && isOptionalParameter(parameterDeclaration) ? factory.createArrayLiteralExpression() : parameterDeclaration.initializer);
            suppressLeadingAndTrailingTrivia(element);
            if (parameterDeclaration.initializer && element.initializer) copyComments(parameterDeclaration.initializer, element.initializer);
            return element;
        }
        function createParameterTypeNode(parameters) {
            const members = map(parameters, createPropertySignatureFromParameterDeclaration);
            const typeNode = addEmitFlags(factory.createTypeLiteralNode(members), 1 /* SingleLine */ );
            return typeNode;
        }
        function createPropertySignatureFromParameterDeclaration(parameterDeclaration) {
            let parameterType = parameterDeclaration.type;
            if (!parameterType && (parameterDeclaration.initializer || isRestParameter(parameterDeclaration))) parameterType = getTypeNode3(parameterDeclaration);
            const propertySignature = factory.createPropertySignature(/*modifiers*/ void 0, getParameterName(parameterDeclaration), isOptionalParameter(parameterDeclaration) ? factory.createToken(58 /* QuestionToken */ ) : parameterDeclaration.questionToken, parameterType);
            suppressLeadingAndTrailingTrivia(propertySignature);
            copyComments(parameterDeclaration.name, propertySignature.name);
            if (parameterDeclaration.type && propertySignature.type) copyComments(parameterDeclaration.type, propertySignature.type);
            return propertySignature;
        }
        function getTypeNode3(node) {
            const type = checker.getTypeAtLocation(node);
            return getTypeNodeIfAccessible(type, node, program, host);
        }
        function isOptionalParameter(parameterDeclaration) {
            if (isRestParameter(parameterDeclaration)) {
                const type = checker.getTypeAtLocation(parameterDeclaration);
                return !checker.isTupleType(type);
            }
            return checker.isOptionalParameter(parameterDeclaration);
        }
    }
    function getParameterName(paramDeclaration) {
        return getTextOfIdentifierOrLiteral(paramDeclaration.name);
    }
    function getClassNames(constructorDeclaration) {
        switch(constructorDeclaration.parent.kind){
            case 264 /* ClassDeclaration */ :
                const classDeclaration = constructorDeclaration.parent;
                if (classDeclaration.name) return [
                    classDeclaration.name
                ];
                const defaultModifier = Debug.checkDefined(findModifier(classDeclaration, 90 /* DefaultKeyword */ ), "Nameless class declaration should be a default export");
                return [
                    defaultModifier
                ];
            case 232 /* ClassExpression */ :
                const classExpression = constructorDeclaration.parent;
                const variableDeclaration = constructorDeclaration.parent.parent;
                const className = classExpression.name;
                if (className) return [
                    className,
                    variableDeclaration.name
                ];
                return [
                    variableDeclaration.name
                ];
        }
    }
    function getFunctionNames(functionDeclaration) {
        switch(functionDeclaration.kind){
            case 263 /* FunctionDeclaration */ :
                if (functionDeclaration.name) return [
                    functionDeclaration.name
                ];
                const defaultModifier = Debug.checkDefined(findModifier(functionDeclaration, 90 /* DefaultKeyword */ ), "Nameless function declaration should be a default export");
                return [
                    defaultModifier
                ];
            case 175 /* MethodDeclaration */ :
                return [
                    functionDeclaration.name
                ];
            case 177 /* Constructor */ :
                const ctrKeyword = Debug.checkDefined(findChildOfKind(functionDeclaration, 137 /* ConstructorKeyword */ , functionDeclaration.getSourceFile()), "Constructor declaration should have constructor keyword");
                if (functionDeclaration.parent.kind === 232 /* ClassExpression */ ) {
                    const variableDeclaration = functionDeclaration.parent.parent;
                    return [
                        variableDeclaration.name,
                        ctrKeyword
                    ];
                }
                return [
                    ctrKeyword
                ];
            case 220 /* ArrowFunction */ :
                return [
                    functionDeclaration.parent.name
                ];
            case 219 /* FunctionExpression */ :
                if (functionDeclaration.name) return [
                    functionDeclaration.name,
                    functionDeclaration.parent.name
                ];
                return [
                    functionDeclaration.parent.name
                ];
            default:
                return Debug.assertNever(functionDeclaration, `Unexpected function declaration kind ${functionDeclaration.kind}`);
        }
    }
    // src/services/_namespaces/ts.refactor.convertStringOrTemplateLiteral.ts
    var ts_refactor_convertStringOrTemplateLiteral_exports = {};
    // src/services/refactors/convertStringOrTemplateLiteral.ts
    var refactorName10 = "Convert to template string";
    var refactorDescription6 = getLocaleSpecificMessage(Diagnostics.Convert_to_template_string);
    var convertStringAction = {
        name: refactorName10,
        description: refactorDescription6,
        kind: "refactor.rewrite.string"
    };
    registerRefactor(refactorName10, {
        kinds: [
            convertStringAction.kind
        ],
        getEditsForAction: getRefactorEditsToConvertToTemplateString,
        getAvailableActions: getRefactorActionsToConvertToTemplateString
    });
    function getRefactorActionsToConvertToTemplateString(context) {
        const { file, startPosition } = context;
        const node = getNodeOrParentOfParentheses(file, startPosition);
        const maybeBinary = getParentBinaryExpression(node);
        const nodeIsStringLiteral = isStringLiteral(maybeBinary);
        const refactorInfo = {
            name: refactorName10,
            description: refactorDescription6,
            actions: []
        };
        if (nodeIsStringLiteral && context.triggerReason !== "invoked") return emptyArray;
        if (isExpressionNode(maybeBinary) && (nodeIsStringLiteral || isBinaryExpression(maybeBinary) && treeToArray(maybeBinary).isValidConcatenation)) {
            refactorInfo.actions.push(convertStringAction);
            return [
                refactorInfo
            ];
        } else if (context.preferences.provideRefactorNotApplicableReason) {
            refactorInfo.actions.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, convertStringAction), {
                notApplicableReason: getLocaleSpecificMessage(Diagnostics.Can_only_convert_string_concatenations_and_string_literals)
            }));
            return [
                refactorInfo
            ];
        }
        return emptyArray;
    }
    function getNodeOrParentOfParentheses(file, startPosition) {
        const node = getTokenAtPosition(file, startPosition);
        const nestedBinary = getParentBinaryExpression(node);
        const isNonStringBinary = !treeToArray(nestedBinary).isValidConcatenation;
        if (isNonStringBinary && isParenthesizedExpression(nestedBinary.parent) && isBinaryExpression(nestedBinary.parent.parent)) return nestedBinary.parent.parent;
        return node;
    }
    function getRefactorEditsToConvertToTemplateString(context, actionName2) {
        const { file, startPosition } = context;
        const node = getNodeOrParentOfParentheses(file, startPosition);
        switch(actionName2){
            case refactorDescription6:
                return {
                    edits: getEditsForToTemplateLiteral(context, node)
                };
            default:
                return Debug.fail("invalid action");
        }
    }
    function getEditsForToTemplateLiteral(context, node) {
        const maybeBinary = getParentBinaryExpression(node);
        const file = context.file;
        const templateLiteral = nodesToTemplate(treeToArray(maybeBinary), file);
        const trailingCommentRanges = getTrailingCommentRanges(file.text, maybeBinary.end);
        if (trailingCommentRanges) {
            const lastComment = trailingCommentRanges[trailingCommentRanges.length - 1];
            const trailingRange = {
                pos: trailingCommentRanges[0].pos,
                end: lastComment.end
            };
            return ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                t.deleteRange(file, trailingRange);
                t.replaceNode(file, maybeBinary, templateLiteral);
            });
        } else return ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(file, maybeBinary, templateLiteral));
    }
    function isNotEqualsOperator(node) {
        return !(node.operatorToken.kind === 64 /* EqualsToken */  || node.operatorToken.kind === 65 /* PlusEqualsToken */ );
    }
    function getParentBinaryExpression(expr) {
        const container = findAncestor(expr.parent, (n)=>{
            switch(n.kind){
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    return false;
                case 229 /* TemplateExpression */ :
                case 227 /* BinaryExpression */ :
                    return !(isBinaryExpression(n.parent) && isNotEqualsOperator(n.parent));
                default:
                    return "quit";
            }
        });
        return container || expr;
    }
    function treeToArray(current) {
        const loop = (current2)=>{
            if (!isBinaryExpression(current2)) return {
                nodes: [
                    current2
                ],
                operators: [],
                validOperators: true,
                hasString: isStringLiteral(current2) || isNoSubstitutionTemplateLiteral(current2)
            };
            const { nodes: nodes2, operators: operators2, hasString: leftHasString, validOperators: leftOperatorValid } = loop(current2.left);
            if (!(leftHasString || isStringLiteral(current2.right) || isTemplateExpression(current2.right))) return {
                nodes: [
                    current2
                ],
                operators: [],
                hasString: false,
                validOperators: true
            };
            const currentOperatorValid = current2.operatorToken.kind === 40 /* PlusToken */ ;
            const validOperators2 = leftOperatorValid && currentOperatorValid;
            nodes2.push(current2.right);
            operators2.push(current2.operatorToken);
            return {
                nodes: nodes2,
                operators: operators2,
                hasString: true,
                validOperators: validOperators2
            };
        };
        const { nodes, operators, validOperators, hasString } = loop(current);
        return {
            nodes,
            operators,
            isValidConcatenation: validOperators && hasString
        };
    }
    var copyTrailingOperatorComments = (operators, file)=>(index, targetNode)=>{
            if (index < operators.length) copyTrailingComments(operators[index], targetNode, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
        };
    var copyCommentFromMultiNode = (nodes, file, copyOperatorComments)=>(indexes, targetNode)=>{
            while(indexes.length > 0){
                const index = indexes.shift();
                copyTrailingComments(nodes[index], targetNode, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
                copyOperatorComments(index, targetNode);
            }
        };
    function escapeRawStringForTemplate(s) {
        return s.replace(/\\.|[$`]/g, (m)=>m[0] === "\\" ? m : "\\" + m);
    }
    function getRawTextOfTemplate(node) {
        const rightShaving = isTemplateHead(node) || isTemplateMiddle(node) ? -2 : -1;
        return getTextOfNode(node).slice(1, rightShaving);
    }
    function concatConsecutiveString(index, nodes) {
        const indexes = [];
        let text = "", rawText = "";
        while(index < nodes.length){
            const node = nodes[index];
            if (isStringLiteralLike(node)) {
                text += node.text;
                rawText += escapeRawStringForTemplate(getTextOfNode(node).slice(1, -1));
                indexes.push(index);
                index++;
            } else if (isTemplateExpression(node)) {
                text += node.head.text;
                rawText += getRawTextOfTemplate(node.head);
                break;
            } else break;
        }
        return [
            index,
            text,
            rawText,
            indexes
        ];
    }
    function nodesToTemplate({ nodes, operators }, file) {
        const copyOperatorComments = copyTrailingOperatorComments(operators, file);
        const copyCommentFromStringLiterals = copyCommentFromMultiNode(nodes, file, copyOperatorComments);
        const [begin, headText, rawHeadText, headIndexes] = concatConsecutiveString(0, nodes);
        if (begin === nodes.length) {
            const noSubstitutionTemplateLiteral = factory.createNoSubstitutionTemplateLiteral(headText, rawHeadText);
            copyCommentFromStringLiterals(headIndexes, noSubstitutionTemplateLiteral);
            return noSubstitutionTemplateLiteral;
        }
        const templateSpans = [];
        const templateHead = factory.createTemplateHead(headText, rawHeadText);
        copyCommentFromStringLiterals(headIndexes, templateHead);
        for(let i = begin; i < nodes.length; i++){
            const currentNode = getExpressionFromParenthesesOrExpression(nodes[i]);
            copyOperatorComments(i, currentNode);
            const [newIndex, subsequentText, rawSubsequentText, stringIndexes] = concatConsecutiveString(i + 1, nodes);
            i = newIndex - 1;
            const isLast = i === nodes.length - 1;
            if (isTemplateExpression(currentNode)) {
                const spans = map(currentNode.templateSpans, (span, index)=>{
                    copyExpressionComments(span);
                    const isLastSpan = index === currentNode.templateSpans.length - 1;
                    const text = span.literal.text + (isLastSpan ? subsequentText : "");
                    const rawText = getRawTextOfTemplate(span.literal) + (isLastSpan ? rawSubsequentText : "");
                    return factory.createTemplateSpan(span.expression, isLast && isLastSpan ? factory.createTemplateTail(text, rawText) : factory.createTemplateMiddle(text, rawText));
                });
                templateSpans.push(...spans);
            } else {
                const templatePart = isLast ? factory.createTemplateTail(subsequentText, rawSubsequentText) : factory.createTemplateMiddle(subsequentText, rawSubsequentText);
                copyCommentFromStringLiterals(stringIndexes, templatePart);
                templateSpans.push(factory.createTemplateSpan(currentNode, templatePart));
            }
        }
        return factory.createTemplateExpression(templateHead, templateSpans);
    }
    function copyExpressionComments(node) {
        const file = node.getSourceFile();
        copyTrailingComments(node, node.expression, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
        copyTrailingAsLeadingComments(node.expression, node.expression, file, 3 /* MultiLineCommentTrivia */ , /*hasTrailingNewLine*/ false);
    }
    function getExpressionFromParenthesesOrExpression(node) {
        if (isParenthesizedExpression(node)) {
            copyExpressionComments(node);
            node = node.expression;
        }
        return node;
    }
    // src/services/_namespaces/ts.refactor.convertToOptionalChainExpression.ts
    var ts_refactor_convertToOptionalChainExpression_exports = {};
    // src/services/refactors/convertToOptionalChainExpression.ts
    var refactorName11 = "Convert to optional chain expression";
    var convertToOptionalChainExpressionMessage = getLocaleSpecificMessage(Diagnostics.Convert_to_optional_chain_expression);
    var toOptionalChainAction = {
        name: refactorName11,
        description: convertToOptionalChainExpressionMessage,
        kind: "refactor.rewrite.expression.optionalChain"
    };
    registerRefactor(refactorName11, {
        kinds: [
            toOptionalChainAction.kind
        ],
        getEditsForAction: getRefactorEditsToConvertToOptionalChain,
        getAvailableActions: getRefactorActionsToConvertToOptionalChain
    });
    function getRefactorActionsToConvertToOptionalChain(context) {
        const info = getInfo3(context, context.triggerReason === "invoked");
        if (!info) return emptyArray;
        if (!isRefactorErrorInfo(info)) return [
            {
                name: refactorName11,
                description: convertToOptionalChainExpressionMessage,
                actions: [
                    toOptionalChainAction
                ]
            }
        ];
        if (context.preferences.provideRefactorNotApplicableReason) return [
            {
                name: refactorName11,
                description: convertToOptionalChainExpressionMessage,
                actions: [
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, toOptionalChainAction), {
                        notApplicableReason: info.error
                    })
                ]
            }
        ];
        return emptyArray;
    }
    function getRefactorEditsToConvertToOptionalChain(context, actionName2) {
        const info = getInfo3(context);
        Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
        const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange6(context.file, context.program.getTypeChecker(), t, info, actionName2));
        return {
            edits,
            renameFilename: void 0,
            renameLocation: void 0
        };
    }
    function isValidExpression(node) {
        return isBinaryExpression(node) || isConditionalExpression(node);
    }
    function isValidStatement(node) {
        return isExpressionStatement(node) || isReturnStatement(node) || isVariableStatement(node);
    }
    function isValidExpressionOrStatement(node) {
        return isValidExpression(node) || isValidStatement(node);
    }
    function getInfo3(context, considerEmptySpans = true) {
        const { file, program } = context;
        const span = getRefactorContextSpan(context);
        const forEmptySpan = span.length === 0;
        if (forEmptySpan && !considerEmptySpans) return void 0;
        const startToken = getTokenAtPosition(file, span.start);
        const endToken = findTokenOnLeftOfPosition(file, span.start + span.length);
        const adjustedSpan = createTextSpanFromBounds(startToken.pos, endToken && endToken.end >= startToken.pos ? endToken.getEnd() : startToken.getEnd());
        const parent2 = forEmptySpan ? getValidParentNodeOfEmptySpan(startToken) : getValidParentNodeContainingSpan(startToken, adjustedSpan);
        const expression = parent2 && isValidExpressionOrStatement(parent2) ? getExpression(parent2) : void 0;
        if (!expression) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_convertible_access_expression)
        };
        const checker = program.getTypeChecker();
        return isConditionalExpression(expression) ? getConditionalInfo(expression, checker) : getBinaryInfo(expression);
    }
    function getConditionalInfo(expression, checker) {
        const condition = expression.condition;
        const finalExpression = getFinalExpressionInChain(expression.whenTrue);
        if (!finalExpression || checker.isNullableType(checker.getTypeAtLocation(finalExpression))) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_convertible_access_expression)
        };
        if ((isPropertyAccessExpression(condition) || isIdentifier(condition)) && getMatchingStart(condition, finalExpression.expression)) return {
            finalExpression,
            occurrences: [
                condition
            ],
            expression
        };
        else if (isBinaryExpression(condition)) {
            const occurrences = getOccurrencesInExpression(finalExpression.expression, condition);
            return occurrences ? {
                finalExpression,
                occurrences,
                expression
            } : {
                error: getLocaleSpecificMessage(Diagnostics.Could_not_find_matching_access_expressions)
            };
        }
    }
    function getBinaryInfo(expression) {
        if (expression.operatorToken.kind !== 56 /* AmpersandAmpersandToken */ ) return {
            error: getLocaleSpecificMessage(Diagnostics.Can_only_convert_logical_AND_access_chains)
        };
        const finalExpression = getFinalExpressionInChain(expression.right);
        if (!finalExpression) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_convertible_access_expression)
        };
        const occurrences = getOccurrencesInExpression(finalExpression.expression, expression.left);
        return occurrences ? {
            finalExpression,
            occurrences,
            expression
        } : {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_matching_access_expressions)
        };
    }
    function getOccurrencesInExpression(matchTo, expression) {
        const occurrences = [];
        while(isBinaryExpression(expression) && expression.operatorToken.kind === 56 /* AmpersandAmpersandToken */ ){
            const match = getMatchingStart(skipParentheses(matchTo), skipParentheses(expression.right));
            if (!match) break;
            occurrences.push(match);
            matchTo = match;
            expression = expression.left;
        }
        const finalMatch = getMatchingStart(matchTo, expression);
        if (finalMatch) occurrences.push(finalMatch);
        return occurrences.length > 0 ? occurrences : void 0;
    }
    function getMatchingStart(chain, subchain) {
        if (!isIdentifier(subchain) && !isPropertyAccessExpression(subchain) && !isElementAccessExpression(subchain)) return void 0;
        return chainStartsWith(chain, subchain) ? subchain : void 0;
    }
    function chainStartsWith(chain, subchain) {
        while(isCallExpression(chain) || isPropertyAccessExpression(chain) || isElementAccessExpression(chain)){
            if (getTextOfChainNode(chain) === getTextOfChainNode(subchain)) break;
            chain = chain.expression;
        }
        while(isPropertyAccessExpression(chain) && isPropertyAccessExpression(subchain) || isElementAccessExpression(chain) && isElementAccessExpression(subchain)){
            if (getTextOfChainNode(chain) !== getTextOfChainNode(subchain)) return false;
            chain = chain.expression;
            subchain = subchain.expression;
        }
        return isIdentifier(chain) && isIdentifier(subchain) && chain.getText() === subchain.getText();
    }
    function getTextOfChainNode(node) {
        if (isIdentifier(node) || isStringOrNumericLiteralLike(node)) return node.getText();
        if (isPropertyAccessExpression(node)) return getTextOfChainNode(node.name);
        if (isElementAccessExpression(node)) return getTextOfChainNode(node.argumentExpression);
        return void 0;
    }
    function getValidParentNodeContainingSpan(node, span) {
        while(node.parent){
            if (isValidExpressionOrStatement(node) && span.length !== 0 && node.end >= span.start + span.length) return node;
            node = node.parent;
        }
        return void 0;
    }
    function getValidParentNodeOfEmptySpan(node) {
        while(node.parent){
            if (isValidExpressionOrStatement(node) && !isValidExpressionOrStatement(node.parent)) return node;
            node = node.parent;
        }
        return void 0;
    }
    function getExpression(node) {
        if (isValidExpression(node)) return node;
        if (isVariableStatement(node)) {
            const variable = getSingleVariableOfVariableStatement(node);
            const initializer = variable == null ? void 0 : variable.initializer;
            return initializer && isValidExpression(initializer) ? initializer : void 0;
        }
        return node.expression && isValidExpression(node.expression) ? node.expression : void 0;
    }
    function getFinalExpressionInChain(node) {
        node = skipParentheses(node);
        if (isBinaryExpression(node)) return getFinalExpressionInChain(node.left);
        else if ((isPropertyAccessExpression(node) || isElementAccessExpression(node) || isCallExpression(node)) && !isOptionalChain(node)) return node;
        return void 0;
    }
    function convertOccurrences(checker, toConvert, occurrences) {
        if (isPropertyAccessExpression(toConvert) || isElementAccessExpression(toConvert) || isCallExpression(toConvert)) {
            const chain = convertOccurrences(checker, toConvert.expression, occurrences);
            const lastOccurrence = occurrences.length > 0 ? occurrences[occurrences.length - 1] : void 0;
            const isOccurrence = (lastOccurrence == null ? void 0 : lastOccurrence.getText()) === toConvert.expression.getText();
            if (isOccurrence) occurrences.pop();
            if (isCallExpression(toConvert)) return isOccurrence ? factory.createCallChain(chain, factory.createToken(29 /* QuestionDotToken */ ), toConvert.typeArguments, toConvert.arguments) : factory.createCallChain(chain, toConvert.questionDotToken, toConvert.typeArguments, toConvert.arguments);
            else if (isPropertyAccessExpression(toConvert)) return isOccurrence ? factory.createPropertyAccessChain(chain, factory.createToken(29 /* QuestionDotToken */ ), toConvert.name) : factory.createPropertyAccessChain(chain, toConvert.questionDotToken, toConvert.name);
            else if (isElementAccessExpression(toConvert)) return isOccurrence ? factory.createElementAccessChain(chain, factory.createToken(29 /* QuestionDotToken */ ), toConvert.argumentExpression) : factory.createElementAccessChain(chain, toConvert.questionDotToken, toConvert.argumentExpression);
        }
        return toConvert;
    }
    function doChange6(sourceFile, checker, changes, info, _actionName) {
        const { finalExpression, occurrences, expression } = info;
        const firstOccurrence = occurrences[occurrences.length - 1];
        const convertedChain = convertOccurrences(checker, finalExpression, occurrences);
        if (convertedChain && (isPropertyAccessExpression(convertedChain) || isElementAccessExpression(convertedChain) || isCallExpression(convertedChain))) {
            if (isBinaryExpression(expression)) changes.replaceNodeRange(sourceFile, firstOccurrence, finalExpression, convertedChain);
            else if (isConditionalExpression(expression)) changes.replaceNode(sourceFile, expression, factory.createBinaryExpression(convertedChain, factory.createToken(61 /* QuestionQuestionToken */ ), expression.whenFalse));
        }
    }
    // src/services/_namespaces/ts.refactor.extractSymbol.ts
    var ts_refactor_extractSymbol_exports = {};
    __export(ts_refactor_extractSymbol_exports, {
        Messages: ()=>Messages,
        RangeFacts: ()=>RangeFacts,
        getRangeToExtract: ()=>getRangeToExtract2,
        getRefactorActionsToExtractSymbol: ()=>getRefactorActionsToExtractSymbol,
        getRefactorEditsToExtractSymbol: ()=>getRefactorEditsToExtractSymbol
    });
    // src/services/refactors/extractSymbol.ts
    var refactorName12 = "Extract Symbol";
    var extractConstantAction = {
        name: "Extract Constant",
        description: getLocaleSpecificMessage(Diagnostics.Extract_constant),
        kind: "refactor.extract.constant"
    };
    var extractFunctionAction = {
        name: "Extract Function",
        description: getLocaleSpecificMessage(Diagnostics.Extract_function),
        kind: "refactor.extract.function"
    };
    registerRefactor(refactorName12, {
        kinds: [
            extractConstantAction.kind,
            extractFunctionAction.kind
        ],
        getEditsForAction: getRefactorEditsToExtractSymbol,
        getAvailableActions: getRefactorActionsToExtractSymbol
    });
    function getRefactorActionsToExtractSymbol(context) {
        const requestedRefactor = context.kind;
        const rangeToExtract = getRangeToExtract2(context.file, getRefactorContextSpan(context), context.triggerReason === "invoked");
        const targetRange = rangeToExtract.targetRange;
        if (targetRange === void 0) {
            if (!rangeToExtract.errors || rangeToExtract.errors.length === 0 || !context.preferences.provideRefactorNotApplicableReason) return emptyArray;
            const errors = [];
            if (refactorKindBeginsWith(extractFunctionAction.kind, requestedRefactor)) errors.push({
                name: refactorName12,
                description: extractFunctionAction.description,
                actions: [
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, extractFunctionAction), {
                        notApplicableReason: getStringError(rangeToExtract.errors)
                    })
                ]
            });
            if (refactorKindBeginsWith(extractConstantAction.kind, requestedRefactor)) errors.push({
                name: refactorName12,
                description: extractConstantAction.description,
                actions: [
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, extractConstantAction), {
                        notApplicableReason: getStringError(rangeToExtract.errors)
                    })
                ]
            });
            return errors;
        }
        const { affectedTextRange, extractions } = getPossibleExtractions(targetRange, context);
        if (extractions === void 0) return emptyArray;
        const functionActions = [];
        const usedFunctionNames = /* @__PURE__ */ new Map();
        let innermostErrorFunctionAction;
        const constantActions = [];
        const usedConstantNames = /* @__PURE__ */ new Map();
        let innermostErrorConstantAction;
        let i = 0;
        for (const { functionExtraction, constantExtraction } of extractions){
            if (refactorKindBeginsWith(extractFunctionAction.kind, requestedRefactor)) {
                const description3 = functionExtraction.description;
                if (functionExtraction.errors.length === 0) {
                    if (!usedFunctionNames.has(description3)) {
                        usedFunctionNames.set(description3, true);
                        functionActions.push({
                            description: description3,
                            name: `function_scope_${i}`,
                            kind: extractFunctionAction.kind,
                            range: {
                                start: {
                                    line: getLineAndCharacterOfPosition(context.file, affectedTextRange.pos).line,
                                    offset: getLineAndCharacterOfPosition(context.file, affectedTextRange.pos).character
                                },
                                end: {
                                    line: getLineAndCharacterOfPosition(context.file, affectedTextRange.end).line,
                                    offset: getLineAndCharacterOfPosition(context.file, affectedTextRange.end).character
                                }
                            }
                        });
                    }
                } else if (!innermostErrorFunctionAction) innermostErrorFunctionAction = {
                    description: description3,
                    name: `function_scope_${i}`,
                    notApplicableReason: getStringError(functionExtraction.errors),
                    kind: extractFunctionAction.kind
                };
            }
            if (refactorKindBeginsWith(extractConstantAction.kind, requestedRefactor)) {
                const description3 = constantExtraction.description;
                if (constantExtraction.errors.length === 0) {
                    if (!usedConstantNames.has(description3)) {
                        usedConstantNames.set(description3, true);
                        constantActions.push({
                            description: description3,
                            name: `constant_scope_${i}`,
                            kind: extractConstantAction.kind,
                            range: {
                                start: {
                                    line: getLineAndCharacterOfPosition(context.file, affectedTextRange.pos).line,
                                    offset: getLineAndCharacterOfPosition(context.file, affectedTextRange.pos).character
                                },
                                end: {
                                    line: getLineAndCharacterOfPosition(context.file, affectedTextRange.end).line,
                                    offset: getLineAndCharacterOfPosition(context.file, affectedTextRange.end).character
                                }
                            }
                        });
                    }
                } else if (!innermostErrorConstantAction) innermostErrorConstantAction = {
                    description: description3,
                    name: `constant_scope_${i}`,
                    notApplicableReason: getStringError(constantExtraction.errors),
                    kind: extractConstantAction.kind
                };
            }
            i++;
        }
        const infos = [];
        if (functionActions.length) infos.push({
            name: refactorName12,
            description: getLocaleSpecificMessage(Diagnostics.Extract_function),
            actions: functionActions
        });
        else if (context.preferences.provideRefactorNotApplicableReason && innermostErrorFunctionAction) infos.push({
            name: refactorName12,
            description: getLocaleSpecificMessage(Diagnostics.Extract_function),
            actions: [
                innermostErrorFunctionAction
            ]
        });
        if (constantActions.length) infos.push({
            name: refactorName12,
            description: getLocaleSpecificMessage(Diagnostics.Extract_constant),
            actions: constantActions
        });
        else if (context.preferences.provideRefactorNotApplicableReason && innermostErrorConstantAction) infos.push({
            name: refactorName12,
            description: getLocaleSpecificMessage(Diagnostics.Extract_constant),
            actions: [
                innermostErrorConstantAction
            ]
        });
        return infos.length ? infos : emptyArray;
        function getStringError(errors) {
            let error2 = errors[0].messageText;
            if (typeof error2 !== "string") error2 = error2.messageText;
            return error2;
        }
    }
    function getRefactorEditsToExtractSymbol(context, actionName2) {
        const rangeToExtract = getRangeToExtract2(context.file, getRefactorContextSpan(context));
        const targetRange = rangeToExtract.targetRange;
        const parsedFunctionIndexMatch = /^function_scope_(\d+)$/.exec(actionName2);
        if (parsedFunctionIndexMatch) {
            const index = +parsedFunctionIndexMatch[1];
            Debug.assert(isFinite(index), "Expected to parse a finite number from the function scope index");
            return getFunctionExtractionAtIndex(targetRange, context, index);
        }
        const parsedConstantIndexMatch = /^constant_scope_(\d+)$/.exec(actionName2);
        if (parsedConstantIndexMatch) {
            const index = +parsedConstantIndexMatch[1];
            Debug.assert(isFinite(index), "Expected to parse a finite number from the constant scope index");
            return getConstantExtractionAtIndex(targetRange, context, index);
        }
        Debug.fail("Unrecognized action name");
    }
    var Messages;
    ((Messages2)=>{
        function createMessage(message) {
            return {
                message,
                code: 0,
                category: 3 /* Message */ ,
                key: message
            };
        }
        Messages2.cannotExtractRange = createMessage("Cannot extract range.");
        Messages2.cannotExtractImport = createMessage("Cannot extract import statement.");
        Messages2.cannotExtractSuper = createMessage("Cannot extract super call.");
        Messages2.cannotExtractJSDoc = createMessage("Cannot extract JSDoc.");
        Messages2.cannotExtractEmpty = createMessage("Cannot extract empty range.");
        Messages2.expressionExpected = createMessage("expression expected.");
        Messages2.uselessConstantType = createMessage("No reason to extract constant of type.");
        Messages2.statementOrExpressionExpected = createMessage("Statement or expression expected.");
        Messages2.cannotExtractRangeContainingConditionalBreakOrContinueStatements = createMessage("Cannot extract range containing conditional break or continue statements.");
        Messages2.cannotExtractRangeContainingConditionalReturnStatement = createMessage("Cannot extract range containing conditional return statement.");
        Messages2.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange = createMessage("Cannot extract range containing labeled break or continue with target outside of the range.");
        Messages2.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators = createMessage("Cannot extract range containing writes to references located outside of the target range in generators.");
        Messages2.typeWillNotBeVisibleInTheNewScope = createMessage("Type will not visible in the new scope.");
        Messages2.functionWillNotBeVisibleInTheNewScope = createMessage("Function will not visible in the new scope.");
        Messages2.cannotExtractIdentifier = createMessage("Select more than a single identifier.");
        Messages2.cannotExtractExportedEntity = createMessage("Cannot extract exported declaration");
        Messages2.cannotWriteInExpression = createMessage("Cannot write back side-effects when extracting an expression");
        Messages2.cannotExtractReadonlyPropertyInitializerOutsideConstructor = createMessage("Cannot move initialization of read-only class property outside of the constructor");
        Messages2.cannotExtractAmbientBlock = createMessage("Cannot extract code from ambient contexts");
        Messages2.cannotAccessVariablesFromNestedScopes = createMessage("Cannot access variables from nested scopes");
        Messages2.cannotExtractToJSClass = createMessage("Cannot extract constant to a class scope in JS");
        Messages2.cannotExtractToExpressionArrowFunction = createMessage("Cannot extract constant to an arrow function without a block");
        Messages2.cannotExtractFunctionsContainingThisToMethod = createMessage("Cannot extract functions containing this to method");
    })(Messages || (Messages = {}));
    var RangeFacts = /* @__PURE__ */ ((RangeFacts2)=>{
        RangeFacts2[RangeFacts2["None"] = 0] = "None";
        RangeFacts2[RangeFacts2["HasReturn"] = 1] = "HasReturn";
        RangeFacts2[RangeFacts2["IsGenerator"] = 2] = "IsGenerator";
        RangeFacts2[RangeFacts2["IsAsyncFunction"] = 4] = "IsAsyncFunction";
        RangeFacts2[RangeFacts2["UsesThis"] = 8] = "UsesThis";
        RangeFacts2[RangeFacts2["UsesThisInFunction"] = 16] = "UsesThisInFunction";
        RangeFacts2[RangeFacts2["InStaticRegion"] = 32] = "InStaticRegion";
        return RangeFacts2;
    })(RangeFacts || {});
    function getRangeToExtract2(sourceFile, span, invoked = true) {
        const { length: length2 } = span;
        if (length2 === 0 && !invoked) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractEmpty)
            ]
        };
        const cursorRequest = length2 === 0 && invoked;
        const startToken = findFirstNonJsxWhitespaceToken(sourceFile, span.start);
        const endToken = findTokenOnLeftOfPosition(sourceFile, textSpanEnd(span));
        const adjustedSpan = startToken && endToken && invoked ? getAdjustedSpanFromNodes(startToken, endToken, sourceFile) : span;
        const start = cursorRequest ? getExtractableParent(startToken) : getParentNodeInSpan(startToken, sourceFile, adjustedSpan);
        const end = cursorRequest ? start : getParentNodeInSpan(endToken, sourceFile, adjustedSpan);
        let rangeFacts = 0 /* None */ ;
        let thisNode;
        if (!start || !end) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
            ]
        };
        if (start.flags & 16777216 /* JSDoc */ ) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractJSDoc)
            ]
        };
        if (start.parent !== end.parent) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
            ]
        };
        if (start !== end) {
            if (!isBlockLike(start.parent)) return {
                errors: [
                    createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
                ]
            };
            const statements = [];
            for (const statement of start.parent.statements){
                if (statement === start || statements.length) {
                    const errors2 = checkNode(statement);
                    if (errors2) return {
                        errors: errors2
                    };
                    statements.push(statement);
                }
                if (statement === end) break;
            }
            if (!statements.length) return {
                errors: [
                    createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
                ]
            };
            return {
                targetRange: {
                    range: statements,
                    facts: rangeFacts,
                    thisNode
                }
            };
        }
        if (isReturnStatement(start) && !start.expression) return {
            errors: [
                createFileDiagnostic(sourceFile, span.start, length2, Messages.cannotExtractRange)
            ]
        };
        const node = refineNode(start);
        const errors = checkRootNode(node) || checkNode(node);
        if (errors) return {
            errors
        };
        return {
            targetRange: {
                range: getStatementOrExpressionRange(node),
                facts: rangeFacts,
                thisNode
            }
        };
        function refineNode(node2) {
            if (isReturnStatement(node2)) {
                if (node2.expression) return node2.expression;
            } else if (isVariableStatement(node2) || isVariableDeclarationList(node2)) {
                const declarations = isVariableStatement(node2) ? node2.declarationList.declarations : node2.declarations;
                let numInitializers = 0;
                let lastInitializer;
                for (const declaration of declarations)if (declaration.initializer) {
                    numInitializers++;
                    lastInitializer = declaration.initializer;
                }
                if (numInitializers === 1) return lastInitializer;
            } else if (isVariableDeclaration(node2)) {
                if (node2.initializer) return node2.initializer;
            }
            return node2;
        }
        function checkRootNode(node2) {
            if (isIdentifier(isExpressionStatement(node2) ? node2.expression : node2)) return [
                createDiagnosticForNode(node2, Messages.cannotExtractIdentifier)
            ];
            return void 0;
        }
        function checkForStaticContext(nodeToCheck, containingClass) {
            let current = nodeToCheck;
            while(current !== containingClass){
                if (current.kind === 173 /* PropertyDeclaration */ ) {
                    if (isStatic(current)) rangeFacts |= 32 /* InStaticRegion */ ;
                    break;
                } else if (current.kind === 170 /* Parameter */ ) {
                    const ctorOrMethod = getContainingFunction(current);
                    if (ctorOrMethod.kind === 177 /* Constructor */ ) rangeFacts |= 32 /* InStaticRegion */ ;
                    break;
                } else if (current.kind === 175 /* MethodDeclaration */ ) {
                    if (isStatic(current)) rangeFacts |= 32 /* InStaticRegion */ ;
                }
                current = current.parent;
            }
        }
        function checkNode(nodeToCheck) {
            let PermittedJumps;
            ((PermittedJumps2)=>{
                PermittedJumps2[PermittedJumps2["None"] = 0] = "None";
                PermittedJumps2[PermittedJumps2["Break"] = 1] = "Break";
                PermittedJumps2[PermittedJumps2["Continue"] = 2] = "Continue";
                PermittedJumps2[PermittedJumps2["Return"] = 4] = "Return";
            })(PermittedJumps || (PermittedJumps = {}));
            Debug.assert(nodeToCheck.pos <= nodeToCheck.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809 (1)");
            Debug.assert(!positionIsSynthesized(nodeToCheck.pos), "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809 (2)");
            if (!isStatement(nodeToCheck) && !(isExpressionNode(nodeToCheck) && isExtractableExpression(nodeToCheck)) && !isStringLiteralJsxAttribute(nodeToCheck)) return [
                createDiagnosticForNode(nodeToCheck, Messages.statementOrExpressionExpected)
            ];
            if (nodeToCheck.flags & 33554432 /* Ambient */ ) return [
                createDiagnosticForNode(nodeToCheck, Messages.cannotExtractAmbientBlock)
            ];
            const containingClass = getContainingClass(nodeToCheck);
            if (containingClass) checkForStaticContext(nodeToCheck, containingClass);
            let errors2;
            let permittedJumps = 4 /* Return */ ;
            let seenLabels;
            visit(nodeToCheck);
            if (rangeFacts & 8 /* UsesThis */ ) {
                const container = getThisContainer(nodeToCheck, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                if (container.kind === 263 /* FunctionDeclaration */  || container.kind === 175 /* MethodDeclaration */  && container.parent.kind === 211 /* ObjectLiteralExpression */  || container.kind === 219 /* FunctionExpression */ ) rangeFacts |= 16 /* UsesThisInFunction */ ;
            }
            return errors2;
            function visit(node2) {
                if (errors2) return true;
                if (isDeclaration(node2)) {
                    const declaringNode = node2.kind === 261 /* VariableDeclaration */  ? node2.parent.parent : node2;
                    if (hasSyntacticModifier(declaringNode, 32 /* Export */ )) {
                        (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractExportedEntity));
                        return true;
                    }
                }
                switch(node2.kind){
                    case 273 /* ImportDeclaration */ :
                        (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractImport));
                        return true;
                    case 278 /* ExportAssignment */ :
                        (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractExportedEntity));
                        return true;
                    case 108 /* SuperKeyword */ :
                        if (node2.parent.kind === 214 /* CallExpression */ ) {
                            const containingClass2 = getContainingClass(node2);
                            if (containingClass2 === void 0 || containingClass2.pos < span.start || containingClass2.end >= span.start + span.length) {
                                (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractSuper));
                                return true;
                            }
                        } else {
                            rangeFacts |= 8 /* UsesThis */ ;
                            thisNode = node2;
                        }
                        break;
                    case 220 /* ArrowFunction */ :
                        forEachChild(node2, function check(n) {
                            if (isThis(n)) {
                                rangeFacts |= 8 /* UsesThis */ ;
                                thisNode = node2;
                            } else if (isClassLike(n) || isFunctionLike(n) && !isArrowFunction(n)) return false;
                            else forEachChild(n, check);
                        });
                    // falls through
                    case 264 /* ClassDeclaration */ :
                    case 263 /* FunctionDeclaration */ :
                        if (isSourceFile(node2.parent) && node2.parent.externalModuleIndicator === void 0) (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.functionWillNotBeVisibleInTheNewScope));
                    // falls through
                    case 232 /* ClassExpression */ :
                    case 219 /* FunctionExpression */ :
                    case 175 /* MethodDeclaration */ :
                    case 177 /* Constructor */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                        return false;
                }
                const savedPermittedJumps = permittedJumps;
                switch(node2.kind){
                    case 246 /* IfStatement */ :
                        permittedJumps &= -5 /* Return */ ;
                        break;
                    case 259 /* TryStatement */ :
                        permittedJumps = 0 /* None */ ;
                        break;
                    case 242 /* Block */ :
                        if (node2.parent && node2.parent.kind === 259 /* TryStatement */  && node2.parent.finallyBlock === node2) permittedJumps = 4 /* Return */ ;
                        break;
                    case 298 /* DefaultClause */ :
                    case 297 /* CaseClause */ :
                        permittedJumps |= 1 /* Break */ ;
                        break;
                    default:
                        if (isIterationStatement(node2, /*lookInLabeledStatements*/ false)) permittedJumps |= 3 /* Continue */ ;
                        break;
                }
                switch(node2.kind){
                    case 198 /* ThisType */ :
                    case 110 /* ThisKeyword */ :
                        rangeFacts |= 8 /* UsesThis */ ;
                        thisNode = node2;
                        break;
                    case 257 /* LabeledStatement */ :
                        {
                            const label = node2.label;
                            (seenLabels || (seenLabels = [])).push(label.escapedText);
                            forEachChild(node2, visit);
                            seenLabels.pop();
                            break;
                        }
                    case 253 /* BreakStatement */ :
                    case 252 /* ContinueStatement */ :
                        {
                            const label = node2.label;
                            if (label) {
                                if (!contains(seenLabels, label.escapedText)) (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange));
                            } else if (!(permittedJumps & (node2.kind === 253 /* BreakStatement */  ? 1 /* Break */  : 2 /* Continue */ ))) (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractRangeContainingConditionalBreakOrContinueStatements));
                            break;
                        }
                    case 224 /* AwaitExpression */ :
                        rangeFacts |= 4 /* IsAsyncFunction */ ;
                        break;
                    case 230 /* YieldExpression */ :
                        rangeFacts |= 2 /* IsGenerator */ ;
                        break;
                    case 254 /* ReturnStatement */ :
                        if (permittedJumps & 4 /* Return */ ) rangeFacts |= 1 /* HasReturn */ ;
                        else (errors2 || (errors2 = [])).push(createDiagnosticForNode(node2, Messages.cannotExtractRangeContainingConditionalReturnStatement));
                        break;
                    default:
                        forEachChild(node2, visit);
                        break;
                }
                permittedJumps = savedPermittedJumps;
            }
        }
    }
    function getAdjustedSpanFromNodes(startNode2, endNode2, sourceFile) {
        const start = startNode2.getStart(sourceFile);
        let end = endNode2.getEnd();
        if (sourceFile.text.charCodeAt(end) === 59 /* semicolon */ ) end++;
        return {
            start,
            length: end - start
        };
    }
    function getStatementOrExpressionRange(node) {
        if (isStatement(node)) return [
            node
        ];
        if (isExpressionNode(node)) return isExpressionStatement(node.parent) ? [
            node.parent
        ] : node;
        if (isStringLiteralJsxAttribute(node)) return node;
        return void 0;
    }
    function isScope(node) {
        return isArrowFunction(node) ? isFunctionBody(node.body) : isFunctionLikeDeclaration(node) || isSourceFile(node) || isModuleBlock(node) || isClassLike(node);
    }
    function collectEnclosingScopes(range) {
        let current = isReadonlyArray(range.range) ? first(range.range) : range.range;
        if (range.facts & 8 /* UsesThis */  && !(range.facts & 16 /* UsesThisInFunction */ )) {
            const containingClass = getContainingClass(current);
            if (containingClass) {
                const containingFunction = findAncestor(current, isFunctionLikeDeclaration);
                return containingFunction ? [
                    containingFunction,
                    containingClass
                ] : [
                    containingClass
                ];
            }
        }
        const scopes = [];
        while(true){
            current = current.parent;
            if (current.kind === 170 /* Parameter */ ) current = findAncestor(current, (parent2)=>isFunctionLikeDeclaration(parent2)).parent;
            if (isScope(current)) {
                scopes.push(current);
                if (current.kind === 308 /* SourceFile */ ) return scopes;
            }
        }
    }
    function getFunctionExtractionAtIndex(targetRange, context, requestedChangesIndex) {
        const { scopes, readsAndWrites: { target, usagesPerScope, functionErrorsPerScope, exposedVariableDeclarations } } = getPossibleExtractionsWorker(targetRange, context);
        Debug.assert(!functionErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
        context.cancellationToken.throwIfCancellationRequested();
        return extractFunctionInScope(target, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], exposedVariableDeclarations, targetRange, context);
    }
    function getConstantExtractionAtIndex(targetRange, context, requestedChangesIndex) {
        const { scopes, readsAndWrites: { target, usagesPerScope, constantErrorsPerScope, exposedVariableDeclarations } } = getPossibleExtractionsWorker(targetRange, context);
        Debug.assert(!constantErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
        Debug.assert(exposedVariableDeclarations.length === 0, "Extract constant accepted a range containing a variable declaration?");
        context.cancellationToken.throwIfCancellationRequested();
        const expression = isExpression(target) ? target : target.statements[0].expression;
        return extractConstantInScope(expression, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], targetRange.facts, context);
    }
    function getPossibleExtractions(targetRange, context) {
        const { scopes, affectedTextRange, readsAndWrites: { functionErrorsPerScope, constantErrorsPerScope } } = getPossibleExtractionsWorker(targetRange, context);
        const extractions = scopes.map((scope, i)=>{
            const functionDescriptionPart = getDescriptionForFunctionInScope(scope);
            const constantDescriptionPart = getDescriptionForConstantInScope(scope);
            const scopeDescription = isFunctionLikeDeclaration(scope) ? getDescriptionForFunctionLikeDeclaration(scope) : isClassLike(scope) ? getDescriptionForClassLikeDeclaration(scope) : getDescriptionForModuleLikeDeclaration(scope);
            let functionDescription;
            let constantDescription;
            if (scopeDescription === 1 /* Global */ ) {
                functionDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    functionDescriptionPart,
                    "global"
                ]);
                constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    constantDescriptionPart,
                    "global"
                ]);
            } else if (scopeDescription === 0 /* Module */ ) {
                functionDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    functionDescriptionPart,
                    "module"
                ]);
                constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1_scope), [
                    constantDescriptionPart,
                    "module"
                ]);
            } else {
                functionDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1), [
                    functionDescriptionPart,
                    scopeDescription
                ]);
                constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_1), [
                    constantDescriptionPart,
                    scopeDescription
                ]);
            }
            if (i === 0 && !isClassLike(scope)) constantDescription = formatStringFromArgs(getLocaleSpecificMessage(Diagnostics.Extract_to_0_in_enclosing_scope), [
                constantDescriptionPart
            ]);
            return {
                functionExtraction: {
                    description: functionDescription,
                    errors: functionErrorsPerScope[i]
                },
                constantExtraction: {
                    description: constantDescription,
                    errors: constantErrorsPerScope[i]
                }
            };
        });
        return {
            affectedTextRange,
            extractions
        };
    }
    function getPossibleExtractionsWorker(targetRange, context) {
        const { file: sourceFile } = context;
        const scopes = collectEnclosingScopes(targetRange);
        const enclosingTextRange = getEnclosingTextRange(targetRange, sourceFile);
        const readsAndWrites = collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, context.program.getTypeChecker(), context.cancellationToken);
        return {
            scopes,
            affectedTextRange: enclosingTextRange,
            readsAndWrites
        };
    }
    function getDescriptionForFunctionInScope(scope) {
        return isFunctionLikeDeclaration(scope) ? "inner function" : isClassLike(scope) ? "method" : "function";
    }
    function getDescriptionForConstantInScope(scope) {
        return isClassLike(scope) ? "readonly field" : "constant";
    }
    function getDescriptionForFunctionLikeDeclaration(scope) {
        switch(scope.kind){
            case 177 /* Constructor */ :
                return "constructor";
            case 219 /* FunctionExpression */ :
            case 263 /* FunctionDeclaration */ :
                return scope.name ? `function '${scope.name.text}'` : ANONYMOUS;
            case 220 /* ArrowFunction */ :
                return "arrow function";
            case 175 /* MethodDeclaration */ :
                return `method '${scope.name.getText()}'`;
            case 178 /* GetAccessor */ :
                return `'get ${scope.name.getText()}'`;
            case 179 /* SetAccessor */ :
                return `'set ${scope.name.getText()}'`;
            default:
                Debug.assertNever(scope, `Unexpected scope kind ${scope.kind}`);
        }
    }
    function getDescriptionForClassLikeDeclaration(scope) {
        return scope.kind === 264 /* ClassDeclaration */  ? scope.name ? `class '${scope.name.text}'` : "anonymous class declaration" : scope.name ? `class expression '${scope.name.text}'` : "anonymous class expression";
    }
    function getDescriptionForModuleLikeDeclaration(scope) {
        return scope.kind === 269 /* ModuleBlock */  ? `namespace '${scope.parent.name.getText()}'` : scope.externalModuleIndicator ? 0 /* Module */  : 1 /* Global */ ;
    }
    function extractFunctionInScope(node, scope, { usages: usagesInScope, typeParameterUsages, substitutions }, exposedVariableDeclarations, range, context) {
        const checker = context.program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(context.program.getCompilerOptions());
        const importAdder = ts_codefix_exports.createImportAdder(context.file, context.program, context.preferences, context.host);
        const file = scope.getSourceFile();
        const functionNameText = getUniqueName(isClassLike(scope) ? "newMethod" : "newFunction", file);
        const isJS = isInJSFile(scope);
        const functionName = factory.createIdentifier(functionNameText);
        let returnType;
        const parameters = [];
        const callArguments = [];
        let writes;
        usagesInScope.forEach((usage, name)=>{
            let typeNode;
            if (!isJS) {
                let type = checker.getTypeOfSymbolAtLocation(usage.symbol, usage.node);
                type = checker.getBaseTypeOfLiteralType(type);
                typeNode = ts_codefix_exports.typeToAutoImportableTypeNode(checker, importAdder, type, scope, scriptTarget, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
            }
            const paramDecl = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ name, /*questionToken*/ void 0, typeNode);
            parameters.push(paramDecl);
            if (usage.usage === 2 /* Write */ ) (writes || (writes = [])).push(usage);
            callArguments.push(factory.createIdentifier(name));
        });
        const typeParametersAndDeclarations = arrayFrom(typeParameterUsages.values(), (type)=>({
                type,
                declaration: getFirstDeclarationBeforePosition(type, context.startPosition)
            }));
        typeParametersAndDeclarations.sort(compareTypesByDeclarationOrder);
        const typeParameters = typeParametersAndDeclarations.length === 0 ? void 0 : mapDefined(typeParametersAndDeclarations, ({ declaration })=>declaration);
        const callTypeArguments = typeParameters !== void 0 ? typeParameters.map((decl)=>factory.createTypeReferenceNode(decl.name, /*typeArguments*/ void 0)) : void 0;
        if (isExpression(node) && !isJS) {
            const contextualType = checker.getContextualType(node);
            returnType = checker.typeToTypeNode(contextualType, scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
        }
        const { body, returnValueProperty } = transformFunctionBody(node, exposedVariableDeclarations, writes, substitutions, !!(range.facts & 1 /* HasReturn */ ));
        suppressLeadingAndTrailingTrivia(body);
        let newFunction;
        const callThis = !!(range.facts & 16 /* UsesThisInFunction */ );
        if (isClassLike(scope)) {
            const modifiers = isJS ? [] : [
                factory.createModifier(123 /* PrivateKeyword */ )
            ];
            if (range.facts & 32 /* InStaticRegion */ ) modifiers.push(factory.createModifier(126 /* StaticKeyword */ ));
            if (range.facts & 4 /* IsAsyncFunction */ ) modifiers.push(factory.createModifier(134 /* AsyncKeyword */ ));
            newFunction = factory.createMethodDeclaration(modifiers.length ? modifiers : void 0, range.facts & 2 /* IsGenerator */  ? factory.createToken(42 /* AsteriskToken */ ) : void 0, functionName, /*questionToken*/ void 0, typeParameters, parameters, returnType, body);
        } else {
            if (callThis) parameters.unshift(factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ "this", /*questionToken*/ void 0, checker.typeToTypeNode(checker.getTypeAtLocation(range.thisNode), scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ ), /*initializer*/ void 0));
            newFunction = factory.createFunctionDeclaration(range.facts & 4 /* IsAsyncFunction */  ? [
                factory.createToken(134 /* AsyncKeyword */ )
            ] : void 0, range.facts & 2 /* IsGenerator */  ? factory.createToken(42 /* AsteriskToken */ ) : void 0, functionName, typeParameters, parameters, returnType, body);
        }
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        const minInsertionPos = (isReadonlyArray(range.range) ? last(range.range) : range.range).end;
        const nodeToInsertBefore = getNodeToInsertFunctionBefore(minInsertionPos, scope);
        if (nodeToInsertBefore) changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newFunction, /*blankLineBetween*/ true);
        else changeTracker.insertNodeAtEndOfScope(context.file, scope, newFunction);
        importAdder.writeFixes(changeTracker);
        const newNodes = [];
        const called = getCalledExpression(scope, range, functionNameText);
        if (callThis) callArguments.unshift(factory.createIdentifier("this"));
        let call = factory.createCallExpression(callThis ? factory.createPropertyAccessExpression(called, "call") : called, callTypeArguments, // Note that no attempt is made to take advantage of type argument inference
        callArguments);
        if (range.facts & 2 /* IsGenerator */ ) call = factory.createYieldExpression(factory.createToken(42 /* AsteriskToken */ ), call);
        if (range.facts & 4 /* IsAsyncFunction */ ) call = factory.createAwaitExpression(call);
        if (isInJSXContent(node)) call = factory.createJsxExpression(/*dotDotDotToken*/ void 0, call);
        if (exposedVariableDeclarations.length && !writes) {
            Debug.assert(!returnValueProperty, "Expected no returnValueProperty");
            Debug.assert(!(range.facts & 1 /* HasReturn */ ), "Expected RangeFacts.HasReturn flag to be unset");
            if (exposedVariableDeclarations.length === 1) {
                const variableDeclaration = exposedVariableDeclarations[0];
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(getSynthesizedDeepClone(variableDeclaration.name), /*exclamationToken*/ void 0, /*type*/ getSynthesizedDeepClone(variableDeclaration.type), /*initializer*/ call)
                ], variableDeclaration.parent.flags)));
            } else {
                const bindingElements = [];
                const typeElements = [];
                let commonNodeFlags = exposedVariableDeclarations[0].parent.flags;
                let sawExplicitType = false;
                for (const variableDeclaration of exposedVariableDeclarations){
                    bindingElements.push(factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ void 0, /*name*/ getSynthesizedDeepClone(variableDeclaration.name)));
                    const variableType = checker.typeToTypeNode(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(variableDeclaration)), scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
                    typeElements.push(factory.createPropertySignature(/*modifiers*/ void 0, /*name*/ variableDeclaration.symbol.name, /*questionToken*/ void 0, /*type*/ variableType));
                    sawExplicitType = sawExplicitType || variableDeclaration.type !== void 0;
                    commonNodeFlags = commonNodeFlags & variableDeclaration.parent.flags;
                }
                const typeLiteral = sawExplicitType ? factory.createTypeLiteralNode(typeElements) : void 0;
                if (typeLiteral) setEmitFlags(typeLiteral, 1 /* SingleLine */ );
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(factory.createObjectBindingPattern(bindingElements), /*exclamationToken*/ void 0, /*type*/ typeLiteral, /*initializer*/ call)
                ], commonNodeFlags)));
            }
        } else if (exposedVariableDeclarations.length || writes) {
            if (exposedVariableDeclarations.length) for (const variableDeclaration of exposedVariableDeclarations){
                let flags = variableDeclaration.parent.flags;
                if (flags & 2 /* Const */ ) flags = flags & -3 /* Const */  | 1 /* Let */ ;
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(variableDeclaration.symbol.name, /*exclamationToken*/ void 0, getTypeDeepCloneUnionUndefined(variableDeclaration.type))
                ], flags)));
            }
            if (returnValueProperty) newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                factory.createVariableDeclaration(returnValueProperty, /*exclamationToken*/ void 0, getTypeDeepCloneUnionUndefined(returnType))
            ], 1 /* Let */ )));
            const assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
            if (returnValueProperty) assignments.unshift(factory.createShorthandPropertyAssignment(returnValueProperty));
            if (assignments.length === 1) {
                Debug.assert(!returnValueProperty, "Shouldn't have returnValueProperty here");
                newNodes.push(factory.createExpressionStatement(factory.createAssignment(assignments[0].name, call)));
                if (range.facts & 1 /* HasReturn */ ) newNodes.push(factory.createReturnStatement());
            } else {
                newNodes.push(factory.createExpressionStatement(factory.createAssignment(factory.createObjectLiteralExpression(assignments), call)));
                if (returnValueProperty) newNodes.push(factory.createReturnStatement(factory.createIdentifier(returnValueProperty)));
            }
        } else {
            if (range.facts & 1 /* HasReturn */ ) newNodes.push(factory.createReturnStatement(call));
            else if (isReadonlyArray(range.range)) newNodes.push(factory.createExpressionStatement(call));
            else newNodes.push(call);
        }
        if (isReadonlyArray(range.range)) changeTracker.replaceNodeRangeWithNodes(context.file, first(range.range), last(range.range), newNodes);
        else changeTracker.replaceNodeWithNodes(context.file, range.range, newNodes);
        const edits = changeTracker.getChanges();
        const renameRange = isReadonlyArray(range.range) ? first(range.range) : range.range;
        const renameFilename = renameRange.getSourceFile().fileName;
        const renameLocation = getRenameLocation(edits, renameFilename, functionNameText, /*preferLastLocation*/ false);
        return {
            renameFilename,
            renameLocation,
            edits
        };
        function getTypeDeepCloneUnionUndefined(typeNode) {
            if (typeNode === void 0) return void 0;
            const clone2 = getSynthesizedDeepClone(typeNode);
            let withoutParens = clone2;
            while(isParenthesizedTypeNode(withoutParens))withoutParens = withoutParens.type;
            return isUnionTypeNode(withoutParens) && find(withoutParens.types, (t)=>t.kind === 157 /* UndefinedKeyword */ ) ? clone2 : factory.createUnionTypeNode([
                clone2,
                factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
            ]);
        }
    }
    function extractConstantInScope(node, scope, { substitutions }, rangeFacts, context) {
        const checker = context.program.getTypeChecker();
        const file = scope.getSourceFile();
        const localNameText = getIdentifierForNode(node, scope, checker, file);
        const isJS = isInJSFile(scope);
        let variableType = isJS || !checker.isContextSensitive(node) ? void 0 : checker.typeToTypeNode(checker.getContextualType(node), scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
        let initializer = transformConstantInitializer(skipParentheses(node), substitutions);
        ({ variableType, initializer } = transformFunctionInitializerAndType(variableType, initializer));
        suppressLeadingAndTrailingTrivia(initializer);
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        if (isClassLike(scope)) {
            Debug.assert(!isJS, "Cannot extract to a JS class");
            const modifiers = [];
            modifiers.push(factory.createModifier(123 /* PrivateKeyword */ ));
            if (rangeFacts & 32 /* InStaticRegion */ ) modifiers.push(factory.createModifier(126 /* StaticKeyword */ ));
            modifiers.push(factory.createModifier(148 /* ReadonlyKeyword */ ));
            const newVariable = factory.createPropertyDeclaration(modifiers, localNameText, /*questionOrExclamationToken*/ void 0, variableType, initializer);
            let localReference = factory.createPropertyAccessExpression(rangeFacts & 32 /* InStaticRegion */  ? factory.createIdentifier(scope.name.getText()) : factory.createThis(), factory.createIdentifier(localNameText));
            if (isInJSXContent(node)) localReference = factory.createJsxExpression(/*dotDotDotToken*/ void 0, localReference);
            const maxInsertionPos = node.pos;
            const nodeToInsertBefore = getNodeToInsertPropertyBefore(maxInsertionPos, scope);
            changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariable, /*blankLineBetween*/ true);
            changeTracker.replaceNode(context.file, node, localReference);
        } else {
            const newVariableDeclaration = factory.createVariableDeclaration(localNameText, /*exclamationToken*/ void 0, variableType, initializer);
            const oldVariableDeclaration = getContainingVariableDeclarationIfInList(node, scope);
            if (oldVariableDeclaration) {
                changeTracker.insertNodeBefore(context.file, oldVariableDeclaration, newVariableDeclaration);
                const localReference = factory.createIdentifier(localNameText);
                changeTracker.replaceNode(context.file, node, localReference);
            } else if (node.parent.kind === 245 /* ExpressionStatement */  && scope === findAncestor(node, isScope)) {
                const newVariableStatement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    newVariableDeclaration
                ], 2 /* Const */ ));
                changeTracker.replaceNode(context.file, node.parent, newVariableStatement);
            } else {
                const newVariableStatement = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    newVariableDeclaration
                ], 2 /* Const */ ));
                const nodeToInsertBefore = getNodeToInsertConstantBefore(node, scope);
                if (nodeToInsertBefore.pos === 0) changeTracker.insertNodeAtTopOfFile(context.file, newVariableStatement, /*blankLineBetween*/ false);
                else changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariableStatement, /*blankLineBetween*/ false);
                if (node.parent.kind === 245 /* ExpressionStatement */ ) changeTracker.delete(context.file, node.parent);
                else {
                    let localReference = factory.createIdentifier(localNameText);
                    if (isInJSXContent(node)) localReference = factory.createJsxExpression(/*dotDotDotToken*/ void 0, localReference);
                    changeTracker.replaceNode(context.file, node, localReference);
                }
            }
        }
        const edits = changeTracker.getChanges();
        const renameFilename = node.getSourceFile().fileName;
        const renameLocation = getRenameLocation(edits, renameFilename, localNameText, /*preferLastLocation*/ true);
        return {
            renameFilename,
            renameLocation,
            edits
        };
        function transformFunctionInitializerAndType(variableType2, initializer2) {
            if (variableType2 === void 0) return {
                variableType: variableType2,
                initializer: initializer2
            };
            if (!isFunctionExpression(initializer2) && !isArrowFunction(initializer2) || !!initializer2.typeParameters) return {
                variableType: variableType2,
                initializer: initializer2
            };
            const functionType = checker.getTypeAtLocation(node);
            const functionSignature = singleOrUndefined(checker.getSignaturesOfType(functionType, 0 /* Call */ ));
            if (!functionSignature) return {
                variableType: variableType2,
                initializer: initializer2
            };
            if (!!functionSignature.getTypeParameters()) return {
                variableType: variableType2,
                initializer: initializer2
            };
            const parameters = [];
            let hasAny = false;
            for (const p of initializer2.parameters)if (p.type) parameters.push(p);
            else {
                const paramType = checker.getTypeAtLocation(p);
                if (paramType === checker.getAnyType()) hasAny = true;
                parameters.push(factory.updateParameterDeclaration(p, p.modifiers, p.dotDotDotToken, p.name, p.questionToken, p.type || checker.typeToTypeNode(paramType, scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ ), p.initializer));
            }
            if (hasAny) return {
                variableType: variableType2,
                initializer: initializer2
            };
            variableType2 = void 0;
            if (isArrowFunction(initializer2)) initializer2 = factory.updateArrowFunction(initializer2, canHaveModifiers(node) ? getModifiers(node) : void 0, initializer2.typeParameters, parameters, initializer2.type || checker.typeToTypeNode(functionSignature.getReturnType(), scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ ), initializer2.equalsGreaterThanToken, initializer2.body);
            else {
                if (functionSignature && !!functionSignature.thisParameter) {
                    const firstParameter = firstOrUndefined(parameters);
                    if (!firstParameter || isIdentifier(firstParameter.name) && firstParameter.name.escapedText !== "this") {
                        const thisType = checker.getTypeOfSymbolAtLocation(functionSignature.thisParameter, node);
                        parameters.splice(0, 0, factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "this", /*questionToken*/ void 0, checker.typeToTypeNode(thisType, scope, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ )));
                    }
                }
                initializer2 = factory.updateFunctionExpression(initializer2, canHaveModifiers(node) ? getModifiers(node) : void 0, initializer2.asteriskToken, initializer2.name, initializer2.typeParameters, parameters, initializer2.type || checker.typeToTypeNode(functionSignature.getReturnType(), scope, 1 /* NoTruncation */ ), initializer2.body);
            }
            return {
                variableType: variableType2,
                initializer: initializer2
            };
        }
    }
    function getContainingVariableDeclarationIfInList(node, scope) {
        let prevNode;
        while(node !== void 0 && node !== scope){
            if (isVariableDeclaration(node) && node.initializer === prevNode && isVariableDeclarationList(node.parent) && node.parent.declarations.length > 1) return node;
            prevNode = node;
            node = node.parent;
        }
    }
    function getFirstDeclarationBeforePosition(type, position) {
        let firstDeclaration;
        const symbol = type.symbol;
        if (symbol && symbol.declarations) {
            for (const declaration of symbol.declarations)if ((firstDeclaration === void 0 || declaration.pos < firstDeclaration.pos) && declaration.pos < position) firstDeclaration = declaration;
        }
        return firstDeclaration;
    }
    function compareTypesByDeclarationOrder({ type: type1, declaration: declaration1 }, { type: type2, declaration: declaration2 }) {
        return compareProperties(declaration1, declaration2, "pos", compareValues) || compareStringsCaseSensitive(type1.symbol ? type1.symbol.getName() : "", type2.symbol ? type2.symbol.getName() : "") || compareValues(type1.id, type2.id);
    }
    function getCalledExpression(scope, range, functionNameText) {
        const functionReference = factory.createIdentifier(functionNameText);
        if (isClassLike(scope)) {
            const lhs = range.facts & 32 /* InStaticRegion */  ? factory.createIdentifier(scope.name.text) : factory.createThis();
            return factory.createPropertyAccessExpression(lhs, functionReference);
        } else return functionReference;
    }
    function transformFunctionBody(body, exposedVariableDeclarations, writes, substitutions, hasReturn2) {
        const hasWritesOrVariableDeclarations = writes !== void 0 || exposedVariableDeclarations.length > 0;
        if (isBlock(body) && !hasWritesOrVariableDeclarations && substitutions.size === 0) return {
            body: factory.createBlock(body.statements, /*multiLine*/ true),
            returnValueProperty: void 0
        };
        let returnValueProperty;
        let ignoreReturns = false;
        const statements = factory.createNodeArray(isBlock(body) ? body.statements.slice(0) : [
            isStatement(body) ? body : factory.createReturnStatement(skipParentheses(body))
        ]);
        if (hasWritesOrVariableDeclarations || substitutions.size) {
            const rewrittenStatements = visitNodes2(statements, visitor, isStatement).slice();
            if (hasWritesOrVariableDeclarations && !hasReturn2 && isStatement(body)) {
                const assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
                if (assignments.length === 1) rewrittenStatements.push(factory.createReturnStatement(assignments[0].name));
                else rewrittenStatements.push(factory.createReturnStatement(factory.createObjectLiteralExpression(assignments)));
            }
            return {
                body: factory.createBlock(rewrittenStatements, /*multiLine*/ true),
                returnValueProperty
            };
        } else return {
            body: factory.createBlock(statements, /*multiLine*/ true),
            returnValueProperty: void 0
        };
        function visitor(node) {
            if (!ignoreReturns && isReturnStatement(node) && hasWritesOrVariableDeclarations) {
                const assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
                if (node.expression) {
                    if (!returnValueProperty) returnValueProperty = "__return";
                    assignments.unshift(factory.createPropertyAssignment(returnValueProperty, visitNode(node.expression, visitor, isExpression)));
                }
                if (assignments.length === 1) return factory.createReturnStatement(assignments[0].name);
                else return factory.createReturnStatement(factory.createObjectLiteralExpression(assignments));
            } else {
                const oldIgnoreReturns = ignoreReturns;
                ignoreReturns = ignoreReturns || isFunctionLikeDeclaration(node) || isClassLike(node);
                const substitution = substitutions.get(getNodeId(node).toString());
                const result = substitution ? getSynthesizedDeepClone(substitution) : visitEachChild(node, visitor, /*context*/ void 0);
                ignoreReturns = oldIgnoreReturns;
                return result;
            }
        }
    }
    function transformConstantInitializer(initializer, substitutions) {
        return substitutions.size ? visitor(initializer) : initializer;
        function visitor(node) {
            const substitution = substitutions.get(getNodeId(node).toString());
            return substitution ? getSynthesizedDeepClone(substitution) : visitEachChild(node, visitor, /*context*/ void 0);
        }
    }
    function getStatementsOrClassElements(scope) {
        if (isFunctionLikeDeclaration(scope)) {
            const body = scope.body;
            if (isBlock(body)) return body.statements;
        } else if (isModuleBlock(scope) || isSourceFile(scope)) return scope.statements;
        else if (isClassLike(scope)) return scope.members;
        else assertType(scope);
        return emptyArray;
    }
    function getNodeToInsertFunctionBefore(minPos, scope) {
        return find(getStatementsOrClassElements(scope), (child)=>child.pos >= minPos && isFunctionLikeDeclaration(child) && !isConstructorDeclaration(child));
    }
    function getNodeToInsertPropertyBefore(maxPos, scope) {
        const members = scope.members;
        Debug.assert(members.length > 0, "Found no members");
        let prevMember;
        let allProperties = true;
        for (const member of members){
            if (member.pos > maxPos) return prevMember || members[0];
            if (allProperties && !isPropertyDeclaration(member)) {
                if (prevMember !== void 0) return member;
                allProperties = false;
            }
            prevMember = member;
        }
        if (prevMember === void 0) return Debug.fail();
        return prevMember;
    }
    function getNodeToInsertConstantBefore(node, scope) {
        Debug.assert(!isClassLike(scope));
        let prevScope;
        for(let curr = node; curr !== scope; curr = curr.parent)if (isScope(curr)) prevScope = curr;
        for(let curr = (prevScope || node).parent;; curr = curr.parent){
            if (isBlockLike(curr)) {
                let prevStatement;
                for (const statement of curr.statements){
                    if (statement.pos > node.pos) break;
                    prevStatement = statement;
                }
                if (!prevStatement && isCaseClause(curr)) {
                    Debug.assert(isSwitchStatement(curr.parent.parent), "Grandparent isn't a switch statement");
                    return curr.parent.parent;
                }
                return Debug.checkDefined(prevStatement, "prevStatement failed to get set");
            }
            Debug.assert(curr !== scope, "Didn't encounter a block-like before encountering scope");
        }
    }
    function getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes) {
        const variableAssignments = map(exposedVariableDeclarations, (v1)=>factory.createShorthandPropertyAssignment(v1.symbol.name));
        const writeAssignments = map(writes, (w)=>factory.createShorthandPropertyAssignment(w.symbol.name));
        return variableAssignments === void 0 ? writeAssignments : writeAssignments === void 0 ? variableAssignments : variableAssignments.concat(writeAssignments);
    }
    function isReadonlyArray(v1) {
        return isArray(v1);
    }
    function getEnclosingTextRange(targetRange, sourceFile) {
        return isReadonlyArray(targetRange.range) ? {
            pos: first(targetRange.range).getStart(sourceFile),
            end: last(targetRange.range).getEnd()
        } : targetRange.range;
    }
    function collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, checker, cancellationToken) {
        const allTypeParameterUsages = /* @__PURE__ */ new Map();
        const usagesPerScope = [];
        const substitutionsPerScope = [];
        const functionErrorsPerScope = [];
        const constantErrorsPerScope = [];
        const visibleDeclarationsInExtractedRange = [];
        const exposedVariableSymbolSet = /* @__PURE__ */ new Map();
        const exposedVariableDeclarations = [];
        let firstExposedNonVariableDeclaration;
        const expression = !isReadonlyArray(targetRange.range) ? targetRange.range : targetRange.range.length === 1 && isExpressionStatement(targetRange.range[0]) ? targetRange.range[0].expression : void 0;
        let expressionDiagnostic;
        if (expression === void 0) {
            const statements = targetRange.range;
            const start = first(statements).getStart();
            const end = last(statements).end;
            expressionDiagnostic = createFileDiagnostic(sourceFile, start, end - start, Messages.expressionExpected);
        } else if (checker.getTypeAtLocation(expression).flags & 147456 /* Never */ ) expressionDiagnostic = createDiagnosticForNode(expression, Messages.uselessConstantType);
        for (const scope of scopes){
            usagesPerScope.push({
                usages: /* @__PURE__ */ new Map(),
                typeParameterUsages: /* @__PURE__ */ new Map(),
                substitutions: /* @__PURE__ */ new Map()
            });
            substitutionsPerScope.push(/* @__PURE__ */ new Map());
            functionErrorsPerScope.push([]);
            const constantErrors = [];
            if (expressionDiagnostic) constantErrors.push(expressionDiagnostic);
            if (isClassLike(scope) && isInJSFile(scope)) constantErrors.push(createDiagnosticForNode(scope, Messages.cannotExtractToJSClass));
            if (isArrowFunction(scope) && !isBlock(scope.body)) constantErrors.push(createDiagnosticForNode(scope, Messages.cannotExtractToExpressionArrowFunction));
            constantErrorsPerScope.push(constantErrors);
        }
        const seenUsages = /* @__PURE__ */ new Map();
        const target = isReadonlyArray(targetRange.range) ? factory.createBlock(targetRange.range) : targetRange.range;
        const unmodifiedNode = isReadonlyArray(targetRange.range) ? first(targetRange.range) : targetRange.range;
        const inGenericContext = isInGenericContext(unmodifiedNode);
        collectUsages(target);
        if (inGenericContext && !isReadonlyArray(targetRange.range) && !isJsxAttribute(targetRange.range)) {
            const contextualType = checker.getContextualType(targetRange.range);
            recordTypeParameterUsages(contextualType);
        }
        if (allTypeParameterUsages.size > 0) {
            const seenTypeParameterUsages = /* @__PURE__ */ new Map();
            let i = 0;
            for(let curr = unmodifiedNode; curr !== void 0 && i < scopes.length; curr = curr.parent){
                if (curr === scopes[i]) {
                    seenTypeParameterUsages.forEach((typeParameter, id)=>{
                        usagesPerScope[i].typeParameterUsages.set(id, typeParameter);
                    });
                    i++;
                }
                if (isDeclarationWithTypeParameters(curr)) for (const typeParameterDecl of getEffectiveTypeParameterDeclarations(curr)){
                    const typeParameter = checker.getTypeAtLocation(typeParameterDecl);
                    if (allTypeParameterUsages.has(typeParameter.id.toString())) seenTypeParameterUsages.set(typeParameter.id.toString(), typeParameter);
                }
            }
            Debug.assert(i === scopes.length, "Should have iterated all scopes");
        }
        if (visibleDeclarationsInExtractedRange.length) {
            const containingLexicalScopeOfExtraction = isBlockScope(scopes[0], scopes[0].parent) ? scopes[0] : getEnclosingBlockScopeContainer(scopes[0]);
            forEachChild(containingLexicalScopeOfExtraction, checkForUsedDeclarations);
        }
        for(let i = 0; i < scopes.length; i++){
            const scopeUsages = usagesPerScope[i];
            if (i > 0 && (scopeUsages.usages.size > 0 || scopeUsages.typeParameterUsages.size > 0)) {
                const errorNode = isReadonlyArray(targetRange.range) ? targetRange.range[0] : targetRange.range;
                constantErrorsPerScope[i].push(createDiagnosticForNode(errorNode, Messages.cannotAccessVariablesFromNestedScopes));
            }
            if (targetRange.facts & 16 /* UsesThisInFunction */  && isClassLike(scopes[i])) functionErrorsPerScope[i].push(createDiagnosticForNode(targetRange.thisNode, Messages.cannotExtractFunctionsContainingThisToMethod));
            let hasWrite = false;
            let readonlyClassPropertyWrite;
            usagesPerScope[i].usages.forEach((value1)=>{
                if (value1.usage === 2 /* Write */ ) {
                    hasWrite = true;
                    if (value1.symbol.flags & 106500 /* ClassMember */  && value1.symbol.valueDeclaration && hasEffectiveModifier(value1.symbol.valueDeclaration, 8 /* Readonly */ )) readonlyClassPropertyWrite = value1.symbol.valueDeclaration;
                }
            });
            Debug.assert(isReadonlyArray(targetRange.range) || exposedVariableDeclarations.length === 0, "No variable declarations expected if something was extracted");
            if (hasWrite && !isReadonlyArray(targetRange.range)) {
                const diag2 = createDiagnosticForNode(targetRange.range, Messages.cannotWriteInExpression);
                functionErrorsPerScope[i].push(diag2);
                constantErrorsPerScope[i].push(diag2);
            } else if (readonlyClassPropertyWrite && i > 0) {
                const diag2 = createDiagnosticForNode(readonlyClassPropertyWrite, Messages.cannotExtractReadonlyPropertyInitializerOutsideConstructor);
                functionErrorsPerScope[i].push(diag2);
                constantErrorsPerScope[i].push(diag2);
            } else if (firstExposedNonVariableDeclaration) {
                const diag2 = createDiagnosticForNode(firstExposedNonVariableDeclaration, Messages.cannotExtractExportedEntity);
                functionErrorsPerScope[i].push(diag2);
                constantErrorsPerScope[i].push(diag2);
            }
        }
        return {
            target,
            usagesPerScope,
            functionErrorsPerScope,
            constantErrorsPerScope,
            exposedVariableDeclarations
        };
        function isInGenericContext(node) {
            return !!findAncestor(node, (n)=>isDeclarationWithTypeParameters(n) && getEffectiveTypeParameterDeclarations(n).length !== 0);
        }
        function recordTypeParameterUsages(type) {
            const symbolWalker = checker.getSymbolWalker(()=>(cancellationToken.throwIfCancellationRequested(), true));
            const { visitedTypes } = symbolWalker.walkType(type);
            for (const visitedType of visitedTypes)if (visitedType.isTypeParameter()) allTypeParameterUsages.set(visitedType.id.toString(), visitedType);
        }
        function collectUsages(node, valueUsage = 1 /* Read */ ) {
            if (inGenericContext) {
                const type = checker.getTypeAtLocation(node);
                recordTypeParameterUsages(type);
            }
            if (isDeclaration(node) && node.symbol) visibleDeclarationsInExtractedRange.push(node);
            if (isAssignmentExpression(node)) {
                collectUsages(node.left, 2 /* Write */ );
                collectUsages(node.right);
            } else if (isUnaryExpressionWithWrite(node)) collectUsages(node.operand, 2 /* Write */ );
            else if (isPropertyAccessExpression(node) || isElementAccessExpression(node)) forEachChild(node, collectUsages);
            else if (isIdentifier(node)) {
                if (!node.parent) return;
                if (isQualifiedName(node.parent) && node !== node.parent.left) return;
                if (isPropertyAccessExpression(node.parent) && node !== node.parent.expression) return;
                recordUsage(node, valueUsage, /*isTypeNode*/ isPartOfTypeNode(node));
            } else forEachChild(node, collectUsages);
        }
        function recordUsage(n, usage, isTypeNode2) {
            const symbolId = recordUsagebySymbol(n, usage, isTypeNode2);
            if (symbolId) for(let i = 0; i < scopes.length; i++){
                const substitution = substitutionsPerScope[i].get(symbolId);
                if (substitution) usagesPerScope[i].substitutions.set(getNodeId(n).toString(), substitution);
            }
        }
        function recordUsagebySymbol(identifier, usage, isTypeName) {
            const symbol = getSymbolReferencedByIdentifier(identifier);
            if (!symbol) return void 0;
            const symbolId = getSymbolId(symbol).toString();
            const lastUsage = seenUsages.get(symbolId);
            if (lastUsage && lastUsage >= usage) return symbolId;
            seenUsages.set(symbolId, usage);
            if (lastUsage) {
                for (const perScope of usagesPerScope){
                    const prevEntry = perScope.usages.get(identifier.text);
                    if (prevEntry) perScope.usages.set(identifier.text, {
                        usage,
                        symbol,
                        node: identifier
                    });
                }
                return symbolId;
            }
            const decls = symbol.getDeclarations();
            const declInFile = decls && find(decls, (d)=>d.getSourceFile() === sourceFile);
            if (!declInFile) return void 0;
            if (rangeContainsStartEnd(enclosingTextRange, declInFile.getStart(), declInFile.end)) return void 0;
            if (targetRange.facts & 2 /* IsGenerator */  && usage === 2 /* Write */ ) {
                const diag2 = createDiagnosticForNode(identifier, Messages.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators);
                for (const errors of functionErrorsPerScope)errors.push(diag2);
                for (const errors of constantErrorsPerScope)errors.push(diag2);
            }
            for(let i = 0; i < scopes.length; i++){
                const scope = scopes[i];
                const resolvedSymbol = checker.resolveName(symbol.name, scope, symbol.flags, /*excludeGlobals*/ false);
                if (resolvedSymbol === symbol) continue;
                if (!substitutionsPerScope[i].has(symbolId)) {
                    const substitution = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.exportSymbol || symbol, scope, isTypeName);
                    if (substitution) substitutionsPerScope[i].set(symbolId, substitution);
                    else if (isTypeName) {
                        if (!(symbol.flags & 262144 /* TypeParameter */ )) {
                            const diag2 = createDiagnosticForNode(identifier, Messages.typeWillNotBeVisibleInTheNewScope);
                            functionErrorsPerScope[i].push(diag2);
                            constantErrorsPerScope[i].push(diag2);
                        }
                    } else usagesPerScope[i].usages.set(identifier.text, {
                        usage,
                        symbol,
                        node: identifier
                    });
                }
            }
            return symbolId;
        }
        function checkForUsedDeclarations(node) {
            if (node === targetRange.range || isReadonlyArray(targetRange.range) && targetRange.range.includes(node)) return;
            const sym = isIdentifier(node) ? getSymbolReferencedByIdentifier(node) : checker.getSymbolAtLocation(node);
            if (sym) {
                const decl = find(visibleDeclarationsInExtractedRange, (d)=>d.symbol === sym);
                if (decl) {
                    if (isVariableDeclaration(decl)) {
                        const idString = decl.symbol.id.toString();
                        if (!exposedVariableSymbolSet.has(idString)) {
                            exposedVariableDeclarations.push(decl);
                            exposedVariableSymbolSet.set(idString, true);
                        }
                    } else firstExposedNonVariableDeclaration = firstExposedNonVariableDeclaration || decl;
                }
            }
            forEachChild(node, checkForUsedDeclarations);
        }
        function getSymbolReferencedByIdentifier(identifier) {
            return identifier.parent && isShorthandPropertyAssignment(identifier.parent) && identifier.parent.name === identifier ? checker.getShorthandAssignmentValueSymbol(identifier.parent) : checker.getSymbolAtLocation(identifier);
        }
        function tryReplaceWithQualifiedNameOrPropertyAccess(symbol, scopeDecl, isTypeNode2) {
            if (!symbol) return void 0;
            const decls = symbol.getDeclarations();
            if (decls && decls.some((d)=>d.parent === scopeDecl)) return factory.createIdentifier(symbol.name);
            const prefix = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.parent, scopeDecl, isTypeNode2);
            if (prefix === void 0) return void 0;
            return isTypeNode2 ? factory.createQualifiedName(prefix, factory.createIdentifier(symbol.name)) : factory.createPropertyAccessExpression(prefix, symbol.name);
        }
    }
    function getExtractableParent(node) {
        return findAncestor(node, (node2)=>node2.parent && isExtractableExpression(node2) && !isBinaryExpression(node2.parent));
    }
    function isExtractableExpression(node) {
        const { parent: parent2 } = node;
        switch(parent2.kind){
            case 307 /* EnumMember */ :
                return false;
        }
        switch(node.kind){
            case 11 /* StringLiteral */ :
                return parent2.kind !== 273 /* ImportDeclaration */  && parent2.kind !== 277 /* ImportSpecifier */ ;
            case 231 /* SpreadElement */ :
            case 207 /* ObjectBindingPattern */ :
            case 209 /* BindingElement */ :
                return false;
            case 80 /* Identifier */ :
                return parent2.kind !== 209 /* BindingElement */  && parent2.kind !== 277 /* ImportSpecifier */  && parent2.kind !== 282 /* ExportSpecifier */ ;
        }
        return true;
    }
    function isInJSXContent(node) {
        return isStringLiteralJsxAttribute(node) || (isJsxElement(node) || isJsxSelfClosingElement(node) || isJsxFragment(node)) && (isJsxElement(node.parent) || isJsxFragment(node.parent));
    }
    function isStringLiteralJsxAttribute(node) {
        return isStringLiteral(node) && node.parent && isJsxAttribute(node.parent);
    }
    // src/services/_namespaces/ts.refactor.generateGetAccessorAndSetAccessor.ts
    var ts_refactor_generateGetAccessorAndSetAccessor_exports = {};
    // src/services/refactors/generateGetAccessorAndSetAccessor.ts
    var actionName = "Generate 'get' and 'set' accessors";
    var actionDescription = getLocaleSpecificMessage(Diagnostics.Generate_get_and_set_accessors);
    var generateGetSetAction = {
        name: actionName,
        description: actionDescription,
        kind: "refactor.rewrite.property.generateAccessors"
    };
    registerRefactor(actionName, {
        kinds: [
            generateGetSetAction.kind
        ],
        getEditsForAction: function getRefactorActionsToGenerateGetAndSetAccessors(context, actionName2) {
            if (!context.endPosition) return void 0;
            const info = ts_codefix_exports.getAccessorConvertiblePropertyAtPosition(context.file, context.program, context.startPosition, context.endPosition);
            Debug.assert(info && !isRefactorErrorInfo(info), "Expected applicable refactor info");
            const edits = ts_codefix_exports.generateAccessorFromProperty(context.file, context.program, context.startPosition, context.endPosition, context, actionName2);
            if (!edits) return void 0;
            const renameFilename = context.file.fileName;
            const nameNeedRename = info.renameAccessor ? info.accessorName : info.fieldName;
            const renameLocationOffset = isIdentifier(nameNeedRename) ? 0 : -1;
            const renameLocation = renameLocationOffset + getRenameLocation(edits, renameFilename, nameNeedRename.text, /*preferLastLocation*/ isParameter(info.declaration));
            return {
                renameFilename,
                renameLocation,
                edits
            };
        },
        getAvailableActions (context) {
            if (!context.endPosition) return emptyArray;
            const info = ts_codefix_exports.getAccessorConvertiblePropertyAtPosition(context.file, context.program, context.startPosition, context.endPosition, context.triggerReason === "invoked");
            if (!info) return emptyArray;
            if (!isRefactorErrorInfo(info)) return [
                {
                    name: actionName,
                    description: actionDescription,
                    actions: [
                        generateGetSetAction
                    ]
                }
            ];
            if (context.preferences.provideRefactorNotApplicableReason) return [
                {
                    name: actionName,
                    description: actionDescription,
                    actions: [
                        (0, _objectSpreadProps._)((0, _objectSpread._)({}, generateGetSetAction), {
                            notApplicableReason: info.error
                        })
                    ]
                }
            ];
            return emptyArray;
        }
    });
    // src/services/_namespaces/ts.refactor.inferFunctionReturnType.ts
    var ts_refactor_inferFunctionReturnType_exports = {};
    // src/services/refactors/inferFunctionReturnType.ts
    var refactorName13 = "Infer function return type";
    var refactorDescription7 = getLocaleSpecificMessage(Diagnostics.Infer_function_return_type);
    var inferReturnTypeAction = {
        name: refactorName13,
        description: refactorDescription7,
        kind: "refactor.rewrite.function.returnType"
    };
    registerRefactor(refactorName13, {
        kinds: [
            inferReturnTypeAction.kind
        ],
        getEditsForAction: getRefactorEditsToInferReturnType,
        getAvailableActions: getRefactorActionsToInferReturnType
    });
    function getRefactorEditsToInferReturnType(context) {
        const info = getInfo4(context);
        if (info && !isRefactorErrorInfo(info)) {
            const edits = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange7(context.file, t, info.declaration, info.returnTypeNode));
            return {
                renameFilename: void 0,
                renameLocation: void 0,
                edits
            };
        }
        return void 0;
    }
    function getRefactorActionsToInferReturnType(context) {
        const info = getInfo4(context);
        if (!info) return emptyArray;
        if (!isRefactorErrorInfo(info)) return [
            {
                name: refactorName13,
                description: refactorDescription7,
                actions: [
                    inferReturnTypeAction
                ]
            }
        ];
        if (context.preferences.provideRefactorNotApplicableReason) return [
            {
                name: refactorName13,
                description: refactorDescription7,
                actions: [
                    (0, _objectSpreadProps._)((0, _objectSpread._)({}, inferReturnTypeAction), {
                        notApplicableReason: info.error
                    })
                ]
            }
        ];
        return emptyArray;
    }
    function doChange7(sourceFile, changes, declaration, typeNode) {
        const closeParen = findChildOfKind(declaration, 22 /* CloseParenToken */ , sourceFile);
        const needParens = isArrowFunction(declaration) && closeParen === void 0;
        const endNode2 = needParens ? first(declaration.parameters) : closeParen;
        if (endNode2) {
            if (needParens) {
                changes.insertNodeBefore(sourceFile, endNode2, factory.createToken(21 /* OpenParenToken */ ));
                changes.insertNodeAfter(sourceFile, endNode2, factory.createToken(22 /* CloseParenToken */ ));
            }
            changes.insertNodeAt(sourceFile, endNode2.end, typeNode, {
                prefix: ": "
            });
        }
    }
    function getInfo4(context) {
        if (isInJSFile(context.file) || !refactorKindBeginsWith(inferReturnTypeAction.kind, context.kind)) return;
        const token = getTouchingPropertyName(context.file, context.startPosition);
        const declaration = findAncestor(token, (n)=>isBlock(n) || n.parent && isArrowFunction(n.parent) && (n.kind === 39 /* EqualsGreaterThanToken */  || n.parent.body === n) ? "quit" : isConvertibleDeclaration(n));
        if (!declaration || !declaration.body || declaration.type) return {
            error: getLocaleSpecificMessage(Diagnostics.Return_type_must_be_inferred_from_a_function)
        };
        const typeChecker = context.program.getTypeChecker();
        let returnType;
        if (typeChecker.isImplementationOfOverload(declaration)) {
            const signatures = typeChecker.getTypeAtLocation(declaration).getCallSignatures();
            if (signatures.length > 1) returnType = typeChecker.getUnionType(mapDefined(signatures, (s)=>s.getReturnType()));
        }
        if (!returnType) {
            const signature = typeChecker.getSignatureFromDeclaration(declaration);
            if (signature) {
                const typePredicate = typeChecker.getTypePredicateOfSignature(signature);
                if (typePredicate && typePredicate.type) {
                    const typePredicateTypeNode = typeChecker.typePredicateToTypePredicateNode(typePredicate, declaration, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
                    if (typePredicateTypeNode) return {
                        declaration,
                        returnTypeNode: typePredicateTypeNode
                    };
                } else returnType = typeChecker.getReturnTypeOfSignature(signature);
            }
        }
        if (!returnType) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_determine_function_return_type)
        };
        const returnTypeNode = typeChecker.typeToTypeNode(returnType, declaration, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
        if (returnTypeNode) return {
            declaration,
            returnTypeNode
        };
    }
    function isConvertibleDeclaration(node) {
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 175 /* MethodDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    // src/services/classifier2020.ts
    var TokenEncodingConsts = /* @__PURE__ */ ((TokenEncodingConsts2)=>{
        TokenEncodingConsts2[TokenEncodingConsts2["typeOffset"] = 8] = "typeOffset";
        TokenEncodingConsts2[TokenEncodingConsts2["modifierMask"] = 255] = "modifierMask";
        return TokenEncodingConsts2;
    })(TokenEncodingConsts || {});
    var TokenType = /* @__PURE__ */ ((TokenType2)=>{
        TokenType2[TokenType2["class"] = 0] = "class";
        TokenType2[TokenType2["enum"] = 1] = "enum";
        TokenType2[TokenType2["interface"] = 2] = "interface";
        TokenType2[TokenType2["namespace"] = 3] = "namespace";
        TokenType2[TokenType2["typeParameter"] = 4] = "typeParameter";
        TokenType2[TokenType2["type"] = 5] = "type";
        TokenType2[TokenType2["parameter"] = 6] = "parameter";
        TokenType2[TokenType2["variable"] = 7] = "variable";
        TokenType2[TokenType2["enumMember"] = 8] = "enumMember";
        TokenType2[TokenType2["property"] = 9] = "property";
        TokenType2[TokenType2["function"] = 10] = "function";
        TokenType2[TokenType2["member"] = 11] = "member";
        return TokenType2;
    })(TokenType || {});
    var TokenModifier = /* @__PURE__ */ ((TokenModifier2)=>{
        TokenModifier2[TokenModifier2["declaration"] = 0] = "declaration";
        TokenModifier2[TokenModifier2["static"] = 1] = "static";
        TokenModifier2[TokenModifier2["async"] = 2] = "async";
        TokenModifier2[TokenModifier2["readonly"] = 3] = "readonly";
        TokenModifier2[TokenModifier2["defaultLibrary"] = 4] = "defaultLibrary";
        TokenModifier2[TokenModifier2["local"] = 5] = "local";
        return TokenModifier2;
    })(TokenModifier || {});
    function getSemanticClassifications2(program, cancellationToken, sourceFile, span) {
        const classifications = getEncodedSemanticClassifications2(program, cancellationToken, sourceFile, span);
        Debug.assert(classifications.spans.length % 3 === 0);
        const dense = classifications.spans;
        const result = [];
        for(let i = 0; i < dense.length; i += 3)result.push({
            textSpan: createTextSpan(dense[i], dense[i + 1]),
            classificationType: dense[i + 2]
        });
        return result;
    }
    function getEncodedSemanticClassifications2(program, cancellationToken, sourceFile, span) {
        return {
            spans: getSemanticTokens(program, sourceFile, span, cancellationToken),
            endOfLineState: 0 /* None */ 
        };
    }
    function getSemanticTokens(program, sourceFile, span, cancellationToken) {
        const resultTokens = [];
        const collector = (node, typeIdx, modifierSet)=>{
            resultTokens.push(node.getStart(sourceFile), node.getWidth(sourceFile), (typeIdx + 1 << 8 /* typeOffset */ ) + modifierSet);
        };
        if (program && sourceFile) collectTokens(program, sourceFile, span, collector, cancellationToken);
        return resultTokens;
    }
    function collectTokens(program, sourceFile, span, collector, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        let inJSXElement = false;
        function visit(node) {
            switch(node.kind){
                case 268 /* ModuleDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                case 232 /* ClassExpression */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            if (!node || !textSpanIntersectsWith(span, node.pos, node.getFullWidth()) || node.getFullWidth() === 0) return;
            const prevInJSXElement = inJSXElement;
            if (isJsxElement(node) || isJsxSelfClosingElement(node)) inJSXElement = true;
            if (isJsxExpression(node)) inJSXElement = false;
            if (isIdentifier(node) && !inJSXElement && !inImportClause(node) && !isInfinityOrNaNString(node.escapedText)) {
                let symbol = typeChecker.getSymbolAtLocation(node);
                if (symbol) {
                    if (symbol.flags & 2097152 /* Alias */ ) symbol = typeChecker.getAliasedSymbol(symbol);
                    let typeIdx = classifySymbol2(symbol, getMeaningFromLocation(node));
                    if (typeIdx !== void 0) {
                        let modifierSet = 0;
                        if (node.parent) {
                            const parentIsDeclaration = isBindingElement(node.parent) || tokenFromDeclarationMapping.get(node.parent.kind) === typeIdx;
                            if (parentIsDeclaration && node.parent.name === node) modifierSet = 1 /* declaration */ ;
                        }
                        if (typeIdx === 6 /* parameter */  && isRightSideOfQualifiedNameOrPropertyAccess2(node)) typeIdx = 9 /* property */ ;
                        typeIdx = reclassifyByType(typeChecker, node, typeIdx);
                        const decl = symbol.valueDeclaration;
                        if (decl) {
                            const modifiers = getCombinedModifierFlags(decl);
                            const nodeFlags = getCombinedNodeFlags(decl);
                            if (modifiers & 256 /* Static */ ) modifierSet |= 2 /* static */ ;
                            if (modifiers & 1024 /* Async */ ) modifierSet |= 4 /* async */ ;
                            if (typeIdx !== 0 /* class */  && typeIdx !== 2 /* interface */ ) {
                                if (modifiers & 8 /* Readonly */  || nodeFlags & 2 /* Const */  || symbol.getFlags() & 8 /* EnumMember */ ) modifierSet |= 8 /* readonly */ ;
                            }
                            if ((typeIdx === 7 /* variable */  || typeIdx === 10 /* function */ ) && isLocalDeclaration(decl, sourceFile)) modifierSet |= 32 /* local */ ;
                            if (program.isSourceFileDefaultLibrary(decl.getSourceFile())) modifierSet |= 16 /* defaultLibrary */ ;
                        } else if (symbol.declarations && symbol.declarations.some((d)=>program.isSourceFileDefaultLibrary(d.getSourceFile()))) modifierSet |= 16 /* defaultLibrary */ ;
                        collector(node, typeIdx, modifierSet);
                    }
                }
            }
            forEachChild(node, visit);
            inJSXElement = prevInJSXElement;
        }
        visit(sourceFile);
    }
    function classifySymbol2(symbol, meaning) {
        const flags = symbol.getFlags();
        if (flags & 32 /* Class */ ) return 0 /* class */ ;
        else if (flags & 384 /* Enum */ ) return 1 /* enum */ ;
        else if (flags & 524288 /* TypeAlias */ ) return 5 /* type */ ;
        else if (flags & 64 /* Interface */ ) {
            if (meaning & 2 /* Type */ ) return 2 /* interface */ ;
        } else if (flags & 262144 /* TypeParameter */ ) return 4 /* typeParameter */ ;
        let decl = symbol.valueDeclaration || symbol.declarations && symbol.declarations[0];
        if (decl && isBindingElement(decl)) decl = getDeclarationForBindingElement(decl);
        return decl && tokenFromDeclarationMapping.get(decl.kind);
    }
    function reclassifyByType(typeChecker, node, typeIdx) {
        if (typeIdx === 7 /* variable */  || typeIdx === 9 /* property */  || typeIdx === 6 /* parameter */ ) {
            const type = typeChecker.getTypeAtLocation(node);
            if (type) {
                const test = (condition)=>{
                    return condition(type) || type.isUnion() && type.types.some(condition);
                };
                if (typeIdx !== 6 /* parameter */  && test((t)=>t.getConstructSignatures().length > 0)) return 0 /* class */ ;
                if (test((t)=>t.getCallSignatures().length > 0) && !test((t)=>t.getProperties().length > 0) || isExpressionInCallExpression(node)) return typeIdx === 9 /* property */  ? 11 /* member */  : 10 /* function */ ;
            }
        }
        return typeIdx;
    }
    function isLocalDeclaration(decl, sourceFile) {
        if (isBindingElement(decl)) decl = getDeclarationForBindingElement(decl);
        if (isVariableDeclaration(decl)) return (!isSourceFile(decl.parent.parent.parent) || isCatchClause(decl.parent)) && decl.getSourceFile() === sourceFile;
        else if (isFunctionDeclaration(decl)) return !isSourceFile(decl.parent) && decl.getSourceFile() === sourceFile;
        return false;
    }
    function getDeclarationForBindingElement(element) {
        while(true){
            if (isBindingElement(element.parent.parent)) element = element.parent.parent;
            else return element.parent.parent;
        }
    }
    function inImportClause(node) {
        const parent2 = node.parent;
        return parent2 && (isImportClause(parent2) || isImportSpecifier(parent2) || isNamespaceImport(parent2));
    }
    function isExpressionInCallExpression(node) {
        while(isRightSideOfQualifiedNameOrPropertyAccess2(node))node = node.parent;
        return isCallExpression(node.parent) && node.parent.expression === node;
    }
    function isRightSideOfQualifiedNameOrPropertyAccess2(node) {
        return isQualifiedName(node.parent) && node.parent.right === node || isPropertyAccessExpression(node.parent) && node.parent.name === node;
    }
    var tokenFromDeclarationMapping = /* @__PURE__ */ new Map([
        [
            261 /* VariableDeclaration */ ,
            7 /* variable */ 
        ],
        [
            170 /* Parameter */ ,
            6 /* parameter */ 
        ],
        [
            173 /* PropertyDeclaration */ ,
            9 /* property */ 
        ],
        [
            268 /* ModuleDeclaration */ ,
            3 /* namespace */ 
        ],
        [
            267 /* EnumDeclaration */ ,
            1 /* enum */ 
        ],
        [
            307 /* EnumMember */ ,
            8 /* enumMember */ 
        ],
        [
            264 /* ClassDeclaration */ ,
            0 /* class */ 
        ],
        [
            175 /* MethodDeclaration */ ,
            11 /* member */ 
        ],
        [
            263 /* FunctionDeclaration */ ,
            10 /* function */ 
        ],
        [
            219 /* FunctionExpression */ ,
            10 /* function */ 
        ],
        [
            174 /* MethodSignature */ ,
            11 /* member */ 
        ],
        [
            178 /* GetAccessor */ ,
            9 /* property */ 
        ],
        [
            179 /* SetAccessor */ ,
            9 /* property */ 
        ],
        [
            172 /* PropertySignature */ ,
            9 /* property */ 
        ],
        [
            265 /* InterfaceDeclaration */ ,
            2 /* interface */ 
        ],
        [
            266 /* TypeAliasDeclaration */ ,
            5 /* type */ 
        ],
        [
            169 /* TypeParameter */ ,
            4 /* typeParameter */ 
        ],
        [
            304 /* PropertyAssignment */ ,
            9 /* property */ 
        ],
        [
            305 /* ShorthandPropertyAssignment */ ,
            9 /* property */ 
        ]
    ]);
    // src/services/services.ts
    var servicesVersion = "0.8";
    function createNode(kind, pos, end, parent2) {
        const node = isNodeKind(kind) ? new NodeObject(kind, pos, end) : kind === 80 /* Identifier */  ? new IdentifierObject(80 /* Identifier */ , pos, end) : kind === 81 /* PrivateIdentifier */  ? new PrivateIdentifierObject(81 /* PrivateIdentifier */ , pos, end) : new TokenObject(kind, pos, end);
        node.parent = parent2;
        node.flags = parent2.flags & 101441536 /* ContextFlags */ ;
        return node;
    }
    var NodeObject = class {
        assertHasRealPosition(message) {
            Debug.assert(!positionIsSynthesized(this.pos) && !positionIsSynthesized(this.end), message || "Node must have a real position for this operation");
        }
        getSourceFile() {
            return getSourceFileOfNode(this);
        }
        getStart(sourceFile, includeJsDocComment) {
            this.assertHasRealPosition();
            return getTokenPosOfNode(this, sourceFile, includeJsDocComment);
        }
        getFullStart() {
            this.assertHasRealPosition();
            return this.pos;
        }
        getEnd() {
            this.assertHasRealPosition();
            return this.end;
        }
        getWidth(sourceFile) {
            this.assertHasRealPosition();
            return this.getEnd() - this.getStart(sourceFile);
        }
        getFullWidth() {
            this.assertHasRealPosition();
            return this.end - this.pos;
        }
        getLeadingTriviaWidth(sourceFile) {
            this.assertHasRealPosition();
            return this.getStart(sourceFile) - this.pos;
        }
        getFullText(sourceFile) {
            this.assertHasRealPosition();
            return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
        }
        getText(sourceFile) {
            this.assertHasRealPosition();
            if (!sourceFile) sourceFile = this.getSourceFile();
            return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
        }
        getChildCount(sourceFile) {
            return this.getChildren(sourceFile).length;
        }
        getChildAt(index, sourceFile) {
            return this.getChildren(sourceFile)[index];
        }
        getChildren(sourceFile = getSourceFileOfNode(this)) {
            this.assertHasRealPosition("Node without a real position cannot be scanned and thus has no token nodes - use forEachChild and collect the result if that's fine");
            var _getNodeChildren;
            return (_getNodeChildren = getNodeChildren(this, sourceFile)) !== null && _getNodeChildren !== void 0 ? _getNodeChildren : setNodeChildren(this, sourceFile, createChildren(this, sourceFile));
        }
        getFirstToken(sourceFile) {
            this.assertHasRealPosition();
            const children = this.getChildren(sourceFile);
            if (!children.length) return void 0;
            const child = find(children, (kid)=>kid.kind < 310 /* FirstJSDocNode */  || kid.kind > 352 /* LastJSDocNode */ );
            return child.kind < 167 /* FirstNode */  ? child : child.getFirstToken(sourceFile);
        }
        getLastToken(sourceFile) {
            this.assertHasRealPosition();
            const children = this.getChildren(sourceFile);
            const child = lastOrUndefined(children);
            if (!child) return void 0;
            return child.kind < 167 /* FirstNode */  ? child : child.getLastToken(sourceFile);
        }
        forEachChild(cbNode, cbNodeArray) {
            return forEachChild(this, cbNode, cbNodeArray);
        }
        constructor(kind, pos, end){
            this.pos = pos;
            this.end = end;
            this.kind = kind;
            this.id = 0;
            this.flags = 0 /* None */ ;
            this.modifierFlagsCache = 0 /* None */ ;
            this.transformFlags = 0 /* None */ ;
            this.parent = void 0;
            this.original = void 0;
            this.emitNode = void 0;
        }
    };
    function createChildren(node, sourceFile) {
        const children = [];
        if (isJSDocCommentContainingNode(node)) {
            node.forEachChild((child)=>{
                children.push(child);
            });
            return children;
        }
        var _ref;
        const languageVariant = (_ref = sourceFile == null ? void 0 : sourceFile.languageVariant) !== null && _ref !== void 0 ? _ref : 0 /* Standard */ ;
        scanner.setText((sourceFile || node.getSourceFile()).text);
        scanner.setLanguageVariant(languageVariant);
        let pos = node.pos;
        const processNode = (child)=>{
            addSyntheticNodes(children, pos, child.pos, node);
            children.push(child);
            pos = child.end;
        };
        const processNodes = (nodes)=>{
            addSyntheticNodes(children, pos, nodes.pos, node);
            children.push(createSyntaxList(nodes, node));
            pos = nodes.end;
        };
        forEach(node.jsDoc, processNode);
        pos = node.pos;
        node.forEachChild(processNode, processNodes);
        addSyntheticNodes(children, pos, node.end, node);
        scanner.setText(void 0);
        scanner.setLanguageVariant(0 /* Standard */ );
        return children;
    }
    function addSyntheticNodes(nodes, pos, end, parent2) {
        scanner.resetTokenState(pos);
        while(pos < end){
            const token = scanner.scan();
            const textPos = scanner.getTokenEnd();
            if (textPos <= end) {
                if (token === 80 /* Identifier */ ) {
                    if (hasTabstop(parent2)) continue;
                    Debug.fail(`Did not expect ${Debug.formatSyntaxKind(parent2.kind)} to have an Identifier in its trivia`);
                }
                nodes.push(createNode(token, pos, textPos, parent2));
            }
            pos = textPos;
            if (token === 1 /* EndOfFileToken */ ) break;
        }
    }
    function createSyntaxList(nodes, parent2) {
        const list = createNode(353 /* SyntaxList */ , nodes.pos, nodes.end, parent2);
        const children = [];
        let pos = nodes.pos;
        for (const node of nodes){
            addSyntheticNodes(children, pos, node.pos, parent2);
            children.push(node);
            pos = node.end;
        }
        addSyntheticNodes(children, pos, nodes.end, parent2);
        list._children = children;
        return list;
    }
    var TokenOrIdentifierObject = class {
        getSourceFile() {
            return getSourceFileOfNode(this);
        }
        getStart(sourceFile, includeJsDocComment) {
            return getTokenPosOfNode(this, sourceFile, includeJsDocComment);
        }
        getFullStart() {
            return this.pos;
        }
        getEnd() {
            return this.end;
        }
        getWidth(sourceFile) {
            return this.getEnd() - this.getStart(sourceFile);
        }
        getFullWidth() {
            return this.end - this.pos;
        }
        getLeadingTriviaWidth(sourceFile) {
            return this.getStart(sourceFile) - this.pos;
        }
        getFullText(sourceFile) {
            return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
        }
        getText(sourceFile) {
            if (!sourceFile) sourceFile = this.getSourceFile();
            return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
        }
        getChildCount() {
            return this.getChildren().length;
        }
        getChildAt(index) {
            return this.getChildren()[index];
        }
        getChildren() {
            return this.kind === 1 /* EndOfFileToken */  ? this.jsDoc || emptyArray : emptyArray;
        }
        getFirstToken() {
            return void 0;
        }
        getLastToken() {
            return void 0;
        }
        forEachChild() {
            return void 0;
        }
        constructor(kind, pos, end){
            this.pos = pos;
            this.end = end;
            this.kind = kind;
            this.id = 0;
            this.flags = 0 /* None */ ;
            this.transformFlags = 0 /* None */ ;
            this.parent = void 0;
            this.emitNode = void 0;
        }
    };
    var SymbolObject = class {
        getFlags() {
            return this.flags;
        }
        get name() {
            return symbolName(this);
        }
        getEscapedName() {
            return this.escapedName;
        }
        getName() {
            return this.name;
        }
        getDeclarations() {
            return this.declarations;
        }
        getDocumentationComment(checker) {
            if (!this.documentationComment) {
                this.documentationComment = emptyArray;
                if (!this.declarations && isTransientSymbol(this) && this.links.target && isTransientSymbol(this.links.target) && this.links.target.links.tupleLabelDeclaration) {
                    const labelDecl = this.links.target.links.tupleLabelDeclaration;
                    this.documentationComment = getDocumentationComment([
                        labelDecl
                    ], checker);
                } else this.documentationComment = getDocumentationComment(this.declarations, checker);
            }
            return this.documentationComment;
        }
        getContextualDocumentationComment(context, checker) {
            if (context) {
                if (isGetAccessor(context)) {
                    if (!this.contextualGetAccessorDocumentationComment) {
                        this.contextualGetAccessorDocumentationComment = emptyArray;
                        this.contextualGetAccessorDocumentationComment = getDocumentationComment(filter(this.declarations, isGetAccessor), checker);
                    }
                    if (length(this.contextualGetAccessorDocumentationComment)) return this.contextualGetAccessorDocumentationComment;
                }
                if (isSetAccessor(context)) {
                    if (!this.contextualSetAccessorDocumentationComment) {
                        this.contextualSetAccessorDocumentationComment = emptyArray;
                        this.contextualSetAccessorDocumentationComment = getDocumentationComment(filter(this.declarations, isSetAccessor), checker);
                    }
                    if (length(this.contextualSetAccessorDocumentationComment)) return this.contextualSetAccessorDocumentationComment;
                }
            }
            return this.getDocumentationComment(checker);
        }
        getJsDocTags(checker) {
            if (this.tags === void 0) {
                this.tags = emptyArray;
                this.tags = getJsDocTagsOfDeclarations(this.declarations, checker);
            }
            return this.tags;
        }
        getContextualJsDocTags(context, checker) {
            if (context) {
                if (isGetAccessor(context)) {
                    if (!this.contextualGetAccessorTags) {
                        this.contextualGetAccessorTags = emptyArray;
                        this.contextualGetAccessorTags = getJsDocTagsOfDeclarations(filter(this.declarations, isGetAccessor), checker);
                    }
                    if (length(this.contextualGetAccessorTags)) return this.contextualGetAccessorTags;
                }
                if (isSetAccessor(context)) {
                    if (!this.contextualSetAccessorTags) {
                        this.contextualSetAccessorTags = emptyArray;
                        this.contextualSetAccessorTags = getJsDocTagsOfDeclarations(filter(this.declarations, isSetAccessor), checker);
                    }
                    if (length(this.contextualSetAccessorTags)) return this.contextualSetAccessorTags;
                }
            }
            return this.getJsDocTags(checker);
        }
        constructor(flags, name){
            this.flags = flags;
            this.escapedName = name;
            this.declarations = void 0;
            this.valueDeclaration = void 0;
            this.id = 0;
            this.mergeId = 0;
            this.parent = void 0;
            this.members = void 0;
            this.exports = void 0;
            this.exportSymbol = void 0;
            this.constEnumOnlyModule = void 0;
            this.isReferenced = void 0;
            this.lastAssignmentPos = void 0;
            this.links = void 0;
        }
    };
    var TokenObject = class extends TokenOrIdentifierObject {
        constructor(kind, pos, end){
            super(kind, pos, end);
        }
    };
    var IdentifierObject = class extends TokenOrIdentifierObject {
        get text() {
            return idText(this);
        }
        constructor(kind, pos, end){
            super(kind, pos, end);
        }
    };
    var PrivateIdentifierObject = class extends TokenOrIdentifierObject {
        get text() {
            return idText(this);
        }
        constructor(kind, pos, end){
            super(kind, pos, end);
        }
    };
    var TypeObject = class {
        getFlags() {
            return this.flags;
        }
        getSymbol() {
            return this.symbol;
        }
        getProperties() {
            return this.checker.getPropertiesOfType(this);
        }
        getProperty(propertyName) {
            return this.checker.getPropertyOfType(this, propertyName);
        }
        getApparentProperties() {
            return this.checker.getAugmentedPropertiesOfType(this);
        }
        getCallSignatures() {
            return this.checker.getSignaturesOfType(this, 0 /* Call */ );
        }
        getConstructSignatures() {
            return this.checker.getSignaturesOfType(this, 1 /* Construct */ );
        }
        getStringIndexType() {
            return this.checker.getIndexTypeOfType(this, 0 /* String */ );
        }
        getNumberIndexType() {
            return this.checker.getIndexTypeOfType(this, 1 /* Number */ );
        }
        getBaseTypes() {
            return this.isClassOrInterface() ? this.checker.getBaseTypes(this) : void 0;
        }
        isNullableType() {
            return this.checker.isNullableType(this);
        }
        getNonNullableType() {
            return this.checker.getNonNullableType(this);
        }
        getNonOptionalType() {
            return this.checker.getNonOptionalType(this);
        }
        getConstraint() {
            return this.checker.getBaseConstraintOfType(this);
        }
        getDefault() {
            return this.checker.getDefaultFromTypeParameter(this);
        }
        isUnion() {
            return !!(this.flags & 1048576 /* Union */ );
        }
        isIntersection() {
            return !!(this.flags & 2097152 /* Intersection */ );
        }
        isUnionOrIntersection() {
            return !!(this.flags & 3145728 /* UnionOrIntersection */ );
        }
        isLiteral() {
            return !!(this.flags & 2432 /* BigIntLiteral */ );
        }
        isStringLiteral() {
            return !!(this.flags & 128 /* StringLiteral */ );
        }
        isNumberLiteral() {
            return !!(this.flags & 256 /* NumberLiteral */ );
        }
        isTypeParameter() {
            return !!(this.flags & 262144 /* TypeParameter */ );
        }
        isClassOrInterface() {
            return !!(getObjectFlags(this) & 3 /* ClassOrInterface */ );
        }
        isClass() {
            return !!(getObjectFlags(this) & 1 /* Class */ );
        }
        isIndexType() {
            return !!(this.flags & 4194304 /* Index */ );
        }
        /**
   * This polyfills `referenceType.typeArguments` for API consumers
   */ get typeArguments() {
            if (getObjectFlags(this) & 4 /* Reference */ ) return this.checker.getTypeArguments(this);
            return void 0;
        }
        constructor(checker, flags){
            this.flags = flags;
            this.checker = checker;
        }
    };
    var SignatureObject = class {
        getDeclaration() {
            return this.declaration;
        }
        getTypeParameters() {
            return this.typeParameters;
        }
        getParameters() {
            return this.parameters;
        }
        getReturnType() {
            return this.checker.getReturnTypeOfSignature(this);
        }
        getTypeParameterAtPosition(pos) {
            const type = this.checker.getParameterType(this, pos);
            if (type.isIndexType() && isThisTypeParameter(type.type)) {
                const constraint = type.type.getConstraint();
                if (constraint) return this.checker.getIndexType(constraint);
            }
            return type;
        }
        getDocumentationComment() {
            return this.documentationComment || (this.documentationComment = getDocumentationComment(singleElementArray(this.declaration), this.checker));
        }
        getJsDocTags() {
            return this.jsDocTags || (this.jsDocTags = getJsDocTagsOfDeclarations(singleElementArray(this.declaration), this.checker));
        }
        // same
        constructor(checker, flags){
            this.flags = flags;
            this.checker = checker;
        }
    };
    function hasJSDocInheritDocTag(node) {
        return getJSDocTags(node).some((tag)=>tag.tagName.text === "inheritDoc" || tag.tagName.text === "inheritdoc");
    }
    function getJsDocTagsOfDeclarations(declarations, checker) {
        if (!declarations) return emptyArray;
        let tags = ts_JsDoc_exports.getJsDocTagsFromDeclarations(declarations, checker);
        if (checker && (tags.length === 0 || declarations.some(hasJSDocInheritDocTag))) {
            const seenSymbols = /* @__PURE__ */ new Set();
            for (const declaration of declarations){
                const inheritedTags = findBaseOfDeclaration(checker, declaration, (symbol)=>{
                    var _a;
                    if (!seenSymbols.has(symbol)) {
                        seenSymbols.add(symbol);
                        if (declaration.kind === 178 /* GetAccessor */  || declaration.kind === 179 /* SetAccessor */ ) return symbol.getContextualJsDocTags(declaration, checker);
                        return ((_a = symbol.declarations) == null ? void 0 : _a.length) === 1 ? symbol.getJsDocTags(checker) : void 0;
                    }
                });
                if (inheritedTags) tags = [
                    ...inheritedTags,
                    ...tags
                ];
            }
        }
        return tags;
    }
    function getDocumentationComment(declarations, checker) {
        if (!declarations) return emptyArray;
        let doc = ts_JsDoc_exports.getJsDocCommentsFromDeclarations(declarations, checker);
        if (checker && (doc.length === 0 || declarations.some(hasJSDocInheritDocTag))) {
            const seenSymbols = /* @__PURE__ */ new Set();
            for (const declaration of declarations){
                const inheritedDocs = findBaseOfDeclaration(checker, declaration, (symbol)=>{
                    if (!seenSymbols.has(symbol)) {
                        seenSymbols.add(symbol);
                        if (declaration.kind === 178 /* GetAccessor */  || declaration.kind === 179 /* SetAccessor */ ) return symbol.getContextualDocumentationComment(declaration, checker);
                        return symbol.getDocumentationComment(checker);
                    }
                });
                if (inheritedDocs) doc = doc.length === 0 ? inheritedDocs.slice() : inheritedDocs.concat(lineBreakPart(), doc);
            }
        }
        return doc;
    }
    function findBaseOfDeclaration(checker, declaration, cb) {
        var _a;
        const classOrInterfaceDeclaration = ((_a = declaration.parent) == null ? void 0 : _a.kind) === 177 /* Constructor */  ? declaration.parent.parent : declaration.parent;
        if (!classOrInterfaceDeclaration) return;
        const isStaticMember = hasStaticModifier(declaration);
        return firstDefined(getAllSuperTypeNodes(classOrInterfaceDeclaration), (superTypeNode)=>{
            const baseType = checker.getTypeAtLocation(superTypeNode);
            const type = isStaticMember && baseType.symbol ? checker.getTypeOfSymbol(baseType.symbol) : baseType;
            const symbol = checker.getPropertyOfType(type, declaration.symbol.name);
            return symbol ? cb(symbol) : void 0;
        });
    }
    var SourceFileObject = class extends NodeObject {
        update(newText, textChangeRange) {
            return updateSourceFile(this, newText, textChangeRange);
        }
        getLineAndCharacterOfPosition(position) {
            return getLineAndCharacterOfPosition(this, position);
        }
        getLineStarts() {
            return getLineStarts(this);
        }
        getPositionOfLineAndCharacter(line, character, allowEdits) {
            return computePositionOfLineAndCharacter(getLineStarts(this), line, character, this.text, allowEdits);
        }
        getLineEndOfPosition(pos) {
            const { line } = this.getLineAndCharacterOfPosition(pos);
            const lineStarts = this.getLineStarts();
            let lastCharPos;
            if (line + 1 >= lineStarts.length) lastCharPos = this.getEnd();
            if (!lastCharPos) lastCharPos = lineStarts[line + 1] - 1;
            const fullText = this.getFullText();
            return fullText[lastCharPos] === "\n" && fullText[lastCharPos - 1] === "\r" ? lastCharPos - 1 : lastCharPos;
        }
        getNamedDeclarations() {
            if (!this.namedDeclarations) this.namedDeclarations = this.computeNamedDeclarations();
            return this.namedDeclarations;
        }
        computeNamedDeclarations() {
            const result = createMultiMap();
            this.forEachChild(visit);
            return result;
            function addDeclaration(declaration) {
                const name = getDeclarationName(declaration);
                if (name) result.add(name, declaration);
            }
            function getDeclarations(name) {
                let declarations = result.get(name);
                if (!declarations) result.set(name, declarations = []);
                return declarations;
            }
            function getDeclarationName(declaration) {
                const name = getNonAssignedNameOfDeclaration(declaration);
                return name && (isComputedPropertyName(name) && isPropertyAccessExpression(name.expression) ? name.expression.name.text : isPropertyName(name) ? getNameFromPropertyName(name) : void 0);
            }
            function visit(node) {
                switch(node.kind){
                    case 263 /* FunctionDeclaration */ :
                    case 219 /* FunctionExpression */ :
                    case 175 /* MethodDeclaration */ :
                    case 174 /* MethodSignature */ :
                        const functionDeclaration = node;
                        const declarationName = getDeclarationName(functionDeclaration);
                        if (declarationName) {
                            const declarations = getDeclarations(declarationName);
                            const lastDeclaration = lastOrUndefined(declarations);
                            if (lastDeclaration && functionDeclaration.parent === lastDeclaration.parent && functionDeclaration.symbol === lastDeclaration.symbol) {
                                if (functionDeclaration.body && !lastDeclaration.body) declarations[declarations.length - 1] = functionDeclaration;
                            } else declarations.push(functionDeclaration);
                        }
                        forEachChild(node, visit);
                        break;
                    case 264 /* ClassDeclaration */ :
                    case 232 /* ClassExpression */ :
                    case 265 /* InterfaceDeclaration */ :
                    case 266 /* TypeAliasDeclaration */ :
                    case 267 /* EnumDeclaration */ :
                    case 268 /* ModuleDeclaration */ :
                    case 272 /* ImportEqualsDeclaration */ :
                    case 282 /* ExportSpecifier */ :
                    case 277 /* ImportSpecifier */ :
                    case 274 /* ImportClause */ :
                    case 275 /* NamespaceImport */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 188 /* TypeLiteral */ :
                        addDeclaration(node);
                        forEachChild(node, visit);
                        break;
                    case 170 /* Parameter */ :
                        if (!hasSyntacticModifier(node, 31 /* ParameterPropertyModifier */ )) break;
                    // falls through
                    case 261 /* VariableDeclaration */ :
                    case 209 /* BindingElement */ :
                        {
                            const decl = node;
                            if (isBindingPattern(decl.name)) {
                                forEachChild(decl.name, visit);
                                break;
                            }
                            if (decl.initializer) visit(decl.initializer);
                        }
                    // falls through
                    case 307 /* EnumMember */ :
                    case 173 /* PropertyDeclaration */ :
                    case 172 /* PropertySignature */ :
                        addDeclaration(node);
                        break;
                    case 279 /* ExportDeclaration */ :
                        const exportDeclaration = node;
                        if (exportDeclaration.exportClause) {
                            if (isNamedExports(exportDeclaration.exportClause)) forEach(exportDeclaration.exportClause.elements, visit);
                            else visit(exportDeclaration.exportClause.name);
                        }
                        break;
                    case 273 /* ImportDeclaration */ :
                        const importClause = node.importClause;
                        if (importClause) {
                            if (importClause.name) addDeclaration(importClause.name);
                            if (importClause.namedBindings) {
                                if (importClause.namedBindings.kind === 275 /* NamespaceImport */ ) addDeclaration(importClause.namedBindings);
                                else forEach(importClause.namedBindings.elements, visit);
                            }
                        }
                        break;
                    case 227 /* BinaryExpression */ :
                        if (getAssignmentDeclarationKind(node) !== 0 /* None */ ) addDeclaration(node);
                    // falls through
                    default:
                        forEachChild(node, visit);
                }
            }
        }
        constructor(kind, pos, end){
            super(kind, pos, end);
        }
    };
    var SourceMapSourceObject = class {
        getLineAndCharacterOfPosition(pos) {
            return getLineAndCharacterOfPosition(this, pos);
        }
        constructor(fileName, text, skipTrivia2){
            this.fileName = fileName;
            this.text = text;
            this.skipTrivia = skipTrivia2 || ((pos)=>pos);
        }
    };
    function getServicesObjectAllocator() {
        return {
            getNodeConstructor: ()=>NodeObject,
            getTokenConstructor: ()=>TokenObject,
            getIdentifierConstructor: ()=>IdentifierObject,
            getPrivateIdentifierConstructor: ()=>PrivateIdentifierObject,
            getSourceFileConstructor: ()=>SourceFileObject,
            getSymbolConstructor: ()=>SymbolObject,
            getTypeConstructor: ()=>TypeObject,
            getSignatureConstructor: ()=>SignatureObject,
            getSourceMapSourceConstructor: ()=>SourceMapSourceObject
        };
    }
    function toEditorSettings(optionsAsMap) {
        let allPropertiesAreCamelCased = true;
        for(const key in optionsAsMap)if (hasProperty(optionsAsMap, key) && !isCamelCase(key)) {
            allPropertiesAreCamelCased = false;
            break;
        }
        if (allPropertiesAreCamelCased) return optionsAsMap;
        const settings = {};
        for(const key in optionsAsMap)if (hasProperty(optionsAsMap, key)) {
            const newKey = isCamelCase(key) ? key : key.charAt(0).toLowerCase() + key.substr(1);
            settings[newKey] = optionsAsMap[key];
        }
        return settings;
    }
    function isCamelCase(s) {
        return !s.length || s.charAt(0) === s.charAt(0).toLowerCase();
    }
    function displayPartsToString(displayParts) {
        if (displayParts) return map(displayParts, (displayPart2)=>displayPart2.text).join("");
        return "";
    }
    function getDefaultCompilerOptions2() {
        return {
            target: 1 /* ES5 */ ,
            jsx: 1 /* Preserve */ 
        };
    }
    function getSupportedCodeFixes() {
        return ts_codefix_exports.getSupportedErrorCodes();
    }
    var SyntaxTreeCache = class {
        getCurrentSourceFile(fileName) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const scriptSnapshot = this.host.getScriptSnapshot(fileName);
            if (!scriptSnapshot) throw new Error("Could not find file: '" + fileName + "'.");
            const scriptKind = getScriptKind(fileName, this.host);
            const version2 = this.host.getScriptVersion(fileName);
            let sourceFile;
            if (this.currentFileName !== fileName) {
                const options = {
                    languageVersion: 99 /* Latest */ ,
                    impliedNodeFormat: getImpliedNodeFormatForFile(toPath(fileName, this.host.getCurrentDirectory(), ((_c = (_b = (_a = this.host).getCompilerHost) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.getCanonicalFileName) || hostGetCanonicalFileName(this.host)), (_h = (_g = (_f = (_e = (_d = this.host).getCompilerHost) == null ? void 0 : _e.call(_d)) == null ? void 0 : _f.getModuleResolutionCache) == null ? void 0 : _g.call(_f)) == null ? void 0 : _h.getPackageJsonInfoCache(), this.host, this.host.getCompilationSettings()),
                    setExternalModuleIndicator: getSetExternalModuleIndicator(this.host.getCompilationSettings()),
                    // These files are used to produce syntax-based highlighting, which reads JSDoc, so we must use ParseAll.
                    jsDocParsingMode: 0 /* ParseAll */ 
                };
                sourceFile = createLanguageServiceSourceFile(fileName, scriptSnapshot, options, version2, /*setNodeParents*/ true, scriptKind);
            } else if (this.currentFileVersion !== version2) {
                const editRange = scriptSnapshot.getChangeRange(this.currentFileScriptSnapshot);
                sourceFile = updateLanguageServiceSourceFile(this.currentSourceFile, scriptSnapshot, version2, editRange);
            }
            if (sourceFile) {
                this.currentFileVersion = version2;
                this.currentFileName = fileName;
                this.currentFileScriptSnapshot = scriptSnapshot;
                this.currentSourceFile = sourceFile;
            }
            return this.currentSourceFile;
        }
        constructor(host){
            this.host = host;
        }
    };
    function setSourceFileFields(sourceFile, scriptSnapshot, version2) {
        sourceFile.version = version2;
        sourceFile.scriptSnapshot = scriptSnapshot;
    }
    function createLanguageServiceSourceFile(fileName, scriptSnapshot, scriptTargetOrOptions, version2, setNodeParents, scriptKind) {
        const sourceFile = createSourceFile(fileName, getSnapshotText(scriptSnapshot), scriptTargetOrOptions, setNodeParents, scriptKind);
        setSourceFileFields(sourceFile, scriptSnapshot, version2);
        return sourceFile;
    }
    function updateLanguageServiceSourceFile(sourceFile, scriptSnapshot, version2, textChangeRange, aggressiveChecks) {
        if (textChangeRange) {
            if (version2 !== sourceFile.version) {
                let newText;
                const prefix = textChangeRange.span.start !== 0 ? sourceFile.text.substr(0, textChangeRange.span.start) : "";
                const suffix = textSpanEnd(textChangeRange.span) !== sourceFile.text.length ? sourceFile.text.substr(textSpanEnd(textChangeRange.span)) : "";
                if (textChangeRange.newLength === 0) newText = prefix && suffix ? prefix + suffix : prefix || suffix;
                else {
                    const changedText = scriptSnapshot.getText(textChangeRange.span.start, textChangeRange.span.start + textChangeRange.newLength);
                    newText = prefix && suffix ? prefix + changedText + suffix : prefix ? prefix + changedText : changedText + suffix;
                }
                const newSourceFile = updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
                setSourceFileFields(newSourceFile, scriptSnapshot, version2);
                newSourceFile.nameTable = void 0;
                if (sourceFile !== newSourceFile && sourceFile.scriptSnapshot) {
                    if (sourceFile.scriptSnapshot.dispose) sourceFile.scriptSnapshot.dispose();
                    sourceFile.scriptSnapshot = void 0;
                }
                return newSourceFile;
            }
        }
        const options = {
            languageVersion: sourceFile.languageVersion,
            impliedNodeFormat: sourceFile.impliedNodeFormat,
            setExternalModuleIndicator: sourceFile.setExternalModuleIndicator,
            jsDocParsingMode: sourceFile.jsDocParsingMode
        };
        return createLanguageServiceSourceFile(sourceFile.fileName, scriptSnapshot, options, version2, /*setNodeParents*/ true, sourceFile.scriptKind);
    }
    var NoopCancellationToken = {
        isCancellationRequested: returnFalse,
        throwIfCancellationRequested: noop
    };
    var CancellationTokenObject = class {
        isCancellationRequested() {
            return this.cancellationToken.isCancellationRequested();
        }
        throwIfCancellationRequested() {
            var _a;
            if (this.isCancellationRequested()) {
                (_a = tracing) == null || _a.instant(tracing.Phase.Session, "cancellationThrown", {
                    kind: "CancellationTokenObject"
                });
                throw new OperationCanceledException();
            }
        }
        constructor(cancellationToken){
            this.cancellationToken = cancellationToken;
        }
    };
    var ThrottledCancellationToken = class {
        isCancellationRequested() {
            const time = timestamp();
            const duration = Math.abs(time - this.lastCancellationCheckTime);
            if (duration >= this.throttleWaitMilliseconds) {
                this.lastCancellationCheckTime = time;
                return this.hostCancellationToken.isCancellationRequested();
            }
            return false;
        }
        throwIfCancellationRequested() {
            var _a;
            if (this.isCancellationRequested()) {
                (_a = tracing) == null || _a.instant(tracing.Phase.Session, "cancellationThrown", {
                    kind: "ThrottledCancellationToken"
                });
                throw new OperationCanceledException();
            }
        }
        constructor(hostCancellationToken, throttleWaitMilliseconds = 20){
            this.hostCancellationToken = hostCancellationToken;
            this.throttleWaitMilliseconds = throttleWaitMilliseconds;
            // Store when we last tried to cancel.  Checking cancellation can be expensive (as we have
            // to marshall over to the host layer).  So we only bother actually checking once enough
            // time has passed.
            this.lastCancellationCheckTime = 0;
        }
    };
    var invalidOperationsInPartialSemanticMode = [
        "getSemanticDiagnostics",
        "getSuggestionDiagnostics",
        "getCompilerOptionsDiagnostics",
        "getSemanticClassifications",
        "getEncodedSemanticClassifications",
        "getCodeFixesAtPosition",
        "getCombinedCodeFix",
        "applyCodeActionCommand",
        "organizeImports",
        "getEditsForFileRename",
        "getEmitOutput",
        "getApplicableRefactors",
        "getEditsForRefactor",
        "prepareCallHierarchy",
        "provideCallHierarchyIncomingCalls",
        "provideCallHierarchyOutgoingCalls",
        "provideInlayHints",
        "getSupportedCodeFixes",
        "getPasteEdits"
    ];
    var invalidOperationsInSyntacticMode = [
        ...invalidOperationsInPartialSemanticMode,
        "getCompletionsAtPosition",
        "getCompletionEntryDetails",
        "getCompletionEntrySymbol",
        "getSignatureHelpItems",
        "getQuickInfoAtPosition",
        "getDefinitionAtPosition",
        "getDefinitionAndBoundSpan",
        "getImplementationAtPosition",
        "getTypeDefinitionAtPosition",
        "getReferencesAtPosition",
        "findReferences",
        "getDocumentHighlights",
        "getNavigateToItems",
        "getRenameInfo",
        "findRenameLocations",
        "getApplicableRefactors",
        "preparePasteEditsForFile"
    ];
    function createLanguageService(host, documentRegistry = createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory(), host.jsDocParsingMode), syntaxOnlyOrLanguageServiceMode) {
        var _a;
        let languageServiceMode;
        if (syntaxOnlyOrLanguageServiceMode === void 0) languageServiceMode = 0 /* Semantic */ ;
        else if (typeof syntaxOnlyOrLanguageServiceMode === "boolean") languageServiceMode = syntaxOnlyOrLanguageServiceMode ? 2 /* Syntactic */  : 0 /* Semantic */ ;
        else languageServiceMode = syntaxOnlyOrLanguageServiceMode;
        const syntaxTreeCache = new SyntaxTreeCache(host);
        let program;
        let lastProjectVersion;
        let lastTypesRootVersion = 0;
        const cancellationToken = host.getCancellationToken ? new CancellationTokenObject(host.getCancellationToken()) : NoopCancellationToken;
        const currentDirectory = host.getCurrentDirectory();
        maybeSetLocalizedDiagnosticMessages((_a = host.getLocalizedDiagnosticMessages) == null ? void 0 : _a.bind(host));
        function log(message) {
            if (host.log) host.log(message);
        }
        const useCaseSensitiveFileNames2 = hostUsesCaseSensitiveFileNames(host);
        const getCanonicalFileName = createGetCanonicalFileName(useCaseSensitiveFileNames2);
        const sourceMapper = getSourceMapper({
            useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames2,
            getCurrentDirectory: ()=>currentDirectory,
            getProgram,
            fileExists: maybeBind(host, host.fileExists),
            readFile: maybeBind(host, host.readFile),
            getDocumentPositionMapper: maybeBind(host, host.getDocumentPositionMapper),
            getSourceFileLike: maybeBind(host, host.getSourceFileLike),
            log
        });
        function getValidSourceFile(fileName) {
            const sourceFile = program.getSourceFile(fileName);
            if (!sourceFile) {
                const error2 = new Error(`Could not find source file: '${fileName}'.`);
                error2.ProgramFiles = program.getSourceFiles().map((f)=>f.fileName);
                throw error2;
            }
            return sourceFile;
        }
        function synchronizeHostData() {
            if (host.updateFromProject && !host.updateFromProjectInProgress) host.updateFromProject();
            else synchronizeHostDataWorker();
        }
        function synchronizeHostDataWorker() {
            var _a2, _b, _c;
            Debug.assert(languageServiceMode !== 2 /* Syntactic */ );
            if (host.getProjectVersion) {
                const hostProjectVersion = host.getProjectVersion();
                if (hostProjectVersion) {
                    if (lastProjectVersion === hostProjectVersion && !((_a2 = host.hasChangedAutomaticTypeDirectiveNames) == null ? void 0 : _a2.call(host))) return;
                    lastProjectVersion = hostProjectVersion;
                }
            }
            const typeRootsVersion = host.getTypeRootsVersion ? host.getTypeRootsVersion() : 0;
            if (lastTypesRootVersion !== typeRootsVersion) {
                log("TypeRoots version has changed; provide new program");
                program = void 0;
                lastTypesRootVersion = typeRootsVersion;
            }
            const rootFileNames = host.getScriptFileNames().slice();
            const newSettings = host.getCompilationSettings() || getDefaultCompilerOptions2();
            const hasInvalidatedResolutions = host.hasInvalidatedResolutions || returnFalse;
            const hasInvalidatedLibResolutions = maybeBind(host, host.hasInvalidatedLibResolutions) || returnFalse;
            const hasChangedAutomaticTypeDirectiveNames = maybeBind(host, host.hasChangedAutomaticTypeDirectiveNames);
            const projectReferences = (_b = host.getProjectReferences) == null ? void 0 : _b.call(host);
            let parsedCommandLines;
            let compilerHost = {
                getSourceFile: getOrCreateSourceFile,
                getSourceFileByPath: getOrCreateSourceFileByPath,
                getCancellationToken: ()=>cancellationToken,
                getCanonicalFileName,
                useCaseSensitiveFileNames: ()=>useCaseSensitiveFileNames2,
                getNewLine: ()=>getNewLineCharacter(newSettings),
                getDefaultLibFileName: (options2)=>host.getDefaultLibFileName(options2),
                writeFile: noop,
                getCurrentDirectory: ()=>currentDirectory,
                fileExists: (fileName)=>host.fileExists(fileName),
                readFile: (fileName)=>host.readFile && host.readFile(fileName),
                getSymlinkCache: maybeBind(host, host.getSymlinkCache),
                realpath: maybeBind(host, host.realpath),
                directoryExists: (directoryName)=>{
                    return directoryProbablyExists(directoryName, host);
                },
                getDirectories: (path)=>{
                    return host.getDirectories ? host.getDirectories(path) : [];
                },
                readDirectory: (path, extensions, exclude, include, depth)=>{
                    Debug.checkDefined(host.readDirectory, "'LanguageServiceHost.readDirectory' must be implemented to correctly process 'projectReferences'");
                    return host.readDirectory(path, extensions, exclude, include, depth);
                },
                onReleaseOldSourceFile,
                onReleaseParsedCommandLine,
                hasInvalidatedResolutions,
                hasInvalidatedLibResolutions,
                hasChangedAutomaticTypeDirectiveNames,
                trace: maybeBind(host, host.trace),
                resolveModuleNames: maybeBind(host, host.resolveModuleNames),
                getModuleResolutionCache: maybeBind(host, host.getModuleResolutionCache),
                createHash: maybeBind(host, host.createHash),
                resolveTypeReferenceDirectives: maybeBind(host, host.resolveTypeReferenceDirectives),
                resolveModuleNameLiterals: maybeBind(host, host.resolveModuleNameLiterals),
                resolveTypeReferenceDirectiveReferences: maybeBind(host, host.resolveTypeReferenceDirectiveReferences),
                resolveLibrary: maybeBind(host, host.resolveLibrary),
                useSourceOfProjectReferenceRedirect: maybeBind(host, host.useSourceOfProjectReferenceRedirect),
                getParsedCommandLine,
                jsDocParsingMode: host.jsDocParsingMode,
                getGlobalTypingsCacheLocation: maybeBind(host, host.getGlobalTypingsCacheLocation)
            };
            const originalGetSourceFile = compilerHost.getSourceFile;
            const { getSourceFileWithCache } = changeCompilerHostLikeToUseCache(compilerHost, (fileName)=>toPath(fileName, currentDirectory, getCanonicalFileName), (...args)=>originalGetSourceFile.call(compilerHost, ...args));
            compilerHost.getSourceFile = getSourceFileWithCache;
            (_c = host.setCompilerHost) == null || _c.call(host, compilerHost);
            const parseConfigHost = {
                useCaseSensitiveFileNames: useCaseSensitiveFileNames2,
                fileExists: (fileName)=>compilerHost.fileExists(fileName),
                readFile: (fileName)=>compilerHost.readFile(fileName),
                directoryExists: (f)=>compilerHost.directoryExists(f),
                getDirectories: (f)=>compilerHost.getDirectories(f),
                realpath: compilerHost.realpath,
                readDirectory: (...args)=>compilerHost.readDirectory(...args),
                trace: compilerHost.trace,
                getCurrentDirectory: compilerHost.getCurrentDirectory,
                onUnRecoverableConfigFileDiagnostic: noop
            };
            const documentRegistryBucketKey = documentRegistry.getKeyForCompilationSettings(newSettings);
            let releasedScriptKinds = /* @__PURE__ */ new Set();
            if (isProgramUptoDate(program, rootFileNames, newSettings, (_path, fileName)=>host.getScriptVersion(fileName), (fileName)=>compilerHost.fileExists(fileName), hasInvalidatedResolutions, hasInvalidatedLibResolutions, hasChangedAutomaticTypeDirectiveNames, getParsedCommandLine, projectReferences)) {
                compilerHost = void 0;
                parsedCommandLines = void 0;
                releasedScriptKinds = void 0;
                return;
            }
            const options = {
                rootNames: rootFileNames,
                options: newSettings,
                host: compilerHost,
                oldProgram: program,
                projectReferences
            };
            program = createProgram(options);
            compilerHost = void 0;
            parsedCommandLines = void 0;
            releasedScriptKinds = void 0;
            sourceMapper.clearCache();
            program.getTypeChecker();
            return;
            function getParsedCommandLine(fileName) {
                const path = toPath(fileName, currentDirectory, getCanonicalFileName);
                const existing = parsedCommandLines == null ? void 0 : parsedCommandLines.get(path);
                if (existing !== void 0) return existing || void 0;
                const result = host.getParsedCommandLine ? host.getParsedCommandLine(fileName) : getParsedCommandLineOfConfigFileUsingSourceFile(fileName);
                (parsedCommandLines || (parsedCommandLines = /* @__PURE__ */ new Map())).set(path, result || false);
                return result;
            }
            function getParsedCommandLineOfConfigFileUsingSourceFile(configFileName) {
                const result = getOrCreateSourceFile(configFileName, 100 /* JSON */ );
                if (!result) return void 0;
                result.path = toPath(configFileName, currentDirectory, getCanonicalFileName);
                result.resolvedPath = result.path;
                result.originalFileName = result.fileName;
                return parseJsonSourceFileConfigFileContent(result, parseConfigHost, getNormalizedAbsolutePath(getDirectoryPath(configFileName), currentDirectory), /*existingOptions*/ void 0, getNormalizedAbsolutePath(configFileName, currentDirectory));
            }
            function onReleaseParsedCommandLine(configFileName, oldResolvedRef, oldOptions) {
                var _a3;
                if (host.getParsedCommandLine) (_a3 = host.onReleaseParsedCommandLine) == null || _a3.call(host, configFileName, oldResolvedRef, oldOptions);
                else if (oldResolvedRef) releaseOldSourceFile(oldResolvedRef.sourceFile, oldOptions);
            }
            function releaseOldSourceFile(oldSourceFile, oldOptions) {
                const oldSettingsKey = documentRegistry.getKeyForCompilationSettings(oldOptions);
                documentRegistry.releaseDocumentWithKey(oldSourceFile.resolvedPath, oldSettingsKey, oldSourceFile.scriptKind, oldSourceFile.impliedNodeFormat);
            }
            function onReleaseOldSourceFile(oldSourceFile, oldOptions, hasSourceFileByPath, newSourceFileByResolvedPath) {
                var _a3;
                releaseOldSourceFile(oldSourceFile, oldOptions);
                (_a3 = host.onReleaseOldSourceFile) == null || _a3.call(host, oldSourceFile, oldOptions, hasSourceFileByPath, newSourceFileByResolvedPath);
            }
            function getOrCreateSourceFile(fileName, languageVersionOrOptions, onError, shouldCreateNewSourceFile) {
                return getOrCreateSourceFileByPath(fileName, toPath(fileName, currentDirectory, getCanonicalFileName), languageVersionOrOptions, onError, shouldCreateNewSourceFile);
            }
            function getOrCreateSourceFileByPath(fileName, path, languageVersionOrOptions, _onError, shouldCreateNewSourceFile) {
                Debug.assert(compilerHost, "getOrCreateSourceFileByPath called after typical CompilerHost lifetime, check the callstack something with a reference to an old host.");
                const scriptSnapshot = host.getScriptSnapshot(fileName);
                if (!scriptSnapshot) return void 0;
                const scriptKind = getScriptKind(fileName, host);
                const scriptVersion = host.getScriptVersion(fileName);
                if (!shouldCreateNewSourceFile) {
                    const oldSourceFile = program && program.getSourceFileByPath(path);
                    if (oldSourceFile) {
                        if (scriptKind === oldSourceFile.scriptKind || releasedScriptKinds.has(oldSourceFile.resolvedPath)) return documentRegistry.updateDocumentWithKey(fileName, path, host, documentRegistryBucketKey, scriptSnapshot, scriptVersion, scriptKind, languageVersionOrOptions);
                        else {
                            documentRegistry.releaseDocumentWithKey(oldSourceFile.resolvedPath, documentRegistry.getKeyForCompilationSettings(program.getCompilerOptions()), oldSourceFile.scriptKind, oldSourceFile.impliedNodeFormat);
                            releasedScriptKinds.add(oldSourceFile.resolvedPath);
                        }
                    }
                }
                return documentRegistry.acquireDocumentWithKey(fileName, path, host, documentRegistryBucketKey, scriptSnapshot, scriptVersion, scriptKind, languageVersionOrOptions);
            }
        }
        function getProgram() {
            if (languageServiceMode === 2 /* Syntactic */ ) {
                Debug.assert(program === void 0);
                return void 0;
            }
            synchronizeHostData();
            return program;
        }
        function getAutoImportProvider() {
            var _a2;
            return (_a2 = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a2.call(host);
        }
        function updateIsDefinitionOfReferencedSymbols(referencedSymbols, knownSymbolSpans) {
            const checker = program.getTypeChecker();
            const symbol = getSymbolForProgram();
            if (!symbol) return false;
            for (const referencedSymbol of referencedSymbols)for (const ref of referencedSymbol.references){
                const refNode = getNodeForSpan(ref);
                Debug.assertIsDefined(refNode);
                if (knownSymbolSpans.has(ref) || ts_FindAllReferences_exports.isDeclarationOfSymbol(refNode, symbol)) {
                    knownSymbolSpans.add(ref);
                    ref.isDefinition = true;
                    const mappedSpan = getMappedDocumentSpan(ref, sourceMapper, maybeBind(host, host.fileExists));
                    if (mappedSpan) knownSymbolSpans.add(mappedSpan);
                } else ref.isDefinition = false;
            }
            return true;
            function getSymbolForProgram() {
                for (const referencedSymbol of referencedSymbols)for (const ref of referencedSymbol.references){
                    if (knownSymbolSpans.has(ref)) {
                        const refNode = getNodeForSpan(ref);
                        Debug.assertIsDefined(refNode);
                        return checker.getSymbolAtLocation(refNode);
                    }
                    const mappedSpan = getMappedDocumentSpan(ref, sourceMapper, maybeBind(host, host.fileExists));
                    if (mappedSpan && knownSymbolSpans.has(mappedSpan)) {
                        const refNode = getNodeForSpan(mappedSpan);
                        if (refNode) return checker.getSymbolAtLocation(refNode);
                    }
                }
                return void 0;
            }
            function getNodeForSpan(docSpan) {
                const sourceFile = program.getSourceFile(docSpan.fileName);
                if (!sourceFile) return void 0;
                const rawNode = getTouchingPropertyName(sourceFile, docSpan.textSpan.start);
                const adjustedNode = ts_FindAllReferences_exports.Core.getAdjustedNode(rawNode, {
                    use: ts_FindAllReferences_exports.FindReferencesUse.References
                });
                return adjustedNode;
            }
        }
        function cleanupSemanticCache() {
            if (program) {
                const key = documentRegistry.getKeyForCompilationSettings(program.getCompilerOptions());
                forEach(program.getSourceFiles(), (f)=>documentRegistry.releaseDocumentWithKey(f.resolvedPath, key, f.scriptKind, f.impliedNodeFormat));
                program = void 0;
            }
        }
        function dispose() {
            cleanupSemanticCache();
            host = void 0;
        }
        function getSyntacticDiagnostics(fileName) {
            synchronizeHostData();
            return program.getSyntacticDiagnostics(getValidSourceFile(fileName), cancellationToken).slice();
        }
        function getSemanticDiagnostics(fileName) {
            synchronizeHostData();
            const targetSourceFile = getValidSourceFile(fileName);
            const semanticDiagnostics = program.getSemanticDiagnostics(targetSourceFile, cancellationToken);
            if (!getEmitDeclarations(program.getCompilerOptions())) return semanticDiagnostics.slice();
            const declarationDiagnostics = program.getDeclarationDiagnostics(targetSourceFile, cancellationToken);
            return [
                ...semanticDiagnostics,
                ...declarationDiagnostics
            ];
        }
        function getRegionSemanticDiagnostics(fileName, ranges) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const options = program.getCompilerOptions();
            if (skipTypeChecking(sourceFile, options, program) || !canIncludeBindAndCheckDiagnostics(sourceFile, options) || program.getCachedSemanticDiagnostics(sourceFile)) return void 0;
            const nodes = getNodesForRanges(sourceFile, ranges);
            if (!nodes) return void 0;
            const checkedSpans = normalizeSpans(nodes.map((node)=>createTextSpanFromBounds(node.getFullStart(), node.getEnd())));
            const semanticDiagnostics = program.getSemanticDiagnostics(sourceFile, cancellationToken, nodes);
            return {
                diagnostics: semanticDiagnostics.slice(),
                spans: checkedSpans
            };
        }
        function getNodesForRanges(file, ranges) {
            const nodes = [];
            const spans = normalizeSpans(ranges.map((range)=>createTextSpanFromRange(range)));
            for (const span of spans){
                const nodesForSpan = getNodesForSpan(file, span);
                if (!nodesForSpan) return void 0;
                nodes.push(...nodesForSpan);
            }
            if (!nodes.length) return void 0;
            return nodes;
        }
        function getNodesForSpan(file, span) {
            if (textSpanContainsTextRange(span, file)) return void 0;
            const endToken = findTokenOnLeftOfPosition(file, textSpanEnd(span)) || file;
            const enclosingNode = findAncestor(endToken, (node)=>textRangeContainsTextSpan(node, span));
            const nodes = [];
            chooseOverlappingNodes(span, enclosingNode, nodes);
            if (file.end === span.start + span.length) nodes.push(file.endOfFileToken);
            if (some(nodes, isSourceFile)) return void 0;
            return nodes;
        }
        function chooseOverlappingNodes(span, node, result) {
            if (!nodeOverlapsWithSpan(node, span)) return false;
            if (textSpanContainsTextRange(span, node)) {
                addSourceElement(node, result);
                return true;
            }
            if (isBlockLike(node)) return chooseOverlappingBlockLike(span, node, result);
            if (isClassLike(node)) return chooseOverlappingClassLike(span, node, result);
            addSourceElement(node, result);
            return true;
        }
        function nodeOverlapsWithSpan(node, span) {
            const spanEnd = span.start + span.length;
            return node.pos < spanEnd && node.end > span.start;
        }
        function addSourceElement(node, result) {
            while(node.parent && !isSourceElement(node))node = node.parent;
            result.push(node);
        }
        function chooseOverlappingBlockLike(span, node, result) {
            const childResult = [];
            const stmts = node.statements.filter((stmt)=>chooseOverlappingNodes(span, stmt, childResult));
            if (stmts.length === node.statements.length) {
                addSourceElement(node, result);
                return true;
            }
            result.push(...childResult);
            return false;
        }
        function chooseOverlappingClassLike(span, node, result) {
            var _a2, _b, _c;
            const overlaps = (n)=>textRangeIntersectsWithTextSpan(n, span);
            if (((_a2 = node.modifiers) == null ? void 0 : _a2.some(overlaps)) || node.name && overlaps(node.name) || ((_b = node.typeParameters) == null ? void 0 : _b.some(overlaps)) || ((_c = node.heritageClauses) == null ? void 0 : _c.some(overlaps))) {
                addSourceElement(node, result);
                return true;
            }
            const childResult = [];
            const members = node.members.filter((member)=>chooseOverlappingNodes(span, member, childResult));
            if (members.length === node.members.length) {
                addSourceElement(node, result);
                return true;
            }
            result.push(...childResult);
            return false;
        }
        function getSuggestionDiagnostics(fileName) {
            synchronizeHostData();
            return computeSuggestionDiagnostics(getValidSourceFile(fileName), program, cancellationToken);
        }
        function getCompilerOptionsDiagnostics() {
            synchronizeHostData();
            return [
                ...program.getOptionsDiagnostics(cancellationToken),
                ...program.getGlobalDiagnostics(cancellationToken)
            ];
        }
        function getCompletionsAtPosition2(fileName, position, options = emptyOptions, formattingSettings) {
            const fullPreferences = (0, _objectSpreadProps._)((0, _objectSpread._)({}, identity(options)), {
                // avoid excess property check
                includeCompletionsForModuleExports: options.includeCompletionsForModuleExports || options.includeExternalModuleExports,
                includeCompletionsWithInsertText: options.includeCompletionsWithInsertText || options.includeInsertTextCompletions
            });
            synchronizeHostData();
            return ts_Completions_exports.getCompletionsAtPosition(host, program, log, getValidSourceFile(fileName), position, fullPreferences, options.triggerCharacter, options.triggerKind, cancellationToken, formattingSettings && ts_formatting_exports.getFormatContext(formattingSettings, host), options.includeSymbol);
        }
        function getCompletionEntryDetails2(fileName, position, name, formattingOptions, source, preferences = emptyOptions, data) {
            synchronizeHostData();
            return ts_Completions_exports.getCompletionEntryDetails(program, log, getValidSourceFile(fileName), position, {
                name,
                source,
                data
            }, host, formattingOptions && ts_formatting_exports.getFormatContext(formattingOptions, host), // TODO: GH#18217
            preferences, cancellationToken);
        }
        function getCompletionEntrySymbol2(fileName, position, name, source, preferences = emptyOptions) {
            synchronizeHostData();
            return ts_Completions_exports.getCompletionEntrySymbol(program, log, getValidSourceFile(fileName), position, {
                name,
                source
            }, host, preferences);
        }
        function getQuickInfoAtPosition(fileName, position, maximumLength, verbosityLevel) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const node = getTouchingPropertyName(sourceFile, position);
            if (node === sourceFile) return void 0;
            const typeChecker = program.getTypeChecker();
            const nodeForQuickInfo = getNodeForQuickInfo(node);
            const symbol = getSymbolAtLocationForQuickInfo(nodeForQuickInfo, typeChecker);
            if (!symbol || typeChecker.isUnknownSymbol(symbol)) {
                const type = shouldGetType(sourceFile, nodeForQuickInfo, position) ? typeChecker.getTypeAtLocation(nodeForQuickInfo) : void 0;
                return type && {
                    kind: "" /* unknown */ ,
                    kindModifiers: "" /* none */ ,
                    textSpan: createTextSpanFromNode(nodeForQuickInfo, sourceFile),
                    displayParts: typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>typeToDisplayParts(typeChecker2, type, getContainerNode(nodeForQuickInfo), /*flags*/ void 0, verbosityLevel)),
                    documentation: type.symbol ? type.symbol.getDocumentationComment(typeChecker) : void 0,
                    tags: type.symbol ? type.symbol.getJsDocTags(typeChecker) : void 0
                };
            }
            const { symbolKind, displayParts, documentation, tags, canIncreaseVerbosityLevel } = typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker2, symbol, sourceFile, getContainerNode(nodeForQuickInfo), nodeForQuickInfo, /*semanticMeaning*/ void 0, /*alias*/ void 0, maximumLength !== null && maximumLength !== void 0 ? maximumLength : defaultHoverMaximumTruncationLength, verbosityLevel));
            return {
                kind: symbolKind,
                kindModifiers: ts_SymbolDisplay_exports.getSymbolModifiers(typeChecker, symbol),
                textSpan: createTextSpanFromNode(nodeForQuickInfo, sourceFile),
                displayParts,
                documentation,
                tags,
                canIncreaseVerbosityLevel
            };
        }
        function preparePasteEditsForFile(fileName, copiedTextRange) {
            synchronizeHostData();
            return ts_preparePasteEdits_exports.preparePasteEdits(getValidSourceFile(fileName), copiedTextRange, program.getTypeChecker());
        }
        function getPasteEdits(args, formatOptions) {
            synchronizeHostData();
            return ts_PasteEdits_exports.pasteEditsProvider(getValidSourceFile(args.targetFile), args.pastedText, args.pasteLocations, args.copiedFrom ? {
                file: getValidSourceFile(args.copiedFrom.file),
                range: args.copiedFrom.range
            } : void 0, host, args.preferences, ts_formatting_exports.getFormatContext(formatOptions, host), cancellationToken);
        }
        function getNodeForQuickInfo(node) {
            if (isNewExpression(node.parent) && node.pos === node.parent.pos) return node.parent.expression;
            if (isNamedTupleMember(node.parent) && node.pos === node.parent.pos) return node.parent;
            if (isImportMeta(node.parent) && node.parent.name === node) return node.parent;
            if (isJsxNamespacedName(node.parent)) return node.parent;
            return node;
        }
        function shouldGetType(sourceFile, node, position) {
            switch(node.kind){
                case 80 /* Identifier */ :
                    if (node.flags & 16777216 /* JSDoc */  && !isInJSFile(node) && (node.parent.kind === 172 /* PropertySignature */  && node.parent.name === node || findAncestor(node, (n)=>n.kind === 170 /* Parameter */ ))) return false;
                    return !isLabelName(node) && !isTagName(node) && !isConstTypeReference(node.parent);
                case 212 /* PropertyAccessExpression */ :
                case 167 /* QualifiedName */ :
                    return !isInComment(sourceFile, position);
                case 110 /* ThisKeyword */ :
                case 198 /* ThisType */ :
                case 108 /* SuperKeyword */ :
                case 203 /* NamedTupleMember */ :
                    return true;
                case 237 /* MetaProperty */ :
                    return isImportMeta(node);
                default:
                    return false;
            }
        }
        function getDefinitionAtPosition2(fileName, position, searchOtherFilesOnly, stopAtAlias) {
            synchronizeHostData();
            return ts_GoToDefinition_exports.getDefinitionAtPosition(program, getValidSourceFile(fileName), position, searchOtherFilesOnly, stopAtAlias);
        }
        function getDefinitionAndBoundSpan2(fileName, position) {
            synchronizeHostData();
            return ts_GoToDefinition_exports.getDefinitionAndBoundSpan(program, getValidSourceFile(fileName), position);
        }
        function getTypeDefinitionAtPosition2(fileName, position) {
            synchronizeHostData();
            return ts_GoToDefinition_exports.getTypeDefinitionAtPosition(program.getTypeChecker(), getValidSourceFile(fileName), position);
        }
        function getImplementationAtPosition(fileName, position) {
            synchronizeHostData();
            return ts_FindAllReferences_exports.getImplementationsAtPosition(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
        }
        function getDocumentHighlights(fileName, position, filesToSearch) {
            const normalizedFileName = normalizePath(fileName);
            Debug.assert(filesToSearch.some((f)=>normalizePath(f) === normalizedFileName));
            synchronizeHostData();
            const sourceFilesToSearch = mapDefined(filesToSearch, (fileName2)=>program.getSourceFile(fileName2));
            const sourceFile = getValidSourceFile(fileName);
            return DocumentHighlights.getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch);
        }
        function findRenameLocations(fileName, position, findInStrings, findInComments, preferences) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const node = getAdjustedRenameLocation(getTouchingPropertyName(sourceFile, position));
            if (!ts_Rename_exports.nodeIsEligibleForRename(node)) return void 0;
            if (isIdentifier(node) && (isJsxOpeningElement(node.parent) || isJsxClosingElement(node.parent)) && isIntrinsicJsxName(node.escapedText)) {
                const { openingElement, closingElement } = node.parent.parent;
                return [
                    openingElement,
                    closingElement
                ].map((node2)=>{
                    const textSpan = createTextSpanFromNode(node2.tagName, sourceFile);
                    return (0, _objectSpread._)({
                        fileName: sourceFile.fileName,
                        textSpan
                    }, ts_FindAllReferences_exports.toContextSpan(textSpan, sourceFile, node2.parent));
                });
            } else {
                const quotePreference = getQuotePreference(sourceFile, preferences !== null && preferences !== void 0 ? preferences : emptyOptions);
                const providePrefixAndSuffixTextForRename = typeof preferences === "boolean" ? preferences : preferences == null ? void 0 : preferences.providePrefixAndSuffixTextForRename;
                return getReferencesWorker2(node, position, {
                    findInStrings,
                    findInComments,
                    providePrefixAndSuffixTextForRename,
                    use: ts_FindAllReferences_exports.FindReferencesUse.Rename
                }, (entry, originalNode, checker)=>ts_FindAllReferences_exports.toRenameLocation(entry, originalNode, checker, providePrefixAndSuffixTextForRename || false, quotePreference));
            }
        }
        function getReferencesAtPosition(fileName, position) {
            synchronizeHostData();
            return getReferencesWorker2(getTouchingPropertyName(getValidSourceFile(fileName), position), position, {
                use: ts_FindAllReferences_exports.FindReferencesUse.References
            }, ts_FindAllReferences_exports.toReferenceEntry);
        }
        function getReferencesWorker2(node, position, options, cb) {
            synchronizeHostData();
            const sourceFiles = options && options.use === ts_FindAllReferences_exports.FindReferencesUse.Rename ? program.getSourceFiles().filter((sourceFile)=>!program.isSourceFileDefaultLibrary(sourceFile)) : program.getSourceFiles();
            return ts_FindAllReferences_exports.findReferenceOrRenameEntries(program, cancellationToken, sourceFiles, node, position, options, cb);
        }
        function findReferences(fileName, position) {
            synchronizeHostData();
            return ts_FindAllReferences_exports.findReferencedSymbols(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
        }
        function getFileReferences(fileName) {
            synchronizeHostData();
            return ts_FindAllReferences_exports.Core.getReferencesForFileName(fileName, program, program.getSourceFiles()).map(ts_FindAllReferences_exports.toReferenceEntry);
        }
        function getNavigateToItems2(searchValue, maxResultCount, fileName, excludeDtsFiles = false, excludeLibFiles = false) {
            synchronizeHostData();
            const sourceFiles = fileName ? [
                getValidSourceFile(fileName)
            ] : program.getSourceFiles();
            return getNavigateToItems(sourceFiles, program.getTypeChecker(), cancellationToken, searchValue, maxResultCount, excludeDtsFiles, excludeLibFiles);
        }
        function getEmitOutput(fileName, emitOnlyDtsFiles, forceDtsEmit) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const customTransformers = host.getCustomTransformers && host.getCustomTransformers();
            return getFileEmitOutput(program, sourceFile, !!emitOnlyDtsFiles, cancellationToken, customTransformers, forceDtsEmit);
        }
        function getSignatureHelpItems2(fileName, position, { triggerReason } = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            return ts_SignatureHelp_exports.getSignatureHelpItems(program, sourceFile, position, triggerReason, cancellationToken);
        }
        function getNonBoundSourceFile(fileName) {
            return syntaxTreeCache.getCurrentSourceFile(fileName);
        }
        function getNameOrDottedNameSpan(fileName, startPos, _endPos) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const node = getTouchingPropertyName(sourceFile, startPos);
            if (node === sourceFile) return void 0;
            switch(node.kind){
                case 212 /* PropertyAccessExpression */ :
                case 167 /* QualifiedName */ :
                case 11 /* StringLiteral */ :
                case 97 /* FalseKeyword */ :
                case 112 /* TrueKeyword */ :
                case 106 /* NullKeyword */ :
                case 108 /* SuperKeyword */ :
                case 110 /* ThisKeyword */ :
                case 198 /* ThisType */ :
                case 80 /* Identifier */ :
                    break;
                // Cant create the text span
                default:
                    return void 0;
            }
            let nodeForStartPos = node;
            while(true){
                if (isRightSideOfPropertyAccess(nodeForStartPos) || isRightSideOfQualifiedName(nodeForStartPos)) nodeForStartPos = nodeForStartPos.parent;
                else if (isNameOfModuleDeclaration(nodeForStartPos)) {
                    if (nodeForStartPos.parent.parent.kind === 268 /* ModuleDeclaration */  && nodeForStartPos.parent.parent.body === nodeForStartPos.parent) nodeForStartPos = nodeForStartPos.parent.parent.name;
                    else break;
                } else break;
            }
            return createTextSpanFromBounds(nodeForStartPos.getStart(), node.getEnd());
        }
        function getBreakpointStatementAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            return ts_BreakpointResolver_exports.spanInSourceFileAtLocation(sourceFile, position);
        }
        function getNavigationBarItems2(fileName) {
            return getNavigationBarItems(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
        }
        function getNavigationTree2(fileName) {
            return getNavigationTree(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
        }
        function getSemanticClassifications3(fileName, span, format) {
            synchronizeHostData();
            const responseFormat = format || "original" /* Original */ ;
            if (responseFormat === "2020" /* TwentyTwenty */ ) return getSemanticClassifications2(program, cancellationToken, getValidSourceFile(fileName), span);
            else return getSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
        }
        function getEncodedSemanticClassifications3(fileName, span, format) {
            synchronizeHostData();
            const responseFormat = format || "original" /* Original */ ;
            if (responseFormat === "original" /* Original */ ) return getEncodedSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
            else return getEncodedSemanticClassifications2(program, cancellationToken, getValidSourceFile(fileName), span);
        }
        function getSyntacticClassifications2(fileName, span) {
            return getSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
        }
        function getEncodedSyntacticClassifications2(fileName, span) {
            return getEncodedSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
        }
        function getOutliningSpans(fileName) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            return ts_OutliningElementsCollector_exports.collectElements(sourceFile, cancellationToken);
        }
        const braceMatching = new Map(Object.entries({
            [19 /* OpenBraceToken */ ]: 20 /* CloseBraceToken */ ,
            [21 /* OpenParenToken */ ]: 22 /* CloseParenToken */ ,
            [23 /* OpenBracketToken */ ]: 24 /* CloseBracketToken */ ,
            [32 /* GreaterThanToken */ ]: 30 /* LessThanToken */ 
        }));
        braceMatching.forEach((value1, key)=>braceMatching.set(value1.toString(), Number(key)));
        function getBraceMatchingAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const token = getTouchingToken(sourceFile, position);
            const matchKind = token.getStart(sourceFile) === position ? braceMatching.get(token.kind.toString()) : void 0;
            const match = matchKind && findChildOfKind(token.parent, matchKind, sourceFile);
            return match ? [
                createTextSpanFromNode(token, sourceFile),
                createTextSpanFromNode(match, sourceFile)
            ].sort((a, b)=>a.start - b.start) : emptyArray;
        }
        function getIndentationAtPosition(fileName, position, editorOptions) {
            let start = timestamp();
            const settings = toEditorSettings(editorOptions);
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            log("getIndentationAtPosition: getCurrentSourceFile: " + (timestamp() - start));
            start = timestamp();
            const result = ts_formatting_exports.SmartIndenter.getIndentation(position, sourceFile, settings);
            log("getIndentationAtPosition: computeIndentation  : " + (timestamp() - start));
            return result;
        }
        function getFormattingEditsForRange(fileName, start, end, options) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            return ts_formatting_exports.formatSelection(start, end, sourceFile, ts_formatting_exports.getFormatContext(toEditorSettings(options), host));
        }
        function getFormattingEditsForDocument(fileName, options) {
            return ts_formatting_exports.formatDocument(syntaxTreeCache.getCurrentSourceFile(fileName), ts_formatting_exports.getFormatContext(toEditorSettings(options), host));
        }
        function getFormattingEditsAfterKeystroke(fileName, position, key, options) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const formatContext = ts_formatting_exports.getFormatContext(toEditorSettings(options), host);
            if (!isInComment(sourceFile, position)) switch(key){
                case "{":
                    return ts_formatting_exports.formatOnOpeningCurly(position, sourceFile, formatContext);
                case "}":
                    return ts_formatting_exports.formatOnClosingCurly(position, sourceFile, formatContext);
                case ";":
                    return ts_formatting_exports.formatOnSemicolon(position, sourceFile, formatContext);
                case "\n":
                    return ts_formatting_exports.formatOnEnter(position, sourceFile, formatContext);
            }
            return [];
        }
        function getCodeFixesAtPosition(fileName, start, end, errorCodes68, formatOptions, preferences = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const span = createTextSpanFromBounds(start, end);
            const formatContext = ts_formatting_exports.getFormatContext(formatOptions, host);
            return flatMap(deduplicate(errorCodes68, equateValues, compareValues), (errorCode)=>{
                cancellationToken.throwIfCancellationRequested();
                return ts_codefix_exports.getFixes({
                    errorCode,
                    sourceFile,
                    span,
                    program,
                    host,
                    cancellationToken,
                    formatContext,
                    preferences
                });
            });
        }
        function getCombinedCodeFix(scope, fixId56, formatOptions, preferences = emptyOptions) {
            synchronizeHostData();
            Debug.assert(scope.type === "file");
            const sourceFile = getValidSourceFile(scope.fileName);
            const formatContext = ts_formatting_exports.getFormatContext(formatOptions, host);
            return ts_codefix_exports.getAllFixes({
                fixId: fixId56,
                sourceFile,
                program,
                host,
                cancellationToken,
                formatContext,
                preferences
            });
        }
        function organizeImports2(args, formatOptions, preferences = emptyOptions) {
            synchronizeHostData();
            Debug.assert(args.type === "file");
            const sourceFile = getValidSourceFile(args.fileName);
            if (containsParseError(sourceFile)) return emptyArray;
            const formatContext = ts_formatting_exports.getFormatContext(formatOptions, host);
            var _args_mode;
            const mode = (_args_mode = args.mode) !== null && _args_mode !== void 0 ? _args_mode : args.skipDestructiveCodeActions ? "SortAndCombine" /* SortAndCombine */  : "All" /* All */ ;
            return ts_OrganizeImports_exports.organizeImports(sourceFile, formatContext, host, program, preferences, mode);
        }
        function getEditsForFileRename2(oldFilePath, newFilePath, formatOptions, preferences = emptyOptions) {
            return getEditsForFileRename(getProgram(), oldFilePath, newFilePath, host, ts_formatting_exports.getFormatContext(formatOptions, host), preferences, sourceMapper);
        }
        function applyCodeActionCommand(fileName, actionOrFormatSettingsOrUndefined) {
            const action = typeof fileName === "string" ? actionOrFormatSettingsOrUndefined : fileName;
            return isArray(action) ? Promise.all(action.map((a)=>applySingleCodeActionCommand(a))) : applySingleCodeActionCommand(action);
        }
        function applySingleCodeActionCommand(action) {
            const getPath = (path)=>toPath(path, currentDirectory, getCanonicalFileName);
            Debug.assertEqual(action.type, "install package");
            return host.installPackage ? host.installPackage({
                fileName: getPath(action.file),
                packageName: action.packageName
            }) : Promise.reject("Host does not implement `installPackage`");
        }
        function getDocCommentTemplateAtPosition2(fileName, position, options, formatOptions) {
            const formatSettings = formatOptions ? ts_formatting_exports.getFormatContext(formatOptions, host).options : void 0;
            return ts_JsDoc_exports.getDocCommentTemplateAtPosition(getNewLineOrDefaultFromHost(host, formatSettings), syntaxTreeCache.getCurrentSourceFile(fileName), position, options);
        }
        function isValidBraceCompletionAtPosition(fileName, position, openingBrace) {
            if (openingBrace === 60 /* lessThan */ ) return false;
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            if (isInString(sourceFile, position)) return false;
            if (isInsideJsxElementOrAttribute(sourceFile, position)) return openingBrace === 123 /* openBrace */ ;
            if (isInTemplateString(sourceFile, position)) return false;
            switch(openingBrace){
                case 39 /* singleQuote */ :
                case 34 /* doubleQuote */ :
                case 96 /* backtick */ :
                    return !isInComment(sourceFile, position);
            }
            return true;
        }
        function getJsxClosingTagAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const token = findPrecedingToken(position, sourceFile);
            if (!token) return void 0;
            const element = token.kind === 32 /* GreaterThanToken */  && isJsxOpeningElement(token.parent) ? token.parent.parent : isJsxText(token) && isJsxElement(token.parent) ? token.parent : void 0;
            if (element && isUnclosedTag(element)) return {
                newText: `</${element.openingElement.tagName.getText(sourceFile)}>`
            };
            const fragment = token.kind === 32 /* GreaterThanToken */  && isJsxOpeningFragment(token.parent) ? token.parent.parent : isJsxText(token) && isJsxFragment(token.parent) ? token.parent : void 0;
            if (fragment && isUnclosedFragment(fragment)) return {
                newText: "</>"
            };
        }
        function getLinkedEditingRangeAtPosition(fileName, position) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const token = findPrecedingToken(position, sourceFile);
            if (!token || token.parent.kind === 308 /* SourceFile */ ) return void 0;
            const jsxTagWordPattern = "[a-zA-Z0-9:\\-\\._$]*";
            if (isJsxFragment(token.parent.parent)) {
                const openFragment = token.parent.parent.openingFragment;
                const closeFragment = token.parent.parent.closingFragment;
                if (containsParseError(openFragment) || containsParseError(closeFragment)) return void 0;
                const openPos = openFragment.getStart(sourceFile) + 1;
                const closePos = closeFragment.getStart(sourceFile) + 2;
                if (position !== openPos && position !== closePos) return void 0;
                return {
                    ranges: [
                        {
                            start: openPos,
                            length: 0
                        },
                        {
                            start: closePos,
                            length: 0
                        }
                    ],
                    wordPattern: jsxTagWordPattern
                };
            } else {
                const tag = findAncestor(token.parent, (n)=>{
                    if (isJsxOpeningElement(n) || isJsxClosingElement(n)) return true;
                    return false;
                });
                if (!tag) return void 0;
                Debug.assert(isJsxOpeningElement(tag) || isJsxClosingElement(tag), "tag should be opening or closing element");
                const openTag = tag.parent.openingElement;
                const closeTag = tag.parent.closingElement;
                const openTagNameStart = openTag.tagName.getStart(sourceFile);
                const openTagNameEnd = openTag.tagName.end;
                const closeTagNameStart = closeTag.tagName.getStart(sourceFile);
                const closeTagNameEnd = closeTag.tagName.end;
                if (openTagNameStart === openTag.getStart(sourceFile) || closeTagNameStart === closeTag.getStart(sourceFile) || openTagNameEnd === openTag.getEnd() || closeTagNameEnd === closeTag.getEnd()) return void 0;
                if (!(openTagNameStart <= position && position <= openTagNameEnd || closeTagNameStart <= position && position <= closeTagNameEnd)) return void 0;
                const openingTagText = openTag.tagName.getText(sourceFile);
                if (openingTagText !== closeTag.tagName.getText(sourceFile)) return void 0;
                return {
                    ranges: [
                        {
                            start: openTagNameStart,
                            length: openTagNameEnd - openTagNameStart
                        },
                        {
                            start: closeTagNameStart,
                            length: closeTagNameEnd - closeTagNameStart
                        }
                    ],
                    wordPattern: jsxTagWordPattern
                };
            }
        }
        function getLinesForRange(sourceFile, textRange) {
            return {
                lineStarts: sourceFile.getLineStarts(),
                firstLine: sourceFile.getLineAndCharacterOfPosition(textRange.pos).line,
                lastLine: sourceFile.getLineAndCharacterOfPosition(textRange.end).line
            };
        }
        function toggleLineComment(fileName, textRange, insertComment) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const textChanges2 = [];
            const { lineStarts, firstLine, lastLine } = getLinesForRange(sourceFile, textRange);
            let isCommenting = insertComment || false;
            let leftMostPosition = Number.MAX_VALUE;
            const lineTextStarts = /* @__PURE__ */ new Map();
            const firstNonWhitespaceCharacterRegex = new RegExp(/\S/);
            const isJsx = isInsideJsxElement(sourceFile, lineStarts[firstLine]);
            const openComment = isJsx ? "{/*" : "//";
            for(let i = firstLine; i <= lastLine; i++){
                const lineText = sourceFile.text.substring(lineStarts[i], sourceFile.getLineEndOfPosition(lineStarts[i]));
                const regExec = firstNonWhitespaceCharacterRegex.exec(lineText);
                if (regExec) {
                    leftMostPosition = Math.min(leftMostPosition, regExec.index);
                    lineTextStarts.set(i.toString(), regExec.index);
                    if (lineText.substr(regExec.index, openComment.length) !== openComment) isCommenting = insertComment === void 0 || insertComment;
                }
            }
            for(let i = firstLine; i <= lastLine; i++){
                if (firstLine !== lastLine && lineStarts[i] === textRange.end) continue;
                const lineTextStart = lineTextStarts.get(i.toString());
                if (lineTextStart !== void 0) {
                    if (isJsx) textChanges2.push(...toggleMultilineComment(fileName, {
                        pos: lineStarts[i] + leftMostPosition,
                        end: sourceFile.getLineEndOfPosition(lineStarts[i])
                    }, isCommenting, isJsx));
                    else if (isCommenting) textChanges2.push({
                        newText: openComment,
                        span: {
                            length: 0,
                            start: lineStarts[i] + leftMostPosition
                        }
                    });
                    else if (sourceFile.text.substr(lineStarts[i] + lineTextStart, openComment.length) === openComment) textChanges2.push({
                        newText: "",
                        span: {
                            length: openComment.length,
                            start: lineStarts[i] + lineTextStart
                        }
                    });
                }
            }
            return textChanges2;
        }
        function toggleMultilineComment(fileName, textRange, insertComment, isInsideJsx) {
            var _a2;
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const textChanges2 = [];
            const { text } = sourceFile;
            let hasComment = false;
            let isCommenting = insertComment || false;
            const positions = [];
            let { pos } = textRange;
            const isJsx = isInsideJsx !== void 0 ? isInsideJsx : isInsideJsxElement(sourceFile, pos);
            const openMultiline = isJsx ? "{/*" : "/*";
            const closeMultiline = isJsx ? "*/}" : "*/";
            const openMultilineRegex = isJsx ? "\\{\\/\\*" : "\\/\\*";
            const closeMultilineRegex = isJsx ? "\\*\\/\\}" : "\\*\\/";
            while(pos <= textRange.end){
                const offset = text.substr(pos, openMultiline.length) === openMultiline ? openMultiline.length : 0;
                const commentRange = isInComment(sourceFile, pos + offset);
                if (commentRange) {
                    if (isJsx) {
                        commentRange.pos--;
                        commentRange.end++;
                    }
                    positions.push(commentRange.pos);
                    if (commentRange.kind === 3 /* MultiLineCommentTrivia */ ) positions.push(commentRange.end);
                    hasComment = true;
                    pos = commentRange.end + 1;
                } else {
                    const newPos = text.substring(pos, textRange.end).search(`(${openMultilineRegex})|(${closeMultilineRegex})`);
                    isCommenting = insertComment !== void 0 ? insertComment : isCommenting || !isTextWhiteSpaceLike(text, pos, newPos === -1 ? textRange.end : pos + newPos);
                    pos = newPos === -1 ? textRange.end + 1 : pos + newPos + closeMultiline.length;
                }
            }
            if (isCommenting || !hasComment) {
                if (((_a2 = isInComment(sourceFile, textRange.pos)) == null ? void 0 : _a2.kind) !== 2 /* SingleLineCommentTrivia */ ) insertSorted(positions, textRange.pos, compareValues);
                insertSorted(positions, textRange.end, compareValues);
                const firstPos = positions[0];
                if (text.substr(firstPos, openMultiline.length) !== openMultiline) textChanges2.push({
                    newText: openMultiline,
                    span: {
                        length: 0,
                        start: firstPos
                    }
                });
                for(let i = 1; i < positions.length - 1; i++){
                    if (text.substr(positions[i] - closeMultiline.length, closeMultiline.length) !== closeMultiline) textChanges2.push({
                        newText: closeMultiline,
                        span: {
                            length: 0,
                            start: positions[i]
                        }
                    });
                    if (text.substr(positions[i], openMultiline.length) !== openMultiline) textChanges2.push({
                        newText: openMultiline,
                        span: {
                            length: 0,
                            start: positions[i]
                        }
                    });
                }
                if (textChanges2.length % 2 !== 0) textChanges2.push({
                    newText: closeMultiline,
                    span: {
                        length: 0,
                        start: positions[positions.length - 1]
                    }
                });
            } else for (const pos2 of positions){
                const from = pos2 - closeMultiline.length > 0 ? pos2 - closeMultiline.length : 0;
                const offset = text.substr(from, closeMultiline.length) === closeMultiline ? closeMultiline.length : 0;
                textChanges2.push({
                    newText: "",
                    span: {
                        length: openMultiline.length,
                        start: pos2 - offset
                    }
                });
            }
            return textChanges2;
        }
        function commentSelection(fileName, textRange) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const { firstLine, lastLine } = getLinesForRange(sourceFile, textRange);
            return firstLine === lastLine && textRange.pos !== textRange.end ? toggleMultilineComment(fileName, textRange, /*insertComment*/ true) : toggleLineComment(fileName, textRange, /*insertComment*/ true);
        }
        function uncommentSelection(fileName, textRange) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const textChanges2 = [];
            const { pos } = textRange;
            let { end } = textRange;
            if (pos === end) end += isInsideJsxElement(sourceFile, pos) ? 2 : 1;
            for(let i = pos; i <= end; i++){
                const commentRange = isInComment(sourceFile, i);
                if (commentRange) {
                    switch(commentRange.kind){
                        case 2 /* SingleLineCommentTrivia */ :
                            textChanges2.push(...toggleLineComment(fileName, {
                                end: commentRange.end,
                                pos: commentRange.pos + 1
                            }, /*insertComment*/ false));
                            break;
                        case 3 /* MultiLineCommentTrivia */ :
                            textChanges2.push(...toggleMultilineComment(fileName, {
                                end: commentRange.end,
                                pos: commentRange.pos + 1
                            }, /*insertComment*/ false));
                    }
                    i = commentRange.end + 1;
                }
            }
            return textChanges2;
        }
        function isUnclosedTag({ openingElement, closingElement, parent: parent2 }) {
            return !tagNamesAreEquivalent(openingElement.tagName, closingElement.tagName) || isJsxElement(parent2) && tagNamesAreEquivalent(openingElement.tagName, parent2.openingElement.tagName) && isUnclosedTag(parent2);
        }
        function isUnclosedFragment({ closingFragment, parent: parent2 }) {
            return !!(closingFragment.flags & 262144 /* ThisNodeHasError */ ) || isJsxFragment(parent2) && isUnclosedFragment(parent2);
        }
        function getSpanOfEnclosingComment(fileName, position, onlyMultiLine) {
            const sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
            const range = ts_formatting_exports.getRangeOfEnclosingComment(sourceFile, position);
            return range && (!onlyMultiLine || range.kind === 3 /* MultiLineCommentTrivia */ ) ? createTextSpanFromRange(range) : void 0;
        }
        function getTodoComments(fileName, descriptors) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            cancellationToken.throwIfCancellationRequested();
            const fileContents = sourceFile.text;
            const result = [];
            if (descriptors.length > 0 && !isNodeModulesFile(sourceFile.fileName)) {
                const regExp = getTodoCommentsRegExp();
                let matchArray;
                while(matchArray = regExp.exec(fileContents)){
                    cancellationToken.throwIfCancellationRequested();
                    const firstDescriptorCaptureIndex = 3;
                    Debug.assert(matchArray.length === descriptors.length + firstDescriptorCaptureIndex);
                    const preamble = matchArray[1];
                    const matchPosition = matchArray.index + preamble.length;
                    if (!isInComment(sourceFile, matchPosition)) continue;
                    let descriptor;
                    for(let i = 0; i < descriptors.length; i++)if (matchArray[i + firstDescriptorCaptureIndex]) descriptor = descriptors[i];
                    if (descriptor === void 0) return Debug.fail();
                    if (isLetterOrDigit(fileContents.charCodeAt(matchPosition + descriptor.text.length))) continue;
                    const message = matchArray[2];
                    result.push({
                        descriptor,
                        message,
                        position: matchPosition
                    });
                }
            }
            return result;
            function escapeRegExp(str) {
                return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
            }
            function getTodoCommentsRegExp() {
                const singleLineCommentStart = /(?:\/{2,}\s*)/.source;
                const multiLineCommentStart = /(?:\/\*+\s*)/.source;
                const anyNumberOfSpacesAndAsterisksAtStartOfLine = /(?:^(?:\s|\*)*)/.source;
                const preamble = "(" + anyNumberOfSpacesAndAsterisksAtStartOfLine + "|" + singleLineCommentStart + "|" + multiLineCommentStart + ")";
                const literals = "(?:" + map(descriptors, (d)=>"(" + escapeRegExp(d.text) + ")").join("|") + ")";
                const endOfLineOrEndOfComment = /(?:$|\*\/)/.source;
                const messageRemainder = /(?:.*?)/.source;
                const messagePortion = "(" + literals + messageRemainder + ")";
                const regExpString = preamble + messagePortion + endOfLineOrEndOfComment;
                return new RegExp(regExpString, "gim");
            }
            function isLetterOrDigit(char) {
                return char >= 97 /* a */  && char <= 122 /* z */  || char >= 65 /* A */  && char <= 90 /* Z */  || char >= 48 /* _0 */  && char <= 57 /* _9 */ ;
            }
            function isNodeModulesFile(path) {
                return path.includes("/node_modules/");
            }
        }
        function getRenameInfo2(fileName, position, preferences) {
            synchronizeHostData();
            return ts_Rename_exports.getRenameInfo(program, getValidSourceFile(fileName), position, preferences || {});
        }
        function getRefactorContext(file, positionOrRange, preferences, formatOptions, triggerReason, kind) {
            const [startPosition, endPosition] = typeof positionOrRange === "number" ? [
                positionOrRange,
                void 0
            ] : [
                positionOrRange.pos,
                positionOrRange.end
            ];
            return {
                file,
                startPosition,
                endPosition,
                program: getProgram(),
                host,
                formatContext: ts_formatting_exports.getFormatContext(formatOptions, host),
                // TODO: GH#18217
                cancellationToken,
                preferences,
                triggerReason,
                kind
            };
        }
        function getInlayHintsContext(file, span, preferences) {
            return {
                file,
                program: getProgram(),
                host,
                span,
                preferences,
                cancellationToken
            };
        }
        function getSmartSelectionRange2(fileName, position) {
            return ts_SmartSelectionRange_exports.getSmartSelectionRange(position, syntaxTreeCache.getCurrentSourceFile(fileName));
        }
        function getApplicableRefactors2(fileName, positionOrRange, preferences = emptyOptions, triggerReason, kind, includeInteractiveActions) {
            synchronizeHostData();
            const file = getValidSourceFile(fileName);
            return ts_refactor_exports.getApplicableRefactors(getRefactorContext(file, positionOrRange, preferences, emptyOptions, triggerReason, kind), includeInteractiveActions);
        }
        function getMoveToRefactoringFileSuggestions(fileName, positionOrRange, preferences = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const allFiles = Debug.checkDefined(program.getSourceFiles());
            const extension = extensionFromPath(fileName);
            const toMove = getStatementsToMove(getRefactorContext(sourceFile, positionOrRange, preferences, emptyOptions));
            const toMoveContainsJsx = containsJsx(toMove == null ? void 0 : toMove.all);
            const files = mapDefined(allFiles, (file)=>{
                const fileNameExtension = extensionFromPath(file.fileName);
                const isValidSourceFile = !(program == null ? void 0 : program.isSourceFileFromExternalLibrary(sourceFile)) && !(sourceFile === getValidSourceFile(file.fileName) || extension === ".ts" /* Ts */  && fileNameExtension === ".d.ts" /* Dts */  || extension === ".d.ts" /* Dts */  && startsWith(getBaseFileName(file.fileName), "lib.") && fileNameExtension === ".d.ts" /* Dts */ );
                return isValidSourceFile && (extension === fileNameExtension || (extension === ".tsx" /* Tsx */  && fileNameExtension === ".ts" /* Ts */  || extension === ".jsx" /* Jsx */  && fileNameExtension === ".js" /* Js */ ) && !toMoveContainsJsx) ? file.fileName : void 0;
            });
            return {
                newFileName: createNewFileName(sourceFile, program, host, toMove),
                files
            };
        }
        function getEditsForRefactor2(fileName, formatOptions, positionOrRange, refactorName14, actionName2, preferences = emptyOptions, interactiveRefactorArguments) {
            synchronizeHostData();
            const file = getValidSourceFile(fileName);
            return ts_refactor_exports.getEditsForRefactor(getRefactorContext(file, positionOrRange, preferences, formatOptions), refactorName14, actionName2, interactiveRefactorArguments);
        }
        function toLineColumnOffset(fileName, position) {
            if (position === 0) return {
                line: 0,
                character: 0
            };
            return sourceMapper.toLineColumnOffset(fileName, position);
        }
        function prepareCallHierarchy(fileName, position) {
            synchronizeHostData();
            const declarations = ts_CallHierarchy_exports.resolveCallHierarchyDeclaration(program, getTouchingPropertyName(getValidSourceFile(fileName), position));
            return declarations && mapOneOrMany(declarations, (declaration)=>ts_CallHierarchy_exports.createCallHierarchyItem(program, declaration));
        }
        function provideCallHierarchyIncomingCalls(fileName, position) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const declaration = firstOrOnly(ts_CallHierarchy_exports.resolveCallHierarchyDeclaration(program, position === 0 ? sourceFile : getTouchingPropertyName(sourceFile, position)));
            return declaration ? ts_CallHierarchy_exports.getIncomingCalls(program, declaration, cancellationToken) : [];
        }
        function provideCallHierarchyOutgoingCalls(fileName, position) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            const declaration = firstOrOnly(ts_CallHierarchy_exports.resolveCallHierarchyDeclaration(program, position === 0 ? sourceFile : getTouchingPropertyName(sourceFile, position)));
            return declaration ? ts_CallHierarchy_exports.getOutgoingCalls(program, declaration) : [];
        }
        function provideInlayHints2(fileName, span, preferences = emptyOptions) {
            synchronizeHostData();
            const sourceFile = getValidSourceFile(fileName);
            return ts_InlayHints_exports.provideInlayHints(getInlayHintsContext(sourceFile, span, preferences));
        }
        function mapCode2(sourceFile, contents, focusLocations, formatOptions, preferences) {
            return ts_MapCode_exports.mapCode(syntaxTreeCache.getCurrentSourceFile(sourceFile), contents, focusLocations, host, ts_formatting_exports.getFormatContext(formatOptions, host), preferences);
        }
        const ls = {
            dispose,
            cleanupSemanticCache,
            getSyntacticDiagnostics,
            getSemanticDiagnostics,
            getRegionSemanticDiagnostics,
            getSuggestionDiagnostics,
            getCompilerOptionsDiagnostics,
            getSyntacticClassifications: getSyntacticClassifications2,
            getSemanticClassifications: getSemanticClassifications3,
            getEncodedSyntacticClassifications: getEncodedSyntacticClassifications2,
            getEncodedSemanticClassifications: getEncodedSemanticClassifications3,
            getCompletionsAtPosition: getCompletionsAtPosition2,
            getCompletionEntryDetails: getCompletionEntryDetails2,
            getCompletionEntrySymbol: getCompletionEntrySymbol2,
            getSignatureHelpItems: getSignatureHelpItems2,
            getQuickInfoAtPosition,
            getDefinitionAtPosition: getDefinitionAtPosition2,
            getDefinitionAndBoundSpan: getDefinitionAndBoundSpan2,
            getImplementationAtPosition,
            getTypeDefinitionAtPosition: getTypeDefinitionAtPosition2,
            getReferencesAtPosition,
            findReferences,
            getFileReferences,
            getDocumentHighlights,
            getNameOrDottedNameSpan,
            getBreakpointStatementAtPosition,
            getNavigateToItems: getNavigateToItems2,
            getRenameInfo: getRenameInfo2,
            getSmartSelectionRange: getSmartSelectionRange2,
            findRenameLocations,
            getNavigationBarItems: getNavigationBarItems2,
            getNavigationTree: getNavigationTree2,
            getOutliningSpans,
            getTodoComments,
            getBraceMatchingAtPosition,
            getIndentationAtPosition,
            getFormattingEditsForRange,
            getFormattingEditsForDocument,
            getFormattingEditsAfterKeystroke,
            getDocCommentTemplateAtPosition: getDocCommentTemplateAtPosition2,
            isValidBraceCompletionAtPosition,
            getJsxClosingTagAtPosition,
            getLinkedEditingRangeAtPosition,
            getSpanOfEnclosingComment,
            getCodeFixesAtPosition,
            getCombinedCodeFix,
            applyCodeActionCommand,
            organizeImports: organizeImports2,
            getEditsForFileRename: getEditsForFileRename2,
            getEmitOutput,
            getNonBoundSourceFile,
            getProgram,
            getCurrentProgram: ()=>program,
            getAutoImportProvider,
            updateIsDefinitionOfReferencedSymbols,
            getApplicableRefactors: getApplicableRefactors2,
            getEditsForRefactor: getEditsForRefactor2,
            getMoveToRefactoringFileSuggestions,
            toLineColumnOffset,
            getSourceMapper: ()=>sourceMapper,
            clearSourceMapperCache: ()=>sourceMapper.clearCache(),
            prepareCallHierarchy,
            provideCallHierarchyIncomingCalls,
            provideCallHierarchyOutgoingCalls,
            toggleLineComment,
            toggleMultilineComment,
            commentSelection,
            uncommentSelection,
            provideInlayHints: provideInlayHints2,
            getSupportedCodeFixes,
            preparePasteEditsForFile,
            getPasteEdits,
            mapCode: mapCode2
        };
        switch(languageServiceMode){
            case 0 /* Semantic */ :
                break;
            case 1 /* PartialSemantic */ :
                invalidOperationsInPartialSemanticMode.forEach((key)=>ls[key] = ()=>{
                        throw new Error(`LanguageService Operation: ${key} not allowed in LanguageServiceMode.PartialSemantic`);
                    });
                break;
            case 2 /* Syntactic */ :
                invalidOperationsInSyntacticMode.forEach((key)=>ls[key] = ()=>{
                        throw new Error(`LanguageService Operation: ${key} not allowed in LanguageServiceMode.Syntactic`);
                    });
                break;
            default:
                Debug.assertNever(languageServiceMode);
        }
        return ls;
    }
    function getNameTable(sourceFile) {
        if (!sourceFile.nameTable) initializeNameTable(sourceFile);
        return sourceFile.nameTable;
    }
    function initializeNameTable(sourceFile) {
        const nameTable = sourceFile.nameTable = /* @__PURE__ */ new Map();
        sourceFile.forEachChild(function walk(node) {
            if (isIdentifier(node) && !isTagName(node) && node.escapedText || isStringOrNumericLiteralLike(node) && literalIsName(node)) {
                const text = getEscapedTextOfIdentifierOrLiteral(node);
                nameTable.set(text, nameTable.get(text) === void 0 ? node.pos : -1);
            } else if (isPrivateIdentifier(node)) {
                const text = node.escapedText;
                nameTable.set(text, nameTable.get(text) === void 0 ? node.pos : -1);
            }
            forEachChild(node, walk);
            if (hasJSDocNodes(node)) for (const jsDoc of node.jsDoc)forEachChild(jsDoc, walk);
        });
    }
    function literalIsName(node) {
        return isDeclarationName(node) || node.parent.kind === 284 /* ExternalModuleReference */  || isArgumentOfElementAccessExpression(node) || isLiteralComputedPropertyDeclarationName(node);
    }
    function getContainingObjectLiteralElement(node) {
        const element = getContainingObjectLiteralElementWorker(node);
        return element && (isObjectLiteralExpression(element.parent) || isJsxAttributes(element.parent)) ? element : void 0;
    }
    function getContainingObjectLiteralElementWorker(node) {
        switch(node.kind){
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 9 /* NumericLiteral */ :
                if (node.parent.kind === 168 /* ComputedPropertyName */ ) return isObjectLiteralElement(node.parent.parent) ? node.parent.parent : void 0;
            // falls through
            case 80 /* Identifier */ :
            case 296 /* JsxNamespacedName */ :
                return isObjectLiteralElement(node.parent) && (node.parent.parent.kind === 211 /* ObjectLiteralExpression */  || node.parent.parent.kind === 293 /* JsxAttributes */ ) && node.parent.name === node ? node.parent : void 0;
        }
        return void 0;
    }
    function getSymbolAtLocationForQuickInfo(node, checker) {
        const object = getContainingObjectLiteralElement(node);
        if (object) {
            const contextualType = checker.getContextualType(object.parent);
            const properties = contextualType && getPropertySymbolsFromContextualType(object, checker, contextualType, /*unionSymbolOk*/ false);
            if (properties && properties.length === 1) return first(properties);
        }
        return checker.getSymbolAtLocation(node);
    }
    function getPropertySymbolsFromContextualType(node, checker, contextualType, unionSymbolOk) {
        const name = getNameFromPropertyName(node.name);
        if (!name) return emptyArray;
        if (!contextualType.isUnion()) {
            const symbol = contextualType.getProperty(name);
            return symbol ? [
                symbol
            ] : emptyArray;
        }
        const filteredTypes = isObjectLiteralExpression(node.parent) || isJsxAttributes(node.parent) ? filter(contextualType.types, (t)=>!checker.isTypeInvalidDueToUnionDiscriminant(t, node.parent)) : contextualType.types;
        const discriminatedPropertySymbols = mapDefined(filteredTypes, (t)=>t.getProperty(name));
        if (unionSymbolOk && (discriminatedPropertySymbols.length === 0 || discriminatedPropertySymbols.length === contextualType.types.length)) {
            const symbol = contextualType.getProperty(name);
            if (symbol) return [
                symbol
            ];
        }
        if (!filteredTypes.length && !discriminatedPropertySymbols.length) return mapDefined(contextualType.types, (t)=>t.getProperty(name));
        return deduplicate(discriminatedPropertySymbols, equateValues);
    }
    function isArgumentOfElementAccessExpression(node) {
        return node && node.parent && node.parent.kind === 213 /* ElementAccessExpression */  && node.parent.argumentExpression === node;
    }
    function getDefaultLibFilePath(options) {
        if (sys) return combinePaths(getDirectoryPath(normalizePath(sys.getExecutingFilePath())), getDefaultLibFileName(options));
        throw new Error("getDefaultLibFilePath is only supported when consumed as a node module. ");
    }
    setObjectAllocator(getServicesObjectAllocator());
    // src/services/transform.ts
    function transform(source, transformers, compilerOptions) {
        const diagnostics = [];
        compilerOptions = fixupCompilerOptions(compilerOptions, diagnostics);
        const nodes = isArray(source) ? source : [
            source
        ];
        const result = transformNodes(/*resolver*/ void 0, /*host*/ void 0, factory, compilerOptions, nodes, transformers, /*allowDtsFiles*/ true);
        result.diagnostics = concatenate(result.diagnostics, diagnostics);
        return result;
    }
    // src/services/_namespaces/ts.BreakpointResolver.ts
    var ts_BreakpointResolver_exports = {};
    __export(ts_BreakpointResolver_exports, {
        spanInSourceFileAtLocation: ()=>spanInSourceFileAtLocation
    });
    // src/services/breakpoints.ts
    function spanInSourceFileAtLocation(sourceFile, position) {
        if (sourceFile.isDeclarationFile) return void 0;
        let tokenAtLocation = getTokenAtPosition(sourceFile, position);
        const lineOfPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
        if (sourceFile.getLineAndCharacterOfPosition(tokenAtLocation.getStart(sourceFile)).line > lineOfPosition) {
            const preceding = findPrecedingToken(tokenAtLocation.pos, sourceFile);
            if (!preceding || sourceFile.getLineAndCharacterOfPosition(preceding.getEnd()).line !== lineOfPosition) return void 0;
            tokenAtLocation = preceding;
        }
        if (tokenAtLocation.flags & 33554432 /* Ambient */ ) return void 0;
        return spanInNode(tokenAtLocation);
        function textSpan(startNode2, endNode2) {
            const lastDecorator = canHaveDecorators(startNode2) ? findLast(startNode2.modifiers, isDecorator) : void 0;
            const start = lastDecorator ? skipTrivia(sourceFile.text, lastDecorator.end) : startNode2.getStart(sourceFile);
            return createTextSpanFromBounds(start, (endNode2 || startNode2).getEnd());
        }
        function textSpanEndingAtNextToken(startNode2, previousTokenToFindNextEndToken) {
            return textSpan(startNode2, findNextToken(previousTokenToFindNextEndToken, previousTokenToFindNextEndToken.parent, sourceFile));
        }
        function spanInNodeIfStartsOnSameLine(node, otherwiseOnNode) {
            if (node && lineOfPosition === sourceFile.getLineAndCharacterOfPosition(node.getStart(sourceFile)).line) return spanInNode(node);
            return spanInNode(otherwiseOnNode);
        }
        function spanInNodeArray(nodeArray, node, match) {
            if (nodeArray) {
                const index = nodeArray.indexOf(node);
                if (index >= 0) {
                    let start = index;
                    let end = index + 1;
                    while(start > 0 && match(nodeArray[start - 1]))start--;
                    while(end < nodeArray.length && match(nodeArray[end]))end++;
                    return createTextSpanFromBounds(skipTrivia(sourceFile.text, nodeArray[start].pos), nodeArray[end - 1].end);
                }
            }
            return textSpan(node);
        }
        function spanInPreviousNode(node) {
            return spanInNode(findPrecedingToken(node.pos, sourceFile));
        }
        function spanInNextNode(node) {
            return spanInNode(findNextToken(node, node.parent, sourceFile));
        }
        function spanInNode(node) {
            if (node) {
                const { parent: parent2 } = node;
                switch(node.kind){
                    case 244 /* VariableStatement */ :
                        return spanInVariableDeclaration(node.declarationList.declarations[0]);
                    case 261 /* VariableDeclaration */ :
                    case 173 /* PropertyDeclaration */ :
                    case 172 /* PropertySignature */ :
                        return spanInVariableDeclaration(node);
                    case 170 /* Parameter */ :
                        return spanInParameterDeclaration(node);
                    case 263 /* FunctionDeclaration */ :
                    case 175 /* MethodDeclaration */ :
                    case 174 /* MethodSignature */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 177 /* Constructor */ :
                    case 219 /* FunctionExpression */ :
                    case 220 /* ArrowFunction */ :
                        return spanInFunctionDeclaration(node);
                    case 242 /* Block */ :
                        if (isFunctionBlock(node)) return spanInFunctionBlock(node);
                    // falls through
                    case 269 /* ModuleBlock */ :
                        return spanInBlock(node);
                    case 300 /* CatchClause */ :
                        return spanInBlock(node.block);
                    case 245 /* ExpressionStatement */ :
                        return textSpan(node.expression);
                    case 254 /* ReturnStatement */ :
                        return textSpan(node.getChildAt(0), node.expression);
                    case 248 /* WhileStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 247 /* DoStatement */ :
                        return spanInNode(node.statement);
                    case 260 /* DebuggerStatement */ :
                        return textSpan(node.getChildAt(0));
                    case 246 /* IfStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 257 /* LabeledStatement */ :
                        return spanInNode(node.statement);
                    case 253 /* BreakStatement */ :
                    case 252 /* ContinueStatement */ :
                        return textSpan(node.getChildAt(0), node.label);
                    case 249 /* ForStatement */ :
                        return spanInForStatement(node);
                    case 250 /* ForInStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 251 /* ForOfStatement */ :
                        return spanInInitializerOfForLike(node);
                    case 256 /* SwitchStatement */ :
                        return textSpanEndingAtNextToken(node, node.expression);
                    case 297 /* CaseClause */ :
                    case 298 /* DefaultClause */ :
                        return spanInNode(node.statements[0]);
                    case 259 /* TryStatement */ :
                        return spanInBlock(node.tryBlock);
                    case 258 /* ThrowStatement */ :
                        return textSpan(node, node.expression);
                    case 278 /* ExportAssignment */ :
                        return textSpan(node, node.expression);
                    case 272 /* ImportEqualsDeclaration */ :
                        return textSpan(node, node.moduleReference);
                    case 273 /* ImportDeclaration */ :
                        return textSpan(node, node.moduleSpecifier);
                    case 279 /* ExportDeclaration */ :
                        return textSpan(node, node.moduleSpecifier);
                    case 268 /* ModuleDeclaration */ :
                        if (getModuleInstanceState(node) !== 1 /* Instantiated */ ) return void 0;
                    // falls through
                    case 264 /* ClassDeclaration */ :
                    case 267 /* EnumDeclaration */ :
                    case 307 /* EnumMember */ :
                    case 209 /* BindingElement */ :
                        return textSpan(node);
                    case 255 /* WithStatement */ :
                        return spanInNode(node.statement);
                    case 171 /* Decorator */ :
                        return spanInNodeArray(parent2.modifiers, node, isDecorator);
                    case 207 /* ObjectBindingPattern */ :
                    case 208 /* ArrayBindingPattern */ :
                        return spanInBindingPattern(node);
                    // No breakpoint in interface, type alias
                    case 265 /* InterfaceDeclaration */ :
                    case 266 /* TypeAliasDeclaration */ :
                        return void 0;
                    // Tokens:
                    case 27 /* SemicolonToken */ :
                    case 1 /* EndOfFileToken */ :
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(node.pos, sourceFile));
                    case 28 /* CommaToken */ :
                        return spanInPreviousNode(node);
                    case 19 /* OpenBraceToken */ :
                        return spanInOpenBraceToken(node);
                    case 20 /* CloseBraceToken */ :
                        return spanInCloseBraceToken(node);
                    case 24 /* CloseBracketToken */ :
                        return spanInCloseBracketToken(node);
                    case 21 /* OpenParenToken */ :
                        return spanInOpenParenToken(node);
                    case 22 /* CloseParenToken */ :
                        return spanInCloseParenToken(node);
                    case 59 /* ColonToken */ :
                        return spanInColonToken(node);
                    case 32 /* GreaterThanToken */ :
                    case 30 /* LessThanToken */ :
                        return spanInGreaterThanOrLessThanToken(node);
                    // Keywords:
                    case 117 /* WhileKeyword */ :
                        return spanInWhileKeyword(node);
                    case 93 /* ElseKeyword */ :
                    case 85 /* CatchKeyword */ :
                    case 98 /* FinallyKeyword */ :
                        return spanInNextNode(node);
                    case 165 /* OfKeyword */ :
                        return spanInOfKeyword(node);
                    default:
                        if (isArrayLiteralOrObjectLiteralDestructuringPattern(node)) return spanInArrayLiteralOrObjectLiteralDestructuringPattern(node);
                        if ((node.kind === 80 /* Identifier */  || node.kind === 231 /* SpreadElement */  || node.kind === 304 /* PropertyAssignment */  || node.kind === 305 /* ShorthandPropertyAssignment */ ) && isArrayLiteralOrObjectLiteralDestructuringPattern(parent2)) return textSpan(node);
                        if (node.kind === 227 /* BinaryExpression */ ) {
                            const { left, operatorToken } = node;
                            if (isArrayLiteralOrObjectLiteralDestructuringPattern(left)) return spanInArrayLiteralOrObjectLiteralDestructuringPattern(left);
                            if (operatorToken.kind === 64 /* EqualsToken */  && isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) return textSpan(node);
                            if (operatorToken.kind === 28 /* CommaToken */ ) return spanInNode(left);
                        }
                        if (isExpressionNode(node)) switch(parent2.kind){
                            case 247 /* DoStatement */ :
                                return spanInPreviousNode(node);
                            case 171 /* Decorator */ :
                                return spanInNode(node.parent);
                            case 249 /* ForStatement */ :
                            case 251 /* ForOfStatement */ :
                                return textSpan(node);
                            case 227 /* BinaryExpression */ :
                                if (node.parent.operatorToken.kind === 28 /* CommaToken */ ) return textSpan(node);
                                break;
                            case 220 /* ArrowFunction */ :
                                if (node.parent.body === node) return textSpan(node);
                                break;
                        }
                        switch(node.parent.kind){
                            case 304 /* PropertyAssignment */ :
                                if (node.parent.name === node && !isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.parent)) return spanInNode(node.parent.initializer);
                                break;
                            case 217 /* TypeAssertionExpression */ :
                                if (node.parent.type === node) return spanInNextNode(node.parent.type);
                                break;
                            case 261 /* VariableDeclaration */ :
                            case 170 /* Parameter */ :
                                {
                                    const { initializer, type } = node.parent;
                                    if (initializer === node || type === node || isAssignmentOperator(node.kind)) return spanInPreviousNode(node);
                                    break;
                                }
                            case 227 /* BinaryExpression */ :
                                {
                                    const { left } = node.parent;
                                    if (isArrayLiteralOrObjectLiteralDestructuringPattern(left) && node !== left) return spanInPreviousNode(node);
                                    break;
                                }
                            default:
                                if (isFunctionLike(node.parent) && node.parent.type === node) return spanInPreviousNode(node);
                        }
                        return spanInNode(node.parent);
                }
            }
            function textSpanFromVariableDeclaration(variableDeclaration) {
                if (isVariableDeclarationList(variableDeclaration.parent) && variableDeclaration.parent.declarations[0] === variableDeclaration) return textSpan(findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent), variableDeclaration);
                else return textSpan(variableDeclaration);
            }
            function spanInVariableDeclaration(variableDeclaration) {
                if (variableDeclaration.parent.parent.kind === 250 /* ForInStatement */ ) return spanInNode(variableDeclaration.parent.parent);
                const parent2 = variableDeclaration.parent;
                if (isBindingPattern(variableDeclaration.name)) return spanInBindingPattern(variableDeclaration.name);
                if (hasOnlyExpressionInitializer(variableDeclaration) && variableDeclaration.initializer || hasSyntacticModifier(variableDeclaration, 32 /* Export */ ) || parent2.parent.kind === 251 /* ForOfStatement */ ) return textSpanFromVariableDeclaration(variableDeclaration);
                if (isVariableDeclarationList(variableDeclaration.parent) && variableDeclaration.parent.declarations[0] !== variableDeclaration) return spanInNode(findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent));
            }
            function canHaveSpanInParameterDeclaration(parameter) {
                return !!parameter.initializer || parameter.dotDotDotToken !== void 0 || hasSyntacticModifier(parameter, 3 /* Private */ );
            }
            function spanInParameterDeclaration(parameter) {
                if (isBindingPattern(parameter.name)) return spanInBindingPattern(parameter.name);
                else if (canHaveSpanInParameterDeclaration(parameter)) return textSpan(parameter);
                else {
                    const functionDeclaration = parameter.parent;
                    const indexOfParameter = functionDeclaration.parameters.indexOf(parameter);
                    Debug.assert(indexOfParameter !== -1);
                    if (indexOfParameter !== 0) return spanInParameterDeclaration(functionDeclaration.parameters[indexOfParameter - 1]);
                    else return spanInNode(functionDeclaration.body);
                }
            }
            function canFunctionHaveSpanInWholeDeclaration(functionDeclaration) {
                return hasSyntacticModifier(functionDeclaration, 32 /* Export */ ) || functionDeclaration.parent.kind === 264 /* ClassDeclaration */  && functionDeclaration.kind !== 177 /* Constructor */ ;
            }
            function spanInFunctionDeclaration(functionDeclaration) {
                if (!functionDeclaration.body) return void 0;
                if (canFunctionHaveSpanInWholeDeclaration(functionDeclaration)) return textSpan(functionDeclaration);
                return spanInNode(functionDeclaration.body);
            }
            function spanInFunctionBlock(block) {
                const nodeForSpanInBlock = block.statements.length ? block.statements[0] : block.getLastToken();
                if (canFunctionHaveSpanInWholeDeclaration(block.parent)) return spanInNodeIfStartsOnSameLine(block.parent, nodeForSpanInBlock);
                return spanInNode(nodeForSpanInBlock);
            }
            function spanInBlock(block) {
                switch(block.parent.kind){
                    case 268 /* ModuleDeclaration */ :
                        if (getModuleInstanceState(block.parent) !== 1 /* Instantiated */ ) return void 0;
                    // Set on parent if on same line otherwise on first statement
                    // falls through
                    case 248 /* WhileStatement */ :
                    case 246 /* IfStatement */ :
                    case 250 /* ForInStatement */ :
                        return spanInNodeIfStartsOnSameLine(block.parent, block.statements[0]);
                    // Set span on previous token if it starts on same line otherwise on the first statement of the block
                    case 249 /* ForStatement */ :
                    case 251 /* ForOfStatement */ :
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(block.pos, sourceFile, block.parent), block.statements[0]);
                }
                return spanInNode(block.statements[0]);
            }
            function spanInInitializerOfForLike(forLikeStatement) {
                if (forLikeStatement.initializer.kind === 262 /* VariableDeclarationList */ ) {
                    const variableDeclarationList = forLikeStatement.initializer;
                    if (variableDeclarationList.declarations.length > 0) return spanInNode(variableDeclarationList.declarations[0]);
                } else return spanInNode(forLikeStatement.initializer);
            }
            function spanInForStatement(forStatement) {
                if (forStatement.initializer) return spanInInitializerOfForLike(forStatement);
                if (forStatement.condition) return textSpan(forStatement.condition);
                if (forStatement.incrementor) return textSpan(forStatement.incrementor);
            }
            function spanInBindingPattern(bindingPattern) {
                const firstBindingElement = forEach(bindingPattern.elements, (element)=>element.kind !== 233 /* OmittedExpression */  ? element : void 0);
                if (firstBindingElement) return spanInNode(firstBindingElement);
                if (bindingPattern.parent.kind === 209 /* BindingElement */ ) return textSpan(bindingPattern.parent);
                return textSpanFromVariableDeclaration(bindingPattern.parent);
            }
            function spanInArrayLiteralOrObjectLiteralDestructuringPattern(node2) {
                Debug.assert(node2.kind !== 208 /* ArrayBindingPattern */  && node2.kind !== 207 /* ObjectBindingPattern */ );
                const elements = node2.kind === 210 /* ArrayLiteralExpression */  ? node2.elements : node2.properties;
                const firstBindingElement = forEach(elements, (element)=>element.kind !== 233 /* OmittedExpression */  ? element : void 0);
                if (firstBindingElement) return spanInNode(firstBindingElement);
                return textSpan(node2.parent.kind === 227 /* BinaryExpression */  ? node2.parent : node2);
            }
            function spanInOpenBraceToken(node2) {
                switch(node2.parent.kind){
                    case 267 /* EnumDeclaration */ :
                        const enumDeclaration = node2.parent;
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(node2.pos, sourceFile, node2.parent), enumDeclaration.members.length ? enumDeclaration.members[0] : enumDeclaration.getLastToken(sourceFile));
                    case 264 /* ClassDeclaration */ :
                        const classDeclaration = node2.parent;
                        return spanInNodeIfStartsOnSameLine(findPrecedingToken(node2.pos, sourceFile, node2.parent), classDeclaration.members.length ? classDeclaration.members[0] : classDeclaration.getLastToken(sourceFile));
                    case 270 /* CaseBlock */ :
                        return spanInNodeIfStartsOnSameLine(node2.parent.parent, node2.parent.clauses[0]);
                }
                return spanInNode(node2.parent);
            }
            function spanInCloseBraceToken(node2) {
                switch(node2.parent.kind){
                    case 269 /* ModuleBlock */ :
                        if (getModuleInstanceState(node2.parent.parent) !== 1 /* Instantiated */ ) return void 0;
                    // falls through
                    case 267 /* EnumDeclaration */ :
                    case 264 /* ClassDeclaration */ :
                        return textSpan(node2);
                    case 242 /* Block */ :
                        if (isFunctionBlock(node2.parent)) return textSpan(node2);
                    // falls through
                    case 300 /* CatchClause */ :
                        return spanInNode(lastOrUndefined(node2.parent.statements));
                    case 270 /* CaseBlock */ :
                        const caseBlock = node2.parent;
                        const lastClause = lastOrUndefined(caseBlock.clauses);
                        if (lastClause) return spanInNode(lastOrUndefined(lastClause.statements));
                        return void 0;
                    case 207 /* ObjectBindingPattern */ :
                        const bindingPattern = node2.parent;
                        return spanInNode(lastOrUndefined(bindingPattern.elements) || bindingPattern);
                    // Default to parent node
                    default:
                        if (isArrayLiteralOrObjectLiteralDestructuringPattern(node2.parent)) {
                            const objectLiteral = node2.parent;
                            return textSpan(lastOrUndefined(objectLiteral.properties) || objectLiteral);
                        }
                        return spanInNode(node2.parent);
                }
            }
            function spanInCloseBracketToken(node2) {
                switch(node2.parent.kind){
                    case 208 /* ArrayBindingPattern */ :
                        const bindingPattern = node2.parent;
                        return textSpan(lastOrUndefined(bindingPattern.elements) || bindingPattern);
                    default:
                        if (isArrayLiteralOrObjectLiteralDestructuringPattern(node2.parent)) {
                            const arrayLiteral = node2.parent;
                            return textSpan(lastOrUndefined(arrayLiteral.elements) || arrayLiteral);
                        }
                        return spanInNode(node2.parent);
                }
            }
            function spanInOpenParenToken(node2) {
                if (node2.parent.kind === 247 /* DoStatement */  || // Go to while keyword and do action instead
                node2.parent.kind === 214 /* CallExpression */  || node2.parent.kind === 215 /* NewExpression */ ) return spanInPreviousNode(node2);
                if (node2.parent.kind === 218 /* ParenthesizedExpression */ ) return spanInNextNode(node2);
                return spanInNode(node2.parent);
            }
            function spanInCloseParenToken(node2) {
                switch(node2.parent.kind){
                    case 219 /* FunctionExpression */ :
                    case 263 /* FunctionDeclaration */ :
                    case 220 /* ArrowFunction */ :
                    case 175 /* MethodDeclaration */ :
                    case 174 /* MethodSignature */ :
                    case 178 /* GetAccessor */ :
                    case 179 /* SetAccessor */ :
                    case 177 /* Constructor */ :
                    case 248 /* WhileStatement */ :
                    case 247 /* DoStatement */ :
                    case 249 /* ForStatement */ :
                    case 251 /* ForOfStatement */ :
                    case 214 /* CallExpression */ :
                    case 215 /* NewExpression */ :
                    case 218 /* ParenthesizedExpression */ :
                        return spanInPreviousNode(node2);
                    // Default to parent node
                    default:
                        return spanInNode(node2.parent);
                }
            }
            function spanInColonToken(node2) {
                if (isFunctionLike(node2.parent) || node2.parent.kind === 304 /* PropertyAssignment */  || node2.parent.kind === 170 /* Parameter */ ) return spanInPreviousNode(node2);
                return spanInNode(node2.parent);
            }
            function spanInGreaterThanOrLessThanToken(node2) {
                if (node2.parent.kind === 217 /* TypeAssertionExpression */ ) return spanInNextNode(node2);
                return spanInNode(node2.parent);
            }
            function spanInWhileKeyword(node2) {
                if (node2.parent.kind === 247 /* DoStatement */ ) return textSpanEndingAtNextToken(node2, node2.parent.expression);
                return spanInNode(node2.parent);
            }
            function spanInOfKeyword(node2) {
                if (node2.parent.kind === 251 /* ForOfStatement */ ) return spanInNextNode(node2);
                return spanInNode(node2.parent);
            }
        }
    }
    // src/services/_namespaces/ts.CallHierarchy.ts
    var ts_CallHierarchy_exports = {};
    __export(ts_CallHierarchy_exports, {
        createCallHierarchyItem: ()=>createCallHierarchyItem,
        getIncomingCalls: ()=>getIncomingCalls,
        getOutgoingCalls: ()=>getOutgoingCalls,
        resolveCallHierarchyDeclaration: ()=>resolveCallHierarchyDeclaration
    });
    // src/services/callHierarchy.ts
    function isNamedExpression(node) {
        return (isFunctionExpression(node) || isClassExpression(node)) && isNamedDeclaration(node);
    }
    function isVariableLike2(node) {
        return isPropertyDeclaration(node) || isVariableDeclaration(node);
    }
    function isAssignedExpression(node) {
        return (isFunctionExpression(node) || isArrowFunction(node) || isClassExpression(node)) && isVariableLike2(node.parent) && node === node.parent.initializer && isIdentifier(node.parent.name) && (!!(getCombinedNodeFlags(node.parent) & 2 /* Const */ ) || isPropertyDeclaration(node.parent));
    }
    function isPossibleCallHierarchyDeclaration(node) {
        return isSourceFile(node) || isModuleDeclaration(node) || isFunctionDeclaration(node) || isFunctionExpression(node) || isClassDeclaration(node) || isClassExpression(node) || isClassStaticBlockDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isGetAccessorDeclaration(node) || isSetAccessorDeclaration(node);
    }
    function isValidCallHierarchyDeclaration(node) {
        return isSourceFile(node) || isModuleDeclaration(node) && isIdentifier(node.name) || isFunctionDeclaration(node) || isClassDeclaration(node) || isClassStaticBlockDeclaration(node) || isMethodDeclaration(node) || isMethodSignature(node) || isGetAccessorDeclaration(node) || isSetAccessorDeclaration(node) || isNamedExpression(node) || isAssignedExpression(node);
    }
    function getCallHierarchyDeclarationReferenceNode(node) {
        if (isSourceFile(node)) return node;
        if (isNamedDeclaration(node)) return node.name;
        if (isAssignedExpression(node)) return node.parent.name;
        return Debug.checkDefined(node.modifiers && find(node.modifiers, isDefaultModifier3));
    }
    function isDefaultModifier3(node) {
        return node.kind === 90 /* DefaultKeyword */ ;
    }
    function getSymbolOfCallHierarchyDeclaration(typeChecker, node) {
        const location = getCallHierarchyDeclarationReferenceNode(node);
        return location && typeChecker.getSymbolAtLocation(location);
    }
    function getCallHierarchyItemName(program, node) {
        if (isSourceFile(node)) return {
            text: node.fileName,
            pos: 0,
            end: 0
        };
        if ((isFunctionDeclaration(node) || isClassDeclaration(node)) && !isNamedDeclaration(node)) {
            const defaultModifier = node.modifiers && find(node.modifiers, isDefaultModifier3);
            if (defaultModifier) return {
                text: "default",
                pos: defaultModifier.getStart(),
                end: defaultModifier.getEnd()
            };
        }
        if (isClassStaticBlockDeclaration(node)) {
            const sourceFile = node.getSourceFile();
            const pos = skipTrivia(sourceFile.text, moveRangePastModifiers(node).pos);
            const end = pos + 6;
            const typeChecker = program.getTypeChecker();
            const symbol = typeChecker.getSymbolAtLocation(node.parent);
            const prefix = symbol ? `${typeChecker.symbolToString(symbol, node.parent)} ` : "";
            return {
                text: `${prefix}static {}`,
                pos,
                end
            };
        }
        const declName = isAssignedExpression(node) ? node.parent.name : Debug.checkDefined(getNameOfDeclaration(node), "Expected call hierarchy item to have a name");
        let text = isIdentifier(declName) ? idText(declName) : isStringOrNumericLiteralLike(declName) ? declName.text : isComputedPropertyName(declName) ? isStringOrNumericLiteralLike(declName.expression) ? declName.expression.text : void 0 : void 0;
        if (text === void 0) {
            const typeChecker = program.getTypeChecker();
            const symbol = typeChecker.getSymbolAtLocation(declName);
            if (symbol) text = typeChecker.symbolToString(symbol, node);
        }
        if (text === void 0) {
            const printer = createPrinterWithRemoveCommentsOmitTrailingSemicolon();
            text = usingSingleLineStringWriter((writer)=>printer.writeNode(4 /* Unspecified */ , node, node.getSourceFile(), writer));
        }
        return {
            text,
            pos: declName.getStart(),
            end: declName.getEnd()
        };
    }
    function getCallHierarchItemContainerName(node) {
        var _a, _b, _c, _d;
        if (isAssignedExpression(node)) {
            if (isPropertyDeclaration(node.parent) && isClassLike(node.parent.parent)) return isClassExpression(node.parent.parent) ? (_a = getAssignedName(node.parent.parent)) == null ? void 0 : _a.getText() : (_b = node.parent.parent.name) == null ? void 0 : _b.getText();
            if (isModuleBlock(node.parent.parent.parent.parent) && isIdentifier(node.parent.parent.parent.parent.parent.name)) return node.parent.parent.parent.parent.parent.name.getText();
            return;
        }
        switch(node.kind){
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 175 /* MethodDeclaration */ :
                if (node.parent.kind === 211 /* ObjectLiteralExpression */ ) return (_c = getAssignedName(node.parent)) == null ? void 0 : _c.getText();
                return (_d = getNameOfDeclaration(node.parent)) == null ? void 0 : _d.getText();
            case 263 /* FunctionDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 268 /* ModuleDeclaration */ :
                if (isModuleBlock(node.parent) && isIdentifier(node.parent.parent.name)) return node.parent.parent.name.getText();
        }
    }
    function findImplementation(typeChecker, node) {
        if (node.body) return node;
        if (isConstructorDeclaration(node)) return getFirstConstructorWithBody(node.parent);
        if (isFunctionDeclaration(node) || isMethodDeclaration(node)) {
            const symbol = getSymbolOfCallHierarchyDeclaration(typeChecker, node);
            if (symbol && symbol.valueDeclaration && isFunctionLikeDeclaration(symbol.valueDeclaration) && symbol.valueDeclaration.body) return symbol.valueDeclaration;
            return void 0;
        }
        return node;
    }
    function findAllInitialDeclarations(typeChecker, node) {
        const symbol = getSymbolOfCallHierarchyDeclaration(typeChecker, node);
        let declarations;
        if (symbol && symbol.declarations) {
            const indices = indicesOf(symbol.declarations);
            const keys = map(symbol.declarations, (decl)=>({
                    file: decl.getSourceFile().fileName,
                    pos: decl.pos
                }));
            indices.sort((a, b)=>compareStringsCaseSensitive(keys[a].file, keys[b].file) || keys[a].pos - keys[b].pos);
            const sortedDeclarations = map(indices, (i)=>symbol.declarations[i]);
            let lastDecl;
            for (const decl of sortedDeclarations)if (isValidCallHierarchyDeclaration(decl)) {
                if (!lastDecl || lastDecl.parent !== decl.parent || lastDecl.end !== decl.pos) declarations = append(declarations, decl);
                lastDecl = decl;
            }
        }
        return declarations;
    }
    function findImplementationOrAllInitialDeclarations(typeChecker, node) {
        if (isClassStaticBlockDeclaration(node)) return node;
        var _findImplementation, _ref;
        if (isFunctionLikeDeclaration(node)) return (_ref = (_findImplementation = findImplementation(typeChecker, node)) !== null && _findImplementation !== void 0 ? _findImplementation : findAllInitialDeclarations(typeChecker, node)) !== null && _ref !== void 0 ? _ref : node;
        var _findAllInitialDeclarations;
        return (_findAllInitialDeclarations = findAllInitialDeclarations(typeChecker, node)) !== null && _findAllInitialDeclarations !== void 0 ? _findAllInitialDeclarations : node;
    }
    function resolveCallHierarchyDeclaration(program, location) {
        const typeChecker = program.getTypeChecker();
        let followingSymbol = false;
        while(true){
            if (isValidCallHierarchyDeclaration(location)) return findImplementationOrAllInitialDeclarations(typeChecker, location);
            if (isPossibleCallHierarchyDeclaration(location)) {
                const ancestor = findAncestor(location, isValidCallHierarchyDeclaration);
                return ancestor && findImplementationOrAllInitialDeclarations(typeChecker, ancestor);
            }
            if (isDeclarationName(location)) {
                if (isValidCallHierarchyDeclaration(location.parent)) return findImplementationOrAllInitialDeclarations(typeChecker, location.parent);
                if (isPossibleCallHierarchyDeclaration(location.parent)) {
                    const ancestor = findAncestor(location.parent, isValidCallHierarchyDeclaration);
                    return ancestor && findImplementationOrAllInitialDeclarations(typeChecker, ancestor);
                }
                if (isVariableLike2(location.parent) && location.parent.initializer && isAssignedExpression(location.parent.initializer)) return location.parent.initializer;
                return void 0;
            }
            if (isConstructorDeclaration(location)) {
                if (isValidCallHierarchyDeclaration(location.parent)) return location.parent;
                return void 0;
            }
            if (location.kind === 126 /* StaticKeyword */  && isClassStaticBlockDeclaration(location.parent)) {
                location = location.parent;
                continue;
            }
            if (isVariableDeclaration(location) && location.initializer && isAssignedExpression(location.initializer)) return location.initializer;
            if (!followingSymbol) {
                let symbol = typeChecker.getSymbolAtLocation(location);
                if (symbol) {
                    if (symbol.flags & 2097152 /* Alias */ ) symbol = typeChecker.getAliasedSymbol(symbol);
                    if (symbol.valueDeclaration) {
                        followingSymbol = true;
                        location = symbol.valueDeclaration;
                        continue;
                    }
                }
            }
            return void 0;
        }
    }
    function createCallHierarchyItem(program, node) {
        const sourceFile = node.getSourceFile();
        const name = getCallHierarchyItemName(program, node);
        const containerName = getCallHierarchItemContainerName(node);
        const kind = getNodeKind(node);
        const kindModifiers = getNodeModifiers(node);
        const span = createTextSpanFromBounds(skipTrivia(sourceFile.text, node.getFullStart(), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true), node.getEnd());
        const selectionSpan = createTextSpanFromBounds(name.pos, name.end);
        return {
            file: sourceFile.fileName,
            kind,
            kindModifiers,
            name: name.text,
            containerName,
            span,
            selectionSpan
        };
    }
    function isDefined(x) {
        return x !== void 0;
    }
    function convertEntryToCallSite(entry) {
        if (entry.kind === ts_FindAllReferences_exports.EntryKind.Node) {
            const { node } = entry;
            if (isCallOrNewExpressionTarget(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isTaggedTemplateTag(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isDecoratorTarget(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isJsxOpeningLikeElementTagName(node, /*includeElementAccess*/ true, /*skipPastOuterExpressions*/ true) || isRightSideOfPropertyAccess(node) || isArgumentExpressionOfElementAccess(node)) {
                const sourceFile = node.getSourceFile();
                const ancestor = findAncestor(node, isValidCallHierarchyDeclaration) || sourceFile;
                return {
                    declaration: ancestor,
                    range: createTextRangeFromNode(node, sourceFile)
                };
            }
        }
    }
    function getCallSiteGroupKey(entry) {
        return getNodeId(entry.declaration);
    }
    function createCallHierarchyIncomingCall(from, fromSpans) {
        return {
            from,
            fromSpans
        };
    }
    function convertCallSiteGroupToIncomingCall(program, entries) {
        return createCallHierarchyIncomingCall(createCallHierarchyItem(program, entries[0].declaration), map(entries, (entry)=>createTextSpanFromRange(entry.range)));
    }
    function getIncomingCalls(program, declaration, cancellationToken) {
        if (isSourceFile(declaration) || isModuleDeclaration(declaration) || isClassStaticBlockDeclaration(declaration)) return [];
        const location = getCallHierarchyDeclarationReferenceNode(declaration);
        const calls = filter(ts_FindAllReferences_exports.findReferenceOrRenameEntries(program, cancellationToken, program.getSourceFiles(), location, /*position*/ 0, {
            use: ts_FindAllReferences_exports.FindReferencesUse.References
        }, convertEntryToCallSite), isDefined);
        return calls ? group(calls, getCallSiteGroupKey, (entries)=>convertCallSiteGroupToIncomingCall(program, entries)) : [];
    }
    function createCallSiteCollector(program, callSites) {
        function recordCallSite(node) {
            const target = isTaggedTemplateExpression(node) ? node.tag : isJsxOpeningLikeElement(node) ? node.tagName : isAccessExpression(node) ? node : isClassStaticBlockDeclaration(node) ? node : node.expression;
            const declaration = resolveCallHierarchyDeclaration(program, target);
            if (declaration) {
                const range = createTextRangeFromNode(target, node.getSourceFile());
                if (isArray(declaration)) for (const decl of declaration)callSites.push({
                    declaration: decl,
                    range
                });
                else callSites.push({
                    declaration,
                    range
                });
            }
        }
        function collect(node) {
            if (!node) return;
            if (node.flags & 33554432 /* Ambient */ ) return;
            if (isValidCallHierarchyDeclaration(node)) {
                if (isClassLike(node)) {
                    for (const member of node.members)if (member.name && isComputedPropertyName(member.name)) collect(member.name.expression);
                }
                return;
            }
            switch(node.kind){
                case 80 /* Identifier */ :
                case 272 /* ImportEqualsDeclaration */ :
                case 273 /* ImportDeclaration */ :
                case 279 /* ExportDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                    return;
                case 176 /* ClassStaticBlockDeclaration */ :
                    recordCallSite(node);
                    return;
                case 217 /* TypeAssertionExpression */ :
                case 235 /* AsExpression */ :
                    collect(node.expression);
                    return;
                case 261 /* VariableDeclaration */ :
                case 170 /* Parameter */ :
                    collect(node.name);
                    collect(node.initializer);
                    return;
                case 214 /* CallExpression */ :
                    recordCallSite(node);
                    collect(node.expression);
                    forEach(node.arguments, collect);
                    return;
                case 215 /* NewExpression */ :
                    recordCallSite(node);
                    collect(node.expression);
                    forEach(node.arguments, collect);
                    return;
                case 216 /* TaggedTemplateExpression */ :
                    recordCallSite(node);
                    collect(node.tag);
                    collect(node.template);
                    return;
                case 287 /* JsxOpeningElement */ :
                case 286 /* JsxSelfClosingElement */ :
                    recordCallSite(node);
                    collect(node.tagName);
                    collect(node.attributes);
                    return;
                case 171 /* Decorator */ :
                    recordCallSite(node);
                    collect(node.expression);
                    return;
                case 212 /* PropertyAccessExpression */ :
                case 213 /* ElementAccessExpression */ :
                    recordCallSite(node);
                    forEachChild(node, collect);
                    break;
                case 239 /* SatisfiesExpression */ :
                    collect(node.expression);
                    return;
            }
            if (isPartOfTypeNode(node)) return;
            forEachChild(node, collect);
        }
        return collect;
    }
    function collectCallSitesOfSourceFile(node, collect) {
        forEach(node.statements, collect);
    }
    function collectCallSitesOfModuleDeclaration(node, collect) {
        if (!hasSyntacticModifier(node, 128 /* Ambient */ ) && node.body && isModuleBlock(node.body)) forEach(node.body.statements, collect);
    }
    function collectCallSitesOfFunctionLikeDeclaration(typeChecker, node, collect) {
        const implementation = findImplementation(typeChecker, node);
        if (implementation) {
            forEach(implementation.parameters, collect);
            collect(implementation.body);
        }
    }
    function collectCallSitesOfClassStaticBlockDeclaration(node, collect) {
        collect(node.body);
    }
    function collectCallSitesOfClassLikeDeclaration(node, collect) {
        forEach(node.modifiers, collect);
        const heritage = getClassExtendsHeritageElement(node);
        if (heritage) collect(heritage.expression);
        for (const member of node.members){
            if (canHaveModifiers(member)) forEach(member.modifiers, collect);
            if (isPropertyDeclaration(member)) collect(member.initializer);
            else if (isConstructorDeclaration(member) && member.body) {
                forEach(member.parameters, collect);
                collect(member.body);
            } else if (isClassStaticBlockDeclaration(member)) collect(member);
        }
    }
    function collectCallSites(program, node) {
        const callSites = [];
        const collect = createCallSiteCollector(program, callSites);
        switch(node.kind){
            case 308 /* SourceFile */ :
                collectCallSitesOfSourceFile(node, collect);
                break;
            case 268 /* ModuleDeclaration */ :
                collectCallSitesOfModuleDeclaration(node, collect);
                break;
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                collectCallSitesOfFunctionLikeDeclaration(program.getTypeChecker(), node, collect);
                break;
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
                collectCallSitesOfClassLikeDeclaration(node, collect);
                break;
            case 176 /* ClassStaticBlockDeclaration */ :
                collectCallSitesOfClassStaticBlockDeclaration(node, collect);
                break;
            default:
                Debug.assertNever(node);
        }
        return callSites;
    }
    function createCallHierarchyOutgoingCall(to, fromSpans) {
        return {
            to,
            fromSpans
        };
    }
    function convertCallSiteGroupToOutgoingCall(program, entries) {
        return createCallHierarchyOutgoingCall(createCallHierarchyItem(program, entries[0].declaration), map(entries, (entry)=>createTextSpanFromRange(entry.range)));
    }
    function getOutgoingCalls(program, declaration) {
        if (declaration.flags & 33554432 /* Ambient */  || isMethodSignature(declaration)) return [];
        return group(collectCallSites(program, declaration), getCallSiteGroupKey, (entries)=>convertCallSiteGroupToOutgoingCall(program, entries));
    }
    // src/services/_namespaces/ts.classifier.ts
    var ts_classifier_exports = {};
    __export(ts_classifier_exports, {
        v2020: ()=>ts_classifier_v2020_exports
    });
    // src/services/_namespaces/ts.classifier.v2020.ts
    var ts_classifier_v2020_exports = {};
    __export(ts_classifier_v2020_exports, {
        TokenEncodingConsts: ()=>TokenEncodingConsts,
        TokenModifier: ()=>TokenModifier,
        TokenType: ()=>TokenType,
        getEncodedSemanticClassifications: ()=>getEncodedSemanticClassifications2,
        getSemanticClassifications: ()=>getSemanticClassifications2
    });
    // src/services/_namespaces/ts.codefix.ts
    var ts_codefix_exports = {};
    __export(ts_codefix_exports, {
        PreserveOptionalFlags: ()=>PreserveOptionalFlags,
        addNewNodeForMemberSymbol: ()=>addNewNodeForMemberSymbol,
        codeFixAll: ()=>codeFixAll,
        createCodeFixAction: ()=>createCodeFixAction,
        createCodeFixActionMaybeFixAll: ()=>createCodeFixActionMaybeFixAll,
        createCodeFixActionWithoutFixAll: ()=>createCodeFixActionWithoutFixAll,
        createCombinedCodeActions: ()=>createCombinedCodeActions,
        createFileTextChanges: ()=>createFileTextChanges,
        createImportAdder: ()=>createImportAdder,
        createImportSpecifierResolver: ()=>createImportSpecifierResolver,
        createMissingMemberNodes: ()=>createMissingMemberNodes,
        createSignatureDeclarationFromCallExpression: ()=>createSignatureDeclarationFromCallExpression,
        createSignatureDeclarationFromSignature: ()=>createSignatureDeclarationFromSignature,
        createStubbedBody: ()=>createStubbedBody,
        eachDiagnostic: ()=>eachDiagnostic,
        findAncestorMatchingSpan: ()=>findAncestorMatchingSpan,
        generateAccessorFromProperty: ()=>generateAccessorFromProperty,
        getAccessorConvertiblePropertyAtPosition: ()=>getAccessorConvertiblePropertyAtPosition,
        getAllFixes: ()=>getAllFixes,
        getFixes: ()=>getFixes,
        getImportCompletionAction: ()=>getImportCompletionAction,
        getImportKind: ()=>getImportKind,
        getJSDocTypedefNodes: ()=>getJSDocTypedefNodes,
        getNoopSymbolTrackerWithResolver: ()=>getNoopSymbolTrackerWithResolver,
        getPromoteTypeOnlyCompletionAction: ()=>getPromoteTypeOnlyCompletionAction,
        getSupportedErrorCodes: ()=>getSupportedErrorCodes,
        importFixName: ()=>importFixName,
        importSymbols: ()=>importSymbols,
        parameterShouldGetTypeFromJSDoc: ()=>parameterShouldGetTypeFromJSDoc,
        registerCodeFix: ()=>registerCodeFix,
        setJsonCompilerOptionValue: ()=>setJsonCompilerOptionValue,
        setJsonCompilerOptionValues: ()=>setJsonCompilerOptionValues,
        tryGetAutoImportableReferenceFromTypeNode: ()=>tryGetAutoImportableReferenceFromTypeNode,
        typeNodeToAutoImportableTypeNode: ()=>typeNodeToAutoImportableTypeNode,
        typePredicateToAutoImportableTypeNode: ()=>typePredicateToAutoImportableTypeNode,
        typeToAutoImportableTypeNode: ()=>typeToAutoImportableTypeNode,
        typeToMinimizedReferenceType: ()=>typeToMinimizedReferenceType
    });
    // src/services/codeFixProvider.ts
    var errorCodeToFixes = createMultiMap();
    var fixIdToRegistration = /* @__PURE__ */ new Map();
    function createCodeFixActionWithoutFixAll(fixName8, changes, description3) {
        return createCodeFixActionWorker(fixName8, diagnosticToString(description3), changes, /*fixId*/ void 0, /*fixAllDescription*/ void 0);
    }
    function createCodeFixAction(fixName8, changes, description3, fixId56, fixAllDescription, command) {
        return createCodeFixActionWorker(fixName8, diagnosticToString(description3), changes, fixId56, diagnosticToString(fixAllDescription), command);
    }
    function createCodeFixActionMaybeFixAll(fixName8, changes, description3, fixId56, fixAllDescription, command) {
        return createCodeFixActionWorker(fixName8, diagnosticToString(description3), changes, fixId56, fixAllDescription && diagnosticToString(fixAllDescription), command);
    }
    function createCodeFixActionWorker(fixName8, description3, changes, fixId56, fixAllDescription, command) {
        return {
            fixName: fixName8,
            description: description3,
            changes,
            fixId: fixId56,
            fixAllDescription,
            commands: command ? [
                command
            ] : void 0
        };
    }
    function registerCodeFix(reg) {
        for (const error2 of reg.errorCodes){
            errorCodeToFixesArray = void 0;
            errorCodeToFixes.add(String(error2), reg);
        }
        if (reg.fixIds) for (const fixId56 of reg.fixIds){
            Debug.assert(!fixIdToRegistration.has(fixId56));
            fixIdToRegistration.set(fixId56, reg);
        }
    }
    var errorCodeToFixesArray;
    function getSupportedErrorCodes() {
        return errorCodeToFixesArray !== null && errorCodeToFixesArray !== void 0 ? errorCodeToFixesArray : errorCodeToFixesArray = arrayFrom(errorCodeToFixes.keys());
    }
    function removeFixIdIfFixAllUnavailable(registration, diagnostics) {
        const { errorCodes: errorCodes68 } = registration;
        let maybeFixableDiagnostics = 0;
        for (const diag2 of diagnostics){
            if (contains(errorCodes68, diag2.code)) maybeFixableDiagnostics++;
            if (maybeFixableDiagnostics > 1) break;
        }
        const fixAllUnavailable = maybeFixableDiagnostics < 2;
        return (_param)=>{
            var { fixId: fixId56, fixAllDescription } = _param, action = (0, _objectWithoutProperties._)(_param, [
                "fixId",
                "fixAllDescription"
            ]);
            return fixAllUnavailable ? action : (0, _objectSpreadProps._)((0, _objectSpread._)({}, action), {
                fixId: fixId56,
                fixAllDescription
            });
        };
    }
    function getFixes(context) {
        const diagnostics = getDiagnostics(context);
        const registrations = errorCodeToFixes.get(String(context.errorCode));
        return flatMap(registrations, (f)=>map(f.getCodeActions(context), removeFixIdIfFixAllUnavailable(f, diagnostics)));
    }
    function getAllFixes(context) {
        return fixIdToRegistration.get(cast(context.fixId, isString)).getAllCodeActions(context);
    }
    function createCombinedCodeActions(changes, commands) {
        return {
            changes,
            commands
        };
    }
    function createFileTextChanges(fileName, textChanges2) {
        return {
            fileName,
            textChanges: textChanges2
        };
    }
    function codeFixAll(context, errorCodes68, use) {
        const commands = [];
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>eachDiagnostic(context, errorCodes68, (diag2)=>use(t, diag2, commands)));
        return createCombinedCodeActions(changes, commands.length === 0 ? void 0 : commands);
    }
    function eachDiagnostic(context, errorCodes68, cb) {
        for (const diag2 of getDiagnostics(context))if (contains(errorCodes68, diag2.code)) cb(diag2);
    }
    function getDiagnostics({ program, sourceFile, cancellationToken }) {
        const diagnostics = [
            ...program.getSemanticDiagnostics(sourceFile, cancellationToken),
            ...program.getSyntacticDiagnostics(sourceFile, cancellationToken),
            ...computeSuggestionDiagnostics(sourceFile, program, cancellationToken)
        ];
        if (getEmitDeclarations(program.getCompilerOptions())) diagnostics.push(...program.getDeclarationDiagnostics(sourceFile, cancellationToken));
        return diagnostics;
    }
    // src/services/codefixes/addConvertToUnknownForNonOverlappingTypes.ts
    var fixId = "addConvertToUnknownForNonOverlappingTypes";
    var errorCodes = [
        Diagnostics.Conversion_of_type_0_to_type_1_may_be_a_mistake_because_neither_type_sufficiently_overlaps_with_the_other_If_this_was_intentional_convert_the_expression_to_unknown_first.code
    ];
    registerCodeFix({
        errorCodes,
        getCodeActions: function getCodeActionsToAddConvertToUnknownForNonOverlappingTypes(context) {
            const assertion = getAssertion(context.sourceFile, context.span.start);
            if (assertion === void 0) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange(t, context.sourceFile, assertion));
            return [
                createCodeFixAction(fixId, changes, Diagnostics.Add_unknown_conversion_for_non_overlapping_types, fixId, Diagnostics.Add_unknown_to_all_conversions_of_non_overlapping_types)
            ];
        },
        fixIds: [
            fixId
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes, (changes, diag2)=>{
                const assertion = getAssertion(diag2.file, diag2.start);
                if (assertion) makeChange(changes, diag2.file, assertion);
            })
    });
    function makeChange(changeTracker, sourceFile, assertion) {
        const replacement = isAsExpression(assertion) ? factory.createAsExpression(assertion.expression, factory.createKeywordTypeNode(159 /* UnknownKeyword */ )) : factory.createTypeAssertion(factory.createKeywordTypeNode(159 /* UnknownKeyword */ ), assertion.expression);
        changeTracker.replaceNode(sourceFile, assertion.expression, replacement);
    }
    function getAssertion(sourceFile, pos) {
        if (isInJSFile(sourceFile)) return void 0;
        return findAncestor(getTokenAtPosition(sourceFile, pos), (n)=>isAsExpression(n) || isTypeAssertionExpression(n));
    }
    // src/services/codefixes/addEmptyExportDeclaration.ts
    registerCodeFix({
        errorCodes: [
            Diagnostics.await_expressions_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module.code,
            Diagnostics.await_using_statements_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module.code,
            Diagnostics.for_await_loops_are_only_allowed_at_the_top_level_of_a_file_when_that_file_is_a_module_but_this_file_has_no_imports_or_exports_Consider_adding_an_empty_export_to_make_this_file_a_module.code
        ],
        getCodeActions: function getCodeActionsToAddEmptyExportDeclaration(context) {
            const { sourceFile } = context;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                const exportDeclaration = factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports([]), /*moduleSpecifier*/ void 0);
                changes2.insertNodeAtEndOfScope(sourceFile, sourceFile, exportDeclaration);
            });
            return [
                createCodeFixActionWithoutFixAll("addEmptyExportDeclaration", changes, Diagnostics.Add_export_to_make_this_file_into_a_module)
            ];
        }
    });
    // src/services/codefixes/addMissingAsync.ts
    var fixId2 = "addMissingAsync";
    var errorCodes2 = [
        Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
        Diagnostics.Type_0_is_not_assignable_to_type_1.code,
        Diagnostics.Type_0_is_not_comparable_to_type_1.code
    ];
    registerCodeFix({
        fixIds: [
            fixId2
        ],
        errorCodes: errorCodes2,
        getCodeActions: function getCodeActionsToAddMissingAsync(context) {
            const { sourceFile, errorCode, cancellationToken, program, span } = context;
            const diagnostic = find(program.getTypeChecker().getDiagnostics(sourceFile, cancellationToken), getIsMatchingAsyncError(span, errorCode));
            const directSpan = diagnostic && diagnostic.relatedInformation && find(diagnostic.relatedInformation, (r)=>r.code === Diagnostics.Did_you_mean_to_mark_this_function_as_async.code);
            const decl = getFixableErrorSpanDeclaration(sourceFile, directSpan);
            if (!decl) return;
            const trackChanges = (cb)=>ts_textChanges_exports.ChangeTracker.with(context, cb);
            return [
                getFix(context, decl, trackChanges)
            ];
        },
        getAllCodeActions: (context)=>{
            const { sourceFile } = context;
            const fixedDeclarations = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes2, (t, diagnostic)=>{
                const span = diagnostic.relatedInformation && find(diagnostic.relatedInformation, (r)=>r.code === Diagnostics.Did_you_mean_to_mark_this_function_as_async.code);
                const decl = getFixableErrorSpanDeclaration(sourceFile, span);
                if (!decl) return;
                const trackChanges = (cb)=>(cb(t), []);
                return getFix(context, decl, trackChanges, fixedDeclarations);
            });
        }
    });
    function getFix(context, decl, trackChanges, fixedDeclarations) {
        const changes = trackChanges((t)=>makeChange2(t, context.sourceFile, decl, fixedDeclarations));
        return createCodeFixAction(fixId2, changes, Diagnostics.Add_async_modifier_to_containing_function, fixId2, Diagnostics.Add_all_missing_async_modifiers);
    }
    function makeChange2(changeTracker, sourceFile, insertionSite, fixedDeclarations) {
        if (fixedDeclarations) {
            if (fixedDeclarations.has(getNodeId(insertionSite))) return;
        }
        fixedDeclarations == null || fixedDeclarations.add(getNodeId(insertionSite));
        const cloneWithModifier = factory.replaceModifiers(getSynthesizedDeepClone(insertionSite, /*includeTrivia*/ true), factory.createNodeArray(factory.createModifiersFromModifierFlags(getSyntacticModifierFlags(insertionSite) | 1024 /* Async */ )));
        changeTracker.replaceNode(sourceFile, insertionSite, cloneWithModifier);
    }
    function getFixableErrorSpanDeclaration(sourceFile, span) {
        if (!span) return void 0;
        const token = getTokenAtPosition(sourceFile, span.start);
        const decl = findAncestor(token, (node)=>{
            if (node.getStart(sourceFile) < span.start || node.getEnd() > textSpanEnd(span)) return "quit";
            return (isArrowFunction(node) || isMethodDeclaration(node) || isFunctionExpression(node) || isFunctionDeclaration(node)) && textSpansEqual(span, createTextSpanFromNode(node, sourceFile));
        });
        return decl;
    }
    function getIsMatchingAsyncError(span, errorCode) {
        return ({ start, length: length2, relatedInformation, code })=>isNumber(start) && isNumber(length2) && textSpansEqual({
                start,
                length: length2
            }, span) && code === errorCode && !!relatedInformation && some(relatedInformation, (related)=>related.code === Diagnostics.Did_you_mean_to_mark_this_function_as_async.code);
    }
    // src/services/codefixes/addMissingAwait.ts
    var fixId3 = "addMissingAwait";
    var propertyAccessCode = Diagnostics.Property_0_does_not_exist_on_type_1.code;
    var callableConstructableErrorCodes = [
        Diagnostics.This_expression_is_not_callable.code,
        Diagnostics.This_expression_is_not_constructable.code
    ];
    var errorCodes3 = [
        Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_bigint_or_an_enum_type.code,
        Diagnostics.The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type.code,
        Diagnostics.The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_bigint_or_an_enum_type.code,
        Diagnostics.Operator_0_cannot_be_applied_to_type_1.code,
        Diagnostics.Operator_0_cannot_be_applied_to_types_1_and_2.code,
        Diagnostics.This_comparison_appears_to_be_unintentional_because_the_types_0_and_1_have_no_overlap.code,
        Diagnostics.This_condition_will_always_return_true_since_this_0_is_always_defined.code,
        Diagnostics.Type_0_is_not_an_array_type.code,
        Diagnostics.Type_0_is_not_an_array_type_or_a_string_type.code,
        Diagnostics.Type_0_can_only_be_iterated_through_when_using_the_downlevelIteration_flag_or_with_a_target_of_es2015_or_higher.code,
        Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator.code,
        Diagnostics.Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator.code,
        Diagnostics.Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator.code,
        Diagnostics.Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator.code,
        Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
        propertyAccessCode,
        ...callableConstructableErrorCodes
    ];
    registerCodeFix({
        fixIds: [
            fixId3
        ],
        errorCodes: errorCodes3,
        getCodeActions: function getCodeActionsToAddMissingAwait(context) {
            const { sourceFile, errorCode, span, cancellationToken, program } = context;
            const expression = getAwaitErrorSpanExpression(sourceFile, errorCode, span, cancellationToken, program);
            if (!expression) return;
            const checker = context.program.getTypeChecker();
            const trackChanges = (cb)=>ts_textChanges_exports.ChangeTracker.with(context, cb);
            return compact([
                getDeclarationSiteFix(context, expression, errorCode, checker, trackChanges),
                getUseSiteFix(context, expression, errorCode, checker, trackChanges)
            ]);
        },
        getAllCodeActions: (context)=>{
            const { sourceFile, program, cancellationToken } = context;
            const checker = context.program.getTypeChecker();
            const fixedDeclarations = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes3, (t, diagnostic)=>{
                const expression = getAwaitErrorSpanExpression(sourceFile, diagnostic.code, diagnostic, cancellationToken, program);
                if (!expression) return;
                const trackChanges = (cb)=>(cb(t), []);
                return getDeclarationSiteFix(context, expression, diagnostic.code, checker, trackChanges, fixedDeclarations) || getUseSiteFix(context, expression, diagnostic.code, checker, trackChanges, fixedDeclarations);
            });
        }
    });
    function getAwaitErrorSpanExpression(sourceFile, errorCode, span, cancellationToken, program) {
        const expression = getFixableErrorSpanExpression(sourceFile, span);
        return expression && isMissingAwaitError(sourceFile, errorCode, span, cancellationToken, program) && isInsideAwaitableBody(expression) ? expression : void 0;
    }
    function getDeclarationSiteFix(context, expression, errorCode, checker, trackChanges, fixedDeclarations) {
        const { sourceFile, program, cancellationToken } = context;
        const awaitableInitializers = findAwaitableInitializers(expression, sourceFile, cancellationToken, program, checker);
        if (awaitableInitializers) {
            const initializerChanges = trackChanges((t)=>{
                forEach(awaitableInitializers.initializers, ({ expression: expression2 })=>makeChange3(t, errorCode, sourceFile, checker, expression2, fixedDeclarations));
                if (fixedDeclarations && awaitableInitializers.needsSecondPassForFixAll) makeChange3(t, errorCode, sourceFile, checker, expression, fixedDeclarations);
            });
            return createCodeFixActionWithoutFixAll("addMissingAwaitToInitializer", initializerChanges, awaitableInitializers.initializers.length === 1 ? [
                Diagnostics.Add_await_to_initializer_for_0,
                awaitableInitializers.initializers[0].declarationSymbol.name
            ] : Diagnostics.Add_await_to_initializers);
        }
    }
    function getUseSiteFix(context, expression, errorCode, checker, trackChanges, fixedDeclarations) {
        const changes = trackChanges((t)=>makeChange3(t, errorCode, context.sourceFile, checker, expression, fixedDeclarations));
        return createCodeFixAction(fixId3, changes, Diagnostics.Add_await, fixId3, Diagnostics.Fix_all_expressions_possibly_missing_await);
    }
    function isMissingAwaitError(sourceFile, errorCode, span, cancellationToken, program) {
        const checker = program.getTypeChecker();
        const diagnostics = checker.getDiagnostics(sourceFile, cancellationToken);
        return some(diagnostics, ({ start, length: length2, relatedInformation, code })=>isNumber(start) && isNumber(length2) && textSpansEqual({
                start,
                length: length2
            }, span) && code === errorCode && !!relatedInformation && some(relatedInformation, (related)=>related.code === Diagnostics.Did_you_forget_to_use_await.code));
    }
    function findAwaitableInitializers(expression, sourceFile, cancellationToken, program, checker) {
        const identifiers = getIdentifiersFromErrorSpanExpression(expression, checker);
        if (!identifiers) return;
        let isCompleteFix = identifiers.isCompleteFix;
        let initializers;
        for (const identifier of identifiers.identifiers){
            const symbol = checker.getSymbolAtLocation(identifier);
            if (!symbol) continue;
            const declaration = tryCast(symbol.valueDeclaration, isVariableDeclaration);
            const variableName = declaration && tryCast(declaration.name, isIdentifier);
            const variableStatement = getAncestor(declaration, 244 /* VariableStatement */ );
            if (!declaration || !variableStatement || declaration.type || !declaration.initializer || variableStatement.getSourceFile() !== sourceFile || hasSyntacticModifier(variableStatement, 32 /* Export */ ) || !variableName || !isInsideAwaitableBody(declaration.initializer)) {
                isCompleteFix = false;
                continue;
            }
            const diagnostics = program.getSemanticDiagnostics(sourceFile, cancellationToken);
            const isUsedElsewhere = ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(variableName, checker, sourceFile, (reference)=>{
                return identifier !== reference && !symbolReferenceIsAlsoMissingAwait(reference, diagnostics, sourceFile, checker);
            });
            if (isUsedElsewhere) {
                isCompleteFix = false;
                continue;
            }
            (initializers || (initializers = [])).push({
                expression: declaration.initializer,
                declarationSymbol: symbol
            });
        }
        return initializers && {
            initializers,
            needsSecondPassForFixAll: !isCompleteFix
        };
    }
    function getIdentifiersFromErrorSpanExpression(expression, checker) {
        if (isPropertyAccessExpression(expression.parent) && isIdentifier(expression.parent.expression)) return {
            identifiers: [
                expression.parent.expression
            ],
            isCompleteFix: true
        };
        if (isIdentifier(expression)) return {
            identifiers: [
                expression
            ],
            isCompleteFix: true
        };
        if (isBinaryExpression(expression)) {
            let sides;
            let isCompleteFix = true;
            for (const side of [
                expression.left,
                expression.right
            ]){
                const type = checker.getTypeAtLocation(side);
                if (checker.getPromisedTypeOfPromise(type)) {
                    if (!isIdentifier(side)) {
                        isCompleteFix = false;
                        continue;
                    }
                    (sides || (sides = [])).push(side);
                }
            }
            return sides && {
                identifiers: sides,
                isCompleteFix
            };
        }
    }
    function symbolReferenceIsAlsoMissingAwait(reference, diagnostics, sourceFile, checker) {
        const errorNode = isPropertyAccessExpression(reference.parent) ? reference.parent.name : isBinaryExpression(reference.parent) ? reference.parent : reference;
        const diagnostic = find(diagnostics, (diagnostic2)=>diagnostic2.start === errorNode.getStart(sourceFile) && diagnostic2.start + diagnostic2.length === errorNode.getEnd());
        return diagnostic && contains(errorCodes3, diagnostic.code) || // A Promise is usually not correct in a binary expression (it's not valid
        // in an arithmetic expression and an equality comparison seems unusual),
        // but if the other side of the binary expression has an error, the side
        // is typed `any` which will squash the error that would identify this
        // Promise as an invalid operand. So if the whole binary expression is
        // typed `any` as a result, there is a strong likelihood that this Promise
        // is accidentally missing `await`.
        checker.getTypeAtLocation(errorNode).flags & 1 /* Any */ ;
    }
    function isInsideAwaitableBody(node) {
        return node.flags & 65536 /* AwaitContext */  || !!findAncestor(node, (ancestor)=>ancestor.parent && isArrowFunction(ancestor.parent) && ancestor.parent.body === ancestor || isBlock(ancestor) && (ancestor.parent.kind === 263 /* FunctionDeclaration */  || ancestor.parent.kind === 219 /* FunctionExpression */  || ancestor.parent.kind === 220 /* ArrowFunction */  || ancestor.parent.kind === 175 /* MethodDeclaration */ ));
    }
    function makeChange3(changeTracker, errorCode, sourceFile, checker, insertionSite, fixedDeclarations) {
        if (isForOfStatement(insertionSite.parent) && !insertionSite.parent.awaitModifier) {
            const exprType = checker.getTypeAtLocation(insertionSite);
            const asyncIter = checker.getAnyAsyncIterableType();
            if (asyncIter && checker.isTypeAssignableTo(exprType, asyncIter)) {
                const forOf = insertionSite.parent;
                changeTracker.replaceNode(sourceFile, forOf, factory.updateForOfStatement(forOf, factory.createToken(135 /* AwaitKeyword */ ), forOf.initializer, forOf.expression, forOf.statement));
                return;
            }
        }
        if (isBinaryExpression(insertionSite)) for (const side of [
            insertionSite.left,
            insertionSite.right
        ]){
            if (fixedDeclarations && isIdentifier(side)) {
                const symbol = checker.getSymbolAtLocation(side);
                if (symbol && fixedDeclarations.has(getSymbolId(symbol))) continue;
            }
            const type = checker.getTypeAtLocation(side);
            const newNode = checker.getPromisedTypeOfPromise(type) ? factory.createAwaitExpression(side) : side;
            changeTracker.replaceNode(sourceFile, side, newNode);
        }
        else if (errorCode === propertyAccessCode && isPropertyAccessExpression(insertionSite.parent)) {
            if (fixedDeclarations && isIdentifier(insertionSite.parent.expression)) {
                const symbol = checker.getSymbolAtLocation(insertionSite.parent.expression);
                if (symbol && fixedDeclarations.has(getSymbolId(symbol))) return;
            }
            changeTracker.replaceNode(sourceFile, insertionSite.parent.expression, factory.createParenthesizedExpression(factory.createAwaitExpression(insertionSite.parent.expression)));
            insertLeadingSemicolonIfNeeded(changeTracker, insertionSite.parent.expression, sourceFile);
        } else if (contains(callableConstructableErrorCodes, errorCode) && isCallOrNewExpression(insertionSite.parent)) {
            if (fixedDeclarations && isIdentifier(insertionSite)) {
                const symbol = checker.getSymbolAtLocation(insertionSite);
                if (symbol && fixedDeclarations.has(getSymbolId(symbol))) return;
            }
            changeTracker.replaceNode(sourceFile, insertionSite, factory.createParenthesizedExpression(factory.createAwaitExpression(insertionSite)));
            insertLeadingSemicolonIfNeeded(changeTracker, insertionSite, sourceFile);
        } else {
            if (fixedDeclarations && isVariableDeclaration(insertionSite.parent) && isIdentifier(insertionSite.parent.name)) {
                const symbol = checker.getSymbolAtLocation(insertionSite.parent.name);
                if (symbol && !tryAddToSet(fixedDeclarations, getSymbolId(symbol))) return;
            }
            changeTracker.replaceNode(sourceFile, insertionSite, factory.createAwaitExpression(insertionSite));
        }
    }
    function insertLeadingSemicolonIfNeeded(changeTracker, beforeNode, sourceFile) {
        const precedingToken = findPrecedingToken(beforeNode.pos, sourceFile);
        if (precedingToken && positionIsASICandidate(precedingToken.end, precedingToken.parent, sourceFile)) changeTracker.insertText(sourceFile, beforeNode.getStart(sourceFile), ";");
    }
    // src/services/codefixes/addMissingConst.ts
    var fixId4 = "addMissingConst";
    var errorCodes4 = [
        Diagnostics.Cannot_find_name_0.code,
        Diagnostics.No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer.code
    ];
    registerCodeFix({
        errorCodes: errorCodes4,
        getCodeActions: function getCodeActionsToAddMissingConst(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange4(t, context.sourceFile, context.span.start, context.program));
            if (changes.length > 0) return [
                createCodeFixAction(fixId4, changes, Diagnostics.Add_const_to_unresolved_variable, fixId4, Diagnostics.Add_const_to_all_unresolved_variables)
            ];
        },
        fixIds: [
            fixId4
        ],
        getAllCodeActions: (context)=>{
            const fixedNodes = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes4, (changes, diag2)=>makeChange4(changes, diag2.file, diag2.start, context.program, fixedNodes));
        }
    });
    function makeChange4(changeTracker, sourceFile, pos, program, fixedNodes) {
        const token = getTokenAtPosition(sourceFile, pos);
        const forInitializer = findAncestor(token, (node)=>isForInOrOfStatement(node.parent) ? node.parent.initializer === node : isPossiblyPartOfDestructuring(node) ? false : "quit");
        if (forInitializer) return applyChange(changeTracker, forInitializer, sourceFile, fixedNodes);
        const parent2 = token.parent;
        if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */  && isExpressionStatement(parent2.parent)) return applyChange(changeTracker, token, sourceFile, fixedNodes);
        if (isArrayLiteralExpression(parent2)) {
            const checker = program.getTypeChecker();
            if (!every(parent2.elements, (element)=>arrayElementCouldBeVariableDeclaration(element, checker))) return;
            return applyChange(changeTracker, parent2, sourceFile, fixedNodes);
        }
        const commaExpression = findAncestor(token, (node)=>isExpressionStatement(node.parent) ? true : isPossiblyPartOfCommaSeperatedInitializer(node) ? false : "quit");
        if (commaExpression) {
            const checker = program.getTypeChecker();
            if (!expressionCouldBeVariableDeclaration(commaExpression, checker)) return;
            return applyChange(changeTracker, commaExpression, sourceFile, fixedNodes);
        }
    }
    function applyChange(changeTracker, initializer, sourceFile, fixedNodes) {
        if (!fixedNodes || tryAddToSet(fixedNodes, initializer)) changeTracker.insertModifierBefore(sourceFile, 87 /* ConstKeyword */ , initializer);
    }
    function isPossiblyPartOfDestructuring(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 210 /* ArrayLiteralExpression */ :
            case 211 /* ObjectLiteralExpression */ :
            case 304 /* PropertyAssignment */ :
            case 305 /* ShorthandPropertyAssignment */ :
                return true;
            default:
                return false;
        }
    }
    function arrayElementCouldBeVariableDeclaration(expression, checker) {
        const identifier = isIdentifier(expression) ? expression : isAssignmentExpression(expression, /*excludeCompoundAssignment*/ true) && isIdentifier(expression.left) ? expression.left : void 0;
        return !!identifier && !checker.getSymbolAtLocation(identifier);
    }
    function isPossiblyPartOfCommaSeperatedInitializer(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 227 /* BinaryExpression */ :
            case 28 /* CommaToken */ :
                return true;
            default:
                return false;
        }
    }
    function expressionCouldBeVariableDeclaration(expression, checker) {
        if (!isBinaryExpression(expression)) return false;
        if (expression.operatorToken.kind === 28 /* CommaToken */ ) return every([
            expression.left,
            expression.right
        ], (expression2)=>expressionCouldBeVariableDeclaration(expression2, checker));
        return expression.operatorToken.kind === 64 /* EqualsToken */  && isIdentifier(expression.left) && !checker.getSymbolAtLocation(expression.left);
    }
    // src/services/codefixes/addMissingDeclareProperty.ts
    var fixId5 = "addMissingDeclareProperty";
    var errorCodes5 = [
        Diagnostics.Property_0_will_overwrite_the_base_property_in_1_If_this_is_intentional_add_an_initializer_Otherwise_add_a_declare_modifier_or_remove_the_redundant_declaration.code
    ];
    registerCodeFix({
        errorCodes: errorCodes5,
        getCodeActions: function getCodeActionsToAddMissingDeclareOnProperty(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange5(t, context.sourceFile, context.span.start));
            if (changes.length > 0) return [
                createCodeFixAction(fixId5, changes, Diagnostics.Prefix_with_declare, fixId5, Diagnostics.Prefix_all_incorrect_property_declarations_with_declare)
            ];
        },
        fixIds: [
            fixId5
        ],
        getAllCodeActions: (context)=>{
            const fixedNodes = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes5, (changes, diag2)=>makeChange5(changes, diag2.file, diag2.start, fixedNodes));
        }
    });
    function makeChange5(changeTracker, sourceFile, pos, fixedNodes) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (!isIdentifier(token)) return;
        const declaration = token.parent;
        if (declaration.kind === 173 /* PropertyDeclaration */  && (!fixedNodes || tryAddToSet(fixedNodes, declaration))) changeTracker.insertModifierBefore(sourceFile, 138 /* DeclareKeyword */ , declaration);
    }
    // src/services/codefixes/addMissingInvocationForDecorator.ts
    var fixId6 = "addMissingInvocationForDecorator";
    var errorCodes6 = [
        Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0.code
    ];
    registerCodeFix({
        errorCodes: errorCodes6,
        getCodeActions: function getCodeActionsToAddMissingInvocationForDecorator(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange6(t, context.sourceFile, context.span.start));
            return [
                createCodeFixAction(fixId6, changes, Diagnostics.Call_decorator_expression, fixId6, Diagnostics.Add_to_all_uncalled_decorators)
            ];
        },
        fixIds: [
            fixId6
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes6, (changes, diag2)=>makeChange6(changes, diag2.file, diag2.start))
    });
    function makeChange6(changeTracker, sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const decorator = findAncestor(token, isDecorator);
        Debug.assert(!!decorator, "Expected position to be owned by a decorator.");
        const replacement = factory.createCallExpression(decorator.expression, /*typeArguments*/ void 0, /*argumentsArray*/ void 0);
        changeTracker.replaceNode(sourceFile, decorator.expression, replacement);
    }
    // src/services/codefixes/addMissingResolutionModeImportAttribute.ts
    var fixId7 = "addMissingResolutionModeImportAttribute";
    var errorCodes7 = [
        Diagnostics.Type_only_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute.code,
        Diagnostics.Type_import_of_an_ECMAScript_module_from_a_CommonJS_module_must_have_a_resolution_mode_attribute.code
    ];
    registerCodeFix({
        errorCodes: errorCodes7,
        getCodeActions: function getCodeActionsToAddMissingResolutionModeImportAttribute(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange7(t, context.sourceFile, context.span.start, context.program, context.host, context.preferences));
            return [
                createCodeFixAction(fixId7, changes, Diagnostics.Add_resolution_mode_import_attribute, fixId7, Diagnostics.Add_resolution_mode_import_attribute_to_all_type_only_imports_that_need_it)
            ];
        },
        fixIds: [
            fixId7
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes7, (changes, diag2)=>makeChange7(changes, diag2.file, diag2.start, context.program, context.host, context.preferences))
    });
    function makeChange7(changeTracker, sourceFile, pos, program, host, preferences) {
        var _a, _b, _c;
        const token = getTokenAtPosition(sourceFile, pos);
        const importNode = findAncestor(token, or(isImportDeclaration, isImportTypeNode));
        Debug.assert(!!importNode, "Expected position to be owned by an ImportDeclaration or ImportType.");
        const useSingleQuotes = getQuotePreference(sourceFile, preferences) === 0 /* Single */ ;
        const moduleSpecifier = tryGetModuleSpecifierFromDeclaration(importNode);
        const canUseImportMode = !moduleSpecifier || ((_a = resolveModuleName(moduleSpecifier.text, sourceFile.fileName, program.getCompilerOptions(), host, program.getModuleResolutionCache(), /*redirectedReference*/ void 0, 99 /* ESNext */ ).resolvedModule) == null ? void 0 : _a.resolvedFileName) === ((_c = (_b = program.getResolvedModuleFromModuleSpecifier(moduleSpecifier, sourceFile)) == null ? void 0 : _b.resolvedModule) == null ? void 0 : _c.resolvedFileName);
        const attributes = importNode.attributes ? factory.updateImportAttributes(importNode.attributes, factory.createNodeArray([
            ...importNode.attributes.elements,
            factory.createImportAttribute(factory.createStringLiteral("resolution-mode", useSingleQuotes), factory.createStringLiteral(canUseImportMode ? "import" : "require", useSingleQuotes))
        ], importNode.attributes.elements.hasTrailingComma), importNode.attributes.multiLine) : factory.createImportAttributes(factory.createNodeArray([
            factory.createImportAttribute(factory.createStringLiteral("resolution-mode", useSingleQuotes), factory.createStringLiteral(canUseImportMode ? "import" : "require", useSingleQuotes))
        ]));
        if (importNode.kind === 273 /* ImportDeclaration */ ) changeTracker.replaceNode(sourceFile, importNode, factory.updateImportDeclaration(importNode, importNode.modifiers, importNode.importClause, importNode.moduleSpecifier, attributes));
        else changeTracker.replaceNode(sourceFile, importNode, factory.updateImportTypeNode(importNode, importNode.argument, attributes, importNode.qualifier, importNode.typeArguments));
    }
    // src/services/codefixes/addNameToNamelessParameter.ts
    var fixId8 = "addNameToNamelessParameter";
    var errorCodes8 = [
        Diagnostics.Parameter_has_a_name_but_no_type_Did_you_mean_0_Colon_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes8,
        getCodeActions: function getCodeActionsToAddNameToNamelessParameter(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange8(t, context.sourceFile, context.span.start));
            return [
                createCodeFixAction(fixId8, changes, Diagnostics.Add_parameter_name, fixId8, Diagnostics.Add_names_to_all_parameters_without_names)
            ];
        },
        fixIds: [
            fixId8
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes8, (changes, diag2)=>makeChange8(changes, diag2.file, diag2.start))
    });
    function makeChange8(changeTracker, sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        const param = token.parent;
        if (!isParameter(param)) return Debug.fail("Tried to add a parameter name to a non-parameter: " + Debug.formatSyntaxKind(token.kind));
        const i = param.parent.parameters.indexOf(param);
        Debug.assert(!param.type, "Tried to add a parameter name to a parameter that already had one.");
        Debug.assert(i > -1, "Parameter not found in parent parameter list.");
        let end = param.name.getEnd();
        let typeNode = factory.createTypeReferenceNode(param.name, /*typeArguments*/ void 0);
        let nextParam = tryGetNextParam(sourceFile, param);
        while(nextParam){
            typeNode = factory.createArrayTypeNode(typeNode);
            end = nextParam.getEnd();
            nextParam = tryGetNextParam(sourceFile, nextParam);
        }
        const replacement = factory.createParameterDeclaration(param.modifiers, param.dotDotDotToken, "arg" + i, param.questionToken, param.dotDotDotToken && !isArrayTypeNode(typeNode) ? factory.createArrayTypeNode(typeNode) : typeNode, param.initializer);
        changeTracker.replaceRange(sourceFile, createRange(param.getStart(sourceFile), end), replacement);
    }
    function tryGetNextParam(sourceFile, param) {
        const nextToken = findNextToken(param.name, param.parent, sourceFile);
        if (nextToken && nextToken.kind === 23 /* OpenBracketToken */  && isArrayBindingPattern(nextToken.parent) && isParameter(nextToken.parent.parent)) return nextToken.parent.parent;
        return void 0;
    }
    // src/services/codefixes/addOptionalPropertyUndefined.ts
    var addOptionalPropertyUndefined = "addOptionalPropertyUndefined";
    var errorCodes9 = [
        Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_type_of_the_target.code,
        Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code,
        Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code
    ];
    registerCodeFix({
        errorCodes: errorCodes9,
        getCodeActions (context) {
            const typeChecker = context.program.getTypeChecker();
            const toAdd = getPropertiesToAdd(context.sourceFile, context.span, typeChecker);
            if (!toAdd.length) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addUndefinedToOptionalProperty(t, toAdd));
            return [
                createCodeFixActionWithoutFixAll(addOptionalPropertyUndefined, changes, Diagnostics.Add_undefined_to_optional_property_type)
            ];
        },
        fixIds: [
            addOptionalPropertyUndefined
        ]
    });
    function getPropertiesToAdd(file, span, checker) {
        var _a, _b;
        const sourceTarget = getSourceTarget(getFixableErrorSpanExpression(file, span), checker);
        if (!sourceTarget) return emptyArray;
        const { source: sourceNode, target: targetNode } = sourceTarget;
        const target = shouldUseParentTypeOfProperty(sourceNode, targetNode, checker) ? checker.getTypeAtLocation(targetNode.expression) : checker.getTypeAtLocation(targetNode);
        if ((_b = (_a = target.symbol) == null ? void 0 : _a.declarations) == null ? void 0 : _b.some((d)=>getSourceFileOfNode(d).fileName.match(/\.d\.ts$/))) return emptyArray;
        return checker.getExactOptionalProperties(target);
    }
    function shouldUseParentTypeOfProperty(sourceNode, targetNode, checker) {
        return isPropertyAccessExpression(targetNode) && !!checker.getExactOptionalProperties(checker.getTypeAtLocation(targetNode.expression)).length && checker.getTypeAtLocation(sourceNode) === checker.getUndefinedType();
    }
    function getSourceTarget(errorNode, checker) {
        var _a;
        if (!errorNode) return void 0;
        else if (isBinaryExpression(errorNode.parent) && errorNode.parent.operatorToken.kind === 64 /* EqualsToken */ ) return {
            source: errorNode.parent.right,
            target: errorNode.parent.left
        };
        else if (isVariableDeclaration(errorNode.parent) && errorNode.parent.initializer) return {
            source: errorNode.parent.initializer,
            target: errorNode.parent.name
        };
        else if (isCallExpression(errorNode.parent)) {
            const n = checker.getSymbolAtLocation(errorNode.parent.expression);
            if (!(n == null ? void 0 : n.valueDeclaration) || !isFunctionLikeKind(n.valueDeclaration.kind)) return void 0;
            if (!isExpression(errorNode)) return void 0;
            const i = errorNode.parent.arguments.indexOf(errorNode);
            if (i === -1) return void 0;
            const name = n.valueDeclaration.parameters[i].name;
            if (isIdentifier(name)) return {
                source: errorNode,
                target: name
            };
        } else if (isPropertyAssignment(errorNode.parent) && isIdentifier(errorNode.parent.name) || isShorthandPropertyAssignment(errorNode.parent)) {
            const parentTarget = getSourceTarget(errorNode.parent.parent, checker);
            if (!parentTarget) return void 0;
            const prop = checker.getPropertyOfType(checker.getTypeAtLocation(parentTarget.target), errorNode.parent.name.text);
            const declaration = (_a = prop == null ? void 0 : prop.declarations) == null ? void 0 : _a[0];
            if (!declaration) return void 0;
            return {
                source: isPropertyAssignment(errorNode.parent) ? errorNode.parent.initializer : errorNode.parent.name,
                target: declaration
            };
        }
        return void 0;
    }
    function addUndefinedToOptionalProperty(changes, toAdd) {
        for (const add of toAdd){
            const d = add.valueDeclaration;
            if (d && (isPropertySignature(d) || isPropertyDeclaration(d)) && d.type) {
                const t = factory.createUnionTypeNode([
                    ...d.type.kind === 193 /* UnionType */  ? d.type.types : [
                        d.type
                    ],
                    factory.createTypeReferenceNode("undefined")
                ]);
                changes.replaceNode(d.getSourceFile(), d.type, t);
            }
        }
    }
    // src/services/codefixes/annotateWithTypeFromJSDoc.ts
    var fixId9 = "annotateWithTypeFromJSDoc";
    var errorCodes10 = [
        Diagnostics.JSDoc_types_may_be_moved_to_TypeScript_types.code
    ];
    registerCodeFix({
        errorCodes: errorCodes10,
        getCodeActions (context) {
            const decl = getDeclaration(context.sourceFile, context.span.start);
            if (!decl) return;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange8(t, context.sourceFile, decl));
            return [
                createCodeFixAction(fixId9, changes, Diagnostics.Annotate_with_type_from_JSDoc, fixId9, Diagnostics.Annotate_everything_with_types_from_JSDoc)
            ];
        },
        fixIds: [
            fixId9
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes10, (changes, diag2)=>{
                const decl = getDeclaration(diag2.file, diag2.start);
                if (decl) doChange8(changes, diag2.file, decl);
            })
    });
    function getDeclaration(file, pos) {
        const name = getTokenAtPosition(file, pos);
        return tryCast(isParameter(name.parent) ? name.parent.parent : name.parent, parameterShouldGetTypeFromJSDoc);
    }
    function parameterShouldGetTypeFromJSDoc(node) {
        return isDeclarationWithType(node) && hasUsableJSDoc(node);
    }
    function hasUsableJSDoc(decl) {
        return isFunctionLikeDeclaration(decl) ? decl.parameters.some(hasUsableJSDoc) || !decl.type && !!getJSDocReturnType(decl) : !decl.type && !!getJSDocType(decl);
    }
    function doChange8(changes, sourceFile, decl) {
        if (isFunctionLikeDeclaration(decl) && (getJSDocReturnType(decl) || decl.parameters.some((p)=>!!getJSDocType(p)))) {
            if (!decl.typeParameters) {
                const typeParameters = getJSDocTypeParameterDeclarations(decl);
                if (typeParameters.length) changes.insertTypeParameters(sourceFile, decl, typeParameters);
            }
            const needParens = isArrowFunction(decl) && !findChildOfKind(decl, 21 /* OpenParenToken */ , sourceFile);
            if (needParens) changes.insertNodeBefore(sourceFile, first(decl.parameters), factory.createToken(21 /* OpenParenToken */ ));
            for (const param of decl.parameters)if (!param.type) {
                const paramType = getJSDocType(param);
                if (paramType) changes.tryInsertTypeAnnotation(sourceFile, param, visitNode(paramType, transformJSDocType, isTypeNode));
            }
            if (needParens) changes.insertNodeAfter(sourceFile, last(decl.parameters), factory.createToken(22 /* CloseParenToken */ ));
            if (!decl.type) {
                const returnType = getJSDocReturnType(decl);
                if (returnType) changes.tryInsertTypeAnnotation(sourceFile, decl, visitNode(returnType, transformJSDocType, isTypeNode));
            }
        } else {
            const jsdocType = Debug.checkDefined(getJSDocType(decl), "A JSDocType for this declaration should exist");
            Debug.assert(!decl.type, "The JSDocType decl should have a type");
            changes.tryInsertTypeAnnotation(sourceFile, decl, visitNode(jsdocType, transformJSDocType, isTypeNode));
        }
    }
    function isDeclarationWithType(node) {
        return isFunctionLikeDeclaration(node) || node.kind === 261 /* VariableDeclaration */  || node.kind === 172 /* PropertySignature */  || node.kind === 173 /* PropertyDeclaration */ ;
    }
    function transformJSDocType(node) {
        switch(node.kind){
            case 313 /* JSDocAllType */ :
            case 314 /* JSDocUnknownType */ :
                return factory.createTypeReferenceNode("any", emptyArray);
            case 317 /* JSDocOptionalType */ :
                return transformJSDocOptionalType(node);
            case 316 /* JSDocNonNullableType */ :
                return transformJSDocType(node.type);
            case 315 /* JSDocNullableType */ :
                return transformJSDocNullableType(node);
            case 319 /* JSDocVariadicType */ :
                return transformJSDocVariadicType(node);
            case 318 /* JSDocFunctionType */ :
                return transformJSDocFunctionType(node);
            case 184 /* TypeReference */ :
                return transformJSDocTypeReference(node);
            case 323 /* JSDocTypeLiteral */ :
                return transformJSDocTypeLiteral(node);
            default:
                const visited = visitEachChild(node, transformJSDocType, /*context*/ void 0);
                setEmitFlags(visited, 1 /* SingleLine */ );
                return visited;
        }
    }
    function transformJSDocTypeLiteral(node) {
        const typeNode = factory.createTypeLiteralNode(map(node.jsDocPropertyTags, (tag)=>factory.createPropertySignature(/*modifiers*/ void 0, isIdentifier(tag.name) ? tag.name : tag.name.right, isOptionalJSDocPropertyLikeTag(tag) ? factory.createToken(58 /* QuestionToken */ ) : void 0, tag.typeExpression && visitNode(tag.typeExpression.type, transformJSDocType, isTypeNode) || factory.createKeywordTypeNode(133 /* AnyKeyword */ ))));
        setEmitFlags(typeNode, 1 /* SingleLine */ );
        return typeNode;
    }
    function transformJSDocOptionalType(node) {
        return factory.createUnionTypeNode([
            visitNode(node.type, transformJSDocType, isTypeNode),
            factory.createTypeReferenceNode("undefined", emptyArray)
        ]);
    }
    function transformJSDocNullableType(node) {
        return factory.createUnionTypeNode([
            visitNode(node.type, transformJSDocType, isTypeNode),
            factory.createTypeReferenceNode("null", emptyArray)
        ]);
    }
    function transformJSDocVariadicType(node) {
        return factory.createArrayTypeNode(visitNode(node.type, transformJSDocType, isTypeNode));
    }
    function transformJSDocFunctionType(node) {
        var _node_type;
        return factory.createFunctionTypeNode(emptyArray, node.parameters.map(transformJSDocParameter), (_node_type = node.type) !== null && _node_type !== void 0 ? _node_type : factory.createKeywordTypeNode(133 /* AnyKeyword */ ));
    }
    function transformJSDocParameter(node) {
        const index = node.parent.parameters.indexOf(node);
        const isRest = node.type.kind === 319 /* JSDocVariadicType */  && index === node.parent.parameters.length - 1;
        const name = node.name || (isRest ? "rest" : "arg" + index);
        const dotdotdot = isRest ? factory.createToken(26 /* DotDotDotToken */ ) : node.dotDotDotToken;
        return factory.createParameterDeclaration(node.modifiers, dotdotdot, name, node.questionToken, visitNode(node.type, transformJSDocType, isTypeNode), node.initializer);
    }
    function transformJSDocTypeReference(node) {
        let name = node.typeName;
        let args = node.typeArguments;
        if (isIdentifier(node.typeName)) {
            if (isJSDocIndexSignature(node)) return transformJSDocIndexSignature(node);
            let text = node.typeName.text;
            switch(node.typeName.text){
                case "String":
                case "Boolean":
                case "Object":
                case "Number":
                    text = text.toLowerCase();
                    break;
                case "array":
                case "date":
                case "promise":
                    text = text[0].toUpperCase() + text.slice(1);
                    break;
            }
            name = factory.createIdentifier(text);
            if ((text === "Array" || text === "Promise") && !node.typeArguments) args = factory.createNodeArray([
                factory.createTypeReferenceNode("any", emptyArray)
            ]);
            else args = visitNodes2(node.typeArguments, transformJSDocType, isTypeNode);
        }
        return factory.createTypeReferenceNode(name, args);
    }
    function transformJSDocIndexSignature(node) {
        const index = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, node.typeArguments[0].kind === 150 /* NumberKeyword */  ? "n" : "s", /*questionToken*/ void 0, factory.createTypeReferenceNode(node.typeArguments[0].kind === 150 /* NumberKeyword */  ? "number" : "string", []), /*initializer*/ void 0);
        const indexSignature = factory.createTypeLiteralNode([
            factory.createIndexSignature(/*modifiers*/ void 0, [
                index
            ], node.typeArguments[1])
        ]);
        setEmitFlags(indexSignature, 1 /* SingleLine */ );
        return indexSignature;
    }
    // src/services/codefixes/convertFunctionToEs6Class.ts
    var fixId10 = "convertFunctionToEs6Class";
    var errorCodes11 = [
        Diagnostics.This_constructor_function_may_be_converted_to_a_class_declaration.code
    ];
    registerCodeFix({
        errorCodes: errorCodes11,
        getCodeActions (context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange9(t, context.sourceFile, context.span.start, context.program.getTypeChecker(), context.preferences, context.program.getCompilerOptions()));
            return [
                createCodeFixAction(fixId10, changes, Diagnostics.Convert_function_to_an_ES2015_class, fixId10, Diagnostics.Convert_all_constructor_functions_to_classes)
            ];
        },
        fixIds: [
            fixId10
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes11, (changes, err)=>doChange9(changes, err.file, err.start, context.program.getTypeChecker(), context.preferences, context.program.getCompilerOptions()))
    });
    function doChange9(changes, sourceFile, position, checker, preferences, compilerOptions) {
        const ctorSymbol = checker.getSymbolAtLocation(getTokenAtPosition(sourceFile, position));
        if (!ctorSymbol || !ctorSymbol.valueDeclaration || !(ctorSymbol.flags & 19 /* Variable */ )) return void 0;
        const ctorDeclaration = ctorSymbol.valueDeclaration;
        if (isFunctionDeclaration(ctorDeclaration) || isFunctionExpression(ctorDeclaration)) changes.replaceNode(sourceFile, ctorDeclaration, createClassFromFunction(ctorDeclaration));
        else if (isVariableDeclaration(ctorDeclaration)) {
            const classDeclaration = createClassFromVariableDeclaration(ctorDeclaration);
            if (!classDeclaration) return void 0;
            const ancestor = ctorDeclaration.parent.parent;
            if (isVariableDeclarationList(ctorDeclaration.parent) && ctorDeclaration.parent.declarations.length > 1) {
                changes.delete(sourceFile, ctorDeclaration);
                changes.insertNodeAfter(sourceFile, ancestor, classDeclaration);
            } else changes.replaceNode(sourceFile, ancestor, classDeclaration);
        }
        function createClassElementsFromSymbol(symbol) {
            const memberElements = [];
            if (symbol.exports) symbol.exports.forEach((member)=>{
                if (member.name === "prototype" && member.declarations) {
                    const firstDeclaration = member.declarations[0];
                    if (member.declarations.length === 1 && isPropertyAccessExpression(firstDeclaration) && isBinaryExpression(firstDeclaration.parent) && firstDeclaration.parent.operatorToken.kind === 64 /* EqualsToken */  && isObjectLiteralExpression(firstDeclaration.parent.right)) {
                        const prototypes = firstDeclaration.parent.right;
                        createClassElement(prototypes.symbol, /*modifiers*/ void 0, memberElements);
                    }
                } else createClassElement(member, [
                    factory.createToken(126 /* StaticKeyword */ )
                ], memberElements);
            });
            if (symbol.members) symbol.members.forEach((member, key)=>{
                var _a, _b, _c, _d;
                if (key === "constructor" && member.valueDeclaration) {
                    const prototypeAssignment = (_d = (_c = (_b = (_a = symbol.exports) == null ? void 0 : _a.get("prototype")) == null ? void 0 : _b.declarations) == null ? void 0 : _c[0]) == null ? void 0 : _d.parent;
                    if (prototypeAssignment && isBinaryExpression(prototypeAssignment) && isObjectLiteralExpression(prototypeAssignment.right) && some(prototypeAssignment.right.properties, isConstructorAssignment)) ;
                    else changes.delete(sourceFile, member.valueDeclaration.parent);
                    return;
                }
                createClassElement(member, /*modifiers*/ void 0, memberElements);
            });
            return memberElements;
            function shouldConvertDeclaration(_target, source) {
                if (isAccessExpression(_target)) {
                    if (isPropertyAccessExpression(_target) && isConstructorAssignment(_target)) return true;
                    return isFunctionLike(source);
                } else return every(_target.properties, (property)=>{
                    if (isMethodDeclaration(property) || isGetOrSetAccessorDeclaration(property)) return true;
                    if (isPropertyAssignment(property) && isFunctionExpression(property.initializer) && !!property.name) return true;
                    if (isConstructorAssignment(property)) return true;
                    return false;
                });
            }
            function createClassElement(symbol2, modifiers, members) {
                if (!(symbol2.flags & 8192 /* Method */ ) && !(symbol2.flags & 4096 /* ObjectLiteral */ )) return;
                const memberDeclaration = symbol2.valueDeclaration;
                const assignmentBinaryExpression = memberDeclaration.parent;
                const assignmentExpr = assignmentBinaryExpression.right;
                if (!shouldConvertDeclaration(memberDeclaration, assignmentExpr)) return;
                if (some(members, (m)=>{
                    const name = getNameOfDeclaration(m);
                    if (name && isIdentifier(name) && idText(name) === symbolName(symbol2)) return true;
                    return false;
                })) return;
                const nodeToDelete = assignmentBinaryExpression.parent && assignmentBinaryExpression.parent.kind === 245 /* ExpressionStatement */  ? assignmentBinaryExpression.parent : assignmentBinaryExpression;
                changes.delete(sourceFile, nodeToDelete);
                if (!assignmentExpr) {
                    members.push(factory.createPropertyDeclaration(modifiers, symbol2.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0));
                    return;
                }
                if (isAccessExpression(memberDeclaration) && (isFunctionExpression(assignmentExpr) || isArrowFunction(assignmentExpr))) {
                    const quotePreference = getQuotePreference(sourceFile, preferences);
                    const name = tryGetPropertyName(memberDeclaration, compilerOptions, quotePreference);
                    if (name) createFunctionLikeExpressionMember(members, assignmentExpr, name);
                    return;
                } else if (isObjectLiteralExpression(assignmentExpr)) {
                    forEach(assignmentExpr.properties, (property)=>{
                        if (isMethodDeclaration(property) || isGetOrSetAccessorDeclaration(property)) members.push(property);
                        if (isPropertyAssignment(property) && isFunctionExpression(property.initializer)) createFunctionLikeExpressionMember(members, property.initializer, property.name);
                        if (isConstructorAssignment(property)) return;
                        return;
                    });
                    return;
                } else {
                    if (isSourceFileJS(sourceFile)) return;
                    if (!isPropertyAccessExpression(memberDeclaration)) return;
                    const prop = factory.createPropertyDeclaration(modifiers, memberDeclaration.name, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, assignmentExpr);
                    copyLeadingComments(assignmentBinaryExpression.parent, prop, sourceFile);
                    members.push(prop);
                    return;
                }
                function createFunctionLikeExpressionMember(members2, expression, name) {
                    if (isFunctionExpression(expression)) return createFunctionExpressionMember(members2, expression, name);
                    else return createArrowFunctionExpressionMember(members2, expression, name);
                }
                function createFunctionExpressionMember(members2, functionExpression, name) {
                    const fullModifiers = concatenate(modifiers, getModifierKindFromSource(functionExpression, 134 /* AsyncKeyword */ ));
                    const method = factory.createMethodDeclaration(fullModifiers, /*asteriskToken*/ void 0, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, functionExpression.parameters, /*type*/ void 0, functionExpression.body);
                    copyLeadingComments(assignmentBinaryExpression, method, sourceFile);
                    members2.push(method);
                    return;
                }
                function createArrowFunctionExpressionMember(members2, arrowFunction, name) {
                    const arrowFunctionBody = arrowFunction.body;
                    let bodyBlock;
                    if (arrowFunctionBody.kind === 242 /* Block */ ) bodyBlock = arrowFunctionBody;
                    else bodyBlock = factory.createBlock([
                        factory.createReturnStatement(arrowFunctionBody)
                    ]);
                    const fullModifiers = concatenate(modifiers, getModifierKindFromSource(arrowFunction, 134 /* AsyncKeyword */ ));
                    const method = factory.createMethodDeclaration(fullModifiers, /*asteriskToken*/ void 0, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, arrowFunction.parameters, /*type*/ void 0, bodyBlock);
                    copyLeadingComments(assignmentBinaryExpression, method, sourceFile);
                    members2.push(method);
                }
            }
        }
        function createClassFromVariableDeclaration(node) {
            const initializer = node.initializer;
            if (!initializer || !isFunctionExpression(initializer) || !isIdentifier(node.name)) return void 0;
            const memberElements = createClassElementsFromSymbol(node.symbol);
            if (initializer.body) memberElements.unshift(factory.createConstructorDeclaration(/*modifiers*/ void 0, initializer.parameters, initializer.body));
            const modifiers = getModifierKindFromSource(node.parent.parent, 95 /* ExportKeyword */ );
            const cls = factory.createClassDeclaration(modifiers, node.name, /*typeParameters*/ void 0, /*heritageClauses*/ void 0, memberElements);
            return cls;
        }
        function createClassFromFunction(node) {
            const memberElements = createClassElementsFromSymbol(ctorSymbol);
            if (node.body) memberElements.unshift(factory.createConstructorDeclaration(/*modifiers*/ void 0, node.parameters, node.body));
            const modifiers = getModifierKindFromSource(node, 95 /* ExportKeyword */ );
            const cls = factory.createClassDeclaration(modifiers, node.name, /*typeParameters*/ void 0, /*heritageClauses*/ void 0, memberElements);
            return cls;
        }
    }
    function getModifierKindFromSource(source, kind) {
        return canHaveModifiers(source) ? filter(source.modifiers, (modifier)=>modifier.kind === kind) : void 0;
    }
    function isConstructorAssignment(x) {
        if (!x.name) return false;
        if (isIdentifier(x.name) && x.name.text === "constructor") return true;
        return false;
    }
    function tryGetPropertyName(node, compilerOptions, quotePreference) {
        if (isPropertyAccessExpression(node)) return node.name;
        const propName = node.argumentExpression;
        if (isNumericLiteral(propName)) return propName;
        if (isStringLiteralLike(propName)) return isIdentifierText(propName.text, getEmitScriptTarget(compilerOptions)) ? factory.createIdentifier(propName.text) : isNoSubstitutionTemplateLiteral(propName) ? factory.createStringLiteral(propName.text, quotePreference === 0 /* Single */ ) : propName;
        return void 0;
    }
    // src/services/codefixes/convertToAsyncFunction.ts
    var fixId11 = "convertToAsyncFunction";
    var errorCodes12 = [
        Diagnostics.This_may_be_converted_to_an_async_function.code
    ];
    var codeActionSucceeded = true;
    registerCodeFix({
        errorCodes: errorCodes12,
        getCodeActions (context) {
            codeActionSucceeded = true;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>convertToAsyncFunction(t, context.sourceFile, context.span.start, context.program.getTypeChecker()));
            return codeActionSucceeded ? [
                createCodeFixAction(fixId11, changes, Diagnostics.Convert_to_async_function, fixId11, Diagnostics.Convert_all_to_async_functions)
            ] : [];
        },
        fixIds: [
            fixId11
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes12, (changes, err)=>convertToAsyncFunction(changes, err.file, err.start, context.program.getTypeChecker()))
    });
    function convertToAsyncFunction(changes, sourceFile, position, checker) {
        const tokenAtPosition = getTokenAtPosition(sourceFile, position);
        let functionToConvert;
        if (isIdentifier(tokenAtPosition) && isVariableDeclaration(tokenAtPosition.parent) && tokenAtPosition.parent.initializer && isFunctionLikeDeclaration(tokenAtPosition.parent.initializer)) functionToConvert = tokenAtPosition.parent.initializer;
        else functionToConvert = tryCast(getContainingFunction(getTokenAtPosition(sourceFile, position)), canBeConvertedToAsync);
        if (!functionToConvert) return;
        const synthNamesMap = /* @__PURE__ */ new Map();
        const isInJavascript = isInJSFile(functionToConvert);
        const setOfExpressionsToReturn = getAllPromiseExpressionsToReturn(functionToConvert, checker);
        const functionToConvertRenamed = renameCollidingVarNames(functionToConvert, checker, synthNamesMap);
        if (!returnsPromise(functionToConvertRenamed, checker)) return;
        const returnStatements = functionToConvertRenamed.body && isBlock(functionToConvertRenamed.body) ? getReturnStatementsWithPromiseHandlers(functionToConvertRenamed.body, checker) : emptyArray;
        const transformer = {
            checker,
            synthNamesMap,
            setOfExpressionsToReturn,
            isInJSFile: isInJavascript
        };
        if (!returnStatements.length) return;
        const pos = skipTrivia(sourceFile.text, moveRangePastModifiers(functionToConvert).pos);
        changes.insertModifierAt(sourceFile, pos, 134 /* AsyncKeyword */ , {
            suffix: " "
        });
        for (const returnStatement of returnStatements){
            forEachChild(returnStatement, function visit(node) {
                if (isCallExpression(node)) {
                    const newNodes = transformExpression(node, node, transformer, /*hasContinuation*/ false);
                    if (hasFailed()) return true;
                    changes.replaceNodeWithNodes(sourceFile, returnStatement, newNodes);
                } else if (!isFunctionLike(node)) {
                    forEachChild(node, visit);
                    if (hasFailed()) return true;
                }
            });
            if (hasFailed()) return;
        }
    }
    function getReturnStatementsWithPromiseHandlers(body, checker) {
        const res = [];
        forEachReturnStatement(body, (ret)=>{
            if (isReturnStatementWithFixablePromiseHandler(ret, checker)) res.push(ret);
        });
        return res;
    }
    function getAllPromiseExpressionsToReturn(func, checker) {
        if (!func.body) return /* @__PURE__ */ new Set();
        const setOfExpressionsToReturn = /* @__PURE__ */ new Set();
        forEachChild(func.body, function visit(node) {
            if (isPromiseReturningCallExpression(node, checker, "then")) {
                setOfExpressionsToReturn.add(getNodeId(node));
                forEach(node.arguments, visit);
            } else if (isPromiseReturningCallExpression(node, checker, "catch") || isPromiseReturningCallExpression(node, checker, "finally")) {
                setOfExpressionsToReturn.add(getNodeId(node));
                forEachChild(node, visit);
            } else if (isPromiseTypedExpression(node, checker)) setOfExpressionsToReturn.add(getNodeId(node));
            else forEachChild(node, visit);
        });
        return setOfExpressionsToReturn;
    }
    function isPromiseReturningCallExpression(node, checker, name) {
        if (!isCallExpression(node)) return false;
        const isExpressionOfName = hasPropertyAccessExpressionWithName(node, name);
        const nodeType = isExpressionOfName && checker.getTypeAtLocation(node);
        return !!(nodeType && checker.getPromisedTypeOfPromise(nodeType));
    }
    function isReferenceToType(type, target) {
        return (getObjectFlags(type) & 4 /* Reference */ ) !== 0 && type.target === target;
    }
    function getExplicitPromisedTypeOfPromiseReturningCallExpression(node, callback, checker) {
        if (node.expression.name.escapedText === "finally") return void 0;
        const promiseType = checker.getTypeAtLocation(node.expression.expression);
        if (isReferenceToType(promiseType, checker.getPromiseType()) || isReferenceToType(promiseType, checker.getPromiseLikeType())) {
            if (node.expression.name.escapedText === "then") {
                if (callback === elementAt(node.arguments, 0)) return elementAt(node.typeArguments, 0);
                else if (callback === elementAt(node.arguments, 1)) return elementAt(node.typeArguments, 1);
            } else return elementAt(node.typeArguments, 0);
        }
    }
    function isPromiseTypedExpression(node, checker) {
        if (!isExpression(node)) return false;
        return !!checker.getPromisedTypeOfPromise(checker.getTypeAtLocation(node));
    }
    function renameCollidingVarNames(nodeToRename, checker, synthNamesMap) {
        const identsToRenameMap = /* @__PURE__ */ new Map();
        const collidingSymbolMap = createMultiMap();
        forEachChild(nodeToRename, function visit(node) {
            if (!isIdentifier(node)) {
                forEachChild(node, visit);
                return;
            }
            const symbol = checker.getSymbolAtLocation(node);
            if (symbol) {
                const type = checker.getTypeAtLocation(node);
                const lastCallSignature = getLastCallSignature(type, checker);
                const symbolIdString = getSymbolId(symbol).toString();
                if (lastCallSignature && !isParameter(node.parent) && !isFunctionLikeDeclaration(node.parent) && !synthNamesMap.has(symbolIdString)) {
                    const firstParameter = firstOrUndefined(lastCallSignature.parameters);
                    const ident = (firstParameter == null ? void 0 : firstParameter.valueDeclaration) && isParameter(firstParameter.valueDeclaration) && tryCast(firstParameter.valueDeclaration.name, isIdentifier) || factory.createUniqueName("result", 16 /* Optimistic */ );
                    const synthName = getNewNameIfConflict(ident, collidingSymbolMap);
                    synthNamesMap.set(symbolIdString, synthName);
                    collidingSymbolMap.add(ident.text, symbol);
                } else if (node.parent && (isParameter(node.parent) || isVariableDeclaration(node.parent) || isBindingElement(node.parent))) {
                    const originalName = node.text;
                    const collidingSymbols = collidingSymbolMap.get(originalName);
                    if (collidingSymbols && collidingSymbols.some((prevSymbol)=>prevSymbol !== symbol)) {
                        const newName = getNewNameIfConflict(node, collidingSymbolMap);
                        identsToRenameMap.set(symbolIdString, newName.identifier);
                        synthNamesMap.set(symbolIdString, newName);
                        collidingSymbolMap.add(originalName, symbol);
                    } else {
                        const identifier = getSynthesizedDeepClone(node);
                        synthNamesMap.set(symbolIdString, createSynthIdentifier(identifier));
                        collidingSymbolMap.add(originalName, symbol);
                    }
                }
            }
        });
        return getSynthesizedDeepCloneWithReplacements(nodeToRename, /*includeTrivia*/ true, (original)=>{
            if (isBindingElement(original) && isIdentifier(original.name) && isObjectBindingPattern(original.parent)) {
                const symbol = checker.getSymbolAtLocation(original.name);
                const renameInfo = symbol && identsToRenameMap.get(String(getSymbolId(symbol)));
                if (renameInfo && renameInfo.text !== (original.name || original.propertyName).getText()) return factory.createBindingElement(original.dotDotDotToken, original.propertyName || original.name, renameInfo, original.initializer);
            } else if (isIdentifier(original)) {
                const symbol = checker.getSymbolAtLocation(original);
                const renameInfo = symbol && identsToRenameMap.get(String(getSymbolId(symbol)));
                if (renameInfo) return factory.createIdentifier(renameInfo.text);
            }
        });
    }
    function getNewNameIfConflict(name, originalNames) {
        const numVarsSameName = (originalNames.get(name.text) || emptyArray).length;
        const identifier = numVarsSameName === 0 ? name : factory.createIdentifier(name.text + "_" + numVarsSameName);
        return createSynthIdentifier(identifier);
    }
    function hasFailed() {
        return !codeActionSucceeded;
    }
    function silentFail() {
        codeActionSucceeded = false;
        return emptyArray;
    }
    function transformExpression(returnContextNode, node, transformer, hasContinuation, continuationArgName) {
        if (isPromiseReturningCallExpression(node, transformer.checker, "then")) return transformThen(node, elementAt(node.arguments, 0), elementAt(node.arguments, 1), transformer, hasContinuation, continuationArgName);
        if (isPromiseReturningCallExpression(node, transformer.checker, "catch")) return transformCatch(node, elementAt(node.arguments, 0), transformer, hasContinuation, continuationArgName);
        if (isPromiseReturningCallExpression(node, transformer.checker, "finally")) return transformFinally(node, elementAt(node.arguments, 0), transformer, hasContinuation, continuationArgName);
        if (isPropertyAccessExpression(node)) return transformExpression(returnContextNode, node.expression, transformer, hasContinuation, continuationArgName);
        const nodeType = transformer.checker.getTypeAtLocation(node);
        if (nodeType && transformer.checker.getPromisedTypeOfPromise(nodeType)) {
            Debug.assertNode(getOriginalNode(node).parent, isPropertyAccessExpression);
            return transformPromiseExpressionOfPropertyAccess(returnContextNode, node, transformer, hasContinuation, continuationArgName);
        }
        return silentFail();
    }
    function isNullOrUndefined2({ checker }, node) {
        if (node.kind === 106 /* NullKeyword */ ) return true;
        if (isIdentifier(node) && !isGeneratedIdentifier(node) && idText(node) === "undefined") {
            const symbol = checker.getSymbolAtLocation(node);
            return !symbol || checker.isUndefinedSymbol(symbol);
        }
        return false;
    }
    function createUniqueSynthName(prevArgName) {
        const renamedPrevArg = factory.createUniqueName(prevArgName.identifier.text, 16 /* Optimistic */ );
        return createSynthIdentifier(renamedPrevArg);
    }
    function getPossibleNameForVarDecl(node, transformer, continuationArgName) {
        let possibleNameForVarDecl;
        if (continuationArgName && !shouldReturn(node, transformer)) {
            if (isSynthIdentifier(continuationArgName)) {
                possibleNameForVarDecl = continuationArgName;
                transformer.synthNamesMap.forEach((val, key)=>{
                    if (val.identifier.text === continuationArgName.identifier.text) {
                        const newSynthName = createUniqueSynthName(continuationArgName);
                        transformer.synthNamesMap.set(key, newSynthName);
                    }
                });
            } else possibleNameForVarDecl = createSynthIdentifier(factory.createUniqueName("result", 16 /* Optimistic */ ), continuationArgName.types);
            declareSynthIdentifier(possibleNameForVarDecl);
        }
        return possibleNameForVarDecl;
    }
    function finishCatchOrFinallyTransform(node, transformer, tryStatement, possibleNameForVarDecl, continuationArgName) {
        const statements = [];
        let varDeclIdentifier;
        if (possibleNameForVarDecl && !shouldReturn(node, transformer)) {
            varDeclIdentifier = getSynthesizedDeepClone(declareSynthIdentifier(possibleNameForVarDecl));
            const typeArray = possibleNameForVarDecl.types;
            const unionType = transformer.checker.getUnionType(typeArray, 2 /* Subtype */ );
            const unionTypeNode = transformer.isInJSFile ? void 0 : transformer.checker.typeToTypeNode(unionType, /*enclosingDeclaration*/ void 0, /*flags*/ void 0);
            const varDecl = [
                factory.createVariableDeclaration(varDeclIdentifier, /*exclamationToken*/ void 0, unionTypeNode)
            ];
            const varDeclList = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList(varDecl, 1 /* Let */ ));
            statements.push(varDeclList);
        }
        statements.push(tryStatement);
        if (continuationArgName && varDeclIdentifier && isSynthBindingPattern(continuationArgName)) statements.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(getSynthesizedDeepClone(declareSynthBindingPattern(continuationArgName)), /*exclamationToken*/ void 0, /*type*/ void 0, varDeclIdentifier)
        ], 2 /* Const */ )));
        return statements;
    }
    function transformFinally(node, onFinally, transformer, hasContinuation, continuationArgName) {
        if (!onFinally || isNullOrUndefined2(transformer, onFinally)) return transformExpression(/* returnContextNode */ node, node.expression.expression, transformer, hasContinuation, continuationArgName);
        const possibleNameForVarDecl = getPossibleNameForVarDecl(node, transformer, continuationArgName);
        const inlinedLeftHandSide = transformExpression(/*returnContextNode*/ node, node.expression.expression, transformer, /*hasContinuation*/ true, possibleNameForVarDecl);
        if (hasFailed()) return silentFail();
        const inlinedCallback = transformCallbackArgument(onFinally, hasContinuation, /*continuationArgName*/ void 0, /*inputArgName*/ void 0, node, transformer);
        if (hasFailed()) return silentFail();
        const tryBlock = factory.createBlock(inlinedLeftHandSide);
        const finallyBlock = factory.createBlock(inlinedCallback);
        const tryStatement = factory.createTryStatement(tryBlock, /*catchClause*/ void 0, finallyBlock);
        return finishCatchOrFinallyTransform(node, transformer, tryStatement, possibleNameForVarDecl, continuationArgName);
    }
    function transformCatch(node, onRejected, transformer, hasContinuation, continuationArgName) {
        if (!onRejected || isNullOrUndefined2(transformer, onRejected)) return transformExpression(/* returnContextNode */ node, node.expression.expression, transformer, hasContinuation, continuationArgName);
        const inputArgName = getArgBindingName(onRejected, transformer);
        const possibleNameForVarDecl = getPossibleNameForVarDecl(node, transformer, continuationArgName);
        const inlinedLeftHandSide = transformExpression(/*returnContextNode*/ node, node.expression.expression, transformer, /*hasContinuation*/ true, possibleNameForVarDecl);
        if (hasFailed()) return silentFail();
        const inlinedCallback = transformCallbackArgument(onRejected, hasContinuation, possibleNameForVarDecl, inputArgName, node, transformer);
        if (hasFailed()) return silentFail();
        const tryBlock = factory.createBlock(inlinedLeftHandSide);
        const catchClause = factory.createCatchClause(inputArgName && getSynthesizedDeepClone(declareSynthBindingName(inputArgName)), factory.createBlock(inlinedCallback));
        const tryStatement = factory.createTryStatement(tryBlock, catchClause, /*finallyBlock*/ void 0);
        return finishCatchOrFinallyTransform(node, transformer, tryStatement, possibleNameForVarDecl, continuationArgName);
    }
    function transformThen(node, onFulfilled, onRejected, transformer, hasContinuation, continuationArgName) {
        if (!onFulfilled || isNullOrUndefined2(transformer, onFulfilled)) return transformCatch(node, onRejected, transformer, hasContinuation, continuationArgName);
        if (onRejected && !isNullOrUndefined2(transformer, onRejected)) return silentFail();
        const inputArgName = getArgBindingName(onFulfilled, transformer);
        const inlinedLeftHandSide = transformExpression(node.expression.expression, node.expression.expression, transformer, /*hasContinuation*/ true, inputArgName);
        if (hasFailed()) return silentFail();
        const inlinedCallback = transformCallbackArgument(onFulfilled, hasContinuation, continuationArgName, inputArgName, node, transformer);
        if (hasFailed()) return silentFail();
        return concatenate(inlinedLeftHandSide, inlinedCallback);
    }
    function transformPromiseExpressionOfPropertyAccess(returnContextNode, node, transformer, hasContinuation, continuationArgName) {
        if (shouldReturn(returnContextNode, transformer)) {
            let returnValue = getSynthesizedDeepClone(node);
            if (hasContinuation) returnValue = factory.createAwaitExpression(returnValue);
            return [
                factory.createReturnStatement(returnValue)
            ];
        }
        return createVariableOrAssignmentOrExpressionStatement(continuationArgName, factory.createAwaitExpression(node), /*typeAnnotation*/ void 0);
    }
    function createVariableOrAssignmentOrExpressionStatement(variableName, rightHandSide, typeAnnotation) {
        if (!variableName || isEmptyBindingName(variableName)) return [
            factory.createExpressionStatement(rightHandSide)
        ];
        if (isSynthIdentifier(variableName) && variableName.hasBeenDeclared) return [
            factory.createExpressionStatement(factory.createAssignment(getSynthesizedDeepClone(referenceSynthIdentifier(variableName)), rightHandSide))
        ];
        return [
            factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                factory.createVariableDeclaration(getSynthesizedDeepClone(declareSynthBindingName(variableName)), /*exclamationToken*/ void 0, typeAnnotation, rightHandSide)
            ], 2 /* Const */ ))
        ];
    }
    function maybeAnnotateAndReturn(expressionToReturn, typeAnnotation) {
        if (typeAnnotation && expressionToReturn) {
            const name = factory.createUniqueName("result", 16 /* Optimistic */ );
            return [
                ...createVariableOrAssignmentOrExpressionStatement(createSynthIdentifier(name), expressionToReturn, typeAnnotation),
                factory.createReturnStatement(name)
            ];
        }
        return [
            factory.createReturnStatement(expressionToReturn)
        ];
    }
    function transformCallbackArgument(func, hasContinuation, continuationArgName, inputArgName, parent2, transformer) {
        var _a;
        switch(func.kind){
            case 106 /* NullKeyword */ :
                break;
            case 212 /* PropertyAccessExpression */ :
            case 80 /* Identifier */ :
                if (!inputArgName) break;
                const synthCall = factory.createCallExpression(getSynthesizedDeepClone(func), /*typeArguments*/ void 0, isSynthIdentifier(inputArgName) ? [
                    referenceSynthIdentifier(inputArgName)
                ] : []);
                if (shouldReturn(parent2, transformer)) return maybeAnnotateAndReturn(synthCall, getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker));
                const type = transformer.checker.getTypeAtLocation(func);
                const callSignatures = transformer.checker.getSignaturesOfType(type, 0 /* Call */ );
                if (!callSignatures.length) return silentFail();
                const returnType = callSignatures[0].getReturnType();
                const varDeclOrAssignment = createVariableOrAssignmentOrExpressionStatement(continuationArgName, factory.createAwaitExpression(synthCall), getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker));
                if (continuationArgName) continuationArgName.types.push(transformer.checker.getAwaitedType(returnType) || returnType);
                return varDeclOrAssignment;
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                {
                    const funcBody = func.body;
                    const returnType2 = (_a = getLastCallSignature(transformer.checker.getTypeAtLocation(func), transformer.checker)) == null ? void 0 : _a.getReturnType();
                    if (isBlock(funcBody)) {
                        let refactoredStmts = [];
                        let seenReturnStatement = false;
                        for (const statement of funcBody.statements){
                            if (isReturnStatement(statement)) {
                                seenReturnStatement = true;
                                if (isReturnStatementWithFixablePromiseHandler(statement, transformer.checker)) refactoredStmts = refactoredStmts.concat(transformReturnStatementWithFixablePromiseHandler(transformer, statement, hasContinuation, continuationArgName));
                                else {
                                    const possiblyAwaitedRightHandSide = returnType2 && statement.expression ? getPossiblyAwaitedRightHandSide(transformer.checker, returnType2, statement.expression) : statement.expression;
                                    refactoredStmts.push(...maybeAnnotateAndReturn(possiblyAwaitedRightHandSide, getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker)));
                                }
                            } else if (hasContinuation && forEachReturnStatement(statement, returnTrue)) return silentFail();
                            else refactoredStmts.push(statement);
                        }
                        return shouldReturn(parent2, transformer) ? refactoredStmts.map((s)=>getSynthesizedDeepClone(s)) : removeReturns(refactoredStmts, continuationArgName, transformer, seenReturnStatement);
                    } else {
                        const inlinedStatements = isFixablePromiseHandler(funcBody, transformer.checker) ? transformReturnStatementWithFixablePromiseHandler(transformer, factory.createReturnStatement(funcBody), hasContinuation, continuationArgName) : emptyArray;
                        if (inlinedStatements.length > 0) return inlinedStatements;
                        if (returnType2) {
                            const possiblyAwaitedRightHandSide = getPossiblyAwaitedRightHandSide(transformer.checker, returnType2, funcBody);
                            if (!shouldReturn(parent2, transformer)) {
                                const transformedStatement = createVariableOrAssignmentOrExpressionStatement(continuationArgName, possiblyAwaitedRightHandSide, /*typeAnnotation*/ void 0);
                                if (continuationArgName) continuationArgName.types.push(transformer.checker.getAwaitedType(returnType2) || returnType2);
                                return transformedStatement;
                            } else return maybeAnnotateAndReturn(possiblyAwaitedRightHandSide, getExplicitPromisedTypeOfPromiseReturningCallExpression(parent2, func, transformer.checker));
                        } else return silentFail();
                    }
                }
            default:
                return silentFail();
        }
        return emptyArray;
    }
    function getPossiblyAwaitedRightHandSide(checker, type, expr) {
        const rightHandSide = getSynthesizedDeepClone(expr);
        return !!checker.getPromisedTypeOfPromise(type) ? factory.createAwaitExpression(rightHandSide) : rightHandSide;
    }
    function getLastCallSignature(type, checker) {
        const callSignatures = checker.getSignaturesOfType(type, 0 /* Call */ );
        return lastOrUndefined(callSignatures);
    }
    function removeReturns(stmts, prevArgName, transformer, seenReturnStatement) {
        const ret = [];
        for (const stmt of stmts){
            if (isReturnStatement(stmt)) {
                if (stmt.expression) {
                    const possiblyAwaitedExpression = isPromiseTypedExpression(stmt.expression, transformer.checker) ? factory.createAwaitExpression(stmt.expression) : stmt.expression;
                    if (prevArgName === void 0) ret.push(factory.createExpressionStatement(possiblyAwaitedExpression));
                    else if (isSynthIdentifier(prevArgName) && prevArgName.hasBeenDeclared) ret.push(factory.createExpressionStatement(factory.createAssignment(referenceSynthIdentifier(prevArgName), possiblyAwaitedExpression)));
                    else ret.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                        factory.createVariableDeclaration(declareSynthBindingName(prevArgName), /*exclamationToken*/ void 0, /*type*/ void 0, possiblyAwaitedExpression)
                    ], 2 /* Const */ )));
                }
            } else ret.push(getSynthesizedDeepClone(stmt));
        }
        if (!seenReturnStatement && prevArgName !== void 0) ret.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(declareSynthBindingName(prevArgName), /*exclamationToken*/ void 0, /*type*/ void 0, factory.createIdentifier("undefined"))
        ], 2 /* Const */ )));
        return ret;
    }
    function transformReturnStatementWithFixablePromiseHandler(transformer, innerRetStmt, hasContinuation, continuationArgName) {
        let innerCbBody = [];
        forEachChild(innerRetStmt, function visit(node) {
            if (isCallExpression(node)) {
                const temp = transformExpression(node, node, transformer, hasContinuation, continuationArgName);
                innerCbBody = innerCbBody.concat(temp);
                if (innerCbBody.length > 0) return;
            } else if (!isFunctionLike(node)) forEachChild(node, visit);
        });
        return innerCbBody;
    }
    function getArgBindingName(funcNode, transformer) {
        const types = [];
        let name;
        if (isFunctionLikeDeclaration(funcNode)) {
            if (funcNode.parameters.length > 0) {
                const param = funcNode.parameters[0].name;
                name = getMappedBindingNameOrDefault(param);
            }
        } else if (isIdentifier(funcNode)) name = getMapEntryOrDefault(funcNode);
        else if (isPropertyAccessExpression(funcNode) && isIdentifier(funcNode.name)) name = getMapEntryOrDefault(funcNode.name);
        if (!name || "identifier" in name && name.identifier.text === "undefined") return void 0;
        return name;
        function getMappedBindingNameOrDefault(bindingName) {
            if (isIdentifier(bindingName)) return getMapEntryOrDefault(bindingName);
            const elements = flatMap(bindingName.elements, (element)=>{
                if (isOmittedExpression(element)) return [];
                return [
                    getMappedBindingNameOrDefault(element.name)
                ];
            });
            return createSynthBindingPattern(bindingName, elements);
        }
        function getMapEntryOrDefault(identifier) {
            const originalNode = getOriginalNode2(identifier);
            const symbol = getSymbol2(originalNode);
            if (!symbol) return createSynthIdentifier(identifier, types);
            const mapEntry = transformer.synthNamesMap.get(getSymbolId(symbol).toString());
            return mapEntry || createSynthIdentifier(identifier, types);
        }
        function getSymbol2(node) {
            var _a;
            var _ref;
            return (_ref = (_a = tryCast(node, canHaveSymbol)) == null ? void 0 : _a.symbol) !== null && _ref !== void 0 ? _ref : transformer.checker.getSymbolAtLocation(node);
        }
        function getOriginalNode2(node) {
            return node.original ? node.original : node;
        }
    }
    function isEmptyBindingName(bindingName) {
        if (!bindingName) return true;
        if (isSynthIdentifier(bindingName)) return !bindingName.identifier.text;
        return every(bindingName.elements, isEmptyBindingName);
    }
    function createSynthIdentifier(identifier, types = []) {
        return {
            kind: 0 /* Identifier */ ,
            identifier,
            types,
            hasBeenDeclared: false,
            hasBeenReferenced: false
        };
    }
    function createSynthBindingPattern(bindingPattern, elements = emptyArray, types = []) {
        return {
            kind: 1 /* BindingPattern */ ,
            bindingPattern,
            elements,
            types
        };
    }
    function referenceSynthIdentifier(synthId) {
        synthId.hasBeenReferenced = true;
        return synthId.identifier;
    }
    function declareSynthBindingName(synthName) {
        return isSynthIdentifier(synthName) ? declareSynthIdentifier(synthName) : declareSynthBindingPattern(synthName);
    }
    function declareSynthBindingPattern(synthPattern) {
        for (const element of synthPattern.elements)declareSynthBindingName(element);
        return synthPattern.bindingPattern;
    }
    function declareSynthIdentifier(synthId) {
        synthId.hasBeenDeclared = true;
        return synthId.identifier;
    }
    function isSynthIdentifier(bindingName) {
        return bindingName.kind === 0 /* Identifier */ ;
    }
    function isSynthBindingPattern(bindingName) {
        return bindingName.kind === 1 /* BindingPattern */ ;
    }
    function shouldReturn(expression, transformer) {
        return !!expression.original && transformer.setOfExpressionsToReturn.has(getNodeId(expression.original));
    }
    // src/services/codefixes/convertToEsModule.ts
    registerCodeFix({
        errorCodes: [
            Diagnostics.File_is_a_CommonJS_module_it_may_be_converted_to_an_ES_module.code
        ],
        getCodeActions (context) {
            const { sourceFile, program, preferences } = context;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                const moduleExportsChangedToDefault = convertFileToEsModule(sourceFile, program.getTypeChecker(), changes2, getEmitScriptTarget(program.getCompilerOptions()), getQuotePreference(sourceFile, preferences));
                if (moduleExportsChangedToDefault) for (const importingFile of program.getSourceFiles())fixImportOfModuleExports(importingFile, sourceFile, program, changes2, getQuotePreference(importingFile, preferences));
            });
            return [
                createCodeFixActionWithoutFixAll("convertToEsModule", changes, Diagnostics.Convert_to_ES_module)
            ];
        }
    });
    function fixImportOfModuleExports(importingFile, exportingFile, program, changes, quotePreference) {
        var _a;
        for (const moduleSpecifier of importingFile.imports){
            const imported = (_a = program.getResolvedModuleFromModuleSpecifier(moduleSpecifier, importingFile)) == null ? void 0 : _a.resolvedModule;
            if (!imported || imported.resolvedFileName !== exportingFile.fileName) continue;
            const importNode = importFromModuleSpecifier(moduleSpecifier);
            switch(importNode.kind){
                case 272 /* ImportEqualsDeclaration */ :
                    changes.replaceNode(importingFile, importNode, makeImport(importNode.name, /*namedImports*/ void 0, moduleSpecifier, quotePreference));
                    break;
                case 214 /* CallExpression */ :
                    if (isRequireCall(importNode, /*requireStringLiteralLikeArgument*/ false)) changes.replaceNode(importingFile, importNode, factory.createPropertyAccessExpression(getSynthesizedDeepClone(importNode), "default"));
                    break;
            }
        }
    }
    function convertFileToEsModule(sourceFile, checker, changes, target, quotePreference) {
        const identifiers = {
            original: collectFreeIdentifiers(sourceFile),
            additional: /* @__PURE__ */ new Set()
        };
        const exports2 = collectExportRenames(sourceFile, checker, identifiers);
        convertExportsAccesses(sourceFile, exports2, changes);
        let moduleExportsChangedToDefault = false;
        let useSitesToUnqualify;
        for (const statement of filter(sourceFile.statements, isVariableStatement)){
            const newUseSites = convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference);
            if (newUseSites) copyEntries(newUseSites, useSitesToUnqualify !== null && useSitesToUnqualify !== void 0 ? useSitesToUnqualify : useSitesToUnqualify = /* @__PURE__ */ new Map());
        }
        for (const statement of filter(sourceFile.statements, (s)=>!isVariableStatement(s))){
            const moduleExportsChanged = convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports2, useSitesToUnqualify, quotePreference);
            moduleExportsChangedToDefault = moduleExportsChangedToDefault || moduleExportsChanged;
        }
        useSitesToUnqualify == null || useSitesToUnqualify.forEach((replacement, original)=>{
            changes.replaceNode(sourceFile, original, replacement);
        });
        return moduleExportsChangedToDefault;
    }
    function collectExportRenames(sourceFile, checker, identifiers) {
        const res = /* @__PURE__ */ new Map();
        forEachExportReference(sourceFile, (node)=>{
            const { text } = node.name;
            if (!res.has(text) && (isIdentifierANonContextualKeyword(node.name) || checker.resolveName(text, node, 111551 /* Value */ , /*excludeGlobals*/ true))) res.set(text, makeUniqueName(`_${text}`, identifiers));
        });
        return res;
    }
    function convertExportsAccesses(sourceFile, exports2, changes) {
        forEachExportReference(sourceFile, (node, isAssignmentLhs)=>{
            if (isAssignmentLhs) return;
            const { text } = node.name;
            changes.replaceNode(sourceFile, node, factory.createIdentifier(exports2.get(text) || text));
        });
    }
    function forEachExportReference(sourceFile, cb) {
        sourceFile.forEachChild(function recur(node) {
            if (isPropertyAccessExpression(node) && isExportsOrModuleExportsOrAlias(sourceFile, node.expression) && isIdentifier(node.name)) {
                const { parent: parent2 } = node;
                cb(node, isBinaryExpression(parent2) && parent2.left === node && parent2.operatorToken.kind === 64 /* EqualsToken */ );
            }
            node.forEachChild(recur);
        });
    }
    function convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports2, useSitesToUnqualify, quotePreference) {
        switch(statement.kind){
            case 244 /* VariableStatement */ :
                convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference);
                return false;
            case 245 /* ExpressionStatement */ :
                {
                    const { expression } = statement;
                    switch(expression.kind){
                        case 214 /* CallExpression */ :
                            if (isRequireCall(expression, /*requireStringLiteralLikeArgument*/ true)) changes.replaceNode(sourceFile, statement, makeImport(/*defaultImport*/ void 0, /*namedImports*/ void 0, expression.arguments[0], quotePreference));
                            return false;
                        case 227 /* BinaryExpression */ :
                            {
                                const { operatorToken } = expression;
                                return operatorToken.kind === 64 /* EqualsToken */  && convertAssignment(sourceFile, checker, expression, changes, exports2, useSitesToUnqualify);
                            }
                    }
                }
            // falls through
            default:
                return false;
        }
    }
    function convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference) {
        const { declarationList } = statement;
        let foundImport = false;
        const converted = map(declarationList.declarations, (decl)=>{
            const { name, initializer } = decl;
            if (initializer) {
                if (isExportsOrModuleExportsOrAlias(sourceFile, initializer)) {
                    foundImport = true;
                    return convertedImports([]);
                } else if (isRequireCall(initializer, /*requireStringLiteralLikeArgument*/ true)) {
                    foundImport = true;
                    return convertSingleImport(name, initializer.arguments[0], checker, identifiers, target, quotePreference);
                } else if (isPropertyAccessExpression(initializer) && isRequireCall(initializer.expression, /*requireStringLiteralLikeArgument*/ true)) {
                    foundImport = true;
                    return convertPropertyAccessImport(name, initializer.name.text, initializer.expression.arguments[0], identifiers, quotePreference);
                }
            }
            return convertedImports([
                factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    decl
                ], declarationList.flags))
            ]);
        });
        if (foundImport) {
            changes.replaceNodeWithNodes(sourceFile, statement, flatMap(converted, (c)=>c.newImports));
            let combinedUseSites;
            forEach(converted, (c)=>{
                if (c.useSitesToUnqualify) copyEntries(c.useSitesToUnqualify, combinedUseSites !== null && combinedUseSites !== void 0 ? combinedUseSites : combinedUseSites = /* @__PURE__ */ new Map());
            });
            return combinedUseSites;
        }
    }
    function convertPropertyAccessImport(name, propertyName, moduleSpecifier, identifiers, quotePreference) {
        switch(name.kind){
            case 207 /* ObjectBindingPattern */ :
            case 208 /* ArrayBindingPattern */ :
                {
                    const tmp = makeUniqueName(propertyName, identifiers);
                    return convertedImports([
                        makeSingleImport(tmp, propertyName, moduleSpecifier, quotePreference),
                        makeConst(/*modifiers*/ void 0, name, factory.createIdentifier(tmp))
                    ]);
                }
            case 80 /* Identifier */ :
                return convertedImports([
                    makeSingleImport(name.text, propertyName, moduleSpecifier, quotePreference)
                ]);
            default:
                return Debug.assertNever(name, `Convert to ES module got invalid syntax form ${name.kind}`);
        }
    }
    function convertAssignment(sourceFile, checker, assignment, changes, exports2, useSitesToUnqualify) {
        const { left, right } = assignment;
        if (!isPropertyAccessExpression(left)) return false;
        if (isExportsOrModuleExportsOrAlias(sourceFile, left)) {
            if (isExportsOrModuleExportsOrAlias(sourceFile, right)) changes.delete(sourceFile, assignment.parent);
            else {
                const replacement = isObjectLiteralExpression(right) ? tryChangeModuleExportsObject(right, useSitesToUnqualify) : isRequireCall(right, /*requireStringLiteralLikeArgument*/ true) ? convertReExportAll(right.arguments[0], checker) : void 0;
                if (replacement) {
                    changes.replaceNodeWithNodes(sourceFile, assignment.parent, replacement[0]);
                    return replacement[1];
                } else {
                    changes.replaceRangeWithText(sourceFile, createRange(left.getStart(sourceFile), right.pos), "export default");
                    return true;
                }
            }
        } else if (isExportsOrModuleExportsOrAlias(sourceFile, left.expression)) convertNamedExport(sourceFile, assignment, changes, exports2);
        return false;
    }
    function tryChangeModuleExportsObject(object, useSitesToUnqualify) {
        const statements = mapAllOrFail(object.properties, (prop)=>{
            switch(prop.kind){
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                // TODO: Maybe we should handle this? See fourslash test `refactorConvertToEs6Module_export_object_shorthand.ts`.
                // falls through
                case 305 /* ShorthandPropertyAssignment */ :
                case 306 /* SpreadAssignment */ :
                    return void 0;
                case 304 /* PropertyAssignment */ :
                    return !isIdentifier(prop.name) ? void 0 : convertExportsDotXEquals_replaceNode(prop.name.text, prop.initializer, useSitesToUnqualify);
                case 175 /* MethodDeclaration */ :
                    return !isIdentifier(prop.name) ? void 0 : functionExpressionToDeclaration(prop.name.text, [
                        factory.createToken(95 /* ExportKeyword */ )
                    ], prop, useSitesToUnqualify);
                default:
                    Debug.assertNever(prop, `Convert to ES6 got invalid prop kind ${prop.kind}`);
            }
        });
        return statements && [
            statements,
            false
        ];
    }
    function convertNamedExport(sourceFile, assignment, changes, exports2) {
        const { text } = assignment.left.name;
        const rename = exports2.get(text);
        if (rename !== void 0) {
            const newNodes = [
                makeConst(/*modifiers*/ void 0, rename, assignment.right),
                makeExportDeclaration([
                    factory.createExportSpecifier(/*isTypeOnly*/ false, rename, text)
                ])
            ];
            changes.replaceNodeWithNodes(sourceFile, assignment.parent, newNodes);
        } else convertExportsPropertyAssignment(assignment, sourceFile, changes);
    }
    function convertReExportAll(reExported, checker) {
        const moduleSpecifier = reExported.text;
        const moduleSymbol = checker.getSymbolAtLocation(reExported);
        const exports2 = moduleSymbol ? moduleSymbol.exports : emptyMap;
        return exports2.has("export=" /* ExportEquals */ ) ? [
            [
                reExportDefault(moduleSpecifier)
            ],
            true
        ] : !exports2.has("default" /* Default */ ) ? [
            [
                reExportStar(moduleSpecifier)
            ],
            false
        ] : // If there's some non-default export, must include both `export *` and `export default`.
        exports2.size > 1 ? [
            [
                reExportStar(moduleSpecifier),
                reExportDefault(moduleSpecifier)
            ],
            true
        ] : [
            [
                reExportDefault(moduleSpecifier)
            ],
            true
        ];
    }
    function reExportStar(moduleSpecifier) {
        return makeExportDeclaration(/*exportSpecifiers*/ void 0, moduleSpecifier);
    }
    function reExportDefault(moduleSpecifier) {
        return makeExportDeclaration([
            factory.createExportSpecifier(/*isTypeOnly*/ false, /*propertyName*/ void 0, "default")
        ], moduleSpecifier);
    }
    function convertExportsPropertyAssignment({ left, right, parent: parent2 }, sourceFile, changes) {
        const name = left.name.text;
        if ((isFunctionExpression(right) || isArrowFunction(right) || isClassExpression(right)) && (!right.name || right.name.text === name)) {
            changes.replaceRange(sourceFile, {
                pos: left.getStart(sourceFile),
                end: right.getStart(sourceFile)
            }, factory.createToken(95 /* ExportKeyword */ ), {
                suffix: " "
            });
            if (!right.name) changes.insertName(sourceFile, right, name);
            const semi = findChildOfKind(parent2, 27 /* SemicolonToken */ , sourceFile);
            if (semi) changes.delete(sourceFile, semi);
        } else changes.replaceNodeRangeWithNodes(sourceFile, left.expression, findChildOfKind(left, 25 /* DotToken */ , sourceFile), [
            factory.createToken(95 /* ExportKeyword */ ),
            factory.createToken(87 /* ConstKeyword */ )
        ], {
            joiner: " ",
            suffix: " "
        });
    }
    function convertExportsDotXEquals_replaceNode(name, exported, useSitesToUnqualify) {
        const modifiers = [
            factory.createToken(95 /* ExportKeyword */ )
        ];
        switch(exported.kind){
            case 219 /* FunctionExpression */ :
                {
                    const { name: expressionName } = exported;
                    if (expressionName && expressionName.text !== name) return exportConst();
                }
            // falls through
            case 220 /* ArrowFunction */ :
                return functionExpressionToDeclaration(name, modifiers, exported, useSitesToUnqualify);
            case 232 /* ClassExpression */ :
                return classExpressionToDeclaration(name, modifiers, exported, useSitesToUnqualify);
            default:
                return exportConst();
        }
        function exportConst() {
            return makeConst(modifiers, factory.createIdentifier(name), replaceImportUseSites(exported, useSitesToUnqualify));
        }
    }
    function replaceImportUseSites(nodeOrNodes, useSitesToUnqualify) {
        if (!useSitesToUnqualify || !some(arrayFrom(useSitesToUnqualify.keys()), (original)=>rangeContainsRange(nodeOrNodes, original))) return nodeOrNodes;
        return isArray(nodeOrNodes) ? getSynthesizedDeepClonesWithReplacements(nodeOrNodes, /*includeTrivia*/ true, replaceNode) : getSynthesizedDeepCloneWithReplacements(nodeOrNodes, /*includeTrivia*/ true, replaceNode);
        function replaceNode(original) {
            if (original.kind === 212 /* PropertyAccessExpression */ ) {
                const replacement = useSitesToUnqualify.get(original);
                useSitesToUnqualify.delete(original);
                return replacement;
            }
        }
    }
    function convertSingleImport(name, moduleSpecifier, checker, identifiers, target, quotePreference) {
        switch(name.kind){
            case 207 /* ObjectBindingPattern */ :
                {
                    const importSpecifiers = mapAllOrFail(name.elements, (e)=>e.dotDotDotToken || e.initializer || e.propertyName && !isIdentifier(e.propertyName) || !isIdentifier(e.name) ? void 0 : makeImportSpecifier2(e.propertyName && e.propertyName.text, e.name.text));
                    if (importSpecifiers) return convertedImports([
                        makeImport(/*defaultImport*/ void 0, importSpecifiers, moduleSpecifier, quotePreference)
                    ]);
                }
            // falls through -- object destructuring has an interesting pattern and must be a variable declaration
            case 208 /* ArrayBindingPattern */ :
                {
                    const tmp = makeUniqueName(moduleSpecifierToValidIdentifier(moduleSpecifier.text, target), identifiers);
                    return convertedImports([
                        makeImport(factory.createIdentifier(tmp), /*namedImports*/ void 0, moduleSpecifier, quotePreference),
                        makeConst(/*modifiers*/ void 0, getSynthesizedDeepClone(name), factory.createIdentifier(tmp))
                    ]);
                }
            case 80 /* Identifier */ :
                return convertSingleIdentifierImport(name, moduleSpecifier, checker, identifiers, quotePreference);
            default:
                return Debug.assertNever(name, `Convert to ES module got invalid name kind ${name.kind}`);
        }
    }
    function convertSingleIdentifierImport(name, moduleSpecifier, checker, identifiers, quotePreference) {
        const nameSymbol = checker.getSymbolAtLocation(name);
        const namedBindingsNames = /* @__PURE__ */ new Map();
        let needDefaultImport = false;
        let useSitesToUnqualify;
        for (const use of identifiers.original.get(name.text)){
            if (checker.getSymbolAtLocation(use) !== nameSymbol || use === name) continue;
            const { parent: parent2 } = use;
            if (isPropertyAccessExpression(parent2)) {
                const { name: { text: propertyName } } = parent2;
                if (propertyName === "default") {
                    needDefaultImport = true;
                    const importDefaultName = use.getText();
                    (useSitesToUnqualify !== null && useSitesToUnqualify !== void 0 ? useSitesToUnqualify : useSitesToUnqualify = /* @__PURE__ */ new Map()).set(parent2, factory.createIdentifier(importDefaultName));
                } else {
                    Debug.assert(parent2.expression === use, "Didn't expect expression === use");
                    let idName = namedBindingsNames.get(propertyName);
                    if (idName === void 0) {
                        idName = makeUniqueName(propertyName, identifiers);
                        namedBindingsNames.set(propertyName, idName);
                    }
                    (useSitesToUnqualify !== null && useSitesToUnqualify !== void 0 ? useSitesToUnqualify : useSitesToUnqualify = /* @__PURE__ */ new Map()).set(parent2, factory.createIdentifier(idName));
                }
            } else needDefaultImport = true;
        }
        const namedBindings = namedBindingsNames.size === 0 ? void 0 : arrayFrom(mapIterator(namedBindingsNames.entries(), ([propertyName, idName])=>factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName === idName ? void 0 : factory.createIdentifier(propertyName), factory.createIdentifier(idName))));
        if (!namedBindings) needDefaultImport = true;
        return convertedImports([
            makeImport(needDefaultImport ? getSynthesizedDeepClone(name) : void 0, namedBindings, moduleSpecifier, quotePreference)
        ], useSitesToUnqualify);
    }
    function makeUniqueName(name, identifiers) {
        while(identifiers.original.has(name) || identifiers.additional.has(name))name = `_${name}`;
        identifiers.additional.add(name);
        return name;
    }
    function collectFreeIdentifiers(file) {
        const map2 = createMultiMap();
        forEachFreeIdentifier(file, (id)=>map2.add(id.text, id));
        return map2;
    }
    function forEachFreeIdentifier(node, cb) {
        if (isIdentifier(node) && isFreeIdentifier(node)) cb(node);
        node.forEachChild((child)=>forEachFreeIdentifier(child, cb));
    }
    function isFreeIdentifier(node) {
        const { parent: parent2 } = node;
        switch(parent2.kind){
            case 212 /* PropertyAccessExpression */ :
                return parent2.name !== node;
            case 209 /* BindingElement */ :
                return parent2.propertyName !== node;
            case 277 /* ImportSpecifier */ :
                return parent2.propertyName !== node;
            default:
                return true;
        }
    }
    function functionExpressionToDeclaration(name, additionalModifiers, fn, useSitesToUnqualify) {
        return factory.createFunctionDeclaration(concatenate(additionalModifiers, getSynthesizedDeepClones(fn.modifiers)), getSynthesizedDeepClone(fn.asteriskToken), name, getSynthesizedDeepClones(fn.typeParameters), getSynthesizedDeepClones(fn.parameters), getSynthesizedDeepClone(fn.type), factory.converters.convertToFunctionBlock(replaceImportUseSites(fn.body, useSitesToUnqualify)));
    }
    function classExpressionToDeclaration(name, additionalModifiers, cls, useSitesToUnqualify) {
        return factory.createClassDeclaration(concatenate(additionalModifiers, getSynthesizedDeepClones(cls.modifiers)), name, getSynthesizedDeepClones(cls.typeParameters), getSynthesizedDeepClones(cls.heritageClauses), replaceImportUseSites(cls.members, useSitesToUnqualify));
    }
    function makeSingleImport(localName, propertyName, moduleSpecifier, quotePreference) {
        return propertyName === "default" ? makeImport(factory.createIdentifier(localName), /*namedImports*/ void 0, moduleSpecifier, quotePreference) : makeImport(/*defaultImport*/ void 0, [
            makeImportSpecifier2(propertyName, localName)
        ], moduleSpecifier, quotePreference);
    }
    function makeImportSpecifier2(propertyName, name) {
        return factory.createImportSpecifier(/*isTypeOnly*/ false, propertyName !== void 0 && propertyName !== name ? factory.createIdentifier(propertyName) : void 0, factory.createIdentifier(name));
    }
    function makeConst(modifiers, name, init) {
        return factory.createVariableStatement(modifiers, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, /*type*/ void 0, init)
        ], 2 /* Const */ ));
    }
    function makeExportDeclaration(exportSpecifiers, moduleSpecifier) {
        return factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, exportSpecifiers && factory.createNamedExports(exportSpecifiers), moduleSpecifier === void 0 ? void 0 : factory.createStringLiteral(moduleSpecifier));
    }
    function convertedImports(newImports, useSitesToUnqualify) {
        return {
            newImports,
            useSitesToUnqualify
        };
    }
    // src/services/codefixes/correctQualifiedNameToIndexedAccessType.ts
    var fixId12 = "correctQualifiedNameToIndexedAccessType";
    var errorCodes13 = [
        Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes13,
        getCodeActions (context) {
            const qualifiedName = getQualifiedName(context.sourceFile, context.span.start);
            if (!qualifiedName) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange10(t, context.sourceFile, qualifiedName));
            const newText = `${qualifiedName.left.text}["${qualifiedName.right.text}"]`;
            return [
                createCodeFixAction(fixId12, changes, [
                    Diagnostics.Rewrite_as_the_indexed_access_type_0,
                    newText
                ], fixId12, Diagnostics.Rewrite_all_as_indexed_access_types)
            ];
        },
        fixIds: [
            fixId12
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes13, (changes, diag2)=>{
                const q = getQualifiedName(diag2.file, diag2.start);
                if (q) doChange10(changes, diag2.file, q);
            })
    });
    function getQualifiedName(sourceFile, pos) {
        const qualifiedName = findAncestor(getTokenAtPosition(sourceFile, pos), isQualifiedName);
        Debug.assert(!!qualifiedName, "Expected position to be owned by a qualified name.");
        return isIdentifier(qualifiedName.left) ? qualifiedName : void 0;
    }
    function doChange10(changeTracker, sourceFile, qualifiedName) {
        const rightText = qualifiedName.right.text;
        const replacement = factory.createIndexedAccessTypeNode(factory.createTypeReferenceNode(qualifiedName.left, /*typeArguments*/ void 0), factory.createLiteralTypeNode(factory.createStringLiteral(rightText)));
        changeTracker.replaceNode(sourceFile, qualifiedName, replacement);
    }
    // src/services/codefixes/convertToTypeOnlyExport.ts
    var errorCodes14 = [
        Diagnostics.Re_exporting_a_type_when_0_is_enabled_requires_using_export_type.code
    ];
    var fixId13 = "convertToTypeOnlyExport";
    registerCodeFix({
        errorCodes: errorCodes14,
        getCodeActions: function getCodeActionsToConvertToTypeOnlyExport(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>fixSingleExportDeclaration(t, getExportSpecifierForDiagnosticSpan(context.span, context.sourceFile), context));
            if (changes.length) return [
                createCodeFixAction(fixId13, changes, Diagnostics.Convert_to_type_only_export, fixId13, Diagnostics.Convert_all_re_exported_types_to_type_only_exports)
            ];
        },
        fixIds: [
            fixId13
        ],
        getAllCodeActions: function getAllCodeActionsToConvertToTypeOnlyExport(context) {
            const fixedExportDeclarations = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes14, (changes, diag2)=>{
                const exportSpecifier = getExportSpecifierForDiagnosticSpan(diag2, context.sourceFile);
                if (exportSpecifier && addToSeen(fixedExportDeclarations, getNodeId(exportSpecifier.parent.parent))) fixSingleExportDeclaration(changes, exportSpecifier, context);
            });
        }
    });
    function getExportSpecifierForDiagnosticSpan(span, sourceFile) {
        return tryCast(getTokenAtPosition(sourceFile, span.start).parent, isExportSpecifier);
    }
    function fixSingleExportDeclaration(changes, exportSpecifier, context) {
        if (!exportSpecifier) return;
        const exportClause = exportSpecifier.parent;
        const exportDeclaration = exportClause.parent;
        const typeExportSpecifiers = getTypeExportSpecifiers(exportSpecifier, context);
        if (typeExportSpecifiers.length === exportClause.elements.length) changes.insertModifierBefore(context.sourceFile, 156 /* TypeKeyword */ , exportClause);
        else {
            const valueExportDeclaration = factory.updateExportDeclaration(exportDeclaration, exportDeclaration.modifiers, /*isTypeOnly*/ false, factory.updateNamedExports(exportClause, filter(exportClause.elements, (e)=>!contains(typeExportSpecifiers, e))), exportDeclaration.moduleSpecifier, /*attributes*/ void 0);
            const typeExportDeclaration = factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ true, factory.createNamedExports(typeExportSpecifiers), exportDeclaration.moduleSpecifier, /*attributes*/ void 0);
            changes.replaceNode(context.sourceFile, exportDeclaration, valueExportDeclaration, {
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude
            });
            changes.insertNodeAfter(context.sourceFile, exportDeclaration, typeExportDeclaration);
        }
    }
    function getTypeExportSpecifiers(originExportSpecifier, context) {
        const exportClause = originExportSpecifier.parent;
        if (exportClause.elements.length === 1) return exportClause.elements;
        const diagnostics = getDiagnosticsWithinSpan(createTextSpanFromNode(exportClause), context.program.getSemanticDiagnostics(context.sourceFile, context.cancellationToken));
        return filter(exportClause.elements, (element)=>{
            var _a;
            return element === originExportSpecifier || ((_a = findDiagnosticForNode(element, diagnostics)) == null ? void 0 : _a.code) === errorCodes14[0];
        });
    }
    // src/services/codefixes/convertToTypeOnlyImport.ts
    var errorCodes15 = [
        Diagnostics._0_is_a_type_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled.code,
        Diagnostics._0_resolves_to_a_type_only_declaration_and_must_be_imported_using_a_type_only_import_when_verbatimModuleSyntax_is_enabled.code
    ];
    var fixId14 = "convertToTypeOnlyImport";
    registerCodeFix({
        errorCodes: errorCodes15,
        getCodeActions: function getCodeActionsToConvertToTypeOnlyImport(context) {
            var _a;
            const declaration = getDeclaration2(context.sourceFile, context.span.start);
            if (declaration) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange11(t, context.sourceFile, declaration));
                const importDeclarationChanges = declaration.kind === 277 /* ImportSpecifier */  && isImportDeclaration(declaration.parent.parent.parent) && canConvertImportDeclarationForSpecifier(declaration, context.sourceFile, context.program) ? ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange11(t, context.sourceFile, declaration.parent.parent.parent)) : void 0;
                var _ref;
                const mainAction = createCodeFixAction(fixId14, changes, declaration.kind === 277 /* ImportSpecifier */  ? [
                    Diagnostics.Use_type_0,
                    (_ref = (_a = declaration.propertyName) == null ? void 0 : _a.text) !== null && _ref !== void 0 ? _ref : declaration.name.text
                ] : Diagnostics.Use_import_type, fixId14, Diagnostics.Fix_all_with_type_only_imports);
                if (some(importDeclarationChanges)) return [
                    createCodeFixActionWithoutFixAll(fixId14, importDeclarationChanges, Diagnostics.Use_import_type),
                    mainAction
                ];
                return [
                    mainAction
                ];
            }
            return void 0;
        },
        fixIds: [
            fixId14
        ],
        getAllCodeActions: function getAllCodeActionsToConvertToTypeOnlyImport(context) {
            const fixedImportDeclarations = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes15, (changes, diag2)=>{
                const errorDeclaration = getDeclaration2(diag2.file, diag2.start);
                if ((errorDeclaration == null ? void 0 : errorDeclaration.kind) === 273 /* ImportDeclaration */  && !fixedImportDeclarations.has(errorDeclaration)) {
                    doChange11(changes, diag2.file, errorDeclaration);
                    fixedImportDeclarations.add(errorDeclaration);
                } else if ((errorDeclaration == null ? void 0 : errorDeclaration.kind) === 277 /* ImportSpecifier */  && isImportDeclaration(errorDeclaration.parent.parent.parent) && !fixedImportDeclarations.has(errorDeclaration.parent.parent.parent) && canConvertImportDeclarationForSpecifier(errorDeclaration, diag2.file, context.program)) {
                    doChange11(changes, diag2.file, errorDeclaration.parent.parent.parent);
                    fixedImportDeclarations.add(errorDeclaration.parent.parent.parent);
                } else if ((errorDeclaration == null ? void 0 : errorDeclaration.kind) === 277 /* ImportSpecifier */ ) doChange11(changes, diag2.file, errorDeclaration);
            });
        }
    });
    function getDeclaration2(sourceFile, pos) {
        const { parent: parent2 } = getTokenAtPosition(sourceFile, pos);
        return isImportSpecifier(parent2) || isImportDeclaration(parent2) && parent2.importClause ? parent2 : void 0;
    }
    function canConvertImportDeclarationForSpecifier(specifier, sourceFile, program) {
        if (specifier.parent.parent.name) return false;
        const nonTypeOnlySpecifiers = specifier.parent.elements.filter((e)=>!e.isTypeOnly);
        if (nonTypeOnlySpecifiers.length === 1) return true;
        const checker = program.getTypeChecker();
        for (const specifier2 of nonTypeOnlySpecifiers){
            const isUsedAsValue = ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(specifier2.name, checker, sourceFile, (usage)=>{
                const symbol = checker.getSymbolAtLocation(usage);
                return !!symbol && checker.symbolIsValue(symbol) || !isValidTypeOnlyAliasUseSite(usage);
            });
            if (isUsedAsValue) return false;
        }
        return true;
    }
    function doChange11(changes, sourceFile, declaration) {
        var _a;
        if (isImportSpecifier(declaration)) changes.replaceNode(sourceFile, declaration, factory.updateImportSpecifier(declaration, /*isTypeOnly*/ true, declaration.propertyName, declaration.name));
        else {
            const importClause = declaration.importClause;
            if (importClause.name && importClause.namedBindings) changes.replaceNodeWithNodes(sourceFile, declaration, [
                factory.createImportDeclaration(getSynthesizedDeepClones(declaration.modifiers, /*includeTrivia*/ true), factory.createImportClause(156 /* TypeKeyword */ , getSynthesizedDeepClone(importClause.name, /*includeTrivia*/ true), /*namedBindings*/ void 0), getSynthesizedDeepClone(declaration.moduleSpecifier, /*includeTrivia*/ true), getSynthesizedDeepClone(declaration.attributes, /*includeTrivia*/ true)),
                factory.createImportDeclaration(getSynthesizedDeepClones(declaration.modifiers, /*includeTrivia*/ true), factory.createImportClause(156 /* TypeKeyword */ , /*name*/ void 0, getSynthesizedDeepClone(importClause.namedBindings, /*includeTrivia*/ true)), getSynthesizedDeepClone(declaration.moduleSpecifier, /*includeTrivia*/ true), getSynthesizedDeepClone(declaration.attributes, /*includeTrivia*/ true))
            ]);
            else {
                const newNamedBindings = ((_a = importClause.namedBindings) == null ? void 0 : _a.kind) === 276 /* NamedImports */  ? factory.updateNamedImports(importClause.namedBindings, sameMap(importClause.namedBindings.elements, (e)=>factory.updateImportSpecifier(e, /*isTypeOnly*/ false, e.propertyName, e.name))) : importClause.namedBindings;
                const importDeclaration = factory.updateImportDeclaration(declaration, declaration.modifiers, factory.updateImportClause(importClause, 156 /* TypeKeyword */ , importClause.name, newNamedBindings), declaration.moduleSpecifier, declaration.attributes);
                changes.replaceNode(sourceFile, declaration, importDeclaration);
            }
        }
    }
    // src/services/codefixes/convertTypedefToType.ts
    var fixId15 = "convertTypedefToType";
    var errorCodes16 = [
        Diagnostics.JSDoc_typedef_may_be_converted_to_TypeScript_type.code
    ];
    registerCodeFix({
        fixIds: [
            fixId15
        ],
        errorCodes: errorCodes16,
        getCodeActions (context) {
            const newLineCharacter = getNewLineOrDefaultFromHost(context.host, context.formatContext.options);
            const node = getTokenAtPosition(context.sourceFile, context.span.start);
            if (!node) return;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange12(t, node, context.sourceFile, newLineCharacter));
            if (changes.length > 0) return [
                createCodeFixAction(fixId15, changes, Diagnostics.Convert_typedef_to_TypeScript_type, fixId15, Diagnostics.Convert_all_typedef_to_TypeScript_types)
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes16, (changes, diag2)=>{
                const newLineCharacter = getNewLineOrDefaultFromHost(context.host, context.formatContext.options);
                const node = getTokenAtPosition(diag2.file, diag2.start);
                const fixAll = true;
                if (node) doChange12(changes, node, diag2.file, newLineCharacter, fixAll);
            })
    });
    function doChange12(changes, node, sourceFile, newLine, fixAll = false) {
        if (!isJSDocTypedefTag(node)) return;
        const declaration = createDeclaration(node);
        if (!declaration) return;
        const commentNode = node.parent;
        const { leftSibling, rightSibling } = getLeftAndRightSiblings(node);
        let pos = commentNode.getStart();
        let prefix = "";
        if (!leftSibling && commentNode.comment) {
            pos = findEndOfTextBetween(commentNode, commentNode.getStart(), node.getStart());
            prefix = `${newLine} */${newLine}`;
        }
        if (leftSibling) {
            if (fixAll && isJSDocTypedefTag(leftSibling)) {
                pos = node.getStart();
                prefix = "";
            } else {
                pos = findEndOfTextBetween(commentNode, leftSibling.getStart(), node.getStart());
                prefix = `${newLine} */${newLine}`;
            }
        }
        let end = commentNode.getEnd();
        let suffix = "";
        if (rightSibling) {
            if (fixAll && isJSDocTypedefTag(rightSibling)) {
                end = rightSibling.getStart();
                suffix = `${newLine}${newLine}`;
            } else {
                end = rightSibling.getStart();
                suffix = `${newLine}/**${newLine} * `;
            }
        }
        changes.replaceRange(sourceFile, {
            pos,
            end
        }, declaration, {
            prefix,
            suffix
        });
    }
    function getLeftAndRightSiblings(typedefNode) {
        const commentNode = typedefNode.parent;
        const maxChildIndex = commentNode.getChildCount() - 1;
        const currentNodeIndex = commentNode.getChildren().findIndex((n)=>n.getStart() === typedefNode.getStart() && n.getEnd() === typedefNode.getEnd());
        const leftSibling = currentNodeIndex > 0 ? commentNode.getChildAt(currentNodeIndex - 1) : void 0;
        const rightSibling = currentNodeIndex < maxChildIndex ? commentNode.getChildAt(currentNodeIndex + 1) : void 0;
        return {
            leftSibling,
            rightSibling
        };
    }
    function findEndOfTextBetween(jsDocComment, from, to) {
        const comment = jsDocComment.getText().substring(from - jsDocComment.getStart(), to - jsDocComment.getStart());
        for(let i = comment.length; i > 0; i--){
            if (!/[*/\s]/.test(comment.substring(i - 1, i))) return from + i;
        }
        return to;
    }
    function createDeclaration(tag) {
        var _a;
        const { typeExpression } = tag;
        if (!typeExpression) return;
        const typeName = (_a = tag.name) == null ? void 0 : _a.getText();
        if (!typeName) return;
        if (typeExpression.kind === 323 /* JSDocTypeLiteral */ ) return createInterfaceForTypeLiteral(typeName, typeExpression);
        if (typeExpression.kind === 310 /* JSDocTypeExpression */ ) return createTypeAliasForTypeExpression(typeName, typeExpression);
    }
    function createInterfaceForTypeLiteral(typeName, typeLiteral) {
        const propertySignatures = createSignatureFromTypeLiteral(typeLiteral);
        if (!some(propertySignatures)) return;
        return factory.createInterfaceDeclaration(/*modifiers*/ void 0, typeName, /*typeParameters*/ void 0, /*heritageClauses*/ void 0, propertySignatures);
    }
    function createTypeAliasForTypeExpression(typeName, typeExpression) {
        const typeReference = getSynthesizedDeepClone(typeExpression.type);
        if (!typeReference) return;
        return factory.createTypeAliasDeclaration(/*modifiers*/ void 0, factory.createIdentifier(typeName), /*typeParameters*/ void 0, typeReference);
    }
    function createSignatureFromTypeLiteral(typeLiteral) {
        const propertyTags = typeLiteral.jsDocPropertyTags;
        if (!some(propertyTags)) return;
        const getSignature = (tag)=>{
            var _a;
            const name = getPropertyName(tag);
            const type = (_a = tag.typeExpression) == null ? void 0 : _a.type;
            const isOptional = tag.isBracketed;
            let typeReference;
            if (type && isJSDocTypeLiteral(type)) {
                const signatures = createSignatureFromTypeLiteral(type);
                typeReference = factory.createTypeLiteralNode(signatures);
            } else if (type) typeReference = getSynthesizedDeepClone(type);
            if (typeReference && name) {
                const questionToken = isOptional ? factory.createToken(58 /* QuestionToken */ ) : void 0;
                return factory.createPropertySignature(/*modifiers*/ void 0, name, questionToken, typeReference);
            }
        };
        return mapDefined(propertyTags, getSignature);
    }
    function getPropertyName(tag) {
        return tag.name.kind === 80 /* Identifier */  ? tag.name.text : tag.name.right.text;
    }
    function getJSDocTypedefNodes(node) {
        if (hasJSDocNodes(node)) return flatMap(node.jsDoc, (doc)=>{
            var _a;
            return (_a = doc.tags) == null ? void 0 : _a.filter((tag)=>isJSDocTypedefTag(tag));
        });
        return [];
    }
    // src/services/codefixes/convertLiteralTypeToMappedType.ts
    var fixId16 = "convertLiteralTypeToMappedType";
    var errorCodes17 = [
        Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here_Did_you_mean_to_use_1_in_0.code
    ];
    registerCodeFix({
        errorCodes: errorCodes17,
        getCodeActions: function getCodeActionsToConvertLiteralTypeToMappedType(context) {
            const { sourceFile, span } = context;
            const info = getInfo5(sourceFile, span.start);
            if (!info) return void 0;
            const { name, constraint } = info;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange13(t, sourceFile, info));
            return [
                createCodeFixAction(fixId16, changes, [
                    Diagnostics.Convert_0_to_1_in_0,
                    constraint,
                    name
                ], fixId16, Diagnostics.Convert_all_type_literals_to_mapped_type)
            ];
        },
        fixIds: [
            fixId16
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes17, (changes, diag2)=>{
                const info = getInfo5(diag2.file, diag2.start);
                if (info) doChange13(changes, diag2.file, info);
            })
    });
    function getInfo5(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(token)) {
            const propertySignature = cast(token.parent.parent, isPropertySignature);
            const propertyName = token.getText(sourceFile);
            return {
                container: cast(propertySignature.parent, isTypeLiteralNode),
                typeNode: propertySignature.type,
                constraint: propertyName,
                name: propertyName === "K" ? "P" : "K"
            };
        }
        return void 0;
    }
    function doChange13(changes, sourceFile, { container, typeNode, constraint, name }) {
        changes.replaceNode(sourceFile, container, factory.createMappedTypeNode(/*readonlyToken*/ void 0, factory.createTypeParameterDeclaration(/*modifiers*/ void 0, name, factory.createTypeReferenceNode(constraint)), /*nameType*/ void 0, /*questionToken*/ void 0, typeNode, /*members*/ void 0));
    }
    // src/services/codefixes/fixClassIncorrectlyImplementsInterface.ts
    var errorCodes18 = [
        Diagnostics.Class_0_incorrectly_implements_interface_1.code,
        Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass.code
    ];
    var fixId17 = "fixClassIncorrectlyImplementsInterface";
    registerCodeFix({
        errorCodes: errorCodes18,
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const classDeclaration = getClass(sourceFile, span.start);
            return mapDefined(getEffectiveImplementsTypeNodes(classDeclaration), (implementedTypeNode)=>{
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingDeclarations(context, implementedTypeNode, sourceFile, classDeclaration, t, context.preferences));
                return changes.length === 0 ? void 0 : createCodeFixAction(fixId17, changes, [
                    Diagnostics.Implement_interface_0,
                    implementedTypeNode.getText(sourceFile)
                ], fixId17, Diagnostics.Implement_all_unimplemented_interfaces);
            });
        },
        fixIds: [
            fixId17
        ],
        getAllCodeActions (context) {
            const seenClassDeclarations = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes18, (changes, diag2)=>{
                const classDeclaration = getClass(diag2.file, diag2.start);
                if (addToSeen(seenClassDeclarations, getNodeId(classDeclaration))) for (const implementedTypeNode of getEffectiveImplementsTypeNodes(classDeclaration))addMissingDeclarations(context, implementedTypeNode, diag2.file, classDeclaration, changes, context.preferences);
            });
        }
    });
    function getClass(sourceFile, pos) {
        return Debug.checkDefined(getContainingClass(getTokenAtPosition(sourceFile, pos)), "There should be a containing class");
    }
    function symbolPointsToNonPrivateMember(symbol) {
        return !symbol.valueDeclaration || !(getEffectiveModifierFlags(symbol.valueDeclaration) & 2 /* Private */ );
    }
    function addMissingDeclarations(context, implementedTypeNode, sourceFile, classDeclaration, changeTracker, preferences) {
        const checker = context.program.getTypeChecker();
        const maybeHeritageClauseSymbol = getHeritageClauseSymbolTable(classDeclaration, checker);
        const implementedType = checker.getTypeAtLocation(implementedTypeNode);
        const implementedTypeSymbols = checker.getPropertiesOfType(implementedType);
        const nonPrivateAndNotExistedInHeritageClauseMembers = implementedTypeSymbols.filter(and(symbolPointsToNonPrivateMember, (symbol)=>!maybeHeritageClauseSymbol.has(symbol.escapedName)));
        const classType = checker.getTypeAtLocation(classDeclaration);
        const constructor = find(classDeclaration.members, (m)=>isConstructorDeclaration(m));
        if (!classType.getNumberIndexType()) createMissingIndexSignatureDeclaration(implementedType, 1 /* Number */ );
        if (!classType.getStringIndexType()) createMissingIndexSignatureDeclaration(implementedType, 0 /* String */ );
        const importAdder = createImportAdder(sourceFile, context.program, preferences, context.host);
        createMissingMemberNodes(classDeclaration, nonPrivateAndNotExistedInHeritageClauseMembers, sourceFile, context, preferences, importAdder, (member)=>insertInterfaceMemberNode(sourceFile, classDeclaration, member));
        importAdder.writeFixes(changeTracker);
        function createMissingIndexSignatureDeclaration(type, kind) {
            const indexInfoOfKind = checker.getIndexInfoOfType(type, kind);
            if (indexInfoOfKind) insertInterfaceMemberNode(sourceFile, classDeclaration, checker.indexInfoToIndexSignatureDeclaration(indexInfoOfKind, classDeclaration, /*flags*/ void 0, /*internalFlags*/ void 0, getNoopSymbolTrackerWithResolver(context)));
        }
        function insertInterfaceMemberNode(sourceFile2, cls, newElement) {
            if (constructor) changeTracker.insertNodeAfter(sourceFile2, constructor, newElement);
            else changeTracker.insertMemberAtStart(sourceFile2, cls, newElement);
        }
    }
    function getHeritageClauseSymbolTable(classDeclaration, checker) {
        const heritageClauseNode = getEffectiveBaseTypeNode(classDeclaration);
        if (!heritageClauseNode) return createSymbolTable();
        const heritageClauseType = checker.getTypeAtLocation(heritageClauseNode);
        const heritageClauseTypeSymbols = checker.getPropertiesOfType(heritageClauseType);
        return createSymbolTable(heritageClauseTypeSymbols.filter(symbolPointsToNonPrivateMember));
    }
    // src/services/codefixes/importFixes.ts
    var importFixName = "import";
    var importFixId = "fixMissingImport";
    var errorCodes19 = [
        Diagnostics.Cannot_find_name_0.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code,
        Diagnostics.Cannot_find_namespace_0.code,
        Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code,
        Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here.code,
        Diagnostics.No_value_exists_in_scope_for_the_shorthand_property_0_Either_declare_one_or_provide_an_initializer.code,
        Diagnostics._0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_1_or_later.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_change_your_target_library_Try_changing_the_lib_compiler_option_to_include_dom.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha_and_then_add_jest_or_mocha_to_the_types_field_in_your_tsconfig.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_jQuery_Try_npm_i_save_dev_types_Slashjquery_and_then_add_jquery_to_the_types_field_in_your_tsconfig.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_a_test_runner_Try_npm_i_save_dev_types_Slashjest_or_npm_i_save_dev_types_Slashmocha.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode.code,
        Diagnostics.Cannot_find_name_0_Do_you_need_to_install_type_definitions_for_node_Try_npm_i_save_dev_types_Slashnode_and_then_add_node_to_the_types_field_in_your_tsconfig.code,
        Diagnostics.Cannot_find_namespace_0_Did_you_mean_1.code,
        Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements.code,
        Diagnostics.This_JSX_tag_requires_0_to_be_in_scope_but_it_could_not_be_found.code
    ];
    registerCodeFix({
        errorCodes: errorCodes19,
        getCodeActions (context) {
            const { errorCode, preferences, sourceFile, span, program } = context;
            const info = getFixInfos(context, errorCode, span.start, /*useAutoImportProvider*/ true);
            if (!info) return void 0;
            return info.map(({ fix, symbolName: symbolName2, errorIdentifierText })=>codeActionForFix(context, sourceFile, symbolName2, fix, /*includeSymbolNameInDescription*/ symbolName2 !== errorIdentifierText, program, preferences));
        },
        fixIds: [
            importFixId
        ],
        getAllCodeActions: (context)=>{
            const { sourceFile, program, preferences, host, cancellationToken } = context;
            const importAdder = createImportAdderWorker(sourceFile, program, /*useAutoImportProvider*/ true, preferences, host, cancellationToken);
            eachDiagnostic(context, errorCodes19, (diag2)=>importAdder.addImportFromDiagnostic(diag2, context));
            return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, importAdder.writeFixes));
        }
    });
    function createImportAdder(sourceFile, program, preferences, host, cancellationToken) {
        return createImportAdderWorker(sourceFile, program, /*useAutoImportProvider*/ false, preferences, host, cancellationToken);
    }
    function createImportAdderWorker(sourceFile, program, useAutoImportProvider, preferences, host, cancellationToken) {
        const compilerOptions = program.getCompilerOptions();
        const addToNamespace = [];
        const importType = [];
        const addToExisting = /* @__PURE__ */ new Map();
        const removeExisting = /* @__PURE__ */ new Set();
        const verbatimImports = /* @__PURE__ */ new Set();
        const newImports = /* @__PURE__ */ new Map();
        return {
            addImportFromDiagnostic,
            addImportFromExportedSymbol,
            addImportForModuleSymbol,
            writeFixes,
            hasFixes,
            addImportForUnresolvedIdentifier,
            addImportForNonExistentExport,
            removeExistingImport,
            addVerbatimImport
        };
        function addVerbatimImport(declaration) {
            verbatimImports.add(declaration);
        }
        function addImportForUnresolvedIdentifier(context, symbolToken, useAutoImportProvider2) {
            const info = getFixInfosWithoutDiagnostic(context, symbolToken, useAutoImportProvider2);
            if (!info || !info.length) return;
            addImport(first(info));
        }
        function addImportFromDiagnostic(diagnostic, context) {
            const info = getFixInfos(context, diagnostic.code, diagnostic.start, useAutoImportProvider);
            if (!info || !info.length) return;
            addImport(first(info));
        }
        function addImportFromExportedSymbol(exportedSymbol, isValidTypeOnlyUseSite, referenceImport) {
            var _a, _b;
            const moduleSymbol = Debug.checkDefined(exportedSymbol.parent, "Expected exported symbol to have module symbol as parent");
            const symbolName2 = getNameForExportedSymbol(exportedSymbol, getEmitScriptTarget(compilerOptions));
            const checker = program.getTypeChecker();
            const symbol = checker.getMergedSymbol(skipAlias(exportedSymbol, checker));
            const exportInfo = getAllExportInfoForSymbol(sourceFile, symbol, symbolName2, moduleSymbol, /*preferCapitalized*/ false, program, host, preferences, cancellationToken);
            if (!exportInfo) {
                Debug.assert((_a = preferences.autoImportFileExcludePatterns) == null ? void 0 : _a.length);
                return;
            }
            const useRequire = shouldUseRequire(sourceFile, program);
            let fix = getImportFixForSymbol(sourceFile, exportInfo, program, /*position*/ void 0, !!isValidTypeOnlyUseSite, useRequire, host, preferences);
            if (fix) {
                var _ref;
                const localName = (_ref = (_b = tryCast(referenceImport == null ? void 0 : referenceImport.name, isIdentifier)) == null ? void 0 : _b.text) !== null && _ref !== void 0 ? _ref : symbolName2;
                let addAsTypeOnly;
                let propertyName;
                if (referenceImport && isTypeOnlyImportDeclaration(referenceImport) && (fix.kind === 3 /* AddNew */  || fix.kind === 2 /* AddToExisting */ ) && fix.addAsTypeOnly === 1 /* Allowed */ ) addAsTypeOnly = 2 /* Required */ ;
                if (exportedSymbol.name !== localName) propertyName = exportedSymbol.name;
                fix = (0, _objectSpread._)({}, fix, addAsTypeOnly === void 0 ? {} : {
                    addAsTypeOnly
                }, propertyName === void 0 ? {} : {
                    propertyName
                });
                addImport({
                    fix,
                    symbolName: localName !== null && localName !== void 0 ? localName : symbolName2,
                    errorIdentifierText: void 0
                });
            }
        }
        function addImportForModuleSymbol(symbolAlias, isValidTypeOnlyUseSite, referenceImport) {
            var _a, _b, _c;
            const checker = program.getTypeChecker();
            const moduleSymbol = checker.getAliasedSymbol(symbolAlias);
            Debug.assert(moduleSymbol.flags & 1536 /* Module */ , "Expected symbol to be a module");
            const moduleSpecifierResolutionHost = createModuleSpecifierResolutionHost(program, host);
            const moduleSpecifierResult = ts_moduleSpecifiers_exports.getModuleSpecifiersWithCacheInfo(moduleSymbol, checker, compilerOptions, sourceFile, moduleSpecifierResolutionHost, preferences, /*options*/ void 0, /*forAutoImport*/ true);
            const useRequire = shouldUseRequire(sourceFile, program);
            let addAsTypeOnly = getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ true, /*symbol*/ void 0, symbolAlias.flags, program.getTypeChecker(), compilerOptions);
            addAsTypeOnly = addAsTypeOnly === 1 /* Allowed */  && isTypeOnlyImportDeclaration(referenceImport) ? 2 /* Required */  : 1 /* Allowed */ ;
            const importKind = isImportDeclaration(referenceImport) ? isDefaultImport(referenceImport) ? 1 /* Default */  : 2 /* Namespace */  : isImportSpecifier(referenceImport) ? 0 /* Named */  : isImportClause(referenceImport) && !!referenceImport.name ? 1 /* Default */  : 2 /* Namespace */ ;
            const exportInfo = [
                {
                    symbol: symbolAlias,
                    moduleSymbol,
                    moduleFileName: (_c = (_b = (_a = moduleSymbol.declarations) == null ? void 0 : _a[0]) == null ? void 0 : _b.getSourceFile()) == null ? void 0 : _c.fileName,
                    exportKind: 4 /* Module */ ,
                    targetFlags: symbolAlias.flags,
                    isFromPackageJson: false
                }
            ];
            const existingFix = getImportFixForSymbol(sourceFile, exportInfo, program, /*position*/ void 0, !!isValidTypeOnlyUseSite, useRequire, host, preferences);
            let fix;
            if (existingFix && importKind !== 2 /* Namespace */  && existingFix.kind !== 0 /* UseNamespace */  && existingFix.kind !== 1 /* JsdocTypeImport */ ) fix = (0, _objectSpreadProps._)((0, _objectSpread._)({}, existingFix), {
                addAsTypeOnly,
                importKind
            });
            else fix = {
                kind: 3 /* AddNew */ ,
                moduleSpecifierKind: existingFix !== void 0 ? existingFix.moduleSpecifierKind : moduleSpecifierResult.kind,
                moduleSpecifier: existingFix !== void 0 ? existingFix.moduleSpecifier : first(moduleSpecifierResult.moduleSpecifiers),
                importKind,
                addAsTypeOnly,
                useRequire
            };
            addImport({
                fix,
                symbolName: symbolAlias.name,
                errorIdentifierText: void 0
            });
        }
        function addImportForNonExistentExport(exportName, exportingFileName, exportKind, exportedMeanings, isImportUsageValidAsTypeOnly) {
            const exportingSourceFile = program.getSourceFile(exportingFileName);
            const useRequire = shouldUseRequire(sourceFile, program);
            if (exportingSourceFile && exportingSourceFile.symbol) {
                const { fixes } = getImportFixes([
                    {
                        exportKind,
                        isFromPackageJson: false,
                        moduleFileName: exportingFileName,
                        moduleSymbol: exportingSourceFile.symbol,
                        targetFlags: exportedMeanings
                    }
                ], /*usagePosition*/ void 0, isImportUsageValidAsTypeOnly, useRequire, program, sourceFile, host, preferences);
                if (fixes.length) addImport({
                    fix: fixes[0],
                    symbolName: exportName,
                    errorIdentifierText: exportName
                });
            } else {
                const futureExportingSourceFile = createFutureSourceFile(exportingFileName, 99 /* ESNext */ , program, host);
                const moduleSpecifier = ts_moduleSpecifiers_exports.getLocalModuleSpecifierBetweenFileNames(sourceFile, exportingFileName, compilerOptions, createModuleSpecifierResolutionHost(program, host), preferences);
                const importKind = getImportKind(futureExportingSourceFile, exportKind, program);
                const addAsTypeOnly = getAddAsTypeOnly(isImportUsageValidAsTypeOnly, /*isForNewImportDeclaration*/ true, /*symbol*/ void 0, exportedMeanings, program.getTypeChecker(), compilerOptions);
                const fix = {
                    kind: 3 /* AddNew */ ,
                    moduleSpecifierKind: "relative",
                    moduleSpecifier,
                    importKind,
                    addAsTypeOnly,
                    useRequire
                };
                addImport({
                    fix,
                    symbolName: exportName,
                    errorIdentifierText: exportName
                });
            }
        }
        function removeExistingImport(declaration) {
            if (declaration.kind === 274 /* ImportClause */ ) Debug.assertIsDefined(declaration.name, "ImportClause should have a name if it's being removed");
            removeExisting.add(declaration);
        }
        function addImport(info) {
            var _a, _b, _c;
            const { fix, symbolName: symbolName2 } = info;
            switch(fix.kind){
                case 0 /* UseNamespace */ :
                    addToNamespace.push(fix);
                    break;
                case 1 /* JsdocTypeImport */ :
                    importType.push(fix);
                    break;
                case 2 /* AddToExisting */ :
                    {
                        const { importClauseOrBindingPattern, importKind, addAsTypeOnly, propertyName } = fix;
                        let entry = addToExisting.get(importClauseOrBindingPattern);
                        if (!entry) addToExisting.set(importClauseOrBindingPattern, entry = {
                            importClauseOrBindingPattern,
                            defaultImport: void 0,
                            namedImports: /* @__PURE__ */ new Map()
                        });
                        if (importKind === 0 /* Named */ ) {
                            const prevTypeOnly = (_a = entry == null ? void 0 : entry.namedImports.get(symbolName2)) == null ? void 0 : _a.addAsTypeOnly;
                            entry.namedImports.set(symbolName2, {
                                addAsTypeOnly: reduceAddAsTypeOnlyValues(prevTypeOnly, addAsTypeOnly),
                                propertyName
                            });
                        } else {
                            Debug.assert(entry.defaultImport === void 0 || entry.defaultImport.name === symbolName2, "(Add to Existing) Default import should be missing or match symbolName");
                            entry.defaultImport = {
                                name: symbolName2,
                                addAsTypeOnly: reduceAddAsTypeOnlyValues((_b = entry.defaultImport) == null ? void 0 : _b.addAsTypeOnly, addAsTypeOnly)
                            };
                        }
                        break;
                    }
                case 3 /* AddNew */ :
                    {
                        const { moduleSpecifier, importKind, useRequire, addAsTypeOnly, propertyName } = fix;
                        const entry = getNewImportEntry(moduleSpecifier, importKind, useRequire, addAsTypeOnly);
                        Debug.assert(entry.useRequire === useRequire, "(Add new) Tried to add an `import` and a `require` for the same module");
                        switch(importKind){
                            case 1 /* Default */ :
                                Debug.assert(entry.defaultImport === void 0 || entry.defaultImport.name === symbolName2, "(Add new) Default import should be missing or match symbolName");
                                entry.defaultImport = {
                                    name: symbolName2,
                                    addAsTypeOnly: reduceAddAsTypeOnlyValues((_c = entry.defaultImport) == null ? void 0 : _c.addAsTypeOnly, addAsTypeOnly)
                                };
                                break;
                            case 0 /* Named */ :
                                const prevValue = (entry.namedImports || (entry.namedImports = /* @__PURE__ */ new Map())).get(symbolName2);
                                entry.namedImports.set(symbolName2, [
                                    reduceAddAsTypeOnlyValues(prevValue, addAsTypeOnly),
                                    propertyName
                                ]);
                                break;
                            case 3 /* CommonJS */ :
                                if (compilerOptions.verbatimModuleSyntax) {
                                    const prevValue2 = (entry.namedImports || (entry.namedImports = /* @__PURE__ */ new Map())).get(symbolName2);
                                    entry.namedImports.set(symbolName2, [
                                        reduceAddAsTypeOnlyValues(prevValue2, addAsTypeOnly),
                                        propertyName
                                    ]);
                                } else {
                                    Debug.assert(entry.namespaceLikeImport === void 0 || entry.namespaceLikeImport.name === symbolName2, "Namespacelike import shoudl be missing or match symbolName");
                                    entry.namespaceLikeImport = {
                                        importKind,
                                        name: symbolName2,
                                        addAsTypeOnly
                                    };
                                }
                                break;
                            case 2 /* Namespace */ :
                                Debug.assert(entry.namespaceLikeImport === void 0 || entry.namespaceLikeImport.name === symbolName2, "Namespacelike import shoudl be missing or match symbolName");
                                entry.namespaceLikeImport = {
                                    importKind,
                                    name: symbolName2,
                                    addAsTypeOnly
                                };
                                break;
                        }
                        break;
                    }
                case 4 /* PromoteTypeOnly */ :
                    break;
                default:
                    Debug.assertNever(fix, `fix wasn't never - got kind ${fix.kind}`);
            }
            function reduceAddAsTypeOnlyValues(prevValue, newValue) {
                return Math.max(prevValue !== null && prevValue !== void 0 ? prevValue : 0, newValue);
            }
            function getNewImportEntry(moduleSpecifier, importKind, useRequire, addAsTypeOnly) {
                const typeOnlyKey = newImportsKey(moduleSpecifier, /*topLevelTypeOnly*/ true);
                const nonTypeOnlyKey = newImportsKey(moduleSpecifier, /*topLevelTypeOnly*/ false);
                const typeOnlyEntry = newImports.get(typeOnlyKey);
                const nonTypeOnlyEntry = newImports.get(nonTypeOnlyKey);
                const newEntry = {
                    defaultImport: void 0,
                    namedImports: void 0,
                    namespaceLikeImport: void 0,
                    useRequire
                };
                if (importKind === 1 /* Default */  && addAsTypeOnly === 2 /* Required */ ) {
                    if (typeOnlyEntry) return typeOnlyEntry;
                    newImports.set(typeOnlyKey, newEntry);
                    return newEntry;
                }
                if (addAsTypeOnly === 1 /* Allowed */  && (typeOnlyEntry || nonTypeOnlyEntry)) return typeOnlyEntry || nonTypeOnlyEntry;
                if (nonTypeOnlyEntry) return nonTypeOnlyEntry;
                newImports.set(nonTypeOnlyKey, newEntry);
                return newEntry;
            }
            function newImportsKey(moduleSpecifier, topLevelTypeOnly) {
                return `${topLevelTypeOnly ? 1 : 0}|${moduleSpecifier}`;
            }
        }
        function writeFixes(changeTracker, oldFileQuotePreference) {
            var _a, _b;
            let quotePreference;
            if (sourceFile.imports !== void 0 && sourceFile.imports.length === 0 && oldFileQuotePreference !== void 0) quotePreference = oldFileQuotePreference;
            else quotePreference = getQuotePreference(sourceFile, preferences);
            for (const fix of addToNamespace)addNamespaceQualifier(changeTracker, sourceFile, fix);
            for (const fix of importType)addImportType(changeTracker, sourceFile, fix, quotePreference);
            let importSpecifiersToRemoveWhileAdding;
            if (removeExisting.size) {
                Debug.assert(isFullSourceFile(sourceFile), "Cannot remove imports from a future source file");
                const importDeclarationsWithRemovals = new Set(mapDefined([
                    ...removeExisting
                ], (d)=>findAncestor(d, isImportDeclaration)));
                const variableDeclarationsWithRemovals = new Set(mapDefined([
                    ...removeExisting
                ], (d)=>findAncestor(d, isVariableDeclarationInitializedToRequire)));
                const emptyImportDeclarations = [
                    ...importDeclarationsWithRemovals
                ].filter((d)=>{
                    var _a2, _b2, _c;
                    return(// nothing added to the import declaration
                    !addToExisting.has(d.importClause) && // no default, or default is being removed
                    (!((_a2 = d.importClause) == null ? void 0 : _a2.name) || removeExisting.has(d.importClause)) && // no namespace import, or namespace import is being removed
                    (!tryCast((_b2 = d.importClause) == null ? void 0 : _b2.namedBindings, isNamespaceImport) || removeExisting.has(d.importClause.namedBindings)) && // no named imports, or all named imports are being removed
                    (!tryCast((_c = d.importClause) == null ? void 0 : _c.namedBindings, isNamedImports) || every(d.importClause.namedBindings.elements, (e)=>removeExisting.has(e))));
                });
                const emptyVariableDeclarations = [
                    ...variableDeclarationsWithRemovals
                ].filter((d)=>// no binding elements being added to the variable declaration
                    (d.name.kind !== 207 /* ObjectBindingPattern */  || !addToExisting.has(d.name)) && // no binding elements, or all binding elements are being removed
                    (d.name.kind !== 207 /* ObjectBindingPattern */  || every(d.name.elements, (e)=>removeExisting.has(e))));
                const namedBindingsToDelete = [
                    ...importDeclarationsWithRemovals
                ].filter((d)=>{
                    var _a2, _b2;
                    return(// has named bindings
                    ((_a2 = d.importClause) == null ? void 0 : _a2.namedBindings) && // is not being fully removed
                    emptyImportDeclarations.indexOf(d) === -1 && // is not gaining named imports
                    !((_b2 = addToExisting.get(d.importClause)) == null ? void 0 : _b2.namedImports) && // all named imports are being removed
                    (d.importClause.namedBindings.kind === 275 /* NamespaceImport */  || every(d.importClause.namedBindings.elements, (e)=>removeExisting.has(e))));
                });
                for (const declaration of [
                    ...emptyImportDeclarations,
                    ...emptyVariableDeclarations
                ])changeTracker.delete(sourceFile, declaration);
                for (const declaration of namedBindingsToDelete)changeTracker.replaceNode(sourceFile, declaration.importClause, factory.updateImportClause(declaration.importClause, declaration.importClause.phaseModifier, declaration.importClause.name, /*namedBindings*/ void 0));
                for (const declaration of removeExisting){
                    const importDeclaration = findAncestor(declaration, isImportDeclaration);
                    if (importDeclaration && emptyImportDeclarations.indexOf(importDeclaration) === -1 && namedBindingsToDelete.indexOf(importDeclaration) === -1) {
                        if (declaration.kind === 274 /* ImportClause */ ) changeTracker.delete(sourceFile, declaration.name);
                        else {
                            Debug.assert(declaration.kind === 277 /* ImportSpecifier */ , "NamespaceImport should have been handled earlier");
                            if ((_a = addToExisting.get(importDeclaration.importClause)) == null ? void 0 : _a.namedImports) (importSpecifiersToRemoveWhileAdding !== null && importSpecifiersToRemoveWhileAdding !== void 0 ? importSpecifiersToRemoveWhileAdding : importSpecifiersToRemoveWhileAdding = /* @__PURE__ */ new Set()).add(declaration);
                            else changeTracker.delete(sourceFile, declaration);
                        }
                    } else if (declaration.kind === 209 /* BindingElement */ ) {
                        if ((_b = addToExisting.get(declaration.parent)) == null ? void 0 : _b.namedImports) (importSpecifiersToRemoveWhileAdding !== null && importSpecifiersToRemoveWhileAdding !== void 0 ? importSpecifiersToRemoveWhileAdding : importSpecifiersToRemoveWhileAdding = /* @__PURE__ */ new Set()).add(declaration);
                        else changeTracker.delete(sourceFile, declaration);
                    } else if (declaration.kind === 272 /* ImportEqualsDeclaration */ ) changeTracker.delete(sourceFile, declaration);
                }
            }
            addToExisting.forEach(({ importClauseOrBindingPattern, defaultImport, namedImports })=>{
                doAddExistingFix(changeTracker, sourceFile, importClauseOrBindingPattern, defaultImport, arrayFrom(namedImports.entries(), ([name, { addAsTypeOnly, propertyName }])=>({
                        addAsTypeOnly,
                        propertyName,
                        name
                    })), importSpecifiersToRemoveWhileAdding, preferences);
            });
            let newDeclarations;
            newImports.forEach(({ useRequire, defaultImport, namedImports, namespaceLikeImport }, key)=>{
                const moduleSpecifier = key.slice(2);
                const getDeclarations = useRequire ? getNewRequires : getNewImports;
                const declarations = getDeclarations(moduleSpecifier, quotePreference, defaultImport, namedImports && arrayFrom(namedImports.entries(), ([name, [addAsTypeOnly, propertyName]])=>({
                        addAsTypeOnly,
                        propertyName,
                        name
                    })), namespaceLikeImport, compilerOptions, preferences);
                newDeclarations = combine(newDeclarations, declarations);
            });
            newDeclarations = combine(newDeclarations, getCombinedVerbatimImports());
            if (newDeclarations) insertImports(changeTracker, sourceFile, newDeclarations, /*blankLineBetween*/ true, preferences);
        }
        function getCombinedVerbatimImports() {
            if (!verbatimImports.size) return void 0;
            const importDeclarations = new Set(mapDefined([
                ...verbatimImports
            ], (d)=>findAncestor(d, isImportDeclaration)));
            const requireStatements = new Set(mapDefined([
                ...verbatimImports
            ], (d)=>findAncestor(d, isRequireVariableStatement)));
            return [
                ...mapDefined([
                    ...verbatimImports
                ], (d)=>d.kind === 272 /* ImportEqualsDeclaration */  ? getSynthesizedDeepClone(d, /*includeTrivia*/ true) : void 0),
                ...[
                    ...importDeclarations
                ].map((d)=>{
                    var _a;
                    if (verbatimImports.has(d)) return getSynthesizedDeepClone(d, /*includeTrivia*/ true);
                    return getSynthesizedDeepClone(factory.updateImportDeclaration(d, d.modifiers, d.importClause && factory.updateImportClause(d.importClause, d.importClause.phaseModifier, verbatimImports.has(d.importClause) ? d.importClause.name : void 0, verbatimImports.has(d.importClause.namedBindings) ? d.importClause.namedBindings : ((_a = tryCast(d.importClause.namedBindings, isNamedImports)) == null ? void 0 : _a.elements.some((e)=>verbatimImports.has(e))) ? factory.updateNamedImports(d.importClause.namedBindings, d.importClause.namedBindings.elements.filter((e)=>verbatimImports.has(e))) : void 0), d.moduleSpecifier, d.attributes), /*includeTrivia*/ true);
                }),
                ...[
                    ...requireStatements
                ].map((s)=>{
                    if (verbatimImports.has(s)) return getSynthesizedDeepClone(s, /*includeTrivia*/ true);
                    return getSynthesizedDeepClone(factory.updateVariableStatement(s, s.modifiers, factory.updateVariableDeclarationList(s.declarationList, mapDefined(s.declarationList.declarations, (d)=>{
                        if (verbatimImports.has(d)) return d;
                        return factory.updateVariableDeclaration(d, d.name.kind === 207 /* ObjectBindingPattern */  ? factory.updateObjectBindingPattern(d.name, d.name.elements.filter((e)=>verbatimImports.has(e))) : d.name, d.exclamationToken, d.type, d.initializer);
                    }))), /*includeTrivia*/ true);
                })
            ];
        }
        function hasFixes() {
            return addToNamespace.length > 0 || importType.length > 0 || addToExisting.size > 0 || newImports.size > 0 || verbatimImports.size > 0 || removeExisting.size > 0;
        }
    }
    function createImportSpecifierResolver(importingFile, program, host, preferences) {
        const packageJsonImportFilter = createPackageJsonImportFilter(importingFile, preferences, host);
        const importMap = createExistingImportMap(importingFile, program);
        return {
            getModuleSpecifierForBestExportInfo
        };
        function getModuleSpecifierForBestExportInfo(exportInfo, position, isValidTypeOnlyUseSite, fromCacheOnly) {
            const { fixes, computedWithoutCacheCount } = getImportFixes(exportInfo, position, isValidTypeOnlyUseSite, /*useRequire*/ false, program, importingFile, host, preferences, importMap, fromCacheOnly);
            const result = getBestFix(fixes, importingFile, program, packageJsonImportFilter, host, preferences);
            return result && (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
                computedWithoutCacheCount
            });
        }
    }
    function getImportCompletionAction(targetSymbol, moduleSymbol, exportMapKey, sourceFile, symbolName2, isJsxTagName, host, program, formatContext, position, preferences, cancellationToken) {
        let exportInfos;
        if (exportMapKey) {
            exportInfos = getExportInfoMap(sourceFile, host, program, preferences, cancellationToken).get(sourceFile.path, exportMapKey);
            Debug.assertIsDefined(exportInfos, "Some exportInfo should match the specified exportMapKey");
        } else {
            exportInfos = pathIsBareSpecifier(stripQuotes(moduleSymbol.name)) ? [
                getSingleExportInfoForSymbol(targetSymbol, symbolName2, moduleSymbol, program, host)
            ] : getAllExportInfoForSymbol(sourceFile, targetSymbol, symbolName2, moduleSymbol, isJsxTagName, program, host, preferences, cancellationToken);
            Debug.assertIsDefined(exportInfos, "Some exportInfo should match the specified symbol / moduleSymbol");
        }
        const useRequire = shouldUseRequire(sourceFile, program);
        const isValidTypeOnlyUseSite = isValidTypeOnlyAliasUseSite(getTokenAtPosition(sourceFile, position));
        const fix = Debug.checkDefined(getImportFixForSymbol(sourceFile, exportInfos, program, position, isValidTypeOnlyUseSite, useRequire, host, preferences));
        return {
            moduleSpecifier: fix.moduleSpecifier,
            codeAction: codeFixActionToCodeAction(codeActionForFix({
                host,
                formatContext,
                preferences
            }, sourceFile, symbolName2, fix, /*includeSymbolNameInDescription*/ false, program, preferences))
        };
    }
    function getPromoteTypeOnlyCompletionAction(sourceFile, symbolToken, program, host, formatContext, preferences) {
        const compilerOptions = program.getCompilerOptions();
        const symbolName2 = single(getSymbolNamesToImport(sourceFile, program.getTypeChecker(), symbolToken, compilerOptions));
        const fix = getTypeOnlyPromotionFix(sourceFile, symbolToken, symbolName2, program);
        const includeSymbolNameInDescription = symbolName2 !== symbolToken.text;
        return fix && codeFixActionToCodeAction(codeActionForFix({
            host,
            formatContext,
            preferences
        }, sourceFile, symbolName2, fix, includeSymbolNameInDescription, program, preferences));
    }
    function getImportFixForSymbol(sourceFile, exportInfos, program, position, isValidTypeOnlyUseSite, useRequire, host, preferences) {
        const packageJsonImportFilter = createPackageJsonImportFilter(sourceFile, preferences, host);
        return getBestFix(getImportFixes(exportInfos, position, isValidTypeOnlyUseSite, useRequire, program, sourceFile, host, preferences).fixes, sourceFile, program, packageJsonImportFilter, host, preferences);
    }
    function codeFixActionToCodeAction({ description: description3, changes, commands }) {
        return {
            description: description3,
            changes,
            commands
        };
    }
    function getAllExportInfoForSymbol(importingFile, symbol, symbolName2, moduleSymbol, preferCapitalized, program, host, preferences, cancellationToken) {
        const getChecker = createGetChecker(program, host);
        const isFileExcluded = preferences.autoImportFileExcludePatterns && getIsFileExcluded(host, preferences);
        const mergedModuleSymbol = program.getTypeChecker().getMergedSymbol(moduleSymbol);
        const moduleSourceFile = isFileExcluded && mergedModuleSymbol.declarations && getDeclarationOfKind(mergedModuleSymbol, 308 /* SourceFile */ );
        const moduleSymbolExcluded = moduleSourceFile && isFileExcluded(moduleSourceFile);
        return getExportInfoMap(importingFile, host, program, preferences, cancellationToken).search(importingFile.path, preferCapitalized, (name)=>name === symbolName2, (info)=>{
            const checker = getChecker(info[0].isFromPackageJson);
            if (checker.getMergedSymbol(skipAlias(info[0].symbol, checker)) === symbol && (moduleSymbolExcluded || info.some((i)=>checker.getMergedSymbol(i.moduleSymbol) === moduleSymbol || i.symbol.parent === moduleSymbol))) return info;
        });
    }
    function getSingleExportInfoForSymbol(symbol, symbolName2, moduleSymbol, program, host) {
        var _a, _b;
        const mainProgramInfo = getInfoWithChecker(program.getTypeChecker(), /*isFromPackageJson*/ false);
        if (mainProgramInfo) return mainProgramInfo;
        const autoImportProvider = (_b = (_a = host.getPackageJsonAutoImportProvider) == null ? void 0 : _a.call(host)) == null ? void 0 : _b.getTypeChecker();
        return Debug.checkDefined(autoImportProvider && getInfoWithChecker(autoImportProvider, /*isFromPackageJson*/ true), `Could not find symbol in specified module for code actions`);
        function getInfoWithChecker(checker, isFromPackageJson) {
            const defaultInfo = getDefaultLikeExportInfo(moduleSymbol, checker);
            if (defaultInfo && skipAlias(defaultInfo.symbol, checker) === symbol) return {
                symbol: defaultInfo.symbol,
                moduleSymbol,
                moduleFileName: void 0,
                exportKind: defaultInfo.exportKind,
                targetFlags: skipAlias(symbol, checker).flags,
                isFromPackageJson
            };
            const named = checker.tryGetMemberInModuleExportsAndProperties(symbolName2, moduleSymbol);
            if (named && skipAlias(named, checker) === symbol) return {
                symbol: named,
                moduleSymbol,
                moduleFileName: void 0,
                exportKind: 0 /* Named */ ,
                targetFlags: skipAlias(symbol, checker).flags,
                isFromPackageJson
            };
        }
    }
    function getImportFixes(exportInfos, usagePosition, isValidTypeOnlyUseSite, useRequire, program, sourceFile, host, preferences, importMap = isFullSourceFile(sourceFile) ? createExistingImportMap(sourceFile, program) : void 0, fromCacheOnly) {
        const checker = program.getTypeChecker();
        const existingImports = importMap ? flatMap(exportInfos, importMap.getImportsForExportInfo) : emptyArray;
        const useNamespace = usagePosition !== void 0 && tryUseExistingNamespaceImport(existingImports, usagePosition);
        const addToExisting = tryAddToExistingImport(existingImports, isValidTypeOnlyUseSite, checker, program.getCompilerOptions());
        if (addToExisting) return {
            computedWithoutCacheCount: 0,
            fixes: [
                ...useNamespace ? [
                    useNamespace
                ] : emptyArray,
                addToExisting
            ]
        };
        const { fixes, computedWithoutCacheCount = 0 } = getFixesForAddImport(exportInfos, existingImports, program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, host, preferences, fromCacheOnly);
        return {
            computedWithoutCacheCount,
            fixes: [
                ...useNamespace ? [
                    useNamespace
                ] : emptyArray,
                ...fixes
            ]
        };
    }
    function tryUseExistingNamespaceImport(existingImports, position) {
        return firstDefined(existingImports, ({ declaration, importKind })=>{
            var _a;
            if (importKind !== 0 /* Named */ ) return void 0;
            const namespacePrefix = getNamespaceLikeImportText(declaration);
            const moduleSpecifier = namespacePrefix && ((_a = tryGetModuleSpecifierFromDeclaration(declaration)) == null ? void 0 : _a.text);
            if (moduleSpecifier) return {
                kind: 0 /* UseNamespace */ ,
                namespacePrefix,
                usagePosition: position,
                moduleSpecifierKind: void 0,
                moduleSpecifier
            };
        });
    }
    function getNamespaceLikeImportText(declaration) {
        var _a, _b, _c;
        switch(declaration.kind){
            case 261 /* VariableDeclaration */ :
                return (_a = tryCast(declaration.name, isIdentifier)) == null ? void 0 : _a.text;
            case 272 /* ImportEqualsDeclaration */ :
                return declaration.name.text;
            case 352 /* JSDocImportTag */ :
            case 273 /* ImportDeclaration */ :
                return (_c = tryCast((_b = declaration.importClause) == null ? void 0 : _b.namedBindings, isNamespaceImport)) == null ? void 0 : _c.name.text;
            default:
                return Debug.assertNever(declaration);
        }
    }
    function getAddAsTypeOnly(isValidTypeOnlyUseSite, isForNewImportDeclaration, symbol, targetFlags, checker, compilerOptions) {
        if (!isValidTypeOnlyUseSite) return 4 /* NotAllowed */ ;
        if (symbol && compilerOptions.verbatimModuleSyntax && (!(targetFlags & 111551 /* Value */ ) || !!checker.getTypeOnlyAliasDeclaration(symbol))) return 2 /* Required */ ;
        return 1 /* Allowed */ ;
    }
    function tryAddToExistingImport(existingImports, isValidTypeOnlyUseSite, checker, compilerOptions) {
        let best;
        for (const existingImport of existingImports){
            const fix = getAddToExistingImportFix(existingImport);
            if (!fix) continue;
            const isTypeOnly = isTypeOnlyImportDeclaration(fix.importClauseOrBindingPattern);
            if (fix.addAsTypeOnly !== 4 /* NotAllowed */  && isTypeOnly || fix.addAsTypeOnly === 4 /* NotAllowed */  && !isTypeOnly) return fix;
            best !== null && best !== void 0 ? best : best = fix;
        }
        return best;
        function getAddToExistingImportFix({ declaration, importKind, symbol, targetFlags }) {
            if (importKind === 3 /* CommonJS */  || importKind === 2 /* Namespace */  || declaration.kind === 272 /* ImportEqualsDeclaration */ ) return void 0;
            if (declaration.kind === 261 /* VariableDeclaration */ ) return (importKind === 0 /* Named */  || importKind === 1 /* Default */ ) && declaration.name.kind === 207 /* ObjectBindingPattern */  ? {
                kind: 2 /* AddToExisting */ ,
                importClauseOrBindingPattern: declaration.name,
                importKind,
                moduleSpecifierKind: void 0,
                moduleSpecifier: declaration.initializer.arguments[0].text,
                addAsTypeOnly: 4 /* NotAllowed */ 
            } : void 0;
            const { importClause } = declaration;
            if (!importClause || !isStringLiteralLike(declaration.moduleSpecifier)) return void 0;
            const { name, namedBindings } = importClause;
            if (importClause.isTypeOnly && !(importKind === 0 /* Named */  && namedBindings)) return void 0;
            const addAsTypeOnly = getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ false, symbol, targetFlags, checker, compilerOptions);
            if (importKind === 1 /* Default */  && (name || // Cannot add a default import to a declaration that already has one
            addAsTypeOnly === 2 /* Required */  && namedBindings)) return void 0;
            if (importKind === 0 /* Named */  && (namedBindings == null ? void 0 : namedBindings.kind) === 275 /* NamespaceImport */ ) return void 0;
            return {
                kind: 2 /* AddToExisting */ ,
                importClauseOrBindingPattern: importClause,
                importKind,
                moduleSpecifierKind: void 0,
                moduleSpecifier: declaration.moduleSpecifier.text,
                addAsTypeOnly
            };
        }
    }
    function createExistingImportMap(importingFile, program) {
        const checker = program.getTypeChecker();
        let importMap;
        for (const moduleSpecifier of importingFile.imports){
            const i = importFromModuleSpecifier(moduleSpecifier);
            if (isVariableDeclarationInitializedToRequire(i.parent)) {
                const moduleSymbol = checker.resolveExternalModuleName(moduleSpecifier);
                if (moduleSymbol) (importMap || (importMap = createMultiMap())).add(getSymbolId(moduleSymbol), i.parent);
            } else if (i.kind === 273 /* ImportDeclaration */  || i.kind === 272 /* ImportEqualsDeclaration */  || i.kind === 352 /* JSDocImportTag */ ) {
                const moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
                if (moduleSymbol) (importMap || (importMap = createMultiMap())).add(getSymbolId(moduleSymbol), i);
            }
        }
        return {
            getImportsForExportInfo: ({ moduleSymbol, exportKind, targetFlags, symbol })=>{
                const matchingDeclarations = importMap == null ? void 0 : importMap.get(getSymbolId(moduleSymbol));
                if (!matchingDeclarations) return emptyArray;
                if (isSourceFileJS(importingFile) && !(targetFlags & 111551 /* Value */ ) && !every(matchingDeclarations, isJSDocImportTag)) return emptyArray;
                const importKind = getImportKind(importingFile, exportKind, program);
                return matchingDeclarations.map((declaration)=>({
                        declaration,
                        importKind,
                        symbol,
                        targetFlags
                    }));
            }
        };
    }
    function shouldUseRequire(sourceFile, program) {
        if (!hasJSFileExtension(sourceFile.fileName)) return false;
        if (sourceFile.commonJsModuleIndicator && !sourceFile.externalModuleIndicator) return true;
        if (sourceFile.externalModuleIndicator && !sourceFile.commonJsModuleIndicator) return false;
        const compilerOptions = program.getCompilerOptions();
        if (compilerOptions.configFile) return getEmitModuleKind(compilerOptions) < 5 /* ES2015 */ ;
        if (getImpliedNodeFormatForEmit(sourceFile, program) === 1 /* CommonJS */ ) return true;
        if (getImpliedNodeFormatForEmit(sourceFile, program) === 99 /* ESNext */ ) return false;
        for (const otherFile of program.getSourceFiles()){
            if (otherFile === sourceFile || !isSourceFileJS(otherFile) || program.isSourceFileFromExternalLibrary(otherFile)) continue;
            if (otherFile.commonJsModuleIndicator && !otherFile.externalModuleIndicator) return true;
            if (otherFile.externalModuleIndicator && !otherFile.commonJsModuleIndicator) return false;
        }
        return true;
    }
    function createGetChecker(program, host) {
        return memoizeOne((isFromPackageJson)=>isFromPackageJson ? host.getPackageJsonAutoImportProvider().getTypeChecker() : program.getTypeChecker());
    }
    function getNewImportFixes(program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, exportInfo, host, preferences, fromCacheOnly) {
        const isJs = hasJSFileExtension(sourceFile.fileName);
        const compilerOptions = program.getCompilerOptions();
        const moduleSpecifierResolutionHost = createModuleSpecifierResolutionHost(program, host);
        const getChecker = createGetChecker(program, host);
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        const rejectNodeModulesRelativePaths = moduleResolutionUsesNodeModules(moduleResolution);
        const getModuleSpecifiers2 = fromCacheOnly ? (exportInfo2)=>ts_moduleSpecifiers_exports.tryGetModuleSpecifiersFromCache(exportInfo2.moduleSymbol, sourceFile, moduleSpecifierResolutionHost, preferences) : (exportInfo2, checker)=>ts_moduleSpecifiers_exports.getModuleSpecifiersWithCacheInfo(exportInfo2.moduleSymbol, checker, compilerOptions, sourceFile, moduleSpecifierResolutionHost, preferences, /*options*/ void 0, /*forAutoImport*/ true);
        let computedWithoutCacheCount = 0;
        const fixes = flatMap(exportInfo, (exportInfo2, i)=>{
            const checker = getChecker(exportInfo2.isFromPackageJson);
            var _getModuleSpecifiers2;
            const { computedWithoutCache, moduleSpecifiers, kind: moduleSpecifierKind } = (_getModuleSpecifiers2 = getModuleSpecifiers2(exportInfo2, checker)) !== null && _getModuleSpecifiers2 !== void 0 ? _getModuleSpecifiers2 : {};
            const importedSymbolHasValueMeaning = !!(exportInfo2.targetFlags & 111551 /* Value */ );
            const addAsTypeOnly = getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ true, exportInfo2.symbol, exportInfo2.targetFlags, checker, compilerOptions);
            computedWithoutCacheCount += computedWithoutCache ? 1 : 0;
            return mapDefined(moduleSpecifiers, (moduleSpecifier)=>{
                if (rejectNodeModulesRelativePaths && pathContainsNodeModules(moduleSpecifier)) return void 0;
                if (!importedSymbolHasValueMeaning && isJs && usagePosition !== void 0) return {
                    kind: 1 /* JsdocTypeImport */ ,
                    moduleSpecifierKind,
                    moduleSpecifier,
                    usagePosition,
                    exportInfo: exportInfo2,
                    isReExport: i > 0
                };
                const importKind = getImportKind(sourceFile, exportInfo2.exportKind, program);
                let qualification;
                if (usagePosition !== void 0 && importKind === 3 /* CommonJS */  && exportInfo2.exportKind === 0 /* Named */ ) {
                    const exportEquals = checker.resolveExternalModuleSymbol(exportInfo2.moduleSymbol);
                    let namespacePrefix;
                    if (exportEquals !== exportInfo2.moduleSymbol) namespacePrefix = forEachNameOfDefaultExport(exportEquals, checker, getEmitScriptTarget(compilerOptions), identity);
                    namespacePrefix || (namespacePrefix = moduleSymbolToValidIdentifier(exportInfo2.moduleSymbol, getEmitScriptTarget(compilerOptions), /*forceCapitalize*/ false));
                    qualification = {
                        namespacePrefix,
                        usagePosition
                    };
                }
                return {
                    kind: 3 /* AddNew */ ,
                    moduleSpecifierKind,
                    moduleSpecifier,
                    importKind,
                    useRequire,
                    addAsTypeOnly,
                    exportInfo: exportInfo2,
                    isReExport: i > 0,
                    qualification
                };
            });
        });
        return {
            computedWithoutCacheCount,
            fixes
        };
    }
    function getFixesForAddImport(exportInfos, existingImports, program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, host, preferences, fromCacheOnly) {
        const existingDeclaration = firstDefined(existingImports, (info)=>newImportInfoFromExistingSpecifier(info, isValidTypeOnlyUseSite, useRequire, program.getTypeChecker(), program.getCompilerOptions()));
        return existingDeclaration ? {
            fixes: [
                existingDeclaration
            ]
        } : getNewImportFixes(program, sourceFile, usagePosition, isValidTypeOnlyUseSite, useRequire, exportInfos, host, preferences, fromCacheOnly);
    }
    function newImportInfoFromExistingSpecifier({ declaration, importKind, symbol, targetFlags }, isValidTypeOnlyUseSite, useRequire, checker, compilerOptions) {
        var _a;
        const moduleSpecifier = (_a = tryGetModuleSpecifierFromDeclaration(declaration)) == null ? void 0 : _a.text;
        if (moduleSpecifier) {
            const addAsTypeOnly = useRequire ? 4 /* NotAllowed */  : getAddAsTypeOnly(isValidTypeOnlyUseSite, /*isForNewImportDeclaration*/ true, symbol, targetFlags, checker, compilerOptions);
            return {
                kind: 3 /* AddNew */ ,
                moduleSpecifierKind: void 0,
                moduleSpecifier,
                importKind,
                addAsTypeOnly,
                useRequire
            };
        }
    }
    function getFixInfos(context, errorCode, pos, useAutoImportProvider) {
        const symbolToken = getTokenAtPosition(context.sourceFile, pos);
        let info;
        if (errorCode === Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code) info = getFixesInfoForUMDImport(context, symbolToken);
        else if (!isIdentifier(symbolToken)) return void 0;
        else if (errorCode === Diagnostics._0_cannot_be_used_as_a_value_because_it_was_imported_using_import_type.code) {
            const symbolName2 = single(getSymbolNamesToImport(context.sourceFile, context.program.getTypeChecker(), symbolToken, context.program.getCompilerOptions()));
            const fix = getTypeOnlyPromotionFix(context.sourceFile, symbolToken, symbolName2, context.program);
            return fix && [
                {
                    fix,
                    symbolName: symbolName2,
                    errorIdentifierText: symbolToken.text
                }
            ];
        } else info = getFixesInfoForNonUMDImport(context, symbolToken, useAutoImportProvider);
        const packageJsonImportFilter = createPackageJsonImportFilter(context.sourceFile, context.preferences, context.host);
        return info && sortFixInfo(info, context.sourceFile, context.program, packageJsonImportFilter, context.host, context.preferences);
    }
    function sortFixInfo(fixes, sourceFile, program, packageJsonImportFilter, host, preferences) {
        const _toPath = (fileName)=>toPath(fileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host));
        return toSorted(fixes, (a, b)=>compareBooleans(!!a.isJsxNamespaceFix, !!b.isJsxNamespaceFix) || compareValues(a.fix.kind, b.fix.kind) || compareModuleSpecifiers(a.fix, b.fix, sourceFile, program, preferences, packageJsonImportFilter.allowsImportingSpecifier, _toPath));
    }
    function getFixInfosWithoutDiagnostic(context, symbolToken, useAutoImportProvider) {
        const info = getFixesInfoForNonUMDImport(context, symbolToken, useAutoImportProvider);
        const packageJsonImportFilter = createPackageJsonImportFilter(context.sourceFile, context.preferences, context.host);
        return info && sortFixInfo(info, context.sourceFile, context.program, packageJsonImportFilter, context.host, context.preferences);
    }
    function getBestFix(fixes, sourceFile, program, packageJsonImportFilter, host, preferences) {
        if (!some(fixes)) return;
        if (fixes[0].kind === 0 /* UseNamespace */  || fixes[0].kind === 2 /* AddToExisting */ ) return fixes[0];
        return fixes.reduce((best, fix)=>// Takes true branch of conditional if `fix` is better than `best`
            compareModuleSpecifiers(fix, best, sourceFile, program, preferences, packageJsonImportFilter.allowsImportingSpecifier, (fileName)=>toPath(fileName, host.getCurrentDirectory(), hostGetCanonicalFileName(host))) === -1 /* LessThan */  ? fix : best);
    }
    function compareModuleSpecifiers(a, b, importingFile, program, preferences, allowsImportingSpecifier, toPath3) {
        if (a.kind !== 0 /* UseNamespace */  && b.kind !== 0 /* UseNamespace */ ) return compareBooleans(b.moduleSpecifierKind !== "node_modules" || allowsImportingSpecifier(b.moduleSpecifier), a.moduleSpecifierKind !== "node_modules" || allowsImportingSpecifier(a.moduleSpecifier)) || compareModuleSpecifierRelativity(a, b, preferences) || compareNodeCoreModuleSpecifiers(a.moduleSpecifier, b.moduleSpecifier, importingFile, program) || compareBooleans(isFixPossiblyReExportingImportingFile(a, importingFile.path, toPath3), isFixPossiblyReExportingImportingFile(b, importingFile.path, toPath3)) || compareNumberOfDirectorySeparators(a.moduleSpecifier, b.moduleSpecifier);
        return 0 /* EqualTo */ ;
    }
    function compareModuleSpecifierRelativity(a, b, preferences) {
        if (preferences.importModuleSpecifierPreference === "non-relative" || preferences.importModuleSpecifierPreference === "project-relative") return compareBooleans(a.moduleSpecifierKind === "relative", b.moduleSpecifierKind === "relative");
        return 0 /* EqualTo */ ;
    }
    function isFixPossiblyReExportingImportingFile(fix, importingFilePath, toPath3) {
        var _a;
        if (fix.isReExport && ((_a = fix.exportInfo) == null ? void 0 : _a.moduleFileName) && isIndexFileName(fix.exportInfo.moduleFileName)) {
            const reExportDir = toPath3(getDirectoryPath(fix.exportInfo.moduleFileName));
            return startsWith(importingFilePath, reExportDir);
        }
        return false;
    }
    function isIndexFileName(fileName) {
        return getBaseFileName(fileName, [
            ".js",
            ".jsx",
            ".d.ts",
            ".ts",
            ".tsx"
        ], /*ignoreCase*/ true) === "index";
    }
    function compareNodeCoreModuleSpecifiers(a, b, importingFile, program) {
        if (startsWith(a, "node:") && !startsWith(b, "node:")) return shouldUseUriStyleNodeCoreModules(importingFile, program) ? -1 /* LessThan */  : 1 /* GreaterThan */ ;
        if (startsWith(b, "node:") && !startsWith(a, "node:")) return shouldUseUriStyleNodeCoreModules(importingFile, program) ? 1 /* GreaterThan */  : -1 /* LessThan */ ;
        return 0 /* EqualTo */ ;
    }
    function getFixesInfoForUMDImport({ sourceFile, program, host, preferences }, token) {
        const checker = program.getTypeChecker();
        const umdSymbol = getUmdSymbol(token, checker);
        if (!umdSymbol) return void 0;
        const symbol = checker.getAliasedSymbol(umdSymbol);
        const symbolName2 = umdSymbol.name;
        const exportInfo = [
            {
                symbol: umdSymbol,
                moduleSymbol: symbol,
                moduleFileName: void 0,
                exportKind: 3 /* UMD */ ,
                targetFlags: symbol.flags,
                isFromPackageJson: false
            }
        ];
        const useRequire = shouldUseRequire(sourceFile, program);
        const fixes = getImportFixes(exportInfo, /*usagePosition*/ void 0, /*isValidTypeOnlyUseSite*/ false, useRequire, program, sourceFile, host, preferences).fixes;
        return fixes.map((fix)=>{
            var _a;
            return {
                fix,
                symbolName: symbolName2,
                errorIdentifierText: (_a = tryCast(token, isIdentifier)) == null ? void 0 : _a.text
            };
        });
    }
    function getUmdSymbol(token, checker) {
        const umdSymbol = isIdentifier(token) ? checker.getSymbolAtLocation(token) : void 0;
        if (isUMDExportSymbol(umdSymbol)) return umdSymbol;
        const { parent: parent2 } = token;
        if (isJsxOpeningLikeElement(parent2) && parent2.tagName === token || isJsxOpeningFragment(parent2)) {
            const parentSymbol = checker.resolveName(checker.getJsxNamespace(parent2), isJsxOpeningLikeElement(parent2) ? token : parent2, 111551 /* Value */ , /*excludeGlobals*/ false);
            if (isUMDExportSymbol(parentSymbol)) return parentSymbol;
        }
        return void 0;
    }
    function getImportKind(importingFile, exportKind, program, forceImportKeyword) {
        if (program.getCompilerOptions().verbatimModuleSyntax && getEmitModuleFormatOfFile(importingFile, program) === 1 /* CommonJS */ ) return 3 /* CommonJS */ ;
        switch(exportKind){
            case 0 /* Named */ :
                return 0 /* Named */ ;
            case 1 /* Default */ :
                return 1 /* Default */ ;
            case 2 /* ExportEquals */ :
                return getExportEqualsImportKind(importingFile, program.getCompilerOptions(), !!forceImportKeyword);
            case 3 /* UMD */ :
                return getUmdImportKind(importingFile, program, !!forceImportKeyword);
            case 4 /* Module */ :
                return 2 /* Namespace */ ;
            default:
                return Debug.assertNever(exportKind);
        }
    }
    function getUmdImportKind(importingFile, program, forceImportKeyword) {
        if (getAllowSyntheticDefaultImports(program.getCompilerOptions())) return 1 /* Default */ ;
        const moduleKind = getEmitModuleKind(program.getCompilerOptions());
        switch(moduleKind){
            case 2 /* AMD */ :
            case 1 /* CommonJS */ :
            case 3 /* UMD */ :
                if (hasJSFileExtension(importingFile.fileName)) return importingFile.externalModuleIndicator || forceImportKeyword ? 2 /* Namespace */  : 3 /* CommonJS */ ;
                return 3 /* CommonJS */ ;
            case 4 /* System */ :
            case 5 /* ES2015 */ :
            case 6 /* ES2020 */ :
            case 7 /* ES2022 */ :
            case 99 /* ESNext */ :
            case 0 /* None */ :
            case 200 /* Preserve */ :
                return 2 /* Namespace */ ;
            case 100 /* Node16 */ :
            case 101 /* Node18 */ :
            case 102 /* Node20 */ :
            case 199 /* NodeNext */ :
                return getImpliedNodeFormatForEmit(importingFile, program) === 99 /* ESNext */  ? 2 /* Namespace */  : 3 /* CommonJS */ ;
            default:
                return Debug.assertNever(moduleKind, `Unexpected moduleKind ${moduleKind}`);
        }
    }
    function getFixesInfoForNonUMDImport({ sourceFile, program, cancellationToken, host, preferences }, symbolToken, useAutoImportProvider) {
        const checker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        return flatMap(getSymbolNamesToImport(sourceFile, checker, symbolToken, compilerOptions), (symbolName2)=>{
            if (symbolName2 === "default" /* Default */ ) return void 0;
            const isValidTypeOnlyUseSite = isValidTypeOnlyAliasUseSite(symbolToken);
            const useRequire = shouldUseRequire(sourceFile, program);
            const exportInfo = getExportInfos(symbolName2, isJSXTagName(symbolToken), getMeaningFromLocation(symbolToken), cancellationToken, sourceFile, program, useAutoImportProvider, host, preferences);
            return arrayFrom(flatMapIterator(exportInfo.values(), (exportInfos)=>getImportFixes(exportInfos, symbolToken.getStart(sourceFile), isValidTypeOnlyUseSite, useRequire, program, sourceFile, host, preferences).fixes), (fix)=>({
                    fix,
                    symbolName: symbolName2,
                    errorIdentifierText: symbolToken.text,
                    isJsxNamespaceFix: symbolName2 !== symbolToken.text
                }));
        });
    }
    function getTypeOnlyPromotionFix(sourceFile, symbolToken, symbolName2, program) {
        const checker = program.getTypeChecker();
        const symbol = checker.resolveName(symbolName2, symbolToken, 111551 /* Value */ , /*excludeGlobals*/ true);
        if (!symbol) return void 0;
        const typeOnlyAliasDeclaration = checker.getTypeOnlyAliasDeclaration(symbol);
        if (!typeOnlyAliasDeclaration || getSourceFileOfNode(typeOnlyAliasDeclaration) !== sourceFile) return void 0;
        return {
            kind: 4 /* PromoteTypeOnly */ ,
            typeOnlyAliasDeclaration
        };
    }
    function getSymbolNamesToImport(sourceFile, checker, symbolToken, compilerOptions) {
        const parent2 = symbolToken.parent;
        if ((isJsxOpeningLikeElement(parent2) || isJsxClosingElement(parent2)) && parent2.tagName === symbolToken && jsxModeNeedsExplicitImport(compilerOptions.jsx)) {
            const jsxNamespace = checker.getJsxNamespace(sourceFile);
            if (needsJsxNamespaceFix(jsxNamespace, symbolToken, checker)) {
                const needsComponentNameFix = !isIntrinsicJsxName(symbolToken.text) && !checker.resolveName(symbolToken.text, symbolToken, 111551 /* Value */ , /*excludeGlobals*/ false);
                return needsComponentNameFix ? [
                    symbolToken.text,
                    jsxNamespace
                ] : [
                    jsxNamespace
                ];
            }
        }
        return [
            symbolToken.text
        ];
    }
    function needsJsxNamespaceFix(jsxNamespace, symbolToken, checker) {
        if (isIntrinsicJsxName(symbolToken.text)) return true;
        const namespaceSymbol = checker.resolveName(jsxNamespace, symbolToken, 111551 /* Value */ , /*excludeGlobals*/ true);
        return !namespaceSymbol || some(namespaceSymbol.declarations, isTypeOnlyImportOrExportDeclaration) && !(namespaceSymbol.flags & 111551 /* Value */ );
    }
    function getExportInfos(symbolName2, isJsxTagName, currentTokenMeaning, cancellationToken, fromFile, program, useAutoImportProvider, host, preferences) {
        var _a;
        const originalSymbolToExportInfos = createMultiMap();
        const packageJsonFilter = createPackageJsonImportFilter(fromFile, preferences, host);
        const moduleSpecifierCache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
        const getModuleSpecifierResolutionHost = memoizeOne((isFromPackageJson)=>{
            return createModuleSpecifierResolutionHost(isFromPackageJson ? host.getPackageJsonAutoImportProvider() : program, host);
        });
        function addSymbol(moduleSymbol, toFile, exportedSymbol, exportKind, program2, isFromPackageJson) {
            const moduleSpecifierResolutionHost = getModuleSpecifierResolutionHost(isFromPackageJson);
            if (isImportable(program2, fromFile, toFile, moduleSymbol, preferences, packageJsonFilter, moduleSpecifierResolutionHost, moduleSpecifierCache)) {
                const checker = program2.getTypeChecker();
                originalSymbolToExportInfos.add(getUniqueSymbolId(exportedSymbol, checker).toString(), {
                    symbol: exportedSymbol,
                    moduleSymbol,
                    moduleFileName: toFile == null ? void 0 : toFile.fileName,
                    exportKind,
                    targetFlags: skipAlias(exportedSymbol, checker).flags,
                    isFromPackageJson
                });
            }
        }
        forEachExternalModuleToImportFrom(program, host, preferences, useAutoImportProvider, (moduleSymbol, sourceFile, program2, isFromPackageJson)=>{
            const checker = program2.getTypeChecker();
            cancellationToken.throwIfCancellationRequested();
            const compilerOptions = program2.getCompilerOptions();
            const defaultInfo = getDefaultLikeExportInfo(moduleSymbol, checker);
            if (defaultInfo && symbolFlagsHaveMeaning(checker.getSymbolFlags(defaultInfo.symbol), currentTokenMeaning) && forEachNameOfDefaultExport(defaultInfo.symbol, checker, getEmitScriptTarget(compilerOptions), (name, capitalizedName)=>(isJsxTagName ? capitalizedName !== null && capitalizedName !== void 0 ? capitalizedName : name : name) === symbolName2)) addSymbol(moduleSymbol, sourceFile, defaultInfo.symbol, defaultInfo.exportKind, program2, isFromPackageJson);
            const exportSymbolWithIdenticalName = checker.tryGetMemberInModuleExportsAndProperties(symbolName2, moduleSymbol);
            if (exportSymbolWithIdenticalName && symbolFlagsHaveMeaning(checker.getSymbolFlags(exportSymbolWithIdenticalName), currentTokenMeaning)) addSymbol(moduleSymbol, sourceFile, exportSymbolWithIdenticalName, 0 /* Named */ , program2, isFromPackageJson);
        });
        return originalSymbolToExportInfos;
    }
    function getExportEqualsImportKind(importingFile, compilerOptions, forceImportKeyword) {
        const allowSyntheticDefaults = getAllowSyntheticDefaultImports(compilerOptions);
        const isJS = hasJSFileExtension(importingFile.fileName);
        if (!isJS && getEmitModuleKind(compilerOptions) >= 5 /* ES2015 */ ) return allowSyntheticDefaults ? 1 /* Default */  : 2 /* Namespace */ ;
        if (isJS) return importingFile.externalModuleIndicator || forceImportKeyword ? allowSyntheticDefaults ? 1 /* Default */  : 2 /* Namespace */  : 3 /* CommonJS */ ;
        var _importingFile_statements;
        for (const statement of (_importingFile_statements = importingFile.statements) !== null && _importingFile_statements !== void 0 ? _importingFile_statements : emptyArray){
            if (isImportEqualsDeclaration(statement) && !nodeIsMissing(statement.moduleReference)) return 3 /* CommonJS */ ;
        }
        return allowSyntheticDefaults ? 1 /* Default */  : 3 /* CommonJS */ ;
    }
    function codeActionForFix(context, sourceFile, symbolName2, fix, includeSymbolNameInDescription, program, preferences) {
        let diag2;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (tracker)=>{
            diag2 = codeActionForFixWorker(tracker, sourceFile, symbolName2, fix, includeSymbolNameInDescription, program, preferences);
        });
        return createCodeFixAction(importFixName, changes, diag2, importFixId, Diagnostics.Add_all_missing_imports);
    }
    function codeActionForFixWorker(changes, sourceFile, symbolName2, fix, includeSymbolNameInDescription, program, preferences) {
        const quotePreference = getQuotePreference(sourceFile, preferences);
        switch(fix.kind){
            case 0 /* UseNamespace */ :
                addNamespaceQualifier(changes, sourceFile, fix);
                return [
                    Diagnostics.Change_0_to_1,
                    symbolName2,
                    `${fix.namespacePrefix}.${symbolName2}`
                ];
            case 1 /* JsdocTypeImport */ :
                addImportType(changes, sourceFile, fix, quotePreference);
                return [
                    Diagnostics.Change_0_to_1,
                    symbolName2,
                    getImportTypePrefix(fix.moduleSpecifier, quotePreference) + symbolName2
                ];
            case 2 /* AddToExisting */ :
                {
                    const { importClauseOrBindingPattern, importKind, addAsTypeOnly, moduleSpecifier } = fix;
                    doAddExistingFix(changes, sourceFile, importClauseOrBindingPattern, importKind === 1 /* Default */  ? {
                        name: symbolName2,
                        addAsTypeOnly
                    } : void 0, importKind === 0 /* Named */  ? [
                        {
                            name: symbolName2,
                            addAsTypeOnly
                        }
                    ] : emptyArray, /*removeExistingImportSpecifiers*/ void 0, preferences);
                    const moduleSpecifierWithoutQuotes = stripQuotes(moduleSpecifier);
                    return includeSymbolNameInDescription ? [
                        Diagnostics.Import_0_from_1,
                        symbolName2,
                        moduleSpecifierWithoutQuotes
                    ] : [
                        Diagnostics.Update_import_from_0,
                        moduleSpecifierWithoutQuotes
                    ];
                }
            case 3 /* AddNew */ :
                {
                    const { importKind, moduleSpecifier, addAsTypeOnly, useRequire, qualification } = fix;
                    const getDeclarations = useRequire ? getNewRequires : getNewImports;
                    const defaultImport = importKind === 1 /* Default */  ? {
                        name: symbolName2,
                        addAsTypeOnly
                    } : void 0;
                    const namedImports = importKind === 0 /* Named */  ? [
                        {
                            name: symbolName2,
                            addAsTypeOnly
                        }
                    ] : void 0;
                    const namespaceLikeImport = importKind === 2 /* Namespace */  || importKind === 3 /* CommonJS */  ? {
                        importKind,
                        name: (qualification == null ? void 0 : qualification.namespacePrefix) || symbolName2,
                        addAsTypeOnly
                    } : void 0;
                    insertImports(changes, sourceFile, getDeclarations(moduleSpecifier, quotePreference, defaultImport, namedImports, namespaceLikeImport, program.getCompilerOptions(), preferences), /*blankLineBetween*/ true, preferences);
                    if (qualification) addNamespaceQualifier(changes, sourceFile, qualification);
                    return includeSymbolNameInDescription ? [
                        Diagnostics.Import_0_from_1,
                        symbolName2,
                        moduleSpecifier
                    ] : [
                        Diagnostics.Add_import_from_0,
                        moduleSpecifier
                    ];
                }
            case 4 /* PromoteTypeOnly */ :
                {
                    const { typeOnlyAliasDeclaration } = fix;
                    const promotedDeclaration = promoteFromTypeOnly(changes, typeOnlyAliasDeclaration, program, sourceFile, preferences);
                    return promotedDeclaration.kind === 277 /* ImportSpecifier */  ? [
                        Diagnostics.Remove_type_from_import_of_0_from_1,
                        symbolName2,
                        getModuleSpecifierText(promotedDeclaration.parent.parent)
                    ] : [
                        Diagnostics.Remove_type_from_import_declaration_from_0,
                        getModuleSpecifierText(promotedDeclaration)
                    ];
                }
            default:
                return Debug.assertNever(fix, `Unexpected fix kind ${fix.kind}`);
        }
    }
    function getModuleSpecifierText(promotedDeclaration) {
        var _a, _b;
        return promotedDeclaration.kind === 272 /* ImportEqualsDeclaration */  ? ((_b = tryCast((_a = tryCast(promotedDeclaration.moduleReference, isExternalModuleReference)) == null ? void 0 : _a.expression, isStringLiteralLike)) == null ? void 0 : _b.text) || promotedDeclaration.moduleReference.getText() : cast(promotedDeclaration.parent.moduleSpecifier, isStringLiteral).text;
    }
    function promoteFromTypeOnly(changes, aliasDeclaration, program, sourceFile, preferences) {
        const compilerOptions = program.getCompilerOptions();
        const convertExistingToTypeOnly = compilerOptions.verbatimModuleSyntax;
        switch(aliasDeclaration.kind){
            case 277 /* ImportSpecifier */ :
                if (aliasDeclaration.isTypeOnly) {
                    if (aliasDeclaration.parent.elements.length > 1) {
                        const newSpecifier = factory.updateImportSpecifier(aliasDeclaration, /*isTypeOnly*/ false, aliasDeclaration.propertyName, aliasDeclaration.name);
                        const { specifierComparer } = ts_OrganizeImports_exports.getNamedImportSpecifierComparerWithDetection(aliasDeclaration.parent.parent.parent, preferences, sourceFile);
                        const insertionIndex = ts_OrganizeImports_exports.getImportSpecifierInsertionIndex(aliasDeclaration.parent.elements, newSpecifier, specifierComparer);
                        if (insertionIndex !== aliasDeclaration.parent.elements.indexOf(aliasDeclaration)) {
                            changes.delete(sourceFile, aliasDeclaration);
                            changes.insertImportSpecifierAtIndex(sourceFile, newSpecifier, aliasDeclaration.parent, insertionIndex);
                            return aliasDeclaration;
                        }
                    }
                    var _aliasDeclaration_propertyName;
                    changes.deleteRange(sourceFile, {
                        pos: getTokenPosOfNode(aliasDeclaration.getFirstToken()),
                        end: getTokenPosOfNode((_aliasDeclaration_propertyName = aliasDeclaration.propertyName) !== null && _aliasDeclaration_propertyName !== void 0 ? _aliasDeclaration_propertyName : aliasDeclaration.name)
                    });
                    return aliasDeclaration;
                } else {
                    Debug.assert(aliasDeclaration.parent.parent.isTypeOnly);
                    promoteImportClause(aliasDeclaration.parent.parent);
                    return aliasDeclaration.parent.parent;
                }
            case 274 /* ImportClause */ :
                promoteImportClause(aliasDeclaration);
                return aliasDeclaration;
            case 275 /* NamespaceImport */ :
                promoteImportClause(aliasDeclaration.parent);
                return aliasDeclaration.parent;
            case 272 /* ImportEqualsDeclaration */ :
                changes.deleteRange(sourceFile, aliasDeclaration.getChildAt(1));
                return aliasDeclaration;
            default:
                Debug.failBadSyntaxKind(aliasDeclaration);
        }
        function promoteImportClause(importClause) {
            var _a;
            changes.delete(sourceFile, getTypeKeywordOfTypeOnlyImport(importClause, sourceFile));
            if (!compilerOptions.allowImportingTsExtensions) {
                const moduleSpecifier = tryGetModuleSpecifierFromDeclaration(importClause.parent);
                const resolvedModule = moduleSpecifier && ((_a = program.getResolvedModuleFromModuleSpecifier(moduleSpecifier, sourceFile)) == null ? void 0 : _a.resolvedModule);
                if (resolvedModule == null ? void 0 : resolvedModule.resolvedUsingTsExtension) {
                    const changedExtension = changeAnyExtension(moduleSpecifier.text, getOutputExtension(moduleSpecifier.text, compilerOptions));
                    changes.replaceNode(sourceFile, moduleSpecifier, factory.createStringLiteral(changedExtension));
                }
            }
            if (convertExistingToTypeOnly) {
                const namedImports = tryCast(importClause.namedBindings, isNamedImports);
                if (namedImports && namedImports.elements.length > 1) {
                    const sortState = ts_OrganizeImports_exports.getNamedImportSpecifierComparerWithDetection(importClause.parent, preferences, sourceFile);
                    if (sortState.isSorted !== false && aliasDeclaration.kind === 277 /* ImportSpecifier */  && namedImports.elements.indexOf(aliasDeclaration) !== 0) {
                        changes.delete(sourceFile, aliasDeclaration);
                        changes.insertImportSpecifierAtIndex(sourceFile, aliasDeclaration, namedImports, 0);
                    }
                    for (const element of namedImports.elements)if (element !== aliasDeclaration && !element.isTypeOnly) changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , element);
                }
            }
        }
    }
    function doAddExistingFix(changes, sourceFile, clause, defaultImport, namedImports, removeExistingImportSpecifiers, preferences) {
        var _a;
        if (clause.kind === 207 /* ObjectBindingPattern */ ) {
            if (removeExistingImportSpecifiers && clause.elements.some((e)=>removeExistingImportSpecifiers.has(e))) {
                changes.replaceNode(sourceFile, clause, factory.createObjectBindingPattern([
                    ...clause.elements.filter((e)=>!removeExistingImportSpecifiers.has(e)),
                    ...defaultImport ? [
                        factory.createBindingElement(/*dotDotDotToken*/ void 0, /*propertyName*/ "default", defaultImport.name)
                    ] : emptyArray,
                    ...namedImports.map((i)=>factory.createBindingElement(/*dotDotDotToken*/ void 0, i.propertyName, i.name))
                ]));
                return;
            }
            if (defaultImport) addElementToBindingPattern(clause, defaultImport.name, "default");
            for (const specifier of namedImports)addElementToBindingPattern(clause, specifier.name, specifier.propertyName);
            return;
        }
        const promoteFromTypeOnly2 = clause.isTypeOnly && some([
            defaultImport,
            ...namedImports
        ], (i)=>(i == null ? void 0 : i.addAsTypeOnly) === 4 /* NotAllowed */ );
        const existingSpecifiers = clause.namedBindings && ((_a = tryCast(clause.namedBindings, isNamedImports)) == null ? void 0 : _a.elements);
        if (defaultImport) {
            Debug.assert(!clause.name, "Cannot add a default import to an import clause that already has one");
            changes.insertNodeAt(sourceFile, clause.getStart(sourceFile), factory.createIdentifier(defaultImport.name), {
                suffix: ", "
            });
        }
        if (namedImports.length) {
            const { specifierComparer, isSorted } = ts_OrganizeImports_exports.getNamedImportSpecifierComparerWithDetection(clause.parent, preferences, sourceFile);
            const newSpecifiers = toSorted(namedImports.map((namedImport)=>factory.createImportSpecifier((!clause.isTypeOnly || promoteFromTypeOnly2) && shouldUseTypeOnly(namedImport, preferences), namedImport.propertyName === void 0 ? void 0 : factory.createIdentifier(namedImport.propertyName), factory.createIdentifier(namedImport.name))), specifierComparer);
            if (removeExistingImportSpecifiers) changes.replaceNode(sourceFile, clause.namedBindings, factory.updateNamedImports(clause.namedBindings, toSorted([
                ...existingSpecifiers.filter((s)=>!removeExistingImportSpecifiers.has(s)),
                ...newSpecifiers
            ], specifierComparer)));
            else if ((existingSpecifiers == null ? void 0 : existingSpecifiers.length) && isSorted !== false) {
                const transformedExistingSpecifiers = promoteFromTypeOnly2 && existingSpecifiers ? factory.updateNamedImports(clause.namedBindings, sameMap(existingSpecifiers, (e)=>factory.updateImportSpecifier(e, /*isTypeOnly*/ true, e.propertyName, e.name))).elements : existingSpecifiers;
                for (const spec of newSpecifiers){
                    const insertionIndex = ts_OrganizeImports_exports.getImportSpecifierInsertionIndex(transformedExistingSpecifiers, spec, specifierComparer);
                    changes.insertImportSpecifierAtIndex(sourceFile, spec, clause.namedBindings, insertionIndex);
                }
            } else if (existingSpecifiers == null ? void 0 : existingSpecifiers.length) for (const spec of newSpecifiers)changes.insertNodeInListAfter(sourceFile, last(existingSpecifiers), spec, existingSpecifiers);
            else if (newSpecifiers.length) {
                const namedImports2 = factory.createNamedImports(newSpecifiers);
                if (clause.namedBindings) changes.replaceNode(sourceFile, clause.namedBindings, namedImports2);
                else changes.insertNodeAfter(sourceFile, Debug.checkDefined(clause.name, "Import clause must have either named imports or a default import"), namedImports2);
            }
        }
        if (promoteFromTypeOnly2) {
            changes.delete(sourceFile, getTypeKeywordOfTypeOnlyImport(clause, sourceFile));
            if (existingSpecifiers) for (const specifier of existingSpecifiers)changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , specifier);
        }
        function addElementToBindingPattern(bindingPattern, name, propertyName) {
            const element = factory.createBindingElement(/*dotDotDotToken*/ void 0, propertyName, name);
            if (bindingPattern.elements.length) changes.insertNodeInListAfter(sourceFile, last(bindingPattern.elements), element);
            else changes.replaceNode(sourceFile, bindingPattern, factory.createObjectBindingPattern([
                element
            ]));
        }
    }
    function addNamespaceQualifier(changes, sourceFile, { namespacePrefix, usagePosition }) {
        changes.insertText(sourceFile, usagePosition, namespacePrefix + ".");
    }
    function addImportType(changes, sourceFile, { moduleSpecifier, usagePosition: position }, quotePreference) {
        changes.insertText(sourceFile, position, getImportTypePrefix(moduleSpecifier, quotePreference));
    }
    function getImportTypePrefix(moduleSpecifier, quotePreference) {
        const quote2 = getQuoteFromPreference(quotePreference);
        return `import(${quote2}${moduleSpecifier}${quote2}).`;
    }
    function needsTypeOnly({ addAsTypeOnly }) {
        return addAsTypeOnly === 2 /* Required */ ;
    }
    function shouldUseTypeOnly(info, preferences) {
        return needsTypeOnly(info) || !!preferences.preferTypeOnlyAutoImports && info.addAsTypeOnly !== 4 /* NotAllowed */ ;
    }
    function getNewImports(moduleSpecifier, quotePreference, defaultImport, namedImports, namespaceLikeImport, compilerOptions, preferences) {
        const quotedModuleSpecifier = makeStringLiteral(moduleSpecifier, quotePreference);
        let statements;
        if (defaultImport !== void 0 || (namedImports == null ? void 0 : namedImports.length)) {
            const topLevelTypeOnly = (!defaultImport || needsTypeOnly(defaultImport)) && every(namedImports, needsTypeOnly) || (compilerOptions.verbatimModuleSyntax || preferences.preferTypeOnlyAutoImports) && (defaultImport == null ? void 0 : defaultImport.addAsTypeOnly) !== 4 /* NotAllowed */  && !some(namedImports, (i)=>i.addAsTypeOnly === 4 /* NotAllowed */ );
            statements = combine(statements, makeImport(defaultImport && factory.createIdentifier(defaultImport.name), namedImports == null ? void 0 : namedImports.map((namedImport)=>factory.createImportSpecifier(!topLevelTypeOnly && shouldUseTypeOnly(namedImport, preferences), namedImport.propertyName === void 0 ? void 0 : factory.createIdentifier(namedImport.propertyName), factory.createIdentifier(namedImport.name))), moduleSpecifier, quotePreference, topLevelTypeOnly));
        }
        if (namespaceLikeImport) {
            const declaration = namespaceLikeImport.importKind === 3 /* CommonJS */  ? factory.createImportEqualsDeclaration(/*modifiers*/ void 0, shouldUseTypeOnly(namespaceLikeImport, preferences), factory.createIdentifier(namespaceLikeImport.name), factory.createExternalModuleReference(quotedModuleSpecifier)) : factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(shouldUseTypeOnly(namespaceLikeImport, preferences) ? 156 /* TypeKeyword */  : void 0, /*name*/ void 0, factory.createNamespaceImport(factory.createIdentifier(namespaceLikeImport.name))), quotedModuleSpecifier, /*attributes*/ void 0);
            statements = combine(statements, declaration);
        }
        return Debug.checkDefined(statements);
    }
    function getNewRequires(moduleSpecifier, quotePreference, defaultImport, namedImports, namespaceLikeImport) {
        const quotedModuleSpecifier = makeStringLiteral(moduleSpecifier, quotePreference);
        let statements;
        if (defaultImport || (namedImports == null ? void 0 : namedImports.length)) {
            const bindingElements = (namedImports == null ? void 0 : namedImports.map(({ name, propertyName })=>factory.createBindingElement(/*dotDotDotToken*/ void 0, propertyName, name))) || [];
            if (defaultImport) bindingElements.unshift(factory.createBindingElement(/*dotDotDotToken*/ void 0, "default", defaultImport.name));
            const declaration = createConstEqualsRequireDeclaration(factory.createObjectBindingPattern(bindingElements), quotedModuleSpecifier);
            statements = combine(statements, declaration);
        }
        if (namespaceLikeImport) {
            const declaration = createConstEqualsRequireDeclaration(namespaceLikeImport.name, quotedModuleSpecifier);
            statements = combine(statements, declaration);
        }
        return Debug.checkDefined(statements);
    }
    function createConstEqualsRequireDeclaration(name, quotedModuleSpecifier) {
        return factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
            factory.createVariableDeclaration(typeof name === "string" ? factory.createIdentifier(name) : name, /*exclamationToken*/ void 0, /*type*/ void 0, factory.createCallExpression(factory.createIdentifier("require"), /*typeArguments*/ void 0, [
                quotedModuleSpecifier
            ]))
        ], 2 /* Const */ ));
    }
    function symbolFlagsHaveMeaning(flags, meaning) {
        return meaning === 7 /* All */  ? true : meaning & 1 /* Value */  ? !!(flags & 111551 /* Value */ ) : meaning & 2 /* Type */  ? !!(flags & 788968 /* Type */ ) : meaning & 4 /* Namespace */  ? !!(flags & 1920 /* Namespace */ ) : false;
    }
    function getImpliedNodeFormatForEmit(file, program) {
        return isFullSourceFile(file) ? program.getImpliedNodeFormatForEmit(file) : getImpliedNodeFormatForEmitWorker(file, program.getCompilerOptions());
    }
    function getEmitModuleFormatOfFile(file, program) {
        return isFullSourceFile(file) ? program.getEmitModuleFormatOfFile(file) : getEmitModuleFormatOfFileWorker(file, program.getCompilerOptions());
    }
    // src/services/codefixes/fixAddMissingConstraint.ts
    var fixId18 = "addMissingConstraint";
    var errorCodes20 = [
        // We want errors this could be attached to:
        // Diagnostics.This_type_parameter_probably_needs_an_extends_0_constraint
        Diagnostics.Type_0_is_not_comparable_to_type_1.code,
        Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated.code,
        Diagnostics.Type_0_is_not_assignable_to_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code,
        Diagnostics.Type_0_is_not_assignable_to_type_1.code,
        Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_with_exactOptionalPropertyTypes_Colon_true_Consider_adding_undefined_to_the_types_of_the_target_s_properties.code,
        Diagnostics.Property_0_is_incompatible_with_index_signature.code,
        Diagnostics.Property_0_in_type_1_is_not_assignable_to_type_2.code,
        Diagnostics.Type_0_does_not_satisfy_the_constraint_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes20,
        getCodeActions (context) {
            const { sourceFile, span, program, preferences, host } = context;
            const info = getInfo6(program, sourceFile, span);
            if (info === void 0) return;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingConstraint(t, program, preferences, host, sourceFile, info));
            return [
                createCodeFixAction(fixId18, changes, Diagnostics.Add_extends_constraint, fixId18, Diagnostics.Add_extends_constraint_to_all_type_parameters)
            ];
        },
        fixIds: [
            fixId18
        ],
        getAllCodeActions: (context)=>{
            const { program, preferences, host } = context;
            const seen = /* @__PURE__ */ new Set();
            return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                eachDiagnostic(context, errorCodes20, (diag2)=>{
                    const info = getInfo6(program, diag2.file, createTextSpan(diag2.start, diag2.length));
                    if (info) {
                        if (addToSeen(seen, getNodeId(info.declaration))) return addMissingConstraint(changes, program, preferences, host, diag2.file, info);
                    }
                    return void 0;
                });
            }));
        }
    });
    function getInfo6(program, sourceFile, span) {
        const diag2 = find(program.getSemanticDiagnostics(sourceFile), (diag3)=>diag3.start === span.start && diag3.length === span.length);
        if (diag2 === void 0 || diag2.relatedInformation === void 0) return;
        const related = find(diag2.relatedInformation, (related2)=>related2.code === Diagnostics.This_type_parameter_might_need_an_extends_0_constraint.code);
        if (related === void 0 || related.file === void 0 || related.start === void 0 || related.length === void 0) return;
        let declaration = findAncestorMatchingSpan(related.file, createTextSpan(related.start, related.length));
        if (declaration === void 0) return;
        if (isIdentifier(declaration) && isTypeParameterDeclaration(declaration.parent)) declaration = declaration.parent;
        if (isTypeParameterDeclaration(declaration)) {
            if (isMappedTypeNode(declaration.parent)) return;
            const token = getTokenAtPosition(sourceFile, span.start);
            const checker = program.getTypeChecker();
            const constraint = tryGetConstraintType(checker, token) || tryGetConstraintFromDiagnosticMessage(related.messageText);
            return {
                constraint,
                declaration,
                token
            };
        }
        return void 0;
    }
    function addMissingConstraint(changes, program, preferences, host, sourceFile, info) {
        const { declaration, constraint } = info;
        const checker = program.getTypeChecker();
        if (isString(constraint)) changes.insertText(sourceFile, declaration.name.end, ` extends ${constraint}`);
        else {
            const scriptTarget = getEmitScriptTarget(program.getCompilerOptions());
            const tracker = getNoopSymbolTrackerWithResolver({
                program,
                host
            });
            const importAdder = createImportAdder(sourceFile, program, preferences, host);
            const typeNode = typeToAutoImportableTypeNode(checker, importAdder, constraint, /*contextNode*/ void 0, scriptTarget, /*flags*/ void 0, /*internalFlags*/ void 0, tracker);
            if (typeNode) {
                changes.replaceNode(sourceFile, declaration, factory.updateTypeParameterDeclaration(declaration, /*modifiers*/ void 0, declaration.name, typeNode, declaration.default));
                importAdder.writeFixes(changes);
            }
        }
    }
    function tryGetConstraintFromDiagnosticMessage(messageText) {
        const [, constraint] = flattenDiagnosticMessageText(messageText, "\n", 0).match(/`extends (.*)`/) || [];
        return constraint;
    }
    function tryGetConstraintType(checker, node) {
        if (isTypeNode(node.parent)) return checker.getTypeArgumentConstraint(node.parent);
        const contextualType = isExpression(node) ? checker.getContextualType(node) : void 0;
        return contextualType || checker.getTypeAtLocation(node);
    }
    // src/services/codefixes/fixOverrideModifier.ts
    var fixName = "fixOverrideModifier";
    var fixAddOverrideId = "fixAddOverrideModifier";
    var fixRemoveOverrideId = "fixRemoveOverrideModifier";
    var errorCodes21 = [
        Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0.code,
        Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class.code,
        Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0.code,
        Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0.code,
        Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0.code,
        Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code,
        Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class.code,
        Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code,
        Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0.code
    ];
    var errorCodeFixIdMap = {
        // case #1:
        [Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0.code]: {
            descriptions: Diagnostics.Add_override_modifier,
            fixId: fixAddOverrideId,
            fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
        },
        [Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code]: {
            descriptions: Diagnostics.Add_override_modifier,
            fixId: fixAddOverrideId,
            fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
        },
        // case #2:
        [Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class.code]: {
            descriptions: Diagnostics.Remove_override_modifier,
            fixId: fixRemoveOverrideId,
            fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
        },
        [Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class.code]: {
            descriptions: Diagnostics.Remove_override_modifier,
            fixId: fixRemoveOverrideId,
            fixAllDescriptions: Diagnostics.Remove_override_modifier
        },
        // case #3:
        [Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0.code]: {
            descriptions: Diagnostics.Add_override_modifier,
            fixId: fixAddOverrideId,
            fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
        },
        [Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code]: {
            descriptions: Diagnostics.Add_override_modifier,
            fixId: fixAddOverrideId,
            fixAllDescriptions: Diagnostics.Add_all_missing_override_modifiers
        },
        // case #4:
        [Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0.code]: {
            descriptions: Diagnostics.Add_override_modifier,
            fixId: fixAddOverrideId,
            fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
        },
        // case #5:
        [Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0.code]: {
            descriptions: Diagnostics.Remove_override_modifier,
            fixId: fixRemoveOverrideId,
            fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
        },
        [Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0.code]: {
            descriptions: Diagnostics.Remove_override_modifier,
            fixId: fixRemoveOverrideId,
            fixAllDescriptions: Diagnostics.Remove_all_unnecessary_override_modifiers
        }
    };
    registerCodeFix({
        errorCodes: errorCodes21,
        getCodeActions: function getCodeActionsToFixOverrideModifierIssues(context) {
            const { errorCode, span } = context;
            const info = errorCodeFixIdMap[errorCode];
            if (!info) return emptyArray;
            const { descriptions, fixId: fixId56, fixAllDescriptions } = info;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>dispatchChanges(changes2, context, errorCode, span.start));
            return [
                createCodeFixActionMaybeFixAll(fixName, changes, descriptions, fixId56, fixAllDescriptions)
            ];
        },
        fixIds: [
            fixName,
            fixAddOverrideId,
            fixRemoveOverrideId
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes21, (changes, diag2)=>{
                const { code, start } = diag2;
                const info = errorCodeFixIdMap[code];
                if (!info || info.fixId !== context.fixId) return;
                dispatchChanges(changes, context, code, start);
            })
    });
    function dispatchChanges(changeTracker, context, errorCode, pos) {
        switch(errorCode){
            case Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_a_member_in_the_base_class_0.code:
            case Diagnostics.This_member_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code:
            case Diagnostics.This_member_must_have_an_override_modifier_because_it_overrides_an_abstract_method_that_is_declared_in_the_base_class_0.code:
            case Diagnostics.This_parameter_property_must_have_an_override_modifier_because_it_overrides_a_member_in_base_class_0.code:
            case Diagnostics.This_parameter_property_must_have_a_JSDoc_comment_with_an_override_tag_because_it_overrides_a_member_in_the_base_class_0.code:
                return doAddOverrideModifierChange(changeTracker, context.sourceFile, pos);
            case Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0.code:
            case Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0.code:
            case Diagnostics.This_member_cannot_have_an_override_modifier_because_its_containing_class_0_does_not_extend_another_class.code:
            case Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_its_containing_class_0_does_not_extend_another_class.code:
                return doRemoveOverrideModifierChange(changeTracker, context.sourceFile, pos);
            default:
                Debug.fail("Unexpected error code: " + errorCode);
        }
    }
    function doAddOverrideModifierChange(changeTracker, sourceFile, pos) {
        const classElement = findContainerClassElementLike(sourceFile, pos);
        if (isSourceFileJS(sourceFile)) {
            changeTracker.addJSDocTags(sourceFile, classElement, [
                factory.createJSDocOverrideTag(factory.createIdentifier("override"))
            ]);
            return;
        }
        const modifiers = classElement.modifiers || emptyArray;
        const staticModifier = find(modifiers, isStaticModifier);
        const abstractModifier = find(modifiers, isAbstractModifier);
        const accessibilityModifier = find(modifiers, (m)=>isAccessibilityModifier(m.kind));
        const lastDecorator = findLast(modifiers, isDecorator);
        const modifierPos = abstractModifier ? abstractModifier.end : staticModifier ? staticModifier.end : accessibilityModifier ? accessibilityModifier.end : lastDecorator ? skipTrivia(sourceFile.text, lastDecorator.end) : classElement.getStart(sourceFile);
        const options = accessibilityModifier || staticModifier || abstractModifier ? {
            prefix: " "
        } : {
            suffix: " "
        };
        changeTracker.insertModifierAt(sourceFile, modifierPos, 164 /* OverrideKeyword */ , options);
    }
    function doRemoveOverrideModifierChange(changeTracker, sourceFile, pos) {
        const classElement = findContainerClassElementLike(sourceFile, pos);
        if (isSourceFileJS(sourceFile)) {
            changeTracker.filterJSDocTags(sourceFile, classElement, not(isJSDocOverrideTag));
            return;
        }
        const overrideModifier = find(classElement.modifiers, isOverrideModifier);
        Debug.assertIsDefined(overrideModifier);
        changeTracker.deleteModifier(sourceFile, overrideModifier);
    }
    function isClassElementLikeHasJSDoc(node) {
        switch(node.kind){
            case 177 /* Constructor */ :
            case 173 /* PropertyDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return true;
            case 170 /* Parameter */ :
                return isParameterPropertyDeclaration(node, node.parent);
            default:
                return false;
        }
    }
    function findContainerClassElementLike(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const classElement = findAncestor(token, (node)=>{
            if (isClassLike(node)) return "quit";
            return isClassElementLikeHasJSDoc(node);
        });
        Debug.assert(classElement && isClassElementLikeHasJSDoc(classElement));
        return classElement;
    }
    // src/services/codefixes/fixNoPropertyAccessFromIndexSignature.ts
    var fixId19 = "fixNoPropertyAccessFromIndexSignature";
    var errorCodes22 = [
        Diagnostics.Property_0_comes_from_an_index_signature_so_it_must_be_accessed_with_0.code
    ];
    registerCodeFix({
        errorCodes: errorCodes22,
        fixIds: [
            fixId19
        ],
        getCodeActions (context) {
            const { sourceFile, span, preferences } = context;
            const property = getPropertyAccessExpression(sourceFile, span.start);
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange14(t, context.sourceFile, property, preferences));
            return [
                createCodeFixAction(fixId19, changes, [
                    Diagnostics.Use_element_access_for_0,
                    property.name.text
                ], fixId19, Diagnostics.Use_element_access_for_all_undeclared_properties)
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes22, (changes, diag2)=>doChange14(changes, diag2.file, getPropertyAccessExpression(diag2.file, diag2.start), context.preferences))
    });
    function doChange14(changes, sourceFile, node, preferences) {
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const argumentsExpression = factory.createStringLiteral(node.name.text, quotePreference === 0 /* Single */ );
        changes.replaceNode(sourceFile, node, isPropertyAccessChain(node) ? factory.createElementAccessChain(node.expression, node.questionDotToken, argumentsExpression) : factory.createElementAccessExpression(node.expression, argumentsExpression));
    }
    function getPropertyAccessExpression(sourceFile, pos) {
        return cast(getTokenAtPosition(sourceFile, pos).parent, isPropertyAccessExpression);
    }
    // src/services/codefixes/fixImplicitThis.ts
    var fixId20 = "fixImplicitThis";
    var errorCodes23 = [
        Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code
    ];
    registerCodeFix({
        errorCodes: errorCodes23,
        getCodeActions: function getCodeActionsToFixImplicitThis(context) {
            const { sourceFile, program, span } = context;
            let diagnostic;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                diagnostic = doChange15(t, sourceFile, span.start, program.getTypeChecker());
            });
            return diagnostic ? [
                createCodeFixAction(fixId20, changes, diagnostic, fixId20, Diagnostics.Fix_all_implicit_this_errors)
            ] : emptyArray;
        },
        fixIds: [
            fixId20
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes23, (changes, diag2)=>{
                doChange15(changes, diag2.file, diag2.start, context.program.getTypeChecker());
            })
    });
    function doChange15(changes, sourceFile, pos, checker) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (!isThis(token)) return void 0;
        const fn = getThisContainer(token, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
        if (!isFunctionDeclaration(fn) && !isFunctionExpression(fn)) return void 0;
        if (!isSourceFile(getThisContainer(fn, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false))) {
            const fnKeyword = Debug.checkDefined(findChildOfKind(fn, 100 /* FunctionKeyword */ , sourceFile));
            const { name } = fn;
            const body = Debug.checkDefined(fn.body);
            if (isFunctionExpression(fn)) {
                if (name && ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(name, checker, sourceFile, body)) return void 0;
                changes.delete(sourceFile, fnKeyword);
                if (name) changes.delete(sourceFile, name);
                changes.insertText(sourceFile, body.pos, " =>");
                return [
                    Diagnostics.Convert_function_expression_0_to_arrow_function,
                    name ? name.text : ANONYMOUS
                ];
            } else {
                changes.replaceNode(sourceFile, fnKeyword, factory.createToken(87 /* ConstKeyword */ ));
                changes.insertText(sourceFile, name.end, " = ");
                changes.insertText(sourceFile, body.pos, " =>");
                return [
                    Diagnostics.Convert_function_declaration_0_to_arrow_function,
                    name.text
                ];
            }
        }
    }
    // src/services/codefixes/fixImportNonExportedMember.ts
    var fixId21 = "fixImportNonExportedMember";
    var errorCodes24 = [
        Diagnostics.Module_0_declares_1_locally_but_it_is_not_exported.code
    ];
    registerCodeFix({
        errorCodes: errorCodes24,
        fixIds: [
            fixId21
        ],
        getCodeActions (context) {
            const { sourceFile, span, program } = context;
            const info = getInfo7(sourceFile, span.start, program);
            if (info === void 0) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange16(t, program, info));
            return [
                createCodeFixAction(fixId21, changes, [
                    Diagnostics.Export_0_from_module_1,
                    info.exportName.node.text,
                    info.moduleSpecifier
                ], fixId21, Diagnostics.Export_all_referenced_locals)
            ];
        },
        getAllCodeActions (context) {
            const { program } = context;
            return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                const exports2 = /* @__PURE__ */ new Map();
                eachDiagnostic(context, errorCodes24, (diag2)=>{
                    const info = getInfo7(diag2.file, diag2.start, program);
                    if (info === void 0) return void 0;
                    const { exportName, node, moduleSourceFile } = info;
                    if (tryGetExportDeclaration(moduleSourceFile, exportName.isTypeOnly) === void 0 && canHaveExportModifier(node)) changes.insertExportModifier(moduleSourceFile, node);
                    else {
                        const moduleExports = exports2.get(moduleSourceFile) || {
                            typeOnlyExports: [],
                            exports: []
                        };
                        if (exportName.isTypeOnly) moduleExports.typeOnlyExports.push(exportName);
                        else moduleExports.exports.push(exportName);
                        exports2.set(moduleSourceFile, moduleExports);
                    }
                });
                exports2.forEach((moduleExports, moduleSourceFile)=>{
                    const exportDeclaration = tryGetExportDeclaration(moduleSourceFile, /*isTypeOnly*/ true);
                    if (exportDeclaration && exportDeclaration.isTypeOnly) {
                        doChanges(changes, program, moduleSourceFile, moduleExports.typeOnlyExports, exportDeclaration);
                        doChanges(changes, program, moduleSourceFile, moduleExports.exports, tryGetExportDeclaration(moduleSourceFile, /*isTypeOnly*/ false));
                    } else doChanges(changes, program, moduleSourceFile, [
                        ...moduleExports.exports,
                        ...moduleExports.typeOnlyExports
                    ], exportDeclaration);
                });
            }));
        }
    });
    function getInfo7(sourceFile, pos, program) {
        var _a, _b;
        const token = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(token)) {
            const importDeclaration = findAncestor(token, isImportDeclaration);
            if (importDeclaration === void 0) return void 0;
            const moduleSpecifier = isStringLiteral(importDeclaration.moduleSpecifier) ? importDeclaration.moduleSpecifier : void 0;
            if (moduleSpecifier === void 0) return void 0;
            const resolvedModule = (_a = program.getResolvedModuleFromModuleSpecifier(moduleSpecifier, sourceFile)) == null ? void 0 : _a.resolvedModule;
            if (resolvedModule === void 0) return void 0;
            const moduleSourceFile = program.getSourceFile(resolvedModule.resolvedFileName);
            if (moduleSourceFile === void 0 || isSourceFileFromLibrary(program, moduleSourceFile)) return void 0;
            const moduleSymbol = moduleSourceFile.symbol;
            const locals = (_b = tryCast(moduleSymbol.valueDeclaration, canHaveLocals)) == null ? void 0 : _b.locals;
            if (locals === void 0) return void 0;
            const localSymbol = locals.get(token.escapedText);
            if (localSymbol === void 0) return void 0;
            const node = getNodeOfSymbol(localSymbol);
            if (node === void 0) return void 0;
            const exportName = {
                node: token,
                isTypeOnly: isTypeDeclaration(node)
            };
            return {
                exportName,
                node,
                moduleSourceFile,
                moduleSpecifier: moduleSpecifier.text
            };
        }
        return void 0;
    }
    function doChange16(changes, program, { exportName, node, moduleSourceFile }) {
        const exportDeclaration = tryGetExportDeclaration(moduleSourceFile, exportName.isTypeOnly);
        if (exportDeclaration) updateExport(changes, program, moduleSourceFile, exportDeclaration, [
            exportName
        ]);
        else if (canHaveExportModifier(node)) changes.insertExportModifier(moduleSourceFile, node);
        else createExport(changes, program, moduleSourceFile, [
            exportName
        ]);
    }
    function doChanges(changes, program, sourceFile, moduleExports, node) {
        if (length(moduleExports)) {
            if (node) updateExport(changes, program, sourceFile, node, moduleExports);
            else createExport(changes, program, sourceFile, moduleExports);
        }
    }
    function tryGetExportDeclaration(sourceFile, isTypeOnly) {
        const predicate = (node)=>isExportDeclaration(node) && (isTypeOnly && node.isTypeOnly || !node.isTypeOnly);
        return findLast(sourceFile.statements, predicate);
    }
    function updateExport(changes, program, sourceFile, node, names) {
        const namedExports = node.exportClause && isNamedExports(node.exportClause) ? node.exportClause.elements : factory.createNodeArray([]);
        const allowTypeModifier = !node.isTypeOnly && !!(getIsolatedModules(program.getCompilerOptions()) || find(namedExports, (e)=>e.isTypeOnly));
        changes.replaceNode(sourceFile, node, factory.updateExportDeclaration(node, node.modifiers, node.isTypeOnly, factory.createNamedExports(factory.createNodeArray([
            ...namedExports,
            ...createExportSpecifiers(names, allowTypeModifier)
        ], /*hasTrailingComma*/ namedExports.hasTrailingComma)), node.moduleSpecifier, node.attributes));
    }
    function createExport(changes, program, sourceFile, names) {
        changes.insertNodeAtEndOfScope(sourceFile, sourceFile, factory.createExportDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, factory.createNamedExports(createExportSpecifiers(names, /*allowTypeModifier*/ getIsolatedModules(program.getCompilerOptions()))), /*moduleSpecifier*/ void 0, /*attributes*/ void 0));
    }
    function createExportSpecifiers(names, allowTypeModifier) {
        return factory.createNodeArray(map(names, (n)=>factory.createExportSpecifier(allowTypeModifier && n.isTypeOnly, /*propertyName*/ void 0, n.node)));
    }
    function getNodeOfSymbol(symbol) {
        if (symbol.valueDeclaration === void 0) return firstOrUndefined(symbol.declarations);
        const declaration = symbol.valueDeclaration;
        const variableStatement = isVariableDeclaration(declaration) ? tryCast(declaration.parent.parent, isVariableStatement) : void 0;
        return variableStatement && length(variableStatement.declarationList.declarations) === 1 ? variableStatement : declaration;
    }
    // src/services/codefixes/fixIncorrectNamedTupleSyntax.ts
    var fixId22 = "fixIncorrectNamedTupleSyntax";
    var errorCodes25 = [
        Diagnostics.A_labeled_tuple_element_is_declared_as_optional_with_a_question_mark_after_the_name_and_before_the_colon_rather_than_after_the_type.code,
        Diagnostics.A_labeled_tuple_element_is_declared_as_rest_with_a_before_the_name_rather_than_before_the_type.code
    ];
    registerCodeFix({
        errorCodes: errorCodes25,
        getCodeActions: function getCodeActionsToFixIncorrectNamedTupleSyntax(context) {
            const { sourceFile, span } = context;
            const namedTupleMember = getNamedTupleMember(sourceFile, span.start);
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange17(t, sourceFile, namedTupleMember));
            return [
                createCodeFixAction(fixId22, changes, Diagnostics.Move_labeled_tuple_element_modifiers_to_labels, fixId22, Diagnostics.Move_labeled_tuple_element_modifiers_to_labels)
            ];
        },
        fixIds: [
            fixId22
        ]
    });
    function getNamedTupleMember(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        return findAncestor(token, (t)=>t.kind === 203 /* NamedTupleMember */ );
    }
    function doChange17(changes, sourceFile, namedTupleMember) {
        if (!namedTupleMember) return;
        let unwrappedType = namedTupleMember.type;
        let sawOptional = false;
        let sawRest = false;
        while(unwrappedType.kind === 191 /* OptionalType */  || unwrappedType.kind === 192 /* RestType */  || unwrappedType.kind === 197 /* ParenthesizedType */ ){
            if (unwrappedType.kind === 191 /* OptionalType */ ) sawOptional = true;
            else if (unwrappedType.kind === 192 /* RestType */ ) sawRest = true;
            unwrappedType = unwrappedType.type;
        }
        const updated = factory.updateNamedTupleMember(namedTupleMember, namedTupleMember.dotDotDotToken || (sawRest ? factory.createToken(26 /* DotDotDotToken */ ) : void 0), namedTupleMember.name, namedTupleMember.questionToken || (sawOptional ? factory.createToken(58 /* QuestionToken */ ) : void 0), unwrappedType);
        if (updated === namedTupleMember) return;
        changes.replaceNode(sourceFile, namedTupleMember, updated);
    }
    // src/services/codefixes/fixSpelling.ts
    var fixId23 = "fixSpelling";
    var errorCodes26 = [
        Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
        Diagnostics.Property_0_may_not_exist_on_type_1_Did_you_mean_2.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
        Diagnostics.Could_not_find_name_0_Did_you_mean_1.code,
        Diagnostics.Cannot_find_namespace_0_Did_you_mean_1.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code,
        Diagnostics._0_has_no_exported_member_named_1_Did_you_mean_2.code,
        Diagnostics.This_member_cannot_have_an_override_modifier_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1.code,
        Diagnostics.This_member_cannot_have_a_JSDoc_comment_with_an_override_tag_because_it_is_not_declared_in_the_base_class_0_Did_you_mean_1.code,
        // for JSX class components
        Diagnostics.No_overload_matches_this_call.code,
        // for JSX FC
        Diagnostics.Type_0_is_not_assignable_to_type_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes26,
        getCodeActions (context) {
            const { sourceFile, errorCode } = context;
            const info = getInfo8(sourceFile, context.span.start, context, errorCode);
            if (!info) return void 0;
            const { node, suggestedSymbol } = info;
            const target = getEmitScriptTarget(context.host.getCompilationSettings());
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange18(t, sourceFile, node, suggestedSymbol, target));
            return [
                createCodeFixAction("spelling", changes, [
                    Diagnostics.Change_spelling_to_0,
                    symbolName(suggestedSymbol)
                ], fixId23, Diagnostics.Fix_all_detected_spelling_errors)
            ];
        },
        fixIds: [
            fixId23
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes26, (changes, diag2)=>{
                const info = getInfo8(diag2.file, diag2.start, context, diag2.code);
                const target = getEmitScriptTarget(context.host.getCompilationSettings());
                if (info) doChange18(changes, context.sourceFile, info.node, info.suggestedSymbol, target);
            })
    });
    function getInfo8(sourceFile, pos, context, errorCode) {
        const node = getTokenAtPosition(sourceFile, pos);
        const parent2 = node.parent;
        if ((errorCode === Diagnostics.No_overload_matches_this_call.code || errorCode === Diagnostics.Type_0_is_not_assignable_to_type_1.code) && !isJsxAttribute(parent2)) return void 0;
        const checker = context.program.getTypeChecker();
        let suggestedSymbol;
        if (isPropertyAccessExpression(parent2) && parent2.name === node) {
            Debug.assert(isMemberName(node), "Expected an identifier for spelling (property access)");
            let containingType = checker.getTypeAtLocation(parent2.expression);
            if (parent2.flags & 64 /* OptionalChain */ ) containingType = checker.getNonNullableType(containingType);
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentProperty(node, containingType);
        } else if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 103 /* InKeyword */  && parent2.left === node && isPrivateIdentifier(node)) {
            const receiverType = checker.getTypeAtLocation(parent2.right);
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentProperty(node, receiverType);
        } else if (isQualifiedName(parent2) && parent2.right === node) {
            const symbol = checker.getSymbolAtLocation(parent2.left);
            if (symbol && symbol.flags & 1536 /* Module */ ) suggestedSymbol = checker.getSuggestedSymbolForNonexistentModule(parent2.right, symbol);
        } else if (isImportSpecifier(parent2) && parent2.name === node) {
            Debug.assertNode(node, isIdentifier, "Expected an identifier for spelling (import)");
            const importDeclaration = findAncestor(node, isImportDeclaration);
            const resolvedSourceFile = getResolvedSourceFileFromImportDeclaration(context, importDeclaration, sourceFile);
            if (resolvedSourceFile && resolvedSourceFile.symbol) suggestedSymbol = checker.getSuggestedSymbolForNonexistentModule(node, resolvedSourceFile.symbol);
        } else if (isJsxAttribute(parent2) && parent2.name === node) {
            Debug.assertNode(node, isIdentifier, "Expected an identifier for JSX attribute");
            const tag = findAncestor(node, isJsxOpeningLikeElement);
            const props = checker.getContextualTypeForArgumentAtIndex(tag, 0);
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentJSXAttribute(node, props);
        } else if (hasOverrideModifier(parent2) && isClassElement(parent2) && parent2.name === node) {
            const baseDeclaration = findAncestor(node, isClassLike);
            const baseTypeNode = baseDeclaration ? getEffectiveBaseTypeNode(baseDeclaration) : void 0;
            const baseType = baseTypeNode ? checker.getTypeAtLocation(baseTypeNode) : void 0;
            if (baseType) suggestedSymbol = checker.getSuggestedSymbolForNonexistentClassMember(getTextOfNode(node), baseType);
        } else {
            const meaning = getMeaningFromLocation(node);
            const name = getTextOfNode(node);
            Debug.assert(name !== void 0, "name should be defined");
            suggestedSymbol = checker.getSuggestedSymbolForNonexistentSymbol(node, name, convertSemanticMeaningToSymbolFlags(meaning));
        }
        return suggestedSymbol === void 0 ? void 0 : {
            node,
            suggestedSymbol
        };
    }
    function doChange18(changes, sourceFile, node, suggestedSymbol, target) {
        const suggestion = symbolName(suggestedSymbol);
        if (!isIdentifierText(suggestion, target) && isPropertyAccessExpression(node.parent)) {
            const valDecl = suggestedSymbol.valueDeclaration;
            if (valDecl && isNamedDeclaration(valDecl) && isPrivateIdentifier(valDecl.name)) changes.replaceNode(sourceFile, node, factory.createIdentifier(suggestion));
            else changes.replaceNode(sourceFile, node.parent, factory.createElementAccessExpression(node.parent.expression, factory.createStringLiteral(suggestion)));
        } else changes.replaceNode(sourceFile, node, factory.createIdentifier(suggestion));
    }
    function convertSemanticMeaningToSymbolFlags(meaning) {
        let flags = 0;
        if (meaning & 4 /* Namespace */ ) flags |= 1920 /* Namespace */ ;
        if (meaning & 2 /* Type */ ) flags |= 788968 /* Type */ ;
        if (meaning & 1 /* Value */ ) flags |= 111551 /* Value */ ;
        return flags;
    }
    function getResolvedSourceFileFromImportDeclaration(context, importDeclaration, importingFile) {
        var _a;
        if (!importDeclaration || !isStringLiteralLike(importDeclaration.moduleSpecifier)) return void 0;
        const resolvedModule = (_a = context.program.getResolvedModuleFromModuleSpecifier(importDeclaration.moduleSpecifier, importingFile)) == null ? void 0 : _a.resolvedModule;
        if (!resolvedModule) return void 0;
        return context.program.getSourceFile(resolvedModule.resolvedFileName);
    }
    // src/services/codefixes/returnValueCorrect.ts
    var fixId24 = "returnValueCorrect";
    var fixIdAddReturnStatement = "fixAddReturnStatement";
    var fixRemoveBracesFromArrowFunctionBody = "fixRemoveBracesFromArrowFunctionBody";
    var fixIdWrapTheBlockWithParen = "fixWrapTheBlockWithParen";
    var errorCodes27 = [
        Diagnostics.A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value.code,
        Diagnostics.Type_0_is_not_assignable_to_type_1.code,
        Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes27,
        fixIds: [
            fixIdAddReturnStatement,
            fixRemoveBracesFromArrowFunctionBody,
            fixIdWrapTheBlockWithParen
        ],
        getCodeActions: function getCodeActionsToCorrectReturnValue(context) {
            const { program, sourceFile, span: { start }, errorCode } = context;
            const info = getInfo9(program.getTypeChecker(), sourceFile, start, errorCode);
            if (!info) return void 0;
            if (info.kind === 0 /* MissingReturnStatement */ ) return append([
                getActionForfixAddReturnStatement(context, info.expression, info.statement)
            ], isArrowFunction(info.declaration) ? getActionForFixRemoveBracesFromArrowFunctionBody(context, info.declaration, info.expression, info.commentSource) : void 0);
            else return [
                getActionForfixWrapTheBlockWithParen(context, info.declaration, info.expression)
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes27, (changes, diag2)=>{
                const info = getInfo9(context.program.getTypeChecker(), diag2.file, diag2.start, diag2.code);
                if (!info) return void 0;
                switch(context.fixId){
                    case fixIdAddReturnStatement:
                        addReturnStatement(changes, diag2.file, info.expression, info.statement);
                        break;
                    case fixRemoveBracesFromArrowFunctionBody:
                        if (!isArrowFunction(info.declaration)) return void 0;
                        removeBlockBodyBrace(changes, diag2.file, info.declaration, info.expression, info.commentSource, /*withParen*/ false);
                        break;
                    case fixIdWrapTheBlockWithParen:
                        if (!isArrowFunction(info.declaration)) return void 0;
                        wrapBlockWithParen(changes, diag2.file, info.declaration, info.expression);
                        break;
                    default:
                        Debug.fail(JSON.stringify(context.fixId));
                }
            })
    });
    function createObjectTypeFromLabeledExpression(checker, label, expression) {
        const member = checker.createSymbol(4 /* Property */ , label.escapedText);
        member.links.type = checker.getTypeAtLocation(expression);
        const members = createSymbolTable([
            member
        ]);
        return checker.createAnonymousType(/*symbol*/ void 0, members, [], [], []);
    }
    function getFixInfo(checker, declaration, expectType, isFunctionType) {
        if (!declaration.body || !isBlock(declaration.body) || length(declaration.body.statements) !== 1) return void 0;
        const firstStatement = first(declaration.body.statements);
        if (isExpressionStatement(firstStatement) && checkFixedAssignableTo(checker, declaration, checker.getTypeAtLocation(firstStatement.expression), expectType, isFunctionType)) return {
            declaration,
            kind: 0 /* MissingReturnStatement */ ,
            expression: firstStatement.expression,
            statement: firstStatement,
            commentSource: firstStatement.expression
        };
        else if (isLabeledStatement(firstStatement) && isExpressionStatement(firstStatement.statement)) {
            const node = factory.createObjectLiteralExpression([
                factory.createPropertyAssignment(firstStatement.label, firstStatement.statement.expression)
            ]);
            const nodeType = createObjectTypeFromLabeledExpression(checker, firstStatement.label, firstStatement.statement.expression);
            if (checkFixedAssignableTo(checker, declaration, nodeType, expectType, isFunctionType)) return isArrowFunction(declaration) ? {
                declaration,
                kind: 1 /* MissingParentheses */ ,
                expression: node,
                statement: firstStatement,
                commentSource: firstStatement.statement.expression
            } : {
                declaration,
                kind: 0 /* MissingReturnStatement */ ,
                expression: node,
                statement: firstStatement,
                commentSource: firstStatement.statement.expression
            };
        } else if (isBlock(firstStatement) && length(firstStatement.statements) === 1) {
            const firstBlockStatement = first(firstStatement.statements);
            if (isLabeledStatement(firstBlockStatement) && isExpressionStatement(firstBlockStatement.statement)) {
                const node = factory.createObjectLiteralExpression([
                    factory.createPropertyAssignment(firstBlockStatement.label, firstBlockStatement.statement.expression)
                ]);
                const nodeType = createObjectTypeFromLabeledExpression(checker, firstBlockStatement.label, firstBlockStatement.statement.expression);
                if (checkFixedAssignableTo(checker, declaration, nodeType, expectType, isFunctionType)) return {
                    declaration,
                    kind: 0 /* MissingReturnStatement */ ,
                    expression: node,
                    statement: firstStatement,
                    commentSource: firstBlockStatement
                };
            }
        }
        return void 0;
    }
    function checkFixedAssignableTo(checker, declaration, exprType, type, isFunctionType) {
        if (isFunctionType) {
            const sig = checker.getSignatureFromDeclaration(declaration);
            if (sig) {
                if (hasSyntacticModifier(declaration, 1024 /* Async */ )) exprType = checker.createPromiseType(exprType);
                const newSig = checker.createSignature(declaration, sig.typeParameters, sig.thisParameter, sig.parameters, exprType, /*typePredicate*/ void 0, sig.minArgumentCount, sig.flags);
                exprType = checker.createAnonymousType(/*symbol*/ void 0, createSymbolTable(), [
                    newSig
                ], [], []);
            } else exprType = checker.getAnyType();
        }
        return checker.isTypeAssignableTo(exprType, type);
    }
    function getInfo9(checker, sourceFile, position, errorCode) {
        const node = getTokenAtPosition(sourceFile, position);
        if (!node.parent) return void 0;
        const declaration = findAncestor(node.parent, isFunctionLikeDeclaration);
        switch(errorCode){
            case Diagnostics.A_function_whose_declared_type_is_neither_undefined_void_nor_any_must_return_a_value.code:
                if (!declaration || !declaration.body || !declaration.type || !rangeContainsRange(declaration.type, node)) return void 0;
                return getFixInfo(checker, declaration, checker.getTypeFromTypeNode(declaration.type), /*isFunctionType*/ false);
            case Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code:
                if (!declaration || !isCallExpression(declaration.parent) || !declaration.body) return void 0;
                const pos = declaration.parent.arguments.indexOf(declaration);
                if (pos === -1) return void 0;
                const type = checker.getContextualTypeForArgumentAtIndex(declaration.parent, pos);
                if (!type) return void 0;
                return getFixInfo(checker, declaration, type, /*isFunctionType*/ true);
            case Diagnostics.Type_0_is_not_assignable_to_type_1.code:
                if (!isDeclarationName(node) || !isVariableLike(node.parent) && !isJsxAttribute(node.parent)) return void 0;
                const initializer = getVariableLikeInitializer(node.parent);
                if (!initializer || !isFunctionLikeDeclaration(initializer) || !initializer.body) return void 0;
                return getFixInfo(checker, initializer, checker.getTypeAtLocation(node.parent), /*isFunctionType*/ true);
        }
        return void 0;
    }
    function getVariableLikeInitializer(declaration) {
        switch(declaration.kind){
            case 261 /* VariableDeclaration */ :
            case 170 /* Parameter */ :
            case 209 /* BindingElement */ :
            case 173 /* PropertyDeclaration */ :
            case 304 /* PropertyAssignment */ :
                return declaration.initializer;
            case 292 /* JsxAttribute */ :
                return declaration.initializer && (isJsxExpression(declaration.initializer) ? declaration.initializer.expression : void 0);
            case 305 /* ShorthandPropertyAssignment */ :
            case 172 /* PropertySignature */ :
            case 307 /* EnumMember */ :
            case 349 /* JSDocPropertyTag */ :
            case 342 /* JSDocParameterTag */ :
                return void 0;
        }
    }
    function addReturnStatement(changes, sourceFile, expression, statement) {
        suppressLeadingAndTrailingTrivia(expression);
        const probablyNeedSemi = probablyUsesSemicolons(sourceFile);
        changes.replaceNode(sourceFile, statement, factory.createReturnStatement(expression), {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude,
            suffix: probablyNeedSemi ? ";" : void 0
        });
    }
    function removeBlockBodyBrace(changes, sourceFile, declaration, expression, commentSource, withParen) {
        const newBody = withParen || needsParentheses(expression) ? factory.createParenthesizedExpression(expression) : expression;
        suppressLeadingAndTrailingTrivia(commentSource);
        copyComments(commentSource, newBody);
        changes.replaceNode(sourceFile, declaration.body, newBody);
    }
    function wrapBlockWithParen(changes, sourceFile, declaration, expression) {
        changes.replaceNode(sourceFile, declaration.body, factory.createParenthesizedExpression(expression));
    }
    function getActionForfixAddReturnStatement(context, expression, statement) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addReturnStatement(t, context.sourceFile, expression, statement));
        return createCodeFixAction(fixId24, changes, Diagnostics.Add_a_return_statement, fixIdAddReturnStatement, Diagnostics.Add_all_missing_return_statement);
    }
    function getActionForFixRemoveBracesFromArrowFunctionBody(context, declaration, expression, commentSource) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>removeBlockBodyBrace(t, context.sourceFile, declaration, expression, commentSource, /*withParen*/ false));
        return createCodeFixAction(fixId24, changes, Diagnostics.Remove_braces_from_arrow_function_body, fixRemoveBracesFromArrowFunctionBody, Diagnostics.Remove_braces_from_all_arrow_function_bodies_with_relevant_issues);
    }
    function getActionForfixWrapTheBlockWithParen(context, declaration, expression) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>wrapBlockWithParen(t, context.sourceFile, declaration, expression));
        return createCodeFixAction(fixId24, changes, Diagnostics.Wrap_the_following_body_with_parentheses_which_should_be_an_object_literal, fixIdWrapTheBlockWithParen, Diagnostics.Wrap_all_object_literal_with_parentheses);
    }
    // src/services/codefixes/fixAddMissingMember.ts
    var fixMissingMember = "fixMissingMember";
    var fixMissingProperties = "fixMissingProperties";
    var fixMissingAttributes = "fixMissingAttributes";
    var fixMissingFunctionDeclaration = "fixMissingFunctionDeclaration";
    var errorCodes28 = [
        Diagnostics.Property_0_does_not_exist_on_type_1.code,
        Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
        Diagnostics.Property_0_is_missing_in_type_1_but_required_in_type_2.code,
        Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2.code,
        Diagnostics.Type_0_is_missing_the_following_properties_from_type_1_Colon_2_and_3_more.code,
        Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
        Diagnostics.Cannot_find_name_0.code,
        Diagnostics.Type_0_does_not_satisfy_the_expected_type_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes28,
        getCodeActions (context) {
            const typeChecker = context.program.getTypeChecker();
            const info = getInfo10(context.sourceFile, context.span.start, context.errorCode, typeChecker, context.program);
            if (!info) return void 0;
            if (info.kind === 3 /* ObjectLiteral */ ) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addObjectLiteralProperties(t, context, info));
                return [
                    createCodeFixAction(fixMissingProperties, changes, Diagnostics.Add_missing_properties, fixMissingProperties, Diagnostics.Add_all_missing_properties)
                ];
            }
            if (info.kind === 4 /* JsxAttributes */ ) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addJsxAttributes(t, context, info));
                return [
                    createCodeFixAction(fixMissingAttributes, changes, Diagnostics.Add_missing_attributes, fixMissingAttributes, Diagnostics.Add_all_missing_attributes)
                ];
            }
            if (info.kind === 2 /* Function */  || info.kind === 5 /* Signature */ ) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addFunctionDeclaration(t, context, info));
                return [
                    createCodeFixAction(fixMissingFunctionDeclaration, changes, [
                        Diagnostics.Add_missing_function_declaration_0,
                        info.token.text
                    ], fixMissingFunctionDeclaration, Diagnostics.Add_all_missing_function_declarations)
                ];
            }
            if (info.kind === 1 /* Enum */ ) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addEnumMemberDeclaration(t, context.program.getTypeChecker(), info));
                return [
                    createCodeFixAction(fixMissingMember, changes, [
                        Diagnostics.Add_missing_enum_member_0,
                        info.token.text
                    ], fixMissingMember, Diagnostics.Add_all_missing_members)
                ];
            }
            return concatenate(getActionsForMissingMethodDeclaration(context, info), getActionsForMissingMemberDeclaration(context, info));
        },
        fixIds: [
            fixMissingMember,
            fixMissingFunctionDeclaration,
            fixMissingProperties,
            fixMissingAttributes
        ],
        getAllCodeActions: (context)=>{
            const { program, fixId: fixId56 } = context;
            const checker = program.getTypeChecker();
            const seen = /* @__PURE__ */ new Set();
            const typeDeclToMembers = /* @__PURE__ */ new Map();
            return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                eachDiagnostic(context, errorCodes28, (diag2)=>{
                    const info = getInfo10(diag2.file, diag2.start, diag2.code, checker, context.program);
                    if (info === void 0) return;
                    const nodeId = getNodeId(info.parentDeclaration) + "#" + (info.kind === 3 /* ObjectLiteral */  ? info.identifier || getNodeId(info.token) : info.token.text);
                    if (!addToSeen(seen, nodeId)) return;
                    if (fixId56 === fixMissingFunctionDeclaration && (info.kind === 2 /* Function */  || info.kind === 5 /* Signature */ )) addFunctionDeclaration(changes, context, info);
                    else if (fixId56 === fixMissingProperties && info.kind === 3 /* ObjectLiteral */ ) addObjectLiteralProperties(changes, context, info);
                    else if (fixId56 === fixMissingAttributes && info.kind === 4 /* JsxAttributes */ ) addJsxAttributes(changes, context, info);
                    else {
                        if (info.kind === 1 /* Enum */ ) addEnumMemberDeclaration(changes, checker, info);
                        if (info.kind === 0 /* TypeLikeDeclaration */ ) {
                            const { parentDeclaration, token } = info;
                            const infos = getOrUpdate(typeDeclToMembers, parentDeclaration, ()=>[]);
                            if (!infos.some((i)=>i.token.text === token.text)) infos.push(info);
                        }
                    }
                });
                typeDeclToMembers.forEach((infos, declaration)=>{
                    const supers = isTypeLiteralNode(declaration) ? void 0 : getAllSupers(declaration, checker);
                    for (const info of infos){
                        if (supers == null ? void 0 : supers.some((superClassOrInterface)=>{
                            const superInfos = typeDeclToMembers.get(superClassOrInterface);
                            return !!superInfos && superInfos.some(({ token: token2 })=>token2.text === info.token.text);
                        })) continue;
                        const { parentDeclaration, declSourceFile, modifierFlags, token, call, isJSFile } = info;
                        if (call && !isPrivateIdentifier(token)) addMethodDeclaration(context, changes, call, token, modifierFlags & 256 /* Static */ , parentDeclaration, declSourceFile);
                        else if (isJSFile && !isInterfaceDeclaration(parentDeclaration) && !isTypeLiteralNode(parentDeclaration)) addMissingMemberInJs(changes, declSourceFile, parentDeclaration, token, !!(modifierFlags & 256 /* Static */ ));
                        else {
                            const typeNode = getTypeNode2(checker, parentDeclaration, token);
                            addPropertyDeclaration(changes, declSourceFile, parentDeclaration, token.text, typeNode, modifierFlags & 256 /* Static */ );
                        }
                    }
                });
            }));
        }
    });
    function getInfo10(sourceFile, tokenPos, errorCode, checker, program) {
        var _a, _b;
        const token = getTokenAtPosition(sourceFile, tokenPos);
        const parent2 = token.parent;
        if (errorCode === Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code) {
            if (!(token.kind === 19 /* OpenBraceToken */  && isObjectLiteralExpression(parent2) && isCallExpression(parent2.parent))) return void 0;
            const argIndex = findIndex(parent2.parent.arguments, (arg)=>arg === parent2);
            if (argIndex < 0) return void 0;
            const signature = checker.getResolvedSignature(parent2.parent);
            if (!(signature && signature.declaration && signature.parameters[argIndex])) return void 0;
            const param = signature.parameters[argIndex].valueDeclaration;
            if (!(param && isParameter(param) && isIdentifier(param.name))) return void 0;
            const properties = arrayFrom(checker.getUnmatchedProperties(checker.getTypeAtLocation(parent2), checker.getParameterType(signature, argIndex).getNonNullableType(), /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false));
            if (!length(properties)) return void 0;
            return {
                kind: 3 /* ObjectLiteral */ ,
                token: param.name,
                identifier: param.name.text,
                properties,
                parentDeclaration: parent2
            };
        }
        if (token.kind === 19 /* OpenBraceToken */  || isSatisfiesExpression(parent2) || isReturnStatement(parent2)) {
            const expression = (isSatisfiesExpression(parent2) || isReturnStatement(parent2)) && parent2.expression ? parent2.expression : parent2;
            if (isObjectLiteralExpression(expression)) {
                const targetType = isSatisfiesExpression(parent2) ? checker.getTypeFromTypeNode(parent2.type) : checker.getContextualType(expression) || checker.getTypeAtLocation(expression);
                const properties = arrayFrom(checker.getUnmatchedProperties(checker.getTypeAtLocation(parent2), targetType.getNonNullableType(), /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false));
                if (!length(properties)) return void 0;
                return {
                    kind: 3 /* ObjectLiteral */ ,
                    token: parent2,
                    identifier: void 0,
                    properties,
                    parentDeclaration: expression,
                    indentation: isReturnStatement(expression.parent) || isYieldExpression(expression.parent) ? 0 : void 0
                };
            }
        }
        if (!isMemberName(token)) return void 0;
        if (isIdentifier(token) && hasInitializer(parent2) && parent2.initializer && isObjectLiteralExpression(parent2.initializer)) {
            const targetType = (_a = checker.getContextualType(token) || checker.getTypeAtLocation(token)) == null ? void 0 : _a.getNonNullableType();
            const properties = arrayFrom(checker.getUnmatchedProperties(checker.getTypeAtLocation(parent2.initializer), targetType, /*requireOptionalProperties*/ false, /*matchDiscriminantProperties*/ false));
            if (!length(properties)) return void 0;
            return {
                kind: 3 /* ObjectLiteral */ ,
                token,
                identifier: token.text,
                properties,
                parentDeclaration: parent2.initializer
            };
        }
        if (isIdentifier(token) && isJsxOpeningLikeElement(token.parent)) {
            const target = getEmitScriptTarget(program.getCompilerOptions());
            const attributes = getUnmatchedAttributes(checker, target, token.parent);
            if (!length(attributes)) return void 0;
            return {
                kind: 4 /* JsxAttributes */ ,
                token,
                attributes,
                parentDeclaration: token.parent
            };
        }
        if (isIdentifier(token)) {
            const type = (_b = checker.getContextualType(token)) == null ? void 0 : _b.getNonNullableType();
            if (type && getObjectFlags(type) & 16 /* Anonymous */ ) {
                const signature = firstOrUndefined(checker.getSignaturesOfType(type, 0 /* Call */ ));
                if (signature === void 0) return void 0;
                return {
                    kind: 5 /* Signature */ ,
                    token,
                    signature,
                    sourceFile,
                    parentDeclaration: findScope(token)
                };
            }
            if (isCallExpression(parent2) && parent2.expression === token) return {
                kind: 2 /* Function */ ,
                token,
                call: parent2,
                sourceFile,
                modifierFlags: 0 /* None */ ,
                parentDeclaration: findScope(token)
            };
        }
        if (!isPropertyAccessExpression(parent2)) return void 0;
        const leftExpressionType = skipConstraint(checker.getTypeAtLocation(parent2.expression));
        const symbol = leftExpressionType.symbol;
        if (!symbol || !symbol.declarations) return void 0;
        if (isIdentifier(token) && isCallExpression(parent2.parent)) {
            const moduleDeclaration = find(symbol.declarations, isModuleDeclaration);
            const moduleDeclarationSourceFile = moduleDeclaration == null ? void 0 : moduleDeclaration.getSourceFile();
            if (moduleDeclaration && moduleDeclarationSourceFile && !isSourceFileFromLibrary(program, moduleDeclarationSourceFile)) return {
                kind: 2 /* Function */ ,
                token,
                call: parent2.parent,
                sourceFile: moduleDeclarationSourceFile,
                modifierFlags: 32 /* Export */ ,
                parentDeclaration: moduleDeclaration
            };
            const moduleSourceFile = find(symbol.declarations, isSourceFile);
            if (sourceFile.commonJsModuleIndicator) return void 0;
            if (moduleSourceFile && !isSourceFileFromLibrary(program, moduleSourceFile)) return {
                kind: 2 /* Function */ ,
                token,
                call: parent2.parent,
                sourceFile: moduleSourceFile,
                modifierFlags: 32 /* Export */ ,
                parentDeclaration: moduleSourceFile
            };
        }
        const classDeclaration = find(symbol.declarations, isClassLike);
        if (!classDeclaration && isPrivateIdentifier(token)) return void 0;
        const declaration = classDeclaration || find(symbol.declarations, (d)=>isInterfaceDeclaration(d) || isTypeLiteralNode(d));
        if (declaration && !isSourceFileFromLibrary(program, declaration.getSourceFile())) {
            const makeStatic = !isTypeLiteralNode(declaration) && (leftExpressionType.target || leftExpressionType) !== checker.getDeclaredTypeOfSymbol(symbol);
            if (makeStatic && (isPrivateIdentifier(token) || isInterfaceDeclaration(declaration))) return void 0;
            const declSourceFile = declaration.getSourceFile();
            const modifierFlags = isTypeLiteralNode(declaration) ? 0 /* None */  : (makeStatic ? 256 /* Static */  : 0 /* None */ ) | (startsWithUnderscore(token.text) ? 2 /* Private */  : 0 /* None */ );
            const isJSFile = isSourceFileJS(declSourceFile);
            const call = tryCast(parent2.parent, isCallExpression);
            return {
                kind: 0 /* TypeLikeDeclaration */ ,
                token,
                call,
                modifierFlags,
                parentDeclaration: declaration,
                declSourceFile,
                isJSFile
            };
        }
        const enumDeclaration = find(symbol.declarations, isEnumDeclaration);
        if (enumDeclaration && !(leftExpressionType.flags & 1056 /* EnumLike */ ) && !isPrivateIdentifier(token) && !isSourceFileFromLibrary(program, enumDeclaration.getSourceFile())) return {
            kind: 1 /* Enum */ ,
            token,
            parentDeclaration: enumDeclaration
        };
        return void 0;
    }
    function getActionsForMissingMemberDeclaration(context, info) {
        return info.isJSFile ? singleElementArray(createActionForAddMissingMemberInJavascriptFile(context, info)) : createActionsForAddMissingMemberInTypeScriptFile(context, info);
    }
    function createActionForAddMissingMemberInJavascriptFile(context, { parentDeclaration, declSourceFile, modifierFlags, token }) {
        if (isInterfaceDeclaration(parentDeclaration) || isTypeLiteralNode(parentDeclaration)) return void 0;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingMemberInJs(t, declSourceFile, parentDeclaration, token, !!(modifierFlags & 256 /* Static */ )));
        if (changes.length === 0) return void 0;
        const diagnostic = modifierFlags & 256 /* Static */  ? Diagnostics.Initialize_static_property_0 : isPrivateIdentifier(token) ? Diagnostics.Declare_a_private_field_named_0 : Diagnostics.Initialize_property_0_in_the_constructor;
        return createCodeFixAction(fixMissingMember, changes, [
            diagnostic,
            token.text
        ], fixMissingMember, Diagnostics.Add_all_missing_members);
    }
    function addMissingMemberInJs(changeTracker, sourceFile, classDeclaration, token, makeStatic) {
        const tokenName = token.text;
        if (makeStatic) {
            if (classDeclaration.kind === 232 /* ClassExpression */ ) return;
            const className = classDeclaration.name.getText();
            const staticInitialization = initializePropertyToUndefined(factory.createIdentifier(className), tokenName);
            changeTracker.insertNodeAfter(sourceFile, classDeclaration, staticInitialization);
        } else if (isPrivateIdentifier(token)) {
            const property = factory.createPropertyDeclaration(/*modifiers*/ void 0, tokenName, /*questionOrExclamationToken*/ void 0, /*type*/ void 0, /*initializer*/ void 0);
            const lastProp = getNodeToInsertPropertyAfter(classDeclaration);
            if (lastProp) changeTracker.insertNodeAfter(sourceFile, lastProp, property);
            else changeTracker.insertMemberAtStart(sourceFile, classDeclaration, property);
        } else {
            const classConstructor = getFirstConstructorWithBody(classDeclaration);
            if (!classConstructor) return;
            const propertyInitialization = initializePropertyToUndefined(factory.createThis(), tokenName);
            changeTracker.insertNodeAtConstructorEnd(sourceFile, classConstructor, propertyInitialization);
        }
    }
    function initializePropertyToUndefined(obj, propertyName) {
        return factory.createExpressionStatement(factory.createAssignment(factory.createPropertyAccessExpression(obj, propertyName), createUndefined()));
    }
    function createActionsForAddMissingMemberInTypeScriptFile(context, { parentDeclaration, declSourceFile, modifierFlags, token }) {
        const memberName = token.text;
        const isStatic2 = modifierFlags & 256 /* Static */ ;
        const typeNode = getTypeNode2(context.program.getTypeChecker(), parentDeclaration, token);
        const addPropertyDeclarationChanges = (modifierFlags2)=>ts_textChanges_exports.ChangeTracker.with(context, (t)=>addPropertyDeclaration(t, declSourceFile, parentDeclaration, memberName, typeNode, modifierFlags2));
        const actions2 = [
            createCodeFixAction(fixMissingMember, addPropertyDeclarationChanges(modifierFlags & 256 /* Static */ ), [
                isStatic2 ? Diagnostics.Declare_static_property_0 : Diagnostics.Declare_property_0,
                memberName
            ], fixMissingMember, Diagnostics.Add_all_missing_members)
        ];
        if (isStatic2 || isPrivateIdentifier(token)) return actions2;
        if (modifierFlags & 2 /* Private */ ) actions2.unshift(createCodeFixActionWithoutFixAll(fixMissingMember, addPropertyDeclarationChanges(2 /* Private */ ), [
            Diagnostics.Declare_private_property_0,
            memberName
        ]));
        actions2.push(createAddIndexSignatureAction(context, declSourceFile, parentDeclaration, token.text, typeNode));
        return actions2;
    }
    function getTypeNode2(checker, node, token) {
        let typeNode;
        if (token.parent.parent.kind === 227 /* BinaryExpression */ ) {
            const binaryExpression = token.parent.parent;
            const otherExpression = token.parent === binaryExpression.left ? binaryExpression.right : binaryExpression.left;
            const widenedType = checker.getWidenedType(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(otherExpression)));
            typeNode = checker.typeToTypeNode(widenedType, node, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ );
        } else {
            const contextualType = checker.getContextualType(token.parent);
            typeNode = contextualType ? checker.typeToTypeNode(contextualType, /*enclosingDeclaration*/ void 0, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ ) : void 0;
        }
        return typeNode || factory.createKeywordTypeNode(133 /* AnyKeyword */ );
    }
    function addPropertyDeclaration(changeTracker, sourceFile, node, tokenName, typeNode, modifierFlags) {
        const modifiers = modifierFlags ? factory.createNodeArray(factory.createModifiersFromModifierFlags(modifierFlags)) : void 0;
        const property = isClassLike(node) ? factory.createPropertyDeclaration(modifiers, tokenName, /*questionOrExclamationToken*/ void 0, typeNode, /*initializer*/ void 0) : factory.createPropertySignature(/*modifiers*/ void 0, tokenName, /*questionToken*/ void 0, typeNode);
        const lastProp = getNodeToInsertPropertyAfter(node);
        if (lastProp) changeTracker.insertNodeAfter(sourceFile, lastProp, property);
        else changeTracker.insertMemberAtStart(sourceFile, node, property);
    }
    function getNodeToInsertPropertyAfter(node) {
        let res;
        for (const member of node.members){
            if (!isPropertyDeclaration(member)) break;
            res = member;
        }
        return res;
    }
    function createAddIndexSignatureAction(context, sourceFile, node, tokenName, typeNode) {
        const stringTypeNode = factory.createKeywordTypeNode(154 /* StringKeyword */ );
        const indexingParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, "x", /*questionToken*/ void 0, stringTypeNode, /*initializer*/ void 0);
        const indexSignature = factory.createIndexSignature(/*modifiers*/ void 0, [
            indexingParameter
        ], typeNode);
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.insertMemberAtStart(sourceFile, node, indexSignature));
        return createCodeFixActionWithoutFixAll(fixMissingMember, changes, [
            Diagnostics.Add_index_signature_for_property_0,
            tokenName
        ]);
    }
    function getActionsForMissingMethodDeclaration(context, info) {
        const { parentDeclaration, declSourceFile, modifierFlags, token, call } = info;
        if (call === void 0) return void 0;
        const methodName = token.text;
        const addMethodDeclarationChanges = (modifierFlags2)=>ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMethodDeclaration(context, t, call, token, modifierFlags2, parentDeclaration, declSourceFile));
        const actions2 = [
            createCodeFixAction(fixMissingMember, addMethodDeclarationChanges(modifierFlags & 256 /* Static */ ), [
                modifierFlags & 256 /* Static */  ? Diagnostics.Declare_static_method_0 : Diagnostics.Declare_method_0,
                methodName
            ], fixMissingMember, Diagnostics.Add_all_missing_members)
        ];
        if (modifierFlags & 2 /* Private */ ) actions2.unshift(createCodeFixActionWithoutFixAll(fixMissingMember, addMethodDeclarationChanges(2 /* Private */ ), [
            Diagnostics.Declare_private_method_0,
            methodName
        ]));
        return actions2;
    }
    function addMethodDeclaration(context, changes, callExpression, name, modifierFlags, parentDeclaration, sourceFile) {
        const importAdder = createImportAdder(sourceFile, context.program, context.preferences, context.host);
        const kind = isClassLike(parentDeclaration) ? 175 /* MethodDeclaration */  : 174 /* MethodSignature */ ;
        const signatureDeclaration = createSignatureDeclarationFromCallExpression(kind, context, importAdder, callExpression, name, modifierFlags, parentDeclaration);
        const containingMethodDeclaration = tryGetContainingMethodDeclaration(parentDeclaration, callExpression);
        if (containingMethodDeclaration) changes.insertNodeAfter(sourceFile, containingMethodDeclaration, signatureDeclaration);
        else changes.insertMemberAtStart(sourceFile, parentDeclaration, signatureDeclaration);
        importAdder.writeFixes(changes);
    }
    function addEnumMemberDeclaration(changes, checker, { token, parentDeclaration }) {
        const hasStringInitializer = some(parentDeclaration.members, (member)=>{
            const type = checker.getTypeAtLocation(member);
            return !!(type && type.flags & 402653316 /* StringLike */ );
        });
        const sourceFile = parentDeclaration.getSourceFile();
        const enumMember = factory.createEnumMember(token, hasStringInitializer ? factory.createStringLiteral(token.text) : void 0);
        const last2 = lastOrUndefined(parentDeclaration.members);
        if (last2) changes.insertNodeInListAfter(sourceFile, last2, enumMember, parentDeclaration.members);
        else changes.insertMemberAtStart(sourceFile, parentDeclaration, enumMember);
    }
    function addFunctionDeclaration(changes, context, info) {
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const functionDeclaration = info.kind === 2 /* Function */  ? createSignatureDeclarationFromCallExpression(263 /* FunctionDeclaration */ , context, importAdder, info.call, idText(info.token), info.modifierFlags, info.parentDeclaration) : createSignatureDeclarationFromSignature(263 /* FunctionDeclaration */ , context, quotePreference, info.signature, createStubbedBody(Diagnostics.Function_not_implemented.message, quotePreference), info.token, /*modifiers*/ void 0, /*optional*/ void 0, /*enclosingDeclaration*/ void 0, importAdder);
        if (functionDeclaration === void 0) Debug.fail("fixMissingFunctionDeclaration codefix got unexpected error.");
        isReturnStatement(info.parentDeclaration) ? changes.insertNodeBefore(info.sourceFile, info.parentDeclaration, functionDeclaration, /*blankLineBetween*/ true) : changes.insertNodeAtEndOfScope(info.sourceFile, info.parentDeclaration, functionDeclaration);
        importAdder.writeFixes(changes);
    }
    function addJsxAttributes(changes, context, info) {
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const checker = context.program.getTypeChecker();
        const jsxAttributesNode = info.parentDeclaration.attributes;
        const hasSpreadAttribute = some(jsxAttributesNode.properties, isJsxSpreadAttribute);
        const attrs = map(info.attributes, (attr)=>{
            const value1 = tryGetValueFromType(context, checker, importAdder, quotePreference, checker.getTypeOfSymbol(attr), info.parentDeclaration);
            const name = factory.createIdentifier(attr.name);
            const jsxAttribute = factory.createJsxAttribute(name, factory.createJsxExpression(/*dotDotDotToken*/ void 0, value1));
            setParent(name, jsxAttribute);
            return jsxAttribute;
        });
        const jsxAttributes = factory.createJsxAttributes(hasSpreadAttribute ? [
            ...attrs,
            ...jsxAttributesNode.properties
        ] : [
            ...jsxAttributesNode.properties,
            ...attrs
        ]);
        const options = {
            prefix: jsxAttributesNode.pos === jsxAttributesNode.end ? " " : void 0
        };
        changes.replaceNode(context.sourceFile, jsxAttributesNode, jsxAttributes, options);
        importAdder.writeFixes(changes);
    }
    function addObjectLiteralProperties(changes, context, info) {
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const target = getEmitScriptTarget(context.program.getCompilerOptions());
        const checker = context.program.getTypeChecker();
        const props = map(info.properties, (prop)=>{
            const initializer = tryGetValueFromType(context, checker, importAdder, quotePreference, checker.getTypeOfSymbol(prop), info.parentDeclaration);
            return factory.createPropertyAssignment(createPropertyNameFromSymbol(prop, target, quotePreference, checker), initializer);
        });
        const options = {
            leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
            trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Exclude,
            indentation: info.indentation
        };
        changes.replaceNode(context.sourceFile, info.parentDeclaration, factory.createObjectLiteralExpression([
            ...info.parentDeclaration.properties,
            ...props
        ], /*multiLine*/ true), options);
        importAdder.writeFixes(changes);
    }
    function tryGetValueFromType(context, checker, importAdder, quotePreference, type, enclosingDeclaration) {
        if (type.flags & 3 /* AnyOrUnknown */ ) return createUndefined();
        if (type.flags & 134217732 /* TemplateLiteral */ ) return factory.createStringLiteral("", /* isSingleQuote */ quotePreference === 0 /* Single */ );
        if (type.flags & 8 /* Number */ ) return factory.createNumericLiteral(0);
        if (type.flags & 64 /* BigInt */ ) return factory.createBigIntLiteral("0n");
        if (type.flags & 16 /* Boolean */ ) return factory.createFalse();
        if (type.flags & 1056 /* EnumLike */ ) {
            const enumMember = type.symbol.exports ? firstOrUndefinedIterator(type.symbol.exports.values()) : type.symbol;
            const symbol = type.symbol.parent && type.symbol.parent.flags & 256 /* RegularEnum */  ? type.symbol.parent : type.symbol;
            const name = checker.symbolToExpression(symbol, 111551 /* Value */ , /*enclosingDeclaration*/ void 0, /*flags*/ 64 /* UseFullyQualifiedType */ );
            return enumMember === void 0 || name === void 0 ? factory.createNumericLiteral(0) : factory.createPropertyAccessExpression(name, checker.symbolToString(enumMember));
        }
        if (type.flags & 256 /* NumberLiteral */ ) return factory.createNumericLiteral(type.value);
        if (type.flags & 2048 /* BigIntLiteral */ ) return factory.createBigIntLiteral(type.value);
        if (type.flags & 128 /* StringLiteral */ ) return factory.createStringLiteral(type.value, /* isSingleQuote */ quotePreference === 0 /* Single */ );
        if (type.flags & 512 /* BooleanLiteral */ ) return type === checker.getFalseType() || type === checker.getFalseType(/*fresh*/ true) ? factory.createFalse() : factory.createTrue();
        if (type.flags & 65536 /* Null */ ) return factory.createNull();
        if (type.flags & 1048576 /* Union */ ) {
            const expression = firstDefined(type.types, (t)=>tryGetValueFromType(context, checker, importAdder, quotePreference, t, enclosingDeclaration));
            return expression !== null && expression !== void 0 ? expression : createUndefined();
        }
        if (checker.isArrayLikeType(type)) return factory.createArrayLiteralExpression();
        if (isObjectLiteralType(type)) {
            const props = map(checker.getPropertiesOfType(type), (prop)=>{
                const initializer = tryGetValueFromType(context, checker, importAdder, quotePreference, checker.getTypeOfSymbol(prop), enclosingDeclaration);
                return factory.createPropertyAssignment(prop.name, initializer);
            });
            return factory.createObjectLiteralExpression(props, /*multiLine*/ true);
        }
        if (getObjectFlags(type) & 16 /* Anonymous */ ) {
            const decl = find(type.symbol.declarations || emptyArray, or(isFunctionTypeNode, isMethodSignature, isMethodDeclaration));
            if (decl === void 0) return createUndefined();
            const signature = checker.getSignaturesOfType(type, 0 /* Call */ );
            if (signature === void 0) return createUndefined();
            const func = createSignatureDeclarationFromSignature(219 /* FunctionExpression */ , context, quotePreference, signature[0], createStubbedBody(Diagnostics.Function_not_implemented.message, quotePreference), /*name*/ void 0, /*modifiers*/ void 0, /*optional*/ void 0, /*enclosingDeclaration*/ enclosingDeclaration, importAdder);
            return func !== null && func !== void 0 ? func : createUndefined();
        }
        if (getObjectFlags(type) & 1 /* Class */ ) {
            const classDeclaration = getClassLikeDeclarationOfSymbol(type.symbol);
            if (classDeclaration === void 0 || hasAbstractModifier(classDeclaration)) return createUndefined();
            const constructorDeclaration = getFirstConstructorWithBody(classDeclaration);
            if (constructorDeclaration && length(constructorDeclaration.parameters)) return createUndefined();
            return factory.createNewExpression(factory.createIdentifier(type.symbol.name), /*typeArguments*/ void 0, /*argumentsArray*/ void 0);
        }
        return createUndefined();
    }
    function createUndefined() {
        return factory.createIdentifier("undefined");
    }
    function isObjectLiteralType(type) {
        return type.flags & 524288 /* Object */  && (getObjectFlags(type) & 128 /* ObjectLiteral */  || type.symbol && tryCast(singleOrUndefined(type.symbol.declarations), isTypeLiteralNode));
    }
    function getUnmatchedAttributes(checker, target, source) {
        const attrsType = checker.getContextualType(source.attributes);
        if (attrsType === void 0) return emptyArray;
        const targetProps = attrsType.getProperties();
        if (!length(targetProps)) return emptyArray;
        const seenNames = /* @__PURE__ */ new Set();
        for (const sourceProp of source.attributes.properties){
            if (isJsxAttribute(sourceProp)) seenNames.add(getEscapedTextOfJsxAttributeName(sourceProp.name));
            if (isJsxSpreadAttribute(sourceProp)) {
                const type = checker.getTypeAtLocation(sourceProp.expression);
                for (const prop of type.getProperties())seenNames.add(prop.escapedName);
            }
        }
        return filter(targetProps, (targetProp)=>isIdentifierText(targetProp.name, target, 1 /* JSX */ ) && !(targetProp.flags & 16777216 /* Optional */  || getCheckFlags(targetProp) & 48 /* Partial */  || seenNames.has(targetProp.escapedName)));
    }
    function tryGetContainingMethodDeclaration(node, callExpression) {
        if (isTypeLiteralNode(node)) return void 0;
        const declaration = findAncestor(callExpression, (n)=>isMethodDeclaration(n) || isConstructorDeclaration(n));
        return declaration && declaration.parent === node ? declaration : void 0;
    }
    function createPropertyNameFromSymbol(symbol, target, quotePreference, checker) {
        if (isTransientSymbol(symbol)) {
            const prop = checker.symbolToNode(symbol, 111551 /* Value */ , /*enclosingDeclaration*/ void 0, /*flags*/ void 0, 1 /* WriteComputedProps */ );
            if (prop && isComputedPropertyName(prop)) return prop;
        }
        return createPropertyNameNodeForIdentifierOrLiteral(symbol.name, target, quotePreference === 0 /* Single */ , /*stringNamed*/ false, /*isMethod*/ false);
    }
    function findScope(node) {
        if (findAncestor(node, isJsxExpression)) {
            const returnStatement = findAncestor(node.parent, isReturnStatement);
            if (returnStatement) return returnStatement;
        }
        return getSourceFileOfNode(node);
    }
    function getAllSupers(decl, checker) {
        const res = [];
        while(decl){
            const superElement = getClassExtendsHeritageElement(decl);
            const superSymbol = superElement && checker.getSymbolAtLocation(superElement.expression);
            if (!superSymbol) break;
            const symbol = superSymbol.flags & 2097152 /* Alias */  ? checker.getAliasedSymbol(superSymbol) : superSymbol;
            const superDecl = symbol.declarations && find(symbol.declarations, isClassLike);
            if (!superDecl) break;
            res.push(superDecl);
            decl = superDecl;
        }
        return res;
    }
    // src/services/codefixes/fixAddMissingNewOperator.ts
    var fixId25 = "addMissingNewOperator";
    var errorCodes29 = [
        Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new.code
    ];
    registerCodeFix({
        errorCodes: errorCodes29,
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingNewOperator(t, sourceFile, span));
            return [
                createCodeFixAction(fixId25, changes, Diagnostics.Add_missing_new_operator_to_call, fixId25, Diagnostics.Add_missing_new_operator_to_all_calls)
            ];
        },
        fixIds: [
            fixId25
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes29, (changes, diag2)=>addMissingNewOperator(changes, context.sourceFile, diag2))
    });
    function addMissingNewOperator(changes, sourceFile, span) {
        const call = cast(findAncestorMatchingSpan2(sourceFile, span), isCallExpression);
        const newExpression = factory.createNewExpression(call.expression, call.typeArguments, call.arguments);
        changes.replaceNode(sourceFile, call, newExpression);
    }
    function findAncestorMatchingSpan2(sourceFile, span) {
        let token = getTokenAtPosition(sourceFile, span.start);
        const end = textSpanEnd(span);
        while(token.end < end)token = token.parent;
        return token;
    }
    // src/services/codefixes/fixAddMissingParam.ts
    var addMissingParamFixId = "addMissingParam";
    var addOptionalParamFixId = "addOptionalParam";
    var errorCodes30 = [
        Diagnostics.Expected_0_arguments_but_got_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes30,
        fixIds: [
            addMissingParamFixId,
            addOptionalParamFixId
        ],
        getCodeActions (context) {
            const info = getInfo11(context.sourceFile, context.program, context.span.start);
            if (info === void 0) return void 0;
            const { name, declarations, newParameters, newOptionalParameters } = info;
            const actions2 = [];
            if (length(newParameters)) append(actions2, createCodeFixAction(addMissingParamFixId, ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange19(t, context.program, context.preferences, context.host, declarations, newParameters)), [
                length(newParameters) > 1 ? Diagnostics.Add_missing_parameters_to_0 : Diagnostics.Add_missing_parameter_to_0,
                name
            ], addMissingParamFixId, Diagnostics.Add_all_missing_parameters));
            if (length(newOptionalParameters)) append(actions2, createCodeFixAction(addOptionalParamFixId, ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange19(t, context.program, context.preferences, context.host, declarations, newOptionalParameters)), [
                length(newOptionalParameters) > 1 ? Diagnostics.Add_optional_parameters_to_0 : Diagnostics.Add_optional_parameter_to_0,
                name
            ], addOptionalParamFixId, Diagnostics.Add_all_optional_parameters));
            return actions2;
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes30, (changes, diag2)=>{
                const info = getInfo11(context.sourceFile, context.program, diag2.start);
                if (info) {
                    const { declarations, newParameters, newOptionalParameters } = info;
                    if (context.fixId === addMissingParamFixId) doChange19(changes, context.program, context.preferences, context.host, declarations, newParameters);
                    if (context.fixId === addOptionalParamFixId) doChange19(changes, context.program, context.preferences, context.host, declarations, newOptionalParameters);
                }
            })
    });
    function getInfo11(sourceFile, program, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const callExpression = findAncestor(token, isCallExpression);
        if (callExpression === void 0 || length(callExpression.arguments) === 0) return void 0;
        const checker = program.getTypeChecker();
        const type = checker.getTypeAtLocation(callExpression.expression);
        const convertibleSignatureDeclarations = filter(type.symbol.declarations, isConvertibleSignatureDeclaration);
        if (convertibleSignatureDeclarations === void 0) return void 0;
        const nonOverloadDeclaration = lastOrUndefined(convertibleSignatureDeclarations);
        if (nonOverloadDeclaration === void 0 || nonOverloadDeclaration.body === void 0 || isSourceFileFromLibrary(program, nonOverloadDeclaration.getSourceFile())) return void 0;
        const name = tryGetName2(nonOverloadDeclaration);
        if (name === void 0) return void 0;
        const newParameters = [];
        const newOptionalParameters = [];
        const parametersLength = length(nonOverloadDeclaration.parameters);
        const argumentsLength = length(callExpression.arguments);
        if (parametersLength > argumentsLength) return void 0;
        const declarations = [
            nonOverloadDeclaration,
            ...getOverloads(nonOverloadDeclaration, convertibleSignatureDeclarations)
        ];
        for(let i = 0, pos2 = 0, paramIndex = 0; i < argumentsLength; i++){
            const arg = callExpression.arguments[i];
            const expr = isAccessExpression(arg) ? getNameOfAccessExpression(arg) : arg;
            const type2 = checker.getWidenedType(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(arg)));
            const parameter = pos2 < parametersLength ? nonOverloadDeclaration.parameters[pos2] : void 0;
            if (parameter && checker.isTypeAssignableTo(type2, checker.getTypeAtLocation(parameter))) {
                pos2++;
                continue;
            }
            const name2 = expr && isIdentifier(expr) ? expr.text : `p${paramIndex++}`;
            const typeNode = typeToTypeNode(checker, type2, nonOverloadDeclaration);
            append(newParameters, {
                pos: i,
                declaration: createParameter(name2, typeNode, /*questionToken*/ void 0)
            });
            if (isOptionalPos(declarations, pos2)) continue;
            append(newOptionalParameters, {
                pos: i,
                declaration: createParameter(name2, typeNode, factory.createToken(58 /* QuestionToken */ ))
            });
        }
        return {
            newParameters,
            newOptionalParameters,
            name: declarationNameToString(name),
            declarations
        };
    }
    function tryGetName2(node) {
        const name = getNameOfDeclaration(node);
        if (name) return name;
        if (isVariableDeclaration(node.parent) && isIdentifier(node.parent.name) || isPropertyDeclaration(node.parent) || isParameter(node.parent)) return node.parent.name;
    }
    function typeToTypeNode(checker, type, enclosingDeclaration) {
        var _checker_typeToTypeNode;
        return (_checker_typeToTypeNode = checker.typeToTypeNode(checker.getWidenedType(type), enclosingDeclaration, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ )) !== null && _checker_typeToTypeNode !== void 0 ? _checker_typeToTypeNode : factory.createKeywordTypeNode(159 /* UnknownKeyword */ );
    }
    function doChange19(changes, program, preferences, host, declarations, newParameters) {
        const scriptTarget = getEmitScriptTarget(program.getCompilerOptions());
        forEach(declarations, (declaration)=>{
            const sourceFile = getSourceFileOfNode(declaration);
            const importAdder = createImportAdder(sourceFile, program, preferences, host);
            if (length(declaration.parameters)) changes.replaceNodeRangeWithNodes(sourceFile, first(declaration.parameters), last(declaration.parameters), updateParameters(importAdder, scriptTarget, declaration, newParameters), {
                joiner: ", ",
                indentation: 0,
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.IncludeAll,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            });
            else forEach(updateParameters(importAdder, scriptTarget, declaration, newParameters), (parameter, index)=>{
                if (length(declaration.parameters) === 0 && index === 0) changes.insertNodeAt(sourceFile, declaration.parameters.end, parameter);
                else changes.insertNodeAtEndOfList(sourceFile, declaration.parameters, parameter);
            });
            importAdder.writeFixes(changes);
        });
    }
    function isConvertibleSignatureDeclaration(node) {
        switch(node.kind){
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 175 /* MethodDeclaration */ :
            case 220 /* ArrowFunction */ :
                return true;
            default:
                return false;
        }
    }
    function updateParameters(importAdder, scriptTarget, node, newParameters) {
        const parameters = map(node.parameters, (p)=>factory.createParameterDeclaration(p.modifiers, p.dotDotDotToken, p.name, p.questionToken, p.type, p.initializer));
        for (const { pos, declaration } of newParameters){
            const prev = pos > 0 ? parameters[pos - 1] : void 0;
            parameters.splice(pos, 0, factory.updateParameterDeclaration(declaration, declaration.modifiers, declaration.dotDotDotToken, declaration.name, prev && prev.questionToken ? factory.createToken(58 /* QuestionToken */ ) : declaration.questionToken, getParameterType(importAdder, declaration.type, scriptTarget), declaration.initializer));
        }
        return parameters;
    }
    function getOverloads(implementation, declarations) {
        const overloads = [];
        for (const declaration of declarations)if (isOverload(declaration)) {
            if (length(declaration.parameters) === length(implementation.parameters)) {
                overloads.push(declaration);
                continue;
            }
            if (length(declaration.parameters) > length(implementation.parameters)) return [];
        }
        return overloads;
    }
    function isOverload(declaration) {
        return isConvertibleSignatureDeclaration(declaration) && declaration.body === void 0;
    }
    function createParameter(name, type, questionToken) {
        return factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, name, questionToken, type, /*initializer*/ void 0);
    }
    function isOptionalPos(declarations, pos) {
        return length(declarations) && some(declarations, (d)=>pos < length(d.parameters) && !!d.parameters[pos] && d.parameters[pos].questionToken === void 0);
    }
    function getParameterType(importAdder, typeNode, scriptTarget) {
        const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
        if (importableReference) {
            importSymbols(importAdder, importableReference.symbols);
            return importableReference.typeNode;
        }
        return typeNode;
    }
    // src/services/codefixes/fixCannotFindModule.ts
    var fixName2 = "fixCannotFindModule";
    var fixIdInstallTypesPackage = "installTypesPackage";
    var errorCodeCannotFindModule = Diagnostics.Cannot_find_module_0_or_its_corresponding_type_declarations.code;
    var errorCannotFindImplicitJsxImport = Diagnostics.This_JSX_tag_requires_the_module_path_0_to_exist_but_none_could_be_found_Make_sure_you_have_types_for_the_appropriate_package_installed.code;
    var errorCodes31 = [
        errorCodeCannotFindModule,
        Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type.code,
        errorCannotFindImplicitJsxImport
    ];
    registerCodeFix({
        errorCodes: errorCodes31,
        getCodeActions: function getCodeActionsToFixNotFoundModule(context) {
            const { host, sourceFile, span: { start }, errorCode } = context;
            const packageName = errorCode === errorCannotFindImplicitJsxImport ? getJSXImplicitImportBase(context.program.getCompilerOptions(), sourceFile) : tryGetImportedPackageName(sourceFile, start);
            if (packageName === void 0) return void 0;
            const typesPackageName = getTypesPackageNameToInstall(packageName, host, errorCode);
            return typesPackageName === void 0 ? [] : [
                createCodeFixAction(fixName2, /*changes*/ [], [
                    Diagnostics.Install_0,
                    typesPackageName
                ], fixIdInstallTypesPackage, Diagnostics.Install_all_missing_types_packages, getInstallCommand(sourceFile.fileName, typesPackageName))
            ];
        },
        fixIds: [
            fixIdInstallTypesPackage
        ],
        getAllCodeActions: (context)=>{
            return codeFixAll(context, errorCodes31, (_changes, diag2, commands)=>{
                const packageName = tryGetImportedPackageName(diag2.file, diag2.start);
                if (packageName === void 0) return void 0;
                switch(context.fixId){
                    case fixIdInstallTypesPackage:
                        {
                            const pkg = getTypesPackageNameToInstall(packageName, context.host, diag2.code);
                            if (pkg) commands.push(getInstallCommand(diag2.file.fileName, pkg));
                            break;
                        }
                    default:
                        Debug.fail(`Bad fixId: ${context.fixId}`);
                }
            });
        }
    });
    function getInstallCommand(fileName, packageName) {
        return {
            type: "install package",
            file: fileName,
            packageName
        };
    }
    function tryGetImportedPackageName(sourceFile, pos) {
        const moduleSpecifierText = tryCast(getTokenAtPosition(sourceFile, pos), isStringLiteral);
        if (!moduleSpecifierText) return void 0;
        const moduleName = moduleSpecifierText.text;
        const { packageName } = parsePackageName(moduleName);
        return isExternalModuleNameRelative(packageName) ? void 0 : packageName;
    }
    function getTypesPackageNameToInstall(packageName, host, diagCode) {
        var _a;
        return diagCode === errorCodeCannotFindModule ? nodeCoreModules.has(packageName) ? "@types/node" : void 0 : ((_a = host.isKnownTypesPackageName) == null ? void 0 : _a.call(host, packageName)) ? getTypesPackageName(packageName) : void 0;
    }
    // src/services/codefixes/fixClassDoesntImplementInheritedAbstractMember.ts
    var errorCodes32 = [
        Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2.code,
        Diagnostics.Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2.code,
        Diagnostics.Non_abstract_class_0_is_missing_implementations_for_the_following_members_of_1_Colon_2_and_3_more.code,
        Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1.code,
        Diagnostics.Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1.code,
        Diagnostics.Non_abstract_class_expression_is_missing_implementations_for_the_following_members_of_0_Colon_1_and_2_more.code
    ];
    var fixId26 = "fixClassDoesntImplementInheritedAbstractMember";
    registerCodeFix({
        errorCodes: errorCodes32,
        getCodeActions: function getCodeActionsToFixClassNotImplementingInheritedMembers(context) {
            const { sourceFile, span } = context;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addMissingMembers(getClass2(sourceFile, span.start), sourceFile, context, t, context.preferences));
            return changes.length === 0 ? void 0 : [
                createCodeFixAction(fixId26, changes, Diagnostics.Implement_inherited_abstract_class, fixId26, Diagnostics.Implement_all_inherited_abstract_classes)
            ];
        },
        fixIds: [
            fixId26
        ],
        getAllCodeActions: function getAllCodeActionsToFixClassDoesntImplementInheritedAbstractMember(context) {
            const seenClassDeclarations = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes32, (changes, diag2)=>{
                const classDeclaration = getClass2(diag2.file, diag2.start);
                if (addToSeen(seenClassDeclarations, getNodeId(classDeclaration))) addMissingMembers(classDeclaration, context.sourceFile, context, changes, context.preferences);
            });
        }
    });
    function getClass2(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        return cast(token.parent, isClassLike);
    }
    function addMissingMembers(classDeclaration, sourceFile, context, changeTracker, preferences) {
        const extendsNode = getEffectiveBaseTypeNode(classDeclaration);
        const checker = context.program.getTypeChecker();
        const instantiatedExtendsType = checker.getTypeAtLocation(extendsNode);
        const abstractAndNonPrivateExtendsSymbols = checker.getPropertiesOfType(instantiatedExtendsType).filter(symbolPointsToNonPrivateAndAbstractMember);
        const importAdder = createImportAdder(sourceFile, context.program, preferences, context.host);
        createMissingMemberNodes(classDeclaration, abstractAndNonPrivateExtendsSymbols, sourceFile, context, preferences, importAdder, (member)=>changeTracker.insertMemberAtStart(sourceFile, classDeclaration, member));
        importAdder.writeFixes(changeTracker);
    }
    function symbolPointsToNonPrivateAndAbstractMember(symbol) {
        const flags = getSyntacticModifierFlags(first(symbol.getDeclarations()));
        return !(flags & 2 /* Private */ ) && !!(flags & 64 /* Abstract */ );
    }
    // src/services/codefixes/fixClassSuperMustPrecedeThisAccess.ts
    var fixId27 = "classSuperMustPrecedeThisAccess";
    var errorCodes33 = [
        Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class.code
    ];
    registerCodeFix({
        errorCodes: errorCodes33,
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const nodes = getNodes(sourceFile, span.start);
            if (!nodes) return void 0;
            const { constructor, superCall } = nodes;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange20(t, sourceFile, constructor, superCall));
            return [
                createCodeFixAction(fixId27, changes, Diagnostics.Make_super_call_the_first_statement_in_the_constructor, fixId27, Diagnostics.Make_all_super_calls_the_first_statement_in_their_constructor)
            ];
        },
        fixIds: [
            fixId27
        ],
        getAllCodeActions (context) {
            const { sourceFile } = context;
            const seenClasses = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes33, (changes, diag2)=>{
                const nodes = getNodes(diag2.file, diag2.start);
                if (!nodes) return;
                const { constructor, superCall } = nodes;
                if (addToSeen(seenClasses, getNodeId(constructor.parent))) doChange20(changes, sourceFile, constructor, superCall);
            });
        }
    });
    function doChange20(changes, sourceFile, constructor, superCall) {
        changes.insertNodeAtConstructorStart(sourceFile, constructor, superCall);
        changes.delete(sourceFile, superCall);
    }
    function getNodes(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (token.kind !== 110 /* ThisKeyword */ ) return void 0;
        const constructor = getContainingFunction(token);
        const superCall = findSuperCall(constructor.body);
        return superCall && !superCall.expression.arguments.some((arg)=>isPropertyAccessExpression(arg) && arg.expression === token) ? {
            constructor,
            superCall
        } : void 0;
    }
    function findSuperCall(n) {
        return isExpressionStatement(n) && isSuperCall(n.expression) ? n : isFunctionLike(n) ? void 0 : forEachChild(n, findSuperCall);
    }
    // src/services/codefixes/fixConstructorForDerivedNeedSuperCall.ts
    var fixId28 = "constructorForDerivedNeedSuperCall";
    var errorCodes34 = [
        Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call.code
    ];
    registerCodeFix({
        errorCodes: errorCodes34,
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const ctr = getNode(sourceFile, span.start);
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange21(t, sourceFile, ctr));
            return [
                createCodeFixAction(fixId28, changes, Diagnostics.Add_missing_super_call, fixId28, Diagnostics.Add_all_missing_super_calls)
            ];
        },
        fixIds: [
            fixId28
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes34, (changes, diag2)=>doChange21(changes, context.sourceFile, getNode(diag2.file, diag2.start)))
    });
    function getNode(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        Debug.assert(isConstructorDeclaration(token.parent), "token should be at the constructor declaration");
        return token.parent;
    }
    function doChange21(changes, sourceFile, ctr) {
        const superCall = factory.createExpressionStatement(factory.createCallExpression(factory.createSuper(), /*typeArguments*/ void 0, /*argumentsArray*/ emptyArray));
        changes.insertNodeAtConstructorStart(sourceFile, ctr, superCall);
    }
    // src/services/codefixes/fixEnableJsxFlag.ts
    var fixID = "fixEnableJsxFlag";
    var errorCodes35 = [
        Diagnostics.Cannot_use_JSX_unless_the_jsx_flag_is_provided.code
    ];
    registerCodeFix({
        errorCodes: errorCodes35,
        getCodeActions: function getCodeActionsToFixEnableJsxFlag(context) {
            const { configFile } = context.program.getCompilerOptions();
            if (configFile === void 0) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (changeTracker)=>doChange22(changeTracker, configFile));
            return [
                createCodeFixActionWithoutFixAll(fixID, changes, Diagnostics.Enable_the_jsx_flag_in_your_configuration_file)
            ];
        },
        fixIds: [
            fixID
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes35, (changes)=>{
                const { configFile } = context.program.getCompilerOptions();
                if (configFile === void 0) return void 0;
                doChange22(changes, configFile);
            })
    });
    function doChange22(changeTracker, configFile) {
        setJsonCompilerOptionValue(changeTracker, configFile, "jsx", factory.createStringLiteral("react"));
    }
    // src/services/codefixes/fixNaNEquality.ts
    var fixId29 = "fixNaNEquality";
    var errorCodes36 = [
        Diagnostics.This_condition_will_always_return_0.code
    ];
    registerCodeFix({
        errorCodes: errorCodes36,
        getCodeActions (context) {
            const { sourceFile, span, program } = context;
            const info = getInfo12(program, sourceFile, span);
            if (info === void 0) return;
            const { suggestion, expression, arg } = info;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange23(t, sourceFile, arg, expression));
            return [
                createCodeFixAction(fixId29, changes, [
                    Diagnostics.Use_0,
                    suggestion
                ], fixId29, Diagnostics.Use_Number_isNaN_in_all_conditions)
            ];
        },
        fixIds: [
            fixId29
        ],
        getAllCodeActions: (context)=>{
            return codeFixAll(context, errorCodes36, (changes, diag2)=>{
                const info = getInfo12(context.program, diag2.file, createTextSpan(diag2.start, diag2.length));
                if (info) doChange23(changes, diag2.file, info.arg, info.expression);
            });
        }
    });
    function getInfo12(program, sourceFile, span) {
        const diag2 = find(program.getSemanticDiagnostics(sourceFile), (diag3)=>diag3.start === span.start && diag3.length === span.length);
        if (diag2 === void 0 || diag2.relatedInformation === void 0) return;
        const related = find(diag2.relatedInformation, (related2)=>related2.code === Diagnostics.Did_you_mean_0.code);
        if (related === void 0 || related.file === void 0 || related.start === void 0 || related.length === void 0) return;
        const token = findAncestorMatchingSpan(related.file, createTextSpan(related.start, related.length));
        if (token === void 0) return;
        if (isExpression(token) && isBinaryExpression(token.parent)) return {
            suggestion: getSuggestion(related.messageText),
            expression: token.parent,
            arg: token
        };
        return void 0;
    }
    function doChange23(changes, sourceFile, arg, expression) {
        const callExpression = factory.createCallExpression(factory.createPropertyAccessExpression(factory.createIdentifier("Number"), factory.createIdentifier("isNaN")), /*typeArguments*/ void 0, [
            arg
        ]);
        const operator = expression.operatorToken.kind;
        changes.replaceNode(sourceFile, expression, operator === 38 /* ExclamationEqualsEqualsToken */  || operator === 36 /* ExclamationEqualsToken */  ? factory.createPrefixUnaryExpression(54 /* ExclamationToken */ , callExpression) : callExpression);
    }
    function getSuggestion(messageText) {
        const [, suggestion] = flattenDiagnosticMessageText(messageText, "\n", 0).match(/'(.*)'/) || [];
        return suggestion;
    }
    // src/services/codefixes/fixModuleAndTargetOptions.ts
    registerCodeFix({
        errorCodes: [
            Diagnostics.Top_level_await_expressions_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher.code,
            Diagnostics.Top_level_await_using_statements_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher.code,
            Diagnostics.Top_level_for_await_loops_are_only_allowed_when_the_module_option_is_set_to_es2022_esnext_system_node16_node18_node20_nodenext_or_preserve_and_the_target_option_is_set_to_es2017_or_higher.code
        ],
        getCodeActions: function getCodeActionsToFixModuleAndTarget(context) {
            const compilerOptions = context.program.getCompilerOptions();
            const { configFile } = compilerOptions;
            if (configFile === void 0) return void 0;
            const codeFixes = [];
            const moduleKind = getEmitModuleKind(compilerOptions);
            const moduleOutOfRange = moduleKind >= 5 /* ES2015 */  && moduleKind < 99 /* ESNext */ ;
            if (moduleOutOfRange) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                    setJsonCompilerOptionValue(changes2, configFile, "module", factory.createStringLiteral("esnext"));
                });
                codeFixes.push(createCodeFixActionWithoutFixAll("fixModuleOption", changes, [
                    Diagnostics.Set_the_module_option_in_your_configuration_file_to_0,
                    "esnext"
                ]));
            }
            const target = getEmitScriptTarget(compilerOptions);
            const targetOutOfRange = target < 4 /* ES2017 */  || target > 99 /* ESNext */ ;
            if (targetOutOfRange) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (tracker)=>{
                    const configObject = getTsConfigObjectLiteralExpression(configFile);
                    if (!configObject) return;
                    const options = [
                        [
                            "target",
                            factory.createStringLiteral("es2017")
                        ]
                    ];
                    if (moduleKind === 1 /* CommonJS */ ) options.push([
                        "module",
                        factory.createStringLiteral("commonjs")
                    ]);
                    setJsonCompilerOptionValues(tracker, configFile, options);
                });
                codeFixes.push(createCodeFixActionWithoutFixAll("fixTargetOption", changes, [
                    Diagnostics.Set_the_target_option_in_your_configuration_file_to_0,
                    "es2017"
                ]));
            }
            return codeFixes.length ? codeFixes : void 0;
        }
    });
    // src/services/codefixes/fixPropertyAssignment.ts
    var fixId30 = "fixPropertyAssignment";
    var errorCodes37 = [
        Diagnostics.Did_you_mean_to_use_a_Colon_An_can_only_follow_a_property_name_when_the_containing_object_literal_is_part_of_a_destructuring_pattern.code
    ];
    registerCodeFix({
        errorCodes: errorCodes37,
        fixIds: [
            fixId30
        ],
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const property = getProperty2(sourceFile, span.start);
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange24(t, context.sourceFile, property));
            return [
                createCodeFixAction(fixId30, changes, [
                    Diagnostics.Change_0_to_1,
                    "=",
                    ":"
                ], fixId30, [
                    Diagnostics.Switch_each_misused_0_to_1,
                    "=",
                    ":"
                ])
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes37, (changes, diag2)=>doChange24(changes, diag2.file, getProperty2(diag2.file, diag2.start)))
    });
    function doChange24(changes, sourceFile, node) {
        changes.replaceNode(sourceFile, node, factory.createPropertyAssignment(node.name, node.objectAssignmentInitializer));
    }
    function getProperty2(sourceFile, pos) {
        return cast(getTokenAtPosition(sourceFile, pos).parent, isShorthandPropertyAssignment);
    }
    // src/services/codefixes/fixExtendsInterfaceBecomesImplements.ts
    var fixId31 = "extendsInterfaceBecomesImplements";
    var errorCodes38 = [
        Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements.code
    ];
    registerCodeFix({
        errorCodes: errorCodes38,
        getCodeActions (context) {
            const { sourceFile } = context;
            const nodes = getNodes2(sourceFile, context.span.start);
            if (!nodes) return void 0;
            const { extendsToken, heritageClauses } = nodes;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChanges2(t, sourceFile, extendsToken, heritageClauses));
            return [
                createCodeFixAction(fixId31, changes, Diagnostics.Change_extends_to_implements, fixId31, Diagnostics.Change_all_extended_interfaces_to_implements)
            ];
        },
        fixIds: [
            fixId31
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes38, (changes, diag2)=>{
                const nodes = getNodes2(diag2.file, diag2.start);
                if (nodes) doChanges2(changes, diag2.file, nodes.extendsToken, nodes.heritageClauses);
            })
    });
    function getNodes2(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const heritageClauses = getContainingClass(token).heritageClauses;
        const extendsToken = heritageClauses[0].getFirstToken();
        return extendsToken.kind === 96 /* ExtendsKeyword */  ? {
            extendsToken,
            heritageClauses
        } : void 0;
    }
    function doChanges2(changes, sourceFile, extendsToken, heritageClauses) {
        changes.replaceNode(sourceFile, extendsToken, factory.createToken(119 /* ImplementsKeyword */ ));
        if (heritageClauses.length === 2 && heritageClauses[0].token === 96 /* ExtendsKeyword */  && heritageClauses[1].token === 119 /* ImplementsKeyword */ ) {
            const implementsToken = heritageClauses[1].getFirstToken();
            const implementsFullStart = implementsToken.getFullStart();
            changes.replaceRange(sourceFile, {
                pos: implementsFullStart,
                end: implementsFullStart
            }, factory.createToken(28 /* CommaToken */ ));
            const text = sourceFile.text;
            let end = implementsToken.end;
            while(end < text.length && isWhiteSpaceSingleLine(text.charCodeAt(end)))end++;
            changes.deleteRange(sourceFile, {
                pos: implementsToken.getStart(),
                end
            });
        }
    }
    // src/services/codefixes/fixForgottenThisPropertyAccess.ts
    var fixId32 = "forgottenThisPropertyAccess";
    var didYouMeanStaticMemberCode = Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code;
    var errorCodes39 = [
        Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
        Diagnostics.Private_identifiers_are_only_allowed_in_class_bodies_and_may_only_be_used_as_part_of_a_class_member_declaration_property_access_or_on_the_left_hand_side_of_an_in_expression.code,
        didYouMeanStaticMemberCode
    ];
    registerCodeFix({
        errorCodes: errorCodes39,
        getCodeActions (context) {
            const { sourceFile } = context;
            const info = getInfo13(sourceFile, context.span.start, context.errorCode);
            if (!info) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange25(t, sourceFile, info));
            return [
                createCodeFixAction(fixId32, changes, [
                    Diagnostics.Add_0_to_unresolved_variable,
                    info.className || "this"
                ], fixId32, Diagnostics.Add_qualifier_to_all_unresolved_variables_matching_a_member_name)
            ];
        },
        fixIds: [
            fixId32
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes39, (changes, diag2)=>{
                const info = getInfo13(diag2.file, diag2.start, diag2.code);
                if (info) doChange25(changes, context.sourceFile, info);
            })
    });
    function getInfo13(sourceFile, pos, diagCode) {
        const node = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(node) || isPrivateIdentifier(node)) return {
            node,
            className: diagCode === didYouMeanStaticMemberCode ? getContainingClass(node).name.text : void 0
        };
    }
    function doChange25(changes, sourceFile, { node, className }) {
        suppressLeadingAndTrailingTrivia(node);
        changes.replaceNode(sourceFile, node, factory.createPropertyAccessExpression(className ? factory.createIdentifier(className) : factory.createThis(), node));
    }
    // src/services/codefixes/fixInvalidJsxCharacters.ts
    var fixIdExpression = "fixInvalidJsxCharacters_expression";
    var fixIdHtmlEntity = "fixInvalidJsxCharacters_htmlEntity";
    var errorCodes40 = [
        Diagnostics.Unexpected_token_Did_you_mean_or_gt.code,
        Diagnostics.Unexpected_token_Did_you_mean_or_rbrace.code
    ];
    registerCodeFix({
        errorCodes: errorCodes40,
        fixIds: [
            fixIdExpression,
            fixIdHtmlEntity
        ],
        getCodeActions (context) {
            const { sourceFile, preferences, span } = context;
            const changeToExpression = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange26(t, preferences, sourceFile, span.start, /*useHtmlEntity*/ false));
            const changeToHtmlEntity = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange26(t, preferences, sourceFile, span.start, /*useHtmlEntity*/ true));
            return [
                createCodeFixAction(fixIdExpression, changeToExpression, Diagnostics.Wrap_invalid_character_in_an_expression_container, fixIdExpression, Diagnostics.Wrap_all_invalid_characters_in_an_expression_container),
                createCodeFixAction(fixIdHtmlEntity, changeToHtmlEntity, Diagnostics.Convert_invalid_character_to_its_html_entity_code, fixIdHtmlEntity, Diagnostics.Convert_all_invalid_characters_to_HTML_entity_code)
            ];
        },
        getAllCodeActions (context) {
            return codeFixAll(context, errorCodes40, (changes, diagnostic)=>doChange26(changes, context.preferences, diagnostic.file, diagnostic.start, context.fixId === fixIdHtmlEntity));
        }
    });
    var htmlEntity = {
        ">": "&gt;",
        "}": "&rbrace;"
    };
    function isValidCharacter(character) {
        return hasProperty(htmlEntity, character);
    }
    function doChange26(changes, preferences, sourceFile, start, useHtmlEntity) {
        const character = sourceFile.getText()[start];
        if (!isValidCharacter(character)) return;
        const replacement = useHtmlEntity ? htmlEntity[character] : `{${quote(sourceFile, preferences, character)}}`;
        changes.replaceRangeWithText(sourceFile, {
            pos: start,
            end: start + 1
        }, replacement);
    }
    // src/services/codefixes/fixUnmatchedParameter.ts
    var deleteUnmatchedParameter = "deleteUnmatchedParameter";
    var renameUnmatchedParameter = "renameUnmatchedParameter";
    var errorCodes41 = [
        Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name.code
    ];
    registerCodeFix({
        fixIds: [
            deleteUnmatchedParameter,
            renameUnmatchedParameter
        ],
        errorCodes: errorCodes41,
        getCodeActions: function getCodeActionsToFixUnmatchedParameter(context) {
            const { sourceFile, span } = context;
            const actions2 = [];
            const info = getInfo14(sourceFile, span.start);
            if (info) {
                append(actions2, getDeleteAction(context, info));
                append(actions2, getRenameAction(context, info));
                return actions2;
            }
            return void 0;
        },
        getAllCodeActions: function getAllCodeActionsToFixUnmatchedParameter(context) {
            const tagsToSignature = /* @__PURE__ */ new Map();
            return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                eachDiagnostic(context, errorCodes41, ({ file, start })=>{
                    const info = getInfo14(file, start);
                    if (info) tagsToSignature.set(info.signature, append(tagsToSignature.get(info.signature), info.jsDocParameterTag));
                });
                tagsToSignature.forEach((tags, signature)=>{
                    if (context.fixId === deleteUnmatchedParameter) {
                        const tagsSet = new Set(tags);
                        changes.filterJSDocTags(signature.getSourceFile(), signature, (t)=>!tagsSet.has(t));
                    }
                });
            }));
        }
    });
    function getDeleteAction(context, { name, jsDocHost, jsDocParameterTag }) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (changeTracker)=>changeTracker.filterJSDocTags(context.sourceFile, jsDocHost, (t)=>t !== jsDocParameterTag));
        return createCodeFixAction(deleteUnmatchedParameter, changes, [
            Diagnostics.Delete_unused_param_tag_0,
            name.getText(context.sourceFile)
        ], deleteUnmatchedParameter, Diagnostics.Delete_all_unused_param_tags);
    }
    function getRenameAction(context, { name, jsDocHost, signature, jsDocParameterTag }) {
        if (!length(signature.parameters)) return void 0;
        const sourceFile = context.sourceFile;
        const tags = getJSDocTags(signature);
        const names = /* @__PURE__ */ new Set();
        for (const tag of tags)if (isJSDocParameterTag(tag) && isIdentifier(tag.name)) names.add(tag.name.escapedText);
        const parameterName = firstDefined(signature.parameters, (p)=>isIdentifier(p.name) && !names.has(p.name.escapedText) ? p.name.getText(sourceFile) : void 0);
        if (parameterName === void 0) return void 0;
        const newJSDocParameterTag = factory.updateJSDocParameterTag(jsDocParameterTag, jsDocParameterTag.tagName, factory.createIdentifier(parameterName), jsDocParameterTag.isBracketed, jsDocParameterTag.typeExpression, jsDocParameterTag.isNameFirst, jsDocParameterTag.comment);
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (changeTracker)=>changeTracker.replaceJSDocComment(sourceFile, jsDocHost, map(tags, (t)=>t === jsDocParameterTag ? newJSDocParameterTag : t)));
        return createCodeFixActionWithoutFixAll(renameUnmatchedParameter, changes, [
            Diagnostics.Rename_param_tag_name_0_to_1,
            name.getText(sourceFile),
            parameterName
        ]);
    }
    function getInfo14(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (token.parent && isJSDocParameterTag(token.parent) && isIdentifier(token.parent.name)) {
            const jsDocParameterTag = token.parent;
            const jsDocHost = getJSDocHost(jsDocParameterTag);
            const signature = getHostSignatureFromJSDoc(jsDocParameterTag);
            if (jsDocHost && signature) return {
                jsDocHost,
                signature,
                name: token.parent.name,
                jsDocParameterTag
            };
        }
        return void 0;
    }
    // src/services/codefixes/fixUnreferenceableDecoratorMetadata.ts
    var fixId33 = "fixUnreferenceableDecoratorMetadata";
    var errorCodes42 = [
        Diagnostics.A_type_referenced_in_a_decorated_signature_must_be_imported_with_import_type_or_a_namespace_import_when_isolatedModules_and_emitDecoratorMetadata_are_enabled.code
    ];
    registerCodeFix({
        errorCodes: errorCodes42,
        getCodeActions: (context)=>{
            const importDeclaration = getImportDeclaration(context.sourceFile, context.program, context.span.start);
            if (!importDeclaration) return;
            const namespaceChanges = ts_textChanges_exports.ChangeTracker.with(context, (t)=>importDeclaration.kind === 277 /* ImportSpecifier */  && doNamespaceImportChange(t, context.sourceFile, importDeclaration, context.program));
            const typeOnlyChanges = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doTypeOnlyImportChange(t, context.sourceFile, importDeclaration, context.program));
            let actions2;
            if (namespaceChanges.length) actions2 = append(actions2, createCodeFixActionWithoutFixAll(fixId33, namespaceChanges, Diagnostics.Convert_named_imports_to_namespace_import));
            if (typeOnlyChanges.length) actions2 = append(actions2, createCodeFixActionWithoutFixAll(fixId33, typeOnlyChanges, Diagnostics.Use_import_type));
            return actions2;
        },
        fixIds: [
            fixId33
        ]
    });
    function getImportDeclaration(sourceFile, program, start) {
        const identifier = tryCast(getTokenAtPosition(sourceFile, start), isIdentifier);
        if (!identifier || identifier.parent.kind !== 184 /* TypeReference */ ) return;
        const checker = program.getTypeChecker();
        const symbol = checker.getSymbolAtLocation(identifier);
        return find((symbol == null ? void 0 : symbol.declarations) || emptyArray, or(isImportClause, isImportSpecifier, isImportEqualsDeclaration));
    }
    function doTypeOnlyImportChange(changes, sourceFile, importDeclaration, program) {
        if (importDeclaration.kind === 272 /* ImportEqualsDeclaration */ ) {
            changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , importDeclaration.name);
            return;
        }
        const importClause = importDeclaration.kind === 274 /* ImportClause */  ? importDeclaration : importDeclaration.parent.parent;
        if (importClause.name && importClause.namedBindings) return;
        const checker = program.getTypeChecker();
        const importsValue = !!forEachImportClauseDeclaration(importClause, (decl)=>{
            if (skipAlias(decl.symbol, checker).flags & 111551 /* Value */ ) return true;
        });
        if (importsValue) return;
        changes.insertModifierBefore(sourceFile, 156 /* TypeKeyword */ , importClause);
    }
    function doNamespaceImportChange(changes, sourceFile, importDeclaration, program) {
        ts_refactor_exports.doChangeNamedToNamespaceOrDefault(sourceFile, program, changes, importDeclaration.parent);
    }
    // src/services/codefixes/fixUnusedIdentifier.ts
    var fixName3 = "unusedIdentifier";
    var fixIdPrefix = "unusedIdentifier_prefix";
    var fixIdDelete = "unusedIdentifier_delete";
    var fixIdDeleteImports = "unusedIdentifier_deleteImports";
    var fixIdInfer = "unusedIdentifier_infer";
    var errorCodes43 = [
        Diagnostics._0_is_declared_but_its_value_is_never_read.code,
        Diagnostics._0_is_declared_but_never_used.code,
        Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code,
        Diagnostics.All_imports_in_import_declaration_are_unused.code,
        Diagnostics.All_destructured_elements_are_unused.code,
        Diagnostics.All_variables_are_unused.code,
        Diagnostics.All_type_parameters_are_unused.code
    ];
    registerCodeFix({
        errorCodes: errorCodes43,
        getCodeActions (context) {
            const { errorCode, sourceFile, program, cancellationToken } = context;
            const checker = program.getTypeChecker();
            const sourceFiles = program.getSourceFiles();
            const token = getTokenAtPosition(sourceFile, context.span.start);
            if (isJSDocTemplateTag(token)) return [
                createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.delete(sourceFile, token)), Diagnostics.Remove_template_tag)
            ];
            if (token.kind === 30 /* LessThanToken */ ) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteTypeParameters(t, sourceFile, token));
                return [
                    createDeleteFix(changes, Diagnostics.Remove_type_parameters)
                ];
            }
            const importDecl = tryGetFullImport(token);
            if (importDecl) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.delete(sourceFile, importDecl));
                return [
                    createCodeFixAction(fixName3, changes, [
                        Diagnostics.Remove_import_from_0,
                        showModuleSpecifier(importDecl)
                    ], fixIdDeleteImports, Diagnostics.Delete_all_unused_imports)
                ];
            } else if (isImport(token)) {
                const deletion = ts_textChanges_exports.ChangeTracker.with(context, (t)=>tryDeleteDeclaration(sourceFile, token, t, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ false));
                if (deletion.length) return [
                    createCodeFixAction(fixName3, deletion, [
                        Diagnostics.Remove_unused_declaration_for_Colon_0,
                        token.getText(sourceFile)
                    ], fixIdDeleteImports, Diagnostics.Delete_all_unused_imports)
                ];
            }
            if (isObjectBindingPattern(token.parent) || isArrayBindingPattern(token.parent)) {
                if (isParameter(token.parent.parent)) {
                    const elements = token.parent.elements;
                    const diagnostic = [
                        elements.length > 1 ? Diagnostics.Remove_unused_declarations_for_Colon_0 : Diagnostics.Remove_unused_declaration_for_Colon_0,
                        map(elements, (e)=>e.getText(sourceFile)).join(", ")
                    ];
                    return [
                        createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteDestructuringElements(t, sourceFile, token.parent)), diagnostic)
                    ];
                }
                return [
                    createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteDestructuring(context, t, sourceFile, token.parent)), Diagnostics.Remove_unused_destructuring_declaration)
                ];
            }
            if (canDeleteEntireVariableStatement(sourceFile, token)) return [
                createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteEntireVariableStatement(t, sourceFile, token.parent)), Diagnostics.Remove_variable_statement)
            ];
            if (isIdentifier(token) && isFunctionDeclaration(token.parent)) return [
                createDeleteFix(ts_textChanges_exports.ChangeTracker.with(context, (t)=>deleteFunctionLikeDeclaration(t, sourceFile, token.parent)), [
                    Diagnostics.Remove_unused_declaration_for_Colon_0,
                    token.getText(sourceFile)
                ])
            ];
            const result = [];
            if (token.kind === 140 /* InferKeyword */ ) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>changeInferToUnknown(t, sourceFile, token));
                const name = cast(token.parent, isInferTypeNode).typeParameter.name.text;
                result.push(createCodeFixAction(fixName3, changes, [
                    Diagnostics.Replace_infer_0_with_unknown,
                    name
                ], fixIdInfer, Diagnostics.Replace_all_unused_infer_with_unknown));
            } else {
                const deletion = ts_textChanges_exports.ChangeTracker.with(context, (t)=>tryDeleteDeclaration(sourceFile, token, t, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ false));
                if (deletion.length) {
                    const name = isComputedPropertyName(token.parent) ? token.parent : token;
                    result.push(createDeleteFix(deletion, [
                        Diagnostics.Remove_unused_declaration_for_Colon_0,
                        name.getText(sourceFile)
                    ]));
                }
            }
            const prefix = ts_textChanges_exports.ChangeTracker.with(context, (t)=>tryPrefixDeclaration(t, errorCode, sourceFile, token));
            if (prefix.length) result.push(createCodeFixAction(fixName3, prefix, [
                Diagnostics.Prefix_0_with_an_underscore,
                token.getText(sourceFile)
            ], fixIdPrefix, Diagnostics.Prefix_all_unused_declarations_with_where_possible));
            return result;
        },
        fixIds: [
            fixIdPrefix,
            fixIdDelete,
            fixIdDeleteImports,
            fixIdInfer
        ],
        getAllCodeActions: (context)=>{
            const { sourceFile, program, cancellationToken } = context;
            const checker = program.getTypeChecker();
            const sourceFiles = program.getSourceFiles();
            return codeFixAll(context, errorCodes43, (changes, diag2)=>{
                const token = getTokenAtPosition(sourceFile, diag2.start);
                switch(context.fixId){
                    case fixIdPrefix:
                        tryPrefixDeclaration(changes, diag2.code, sourceFile, token);
                        break;
                    case fixIdDeleteImports:
                        {
                            const importDecl = tryGetFullImport(token);
                            if (importDecl) changes.delete(sourceFile, importDecl);
                            else if (isImport(token)) tryDeleteDeclaration(sourceFile, token, changes, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ true);
                            break;
                        }
                    case fixIdDelete:
                        if (token.kind === 140 /* InferKeyword */  || isImport(token)) break;
                        else if (isJSDocTemplateTag(token)) changes.delete(sourceFile, token);
                        else if (token.kind === 30 /* LessThanToken */ ) deleteTypeParameters(changes, sourceFile, token);
                        else if (isObjectBindingPattern(token.parent)) {
                            if (token.parent.parent.initializer) break;
                            else if (!isParameter(token.parent.parent) || isNotProvidedArguments(token.parent.parent, checker, sourceFiles)) changes.delete(sourceFile, token.parent.parent);
                        } else if (isArrayBindingPattern(token.parent.parent) && token.parent.parent.parent.initializer) break;
                        else if (canDeleteEntireVariableStatement(sourceFile, token)) deleteEntireVariableStatement(changes, sourceFile, token.parent);
                        else if (isIdentifier(token) && isFunctionDeclaration(token.parent)) deleteFunctionLikeDeclaration(changes, sourceFile, token.parent);
                        else tryDeleteDeclaration(sourceFile, token, changes, checker, sourceFiles, program, cancellationToken, /*isFixAll*/ true);
                        break;
                    case fixIdInfer:
                        if (token.kind === 140 /* InferKeyword */ ) changeInferToUnknown(changes, sourceFile, token);
                        break;
                    default:
                        Debug.fail(JSON.stringify(context.fixId));
                }
            });
        }
    });
    function changeInferToUnknown(changes, sourceFile, token) {
        changes.replaceNode(sourceFile, token.parent, factory.createKeywordTypeNode(159 /* UnknownKeyword */ ));
    }
    function createDeleteFix(changes, diag2) {
        return createCodeFixAction(fixName3, changes, diag2, fixIdDelete, Diagnostics.Delete_all_unused_declarations);
    }
    function deleteTypeParameters(changes, sourceFile, token) {
        changes.delete(sourceFile, Debug.checkDefined(cast(token.parent, isDeclarationWithTypeParameterChildren).typeParameters, "The type parameter to delete should exist"));
    }
    function isImport(token) {
        return token.kind === 102 /* ImportKeyword */  || token.kind === 80 /* Identifier */  && (token.parent.kind === 277 /* ImportSpecifier */  || token.parent.kind === 274 /* ImportClause */ );
    }
    function tryGetFullImport(token) {
        return token.kind === 102 /* ImportKeyword */  ? tryCast(token.parent, isImportDeclaration) : void 0;
    }
    function canDeleteEntireVariableStatement(sourceFile, token) {
        return isVariableDeclarationList(token.parent) && first(token.parent.getChildren(sourceFile)) === token;
    }
    function deleteEntireVariableStatement(changes, sourceFile, node) {
        changes.delete(sourceFile, node.parent.kind === 244 /* VariableStatement */  ? node.parent : node);
    }
    function deleteDestructuringElements(changes, sourceFile, node) {
        forEach(node.elements, (n)=>changes.delete(sourceFile, n));
    }
    function deleteDestructuring(context, changes, sourceFile, { parent: parent2 }) {
        if (isVariableDeclaration(parent2) && parent2.initializer && isCallLikeExpression(parent2.initializer)) {
            if (isVariableDeclarationList(parent2.parent) && length(parent2.parent.declarations) > 1) {
                const varStatement = parent2.parent.parent;
                const pos = varStatement.getStart(sourceFile);
                const end = varStatement.end;
                changes.delete(sourceFile, parent2);
                changes.insertNodeAt(sourceFile, end, parent2.initializer, {
                    prefix: getNewLineOrDefaultFromHost(context.host, context.formatContext.options) + sourceFile.text.slice(getPrecedingNonSpaceCharacterPosition(sourceFile.text, pos - 1), pos),
                    suffix: probablyUsesSemicolons(sourceFile) ? ";" : ""
                });
            } else changes.replaceNode(sourceFile, parent2.parent, parent2.initializer);
        } else changes.delete(sourceFile, parent2);
    }
    function tryPrefixDeclaration(changes, errorCode, sourceFile, token) {
        if (errorCode === Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code) return;
        if (token.kind === 140 /* InferKeyword */ ) token = cast(token.parent, isInferTypeNode).typeParameter.name;
        if (isIdentifier(token) && canPrefix(token)) {
            changes.replaceNode(sourceFile, token, factory.createIdentifier(`_${token.text}`));
            if (isParameter(token.parent)) getJSDocParameterTags(token.parent).forEach((tag)=>{
                if (isIdentifier(tag.name)) changes.replaceNode(sourceFile, tag.name, factory.createIdentifier(`_${tag.name.text}`));
            });
        }
    }
    function canPrefix(token) {
        switch(token.parent.kind){
            case 170 /* Parameter */ :
            case 169 /* TypeParameter */ :
                return true;
            case 261 /* VariableDeclaration */ :
                {
                    const varDecl = token.parent;
                    switch(varDecl.parent.parent.kind){
                        case 251 /* ForOfStatement */ :
                        case 250 /* ForInStatement */ :
                            return true;
                    }
                }
        }
        return false;
    }
    function tryDeleteDeclaration(sourceFile, token, changes, checker, sourceFiles, program, cancellationToken, isFixAll) {
        tryDeleteDeclarationWorker(token, changes, sourceFile, checker, sourceFiles, program, cancellationToken, isFixAll);
        if (isIdentifier(token)) ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(token, checker, sourceFile, (ref)=>{
            if (isPropertyAccessExpression(ref.parent) && ref.parent.name === ref) ref = ref.parent;
            if (!isFixAll && mayDeleteExpression(ref)) changes.delete(sourceFile, ref.parent.parent);
        });
    }
    function tryDeleteDeclarationWorker(token, changes, sourceFile, checker, sourceFiles, program, cancellationToken, isFixAll) {
        const { parent: parent2 } = token;
        if (isParameter(parent2)) tryDeleteParameter(changes, sourceFile, parent2, checker, sourceFiles, program, cancellationToken, isFixAll);
        else if (!(isFixAll && isIdentifier(token) && ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(token, checker, sourceFile))) {
            const node = isImportClause(parent2) ? token : isComputedPropertyName(parent2) ? parent2.parent : parent2;
            Debug.assert(node !== sourceFile, "should not delete whole source file");
            changes.delete(sourceFile, node);
        }
    }
    function tryDeleteParameter(changes, sourceFile, parameter, checker, sourceFiles, program, cancellationToken, isFixAll = false) {
        if (mayDeleteParameter(checker, sourceFile, parameter, sourceFiles, program, cancellationToken, isFixAll)) {
            if (parameter.modifiers && parameter.modifiers.length > 0 && (!isIdentifier(parameter.name) || ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(parameter.name, checker, sourceFile))) {
                for (const modifier of parameter.modifiers)if (isModifier(modifier)) changes.deleteModifier(sourceFile, modifier);
            } else if (!parameter.initializer && isNotProvidedArguments(parameter, checker, sourceFiles)) changes.delete(sourceFile, parameter);
        }
    }
    function isNotProvidedArguments(parameter, checker, sourceFiles) {
        const index = parameter.parent.parameters.indexOf(parameter);
        return !ts_FindAllReferences_exports.Core.someSignatureUsage(parameter.parent, sourceFiles, checker, (_, call)=>!call || call.arguments.length > index);
    }
    function mayDeleteParameter(checker, sourceFile, parameter, sourceFiles, program, cancellationToken, isFixAll) {
        const { parent: parent2 } = parameter;
        switch(parent2.kind){
            case 175 /* MethodDeclaration */ :
            case 177 /* Constructor */ :
                const index = parent2.parameters.indexOf(parameter);
                const referent = isMethodDeclaration(parent2) ? parent2.name : parent2;
                const entries = ts_FindAllReferences_exports.Core.getReferencedSymbolsForNode(parent2.pos, referent, program, sourceFiles, cancellationToken);
                if (entries) for (const entry of entries){
                    for (const reference of entry.references)if (reference.kind === ts_FindAllReferences_exports.EntryKind.Node) {
                        const isSuperCall2 = isSuperKeyword(reference.node) && isCallExpression(reference.node.parent) && reference.node.parent.arguments.length > index;
                        const isSuperMethodCall = isPropertyAccessExpression(reference.node.parent) && isSuperKeyword(reference.node.parent.expression) && isCallExpression(reference.node.parent.parent) && reference.node.parent.parent.arguments.length > index;
                        const isOverriddenMethod = (isMethodDeclaration(reference.node.parent) || isMethodSignature(reference.node.parent)) && reference.node.parent !== parameter.parent && reference.node.parent.parameters.length > index;
                        if (isSuperCall2 || isSuperMethodCall || isOverriddenMethod) return false;
                    }
                }
                return true;
            case 263 /* FunctionDeclaration */ :
                if (parent2.name && isCallbackLike(checker, sourceFile, parent2.name)) return isLastParameter(parent2, parameter, isFixAll);
                return true;
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return isLastParameter(parent2, parameter, isFixAll);
            case 179 /* SetAccessor */ :
                return false;
            case 178 /* GetAccessor */ :
                return true;
            default:
                return Debug.failBadSyntaxKind(parent2);
        }
    }
    function isCallbackLike(checker, sourceFile, name) {
        return !!ts_FindAllReferences_exports.Core.eachSymbolReferenceInFile(name, checker, sourceFile, (reference)=>isIdentifier(reference) && isCallExpression(reference.parent) && reference.parent.arguments.includes(reference));
    }
    function isLastParameter(func, parameter, isFixAll) {
        const parameters = func.parameters;
        const index = parameters.indexOf(parameter);
        Debug.assert(index !== -1, "The parameter should already be in the list");
        return isFixAll ? parameters.slice(index + 1).every((p)=>isIdentifier(p.name) && !p.symbol.isReferenced) : index === parameters.length - 1;
    }
    function mayDeleteExpression(node) {
        return (isBinaryExpression(node.parent) && node.parent.left === node || (isPostfixUnaryExpression(node.parent) || isPrefixUnaryExpression(node.parent)) && node.parent.operand === node) && isExpressionStatement(node.parent.parent);
    }
    function deleteFunctionLikeDeclaration(changes, sourceFile, node) {
        const declarations = node.symbol.declarations;
        if (declarations) for (const declaration of declarations)changes.delete(sourceFile, declaration);
    }
    // src/services/codefixes/fixUnreachableCode.ts
    var fixId34 = "fixUnreachableCode";
    var errorCodes44 = [
        Diagnostics.Unreachable_code_detected.code
    ];
    registerCodeFix({
        errorCodes: errorCodes44,
        getCodeActions (context) {
            const syntacticDiagnostics = context.program.getSyntacticDiagnostics(context.sourceFile, context.cancellationToken);
            if (syntacticDiagnostics.length) return;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange27(t, context.sourceFile, context.span.start, context.span.length, context.errorCode));
            return [
                createCodeFixAction(fixId34, changes, Diagnostics.Remove_unreachable_code, fixId34, Diagnostics.Remove_all_unreachable_code)
            ];
        },
        fixIds: [
            fixId34
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes44, (changes, diag2)=>doChange27(changes, diag2.file, diag2.start, diag2.length, diag2.code))
    });
    function doChange27(changes, sourceFile, start, length2, errorCode) {
        const token = getTokenAtPosition(sourceFile, start);
        const statement = findAncestor(token, isStatement);
        if (statement.getStart(sourceFile) !== token.getStart(sourceFile)) {
            const logData = JSON.stringify({
                statementKind: Debug.formatSyntaxKind(statement.kind),
                tokenKind: Debug.formatSyntaxKind(token.kind),
                errorCode,
                start,
                length: length2
            });
            Debug.fail("Token and statement should start at the same point. " + logData);
        }
        const container = (isBlock(statement.parent) ? statement.parent : statement).parent;
        if (!isBlock(statement.parent) || statement === first(statement.parent.statements)) switch(container.kind){
            case 246 /* IfStatement */ :
                if (container.elseStatement) {
                    if (isBlock(statement.parent)) break;
                    else changes.replaceNode(sourceFile, statement, factory.createBlock(emptyArray));
                    return;
                }
            // falls through
            case 248 /* WhileStatement */ :
            case 249 /* ForStatement */ :
                changes.delete(sourceFile, container);
                return;
        }
        if (isBlock(statement.parent)) {
            const end = start + length2;
            const lastStatement = Debug.checkDefined(lastWhere(sliceAfter(statement.parent.statements, statement), (s)=>s.pos < end), "Some statement should be last");
            changes.deleteNodeRange(sourceFile, statement, lastStatement);
        } else changes.delete(sourceFile, statement);
    }
    function lastWhere(a, pred) {
        let last2;
        for (const value1 of a){
            if (!pred(value1)) break;
            last2 = value1;
        }
        return last2;
    }
    // src/services/codefixes/fixUnusedLabel.ts
    var fixId35 = "fixUnusedLabel";
    var errorCodes45 = [
        Diagnostics.Unused_label.code
    ];
    registerCodeFix({
        errorCodes: errorCodes45,
        getCodeActions (context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange28(t, context.sourceFile, context.span.start));
            return [
                createCodeFixAction(fixId35, changes, Diagnostics.Remove_unused_label, fixId35, Diagnostics.Remove_all_unused_labels)
            ];
        },
        fixIds: [
            fixId35
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes45, (changes, diag2)=>doChange28(changes, diag2.file, diag2.start))
    });
    function doChange28(changes, sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        const labeledStatement = cast(token.parent, isLabeledStatement);
        const pos = token.getStart(sourceFile);
        const statementPos = labeledStatement.statement.getStart(sourceFile);
        const end = positionsAreOnSameLine(pos, statementPos, sourceFile) ? statementPos : skipTrivia(sourceFile.text, findChildOfKind(labeledStatement, 59 /* ColonToken */ , sourceFile).end, /*stopAfterLineBreak*/ true);
        changes.deleteRange(sourceFile, {
            pos,
            end
        });
    }
    // src/services/codefixes/fixJSDocTypes.ts
    var fixIdPlain = "fixJSDocTypes_plain";
    var fixIdNullable = "fixJSDocTypes_nullable";
    var errorCodes46 = [
        Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments.code,
        Diagnostics._0_at_the_end_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1.code,
        Diagnostics._0_at_the_start_of_a_type_is_not_valid_TypeScript_syntax_Did_you_mean_to_write_1.code
    ];
    registerCodeFix({
        errorCodes: errorCodes46,
        getCodeActions (context) {
            const { sourceFile } = context;
            const checker = context.program.getTypeChecker();
            const info = getInfo15(sourceFile, context.span.start, checker);
            if (!info) return void 0;
            const { typeNode, type } = info;
            const original = typeNode.getText(sourceFile);
            const actions2 = [
                fix(type, fixIdPlain, Diagnostics.Change_all_jsdoc_style_types_to_TypeScript)
            ];
            if (typeNode.kind === 315 /* JSDocNullableType */ ) actions2.push(fix(type, fixIdNullable, Diagnostics.Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types));
            return actions2;
            function fix(type2, fixId56, fixAllDescription) {
                const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange29(t, sourceFile, typeNode, type2, checker));
                return createCodeFixAction("jdocTypes", changes, [
                    Diagnostics.Change_0_to_1,
                    original,
                    checker.typeToString(type2)
                ], fixId56, fixAllDescription);
            }
        },
        fixIds: [
            fixIdPlain,
            fixIdNullable
        ],
        getAllCodeActions (context) {
            const { fixId: fixId56, program, sourceFile } = context;
            const checker = program.getTypeChecker();
            return codeFixAll(context, errorCodes46, (changes, err)=>{
                const info = getInfo15(err.file, err.start, checker);
                if (!info) return;
                const { typeNode, type } = info;
                const fixedType = typeNode.kind === 315 /* JSDocNullableType */  && fixId56 === fixIdNullable ? checker.getNullableType(type, 32768 /* Undefined */ ) : type;
                doChange29(changes, sourceFile, typeNode, fixedType, checker);
            });
        }
    });
    function doChange29(changes, sourceFile, oldTypeNode, newType, checker) {
        changes.replaceNode(sourceFile, oldTypeNode, checker.typeToTypeNode(newType, /*enclosingDeclaration*/ oldTypeNode, /*flags*/ void 0));
    }
    function getInfo15(sourceFile, pos, checker) {
        const decl = findAncestor(getTokenAtPosition(sourceFile, pos), isTypeContainer);
        const typeNode = decl && decl.type;
        return typeNode && {
            typeNode,
            type: getType(checker, typeNode)
        };
    }
    function isTypeContainer(node) {
        switch(node.kind){
            case 235 /* AsExpression */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 263 /* FunctionDeclaration */ :
            case 178 /* GetAccessor */ :
            case 182 /* IndexSignature */ :
            case 201 /* MappedType */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 170 /* Parameter */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
            case 179 /* SetAccessor */ :
            case 266 /* TypeAliasDeclaration */ :
            case 217 /* TypeAssertionExpression */ :
            case 261 /* VariableDeclaration */ :
                return true;
            default:
                return false;
        }
    }
    function getType(checker, node) {
        if (isJSDocNullableType(node)) {
            const type = checker.getTypeFromTypeNode(node.type);
            if (type === checker.getNeverType() || type === checker.getVoidType()) return type;
            return checker.getUnionType(append([
                type,
                checker.getUndefinedType()
            ], node.postfix ? void 0 : checker.getNullType()));
        }
        return checker.getTypeFromTypeNode(node);
    }
    // src/services/codefixes/fixMissingCallParentheses.ts
    var fixId36 = "fixMissingCallParentheses";
    var errorCodes47 = [
        Diagnostics.This_condition_will_always_return_true_since_this_function_is_always_defined_Did_you_mean_to_call_it_instead.code
    ];
    registerCodeFix({
        errorCodes: errorCodes47,
        fixIds: [
            fixId36
        ],
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const callName = getCallName(sourceFile, span.start);
            if (!callName) return;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange30(t, context.sourceFile, callName));
            return [
                createCodeFixAction(fixId36, changes, Diagnostics.Add_missing_call_parentheses, fixId36, Diagnostics.Add_all_missing_call_parentheses)
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes47, (changes, diag2)=>{
                const callName = getCallName(diag2.file, diag2.start);
                if (callName) doChange30(changes, diag2.file, callName);
            })
    });
    function doChange30(changes, sourceFile, name) {
        changes.replaceNodeWithText(sourceFile, name, `${name.text}()`);
    }
    function getCallName(sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        if (isPropertyAccessExpression(token.parent)) {
            let current = token.parent;
            while(isPropertyAccessExpression(current.parent))current = current.parent;
            return current.name;
        }
        if (isIdentifier(token)) return token;
        return void 0;
    }
    // src/services/codefixes/fixMissingTypeAnnotationOnExports.ts
    var fixId37 = "fixMissingTypeAnnotationOnExports";
    var addAnnotationFix = "add-annotation";
    var addInlineTypeAssertion = "add-type-assertion";
    var extractExpression = "extract-expression";
    var errorCodes48 = [
        Diagnostics.Function_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations.code,
        Diagnostics.Method_must_have_an_explicit_return_type_annotation_with_isolatedDeclarations.code,
        Diagnostics.At_least_one_accessor_must_have_an_explicit_type_annotation_with_isolatedDeclarations.code,
        Diagnostics.Variable_must_have_an_explicit_type_annotation_with_isolatedDeclarations.code,
        Diagnostics.Parameter_must_have_an_explicit_type_annotation_with_isolatedDeclarations.code,
        Diagnostics.Property_must_have_an_explicit_type_annotation_with_isolatedDeclarations.code,
        Diagnostics.Expression_type_can_t_be_inferred_with_isolatedDeclarations.code,
        Diagnostics.Binding_elements_can_t_be_exported_directly_with_isolatedDeclarations.code,
        Diagnostics.Computed_property_names_on_class_or_object_literals_cannot_be_inferred_with_isolatedDeclarations.code,
        Diagnostics.Computed_properties_must_be_number_or_string_literals_variables_or_dotted_expressions_with_isolatedDeclarations.code,
        Diagnostics.Enum_member_initializers_must_be_computable_without_references_to_external_symbols_with_isolatedDeclarations.code,
        Diagnostics.Extends_clause_can_t_contain_an_expression_with_isolatedDeclarations.code,
        Diagnostics.Objects_that_contain_shorthand_properties_can_t_be_inferred_with_isolatedDeclarations.code,
        Diagnostics.Objects_that_contain_spread_assignments_can_t_be_inferred_with_isolatedDeclarations.code,
        Diagnostics.Arrays_with_spread_elements_can_t_inferred_with_isolatedDeclarations.code,
        Diagnostics.Default_exports_can_t_be_inferred_with_isolatedDeclarations.code,
        Diagnostics.Only_const_arrays_can_be_inferred_with_isolatedDeclarations.code,
        Diagnostics.Assigning_properties_to_functions_without_declaring_them_is_not_supported_with_isolatedDeclarations_Add_an_explicit_declaration_for_the_properties_assigned_to_this_function.code,
        Diagnostics.Declaration_emit_for_this_parameter_requires_implicitly_adding_undefined_to_its_type_This_is_not_supported_with_isolatedDeclarations.code,
        Diagnostics.Type_containing_private_name_0_can_t_be_used_with_isolatedDeclarations.code,
        Diagnostics.Add_satisfies_and_a_type_assertion_to_this_expression_satisfies_T_as_T_to_make_the_type_explicit.code
    ];
    var canHaveTypeAnnotation = /* @__PURE__ */ new Set([
        178 /* GetAccessor */ ,
        175 /* MethodDeclaration */ ,
        173 /* PropertyDeclaration */ ,
        263 /* FunctionDeclaration */ ,
        219 /* FunctionExpression */ ,
        220 /* ArrowFunction */ ,
        261 /* VariableDeclaration */ ,
        170 /* Parameter */ ,
        278 /* ExportAssignment */ ,
        264 /* ClassDeclaration */ ,
        207 /* ObjectBindingPattern */ ,
        208 /* ArrayBindingPattern */ 
    ]);
    var declarationEmitNodeBuilderFlags2 = 531469 /* NoTruncation */ ;
    var declarationEmitInternalNodeBuilderFlags2 = 1 /* WriteComputedProps */ ;
    registerCodeFix({
        errorCodes: errorCodes48,
        fixIds: [
            fixId37
        ],
        getCodeActions (context) {
            const fixes = [];
            addCodeAction(addAnnotationFix, fixes, context, 0 /* Full */ , (f)=>f.addTypeAnnotation(context.span));
            addCodeAction(addAnnotationFix, fixes, context, 1 /* Relative */ , (f)=>f.addTypeAnnotation(context.span));
            addCodeAction(addAnnotationFix, fixes, context, 2 /* Widened */ , (f)=>f.addTypeAnnotation(context.span));
            addCodeAction(addInlineTypeAssertion, fixes, context, 0 /* Full */ , (f)=>f.addInlineAssertion(context.span));
            addCodeAction(addInlineTypeAssertion, fixes, context, 1 /* Relative */ , (f)=>f.addInlineAssertion(context.span));
            addCodeAction(addInlineTypeAssertion, fixes, context, 2 /* Widened */ , (f)=>f.addInlineAssertion(context.span));
            addCodeAction(extractExpression, fixes, context, 0 /* Full */ , (f)=>f.extractAsVariable(context.span));
            return fixes;
        },
        getAllCodeActions: (context)=>{
            const changes = withContext(context, 0 /* Full */ , (f)=>{
                eachDiagnostic(context, errorCodes48, (diag2)=>{
                    f.addTypeAnnotation(diag2);
                });
            });
            return createCombinedCodeActions(changes.textChanges);
        }
    });
    function addCodeAction(fixName8, fixes, context, typePrintMode, cb) {
        const changes = withContext(context, typePrintMode, cb);
        if (changes.result && changes.textChanges.length) fixes.push(createCodeFixAction(fixName8, changes.textChanges, changes.result, fixId37, Diagnostics.Add_all_missing_type_annotations));
    }
    function withContext(context, typePrintMode, cb) {
        const emptyInferenceResult = {
            typeNode: void 0,
            mutatedTarget: false
        };
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        const sourceFile = context.sourceFile;
        const program = context.program;
        const typeChecker = program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(program.getCompilerOptions());
        const importAdder = createImportAdder(context.sourceFile, context.program, context.preferences, context.host);
        const fixedNodes = /* @__PURE__ */ new Set();
        const expandoPropertiesAdded = /* @__PURE__ */ new Set();
        const typePrinter = createPrinter({
            preserveSourceNewlines: false
        });
        const result = cb({
            addTypeAnnotation,
            addInlineAssertion,
            extractAsVariable
        });
        importAdder.writeFixes(changeTracker);
        var ExpressionType2;
        return {
            result,
            textChanges: changeTracker.getChanges()
        };
        function addTypeAnnotation(span) {
            context.cancellationToken.throwIfCancellationRequested();
            const nodeWithDiag = getTokenAtPosition(sourceFile, span.start);
            const expandoFunction = findExpandoFunction(nodeWithDiag);
            if (expandoFunction) {
                if (isFunctionDeclaration(expandoFunction)) return createNamespaceForExpandoProperties(expandoFunction);
                return fixIsolatedDeclarationError(expandoFunction);
            }
            const nodeMissingType = findAncestorWithMissingType(nodeWithDiag);
            if (nodeMissingType) return fixIsolatedDeclarationError(nodeMissingType);
            return void 0;
        }
        function createNamespaceForExpandoProperties(expandoFunc) {
            var _a;
            if (expandoPropertiesAdded == null ? void 0 : expandoPropertiesAdded.has(expandoFunc)) return void 0;
            expandoPropertiesAdded == null || expandoPropertiesAdded.add(expandoFunc);
            const type = typeChecker.getTypeAtLocation(expandoFunc);
            const elements = typeChecker.getPropertiesOfType(type);
            if (!expandoFunc.name || elements.length === 0) return void 0;
            const newProperties = [];
            for (const symbol of elements){
                if (!isIdentifierText(symbol.name, getEmitScriptTarget(program.getCompilerOptions()))) continue;
                if (symbol.valueDeclaration && isVariableDeclaration(symbol.valueDeclaration)) continue;
                newProperties.push(factory.createVariableStatement([
                    factory.createModifier(95 /* ExportKeyword */ )
                ], factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(symbol.name, /*exclamationToken*/ void 0, typeToTypeNode2(typeChecker.getTypeOfSymbol(symbol), expandoFunc), /*initializer*/ void 0)
                ])));
            }
            if (newProperties.length === 0) return void 0;
            const modifiers = [];
            if ((_a = expandoFunc.modifiers) == null ? void 0 : _a.some((modifier)=>modifier.kind === 95 /* ExportKeyword */ )) modifiers.push(factory.createModifier(95 /* ExportKeyword */ ));
            modifiers.push(factory.createModifier(138 /* DeclareKeyword */ ));
            const namespace = factory.createModuleDeclaration(modifiers, expandoFunc.name, factory.createModuleBlock(newProperties), /*flags*/ 101441696 /* ContextFlags */ );
            changeTracker.insertNodeAfter(sourceFile, expandoFunc, namespace);
            return [
                Diagnostics.Annotate_types_of_properties_expando_function_in_a_namespace
            ];
        }
        function needsParenthesizedExpressionForAssertion(node) {
            return !isEntityNameExpression(node) && !isCallExpression(node) && !isObjectLiteralExpression(node) && !isArrayLiteralExpression(node);
        }
        function createAsExpression(node, type) {
            if (needsParenthesizedExpressionForAssertion(node)) node = factory.createParenthesizedExpression(node);
            return factory.createAsExpression(node, type);
        }
        function createSatisfiesAsExpression(node, type) {
            if (needsParenthesizedExpressionForAssertion(node)) node = factory.createParenthesizedExpression(node);
            return factory.createAsExpression(factory.createSatisfiesExpression(node, getSynthesizedDeepClone(type)), type);
        }
        function addInlineAssertion(span) {
            context.cancellationToken.throwIfCancellationRequested();
            const nodeWithDiag = getTokenAtPosition(sourceFile, span.start);
            const expandoFunction = findExpandoFunction(nodeWithDiag);
            if (expandoFunction) return;
            const targetNode = findBestFittingNode(nodeWithDiag, span);
            if (!targetNode || isValueSignatureDeclaration(targetNode) || isValueSignatureDeclaration(targetNode.parent)) return;
            const isExpressionTarget = isExpression(targetNode);
            const isShorthandPropertyAssignmentTarget = isShorthandPropertyAssignment(targetNode);
            if (!isShorthandPropertyAssignmentTarget && isDeclaration(targetNode)) return void 0;
            if (findAncestor(targetNode, isBindingPattern)) return void 0;
            if (findAncestor(targetNode, isEnumMember)) return void 0;
            if (isExpressionTarget && (findAncestor(targetNode, isHeritageClause) || findAncestor(targetNode, isTypeNode))) return void 0;
            if (isSpreadElement(targetNode)) return void 0;
            const variableDeclaration = findAncestor(targetNode, isVariableDeclaration);
            const type = variableDeclaration && typeChecker.getTypeAtLocation(variableDeclaration);
            if (type && type.flags & 8192 /* UniqueESSymbol */ ) return void 0;
            if (!(isExpressionTarget || isShorthandPropertyAssignmentTarget)) return void 0;
            const { typeNode, mutatedTarget } = inferType(targetNode, type);
            if (!typeNode || mutatedTarget) return void 0;
            if (isShorthandPropertyAssignmentTarget) changeTracker.insertNodeAt(sourceFile, targetNode.end, createAsExpression(getSynthesizedDeepClone(targetNode.name), typeNode), {
                prefix: ": "
            });
            else if (isExpressionTarget) changeTracker.replaceNode(sourceFile, targetNode, createSatisfiesAsExpression(getSynthesizedDeepClone(targetNode), typeNode));
            else Debug.assertNever(targetNode);
            return [
                Diagnostics.Add_satisfies_and_an_inline_type_assertion_with_0,
                typeToStringForDiag(typeNode)
            ];
        }
        function extractAsVariable(span) {
            context.cancellationToken.throwIfCancellationRequested();
            const nodeWithDiag = getTokenAtPosition(sourceFile, span.start);
            const targetNode = findBestFittingNode(nodeWithDiag, span);
            if (!targetNode || isValueSignatureDeclaration(targetNode) || isValueSignatureDeclaration(targetNode.parent)) return;
            const isExpressionTarget = isExpression(targetNode);
            if (!isExpressionTarget) return;
            if (isArrayLiteralExpression(targetNode)) {
                changeTracker.replaceNode(sourceFile, targetNode, createAsExpression(targetNode, factory.createTypeReferenceNode("const")));
                return [
                    Diagnostics.Mark_array_literal_as_const
                ];
            }
            const parentPropertyAssignment = findAncestor(targetNode, isPropertyAssignment);
            if (parentPropertyAssignment) {
                if (parentPropertyAssignment === targetNode.parent && isEntityNameExpression(targetNode)) return;
                const tempName = factory.createUniqueName(getIdentifierForNode(targetNode, sourceFile, typeChecker, sourceFile), 16 /* Optimistic */ );
                let replacementTarget = targetNode;
                let initializationNode = targetNode;
                if (isSpreadElement(replacementTarget)) {
                    replacementTarget = walkUpParenthesizedExpressions(replacementTarget.parent);
                    if (isConstAssertion2(replacementTarget.parent)) initializationNode = replacementTarget = replacementTarget.parent;
                    else initializationNode = createAsExpression(replacementTarget, factory.createTypeReferenceNode("const"));
                }
                if (isEntityNameExpression(replacementTarget)) return void 0;
                const variableDefinition = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(tempName, /*exclamationToken*/ void 0, /*type*/ void 0, initializationNode)
                ], 2 /* Const */ ));
                const statement = findAncestor(targetNode, isStatement);
                changeTracker.insertNodeBefore(sourceFile, statement, variableDefinition);
                changeTracker.replaceNode(sourceFile, replacementTarget, factory.createAsExpression(factory.cloneNode(tempName), factory.createTypeQueryNode(factory.cloneNode(tempName))));
                return [
                    Diagnostics.Extract_to_variable_and_replace_with_0_as_typeof_0,
                    typeToStringForDiag(tempName)
                ];
            }
        }
        function findExpandoFunction(node) {
            const expandoDeclaration = findAncestor(node, (n)=>isStatement(n) ? "quit" : isExpandoPropertyDeclaration(n));
            if (expandoDeclaration && isExpandoPropertyDeclaration(expandoDeclaration)) {
                let assignmentTarget = expandoDeclaration;
                if (isBinaryExpression(assignmentTarget)) {
                    assignmentTarget = assignmentTarget.left;
                    if (!isExpandoPropertyDeclaration(assignmentTarget)) return void 0;
                }
                const targetType = typeChecker.getTypeAtLocation(assignmentTarget.expression);
                if (!targetType) return;
                const properties = typeChecker.getPropertiesOfType(targetType);
                if (some(properties, (p)=>p.valueDeclaration === expandoDeclaration || p.valueDeclaration === expandoDeclaration.parent)) {
                    const fn = targetType.symbol.valueDeclaration;
                    if (fn) {
                        if (isFunctionExpressionOrArrowFunction(fn) && isVariableDeclaration(fn.parent)) return fn.parent;
                        if (isFunctionDeclaration(fn)) return fn;
                    }
                }
            }
            return void 0;
        }
        function fixIsolatedDeclarationError(node) {
            if (fixedNodes == null ? void 0 : fixedNodes.has(node)) return void 0;
            fixedNodes == null || fixedNodes.add(node);
            switch(node.kind){
                case 170 /* Parameter */ :
                case 173 /* PropertyDeclaration */ :
                case 261 /* VariableDeclaration */ :
                    return addTypeToVariableLike(node);
                case 220 /* ArrowFunction */ :
                case 219 /* FunctionExpression */ :
                case 263 /* FunctionDeclaration */ :
                case 175 /* MethodDeclaration */ :
                case 178 /* GetAccessor */ :
                    return addTypeToSignatureDeclaration(node, sourceFile);
                case 278 /* ExportAssignment */ :
                    return transformExportAssignment(node);
                case 264 /* ClassDeclaration */ :
                    return transformExtendsClauseWithExpression(node);
                case 207 /* ObjectBindingPattern */ :
                case 208 /* ArrayBindingPattern */ :
                    return transformDestructuringPatterns(node);
                default:
                    throw new Error(`Cannot find a fix for the given node ${node.kind}`);
            }
        }
        function addTypeToSignatureDeclaration(func, sourceFile2) {
            if (func.type) return;
            const { typeNode } = inferType(func);
            if (typeNode) {
                changeTracker.tryInsertTypeAnnotation(sourceFile2, func, typeNode);
                return [
                    Diagnostics.Add_return_type_0,
                    typeToStringForDiag(typeNode)
                ];
            }
        }
        function transformExportAssignment(defaultExport) {
            if (defaultExport.isExportEquals) return;
            const { typeNode } = inferType(defaultExport.expression);
            if (!typeNode) return void 0;
            const defaultIdentifier = factory.createUniqueName("_default");
            changeTracker.replaceNodeWithNodes(sourceFile, defaultExport, [
                factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(defaultIdentifier, /*exclamationToken*/ void 0, typeNode, defaultExport.expression)
                ], 2 /* Const */ )),
                factory.updateExportAssignment(defaultExport, defaultExport == null ? void 0 : defaultExport.modifiers, defaultIdentifier)
            ]);
            return [
                Diagnostics.Extract_default_export_to_variable
            ];
        }
        function transformExtendsClauseWithExpression(classDecl) {
            var _a, _b;
            const extendsClause = (_a = classDecl.heritageClauses) == null ? void 0 : _a.find((p)=>p.token === 96 /* ExtendsKeyword */ );
            const heritageExpression = extendsClause == null ? void 0 : extendsClause.types[0];
            if (!heritageExpression) return void 0;
            const { typeNode: heritageTypeNode } = inferType(heritageExpression.expression);
            if (!heritageTypeNode) return void 0;
            const baseClassName = factory.createUniqueName(classDecl.name ? classDecl.name.text + "Base" : "Anonymous", 16 /* Optimistic */ );
            const heritageVariable = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                factory.createVariableDeclaration(baseClassName, /*exclamationToken*/ void 0, heritageTypeNode, heritageExpression.expression)
            ], 2 /* Const */ ));
            changeTracker.insertNodeBefore(sourceFile, classDecl, heritageVariable);
            const trailingComments = getTrailingCommentRanges(sourceFile.text, heritageExpression.end);
            var _ref;
            const realEnd = (_ref = (_b = trailingComments == null ? void 0 : trailingComments[trailingComments.length - 1]) == null ? void 0 : _b.end) !== null && _ref !== void 0 ? _ref : heritageExpression.end;
            changeTracker.replaceRange(sourceFile, {
                pos: heritageExpression.getFullStart(),
                end: realEnd
            }, baseClassName, {
                prefix: " "
            });
            return [
                Diagnostics.Extract_base_class_to_variable
            ];
        }
        function transformDestructuringPatterns(bindingPattern) {
            var _a;
            const enclosingVariableDeclaration = bindingPattern.parent;
            const enclosingVarStmt = bindingPattern.parent.parent.parent;
            if (!enclosingVariableDeclaration.initializer) return void 0;
            let baseExpr;
            const newNodes = [];
            if (!isIdentifier(enclosingVariableDeclaration.initializer)) {
                const tempHolderForReturn = factory.createUniqueName("dest", 16 /* Optimistic */ );
                baseExpr = {
                    expression: {
                        kind: 3 /* Identifier */ ,
                        identifier: tempHolderForReturn
                    }
                };
                newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(tempHolderForReturn, /*exclamationToken*/ void 0, /*type*/ void 0, enclosingVariableDeclaration.initializer)
                ], 2 /* Const */ )));
            } else baseExpr = {
                expression: {
                    kind: 3 /* Identifier */ ,
                    identifier: enclosingVariableDeclaration.initializer
                }
            };
            const bindingElements = [];
            if (isArrayBindingPattern(bindingPattern)) addArrayBindingPatterns(bindingPattern, bindingElements, baseExpr);
            else addObjectBindingPatterns(bindingPattern, bindingElements, baseExpr);
            const expressionToVar = /* @__PURE__ */ new Map();
            for (const bindingElement of bindingElements){
                if (bindingElement.element.propertyName && isComputedPropertyName(bindingElement.element.propertyName)) {
                    const computedExpression = bindingElement.element.propertyName.expression;
                    const identifierForComputedProperty = factory.getGeneratedNameForNode(computedExpression);
                    const variableDecl = factory.createVariableDeclaration(identifierForComputedProperty, /*exclamationToken*/ void 0, /*type*/ void 0, computedExpression);
                    const variableList = factory.createVariableDeclarationList([
                        variableDecl
                    ], 2 /* Const */ );
                    const variableStatement = factory.createVariableStatement(/*modifiers*/ void 0, variableList);
                    newNodes.push(variableStatement);
                    expressionToVar.set(computedExpression, identifierForComputedProperty);
                }
                const name = bindingElement.element.name;
                if (isArrayBindingPattern(name)) addArrayBindingPatterns(name, bindingElements, bindingElement);
                else if (isObjectBindingPattern(name)) addObjectBindingPatterns(name, bindingElements, bindingElement);
                else {
                    const { typeNode } = inferType(name);
                    let variableInitializer = createChainedExpression(bindingElement, expressionToVar);
                    if (bindingElement.element.initializer) {
                        const propertyName = (_a = bindingElement.element) == null ? void 0 : _a.propertyName;
                        const tempName = factory.createUniqueName(propertyName && isIdentifier(propertyName) ? propertyName.text : "temp", 16 /* Optimistic */ );
                        newNodes.push(factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                            factory.createVariableDeclaration(tempName, /*exclamationToken*/ void 0, /*type*/ void 0, variableInitializer)
                        ], 2 /* Const */ )));
                        variableInitializer = factory.createConditionalExpression(factory.createBinaryExpression(tempName, factory.createToken(37 /* EqualsEqualsEqualsToken */ ), factory.createIdentifier("undefined")), factory.createToken(58 /* QuestionToken */ ), bindingElement.element.initializer, factory.createToken(59 /* ColonToken */ ), variableInitializer);
                    }
                    const exportModifier = hasSyntacticModifier(enclosingVarStmt, 32 /* Export */ ) ? [
                        factory.createToken(95 /* ExportKeyword */ )
                    ] : void 0;
                    newNodes.push(factory.createVariableStatement(exportModifier, factory.createVariableDeclarationList([
                        factory.createVariableDeclaration(name, /*exclamationToken*/ void 0, typeNode, variableInitializer)
                    ], 2 /* Const */ )));
                }
            }
            if (enclosingVarStmt.declarationList.declarations.length > 1) newNodes.push(factory.updateVariableStatement(enclosingVarStmt, enclosingVarStmt.modifiers, factory.updateVariableDeclarationList(enclosingVarStmt.declarationList, enclosingVarStmt.declarationList.declarations.filter((node)=>node !== bindingPattern.parent))));
            changeTracker.replaceNodeWithNodes(sourceFile, enclosingVarStmt, newNodes);
            return [
                Diagnostics.Extract_binding_expressions_to_variable
            ];
        }
        function addArrayBindingPatterns(bindingPattern, bindingElements, parent2) {
            for(let i = 0; i < bindingPattern.elements.length; ++i){
                const element = bindingPattern.elements[i];
                if (isOmittedExpression(element)) continue;
                bindingElements.push({
                    element,
                    parent: parent2,
                    expression: {
                        kind: 2 /* ArrayAccess */ ,
                        arrayIndex: i
                    }
                });
            }
        }
        function addObjectBindingPatterns(bindingPattern, bindingElements, parent2) {
            for (const bindingElement of bindingPattern.elements){
                let name;
                if (bindingElement.propertyName) {
                    if (isComputedPropertyName(bindingElement.propertyName)) {
                        bindingElements.push({
                            element: bindingElement,
                            parent: parent2,
                            expression: {
                                kind: 1 /* Computed */ ,
                                computed: bindingElement.propertyName.expression
                            }
                        });
                        continue;
                    } else name = bindingElement.propertyName.text;
                } else name = bindingElement.name.text;
                bindingElements.push({
                    element: bindingElement,
                    parent: parent2,
                    expression: {
                        kind: 0 /* Text */ ,
                        text: name
                    }
                });
            }
        }
        function createChainedExpression(expression, expressionToVar) {
            const reverseTraverse = [
                expression
            ];
            while(expression.parent){
                expression = expression.parent;
                reverseTraverse.push(expression);
            }
            let chainedExpression = reverseTraverse[reverseTraverse.length - 1].expression.identifier;
            for(let i = reverseTraverse.length - 2; i >= 0; --i){
                const nextSubExpr = reverseTraverse[i].expression;
                if (nextSubExpr.kind === 0 /* Text */ ) chainedExpression = factory.createPropertyAccessChain(chainedExpression, /*questionDotToken*/ void 0, factory.createIdentifier(nextSubExpr.text));
                else if (nextSubExpr.kind === 1 /* Computed */ ) chainedExpression = factory.createElementAccessExpression(chainedExpression, expressionToVar.get(nextSubExpr.computed));
                else if (nextSubExpr.kind === 2 /* ArrayAccess */ ) chainedExpression = factory.createElementAccessExpression(chainedExpression, nextSubExpr.arrayIndex);
            }
            return chainedExpression;
        }
        function inferType(node, variableType) {
            if (typePrintMode === 1 /* Relative */ ) return relativeType(node);
            let type;
            if (isValueSignatureDeclaration(node)) {
                const signature = typeChecker.getSignatureFromDeclaration(node);
                if (signature) {
                    const typePredicate = typeChecker.getTypePredicateOfSignature(signature);
                    if (typePredicate) {
                        if (!typePredicate.type) return emptyInferenceResult;
                        var _findAncestor;
                        return {
                            typeNode: typePredicateToTypeNode(typePredicate, (_findAncestor = findAncestor(node, isDeclaration)) !== null && _findAncestor !== void 0 ? _findAncestor : sourceFile, getFlags(typePredicate.type)),
                            mutatedTarget: false
                        };
                    }
                    type = typeChecker.getReturnTypeOfSignature(signature);
                }
            } else type = typeChecker.getTypeAtLocation(node);
            if (!type) return emptyInferenceResult;
            if (typePrintMode === 2 /* Widened */ ) {
                if (variableType) type = variableType;
                const widenedType = typeChecker.getWidenedLiteralType(type);
                if (typeChecker.isTypeAssignableTo(widenedType, type)) return emptyInferenceResult;
                type = widenedType;
            }
            var _findAncestor1;
            const enclosingDeclaration = (_findAncestor1 = findAncestor(node, isDeclaration)) !== null && _findAncestor1 !== void 0 ? _findAncestor1 : sourceFile;
            if (isParameter(node) && typeChecker.requiresAddingImplicitUndefined(node, enclosingDeclaration)) type = typeChecker.getUnionType([
                typeChecker.getUndefinedType(),
                type
            ], 0 /* None */ );
            return {
                typeNode: typeToTypeNode2(type, enclosingDeclaration, getFlags(type)),
                mutatedTarget: false
            };
            function getFlags(type2) {
                return (isVariableDeclaration(node) || isPropertyDeclaration(node) && hasSyntacticModifier(node, 264 /* Readonly */ )) && type2.flags & 8192 /* UniqueESSymbol */  ? 1048576 /* AllowUniqueESSymbolType */  : 0 /* None */ ;
            }
        }
        function createTypeOfFromEntityNameExpression(node) {
            return factory.createTypeQueryNode(getSynthesizedDeepClone(node));
        }
        function typeFromArraySpreadElements(node, name = "temp") {
            const isConstContext = !!findAncestor(node, isConstAssertion2);
            if (!isConstContext) return emptyInferenceResult;
            return typeFromSpreads(node, name, isConstContext, (n)=>n.elements, isSpreadElement, factory.createSpreadElement, (props)=>factory.createArrayLiteralExpression(props, /*multiLine*/ true), (types)=>factory.createTupleTypeNode(types.map(factory.createRestTypeNode)));
        }
        function typeFromObjectSpreadAssignment(node, name = "temp") {
            const isConstContext = !!findAncestor(node, isConstAssertion2);
            return typeFromSpreads(node, name, isConstContext, (n)=>n.properties, isSpreadAssignment, factory.createSpreadAssignment, (props)=>factory.createObjectLiteralExpression(props, /*multiLine*/ true), factory.createIntersectionTypeNode);
        }
        function typeFromSpreads(node, name, isConstContext, getChildren, isSpread, createSpread, makeNodeOfKind, finalType) {
            const intersectionTypes = [];
            const newSpreads = [];
            let currentVariableProperties;
            const statement = findAncestor(node, isStatement);
            for (const prop of getChildren(node))if (isSpread(prop)) {
                finalizesVariablePart();
                if (isEntityNameExpression(prop.expression)) {
                    intersectionTypes.push(createTypeOfFromEntityNameExpression(prop.expression));
                    newSpreads.push(prop);
                } else makeVariable(prop.expression);
            } else (currentVariableProperties !== null && currentVariableProperties !== void 0 ? currentVariableProperties : currentVariableProperties = []).push(prop);
            if (newSpreads.length === 0) return emptyInferenceResult;
            finalizesVariablePart();
            changeTracker.replaceNode(sourceFile, node, makeNodeOfKind(newSpreads));
            return {
                typeNode: finalType(intersectionTypes),
                mutatedTarget: true
            };
            function makeVariable(expression) {
                const tempName = factory.createUniqueName(name + "_Part" + (newSpreads.length + 1), 16 /* Optimistic */ );
                const initializer = !isConstContext ? expression : factory.createAsExpression(expression, factory.createTypeReferenceNode("const"));
                const variableDefinition = factory.createVariableStatement(/*modifiers*/ void 0, factory.createVariableDeclarationList([
                    factory.createVariableDeclaration(tempName, /*exclamationToken*/ void 0, /*type*/ void 0, initializer)
                ], 2 /* Const */ ));
                changeTracker.insertNodeBefore(sourceFile, statement, variableDefinition);
                intersectionTypes.push(createTypeOfFromEntityNameExpression(tempName));
                newSpreads.push(createSpread(tempName));
            }
            function finalizesVariablePart() {
                if (currentVariableProperties) {
                    makeVariable(makeNodeOfKind(currentVariableProperties));
                    currentVariableProperties = void 0;
                }
            }
        }
        function isConstAssertion2(location) {
            return isAssertionExpression(location) && isConstTypeReference(location.type);
        }
        function relativeType(node) {
            if (isParameter(node)) return emptyInferenceResult;
            if (isShorthandPropertyAssignment(node)) return {
                typeNode: createTypeOfFromEntityNameExpression(node.name),
                mutatedTarget: false
            };
            if (isEntityNameExpression(node)) return {
                typeNode: createTypeOfFromEntityNameExpression(node),
                mutatedTarget: false
            };
            if (isConstAssertion2(node)) return relativeType(node.expression);
            if (isArrayLiteralExpression(node)) {
                const variableDecl = findAncestor(node, isVariableDeclaration);
                const partName = variableDecl && isIdentifier(variableDecl.name) ? variableDecl.name.text : void 0;
                return typeFromArraySpreadElements(node, partName);
            }
            if (isObjectLiteralExpression(node)) {
                const variableDecl = findAncestor(node, isVariableDeclaration);
                const partName = variableDecl && isIdentifier(variableDecl.name) ? variableDecl.name.text : void 0;
                return typeFromObjectSpreadAssignment(node, partName);
            }
            if (isVariableDeclaration(node) && node.initializer) return relativeType(node.initializer);
            if (isConditionalExpression(node)) {
                const { typeNode: trueType, mutatedTarget: mTrue } = relativeType(node.whenTrue);
                if (!trueType) return emptyInferenceResult;
                const { typeNode: falseType, mutatedTarget: mFalse } = relativeType(node.whenFalse);
                if (!falseType) return emptyInferenceResult;
                return {
                    typeNode: factory.createUnionTypeNode([
                        trueType,
                        falseType
                    ]),
                    mutatedTarget: mTrue || mFalse
                };
            }
            return emptyInferenceResult;
        }
        function typeToTypeNode2(type, enclosingDeclaration, flags = 0 /* None */ ) {
            let isTruncated = false;
            const minimizedTypeNode = typeToMinimizedReferenceType(typeChecker, type, enclosingDeclaration, declarationEmitNodeBuilderFlags2 | flags, declarationEmitInternalNodeBuilderFlags2, {
                moduleResolverHost: program,
                trackSymbol () {
                    return true;
                },
                reportTruncationError () {
                    isTruncated = true;
                }
            });
            if (!minimizedTypeNode) return void 0;
            const result2 = typeNodeToAutoImportableTypeNode(minimizedTypeNode, importAdder, scriptTarget);
            return isTruncated ? factory.createKeywordTypeNode(133 /* AnyKeyword */ ) : result2;
        }
        function typePredicateToTypeNode(typePredicate, enclosingDeclaration, flags = 0 /* None */ ) {
            let isTruncated = false;
            const result2 = typePredicateToAutoImportableTypeNode(typeChecker, importAdder, typePredicate, enclosingDeclaration, scriptTarget, declarationEmitNodeBuilderFlags2 | flags, declarationEmitInternalNodeBuilderFlags2, {
                moduleResolverHost: program,
                trackSymbol () {
                    return true;
                },
                reportTruncationError () {
                    isTruncated = true;
                }
            });
            return isTruncated ? factory.createKeywordTypeNode(133 /* AnyKeyword */ ) : result2;
        }
        function addTypeToVariableLike(decl) {
            const { typeNode } = inferType(decl);
            if (typeNode) {
                if (decl.type) changeTracker.replaceNode(getSourceFileOfNode(decl), decl.type, typeNode);
                else changeTracker.tryInsertTypeAnnotation(getSourceFileOfNode(decl), decl, typeNode);
                return [
                    Diagnostics.Add_annotation_of_type_0,
                    typeToStringForDiag(typeNode)
                ];
            }
        }
        function typeToStringForDiag(node) {
            setEmitFlags(node, 1 /* SingleLine */ );
            const result2 = typePrinter.printNode(4 /* Unspecified */ , node, sourceFile);
            if (result2.length > defaultMaximumTruncationLength) return result2.substring(0, defaultMaximumTruncationLength - 3) + "...";
            setEmitFlags(node, 0 /* None */ );
            return result2;
        }
        function findAncestorWithMissingType(node) {
            return findAncestor(node, (n)=>{
                return canHaveTypeAnnotation.has(n.kind) && (!isObjectBindingPattern(n) && !isArrayBindingPattern(n) || isVariableDeclaration(n.parent));
            });
        }
        function findBestFittingNode(node, span) {
            while(node && node.end < span.start + span.length)node = node.parent;
            while(node.parent.pos === node.pos && node.parent.end === node.end)node = node.parent;
            if (isIdentifier(node) && hasInitializer(node.parent) && node.parent.initializer) return node.parent.initializer;
            return node;
        }
    }
    // src/services/codefixes/fixAwaitInSyncFunction.ts
    var fixId38 = "fixAwaitInSyncFunction";
    var errorCodes49 = [
        Diagnostics.await_expressions_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
        Diagnostics.await_using_statements_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
        Diagnostics.for_await_loops_are_only_allowed_within_async_functions_and_at_the_top_levels_of_modules.code,
        Diagnostics.Cannot_find_name_0_Did_you_mean_to_write_this_in_an_async_function.code
    ];
    registerCodeFix({
        errorCodes: errorCodes49,
        getCodeActions (context) {
            const { sourceFile, span } = context;
            const nodes = getNodes3(sourceFile, span.start);
            if (!nodes) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange31(t, sourceFile, nodes));
            return [
                createCodeFixAction(fixId38, changes, Diagnostics.Add_async_modifier_to_containing_function, fixId38, Diagnostics.Add_all_missing_async_modifiers)
            ];
        },
        fixIds: [
            fixId38
        ],
        getAllCodeActions: function getAllCodeActionsToFixAwaitInSyncFunction(context) {
            const seen = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes49, (changes, diag2)=>{
                const nodes = getNodes3(diag2.file, diag2.start);
                if (!nodes || !addToSeen(seen, getNodeId(nodes.insertBefore))) return;
                doChange31(changes, context.sourceFile, nodes);
            });
        }
    });
    function getReturnType(expr) {
        if (expr.type) return expr.type;
        if (isVariableDeclaration(expr.parent) && expr.parent.type && isFunctionTypeNode(expr.parent.type)) return expr.parent.type.type;
    }
    function getNodes3(sourceFile, start) {
        const token = getTokenAtPosition(sourceFile, start);
        const containingFunction = getContainingFunction(token);
        if (!containingFunction) return;
        let insertBefore;
        switch(containingFunction.kind){
            case 175 /* MethodDeclaration */ :
                insertBefore = containingFunction.name;
                break;
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
                insertBefore = findChildOfKind(containingFunction, 100 /* FunctionKeyword */ , sourceFile);
                break;
            case 220 /* ArrowFunction */ :
                const kind = containingFunction.typeParameters ? 30 /* LessThanToken */  : 21 /* OpenParenToken */ ;
                insertBefore = findChildOfKind(containingFunction, kind, sourceFile) || first(containingFunction.parameters);
                break;
            default:
                return;
        }
        return insertBefore && {
            insertBefore,
            returnType: getReturnType(containingFunction)
        };
    }
    function doChange31(changes, sourceFile, { insertBefore, returnType }) {
        if (returnType) {
            const entityName = getEntityNameFromTypeNode(returnType);
            if (!entityName || entityName.kind !== 80 /* Identifier */  || entityName.text !== "Promise") changes.replaceNode(sourceFile, returnType, factory.createTypeReferenceNode("Promise", factory.createNodeArray([
                returnType
            ])));
        }
        changes.insertModifierBefore(sourceFile, 134 /* AsyncKeyword */ , insertBefore);
    }
    // src/services/codefixes/fixPropertyOverrideAccessor.ts
    var errorCodes50 = [
        Diagnostics._0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property.code,
        Diagnostics._0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor.code
    ];
    var fixId39 = "fixPropertyOverrideAccessor";
    registerCodeFix({
        errorCodes: errorCodes50,
        getCodeActions (context) {
            const edits = doChange32(context.sourceFile, context.span.start, context.span.length, context.errorCode, context);
            if (edits) return [
                createCodeFixAction(fixId39, edits, Diagnostics.Generate_get_and_set_accessors, fixId39, Diagnostics.Generate_get_and_set_accessors_for_all_overriding_properties)
            ];
        },
        fixIds: [
            fixId39
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes50, (changes, diag2)=>{
                const edits = doChange32(diag2.file, diag2.start, diag2.length, diag2.code, context);
                if (edits) for (const edit of edits)changes.pushRaw(context.sourceFile, edit);
            })
    });
    function doChange32(file, start, length2, code, context) {
        let startPosition;
        let endPosition;
        if (code === Diagnostics._0_is_defined_as_an_accessor_in_class_1_but_is_overridden_here_in_2_as_an_instance_property.code) {
            startPosition = start;
            endPosition = start + length2;
        } else if (code === Diagnostics._0_is_defined_as_a_property_in_class_1_but_is_overridden_here_in_2_as_an_accessor.code) {
            const checker = context.program.getTypeChecker();
            const node = getTokenAtPosition(file, start).parent;
            if (isComputedPropertyName(node)) return;
            Debug.assert(isAccessor(node), "error span of fixPropertyOverrideAccessor should only be on an accessor");
            const containingClass = node.parent;
            Debug.assert(isClassLike(containingClass), "erroneous accessors should only be inside classes");
            const baseTypeNode = getEffectiveBaseTypeNode(containingClass);
            if (!baseTypeNode) return;
            const expression = skipParentheses(baseTypeNode.expression);
            const base = isClassExpression(expression) ? expression.symbol : checker.getSymbolAtLocation(expression);
            if (!base) return;
            const baseType = checker.getDeclaredTypeOfSymbol(base);
            const baseProp = checker.getPropertyOfType(baseType, unescapeLeadingUnderscores(getTextOfPropertyName(node.name)));
            if (!baseProp || !baseProp.valueDeclaration) return;
            startPosition = baseProp.valueDeclaration.pos;
            endPosition = baseProp.valueDeclaration.end;
            file = getSourceFileOfNode(baseProp.valueDeclaration);
        } else Debug.fail("fixPropertyOverrideAccessor codefix got unexpected error code " + code);
        return generateAccessorFromProperty(file, context.program, startPosition, endPosition, context, Diagnostics.Generate_get_and_set_accessors.message);
    }
    // src/services/codefixes/inferFromUsage.ts
    var fixId40 = "inferFromUsage";
    var errorCodes51 = [
        // Variable declarations
        Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code,
        // Variable uses
        Diagnostics.Variable_0_implicitly_has_an_1_type.code,
        // Parameter declarations
        Diagnostics.Parameter_0_implicitly_has_an_1_type.code,
        Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code,
        // Get Accessor declarations
        Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code,
        Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code,
        // Set Accessor declarations
        Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code,
        // Property declarations
        Diagnostics.Member_0_implicitly_has_an_1_type.code,
        //// Suggestions
        // Variable declarations
        Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage.code,
        // Variable uses
        Diagnostics.Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code,
        // Parameter declarations
        Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code,
        Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage.code,
        // Get Accessor declarations
        Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage.code,
        Diagnostics._0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage.code,
        // Set Accessor declarations
        Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage.code,
        // Property declarations
        Diagnostics.Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code,
        // Function expressions and declarations
        Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code
    ];
    registerCodeFix({
        errorCodes: errorCodes51,
        getCodeActions (context) {
            const { sourceFile, program, span: { start }, errorCode, cancellationToken, host, preferences } = context;
            const token = getTokenAtPosition(sourceFile, start);
            let declaration;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (changes2)=>{
                declaration = doChange33(changes2, sourceFile, token, errorCode, program, cancellationToken, /*markSeen*/ returnTrue, host, preferences);
            });
            const name = declaration && getNameOfDeclaration(declaration);
            return !name || changes.length === 0 ? void 0 : [
                createCodeFixAction(fixId40, changes, [
                    getDiagnostic(errorCode, token),
                    getTextOfNode(name)
                ], fixId40, Diagnostics.Infer_all_types_from_usage)
            ];
        },
        fixIds: [
            fixId40
        ],
        getAllCodeActions (context) {
            const { sourceFile, program, cancellationToken, host, preferences } = context;
            const markSeen = nodeSeenTracker();
            return codeFixAll(context, errorCodes51, (changes, err)=>{
                doChange33(changes, sourceFile, getTokenAtPosition(err.file, err.start), err.code, program, cancellationToken, markSeen, host, preferences);
            });
        }
    });
    function getDiagnostic(errorCode, token) {
        switch(errorCode){
            case Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
            case Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return isSetAccessorDeclaration(getContainingFunction(token)) ? Diagnostics.Infer_type_of_0_from_usage : Diagnostics.Infer_parameter_types_from_usage;
            // TODO: GH#18217
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Infer_parameter_types_from_usage;
            case Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code:
                return Diagnostics.Infer_this_type_of_0_from_usage;
            default:
                return Diagnostics.Infer_type_of_0_from_usage;
        }
    }
    function mapSuggestionDiagnostic(errorCode) {
        switch(errorCode){
            case Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code;
            case Diagnostics.Variable_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Variable_0_implicitly_has_an_1_type.code;
            case Diagnostics.Parameter_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Parameter_0_implicitly_has_an_1_type.code;
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code;
            case Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_get_accessor_may_be_inferred_from_usage.code:
                return Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code;
            case Diagnostics._0_implicitly_has_an_1_return_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code;
            case Diagnostics.Property_0_implicitly_has_type_any_but_a_better_type_for_its_set_accessor_may_be_inferred_from_usage.code:
                return Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code;
            case Diagnostics.Member_0_implicitly_has_an_1_type_but_a_better_type_may_be_inferred_from_usage.code:
                return Diagnostics.Member_0_implicitly_has_an_1_type.code;
        }
        return errorCode;
    }
    function doChange33(changes, sourceFile, token, errorCode, program, cancellationToken, markSeen, host, preferences) {
        if (!isParameterPropertyModifier(token.kind) && token.kind !== 80 /* Identifier */  && token.kind !== 26 /* DotDotDotToken */  && token.kind !== 110 /* ThisKeyword */ ) return void 0;
        const { parent: parent2 } = token;
        const importAdder = createImportAdder(sourceFile, program, preferences, host);
        errorCode = mapSuggestionDiagnostic(errorCode);
        switch(errorCode){
            // Variable and Property declarations
            case Diagnostics.Member_0_implicitly_has_an_1_type.code:
            case Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code:
                if (isVariableDeclaration(parent2) && markSeen(parent2) || isPropertyDeclaration(parent2) || isPropertySignature(parent2)) {
                    annotateVariableDeclaration(changes, importAdder, sourceFile, parent2, program, host, cancellationToken);
                    importAdder.writeFixes(changes);
                    return parent2;
                }
                if (isPropertyAccessExpression(parent2)) {
                    const type = inferTypeForVariableFromUsage(parent2.name, program, cancellationToken);
                    const typeNode = getTypeNodeIfAccessible(type, parent2, program, host);
                    if (typeNode) {
                        const typeTag = factory.createJSDocTypeTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(typeNode), /*comment*/ void 0);
                        changes.addJSDocTags(sourceFile, cast(parent2.parent.parent, isExpressionStatement), [
                            typeTag
                        ]);
                    }
                    importAdder.writeFixes(changes);
                    return parent2;
                }
                return void 0;
            case Diagnostics.Variable_0_implicitly_has_an_1_type.code:
                {
                    const symbol = program.getTypeChecker().getSymbolAtLocation(token);
                    if (symbol && symbol.valueDeclaration && isVariableDeclaration(symbol.valueDeclaration) && markSeen(symbol.valueDeclaration)) {
                        annotateVariableDeclaration(changes, importAdder, getSourceFileOfNode(symbol.valueDeclaration), symbol.valueDeclaration, program, host, cancellationToken);
                        importAdder.writeFixes(changes);
                        return symbol.valueDeclaration;
                    }
                    return void 0;
                }
        }
        const containingFunction = getContainingFunction(token);
        if (containingFunction === void 0) return void 0;
        let declaration;
        switch(errorCode){
            // Parameter declarations
            case Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
                if (isSetAccessorDeclaration(containingFunction)) {
                    annotateSetAccessor(changes, importAdder, sourceFile, containingFunction, program, host, cancellationToken);
                    declaration = containingFunction;
                    break;
                }
            // falls through
            case Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
                if (markSeen(containingFunction)) {
                    const param = cast(parent2, isParameter);
                    annotateParameters(changes, importAdder, sourceFile, param, containingFunction, program, host, cancellationToken);
                    declaration = param;
                }
                break;
            // Get Accessor declarations
            case Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code:
            case Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code:
                if (isGetAccessorDeclaration(containingFunction) && isIdentifier(containingFunction.name)) {
                    annotate(changes, importAdder, sourceFile, containingFunction, inferTypeForVariableFromUsage(containingFunction.name, program, cancellationToken), program, host);
                    declaration = containingFunction;
                }
                break;
            // Set Accessor declarations
            case Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code:
                if (isSetAccessorDeclaration(containingFunction)) {
                    annotateSetAccessor(changes, importAdder, sourceFile, containingFunction, program, host, cancellationToken);
                    declaration = containingFunction;
                }
                break;
            // Function 'this'
            case Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation.code:
                if (ts_textChanges_exports.isThisTypeAnnotatable(containingFunction) && markSeen(containingFunction)) {
                    annotateThis(changes, sourceFile, containingFunction, program, host, cancellationToken);
                    declaration = containingFunction;
                }
                break;
            default:
                return Debug.fail(String(errorCode));
        }
        importAdder.writeFixes(changes);
        return declaration;
    }
    function annotateVariableDeclaration(changes, importAdder, sourceFile, declaration, program, host, cancellationToken) {
        if (isIdentifier(declaration.name)) annotate(changes, importAdder, sourceFile, declaration, inferTypeForVariableFromUsage(declaration.name, program, cancellationToken), program, host);
    }
    function annotateParameters(changes, importAdder, sourceFile, parameterDeclaration, containingFunction, program, host, cancellationToken) {
        if (!isIdentifier(parameterDeclaration.name)) return;
        const parameterInferences = inferTypeForParametersFromUsage(containingFunction, sourceFile, program, cancellationToken);
        Debug.assert(containingFunction.parameters.length === parameterInferences.length, "Parameter count and inference count should match");
        if (isInJSFile(containingFunction)) annotateJSDocParameters(changes, sourceFile, parameterInferences, program, host);
        else {
            const needParens = isArrowFunction(containingFunction) && !findChildOfKind(containingFunction, 21 /* OpenParenToken */ , sourceFile);
            if (needParens) changes.insertNodeBefore(sourceFile, first(containingFunction.parameters), factory.createToken(21 /* OpenParenToken */ ));
            for (const { declaration, type } of parameterInferences)if (declaration && !declaration.type && !declaration.initializer) annotate(changes, importAdder, sourceFile, declaration, type, program, host);
            if (needParens) changes.insertNodeAfter(sourceFile, last(containingFunction.parameters), factory.createToken(22 /* CloseParenToken */ ));
        }
    }
    function annotateThis(changes, sourceFile, containingFunction, program, host, cancellationToken) {
        const references = getFunctionReferences(containingFunction, sourceFile, program, cancellationToken);
        if (!references || !references.length) return;
        const thisInference = inferTypeFromReferences(program, references, cancellationToken).thisParameter();
        const typeNode = getTypeNodeIfAccessible(thisInference, containingFunction, program, host);
        if (!typeNode) return;
        if (isInJSFile(containingFunction)) annotateJSDocThis(changes, sourceFile, containingFunction, typeNode);
        else changes.tryInsertThisTypeAnnotation(sourceFile, containingFunction, typeNode);
    }
    function annotateJSDocThis(changes, sourceFile, containingFunction, typeNode) {
        changes.addJSDocTags(sourceFile, containingFunction, [
            factory.createJSDocThisTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(typeNode))
        ]);
    }
    function annotateSetAccessor(changes, importAdder, sourceFile, setAccessorDeclaration, program, host, cancellationToken) {
        const param = firstOrUndefined(setAccessorDeclaration.parameters);
        if (param && isIdentifier(setAccessorDeclaration.name) && isIdentifier(param.name)) {
            let type = inferTypeForVariableFromUsage(setAccessorDeclaration.name, program, cancellationToken);
            if (type === program.getTypeChecker().getAnyType()) type = inferTypeForVariableFromUsage(param.name, program, cancellationToken);
            if (isInJSFile(setAccessorDeclaration)) annotateJSDocParameters(changes, sourceFile, [
                {
                    declaration: param,
                    type
                }
            ], program, host);
            else annotate(changes, importAdder, sourceFile, param, type, program, host);
        }
    }
    function annotate(changes, importAdder, sourceFile, declaration, type, program, host) {
        const typeNode = getTypeNodeIfAccessible(type, declaration, program, host);
        if (typeNode) {
            if (isInJSFile(sourceFile) && declaration.kind !== 172 /* PropertySignature */ ) {
                const parent2 = isVariableDeclaration(declaration) ? tryCast(declaration.parent.parent, isVariableStatement) : declaration;
                if (!parent2) return;
                const typeExpression = factory.createJSDocTypeExpression(typeNode);
                const typeTag = isGetAccessorDeclaration(declaration) ? factory.createJSDocReturnTag(/*tagName*/ void 0, typeExpression, /*comment*/ void 0) : factory.createJSDocTypeTag(/*tagName*/ void 0, typeExpression, /*comment*/ void 0);
                changes.addJSDocTags(sourceFile, parent2, [
                    typeTag
                ]);
            } else if (!tryReplaceImportTypeNodeWithAutoImport(typeNode, declaration, sourceFile, changes, importAdder, getEmitScriptTarget(program.getCompilerOptions()))) changes.tryInsertTypeAnnotation(sourceFile, declaration, typeNode);
        }
    }
    function tryReplaceImportTypeNodeWithAutoImport(typeNode, declaration, sourceFile, changes, importAdder, scriptTarget) {
        const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
        if (importableReference && changes.tryInsertTypeAnnotation(sourceFile, declaration, importableReference.typeNode)) {
            forEach(importableReference.symbols, (s)=>importAdder.addImportFromExportedSymbol(s, /*isValidTypeOnlyUseSite*/ true));
            return true;
        }
        return false;
    }
    function annotateJSDocParameters(changes, sourceFile, parameterInferences, program, host) {
        const signature = parameterInferences.length && parameterInferences[0].declaration.parent;
        if (!signature) return;
        const inferences = mapDefined(parameterInferences, (inference)=>{
            const param = inference.declaration;
            if (param.initializer || getJSDocType(param) || !isIdentifier(param.name)) return;
            const typeNode = inference.type && getTypeNodeIfAccessible(inference.type, param, program, host);
            if (typeNode) {
                const name = factory.cloneNode(param.name);
                setEmitFlags(name, 7168 /* NoNestedComments */ );
                return {
                    name: factory.cloneNode(param.name),
                    param,
                    isOptional: !!inference.isOptional,
                    typeNode
                };
            }
        });
        if (!inferences.length) return;
        if (isArrowFunction(signature) || isFunctionExpression(signature)) {
            const needParens = isArrowFunction(signature) && !findChildOfKind(signature, 21 /* OpenParenToken */ , sourceFile);
            if (needParens) changes.insertNodeBefore(sourceFile, first(signature.parameters), factory.createToken(21 /* OpenParenToken */ ));
            forEach(inferences, ({ typeNode, param })=>{
                const typeTag = factory.createJSDocTypeTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(typeNode));
                const jsDoc = factory.createJSDocComment(/*comment*/ void 0, [
                    typeTag
                ]);
                changes.insertNodeAt(sourceFile, param.getStart(sourceFile), jsDoc, {
                    suffix: " "
                });
            });
            if (needParens) changes.insertNodeAfter(sourceFile, last(signature.parameters), factory.createToken(22 /* CloseParenToken */ ));
        } else {
            const paramTags = map(inferences, ({ name, typeNode, isOptional })=>factory.createJSDocParameterTag(/*tagName*/ void 0, name, /*isBracketed*/ !!isOptional, factory.createJSDocTypeExpression(typeNode), /*isNameFirst*/ false, /*comment*/ void 0));
            changes.addJSDocTags(sourceFile, signature, paramTags);
        }
    }
    function getReferences(token, program, cancellationToken) {
        return mapDefined(ts_FindAllReferences_exports.getReferenceEntriesForNode(-1, token, program, program.getSourceFiles(), cancellationToken), (entry)=>entry.kind !== ts_FindAllReferences_exports.EntryKind.Span ? tryCast(entry.node, isIdentifier) : void 0);
    }
    function inferTypeForVariableFromUsage(token, program, cancellationToken) {
        const references = getReferences(token, program, cancellationToken);
        return inferTypeFromReferences(program, references, cancellationToken).single();
    }
    function inferTypeForParametersFromUsage(func, sourceFile, program, cancellationToken) {
        const references = getFunctionReferences(func, sourceFile, program, cancellationToken);
        return references && inferTypeFromReferences(program, references, cancellationToken).parameters(func) || func.parameters.map((p)=>({
                declaration: p,
                type: isIdentifier(p.name) ? inferTypeForVariableFromUsage(p.name, program, cancellationToken) : program.getTypeChecker().getAnyType()
            }));
    }
    function getFunctionReferences(containingFunction, sourceFile, program, cancellationToken) {
        let searchToken;
        switch(containingFunction.kind){
            case 177 /* Constructor */ :
                searchToken = findChildOfKind(containingFunction, 137 /* ConstructorKeyword */ , sourceFile);
                break;
            case 220 /* ArrowFunction */ :
            case 219 /* FunctionExpression */ :
                const parent2 = containingFunction.parent;
                searchToken = (isVariableDeclaration(parent2) || isPropertyDeclaration(parent2)) && isIdentifier(parent2.name) ? parent2.name : containingFunction.name;
                break;
            case 263 /* FunctionDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
                searchToken = containingFunction.name;
                break;
        }
        if (!searchToken) return void 0;
        return getReferences(searchToken, program, cancellationToken);
    }
    function inferTypeFromReferences(program, references, cancellationToken) {
        const checker = program.getTypeChecker();
        const builtinConstructors = {
            string: ()=>checker.getStringType(),
            number: ()=>checker.getNumberType(),
            Array: (t)=>checker.createArrayType(t),
            Promise: (t)=>checker.createPromiseType(t)
        };
        const builtins = [
            checker.getStringType(),
            checker.getNumberType(),
            checker.createArrayType(checker.getAnyType()),
            checker.createPromiseType(checker.getAnyType())
        ];
        return {
            single: single2,
            parameters,
            thisParameter
        };
        function createEmptyUsage() {
            return {
                isNumber: void 0,
                isString: void 0,
                isNumberOrString: void 0,
                candidateTypes: void 0,
                properties: void 0,
                calls: void 0,
                constructs: void 0,
                numberIndex: void 0,
                stringIndex: void 0,
                candidateThisTypes: void 0,
                inferredTypes: void 0
            };
        }
        function combineUsages(usages) {
            const combinedProperties = /* @__PURE__ */ new Map();
            for (const u of usages)if (u.properties) u.properties.forEach((p, name)=>{
                if (!combinedProperties.has(name)) combinedProperties.set(name, []);
                combinedProperties.get(name).push(p);
            });
            const properties = /* @__PURE__ */ new Map();
            combinedProperties.forEach((ps, name)=>{
                properties.set(name, combineUsages(ps));
            });
            return {
                isNumber: usages.some((u)=>u.isNumber),
                isString: usages.some((u)=>u.isString),
                isNumberOrString: usages.some((u)=>u.isNumberOrString),
                candidateTypes: flatMap(usages, (u)=>u.candidateTypes),
                properties,
                calls: flatMap(usages, (u)=>u.calls),
                constructs: flatMap(usages, (u)=>u.constructs),
                numberIndex: forEach(usages, (u)=>u.numberIndex),
                stringIndex: forEach(usages, (u)=>u.stringIndex),
                candidateThisTypes: flatMap(usages, (u)=>u.candidateThisTypes),
                inferredTypes: void 0
            };
        }
        function single2() {
            return combineTypes(inferTypesFromReferencesSingle(references));
        }
        function parameters(declaration) {
            if (references.length === 0 || !declaration.parameters) return void 0;
            const usage = createEmptyUsage();
            for (const reference of references){
                cancellationToken.throwIfCancellationRequested();
                calculateUsageOfNode(reference, usage);
            }
            const calls = [
                ...usage.constructs || [],
                ...usage.calls || []
            ];
            return declaration.parameters.map((parameter, parameterIndex)=>{
                const types = [];
                const isRest = isRestParameter(parameter);
                let isOptional = false;
                for (const call of calls){
                    if (call.argumentTypes.length <= parameterIndex) {
                        isOptional = isInJSFile(declaration);
                        types.push(checker.getUndefinedType());
                    } else if (isRest) for(let i = parameterIndex; i < call.argumentTypes.length; i++)types.push(checker.getBaseTypeOfLiteralType(call.argumentTypes[i]));
                    else types.push(checker.getBaseTypeOfLiteralType(call.argumentTypes[parameterIndex]));
                }
                if (isIdentifier(parameter.name)) {
                    const inferred = inferTypesFromReferencesSingle(getReferences(parameter.name, program, cancellationToken));
                    types.push(...isRest ? mapDefined(inferred, checker.getElementTypeOfArrayType) : inferred);
                }
                const type = combineTypes(types);
                return {
                    type: isRest ? checker.createArrayType(type) : type,
                    isOptional: isOptional && !isRest,
                    declaration: parameter
                };
            });
        }
        function thisParameter() {
            const usage = createEmptyUsage();
            for (const reference of references){
                cancellationToken.throwIfCancellationRequested();
                calculateUsageOfNode(reference, usage);
            }
            return combineTypes(usage.candidateThisTypes || emptyArray);
        }
        function inferTypesFromReferencesSingle(references2) {
            const usage = createEmptyUsage();
            for (const reference of references2){
                cancellationToken.throwIfCancellationRequested();
                calculateUsageOfNode(reference, usage);
            }
            return inferTypes(usage);
        }
        function calculateUsageOfNode(node, usage) {
            while(isRightSideOfQualifiedNameOrPropertyAccess(node))node = node.parent;
            switch(node.parent.kind){
                case 245 /* ExpressionStatement */ :
                    inferTypeFromExpressionStatement(node, usage);
                    break;
                case 226 /* PostfixUnaryExpression */ :
                    usage.isNumber = true;
                    break;
                case 225 /* PrefixUnaryExpression */ :
                    inferTypeFromPrefixUnaryExpression(node.parent, usage);
                    break;
                case 227 /* BinaryExpression */ :
                    inferTypeFromBinaryExpression(node, node.parent, usage);
                    break;
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                    inferTypeFromSwitchStatementLabel(node.parent, usage);
                    break;
                case 214 /* CallExpression */ :
                case 215 /* NewExpression */ :
                    if (node.parent.expression === node) inferTypeFromCallExpression(node.parent, usage);
                    else inferTypeFromContextualType(node, usage);
                    break;
                case 212 /* PropertyAccessExpression */ :
                    inferTypeFromPropertyAccessExpression(node.parent, usage);
                    break;
                case 213 /* ElementAccessExpression */ :
                    inferTypeFromPropertyElementExpression(node.parent, node, usage);
                    break;
                case 304 /* PropertyAssignment */ :
                case 305 /* ShorthandPropertyAssignment */ :
                    inferTypeFromPropertyAssignment(node.parent, usage);
                    break;
                case 173 /* PropertyDeclaration */ :
                    inferTypeFromPropertyDeclaration(node.parent, usage);
                    break;
                case 261 /* VariableDeclaration */ :
                    {
                        const { name, initializer } = node.parent;
                        if (node === name) {
                            if (initializer) addCandidateType(usage, checker.getTypeAtLocation(initializer));
                            break;
                        }
                    }
                // falls through
                default:
                    return inferTypeFromContextualType(node, usage);
            }
        }
        function inferTypeFromContextualType(node, usage) {
            if (isExpressionNode(node)) addCandidateType(usage, checker.getContextualType(node));
        }
        function inferTypeFromExpressionStatement(node, usage) {
            addCandidateType(usage, isCallExpression(node) ? checker.getVoidType() : checker.getAnyType());
        }
        function inferTypeFromPrefixUnaryExpression(node, usage) {
            switch(node.operator){
                case 46 /* PlusPlusToken */ :
                case 47 /* MinusMinusToken */ :
                case 41 /* MinusToken */ :
                case 55 /* TildeToken */ :
                    usage.isNumber = true;
                    break;
                case 40 /* PlusToken */ :
                    usage.isNumberOrString = true;
                    break;
            }
        }
        function inferTypeFromBinaryExpression(node, parent2, usage) {
            switch(parent2.operatorToken.kind){
                // ExponentiationOperator
                case 43 /* AsteriskAsteriskToken */ :
                // MultiplicativeOperator
                // falls through
                case 42 /* AsteriskToken */ :
                case 44 /* SlashToken */ :
                case 45 /* PercentToken */ :
                // ShiftOperator
                // falls through
                case 48 /* LessThanLessThanToken */ :
                case 49 /* GreaterThanGreaterThanToken */ :
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                // BitwiseOperator
                // falls through
                case 51 /* AmpersandToken */ :
                case 52 /* BarToken */ :
                case 53 /* CaretToken */ :
                // CompoundAssignmentOperator
                // falls through
                case 66 /* MinusEqualsToken */ :
                case 68 /* AsteriskAsteriskEqualsToken */ :
                case 67 /* AsteriskEqualsToken */ :
                case 69 /* SlashEqualsToken */ :
                case 70 /* PercentEqualsToken */ :
                case 74 /* AmpersandEqualsToken */ :
                case 75 /* BarEqualsToken */ :
                case 79 /* CaretEqualsToken */ :
                case 71 /* LessThanLessThanEqualsToken */ :
                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                // AdditiveOperator
                // falls through
                case 41 /* MinusToken */ :
                // RelationalOperator
                // falls through
                case 30 /* LessThanToken */ :
                case 33 /* LessThanEqualsToken */ :
                case 32 /* GreaterThanToken */ :
                case 34 /* GreaterThanEqualsToken */ :
                    const operandType = checker.getTypeAtLocation(parent2.left === node ? parent2.right : parent2.left);
                    if (operandType.flags & 1056 /* EnumLike */ ) addCandidateType(usage, operandType);
                    else usage.isNumber = true;
                    break;
                case 65 /* PlusEqualsToken */ :
                case 40 /* PlusToken */ :
                    const otherOperandType = checker.getTypeAtLocation(parent2.left === node ? parent2.right : parent2.left);
                    if (otherOperandType.flags & 1056 /* EnumLike */ ) addCandidateType(usage, otherOperandType);
                    else if (otherOperandType.flags & 296 /* NumberLike */ ) usage.isNumber = true;
                    else if (otherOperandType.flags & 402653316 /* StringLike */ ) usage.isString = true;
                    else if (otherOperandType.flags & 1 /* Any */ ) ;
                    else usage.isNumberOrString = true;
                    break;
                //  AssignmentOperators
                case 64 /* EqualsToken */ :
                case 35 /* EqualsEqualsToken */ :
                case 37 /* EqualsEqualsEqualsToken */ :
                case 38 /* ExclamationEqualsEqualsToken */ :
                case 36 /* ExclamationEqualsToken */ :
                case 77 /* AmpersandAmpersandEqualsToken */ :
                case 78 /* QuestionQuestionEqualsToken */ :
                case 76 /* BarBarEqualsToken */ :
                    addCandidateType(usage, checker.getTypeAtLocation(parent2.left === node ? parent2.right : parent2.left));
                    break;
                case 103 /* InKeyword */ :
                    if (node === parent2.left) usage.isString = true;
                    break;
                // LogicalOperator Or NullishCoalescing
                case 57 /* BarBarToken */ :
                case 61 /* QuestionQuestionToken */ :
                    if (node === parent2.left && (node.parent.parent.kind === 261 /* VariableDeclaration */  || isAssignmentExpression(node.parent.parent, /*excludeCompoundAssignment*/ true))) addCandidateType(usage, checker.getTypeAtLocation(parent2.right));
                    break;
                case 56 /* AmpersandAmpersandToken */ :
                case 28 /* CommaToken */ :
                case 104 /* InstanceOfKeyword */ :
                    break;
            }
        }
        function inferTypeFromSwitchStatementLabel(parent2, usage) {
            addCandidateType(usage, checker.getTypeAtLocation(parent2.parent.parent.expression));
        }
        function inferTypeFromCallExpression(parent2, usage) {
            const call = {
                argumentTypes: [],
                return_: createEmptyUsage()
            };
            if (parent2.arguments) for (const argument of parent2.arguments)call.argumentTypes.push(checker.getTypeAtLocation(argument));
            calculateUsageOfNode(parent2, call.return_);
            if (parent2.kind === 214 /* CallExpression */ ) (usage.calls || (usage.calls = [])).push(call);
            else (usage.constructs || (usage.constructs = [])).push(call);
        }
        function inferTypeFromPropertyAccessExpression(parent2, usage) {
            const name = escapeLeadingUnderscores(parent2.name.text);
            if (!usage.properties) usage.properties = /* @__PURE__ */ new Map();
            const propertyUsage = usage.properties.get(name) || createEmptyUsage();
            calculateUsageOfNode(parent2, propertyUsage);
            usage.properties.set(name, propertyUsage);
        }
        function inferTypeFromPropertyElementExpression(parent2, node, usage) {
            if (node === parent2.argumentExpression) {
                usage.isNumberOrString = true;
                return;
            } else {
                const indexType = checker.getTypeAtLocation(parent2.argumentExpression);
                const indexUsage = createEmptyUsage();
                calculateUsageOfNode(parent2, indexUsage);
                if (indexType.flags & 296 /* NumberLike */ ) usage.numberIndex = indexUsage;
                else usage.stringIndex = indexUsage;
            }
        }
        function inferTypeFromPropertyAssignment(assignment, usage) {
            const nodeWithRealType = isVariableDeclaration(assignment.parent.parent) ? assignment.parent.parent : assignment.parent;
            addCandidateThisType(usage, checker.getTypeAtLocation(nodeWithRealType));
        }
        function inferTypeFromPropertyDeclaration(declaration, usage) {
            addCandidateThisType(usage, checker.getTypeAtLocation(declaration.parent));
        }
        function removeLowPriorityInferences(inferences, priorities) {
            const toRemove = [];
            for (const i of inferences){
                for (const { high, low } of priorities)if (high(i)) {
                    Debug.assert(!low(i), "Priority can't have both low and high");
                    toRemove.push(low);
                }
            }
            return inferences.filter((i)=>toRemove.every((f)=>!f(i)));
        }
        function combineFromUsage(usage) {
            return combineTypes(inferTypes(usage));
        }
        function combineTypes(inferences) {
            if (!inferences.length) return checker.getAnyType();
            const stringNumber = checker.getUnionType([
                checker.getStringType(),
                checker.getNumberType()
            ]);
            const priorities = [
                {
                    high: (t)=>t === checker.getStringType() || t === checker.getNumberType(),
                    low: (t)=>t === stringNumber
                },
                {
                    high: (t)=>!(t.flags & 16385 /* Void */ ),
                    low: (t)=>!!(t.flags & 16385 /* Void */ )
                },
                {
                    high: (t)=>!(t.flags & 114689 /* Void */ ) && !(getObjectFlags(t) & 16 /* Anonymous */ ),
                    low: (t)=>!!(getObjectFlags(t) & 16 /* Anonymous */ )
                }
            ];
            let good = removeLowPriorityInferences(inferences, priorities);
            const anons = good.filter((i)=>getObjectFlags(i) & 16 /* Anonymous */ );
            if (anons.length) {
                good = good.filter((i)=>!(getObjectFlags(i) & 16 /* Anonymous */ ));
                good.push(combineAnonymousTypes(anons));
            }
            return checker.getWidenedType(checker.getUnionType(good.map(checker.getBaseTypeOfLiteralType), 2 /* Subtype */ ));
        }
        function combineAnonymousTypes(anons) {
            if (anons.length === 1) return anons[0];
            const calls = [];
            const constructs = [];
            const stringIndices = [];
            const numberIndices = [];
            let stringIndexReadonly = false;
            let numberIndexReadonly = false;
            const props = createMultiMap();
            for (const anon2 of anons){
                for (const p of checker.getPropertiesOfType(anon2))props.add(p.escapedName, p.valueDeclaration ? checker.getTypeOfSymbolAtLocation(p, p.valueDeclaration) : checker.getAnyType());
                calls.push(...checker.getSignaturesOfType(anon2, 0 /* Call */ ));
                constructs.push(...checker.getSignaturesOfType(anon2, 1 /* Construct */ ));
                const stringIndexInfo = checker.getIndexInfoOfType(anon2, 0 /* String */ );
                if (stringIndexInfo) {
                    stringIndices.push(stringIndexInfo.type);
                    stringIndexReadonly = stringIndexReadonly || stringIndexInfo.isReadonly;
                }
                const numberIndexInfo = checker.getIndexInfoOfType(anon2, 1 /* Number */ );
                if (numberIndexInfo) {
                    numberIndices.push(numberIndexInfo.type);
                    numberIndexReadonly = numberIndexReadonly || numberIndexInfo.isReadonly;
                }
            }
            const members = mapEntries(props, (name, types)=>{
                const isOptional = types.length < anons.length ? 16777216 /* Optional */  : 0;
                const s = checker.createSymbol(4 /* Property */  | isOptional, name);
                s.links.type = checker.getUnionType(types);
                return [
                    name,
                    s
                ];
            });
            const indexInfos = [];
            if (stringIndices.length) indexInfos.push(checker.createIndexInfo(checker.getStringType(), checker.getUnionType(stringIndices), stringIndexReadonly));
            if (numberIndices.length) indexInfos.push(checker.createIndexInfo(checker.getNumberType(), checker.getUnionType(numberIndices), numberIndexReadonly));
            return checker.createAnonymousType(anons[0].symbol, members, calls, constructs, indexInfos);
        }
        function inferTypes(usage) {
            var _a, _b, _c;
            const types = [];
            if (usage.isNumber) types.push(checker.getNumberType());
            if (usage.isString) types.push(checker.getStringType());
            if (usage.isNumberOrString) types.push(checker.getUnionType([
                checker.getStringType(),
                checker.getNumberType()
            ]));
            if (usage.numberIndex) types.push(checker.createArrayType(combineFromUsage(usage.numberIndex)));
            if (((_a = usage.properties) == null ? void 0 : _a.size) || ((_b = usage.constructs) == null ? void 0 : _b.length) || usage.stringIndex) types.push(inferStructuralType(usage));
            const candidateTypes = (usage.candidateTypes || []).map((t)=>checker.getBaseTypeOfLiteralType(t));
            const callsType = ((_c = usage.calls) == null ? void 0 : _c.length) ? inferStructuralType(usage) : void 0;
            if (callsType && candidateTypes) types.push(checker.getUnionType([
                callsType,
                ...candidateTypes
            ], 2 /* Subtype */ ));
            else {
                if (callsType) types.push(callsType);
                if (length(candidateTypes)) types.push(...candidateTypes);
            }
            types.push(...inferNamedTypesFromProperties(usage));
            return types;
        }
        function inferStructuralType(usage) {
            const members = /* @__PURE__ */ new Map();
            if (usage.properties) usage.properties.forEach((u, name)=>{
                const symbol = checker.createSymbol(4 /* Property */ , name);
                symbol.links.type = combineFromUsage(u);
                members.set(name, symbol);
            });
            const callSignatures = usage.calls ? [
                getSignatureFromCalls(usage.calls)
            ] : [];
            const constructSignatures = usage.constructs ? [
                getSignatureFromCalls(usage.constructs)
            ] : [];
            const indexInfos = usage.stringIndex ? [
                checker.createIndexInfo(checker.getStringType(), combineFromUsage(usage.stringIndex), /*isReadonly*/ false)
            ] : [];
            return checker.createAnonymousType(/*symbol*/ void 0, members, callSignatures, constructSignatures, indexInfos);
        }
        function inferNamedTypesFromProperties(usage) {
            if (!usage.properties || !usage.properties.size) return [];
            const types = builtins.filter((t)=>allPropertiesAreAssignableToUsage(t, usage));
            if (0 < types.length && types.length < 3) return types.map((t)=>inferInstantiationFromUsage(t, usage));
            return [];
        }
        function allPropertiesAreAssignableToUsage(type, usage) {
            if (!usage.properties) return false;
            return !forEachEntry(usage.properties, (propUsage, name)=>{
                const source = checker.getTypeOfPropertyOfType(type, name);
                if (!source) return true;
                if (propUsage.calls) {
                    const sigs = checker.getSignaturesOfType(source, 0 /* Call */ );
                    return !sigs.length || !checker.isTypeAssignableTo(source, getFunctionFromCalls(propUsage.calls));
                } else return !checker.isTypeAssignableTo(source, combineFromUsage(propUsage));
            });
        }
        function inferInstantiationFromUsage(type, usage) {
            if (!(getObjectFlags(type) & 4 /* Reference */ ) || !usage.properties) return type;
            const generic = type.target;
            const singleTypeParameter = singleOrUndefined(generic.typeParameters);
            if (!singleTypeParameter) return type;
            const types = [];
            usage.properties.forEach((propUsage, name)=>{
                const genericPropertyType = checker.getTypeOfPropertyOfType(generic, name);
                Debug.assert(!!genericPropertyType, "generic should have all the properties of its reference.");
                types.push(...inferTypeParameters(genericPropertyType, combineFromUsage(propUsage), singleTypeParameter));
            });
            return builtinConstructors[type.symbol.escapedName](combineTypes(types));
        }
        function inferTypeParameters(genericType, usageType, typeParameter) {
            if (genericType === typeParameter) return [
                usageType
            ];
            else if (genericType.flags & 3145728 /* UnionOrIntersection */ ) return flatMap(genericType.types, (t)=>inferTypeParameters(t, usageType, typeParameter));
            else if (getObjectFlags(genericType) & 4 /* Reference */  && getObjectFlags(usageType) & 4 /* Reference */ ) {
                const genericArgs = checker.getTypeArguments(genericType);
                const usageArgs = checker.getTypeArguments(usageType);
                const types = [];
                if (genericArgs && usageArgs) {
                    for(let i = 0; i < genericArgs.length; i++)if (usageArgs[i]) types.push(...inferTypeParameters(genericArgs[i], usageArgs[i], typeParameter));
                }
                return types;
            }
            const genericSigs = checker.getSignaturesOfType(genericType, 0 /* Call */ );
            const usageSigs = checker.getSignaturesOfType(usageType, 0 /* Call */ );
            if (genericSigs.length === 1 && usageSigs.length === 1) return inferFromSignatures(genericSigs[0], usageSigs[0], typeParameter);
            return [];
        }
        function inferFromSignatures(genericSig, usageSig, typeParameter) {
            var _a;
            const types = [];
            for(let i = 0; i < genericSig.parameters.length; i++){
                const genericParam = genericSig.parameters[i];
                const usageParam = usageSig.parameters[i];
                const isRest = genericSig.declaration && isRestParameter(genericSig.declaration.parameters[i]);
                if (!usageParam) break;
                let genericParamType = genericParam.valueDeclaration ? checker.getTypeOfSymbolAtLocation(genericParam, genericParam.valueDeclaration) : checker.getAnyType();
                const elementType = isRest && checker.getElementTypeOfArrayType(genericParamType);
                if (elementType) genericParamType = elementType;
                const targetType = ((_a = tryCast(usageParam, isTransientSymbol)) == null ? void 0 : _a.links.type) || (usageParam.valueDeclaration ? checker.getTypeOfSymbolAtLocation(usageParam, usageParam.valueDeclaration) : checker.getAnyType());
                types.push(...inferTypeParameters(genericParamType, targetType, typeParameter));
            }
            const genericReturn = checker.getReturnTypeOfSignature(genericSig);
            const usageReturn = checker.getReturnTypeOfSignature(usageSig);
            types.push(...inferTypeParameters(genericReturn, usageReturn, typeParameter));
            return types;
        }
        function getFunctionFromCalls(calls) {
            return checker.createAnonymousType(/*symbol*/ void 0, createSymbolTable(), [
                getSignatureFromCalls(calls)
            ], emptyArray, emptyArray);
        }
        function getSignatureFromCalls(calls) {
            const parameters2 = [];
            const length2 = Math.max(...calls.map((c)=>c.argumentTypes.length));
            for(let i = 0; i < length2; i++){
                const symbol = checker.createSymbol(1 /* FunctionScopedVariable */ , escapeLeadingUnderscores(`arg${i}`));
                symbol.links.type = combineTypes(calls.map((call)=>call.argumentTypes[i] || checker.getUndefinedType()));
                if (calls.some((call)=>call.argumentTypes[i] === void 0)) symbol.flags |= 16777216 /* Optional */ ;
                parameters2.push(symbol);
            }
            const returnType = combineFromUsage(combineUsages(calls.map((call)=>call.return_)));
            return checker.createSignature(/*declaration*/ void 0, /*typeParameters*/ void 0, /*thisParameter*/ void 0, parameters2, returnType, /*typePredicate*/ void 0, length2, 0 /* None */ );
        }
        function addCandidateType(usage, type) {
            if (type && !(type.flags & 1 /* Any */ ) && !(type.flags & 131072 /* Never */ )) (usage.candidateTypes || (usage.candidateTypes = [])).push(type);
        }
        function addCandidateThisType(usage, type) {
            if (type && !(type.flags & 1 /* Any */ ) && !(type.flags & 131072 /* Never */ )) (usage.candidateThisTypes || (usage.candidateThisTypes = [])).push(type);
        }
    }
    // src/services/codefixes/fixReturnTypeInAsyncFunction.ts
    var fixId41 = "fixReturnTypeInAsyncFunction";
    var errorCodes52 = [
        Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_Did_you_mean_to_write_Promise_0.code
    ];
    registerCodeFix({
        errorCodes: errorCodes52,
        fixIds: [
            fixId41
        ],
        getCodeActions: function getCodeActionsToFixReturnTypeInAsyncFunction(context) {
            const { sourceFile, program, span } = context;
            const checker = program.getTypeChecker();
            const info = getInfo16(sourceFile, program.getTypeChecker(), span.start);
            if (!info) return void 0;
            const { returnTypeNode, returnType, promisedTypeNode, promisedType } = info;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange34(t, sourceFile, returnTypeNode, promisedTypeNode));
            return [
                createCodeFixAction(fixId41, changes, [
                    Diagnostics.Replace_0_with_Promise_1,
                    checker.typeToString(returnType),
                    checker.typeToString(promisedType)
                ], fixId41, Diagnostics.Fix_all_incorrect_return_type_of_an_async_functions)
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes52, (changes, diag2)=>{
                const info = getInfo16(diag2.file, context.program.getTypeChecker(), diag2.start);
                if (info) doChange34(changes, diag2.file, info.returnTypeNode, info.promisedTypeNode);
            })
    });
    function getInfo16(sourceFile, checker, pos) {
        if (isInJSFile(sourceFile)) return void 0;
        const token = getTokenAtPosition(sourceFile, pos);
        const func = findAncestor(token, isFunctionLikeDeclaration);
        const returnTypeNode = func == null ? void 0 : func.type;
        if (!returnTypeNode) return void 0;
        const returnType = checker.getTypeFromTypeNode(returnTypeNode);
        const promisedType = checker.getAwaitedType(returnType) || checker.getVoidType();
        const promisedTypeNode = checker.typeToTypeNode(promisedType, /*enclosingDeclaration*/ returnTypeNode, /*flags*/ void 0);
        if (promisedTypeNode) return {
            returnTypeNode,
            returnType,
            promisedTypeNode,
            promisedType
        };
    }
    function doChange34(changes, sourceFile, returnTypeNode, promisedTypeNode) {
        changes.replaceNode(sourceFile, returnTypeNode, factory.createTypeReferenceNode("Promise", [
            promisedTypeNode
        ]));
    }
    // src/services/codefixes/disableJsDiagnostics.ts
    var fixName4 = "disableJsDiagnostics";
    var fixId42 = "disableJsDiagnostics";
    var errorCodes53 = mapDefined(Object.keys(Diagnostics), (key)=>{
        const diag2 = Diagnostics[key];
        return diag2.category === 1 /* Error */  ? diag2.code : void 0;
    });
    registerCodeFix({
        errorCodes: errorCodes53,
        getCodeActions: function getCodeActionsToDisableJsDiagnostics(context) {
            const { sourceFile, program, span, host, formatContext } = context;
            if (!isInJSFile(sourceFile) || !isCheckJsEnabledForFile(sourceFile, program.getCompilerOptions())) return void 0;
            const newLineCharacter = sourceFile.checkJsDirective ? "" : getNewLineOrDefaultFromHost(host, formatContext.options);
            const fixes = [
                // fixId unnecessary because adding `// @ts-nocheck` even once will ignore every error in the file.
                createCodeFixActionWithoutFixAll(fixName4, [
                    createFileTextChanges(sourceFile.fileName, [
                        createTextChange(sourceFile.checkJsDirective ? createTextSpanFromBounds(sourceFile.checkJsDirective.pos, sourceFile.checkJsDirective.end) : createTextSpan(0, 0), `// @ts-nocheck${newLineCharacter}`)
                    ])
                ], Diagnostics.Disable_checking_for_this_file)
            ];
            if (ts_textChanges_exports.isValidLocationToAddComment(sourceFile, span.start)) fixes.unshift(createCodeFixAction(fixName4, ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange9(t, sourceFile, span.start)), Diagnostics.Ignore_this_error_message, fixId42, Diagnostics.Add_ts_ignore_to_all_error_messages));
            return fixes;
        },
        fixIds: [
            fixId42
        ],
        getAllCodeActions: (context)=>{
            const seenLines = /* @__PURE__ */ new Set();
            return codeFixAll(context, errorCodes53, (changes, diag2)=>{
                if (ts_textChanges_exports.isValidLocationToAddComment(diag2.file, diag2.start)) makeChange9(changes, diag2.file, diag2.start, seenLines);
            });
        }
    });
    function makeChange9(changes, sourceFile, position, seenLines) {
        const { line: lineNumber } = getLineAndCharacterOfPosition(sourceFile, position);
        if (!seenLines || tryAddToSet(seenLines, lineNumber)) changes.insertCommentBeforeLine(sourceFile, lineNumber, position, " @ts-ignore");
    }
    // src/services/codefixes/helpers.ts
    function createMissingMemberNodes(classDeclaration, possiblyMissingSymbols, sourceFile, context, preferences, importAdder, addClassElement) {
        const classMembers = classDeclaration.symbol.members;
        for (const symbol of possiblyMissingSymbols)if (!classMembers.has(symbol.escapedName)) addNewNodeForMemberSymbol(symbol, classDeclaration, sourceFile, context, preferences, importAdder, addClassElement, /*body*/ void 0);
    }
    function getNoopSymbolTrackerWithResolver(context) {
        return {
            trackSymbol: ()=>false,
            moduleResolverHost: getModuleSpecifierResolverHost(context.program, context.host)
        };
    }
    var PreserveOptionalFlags = /* @__PURE__ */ ((PreserveOptionalFlags2)=>{
        PreserveOptionalFlags2[PreserveOptionalFlags2["Method"] = 1] = "Method";
        PreserveOptionalFlags2[PreserveOptionalFlags2["Property"] = 2] = "Property";
        PreserveOptionalFlags2[PreserveOptionalFlags2["All"] = 3] = "All";
        return PreserveOptionalFlags2;
    })(PreserveOptionalFlags || {});
    function addNewNodeForMemberSymbol(symbol, enclosingDeclaration, sourceFile, context, preferences, importAdder, addClassElement, body, preserveOptional = 3 /* All */ , isAmbient = false) {
        const declarations = symbol.getDeclarations();
        const declaration = firstOrUndefined(declarations);
        const checker = context.program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(context.program.getCompilerOptions());
        var _ref;
        const kind = (_ref = declaration == null ? void 0 : declaration.kind) !== null && _ref !== void 0 ? _ref : 172 /* PropertySignature */ ;
        const declarationName = createDeclarationName(symbol, declaration);
        const effectiveModifierFlags = declaration ? getEffectiveModifierFlags(declaration) : 0 /* None */ ;
        let modifierFlags = effectiveModifierFlags & 256 /* Static */ ;
        modifierFlags |= effectiveModifierFlags & 1 /* Public */  ? 1 /* Public */  : effectiveModifierFlags & 4 /* Protected */  ? 4 /* Protected */  : 0 /* None */ ;
        if (declaration && isAutoAccessorPropertyDeclaration(declaration)) modifierFlags |= 512 /* Accessor */ ;
        const modifiers = createModifiers();
        const type = checker.getWidenedType(checker.getTypeOfSymbolAtLocation(symbol, enclosingDeclaration));
        const optional = !!(symbol.flags & 16777216 /* Optional */ );
        const ambient = !!(enclosingDeclaration.flags & 33554432 /* Ambient */ ) || isAmbient;
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const flags = 1 /* NoTruncation */  | (quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ );
        switch(kind){
            case 172 /* PropertySignature */ :
            case 173 /* PropertyDeclaration */ :
                let typeNode = checker.typeToTypeNode(type, enclosingDeclaration, flags, 8 /* AllowUnresolvedNames */ , getNoopSymbolTrackerWithResolver(context));
                if (importAdder) {
                    const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
                    if (importableReference) {
                        typeNode = importableReference.typeNode;
                        importSymbols(importAdder, importableReference.symbols);
                    }
                }
                addClassElement(factory.createPropertyDeclaration(modifiers, declaration ? createName(declarationName) : symbol.getName(), optional && preserveOptional & 2 /* Property */  ? factory.createToken(58 /* QuestionToken */ ) : void 0, typeNode, /*initializer*/ void 0));
                break;
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                {
                    Debug.assertIsDefined(declarations);
                    let typeNode2 = checker.typeToTypeNode(type, enclosingDeclaration, flags, /*internalFlags*/ void 0, getNoopSymbolTrackerWithResolver(context));
                    const allAccessors = getAllAccessorDeclarations(declarations, declaration);
                    const orderedAccessors = allAccessors.secondAccessor ? [
                        allAccessors.firstAccessor,
                        allAccessors.secondAccessor
                    ] : [
                        allAccessors.firstAccessor
                    ];
                    if (importAdder) {
                        const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode2, scriptTarget);
                        if (importableReference) {
                            typeNode2 = importableReference.typeNode;
                            importSymbols(importAdder, importableReference.symbols);
                        }
                    }
                    for (const accessor of orderedAccessors)if (isGetAccessorDeclaration(accessor)) addClassElement(factory.createGetAccessorDeclaration(modifiers, createName(declarationName), emptyArray, createTypeNode(typeNode2), createBody(body, quotePreference, ambient)));
                    else {
                        Debug.assertNode(accessor, isSetAccessorDeclaration, "The counterpart to a getter should be a setter");
                        const parameter = getSetAccessorValueParameter(accessor);
                        const parameterName = parameter && isIdentifier(parameter.name) ? idText(parameter.name) : void 0;
                        addClassElement(factory.createSetAccessorDeclaration(modifiers, createName(declarationName), createDummyParameters(1, [
                            parameterName
                        ], [
                            createTypeNode(typeNode2)
                        ], 1, /*inJs*/ false), createBody(body, quotePreference, ambient)));
                    }
                    break;
                }
            case 174 /* MethodSignature */ :
            case 175 /* MethodDeclaration */ :
                Debug.assertIsDefined(declarations);
                const signatures = type.isUnion() ? flatMap(type.types, (t)=>t.getCallSignatures()) : type.getCallSignatures();
                if (!some(signatures)) break;
                if (declarations.length === 1) {
                    Debug.assert(signatures.length === 1, "One declaration implies one signature");
                    const signature = signatures[0];
                    outputMethod(quotePreference, signature, modifiers, createName(declarationName), createBody(body, quotePreference, ambient));
                    break;
                }
                for (const signature of signatures){
                    if (signature.declaration && signature.declaration.flags & 33554432 /* Ambient */ ) continue;
                    outputMethod(quotePreference, signature, modifiers, createName(declarationName));
                }
                if (!ambient) {
                    if (declarations.length > signatures.length) {
                        const signature = checker.getSignatureFromDeclaration(declarations[declarations.length - 1]);
                        outputMethod(quotePreference, signature, modifiers, createName(declarationName), createBody(body, quotePreference));
                    } else {
                        Debug.assert(declarations.length === signatures.length, "Declarations and signatures should match count");
                        addClassElement(createMethodImplementingSignatures(checker, context, enclosingDeclaration, signatures, createName(declarationName), optional && !!(preserveOptional & 1 /* Method */ ), modifiers, quotePreference, body));
                    }
                }
                break;
        }
        function outputMethod(quotePreference2, signature, modifiers2, name, body2) {
            const method = createSignatureDeclarationFromSignature(175 /* MethodDeclaration */ , context, quotePreference2, signature, body2, name, modifiers2, optional && !!(preserveOptional & 1 /* Method */ ), enclosingDeclaration, importAdder);
            if (method) addClassElement(method);
        }
        function createModifiers() {
            let modifiers2;
            if (modifierFlags) modifiers2 = combine(modifiers2, factory.createModifiersFromModifierFlags(modifierFlags));
            if (shouldAddOverrideKeyword()) modifiers2 = append(modifiers2, factory.createToken(164 /* OverrideKeyword */ ));
            return modifiers2 && factory.createNodeArray(modifiers2);
        }
        function shouldAddOverrideKeyword() {
            return !!(context.program.getCompilerOptions().noImplicitOverride && declaration && hasAbstractModifier(declaration));
        }
        function createName(node) {
            if (isIdentifier(node) && node.escapedText === "constructor") return factory.createComputedPropertyName(factory.createStringLiteral(idText(node), quotePreference === 0 /* Single */ ));
            return getSynthesizedDeepClone(node, /*includeTrivia*/ false);
        }
        function createBody(block, quotePreference2, ambient2) {
            return ambient2 ? void 0 : getSynthesizedDeepClone(block, /*includeTrivia*/ false) || createStubbedMethodBody(quotePreference2);
        }
        function createTypeNode(typeNode) {
            return getSynthesizedDeepClone(typeNode, /*includeTrivia*/ false);
        }
        function createDeclarationName(symbol2, declaration2) {
            if (getCheckFlags(symbol2) & 262144 /* Mapped */ ) {
                const nameType = symbol2.links.nameType;
                if (nameType && isTypeUsableAsPropertyName(nameType)) return factory.createIdentifier(unescapeLeadingUnderscores(getPropertyNameFromType(nameType)));
            }
            return getSynthesizedDeepClone(getNameOfDeclaration(declaration2), /*includeTrivia*/ false);
        }
    }
    function createSignatureDeclarationFromSignature(kind, context, quotePreference, signature, body, name, modifiers, optional, enclosingDeclaration, importAdder) {
        const program = context.program;
        const checker = program.getTypeChecker();
        const scriptTarget = getEmitScriptTarget(program.getCompilerOptions());
        const isJs = isInJSFile(enclosingDeclaration);
        const flags = 524545 /* AllowEmptyTuple */  | (quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ );
        const signatureDeclaration = checker.signatureToSignatureDeclaration(signature, kind, enclosingDeclaration, flags, 8 /* AllowUnresolvedNames */ , getNoopSymbolTrackerWithResolver(context));
        if (!signatureDeclaration) return void 0;
        let typeParameters = isJs ? void 0 : signatureDeclaration.typeParameters;
        let parameters = signatureDeclaration.parameters;
        let type = isJs ? void 0 : getSynthesizedDeepClone(signatureDeclaration.type);
        if (importAdder) {
            if (typeParameters) {
                const newTypeParameters = sameMap(typeParameters, (typeParameterDecl)=>{
                    let constraint = typeParameterDecl.constraint;
                    let defaultType = typeParameterDecl.default;
                    if (constraint) {
                        const importableReference = tryGetAutoImportableReferenceFromTypeNode(constraint, scriptTarget);
                        if (importableReference) {
                            constraint = importableReference.typeNode;
                            importSymbols(importAdder, importableReference.symbols);
                        }
                    }
                    if (defaultType) {
                        const importableReference = tryGetAutoImportableReferenceFromTypeNode(defaultType, scriptTarget);
                        if (importableReference) {
                            defaultType = importableReference.typeNode;
                            importSymbols(importAdder, importableReference.symbols);
                        }
                    }
                    return factory.updateTypeParameterDeclaration(typeParameterDecl, typeParameterDecl.modifiers, typeParameterDecl.name, constraint, defaultType);
                });
                if (typeParameters !== newTypeParameters) typeParameters = setTextRange(factory.createNodeArray(newTypeParameters, typeParameters.hasTrailingComma), typeParameters);
            }
            const newParameters = sameMap(parameters, (parameterDecl)=>{
                let type2 = isJs ? void 0 : parameterDecl.type;
                if (type2) {
                    const importableReference = tryGetAutoImportableReferenceFromTypeNode(type2, scriptTarget);
                    if (importableReference) {
                        type2 = importableReference.typeNode;
                        importSymbols(importAdder, importableReference.symbols);
                    }
                }
                return factory.updateParameterDeclaration(parameterDecl, parameterDecl.modifiers, parameterDecl.dotDotDotToken, parameterDecl.name, isJs ? void 0 : parameterDecl.questionToken, type2, parameterDecl.initializer);
            });
            if (parameters !== newParameters) parameters = setTextRange(factory.createNodeArray(newParameters, parameters.hasTrailingComma), parameters);
            if (type) {
                const importableReference = tryGetAutoImportableReferenceFromTypeNode(type, scriptTarget);
                if (importableReference) {
                    type = importableReference.typeNode;
                    importSymbols(importAdder, importableReference.symbols);
                }
            }
        }
        const questionToken = optional ? factory.createToken(58 /* QuestionToken */ ) : void 0;
        const asteriskToken = signatureDeclaration.asteriskToken;
        if (isFunctionExpression(signatureDeclaration)) return factory.updateFunctionExpression(signatureDeclaration, modifiers, signatureDeclaration.asteriskToken, tryCast(name, isIdentifier), typeParameters, parameters, type, body !== null && body !== void 0 ? body : signatureDeclaration.body);
        if (isArrowFunction(signatureDeclaration)) return factory.updateArrowFunction(signatureDeclaration, modifiers, typeParameters, parameters, type, signatureDeclaration.equalsGreaterThanToken, body !== null && body !== void 0 ? body : signatureDeclaration.body);
        if (isMethodDeclaration(signatureDeclaration)) return factory.updateMethodDeclaration(signatureDeclaration, modifiers, asteriskToken, name !== null && name !== void 0 ? name : factory.createIdentifier(""), questionToken, typeParameters, parameters, type, body);
        if (isFunctionDeclaration(signatureDeclaration)) return factory.updateFunctionDeclaration(signatureDeclaration, modifiers, signatureDeclaration.asteriskToken, tryCast(name, isIdentifier), typeParameters, parameters, type, body !== null && body !== void 0 ? body : signatureDeclaration.body);
        return void 0;
    }
    function createSignatureDeclarationFromCallExpression(kind, context, importAdder, call, name, modifierFlags, contextNode) {
        const quotePreference = getQuotePreference(context.sourceFile, context.preferences);
        const scriptTarget = getEmitScriptTarget(context.program.getCompilerOptions());
        const tracker = getNoopSymbolTrackerWithResolver(context);
        const checker = context.program.getTypeChecker();
        const isJs = isInJSFile(contextNode);
        const { typeArguments, arguments: args, parent: parent2 } = call;
        const contextualType = isJs ? void 0 : checker.getContextualType(call);
        const names = map(args, (arg)=>isIdentifier(arg) ? arg.text : isPropertyAccessExpression(arg) && isIdentifier(arg.name) ? arg.name.text : void 0);
        const instanceTypes = isJs ? [] : map(args, (arg)=>checker.getTypeAtLocation(arg));
        const { argumentTypeNodes, argumentTypeParameters } = getArgumentTypesAndTypeParameters(checker, importAdder, instanceTypes, contextNode, scriptTarget, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ , tracker);
        const modifiers = modifierFlags ? factory.createNodeArray(factory.createModifiersFromModifierFlags(modifierFlags)) : void 0;
        const asteriskToken = isYieldExpression(parent2) ? factory.createToken(42 /* AsteriskToken */ ) : void 0;
        const typeParameters = isJs ? void 0 : createTypeParametersForArguments(checker, argumentTypeParameters, typeArguments);
        const parameters = createDummyParameters(args.length, names, argumentTypeNodes, /*minArgumentCount*/ void 0, isJs);
        const type = isJs || contextualType === void 0 ? void 0 : checker.typeToTypeNode(contextualType, contextNode, /*flags*/ void 0, /*internalFlags*/ void 0, tracker);
        switch(kind){
            case 175 /* MethodDeclaration */ :
                return factory.createMethodDeclaration(modifiers, asteriskToken, name, /*questionToken*/ void 0, typeParameters, parameters, type, createStubbedMethodBody(quotePreference));
            case 174 /* MethodSignature */ :
                return factory.createMethodSignature(modifiers, name, /*questionToken*/ void 0, typeParameters, parameters, type === void 0 ? factory.createKeywordTypeNode(159 /* UnknownKeyword */ ) : type);
            case 263 /* FunctionDeclaration */ :
                Debug.assert(typeof name === "string" || isIdentifier(name), "Unexpected name");
                return factory.createFunctionDeclaration(modifiers, asteriskToken, name, typeParameters, parameters, type, createStubbedBody(Diagnostics.Function_not_implemented.message, quotePreference));
            default:
                Debug.fail("Unexpected kind");
        }
    }
    function createTypeParametersForArguments(checker, argumentTypeParameters, typeArguments) {
        const usedNames = new Set(argumentTypeParameters.map((pair)=>pair[0]));
        const constraintsByName = new Map(argumentTypeParameters);
        if (typeArguments) {
            const typeArgumentsWithNewTypes = typeArguments.filter((typeArgument)=>!argumentTypeParameters.some((pair)=>{
                    var _a;
                    return checker.getTypeAtLocation(typeArgument) === ((_a = pair[1]) == null ? void 0 : _a.argumentType);
                }));
            const targetSize = usedNames.size + typeArgumentsWithNewTypes.length;
            for(let i = 0; usedNames.size < targetSize; i += 1)usedNames.add(createTypeParameterName(i));
        }
        return arrayFrom(usedNames.values(), (usedName)=>{
            var _a;
            return factory.createTypeParameterDeclaration(/*modifiers*/ void 0, usedName, (_a = constraintsByName.get(usedName)) == null ? void 0 : _a.constraint);
        });
    }
    function createTypeParameterName(index) {
        return 84 /* T */  + index <= 90 /* Z */  ? String.fromCharCode(84 /* T */  + index) : `T${index}`;
    }
    function typeToAutoImportableTypeNode(checker, importAdder, type, contextNode, scriptTarget, flags, internalFlags, tracker) {
        const typeNode = checker.typeToTypeNode(type, contextNode, flags, internalFlags, tracker);
        if (!typeNode) return void 0;
        return typeNodeToAutoImportableTypeNode(typeNode, importAdder, scriptTarget);
    }
    function typeNodeToAutoImportableTypeNode(typeNode, importAdder, scriptTarget) {
        const importableReference = tryGetAutoImportableReferenceFromTypeNode(typeNode, scriptTarget);
        if (importableReference) {
            importSymbols(importAdder, importableReference.symbols);
            typeNode = importableReference.typeNode;
        }
        return getSynthesizedDeepClone(typeNode);
    }
    function endOfRequiredTypeParameters(checker, type) {
        var _a;
        Debug.assert(type.typeArguments);
        const fullTypeArguments = type.typeArguments;
        const target = type.target;
        for(let cutoff = 0; cutoff < fullTypeArguments.length; cutoff++){
            if (((_a = target.localTypeParameters) == null ? void 0 : _a[cutoff].constraint) === void 0) continue;
            const typeArguments = fullTypeArguments.slice(0, cutoff);
            const filledIn = checker.fillMissingTypeArguments(typeArguments, target.typeParameters, cutoff, /*isJavaScriptImplicitAny*/ false);
            if (filledIn.every((fill, i)=>fill === fullTypeArguments[i])) return cutoff;
        }
        return fullTypeArguments.length;
    }
    function typeToMinimizedReferenceType(checker, type, contextNode, flags, internalFlags, tracker) {
        let typeNode = checker.typeToTypeNode(type, contextNode, flags, internalFlags, tracker);
        if (!typeNode) return void 0;
        if (isTypeReferenceNode(typeNode)) {
            const genericType = type;
            if (genericType.typeArguments && typeNode.typeArguments) {
                const cutoff = endOfRequiredTypeParameters(checker, genericType);
                if (cutoff < typeNode.typeArguments.length) {
                    const newTypeArguments = factory.createNodeArray(typeNode.typeArguments.slice(0, cutoff));
                    typeNode = factory.updateTypeReferenceNode(typeNode, typeNode.typeName, newTypeArguments);
                }
            }
        }
        return typeNode;
    }
    function typePredicateToAutoImportableTypeNode(checker, importAdder, typePredicate, contextNode, scriptTarget, flags, internalFlags, tracker) {
        let typePredicateNode = checker.typePredicateToTypePredicateNode(typePredicate, contextNode, flags, internalFlags, tracker);
        if ((typePredicateNode == null ? void 0 : typePredicateNode.type) && isImportTypeNode(typePredicateNode.type)) {
            const importableReference = tryGetAutoImportableReferenceFromTypeNode(typePredicateNode.type, scriptTarget);
            if (importableReference) {
                importSymbols(importAdder, importableReference.symbols);
                typePredicateNode = factory.updateTypePredicateNode(typePredicateNode, typePredicateNode.assertsModifier, typePredicateNode.parameterName, importableReference.typeNode);
            }
        }
        return getSynthesizedDeepClone(typePredicateNode);
    }
    function typeContainsTypeParameter(type) {
        if (type.isUnionOrIntersection()) return type.types.some(typeContainsTypeParameter);
        return type.flags & 262144 /* TypeParameter */ ;
    }
    function getArgumentTypesAndTypeParameters(checker, importAdder, instanceTypes, contextNode, scriptTarget, flags, internalFlags, tracker) {
        const argumentTypeNodes = [];
        const argumentTypeParameters = /* @__PURE__ */ new Map();
        for(let i = 0; i < instanceTypes.length; i += 1){
            const instanceType = instanceTypes[i];
            if (instanceType.isUnionOrIntersection() && instanceType.types.some(typeContainsTypeParameter)) {
                const synthesizedTypeParameterName = createTypeParameterName(i);
                argumentTypeNodes.push(factory.createTypeReferenceNode(synthesizedTypeParameterName));
                argumentTypeParameters.set(synthesizedTypeParameterName, void 0);
                continue;
            }
            const widenedInstanceType = checker.getBaseTypeOfLiteralType(instanceType);
            const argumentTypeNode = typeToAutoImportableTypeNode(checker, importAdder, widenedInstanceType, contextNode, scriptTarget, flags, internalFlags, tracker);
            if (!argumentTypeNode) continue;
            argumentTypeNodes.push(argumentTypeNode);
            const argumentTypeParameter = getFirstTypeParameterName(instanceType);
            const instanceTypeConstraint = instanceType.isTypeParameter() && instanceType.constraint && !isAnonymousObjectConstraintType(instanceType.constraint) ? typeToAutoImportableTypeNode(checker, importAdder, instanceType.constraint, contextNode, scriptTarget, flags, internalFlags, tracker) : void 0;
            if (argumentTypeParameter) argumentTypeParameters.set(argumentTypeParameter, {
                argumentType: instanceType,
                constraint: instanceTypeConstraint
            });
        }
        return {
            argumentTypeNodes,
            argumentTypeParameters: arrayFrom(argumentTypeParameters.entries())
        };
    }
    function isAnonymousObjectConstraintType(type) {
        return type.flags & 524288 /* Object */  && type.objectFlags === 16 /* Anonymous */ ;
    }
    function getFirstTypeParameterName(type) {
        var _a;
        if (type.flags & 3145728 /* Intersection */ ) for (const subType of type.types){
            const subTypeName = getFirstTypeParameterName(subType);
            if (subTypeName) return subTypeName;
        }
        return type.flags & 262144 /* TypeParameter */  ? (_a = type.getSymbol()) == null ? void 0 : _a.getName() : void 0;
    }
    function createDummyParameters(argCount, names, types, minArgumentCount, inJs) {
        const parameters = [];
        const parameterNameCounts = /* @__PURE__ */ new Map();
        for(let i = 0; i < argCount; i++){
            const parameterName = (names == null ? void 0 : names[i]) || `arg${i}`;
            const parameterNameCount = parameterNameCounts.get(parameterName);
            parameterNameCounts.set(parameterName, (parameterNameCount || 0) + 1);
            const newParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, /*name*/ parameterName + (parameterNameCount || ""), /*questionToken*/ minArgumentCount !== void 0 && i >= minArgumentCount ? factory.createToken(58 /* QuestionToken */ ) : void 0, /*type*/ inJs ? void 0 : (types == null ? void 0 : types[i]) || factory.createKeywordTypeNode(159 /* UnknownKeyword */ ), /*initializer*/ void 0);
            parameters.push(newParameter);
        }
        return parameters;
    }
    function createMethodImplementingSignatures(checker, context, enclosingDeclaration, signatures, name, optional, modifiers, quotePreference, body) {
        let maxArgsSignature = signatures[0];
        let minArgumentCount = signatures[0].minArgumentCount;
        let someSigHasRestParameter = false;
        for (const sig of signatures){
            minArgumentCount = Math.min(sig.minArgumentCount, minArgumentCount);
            if (signatureHasRestParameter(sig)) someSigHasRestParameter = true;
            if (sig.parameters.length >= maxArgsSignature.parameters.length && (!signatureHasRestParameter(sig) || signatureHasRestParameter(maxArgsSignature))) maxArgsSignature = sig;
        }
        const maxNonRestArgs = maxArgsSignature.parameters.length - (signatureHasRestParameter(maxArgsSignature) ? 1 : 0);
        const maxArgsParameterSymbolNames = maxArgsSignature.parameters.map((symbol)=>symbol.name);
        const parameters = createDummyParameters(maxNonRestArgs, maxArgsParameterSymbolNames, /*types*/ void 0, minArgumentCount, /*inJs*/ false);
        if (someSigHasRestParameter) {
            const restParameter = factory.createParameterDeclaration(/*modifiers*/ void 0, factory.createToken(26 /* DotDotDotToken */ ), maxArgsParameterSymbolNames[maxNonRestArgs] || "rest", /*questionToken*/ maxNonRestArgs >= minArgumentCount ? factory.createToken(58 /* QuestionToken */ ) : void 0, factory.createArrayTypeNode(factory.createKeywordTypeNode(159 /* UnknownKeyword */ )), /*initializer*/ void 0);
            parameters.push(restParameter);
        }
        return createStubbedMethod(modifiers, name, optional, /*typeParameters*/ void 0, parameters, getReturnTypeFromSignatures(signatures, checker, context, enclosingDeclaration), quotePreference, body);
    }
    function getReturnTypeFromSignatures(signatures, checker, context, enclosingDeclaration) {
        if (length(signatures)) {
            const type = checker.getUnionType(map(signatures, checker.getReturnTypeOfSignature));
            return checker.typeToTypeNode(type, enclosingDeclaration, 1 /* NoTruncation */ , 8 /* AllowUnresolvedNames */ , getNoopSymbolTrackerWithResolver(context));
        }
    }
    function createStubbedMethod(modifiers, name, optional, typeParameters, parameters, returnType, quotePreference, body) {
        return factory.createMethodDeclaration(modifiers, /*asteriskToken*/ void 0, name, optional ? factory.createToken(58 /* QuestionToken */ ) : void 0, typeParameters, parameters, returnType, body || createStubbedMethodBody(quotePreference));
    }
    function createStubbedMethodBody(quotePreference) {
        return createStubbedBody(Diagnostics.Method_not_implemented.message, quotePreference);
    }
    function createStubbedBody(text, quotePreference) {
        return factory.createBlock([
            factory.createThrowStatement(factory.createNewExpression(factory.createIdentifier("Error"), /*typeArguments*/ void 0, // TODO Handle auto quote preference.
            [
                factory.createStringLiteral(text, /*isSingleQuote*/ quotePreference === 0 /* Single */ )
            ]))
        ], /*multiLine*/ true);
    }
    function setJsonCompilerOptionValues(changeTracker, configFile, options) {
        const tsconfigObjectLiteral = getTsConfigObjectLiteralExpression(configFile);
        if (!tsconfigObjectLiteral) return void 0;
        const compilerOptionsProperty = findJsonProperty(tsconfigObjectLiteral, "compilerOptions");
        if (compilerOptionsProperty === void 0) {
            changeTracker.insertNodeAtObjectStart(configFile, tsconfigObjectLiteral, createJsonPropertyAssignment("compilerOptions", factory.createObjectLiteralExpression(options.map(([optionName, optionValue])=>createJsonPropertyAssignment(optionName, optionValue)), /*multiLine*/ true)));
            return;
        }
        const compilerOptions = compilerOptionsProperty.initializer;
        if (!isObjectLiteralExpression(compilerOptions)) return;
        for (const [optionName, optionValue] of options){
            const optionProperty = findJsonProperty(compilerOptions, optionName);
            if (optionProperty === void 0) changeTracker.insertNodeAtObjectStart(configFile, compilerOptions, createJsonPropertyAssignment(optionName, optionValue));
            else changeTracker.replaceNode(configFile, optionProperty.initializer, optionValue);
        }
    }
    function setJsonCompilerOptionValue(changeTracker, configFile, optionName, optionValue) {
        setJsonCompilerOptionValues(changeTracker, configFile, [
            [
                optionName,
                optionValue
            ]
        ]);
    }
    function createJsonPropertyAssignment(name, initializer) {
        return factory.createPropertyAssignment(factory.createStringLiteral(name), initializer);
    }
    function findJsonProperty(obj, name) {
        return find(obj.properties, (p)=>isPropertyAssignment(p) && !!p.name && isStringLiteral(p.name) && p.name.text === name);
    }
    function tryGetAutoImportableReferenceFromTypeNode(importTypeNode, scriptTarget) {
        let symbols;
        const typeNode = visitNode(importTypeNode, visit, isTypeNode);
        if (symbols && typeNode) return {
            typeNode,
            symbols
        };
        function visit(node) {
            if (isLiteralImportTypeNode(node) && node.qualifier) {
                const firstIdentifier = getFirstIdentifier(node.qualifier);
                if (!firstIdentifier.symbol) return visitEachChild(node, visit, /*context*/ void 0);
                const name = getNameForExportedSymbol(firstIdentifier.symbol, scriptTarget);
                const qualifier = name !== firstIdentifier.text ? replaceFirstIdentifierOfEntityName(node.qualifier, factory.createIdentifier(name)) : node.qualifier;
                symbols = append(symbols, firstIdentifier.symbol);
                const typeArguments = visitNodes2(node.typeArguments, visit, isTypeNode);
                return factory.createTypeReferenceNode(qualifier, typeArguments);
            }
            return visitEachChild(node, visit, /*context*/ void 0);
        }
    }
    function replaceFirstIdentifierOfEntityName(name, newIdentifier) {
        if (name.kind === 80 /* Identifier */ ) return newIdentifier;
        return factory.createQualifiedName(replaceFirstIdentifierOfEntityName(name.left, newIdentifier), name.right);
    }
    function importSymbols(importAdder, symbols) {
        symbols.forEach((s)=>importAdder.addImportFromExportedSymbol(s, /*isValidTypeOnlyUseSite*/ true));
    }
    function findAncestorMatchingSpan(sourceFile, span) {
        const end = textSpanEnd(span);
        let token = getTokenAtPosition(sourceFile, span.start);
        while(token.end < end)token = token.parent;
        return token;
    }
    // src/services/codefixes/generateAccessors.ts
    function generateAccessorFromProperty(file, program, start, end, context, _actionName) {
        const fieldInfo = getAccessorConvertiblePropertyAtPosition(file, program, start, end);
        if (!fieldInfo || ts_refactor_exports.isRefactorErrorInfo(fieldInfo)) return void 0;
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext(context);
        const { isStatic: isStatic2, isReadonly, fieldName, accessorName, originalName, type, container, declaration } = fieldInfo;
        suppressLeadingAndTrailingTrivia(fieldName);
        suppressLeadingAndTrailingTrivia(accessorName);
        suppressLeadingAndTrailingTrivia(declaration);
        suppressLeadingAndTrailingTrivia(container);
        let accessorModifiers;
        let fieldModifiers;
        if (isClassLike(container)) {
            const modifierFlags = getEffectiveModifierFlags(declaration);
            if (isSourceFileJS(file)) {
                const modifiers = factory.createModifiersFromModifierFlags(modifierFlags);
                accessorModifiers = modifiers;
                fieldModifiers = modifiers;
            } else {
                accessorModifiers = factory.createModifiersFromModifierFlags(prepareModifierFlagsForAccessor(modifierFlags));
                fieldModifiers = factory.createModifiersFromModifierFlags(prepareModifierFlagsForField(modifierFlags));
            }
            if (canHaveDecorators(declaration)) fieldModifiers = concatenate(getDecorators(declaration), fieldModifiers);
        }
        updateFieldDeclaration(changeTracker, file, declaration, type, fieldName, fieldModifiers);
        const getAccessor = generateGetAccessor(fieldName, accessorName, type, accessorModifiers, isStatic2, container);
        suppressLeadingAndTrailingTrivia(getAccessor);
        insertAccessor(changeTracker, file, getAccessor, declaration, container);
        if (isReadonly) {
            const constructor = getFirstConstructorWithBody(container);
            if (constructor) updateReadonlyPropertyInitializerStatementConstructor(changeTracker, file, constructor, fieldName.text, originalName);
        } else {
            const setAccessor = generateSetAccessor(fieldName, accessorName, type, accessorModifiers, isStatic2, container);
            suppressLeadingAndTrailingTrivia(setAccessor);
            insertAccessor(changeTracker, file, setAccessor, declaration, container);
        }
        return changeTracker.getChanges();
    }
    function isConvertibleName(name) {
        return isIdentifier(name) || isStringLiteral(name);
    }
    function isAcceptedDeclaration(node) {
        return isParameterPropertyDeclaration(node, node.parent) || isPropertyDeclaration(node) || isPropertyAssignment(node);
    }
    function createPropertyName(name, originalName) {
        return isIdentifier(originalName) ? factory.createIdentifier(name) : factory.createStringLiteral(name);
    }
    function createAccessorAccessExpression(fieldName, isStatic2, container) {
        const leftHead = isStatic2 ? container.name : factory.createThis();
        return isIdentifier(fieldName) ? factory.createPropertyAccessExpression(leftHead, fieldName) : factory.createElementAccessExpression(leftHead, factory.createStringLiteralFromNode(fieldName));
    }
    function prepareModifierFlagsForAccessor(modifierFlags) {
        modifierFlags &= -9 /* Readonly */ ;
        modifierFlags &= -3 /* Private */ ;
        if (!(modifierFlags & 4 /* Protected */ )) modifierFlags |= 1 /* Public */ ;
        return modifierFlags;
    }
    function prepareModifierFlagsForField(modifierFlags) {
        modifierFlags &= -2 /* Public */ ;
        modifierFlags &= -5 /* Protected */ ;
        modifierFlags |= 2 /* Private */ ;
        return modifierFlags;
    }
    function getAccessorConvertiblePropertyAtPosition(file, program, start, end, considerEmptySpans = true) {
        const node = getTokenAtPosition(file, start);
        const cursorRequest = start === end && considerEmptySpans;
        const declaration = findAncestor(node.parent, isAcceptedDeclaration);
        const meaning = 271 /* Readonly */ ;
        if (!declaration || !(nodeOverlapsWithStartEnd(declaration.name, file, start, end) || cursorRequest)) return {
            error: getLocaleSpecificMessage(Diagnostics.Could_not_find_property_for_which_to_generate_accessor)
        };
        if (!isConvertibleName(declaration.name)) return {
            error: getLocaleSpecificMessage(Diagnostics.Name_is_not_valid)
        };
        if ((getEffectiveModifierFlags(declaration) & 98303 /* Modifier */  | meaning) !== meaning) return {
            error: getLocaleSpecificMessage(Diagnostics.Can_only_convert_property_with_modifier)
        };
        const name = declaration.name.text;
        const startWithUnderscore = startsWithUnderscore(name);
        const fieldName = createPropertyName(startWithUnderscore ? name : getUniqueName(`_${name}`, file), declaration.name);
        const accessorName = createPropertyName(startWithUnderscore ? getUniqueName(name.substring(1), file) : name, declaration.name);
        return {
            isStatic: hasStaticModifier(declaration),
            isReadonly: hasEffectiveReadonlyModifier(declaration),
            type: getDeclarationType(declaration, program),
            container: declaration.kind === 170 /* Parameter */  ? declaration.parent.parent : declaration.parent,
            originalName: declaration.name.text,
            declaration,
            fieldName,
            accessorName,
            renameAccessor: startWithUnderscore
        };
    }
    function generateGetAccessor(fieldName, accessorName, type, modifiers, isStatic2, container) {
        return factory.createGetAccessorDeclaration(modifiers, accessorName, [], type, factory.createBlock([
            factory.createReturnStatement(createAccessorAccessExpression(fieldName, isStatic2, container))
        ], /*multiLine*/ true));
    }
    function generateSetAccessor(fieldName, accessorName, type, modifiers, isStatic2, container) {
        return factory.createSetAccessorDeclaration(modifiers, accessorName, [
            factory.createParameterDeclaration(/*modifiers*/ void 0, /*dotDotDotToken*/ void 0, factory.createIdentifier("value"), /*questionToken*/ void 0, type)
        ], factory.createBlock([
            factory.createExpressionStatement(factory.createAssignment(createAccessorAccessExpression(fieldName, isStatic2, container), factory.createIdentifier("value")))
        ], /*multiLine*/ true));
    }
    function updatePropertyDeclaration(changeTracker, file, declaration, type, fieldName, modifiers) {
        const property = factory.updatePropertyDeclaration(declaration, modifiers, fieldName, declaration.questionToken || declaration.exclamationToken, type, declaration.initializer);
        changeTracker.replaceNode(file, declaration, property);
    }
    function updatePropertyAssignmentDeclaration(changeTracker, file, declaration, fieldName) {
        let assignment = factory.updatePropertyAssignment(declaration, fieldName, declaration.initializer);
        if (assignment.modifiers || assignment.questionToken || assignment.exclamationToken) {
            if (assignment === declaration) assignment = factory.cloneNode(assignment);
            assignment.modifiers = void 0;
            assignment.questionToken = void 0;
            assignment.exclamationToken = void 0;
        }
        changeTracker.replacePropertyAssignment(file, declaration, assignment);
    }
    function updateFieldDeclaration(changeTracker, file, declaration, type, fieldName, modifiers) {
        if (isPropertyDeclaration(declaration)) updatePropertyDeclaration(changeTracker, file, declaration, type, fieldName, modifiers);
        else if (isPropertyAssignment(declaration)) updatePropertyAssignmentDeclaration(changeTracker, file, declaration, fieldName);
        else changeTracker.replaceNode(file, declaration, factory.updateParameterDeclaration(declaration, modifiers, declaration.dotDotDotToken, cast(fieldName, isIdentifier), declaration.questionToken, declaration.type, declaration.initializer));
    }
    function insertAccessor(changeTracker, file, accessor, declaration, container) {
        isParameterPropertyDeclaration(declaration, declaration.parent) ? changeTracker.insertMemberAtStart(file, container, accessor) : isPropertyAssignment(declaration) ? changeTracker.insertNodeAfterComma(file, declaration, accessor) : changeTracker.insertNodeAfter(file, declaration, accessor);
    }
    function updateReadonlyPropertyInitializerStatementConstructor(changeTracker, file, constructor, fieldName, originalName) {
        if (!constructor.body) return;
        constructor.body.forEachChild(function recur(node) {
            if (isElementAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */  && isStringLiteral(node.argumentExpression) && node.argumentExpression.text === originalName && isWriteAccess(node)) changeTracker.replaceNode(file, node.argumentExpression, factory.createStringLiteral(fieldName));
            if (isPropertyAccessExpression(node) && node.expression.kind === 110 /* ThisKeyword */  && node.name.text === originalName && isWriteAccess(node)) changeTracker.replaceNode(file, node.name, factory.createIdentifier(fieldName));
            if (!isFunctionLike(node) && !isClassLike(node)) node.forEachChild(recur);
        });
    }
    function getDeclarationType(declaration, program) {
        const typeNode = getTypeAnnotationNode(declaration);
        if (isPropertyDeclaration(declaration) && typeNode && declaration.questionToken) {
            const typeChecker = program.getTypeChecker();
            const type = typeChecker.getTypeFromTypeNode(typeNode);
            if (!typeChecker.isTypeAssignableTo(typeChecker.getUndefinedType(), type)) {
                const types = isUnionTypeNode(typeNode) ? typeNode.types : [
                    typeNode
                ];
                return factory.createUnionTypeNode([
                    ...types,
                    factory.createKeywordTypeNode(157 /* UndefinedKeyword */ )
                ]);
            }
        }
        return typeNode;
    }
    // src/services/codefixes/fixInvalidImportSyntax.ts
    var fixName5 = "invalidImportSyntax";
    function getCodeFixesForImportDeclaration(context, node) {
        const sourceFile = getSourceFileOfNode(node);
        const namespace = getNamespaceDeclarationNode(node);
        const opts = context.program.getCompilerOptions();
        const variations = [];
        variations.push(createAction(context, sourceFile, node, makeImport(namespace.name, /*namedImports*/ void 0, node.moduleSpecifier, getQuotePreference(sourceFile, context.preferences))));
        if (getEmitModuleKind(opts) === 1 /* CommonJS */ ) variations.push(createAction(context, sourceFile, node, factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, namespace.name, factory.createExternalModuleReference(node.moduleSpecifier))));
        return variations;
    }
    function createAction(context, sourceFile, node, replacement) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(sourceFile, node, replacement));
        return createCodeFixActionWithoutFixAll(fixName5, changes, [
            Diagnostics.Replace_import_with_0,
            changes[0].textChanges[0].newText
        ]);
    }
    registerCodeFix({
        errorCodes: [
            Diagnostics.This_expression_is_not_callable.code,
            Diagnostics.This_expression_is_not_constructable.code
        ],
        getCodeActions: getActionsForUsageOfInvalidImport
    });
    function getActionsForUsageOfInvalidImport(context) {
        const sourceFile = context.sourceFile;
        const targetKind = Diagnostics.This_expression_is_not_callable.code === context.errorCode ? 214 /* CallExpression */  : 215 /* NewExpression */ ;
        const node = findAncestor(getTokenAtPosition(sourceFile, context.span.start), (a)=>a.kind === targetKind);
        if (!node) return [];
        const expr = node.expression;
        return getImportCodeFixesForExpression(context, expr);
    }
    registerCodeFix({
        errorCodes: [
            // The following error codes cover pretty much all assignability errors that could involve an expression
            Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1.code,
            Diagnostics.Type_0_does_not_satisfy_the_constraint_1.code,
            Diagnostics.Type_0_is_not_assignable_to_type_1.code,
            Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated.code,
            Diagnostics.Type_predicate_0_is_not_assignable_to_1.code,
            Diagnostics.Property_0_of_type_1_is_not_assignable_to_2_index_type_3.code,
            Diagnostics._0_index_type_1_is_not_assignable_to_2_index_type_3.code,
            Diagnostics.Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2.code,
            Diagnostics.Property_0_in_type_1_is_not_assignable_to_type_2.code,
            Diagnostics.Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property.code,
            Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1.code
        ],
        getCodeActions: getActionsForInvalidImportLocation
    });
    function getActionsForInvalidImportLocation(context) {
        const sourceFile = context.sourceFile;
        const node = findAncestor(getTokenAtPosition(sourceFile, context.span.start), (a)=>a.getStart() === context.span.start && a.getEnd() === context.span.start + context.span.length);
        if (!node) return [];
        return getImportCodeFixesForExpression(context, node);
    }
    function getImportCodeFixesForExpression(context, expr) {
        const type = context.program.getTypeChecker().getTypeAtLocation(expr);
        if (!(type.symbol && isTransientSymbol(type.symbol) && type.symbol.links.originatingImport)) return [];
        const fixes = [];
        const relatedImport = type.symbol.links.originatingImport;
        if (!isImportCall(relatedImport)) addRange(fixes, getCodeFixesForImportDeclaration(context, relatedImport));
        if (isExpression(expr) && !(isNamedDeclaration(expr.parent) && expr.parent.name === expr)) {
            const sourceFile = context.sourceFile;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>t.replaceNode(sourceFile, expr, factory.createPropertyAccessExpression(expr, "default"), {}));
            fixes.push(createCodeFixActionWithoutFixAll(fixName5, changes, Diagnostics.Use_synthetic_default_member));
        }
        return fixes;
    }
    // src/services/codefixes/fixStrictClassInitialization.ts
    var fixName6 = "strictClassInitialization";
    var fixIdAddDefiniteAssignmentAssertions = "addMissingPropertyDefiniteAssignmentAssertions";
    var fixIdAddUndefinedType = "addMissingPropertyUndefinedType";
    var fixIdAddInitializer = "addMissingPropertyInitializer";
    var errorCodes54 = [
        Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor.code
    ];
    registerCodeFix({
        errorCodes: errorCodes54,
        getCodeActions: function getCodeActionsForStrictClassInitializationErrors(context) {
            const info = getInfo17(context.sourceFile, context.span.start);
            if (!info) return;
            const result = [];
            append(result, getActionForAddMissingUndefinedType(context, info));
            append(result, getActionForAddMissingDefiniteAssignmentAssertion(context, info));
            append(result, getActionForAddMissingInitializer(context, info));
            return result;
        },
        fixIds: [
            fixIdAddDefiniteAssignmentAssertions,
            fixIdAddUndefinedType,
            fixIdAddInitializer
        ],
        getAllCodeActions: (context)=>{
            return codeFixAll(context, errorCodes54, (changes, diag2)=>{
                const info = getInfo17(diag2.file, diag2.start);
                if (!info) return;
                switch(context.fixId){
                    case fixIdAddDefiniteAssignmentAssertions:
                        addDefiniteAssignmentAssertion(changes, diag2.file, info.prop);
                        break;
                    case fixIdAddUndefinedType:
                        addUndefinedType(changes, diag2.file, info);
                        break;
                    case fixIdAddInitializer:
                        const checker = context.program.getTypeChecker();
                        const initializer = getInitializer(checker, info.prop);
                        if (!initializer) return;
                        addInitializer(changes, diag2.file, info.prop, initializer);
                        break;
                    default:
                        Debug.fail(JSON.stringify(context.fixId));
                }
            });
        }
    });
    function getInfo17(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        if (isIdentifier(token) && isPropertyDeclaration(token.parent)) {
            const type = getEffectiveTypeAnnotationNode(token.parent);
            if (type) return {
                type,
                prop: token.parent,
                isJs: isInJSFile(token.parent)
            };
        }
        return void 0;
    }
    function getActionForAddMissingDefiniteAssignmentAssertion(context, info) {
        if (info.isJs) return void 0;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addDefiniteAssignmentAssertion(t, context.sourceFile, info.prop));
        return createCodeFixAction(fixName6, changes, [
            Diagnostics.Add_definite_assignment_assertion_to_property_0,
            info.prop.getText()
        ], fixIdAddDefiniteAssignmentAssertions, Diagnostics.Add_definite_assignment_assertions_to_all_uninitialized_properties);
    }
    function addDefiniteAssignmentAssertion(changeTracker, propertyDeclarationSourceFile, propertyDeclaration) {
        suppressLeadingAndTrailingTrivia(propertyDeclaration);
        const property = factory.updatePropertyDeclaration(propertyDeclaration, propertyDeclaration.modifiers, propertyDeclaration.name, factory.createToken(54 /* ExclamationToken */ ), propertyDeclaration.type, propertyDeclaration.initializer);
        changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property);
    }
    function getActionForAddMissingUndefinedType(context, info) {
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addUndefinedType(t, context.sourceFile, info));
        return createCodeFixAction(fixName6, changes, [
            Diagnostics.Add_undefined_type_to_property_0,
            info.prop.name.getText()
        ], fixIdAddUndefinedType, Diagnostics.Add_undefined_type_to_all_uninitialized_properties);
    }
    function addUndefinedType(changeTracker, sourceFile, info) {
        const undefinedTypeNode = factory.createKeywordTypeNode(157 /* UndefinedKeyword */ );
        const types = isUnionTypeNode(info.type) ? info.type.types.concat(undefinedTypeNode) : [
            info.type,
            undefinedTypeNode
        ];
        const unionTypeNode = factory.createUnionTypeNode(types);
        if (info.isJs) changeTracker.addJSDocTags(sourceFile, info.prop, [
            factory.createJSDocTypeTag(/*tagName*/ void 0, factory.createJSDocTypeExpression(unionTypeNode))
        ]);
        else changeTracker.replaceNode(sourceFile, info.type, unionTypeNode);
    }
    function getActionForAddMissingInitializer(context, info) {
        if (info.isJs) return void 0;
        const checker = context.program.getTypeChecker();
        const initializer = getInitializer(checker, info.prop);
        if (!initializer) return void 0;
        const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>addInitializer(t, context.sourceFile, info.prop, initializer));
        return createCodeFixAction(fixName6, changes, [
            Diagnostics.Add_initializer_to_property_0,
            info.prop.name.getText()
        ], fixIdAddInitializer, Diagnostics.Add_initializers_to_all_uninitialized_properties);
    }
    function addInitializer(changeTracker, propertyDeclarationSourceFile, propertyDeclaration, initializer) {
        suppressLeadingAndTrailingTrivia(propertyDeclaration);
        const property = factory.updatePropertyDeclaration(propertyDeclaration, propertyDeclaration.modifiers, propertyDeclaration.name, propertyDeclaration.questionToken, propertyDeclaration.type, initializer);
        changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property);
    }
    function getInitializer(checker, propertyDeclaration) {
        return getDefaultValueFromType(checker, checker.getTypeFromTypeNode(propertyDeclaration.type));
    }
    function getDefaultValueFromType(checker, type) {
        if (type.flags & 512 /* BooleanLiteral */ ) return type === checker.getFalseType() || type === checker.getFalseType(/*fresh*/ true) ? factory.createFalse() : factory.createTrue();
        else if (type.isStringLiteral()) return factory.createStringLiteral(type.value);
        else if (type.isNumberLiteral()) return factory.createNumericLiteral(type.value);
        else if (type.flags & 2048 /* BigIntLiteral */ ) return factory.createBigIntLiteral(type.value);
        else if (type.isUnion()) return firstDefined(type.types, (t)=>getDefaultValueFromType(checker, t));
        else if (type.isClass()) {
            const classDeclaration = getClassLikeDeclarationOfSymbol(type.symbol);
            if (!classDeclaration || hasSyntacticModifier(classDeclaration, 64 /* Abstract */ )) return void 0;
            const constructorDeclaration = getFirstConstructorWithBody(classDeclaration);
            if (constructorDeclaration && constructorDeclaration.parameters.length) return void 0;
            return factory.createNewExpression(factory.createIdentifier(type.symbol.name), /*typeArguments*/ void 0, /*argumentsArray*/ void 0);
        } else if (checker.isArrayLikeType(type)) return factory.createArrayLiteralExpression();
        return void 0;
    }
    // src/services/codefixes/requireInTs.ts
    var fixId43 = "requireInTs";
    var errorCodes55 = [
        Diagnostics.require_call_may_be_converted_to_an_import.code
    ];
    registerCodeFix({
        errorCodes: errorCodes55,
        getCodeActions (context) {
            const info = getInfo18(context.sourceFile, context.program, context.span.start, context.preferences);
            if (!info) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange35(t, context.sourceFile, info));
            return [
                createCodeFixAction(fixId43, changes, Diagnostics.Convert_require_to_import, fixId43, Diagnostics.Convert_all_require_to_import)
            ];
        },
        fixIds: [
            fixId43
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes55, (changes, diag2)=>{
                const info = getInfo18(diag2.file, context.program, diag2.start, context.preferences);
                if (info) doChange35(changes, context.sourceFile, info);
            })
    });
    function doChange35(changes, sourceFile, info) {
        const { allowSyntheticDefaults, defaultImportName, namedImports, statement, moduleSpecifier } = info;
        changes.replaceNode(sourceFile, statement, defaultImportName && !allowSyntheticDefaults ? factory.createImportEqualsDeclaration(/*modifiers*/ void 0, /*isTypeOnly*/ false, defaultImportName, factory.createExternalModuleReference(moduleSpecifier)) : factory.createImportDeclaration(/*modifiers*/ void 0, factory.createImportClause(/*phaseModifier*/ void 0, defaultImportName, namedImports), moduleSpecifier, /*attributes*/ void 0));
    }
    function getInfo18(sourceFile, program, pos, preferences) {
        const { parent: parent2 } = getTokenAtPosition(sourceFile, pos);
        if (!isRequireCall(parent2, /*requireStringLiteralLikeArgument*/ true)) Debug.failBadSyntaxKind(parent2);
        const decl = cast(parent2.parent, isVariableDeclaration);
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const defaultImportName = tryCast(decl.name, isIdentifier);
        const namedImports = isObjectBindingPattern(decl.name) ? tryCreateNamedImportsFromObjectBindingPattern(decl.name) : void 0;
        if (defaultImportName || namedImports) {
            const moduleSpecifier = first(parent2.arguments);
            return {
                allowSyntheticDefaults: getAllowSyntheticDefaultImports(program.getCompilerOptions()),
                defaultImportName,
                namedImports,
                statement: cast(decl.parent.parent, isVariableStatement),
                moduleSpecifier: isNoSubstitutionTemplateLiteral(moduleSpecifier) ? factory.createStringLiteral(moduleSpecifier.text, quotePreference === 0 /* Single */ ) : moduleSpecifier
            };
        }
    }
    function tryCreateNamedImportsFromObjectBindingPattern(node) {
        const importSpecifiers = [];
        for (const element of node.elements){
            if (!isIdentifier(element.name) || element.initializer) return void 0;
            importSpecifiers.push(factory.createImportSpecifier(/*isTypeOnly*/ false, tryCast(element.propertyName, isIdentifier), element.name));
        }
        if (importSpecifiers.length) return factory.createNamedImports(importSpecifiers);
    }
    // src/services/codefixes/useDefaultImport.ts
    var fixId44 = "useDefaultImport";
    var errorCodes56 = [
        Diagnostics.Import_may_be_converted_to_a_default_import.code
    ];
    registerCodeFix({
        errorCodes: errorCodes56,
        getCodeActions (context) {
            const { sourceFile, span: { start } } = context;
            const info = getInfo19(sourceFile, start);
            if (!info) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange36(t, sourceFile, info, context.preferences));
            return [
                createCodeFixAction(fixId44, changes, Diagnostics.Convert_to_default_import, fixId44, Diagnostics.Convert_all_to_default_imports)
            ];
        },
        fixIds: [
            fixId44
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes56, (changes, diag2)=>{
                const info = getInfo19(diag2.file, diag2.start);
                if (info) doChange36(changes, diag2.file, info, context.preferences);
            })
    });
    function getInfo19(sourceFile, pos) {
        const name = getTokenAtPosition(sourceFile, pos);
        if (!isIdentifier(name)) return void 0;
        const { parent: parent2 } = name;
        if (isImportEqualsDeclaration(parent2) && isExternalModuleReference(parent2.moduleReference)) return {
            importNode: parent2,
            name,
            moduleSpecifier: parent2.moduleReference.expression
        };
        else if (isNamespaceImport(parent2) && isImportDeclaration(parent2.parent.parent)) {
            const importNode = parent2.parent.parent;
            return {
                importNode,
                name,
                moduleSpecifier: importNode.moduleSpecifier
            };
        }
    }
    function doChange36(changes, sourceFile, info, preferences) {
        changes.replaceNode(sourceFile, info.importNode, makeImport(info.name, /*namedImports*/ void 0, info.moduleSpecifier, getQuotePreference(sourceFile, preferences)));
    }
    // src/services/codefixes/useBigintLiteral.ts
    var fixId45 = "useBigintLiteral";
    var errorCodes57 = [
        Diagnostics.Numeric_literals_with_absolute_values_equal_to_2_53_or_greater_are_too_large_to_be_represented_accurately_as_integers.code
    ];
    registerCodeFix({
        errorCodes: errorCodes57,
        getCodeActions: function getCodeActionsToUseBigintLiteral(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange10(t, context.sourceFile, context.span));
            if (changes.length > 0) return [
                createCodeFixAction(fixId45, changes, Diagnostics.Convert_to_a_bigint_numeric_literal, fixId45, Diagnostics.Convert_all_to_bigint_numeric_literals)
            ];
        },
        fixIds: [
            fixId45
        ],
        getAllCodeActions: (context)=>{
            return codeFixAll(context, errorCodes57, (changes, diag2)=>makeChange10(changes, diag2.file, diag2));
        }
    });
    function makeChange10(changeTracker, sourceFile, span) {
        const numericLiteral = tryCast(getTokenAtPosition(sourceFile, span.start), isNumericLiteral);
        if (!numericLiteral) return;
        const newText = numericLiteral.getText(sourceFile) + "n";
        changeTracker.replaceNode(sourceFile, numericLiteral, factory.createBigIntLiteral(newText));
    }
    // src/services/codefixes/fixAddModuleReferTypeMissingTypeof.ts
    var fixIdAddMissingTypeof = "fixAddModuleReferTypeMissingTypeof";
    var fixId46 = fixIdAddMissingTypeof;
    var errorCodes58 = [
        Diagnostics.Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_Did_you_mean_typeof_import_0.code
    ];
    registerCodeFix({
        errorCodes: errorCodes58,
        getCodeActions: function getCodeActionsToAddMissingTypeof(context) {
            const { sourceFile, span } = context;
            const importType = getImportTypeNode(sourceFile, span.start);
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange37(t, sourceFile, importType));
            return [
                createCodeFixAction(fixId46, changes, Diagnostics.Add_missing_typeof, fixId46, Diagnostics.Add_missing_typeof)
            ];
        },
        fixIds: [
            fixId46
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes58, (changes, diag2)=>doChange37(changes, context.sourceFile, getImportTypeNode(diag2.file, diag2.start)))
    });
    function getImportTypeNode(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        Debug.assert(token.kind === 102 /* ImportKeyword */ , "This token should be an ImportKeyword");
        Debug.assert(token.parent.kind === 206 /* ImportType */ , "Token parent should be an ImportType");
        return token.parent;
    }
    function doChange37(changes, sourceFile, importType) {
        const newTypeNode = factory.updateImportTypeNode(importType, importType.argument, importType.attributes, importType.qualifier, importType.typeArguments, /*isTypeOf*/ true);
        changes.replaceNode(sourceFile, importType, newTypeNode);
    }
    // src/services/codefixes/wrapJsxInFragment.ts
    var fixID2 = "wrapJsxInFragment";
    var errorCodes59 = [
        Diagnostics.JSX_expressions_must_have_one_parent_element.code
    ];
    registerCodeFix({
        errorCodes: errorCodes59,
        getCodeActions: function getCodeActionsToWrapJsxInFragment(context) {
            const { sourceFile, span } = context;
            const node = findNodeToFix(sourceFile, span.start);
            if (!node) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange38(t, sourceFile, node));
            return [
                createCodeFixAction(fixID2, changes, Diagnostics.Wrap_in_JSX_fragment, fixID2, Diagnostics.Wrap_all_unparented_JSX_in_JSX_fragment)
            ];
        },
        fixIds: [
            fixID2
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes59, (changes, diag2)=>{
                const node = findNodeToFix(context.sourceFile, diag2.start);
                if (!node) return void 0;
                doChange38(changes, context.sourceFile, node);
            })
    });
    function findNodeToFix(sourceFile, pos) {
        const lessThanToken = getTokenAtPosition(sourceFile, pos);
        const firstJsxElementOrOpenElement = lessThanToken.parent;
        let binaryExpr = firstJsxElementOrOpenElement.parent;
        if (!isBinaryExpression(binaryExpr)) {
            binaryExpr = binaryExpr.parent;
            if (!isBinaryExpression(binaryExpr)) return void 0;
        }
        if (!nodeIsMissing(binaryExpr.operatorToken)) return void 0;
        return binaryExpr;
    }
    function doChange38(changeTracker, sf, node) {
        const jsx = flattenInvalidBinaryExpr(node);
        if (jsx) changeTracker.replaceNode(sf, node, factory.createJsxFragment(factory.createJsxOpeningFragment(), jsx, factory.createJsxJsxClosingFragment()));
    }
    function flattenInvalidBinaryExpr(node) {
        const children = [];
        let current = node;
        while(true){
            if (isBinaryExpression(current) && nodeIsMissing(current.operatorToken) && current.operatorToken.kind === 28 /* CommaToken */ ) {
                children.push(current.left);
                if (isJsxChild(current.right)) {
                    children.push(current.right);
                    return children;
                } else if (isBinaryExpression(current.right)) {
                    current = current.right;
                    continue;
                } else return void 0;
            } else return void 0;
        }
    }
    // src/services/codefixes/wrapDecoratorInParentheses.ts
    var fixId47 = "wrapDecoratorInParentheses";
    var errorCodes60 = [
        Diagnostics.Expression_must_be_enclosed_in_parentheses_to_be_used_as_a_decorator.code
    ];
    registerCodeFix({
        errorCodes: errorCodes60,
        getCodeActions: function getCodeActionsToWrapDecoratorExpressionInParentheses(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange11(t, context.sourceFile, context.span.start));
            return [
                createCodeFixAction(fixId47, changes, Diagnostics.Wrap_in_parentheses, fixId47, Diagnostics.Wrap_all_invalid_decorator_expressions_in_parentheses)
            ];
        },
        fixIds: [
            fixId47
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes60, (changes, diag2)=>makeChange11(changes, diag2.file, diag2.start))
    });
    function makeChange11(changeTracker, sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const decorator = findAncestor(token, isDecorator);
        Debug.assert(!!decorator, "Expected position to be owned by a decorator.");
        const replacement = factory.createParenthesizedExpression(decorator.expression);
        changeTracker.replaceNode(sourceFile, decorator.expression, replacement);
    }
    // src/services/codefixes/convertToMappedObjectType.ts
    var fixId48 = "fixConvertToMappedObjectType";
    var errorCodes61 = [
        Diagnostics.An_index_signature_parameter_type_cannot_be_a_literal_type_or_generic_type_Consider_using_a_mapped_object_type_instead.code
    ];
    registerCodeFix({
        errorCodes: errorCodes61,
        getCodeActions: function getCodeActionsToConvertToMappedTypeObject(context) {
            const { sourceFile, span } = context;
            const info = getInfo20(sourceFile, span.start);
            if (!info) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange39(t, sourceFile, info));
            const name = idText(info.container.name);
            return [
                createCodeFixAction(fixId48, changes, [
                    Diagnostics.Convert_0_to_mapped_object_type,
                    name
                ], fixId48, [
                    Diagnostics.Convert_0_to_mapped_object_type,
                    name
                ])
            ];
        },
        fixIds: [
            fixId48
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes61, (changes, diag2)=>{
                const info = getInfo20(diag2.file, diag2.start);
                if (info) doChange39(changes, diag2.file, info);
            })
    });
    function getInfo20(sourceFile, pos) {
        const token = getTokenAtPosition(sourceFile, pos);
        const indexSignature = tryCast(token.parent.parent, isIndexSignatureDeclaration);
        if (!indexSignature) return void 0;
        const container = isInterfaceDeclaration(indexSignature.parent) ? indexSignature.parent : tryCast(indexSignature.parent.parent, isTypeAliasDeclaration);
        if (!container) return void 0;
        return {
            indexSignature,
            container
        };
    }
    function createTypeAliasFromInterface(declaration, type) {
        return factory.createTypeAliasDeclaration(declaration.modifiers, declaration.name, declaration.typeParameters, type);
    }
    function doChange39(changes, sourceFile, { indexSignature, container }) {
        const members = isInterfaceDeclaration(container) ? container.members : container.type.members;
        const otherMembers = members.filter((member)=>!isIndexSignatureDeclaration(member));
        const parameter = first(indexSignature.parameters);
        const mappedTypeParameter = factory.createTypeParameterDeclaration(/*modifiers*/ void 0, cast(parameter.name, isIdentifier), parameter.type);
        const mappedIntersectionType = factory.createMappedTypeNode(hasEffectiveReadonlyModifier(indexSignature) ? factory.createModifier(148 /* ReadonlyKeyword */ ) : void 0, mappedTypeParameter, /*nameType*/ void 0, indexSignature.questionToken, indexSignature.type, /*members*/ void 0);
        const intersectionType = factory.createIntersectionTypeNode([
            ...getAllSuperTypeNodes(container),
            mappedIntersectionType,
            ...otherMembers.length ? [
                factory.createTypeLiteralNode(otherMembers)
            ] : emptyArray
        ]);
        changes.replaceNode(sourceFile, container, createTypeAliasFromInterface(container, intersectionType));
    }
    // src/services/codefixes/removeAccidentalCallParentheses.ts
    var fixId49 = "removeAccidentalCallParentheses";
    var errorCodes62 = [
        Diagnostics.This_expression_is_not_callable_because_it_is_a_get_accessor_Did_you_mean_to_use_it_without.code
    ];
    registerCodeFix({
        errorCodes: errorCodes62,
        getCodeActions (context) {
            const callExpression = findAncestor(getTokenAtPosition(context.sourceFile, context.span.start), isCallExpression);
            if (!callExpression) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                t.deleteRange(context.sourceFile, {
                    pos: callExpression.expression.end,
                    end: callExpression.end
                });
            });
            return [
                createCodeFixActionWithoutFixAll(fixId49, changes, Diagnostics.Remove_parentheses)
            ];
        },
        fixIds: [
            fixId49
        ]
    });
    // src/services/codefixes/removeUnnecessaryAwait.ts
    var fixId50 = "removeUnnecessaryAwait";
    var errorCodes63 = [
        Diagnostics.await_has_no_effect_on_the_type_of_this_expression.code
    ];
    registerCodeFix({
        errorCodes: errorCodes63,
        getCodeActions: function getCodeActionsToRemoveUnnecessaryAwait(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange12(t, context.sourceFile, context.span));
            if (changes.length > 0) return [
                createCodeFixAction(fixId50, changes, Diagnostics.Remove_unnecessary_await, fixId50, Diagnostics.Remove_all_unnecessary_uses_of_await)
            ];
        },
        fixIds: [
            fixId50
        ],
        getAllCodeActions: (context)=>{
            return codeFixAll(context, errorCodes63, (changes, diag2)=>makeChange12(changes, diag2.file, diag2));
        }
    });
    function makeChange12(changeTracker, sourceFile, span) {
        const awaitKeyword = tryCast(getTokenAtPosition(sourceFile, span.start), (node)=>node.kind === 135 /* AwaitKeyword */ );
        const awaitExpression = awaitKeyword && tryCast(awaitKeyword.parent, isAwaitExpression);
        if (!awaitExpression) return;
        let expressionToReplace = awaitExpression;
        const hasSurroundingParens = isParenthesizedExpression(awaitExpression.parent);
        if (hasSurroundingParens) {
            const leftMostExpression = getLeftmostExpression(awaitExpression.expression, /*stopAtCallExpressions*/ false);
            if (isIdentifier(leftMostExpression)) {
                const precedingToken = findPrecedingToken(awaitExpression.parent.pos, sourceFile);
                if (precedingToken && precedingToken.kind !== 105 /* NewKeyword */ ) expressionToReplace = awaitExpression.parent;
            }
        }
        changeTracker.replaceNode(sourceFile, expressionToReplace, awaitExpression.expression);
    }
    // src/services/codefixes/splitTypeOnlyImport.ts
    var errorCodes64 = [
        Diagnostics.A_type_only_import_can_specify_a_default_import_or_named_bindings_but_not_both.code
    ];
    var fixId51 = "splitTypeOnlyImport";
    registerCodeFix({
        errorCodes: errorCodes64,
        fixIds: [
            fixId51
        ],
        getCodeActions: function getCodeActionsToSplitTypeOnlyImport(context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>{
                return splitTypeOnlyImport(t, getImportDeclaration2(context.sourceFile, context.span), context);
            });
            if (changes.length) return [
                createCodeFixAction(fixId51, changes, Diagnostics.Split_into_two_separate_import_declarations, fixId51, Diagnostics.Split_all_invalid_type_only_imports)
            ];
        },
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes64, (changes, error2)=>{
                splitTypeOnlyImport(changes, getImportDeclaration2(context.sourceFile, error2), context);
            })
    });
    function getImportDeclaration2(sourceFile, span) {
        return findAncestor(getTokenAtPosition(sourceFile, span.start), isImportDeclaration);
    }
    function splitTypeOnlyImport(changes, importDeclaration, context) {
        if (!importDeclaration) return;
        const importClause = Debug.checkDefined(importDeclaration.importClause);
        changes.replaceNode(context.sourceFile, importDeclaration, factory.updateImportDeclaration(importDeclaration, importDeclaration.modifiers, factory.updateImportClause(importClause, importClause.phaseModifier, importClause.name, /*namedBindings*/ void 0), importDeclaration.moduleSpecifier, importDeclaration.attributes));
        changes.insertNodeAfter(context.sourceFile, importDeclaration, factory.createImportDeclaration(/*modifiers*/ void 0, factory.updateImportClause(importClause, importClause.phaseModifier, /*name*/ void 0, importClause.namedBindings), importDeclaration.moduleSpecifier, importDeclaration.attributes));
    }
    // src/services/codefixes/convertConstToLet.ts
    var fixId52 = "fixConvertConstToLet";
    var errorCodes65 = [
        Diagnostics.Cannot_assign_to_0_because_it_is_a_constant.code
    ];
    registerCodeFix({
        errorCodes: errorCodes65,
        getCodeActions: function getCodeActionsToConvertConstToLet(context) {
            const { sourceFile, span, program } = context;
            const info = getInfo21(sourceFile, span.start, program);
            if (info === void 0) return;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange40(t, sourceFile, info.token));
            return [
                createCodeFixActionMaybeFixAll(fixId52, changes, Diagnostics.Convert_const_to_let, fixId52, Diagnostics.Convert_all_const_to_let)
            ];
        },
        getAllCodeActions: (context)=>{
            const { program } = context;
            const seen = /* @__PURE__ */ new Set();
            return createCombinedCodeActions(ts_textChanges_exports.ChangeTracker.with(context, (changes)=>{
                eachDiagnostic(context, errorCodes65, (diag2)=>{
                    const info = getInfo21(diag2.file, diag2.start, program);
                    if (info) {
                        if (addToSeen(seen, getSymbolId(info.symbol))) return doChange40(changes, diag2.file, info.token);
                    }
                    return void 0;
                });
            }));
        },
        fixIds: [
            fixId52
        ]
    });
    function getInfo21(sourceFile, pos, program) {
        var _a;
        const checker = program.getTypeChecker();
        const symbol = checker.getSymbolAtLocation(getTokenAtPosition(sourceFile, pos));
        if (symbol === void 0) return;
        const declaration = tryCast((_a = symbol == null ? void 0 : symbol.valueDeclaration) == null ? void 0 : _a.parent, isVariableDeclarationList);
        if (declaration === void 0) return;
        const constToken = findChildOfKind(declaration, 87 /* ConstKeyword */ , sourceFile);
        if (constToken === void 0) return;
        return {
            symbol,
            token: constToken
        };
    }
    function doChange40(changes, sourceFile, token) {
        changes.replaceNode(sourceFile, token, factory.createToken(121 /* LetKeyword */ ));
    }
    // src/services/codefixes/fixExpectedComma.ts
    var fixId53 = "fixExpectedComma";
    var expectedErrorCode = Diagnostics._0_expected.code;
    var errorCodes66 = [
        expectedErrorCode
    ];
    registerCodeFix({
        errorCodes: errorCodes66,
        getCodeActions (context) {
            const { sourceFile } = context;
            const info = getInfo22(sourceFile, context.span.start, context.errorCode);
            if (!info) return void 0;
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>doChange41(t, sourceFile, info));
            return [
                createCodeFixAction(fixId53, changes, [
                    Diagnostics.Change_0_to_1,
                    ";",
                    ","
                ], fixId53, [
                    Diagnostics.Change_0_to_1,
                    ";",
                    ","
                ])
            ];
        },
        fixIds: [
            fixId53
        ],
        getAllCodeActions: (context)=>codeFixAll(context, errorCodes66, (changes, diag2)=>{
                const info = getInfo22(diag2.file, diag2.start, diag2.code);
                if (info) doChange41(changes, context.sourceFile, info);
            })
    });
    function getInfo22(sourceFile, pos, _) {
        const node = getTokenAtPosition(sourceFile, pos);
        return node.kind === 27 /* SemicolonToken */  && node.parent && (isObjectLiteralExpression(node.parent) || isArrayLiteralExpression(node.parent)) ? {
            node
        } : void 0;
    }
    function doChange41(changes, sourceFile, { node }) {
        const newNode = factory.createToken(28 /* CommaToken */ );
        changes.replaceNode(sourceFile, node, newNode);
    }
    // src/services/codefixes/fixAddVoidToPromise.ts
    var fixName7 = "addVoidToPromise";
    var fixId54 = "addVoidToPromise";
    var errorCodes67 = [
        Diagnostics.Expected_1_argument_but_got_0_new_Promise_needs_a_JSDoc_hint_to_produce_a_resolve_that_can_be_called_without_arguments.code,
        Diagnostics.Expected_0_arguments_but_got_1_Did_you_forget_to_include_void_in_your_type_argument_to_Promise.code
    ];
    registerCodeFix({
        errorCodes: errorCodes67,
        fixIds: [
            fixId54
        ],
        getCodeActions (context) {
            const changes = ts_textChanges_exports.ChangeTracker.with(context, (t)=>makeChange13(t, context.sourceFile, context.span, context.program));
            if (changes.length > 0) return [
                createCodeFixAction(fixName7, changes, Diagnostics.Add_void_to_Promise_resolved_without_a_value, fixId54, Diagnostics.Add_void_to_all_Promises_resolved_without_a_value)
            ];
        },
        getAllCodeActions (context) {
            return codeFixAll(context, errorCodes67, (changes, diag2)=>makeChange13(changes, diag2.file, diag2, context.program, /* @__PURE__ */ new Set()));
        }
    });
    function makeChange13(changes, sourceFile, span, program, seen) {
        const node = getTokenAtPosition(sourceFile, span.start);
        if (!isIdentifier(node) || !isCallExpression(node.parent) || node.parent.expression !== node || node.parent.arguments.length !== 0) return;
        const checker = program.getTypeChecker();
        const symbol = checker.getSymbolAtLocation(node);
        const decl = symbol == null ? void 0 : symbol.valueDeclaration;
        if (!decl || !isParameter(decl) || !isNewExpression(decl.parent.parent)) return;
        if (seen == null ? void 0 : seen.has(decl)) return;
        seen == null || seen.add(decl);
        const typeArguments = getEffectiveTypeArguments(decl.parent.parent);
        if (some(typeArguments)) {
            const typeArgument = typeArguments[0];
            const needsParens = !isUnionTypeNode(typeArgument) && !isParenthesizedTypeNode(typeArgument) && isParenthesizedTypeNode(factory.createUnionTypeNode([
                typeArgument,
                factory.createKeywordTypeNode(116 /* VoidKeyword */ )
            ]).types[0]);
            if (needsParens) changes.insertText(sourceFile, typeArgument.pos, "(");
            changes.insertText(sourceFile, typeArgument.end, needsParens ? ") | void" : " | void");
        } else {
            const signature = checker.getResolvedSignature(node.parent);
            const parameter = signature == null ? void 0 : signature.parameters[0];
            const parameterType = parameter && checker.getTypeOfSymbolAtLocation(parameter, decl.parent.parent);
            if (isInJSFile(decl)) {
                if (!parameterType || parameterType.flags & 3 /* AnyOrUnknown */ ) {
                    changes.insertText(sourceFile, decl.parent.parent.end, `)`);
                    changes.insertText(sourceFile, skipTrivia(sourceFile.text, decl.parent.parent.pos), `/** @type {Promise<void>} */(`);
                }
            } else if (!parameterType || parameterType.flags & 2 /* Unknown */ ) changes.insertText(sourceFile, decl.parent.parent.expression.end, "<void>");
        }
    }
    function getEffectiveTypeArguments(node) {
        var _a;
        if (isInJSFile(node)) {
            if (isParenthesizedExpression(node.parent)) {
                const jsDocType = (_a = getJSDocTypeTag(node.parent)) == null ? void 0 : _a.typeExpression.type;
                if (jsDocType && isTypeReferenceNode(jsDocType) && isIdentifier(jsDocType.typeName) && idText(jsDocType.typeName) === "Promise") return jsDocType.typeArguments;
            }
        } else return node.typeArguments;
    }
    // src/services/_namespaces/ts.Completions.ts
    var ts_Completions_exports = {};
    __export(ts_Completions_exports, {
        CompletionKind: ()=>CompletionKind,
        CompletionSource: ()=>CompletionSource,
        SortText: ()=>SortText,
        StringCompletions: ()=>ts_Completions_StringCompletions_exports,
        SymbolOriginInfoKind: ()=>SymbolOriginInfoKind,
        createCompletionDetails: ()=>createCompletionDetails,
        createCompletionDetailsForSymbol: ()=>createCompletionDetailsForSymbol,
        getCompletionEntriesFromSymbols: ()=>getCompletionEntriesFromSymbols,
        getCompletionEntryDetails: ()=>getCompletionEntryDetails,
        getCompletionEntrySymbol: ()=>getCompletionEntrySymbol,
        getCompletionsAtPosition: ()=>getCompletionsAtPosition,
        getDefaultCommitCharacters: ()=>getDefaultCommitCharacters,
        getPropertiesForObjectExpression: ()=>getPropertiesForObjectExpression,
        moduleSpecifierResolutionCacheAttemptLimit: ()=>moduleSpecifierResolutionCacheAttemptLimit,
        moduleSpecifierResolutionLimit: ()=>moduleSpecifierResolutionLimit
    });
    // src/services/completions.ts
    var moduleSpecifierResolutionLimit = 100;
    var moduleSpecifierResolutionCacheAttemptLimit = 1e3;
    var SortText = {
        // Presets
        LocalDeclarationPriority: "10",
        LocationPriority: "11",
        OptionalMember: "12",
        MemberDeclaredBySpreadAssignment: "13",
        SuggestedClassMembers: "14",
        GlobalsOrKeywords: "15",
        AutoImportSuggestions: "16",
        ClassMemberSnippets: "17",
        JavascriptIdentifiers: "18",
        // Transformations
        Deprecated (sortText) {
            return "z" + sortText;
        },
        ObjectLiteralProperty (presetSortText, symbolDisplayName) {
            return `${presetSortText}\0${symbolDisplayName}\0`;
        },
        SortBelow (sortText) {
            return sortText + "1";
        }
    };
    var allCommitCharacters = [
        ".",
        ",",
        ";"
    ];
    var noCommaCommitCharacters = [
        ".",
        ";"
    ];
    var CompletionSource = /* @__PURE__ */ ((CompletionSource2)=>{
        CompletionSource2["ThisProperty"] = "ThisProperty/";
        CompletionSource2["ClassMemberSnippet"] = "ClassMemberSnippet/";
        CompletionSource2["TypeOnlyAlias"] = "TypeOnlyAlias/";
        CompletionSource2["ObjectLiteralMethodSnippet"] = "ObjectLiteralMethodSnippet/";
        CompletionSource2["SwitchCases"] = "SwitchCases/";
        CompletionSource2["ObjectLiteralMemberWithComma"] = "ObjectLiteralMemberWithComma/";
        return CompletionSource2;
    })(CompletionSource || {});
    var SymbolOriginInfoKind = /* @__PURE__ */ ((SymbolOriginInfoKind2)=>{
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["ThisType"] = 1] = "ThisType";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["SymbolMember"] = 2] = "SymbolMember";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["Export"] = 4] = "Export";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["Promise"] = 8] = "Promise";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["Nullable"] = 16] = "Nullable";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["ResolvedExport"] = 32] = "ResolvedExport";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["TypeOnlyAlias"] = 64] = "TypeOnlyAlias";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["ObjectLiteralMethod"] = 128] = "ObjectLiteralMethod";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["Ignore"] = 256] = "Ignore";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["ComputedPropertyName"] = 512] = "ComputedPropertyName";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["SymbolMemberNoExport"] = 2 /* SymbolMember */ ] = "SymbolMemberNoExport";
        SymbolOriginInfoKind2[SymbolOriginInfoKind2["SymbolMemberExport"] = 6] = "SymbolMemberExport";
        return SymbolOriginInfoKind2;
    })(SymbolOriginInfoKind || {});
    function originIsThisType(origin) {
        return !!(origin.kind & 1 /* ThisType */ );
    }
    function originIsSymbolMember(origin) {
        return !!(origin.kind & 2 /* SymbolMember */ );
    }
    function originIsExport(origin) {
        return !!(origin && origin.kind & 4 /* Export */ );
    }
    function originIsResolvedExport(origin) {
        return !!(origin && origin.kind === 32 /* ResolvedExport */ );
    }
    function originIncludesSymbolName(origin) {
        return originIsExport(origin) || originIsResolvedExport(origin) || originIsComputedPropertyName(origin);
    }
    function originIsPackageJsonImport(origin) {
        return (originIsExport(origin) || originIsResolvedExport(origin)) && !!origin.isFromPackageJson;
    }
    function originIsPromise(origin) {
        return !!(origin.kind & 8 /* Promise */ );
    }
    function originIsNullableMember(origin) {
        return !!(origin.kind & 16 /* Nullable */ );
    }
    function originIsTypeOnlyAlias(origin) {
        return !!(origin && origin.kind & 64 /* TypeOnlyAlias */ );
    }
    function originIsObjectLiteralMethod(origin) {
        return !!(origin && origin.kind & 128 /* ObjectLiteralMethod */ );
    }
    function originIsIgnore(origin) {
        return !!(origin && origin.kind & 256 /* Ignore */ );
    }
    function originIsComputedPropertyName(origin) {
        return !!(origin && origin.kind & 512 /* ComputedPropertyName */ );
    }
    function resolvingModuleSpecifiers(logPrefix, host, resolver, program, position, preferences, isForImportStatementCompletion, isValidTypeOnlyUseSite, cb) {
        var _a, _b, _c, _d;
        const start = timestamp();
        const needsFullResolution = isForImportStatementCompletion || getResolvePackageJsonExports(program.getCompilerOptions()) || ((_a = preferences.autoImportSpecifierExcludeRegexes) == null ? void 0 : _a.length);
        let skippedAny = false;
        let ambientCount = 0;
        let resolvedCount = 0;
        let resolvedFromCacheCount = 0;
        let cacheAttemptCount = 0;
        const result = cb({
            tryResolve,
            skippedAny: ()=>skippedAny,
            resolvedAny: ()=>resolvedCount > 0,
            resolvedBeyondLimit: ()=>resolvedCount > moduleSpecifierResolutionLimit
        });
        const hitRateMessage = cacheAttemptCount ? ` (${(resolvedFromCacheCount / cacheAttemptCount * 100).toFixed(1)}% hit rate)` : "";
        (_b = host.log) == null || _b.call(host, `${logPrefix}: resolved ${resolvedCount} module specifiers, plus ${ambientCount} ambient and ${resolvedFromCacheCount} from cache${hitRateMessage}`);
        (_c = host.log) == null || _c.call(host, `${logPrefix}: response is ${skippedAny ? "incomplete" : "complete"}`);
        (_d = host.log) == null || _d.call(host, `${logPrefix}: ${timestamp() - start}`);
        return result;
        function tryResolve(exportInfo, isFromAmbientModule) {
            if (isFromAmbientModule) {
                const result3 = resolver.getModuleSpecifierForBestExportInfo(exportInfo, position, isValidTypeOnlyUseSite);
                if (result3) ambientCount++;
                return result3 || "failed";
            }
            const shouldResolveModuleSpecifier = needsFullResolution || preferences.allowIncompleteCompletions && resolvedCount < moduleSpecifierResolutionLimit;
            const shouldGetModuleSpecifierFromCache = !shouldResolveModuleSpecifier && preferences.allowIncompleteCompletions && cacheAttemptCount < moduleSpecifierResolutionCacheAttemptLimit;
            const result2 = shouldResolveModuleSpecifier || shouldGetModuleSpecifierFromCache ? resolver.getModuleSpecifierForBestExportInfo(exportInfo, position, isValidTypeOnlyUseSite, shouldGetModuleSpecifierFromCache) : void 0;
            if (!shouldResolveModuleSpecifier && !shouldGetModuleSpecifierFromCache || shouldGetModuleSpecifierFromCache && !result2) skippedAny = true;
            resolvedCount += (result2 == null ? void 0 : result2.computedWithoutCacheCount) || 0;
            resolvedFromCacheCount += exportInfo.length - ((result2 == null ? void 0 : result2.computedWithoutCacheCount) || 0);
            if (shouldGetModuleSpecifierFromCache) cacheAttemptCount++;
            return result2 || (needsFullResolution ? "failed" : "skipped");
        }
    }
    function getDefaultCommitCharacters(isNewIdentifierLocation) {
        if (isNewIdentifierLocation) return [];
        return allCommitCharacters;
    }
    function getCompletionsAtPosition(host, program, log, sourceFile, position, preferences, triggerCharacter, completionKind, cancellationToken, formatContext, includeSymbol = false) {
        var _a;
        const { previousToken } = getRelevantTokens(position, sourceFile);
        if (triggerCharacter && !isInString(sourceFile, position, previousToken) && !isValidTrigger(sourceFile, triggerCharacter, previousToken, position)) return void 0;
        if (triggerCharacter === " ") {
            if (preferences.includeCompletionsForImportStatements && preferences.includeCompletionsWithInsertText) return {
                isGlobalCompletion: true,
                isMemberCompletion: false,
                isNewIdentifierLocation: true,
                isIncomplete: true,
                entries: [],
                defaultCommitCharacters: getDefaultCommitCharacters(/*isNewIdentifierLocation*/ true)
            };
            return void 0;
        }
        const compilerOptions = program.getCompilerOptions();
        const checker = program.getTypeChecker();
        const incompleteCompletionsCache = preferences.allowIncompleteCompletions ? (_a = host.getIncompleteCompletionsCache) == null ? void 0 : _a.call(host) : void 0;
        if (incompleteCompletionsCache && completionKind === 3 /* TriggerForIncompleteCompletions */  && previousToken && isIdentifier(previousToken)) {
            const incompleteContinuation = continuePreviousIncompleteResponse(incompleteCompletionsCache, sourceFile, previousToken, program, host, preferences, cancellationToken, position);
            if (incompleteContinuation) return incompleteContinuation;
        } else incompleteCompletionsCache == null || incompleteCompletionsCache.clear();
        const stringCompletions = ts_Completions_StringCompletions_exports.getStringLiteralCompletions(sourceFile, position, previousToken, compilerOptions, host, program, log, preferences, includeSymbol);
        if (stringCompletions) return stringCompletions;
        if (previousToken && isBreakOrContinueStatement(previousToken.parent) && (previousToken.kind === 83 /* BreakKeyword */  || previousToken.kind === 88 /* ContinueKeyword */  || previousToken.kind === 80 /* Identifier */ )) return getLabelCompletionAtPosition(previousToken.parent);
        const completionData = getCompletionData(program, log, sourceFile, compilerOptions, position, preferences, /*detailsEntryId*/ void 0, host, formatContext, cancellationToken);
        if (!completionData) return void 0;
        switch(completionData.kind){
            case 0 /* Data */ :
                const response = completionInfoFromData(sourceFile, host, program, compilerOptions, log, completionData, preferences, formatContext, position, includeSymbol);
                if (response == null ? void 0 : response.isIncomplete) incompleteCompletionsCache == null || incompleteCompletionsCache.set(response);
                return response;
            case 1 /* JsDocTagName */ :
                return jsdocCompletionInfo([
                    ...ts_JsDoc_exports.getJSDocTagNameCompletions(),
                    ...getJSDocParameterCompletions(sourceFile, position, checker, compilerOptions, preferences, /*tagNameOnly*/ true)
                ]);
            case 2 /* JsDocTag */ :
                return jsdocCompletionInfo([
                    ...ts_JsDoc_exports.getJSDocTagCompletions(),
                    ...getJSDocParameterCompletions(sourceFile, position, checker, compilerOptions, preferences, /*tagNameOnly*/ false)
                ]);
            case 3 /* JsDocParameterName */ :
                return jsdocCompletionInfo(ts_JsDoc_exports.getJSDocParameterNameCompletions(completionData.tag));
            case 4 /* Keywords */ :
                return specificKeywordCompletionInfo(completionData.keywordCompletions, completionData.isNewIdentifierLocation);
            default:
                return Debug.assertNever(completionData);
        }
    }
    function compareCompletionEntries(entryInArray, entryToInsert) {
        var _a, _b;
        let result = compareStringsCaseSensitiveUI(entryInArray.sortText, entryToInsert.sortText);
        if (result === 0 /* EqualTo */ ) result = compareStringsCaseSensitiveUI(entryInArray.name, entryToInsert.name);
        if (result === 0 /* EqualTo */  && ((_a = entryInArray.data) == null ? void 0 : _a.moduleSpecifier) && ((_b = entryToInsert.data) == null ? void 0 : _b.moduleSpecifier)) result = compareNumberOfDirectorySeparators(entryInArray.data.moduleSpecifier, entryToInsert.data.moduleSpecifier);
        if (result === 0 /* EqualTo */ ) return -1 /* LessThan */ ;
        return result;
    }
    function completionEntryDataIsResolved(data) {
        return !!(data == null ? void 0 : data.moduleSpecifier);
    }
    function continuePreviousIncompleteResponse(cache, file, location, program, host, preferences, cancellationToken, position) {
        const previousResponse = cache.get();
        if (!previousResponse) return void 0;
        const touchNode = getTouchingPropertyName(file, position);
        const lowerCaseTokenText = location.text.toLowerCase();
        const exportMap = getExportInfoMap(file, host, program, preferences, cancellationToken);
        const newEntries = resolvingModuleSpecifiers("continuePreviousIncompleteResponse", host, ts_codefix_exports.createImportSpecifierResolver(file, program, host, preferences), program, location.getStart(), preferences, /*isForImportStatementCompletion*/ false, isValidTypeOnlyAliasUseSite(location), (context)=>{
            const entries = mapDefined(previousResponse.entries, (entry)=>{
                var _a;
                if (!entry.hasAction || !entry.source || !entry.data || completionEntryDataIsResolved(entry.data)) return entry;
                if (!charactersFuzzyMatchInString(entry.name, lowerCaseTokenText)) return void 0;
                const { origin } = Debug.checkDefined(getAutoImportSymbolFromCompletionEntryData(entry.name, entry.data, program, host));
                const info = exportMap.get(file.path, entry.data.exportMapKey);
                const result = info && context.tryResolve(info, !isExternalModuleNameRelative(stripQuotes(origin.moduleSymbol.name)));
                if (result === "skipped") return entry;
                if (!result || result === "failed") {
                    (_a = host.log) == null || _a.call(host, `Unexpected failure resolving auto import for '${entry.name}' from '${entry.source}'`);
                    return void 0;
                }
                const newOrigin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, origin), {
                    kind: 32 /* ResolvedExport */ ,
                    moduleSpecifier: result.moduleSpecifier
                });
                entry.data = originToCompletionEntryData(newOrigin);
                entry.source = getSourceFromOrigin(newOrigin);
                entry.sourceDisplay = [
                    textPart(newOrigin.moduleSpecifier)
                ];
                return entry;
            });
            if (!context.skippedAny()) previousResponse.isIncomplete = void 0;
            return entries;
        });
        previousResponse.entries = newEntries;
        previousResponse.flags = (previousResponse.flags || 0) | 4 /* IsContinuation */ ;
        previousResponse.optionalReplacementSpan = getOptionalReplacementSpan(touchNode);
        return previousResponse;
    }
    function jsdocCompletionInfo(entries) {
        return {
            isGlobalCompletion: false,
            isMemberCompletion: false,
            isNewIdentifierLocation: false,
            entries,
            defaultCommitCharacters: getDefaultCommitCharacters(/*isNewIdentifierLocation*/ false)
        };
    }
    function getJSDocParameterCompletions(sourceFile, position, checker, options, preferences, tagNameOnly) {
        const currentToken = getTokenAtPosition(sourceFile, position);
        if (!isJSDocTag(currentToken) && !isJSDoc(currentToken)) return [];
        const jsDoc = isJSDoc(currentToken) ? currentToken : currentToken.parent;
        if (!isJSDoc(jsDoc)) return [];
        const func = jsDoc.parent;
        if (!isFunctionLike(func)) return [];
        const isJs = isSourceFileJS(sourceFile);
        const isSnippet = preferences.includeCompletionsWithSnippetText || void 0;
        const paramTagCount = countWhere(jsDoc.tags, (tag)=>isJSDocParameterTag(tag) && tag.getEnd() <= position);
        return mapDefined(func.parameters, (param)=>{
            if (getJSDocParameterTags(param).length) return void 0;
            if (isIdentifier(param.name)) {
                const tabstopCounter = {
                    tabstop: 1
                };
                const paramName = param.name.text;
                let displayText = getJSDocParamAnnotation(paramName, param.initializer, param.dotDotDotToken, isJs, /*isObject*/ false, /*isSnippet*/ false, checker, options, preferences);
                let snippetText = isSnippet ? getJSDocParamAnnotation(paramName, param.initializer, param.dotDotDotToken, isJs, /*isObject*/ false, /*isSnippet*/ true, checker, options, preferences, tabstopCounter) : void 0;
                if (tagNameOnly) {
                    displayText = displayText.slice(1);
                    if (snippetText) snippetText = snippetText.slice(1);
                }
                return {
                    name: displayText,
                    kind: "parameter" /* parameterElement */ ,
                    sortText: SortText.LocationPriority,
                    insertText: isSnippet ? snippetText : void 0,
                    isSnippet
                };
            } else if (param.parent.parameters.indexOf(param) === paramTagCount) {
                const paramPath = `param${paramTagCount}`;
                const displayTextResult = generateJSDocParamTagsForDestructuring(paramPath, param.name, param.initializer, param.dotDotDotToken, isJs, /*isSnippet*/ false, checker, options, preferences);
                const snippetTextResult = isSnippet ? generateJSDocParamTagsForDestructuring(paramPath, param.name, param.initializer, param.dotDotDotToken, isJs, /*isSnippet*/ true, checker, options, preferences) : void 0;
                let displayText = displayTextResult.join(getNewLineCharacter(options) + "* ");
                let snippetText = snippetTextResult == null ? void 0 : snippetTextResult.join(getNewLineCharacter(options) + "* ");
                if (tagNameOnly) {
                    displayText = displayText.slice(1);
                    if (snippetText) snippetText = snippetText.slice(1);
                }
                return {
                    name: displayText,
                    kind: "parameter" /* parameterElement */ ,
                    sortText: SortText.LocationPriority,
                    insertText: isSnippet ? snippetText : void 0,
                    isSnippet
                };
            }
        });
    }
    function generateJSDocParamTagsForDestructuring(path, pattern, initializer, dotDotDotToken, isJs, isSnippet, checker, options, preferences) {
        if (!isJs) return [
            getJSDocParamAnnotation(path, initializer, dotDotDotToken, isJs, /*isObject*/ false, isSnippet, checker, options, preferences, {
                tabstop: 1
            })
        ];
        return patternWorker(path, pattern, initializer, dotDotDotToken, {
            tabstop: 1
        });
        function patternWorker(path2, pattern2, initializer2, dotDotDotToken2, counter) {
            if (isObjectBindingPattern(pattern2) && !dotDotDotToken2) {
                const oldTabstop = counter.tabstop;
                const childCounter = {
                    tabstop: oldTabstop
                };
                const rootParam = getJSDocParamAnnotation(path2, initializer2, dotDotDotToken2, isJs, /*isObject*/ true, isSnippet, checker, options, preferences, childCounter);
                let childTags = [];
                for (const element of pattern2.elements){
                    const elementTags = elementWorker(path2, element, childCounter);
                    if (!elementTags) {
                        childTags = void 0;
                        break;
                    } else childTags.push(...elementTags);
                }
                if (childTags) {
                    counter.tabstop = childCounter.tabstop;
                    return [
                        rootParam,
                        ...childTags
                    ];
                }
            }
            return [
                getJSDocParamAnnotation(path2, initializer2, dotDotDotToken2, isJs, /*isObject*/ false, isSnippet, checker, options, preferences, counter)
            ];
        }
        function elementWorker(path2, element, counter) {
            if (!element.propertyName && isIdentifier(element.name) || isIdentifier(element.name)) {
                const propertyName = element.propertyName ? tryGetTextOfPropertyName(element.propertyName) : element.name.text;
                if (!propertyName) return void 0;
                const paramName = `${path2}.${propertyName}`;
                return [
                    getJSDocParamAnnotation(paramName, element.initializer, element.dotDotDotToken, isJs, /*isObject*/ false, isSnippet, checker, options, preferences, counter)
                ];
            } else if (element.propertyName) {
                const propertyName = tryGetTextOfPropertyName(element.propertyName);
                return propertyName && patternWorker(`${path2}.${propertyName}`, element.name, element.initializer, element.dotDotDotToken, counter);
            }
            return void 0;
        }
    }
    function getJSDocParamAnnotation(paramName, initializer, dotDotDotToken, isJs, isObject, isSnippet, checker, options, preferences, tabstopCounter) {
        if (isSnippet) Debug.assertIsDefined(tabstopCounter);
        if (initializer) paramName = getJSDocParamNameWithInitializer(paramName, initializer);
        if (isSnippet) paramName = escapeSnippetText(paramName);
        if (isJs) {
            let type = "*";
            if (isObject) {
                Debug.assert(!dotDotDotToken, `Cannot annotate a rest parameter with type 'Object'.`);
                type = "Object";
            } else {
                if (initializer) {
                    const inferredType = checker.getTypeAtLocation(initializer.parent);
                    if (!(inferredType.flags & 16385 /* Void */ )) {
                        const sourceFile = initializer.getSourceFile();
                        const quotePreference = getQuotePreference(sourceFile, preferences);
                        const builderFlags = quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ ;
                        const typeNode = checker.typeToTypeNode(inferredType, findAncestor(initializer, isFunctionLike), builderFlags);
                        if (typeNode) {
                            const printer = isSnippet ? createSnippetPrinter({
                                removeComments: true,
                                module: options.module,
                                moduleResolution: options.moduleResolution,
                                target: options.target
                            }) : createPrinter({
                                removeComments: true,
                                module: options.module,
                                moduleResolution: options.moduleResolution,
                                target: options.target
                            });
                            setEmitFlags(typeNode, 1 /* SingleLine */ );
                            type = printer.printNode(4 /* Unspecified */ , typeNode, sourceFile);
                        }
                    }
                }
                if (isSnippet && type === "*") type = `\${${tabstopCounter.tabstop++}:${type}}`;
            }
            const dotDotDot = !isObject && dotDotDotToken ? "..." : "";
            const description3 = isSnippet ? `\${${tabstopCounter.tabstop++}}` : "";
            return `@param {${dotDotDot}${type}} ${paramName} ${description3}`;
        } else {
            const description3 = isSnippet ? `\${${tabstopCounter.tabstop++}}` : "";
            return `@param ${paramName} ${description3}`;
        }
    }
    function getJSDocParamNameWithInitializer(paramName, initializer) {
        const initializerText = initializer.getText().trim();
        if (initializerText.includes("\n") || initializerText.length > 80) return `[${paramName}]`;
        return `[${paramName}=${initializerText}]`;
    }
    function keywordToCompletionEntry(keyword) {
        return {
            name: tokenToString(keyword),
            kind: "keyword" /* keyword */ ,
            kindModifiers: "" /* none */ ,
            sortText: SortText.GlobalsOrKeywords
        };
    }
    function specificKeywordCompletionInfo(entries, isNewIdentifierLocation) {
        return {
            isGlobalCompletion: false,
            isMemberCompletion: false,
            isNewIdentifierLocation,
            entries: entries.slice(),
            defaultCommitCharacters: getDefaultCommitCharacters(isNewIdentifierLocation)
        };
    }
    function keywordCompletionData(keywordFilters, filterOutTsOnlyKeywords, isNewIdentifierLocation) {
        return {
            kind: 4 /* Keywords */ ,
            keywordCompletions: getKeywordCompletions(keywordFilters, filterOutTsOnlyKeywords),
            isNewIdentifierLocation
        };
    }
    function keywordFiltersFromSyntaxKind(keywordCompletion) {
        switch(keywordCompletion){
            case 156 /* TypeKeyword */ :
                return 8 /* TypeKeyword */ ;
            default:
                Debug.fail("Unknown mapping from SyntaxKind to KeywordCompletionFilters");
        }
    }
    function getOptionalReplacementSpan(location) {
        return (location == null ? void 0 : location.kind) === 80 /* Identifier */  ? createTextSpanFromNode(location) : void 0;
    }
    function completionInfoFromData(sourceFile, host, program, compilerOptions, log, completionData, preferences, formatContext, position, includeSymbol) {
        const { symbols, contextToken, completionKind, isInSnippetScope, isNewIdentifierLocation, location, propertyAccessToConvert, keywordFilters, symbolToOriginInfoMap, recommendedCompletion, isJsxInitializer, isTypeOnlyLocation, isJsxIdentifierExpected, isRightOfOpenTag, isRightOfDotOrQuestionDot, importStatementCompletion, insideJsDocTagTypeExpression, symbolToSortTextMap, hasUnresolvedAutoImports, defaultCommitCharacters } = completionData;
        let literals = completionData.literals;
        const checker = program.getTypeChecker();
        if (getLanguageVariant(sourceFile.scriptKind) === 1 /* JSX */ ) {
            const completionInfo = getJsxClosingTagCompletion(location, sourceFile);
            if (completionInfo) return completionInfo;
        }
        const caseClause = findAncestor(contextToken, isCaseClause);
        if (caseClause && (isCaseKeyword(contextToken) || isNodeDescendantOf(contextToken, caseClause.expression))) {
            const tracker = newCaseClauseTracker(checker, caseClause.parent.clauses);
            literals = literals.filter((literal)=>!tracker.hasValue(literal));
            symbols.forEach((symbol, i)=>{
                if (symbol.valueDeclaration && isEnumMember(symbol.valueDeclaration)) {
                    const value1 = checker.getConstantValue(symbol.valueDeclaration);
                    if (value1 !== void 0 && tracker.hasValue(value1)) symbolToOriginInfoMap[i] = {
                        kind: 256 /* Ignore */ 
                    };
                }
            });
        }
        const entries = createSortedArray();
        const isChecked = isCheckedFile(sourceFile, compilerOptions);
        if (isChecked && !isNewIdentifierLocation && (!symbols || symbols.length === 0) && keywordFilters === 0 /* None */ ) return void 0;
        const uniqueNames = getCompletionEntriesFromSymbols(symbols, entries, /*replacementToken*/ void 0, contextToken, location, position, sourceFile, host, program, getEmitScriptTarget(compilerOptions), log, completionKind, preferences, compilerOptions, formatContext, isTypeOnlyLocation, propertyAccessToConvert, isJsxIdentifierExpected, isJsxInitializer, importStatementCompletion, recommendedCompletion, symbolToOriginInfoMap, symbolToSortTextMap, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol);
        if (keywordFilters !== 0 /* None */ ) {
            for (const keywordEntry of getKeywordCompletions(keywordFilters, !insideJsDocTagTypeExpression && isSourceFileJS(sourceFile)))if (isTypeOnlyLocation && isTypeKeyword(stringToToken(keywordEntry.name)) || !isTypeOnlyLocation && isContextualKeywordInAutoImportableExpressionSpace(keywordEntry.name) || !uniqueNames.has(keywordEntry.name)) {
                uniqueNames.add(keywordEntry.name);
                insertSorted(entries, keywordEntry, compareCompletionEntries, /*equalityComparer*/ void 0, /*allowDuplicates*/ true);
            }
        }
        for (const keywordEntry of getContextualKeywords(contextToken, position))if (!uniqueNames.has(keywordEntry.name)) {
            uniqueNames.add(keywordEntry.name);
            insertSorted(entries, keywordEntry, compareCompletionEntries, /*equalityComparer*/ void 0, /*allowDuplicates*/ true);
        }
        for (const literal of literals){
            const literalEntry = createCompletionEntryForLiteral(sourceFile, preferences, literal);
            uniqueNames.add(literalEntry.name);
            insertSorted(entries, literalEntry, compareCompletionEntries, /*equalityComparer*/ void 0, /*allowDuplicates*/ true);
        }
        if (!isChecked) getJSCompletionEntries(sourceFile, location.pos, uniqueNames, getEmitScriptTarget(compilerOptions), entries);
        let caseBlock;
        if (preferences.includeCompletionsWithInsertText && contextToken && !isRightOfOpenTag && !isRightOfDotOrQuestionDot && (caseBlock = findAncestor(contextToken, isCaseBlock))) {
            const cases = getExhaustiveCaseSnippets(caseBlock, sourceFile, preferences, compilerOptions, host, program, formatContext);
            if (cases) entries.push(cases.entry);
        }
        return {
            flags: completionData.flags,
            isGlobalCompletion: isInSnippetScope,
            isIncomplete: preferences.allowIncompleteCompletions && hasUnresolvedAutoImports ? true : void 0,
            isMemberCompletion: isMemberCompletionKind(completionKind),
            isNewIdentifierLocation,
            optionalReplacementSpan: getOptionalReplacementSpan(location),
            entries,
            defaultCommitCharacters: defaultCommitCharacters !== null && defaultCommitCharacters !== void 0 ? defaultCommitCharacters : getDefaultCommitCharacters(isNewIdentifierLocation)
        };
    }
    function isCheckedFile(sourceFile, compilerOptions) {
        return !isSourceFileJS(sourceFile) || !!isCheckJsEnabledForFile(sourceFile, compilerOptions);
    }
    function getExhaustiveCaseSnippets(caseBlock, sourceFile, preferences, options, host, program, formatContext) {
        const clauses = caseBlock.clauses;
        const checker = program.getTypeChecker();
        const switchType = checker.getTypeAtLocation(caseBlock.parent.expression);
        if (switchType && switchType.isUnion() && every(switchType.types, (type)=>type.isLiteral())) {
            const tracker = newCaseClauseTracker(checker, clauses);
            const target = getEmitScriptTarget(options);
            const quotePreference = getQuotePreference(sourceFile, preferences);
            const importAdder = ts_codefix_exports.createImportAdder(sourceFile, program, preferences, host);
            const elements = [];
            for (const type of switchType.types){
                if (type.flags & 1024 /* EnumLiteral */ ) {
                    Debug.assert(type.symbol, "An enum member type should have a symbol");
                    Debug.assert(type.symbol.parent, "An enum member type should have a parent symbol (the enum symbol)");
                    const enumValue = type.symbol.valueDeclaration && checker.getConstantValue(type.symbol.valueDeclaration);
                    if (enumValue !== void 0) {
                        if (tracker.hasValue(enumValue)) continue;
                        tracker.addValue(enumValue);
                    }
                    const typeNode = ts_codefix_exports.typeToAutoImportableTypeNode(checker, importAdder, type, caseBlock, target);
                    if (!typeNode) return void 0;
                    const expr = typeNodeToExpression(typeNode, target, quotePreference);
                    if (!expr) return void 0;
                    elements.push(expr);
                } else if (!tracker.hasValue(type.value)) switch(typeof type.value){
                    case "object":
                        elements.push(type.value.negative ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createBigIntLiteral({
                            negative: false,
                            base10Value: type.value.base10Value
                        })) : factory.createBigIntLiteral(type.value));
                        break;
                    case "number":
                        elements.push(type.value < 0 ? factory.createPrefixUnaryExpression(41 /* MinusToken */ , factory.createNumericLiteral(-type.value)) : factory.createNumericLiteral(type.value));
                        break;
                    case "string":
                        elements.push(factory.createStringLiteral(type.value, quotePreference === 0 /* Single */ ));
                        break;
                }
            }
            if (elements.length === 0) return void 0;
            const newClauses = map(elements, (element)=>factory.createCaseClause(element, []));
            const newLineChar = getNewLineOrDefaultFromHost(host, formatContext == null ? void 0 : formatContext.options);
            const printer = createSnippetPrinter({
                removeComments: true,
                module: options.module,
                moduleResolution: options.moduleResolution,
                target: options.target,
                newLine: getNewLineKind(newLineChar)
            });
            const printNode = formatContext ? (node)=>printer.printAndFormatNode(4 /* Unspecified */ , node, sourceFile, formatContext) : (node)=>printer.printNode(4 /* Unspecified */ , node, sourceFile);
            const insertText = map(newClauses, (clause, i)=>{
                if (preferences.includeCompletionsWithSnippetText) return `${printNode(clause)}$${i + 1}`;
                return `${printNode(clause)}`;
            }).join(newLineChar);
            const firstClause = printer.printNode(4 /* Unspecified */ , newClauses[0], sourceFile);
            return {
                entry: {
                    name: `${firstClause} ...`,
                    kind: "" /* unknown */ ,
                    sortText: SortText.GlobalsOrKeywords,
                    insertText,
                    hasAction: importAdder.hasFixes() || void 0,
                    source: "SwitchCases/" /* SwitchCases */ ,
                    isSnippet: preferences.includeCompletionsWithSnippetText ? true : void 0
                },
                importAdder
            };
        }
        return void 0;
    }
    function typeNodeToExpression(typeNode, languageVersion, quotePreference) {
        switch(typeNode.kind){
            case 184 /* TypeReference */ :
                const typeName = typeNode.typeName;
                return entityNameToExpression(typeName, languageVersion, quotePreference);
            case 200 /* IndexedAccessType */ :
                const objectExpression = typeNodeToExpression(typeNode.objectType, languageVersion, quotePreference);
                const indexExpression = typeNodeToExpression(typeNode.indexType, languageVersion, quotePreference);
                return objectExpression && indexExpression && factory.createElementAccessExpression(objectExpression, indexExpression);
            case 202 /* LiteralType */ :
                const literal = typeNode.literal;
                switch(literal.kind){
                    case 11 /* StringLiteral */ :
                        return factory.createStringLiteral(literal.text, quotePreference === 0 /* Single */ );
                    case 9 /* NumericLiteral */ :
                        return factory.createNumericLiteral(literal.text, literal.numericLiteralFlags);
                }
                return void 0;
            case 197 /* ParenthesizedType */ :
                const exp = typeNodeToExpression(typeNode.type, languageVersion, quotePreference);
                return exp && (isIdentifier(exp) ? exp : factory.createParenthesizedExpression(exp));
            case 187 /* TypeQuery */ :
                return entityNameToExpression(typeNode.exprName, languageVersion, quotePreference);
            case 206 /* ImportType */ :
                Debug.fail(`We should not get an import type after calling 'codefix.typeToAutoImportableTypeNode'.`);
        }
        return void 0;
    }
    function entityNameToExpression(entityName, languageVersion, quotePreference) {
        if (isIdentifier(entityName)) return entityName;
        const unescapedName = unescapeLeadingUnderscores(entityName.right.escapedText);
        if (canUsePropertyAccess(unescapedName, languageVersion)) return factory.createPropertyAccessExpression(entityNameToExpression(entityName.left, languageVersion, quotePreference), unescapedName);
        else return factory.createElementAccessExpression(entityNameToExpression(entityName.left, languageVersion, quotePreference), factory.createStringLiteral(unescapedName, quotePreference === 0 /* Single */ ));
    }
    function isMemberCompletionKind(kind) {
        switch(kind){
            case 0 /* ObjectPropertyDeclaration */ :
            case 3 /* MemberLike */ :
            case 2 /* PropertyAccess */ :
                return true;
            default:
                return false;
        }
    }
    function getJsxClosingTagCompletion(location, sourceFile) {
        const jsxClosingElement = findAncestor(location, (node)=>{
            switch(node.kind){
                case 288 /* JsxClosingElement */ :
                    return true;
                case 31 /* LessThanSlashToken */ :
                case 32 /* GreaterThanToken */ :
                case 80 /* Identifier */ :
                case 212 /* PropertyAccessExpression */ :
                    return false;
                default:
                    return "quit";
            }
        });
        if (jsxClosingElement) {
            const hasClosingAngleBracket = !!findChildOfKind(jsxClosingElement, 32 /* GreaterThanToken */ , sourceFile);
            const tagName = jsxClosingElement.parent.openingElement.tagName;
            const closingTag = tagName.getText(sourceFile);
            const fullClosingTag = closingTag + (hasClosingAngleBracket ? "" : ">");
            const replacementSpan = createTextSpanFromNode(jsxClosingElement.tagName);
            const entry = {
                name: fullClosingTag,
                kind: "class" /* classElement */ ,
                kindModifiers: void 0,
                sortText: SortText.LocationPriority
            };
            return {
                isGlobalCompletion: false,
                isMemberCompletion: true,
                isNewIdentifierLocation: false,
                optionalReplacementSpan: replacementSpan,
                entries: [
                    entry
                ],
                defaultCommitCharacters: getDefaultCommitCharacters(/*isNewIdentifierLocation*/ false)
            };
        }
        return;
    }
    function getJSCompletionEntries(sourceFile, position, uniqueNames, target, entries) {
        getNameTable(sourceFile).forEach((pos, name)=>{
            if (pos === position) return;
            const realName = unescapeLeadingUnderscores(name);
            if (!uniqueNames.has(realName) && isIdentifierText(realName, target)) {
                uniqueNames.add(realName);
                insertSorted(entries, {
                    name: realName,
                    kind: "warning" /* warning */ ,
                    kindModifiers: "",
                    sortText: SortText.JavascriptIdentifiers,
                    isFromUncheckedFile: true,
                    commitCharacters: []
                }, compareCompletionEntries);
            }
        });
    }
    function completionNameForLiteral(sourceFile, preferences, literal) {
        return typeof literal === "object" ? pseudoBigIntToString(literal) + "n" : isString(literal) ? quote(sourceFile, preferences, literal) : JSON.stringify(literal);
    }
    function createCompletionEntryForLiteral(sourceFile, preferences, literal) {
        return {
            name: completionNameForLiteral(sourceFile, preferences, literal),
            kind: "string" /* string */ ,
            kindModifiers: "" /* none */ ,
            sortText: SortText.LocationPriority,
            commitCharacters: []
        };
    }
    function createCompletionEntry(symbol, sortText, replacementToken, contextToken, location, position, sourceFile, host, program, name, needsConvertPropertyAccess, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, importStatementCompletion, useSemicolons, options, preferences, completionKind, formatContext, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol) {
        var _a, _b;
        let insertText;
        let filterText;
        let replacementSpan = getReplacementSpanForContextToken(replacementToken, position);
        let data;
        let isSnippet;
        let source = getSourceFromOrigin(origin);
        let sourceDisplay;
        let hasAction;
        let labelDetails;
        const typeChecker = program.getTypeChecker();
        const insertQuestionDot = origin && originIsNullableMember(origin);
        const useBraces = origin && originIsSymbolMember(origin) || needsConvertPropertyAccess;
        if (origin && originIsThisType(origin)) insertText = needsConvertPropertyAccess ? `this${insertQuestionDot ? "?." : ""}[${quotePropertyName(sourceFile, preferences, name)}]` : `this${insertQuestionDot ? "?." : "."}${name}`;
        else if ((useBraces || insertQuestionDot) && propertyAccessToConvert) {
            insertText = useBraces ? needsConvertPropertyAccess ? `[${quotePropertyName(sourceFile, preferences, name)}]` : `[${name}]` : name;
            if (insertQuestionDot || propertyAccessToConvert.questionDotToken) insertText = `?.${insertText}`;
            const dot = findChildOfKind(propertyAccessToConvert, 25 /* DotToken */ , sourceFile) || findChildOfKind(propertyAccessToConvert, 29 /* QuestionDotToken */ , sourceFile);
            if (!dot) return void 0;
            const end = startsWith(name, propertyAccessToConvert.name.text) ? propertyAccessToConvert.name.end : dot.end;
            replacementSpan = createTextSpanFromBounds(dot.getStart(sourceFile), end);
        }
        if (isJsxInitializer) {
            if (insertText === void 0) insertText = name;
            insertText = `{${insertText}}`;
            if (typeof isJsxInitializer !== "boolean") replacementSpan = createTextSpanFromNode(isJsxInitializer, sourceFile);
        }
        if (origin && originIsPromise(origin) && propertyAccessToConvert) {
            if (insertText === void 0) insertText = name;
            const precedingToken = findPrecedingToken(propertyAccessToConvert.pos, sourceFile);
            let awaitText = "";
            if (precedingToken && positionIsASICandidate(precedingToken.end, precedingToken.parent, sourceFile)) awaitText = ";";
            awaitText += `(await ${propertyAccessToConvert.expression.getText()})`;
            insertText = needsConvertPropertyAccess ? `${awaitText}${insertText}` : `${awaitText}${insertQuestionDot ? "?." : "."}${insertText}`;
            const isInAwaitExpression = tryCast(propertyAccessToConvert.parent, isAwaitExpression);
            const wrapNode = isInAwaitExpression ? propertyAccessToConvert.parent : propertyAccessToConvert.expression;
            replacementSpan = createTextSpanFromBounds(wrapNode.getStart(sourceFile), propertyAccessToConvert.end);
        }
        if (originIsResolvedExport(origin)) {
            sourceDisplay = [
                textPart(origin.moduleSpecifier)
            ];
            if (importStatementCompletion) {
                ({ insertText, replacementSpan } = getInsertTextAndReplacementSpanForImportCompletion(name, importStatementCompletion, origin, useSemicolons, sourceFile, program, preferences));
                isSnippet = preferences.includeCompletionsWithSnippetText ? true : void 0;
            }
        }
        if ((origin == null ? void 0 : origin.kind) === 64 /* TypeOnlyAlias */ ) hasAction = true;
        if (completionKind === 0 /* ObjectPropertyDeclaration */  && contextToken && ((_a = findPrecedingToken(contextToken.pos, sourceFile, contextToken)) == null ? void 0 : _a.kind) !== 28 /* CommaToken */ ) {
            if (isMethodDeclaration(contextToken.parent.parent) || isGetAccessorDeclaration(contextToken.parent.parent) || isSetAccessorDeclaration(contextToken.parent.parent) || isSpreadAssignment(contextToken.parent) || ((_b = findAncestor(contextToken.parent, isPropertyAssignment)) == null ? void 0 : _b.getLastToken(sourceFile)) === contextToken || isShorthandPropertyAssignment(contextToken.parent) && getLineAndCharacterOfPosition(sourceFile, contextToken.getEnd()).line !== getLineAndCharacterOfPosition(sourceFile, position).line) {
                source = "ObjectLiteralMemberWithComma/" /* ObjectLiteralMemberWithComma */ ;
                hasAction = true;
            }
        }
        if (preferences.includeCompletionsWithClassMemberSnippets && preferences.includeCompletionsWithInsertText && completionKind === 3 /* MemberLike */  && isClassLikeMemberCompletion(symbol, location, sourceFile)) {
            let importAdder;
            const memberCompletionEntry = getEntryForMemberCompletion(host, program, options, preferences, name, symbol, location, position, contextToken, formatContext);
            if (memberCompletionEntry) {
                ({ insertText, filterText, isSnippet, importAdder } = memberCompletionEntry);
                if ((importAdder == null ? void 0 : importAdder.hasFixes()) || memberCompletionEntry.eraseRange) {
                    hasAction = true;
                    source = "ClassMemberSnippet/" /* ClassMemberSnippet */ ;
                }
            } else return void 0;
        }
        if (origin && originIsObjectLiteralMethod(origin)) {
            ({ insertText, isSnippet, labelDetails } = origin);
            if (!preferences.useLabelDetailsInCompletionEntries) {
                name = name + labelDetails.detail;
                labelDetails = void 0;
            }
            source = "ObjectLiteralMethodSnippet/" /* ObjectLiteralMethodSnippet */ ;
            sortText = SortText.SortBelow(sortText);
        }
        if (isJsxIdentifierExpected && !isRightOfOpenTag && preferences.includeCompletionsWithSnippetText && preferences.jsxAttributeCompletionStyle && preferences.jsxAttributeCompletionStyle !== "none" && !(isJsxAttribute(location.parent) && location.parent.initializer)) {
            let useBraces2 = preferences.jsxAttributeCompletionStyle === "braces";
            const type = typeChecker.getTypeOfSymbolAtLocation(symbol, location);
            if (preferences.jsxAttributeCompletionStyle === "auto" && !(type.flags & 528 /* BooleanLike */ ) && !(type.flags & 1048576 /* Union */  && find(type.types, (type2)=>!!(type2.flags & 528 /* BooleanLike */ )))) {
                if (type.flags & 402653316 /* StringLike */  || type.flags & 1048576 /* Union */  && every(type.types, (type2)=>!!(type2.flags & 402686084 /* Undefined */  || isStringAndEmptyAnonymousObjectIntersection(type2)))) {
                    insertText = `${escapeSnippetText(name)}=${quote(sourceFile, preferences, "$1")}`;
                    isSnippet = true;
                } else useBraces2 = true;
            }
            if (useBraces2) {
                insertText = `${escapeSnippetText(name)}={$1}`;
                isSnippet = true;
            }
        }
        if (insertText !== void 0 && !preferences.includeCompletionsWithInsertText) return void 0;
        if (originIsExport(origin) || originIsResolvedExport(origin)) {
            data = originToCompletionEntryData(origin);
            hasAction = !importStatementCompletion;
        }
        const parentNamedImportOrExport = findAncestor(location, isNamedImportsOrExports);
        if (parentNamedImportOrExport) {
            const languageVersion = getEmitScriptTarget(host.getCompilationSettings());
            if (!isIdentifierText(name, languageVersion)) {
                insertText = quotePropertyName(sourceFile, preferences, name);
                if (parentNamedImportOrExport.kind === 276 /* NamedImports */ ) {
                    scanner.setText(sourceFile.text);
                    scanner.resetTokenState(position);
                    if (!(scanner.scan() === 130 /* AsKeyword */  && scanner.scan() === 80 /* Identifier */ )) insertText += " as " + generateIdentifierForArbitraryString(name, languageVersion);
                }
            } else if (parentNamedImportOrExport.kind === 276 /* NamedImports */ ) {
                const possibleToken = stringToToken(name);
                if (possibleToken && (possibleToken === 135 /* AwaitKeyword */  || isNonContextualKeyword(possibleToken))) insertText = `${name} as ${name}_`;
            }
        }
        const kind = ts_SymbolDisplay_exports.getSymbolKind(typeChecker, symbol, location);
        const commitCharacters = kind === "warning" /* warning */  || kind === "string" /* string */  ? [] : void 0;
        return (0, _objectSpread._)({
            name,
            kind,
            kindModifiers: ts_SymbolDisplay_exports.getSymbolModifiers(typeChecker, symbol),
            sortText,
            source,
            hasAction: hasAction ? true : void 0,
            isRecommended: isRecommendedCompletionMatch(symbol, recommendedCompletion, typeChecker) || void 0,
            insertText,
            filterText,
            replacementSpan,
            sourceDisplay,
            labelDetails,
            isSnippet,
            isPackageJsonImport: originIsPackageJsonImport(origin) || void 0,
            isImportStatementCompletion: !!importStatementCompletion || void 0,
            data,
            commitCharacters
        }, includeSymbol ? {
            symbol
        } : void 0);
    }
    function generateIdentifierForArbitraryString(text, languageVersion) {
        let needsUnderscore = false;
        let identifier = "";
        let ch;
        for(let i = 0; i < text.length; i += ch !== void 0 && ch >= 65536 ? 2 : 1){
            ch = text.codePointAt(i);
            if (ch !== void 0 && (i === 0 ? isIdentifierStart(ch, languageVersion) : isIdentifierPart(ch, languageVersion))) {
                if (needsUnderscore) identifier += "_";
                identifier += String.fromCodePoint(ch);
                needsUnderscore = false;
            } else needsUnderscore = true;
        }
        if (needsUnderscore) identifier += "_";
        return identifier || "_";
    }
    function isClassLikeMemberCompletion(symbol, location, sourceFile) {
        if (isInJSFile(location)) return false;
        const memberFlags = 106500 /* EnumMemberExcludes */ ;
        return !!(symbol.flags & memberFlags) && (isClassLike(location) || location.parent && location.parent.parent && isClassElement(location.parent) && location === location.parent.name && location.parent.getLastToken(sourceFile) === location.parent.name && isClassLike(location.parent.parent) || location.parent && isSyntaxList(location) && isClassLike(location.parent));
    }
    function getEntryForMemberCompletion(host, program, options, preferences, name, symbol, location, position, contextToken, formatContext) {
        const classLikeDeclaration = findAncestor(location, isClassLike);
        if (!classLikeDeclaration) return void 0;
        let isSnippet;
        let insertText = name;
        const filterText = name;
        const checker = program.getTypeChecker();
        const sourceFile = location.getSourceFile();
        const printer = createSnippetPrinter({
            removeComments: true,
            module: options.module,
            moduleResolution: options.moduleResolution,
            target: options.target,
            omitTrailingSemicolon: false,
            newLine: getNewLineKind(getNewLineOrDefaultFromHost(host, formatContext == null ? void 0 : formatContext.options))
        });
        const importAdder = ts_codefix_exports.createImportAdder(sourceFile, program, preferences, host);
        let body;
        if (preferences.includeCompletionsWithSnippetText) {
            isSnippet = true;
            const emptyStmt = factory.createEmptyStatement();
            body = factory.createBlock([
                emptyStmt
            ], /*multiLine*/ true);
            setSnippetElement(emptyStmt, {
                kind: 0 /* TabStop */ ,
                order: 0
            });
        } else body = factory.createBlock([], /*multiLine*/ true);
        let modifiers = 0 /* None */ ;
        const { modifiers: presentModifiers, range: eraseRange, decorators: presentDecorators } = getPresentModifiers(contextToken, sourceFile, position);
        const isAbstract = presentModifiers & 64 /* Abstract */  && classLikeDeclaration.modifierFlagsCache & 64 /* Abstract */ ;
        let completionNodes = [];
        ts_codefix_exports.addNewNodeForMemberSymbol(symbol, classLikeDeclaration, sourceFile, {
            program,
            host
        }, preferences, importAdder, // `addNewNodeForMemberSymbol` calls this callback function for each new member node
        // it adds for the given member symbol.
        // We store these member nodes in the `completionNodes` array.
        // Note: there might be:
        //  - No nodes if `addNewNodeForMemberSymbol` cannot figure out a node for the member;
        //  - One node;
        //  - More than one node if the member is overloaded (e.g. a method with overload signatures).
        (node)=>{
            let requiredModifiers = 0 /* None */ ;
            if (isAbstract) requiredModifiers |= 64 /* Abstract */ ;
            if (isClassElement(node) && checker.getMemberOverrideModifierStatus(classLikeDeclaration, node, symbol) === 1 /* NeedsOverride */ ) requiredModifiers |= 16 /* Override */ ;
            if (!completionNodes.length) modifiers = node.modifierFlagsCache | requiredModifiers;
            node = factory.replaceModifiers(node, modifiers);
            completionNodes.push(node);
        }, body, ts_codefix_exports.PreserveOptionalFlags.Property, !!isAbstract);
        if (completionNodes.length) {
            const isMethod = symbol.flags & 8192 /* Method */ ;
            let allowedModifiers = modifiers | 17 /* Public */ ;
            if (!isMethod) allowedModifiers |= 136 /* Readonly */ ;
            else allowedModifiers |= 1024 /* Async */ ;
            const allowedAndPresent = presentModifiers & allowedModifiers;
            if (presentModifiers & ~allowedModifiers) return void 0;
            if (modifiers & 4 /* Protected */  && allowedAndPresent & 1 /* Public */ ) modifiers &= -5 /* Protected */ ;
            if (allowedAndPresent !== 0 /* None */  && !(allowedAndPresent & 1 /* Public */ )) modifiers &= -2 /* Public */ ;
            modifiers |= allowedAndPresent;
            completionNodes = completionNodes.map((node)=>factory.replaceModifiers(node, modifiers));
            if (presentDecorators == null ? void 0 : presentDecorators.length) {
                const lastNode = completionNodes[completionNodes.length - 1];
                if (canHaveDecorators(lastNode)) completionNodes[completionNodes.length - 1] = factory.replaceDecoratorsAndModifiers(lastNode, presentDecorators.concat(getModifiers(lastNode) || []));
            }
            const format = 131073 /* NoTrailingNewLine */ ;
            if (formatContext) insertText = printer.printAndFormatSnippetList(format, factory.createNodeArray(completionNodes), sourceFile, formatContext);
            else insertText = printer.printSnippetList(format, factory.createNodeArray(completionNodes), sourceFile);
        }
        return {
            insertText,
            filterText,
            isSnippet,
            importAdder,
            eraseRange
        };
    }
    function getPresentModifiers(contextToken, sourceFile, position) {
        if (!contextToken || getLineAndCharacterOfPosition(sourceFile, position).line > getLineAndCharacterOfPosition(sourceFile, contextToken.getEnd()).line) return {
            modifiers: 0 /* None */ 
        };
        let modifiers = 0 /* None */ ;
        let decorators;
        let contextMod;
        const range = {
            pos: position,
            end: position
        };
        if (isPropertyDeclaration(contextToken.parent) && (contextMod = isModifierLike2(contextToken))) {
            if (contextToken.parent.modifiers) {
                modifiers |= modifiersToFlags(contextToken.parent.modifiers) & 98303 /* Modifier */ ;
                decorators = contextToken.parent.modifiers.filter(isDecorator) || [];
                range.pos = Math.min(...contextToken.parent.modifiers.map((n)=>n.getStart(sourceFile)));
            }
            const contextModifierFlag = modifierToFlag(contextMod);
            if (!(modifiers & contextModifierFlag)) {
                modifiers |= contextModifierFlag;
                range.pos = Math.min(range.pos, contextToken.getStart(sourceFile));
            }
            if (contextToken.parent.name !== contextToken) range.end = contextToken.parent.name.getStart(sourceFile);
        }
        return {
            modifiers,
            decorators,
            range: range.pos < range.end ? range : void 0
        };
    }
    function isModifierLike2(node) {
        if (isModifier(node)) return node.kind;
        if (isIdentifier(node)) {
            const originalKeywordKind = identifierToKeywordKind(node);
            if (originalKeywordKind && isModifierKind(originalKeywordKind)) return originalKeywordKind;
        }
        return void 0;
    }
    function getEntryForObjectLiteralMethodCompletion(symbol, name, enclosingDeclaration, program, host, options, preferences, formatContext) {
        const isSnippet = preferences.includeCompletionsWithSnippetText || void 0;
        let insertText = name;
        const sourceFile = enclosingDeclaration.getSourceFile();
        const method = createObjectLiteralMethod(symbol, enclosingDeclaration, sourceFile, program, host, preferences);
        if (!method) return void 0;
        const printer = createSnippetPrinter({
            removeComments: true,
            module: options.module,
            moduleResolution: options.moduleResolution,
            target: options.target,
            omitTrailingSemicolon: false,
            newLine: getNewLineKind(getNewLineOrDefaultFromHost(host, formatContext == null ? void 0 : formatContext.options))
        });
        if (formatContext) insertText = printer.printAndFormatSnippetList(80 /* AllowTrailingComma */ , factory.createNodeArray([
            method
        ], /*hasTrailingComma*/ true), sourceFile, formatContext);
        else insertText = printer.printSnippetList(80 /* AllowTrailingComma */ , factory.createNodeArray([
            method
        ], /*hasTrailingComma*/ true), sourceFile);
        const signaturePrinter = createPrinter({
            removeComments: true,
            module: options.module,
            moduleResolution: options.moduleResolution,
            target: options.target,
            omitTrailingSemicolon: true
        });
        const methodSignature = factory.createMethodSignature(/*modifiers*/ void 0, /*name*/ "", method.questionToken, method.typeParameters, method.parameters, method.type);
        const labelDetails = {
            detail: signaturePrinter.printNode(4 /* Unspecified */ , methodSignature, sourceFile)
        };
        return {
            isSnippet,
            insertText,
            labelDetails
        };
    }
    function createObjectLiteralMethod(symbol, enclosingDeclaration, sourceFile, program, host, preferences) {
        const declarations = symbol.getDeclarations();
        if (!(declarations && declarations.length)) return void 0;
        const checker = program.getTypeChecker();
        const declaration = declarations[0];
        const name = getSynthesizedDeepClone(getNameOfDeclaration(declaration), /*includeTrivia*/ false);
        const type = checker.getWidenedType(checker.getTypeOfSymbolAtLocation(symbol, enclosingDeclaration));
        const quotePreference = getQuotePreference(sourceFile, preferences);
        const builderFlags = 33554432 /* OmitThisParameter */  | (quotePreference === 0 /* Single */  ? 268435456 /* UseSingleQuotesForStringLiteralType */  : 0 /* None */ );
        switch(declaration.kind){
            case 172 /* PropertySignature */ :
            case 173 /* PropertyDeclaration */ :
            case 174 /* MethodSignature */ :
            case 175 /* MethodDeclaration */ :
                {
                    let effectiveType = type.flags & 1048576 /* Union */  && type.types.length < 10 ? checker.getUnionType(type.types, 2 /* Subtype */ ) : type;
                    if (effectiveType.flags & 1048576 /* Union */ ) {
                        const functionTypes = filter(effectiveType.types, (type2)=>checker.getSignaturesOfType(type2, 0 /* Call */ ).length > 0);
                        if (functionTypes.length === 1) effectiveType = functionTypes[0];
                        else return void 0;
                    }
                    const signatures = checker.getSignaturesOfType(effectiveType, 0 /* Call */ );
                    if (signatures.length !== 1) return void 0;
                    const typeNode = checker.typeToTypeNode(effectiveType, enclosingDeclaration, builderFlags, /*internalFlags*/ void 0, ts_codefix_exports.getNoopSymbolTrackerWithResolver({
                        program,
                        host
                    }));
                    if (!typeNode || !isFunctionTypeNode(typeNode)) return void 0;
                    let body;
                    if (preferences.includeCompletionsWithSnippetText) {
                        const emptyStmt = factory.createEmptyStatement();
                        body = factory.createBlock([
                            emptyStmt
                        ], /*multiLine*/ true);
                        setSnippetElement(emptyStmt, {
                            kind: 0 /* TabStop */ ,
                            order: 0
                        });
                    } else body = factory.createBlock([], /*multiLine*/ true);
                    const parameters = typeNode.parameters.map((typedParam)=>factory.createParameterDeclaration(/*modifiers*/ void 0, typedParam.dotDotDotToken, typedParam.name, /*questionToken*/ void 0, /*type*/ void 0, typedParam.initializer));
                    return factory.createMethodDeclaration(/*modifiers*/ void 0, /*asteriskToken*/ void 0, name, /*questionToken*/ void 0, /*typeParameters*/ void 0, parameters, /*type*/ void 0, body);
                }
            default:
                return void 0;
        }
    }
    function createSnippetPrinter(printerOptions) {
        let escapes;
        const baseWriter = ts_textChanges_exports.createWriter(getNewLineCharacter(printerOptions));
        const printer = createPrinter(printerOptions, baseWriter);
        const writer = (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseWriter), {
            write: (s)=>escapingWrite(s, ()=>baseWriter.write(s)),
            nonEscapingWrite: baseWriter.write,
            writeLiteral: (s)=>escapingWrite(s, ()=>baseWriter.writeLiteral(s)),
            writeStringLiteral: (s)=>escapingWrite(s, ()=>baseWriter.writeStringLiteral(s)),
            writeSymbol: (s, symbol)=>escapingWrite(s, ()=>baseWriter.writeSymbol(s, symbol)),
            writeParameter: (s)=>escapingWrite(s, ()=>baseWriter.writeParameter(s)),
            writeComment: (s)=>escapingWrite(s, ()=>baseWriter.writeComment(s)),
            writeProperty: (s)=>escapingWrite(s, ()=>baseWriter.writeProperty(s))
        });
        return {
            printSnippetList,
            printAndFormatSnippetList,
            printNode,
            printAndFormatNode
        };
        function escapingWrite(s, write) {
            const escaped = escapeSnippetText(s);
            if (escaped !== s) {
                const start = baseWriter.getTextPos();
                write();
                const end = baseWriter.getTextPos();
                escapes = append(escapes || (escapes = []), {
                    newText: escaped,
                    span: {
                        start,
                        length: end - start
                    }
                });
            } else write();
        }
        function printSnippetList(format, list, sourceFile) {
            const unescaped = printUnescapedSnippetList(format, list, sourceFile);
            return escapes ? ts_textChanges_exports.applyChanges(unescaped, escapes) : unescaped;
        }
        function printUnescapedSnippetList(format, list, sourceFile) {
            escapes = void 0;
            writer.clear();
            printer.writeList(format, list, sourceFile, writer);
            return writer.getText();
        }
        function printAndFormatSnippetList(format, list, sourceFile, formatContext) {
            const syntheticFile = {
                text: printUnescapedSnippetList(format, list, sourceFile),
                getLineAndCharacterOfPosition (pos) {
                    return getLineAndCharacterOfPosition(this, pos);
                }
            };
            const formatOptions = getFormatCodeSettingsForWriting(formatContext, sourceFile);
            const changes = flatMap(list, (node)=>{
                const nodeWithPos = ts_textChanges_exports.assignPositionsToNode(node);
                return ts_formatting_exports.formatNodeGivenIndentation(nodeWithPos, syntheticFile, sourceFile.languageVariant, /* indentation */ 0, /* delta */ 0, (0, _objectSpreadProps._)((0, _objectSpread._)({}, formatContext), {
                    options: formatOptions
                }));
            });
            const allChanges = escapes ? toSorted(concatenate(changes, escapes), (a, b)=>compareTextSpans(a.span, b.span)) : changes;
            return ts_textChanges_exports.applyChanges(syntheticFile.text, allChanges);
        }
        function printNode(hint, node, sourceFile) {
            const unescaped = printUnescapedNode(hint, node, sourceFile);
            return escapes ? ts_textChanges_exports.applyChanges(unescaped, escapes) : unescaped;
        }
        function printUnescapedNode(hint, node, sourceFile) {
            escapes = void 0;
            writer.clear();
            printer.writeNode(hint, node, sourceFile, writer);
            return writer.getText();
        }
        function printAndFormatNode(hint, node, sourceFile, formatContext) {
            const syntheticFile = {
                text: printUnescapedNode(hint, node, sourceFile),
                getLineAndCharacterOfPosition (pos) {
                    return getLineAndCharacterOfPosition(this, pos);
                }
            };
            const formatOptions = getFormatCodeSettingsForWriting(formatContext, sourceFile);
            const nodeWithPos = ts_textChanges_exports.assignPositionsToNode(node);
            const changes = ts_formatting_exports.formatNodeGivenIndentation(nodeWithPos, syntheticFile, sourceFile.languageVariant, /* indentation */ 0, /* delta */ 0, (0, _objectSpreadProps._)((0, _objectSpread._)({}, formatContext), {
                options: formatOptions
            }));
            const allChanges = escapes ? toSorted(concatenate(changes, escapes), (a, b)=>compareTextSpans(a.span, b.span)) : changes;
            return ts_textChanges_exports.applyChanges(syntheticFile.text, allChanges);
        }
    }
    function originToCompletionEntryData(origin) {
        const ambientModuleName = origin.fileName ? void 0 : stripQuotes(origin.moduleSymbol.name);
        const isPackageJsonImport = origin.isFromPackageJson ? true : void 0;
        if (originIsResolvedExport(origin)) {
            const resolvedData = {
                exportName: origin.exportName,
                exportMapKey: origin.exportMapKey,
                moduleSpecifier: origin.moduleSpecifier,
                ambientModuleName,
                fileName: origin.fileName,
                isPackageJsonImport
            };
            return resolvedData;
        }
        const unresolvedData = {
            exportName: origin.exportName,
            exportMapKey: origin.exportMapKey,
            fileName: origin.fileName,
            ambientModuleName: origin.fileName ? void 0 : stripQuotes(origin.moduleSymbol.name),
            isPackageJsonImport: origin.isFromPackageJson ? true : void 0
        };
        return unresolvedData;
    }
    function completionEntryDataToSymbolOriginInfo(data, completionName, moduleSymbol) {
        const isDefaultExport = data.exportName === "default" /* Default */ ;
        const isFromPackageJson = !!data.isPackageJsonImport;
        if (completionEntryDataIsResolved(data)) {
            const resolvedOrigin = {
                kind: 32 /* ResolvedExport */ ,
                exportName: data.exportName,
                exportMapKey: data.exportMapKey,
                moduleSpecifier: data.moduleSpecifier,
                symbolName: completionName,
                fileName: data.fileName,
                moduleSymbol,
                isDefaultExport,
                isFromPackageJson
            };
            return resolvedOrigin;
        }
        const unresolvedOrigin = {
            kind: 4 /* Export */ ,
            exportName: data.exportName,
            exportMapKey: data.exportMapKey,
            symbolName: completionName,
            fileName: data.fileName,
            moduleSymbol,
            isDefaultExport,
            isFromPackageJson
        };
        return unresolvedOrigin;
    }
    function getInsertTextAndReplacementSpanForImportCompletion(name, importStatementCompletion, origin, useSemicolons, sourceFile, program, preferences) {
        const replacementSpan = importStatementCompletion.replacementSpan;
        const quotedModuleSpecifier = escapeSnippetText(quote(sourceFile, preferences, origin.moduleSpecifier));
        const exportKind = origin.isDefaultExport ? 1 /* Default */  : origin.exportName === "export=" /* ExportEquals */  ? 2 /* ExportEquals */  : 0 /* Named */ ;
        const tabStop = preferences.includeCompletionsWithSnippetText ? "$1" : "";
        const importKind = ts_codefix_exports.getImportKind(sourceFile, exportKind, program, /*forceImportKeyword*/ true);
        const isImportSpecifierTypeOnly = importStatementCompletion.couldBeTypeOnlyImportSpecifier;
        const topLevelTypeOnlyText = importStatementCompletion.isTopLevelTypeOnly ? ` ${tokenToString(156 /* TypeKeyword */ )} ` : " ";
        const importSpecifierTypeOnlyText = isImportSpecifierTypeOnly ? `${tokenToString(156 /* TypeKeyword */ )} ` : "";
        const suffix = useSemicolons ? ";" : "";
        switch(importKind){
            case 3 /* CommonJS */ :
                return {
                    replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}${escapeSnippetText(name)}${tabStop} = require(${quotedModuleSpecifier})${suffix}`
                };
            case 1 /* Default */ :
                return {
                    replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}${escapeSnippetText(name)}${tabStop} from ${quotedModuleSpecifier}${suffix}`
                };
            case 2 /* Namespace */ :
                return {
                    replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}* as ${escapeSnippetText(name)} from ${quotedModuleSpecifier}${suffix}`
                };
            case 0 /* Named */ :
                return {
                    replacementSpan,
                    insertText: `import${topLevelTypeOnlyText}{ ${importSpecifierTypeOnlyText}${escapeSnippetText(name)}${tabStop} } from ${quotedModuleSpecifier}${suffix}`
                };
        }
    }
    function quotePropertyName(sourceFile, preferences, name) {
        if (/^\d+$/.test(name)) return name;
        return quote(sourceFile, preferences, name);
    }
    function isRecommendedCompletionMatch(localSymbol, recommendedCompletion, checker) {
        return localSymbol === recommendedCompletion || !!(localSymbol.flags & 1048576 /* ExportValue */ ) && checker.getExportSymbolOfSymbol(localSymbol) === recommendedCompletion;
    }
    function getSourceFromOrigin(origin) {
        if (originIsExport(origin)) return stripQuotes(origin.moduleSymbol.name);
        if (originIsResolvedExport(origin)) return origin.moduleSpecifier;
        if ((origin == null ? void 0 : origin.kind) === 1 /* ThisType */ ) return "ThisProperty/" /* ThisProperty */ ;
        if ((origin == null ? void 0 : origin.kind) === 64 /* TypeOnlyAlias */ ) return "TypeOnlyAlias/" /* TypeOnlyAlias */ ;
    }
    function getCompletionEntriesFromSymbols(symbols, entries, replacementToken, contextToken, location, position, sourceFile, host, program, target, log, kind, preferences, compilerOptions, formatContext, isTypeOnlyLocation, propertyAccessToConvert, jsxIdentifierExpected, isJsxInitializer, importStatementCompletion, recommendedCompletion, symbolToOriginInfoMap, symbolToSortTextMap, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol = false) {
        const start = timestamp();
        const closestSymbolDeclaration = getClosestSymbolDeclaration(contextToken, location);
        const useSemicolons = probablyUsesSemicolons(sourceFile);
        const typeChecker = program.getTypeChecker();
        const uniques = /* @__PURE__ */ new Map();
        for(let i = 0; i < symbols.length; i++){
            const symbol = symbols[i];
            const origin = symbolToOriginInfoMap == null ? void 0 : symbolToOriginInfoMap[i];
            const info = getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind, !!jsxIdentifierExpected);
            if (!info || uniques.get(info.name) && (!origin || !originIsObjectLiteralMethod(origin)) || kind === 1 /* Global */  && symbolToSortTextMap && !shouldIncludeSymbol(symbol, symbolToSortTextMap)) continue;
            if (!isTypeOnlyLocation && isInJSFile(sourceFile) && symbolAppearsToBeTypeOnly(symbol)) continue;
            const { name, needsConvertPropertyAccess } = info;
            var _ref;
            const originalSortText = (_ref = symbolToSortTextMap == null ? void 0 : symbolToSortTextMap[getSymbolId(symbol)]) !== null && _ref !== void 0 ? _ref : SortText.LocationPriority;
            const sortText = isDeprecated(symbol, typeChecker) ? SortText.Deprecated(originalSortText) : originalSortText;
            const entry = createCompletionEntry(symbol, sortText, replacementToken, contextToken, location, position, sourceFile, host, program, name, needsConvertPropertyAccess, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, importStatementCompletion, useSemicolons, compilerOptions, preferences, kind, formatContext, isJsxIdentifierExpected, isRightOfOpenTag, includeSymbol);
            if (!entry) continue;
            const shouldShadowLaterSymbols = (!origin || originIsTypeOnlyAlias(origin)) && !(symbol.parent === void 0 && !some(symbol.declarations, (d)=>d.getSourceFile() === location.getSourceFile()));
            uniques.set(name, shouldShadowLaterSymbols);
            insertSorted(entries, entry, compareCompletionEntries, /*equalityComparer*/ void 0, /*allowDuplicates*/ true);
        }
        log("getCompletionsAtPosition: getCompletionEntriesFromSymbols: " + (timestamp() - start));
        return {
            has: (name)=>uniques.has(name),
            add: (name)=>uniques.set(name, true)
        };
        function shouldIncludeSymbol(symbol, symbolToSortTextMap2) {
            var _a;
            let allFlags = symbol.flags;
            if (location.parent && isExportAssignment(location.parent)) return true;
            if (closestSymbolDeclaration && tryCast(closestSymbolDeclaration, isVariableDeclaration)) {
                if (symbol.valueDeclaration === closestSymbolDeclaration) return false;
                if (isBindingPattern(closestSymbolDeclaration.name) && closestSymbolDeclaration.name.elements.some((e)=>e === symbol.valueDeclaration)) return false;
            }
            var _symbol_valueDeclaration;
            const symbolDeclaration = (_symbol_valueDeclaration = symbol.valueDeclaration) !== null && _symbol_valueDeclaration !== void 0 ? _symbol_valueDeclaration : (_a = symbol.declarations) == null ? void 0 : _a[0];
            if (closestSymbolDeclaration && symbolDeclaration) {
                if (isParameter(closestSymbolDeclaration) && isParameter(symbolDeclaration)) {
                    const parameters = closestSymbolDeclaration.parent.parameters;
                    if (symbolDeclaration.pos >= closestSymbolDeclaration.pos && symbolDeclaration.pos < parameters.end) return false;
                } else if (isTypeParameterDeclaration(closestSymbolDeclaration) && isTypeParameterDeclaration(symbolDeclaration)) {
                    if (closestSymbolDeclaration === symbolDeclaration && (contextToken == null ? void 0 : contextToken.kind) === 96 /* ExtendsKeyword */ ) return false;
                    if (isInTypeParameterDefault(contextToken) && !isInferTypeNode(closestSymbolDeclaration.parent)) {
                        const typeParameters = closestSymbolDeclaration.parent.typeParameters;
                        if (typeParameters && symbolDeclaration.pos >= closestSymbolDeclaration.pos && symbolDeclaration.pos < typeParameters.end) return false;
                    }
                }
            }
            const symbolOrigin = skipAlias(symbol, typeChecker);
            if (!!sourceFile.externalModuleIndicator && !compilerOptions.allowUmdGlobalAccess && symbolToSortTextMap2[getSymbolId(symbol)] === SortText.GlobalsOrKeywords && (symbolToSortTextMap2[getSymbolId(symbolOrigin)] === SortText.AutoImportSuggestions || symbolToSortTextMap2[getSymbolId(symbolOrigin)] === SortText.LocationPriority)) return false;
            allFlags |= getCombinedLocalAndExportSymbolFlags(symbolOrigin);
            if (isInRightSideOfInternalImportEqualsDeclaration(location)) return !!(allFlags & 1920 /* Namespace */ );
            if (isTypeOnlyLocation) return symbolCanBeReferencedAtTypeLocation(symbol, typeChecker);
            return !!(allFlags & 111551 /* Value */ );
        }
        function symbolAppearsToBeTypeOnly(symbol) {
            var _a;
            const flags = getCombinedLocalAndExportSymbolFlags(skipAlias(symbol, typeChecker));
            return !(flags & 111551 /* Value */ ) && (!isInJSFile((_a = symbol.declarations) == null ? void 0 : _a[0]) || !!(flags & 788968 /* Type */ ));
        }
    }
    function getLabelCompletionAtPosition(node) {
        const entries = getLabelStatementCompletions(node);
        if (entries.length) return {
            isGlobalCompletion: false,
            isMemberCompletion: false,
            isNewIdentifierLocation: false,
            entries,
            defaultCommitCharacters: getDefaultCommitCharacters(/*isNewIdentifierLocation*/ false)
        };
    }
    function getLabelStatementCompletions(node) {
        const entries = [];
        const uniques = /* @__PURE__ */ new Map();
        let current = node;
        while(current){
            if (isFunctionLike(current)) break;
            if (isLabeledStatement(current)) {
                const name = current.label.text;
                if (!uniques.has(name)) {
                    uniques.set(name, true);
                    entries.push({
                        name,
                        kindModifiers: "" /* none */ ,
                        kind: "label" /* label */ ,
                        sortText: SortText.LocationPriority
                    });
                }
            }
            current = current.parent;
        }
        return entries;
    }
    function getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId, host, preferences) {
        if (entryId.source === "SwitchCases/" /* SwitchCases */ ) return {
            type: "cases"
        };
        if (entryId.data) {
            const autoImport = getAutoImportSymbolFromCompletionEntryData(entryId.name, entryId.data, program, host);
            if (autoImport) {
                const { contextToken: contextToken2, previousToken: previousToken2 } = getRelevantTokens(position, sourceFile);
                return {
                    type: "symbol",
                    symbol: autoImport.symbol,
                    location: getTouchingPropertyName(sourceFile, position),
                    previousToken: previousToken2,
                    contextToken: contextToken2,
                    isJsxInitializer: false,
                    isTypeOnlyLocation: false,
                    origin: autoImport.origin
                };
            }
        }
        const compilerOptions = program.getCompilerOptions();
        const completionData = getCompletionData(program, log, sourceFile, compilerOptions, position, {
            includeCompletionsForModuleExports: true,
            includeCompletionsWithInsertText: true
        }, entryId, host, /*formatContext*/ void 0);
        if (!completionData) return {
            type: "none"
        };
        if (completionData.kind !== 0 /* Data */ ) return {
            type: "request",
            request: completionData
        };
        const { symbols, literals, location, completionKind, symbolToOriginInfoMap, contextToken, previousToken, isJsxInitializer, isTypeOnlyLocation } = completionData;
        const literal = find(literals, (l)=>completionNameForLiteral(sourceFile, preferences, l) === entryId.name);
        if (literal !== void 0) return {
            type: "literal",
            literal
        };
        return firstDefined(symbols, (symbol, index)=>{
            const origin = symbolToOriginInfoMap[index];
            const info = getCompletionEntryDisplayNameForSymbol(symbol, getEmitScriptTarget(compilerOptions), origin, completionKind, completionData.isJsxIdentifierExpected);
            return info && info.name === entryId.name && (entryId.source === "ClassMemberSnippet/" /* ClassMemberSnippet */  && symbol.flags & 106500 /* ClassMember */  || entryId.source === "ObjectLiteralMethodSnippet/" /* ObjectLiteralMethodSnippet */  && symbol.flags & 8196 /* Method */  || getSourceFromOrigin(origin) === entryId.source || entryId.source === "ObjectLiteralMemberWithComma/" /* ObjectLiteralMemberWithComma */ ) ? {
                type: "symbol",
                symbol,
                location,
                origin,
                contextToken,
                previousToken,
                isJsxInitializer,
                isTypeOnlyLocation
            } : void 0;
        }) || {
            type: "none"
        };
    }
    function getCompletionEntryDetails(program, log, sourceFile, position, entryId, host, formatContext, preferences, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        const { name, source, data } = entryId;
        const { previousToken, contextToken } = getRelevantTokens(position, sourceFile);
        if (isInString(sourceFile, position, previousToken)) return ts_Completions_StringCompletions_exports.getStringLiteralCompletionDetails(name, sourceFile, position, previousToken, program, host, cancellationToken, preferences);
        const symbolCompletion = getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId, host, preferences);
        switch(symbolCompletion.type){
            case "request":
                {
                    const { request } = symbolCompletion;
                    switch(request.kind){
                        case 1 /* JsDocTagName */ :
                            return ts_JsDoc_exports.getJSDocTagNameCompletionDetails(name);
                        case 2 /* JsDocTag */ :
                            return ts_JsDoc_exports.getJSDocTagCompletionDetails(name);
                        case 3 /* JsDocParameterName */ :
                            return ts_JsDoc_exports.getJSDocParameterNameCompletionDetails(name);
                        case 4 /* Keywords */ :
                            return some(request.keywordCompletions, (c)=>c.name === name) ? createSimpleDetails(name, "keyword" /* keyword */ , 5 /* keyword */ ) : void 0;
                        default:
                            return Debug.assertNever(request);
                    }
                }
            case "symbol":
                {
                    const { symbol, location, contextToken: contextToken2, origin, previousToken: previousToken2 } = symbolCompletion;
                    const { codeActions, sourceDisplay } = getCompletionEntryCodeActionsAndSourceDisplay(name, location, contextToken2, origin, symbol, program, host, compilerOptions, sourceFile, position, previousToken2, formatContext, preferences, data, source, cancellationToken);
                    const symbolName2 = originIsComputedPropertyName(origin) ? origin.symbolName : symbol.name;
                    return createCompletionDetailsForSymbol(symbol, symbolName2, typeChecker, sourceFile, location, cancellationToken, codeActions, sourceDisplay);
                }
            case "literal":
                {
                    const { literal } = symbolCompletion;
                    return createSimpleDetails(completionNameForLiteral(sourceFile, preferences, literal), "string" /* string */ , typeof literal === "string" ? 8 /* stringLiteral */  : 7 /* numericLiteral */ );
                }
            case "cases":
                {
                    const snippets = getExhaustiveCaseSnippets(contextToken.parent, sourceFile, preferences, program.getCompilerOptions(), host, program, /*formatContext*/ void 0);
                    if (snippets == null ? void 0 : snippets.importAdder.hasFixes()) {
                        const { entry, importAdder } = snippets;
                        const changes = ts_textChanges_exports.ChangeTracker.with({
                            host,
                            formatContext,
                            preferences
                        }, importAdder.writeFixes);
                        return {
                            name: entry.name,
                            kind: "" /* unknown */ ,
                            kindModifiers: "",
                            displayParts: [],
                            sourceDisplay: void 0,
                            codeActions: [
                                {
                                    changes,
                                    description: diagnosticToString([
                                        Diagnostics.Includes_imports_of_types_referenced_by_0,
                                        name
                                    ])
                                }
                            ]
                        };
                    }
                    return {
                        name,
                        kind: "" /* unknown */ ,
                        kindModifiers: "",
                        displayParts: [],
                        sourceDisplay: void 0
                    };
                }
            case "none":
                return allKeywordsCompletions().some((c)=>c.name === name) ? createSimpleDetails(name, "keyword" /* keyword */ , 5 /* keyword */ ) : void 0;
            default:
                Debug.assertNever(symbolCompletion);
        }
    }
    function createSimpleDetails(name, kind, kind2) {
        return createCompletionDetails(name, "" /* none */ , kind, [
            displayPart(name, kind2)
        ]);
    }
    function createCompletionDetailsForSymbol(symbol, name, checker, sourceFile, location, cancellationToken, codeActions, sourceDisplay) {
        const { displayParts, documentation, symbolKind, tags } = checker.runWithCancellationToken(cancellationToken, (checker2)=>ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(checker2, symbol, sourceFile, location, location, 7 /* All */ ));
        return createCompletionDetails(name, ts_SymbolDisplay_exports.getSymbolModifiers(checker, symbol), symbolKind, displayParts, documentation, tags, codeActions, sourceDisplay);
    }
    function createCompletionDetails(name, kindModifiers, kind, displayParts, documentation, tags, codeActions, source) {
        return {
            name,
            kindModifiers,
            kind,
            displayParts,
            documentation,
            tags,
            codeActions,
            source,
            sourceDisplay: source
        };
    }
    function getCompletionEntryCodeActionsAndSourceDisplay(name, location, contextToken, origin, symbol, program, host, compilerOptions, sourceFile, position, previousToken, formatContext, preferences, data, source, cancellationToken) {
        if (data == null ? void 0 : data.moduleSpecifier) {
            if (previousToken && getImportStatementCompletionInfo(contextToken || previousToken, sourceFile).replacementSpan) return {
                codeActions: void 0,
                sourceDisplay: [
                    textPart(data.moduleSpecifier)
                ]
            };
        }
        if (source === "ClassMemberSnippet/" /* ClassMemberSnippet */ ) {
            const { importAdder, eraseRange } = getEntryForMemberCompletion(host, program, compilerOptions, preferences, name, symbol, location, position, contextToken, formatContext);
            if ((importAdder == null ? void 0 : importAdder.hasFixes()) || eraseRange) {
                const changes = ts_textChanges_exports.ChangeTracker.with({
                    host,
                    formatContext,
                    preferences
                }, (tracker)=>{
                    if (importAdder) importAdder.writeFixes(tracker);
                    if (eraseRange) tracker.deleteRange(sourceFile, eraseRange);
                });
                return {
                    sourceDisplay: void 0,
                    codeActions: [
                        {
                            changes,
                            description: (importAdder == null ? void 0 : importAdder.hasFixes()) ? diagnosticToString([
                                Diagnostics.Includes_imports_of_types_referenced_by_0,
                                name
                            ]) : diagnosticToString([
                                Diagnostics.Update_modifiers_of_0,
                                name
                            ])
                        }
                    ]
                };
            }
        }
        if (originIsTypeOnlyAlias(origin)) {
            const codeAction2 = ts_codefix_exports.getPromoteTypeOnlyCompletionAction(sourceFile, origin.declaration.name, program, host, formatContext, preferences);
            Debug.assertIsDefined(codeAction2, "Expected to have a code action for promoting type-only alias");
            return {
                codeActions: [
                    codeAction2
                ],
                sourceDisplay: void 0
            };
        }
        if (source === "ObjectLiteralMemberWithComma/" /* ObjectLiteralMemberWithComma */  && contextToken) {
            const changes = ts_textChanges_exports.ChangeTracker.with({
                host,
                formatContext,
                preferences
            }, (tracker)=>tracker.insertText(sourceFile, contextToken.end, ","));
            if (changes) return {
                sourceDisplay: void 0,
                codeActions: [
                    {
                        changes,
                        description: diagnosticToString([
                            Diagnostics.Add_missing_comma_for_object_member_completion_0,
                            name
                        ])
                    }
                ]
            };
        }
        if (!origin || !(originIsExport(origin) || originIsResolvedExport(origin))) return {
            codeActions: void 0,
            sourceDisplay: void 0
        };
        const checker = origin.isFromPackageJson ? host.getPackageJsonAutoImportProvider().getTypeChecker() : program.getTypeChecker();
        const { moduleSymbol } = origin;
        const targetSymbol = checker.getMergedSymbol(skipAlias(symbol.exportSymbol || symbol, checker));
        const isJsxOpeningTagName = (contextToken == null ? void 0 : contextToken.kind) === 30 /* LessThanToken */  && isJsxOpeningLikeElement(contextToken.parent);
        const { moduleSpecifier, codeAction } = ts_codefix_exports.getImportCompletionAction(targetSymbol, moduleSymbol, data == null ? void 0 : data.exportMapKey, sourceFile, name, isJsxOpeningTagName, host, program, formatContext, previousToken && isIdentifier(previousToken) ? previousToken.getStart(sourceFile) : position, preferences, cancellationToken);
        Debug.assert(!(data == null ? void 0 : data.moduleSpecifier) || moduleSpecifier === data.moduleSpecifier);
        return {
            sourceDisplay: [
                textPart(moduleSpecifier)
            ],
            codeActions: [
                codeAction
            ]
        };
    }
    function getCompletionEntrySymbol(program, log, sourceFile, position, entryId, host, preferences) {
        const completion = getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId, host, preferences);
        return completion.type === "symbol" ? completion.symbol : void 0;
    }
    var CompletionKind = /* @__PURE__ */ ((CompletionKind2)=>{
        CompletionKind2[CompletionKind2["ObjectPropertyDeclaration"] = 0] = "ObjectPropertyDeclaration";
        CompletionKind2[CompletionKind2["Global"] = 1] = "Global";
        CompletionKind2[CompletionKind2["PropertyAccess"] = 2] = "PropertyAccess";
        CompletionKind2[CompletionKind2["MemberLike"] = 3] = "MemberLike";
        CompletionKind2[CompletionKind2["String"] = 4] = "String";
        CompletionKind2[CompletionKind2["None"] = 5] = "None";
        return CompletionKind2;
    })(CompletionKind || {});
    function getRecommendedCompletion(previousToken, contextualType, checker) {
        return firstDefined(contextualType && (contextualType.isUnion() ? contextualType.types : [
            contextualType
        ]), (type)=>{
            const symbol = type && type.symbol;
            return symbol && symbol.flags & 424 /* Class */  && !isAbstractConstructorSymbol(symbol) ? getFirstSymbolInChain(symbol, previousToken, checker) : void 0;
        });
    }
    function getContextualType(previousToken, position, sourceFile, checker) {
        const { parent: parent2 } = previousToken;
        switch(previousToken.kind){
            case 80 /* Identifier */ :
                return getContextualTypeFromParent(previousToken, checker);
            case 64 /* EqualsToken */ :
                switch(parent2.kind){
                    case 261 /* VariableDeclaration */ :
                        return checker.getContextualType(parent2.initializer);
                    // TODO: GH#18217
                    case 227 /* BinaryExpression */ :
                        return checker.getTypeAtLocation(parent2.left);
                    case 292 /* JsxAttribute */ :
                        return checker.getContextualTypeForJsxAttribute(parent2);
                    default:
                        return void 0;
                }
            case 105 /* NewKeyword */ :
                return checker.getContextualType(parent2);
            case 84 /* CaseKeyword */ :
                const caseClause = tryCast(parent2, isCaseClause);
                return caseClause ? getSwitchedType(caseClause, checker) : void 0;
            case 19 /* OpenBraceToken */ :
                return isJsxExpression(parent2) && !isJsxElement(parent2.parent) && !isJsxFragment(parent2.parent) ? checker.getContextualTypeForJsxAttribute(parent2.parent) : void 0;
            default:
                const argInfo = ts_SignatureHelp_exports.getArgumentInfoForCompletions(previousToken, position, sourceFile, checker);
                return argInfo ? checker.getContextualTypeForArgumentAtIndex(argInfo.invocation, argInfo.argumentIndex) : isEqualityOperatorKind(previousToken.kind) && isBinaryExpression(parent2) && isEqualityOperatorKind(parent2.operatorToken.kind) ? // completion at `x ===/**/` should be for the right side
                checker.getTypeAtLocation(parent2.left) : checker.getContextualType(previousToken, 4 /* Completions */ ) || checker.getContextualType(previousToken);
        }
    }
    function getFirstSymbolInChain(symbol, enclosingDeclaration, checker) {
        const chain = checker.getAccessibleSymbolChain(symbol, enclosingDeclaration, /*meaning*/ -1 /* All */ , /*useOnlyExternalAliasing*/ false);
        if (chain) return first(chain);
        return symbol.parent && (isModuleSymbol(symbol.parent) ? symbol : getFirstSymbolInChain(symbol.parent, enclosingDeclaration, checker));
    }
    function isModuleSymbol(symbol) {
        var _a;
        return !!((_a = symbol.declarations) == null ? void 0 : _a.some((d)=>d.kind === 308 /* SourceFile */ ));
    }
    function getCompletionData(program, log, sourceFile, compilerOptions, position, preferences, detailsEntryId, host, formatContext, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        const inCheckedFile = isCheckedFile(sourceFile, compilerOptions);
        let start = timestamp();
        let currentToken = getTokenAtPosition(sourceFile, position);
        log("getCompletionData: Get current token: " + (timestamp() - start));
        start = timestamp();
        const insideComment = isInComment(sourceFile, position, currentToken);
        log("getCompletionData: Is inside comment: " + (timestamp() - start));
        let insideJsDocTagTypeExpression = false;
        let insideJsDocImportTag = false;
        let isInSnippetScope = false;
        if (insideComment) {
            if (hasDocComment(sourceFile, position)) {
                if (sourceFile.text.charCodeAt(position - 1) === 64 /* at */ ) return {
                    kind: 1 /* JsDocTagName */ 
                };
                else {
                    const lineStart = getLineStartPositionForPosition(position, sourceFile);
                    if (!/[^*|\s(/)]/.test(sourceFile.text.substring(lineStart, position))) return {
                        kind: 2 /* JsDocTag */ 
                    };
                }
            }
            const tag = getJsDocTagAtPosition(currentToken, position);
            if (tag) {
                if (tag.tagName.pos <= position && position <= tag.tagName.end) return {
                    kind: 1 /* JsDocTagName */ 
                };
                if (isJSDocImportTag(tag)) insideJsDocImportTag = true;
                else {
                    const typeExpression = tryGetTypeExpressionFromTag(tag);
                    if (typeExpression) {
                        currentToken = getTokenAtPosition(sourceFile, position);
                        if (!currentToken || !isDeclarationName(currentToken) && (currentToken.parent.kind !== 349 /* JSDocPropertyTag */  || currentToken.parent.name !== currentToken)) insideJsDocTagTypeExpression = isCurrentlyEditingNode(typeExpression);
                    }
                    if (!insideJsDocTagTypeExpression && isJSDocParameterTag(tag) && (nodeIsMissing(tag.name) || tag.name.pos <= position && position <= tag.name.end)) return {
                        kind: 3 /* JsDocParameterName */ ,
                        tag
                    };
                }
            }
            if (!insideJsDocTagTypeExpression && !insideJsDocImportTag) {
                log("Returning an empty list because completion was inside a regular comment or plain text part of a JsDoc comment.");
                return void 0;
            }
        }
        start = timestamp();
        const isJsOnlyLocation = !insideJsDocTagTypeExpression && !insideJsDocImportTag && isSourceFileJS(sourceFile);
        const tokens = getRelevantTokens(position, sourceFile);
        const previousToken = tokens.previousToken;
        let contextToken = tokens.contextToken;
        log("getCompletionData: Get previous token: " + (timestamp() - start));
        let node = currentToken;
        let propertyAccessToConvert;
        let isRightOfDot = false;
        let isRightOfQuestionDot = false;
        let isRightOfOpenTag = false;
        let isStartingCloseTag = false;
        let isJsxInitializer = false;
        let isJsxIdentifierExpected = false;
        let importStatementCompletion;
        let location = getTouchingPropertyName(sourceFile, position);
        let keywordFilters = 0 /* None */ ;
        let isNewIdentifierLocation = false;
        let flags = 0 /* None */ ;
        let defaultCommitCharacters;
        if (contextToken) {
            const importStatementCompletionInfo = getImportStatementCompletionInfo(contextToken, sourceFile);
            if (importStatementCompletionInfo.keywordCompletion) {
                if (importStatementCompletionInfo.isKeywordOnlyCompletion) return {
                    kind: 4 /* Keywords */ ,
                    keywordCompletions: [
                        keywordToCompletionEntry(importStatementCompletionInfo.keywordCompletion)
                    ],
                    isNewIdentifierLocation: importStatementCompletionInfo.isNewIdentifierLocation
                };
                keywordFilters = keywordFiltersFromSyntaxKind(importStatementCompletionInfo.keywordCompletion);
            }
            if (importStatementCompletionInfo.replacementSpan && preferences.includeCompletionsForImportStatements && preferences.includeCompletionsWithInsertText) {
                flags |= 2 /* IsImportStatementCompletion */ ;
                importStatementCompletion = importStatementCompletionInfo;
                isNewIdentifierLocation = importStatementCompletionInfo.isNewIdentifierLocation;
            }
            if (!importStatementCompletionInfo.replacementSpan && isCompletionListBlocker(contextToken)) {
                log("Returning an empty list because completion was requested in an invalid position.");
                return keywordFilters ? keywordCompletionData(keywordFilters, isJsOnlyLocation, computeCommitCharactersAndIsNewIdentifier().isNewIdentifierLocation) : void 0;
            }
            let parent2 = contextToken.parent;
            if (contextToken.kind === 25 /* DotToken */  || contextToken.kind === 29 /* QuestionDotToken */ ) {
                isRightOfDot = contextToken.kind === 25 /* DotToken */ ;
                isRightOfQuestionDot = contextToken.kind === 29 /* QuestionDotToken */ ;
                switch(parent2.kind){
                    case 212 /* PropertyAccessExpression */ :
                        propertyAccessToConvert = parent2;
                        node = propertyAccessToConvert.expression;
                        const leftmostAccessExpression = getLeftmostAccessExpression(propertyAccessToConvert);
                        if (nodeIsMissing(leftmostAccessExpression) || (isCallExpression(node) || isFunctionLike(node)) && node.end === contextToken.pos && node.getChildCount(sourceFile) && last(node.getChildren(sourceFile)).kind !== 22 /* CloseParenToken */ ) return void 0;
                        break;
                    case 167 /* QualifiedName */ :
                        node = parent2.left;
                        break;
                    case 268 /* ModuleDeclaration */ :
                        node = parent2.name;
                        break;
                    case 206 /* ImportType */ :
                        node = parent2;
                        break;
                    case 237 /* MetaProperty */ :
                        node = parent2.getFirstToken(sourceFile);
                        Debug.assert(node.kind === 102 /* ImportKeyword */  || node.kind === 105 /* NewKeyword */ );
                        break;
                    default:
                        return void 0;
                }
            } else if (!importStatementCompletion) {
                if (parent2 && parent2.kind === 212 /* PropertyAccessExpression */ ) {
                    contextToken = parent2;
                    parent2 = parent2.parent;
                }
                if (currentToken.parent === location) switch(currentToken.kind){
                    case 32 /* GreaterThanToken */ :
                        if (currentToken.parent.kind === 285 /* JsxElement */  || currentToken.parent.kind === 287 /* JsxOpeningElement */ ) location = currentToken;
                        break;
                    case 31 /* LessThanSlashToken */ :
                        if (currentToken.parent.kind === 286 /* JsxSelfClosingElement */ ) location = currentToken;
                        break;
                }
                switch(parent2.kind){
                    case 288 /* JsxClosingElement */ :
                        if (contextToken.kind === 31 /* LessThanSlashToken */ ) {
                            isStartingCloseTag = true;
                            location = contextToken;
                        }
                        break;
                    case 227 /* BinaryExpression */ :
                        if (!binaryExpressionMayBeOpenTag(parent2)) break;
                    // falls through
                    case 286 /* JsxSelfClosingElement */ :
                    case 285 /* JsxElement */ :
                    case 287 /* JsxOpeningElement */ :
                        isJsxIdentifierExpected = true;
                        if (contextToken.kind === 30 /* LessThanToken */ ) {
                            isRightOfOpenTag = true;
                            location = contextToken;
                        }
                        break;
                    case 295 /* JsxExpression */ :
                    case 294 /* JsxSpreadAttribute */ :
                        if (previousToken.kind === 20 /* CloseBraceToken */  || previousToken.kind === 80 /* Identifier */  && previousToken.parent.kind === 292 /* JsxAttribute */ ) isJsxIdentifierExpected = true;
                        break;
                    case 292 /* JsxAttribute */ :
                        if (parent2.initializer === previousToken && previousToken.end < position) {
                            isJsxIdentifierExpected = true;
                            break;
                        }
                        switch(previousToken.kind){
                            case 64 /* EqualsToken */ :
                                isJsxInitializer = true;
                                break;
                            case 80 /* Identifier */ :
                                isJsxIdentifierExpected = true;
                                if (parent2 !== previousToken.parent && !parent2.initializer && findChildOfKind(parent2, 64 /* EqualsToken */ , sourceFile)) isJsxInitializer = previousToken;
                        }
                        break;
                }
            }
        }
        const semanticStart = timestamp();
        let completionKind = 5 /* None */ ;
        let hasUnresolvedAutoImports = false;
        let symbols = [];
        let importSpecifierResolver;
        const symbolToOriginInfoMap = [];
        const symbolToSortTextMap = [];
        const seenPropertySymbols = /* @__PURE__ */ new Set();
        const isTypeOnlyLocation = isTypeOnlyCompletion();
        const getModuleSpecifierResolutionHost = memoizeOne((isFromPackageJson)=>{
            return createModuleSpecifierResolutionHost(isFromPackageJson ? host.getPackageJsonAutoImportProvider() : program, host);
        });
        if (isRightOfDot || isRightOfQuestionDot) getTypeScriptMemberSymbols();
        else if (isRightOfOpenTag) {
            symbols = typeChecker.getJsxIntrinsicTagNamesAt(location);
            Debug.assertEachIsDefined(symbols, "getJsxIntrinsicTagNames() should all be defined");
            tryGetGlobalSymbols();
            completionKind = 1 /* Global */ ;
            keywordFilters = 0 /* None */ ;
        } else if (isStartingCloseTag) {
            const tagName = contextToken.parent.parent.openingElement.tagName;
            const tagSymbol = typeChecker.getSymbolAtLocation(tagName);
            if (tagSymbol) symbols = [
                tagSymbol
            ];
            completionKind = 1 /* Global */ ;
            keywordFilters = 0 /* None */ ;
        } else {
            if (!tryGetGlobalSymbols()) return keywordFilters ? keywordCompletionData(keywordFilters, isJsOnlyLocation, isNewIdentifierLocation) : void 0;
        }
        log("getCompletionData: Semantic work: " + (timestamp() - semanticStart));
        const contextualType = previousToken && getContextualType(previousToken, position, sourceFile, typeChecker);
        const isLiteralExpected = !tryCast(previousToken, isStringLiteralLike) && !isJsxIdentifierExpected;
        const literals = !isLiteralExpected ? [] : mapDefined(contextualType && (contextualType.isUnion() ? contextualType.types : [
            contextualType
        ]), (t)=>t.isLiteral() && !(t.flags & 1024 /* EnumLiteral */ ) ? t.value : void 0);
        const recommendedCompletion = previousToken && contextualType && getRecommendedCompletion(previousToken, contextualType, typeChecker);
        return {
            kind: 0 /* Data */ ,
            symbols,
            completionKind,
            isInSnippetScope,
            propertyAccessToConvert,
            isNewIdentifierLocation,
            location,
            keywordFilters,
            literals,
            symbolToOriginInfoMap,
            recommendedCompletion,
            previousToken,
            contextToken,
            isJsxInitializer,
            insideJsDocTagTypeExpression,
            symbolToSortTextMap,
            isTypeOnlyLocation,
            isJsxIdentifierExpected,
            isRightOfOpenTag,
            isRightOfDotOrQuestionDot: isRightOfDot || isRightOfQuestionDot,
            importStatementCompletion,
            hasUnresolvedAutoImports,
            flags,
            defaultCommitCharacters
        };
        function isTagWithTypeExpression(tag) {
            switch(tag.kind){
                case 342 /* JSDocParameterTag */ :
                case 349 /* JSDocPropertyTag */ :
                case 343 /* JSDocReturnTag */ :
                case 345 /* JSDocTypeTag */ :
                case 347 /* JSDocTypedefTag */ :
                case 350 /* JSDocThrowsTag */ :
                case 351 /* JSDocSatisfiesTag */ :
                    return true;
                case 346 /* JSDocTemplateTag */ :
                    return !!tag.constraint;
                default:
                    return false;
            }
        }
        function tryGetTypeExpressionFromTag(tag) {
            if (isTagWithTypeExpression(tag)) {
                const typeExpression = isJSDocTemplateTag(tag) ? tag.constraint : tag.typeExpression;
                return typeExpression && typeExpression.kind === 310 /* JSDocTypeExpression */  ? typeExpression : void 0;
            }
            if (isJSDocAugmentsTag(tag) || isJSDocImplementsTag(tag)) return tag.class;
            return void 0;
        }
        function getTypeScriptMemberSymbols() {
            completionKind = 2 /* PropertyAccess */ ;
            const isImportType = isLiteralImportTypeNode(node);
            const isTypeLocation = isImportType && !node.isTypeOf || isPartOfTypeNode(node.parent) || isPossiblyTypeArgumentPosition(contextToken, sourceFile, typeChecker);
            const isRhsOfImportDeclaration = isInRightSideOfInternalImportEqualsDeclaration(node);
            if (isEntityName(node) || isImportType || isPropertyAccessExpression(node)) {
                const isNamespaceName = isModuleDeclaration(node.parent);
                if (isNamespaceName) {
                    isNewIdentifierLocation = true;
                    defaultCommitCharacters = [];
                }
                let symbol = typeChecker.getSymbolAtLocation(node);
                if (symbol) {
                    symbol = skipAlias(symbol, typeChecker);
                    if (symbol.flags & 1920 /* Enum */ ) {
                        const exportedSymbols = typeChecker.getExportsOfModule(symbol);
                        Debug.assertEachIsDefined(exportedSymbols, "getExportsOfModule() should all be defined");
                        const isValidValueAccess = (symbol2)=>typeChecker.isValidPropertyAccess(isImportType ? node : node.parent, symbol2.name);
                        const isValidTypeAccess = (symbol2)=>symbolCanBeReferencedAtTypeLocation(symbol2, typeChecker);
                        const isValidAccess = isNamespaceName ? (symbol2)=>{
                            var _a;
                            return !!(symbol2.flags & 1920 /* Namespace */ ) && !((_a = symbol2.declarations) == null ? void 0 : _a.every((d)=>d.parent === node.parent));
                        } : isRhsOfImportDeclaration ? // Any kind is allowed when dotting off namespace in internal import equals declaration
                        (symbol2)=>isValidTypeAccess(symbol2) || isValidValueAccess(symbol2) : isTypeLocation || insideJsDocTagTypeExpression ? isValidTypeAccess : isValidValueAccess;
                        for (const exportedSymbol of exportedSymbols)if (isValidAccess(exportedSymbol)) symbols.push(exportedSymbol);
                        if (!isTypeLocation && !insideJsDocTagTypeExpression && symbol.declarations && symbol.declarations.some((d)=>d.kind !== 308 /* SourceFile */  && d.kind !== 268 /* ModuleDeclaration */  && d.kind !== 267 /* EnumDeclaration */ )) {
                            let type = typeChecker.getTypeOfSymbolAtLocation(symbol, node).getNonOptionalType();
                            let insertQuestionDot = false;
                            if (type.isNullableType()) {
                                const canCorrectToQuestionDot = isRightOfDot && !isRightOfQuestionDot && preferences.includeAutomaticOptionalChainCompletions !== false;
                                if (canCorrectToQuestionDot || isRightOfQuestionDot) {
                                    type = type.getNonNullableType();
                                    if (canCorrectToQuestionDot) insertQuestionDot = true;
                                }
                            }
                            addTypeProperties(type, !!(node.flags & 65536 /* AwaitContext */ ), insertQuestionDot);
                        }
                        return;
                    }
                }
            }
            if (!isTypeLocation || isInTypeQuery(node)) {
                typeChecker.tryGetThisTypeAt(node, /*includeGlobalThis*/ false);
                let type = typeChecker.getTypeAtLocation(node).getNonOptionalType();
                if (!isTypeLocation) {
                    let insertQuestionDot = false;
                    if (type.isNullableType()) {
                        const canCorrectToQuestionDot = isRightOfDot && !isRightOfQuestionDot && preferences.includeAutomaticOptionalChainCompletions !== false;
                        if (canCorrectToQuestionDot || isRightOfQuestionDot) {
                            type = type.getNonNullableType();
                            if (canCorrectToQuestionDot) insertQuestionDot = true;
                        }
                    }
                    addTypeProperties(type, !!(node.flags & 65536 /* AwaitContext */ ), insertQuestionDot);
                } else addTypeProperties(type.getNonNullableType(), /*insertAwait*/ false, /*insertQuestionDot*/ false);
            }
        }
        function addTypeProperties(type, insertAwait, insertQuestionDot) {
            if (type.getStringIndexType()) {
                isNewIdentifierLocation = true;
                defaultCommitCharacters = [];
            }
            if (isRightOfQuestionDot && some(type.getCallSignatures())) {
                isNewIdentifierLocation = true;
                defaultCommitCharacters !== null && defaultCommitCharacters !== void 0 ? defaultCommitCharacters : defaultCommitCharacters = allCommitCharacters;
            }
            const propertyAccess = node.kind === 206 /* ImportType */  ? node : node.parent;
            if (inCheckedFile) {
                for (const symbol of type.getApparentProperties())if (typeChecker.isValidPropertyAccessForCompletions(propertyAccess, type, symbol)) addPropertySymbol(symbol, /*insertAwait*/ false, insertQuestionDot);
            } else symbols.push(...filter(getPropertiesForCompletion(type, typeChecker), (s)=>typeChecker.isValidPropertyAccessForCompletions(propertyAccess, type, s)));
            if (insertAwait && preferences.includeCompletionsWithInsertText) {
                const promiseType = typeChecker.getPromisedTypeOfPromise(type);
                if (promiseType) {
                    for (const symbol of promiseType.getApparentProperties())if (typeChecker.isValidPropertyAccessForCompletions(propertyAccess, promiseType, symbol)) addPropertySymbol(symbol, /*insertAwait*/ true, insertQuestionDot);
                }
            }
        }
        function addPropertySymbol(symbol, insertAwait, insertQuestionDot) {
            var _a;
            const computedPropertyName = firstDefined(symbol.declarations, (decl)=>tryCast(getNameOfDeclaration(decl), isComputedPropertyName));
            if (computedPropertyName) {
                const leftMostName = getLeftMostName(computedPropertyName.expression);
                const nameSymbol = leftMostName && typeChecker.getSymbolAtLocation(leftMostName);
                const firstAccessibleSymbol = nameSymbol && getFirstSymbolInChain(nameSymbol, contextToken, typeChecker);
                const firstAccessibleSymbolId = firstAccessibleSymbol && getSymbolId(firstAccessibleSymbol);
                if (firstAccessibleSymbolId && addToSeen(seenPropertySymbols, firstAccessibleSymbolId)) {
                    const index = symbols.length;
                    symbols.push(firstAccessibleSymbol);
                    symbolToSortTextMap[getSymbolId(firstAccessibleSymbol)] = SortText.GlobalsOrKeywords;
                    const moduleSymbol = firstAccessibleSymbol.parent;
                    if (!moduleSymbol || !isExternalModuleSymbol(moduleSymbol) || typeChecker.tryGetMemberInModuleExportsAndProperties(firstAccessibleSymbol.name, moduleSymbol) !== firstAccessibleSymbol) symbolToOriginInfoMap[index] = {
                        kind: getNullableSymbolOriginInfoKind(2 /* SymbolMemberNoExport */ )
                    };
                    else {
                        const fileName = isExternalModuleNameRelative(stripQuotes(moduleSymbol.name)) ? (_a = getSourceFileOfModule(moduleSymbol)) == null ? void 0 : _a.fileName : void 0;
                        const { moduleSpecifier } = (importSpecifierResolver || (importSpecifierResolver = ts_codefix_exports.createImportSpecifierResolver(sourceFile, program, host, preferences))).getModuleSpecifierForBestExportInfo([
                            {
                                exportKind: 0 /* Named */ ,
                                moduleFileName: fileName,
                                isFromPackageJson: false,
                                moduleSymbol,
                                symbol: firstAccessibleSymbol,
                                targetFlags: skipAlias(firstAccessibleSymbol, typeChecker).flags
                            }
                        ], position, isValidTypeOnlyAliasUseSite(location)) || {};
                        if (moduleSpecifier) {
                            const origin = {
                                kind: getNullableSymbolOriginInfoKind(6 /* SymbolMemberExport */ ),
                                moduleSymbol,
                                isDefaultExport: false,
                                symbolName: firstAccessibleSymbol.name,
                                exportName: firstAccessibleSymbol.name,
                                fileName,
                                moduleSpecifier
                            };
                            symbolToOriginInfoMap[index] = origin;
                        }
                    }
                } else if (preferences.includeCompletionsWithInsertText) {
                    if (firstAccessibleSymbolId && seenPropertySymbols.has(firstAccessibleSymbolId)) return;
                    addSymbolOriginInfo(symbol);
                    addSymbolSortInfo(symbol);
                    symbols.push(symbol);
                }
            } else {
                addSymbolOriginInfo(symbol);
                addSymbolSortInfo(symbol);
                symbols.push(symbol);
            }
            function addSymbolSortInfo(symbol2) {
                if (isStaticProperty(symbol2)) symbolToSortTextMap[getSymbolId(symbol2)] = SortText.LocalDeclarationPriority;
            }
            function addSymbolOriginInfo(symbol2) {
                if (preferences.includeCompletionsWithInsertText) {
                    if (insertAwait && addToSeen(seenPropertySymbols, getSymbolId(symbol2))) symbolToOriginInfoMap[symbols.length] = {
                        kind: getNullableSymbolOriginInfoKind(8 /* Promise */ )
                    };
                    else if (insertQuestionDot) symbolToOriginInfoMap[symbols.length] = {
                        kind: 16 /* Nullable */ 
                    };
                }
            }
            function getNullableSymbolOriginInfoKind(kind) {
                return insertQuestionDot ? kind | 16 /* Nullable */  : kind;
            }
        }
        function getLeftMostName(e) {
            return isIdentifier(e) ? e : isPropertyAccessExpression(e) ? getLeftMostName(e.expression) : void 0;
        }
        function tryGetGlobalSymbols() {
            const result = tryGetObjectTypeLiteralInTypeArgumentCompletionSymbols() || tryGetObjectLikeCompletionSymbols() || tryGetImportCompletionSymbols() || tryGetImportOrExportClauseCompletionSymbols() || tryGetImportAttributesCompletionSymbols() || tryGetLocalNamedExportCompletionSymbols() || tryGetConstructorCompletion() || tryGetClassLikeCompletionSymbols() || tryGetJsxCompletionSymbols() || (getGlobalCompletions(), 1 /* Success */ );
            return result === 1 /* Success */ ;
        }
        function tryGetConstructorCompletion() {
            if (!tryGetConstructorLikeCompletionContainer(contextToken)) return 0 /* Continue */ ;
            completionKind = 5 /* None */ ;
            isNewIdentifierLocation = true;
            keywordFilters = 4 /* ConstructorParameterKeywords */ ;
            return 1 /* Success */ ;
        }
        function tryGetJsxCompletionSymbols() {
            const jsxContainer = tryGetContainingJsxElement(contextToken);
            const attrsType = jsxContainer && typeChecker.getContextualType(jsxContainer.attributes);
            if (!attrsType) return 0 /* Continue */ ;
            const completionsType = jsxContainer && typeChecker.getContextualType(jsxContainer.attributes, 4 /* Completions */ );
            symbols = concatenate(symbols, filterJsxAttributes(getPropertiesForObjectExpression(attrsType, completionsType, jsxContainer.attributes, typeChecker), jsxContainer.attributes.properties));
            setSortTextToOptionalMember();
            completionKind = 3 /* MemberLike */ ;
            isNewIdentifierLocation = false;
            return 1 /* Success */ ;
        }
        function tryGetImportCompletionSymbols() {
            if (!importStatementCompletion) return 0 /* Continue */ ;
            isNewIdentifierLocation = true;
            collectAutoImports();
            return 1 /* Success */ ;
        }
        function getGlobalCompletions() {
            keywordFilters = tryGetFunctionLikeBodyCompletionContainer(contextToken) ? 5 /* FunctionLikeBodyKeywords */  : 1 /* All */ ;
            completionKind = 1 /* Global */ ;
            ({ isNewIdentifierLocation, defaultCommitCharacters } = computeCommitCharactersAndIsNewIdentifier());
            if (previousToken !== contextToken) Debug.assert(!!previousToken, "Expected 'contextToken' to be defined when different from 'previousToken'.");
            const adjustedPosition = previousToken !== contextToken ? previousToken.getStart() : position;
            const scopeNode = getScopeNode(contextToken, adjustedPosition, sourceFile) || sourceFile;
            isInSnippetScope = isSnippetScope(scopeNode);
            const symbolMeanings = (isTypeOnlyLocation ? 0 /* None */  : 111551 /* Value */ ) | 2887656 /* Alias */ ;
            const typeOnlyAliasNeedsPromotion = previousToken && !isValidTypeOnlyAliasUseSite(previousToken);
            symbols = concatenate(symbols, typeChecker.getSymbolsInScope(scopeNode, symbolMeanings));
            Debug.assertEachIsDefined(symbols, "getSymbolsInScope() should all be defined");
            for(let i = 0; i < symbols.length; i++){
                const symbol = symbols[i];
                if (!typeChecker.isArgumentsSymbol(symbol) && !some(symbol.declarations, (d)=>d.getSourceFile() === sourceFile)) symbolToSortTextMap[getSymbolId(symbol)] = SortText.GlobalsOrKeywords;
                if (typeOnlyAliasNeedsPromotion && !(symbol.flags & 111551 /* Value */ )) {
                    const typeOnlyAliasDeclaration = symbol.declarations && find(symbol.declarations, isTypeOnlyImportDeclaration);
                    if (typeOnlyAliasDeclaration) {
                        const origin = {
                            kind: 64 /* TypeOnlyAlias */ ,
                            declaration: typeOnlyAliasDeclaration
                        };
                        symbolToOriginInfoMap[i] = origin;
                    }
                }
            }
            if (preferences.includeCompletionsWithInsertText && scopeNode.kind !== 308 /* SourceFile */ ) {
                const thisType = typeChecker.tryGetThisTypeAt(scopeNode, /*includeGlobalThis*/ false, isClassLike(scopeNode.parent) ? scopeNode : void 0);
                if (thisType && !isProbablyGlobalType(thisType, sourceFile, typeChecker)) for (const symbol of getPropertiesForCompletion(thisType, typeChecker)){
                    symbolToOriginInfoMap[symbols.length] = {
                        kind: 1 /* ThisType */ 
                    };
                    symbols.push(symbol);
                    symbolToSortTextMap[getSymbolId(symbol)] = SortText.SuggestedClassMembers;
                }
            }
            collectAutoImports();
            if (isTypeOnlyLocation) keywordFilters = contextToken && isAssertionExpression(contextToken.parent) ? 6 /* TypeAssertionKeywords */  : 7 /* TypeKeywords */ ;
        }
        function shouldOfferImportCompletions() {
            var _a;
            if (importStatementCompletion) return true;
            if (!preferences.includeCompletionsForModuleExports) return false;
            if (sourceFile.externalModuleIndicator || sourceFile.commonJsModuleIndicator) return true;
            if (compilerOptionsIndicateEsModules(program.getCompilerOptions())) return true;
            return ((_a = program.getSymlinkCache) == null ? void 0 : _a.call(program).hasAnySymlinks()) || !!program.getCompilerOptions().paths || programContainsModules(program);
        }
        function isSnippetScope(scopeNode) {
            switch(scopeNode.kind){
                case 308 /* SourceFile */ :
                case 229 /* TemplateExpression */ :
                case 295 /* JsxExpression */ :
                case 242 /* Block */ :
                    return true;
                default:
                    return isStatement(scopeNode);
            }
        }
        function isTypeOnlyCompletion() {
            return insideJsDocTagTypeExpression || insideJsDocImportTag || !!importStatementCompletion && isTypeOnlyImportOrExportDeclaration(location.parent) || !isContextTokenValueLocation(contextToken) && (isPossiblyTypeArgumentPosition(contextToken, sourceFile, typeChecker) || isPartOfTypeNode(location) || isContextTokenTypeLocation(contextToken));
        }
        function isContextTokenValueLocation(contextToken2) {
            return contextToken2 && (contextToken2.kind === 114 /* TypeOfKeyword */  && (contextToken2.parent.kind === 187 /* TypeQuery */  || isTypeOfExpression(contextToken2.parent)) || contextToken2.kind === 131 /* AssertsKeyword */  && contextToken2.parent.kind === 183 /* TypePredicate */ );
        }
        function isContextTokenTypeLocation(contextToken2) {
            if (contextToken2) {
                const parentKind = contextToken2.parent.kind;
                switch(contextToken2.kind){
                    case 59 /* ColonToken */ :
                        return parentKind === 173 /* PropertyDeclaration */  || parentKind === 172 /* PropertySignature */  || parentKind === 170 /* Parameter */  || parentKind === 261 /* VariableDeclaration */  || isFunctionLikeKind(parentKind);
                    case 64 /* EqualsToken */ :
                        return parentKind === 266 /* TypeAliasDeclaration */  || parentKind === 169 /* TypeParameter */ ;
                    case 130 /* AsKeyword */ :
                        return parentKind === 235 /* AsExpression */ ;
                    case 30 /* LessThanToken */ :
                        return parentKind === 184 /* TypeReference */  || parentKind === 217 /* TypeAssertionExpression */ ;
                    case 96 /* ExtendsKeyword */ :
                        return parentKind === 169 /* TypeParameter */ ;
                    case 152 /* SatisfiesKeyword */ :
                        return parentKind === 239 /* SatisfiesExpression */ ;
                }
            }
            return false;
        }
        function collectAutoImports() {
            var _a, _b;
            if (!shouldOfferImportCompletions()) return;
            Debug.assert(!(detailsEntryId == null ? void 0 : detailsEntryId.data), "Should not run 'collectAutoImports' when faster path is available via `data`");
            if (detailsEntryId && !detailsEntryId.source) return;
            flags |= 1 /* MayIncludeAutoImports */ ;
            const isAfterTypeOnlyImportSpecifierModifier = previousToken === contextToken && importStatementCompletion;
            const lowerCaseTokenText = isAfterTypeOnlyImportSpecifierModifier ? "" : previousToken && isIdentifier(previousToken) ? previousToken.text.toLowerCase() : "";
            const moduleSpecifierCache = (_a = host.getModuleSpecifierCache) == null ? void 0 : _a.call(host);
            const exportInfo = getExportInfoMap(sourceFile, host, program, preferences, cancellationToken);
            const packageJsonAutoImportProvider = (_b = host.getPackageJsonAutoImportProvider) == null ? void 0 : _b.call(host);
            const packageJsonFilter = detailsEntryId ? void 0 : createPackageJsonImportFilter(sourceFile, preferences, host);
            resolvingModuleSpecifiers("collectAutoImports", host, importSpecifierResolver || (importSpecifierResolver = ts_codefix_exports.createImportSpecifierResolver(sourceFile, program, host, preferences)), program, position, preferences, !!importStatementCompletion, isValidTypeOnlyAliasUseSite(location), (context)=>{
                exportInfo.search(sourceFile.path, /*preferCapitalized*/ isRightOfOpenTag, (symbolName2, targetFlags)=>{
                    if (!isIdentifierText(symbolName2, getEmitScriptTarget(host.getCompilationSettings()))) return false;
                    if (!detailsEntryId && isStringANonContextualKeyword(symbolName2)) return false;
                    if (!isTypeOnlyLocation && !importStatementCompletion && !(targetFlags & 111551 /* Value */ )) return false;
                    if (isTypeOnlyLocation && !(targetFlags & 790504 /* Type */ )) return false;
                    const firstChar = symbolName2.charCodeAt(0);
                    if (isRightOfOpenTag && (firstChar < 65 /* A */  || firstChar > 90 /* Z */ )) return false;
                    if (detailsEntryId) return true;
                    return charactersFuzzyMatchInString(symbolName2, lowerCaseTokenText);
                }, (info, symbolName2, isFromAmbientModule, exportMapKey)=>{
                    if (detailsEntryId && !some(info, (i)=>detailsEntryId.source === stripQuotes(i.moduleSymbol.name))) return;
                    info = filter(info, isImportableExportInfo);
                    if (!info.length) return;
                    const result = context.tryResolve(info, isFromAmbientModule) || {};
                    if (result === "failed") return;
                    let exportInfo2 = info[0], moduleSpecifier;
                    if (result !== "skipped") ({ exportInfo: exportInfo2 = info[0], moduleSpecifier } = result);
                    const isDefaultExport = exportInfo2.exportKind === 1 /* Default */ ;
                    const symbol = isDefaultExport && getLocalSymbolForExportDefault(Debug.checkDefined(exportInfo2.symbol)) || Debug.checkDefined(exportInfo2.symbol);
                    pushAutoImportSymbol(symbol, {
                        kind: moduleSpecifier ? 32 /* ResolvedExport */  : 4 /* Export */ ,
                        moduleSpecifier,
                        symbolName: symbolName2,
                        exportMapKey,
                        exportName: exportInfo2.exportKind === 2 /* ExportEquals */  ? "export=" /* ExportEquals */  : Debug.checkDefined(exportInfo2.symbol).name,
                        fileName: exportInfo2.moduleFileName,
                        isDefaultExport,
                        moduleSymbol: exportInfo2.moduleSymbol,
                        isFromPackageJson: exportInfo2.isFromPackageJson
                    });
                });
                hasUnresolvedAutoImports = context.skippedAny();
                flags |= context.resolvedAny() ? 8 /* ResolvedModuleSpecifiers */  : 0;
                flags |= context.resolvedBeyondLimit() ? 16 /* ResolvedModuleSpecifiersBeyondLimit */  : 0;
            });
            function isImportableExportInfo(info) {
                return isImportable(info.isFromPackageJson ? packageJsonAutoImportProvider : program, sourceFile, tryCast(info.moduleSymbol.valueDeclaration, isSourceFile), info.moduleSymbol, preferences, packageJsonFilter, getModuleSpecifierResolutionHost(info.isFromPackageJson), moduleSpecifierCache);
            }
        }
        function pushAutoImportSymbol(symbol, origin) {
            const symbolId = getSymbolId(symbol);
            if (symbolToSortTextMap[symbolId] === SortText.GlobalsOrKeywords) return;
            symbolToOriginInfoMap[symbols.length] = origin;
            symbolToSortTextMap[symbolId] = importStatementCompletion ? SortText.LocationPriority : SortText.AutoImportSuggestions;
            symbols.push(symbol);
        }
        function collectObjectLiteralMethodSymbols(members, enclosingDeclaration) {
            if (isInJSFile(location)) return;
            members.forEach((member)=>{
                if (!isObjectLiteralMethodSymbol(member)) return;
                const displayName = getCompletionEntryDisplayNameForSymbol(member, getEmitScriptTarget(compilerOptions), /*origin*/ void 0, 0 /* ObjectPropertyDeclaration */ , /*jsxIdentifierExpected*/ false);
                if (!displayName) return;
                const { name } = displayName;
                const entryProps = getEntryForObjectLiteralMethodCompletion(member, name, enclosingDeclaration, program, host, compilerOptions, preferences, formatContext);
                if (!entryProps) return;
                const origin = (0, _objectSpread._)({
                    kind: 128 /* ObjectLiteralMethod */ 
                }, entryProps);
                flags |= 32 /* MayIncludeMethodSnippets */ ;
                symbolToOriginInfoMap[symbols.length] = origin;
                symbols.push(member);
            });
        }
        function isObjectLiteralMethodSymbol(symbol) {
            if (!(symbol.flags & 8196 /* Method */ )) return false;
            return true;
        }
        function getScopeNode(initialToken, position2, sourceFile2) {
            let scope = initialToken;
            while(scope && !positionBelongsToNode(scope, position2, sourceFile2))scope = scope.parent;
            return scope;
        }
        function isCompletionListBlocker(contextToken2) {
            const start2 = timestamp();
            const result = isInStringOrRegularExpressionOrTemplateLiteral(contextToken2) || isSolelyIdentifierDefinitionLocation(contextToken2) || isDotOfNumericLiteral(contextToken2) || isInJsxText(contextToken2) || isBigIntLiteral(contextToken2);
            log("getCompletionsAtPosition: isCompletionListBlocker: " + (timestamp() - start2));
            return result;
        }
        function isInJsxText(contextToken2) {
            if (contextToken2.kind === 12 /* JsxText */ ) return true;
            if (contextToken2.kind === 32 /* GreaterThanToken */  && contextToken2.parent) {
                if (location === contextToken2.parent && (location.kind === 287 /* JsxOpeningElement */  || location.kind === 286 /* JsxSelfClosingElement */ )) return false;
                if (contextToken2.parent.kind === 287 /* JsxOpeningElement */ ) return location.parent.kind !== 287 /* JsxOpeningElement */ ;
                if (contextToken2.parent.kind === 288 /* JsxClosingElement */  || contextToken2.parent.kind === 286 /* JsxSelfClosingElement */ ) return !!contextToken2.parent.parent && contextToken2.parent.parent.kind === 285 /* JsxElement */ ;
            }
            return false;
        }
        function computeCommitCharactersAndIsNewIdentifier() {
            if (contextToken) {
                const containingNodeKind = contextToken.parent.kind;
                const tokenKind = keywordForNode(contextToken);
                switch(tokenKind){
                    case 28 /* CommaToken */ :
                        switch(containingNodeKind){
                            case 214 /* CallExpression */ :
                            // func( a, |
                            case 215 /* NewExpression */ :
                                {
                                    const expression = contextToken.parent.expression;
                                    if (getLineAndCharacterOfPosition(sourceFile, expression.end).line !== getLineAndCharacterOfPosition(sourceFile, position).line) return {
                                        defaultCommitCharacters: noCommaCommitCharacters,
                                        isNewIdentifierLocation: true
                                    };
                                    return {
                                        defaultCommitCharacters: allCommitCharacters,
                                        isNewIdentifierLocation: true
                                    };
                                }
                            case 227 /* BinaryExpression */ :
                                return {
                                    defaultCommitCharacters: noCommaCommitCharacters,
                                    isNewIdentifierLocation: true
                                };
                            case 177 /* Constructor */ :
                            // constructor( a, | /* public, protected, private keywords are allowed here, so show completion */
                            case 185 /* FunctionType */ :
                            // var x: (s: string, list|
                            case 211 /* ObjectLiteralExpression */ :
                                return {
                                    defaultCommitCharacters: [],
                                    isNewIdentifierLocation: true
                                };
                            case 210 /* ArrayLiteralExpression */ :
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: true
                                };
                            default:
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: false
                                };
                        }
                    case 21 /* OpenParenToken */ :
                        switch(containingNodeKind){
                            case 214 /* CallExpression */ :
                            // func( |
                            case 215 /* NewExpression */ :
                                {
                                    const expression = contextToken.parent.expression;
                                    if (getLineAndCharacterOfPosition(sourceFile, expression.end).line !== getLineAndCharacterOfPosition(sourceFile, position).line) return {
                                        defaultCommitCharacters: noCommaCommitCharacters,
                                        isNewIdentifierLocation: true
                                    };
                                    return {
                                        defaultCommitCharacters: allCommitCharacters,
                                        isNewIdentifierLocation: true
                                    };
                                }
                            case 218 /* ParenthesizedExpression */ :
                                return {
                                    defaultCommitCharacters: noCommaCommitCharacters,
                                    isNewIdentifierLocation: true
                                };
                            case 177 /* Constructor */ :
                            // constructor( |
                            case 197 /* ParenthesizedType */ :
                                return {
                                    defaultCommitCharacters: [],
                                    isNewIdentifierLocation: true
                                };
                            default:
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: false
                                };
                        }
                    case 23 /* OpenBracketToken */ :
                        switch(containingNodeKind){
                            case 210 /* ArrayLiteralExpression */ :
                            // [ |
                            case 182 /* IndexSignature */ :
                            // [ | : string ]
                            case 190 /* TupleType */ :
                            // [ | : string ]
                            case 168 /* ComputedPropertyName */ :
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: true
                                };
                            default:
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: false
                                };
                        }
                    case 144 /* ModuleKeyword */ :
                    // module |
                    case 145 /* NamespaceKeyword */ :
                    // namespace |
                    case 102 /* ImportKeyword */ :
                        return {
                            defaultCommitCharacters: [],
                            isNewIdentifierLocation: true
                        };
                    case 25 /* DotToken */ :
                        switch(containingNodeKind){
                            case 268 /* ModuleDeclaration */ :
                                return {
                                    defaultCommitCharacters: [],
                                    isNewIdentifierLocation: true
                                };
                            default:
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: false
                                };
                        }
                    case 19 /* OpenBraceToken */ :
                        switch(containingNodeKind){
                            case 264 /* ClassDeclaration */ :
                            // class A { |
                            case 211 /* ObjectLiteralExpression */ :
                                return {
                                    defaultCommitCharacters: [],
                                    isNewIdentifierLocation: true
                                };
                            default:
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: false
                                };
                        }
                    case 64 /* EqualsToken */ :
                        switch(containingNodeKind){
                            case 261 /* VariableDeclaration */ :
                            // const x = a|
                            case 227 /* BinaryExpression */ :
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: true
                                };
                            default:
                                return {
                                    defaultCommitCharacters: allCommitCharacters,
                                    isNewIdentifierLocation: false
                                };
                        }
                    case 16 /* TemplateHead */ :
                        return {
                            defaultCommitCharacters: allCommitCharacters,
                            isNewIdentifierLocation: containingNodeKind === 229 /* TemplateExpression */ 
                        };
                    case 17 /* TemplateMiddle */ :
                        return {
                            defaultCommitCharacters: allCommitCharacters,
                            isNewIdentifierLocation: containingNodeKind === 240 /* TemplateSpan */ 
                        };
                    case 134 /* AsyncKeyword */ :
                        return containingNodeKind === 175 /* MethodDeclaration */  || containingNodeKind === 305 /* ShorthandPropertyAssignment */  ? {
                            defaultCommitCharacters: [],
                            isNewIdentifierLocation: true
                        } : {
                            defaultCommitCharacters: allCommitCharacters,
                            isNewIdentifierLocation: false
                        };
                    case 42 /* AsteriskToken */ :
                        return containingNodeKind === 175 /* MethodDeclaration */  ? {
                            defaultCommitCharacters: [],
                            isNewIdentifierLocation: true
                        } : {
                            defaultCommitCharacters: allCommitCharacters,
                            isNewIdentifierLocation: false
                        };
                }
                if (isClassMemberCompletionKeyword(tokenKind)) return {
                    defaultCommitCharacters: [],
                    isNewIdentifierLocation: true
                };
            }
            return {
                defaultCommitCharacters: allCommitCharacters,
                isNewIdentifierLocation: false
            };
        }
        function isInStringOrRegularExpressionOrTemplateLiteral(contextToken2) {
            return (isRegularExpressionLiteral(contextToken2) || isStringTextContainingNode(contextToken2)) && (rangeContainsPositionExclusive(contextToken2, position) || position === contextToken2.end && (!!contextToken2.isUnterminated || isRegularExpressionLiteral(contextToken2)));
        }
        function tryGetObjectTypeLiteralInTypeArgumentCompletionSymbols() {
            const typeLiteralNode = tryGetTypeLiteralNode(contextToken);
            if (!typeLiteralNode) return 0 /* Continue */ ;
            const intersectionTypeNode = isIntersectionTypeNode(typeLiteralNode.parent) ? typeLiteralNode.parent : void 0;
            const containerTypeNode = intersectionTypeNode || typeLiteralNode;
            const containerExpectedType = getConstraintOfTypeArgumentProperty(containerTypeNode, typeChecker);
            if (!containerExpectedType) return 0 /* Continue */ ;
            const containerActualType = typeChecker.getTypeFromTypeNode(containerTypeNode);
            const members = getPropertiesForCompletion(containerExpectedType, typeChecker);
            const existingMembers = getPropertiesForCompletion(containerActualType, typeChecker);
            const existingMemberEscapedNames = /* @__PURE__ */ new Set();
            existingMembers.forEach((s)=>existingMemberEscapedNames.add(s.escapedName));
            symbols = concatenate(symbols, filter(members, (s)=>!existingMemberEscapedNames.has(s.escapedName)));
            completionKind = 0 /* ObjectPropertyDeclaration */ ;
            isNewIdentifierLocation = true;
            return 1 /* Success */ ;
        }
        function tryGetObjectLikeCompletionSymbols() {
            if ((contextToken == null ? void 0 : contextToken.kind) === 26 /* DotDotDotToken */ ) return 0 /* Continue */ ;
            const symbolsStartIndex = symbols.length;
            const objectLikeContainer = tryGetObjectLikeCompletionContainer(contextToken, position, sourceFile);
            if (!objectLikeContainer) return 0 /* Continue */ ;
            completionKind = 0 /* ObjectPropertyDeclaration */ ;
            let typeMembers;
            let existingMembers;
            if (objectLikeContainer.kind === 211 /* ObjectLiteralExpression */ ) {
                const instantiatedType = tryGetObjectLiteralContextualType(objectLikeContainer, typeChecker);
                if (instantiatedType === void 0) {
                    if (objectLikeContainer.flags & 67108864 /* InWithStatement */ ) return 2 /* Fail */ ;
                    return 0 /* Continue */ ;
                }
                const completionsType = typeChecker.getContextualType(objectLikeContainer, 4 /* Completions */ );
                const hasStringIndexType = (completionsType || instantiatedType).getStringIndexType();
                const hasNumberIndextype = (completionsType || instantiatedType).getNumberIndexType();
                isNewIdentifierLocation = !!hasStringIndexType || !!hasNumberIndextype;
                typeMembers = getPropertiesForObjectExpression(instantiatedType, completionsType, objectLikeContainer, typeChecker);
                existingMembers = objectLikeContainer.properties;
                if (typeMembers.length === 0) {
                    if (!hasNumberIndextype) return 0 /* Continue */ ;
                }
            } else {
                Debug.assert(objectLikeContainer.kind === 207 /* ObjectBindingPattern */ );
                isNewIdentifierLocation = false;
                const rootDeclaration = getRootDeclaration(objectLikeContainer.parent);
                if (!isVariableLike(rootDeclaration)) return Debug.fail("Root declaration is not variable-like.");
                let canGetType = hasInitializer(rootDeclaration) || !!getEffectiveTypeAnnotationNode(rootDeclaration) || rootDeclaration.parent.parent.kind === 251 /* ForOfStatement */ ;
                if (!canGetType && rootDeclaration.kind === 170 /* Parameter */ ) {
                    if (isExpression(rootDeclaration.parent)) canGetType = !!typeChecker.getContextualType(rootDeclaration.parent);
                    else if (rootDeclaration.parent.kind === 175 /* MethodDeclaration */  || rootDeclaration.parent.kind === 179 /* SetAccessor */ ) canGetType = isExpression(rootDeclaration.parent.parent) && !!typeChecker.getContextualType(rootDeclaration.parent.parent);
                }
                if (canGetType) {
                    const typeForObject = typeChecker.getTypeAtLocation(objectLikeContainer);
                    if (!typeForObject) return 2 /* Fail */ ;
                    typeMembers = typeChecker.getPropertiesOfType(typeForObject).filter((propertySymbol)=>{
                        return typeChecker.isPropertyAccessible(objectLikeContainer, /*isSuper*/ false, /*isWrite*/ false, typeForObject, propertySymbol);
                    });
                    existingMembers = objectLikeContainer.elements;
                }
            }
            if (typeMembers && typeMembers.length > 0) {
                const filteredMembers = filterObjectMembersList(typeMembers, Debug.checkDefined(existingMembers));
                symbols = concatenate(symbols, filteredMembers);
                setSortTextToOptionalMember();
                if (objectLikeContainer.kind === 211 /* ObjectLiteralExpression */  && preferences.includeCompletionsWithObjectLiteralMethodSnippets && preferences.includeCompletionsWithInsertText) {
                    transformObjectLiteralMembersSortText(symbolsStartIndex);
                    collectObjectLiteralMethodSymbols(filteredMembers, objectLikeContainer);
                }
            }
            return 1 /* Success */ ;
        }
        function tryGetImportOrExportClauseCompletionSymbols() {
            if (!contextToken) return 0 /* Continue */ ;
            const namedImportsOrExports = contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 28 /* CommaToken */  ? tryCast(contextToken.parent, isNamedImportsOrExports) : isTypeKeywordTokenOrIdentifier(contextToken) ? tryCast(contextToken.parent.parent, isNamedImportsOrExports) : void 0;
            if (!namedImportsOrExports) return 0 /* Continue */ ;
            if (!isTypeKeywordTokenOrIdentifier(contextToken)) keywordFilters = 8 /* TypeKeyword */ ;
            const { moduleSpecifier } = namedImportsOrExports.kind === 276 /* NamedImports */  ? namedImportsOrExports.parent.parent : namedImportsOrExports.parent;
            if (!moduleSpecifier) {
                isNewIdentifierLocation = true;
                return namedImportsOrExports.kind === 276 /* NamedImports */  ? 2 /* Fail */  : 0 /* Continue */ ;
            }
            const moduleSpecifierSymbol = typeChecker.getSymbolAtLocation(moduleSpecifier);
            if (!moduleSpecifierSymbol) {
                isNewIdentifierLocation = true;
                return 2 /* Fail */ ;
            }
            completionKind = 3 /* MemberLike */ ;
            isNewIdentifierLocation = false;
            const exports2 = typeChecker.getExportsAndPropertiesOfModule(moduleSpecifierSymbol);
            const existing = new Set(namedImportsOrExports.elements.filter((n)=>!isCurrentlyEditingNode(n)).map((n)=>moduleExportNameTextEscaped(n.propertyName || n.name)));
            const uniques = exports2.filter((e)=>e.escapedName !== "default" /* Default */  && !existing.has(e.escapedName));
            symbols = concatenate(symbols, uniques);
            if (!uniques.length) keywordFilters = 0 /* None */ ;
            return 1 /* Success */ ;
        }
        function tryGetImportAttributesCompletionSymbols() {
            if (contextToken === void 0) return 0 /* Continue */ ;
            const importAttributes = contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 28 /* CommaToken */  ? tryCast(contextToken.parent, isImportAttributes) : contextToken.kind === 59 /* ColonToken */  ? tryCast(contextToken.parent.parent, isImportAttributes) : void 0;
            if (importAttributes === void 0) return 0 /* Continue */ ;
            const existing = new Set(importAttributes.elements.map(getNameFromImportAttribute));
            symbols = filter(typeChecker.getTypeAtLocation(importAttributes).getApparentProperties(), (attr)=>!existing.has(attr.escapedName));
            return 1 /* Success */ ;
        }
        function tryGetLocalNamedExportCompletionSymbols() {
            var _a;
            const namedExports = contextToken && (contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 28 /* CommaToken */ ) ? tryCast(contextToken.parent, isNamedExports) : void 0;
            if (!namedExports) return 0 /* Continue */ ;
            const localsContainer = findAncestor(namedExports, or(isSourceFile, isModuleDeclaration));
            completionKind = 5 /* None */ ;
            isNewIdentifierLocation = false;
            (_a = localsContainer.locals) == null || _a.forEach((symbol, name)=>{
                var _a2, _b;
                symbols.push(symbol);
                if ((_b = (_a2 = localsContainer.symbol) == null ? void 0 : _a2.exports) == null ? void 0 : _b.has(name)) symbolToSortTextMap[getSymbolId(symbol)] = SortText.OptionalMember;
            });
            return 1 /* Success */ ;
        }
        function tryGetClassLikeCompletionSymbols() {
            const decl = tryGetObjectTypeDeclarationCompletionContainer(sourceFile, contextToken, location, position);
            if (!decl) return 0 /* Continue */ ;
            completionKind = 3 /* MemberLike */ ;
            isNewIdentifierLocation = true;
            keywordFilters = contextToken.kind === 42 /* AsteriskToken */  ? 0 /* None */  : isClassLike(decl) ? 2 /* ClassElementKeywords */  : 3 /* InterfaceElementKeywords */ ;
            if (!isClassLike(decl)) return 1 /* Success */ ;
            const classElement = contextToken.kind === 27 /* SemicolonToken */  ? contextToken.parent.parent : contextToken.parent;
            let classElementModifierFlags = isClassElement(classElement) ? getEffectiveModifierFlags(classElement) : 0 /* None */ ;
            if (contextToken.kind === 80 /* Identifier */  && !isCurrentlyEditingNode(contextToken)) switch(contextToken.getText()){
                case "private":
                    classElementModifierFlags = classElementModifierFlags | 2 /* Private */ ;
                    break;
                case "static":
                    classElementModifierFlags = classElementModifierFlags | 256 /* Static */ ;
                    break;
                case "override":
                    classElementModifierFlags = classElementModifierFlags | 16 /* Override */ ;
                    break;
            }
            if (isClassStaticBlockDeclaration(classElement)) classElementModifierFlags |= 256 /* Static */ ;
            if (!(classElementModifierFlags & 2 /* Private */ )) {
                const baseTypeNodes = isClassLike(decl) && classElementModifierFlags & 16 /* Override */  ? singleElementArray(getEffectiveBaseTypeNode(decl)) : getAllSuperTypeNodes(decl);
                const baseSymbols = flatMap(baseTypeNodes, (baseTypeNode)=>{
                    const type = typeChecker.getTypeAtLocation(baseTypeNode);
                    return classElementModifierFlags & 256 /* Static */  ? (type == null ? void 0 : type.symbol) && typeChecker.getPropertiesOfType(typeChecker.getTypeOfSymbolAtLocation(type.symbol, decl)) : type && typeChecker.getPropertiesOfType(type);
                });
                symbols = concatenate(symbols, filterClassMembersList(baseSymbols, decl.members, classElementModifierFlags));
                forEach(symbols, (symbol, index)=>{
                    const declaration = symbol == null ? void 0 : symbol.valueDeclaration;
                    if (declaration && isClassElement(declaration) && declaration.name && isComputedPropertyName(declaration.name)) {
                        const origin = {
                            kind: 512 /* ComputedPropertyName */ ,
                            symbolName: typeChecker.symbolToString(symbol)
                        };
                        symbolToOriginInfoMap[index] = origin;
                    }
                });
            }
            return 1 /* Success */ ;
        }
        function isConstructorParameterCompletion(node2) {
            return !!node2.parent && isParameter(node2.parent) && isConstructorDeclaration(node2.parent.parent) && (isParameterPropertyModifier(node2.kind) || isDeclarationName(node2));
        }
        function tryGetConstructorLikeCompletionContainer(contextToken2) {
            if (contextToken2) {
                const parent2 = contextToken2.parent;
                switch(contextToken2.kind){
                    case 21 /* OpenParenToken */ :
                    case 28 /* CommaToken */ :
                        return isConstructorDeclaration(contextToken2.parent) ? contextToken2.parent : void 0;
                    default:
                        if (isConstructorParameterCompletion(contextToken2)) return parent2.parent;
                }
            }
            return void 0;
        }
        function tryGetFunctionLikeBodyCompletionContainer(contextToken2) {
            if (contextToken2) {
                let prev;
                const container = findAncestor(contextToken2.parent, (node2)=>{
                    if (isClassLike(node2)) return "quit";
                    if (isFunctionLikeDeclaration(node2) && prev === node2.body) return true;
                    prev = node2;
                    return false;
                });
                return container && container;
            }
        }
        function tryGetContainingJsxElement(contextToken2) {
            if (contextToken2) {
                const parent2 = contextToken2.parent;
                switch(contextToken2.kind){
                    case 32 /* GreaterThanToken */ :
                    // End of a type argument list
                    case 31 /* LessThanSlashToken */ :
                    case 44 /* SlashToken */ :
                    case 80 /* Identifier */ :
                    case 212 /* PropertyAccessExpression */ :
                    case 293 /* JsxAttributes */ :
                    case 292 /* JsxAttribute */ :
                    case 294 /* JsxSpreadAttribute */ :
                        if (parent2 && (parent2.kind === 286 /* JsxSelfClosingElement */  || parent2.kind === 287 /* JsxOpeningElement */ )) {
                            if (contextToken2.kind === 32 /* GreaterThanToken */ ) {
                                const precedingToken = findPrecedingToken(contextToken2.pos, sourceFile, /*startNode*/ void 0);
                                if (!parent2.typeArguments || precedingToken && precedingToken.kind === 44 /* SlashToken */ ) break;
                            }
                            return parent2;
                        } else if (parent2.kind === 292 /* JsxAttribute */ ) return parent2.parent.parent;
                        break;
                    // The context token is the closing } or " of an attribute, which means
                    // its parent is a JsxExpression, whose parent is a JsxAttribute,
                    // whose parent is a JsxOpeningLikeElement
                    case 11 /* StringLiteral */ :
                        if (parent2 && (parent2.kind === 292 /* JsxAttribute */  || parent2.kind === 294 /* JsxSpreadAttribute */ )) return parent2.parent.parent;
                        break;
                    case 20 /* CloseBraceToken */ :
                        if (parent2 && parent2.kind === 295 /* JsxExpression */  && parent2.parent && parent2.parent.kind === 292 /* JsxAttribute */ ) return parent2.parent.parent.parent;
                        if (parent2 && parent2.kind === 294 /* JsxSpreadAttribute */ ) return parent2.parent.parent;
                        break;
                }
            }
            return void 0;
        }
        function isInDifferentLineThanContextToken(contextToken2, position2) {
            return sourceFile.getLineEndOfPosition(contextToken2.getEnd()) < position2;
        }
        function isSolelyIdentifierDefinitionLocation(contextToken2) {
            const parent2 = contextToken2.parent;
            const containingNodeKind = parent2.kind;
            switch(contextToken2.kind){
                case 28 /* CommaToken */ :
                    return containingNodeKind === 261 /* VariableDeclaration */  || isVariableDeclarationListButNotTypeArgument(contextToken2) || containingNodeKind === 244 /* VariableStatement */  || containingNodeKind === 267 /* EnumDeclaration */  || // enum a { foo, |
                    isFunctionLikeButNotConstructor(containingNodeKind) || containingNodeKind === 265 /* InterfaceDeclaration */  || // interface A<T, |
                    containingNodeKind === 208 /* ArrayBindingPattern */  || // var [x, y|
                    containingNodeKind === 266 /* TypeAliasDeclaration */  || // type Map, K, |
                    // class A<T, |
                    // var C = class D<T, |
                    isClassLike(parent2) && !!parent2.typeParameters && parent2.typeParameters.end >= contextToken2.pos;
                case 25 /* DotToken */ :
                    return containingNodeKind === 208 /* ArrayBindingPattern */ ;
                // var [.|
                case 59 /* ColonToken */ :
                    return containingNodeKind === 209 /* BindingElement */ ;
                // var {x :html|
                case 23 /* OpenBracketToken */ :
                    return containingNodeKind === 208 /* ArrayBindingPattern */ ;
                // var [x|
                case 21 /* OpenParenToken */ :
                    return containingNodeKind === 300 /* CatchClause */  || isFunctionLikeButNotConstructor(containingNodeKind);
                case 19 /* OpenBraceToken */ :
                    return containingNodeKind === 267 /* EnumDeclaration */ ;
                // enum a { |
                case 30 /* LessThanToken */ :
                    return containingNodeKind === 264 /* ClassDeclaration */  || // class A< |
                    containingNodeKind === 232 /* ClassExpression */  || // var C = class D< |
                    containingNodeKind === 265 /* InterfaceDeclaration */  || // interface A< |
                    containingNodeKind === 266 /* TypeAliasDeclaration */  || // type List< |
                    isFunctionLikeKind(containingNodeKind);
                case 126 /* StaticKeyword */ :
                    return containingNodeKind === 173 /* PropertyDeclaration */  && !isClassLike(parent2.parent);
                case 26 /* DotDotDotToken */ :
                    return containingNodeKind === 170 /* Parameter */  || !!parent2.parent && parent2.parent.kind === 208 /* ArrayBindingPattern */ ;
                // var [...z|
                case 125 /* PublicKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                    return containingNodeKind === 170 /* Parameter */  && !isConstructorDeclaration(parent2.parent);
                case 130 /* AsKeyword */ :
                    return containingNodeKind === 277 /* ImportSpecifier */  || containingNodeKind === 282 /* ExportSpecifier */  || containingNodeKind === 275 /* NamespaceImport */ ;
                case 139 /* GetKeyword */ :
                case 153 /* SetKeyword */ :
                    return !isFromObjectTypeDeclaration(contextToken2);
                case 80 /* Identifier */ :
                    {
                        if ((containingNodeKind === 277 /* ImportSpecifier */  || containingNodeKind === 282 /* ExportSpecifier */ ) && contextToken2 === parent2.name && contextToken2.text === "type") return false;
                        const ancestorVariableDeclaration = findAncestor(contextToken2.parent, isVariableDeclaration);
                        if (ancestorVariableDeclaration && isInDifferentLineThanContextToken(contextToken2, position)) return false;
                        break;
                    }
                case 86 /* ClassKeyword */ :
                case 94 /* EnumKeyword */ :
                case 120 /* InterfaceKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 115 /* VarKeyword */ :
                case 102 /* ImportKeyword */ :
                case 121 /* LetKeyword */ :
                case 87 /* ConstKeyword */ :
                case 140 /* InferKeyword */ :
                    return true;
                case 156 /* TypeKeyword */ :
                    return containingNodeKind !== 277 /* ImportSpecifier */ ;
                case 42 /* AsteriskToken */ :
                    return isFunctionLike(contextToken2.parent) && !isMethodDeclaration(contextToken2.parent);
            }
            if (isClassMemberCompletionKeyword(keywordForNode(contextToken2)) && isFromObjectTypeDeclaration(contextToken2)) return false;
            if (isConstructorParameterCompletion(contextToken2)) {
                if (!isIdentifier(contextToken2) || isParameterPropertyModifier(keywordForNode(contextToken2)) || isCurrentlyEditingNode(contextToken2)) return false;
            }
            switch(keywordForNode(contextToken2)){
                case 128 /* AbstractKeyword */ :
                case 86 /* ClassKeyword */ :
                case 87 /* ConstKeyword */ :
                case 138 /* DeclareKeyword */ :
                case 94 /* EnumKeyword */ :
                case 100 /* FunctionKeyword */ :
                case 120 /* InterfaceKeyword */ :
                case 121 /* LetKeyword */ :
                case 123 /* PrivateKeyword */ :
                case 124 /* ProtectedKeyword */ :
                case 125 /* PublicKeyword */ :
                case 126 /* StaticKeyword */ :
                case 115 /* VarKeyword */ :
                    return true;
                case 134 /* AsyncKeyword */ :
                    return isPropertyDeclaration(contextToken2.parent);
            }
            const ancestorClassLike = findAncestor(contextToken2.parent, isClassLike);
            if (ancestorClassLike && contextToken2 === previousToken && isPreviousPropertyDeclarationTerminated(contextToken2, position)) return false;
            const ancestorPropertyDeclaraion = getAncestor(contextToken2.parent, 173 /* PropertyDeclaration */ );
            if (ancestorPropertyDeclaraion && contextToken2 !== previousToken && isClassLike(previousToken.parent.parent) && position <= previousToken.end) {
                if (isPreviousPropertyDeclarationTerminated(contextToken2, previousToken.end)) return false;
                else if (contextToken2.kind !== 64 /* EqualsToken */  && (isInitializedProperty(ancestorPropertyDeclaraion) || hasType(ancestorPropertyDeclaraion))) return true;
            }
            return isDeclarationName(contextToken2) && !isShorthandPropertyAssignment(contextToken2.parent) && !isJsxAttribute(contextToken2.parent) && !((isClassLike(contextToken2.parent) || isInterfaceDeclaration(contextToken2.parent) || isTypeParameterDeclaration(contextToken2.parent)) && (contextToken2 !== previousToken || position > previousToken.end));
        }
        function isPreviousPropertyDeclarationTerminated(contextToken2, position2) {
            return contextToken2.kind !== 64 /* EqualsToken */  && (contextToken2.kind === 27 /* SemicolonToken */  || !positionsAreOnSameLine(contextToken2.end, position2, sourceFile));
        }
        function isFunctionLikeButNotConstructor(kind) {
            return isFunctionLikeKind(kind) && kind !== 177 /* Constructor */ ;
        }
        function isDotOfNumericLiteral(contextToken2) {
            if (contextToken2.kind === 9 /* NumericLiteral */ ) {
                const text = contextToken2.getFullText();
                return text.charAt(text.length - 1) === ".";
            }
            return false;
        }
        function isVariableDeclarationListButNotTypeArgument(node2) {
            return node2.parent.kind === 262 /* VariableDeclarationList */  && !isPossiblyTypeArgumentPosition(node2, sourceFile, typeChecker);
        }
        function filterObjectMembersList(contextualMemberSymbols, existingMembers) {
            if (existingMembers.length === 0) return contextualMemberSymbols;
            const membersDeclaredBySpreadAssignment = /* @__PURE__ */ new Set();
            const existingMemberNames = /* @__PURE__ */ new Set();
            for (const m of existingMembers){
                if (m.kind !== 304 /* PropertyAssignment */  && m.kind !== 305 /* ShorthandPropertyAssignment */  && m.kind !== 209 /* BindingElement */  && m.kind !== 175 /* MethodDeclaration */  && m.kind !== 178 /* GetAccessor */  && m.kind !== 179 /* SetAccessor */  && m.kind !== 306 /* SpreadAssignment */ ) continue;
                if (isCurrentlyEditingNode(m)) continue;
                let existingName;
                if (isSpreadAssignment(m)) setMembersDeclaredBySpreadAssignment(m, membersDeclaredBySpreadAssignment);
                else if (isBindingElement(m) && m.propertyName) {
                    if (m.propertyName.kind === 80 /* Identifier */ ) existingName = m.propertyName.escapedText;
                } else {
                    const name = getNameOfDeclaration(m);
                    existingName = name && isPropertyNameLiteral(name) ? getEscapedTextOfIdentifierOrLiteral(name) : void 0;
                }
                if (existingName !== void 0) existingMemberNames.add(existingName);
            }
            const filteredSymbols = contextualMemberSymbols.filter((m)=>!existingMemberNames.has(m.escapedName));
            setSortTextToMemberDeclaredBySpreadAssignment(membersDeclaredBySpreadAssignment, filteredSymbols);
            return filteredSymbols;
        }
        function setMembersDeclaredBySpreadAssignment(declaration, membersDeclaredBySpreadAssignment) {
            const expression = declaration.expression;
            const symbol = typeChecker.getSymbolAtLocation(expression);
            const type = symbol && typeChecker.getTypeOfSymbolAtLocation(symbol, expression);
            const properties = type && type.properties;
            if (properties) properties.forEach((property)=>{
                membersDeclaredBySpreadAssignment.add(property.name);
            });
        }
        function setSortTextToOptionalMember() {
            symbols.forEach((m)=>{
                if (m.flags & 16777216 /* Optional */ ) {
                    const symbolId = getSymbolId(m);
                    var _symbolToSortTextMap_symbolId;
                    symbolToSortTextMap[symbolId] = (_symbolToSortTextMap_symbolId = symbolToSortTextMap[symbolId]) !== null && _symbolToSortTextMap_symbolId !== void 0 ? _symbolToSortTextMap_symbolId : SortText.OptionalMember;
                }
            });
        }
        function setSortTextToMemberDeclaredBySpreadAssignment(membersDeclaredBySpreadAssignment, contextualMemberSymbols) {
            if (membersDeclaredBySpreadAssignment.size === 0) return;
            for (const contextualMemberSymbol of contextualMemberSymbols)if (membersDeclaredBySpreadAssignment.has(contextualMemberSymbol.name)) symbolToSortTextMap[getSymbolId(contextualMemberSymbol)] = SortText.MemberDeclaredBySpreadAssignment;
        }
        function transformObjectLiteralMembersSortText(start2) {
            for(let i = start2; i < symbols.length; i++){
                const symbol = symbols[i];
                const symbolId = getSymbolId(symbol);
                const origin = symbolToOriginInfoMap == null ? void 0 : symbolToOriginInfoMap[i];
                const target = getEmitScriptTarget(compilerOptions);
                const displayName = getCompletionEntryDisplayNameForSymbol(symbol, target, origin, 0 /* ObjectPropertyDeclaration */ , /*jsxIdentifierExpected*/ false);
                if (displayName) {
                    var _symbolToSortTextMap_symbolId;
                    const originalSortText = (_symbolToSortTextMap_symbolId = symbolToSortTextMap[symbolId]) !== null && _symbolToSortTextMap_symbolId !== void 0 ? _symbolToSortTextMap_symbolId : SortText.LocationPriority;
                    const { name } = displayName;
                    symbolToSortTextMap[symbolId] = SortText.ObjectLiteralProperty(originalSortText, name);
                }
            }
        }
        function filterClassMembersList(baseSymbols, existingMembers, currentClassElementModifierFlags) {
            const existingMemberNames = /* @__PURE__ */ new Set();
            for (const m of existingMembers){
                if (m.kind !== 173 /* PropertyDeclaration */  && m.kind !== 175 /* MethodDeclaration */  && m.kind !== 178 /* GetAccessor */  && m.kind !== 179 /* SetAccessor */ ) continue;
                if (isCurrentlyEditingNode(m)) continue;
                if (hasEffectiveModifier(m, 2 /* Private */ )) continue;
                if (isStatic(m) !== !!(currentClassElementModifierFlags & 256 /* Static */ )) continue;
                const existingName = getPropertyNameForPropertyNameNode(m.name);
                if (existingName) existingMemberNames.add(existingName);
            }
            return baseSymbols.filter((propertySymbol)=>!existingMemberNames.has(propertySymbol.escapedName) && !!propertySymbol.declarations && !(getDeclarationModifierFlagsFromSymbol(propertySymbol) & 2 /* Private */ ) && !(propertySymbol.valueDeclaration && isPrivateIdentifierClassElementDeclaration(propertySymbol.valueDeclaration)));
        }
        function filterJsxAttributes(symbols2, attributes) {
            const seenNames = /* @__PURE__ */ new Set();
            const membersDeclaredBySpreadAssignment = /* @__PURE__ */ new Set();
            for (const attr of attributes){
                if (isCurrentlyEditingNode(attr)) continue;
                if (attr.kind === 292 /* JsxAttribute */ ) seenNames.add(getEscapedTextOfJsxAttributeName(attr.name));
                else if (isJsxSpreadAttribute(attr)) setMembersDeclaredBySpreadAssignment(attr, membersDeclaredBySpreadAssignment);
            }
            const filteredSymbols = symbols2.filter((a)=>!seenNames.has(a.escapedName));
            setSortTextToMemberDeclaredBySpreadAssignment(membersDeclaredBySpreadAssignment, filteredSymbols);
            return filteredSymbols;
        }
        function isCurrentlyEditingNode(node2) {
            return node2.getStart(sourceFile) <= position && position <= node2.getEnd();
        }
    }
    function tryGetObjectLikeCompletionContainer(contextToken, position, sourceFile) {
        var _a;
        if (contextToken) {
            const { parent: parent2 } = contextToken;
            switch(contextToken.kind){
                case 19 /* OpenBraceToken */ :
                // const x = { |
                case 28 /* CommaToken */ :
                    if (isObjectLiteralExpression(parent2) || isObjectBindingPattern(parent2)) return parent2;
                    break;
                case 42 /* AsteriskToken */ :
                    return isMethodDeclaration(parent2) ? tryCast(parent2.parent, isObjectLiteralExpression) : void 0;
                case 134 /* AsyncKeyword */ :
                    return tryCast(parent2.parent, isObjectLiteralExpression);
                case 80 /* Identifier */ :
                    if (contextToken.text === "async" && isShorthandPropertyAssignment(contextToken.parent)) return contextToken.parent.parent;
                    else {
                        if (isObjectLiteralExpression(contextToken.parent.parent) && (isSpreadAssignment(contextToken.parent) || isShorthandPropertyAssignment(contextToken.parent) && getLineAndCharacterOfPosition(sourceFile, contextToken.getEnd()).line !== getLineAndCharacterOfPosition(sourceFile, position).line)) return contextToken.parent.parent;
                        const ancestorNode2 = findAncestor(parent2, isPropertyAssignment);
                        if ((ancestorNode2 == null ? void 0 : ancestorNode2.getLastToken(sourceFile)) === contextToken && isObjectLiteralExpression(ancestorNode2.parent)) return ancestorNode2.parent;
                    }
                    break;
                default:
                    if (((_a = parent2.parent) == null ? void 0 : _a.parent) && (isMethodDeclaration(parent2.parent) || isGetAccessorDeclaration(parent2.parent) || isSetAccessorDeclaration(parent2.parent)) && isObjectLiteralExpression(parent2.parent.parent)) return parent2.parent.parent;
                    if (isSpreadAssignment(parent2) && isObjectLiteralExpression(parent2.parent)) return parent2.parent;
                    const ancestorNode = findAncestor(parent2, isPropertyAssignment);
                    if (contextToken.kind !== 59 /* ColonToken */  && (ancestorNode == null ? void 0 : ancestorNode.getLastToken(sourceFile)) === contextToken && isObjectLiteralExpression(ancestorNode.parent)) return ancestorNode.parent;
            }
        }
        return void 0;
    }
    function getRelevantTokens(position, sourceFile) {
        const previousToken = findPrecedingToken(position, sourceFile);
        if (previousToken && position <= previousToken.end && (isMemberName(previousToken) || isKeyword(previousToken.kind))) {
            const contextToken = findPrecedingToken(previousToken.getFullStart(), sourceFile, /*startNode*/ void 0);
            return {
                contextToken,
                previousToken
            };
        }
        return {
            contextToken: previousToken,
            previousToken
        };
    }
    function getAutoImportSymbolFromCompletionEntryData(name, data, program, host) {
        const containingProgram = data.isPackageJsonImport ? host.getPackageJsonAutoImportProvider() : program;
        const checker = containingProgram.getTypeChecker();
        const moduleSymbol = data.ambientModuleName ? checker.tryFindAmbientModule(data.ambientModuleName) : data.fileName ? checker.getMergedSymbol(Debug.checkDefined(containingProgram.getSourceFile(data.fileName)).symbol) : void 0;
        if (!moduleSymbol) return void 0;
        let symbol = data.exportName === "export=" /* ExportEquals */  ? checker.resolveExternalModuleSymbol(moduleSymbol) : checker.tryGetMemberInModuleExportsAndProperties(data.exportName, moduleSymbol);
        if (!symbol) return void 0;
        const isDefaultExport = data.exportName === "default" /* Default */ ;
        symbol = isDefaultExport && getLocalSymbolForExportDefault(symbol) || symbol;
        return {
            symbol,
            origin: completionEntryDataToSymbolOriginInfo(data, name, moduleSymbol)
        };
    }
    function getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind, jsxIdentifierExpected) {
        if (originIsIgnore(origin)) return void 0;
        const name = originIncludesSymbolName(origin) ? origin.symbolName : symbol.name;
        if (name === void 0 || symbol.flags & 1536 /* Module */  && isSingleOrDoubleQuote(name.charCodeAt(0)) || isKnownSymbol(symbol)) return void 0;
        const validNameResult = {
            name,
            needsConvertPropertyAccess: false
        };
        if (isIdentifierText(name, target, jsxIdentifierExpected ? 1 /* JSX */  : 0 /* Standard */ ) || symbol.valueDeclaration && isPrivateIdentifierClassElementDeclaration(symbol.valueDeclaration)) return validNameResult;
        if (symbol.flags & 2097152 /* Alias */ ) return {
            name,
            needsConvertPropertyAccess: true
        };
        switch(kind){
            case 3 /* MemberLike */ :
                return originIsComputedPropertyName(origin) ? {
                    name: origin.symbolName,
                    needsConvertPropertyAccess: false
                } : void 0;
            case 0 /* ObjectPropertyDeclaration */ :
                return {
                    name: JSON.stringify(name),
                    needsConvertPropertyAccess: false
                };
            case 2 /* PropertyAccess */ :
            case 1 /* Global */ :
                return name.charCodeAt(0) === 32 /* space */  ? void 0 : {
                    name,
                    needsConvertPropertyAccess: true
                };
            case 5 /* None */ :
            case 4 /* String */ :
                return validNameResult;
            default:
                Debug.assertNever(kind);
        }
    }
    var _keywordCompletions = [];
    var allKeywordsCompletions = memoize(()=>{
        const res = [];
        for(let i = 83 /* FirstKeyword */ ; i <= 166 /* LastKeyword */ ; i++)res.push({
            name: tokenToString(i),
            kind: "keyword" /* keyword */ ,
            kindModifiers: "" /* none */ ,
            sortText: SortText.GlobalsOrKeywords
        });
        return res;
    });
    function getKeywordCompletions(keywordFilter, filterOutTsOnlyKeywords) {
        if (!filterOutTsOnlyKeywords) return getTypescriptKeywordCompletions(keywordFilter);
        const index = keywordFilter + 8 /* Last */  + 1;
        return _keywordCompletions[index] || (_keywordCompletions[index] = getTypescriptKeywordCompletions(keywordFilter).filter((entry)=>!isTypeScriptOnlyKeyword(stringToToken(entry.name))));
    }
    function getTypescriptKeywordCompletions(keywordFilter) {
        return _keywordCompletions[keywordFilter] || (_keywordCompletions[keywordFilter] = allKeywordsCompletions().filter((entry)=>{
            const kind = stringToToken(entry.name);
            switch(keywordFilter){
                case 0 /* None */ :
                    return false;
                case 1 /* All */ :
                    return isFunctionLikeBodyKeyword(kind) || kind === 138 /* DeclareKeyword */  || kind === 144 /* ModuleKeyword */  || kind === 156 /* TypeKeyword */  || kind === 145 /* NamespaceKeyword */  || kind === 128 /* AbstractKeyword */  || isTypeKeyword(kind) && kind !== 157 /* UndefinedKeyword */ ;
                case 5 /* FunctionLikeBodyKeywords */ :
                    return isFunctionLikeBodyKeyword(kind);
                case 2 /* ClassElementKeywords */ :
                    return isClassMemberCompletionKeyword(kind);
                case 3 /* InterfaceElementKeywords */ :
                    return isInterfaceOrTypeLiteralCompletionKeyword(kind);
                case 4 /* ConstructorParameterKeywords */ :
                    return isParameterPropertyModifier(kind);
                case 6 /* TypeAssertionKeywords */ :
                    return isTypeKeyword(kind) || kind === 87 /* ConstKeyword */ ;
                case 7 /* TypeKeywords */ :
                    return isTypeKeyword(kind);
                case 8 /* TypeKeyword */ :
                    return kind === 156 /* TypeKeyword */ ;
                default:
                    return Debug.assertNever(keywordFilter);
            }
        }));
    }
    function isTypeScriptOnlyKeyword(kind) {
        switch(kind){
            case 128 /* AbstractKeyword */ :
            case 133 /* AnyKeyword */ :
            case 163 /* BigIntKeyword */ :
            case 136 /* BooleanKeyword */ :
            case 138 /* DeclareKeyword */ :
            case 94 /* EnumKeyword */ :
            case 162 /* GlobalKeyword */ :
            case 119 /* ImplementsKeyword */ :
            case 140 /* InferKeyword */ :
            case 120 /* InterfaceKeyword */ :
            case 142 /* IsKeyword */ :
            case 143 /* KeyOfKeyword */ :
            case 144 /* ModuleKeyword */ :
            case 145 /* NamespaceKeyword */ :
            case 146 /* NeverKeyword */ :
            case 150 /* NumberKeyword */ :
            case 151 /* ObjectKeyword */ :
            case 164 /* OverrideKeyword */ :
            case 123 /* PrivateKeyword */ :
            case 124 /* ProtectedKeyword */ :
            case 125 /* PublicKeyword */ :
            case 148 /* ReadonlyKeyword */ :
            case 154 /* StringKeyword */ :
            case 155 /* SymbolKeyword */ :
            case 156 /* TypeKeyword */ :
            case 158 /* UniqueKeyword */ :
            case 159 /* UnknownKeyword */ :
                return true;
            default:
                return false;
        }
    }
    function isInterfaceOrTypeLiteralCompletionKeyword(kind) {
        return kind === 148 /* ReadonlyKeyword */ ;
    }
    function isClassMemberCompletionKeyword(kind) {
        switch(kind){
            case 128 /* AbstractKeyword */ :
            case 129 /* AccessorKeyword */ :
            case 137 /* ConstructorKeyword */ :
            case 139 /* GetKeyword */ :
            case 153 /* SetKeyword */ :
            case 134 /* AsyncKeyword */ :
            case 138 /* DeclareKeyword */ :
            case 164 /* OverrideKeyword */ :
                return true;
            default:
                return isClassMemberModifier(kind);
        }
    }
    function isFunctionLikeBodyKeyword(kind) {
        return kind === 134 /* AsyncKeyword */  || kind === 135 /* AwaitKeyword */  || kind === 160 /* UsingKeyword */  || kind === 130 /* AsKeyword */  || kind === 152 /* SatisfiesKeyword */  || kind === 156 /* TypeKeyword */  || !isContextualKeyword(kind) && !isClassMemberCompletionKeyword(kind);
    }
    function keywordForNode(node) {
        var _identifierToKeywordKind;
        return isIdentifier(node) ? (_identifierToKeywordKind = identifierToKeywordKind(node)) !== null && _identifierToKeywordKind !== void 0 ? _identifierToKeywordKind : 0 /* Unknown */  : node.kind;
    }
    function getContextualKeywords(contextToken, position) {
        const entries = [];
        if (contextToken) {
            const file = contextToken.getSourceFile();
            const parent2 = contextToken.parent;
            const tokenLine = file.getLineAndCharacterOfPosition(contextToken.end).line;
            const currentLine = file.getLineAndCharacterOfPosition(position).line;
            if ((isImportDeclaration(parent2) || isExportDeclaration(parent2) && parent2.moduleSpecifier) && contextToken === parent2.moduleSpecifier && tokenLine === currentLine) entries.push({
                name: tokenToString(132 /* AssertKeyword */ ),
                kind: "keyword" /* keyword */ ,
                kindModifiers: "" /* none */ ,
                sortText: SortText.GlobalsOrKeywords
            });
        }
        return entries;
    }
    function getJsDocTagAtPosition(node, position) {
        return findAncestor(node, (n)=>isJSDocTag(n) && rangeContainsPosition(n, position) ? true : isJSDoc(n) ? "quit" : false);
    }
    function getPropertiesForObjectExpression(contextualType, completionsType, obj, checker) {
        const hasCompletionsType = completionsType && completionsType !== contextualType;
        const promiseFilteredContextualType = checker.getUnionType(filter(contextualType.flags & 1048576 /* Union */  ? contextualType.types : [
            contextualType
        ], (t)=>!checker.getPromisedTypeOfPromise(t)));
        const type = hasCompletionsType && !(completionsType.flags & 3 /* AnyOrUnknown */ ) ? checker.getUnionType([
            promiseFilteredContextualType,
            completionsType
        ]) : promiseFilteredContextualType;
        const properties = getApparentProperties(type, obj, checker);
        return type.isClass() && containsNonPublicProperties(properties) ? [] : hasCompletionsType ? filter(properties, hasDeclarationOtherThanSelf) : properties;
        function hasDeclarationOtherThanSelf(member) {
            if (!length(member.declarations)) return true;
            return some(member.declarations, (decl)=>decl.parent !== obj);
        }
    }
    function getApparentProperties(type, node, checker) {
        if (!type.isUnion()) return type.getApparentProperties();
        return checker.getAllPossiblePropertiesOfTypes(filter(type.types, (memberType)=>!(memberType.flags & 402784252 /* Primitive */  || checker.isArrayLikeType(memberType) || checker.isTypeInvalidDueToUnionDiscriminant(memberType, node) || checker.typeHasCallOrConstructSignatures(memberType) || memberType.isClass() && containsNonPublicProperties(memberType.getApparentProperties()))));
    }
    function containsNonPublicProperties(props) {
        return some(props, (p)=>!!(getDeclarationModifierFlagsFromSymbol(p) & 6 /* NonPublicAccessibilityModifier */ ));
    }
    function getPropertiesForCompletion(type, checker) {
        return type.isUnion() ? Debug.checkEachDefined(checker.getAllPossiblePropertiesOfTypes(type.types), "getAllPossiblePropertiesOfTypes() should all be defined") : Debug.checkEachDefined(type.getApparentProperties(), "getApparentProperties() should all be defined");
    }
    function tryGetObjectTypeDeclarationCompletionContainer(sourceFile, contextToken, location, position) {
        switch(location.kind){
            case 353 /* SyntaxList */ :
                return tryCast(location.parent, isObjectTypeDeclaration);
            case 1 /* EndOfFileToken */ :
                const cls = tryCast(lastOrUndefined(cast(location.parent, isSourceFile).statements), isObjectTypeDeclaration);
                if (cls && !findChildOfKind(cls, 20 /* CloseBraceToken */ , sourceFile)) return cls;
                break;
            case 81 /* PrivateIdentifier */ :
                if (tryCast(location.parent, isPropertyDeclaration)) return findAncestor(location, isClassLike);
                break;
            case 80 /* Identifier */ :
                {
                    const originalKeywordKind = identifierToKeywordKind(location);
                    if (originalKeywordKind) return void 0;
                    if (isPropertyDeclaration(location.parent) && location.parent.initializer === location) return void 0;
                    if (isFromObjectTypeDeclaration(location)) return findAncestor(location, isObjectTypeDeclaration);
                }
        }
        if (!contextToken) return void 0;
        if (location.kind === 137 /* ConstructorKeyword */  || isIdentifier(contextToken) && isPropertyDeclaration(contextToken.parent) && isClassLike(location)) return findAncestor(contextToken, isClassLike);
        switch(contextToken.kind){
            case 64 /* EqualsToken */ :
                return void 0;
            case 27 /* SemicolonToken */ :
            // class c {getValue(): number; | }
            case 20 /* CloseBraceToken */ :
                return isFromObjectTypeDeclaration(location) && location.parent.name === location ? location.parent.parent : tryCast(location, isObjectTypeDeclaration);
            case 19 /* OpenBraceToken */ :
            // class c { |
            case 28 /* CommaToken */ :
                return tryCast(contextToken.parent, isObjectTypeDeclaration);
            default:
                if (isObjectTypeDeclaration(location)) {
                    if (getLineAndCharacterOfPosition(sourceFile, contextToken.getEnd()).line !== getLineAndCharacterOfPosition(sourceFile, position).line) return location;
                    const isValidKeyword = isClassLike(contextToken.parent.parent) ? isClassMemberCompletionKeyword : isInterfaceOrTypeLiteralCompletionKeyword;
                    var _identifierToKeywordKind;
                    return isValidKeyword(contextToken.kind) || contextToken.kind === 42 /* AsteriskToken */  || isIdentifier(contextToken) && isValidKeyword((_identifierToKeywordKind = identifierToKeywordKind(contextToken)) !== null && _identifierToKeywordKind !== void 0 ? _identifierToKeywordKind : 0 /* Unknown */ ) ? contextToken.parent.parent : void 0;
                }
                return void 0;
        }
    }
    function tryGetTypeLiteralNode(node) {
        if (!node) return void 0;
        const parent2 = node.parent;
        switch(node.kind){
            case 19 /* OpenBraceToken */ :
                if (isTypeLiteralNode(parent2)) return parent2;
                break;
            case 27 /* SemicolonToken */ :
            case 28 /* CommaToken */ :
            case 80 /* Identifier */ :
                if (parent2.kind === 172 /* PropertySignature */  && isTypeLiteralNode(parent2.parent)) return parent2.parent;
                break;
        }
        return void 0;
    }
    function getConstraintOfTypeArgumentProperty(node, checker) {
        if (!node) return void 0;
        if (isTypeNode(node) && isTypeReferenceType(node.parent)) return checker.getTypeArgumentConstraint(node);
        const t = getConstraintOfTypeArgumentProperty(node.parent, checker);
        if (!t) return void 0;
        switch(node.kind){
            case 172 /* PropertySignature */ :
                return checker.getTypeOfPropertyOfContextualType(t, node.symbol.escapedName);
            case 194 /* IntersectionType */ :
            case 188 /* TypeLiteral */ :
            case 193 /* UnionType */ :
                return t;
        }
    }
    function isFromObjectTypeDeclaration(node) {
        return node.parent && isClassOrTypeElement(node.parent) && isObjectTypeDeclaration(node.parent.parent);
    }
    function isValidTrigger(sourceFile, triggerCharacter, contextToken, position) {
        switch(triggerCharacter){
            case ".":
            case "@":
                return true;
            case '"':
            case "'":
            case "`":
                return !!contextToken && isStringLiteralOrTemplate(contextToken) && position === contextToken.getStart(sourceFile) + 1;
            case "#":
                return !!contextToken && isPrivateIdentifier(contextToken) && !!getContainingClass(contextToken);
            case "<":
                return !!contextToken && contextToken.kind === 30 /* LessThanToken */  && (!isBinaryExpression(contextToken.parent) || binaryExpressionMayBeOpenTag(contextToken.parent));
            case "/":
                return !!contextToken && (isStringLiteralLike(contextToken) ? !!tryGetImportFromModuleSpecifier(contextToken) : contextToken.kind === 31 /* LessThanSlashToken */  && isJsxClosingElement(contextToken.parent));
            case " ":
                return !!contextToken && isImportKeyword(contextToken) && contextToken.parent.kind === 308 /* SourceFile */ ;
            default:
                return Debug.assertNever(triggerCharacter);
        }
    }
    function binaryExpressionMayBeOpenTag({ left }) {
        return nodeIsMissing(left);
    }
    function isProbablyGlobalType(type, sourceFile, checker) {
        const selfSymbol = checker.resolveName("self", /*location*/ void 0, 111551 /* Value */ , /*excludeGlobals*/ false);
        if (selfSymbol && checker.getTypeOfSymbolAtLocation(selfSymbol, sourceFile) === type) return true;
        const globalSymbol = checker.resolveName("global", /*location*/ void 0, 111551 /* Value */ , /*excludeGlobals*/ false);
        if (globalSymbol && checker.getTypeOfSymbolAtLocation(globalSymbol, sourceFile) === type) return true;
        const globalThisSymbol = checker.resolveName("globalThis", /*location*/ void 0, 111551 /* Value */ , /*excludeGlobals*/ false);
        if (globalThisSymbol && checker.getTypeOfSymbolAtLocation(globalThisSymbol, sourceFile) === type) return true;
        return false;
    }
    function isStaticProperty(symbol) {
        return !!(symbol.valueDeclaration && getEffectiveModifierFlags(symbol.valueDeclaration) & 256 /* Static */  && isClassLike(symbol.valueDeclaration.parent));
    }
    function tryGetObjectLiteralContextualType(node, typeChecker) {
        const type = typeChecker.getContextualType(node);
        if (type) return type;
        const parent2 = walkUpParenthesizedExpressions(node.parent);
        if (isBinaryExpression(parent2) && parent2.operatorToken.kind === 64 /* EqualsToken */  && node === parent2.left) return typeChecker.getTypeAtLocation(parent2);
        if (isExpression(parent2)) return typeChecker.getContextualType(parent2);
        return void 0;
    }
    function getImportStatementCompletionInfo(contextToken, sourceFile) {
        var _a, _b, _c;
        let keywordCompletion;
        let isKeywordOnlyCompletion = false;
        const candidate = getCandidate();
        return {
            isKeywordOnlyCompletion,
            keywordCompletion,
            isNewIdentifierLocation: !!(candidate || keywordCompletion === 156 /* TypeKeyword */ ),
            isTopLevelTypeOnly: !!((_b = (_a = tryCast(candidate, isImportDeclaration)) == null ? void 0 : _a.importClause) == null ? void 0 : _b.isTypeOnly) || !!((_c = tryCast(candidate, isImportEqualsDeclaration)) == null ? void 0 : _c.isTypeOnly),
            couldBeTypeOnlyImportSpecifier: !!candidate && couldBeTypeOnlyImportSpecifier(candidate, contextToken),
            replacementSpan: getSingleLineReplacementSpanForImportCompletionNode(candidate)
        };
        function getCandidate() {
            const parent2 = contextToken.parent;
            if (isImportEqualsDeclaration(parent2)) {
                const lastToken = parent2.getLastToken(sourceFile);
                if (isIdentifier(contextToken) && lastToken !== contextToken) {
                    keywordCompletion = 161 /* FromKeyword */ ;
                    isKeywordOnlyCompletion = true;
                    return void 0;
                }
                keywordCompletion = contextToken.kind === 156 /* TypeKeyword */  ? void 0 : 156 /* TypeKeyword */ ;
                return isModuleSpecifierMissingOrEmpty(parent2.moduleReference) ? parent2 : void 0;
            }
            if (couldBeTypeOnlyImportSpecifier(parent2, contextToken) && canCompleteFromNamedBindings(parent2.parent)) return parent2;
            if (isNamedImports(parent2) || isNamespaceImport(parent2)) {
                if (!parent2.parent.isTypeOnly && (contextToken.kind === 19 /* OpenBraceToken */  || contextToken.kind === 102 /* ImportKeyword */  || contextToken.kind === 28 /* CommaToken */ )) keywordCompletion = 156 /* TypeKeyword */ ;
                if (canCompleteFromNamedBindings(parent2)) {
                    if (contextToken.kind === 20 /* CloseBraceToken */  || contextToken.kind === 80 /* Identifier */ ) {
                        isKeywordOnlyCompletion = true;
                        keywordCompletion = 161 /* FromKeyword */ ;
                    } else return parent2.parent.parent;
                }
                return void 0;
            }
            if (isExportDeclaration(parent2) && contextToken.kind === 42 /* AsteriskToken */  || isNamedExports(parent2) && contextToken.kind === 20 /* CloseBraceToken */ ) {
                isKeywordOnlyCompletion = true;
                keywordCompletion = 161 /* FromKeyword */ ;
                return void 0;
            }
            if (isImportKeyword(contextToken) && isSourceFile(parent2)) {
                keywordCompletion = 156 /* TypeKeyword */ ;
                return contextToken;
            }
            if (isImportKeyword(contextToken) && isImportDeclaration(parent2)) {
                keywordCompletion = 156 /* TypeKeyword */ ;
                return isModuleSpecifierMissingOrEmpty(parent2.moduleSpecifier) ? parent2 : void 0;
            }
            return void 0;
        }
    }
    function getSingleLineReplacementSpanForImportCompletionNode(node) {
        var _a;
        if (!node) return void 0;
        var _findAncestor;
        const top = (_findAncestor = findAncestor(node, or(isImportDeclaration, isImportEqualsDeclaration, isJSDocImportTag))) !== null && _findAncestor !== void 0 ? _findAncestor : node;
        const sourceFile = top.getSourceFile();
        if (rangeIsOnSingleLine(top, sourceFile)) return createTextSpanFromNode(top, sourceFile);
        Debug.assert(top.kind !== 102 /* ImportKeyword */  && top.kind !== 277 /* ImportSpecifier */ );
        var _getPotentiallyInvalidImportSpecifier;
        const potentialSplitPoint = top.kind === 273 /* ImportDeclaration */  || top.kind === 352 /* JSDocImportTag */  ? (_getPotentiallyInvalidImportSpecifier = getPotentiallyInvalidImportSpecifier((_a = top.importClause) == null ? void 0 : _a.namedBindings)) !== null && _getPotentiallyInvalidImportSpecifier !== void 0 ? _getPotentiallyInvalidImportSpecifier : top.moduleSpecifier : top.moduleReference;
        const withoutModuleSpecifier = {
            pos: top.getFirstToken().getStart(),
            end: potentialSplitPoint.pos
        };
        if (rangeIsOnSingleLine(withoutModuleSpecifier, sourceFile)) return createTextSpanFromRange(withoutModuleSpecifier);
    }
    function getPotentiallyInvalidImportSpecifier(namedBindings) {
        var _a;
        return find((_a = tryCast(namedBindings, isNamedImports)) == null ? void 0 : _a.elements, (e)=>{
            var _a2;
            return !e.propertyName && isStringANonContextualKeyword(e.name.text) && ((_a2 = findPrecedingToken(e.name.pos, namedBindings.getSourceFile(), namedBindings)) == null ? void 0 : _a2.kind) !== 28 /* CommaToken */ ;
        });
    }
    function couldBeTypeOnlyImportSpecifier(importSpecifier, contextToken) {
        return isImportSpecifier(importSpecifier) && (importSpecifier.isTypeOnly || contextToken === importSpecifier.name && isTypeKeywordTokenOrIdentifier(contextToken));
    }
    function canCompleteFromNamedBindings(namedBindings) {
        if (!isModuleSpecifierMissingOrEmpty(namedBindings.parent.parent.moduleSpecifier) || namedBindings.parent.name) return false;
        if (isNamedImports(namedBindings)) {
            const invalidNamedImport = getPotentiallyInvalidImportSpecifier(namedBindings);
            const validImports = invalidNamedImport ? namedBindings.elements.indexOf(invalidNamedImport) : namedBindings.elements.length;
            return validImports < 2;
        }
        return true;
    }
    function isModuleSpecifierMissingOrEmpty(specifier) {
        var _a;
        if (nodeIsMissing(specifier)) return true;
        return !((_a = tryCast(isExternalModuleReference(specifier) ? specifier.expression : specifier, isStringLiteralLike)) == null ? void 0 : _a.text);
    }
    function getClosestSymbolDeclaration(contextToken, location) {
        if (!contextToken) return;
        let closestDeclaration = findAncestor(contextToken, (node)=>isFunctionBlock(node) || isArrowFunctionBody(node) || isBindingPattern(node) ? "quit" : (isParameter(node) || isTypeParameterDeclaration(node)) && !isIndexSignatureDeclaration(node.parent));
        if (!closestDeclaration) closestDeclaration = findAncestor(location, (node)=>isFunctionBlock(node) || isArrowFunctionBody(node) || isBindingPattern(node) ? "quit" : isVariableDeclaration(node));
        return closestDeclaration;
    }
    function isInTypeParameterDefault(contextToken) {
        if (!contextToken) return false;
        let node = contextToken;
        let parent2 = contextToken.parent;
        while(parent2){
            if (isTypeParameterDeclaration(parent2)) return parent2.default === node || node.kind === 64 /* EqualsToken */ ;
            node = parent2;
            parent2 = parent2.parent;
        }
        return false;
    }
    function isArrowFunctionBody(node) {
        return node.parent && isArrowFunction(node.parent) && (node.parent.body === node || // const a = () => /**/;
        node.kind === 39 /* EqualsGreaterThanToken */ );
    }
    function symbolCanBeReferencedAtTypeLocation(symbol, checker, seenModules = /* @__PURE__ */ new Set()) {
        return nonAliasCanBeReferencedAtTypeLocation(symbol) || nonAliasCanBeReferencedAtTypeLocation(skipAlias(symbol.exportSymbol || symbol, checker));
        function nonAliasCanBeReferencedAtTypeLocation(symbol2) {
            return !!(symbol2.flags & 788968 /* Type */ ) || checker.isUnknownSymbol(symbol2) || !!(symbol2.flags & 1536 /* Module */ ) && addToSeen(seenModules, symbol2) && checker.getExportsOfModule(symbol2).some((e)=>symbolCanBeReferencedAtTypeLocation(e, checker, seenModules));
        }
    }
    function isDeprecated(symbol, checker) {
        const declarations = skipAlias(symbol, checker).declarations;
        return !!length(declarations) && every(declarations, isDeprecatedDeclaration);
    }
    function charactersFuzzyMatchInString(identifierString, lowercaseCharacters) {
        if (lowercaseCharacters.length === 0) return true;
        let matchedFirstCharacter = false;
        let prevChar;
        let characterIndex = 0;
        const len = identifierString.length;
        for(let strIndex = 0; strIndex < len; strIndex++){
            const strChar = identifierString.charCodeAt(strIndex);
            const testChar = lowercaseCharacters.charCodeAt(characterIndex);
            if (strChar === testChar || strChar === toUpperCharCode(testChar)) {
                matchedFirstCharacter || (matchedFirstCharacter = prevChar === void 0 || // Beginning of word
                97 /* a */  <= prevChar && prevChar <= 122 /* z */  && 65 /* A */  <= strChar && strChar <= 90 /* Z */  || // camelCase transition
                prevChar === 95 /* _ */  && strChar !== 95 /* _ */ );
                if (matchedFirstCharacter) characterIndex++;
                if (characterIndex === lowercaseCharacters.length) return true;
            }
            prevChar = strChar;
        }
        return false;
    }
    function toUpperCharCode(charCode) {
        if (97 /* a */  <= charCode && charCode <= 122 /* z */ ) return charCode - 32;
        return charCode;
    }
    function isContextualKeywordInAutoImportableExpressionSpace(keyword) {
        return keyword === "abstract" || keyword === "async" || keyword === "await" || keyword === "declare" || keyword === "module" || keyword === "namespace" || keyword === "type" || keyword === "satisfies" || keyword === "as";
    }
    // src/services/_namespaces/ts.Completions.StringCompletions.ts
    var ts_Completions_StringCompletions_exports = {};
    __export(ts_Completions_StringCompletions_exports, {
        getStringLiteralCompletionDetails: ()=>getStringLiteralCompletionDetails,
        getStringLiteralCompletions: ()=>getStringLiteralCompletions
    });
    // src/services/stringCompletions.ts
    var kindPrecedence = {
        ["directory" /* directory */ ]: 0,
        ["script" /* scriptElement */ ]: 1,
        ["external module name" /* externalModuleName */ ]: 2
    };
    function createNameAndKindSet() {
        const map2 = /* @__PURE__ */ new Map();
        function add(value1) {
            const existing = map2.get(value1.name);
            if (!existing || kindPrecedence[existing.kind] < kindPrecedence[value1.kind]) map2.set(value1.name, value1);
        }
        return {
            add,
            has: map2.has.bind(map2),
            values: map2.values.bind(map2)
        };
    }
    function getStringLiteralCompletions(sourceFile, position, contextToken, options, host, program, log, preferences, includeSymbol) {
        if (isInReferenceComment(sourceFile, position)) {
            const entries = getTripleSlashReferenceCompletion(sourceFile, position, program, host, createModuleSpecifierResolutionHost(program, host));
            return entries && convertPathCompletions(entries);
        }
        if (isInString(sourceFile, position, contextToken)) {
            if (!contextToken || !isStringLiteralLike(contextToken)) return void 0;
            const entries = getStringLiteralCompletionEntries(sourceFile, contextToken, position, program, host, preferences);
            return convertStringLiteralCompletions(entries, contextToken, sourceFile, host, program, log, options, preferences, position, includeSymbol);
        }
    }
    function convertStringLiteralCompletions(completion, contextToken, sourceFile, host, program, log, options, preferences, position, includeSymbol) {
        if (completion === void 0) return void 0;
        const optionalReplacementSpan = createTextSpanFromStringLiteralLikeContent(contextToken, position);
        switch(completion.kind){
            case 0 /* Paths */ :
                return convertPathCompletions(completion.paths);
            case 1 /* Properties */ :
                {
                    const entries = createSortedArray();
                    getCompletionEntriesFromSymbols(completion.symbols, entries, contextToken, contextToken, sourceFile, position, sourceFile, host, program, 99 /* ESNext */ , log, 4 /* String */ , preferences, options, /*formatContext*/ void 0, /*isTypeOnlyLocation*/ void 0, /*propertyAccessToConvert*/ void 0, /*jsxIdentifierExpected*/ void 0, /*isJsxInitializer*/ void 0, /*importStatementCompletion*/ void 0, /*recommendedCompletion*/ void 0, /*symbolToOriginInfoMap*/ void 0, /*symbolToSortTextMap*/ void 0, /*isJsxIdentifierExpected*/ void 0, /*isRightOfOpenTag*/ void 0, includeSymbol);
                    return {
                        isGlobalCompletion: false,
                        isMemberCompletion: true,
                        isNewIdentifierLocation: completion.hasIndexSignature,
                        optionalReplacementSpan,
                        entries,
                        defaultCommitCharacters: getDefaultCommitCharacters(completion.hasIndexSignature)
                    };
                }
            case 2 /* Types */ :
                {
                    const quoteChar = contextToken.kind === 15 /* NoSubstitutionTemplateLiteral */  ? 96 /* backtick */  : startsWith(getTextOfNode(contextToken), "'") ? 39 /* singleQuote */  : 34 /* doubleQuote */ ;
                    const entries = completion.types.map((type)=>({
                            name: escapeString(type.value, quoteChar),
                            kindModifiers: "" /* none */ ,
                            kind: "string" /* string */ ,
                            sortText: SortText.LocationPriority,
                            replacementSpan: getReplacementSpanForContextToken(contextToken, position),
                            commitCharacters: []
                        }));
                    return {
                        isGlobalCompletion: false,
                        isMemberCompletion: false,
                        isNewIdentifierLocation: completion.isNewIdentifier,
                        optionalReplacementSpan,
                        entries,
                        defaultCommitCharacters: getDefaultCommitCharacters(completion.isNewIdentifier)
                    };
                }
            default:
                return Debug.assertNever(completion);
        }
    }
    function getStringLiteralCompletionDetails(name, sourceFile, position, contextToken, program, host, cancellationToken, preferences) {
        if (!contextToken || !isStringLiteralLike(contextToken)) return void 0;
        const completions = getStringLiteralCompletionEntries(sourceFile, contextToken, position, program, host, preferences);
        return completions && stringLiteralCompletionDetails(name, contextToken, completions, sourceFile, program.getTypeChecker(), cancellationToken);
    }
    function stringLiteralCompletionDetails(name, location, completion, sourceFile, checker, cancellationToken) {
        switch(completion.kind){
            case 0 /* Paths */ :
                {
                    const match = find(completion.paths, (p)=>p.name === name);
                    return match && createCompletionDetails(name, kindModifiersFromExtension(match.extension), match.kind, [
                        textPart(name)
                    ]);
                }
            case 1 /* Properties */ :
                {
                    const match = find(completion.symbols, (s)=>s.name === name);
                    return match && createCompletionDetailsForSymbol(match, match.name, checker, sourceFile, location, cancellationToken);
                }
            case 2 /* Types */ :
                return find(completion.types, (t)=>t.value === name) ? createCompletionDetails(name, "" /* none */ , "string" /* string */ , [
                    textPart(name)
                ]) : void 0;
            default:
                return Debug.assertNever(completion);
        }
    }
    function convertPathCompletions(pathCompletions) {
        const isGlobalCompletion = false;
        const isNewIdentifierLocation = true;
        const entries = pathCompletions.map(({ name, kind, span, extension })=>({
                name,
                kind,
                kindModifiers: kindModifiersFromExtension(extension),
                sortText: SortText.LocationPriority,
                replacementSpan: span
            }));
        return {
            isGlobalCompletion,
            isMemberCompletion: false,
            isNewIdentifierLocation,
            entries,
            defaultCommitCharacters: getDefaultCommitCharacters(isNewIdentifierLocation)
        };
    }
    function kindModifiersFromExtension(extension) {
        switch(extension){
            case ".d.ts" /* Dts */ :
                return ".d.ts" /* dtsModifier */ ;
            case ".js" /* Js */ :
                return ".js" /* jsModifier */ ;
            case ".json" /* Json */ :
                return ".json" /* jsonModifier */ ;
            case ".jsx" /* Jsx */ :
                return ".jsx" /* jsxModifier */ ;
            case ".ts" /* Ts */ :
                return ".ts" /* tsModifier */ ;
            case ".tsx" /* Tsx */ :
                return ".tsx" /* tsxModifier */ ;
            case ".d.mts" /* Dmts */ :
                return ".d.mts" /* dmtsModifier */ ;
            case ".mjs" /* Mjs */ :
                return ".mjs" /* mjsModifier */ ;
            case ".mts" /* Mts */ :
                return ".mts" /* mtsModifier */ ;
            case ".d.cts" /* Dcts */ :
                return ".d.cts" /* dctsModifier */ ;
            case ".cjs" /* Cjs */ :
                return ".cjs" /* cjsModifier */ ;
            case ".cts" /* Cts */ :
                return ".cts" /* ctsModifier */ ;
            case ".tsbuildinfo" /* TsBuildInfo */ :
                return Debug.fail(`Extension ${".tsbuildinfo" /* TsBuildInfo */ } is unsupported.`);
            case void 0:
                return "" /* none */ ;
            default:
                return Debug.assertNever(extension);
        }
    }
    function getStringLiteralCompletionEntries(sourceFile, node, position, program, host, preferences) {
        const typeChecker = program.getTypeChecker();
        const parent2 = walkUpParentheses(node.parent);
        switch(parent2.kind){
            case 202 /* LiteralType */ :
                {
                    const grandParent = walkUpParentheses(parent2.parent);
                    if (grandParent.kind === 206 /* ImportType */ ) return {
                        kind: 0 /* Paths */ ,
                        paths: getStringLiteralCompletionsFromModuleNames(sourceFile, node, program, host, preferences)
                    };
                    return fromUnionableLiteralType(grandParent);
                }
            case 304 /* PropertyAssignment */ :
                if (isObjectLiteralExpression(parent2.parent) && parent2.name === node) return stringLiteralCompletionsForObjectLiteral(typeChecker, parent2.parent);
                return fromContextualType() || fromContextualType(0 /* None */ );
            case 213 /* ElementAccessExpression */ :
                {
                    const { expression, argumentExpression } = parent2;
                    if (node === skipParentheses(argumentExpression)) return stringLiteralCompletionsFromProperties(typeChecker.getTypeAtLocation(expression));
                    return void 0;
                }
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
            case 292 /* JsxAttribute */ :
                if (!isRequireCallArgument(node) && !isImportCall(parent2)) {
                    const argumentInfo = ts_SignatureHelp_exports.getArgumentInfoForCompletions(parent2.kind === 292 /* JsxAttribute */  ? parent2.parent : node, position, sourceFile, typeChecker);
                    return argumentInfo && getStringLiteralCompletionsFromSignature(argumentInfo.invocation, node, argumentInfo, typeChecker) || fromContextualType(0 /* None */ );
                }
            // falls through (is `require("")` or `require(""` or `import("")`)
            case 273 /* ImportDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 284 /* ExternalModuleReference */ :
            case 352 /* JSDocImportTag */ :
                return {
                    kind: 0 /* Paths */ ,
                    paths: getStringLiteralCompletionsFromModuleNames(sourceFile, node, program, host, preferences)
                };
            case 297 /* CaseClause */ :
                const tracker = newCaseClauseTracker(typeChecker, parent2.parent.clauses);
                const contextualTypes = fromContextualType();
                if (!contextualTypes) return;
                const literals = contextualTypes.types.filter((literal)=>!tracker.hasValue(literal.value));
                return {
                    kind: 2 /* Types */ ,
                    types: literals,
                    isNewIdentifier: false
                };
            case 277 /* ImportSpecifier */ :
            case 282 /* ExportSpecifier */ :
                const specifier = parent2;
                if (specifier.propertyName && node !== specifier.propertyName) return;
                const namedImportsOrExports = specifier.parent;
                const { moduleSpecifier } = namedImportsOrExports.kind === 276 /* NamedImports */  ? namedImportsOrExports.parent.parent : namedImportsOrExports.parent;
                if (!moduleSpecifier) return;
                const moduleSpecifierSymbol = typeChecker.getSymbolAtLocation(moduleSpecifier);
                if (!moduleSpecifierSymbol) return;
                const exports2 = typeChecker.getExportsAndPropertiesOfModule(moduleSpecifierSymbol);
                const existing = new Set(namedImportsOrExports.elements.map((n)=>moduleExportNameTextEscaped(n.propertyName || n.name)));
                const uniques = exports2.filter((e)=>e.escapedName !== "default" /* Default */  && !existing.has(e.escapedName));
                return {
                    kind: 1 /* Properties */ ,
                    symbols: uniques,
                    hasIndexSignature: false
                };
            case 227 /* BinaryExpression */ :
                if (parent2.operatorToken.kind === 103 /* InKeyword */ ) {
                    const type = typeChecker.getTypeAtLocation(parent2.right);
                    const properties = type.isUnion() ? typeChecker.getAllPossiblePropertiesOfTypes(type.types) : type.getApparentProperties();
                    return {
                        kind: 1 /* Properties */ ,
                        symbols: properties.filter((prop)=>!prop.valueDeclaration || !isPrivateIdentifierClassElementDeclaration(prop.valueDeclaration)),
                        hasIndexSignature: false
                    };
                }
                return fromContextualType(0 /* None */ );
            default:
                return fromContextualType() || fromContextualType(0 /* None */ );
        }
        function fromUnionableLiteralType(grandParent) {
            switch(grandParent.kind){
                case 234 /* ExpressionWithTypeArguments */ :
                case 184 /* TypeReference */ :
                    {
                        const typeArgument = findAncestor(parent2, (n)=>n.parent === grandParent);
                        if (typeArgument) return {
                            kind: 2 /* Types */ ,
                            types: getStringLiteralTypes(typeChecker.getTypeArgumentConstraint(typeArgument)),
                            isNewIdentifier: false
                        };
                        return void 0;
                    }
                case 200 /* IndexedAccessType */ :
                    const { indexType, objectType } = grandParent;
                    if (!rangeContainsPosition(indexType, position)) return void 0;
                    return stringLiteralCompletionsFromProperties(typeChecker.getTypeFromTypeNode(objectType));
                case 193 /* UnionType */ :
                    {
                        const result = fromUnionableLiteralType(walkUpParentheses(grandParent.parent));
                        if (!result) return void 0;
                        const alreadyUsedTypes = getAlreadyUsedTypesInStringLiteralUnion(grandParent, parent2);
                        if (result.kind === 1 /* Properties */ ) return {
                            kind: 1 /* Properties */ ,
                            symbols: result.symbols.filter((sym)=>!contains(alreadyUsedTypes, sym.name)),
                            hasIndexSignature: result.hasIndexSignature
                        };
                        return {
                            kind: 2 /* Types */ ,
                            types: result.types.filter((t)=>!contains(alreadyUsedTypes, t.value)),
                            isNewIdentifier: false
                        };
                    }
                default:
                    return void 0;
            }
        }
        function fromContextualType(contextFlags = 4 /* Completions */ ) {
            const types = getStringLiteralTypes(getContextualTypeFromParent(node, typeChecker, contextFlags));
            if (!types.length) return;
            return {
                kind: 2 /* Types */ ,
                types,
                isNewIdentifier: false
            };
        }
    }
    function walkUpParentheses(node) {
        switch(node.kind){
            case 197 /* ParenthesizedType */ :
                return walkUpParenthesizedTypes(node);
            case 218 /* ParenthesizedExpression */ :
                return walkUpParenthesizedExpressions(node);
            default:
                return node;
        }
    }
    function getAlreadyUsedTypesInStringLiteralUnion(union, current) {
        return mapDefined(union.types, (type)=>type !== current && isLiteralTypeNode(type) && isStringLiteral(type.literal) ? type.literal.text : void 0);
    }
    function getStringLiteralCompletionsFromSignature(call, arg, argumentInfo, checker) {
        let isNewIdentifier = false;
        const uniques = /* @__PURE__ */ new Set();
        const editingArgument = isJsxOpeningLikeElement(call) ? Debug.checkDefined(findAncestor(arg.parent, isJsxAttribute)) : arg;
        const candidates = checker.getCandidateSignaturesForStringLiteralCompletions(call, editingArgument);
        const types = flatMap(candidates, (candidate)=>{
            if (!signatureHasRestParameter(candidate) && argumentInfo.argumentCount > candidate.parameters.length) return;
            let type = candidate.getTypeParameterAtPosition(argumentInfo.argumentIndex);
            if (isJsxOpeningLikeElement(call)) {
                const propType = checker.getTypeOfPropertyOfType(type, getTextOfJsxAttributeName(editingArgument.name));
                if (propType) type = propType;
            }
            isNewIdentifier = isNewIdentifier || !!(type.flags & 4 /* String */ );
            return getStringLiteralTypes(type, uniques);
        });
        return length(types) ? {
            kind: 2 /* Types */ ,
            types,
            isNewIdentifier
        } : void 0;
    }
    function stringLiteralCompletionsFromProperties(type) {
        return type && {
            kind: 1 /* Properties */ ,
            symbols: filter(type.getApparentProperties(), (prop)=>!(prop.valueDeclaration && isPrivateIdentifierClassElementDeclaration(prop.valueDeclaration))),
            hasIndexSignature: hasIndexSignature(type)
        };
    }
    function stringLiteralCompletionsForObjectLiteral(checker, objectLiteralExpression) {
        const contextualType = checker.getContextualType(objectLiteralExpression);
        if (!contextualType) return void 0;
        const completionsType = checker.getContextualType(objectLiteralExpression, 4 /* Completions */ );
        const symbols = getPropertiesForObjectExpression(contextualType, completionsType, objectLiteralExpression, checker);
        return {
            kind: 1 /* Properties */ ,
            symbols,
            hasIndexSignature: hasIndexSignature(contextualType)
        };
    }
    function getStringLiteralTypes(type, uniques = /* @__PURE__ */ new Set()) {
        if (!type) return emptyArray;
        type = skipConstraint(type);
        return type.isUnion() ? flatMap(type.types, (t)=>getStringLiteralTypes(t, uniques)) : type.isStringLiteral() && !(type.flags & 1024 /* EnumLiteral */ ) && addToSeen(uniques, type.value) ? [
            type
        ] : emptyArray;
    }
    function nameAndKind(name, kind, extension) {
        return {
            name,
            kind,
            extension
        };
    }
    function directoryResult(name) {
        return nameAndKind(name, "directory" /* directory */ , /*extension*/ void 0);
    }
    function addReplacementSpans(text, textStart, names) {
        const span = getDirectoryFragmentTextSpan(text, textStart);
        const wholeSpan = text.length === 0 ? void 0 : createTextSpan(textStart, text.length);
        return names.map(({ name, kind, extension })=>name.includes(directorySeparator) || name.includes(altDirectorySeparator) ? {
                name,
                kind,
                extension,
                span: wholeSpan
            } : {
                name,
                kind,
                extension,
                span
            });
    }
    function getStringLiteralCompletionsFromModuleNames(sourceFile, node, program, host, preferences) {
        return addReplacementSpans(node.text, node.getStart(sourceFile) + 1, getStringLiteralCompletionsFromModuleNamesWorker(sourceFile, node, program, host, preferences));
    }
    function getStringLiteralCompletionsFromModuleNamesWorker(sourceFile, node, program, host, preferences) {
        const literalValue = normalizeSlashes(node.text);
        const mode = isStringLiteralLike(node) ? program.getModeForUsageLocation(sourceFile, node) : void 0;
        const scriptPath = sourceFile.path;
        const scriptDirectory = getDirectoryPath(scriptPath);
        const compilerOptions = program.getCompilerOptions();
        const typeChecker = program.getTypeChecker();
        const moduleSpecifierResolutionHost = createModuleSpecifierResolutionHost(program, host);
        const extensionOptions = getExtensionOptions(compilerOptions, 1 /* ModuleSpecifier */ , sourceFile, typeChecker, preferences, mode);
        return isPathRelativeToScript(literalValue) || !compilerOptions.baseUrl && !compilerOptions.paths && (isRootedDiskPath(literalValue) || isUrl(literalValue)) ? getCompletionEntriesForRelativeModules(literalValue, scriptDirectory, program, host, moduleSpecifierResolutionHost, scriptPath, extensionOptions) : getCompletionEntriesForNonRelativeModules(literalValue, scriptDirectory, mode, program, host, moduleSpecifierResolutionHost, extensionOptions);
    }
    function getExtensionOptions(compilerOptions, referenceKind, importingSourceFile, typeChecker, preferences, resolutionMode) {
        return {
            extensionsToSearch: flatten(getSupportedExtensionsForModuleResolution(compilerOptions, typeChecker)),
            referenceKind,
            importingSourceFile,
            endingPreference: preferences == null ? void 0 : preferences.importModuleSpecifierEnding,
            resolutionMode
        };
    }
    function getCompletionEntriesForRelativeModules(literalValue, scriptDirectory, program, host, moduleSpecifierResolutionHost, scriptPath, extensionOptions) {
        const compilerOptions = program.getCompilerOptions();
        if (compilerOptions.rootDirs) return getCompletionEntriesForDirectoryFragmentWithRootDirs(compilerOptions.rootDirs, literalValue, scriptDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, scriptPath);
        else return arrayFrom(getCompletionEntriesForDirectoryFragment(literalValue, scriptDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, /*moduleSpecifierIsRelative*/ true, scriptPath).values());
    }
    function getSupportedExtensionsForModuleResolution(compilerOptions, typeChecker) {
        const ambientModulesExtensions = !typeChecker ? [] : mapDefined(typeChecker.getAmbientModules(), (module2)=>{
            const name = module2.name.slice(1, -1);
            if (!name.startsWith("*.") || name.includes("/")) return;
            return name.slice(1);
        });
        const extensions = [
            ...getSupportedExtensions(compilerOptions),
            ambientModulesExtensions
        ];
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        return moduleResolutionUsesNodeModules(moduleResolution) ? getSupportedExtensionsWithJsonIfResolveJsonModule(compilerOptions, extensions) : extensions;
    }
    function getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptDirectory, ignoreCase) {
        rootDirs = rootDirs.map((rootDirectory)=>ensureTrailingDirectorySeparator(normalizePath(isRootedDiskPath(rootDirectory) ? rootDirectory : combinePaths(basePath, rootDirectory))));
        const relativeDirectory = firstDefined(rootDirs, (rootDirectory)=>containsPath(rootDirectory, scriptDirectory, basePath, ignoreCase) ? scriptDirectory.substr(rootDirectory.length) : void 0);
        return deduplicate([
            ...rootDirs.map((rootDirectory)=>combinePaths(rootDirectory, relativeDirectory)),
            scriptDirectory
        ].map((baseDir)=>removeTrailingDirectorySeparator(baseDir)), equateStringsCaseSensitive, compareStringsCaseSensitive);
    }
    function getCompletionEntriesForDirectoryFragmentWithRootDirs(rootDirs, fragment, scriptDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, exclude) {
        const compilerOptions = program.getCompilerOptions();
        const basePath = compilerOptions.project || host.getCurrentDirectory();
        const ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
        const baseDirectories = getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptDirectory, ignoreCase);
        return deduplicate(flatMap(baseDirectories, (baseDirectory)=>arrayFrom(getCompletionEntriesForDirectoryFragment(fragment, baseDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, /*moduleSpecifierIsRelative*/ true, exclude).values())), (itemA, itemB)=>itemA.name === itemB.name && itemA.kind === itemB.kind && itemA.extension === itemB.extension);
    }
    function getCompletionEntriesForDirectoryFragment(fragment, scriptDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, moduleSpecifierIsRelative, exclude, result = createNameAndKindSet()) {
        var _a;
        if (fragment === void 0) fragment = "";
        fragment = normalizeSlashes(fragment);
        if (!hasTrailingDirectorySeparator(fragment)) fragment = getDirectoryPath(fragment);
        if (fragment === "") fragment = "." + directorySeparator;
        fragment = ensureTrailingDirectorySeparator(fragment);
        const absolutePath = resolvePath(scriptDirectory, fragment);
        const baseDirectory = hasTrailingDirectorySeparator(absolutePath) ? absolutePath : getDirectoryPath(absolutePath);
        if (!moduleSpecifierIsRelative) {
            const packageJsonPath = findPackageJson(baseDirectory, host);
            if (packageJsonPath) {
                const packageJson = readJson(packageJsonPath, host);
                const typesVersions = packageJson.typesVersions;
                if (typeof typesVersions === "object") {
                    const versionPaths = (_a = getPackageJsonTypesVersionsPaths(typesVersions)) == null ? void 0 : _a.paths;
                    if (versionPaths) {
                        const packageDirectory = getDirectoryPath(packageJsonPath);
                        const pathInPackage = absolutePath.slice(ensureTrailingDirectorySeparator(packageDirectory).length);
                        if (addCompletionEntriesFromPaths(result, pathInPackage, packageDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, versionPaths)) return result;
                    }
                }
            }
        }
        const ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
        if (!tryDirectoryExists(host, baseDirectory)) return result;
        const files = tryReadDirectory(host, baseDirectory, extensionOptions.extensionsToSearch, /*exclude*/ void 0, /*include*/ [
            "./*"
        ]);
        if (files) for (let filePath of files){
            filePath = normalizePath(filePath);
            if (exclude && comparePaths(filePath, exclude, scriptDirectory, ignoreCase) === 0 /* EqualTo */ ) continue;
            const { name, extension } = getFilenameWithExtensionOption(getBaseFileName(filePath), program, extensionOptions, /*isExportsOrImportsWildcard*/ false);
            result.add(nameAndKind(name, "script" /* scriptElement */ , extension));
        }
        const directories = tryGetDirectories(host, baseDirectory);
        if (directories) for (const directory of directories){
            const directoryName = getBaseFileName(normalizePath(directory));
            if (directoryName !== "@types") result.add(directoryResult(directoryName));
        }
        return result;
    }
    function getFilenameWithExtensionOption(name, program, extensionOptions, isExportsOrImportsWildcard) {
        const nonJsResult = ts_moduleSpecifiers_exports.tryGetRealFileNameForNonJsDeclarationFileName(name);
        if (nonJsResult) return {
            name: nonJsResult,
            extension: tryGetExtensionFromPath2(nonJsResult)
        };
        if (extensionOptions.referenceKind === 0 /* Filename */ ) return {
            name,
            extension: tryGetExtensionFromPath2(name)
        };
        let allowedEndings = ts_moduleSpecifiers_exports.getModuleSpecifierPreferences({
            importModuleSpecifierEnding: extensionOptions.endingPreference
        }, program, program.getCompilerOptions(), extensionOptions.importingSourceFile).getAllowedEndingsInPreferredOrder(extensionOptions.resolutionMode);
        if (isExportsOrImportsWildcard) allowedEndings = allowedEndings.filter((e)=>e !== 0 /* Minimal */  && e !== 1 /* Index */ );
        if (allowedEndings[0] === 3 /* TsExtension */ ) {
            if (fileExtensionIsOneOf(name, supportedTSImplementationExtensions)) return {
                name,
                extension: tryGetExtensionFromPath2(name)
            };
            const outputExtension2 = ts_moduleSpecifiers_exports.tryGetJSExtensionForFile(name, program.getCompilerOptions());
            return outputExtension2 ? {
                name: changeExtension(name, outputExtension2),
                extension: outputExtension2
            } : {
                name,
                extension: tryGetExtensionFromPath2(name)
            };
        }
        if (!isExportsOrImportsWildcard && (allowedEndings[0] === 0 /* Minimal */  || allowedEndings[0] === 1 /* Index */ ) && fileExtensionIsOneOf(name, [
            ".js" /* Js */ ,
            ".jsx" /* Jsx */ ,
            ".ts" /* Ts */ ,
            ".tsx" /* Tsx */ ,
            ".d.ts" /* Dts */ 
        ])) return {
            name: removeFileExtension(name),
            extension: tryGetExtensionFromPath2(name)
        };
        const outputExtension = ts_moduleSpecifiers_exports.tryGetJSExtensionForFile(name, program.getCompilerOptions());
        return outputExtension ? {
            name: changeExtension(name, outputExtension),
            extension: outputExtension
        } : {
            name,
            extension: tryGetExtensionFromPath2(name)
        };
    }
    function addCompletionEntriesFromPaths(result, fragment, baseDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, paths) {
        const getPatternsForKey = (key)=>paths[key];
        const comparePaths2 = (a, b)=>{
            const patternA = tryParsePattern(a);
            const patternB = tryParsePattern(b);
            const lengthA = typeof patternA === "object" ? patternA.prefix.length : a.length;
            const lengthB = typeof patternB === "object" ? patternB.prefix.length : b.length;
            return compareValues(lengthB, lengthA);
        };
        return addCompletionEntriesFromPathsOrExportsOrImports(result, /*isExports*/ false, /*isImports*/ false, fragment, baseDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, getOwnKeys(paths), getPatternsForKey, comparePaths2);
    }
    function addCompletionEntriesFromPathsOrExportsOrImports(result, isExports, isImports, fragment, baseDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, keys, getPatternsForKey, comparePaths2) {
        let pathResults = [];
        let matchedPath;
        for (const key of keys){
            if (key === ".") continue;
            const keyWithoutLeadingDotSlash = key.replace(/^\.\//, "") + ((isExports || isImports) && endsWith(key, "/") ? "*" : "");
            const patterns = getPatternsForKey(key);
            if (patterns) {
                const pathPattern = tryParsePattern(keyWithoutLeadingDotSlash);
                if (!pathPattern) continue;
                const isMatch = typeof pathPattern === "object" && isPatternMatch(pathPattern, fragment);
                const isLongestMatch = isMatch && (matchedPath === void 0 || comparePaths2(keyWithoutLeadingDotSlash, matchedPath) === -1 /* LessThan */ );
                if (isLongestMatch) {
                    matchedPath = keyWithoutLeadingDotSlash;
                    pathResults = pathResults.filter((r)=>!r.matchedPattern);
                }
                if (typeof pathPattern === "string" || matchedPath === void 0 || comparePaths2(keyWithoutLeadingDotSlash, matchedPath) !== 1 /* GreaterThan */ ) pathResults.push({
                    matchedPattern: isMatch,
                    results: getCompletionsForPathMapping(keyWithoutLeadingDotSlash, patterns, fragment, baseDirectory, extensionOptions, isExports, isImports, program, host, moduleSpecifierResolutionHost).map(({ name, kind, extension })=>nameAndKind(name, kind, extension))
                });
            }
        }
        pathResults.forEach((pathResult)=>pathResult.results.forEach((r)=>result.add(r)));
        return matchedPath !== void 0;
    }
    function getCompletionEntriesForNonRelativeModules(fragment, scriptPath, mode, program, host, moduleSpecifierResolutionHost, extensionOptions) {
        const typeChecker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        const { baseUrl, paths } = compilerOptions;
        const result = createNameAndKindSet();
        const moduleResolution = getEmitModuleResolutionKind(compilerOptions);
        if (baseUrl) {
            const absolute = normalizePath(combinePaths(host.getCurrentDirectory(), baseUrl));
            getCompletionEntriesForDirectoryFragment(fragment, absolute, extensionOptions, program, host, moduleSpecifierResolutionHost, /*moduleSpecifierIsRelative*/ false, /*exclude*/ void 0, result);
        }
        if (paths) {
            const absolute = getPathsBasePath(compilerOptions, host);
            addCompletionEntriesFromPaths(result, fragment, absolute, extensionOptions, program, host, moduleSpecifierResolutionHost, paths);
        }
        const fragmentDirectory = getFragmentDirectory(fragment);
        for (const ambientName of getAmbientModuleCompletions(fragment, fragmentDirectory, typeChecker))result.add(nameAndKind(ambientName, "external module name" /* externalModuleName */ , /*extension*/ void 0));
        getCompletionEntriesFromTypings(program, host, moduleSpecifierResolutionHost, scriptPath, fragmentDirectory, extensionOptions, result);
        if (moduleResolutionUsesNodeModules(moduleResolution)) {
            let foundGlobal = false;
            if (fragmentDirectory === void 0) for (const moduleName of enumerateNodeModulesVisibleToScript(host, scriptPath)){
                const moduleResult = nameAndKind(moduleName, "external module name" /* externalModuleName */ , /*extension*/ void 0);
                if (!result.has(moduleResult.name)) {
                    foundGlobal = true;
                    result.add(moduleResult);
                }
            }
            if (!foundGlobal) {
                const resolvePackageJsonExports = getResolvePackageJsonExports(compilerOptions);
                const resolvePackageJsonImports = getResolvePackageJsonImports(compilerOptions);
                let seenPackageScope = false;
                const importsLookup = (directory)=>{
                    if (resolvePackageJsonImports && !seenPackageScope) {
                        const packageFile = combinePaths(directory, "package.json");
                        if (seenPackageScope = tryFileExists(host, packageFile)) {
                            const packageJson = readJson(packageFile, host);
                            exportsOrImportsLookup(packageJson.imports, fragment, directory, /*isExports*/ false, /*isImports*/ true);
                        }
                    }
                };
                let ancestorLookup = (ancestor)=>{
                    const nodeModules = combinePaths(ancestor, "node_modules");
                    if (tryDirectoryExists(host, nodeModules)) getCompletionEntriesForDirectoryFragment(fragment, nodeModules, extensionOptions, program, host, moduleSpecifierResolutionHost, /*moduleSpecifierIsRelative*/ false, /*exclude*/ void 0, result);
                    importsLookup(ancestor);
                };
                if (fragmentDirectory && resolvePackageJsonExports) {
                    const nodeModulesDirectoryOrImportsLookup = ancestorLookup;
                    ancestorLookup = (ancestor)=>{
                        const components = getPathComponents(fragment);
                        components.shift();
                        let packagePath = components.shift();
                        if (!packagePath) return nodeModulesDirectoryOrImportsLookup(ancestor);
                        if (startsWith(packagePath, "@")) {
                            const subName = components.shift();
                            if (!subName) return nodeModulesDirectoryOrImportsLookup(ancestor);
                            packagePath = combinePaths(packagePath, subName);
                        }
                        if (resolvePackageJsonImports && startsWith(packagePath, "#")) return importsLookup(ancestor);
                        const packageDirectory = combinePaths(ancestor, "node_modules", packagePath);
                        const packageFile = combinePaths(packageDirectory, "package.json");
                        if (tryFileExists(host, packageFile)) {
                            const packageJson = readJson(packageFile, host);
                            const fragmentSubpath = components.join("/") + (components.length && hasTrailingDirectorySeparator(fragment) ? "/" : "");
                            exportsOrImportsLookup(packageJson.exports, fragmentSubpath, packageDirectory, /*isExports*/ true, /*isImports*/ false);
                            return;
                        }
                        return nodeModulesDirectoryOrImportsLookup(ancestor);
                    };
                }
                forEachAncestorDirectoryStoppingAtGlobalCache(host, scriptPath, ancestorLookup);
            }
        }
        return arrayFrom(result.values());
        function exportsOrImportsLookup(lookupTable, fragment2, baseDirectory, isExports, isImports) {
            if (typeof lookupTable !== "object" || lookupTable === null) return;
            const keys = getOwnKeys(lookupTable);
            const conditions = getConditions(compilerOptions, mode);
            addCompletionEntriesFromPathsOrExportsOrImports(result, isExports, isImports, fragment2, baseDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, keys, (key)=>{
                const pattern = getPatternFromFirstMatchingCondition(lookupTable[key], conditions);
                if (pattern === void 0) return void 0;
                return singleElementArray(endsWith(key, "/") && endsWith(pattern, "/") ? pattern + "*" : pattern);
            }, comparePatternKeys);
        }
    }
    function getPatternFromFirstMatchingCondition(target, conditions) {
        if (typeof target === "string") return target;
        if (target && typeof target === "object" && !isArray(target)) {
            for(const condition in target)if (condition === "default" || conditions.includes(condition) || isApplicableVersionedTypesKey(conditions, condition)) {
                const pattern = target[condition];
                return getPatternFromFirstMatchingCondition(pattern, conditions);
            }
        }
    }
    function getFragmentDirectory(fragment) {
        return containsSlash(fragment) ? hasTrailingDirectorySeparator(fragment) ? fragment : getDirectoryPath(fragment) : void 0;
    }
    function getCompletionsForPathMapping(path, patterns, fragment, packageDirectory, extensionOptions, isExports, isImports, program, host, moduleSpecifierResolutionHost) {
        const parsedPath = tryParsePattern(path);
        if (!parsedPath) return emptyArray;
        if (typeof parsedPath === "string") return justPathMappingName(path, "script" /* scriptElement */ );
        const remainingFragment = tryRemovePrefix(fragment, parsedPath.prefix);
        if (remainingFragment === void 0) {
            const starIsFullPathComponent = endsWith(path, "/*");
            return starIsFullPathComponent ? justPathMappingName(parsedPath.prefix, "directory" /* directory */ ) : flatMap(patterns, (pattern)=>{
                var _a;
                return (_a = getModulesForPathsPattern("", packageDirectory, pattern, extensionOptions, isExports, isImports, program, host, moduleSpecifierResolutionHost)) == null ? void 0 : _a.map((_param)=>{
                    var { name } = _param, rest = (0, _objectWithoutProperties._)(_param, [
                        "name"
                    ]);
                    return (0, _objectSpread._)({
                        name: parsedPath.prefix + name + parsedPath.suffix
                    }, rest);
                });
            });
        }
        return flatMap(patterns, (pattern)=>getModulesForPathsPattern(remainingFragment, packageDirectory, pattern, extensionOptions, isExports, isImports, program, host, moduleSpecifierResolutionHost));
        function justPathMappingName(name, kind) {
            return startsWith(name, fragment) ? [
                {
                    name: removeTrailingDirectorySeparator(name),
                    kind,
                    extension: void 0
                }
            ] : emptyArray;
        }
    }
    function getModulesForPathsPattern(fragment, packageDirectory, pattern, extensionOptions, isExports, isImports, program, host, moduleSpecifierResolutionHost) {
        if (!host.readDirectory) return void 0;
        const parsed = tryParsePattern(pattern);
        if (parsed === void 0 || isString(parsed)) return void 0;
        const normalizedPrefix = resolvePath(parsed.prefix);
        const normalizedPrefixDirectory = hasTrailingDirectorySeparator(parsed.prefix) ? normalizedPrefix : getDirectoryPath(normalizedPrefix);
        const normalizedPrefixBase = hasTrailingDirectorySeparator(parsed.prefix) ? "" : getBaseFileName(normalizedPrefix);
        const fragmentHasPath = containsSlash(fragment);
        const fragmentDirectory = fragmentHasPath ? hasTrailingDirectorySeparator(fragment) ? fragment : getDirectoryPath(fragment) : void 0;
        const getCommonSourceDirectory2 = ()=>moduleSpecifierResolutionHost.getCommonSourceDirectory();
        const ignoreCase = !hostUsesCaseSensitiveFileNames(moduleSpecifierResolutionHost);
        const outDir = program.getCompilerOptions().outDir;
        const declarationDir = program.getCompilerOptions().declarationDir;
        const expandedPrefixDirectory = fragmentHasPath ? combinePaths(normalizedPrefixDirectory, normalizedPrefixBase + fragmentDirectory) : normalizedPrefixDirectory;
        const baseDirectory = normalizePath(combinePaths(packageDirectory, expandedPrefixDirectory));
        const possibleInputBaseDirectoryForOutDir = isImports && outDir && getPossibleOriginalInputPathWithoutChangingExt(baseDirectory, ignoreCase, outDir, getCommonSourceDirectory2);
        const possibleInputBaseDirectoryForDeclarationDir = isImports && declarationDir && getPossibleOriginalInputPathWithoutChangingExt(baseDirectory, ignoreCase, declarationDir, getCommonSourceDirectory2);
        const normalizedSuffix = normalizePath(parsed.suffix);
        const declarationExtension = normalizedSuffix && getDeclarationEmitExtensionForPath("_" + normalizedSuffix);
        const inputExtension = normalizedSuffix ? getPossibleOriginalInputExtensionForExtension("_" + normalizedSuffix) : void 0;
        const matchingSuffixes = [
            declarationExtension && changeExtension(normalizedSuffix, declarationExtension),
            ...inputExtension ? inputExtension.map((ext)=>changeExtension(normalizedSuffix, ext)) : [],
            normalizedSuffix
        ].filter(isString);
        const includeGlobs = normalizedSuffix ? matchingSuffixes.map((suffix)=>"**/*" + suffix) : [
            "./*"
        ];
        const isExportsOrImportsWildcard = (isExports || isImports) && endsWith(pattern, "/*");
        let matches = getMatchesWithPrefix(baseDirectory);
        if (possibleInputBaseDirectoryForOutDir) matches = concatenate(matches, getMatchesWithPrefix(possibleInputBaseDirectoryForOutDir));
        if (possibleInputBaseDirectoryForDeclarationDir) matches = concatenate(matches, getMatchesWithPrefix(possibleInputBaseDirectoryForDeclarationDir));
        if (!normalizedSuffix) {
            matches = concatenate(matches, getDirectoryMatches(baseDirectory));
            if (possibleInputBaseDirectoryForOutDir) matches = concatenate(matches, getDirectoryMatches(possibleInputBaseDirectoryForOutDir));
            if (possibleInputBaseDirectoryForDeclarationDir) matches = concatenate(matches, getDirectoryMatches(possibleInputBaseDirectoryForDeclarationDir));
        }
        return matches;
        function getMatchesWithPrefix(directory) {
            const completePrefix = fragmentHasPath ? directory : ensureTrailingDirectorySeparator(directory) + normalizedPrefixBase;
            return mapDefined(tryReadDirectory(host, directory, extensionOptions.extensionsToSearch, /*exclude*/ void 0, includeGlobs), (match)=>{
                const trimmedWithPattern = trimPrefixAndSuffix(match, completePrefix);
                if (trimmedWithPattern) {
                    if (containsSlash(trimmedWithPattern)) return directoryResult(getPathComponents(removeLeadingDirectorySeparator(trimmedWithPattern))[1]);
                    const { name, extension } = getFilenameWithExtensionOption(trimmedWithPattern, program, extensionOptions, isExportsOrImportsWildcard);
                    return nameAndKind(name, "script" /* scriptElement */ , extension);
                }
            });
        }
        function getDirectoryMatches(directoryName) {
            return mapDefined(tryGetDirectories(host, directoryName), (dir)=>dir === "node_modules" ? void 0 : directoryResult(dir));
        }
        function trimPrefixAndSuffix(path, prefix) {
            return firstDefined(matchingSuffixes, (suffix)=>{
                const inner = withoutStartAndEnd(normalizePath(path), prefix, suffix);
                return inner === void 0 ? void 0 : removeLeadingDirectorySeparator(inner);
            });
        }
    }
    function withoutStartAndEnd(s, start, end) {
        return startsWith(s, start) && endsWith(s, end) ? s.slice(start.length, s.length - end.length) : void 0;
    }
    function removeLeadingDirectorySeparator(path) {
        return path[0] === directorySeparator ? path.slice(1) : path;
    }
    function getAmbientModuleCompletions(fragment, fragmentDirectory, checker) {
        const ambientModules = checker.getAmbientModules().map((sym)=>stripQuotes(sym.name));
        const nonRelativeModuleNames = ambientModules.filter((moduleName)=>startsWith(moduleName, fragment) && !moduleName.includes("*"));
        if (fragmentDirectory !== void 0) {
            const moduleNameWithSeparator = ensureTrailingDirectorySeparator(fragmentDirectory);
            return nonRelativeModuleNames.map((nonRelativeModuleName)=>removePrefix(nonRelativeModuleName, moduleNameWithSeparator));
        }
        return nonRelativeModuleNames;
    }
    function getTripleSlashReferenceCompletion(sourceFile, position, program, host, moduleSpecifierResolutionHost) {
        const compilerOptions = program.getCompilerOptions();
        const token = getTokenAtPosition(sourceFile, position);
        const commentRanges = getLeadingCommentRanges(sourceFile.text, token.pos);
        const range = commentRanges && find(commentRanges, (commentRange)=>position >= commentRange.pos && position <= commentRange.end);
        if (!range) return void 0;
        const text = sourceFile.text.slice(range.pos, position);
        const match = tripleSlashDirectiveFragmentRegex.exec(text);
        if (!match) return void 0;
        const [, prefix, kind, toComplete] = match;
        const scriptPath = getDirectoryPath(sourceFile.path);
        const names = kind === "path" ? getCompletionEntriesForDirectoryFragment(toComplete, scriptPath, getExtensionOptions(compilerOptions, 0 /* Filename */ , sourceFile), program, host, moduleSpecifierResolutionHost, /*moduleSpecifierIsRelative*/ true, sourceFile.path) : kind === "types" ? getCompletionEntriesFromTypings(program, host, moduleSpecifierResolutionHost, scriptPath, getFragmentDirectory(toComplete), getExtensionOptions(compilerOptions, 1 /* ModuleSpecifier */ , sourceFile)) : Debug.fail();
        return addReplacementSpans(toComplete, range.pos + prefix.length, arrayFrom(names.values()));
    }
    function getCompletionEntriesFromTypings(program, host, moduleSpecifierResolutionHost, scriptPath, fragmentDirectory, extensionOptions, result = createNameAndKindSet()) {
        const options = program.getCompilerOptions();
        const seen = /* @__PURE__ */ new Map();
        const typeRoots = tryAndIgnoreErrors(()=>getEffectiveTypeRoots(options, host)) || emptyArray;
        for (const root of typeRoots)getCompletionEntriesFromDirectories(root);
        for (const packageJson of findPackageJsons(scriptPath, host)){
            const typesDir = combinePaths(getDirectoryPath(packageJson), "node_modules/@types");
            getCompletionEntriesFromDirectories(typesDir);
        }
        return result;
        function getCompletionEntriesFromDirectories(directory) {
            if (!tryDirectoryExists(host, directory)) return;
            for (const typeDirectoryName of tryGetDirectories(host, directory)){
                const packageName = unmangleScopedPackageName(typeDirectoryName);
                if (options.types && !contains(options.types, packageName)) continue;
                if (fragmentDirectory === void 0) {
                    if (!seen.has(packageName)) {
                        result.add(nameAndKind(packageName, "external module name" /* externalModuleName */ , /*extension*/ void 0));
                        seen.set(packageName, true);
                    }
                } else {
                    const baseDirectory = combinePaths(directory, typeDirectoryName);
                    const remainingFragment = tryRemoveDirectoryPrefix(fragmentDirectory, packageName, hostGetCanonicalFileName(host));
                    if (remainingFragment !== void 0) getCompletionEntriesForDirectoryFragment(remainingFragment, baseDirectory, extensionOptions, program, host, moduleSpecifierResolutionHost, /*moduleSpecifierIsRelative*/ false, /*exclude*/ void 0, result);
                }
            }
        }
    }
    function enumerateNodeModulesVisibleToScript(host, scriptPath) {
        if (!host.readFile || !host.fileExists) return emptyArray;
        const result = [];
        for (const packageJson of findPackageJsons(scriptPath, host)){
            const contents = readJson(packageJson, host);
            for (const key of nodeModulesDependencyKeys){
                const dependencies = contents[key];
                if (!dependencies) continue;
                for(const dep in dependencies)if (hasProperty(dependencies, dep) && !startsWith(dep, "@types/")) result.push(dep);
            }
        }
        return result;
    }
    function getDirectoryFragmentTextSpan(text, textStart) {
        const index = Math.max(text.lastIndexOf(directorySeparator), text.lastIndexOf(altDirectorySeparator));
        const offset = index !== -1 ? index + 1 : 0;
        const length2 = text.length - offset;
        return length2 === 0 || isIdentifierText(text.substr(offset, length2), 99 /* ESNext */ ) ? void 0 : createTextSpan(textStart + offset, length2);
    }
    function isPathRelativeToScript(path) {
        if (path && path.length >= 2 && path.charCodeAt(0) === 46 /* dot */ ) {
            const slashIndex = path.length >= 3 && path.charCodeAt(1) === 46 /* dot */  ? 2 : 1;
            const slashCharCode = path.charCodeAt(slashIndex);
            return slashCharCode === 47 /* slash */  || slashCharCode === 92 /* backslash */ ;
        }
        return false;
    }
    var tripleSlashDirectiveFragmentRegex = /^(\/\/\/\s*<reference\s+(path|types)\s*=\s*(?:'|"))([^\x03"]*)$/;
    var nodeModulesDependencyKeys = [
        "dependencies",
        "devDependencies",
        "peerDependencies",
        "optionalDependencies"
    ];
    function containsSlash(fragment) {
        return fragment.includes(directorySeparator);
    }
    function isRequireCallArgument(node) {
        return isCallExpression(node.parent) && firstOrUndefined(node.parent.arguments) === node && isIdentifier(node.parent.expression) && node.parent.expression.escapedText === "require";
    }
    // src/services/_namespaces/ts.FindAllReferences.ts
    var ts_FindAllReferences_exports = {};
    __export(ts_FindAllReferences_exports, {
        Core: ()=>Core,
        DefinitionKind: ()=>DefinitionKind,
        EntryKind: ()=>EntryKind,
        ExportKind: ()=>ExportKind2,
        FindReferencesUse: ()=>FindReferencesUse,
        ImportExport: ()=>ImportExport,
        createImportTracker: ()=>createImportTracker,
        findModuleReferences: ()=>findModuleReferences,
        findReferenceOrRenameEntries: ()=>findReferenceOrRenameEntries,
        findReferencedSymbols: ()=>findReferencedSymbols,
        getContextNode: ()=>getContextNode,
        getExportInfo: ()=>getExportInfo,
        getImplementationsAtPosition: ()=>getImplementationsAtPosition,
        getImportOrExportSymbol: ()=>getImportOrExportSymbol,
        getReferenceEntriesForNode: ()=>getReferenceEntriesForNode,
        isContextWithStartAndEndNode: ()=>isContextWithStartAndEndNode,
        isDeclarationOfSymbol: ()=>isDeclarationOfSymbol,
        isWriteAccessForReference: ()=>isWriteAccessForReference,
        toContextSpan: ()=>toContextSpan,
        toHighlightSpan: ()=>toHighlightSpan,
        toReferenceEntry: ()=>toReferenceEntry,
        toRenameLocation: ()=>toRenameLocation
    });
    // src/services/importTracker.ts
    function createImportTracker(sourceFiles, sourceFilesSet, checker, cancellationToken) {
        const allDirectImports = getDirectImportsMap(sourceFiles, checker, cancellationToken);
        return (exportSymbol, exportInfo, isForRename)=>{
            const { directImports, indirectUsers } = getImportersForExport(sourceFiles, sourceFilesSet, allDirectImports, exportInfo, checker, cancellationToken);
            return (0, _objectSpread._)({
                indirectUsers
            }, getSearchesFromDirectImports(directImports, exportSymbol, exportInfo.exportKind, checker, isForRename));
        };
    }
    var ExportKind2 = /* @__PURE__ */ ((ExportKind3)=>{
        ExportKind3[ExportKind3["Named"] = 0] = "Named";
        ExportKind3[ExportKind3["Default"] = 1] = "Default";
        ExportKind3[ExportKind3["ExportEquals"] = 2] = "ExportEquals";
        return ExportKind3;
    })(ExportKind2 || {});
    var ImportExport = /* @__PURE__ */ ((ImportExport2)=>{
        ImportExport2[ImportExport2["Import"] = 0] = "Import";
        ImportExport2[ImportExport2["Export"] = 1] = "Export";
        return ImportExport2;
    })(ImportExport || {});
    function getImportersForExport(sourceFiles, sourceFilesSet, allDirectImports, { exportingModuleSymbol, exportKind }, checker, cancellationToken) {
        const markSeenDirectImport = nodeSeenTracker();
        const markSeenIndirectUser = nodeSeenTracker();
        const directImports = [];
        const isAvailableThroughGlobal = !!exportingModuleSymbol.globalExports;
        const indirectUserDeclarations = isAvailableThroughGlobal ? void 0 : [];
        handleDirectImports(exportingModuleSymbol);
        return {
            directImports,
            indirectUsers: getIndirectUsers()
        };
        function getIndirectUsers() {
            if (isAvailableThroughGlobal) return sourceFiles;
            if (exportingModuleSymbol.declarations) {
                for (const decl of exportingModuleSymbol.declarations)if (isExternalModuleAugmentation(decl) && sourceFilesSet.has(decl.getSourceFile().fileName)) addIndirectUser(decl);
            }
            return indirectUserDeclarations.map(getSourceFileOfNode);
        }
        function handleDirectImports(exportingModuleSymbol2) {
            const theseDirectImports = getDirectImports(exportingModuleSymbol2);
            if (theseDirectImports) for (const direct of theseDirectImports){
                if (!markSeenDirectImport(direct)) continue;
                if (cancellationToken) cancellationToken.throwIfCancellationRequested();
                switch(direct.kind){
                    case 214 /* CallExpression */ :
                        if (isImportCall(direct)) {
                            handleImportCall(direct);
                            break;
                        }
                        if (!isAvailableThroughGlobal) {
                            const parent2 = direct.parent;
                            if (exportKind === 2 /* ExportEquals */  && parent2.kind === 261 /* VariableDeclaration */ ) {
                                const { name } = parent2;
                                if (name.kind === 80 /* Identifier */ ) {
                                    directImports.push(name);
                                    break;
                                }
                            }
                        }
                        break;
                    case 80 /* Identifier */ :
                        break;
                    // TODO: GH#23879
                    case 272 /* ImportEqualsDeclaration */ :
                        handleNamespaceImport(direct, direct.name, hasSyntacticModifier(direct, 32 /* Export */ ), /*alreadyAddedDirect*/ false);
                        break;
                    case 273 /* ImportDeclaration */ :
                    case 352 /* JSDocImportTag */ :
                        directImports.push(direct);
                        const namedBindings = direct.importClause && direct.importClause.namedBindings;
                        if (namedBindings && namedBindings.kind === 275 /* NamespaceImport */ ) handleNamespaceImport(direct, namedBindings.name, /*isReExport*/ false, /*alreadyAddedDirect*/ true);
                        else if (!isAvailableThroughGlobal && isDefaultImport(direct)) addIndirectUser(getSourceFileLikeForImportDeclaration(direct));
                        break;
                    case 279 /* ExportDeclaration */ :
                        if (!direct.exportClause) handleDirectImports(getContainingModuleSymbol(direct, checker));
                        else if (direct.exportClause.kind === 281 /* NamespaceExport */ ) addIndirectUser(getSourceFileLikeForImportDeclaration(direct), /*addTransitiveDependencies*/ true);
                        else directImports.push(direct);
                        break;
                    case 206 /* ImportType */ :
                        if (!isAvailableThroughGlobal && direct.isTypeOf && !direct.qualifier && isExported2(direct)) addIndirectUser(direct.getSourceFile(), /*addTransitiveDependencies*/ true);
                        directImports.push(direct);
                        break;
                    default:
                        Debug.failBadSyntaxKind(direct, "Unexpected import kind.");
                }
            }
        }
        function handleImportCall(importCall) {
            const top = findAncestor(importCall, isAmbientModuleDeclaration) || importCall.getSourceFile();
            addIndirectUser(top, /** addTransitiveDependencies */ !!isExported2(importCall, /*stopAtAmbientModule*/ true));
        }
        function isExported2(node, stopAtAmbientModule = false) {
            return findAncestor(node, (node2)=>{
                if (stopAtAmbientModule && isAmbientModuleDeclaration(node2)) return "quit";
                return canHaveModifiers(node2) && some(node2.modifiers, isExportModifier);
            });
        }
        function handleNamespaceImport(importDeclaration, name, isReExport, alreadyAddedDirect) {
            if (exportKind === 2 /* ExportEquals */ ) {
                if (!alreadyAddedDirect) directImports.push(importDeclaration);
            } else if (!isAvailableThroughGlobal) {
                const sourceFileLike = getSourceFileLikeForImportDeclaration(importDeclaration);
                Debug.assert(sourceFileLike.kind === 308 /* SourceFile */  || sourceFileLike.kind === 268 /* ModuleDeclaration */ );
                if (isReExport || findNamespaceReExports(sourceFileLike, name, checker)) addIndirectUser(sourceFileLike, /*addTransitiveDependencies*/ true);
                else addIndirectUser(sourceFileLike);
            }
        }
        function addIndirectUser(sourceFileLike, addTransitiveDependencies = false) {
            Debug.assert(!isAvailableThroughGlobal);
            const isNew = markSeenIndirectUser(sourceFileLike);
            if (!isNew) return;
            indirectUserDeclarations.push(sourceFileLike);
            if (!addTransitiveDependencies) return;
            const moduleSymbol = checker.getMergedSymbol(sourceFileLike.symbol);
            if (!moduleSymbol) return;
            Debug.assert(!!(moduleSymbol.flags & 1536 /* Module */ ));
            const directImports2 = getDirectImports(moduleSymbol);
            if (directImports2) {
                for (const directImport of directImports2)if (!isImportTypeNode(directImport)) addIndirectUser(getSourceFileLikeForImportDeclaration(directImport), /*addTransitiveDependencies*/ true);
            }
        }
        function getDirectImports(moduleSymbol) {
            return allDirectImports.get(getSymbolId(moduleSymbol).toString());
        }
    }
    function getSearchesFromDirectImports(directImports, exportSymbol, exportKind, checker, isForRename) {
        const importSearches = [];
        const singleReferences = [];
        function addSearch(location, symbol) {
            importSearches.push([
                location,
                symbol
            ]);
        }
        if (directImports) for (const decl of directImports)handleImport(decl);
        return {
            importSearches,
            singleReferences
        };
        function handleImport(decl) {
            if (decl.kind === 272 /* ImportEqualsDeclaration */ ) {
                if (isExternalModuleImportEquals(decl)) handleNamespaceImportLike(decl.name);
                return;
            }
            if (decl.kind === 80 /* Identifier */ ) {
                handleNamespaceImportLike(decl);
                return;
            }
            if (decl.kind === 206 /* ImportType */ ) {
                if (decl.qualifier) {
                    const firstIdentifier = getFirstIdentifier(decl.qualifier);
                    if (firstIdentifier.escapedText === symbolName(exportSymbol)) singleReferences.push(firstIdentifier);
                } else if (exportKind === 2 /* ExportEquals */ ) singleReferences.push(decl.argument.literal);
                return;
            }
            if (decl.moduleSpecifier.kind !== 11 /* StringLiteral */ ) return;
            if (decl.kind === 279 /* ExportDeclaration */ ) {
                if (decl.exportClause && isNamedExports(decl.exportClause)) searchForNamedImport(decl.exportClause);
                return;
            }
            const { name, namedBindings } = decl.importClause || {
                name: void 0,
                namedBindings: void 0
            };
            if (namedBindings) switch(namedBindings.kind){
                case 275 /* NamespaceImport */ :
                    handleNamespaceImportLike(namedBindings.name);
                    break;
                case 276 /* NamedImports */ :
                    if (exportKind === 0 /* Named */  || exportKind === 1 /* Default */ ) searchForNamedImport(namedBindings);
                    break;
                default:
                    Debug.assertNever(namedBindings);
            }
            if (name && (exportKind === 1 /* Default */  || exportKind === 2 /* ExportEquals */ ) && (!isForRename || name.escapedText === symbolEscapedNameNoDefault(exportSymbol))) {
                const defaultImportAlias = checker.getSymbolAtLocation(name);
                addSearch(name, defaultImportAlias);
            }
        }
        function handleNamespaceImportLike(importName) {
            if (exportKind === 2 /* ExportEquals */  && (!isForRename || isNameMatch(importName.escapedText))) addSearch(importName, checker.getSymbolAtLocation(importName));
        }
        function searchForNamedImport(namedBindings) {
            if (!namedBindings) return;
            for (const element of namedBindings.elements){
                const { name, propertyName } = element;
                if (!isNameMatch(moduleExportNameTextEscaped(propertyName || name))) continue;
                if (propertyName) {
                    singleReferences.push(propertyName);
                    if (!isForRename || moduleExportNameTextEscaped(name) === exportSymbol.escapedName) addSearch(name, checker.getSymbolAtLocation(name));
                } else {
                    const localSymbol = element.kind === 282 /* ExportSpecifier */  && element.propertyName ? checker.getExportSpecifierLocalTargetSymbol(element) : checker.getSymbolAtLocation(name);
                    addSearch(name, localSymbol);
                }
            }
        }
        function isNameMatch(name) {
            return name === exportSymbol.escapedName || exportKind !== 0 /* Named */  && name === "default" /* Default */ ;
        }
    }
    function findNamespaceReExports(sourceFileLike, name, checker) {
        const namespaceImportSymbol = checker.getSymbolAtLocation(name);
        return !!forEachPossibleImportOrExportStatement(sourceFileLike, (statement)=>{
            if (!isExportDeclaration(statement)) return;
            const { exportClause, moduleSpecifier } = statement;
            return !moduleSpecifier && exportClause && isNamedExports(exportClause) && exportClause.elements.some((element)=>checker.getExportSpecifierLocalTargetSymbol(element) === namespaceImportSymbol);
        });
    }
    function findModuleReferences(program, sourceFiles, searchModuleSymbol) {
        var _a;
        const refs = [];
        const checker = program.getTypeChecker();
        for (const referencingFile of sourceFiles){
            const searchSourceFile = searchModuleSymbol.valueDeclaration;
            if ((searchSourceFile == null ? void 0 : searchSourceFile.kind) === 308 /* SourceFile */ ) {
                for (const ref of referencingFile.referencedFiles)if (program.getSourceFileFromReference(referencingFile, ref) === searchSourceFile) refs.push({
                    kind: "reference",
                    referencingFile,
                    ref
                });
                for (const ref of referencingFile.typeReferenceDirectives){
                    const referenced = (_a = program.getResolvedTypeReferenceDirectiveFromTypeReferenceDirective(ref, referencingFile)) == null ? void 0 : _a.resolvedTypeReferenceDirective;
                    if (referenced !== void 0 && referenced.resolvedFileName === searchSourceFile.fileName) refs.push({
                        kind: "reference",
                        referencingFile,
                        ref
                    });
                }
            }
            forEachImport(referencingFile, (importDecl, moduleSpecifier)=>{
                const moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
                if (moduleSymbol === searchModuleSymbol) refs.push(nodeIsSynthesized(importDecl) ? {
                    kind: "implicit",
                    literal: moduleSpecifier,
                    referencingFile
                } : {
                    kind: "import",
                    literal: moduleSpecifier
                });
            });
        }
        return refs;
    }
    function getDirectImportsMap(sourceFiles, checker, cancellationToken) {
        const map2 = /* @__PURE__ */ new Map();
        for (const sourceFile of sourceFiles){
            if (cancellationToken) cancellationToken.throwIfCancellationRequested();
            forEachImport(sourceFile, (importDecl, moduleSpecifier)=>{
                const moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
                if (moduleSymbol) {
                    const id = getSymbolId(moduleSymbol).toString();
                    let imports = map2.get(id);
                    if (!imports) map2.set(id, imports = []);
                    imports.push(importDecl);
                }
            });
        }
        return map2;
    }
    function forEachPossibleImportOrExportStatement(sourceFileLike, action) {
        return forEach(sourceFileLike.kind === 308 /* SourceFile */  ? sourceFileLike.statements : sourceFileLike.body.statements, (statement)=>// TODO: GH#18217
            action(statement) || isAmbientModuleDeclaration(statement) && forEach(statement.body && statement.body.statements, action));
    }
    function forEachImport(sourceFile, action) {
        if (sourceFile.externalModuleIndicator || sourceFile.imports !== void 0) for (const i of sourceFile.imports)action(importFromModuleSpecifier(i), i);
        else forEachPossibleImportOrExportStatement(sourceFile, (statement)=>{
            switch(statement.kind){
                case 279 /* ExportDeclaration */ :
                case 273 /* ImportDeclaration */ :
                    {
                        const decl = statement;
                        if (decl.moduleSpecifier && isStringLiteral(decl.moduleSpecifier)) action(decl, decl.moduleSpecifier);
                        break;
                    }
                case 272 /* ImportEqualsDeclaration */ :
                    {
                        const decl = statement;
                        if (isExternalModuleImportEquals(decl)) action(decl, decl.moduleReference.expression);
                        break;
                    }
            }
        });
    }
    function getImportOrExportSymbol(node, symbol, checker, comingFromExport) {
        return comingFromExport ? getExport() : getExport() || getImport();
        function getExport() {
            var _a;
            const { parent: parent2 } = node;
            const grandparent = parent2.parent;
            if (symbol.exportSymbol) {
                if (parent2.kind === 212 /* PropertyAccessExpression */ ) return ((_a = symbol.declarations) == null ? void 0 : _a.some((d)=>d === parent2)) && isBinaryExpression(grandparent) ? getSpecialPropertyExport(grandparent, /*useLhsSymbol*/ false) : void 0;
                else return exportInfo(symbol.exportSymbol, getExportKindForDeclaration(parent2));
            } else {
                const exportNode = getExportNode(parent2, node);
                if (exportNode && hasSyntacticModifier(exportNode, 32 /* Export */ )) {
                    if (isImportEqualsDeclaration(exportNode) && exportNode.moduleReference === node) {
                        if (comingFromExport) return void 0;
                        const lhsSymbol = checker.getSymbolAtLocation(exportNode.name);
                        return {
                            kind: 0 /* Import */ ,
                            symbol: lhsSymbol
                        };
                    } else return exportInfo(symbol, getExportKindForDeclaration(exportNode));
                } else if (isNamespaceExport(parent2)) return exportInfo(symbol, 0 /* Named */ );
                else if (isExportAssignment(parent2)) return getExportAssignmentExport(parent2);
                else if (isExportAssignment(grandparent)) return getExportAssignmentExport(grandparent);
                else if (isBinaryExpression(parent2)) return getSpecialPropertyExport(parent2, /*useLhsSymbol*/ true);
                else if (isBinaryExpression(grandparent)) return getSpecialPropertyExport(grandparent, /*useLhsSymbol*/ true);
                else if (isJSDocTypedefTag(parent2) || isJSDocCallbackTag(parent2)) return exportInfo(symbol, 0 /* Named */ );
            }
            function getExportAssignmentExport(ex) {
                if (!ex.symbol.parent) return void 0;
                const exportKind = ex.isExportEquals ? 2 /* ExportEquals */  : 1 /* Default */ ;
                return {
                    kind: 1 /* Export */ ,
                    symbol,
                    exportInfo: {
                        exportingModuleSymbol: ex.symbol.parent,
                        exportKind
                    }
                };
            }
            function getSpecialPropertyExport(node2, useLhsSymbol) {
                let kind;
                switch(getAssignmentDeclarationKind(node2)){
                    case 1 /* ExportsProperty */ :
                        kind = 0 /* Named */ ;
                        break;
                    case 2 /* ModuleExports */ :
                        kind = 2 /* ExportEquals */ ;
                        break;
                    default:
                        return void 0;
                }
                const sym = useLhsSymbol ? checker.getSymbolAtLocation(getNameOfAccessExpression(cast(node2.left, isAccessExpression))) : symbol;
                return sym && exportInfo(sym, kind);
            }
        }
        function getImport() {
            const isImport3 = isNodeImport(node);
            if (!isImport3) return void 0;
            let importedSymbol = checker.getImmediateAliasedSymbol(symbol);
            if (!importedSymbol) return void 0;
            importedSymbol = skipExportSpecifierSymbol(importedSymbol, checker);
            if (importedSymbol.escapedName === "export=") {
                importedSymbol = getExportEqualsLocalSymbol(importedSymbol, checker);
                if (importedSymbol === void 0) return void 0;
            }
            const importedName = symbolEscapedNameNoDefault(importedSymbol);
            if (importedName === void 0 || importedName === "default" /* Default */  || importedName === symbol.escapedName) return {
                kind: 0 /* Import */ ,
                symbol: importedSymbol
            };
        }
        function exportInfo(symbol2, kind) {
            const exportInfo2 = getExportInfo(symbol2, kind, checker);
            return exportInfo2 && {
                kind: 1 /* Export */ ,
                symbol: symbol2,
                exportInfo: exportInfo2
            };
        }
        function getExportKindForDeclaration(node2) {
            return hasSyntacticModifier(node2, 2048 /* Default */ ) ? 1 /* Default */  : 0 /* Named */ ;
        }
    }
    function getExportEqualsLocalSymbol(importedSymbol, checker) {
        var _a, _b;
        if (importedSymbol.flags & 2097152 /* Alias */ ) return checker.getImmediateAliasedSymbol(importedSymbol);
        const decl = Debug.checkDefined(importedSymbol.valueDeclaration);
        if (isExportAssignment(decl)) return (_a = tryCast(decl.expression, canHaveSymbol)) == null ? void 0 : _a.symbol;
        else if (isBinaryExpression(decl)) return (_b = tryCast(decl.right, canHaveSymbol)) == null ? void 0 : _b.symbol;
        else if (isSourceFile(decl)) return decl.symbol;
        return void 0;
    }
    function getExportNode(parent2, node) {
        const declaration = isVariableDeclaration(parent2) ? parent2 : isBindingElement(parent2) ? walkUpBindingElementsAndPatterns(parent2) : void 0;
        if (declaration) return parent2.name !== node ? void 0 : isCatchClause(declaration.parent) ? void 0 : isVariableStatement(declaration.parent.parent) ? declaration.parent.parent : void 0;
        else return parent2;
    }
    function isNodeImport(node) {
        const { parent: parent2 } = node;
        switch(parent2.kind){
            case 272 /* ImportEqualsDeclaration */ :
                return parent2.name === node && isExternalModuleImportEquals(parent2);
            case 277 /* ImportSpecifier */ :
                return !parent2.propertyName;
            case 274 /* ImportClause */ :
            case 275 /* NamespaceImport */ :
                Debug.assert(parent2.name === node);
                return true;
            case 209 /* BindingElement */ :
                return isInJSFile(node) && isVariableDeclarationInitializedToBareOrAccessedRequire(parent2.parent.parent);
            default:
                return false;
        }
    }
    function getExportInfo(exportSymbol, exportKind, checker) {
        const moduleSymbol = exportSymbol.parent;
        if (!moduleSymbol) return void 0;
        const exportingModuleSymbol = checker.getMergedSymbol(moduleSymbol);
        return isExternalModuleSymbol(exportingModuleSymbol) ? {
            exportingModuleSymbol,
            exportKind
        } : void 0;
    }
    function skipExportSpecifierSymbol(symbol, checker) {
        if (symbol.declarations) for (const declaration of symbol.declarations){
            if (isExportSpecifier(declaration) && !declaration.propertyName && !declaration.parent.parent.moduleSpecifier) return checker.getExportSpecifierLocalTargetSymbol(declaration) || symbol;
            else if (isPropertyAccessExpression(declaration) && isModuleExportsAccessExpression(declaration.expression) && !isPrivateIdentifier(declaration.name)) return checker.getSymbolAtLocation(declaration);
            else if (isShorthandPropertyAssignment(declaration) && isBinaryExpression(declaration.parent.parent) && getAssignmentDeclarationKind(declaration.parent.parent) === 2 /* ModuleExports */ ) return checker.getExportSpecifierLocalTargetSymbol(declaration.name);
        }
        return symbol;
    }
    function getContainingModuleSymbol(importer, checker) {
        return checker.getMergedSymbol(getSourceFileLikeForImportDeclaration(importer).symbol);
    }
    function getSourceFileLikeForImportDeclaration(node) {
        if (node.kind === 214 /* CallExpression */  || node.kind === 352 /* JSDocImportTag */ ) return node.getSourceFile();
        const { parent: parent2 } = node;
        if (parent2.kind === 308 /* SourceFile */ ) return parent2;
        Debug.assert(parent2.kind === 269 /* ModuleBlock */ );
        return cast(parent2.parent, isAmbientModuleDeclaration);
    }
    function isAmbientModuleDeclaration(node) {
        return node.kind === 268 /* ModuleDeclaration */  && node.name.kind === 11 /* StringLiteral */ ;
    }
    function isExternalModuleImportEquals(eq) {
        return eq.moduleReference.kind === 284 /* ExternalModuleReference */  && eq.moduleReference.expression.kind === 11 /* StringLiteral */ ;
    }
    // src/services/findAllReferences.ts
    var DefinitionKind = /* @__PURE__ */ ((DefinitionKind2)=>{
        DefinitionKind2[DefinitionKind2["Symbol"] = 0] = "Symbol";
        DefinitionKind2[DefinitionKind2["Label"] = 1] = "Label";
        DefinitionKind2[DefinitionKind2["Keyword"] = 2] = "Keyword";
        DefinitionKind2[DefinitionKind2["This"] = 3] = "This";
        DefinitionKind2[DefinitionKind2["String"] = 4] = "String";
        DefinitionKind2[DefinitionKind2["TripleSlashReference"] = 5] = "TripleSlashReference";
        return DefinitionKind2;
    })(DefinitionKind || {});
    var EntryKind = /* @__PURE__ */ ((EntryKind2)=>{
        EntryKind2[EntryKind2["Span"] = 0] = "Span";
        EntryKind2[EntryKind2["Node"] = 1] = "Node";
        EntryKind2[EntryKind2["StringLiteral"] = 2] = "StringLiteral";
        EntryKind2[EntryKind2["SearchedLocalFoundProperty"] = 3] = "SearchedLocalFoundProperty";
        EntryKind2[EntryKind2["SearchedPropertyFoundLocal"] = 4] = "SearchedPropertyFoundLocal";
        return EntryKind2;
    })(EntryKind || {});
    function nodeEntry(node, kind = 1 /* Node */ ) {
        return {
            kind,
            node: node.name || node,
            context: getContextNodeForNodeEntry(node)
        };
    }
    function isContextWithStartAndEndNode(node) {
        return node && node.kind === void 0;
    }
    function getContextNodeForNodeEntry(node) {
        if (isDeclaration(node)) return getContextNode(node);
        if (!node.parent) return void 0;
        if (!isDeclaration(node.parent) && !isExportAssignment(node.parent)) {
            if (isInJSFile(node)) {
                const binaryExpression = isBinaryExpression(node.parent) ? node.parent : isAccessExpression(node.parent) && isBinaryExpression(node.parent.parent) && node.parent.parent.left === node.parent ? node.parent.parent : void 0;
                if (binaryExpression && getAssignmentDeclarationKind(binaryExpression) !== 0 /* None */ ) return getContextNode(binaryExpression);
            }
            if (isJsxOpeningElement(node.parent) || isJsxClosingElement(node.parent)) return node.parent.parent;
            else if (isJsxSelfClosingElement(node.parent) || isLabeledStatement(node.parent) || isBreakOrContinueStatement(node.parent)) return node.parent;
            else if (isStringLiteralLike(node)) {
                const validImport = tryGetImportFromModuleSpecifier(node);
                if (validImport) {
                    const declOrStatement = findAncestor(validImport, (node2)=>isDeclaration(node2) || isStatement(node2) || isJSDocTag(node2));
                    return isDeclaration(declOrStatement) ? getContextNode(declOrStatement) : declOrStatement;
                }
            }
            const propertyName = findAncestor(node, isComputedPropertyName);
            return propertyName ? getContextNode(propertyName.parent) : void 0;
        }
        if (node.parent.name === node || // node is name of declaration, use parent
        isConstructorDeclaration(node.parent) || isExportAssignment(node.parent) || // Property name of the import export specifier or binding pattern, use parent
        (isImportOrExportSpecifier(node.parent) || isBindingElement(node.parent)) && node.parent.propertyName === node || // Is default export
        node.kind === 90 /* DefaultKeyword */  && hasSyntacticModifier(node.parent, 2080 /* ExportDefault */ )) return getContextNode(node.parent);
        return void 0;
    }
    function getContextNode(node) {
        if (!node) return void 0;
        switch(node.kind){
            case 261 /* VariableDeclaration */ :
                return !isVariableDeclarationList(node.parent) || node.parent.declarations.length !== 1 ? node : isVariableStatement(node.parent.parent) ? node.parent.parent : isForInOrOfStatement(node.parent.parent) ? getContextNode(node.parent.parent) : node.parent;
            case 209 /* BindingElement */ :
                return getContextNode(node.parent.parent);
            case 277 /* ImportSpecifier */ :
                return node.parent.parent.parent;
            case 282 /* ExportSpecifier */ :
            case 275 /* NamespaceImport */ :
                return node.parent.parent;
            case 274 /* ImportClause */ :
            case 281 /* NamespaceExport */ :
                return node.parent;
            case 227 /* BinaryExpression */ :
                return isExpressionStatement(node.parent) ? node.parent : node;
            case 251 /* ForOfStatement */ :
            case 250 /* ForInStatement */ :
                return {
                    start: node.initializer,
                    end: node.expression
                };
            case 304 /* PropertyAssignment */ :
            case 305 /* ShorthandPropertyAssignment */ :
                return isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent) ? getContextNode(findAncestor(node.parent, (node2)=>isBinaryExpression(node2) || isForInOrOfStatement(node2))) : node;
            case 256 /* SwitchStatement */ :
                return {
                    start: find(node.getChildren(node.getSourceFile()), (node2)=>node2.kind === 109 /* SwitchKeyword */ ),
                    end: node.caseBlock
                };
            default:
                return node;
        }
    }
    function toContextSpan(textSpan, sourceFile, context) {
        if (!context) return void 0;
        const contextSpan = isContextWithStartAndEndNode(context) ? getTextSpan(context.start, sourceFile, context.end) : getTextSpan(context, sourceFile);
        return contextSpan.start !== textSpan.start || contextSpan.length !== textSpan.length ? {
            contextSpan
        } : void 0;
    }
    var FindReferencesUse = /* @__PURE__ */ ((FindReferencesUse2)=>{
        FindReferencesUse2[FindReferencesUse2["Other"] = 0] = "Other";
        FindReferencesUse2[FindReferencesUse2["References"] = 1] = "References";
        FindReferencesUse2[FindReferencesUse2["Rename"] = 2] = "Rename";
        return FindReferencesUse2;
    })(FindReferencesUse || {});
    function findReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position) {
        const node = getTouchingPropertyName(sourceFile, position);
        const options = {
            use: 1 /* References */ 
        };
        const referencedSymbols = Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options);
        const checker = program.getTypeChecker();
        const adjustedNode = Core.getAdjustedNode(node, options);
        const symbol = isDefinitionForReference(adjustedNode) ? checker.getSymbolAtLocation(adjustedNode) : void 0;
        return !referencedSymbols || !referencedSymbols.length ? void 0 : mapDefined(referencedSymbols, ({ definition, references })=>// Only include referenced symbols that have a valid definition.
            definition && {
                definition: checker.runWithCancellationToken(cancellationToken, (checker2)=>definitionToReferencedSymbolDefinitionInfo(definition, checker2, node)),
                references: references.map((r)=>toReferencedSymbolEntry(r, symbol))
            });
    }
    function isDefinitionForReference(node) {
        return node.kind === 90 /* DefaultKeyword */  || !!getDeclarationFromName(node) || isLiteralComputedPropertyDeclarationName(node) || node.kind === 137 /* ConstructorKeyword */  && isConstructorDeclaration(node.parent);
    }
    function getImplementationsAtPosition(program, cancellationToken, sourceFiles, sourceFile, position) {
        const node = getTouchingPropertyName(sourceFile, position);
        let referenceEntries;
        const entries = getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position);
        if (node.parent.kind === 212 /* PropertyAccessExpression */  || node.parent.kind === 209 /* BindingElement */  || node.parent.kind === 213 /* ElementAccessExpression */  || node.kind === 108 /* SuperKeyword */ ) referenceEntries = entries && [
            ...entries
        ];
        else if (entries) {
            const queue = createQueue(entries);
            const seenNodes = /* @__PURE__ */ new Set();
            while(!queue.isEmpty()){
                const entry = queue.dequeue();
                if (!addToSeen(seenNodes, getNodeId(entry.node))) continue;
                referenceEntries = append(referenceEntries, entry);
                const entries2 = getImplementationReferenceEntries(program, cancellationToken, sourceFiles, entry.node, entry.node.pos);
                if (entries2) queue.enqueue(...entries2);
            }
        }
        const checker = program.getTypeChecker();
        return map(referenceEntries, (entry)=>toImplementationLocation(entry, checker));
    }
    function getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position) {
        if (node.kind === 308 /* SourceFile */ ) return void 0;
        const checker = program.getTypeChecker();
        if (node.parent.kind === 305 /* ShorthandPropertyAssignment */ ) {
            const result = [];
            Core.getReferenceEntriesForShorthandPropertyAssignment(node, checker, (node2)=>result.push(nodeEntry(node2)));
            return result;
        } else if (node.kind === 108 /* SuperKeyword */  || isSuperProperty(node.parent)) {
            const symbol = checker.getSymbolAtLocation(node);
            return symbol.valueDeclaration && [
                nodeEntry(symbol.valueDeclaration)
            ];
        } else return getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, {
            implementations: true,
            use: 1 /* References */ 
        });
    }
    function findReferenceOrRenameEntries(program, cancellationToken, sourceFiles, node, position, options, convertEntry) {
        return map(flattenEntries(Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options)), (entry)=>convertEntry(entry, node, program.getTypeChecker()));
    }
    function getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, options = {}, sourceFilesSet = new Set(sourceFiles.map((f)=>f.fileName))) {
        return flattenEntries(Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options, sourceFilesSet));
    }
    function flattenEntries(referenceSymbols) {
        return referenceSymbols && flatMap(referenceSymbols, (r)=>r.references);
    }
    function definitionToReferencedSymbolDefinitionInfo(def, checker, originalNode) {
        const info = (()=>{
            switch(def.type){
                case 0 /* Symbol */ :
                    {
                        const { symbol } = def;
                        const { displayParts: displayParts2, kind: kind2 } = getDefinitionKindAndDisplayParts(symbol, checker, originalNode);
                        const name2 = displayParts2.map((p)=>p.text).join("");
                        const declaration = symbol.declarations && firstOrUndefined(symbol.declarations);
                        const node = declaration ? getNameOfDeclaration(declaration) || declaration : originalNode;
                        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getFileAndTextSpanFromNode(node)), {
                            name: name2,
                            kind: kind2,
                            displayParts: displayParts2,
                            context: getContextNode(declaration)
                        });
                    }
                case 1 /* Label */ :
                    {
                        const { node } = def;
                        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getFileAndTextSpanFromNode(node)), {
                            name: node.text,
                            kind: "label" /* label */ ,
                            displayParts: [
                                displayPart(node.text, 17 /* text */ )
                            ]
                        });
                    }
                case 2 /* Keyword */ :
                    {
                        const { node } = def;
                        const name2 = tokenToString(node.kind);
                        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getFileAndTextSpanFromNode(node)), {
                            name: name2,
                            kind: "keyword" /* keyword */ ,
                            displayParts: [
                                {
                                    text: name2,
                                    kind: "keyword" /* keyword */ 
                                }
                            ]
                        });
                    }
                case 3 /* This */ :
                    {
                        const { node } = def;
                        const symbol = checker.getSymbolAtLocation(node);
                        const displayParts2 = symbol && ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, node.getSourceFile(), getContainerNode(node), node).displayParts || [
                            textPart("this")
                        ];
                        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getFileAndTextSpanFromNode(node)), {
                            name: "this",
                            kind: "var" /* variableElement */ ,
                            displayParts: displayParts2
                        });
                    }
                case 4 /* String */ :
                    {
                        const { node } = def;
                        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, getFileAndTextSpanFromNode(node)), {
                            name: node.text,
                            kind: "var" /* variableElement */ ,
                            displayParts: [
                                displayPart(getTextOfNode(node), 8 /* stringLiteral */ )
                            ]
                        });
                    }
                case 5 /* TripleSlashReference */ :
                    return {
                        textSpan: createTextSpanFromRange(def.reference),
                        sourceFile: def.file,
                        name: def.reference.fileName,
                        kind: "string" /* string */ ,
                        displayParts: [
                            displayPart(`"${def.reference.fileName}"`, 8 /* stringLiteral */ )
                        ]
                    };
                default:
                    return Debug.assertNever(def);
            }
        })();
        const { sourceFile, textSpan, name, kind, displayParts, context } = info;
        return (0, _objectSpread._)({
            containerKind: "" /* unknown */ ,
            containerName: "",
            fileName: sourceFile.fileName,
            kind,
            name,
            textSpan,
            displayParts
        }, toContextSpan(textSpan, sourceFile, context));
    }
    function getFileAndTextSpanFromNode(node) {
        const sourceFile = node.getSourceFile();
        return {
            sourceFile,
            textSpan: getTextSpan(isComputedPropertyName(node) ? node.expression : node, sourceFile)
        };
    }
    function getDefinitionKindAndDisplayParts(symbol, checker, node) {
        const meaning = Core.getIntersectingMeaningFromDeclarations(node, symbol);
        const enclosingDeclaration = symbol.declarations && firstOrUndefined(symbol.declarations) || node;
        const { displayParts, symbolKind } = ts_SymbolDisplay_exports.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, enclosingDeclaration.getSourceFile(), enclosingDeclaration, enclosingDeclaration, meaning);
        return {
            displayParts,
            kind: symbolKind
        };
    }
    function toRenameLocation(entry, originalNode, checker, providePrefixAndSuffixText, quotePreference) {
        return (0, _objectSpread._)({}, entryToDocumentSpan(entry), providePrefixAndSuffixText && getPrefixAndSuffixText(entry, originalNode, checker, quotePreference));
    }
    function toReferencedSymbolEntry(entry, symbol) {
        const referenceEntry = toReferenceEntry(entry);
        if (!symbol) return referenceEntry;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, referenceEntry), {
            isDefinition: entry.kind !== 0 /* Span */  && isDeclarationOfSymbol(entry.node, symbol)
        });
    }
    function toReferenceEntry(entry) {
        const documentSpan = entryToDocumentSpan(entry);
        if (entry.kind === 0 /* Span */ ) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, documentSpan), {
            isWriteAccess: false
        });
        const { kind, node } = entry;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, documentSpan), {
            isWriteAccess: isWriteAccessForReference(node),
            isInString: kind === 2 /* StringLiteral */  ? true : void 0
        });
    }
    function entryToDocumentSpan(entry) {
        if (entry.kind === 0 /* Span */ ) return {
            textSpan: entry.textSpan,
            fileName: entry.fileName
        };
        else {
            const sourceFile = entry.node.getSourceFile();
            const textSpan = getTextSpan(entry.node, sourceFile);
            return (0, _objectSpread._)({
                textSpan,
                fileName: sourceFile.fileName
            }, toContextSpan(textSpan, sourceFile, entry.context));
        }
    }
    function getPrefixAndSuffixText(entry, originalNode, checker, quotePreference) {
        if (entry.kind !== 0 /* Span */  && (isIdentifier(originalNode) || isStringLiteralLike(originalNode))) {
            const { node, kind } = entry;
            const parent2 = node.parent;
            const name = originalNode.text;
            const isShorthandAssignment = isShorthandPropertyAssignment(parent2);
            if (isShorthandAssignment || isObjectBindingElementWithoutPropertyName(parent2) && parent2.name === node && parent2.dotDotDotToken === void 0) {
                const prefixColon = {
                    prefixText: name + ": "
                };
                const suffixColon = {
                    suffixText: ": " + name
                };
                if (kind === 3 /* SearchedLocalFoundProperty */ ) return prefixColon;
                if (kind === 4 /* SearchedPropertyFoundLocal */ ) return suffixColon;
                if (isShorthandAssignment) {
                    const grandParent = parent2.parent;
                    if (isObjectLiteralExpression(grandParent) && isBinaryExpression(grandParent.parent) && isModuleExportsAccessExpression(grandParent.parent.left)) return prefixColon;
                    return suffixColon;
                } else return prefixColon;
            } else if (isImportSpecifier(parent2) && !parent2.propertyName) {
                const originalSymbol = isExportSpecifier(originalNode.parent) ? checker.getExportSpecifierLocalTargetSymbol(originalNode.parent) : checker.getSymbolAtLocation(originalNode);
                return contains(originalSymbol.declarations, parent2) ? {
                    prefixText: name + " as "
                } : emptyOptions;
            } else if (isExportSpecifier(parent2) && !parent2.propertyName) return originalNode === entry.node || checker.getSymbolAtLocation(originalNode) === checker.getSymbolAtLocation(entry.node) ? {
                prefixText: name + " as "
            } : {
                suffixText: " as " + name
            };
        }
        if (entry.kind !== 0 /* Span */  && isNumericLiteral(entry.node) && isAccessExpression(entry.node.parent)) {
            const quote2 = getQuoteFromPreference(quotePreference);
            return {
                prefixText: quote2,
                suffixText: quote2
            };
        }
        return emptyOptions;
    }
    function toImplementationLocation(entry, checker) {
        const documentSpan = entryToDocumentSpan(entry);
        if (entry.kind !== 0 /* Span */ ) {
            const { node } = entry;
            return (0, _objectSpread._)({}, documentSpan, implementationKindDisplayParts(node, checker));
        } else return (0, _objectSpreadProps._)((0, _objectSpread._)({}, documentSpan), {
            kind: "" /* unknown */ ,
            displayParts: []
        });
    }
    function implementationKindDisplayParts(node, checker) {
        const symbol = checker.getSymbolAtLocation(isDeclaration(node) && node.name ? node.name : node);
        if (symbol) return getDefinitionKindAndDisplayParts(symbol, checker, node);
        else if (node.kind === 211 /* ObjectLiteralExpression */ ) return {
            kind: "interface" /* interfaceElement */ ,
            displayParts: [
                punctuationPart(21 /* OpenParenToken */ ),
                textPart("object literal"),
                punctuationPart(22 /* CloseParenToken */ )
            ]
        };
        else if (node.kind === 232 /* ClassExpression */ ) return {
            kind: "local class" /* localClassElement */ ,
            displayParts: [
                punctuationPart(21 /* OpenParenToken */ ),
                textPart("anonymous local class"),
                punctuationPart(22 /* CloseParenToken */ )
            ]
        };
        else return {
            kind: getNodeKind(node),
            displayParts: []
        };
    }
    function toHighlightSpan(entry) {
        const documentSpan = entryToDocumentSpan(entry);
        if (entry.kind === 0 /* Span */ ) return {
            fileName: documentSpan.fileName,
            span: {
                textSpan: documentSpan.textSpan,
                kind: "reference" /* reference */ 
            }
        };
        const writeAccess = isWriteAccessForReference(entry.node);
        const span = (0, _objectSpread._)({
            textSpan: documentSpan.textSpan,
            kind: writeAccess ? "writtenReference" /* writtenReference */  : "reference" /* reference */ ,
            isInString: entry.kind === 2 /* StringLiteral */  ? true : void 0
        }, documentSpan.contextSpan && {
            contextSpan: documentSpan.contextSpan
        });
        return {
            fileName: documentSpan.fileName,
            span
        };
    }
    function getTextSpan(node, sourceFile, endNode2) {
        let start = node.getStart(sourceFile);
        let end = (endNode2 || node).getEnd();
        if (isStringLiteralLike(node) && end - start > 2) {
            Debug.assert(endNode2 === void 0);
            start += 1;
            end -= 1;
        }
        if ((endNode2 == null ? void 0 : endNode2.kind) === 270 /* CaseBlock */ ) end = endNode2.getFullStart();
        return createTextSpanFromBounds(start, end);
    }
    function getTextSpanOfEntry(entry) {
        return entry.kind === 0 /* Span */  ? entry.textSpan : getTextSpan(entry.node, entry.node.getSourceFile());
    }
    function isWriteAccessForReference(node) {
        const decl = getDeclarationFromName(node);
        return !!decl && declarationIsWriteAccess(decl) || node.kind === 90 /* DefaultKeyword */  || isWriteAccess(node);
    }
    function isDeclarationOfSymbol(node, target) {
        var _a;
        if (!target) return false;
        const source = getDeclarationFromName(node) || (node.kind === 90 /* DefaultKeyword */  ? node.parent : isLiteralComputedPropertyDeclarationName(node) ? node.parent.parent : node.kind === 137 /* ConstructorKeyword */  && isConstructorDeclaration(node.parent) ? node.parent.parent : void 0);
        const commonjsSource = source && isBinaryExpression(source) ? source.left : void 0;
        return !!(source && ((_a = target.declarations) == null ? void 0 : _a.some((d)=>d === source || d === commonjsSource)));
    }
    function declarationIsWriteAccess(decl) {
        if (!!(decl.flags & 33554432 /* Ambient */ )) return true;
        switch(decl.kind){
            case 227 /* BinaryExpression */ :
            case 209 /* BindingElement */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 90 /* DefaultKeyword */ :
            case 267 /* EnumDeclaration */ :
            case 307 /* EnumMember */ :
            case 282 /* ExportSpecifier */ :
            case 274 /* ImportClause */ :
            // default import
            case 272 /* ImportEqualsDeclaration */ :
            case 277 /* ImportSpecifier */ :
            case 265 /* InterfaceDeclaration */ :
            case 339 /* JSDocCallbackTag */ :
            case 347 /* JSDocTypedefTag */ :
            case 292 /* JsxAttribute */ :
            case 268 /* ModuleDeclaration */ :
            case 271 /* NamespaceExportDeclaration */ :
            case 275 /* NamespaceImport */ :
            case 281 /* NamespaceExport */ :
            case 170 /* Parameter */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 266 /* TypeAliasDeclaration */ :
            case 169 /* TypeParameter */ :
                return true;
            case 304 /* PropertyAssignment */ :
                return !isArrayLiteralOrObjectLiteralDestructuringPattern(decl.parent);
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 177 /* Constructor */ :
            case 175 /* MethodDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                return !!decl.body;
            case 261 /* VariableDeclaration */ :
            case 173 /* PropertyDeclaration */ :
                return !!decl.initializer || isCatchClause(decl.parent);
            case 174 /* MethodSignature */ :
            case 172 /* PropertySignature */ :
            case 349 /* JSDocPropertyTag */ :
            case 342 /* JSDocParameterTag */ :
                return false;
            default:
                return Debug.failBadSyntaxKind(decl);
        }
    }
    var Core;
    ((Core2)=>{
        function getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options = {}, sourceFilesSet = new Set(sourceFiles.map((f)=>f.fileName))) {
            var _a, _b;
            node = getAdjustedNode2(node, options);
            if (isSourceFile(node)) {
                const resolvedRef = ts_GoToDefinition_exports.getReferenceAtPosition(node, position, program);
                if (!(resolvedRef == null ? void 0 : resolvedRef.file)) return void 0;
                const moduleSymbol = program.getTypeChecker().getMergedSymbol(resolvedRef.file.symbol);
                if (moduleSymbol) return getReferencedSymbolsForModule(program, moduleSymbol, /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet);
                const fileIncludeReasons = program.getFileIncludeReasons();
                if (!fileIncludeReasons) return void 0;
                return [
                    {
                        definition: {
                            type: 5 /* TripleSlashReference */ ,
                            reference: resolvedRef.reference,
                            file: node
                        },
                        references: getReferencesForNonModule(resolvedRef.file, fileIncludeReasons, program) || emptyArray
                    }
                ];
            }
            if (!options.implementations) {
                const special = getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken);
                if (special) return special;
            }
            const checker = program.getTypeChecker();
            const symbol = checker.getSymbolAtLocation(isConstructorDeclaration(node) && node.parent.name || node);
            if (!symbol) {
                if (!options.implementations && isStringLiteralLike(node)) {
                    if (isModuleSpecifierLike(node)) {
                        const fileIncludeReasons = program.getFileIncludeReasons();
                        const referencedFileName = (_b = (_a = program.getResolvedModuleFromModuleSpecifier(node)) == null ? void 0 : _a.resolvedModule) == null ? void 0 : _b.resolvedFileName;
                        const referencedFile = referencedFileName ? program.getSourceFile(referencedFileName) : void 0;
                        if (referencedFile) return [
                            {
                                definition: {
                                    type: 4 /* String */ ,
                                    node
                                },
                                references: getReferencesForNonModule(referencedFile, fileIncludeReasons, program) || emptyArray
                            }
                        ];
                    }
                    return getReferencesForStringLiteral(node, sourceFiles, checker, cancellationToken);
                }
                return void 0;
            }
            if (symbol.escapedName === "export=" /* ExportEquals */ ) return getReferencedSymbolsForModule(program, symbol.parent, /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet);
            const moduleReferences = getReferencedSymbolsForModuleIfDeclaredBySourceFile(symbol, program, sourceFiles, cancellationToken, options, sourceFilesSet);
            if (moduleReferences && !(symbol.flags & 33554432 /* Transient */ )) return moduleReferences;
            const aliasedSymbol = getMergedAliasedSymbolOfNamespaceExportDeclaration(node, symbol, checker);
            const moduleReferencesOfExportTarget = aliasedSymbol && getReferencedSymbolsForModuleIfDeclaredBySourceFile(aliasedSymbol, program, sourceFiles, cancellationToken, options, sourceFilesSet);
            const references = getReferencedSymbolsForSymbol(symbol, node, sourceFiles, sourceFilesSet, checker, cancellationToken, options);
            return mergeReferences(program, moduleReferences, references, moduleReferencesOfExportTarget);
        }
        Core2.getReferencedSymbolsForNode = getReferencedSymbolsForNode;
        function getAdjustedNode2(node, options) {
            if (options.use === 1 /* References */ ) node = getAdjustedReferenceLocation(node);
            else if (options.use === 2 /* Rename */ ) node = getAdjustedRenameLocation(node);
            return node;
        }
        Core2.getAdjustedNode = getAdjustedNode2;
        function getReferencesForFileName(fileName, program, sourceFiles, sourceFilesSet = new Set(sourceFiles.map((f)=>f.fileName))) {
            var _a, _b;
            const moduleSymbol = (_a = program.getSourceFile(fileName)) == null ? void 0 : _a.symbol;
            if (moduleSymbol) return ((_b = getReferencedSymbolsForModule(program, moduleSymbol, /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet)[0]) == null ? void 0 : _b.references) || emptyArray;
            const fileIncludeReasons = program.getFileIncludeReasons();
            const referencedFile = program.getSourceFile(fileName);
            return referencedFile && fileIncludeReasons && getReferencesForNonModule(referencedFile, fileIncludeReasons, program) || emptyArray;
        }
        Core2.getReferencesForFileName = getReferencesForFileName;
        function getReferencesForNonModule(referencedFile, refFileMap, program) {
            let entries;
            const references = refFileMap.get(referencedFile.path) || emptyArray;
            for (const ref of references)if (isReferencedFile(ref)) {
                const referencingFile = program.getSourceFileByPath(ref.file);
                const location = getReferencedFileLocation(program, ref);
                if (isReferenceFileLocation(location)) entries = append(entries, {
                    kind: 0 /* Span */ ,
                    fileName: referencingFile.fileName,
                    textSpan: createTextSpanFromRange(location)
                });
            }
            return entries;
        }
        function getMergedAliasedSymbolOfNamespaceExportDeclaration(node, symbol, checker) {
            if (node.parent && isNamespaceExportDeclaration(node.parent)) {
                const aliasedSymbol = checker.getAliasedSymbol(symbol);
                const targetSymbol = checker.getMergedSymbol(aliasedSymbol);
                if (aliasedSymbol !== targetSymbol) return targetSymbol;
            }
            return void 0;
        }
        function getReferencedSymbolsForModuleIfDeclaredBySourceFile(symbol, program, sourceFiles, cancellationToken, options, sourceFilesSet) {
            const moduleSourceFile = symbol.flags & 1536 /* Module */  && symbol.declarations && find(symbol.declarations, isSourceFile);
            if (!moduleSourceFile) return void 0;
            const exportEquals = symbol.exports.get("export=" /* ExportEquals */ );
            const moduleReferences = getReferencedSymbolsForModule(program, symbol, !!exportEquals, sourceFiles, sourceFilesSet);
            if (!exportEquals || !sourceFilesSet.has(moduleSourceFile.fileName)) return moduleReferences;
            const checker = program.getTypeChecker();
            symbol = skipAlias(exportEquals, checker);
            return mergeReferences(program, moduleReferences, getReferencedSymbolsForSymbol(symbol, /*node*/ void 0, sourceFiles, sourceFilesSet, checker, cancellationToken, options));
        }
        function mergeReferences(program, ...referencesToMerge) {
            let result;
            for (const references of referencesToMerge){
                if (!references || !references.length) continue;
                if (!result) {
                    result = references;
                    continue;
                }
                for (const entry of references){
                    if (!entry.definition || entry.definition.type !== 0 /* Symbol */ ) {
                        result.push(entry);
                        continue;
                    }
                    const symbol = entry.definition.symbol;
                    const refIndex = findIndex(result, (ref)=>!!ref.definition && ref.definition.type === 0 /* Symbol */  && ref.definition.symbol === symbol);
                    if (refIndex === -1) {
                        result.push(entry);
                        continue;
                    }
                    const reference = result[refIndex];
                    result[refIndex] = {
                        definition: reference.definition,
                        references: reference.references.concat(entry.references).sort((entry1, entry2)=>{
                            const entry1File = getSourceFileIndexOfEntry(program, entry1);
                            const entry2File = getSourceFileIndexOfEntry(program, entry2);
                            if (entry1File !== entry2File) return compareValues(entry1File, entry2File);
                            const entry1Span = getTextSpanOfEntry(entry1);
                            const entry2Span = getTextSpanOfEntry(entry2);
                            return entry1Span.start !== entry2Span.start ? compareValues(entry1Span.start, entry2Span.start) : compareValues(entry1Span.length, entry2Span.length);
                        })
                    };
                }
            }
            return result;
        }
        function getSourceFileIndexOfEntry(program, entry) {
            const sourceFile = entry.kind === 0 /* Span */  ? program.getSourceFile(entry.fileName) : entry.node.getSourceFile();
            return program.getSourceFiles().indexOf(sourceFile);
        }
        function getReferencedSymbolsForModule(program, symbol, excludeImportTypeOfExportEquals, sourceFiles, sourceFilesSet) {
            Debug.assert(!!symbol.valueDeclaration);
            const references = mapDefined(findModuleReferences(program, sourceFiles, symbol), (reference)=>{
                if (reference.kind === "import") {
                    const parent2 = reference.literal.parent;
                    if (isLiteralTypeNode(parent2)) {
                        const importType = cast(parent2.parent, isImportTypeNode);
                        if (excludeImportTypeOfExportEquals && !importType.qualifier) return void 0;
                    }
                    return nodeEntry(reference.literal);
                } else if (reference.kind === "implicit") {
                    const range = reference.literal.text !== externalHelpersModuleNameText && forEachChildRecursively(reference.referencingFile, (n)=>!(n.transformFlags & 2 /* ContainsJsx */ ) ? "skip" : isJsxElement(n) || isJsxSelfClosingElement(n) || isJsxFragment(n) ? n : void 0) || reference.referencingFile.statements[0] || reference.referencingFile;
                    return nodeEntry(range);
                } else return {
                    kind: 0 /* Span */ ,
                    fileName: reference.referencingFile.fileName,
                    textSpan: createTextSpanFromRange(reference.ref)
                };
            });
            if (symbol.declarations) for (const decl of symbol.declarations)switch(decl.kind){
                case 308 /* SourceFile */ :
                    break;
                case 268 /* ModuleDeclaration */ :
                    if (sourceFilesSet.has(decl.getSourceFile().fileName)) references.push(nodeEntry(decl.name));
                    break;
                default:
                    Debug.assert(!!(symbol.flags & 33554432 /* Transient */ ), "Expected a module symbol to be declared by a SourceFile or ModuleDeclaration.");
            }
            const exported = symbol.exports.get("export=" /* ExportEquals */ );
            if (exported == null ? void 0 : exported.declarations) for (const decl of exported.declarations){
                const sourceFile = decl.getSourceFile();
                if (sourceFilesSet.has(sourceFile.fileName)) {
                    const node = isBinaryExpression(decl) && isPropertyAccessExpression(decl.left) ? decl.left.expression : isExportAssignment(decl) ? Debug.checkDefined(findChildOfKind(decl, 95 /* ExportKeyword */ , sourceFile)) : getNameOfDeclaration(decl) || decl;
                    references.push(nodeEntry(node));
                }
            }
            return references.length ? [
                {
                    definition: {
                        type: 0 /* Symbol */ ,
                        symbol
                    },
                    references
                }
            ] : emptyArray;
        }
        function isReadonlyTypeOperator(node) {
            return node.kind === 148 /* ReadonlyKeyword */  && isTypeOperatorNode(node.parent) && node.parent.operator === 148 /* ReadonlyKeyword */ ;
        }
        function getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken) {
            if (isTypeKeyword(node.kind)) {
                if (node.kind === 116 /* VoidKeyword */  && isVoidExpression(node.parent)) return void 0;
                if (node.kind === 148 /* ReadonlyKeyword */  && !isReadonlyTypeOperator(node)) return void 0;
                return getAllReferencesForKeyword(sourceFiles, node.kind, cancellationToken, node.kind === 148 /* ReadonlyKeyword */  ? isReadonlyTypeOperator : void 0);
            }
            if (isImportMeta(node.parent) && node.parent.name === node) return getAllReferencesForImportMeta(sourceFiles, cancellationToken);
            if (isStaticModifier(node) && isClassStaticBlockDeclaration(node.parent)) return [
                {
                    definition: {
                        type: 2 /* Keyword */ ,
                        node
                    },
                    references: [
                        nodeEntry(node)
                    ]
                }
            ];
            if (isJumpStatementTarget(node)) {
                const labelDefinition = getTargetLabel(node.parent, node.text);
                return labelDefinition && getLabelReferencesInNode(labelDefinition.parent, labelDefinition);
            } else if (isLabelOfLabeledStatement(node)) return getLabelReferencesInNode(node.parent, node);
            if (isThis(node)) return getReferencesForThisKeyword(node, sourceFiles, cancellationToken);
            if (node.kind === 108 /* SuperKeyword */ ) return getReferencesForSuperKeyword(node);
            return void 0;
        }
        function getReferencedSymbolsForSymbol(originalSymbol, node, sourceFiles, sourceFilesSet, checker, cancellationToken, options) {
            const symbol = node && skipPastExportOrImportSpecifierOrUnion(originalSymbol, node, checker, /*useLocalSymbolForExportSpecifier*/ !isForRenameWithPrefixAndSuffixText(options)) || originalSymbol;
            const searchMeaning = node && options.use !== 2 /* Rename */  ? getIntersectingMeaningFromDeclarations(node, symbol) : 7 /* All */ ;
            const result = [];
            const state = new State(sourceFiles, sourceFilesSet, node ? getSpecialSearchKind(node) : 0 /* None */ , checker, cancellationToken, searchMeaning, options, result);
            const exportSpecifier = !isForRenameWithPrefixAndSuffixText(options) || !symbol.declarations ? void 0 : find(symbol.declarations, isExportSpecifier);
            if (exportSpecifier) getReferencesAtExportSpecifier(exportSpecifier.name, symbol, exportSpecifier, state.createSearch(node, originalSymbol, /*comingFrom*/ void 0), state, /*addReferencesHere*/ true, /*alwaysGetReferences*/ true);
            else if (node && node.kind === 90 /* DefaultKeyword */  && symbol.escapedName === "default" /* Default */  && symbol.parent) {
                addReference(node, symbol, state);
                searchForImportsOfExport(node, symbol, {
                    exportingModuleSymbol: symbol.parent,
                    exportKind: 1 /* Default */ 
                }, state);
            } else {
                const search = state.createSearch(node, symbol, /*comingFrom*/ void 0, {
                    allSearchSymbols: node ? populateSearchSymbolSet(symbol, node, checker, options.use === 2 /* Rename */ , !!options.providePrefixAndSuffixTextForRename, !!options.implementations) : [
                        symbol
                    ]
                });
                getReferencesInContainerOrFiles(symbol, state, search);
            }
            return result;
        }
        function getReferencesInContainerOrFiles(symbol, state, search) {
            const scope = getSymbolScope(symbol);
            if (scope) getReferencesInContainer(scope, scope.getSourceFile(), search, state, /*addReferencesHere*/ !(isSourceFile(scope) && !contains(state.sourceFiles, scope)));
            else for (const sourceFile of state.sourceFiles){
                state.cancellationToken.throwIfCancellationRequested();
                searchForName(sourceFile, search, state);
            }
        }
        function getSpecialSearchKind(node) {
            switch(node.kind){
                case 177 /* Constructor */ :
                case 137 /* ConstructorKeyword */ :
                    return 1 /* Constructor */ ;
                case 80 /* Identifier */ :
                    if (isClassLike(node.parent)) {
                        Debug.assert(node.parent.name === node);
                        return 2 /* Class */ ;
                    }
                // falls through
                default:
                    return 0 /* None */ ;
            }
        }
        function skipPastExportOrImportSpecifierOrUnion(symbol, node, checker, useLocalSymbolForExportSpecifier) {
            const { parent: parent2 } = node;
            if (isExportSpecifier(parent2) && useLocalSymbolForExportSpecifier) return getLocalSymbolForExportSpecifier(node, symbol, parent2, checker);
            return firstDefined(symbol.declarations, (decl)=>{
                if (!decl.parent) {
                    if (symbol.flags & 33554432 /* Transient */ ) return void 0;
                    Debug.fail(`Unexpected symbol at ${Debug.formatSyntaxKind(node.kind)}: ${Debug.formatSymbol(symbol)}`);
                }
                return isTypeLiteralNode(decl.parent) && isUnionTypeNode(decl.parent.parent) ? checker.getPropertyOfType(checker.getTypeFromTypeNode(decl.parent.parent), symbol.name) : void 0;
            });
        }
        let SpecialSearchKind;
        ((SpecialSearchKind2)=>{
            SpecialSearchKind2[SpecialSearchKind2["None"] = 0] = "None";
            SpecialSearchKind2[SpecialSearchKind2["Constructor"] = 1] = "Constructor";
            SpecialSearchKind2[SpecialSearchKind2["Class"] = 2] = "Class";
        })(SpecialSearchKind || (SpecialSearchKind = {}));
        function getNonModuleSymbolOfMergedModuleSymbol(symbol) {
            if (!(symbol.flags & 33555968 /* Transient */ )) return void 0;
            const decl = symbol.declarations && find(symbol.declarations, (d)=>!isSourceFile(d) && !isModuleDeclaration(d));
            return decl && decl.symbol;
        }
        class State {
            includesSourceFile(sourceFile) {
                return this.sourceFilesSet.has(sourceFile.fileName);
            }
            /** Gets every place to look for references of an exported symbols. See `ImportsResult` in `importTracker.ts` for more documentation. */ getImportSearches(exportSymbol, exportInfo) {
                if (!this.importTracker) this.importTracker = createImportTracker(this.sourceFiles, this.sourceFilesSet, this.checker, this.cancellationToken);
                return this.importTracker(exportSymbol, exportInfo, this.options.use === 2 /* Rename */ );
            }
            /** @param allSearchSymbols set of additional symbols for use by `includes`. */ createSearch(location, symbol, comingFrom, searchOptions = {}) {
                const { text = stripQuotes(symbolName(getLocalSymbolForExportDefault(symbol) || getNonModuleSymbolOfMergedModuleSymbol(symbol) || symbol)), allSearchSymbols = [
                    symbol
                ] } = searchOptions;
                const escapedText = escapeLeadingUnderscores(text);
                const parents = this.options.implementations && location ? getParentSymbolsOfPropertyAccess(location, symbol, this.checker) : void 0;
                return {
                    symbol,
                    comingFrom,
                    text,
                    escapedText,
                    parents,
                    allSearchSymbols,
                    includes: (sym)=>contains(allSearchSymbols, sym)
                };
            }
            /**
     * Callback to add references for a particular searched symbol.
     * This initializes a reference group, so only call this if you will add at least one reference.
     */ referenceAdder(searchSymbol) {
                const symbolId = getSymbolId(searchSymbol);
                let references = this.symbolIdToReferences[symbolId];
                if (!references) {
                    references = this.symbolIdToReferences[symbolId] = [];
                    this.result.push({
                        definition: {
                            type: 0 /* Symbol */ ,
                            symbol: searchSymbol
                        },
                        references
                    });
                }
                return (node, kind)=>references.push(nodeEntry(node, kind));
            }
            /** Add a reference with no associated definition. */ addStringOrCommentReference(fileName, textSpan) {
                this.result.push({
                    definition: void 0,
                    references: [
                        {
                            kind: 0 /* Span */ ,
                            fileName,
                            textSpan
                        }
                    ]
                });
            }
            /** Returns `true` the first time we search for a symbol in a file and `false` afterwards. */ markSearchedSymbols(sourceFile, symbols) {
                const sourceId = getNodeId(sourceFile);
                const seenSymbols = this.sourceFileToSeenSymbols[sourceId] || (this.sourceFileToSeenSymbols[sourceId] = /* @__PURE__ */ new Set());
                let anyNewSymbols = false;
                for (const sym of symbols)anyNewSymbols = tryAddToSet(seenSymbols, getSymbolId(sym)) || anyNewSymbols;
                return anyNewSymbols;
            }
            constructor(sourceFiles, sourceFilesSet, specialSearchKind, checker, cancellationToken, searchMeaning, options, result){
                this.sourceFiles = sourceFiles;
                this.sourceFilesSet = sourceFilesSet;
                this.specialSearchKind = specialSearchKind;
                this.checker = checker;
                this.cancellationToken = cancellationToken;
                this.searchMeaning = searchMeaning;
                this.options = options;
                this.result = result;
                /** Cache for `explicitlyinheritsFrom`. */ this.inheritsFromCache = /* @__PURE__ */ new Map();
                /**
       * Type nodes can contain multiple references to the same type. For example:
       *      let x: Foo & (Foo & Bar) = ...
       * Because we are returning the implementation locations and not the identifier locations,
       * duplicate entries would be returned here as each of the type references is part of
       * the same implementation. For that reason, check before we add a new entry.
       */ this.markSeenContainingTypeReference = nodeSeenTracker();
                /**
       * It's possible that we will encounter the right side of `export { foo as bar } from "x";` more than once.
       * For example:
       *     // b.ts
       *     export { foo as bar } from "./a";
       *     import { bar } from "./b";
       *
       * Normally at `foo as bar` we directly add `foo` and do not locally search for it (since it doesn't declare a local).
       * But another reference to it may appear in the same source file.
       * See `tests/cases/fourslash/transitiveExportImports3.ts`.
       */ this.markSeenReExportRHS = nodeSeenTracker();
                this.symbolIdToReferences = [];
                // Source file ID -> symbol ID -> Whether the symbol has been searched for in the source file.
                this.sourceFileToSeenSymbols = [];
            }
        }
        function searchForImportsOfExport(exportLocation, exportSymbol, exportInfo, state) {
            const { importSearches, singleReferences, indirectUsers } = state.getImportSearches(exportSymbol, exportInfo);
            if (singleReferences.length) {
                const addRef = state.referenceAdder(exportSymbol);
                for (const singleRef of singleReferences)if (shouldAddSingleReference(singleRef, state)) addRef(singleRef);
            }
            for (const [importLocation, importSymbol] of importSearches)getReferencesInSourceFile(importLocation.getSourceFile(), state.createSearch(importLocation, importSymbol, 1 /* Export */ ), state);
            if (indirectUsers.length) {
                let indirectSearch;
                switch(exportInfo.exportKind){
                    case 0 /* Named */ :
                        indirectSearch = state.createSearch(exportLocation, exportSymbol, 1 /* Export */ );
                        break;
                    case 1 /* Default */ :
                        indirectSearch = state.options.use === 2 /* Rename */  ? void 0 : state.createSearch(exportLocation, exportSymbol, 1 /* Export */ , {
                            text: "default"
                        });
                        break;
                    case 2 /* ExportEquals */ :
                        break;
                }
                if (indirectSearch) for (const indirectUser of indirectUsers)searchForName(indirectUser, indirectSearch, state);
            }
        }
        function eachExportReference(sourceFiles, checker, cancellationToken, exportSymbol, exportingModuleSymbol, exportName, isDefaultExport, cb) {
            const importTracker = createImportTracker(sourceFiles, new Set(sourceFiles.map((f)=>f.fileName)), checker, cancellationToken);
            const { importSearches, indirectUsers, singleReferences } = importTracker(exportSymbol, {
                exportKind: isDefaultExport ? 1 /* Default */  : 0 /* Named */ ,
                exportingModuleSymbol
            }, /*isForRename*/ false);
            for (const [importLocation] of importSearches)cb(importLocation);
            for (const singleReference of singleReferences)if (isIdentifier(singleReference) && isImportTypeNode(singleReference.parent)) cb(singleReference);
            for (const indirectUser of indirectUsers)for (const node of getPossibleSymbolReferenceNodes(indirectUser, isDefaultExport ? "default" : exportName)){
                const symbol = checker.getSymbolAtLocation(node);
                const hasExportAssignmentDeclaration = some(symbol == null ? void 0 : symbol.declarations, (d)=>tryCast(d, isExportAssignment) ? true : false);
                if (isIdentifier(node) && !isImportOrExportSpecifier(node.parent) && (symbol === exportSymbol || hasExportAssignmentDeclaration)) cb(node);
            }
        }
        Core2.eachExportReference = eachExportReference;
        function shouldAddSingleReference(singleRef, state) {
            if (!hasMatchingMeaning(singleRef, state)) return false;
            if (state.options.use !== 2 /* Rename */ ) return true;
            if (!isIdentifier(singleRef) && !isImportOrExportSpecifier(singleRef.parent)) return false;
            return !(isImportOrExportSpecifier(singleRef.parent) && moduleExportNameIsDefault(singleRef));
        }
        function searchForImportedSymbol(symbol, state) {
            if (!symbol.declarations) return;
            for (const declaration of symbol.declarations){
                const exportingFile = declaration.getSourceFile();
                getReferencesInSourceFile(exportingFile, state.createSearch(declaration, symbol, 0 /* Import */ ), state, state.includesSourceFile(exportingFile));
            }
        }
        function searchForName(sourceFile, search, state) {
            if (getNameTable(sourceFile).get(search.escapedText) !== void 0) getReferencesInSourceFile(sourceFile, search, state);
        }
        function getPropertySymbolOfDestructuringAssignment(location, checker) {
            return isArrayLiteralOrObjectLiteralDestructuringPattern(location.parent.parent) ? checker.getPropertySymbolOfDestructuringAssignment(location) : void 0;
        }
        function getSymbolScope(symbol) {
            const { declarations, flags, parent: parent2, valueDeclaration } = symbol;
            if (valueDeclaration && (valueDeclaration.kind === 219 /* FunctionExpression */  || valueDeclaration.kind === 232 /* ClassExpression */ )) return valueDeclaration;
            if (!declarations) return void 0;
            if (flags & 8196 /* Method */ ) {
                const privateDeclaration = find(declarations, (d)=>hasEffectiveModifier(d, 2 /* Private */ ) || isPrivateIdentifierClassElementDeclaration(d));
                if (privateDeclaration) return getAncestor(privateDeclaration, 264 /* ClassDeclaration */ );
                return void 0;
            }
            if (declarations.some(isObjectBindingElementWithoutPropertyName)) return void 0;
            const exposedByParent = parent2 && !(symbol.flags & 262144 /* TypeParameter */ );
            if (exposedByParent && !(isExternalModuleSymbol(parent2) && !parent2.globalExports)) return void 0;
            let scope;
            for (const declaration of declarations){
                const container = getContainerNode(declaration);
                if (scope && scope !== container) return void 0;
                if (!container || container.kind === 308 /* SourceFile */  && !isExternalOrCommonJsModule(container)) return void 0;
                scope = container;
                if (isFunctionExpression(scope)) {
                    let next;
                    while(next = getNextJSDocCommentLocation(scope))scope = next;
                }
            }
            return exposedByParent ? scope.getSourceFile() : scope;
        }
        function isSymbolReferencedInFile(definition, checker, sourceFile, searchContainer = sourceFile) {
            return eachSymbolReferenceInFile(definition, checker, sourceFile, ()=>true, searchContainer) || false;
        }
        Core2.isSymbolReferencedInFile = isSymbolReferencedInFile;
        function eachSymbolReferenceInFile(definition, checker, sourceFile, cb, searchContainer = sourceFile) {
            const symbol = isParameterPropertyDeclaration(definition.parent, definition.parent.parent) ? first(checker.getSymbolsOfParameterPropertyDeclaration(definition.parent, definition.text)) : checker.getSymbolAtLocation(definition);
            if (!symbol) return void 0;
            for (const token of getPossibleSymbolReferenceNodes(sourceFile, symbol.name, searchContainer)){
                if (!isIdentifier(token) || token === definition || token.escapedText !== definition.escapedText) continue;
                const referenceSymbol = checker.getSymbolAtLocation(token);
                if (referenceSymbol === symbol || checker.getShorthandAssignmentValueSymbol(token.parent) === symbol || isExportSpecifier(token.parent) && getLocalSymbolForExportSpecifier(token, referenceSymbol, token.parent, checker) === symbol) {
                    const res = cb(token);
                    if (res) return res;
                }
            }
        }
        Core2.eachSymbolReferenceInFile = eachSymbolReferenceInFile;
        function getTopMostDeclarationNamesInFile(declarationName, sourceFile) {
            const candidates = filter(getPossibleSymbolReferenceNodes(sourceFile, declarationName), (name)=>!!getDeclarationFromName(name));
            return candidates.reduce((topMost, decl)=>{
                const depth = getDepth(decl);
                if (!some(topMost.declarationNames) || depth === topMost.depth) {
                    topMost.declarationNames.push(decl);
                    topMost.depth = depth;
                } else if (depth < topMost.depth) {
                    topMost.declarationNames = [
                        decl
                    ];
                    topMost.depth = depth;
                }
                return topMost;
            }, {
                depth: Infinity,
                declarationNames: []
            }).declarationNames;
            function getDepth(declaration) {
                let depth = 0;
                while(declaration){
                    declaration = getContainerNode(declaration);
                    depth++;
                }
                return depth;
            }
        }
        Core2.getTopMostDeclarationNamesInFile = getTopMostDeclarationNamesInFile;
        function someSignatureUsage(signature, sourceFiles, checker, cb) {
            if (!signature.name || !isIdentifier(signature.name)) return false;
            const symbol = Debug.checkDefined(checker.getSymbolAtLocation(signature.name));
            for (const sourceFile of sourceFiles)for (const name of getPossibleSymbolReferenceNodes(sourceFile, symbol.name)){
                if (!isIdentifier(name) || name === signature.name || name.escapedText !== signature.name.escapedText) continue;
                const called = climbPastPropertyAccess(name);
                const call = isCallExpression(called.parent) && called.parent.expression === called ? called.parent : void 0;
                const referenceSymbol = checker.getSymbolAtLocation(name);
                if (referenceSymbol && checker.getRootSymbols(referenceSymbol).some((s)=>s === symbol)) {
                    if (cb(name, call)) return true;
                }
            }
            return false;
        }
        Core2.someSignatureUsage = someSignatureUsage;
        function getPossibleSymbolReferenceNodes(sourceFile, symbolName2, container = sourceFile) {
            return mapDefined(getPossibleSymbolReferencePositions(sourceFile, symbolName2, container), (pos)=>{
                const referenceLocation = getTouchingPropertyName(sourceFile, pos);
                return referenceLocation === sourceFile ? void 0 : referenceLocation;
            });
        }
        function getPossibleSymbolReferencePositions(sourceFile, symbolName2, container = sourceFile) {
            const positions = [];
            if (!symbolName2 || !symbolName2.length) return positions;
            const text = sourceFile.text;
            const sourceLength = text.length;
            const symbolNameLength = symbolName2.length;
            let position = text.indexOf(symbolName2, container.pos);
            while(position >= 0){
                if (position > container.end) break;
                const endPosition = position + symbolNameLength;
                if ((position === 0 || !isIdentifierPart(text.charCodeAt(position - 1), 99 /* Latest */ )) && (endPosition === sourceLength || !isIdentifierPart(text.charCodeAt(endPosition), 99 /* Latest */ ))) positions.push(position);
                position = text.indexOf(symbolName2, position + symbolNameLength + 1);
            }
            return positions;
        }
        function getLabelReferencesInNode(container, targetLabel) {
            const sourceFile = container.getSourceFile();
            const labelName = targetLabel.text;
            const references = mapDefined(getPossibleSymbolReferenceNodes(sourceFile, labelName, container), (node)=>// Only pick labels that are either the target label, or have a target that is the target label
                node === targetLabel || isJumpStatementTarget(node) && getTargetLabel(node, labelName) === targetLabel ? nodeEntry(node) : void 0);
            return [
                {
                    definition: {
                        type: 1 /* Label */ ,
                        node: targetLabel
                    },
                    references
                }
            ];
        }
        function isValidReferencePosition(node, searchSymbolName) {
            switch(node.kind){
                case 81 /* PrivateIdentifier */ :
                    if (isJSDocMemberName(node.parent)) return true;
                // falls through I guess
                case 80 /* Identifier */ :
                    return node.text.length === searchSymbolName.length;
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 11 /* StringLiteral */ :
                    {
                        const str = node;
                        return str.text.length === searchSymbolName.length && (isLiteralNameOfPropertyDeclarationOrIndexAccess(str) || isNameOfModuleDeclaration(node) || isExpressionOfExternalModuleImportEqualsDeclaration(node) || isCallExpression(node.parent) && isBindableObjectDefinePropertyCall(node.parent) && node.parent.arguments[1] === node || isImportOrExportSpecifier(node.parent));
                    }
                case 9 /* NumericLiteral */ :
                    return isLiteralNameOfPropertyDeclarationOrIndexAccess(node) && node.text.length === searchSymbolName.length;
                case 90 /* DefaultKeyword */ :
                    return 7 === searchSymbolName.length;
                default:
                    return false;
            }
        }
        function getAllReferencesForImportMeta(sourceFiles, cancellationToken) {
            const references = flatMap(sourceFiles, (sourceFile)=>{
                cancellationToken.throwIfCancellationRequested();
                return mapDefined(getPossibleSymbolReferenceNodes(sourceFile, "meta", sourceFile), (node)=>{
                    const parent2 = node.parent;
                    if (isImportMeta(parent2)) return nodeEntry(parent2);
                });
            });
            return references.length ? [
                {
                    definition: {
                        type: 2 /* Keyword */ ,
                        node: references[0].node
                    },
                    references
                }
            ] : void 0;
        }
        function getAllReferencesForKeyword(sourceFiles, keywordKind, cancellationToken, filter2) {
            const references = flatMap(sourceFiles, (sourceFile)=>{
                cancellationToken.throwIfCancellationRequested();
                return mapDefined(getPossibleSymbolReferenceNodes(sourceFile, tokenToString(keywordKind), sourceFile), (referenceLocation)=>{
                    if (referenceLocation.kind === keywordKind && (!filter2 || filter2(referenceLocation))) return nodeEntry(referenceLocation);
                });
            });
            return references.length ? [
                {
                    definition: {
                        type: 2 /* Keyword */ ,
                        node: references[0].node
                    },
                    references
                }
            ] : void 0;
        }
        function getReferencesInSourceFile(sourceFile, search, state, addReferencesHere = true) {
            state.cancellationToken.throwIfCancellationRequested();
            return getReferencesInContainer(sourceFile, sourceFile, search, state, addReferencesHere);
        }
        function getReferencesInContainer(container, sourceFile, search, state, addReferencesHere) {
            if (!state.markSearchedSymbols(sourceFile, search.allSearchSymbols)) return;
            for (const position of getPossibleSymbolReferencePositions(sourceFile, search.text, container))getReferencesAtLocation(sourceFile, position, search, state, addReferencesHere);
        }
        function hasMatchingMeaning(referenceLocation, state) {
            return !!(getMeaningFromLocation(referenceLocation) & state.searchMeaning);
        }
        function getReferencesAtLocation(sourceFile, position, search, state, addReferencesHere) {
            const referenceLocation = getTouchingPropertyName(sourceFile, position);
            if (!isValidReferencePosition(referenceLocation, search.text)) {
                if (!state.options.implementations && (state.options.findInStrings && isInString(sourceFile, position) || state.options.findInComments && isInNonReferenceComment(sourceFile, position))) state.addStringOrCommentReference(sourceFile.fileName, createTextSpan(position, search.text.length));
                return;
            }
            if (!hasMatchingMeaning(referenceLocation, state)) return;
            let referenceSymbol = state.checker.getSymbolAtLocation(referenceLocation);
            if (!referenceSymbol) return;
            const parent2 = referenceLocation.parent;
            if (isImportSpecifier(parent2) && parent2.propertyName === referenceLocation) return;
            if (isExportSpecifier(parent2)) {
                Debug.assert(referenceLocation.kind === 80 /* Identifier */  || referenceLocation.kind === 11 /* StringLiteral */ );
                getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, parent2, search, state, addReferencesHere);
                return;
            }
            if (isJSDocPropertyLikeTag(parent2) && parent2.isNameFirst && parent2.typeExpression && isJSDocTypeLiteral(parent2.typeExpression.type) && parent2.typeExpression.type.jsDocPropertyTags && length(parent2.typeExpression.type.jsDocPropertyTags)) {
                getReferencesAtJSDocTypeLiteral(parent2.typeExpression.type.jsDocPropertyTags, referenceLocation, search, state);
                return;
            }
            const relatedSymbol = getRelatedSymbol(search, referenceSymbol, referenceLocation, state);
            if (!relatedSymbol) {
                getReferenceForShorthandProperty(referenceSymbol, search, state);
                return;
            }
            switch(state.specialSearchKind){
                case 0 /* None */ :
                    if (addReferencesHere) addReference(referenceLocation, relatedSymbol, state);
                    break;
                case 1 /* Constructor */ :
                    addConstructorReferences(referenceLocation, sourceFile, search, state);
                    break;
                case 2 /* Class */ :
                    addClassStaticThisReferences(referenceLocation, search, state);
                    break;
                default:
                    Debug.assertNever(state.specialSearchKind);
            }
            if (isInJSFile(referenceLocation) && isBindingElement(referenceLocation.parent) && isVariableDeclarationInitializedToBareOrAccessedRequire(referenceLocation.parent.parent.parent)) {
                referenceSymbol = referenceLocation.parent.symbol;
                if (!referenceSymbol) return;
            }
            getImportOrExportReferences(referenceLocation, referenceSymbol, search, state);
        }
        function getReferencesAtJSDocTypeLiteral(jsDocPropertyTags, referenceLocation, search, state) {
            const addRef = state.referenceAdder(search.symbol);
            addReference(referenceLocation, search.symbol, state);
            forEach(jsDocPropertyTags, (propTag)=>{
                if (isQualifiedName(propTag.name)) addRef(propTag.name.left);
            });
        }
        function getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, search, state, addReferencesHere, alwaysGetReferences) {
            Debug.assert(!alwaysGetReferences || !!state.options.providePrefixAndSuffixTextForRename, "If alwaysGetReferences is true, then prefix/suffix text must be enabled");
            const { parent: parent2, propertyName, name } = exportSpecifier;
            const exportDeclaration = parent2.parent;
            const localSymbol = getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, state.checker);
            if (!alwaysGetReferences && !search.includes(localSymbol)) return;
            if (!propertyName) {
                if (!(state.options.use === 2 /* Rename */  && moduleExportNameIsDefault(name))) addRef();
            } else if (referenceLocation === propertyName) {
                if (!exportDeclaration.moduleSpecifier) addRef();
                if (addReferencesHere && state.options.use !== 2 /* Rename */  && state.markSeenReExportRHS(name)) addReference(name, Debug.checkDefined(exportSpecifier.symbol), state);
            } else if (state.markSeenReExportRHS(referenceLocation)) addRef();
            if (!isForRenameWithPrefixAndSuffixText(state.options) || alwaysGetReferences) {
                const isDefaultExport = moduleExportNameIsDefault(referenceLocation) || moduleExportNameIsDefault(exportSpecifier.name);
                const exportKind = isDefaultExport ? 1 /* Default */  : 0 /* Named */ ;
                const exportSymbol = Debug.checkDefined(exportSpecifier.symbol);
                const exportInfo = getExportInfo(exportSymbol, exportKind, state.checker);
                if (exportInfo) searchForImportsOfExport(referenceLocation, exportSymbol, exportInfo, state);
            }
            if (search.comingFrom !== 1 /* Export */  && exportDeclaration.moduleSpecifier && !propertyName && !isForRenameWithPrefixAndSuffixText(state.options)) {
                const imported = state.checker.getExportSpecifierLocalTargetSymbol(exportSpecifier);
                if (imported) searchForImportedSymbol(imported, state);
            }
            function addRef() {
                if (addReferencesHere) addReference(referenceLocation, localSymbol, state);
            }
        }
        function getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, checker) {
            return isExportSpecifierAlias(referenceLocation, exportSpecifier) && checker.getExportSpecifierLocalTargetSymbol(exportSpecifier) || referenceSymbol;
        }
        function isExportSpecifierAlias(referenceLocation, exportSpecifier) {
            const { parent: parent2, propertyName, name } = exportSpecifier;
            Debug.assert(propertyName === referenceLocation || name === referenceLocation);
            if (propertyName) return propertyName === referenceLocation;
            else return !parent2.parent.moduleSpecifier;
        }
        function getImportOrExportReferences(referenceLocation, referenceSymbol, search, state) {
            const importOrExport = getImportOrExportSymbol(referenceLocation, referenceSymbol, state.checker, search.comingFrom === 1 /* Export */ );
            if (!importOrExport) return;
            const { symbol } = importOrExport;
            if (importOrExport.kind === 0 /* Import */ ) {
                if (!isForRenameWithPrefixAndSuffixText(state.options)) searchForImportedSymbol(symbol, state);
            } else searchForImportsOfExport(referenceLocation, symbol, importOrExport.exportInfo, state);
        }
        function getReferenceForShorthandProperty({ flags, valueDeclaration }, search, state) {
            const shorthandValueSymbol = state.checker.getShorthandAssignmentValueSymbol(valueDeclaration);
            const name = valueDeclaration && getNameOfDeclaration(valueDeclaration);
            if (!(flags & 33554432 /* Transient */ ) && name && search.includes(shorthandValueSymbol)) addReference(name, shorthandValueSymbol, state);
        }
        function addReference(referenceLocation, relatedSymbol, state) {
            const { kind, symbol } = "kind" in relatedSymbol ? relatedSymbol : {
                kind: void 0,
                symbol: relatedSymbol
            };
            if (state.options.use === 2 /* Rename */  && referenceLocation.kind === 90 /* DefaultKeyword */ ) return;
            const addRef = state.referenceAdder(symbol);
            if (state.options.implementations) addImplementationReferences(referenceLocation, addRef, state);
            else addRef(referenceLocation, kind);
        }
        function addConstructorReferences(referenceLocation, sourceFile, search, state) {
            if (isNewExpressionTarget(referenceLocation)) addReference(referenceLocation, search.symbol, state);
            const pusher = ()=>state.referenceAdder(search.symbol);
            if (isClassLike(referenceLocation.parent)) {
                Debug.assert(referenceLocation.kind === 90 /* DefaultKeyword */  || referenceLocation.parent.name === referenceLocation);
                findOwnConstructorReferences(search.symbol, sourceFile, pusher());
            } else {
                const classExtending = tryGetClassByExtendingIdentifier(referenceLocation);
                if (classExtending) {
                    findSuperConstructorAccesses(classExtending, pusher());
                    findInheritedConstructorReferences(classExtending, state);
                }
            }
        }
        function addClassStaticThisReferences(referenceLocation, search, state) {
            addReference(referenceLocation, search.symbol, state);
            const classLike = referenceLocation.parent;
            if (state.options.use === 2 /* Rename */  || !isClassLike(classLike)) return;
            Debug.assert(classLike.name === referenceLocation);
            const addRef = state.referenceAdder(search.symbol);
            for (const member of classLike.members){
                if (!(isMethodOrAccessor(member) && isStatic(member))) continue;
                if (member.body) member.body.forEachChild(function cb(node) {
                    if (node.kind === 110 /* ThisKeyword */ ) addRef(node);
                    else if (!isFunctionLike(node) && !isClassLike(node)) node.forEachChild(cb);
                });
            }
        }
        function findOwnConstructorReferences(classSymbol, sourceFile, addNode) {
            const constructorSymbol = getClassConstructorSymbol(classSymbol);
            if (constructorSymbol && constructorSymbol.declarations) for (const decl of constructorSymbol.declarations){
                const ctrKeyword = findChildOfKind(decl, 137 /* ConstructorKeyword */ , sourceFile);
                Debug.assert(decl.kind === 177 /* Constructor */  && !!ctrKeyword);
                addNode(ctrKeyword);
            }
            if (classSymbol.exports) classSymbol.exports.forEach((member)=>{
                const decl = member.valueDeclaration;
                if (decl && decl.kind === 175 /* MethodDeclaration */ ) {
                    const body = decl.body;
                    if (body) forEachDescendantOfKind(body, 110 /* ThisKeyword */ , (thisKeyword)=>{
                        if (isNewExpressionTarget(thisKeyword)) addNode(thisKeyword);
                    });
                }
            });
        }
        function getClassConstructorSymbol(classSymbol) {
            return classSymbol.members && classSymbol.members.get("__constructor" /* Constructor */ );
        }
        function findSuperConstructorAccesses(classDeclaration, addNode) {
            const constructor = getClassConstructorSymbol(classDeclaration.symbol);
            if (!(constructor && constructor.declarations)) return;
            for (const decl of constructor.declarations){
                Debug.assert(decl.kind === 177 /* Constructor */ );
                const body = decl.body;
                if (body) forEachDescendantOfKind(body, 108 /* SuperKeyword */ , (node)=>{
                    if (isCallExpressionTarget(node)) addNode(node);
                });
            }
        }
        function hasOwnConstructor(classDeclaration) {
            return !!getClassConstructorSymbol(classDeclaration.symbol);
        }
        function findInheritedConstructorReferences(classDeclaration, state) {
            if (hasOwnConstructor(classDeclaration)) return;
            const classSymbol = classDeclaration.symbol;
            const search = state.createSearch(/*location*/ void 0, classSymbol, /*comingFrom*/ void 0);
            getReferencesInContainerOrFiles(classSymbol, state, search);
        }
        function addImplementationReferences(refNode, addReference2, state) {
            if (isDeclarationName(refNode) && isImplementation(refNode.parent)) {
                addReference2(refNode);
                return;
            }
            if (refNode.kind !== 80 /* Identifier */ ) return;
            if (refNode.parent.kind === 305 /* ShorthandPropertyAssignment */ ) getReferenceEntriesForShorthandPropertyAssignment(refNode, state.checker, addReference2);
            const containingNode = getContainingNodeIfInHeritageClause(refNode);
            if (containingNode) {
                addReference2(containingNode);
                return;
            }
            const typeNode = findAncestor(refNode, (a)=>!isQualifiedName(a.parent) && !isTypeNode(a.parent) && !isTypeElement(a.parent));
            const typeHavingNode = typeNode.parent;
            if (hasType(typeHavingNode) && typeHavingNode.type === typeNode && state.markSeenContainingTypeReference(typeHavingNode)) {
                if (hasInitializer(typeHavingNode)) addIfImplementation(typeHavingNode.initializer);
                else if (isFunctionLike(typeHavingNode) && typeHavingNode.body) {
                    const body = typeHavingNode.body;
                    if (body.kind === 242 /* Block */ ) forEachReturnStatement(body, (returnStatement)=>{
                        if (returnStatement.expression) addIfImplementation(returnStatement.expression);
                    });
                    else addIfImplementation(body);
                } else if (isAssertionExpression(typeHavingNode) || isSatisfiesExpression(typeHavingNode)) addIfImplementation(typeHavingNode.expression);
            }
            function addIfImplementation(e) {
                if (isImplementationExpression(e)) addReference2(e);
            }
        }
        function getContainingNodeIfInHeritageClause(node) {
            return isIdentifier(node) || isPropertyAccessExpression(node) ? getContainingNodeIfInHeritageClause(node.parent) : isExpressionWithTypeArguments(node) ? tryCast(node.parent.parent, or(isClassLike, isInterfaceDeclaration)) : void 0;
        }
        function isImplementationExpression(node) {
            switch(node.kind){
                case 218 /* ParenthesizedExpression */ :
                    return isImplementationExpression(node.expression);
                case 220 /* ArrowFunction */ :
                case 219 /* FunctionExpression */ :
                case 211 /* ObjectLiteralExpression */ :
                case 232 /* ClassExpression */ :
                case 210 /* ArrayLiteralExpression */ :
                    return true;
                default:
                    return false;
            }
        }
        function explicitlyInheritsFrom(symbol, parent2, cachedResults, checker) {
            if (symbol === parent2) return true;
            const key = getSymbolId(symbol) + "," + getSymbolId(parent2);
            const cached = cachedResults.get(key);
            if (cached !== void 0) return cached;
            cachedResults.set(key, false);
            const inherits = !!symbol.declarations && symbol.declarations.some((declaration)=>getAllSuperTypeNodes(declaration).some((typeReference)=>{
                    const type = checker.getTypeAtLocation(typeReference);
                    return !!type && !!type.symbol && explicitlyInheritsFrom(type.symbol, parent2, cachedResults, checker);
                }));
            cachedResults.set(key, inherits);
            return inherits;
        }
        function getReferencesForSuperKeyword(superKeyword) {
            let searchSpaceNode = getSuperContainer(superKeyword, /*stopOnFunctions*/ false);
            if (!searchSpaceNode) return void 0;
            let staticFlag = 256 /* Static */ ;
            switch(searchSpaceNode.kind){
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    staticFlag &= getSyntacticModifierFlags(searchSpaceNode);
                    searchSpaceNode = searchSpaceNode.parent;
                    break;
                default:
                    return void 0;
            }
            const sourceFile = searchSpaceNode.getSourceFile();
            const references = mapDefined(getPossibleSymbolReferenceNodes(sourceFile, "super", searchSpaceNode), (node)=>{
                if (node.kind !== 108 /* SuperKeyword */ ) return;
                const container = getSuperContainer(node, /*stopOnFunctions*/ false);
                return container && isStatic(container) === !!staticFlag && container.parent.symbol === searchSpaceNode.symbol ? nodeEntry(node) : void 0;
            });
            return [
                {
                    definition: {
                        type: 0 /* Symbol */ ,
                        symbol: searchSpaceNode.symbol
                    },
                    references
                }
            ];
        }
        function isParameterName(node) {
            return node.kind === 80 /* Identifier */  && node.parent.kind === 170 /* Parameter */  && node.parent.name === node;
        }
        function getReferencesForThisKeyword(thisOrSuperKeyword, sourceFiles, cancellationToken) {
            let searchSpaceNode = getThisContainer(thisOrSuperKeyword, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
            let staticFlag = 256 /* Static */ ;
            switch(searchSpaceNode.kind){
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                    if (isObjectLiteralMethod(searchSpaceNode)) {
                        staticFlag &= getSyntacticModifierFlags(searchSpaceNode);
                        searchSpaceNode = searchSpaceNode.parent;
                        break;
                    }
                // falls through
                case 173 /* PropertyDeclaration */ :
                case 172 /* PropertySignature */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    staticFlag &= getSyntacticModifierFlags(searchSpaceNode);
                    searchSpaceNode = searchSpaceNode.parent;
                    break;
                case 308 /* SourceFile */ :
                    if (isExternalModule(searchSpaceNode) || isParameterName(thisOrSuperKeyword)) return void 0;
                // falls through
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                    break;
                // Computed properties in classes are not handled here because references to this are illegal,
                // so there is no point finding references to them.
                default:
                    return void 0;
            }
            const references = flatMap(searchSpaceNode.kind === 308 /* SourceFile */  ? sourceFiles : [
                searchSpaceNode.getSourceFile()
            ], (sourceFile)=>{
                cancellationToken.throwIfCancellationRequested();
                return getPossibleSymbolReferenceNodes(sourceFile, "this", isSourceFile(searchSpaceNode) ? sourceFile : searchSpaceNode).filter((node)=>{
                    if (!isThis(node)) return false;
                    const container = getThisContainer(node, /*includeArrowFunctions*/ false, /*includeClassComputedPropertyName*/ false);
                    if (!canHaveSymbol(container)) return false;
                    switch(searchSpaceNode.kind){
                        case 219 /* FunctionExpression */ :
                        case 263 /* FunctionDeclaration */ :
                            return searchSpaceNode.symbol === container.symbol;
                        case 175 /* MethodDeclaration */ :
                        case 174 /* MethodSignature */ :
                            return isObjectLiteralMethod(searchSpaceNode) && searchSpaceNode.symbol === container.symbol;
                        case 232 /* ClassExpression */ :
                        case 264 /* ClassDeclaration */ :
                        case 211 /* ObjectLiteralExpression */ :
                            return container.parent && canHaveSymbol(container.parent) && searchSpaceNode.symbol === container.parent.symbol && isStatic(container) === !!staticFlag;
                        case 308 /* SourceFile */ :
                            return container.kind === 308 /* SourceFile */  && !isExternalModule(container) && !isParameterName(node);
                    }
                });
            }).map((n)=>nodeEntry(n));
            const thisParameter = firstDefined(references, (r)=>isParameter(r.node.parent) ? r.node : void 0);
            return [
                {
                    definition: {
                        type: 3 /* This */ ,
                        node: thisParameter || thisOrSuperKeyword
                    },
                    references
                }
            ];
        }
        function getReferencesForStringLiteral(node, sourceFiles, checker, cancellationToken) {
            const type = getContextualTypeFromParentOrAncestorTypeNode(node, checker);
            const references = flatMap(sourceFiles, (sourceFile)=>{
                cancellationToken.throwIfCancellationRequested();
                return mapDefined(getPossibleSymbolReferenceNodes(sourceFile, node.text), (ref)=>{
                    if (isStringLiteralLike(ref) && ref.text === node.text) {
                        if (type) {
                            const refType = getContextualTypeFromParentOrAncestorTypeNode(ref, checker);
                            if (type !== checker.getStringType() && (type === refType || isStringLiteralPropertyReference(ref, checker))) return nodeEntry(ref, 2 /* StringLiteral */ );
                        } else return isNoSubstitutionTemplateLiteral(ref) && !rangeIsOnSingleLine(ref, sourceFile) ? void 0 : nodeEntry(ref, 2 /* StringLiteral */ );
                    }
                });
            });
            return [
                {
                    definition: {
                        type: 4 /* String */ ,
                        node
                    },
                    references
                }
            ];
        }
        function isStringLiteralPropertyReference(node, checker) {
            if (isPropertySignature(node.parent)) return checker.getPropertyOfType(checker.getTypeAtLocation(node.parent.parent), node.text);
        }
        function populateSearchSymbolSet(symbol, location, checker, isForRename, providePrefixAndSuffixText, implementations) {
            const result = [];
            forEachRelatedSymbol(symbol, location, checker, isForRename, !(isForRename && providePrefixAndSuffixText), (sym, root, base)=>{
                if (base) {
                    if (isStaticSymbol(symbol) !== isStaticSymbol(base)) base = void 0;
                }
                result.push(base || root || sym);
            }, // when try to find implementation, implementations is true, and not allowed to find base class
            /*allowBaseTypes*/ ()=>!implementations);
            return result;
        }
        function forEachRelatedSymbol(symbol, location, checker, isForRenamePopulateSearchSymbolSet, onlyIncludeBindingElementAtReferenceLocation, cbSymbol, allowBaseTypes) {
            const containingObjectLiteralElement = getContainingObjectLiteralElement(location);
            if (containingObjectLiteralElement) {
                const shorthandValueSymbol = checker.getShorthandAssignmentValueSymbol(location.parent);
                if (shorthandValueSymbol && isForRenamePopulateSearchSymbolSet) return cbSymbol(shorthandValueSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 3 /* SearchedLocalFoundProperty */ );
                const contextualType = checker.getContextualType(containingObjectLiteralElement.parent);
                const res2 = contextualType && firstDefined(getPropertySymbolsFromContextualType(containingObjectLiteralElement, checker, contextualType, /*unionSymbolOk*/ true), (sym)=>fromRoot(sym, 4 /* SearchedPropertyFoundLocal */ ));
                if (res2) return res2;
                const propertySymbol = getPropertySymbolOfDestructuringAssignment(location, checker);
                const res1 = propertySymbol && cbSymbol(propertySymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 4 /* SearchedPropertyFoundLocal */ );
                if (res1) return res1;
                const res22 = shorthandValueSymbol && cbSymbol(shorthandValueSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 3 /* SearchedLocalFoundProperty */ );
                if (res22) return res22;
            }
            const aliasedSymbol = getMergedAliasedSymbolOfNamespaceExportDeclaration(location, symbol, checker);
            if (aliasedSymbol) {
                const res2 = cbSymbol(aliasedSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 1 /* Node */ );
                if (res2) return res2;
            }
            const res = fromRoot(symbol);
            if (res) return res;
            if (symbol.valueDeclaration && isParameterPropertyDeclaration(symbol.valueDeclaration, symbol.valueDeclaration.parent)) {
                const paramProps = checker.getSymbolsOfParameterPropertyDeclaration(cast(symbol.valueDeclaration, isParameter), symbol.name);
                Debug.assert(paramProps.length === 2 && !!(paramProps[0].flags & 1 /* FunctionScopedVariable */ ) && !!(paramProps[1].flags & 4 /* Property */ ));
                return fromRoot(symbol.flags & 1 /* FunctionScopedVariable */  ? paramProps[1] : paramProps[0]);
            }
            const exportSpecifier = getDeclarationOfKind(symbol, 282 /* ExportSpecifier */ );
            if (!isForRenamePopulateSearchSymbolSet || exportSpecifier && !exportSpecifier.propertyName) {
                const localSymbol = exportSpecifier && checker.getExportSpecifierLocalTargetSymbol(exportSpecifier);
                if (localSymbol) {
                    const res2 = cbSymbol(localSymbol, /*rootSymbol*/ void 0, /*baseSymbol*/ void 0, 1 /* Node */ );
                    if (res2) return res2;
                }
            }
            if (!isForRenamePopulateSearchSymbolSet) {
                let bindingElementPropertySymbol;
                if (onlyIncludeBindingElementAtReferenceLocation) bindingElementPropertySymbol = isObjectBindingElementWithoutPropertyName(location.parent) ? getPropertySymbolFromBindingElement(checker, location.parent) : void 0;
                else bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker);
                return bindingElementPropertySymbol && fromRoot(bindingElementPropertySymbol, 4 /* SearchedPropertyFoundLocal */ );
            }
            Debug.assert(isForRenamePopulateSearchSymbolSet);
            const includeOriginalSymbolOfBindingElement = onlyIncludeBindingElementAtReferenceLocation;
            if (includeOriginalSymbolOfBindingElement) {
                const bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker);
                return bindingElementPropertySymbol && fromRoot(bindingElementPropertySymbol, 4 /* SearchedPropertyFoundLocal */ );
            }
            function fromRoot(sym, kind) {
                return firstDefined(checker.getRootSymbols(sym), (rootSymbol)=>cbSymbol(sym, rootSymbol, /*baseSymbol*/ void 0, kind) || (rootSymbol.parent && rootSymbol.parent.flags & 96 /* Interface */  && allowBaseTypes(rootSymbol) ? getPropertySymbolsFromBaseTypes(rootSymbol.parent, rootSymbol.name, checker, (base)=>cbSymbol(sym, rootSymbol, base, kind)) : void 0));
            }
            function getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol2, checker2) {
                const bindingElement = getDeclarationOfKind(symbol2, 209 /* BindingElement */ );
                if (bindingElement && isObjectBindingElementWithoutPropertyName(bindingElement)) return getPropertySymbolFromBindingElement(checker2, bindingElement);
            }
        }
        function getPropertySymbolsFromBaseTypes(symbol, propertyName, checker, cb) {
            const seen = /* @__PURE__ */ new Set();
            return recur(symbol);
            function recur(symbol2) {
                if (!(symbol2.flags & 96 /* Interface */ ) || !addToSeen(seen, symbol2)) return;
                return firstDefined(symbol2.declarations, (declaration)=>firstDefined(getAllSuperTypeNodes(declaration), (typeReference)=>{
                        const type = checker.getTypeAtLocation(typeReference);
                        const propertySymbol = type.symbol && checker.getPropertyOfType(type, propertyName);
                        return propertySymbol && firstDefined(checker.getRootSymbols(propertySymbol), cb) || type.symbol && recur(type.symbol);
                    }));
            }
        }
        function isStaticSymbol(symbol) {
            if (!symbol.valueDeclaration) return false;
            const modifierFlags = getEffectiveModifierFlags(symbol.valueDeclaration);
            return !!(modifierFlags & 256 /* Static */ );
        }
        function getRelatedSymbol(search, referenceSymbol, referenceLocation, state) {
            const { checker } = state;
            return forEachRelatedSymbol(referenceSymbol, referenceLocation, checker, /*isForRenamePopulateSearchSymbolSet*/ false, /*onlyIncludeBindingElementAtReferenceLocation*/ state.options.use !== 2 /* Rename */  || !!state.options.providePrefixAndSuffixTextForRename, (sym, rootSymbol, baseSymbol, kind)=>{
                if (baseSymbol) {
                    if (isStaticSymbol(referenceSymbol) !== isStaticSymbol(baseSymbol)) baseSymbol = void 0;
                }
                return search.includes(baseSymbol || rootSymbol || sym) ? {
                    symbol: rootSymbol && !(getCheckFlags(sym) & 6 /* Synthetic */ ) ? rootSymbol : sym,
                    kind
                } : void 0;
            }, /*allowBaseTypes*/ (rootSymbol)=>!(search.parents && !search.parents.some((parent2)=>explicitlyInheritsFrom(rootSymbol.parent, parent2, state.inheritsFromCache, checker))));
        }
        function getIntersectingMeaningFromDeclarations(node, symbol) {
            let meaning = getMeaningFromLocation(node);
            const { declarations } = symbol;
            if (declarations) {
                let lastIterationMeaning;
                do {
                    lastIterationMeaning = meaning;
                    for (const declaration of declarations){
                        const declarationMeaning = getMeaningFromDeclaration(declaration);
                        if (declarationMeaning & meaning) meaning |= declarationMeaning;
                    }
                }while (meaning !== lastIterationMeaning);
            }
            return meaning;
        }
        Core2.getIntersectingMeaningFromDeclarations = getIntersectingMeaningFromDeclarations;
        function isImplementation(node) {
            return !!(node.flags & 33554432 /* Ambient */ ) ? !(isInterfaceDeclaration(node) || isTypeAliasDeclaration(node)) : isVariableLike(node) ? hasInitializer(node) : isFunctionLikeDeclaration(node) ? !!node.body : isClassLike(node) || isModuleOrEnumDeclaration(node);
        }
        function getReferenceEntriesForShorthandPropertyAssignment(node, checker, addReference2) {
            const refSymbol = checker.getSymbolAtLocation(node);
            const shorthandSymbol = checker.getShorthandAssignmentValueSymbol(refSymbol.valueDeclaration);
            if (shorthandSymbol) {
                for (const declaration of shorthandSymbol.getDeclarations())if (getMeaningFromDeclaration(declaration) & 1 /* Value */ ) addReference2(declaration);
            }
        }
        Core2.getReferenceEntriesForShorthandPropertyAssignment = getReferenceEntriesForShorthandPropertyAssignment;
        function forEachDescendantOfKind(node, kind, action) {
            forEachChild(node, (child)=>{
                if (child.kind === kind) action(child);
                forEachDescendantOfKind(child, kind, action);
            });
        }
        function tryGetClassByExtendingIdentifier(node) {
            return tryGetClassExtendingExpressionWithTypeArguments(climbPastPropertyAccess(node).parent);
        }
        function getParentSymbolsOfPropertyAccess(location, symbol, checker) {
            const propertyAccessExpression = isRightSideOfPropertyAccess(location) ? location.parent : void 0;
            const lhsType = propertyAccessExpression && checker.getTypeAtLocation(propertyAccessExpression.expression);
            const res = mapDefined(lhsType && (lhsType.isUnionOrIntersection() ? lhsType.types : lhsType.symbol === symbol.parent ? void 0 : [
                lhsType
            ]), (t)=>t.symbol && t.symbol.flags & 96 /* Interface */  ? t.symbol : void 0);
            return res.length === 0 ? void 0 : res;
        }
        function isForRenameWithPrefixAndSuffixText(options) {
            return options.use === 2 /* Rename */  && options.providePrefixAndSuffixTextForRename;
        }
    })(Core || (Core = {}));
    // src/services/_namespaces/ts.GoToDefinition.ts
    var ts_GoToDefinition_exports = {};
    __export(ts_GoToDefinition_exports, {
        createDefinitionInfo: ()=>createDefinitionInfo,
        getDefinitionAndBoundSpan: ()=>getDefinitionAndBoundSpan,
        getDefinitionAtPosition: ()=>getDefinitionAtPosition,
        getReferenceAtPosition: ()=>getReferenceAtPosition,
        getTypeDefinitionAtPosition: ()=>getTypeDefinitionAtPosition
    });
    // src/services/goToDefinition.ts
    function getDefinitionAtPosition(program, sourceFile, position, searchOtherFilesOnly, stopAtAlias) {
        var _a;
        const resolvedRef = getReferenceAtPosition(sourceFile, position, program);
        const fileReferenceDefinition = resolvedRef && [
            getDefinitionInfoForFileReference(resolvedRef.reference.fileName, resolvedRef.fileName, resolvedRef.unverified)
        ] || emptyArray;
        if (resolvedRef == null ? void 0 : resolvedRef.file) return fileReferenceDefinition;
        const node = getTouchingPropertyName(sourceFile, position);
        if (node === sourceFile) return void 0;
        const { parent: parent2 } = node;
        const typeChecker = program.getTypeChecker();
        if (node.kind === 164 /* OverrideKeyword */  || isIdentifier(node) && isJSDocOverrideTag(parent2) && parent2.tagName === node) {
            const def = getDefinitionFromOverriddenMember(typeChecker, node);
            if (def !== void 0 || node.kind !== 164 /* OverrideKeyword */ ) return def || emptyArray;
        }
        if (isJumpStatementTarget(node)) {
            const label = getTargetLabel(node.parent, node.text);
            return label ? [
                createDefinitionInfoFromName(typeChecker, label, "label" /* label */ , node.text, /*containerName*/ void 0)
            ] : void 0;
        }
        switch(node.kind){
            case 90 /* DefaultKeyword */ :
                if (!isDefaultClause(node.parent)) break;
            // falls through
            case 84 /* CaseKeyword */ :
                const switchStatement = findAncestor(node.parent, isSwitchStatement);
                if (switchStatement) return [
                    createDefinitionInfoFromSwitch(switchStatement, sourceFile)
                ];
                break;
        }
        let findFunctionDecl;
        switch(node.kind){
            case 107 /* ReturnKeyword */ :
            case 135 /* AwaitKeyword */ :
            case 127 /* YieldKeyword */ :
                findFunctionDecl = isFunctionLikeDeclaration;
                const functionDeclaration = findAncestor(node, findFunctionDecl);
                return functionDeclaration ? [
                    createDefinitionFromSignatureDeclaration(typeChecker, functionDeclaration)
                ] : void 0;
        }
        if (isStaticModifier(node) && isClassStaticBlockDeclaration(node.parent)) {
            const classDecl = node.parent.parent;
            const { symbol: symbol2, failedAliasResolution: failedAliasResolution2 } = getSymbol(classDecl, typeChecker, stopAtAlias);
            const staticBlocks = filter(classDecl.members, isClassStaticBlockDeclaration);
            const containerName = symbol2 ? typeChecker.symbolToString(symbol2, classDecl) : "";
            const sourceFile2 = node.getSourceFile();
            return map(staticBlocks, (staticBlock)=>{
                let { pos } = moveRangePastModifiers(staticBlock);
                pos = skipTrivia(sourceFile2.text, pos);
                return createDefinitionInfoFromName(typeChecker, staticBlock, "constructor" /* constructorImplementationElement */ , "static {}", containerName, /*unverified*/ false, failedAliasResolution2, {
                    start: pos,
                    length: 6
                });
            });
        }
        let { symbol, failedAliasResolution } = getSymbol(node, typeChecker, stopAtAlias);
        let fallbackNode = node;
        if (searchOtherFilesOnly && failedAliasResolution) {
            const importDeclaration = forEach([
                node,
                ...(symbol == null ? void 0 : symbol.declarations) || emptyArray
            ], (n)=>findAncestor(n, isAnyImportOrBareOrAccessedRequire));
            const moduleSpecifier = importDeclaration && tryGetModuleSpecifierFromDeclaration(importDeclaration);
            if (moduleSpecifier) {
                ({ symbol, failedAliasResolution } = getSymbol(moduleSpecifier, typeChecker, stopAtAlias));
                fallbackNode = moduleSpecifier;
            }
        }
        if (!symbol && isModuleSpecifierLike(fallbackNode)) {
            const ref = (_a = program.getResolvedModuleFromModuleSpecifier(fallbackNode, sourceFile)) == null ? void 0 : _a.resolvedModule;
            if (ref) return [
                {
                    name: fallbackNode.text,
                    fileName: ref.resolvedFileName,
                    containerName: void 0,
                    containerKind: void 0,
                    kind: "script" /* scriptElement */ ,
                    textSpan: createTextSpan(0, 0),
                    failedAliasResolution,
                    isAmbient: isDeclarationFileName(ref.resolvedFileName),
                    unverified: fallbackNode !== node
                }
            ];
        }
        if (isModifier(node) && (isClassElement(parent2) || isNamedDeclaration(parent2))) symbol = parent2.symbol;
        if (!symbol) return concatenate(fileReferenceDefinition, getDefinitionInfoForIndexSignatures(node, typeChecker));
        if (searchOtherFilesOnly && every(symbol.declarations, (d)=>d.getSourceFile().fileName === sourceFile.fileName)) return void 0;
        const calledDeclaration = tryGetSignatureDeclaration(typeChecker, node);
        if (calledDeclaration && !(isJsxOpeningLikeElement(node.parent) && isJsxConstructorLike(calledDeclaration))) {
            const sigInfo = createDefinitionFromSignatureDeclaration(typeChecker, calledDeclaration, failedAliasResolution);
            let declarationFilter = (d)=>d !== calledDeclaration;
            if (typeChecker.getRootSymbols(symbol).some((s)=>symbolMatchesSignature(s, calledDeclaration))) {
                if (!isConstructorDeclaration(calledDeclaration)) return [
                    sigInfo
                ];
                declarationFilter = (d)=>d !== calledDeclaration && (isClassDeclaration(d) || isClassExpression(d));
            }
            const defs = getDefinitionFromSymbol(typeChecker, symbol, node, failedAliasResolution, declarationFilter) || emptyArray;
            return node.kind === 108 /* SuperKeyword */  ? [
                sigInfo,
                ...defs
            ] : [
                ...defs,
                sigInfo
            ];
        }
        if (node.parent.kind === 305 /* ShorthandPropertyAssignment */ ) {
            const shorthandSymbol = typeChecker.getShorthandAssignmentValueSymbol(symbol.valueDeclaration);
            const definitions = (shorthandSymbol == null ? void 0 : shorthandSymbol.declarations) ? shorthandSymbol.declarations.map((decl)=>createDefinitionInfo(decl, typeChecker, shorthandSymbol, node, /*unverified*/ false, failedAliasResolution)) : emptyArray;
            return concatenate(definitions, getDefinitionFromObjectLiteralElement(typeChecker, node));
        }
        if (isPropertyName(node) && isBindingElement(parent2) && isObjectBindingPattern(parent2.parent) && node === (parent2.propertyName || parent2.name)) {
            const name = getNameFromPropertyName(node);
            const type = typeChecker.getTypeAtLocation(parent2.parent);
            return name === void 0 ? emptyArray : flatMap(type.isUnion() ? type.types : [
                type
            ], (t)=>{
                const prop = t.getProperty(name);
                return prop && getDefinitionFromSymbol(typeChecker, prop, node);
            });
        }
        const objectLiteralElementDefinition = getDefinitionFromObjectLiteralElement(typeChecker, node);
        return concatenate(fileReferenceDefinition, objectLiteralElementDefinition.length ? objectLiteralElementDefinition : getDefinitionFromSymbol(typeChecker, symbol, node, failedAliasResolution));
    }
    function symbolMatchesSignature(s, calledDeclaration) {
        var _a;
        return s === calledDeclaration.symbol || s === calledDeclaration.symbol.parent || isAssignmentExpression(calledDeclaration.parent) || !isCallLikeExpression(calledDeclaration.parent) && s === ((_a = tryCast(calledDeclaration.parent, canHaveSymbol)) == null ? void 0 : _a.symbol);
    }
    function getDefinitionFromObjectLiteralElement(typeChecker, node) {
        const element = getContainingObjectLiteralElement(node);
        if (element) {
            const contextualType = element && typeChecker.getContextualType(element.parent);
            if (contextualType) return flatMap(getPropertySymbolsFromContextualType(element, typeChecker, contextualType, /*unionSymbolOk*/ false), (propertySymbol)=>getDefinitionFromSymbol(typeChecker, propertySymbol, node));
        }
        return emptyArray;
    }
    function getDefinitionFromOverriddenMember(typeChecker, node) {
        const classElement = findAncestor(node, isClassElement);
        if (!(classElement && classElement.name)) return;
        const baseDeclaration = findAncestor(classElement, isClassLike);
        if (!baseDeclaration) return;
        const baseTypeNode = getEffectiveBaseTypeNode(baseDeclaration);
        if (!baseTypeNode) return;
        const expression = skipParentheses(baseTypeNode.expression);
        const base = isClassExpression(expression) ? expression.symbol : typeChecker.getSymbolAtLocation(expression);
        if (!base) return;
        const baseType = hasStaticModifier(classElement) ? typeChecker.getTypeOfSymbol(base) : typeChecker.getDeclaredTypeOfSymbol(base);
        let baseProp;
        if (isComputedPropertyName(classElement.name)) {
            const prop = typeChecker.getSymbolAtLocation(classElement.name);
            if (!prop) return;
            if (isKnownSymbol(prop)) baseProp = find(typeChecker.getPropertiesOfType(baseType), (s)=>s.escapedName === prop.escapedName);
            else baseProp = typeChecker.getPropertyOfType(baseType, unescapeLeadingUnderscores(prop.escapedName));
        } else baseProp = typeChecker.getPropertyOfType(baseType, unescapeLeadingUnderscores(getTextOfPropertyName(classElement.name)));
        if (!baseProp) return;
        return getDefinitionFromSymbol(typeChecker, baseProp, node);
    }
    function getReferenceAtPosition(sourceFile, position, program) {
        var _a, _b;
        const referencePath = findReferenceInPosition(sourceFile.referencedFiles, position);
        if (referencePath) {
            const file = program.getSourceFileFromReference(sourceFile, referencePath);
            return file && {
                reference: referencePath,
                fileName: file.fileName,
                file,
                unverified: false
            };
        }
        const typeReferenceDirective = findReferenceInPosition(sourceFile.typeReferenceDirectives, position);
        if (typeReferenceDirective) {
            const reference = (_a = program.getResolvedTypeReferenceDirectiveFromTypeReferenceDirective(typeReferenceDirective, sourceFile)) == null ? void 0 : _a.resolvedTypeReferenceDirective;
            const file = reference && program.getSourceFile(reference.resolvedFileName);
            return file && {
                reference: typeReferenceDirective,
                fileName: file.fileName,
                file,
                unverified: false
            };
        }
        const libReferenceDirective = findReferenceInPosition(sourceFile.libReferenceDirectives, position);
        if (libReferenceDirective) {
            const file = program.getLibFileFromReference(libReferenceDirective);
            return file && {
                reference: libReferenceDirective,
                fileName: file.fileName,
                file,
                unverified: false
            };
        }
        if (sourceFile.imports.length || sourceFile.moduleAugmentations.length) {
            const node = getTouchingToken(sourceFile, position);
            let resolution;
            if (isModuleSpecifierLike(node) && isExternalModuleNameRelative(node.text) && (resolution = program.getResolvedModuleFromModuleSpecifier(node, sourceFile))) {
                const verifiedFileName = (_b = resolution.resolvedModule) == null ? void 0 : _b.resolvedFileName;
                const fileName = verifiedFileName || resolvePath(getDirectoryPath(sourceFile.fileName), node.text);
                return {
                    file: program.getSourceFile(fileName),
                    fileName,
                    reference: {
                        pos: node.getStart(),
                        end: node.getEnd(),
                        fileName: node.text
                    },
                    unverified: !verifiedFileName
                };
            }
        }
        return void 0;
    }
    var typesWithUnwrappedTypeArguments = /* @__PURE__ */ new Set([
        "Array",
        "ArrayLike",
        "ReadonlyArray",
        "Promise",
        "PromiseLike",
        "Iterable",
        "IterableIterator",
        "AsyncIterable",
        "Set",
        "WeakSet",
        "ReadonlySet",
        "Map",
        "WeakMap",
        "ReadonlyMap",
        "Partial",
        "Required",
        "Readonly",
        "Pick",
        "Omit"
    ]);
    function shouldUnwrapFirstTypeArgumentTypeDefinitionFromTypeReference(typeChecker, type) {
        const referenceName = type.symbol.name;
        if (!typesWithUnwrappedTypeArguments.has(referenceName)) return false;
        const globalType = typeChecker.resolveName(referenceName, /*location*/ void 0, 788968 /* Type */ , /*excludeGlobals*/ false);
        return !!globalType && globalType === type.target.symbol;
    }
    function shouldUnwrapFirstTypeArgumentTypeDefinitionFromAlias(typeChecker, type) {
        if (!type.aliasSymbol) return false;
        const referenceName = type.aliasSymbol.name;
        if (!typesWithUnwrappedTypeArguments.has(referenceName)) return false;
        const globalType = typeChecker.resolveName(referenceName, /*location*/ void 0, 788968 /* Type */ , /*excludeGlobals*/ false);
        return !!globalType && globalType === type.aliasSymbol;
    }
    function getFirstTypeArgumentDefinitions(typeChecker, type, node, failedAliasResolution) {
        var _a, _b;
        if (!!(getObjectFlags(type) & 4 /* Reference */ ) && shouldUnwrapFirstTypeArgumentTypeDefinitionFromTypeReference(typeChecker, type)) return definitionFromType(typeChecker.getTypeArguments(type)[0], typeChecker, node, failedAliasResolution);
        if (shouldUnwrapFirstTypeArgumentTypeDefinitionFromAlias(typeChecker, type) && type.aliasTypeArguments) return definitionFromType(type.aliasTypeArguments[0], typeChecker, node, failedAliasResolution);
        if (getObjectFlags(type) & 32 /* Mapped */  && type.target && shouldUnwrapFirstTypeArgumentTypeDefinitionFromAlias(typeChecker, type.target)) {
            const declaration = (_b = (_a = type.aliasSymbol) == null ? void 0 : _a.declarations) == null ? void 0 : _b[0];
            if (declaration && isTypeAliasDeclaration(declaration) && isTypeReferenceNode(declaration.type) && declaration.type.typeArguments) return definitionFromType(typeChecker.getTypeAtLocation(declaration.type.typeArguments[0]), typeChecker, node, failedAliasResolution);
        }
        return [];
    }
    function getTypeDefinitionAtPosition(typeChecker, sourceFile, position) {
        const node = getTouchingPropertyName(sourceFile, position);
        if (node === sourceFile) return void 0;
        if (isImportMeta(node.parent) && node.parent.name === node) return definitionFromType(typeChecker.getTypeAtLocation(node.parent), typeChecker, node.parent, /*failedAliasResolution*/ false);
        let { symbol, failedAliasResolution } = getSymbol(node, typeChecker, /*stopAtAlias*/ false);
        if (isModifier(node) && (isClassElement(node.parent) || isNamedDeclaration(node.parent))) {
            symbol = node.parent.symbol;
            failedAliasResolution = false;
        }
        if (!symbol) return void 0;
        const typeAtLocation = typeChecker.getTypeOfSymbolAtLocation(symbol, node);
        const returnType = tryGetReturnTypeOfFunction(symbol, typeAtLocation, typeChecker);
        const fromReturnType = returnType && definitionFromType(returnType, typeChecker, node, failedAliasResolution);
        const [resolvedType, typeDefinitions] = fromReturnType && fromReturnType.length !== 0 ? [
            returnType,
            fromReturnType
        ] : [
            typeAtLocation,
            definitionFromType(typeAtLocation, typeChecker, node, failedAliasResolution)
        ];
        return typeDefinitions.length ? [
            ...getFirstTypeArgumentDefinitions(typeChecker, resolvedType, node, failedAliasResolution),
            ...typeDefinitions
        ] : !(symbol.flags & 111551 /* Value */ ) && symbol.flags & 788968 /* Type */  ? getDefinitionFromSymbol(typeChecker, skipAlias(symbol, typeChecker), node, failedAliasResolution) : void 0;
    }
    function definitionFromType(type, checker, node, failedAliasResolution) {
        return flatMap(type.isUnion() && !(type.flags & 32 /* Enum */ ) ? type.types : [
            type
        ], (t)=>t.symbol && getDefinitionFromSymbol(checker, t.symbol, node, failedAliasResolution));
    }
    function tryGetReturnTypeOfFunction(symbol, type, checker) {
        if (type.symbol === symbol || // At `const f = () => {}`, the symbol is `f` and the type symbol is at `() => {}`
        symbol.valueDeclaration && type.symbol && isVariableDeclaration(symbol.valueDeclaration) && symbol.valueDeclaration.initializer === type.symbol.valueDeclaration) {
            const sigs = type.getCallSignatures();
            if (sigs.length === 1) return checker.getReturnTypeOfSignature(first(sigs));
        }
        return void 0;
    }
    function getDefinitionAndBoundSpan(program, sourceFile, position) {
        const definitions = getDefinitionAtPosition(program, sourceFile, position);
        if (!definitions || definitions.length === 0) return void 0;
        const comment = findReferenceInPosition(sourceFile.referencedFiles, position) || findReferenceInPosition(sourceFile.typeReferenceDirectives, position) || findReferenceInPosition(sourceFile.libReferenceDirectives, position);
        if (comment) return {
            definitions,
            textSpan: createTextSpanFromRange(comment)
        };
        const node = getTouchingPropertyName(sourceFile, position);
        const textSpan = createTextSpan(node.getStart(), node.getWidth());
        return {
            definitions,
            textSpan
        };
    }
    function getDefinitionInfoForIndexSignatures(node, checker) {
        return mapDefined(checker.getIndexInfosAtLocation(node), (info)=>info.declaration && createDefinitionFromSignatureDeclaration(checker, info.declaration));
    }
    function getSymbol(node, checker, stopAtAlias) {
        const symbol = checker.getSymbolAtLocation(node);
        let failedAliasResolution = false;
        if ((symbol == null ? void 0 : symbol.declarations) && symbol.flags & 2097152 /* Alias */  && !stopAtAlias && shouldSkipAlias(node, symbol.declarations[0])) {
            const aliased = checker.getAliasedSymbol(symbol);
            if (aliased.declarations) return {
                symbol: aliased
            };
            else failedAliasResolution = true;
        }
        return {
            symbol,
            failedAliasResolution
        };
    }
    function shouldSkipAlias(node, declaration) {
        if (node.kind !== 80 /* Identifier */  && (node.kind !== 11 /* StringLiteral */  || !isImportOrExportSpecifier(node.parent))) return false;
        if (node.parent === declaration) return true;
        if (declaration.kind === 275 /* NamespaceImport */ ) return false;
        return true;
    }
    function isExpandoDeclaration(node) {
        if (!isAssignmentDeclaration(node)) return false;
        const containingAssignment = findAncestor(node, (p)=>{
            if (isAssignmentExpression(p)) return true;
            if (!isAssignmentDeclaration(p)) return "quit";
            return false;
        });
        return !!containingAssignment && getAssignmentDeclarationKind(containingAssignment) === 5 /* Property */ ;
    }
    function getDefinitionFromSymbol(typeChecker, symbol, node, failedAliasResolution, declarationFilter) {
        const filteredDeclarations = declarationFilter !== void 0 ? filter(symbol.declarations, declarationFilter) : symbol.declarations;
        const signatureDefinition = !declarationFilter && (getConstructSignatureDefinition() || getCallSignatureDefinition());
        if (signatureDefinition) return signatureDefinition;
        const withoutExpandos = filter(filteredDeclarations, (d)=>!isExpandoDeclaration(d));
        const results = some(withoutExpandos) ? withoutExpandos : filteredDeclarations;
        return map(results, (declaration)=>createDefinitionInfo(declaration, typeChecker, symbol, node, /*unverified*/ false, failedAliasResolution));
        function getConstructSignatureDefinition() {
            if (symbol.flags & 32 /* Class */  && !(symbol.flags & 19 /* Variable */ ) && (isNewExpressionTarget(node) || node.kind === 137 /* ConstructorKeyword */ )) {
                const cls = find(filteredDeclarations, isClassLike);
                return cls && getSignatureDefinition(cls.members, /*selectConstructors*/ true);
            }
        }
        function getCallSignatureDefinition() {
            return isCallOrNewExpressionTarget(node) || isNameOfFunctionDeclaration(node) ? getSignatureDefinition(filteredDeclarations, /*selectConstructors*/ false) : void 0;
        }
        function getSignatureDefinition(signatureDeclarations, selectConstructors) {
            if (!signatureDeclarations) return void 0;
            const declarations = signatureDeclarations.filter(selectConstructors ? isConstructorDeclaration : isFunctionLike);
            const declarationsWithBody = declarations.filter((d)=>!!d.body);
            return declarations.length ? declarationsWithBody.length !== 0 ? declarationsWithBody.map((x)=>createDefinitionInfo(x, typeChecker, symbol, node)) : [
                createDefinitionInfo(last(declarations), typeChecker, symbol, node, /*unverified*/ false, failedAliasResolution)
            ] : void 0;
        }
    }
    function createDefinitionInfo(declaration, checker, symbol, node, unverified, failedAliasResolution) {
        const symbolName2 = checker.symbolToString(symbol);
        const symbolKind = ts_SymbolDisplay_exports.getSymbolKind(checker, symbol, node);
        const containerName = symbol.parent ? checker.symbolToString(symbol.parent, node) : "";
        return createDefinitionInfoFromName(checker, declaration, symbolKind, symbolName2, containerName, unverified, failedAliasResolution);
    }
    function createDefinitionInfoFromName(checker, declaration, symbolKind, symbolName2, containerName, unverified, failedAliasResolution, textSpan) {
        const sourceFile = declaration.getSourceFile();
        if (!textSpan) {
            const name = getNameOfDeclaration(declaration) || declaration;
            textSpan = createTextSpanFromNode(name, sourceFile);
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            fileName: sourceFile.fileName,
            textSpan,
            kind: symbolKind,
            name: symbolName2,
            containerKind: void 0,
            // TODO: GH#18217
            containerName
        }, ts_FindAllReferences_exports.toContextSpan(textSpan, sourceFile, ts_FindAllReferences_exports.getContextNode(declaration))), {
            isLocal: !isDefinitionVisible(checker, declaration),
            isAmbient: !!(declaration.flags & 33554432 /* Ambient */ ),
            unverified,
            failedAliasResolution
        });
    }
    function createDefinitionInfoFromSwitch(statement, sourceFile) {
        const keyword = ts_FindAllReferences_exports.getContextNode(statement);
        const textSpan = createTextSpanFromNode(isContextWithStartAndEndNode(keyword) ? keyword.start : keyword, sourceFile);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            fileName: sourceFile.fileName,
            textSpan,
            kind: "keyword" /* keyword */ ,
            name: "switch",
            containerKind: void 0,
            containerName: ""
        }, ts_FindAllReferences_exports.toContextSpan(textSpan, sourceFile, keyword)), {
            isLocal: true,
            isAmbient: false,
            unverified: false,
            failedAliasResolution: void 0
        });
    }
    function isDefinitionVisible(checker, declaration) {
        if (checker.isDeclarationVisible(declaration)) return true;
        if (!declaration.parent) return false;
        if (hasInitializer(declaration.parent) && declaration.parent.initializer === declaration) return isDefinitionVisible(checker, declaration.parent);
        switch(declaration.kind){
            case 173 /* PropertyDeclaration */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            case 175 /* MethodDeclaration */ :
                if (hasEffectiveModifier(declaration, 2 /* Private */ )) return false;
            // Public properties/methods are visible if its parents are visible, so:
            // falls through
            case 177 /* Constructor */ :
            case 304 /* PropertyAssignment */ :
            case 305 /* ShorthandPropertyAssignment */ :
            case 211 /* ObjectLiteralExpression */ :
            case 232 /* ClassExpression */ :
            case 220 /* ArrowFunction */ :
            case 219 /* FunctionExpression */ :
                return isDefinitionVisible(checker, declaration.parent);
            default:
                return false;
        }
    }
    function createDefinitionFromSignatureDeclaration(typeChecker, decl, failedAliasResolution) {
        return createDefinitionInfo(decl, typeChecker, decl.symbol, decl, /*unverified*/ false, failedAliasResolution);
    }
    function findReferenceInPosition(refs, pos) {
        return find(refs, (ref)=>textRangeContainsPositionInclusive(ref, pos));
    }
    function getDefinitionInfoForFileReference(name, targetFileName, unverified) {
        return {
            fileName: targetFileName,
            textSpan: createTextSpanFromBounds(0, 0),
            kind: "script" /* scriptElement */ ,
            name,
            containerName: void 0,
            containerKind: void 0,
            // TODO: GH#18217
            unverified
        };
    }
    function getAncestorCallLikeExpression(node) {
        const target = findAncestor(node, (n)=>!isRightSideOfPropertyAccess(n));
        const callLike = target == null ? void 0 : target.parent;
        return callLike && isCallLikeExpression(callLike) && getInvokedExpression(callLike) === target ? callLike : void 0;
    }
    function tryGetSignatureDeclaration(typeChecker, node) {
        const callLike = getAncestorCallLikeExpression(node);
        const signature = callLike && typeChecker.getResolvedSignature(callLike);
        return tryCast(signature && signature.declaration, (d)=>isFunctionLike(d) && !isFunctionTypeNode(d));
    }
    function isJsxConstructorLike(node) {
        switch(node.kind){
            case 177 /* Constructor */ :
            case 186 /* ConstructorType */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
                return true;
            default:
                return false;
        }
    }
    // src/services/_namespaces/ts.InlayHints.ts
    var ts_InlayHints_exports = {};
    __export(ts_InlayHints_exports, {
        provideInlayHints: ()=>provideInlayHints
    });
    // src/services/inlayHints.ts
    var leadingParameterNameCommentRegexFactory = (name)=>{
        return new RegExp(`^\\s?/\\*\\*?\\s?${name}\\s?\\*\\/\\s?$`);
    };
    function shouldShowParameterNameHints(preferences) {
        return preferences.includeInlayParameterNameHints === "literals" || preferences.includeInlayParameterNameHints === "all";
    }
    function shouldShowLiteralParameterNameHintsOnly(preferences) {
        return preferences.includeInlayParameterNameHints === "literals";
    }
    function shouldUseInteractiveInlayHints(preferences) {
        return preferences.interactiveInlayHints === true;
    }
    function provideInlayHints(context) {
        const { file, program, span, cancellationToken, preferences } = context;
        const sourceFileText = file.text;
        const compilerOptions = program.getCompilerOptions();
        const quotePreference = getQuotePreference(file, preferences);
        const checker = program.getTypeChecker();
        const result = [];
        visitor(file);
        return result;
        function visitor(node) {
            if (!node || node.getFullWidth() === 0) return;
            switch(node.kind){
                case 268 /* ModuleDeclaration */ :
                case 264 /* ClassDeclaration */ :
                case 265 /* InterfaceDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                case 232 /* ClassExpression */ :
                case 219 /* FunctionExpression */ :
                case 175 /* MethodDeclaration */ :
                case 220 /* ArrowFunction */ :
                    cancellationToken.throwIfCancellationRequested();
            }
            if (!textSpanIntersectsWith(span, node.pos, node.getFullWidth())) return;
            if (isTypeNode(node) && !isExpressionWithTypeArguments(node)) return;
            if (preferences.includeInlayVariableTypeHints && isVariableDeclaration(node)) visitVariableLikeDeclaration(node);
            else if (preferences.includeInlayPropertyDeclarationTypeHints && isPropertyDeclaration(node)) visitVariableLikeDeclaration(node);
            else if (preferences.includeInlayEnumMemberValueHints && isEnumMember(node)) visitEnumMember(node);
            else if (shouldShowParameterNameHints(preferences) && (isCallExpression(node) || isNewExpression(node))) visitCallOrNewExpression(node);
            else {
                if (preferences.includeInlayFunctionParameterTypeHints && isFunctionLikeDeclaration(node) && hasContextSensitiveParameters(node)) visitFunctionLikeForParameterType(node);
                if (preferences.includeInlayFunctionLikeReturnTypeHints && isSignatureSupportingReturnAnnotation(node)) visitFunctionDeclarationLikeForReturnType(node);
            }
            return forEachChild(node, visitor);
        }
        function isSignatureSupportingReturnAnnotation(node) {
            return isArrowFunction(node) || isFunctionExpression(node) || isFunctionDeclaration(node) || isMethodDeclaration(node) || isGetAccessorDeclaration(node);
        }
        function addParameterHints(text, parameter, position, isFirstVariadicArgument) {
            let hintText = `${isFirstVariadicArgument ? "..." : ""}${text}`;
            let displayParts;
            if (shouldUseInteractiveInlayHints(preferences)) {
                displayParts = [
                    getNodeDisplayPart(hintText, parameter),
                    {
                        text: ":"
                    }
                ];
                hintText = "";
            } else hintText += ":";
            result.push({
                text: hintText,
                position,
                kind: "Parameter" /* Parameter */ ,
                whitespaceAfter: true,
                displayParts
            });
        }
        function addTypeHints(hintText, position) {
            result.push({
                text: typeof hintText === "string" ? `: ${hintText}` : "",
                displayParts: typeof hintText === "string" ? void 0 : [
                    {
                        text: ": "
                    },
                    ...hintText
                ],
                position,
                kind: "Type" /* Type */ ,
                whitespaceBefore: true
            });
        }
        function addEnumMemberValueHints(text, position) {
            result.push({
                text: `= ${text}`,
                position,
                kind: "Enum" /* Enum */ ,
                whitespaceBefore: true
            });
        }
        function visitEnumMember(member) {
            if (member.initializer) return;
            const enumValue = checker.getConstantValue(member);
            if (enumValue !== void 0) addEnumMemberValueHints(enumValue.toString(), member.end);
        }
        function isModuleReferenceType(type) {
            return type.symbol && type.symbol.flags & 1536 /* Module */ ;
        }
        function visitVariableLikeDeclaration(decl) {
            if (decl.initializer === void 0 && !(isPropertyDeclaration(decl) && !(checker.getTypeAtLocation(decl).flags & 1 /* Any */ )) || isBindingPattern(decl.name) || isVariableDeclaration(decl) && !isHintableDeclaration(decl)) return;
            const effectiveTypeAnnotation = getEffectiveTypeAnnotationNode(decl);
            if (effectiveTypeAnnotation) return;
            const declarationType = checker.getTypeAtLocation(decl);
            if (isModuleReferenceType(declarationType)) return;
            const hintParts = typeToInlayHintParts(declarationType);
            if (hintParts) {
                const hintText = typeof hintParts === "string" ? hintParts : hintParts.map((part)=>part.text).join("");
                const isVariableNameMatchesType = preferences.includeInlayVariableTypeHintsWhenTypeMatchesName === false && equateStringsCaseInsensitive(decl.name.getText(), hintText);
                if (isVariableNameMatchesType) return;
                addTypeHints(hintParts, decl.name.end);
            }
        }
        function visitCallOrNewExpression(expr) {
            const args = expr.arguments;
            if (!args || !args.length) return;
            const signature = checker.getResolvedSignature(expr);
            if (signature === void 0) return;
            let signatureParamPos = 0;
            for (const originalArg of args){
                const arg = skipParentheses(originalArg);
                if (shouldShowLiteralParameterNameHintsOnly(preferences) && !isHintableLiteral(arg)) {
                    signatureParamPos++;
                    continue;
                }
                let spreadArgs = 0;
                if (isSpreadElement(arg)) {
                    const spreadType = checker.getTypeAtLocation(arg.expression);
                    if (checker.isTupleType(spreadType)) {
                        const { elementFlags, fixedLength } = spreadType.target;
                        if (fixedLength === 0) continue;
                        const firstOptionalIndex = findIndex(elementFlags, (f)=>!(f & 1 /* Required */ ));
                        const requiredArgs = firstOptionalIndex < 0 ? fixedLength : firstOptionalIndex;
                        if (requiredArgs > 0) spreadArgs = firstOptionalIndex < 0 ? fixedLength : firstOptionalIndex;
                    }
                }
                const identifierInfo = checker.getParameterIdentifierInfoAtPosition(signature, signatureParamPos);
                signatureParamPos = signatureParamPos + (spreadArgs || 1);
                if (identifierInfo) {
                    const { parameter, parameterName, isRestParameter: isFirstVariadicArgument } = identifierInfo;
                    const isParameterNameNotSameAsArgument = preferences.includeInlayParameterNameHintsWhenArgumentMatchesName || !identifierOrAccessExpressionPostfixMatchesParameterName(arg, parameterName);
                    if (!isParameterNameNotSameAsArgument && !isFirstVariadicArgument) continue;
                    const name = unescapeLeadingUnderscores(parameterName);
                    if (leadingCommentsContainsParameterName(arg, name)) continue;
                    addParameterHints(name, parameter, originalArg.getStart(), isFirstVariadicArgument);
                }
            }
        }
        function identifierOrAccessExpressionPostfixMatchesParameterName(expr, parameterName) {
            if (isIdentifier(expr)) return expr.text === parameterName;
            if (isPropertyAccessExpression(expr)) return expr.name.text === parameterName;
            return false;
        }
        function leadingCommentsContainsParameterName(node, name) {
            if (!isIdentifierText(name, getEmitScriptTarget(compilerOptions), getLanguageVariant(file.scriptKind))) return false;
            const ranges = getLeadingCommentRanges(sourceFileText, node.pos);
            if (!(ranges == null ? void 0 : ranges.length)) return false;
            const regex = leadingParameterNameCommentRegexFactory(name);
            return some(ranges, (range)=>regex.test(sourceFileText.substring(range.pos, range.end)));
        }
        function isHintableLiteral(node) {
            switch(node.kind){
                case 225 /* PrefixUnaryExpression */ :
                    {
                        const operand = node.operand;
                        return isLiteralExpression(operand) || isIdentifier(operand) && isInfinityOrNaNString(operand.escapedText);
                    }
                case 112 /* TrueKeyword */ :
                case 97 /* FalseKeyword */ :
                case 106 /* NullKeyword */ :
                case 15 /* NoSubstitutionTemplateLiteral */ :
                case 229 /* TemplateExpression */ :
                    return true;
                case 80 /* Identifier */ :
                    {
                        const name = node.escapedText;
                        return isUndefined(name) || isInfinityOrNaNString(name);
                    }
            }
            return isLiteralExpression(node);
        }
        function visitFunctionDeclarationLikeForReturnType(decl) {
            if (isArrowFunction(decl)) {
                if (!findChildOfKind(decl, 21 /* OpenParenToken */ , file)) return;
            }
            const effectiveTypeAnnotation = getEffectiveReturnTypeNode(decl);
            if (effectiveTypeAnnotation || !decl.body) return;
            const signature = checker.getSignatureFromDeclaration(decl);
            if (!signature) return;
            const typePredicate = checker.getTypePredicateOfSignature(signature);
            if (typePredicate == null ? void 0 : typePredicate.type) {
                const hintParts2 = typePredicateToInlayHintParts(typePredicate);
                if (hintParts2) {
                    addTypeHints(hintParts2, getTypeAnnotationPosition(decl));
                    return;
                }
            }
            const returnType = checker.getReturnTypeOfSignature(signature);
            if (isModuleReferenceType(returnType)) return;
            const hintParts = typeToInlayHintParts(returnType);
            if (hintParts) addTypeHints(hintParts, getTypeAnnotationPosition(decl));
        }
        function getTypeAnnotationPosition(decl) {
            const closeParenToken = findChildOfKind(decl, 22 /* CloseParenToken */ , file);
            if (closeParenToken) return closeParenToken.end;
            return decl.parameters.end;
        }
        function visitFunctionLikeForParameterType(node) {
            const signature = checker.getSignatureFromDeclaration(node);
            if (!signature) return;
            let pos = 0;
            for (const param of node.parameters){
                if (isHintableDeclaration(param)) addParameterTypeHint(param, parameterIsThisKeyword(param) ? signature.thisParameter : signature.parameters[pos]);
                if (parameterIsThisKeyword(param)) continue;
                pos++;
            }
        }
        function addParameterTypeHint(node, symbol) {
            const effectiveTypeAnnotation = getEffectiveTypeAnnotationNode(node);
            if (effectiveTypeAnnotation || symbol === void 0) return;
            const typeHints = getParameterDeclarationTypeHints(symbol);
            if (typeHints === void 0) return;
            addTypeHints(typeHints, node.questionToken ? node.questionToken.end : node.name.end);
        }
        function getParameterDeclarationTypeHints(symbol) {
            const valueDeclaration = symbol.valueDeclaration;
            if (!valueDeclaration || !isParameter(valueDeclaration)) return void 0;
            const signatureParamType = checker.getTypeOfSymbolAtLocation(symbol, valueDeclaration);
            if (isModuleReferenceType(signatureParamType)) return void 0;
            return typeToInlayHintParts(signatureParamType);
        }
        function printTypeInSingleLine(type) {
            const flags = 71286784 /* UseAliasDefinedOutsideCurrentScope */ ;
            const printer = createPrinterWithRemoveComments();
            return usingSingleLineStringWriter((writer)=>{
                const typeNode = checker.typeToTypeNode(type, /*enclosingDeclaration*/ void 0, flags);
                Debug.assertIsDefined(typeNode, "should always get typenode");
                printer.writeNode(4 /* Unspecified */ , typeNode, /*sourceFile*/ file, writer);
            });
        }
        function printTypePredicateInSingleLine(typePredicate) {
            const flags = 71286784 /* UseAliasDefinedOutsideCurrentScope */ ;
            const printer = createPrinterWithRemoveComments();
            return usingSingleLineStringWriter((writer)=>{
                const typePredicateNode = checker.typePredicateToTypePredicateNode(typePredicate, /*enclosingDeclaration*/ void 0, flags);
                Debug.assertIsDefined(typePredicateNode, "should always get typePredicateNode");
                printer.writeNode(4 /* Unspecified */ , typePredicateNode, /*sourceFile*/ file, writer);
            });
        }
        function typeToInlayHintParts(type) {
            if (!shouldUseInteractiveInlayHints(preferences)) return printTypeInSingleLine(type);
            const flags = 71286784 /* UseAliasDefinedOutsideCurrentScope */ ;
            const typeNode = checker.typeToTypeNode(type, /*enclosingDeclaration*/ void 0, flags);
            Debug.assertIsDefined(typeNode, "should always get typeNode");
            return getInlayHintDisplayParts(typeNode);
        }
        function typePredicateToInlayHintParts(typePredicate) {
            if (!shouldUseInteractiveInlayHints(preferences)) return printTypePredicateInSingleLine(typePredicate);
            const flags = 71286784 /* UseAliasDefinedOutsideCurrentScope */ ;
            const typeNode = checker.typePredicateToTypePredicateNode(typePredicate, /*enclosingDeclaration*/ void 0, flags);
            Debug.assertIsDefined(typeNode, "should always get typenode");
            return getInlayHintDisplayParts(typeNode);
        }
        function getInlayHintDisplayParts(node) {
            const parts = [];
            visitForDisplayParts(node);
            return parts;
            function visitForDisplayParts(node2) {
                var _a, _b;
                if (!node2) return;
                const tokenString = tokenToString(node2.kind);
                if (tokenString) {
                    parts.push({
                        text: tokenString
                    });
                    return;
                }
                if (isLiteralExpression(node2)) {
                    parts.push({
                        text: getLiteralText2(node2)
                    });
                    return;
                }
                switch(node2.kind){
                    case 80 /* Identifier */ :
                        Debug.assertNode(node2, isIdentifier);
                        const identifierText = idText(node2);
                        const name = node2.symbol && node2.symbol.declarations && node2.symbol.declarations.length && getNameOfDeclaration(node2.symbol.declarations[0]);
                        if (name) parts.push(getNodeDisplayPart(identifierText, name));
                        else parts.push({
                            text: identifierText
                        });
                        break;
                    case 167 /* QualifiedName */ :
                        Debug.assertNode(node2, isQualifiedName);
                        visitForDisplayParts(node2.left);
                        parts.push({
                            text: "."
                        });
                        visitForDisplayParts(node2.right);
                        break;
                    case 183 /* TypePredicate */ :
                        Debug.assertNode(node2, isTypePredicateNode);
                        if (node2.assertsModifier) parts.push({
                            text: "asserts "
                        });
                        visitForDisplayParts(node2.parameterName);
                        if (node2.type) {
                            parts.push({
                                text: " is "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 184 /* TypeReference */ :
                        Debug.assertNode(node2, isTypeReferenceNode);
                        visitForDisplayParts(node2.typeName);
                        if (node2.typeArguments) {
                            parts.push({
                                text: "<"
                            });
                            visitDisplayPartList(node2.typeArguments, ", ");
                            parts.push({
                                text: ">"
                            });
                        }
                        break;
                    case 169 /* TypeParameter */ :
                        Debug.assertNode(node2, isTypeParameterDeclaration);
                        if (node2.modifiers) visitDisplayPartList(node2.modifiers, " ");
                        visitForDisplayParts(node2.name);
                        if (node2.constraint) {
                            parts.push({
                                text: " extends "
                            });
                            visitForDisplayParts(node2.constraint);
                        }
                        if (node2.default) {
                            parts.push({
                                text: " = "
                            });
                            visitForDisplayParts(node2.default);
                        }
                        break;
                    case 170 /* Parameter */ :
                        Debug.assertNode(node2, isParameter);
                        if (node2.modifiers) visitDisplayPartList(node2.modifiers, " ");
                        if (node2.dotDotDotToken) parts.push({
                            text: "..."
                        });
                        visitForDisplayParts(node2.name);
                        if (node2.questionToken) parts.push({
                            text: "?"
                        });
                        if (node2.type) {
                            parts.push({
                                text: ": "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 186 /* ConstructorType */ :
                        Debug.assertNode(node2, isConstructorTypeNode);
                        parts.push({
                            text: "new "
                        });
                        visitParametersAndTypeParameters(node2);
                        parts.push({
                            text: " => "
                        });
                        visitForDisplayParts(node2.type);
                        break;
                    case 187 /* TypeQuery */ :
                        Debug.assertNode(node2, isTypeQueryNode);
                        parts.push({
                            text: "typeof "
                        });
                        visitForDisplayParts(node2.exprName);
                        if (node2.typeArguments) {
                            parts.push({
                                text: "<"
                            });
                            visitDisplayPartList(node2.typeArguments, ", ");
                            parts.push({
                                text: ">"
                            });
                        }
                        break;
                    case 188 /* TypeLiteral */ :
                        Debug.assertNode(node2, isTypeLiteralNode);
                        parts.push({
                            text: "{"
                        });
                        if (node2.members.length) {
                            parts.push({
                                text: " "
                            });
                            visitDisplayPartList(node2.members, "; ");
                            parts.push({
                                text: " "
                            });
                        }
                        parts.push({
                            text: "}"
                        });
                        break;
                    case 189 /* ArrayType */ :
                        Debug.assertNode(node2, isArrayTypeNode);
                        visitForDisplayParts(node2.elementType);
                        parts.push({
                            text: "[]"
                        });
                        break;
                    case 190 /* TupleType */ :
                        Debug.assertNode(node2, isTupleTypeNode);
                        parts.push({
                            text: "["
                        });
                        visitDisplayPartList(node2.elements, ", ");
                        parts.push({
                            text: "]"
                        });
                        break;
                    case 203 /* NamedTupleMember */ :
                        Debug.assertNode(node2, isNamedTupleMember);
                        if (node2.dotDotDotToken) parts.push({
                            text: "..."
                        });
                        visitForDisplayParts(node2.name);
                        if (node2.questionToken) parts.push({
                            text: "?"
                        });
                        parts.push({
                            text: ": "
                        });
                        visitForDisplayParts(node2.type);
                        break;
                    case 191 /* OptionalType */ :
                        Debug.assertNode(node2, isOptionalTypeNode);
                        visitForDisplayParts(node2.type);
                        parts.push({
                            text: "?"
                        });
                        break;
                    case 192 /* RestType */ :
                        Debug.assertNode(node2, isRestTypeNode);
                        parts.push({
                            text: "..."
                        });
                        visitForDisplayParts(node2.type);
                        break;
                    case 193 /* UnionType */ :
                        Debug.assertNode(node2, isUnionTypeNode);
                        visitDisplayPartList(node2.types, " | ");
                        break;
                    case 194 /* IntersectionType */ :
                        Debug.assertNode(node2, isIntersectionTypeNode);
                        visitDisplayPartList(node2.types, " & ");
                        break;
                    case 195 /* ConditionalType */ :
                        Debug.assertNode(node2, isConditionalTypeNode);
                        visitForDisplayParts(node2.checkType);
                        parts.push({
                            text: " extends "
                        });
                        visitForDisplayParts(node2.extendsType);
                        parts.push({
                            text: " ? "
                        });
                        visitForDisplayParts(node2.trueType);
                        parts.push({
                            text: " : "
                        });
                        visitForDisplayParts(node2.falseType);
                        break;
                    case 196 /* InferType */ :
                        Debug.assertNode(node2, isInferTypeNode);
                        parts.push({
                            text: "infer "
                        });
                        visitForDisplayParts(node2.typeParameter);
                        break;
                    case 197 /* ParenthesizedType */ :
                        Debug.assertNode(node2, isParenthesizedTypeNode);
                        parts.push({
                            text: "("
                        });
                        visitForDisplayParts(node2.type);
                        parts.push({
                            text: ")"
                        });
                        break;
                    case 199 /* TypeOperator */ :
                        Debug.assertNode(node2, isTypeOperatorNode);
                        parts.push({
                            text: `${tokenToString(node2.operator)} `
                        });
                        visitForDisplayParts(node2.type);
                        break;
                    case 200 /* IndexedAccessType */ :
                        Debug.assertNode(node2, isIndexedAccessTypeNode);
                        visitForDisplayParts(node2.objectType);
                        parts.push({
                            text: "["
                        });
                        visitForDisplayParts(node2.indexType);
                        parts.push({
                            text: "]"
                        });
                        break;
                    case 201 /* MappedType */ :
                        Debug.assertNode(node2, isMappedTypeNode);
                        parts.push({
                            text: "{ "
                        });
                        if (node2.readonlyToken) {
                            if (node2.readonlyToken.kind === 40 /* PlusToken */ ) parts.push({
                                text: "+"
                            });
                            else if (node2.readonlyToken.kind === 41 /* MinusToken */ ) parts.push({
                                text: "-"
                            });
                            parts.push({
                                text: "readonly "
                            });
                        }
                        parts.push({
                            text: "["
                        });
                        visitForDisplayParts(node2.typeParameter);
                        if (node2.nameType) {
                            parts.push({
                                text: " as "
                            });
                            visitForDisplayParts(node2.nameType);
                        }
                        parts.push({
                            text: "]"
                        });
                        if (node2.questionToken) {
                            if (node2.questionToken.kind === 40 /* PlusToken */ ) parts.push({
                                text: "+"
                            });
                            else if (node2.questionToken.kind === 41 /* MinusToken */ ) parts.push({
                                text: "-"
                            });
                            parts.push({
                                text: "?"
                            });
                        }
                        parts.push({
                            text: ": "
                        });
                        if (node2.type) visitForDisplayParts(node2.type);
                        parts.push({
                            text: "; }"
                        });
                        break;
                    case 202 /* LiteralType */ :
                        Debug.assertNode(node2, isLiteralTypeNode);
                        visitForDisplayParts(node2.literal);
                        break;
                    case 185 /* FunctionType */ :
                        Debug.assertNode(node2, isFunctionTypeNode);
                        visitParametersAndTypeParameters(node2);
                        parts.push({
                            text: " => "
                        });
                        visitForDisplayParts(node2.type);
                        break;
                    case 206 /* ImportType */ :
                        Debug.assertNode(node2, isImportTypeNode);
                        if (node2.isTypeOf) parts.push({
                            text: "typeof "
                        });
                        parts.push({
                            text: "import("
                        });
                        visitForDisplayParts(node2.argument);
                        if (node2.assertions) {
                            parts.push({
                                text: ", { assert: "
                            });
                            visitDisplayPartList(node2.assertions.assertClause.elements, ", ");
                            parts.push({
                                text: " }"
                            });
                        }
                        parts.push({
                            text: ")"
                        });
                        if (node2.qualifier) {
                            parts.push({
                                text: "."
                            });
                            visitForDisplayParts(node2.qualifier);
                        }
                        if (node2.typeArguments) {
                            parts.push({
                                text: "<"
                            });
                            visitDisplayPartList(node2.typeArguments, ", ");
                            parts.push({
                                text: ">"
                            });
                        }
                        break;
                    case 172 /* PropertySignature */ :
                        Debug.assertNode(node2, isPropertySignature);
                        if ((_a = node2.modifiers) == null ? void 0 : _a.length) {
                            visitDisplayPartList(node2.modifiers, " ");
                            parts.push({
                                text: " "
                            });
                        }
                        visitForDisplayParts(node2.name);
                        if (node2.questionToken) parts.push({
                            text: "?"
                        });
                        if (node2.type) {
                            parts.push({
                                text: ": "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 182 /* IndexSignature */ :
                        Debug.assertNode(node2, isIndexSignatureDeclaration);
                        parts.push({
                            text: "["
                        });
                        visitDisplayPartList(node2.parameters, ", ");
                        parts.push({
                            text: "]"
                        });
                        if (node2.type) {
                            parts.push({
                                text: ": "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 174 /* MethodSignature */ :
                        Debug.assertNode(node2, isMethodSignature);
                        if ((_b = node2.modifiers) == null ? void 0 : _b.length) {
                            visitDisplayPartList(node2.modifiers, " ");
                            parts.push({
                                text: " "
                            });
                        }
                        visitForDisplayParts(node2.name);
                        if (node2.questionToken) parts.push({
                            text: "?"
                        });
                        visitParametersAndTypeParameters(node2);
                        if (node2.type) {
                            parts.push({
                                text: ": "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 180 /* CallSignature */ :
                        Debug.assertNode(node2, isCallSignatureDeclaration);
                        visitParametersAndTypeParameters(node2);
                        if (node2.type) {
                            parts.push({
                                text: ": "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 181 /* ConstructSignature */ :
                        Debug.assertNode(node2, isConstructSignatureDeclaration);
                        parts.push({
                            text: "new "
                        });
                        visitParametersAndTypeParameters(node2);
                        if (node2.type) {
                            parts.push({
                                text: ": "
                            });
                            visitForDisplayParts(node2.type);
                        }
                        break;
                    case 208 /* ArrayBindingPattern */ :
                        Debug.assertNode(node2, isArrayBindingPattern);
                        parts.push({
                            text: "["
                        });
                        visitDisplayPartList(node2.elements, ", ");
                        parts.push({
                            text: "]"
                        });
                        break;
                    case 207 /* ObjectBindingPattern */ :
                        Debug.assertNode(node2, isObjectBindingPattern);
                        parts.push({
                            text: "{"
                        });
                        if (node2.elements.length) {
                            parts.push({
                                text: " "
                            });
                            visitDisplayPartList(node2.elements, ", ");
                            parts.push({
                                text: " "
                            });
                        }
                        parts.push({
                            text: "}"
                        });
                        break;
                    case 209 /* BindingElement */ :
                        Debug.assertNode(node2, isBindingElement);
                        visitForDisplayParts(node2.name);
                        break;
                    case 225 /* PrefixUnaryExpression */ :
                        Debug.assertNode(node2, isPrefixUnaryExpression);
                        parts.push({
                            text: tokenToString(node2.operator)
                        });
                        visitForDisplayParts(node2.operand);
                        break;
                    case 204 /* TemplateLiteralType */ :
                        Debug.assertNode(node2, isTemplateLiteralTypeNode);
                        visitForDisplayParts(node2.head);
                        node2.templateSpans.forEach(visitForDisplayParts);
                        break;
                    case 16 /* TemplateHead */ :
                        Debug.assertNode(node2, isTemplateHead);
                        parts.push({
                            text: getLiteralText2(node2)
                        });
                        break;
                    case 205 /* TemplateLiteralTypeSpan */ :
                        Debug.assertNode(node2, isTemplateLiteralTypeSpan);
                        visitForDisplayParts(node2.type);
                        visitForDisplayParts(node2.literal);
                        break;
                    case 17 /* TemplateMiddle */ :
                        Debug.assertNode(node2, isTemplateMiddle);
                        parts.push({
                            text: getLiteralText2(node2)
                        });
                        break;
                    case 18 /* TemplateTail */ :
                        Debug.assertNode(node2, isTemplateTail);
                        parts.push({
                            text: getLiteralText2(node2)
                        });
                        break;
                    case 198 /* ThisType */ :
                        Debug.assertNode(node2, isThisTypeNode);
                        parts.push({
                            text: "this"
                        });
                        break;
                    case 168 /* ComputedPropertyName */ :
                        Debug.assertNode(node2, isComputedPropertyName);
                        parts.push({
                            text: "["
                        });
                        visitForDisplayParts(node2.expression);
                        parts.push({
                            text: "]"
                        });
                        break;
                    default:
                        Debug.failBadSyntaxKind(node2);
                }
            }
            function visitParametersAndTypeParameters(signatureDeclaration) {
                if (signatureDeclaration.typeParameters) {
                    parts.push({
                        text: "<"
                    });
                    visitDisplayPartList(signatureDeclaration.typeParameters, ", ");
                    parts.push({
                        text: ">"
                    });
                }
                parts.push({
                    text: "("
                });
                visitDisplayPartList(signatureDeclaration.parameters, ", ");
                parts.push({
                    text: ")"
                });
            }
            function visitDisplayPartList(nodes, separator) {
                nodes.forEach((node2, index)=>{
                    if (index > 0) parts.push({
                        text: separator
                    });
                    visitForDisplayParts(node2);
                });
            }
            function getLiteralText2(node2) {
                switch(node2.kind){
                    case 11 /* StringLiteral */ :
                        return quotePreference === 0 /* Single */  ? `'${escapeString(node2.text, 39 /* singleQuote */ )}'` : `"${escapeString(node2.text, 34 /* doubleQuote */ )}"`;
                    case 16 /* TemplateHead */ :
                    case 17 /* TemplateMiddle */ :
                    case 18 /* TemplateTail */ :
                        {
                            var _node2_rawText;
                            const rawText = (_node2_rawText = node2.rawText) !== null && _node2_rawText !== void 0 ? _node2_rawText : escapeTemplateSubstitution(escapeString(node2.text, 96 /* backtick */ ));
                            switch(node2.kind){
                                case 16 /* TemplateHead */ :
                                    return "`" + rawText + "${";
                                case 17 /* TemplateMiddle */ :
                                    return "}" + rawText + "${";
                                case 18 /* TemplateTail */ :
                                    return "}" + rawText + "`";
                            }
                        }
                }
                return node2.text;
            }
        }
        function isUndefined(name) {
            return name === "undefined";
        }
        function isHintableDeclaration(node) {
            if ((isPartOfParameterDeclaration(node) || isVariableDeclaration(node) && isVarConst(node)) && node.initializer) {
                const initializer = skipParentheses(node.initializer);
                return !(isHintableLiteral(initializer) || isNewExpression(initializer) || isObjectLiteralExpression(initializer) || isAssertionExpression(initializer));
            }
            return true;
        }
        function getNodeDisplayPart(text, node) {
            const sourceFile = node.getSourceFile();
            return {
                text,
                span: createTextSpanFromNode(node, sourceFile),
                file: sourceFile.fileName
            };
        }
    }
    // src/services/_namespaces/ts.JsDoc.ts
    var ts_JsDoc_exports = {};
    __export(ts_JsDoc_exports, {
        getDocCommentTemplateAtPosition: ()=>getDocCommentTemplateAtPosition,
        getJSDocParameterNameCompletionDetails: ()=>getJSDocParameterNameCompletionDetails,
        getJSDocParameterNameCompletions: ()=>getJSDocParameterNameCompletions,
        getJSDocTagCompletionDetails: ()=>getJSDocTagCompletionDetails,
        getJSDocTagCompletions: ()=>getJSDocTagCompletions,
        getJSDocTagNameCompletionDetails: ()=>getJSDocTagNameCompletionDetails,
        getJSDocTagNameCompletions: ()=>getJSDocTagNameCompletions,
        getJsDocCommentsFromDeclarations: ()=>getJsDocCommentsFromDeclarations,
        getJsDocTagsFromDeclarations: ()=>getJsDocTagsFromDeclarations
    });
    // src/services/jsDoc.ts
    var jsDocTagNames = [
        "abstract",
        "access",
        "alias",
        "argument",
        "async",
        "augments",
        "author",
        "borrows",
        "callback",
        "class",
        "classdesc",
        "constant",
        "constructor",
        "constructs",
        "copyright",
        "default",
        "deprecated",
        "description",
        "emits",
        "enum",
        "event",
        "example",
        "exports",
        "extends",
        "external",
        "field",
        "file",
        "fileoverview",
        "fires",
        "function",
        "generator",
        "global",
        "hideconstructor",
        "host",
        "ignore",
        "implements",
        "import",
        "inheritdoc",
        "inner",
        "instance",
        "interface",
        "kind",
        "lends",
        "license",
        "link",
        "linkcode",
        "linkplain",
        "listens",
        "member",
        "memberof",
        "method",
        "mixes",
        "module",
        "name",
        "namespace",
        "overload",
        "override",
        "package",
        "param",
        "private",
        "prop",
        "property",
        "protected",
        "public",
        "readonly",
        "requires",
        "returns",
        "satisfies",
        "see",
        "since",
        "static",
        "summary",
        "template",
        "this",
        "throws",
        "todo",
        "tutorial",
        "type",
        "typedef",
        "var",
        "variation",
        "version",
        "virtual",
        "yields"
    ];
    var jsDocTagNameCompletionEntries;
    var jsDocTagCompletionEntries;
    function getJsDocCommentsFromDeclarations(declarations, checker) {
        const parts = [];
        forEachUnique(declarations, (declaration)=>{
            for (const jsdoc of getCommentHavingNodes(declaration)){
                const inheritDoc = isJSDoc(jsdoc) && jsdoc.tags && find(jsdoc.tags, (t)=>t.kind === 328 /* JSDocTag */  && (t.tagName.escapedText === "inheritDoc" || t.tagName.escapedText === "inheritdoc"));
                if (jsdoc.comment === void 0 && !inheritDoc || isJSDoc(jsdoc) && declaration.kind !== 347 /* JSDocTypedefTag */  && declaration.kind !== 339 /* JSDocCallbackTag */  && jsdoc.tags && jsdoc.tags.some((t)=>t.kind === 347 /* JSDocTypedefTag */  || t.kind === 339 /* JSDocCallbackTag */ ) && !jsdoc.tags.some((t)=>t.kind === 342 /* JSDocParameterTag */  || t.kind === 343 /* JSDocReturnTag */ )) continue;
                let newparts = jsdoc.comment ? getDisplayPartsFromComment(jsdoc.comment, checker) : [];
                if (inheritDoc && inheritDoc.comment) newparts = newparts.concat(getDisplayPartsFromComment(inheritDoc.comment, checker));
                if (!contains(parts, newparts, isIdenticalListOfDisplayParts)) parts.push(newparts);
            }
        });
        return flatten(intersperse(parts, [
            lineBreakPart()
        ]));
    }
    function isIdenticalListOfDisplayParts(parts1, parts2) {
        return arrayIsEqualTo(parts1, parts2, (p1, p2)=>p1.kind === p2.kind && p1.text === p2.text);
    }
    function getCommentHavingNodes(declaration) {
        switch(declaration.kind){
            case 342 /* JSDocParameterTag */ :
            case 349 /* JSDocPropertyTag */ :
                return [
                    declaration
                ];
            case 339 /* JSDocCallbackTag */ :
            case 347 /* JSDocTypedefTag */ :
                return [
                    declaration,
                    declaration.parent
                ];
            case 324 /* JSDocSignature */ :
                if (isJSDocOverloadTag(declaration.parent)) return [
                    declaration.parent.parent
                ];
            // falls through
            default:
                return getJSDocCommentsAndTags(declaration);
        }
    }
    function getJsDocTagsFromDeclarations(declarations, checker) {
        const infos = [];
        forEachUnique(declarations, (declaration)=>{
            const tags = getJSDocTags(declaration);
            if (tags.some((t)=>t.kind === 347 /* JSDocTypedefTag */  || t.kind === 339 /* JSDocCallbackTag */ ) && !tags.some((t)=>t.kind === 342 /* JSDocParameterTag */  || t.kind === 343 /* JSDocReturnTag */ )) return;
            for (const tag of tags){
                infos.push({
                    name: tag.tagName.text,
                    text: getCommentDisplayParts(tag, checker)
                });
                infos.push(...getJSDocPropertyTagsInfo(tryGetJSDocPropertyTags(tag), checker));
            }
        });
        return infos;
    }
    function getJSDocPropertyTagsInfo(nodes, checker) {
        return flatMap(nodes, (propTag)=>concatenate([
                {
                    name: propTag.tagName.text,
                    text: getCommentDisplayParts(propTag, checker)
                }
            ], getJSDocPropertyTagsInfo(tryGetJSDocPropertyTags(propTag), checker)));
    }
    function tryGetJSDocPropertyTags(node) {
        return isJSDocPropertyLikeTag(node) && node.isNameFirst && node.typeExpression && isJSDocTypeLiteral(node.typeExpression.type) ? node.typeExpression.type.jsDocPropertyTags : void 0;
    }
    function getDisplayPartsFromComment(comment, checker) {
        if (typeof comment === "string") return [
            textPart(comment)
        ];
        return flatMap(comment, (node)=>node.kind === 322 /* JSDocText */  ? [
                textPart(node.text)
            ] : buildLinkParts(node, checker));
    }
    function getCommentDisplayParts(tag, checker) {
        const { comment, kind } = tag;
        const namePart = getTagNameDisplayPart(kind);
        switch(kind){
            case 350 /* JSDocThrowsTag */ :
                const typeExpression = tag.typeExpression;
                return typeExpression ? withNode(typeExpression) : comment === void 0 ? void 0 : getDisplayPartsFromComment(comment, checker);
            case 330 /* JSDocImplementsTag */ :
                return withNode(tag.class);
            case 329 /* JSDocAugmentsTag */ :
                return withNode(tag.class);
            case 346 /* JSDocTemplateTag */ :
                const templateTag = tag;
                const displayParts = [];
                if (templateTag.constraint) displayParts.push(textPart(templateTag.constraint.getText()));
                if (length(templateTag.typeParameters)) {
                    if (length(displayParts)) displayParts.push(spacePart());
                    const lastTypeParameter = templateTag.typeParameters[templateTag.typeParameters.length - 1];
                    forEach(templateTag.typeParameters, (tp)=>{
                        displayParts.push(namePart(tp.getText()));
                        if (lastTypeParameter !== tp) displayParts.push(...[
                            punctuationPart(28 /* CommaToken */ ),
                            spacePart()
                        ]);
                    });
                }
                if (comment) displayParts.push(...[
                    spacePart(),
                    ...getDisplayPartsFromComment(comment, checker)
                ]);
                return displayParts;
            case 345 /* JSDocTypeTag */ :
            case 351 /* JSDocSatisfiesTag */ :
                return withNode(tag.typeExpression);
            case 347 /* JSDocTypedefTag */ :
            case 339 /* JSDocCallbackTag */ :
            case 349 /* JSDocPropertyTag */ :
            case 342 /* JSDocParameterTag */ :
            case 348 /* JSDocSeeTag */ :
                const { name } = tag;
                return name ? withNode(name) : comment === void 0 ? void 0 : getDisplayPartsFromComment(comment, checker);
            default:
                return comment === void 0 ? void 0 : getDisplayPartsFromComment(comment, checker);
        }
        function withNode(node) {
            return addComment(node.getText());
        }
        function addComment(s) {
            if (comment) {
                if (s.match(/^https?$/)) return [
                    textPart(s),
                    ...getDisplayPartsFromComment(comment, checker)
                ];
                else return [
                    namePart(s),
                    spacePart(),
                    ...getDisplayPartsFromComment(comment, checker)
                ];
            } else return [
                textPart(s)
            ];
        }
    }
    function getTagNameDisplayPart(kind) {
        switch(kind){
            case 342 /* JSDocParameterTag */ :
                return parameterNamePart;
            case 349 /* JSDocPropertyTag */ :
                return propertyNamePart;
            case 346 /* JSDocTemplateTag */ :
                return typeParameterNamePart;
            case 347 /* JSDocTypedefTag */ :
            case 339 /* JSDocCallbackTag */ :
                return typeAliasNamePart;
            default:
                return textPart;
        }
    }
    function getJSDocTagNameCompletions() {
        return jsDocTagNameCompletionEntries || (jsDocTagNameCompletionEntries = map(jsDocTagNames, (tagName)=>{
            return {
                name: tagName,
                kind: "keyword" /* keyword */ ,
                kindModifiers: "",
                sortText: ts_Completions_exports.SortText.LocationPriority
            };
        }));
    }
    var getJSDocTagNameCompletionDetails = getJSDocTagCompletionDetails;
    function getJSDocTagCompletions() {
        return jsDocTagCompletionEntries || (jsDocTagCompletionEntries = map(jsDocTagNames, (tagName)=>{
            return {
                name: `@${tagName}`,
                kind: "keyword" /* keyword */ ,
                kindModifiers: "",
                sortText: ts_Completions_exports.SortText.LocationPriority
            };
        }));
    }
    function getJSDocTagCompletionDetails(name) {
        return {
            name,
            kind: "" /* unknown */ ,
            // TODO: should have its own kind?
            kindModifiers: "",
            displayParts: [
                textPart(name)
            ],
            documentation: emptyArray,
            tags: void 0,
            codeActions: void 0
        };
    }
    function getJSDocParameterNameCompletions(tag) {
        if (!isIdentifier(tag.name)) return emptyArray;
        const nameThusFar = tag.name.text;
        const jsdoc = tag.parent;
        const fn = jsdoc.parent;
        if (!isFunctionLike(fn)) return [];
        return mapDefined(fn.parameters, (param)=>{
            if (!isIdentifier(param.name)) return void 0;
            const name = param.name.text;
            if (jsdoc.tags.some((t)=>t !== tag && isJSDocParameterTag(t) && isIdentifier(t.name) && t.name.escapedText === name) || nameThusFar !== void 0 && !startsWith(name, nameThusFar)) return void 0;
            return {
                name,
                kind: "parameter" /* parameterElement */ ,
                kindModifiers: "",
                sortText: ts_Completions_exports.SortText.LocationPriority
            };
        });
    }
    function getJSDocParameterNameCompletionDetails(name) {
        return {
            name,
            kind: "parameter" /* parameterElement */ ,
            kindModifiers: "",
            displayParts: [
                textPart(name)
            ],
            documentation: emptyArray,
            tags: void 0,
            codeActions: void 0
        };
    }
    function getDocCommentTemplateAtPosition(newLine, sourceFile, position, options) {
        const tokenAtPos = getTokenAtPosition(sourceFile, position);
        const existingDocComment = findAncestor(tokenAtPos, isJSDoc);
        if (existingDocComment && (existingDocComment.comment !== void 0 || length(existingDocComment.tags))) return void 0;
        const tokenStart = tokenAtPos.getStart(sourceFile);
        if (!existingDocComment && tokenStart < position) return void 0;
        const commentOwnerInfo = getCommentOwnerInfo(tokenAtPos, options);
        if (!commentOwnerInfo) return void 0;
        const { commentOwner, parameters, hasReturn: hasReturn2 } = commentOwnerInfo;
        const commentOwnerJsDoc = hasJSDocNodes(commentOwner) && commentOwner.jsDoc ? commentOwner.jsDoc : void 0;
        const lastJsDoc = lastOrUndefined(commentOwnerJsDoc);
        if (commentOwner.getStart(sourceFile) < position || lastJsDoc && existingDocComment && lastJsDoc !== existingDocComment) return void 0;
        const indentationStr = getIndentationStringAtPosition(sourceFile, position);
        const isJavaScriptFile = hasJSFileExtension(sourceFile.fileName);
        const tags = (parameters ? parameterDocComments(parameters || [], isJavaScriptFile, indentationStr, newLine) : "") + (hasReturn2 ? returnsDocComment(indentationStr, newLine) : "");
        const openComment = "/**";
        const closeComment = " */";
        const hasTag = length(getJSDocTags(commentOwner)) > 0;
        if (tags && !hasTag) {
            const preamble = openComment + newLine + indentationStr + " * ";
            const endLine = tokenStart === position ? newLine + indentationStr : "";
            const result = preamble + newLine + tags + indentationStr + closeComment + endLine;
            return {
                newText: result,
                caretOffset: preamble.length
            };
        }
        return {
            newText: openComment + closeComment,
            caretOffset: 3
        };
    }
    function getIndentationStringAtPosition(sourceFile, position) {
        const { text } = sourceFile;
        const lineStart = getLineStartPositionForPosition(position, sourceFile);
        let pos = lineStart;
        for(; pos <= position && isWhiteSpaceSingleLine(text.charCodeAt(pos)); pos++);
        return text.slice(lineStart, pos);
    }
    function parameterDocComments(parameters, isJavaScriptFile, indentationStr, newLine) {
        return parameters.map(({ name, dotDotDotToken }, i)=>{
            const paramName = name.kind === 80 /* Identifier */  ? name.text : "param" + i;
            const type = isJavaScriptFile ? dotDotDotToken ? "{...any} " : "{any} " : "";
            return `${indentationStr} * @param ${type}${paramName}${newLine}`;
        }).join("");
    }
    function returnsDocComment(indentationStr, newLine) {
        return `${indentationStr} * @returns${newLine}`;
    }
    function getCommentOwnerInfo(tokenAtPos, options) {
        return forEachAncestor(tokenAtPos, (n)=>getCommentOwnerInfoWorker(n, options));
    }
    function getCommentOwnerInfoWorker(commentOwner, options) {
        switch(commentOwner.kind){
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 175 /* MethodDeclaration */ :
            case 177 /* Constructor */ :
            case 174 /* MethodSignature */ :
            case 220 /* ArrowFunction */ :
                const host = commentOwner;
                return {
                    commentOwner,
                    parameters: host.parameters,
                    hasReturn: hasReturn(host, options)
                };
            case 304 /* PropertyAssignment */ :
                return getCommentOwnerInfoWorker(commentOwner.initializer, options);
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 307 /* EnumMember */ :
            case 266 /* TypeAliasDeclaration */ :
                return {
                    commentOwner
                };
            case 172 /* PropertySignature */ :
                {
                    const host2 = commentOwner;
                    return host2.type && isFunctionTypeNode(host2.type) ? {
                        commentOwner,
                        parameters: host2.type.parameters,
                        hasReturn: hasReturn(host2.type, options)
                    } : {
                        commentOwner
                    };
                }
            case 244 /* VariableStatement */ :
                {
                    const varStatement = commentOwner;
                    const varDeclarations = varStatement.declarationList.declarations;
                    const host2 = varDeclarations.length === 1 && varDeclarations[0].initializer ? getRightHandSideOfAssignment(varDeclarations[0].initializer) : void 0;
                    return host2 ? {
                        commentOwner,
                        parameters: host2.parameters,
                        hasReturn: hasReturn(host2, options)
                    } : {
                        commentOwner
                    };
                }
            case 308 /* SourceFile */ :
                return "quit";
            case 268 /* ModuleDeclaration */ :
                return commentOwner.parent.kind === 268 /* ModuleDeclaration */  ? void 0 : {
                    commentOwner
                };
            case 245 /* ExpressionStatement */ :
                return getCommentOwnerInfoWorker(commentOwner.expression, options);
            case 227 /* BinaryExpression */ :
                {
                    const be = commentOwner;
                    if (getAssignmentDeclarationKind(be) === 0 /* None */ ) return "quit";
                    return isFunctionLike(be.right) ? {
                        commentOwner,
                        parameters: be.right.parameters,
                        hasReturn: hasReturn(be.right, options)
                    } : {
                        commentOwner
                    };
                }
            case 173 /* PropertyDeclaration */ :
                const init = commentOwner.initializer;
                if (init && (isFunctionExpression(init) || isArrowFunction(init))) return {
                    commentOwner,
                    parameters: init.parameters,
                    hasReturn: hasReturn(init, options)
                };
        }
    }
    function hasReturn(node, options) {
        return !!(options == null ? void 0 : options.generateReturnInDocTemplate) && (isFunctionTypeNode(node) || isArrowFunction(node) && isExpression(node.body) || isFunctionLikeDeclaration(node) && node.body && isBlock(node.body) && !!forEachReturnStatement(node.body, (n)=>n));
    }
    function getRightHandSideOfAssignment(rightHandSide) {
        while(rightHandSide.kind === 218 /* ParenthesizedExpression */ )rightHandSide = rightHandSide.expression;
        switch(rightHandSide.kind){
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                return rightHandSide;
            case 232 /* ClassExpression */ :
                return find(rightHandSide.members, isConstructorDeclaration);
        }
    }
    // src/services/_namespaces/ts.MapCode.ts
    var ts_MapCode_exports = {};
    __export(ts_MapCode_exports, {
        mapCode: ()=>mapCode
    });
    // src/services/mapCode.ts
    function mapCode(sourceFile, contents, focusLocations, host, formatContext, preferences) {
        return ts_textChanges_exports.ChangeTracker.with({
            host,
            formatContext,
            preferences
        }, (changeTracker)=>{
            const parsed = contents.map((c)=>parse(sourceFile, c));
            const flattenedLocations = focusLocations && flatten(focusLocations);
            for (const nodes of parsed)placeNodeGroup(sourceFile, changeTracker, nodes, flattenedLocations);
        });
    }
    function parse(sourceFile, content) {
        const nodeKinds = [
            {
                parse: ()=>createSourceFile("__mapcode_content_nodes.ts", content, sourceFile.languageVersion, /*setParentNodes*/ true, sourceFile.scriptKind),
                body: (sf)=>sf.statements
            },
            {
                parse: ()=>createSourceFile("__mapcode_class_content_nodes.ts", `class __class {
${content}
}`, sourceFile.languageVersion, /*setParentNodes*/ true, sourceFile.scriptKind),
                body: (cw)=>cw.statements[0].members
            }
        ];
        const parsedNodes = [];
        for (const { parse: parse2, body: body2 } of nodeKinds){
            const sourceFile2 = parse2();
            const bod = body2(sourceFile2);
            if (bod.length && sourceFile2.parseDiagnostics.length === 0) return bod;
            else if (bod.length) parsedNodes.push({
                sourceFile: sourceFile2,
                body: bod
            });
        }
        parsedNodes.sort((a, b)=>a.sourceFile.parseDiagnostics.length - b.sourceFile.parseDiagnostics.length);
        const { body } = parsedNodes[0];
        return body;
    }
    function placeNodeGroup(originalFile, changeTracker, changes, focusLocations) {
        if (isClassElement(changes[0]) || isTypeElement(changes[0])) placeClassNodeGroup(originalFile, changeTracker, changes, focusLocations);
        else placeStatements(originalFile, changeTracker, changes, focusLocations);
    }
    function placeClassNodeGroup(originalFile, changeTracker, changes, focusLocations) {
        let classOrInterface;
        if (!focusLocations || !focusLocations.length) classOrInterface = find(originalFile.statements, or(isClassLike, isInterfaceDeclaration));
        else classOrInterface = forEach(focusLocations, (location)=>findAncestor(getTokenAtPosition(originalFile, location.start), or(isClassLike, isInterfaceDeclaration)));
        if (!classOrInterface) return;
        const firstMatch = classOrInterface.members.find((member)=>changes.some((change)=>matchNode(change, member)));
        if (firstMatch) {
            const lastMatch = findLast(classOrInterface.members, (member)=>changes.some((change)=>matchNode(change, member)));
            forEach(changes, wipeNode);
            changeTracker.replaceNodeRangeWithNodes(originalFile, firstMatch, lastMatch, changes);
            return;
        }
        forEach(changes, wipeNode);
        changeTracker.insertNodesAfter(originalFile, classOrInterface.members[classOrInterface.members.length - 1], changes);
    }
    function placeStatements(originalFile, changeTracker, changes, focusLocations) {
        if (!(focusLocations == null ? void 0 : focusLocations.length)) {
            changeTracker.insertNodesAtEndOfFile(originalFile, changes, /*blankLineBetween*/ false);
            return;
        }
        for (const location of focusLocations){
            const scope = findAncestor(getTokenAtPosition(originalFile, location.start), (block)=>or(isBlock, isSourceFile)(block) && some(block.statements, (origStmt)=>changes.some((newStmt)=>matchNode(newStmt, origStmt))));
            if (scope) {
                const start = scope.statements.find((stmt)=>changes.some((node)=>matchNode(node, stmt)));
                if (start) {
                    const end = findLast(scope.statements, (stmt)=>changes.some((node)=>matchNode(node, stmt)));
                    forEach(changes, wipeNode);
                    changeTracker.replaceNodeRangeWithNodes(originalFile, start, end, changes);
                    return;
                }
            }
        }
        let scopeStatements = originalFile.statements;
        for (const location of focusLocations){
            const block = findAncestor(getTokenAtPosition(originalFile, location.start), isBlock);
            if (block) {
                scopeStatements = block.statements;
                break;
            }
        }
        forEach(changes, wipeNode);
        changeTracker.insertNodesAfter(originalFile, scopeStatements[scopeStatements.length - 1], changes);
    }
    function matchNode(a, b) {
        var _a, _b, _c, _d, _e, _f;
        if (a.kind !== b.kind) return false;
        if (a.kind === 177 /* Constructor */ ) return a.kind === b.kind;
        if (isNamedDeclaration(a) && isNamedDeclaration(b)) return a.name.getText() === b.name.getText();
        if (isIfStatement(a) && isIfStatement(b)) return a.expression.getText() === b.expression.getText();
        if (isWhileStatement(a) && isWhileStatement(b)) return a.expression.getText() === b.expression.getText();
        if (isForStatement(a) && isForStatement(b)) return ((_a = a.initializer) == null ? void 0 : _a.getText()) === ((_b = b.initializer) == null ? void 0 : _b.getText()) && ((_c = a.incrementor) == null ? void 0 : _c.getText()) === ((_d = b.incrementor) == null ? void 0 : _d.getText()) && ((_e = a.condition) == null ? void 0 : _e.getText()) === ((_f = b.condition) == null ? void 0 : _f.getText());
        if (isForInOrOfStatement(a) && isForInOrOfStatement(b)) return a.expression.getText() === b.expression.getText() && a.initializer.getText() === b.initializer.getText();
        if (isLabeledStatement(a) && isLabeledStatement(b)) return a.label.getText() === b.label.getText();
        if (a.getText() === b.getText()) return true;
        return false;
    }
    function wipeNode(node) {
        resetNodePositions(node);
        node.parent = void 0;
    }
    function resetNodePositions(node) {
        node.pos = -1;
        node.end = -1;
        node.forEachChild(resetNodePositions);
    }
    // src/services/_namespaces/ts.OrganizeImports.ts
    var ts_OrganizeImports_exports = {};
    __export(ts_OrganizeImports_exports, {
        compareImportsOrRequireStatements: ()=>compareImportsOrRequireStatements,
        compareModuleSpecifiers: ()=>compareModuleSpecifiers2,
        getImportDeclarationInsertionIndex: ()=>getImportDeclarationInsertionIndex,
        getImportSpecifierInsertionIndex: ()=>getImportSpecifierInsertionIndex,
        getNamedImportSpecifierComparerWithDetection: ()=>getNamedImportSpecifierComparerWithDetection,
        getOrganizeImportsStringComparerWithDetection: ()=>getOrganizeImportsStringComparerWithDetection,
        organizeImports: ()=>organizeImports,
        testCoalesceExports: ()=>testCoalesceExports,
        testCoalesceImports: ()=>testCoalesceImports
    });
    // src/services/organizeImports.ts
    function organizeImports(sourceFile, formatContext, host, program, preferences, mode) {
        const changeTracker = ts_textChanges_exports.ChangeTracker.fromContext({
            host,
            formatContext,
            preferences
        });
        const shouldSort = mode === "SortAndCombine" /* SortAndCombine */  || mode === "All" /* All */ ;
        const shouldCombine = shouldSort;
        const shouldRemove = mode === "RemoveUnused" /* RemoveUnused */  || mode === "All" /* All */ ;
        const topLevelImportDecls = sourceFile.statements.filter(isImportDeclaration);
        const topLevelImportGroupDecls = groupByNewlineContiguous(sourceFile, topLevelImportDecls);
        const { comparersToTest, typeOrdersToTest } = getDetectionLists(preferences);
        const defaultComparer = comparersToTest[0];
        const comparer = {
            moduleSpecifierComparer: typeof preferences.organizeImportsIgnoreCase === "boolean" ? defaultComparer : void 0,
            namedImportComparer: typeof preferences.organizeImportsIgnoreCase === "boolean" ? defaultComparer : void 0,
            typeOrder: preferences.organizeImportsTypeOrder
        };
        if (typeof preferences.organizeImportsIgnoreCase !== "boolean") ({ comparer: comparer.moduleSpecifierComparer } = detectModuleSpecifierCaseBySort(topLevelImportGroupDecls, comparersToTest));
        if (!comparer.typeOrder || typeof preferences.organizeImportsIgnoreCase !== "boolean") {
            const namedImportSort = detectNamedImportOrganizationBySort(topLevelImportDecls, comparersToTest, typeOrdersToTest);
            if (namedImportSort) {
                const { namedImportComparer, typeOrder } = namedImportSort;
                var _comparer_namedImportComparer;
                comparer.namedImportComparer = (_comparer_namedImportComparer = comparer.namedImportComparer) !== null && _comparer_namedImportComparer !== void 0 ? _comparer_namedImportComparer : namedImportComparer;
                var _comparer_typeOrder;
                comparer.typeOrder = (_comparer_typeOrder = comparer.typeOrder) !== null && _comparer_typeOrder !== void 0 ? _comparer_typeOrder : typeOrder;
            }
        }
        topLevelImportGroupDecls.forEach((importGroupDecl)=>organizeImportsWorker(importGroupDecl, comparer));
        if (mode !== "RemoveUnused" /* RemoveUnused */ ) getTopLevelExportGroups(sourceFile).forEach((exportGroupDecl)=>organizeExportsWorker(exportGroupDecl, comparer.namedImportComparer));
        for (const ambientModule of sourceFile.statements.filter(isAmbientModule)){
            if (!ambientModule.body) continue;
            const ambientModuleImportGroupDecls = groupByNewlineContiguous(sourceFile, ambientModule.body.statements.filter(isImportDeclaration));
            ambientModuleImportGroupDecls.forEach((importGroupDecl)=>organizeImportsWorker(importGroupDecl, comparer));
            if (mode !== "RemoveUnused" /* RemoveUnused */ ) {
                const ambientModuleExportDecls = ambientModule.body.statements.filter(isExportDeclaration);
                organizeExportsWorker(ambientModuleExportDecls, comparer.namedImportComparer);
            }
        }
        return changeTracker.getChanges();
        function organizeDeclsWorker(oldImportDecls, coalesce) {
            if (length(oldImportDecls) === 0) return;
            setEmitFlags(oldImportDecls[0], 1024 /* NoLeadingComments */ );
            const oldImportGroups = shouldCombine ? group(oldImportDecls, (importDecl)=>getExternalModuleName2(importDecl.moduleSpecifier)) : [
                oldImportDecls
            ];
            const sortedImportGroups = shouldSort ? toSorted(oldImportGroups, (group1, group2)=>{
                var _comparer_moduleSpecifierComparer;
                return compareModuleSpecifiersWorker(group1[0].moduleSpecifier, group2[0].moduleSpecifier, (_comparer_moduleSpecifierComparer = comparer.moduleSpecifierComparer) !== null && _comparer_moduleSpecifierComparer !== void 0 ? _comparer_moduleSpecifierComparer : defaultComparer);
            }) : oldImportGroups;
            const newImportDecls = flatMap(sortedImportGroups, (importGroup)=>getExternalModuleName2(importGroup[0].moduleSpecifier) || importGroup[0].moduleSpecifier === void 0 ? coalesce(importGroup) : importGroup);
            if (newImportDecls.length === 0) changeTracker.deleteNodes(sourceFile, oldImportDecls, {
                leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
                trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
            }, /*hasTrailingComment*/ true);
            else {
                const replaceOptions = {
                    leadingTriviaOption: ts_textChanges_exports.LeadingTriviaOption.Exclude,
                    // Leave header comment in place
                    trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include,
                    suffix: getNewLineOrDefaultFromHost(host, formatContext.options)
                };
                changeTracker.replaceNodeWithNodes(sourceFile, oldImportDecls[0], newImportDecls, replaceOptions);
                const hasTrailingComment = changeTracker.nodeHasTrailingComment(sourceFile, oldImportDecls[0], replaceOptions);
                changeTracker.deleteNodes(sourceFile, oldImportDecls.slice(1), {
                    trailingTriviaOption: ts_textChanges_exports.TrailingTriviaOption.Include
                }, hasTrailingComment);
            }
        }
        function organizeImportsWorker(oldImportDecls, comparer2) {
            var _comparer2_moduleSpecifierComparer;
            const detectedModuleCaseComparer = (_comparer2_moduleSpecifierComparer = comparer2.moduleSpecifierComparer) !== null && _comparer2_moduleSpecifierComparer !== void 0 ? _comparer2_moduleSpecifierComparer : defaultComparer;
            var _comparer2_namedImportComparer;
            const detectedNamedImportCaseComparer = (_comparer2_namedImportComparer = comparer2.namedImportComparer) !== null && _comparer2_namedImportComparer !== void 0 ? _comparer2_namedImportComparer : defaultComparer;
            var _comparer2_typeOrder;
            const detectedTypeOrder = (_comparer2_typeOrder = comparer2.typeOrder) !== null && _comparer2_typeOrder !== void 0 ? _comparer2_typeOrder : "last";
            const specifierComparer = getNamedImportSpecifierComparer({
                organizeImportsTypeOrder: detectedTypeOrder
            }, detectedNamedImportCaseComparer);
            const processImportsOfSameModuleSpecifier = (importGroup)=>{
                if (shouldRemove) importGroup = removeUnusedImports(importGroup, sourceFile, program);
                if (shouldCombine) importGroup = coalesceImportsWorker(importGroup, detectedModuleCaseComparer, specifierComparer, sourceFile);
                if (shouldSort) importGroup = toSorted(importGroup, (s1, s2)=>compareImportsOrRequireStatements(s1, s2, detectedModuleCaseComparer));
                return importGroup;
            };
            organizeDeclsWorker(oldImportDecls, processImportsOfSameModuleSpecifier);
        }
        function organizeExportsWorker(oldExportDecls, specifierCaseComparer) {
            const useComparer = getNamedImportSpecifierComparer(preferences, specifierCaseComparer);
            organizeDeclsWorker(oldExportDecls, (group2)=>coalesceExportsWorker(group2, useComparer));
        }
    }
    function getDetectionLists(preferences) {
        return {
            comparersToTest: typeof preferences.organizeImportsIgnoreCase === "boolean" ? [
                getOrganizeImportsStringComparer(preferences, preferences.organizeImportsIgnoreCase)
            ] : [
                getOrganizeImportsStringComparer(preferences, /*ignoreCase*/ true),
                getOrganizeImportsStringComparer(preferences, /*ignoreCase*/ false)
            ],
            typeOrdersToTest: preferences.organizeImportsTypeOrder ? [
                preferences.organizeImportsTypeOrder
            ] : [
                "last",
                "inline",
                "first"
            ]
        };
    }
    function groupByNewlineContiguous(sourceFile, decls) {
        const scanner2 = createScanner(sourceFile.languageVersion, /*skipTrivia*/ false, sourceFile.languageVariant);
        const group2 = [];
        let groupIndex = 0;
        for (const decl of decls){
            if (group2[groupIndex] && isNewGroup(sourceFile, decl, scanner2)) groupIndex++;
            if (!group2[groupIndex]) group2[groupIndex] = [];
            group2[groupIndex].push(decl);
        }
        return group2;
    }
    function isNewGroup(sourceFile, decl, scanner2) {
        const startPos = decl.getFullStart();
        const endPos = decl.getStart();
        scanner2.setText(sourceFile.text, startPos, endPos - startPos);
        let numberOfNewLines = 0;
        while(scanner2.getTokenStart() < endPos){
            const tokenKind = scanner2.scan();
            if (tokenKind === 4 /* NewLineTrivia */ ) {
                numberOfNewLines++;
                if (numberOfNewLines >= 2) return true;
            }
        }
        return false;
    }
    function getTopLevelExportGroups(sourceFile) {
        const topLevelExportGroups = [];
        const statements = sourceFile.statements;
        const len = length(statements);
        let i = 0;
        let groupIndex = 0;
        while(i < len)if (isExportDeclaration(statements[i])) {
            if (topLevelExportGroups[groupIndex] === void 0) topLevelExportGroups[groupIndex] = [];
            const exportDecl = statements[i];
            if (exportDecl.moduleSpecifier) {
                topLevelExportGroups[groupIndex].push(exportDecl);
                i++;
            } else {
                while(i < len && isExportDeclaration(statements[i]))topLevelExportGroups[groupIndex].push(statements[i++]);
                groupIndex++;
            }
        } else i++;
        return flatMap(topLevelExportGroups, (exportGroupDecls)=>groupByNewlineContiguous(sourceFile, exportGroupDecls));
    }
    function removeUnusedImports(oldImports, sourceFile, program) {
        const typeChecker = program.getTypeChecker();
        const compilerOptions = program.getCompilerOptions();
        const jsxNamespace = typeChecker.getJsxNamespace(sourceFile);
        const jsxFragmentFactory = typeChecker.getJsxFragmentFactory(sourceFile);
        const jsxElementsPresent = !!(sourceFile.transformFlags & 2 /* ContainsJsx */ );
        const usedImports = [];
        for (const importDecl of oldImports){
            const { importClause, moduleSpecifier } = importDecl;
            if (!importClause) {
                usedImports.push(importDecl);
                continue;
            }
            let { name, namedBindings } = importClause;
            if (name && !isDeclarationUsed(name)) name = void 0;
            if (namedBindings) {
                if (isNamespaceImport(namedBindings)) {
                    if (!isDeclarationUsed(namedBindings.name)) namedBindings = void 0;
                } else {
                    const newElements = namedBindings.elements.filter((e)=>isDeclarationUsed(e.name));
                    if (newElements.length < namedBindings.elements.length) namedBindings = newElements.length ? factory.updateNamedImports(namedBindings, newElements) : void 0;
                }
            }
            if (name || namedBindings) usedImports.push(updateImportDeclarationAndClause(importDecl, name, namedBindings));
            else if (hasModuleDeclarationMatchingSpecifier(sourceFile, moduleSpecifier)) {
                if (sourceFile.isDeclarationFile) usedImports.push(factory.createImportDeclaration(importDecl.modifiers, /*importClause*/ void 0, moduleSpecifier, /*attributes*/ void 0));
                else usedImports.push(importDecl);
            }
        }
        return usedImports;
        function isDeclarationUsed(identifier) {
            return jsxElementsPresent && (identifier.text === jsxNamespace || jsxFragmentFactory && identifier.text === jsxFragmentFactory) && jsxModeNeedsExplicitImport(compilerOptions.jsx) || ts_FindAllReferences_exports.Core.isSymbolReferencedInFile(identifier, typeChecker, sourceFile);
        }
    }
    function getExternalModuleName2(specifier) {
        return specifier !== void 0 && isStringLiteralLike(specifier) ? specifier.text : void 0;
    }
    function getCategorizedImports(importGroup) {
        let importWithoutClause;
        const typeOnlyImports = {
            defaultImports: [],
            namespaceImports: [],
            namedImports: []
        };
        const regularImports = {
            defaultImports: [],
            namespaceImports: [],
            namedImports: []
        };
        for (const importDeclaration of importGroup){
            if (importDeclaration.importClause === void 0) {
                importWithoutClause = importWithoutClause || importDeclaration;
                continue;
            }
            const group2 = importDeclaration.importClause.isTypeOnly ? typeOnlyImports : regularImports;
            const { name, namedBindings } = importDeclaration.importClause;
            if (name) group2.defaultImports.push(importDeclaration);
            if (namedBindings) {
                if (isNamespaceImport(namedBindings)) group2.namespaceImports.push(importDeclaration);
                else group2.namedImports.push(importDeclaration);
            }
        }
        return {
            importWithoutClause,
            typeOnlyImports,
            regularImports
        };
    }
    function coalesceImportsWorker(importGroup, comparer, specifierComparer, sourceFile) {
        if (importGroup.length === 0) return importGroup;
        const importGroupsByAttributes = groupBy(importGroup, (decl)=>{
            if (decl.attributes) {
                let attrs = decl.attributes.token + " ";
                for (const x of toSorted(decl.attributes.elements, (x2, y)=>compareStringsCaseSensitive(x2.name.text, y.name.text))){
                    attrs += x.name.text + ":";
                    attrs += isStringLiteralLike(x.value) ? `"${x.value.text}"` : x.value.getText() + " ";
                }
                return attrs;
            }
            return "";
        });
        const coalescedImports = [];
        for(const attribute in importGroupsByAttributes){
            const importGroupSameAttrs = importGroupsByAttributes[attribute];
            const { importWithoutClause, typeOnlyImports, regularImports } = getCategorizedImports(importGroupSameAttrs);
            if (importWithoutClause) coalescedImports.push(importWithoutClause);
            for (const group2 of [
                regularImports,
                typeOnlyImports
            ]){
                const isTypeOnly = group2 === typeOnlyImports;
                const { defaultImports, namespaceImports, namedImports } = group2;
                if (!isTypeOnly && defaultImports.length === 1 && namespaceImports.length === 1 && namedImports.length === 0) {
                    const defaultImport = defaultImports[0];
                    coalescedImports.push(updateImportDeclarationAndClause(defaultImport, defaultImport.importClause.name, namespaceImports[0].importClause.namedBindings));
                    continue;
                }
                const sortedNamespaceImports = toSorted(namespaceImports, (i1, i2)=>comparer(i1.importClause.namedBindings.name.text, i2.importClause.namedBindings.name.text));
                for (const namespaceImport of sortedNamespaceImports)coalescedImports.push(updateImportDeclarationAndClause(namespaceImport, /*name*/ void 0, namespaceImport.importClause.namedBindings));
                const firstDefaultImport = firstOrUndefined(defaultImports);
                const firstNamedImport = firstOrUndefined(namedImports);
                const importDecl = firstDefaultImport !== null && firstDefaultImport !== void 0 ? firstDefaultImport : firstNamedImport;
                if (!importDecl) continue;
                let newDefaultImport;
                const newImportSpecifiers = [];
                if (defaultImports.length === 1) newDefaultImport = defaultImports[0].importClause.name;
                else for (const defaultImport of defaultImports)newImportSpecifiers.push(factory.createImportSpecifier(/*isTypeOnly*/ false, factory.createIdentifier("default"), defaultImport.importClause.name));
                newImportSpecifiers.push(...getNewImportSpecifiers(namedImports));
                const sortedImportSpecifiers = factory.createNodeArray(toSorted(newImportSpecifiers, specifierComparer), firstNamedImport == null ? void 0 : firstNamedImport.importClause.namedBindings.elements.hasTrailingComma);
                const newNamedImports = sortedImportSpecifiers.length === 0 ? newDefaultImport ? void 0 : factory.createNamedImports(emptyArray) : firstNamedImport ? factory.updateNamedImports(firstNamedImport.importClause.namedBindings, sortedImportSpecifiers) : factory.createNamedImports(sortedImportSpecifiers);
                if (sourceFile && newNamedImports && (firstNamedImport == null ? void 0 : firstNamedImport.importClause.namedBindings) && !rangeIsOnSingleLine(firstNamedImport.importClause.namedBindings, sourceFile)) setEmitFlags(newNamedImports, 2 /* MultiLine */ );
                if (isTypeOnly && newDefaultImport && newNamedImports) {
                    coalescedImports.push(updateImportDeclarationAndClause(importDecl, newDefaultImport, /*namedBindings*/ void 0));
                    coalescedImports.push(updateImportDeclarationAndClause(firstNamedImport !== null && firstNamedImport !== void 0 ? firstNamedImport : importDecl, /*name*/ void 0, newNamedImports));
                } else coalescedImports.push(updateImportDeclarationAndClause(importDecl, newDefaultImport, newNamedImports));
            }
        }
        return coalescedImports;
    }
    function coalesceExportsWorker(exportGroup, specifierComparer) {
        if (exportGroup.length === 0) return exportGroup;
        const { exportWithoutClause, namedExports, typeOnlyExports } = getCategorizedExports(exportGroup);
        const coalescedExports = [];
        if (exportWithoutClause) coalescedExports.push(exportWithoutClause);
        for (const exportGroup2 of [
            namedExports,
            typeOnlyExports
        ]){
            if (exportGroup2.length === 0) continue;
            const newExportSpecifiers = [];
            newExportSpecifiers.push(...flatMap(exportGroup2, (i)=>i.exportClause && isNamedExports(i.exportClause) ? i.exportClause.elements : emptyArray));
            const sortedExportSpecifiers = toSorted(newExportSpecifiers, specifierComparer);
            const exportDecl = exportGroup2[0];
            coalescedExports.push(factory.updateExportDeclaration(exportDecl, exportDecl.modifiers, exportDecl.isTypeOnly, exportDecl.exportClause && (isNamedExports(exportDecl.exportClause) ? factory.updateNamedExports(exportDecl.exportClause, sortedExportSpecifiers) : factory.updateNamespaceExport(exportDecl.exportClause, exportDecl.exportClause.name)), exportDecl.moduleSpecifier, exportDecl.attributes));
        }
        return coalescedExports;
        function getCategorizedExports(exportGroup2) {
            let exportWithoutClause2;
            const namedExports2 = [];
            const typeOnlyExports2 = [];
            for (const exportDeclaration of exportGroup2){
                if (exportDeclaration.exportClause === void 0) exportWithoutClause2 = exportWithoutClause2 || exportDeclaration;
                else if (exportDeclaration.isTypeOnly) typeOnlyExports2.push(exportDeclaration);
                else namedExports2.push(exportDeclaration);
            }
            return {
                exportWithoutClause: exportWithoutClause2,
                namedExports: namedExports2,
                typeOnlyExports: typeOnlyExports2
            };
        }
    }
    function updateImportDeclarationAndClause(importDeclaration, name, namedBindings) {
        return factory.updateImportDeclaration(importDeclaration, importDeclaration.modifiers, factory.updateImportClause(importDeclaration.importClause, importDeclaration.importClause.phaseModifier, name, namedBindings), // TODO: GH#18217
        importDeclaration.moduleSpecifier, importDeclaration.attributes);
    }
    function compareImportOrExportSpecifiers(s1, s2, comparer, preferences) {
        switch(preferences == null ? void 0 : preferences.organizeImportsTypeOrder){
            case "first":
                return compareBooleans(s2.isTypeOnly, s1.isTypeOnly) || comparer(s1.name.text, s2.name.text);
            case "inline":
                return comparer(s1.name.text, s2.name.text);
            default:
                return compareBooleans(s1.isTypeOnly, s2.isTypeOnly) || comparer(s1.name.text, s2.name.text);
        }
    }
    function compareModuleSpecifiersWorker(m1, m2, comparer) {
        const name1 = m1 === void 0 ? void 0 : getExternalModuleName2(m1);
        const name2 = m2 === void 0 ? void 0 : getExternalModuleName2(m2);
        return compareBooleans(name1 === void 0, name2 === void 0) || compareBooleans(isExternalModuleNameRelative(name1), isExternalModuleNameRelative(name2)) || comparer(name1, name2);
    }
    function getModuleNamesFromDecls(decls) {
        return decls.map((s)=>getExternalModuleName2(getModuleSpecifierExpression(s)) || "");
    }
    function getModuleSpecifierExpression(declaration) {
        var _a;
        switch(declaration.kind){
            case 272 /* ImportEqualsDeclaration */ :
                return (_a = tryCast(declaration.moduleReference, isExternalModuleReference)) == null ? void 0 : _a.expression;
            case 273 /* ImportDeclaration */ :
                return declaration.moduleSpecifier;
            case 244 /* VariableStatement */ :
                return declaration.declarationList.declarations[0].initializer.arguments[0];
        }
    }
    function hasModuleDeclarationMatchingSpecifier(sourceFile, moduleSpecifier) {
        const moduleSpecifierText = isStringLiteral(moduleSpecifier) && moduleSpecifier.text;
        return isString(moduleSpecifierText) && some(sourceFile.moduleAugmentations, (moduleName)=>isStringLiteral(moduleName) && moduleName.text === moduleSpecifierText);
    }
    function getNewImportSpecifiers(namedImports) {
        return flatMap(namedImports, (namedImport)=>map(tryGetNamedBindingElements(namedImport), (importSpecifier)=>importSpecifier.name && importSpecifier.propertyName && moduleExportNameTextEscaped(importSpecifier.name) === moduleExportNameTextEscaped(importSpecifier.propertyName) ? factory.updateImportSpecifier(importSpecifier, importSpecifier.isTypeOnly, /*propertyName*/ void 0, importSpecifier.name) : importSpecifier));
    }
    function tryGetNamedBindingElements(namedImport) {
        var _a;
        return ((_a = namedImport.importClause) == null ? void 0 : _a.namedBindings) && isNamedImports(namedImport.importClause.namedBindings) ? namedImport.importClause.namedBindings.elements : void 0;
    }
    function detectModuleSpecifierCaseBySort(importDeclsByGroup, comparersToTest) {
        const moduleSpecifiersByGroup = [];
        importDeclsByGroup.forEach((importGroup)=>{
            moduleSpecifiersByGroup.push(getModuleNamesFromDecls(importGroup));
        });
        return detectCaseSensitivityBySort(moduleSpecifiersByGroup, comparersToTest);
    }
    function detectNamedImportOrganizationBySort(originalGroups, comparersToTest, typesToTest) {
        let bothNamedImports = false;
        const importDeclsWithNamed = originalGroups.filter((i)=>{
            var _a, _b;
            const namedImports = (_b = tryCast((_a = i.importClause) == null ? void 0 : _a.namedBindings, isNamedImports)) == null ? void 0 : _b.elements;
            if (!(namedImports == null ? void 0 : namedImports.length)) return false;
            if (!bothNamedImports && namedImports.some((n)=>n.isTypeOnly) && namedImports.some((n)=>!n.isTypeOnly)) bothNamedImports = true;
            return true;
        });
        if (importDeclsWithNamed.length === 0) return;
        const namedImportsByDecl = importDeclsWithNamed.map((importDecl)=>{
            var _a, _b;
            return (_b = tryCast((_a = importDecl.importClause) == null ? void 0 : _a.namedBindings, isNamedImports)) == null ? void 0 : _b.elements;
        }).filter((elements)=>elements !== void 0);
        if (!bothNamedImports || typesToTest.length === 0) {
            const sortState = detectCaseSensitivityBySort(namedImportsByDecl.map((i)=>i.map((n)=>n.name.text)), comparersToTest);
            return {
                namedImportComparer: sortState.comparer,
                typeOrder: typesToTest.length === 1 ? typesToTest[0] : void 0,
                isSorted: sortState.isSorted
            };
        }
        const bestDiff = {
            first: Infinity,
            last: Infinity,
            inline: Infinity
        };
        const bestComparer = {
            first: comparersToTest[0],
            last: comparersToTest[0],
            inline: comparersToTest[0]
        };
        for (const curComparer of comparersToTest){
            const currDiff = {
                first: 0,
                last: 0,
                inline: 0
            };
            var _currDiff_typeOrder;
            for (const importDecl of namedImportsByDecl)for (const typeOrder of typesToTest)currDiff[typeOrder] = ((_currDiff_typeOrder = currDiff[typeOrder]) !== null && _currDiff_typeOrder !== void 0 ? _currDiff_typeOrder : 0) + measureSortedness(importDecl, (n1, n2)=>compareImportOrExportSpecifiers(n1, n2, curComparer, {
                    organizeImportsTypeOrder: typeOrder
                }));
            for (const key of typesToTest){
                const typeOrder = key;
                if (currDiff[typeOrder] < bestDiff[typeOrder]) {
                    bestDiff[typeOrder] = currDiff[typeOrder];
                    bestComparer[typeOrder] = curComparer;
                }
            }
        }
        outer: for (const bestKey of typesToTest){
            const bestTypeOrder = bestKey;
            for (const testKey of typesToTest){
                const testTypeOrder = testKey;
                if (bestDiff[testTypeOrder] < bestDiff[bestTypeOrder]) continue outer;
            }
            return {
                namedImportComparer: bestComparer[bestTypeOrder],
                typeOrder: bestTypeOrder,
                isSorted: bestDiff[bestTypeOrder] === 0
            };
        }
        return {
            namedImportComparer: bestComparer.last,
            typeOrder: "last",
            isSorted: bestDiff.last === 0
        };
    }
    function measureSortedness(arr, comparer) {
        let i = 0;
        for(let j = 0; j < arr.length - 1; j++)if (comparer(arr[j], arr[j + 1]) > 0) i++;
        return i;
    }
    function detectCaseSensitivityBySort(originalGroups, comparersToTest) {
        let bestComparer;
        let bestDiff = Infinity;
        for (const curComparer of comparersToTest){
            let diffOfCurrentComparer = 0;
            for (const listToSort of originalGroups){
                if (listToSort.length <= 1) continue;
                const diff = measureSortedness(listToSort, curComparer);
                diffOfCurrentComparer += diff;
            }
            if (diffOfCurrentComparer < bestDiff) {
                bestDiff = diffOfCurrentComparer;
                bestComparer = curComparer;
            }
        }
        return {
            comparer: bestComparer !== null && bestComparer !== void 0 ? bestComparer : comparersToTest[0],
            isSorted: bestDiff === 0
        };
    }
    function compareImportKind(s1, s2) {
        return compareValues(getImportKindOrder(s1), getImportKindOrder(s2));
    }
    function getImportKindOrder(s1) {
        var _a;
        switch(s1.kind){
            case 273 /* ImportDeclaration */ :
                if (!s1.importClause) return 0;
                if (s1.importClause.isTypeOnly) return 1;
                if (((_a = s1.importClause.namedBindings) == null ? void 0 : _a.kind) === 275 /* NamespaceImport */ ) return 2;
                if (s1.importClause.name) return 3;
                return 4;
            case 272 /* ImportEqualsDeclaration */ :
                return 5;
            case 244 /* VariableStatement */ :
                return 6;
        }
    }
    function getOrganizeImportsOrdinalStringComparer(ignoreCase) {
        return ignoreCase ? compareStringsCaseInsensitiveEslintCompatible : compareStringsCaseSensitive;
    }
    function getOrganizeImportsUnicodeStringComparer(ignoreCase, preferences) {
        const resolvedLocale = getOrganizeImportsLocale(preferences);
        var _preferences_organizeImportsCaseFirst;
        const caseFirst = (_preferences_organizeImportsCaseFirst = preferences.organizeImportsCaseFirst) !== null && _preferences_organizeImportsCaseFirst !== void 0 ? _preferences_organizeImportsCaseFirst : false;
        var _preferences_organizeImportsNumericCollation;
        const numeric = (_preferences_organizeImportsNumericCollation = preferences.organizeImportsNumericCollation) !== null && _preferences_organizeImportsNumericCollation !== void 0 ? _preferences_organizeImportsNumericCollation : false;
        var _preferences_organizeImportsAccentCollation;
        const accents = (_preferences_organizeImportsAccentCollation = preferences.organizeImportsAccentCollation) !== null && _preferences_organizeImportsAccentCollation !== void 0 ? _preferences_organizeImportsAccentCollation : true;
        const sensitivity = ignoreCase ? accents ? "accent" : "base" : accents ? "variant" : "case";
        const collator = new Intl.Collator(resolvedLocale, {
            usage: "sort",
            caseFirst: caseFirst || "false",
            sensitivity,
            numeric
        });
        return collator.compare;
    }
    function getOrganizeImportsLocale(preferences) {
        let locale = preferences.organizeImportsLocale;
        if (locale === "auto") locale = getUILocale();
        if (locale === void 0) locale = "en";
        const supportedLocales = Intl.Collator.supportedLocalesOf(locale);
        const resolvedLocale = supportedLocales.length ? supportedLocales[0] : "en";
        return resolvedLocale;
    }
    function getOrganizeImportsStringComparer(preferences, ignoreCase) {
        var _preferences_organizeImportsCollation;
        const collation = (_preferences_organizeImportsCollation = preferences.organizeImportsCollation) !== null && _preferences_organizeImportsCollation !== void 0 ? _preferences_organizeImportsCollation : "ordinal";
        return collation === "unicode" ? getOrganizeImportsUnicodeStringComparer(ignoreCase, preferences) : getOrganizeImportsOrdinalStringComparer(ignoreCase);
    }
    function getOrganizeImportsStringComparerWithDetection(originalImportDecls, preferences) {
        return detectModuleSpecifierCaseBySort([
            originalImportDecls
        ], getDetectionLists(preferences).comparersToTest);
    }
    function getNamedImportSpecifierComparer(preferences, comparer) {
        const stringComparer = comparer !== null && comparer !== void 0 ? comparer : getOrganizeImportsOrdinalStringComparer(!!preferences.organizeImportsIgnoreCase);
        return (s1, s2)=>compareImportOrExportSpecifiers(s1, s2, stringComparer, preferences);
    }
    function getNamedImportSpecifierComparerWithDetection(importDecl, preferences, sourceFile) {
        const { comparersToTest, typeOrdersToTest } = getDetectionLists(preferences);
        const detectFromDecl = detectNamedImportOrganizationBySort([
            importDecl
        ], comparersToTest, typeOrdersToTest);
        let specifierComparer = getNamedImportSpecifierComparer(preferences, comparersToTest[0]);
        let isSorted;
        if (typeof preferences.organizeImportsIgnoreCase !== "boolean" || !preferences.organizeImportsTypeOrder) {
            if (detectFromDecl) {
                const { namedImportComparer, typeOrder, isSorted: isDetectedSorted } = detectFromDecl;
                isSorted = isDetectedSorted;
                specifierComparer = getNamedImportSpecifierComparer({
                    organizeImportsTypeOrder: typeOrder
                }, namedImportComparer);
            } else if (sourceFile) {
                const detectFromFile = detectNamedImportOrganizationBySort(sourceFile.statements.filter(isImportDeclaration), comparersToTest, typeOrdersToTest);
                if (detectFromFile) {
                    const { namedImportComparer, typeOrder, isSorted: isDetectedSorted } = detectFromFile;
                    isSorted = isDetectedSorted;
                    specifierComparer = getNamedImportSpecifierComparer({
                        organizeImportsTypeOrder: typeOrder
                    }, namedImportComparer);
                }
            }
        }
        return {
            specifierComparer,
            isSorted
        };
    }
    function getImportDeclarationInsertionIndex(sortedImports, newImport, comparer) {
        const index = binarySearch(sortedImports, newImport, identity, (a, b)=>compareImportsOrRequireStatements(a, b, comparer));
        return index < 0 ? ~index : index;
    }
    function getImportSpecifierInsertionIndex(sortedImports, newImport, comparer) {
        const index = binarySearch(sortedImports, newImport, identity, comparer);
        return index < 0 ? ~index : index;
    }
    function compareImportsOrRequireStatements(s1, s2, comparer) {
        return compareModuleSpecifiersWorker(getModuleSpecifierExpression(s1), getModuleSpecifierExpression(s2), comparer) || compareImportKind(s1, s2);
    }
    function testCoalesceImports(importGroup, ignoreCase, sourceFile, preferences) {
        const comparer = getOrganizeImportsOrdinalStringComparer(ignoreCase);
        const specifierComparer = getNamedImportSpecifierComparer({
            organizeImportsTypeOrder: preferences == null ? void 0 : preferences.organizeImportsTypeOrder
        }, comparer);
        return coalesceImportsWorker(importGroup, comparer, specifierComparer, sourceFile);
    }
    function testCoalesceExports(exportGroup, ignoreCase, preferences) {
        const comparer = (s1, s2)=>{
            var _ref;
            return compareImportOrExportSpecifiers(s1, s2, getOrganizeImportsOrdinalStringComparer(ignoreCase), {
                organizeImportsTypeOrder: (_ref = preferences == null ? void 0 : preferences.organizeImportsTypeOrder) !== null && _ref !== void 0 ? _ref : "last"
            });
        };
        return coalesceExportsWorker(exportGroup, comparer);
    }
    function compareModuleSpecifiers2(m1, m2, ignoreCase) {
        const comparer = getOrganizeImportsOrdinalStringComparer(!!ignoreCase);
        return compareModuleSpecifiersWorker(m1, m2, comparer);
    }
    // src/services/_namespaces/ts.OutliningElementsCollector.ts
    var ts_OutliningElementsCollector_exports = {};
    __export(ts_OutliningElementsCollector_exports, {
        collectElements: ()=>collectElements
    });
    // src/services/outliningElementsCollector.ts
    function collectElements(sourceFile, cancellationToken) {
        const res = [];
        addNodeOutliningSpans(sourceFile, cancellationToken, res);
        addRegionOutliningSpans(sourceFile, res);
        res.sort((span1, span2)=>span1.textSpan.start - span2.textSpan.start);
        return res;
    }
    function addNodeOutliningSpans(sourceFile, cancellationToken, out) {
        let depthRemaining = 40;
        let current = 0;
        const statements = sourceFile.statements;
        const n = statements.length;
        while(current < n){
            while(current < n && !isAnyImportSyntax(statements[current])){
                visitNode3(statements[current]);
                current++;
            }
            if (current === n) break;
            const firstImport = current;
            while(current < n && isAnyImportSyntax(statements[current])){
                visitNode3(statements[current]);
                current++;
            }
            const lastImport = current - 1;
            if (lastImport !== firstImport) out.push(createOutliningSpanFromBounds(findChildOfKind(statements[firstImport], 102 /* ImportKeyword */ , sourceFile).getStart(sourceFile), statements[lastImport].getEnd(), "imports" /* Imports */ ));
        }
        visitNode3(sourceFile.endOfFileToken);
        function visitNode3(n2) {
            var _a;
            if (depthRemaining === 0) return;
            cancellationToken.throwIfCancellationRequested();
            if (isDeclaration(n2) || isVariableStatement(n2) || isReturnStatement(n2) || isCallOrNewExpression(n2) || n2.kind === 1 /* EndOfFileToken */ ) addOutliningForLeadingCommentsForNode(n2, sourceFile, cancellationToken, out);
            if (isFunctionLike(n2) && isBinaryExpression(n2.parent) && isPropertyAccessExpression(n2.parent.left)) addOutliningForLeadingCommentsForNode(n2.parent.left, sourceFile, cancellationToken, out);
            if (isBlock(n2) || isModuleBlock(n2)) addOutliningForLeadingCommentsForPos(n2.statements.end, sourceFile, cancellationToken, out);
            if (isClassLike(n2) || isInterfaceDeclaration(n2)) addOutliningForLeadingCommentsForPos(n2.members.end, sourceFile, cancellationToken, out);
            const span = getOutliningSpanForNode(n2, sourceFile);
            if (span) out.push(span);
            depthRemaining--;
            if (isCallExpression(n2)) {
                depthRemaining++;
                visitNode3(n2.expression);
                depthRemaining--;
                n2.arguments.forEach(visitNode3);
                (_a = n2.typeArguments) == null || _a.forEach(visitNode3);
            } else if (isIfStatement(n2) && n2.elseStatement && isIfStatement(n2.elseStatement)) {
                visitNode3(n2.expression);
                visitNode3(n2.thenStatement);
                depthRemaining++;
                visitNode3(n2.elseStatement);
                depthRemaining--;
            } else n2.forEachChild(visitNode3);
            depthRemaining++;
        }
    }
    function addRegionOutliningSpans(sourceFile, out) {
        const regions = [];
        const lineStarts = sourceFile.getLineStarts();
        for (const currentLineStart of lineStarts){
            const lineEnd = sourceFile.getLineEndOfPosition(currentLineStart);
            const lineText = sourceFile.text.substring(currentLineStart, lineEnd);
            const result = parseRegionDelimiter(lineText);
            if (!result || isInComment(sourceFile, currentLineStart)) continue;
            if (result.isStart) {
                const span = createTextSpanFromBounds(sourceFile.text.indexOf("//", currentLineStart), lineEnd);
                regions.push(createOutliningSpan(span, "region" /* Region */ , span, /*autoCollapse*/ false, result.name || "#region"));
            } else {
                const region = regions.pop();
                if (region) {
                    region.textSpan.length = lineEnd - region.textSpan.start;
                    region.hintSpan.length = lineEnd - region.textSpan.start;
                    out.push(region);
                }
            }
        }
    }
    var regionDelimiterRegExp = /^#(end)?region(.*)\r?$/;
    function parseRegionDelimiter(lineText) {
        lineText = lineText.trimStart();
        if (!startsWith(lineText, "//")) return null;
        lineText = lineText.slice(2).trim();
        const result = regionDelimiterRegExp.exec(lineText);
        if (result) return {
            isStart: !result[1],
            name: result[2].trim()
        };
        return void 0;
    }
    function addOutliningForLeadingCommentsForPos(pos, sourceFile, cancellationToken, out) {
        const comments = getLeadingCommentRanges(sourceFile.text, pos);
        if (!comments) return;
        let firstSingleLineCommentStart = -1;
        let lastSingleLineCommentEnd = -1;
        let singleLineCommentCount = 0;
        const sourceText = sourceFile.getFullText();
        for (const { kind, pos: pos2, end } of comments){
            cancellationToken.throwIfCancellationRequested();
            switch(kind){
                case 2 /* SingleLineCommentTrivia */ :
                    const commentText = sourceText.slice(pos2, end);
                    if (parseRegionDelimiter(commentText)) {
                        combineAndAddMultipleSingleLineComments();
                        singleLineCommentCount = 0;
                        break;
                    }
                    if (singleLineCommentCount === 0) firstSingleLineCommentStart = pos2;
                    lastSingleLineCommentEnd = end;
                    singleLineCommentCount++;
                    break;
                case 3 /* MultiLineCommentTrivia */ :
                    combineAndAddMultipleSingleLineComments();
                    out.push(createOutliningSpanFromBounds(pos2, end, "comment" /* Comment */ ));
                    singleLineCommentCount = 0;
                    break;
                default:
                    Debug.assertNever(kind);
            }
        }
        combineAndAddMultipleSingleLineComments();
        function combineAndAddMultipleSingleLineComments() {
            if (singleLineCommentCount > 1) out.push(createOutliningSpanFromBounds(firstSingleLineCommentStart, lastSingleLineCommentEnd, "comment" /* Comment */ ));
        }
    }
    function addOutliningForLeadingCommentsForNode(n, sourceFile, cancellationToken, out) {
        if (isJsxText(n)) return;
        addOutliningForLeadingCommentsForPos(n.pos, sourceFile, cancellationToken, out);
    }
    function createOutliningSpanFromBounds(pos, end, kind) {
        return createOutliningSpan(createTextSpanFromBounds(pos, end), kind);
    }
    function getOutliningSpanForNode(n, sourceFile) {
        switch(n.kind){
            case 242 /* Block */ :
                if (isFunctionLike(n.parent)) return functionSpan(n.parent, n, sourceFile);
                switch(n.parent.kind){
                    case 247 /* DoStatement */ :
                    case 250 /* ForInStatement */ :
                    case 251 /* ForOfStatement */ :
                    case 249 /* ForStatement */ :
                    case 246 /* IfStatement */ :
                    case 248 /* WhileStatement */ :
                    case 255 /* WithStatement */ :
                    case 300 /* CatchClause */ :
                        return spanForNode(n.parent);
                    case 259 /* TryStatement */ :
                        const tryStatement = n.parent;
                        if (tryStatement.tryBlock === n) return spanForNode(n.parent);
                        else if (tryStatement.finallyBlock === n) {
                            const node = findChildOfKind(tryStatement, 98 /* FinallyKeyword */ , sourceFile);
                            if (node) return spanForNode(node);
                        }
                    // falls through
                    default:
                        return createOutliningSpan(createTextSpanFromNode(n, sourceFile), "code" /* Code */ );
                }
            case 269 /* ModuleBlock */ :
                return spanForNode(n.parent);
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 270 /* CaseBlock */ :
            case 188 /* TypeLiteral */ :
            case 207 /* ObjectBindingPattern */ :
                return spanForNode(n);
            case 190 /* TupleType */ :
                return spanForNode(n, /*autoCollapse*/ false, /*useFullStart*/ !isTupleTypeNode(n.parent), 23 /* OpenBracketToken */ );
            case 297 /* CaseClause */ :
            case 298 /* DefaultClause */ :
                return spanForNodeArray(n.statements);
            case 211 /* ObjectLiteralExpression */ :
                return spanForObjectOrArrayLiteral(n);
            case 210 /* ArrayLiteralExpression */ :
                return spanForObjectOrArrayLiteral(n, 23 /* OpenBracketToken */ );
            case 285 /* JsxElement */ :
                return spanForJSXElement(n);
            case 289 /* JsxFragment */ :
                return spanForJSXFragment(n);
            case 286 /* JsxSelfClosingElement */ :
            case 287 /* JsxOpeningElement */ :
                return spanForJSXAttributes(n.attributes);
            case 229 /* TemplateExpression */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
                return spanForTemplateLiteral(n);
            case 208 /* ArrayBindingPattern */ :
                return spanForNode(n, /*autoCollapse*/ false, /*useFullStart*/ !isBindingElement(n.parent), 23 /* OpenBracketToken */ );
            case 220 /* ArrowFunction */ :
                return spanForArrowFunction(n);
            case 214 /* CallExpression */ :
                return spanForCallExpression(n);
            case 218 /* ParenthesizedExpression */ :
                return spanForParenthesizedExpression(n);
            case 276 /* NamedImports */ :
            case 280 /* NamedExports */ :
            case 301 /* ImportAttributes */ :
                return spanForImportExportElements(n);
        }
        function spanForImportExportElements(node) {
            if (!node.elements.length) return void 0;
            const openToken = findChildOfKind(node, 19 /* OpenBraceToken */ , sourceFile);
            const closeToken = findChildOfKind(node, 20 /* CloseBraceToken */ , sourceFile);
            if (!openToken || !closeToken || positionsAreOnSameLine(openToken.pos, closeToken.pos, sourceFile)) return void 0;
            return spanBetweenTokens(openToken, closeToken, node, sourceFile, /*autoCollapse*/ false, /*useFullStart*/ false);
        }
        function spanForCallExpression(node) {
            if (!node.arguments.length) return void 0;
            const openToken = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile);
            const closeToken = findChildOfKind(node, 22 /* CloseParenToken */ , sourceFile);
            if (!openToken || !closeToken || positionsAreOnSameLine(openToken.pos, closeToken.pos, sourceFile)) return void 0;
            return spanBetweenTokens(openToken, closeToken, node, sourceFile, /*autoCollapse*/ false, /*useFullStart*/ true);
        }
        function spanForArrowFunction(node) {
            if (isBlock(node.body) || isParenthesizedExpression(node.body) || positionsAreOnSameLine(node.body.getFullStart(), node.body.getEnd(), sourceFile)) return void 0;
            const textSpan = createTextSpanFromBounds(node.body.getFullStart(), node.body.getEnd());
            return createOutliningSpan(textSpan, "code" /* Code */ , createTextSpanFromNode(node));
        }
        function spanForJSXElement(node) {
            const textSpan = createTextSpanFromBounds(node.openingElement.getStart(sourceFile), node.closingElement.getEnd());
            const tagName = node.openingElement.tagName.getText(sourceFile);
            const bannerText = "<" + tagName + ">...</" + tagName + ">";
            return createOutliningSpan(textSpan, "code" /* Code */ , textSpan, /*autoCollapse*/ false, bannerText);
        }
        function spanForJSXFragment(node) {
            const textSpan = createTextSpanFromBounds(node.openingFragment.getStart(sourceFile), node.closingFragment.getEnd());
            const bannerText = "<>...</>";
            return createOutliningSpan(textSpan, "code" /* Code */ , textSpan, /*autoCollapse*/ false, bannerText);
        }
        function spanForJSXAttributes(node) {
            if (node.properties.length === 0) return void 0;
            return createOutliningSpanFromBounds(node.getStart(sourceFile), node.getEnd(), "code" /* Code */ );
        }
        function spanForTemplateLiteral(node) {
            if (node.kind === 15 /* NoSubstitutionTemplateLiteral */  && node.text.length === 0) return void 0;
            return createOutliningSpanFromBounds(node.getStart(sourceFile), node.getEnd(), "code" /* Code */ );
        }
        function spanForObjectOrArrayLiteral(node, open = 19 /* OpenBraceToken */ ) {
            return spanForNode(node, /*autoCollapse*/ false, /*useFullStart*/ !isArrayLiteralExpression(node.parent) && !isCallExpression(node.parent), open);
        }
        function spanForNode(hintSpanNode, autoCollapse = false, useFullStart = true, open = 19 /* OpenBraceToken */ , close = open === 19 /* OpenBraceToken */  ? 20 /* CloseBraceToken */  : 24 /* CloseBracketToken */ ) {
            const openToken = findChildOfKind(n, open, sourceFile);
            const closeToken = findChildOfKind(n, close, sourceFile);
            return openToken && closeToken && spanBetweenTokens(openToken, closeToken, hintSpanNode, sourceFile, autoCollapse, useFullStart);
        }
        function spanForNodeArray(nodeArray) {
            return nodeArray.length ? createOutliningSpan(createTextSpanFromRange(nodeArray), "code" /* Code */ ) : void 0;
        }
        function spanForParenthesizedExpression(node) {
            if (positionsAreOnSameLine(node.getStart(), node.getEnd(), sourceFile)) return void 0;
            const textSpan = createTextSpanFromBounds(node.getStart(), node.getEnd());
            return createOutliningSpan(textSpan, "code" /* Code */ , createTextSpanFromNode(node));
        }
    }
    function functionSpan(node, body, sourceFile) {
        const openToken = tryGetFunctionOpenToken(node, body, sourceFile);
        const closeToken = findChildOfKind(body, 20 /* CloseBraceToken */ , sourceFile);
        return openToken && closeToken && spanBetweenTokens(openToken, closeToken, node, sourceFile, /*autoCollapse*/ node.kind !== 220 /* ArrowFunction */ );
    }
    function spanBetweenTokens(openToken, closeToken, hintSpanNode, sourceFile, autoCollapse = false, useFullStart = true) {
        const textSpan = createTextSpanFromBounds(useFullStart ? openToken.getFullStart() : openToken.getStart(sourceFile), closeToken.getEnd());
        return createOutliningSpan(textSpan, "code" /* Code */ , createTextSpanFromNode(hintSpanNode, sourceFile), autoCollapse);
    }
    function createOutliningSpan(textSpan, kind, hintSpan = textSpan, autoCollapse = false, bannerText = "...") {
        return {
            textSpan,
            kind,
            hintSpan,
            bannerText,
            autoCollapse
        };
    }
    function tryGetFunctionOpenToken(node, body, sourceFile) {
        if (isNodeArrayMultiLine(node.parameters, sourceFile)) {
            const openParenToken = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile);
            if (openParenToken) return openParenToken;
        }
        return findChildOfKind(body, 19 /* OpenBraceToken */ , sourceFile);
    }
    // src/services/_namespaces/ts.Rename.ts
    var ts_Rename_exports = {};
    __export(ts_Rename_exports, {
        getRenameInfo: ()=>getRenameInfo,
        nodeIsEligibleForRename: ()=>nodeIsEligibleForRename
    });
    // src/services/rename.ts
    function getRenameInfo(program, sourceFile, position, preferences) {
        const node = getAdjustedRenameLocation(getTouchingPropertyName(sourceFile, position));
        if (nodeIsEligibleForRename(node)) {
            const renameInfo = getRenameInfoForNode(node, program.getTypeChecker(), sourceFile, program, preferences);
            if (renameInfo) return renameInfo;
        }
        return getRenameInfoError(Diagnostics.You_cannot_rename_this_element);
    }
    function getRenameInfoForNode(node, typeChecker, sourceFile, program, preferences) {
        const symbol = typeChecker.getSymbolAtLocation(node);
        if (!symbol) {
            if (isStringLiteralLike(node)) {
                const type = getContextualTypeFromParentOrAncestorTypeNode(node, typeChecker);
                if (type && (type.flags & 128 /* StringLiteral */  || type.flags & 1048576 /* Union */  && every(type.types, (type2)=>!!(type2.flags & 128 /* StringLiteral */ )))) return getRenameInfoSuccess(node.text, node.text, "string" /* string */ , "", node, sourceFile);
            } else if (isLabelName(node)) {
                const name = getTextOfNode(node);
                return getRenameInfoSuccess(name, name, "label" /* label */ , "" /* none */ , node, sourceFile);
            }
            return void 0;
        }
        const { declarations } = symbol;
        if (!declarations || declarations.length === 0) return;
        if (declarations.some((declaration)=>isDefinedInLibraryFile(program, declaration))) return getRenameInfoError(Diagnostics.You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library);
        if (isIdentifier(node) && node.escapedText === "default" && symbol.parent && symbol.parent.flags & 1536 /* Module */ ) return void 0;
        if (isStringLiteralLike(node) && tryGetImportFromModuleSpecifier(node)) return preferences.allowRenameOfImportPath ? getRenameInfoForModule(node, sourceFile, symbol) : void 0;
        const wouldRenameNodeModules = wouldRenameInOtherNodeModules(sourceFile, symbol, typeChecker, preferences);
        if (wouldRenameNodeModules) return getRenameInfoError(wouldRenameNodeModules);
        const kind = ts_SymbolDisplay_exports.getSymbolKind(typeChecker, symbol, node);
        const specifierName = isImportOrExportSpecifierName(node) || isStringOrNumericLiteralLike(node) && node.parent.kind === 168 /* ComputedPropertyName */  ? stripQuotes(getTextOfIdentifierOrLiteral(node)) : void 0;
        const displayName = specifierName || typeChecker.symbolToString(symbol);
        const fullDisplayName = specifierName || typeChecker.getFullyQualifiedName(symbol);
        return getRenameInfoSuccess(displayName, fullDisplayName, kind, ts_SymbolDisplay_exports.getSymbolModifiers(typeChecker, symbol), node, sourceFile);
    }
    function isDefinedInLibraryFile(program, declaration) {
        const sourceFile = declaration.getSourceFile();
        return program.isSourceFileDefaultLibrary(sourceFile) && fileExtensionIs(sourceFile.fileName, ".d.ts" /* Dts */ );
    }
    function wouldRenameInOtherNodeModules(originalFile, symbol, checker, preferences) {
        if (!preferences.providePrefixAndSuffixTextForRename && symbol.flags & 2097152 /* Alias */ ) {
            const importSpecifier = symbol.declarations && find(symbol.declarations, (decl)=>isImportSpecifier(decl));
            if (importSpecifier && !importSpecifier.propertyName) symbol = checker.getAliasedSymbol(symbol);
        }
        const { declarations } = symbol;
        if (!declarations) return void 0;
        const originalPackage = getPackagePathComponents(originalFile.path);
        if (originalPackage === void 0) {
            if (some(declarations, (declaration)=>isInsideNodeModules(declaration.getSourceFile().path))) return Diagnostics.You_cannot_rename_elements_that_are_defined_in_a_node_modules_folder;
            else return void 0;
        }
        for (const declaration of declarations){
            const declPackage = getPackagePathComponents(declaration.getSourceFile().path);
            if (declPackage) {
                const length2 = Math.min(originalPackage.length, declPackage.length);
                for(let i = 0; i <= length2; i++){
                    if (compareStringsCaseSensitive(originalPackage[i], declPackage[i]) !== 0 /* EqualTo */ ) return Diagnostics.You_cannot_rename_elements_that_are_defined_in_another_node_modules_folder;
                }
            }
        }
        return void 0;
    }
    function getPackagePathComponents(filePath) {
        const components = getPathComponents(filePath);
        const nodeModulesIdx = components.lastIndexOf("node_modules");
        if (nodeModulesIdx === -1) return void 0;
        return components.slice(0, nodeModulesIdx + 2);
    }
    function getRenameInfoForModule(node, sourceFile, moduleSymbol) {
        if (!isExternalModuleNameRelative(node.text)) return getRenameInfoError(Diagnostics.You_cannot_rename_a_module_via_a_global_import);
        const moduleSourceFile = moduleSymbol.declarations && find(moduleSymbol.declarations, isSourceFile);
        if (!moduleSourceFile) return void 0;
        const withoutIndex = endsWith(node.text, "/index") || endsWith(node.text, "/index.js") ? void 0 : tryRemoveSuffix(removeFileExtension(moduleSourceFile.fileName), "/index");
        const fileName = withoutIndex === void 0 ? moduleSourceFile.fileName : withoutIndex;
        const kind = withoutIndex === void 0 ? "module" /* moduleElement */  : "directory" /* directory */ ;
        const indexAfterLastSlash = node.text.lastIndexOf("/") + 1;
        const triggerSpan = createTextSpan(node.getStart(sourceFile) + 1 + indexAfterLastSlash, node.text.length - indexAfterLastSlash);
        return {
            canRename: true,
            fileToRename: fileName,
            kind,
            displayName: fileName,
            fullDisplayName: node.text,
            kindModifiers: "" /* none */ ,
            triggerSpan
        };
    }
    function getRenameInfoSuccess(displayName, fullDisplayName, kind, kindModifiers, node, sourceFile) {
        return {
            canRename: true,
            fileToRename: void 0,
            kind,
            displayName,
            fullDisplayName,
            kindModifiers,
            triggerSpan: createTriggerSpanForNode(node, sourceFile)
        };
    }
    function getRenameInfoError(diagnostic) {
        return {
            canRename: false,
            localizedErrorMessage: getLocaleSpecificMessage(diagnostic)
        };
    }
    function createTriggerSpanForNode(node, sourceFile) {
        let start = node.getStart(sourceFile);
        let width = node.getWidth(sourceFile);
        if (isStringLiteralLike(node)) {
            start += 1;
            width -= 2;
        }
        return createTextSpan(start, width);
    }
    function nodeIsEligibleForRename(node) {
        switch(node.kind){
            case 80 /* Identifier */ :
            case 81 /* PrivateIdentifier */ :
            case 11 /* StringLiteral */ :
            case 15 /* NoSubstitutionTemplateLiteral */ :
            case 110 /* ThisKeyword */ :
                return true;
            case 9 /* NumericLiteral */ :
                return isLiteralNameOfPropertyDeclarationOrIndexAccess(node);
            default:
                return false;
        }
    }
    // src/services/_namespaces/ts.SignatureHelp.ts
    var ts_SignatureHelp_exports = {};
    __export(ts_SignatureHelp_exports, {
        getArgumentInfoForCompletions: ()=>getArgumentInfoForCompletions,
        getSignatureHelpItems: ()=>getSignatureHelpItems
    });
    // src/services/signatureHelp.ts
    function getSignatureHelpItems(program, sourceFile, position, triggerReason, cancellationToken) {
        const typeChecker = program.getTypeChecker();
        const startingToken = findTokenOnLeftOfPosition(sourceFile, position);
        if (!startingToken) return void 0;
        const onlyUseSyntacticOwners = !!triggerReason && triggerReason.kind === "characterTyped";
        if (onlyUseSyntacticOwners && (isInString(sourceFile, position, startingToken) || isInComment(sourceFile, position))) return void 0;
        const isManuallyInvoked = !!triggerReason && triggerReason.kind === "invoked";
        const argumentInfo = getContainingArgumentInfo(startingToken, position, sourceFile, typeChecker, isManuallyInvoked);
        if (!argumentInfo) return void 0;
        cancellationToken.throwIfCancellationRequested();
        const candidateInfo = getCandidateOrTypeInfo(argumentInfo, typeChecker, sourceFile, startingToken, onlyUseSyntacticOwners);
        cancellationToken.throwIfCancellationRequested();
        if (!candidateInfo) return isSourceFileJS(sourceFile) ? createJSSignatureHelpItems(argumentInfo, program, cancellationToken) : void 0;
        return typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>candidateInfo.kind === 0 /* Candidate */  ? createSignatureHelpItems(candidateInfo.candidates, candidateInfo.resolvedSignature, argumentInfo, sourceFile, typeChecker2) : createTypeHelpItems(candidateInfo.symbol, argumentInfo, sourceFile, typeChecker2));
    }
    function getCandidateOrTypeInfo({ invocation, argumentCount }, checker, sourceFile, startingToken, onlyUseSyntacticOwners) {
        switch(invocation.kind){
            case 0 /* Call */ :
                {
                    if (onlyUseSyntacticOwners && !isSyntacticOwner(startingToken, invocation.node, sourceFile)) return void 0;
                    const candidates = [];
                    const resolvedSignature = checker.getResolvedSignatureForSignatureHelp(invocation.node, candidates, argumentCount);
                    return candidates.length === 0 ? void 0 : {
                        kind: 0 /* Candidate */ ,
                        candidates,
                        resolvedSignature
                    };
                }
            case 1 /* TypeArgs */ :
                {
                    const { called } = invocation;
                    if (onlyUseSyntacticOwners && !containsPrecedingToken(startingToken, sourceFile, isIdentifier(called) ? called.parent : called)) return void 0;
                    const candidates = getPossibleGenericSignatures(called, argumentCount, checker);
                    if (candidates.length !== 0) return {
                        kind: 0 /* Candidate */ ,
                        candidates,
                        resolvedSignature: first(candidates)
                    };
                    const symbol = checker.getSymbolAtLocation(called);
                    return symbol && {
                        kind: 1 /* Type */ ,
                        symbol
                    };
                }
            case 2 /* Contextual */ :
                return {
                    kind: 0 /* Candidate */ ,
                    candidates: [
                        invocation.signature
                    ],
                    resolvedSignature: invocation.signature
                };
            default:
                return Debug.assertNever(invocation);
        }
    }
    function isSyntacticOwner(startingToken, node, sourceFile) {
        if (!isCallOrNewExpression(node)) return false;
        const invocationChildren = node.getChildren(sourceFile);
        switch(startingToken.kind){
            case 21 /* OpenParenToken */ :
                return contains(invocationChildren, startingToken);
            case 28 /* CommaToken */ :
                {
                    const containingList = findContainingList(startingToken);
                    return !!containingList && contains(invocationChildren, containingList);
                }
            case 30 /* LessThanToken */ :
                return containsPrecedingToken(startingToken, sourceFile, node.expression);
            default:
                return false;
        }
    }
    function createJSSignatureHelpItems(argumentInfo, program, cancellationToken) {
        if (argumentInfo.invocation.kind === 2 /* Contextual */ ) return void 0;
        const expression = getExpressionFromInvocation(argumentInfo.invocation);
        const name = isPropertyAccessExpression(expression) ? expression.name.text : void 0;
        const typeChecker = program.getTypeChecker();
        return name === void 0 ? void 0 : firstDefined(program.getSourceFiles(), (sourceFile)=>firstDefined(sourceFile.getNamedDeclarations().get(name), (declaration)=>{
                const type = declaration.symbol && typeChecker.getTypeOfSymbolAtLocation(declaration.symbol, declaration);
                const callSignatures = type && type.getCallSignatures();
                if (callSignatures && callSignatures.length) return typeChecker.runWithCancellationToken(cancellationToken, (typeChecker2)=>createSignatureHelpItems(callSignatures, callSignatures[0], argumentInfo, sourceFile, typeChecker2, /*useFullPrefix*/ true));
            }));
    }
    function containsPrecedingToken(startingToken, sourceFile, container) {
        const pos = startingToken.getFullStart();
        let currentParent = startingToken.parent;
        while(currentParent){
            const precedingToken = findPrecedingToken(pos, sourceFile, currentParent, /*excludeJsdoc*/ true);
            if (precedingToken) return rangeContainsRange(container, precedingToken);
            currentParent = currentParent.parent;
        }
        return Debug.fail("Could not find preceding token");
    }
    function getArgumentInfoForCompletions(node, position, sourceFile, checker) {
        const info = getImmediatelyContainingArgumentInfo(node, position, sourceFile, checker);
        return !info || info.isTypeParameterList || info.invocation.kind !== 0 /* Call */  ? void 0 : {
            invocation: info.invocation.node,
            argumentCount: info.argumentCount,
            argumentIndex: info.argumentIndex
        };
    }
    function getArgumentOrParameterListInfo(node, position, sourceFile, checker) {
        const info = getArgumentOrParameterListAndIndex(node, sourceFile, checker);
        if (!info) return void 0;
        const { list, argumentIndex } = info;
        const argumentCount = getArgumentCount(checker, list);
        const argumentsSpan = getApplicableSpanForArguments(list, sourceFile);
        return {
            list,
            argumentIndex,
            argumentCount,
            argumentsSpan
        };
    }
    function getArgumentOrParameterListAndIndex(node, sourceFile, checker) {
        if (node.kind === 30 /* LessThanToken */  || node.kind === 21 /* OpenParenToken */ ) return {
            list: getChildListThatStartsWithOpenerToken(node.parent, node, sourceFile),
            argumentIndex: 0
        };
        else {
            const list = findContainingList(node);
            return list && {
                list,
                argumentIndex: getArgumentIndex(checker, list, node)
            };
        }
    }
    function getImmediatelyContainingArgumentInfo(node, position, sourceFile, checker) {
        const { parent: parent2 } = node;
        if (isCallOrNewExpression(parent2)) {
            const invocation = parent2;
            const info = getArgumentOrParameterListInfo(node, position, sourceFile, checker);
            if (!info) return void 0;
            const { list, argumentIndex, argumentCount, argumentsSpan } = info;
            const isTypeParameterList = !!parent2.typeArguments && parent2.typeArguments.pos === list.pos;
            return {
                isTypeParameterList,
                invocation: {
                    kind: 0 /* Call */ ,
                    node: invocation
                },
                argumentsSpan,
                argumentIndex,
                argumentCount
            };
        } else if (isNoSubstitutionTemplateLiteral(node) && isTaggedTemplateExpression(parent2)) {
            if (isInsideTemplateLiteral(node, position, sourceFile)) return getArgumentListInfoForTemplate(parent2, /*argumentIndex*/ 0, sourceFile);
            return void 0;
        } else if (isTemplateHead(node) && parent2.parent.kind === 216 /* TaggedTemplateExpression */ ) {
            const templateExpression = parent2;
            const tagExpression = templateExpression.parent;
            Debug.assert(templateExpression.kind === 229 /* TemplateExpression */ );
            const argumentIndex = isInsideTemplateLiteral(node, position, sourceFile) ? 0 : 1;
            return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
        } else if (isTemplateSpan(parent2) && isTaggedTemplateExpression(parent2.parent.parent)) {
            const templateSpan = parent2;
            const tagExpression = parent2.parent.parent;
            if (isTemplateTail(node) && !isInsideTemplateLiteral(node, position, sourceFile)) return void 0;
            const spanIndex = templateSpan.parent.templateSpans.indexOf(templateSpan);
            const argumentIndex = getArgumentIndexForTemplatePiece(spanIndex, node, position, sourceFile);
            return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
        } else if (isJsxOpeningLikeElement(parent2)) {
            const attributeSpanStart = parent2.attributes.pos;
            const attributeSpanEnd = skipTrivia(sourceFile.text, parent2.attributes.end, /*stopAfterLineBreak*/ false);
            return {
                isTypeParameterList: false,
                invocation: {
                    kind: 0 /* Call */ ,
                    node: parent2
                },
                argumentsSpan: createTextSpan(attributeSpanStart, attributeSpanEnd - attributeSpanStart),
                argumentIndex: 0,
                argumentCount: 1
            };
        } else {
            const typeArgInfo = getPossibleTypeArgumentsInfo(node, sourceFile);
            if (typeArgInfo) {
                const { called, nTypeArguments } = typeArgInfo;
                const invocation = {
                    kind: 1 /* TypeArgs */ ,
                    called
                };
                const argumentsSpan = createTextSpanFromBounds(called.getStart(sourceFile), node.end);
                return {
                    isTypeParameterList: true,
                    invocation,
                    argumentsSpan,
                    argumentIndex: nTypeArguments,
                    argumentCount: nTypeArguments + 1
                };
            }
            return void 0;
        }
    }
    function getImmediatelyContainingArgumentOrContextualParameterInfo(node, position, sourceFile, checker) {
        return tryGetParameterInfo(node, position, sourceFile, checker) || getImmediatelyContainingArgumentInfo(node, position, sourceFile, checker);
    }
    function getHighestBinary(b) {
        return isBinaryExpression(b.parent) ? getHighestBinary(b.parent) : b;
    }
    function countBinaryExpressionParameters(b) {
        return isBinaryExpression(b.left) ? countBinaryExpressionParameters(b.left) + 1 : 2;
    }
    function tryGetParameterInfo(startingToken, position, sourceFile, checker) {
        const node = getAdjustedNode(startingToken);
        if (node === void 0) return void 0;
        const info = getContextualSignatureLocationInfo(node, sourceFile, position, checker);
        if (info === void 0) return void 0;
        const { contextualType, argumentIndex, argumentCount, argumentsSpan } = info;
        const nonNullableContextualType = contextualType.getNonNullableType();
        const symbol = nonNullableContextualType.symbol;
        if (symbol === void 0) return void 0;
        const signature = lastOrUndefined(nonNullableContextualType.getCallSignatures());
        if (signature === void 0) return void 0;
        const invocation = {
            kind: 2 /* Contextual */ ,
            signature,
            node: startingToken,
            symbol: chooseBetterSymbol(symbol)
        };
        return {
            isTypeParameterList: false,
            invocation,
            argumentsSpan,
            argumentIndex,
            argumentCount
        };
    }
    function getAdjustedNode(node) {
        switch(node.kind){
            case 21 /* OpenParenToken */ :
            case 28 /* CommaToken */ :
                return node;
            default:
                return findAncestor(node.parent, (n)=>isParameter(n) ? true : isBindingElement(n) || isObjectBindingPattern(n) || isArrayBindingPattern(n) ? false : "quit");
        }
    }
    function getContextualSignatureLocationInfo(node, sourceFile, position, checker) {
        const { parent: parent2 } = node;
        switch(parent2.kind){
            case 218 /* ParenthesizedExpression */ :
            case 175 /* MethodDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
                const info = getArgumentOrParameterListInfo(node, position, sourceFile, checker);
                if (!info) return void 0;
                const { argumentIndex, argumentCount, argumentsSpan } = info;
                const contextualType = isMethodDeclaration(parent2) ? checker.getContextualTypeForObjectLiteralElement(parent2) : checker.getContextualType(parent2);
                return contextualType && {
                    contextualType,
                    argumentIndex,
                    argumentCount,
                    argumentsSpan
                };
            case 227 /* BinaryExpression */ :
                {
                    const highestBinary = getHighestBinary(parent2);
                    const contextualType2 = checker.getContextualType(highestBinary);
                    const argumentIndex2 = node.kind === 21 /* OpenParenToken */  ? 0 : countBinaryExpressionParameters(parent2) - 1;
                    const argumentCount2 = countBinaryExpressionParameters(highestBinary);
                    return contextualType2 && {
                        contextualType: contextualType2,
                        argumentIndex: argumentIndex2,
                        argumentCount: argumentCount2,
                        argumentsSpan: createTextSpanFromNode(parent2)
                    };
                }
            default:
                return void 0;
        }
    }
    function chooseBetterSymbol(s) {
        return s.name === "__type" /* Type */  ? firstDefined(s.declarations, (d)=>{
            var _a;
            return isFunctionTypeNode(d) ? (_a = tryCast(d.parent, canHaveSymbol)) == null ? void 0 : _a.symbol : void 0;
        }) || s : s;
    }
    function getSpreadElementCount(node, checker) {
        const spreadType = checker.getTypeAtLocation(node.expression);
        if (checker.isTupleType(spreadType)) {
            const { elementFlags, fixedLength } = spreadType.target;
            if (fixedLength === 0) return 0;
            const firstOptionalIndex = findIndex(elementFlags, (f)=>!(f & 1 /* Required */ ));
            return firstOptionalIndex < 0 ? fixedLength : firstOptionalIndex;
        }
        return 0;
    }
    function getArgumentIndex(checker, argumentsList, node) {
        return getArgumentIndexOrCount(checker, argumentsList, node);
    }
    function getArgumentCount(checker, argumentsList) {
        return getArgumentIndexOrCount(checker, argumentsList, /*node*/ void 0);
    }
    function getArgumentIndexOrCount(checker, argumentsList, node) {
        const args = argumentsList.getChildren();
        let argumentIndex = 0;
        let skipComma = false;
        for (const child of args){
            if (node && child === node) {
                if (!skipComma && child.kind === 28 /* CommaToken */ ) argumentIndex++;
                return argumentIndex;
            }
            if (isSpreadElement(child)) {
                argumentIndex += getSpreadElementCount(child, checker);
                skipComma = true;
                continue;
            }
            if (child.kind !== 28 /* CommaToken */ ) {
                argumentIndex++;
                skipComma = true;
                continue;
            }
            if (skipComma) {
                skipComma = false;
                continue;
            }
            argumentIndex++;
        }
        if (node) return argumentIndex;
        return args.length && last(args).kind === 28 /* CommaToken */  ? argumentIndex + 1 : argumentIndex;
    }
    function getArgumentIndexForTemplatePiece(spanIndex, node, position, sourceFile) {
        Debug.assert(position >= node.getStart(), "Assumed 'position' could not occur before node.");
        if (isTemplateLiteralToken(node)) {
            if (isInsideTemplateLiteral(node, position, sourceFile)) return 0;
            return spanIndex + 2;
        }
        return spanIndex + 1;
    }
    function getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile) {
        const argumentCount = isNoSubstitutionTemplateLiteral(tagExpression.template) ? 1 : tagExpression.template.templateSpans.length + 1;
        if (argumentIndex !== 0) Debug.assertLessThan(argumentIndex, argumentCount);
        return {
            isTypeParameterList: false,
            invocation: {
                kind: 0 /* Call */ ,
                node: tagExpression
            },
            argumentsSpan: getApplicableSpanForTaggedTemplate(tagExpression, sourceFile),
            argumentIndex,
            argumentCount
        };
    }
    function getApplicableSpanForArguments(argumentsList, sourceFile) {
        const applicableSpanStart = argumentsList.getFullStart();
        const applicableSpanEnd = skipTrivia(sourceFile.text, argumentsList.getEnd(), /*stopAfterLineBreak*/ false);
        return createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
    }
    function getApplicableSpanForTaggedTemplate(taggedTemplate, sourceFile) {
        const template = taggedTemplate.template;
        const applicableSpanStart = template.getStart();
        let applicableSpanEnd = template.getEnd();
        if (template.kind === 229 /* TemplateExpression */ ) {
            const lastSpan = last(template.templateSpans);
            if (lastSpan.literal.getFullWidth() === 0) applicableSpanEnd = skipTrivia(sourceFile.text, applicableSpanEnd, /*stopAfterLineBreak*/ false);
        }
        return createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
    }
    function getContainingArgumentInfo(node, position, sourceFile, checker, isManuallyInvoked) {
        for(let n = node; !isSourceFile(n) && (isManuallyInvoked || !isBlock(n)); n = n.parent){
            Debug.assert(rangeContainsRange(n.parent, n), "Not a subspan", ()=>`Child: ${Debug.formatSyntaxKind(n.kind)}, parent: ${Debug.formatSyntaxKind(n.parent.kind)}`);
            const argumentInfo = getImmediatelyContainingArgumentOrContextualParameterInfo(n, position, sourceFile, checker);
            if (argumentInfo) return argumentInfo;
        }
        return void 0;
    }
    function getChildListThatStartsWithOpenerToken(parent2, openerToken, sourceFile) {
        const children = parent2.getChildren(sourceFile);
        const indexOfOpenerToken = children.indexOf(openerToken);
        Debug.assert(indexOfOpenerToken >= 0 && children.length > indexOfOpenerToken + 1);
        return children[indexOfOpenerToken + 1];
    }
    function getExpressionFromInvocation(invocation) {
        return invocation.kind === 0 /* Call */  ? getInvokedExpression(invocation.node) : invocation.called;
    }
    function getEnclosingDeclarationFromInvocation(invocation) {
        return invocation.kind === 0 /* Call */  ? invocation.node : invocation.kind === 1 /* TypeArgs */  ? invocation.called : invocation.node;
    }
    var signatureHelpNodeBuilderFlags = 70246400 /* UseAliasDefinedOutsideCurrentScope */ ;
    function createSignatureHelpItems(candidates, resolvedSignature, { isTypeParameterList, argumentCount, argumentsSpan: applicableSpan, invocation, argumentIndex }, sourceFile, typeChecker, useFullPrefix) {
        var _a;
        const enclosingDeclaration = getEnclosingDeclarationFromInvocation(invocation);
        const callTargetSymbol = invocation.kind === 2 /* Contextual */  ? invocation.symbol : typeChecker.getSymbolAtLocation(getExpressionFromInvocation(invocation)) || useFullPrefix && ((_a = resolvedSignature.declaration) == null ? void 0 : _a.symbol);
        const callTargetDisplayParts = callTargetSymbol ? symbolToDisplayParts(typeChecker, callTargetSymbol, useFullPrefix ? sourceFile : void 0, /*meaning*/ void 0) : emptyArray;
        const items = map(candidates, (candidateSignature)=>getSignatureHelpItem(candidateSignature, callTargetDisplayParts, isTypeParameterList, typeChecker, enclosingDeclaration, sourceFile));
        let selectedItemIndex = 0;
        let itemsSeen = 0;
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            if (candidates[i] === resolvedSignature) {
                selectedItemIndex = itemsSeen;
                if (item.length > 1) {
                    let count = 0;
                    for (const i2 of item){
                        if (i2.isVariadic || i2.parameters.length >= argumentCount) {
                            selectedItemIndex = itemsSeen + count;
                            break;
                        }
                        count++;
                    }
                }
            }
            itemsSeen += item.length;
        }
        Debug.assert(selectedItemIndex !== -1);
        const help = {
            items: flatMapToMutable(items, identity),
            applicableSpan,
            selectedItemIndex,
            argumentIndex,
            argumentCount
        };
        const selected = help.items[selectedItemIndex];
        if (selected.isVariadic) {
            const firstRest = findIndex(selected.parameters, (p)=>!!p.isRest);
            if (-1 < firstRest && firstRest < selected.parameters.length - 1) help.argumentIndex = selected.parameters.length;
            else help.argumentIndex = Math.min(help.argumentIndex, selected.parameters.length - 1);
        }
        return help;
    }
    function createTypeHelpItems(symbol, { argumentCount, argumentsSpan: applicableSpan, invocation, argumentIndex }, sourceFile, checker) {
        const typeParameters = checker.getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
        if (!typeParameters) return void 0;
        const items = [
            getTypeHelpItem(symbol, typeParameters, checker, getEnclosingDeclarationFromInvocation(invocation), sourceFile)
        ];
        return {
            items,
            applicableSpan,
            selectedItemIndex: 0,
            argumentIndex,
            argumentCount
        };
    }
    function getTypeHelpItem(symbol, typeParameters, checker, enclosingDeclaration, sourceFile) {
        const typeSymbolDisplay = symbolToDisplayParts(checker, symbol);
        const printer = createPrinterWithRemoveComments();
        const parameters = typeParameters.map((t)=>createSignatureHelpParameterForTypeParameter(t, checker, enclosingDeclaration, sourceFile, printer));
        const documentation = symbol.getDocumentationComment(checker);
        const tags = symbol.getJsDocTags(checker);
        const prefixDisplayParts = [
            ...typeSymbolDisplay,
            punctuationPart(30 /* LessThanToken */ )
        ];
        return {
            isVariadic: false,
            prefixDisplayParts,
            suffixDisplayParts: [
                punctuationPart(32 /* GreaterThanToken */ )
            ],
            separatorDisplayParts,
            parameters,
            documentation,
            tags
        };
    }
    var separatorDisplayParts = [
        punctuationPart(28 /* CommaToken */ ),
        spacePart()
    ];
    function getSignatureHelpItem(candidateSignature, callTargetDisplayParts, isTypeParameterList, checker, enclosingDeclaration, sourceFile) {
        const infos = (isTypeParameterList ? itemInfoForTypeParameters : itemInfoForParameters)(candidateSignature, checker, enclosingDeclaration, sourceFile);
        return map(infos, ({ isVariadic, parameters, prefix, suffix })=>{
            const prefixDisplayParts = [
                ...callTargetDisplayParts,
                ...prefix
            ];
            const suffixDisplayParts = [
                ...suffix,
                ...returnTypeToDisplayParts(candidateSignature, enclosingDeclaration, checker)
            ];
            const documentation = candidateSignature.getDocumentationComment(checker);
            const tags = candidateSignature.getJsDocTags();
            return {
                isVariadic,
                prefixDisplayParts,
                suffixDisplayParts,
                separatorDisplayParts,
                parameters,
                documentation,
                tags
            };
        });
    }
    function returnTypeToDisplayParts(candidateSignature, enclosingDeclaration, checker) {
        return mapToDisplayParts((writer)=>{
            writer.writePunctuation(":");
            writer.writeSpace(" ");
            const predicate = checker.getTypePredicateOfSignature(candidateSignature);
            if (predicate) checker.writeTypePredicate(predicate, enclosingDeclaration, /*flags*/ void 0, writer);
            else checker.writeType(checker.getReturnTypeOfSignature(candidateSignature), enclosingDeclaration, /*flags*/ void 0, writer);
        });
    }
    function itemInfoForTypeParameters(candidateSignature, checker, enclosingDeclaration, sourceFile) {
        const typeParameters = (candidateSignature.target || candidateSignature).typeParameters;
        const printer = createPrinterWithRemoveComments();
        const parameters = (typeParameters || emptyArray).map((t)=>createSignatureHelpParameterForTypeParameter(t, checker, enclosingDeclaration, sourceFile, printer));
        const thisParameter = candidateSignature.thisParameter ? [
            checker.symbolToParameterDeclaration(candidateSignature.thisParameter, enclosingDeclaration, signatureHelpNodeBuilderFlags)
        ] : [];
        return checker.getExpandedParameters(candidateSignature).map((paramList)=>{
            const params = factory.createNodeArray([
                ...thisParameter,
                ...map(paramList, (param)=>checker.symbolToParameterDeclaration(param, enclosingDeclaration, signatureHelpNodeBuilderFlags))
            ]);
            const parameterParts = mapToDisplayParts((writer)=>{
                printer.writeList(2576 /* CallExpressionArguments */ , params, sourceFile, writer);
            });
            return {
                isVariadic: false,
                parameters,
                prefix: [
                    punctuationPart(30 /* LessThanToken */ )
                ],
                suffix: [
                    punctuationPart(32 /* GreaterThanToken */ ),
                    ...parameterParts
                ]
            };
        });
    }
    function itemInfoForParameters(candidateSignature, checker, enclosingDeclaration, sourceFile) {
        const printer = createPrinterWithRemoveComments();
        const typeParameterParts = mapToDisplayParts((writer)=>{
            if (candidateSignature.typeParameters && candidateSignature.typeParameters.length) {
                const args = factory.createNodeArray(candidateSignature.typeParameters.map((p)=>checker.typeParameterToDeclaration(p, enclosingDeclaration, signatureHelpNodeBuilderFlags)));
                printer.writeList(53776 /* TypeParameters */ , args, sourceFile, writer);
            }
        });
        const lists = checker.getExpandedParameters(candidateSignature);
        const isVariadic = !checker.hasEffectiveRestParameter(candidateSignature) ? (_)=>false : lists.length === 1 ? (_)=>true : (pList)=>{
            var _a;
            return !!(pList.length && ((_a = tryCast(pList[pList.length - 1], isTransientSymbol)) == null ? void 0 : _a.links.checkFlags) & 32768 /* RestParameter */ );
        };
        return lists.map((parameterList)=>({
                isVariadic: isVariadic(parameterList),
                parameters: parameterList.map((p)=>createSignatureHelpParameterForParameter(p, checker, enclosingDeclaration, sourceFile, printer)),
                prefix: [
                    ...typeParameterParts,
                    punctuationPart(21 /* OpenParenToken */ )
                ],
                suffix: [
                    punctuationPart(22 /* CloseParenToken */ )
                ]
            }));
    }
    function createSignatureHelpParameterForParameter(parameter, checker, enclosingDeclaration, sourceFile, printer) {
        const displayParts = mapToDisplayParts((writer)=>{
            const param = checker.symbolToParameterDeclaration(parameter, enclosingDeclaration, signatureHelpNodeBuilderFlags);
            printer.writeNode(4 /* Unspecified */ , param, sourceFile, writer);
        });
        const isOptional = checker.isOptionalParameter(parameter.valueDeclaration);
        const isRest = isTransientSymbol(parameter) && !!(parameter.links.checkFlags & 32768 /* RestParameter */ );
        return {
            name: parameter.name,
            documentation: parameter.getDocumentationComment(checker),
            displayParts,
            isOptional,
            isRest
        };
    }
    function createSignatureHelpParameterForTypeParameter(typeParameter, checker, enclosingDeclaration, sourceFile, printer) {
        const displayParts = mapToDisplayParts((writer)=>{
            const param = checker.typeParameterToDeclaration(typeParameter, enclosingDeclaration, signatureHelpNodeBuilderFlags);
            printer.writeNode(4 /* Unspecified */ , param, sourceFile, writer);
        });
        return {
            name: typeParameter.symbol.name,
            documentation: typeParameter.symbol.getDocumentationComment(checker),
            displayParts,
            isOptional: false,
            isRest: false
        };
    }
    // src/services/_namespaces/ts.SmartSelectionRange.ts
    var ts_SmartSelectionRange_exports = {};
    __export(ts_SmartSelectionRange_exports, {
        getSmartSelectionRange: ()=>getSmartSelectionRange
    });
    // src/services/smartSelection.ts
    function getSmartSelectionRange(pos, sourceFile) {
        var _a, _b;
        let selectionRange = {
            textSpan: createTextSpanFromBounds(sourceFile.getFullStart(), sourceFile.getEnd())
        };
        let parentNode = sourceFile;
        outer: while(true){
            const children = getSelectionChildren(parentNode);
            if (!children.length) break;
            for(let i = 0; i < children.length; i++){
                const prevNode = children[i - 1];
                const node = children[i];
                const nextNode = children[i + 1];
                if (getTokenPosOfNode(node, sourceFile, /*includeJsDoc*/ true) > pos) break outer;
                const comment = singleOrUndefined(getTrailingCommentRanges(sourceFile.text, node.end));
                if (comment && comment.kind === 2 /* SingleLineCommentTrivia */ ) pushSelectionCommentRange(comment.pos, comment.end);
                if (positionShouldSnapToNode(sourceFile, pos, node)) {
                    if (isFunctionBody(node) && isFunctionLikeDeclaration(parentNode) && !positionsAreOnSameLine(node.getStart(sourceFile), node.getEnd(), sourceFile)) pushSelectionRange(node.getStart(sourceFile), node.getEnd());
                    if (isBlock(node) || isTemplateSpan(node) || isTemplateHead(node) || isTemplateTail(node) || prevNode && isTemplateHead(prevNode) || isVariableDeclarationList(node) && isVariableStatement(parentNode) || isSyntaxList(node) && isVariableDeclarationList(parentNode) || isVariableDeclaration(node) && isSyntaxList(parentNode) && children.length === 1 || isJSDocTypeExpression(node) || isJSDocSignature(node) || isJSDocTypeLiteral(node)) {
                        parentNode = node;
                        break;
                    }
                    if (isTemplateSpan(parentNode) && nextNode && isTemplateMiddleOrTemplateTail(nextNode)) {
                        const start2 = node.getFullStart() - 2;
                        const end2 = nextNode.getStart() + 1;
                        pushSelectionRange(start2, end2);
                    }
                    const isBetweenMultiLineBookends = isSyntaxList(node) && isListOpener(prevNode) && isListCloser(nextNode) && !positionsAreOnSameLine(prevNode.getStart(), nextNode.getStart(), sourceFile);
                    let start = isBetweenMultiLineBookends ? prevNode.getEnd() : node.getStart();
                    const end = isBetweenMultiLineBookends ? nextNode.getStart() : getEndPos(sourceFile, node);
                    if (hasJSDocNodes(node) && ((_a = node.jsDoc) == null ? void 0 : _a.length)) pushSelectionRange(first(node.jsDoc).getStart(), end);
                    if (isSyntaxList(node)) {
                        const firstChild = node.getChildren()[0];
                        if (firstChild && hasJSDocNodes(firstChild) && ((_b = firstChild.jsDoc) == null ? void 0 : _b.length) && firstChild.getStart() !== node.pos) start = Math.min(start, first(firstChild.jsDoc).getStart());
                    }
                    pushSelectionRange(start, end);
                    if (isStringLiteral(node) || isTemplateLiteral(node)) pushSelectionRange(start + 1, end - 1);
                    parentNode = node;
                    break;
                }
                if (i === children.length - 1) break outer;
            }
        }
        return selectionRange;
        function pushSelectionRange(start, end) {
            if (start !== end) {
                const textSpan = createTextSpanFromBounds(start, end);
                if (!selectionRange || // Skip ranges that are identical to the parent
                !textSpansEqual(textSpan, selectionRange.textSpan) && // Skip ranges that don't contain the original position
                textSpanIntersectsWithPosition(textSpan, pos)) selectionRange = (0, _objectSpread._)({
                    textSpan
                }, selectionRange && {
                    parent: selectionRange
                });
            }
        }
        function pushSelectionCommentRange(start, end) {
            pushSelectionRange(start, end);
            let pos2 = start;
            while(sourceFile.text.charCodeAt(pos2) === 47 /* slash */ )pos2++;
            pushSelectionRange(pos2, end);
        }
    }
    function positionShouldSnapToNode(sourceFile, pos, node) {
        Debug.assert(node.pos <= pos);
        if (pos < node.end) return true;
        const nodeEnd = node.getEnd();
        if (nodeEnd === pos) return getTouchingPropertyName(sourceFile, pos).pos < node.end;
        return false;
    }
    var isImport2 = or(isImportDeclaration, isImportEqualsDeclaration);
    function getSelectionChildren(node) {
        var _a;
        if (isSourceFile(node)) return groupChildren(node.getChildAt(0).getChildren(), isImport2);
        if (isMappedTypeNode(node)) {
            const [openBraceToken, ...children] = node.getChildren();
            const closeBraceToken = Debug.checkDefined(children.pop());
            Debug.assertEqual(openBraceToken.kind, 19 /* OpenBraceToken */ );
            Debug.assertEqual(closeBraceToken.kind, 20 /* CloseBraceToken */ );
            const groupedWithPlusMinusTokens = groupChildren(children, (child)=>child === node.readonlyToken || child.kind === 148 /* ReadonlyKeyword */  || child === node.questionToken || child.kind === 58 /* QuestionToken */ );
            const groupedWithBrackets = groupChildren(groupedWithPlusMinusTokens, ({ kind })=>kind === 23 /* OpenBracketToken */  || kind === 169 /* TypeParameter */  || kind === 24 /* CloseBracketToken */ );
            return [
                openBraceToken,
                // Pivot on `:`
                createSyntaxList2(splitChildren(groupedWithBrackets, ({ kind })=>kind === 59 /* ColonToken */ )),
                closeBraceToken
            ];
        }
        if (isPropertySignature(node)) {
            const children = groupChildren(node.getChildren(), (child)=>child === node.name || contains(node.modifiers, child));
            const firstJSDocChild = ((_a = children[0]) == null ? void 0 : _a.kind) === 321 /* JSDoc */  ? children[0] : void 0;
            const withJSDocSeparated = firstJSDocChild ? children.slice(1) : children;
            const splittedChildren = splitChildren(withJSDocSeparated, ({ kind })=>kind === 59 /* ColonToken */ );
            return firstJSDocChild ? [
                firstJSDocChild,
                createSyntaxList2(splittedChildren)
            ] : splittedChildren;
        }
        if (isParameter(node)) {
            const groupedDotDotDotAndName = groupChildren(node.getChildren(), (child)=>child === node.dotDotDotToken || child === node.name);
            const groupedWithQuestionToken = groupChildren(groupedDotDotDotAndName, (child)=>child === groupedDotDotDotAndName[0] || child === node.questionToken);
            return splitChildren(groupedWithQuestionToken, ({ kind })=>kind === 64 /* EqualsToken */ );
        }
        if (isBindingElement(node)) return splitChildren(node.getChildren(), ({ kind })=>kind === 64 /* EqualsToken */ );
        return node.getChildren();
    }
    function groupChildren(children, groupOn) {
        const result = [];
        let group2;
        for (const child of children)if (groupOn(child)) {
            group2 = group2 || [];
            group2.push(child);
        } else {
            if (group2) {
                result.push(createSyntaxList2(group2));
                group2 = void 0;
            }
            result.push(child);
        }
        if (group2) result.push(createSyntaxList2(group2));
        return result;
    }
    function splitChildren(children, pivotOn, separateTrailingSemicolon = true) {
        if (children.length < 2) return children;
        const splitTokenIndex = findIndex(children, pivotOn);
        if (splitTokenIndex === -1) return children;
        const leftChildren = children.slice(0, splitTokenIndex);
        const splitToken = children[splitTokenIndex];
        const lastToken = last(children);
        const separateLastToken = separateTrailingSemicolon && lastToken.kind === 27 /* SemicolonToken */ ;
        const rightChildren = children.slice(splitTokenIndex + 1, separateLastToken ? children.length - 1 : void 0);
        const result = compact([
            leftChildren.length ? createSyntaxList2(leftChildren) : void 0,
            splitToken,
            rightChildren.length ? createSyntaxList2(rightChildren) : void 0
        ]);
        return separateLastToken ? result.concat(lastToken) : result;
    }
    function createSyntaxList2(children) {
        Debug.assertGreaterThanOrEqual(children.length, 1);
        return setTextRangePosEnd(parseNodeFactory.createSyntaxList(children), children[0].pos, last(children).end);
    }
    function isListOpener(token) {
        const kind = token && token.kind;
        return kind === 19 /* OpenBraceToken */  || kind === 23 /* OpenBracketToken */  || kind === 21 /* OpenParenToken */  || kind === 287 /* JsxOpeningElement */ ;
    }
    function isListCloser(token) {
        const kind = token && token.kind;
        return kind === 20 /* CloseBraceToken */  || kind === 24 /* CloseBracketToken */  || kind === 22 /* CloseParenToken */  || kind === 288 /* JsxClosingElement */ ;
    }
    function getEndPos(sourceFile, node) {
        switch(node.kind){
            case 342 /* JSDocParameterTag */ :
            case 339 /* JSDocCallbackTag */ :
            case 349 /* JSDocPropertyTag */ :
            case 347 /* JSDocTypedefTag */ :
            case 344 /* JSDocThisTag */ :
                return sourceFile.getLineEndOfPosition(node.getStart());
            default:
                return node.getEnd();
        }
    }
    // src/services/_namespaces/ts.SymbolDisplay.ts
    var ts_SymbolDisplay_exports = {};
    __export(ts_SymbolDisplay_exports, {
        getSymbolDisplayPartsDocumentationAndSymbolKind: ()=>getSymbolDisplayPartsDocumentationAndSymbolKind,
        getSymbolKind: ()=>getSymbolKind,
        getSymbolModifiers: ()=>getSymbolModifiers
    });
    // src/services/symbolDisplay.ts
    var symbolDisplayNodeBuilderFlags = 70246400 /* UseAliasDefinedOutsideCurrentScope */ ;
    function getSymbolKind(typeChecker, symbol, location) {
        const result = getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location);
        if (result !== "" /* unknown */ ) return result;
        const flags = getCombinedLocalAndExportSymbolFlags(symbol);
        if (flags & 32 /* Class */ ) return getDeclarationOfKind(symbol, 232 /* ClassExpression */ ) ? "local class" /* localClassElement */  : "class" /* classElement */ ;
        if (flags & 384 /* Enum */ ) return "enum" /* enumElement */ ;
        if (flags & 524288 /* TypeAlias */ ) return "type" /* typeElement */ ;
        if (flags & 64 /* Interface */ ) return "interface" /* interfaceElement */ ;
        if (flags & 262144 /* TypeParameter */ ) return "type parameter" /* typeParameterElement */ ;
        if (flags & 8 /* EnumMember */ ) return "enum member" /* enumMemberElement */ ;
        if (flags & 2097152 /* Alias */ ) return "alias" /* alias */ ;
        if (flags & 1536 /* Module */ ) return "module" /* moduleElement */ ;
        return result;
    }
    function getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location) {
        const roots = typeChecker.getRootSymbols(symbol);
        if (roots.length === 1 && first(roots).flags & 8192 /* Method */  && typeChecker.getTypeOfSymbolAtLocation(symbol, location).getNonNullableType().getCallSignatures().length !== 0) return "method" /* memberFunctionElement */ ;
        if (typeChecker.isUndefinedSymbol(symbol)) return "var" /* variableElement */ ;
        if (typeChecker.isArgumentsSymbol(symbol)) return "local var" /* localVariableElement */ ;
        if (location.kind === 110 /* ThisKeyword */  && isExpression(location) || isThisInTypeQuery(location)) return "parameter" /* parameterElement */ ;
        const flags = getCombinedLocalAndExportSymbolFlags(symbol);
        if (flags & 3 /* Variable */ ) {
            if (isFirstDeclarationOfSymbolParameter(symbol)) return "parameter" /* parameterElement */ ;
            else if (symbol.valueDeclaration && isVarConst(symbol.valueDeclaration)) return "const" /* constElement */ ;
            else if (symbol.valueDeclaration && isVarUsing(symbol.valueDeclaration)) return "using" /* variableUsingElement */ ;
            else if (symbol.valueDeclaration && isVarAwaitUsing(symbol.valueDeclaration)) return "await using" /* variableAwaitUsingElement */ ;
            else if (forEach(symbol.declarations, isLet)) return "let" /* letElement */ ;
            return isLocalVariableOrFunction(symbol) ? "local var" /* localVariableElement */  : "var" /* variableElement */ ;
        }
        if (flags & 16 /* Function */ ) return isLocalVariableOrFunction(symbol) ? "local function" /* localFunctionElement */  : "function" /* functionElement */ ;
        if (flags & 32768 /* GetAccessor */ ) return "getter" /* memberGetAccessorElement */ ;
        if (flags & 65536 /* SetAccessor */ ) return "setter" /* memberSetAccessorElement */ ;
        if (flags & 8192 /* Method */ ) return "method" /* memberFunctionElement */ ;
        if (flags & 16384 /* Constructor */ ) return "constructor" /* constructorImplementationElement */ ;
        if (flags & 131072 /* Signature */ ) return "index" /* indexSignatureElement */ ;
        if (flags & 4 /* Property */ ) {
            if (flags & 33554432 /* Transient */  && symbol.links.checkFlags & 6 /* Synthetic */ ) {
                const unionPropertyKind = forEach(typeChecker.getRootSymbols(symbol), (rootSymbol)=>{
                    const rootSymbolFlags = rootSymbol.getFlags();
                    if (rootSymbolFlags & 98311 /* Variable */ ) return "property" /* memberVariableElement */ ;
                });
                if (!unionPropertyKind) {
                    const typeOfUnionProperty = typeChecker.getTypeOfSymbolAtLocation(symbol, location);
                    if (typeOfUnionProperty.getCallSignatures().length) return "method" /* memberFunctionElement */ ;
                    return "property" /* memberVariableElement */ ;
                }
                return unionPropertyKind;
            }
            return "property" /* memberVariableElement */ ;
        }
        return "" /* unknown */ ;
    }
    function getNormalizedSymbolModifiers(symbol) {
        if (symbol.declarations && symbol.declarations.length) {
            const [declaration, ...declarations] = symbol.declarations;
            const excludeFlags = length(declarations) && isDeprecatedDeclaration(declaration) && some(declarations, (d)=>!isDeprecatedDeclaration(d)) ? 65536 /* Deprecated */  : 0 /* None */ ;
            const modifiers = getNodeModifiers(declaration, excludeFlags);
            if (modifiers) return modifiers.split(",");
        }
        return [];
    }
    function getSymbolModifiers(typeChecker, symbol) {
        if (!symbol) return "" /* none */ ;
        const modifiers = new Set(getNormalizedSymbolModifiers(symbol));
        if (symbol.flags & 2097152 /* Alias */ ) {
            const resolvedSymbol = typeChecker.getAliasedSymbol(symbol);
            if (resolvedSymbol !== symbol) forEach(getNormalizedSymbolModifiers(resolvedSymbol), (modifier)=>{
                modifiers.add(modifier);
            });
        }
        if (symbol.flags & 16777216 /* Optional */ ) modifiers.add("optional" /* optionalModifier */ );
        return modifiers.size > 0 ? arrayFrom(modifiers.values()).join(",") : "" /* none */ ;
    }
    function getSymbolDisplayPartsDocumentationAndSymbolKindWorker(typeChecker, symbol, sourceFile, enclosingDeclaration, location, type, semanticMeaning, alias, maximumLength, verbosityLevel) {
        var _a;
        const displayParts = [];
        let documentation = [];
        let tags = [];
        const symbolFlags = getCombinedLocalAndExportSymbolFlags(symbol);
        let symbolKind = semanticMeaning & 1 /* Value */  ? getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location) : "" /* unknown */ ;
        let hasAddedSymbolInfo = false;
        const isThisExpression = location.kind === 110 /* ThisKeyword */  && isInExpressionContext(location) || isThisInTypeQuery(location);
        let documentationFromAlias;
        let tagsFromAlias;
        let hasMultipleSignatures = false;
        const typeWriterOut = {
            canIncreaseExpansionDepth: false,
            truncated: false
        };
        let symbolWasExpanded = false;
        if (location.kind === 110 /* ThisKeyword */  && !isThisExpression) return {
            displayParts: [
                keywordPart(110 /* ThisKeyword */ )
            ],
            documentation: [],
            symbolKind: "primitive type" /* primitiveType */ ,
            tags: void 0
        };
        if (symbolKind !== "" /* unknown */  || symbolFlags & 32 /* Class */  || symbolFlags & 2097152 /* Alias */ ) {
            if (symbolKind === "getter" /* memberGetAccessorElement */  || symbolKind === "setter" /* memberSetAccessorElement */ ) {
                const declaration = find(symbol.declarations, (declaration2)=>declaration2.name === location && declaration2.kind !== 212 /* PropertyAccessExpression */ );
                if (declaration) switch(declaration.kind){
                    case 178 /* GetAccessor */ :
                        symbolKind = "getter" /* memberGetAccessorElement */ ;
                        break;
                    case 179 /* SetAccessor */ :
                        symbolKind = "setter" /* memberSetAccessorElement */ ;
                        break;
                    case 173 /* PropertyDeclaration */ :
                        symbolKind = "accessor" /* memberAccessorVariableElement */ ;
                        break;
                    default:
                        Debug.assertNever(declaration);
                }
                else symbolKind = "property" /* memberVariableElement */ ;
            }
            let signature;
            type !== null && type !== void 0 ? type : type = isThisExpression ? typeChecker.getTypeAtLocation(location) : typeChecker.getTypeOfSymbolAtLocation(symbol, location);
            if (location.parent && location.parent.kind === 212 /* PropertyAccessExpression */ ) {
                const right = location.parent.name;
                if (right === location || right && right.getFullWidth() === 0) location = location.parent;
            }
            let callExpressionLike;
            if (isCallOrNewExpression(location)) callExpressionLike = location;
            else if (isCallExpressionTarget(location) || isNewExpressionTarget(location)) callExpressionLike = location.parent;
            else if (location.parent && (isJsxOpeningLikeElement(location.parent) || isTaggedTemplateExpression(location.parent)) && isFunctionLike(symbol.valueDeclaration)) callExpressionLike = location.parent;
            if (callExpressionLike) {
                signature = typeChecker.getResolvedSignature(callExpressionLike);
                const useConstructSignatures = callExpressionLike.kind === 215 /* NewExpression */  || isCallExpression(callExpressionLike) && callExpressionLike.expression.kind === 108 /* SuperKeyword */ ;
                const allSignatures = useConstructSignatures ? type.getConstructSignatures() : type.getCallSignatures();
                if (signature && !contains(allSignatures, signature.target) && !contains(allSignatures, signature)) signature = allSignatures.length ? allSignatures[0] : void 0;
                if (signature) {
                    if (useConstructSignatures && symbolFlags & 32 /* Class */ ) {
                        symbolKind = "constructor" /* constructorImplementationElement */ ;
                        addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
                    } else if (symbolFlags & 2097152 /* Alias */ ) {
                        symbolKind = "alias" /* alias */ ;
                        pushSymbolKind(symbolKind);
                        displayParts.push(spacePart());
                        if (useConstructSignatures) {
                            if (signature.flags & 4 /* Abstract */ ) {
                                displayParts.push(keywordPart(128 /* AbstractKeyword */ ));
                                displayParts.push(spacePart());
                            }
                            displayParts.push(keywordPart(105 /* NewKeyword */ ));
                            displayParts.push(spacePart());
                        }
                        addFullSymbolName(symbol);
                    } else addPrefixForAnyFunctionOrVar(symbol, symbolKind);
                    switch(symbolKind){
                        case "JSX attribute" /* jsxAttribute */ :
                        case "property" /* memberVariableElement */ :
                        case "var" /* variableElement */ :
                        case "const" /* constElement */ :
                        case "let" /* letElement */ :
                        case "parameter" /* parameterElement */ :
                        case "local var" /* localVariableElement */ :
                            displayParts.push(punctuationPart(59 /* ColonToken */ ));
                            displayParts.push(spacePart());
                            if (!(getObjectFlags(type) & 16 /* Anonymous */ ) && type.symbol) {
                                addRange(displayParts, symbolToDisplayParts(typeChecker, type.symbol, enclosingDeclaration, /*meaning*/ void 0, 5 /* WriteTypeParametersOrArguments */ ));
                                displayParts.push(lineBreakPart());
                            }
                            if (useConstructSignatures) {
                                if (signature.flags & 4 /* Abstract */ ) {
                                    displayParts.push(keywordPart(128 /* AbstractKeyword */ ));
                                    displayParts.push(spacePart());
                                }
                                displayParts.push(keywordPart(105 /* NewKeyword */ ));
                                displayParts.push(spacePart());
                            }
                            addSignatureDisplayParts(signature, allSignatures, 262144 /* WriteArrowStyleSignature */ );
                            break;
                        default:
                            addSignatureDisplayParts(signature, allSignatures);
                    }
                    hasAddedSymbolInfo = true;
                    hasMultipleSignatures = allSignatures.length > 1;
                }
            } else if (isNameOfFunctionDeclaration(location) && !(symbolFlags & 98304 /* Accessor */ ) || // name of function declaration
            location.kind === 137 /* ConstructorKeyword */  && location.parent.kind === 177 /* Constructor */ ) {
                const functionDeclaration = location.parent;
                const locationIsSymbolDeclaration = symbol.declarations && find(symbol.declarations, (declaration)=>declaration === (location.kind === 137 /* ConstructorKeyword */  ? functionDeclaration.parent : functionDeclaration));
                if (locationIsSymbolDeclaration) {
                    const allSignatures = functionDeclaration.kind === 177 /* Constructor */  ? type.getNonNullableType().getConstructSignatures() : type.getNonNullableType().getCallSignatures();
                    if (!typeChecker.isImplementationOfOverload(functionDeclaration)) signature = typeChecker.getSignatureFromDeclaration(functionDeclaration);
                    else signature = allSignatures[0];
                    if (functionDeclaration.kind === 177 /* Constructor */ ) {
                        symbolKind = "constructor" /* constructorImplementationElement */ ;
                        addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
                    } else addPrefixForAnyFunctionOrVar(functionDeclaration.kind === 180 /* CallSignature */  && !(type.symbol.flags & 2048 /* TypeLiteral */  || type.symbol.flags & 4096 /* ObjectLiteral */ ) ? type.symbol : symbol, symbolKind);
                    if (signature) addSignatureDisplayParts(signature, allSignatures);
                    hasAddedSymbolInfo = true;
                    hasMultipleSignatures = allSignatures.length > 1;
                }
            }
        }
        if (symbolFlags & 32 /* Class */  && !hasAddedSymbolInfo && !isThisExpression) {
            addAliasPrefixIfNecessary();
            const classExpression = getDeclarationOfKind(symbol, 232 /* ClassExpression */ );
            if (classExpression) {
                pushSymbolKind("local class" /* localClassElement */ );
                displayParts.push(spacePart());
            }
            if (!tryExpandSymbol(symbol, semanticMeaning)) {
                if (!classExpression) {
                    displayParts.push(keywordPart(86 /* ClassKeyword */ ));
                    displayParts.push(spacePart());
                }
                addFullSymbolName(symbol);
                writeTypeParametersOfSymbol(symbol, sourceFile);
            }
        }
        if (symbolFlags & 64 /* Interface */  && semanticMeaning & 2 /* Type */ ) {
            prefixNextMeaning();
            if (!tryExpandSymbol(symbol, semanticMeaning)) {
                displayParts.push(keywordPart(120 /* InterfaceKeyword */ ));
                displayParts.push(spacePart());
                addFullSymbolName(symbol);
                writeTypeParametersOfSymbol(symbol, sourceFile);
            }
        }
        if (symbolFlags & 524288 /* TypeAlias */  && semanticMeaning & 2 /* Type */ ) {
            prefixNextMeaning();
            displayParts.push(keywordPart(156 /* TypeKeyword */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            writeTypeParametersOfSymbol(symbol, sourceFile);
            displayParts.push(spacePart());
            displayParts.push(operatorPart(64 /* EqualsToken */ ));
            displayParts.push(spacePart());
            addRange(displayParts, typeToDisplayParts(typeChecker, location.parent && isConstTypeReference(location.parent) ? typeChecker.getTypeAtLocation(location.parent) : typeChecker.getDeclaredTypeOfSymbol(symbol), enclosingDeclaration, 8388608 /* InTypeAlias */ , maximumLength, verbosityLevel, typeWriterOut));
        }
        if (symbolFlags & 384 /* Enum */ ) {
            prefixNextMeaning();
            if (!tryExpandSymbol(symbol, semanticMeaning)) {
                if (some(symbol.declarations, (d)=>isEnumDeclaration(d) && isEnumConst(d))) {
                    displayParts.push(keywordPart(87 /* ConstKeyword */ ));
                    displayParts.push(spacePart());
                }
                displayParts.push(keywordPart(94 /* EnumKeyword */ ));
                displayParts.push(spacePart());
                addFullSymbolName(symbol, /*enclosingDeclaration*/ void 0);
            }
        }
        if (symbolFlags & 1536 /* Module */  && !isThisExpression) {
            prefixNextMeaning();
            if (!tryExpandSymbol(symbol, semanticMeaning)) {
                const declaration = getDeclarationOfKind(symbol, 268 /* ModuleDeclaration */ );
                const isNamespace = declaration && declaration.name && declaration.name.kind === 80 /* Identifier */ ;
                displayParts.push(keywordPart(isNamespace ? 145 /* NamespaceKeyword */  : 144 /* ModuleKeyword */ ));
                displayParts.push(spacePart());
                addFullSymbolName(symbol);
            }
        }
        if (symbolFlags & 262144 /* TypeParameter */  && semanticMeaning & 2 /* Type */ ) {
            prefixNextMeaning();
            displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
            displayParts.push(textPart("type parameter"));
            displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            if (symbol.parent) {
                addInPrefix();
                addFullSymbolName(symbol.parent, enclosingDeclaration);
                writeTypeParametersOfSymbol(symbol.parent, enclosingDeclaration);
            } else {
                const decl = getDeclarationOfKind(symbol, 169 /* TypeParameter */ );
                if (decl === void 0) return Debug.fail();
                const declaration = decl.parent;
                if (declaration) {
                    if (isFunctionLike(declaration)) {
                        addInPrefix();
                        const signature = typeChecker.getSignatureFromDeclaration(declaration);
                        if (declaration.kind === 181 /* ConstructSignature */ ) {
                            displayParts.push(keywordPart(105 /* NewKeyword */ ));
                            displayParts.push(spacePart());
                        } else if (declaration.kind !== 180 /* CallSignature */  && declaration.name) addFullSymbolName(declaration.symbol);
                        addRange(displayParts, signatureToDisplayParts(typeChecker, signature, sourceFile, 32 /* WriteTypeArgumentsOfSignature */ ));
                    } else if (isTypeAliasDeclaration(declaration)) {
                        addInPrefix();
                        displayParts.push(keywordPart(156 /* TypeKeyword */ ));
                        displayParts.push(spacePart());
                        addFullSymbolName(declaration.symbol);
                        writeTypeParametersOfSymbol(declaration.symbol, sourceFile);
                    }
                }
            }
        }
        if (symbolFlags & 8 /* EnumMember */ ) {
            symbolKind = "enum member" /* enumMemberElement */ ;
            addPrefixForAnyFunctionOrVar(symbol, "enum member");
            const declaration = (_a = symbol.declarations) == null ? void 0 : _a[0];
            if ((declaration == null ? void 0 : declaration.kind) === 307 /* EnumMember */ ) {
                const constantValue = typeChecker.getConstantValue(declaration);
                if (constantValue !== void 0) {
                    displayParts.push(spacePart());
                    displayParts.push(operatorPart(64 /* EqualsToken */ ));
                    displayParts.push(spacePart());
                    displayParts.push(displayPart(getTextOfConstantValue(constantValue), typeof constantValue === "number" ? 7 /* numericLiteral */  : 8 /* stringLiteral */ ));
                }
            }
        }
        if (symbol.flags & 2097152 /* Alias */ ) {
            prefixNextMeaning();
            if (!hasAddedSymbolInfo || documentation.length === 0 && tags.length === 0) {
                const resolvedSymbol = typeChecker.getAliasedSymbol(symbol);
                if (resolvedSymbol !== symbol && resolvedSymbol.declarations && resolvedSymbol.declarations.length > 0) {
                    const resolvedNode = resolvedSymbol.declarations[0];
                    const declarationName = getNameOfDeclaration(resolvedNode);
                    if (declarationName && !hasAddedSymbolInfo) {
                        const isExternalModuleDeclaration = isModuleWithStringLiteralName(resolvedNode) && hasSyntacticModifier(resolvedNode, 128 /* Ambient */ );
                        const shouldUseAliasName = symbol.name !== "default" && !isExternalModuleDeclaration;
                        const resolvedInfo = getSymbolDisplayPartsDocumentationAndSymbolKindWorker(typeChecker, resolvedSymbol, getSourceFileOfNode(resolvedNode), enclosingDeclaration, declarationName, type, semanticMeaning, shouldUseAliasName ? symbol : resolvedSymbol, maximumLength, verbosityLevel);
                        displayParts.push(...resolvedInfo.displayParts);
                        displayParts.push(lineBreakPart());
                        documentationFromAlias = resolvedInfo.documentation;
                        tagsFromAlias = resolvedInfo.tags;
                        if (typeWriterOut && resolvedInfo.canIncreaseVerbosityLevel) typeWriterOut.canIncreaseExpansionDepth = true;
                    } else {
                        documentationFromAlias = resolvedSymbol.getContextualDocumentationComment(resolvedNode, typeChecker);
                        tagsFromAlias = resolvedSymbol.getJsDocTags(typeChecker);
                    }
                }
            }
            if (symbol.declarations) switch(symbol.declarations[0].kind){
                case 271 /* NamespaceExportDeclaration */ :
                    displayParts.push(keywordPart(95 /* ExportKeyword */ ));
                    displayParts.push(spacePart());
                    displayParts.push(keywordPart(145 /* NamespaceKeyword */ ));
                    break;
                case 278 /* ExportAssignment */ :
                    displayParts.push(keywordPart(95 /* ExportKeyword */ ));
                    displayParts.push(spacePart());
                    displayParts.push(keywordPart(symbol.declarations[0].isExportEquals ? 64 /* EqualsToken */  : 90 /* DefaultKeyword */ ));
                    break;
                case 282 /* ExportSpecifier */ :
                    displayParts.push(keywordPart(95 /* ExportKeyword */ ));
                    break;
                default:
                    displayParts.push(keywordPart(102 /* ImportKeyword */ ));
            }
            displayParts.push(spacePart());
            addFullSymbolName(symbol);
            forEach(symbol.declarations, (declaration)=>{
                if (declaration.kind === 272 /* ImportEqualsDeclaration */ ) {
                    const importEqualsDeclaration = declaration;
                    if (isExternalModuleImportEqualsDeclaration(importEqualsDeclaration)) {
                        displayParts.push(spacePart());
                        displayParts.push(operatorPart(64 /* EqualsToken */ ));
                        displayParts.push(spacePart());
                        displayParts.push(keywordPart(149 /* RequireKeyword */ ));
                        displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                        displayParts.push(displayPart(getTextOfNode(getExternalModuleImportEqualsDeclarationExpression(importEqualsDeclaration)), 8 /* stringLiteral */ ));
                        displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
                    } else {
                        const internalAliasSymbol = typeChecker.getSymbolAtLocation(importEqualsDeclaration.moduleReference);
                        if (internalAliasSymbol) {
                            displayParts.push(spacePart());
                            displayParts.push(operatorPart(64 /* EqualsToken */ ));
                            displayParts.push(spacePart());
                            addFullSymbolName(internalAliasSymbol, enclosingDeclaration);
                        }
                    }
                    return true;
                }
            });
        }
        if (!hasAddedSymbolInfo) {
            if (symbolKind !== "" /* unknown */ ) {
                if (type) {
                    if (isThisExpression) {
                        prefixNextMeaning();
                        displayParts.push(keywordPart(110 /* ThisKeyword */ ));
                    } else addPrefixForAnyFunctionOrVar(symbol, symbolKind);
                    if (symbolKind === "property" /* memberVariableElement */  || symbolKind === "accessor" /* memberAccessorVariableElement */  || symbolKind === "getter" /* memberGetAccessorElement */  || symbolKind === "setter" /* memberSetAccessorElement */  || symbolKind === "JSX attribute" /* jsxAttribute */  || symbolFlags & 3 /* Variable */  || symbolKind === "local var" /* localVariableElement */  || symbolKind === "index" /* indexSignatureElement */  || symbolKind === "using" /* variableUsingElement */  || symbolKind === "await using" /* variableAwaitUsingElement */  || isThisExpression) {
                        displayParts.push(punctuationPart(59 /* ColonToken */ ));
                        displayParts.push(spacePart());
                        if (type.symbol && type.symbol.flags & 262144 /* TypeParameter */  && symbolKind !== "index" /* indexSignatureElement */ ) {
                            const typeParameterParts = mapToDisplayParts((writer)=>{
                                const param = typeChecker.typeParameterToDeclaration(type, enclosingDeclaration, symbolDisplayNodeBuilderFlags, /*internalFlags*/ void 0, /*tracker*/ void 0, maximumLength, verbosityLevel, typeWriterOut);
                                getPrinter().writeNode(4 /* Unspecified */ , param, getSourceFileOfNode(getParseTreeNode(enclosingDeclaration)), writer);
                            }, maximumLength);
                            addRange(displayParts, typeParameterParts);
                        } else addRange(displayParts, typeToDisplayParts(typeChecker, type, enclosingDeclaration, /*flags*/ void 0, maximumLength, verbosityLevel, typeWriterOut));
                        if (isTransientSymbol(symbol) && symbol.links.target && isTransientSymbol(symbol.links.target) && symbol.links.target.links.tupleLabelDeclaration) {
                            const labelDecl = symbol.links.target.links.tupleLabelDeclaration;
                            Debug.assertNode(labelDecl.name, isIdentifier);
                            displayParts.push(spacePart());
                            displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                            displayParts.push(textPart(idText(labelDecl.name)));
                            displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
                        }
                    } else if (symbolFlags & 16 /* Function */  || symbolFlags & 8192 /* Method */  || symbolFlags & 16384 /* Constructor */  || symbolFlags & 131072 /* Signature */  || symbolFlags & 98304 /* Accessor */  || symbolKind === "method" /* memberFunctionElement */ ) {
                        const allSignatures = type.getNonNullableType().getCallSignatures();
                        if (allSignatures.length) {
                            addSignatureDisplayParts(allSignatures[0], allSignatures);
                            hasMultipleSignatures = allSignatures.length > 1;
                        }
                    }
                }
            } else symbolKind = getSymbolKind(typeChecker, symbol, location);
        }
        if (documentation.length === 0 && !hasMultipleSignatures) documentation = symbol.getContextualDocumentationComment(enclosingDeclaration, typeChecker);
        if (documentation.length === 0 && symbolFlags & 4 /* Property */ ) {
            if (symbol.parent && symbol.declarations && forEach(symbol.parent.declarations, (declaration)=>declaration.kind === 308 /* SourceFile */ )) for (const declaration of symbol.declarations){
                if (!declaration.parent || declaration.parent.kind !== 227 /* BinaryExpression */ ) continue;
                const rhsSymbol = typeChecker.getSymbolAtLocation(declaration.parent.right);
                if (!rhsSymbol) continue;
                documentation = rhsSymbol.getDocumentationComment(typeChecker);
                tags = rhsSymbol.getJsDocTags(typeChecker);
                if (documentation.length > 0) break;
            }
        }
        if (documentation.length === 0 && isIdentifier(location) && symbol.valueDeclaration && isBindingElement(symbol.valueDeclaration)) {
            const declaration = symbol.valueDeclaration;
            const parent2 = declaration.parent;
            const name = declaration.propertyName || declaration.name;
            if (isIdentifier(name) && isObjectBindingPattern(parent2)) {
                const propertyName = getTextOfIdentifierOrLiteral(name);
                const objectType = typeChecker.getTypeAtLocation(parent2);
                documentation = firstDefined(objectType.isUnion() ? objectType.types : [
                    objectType
                ], (t)=>{
                    const prop = t.getProperty(propertyName);
                    return prop ? prop.getDocumentationComment(typeChecker) : void 0;
                }) || emptyArray;
            }
        }
        if (tags.length === 0 && !hasMultipleSignatures && !isInJSDoc(location)) tags = symbol.getContextualJsDocTags(enclosingDeclaration, typeChecker);
        if (documentation.length === 0 && documentationFromAlias) documentation = documentationFromAlias;
        if (tags.length === 0 && tagsFromAlias) tags = tagsFromAlias;
        const canIncreaseVerbosityLevel = !typeWriterOut.truncated && typeWriterOut.canIncreaseExpansionDepth;
        return {
            displayParts,
            documentation,
            symbolKind,
            tags: tags.length === 0 ? void 0 : tags,
            canIncreaseVerbosityLevel: verbosityLevel !== void 0 ? canIncreaseVerbosityLevel : void 0
        };
        function getPrinter() {
            return createPrinterWithRemoveComments();
        }
        function prefixNextMeaning() {
            if (displayParts.length) displayParts.push(lineBreakPart());
            addAliasPrefixIfNecessary();
        }
        function addAliasPrefixIfNecessary() {
            if (alias) {
                pushSymbolKind("alias" /* alias */ );
                displayParts.push(spacePart());
            }
        }
        function addInPrefix() {
            displayParts.push(spacePart());
            displayParts.push(keywordPart(103 /* InKeyword */ ));
            displayParts.push(spacePart());
        }
        function canExpandSymbol(symbol2, out) {
            if (verbosityLevel === void 0) return false;
            const type2 = symbol2.flags & 96 /* Interface */  ? typeChecker.getDeclaredTypeOfSymbol(symbol2) : typeChecker.getTypeOfSymbolAtLocation(symbol2, location);
            if (!type2 || typeChecker.isLibType(type2)) return false;
            if (0 < verbosityLevel) return true;
            if (out) out.canIncreaseExpansionDepth = true;
            return false;
        }
        function semanticToSymbolMeaning(meaning) {
            let symbolMeaning = 0 /* None */ ;
            if (meaning & 1 /* Value */ ) symbolMeaning |= 111551 /* Value */ ;
            if (meaning & 2 /* Type */ ) symbolMeaning |= 788968 /* Type */ ;
            if (meaning & 4 /* Namespace */ ) symbolMeaning |= 1920 /* Namespace */ ;
            return symbolMeaning;
        }
        function tryExpandSymbol(symbol2, meaning) {
            if (symbolWasExpanded) return true;
            if (canExpandSymbol(symbol2, typeWriterOut)) {
                const symbolMeaning = semanticToSymbolMeaning(meaning);
                const expandedDisplayParts = mapToDisplayParts((writer)=>{
                    const nodes = typeChecker.getEmitResolver().symbolToDeclarations(symbol2, symbolMeaning, 17408 /* UseAliasDefinedOutsideCurrentScope */ , maximumLength, verbosityLevel !== void 0 ? verbosityLevel - 1 : void 0, typeWriterOut);
                    const printer = getPrinter();
                    const sourceFile2 = symbol2.valueDeclaration && getSourceFileOfNode(symbol2.valueDeclaration);
                    nodes.forEach((node, i)=>{
                        if (i > 0) writer.writeLine();
                        printer.writeNode(4 /* Unspecified */ , node, sourceFile2, writer);
                    });
                }, maximumLength);
                addRange(displayParts, expandedDisplayParts);
                symbolWasExpanded = true;
                return true;
            }
            return false;
        }
        function addFullSymbolName(symbolToDisplay, enclosingDeclaration2) {
            let indexInfos;
            if (alias && symbolToDisplay === symbol) symbolToDisplay = alias;
            if (symbolKind === "index" /* indexSignatureElement */ ) indexInfos = typeChecker.getIndexInfosOfIndexSymbol(symbolToDisplay);
            let fullSymbolDisplayParts = [];
            if (symbolToDisplay.flags & 131072 /* Signature */  && indexInfos) {
                if (symbolToDisplay.parent) fullSymbolDisplayParts = symbolToDisplayParts(typeChecker, symbolToDisplay.parent);
                fullSymbolDisplayParts.push(punctuationPart(23 /* OpenBracketToken */ ));
                indexInfos.forEach((info, i)=>{
                    fullSymbolDisplayParts.push(...typeToDisplayParts(typeChecker, info.keyType));
                    if (i !== indexInfos.length - 1) {
                        fullSymbolDisplayParts.push(spacePart());
                        fullSymbolDisplayParts.push(punctuationPart(52 /* BarToken */ ));
                        fullSymbolDisplayParts.push(spacePart());
                    }
                });
                fullSymbolDisplayParts.push(punctuationPart(24 /* CloseBracketToken */ ));
            } else fullSymbolDisplayParts = symbolToDisplayParts(typeChecker, symbolToDisplay, enclosingDeclaration2 || sourceFile, /*meaning*/ void 0, 7 /* AllowAnyNodeKind */ );
            addRange(displayParts, fullSymbolDisplayParts);
            if (symbol.flags & 16777216 /* Optional */ ) displayParts.push(punctuationPart(58 /* QuestionToken */ ));
        }
        function addPrefixForAnyFunctionOrVar(symbol2, symbolKind2) {
            prefixNextMeaning();
            if (symbolKind2) {
                pushSymbolKind(symbolKind2);
                if (symbol2 && !some(symbol2.declarations, (d)=>isArrowFunction(d) || (isFunctionExpression(d) || isClassExpression(d)) && !d.name)) {
                    displayParts.push(spacePart());
                    addFullSymbolName(symbol2);
                }
            }
        }
        function pushSymbolKind(symbolKind2) {
            switch(symbolKind2){
                case "var" /* variableElement */ :
                case "function" /* functionElement */ :
                case "let" /* letElement */ :
                case "const" /* constElement */ :
                case "constructor" /* constructorImplementationElement */ :
                case "using" /* variableUsingElement */ :
                case "await using" /* variableAwaitUsingElement */ :
                    displayParts.push(textOrKeywordPart(symbolKind2));
                    return;
                default:
                    displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                    displayParts.push(textOrKeywordPart(symbolKind2));
                    displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
                    return;
            }
        }
        function addSignatureDisplayParts(signature, allSignatures, flags = 0 /* None */ ) {
            addRange(displayParts, signatureToDisplayParts(typeChecker, signature, enclosingDeclaration, flags | 32 /* WriteTypeArgumentsOfSignature */ , maximumLength, verbosityLevel, typeWriterOut));
            if (allSignatures.length > 1) {
                displayParts.push(spacePart());
                displayParts.push(punctuationPart(21 /* OpenParenToken */ ));
                displayParts.push(operatorPart(40 /* PlusToken */ ));
                displayParts.push(displayPart((allSignatures.length - 1).toString(), 7 /* numericLiteral */ ));
                displayParts.push(spacePart());
                displayParts.push(textPart(allSignatures.length === 2 ? "overload" : "overloads"));
                displayParts.push(punctuationPart(22 /* CloseParenToken */ ));
            }
            documentation = signature.getDocumentationComment(typeChecker);
            tags = signature.getJsDocTags();
            if (allSignatures.length > 1 && documentation.length === 0 && tags.length === 0) {
                documentation = allSignatures[0].getDocumentationComment(typeChecker);
                tags = allSignatures[0].getJsDocTags().filter((tag)=>tag.name !== "deprecated");
            }
        }
        function writeTypeParametersOfSymbol(symbol2, enclosingDeclaration2) {
            const typeParameterParts = mapToDisplayParts((writer)=>{
                const params = typeChecker.symbolToTypeParameterDeclarations(symbol2, enclosingDeclaration2, symbolDisplayNodeBuilderFlags);
                getPrinter().writeList(53776 /* TypeParameters */ , params, getSourceFileOfNode(getParseTreeNode(enclosingDeclaration2)), writer);
            });
            addRange(displayParts, typeParameterParts);
        }
    }
    function getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, enclosingDeclaration, location, semanticMeaning = getMeaningFromLocation(location), alias, maximumLength, verbosityLevel) {
        return getSymbolDisplayPartsDocumentationAndSymbolKindWorker(typeChecker, symbol, sourceFile, enclosingDeclaration, location, /*type*/ void 0, semanticMeaning, alias, maximumLength, verbosityLevel);
    }
    function isLocalVariableOrFunction(symbol) {
        if (symbol.parent) return false;
        return forEach(symbol.declarations, (declaration)=>{
            if (declaration.kind === 219 /* FunctionExpression */ ) return true;
            if (declaration.kind !== 261 /* VariableDeclaration */  && declaration.kind !== 263 /* FunctionDeclaration */ ) return false;
            for(let parent2 = declaration.parent; !isFunctionBlock(parent2); parent2 = parent2.parent){
                if (parent2.kind === 308 /* SourceFile */  || parent2.kind === 269 /* ModuleBlock */ ) return false;
            }
            return true;
        });
    }
    // src/services/_namespaces/ts.textChanges.ts
    var ts_textChanges_exports = {};
    __export(ts_textChanges_exports, {
        ChangeTracker: ()=>ChangeTracker,
        LeadingTriviaOption: ()=>LeadingTriviaOption,
        TrailingTriviaOption: ()=>TrailingTriviaOption,
        applyChanges: ()=>applyChanges,
        assignPositionsToNode: ()=>assignPositionsToNode,
        createWriter: ()=>createWriter,
        deleteNode: ()=>deleteNode,
        getAdjustedEndPosition: ()=>getAdjustedEndPosition,
        isThisTypeAnnotatable: ()=>isThisTypeAnnotatable,
        isValidLocationToAddComment: ()=>isValidLocationToAddComment
    });
    // src/services/textChanges.ts
    function getPos2(n) {
        const result = n.__pos;
        Debug.assert(typeof result === "number");
        return result;
    }
    function setPos(n, pos) {
        Debug.assert(typeof pos === "number");
        n.__pos = pos;
    }
    function getEnd(n) {
        const result = n.__end;
        Debug.assert(typeof result === "number");
        return result;
    }
    function setEnd(n, end) {
        Debug.assert(typeof end === "number");
        n.__end = end;
    }
    var LeadingTriviaOption = /* @__PURE__ */ ((LeadingTriviaOption2)=>{
        LeadingTriviaOption2[LeadingTriviaOption2["Exclude"] = 0] = "Exclude";
        LeadingTriviaOption2[LeadingTriviaOption2["IncludeAll"] = 1] = "IncludeAll";
        LeadingTriviaOption2[LeadingTriviaOption2["JSDoc"] = 2] = "JSDoc";
        LeadingTriviaOption2[LeadingTriviaOption2["StartLine"] = 3] = "StartLine";
        return LeadingTriviaOption2;
    })(LeadingTriviaOption || {});
    var TrailingTriviaOption = /* @__PURE__ */ ((TrailingTriviaOption2)=>{
        TrailingTriviaOption2[TrailingTriviaOption2["Exclude"] = 0] = "Exclude";
        TrailingTriviaOption2[TrailingTriviaOption2["ExcludeWhitespace"] = 1] = "ExcludeWhitespace";
        TrailingTriviaOption2[TrailingTriviaOption2["Include"] = 2] = "Include";
        return TrailingTriviaOption2;
    })(TrailingTriviaOption || {});
    function skipWhitespacesAndLineBreaks(text, start) {
        return skipTrivia(text, start, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
    }
    function hasCommentsBeforeLineBreak(text, start) {
        let i = start;
        while(i < text.length){
            const ch = text.charCodeAt(i);
            if (isWhiteSpaceSingleLine(ch)) {
                i++;
                continue;
            }
            return ch === 47 /* slash */ ;
        }
        return false;
    }
    var useNonAdjustedPositions = {
        leadingTriviaOption: 0 /* Exclude */ ,
        trailingTriviaOption: 0 /* Exclude */ 
    };
    function getAdjustedRange(sourceFile, startNode2, endNode2, options) {
        return {
            pos: getAdjustedStartPosition(sourceFile, startNode2, options),
            end: getAdjustedEndPosition(sourceFile, endNode2, options)
        };
    }
    function getAdjustedStartPosition(sourceFile, node, options, hasTrailingComment = false) {
        var _a, _b;
        const { leadingTriviaOption } = options;
        if (leadingTriviaOption === 0 /* Exclude */ ) return node.getStart(sourceFile);
        if (leadingTriviaOption === 3 /* StartLine */ ) {
            const startPos = node.getStart(sourceFile);
            const pos = getLineStartPositionForPosition(startPos, sourceFile);
            return rangeContainsPosition(node, pos) ? pos : startPos;
        }
        if (leadingTriviaOption === 2 /* JSDoc */ ) {
            const JSDocComments = getJSDocCommentRanges(node, sourceFile.text);
            if (JSDocComments == null ? void 0 : JSDocComments.length) return getLineStartPositionForPosition(JSDocComments[0].pos, sourceFile);
        }
        const fullStart = node.getFullStart();
        const start = node.getStart(sourceFile);
        if (fullStart === start) return start;
        const fullStartLine = getLineStartPositionForPosition(fullStart, sourceFile);
        const startLine = getLineStartPositionForPosition(start, sourceFile);
        if (startLine === fullStartLine) return leadingTriviaOption === 1 /* IncludeAll */  ? fullStart : start;
        if (hasTrailingComment) {
            const comment = ((_a = getLeadingCommentRanges(sourceFile.text, fullStart)) == null ? void 0 : _a[0]) || ((_b = getTrailingCommentRanges(sourceFile.text, fullStart)) == null ? void 0 : _b[0]);
            if (comment) return skipTrivia(sourceFile.text, comment.end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ true);
        }
        const nextLineStart = fullStart > 0 ? 1 : 0;
        let adjustedStartPosition = getStartPositionOfLine(getLineOfLocalPosition(sourceFile, fullStartLine) + nextLineStart, sourceFile);
        adjustedStartPosition = skipWhitespacesAndLineBreaks(sourceFile.text, adjustedStartPosition);
        return getStartPositionOfLine(getLineOfLocalPosition(sourceFile, adjustedStartPosition), sourceFile);
    }
    function getEndPositionOfMultilineTrailingComment(sourceFile, node, options) {
        const { end } = node;
        const { trailingTriviaOption } = options;
        if (trailingTriviaOption === 2 /* Include */ ) {
            const comments = getTrailingCommentRanges(sourceFile.text, end);
            if (comments) {
                const nodeEndLine = getLineOfLocalPosition(sourceFile, node.end);
                for (const comment of comments){
                    if (comment.kind === 2 /* SingleLineCommentTrivia */  || getLineOfLocalPosition(sourceFile, comment.pos) > nodeEndLine) break;
                    const commentEndLine = getLineOfLocalPosition(sourceFile, comment.end);
                    if (commentEndLine > nodeEndLine) return skipTrivia(sourceFile.text, comment.end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ true);
                }
            }
        }
        return void 0;
    }
    function getAdjustedEndPosition(sourceFile, node, options) {
        var _a;
        const { end } = node;
        const { trailingTriviaOption } = options;
        if (trailingTriviaOption === 0 /* Exclude */ ) return end;
        if (trailingTriviaOption === 1 /* ExcludeWhitespace */ ) {
            const comments = concatenate(getTrailingCommentRanges(sourceFile.text, end), getLeadingCommentRanges(sourceFile.text, end));
            const realEnd = (_a = comments == null ? void 0 : comments[comments.length - 1]) == null ? void 0 : _a.end;
            if (realEnd) return realEnd;
            return end;
        }
        const multilineEndPosition = getEndPositionOfMultilineTrailingComment(sourceFile, node, options);
        if (multilineEndPosition) return multilineEndPosition;
        const newEnd = skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true);
        return newEnd !== end && (trailingTriviaOption === 2 /* Include */  || isLineBreak(sourceFile.text.charCodeAt(newEnd - 1))) ? newEnd : end;
    }
    function isSeparator(node, candidate) {
        return !!candidate && !!node.parent && (candidate.kind === 28 /* CommaToken */  || candidate.kind === 27 /* SemicolonToken */  && node.parent.kind === 211 /* ObjectLiteralExpression */ );
    }
    function isThisTypeAnnotatable(containingFunction) {
        return isFunctionExpression(containingFunction) || isFunctionDeclaration(containingFunction);
    }
    var ChangeTracker = class _ChangeTracker {
        static fromContext(context) {
            return new _ChangeTracker(getNewLineOrDefaultFromHost(context.host, context.formatContext.options), context.formatContext);
        }
        static with(context, cb) {
            const tracker = _ChangeTracker.fromContext(context);
            cb(tracker);
            return tracker.getChanges();
        }
        pushRaw(sourceFile, change) {
            Debug.assertEqual(sourceFile.fileName, change.fileName);
            for (const c of change.textChanges)this.changes.push({
                kind: 3 /* Text */ ,
                sourceFile,
                text: c.newText,
                range: createTextRangeFromSpan(c.span)
            });
        }
        deleteRange(sourceFile, range) {
            this.changes.push({
                kind: 0 /* Remove */ ,
                sourceFile,
                range
            });
        }
        delete(sourceFile, node) {
            this.deletedNodes.push({
                sourceFile,
                node
            });
        }
        /** Stop! Consider using `delete` instead, which has logic for deleting nodes from delimited lists. */ deleteNode(sourceFile, node, options = {
            leadingTriviaOption: 1 /* IncludeAll */ 
        }) {
            this.deleteRange(sourceFile, getAdjustedRange(sourceFile, node, node, options));
        }
        deleteNodes(sourceFile, nodes, options = {
            leadingTriviaOption: 1 /* IncludeAll */ 
        }, hasTrailingComment) {
            for (const node of nodes){
                const pos = getAdjustedStartPosition(sourceFile, node, options, hasTrailingComment);
                const end = getAdjustedEndPosition(sourceFile, node, options);
                this.deleteRange(sourceFile, {
                    pos,
                    end
                });
                hasTrailingComment = !!getEndPositionOfMultilineTrailingComment(sourceFile, node, options);
            }
        }
        deleteModifier(sourceFile, modifier) {
            this.deleteRange(sourceFile, {
                pos: modifier.getStart(sourceFile),
                end: skipTrivia(sourceFile.text, modifier.end, /*stopAfterLineBreak*/ true)
            });
        }
        deleteNodeRange(sourceFile, startNode2, endNode2, options = {
            leadingTriviaOption: 1 /* IncludeAll */ 
        }) {
            const startPosition = getAdjustedStartPosition(sourceFile, startNode2, options);
            const endPosition = getAdjustedEndPosition(sourceFile, endNode2, options);
            this.deleteRange(sourceFile, {
                pos: startPosition,
                end: endPosition
            });
        }
        deleteNodeRangeExcludingEnd(sourceFile, startNode2, afterEndNode, options = {
            leadingTriviaOption: 1 /* IncludeAll */ 
        }) {
            const startPosition = getAdjustedStartPosition(sourceFile, startNode2, options);
            const endPosition = afterEndNode === void 0 ? sourceFile.text.length : getAdjustedStartPosition(sourceFile, afterEndNode, options);
            this.deleteRange(sourceFile, {
                pos: startPosition,
                end: endPosition
            });
        }
        replaceRange(sourceFile, range, newNode, options = {}) {
            this.changes.push({
                kind: 1 /* ReplaceWithSingleNode */ ,
                sourceFile,
                range,
                options,
                node: newNode
            });
        }
        replaceNode(sourceFile, oldNode, newNode, options = useNonAdjustedPositions) {
            this.replaceRange(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, options), newNode, options);
        }
        replaceNodeRange(sourceFile, startNode2, endNode2, newNode, options = useNonAdjustedPositions) {
            this.replaceRange(sourceFile, getAdjustedRange(sourceFile, startNode2, endNode2, options), newNode, options);
        }
        replaceRangeWithNodes(sourceFile, range, newNodes, options = {}) {
            this.changes.push({
                kind: 2 /* ReplaceWithMultipleNodes */ ,
                sourceFile,
                range,
                options,
                nodes: newNodes
            });
        }
        replaceNodeWithNodes(sourceFile, oldNode, newNodes, options = useNonAdjustedPositions) {
            this.replaceRangeWithNodes(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, options), newNodes, options);
        }
        replaceNodeWithText(sourceFile, oldNode, text) {
            this.replaceRangeWithText(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, useNonAdjustedPositions), text);
        }
        replaceNodeRangeWithNodes(sourceFile, startNode2, endNode2, newNodes, options = useNonAdjustedPositions) {
            this.replaceRangeWithNodes(sourceFile, getAdjustedRange(sourceFile, startNode2, endNode2, options), newNodes, options);
        }
        nodeHasTrailingComment(sourceFile, oldNode, configurableEnd = useNonAdjustedPositions) {
            return !!getEndPositionOfMultilineTrailingComment(sourceFile, oldNode, configurableEnd);
        }
        nextCommaToken(sourceFile, node) {
            const next = findNextToken(node, node.parent, sourceFile);
            return next && next.kind === 28 /* CommaToken */  ? next : void 0;
        }
        replacePropertyAssignment(sourceFile, oldNode, newNode) {
            const suffix = this.nextCommaToken(sourceFile, oldNode) ? "" : "," + this.newLineCharacter;
            this.replaceNode(sourceFile, oldNode, newNode, {
                suffix
            });
        }
        insertNodeAt(sourceFile, pos, newNode, options = {}) {
            this.replaceRange(sourceFile, createRange(pos), newNode, options);
        }
        insertNodesAt(sourceFile, pos, newNodes, options = {}) {
            this.replaceRangeWithNodes(sourceFile, createRange(pos), newNodes, options);
        }
        insertNodeAtTopOfFile(sourceFile, newNode, blankLineBetween) {
            this.insertAtTopOfFile(sourceFile, newNode, blankLineBetween);
        }
        insertNodesAtTopOfFile(sourceFile, newNodes, blankLineBetween) {
            this.insertAtTopOfFile(sourceFile, newNodes, blankLineBetween);
        }
        insertAtTopOfFile(sourceFile, insert, blankLineBetween) {
            const pos = getInsertionPositionAtSourceFileTop(sourceFile);
            const options = {
                prefix: pos === 0 ? void 0 : this.newLineCharacter,
                suffix: (isLineBreak(sourceFile.text.charCodeAt(pos)) ? "" : this.newLineCharacter) + (blankLineBetween ? this.newLineCharacter : "")
            };
            if (isArray(insert)) this.insertNodesAt(sourceFile, pos, insert, options);
            else this.insertNodeAt(sourceFile, pos, insert, options);
        }
        insertNodesAtEndOfFile(sourceFile, newNodes, blankLineBetween) {
            this.insertAtEndOfFile(sourceFile, newNodes, blankLineBetween);
        }
        insertAtEndOfFile(sourceFile, insert, blankLineBetween) {
            const pos = sourceFile.end + 1;
            const options = {
                prefix: this.newLineCharacter,
                suffix: this.newLineCharacter + (blankLineBetween ? this.newLineCharacter : "")
            };
            this.insertNodesAt(sourceFile, pos, insert, options);
        }
        insertStatementsInNewFile(fileName, statements, oldFile) {
            if (!this.newFileChanges) this.newFileChanges = createMultiMap();
            this.newFileChanges.add(fileName, {
                oldFile,
                statements
            });
        }
        insertFirstParameter(sourceFile, parameters, newParam) {
            const p0 = firstOrUndefined(parameters);
            if (p0) this.insertNodeBefore(sourceFile, p0, newParam);
            else this.insertNodeAt(sourceFile, parameters.pos, newParam);
        }
        insertNodeBefore(sourceFile, before, newNode, blankLineBetween = false, options = {}) {
            this.insertNodeAt(sourceFile, getAdjustedStartPosition(sourceFile, before, options), newNode, this.getOptionsForInsertNodeBefore(before, newNode, blankLineBetween));
        }
        insertNodesBefore(sourceFile, before, newNodes, blankLineBetween = false, options = {}) {
            this.insertNodesAt(sourceFile, getAdjustedStartPosition(sourceFile, before, options), newNodes, this.getOptionsForInsertNodeBefore(before, first(newNodes), blankLineBetween));
        }
        insertModifierAt(sourceFile, pos, modifier, options = {}) {
            this.insertNodeAt(sourceFile, pos, factory.createToken(modifier), options);
        }
        insertModifierBefore(sourceFile, modifier, before) {
            return this.insertModifierAt(sourceFile, before.getStart(sourceFile), modifier, {
                suffix: " "
            });
        }
        insertCommentBeforeLine(sourceFile, lineNumber, position, commentText) {
            const lineStartPosition = getStartPositionOfLine(lineNumber, sourceFile);
            const startPosition = getFirstNonSpaceCharacterPosition(sourceFile.text, lineStartPosition);
            const insertAtLineStart = isValidLocationToAddComment(sourceFile, startPosition);
            const token = getTouchingToken(sourceFile, insertAtLineStart ? startPosition : position);
            const indent3 = sourceFile.text.slice(lineStartPosition, startPosition);
            const text = `${insertAtLineStart ? "" : this.newLineCharacter}//${commentText}${this.newLineCharacter}${indent3}`;
            this.insertText(sourceFile, token.getStart(sourceFile), text);
        }
        insertJsdocCommentBefore(sourceFile, node, tag) {
            const fnStart = node.getStart(sourceFile);
            if (node.jsDoc) for (const jsdoc of node.jsDoc)this.deleteRange(sourceFile, {
                pos: getLineStartPositionForPosition(jsdoc.getStart(sourceFile), sourceFile),
                end: getAdjustedEndPosition(sourceFile, jsdoc, /*options*/ {})
            });
            const startPosition = getPrecedingNonSpaceCharacterPosition(sourceFile.text, fnStart - 1);
            const indent3 = sourceFile.text.slice(startPosition, fnStart);
            this.insertNodeAt(sourceFile, fnStart, tag, {
                suffix: this.newLineCharacter + indent3
            });
        }
        createJSDocText(sourceFile, node) {
            const comments = flatMap(node.jsDoc, (jsDoc2)=>isString(jsDoc2.comment) ? factory.createJSDocText(jsDoc2.comment) : jsDoc2.comment);
            const jsDoc = singleOrUndefined(node.jsDoc);
            return jsDoc && positionsAreOnSameLine(jsDoc.pos, jsDoc.end, sourceFile) && length(comments) === 0 ? void 0 : factory.createNodeArray(intersperse(comments, factory.createJSDocText("\n")));
        }
        replaceJSDocComment(sourceFile, node, tags) {
            this.insertJsdocCommentBefore(sourceFile, updateJSDocHost(node), factory.createJSDocComment(this.createJSDocText(sourceFile, node), factory.createNodeArray(tags)));
        }
        addJSDocTags(sourceFile, parent2, newTags) {
            const oldTags = flatMapToMutable(parent2.jsDoc, (j)=>j.tags);
            const unmergedNewTags = newTags.filter((newTag)=>!oldTags.some((tag, i)=>{
                    const merged = tryMergeJsdocTags(tag, newTag);
                    if (merged) oldTags[i] = merged;
                    return !!merged;
                }));
            this.replaceJSDocComment(sourceFile, parent2, [
                ...oldTags,
                ...unmergedNewTags
            ]);
        }
        filterJSDocTags(sourceFile, parent2, predicate) {
            this.replaceJSDocComment(sourceFile, parent2, filter(flatMapToMutable(parent2.jsDoc, (j)=>j.tags), predicate));
        }
        replaceRangeWithText(sourceFile, range, text) {
            this.changes.push({
                kind: 3 /* Text */ ,
                sourceFile,
                range,
                text
            });
        }
        insertText(sourceFile, pos, text) {
            this.replaceRangeWithText(sourceFile, createRange(pos), text);
        }
        /** Prefer this over replacing a node with another that has a type annotation, as it avoids reformatting the other parts of the node. */ tryInsertTypeAnnotation(sourceFile, node, type) {
            let endNode2;
            var _ref;
            if (isFunctionLike(node)) {
                endNode2 = findChildOfKind(node, 22 /* CloseParenToken */ , sourceFile);
                if (!endNode2) {
                    if (!isArrowFunction(node)) return false;
                    endNode2 = first(node.parameters);
                }
            } else endNode2 = (_ref = node.kind === 261 /* VariableDeclaration */  ? node.exclamationToken : node.questionToken) !== null && _ref !== void 0 ? _ref : node.name;
            this.insertNodeAt(sourceFile, endNode2.end, type, {
                prefix: ": "
            });
            return true;
        }
        tryInsertThisTypeAnnotation(sourceFile, node, type) {
            const start = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile).getStart(sourceFile) + 1;
            const suffix = node.parameters.length ? ", " : "";
            this.insertNodeAt(sourceFile, start, type, {
                prefix: "this: ",
                suffix
            });
        }
        insertTypeParameters(sourceFile, node, typeParameters) {
            const start = (findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile) || first(node.parameters)).getStart(sourceFile);
            this.insertNodesAt(sourceFile, start, typeParameters, {
                prefix: "<",
                suffix: ">",
                joiner: ", "
            });
        }
        getOptionsForInsertNodeBefore(before, inserted, blankLineBetween) {
            if (isStatement(before) || isClassElement(before)) return {
                suffix: blankLineBetween ? this.newLineCharacter + this.newLineCharacter : this.newLineCharacter
            };
            else if (isVariableDeclaration(before)) return {
                suffix: ", "
            };
            else if (isParameter(before)) return isParameter(inserted) ? {
                suffix: ", "
            } : {};
            else if (isStringLiteral(before) && isImportDeclaration(before.parent) || isNamedImports(before)) return {
                suffix: ", "
            };
            else if (isImportSpecifier(before)) return {
                suffix: "," + (blankLineBetween ? this.newLineCharacter : " ")
            };
            return Debug.failBadSyntaxKind(before);
        }
        insertNodeAtConstructorStart(sourceFile, ctr, newStatement) {
            const firstStatement = firstOrUndefined(ctr.body.statements);
            if (!firstStatement || !ctr.body.multiLine) this.replaceConstructorBody(sourceFile, ctr, [
                newStatement,
                ...ctr.body.statements
            ]);
            else this.insertNodeBefore(sourceFile, firstStatement, newStatement);
        }
        insertNodeAtConstructorStartAfterSuperCall(sourceFile, ctr, newStatement) {
            const superCallStatement = find(ctr.body.statements, (stmt)=>isExpressionStatement(stmt) && isSuperCall(stmt.expression));
            if (!superCallStatement || !ctr.body.multiLine) this.replaceConstructorBody(sourceFile, ctr, [
                ...ctr.body.statements,
                newStatement
            ]);
            else this.insertNodeAfter(sourceFile, superCallStatement, newStatement);
        }
        insertNodeAtConstructorEnd(sourceFile, ctr, newStatement) {
            const lastStatement = lastOrUndefined(ctr.body.statements);
            if (!lastStatement || !ctr.body.multiLine) this.replaceConstructorBody(sourceFile, ctr, [
                ...ctr.body.statements,
                newStatement
            ]);
            else this.insertNodeAfter(sourceFile, lastStatement, newStatement);
        }
        replaceConstructorBody(sourceFile, ctr, statements) {
            this.replaceNode(sourceFile, ctr.body, factory.createBlock(statements, /*multiLine*/ true));
        }
        insertNodeAtEndOfScope(sourceFile, scope, newNode) {
            const pos = getAdjustedStartPosition(sourceFile, scope.getLastToken(), {});
            this.insertNodeAt(sourceFile, pos, newNode, {
                prefix: isLineBreak(sourceFile.text.charCodeAt(scope.getLastToken().pos)) ? this.newLineCharacter : this.newLineCharacter + this.newLineCharacter,
                suffix: this.newLineCharacter
            });
        }
        insertMemberAtStart(sourceFile, node, newElement) {
            this.insertNodeAtStartWorker(sourceFile, node, newElement);
        }
        insertNodeAtObjectStart(sourceFile, obj, newElement) {
            this.insertNodeAtStartWorker(sourceFile, obj, newElement);
        }
        insertNodeAtStartWorker(sourceFile, node, newElement) {
            var _this_guessIndentationFromExistingMembers;
            const indentation = (_this_guessIndentationFromExistingMembers = this.guessIndentationFromExistingMembers(sourceFile, node)) !== null && _this_guessIndentationFromExistingMembers !== void 0 ? _this_guessIndentationFromExistingMembers : this.computeIndentationForNewMember(sourceFile, node);
            this.insertNodeAt(sourceFile, getMembersOrProperties(node).pos, newElement, this.getInsertNodeAtStartInsertOptions(sourceFile, node, indentation));
        }
        /**
   * Tries to guess the indentation from the existing members of a class/interface/object. All members must be on
   * new lines and must share the same indentation.
   */ guessIndentationFromExistingMembers(sourceFile, node) {
            let indentation;
            let lastRange = node;
            for (const member of getMembersOrProperties(node)){
                if (rangeStartPositionsAreOnSameLine(lastRange, member, sourceFile)) return void 0;
                const memberStart = member.getStart(sourceFile);
                const memberIndentation = ts_formatting_exports.SmartIndenter.findFirstNonWhitespaceColumn(getLineStartPositionForPosition(memberStart, sourceFile), memberStart, sourceFile, this.formatContext.options);
                if (indentation === void 0) indentation = memberIndentation;
                else if (memberIndentation !== indentation) return void 0;
                lastRange = member;
            }
            return indentation;
        }
        computeIndentationForNewMember(sourceFile, node) {
            const nodeStart = node.getStart(sourceFile);
            var _this_formatContext_options_indentSize;
            return ts_formatting_exports.SmartIndenter.findFirstNonWhitespaceColumn(getLineStartPositionForPosition(nodeStart, sourceFile), nodeStart, sourceFile, this.formatContext.options) + ((_this_formatContext_options_indentSize = this.formatContext.options.indentSize) !== null && _this_formatContext_options_indentSize !== void 0 ? _this_formatContext_options_indentSize : 4);
        }
        getInsertNodeAtStartInsertOptions(sourceFile, node, indentation) {
            const members = getMembersOrProperties(node);
            const isEmpty = members.length === 0;
            const isFirstInsertion = !this.classesWithNodesInsertedAtStart.has(getNodeId(node));
            if (isFirstInsertion) this.classesWithNodesInsertedAtStart.set(getNodeId(node), {
                node,
                sourceFile
            });
            const insertTrailingComma = isObjectLiteralExpression(node) && (!isJsonSourceFile(sourceFile) || !isEmpty);
            const insertLeadingComma = isObjectLiteralExpression(node) && isJsonSourceFile(sourceFile) && isEmpty && !isFirstInsertion;
            return {
                indentation,
                prefix: (insertLeadingComma ? "," : "") + this.newLineCharacter,
                suffix: insertTrailingComma ? "," : isInterfaceDeclaration(node) && isEmpty ? ";" : ""
            };
        }
        insertNodeAfterComma(sourceFile, after, newNode) {
            const endPosition = this.insertNodeAfterWorker(sourceFile, this.nextCommaToken(sourceFile, after) || after, newNode);
            this.insertNodeAt(sourceFile, endPosition, newNode, this.getInsertNodeAfterOptions(sourceFile, after));
        }
        insertNodeAfter(sourceFile, after, newNode) {
            const endPosition = this.insertNodeAfterWorker(sourceFile, after, newNode);
            this.insertNodeAt(sourceFile, endPosition, newNode, this.getInsertNodeAfterOptions(sourceFile, after));
        }
        insertNodeAtEndOfList(sourceFile, list, newNode) {
            this.insertNodeAt(sourceFile, list.end, newNode, {
                prefix: ", "
            });
        }
        insertNodesAfter(sourceFile, after, newNodes) {
            const endPosition = this.insertNodeAfterWorker(sourceFile, after, first(newNodes));
            this.insertNodesAt(sourceFile, endPosition, newNodes, this.getInsertNodeAfterOptions(sourceFile, after));
        }
        insertNodeAfterWorker(sourceFile, after, newNode) {
            if (needSemicolonBetween(after, newNode)) {
                if (sourceFile.text.charCodeAt(after.end - 1) !== 59 /* semicolon */ ) this.replaceRange(sourceFile, createRange(after.end), factory.createToken(27 /* SemicolonToken */ ));
            }
            const endPosition = getAdjustedEndPosition(sourceFile, after, {});
            return endPosition;
        }
        getInsertNodeAfterOptions(sourceFile, after) {
            const options = this.getInsertNodeAfterOptionsWorker(after);
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                prefix: after.end === sourceFile.end && isStatement(after) ? options.prefix ? `
${options.prefix}` : "\n" : options.prefix
            });
        }
        getInsertNodeAfterOptionsWorker(node) {
            switch(node.kind){
                case 264 /* ClassDeclaration */ :
                case 268 /* ModuleDeclaration */ :
                    return {
                        prefix: this.newLineCharacter,
                        suffix: this.newLineCharacter
                    };
                case 261 /* VariableDeclaration */ :
                case 11 /* StringLiteral */ :
                case 80 /* Identifier */ :
                    return {
                        prefix: ", "
                    };
                case 304 /* PropertyAssignment */ :
                    return {
                        suffix: "," + this.newLineCharacter
                    };
                case 95 /* ExportKeyword */ :
                    return {
                        prefix: " "
                    };
                case 170 /* Parameter */ :
                    return {};
                default:
                    Debug.assert(isStatement(node) || isClassOrTypeElement(node));
                    return {
                        suffix: this.newLineCharacter
                    };
            }
        }
        insertName(sourceFile, node, name) {
            Debug.assert(!node.name);
            if (node.kind === 220 /* ArrowFunction */ ) {
                const arrow = findChildOfKind(node, 39 /* EqualsGreaterThanToken */ , sourceFile);
                const lparen = findChildOfKind(node, 21 /* OpenParenToken */ , sourceFile);
                if (lparen) {
                    this.insertNodesAt(sourceFile, lparen.getStart(sourceFile), [
                        factory.createToken(100 /* FunctionKeyword */ ),
                        factory.createIdentifier(name)
                    ], {
                        joiner: " "
                    });
                    deleteNode(this, sourceFile, arrow);
                } else {
                    this.insertText(sourceFile, first(node.parameters).getStart(sourceFile), `function ${name}(`);
                    this.replaceRange(sourceFile, arrow, factory.createToken(22 /* CloseParenToken */ ));
                }
                if (node.body.kind !== 242 /* Block */ ) {
                    this.insertNodesAt(sourceFile, node.body.getStart(sourceFile), [
                        factory.createToken(19 /* OpenBraceToken */ ),
                        factory.createToken(107 /* ReturnKeyword */ )
                    ], {
                        joiner: " ",
                        suffix: " "
                    });
                    this.insertNodesAt(sourceFile, node.body.end, [
                        factory.createToken(27 /* SemicolonToken */ ),
                        factory.createToken(20 /* CloseBraceToken */ )
                    ], {
                        joiner: " "
                    });
                }
            } else {
                const pos = findChildOfKind(node, node.kind === 219 /* FunctionExpression */  ? 100 /* FunctionKeyword */  : 86 /* ClassKeyword */ , sourceFile).end;
                this.insertNodeAt(sourceFile, pos, factory.createIdentifier(name), {
                    prefix: " "
                });
            }
        }
        insertExportModifier(sourceFile, node) {
            this.insertText(sourceFile, node.getStart(sourceFile), "export ");
        }
        insertImportSpecifierAtIndex(sourceFile, importSpecifier, namedImports, index) {
            const prevSpecifier = namedImports.elements[index - 1];
            if (prevSpecifier) this.insertNodeInListAfter(sourceFile, prevSpecifier, importSpecifier);
            else this.insertNodeBefore(sourceFile, namedImports.elements[0], importSpecifier, !positionsAreOnSameLine(namedImports.elements[0].getStart(), namedImports.parent.parent.getStart(), sourceFile));
        }
        /**
   * This function should be used to insert nodes in lists when nodes don't carry separators as the part of the node range,
   * i.e. arguments in arguments lists, parameters in parameter lists etc.
   * Note that separators are part of the node in statements and class elements.
   */ insertNodeInListAfter(sourceFile, after, newNode, containingList = ts_formatting_exports.SmartIndenter.getContainingList(after, sourceFile)) {
            if (!containingList) {
                Debug.fail("node is not a list element");
                return;
            }
            const index = indexOfNode(containingList, after);
            if (index < 0) return;
            const end = after.getEnd();
            if (index !== containingList.length - 1) {
                const nextToken = getTokenAtPosition(sourceFile, after.end);
                if (nextToken && isSeparator(after, nextToken)) {
                    const nextNode = containingList[index + 1];
                    const startPos = skipWhitespacesAndLineBreaks(sourceFile.text, nextNode.getFullStart());
                    const suffix = `${tokenToString(nextToken.kind)}${sourceFile.text.substring(nextToken.end, startPos)}`;
                    this.insertNodesAt(sourceFile, startPos, [
                        newNode
                    ], {
                        suffix
                    });
                }
            } else {
                const afterStart = after.getStart(sourceFile);
                const afterStartLinePosition = getLineStartPositionForPosition(afterStart, sourceFile);
                let separator;
                let multilineList = false;
                if (containingList.length === 1) separator = 28 /* CommaToken */ ;
                else {
                    const tokenBeforeInsertPosition = findPrecedingToken(after.pos, sourceFile);
                    separator = isSeparator(after, tokenBeforeInsertPosition) ? tokenBeforeInsertPosition.kind : 28 /* CommaToken */ ;
                    const afterMinusOneStartLinePosition = getLineStartPositionForPosition(containingList[index - 1].getStart(sourceFile), sourceFile);
                    multilineList = afterMinusOneStartLinePosition !== afterStartLinePosition;
                }
                if (hasCommentsBeforeLineBreak(sourceFile.text, after.end) || !positionsAreOnSameLine(containingList.pos, containingList.end, sourceFile)) multilineList = true;
                if (multilineList) {
                    this.replaceRange(sourceFile, createRange(end), factory.createToken(separator));
                    const indentation = ts_formatting_exports.SmartIndenter.findFirstNonWhitespaceColumn(afterStartLinePosition, afterStart, sourceFile, this.formatContext.options);
                    let insertPos = skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ false);
                    while(insertPos !== end && isLineBreak(sourceFile.text.charCodeAt(insertPos - 1)))insertPos--;
                    this.replaceRange(sourceFile, createRange(insertPos), newNode, {
                        indentation,
                        prefix: this.newLineCharacter
                    });
                } else this.replaceRange(sourceFile, createRange(end), newNode, {
                    prefix: `${tokenToString(separator)} `
                });
            }
        }
        parenthesizeExpression(sourceFile, expression) {
            this.replaceRange(sourceFile, rangeOfNode(expression), factory.createParenthesizedExpression(expression));
        }
        finishClassesWithNodesInsertedAtStart() {
            this.classesWithNodesInsertedAtStart.forEach(({ node, sourceFile })=>{
                const [openBraceEnd, closeBraceEnd] = getClassOrObjectBraceEnds(node, sourceFile);
                if (openBraceEnd !== void 0 && closeBraceEnd !== void 0) {
                    const isEmpty = getMembersOrProperties(node).length === 0;
                    const isSingleLine = positionsAreOnSameLine(openBraceEnd, closeBraceEnd, sourceFile);
                    if (isEmpty && isSingleLine && openBraceEnd !== closeBraceEnd - 1) this.deleteRange(sourceFile, createRange(openBraceEnd, closeBraceEnd - 1));
                    if (isSingleLine) this.insertText(sourceFile, closeBraceEnd - 1, this.newLineCharacter);
                }
            });
        }
        finishDeleteDeclarations() {
            const deletedNodesInLists = /* @__PURE__ */ new Set();
            for (const { sourceFile, node } of this.deletedNodes)if (!this.deletedNodes.some((d)=>d.sourceFile === sourceFile && rangeContainsRangeExclusive(d.node, node))) {
                if (isArray(node)) this.deleteRange(sourceFile, rangeOfTypeParameters(sourceFile, node));
                else deleteDeclaration.deleteDeclaration(this, deletedNodesInLists, sourceFile, node);
            }
            deletedNodesInLists.forEach((node)=>{
                const sourceFile = node.getSourceFile();
                const list = ts_formatting_exports.SmartIndenter.getContainingList(node, sourceFile);
                if (node !== last(list)) return;
                const lastNonDeletedIndex = findLastIndex(list, (n)=>!deletedNodesInLists.has(n), list.length - 2);
                if (lastNonDeletedIndex !== -1) this.deleteRange(sourceFile, {
                    pos: list[lastNonDeletedIndex].end,
                    end: startPositionToDeleteNodeInList(sourceFile, list[lastNonDeletedIndex + 1])
                });
            });
        }
        /**
   * Note: after calling this, the TextChanges object must be discarded!
   * @param validate only for tests
   *    The reason we must validate as part of this method is that `getNonFormattedText` changes the node's positions,
   *    so we can only call this once and can't get the non-formatted text separately.
   */ getChanges(validate) {
            this.finishDeleteDeclarations();
            this.finishClassesWithNodesInsertedAtStart();
            const changes = changesToText.getTextChangesFromChanges(this.changes, this.newLineCharacter, this.formatContext, validate);
            if (this.newFileChanges) this.newFileChanges.forEach((insertions, fileName)=>{
                changes.push(changesToText.newFileChanges(fileName, insertions, this.newLineCharacter, this.formatContext));
            });
            return changes;
        }
        createNewFile(oldFile, fileName, statements) {
            this.insertStatementsInNewFile(fileName, statements, oldFile);
        }
        /** Public for tests only. Other callers should use `ChangeTracker.with`. */ constructor(newLineCharacter, formatContext){
            this.newLineCharacter = newLineCharacter;
            this.formatContext = formatContext;
            this.changes = [];
            this.classesWithNodesInsertedAtStart = /* @__PURE__ */ new Map();
            // Set<ClassDeclaration> implemented as Map<node id, ClassDeclaration>
            this.deletedNodes = [];
        }
    };
    function updateJSDocHost(parent2) {
        if (parent2.kind !== 220 /* ArrowFunction */ ) return parent2;
        const jsDocNode = parent2.parent.kind === 173 /* PropertyDeclaration */  ? parent2.parent : parent2.parent.parent;
        jsDocNode.jsDoc = parent2.jsDoc;
        return jsDocNode;
    }
    function tryMergeJsdocTags(oldTag, newTag) {
        if (oldTag.kind !== newTag.kind) return void 0;
        switch(oldTag.kind){
            case 342 /* JSDocParameterTag */ :
                {
                    const oldParam = oldTag;
                    const newParam = newTag;
                    return isIdentifier(oldParam.name) && isIdentifier(newParam.name) && oldParam.name.escapedText === newParam.name.escapedText ? factory.createJSDocParameterTag(/*tagName*/ void 0, newParam.name, /*isBracketed*/ false, newParam.typeExpression, newParam.isNameFirst, oldParam.comment) : void 0;
                }
            case 343 /* JSDocReturnTag */ :
                return factory.createJSDocReturnTag(/*tagName*/ void 0, newTag.typeExpression, oldTag.comment);
            case 345 /* JSDocTypeTag */ :
                return factory.createJSDocTypeTag(/*tagName*/ void 0, newTag.typeExpression, oldTag.comment);
        }
    }
    function startPositionToDeleteNodeInList(sourceFile, node) {
        return skipTrivia(sourceFile.text, getAdjustedStartPosition(sourceFile, node, {
            leadingTriviaOption: 1 /* IncludeAll */ 
        }), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
    }
    function endPositionToDeleteNodeInList(sourceFile, node, prevNode, nextNode) {
        const end = startPositionToDeleteNodeInList(sourceFile, nextNode);
        if (prevNode === void 0 || positionsAreOnSameLine(getAdjustedEndPosition(sourceFile, node, {}), end, sourceFile)) return end;
        const token = findPrecedingToken(nextNode.getStart(sourceFile), sourceFile);
        if (isSeparator(node, token)) {
            const prevToken = findPrecedingToken(node.getStart(sourceFile), sourceFile);
            if (isSeparator(prevNode, prevToken)) {
                const pos = skipTrivia(sourceFile.text, token.getEnd(), /*stopAfterLineBreak*/ true, /*stopAtComments*/ true);
                if (positionsAreOnSameLine(prevToken.getStart(sourceFile), token.getStart(sourceFile), sourceFile)) return isLineBreak(sourceFile.text.charCodeAt(pos - 1)) ? pos - 1 : pos;
                if (isLineBreak(sourceFile.text.charCodeAt(pos))) return pos;
            }
        }
        return end;
    }
    function getClassOrObjectBraceEnds(cls, sourceFile) {
        const open = findChildOfKind(cls, 19 /* OpenBraceToken */ , sourceFile);
        const close = findChildOfKind(cls, 20 /* CloseBraceToken */ , sourceFile);
        return [
            open == null ? void 0 : open.end,
            close == null ? void 0 : close.end
        ];
    }
    function getMembersOrProperties(node) {
        return isObjectLiteralExpression(node) ? node.properties : node.members;
    }
    var changesToText;
    ((changesToText2)=>{
        function getTextChangesFromChanges(changes, newLineCharacter, formatContext, validate) {
            return mapDefined(group(changes, (c)=>c.sourceFile.path), (changesInFile)=>{
                const sourceFile = changesInFile[0].sourceFile;
                const normalized = toSorted(changesInFile, (a, b)=>a.range.pos - b.range.pos || a.range.end - b.range.end);
                for(let i = 0; i < normalized.length - 1; i++)Debug.assert(normalized[i].range.end <= normalized[i + 1].range.pos, "Changes overlap", ()=>`${JSON.stringify(normalized[i].range)} and ${JSON.stringify(normalized[i + 1].range)}`);
                const textChanges2 = mapDefined(normalized, (c)=>{
                    const span = createTextSpanFromRange(c.range);
                    var _getSourceFileOfNode, _getSourceFileOfNode1;
                    const targetSourceFile = c.kind === 1 /* ReplaceWithSingleNode */  ? (_getSourceFileOfNode = getSourceFileOfNode(getOriginalNode(c.node))) !== null && _getSourceFileOfNode !== void 0 ? _getSourceFileOfNode : c.sourceFile : c.kind === 2 /* ReplaceWithMultipleNodes */  ? (_getSourceFileOfNode1 = getSourceFileOfNode(getOriginalNode(c.nodes[0]))) !== null && _getSourceFileOfNode1 !== void 0 ? _getSourceFileOfNode1 : c.sourceFile : c.sourceFile;
                    const newText = computeNewText(c, targetSourceFile, sourceFile, newLineCharacter, formatContext, validate);
                    if (span.length === newText.length && stringContainsAt(targetSourceFile.text, newText, span.start)) return void 0;
                    return createTextChange(span, newText);
                });
                return textChanges2.length > 0 ? {
                    fileName: sourceFile.fileName,
                    textChanges: textChanges2
                } : void 0;
            });
        }
        changesToText2.getTextChangesFromChanges = getTextChangesFromChanges;
        function newFileChanges(fileName, insertions, newLineCharacter, formatContext) {
            const text = newFileChangesWorker(getScriptKindFromFileName(fileName), insertions, newLineCharacter, formatContext);
            return {
                fileName,
                textChanges: [
                    createTextChange(createTextSpan(0, 0), text)
                ],
                isNewFile: true
            };
        }
        changesToText2.newFileChanges = newFileChanges;
        function newFileChangesWorker(scriptKind, insertions, newLineCharacter, formatContext) {
            const nonFormattedText = flatMap(insertions, (insertion)=>insertion.statements.map((s)=>s === 4 /* NewLineTrivia */  ? "" : getNonformattedText(s, insertion.oldFile, newLineCharacter).text)).join(newLineCharacter);
            const sourceFile = createSourceFile("any file name", nonFormattedText, {
                languageVersion: 99 /* ESNext */ ,
                jsDocParsingMode: 1 /* ParseNone */ 
            }, /*setParentNodes*/ true, scriptKind);
            const changes = ts_formatting_exports.formatDocument(sourceFile, formatContext);
            return applyChanges(nonFormattedText, changes) + newLineCharacter;
        }
        changesToText2.newFileChangesWorker = newFileChangesWorker;
        function computeNewText(change, targetSourceFile, sourceFile, newLineCharacter, formatContext, validate) {
            var _a;
            if (change.kind === 0 /* Remove */ ) return "";
            if (change.kind === 3 /* Text */ ) return change.text;
            const { options = {}, range: { pos } } = change;
            const format = (n)=>getFormattedTextOfNode(n, targetSourceFile, sourceFile, pos, options, newLineCharacter, formatContext, validate);
            const text = change.kind === 2 /* ReplaceWithMultipleNodes */  ? change.nodes.map((n)=>removeSuffix(format(n), newLineCharacter)).join(((_a = change.options) == null ? void 0 : _a.joiner) || newLineCharacter) : format(change.node);
            const noIndent = options.indentation !== void 0 || getLineStartPositionForPosition(pos, targetSourceFile) === pos ? text : text.replace(/^\s+/, "");
            return (options.prefix || "") + noIndent + (!options.suffix || endsWith(noIndent, options.suffix) ? "" : options.suffix);
        }
        function getFormattedTextOfNode(nodeIn, targetSourceFile, sourceFile, pos, { indentation, prefix, delta }, newLineCharacter, formatContext, validate) {
            const { node, text } = getNonformattedText(nodeIn, targetSourceFile, newLineCharacter);
            if (validate) validate(node, text);
            const formatOptions = getFormatCodeSettingsForWriting(formatContext, targetSourceFile);
            const initialIndentation = indentation !== void 0 ? indentation : ts_formatting_exports.SmartIndenter.getIndentation(pos, sourceFile, formatOptions, prefix === newLineCharacter || getLineStartPositionForPosition(pos, targetSourceFile) === pos);
            if (delta === void 0) delta = ts_formatting_exports.SmartIndenter.shouldIndentChildNode(formatOptions, nodeIn) ? formatOptions.indentSize || 0 : 0;
            const file = {
                text,
                getLineAndCharacterOfPosition (pos2) {
                    return getLineAndCharacterOfPosition(this, pos2);
                }
            };
            const changes = ts_formatting_exports.formatNodeGivenIndentation(node, file, targetSourceFile.languageVariant, initialIndentation, delta, (0, _objectSpreadProps._)((0, _objectSpread._)({}, formatContext), {
                options: formatOptions
            }));
            return applyChanges(text, changes);
        }
        function getNonformattedText(node, sourceFile, newLineCharacter) {
            const writer = createWriter(newLineCharacter);
            const newLine = getNewLineKind(newLineCharacter);
            createPrinter({
                newLine,
                neverAsciiEscape: true,
                preserveSourceNewlines: true,
                terminateUnterminatedLiterals: true
            }, writer).writeNode(4 /* Unspecified */ , node, sourceFile, writer);
            return {
                text: writer.getText(),
                node: assignPositionsToNode(node)
            };
        }
        changesToText2.getNonformattedText = getNonformattedText;
    })(changesToText || (changesToText = {}));
    function applyChanges(text, changes) {
        for(let i = changes.length - 1; i >= 0; i--){
            const { span, newText } = changes[i];
            text = `${text.substring(0, span.start)}${newText}${text.substring(textSpanEnd(span))}`;
        }
        return text;
    }
    function isTrivia2(s) {
        return skipTrivia(s, 0) === s.length;
    }
    var textChangesTransformationContext = (0, _objectSpreadProps._)((0, _objectSpread._)({}, nullTransformationContext), {
        factory: createNodeFactory(nullTransformationContext.factory.flags | 1 /* NoParenthesizerRules */ , nullTransformationContext.factory.baseFactory)
    });
    function assignPositionsToNode(node) {
        const visited = visitEachChild(node, assignPositionsToNode, textChangesTransformationContext, assignPositionsToNodeArray, assignPositionsToNode);
        const newNode = nodeIsSynthesized(visited) ? visited : Object.create(visited);
        setTextRangePosEnd(newNode, getPos2(node), getEnd(node));
        return newNode;
    }
    function assignPositionsToNodeArray(nodes, visitor, test, start, count) {
        const visited = visitNodes2(nodes, visitor, test, start, count);
        if (!visited) return visited;
        Debug.assert(nodes);
        const nodeArray = visited === nodes ? factory.createNodeArray(visited.slice(0)) : visited;
        setTextRangePosEnd(nodeArray, getPos2(nodes), getEnd(nodes));
        return nodeArray;
    }
    function createWriter(newLine) {
        let lastNonTriviaPosition = 0;
        const writer = createTextWriter(newLine);
        const onBeforeEmitNode = (node)=>{
            if (node) setPos(node, lastNonTriviaPosition);
        };
        const onAfterEmitNode = (node)=>{
            if (node) setEnd(node, lastNonTriviaPosition);
        };
        const onBeforeEmitNodeArray = (nodes)=>{
            if (nodes) setPos(nodes, lastNonTriviaPosition);
        };
        const onAfterEmitNodeArray = (nodes)=>{
            if (nodes) setEnd(nodes, lastNonTriviaPosition);
        };
        const onBeforeEmitToken = (node)=>{
            if (node) setPos(node, lastNonTriviaPosition);
        };
        const onAfterEmitToken = (node)=>{
            if (node) setEnd(node, lastNonTriviaPosition);
        };
        function setLastNonTriviaPosition(s, force) {
            if (force || !isTrivia2(s)) {
                lastNonTriviaPosition = writer.getTextPos();
                let i = 0;
                while(isWhiteSpaceLike(s.charCodeAt(s.length - i - 1)))i++;
                lastNonTriviaPosition -= i;
            }
        }
        function write(s) {
            writer.write(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeComment(s) {
            writer.writeComment(s);
        }
        function writeKeyword(s) {
            writer.writeKeyword(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeOperator(s) {
            writer.writeOperator(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writePunctuation(s) {
            writer.writePunctuation(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeTrailingSemicolon(s) {
            writer.writeTrailingSemicolon(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeParameter(s) {
            writer.writeParameter(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeProperty(s) {
            writer.writeProperty(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeSpace(s) {
            writer.writeSpace(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeStringLiteral(s) {
            writer.writeStringLiteral(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeSymbol(s, sym) {
            writer.writeSymbol(s, sym);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeLine(force) {
            writer.writeLine(force);
        }
        function increaseIndent() {
            writer.increaseIndent();
        }
        function decreaseIndent() {
            writer.decreaseIndent();
        }
        function getText() {
            return writer.getText();
        }
        function rawWrite(s) {
            writer.rawWrite(s);
            setLastNonTriviaPosition(s, /*force*/ false);
        }
        function writeLiteral(s) {
            writer.writeLiteral(s);
            setLastNonTriviaPosition(s, /*force*/ true);
        }
        function getTextPos() {
            return writer.getTextPos();
        }
        function getLine() {
            return writer.getLine();
        }
        function getColumn() {
            return writer.getColumn();
        }
        function getIndent() {
            return writer.getIndent();
        }
        function isAtStartOfLine() {
            return writer.isAtStartOfLine();
        }
        function clear2() {
            writer.clear();
            lastNonTriviaPosition = 0;
        }
        return {
            onBeforeEmitNode,
            onAfterEmitNode,
            onBeforeEmitNodeArray,
            onAfterEmitNodeArray,
            onBeforeEmitToken,
            onAfterEmitToken,
            write,
            writeComment,
            writeKeyword,
            writeOperator,
            writePunctuation,
            writeTrailingSemicolon,
            writeParameter,
            writeProperty,
            writeSpace,
            writeStringLiteral,
            writeSymbol,
            writeLine,
            increaseIndent,
            decreaseIndent,
            getText,
            rawWrite,
            writeLiteral,
            getTextPos,
            getLine,
            getColumn,
            getIndent,
            isAtStartOfLine,
            hasTrailingComment: ()=>writer.hasTrailingComment(),
            hasTrailingWhitespace: ()=>writer.hasTrailingWhitespace(),
            clear: clear2
        };
    }
    function getInsertionPositionAtSourceFileTop(sourceFile) {
        let lastPrologue;
        for (const node of sourceFile.statements){
            if (isPrologueDirective(node)) lastPrologue = node;
            else break;
        }
        let position = 0;
        const text = sourceFile.text;
        if (lastPrologue) {
            position = lastPrologue.end;
            advancePastLineBreak();
            return position;
        }
        const shebang = getShebang(text);
        if (shebang !== void 0) {
            position = shebang.length;
            advancePastLineBreak();
        }
        const ranges = getLeadingCommentRanges(text, position);
        if (!ranges) return position;
        let lastComment;
        let firstNodeLine;
        for (const range of ranges){
            if (range.kind === 3 /* MultiLineCommentTrivia */ ) {
                if (isPinnedComment(text, range.pos)) {
                    lastComment = {
                        range,
                        pinnedOrTripleSlash: true
                    };
                    continue;
                }
            } else if (isRecognizedTripleSlashComment(text, range.pos, range.end)) {
                lastComment = {
                    range,
                    pinnedOrTripleSlash: true
                };
                continue;
            }
            if (lastComment) {
                if (lastComment.pinnedOrTripleSlash) break;
                const commentLine = sourceFile.getLineAndCharacterOfPosition(range.pos).line;
                const lastCommentEndLine = sourceFile.getLineAndCharacterOfPosition(lastComment.range.end).line;
                if (commentLine >= lastCommentEndLine + 2) break;
            }
            if (sourceFile.statements.length) {
                if (firstNodeLine === void 0) firstNodeLine = sourceFile.getLineAndCharacterOfPosition(sourceFile.statements[0].getStart()).line;
                const commentEndLine = sourceFile.getLineAndCharacterOfPosition(range.end).line;
                if (firstNodeLine < commentEndLine + 2) break;
            }
            lastComment = {
                range,
                pinnedOrTripleSlash: false
            };
        }
        if (lastComment) {
            position = lastComment.range.end;
            advancePastLineBreak();
        }
        return position;
        function advancePastLineBreak() {
            if (position < text.length) {
                const charCode = text.charCodeAt(position);
                if (isLineBreak(charCode)) {
                    position++;
                    if (position < text.length && charCode === 13 /* carriageReturn */  && text.charCodeAt(position) === 10 /* lineFeed */ ) position++;
                }
            }
        }
    }
    function isValidLocationToAddComment(sourceFile, position) {
        return !isInComment(sourceFile, position) && !isInString(sourceFile, position) && !isInTemplateString(sourceFile, position) && !isInJSXText(sourceFile, position);
    }
    function needSemicolonBetween(a, b) {
        return (isPropertySignature(a) || isPropertyDeclaration(a)) && isClassOrTypeElement(b) && b.name.kind === 168 /* ComputedPropertyName */  || isStatementButNotDeclaration(a) && isStatementButNotDeclaration(b);
    }
    var deleteDeclaration;
    ((_deleteDeclaration)=>{
        function deleteDeclaration2(changes, deletedNodesInLists, sourceFile, node) {
            switch(node.kind){
                case 170 /* Parameter */ :
                    {
                        const oldFunction = node.parent;
                        if (isArrowFunction(oldFunction) && oldFunction.parameters.length === 1 && !findChildOfKind(oldFunction, 21 /* OpenParenToken */ , sourceFile)) changes.replaceNodeWithText(sourceFile, node, "()");
                        else deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                        break;
                    }
                case 273 /* ImportDeclaration */ :
                case 272 /* ImportEqualsDeclaration */ :
                    const isFirstImport = sourceFile.imports.length && node === first(sourceFile.imports).parent || node === find(sourceFile.statements, isAnyImportSyntax);
                    deleteNode(changes, sourceFile, node, {
                        leadingTriviaOption: isFirstImport ? 0 /* Exclude */  : hasJSDocNodes(node) ? 2 /* JSDoc */  : 3 /* StartLine */ 
                    });
                    break;
                case 209 /* BindingElement */ :
                    const pattern = node.parent;
                    const preserveComma = pattern.kind === 208 /* ArrayBindingPattern */  && node !== last(pattern.elements);
                    if (preserveComma) deleteNode(changes, sourceFile, node);
                    else deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                    break;
                case 261 /* VariableDeclaration */ :
                    deleteVariableDeclaration(changes, deletedNodesInLists, sourceFile, node);
                    break;
                case 169 /* TypeParameter */ :
                    deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                    break;
                case 277 /* ImportSpecifier */ :
                    const namedImports = node.parent;
                    if (namedImports.elements.length === 1) deleteImportBinding(changes, sourceFile, namedImports);
                    else deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                    break;
                case 275 /* NamespaceImport */ :
                    deleteImportBinding(changes, sourceFile, node);
                    break;
                case 27 /* SemicolonToken */ :
                    deleteNode(changes, sourceFile, node, {
                        trailingTriviaOption: 0 /* Exclude */ 
                    });
                    break;
                case 100 /* FunctionKeyword */ :
                    deleteNode(changes, sourceFile, node, {
                        leadingTriviaOption: 0 /* Exclude */ 
                    });
                    break;
                case 264 /* ClassDeclaration */ :
                case 263 /* FunctionDeclaration */ :
                    deleteNode(changes, sourceFile, node, {
                        leadingTriviaOption: hasJSDocNodes(node) ? 2 /* JSDoc */  : 3 /* StartLine */ 
                    });
                    break;
                default:
                    if (!node.parent) deleteNode(changes, sourceFile, node);
                    else if (isImportClause(node.parent) && node.parent.name === node) deleteDefaultImport(changes, sourceFile, node.parent);
                    else if (isCallExpression(node.parent) && contains(node.parent.arguments, node)) deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                    else deleteNode(changes, sourceFile, node);
            }
        }
        _deleteDeclaration.deleteDeclaration = deleteDeclaration2;
        function deleteDefaultImport(changes, sourceFile, importClause) {
            if (!importClause.namedBindings) deleteNode(changes, sourceFile, importClause.parent);
            else {
                const start = importClause.name.getStart(sourceFile);
                const nextToken = getTokenAtPosition(sourceFile, importClause.name.end);
                if (nextToken && nextToken.kind === 28 /* CommaToken */ ) {
                    const end = skipTrivia(sourceFile.text, nextToken.end, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
                    changes.deleteRange(sourceFile, {
                        pos: start,
                        end
                    });
                } else deleteNode(changes, sourceFile, importClause.name);
            }
        }
        function deleteImportBinding(changes, sourceFile, node) {
            if (node.parent.name) {
                const previousToken = Debug.checkDefined(getTokenAtPosition(sourceFile, node.pos - 1));
                changes.deleteRange(sourceFile, {
                    pos: previousToken.getStart(sourceFile),
                    end: node.end
                });
            } else {
                const importDecl = getAncestor(node, 273 /* ImportDeclaration */ );
                deleteNode(changes, sourceFile, importDecl);
            }
        }
        function deleteVariableDeclaration(changes, deletedNodesInLists, sourceFile, node) {
            const { parent: parent2 } = node;
            if (parent2.kind === 300 /* CatchClause */ ) {
                changes.deleteNodeRange(sourceFile, findChildOfKind(parent2, 21 /* OpenParenToken */ , sourceFile), findChildOfKind(parent2, 22 /* CloseParenToken */ , sourceFile));
                return;
            }
            if (parent2.declarations.length !== 1) {
                deleteNodeInList(changes, deletedNodesInLists, sourceFile, node);
                return;
            }
            const gp = parent2.parent;
            switch(gp.kind){
                case 251 /* ForOfStatement */ :
                case 250 /* ForInStatement */ :
                    changes.replaceNode(sourceFile, node, factory.createObjectLiteralExpression());
                    break;
                case 249 /* ForStatement */ :
                    deleteNode(changes, sourceFile, parent2);
                    break;
                case 244 /* VariableStatement */ :
                    deleteNode(changes, sourceFile, gp, {
                        leadingTriviaOption: hasJSDocNodes(gp) ? 2 /* JSDoc */  : 3 /* StartLine */ 
                    });
                    break;
                default:
                    Debug.assertNever(gp);
            }
        }
    })(deleteDeclaration || (deleteDeclaration = {}));
    function deleteNode(changes, sourceFile, node, options = {
        leadingTriviaOption: 1 /* IncludeAll */ 
    }) {
        const startPosition = getAdjustedStartPosition(sourceFile, node, options);
        const endPosition = getAdjustedEndPosition(sourceFile, node, options);
        changes.deleteRange(sourceFile, {
            pos: startPosition,
            end: endPosition
        });
    }
    function deleteNodeInList(changes, deletedNodesInLists, sourceFile, node) {
        const containingList = Debug.checkDefined(ts_formatting_exports.SmartIndenter.getContainingList(node, sourceFile));
        const index = indexOfNode(containingList, node);
        Debug.assert(index !== -1);
        if (containingList.length === 1) {
            deleteNode(changes, sourceFile, node);
            return;
        }
        Debug.assert(!deletedNodesInLists.has(node), "Deleting a node twice");
        deletedNodesInLists.add(node);
        changes.deleteRange(sourceFile, {
            pos: startPositionToDeleteNodeInList(sourceFile, node),
            end: index === containingList.length - 1 ? getAdjustedEndPosition(sourceFile, node, {}) : endPositionToDeleteNodeInList(sourceFile, node, containingList[index - 1], containingList[index + 1])
        });
    }
    // src/services/_namespaces/ts.formatting.ts
    var ts_formatting_exports = {};
    __export(ts_formatting_exports, {
        FormattingContext: ()=>FormattingContext,
        FormattingRequestKind: ()=>FormattingRequestKind,
        RuleAction: ()=>RuleAction,
        RuleFlags: ()=>RuleFlags,
        SmartIndenter: ()=>SmartIndenter,
        anyContext: ()=>anyContext,
        createTextRangeWithKind: ()=>createTextRangeWithKind,
        formatDocument: ()=>formatDocument,
        formatNodeGivenIndentation: ()=>formatNodeGivenIndentation,
        formatOnClosingCurly: ()=>formatOnClosingCurly,
        formatOnEnter: ()=>formatOnEnter,
        formatOnOpeningCurly: ()=>formatOnOpeningCurly,
        formatOnSemicolon: ()=>formatOnSemicolon,
        formatSelection: ()=>formatSelection,
        getAllRules: ()=>getAllRules,
        getFormatContext: ()=>getFormatContext,
        getFormattingScanner: ()=>getFormattingScanner,
        getIndentationString: ()=>getIndentationString,
        getRangeOfEnclosingComment: ()=>getRangeOfEnclosingComment
    });
    // src/services/formatting/formattingContext.ts
    var FormattingRequestKind = /* @__PURE__ */ ((FormattingRequestKind2)=>{
        FormattingRequestKind2[FormattingRequestKind2["FormatDocument"] = 0] = "FormatDocument";
        FormattingRequestKind2[FormattingRequestKind2["FormatSelection"] = 1] = "FormatSelection";
        FormattingRequestKind2[FormattingRequestKind2["FormatOnEnter"] = 2] = "FormatOnEnter";
        FormattingRequestKind2[FormattingRequestKind2["FormatOnSemicolon"] = 3] = "FormatOnSemicolon";
        FormattingRequestKind2[FormattingRequestKind2["FormatOnOpeningCurlyBrace"] = 4] = "FormatOnOpeningCurlyBrace";
        FormattingRequestKind2[FormattingRequestKind2["FormatOnClosingCurlyBrace"] = 5] = "FormatOnClosingCurlyBrace";
        return FormattingRequestKind2;
    })(FormattingRequestKind || {});
    var FormattingContext = class {
        updateContext(currentRange, currentTokenParent, nextRange, nextTokenParent, commonParent) {
            this.currentTokenSpan = Debug.checkDefined(currentRange);
            this.currentTokenParent = Debug.checkDefined(currentTokenParent);
            this.nextTokenSpan = Debug.checkDefined(nextRange);
            this.nextTokenParent = Debug.checkDefined(nextTokenParent);
            this.contextNode = Debug.checkDefined(commonParent);
            this.contextNodeAllOnSameLine = void 0;
            this.nextNodeAllOnSameLine = void 0;
            this.tokensAreOnSameLine = void 0;
            this.contextNodeBlockIsOnOneLine = void 0;
            this.nextNodeBlockIsOnOneLine = void 0;
        }
        ContextNodeAllOnSameLine() {
            if (this.contextNodeAllOnSameLine === void 0) this.contextNodeAllOnSameLine = this.NodeIsOnOneLine(this.contextNode);
            return this.contextNodeAllOnSameLine;
        }
        NextNodeAllOnSameLine() {
            if (this.nextNodeAllOnSameLine === void 0) this.nextNodeAllOnSameLine = this.NodeIsOnOneLine(this.nextTokenParent);
            return this.nextNodeAllOnSameLine;
        }
        TokensAreOnSameLine() {
            if (this.tokensAreOnSameLine === void 0) {
                const startLine = this.sourceFile.getLineAndCharacterOfPosition(this.currentTokenSpan.pos).line;
                const endLine = this.sourceFile.getLineAndCharacterOfPosition(this.nextTokenSpan.pos).line;
                this.tokensAreOnSameLine = startLine === endLine;
            }
            return this.tokensAreOnSameLine;
        }
        ContextNodeBlockIsOnOneLine() {
            if (this.contextNodeBlockIsOnOneLine === void 0) this.contextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.contextNode);
            return this.contextNodeBlockIsOnOneLine;
        }
        NextNodeBlockIsOnOneLine() {
            if (this.nextNodeBlockIsOnOneLine === void 0) this.nextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.nextTokenParent);
            return this.nextNodeBlockIsOnOneLine;
        }
        NodeIsOnOneLine(node) {
            const startLine = this.sourceFile.getLineAndCharacterOfPosition(node.getStart(this.sourceFile)).line;
            const endLine = this.sourceFile.getLineAndCharacterOfPosition(node.getEnd()).line;
            return startLine === endLine;
        }
        BlockIsOnOneLine(node) {
            const openBrace = findChildOfKind(node, 19 /* OpenBraceToken */ , this.sourceFile);
            const closeBrace = findChildOfKind(node, 20 /* CloseBraceToken */ , this.sourceFile);
            if (openBrace && closeBrace) {
                const startLine = this.sourceFile.getLineAndCharacterOfPosition(openBrace.getEnd()).line;
                const endLine = this.sourceFile.getLineAndCharacterOfPosition(closeBrace.getStart(this.sourceFile)).line;
                return startLine === endLine;
            }
            return false;
        }
        constructor(sourceFile, formattingRequestKind, options){
            this.sourceFile = sourceFile;
            this.formattingRequestKind = formattingRequestKind;
            this.options = options;
        }
    };
    // src/services/formatting/formattingScanner.ts
    var standardScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, 0 /* Standard */ );
    var jsxScanner = createScanner(99 /* Latest */ , /*skipTrivia*/ false, 1 /* JSX */ );
    function getFormattingScanner(text, languageVariant, startPos, endPos, cb) {
        const scanner2 = languageVariant === 1 /* JSX */  ? jsxScanner : standardScanner;
        scanner2.setText(text);
        scanner2.resetTokenState(startPos);
        let wasNewLine = true;
        let leadingTrivia;
        let trailingTrivia;
        let savedPos;
        let lastScanAction;
        let lastTokenInfo;
        const res = cb({
            advance,
            readTokenInfo,
            readEOFTokenRange,
            isOnToken,
            isOnEOF,
            getCurrentLeadingTrivia: ()=>leadingTrivia,
            lastTrailingTriviaWasNewLine: ()=>wasNewLine,
            skipToEndOf,
            skipToStartOf,
            getTokenFullStart: ()=>{
                var _ref;
                return (_ref = lastTokenInfo == null ? void 0 : lastTokenInfo.token.pos) !== null && _ref !== void 0 ? _ref : scanner2.getTokenStart();
            },
            getStartPos: ()=>{
                var _ref;
                return (_ref = lastTokenInfo == null ? void 0 : lastTokenInfo.token.pos) !== null && _ref !== void 0 ? _ref : scanner2.getTokenStart();
            }
        });
        lastTokenInfo = void 0;
        scanner2.setText(void 0);
        return res;
        function advance() {
            lastTokenInfo = void 0;
            const isStarted = scanner2.getTokenFullStart() !== startPos;
            if (isStarted) wasNewLine = !!trailingTrivia && last(trailingTrivia).kind === 4 /* NewLineTrivia */ ;
            else scanner2.scan();
            leadingTrivia = void 0;
            trailingTrivia = void 0;
            let pos = scanner2.getTokenFullStart();
            while(pos < endPos){
                const t = scanner2.getToken();
                if (!isTrivia(t)) break;
                scanner2.scan();
                const item = {
                    pos,
                    end: scanner2.getTokenFullStart(),
                    kind: t
                };
                pos = scanner2.getTokenFullStart();
                leadingTrivia = append(leadingTrivia, item);
            }
            savedPos = scanner2.getTokenFullStart();
        }
        function shouldRescanGreaterThanToken(node) {
            switch(node.kind){
                case 34 /* GreaterThanEqualsToken */ :
                case 72 /* GreaterThanGreaterThanEqualsToken */ :
                case 73 /* GreaterThanGreaterThanGreaterThanEqualsToken */ :
                case 50 /* GreaterThanGreaterThanGreaterThanToken */ :
                case 49 /* GreaterThanGreaterThanToken */ :
                    return true;
            }
            return false;
        }
        function shouldRescanJsxIdentifier(node) {
            if (node.parent) switch(node.parent.kind){
                case 292 /* JsxAttribute */ :
                case 287 /* JsxOpeningElement */ :
                case 288 /* JsxClosingElement */ :
                case 286 /* JsxSelfClosingElement */ :
                    return isKeyword(node.kind) || node.kind === 80 /* Identifier */ ;
            }
            return false;
        }
        function shouldRescanJsxText(node) {
            return isJsxText(node) || isJsxElement(node) && (lastTokenInfo == null ? void 0 : lastTokenInfo.token.kind) === 12 /* JsxText */ ;
        }
        function shouldRescanSlashToken(container) {
            return container.kind === 14 /* RegularExpressionLiteral */ ;
        }
        function shouldRescanTemplateToken(container) {
            return container.kind === 17 /* TemplateMiddle */  || container.kind === 18 /* TemplateTail */ ;
        }
        function shouldRescanJsxAttributeValue(node) {
            return node.parent && isJsxAttribute(node.parent) && node.parent.initializer === node;
        }
        function startsWithSlashToken(t) {
            return t === 44 /* SlashToken */  || t === 69 /* SlashEqualsToken */ ;
        }
        function readTokenInfo(n) {
            Debug.assert(isOnToken());
            const expectedScanAction = shouldRescanGreaterThanToken(n) ? 1 /* RescanGreaterThanToken */  : shouldRescanSlashToken(n) ? 2 /* RescanSlashToken */  : shouldRescanTemplateToken(n) ? 3 /* RescanTemplateToken */  : shouldRescanJsxIdentifier(n) ? 4 /* RescanJsxIdentifier */  : shouldRescanJsxText(n) ? 5 /* RescanJsxText */  : shouldRescanJsxAttributeValue(n) ? 6 /* RescanJsxAttributeValue */  : 0 /* Scan */ ;
            if (lastTokenInfo && expectedScanAction === lastScanAction) return fixTokenKind(lastTokenInfo, n);
            if (scanner2.getTokenFullStart() !== savedPos) {
                Debug.assert(lastTokenInfo !== void 0);
                scanner2.resetTokenState(savedPos);
                scanner2.scan();
            }
            let currentToken = getNextToken(n, expectedScanAction);
            const token = createTextRangeWithKind(scanner2.getTokenFullStart(), scanner2.getTokenEnd(), currentToken);
            if (trailingTrivia) trailingTrivia = void 0;
            while(scanner2.getTokenFullStart() < endPos){
                currentToken = scanner2.scan();
                if (!isTrivia(currentToken)) break;
                const trivia = createTextRangeWithKind(scanner2.getTokenFullStart(), scanner2.getTokenEnd(), currentToken);
                if (!trailingTrivia) trailingTrivia = [];
                trailingTrivia.push(trivia);
                if (currentToken === 4 /* NewLineTrivia */ ) {
                    scanner2.scan();
                    break;
                }
            }
            lastTokenInfo = {
                leadingTrivia,
                trailingTrivia,
                token
            };
            return fixTokenKind(lastTokenInfo, n);
        }
        function getNextToken(n, expectedScanAction) {
            const token = scanner2.getToken();
            lastScanAction = 0 /* Scan */ ;
            switch(expectedScanAction){
                case 1 /* RescanGreaterThanToken */ :
                    if (token === 32 /* GreaterThanToken */ ) {
                        lastScanAction = 1 /* RescanGreaterThanToken */ ;
                        const newToken = scanner2.reScanGreaterToken();
                        Debug.assert(n.kind === newToken);
                        return newToken;
                    }
                    break;
                case 2 /* RescanSlashToken */ :
                    if (startsWithSlashToken(token)) {
                        lastScanAction = 2 /* RescanSlashToken */ ;
                        const newToken = scanner2.reScanSlashToken();
                        Debug.assert(n.kind === newToken);
                        return newToken;
                    }
                    break;
                case 3 /* RescanTemplateToken */ :
                    if (token === 20 /* CloseBraceToken */ ) {
                        lastScanAction = 3 /* RescanTemplateToken */ ;
                        return scanner2.reScanTemplateToken(/*isTaggedTemplate*/ false);
                    }
                    break;
                case 4 /* RescanJsxIdentifier */ :
                    lastScanAction = 4 /* RescanJsxIdentifier */ ;
                    return scanner2.scanJsxIdentifier();
                case 5 /* RescanJsxText */ :
                    lastScanAction = 5 /* RescanJsxText */ ;
                    return scanner2.reScanJsxToken(/*allowMultilineJsxText*/ false);
                case 6 /* RescanJsxAttributeValue */ :
                    lastScanAction = 6 /* RescanJsxAttributeValue */ ;
                    return scanner2.reScanJsxAttributeValue();
                case 0 /* Scan */ :
                    break;
                default:
                    Debug.assertNever(expectedScanAction);
            }
            return token;
        }
        function readEOFTokenRange() {
            Debug.assert(isOnEOF());
            return createTextRangeWithKind(scanner2.getTokenFullStart(), scanner2.getTokenEnd(), 1 /* EndOfFileToken */ );
        }
        function isOnToken() {
            const current = lastTokenInfo ? lastTokenInfo.token.kind : scanner2.getToken();
            return current !== 1 /* EndOfFileToken */  && !isTrivia(current);
        }
        function isOnEOF() {
            const current = lastTokenInfo ? lastTokenInfo.token.kind : scanner2.getToken();
            return current === 1 /* EndOfFileToken */ ;
        }
        function fixTokenKind(tokenInfo, container) {
            if (isToken(container) && tokenInfo.token.kind !== container.kind) tokenInfo.token.kind = container.kind;
            return tokenInfo;
        }
        function skipToEndOf(node) {
            scanner2.resetTokenState(node.end);
            savedPos = scanner2.getTokenFullStart();
            lastScanAction = void 0;
            lastTokenInfo = void 0;
            wasNewLine = false;
            leadingTrivia = void 0;
            trailingTrivia = void 0;
        }
        function skipToStartOf(node) {
            scanner2.resetTokenState(node.pos);
            savedPos = scanner2.getTokenFullStart();
            lastScanAction = void 0;
            lastTokenInfo = void 0;
            wasNewLine = false;
            leadingTrivia = void 0;
            trailingTrivia = void 0;
        }
    }
    // src/services/formatting/rule.ts
    var anyContext = emptyArray;
    var RuleAction = /* @__PURE__ */ ((RuleAction2)=>{
        RuleAction2[RuleAction2["None"] = 0] = "None";
        RuleAction2[RuleAction2["StopProcessingSpaceActions"] = 1] = "StopProcessingSpaceActions";
        RuleAction2[RuleAction2["StopProcessingTokenActions"] = 2] = "StopProcessingTokenActions";
        RuleAction2[RuleAction2["InsertSpace"] = 4] = "InsertSpace";
        RuleAction2[RuleAction2["InsertNewLine"] = 8] = "InsertNewLine";
        RuleAction2[RuleAction2["DeleteSpace"] = 16] = "DeleteSpace";
        RuleAction2[RuleAction2["DeleteToken"] = 32] = "DeleteToken";
        RuleAction2[RuleAction2["InsertTrailingSemicolon"] = 64] = "InsertTrailingSemicolon";
        RuleAction2[RuleAction2["StopAction"] = 3] = "StopAction";
        RuleAction2[RuleAction2["ModifySpaceAction"] = 28] = "ModifySpaceAction";
        RuleAction2[RuleAction2["ModifyTokenAction"] = 96] = "ModifyTokenAction";
        return RuleAction2;
    })(RuleAction || {});
    var RuleFlags = /* @__PURE__ */ ((RuleFlags2)=>{
        RuleFlags2[RuleFlags2["None"] = 0] = "None";
        RuleFlags2[RuleFlags2["CanDeleteNewLines"] = 1] = "CanDeleteNewLines";
        return RuleFlags2;
    })(RuleFlags || {});
    // src/services/formatting/rules.ts
    function getAllRules() {
        const allTokens = [];
        for(let token = 0 /* FirstToken */ ; token <= 166 /* LastToken */ ; token++)if (token !== 1 /* EndOfFileToken */ ) allTokens.push(token);
        function anyTokenExcept(...tokens) {
            return {
                tokens: allTokens.filter((t)=>!tokens.some((t2)=>t2 === t)),
                isSpecific: false
            };
        }
        const anyToken = {
            tokens: allTokens,
            isSpecific: false
        };
        const anyTokenIncludingMultilineComments = tokenRangeFrom([
            ...allTokens,
            3 /* MultiLineCommentTrivia */ 
        ]);
        const anyTokenIncludingEOF = tokenRangeFrom([
            ...allTokens,
            1 /* EndOfFileToken */ 
        ]);
        const keywords = tokenRangeFromRange(83 /* FirstKeyword */ , 166 /* LastKeyword */ );
        const binaryOperators = tokenRangeFromRange(30 /* FirstBinaryOperator */ , 79 /* LastBinaryOperator */ );
        const binaryKeywordOperators = [
            103 /* InKeyword */ ,
            104 /* InstanceOfKeyword */ ,
            165 /* OfKeyword */ ,
            130 /* AsKeyword */ ,
            142 /* IsKeyword */ ,
            152 /* SatisfiesKeyword */ 
        ];
        const unaryPrefixOperators = [
            46 /* PlusPlusToken */ ,
            47 /* MinusMinusToken */ ,
            55 /* TildeToken */ ,
            54 /* ExclamationToken */ 
        ];
        const unaryPrefixExpressions = [
            9 /* NumericLiteral */ ,
            10 /* BigIntLiteral */ ,
            80 /* Identifier */ ,
            21 /* OpenParenToken */ ,
            23 /* OpenBracketToken */ ,
            19 /* OpenBraceToken */ ,
            110 /* ThisKeyword */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPreincrementExpressions = [
            80 /* Identifier */ ,
            21 /* OpenParenToken */ ,
            110 /* ThisKeyword */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPostincrementExpressions = [
            80 /* Identifier */ ,
            22 /* CloseParenToken */ ,
            24 /* CloseBracketToken */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPredecrementExpressions = [
            80 /* Identifier */ ,
            21 /* OpenParenToken */ ,
            110 /* ThisKeyword */ ,
            105 /* NewKeyword */ 
        ];
        const unaryPostdecrementExpressions = [
            80 /* Identifier */ ,
            22 /* CloseParenToken */ ,
            24 /* CloseBracketToken */ ,
            105 /* NewKeyword */ 
        ];
        const comments = [
            2 /* SingleLineCommentTrivia */ ,
            3 /* MultiLineCommentTrivia */ 
        ];
        const typeNames = [
            80 /* Identifier */ ,
            ...typeKeywords
        ];
        const functionOpenBraceLeftTokenRange = anyTokenIncludingMultilineComments;
        const typeScriptOpenBraceLeftTokenRange = tokenRangeFrom([
            80 /* Identifier */ ,
            32 /* GreaterThanToken */ ,
            3 /* MultiLineCommentTrivia */ ,
            86 /* ClassKeyword */ ,
            95 /* ExportKeyword */ ,
            102 /* ImportKeyword */ 
        ]);
        const controlOpenBraceLeftTokenRange = tokenRangeFrom([
            22 /* CloseParenToken */ ,
            3 /* MultiLineCommentTrivia */ ,
            92 /* DoKeyword */ ,
            113 /* TryKeyword */ ,
            98 /* FinallyKeyword */ ,
            93 /* ElseKeyword */ ,
            85 /* CatchKeyword */ 
        ]);
        const highPriorityCommonRules = [
            // Leave comments alone
            rule("IgnoreBeforeComment", anyToken, comments, anyContext, 1 /* StopProcessingSpaceActions */ ),
            rule("IgnoreAfterLineComment", 2 /* SingleLineCommentTrivia */ , anyToken, anyContext, 1 /* StopProcessingSpaceActions */ ),
            rule("NotSpaceBeforeColon", anyToken, 59 /* ColonToken */ , [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext,
                isNotTypeAnnotationContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterColon", 59 /* ColonToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext,
                isNextTokenParentNotJsxNamespacedName
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeQuestionMark", anyToken, 58 /* QuestionToken */ , [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext,
                isNotTypeAnnotationContext
            ], 16 /* DeleteSpace */ ),
            // insert space after '?' only when it is used in conditional operator
            rule("SpaceAfterQuestionMarkInConditionalOperator", 58 /* QuestionToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isConditionalOperatorContext
            ], 4 /* InsertSpace */ ),
            // in other cases there should be no space between '?' and next token
            rule("NoSpaceAfterQuestionMark", 58 /* QuestionToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isNonOptionalPropertyContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeDot", anyToken, [
                25 /* DotToken */ ,
                29 /* QuestionDotToken */ 
            ], [
                isNonJsxSameLineTokenContext,
                isNotPropertyAccessOnIntegerLiteral
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterDot", [
                25 /* DotToken */ ,
                29 /* QuestionDotToken */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBetweenImportParenInImportType", 102 /* ImportKeyword */ , 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext,
                isImportTypeContext
            ], 16 /* DeleteSpace */ ),
            // Special handling of unary operators.
            // Prefix operators generally shouldn't have a space between
            // them and their target unary expression.
            rule("NoSpaceAfterUnaryPrefixOperator", unaryPrefixOperators, unaryPrefixExpressions, [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterUnaryPreincrementOperator", 46 /* PlusPlusToken */ , unaryPreincrementExpressions, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterUnaryPredecrementOperator", 47 /* MinusMinusToken */ , unaryPredecrementExpressions, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeUnaryPostincrementOperator", unaryPostincrementExpressions, 46 /* PlusPlusToken */ , [
                isNonJsxSameLineTokenContext,
                isNotStatementConditionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeUnaryPostdecrementOperator", unaryPostdecrementExpressions, 47 /* MinusMinusToken */ , [
                isNonJsxSameLineTokenContext,
                isNotStatementConditionContext
            ], 16 /* DeleteSpace */ ),
            // More unary operator special-casing.
            // DevDiv 181814: Be careful when removing leading whitespace
            // around unary operators.  Examples:
            //      1 - -2  --X--> 1--2
            //      a + ++b --X--> a+++b
            rule("SpaceAfterPostincrementWhenFollowedByAdd", 46 /* PlusPlusToken */ , 40 /* PlusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterAddWhenFollowedByUnaryPlus", 40 /* PlusToken */ , 40 /* PlusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterAddWhenFollowedByPreincrement", 40 /* PlusToken */ , 46 /* PlusPlusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterPostdecrementWhenFollowedBySubtract", 47 /* MinusMinusToken */ , 41 /* MinusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterSubtractWhenFollowedByUnaryMinus", 41 /* MinusToken */ , 41 /* MinusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterSubtractWhenFollowedByPredecrement", 41 /* MinusToken */ , 47 /* MinusMinusToken */ , [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterCloseBrace", 20 /* CloseBraceToken */ , [
                28 /* CommaToken */ ,
                27 /* SemicolonToken */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // For functions and control block place } on a new line [multi-line rule]
            rule("NewLineBeforeCloseBraceInBlockContext", anyTokenIncludingMultilineComments, 20 /* CloseBraceToken */ , [
                isMultilineBlockContext
            ], 8 /* InsertNewLine */ ),
            // Space/new line after }.
            rule("SpaceAfterCloseBrace", 20 /* CloseBraceToken */ , anyTokenExcept(22 /* CloseParenToken */ ), [
                isNonJsxSameLineTokenContext,
                isAfterCodeBlockContext
            ], 4 /* InsertSpace */ ),
            // Special case for (}, else) and (}, while) since else & while tokens are not part of the tree which makes SpaceAfterCloseBrace rule not applied
            // Also should not apply to })
            rule("SpaceBetweenCloseBraceAndElse", 20 /* CloseBraceToken */ , 93 /* ElseKeyword */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBetweenCloseBraceAndWhile", 20 /* CloseBraceToken */ , 117 /* WhileKeyword */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isNonJsxSameLineTokenContext,
                isObjectContext
            ], 16 /* DeleteSpace */ ),
            // Add a space after control dec context if the next character is an open bracket ex: 'if (false)[a, b] = [1, 2];' -> 'if (false) [a, b] = [1, 2];'
            rule("SpaceAfterConditionalClosingParen", 22 /* CloseParenToken */ , 23 /* OpenBracketToken */ , [
                isControlDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenFunctionKeywordAndStar", 100 /* FunctionKeyword */ , 42 /* AsteriskToken */ , [
                isFunctionDeclarationOrFunctionExpressionContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterStarInGeneratorDeclaration", 42 /* AsteriskToken */ , 80 /* Identifier */ , [
                isFunctionDeclarationOrFunctionExpressionContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterFunctionInFuncDecl", 100 /* FunctionKeyword */ , anyToken, [
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            // Insert new line after { and before } in multi-line contexts.
            rule("NewLineAfterOpenBraceInBlockContext", 19 /* OpenBraceToken */ , anyToken, [
                isMultilineBlockContext
            ], 8 /* InsertNewLine */ ),
            // For get/set members, we check for (identifier,identifier) since get/set don't have tokens and they are represented as just an identifier token.
            // Though, we do extra check on the context to make sure we are dealing with get/set node. Example:
            //      get x() {}
            //      set x(val) {}
            rule("SpaceAfterGetSetInMember", [
                139 /* GetKeyword */ ,
                153 /* SetKeyword */ 
            ], 80 /* Identifier */ , [
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenYieldKeywordAndStar", 127 /* YieldKeyword */ , 42 /* AsteriskToken */ , [
                isNonJsxSameLineTokenContext,
                isYieldOrYieldStarWithOperand
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBetweenYieldOrYieldStarAndOperand", [
                127 /* YieldKeyword */ ,
                42 /* AsteriskToken */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext,
                isYieldOrYieldStarWithOperand
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenReturnAndSemicolon", 107 /* ReturnKeyword */ , 27 /* SemicolonToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterCertainKeywords", [
                115 /* VarKeyword */ ,
                111 /* ThrowKeyword */ ,
                105 /* NewKeyword */ ,
                91 /* DeleteKeyword */ ,
                107 /* ReturnKeyword */ ,
                114 /* TypeOfKeyword */ ,
                135 /* AwaitKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterLetConstInVariableDeclaration", [
                121 /* LetKeyword */ ,
                87 /* ConstKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext,
                isStartOfVariableDeclarationList
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeOpenParenInFuncCall", anyToken, 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext,
                isFunctionCallOrNewContext,
                isPreviousTokenNotComma
            ], 16 /* DeleteSpace */ ),
            // Special case for binary operators (that are keywords). For these we have to add a space and shouldn't follow any user options.
            rule("SpaceBeforeBinaryKeywordOperator", anyToken, binaryKeywordOperators, [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterBinaryKeywordOperator", binaryKeywordOperators, anyToken, [
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterVoidOperator", 116 /* VoidKeyword */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isVoidOpContext
            ], 4 /* InsertSpace */ ),
            // Async-await
            rule("SpaceBetweenAsyncAndOpenParen", 134 /* AsyncKeyword */ , 21 /* OpenParenToken */ , [
                isArrowFunctionContext,
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBetweenAsyncAndFunctionKeyword", 134 /* AsyncKeyword */ , [
                100 /* FunctionKeyword */ ,
                80 /* Identifier */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Template string
            rule("NoSpaceBetweenTagAndTemplateString", [
                80 /* Identifier */ ,
                22 /* CloseParenToken */ 
            ], [
                15 /* NoSubstitutionTemplateLiteral */ ,
                16 /* TemplateHead */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // JSX opening elements
            rule("SpaceBeforeJsxAttribute", anyToken, 80 /* Identifier */ , [
                isNextTokenParentJsxAttribute,
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeSlashInJsxOpeningElement", anyToken, 44 /* SlashToken */ , [
                isJsxSelfClosingElementContext,
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeGreaterThanTokenInJsxOpeningElement", 44 /* SlashToken */ , 32 /* GreaterThanToken */ , [
                isJsxSelfClosingElementContext,
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeEqualInJsxAttribute", anyToken, 64 /* EqualsToken */ , [
                isJsxAttributeContext,
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterEqualInJsxAttribute", 64 /* EqualsToken */ , anyToken, [
                isJsxAttributeContext,
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeJsxNamespaceColon", 80 /* Identifier */ , 59 /* ColonToken */ , [
                isNextTokenParentJsxNamespacedName
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterJsxNamespaceColon", 59 /* ColonToken */ , 80 /* Identifier */ , [
                isNextTokenParentJsxNamespacedName
            ], 16 /* DeleteSpace */ ),
            // TypeScript-specific rules
            // Use of module as a function call. e.g.: import m2 = module("m2");
            rule("NoSpaceAfterModuleImport", [
                144 /* ModuleKeyword */ ,
                149 /* RequireKeyword */ 
            ], 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Add a space around certain TypeScript keywords
            rule("SpaceAfterCertainTypeScriptKeywords", [
                128 /* AbstractKeyword */ ,
                129 /* AccessorKeyword */ ,
                86 /* ClassKeyword */ ,
                138 /* DeclareKeyword */ ,
                90 /* DefaultKeyword */ ,
                94 /* EnumKeyword */ ,
                95 /* ExportKeyword */ ,
                96 /* ExtendsKeyword */ ,
                139 /* GetKeyword */ ,
                119 /* ImplementsKeyword */ ,
                102 /* ImportKeyword */ ,
                120 /* InterfaceKeyword */ ,
                144 /* ModuleKeyword */ ,
                145 /* NamespaceKeyword */ ,
                123 /* PrivateKeyword */ ,
                125 /* PublicKeyword */ ,
                124 /* ProtectedKeyword */ ,
                148 /* ReadonlyKeyword */ ,
                153 /* SetKeyword */ ,
                126 /* StaticKeyword */ ,
                156 /* TypeKeyword */ ,
                161 /* FromKeyword */ ,
                143 /* KeyOfKeyword */ ,
                140 /* InferKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCertainTypeScriptKeywords", anyToken, [
                96 /* ExtendsKeyword */ ,
                119 /* ImplementsKeyword */ ,
                161 /* FromKeyword */ 
            ], [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Treat string literals in module names as identifiers, and add a space between the literal and the opening Brace braces, e.g.: module "m2" {
            rule("SpaceAfterModuleName", 11 /* StringLiteral */ , 19 /* OpenBraceToken */ , [
                isModuleDeclContext
            ], 4 /* InsertSpace */ ),
            // Lambda expressions
            rule("SpaceBeforeArrow", anyToken, 39 /* EqualsGreaterThanToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterArrow", 39 /* EqualsGreaterThanToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Optional parameters and let args
            rule("NoSpaceAfterEllipsis", 26 /* DotDotDotToken */ , 80 /* Identifier */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOptionalParameters", 58 /* QuestionToken */ , [
                22 /* CloseParenToken */ ,
                28 /* CommaToken */ 
            ], [
                isNonJsxSameLineTokenContext,
                isNotBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            // Remove spaces in empty interface literals. e.g.: x: {}
            rule("NoSpaceBetweenEmptyInterfaceBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isNonJsxSameLineTokenContext,
                isObjectTypeContext
            ], 16 /* DeleteSpace */ ),
            // generics and type assertions
            rule("NoSpaceBeforeOpenAngularBracket", typeNames, 30 /* LessThanToken */ , [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBetweenCloseParenAndAngularBracket", 22 /* CloseParenToken */ , 30 /* LessThanToken */ , [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenAngularBracket", 30 /* LessThanToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseAngularBracket", anyToken, 32 /* GreaterThanToken */ , [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterCloseAngularBracket", 32 /* GreaterThanToken */ , [
                21 /* OpenParenToken */ ,
                23 /* OpenBracketToken */ ,
                32 /* GreaterThanToken */ ,
                28 /* CommaToken */ 
            ], [
                isNonJsxSameLineTokenContext,
                isTypeArgumentOrParameterOrAssertionContext,
                isNotFunctionDeclContext,
                /*To prevent an interference with the SpaceBeforeOpenParenInFuncDecl rule*/ isNonTypeAssertionContext
            ], 16 /* DeleteSpace */ ),
            // decorators
            rule("SpaceBeforeAt", [
                22 /* CloseParenToken */ ,
                80 /* Identifier */ 
            ], 60 /* AtToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterAt", 60 /* AtToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after @ in decorator
            rule("SpaceAfterDecorator", anyToken, [
                128 /* AbstractKeyword */ ,
                80 /* Identifier */ ,
                95 /* ExportKeyword */ ,
                90 /* DefaultKeyword */ ,
                86 /* ClassKeyword */ ,
                126 /* StaticKeyword */ ,
                125 /* PublicKeyword */ ,
                123 /* PrivateKeyword */ ,
                124 /* ProtectedKeyword */ ,
                139 /* GetKeyword */ ,
                153 /* SetKeyword */ ,
                23 /* OpenBracketToken */ ,
                42 /* AsteriskToken */ 
            ], [
                isEndOfDecoratorContextOnSameLine
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeNonNullAssertionOperator", anyToken, 54 /* ExclamationToken */ , [
                isNonJsxSameLineTokenContext,
                isNonNullAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterNewKeywordOnConstructorSignature", 105 /* NewKeyword */ , 21 /* OpenParenToken */ , [
                isNonJsxSameLineTokenContext,
                isConstructorSignatureContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceLessThanAndNonJSXTypeAnnotation", 30 /* LessThanToken */ , 30 /* LessThanToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ )
        ];
        const userConfigurableRules = [
            // Treat constructor as an identifier in a function declaration, and remove spaces between constructor and following left parentheses
            rule("SpaceAfterConstructor", 137 /* ConstructorKeyword */ , 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterConstructor"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterConstructor", 137 /* ConstructorKeyword */ , 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterConstructor"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterComma", 28 /* CommaToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterCommaDelimiter"),
                isNonJsxSameLineTokenContext,
                isNonJsxElementOrFragmentContext,
                isNextTokenNotCloseBracket,
                isNextTokenNotCloseParen
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterComma", 28 /* CommaToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterCommaDelimiter"),
                isNonJsxSameLineTokenContext,
                isNonJsxElementOrFragmentContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after function keyword for anonymous functions
            rule("SpaceAfterAnonymousFunctionKeyword", [
                100 /* FunctionKeyword */ ,
                42 /* AsteriskToken */ 
            ], 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterFunctionKeywordForAnonymousFunctions"),
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterAnonymousFunctionKeyword", [
                100 /* FunctionKeyword */ ,
                42 /* AsteriskToken */ 
            ], 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterFunctionKeywordForAnonymousFunctions"),
                isFunctionDeclContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after keywords in control flow statements
            rule("SpaceAfterKeywordInControl", keywords, 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterKeywordsInControlFlowStatements"),
                isControlDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterKeywordInControl", keywords, 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterKeywordsInControlFlowStatements"),
                isControlDeclContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after opening and before closing nonempty parenthesis
            rule("SpaceAfterOpenParen", 21 /* OpenParenToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseParen", anyToken, 22 /* CloseParenToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBetweenOpenParens", 21 /* OpenParenToken */ , 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenParens", 21 /* OpenParenToken */ , 22 /* CloseParenToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenParen", 21 /* OpenParenToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseParen", anyToken, 22 /* CloseParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after opening and before closing nonempty brackets
            rule("SpaceAfterOpenBracket", 23 /* OpenBracketToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseBracket", anyToken, 24 /* CloseBracketToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenBrackets", 23 /* OpenBracketToken */ , 24 /* CloseBracketToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenBracket", 23 /* OpenBracketToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseBracket", anyToken, 24 /* CloseBracketToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert a space after { and before } in single-line contexts, but remove space from empty object literals {}.
            rule("SpaceAfterOpenBrace", 19 /* OpenBraceToken */ , anyToken, [
                isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isBraceWrappedContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseBrace", anyToken, 20 /* CloseBraceToken */ , [
                isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isBraceWrappedContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isNonJsxSameLineTokenContext,
                isObjectContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterOpenBrace", 19 /* OpenBraceToken */ , anyToken, [
                isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseBrace", anyToken, 20 /* CloseBraceToken */ , [
                isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert a space after opening and before closing empty brace brackets
            rule("SpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingEmptyBraces")
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBetweenEmptyBraceBrackets", 19 /* OpenBraceToken */ , 20 /* CloseBraceToken */ , [
                isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingEmptyBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after opening and before closing template string braces
            rule("SpaceAfterTemplateHeadAndMiddle", [
                16 /* TemplateHead */ ,
                17 /* TemplateMiddle */ 
            ], anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxTextContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceBeforeTemplateMiddleAndTail", anyToken, [
                17 /* TemplateMiddle */ ,
                18 /* TemplateTail */ 
            ], [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterTemplateHeadAndMiddle", [
                16 /* TemplateHead */ ,
                17 /* TemplateMiddle */ 
            ], anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxTextContext
            ], 16 /* DeleteSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("NoSpaceBeforeTemplateMiddleAndTail", anyToken, [
                17 /* TemplateMiddle */ ,
                18 /* TemplateTail */ 
            ], [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"),
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // No space after { and before } in JSX expression
            rule("SpaceAfterOpenBraceInJsxExpression", 19 /* OpenBraceToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceBeforeCloseBraceInJsxExpression", anyToken, 20 /* CloseBraceToken */ , [
                isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterOpenBraceInJsxExpression", 19 /* OpenBraceToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceBeforeCloseBraceInJsxExpression", anyToken, 20 /* CloseBraceToken */ , [
                isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"),
                isNonJsxSameLineTokenContext,
                isJsxExpressionContext
            ], 16 /* DeleteSpace */ ),
            // Insert space after semicolon in for statement
            rule("SpaceAfterSemicolonInFor", 27 /* SemicolonToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterSemicolonInForStatements"),
                isNonJsxSameLineTokenContext,
                isForContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterSemicolonInFor", 27 /* SemicolonToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterSemicolonInForStatements"),
                isNonJsxSameLineTokenContext,
                isForContext
            ], 16 /* DeleteSpace */ ),
            // Insert space before and after binary operators
            rule("SpaceBeforeBinaryOperator", anyToken, binaryOperators, [
                isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("SpaceAfterBinaryOperator", binaryOperators, anyToken, [
                isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeBinaryOperator", anyToken, binaryOperators, [
                isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterBinaryOperator", binaryOperators, anyToken, [
                isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"),
                isNonJsxSameLineTokenContext,
                isBinaryOpContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBeforeOpenParenInFuncDecl", anyToken, 21 /* OpenParenToken */ , [
                isOptionEnabled("insertSpaceBeforeFunctionParenthesis"),
                isNonJsxSameLineTokenContext,
                isFunctionDeclContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeOpenParenInFuncDecl", anyToken, 21 /* OpenParenToken */ , [
                isOptionDisabledOrUndefined("insertSpaceBeforeFunctionParenthesis"),
                isNonJsxSameLineTokenContext,
                isFunctionDeclContext
            ], 16 /* DeleteSpace */ ),
            // Open Brace braces after control block
            rule("NewLineBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionEnabled("placeOpenBraceOnNewLineForControlBlocks"),
                isControlDeclContext,
                isBeforeMultilineBlockContext
            ], 8 /* InsertNewLine */ , 1 /* CanDeleteNewLines */ ),
            // Open Brace braces after function
            // TypeScript: Function can have return types, which can be made of tons of different token kinds
            rule("NewLineBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionEnabled("placeOpenBraceOnNewLineForFunctions"),
                isFunctionDeclContext,
                isBeforeMultilineBlockContext
            ], 8 /* InsertNewLine */ , 1 /* CanDeleteNewLines */ ),
            // Open Brace braces after TypeScript module/class/interface
            rule("NewLineBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionEnabled("placeOpenBraceOnNewLineForFunctions"),
                isTypeScriptDeclWithBlockContext,
                isBeforeMultilineBlockContext
            ], 8 /* InsertNewLine */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceAfterTypeAssertion", 32 /* GreaterThanToken */ , anyToken, [
                isOptionEnabled("insertSpaceAfterTypeAssertion"),
                isNonJsxSameLineTokenContext,
                isTypeAssertionContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceAfterTypeAssertion", 32 /* GreaterThanToken */ , anyToken, [
                isOptionDisabledOrUndefined("insertSpaceAfterTypeAssertion"),
                isNonJsxSameLineTokenContext,
                isTypeAssertionContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBeforeTypeAnnotation", anyToken, [
                58 /* QuestionToken */ ,
                59 /* ColonToken */ 
            ], [
                isOptionEnabled("insertSpaceBeforeTypeAnnotation"),
                isNonJsxSameLineTokenContext,
                isTypeAnnotationContext
            ], 4 /* InsertSpace */ ),
            rule("NoSpaceBeforeTypeAnnotation", anyToken, [
                58 /* QuestionToken */ ,
                59 /* ColonToken */ 
            ], [
                isOptionDisabledOrUndefined("insertSpaceBeforeTypeAnnotation"),
                isNonJsxSameLineTokenContext,
                isTypeAnnotationContext
            ], 16 /* DeleteSpace */ ),
            rule("NoOptionalSemicolon", 27 /* SemicolonToken */ , anyTokenIncludingEOF, [
                optionEquals("semicolons", "remove" /* Remove */ ),
                isSemicolonDeletionContext
            ], 32 /* DeleteToken */ ),
            rule("OptionalSemicolon", anyToken, anyTokenIncludingEOF, [
                optionEquals("semicolons", "insert" /* Insert */ ),
                isSemicolonInsertionContext
            ], 64 /* InsertTrailingSemicolon */ )
        ];
        const lowPriorityCommonRules = [
            // Space after keyword but not before ; or : or ?
            rule("NoSpaceBeforeSemicolon", anyToken, 27 /* SemicolonToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForControlBlocks"),
                isControlDeclContext,
                isNotFormatOnEnter,
                isSameLineTokenOrBeforeBlockContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"),
                isFunctionDeclContext,
                isBeforeBlockContext,
                isNotFormatOnEnter,
                isSameLineTokenOrBeforeBlockContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("SpaceBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 19 /* OpenBraceToken */ , [
                isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"),
                isTypeScriptDeclWithBlockContext,
                isNotFormatOnEnter,
                isSameLineTokenOrBeforeBlockContext
            ], 4 /* InsertSpace */ , 1 /* CanDeleteNewLines */ ),
            rule("NoSpaceBeforeComma", anyToken, 28 /* CommaToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // No space before and after indexer `x[]`
            rule("NoSpaceBeforeOpenBracket", anyTokenExcept(134 /* AsyncKeyword */ , 84 /* CaseKeyword */ ), 23 /* OpenBracketToken */ , [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            rule("NoSpaceAfterCloseBracket", 24 /* CloseBracketToken */ , anyToken, [
                isNonJsxSameLineTokenContext,
                isNotBeforeBlockInFunctionDeclarationContext
            ], 16 /* DeleteSpace */ ),
            rule("SpaceAfterSemicolon", 27 /* SemicolonToken */ , anyToken, [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Remove extra space between for and await
            rule("SpaceBetweenForAndAwaitKeyword", 99 /* ForKeyword */ , 135 /* AwaitKeyword */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ ),
            // Remove extra spaces between ... and type name in tuple spread
            rule("SpaceBetweenDotDotDotAndTypeName", 26 /* DotDotDotToken */ , typeNames, [
                isNonJsxSameLineTokenContext
            ], 16 /* DeleteSpace */ ),
            // Add a space between statements. All keywords except (do,else,case) has open/close parens after them.
            // So, we have a rule to add a space for [),Any], [do,Any], [else,Any], and [case,Any]
            rule("SpaceBetweenStatements", [
                22 /* CloseParenToken */ ,
                92 /* DoKeyword */ ,
                93 /* ElseKeyword */ ,
                84 /* CaseKeyword */ 
            ], anyToken, [
                isNonJsxSameLineTokenContext,
                isNonJsxElementOrFragmentContext,
                isNotForContext
            ], 4 /* InsertSpace */ ),
            // This low-pri rule takes care of "try {", "catch {" and "finally {" in case the rule SpaceBeforeOpenBraceInControl didn't execute on FormatOnEnter.
            rule("SpaceAfterTryCatchFinally", [
                113 /* TryKeyword */ ,
                85 /* CatchKeyword */ ,
                98 /* FinallyKeyword */ 
            ], 19 /* OpenBraceToken */ , [
                isNonJsxSameLineTokenContext
            ], 4 /* InsertSpace */ )
        ];
        return [
            ...highPriorityCommonRules,
            ...userConfigurableRules,
            ...lowPriorityCommonRules
        ];
    }
    function rule(debugName, left, right, context, action, flags = 0 /* None */ ) {
        return {
            leftTokenRange: toTokenRange(left),
            rightTokenRange: toTokenRange(right),
            rule: {
                debugName,
                context,
                action,
                flags
            }
        };
    }
    function tokenRangeFrom(tokens) {
        return {
            tokens,
            isSpecific: true
        };
    }
    function toTokenRange(arg) {
        return typeof arg === "number" ? tokenRangeFrom([
            arg
        ]) : isArray(arg) ? tokenRangeFrom(arg) : arg;
    }
    function tokenRangeFromRange(from, to, except = []) {
        const tokens = [];
        for(let token = from; token <= to; token++)if (!contains(except, token)) tokens.push(token);
        return tokenRangeFrom(tokens);
    }
    function optionEquals(optionName, optionValue) {
        return (context)=>context.options && context.options[optionName] === optionValue;
    }
    function isOptionEnabled(optionName) {
        return (context)=>context.options && hasProperty(context.options, optionName) && !!context.options[optionName];
    }
    function isOptionDisabled(optionName) {
        return (context)=>context.options && hasProperty(context.options, optionName) && !context.options[optionName];
    }
    function isOptionDisabledOrUndefined(optionName) {
        return (context)=>!context.options || !hasProperty(context.options, optionName) || !context.options[optionName];
    }
    function isOptionDisabledOrUndefinedOrTokensOnSameLine(optionName) {
        return (context)=>!context.options || !hasProperty(context.options, optionName) || !context.options[optionName] || context.TokensAreOnSameLine();
    }
    function isOptionEnabledOrUndefined(optionName) {
        return (context)=>!context.options || !hasProperty(context.options, optionName) || !!context.options[optionName];
    }
    function isForContext(context) {
        return context.contextNode.kind === 249 /* ForStatement */ ;
    }
    function isNotForContext(context) {
        return !isForContext(context);
    }
    function isBinaryOpContext(context) {
        switch(context.contextNode.kind){
            case 227 /* BinaryExpression */ :
                return context.contextNode.operatorToken.kind !== 28 /* CommaToken */ ;
            case 228 /* ConditionalExpression */ :
            case 195 /* ConditionalType */ :
            case 235 /* AsExpression */ :
            case 282 /* ExportSpecifier */ :
            case 277 /* ImportSpecifier */ :
            case 183 /* TypePredicate */ :
            case 193 /* UnionType */ :
            case 194 /* IntersectionType */ :
            case 239 /* SatisfiesExpression */ :
                return true;
            // equals in binding elements: function foo([[x, y] = [1, 2]])
            case 209 /* BindingElement */ :
            // equals in type X = ...
            // falls through
            case 266 /* TypeAliasDeclaration */ :
            // equal in import a = module('a');
            // falls through
            case 272 /* ImportEqualsDeclaration */ :
            // equal in export = 1
            // falls through
            case 278 /* ExportAssignment */ :
            // equal in let a = 0
            // falls through
            case 261 /* VariableDeclaration */ :
            // equal in p = 0
            // falls through
            case 170 /* Parameter */ :
            case 307 /* EnumMember */ :
            case 173 /* PropertyDeclaration */ :
            case 172 /* PropertySignature */ :
                return context.currentTokenSpan.kind === 64 /* EqualsToken */  || context.nextTokenSpan.kind === 64 /* EqualsToken */ ;
            // "in" keyword in for (let x in []) { }
            case 250 /* ForInStatement */ :
            // "in" keyword in [P in keyof T]: T[P]
            // falls through
            case 169 /* TypeParameter */ :
                return context.currentTokenSpan.kind === 103 /* InKeyword */  || context.nextTokenSpan.kind === 103 /* InKeyword */  || context.currentTokenSpan.kind === 64 /* EqualsToken */  || context.nextTokenSpan.kind === 64 /* EqualsToken */ ;
            // Technically, "of" is not a binary operator, but format it the same way as "in"
            case 251 /* ForOfStatement */ :
                return context.currentTokenSpan.kind === 165 /* OfKeyword */  || context.nextTokenSpan.kind === 165 /* OfKeyword */ ;
        }
        return false;
    }
    function isNotBinaryOpContext(context) {
        return !isBinaryOpContext(context);
    }
    function isNotTypeAnnotationContext(context) {
        return !isTypeAnnotationContext(context);
    }
    function isTypeAnnotationContext(context) {
        const contextKind = context.contextNode.kind;
        return contextKind === 173 /* PropertyDeclaration */  || contextKind === 172 /* PropertySignature */  || contextKind === 170 /* Parameter */  || contextKind === 261 /* VariableDeclaration */  || isFunctionLikeKind(contextKind);
    }
    function isOptionalPropertyContext(context) {
        return isPropertyDeclaration(context.contextNode) && context.contextNode.questionToken;
    }
    function isNonOptionalPropertyContext(context) {
        return !isOptionalPropertyContext(context);
    }
    function isConditionalOperatorContext(context) {
        return context.contextNode.kind === 228 /* ConditionalExpression */  || context.contextNode.kind === 195 /* ConditionalType */ ;
    }
    function isSameLineTokenOrBeforeBlockContext(context) {
        return context.TokensAreOnSameLine() || isBeforeBlockContext(context);
    }
    function isBraceWrappedContext(context) {
        return context.contextNode.kind === 207 /* ObjectBindingPattern */  || context.contextNode.kind === 201 /* MappedType */  || isSingleLineBlockContext(context);
    }
    function isBeforeMultilineBlockContext(context) {
        return isBeforeBlockContext(context) && !(context.NextNodeAllOnSameLine() || context.NextNodeBlockIsOnOneLine());
    }
    function isMultilineBlockContext(context) {
        return isBlockContext(context) && !(context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
    }
    function isSingleLineBlockContext(context) {
        return isBlockContext(context) && (context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
    }
    function isBlockContext(context) {
        return nodeIsBlockContext(context.contextNode);
    }
    function isBeforeBlockContext(context) {
        return nodeIsBlockContext(context.nextTokenParent);
    }
    function nodeIsBlockContext(node) {
        if (nodeIsTypeScriptDeclWithBlockContext(node)) return true;
        switch(node.kind){
            case 242 /* Block */ :
            case 270 /* CaseBlock */ :
            case 211 /* ObjectLiteralExpression */ :
            case 269 /* ModuleBlock */ :
                return true;
        }
        return false;
    }
    function isFunctionDeclContext(context) {
        switch(context.contextNode.kind){
            case 263 /* FunctionDeclaration */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            // case SyntaxKind.MemberFunctionDeclaration:
            // falls through
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
            // case SyntaxKind.MethodSignature:
            // falls through
            case 180 /* CallSignature */ :
            case 219 /* FunctionExpression */ :
            case 177 /* Constructor */ :
            case 220 /* ArrowFunction */ :
            // case SyntaxKind.ConstructorDeclaration:
            // case SyntaxKind.SimpleArrowFunctionExpression:
            // case SyntaxKind.ParenthesizedArrowFunctionExpression:
            // falls through
            case 265 /* InterfaceDeclaration */ :
                return true;
        }
        return false;
    }
    function isNotFunctionDeclContext(context) {
        return !isFunctionDeclContext(context);
    }
    function isFunctionDeclarationOrFunctionExpressionContext(context) {
        return context.contextNode.kind === 263 /* FunctionDeclaration */  || context.contextNode.kind === 219 /* FunctionExpression */ ;
    }
    function isTypeScriptDeclWithBlockContext(context) {
        return nodeIsTypeScriptDeclWithBlockContext(context.contextNode);
    }
    function nodeIsTypeScriptDeclWithBlockContext(node) {
        switch(node.kind){
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 188 /* TypeLiteral */ :
            case 268 /* ModuleDeclaration */ :
            case 279 /* ExportDeclaration */ :
            case 280 /* NamedExports */ :
            case 273 /* ImportDeclaration */ :
            case 276 /* NamedImports */ :
                return true;
        }
        return false;
    }
    function isAfterCodeBlockContext(context) {
        switch(context.currentTokenParent.kind){
            case 264 /* ClassDeclaration */ :
            case 268 /* ModuleDeclaration */ :
            case 267 /* EnumDeclaration */ :
            case 300 /* CatchClause */ :
            case 269 /* ModuleBlock */ :
            case 256 /* SwitchStatement */ :
                return true;
            case 242 /* Block */ :
                {
                    const blockParent = context.currentTokenParent.parent;
                    if (!blockParent || blockParent.kind !== 220 /* ArrowFunction */  && blockParent.kind !== 219 /* FunctionExpression */ ) return true;
                }
        }
        return false;
    }
    function isControlDeclContext(context) {
        switch(context.contextNode.kind){
            case 246 /* IfStatement */ :
            case 256 /* SwitchStatement */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 248 /* WhileStatement */ :
            case 259 /* TryStatement */ :
            case 247 /* DoStatement */ :
            case 255 /* WithStatement */ :
            // TODO
            // case SyntaxKind.ElseClause:
            // falls through
            case 300 /* CatchClause */ :
                return true;
            default:
                return false;
        }
    }
    function isObjectContext(context) {
        return context.contextNode.kind === 211 /* ObjectLiteralExpression */ ;
    }
    function isFunctionCallContext(context) {
        return context.contextNode.kind === 214 /* CallExpression */ ;
    }
    function isNewContext(context) {
        return context.contextNode.kind === 215 /* NewExpression */ ;
    }
    function isFunctionCallOrNewContext(context) {
        return isFunctionCallContext(context) || isNewContext(context);
    }
    function isPreviousTokenNotComma(context) {
        return context.currentTokenSpan.kind !== 28 /* CommaToken */ ;
    }
    function isNextTokenNotCloseBracket(context) {
        return context.nextTokenSpan.kind !== 24 /* CloseBracketToken */ ;
    }
    function isNextTokenNotCloseParen(context) {
        return context.nextTokenSpan.kind !== 22 /* CloseParenToken */ ;
    }
    function isArrowFunctionContext(context) {
        return context.contextNode.kind === 220 /* ArrowFunction */ ;
    }
    function isImportTypeContext(context) {
        return context.contextNode.kind === 206 /* ImportType */ ;
    }
    function isNonJsxSameLineTokenContext(context) {
        return context.TokensAreOnSameLine() && context.contextNode.kind !== 12 /* JsxText */ ;
    }
    function isNonJsxTextContext(context) {
        return context.contextNode.kind !== 12 /* JsxText */ ;
    }
    function isNonJsxElementOrFragmentContext(context) {
        return context.contextNode.kind !== 285 /* JsxElement */  && context.contextNode.kind !== 289 /* JsxFragment */ ;
    }
    function isJsxExpressionContext(context) {
        return context.contextNode.kind === 295 /* JsxExpression */  || context.contextNode.kind === 294 /* JsxSpreadAttribute */ ;
    }
    function isNextTokenParentJsxAttribute(context) {
        return context.nextTokenParent.kind === 292 /* JsxAttribute */  || context.nextTokenParent.kind === 296 /* JsxNamespacedName */  && context.nextTokenParent.parent.kind === 292 /* JsxAttribute */ ;
    }
    function isJsxAttributeContext(context) {
        return context.contextNode.kind === 292 /* JsxAttribute */ ;
    }
    function isNextTokenParentNotJsxNamespacedName(context) {
        return context.nextTokenParent.kind !== 296 /* JsxNamespacedName */ ;
    }
    function isNextTokenParentJsxNamespacedName(context) {
        return context.nextTokenParent.kind === 296 /* JsxNamespacedName */ ;
    }
    function isJsxSelfClosingElementContext(context) {
        return context.contextNode.kind === 286 /* JsxSelfClosingElement */ ;
    }
    function isNotBeforeBlockInFunctionDeclarationContext(context) {
        return !isFunctionDeclContext(context) && !isBeforeBlockContext(context);
    }
    function isEndOfDecoratorContextOnSameLine(context) {
        return context.TokensAreOnSameLine() && hasDecorators(context.contextNode) && nodeIsInDecoratorContext(context.currentTokenParent) && !nodeIsInDecoratorContext(context.nextTokenParent);
    }
    function nodeIsInDecoratorContext(node) {
        while(node && isExpression(node))node = node.parent;
        return node && node.kind === 171 /* Decorator */ ;
    }
    function isStartOfVariableDeclarationList(context) {
        return context.currentTokenParent.kind === 262 /* VariableDeclarationList */  && context.currentTokenParent.getStart(context.sourceFile) === context.currentTokenSpan.pos;
    }
    function isNotFormatOnEnter(context) {
        return context.formattingRequestKind !== 2 /* FormatOnEnter */ ;
    }
    function isModuleDeclContext(context) {
        return context.contextNode.kind === 268 /* ModuleDeclaration */ ;
    }
    function isObjectTypeContext(context) {
        return context.contextNode.kind === 188 /* TypeLiteral */ ;
    }
    function isConstructorSignatureContext(context) {
        return context.contextNode.kind === 181 /* ConstructSignature */ ;
    }
    function isTypeArgumentOrParameterOrAssertion(token, parent2) {
        if (token.kind !== 30 /* LessThanToken */  && token.kind !== 32 /* GreaterThanToken */ ) return false;
        switch(parent2.kind){
            case 184 /* TypeReference */ :
            case 217 /* TypeAssertionExpression */ :
            case 266 /* TypeAliasDeclaration */ :
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 220 /* ArrowFunction */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
            case 234 /* ExpressionWithTypeArguments */ :
                return true;
            default:
                return false;
        }
    }
    function isTypeArgumentOrParameterOrAssertionContext(context) {
        return isTypeArgumentOrParameterOrAssertion(context.currentTokenSpan, context.currentTokenParent) || isTypeArgumentOrParameterOrAssertion(context.nextTokenSpan, context.nextTokenParent);
    }
    function isTypeAssertionContext(context) {
        return context.contextNode.kind === 217 /* TypeAssertionExpression */ ;
    }
    function isNonTypeAssertionContext(context) {
        return !isTypeAssertionContext(context);
    }
    function isVoidOpContext(context) {
        return context.currentTokenSpan.kind === 116 /* VoidKeyword */  && context.currentTokenParent.kind === 223 /* VoidExpression */ ;
    }
    function isYieldOrYieldStarWithOperand(context) {
        return context.contextNode.kind === 230 /* YieldExpression */  && context.contextNode.expression !== void 0;
    }
    function isNonNullAssertionContext(context) {
        return context.contextNode.kind === 236 /* NonNullExpression */ ;
    }
    function isNotStatementConditionContext(context) {
        return !isStatementConditionContext(context);
    }
    function isStatementConditionContext(context) {
        switch(context.contextNode.kind){
            case 246 /* IfStatement */ :
            case 249 /* ForStatement */ :
            case 250 /* ForInStatement */ :
            case 251 /* ForOfStatement */ :
            case 247 /* DoStatement */ :
            case 248 /* WhileStatement */ :
                return true;
            default:
                return false;
        }
    }
    function isSemicolonDeletionContext(context) {
        let nextTokenKind = context.nextTokenSpan.kind;
        let nextTokenStart = context.nextTokenSpan.pos;
        if (isTrivia(nextTokenKind)) {
            const nextRealToken = context.nextTokenParent === context.currentTokenParent ? findNextToken(context.currentTokenParent, findAncestor(context.currentTokenParent, (a)=>!a.parent), context.sourceFile) : context.nextTokenParent.getFirstToken(context.sourceFile);
            if (!nextRealToken) return true;
            nextTokenKind = nextRealToken.kind;
            nextTokenStart = nextRealToken.getStart(context.sourceFile);
        }
        const startLine = context.sourceFile.getLineAndCharacterOfPosition(context.currentTokenSpan.pos).line;
        const endLine = context.sourceFile.getLineAndCharacterOfPosition(nextTokenStart).line;
        if (startLine === endLine) return nextTokenKind === 20 /* CloseBraceToken */  || nextTokenKind === 1 /* EndOfFileToken */ ;
        if (nextTokenKind === 27 /* SemicolonToken */  && context.currentTokenSpan.kind === 27 /* SemicolonToken */ ) return true;
        if (nextTokenKind === 241 /* SemicolonClassElement */  || nextTokenKind === 27 /* SemicolonToken */ ) return false;
        if (context.contextNode.kind === 265 /* InterfaceDeclaration */  || context.contextNode.kind === 266 /* TypeAliasDeclaration */ ) return !isPropertySignature(context.currentTokenParent) || !!context.currentTokenParent.type || nextTokenKind !== 21 /* OpenParenToken */ ;
        if (isPropertyDeclaration(context.currentTokenParent)) return !context.currentTokenParent.initializer;
        return context.currentTokenParent.kind !== 249 /* ForStatement */  && context.currentTokenParent.kind !== 243 /* EmptyStatement */  && context.currentTokenParent.kind !== 241 /* SemicolonClassElement */  && nextTokenKind !== 23 /* OpenBracketToken */  && nextTokenKind !== 21 /* OpenParenToken */  && nextTokenKind !== 40 /* PlusToken */  && nextTokenKind !== 41 /* MinusToken */  && nextTokenKind !== 44 /* SlashToken */  && nextTokenKind !== 14 /* RegularExpressionLiteral */  && nextTokenKind !== 28 /* CommaToken */  && nextTokenKind !== 229 /* TemplateExpression */  && nextTokenKind !== 16 /* TemplateHead */  && nextTokenKind !== 15 /* NoSubstitutionTemplateLiteral */  && nextTokenKind !== 25 /* DotToken */ ;
    }
    function isSemicolonInsertionContext(context) {
        return positionIsASICandidate(context.currentTokenSpan.end, context.currentTokenParent, context.sourceFile);
    }
    function isNotPropertyAccessOnIntegerLiteral(context) {
        return !isPropertyAccessExpression(context.contextNode) || !isNumericLiteral(context.contextNode.expression) || context.contextNode.expression.getText().includes(".");
    }
    // src/services/formatting/rulesMap.ts
    function getFormatContext(options, host) {
        return {
            options,
            getRules: getRulesMap(),
            host
        };
    }
    var rulesMapCache;
    function getRulesMap() {
        if (rulesMapCache === void 0) rulesMapCache = createRulesMap(getAllRules());
        return rulesMapCache;
    }
    function getRuleActionExclusion(ruleAction) {
        let mask2 = 0 /* None */ ;
        if (ruleAction & 1 /* StopProcessingSpaceActions */ ) mask2 |= 28 /* ModifySpaceAction */ ;
        if (ruleAction & 2 /* StopProcessingTokenActions */ ) mask2 |= 96 /* ModifyTokenAction */ ;
        if (ruleAction & 28 /* ModifySpaceAction */ ) mask2 |= 28 /* ModifySpaceAction */ ;
        if (ruleAction & 96 /* ModifyTokenAction */ ) mask2 |= 96 /* ModifyTokenAction */ ;
        return mask2;
    }
    function createRulesMap(rules) {
        const map2 = buildMap(rules);
        return (context)=>{
            const bucket = map2[getRuleBucketIndex(context.currentTokenSpan.kind, context.nextTokenSpan.kind)];
            if (bucket) {
                const rules2 = [];
                let ruleActionMask = 0;
                for (const rule2 of bucket){
                    const acceptRuleActions = ~getRuleActionExclusion(ruleActionMask);
                    if (rule2.action & acceptRuleActions && every(rule2.context, (c)=>c(context))) {
                        rules2.push(rule2);
                        ruleActionMask |= rule2.action;
                    }
                }
                if (rules2.length) return rules2;
            }
        };
    }
    function buildMap(rules) {
        const map2 = new Array(mapRowLength * mapRowLength);
        const rulesBucketConstructionStateList = new Array(map2.length);
        for (const rule2 of rules){
            const specificRule = rule2.leftTokenRange.isSpecific && rule2.rightTokenRange.isSpecific;
            for (const left of rule2.leftTokenRange.tokens)for (const right of rule2.rightTokenRange.tokens){
                const index = getRuleBucketIndex(left, right);
                let rulesBucket = map2[index];
                if (rulesBucket === void 0) rulesBucket = map2[index] = [];
                addRule(rulesBucket, rule2.rule, specificRule, rulesBucketConstructionStateList, index);
            }
        }
        return map2;
    }
    function getRuleBucketIndex(row, column) {
        Debug.assert(row <= 166 /* LastKeyword */  && column <= 166 /* LastKeyword */ , "Must compute formatting context from tokens");
        return row * mapRowLength + column;
    }
    var maskBitSize = 5;
    var mask = 31;
    var mapRowLength = 167;
    var RulesPosition = ((RulesPosition2)=>{
        RulesPosition2[RulesPosition2["StopRulesSpecific"] = 0] = "StopRulesSpecific";
        RulesPosition2[RulesPosition2["StopRulesAny"] = maskBitSize * 1] = "StopRulesAny";
        RulesPosition2[RulesPosition2["ContextRulesSpecific"] = maskBitSize * 2] = "ContextRulesSpecific";
        RulesPosition2[RulesPosition2["ContextRulesAny"] = maskBitSize * 3] = "ContextRulesAny";
        RulesPosition2[RulesPosition2["NoContextRulesSpecific"] = maskBitSize * 4] = "NoContextRulesSpecific";
        RulesPosition2[RulesPosition2["NoContextRulesAny"] = maskBitSize * 5] = "NoContextRulesAny";
        return RulesPosition2;
    })(RulesPosition || {});
    function addRule(rules, rule2, specificTokens, constructionState, rulesBucketIndex) {
        const position = rule2.action & 3 /* StopAction */  ? specificTokens ? 0 /* StopRulesSpecific */  : RulesPosition.StopRulesAny : rule2.context !== anyContext ? specificTokens ? RulesPosition.ContextRulesSpecific : RulesPosition.ContextRulesAny : specificTokens ? RulesPosition.NoContextRulesSpecific : RulesPosition.NoContextRulesAny;
        const state = constructionState[rulesBucketIndex] || 0;
        rules.splice(getInsertionIndex(state, position), 0, rule2);
        constructionState[rulesBucketIndex] = increaseInsertionIndex(state, position);
    }
    function getInsertionIndex(indexBitmap, maskPosition) {
        let index = 0;
        for(let pos = 0; pos <= maskPosition; pos += maskBitSize){
            index += indexBitmap & mask;
            indexBitmap >>= maskBitSize;
        }
        return index;
    }
    function increaseInsertionIndex(indexBitmap, maskPosition) {
        const value1 = (indexBitmap >> maskPosition & mask) + 1;
        Debug.assert((value1 & mask) === value1, "Adding more rules into the sub-bucket than allowed. Maximum allowed is 32 rules.");
        return indexBitmap & ~(mask << maskPosition) | value1 << maskPosition;
    }
    // src/services/formatting/formatting.ts
    function createTextRangeWithKind(pos, end, kind) {
        const textRangeWithKind = {
            pos,
            end,
            kind
        };
        if (Debug.isDebugging) Object.defineProperty(textRangeWithKind, "__debugKind", {
            get: ()=>Debug.formatSyntaxKind(kind)
        });
        return textRangeWithKind;
    }
    function formatOnEnter(position, sourceFile, formatContext) {
        const line = sourceFile.getLineAndCharacterOfPosition(position).line;
        if (line === 0) return [];
        let endOfFormatSpan = getEndLinePosition(line, sourceFile);
        while(isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(endOfFormatSpan)))endOfFormatSpan--;
        if (isLineBreak(sourceFile.text.charCodeAt(endOfFormatSpan))) endOfFormatSpan--;
        const span = {
            // get start position for the previous line
            pos: getStartPositionOfLine(line - 1, sourceFile),
            // end value is exclusive so add 1 to the result
            end: endOfFormatSpan + 1
        };
        return formatSpan(span, sourceFile, formatContext, 2 /* FormatOnEnter */ );
    }
    function formatOnSemicolon(position, sourceFile, formatContext) {
        const semicolon = findImmediatelyPrecedingTokenOfKind(position, 27 /* SemicolonToken */ , sourceFile);
        return formatNodeLines(findOutermostNodeWithinListLevel(semicolon), sourceFile, formatContext, 3 /* FormatOnSemicolon */ );
    }
    function formatOnOpeningCurly(position, sourceFile, formatContext) {
        const openingCurly = findImmediatelyPrecedingTokenOfKind(position, 19 /* OpenBraceToken */ , sourceFile);
        if (!openingCurly) return [];
        const curlyBraceRange = openingCurly.parent;
        const outermostNode = findOutermostNodeWithinListLevel(curlyBraceRange);
        const textRange = {
            pos: getLineStartPositionForPosition(outermostNode.getStart(sourceFile), sourceFile),
            // TODO: GH#18217
            end: position
        };
        return formatSpan(textRange, sourceFile, formatContext, 4 /* FormatOnOpeningCurlyBrace */ );
    }
    function formatOnClosingCurly(position, sourceFile, formatContext) {
        const precedingToken = findImmediatelyPrecedingTokenOfKind(position, 20 /* CloseBraceToken */ , sourceFile);
        return formatNodeLines(findOutermostNodeWithinListLevel(precedingToken), sourceFile, formatContext, 5 /* FormatOnClosingCurlyBrace */ );
    }
    function formatDocument(sourceFile, formatContext) {
        const span = {
            pos: 0,
            end: sourceFile.text.length
        };
        return formatSpan(span, sourceFile, formatContext, 0 /* FormatDocument */ );
    }
    function formatSelection(start, end, sourceFile, formatContext) {
        const span = {
            pos: getLineStartPositionForPosition(start, sourceFile),
            end
        };
        return formatSpan(span, sourceFile, formatContext, 1 /* FormatSelection */ );
    }
    function findImmediatelyPrecedingTokenOfKind(end, expectedTokenKind, sourceFile) {
        const precedingToken = findPrecedingToken(end, sourceFile);
        return precedingToken && precedingToken.kind === expectedTokenKind && end === precedingToken.getEnd() ? precedingToken : void 0;
    }
    function findOutermostNodeWithinListLevel(node) {
        let current = node;
        while(current && current.parent && current.parent.end === node.end && !isListElement(current.parent, current))current = current.parent;
        return current;
    }
    function isListElement(parent2, node) {
        switch(parent2.kind){
            case 264 /* ClassDeclaration */ :
            case 265 /* InterfaceDeclaration */ :
                return rangeContainsRange(parent2.members, node);
            case 268 /* ModuleDeclaration */ :
                const body = parent2.body;
                return !!body && body.kind === 269 /* ModuleBlock */  && rangeContainsRange(body.statements, node);
            case 308 /* SourceFile */ :
            case 242 /* Block */ :
            case 269 /* ModuleBlock */ :
                return rangeContainsRange(parent2.statements, node);
            case 300 /* CatchClause */ :
                return rangeContainsRange(parent2.block.statements, node);
        }
        return false;
    }
    function findEnclosingNode(range, sourceFile) {
        return find2(sourceFile);
        function find2(n) {
            const candidate = forEachChild(n, (c)=>startEndContainsRange(c.getStart(sourceFile), c.end, range) && c);
            if (candidate) {
                const result = find2(candidate);
                if (result) return result;
            }
            return n;
        }
    }
    function prepareRangeContainsErrorFunction(errors, originalRange) {
        if (!errors.length) return rangeHasNoErrors;
        const sorted = errors.filter((d)=>rangeOverlapsWithStartEnd(originalRange, d.start, d.start + d.length)).sort((e1, e2)=>e1.start - e2.start);
        if (!sorted.length) return rangeHasNoErrors;
        let index = 0;
        return (r)=>{
            while(true){
                if (index >= sorted.length) return false;
                const error2 = sorted[index];
                if (r.end <= error2.start) return false;
                if (startEndOverlapsWithStartEnd(r.pos, r.end, error2.start, error2.start + error2.length)) return true;
                index++;
            }
        };
        function rangeHasNoErrors() {
            return false;
        }
    }
    function getScanStartPosition(enclosingNode, originalRange, sourceFile) {
        const start = enclosingNode.getStart(sourceFile);
        if (start === originalRange.pos && enclosingNode.end === originalRange.end) return start;
        const precedingToken = findPrecedingToken(originalRange.pos, sourceFile);
        if (!precedingToken) return enclosingNode.pos;
        if (precedingToken.end >= originalRange.pos) return enclosingNode.pos;
        return precedingToken.end;
    }
    function getOwnOrInheritedDelta(n, options, sourceFile) {
        let previousLine = -1 /* Unknown */ ;
        let child;
        while(n){
            const line = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile)).line;
            if (previousLine !== -1 /* Unknown */  && line !== previousLine) break;
            if (SmartIndenter.shouldIndentChildNode(options, n, child, sourceFile)) return options.indentSize;
            previousLine = line;
            child = n;
            n = n.parent;
        }
        return 0;
    }
    function formatNodeGivenIndentation(node, sourceFileLike, languageVariant, initialIndentation, delta, formatContext) {
        const range = {
            pos: node.pos,
            end: node.end
        };
        return getFormattingScanner(sourceFileLike.text, languageVariant, range.pos, range.end, (scanner2)=>formatSpanWorker(range, node, initialIndentation, delta, scanner2, formatContext, 1 /* FormatSelection */ , (_)=>false, // assume that node does not have any errors
            sourceFileLike));
    }
    function formatNodeLines(node, sourceFile, formatContext, requestKind) {
        if (!node) return [];
        const span = {
            pos: getLineStartPositionForPosition(node.getStart(sourceFile), sourceFile),
            end: node.end
        };
        return formatSpan(span, sourceFile, formatContext, requestKind);
    }
    function formatSpan(originalRange, sourceFile, formatContext, requestKind) {
        const enclosingNode = findEnclosingNode(originalRange, sourceFile);
        return getFormattingScanner(sourceFile.text, sourceFile.languageVariant, getScanStartPosition(enclosingNode, originalRange, sourceFile), originalRange.end, (scanner2)=>formatSpanWorker(originalRange, enclosingNode, SmartIndenter.getIndentationForNode(enclosingNode, originalRange, sourceFile, formatContext.options), getOwnOrInheritedDelta(enclosingNode, formatContext.options, sourceFile), scanner2, formatContext, requestKind, prepareRangeContainsErrorFunction(sourceFile.parseDiagnostics, originalRange), sourceFile));
    }
    function formatSpanWorker(originalRange, enclosingNode, initialIndentation, delta, formattingScanner, { options, getRules, host }, requestKind, rangeContainsError, sourceFile) {
        var _a;
        const formattingContext = new FormattingContext(sourceFile, requestKind, options);
        let previousRangeTriviaEnd;
        let previousRange;
        let previousParent;
        let previousRangeStartLine;
        let lastIndentedLine;
        let indentationOnLastIndentedLine = -1 /* Unknown */ ;
        const edits = [];
        formattingScanner.advance();
        if (formattingScanner.isOnToken()) {
            const startLine = sourceFile.getLineAndCharacterOfPosition(enclosingNode.getStart(sourceFile)).line;
            let undecoratedStartLine = startLine;
            if (hasDecorators(enclosingNode)) undecoratedStartLine = sourceFile.getLineAndCharacterOfPosition(getNonDecoratorTokenPosOfNode(enclosingNode, sourceFile)).line;
            processNode(enclosingNode, enclosingNode, startLine, undecoratedStartLine, initialIndentation, delta);
        }
        const remainingTrivia = formattingScanner.getCurrentLeadingTrivia();
        if (remainingTrivia) {
            const indentation = SmartIndenter.nodeWillIndentChild(options, enclosingNode, /*child*/ void 0, sourceFile, /*indentByDefault*/ false) ? initialIndentation + options.indentSize : initialIndentation;
            indentTriviaItems(remainingTrivia, indentation, /*indentNextTokenOrTrivia*/ true, (item)=>{
                processRange(item, sourceFile.getLineAndCharacterOfPosition(item.pos), enclosingNode, enclosingNode, /*dynamicIndentation*/ void 0);
                insertIndentation(item.pos, indentation, /*lineAdded*/ false);
            });
            if (options.trimTrailingWhitespace !== false) trimTrailingWhitespacesForRemainingRange(remainingTrivia);
        }
        if (previousRange && formattingScanner.getTokenFullStart() >= originalRange.end) {
            const tokenInfo = formattingScanner.isOnEOF() ? formattingScanner.readEOFTokenRange() : formattingScanner.isOnToken() ? formattingScanner.readTokenInfo(enclosingNode).token : void 0;
            if (tokenInfo && tokenInfo.pos === previousRangeTriviaEnd) {
                const parent2 = ((_a = findPrecedingToken(tokenInfo.end, sourceFile, enclosingNode)) == null ? void 0 : _a.parent) || previousParent;
                processPair(tokenInfo, sourceFile.getLineAndCharacterOfPosition(tokenInfo.pos).line, parent2, previousRange, previousRangeStartLine, previousParent, parent2, /*dynamicIndentation*/ void 0);
            }
        }
        return edits;
        function tryComputeIndentationForListItem(startPos, endPos, parentStartLine, range, inheritedIndentation) {
            if (rangeOverlapsWithStartEnd(range, startPos, endPos) || rangeContainsStartEnd(range, startPos, endPos)) {
                if (inheritedIndentation !== -1 /* Unknown */ ) return inheritedIndentation;
            } else {
                const startLine = sourceFile.getLineAndCharacterOfPosition(startPos).line;
                const startLinePosition = getLineStartPositionForPosition(startPos, sourceFile);
                const column = SmartIndenter.findFirstNonWhitespaceColumn(startLinePosition, startPos, sourceFile, options);
                if (startLine !== parentStartLine || startPos === column) {
                    const baseIndentSize = SmartIndenter.getBaseIndentation(options);
                    return baseIndentSize > column ? baseIndentSize : column;
                }
            }
            return -1 /* Unknown */ ;
        }
        function computeIndentation(node, startLine, inheritedIndentation, parent2, parentDynamicIndentation, effectiveParentStartLine) {
            const delta2 = SmartIndenter.shouldIndentChildNode(options, node) ? options.indentSize : 0;
            if (effectiveParentStartLine === startLine) return {
                indentation: startLine === lastIndentedLine ? indentationOnLastIndentedLine : parentDynamicIndentation.getIndentation(),
                delta: Math.min(options.indentSize, parentDynamicIndentation.getDelta(node) + delta2)
            };
            else if (inheritedIndentation === -1 /* Unknown */ ) {
                if (node.kind === 21 /* OpenParenToken */  && startLine === lastIndentedLine) return {
                    indentation: indentationOnLastIndentedLine,
                    delta: parentDynamicIndentation.getDelta(node)
                };
                else if (SmartIndenter.childStartsOnTheSameLineWithElseInIfStatement(parent2, node, startLine, sourceFile) || SmartIndenter.childIsUnindentedBranchOfConditionalExpression(parent2, node, startLine, sourceFile) || SmartIndenter.argumentStartsOnSameLineAsPreviousArgument(parent2, node, startLine, sourceFile)) return {
                    indentation: parentDynamicIndentation.getIndentation(),
                    delta: delta2
                };
                else return {
                    indentation: parentDynamicIndentation.getIndentation() + parentDynamicIndentation.getDelta(node),
                    delta: delta2
                };
            } else return {
                indentation: inheritedIndentation,
                delta: delta2
            };
        }
        function getFirstNonDecoratorTokenOfNode(node) {
            if (canHaveModifiers(node)) {
                const modifier = find(node.modifiers, isModifier, findIndex(node.modifiers, isDecorator));
                if (modifier) return modifier.kind;
            }
            switch(node.kind){
                case 264 /* ClassDeclaration */ :
                    return 86 /* ClassKeyword */ ;
                case 265 /* InterfaceDeclaration */ :
                    return 120 /* InterfaceKeyword */ ;
                case 263 /* FunctionDeclaration */ :
                    return 100 /* FunctionKeyword */ ;
                case 267 /* EnumDeclaration */ :
                    return 267 /* EnumDeclaration */ ;
                case 178 /* GetAccessor */ :
                    return 139 /* GetKeyword */ ;
                case 179 /* SetAccessor */ :
                    return 153 /* SetKeyword */ ;
                case 175 /* MethodDeclaration */ :
                    if (node.asteriskToken) return 42 /* AsteriskToken */ ;
                // falls through
                case 173 /* PropertyDeclaration */ :
                case 170 /* Parameter */ :
                    const name = getNameOfDeclaration(node);
                    if (name) return name.kind;
            }
        }
        function getDynamicIndentation(node, nodeStartLine, indentation, delta2) {
            return {
                getIndentationForComment: (kind, tokenIndentation, container)=>{
                    switch(kind){
                        // preceding comment to the token that closes the indentation scope inherits the indentation from the scope
                        // ..  {
                        //     // comment
                        // }
                        case 20 /* CloseBraceToken */ :
                        case 24 /* CloseBracketToken */ :
                        case 22 /* CloseParenToken */ :
                            return indentation + getDelta(container);
                    }
                    return tokenIndentation !== -1 /* Unknown */  ? tokenIndentation : indentation;
                },
                // if list end token is LessThanToken '>' then its delta should be explicitly suppressed
                // so that LessThanToken as a binary operator can still be indented.
                // foo.then
                //     <
                //         number,
                //         string,
                //     >();
                // vs
                // var a = xValue
                //     > yValue;
                getIndentationForToken: (line, kind, container, suppressDelta)=>!suppressDelta && shouldAddDelta(line, kind, container) ? indentation + getDelta(container) : indentation,
                getIndentation: ()=>indentation,
                getDelta,
                recomputeIndentation: (lineAdded, parent2)=>{
                    if (SmartIndenter.shouldIndentChildNode(options, parent2, node, sourceFile)) {
                        indentation += lineAdded ? options.indentSize : -options.indentSize;
                        delta2 = SmartIndenter.shouldIndentChildNode(options, node) ? options.indentSize : 0;
                    }
                }
            };
            function shouldAddDelta(line, kind, container) {
                switch(kind){
                    // open and close brace, 'else' and 'while' (in do statement) tokens has indentation of the parent
                    case 19 /* OpenBraceToken */ :
                    case 20 /* CloseBraceToken */ :
                    case 22 /* CloseParenToken */ :
                    case 93 /* ElseKeyword */ :
                    case 117 /* WhileKeyword */ :
                    case 60 /* AtToken */ :
                        return false;
                    case 44 /* SlashToken */ :
                    case 32 /* GreaterThanToken */ :
                        switch(container.kind){
                            case 287 /* JsxOpeningElement */ :
                            case 288 /* JsxClosingElement */ :
                            case 286 /* JsxSelfClosingElement */ :
                                return false;
                        }
                        break;
                    case 23 /* OpenBracketToken */ :
                    case 24 /* CloseBracketToken */ :
                        if (container.kind !== 201 /* MappedType */ ) return false;
                        break;
                }
                return nodeStartLine !== line && !(hasDecorators(node) && kind === getFirstNonDecoratorTokenOfNode(node));
            }
            function getDelta(child) {
                return SmartIndenter.nodeWillIndentChild(options, node, child, sourceFile, /*indentByDefault*/ true) ? delta2 : 0;
            }
        }
        function processNode(node, contextNode, nodeStartLine, undecoratedNodeStartLine, indentation, delta2) {
            if (!rangeOverlapsWithStartEnd(originalRange, node.getStart(sourceFile), node.getEnd())) return;
            const nodeDynamicIndentation = getDynamicIndentation(node, nodeStartLine, indentation, delta2);
            let childContextNode = contextNode;
            forEachChild(node, (child)=>{
                processChildNode(child, /*inheritedIndentation*/ -1 /* Unknown */ , node, nodeDynamicIndentation, nodeStartLine, undecoratedNodeStartLine, /*isListItem*/ false);
            }, (nodes)=>{
                processChildNodes(nodes, node, nodeStartLine, nodeDynamicIndentation);
            });
            while(formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end){
                const tokenInfo = formattingScanner.readTokenInfo(node);
                if (tokenInfo.token.end > Math.min(node.end, originalRange.end)) break;
                consumeTokenAndAdvanceScanner(tokenInfo, node, nodeDynamicIndentation, node);
            }
            function processChildNode(child, inheritedIndentation, parent2, parentDynamicIndentation, parentStartLine, undecoratedParentStartLine, isListItem, isFirstListItem) {
                Debug.assert(!nodeIsSynthesized(child));
                if (nodeIsMissing(child) || isGrammarError(parent2, child)) return inheritedIndentation;
                const childStartPos = child.getStart(sourceFile);
                const childStartLine = sourceFile.getLineAndCharacterOfPosition(childStartPos).line;
                let undecoratedChildStartLine = childStartLine;
                if (hasDecorators(child)) undecoratedChildStartLine = sourceFile.getLineAndCharacterOfPosition(getNonDecoratorTokenPosOfNode(child, sourceFile)).line;
                let childIndentationAmount = -1 /* Unknown */ ;
                if (isListItem && rangeContainsRange(originalRange, parent2)) {
                    childIndentationAmount = tryComputeIndentationForListItem(childStartPos, child.end, parentStartLine, originalRange, inheritedIndentation);
                    if (childIndentationAmount !== -1 /* Unknown */ ) inheritedIndentation = childIndentationAmount;
                }
                if (!rangeOverlapsWithStartEnd(originalRange, child.pos, child.end)) {
                    if (child.end < originalRange.pos) formattingScanner.skipToEndOf(child);
                    return inheritedIndentation;
                }
                if (child.getFullWidth() === 0) return inheritedIndentation;
                while(formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end){
                    const tokenInfo = formattingScanner.readTokenInfo(node);
                    if (tokenInfo.token.end > originalRange.end) return inheritedIndentation;
                    if (tokenInfo.token.end > childStartPos) {
                        if (tokenInfo.token.pos > childStartPos) formattingScanner.skipToStartOf(child);
                        break;
                    }
                    consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, node);
                }
                if (!formattingScanner.isOnToken() || formattingScanner.getTokenFullStart() >= originalRange.end) return inheritedIndentation;
                if (isToken(child)) {
                    const tokenInfo = formattingScanner.readTokenInfo(child);
                    if (child.kind !== 12 /* JsxText */ ) {
                        Debug.assert(tokenInfo.token.end === child.end, "Token end is child end");
                        consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, child);
                        return inheritedIndentation;
                    }
                }
                const effectiveParentStartLine = child.kind === 171 /* Decorator */  ? childStartLine : undecoratedParentStartLine;
                const childIndentation = computeIndentation(child, childStartLine, childIndentationAmount, node, parentDynamicIndentation, effectiveParentStartLine);
                processNode(child, childContextNode, childStartLine, undecoratedChildStartLine, childIndentation.indentation, childIndentation.delta);
                childContextNode = node;
                if (isFirstListItem && parent2.kind === 210 /* ArrayLiteralExpression */  && inheritedIndentation === -1 /* Unknown */ ) inheritedIndentation = childIndentation.indentation;
                return inheritedIndentation;
            }
            function processChildNodes(nodes, parent2, parentStartLine, parentDynamicIndentation) {
                Debug.assert(isNodeArray(nodes));
                Debug.assert(!nodeIsSynthesized(nodes));
                const listStartToken = getOpenTokenForList(parent2, nodes);
                let listDynamicIndentation = parentDynamicIndentation;
                let startLine = parentStartLine;
                if (!rangeOverlapsWithStartEnd(originalRange, nodes.pos, nodes.end)) {
                    if (nodes.end < originalRange.pos) formattingScanner.skipToEndOf(nodes);
                    return;
                }
                if (listStartToken !== 0 /* Unknown */ ) while(formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end){
                    const tokenInfo = formattingScanner.readTokenInfo(parent2);
                    if (tokenInfo.token.end > nodes.pos) break;
                    else if (tokenInfo.token.kind === listStartToken) {
                        startLine = sourceFile.getLineAndCharacterOfPosition(tokenInfo.token.pos).line;
                        consumeTokenAndAdvanceScanner(tokenInfo, parent2, parentDynamicIndentation, parent2);
                        let indentationOnListStartToken;
                        if (indentationOnLastIndentedLine !== -1 /* Unknown */ ) indentationOnListStartToken = indentationOnLastIndentedLine;
                        else {
                            const startLinePosition = getLineStartPositionForPosition(tokenInfo.token.pos, sourceFile);
                            indentationOnListStartToken = SmartIndenter.findFirstNonWhitespaceColumn(startLinePosition, tokenInfo.token.pos, sourceFile, options);
                        }
                        listDynamicIndentation = getDynamicIndentation(parent2, parentStartLine, indentationOnListStartToken, options.indentSize);
                    } else consumeTokenAndAdvanceScanner(tokenInfo, parent2, parentDynamicIndentation, parent2);
                }
                let inheritedIndentation = -1 /* Unknown */ ;
                for(let i = 0; i < nodes.length; i++){
                    const child = nodes[i];
                    inheritedIndentation = processChildNode(child, inheritedIndentation, node, listDynamicIndentation, startLine, startLine, /*isListItem*/ true, /*isFirstListItem*/ i === 0);
                }
                const listEndToken = getCloseTokenForOpenToken(listStartToken);
                if (listEndToken !== 0 /* Unknown */  && formattingScanner.isOnToken() && formattingScanner.getTokenFullStart() < originalRange.end) {
                    let tokenInfo = formattingScanner.readTokenInfo(parent2);
                    if (tokenInfo.token.kind === 28 /* CommaToken */ ) {
                        consumeTokenAndAdvanceScanner(tokenInfo, parent2, listDynamicIndentation, parent2);
                        tokenInfo = formattingScanner.isOnToken() ? formattingScanner.readTokenInfo(parent2) : void 0;
                    }
                    if (tokenInfo && tokenInfo.token.kind === listEndToken && rangeContainsRange(parent2, tokenInfo.token)) consumeTokenAndAdvanceScanner(tokenInfo, parent2, listDynamicIndentation, parent2, /*isListEndToken*/ true);
                }
            }
            function consumeTokenAndAdvanceScanner(currentTokenInfo, parent2, dynamicIndentation, container, isListEndToken) {
                Debug.assert(rangeContainsRange(parent2, currentTokenInfo.token));
                const lastTriviaWasNewLine = formattingScanner.lastTrailingTriviaWasNewLine();
                let indentToken = false;
                if (currentTokenInfo.leadingTrivia) processTrivia(currentTokenInfo.leadingTrivia, parent2, childContextNode, dynamicIndentation);
                let lineAction = 0 /* None */ ;
                const isTokenInRange = rangeContainsRange(originalRange, currentTokenInfo.token);
                const tokenStart = sourceFile.getLineAndCharacterOfPosition(currentTokenInfo.token.pos);
                if (isTokenInRange) {
                    const rangeHasError = rangeContainsError(currentTokenInfo.token);
                    const savePreviousRange = previousRange;
                    lineAction = processRange(currentTokenInfo.token, tokenStart, parent2, childContextNode, dynamicIndentation);
                    if (!rangeHasError) {
                        if (lineAction === 0 /* None */ ) {
                            const prevEndLine = savePreviousRange && sourceFile.getLineAndCharacterOfPosition(savePreviousRange.end).line;
                            indentToken = lastTriviaWasNewLine && tokenStart.line !== prevEndLine;
                        } else indentToken = lineAction === 1 /* LineAdded */ ;
                    }
                }
                if (currentTokenInfo.trailingTrivia) {
                    previousRangeTriviaEnd = last(currentTokenInfo.trailingTrivia).end;
                    processTrivia(currentTokenInfo.trailingTrivia, parent2, childContextNode, dynamicIndentation);
                }
                if (indentToken) {
                    const tokenIndentation = isTokenInRange && !rangeContainsError(currentTokenInfo.token) ? dynamicIndentation.getIndentationForToken(tokenStart.line, currentTokenInfo.token.kind, container, !!isListEndToken) : -1 /* Unknown */ ;
                    let indentNextTokenOrTrivia = true;
                    if (currentTokenInfo.leadingTrivia) {
                        const commentIndentation = dynamicIndentation.getIndentationForComment(currentTokenInfo.token.kind, tokenIndentation, container);
                        indentNextTokenOrTrivia = indentTriviaItems(currentTokenInfo.leadingTrivia, commentIndentation, indentNextTokenOrTrivia, (item)=>insertIndentation(item.pos, commentIndentation, /*lineAdded*/ false));
                    }
                    if (tokenIndentation !== -1 /* Unknown */  && indentNextTokenOrTrivia) {
                        insertIndentation(currentTokenInfo.token.pos, tokenIndentation, lineAction === 1 /* LineAdded */ );
                        lastIndentedLine = tokenStart.line;
                        indentationOnLastIndentedLine = tokenIndentation;
                    }
                }
                formattingScanner.advance();
                childContextNode = parent2;
            }
        }
        function indentTriviaItems(trivia, commentIndentation, indentNextTokenOrTrivia, indentSingleLine) {
            for (const triviaItem of trivia){
                const triviaInRange = rangeContainsRange(originalRange, triviaItem);
                switch(triviaItem.kind){
                    case 3 /* MultiLineCommentTrivia */ :
                        if (triviaInRange) indentMultilineComment(triviaItem, commentIndentation, /*firstLineIsIndented*/ !indentNextTokenOrTrivia);
                        indentNextTokenOrTrivia = false;
                        break;
                    case 2 /* SingleLineCommentTrivia */ :
                        if (indentNextTokenOrTrivia && triviaInRange) indentSingleLine(triviaItem);
                        indentNextTokenOrTrivia = false;
                        break;
                    case 4 /* NewLineTrivia */ :
                        indentNextTokenOrTrivia = true;
                        break;
                }
            }
            return indentNextTokenOrTrivia;
        }
        function processTrivia(trivia, parent2, contextNode, dynamicIndentation) {
            for (const triviaItem of trivia)if (isComment(triviaItem.kind) && rangeContainsRange(originalRange, triviaItem)) {
                const triviaItemStart = sourceFile.getLineAndCharacterOfPosition(triviaItem.pos);
                processRange(triviaItem, triviaItemStart, parent2, contextNode, dynamicIndentation);
            }
        }
        function processRange(range, rangeStart, parent2, contextNode, dynamicIndentation) {
            const rangeHasError = rangeContainsError(range);
            let lineAction = 0 /* None */ ;
            if (!rangeHasError) {
                if (!previousRange) {
                    const originalStart = sourceFile.getLineAndCharacterOfPosition(originalRange.pos);
                    trimTrailingWhitespacesForLines(originalStart.line, rangeStart.line);
                } else lineAction = processPair(range, rangeStart.line, parent2, previousRange, previousRangeStartLine, previousParent, contextNode, dynamicIndentation);
            }
            previousRange = range;
            previousRangeTriviaEnd = range.end;
            previousParent = parent2;
            previousRangeStartLine = rangeStart.line;
            return lineAction;
        }
        function processPair(currentItem, currentStartLine, currentParent, previousItem, previousStartLine, previousParent2, contextNode, dynamicIndentation) {
            formattingContext.updateContext(previousItem, previousParent2, currentItem, currentParent, contextNode);
            const rules = getRules(formattingContext);
            let trimTrailingWhitespaces = formattingContext.options.trimTrailingWhitespace !== false;
            let lineAction = 0 /* None */ ;
            if (rules) forEachRight(rules, (rule2)=>{
                lineAction = applyRuleEdits(rule2, previousItem, previousStartLine, currentItem, currentStartLine);
                if (dynamicIndentation) switch(lineAction){
                    case 2 /* LineRemoved */ :
                        if (currentParent.getStart(sourceFile) === currentItem.pos) dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ false, contextNode);
                        break;
                    case 1 /* LineAdded */ :
                        if (currentParent.getStart(sourceFile) === currentItem.pos) dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ true, contextNode);
                        break;
                    default:
                        Debug.assert(lineAction === 0 /* None */ );
                }
                trimTrailingWhitespaces = trimTrailingWhitespaces && !(rule2.action & 16 /* DeleteSpace */ ) && rule2.flags !== 1 /* CanDeleteNewLines */ ;
            });
            else trimTrailingWhitespaces = trimTrailingWhitespaces && currentItem.kind !== 1 /* EndOfFileToken */ ;
            if (currentStartLine !== previousStartLine && trimTrailingWhitespaces) trimTrailingWhitespacesForLines(previousStartLine, currentStartLine, previousItem);
            return lineAction;
        }
        function insertIndentation(pos, indentation, lineAdded) {
            const indentationString = getIndentationString(indentation, options);
            if (lineAdded) recordReplace(pos, 0, indentationString);
            else {
                const tokenStart = sourceFile.getLineAndCharacterOfPosition(pos);
                const startLinePosition = getStartPositionOfLine(tokenStart.line, sourceFile);
                if (indentation !== characterToColumn(startLinePosition, tokenStart.character) || indentationIsDifferent(indentationString, startLinePosition)) recordReplace(startLinePosition, tokenStart.character, indentationString);
            }
        }
        function characterToColumn(startLinePosition, characterInLine) {
            let column = 0;
            for(let i = 0; i < characterInLine; i++)if (sourceFile.text.charCodeAt(startLinePosition + i) === 9 /* tab */ ) column += options.tabSize - column % options.tabSize;
            else column++;
            return column;
        }
        function indentationIsDifferent(indentationString, startLinePosition) {
            return indentationString !== sourceFile.text.substr(startLinePosition, indentationString.length);
        }
        function indentMultilineComment(commentRange, indentation, firstLineIsIndented, indentFinalLine = true) {
            let startLine = sourceFile.getLineAndCharacterOfPosition(commentRange.pos).line;
            const endLine = sourceFile.getLineAndCharacterOfPosition(commentRange.end).line;
            if (startLine === endLine) {
                if (!firstLineIsIndented) insertIndentation(commentRange.pos, indentation, /*lineAdded*/ false);
                return;
            }
            const parts = [];
            let startPos = commentRange.pos;
            for(let line = startLine; line < endLine; line++){
                const endOfLine = getEndLinePosition(line, sourceFile);
                parts.push({
                    pos: startPos,
                    end: endOfLine
                });
                startPos = getStartPositionOfLine(line + 1, sourceFile);
            }
            if (indentFinalLine) parts.push({
                pos: startPos,
                end: commentRange.end
            });
            if (parts.length === 0) return;
            const startLinePos = getStartPositionOfLine(startLine, sourceFile);
            const nonWhitespaceColumnInFirstPart = SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(startLinePos, parts[0].pos, sourceFile, options);
            let startIndex = 0;
            if (firstLineIsIndented) {
                startIndex = 1;
                startLine++;
            }
            const delta2 = indentation - nonWhitespaceColumnInFirstPart.column;
            for(let i = startIndex; i < parts.length; i++, startLine++){
                const startLinePos2 = getStartPositionOfLine(startLine, sourceFile);
                const nonWhitespaceCharacterAndColumn = i === 0 ? nonWhitespaceColumnInFirstPart : SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(parts[i].pos, parts[i].end, sourceFile, options);
                const newIndentation = nonWhitespaceCharacterAndColumn.column + delta2;
                if (newIndentation > 0) {
                    const indentationString = getIndentationString(newIndentation, options);
                    recordReplace(startLinePos2, nonWhitespaceCharacterAndColumn.character, indentationString);
                } else recordDelete(startLinePos2, nonWhitespaceCharacterAndColumn.character);
            }
        }
        function trimTrailingWhitespacesForLines(line1, line2, range) {
            for(let line = line1; line < line2; line++){
                const lineStartPosition = getStartPositionOfLine(line, sourceFile);
                const lineEndPosition = getEndLinePosition(line, sourceFile);
                if (range && (isComment(range.kind) || isStringOrRegularExpressionOrTemplateLiteral(range.kind)) && range.pos <= lineEndPosition && range.end > lineEndPosition) continue;
                const whitespaceStart = getTrailingWhitespaceStartPosition(lineStartPosition, lineEndPosition);
                if (whitespaceStart !== -1) {
                    Debug.assert(whitespaceStart === lineStartPosition || !isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(whitespaceStart - 1)));
                    recordDelete(whitespaceStart, lineEndPosition + 1 - whitespaceStart);
                }
            }
        }
        function getTrailingWhitespaceStartPosition(start, end) {
            let pos = end;
            while(pos >= start && isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(pos)))pos--;
            if (pos !== end) return pos + 1;
            return -1;
        }
        function trimTrailingWhitespacesForRemainingRange(trivias) {
            let startPos = previousRange ? previousRange.end : originalRange.pos;
            for (const trivia of trivias)if (isComment(trivia.kind)) {
                if (startPos < trivia.pos) trimTrailingWitespacesForPositions(startPos, trivia.pos - 1, previousRange);
                startPos = trivia.end + 1;
            }
            if (startPos < originalRange.end) trimTrailingWitespacesForPositions(startPos, originalRange.end, previousRange);
        }
        function trimTrailingWitespacesForPositions(startPos, endPos, previousRange2) {
            const startLine = sourceFile.getLineAndCharacterOfPosition(startPos).line;
            const endLine = sourceFile.getLineAndCharacterOfPosition(endPos).line;
            trimTrailingWhitespacesForLines(startLine, endLine + 1, previousRange2);
        }
        function recordDelete(start, len) {
            if (len) edits.push(createTextChangeFromStartLength(start, len, ""));
        }
        function recordReplace(start, len, newText) {
            if (len || newText) edits.push(createTextChangeFromStartLength(start, len, newText));
        }
        function recordInsert(start, text) {
            if (text) edits.push(createTextChangeFromStartLength(start, 0, text));
        }
        function applyRuleEdits(rule2, previousRange2, previousStartLine, currentRange, currentStartLine) {
            const onLaterLine = currentStartLine !== previousStartLine;
            switch(rule2.action){
                case 1 /* StopProcessingSpaceActions */ :
                    return 0 /* None */ ;
                case 16 /* DeleteSpace */ :
                    if (previousRange2.end !== currentRange.pos) {
                        recordDelete(previousRange2.end, currentRange.pos - previousRange2.end);
                        return onLaterLine ? 2 /* LineRemoved */  : 0 /* None */ ;
                    }
                    break;
                case 32 /* DeleteToken */ :
                    recordDelete(previousRange2.pos, previousRange2.end - previousRange2.pos);
                    break;
                case 8 /* InsertNewLine */ :
                    if (rule2.flags !== 1 /* CanDeleteNewLines */  && previousStartLine !== currentStartLine) return 0 /* None */ ;
                    const lineDelta = currentStartLine - previousStartLine;
                    if (lineDelta !== 1) {
                        recordReplace(previousRange2.end, currentRange.pos - previousRange2.end, getNewLineOrDefaultFromHost(host, options));
                        return onLaterLine ? 0 /* None */  : 1 /* LineAdded */ ;
                    }
                    break;
                case 4 /* InsertSpace */ :
                    if (rule2.flags !== 1 /* CanDeleteNewLines */  && previousStartLine !== currentStartLine) return 0 /* None */ ;
                    const posDelta = currentRange.pos - previousRange2.end;
                    if (posDelta !== 1 || sourceFile.text.charCodeAt(previousRange2.end) !== 32 /* space */ ) {
                        recordReplace(previousRange2.end, currentRange.pos - previousRange2.end, " ");
                        return onLaterLine ? 2 /* LineRemoved */  : 0 /* None */ ;
                    }
                    break;
                case 64 /* InsertTrailingSemicolon */ :
                    recordInsert(previousRange2.end, ";");
            }
            return 0 /* None */ ;
        }
    }
    function getRangeOfEnclosingComment(sourceFile, position, precedingToken, tokenAtPosition = getTokenAtPosition(sourceFile, position)) {
        const jsdoc = findAncestor(tokenAtPosition, isJSDoc);
        if (jsdoc) tokenAtPosition = jsdoc.parent;
        const tokenStart = tokenAtPosition.getStart(sourceFile);
        if (tokenStart <= position && position < tokenAtPosition.getEnd()) return void 0;
        precedingToken = precedingToken === null ? void 0 : precedingToken === void 0 ? findPrecedingToken(position, sourceFile) : precedingToken;
        const trailingRangesOfPreviousToken = precedingToken && getTrailingCommentRanges(sourceFile.text, precedingToken.end);
        const leadingCommentRangesOfNextToken = getLeadingCommentRangesOfNode(tokenAtPosition, sourceFile);
        const commentRanges = concatenate(trailingRangesOfPreviousToken, leadingCommentRangesOfNextToken);
        return commentRanges && find(commentRanges, (range)=>rangeContainsPositionExclusive(range, position) || // The end marker of a single-line comment does not include the newline character.
            // With caret at `^`, in the following case, we are inside a comment (^ denotes the cursor position):
            //
            //    // asdf   ^\n
            //
            // But for closed multi-line comments, we don't want to be inside the comment in the following case:
            //
            //    /* asdf */^
            //
            // However, unterminated multi-line comments *do* contain their end.
            //
            // Internally, we represent the end of the comment at the newline and closing '/', respectively.
            //
            position === range.end && (range.kind === 2 /* SingleLineCommentTrivia */  || position === sourceFile.getFullWidth()));
    }
    function getOpenTokenForList(node, list) {
        switch(node.kind){
            case 177 /* Constructor */ :
            case 263 /* FunctionDeclaration */ :
            case 219 /* FunctionExpression */ :
            case 175 /* MethodDeclaration */ :
            case 174 /* MethodSignature */ :
            case 220 /* ArrowFunction */ :
            case 180 /* CallSignature */ :
            case 181 /* ConstructSignature */ :
            case 185 /* FunctionType */ :
            case 186 /* ConstructorType */ :
            case 178 /* GetAccessor */ :
            case 179 /* SetAccessor */ :
                if (node.typeParameters === list) return 30 /* LessThanToken */ ;
                else if (node.parameters === list) return 21 /* OpenParenToken */ ;
                break;
            case 214 /* CallExpression */ :
            case 215 /* NewExpression */ :
                if (node.typeArguments === list) return 30 /* LessThanToken */ ;
                else if (node.arguments === list) return 21 /* OpenParenToken */ ;
                break;
            case 264 /* ClassDeclaration */ :
            case 232 /* ClassExpression */ :
            case 265 /* InterfaceDeclaration */ :
            case 266 /* TypeAliasDeclaration */ :
                if (node.typeParameters === list) return 30 /* LessThanToken */ ;
                break;
            case 184 /* TypeReference */ :
            case 216 /* TaggedTemplateExpression */ :
            case 187 /* TypeQuery */ :
            case 234 /* ExpressionWithTypeArguments */ :
            case 206 /* ImportType */ :
                if (node.typeArguments === list) return 30 /* LessThanToken */ ;
                break;
            case 188 /* TypeLiteral */ :
                return 19 /* OpenBraceToken */ ;
        }
        return 0 /* Unknown */ ;
    }
    function getCloseTokenForOpenToken(kind) {
        switch(kind){
            case 21 /* OpenParenToken */ :
                return 22 /* CloseParenToken */ ;
            case 30 /* LessThanToken */ :
                return 32 /* GreaterThanToken */ ;
            case 19 /* OpenBraceToken */ :
                return 20 /* CloseBraceToken */ ;
        }
        return 0 /* Unknown */ ;
    }
    var internedSizes;
    var internedTabsIndentation;
    var internedSpacesIndentation;
    function getIndentationString(indentation, options) {
        const resetInternedStrings = !internedSizes || internedSizes.tabSize !== options.tabSize || internedSizes.indentSize !== options.indentSize;
        if (resetInternedStrings) {
            internedSizes = {
                tabSize: options.tabSize,
                indentSize: options.indentSize
            };
            internedTabsIndentation = internedSpacesIndentation = void 0;
        }
        if (!options.convertTabsToSpaces) {
            const tabs = Math.floor(indentation / options.tabSize);
            const spaces = indentation - tabs * options.tabSize;
            let tabString;
            if (!internedTabsIndentation) internedTabsIndentation = [];
            if (internedTabsIndentation[tabs] === void 0) internedTabsIndentation[tabs] = tabString = repeatString("	", tabs);
            else tabString = internedTabsIndentation[tabs];
            return spaces ? tabString + repeatString(" ", spaces) : tabString;
        } else {
            let spacesString;
            const quotient = Math.floor(indentation / options.indentSize);
            const remainder = indentation % options.indentSize;
            if (!internedSpacesIndentation) internedSpacesIndentation = [];
            if (internedSpacesIndentation[quotient] === void 0) {
                spacesString = repeatString(" ", options.indentSize * quotient);
                internedSpacesIndentation[quotient] = spacesString;
            } else spacesString = internedSpacesIndentation[quotient];
            return remainder ? spacesString + repeatString(" ", remainder) : spacesString;
        }
    }
    // src/services/formatting/smartIndenter.ts
    var SmartIndenter;
    ((SmartIndenter2)=>{
        let Value;
        ((Value2)=>{
            Value2[Value2["Unknown"] = -1] = "Unknown";
        })(Value || (Value = {}));
        function getIndentation(position, sourceFile, options, assumeNewLineBeforeCloseBrace = false) {
            if (position > sourceFile.text.length) return getBaseIndentation(options);
            if (options.indentStyle === 0 /* None */ ) return 0;
            const precedingToken = findPrecedingToken(position, sourceFile, /*startNode*/ void 0, /*excludeJsdoc*/ true);
            const enclosingCommentRange = getRangeOfEnclosingComment(sourceFile, position, precedingToken || null);
            if (enclosingCommentRange && enclosingCommentRange.kind === 3 /* MultiLineCommentTrivia */ ) return getCommentIndent(sourceFile, position, options, enclosingCommentRange);
            if (!precedingToken) return getBaseIndentation(options);
            const precedingTokenIsLiteral = isStringOrRegularExpressionOrTemplateLiteral(precedingToken.kind);
            if (precedingTokenIsLiteral && precedingToken.getStart(sourceFile) <= position && position < precedingToken.end) return 0;
            const lineAtPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
            const currentToken = getTokenAtPosition(sourceFile, position);
            const isObjectLiteral = currentToken.kind === 19 /* OpenBraceToken */  && currentToken.parent.kind === 211 /* ObjectLiteralExpression */ ;
            if (options.indentStyle === 1 /* Block */  || isObjectLiteral) return getBlockIndent(sourceFile, position, options);
            if (precedingToken.kind === 28 /* CommaToken */  && precedingToken.parent.kind !== 227 /* BinaryExpression */ ) {
                const actualIndentation = getActualIndentationForListItemBeforeComma(precedingToken, sourceFile, options);
                if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation;
            }
            const containerList = getListByPosition(position, precedingToken.parent, sourceFile);
            if (containerList && !rangeContainsRange(containerList, precedingToken)) {
                const useTheSameBaseIndentation = [
                    219 /* FunctionExpression */ ,
                    220 /* ArrowFunction */ 
                ].includes(currentToken.parent.kind);
                const indentSize = useTheSameBaseIndentation ? 0 : options.indentSize;
                return getActualIndentationForListStartLine(containerList, sourceFile, options) + indentSize;
            }
            return getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options);
        }
        SmartIndenter2.getIndentation = getIndentation;
        function getCommentIndent(sourceFile, position, options, enclosingCommentRange) {
            const previousLine = getLineAndCharacterOfPosition(sourceFile, position).line - 1;
            const commentStartLine = getLineAndCharacterOfPosition(sourceFile, enclosingCommentRange.pos).line;
            Debug.assert(commentStartLine >= 0);
            if (previousLine <= commentStartLine) return findFirstNonWhitespaceColumn(getStartPositionOfLine(commentStartLine, sourceFile), position, sourceFile, options);
            const startPositionOfLine = getStartPositionOfLine(previousLine, sourceFile);
            const { column, character } = findFirstNonWhitespaceCharacterAndColumn(startPositionOfLine, position, sourceFile, options);
            if (column === 0) return column;
            const firstNonWhitespaceCharacterCode = sourceFile.text.charCodeAt(startPositionOfLine + character);
            return firstNonWhitespaceCharacterCode === 42 /* asterisk */  ? column - 1 : column;
        }
        function getBlockIndent(sourceFile, position, options) {
            let current = position;
            while(current > 0){
                const char = sourceFile.text.charCodeAt(current);
                if (!isWhiteSpaceLike(char)) break;
                current--;
            }
            const lineStart = getLineStartPositionForPosition(current, sourceFile);
            return findFirstNonWhitespaceColumn(lineStart, current, sourceFile, options);
        }
        function getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options) {
            let previous;
            let current = precedingToken;
            while(current){
                if (positionBelongsToNode(current, position, sourceFile) && shouldIndentChildNode(options, current, previous, sourceFile, /*isNextChild*/ true)) {
                    const currentStart = getStartLineAndCharacterForNode(current, sourceFile);
                    const nextTokenKind = nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile);
                    const indentationDelta = nextTokenKind !== 0 /* Unknown */  ? assumeNewLineBeforeCloseBrace && nextTokenKind === 2 /* CloseBrace */  ? options.indentSize : 0 : lineAtPosition !== currentStart.line ? options.indentSize : 0;
                    return getIndentationForNodeWorker(current, currentStart, /*ignoreActualIndentationRange*/ void 0, indentationDelta, sourceFile, /*isNextChild*/ true, options);
                }
                const actualIndentation = getActualIndentationForListItem(current, sourceFile, options, /*listIndentsChild*/ true);
                if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation;
                previous = current;
                current = current.parent;
            }
            return getBaseIndentation(options);
        }
        function getIndentationForNode(n, ignoreActualIndentationRange, sourceFile, options) {
            const start = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
            return getIndentationForNodeWorker(n, start, ignoreActualIndentationRange, /*indentationDelta*/ 0, sourceFile, /*isNextChild*/ false, options);
        }
        SmartIndenter2.getIndentationForNode = getIndentationForNode;
        function getBaseIndentation(options) {
            return options.baseIndentSize || 0;
        }
        SmartIndenter2.getBaseIndentation = getBaseIndentation;
        function getIndentationForNodeWorker(current, currentStart, ignoreActualIndentationRange, indentationDelta, sourceFile, isNextChild, options) {
            var _a;
            let parent2 = current.parent;
            while(parent2){
                let useActualIndentation = true;
                if (ignoreActualIndentationRange) {
                    const start = current.getStart(sourceFile);
                    useActualIndentation = start < ignoreActualIndentationRange.pos || start > ignoreActualIndentationRange.end;
                }
                const containingListOrParentStart = getContainingListOrParentStart(parent2, current, sourceFile);
                const parentAndChildShareLine = containingListOrParentStart.line === currentStart.line || childStartsOnTheSameLineWithElseInIfStatement(parent2, current, currentStart.line, sourceFile);
                if (useActualIndentation) {
                    const firstListChild = (_a = getContainingList(current, sourceFile)) == null ? void 0 : _a[0];
                    const listIndentsChild = !!firstListChild && getStartLineAndCharacterForNode(firstListChild, sourceFile).line > containingListOrParentStart.line;
                    let actualIndentation = getActualIndentationForListItem(current, sourceFile, options, listIndentsChild);
                    if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation + indentationDelta;
                    actualIndentation = getActualIndentationForNode(current, parent2, currentStart, parentAndChildShareLine, sourceFile, options);
                    if (actualIndentation !== -1 /* Unknown */ ) return actualIndentation + indentationDelta;
                }
                if (shouldIndentChildNode(options, parent2, current, sourceFile, isNextChild) && !parentAndChildShareLine) indentationDelta += options.indentSize;
                const useTrueStart = isArgumentAndStartLineOverlapsExpressionBeingCalled(parent2, current, currentStart.line, sourceFile);
                current = parent2;
                parent2 = current.parent;
                currentStart = useTrueStart ? sourceFile.getLineAndCharacterOfPosition(current.getStart(sourceFile)) : containingListOrParentStart;
            }
            return indentationDelta + getBaseIndentation(options);
        }
        function getContainingListOrParentStart(parent2, child, sourceFile) {
            const containingList = getContainingList(child, sourceFile);
            const startPos = containingList ? containingList.pos : parent2.getStart(sourceFile);
            return sourceFile.getLineAndCharacterOfPosition(startPos);
        }
        function getActualIndentationForListItemBeforeComma(commaToken, sourceFile, options) {
            const commaItemInfo = findListItemInfo(commaToken);
            if (commaItemInfo && commaItemInfo.listItemIndex > 0) return deriveActualIndentationFromList(commaItemInfo.list.getChildren(), commaItemInfo.listItemIndex - 1, sourceFile, options);
            else return -1 /* Unknown */ ;
        }
        function getActualIndentationForNode(current, parent2, currentLineAndChar, parentAndChildShareLine, sourceFile, options) {
            const useActualIndentation = (isDeclaration(current) || isStatementButNotDeclaration(current)) && (parent2.kind === 308 /* SourceFile */  || !parentAndChildShareLine);
            if (!useActualIndentation) return -1 /* Unknown */ ;
            return findColumnForFirstNonWhitespaceCharacterInLine(currentLineAndChar, sourceFile, options);
        }
        let NextTokenKind;
        ((NextTokenKind2)=>{
            NextTokenKind2[NextTokenKind2["Unknown"] = 0] = "Unknown";
            NextTokenKind2[NextTokenKind2["OpenBrace"] = 1] = "OpenBrace";
            NextTokenKind2[NextTokenKind2["CloseBrace"] = 2] = "CloseBrace";
        })(NextTokenKind || (NextTokenKind = {}));
        function nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile) {
            const nextToken = findNextToken(precedingToken, current, sourceFile);
            if (!nextToken) return 0 /* Unknown */ ;
            if (nextToken.kind === 19 /* OpenBraceToken */ ) return 1 /* OpenBrace */ ;
            else if (nextToken.kind === 20 /* CloseBraceToken */ ) {
                const nextTokenStartLine = getStartLineAndCharacterForNode(nextToken, sourceFile).line;
                return lineAtPosition === nextTokenStartLine ? 2 /* CloseBrace */  : 0 /* Unknown */ ;
            }
            return 0 /* Unknown */ ;
        }
        function getStartLineAndCharacterForNode(n, sourceFile) {
            return sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
        }
        function isArgumentAndStartLineOverlapsExpressionBeingCalled(parent2, child, childStartLine, sourceFile) {
            if (!(isCallExpression(parent2) && contains(parent2.arguments, child))) return false;
            const expressionOfCallExpressionEnd = parent2.expression.getEnd();
            const expressionOfCallExpressionEndLine = getLineAndCharacterOfPosition(sourceFile, expressionOfCallExpressionEnd).line;
            return expressionOfCallExpressionEndLine === childStartLine;
        }
        SmartIndenter2.isArgumentAndStartLineOverlapsExpressionBeingCalled = isArgumentAndStartLineOverlapsExpressionBeingCalled;
        function childStartsOnTheSameLineWithElseInIfStatement(parent2, child, childStartLine, sourceFile) {
            if (parent2.kind === 246 /* IfStatement */  && parent2.elseStatement === child) {
                const elseKeyword = findChildOfKind(parent2, 93 /* ElseKeyword */ , sourceFile);
                Debug.assert(elseKeyword !== void 0);
                const elseKeywordStartLine = getStartLineAndCharacterForNode(elseKeyword, sourceFile).line;
                return elseKeywordStartLine === childStartLine;
            }
            return false;
        }
        SmartIndenter2.childStartsOnTheSameLineWithElseInIfStatement = childStartsOnTheSameLineWithElseInIfStatement;
        function childIsUnindentedBranchOfConditionalExpression(parent2, child, childStartLine, sourceFile) {
            if (isConditionalExpression(parent2) && (child === parent2.whenTrue || child === parent2.whenFalse)) {
                const conditionEndLine = getLineAndCharacterOfPosition(sourceFile, parent2.condition.end).line;
                if (child === parent2.whenTrue) return childStartLine === conditionEndLine;
                else {
                    const trueStartLine = getStartLineAndCharacterForNode(parent2.whenTrue, sourceFile).line;
                    const trueEndLine = getLineAndCharacterOfPosition(sourceFile, parent2.whenTrue.end).line;
                    return conditionEndLine === trueStartLine && trueEndLine === childStartLine;
                }
            }
            return false;
        }
        SmartIndenter2.childIsUnindentedBranchOfConditionalExpression = childIsUnindentedBranchOfConditionalExpression;
        function argumentStartsOnSameLineAsPreviousArgument(parent2, child, childStartLine, sourceFile) {
            if (isCallOrNewExpression(parent2)) {
                if (!parent2.arguments) return false;
                const currentNode = find(parent2.arguments, (arg)=>arg.pos === child.pos);
                if (!currentNode) return false;
                const currentIndex = parent2.arguments.indexOf(currentNode);
                if (currentIndex === 0) return false;
                const previousNode = parent2.arguments[currentIndex - 1];
                const lineOfPreviousNode = getLineAndCharacterOfPosition(sourceFile, previousNode.getEnd()).line;
                if (childStartLine === lineOfPreviousNode) return true;
            }
            return false;
        }
        SmartIndenter2.argumentStartsOnSameLineAsPreviousArgument = argumentStartsOnSameLineAsPreviousArgument;
        function getContainingList(node, sourceFile) {
            return node.parent && getListByRange(node.getStart(sourceFile), node.getEnd(), node.parent, sourceFile);
        }
        SmartIndenter2.getContainingList = getContainingList;
        function getListByPosition(pos, node, sourceFile) {
            return node && getListByRange(pos, pos, node, sourceFile);
        }
        function getListByRange(start, end, node, sourceFile) {
            switch(node.kind){
                case 184 /* TypeReference */ :
                    return getList(node.typeArguments);
                case 211 /* ObjectLiteralExpression */ :
                    return getList(node.properties);
                case 210 /* ArrayLiteralExpression */ :
                    return getList(node.elements);
                case 188 /* TypeLiteral */ :
                    return getList(node.members);
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 220 /* ArrowFunction */ :
                case 175 /* MethodDeclaration */ :
                case 174 /* MethodSignature */ :
                case 180 /* CallSignature */ :
                case 177 /* Constructor */ :
                case 186 /* ConstructorType */ :
                case 181 /* ConstructSignature */ :
                    return getList(node.typeParameters) || getList(node.parameters);
                case 178 /* GetAccessor */ :
                    return getList(node.parameters);
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                case 265 /* InterfaceDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 346 /* JSDocTemplateTag */ :
                    return getList(node.typeParameters);
                case 215 /* NewExpression */ :
                case 214 /* CallExpression */ :
                    return getList(node.typeArguments) || getList(node.arguments);
                case 262 /* VariableDeclarationList */ :
                    return getList(node.declarations);
                case 276 /* NamedImports */ :
                case 280 /* NamedExports */ :
                    return getList(node.elements);
                case 207 /* ObjectBindingPattern */ :
                case 208 /* ArrayBindingPattern */ :
                    return getList(node.elements);
            }
            function getList(list) {
                return list && rangeContainsStartEnd(getVisualListRange(node, list, sourceFile), start, end) ? list : void 0;
            }
        }
        function getVisualListRange(node, list, sourceFile) {
            const children = node.getChildren(sourceFile);
            for(let i = 1; i < children.length - 1; i++){
                if (children[i].pos === list.pos && children[i].end === list.end) return {
                    pos: children[i - 1].end,
                    end: children[i + 1].getStart(sourceFile)
                };
            }
            return list;
        }
        function getActualIndentationForListStartLine(list, sourceFile, options) {
            if (!list) return -1 /* Unknown */ ;
            return findColumnForFirstNonWhitespaceCharacterInLine(sourceFile.getLineAndCharacterOfPosition(list.pos), sourceFile, options);
        }
        function getActualIndentationForListItem(node, sourceFile, options, listIndentsChild) {
            if (node.parent && node.parent.kind === 262 /* VariableDeclarationList */ ) return -1 /* Unknown */ ;
            const containingList = getContainingList(node, sourceFile);
            if (containingList) {
                const index = containingList.indexOf(node);
                if (index !== -1) {
                    const result = deriveActualIndentationFromList(containingList, index, sourceFile, options);
                    if (result !== -1 /* Unknown */ ) return result;
                }
                return getActualIndentationForListStartLine(containingList, sourceFile, options) + (listIndentsChild ? options.indentSize : 0);
            }
            return -1 /* Unknown */ ;
        }
        function deriveActualIndentationFromList(list, index, sourceFile, options) {
            Debug.assert(index >= 0 && index < list.length);
            const node = list[index];
            let lineAndCharacter = getStartLineAndCharacterForNode(node, sourceFile);
            for(let i = index - 1; i >= 0; i--){
                if (list[i].kind === 28 /* CommaToken */ ) continue;
                const prevEndLine = sourceFile.getLineAndCharacterOfPosition(list[i].end).line;
                if (prevEndLine !== lineAndCharacter.line) return findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options);
                lineAndCharacter = getStartLineAndCharacterForNode(list[i], sourceFile);
            }
            return -1 /* Unknown */ ;
        }
        function findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options) {
            const lineStart = sourceFile.getPositionOfLineAndCharacter(lineAndCharacter.line, 0);
            return findFirstNonWhitespaceColumn(lineStart, lineStart + lineAndCharacter.character, sourceFile, options);
        }
        function findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options) {
            let character = 0;
            let column = 0;
            for(let pos = startPos; pos < endPos; pos++){
                const ch = sourceFile.text.charCodeAt(pos);
                if (!isWhiteSpaceSingleLine(ch)) break;
                if (ch === 9 /* tab */ ) column += options.tabSize + column % options.tabSize;
                else column++;
                character++;
            }
            return {
                column,
                character
            };
        }
        SmartIndenter2.findFirstNonWhitespaceCharacterAndColumn = findFirstNonWhitespaceCharacterAndColumn;
        function findFirstNonWhitespaceColumn(startPos, endPos, sourceFile, options) {
            return findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options).column;
        }
        SmartIndenter2.findFirstNonWhitespaceColumn = findFirstNonWhitespaceColumn;
        function nodeWillIndentChild(settings, parent2, child, sourceFile, indentByDefault) {
            const childKind = child ? child.kind : 0 /* Unknown */ ;
            switch(parent2.kind){
                case 245 /* ExpressionStatement */ :
                case 264 /* ClassDeclaration */ :
                case 232 /* ClassExpression */ :
                case 265 /* InterfaceDeclaration */ :
                case 267 /* EnumDeclaration */ :
                case 266 /* TypeAliasDeclaration */ :
                case 210 /* ArrayLiteralExpression */ :
                case 242 /* Block */ :
                case 269 /* ModuleBlock */ :
                case 211 /* ObjectLiteralExpression */ :
                case 188 /* TypeLiteral */ :
                case 201 /* MappedType */ :
                case 190 /* TupleType */ :
                case 218 /* ParenthesizedExpression */ :
                case 212 /* PropertyAccessExpression */ :
                case 214 /* CallExpression */ :
                case 215 /* NewExpression */ :
                case 244 /* VariableStatement */ :
                case 278 /* ExportAssignment */ :
                case 254 /* ReturnStatement */ :
                case 228 /* ConditionalExpression */ :
                case 208 /* ArrayBindingPattern */ :
                case 207 /* ObjectBindingPattern */ :
                case 287 /* JsxOpeningElement */ :
                case 290 /* JsxOpeningFragment */ :
                case 286 /* JsxSelfClosingElement */ :
                case 295 /* JsxExpression */ :
                case 174 /* MethodSignature */ :
                case 180 /* CallSignature */ :
                case 181 /* ConstructSignature */ :
                case 170 /* Parameter */ :
                case 185 /* FunctionType */ :
                case 186 /* ConstructorType */ :
                case 197 /* ParenthesizedType */ :
                case 216 /* TaggedTemplateExpression */ :
                case 224 /* AwaitExpression */ :
                case 280 /* NamedExports */ :
                case 276 /* NamedImports */ :
                case 282 /* ExportSpecifier */ :
                case 277 /* ImportSpecifier */ :
                case 173 /* PropertyDeclaration */ :
                case 297 /* CaseClause */ :
                case 298 /* DefaultClause */ :
                    return true;
                case 270 /* CaseBlock */ :
                    var _settings_indentSwitchCase;
                    return (_settings_indentSwitchCase = settings.indentSwitchCase) !== null && _settings_indentSwitchCase !== void 0 ? _settings_indentSwitchCase : true;
                case 261 /* VariableDeclaration */ :
                case 304 /* PropertyAssignment */ :
                case 227 /* BinaryExpression */ :
                    if (!settings.indentMultiLineObjectLiteralBeginningOnBlankLine && sourceFile && childKind === 211 /* ObjectLiteralExpression */ ) return rangeIsOnOneLine(sourceFile, child);
                    if (parent2.kind === 227 /* BinaryExpression */  && sourceFile && child && childKind === 285 /* JsxElement */ ) {
                        const parentStartLine = sourceFile.getLineAndCharacterOfPosition(skipTrivia(sourceFile.text, parent2.pos)).line;
                        const childStartLine = sourceFile.getLineAndCharacterOfPosition(skipTrivia(sourceFile.text, child.pos)).line;
                        return parentStartLine !== childStartLine;
                    }
                    if (parent2.kind !== 227 /* BinaryExpression */ ) return true;
                    break;
                case 247 /* DoStatement */ :
                case 248 /* WhileStatement */ :
                case 250 /* ForInStatement */ :
                case 251 /* ForOfStatement */ :
                case 249 /* ForStatement */ :
                case 246 /* IfStatement */ :
                case 263 /* FunctionDeclaration */ :
                case 219 /* FunctionExpression */ :
                case 175 /* MethodDeclaration */ :
                case 177 /* Constructor */ :
                case 178 /* GetAccessor */ :
                case 179 /* SetAccessor */ :
                    return childKind !== 242 /* Block */ ;
                case 220 /* ArrowFunction */ :
                    if (sourceFile && childKind === 218 /* ParenthesizedExpression */ ) return rangeIsOnOneLine(sourceFile, child);
                    return childKind !== 242 /* Block */ ;
                case 279 /* ExportDeclaration */ :
                    return childKind !== 280 /* NamedExports */ ;
                case 273 /* ImportDeclaration */ :
                    return childKind !== 274 /* ImportClause */  || !!child.namedBindings && child.namedBindings.kind !== 276 /* NamedImports */ ;
                case 285 /* JsxElement */ :
                    return childKind !== 288 /* JsxClosingElement */ ;
                case 289 /* JsxFragment */ :
                    return childKind !== 291 /* JsxClosingFragment */ ;
                case 194 /* IntersectionType */ :
                case 193 /* UnionType */ :
                case 239 /* SatisfiesExpression */ :
                    if (childKind === 188 /* TypeLiteral */  || childKind === 190 /* TupleType */  || childKind === 201 /* MappedType */ ) return false;
                    break;
                case 259 /* TryStatement */ :
                    if (childKind === 242 /* Block */ ) return false;
                    break;
            }
            return indentByDefault;
        }
        SmartIndenter2.nodeWillIndentChild = nodeWillIndentChild;
        function isControlFlowEndingStatement(kind, parent2) {
            switch(kind){
                case 254 /* ReturnStatement */ :
                case 258 /* ThrowStatement */ :
                case 252 /* ContinueStatement */ :
                case 253 /* BreakStatement */ :
                    return parent2.kind !== 242 /* Block */ ;
                default:
                    return false;
            }
        }
        function shouldIndentChildNode(settings, parent2, child, sourceFile, isNextChild = false) {
            return nodeWillIndentChild(settings, parent2, child, sourceFile, /*indentByDefault*/ false) && !(isNextChild && child && isControlFlowEndingStatement(child.kind, parent2));
        }
        SmartIndenter2.shouldIndentChildNode = shouldIndentChildNode;
        function rangeIsOnOneLine(sourceFile, range) {
            const rangeStart = skipTrivia(sourceFile.text, range.pos);
            const startLine = sourceFile.getLineAndCharacterOfPosition(rangeStart).line;
            const endLine = sourceFile.getLineAndCharacterOfPosition(range.end).line;
            return startLine === endLine;
        }
    })(SmartIndenter || (SmartIndenter = {}));
    // src/services/_namespaces/ts.preparePasteEdits.ts
    var ts_preparePasteEdits_exports = {};
    __export(ts_preparePasteEdits_exports, {
        preparePasteEdits: ()=>preparePasteEdits
    });
    // src/services/preparePasteEdits.ts
    function preparePasteEdits(sourceFile, copiedFromRange, checker) {
        let shouldProvidePasteEdits = false;
        copiedFromRange.forEach((range)=>{
            const enclosingNode = findAncestor(getTokenAtPosition(sourceFile, range.pos), (ancestorNode)=>rangeContainsRange(ancestorNode, range));
            if (!enclosingNode) return;
            forEachChild(enclosingNode, function checkNameResolution(node) {
                var _a;
                if (shouldProvidePasteEdits) return;
                if (isIdentifier(node) && rangeContainsPosition(range, node.getStart(sourceFile))) {
                    const resolvedSymbol = checker.resolveName(node.text, node, -1 /* All */ , /*excludeGlobals*/ false);
                    if (resolvedSymbol && resolvedSymbol.declarations) {
                        for (const decl of resolvedSymbol.declarations)if (isInImport(decl) || !!(node.text && sourceFile.symbol && ((_a = sourceFile.symbol.exports) == null ? void 0 : _a.has(node.escapedText)))) {
                            shouldProvidePasteEdits = true;
                            return;
                        }
                    }
                }
                node.forEachChild(checkNameResolution);
            });
            if (shouldProvidePasteEdits) return;
        });
        return shouldProvidePasteEdits;
    }
    // src/services/_namespaces/ts.PasteEdits.ts
    var ts_PasteEdits_exports = {};
    __export(ts_PasteEdits_exports, {
        pasteEditsProvider: ()=>pasteEditsProvider
    });
    // src/services/pasteEdits.ts
    var fixId55 = "providePostPasteEdits";
    function pasteEditsProvider(targetFile, pastedText, pasteLocations, copiedFrom, host, preferences, formatContext, cancellationToken) {
        const changes = ts_textChanges_exports.ChangeTracker.with({
            host,
            formatContext,
            preferences
        }, (changeTracker)=>pasteEdits(targetFile, pastedText, pasteLocations, copiedFrom, host, preferences, formatContext, cancellationToken, changeTracker));
        return {
            edits: changes,
            fixId: fixId55
        };
    }
    function pasteEdits(targetFile, pastedText, pasteLocations, copiedFrom, host, preferences, formatContext, cancellationToken, changes) {
        let actualPastedText;
        if (pastedText.length !== pasteLocations.length) actualPastedText = pastedText.length === 1 ? pastedText[0] : pastedText.join(getNewLineOrDefaultFromHost(formatContext.host, formatContext.options));
        const statements = [];
        let newText = targetFile.text;
        for(let i = pasteLocations.length - 1; i >= 0; i--){
            const { pos, end } = pasteLocations[i];
            newText = actualPastedText ? newText.slice(0, pos) + actualPastedText + newText.slice(end) : newText.slice(0, pos) + pastedText[i] + newText.slice(end);
        }
        let importAdder;
        Debug.checkDefined(host.runWithTemporaryFileUpdate).call(host, targetFile.fileName, newText, (updatedProgram, originalProgram, updatedFile)=>{
            importAdder = ts_codefix_exports.createImportAdder(updatedFile, updatedProgram, preferences, host);
            if (copiedFrom == null ? void 0 : copiedFrom.range) {
                Debug.assert(copiedFrom.range.length === pastedText.length);
                copiedFrom.range.forEach((copy)=>{
                    const statementsInSourceFile = copiedFrom.file.statements;
                    const startNodeIndex = findIndex(statementsInSourceFile, (s)=>s.end > copy.pos);
                    if (startNodeIndex === -1) return void 0;
                    let endNodeIndex = findIndex(statementsInSourceFile, (s)=>s.end >= copy.end, startNodeIndex);
                    if (endNodeIndex !== -1 && copy.end <= statementsInSourceFile[endNodeIndex].getStart()) endNodeIndex--;
                    statements.push(...statementsInSourceFile.slice(startNodeIndex, endNodeIndex === -1 ? statementsInSourceFile.length : endNodeIndex + 1));
                });
                Debug.assertIsDefined(originalProgram, "no original program found");
                const originalProgramTypeChecker = originalProgram.getTypeChecker();
                const usageInfoRange = getUsageInfoRangeForPasteEdits(copiedFrom);
                const usage = getUsageInfo(copiedFrom.file, statements, originalProgramTypeChecker, getExistingLocals(updatedFile, statements, originalProgramTypeChecker), usageInfoRange);
                const useEsModuleSyntax = !fileShouldUseJavaScriptRequire(targetFile.fileName, originalProgram, host, !!copiedFrom.file.commonJsModuleIndicator);
                addExportsInOldFile(copiedFrom.file, usage.targetFileImportsFromOldFile, changes, useEsModuleSyntax);
                addTargetFileImports(copiedFrom.file, usage.oldImportsNeededByTargetFile, usage.targetFileImportsFromOldFile, originalProgramTypeChecker, updatedProgram, importAdder);
            } else {
                const context = {
                    sourceFile: updatedFile,
                    program: originalProgram,
                    cancellationToken,
                    host,
                    preferences,
                    formatContext
                };
                let offset = 0;
                pasteLocations.forEach((location, i)=>{
                    const oldTextLength = location.end - location.pos;
                    const textToBePasted = actualPastedText !== null && actualPastedText !== void 0 ? actualPastedText : pastedText[i];
                    const startPos = location.pos + offset;
                    const endPos = startPos + textToBePasted.length;
                    const range = {
                        pos: startPos,
                        end: endPos
                    };
                    offset += textToBePasted.length - oldTextLength;
                    const enclosingNode = findAncestor(getTokenAtPosition(context.sourceFile, range.pos), (ancestorNode)=>rangeContainsRange(ancestorNode, range));
                    if (!enclosingNode) return;
                    forEachChild(enclosingNode, function importUnresolvedIdentifiers(node) {
                        const isImportCandidate = isIdentifier(node) && rangeContainsPosition(range, node.getStart(updatedFile)) && !(updatedProgram == null ? void 0 : updatedProgram.getTypeChecker().resolveName(node.text, node, -1 /* All */ , /*excludeGlobals*/ false));
                        if (isImportCandidate) return importAdder.addImportForUnresolvedIdentifier(context, node, /*useAutoImportProvider*/ true);
                        node.forEachChild(importUnresolvedIdentifiers);
                    });
                });
            }
            importAdder.writeFixes(changes, getQuotePreference(copiedFrom ? copiedFrom.file : targetFile, preferences));
        });
        if (!importAdder.hasFixes()) return;
        pasteLocations.forEach((paste, i)=>{
            changes.replaceRangeWithText(targetFile, {
                pos: paste.pos,
                end: paste.end
            }, actualPastedText !== null && actualPastedText !== void 0 ? actualPastedText : pastedText[i]);
        });
    }
    function getUsageInfoRangeForPasteEdits({ file: sourceFile, range }) {
        const pos = range[0].pos;
        const end = range[range.length - 1].end;
        const startToken = getTokenAtPosition(sourceFile, pos);
        var _findTokenOnLeftOfPosition;
        const endToken = (_findTokenOnLeftOfPosition = findTokenOnLeftOfPosition(sourceFile, pos)) !== null && _findTokenOnLeftOfPosition !== void 0 ? _findTokenOnLeftOfPosition : getTokenAtPosition(sourceFile, end);
        return {
            pos: isIdentifier(startToken) && pos <= startToken.getStart(sourceFile) ? startToken.getFullStart() : pos,
            end: isIdentifier(endToken) && end === endToken.getEnd() ? ts_textChanges_exports.getAdjustedEndPosition(sourceFile, endToken, {}) : end
        };
    }
    // src/server/_namespaces/ts.ts
    var ts_exports2 = {};
    __export(ts_exports2, {
        ANONYMOUS: ()=>ANONYMOUS,
        AccessFlags: ()=>AccessFlags,
        AssertionLevel: ()=>AssertionLevel,
        AssignmentDeclarationKind: ()=>AssignmentDeclarationKind,
        AssignmentKind: ()=>AssignmentKind,
        Associativity: ()=>Associativity,
        BreakpointResolver: ()=>ts_BreakpointResolver_exports,
        BuilderFileEmit: ()=>BuilderFileEmit,
        BuilderProgramKind: ()=>BuilderProgramKind,
        BuilderState: ()=>BuilderState,
        CallHierarchy: ()=>ts_CallHierarchy_exports,
        CharacterCodes: ()=>CharacterCodes,
        CheckFlags: ()=>CheckFlags,
        CheckMode: ()=>CheckMode,
        ClassificationType: ()=>ClassificationType,
        ClassificationTypeNames: ()=>ClassificationTypeNames,
        CommentDirectiveType: ()=>CommentDirectiveType,
        Comparison: ()=>Comparison,
        CompletionInfoFlags: ()=>CompletionInfoFlags,
        CompletionTriggerKind: ()=>CompletionTriggerKind,
        Completions: ()=>ts_Completions_exports,
        ContainerFlags: ()=>ContainerFlags,
        ContextFlags: ()=>ContextFlags,
        Debug: ()=>Debug,
        DiagnosticCategory: ()=>DiagnosticCategory,
        Diagnostics: ()=>Diagnostics,
        DocumentHighlights: ()=>DocumentHighlights,
        ElementFlags: ()=>ElementFlags,
        EmitFlags: ()=>EmitFlags,
        EmitHint: ()=>EmitHint,
        EmitOnly: ()=>EmitOnly,
        EndOfLineState: ()=>EndOfLineState,
        ExitStatus: ()=>ExitStatus,
        ExportKind: ()=>ExportKind,
        Extension: ()=>Extension,
        ExternalEmitHelpers: ()=>ExternalEmitHelpers,
        FileIncludeKind: ()=>FileIncludeKind,
        FilePreprocessingDiagnosticsKind: ()=>FilePreprocessingDiagnosticsKind,
        FileSystemEntryKind: ()=>FileSystemEntryKind,
        FileWatcherEventKind: ()=>FileWatcherEventKind,
        FindAllReferences: ()=>ts_FindAllReferences_exports,
        FlattenLevel: ()=>FlattenLevel,
        FlowFlags: ()=>FlowFlags,
        ForegroundColorEscapeSequences: ()=>ForegroundColorEscapeSequences,
        FunctionFlags: ()=>FunctionFlags,
        GeneratedIdentifierFlags: ()=>GeneratedIdentifierFlags,
        GetLiteralTextFlags: ()=>GetLiteralTextFlags,
        GoToDefinition: ()=>ts_GoToDefinition_exports,
        HighlightSpanKind: ()=>HighlightSpanKind,
        IdentifierNameMap: ()=>IdentifierNameMap,
        ImportKind: ()=>ImportKind,
        ImportsNotUsedAsValues: ()=>ImportsNotUsedAsValues,
        IndentStyle: ()=>IndentStyle,
        IndexFlags: ()=>IndexFlags,
        IndexKind: ()=>IndexKind,
        InferenceFlags: ()=>InferenceFlags,
        InferencePriority: ()=>InferencePriority,
        InlayHintKind: ()=>InlayHintKind2,
        InlayHints: ()=>ts_InlayHints_exports,
        InternalEmitFlags: ()=>InternalEmitFlags,
        InternalNodeBuilderFlags: ()=>InternalNodeBuilderFlags,
        InternalSymbolName: ()=>InternalSymbolName,
        IntersectionFlags: ()=>IntersectionFlags,
        InvalidatedProjectKind: ()=>InvalidatedProjectKind,
        JSDocParsingMode: ()=>JSDocParsingMode,
        JsDoc: ()=>ts_JsDoc_exports,
        JsTyping: ()=>ts_JsTyping_exports,
        JsxEmit: ()=>JsxEmit,
        JsxFlags: ()=>JsxFlags,
        JsxReferenceKind: ()=>JsxReferenceKind,
        LanguageFeatureMinimumTarget: ()=>LanguageFeatureMinimumTarget,
        LanguageServiceMode: ()=>LanguageServiceMode,
        LanguageVariant: ()=>LanguageVariant,
        LexicalEnvironmentFlags: ()=>LexicalEnvironmentFlags,
        ListFormat: ()=>ListFormat,
        LogLevel: ()=>LogLevel,
        MapCode: ()=>ts_MapCode_exports,
        MemberOverrideStatus: ()=>MemberOverrideStatus,
        ModifierFlags: ()=>ModifierFlags,
        ModuleDetectionKind: ()=>ModuleDetectionKind,
        ModuleInstanceState: ()=>ModuleInstanceState,
        ModuleKind: ()=>ModuleKind,
        ModuleResolutionKind: ()=>ModuleResolutionKind,
        ModuleSpecifierEnding: ()=>ModuleSpecifierEnding,
        NavigateTo: ()=>ts_NavigateTo_exports,
        NavigationBar: ()=>ts_NavigationBar_exports,
        NewLineKind: ()=>NewLineKind,
        NodeBuilderFlags: ()=>NodeBuilderFlags,
        NodeCheckFlags: ()=>NodeCheckFlags,
        NodeFactoryFlags: ()=>NodeFactoryFlags,
        NodeFlags: ()=>NodeFlags,
        NodeResolutionFeatures: ()=>NodeResolutionFeatures,
        ObjectFlags: ()=>ObjectFlags,
        OperationCanceledException: ()=>OperationCanceledException,
        OperatorPrecedence: ()=>OperatorPrecedence,
        OrganizeImports: ()=>ts_OrganizeImports_exports,
        OrganizeImportsMode: ()=>OrganizeImportsMode,
        OuterExpressionKinds: ()=>OuterExpressionKinds,
        OutliningElementsCollector: ()=>ts_OutliningElementsCollector_exports,
        OutliningSpanKind: ()=>OutliningSpanKind,
        OutputFileType: ()=>OutputFileType,
        PackageJsonAutoImportPreference: ()=>PackageJsonAutoImportPreference,
        PackageJsonDependencyGroup: ()=>PackageJsonDependencyGroup,
        PatternMatchKind: ()=>PatternMatchKind,
        PollingInterval: ()=>PollingInterval,
        PollingWatchKind: ()=>PollingWatchKind,
        PragmaKindFlags: ()=>PragmaKindFlags,
        PredicateSemantics: ()=>PredicateSemantics,
        PreparePasteEdits: ()=>ts_preparePasteEdits_exports,
        PrivateIdentifierKind: ()=>PrivateIdentifierKind,
        ProcessLevel: ()=>ProcessLevel,
        ProgramUpdateLevel: ()=>ProgramUpdateLevel,
        QuotePreference: ()=>QuotePreference,
        RegularExpressionFlags: ()=>RegularExpressionFlags,
        RelationComparisonResult: ()=>RelationComparisonResult,
        Rename: ()=>ts_Rename_exports,
        ScriptElementKind: ()=>ScriptElementKind,
        ScriptElementKindModifier: ()=>ScriptElementKindModifier,
        ScriptKind: ()=>ScriptKind,
        ScriptSnapshot: ()=>ScriptSnapshot,
        ScriptTarget: ()=>ScriptTarget,
        SemanticClassificationFormat: ()=>SemanticClassificationFormat,
        SemanticMeaning: ()=>SemanticMeaning,
        SemicolonPreference: ()=>SemicolonPreference,
        SignatureCheckMode: ()=>SignatureCheckMode,
        SignatureFlags: ()=>SignatureFlags,
        SignatureHelp: ()=>ts_SignatureHelp_exports,
        SignatureInfo: ()=>SignatureInfo,
        SignatureKind: ()=>SignatureKind,
        SmartSelectionRange: ()=>ts_SmartSelectionRange_exports,
        SnippetKind: ()=>SnippetKind,
        StatisticType: ()=>StatisticType,
        StructureIsReused: ()=>StructureIsReused,
        SymbolAccessibility: ()=>SymbolAccessibility,
        SymbolDisplay: ()=>ts_SymbolDisplay_exports,
        SymbolDisplayPartKind: ()=>SymbolDisplayPartKind,
        SymbolFlags: ()=>SymbolFlags,
        SymbolFormatFlags: ()=>SymbolFormatFlags,
        SyntaxKind: ()=>SyntaxKind,
        Ternary: ()=>Ternary,
        ThrottledCancellationToken: ()=>ThrottledCancellationToken,
        TokenClass: ()=>TokenClass,
        TokenFlags: ()=>TokenFlags,
        TransformFlags: ()=>TransformFlags,
        TypeFacts: ()=>TypeFacts,
        TypeFlags: ()=>TypeFlags,
        TypeFormatFlags: ()=>TypeFormatFlags,
        TypeMapKind: ()=>TypeMapKind,
        TypePredicateKind: ()=>TypePredicateKind,
        TypeReferenceSerializationKind: ()=>TypeReferenceSerializationKind,
        UnionReduction: ()=>UnionReduction,
        UpToDateStatusType: ()=>UpToDateStatusType,
        VarianceFlags: ()=>VarianceFlags,
        Version: ()=>Version,
        VersionRange: ()=>VersionRange,
        WatchDirectoryFlags: ()=>WatchDirectoryFlags,
        WatchDirectoryKind: ()=>WatchDirectoryKind,
        WatchFileKind: ()=>WatchFileKind,
        WatchLogLevel: ()=>WatchLogLevel,
        WatchType: ()=>WatchType,
        accessPrivateIdentifier: ()=>accessPrivateIdentifier,
        addEmitFlags: ()=>addEmitFlags,
        addEmitHelper: ()=>addEmitHelper,
        addEmitHelpers: ()=>addEmitHelpers,
        addInternalEmitFlags: ()=>addInternalEmitFlags,
        addNodeFactoryPatcher: ()=>addNodeFactoryPatcher,
        addObjectAllocatorPatcher: ()=>addObjectAllocatorPatcher,
        addRange: ()=>addRange,
        addRelatedInfo: ()=>addRelatedInfo,
        addSyntheticLeadingComment: ()=>addSyntheticLeadingComment,
        addSyntheticTrailingComment: ()=>addSyntheticTrailingComment,
        addToSeen: ()=>addToSeen,
        advancedAsyncSuperHelper: ()=>advancedAsyncSuperHelper,
        affectsDeclarationPathOptionDeclarations: ()=>affectsDeclarationPathOptionDeclarations,
        affectsEmitOptionDeclarations: ()=>affectsEmitOptionDeclarations,
        allKeysStartWithDot: ()=>allKeysStartWithDot,
        altDirectorySeparator: ()=>altDirectorySeparator,
        and: ()=>and,
        append: ()=>append,
        appendIfUnique: ()=>appendIfUnique,
        arrayFrom: ()=>arrayFrom,
        arrayIsEqualTo: ()=>arrayIsEqualTo,
        arrayIsHomogeneous: ()=>arrayIsHomogeneous,
        arrayOf: ()=>arrayOf,
        arrayReverseIterator: ()=>arrayReverseIterator,
        arrayToMap: ()=>arrayToMap,
        arrayToMultiMap: ()=>arrayToMultiMap,
        arrayToNumericMap: ()=>arrayToNumericMap,
        assertType: ()=>assertType,
        assign: ()=>assign,
        asyncSuperHelper: ()=>asyncSuperHelper,
        attachFileToDiagnostics: ()=>attachFileToDiagnostics,
        base64decode: ()=>base64decode,
        base64encode: ()=>base64encode,
        binarySearch: ()=>binarySearch,
        binarySearchKey: ()=>binarySearchKey,
        bindSourceFile: ()=>bindSourceFile,
        breakIntoCharacterSpans: ()=>breakIntoCharacterSpans,
        breakIntoWordSpans: ()=>breakIntoWordSpans,
        buildLinkParts: ()=>buildLinkParts,
        buildOpts: ()=>buildOpts,
        buildOverload: ()=>buildOverload,
        bundlerModuleNameResolver: ()=>bundlerModuleNameResolver,
        canBeConvertedToAsync: ()=>canBeConvertedToAsync,
        canHaveDecorators: ()=>canHaveDecorators,
        canHaveExportModifier: ()=>canHaveExportModifier,
        canHaveFlowNode: ()=>canHaveFlowNode,
        canHaveIllegalDecorators: ()=>canHaveIllegalDecorators,
        canHaveIllegalModifiers: ()=>canHaveIllegalModifiers,
        canHaveIllegalType: ()=>canHaveIllegalType,
        canHaveIllegalTypeParameters: ()=>canHaveIllegalTypeParameters,
        canHaveJSDoc: ()=>canHaveJSDoc,
        canHaveLocals: ()=>canHaveLocals,
        canHaveModifiers: ()=>canHaveModifiers,
        canHaveModuleSpecifier: ()=>canHaveModuleSpecifier,
        canHaveSymbol: ()=>canHaveSymbol,
        canIncludeBindAndCheckDiagnostics: ()=>canIncludeBindAndCheckDiagnostics,
        canJsonReportNoInputFiles: ()=>canJsonReportNoInputFiles,
        canProduceDiagnostics: ()=>canProduceDiagnostics,
        canUsePropertyAccess: ()=>canUsePropertyAccess,
        canWatchAffectingLocation: ()=>canWatchAffectingLocation,
        canWatchAtTypes: ()=>canWatchAtTypes,
        canWatchDirectoryOrFile: ()=>canWatchDirectoryOrFile,
        canWatchDirectoryOrFilePath: ()=>canWatchDirectoryOrFilePath,
        cartesianProduct: ()=>cartesianProduct,
        cast: ()=>cast,
        chainBundle: ()=>chainBundle,
        chainDiagnosticMessages: ()=>chainDiagnosticMessages,
        changeAnyExtension: ()=>changeAnyExtension,
        changeCompilerHostLikeToUseCache: ()=>changeCompilerHostLikeToUseCache,
        changeExtension: ()=>changeExtension,
        changeFullExtension: ()=>changeFullExtension,
        changesAffectModuleResolution: ()=>changesAffectModuleResolution,
        changesAffectingProgramStructure: ()=>changesAffectingProgramStructure,
        characterCodeToRegularExpressionFlag: ()=>characterCodeToRegularExpressionFlag,
        childIsDecorated: ()=>childIsDecorated,
        classElementOrClassElementParameterIsDecorated: ()=>classElementOrClassElementParameterIsDecorated,
        classHasClassThisAssignment: ()=>classHasClassThisAssignment,
        classHasDeclaredOrExplicitlyAssignedName: ()=>classHasDeclaredOrExplicitlyAssignedName,
        classHasExplicitlyAssignedName: ()=>classHasExplicitlyAssignedName,
        classOrConstructorParameterIsDecorated: ()=>classOrConstructorParameterIsDecorated,
        classicNameResolver: ()=>classicNameResolver,
        classifier: ()=>ts_classifier_exports,
        cleanExtendedConfigCache: ()=>cleanExtendedConfigCache,
        clear: ()=>clear,
        clearMap: ()=>clearMap,
        clearSharedExtendedConfigFileWatcher: ()=>clearSharedExtendedConfigFileWatcher,
        climbPastPropertyAccess: ()=>climbPastPropertyAccess,
        clone: ()=>clone,
        cloneCompilerOptions: ()=>cloneCompilerOptions,
        closeFileWatcher: ()=>closeFileWatcher,
        closeFileWatcherOf: ()=>closeFileWatcherOf,
        codefix: ()=>ts_codefix_exports,
        collapseTextChangeRangesAcrossMultipleVersions: ()=>collapseTextChangeRangesAcrossMultipleVersions,
        collectExternalModuleInfo: ()=>collectExternalModuleInfo,
        combine: ()=>combine,
        combinePaths: ()=>combinePaths,
        commandLineOptionOfCustomType: ()=>commandLineOptionOfCustomType,
        commentPragmas: ()=>commentPragmas,
        commonOptionsWithBuild: ()=>commonOptionsWithBuild,
        compact: ()=>compact,
        compareBooleans: ()=>compareBooleans,
        compareDataObjects: ()=>compareDataObjects,
        compareDiagnostics: ()=>compareDiagnostics,
        compareEmitHelpers: ()=>compareEmitHelpers,
        compareNumberOfDirectorySeparators: ()=>compareNumberOfDirectorySeparators,
        comparePaths: ()=>comparePaths,
        comparePathsCaseInsensitive: ()=>comparePathsCaseInsensitive,
        comparePathsCaseSensitive: ()=>comparePathsCaseSensitive,
        comparePatternKeys: ()=>comparePatternKeys,
        compareProperties: ()=>compareProperties,
        compareStringsCaseInsensitive: ()=>compareStringsCaseInsensitive,
        compareStringsCaseInsensitiveEslintCompatible: ()=>compareStringsCaseInsensitiveEslintCompatible,
        compareStringsCaseSensitive: ()=>compareStringsCaseSensitive,
        compareStringsCaseSensitiveUI: ()=>compareStringsCaseSensitiveUI,
        compareTextSpans: ()=>compareTextSpans,
        compareValues: ()=>compareValues,
        compilerOptionsAffectDeclarationPath: ()=>compilerOptionsAffectDeclarationPath,
        compilerOptionsAffectEmit: ()=>compilerOptionsAffectEmit,
        compilerOptionsAffectSemanticDiagnostics: ()=>compilerOptionsAffectSemanticDiagnostics,
        compilerOptionsDidYouMeanDiagnostics: ()=>compilerOptionsDidYouMeanDiagnostics,
        compilerOptionsIndicateEsModules: ()=>compilerOptionsIndicateEsModules,
        computeCommonSourceDirectoryOfFilenames: ()=>computeCommonSourceDirectoryOfFilenames,
        computeLineAndCharacterOfPosition: ()=>computeLineAndCharacterOfPosition,
        computeLineOfPosition: ()=>computeLineOfPosition,
        computeLineStarts: ()=>computeLineStarts,
        computePositionOfLineAndCharacter: ()=>computePositionOfLineAndCharacter,
        computeSignatureWithDiagnostics: ()=>computeSignatureWithDiagnostics,
        computeSuggestionDiagnostics: ()=>computeSuggestionDiagnostics,
        computedOptions: ()=>computedOptions,
        concatenate: ()=>concatenate,
        concatenateDiagnosticMessageChains: ()=>concatenateDiagnosticMessageChains,
        consumesNodeCoreModules: ()=>consumesNodeCoreModules,
        contains: ()=>contains,
        containsIgnoredPath: ()=>containsIgnoredPath,
        containsObjectRestOrSpread: ()=>containsObjectRestOrSpread,
        containsParseError: ()=>containsParseError,
        containsPath: ()=>containsPath,
        convertCompilerOptionsForTelemetry: ()=>convertCompilerOptionsForTelemetry,
        convertCompilerOptionsFromJson: ()=>convertCompilerOptionsFromJson,
        convertJsonOption: ()=>convertJsonOption,
        convertToBase64: ()=>convertToBase64,
        convertToJson: ()=>convertToJson,
        convertToObject: ()=>convertToObject,
        convertToOptionsWithAbsolutePaths: ()=>convertToOptionsWithAbsolutePaths,
        convertToRelativePath: ()=>convertToRelativePath,
        convertToTSConfig: ()=>convertToTSConfig,
        convertTypeAcquisitionFromJson: ()=>convertTypeAcquisitionFromJson,
        copyComments: ()=>copyComments,
        copyEntries: ()=>copyEntries,
        copyLeadingComments: ()=>copyLeadingComments,
        copyProperties: ()=>copyProperties,
        copyTrailingAsLeadingComments: ()=>copyTrailingAsLeadingComments,
        copyTrailingComments: ()=>copyTrailingComments,
        couldStartTrivia: ()=>couldStartTrivia,
        countWhere: ()=>countWhere,
        createAbstractBuilder: ()=>createAbstractBuilder,
        createAccessorPropertyBackingField: ()=>createAccessorPropertyBackingField,
        createAccessorPropertyGetRedirector: ()=>createAccessorPropertyGetRedirector,
        createAccessorPropertySetRedirector: ()=>createAccessorPropertySetRedirector,
        createBaseNodeFactory: ()=>createBaseNodeFactory,
        createBinaryExpressionTrampoline: ()=>createBinaryExpressionTrampoline,
        createBuilderProgram: ()=>createBuilderProgram,
        createBuilderProgramUsingIncrementalBuildInfo: ()=>createBuilderProgramUsingIncrementalBuildInfo,
        createBuilderStatusReporter: ()=>createBuilderStatusReporter,
        createCacheableExportInfoMap: ()=>createCacheableExportInfoMap,
        createCachedDirectoryStructureHost: ()=>createCachedDirectoryStructureHost,
        createClassifier: ()=>createClassifier,
        createCommentDirectivesMap: ()=>createCommentDirectivesMap,
        createCompilerDiagnostic: ()=>createCompilerDiagnostic,
        createCompilerDiagnosticForInvalidCustomType: ()=>createCompilerDiagnosticForInvalidCustomType,
        createCompilerDiagnosticFromMessageChain: ()=>createCompilerDiagnosticFromMessageChain,
        createCompilerHost: ()=>createCompilerHost,
        createCompilerHostFromProgramHost: ()=>createCompilerHostFromProgramHost,
        createCompilerHostWorker: ()=>createCompilerHostWorker,
        createDetachedDiagnostic: ()=>createDetachedDiagnostic,
        createDiagnosticCollection: ()=>createDiagnosticCollection,
        createDiagnosticForFileFromMessageChain: ()=>createDiagnosticForFileFromMessageChain,
        createDiagnosticForNode: ()=>createDiagnosticForNode,
        createDiagnosticForNodeArray: ()=>createDiagnosticForNodeArray,
        createDiagnosticForNodeArrayFromMessageChain: ()=>createDiagnosticForNodeArrayFromMessageChain,
        createDiagnosticForNodeFromMessageChain: ()=>createDiagnosticForNodeFromMessageChain,
        createDiagnosticForNodeInSourceFile: ()=>createDiagnosticForNodeInSourceFile,
        createDiagnosticForRange: ()=>createDiagnosticForRange,
        createDiagnosticMessageChainFromDiagnostic: ()=>createDiagnosticMessageChainFromDiagnostic,
        createDiagnosticReporter: ()=>createDiagnosticReporter,
        createDocumentPositionMapper: ()=>createDocumentPositionMapper,
        createDocumentRegistry: ()=>createDocumentRegistry,
        createDocumentRegistryInternal: ()=>createDocumentRegistryInternal,
        createEmitAndSemanticDiagnosticsBuilderProgram: ()=>createEmitAndSemanticDiagnosticsBuilderProgram,
        createEmitHelperFactory: ()=>createEmitHelperFactory,
        createEmptyExports: ()=>createEmptyExports,
        createEvaluator: ()=>createEvaluator,
        createExpressionForJsxElement: ()=>createExpressionForJsxElement,
        createExpressionForJsxFragment: ()=>createExpressionForJsxFragment,
        createExpressionForObjectLiteralElementLike: ()=>createExpressionForObjectLiteralElementLike,
        createExpressionForPropertyName: ()=>createExpressionForPropertyName,
        createExpressionFromEntityName: ()=>createExpressionFromEntityName,
        createExternalHelpersImportDeclarationIfNeeded: ()=>createExternalHelpersImportDeclarationIfNeeded,
        createFileDiagnostic: ()=>createFileDiagnostic,
        createFileDiagnosticFromMessageChain: ()=>createFileDiagnosticFromMessageChain,
        createFlowNode: ()=>createFlowNode,
        createForOfBindingStatement: ()=>createForOfBindingStatement,
        createFutureSourceFile: ()=>createFutureSourceFile,
        createGetCanonicalFileName: ()=>createGetCanonicalFileName,
        createGetIsolatedDeclarationErrors: ()=>createGetIsolatedDeclarationErrors,
        createGetSourceFile: ()=>createGetSourceFile,
        createGetSymbolAccessibilityDiagnosticForNode: ()=>createGetSymbolAccessibilityDiagnosticForNode,
        createGetSymbolAccessibilityDiagnosticForNodeName: ()=>createGetSymbolAccessibilityDiagnosticForNodeName,
        createGetSymbolWalker: ()=>createGetSymbolWalker,
        createIncrementalCompilerHost: ()=>createIncrementalCompilerHost,
        createIncrementalProgram: ()=>createIncrementalProgram,
        createJsxFactoryExpression: ()=>createJsxFactoryExpression,
        createLanguageService: ()=>createLanguageService,
        createLanguageServiceSourceFile: ()=>createLanguageServiceSourceFile,
        createMemberAccessForPropertyName: ()=>createMemberAccessForPropertyName,
        createModeAwareCache: ()=>createModeAwareCache,
        createModeAwareCacheKey: ()=>createModeAwareCacheKey,
        createModeMismatchDetails: ()=>createModeMismatchDetails,
        createModuleNotFoundChain: ()=>createModuleNotFoundChain,
        createModuleResolutionCache: ()=>createModuleResolutionCache,
        createModuleResolutionLoader: ()=>createModuleResolutionLoader,
        createModuleResolutionLoaderUsingGlobalCache: ()=>createModuleResolutionLoaderUsingGlobalCache,
        createModuleSpecifierResolutionHost: ()=>createModuleSpecifierResolutionHost,
        createMultiMap: ()=>createMultiMap,
        createNameResolver: ()=>createNameResolver,
        createNodeConverters: ()=>createNodeConverters,
        createNodeFactory: ()=>createNodeFactory,
        createOptionNameMap: ()=>createOptionNameMap,
        createOverload: ()=>createOverload,
        createPackageJsonImportFilter: ()=>createPackageJsonImportFilter,
        createPackageJsonInfo: ()=>createPackageJsonInfo,
        createParenthesizerRules: ()=>createParenthesizerRules,
        createPatternMatcher: ()=>createPatternMatcher,
        createPrinter: ()=>createPrinter,
        createPrinterWithDefaults: ()=>createPrinterWithDefaults,
        createPrinterWithRemoveComments: ()=>createPrinterWithRemoveComments,
        createPrinterWithRemoveCommentsNeverAsciiEscape: ()=>createPrinterWithRemoveCommentsNeverAsciiEscape,
        createPrinterWithRemoveCommentsOmitTrailingSemicolon: ()=>createPrinterWithRemoveCommentsOmitTrailingSemicolon,
        createProgram: ()=>createProgram,
        createProgramDiagnostics: ()=>createProgramDiagnostics,
        createProgramHost: ()=>createProgramHost,
        createPropertyNameNodeForIdentifierOrLiteral: ()=>createPropertyNameNodeForIdentifierOrLiteral,
        createQueue: ()=>createQueue,
        createRange: ()=>createRange,
        createRedirectedBuilderProgram: ()=>createRedirectedBuilderProgram,
        createResolutionCache: ()=>createResolutionCache,
        createRuntimeTypeSerializer: ()=>createRuntimeTypeSerializer,
        createScanner: ()=>createScanner,
        createSemanticDiagnosticsBuilderProgram: ()=>createSemanticDiagnosticsBuilderProgram,
        createSet: ()=>createSet,
        createSolutionBuilder: ()=>createSolutionBuilder,
        createSolutionBuilderHost: ()=>createSolutionBuilderHost,
        createSolutionBuilderWithWatch: ()=>createSolutionBuilderWithWatch,
        createSolutionBuilderWithWatchHost: ()=>createSolutionBuilderWithWatchHost,
        createSortedArray: ()=>createSortedArray,
        createSourceFile: ()=>createSourceFile,
        createSourceMapGenerator: ()=>createSourceMapGenerator,
        createSourceMapSource: ()=>createSourceMapSource,
        createSuperAccessVariableStatement: ()=>createSuperAccessVariableStatement,
        createSymbolTable: ()=>createSymbolTable,
        createSymlinkCache: ()=>createSymlinkCache,
        createSyntacticTypeNodeBuilder: ()=>createSyntacticTypeNodeBuilder,
        createSystemWatchFunctions: ()=>createSystemWatchFunctions,
        createTextChange: ()=>createTextChange,
        createTextChangeFromStartLength: ()=>createTextChangeFromStartLength,
        createTextChangeRange: ()=>createTextChangeRange,
        createTextRangeFromNode: ()=>createTextRangeFromNode,
        createTextRangeFromSpan: ()=>createTextRangeFromSpan,
        createTextSpan: ()=>createTextSpan,
        createTextSpanFromBounds: ()=>createTextSpanFromBounds,
        createTextSpanFromNode: ()=>createTextSpanFromNode,
        createTextSpanFromRange: ()=>createTextSpanFromRange,
        createTextSpanFromStringLiteralLikeContent: ()=>createTextSpanFromStringLiteralLikeContent,
        createTextWriter: ()=>createTextWriter,
        createTokenRange: ()=>createTokenRange,
        createTypeChecker: ()=>createTypeChecker,
        createTypeReferenceDirectiveResolutionCache: ()=>createTypeReferenceDirectiveResolutionCache,
        createTypeReferenceResolutionLoader: ()=>createTypeReferenceResolutionLoader,
        createWatchCompilerHost: ()=>createWatchCompilerHost2,
        createWatchCompilerHostOfConfigFile: ()=>createWatchCompilerHostOfConfigFile,
        createWatchCompilerHostOfFilesAndCompilerOptions: ()=>createWatchCompilerHostOfFilesAndCompilerOptions,
        createWatchFactory: ()=>createWatchFactory,
        createWatchHost: ()=>createWatchHost,
        createWatchProgram: ()=>createWatchProgram,
        createWatchStatusReporter: ()=>createWatchStatusReporter,
        createWriteFileMeasuringIO: ()=>createWriteFileMeasuringIO,
        declarationNameToString: ()=>declarationNameToString,
        decodeMappings: ()=>decodeMappings,
        decodedTextSpanIntersectsWith: ()=>decodedTextSpanIntersectsWith,
        deduplicate: ()=>deduplicate,
        defaultHoverMaximumTruncationLength: ()=>defaultHoverMaximumTruncationLength,
        defaultInitCompilerOptions: ()=>defaultInitCompilerOptions,
        defaultMaximumTruncationLength: ()=>defaultMaximumTruncationLength,
        diagnosticCategoryName: ()=>diagnosticCategoryName,
        diagnosticToString: ()=>diagnosticToString,
        diagnosticsEqualityComparer: ()=>diagnosticsEqualityComparer,
        directoryProbablyExists: ()=>directoryProbablyExists,
        directorySeparator: ()=>directorySeparator,
        displayPart: ()=>displayPart,
        displayPartsToString: ()=>displayPartsToString,
        disposeEmitNodes: ()=>disposeEmitNodes,
        documentSpansEqual: ()=>documentSpansEqual,
        dumpTracingLegend: ()=>dumpTracingLegend,
        elementAt: ()=>elementAt,
        elideNodes: ()=>elideNodes,
        emitDetachedComments: ()=>emitDetachedComments,
        emitFiles: ()=>emitFiles,
        emitFilesAndReportErrors: ()=>emitFilesAndReportErrors,
        emitFilesAndReportErrorsAndGetExitStatus: ()=>emitFilesAndReportErrorsAndGetExitStatus,
        emitModuleKindIsNonNodeESM: ()=>emitModuleKindIsNonNodeESM,
        emitNewLineBeforeLeadingCommentOfPosition: ()=>emitNewLineBeforeLeadingCommentOfPosition,
        emitResolverSkipsTypeChecking: ()=>emitResolverSkipsTypeChecking,
        emitSkippedWithNoDiagnostics: ()=>emitSkippedWithNoDiagnostics,
        emptyArray: ()=>emptyArray,
        emptyFileSystemEntries: ()=>emptyFileSystemEntries,
        emptyMap: ()=>emptyMap,
        emptyOptions: ()=>emptyOptions,
        endsWith: ()=>endsWith,
        ensurePathIsNonModuleName: ()=>ensurePathIsNonModuleName,
        ensureScriptKind: ()=>ensureScriptKind,
        ensureTrailingDirectorySeparator: ()=>ensureTrailingDirectorySeparator,
        entityNameToString: ()=>entityNameToString,
        enumerateInsertsAndDeletes: ()=>enumerateInsertsAndDeletes,
        equalOwnProperties: ()=>equalOwnProperties,
        equateStringsCaseInsensitive: ()=>equateStringsCaseInsensitive,
        equateStringsCaseSensitive: ()=>equateStringsCaseSensitive,
        equateValues: ()=>equateValues,
        escapeJsxAttributeString: ()=>escapeJsxAttributeString,
        escapeLeadingUnderscores: ()=>escapeLeadingUnderscores,
        escapeNonAsciiString: ()=>escapeNonAsciiString,
        escapeSnippetText: ()=>escapeSnippetText,
        escapeString: ()=>escapeString,
        escapeTemplateSubstitution: ()=>escapeTemplateSubstitution,
        evaluatorResult: ()=>evaluatorResult,
        every: ()=>every,
        exclusivelyPrefixedNodeCoreModules: ()=>exclusivelyPrefixedNodeCoreModules,
        executeCommandLine: ()=>executeCommandLine,
        expandPreOrPostfixIncrementOrDecrementExpression: ()=>expandPreOrPostfixIncrementOrDecrementExpression,
        explainFiles: ()=>explainFiles,
        explainIfFileIsRedirectAndImpliedFormat: ()=>explainIfFileIsRedirectAndImpliedFormat,
        exportAssignmentIsAlias: ()=>exportAssignmentIsAlias,
        expressionResultIsUnused: ()=>expressionResultIsUnused,
        extend: ()=>extend,
        extensionFromPath: ()=>extensionFromPath,
        extensionIsTS: ()=>extensionIsTS,
        extensionsNotSupportingExtensionlessResolution: ()=>extensionsNotSupportingExtensionlessResolution,
        externalHelpersModuleNameText: ()=>externalHelpersModuleNameText,
        factory: ()=>factory,
        fileExtensionIs: ()=>fileExtensionIs,
        fileExtensionIsOneOf: ()=>fileExtensionIsOneOf,
        fileIncludeReasonToDiagnostics: ()=>fileIncludeReasonToDiagnostics,
        fileShouldUseJavaScriptRequire: ()=>fileShouldUseJavaScriptRequire,
        filter: ()=>filter,
        filterMutate: ()=>filterMutate,
        filterSemanticDiagnostics: ()=>filterSemanticDiagnostics,
        find: ()=>find,
        findAncestor: ()=>findAncestor,
        findBestPatternMatch: ()=>findBestPatternMatch,
        findChildOfKind: ()=>findChildOfKind,
        findComputedPropertyNameCacheAssignment: ()=>findComputedPropertyNameCacheAssignment,
        findConfigFile: ()=>findConfigFile,
        findConstructorDeclaration: ()=>findConstructorDeclaration,
        findContainingList: ()=>findContainingList,
        findDiagnosticForNode: ()=>findDiagnosticForNode,
        findFirstNonJsxWhitespaceToken: ()=>findFirstNonJsxWhitespaceToken,
        findIndex: ()=>findIndex,
        findLast: ()=>findLast,
        findLastIndex: ()=>findLastIndex,
        findListItemInfo: ()=>findListItemInfo,
        findModifier: ()=>findModifier,
        findNextToken: ()=>findNextToken,
        findPackageJson: ()=>findPackageJson,
        findPackageJsons: ()=>findPackageJsons,
        findPrecedingMatchingToken: ()=>findPrecedingMatchingToken,
        findPrecedingToken: ()=>findPrecedingToken,
        findSuperStatementIndexPath: ()=>findSuperStatementIndexPath,
        findTokenOnLeftOfPosition: ()=>findTokenOnLeftOfPosition,
        findUseStrictPrologue: ()=>findUseStrictPrologue,
        first: ()=>first,
        firstDefined: ()=>firstDefined,
        firstDefinedIterator: ()=>firstDefinedIterator,
        firstIterator: ()=>firstIterator,
        firstOrOnly: ()=>firstOrOnly,
        firstOrUndefined: ()=>firstOrUndefined,
        firstOrUndefinedIterator: ()=>firstOrUndefinedIterator,
        fixupCompilerOptions: ()=>fixupCompilerOptions,
        flatMap: ()=>flatMap,
        flatMapIterator: ()=>flatMapIterator,
        flatMapToMutable: ()=>flatMapToMutable,
        flatten: ()=>flatten,
        flattenCommaList: ()=>flattenCommaList,
        flattenDestructuringAssignment: ()=>flattenDestructuringAssignment,
        flattenDestructuringBinding: ()=>flattenDestructuringBinding,
        flattenDiagnosticMessageText: ()=>flattenDiagnosticMessageText,
        forEach: ()=>forEach,
        forEachAncestor: ()=>forEachAncestor,
        forEachAncestorDirectory: ()=>forEachAncestorDirectory,
        forEachAncestorDirectoryStoppingAtGlobalCache: ()=>forEachAncestorDirectoryStoppingAtGlobalCache,
        forEachChild: ()=>forEachChild,
        forEachChildRecursively: ()=>forEachChildRecursively,
        forEachDynamicImportOrRequireCall: ()=>forEachDynamicImportOrRequireCall,
        forEachEmittedFile: ()=>forEachEmittedFile,
        forEachEnclosingBlockScopeContainer: ()=>forEachEnclosingBlockScopeContainer,
        forEachEntry: ()=>forEachEntry,
        forEachExternalModuleToImportFrom: ()=>forEachExternalModuleToImportFrom,
        forEachImportClauseDeclaration: ()=>forEachImportClauseDeclaration,
        forEachKey: ()=>forEachKey,
        forEachLeadingCommentRange: ()=>forEachLeadingCommentRange,
        forEachNameInAccessChainWalkingLeft: ()=>forEachNameInAccessChainWalkingLeft,
        forEachNameOfDefaultExport: ()=>forEachNameOfDefaultExport,
        forEachOptionsSyntaxByName: ()=>forEachOptionsSyntaxByName,
        forEachProjectReference: ()=>forEachProjectReference,
        forEachPropertyAssignment: ()=>forEachPropertyAssignment,
        forEachResolvedProjectReference: ()=>forEachResolvedProjectReference,
        forEachReturnStatement: ()=>forEachReturnStatement,
        forEachRight: ()=>forEachRight,
        forEachTrailingCommentRange: ()=>forEachTrailingCommentRange,
        forEachTsConfigPropArray: ()=>forEachTsConfigPropArray,
        forEachUnique: ()=>forEachUnique,
        forEachYieldExpression: ()=>forEachYieldExpression,
        formatColorAndReset: ()=>formatColorAndReset,
        formatDiagnostic: ()=>formatDiagnostic,
        formatDiagnostics: ()=>formatDiagnostics,
        formatDiagnosticsWithColorAndContext: ()=>formatDiagnosticsWithColorAndContext,
        formatGeneratedName: ()=>formatGeneratedName,
        formatGeneratedNamePart: ()=>formatGeneratedNamePart,
        formatLocation: ()=>formatLocation,
        formatMessage: ()=>formatMessage,
        formatStringFromArgs: ()=>formatStringFromArgs,
        formatting: ()=>ts_formatting_exports,
        generateDjb2Hash: ()=>generateDjb2Hash,
        generateTSConfig: ()=>generateTSConfig,
        getAdjustedReferenceLocation: ()=>getAdjustedReferenceLocation,
        getAdjustedRenameLocation: ()=>getAdjustedRenameLocation,
        getAliasDeclarationFromName: ()=>getAliasDeclarationFromName,
        getAllAccessorDeclarations: ()=>getAllAccessorDeclarations,
        getAllDecoratorsOfClass: ()=>getAllDecoratorsOfClass,
        getAllDecoratorsOfClassElement: ()=>getAllDecoratorsOfClassElement,
        getAllJSDocTags: ()=>getAllJSDocTags,
        getAllJSDocTagsOfKind: ()=>getAllJSDocTagsOfKind,
        getAllKeys: ()=>getAllKeys,
        getAllProjectOutputs: ()=>getAllProjectOutputs,
        getAllSuperTypeNodes: ()=>getAllSuperTypeNodes,
        getAllowImportingTsExtensions: ()=>getAllowImportingTsExtensions,
        getAllowJSCompilerOption: ()=>getAllowJSCompilerOption,
        getAllowSyntheticDefaultImports: ()=>getAllowSyntheticDefaultImports,
        getAncestor: ()=>getAncestor,
        getAnyExtensionFromPath: ()=>getAnyExtensionFromPath,
        getAreDeclarationMapsEnabled: ()=>getAreDeclarationMapsEnabled,
        getAssignedExpandoInitializer: ()=>getAssignedExpandoInitializer,
        getAssignedName: ()=>getAssignedName,
        getAssignmentDeclarationKind: ()=>getAssignmentDeclarationKind,
        getAssignmentDeclarationPropertyAccessKind: ()=>getAssignmentDeclarationPropertyAccessKind,
        getAssignmentTargetKind: ()=>getAssignmentTargetKind,
        getAutomaticTypeDirectiveNames: ()=>getAutomaticTypeDirectiveNames,
        getBaseFileName: ()=>getBaseFileName,
        getBinaryOperatorPrecedence: ()=>getBinaryOperatorPrecedence,
        getBuildInfo: ()=>getBuildInfo,
        getBuildInfoFileVersionMap: ()=>getBuildInfoFileVersionMap,
        getBuildInfoText: ()=>getBuildInfoText,
        getBuildOrderFromAnyBuildOrder: ()=>getBuildOrderFromAnyBuildOrder,
        getBuilderCreationParameters: ()=>getBuilderCreationParameters,
        getBuilderFileEmit: ()=>getBuilderFileEmit,
        getCanonicalDiagnostic: ()=>getCanonicalDiagnostic,
        getCheckFlags: ()=>getCheckFlags,
        getClassExtendsHeritageElement: ()=>getClassExtendsHeritageElement,
        getClassLikeDeclarationOfSymbol: ()=>getClassLikeDeclarationOfSymbol,
        getCombinedLocalAndExportSymbolFlags: ()=>getCombinedLocalAndExportSymbolFlags,
        getCombinedModifierFlags: ()=>getCombinedModifierFlags,
        getCombinedNodeFlags: ()=>getCombinedNodeFlags,
        getCombinedNodeFlagsAlwaysIncludeJSDoc: ()=>getCombinedNodeFlagsAlwaysIncludeJSDoc,
        getCommentRange: ()=>getCommentRange,
        getCommonSourceDirectory: ()=>getCommonSourceDirectory,
        getCommonSourceDirectoryOfConfig: ()=>getCommonSourceDirectoryOfConfig,
        getCompilerOptionValue: ()=>getCompilerOptionValue,
        getConditions: ()=>getConditions,
        getConfigFileParsingDiagnostics: ()=>getConfigFileParsingDiagnostics,
        getConstantValue: ()=>getConstantValue,
        getContainerFlags: ()=>getContainerFlags,
        getContainerNode: ()=>getContainerNode,
        getContainingClass: ()=>getContainingClass,
        getContainingClassExcludingClassDecorators: ()=>getContainingClassExcludingClassDecorators,
        getContainingClassStaticBlock: ()=>getContainingClassStaticBlock,
        getContainingFunction: ()=>getContainingFunction,
        getContainingFunctionDeclaration: ()=>getContainingFunctionDeclaration,
        getContainingFunctionOrClassStaticBlock: ()=>getContainingFunctionOrClassStaticBlock,
        getContainingNodeArray: ()=>getContainingNodeArray,
        getContainingObjectLiteralElement: ()=>getContainingObjectLiteralElement,
        getContextualTypeFromParent: ()=>getContextualTypeFromParent,
        getContextualTypeFromParentOrAncestorTypeNode: ()=>getContextualTypeFromParentOrAncestorTypeNode,
        getDeclarationDiagnostics: ()=>getDeclarationDiagnostics,
        getDeclarationEmitExtensionForPath: ()=>getDeclarationEmitExtensionForPath,
        getDeclarationEmitOutputFilePath: ()=>getDeclarationEmitOutputFilePath,
        getDeclarationEmitOutputFilePathWorker: ()=>getDeclarationEmitOutputFilePathWorker,
        getDeclarationFileExtension: ()=>getDeclarationFileExtension,
        getDeclarationFromName: ()=>getDeclarationFromName,
        getDeclarationModifierFlagsFromSymbol: ()=>getDeclarationModifierFlagsFromSymbol,
        getDeclarationOfKind: ()=>getDeclarationOfKind,
        getDeclarationsOfKind: ()=>getDeclarationsOfKind,
        getDeclaredExpandoInitializer: ()=>getDeclaredExpandoInitializer,
        getDecorators: ()=>getDecorators,
        getDefaultCompilerOptions: ()=>getDefaultCompilerOptions2,
        getDefaultFormatCodeSettings: ()=>getDefaultFormatCodeSettings,
        getDefaultLibFileName: ()=>getDefaultLibFileName,
        getDefaultLibFilePath: ()=>getDefaultLibFilePath,
        getDefaultLikeExportInfo: ()=>getDefaultLikeExportInfo,
        getDefaultLikeExportNameFromDeclaration: ()=>getDefaultLikeExportNameFromDeclaration,
        getDefaultResolutionModeForFileWorker: ()=>getDefaultResolutionModeForFileWorker,
        getDiagnosticText: ()=>getDiagnosticText,
        getDiagnosticsWithinSpan: ()=>getDiagnosticsWithinSpan,
        getDirectoryPath: ()=>getDirectoryPath,
        getDirectoryToWatchFailedLookupLocation: ()=>getDirectoryToWatchFailedLookupLocation,
        getDirectoryToWatchFailedLookupLocationFromTypeRoot: ()=>getDirectoryToWatchFailedLookupLocationFromTypeRoot,
        getDocumentPositionMapper: ()=>getDocumentPositionMapper,
        getDocumentSpansEqualityComparer: ()=>getDocumentSpansEqualityComparer,
        getESModuleInterop: ()=>getESModuleInterop,
        getEditsForFileRename: ()=>getEditsForFileRename,
        getEffectiveBaseTypeNode: ()=>getEffectiveBaseTypeNode,
        getEffectiveConstraintOfTypeParameter: ()=>getEffectiveConstraintOfTypeParameter,
        getEffectiveContainerForJSDocTemplateTag: ()=>getEffectiveContainerForJSDocTemplateTag,
        getEffectiveImplementsTypeNodes: ()=>getEffectiveImplementsTypeNodes,
        getEffectiveInitializer: ()=>getEffectiveInitializer,
        getEffectiveJSDocHost: ()=>getEffectiveJSDocHost,
        getEffectiveModifierFlags: ()=>getEffectiveModifierFlags,
        getEffectiveModifierFlagsAlwaysIncludeJSDoc: ()=>getEffectiveModifierFlagsAlwaysIncludeJSDoc,
        getEffectiveModifierFlagsNoCache: ()=>getEffectiveModifierFlagsNoCache,
        getEffectiveReturnTypeNode: ()=>getEffectiveReturnTypeNode,
        getEffectiveSetAccessorTypeAnnotationNode: ()=>getEffectiveSetAccessorTypeAnnotationNode,
        getEffectiveTypeAnnotationNode: ()=>getEffectiveTypeAnnotationNode,
        getEffectiveTypeParameterDeclarations: ()=>getEffectiveTypeParameterDeclarations,
        getEffectiveTypeRoots: ()=>getEffectiveTypeRoots,
        getElementOrPropertyAccessArgumentExpressionOrName: ()=>getElementOrPropertyAccessArgumentExpressionOrName,
        getElementOrPropertyAccessName: ()=>getElementOrPropertyAccessName,
        getElementsOfBindingOrAssignmentPattern: ()=>getElementsOfBindingOrAssignmentPattern,
        getEmitDeclarations: ()=>getEmitDeclarations,
        getEmitFlags: ()=>getEmitFlags,
        getEmitHelpers: ()=>getEmitHelpers,
        getEmitModuleDetectionKind: ()=>getEmitModuleDetectionKind,
        getEmitModuleFormatOfFileWorker: ()=>getEmitModuleFormatOfFileWorker,
        getEmitModuleKind: ()=>getEmitModuleKind,
        getEmitModuleResolutionKind: ()=>getEmitModuleResolutionKind,
        getEmitScriptTarget: ()=>getEmitScriptTarget,
        getEmitStandardClassFields: ()=>getEmitStandardClassFields,
        getEnclosingBlockScopeContainer: ()=>getEnclosingBlockScopeContainer,
        getEnclosingContainer: ()=>getEnclosingContainer,
        getEncodedSemanticClassifications: ()=>getEncodedSemanticClassifications,
        getEncodedSyntacticClassifications: ()=>getEncodedSyntacticClassifications,
        getEndLinePosition: ()=>getEndLinePosition,
        getEntityNameFromTypeNode: ()=>getEntityNameFromTypeNode,
        getEntrypointsFromPackageJsonInfo: ()=>getEntrypointsFromPackageJsonInfo,
        getErrorCountForSummary: ()=>getErrorCountForSummary,
        getErrorSpanForNode: ()=>getErrorSpanForNode,
        getErrorSummaryText: ()=>getErrorSummaryText,
        getEscapedTextOfIdentifierOrLiteral: ()=>getEscapedTextOfIdentifierOrLiteral,
        getEscapedTextOfJsxAttributeName: ()=>getEscapedTextOfJsxAttributeName,
        getEscapedTextOfJsxNamespacedName: ()=>getEscapedTextOfJsxNamespacedName,
        getExpandoInitializer: ()=>getExpandoInitializer,
        getExportAssignmentExpression: ()=>getExportAssignmentExpression,
        getExportInfoMap: ()=>getExportInfoMap,
        getExportNeedsImportStarHelper: ()=>getExportNeedsImportStarHelper,
        getExpressionAssociativity: ()=>getExpressionAssociativity,
        getExpressionPrecedence: ()=>getExpressionPrecedence,
        getExternalHelpersModuleName: ()=>getExternalHelpersModuleName,
        getExternalModuleImportEqualsDeclarationExpression: ()=>getExternalModuleImportEqualsDeclarationExpression,
        getExternalModuleName: ()=>getExternalModuleName,
        getExternalModuleNameFromDeclaration: ()=>getExternalModuleNameFromDeclaration,
        getExternalModuleNameFromPath: ()=>getExternalModuleNameFromPath,
        getExternalModuleNameLiteral: ()=>getExternalModuleNameLiteral,
        getExternalModuleRequireArgument: ()=>getExternalModuleRequireArgument,
        getFallbackOptions: ()=>getFallbackOptions,
        getFileEmitOutput: ()=>getFileEmitOutput,
        getFileMatcherPatterns: ()=>getFileMatcherPatterns,
        getFileNamesFromConfigSpecs: ()=>getFileNamesFromConfigSpecs,
        getFileWatcherEventKind: ()=>getFileWatcherEventKind,
        getFilesInErrorForSummary: ()=>getFilesInErrorForSummary,
        getFirstConstructorWithBody: ()=>getFirstConstructorWithBody,
        getFirstIdentifier: ()=>getFirstIdentifier,
        getFirstNonSpaceCharacterPosition: ()=>getFirstNonSpaceCharacterPosition,
        getFirstProjectOutput: ()=>getFirstProjectOutput,
        getFixableErrorSpanExpression: ()=>getFixableErrorSpanExpression,
        getFormatCodeSettingsForWriting: ()=>getFormatCodeSettingsForWriting,
        getFullWidth: ()=>getFullWidth,
        getFunctionFlags: ()=>getFunctionFlags,
        getHeritageClause: ()=>getHeritageClause,
        getHostSignatureFromJSDoc: ()=>getHostSignatureFromJSDoc,
        getIdentifierAutoGenerate: ()=>getIdentifierAutoGenerate,
        getIdentifierGeneratedImportReference: ()=>getIdentifierGeneratedImportReference,
        getIdentifierTypeArguments: ()=>getIdentifierTypeArguments,
        getImmediatelyInvokedFunctionExpression: ()=>getImmediatelyInvokedFunctionExpression,
        getImpliedNodeFormatForEmitWorker: ()=>getImpliedNodeFormatForEmitWorker,
        getImpliedNodeFormatForFile: ()=>getImpliedNodeFormatForFile,
        getImpliedNodeFormatForFileWorker: ()=>getImpliedNodeFormatForFileWorker,
        getImportNeedsImportDefaultHelper: ()=>getImportNeedsImportDefaultHelper,
        getImportNeedsImportStarHelper: ()=>getImportNeedsImportStarHelper,
        getIndentString: ()=>getIndentString,
        getInferredLibraryNameResolveFrom: ()=>getInferredLibraryNameResolveFrom,
        getInitializedVariables: ()=>getInitializedVariables,
        getInitializerOfBinaryExpression: ()=>getInitializerOfBinaryExpression,
        getInitializerOfBindingOrAssignmentElement: ()=>getInitializerOfBindingOrAssignmentElement,
        getInterfaceBaseTypeNodes: ()=>getInterfaceBaseTypeNodes,
        getInternalEmitFlags: ()=>getInternalEmitFlags,
        getInvokedExpression: ()=>getInvokedExpression,
        getIsFileExcluded: ()=>getIsFileExcluded,
        getIsolatedModules: ()=>getIsolatedModules,
        getJSDocAugmentsTag: ()=>getJSDocAugmentsTag,
        getJSDocClassTag: ()=>getJSDocClassTag,
        getJSDocCommentRanges: ()=>getJSDocCommentRanges,
        getJSDocCommentsAndTags: ()=>getJSDocCommentsAndTags,
        getJSDocDeprecatedTag: ()=>getJSDocDeprecatedTag,
        getJSDocDeprecatedTagNoCache: ()=>getJSDocDeprecatedTagNoCache,
        getJSDocEnumTag: ()=>getJSDocEnumTag,
        getJSDocHost: ()=>getJSDocHost,
        getJSDocImplementsTags: ()=>getJSDocImplementsTags,
        getJSDocOverloadTags: ()=>getJSDocOverloadTags,
        getJSDocOverrideTagNoCache: ()=>getJSDocOverrideTagNoCache,
        getJSDocParameterTags: ()=>getJSDocParameterTags,
        getJSDocParameterTagsNoCache: ()=>getJSDocParameterTagsNoCache,
        getJSDocPrivateTag: ()=>getJSDocPrivateTag,
        getJSDocPrivateTagNoCache: ()=>getJSDocPrivateTagNoCache,
        getJSDocProtectedTag: ()=>getJSDocProtectedTag,
        getJSDocProtectedTagNoCache: ()=>getJSDocProtectedTagNoCache,
        getJSDocPublicTag: ()=>getJSDocPublicTag,
        getJSDocPublicTagNoCache: ()=>getJSDocPublicTagNoCache,
        getJSDocReadonlyTag: ()=>getJSDocReadonlyTag,
        getJSDocReadonlyTagNoCache: ()=>getJSDocReadonlyTagNoCache,
        getJSDocReturnTag: ()=>getJSDocReturnTag,
        getJSDocReturnType: ()=>getJSDocReturnType,
        getJSDocRoot: ()=>getJSDocRoot,
        getJSDocSatisfiesExpressionType: ()=>getJSDocSatisfiesExpressionType,
        getJSDocSatisfiesTag: ()=>getJSDocSatisfiesTag,
        getJSDocTags: ()=>getJSDocTags,
        getJSDocTemplateTag: ()=>getJSDocTemplateTag,
        getJSDocThisTag: ()=>getJSDocThisTag,
        getJSDocType: ()=>getJSDocType,
        getJSDocTypeAliasName: ()=>getJSDocTypeAliasName,
        getJSDocTypeAssertionType: ()=>getJSDocTypeAssertionType,
        getJSDocTypeParameterDeclarations: ()=>getJSDocTypeParameterDeclarations,
        getJSDocTypeParameterTags: ()=>getJSDocTypeParameterTags,
        getJSDocTypeParameterTagsNoCache: ()=>getJSDocTypeParameterTagsNoCache,
        getJSDocTypeTag: ()=>getJSDocTypeTag,
        getJSXImplicitImportBase: ()=>getJSXImplicitImportBase,
        getJSXRuntimeImport: ()=>getJSXRuntimeImport,
        getJSXTransformEnabled: ()=>getJSXTransformEnabled,
        getKeyForCompilerOptions: ()=>getKeyForCompilerOptions,
        getLanguageVariant: ()=>getLanguageVariant,
        getLastChild: ()=>getLastChild,
        getLeadingCommentRanges: ()=>getLeadingCommentRanges,
        getLeadingCommentRangesOfNode: ()=>getLeadingCommentRangesOfNode,
        getLeftmostAccessExpression: ()=>getLeftmostAccessExpression,
        getLeftmostExpression: ()=>getLeftmostExpression,
        getLibFileNameFromLibReference: ()=>getLibFileNameFromLibReference,
        getLibNameFromLibReference: ()=>getLibNameFromLibReference,
        getLibraryNameFromLibFileName: ()=>getLibraryNameFromLibFileName,
        getLineAndCharacterOfPosition: ()=>getLineAndCharacterOfPosition,
        getLineInfo: ()=>getLineInfo,
        getLineOfLocalPosition: ()=>getLineOfLocalPosition,
        getLineStartPositionForPosition: ()=>getLineStartPositionForPosition,
        getLineStarts: ()=>getLineStarts,
        getLinesBetweenPositionAndNextNonWhitespaceCharacter: ()=>getLinesBetweenPositionAndNextNonWhitespaceCharacter,
        getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter: ()=>getLinesBetweenPositionAndPrecedingNonWhitespaceCharacter,
        getLinesBetweenPositions: ()=>getLinesBetweenPositions,
        getLinesBetweenRangeEndAndRangeStart: ()=>getLinesBetweenRangeEndAndRangeStart,
        getLinesBetweenRangeEndPositions: ()=>getLinesBetweenRangeEndPositions,
        getLiteralText: ()=>getLiteralText,
        getLocalNameForExternalImport: ()=>getLocalNameForExternalImport,
        getLocalSymbolForExportDefault: ()=>getLocalSymbolForExportDefault,
        getLocaleSpecificMessage: ()=>getLocaleSpecificMessage,
        getLocaleTimeString: ()=>getLocaleTimeString,
        getMappedContextSpan: ()=>getMappedContextSpan,
        getMappedDocumentSpan: ()=>getMappedDocumentSpan,
        getMappedLocation: ()=>getMappedLocation,
        getMatchedFileSpec: ()=>getMatchedFileSpec,
        getMatchedIncludeSpec: ()=>getMatchedIncludeSpec,
        getMeaningFromDeclaration: ()=>getMeaningFromDeclaration,
        getMeaningFromLocation: ()=>getMeaningFromLocation,
        getMembersOfDeclaration: ()=>getMembersOfDeclaration,
        getModeForFileReference: ()=>getModeForFileReference,
        getModeForResolutionAtIndex: ()=>getModeForResolutionAtIndex,
        getModeForUsageLocation: ()=>getModeForUsageLocation,
        getModifiedTime: ()=>getModifiedTime,
        getModifiers: ()=>getModifiers,
        getModuleInstanceState: ()=>getModuleInstanceState,
        getModuleNameStringLiteralAt: ()=>getModuleNameStringLiteralAt,
        getModuleSpecifierEndingPreference: ()=>getModuleSpecifierEndingPreference,
        getModuleSpecifierResolverHost: ()=>getModuleSpecifierResolverHost,
        getNameForExportedSymbol: ()=>getNameForExportedSymbol,
        getNameFromImportAttribute: ()=>getNameFromImportAttribute,
        getNameFromIndexInfo: ()=>getNameFromIndexInfo,
        getNameFromPropertyName: ()=>getNameFromPropertyName,
        getNameOfAccessExpression: ()=>getNameOfAccessExpression,
        getNameOfCompilerOptionValue: ()=>getNameOfCompilerOptionValue,
        getNameOfDeclaration: ()=>getNameOfDeclaration,
        getNameOfExpando: ()=>getNameOfExpando,
        getNameOfJSDocTypedef: ()=>getNameOfJSDocTypedef,
        getNameOfScriptTarget: ()=>getNameOfScriptTarget,
        getNameOrArgument: ()=>getNameOrArgument,
        getNameTable: ()=>getNameTable,
        getNamespaceDeclarationNode: ()=>getNamespaceDeclarationNode,
        getNewLineCharacter: ()=>getNewLineCharacter,
        getNewLineKind: ()=>getNewLineKind,
        getNewLineOrDefaultFromHost: ()=>getNewLineOrDefaultFromHost,
        getNewTargetContainer: ()=>getNewTargetContainer,
        getNextJSDocCommentLocation: ()=>getNextJSDocCommentLocation,
        getNodeChildren: ()=>getNodeChildren,
        getNodeForGeneratedName: ()=>getNodeForGeneratedName,
        getNodeId: ()=>getNodeId,
        getNodeKind: ()=>getNodeKind,
        getNodeModifiers: ()=>getNodeModifiers,
        getNodeModulePathParts: ()=>getNodeModulePathParts,
        getNonAssignedNameOfDeclaration: ()=>getNonAssignedNameOfDeclaration,
        getNonAssignmentOperatorForCompoundAssignment: ()=>getNonAssignmentOperatorForCompoundAssignment,
        getNonAugmentationDeclaration: ()=>getNonAugmentationDeclaration,
        getNonDecoratorTokenPosOfNode: ()=>getNonDecoratorTokenPosOfNode,
        getNonIncrementalBuildInfoRoots: ()=>getNonIncrementalBuildInfoRoots,
        getNonModifierTokenPosOfNode: ()=>getNonModifierTokenPosOfNode,
        getNormalizedAbsolutePath: ()=>getNormalizedAbsolutePath,
        getNormalizedAbsolutePathWithoutRoot: ()=>getNormalizedAbsolutePathWithoutRoot,
        getNormalizedPathComponents: ()=>getNormalizedPathComponents,
        getObjectFlags: ()=>getObjectFlags,
        getOperatorAssociativity: ()=>getOperatorAssociativity,
        getOperatorPrecedence: ()=>getOperatorPrecedence,
        getOptionFromName: ()=>getOptionFromName,
        getOptionsForLibraryResolution: ()=>getOptionsForLibraryResolution,
        getOptionsNameMap: ()=>getOptionsNameMap,
        getOptionsSyntaxByArrayElementValue: ()=>getOptionsSyntaxByArrayElementValue,
        getOptionsSyntaxByValue: ()=>getOptionsSyntaxByValue,
        getOrCreateEmitNode: ()=>getOrCreateEmitNode,
        getOrUpdate: ()=>getOrUpdate,
        getOriginalNode: ()=>getOriginalNode,
        getOriginalNodeId: ()=>getOriginalNodeId,
        getOutputDeclarationFileName: ()=>getOutputDeclarationFileName,
        getOutputDeclarationFileNameWorker: ()=>getOutputDeclarationFileNameWorker,
        getOutputExtension: ()=>getOutputExtension,
        getOutputFileNames: ()=>getOutputFileNames,
        getOutputJSFileNameWorker: ()=>getOutputJSFileNameWorker,
        getOutputPathsFor: ()=>getOutputPathsFor,
        getOwnEmitOutputFilePath: ()=>getOwnEmitOutputFilePath,
        getOwnKeys: ()=>getOwnKeys,
        getOwnValues: ()=>getOwnValues,
        getPackageJsonTypesVersionsPaths: ()=>getPackageJsonTypesVersionsPaths,
        getPackageNameFromTypesPackageName: ()=>getPackageNameFromTypesPackageName,
        getPackageScopeForPath: ()=>getPackageScopeForPath,
        getParameterSymbolFromJSDoc: ()=>getParameterSymbolFromJSDoc,
        getParentNodeInSpan: ()=>getParentNodeInSpan,
        getParseTreeNode: ()=>getParseTreeNode,
        getParsedCommandLineOfConfigFile: ()=>getParsedCommandLineOfConfigFile,
        getPathComponents: ()=>getPathComponents,
        getPathFromPathComponents: ()=>getPathFromPathComponents,
        getPathUpdater: ()=>getPathUpdater,
        getPathsBasePath: ()=>getPathsBasePath,
        getPatternFromSpec: ()=>getPatternFromSpec,
        getPendingEmitKindWithSeen: ()=>getPendingEmitKindWithSeen,
        getPositionOfLineAndCharacter: ()=>getPositionOfLineAndCharacter,
        getPossibleGenericSignatures: ()=>getPossibleGenericSignatures,
        getPossibleOriginalInputExtensionForExtension: ()=>getPossibleOriginalInputExtensionForExtension,
        getPossibleOriginalInputPathWithoutChangingExt: ()=>getPossibleOriginalInputPathWithoutChangingExt,
        getPossibleTypeArgumentsInfo: ()=>getPossibleTypeArgumentsInfo,
        getPreEmitDiagnostics: ()=>getPreEmitDiagnostics,
        getPrecedingNonSpaceCharacterPosition: ()=>getPrecedingNonSpaceCharacterPosition,
        getPrivateIdentifier: ()=>getPrivateIdentifier,
        getProperties: ()=>getProperties,
        getProperty: ()=>getProperty,
        getPropertyAssignmentAliasLikeExpression: ()=>getPropertyAssignmentAliasLikeExpression,
        getPropertyNameForPropertyNameNode: ()=>getPropertyNameForPropertyNameNode,
        getPropertyNameFromType: ()=>getPropertyNameFromType,
        getPropertyNameOfBindingOrAssignmentElement: ()=>getPropertyNameOfBindingOrAssignmentElement,
        getPropertySymbolFromBindingElement: ()=>getPropertySymbolFromBindingElement,
        getPropertySymbolsFromContextualType: ()=>getPropertySymbolsFromContextualType,
        getQuoteFromPreference: ()=>getQuoteFromPreference,
        getQuotePreference: ()=>getQuotePreference,
        getRangesWhere: ()=>getRangesWhere,
        getRefactorContextSpan: ()=>getRefactorContextSpan,
        getReferencedFileLocation: ()=>getReferencedFileLocation,
        getRegexFromPattern: ()=>getRegexFromPattern,
        getRegularExpressionForWildcard: ()=>getRegularExpressionForWildcard,
        getRegularExpressionsForWildcards: ()=>getRegularExpressionsForWildcards,
        getRelativePathFromDirectory: ()=>getRelativePathFromDirectory,
        getRelativePathFromFile: ()=>getRelativePathFromFile,
        getRelativePathToDirectoryOrUrl: ()=>getRelativePathToDirectoryOrUrl,
        getRenameLocation: ()=>getRenameLocation,
        getReplacementSpanForContextToken: ()=>getReplacementSpanForContextToken,
        getResolutionDiagnostic: ()=>getResolutionDiagnostic,
        getResolutionModeOverride: ()=>getResolutionModeOverride,
        getResolveJsonModule: ()=>getResolveJsonModule,
        getResolvePackageJsonExports: ()=>getResolvePackageJsonExports,
        getResolvePackageJsonImports: ()=>getResolvePackageJsonImports,
        getResolvedExternalModuleName: ()=>getResolvedExternalModuleName,
        getResolvedModuleFromResolution: ()=>getResolvedModuleFromResolution,
        getResolvedTypeReferenceDirectiveFromResolution: ()=>getResolvedTypeReferenceDirectiveFromResolution,
        getRestIndicatorOfBindingOrAssignmentElement: ()=>getRestIndicatorOfBindingOrAssignmentElement,
        getRestParameterElementType: ()=>getRestParameterElementType,
        getRightMostAssignedExpression: ()=>getRightMostAssignedExpression,
        getRootDeclaration: ()=>getRootDeclaration,
        getRootDirectoryOfResolutionCache: ()=>getRootDirectoryOfResolutionCache,
        getRootLength: ()=>getRootLength,
        getScriptKind: ()=>getScriptKind,
        getScriptKindFromFileName: ()=>getScriptKindFromFileName,
        getScriptTargetFeatures: ()=>getScriptTargetFeatures,
        getSelectedEffectiveModifierFlags: ()=>getSelectedEffectiveModifierFlags,
        getSelectedSyntacticModifierFlags: ()=>getSelectedSyntacticModifierFlags,
        getSemanticClassifications: ()=>getSemanticClassifications,
        getSemanticJsxChildren: ()=>getSemanticJsxChildren,
        getSetAccessorTypeAnnotationNode: ()=>getSetAccessorTypeAnnotationNode,
        getSetAccessorValueParameter: ()=>getSetAccessorValueParameter,
        getSetExternalModuleIndicator: ()=>getSetExternalModuleIndicator,
        getShebang: ()=>getShebang,
        getSingleVariableOfVariableStatement: ()=>getSingleVariableOfVariableStatement,
        getSnapshotText: ()=>getSnapshotText,
        getSnippetElement: ()=>getSnippetElement,
        getSourceFileOfModule: ()=>getSourceFileOfModule,
        getSourceFileOfNode: ()=>getSourceFileOfNode,
        getSourceFilePathInNewDir: ()=>getSourceFilePathInNewDir,
        getSourceFileVersionAsHashFromText: ()=>getSourceFileVersionAsHashFromText,
        getSourceFilesToEmit: ()=>getSourceFilesToEmit,
        getSourceMapRange: ()=>getSourceMapRange,
        getSourceMapper: ()=>getSourceMapper,
        getSourceTextOfNodeFromSourceFile: ()=>getSourceTextOfNodeFromSourceFile,
        getSpanOfTokenAtPosition: ()=>getSpanOfTokenAtPosition,
        getSpellingSuggestion: ()=>getSpellingSuggestion,
        getStartPositionOfLine: ()=>getStartPositionOfLine,
        getStartPositionOfRange: ()=>getStartPositionOfRange,
        getStartsOnNewLine: ()=>getStartsOnNewLine,
        getStaticPropertiesAndClassStaticBlock: ()=>getStaticPropertiesAndClassStaticBlock,
        getStrictOptionValue: ()=>getStrictOptionValue,
        getStringComparer: ()=>getStringComparer,
        getSubPatternFromSpec: ()=>getSubPatternFromSpec,
        getSuperCallFromStatement: ()=>getSuperCallFromStatement,
        getSuperContainer: ()=>getSuperContainer,
        getSupportedCodeFixes: ()=>getSupportedCodeFixes,
        getSupportedExtensions: ()=>getSupportedExtensions,
        getSupportedExtensionsWithJsonIfResolveJsonModule: ()=>getSupportedExtensionsWithJsonIfResolveJsonModule,
        getSwitchedType: ()=>getSwitchedType,
        getSymbolId: ()=>getSymbolId,
        getSymbolNameForPrivateIdentifier: ()=>getSymbolNameForPrivateIdentifier,
        getSymbolTarget: ()=>getSymbolTarget,
        getSyntacticClassifications: ()=>getSyntacticClassifications,
        getSyntacticModifierFlags: ()=>getSyntacticModifierFlags,
        getSyntacticModifierFlagsNoCache: ()=>getSyntacticModifierFlagsNoCache,
        getSynthesizedDeepClone: ()=>getSynthesizedDeepClone,
        getSynthesizedDeepCloneWithReplacements: ()=>getSynthesizedDeepCloneWithReplacements,
        getSynthesizedDeepClones: ()=>getSynthesizedDeepClones,
        getSynthesizedDeepClonesWithReplacements: ()=>getSynthesizedDeepClonesWithReplacements,
        getSyntheticLeadingComments: ()=>getSyntheticLeadingComments,
        getSyntheticTrailingComments: ()=>getSyntheticTrailingComments,
        getTargetLabel: ()=>getTargetLabel,
        getTargetOfBindingOrAssignmentElement: ()=>getTargetOfBindingOrAssignmentElement,
        getTemporaryModuleResolutionState: ()=>getTemporaryModuleResolutionState,
        getTextOfConstantValue: ()=>getTextOfConstantValue,
        getTextOfIdentifierOrLiteral: ()=>getTextOfIdentifierOrLiteral,
        getTextOfJSDocComment: ()=>getTextOfJSDocComment,
        getTextOfJsxAttributeName: ()=>getTextOfJsxAttributeName,
        getTextOfJsxNamespacedName: ()=>getTextOfJsxNamespacedName,
        getTextOfNode: ()=>getTextOfNode,
        getTextOfNodeFromSourceText: ()=>getTextOfNodeFromSourceText,
        getTextOfPropertyName: ()=>getTextOfPropertyName,
        getThisContainer: ()=>getThisContainer,
        getThisParameter: ()=>getThisParameter,
        getTokenAtPosition: ()=>getTokenAtPosition,
        getTokenPosOfNode: ()=>getTokenPosOfNode,
        getTokenSourceMapRange: ()=>getTokenSourceMapRange,
        getTouchingPropertyName: ()=>getTouchingPropertyName,
        getTouchingToken: ()=>getTouchingToken,
        getTrailingCommentRanges: ()=>getTrailingCommentRanges,
        getTrailingSemicolonDeferringWriter: ()=>getTrailingSemicolonDeferringWriter,
        getTransformers: ()=>getTransformers,
        getTsBuildInfoEmitOutputFilePath: ()=>getTsBuildInfoEmitOutputFilePath,
        getTsConfigObjectLiteralExpression: ()=>getTsConfigObjectLiteralExpression,
        getTsConfigPropArrayElementValue: ()=>getTsConfigPropArrayElementValue,
        getTypeAnnotationNode: ()=>getTypeAnnotationNode,
        getTypeArgumentOrTypeParameterList: ()=>getTypeArgumentOrTypeParameterList,
        getTypeKeywordOfTypeOnlyImport: ()=>getTypeKeywordOfTypeOnlyImport,
        getTypeNode: ()=>getTypeNode,
        getTypeNodeIfAccessible: ()=>getTypeNodeIfAccessible,
        getTypeParameterFromJsDoc: ()=>getTypeParameterFromJsDoc,
        getTypeParameterOwner: ()=>getTypeParameterOwner,
        getTypesPackageName: ()=>getTypesPackageName,
        getUILocale: ()=>getUILocale,
        getUniqueName: ()=>getUniqueName,
        getUniqueSymbolId: ()=>getUniqueSymbolId,
        getUseDefineForClassFields: ()=>getUseDefineForClassFields,
        getWatchErrorSummaryDiagnosticMessage: ()=>getWatchErrorSummaryDiagnosticMessage,
        getWatchFactory: ()=>getWatchFactory,
        group: ()=>group,
        groupBy: ()=>groupBy,
        guessIndentation: ()=>guessIndentation,
        handleNoEmitOptions: ()=>handleNoEmitOptions,
        handleWatchOptionsConfigDirTemplateSubstitution: ()=>handleWatchOptionsConfigDirTemplateSubstitution,
        hasAbstractModifier: ()=>hasAbstractModifier,
        hasAccessorModifier: ()=>hasAccessorModifier,
        hasAmbientModifier: ()=>hasAmbientModifier,
        hasChangesInResolutions: ()=>hasChangesInResolutions,
        hasContextSensitiveParameters: ()=>hasContextSensitiveParameters,
        hasDecorators: ()=>hasDecorators,
        hasDocComment: ()=>hasDocComment,
        hasDynamicName: ()=>hasDynamicName,
        hasEffectiveModifier: ()=>hasEffectiveModifier,
        hasEffectiveModifiers: ()=>hasEffectiveModifiers,
        hasEffectiveReadonlyModifier: ()=>hasEffectiveReadonlyModifier,
        hasExtension: ()=>hasExtension,
        hasImplementationTSFileExtension: ()=>hasImplementationTSFileExtension,
        hasIndexSignature: ()=>hasIndexSignature,
        hasInferredType: ()=>hasInferredType,
        hasInitializer: ()=>hasInitializer,
        hasInvalidEscape: ()=>hasInvalidEscape,
        hasJSDocNodes: ()=>hasJSDocNodes,
        hasJSDocParameterTags: ()=>hasJSDocParameterTags,
        hasJSFileExtension: ()=>hasJSFileExtension,
        hasJsonModuleEmitEnabled: ()=>hasJsonModuleEmitEnabled,
        hasOnlyExpressionInitializer: ()=>hasOnlyExpressionInitializer,
        hasOverrideModifier: ()=>hasOverrideModifier,
        hasPossibleExternalModuleReference: ()=>hasPossibleExternalModuleReference,
        hasProperty: ()=>hasProperty,
        hasPropertyAccessExpressionWithName: ()=>hasPropertyAccessExpressionWithName,
        hasQuestionToken: ()=>hasQuestionToken,
        hasRecordedExternalHelpers: ()=>hasRecordedExternalHelpers,
        hasResolutionModeOverride: ()=>hasResolutionModeOverride,
        hasRestParameter: ()=>hasRestParameter,
        hasScopeMarker: ()=>hasScopeMarker,
        hasStaticModifier: ()=>hasStaticModifier,
        hasSyntacticModifier: ()=>hasSyntacticModifier,
        hasSyntacticModifiers: ()=>hasSyntacticModifiers,
        hasTSFileExtension: ()=>hasTSFileExtension,
        hasTabstop: ()=>hasTabstop,
        hasTrailingDirectorySeparator: ()=>hasTrailingDirectorySeparator,
        hasType: ()=>hasType,
        hasTypeArguments: ()=>hasTypeArguments,
        hasZeroOrOneAsteriskCharacter: ()=>hasZeroOrOneAsteriskCharacter,
        hostGetCanonicalFileName: ()=>hostGetCanonicalFileName,
        hostUsesCaseSensitiveFileNames: ()=>hostUsesCaseSensitiveFileNames,
        idText: ()=>idText,
        identifierIsThisKeyword: ()=>identifierIsThisKeyword,
        identifierToKeywordKind: ()=>identifierToKeywordKind,
        identity: ()=>identity,
        identitySourceMapConsumer: ()=>identitySourceMapConsumer,
        ignoreSourceNewlines: ()=>ignoreSourceNewlines,
        ignoredPaths: ()=>ignoredPaths,
        importFromModuleSpecifier: ()=>importFromModuleSpecifier,
        importSyntaxAffectsModuleResolution: ()=>importSyntaxAffectsModuleResolution,
        indexOfAnyCharCode: ()=>indexOfAnyCharCode,
        indexOfNode: ()=>indexOfNode,
        indicesOf: ()=>indicesOf,
        inferredTypesContainingFile: ()=>inferredTypesContainingFile,
        injectClassNamedEvaluationHelperBlockIfMissing: ()=>injectClassNamedEvaluationHelperBlockIfMissing,
        injectClassThisAssignmentIfMissing: ()=>injectClassThisAssignmentIfMissing,
        insertImports: ()=>insertImports,
        insertSorted: ()=>insertSorted,
        insertStatementAfterCustomPrologue: ()=>insertStatementAfterCustomPrologue,
        insertStatementAfterStandardPrologue: ()=>insertStatementAfterStandardPrologue,
        insertStatementsAfterCustomPrologue: ()=>insertStatementsAfterCustomPrologue,
        insertStatementsAfterStandardPrologue: ()=>insertStatementsAfterStandardPrologue,
        intersperse: ()=>intersperse,
        intrinsicTagNameToString: ()=>intrinsicTagNameToString,
        introducesArgumentsExoticObject: ()=>introducesArgumentsExoticObject,
        inverseJsxOptionMap: ()=>inverseJsxOptionMap,
        isAbstractConstructorSymbol: ()=>isAbstractConstructorSymbol,
        isAbstractModifier: ()=>isAbstractModifier,
        isAccessExpression: ()=>isAccessExpression,
        isAccessibilityModifier: ()=>isAccessibilityModifier,
        isAccessor: ()=>isAccessor,
        isAccessorModifier: ()=>isAccessorModifier,
        isAliasableExpression: ()=>isAliasableExpression,
        isAmbientModule: ()=>isAmbientModule,
        isAmbientPropertyDeclaration: ()=>isAmbientPropertyDeclaration,
        isAnyDirectorySeparator: ()=>isAnyDirectorySeparator,
        isAnyImportOrBareOrAccessedRequire: ()=>isAnyImportOrBareOrAccessedRequire,
        isAnyImportOrReExport: ()=>isAnyImportOrReExport,
        isAnyImportOrRequireStatement: ()=>isAnyImportOrRequireStatement,
        isAnyImportSyntax: ()=>isAnyImportSyntax,
        isAnySupportedFileExtension: ()=>isAnySupportedFileExtension,
        isApplicableVersionedTypesKey: ()=>isApplicableVersionedTypesKey,
        isArgumentExpressionOfElementAccess: ()=>isArgumentExpressionOfElementAccess,
        isArray: ()=>isArray,
        isArrayBindingElement: ()=>isArrayBindingElement,
        isArrayBindingOrAssignmentElement: ()=>isArrayBindingOrAssignmentElement,
        isArrayBindingOrAssignmentPattern: ()=>isArrayBindingOrAssignmentPattern,
        isArrayBindingPattern: ()=>isArrayBindingPattern,
        isArrayLiteralExpression: ()=>isArrayLiteralExpression,
        isArrayLiteralOrObjectLiteralDestructuringPattern: ()=>isArrayLiteralOrObjectLiteralDestructuringPattern,
        isArrayTypeNode: ()=>isArrayTypeNode,
        isArrowFunction: ()=>isArrowFunction,
        isAsExpression: ()=>isAsExpression,
        isAssertClause: ()=>isAssertClause,
        isAssertEntry: ()=>isAssertEntry,
        isAssertionExpression: ()=>isAssertionExpression,
        isAssertsKeyword: ()=>isAssertsKeyword,
        isAssignmentDeclaration: ()=>isAssignmentDeclaration,
        isAssignmentExpression: ()=>isAssignmentExpression,
        isAssignmentOperator: ()=>isAssignmentOperator,
        isAssignmentPattern: ()=>isAssignmentPattern,
        isAssignmentTarget: ()=>isAssignmentTarget,
        isAsteriskToken: ()=>isAsteriskToken,
        isAsyncFunction: ()=>isAsyncFunction,
        isAsyncModifier: ()=>isAsyncModifier,
        isAutoAccessorPropertyDeclaration: ()=>isAutoAccessorPropertyDeclaration,
        isAwaitExpression: ()=>isAwaitExpression,
        isAwaitKeyword: ()=>isAwaitKeyword,
        isBigIntLiteral: ()=>isBigIntLiteral,
        isBinaryExpression: ()=>isBinaryExpression,
        isBinaryLogicalOperator: ()=>isBinaryLogicalOperator,
        isBinaryOperatorToken: ()=>isBinaryOperatorToken,
        isBindableObjectDefinePropertyCall: ()=>isBindableObjectDefinePropertyCall,
        isBindableStaticAccessExpression: ()=>isBindableStaticAccessExpression,
        isBindableStaticElementAccessExpression: ()=>isBindableStaticElementAccessExpression,
        isBindableStaticNameExpression: ()=>isBindableStaticNameExpression,
        isBindingElement: ()=>isBindingElement,
        isBindingElementOfBareOrAccessedRequire: ()=>isBindingElementOfBareOrAccessedRequire,
        isBindingName: ()=>isBindingName,
        isBindingOrAssignmentElement: ()=>isBindingOrAssignmentElement,
        isBindingOrAssignmentPattern: ()=>isBindingOrAssignmentPattern,
        isBindingPattern: ()=>isBindingPattern,
        isBlock: ()=>isBlock,
        isBlockLike: ()=>isBlockLike,
        isBlockOrCatchScoped: ()=>isBlockOrCatchScoped,
        isBlockScope: ()=>isBlockScope,
        isBlockScopedContainerTopLevel: ()=>isBlockScopedContainerTopLevel,
        isBooleanLiteral: ()=>isBooleanLiteral,
        isBreakOrContinueStatement: ()=>isBreakOrContinueStatement,
        isBreakStatement: ()=>isBreakStatement,
        isBuildCommand: ()=>isBuildCommand,
        isBuildInfoFile: ()=>isBuildInfoFile,
        isBuilderProgram: ()=>isBuilderProgram,
        isBundle: ()=>isBundle,
        isCallChain: ()=>isCallChain,
        isCallExpression: ()=>isCallExpression,
        isCallExpressionTarget: ()=>isCallExpressionTarget,
        isCallLikeExpression: ()=>isCallLikeExpression,
        isCallLikeOrFunctionLikeExpression: ()=>isCallLikeOrFunctionLikeExpression,
        isCallOrNewExpression: ()=>isCallOrNewExpression,
        isCallOrNewExpressionTarget: ()=>isCallOrNewExpressionTarget,
        isCallSignatureDeclaration: ()=>isCallSignatureDeclaration,
        isCallToHelper: ()=>isCallToHelper,
        isCaseBlock: ()=>isCaseBlock,
        isCaseClause: ()=>isCaseClause,
        isCaseKeyword: ()=>isCaseKeyword,
        isCaseOrDefaultClause: ()=>isCaseOrDefaultClause,
        isCatchClause: ()=>isCatchClause,
        isCatchClauseVariableDeclaration: ()=>isCatchClauseVariableDeclaration,
        isCatchClauseVariableDeclarationOrBindingElement: ()=>isCatchClauseVariableDeclarationOrBindingElement,
        isCheckJsEnabledForFile: ()=>isCheckJsEnabledForFile,
        isCircularBuildOrder: ()=>isCircularBuildOrder,
        isClassDeclaration: ()=>isClassDeclaration,
        isClassElement: ()=>isClassElement,
        isClassExpression: ()=>isClassExpression,
        isClassInstanceProperty: ()=>isClassInstanceProperty,
        isClassLike: ()=>isClassLike,
        isClassMemberModifier: ()=>isClassMemberModifier,
        isClassNamedEvaluationHelperBlock: ()=>isClassNamedEvaluationHelperBlock,
        isClassOrTypeElement: ()=>isClassOrTypeElement,
        isClassStaticBlockDeclaration: ()=>isClassStaticBlockDeclaration,
        isClassThisAssignmentBlock: ()=>isClassThisAssignmentBlock,
        isColonToken: ()=>isColonToken,
        isCommaExpression: ()=>isCommaExpression,
        isCommaListExpression: ()=>isCommaListExpression,
        isCommaSequence: ()=>isCommaSequence,
        isCommaToken: ()=>isCommaToken,
        isComment: ()=>isComment,
        isCommonJsExportPropertyAssignment: ()=>isCommonJsExportPropertyAssignment,
        isCommonJsExportedExpression: ()=>isCommonJsExportedExpression,
        isCompoundAssignment: ()=>isCompoundAssignment,
        isComputedNonLiteralName: ()=>isComputedNonLiteralName,
        isComputedPropertyName: ()=>isComputedPropertyName,
        isConciseBody: ()=>isConciseBody,
        isConditionalExpression: ()=>isConditionalExpression,
        isConditionalTypeNode: ()=>isConditionalTypeNode,
        isConstAssertion: ()=>isConstAssertion,
        isConstTypeReference: ()=>isConstTypeReference,
        isConstructSignatureDeclaration: ()=>isConstructSignatureDeclaration,
        isConstructorDeclaration: ()=>isConstructorDeclaration,
        isConstructorTypeNode: ()=>isConstructorTypeNode,
        isContextualKeyword: ()=>isContextualKeyword,
        isContinueStatement: ()=>isContinueStatement,
        isCustomPrologue: ()=>isCustomPrologue,
        isDebuggerStatement: ()=>isDebuggerStatement,
        isDeclaration: ()=>isDeclaration,
        isDeclarationBindingElement: ()=>isDeclarationBindingElement,
        isDeclarationFileName: ()=>isDeclarationFileName,
        isDeclarationName: ()=>isDeclarationName,
        isDeclarationNameOfEnumOrNamespace: ()=>isDeclarationNameOfEnumOrNamespace,
        isDeclarationReadonly: ()=>isDeclarationReadonly,
        isDeclarationStatement: ()=>isDeclarationStatement,
        isDeclarationWithTypeParameterChildren: ()=>isDeclarationWithTypeParameterChildren,
        isDeclarationWithTypeParameters: ()=>isDeclarationWithTypeParameters,
        isDecorator: ()=>isDecorator,
        isDecoratorTarget: ()=>isDecoratorTarget,
        isDefaultClause: ()=>isDefaultClause,
        isDefaultImport: ()=>isDefaultImport,
        isDefaultModifier: ()=>isDefaultModifier,
        isDefaultedExpandoInitializer: ()=>isDefaultedExpandoInitializer,
        isDeleteExpression: ()=>isDeleteExpression,
        isDeleteTarget: ()=>isDeleteTarget,
        isDeprecatedDeclaration: ()=>isDeprecatedDeclaration,
        isDestructuringAssignment: ()=>isDestructuringAssignment,
        isDiskPathRoot: ()=>isDiskPathRoot,
        isDoStatement: ()=>isDoStatement,
        isDocumentRegistryEntry: ()=>isDocumentRegistryEntry,
        isDotDotDotToken: ()=>isDotDotDotToken,
        isDottedName: ()=>isDottedName,
        isDynamicName: ()=>isDynamicName,
        isEffectiveExternalModule: ()=>isEffectiveExternalModule,
        isEffectiveStrictModeSourceFile: ()=>isEffectiveStrictModeSourceFile,
        isElementAccessChain: ()=>isElementAccessChain,
        isElementAccessExpression: ()=>isElementAccessExpression,
        isEmittedFileOfProgram: ()=>isEmittedFileOfProgram,
        isEmptyArrayLiteral: ()=>isEmptyArrayLiteral,
        isEmptyBindingElement: ()=>isEmptyBindingElement,
        isEmptyBindingPattern: ()=>isEmptyBindingPattern,
        isEmptyObjectLiteral: ()=>isEmptyObjectLiteral,
        isEmptyStatement: ()=>isEmptyStatement,
        isEmptyStringLiteral: ()=>isEmptyStringLiteral,
        isEntityName: ()=>isEntityName,
        isEntityNameExpression: ()=>isEntityNameExpression,
        isEnumConst: ()=>isEnumConst,
        isEnumDeclaration: ()=>isEnumDeclaration,
        isEnumMember: ()=>isEnumMember,
        isEqualityOperatorKind: ()=>isEqualityOperatorKind,
        isEqualsGreaterThanToken: ()=>isEqualsGreaterThanToken,
        isExclamationToken: ()=>isExclamationToken,
        isExcludedFile: ()=>isExcludedFile,
        isExclusivelyTypeOnlyImportOrExport: ()=>isExclusivelyTypeOnlyImportOrExport,
        isExpandoPropertyDeclaration: ()=>isExpandoPropertyDeclaration,
        isExportAssignment: ()=>isExportAssignment,
        isExportDeclaration: ()=>isExportDeclaration,
        isExportModifier: ()=>isExportModifier,
        isExportName: ()=>isExportName,
        isExportNamespaceAsDefaultDeclaration: ()=>isExportNamespaceAsDefaultDeclaration,
        isExportOrDefaultModifier: ()=>isExportOrDefaultModifier,
        isExportSpecifier: ()=>isExportSpecifier,
        isExportsIdentifier: ()=>isExportsIdentifier,
        isExportsOrModuleExportsOrAlias: ()=>isExportsOrModuleExportsOrAlias,
        isExpression: ()=>isExpression,
        isExpressionNode: ()=>isExpressionNode,
        isExpressionOfExternalModuleImportEqualsDeclaration: ()=>isExpressionOfExternalModuleImportEqualsDeclaration,
        isExpressionOfOptionalChainRoot: ()=>isExpressionOfOptionalChainRoot,
        isExpressionStatement: ()=>isExpressionStatement,
        isExpressionWithTypeArguments: ()=>isExpressionWithTypeArguments,
        isExpressionWithTypeArgumentsInClassExtendsClause: ()=>isExpressionWithTypeArgumentsInClassExtendsClause,
        isExternalModule: ()=>isExternalModule,
        isExternalModuleAugmentation: ()=>isExternalModuleAugmentation,
        isExternalModuleImportEqualsDeclaration: ()=>isExternalModuleImportEqualsDeclaration,
        isExternalModuleIndicator: ()=>isExternalModuleIndicator,
        isExternalModuleNameRelative: ()=>isExternalModuleNameRelative,
        isExternalModuleReference: ()=>isExternalModuleReference,
        isExternalModuleSymbol: ()=>isExternalModuleSymbol,
        isExternalOrCommonJsModule: ()=>isExternalOrCommonJsModule,
        isFileLevelReservedGeneratedIdentifier: ()=>isFileLevelReservedGeneratedIdentifier,
        isFileLevelUniqueName: ()=>isFileLevelUniqueName,
        isFileProbablyExternalModule: ()=>isFileProbablyExternalModule,
        isFirstDeclarationOfSymbolParameter: ()=>isFirstDeclarationOfSymbolParameter,
        isFixablePromiseHandler: ()=>isFixablePromiseHandler,
        isForInOrOfStatement: ()=>isForInOrOfStatement,
        isForInStatement: ()=>isForInStatement,
        isForInitializer: ()=>isForInitializer,
        isForOfStatement: ()=>isForOfStatement,
        isForStatement: ()=>isForStatement,
        isFullSourceFile: ()=>isFullSourceFile,
        isFunctionBlock: ()=>isFunctionBlock,
        isFunctionBody: ()=>isFunctionBody,
        isFunctionDeclaration: ()=>isFunctionDeclaration,
        isFunctionExpression: ()=>isFunctionExpression,
        isFunctionExpressionOrArrowFunction: ()=>isFunctionExpressionOrArrowFunction,
        isFunctionLike: ()=>isFunctionLike,
        isFunctionLikeDeclaration: ()=>isFunctionLikeDeclaration,
        isFunctionLikeKind: ()=>isFunctionLikeKind,
        isFunctionLikeOrClassStaticBlockDeclaration: ()=>isFunctionLikeOrClassStaticBlockDeclaration,
        isFunctionOrConstructorTypeNode: ()=>isFunctionOrConstructorTypeNode,
        isFunctionOrModuleBlock: ()=>isFunctionOrModuleBlock,
        isFunctionSymbol: ()=>isFunctionSymbol,
        isFunctionTypeNode: ()=>isFunctionTypeNode,
        isGeneratedIdentifier: ()=>isGeneratedIdentifier,
        isGeneratedPrivateIdentifier: ()=>isGeneratedPrivateIdentifier,
        isGetAccessor: ()=>isGetAccessor,
        isGetAccessorDeclaration: ()=>isGetAccessorDeclaration,
        isGetOrSetAccessorDeclaration: ()=>isGetOrSetAccessorDeclaration,
        isGlobalScopeAugmentation: ()=>isGlobalScopeAugmentation,
        isGlobalSourceFile: ()=>isGlobalSourceFile,
        isGrammarError: ()=>isGrammarError,
        isHeritageClause: ()=>isHeritageClause,
        isHoistedFunction: ()=>isHoistedFunction,
        isHoistedVariableStatement: ()=>isHoistedVariableStatement,
        isIdentifier: ()=>isIdentifier,
        isIdentifierANonContextualKeyword: ()=>isIdentifierANonContextualKeyword,
        isIdentifierName: ()=>isIdentifierName,
        isIdentifierOrThisTypeNode: ()=>isIdentifierOrThisTypeNode,
        isIdentifierPart: ()=>isIdentifierPart,
        isIdentifierStart: ()=>isIdentifierStart,
        isIdentifierText: ()=>isIdentifierText,
        isIdentifierTypePredicate: ()=>isIdentifierTypePredicate,
        isIdentifierTypeReference: ()=>isIdentifierTypeReference,
        isIfStatement: ()=>isIfStatement,
        isIgnoredFileFromWildCardWatching: ()=>isIgnoredFileFromWildCardWatching,
        isImplicitGlob: ()=>isImplicitGlob,
        isImportAttribute: ()=>isImportAttribute,
        isImportAttributeName: ()=>isImportAttributeName,
        isImportAttributes: ()=>isImportAttributes,
        isImportCall: ()=>isImportCall,
        isImportClause: ()=>isImportClause,
        isImportDeclaration: ()=>isImportDeclaration,
        isImportEqualsDeclaration: ()=>isImportEqualsDeclaration,
        isImportKeyword: ()=>isImportKeyword,
        isImportMeta: ()=>isImportMeta,
        isImportOrExportSpecifier: ()=>isImportOrExportSpecifier,
        isImportOrExportSpecifierName: ()=>isImportOrExportSpecifierName,
        isImportSpecifier: ()=>isImportSpecifier,
        isImportTypeAssertionContainer: ()=>isImportTypeAssertionContainer,
        isImportTypeNode: ()=>isImportTypeNode,
        isImportable: ()=>isImportable,
        isInComment: ()=>isInComment,
        isInCompoundLikeAssignment: ()=>isInCompoundLikeAssignment,
        isInExpressionContext: ()=>isInExpressionContext,
        isInJSDoc: ()=>isInJSDoc,
        isInJSFile: ()=>isInJSFile,
        isInJSXText: ()=>isInJSXText,
        isInJsonFile: ()=>isInJsonFile,
        isInNonReferenceComment: ()=>isInNonReferenceComment,
        isInReferenceComment: ()=>isInReferenceComment,
        isInRightSideOfInternalImportEqualsDeclaration: ()=>isInRightSideOfInternalImportEqualsDeclaration,
        isInString: ()=>isInString,
        isInTemplateString: ()=>isInTemplateString,
        isInTopLevelContext: ()=>isInTopLevelContext,
        isInTypeQuery: ()=>isInTypeQuery,
        isIncrementalBuildInfo: ()=>isIncrementalBuildInfo,
        isIncrementalBundleEmitBuildInfo: ()=>isIncrementalBundleEmitBuildInfo,
        isIncrementalCompilation: ()=>isIncrementalCompilation,
        isIndexSignatureDeclaration: ()=>isIndexSignatureDeclaration,
        isIndexedAccessTypeNode: ()=>isIndexedAccessTypeNode,
        isInferTypeNode: ()=>isInferTypeNode,
        isInfinityOrNaNString: ()=>isInfinityOrNaNString,
        isInitializedProperty: ()=>isInitializedProperty,
        isInitializedVariable: ()=>isInitializedVariable,
        isInsideJsxElement: ()=>isInsideJsxElement,
        isInsideJsxElementOrAttribute: ()=>isInsideJsxElementOrAttribute,
        isInsideNodeModules: ()=>isInsideNodeModules,
        isInsideTemplateLiteral: ()=>isInsideTemplateLiteral,
        isInstanceOfExpression: ()=>isInstanceOfExpression,
        isInstantiatedModule: ()=>isInstantiatedModule,
        isInterfaceDeclaration: ()=>isInterfaceDeclaration,
        isInternalDeclaration: ()=>isInternalDeclaration,
        isInternalModuleImportEqualsDeclaration: ()=>isInternalModuleImportEqualsDeclaration,
        isInternalName: ()=>isInternalName,
        isIntersectionTypeNode: ()=>isIntersectionTypeNode,
        isIntrinsicJsxName: ()=>isIntrinsicJsxName,
        isIterationStatement: ()=>isIterationStatement,
        isJSDoc: ()=>isJSDoc,
        isJSDocAllType: ()=>isJSDocAllType,
        isJSDocAugmentsTag: ()=>isJSDocAugmentsTag,
        isJSDocAuthorTag: ()=>isJSDocAuthorTag,
        isJSDocCallbackTag: ()=>isJSDocCallbackTag,
        isJSDocClassTag: ()=>isJSDocClassTag,
        isJSDocCommentContainingNode: ()=>isJSDocCommentContainingNode,
        isJSDocConstructSignature: ()=>isJSDocConstructSignature,
        isJSDocDeprecatedTag: ()=>isJSDocDeprecatedTag,
        isJSDocEnumTag: ()=>isJSDocEnumTag,
        isJSDocFunctionType: ()=>isJSDocFunctionType,
        isJSDocImplementsTag: ()=>isJSDocImplementsTag,
        isJSDocImportTag: ()=>isJSDocImportTag,
        isJSDocIndexSignature: ()=>isJSDocIndexSignature,
        isJSDocLikeText: ()=>isJSDocLikeText,
        isJSDocLink: ()=>isJSDocLink,
        isJSDocLinkCode: ()=>isJSDocLinkCode,
        isJSDocLinkLike: ()=>isJSDocLinkLike,
        isJSDocLinkPlain: ()=>isJSDocLinkPlain,
        isJSDocMemberName: ()=>isJSDocMemberName,
        isJSDocNameReference: ()=>isJSDocNameReference,
        isJSDocNamepathType: ()=>isJSDocNamepathType,
        isJSDocNamespaceBody: ()=>isJSDocNamespaceBody,
        isJSDocNode: ()=>isJSDocNode,
        isJSDocNonNullableType: ()=>isJSDocNonNullableType,
        isJSDocNullableType: ()=>isJSDocNullableType,
        isJSDocOptionalParameter: ()=>isJSDocOptionalParameter,
        isJSDocOptionalType: ()=>isJSDocOptionalType,
        isJSDocOverloadTag: ()=>isJSDocOverloadTag,
        isJSDocOverrideTag: ()=>isJSDocOverrideTag,
        isJSDocParameterTag: ()=>isJSDocParameterTag,
        isJSDocPrivateTag: ()=>isJSDocPrivateTag,
        isJSDocPropertyLikeTag: ()=>isJSDocPropertyLikeTag,
        isJSDocPropertyTag: ()=>isJSDocPropertyTag,
        isJSDocProtectedTag: ()=>isJSDocProtectedTag,
        isJSDocPublicTag: ()=>isJSDocPublicTag,
        isJSDocReadonlyTag: ()=>isJSDocReadonlyTag,
        isJSDocReturnTag: ()=>isJSDocReturnTag,
        isJSDocSatisfiesExpression: ()=>isJSDocSatisfiesExpression,
        isJSDocSatisfiesTag: ()=>isJSDocSatisfiesTag,
        isJSDocSeeTag: ()=>isJSDocSeeTag,
        isJSDocSignature: ()=>isJSDocSignature,
        isJSDocTag: ()=>isJSDocTag,
        isJSDocTemplateTag: ()=>isJSDocTemplateTag,
        isJSDocThisTag: ()=>isJSDocThisTag,
        isJSDocThrowsTag: ()=>isJSDocThrowsTag,
        isJSDocTypeAlias: ()=>isJSDocTypeAlias,
        isJSDocTypeAssertion: ()=>isJSDocTypeAssertion,
        isJSDocTypeExpression: ()=>isJSDocTypeExpression,
        isJSDocTypeLiteral: ()=>isJSDocTypeLiteral,
        isJSDocTypeTag: ()=>isJSDocTypeTag,
        isJSDocTypedefTag: ()=>isJSDocTypedefTag,
        isJSDocUnknownTag: ()=>isJSDocUnknownTag,
        isJSDocUnknownType: ()=>isJSDocUnknownType,
        isJSDocVariadicType: ()=>isJSDocVariadicType,
        isJSXTagName: ()=>isJSXTagName,
        isJsonEqual: ()=>isJsonEqual,
        isJsonSourceFile: ()=>isJsonSourceFile,
        isJsxAttribute: ()=>isJsxAttribute,
        isJsxAttributeLike: ()=>isJsxAttributeLike,
        isJsxAttributeName: ()=>isJsxAttributeName,
        isJsxAttributes: ()=>isJsxAttributes,
        isJsxCallLike: ()=>isJsxCallLike,
        isJsxChild: ()=>isJsxChild,
        isJsxClosingElement: ()=>isJsxClosingElement,
        isJsxClosingFragment: ()=>isJsxClosingFragment,
        isJsxElement: ()=>isJsxElement,
        isJsxExpression: ()=>isJsxExpression,
        isJsxFragment: ()=>isJsxFragment,
        isJsxNamespacedName: ()=>isJsxNamespacedName,
        isJsxOpeningElement: ()=>isJsxOpeningElement,
        isJsxOpeningFragment: ()=>isJsxOpeningFragment,
        isJsxOpeningLikeElement: ()=>isJsxOpeningLikeElement,
        isJsxOpeningLikeElementTagName: ()=>isJsxOpeningLikeElementTagName,
        isJsxSelfClosingElement: ()=>isJsxSelfClosingElement,
        isJsxSpreadAttribute: ()=>isJsxSpreadAttribute,
        isJsxTagNameExpression: ()=>isJsxTagNameExpression,
        isJsxText: ()=>isJsxText,
        isJumpStatementTarget: ()=>isJumpStatementTarget,
        isKeyword: ()=>isKeyword,
        isKeywordOrPunctuation: ()=>isKeywordOrPunctuation,
        isKnownSymbol: ()=>isKnownSymbol,
        isLabelName: ()=>isLabelName,
        isLabelOfLabeledStatement: ()=>isLabelOfLabeledStatement,
        isLabeledStatement: ()=>isLabeledStatement,
        isLateVisibilityPaintedStatement: ()=>isLateVisibilityPaintedStatement,
        isLeftHandSideExpression: ()=>isLeftHandSideExpression,
        isLet: ()=>isLet,
        isLineBreak: ()=>isLineBreak,
        isLiteralComputedPropertyDeclarationName: ()=>isLiteralComputedPropertyDeclarationName,
        isLiteralExpression: ()=>isLiteralExpression,
        isLiteralExpressionOfObject: ()=>isLiteralExpressionOfObject,
        isLiteralImportTypeNode: ()=>isLiteralImportTypeNode,
        isLiteralKind: ()=>isLiteralKind,
        isLiteralNameOfPropertyDeclarationOrIndexAccess: ()=>isLiteralNameOfPropertyDeclarationOrIndexAccess,
        isLiteralTypeLiteral: ()=>isLiteralTypeLiteral,
        isLiteralTypeNode: ()=>isLiteralTypeNode,
        isLocalName: ()=>isLocalName,
        isLogicalOperator: ()=>isLogicalOperator,
        isLogicalOrCoalescingAssignmentExpression: ()=>isLogicalOrCoalescingAssignmentExpression,
        isLogicalOrCoalescingAssignmentOperator: ()=>isLogicalOrCoalescingAssignmentOperator,
        isLogicalOrCoalescingBinaryExpression: ()=>isLogicalOrCoalescingBinaryExpression,
        isLogicalOrCoalescingBinaryOperator: ()=>isLogicalOrCoalescingBinaryOperator,
        isMappedTypeNode: ()=>isMappedTypeNode,
        isMemberName: ()=>isMemberName,
        isMetaProperty: ()=>isMetaProperty,
        isMethodDeclaration: ()=>isMethodDeclaration,
        isMethodOrAccessor: ()=>isMethodOrAccessor,
        isMethodSignature: ()=>isMethodSignature,
        isMinusToken: ()=>isMinusToken,
        isMissingDeclaration: ()=>isMissingDeclaration,
        isMissingPackageJsonInfo: ()=>isMissingPackageJsonInfo,
        isModifier: ()=>isModifier,
        isModifierKind: ()=>isModifierKind,
        isModifierLike: ()=>isModifierLike,
        isModuleAugmentationExternal: ()=>isModuleAugmentationExternal,
        isModuleBlock: ()=>isModuleBlock,
        isModuleBody: ()=>isModuleBody,
        isModuleDeclaration: ()=>isModuleDeclaration,
        isModuleExportName: ()=>isModuleExportName,
        isModuleExportsAccessExpression: ()=>isModuleExportsAccessExpression,
        isModuleIdentifier: ()=>isModuleIdentifier,
        isModuleName: ()=>isModuleName,
        isModuleOrEnumDeclaration: ()=>isModuleOrEnumDeclaration,
        isModuleReference: ()=>isModuleReference,
        isModuleSpecifierLike: ()=>isModuleSpecifierLike,
        isModuleWithStringLiteralName: ()=>isModuleWithStringLiteralName,
        isNameOfFunctionDeclaration: ()=>isNameOfFunctionDeclaration,
        isNameOfModuleDeclaration: ()=>isNameOfModuleDeclaration,
        isNamedDeclaration: ()=>isNamedDeclaration,
        isNamedEvaluation: ()=>isNamedEvaluation,
        isNamedEvaluationSource: ()=>isNamedEvaluationSource,
        isNamedExportBindings: ()=>isNamedExportBindings,
        isNamedExports: ()=>isNamedExports,
        isNamedImportBindings: ()=>isNamedImportBindings,
        isNamedImports: ()=>isNamedImports,
        isNamedImportsOrExports: ()=>isNamedImportsOrExports,
        isNamedTupleMember: ()=>isNamedTupleMember,
        isNamespaceBody: ()=>isNamespaceBody,
        isNamespaceExport: ()=>isNamespaceExport,
        isNamespaceExportDeclaration: ()=>isNamespaceExportDeclaration,
        isNamespaceImport: ()=>isNamespaceImport,
        isNamespaceReexportDeclaration: ()=>isNamespaceReexportDeclaration,
        isNewExpression: ()=>isNewExpression,
        isNewExpressionTarget: ()=>isNewExpressionTarget,
        isNewScopeNode: ()=>isNewScopeNode,
        isNoSubstitutionTemplateLiteral: ()=>isNoSubstitutionTemplateLiteral,
        isNodeArray: ()=>isNodeArray,
        isNodeArrayMultiLine: ()=>isNodeArrayMultiLine,
        isNodeDescendantOf: ()=>isNodeDescendantOf,
        isNodeKind: ()=>isNodeKind,
        isNodeLikeSystem: ()=>isNodeLikeSystem,
        isNodeModulesDirectory: ()=>isNodeModulesDirectory,
        isNodeWithPossibleHoistedDeclaration: ()=>isNodeWithPossibleHoistedDeclaration,
        isNonContextualKeyword: ()=>isNonContextualKeyword,
        isNonGlobalAmbientModule: ()=>isNonGlobalAmbientModule,
        isNonNullAccess: ()=>isNonNullAccess,
        isNonNullChain: ()=>isNonNullChain,
        isNonNullExpression: ()=>isNonNullExpression,
        isNonStaticMethodOrAccessorWithPrivateName: ()=>isNonStaticMethodOrAccessorWithPrivateName,
        isNotEmittedStatement: ()=>isNotEmittedStatement,
        isNullishCoalesce: ()=>isNullishCoalesce,
        isNumber: ()=>isNumber,
        isNumericLiteral: ()=>isNumericLiteral,
        isNumericLiteralName: ()=>isNumericLiteralName,
        isObjectBindingElementWithoutPropertyName: ()=>isObjectBindingElementWithoutPropertyName,
        isObjectBindingOrAssignmentElement: ()=>isObjectBindingOrAssignmentElement,
        isObjectBindingOrAssignmentPattern: ()=>isObjectBindingOrAssignmentPattern,
        isObjectBindingPattern: ()=>isObjectBindingPattern,
        isObjectLiteralElement: ()=>isObjectLiteralElement,
        isObjectLiteralElementLike: ()=>isObjectLiteralElementLike,
        isObjectLiteralExpression: ()=>isObjectLiteralExpression,
        isObjectLiteralMethod: ()=>isObjectLiteralMethod,
        isObjectLiteralOrClassExpressionMethodOrAccessor: ()=>isObjectLiteralOrClassExpressionMethodOrAccessor,
        isObjectTypeDeclaration: ()=>isObjectTypeDeclaration,
        isOmittedExpression: ()=>isOmittedExpression,
        isOptionalChain: ()=>isOptionalChain,
        isOptionalChainRoot: ()=>isOptionalChainRoot,
        isOptionalDeclaration: ()=>isOptionalDeclaration,
        isOptionalJSDocPropertyLikeTag: ()=>isOptionalJSDocPropertyLikeTag,
        isOptionalTypeNode: ()=>isOptionalTypeNode,
        isOuterExpression: ()=>isOuterExpression,
        isOutermostOptionalChain: ()=>isOutermostOptionalChain,
        isOverrideModifier: ()=>isOverrideModifier,
        isPackageJsonInfo: ()=>isPackageJsonInfo,
        isPackedArrayLiteral: ()=>isPackedArrayLiteral,
        isParameter: ()=>isParameter,
        isParameterPropertyDeclaration: ()=>isParameterPropertyDeclaration,
        isParameterPropertyModifier: ()=>isParameterPropertyModifier,
        isParenthesizedExpression: ()=>isParenthesizedExpression,
        isParenthesizedTypeNode: ()=>isParenthesizedTypeNode,
        isParseTreeNode: ()=>isParseTreeNode,
        isPartOfParameterDeclaration: ()=>isPartOfParameterDeclaration,
        isPartOfTypeNode: ()=>isPartOfTypeNode,
        isPartOfTypeOnlyImportOrExportDeclaration: ()=>isPartOfTypeOnlyImportOrExportDeclaration,
        isPartOfTypeQuery: ()=>isPartOfTypeQuery,
        isPartiallyEmittedExpression: ()=>isPartiallyEmittedExpression,
        isPatternMatch: ()=>isPatternMatch,
        isPinnedComment: ()=>isPinnedComment,
        isPlainJsFile: ()=>isPlainJsFile,
        isPlusToken: ()=>isPlusToken,
        isPossiblyTypeArgumentPosition: ()=>isPossiblyTypeArgumentPosition,
        isPostfixUnaryExpression: ()=>isPostfixUnaryExpression,
        isPrefixUnaryExpression: ()=>isPrefixUnaryExpression,
        isPrimitiveLiteralValue: ()=>isPrimitiveLiteralValue,
        isPrivateIdentifier: ()=>isPrivateIdentifier,
        isPrivateIdentifierClassElementDeclaration: ()=>isPrivateIdentifierClassElementDeclaration,
        isPrivateIdentifierPropertyAccessExpression: ()=>isPrivateIdentifierPropertyAccessExpression,
        isPrivateIdentifierSymbol: ()=>isPrivateIdentifierSymbol,
        isProgramUptoDate: ()=>isProgramUptoDate,
        isPrologueDirective: ()=>isPrologueDirective,
        isPropertyAccessChain: ()=>isPropertyAccessChain,
        isPropertyAccessEntityNameExpression: ()=>isPropertyAccessEntityNameExpression,
        isPropertyAccessExpression: ()=>isPropertyAccessExpression,
        isPropertyAccessOrQualifiedName: ()=>isPropertyAccessOrQualifiedName,
        isPropertyAccessOrQualifiedNameOrImportTypeNode: ()=>isPropertyAccessOrQualifiedNameOrImportTypeNode,
        isPropertyAssignment: ()=>isPropertyAssignment,
        isPropertyDeclaration: ()=>isPropertyDeclaration,
        isPropertyName: ()=>isPropertyName,
        isPropertyNameLiteral: ()=>isPropertyNameLiteral,
        isPropertySignature: ()=>isPropertySignature,
        isPrototypeAccess: ()=>isPrototypeAccess,
        isPrototypePropertyAssignment: ()=>isPrototypePropertyAssignment,
        isPunctuation: ()=>isPunctuation,
        isPushOrUnshiftIdentifier: ()=>isPushOrUnshiftIdentifier,
        isQualifiedName: ()=>isQualifiedName,
        isQuestionDotToken: ()=>isQuestionDotToken,
        isQuestionOrExclamationToken: ()=>isQuestionOrExclamationToken,
        isQuestionOrPlusOrMinusToken: ()=>isQuestionOrPlusOrMinusToken,
        isQuestionToken: ()=>isQuestionToken,
        isReadonlyKeyword: ()=>isReadonlyKeyword,
        isReadonlyKeywordOrPlusOrMinusToken: ()=>isReadonlyKeywordOrPlusOrMinusToken,
        isRecognizedTripleSlashComment: ()=>isRecognizedTripleSlashComment,
        isReferenceFileLocation: ()=>isReferenceFileLocation,
        isReferencedFile: ()=>isReferencedFile,
        isRegularExpressionLiteral: ()=>isRegularExpressionLiteral,
        isRequireCall: ()=>isRequireCall,
        isRequireVariableStatement: ()=>isRequireVariableStatement,
        isRestParameter: ()=>isRestParameter,
        isRestTypeNode: ()=>isRestTypeNode,
        isReturnStatement: ()=>isReturnStatement,
        isReturnStatementWithFixablePromiseHandler: ()=>isReturnStatementWithFixablePromiseHandler,
        isRightSideOfAccessExpression: ()=>isRightSideOfAccessExpression,
        isRightSideOfInstanceofExpression: ()=>isRightSideOfInstanceofExpression,
        isRightSideOfPropertyAccess: ()=>isRightSideOfPropertyAccess,
        isRightSideOfQualifiedName: ()=>isRightSideOfQualifiedName,
        isRightSideOfQualifiedNameOrPropertyAccess: ()=>isRightSideOfQualifiedNameOrPropertyAccess,
        isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName: ()=>isRightSideOfQualifiedNameOrPropertyAccessOrJSDocMemberName,
        isRootedDiskPath: ()=>isRootedDiskPath,
        isSameEntityName: ()=>isSameEntityName,
        isSatisfiesExpression: ()=>isSatisfiesExpression,
        isSemicolonClassElement: ()=>isSemicolonClassElement,
        isSetAccessor: ()=>isSetAccessor,
        isSetAccessorDeclaration: ()=>isSetAccessorDeclaration,
        isShiftOperatorOrHigher: ()=>isShiftOperatorOrHigher,
        isShorthandAmbientModuleSymbol: ()=>isShorthandAmbientModuleSymbol,
        isShorthandPropertyAssignment: ()=>isShorthandPropertyAssignment,
        isSideEffectImport: ()=>isSideEffectImport,
        isSignedNumericLiteral: ()=>isSignedNumericLiteral,
        isSimpleCopiableExpression: ()=>isSimpleCopiableExpression,
        isSimpleInlineableExpression: ()=>isSimpleInlineableExpression,
        isSimpleParameterList: ()=>isSimpleParameterList,
        isSingleOrDoubleQuote: ()=>isSingleOrDoubleQuote,
        isSolutionConfig: ()=>isSolutionConfig,
        isSourceElement: ()=>isSourceElement,
        isSourceFile: ()=>isSourceFile,
        isSourceFileFromLibrary: ()=>isSourceFileFromLibrary,
        isSourceFileJS: ()=>isSourceFileJS,
        isSourceFileNotJson: ()=>isSourceFileNotJson,
        isSourceMapping: ()=>isSourceMapping,
        isSpecialPropertyDeclaration: ()=>isSpecialPropertyDeclaration,
        isSpreadAssignment: ()=>isSpreadAssignment,
        isSpreadElement: ()=>isSpreadElement,
        isStatement: ()=>isStatement,
        isStatementButNotDeclaration: ()=>isStatementButNotDeclaration,
        isStatementOrBlock: ()=>isStatementOrBlock,
        isStatementWithLocals: ()=>isStatementWithLocals,
        isStatic: ()=>isStatic,
        isStaticModifier: ()=>isStaticModifier,
        isString: ()=>isString,
        isStringANonContextualKeyword: ()=>isStringANonContextualKeyword,
        isStringAndEmptyAnonymousObjectIntersection: ()=>isStringAndEmptyAnonymousObjectIntersection,
        isStringDoubleQuoted: ()=>isStringDoubleQuoted,
        isStringLiteral: ()=>isStringLiteral,
        isStringLiteralLike: ()=>isStringLiteralLike,
        isStringLiteralOrJsxExpression: ()=>isStringLiteralOrJsxExpression,
        isStringLiteralOrTemplate: ()=>isStringLiteralOrTemplate,
        isStringOrNumericLiteralLike: ()=>isStringOrNumericLiteralLike,
        isStringOrRegularExpressionOrTemplateLiteral: ()=>isStringOrRegularExpressionOrTemplateLiteral,
        isStringTextContainingNode: ()=>isStringTextContainingNode,
        isSuperCall: ()=>isSuperCall,
        isSuperKeyword: ()=>isSuperKeyword,
        isSuperProperty: ()=>isSuperProperty,
        isSupportedSourceFileName: ()=>isSupportedSourceFileName,
        isSwitchStatement: ()=>isSwitchStatement,
        isSyntaxList: ()=>isSyntaxList,
        isSyntheticExpression: ()=>isSyntheticExpression,
        isSyntheticReference: ()=>isSyntheticReference,
        isTagName: ()=>isTagName,
        isTaggedTemplateExpression: ()=>isTaggedTemplateExpression,
        isTaggedTemplateTag: ()=>isTaggedTemplateTag,
        isTemplateExpression: ()=>isTemplateExpression,
        isTemplateHead: ()=>isTemplateHead,
        isTemplateLiteral: ()=>isTemplateLiteral,
        isTemplateLiteralKind: ()=>isTemplateLiteralKind,
        isTemplateLiteralToken: ()=>isTemplateLiteralToken,
        isTemplateLiteralTypeNode: ()=>isTemplateLiteralTypeNode,
        isTemplateLiteralTypeSpan: ()=>isTemplateLiteralTypeSpan,
        isTemplateMiddle: ()=>isTemplateMiddle,
        isTemplateMiddleOrTemplateTail: ()=>isTemplateMiddleOrTemplateTail,
        isTemplateSpan: ()=>isTemplateSpan,
        isTemplateTail: ()=>isTemplateTail,
        isTextWhiteSpaceLike: ()=>isTextWhiteSpaceLike,
        isThis: ()=>isThis,
        isThisContainerOrFunctionBlock: ()=>isThisContainerOrFunctionBlock,
        isThisIdentifier: ()=>isThisIdentifier,
        isThisInTypeQuery: ()=>isThisInTypeQuery,
        isThisInitializedDeclaration: ()=>isThisInitializedDeclaration,
        isThisInitializedObjectBindingExpression: ()=>isThisInitializedObjectBindingExpression,
        isThisProperty: ()=>isThisProperty,
        isThisTypeNode: ()=>isThisTypeNode,
        isThisTypeParameter: ()=>isThisTypeParameter,
        isThisTypePredicate: ()=>isThisTypePredicate,
        isThrowStatement: ()=>isThrowStatement,
        isToken: ()=>isToken,
        isTokenKind: ()=>isTokenKind,
        isTraceEnabled: ()=>isTraceEnabled,
        isTransientSymbol: ()=>isTransientSymbol,
        isTrivia: ()=>isTrivia,
        isTryStatement: ()=>isTryStatement,
        isTupleTypeNode: ()=>isTupleTypeNode,
        isTypeAlias: ()=>isTypeAlias,
        isTypeAliasDeclaration: ()=>isTypeAliasDeclaration,
        isTypeAssertionExpression: ()=>isTypeAssertionExpression,
        isTypeDeclaration: ()=>isTypeDeclaration,
        isTypeElement: ()=>isTypeElement,
        isTypeKeyword: ()=>isTypeKeyword,
        isTypeKeywordTokenOrIdentifier: ()=>isTypeKeywordTokenOrIdentifier,
        isTypeLiteralNode: ()=>isTypeLiteralNode,
        isTypeNode: ()=>isTypeNode,
        isTypeNodeKind: ()=>isTypeNodeKind,
        isTypeOfExpression: ()=>isTypeOfExpression,
        isTypeOnlyExportDeclaration: ()=>isTypeOnlyExportDeclaration,
        isTypeOnlyImportDeclaration: ()=>isTypeOnlyImportDeclaration,
        isTypeOnlyImportOrExportDeclaration: ()=>isTypeOnlyImportOrExportDeclaration,
        isTypeOperatorNode: ()=>isTypeOperatorNode,
        isTypeParameterDeclaration: ()=>isTypeParameterDeclaration,
        isTypePredicateNode: ()=>isTypePredicateNode,
        isTypeQueryNode: ()=>isTypeQueryNode,
        isTypeReferenceNode: ()=>isTypeReferenceNode,
        isTypeReferenceType: ()=>isTypeReferenceType,
        isTypeUsableAsPropertyName: ()=>isTypeUsableAsPropertyName,
        isUMDExportSymbol: ()=>isUMDExportSymbol,
        isUnaryExpression: ()=>isUnaryExpression,
        isUnaryExpressionWithWrite: ()=>isUnaryExpressionWithWrite,
        isUnicodeIdentifierStart: ()=>isUnicodeIdentifierStart,
        isUnionTypeNode: ()=>isUnionTypeNode,
        isUrl: ()=>isUrl,
        isValidBigIntString: ()=>isValidBigIntString,
        isValidESSymbolDeclaration: ()=>isValidESSymbolDeclaration,
        isValidTypeOnlyAliasUseSite: ()=>isValidTypeOnlyAliasUseSite,
        isValueSignatureDeclaration: ()=>isValueSignatureDeclaration,
        isVarAwaitUsing: ()=>isVarAwaitUsing,
        isVarConst: ()=>isVarConst,
        isVarConstLike: ()=>isVarConstLike,
        isVarUsing: ()=>isVarUsing,
        isVariableDeclaration: ()=>isVariableDeclaration,
        isVariableDeclarationInVariableStatement: ()=>isVariableDeclarationInVariableStatement,
        isVariableDeclarationInitializedToBareOrAccessedRequire: ()=>isVariableDeclarationInitializedToBareOrAccessedRequire,
        isVariableDeclarationInitializedToRequire: ()=>isVariableDeclarationInitializedToRequire,
        isVariableDeclarationList: ()=>isVariableDeclarationList,
        isVariableLike: ()=>isVariableLike,
        isVariableStatement: ()=>isVariableStatement,
        isVoidExpression: ()=>isVoidExpression,
        isWatchSet: ()=>isWatchSet,
        isWhileStatement: ()=>isWhileStatement,
        isWhiteSpaceLike: ()=>isWhiteSpaceLike,
        isWhiteSpaceSingleLine: ()=>isWhiteSpaceSingleLine,
        isWithStatement: ()=>isWithStatement,
        isWriteAccess: ()=>isWriteAccess,
        isWriteOnlyAccess: ()=>isWriteOnlyAccess,
        isYieldExpression: ()=>isYieldExpression,
        jsxModeNeedsExplicitImport: ()=>jsxModeNeedsExplicitImport,
        keywordPart: ()=>keywordPart,
        last: ()=>last,
        lastOrUndefined: ()=>lastOrUndefined,
        length: ()=>length,
        libMap: ()=>libMap,
        libs: ()=>libs,
        lineBreakPart: ()=>lineBreakPart,
        loadModuleFromGlobalCache: ()=>loadModuleFromGlobalCache,
        loadWithModeAwareCache: ()=>loadWithModeAwareCache,
        makeIdentifierFromModuleName: ()=>makeIdentifierFromModuleName,
        makeImport: ()=>makeImport,
        makeStringLiteral: ()=>makeStringLiteral,
        mangleScopedPackageName: ()=>mangleScopedPackageName,
        map: ()=>map,
        mapAllOrFail: ()=>mapAllOrFail,
        mapDefined: ()=>mapDefined,
        mapDefinedIterator: ()=>mapDefinedIterator,
        mapEntries: ()=>mapEntries,
        mapIterator: ()=>mapIterator,
        mapOneOrMany: ()=>mapOneOrMany,
        mapToDisplayParts: ()=>mapToDisplayParts,
        matchFiles: ()=>matchFiles,
        matchPatternOrExact: ()=>matchPatternOrExact,
        matchedText: ()=>matchedText,
        matchesExclude: ()=>matchesExclude,
        matchesExcludeWorker: ()=>matchesExcludeWorker,
        maxBy: ()=>maxBy,
        maybeBind: ()=>maybeBind,
        maybeSetLocalizedDiagnosticMessages: ()=>maybeSetLocalizedDiagnosticMessages,
        memoize: ()=>memoize,
        memoizeOne: ()=>memoizeOne,
        min: ()=>min,
        minAndMax: ()=>minAndMax,
        missingFileModifiedTime: ()=>missingFileModifiedTime,
        modifierToFlag: ()=>modifierToFlag,
        modifiersToFlags: ()=>modifiersToFlags,
        moduleExportNameIsDefault: ()=>moduleExportNameIsDefault,
        moduleExportNameTextEscaped: ()=>moduleExportNameTextEscaped,
        moduleExportNameTextUnescaped: ()=>moduleExportNameTextUnescaped,
        moduleOptionDeclaration: ()=>moduleOptionDeclaration,
        moduleResolutionIsEqualTo: ()=>moduleResolutionIsEqualTo,
        moduleResolutionNameAndModeGetter: ()=>moduleResolutionNameAndModeGetter,
        moduleResolutionOptionDeclarations: ()=>moduleResolutionOptionDeclarations,
        moduleResolutionSupportsPackageJsonExportsAndImports: ()=>moduleResolutionSupportsPackageJsonExportsAndImports,
        moduleResolutionUsesNodeModules: ()=>moduleResolutionUsesNodeModules,
        moduleSpecifierToValidIdentifier: ()=>moduleSpecifierToValidIdentifier,
        moduleSpecifiers: ()=>ts_moduleSpecifiers_exports,
        moduleSupportsImportAttributes: ()=>moduleSupportsImportAttributes,
        moduleSymbolToValidIdentifier: ()=>moduleSymbolToValidIdentifier,
        moveEmitHelpers: ()=>moveEmitHelpers,
        moveRangeEnd: ()=>moveRangeEnd,
        moveRangePastDecorators: ()=>moveRangePastDecorators,
        moveRangePastModifiers: ()=>moveRangePastModifiers,
        moveRangePos: ()=>moveRangePos,
        moveSyntheticComments: ()=>moveSyntheticComments,
        mutateMap: ()=>mutateMap,
        mutateMapSkippingNewValues: ()=>mutateMapSkippingNewValues,
        needsParentheses: ()=>needsParentheses,
        needsScopeMarker: ()=>needsScopeMarker,
        newCaseClauseTracker: ()=>newCaseClauseTracker,
        newPrivateEnvironment: ()=>newPrivateEnvironment,
        noEmitNotification: ()=>noEmitNotification,
        noEmitSubstitution: ()=>noEmitSubstitution,
        noTransformers: ()=>noTransformers,
        noTruncationMaximumTruncationLength: ()=>noTruncationMaximumTruncationLength,
        nodeCanBeDecorated: ()=>nodeCanBeDecorated,
        nodeCoreModules: ()=>nodeCoreModules,
        nodeHasName: ()=>nodeHasName,
        nodeIsDecorated: ()=>nodeIsDecorated,
        nodeIsMissing: ()=>nodeIsMissing,
        nodeIsPresent: ()=>nodeIsPresent,
        nodeIsSynthesized: ()=>nodeIsSynthesized,
        nodeModuleNameResolver: ()=>nodeModuleNameResolver,
        nodeModulesPathPart: ()=>nodeModulesPathPart,
        nodeNextJsonConfigResolver: ()=>nodeNextJsonConfigResolver,
        nodeOrChildIsDecorated: ()=>nodeOrChildIsDecorated,
        nodeOverlapsWithStartEnd: ()=>nodeOverlapsWithStartEnd,
        nodePosToString: ()=>nodePosToString,
        nodeSeenTracker: ()=>nodeSeenTracker,
        nodeStartsNewLexicalEnvironment: ()=>nodeStartsNewLexicalEnvironment,
        noop: ()=>noop,
        noopFileWatcher: ()=>noopFileWatcher,
        normalizePath: ()=>normalizePath,
        normalizeSlashes: ()=>normalizeSlashes,
        normalizeSpans: ()=>normalizeSpans,
        not: ()=>not,
        notImplemented: ()=>notImplemented,
        notImplementedResolver: ()=>notImplementedResolver,
        nullNodeConverters: ()=>nullNodeConverters,
        nullParenthesizerRules: ()=>nullParenthesizerRules,
        nullTransformationContext: ()=>nullTransformationContext,
        objectAllocator: ()=>objectAllocator,
        operatorPart: ()=>operatorPart,
        optionDeclarations: ()=>optionDeclarations,
        optionMapToObject: ()=>optionMapToObject,
        optionsAffectingProgramStructure: ()=>optionsAffectingProgramStructure,
        optionsForBuild: ()=>optionsForBuild,
        optionsForWatch: ()=>optionsForWatch,
        optionsHaveChanges: ()=>optionsHaveChanges,
        or: ()=>or,
        orderedRemoveItem: ()=>orderedRemoveItem,
        orderedRemoveItemAt: ()=>orderedRemoveItemAt,
        packageIdToPackageName: ()=>packageIdToPackageName,
        packageIdToString: ()=>packageIdToString,
        parameterIsThisKeyword: ()=>parameterIsThisKeyword,
        parameterNamePart: ()=>parameterNamePart,
        parseBaseNodeFactory: ()=>parseBaseNodeFactory,
        parseBigInt: ()=>parseBigInt,
        parseBuildCommand: ()=>parseBuildCommand,
        parseCommandLine: ()=>parseCommandLine,
        parseCommandLineWorker: ()=>parseCommandLineWorker,
        parseConfigFileTextToJson: ()=>parseConfigFileTextToJson,
        parseConfigFileWithSystem: ()=>parseConfigFileWithSystem,
        parseConfigHostFromCompilerHostLike: ()=>parseConfigHostFromCompilerHostLike,
        parseCustomTypeOption: ()=>parseCustomTypeOption,
        parseIsolatedEntityName: ()=>parseIsolatedEntityName,
        parseIsolatedJSDocComment: ()=>parseIsolatedJSDocComment,
        parseJSDocTypeExpressionForTests: ()=>parseJSDocTypeExpressionForTests,
        parseJsonConfigFileContent: ()=>parseJsonConfigFileContent,
        parseJsonSourceFileConfigFileContent: ()=>parseJsonSourceFileConfigFileContent,
        parseJsonText: ()=>parseJsonText,
        parseListTypeOption: ()=>parseListTypeOption,
        parseNodeFactory: ()=>parseNodeFactory,
        parseNodeModuleFromPath: ()=>parseNodeModuleFromPath,
        parsePackageName: ()=>parsePackageName,
        parsePseudoBigInt: ()=>parsePseudoBigInt,
        parseValidBigInt: ()=>parseValidBigInt,
        pasteEdits: ()=>ts_PasteEdits_exports,
        patchWriteFileEnsuringDirectory: ()=>patchWriteFileEnsuringDirectory,
        pathContainsNodeModules: ()=>pathContainsNodeModules,
        pathIsAbsolute: ()=>pathIsAbsolute,
        pathIsBareSpecifier: ()=>pathIsBareSpecifier,
        pathIsRelative: ()=>pathIsRelative,
        patternText: ()=>patternText,
        performIncrementalCompilation: ()=>performIncrementalCompilation,
        performance: ()=>ts_performance_exports,
        positionBelongsToNode: ()=>positionBelongsToNode,
        positionIsASICandidate: ()=>positionIsASICandidate,
        positionIsSynthesized: ()=>positionIsSynthesized,
        positionsAreOnSameLine: ()=>positionsAreOnSameLine,
        preProcessFile: ()=>preProcessFile,
        probablyUsesSemicolons: ()=>probablyUsesSemicolons,
        processCommentPragmas: ()=>processCommentPragmas,
        processPragmasIntoFields: ()=>processPragmasIntoFields,
        processTaggedTemplateExpression: ()=>processTaggedTemplateExpression,
        programContainsEsModules: ()=>programContainsEsModules,
        programContainsModules: ()=>programContainsModules,
        projectReferenceIsEqualTo: ()=>projectReferenceIsEqualTo,
        propertyNamePart: ()=>propertyNamePart,
        pseudoBigIntToString: ()=>pseudoBigIntToString,
        punctuationPart: ()=>punctuationPart,
        pushIfUnique: ()=>pushIfUnique,
        quote: ()=>quote,
        quotePreferenceFromString: ()=>quotePreferenceFromString,
        rangeContainsPosition: ()=>rangeContainsPosition,
        rangeContainsPositionExclusive: ()=>rangeContainsPositionExclusive,
        rangeContainsRange: ()=>rangeContainsRange,
        rangeContainsRangeExclusive: ()=>rangeContainsRangeExclusive,
        rangeContainsStartEnd: ()=>rangeContainsStartEnd,
        rangeEndIsOnSameLineAsRangeStart: ()=>rangeEndIsOnSameLineAsRangeStart,
        rangeEndPositionsAreOnSameLine: ()=>rangeEndPositionsAreOnSameLine,
        rangeEquals: ()=>rangeEquals,
        rangeIsOnSingleLine: ()=>rangeIsOnSingleLine,
        rangeOfNode: ()=>rangeOfNode,
        rangeOfTypeParameters: ()=>rangeOfTypeParameters,
        rangeOverlapsWithStartEnd: ()=>rangeOverlapsWithStartEnd,
        rangeStartIsOnSameLineAsRangeEnd: ()=>rangeStartIsOnSameLineAsRangeEnd,
        rangeStartPositionsAreOnSameLine: ()=>rangeStartPositionsAreOnSameLine,
        readBuilderProgram: ()=>readBuilderProgram,
        readConfigFile: ()=>readConfigFile,
        readJson: ()=>readJson,
        readJsonConfigFile: ()=>readJsonConfigFile,
        readJsonOrUndefined: ()=>readJsonOrUndefined,
        reduceEachLeadingCommentRange: ()=>reduceEachLeadingCommentRange,
        reduceEachTrailingCommentRange: ()=>reduceEachTrailingCommentRange,
        reduceLeft: ()=>reduceLeft,
        reduceLeftIterator: ()=>reduceLeftIterator,
        reducePathComponents: ()=>reducePathComponents,
        refactor: ()=>ts_refactor_exports,
        regExpEscape: ()=>regExpEscape,
        regularExpressionFlagToCharacterCode: ()=>regularExpressionFlagToCharacterCode,
        relativeComplement: ()=>relativeComplement,
        removeAllComments: ()=>removeAllComments,
        removeEmitHelper: ()=>removeEmitHelper,
        removeExtension: ()=>removeExtension,
        removeFileExtension: ()=>removeFileExtension,
        removeIgnoredPath: ()=>removeIgnoredPath,
        removeMinAndVersionNumbers: ()=>removeMinAndVersionNumbers,
        removePrefix: ()=>removePrefix,
        removeSuffix: ()=>removeSuffix,
        removeTrailingDirectorySeparator: ()=>removeTrailingDirectorySeparator,
        repeatString: ()=>repeatString,
        replaceElement: ()=>replaceElement,
        replaceFirstStar: ()=>replaceFirstStar,
        resolutionExtensionIsTSOrJson: ()=>resolutionExtensionIsTSOrJson,
        resolveConfigFileProjectName: ()=>resolveConfigFileProjectName,
        resolveJSModule: ()=>resolveJSModule,
        resolveLibrary: ()=>resolveLibrary,
        resolveModuleName: ()=>resolveModuleName,
        resolveModuleNameFromCache: ()=>resolveModuleNameFromCache,
        resolvePackageNameToPackageJson: ()=>resolvePackageNameToPackageJson,
        resolvePath: ()=>resolvePath,
        resolveProjectReferencePath: ()=>resolveProjectReferencePath,
        resolveTripleslashReference: ()=>resolveTripleslashReference,
        resolveTypeReferenceDirective: ()=>resolveTypeReferenceDirective,
        resolvingEmptyArray: ()=>resolvingEmptyArray,
        returnFalse: ()=>returnFalse,
        returnNoopFileWatcher: ()=>returnNoopFileWatcher,
        returnTrue: ()=>returnTrue,
        returnUndefined: ()=>returnUndefined,
        returnsPromise: ()=>returnsPromise,
        rewriteModuleSpecifier: ()=>rewriteModuleSpecifier,
        sameFlatMap: ()=>sameFlatMap,
        sameMap: ()=>sameMap,
        sameMapping: ()=>sameMapping,
        scanTokenAtPosition: ()=>scanTokenAtPosition,
        scanner: ()=>scanner,
        semanticDiagnosticsOptionDeclarations: ()=>semanticDiagnosticsOptionDeclarations,
        serializeCompilerOptions: ()=>serializeCompilerOptions,
        server: ()=>ts_server_exports3,
        servicesVersion: ()=>servicesVersion,
        setCommentRange: ()=>setCommentRange,
        setConfigFileInOptions: ()=>setConfigFileInOptions,
        setConstantValue: ()=>setConstantValue,
        setEmitFlags: ()=>setEmitFlags,
        setGetSourceFileAsHashVersioned: ()=>setGetSourceFileAsHashVersioned,
        setIdentifierAutoGenerate: ()=>setIdentifierAutoGenerate,
        setIdentifierGeneratedImportReference: ()=>setIdentifierGeneratedImportReference,
        setIdentifierTypeArguments: ()=>setIdentifierTypeArguments,
        setInternalEmitFlags: ()=>setInternalEmitFlags,
        setLocalizedDiagnosticMessages: ()=>setLocalizedDiagnosticMessages,
        setNodeChildren: ()=>setNodeChildren,
        setNodeFlags: ()=>setNodeFlags,
        setObjectAllocator: ()=>setObjectAllocator,
        setOriginalNode: ()=>setOriginalNode,
        setParent: ()=>setParent,
        setParentRecursive: ()=>setParentRecursive,
        setPrivateIdentifier: ()=>setPrivateIdentifier,
        setSnippetElement: ()=>setSnippetElement,
        setSourceMapRange: ()=>setSourceMapRange,
        setStackTraceLimit: ()=>setStackTraceLimit,
        setStartsOnNewLine: ()=>setStartsOnNewLine,
        setSyntheticLeadingComments: ()=>setSyntheticLeadingComments,
        setSyntheticTrailingComments: ()=>setSyntheticTrailingComments,
        setSys: ()=>setSys,
        setSysLog: ()=>setSysLog,
        setTextRange: ()=>setTextRange,
        setTextRangeEnd: ()=>setTextRangeEnd,
        setTextRangePos: ()=>setTextRangePos,
        setTextRangePosEnd: ()=>setTextRangePosEnd,
        setTextRangePosWidth: ()=>setTextRangePosWidth,
        setTokenSourceMapRange: ()=>setTokenSourceMapRange,
        setTypeNode: ()=>setTypeNode,
        setUILocale: ()=>setUILocale,
        setValueDeclaration: ()=>setValueDeclaration,
        shouldAllowImportingTsExtension: ()=>shouldAllowImportingTsExtension,
        shouldPreserveConstEnums: ()=>shouldPreserveConstEnums,
        shouldRewriteModuleSpecifier: ()=>shouldRewriteModuleSpecifier,
        shouldUseUriStyleNodeCoreModules: ()=>shouldUseUriStyleNodeCoreModules,
        showModuleSpecifier: ()=>showModuleSpecifier,
        signatureHasRestParameter: ()=>signatureHasRestParameter,
        signatureToDisplayParts: ()=>signatureToDisplayParts,
        single: ()=>single,
        singleElementArray: ()=>singleElementArray,
        singleIterator: ()=>singleIterator,
        singleOrMany: ()=>singleOrMany,
        singleOrUndefined: ()=>singleOrUndefined,
        skipAlias: ()=>skipAlias,
        skipConstraint: ()=>skipConstraint,
        skipOuterExpressions: ()=>skipOuterExpressions,
        skipParentheses: ()=>skipParentheses,
        skipPartiallyEmittedExpressions: ()=>skipPartiallyEmittedExpressions,
        skipTrivia: ()=>skipTrivia,
        skipTypeChecking: ()=>skipTypeChecking,
        skipTypeCheckingIgnoringNoCheck: ()=>skipTypeCheckingIgnoringNoCheck,
        skipTypeParentheses: ()=>skipTypeParentheses,
        skipWhile: ()=>skipWhile,
        sliceAfter: ()=>sliceAfter,
        some: ()=>some,
        sortAndDeduplicate: ()=>sortAndDeduplicate,
        sortAndDeduplicateDiagnostics: ()=>sortAndDeduplicateDiagnostics,
        sourceFileAffectingCompilerOptions: ()=>sourceFileAffectingCompilerOptions,
        sourceFileMayBeEmitted: ()=>sourceFileMayBeEmitted,
        sourceMapCommentRegExp: ()=>sourceMapCommentRegExp,
        sourceMapCommentRegExpDontCareLineStart: ()=>sourceMapCommentRegExpDontCareLineStart,
        spacePart: ()=>spacePart,
        spanMap: ()=>spanMap,
        startEndContainsRange: ()=>startEndContainsRange,
        startEndOverlapsWithStartEnd: ()=>startEndOverlapsWithStartEnd,
        startOnNewLine: ()=>startOnNewLine,
        startTracing: ()=>startTracing,
        startsWith: ()=>startsWith,
        startsWithDirectory: ()=>startsWithDirectory,
        startsWithUnderscore: ()=>startsWithUnderscore,
        startsWithUseStrict: ()=>startsWithUseStrict,
        stringContainsAt: ()=>stringContainsAt,
        stringToToken: ()=>stringToToken,
        stripQuotes: ()=>stripQuotes,
        supportedDeclarationExtensions: ()=>supportedDeclarationExtensions,
        supportedJSExtensionsFlat: ()=>supportedJSExtensionsFlat,
        supportedLocaleDirectories: ()=>supportedLocaleDirectories,
        supportedTSExtensionsFlat: ()=>supportedTSExtensionsFlat,
        supportedTSImplementationExtensions: ()=>supportedTSImplementationExtensions,
        suppressLeadingAndTrailingTrivia: ()=>suppressLeadingAndTrailingTrivia,
        suppressLeadingTrivia: ()=>suppressLeadingTrivia,
        suppressTrailingTrivia: ()=>suppressTrailingTrivia,
        symbolEscapedNameNoDefault: ()=>symbolEscapedNameNoDefault,
        symbolName: ()=>symbolName,
        symbolNameNoDefault: ()=>symbolNameNoDefault,
        symbolToDisplayParts: ()=>symbolToDisplayParts,
        sys: ()=>sys,
        sysLog: ()=>sysLog,
        tagNamesAreEquivalent: ()=>tagNamesAreEquivalent,
        takeWhile: ()=>takeWhile,
        targetOptionDeclaration: ()=>targetOptionDeclaration,
        targetToLibMap: ()=>targetToLibMap,
        testFormatSettings: ()=>testFormatSettings,
        textChangeRangeIsUnchanged: ()=>textChangeRangeIsUnchanged,
        textChangeRangeNewSpan: ()=>textChangeRangeNewSpan,
        textChanges: ()=>ts_textChanges_exports,
        textOrKeywordPart: ()=>textOrKeywordPart,
        textPart: ()=>textPart,
        textRangeContainsPositionInclusive: ()=>textRangeContainsPositionInclusive,
        textRangeContainsTextSpan: ()=>textRangeContainsTextSpan,
        textRangeIntersectsWithTextSpan: ()=>textRangeIntersectsWithTextSpan,
        textSpanContainsPosition: ()=>textSpanContainsPosition,
        textSpanContainsTextRange: ()=>textSpanContainsTextRange,
        textSpanContainsTextSpan: ()=>textSpanContainsTextSpan,
        textSpanEnd: ()=>textSpanEnd,
        textSpanIntersection: ()=>textSpanIntersection,
        textSpanIntersectsWith: ()=>textSpanIntersectsWith,
        textSpanIntersectsWithPosition: ()=>textSpanIntersectsWithPosition,
        textSpanIntersectsWithTextSpan: ()=>textSpanIntersectsWithTextSpan,
        textSpanIsEmpty: ()=>textSpanIsEmpty,
        textSpanOverlap: ()=>textSpanOverlap,
        textSpanOverlapsWith: ()=>textSpanOverlapsWith,
        textSpansEqual: ()=>textSpansEqual,
        textToKeywordObj: ()=>textToKeywordObj,
        timestamp: ()=>timestamp,
        toArray: ()=>toArray,
        toBuilderFileEmit: ()=>toBuilderFileEmit,
        toBuilderStateFileInfoForMultiEmit: ()=>toBuilderStateFileInfoForMultiEmit,
        toEditorSettings: ()=>toEditorSettings,
        toFileNameLowerCase: ()=>toFileNameLowerCase,
        toPath: ()=>toPath,
        toProgramEmitPending: ()=>toProgramEmitPending,
        toSorted: ()=>toSorted,
        tokenIsIdentifierOrKeyword: ()=>tokenIsIdentifierOrKeyword,
        tokenIsIdentifierOrKeywordOrGreaterThan: ()=>tokenIsIdentifierOrKeywordOrGreaterThan,
        tokenToString: ()=>tokenToString,
        trace: ()=>trace,
        tracing: ()=>tracing,
        tracingEnabled: ()=>tracingEnabled,
        transferSourceFileChildren: ()=>transferSourceFileChildren,
        transform: ()=>transform,
        transformClassFields: ()=>transformClassFields,
        transformDeclarations: ()=>transformDeclarations,
        transformECMAScriptModule: ()=>transformECMAScriptModule,
        transformES2015: ()=>transformES2015,
        transformES2016: ()=>transformES2016,
        transformES2017: ()=>transformES2017,
        transformES2018: ()=>transformES2018,
        transformES2019: ()=>transformES2019,
        transformES2020: ()=>transformES2020,
        transformES2021: ()=>transformES2021,
        transformESDecorators: ()=>transformESDecorators,
        transformESNext: ()=>transformESNext,
        transformGenerators: ()=>transformGenerators,
        transformImpliedNodeFormatDependentModule: ()=>transformImpliedNodeFormatDependentModule,
        transformJsx: ()=>transformJsx,
        transformLegacyDecorators: ()=>transformLegacyDecorators,
        transformModule: ()=>transformModule,
        transformNamedEvaluation: ()=>transformNamedEvaluation,
        transformNodes: ()=>transformNodes,
        transformSystemModule: ()=>transformSystemModule,
        transformTypeScript: ()=>transformTypeScript,
        transpile: ()=>transpile,
        transpileDeclaration: ()=>transpileDeclaration,
        transpileModule: ()=>transpileModule,
        transpileOptionValueCompilerOptions: ()=>transpileOptionValueCompilerOptions,
        tryAddToSet: ()=>tryAddToSet,
        tryAndIgnoreErrors: ()=>tryAndIgnoreErrors,
        tryCast: ()=>tryCast,
        tryDirectoryExists: ()=>tryDirectoryExists,
        tryExtractTSExtension: ()=>tryExtractTSExtension,
        tryFileExists: ()=>tryFileExists,
        tryGetClassExtendingExpressionWithTypeArguments: ()=>tryGetClassExtendingExpressionWithTypeArguments,
        tryGetClassImplementingOrExtendingExpressionWithTypeArguments: ()=>tryGetClassImplementingOrExtendingExpressionWithTypeArguments,
        tryGetDirectories: ()=>tryGetDirectories,
        tryGetExtensionFromPath: ()=>tryGetExtensionFromPath2,
        tryGetImportFromModuleSpecifier: ()=>tryGetImportFromModuleSpecifier,
        tryGetJSDocSatisfiesTypeNode: ()=>tryGetJSDocSatisfiesTypeNode,
        tryGetModuleNameFromFile: ()=>tryGetModuleNameFromFile,
        tryGetModuleSpecifierFromDeclaration: ()=>tryGetModuleSpecifierFromDeclaration,
        tryGetNativePerformanceHooks: ()=>tryGetNativePerformanceHooks,
        tryGetPropertyAccessOrIdentifierToString: ()=>tryGetPropertyAccessOrIdentifierToString,
        tryGetPropertyNameOfBindingOrAssignmentElement: ()=>tryGetPropertyNameOfBindingOrAssignmentElement,
        tryGetSourceMappingURL: ()=>tryGetSourceMappingURL,
        tryGetTextOfPropertyName: ()=>tryGetTextOfPropertyName,
        tryParseJson: ()=>tryParseJson,
        tryParsePattern: ()=>tryParsePattern,
        tryParsePatterns: ()=>tryParsePatterns,
        tryParseRawSourceMap: ()=>tryParseRawSourceMap,
        tryReadDirectory: ()=>tryReadDirectory,
        tryReadFile: ()=>tryReadFile,
        tryRemoveDirectoryPrefix: ()=>tryRemoveDirectoryPrefix,
        tryRemoveExtension: ()=>tryRemoveExtension,
        tryRemovePrefix: ()=>tryRemovePrefix,
        tryRemoveSuffix: ()=>tryRemoveSuffix,
        tscBuildOption: ()=>tscBuildOption,
        typeAcquisitionDeclarations: ()=>typeAcquisitionDeclarations,
        typeAliasNamePart: ()=>typeAliasNamePart,
        typeDirectiveIsEqualTo: ()=>typeDirectiveIsEqualTo,
        typeKeywords: ()=>typeKeywords,
        typeParameterNamePart: ()=>typeParameterNamePart,
        typeToDisplayParts: ()=>typeToDisplayParts,
        unchangedPollThresholds: ()=>unchangedPollThresholds,
        unchangedTextChangeRange: ()=>unchangedTextChangeRange,
        unescapeLeadingUnderscores: ()=>unescapeLeadingUnderscores,
        unmangleScopedPackageName: ()=>unmangleScopedPackageName,
        unorderedRemoveItem: ()=>unorderedRemoveItem,
        unprefixedNodeCoreModules: ()=>unprefixedNodeCoreModules,
        unreachableCodeIsError: ()=>unreachableCodeIsError,
        unsetNodeChildren: ()=>unsetNodeChildren,
        unusedLabelIsError: ()=>unusedLabelIsError,
        unwrapInnermostStatementOfLabel: ()=>unwrapInnermostStatementOfLabel,
        unwrapParenthesizedExpression: ()=>unwrapParenthesizedExpression,
        updateErrorForNoInputFiles: ()=>updateErrorForNoInputFiles,
        updateLanguageServiceSourceFile: ()=>updateLanguageServiceSourceFile,
        updateMissingFilePathsWatch: ()=>updateMissingFilePathsWatch,
        updateResolutionField: ()=>updateResolutionField,
        updateSharedExtendedConfigFileWatcher: ()=>updateSharedExtendedConfigFileWatcher,
        updateSourceFile: ()=>updateSourceFile,
        updateWatchingWildcardDirectories: ()=>updateWatchingWildcardDirectories,
        usingSingleLineStringWriter: ()=>usingSingleLineStringWriter,
        utf16EncodeAsString: ()=>utf16EncodeAsString,
        validateLocaleAndSetLanguage: ()=>validateLocaleAndSetLanguage,
        version: ()=>version,
        versionMajorMinor: ()=>versionMajorMinor,
        visitArray: ()=>visitArray,
        visitCommaListElements: ()=>visitCommaListElements,
        visitEachChild: ()=>visitEachChild,
        visitFunctionBody: ()=>visitFunctionBody,
        visitIterationBody: ()=>visitIterationBody,
        visitLexicalEnvironment: ()=>visitLexicalEnvironment,
        visitNode: ()=>visitNode,
        visitNodes: ()=>visitNodes2,
        visitParameterList: ()=>visitParameterList,
        walkUpBindingElementsAndPatterns: ()=>walkUpBindingElementsAndPatterns,
        walkUpOuterExpressions: ()=>walkUpOuterExpressions,
        walkUpParenthesizedExpressions: ()=>walkUpParenthesizedExpressions,
        walkUpParenthesizedTypes: ()=>walkUpParenthesizedTypes,
        walkUpParenthesizedTypesAndGetParentAndChild: ()=>walkUpParenthesizedTypesAndGetParentAndChild,
        whitespaceOrMapCommentRegExp: ()=>whitespaceOrMapCommentRegExp,
        writeCommentRange: ()=>writeCommentRange,
        writeFile: ()=>writeFile,
        writeFileEnsuringDirectories: ()=>writeFileEnsuringDirectories,
        zipWith: ()=>zipWith
    });
    // src/deprecatedCompat/deprecate.ts
    var enableDeprecationWarnings = true;
    var typeScriptVersion2;
    function getTypeScriptVersion() {
        return typeScriptVersion2 !== null && typeScriptVersion2 !== void 0 ? typeScriptVersion2 : typeScriptVersion2 = new Version(version);
    }
    function formatDeprecationMessage(name, error2, errorAfter, since, message) {
        let deprecationMessage = error2 ? "DeprecationError: " : "DeprecationWarning: ";
        deprecationMessage += `'${name}' `;
        deprecationMessage += since ? `has been deprecated since v${since}` : "is deprecated";
        deprecationMessage += error2 ? " and can no longer be used." : errorAfter ? ` and will no longer be usable after v${errorAfter}.` : ".";
        deprecationMessage += message ? ` ${formatStringFromArgs(message, [
            name
        ])}` : "";
        return deprecationMessage;
    }
    function createErrorDeprecation(name, errorAfter, since, message) {
        const deprecationMessage = formatDeprecationMessage(name, /*error*/ true, errorAfter, since, message);
        return ()=>{
            throw new TypeError(deprecationMessage);
        };
    }
    function createWarningDeprecation(name, errorAfter, since, message) {
        let hasWrittenDeprecation = false;
        return ()=>{
            if (enableDeprecationWarnings && !hasWrittenDeprecation) {
                Debug.log.warn(formatDeprecationMessage(name, /*error*/ false, errorAfter, since, message));
                hasWrittenDeprecation = true;
            }
        };
    }
    function createDeprecation(name, options = {}) {
        var _options_typeScriptVersion;
        const version2 = typeof options.typeScriptVersion === "string" ? new Version(options.typeScriptVersion) : (_options_typeScriptVersion = options.typeScriptVersion) !== null && _options_typeScriptVersion !== void 0 ? _options_typeScriptVersion : getTypeScriptVersion();
        const errorAfter = typeof options.errorAfter === "string" ? new Version(options.errorAfter) : options.errorAfter;
        const warnAfter = typeof options.warnAfter === "string" ? new Version(options.warnAfter) : options.warnAfter;
        var _options_since;
        const since = typeof options.since === "string" ? new Version(options.since) : (_options_since = options.since) !== null && _options_since !== void 0 ? _options_since : warnAfter;
        const error2 = options.error || errorAfter && version2.compareTo(errorAfter) >= 0;
        const warn = !warnAfter || version2.compareTo(warnAfter) >= 0;
        return error2 ? createErrorDeprecation(name, errorAfter, since, options.message) : warn ? createWarningDeprecation(name, errorAfter, since, options.message) : noop;
    }
    function wrapFunction(deprecation, func) {
        return function() {
            deprecation();
            return func.apply(this, arguments);
        };
    }
    function deprecate(func, options) {
        var _ref;
        const deprecation = createDeprecation((_ref = options == null ? void 0 : options.name) !== null && _ref !== void 0 ? _ref : Debug.getFunctionName(func), options);
        return wrapFunction(deprecation, func);
    }
    // src/deprecatedCompat/deprecations.ts
    function createOverload(name, overloads, binder2, deprecations) {
        Object.defineProperty(call, "name", (0, _objectSpreadProps._)((0, _objectSpread._)({}, Object.getOwnPropertyDescriptor(call, "name")), {
            value: name
        }));
        if (deprecations) for (const key of Object.keys(deprecations)){
            const index = +key;
            if (!isNaN(index) && hasProperty(overloads, `${index}`)) overloads[index] = deprecate(overloads[index], (0, _objectSpreadProps._)((0, _objectSpread._)({}, deprecations[index]), {
                name
            }));
        }
        const bind = createBinder2(overloads, binder2);
        return call;
        function call(...args) {
            const index = bind(args);
            const fn = index !== void 0 ? overloads[index] : void 0;
            if (typeof fn === "function") return fn(...args);
            throw new TypeError("Invalid arguments");
        }
    }
    function createBinder2(overloads, binder2) {
        return (args)=>{
            for(let i = 0; hasProperty(overloads, `${i}`) && hasProperty(binder2, `${i}`); i++){
                const fn = binder2[i];
                if (fn(args)) return i;
            }
        };
    }
    function buildOverload(name) {
        return {
            overload: (overloads)=>({
                    bind: (binder2)=>({
                            finish: ()=>createOverload(name, overloads, binder2),
                            deprecate: (deprecations)=>({
                                    finish: ()=>createOverload(name, overloads, binder2, deprecations)
                                })
                        })
                })
        };
    }
    // src/server/_namespaces/ts.server.ts
    var ts_server_exports3 = {};
    __export(ts_server_exports3, {
        ActionInvalidate: ()=>ActionInvalidate,
        ActionPackageInstalled: ()=>ActionPackageInstalled,
        ActionSet: ()=>ActionSet,
        ActionWatchTypingLocations: ()=>ActionWatchTypingLocations,
        Arguments: ()=>Arguments,
        AutoImportProviderProject: ()=>AutoImportProviderProject,
        AuxiliaryProject: ()=>AuxiliaryProject,
        CharRangeSection: ()=>CharRangeSection,
        CloseFileWatcherEvent: ()=>CloseFileWatcherEvent,
        CommandNames: ()=>CommandNames,
        ConfigFileDiagEvent: ()=>ConfigFileDiagEvent,
        ConfiguredProject: ()=>ConfiguredProject2,
        ConfiguredProjectLoadKind: ()=>ConfiguredProjectLoadKind,
        CreateDirectoryWatcherEvent: ()=>CreateDirectoryWatcherEvent,
        CreateFileWatcherEvent: ()=>CreateFileWatcherEvent,
        Errors: ()=>Errors,
        EventBeginInstallTypes: ()=>EventBeginInstallTypes,
        EventEndInstallTypes: ()=>EventEndInstallTypes,
        EventInitializationFailed: ()=>EventInitializationFailed,
        EventTypesRegistry: ()=>EventTypesRegistry,
        ExternalProject: ()=>ExternalProject,
        GcTimer: ()=>GcTimer,
        InferredProject: ()=>InferredProject2,
        LargeFileReferencedEvent: ()=>LargeFileReferencedEvent,
        LineIndex: ()=>LineIndex,
        LineLeaf: ()=>LineLeaf,
        LineNode: ()=>LineNode,
        LogLevel: ()=>LogLevel2,
        Msg: ()=>Msg,
        OpenFileInfoTelemetryEvent: ()=>OpenFileInfoTelemetryEvent,
        Project: ()=>Project2,
        ProjectInfoTelemetryEvent: ()=>ProjectInfoTelemetryEvent,
        ProjectKind: ()=>ProjectKind,
        ProjectLanguageServiceStateEvent: ()=>ProjectLanguageServiceStateEvent,
        ProjectLoadingFinishEvent: ()=>ProjectLoadingFinishEvent,
        ProjectLoadingStartEvent: ()=>ProjectLoadingStartEvent,
        ProjectService: ()=>ProjectService2,
        ProjectsUpdatedInBackgroundEvent: ()=>ProjectsUpdatedInBackgroundEvent,
        ScriptInfo: ()=>ScriptInfo,
        ScriptVersionCache: ()=>ScriptVersionCache,
        Session: ()=>Session3,
        TextStorage: ()=>TextStorage,
        ThrottledOperations: ()=>ThrottledOperations,
        TypingsInstallerAdapter: ()=>TypingsInstallerAdapter,
        allFilesAreJsOrDts: ()=>allFilesAreJsOrDts,
        allRootFilesAreJsOrDts: ()=>allRootFilesAreJsOrDts,
        asNormalizedPath: ()=>asNormalizedPath,
        convertCompilerOptions: ()=>convertCompilerOptions,
        convertFormatOptions: ()=>convertFormatOptions,
        convertScriptKindName: ()=>convertScriptKindName,
        convertTypeAcquisition: ()=>convertTypeAcquisition,
        convertUserPreferences: ()=>convertUserPreferences,
        convertWatchOptions: ()=>convertWatchOptions,
        countEachFileTypes: ()=>countEachFileTypes,
        createInstallTypingsRequest: ()=>createInstallTypingsRequest,
        createModuleSpecifierCache: ()=>createModuleSpecifierCache,
        createNormalizedPathMap: ()=>createNormalizedPathMap,
        createPackageJsonCache: ()=>createPackageJsonCache,
        createSortedArray: ()=>createSortedArray2,
        emptyArray: ()=>emptyArray2,
        findArgument: ()=>findArgument,
        formatDiagnosticToProtocol: ()=>formatDiagnosticToProtocol,
        formatMessage: ()=>formatMessage2,
        getBaseConfigFileName: ()=>getBaseConfigFileName,
        getDetailWatchInfo: ()=>getDetailWatchInfo,
        getLocationInNewDocument: ()=>getLocationInNewDocument,
        hasArgument: ()=>hasArgument,
        hasNoTypeScriptSource: ()=>hasNoTypeScriptSource,
        indent: ()=>indent2,
        isBackgroundProject: ()=>isBackgroundProject,
        isConfigFile: ()=>isConfigFile,
        isConfiguredProject: ()=>isConfiguredProject,
        isDynamicFileName: ()=>isDynamicFileName,
        isExternalProject: ()=>isExternalProject,
        isInferredProject: ()=>isInferredProject,
        isInferredProjectName: ()=>isInferredProjectName,
        isProjectDeferredClose: ()=>isProjectDeferredClose,
        makeAutoImportProviderProjectName: ()=>makeAutoImportProviderProjectName,
        makeAuxiliaryProjectName: ()=>makeAuxiliaryProjectName,
        makeInferredProjectName: ()=>makeInferredProjectName,
        maxFileSize: ()=>maxFileSize,
        maxProgramSizeForNonTsFiles: ()=>maxProgramSizeForNonTsFiles,
        normalizedPathToPath: ()=>normalizedPathToPath,
        nowString: ()=>nowString,
        nullCancellationToken: ()=>nullCancellationToken,
        nullTypingsInstaller: ()=>nullTypingsInstaller,
        protocol: ()=>ts_server_protocol_exports,
        scriptInfoIsContainedByBackgroundProject: ()=>scriptInfoIsContainedByBackgroundProject,
        scriptInfoIsContainedByDeferredClosedProject: ()=>scriptInfoIsContainedByDeferredClosedProject,
        stringifyIndented: ()=>stringifyIndented,
        toEvent: ()=>toEvent,
        toNormalizedPath: ()=>toNormalizedPath,
        tryConvertScriptKindName: ()=>tryConvertScriptKindName,
        typingsInstaller: ()=>ts_server_typingsInstaller_exports,
        updateProjectIfDirty: ()=>updateProjectIfDirty
    });
    // src/typingsInstallerCore/_namespaces/ts.server.typingsInstaller.ts
    var ts_server_typingsInstaller_exports = {};
    __export(ts_server_typingsInstaller_exports, {
        TypingsInstaller: ()=>TypingsInstaller,
        getNpmCommandForInstallation: ()=>getNpmCommandForInstallation,
        installNpmPackages: ()=>installNpmPackages,
        typingsName: ()=>typingsName
    });
    // src/typingsInstallerCore/typingsInstaller.ts
    var nullLog = {
        isEnabled: ()=>false,
        writeLine: noop
    };
    function typingToFileName(cachePath, packageName, installTypingHost, log) {
        try {
            const result = resolveModuleName(packageName, combinePaths(cachePath, "index.d.ts"), {
                moduleResolution: 2 /* Node10 */ 
            }, installTypingHost);
            return result.resolvedModule && result.resolvedModule.resolvedFileName;
        } catch (e) {
            if (log.isEnabled()) log.writeLine(`Failed to resolve ${packageName} in folder '${cachePath}': ${e.message}`);
            return void 0;
        }
    }
    function installNpmPackages(npmPath, tsVersion, packageNames, install) {
        let hasError = false;
        for(let remaining = packageNames.length; remaining > 0;){
            const result = getNpmCommandForInstallation(npmPath, tsVersion, packageNames, remaining);
            remaining = result.remaining;
            hasError = install(result.command) || hasError;
        }
        return hasError;
    }
    function getNpmCommandForInstallation(npmPath, tsVersion, packageNames, remaining) {
        const sliceStart = packageNames.length - remaining;
        let command, toSlice = remaining;
        while(true){
            command = `${npmPath} install --ignore-scripts ${(toSlice === packageNames.length ? packageNames : packageNames.slice(sliceStart, sliceStart + toSlice)).join(" ")} --save-dev --user-agent="typesInstaller/${tsVersion}"`;
            if (command.length < 8e3) break;
            toSlice = toSlice - Math.floor(toSlice / 2);
        }
        return {
            command,
            remaining: remaining - toSlice
        };
    }
    var TypingsInstaller = class {
        /** @internal */ handleRequest(req) {
            switch(req.kind){
                case "discover":
                    this.install(req);
                    break;
                case "closeProject":
                    this.closeProject(req);
                    break;
                case "typesRegistry":
                    {
                        const typesRegistry = {};
                        this.typesRegistry.forEach((value1, key)=>{
                            typesRegistry[key] = value1;
                        });
                        const response = {
                            kind: EventTypesRegistry,
                            typesRegistry
                        };
                        this.sendResponse(response);
                        break;
                    }
                case "installPackage":
                    this.installPackage(req);
                    break;
                default:
                    Debug.assertNever(req);
            }
        }
        closeProject(req) {
            this.closeWatchers(req.projectName);
        }
        closeWatchers(projectName) {
            if (this.log.isEnabled()) this.log.writeLine(`Closing file watchers for project '${projectName}'`);
            const watchers = this.projectWatchers.get(projectName);
            if (!watchers) {
                if (this.log.isEnabled()) this.log.writeLine(`No watchers are registered for project '${projectName}'`);
                return;
            }
            this.projectWatchers.delete(projectName);
            this.sendResponse({
                kind: ActionWatchTypingLocations,
                projectName,
                files: []
            });
            if (this.log.isEnabled()) this.log.writeLine(`Closing file watchers for project '${projectName}' - done.`);
        }
        install(req) {
            if (this.log.isEnabled()) this.log.writeLine(`Got install request${stringifyIndented(req)}`);
            if (req.cachePath) {
                if (this.log.isEnabled()) this.log.writeLine(`Request specifies cache path '${req.cachePath}', loading cached information...`);
                this.processCacheLocation(req.cachePath);
            }
            if (this.safeList === void 0) this.initializeSafeList();
            const discoverTypingsResult = ts_JsTyping_exports.discoverTypings(this.installTypingHost, this.log.isEnabled() ? (s)=>this.log.writeLine(s) : void 0, req.fileNames, req.projectRootPath, this.safeList, this.packageNameToTypingLocation, req.typeAcquisition, req.unresolvedImports, this.typesRegistry, req.compilerOptions);
            this.watchFiles(req.projectName, discoverTypingsResult.filesToWatch);
            if (discoverTypingsResult.newTypingNames.length) this.installTypings(req, req.cachePath || this.globalCachePath, discoverTypingsResult.cachedTypingPaths, discoverTypingsResult.newTypingNames);
            else {
                this.sendResponse(this.createSetTypings(req, discoverTypingsResult.cachedTypingPaths));
                if (this.log.isEnabled()) this.log.writeLine(`No new typings were requested as a result of typings discovery`);
            }
        }
        /** @internal */ installPackage(req) {
            const { fileName, packageName, projectName, projectRootPath, id } = req;
            const cwd = forEachAncestorDirectory(getDirectoryPath(fileName), (directory)=>{
                if (this.installTypingHost.fileExists(combinePaths(directory, "package.json"))) return directory;
            }) || projectRootPath;
            if (cwd) this.installWorker(-1, [
                packageName
            ], cwd, (success)=>{
                const message = success ? `Package ${packageName} installed.` : `There was an error installing ${packageName}.`;
                const response = {
                    kind: ActionPackageInstalled,
                    projectName,
                    id,
                    success,
                    message
                };
                this.sendResponse(response);
            });
            else {
                const response = {
                    kind: ActionPackageInstalled,
                    projectName,
                    id,
                    success: false,
                    message: "Could not determine a project root path."
                };
                this.sendResponse(response);
            }
        }
        initializeSafeList() {
            if (this.typesMapLocation) {
                const safeListFromMap = ts_JsTyping_exports.loadTypesMap(this.installTypingHost, this.typesMapLocation);
                if (safeListFromMap) {
                    this.log.writeLine(`Loaded safelist from types map file '${this.typesMapLocation}'`);
                    this.safeList = safeListFromMap;
                    return;
                }
                this.log.writeLine(`Failed to load safelist from types map file '${this.typesMapLocation}'`);
            }
            this.safeList = ts_JsTyping_exports.loadSafeList(this.installTypingHost, this.safeListPath);
        }
        processCacheLocation(cacheLocation) {
            if (this.log.isEnabled()) this.log.writeLine(`Processing cache location '${cacheLocation}'`);
            if (this.knownCachesSet.has(cacheLocation)) {
                if (this.log.isEnabled()) this.log.writeLine(`Cache location was already processed...`);
                return;
            }
            const packageJson = combinePaths(cacheLocation, "package.json");
            const packageLockJson = combinePaths(cacheLocation, "package-lock.json");
            if (this.log.isEnabled()) this.log.writeLine(`Trying to find '${packageJson}'...`);
            if (this.installTypingHost.fileExists(packageJson) && this.installTypingHost.fileExists(packageLockJson)) {
                const npmConfig = JSON.parse(this.installTypingHost.readFile(packageJson));
                const npmLock = JSON.parse(this.installTypingHost.readFile(packageLockJson));
                if (this.log.isEnabled()) {
                    this.log.writeLine(`Loaded content of '${packageJson}':${stringifyIndented(npmConfig)}`);
                    this.log.writeLine(`Loaded content of '${packageLockJson}':${stringifyIndented(npmLock)}`);
                }
                if (npmConfig.devDependencies && (npmLock.packages || npmLock.dependencies)) for(const key in npmConfig.devDependencies){
                    if (npmLock.packages && !hasProperty(npmLock.packages, `node_modules/${key}`) || npmLock.dependencies && !hasProperty(npmLock.dependencies, key)) continue;
                    const packageName = getBaseFileName(key);
                    if (!packageName) continue;
                    const typingFile = typingToFileName(cacheLocation, packageName, this.installTypingHost, this.log);
                    if (!typingFile) {
                        this.missingTypingsSet.add(packageName);
                        continue;
                    }
                    const existingTypingFile = this.packageNameToTypingLocation.get(packageName);
                    if (existingTypingFile) {
                        if (existingTypingFile.typingLocation === typingFile) continue;
                        if (this.log.isEnabled()) this.log.writeLine(`New typing for package ${packageName} from '${typingFile}' conflicts with existing typing file '${existingTypingFile}'`);
                    }
                    if (this.log.isEnabled()) this.log.writeLine(`Adding entry into typings cache: '${packageName}' => '${typingFile}'`);
                    const info = npmLock.packages && getProperty(npmLock.packages, `node_modules/${key}`) || getProperty(npmLock.dependencies, key);
                    const version2 = info && info.version;
                    if (!version2) continue;
                    const newTyping = {
                        typingLocation: typingFile,
                        version: new Version(version2)
                    };
                    this.packageNameToTypingLocation.set(packageName, newTyping);
                }
            }
            if (this.log.isEnabled()) this.log.writeLine(`Finished processing cache location '${cacheLocation}'`);
            this.knownCachesSet.add(cacheLocation);
        }
        filterTypings(typingsToInstall) {
            return mapDefined(typingsToInstall, (typing)=>{
                const typingKey = mangleScopedPackageName(typing);
                if (this.missingTypingsSet.has(typingKey)) {
                    if (this.log.isEnabled()) this.log.writeLine(`'${typing}':: '${typingKey}' is in missingTypingsSet - skipping...`);
                    return void 0;
                }
                const validationResult = ts_JsTyping_exports.validatePackageName(typing);
                if (validationResult !== ts_JsTyping_exports.NameValidationResult.Ok) {
                    this.missingTypingsSet.add(typingKey);
                    if (this.log.isEnabled()) this.log.writeLine(ts_JsTyping_exports.renderPackageNameValidationFailure(validationResult, typing));
                    return void 0;
                }
                if (!this.typesRegistry.has(typingKey)) {
                    if (this.log.isEnabled()) this.log.writeLine(`'${typing}':: Entry for package '${typingKey}' does not exist in local types registry - skipping...`);
                    return void 0;
                }
                if (this.packageNameToTypingLocation.get(typingKey) && ts_JsTyping_exports.isTypingUpToDate(this.packageNameToTypingLocation.get(typingKey), this.typesRegistry.get(typingKey))) {
                    if (this.log.isEnabled()) this.log.writeLine(`'${typing}':: '${typingKey}' already has an up-to-date typing - skipping...`);
                    return void 0;
                }
                return typingKey;
            });
        }
        ensurePackageDirectoryExists(directory) {
            const npmConfigPath = combinePaths(directory, "package.json");
            if (this.log.isEnabled()) this.log.writeLine(`Npm config file: ${npmConfigPath}`);
            if (!this.installTypingHost.fileExists(npmConfigPath)) {
                if (this.log.isEnabled()) this.log.writeLine(`Npm config file: '${npmConfigPath}' is missing, creating new one...`);
                this.ensureDirectoryExists(directory, this.installTypingHost);
                this.installTypingHost.writeFile(npmConfigPath, '{ "private": true }');
            }
        }
        installTypings(req, cachePath, currentlyCachedTypings, typingsToInstall) {
            if (this.log.isEnabled()) this.log.writeLine(`Installing typings ${JSON.stringify(typingsToInstall)}`);
            const filteredTypings = this.filterTypings(typingsToInstall);
            if (filteredTypings.length === 0) {
                if (this.log.isEnabled()) this.log.writeLine(`All typings are known to be missing or invalid - no need to install more typings`);
                this.sendResponse(this.createSetTypings(req, currentlyCachedTypings));
                return;
            }
            this.ensurePackageDirectoryExists(cachePath);
            const requestId = this.installRunCount;
            this.installRunCount++;
            this.sendResponse({
                kind: EventBeginInstallTypes,
                eventId: requestId,
                typingsInstallerVersion: version,
                projectName: req.projectName
            });
            const scopedTypings = filteredTypings.map(typingsName);
            this.installTypingsAsync(requestId, scopedTypings, cachePath, (ok)=>{
                try {
                    if (!ok) {
                        if (this.log.isEnabled()) this.log.writeLine(`install request failed, marking packages as missing to prevent repeated requests: ${JSON.stringify(filteredTypings)}`);
                        for (const typing of filteredTypings)this.missingTypingsSet.add(typing);
                        return;
                    }
                    if (this.log.isEnabled()) this.log.writeLine(`Installed typings ${JSON.stringify(scopedTypings)}`);
                    const installedTypingFiles = [];
                    for (const packageName of filteredTypings){
                        const typingFile = typingToFileName(cachePath, packageName, this.installTypingHost, this.log);
                        if (!typingFile) {
                            this.missingTypingsSet.add(packageName);
                            continue;
                        }
                        const distTags = this.typesRegistry.get(packageName);
                        const newVersion = new Version(distTags[`ts${versionMajorMinor}`] || distTags[this.latestDistTag]);
                        const newTyping = {
                            typingLocation: typingFile,
                            version: newVersion
                        };
                        this.packageNameToTypingLocation.set(packageName, newTyping);
                        installedTypingFiles.push(typingFile);
                    }
                    if (this.log.isEnabled()) this.log.writeLine(`Installed typing files ${JSON.stringify(installedTypingFiles)}`);
                    this.sendResponse(this.createSetTypings(req, currentlyCachedTypings.concat(installedTypingFiles)));
                } finally{
                    const response = {
                        kind: EventEndInstallTypes,
                        eventId: requestId,
                        projectName: req.projectName,
                        packagesToInstall: scopedTypings,
                        installSuccess: ok,
                        typingsInstallerVersion: version
                    };
                    this.sendResponse(response);
                }
            });
        }
        ensureDirectoryExists(directory, host) {
            const directoryName = getDirectoryPath(directory);
            if (!host.directoryExists(directoryName)) this.ensureDirectoryExists(directoryName, host);
            if (!host.directoryExists(directory)) host.createDirectory(directory);
        }
        watchFiles(projectName, files) {
            if (!files.length) {
                this.closeWatchers(projectName);
                return;
            }
            const existing = this.projectWatchers.get(projectName);
            const newSet = new Set(files);
            if (!existing || forEachKey(newSet, (s)=>!existing.has(s)) || forEachKey(existing, (s)=>!newSet.has(s))) {
                this.projectWatchers.set(projectName, newSet);
                this.sendResponse({
                    kind: ActionWatchTypingLocations,
                    projectName,
                    files
                });
            } else this.sendResponse({
                kind: ActionWatchTypingLocations,
                projectName,
                files: void 0
            });
        }
        createSetTypings(request, typings) {
            return {
                projectName: request.projectName,
                typeAcquisition: request.typeAcquisition,
                compilerOptions: request.compilerOptions,
                typings,
                unresolvedImports: request.unresolvedImports,
                kind: ActionSet
            };
        }
        installTypingsAsync(requestId, packageNames, cwd, onRequestCompleted) {
            this.pendingRunRequests.unshift({
                requestId,
                packageNames,
                cwd,
                onRequestCompleted
            });
            this.executeWithThrottling();
        }
        executeWithThrottling() {
            while(this.inFlightRequestCount < this.throttleLimit && this.pendingRunRequests.length){
                this.inFlightRequestCount++;
                const request = this.pendingRunRequests.pop();
                this.installWorker(request.requestId, request.packageNames, request.cwd, (ok)=>{
                    this.inFlightRequestCount--;
                    request.onRequestCompleted(ok);
                    this.executeWithThrottling();
                });
            }
        }
        constructor(installTypingHost, globalCachePath, safeListPath, typesMapLocation, throttleLimit, log = nullLog){
            this.installTypingHost = installTypingHost;
            this.globalCachePath = globalCachePath;
            this.safeListPath = safeListPath;
            this.typesMapLocation = typesMapLocation;
            this.throttleLimit = throttleLimit;
            this.log = log;
            this.packageNameToTypingLocation = /* @__PURE__ */ new Map();
            this.missingTypingsSet = /* @__PURE__ */ new Set();
            this.knownCachesSet = /* @__PURE__ */ new Set();
            this.projectWatchers = /* @__PURE__ */ new Map();
            this.pendingRunRequests = [];
            this.installRunCount = 1;
            this.inFlightRequestCount = 0;
            // eslint-disable-line @typescript-eslint/unified-signatures
            this.latestDistTag = "latest";
            const isLoggingEnabled = this.log.isEnabled();
            if (isLoggingEnabled) this.log.writeLine(`Global cache location '${globalCachePath}', safe file path '${safeListPath}', types map path ${typesMapLocation}`);
            this.processCacheLocation(this.globalCachePath);
        }
    };
    function typingsName(packageName) {
        return `@types/${packageName}@ts${versionMajorMinor}`;
    }
    // src/server/utilitiesPublic.ts
    var LogLevel2 = /* @__PURE__ */ ((LogLevel3)=>{
        LogLevel3[LogLevel3["terse"] = 0] = "terse";
        LogLevel3[LogLevel3["normal"] = 1] = "normal";
        LogLevel3[LogLevel3["requestTime"] = 2] = "requestTime";
        LogLevel3[LogLevel3["verbose"] = 3] = "verbose";
        return LogLevel3;
    })(LogLevel2 || {});
    var emptyArray2 = createSortedArray2();
    var Msg = /* @__PURE__ */ ((Msg2)=>{
        Msg2["Err"] = "Err";
        Msg2["Info"] = "Info";
        Msg2["Perf"] = "Perf";
        return Msg2;
    })(Msg || {});
    function createInstallTypingsRequest(project, typeAcquisition, unresolvedImports, cachePath) {
        return {
            projectName: project.getProjectName(),
            fileNames: project.getFileNames(/*excludeFilesFromExternalLibraries*/ true, /*excludeConfigFiles*/ true).concat(project.getExcludedFiles()),
            compilerOptions: project.getCompilationSettings(),
            typeAcquisition,
            unresolvedImports,
            projectRootPath: project.getCurrentDirectory(),
            cachePath,
            kind: "discover"
        };
    }
    var Errors;
    ((Errors2)=>{
        function ThrowNoProject() {
            throw new Error("No Project.");
        }
        Errors2.ThrowNoProject = ThrowNoProject;
        function ThrowProjectLanguageServiceDisabled() {
            throw new Error("The project's language service is disabled.");
        }
        Errors2.ThrowProjectLanguageServiceDisabled = ThrowProjectLanguageServiceDisabled;
        function ThrowProjectDoesNotContainDocument(fileName, project) {
            throw new Error(`Project '${project.getProjectName()}' does not contain document '${fileName}'`);
        }
        Errors2.ThrowProjectDoesNotContainDocument = ThrowProjectDoesNotContainDocument;
    })(Errors || (Errors = {}));
    function toNormalizedPath(fileName) {
        return normalizePath(fileName);
    }
    function normalizedPathToPath(normalizedPath, currentDirectory, getCanonicalFileName) {
        const f = isRootedDiskPath(normalizedPath) ? normalizedPath : getNormalizedAbsolutePath(normalizedPath, currentDirectory);
        return getCanonicalFileName(f);
    }
    function asNormalizedPath(fileName) {
        return fileName;
    }
    function createNormalizedPathMap() {
        const map2 = /* @__PURE__ */ new Map();
        return {
            get (path) {
                return map2.get(path);
            },
            set (path, value1) {
                map2.set(path, value1);
            },
            contains (path) {
                return map2.has(path);
            },
            remove (path) {
                map2.delete(path);
            }
        };
    }
    function isInferredProjectName(name) {
        return /dev\/null\/inferredProject\d+\*/.test(name);
    }
    function makeInferredProjectName(counter) {
        return `/dev/null/inferredProject${counter}*`;
    }
    function makeAutoImportProviderProjectName(counter) {
        return `/dev/null/autoImportProviderProject${counter}*`;
    }
    function makeAuxiliaryProjectName(counter) {
        return `/dev/null/auxiliaryProject${counter}*`;
    }
    function createSortedArray2() {
        return [];
    }
    // src/server/utilities.ts
    var ThrottledOperations = class _ThrottledOperations {
        /**
   * Wait `number` milliseconds and then invoke `cb`.  If, while waiting, schedule
   * is called again with the same `operationId`, cancel this operation in favor
   * of the new one.  (Note that the amount of time the canceled operation had been
   * waiting does not affect the amount of time that the new operation waits.)
   */ schedule(operationId, delay, cb) {
            const pendingTimeout = this.pendingTimeouts.get(operationId);
            if (pendingTimeout) this.host.clearTimeout(pendingTimeout);
            this.pendingTimeouts.set(operationId, this.host.setTimeout(_ThrottledOperations.run, delay, operationId, this, cb));
            if (this.logger) this.logger.info(`Scheduled: ${operationId}${pendingTimeout ? ", Cancelled earlier one" : ""}`);
        }
        cancel(operationId) {
            const pendingTimeout = this.pendingTimeouts.get(operationId);
            if (!pendingTimeout) return false;
            this.host.clearTimeout(pendingTimeout);
            return this.pendingTimeouts.delete(operationId);
        }
        static run(operationId, self, cb) {
            self.pendingTimeouts.delete(operationId);
            if (self.logger) self.logger.info(`Running: ${operationId}`);
            cb();
        }
        constructor(host, logger){
            this.host = host;
            this.pendingTimeouts = /* @__PURE__ */ new Map();
            this.logger = logger.hasLevel(3 /* verbose */ ) ? logger : void 0;
        }
    };
    var GcTimer = class _GcTimer {
        scheduleCollect() {
            if (!this.host.gc || this.timerId !== void 0) return;
            this.timerId = this.host.setTimeout(_GcTimer.run, this.delay, this);
        }
        static run(self) {
            self.timerId = void 0;
            const log = self.logger.hasLevel(2 /* requestTime */ );
            const before = log && self.host.getMemoryUsage();
            self.host.gc();
            if (log) {
                const after = self.host.getMemoryUsage();
                self.logger.perftrc(`GC::before ${before}, after ${after}`);
            }
        }
        constructor(host, delay, logger){
            this.host = host;
            this.delay = delay;
            this.logger = logger;
        }
    };
    function getBaseConfigFileName(configFilePath) {
        const base = getBaseFileName(configFilePath);
        return base === "tsconfig.json" || base === "jsconfig.json" ? base : void 0;
    }
    // src/server/_namespaces/ts.server.protocol.ts
    var ts_server_protocol_exports = {};
    __export(ts_server_protocol_exports, {
        ClassificationType: ()=>ClassificationType,
        CommandTypes: ()=>CommandTypes,
        CompletionTriggerKind: ()=>CompletionTriggerKind,
        IndentStyle: ()=>IndentStyle2,
        JsxEmit: ()=>JsxEmit2,
        ModuleKind: ()=>ModuleKind2,
        ModuleResolutionKind: ()=>ModuleResolutionKind2,
        NewLineKind: ()=>NewLineKind2,
        OrganizeImportsMode: ()=>OrganizeImportsMode,
        PollingWatchKind: ()=>PollingWatchKind2,
        ScriptTarget: ()=>ScriptTarget11,
        SemicolonPreference: ()=>SemicolonPreference,
        WatchDirectoryKind: ()=>WatchDirectoryKind2,
        WatchFileKind: ()=>WatchFileKind2
    });
    // src/server/protocol.ts
    var CommandTypes = /* @__PURE__ */ ((CommandTypes2)=>{
        CommandTypes2["JsxClosingTag"] = "jsxClosingTag";
        CommandTypes2["LinkedEditingRange"] = "linkedEditingRange";
        CommandTypes2["Brace"] = "brace";
        CommandTypes2["BraceFull"] = "brace-full";
        CommandTypes2["BraceCompletion"] = "braceCompletion";
        CommandTypes2["GetSpanOfEnclosingComment"] = "getSpanOfEnclosingComment";
        CommandTypes2["Change"] = "change";
        CommandTypes2["Close"] = "close";
        CommandTypes2["Completions"] = "completions";
        CommandTypes2["CompletionInfo"] = "completionInfo";
        CommandTypes2["CompletionsFull"] = "completions-full";
        CommandTypes2["CompletionDetails"] = "completionEntryDetails";
        CommandTypes2["CompletionDetailsFull"] = "completionEntryDetails-full";
        CommandTypes2["CompileOnSaveAffectedFileList"] = "compileOnSaveAffectedFileList";
        CommandTypes2["CompileOnSaveEmitFile"] = "compileOnSaveEmitFile";
        CommandTypes2["Configure"] = "configure";
        CommandTypes2["Definition"] = "definition";
        CommandTypes2["DefinitionFull"] = "definition-full";
        CommandTypes2["DefinitionAndBoundSpan"] = "definitionAndBoundSpan";
        CommandTypes2["DefinitionAndBoundSpanFull"] = "definitionAndBoundSpan-full";
        CommandTypes2["Implementation"] = "implementation";
        CommandTypes2["ImplementationFull"] = "implementation-full";
        CommandTypes2["EmitOutput"] = "emit-output";
        CommandTypes2["Exit"] = "exit";
        CommandTypes2["FileReferences"] = "fileReferences";
        CommandTypes2["FileReferencesFull"] = "fileReferences-full";
        CommandTypes2["Format"] = "format";
        CommandTypes2["Formatonkey"] = "formatonkey";
        CommandTypes2["FormatFull"] = "format-full";
        CommandTypes2["FormatonkeyFull"] = "formatonkey-full";
        CommandTypes2["FormatRangeFull"] = "formatRange-full";
        CommandTypes2["Geterr"] = "geterr";
        CommandTypes2["GeterrForProject"] = "geterrForProject";
        CommandTypes2["SemanticDiagnosticsSync"] = "semanticDiagnosticsSync";
        CommandTypes2["SyntacticDiagnosticsSync"] = "syntacticDiagnosticsSync";
        CommandTypes2["SuggestionDiagnosticsSync"] = "suggestionDiagnosticsSync";
        CommandTypes2["NavBar"] = "navbar";
        CommandTypes2["NavBarFull"] = "navbar-full";
        CommandTypes2["Navto"] = "navto";
        CommandTypes2["NavtoFull"] = "navto-full";
        CommandTypes2["NavTree"] = "navtree";
        CommandTypes2["NavTreeFull"] = "navtree-full";
        CommandTypes2["DocumentHighlights"] = "documentHighlights";
        CommandTypes2["DocumentHighlightsFull"] = "documentHighlights-full";
        CommandTypes2["Open"] = "open";
        CommandTypes2["Quickinfo"] = "quickinfo";
        CommandTypes2["QuickinfoFull"] = "quickinfo-full";
        CommandTypes2["References"] = "references";
        CommandTypes2["ReferencesFull"] = "references-full";
        CommandTypes2["Reload"] = "reload";
        CommandTypes2["Rename"] = "rename";
        CommandTypes2["RenameInfoFull"] = "rename-full";
        CommandTypes2["RenameLocationsFull"] = "renameLocations-full";
        CommandTypes2["Saveto"] = "saveto";
        CommandTypes2["SignatureHelp"] = "signatureHelp";
        CommandTypes2["SignatureHelpFull"] = "signatureHelp-full";
        CommandTypes2["FindSourceDefinition"] = "findSourceDefinition";
        CommandTypes2["Status"] = "status";
        CommandTypes2["TypeDefinition"] = "typeDefinition";
        CommandTypes2["ProjectInfo"] = "projectInfo";
        CommandTypes2["ReloadProjects"] = "reloadProjects";
        CommandTypes2["Unknown"] = "unknown";
        CommandTypes2["OpenExternalProject"] = "openExternalProject";
        CommandTypes2["OpenExternalProjects"] = "openExternalProjects";
        CommandTypes2["CloseExternalProject"] = "closeExternalProject";
        CommandTypes2["SynchronizeProjectList"] = "synchronizeProjectList";
        CommandTypes2["ApplyChangedToOpenFiles"] = "applyChangedToOpenFiles";
        CommandTypes2["UpdateOpen"] = "updateOpen";
        CommandTypes2["EncodedSyntacticClassificationsFull"] = "encodedSyntacticClassifications-full";
        CommandTypes2["EncodedSemanticClassificationsFull"] = "encodedSemanticClassifications-full";
        CommandTypes2["Cleanup"] = "cleanup";
        CommandTypes2["GetOutliningSpans"] = "getOutliningSpans";
        CommandTypes2["GetOutliningSpansFull"] = "outliningSpans";
        CommandTypes2["TodoComments"] = "todoComments";
        CommandTypes2["Indentation"] = "indentation";
        CommandTypes2["DocCommentTemplate"] = "docCommentTemplate";
        CommandTypes2["CompilerOptionsDiagnosticsFull"] = "compilerOptionsDiagnostics-full";
        CommandTypes2["NameOrDottedNameSpan"] = "nameOrDottedNameSpan";
        CommandTypes2["BreakpointStatement"] = "breakpointStatement";
        CommandTypes2["CompilerOptionsForInferredProjects"] = "compilerOptionsForInferredProjects";
        CommandTypes2["GetCodeFixes"] = "getCodeFixes";
        CommandTypes2["GetCodeFixesFull"] = "getCodeFixes-full";
        CommandTypes2["GetCombinedCodeFix"] = "getCombinedCodeFix";
        CommandTypes2["GetCombinedCodeFixFull"] = "getCombinedCodeFix-full";
        CommandTypes2["ApplyCodeActionCommand"] = "applyCodeActionCommand";
        CommandTypes2["GetSupportedCodeFixes"] = "getSupportedCodeFixes";
        CommandTypes2["GetApplicableRefactors"] = "getApplicableRefactors";
        CommandTypes2["GetEditsForRefactor"] = "getEditsForRefactor";
        CommandTypes2["GetMoveToRefactoringFileSuggestions"] = "getMoveToRefactoringFileSuggestions";
        CommandTypes2["PreparePasteEdits"] = "preparePasteEdits";
        CommandTypes2["GetPasteEdits"] = "getPasteEdits";
        CommandTypes2["GetEditsForRefactorFull"] = "getEditsForRefactor-full";
        CommandTypes2["OrganizeImports"] = "organizeImports";
        CommandTypes2["OrganizeImportsFull"] = "organizeImports-full";
        CommandTypes2["GetEditsForFileRename"] = "getEditsForFileRename";
        CommandTypes2["GetEditsForFileRenameFull"] = "getEditsForFileRename-full";
        CommandTypes2["ConfigurePlugin"] = "configurePlugin";
        CommandTypes2["SelectionRange"] = "selectionRange";
        CommandTypes2["SelectionRangeFull"] = "selectionRange-full";
        CommandTypes2["ToggleLineComment"] = "toggleLineComment";
        CommandTypes2["ToggleLineCommentFull"] = "toggleLineComment-full";
        CommandTypes2["ToggleMultilineComment"] = "toggleMultilineComment";
        CommandTypes2["ToggleMultilineCommentFull"] = "toggleMultilineComment-full";
        CommandTypes2["CommentSelection"] = "commentSelection";
        CommandTypes2["CommentSelectionFull"] = "commentSelection-full";
        CommandTypes2["UncommentSelection"] = "uncommentSelection";
        CommandTypes2["UncommentSelectionFull"] = "uncommentSelection-full";
        CommandTypes2["PrepareCallHierarchy"] = "prepareCallHierarchy";
        CommandTypes2["ProvideCallHierarchyIncomingCalls"] = "provideCallHierarchyIncomingCalls";
        CommandTypes2["ProvideCallHierarchyOutgoingCalls"] = "provideCallHierarchyOutgoingCalls";
        CommandTypes2["ProvideInlayHints"] = "provideInlayHints";
        CommandTypes2["WatchChange"] = "watchChange";
        CommandTypes2["MapCode"] = "mapCode";
        CommandTypes2["CopilotRelated"] = "copilotRelated";
        return CommandTypes2;
    })(CommandTypes || {});
    var WatchFileKind2 = /* @__PURE__ */ ((WatchFileKind3)=>{
        WatchFileKind3["FixedPollingInterval"] = "FixedPollingInterval";
        WatchFileKind3["PriorityPollingInterval"] = "PriorityPollingInterval";
        WatchFileKind3["DynamicPriorityPolling"] = "DynamicPriorityPolling";
        WatchFileKind3["FixedChunkSizePolling"] = "FixedChunkSizePolling";
        WatchFileKind3["UseFsEvents"] = "UseFsEvents";
        WatchFileKind3["UseFsEventsOnParentDirectory"] = "UseFsEventsOnParentDirectory";
        return WatchFileKind3;
    })(WatchFileKind2 || {});
    var WatchDirectoryKind2 = /* @__PURE__ */ ((WatchDirectoryKind3)=>{
        WatchDirectoryKind3["UseFsEvents"] = "UseFsEvents";
        WatchDirectoryKind3["FixedPollingInterval"] = "FixedPollingInterval";
        WatchDirectoryKind3["DynamicPriorityPolling"] = "DynamicPriorityPolling";
        WatchDirectoryKind3["FixedChunkSizePolling"] = "FixedChunkSizePolling";
        return WatchDirectoryKind3;
    })(WatchDirectoryKind2 || {});
    var PollingWatchKind2 = /* @__PURE__ */ ((PollingWatchKind3)=>{
        PollingWatchKind3["FixedInterval"] = "FixedInterval";
        PollingWatchKind3["PriorityInterval"] = "PriorityInterval";
        PollingWatchKind3["DynamicPriority"] = "DynamicPriority";
        PollingWatchKind3["FixedChunkSize"] = "FixedChunkSize";
        return PollingWatchKind3;
    })(PollingWatchKind2 || {});
    var IndentStyle2 = /* @__PURE__ */ ((IndentStyle3)=>{
        IndentStyle3["None"] = "None";
        IndentStyle3["Block"] = "Block";
        IndentStyle3["Smart"] = "Smart";
        return IndentStyle3;
    })(IndentStyle2 || {});
    var JsxEmit2 = /* @__PURE__ */ ((JsxEmit3)=>{
        JsxEmit3["None"] = "none";
        JsxEmit3["Preserve"] = "preserve";
        JsxEmit3["ReactNative"] = "react-native";
        JsxEmit3["React"] = "react";
        JsxEmit3["ReactJSX"] = "react-jsx";
        JsxEmit3["ReactJSXDev"] = "react-jsxdev";
        return JsxEmit3;
    })(JsxEmit2 || {});
    var ModuleKind2 = /* @__PURE__ */ ((ModuleKind3)=>{
        ModuleKind3["None"] = "none";
        ModuleKind3["CommonJS"] = "commonjs";
        ModuleKind3["AMD"] = "amd";
        ModuleKind3["UMD"] = "umd";
        ModuleKind3["System"] = "system";
        ModuleKind3["ES6"] = "es6";
        ModuleKind3["ES2015"] = "es2015";
        ModuleKind3["ES2020"] = "es2020";
        ModuleKind3["ES2022"] = "es2022";
        ModuleKind3["ESNext"] = "esnext";
        ModuleKind3["Node16"] = "node16";
        ModuleKind3["Node18"] = "node18";
        ModuleKind3["Node20"] = "node20";
        ModuleKind3["NodeNext"] = "nodenext";
        ModuleKind3["Preserve"] = "preserve";
        return ModuleKind3;
    })(ModuleKind2 || {});
    var ModuleResolutionKind2 = /* @__PURE__ */ ((ModuleResolutionKind3)=>{
        ModuleResolutionKind3["Classic"] = "classic";
        ModuleResolutionKind3["Node"] = "node";
        ModuleResolutionKind3["NodeJs"] = "node";
        ModuleResolutionKind3["Node10"] = "node10";
        ModuleResolutionKind3["Node16"] = "node16";
        ModuleResolutionKind3["NodeNext"] = "nodenext";
        ModuleResolutionKind3["Bundler"] = "bundler";
        return ModuleResolutionKind3;
    })(ModuleResolutionKind2 || {});
    var NewLineKind2 = /* @__PURE__ */ ((NewLineKind3)=>{
        NewLineKind3["Crlf"] = "Crlf";
        NewLineKind3["Lf"] = "Lf";
        return NewLineKind3;
    })(NewLineKind2 || {});
    var ScriptTarget11 = /* @__PURE__ */ ((ScriptTarget12)=>{
        ScriptTarget12["ES3"] = "es3";
        ScriptTarget12["ES5"] = "es5";
        ScriptTarget12["ES6"] = "es6";
        ScriptTarget12["ES2015"] = "es2015";
        ScriptTarget12["ES2016"] = "es2016";
        ScriptTarget12["ES2017"] = "es2017";
        ScriptTarget12["ES2018"] = "es2018";
        ScriptTarget12["ES2019"] = "es2019";
        ScriptTarget12["ES2020"] = "es2020";
        ScriptTarget12["ES2021"] = "es2021";
        ScriptTarget12["ES2022"] = "es2022";
        ScriptTarget12["ES2023"] = "es2023";
        ScriptTarget12["ES2024"] = "es2024";
        ScriptTarget12["ESNext"] = "esnext";
        ScriptTarget12["JSON"] = "json";
        ScriptTarget12["Latest"] = "esnext" /* ESNext */ ;
        return ScriptTarget12;
    })(ScriptTarget11 || {});
    // src/server/scriptInfo.ts
    var TextStorage = class {
        getVersion() {
            return this.svc ? `SVC-${this.version}-${this.svc.getSnapshotVersion()}` : `Text-${this.version}`;
        }
        hasScriptVersionCache_TestOnly() {
            return this.svc !== void 0;
        }
        resetSourceMapInfo() {
            this.info.sourceFileLike = void 0;
            this.info.closeSourceMapFileWatcher();
            this.info.sourceMapFilePath = void 0;
            this.info.declarationInfoPath = void 0;
            this.info.sourceInfos = void 0;
            this.info.documentPositionMapper = void 0;
        }
        /** Public for testing */ useText(newText) {
            this.svc = void 0;
            this.text = newText;
            this.textSnapshot = void 0;
            this.lineMap = void 0;
            this.fileSize = void 0;
            this.resetSourceMapInfo();
            this.version++;
        }
        edit(start, end, newText) {
            this.switchToScriptVersionCache().edit(start, end - start, newText);
            this.ownFileText = false;
            this.text = void 0;
            this.textSnapshot = void 0;
            this.lineMap = void 0;
            this.fileSize = void 0;
            this.resetSourceMapInfo();
        }
        /**
   * Set the contents as newText
   * returns true if text changed
   */ reload(newText) {
            Debug.assert(newText !== void 0);
            this.pendingReloadFromDisk = false;
            if (!this.text && this.svc) this.text = getSnapshotText(this.svc.getSnapshot());
            if (this.text !== newText) {
                this.useText(newText);
                this.ownFileText = false;
                return true;
            }
            return false;
        }
        /**
   * Reads the contents from tempFile(if supplied) or own file and sets it as contents
   * returns true if text changed
   */ reloadWithFileText(tempFileName) {
            const { text: newText, fileSize } = tempFileName || !this.info.isDynamicOrHasMixedContent() ? this.getFileTextAndSize(tempFileName) : {
                text: "",
                fileSize: void 0
            };
            const reloaded = this.reload(newText);
            this.fileSize = fileSize;
            this.ownFileText = !tempFileName || tempFileName === this.info.fileName;
            if (this.ownFileText && this.info.mTime === missingFileModifiedTime.getTime()) this.info.mTime = (this.host.getModifiedTime(this.info.fileName) || missingFileModifiedTime).getTime();
            return reloaded;
        }
        /**
   * Schedule reload from the disk if its not already scheduled and its not own text
   * returns true when scheduling reload
   */ scheduleReloadIfNeeded() {
            return !this.pendingReloadFromDisk && !this.ownFileText ? this.pendingReloadFromDisk = true : false;
        }
        delayReloadFromFileIntoText() {
            this.pendingReloadFromDisk = true;
        }
        /**
   * For telemetry purposes, we would like to be able to report the size of the file.
   * However, we do not want telemetry to require extra file I/O so we report a size
   * that may be stale (e.g. may not reflect change made on disk since the last reload).
   * NB: Will read from disk if the file contents have never been loaded because
   * telemetry falsely indicating size 0 would be counter-productive.
   */ getTelemetryFileSize() {
            return !!this.fileSize ? this.fileSize : !!this.text ? this.text.length : !!this.svc ? this.svc.getSnapshot().getLength() : this.getSnapshot().getLength();
        }
        getSnapshot() {
            var _a;
            var _this_textSnapshot;
            return ((_a = this.tryUseScriptVersionCache()) == null ? void 0 : _a.getSnapshot()) || ((_this_textSnapshot = this.textSnapshot) !== null && _this_textSnapshot !== void 0 ? _this_textSnapshot : this.textSnapshot = ScriptSnapshot.fromString(Debug.checkDefined(this.text)));
        }
        getAbsolutePositionAndLineText(oneBasedLine) {
            const svc = this.tryUseScriptVersionCache();
            if (svc) return svc.getAbsolutePositionAndLineText(oneBasedLine);
            const lineMap = this.getLineMap();
            return oneBasedLine <= lineMap.length ? {
                absolutePosition: lineMap[oneBasedLine - 1],
                lineText: this.text.substring(lineMap[oneBasedLine - 1], lineMap[oneBasedLine])
            } : {
                absolutePosition: this.text.length,
                lineText: void 0
            };
        }
        /**
   *  @param line 0 based index
   */ lineToTextSpan(line) {
            const svc = this.tryUseScriptVersionCache();
            if (svc) return svc.lineToTextSpan(line);
            const lineMap = this.getLineMap();
            const start = lineMap[line];
            const end = line + 1 < lineMap.length ? lineMap[line + 1] : this.text.length;
            return createTextSpanFromBounds(start, end);
        }
        /**
   * @param line 1 based index
   * @param offset 1 based index
   */ lineOffsetToPosition(line, offset, allowEdits) {
            const svc = this.tryUseScriptVersionCache();
            return svc ? svc.lineOffsetToPosition(line, offset) : computePositionOfLineAndCharacter(this.getLineMap(), line - 1, offset - 1, this.text, allowEdits);
        }
        positionToLineOffset(position) {
            const svc = this.tryUseScriptVersionCache();
            if (svc) return svc.positionToLineOffset(position);
            const { line, character } = computeLineAndCharacterOfPosition(this.getLineMap(), position);
            return {
                line: line + 1,
                offset: character + 1
            };
        }
        getFileTextAndSize(tempFileName) {
            let text;
            const fileName = tempFileName || this.info.fileName;
            const getText = ()=>text === void 0 ? text = this.host.readFile(fileName) || "" : text;
            if (!hasTSFileExtension(this.info.fileName)) {
                const fileSize = this.host.getFileSize ? this.host.getFileSize(fileName) : getText().length;
                if (fileSize > maxFileSize) {
                    Debug.assert(!!this.info.containingProjects.length);
                    const service = this.info.containingProjects[0].projectService;
                    service.logger.info(`Skipped loading contents of large file ${fileName} for info ${this.info.fileName}: fileSize: ${fileSize}`);
                    this.info.containingProjects[0].projectService.sendLargeFileReferencedEvent(fileName, fileSize);
                    return {
                        text: "",
                        fileSize
                    };
                }
            }
            return {
                text: getText()
            };
        }
        /** @internal */ switchToScriptVersionCache() {
            if (!this.svc || this.pendingReloadFromDisk) {
                this.svc = ScriptVersionCache.fromString(this.getOrLoadText());
                this.textSnapshot = void 0;
                this.version++;
            }
            return this.svc;
        }
        tryUseScriptVersionCache() {
            if (!this.svc || this.pendingReloadFromDisk) this.getOrLoadText();
            if (this.isOpen) {
                if (!this.svc && !this.textSnapshot) {
                    this.svc = ScriptVersionCache.fromString(Debug.checkDefined(this.text));
                    this.textSnapshot = void 0;
                }
                return this.svc;
            }
            return this.svc;
        }
        getOrLoadText() {
            if (this.text === void 0 || this.pendingReloadFromDisk) {
                Debug.assert(!this.svc || this.pendingReloadFromDisk, "ScriptVersionCache should not be set when reloading from disk");
                this.reloadWithFileText();
            }
            return this.text;
        }
        getLineMap() {
            Debug.assert(!this.svc, "ScriptVersionCache should not be set");
            return this.lineMap || (this.lineMap = computeLineStarts(Debug.checkDefined(this.text)));
        }
        getLineInfo() {
            const svc = this.tryUseScriptVersionCache();
            if (svc) return {
                getLineCount: ()=>svc.getLineCount(),
                getLineText: (line)=>svc.getAbsolutePositionAndLineText(line + 1).lineText
            };
            const lineMap = this.getLineMap();
            return getLineInfo(this.text, lineMap);
        }
        constructor(host, info, initialVersion){
            this.host = host;
            this.info = info;
            /**
     * True if the text is for the file thats open in the editor
     */ this.isOpen = false;
            /**
     * True if the text present is the text from the file on the disk
     */ this.ownFileText = false;
            /**
     * True when reloading contents of file from the disk is pending
     */ this.pendingReloadFromDisk = false;
            this.version = initialVersion || 0;
        }
    };
    function isDynamicFileName(fileName) {
        return fileName[0] === "^" || (fileName.includes("walkThroughSnippet:/") || fileName.includes("untitled:/")) && getBaseFileName(fileName)[0] === "^" || fileName.includes(":^") && !fileName.includes(directorySeparator);
    }
    var ScriptInfo = class {
        /** @internal */ isDynamicOrHasMixedContent() {
            return this.hasMixedContent || this.isDynamic;
        }
        isScriptOpen() {
            return this.textStorage.isOpen;
        }
        open(newText) {
            this.textStorage.isOpen = true;
            if (newText !== void 0 && this.textStorage.reload(newText)) this.markContainingProjectsAsDirty();
        }
        close(fileExists = true) {
            this.textStorage.isOpen = false;
            if (fileExists && this.textStorage.scheduleReloadIfNeeded()) this.markContainingProjectsAsDirty();
        }
        getSnapshot() {
            return this.textStorage.getSnapshot();
        }
        ensureRealPath() {
            if (this.realpath === void 0) {
                this.realpath = this.path;
                if (this.host.realpath) {
                    Debug.assert(!!this.containingProjects.length);
                    const project = this.containingProjects[0];
                    const realpath = this.host.realpath(this.path);
                    if (realpath) {
                        this.realpath = project.toPath(realpath);
                        if (this.realpath !== this.path) project.projectService.realpathToScriptInfos.add(this.realpath, this);
                    }
                }
            }
        }
        /** @internal */ getRealpathIfDifferent() {
            return this.realpath && this.realpath !== this.path ? this.realpath : void 0;
        }
        /**
   * @internal
   * Does not compute realpath; uses precomputed result. Use `ensureRealPath`
   * first if a definite result is needed.
   */ isSymlink() {
            return this.realpath && this.realpath !== this.path;
        }
        getFormatCodeSettings() {
            return this.formatSettings;
        }
        getPreferences() {
            return this.preferences;
        }
        attachToProject(project) {
            const isNew = !this.isAttached(project);
            if (isNew) {
                this.containingProjects.push(project);
                if (!project.getCompilerOptions().preserveSymlinks) this.ensureRealPath();
                project.onFileAddedOrRemoved(this.isSymlink());
            }
            return isNew;
        }
        isAttached(project) {
            switch(this.containingProjects.length){
                case 0:
                    return false;
                case 1:
                    return this.containingProjects[0] === project;
                case 2:
                    return this.containingProjects[0] === project || this.containingProjects[1] === project;
                default:
                    return contains(this.containingProjects, project);
            }
        }
        detachFromProject(project) {
            switch(this.containingProjects.length){
                case 0:
                    return;
                case 1:
                    if (this.containingProjects[0] === project) {
                        project.onFileAddedOrRemoved(this.isSymlink());
                        this.containingProjects.pop();
                    }
                    break;
                case 2:
                    if (this.containingProjects[0] === project) {
                        project.onFileAddedOrRemoved(this.isSymlink());
                        this.containingProjects[0] = this.containingProjects.pop();
                    } else if (this.containingProjects[1] === project) {
                        project.onFileAddedOrRemoved(this.isSymlink());
                        this.containingProjects.pop();
                    }
                    break;
                default:
                    if (orderedRemoveItem(this.containingProjects, project)) project.onFileAddedOrRemoved(this.isSymlink());
                    break;
            }
        }
        detachAllProjects() {
            for (const p of this.containingProjects){
                if (isConfiguredProject(p)) p.getCachedDirectoryStructureHost().addOrDeleteFile(this.fileName, this.path, 2 /* Deleted */ );
                const existingRoot = p.getRootFilesMap().get(this.path);
                p.removeFile(this, /*fileExists*/ false, /*detachFromProject*/ false);
                p.onFileAddedOrRemoved(this.isSymlink());
                if (existingRoot && !isInferredProject(p)) p.addMissingFileRoot(existingRoot.fileName);
            }
            clear(this.containingProjects);
        }
        getDefaultProject() {
            switch(this.containingProjects.length){
                case 0:
                    return Errors.ThrowNoProject();
                case 1:
                    return isProjectDeferredClose(this.containingProjects[0]) || isBackgroundProject(this.containingProjects[0]) ? Errors.ThrowNoProject() : this.containingProjects[0];
                default:
                    let firstConfiguredProject;
                    let firstInferredProject;
                    let firstNonSourceOfProjectReferenceRedirect;
                    let defaultConfiguredProject;
                    for(let index = 0; index < this.containingProjects.length; index++){
                        const project = this.containingProjects[index];
                        if (isConfiguredProject(project)) {
                            if (project.deferredClose) continue;
                            if (!project.isSourceOfProjectReferenceRedirect(this.fileName)) {
                                if (defaultConfiguredProject === void 0 && index !== this.containingProjects.length - 1) defaultConfiguredProject = project.projectService.findDefaultConfiguredProject(this) || false;
                                if (defaultConfiguredProject === project) return project;
                                if (!firstNonSourceOfProjectReferenceRedirect) firstNonSourceOfProjectReferenceRedirect = project;
                            }
                            if (!firstConfiguredProject) firstConfiguredProject = project;
                        } else if (isExternalProject(project)) return project;
                        else if (!firstInferredProject && isInferredProject(project)) firstInferredProject = project;
                    }
                    var _ref;
                    return (_ref = defaultConfiguredProject || firstNonSourceOfProjectReferenceRedirect || firstConfiguredProject || firstInferredProject) !== null && _ref !== void 0 ? _ref : Errors.ThrowNoProject();
            }
        }
        registerFileUpdate() {
            for (const p of this.containingProjects)p.registerFileUpdate(this.path);
        }
        setOptions(formatSettings, preferences) {
            if (formatSettings) {
                if (!this.formatSettings) {
                    this.formatSettings = getDefaultFormatCodeSettings(this.host.newLine);
                    assign(this.formatSettings, formatSettings);
                } else this.formatSettings = (0, _objectSpread._)({}, this.formatSettings, formatSettings);
            }
            if (preferences) {
                if (!this.preferences) this.preferences = emptyOptions;
                this.preferences = (0, _objectSpread._)({}, this.preferences, preferences);
            }
        }
        getLatestVersion() {
            this.textStorage.getSnapshot();
            return this.textStorage.getVersion();
        }
        saveTo(fileName) {
            this.host.writeFile(fileName, getSnapshotText(this.textStorage.getSnapshot()));
        }
        /** @internal */ delayReloadNonMixedContentFile() {
            Debug.assert(!this.isDynamicOrHasMixedContent());
            this.textStorage.delayReloadFromFileIntoText();
            this.markContainingProjectsAsDirty();
        }
        reloadFromFile(tempFileName) {
            if (this.textStorage.reloadWithFileText(tempFileName)) {
                this.markContainingProjectsAsDirty();
                return true;
            }
            return false;
        }
        editContent(start, end, newText) {
            this.textStorage.edit(start, end, newText);
            this.markContainingProjectsAsDirty();
        }
        markContainingProjectsAsDirty() {
            for (const p of this.containingProjects)p.markFileAsDirty(this.path);
        }
        isOrphan() {
            return this.deferredDelete || !forEach(this.containingProjects, (p)=>!p.isOrphan());
        }
        /**
   *  @param line 1 based index
   */ lineToTextSpan(line) {
            return this.textStorage.lineToTextSpan(line);
        }
        // eslint-disable-line @typescript-eslint/unified-signatures
        lineOffsetToPosition(line, offset, allowEdits) {
            return this.textStorage.lineOffsetToPosition(line, offset, allowEdits);
        }
        positionToLineOffset(position) {
            failIfInvalidPosition(position);
            const location = this.textStorage.positionToLineOffset(position);
            failIfInvalidLocation(location);
            return location;
        }
        isJavaScript() {
            return this.scriptKind === 1 /* JS */  || this.scriptKind === 2 /* JSX */ ;
        }
        /** @internal */ closeSourceMapFileWatcher() {
            if (this.sourceMapFilePath && !isString(this.sourceMapFilePath)) {
                closeFileWatcherOf(this.sourceMapFilePath);
                this.sourceMapFilePath = void 0;
            }
        }
        constructor(host, fileName, scriptKind, hasMixedContent, path, initialVersion){
            this.host = host;
            this.fileName = fileName;
            this.scriptKind = scriptKind;
            this.hasMixedContent = hasMixedContent;
            this.path = path;
            /**
     * All projects that include this file
     */ this.containingProjects = [];
            this.isDynamic = isDynamicFileName(fileName);
            this.textStorage = new TextStorage(host, this, initialVersion);
            if (hasMixedContent || this.isDynamic) this.realpath = this.path;
            this.scriptKind = scriptKind ? scriptKind : getScriptKindFromFileName(fileName);
        }
    };
    function failIfInvalidPosition(position) {
        Debug.assert(typeof position === "number", `Expected position ${position} to be a number.`);
        Debug.assert(position >= 0, `Expected position to be non-negative.`);
    }
    function failIfInvalidLocation(location) {
        Debug.assert(typeof location.line === "number", `Expected line ${location.line} to be a number.`);
        Debug.assert(typeof location.offset === "number", `Expected offset ${location.offset} to be a number.`);
        Debug.assert(location.line > 0, `Expected line to be non-${location.line === 0 ? "zero" : "negative"}`);
        Debug.assert(location.offset > 0, `Expected offset to be non-${location.offset === 0 ? "zero" : "negative"}`);
    }
    function scriptInfoIsContainedByBackgroundProject(info) {
        return some(info.containingProjects, isBackgroundProject);
    }
    function scriptInfoIsContainedByDeferredClosedProject(info) {
        return some(info.containingProjects, isProjectDeferredClose);
    }
    // src/server/project.ts
    var ProjectKind = /* @__PURE__ */ ((ProjectKind2)=>{
        ProjectKind2[ProjectKind2["Inferred"] = 0] = "Inferred";
        ProjectKind2[ProjectKind2["Configured"] = 1] = "Configured";
        ProjectKind2[ProjectKind2["External"] = 2] = "External";
        ProjectKind2[ProjectKind2["AutoImportProvider"] = 3] = "AutoImportProvider";
        ProjectKind2[ProjectKind2["Auxiliary"] = 4] = "Auxiliary";
        return ProjectKind2;
    })(ProjectKind || {});
    function countEachFileTypes(infos, includeSizes = false) {
        const result = {
            js: 0,
            jsSize: 0,
            jsx: 0,
            jsxSize: 0,
            ts: 0,
            tsSize: 0,
            tsx: 0,
            tsxSize: 0,
            dts: 0,
            dtsSize: 0,
            deferred: 0,
            deferredSize: 0
        };
        for (const info of infos){
            const fileSize = includeSizes ? info.textStorage.getTelemetryFileSize() : 0;
            switch(info.scriptKind){
                case 1 /* JS */ :
                    result.js += 1;
                    result.jsSize += fileSize;
                    break;
                case 2 /* JSX */ :
                    result.jsx += 1;
                    result.jsxSize += fileSize;
                    break;
                case 3 /* TS */ :
                    if (isDeclarationFileName(info.fileName)) {
                        result.dts += 1;
                        result.dtsSize += fileSize;
                    } else {
                        result.ts += 1;
                        result.tsSize += fileSize;
                    }
                    break;
                case 4 /* TSX */ :
                    result.tsx += 1;
                    result.tsxSize += fileSize;
                    break;
                case 7 /* Deferred */ :
                    result.deferred += 1;
                    result.deferredSize += fileSize;
                    break;
            }
        }
        return result;
    }
    function hasOneOrMoreJsAndNoTsFiles(project) {
        const counts2 = countEachFileTypes(project.getScriptInfos());
        return counts2.js > 0 && counts2.ts === 0 && counts2.tsx === 0;
    }
    function allRootFilesAreJsOrDts(project) {
        const counts2 = countEachFileTypes(project.getRootScriptInfos());
        return counts2.ts === 0 && counts2.tsx === 0;
    }
    function allFilesAreJsOrDts(project) {
        const counts2 = countEachFileTypes(project.getScriptInfos());
        return counts2.ts === 0 && counts2.tsx === 0;
    }
    function hasNoTypeScriptSource(fileNames) {
        return !fileNames.some((fileName)=>fileExtensionIs(fileName, ".ts" /* Ts */ ) && !isDeclarationFileName(fileName) || fileExtensionIs(fileName, ".tsx" /* Tsx */ ));
    }
    function isGeneratedFileWatcher(watch) {
        return watch.generatedFilePath !== void 0;
    }
    function setIsEqualTo(arr1, arr2) {
        if (arr1 === arr2) return true;
        if ((arr1 || emptyArray2).length === 0 && (arr2 || emptyArray2).length === 0) return true;
        const set = /* @__PURE__ */ new Map();
        let unique = 0;
        for (const v1 of arr1)if (set.get(v1) !== true) {
            set.set(v1, true);
            unique++;
        }
        for (const v1 of arr2){
            const isSet = set.get(v1);
            if (isSet === void 0) return false;
            if (isSet === true) {
                set.set(v1, false);
                unique--;
            }
        }
        return unique === 0;
    }
    function typeAcquisitionChanged(opt1, opt2) {
        return opt1.enable !== opt2.enable || !setIsEqualTo(opt1.include, opt2.include) || !setIsEqualTo(opt1.exclude, opt2.exclude);
    }
    function compilerOptionsChanged(opt1, opt2) {
        return getAllowJSCompilerOption(opt1) !== getAllowJSCompilerOption(opt2);
    }
    function unresolvedImportsChanged(imports1, imports2) {
        if (imports1 === imports2) return false;
        return !arrayIsEqualTo(imports1, imports2);
    }
    var Project2 = class _Project {
        /** @internal */ getRedirectFromSourceFile(_fileName) {
            return void 0;
        }
        isNonTsProject() {
            updateProjectIfDirty(this);
            return allFilesAreJsOrDts(this);
        }
        isJsOnlyProject() {
            updateProjectIfDirty(this);
            return hasOneOrMoreJsAndNoTsFiles(this);
        }
        static resolveModule(moduleName, initialDir, host, log) {
            return _Project.importServicePluginSync({
                name: moduleName
            }, [
                initialDir
            ], host, log).resolvedModule;
        }
        /** @internal */ static importServicePluginSync(pluginConfigEntry, searchPaths, host, log) {
            Debug.assertIsDefined(host.require);
            let errorLogs;
            let resolvedModule;
            for (const initialDir of searchPaths){
                const resolvedPath = normalizeSlashes(host.resolvePath(combinePaths(initialDir, "node_modules")));
                log(`Loading ${pluginConfigEntry.name} from ${initialDir} (resolved to ${resolvedPath})`);
                const result = host.require(resolvedPath, pluginConfigEntry.name);
                if (!result.error) {
                    resolvedModule = result.module;
                    break;
                }
                const err = result.error.stack || result.error.message || JSON.stringify(result.error);
                (errorLogs !== null && errorLogs !== void 0 ? errorLogs : errorLogs = []).push(`Failed to load module '${pluginConfigEntry.name}' from ${resolvedPath}: ${err}`);
            }
            return {
                pluginConfigEntry,
                resolvedModule,
                errorLogs
            };
        }
        /** @internal */ static async importServicePluginAsync(pluginConfigEntry, searchPaths, host, log) {
            Debug.assertIsDefined(host.importPlugin);
            let errorLogs;
            let resolvedModule;
            for (const initialDir of searchPaths){
                const resolvedPath = combinePaths(initialDir, "node_modules");
                log(`Dynamically importing ${pluginConfigEntry.name} from ${initialDir} (resolved to ${resolvedPath})`);
                let result;
                try {
                    result = await host.importPlugin(resolvedPath, pluginConfigEntry.name);
                } catch (e) {
                    result = {
                        module: void 0,
                        error: e
                    };
                }
                if (!result.error) {
                    resolvedModule = result.module;
                    break;
                }
                const err = result.error.stack || result.error.message || JSON.stringify(result.error);
                (errorLogs !== null && errorLogs !== void 0 ? errorLogs : errorLogs = []).push(`Failed to dynamically import module '${pluginConfigEntry.name}' from ${resolvedPath}: ${err}`);
            }
            return {
                pluginConfigEntry,
                resolvedModule,
                errorLogs
            };
        }
        isKnownTypesPackageName(name) {
            return this.projectService.typingsInstaller.isKnownTypesPackageName(name);
        }
        installPackage(options) {
            return this.projectService.typingsInstaller.installPackage((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                projectName: this.projectName,
                projectRootPath: this.toPath(this.currentDirectory)
            }));
        }
        /** @internal */ getGlobalTypingsCacheLocation() {
            return this.getTypeAcquisition().enable ? this.projectService.typingsInstaller.globalTypingsCacheLocation : void 0;
        }
        /** @internal */ getSymlinkCache() {
            if (!this.symlinks) this.symlinks = createSymlinkCache(this.getCurrentDirectory(), this.getCanonicalFileName);
            if (this.program && !this.symlinks.hasProcessedResolutions()) this.symlinks.setSymlinksFromResolutions(this.program.forEachResolvedModule, this.program.forEachResolvedTypeReferenceDirective, this.program.getAutomaticTypeDirectiveResolutions());
            return this.symlinks;
        }
        // Method of LanguageServiceHost
        getCompilationSettings() {
            return this.compilerOptions;
        }
        // Method to support public API
        getCompilerOptions() {
            return this.getCompilationSettings();
        }
        getNewLine() {
            return this.projectService.host.newLine;
        }
        getProjectVersion() {
            return this.projectStateVersion.toString();
        }
        getProjectReferences() {
            return void 0;
        }
        getScriptFileNames() {
            if (!this.rootFilesMap.size) return emptyArray;
            let result;
            this.rootFilesMap.forEach((value1)=>{
                if (this.languageServiceEnabled || value1.info && value1.info.isScriptOpen()) (result || (result = [])).push(value1.fileName);
            });
            return addRange(result, this.typingFiles) || emptyArray;
        }
        getOrCreateScriptInfoAndAttachToProject(fileName) {
            const scriptInfo = this.projectService.getOrCreateScriptInfoNotOpenedByClient(fileName, this.currentDirectory, this.directoryStructureHost, /*deferredDeleteOk*/ false);
            if (scriptInfo) {
                const existingValue = this.rootFilesMap.get(scriptInfo.path);
                if (existingValue && existingValue.info !== scriptInfo) existingValue.info = scriptInfo;
                scriptInfo.attachToProject(this);
            }
            return scriptInfo;
        }
        getScriptKind(fileName) {
            const info = this.projectService.getScriptInfoForPath(this.toPath(fileName));
            return info && info.scriptKind;
        }
        getScriptVersion(filename) {
            const info = this.projectService.getOrCreateScriptInfoNotOpenedByClient(filename, this.currentDirectory, this.directoryStructureHost, /*deferredDeleteOk*/ false);
            return info && info.getLatestVersion();
        }
        getScriptSnapshot(filename) {
            const scriptInfo = this.getOrCreateScriptInfoAndAttachToProject(filename);
            if (scriptInfo) return scriptInfo.getSnapshot();
        }
        getCancellationToken() {
            return this.cancellationToken;
        }
        getCurrentDirectory() {
            return this.currentDirectory;
        }
        getDefaultLibFileName() {
            const nodeModuleBinDir = getDirectoryPath(normalizePath(this.projectService.getExecutingFilePath()));
            return combinePaths(nodeModuleBinDir, getDefaultLibFileName(this.compilerOptions));
        }
        useCaseSensitiveFileNames() {
            return this.projectService.host.useCaseSensitiveFileNames;
        }
        readDirectory(path, extensions, exclude, include, depth) {
            return this.directoryStructureHost.readDirectory(path, extensions, exclude, include, depth);
        }
        readFile(fileName) {
            return this.projectService.host.readFile(fileName);
        }
        writeFile(fileName, content) {
            return this.projectService.host.writeFile(fileName, content);
        }
        fileExists(file) {
            const path = this.toPath(file);
            return !!this.projectService.getScriptInfoForPath(path) || !this.isWatchedMissingFile(path) && this.directoryStructureHost.fileExists(file);
        }
        /** @internal */ resolveModuleNameLiterals(moduleLiterals, containingFile, redirectedReference, options, containingSourceFile, reusedNames) {
            return this.resolutionCache.resolveModuleNameLiterals(moduleLiterals, containingFile, redirectedReference, options, containingSourceFile, reusedNames);
        }
        /** @internal */ getModuleResolutionCache() {
            return this.resolutionCache.getModuleResolutionCache();
        }
        /** @internal */ resolveTypeReferenceDirectiveReferences(typeDirectiveReferences, containingFile, redirectedReference, options, containingSourceFile, reusedNames) {
            return this.resolutionCache.resolveTypeReferenceDirectiveReferences(typeDirectiveReferences, containingFile, redirectedReference, options, containingSourceFile, reusedNames);
        }
        /** @internal */ resolveLibrary(libraryName, resolveFrom, options, libFileName) {
            return this.resolutionCache.resolveLibrary(libraryName, resolveFrom, options, libFileName);
        }
        directoryExists(path) {
            return this.directoryStructureHost.directoryExists(path);
        }
        getDirectories(path) {
            return this.directoryStructureHost.getDirectories(path);
        }
        /** @internal */ getCachedDirectoryStructureHost() {
            return void 0;
        }
        /** @internal */ toPath(fileName) {
            return toPath(fileName, this.currentDirectory, this.projectService.toCanonicalFileName);
        }
        /** @internal */ watchDirectoryOfFailedLookupLocation(directory, cb, flags) {
            return this.projectService.watchFactory.watchDirectory(directory, cb, flags, this.projectService.getWatchOptions(this), WatchType.FailedLookupLocations, this);
        }
        /** @internal */ watchAffectingFileLocation(file, cb) {
            return this.projectService.watchFactory.watchFile(file, cb, 2e3 /* High */ , this.projectService.getWatchOptions(this), WatchType.AffectingFileLocation, this);
        }
        /** @internal */ clearInvalidateResolutionOfFailedLookupTimer() {
            return this.projectService.throttledOperations.cancel(`${this.getProjectName()}FailedLookupInvalidation`);
        }
        /** @internal */ scheduleInvalidateResolutionsOfFailedLookupLocations() {
            this.projectService.throttledOperations.schedule(`${this.getProjectName()}FailedLookupInvalidation`, /*delay*/ 1e3, ()=>{
                if (this.resolutionCache.invalidateResolutionsOfFailedLookupLocations()) this.projectService.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(this);
            });
        }
        /** @internal */ invalidateResolutionsOfFailedLookupLocations() {
            if (this.clearInvalidateResolutionOfFailedLookupTimer() && this.resolutionCache.invalidateResolutionsOfFailedLookupLocations()) {
                this.markAsDirty();
                this.projectService.delayEnsureProjectForOpenFiles();
            }
        }
        /** @internal */ onInvalidatedResolution() {
            this.projectService.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(this);
        }
        /** @internal */ watchTypeRootsDirectory(directory, cb, flags) {
            return this.projectService.watchFactory.watchDirectory(directory, cb, flags, this.projectService.getWatchOptions(this), WatchType.TypeRoots, this);
        }
        /** @internal */ hasChangedAutomaticTypeDirectiveNames() {
            return this.resolutionCache.hasChangedAutomaticTypeDirectiveNames();
        }
        /** @internal */ onChangedAutomaticTypeDirectiveNames() {
            this.projectService.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(this);
        }
        /** @internal */ fileIsOpen(filePath) {
            return this.projectService.openFiles.has(filePath);
        }
        /** @internal */ writeLog(s) {
            this.projectService.logger.info(s);
        }
        log(s) {
            this.writeLog(s);
        }
        error(s) {
            this.projectService.logger.msg(s, "Err" /* Err */ );
        }
        setInternalCompilerOptionsForEmittingJsFiles() {
            if (this.projectKind === 0 /* Inferred */  || this.projectKind === 2 /* External */ ) this.compilerOptions.noEmitForJsFiles = true;
        }
        /**
   * Get the errors that dont have any file name associated
   */ getGlobalProjectErrors() {
            return filter(this.projectErrors, (diagnostic)=>!diagnostic.file) || emptyArray2;
        }
        /**
   * Get all the project errors
   */ getAllProjectErrors() {
            return this.projectErrors || emptyArray2;
        }
        setProjectErrors(projectErrors) {
            this.projectErrors = projectErrors;
        }
        getLanguageService(ensureSynchronized = true) {
            if (ensureSynchronized) updateProjectIfDirty(this);
            return this.languageService;
        }
        /** @internal */ getSourceMapper() {
            return this.getLanguageService().getSourceMapper();
        }
        /** @internal */ clearSourceMapperCache() {
            this.languageService.clearSourceMapperCache();
        }
        /** @internal */ getDocumentPositionMapper(generatedFileName, sourceFileName) {
            return this.projectService.getDocumentPositionMapper(this, generatedFileName, sourceFileName);
        }
        /** @internal */ getSourceFileLike(fileName) {
            return this.projectService.getSourceFileLike(fileName, this);
        }
        /** @internal */ shouldEmitFile(scriptInfo) {
            return scriptInfo && !scriptInfo.isDynamicOrHasMixedContent() && !this.program.isSourceOfProjectReferenceRedirect(scriptInfo.path);
        }
        getCompileOnSaveAffectedFileList(scriptInfo) {
            if (!this.languageServiceEnabled) return [];
            updateProjectIfDirty(this);
            this.builderState = BuilderState.create(this.program, this.builderState, /*disableUseFileVersionAsSignature*/ true);
            return mapDefined(BuilderState.getFilesAffectedBy(this.builderState, this.program, scriptInfo.path, this.cancellationToken, this.projectService.host), (sourceFile)=>this.shouldEmitFile(this.projectService.getScriptInfoForPath(sourceFile.path)) ? sourceFile.fileName : void 0);
        }
        /**
   * Returns true if emit was conducted
   */ emitFile(scriptInfo, writeFile2) {
            if (!this.languageServiceEnabled || !this.shouldEmitFile(scriptInfo)) return {
                emitSkipped: true,
                diagnostics: emptyArray2
            };
            const { emitSkipped, diagnostics, outputFiles } = this.getLanguageService().getEmitOutput(scriptInfo.fileName);
            if (!emitSkipped) {
                for (const outputFile of outputFiles){
                    const outputFileAbsoluteFileName = getNormalizedAbsolutePath(outputFile.name, this.currentDirectory);
                    writeFile2(outputFileAbsoluteFileName, outputFile.text, outputFile.writeByteOrderMark);
                }
                if (this.builderState && getEmitDeclarations(this.compilerOptions)) {
                    const dtsFiles = outputFiles.filter((f)=>isDeclarationFileName(f.name));
                    if (dtsFiles.length === 1) {
                        const sourceFile = this.program.getSourceFile(scriptInfo.fileName);
                        const signature = this.projectService.host.createHash ? this.projectService.host.createHash(dtsFiles[0].text) : generateDjb2Hash(dtsFiles[0].text);
                        BuilderState.updateSignatureOfFile(this.builderState, signature, sourceFile.resolvedPath);
                    }
                }
            }
            return {
                emitSkipped,
                diagnostics
            };
        }
        enableLanguageService() {
            if (this.languageServiceEnabled || this.projectService.serverMode === 2 /* Syntactic */ ) return;
            this.languageServiceEnabled = true;
            this.lastFileExceededProgramSize = void 0;
            this.projectService.onUpdateLanguageServiceStateForProject(this, /*languageServiceEnabled*/ true);
        }
        /** @internal */ cleanupProgram() {
            if (this.program) {
                for (const f of this.program.getSourceFiles())this.detachScriptInfoIfNotRoot(f.fileName);
                this.program.forEachResolvedProjectReference((ref)=>this.detachScriptInfoFromProject(ref.sourceFile.fileName));
                this.program = void 0;
            }
        }
        disableLanguageService(lastFileExceededProgramSize) {
            if (!this.languageServiceEnabled) return;
            Debug.assert(this.projectService.serverMode !== 2 /* Syntactic */ );
            this.languageService.cleanupSemanticCache();
            this.languageServiceEnabled = false;
            this.cleanupProgram();
            this.lastFileExceededProgramSize = lastFileExceededProgramSize;
            this.builderState = void 0;
            if (this.autoImportProviderHost) this.autoImportProviderHost.close();
            this.autoImportProviderHost = void 0;
            this.resolutionCache.closeTypeRootsWatch();
            this.clearGeneratedFileWatch();
            this.projectService.verifyDocumentRegistry();
            this.projectService.onUpdateLanguageServiceStateForProject(this, /*languageServiceEnabled*/ false);
        }
        getProjectName() {
            return this.projectName;
        }
        removeLocalTypingsFromTypeAcquisition(newTypeAcquisition) {
            if (!newTypeAcquisition.enable || !newTypeAcquisition.include) return newTypeAcquisition;
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, newTypeAcquisition), {
                include: this.removeExistingTypings(newTypeAcquisition.include)
            });
        }
        getExternalFiles(updateLevel) {
            return toSorted(flatMap(this.plugins, (plugin)=>{
                if (typeof plugin.module.getExternalFiles !== "function") return;
                try {
                    return plugin.module.getExternalFiles(this, updateLevel || 0 /* Update */ );
                } catch (e) {
                    this.projectService.logger.info(`A plugin threw an exception in getExternalFiles: ${e}`);
                    if (e.stack) this.projectService.logger.info(e.stack);
                }
            }));
        }
        getSourceFile(path) {
            if (!this.program) return void 0;
            return this.program.getSourceFileByPath(path);
        }
        /** @internal */ getSourceFileOrConfigFile(path) {
            const options = this.program.getCompilerOptions();
            return path === options.configFilePath ? options.configFile : this.getSourceFile(path);
        }
        close() {
            var _a;
            if (this.typingsCache) this.projectService.typingsInstaller.onProjectClosed(this);
            this.typingsCache = void 0;
            this.closeWatchingTypingLocations();
            this.cleanupProgram();
            forEach(this.externalFiles, (externalFile)=>this.detachScriptInfoIfNotRoot(externalFile));
            this.rootFilesMap.forEach((root)=>{
                var _a2;
                return (_a2 = root.info) == null ? void 0 : _a2.detachFromProject(this);
            });
            this.projectService.pendingEnsureProjectForOpenFiles = true;
            this.rootFilesMap = void 0;
            this.externalFiles = void 0;
            this.program = void 0;
            this.builderState = void 0;
            this.resolutionCache.clear();
            this.resolutionCache = void 0;
            this.cachedUnresolvedImportsPerFile = void 0;
            (_a = this.packageJsonWatches) == null || _a.forEach((watcher)=>{
                watcher.projects.delete(this);
                watcher.close();
            });
            this.packageJsonWatches = void 0;
            this.moduleSpecifierCache.clear();
            this.moduleSpecifierCache = void 0;
            this.directoryStructureHost = void 0;
            this.exportMapCache = void 0;
            this.projectErrors = void 0;
            this.plugins.length = 0;
            if (this.missingFilesMap) {
                clearMap(this.missingFilesMap, closeFileWatcher);
                this.missingFilesMap = void 0;
            }
            this.clearGeneratedFileWatch();
            this.clearInvalidateResolutionOfFailedLookupTimer();
            if (this.autoImportProviderHost) this.autoImportProviderHost.close();
            this.autoImportProviderHost = void 0;
            if (this.noDtsResolutionProject) this.noDtsResolutionProject.close();
            this.noDtsResolutionProject = void 0;
            this.languageService.dispose();
            this.languageService = void 0;
        }
        detachScriptInfoIfNotRoot(uncheckedFilename) {
            const info = this.projectService.getScriptInfo(uncheckedFilename);
            if (info && !this.isRoot(info)) info.detachFromProject(this);
        }
        isClosed() {
            return this.rootFilesMap === void 0;
        }
        hasRoots() {
            var _a;
            return !!((_a = this.rootFilesMap) == null ? void 0 : _a.size);
        }
        /** @internal */ isOrphan() {
            return false;
        }
        getRootFiles() {
            return this.rootFilesMap && arrayFrom(mapDefinedIterator(this.rootFilesMap.values(), (value1)=>{
                var _a;
                return (_a = value1.info) == null ? void 0 : _a.fileName;
            }));
        }
        /** @internal */ getRootFilesMap() {
            return this.rootFilesMap;
        }
        getRootScriptInfos() {
            return arrayFrom(mapDefinedIterator(this.rootFilesMap.values(), (value1)=>value1.info));
        }
        getScriptInfos() {
            if (!this.languageServiceEnabled) return this.getRootScriptInfos();
            return map(this.program.getSourceFiles(), (sourceFile)=>{
                const scriptInfo = this.projectService.getScriptInfoForPath(sourceFile.resolvedPath);
                Debug.assert(!!scriptInfo, "getScriptInfo", ()=>`scriptInfo for a file '${sourceFile.fileName}' Path: '${sourceFile.path}' / '${sourceFile.resolvedPath}' is missing.`);
                return scriptInfo;
            });
        }
        getExcludedFiles() {
            return emptyArray2;
        }
        getFileNames(excludeFilesFromExternalLibraries, excludeConfigFiles) {
            if (!this.program) return [];
            if (!this.languageServiceEnabled) {
                let rootFiles = this.getRootFiles();
                if (this.compilerOptions) {
                    const defaultLibrary = getDefaultLibFilePath(this.compilerOptions);
                    if (defaultLibrary) (rootFiles || (rootFiles = [])).push(asNormalizedPath(defaultLibrary));
                }
                return rootFiles;
            }
            const result = [];
            for (const f of this.program.getSourceFiles()){
                if (excludeFilesFromExternalLibraries && this.program.isSourceFileFromExternalLibrary(f)) continue;
                result.push(asNormalizedPath(f.fileName));
            }
            if (!excludeConfigFiles) {
                const configFile = this.program.getCompilerOptions().configFile;
                if (configFile) {
                    result.push(asNormalizedPath(configFile.fileName));
                    if (configFile.extendedSourceFiles) for (const f of configFile.extendedSourceFiles)result.push(asNormalizedPath(f));
                }
            }
            return result;
        }
        /** @internal */ getFileNamesWithRedirectInfo(includeProjectReferenceRedirectInfo) {
            return this.getFileNames().map((fileName)=>({
                    fileName,
                    isSourceOfProjectReferenceRedirect: includeProjectReferenceRedirectInfo && this.isSourceOfProjectReferenceRedirect(fileName)
                }));
        }
        hasConfigFile(configFilePath) {
            if (this.program && this.languageServiceEnabled) {
                const configFile = this.program.getCompilerOptions().configFile;
                if (configFile) {
                    if (configFilePath === asNormalizedPath(configFile.fileName)) return true;
                    if (configFile.extendedSourceFiles) for (const f of configFile.extendedSourceFiles){
                        if (configFilePath === asNormalizedPath(f)) return true;
                    }
                }
            }
            return false;
        }
        containsScriptInfo(info) {
            if (this.isRoot(info)) return true;
            if (!this.program) return false;
            const file = this.program.getSourceFileByPath(info.path);
            return !!file && file.resolvedPath === info.path;
        }
        containsFile(filename, requireOpen) {
            const info = this.projectService.getScriptInfoForNormalizedPath(filename);
            if (info && (info.isScriptOpen() || !requireOpen)) return this.containsScriptInfo(info);
            return false;
        }
        isRoot(info) {
            var _a, _b;
            return ((_b = (_a = this.rootFilesMap) == null ? void 0 : _a.get(info.path)) == null ? void 0 : _b.info) === info;
        }
        // add a root file to project
        addRoot(info, fileName) {
            Debug.assert(!this.isRoot(info));
            this.rootFilesMap.set(info.path, {
                fileName: fileName || info.fileName,
                info
            });
            info.attachToProject(this);
            this.markAsDirty();
        }
        // add a root file that doesnt exist on host
        addMissingFileRoot(fileName) {
            const path = this.projectService.toPath(fileName);
            this.rootFilesMap.set(path, {
                fileName
            });
            this.markAsDirty();
        }
        removeFile(info, fileExists, detachFromProject) {
            if (this.isRoot(info)) this.removeRoot(info);
            if (fileExists) this.resolutionCache.removeResolutionsOfFile(info.path);
            else this.resolutionCache.invalidateResolutionOfFile(info.path);
            this.cachedUnresolvedImportsPerFile.delete(info.path);
            if (detachFromProject) info.detachFromProject(this);
            this.markAsDirty();
        }
        registerFileUpdate(fileName) {
            (this.updatedFileNames || (this.updatedFileNames = /* @__PURE__ */ new Set())).add(fileName);
        }
        /** @internal */ markFileAsDirty(changedFile) {
            this.markAsDirty();
            if (this.exportMapCache && !this.exportMapCache.isEmpty()) (this.changedFilesForExportMapCache || (this.changedFilesForExportMapCache = /* @__PURE__ */ new Set())).add(changedFile);
        }
        /** @internal */ markAsDirty() {
            if (!this.dirty) {
                this.projectStateVersion++;
                this.dirty = true;
            }
        }
        /** @internal */ markAutoImportProviderAsDirty() {
            var _a;
            if (!this.autoImportProviderHost) this.autoImportProviderHost = void 0;
            (_a = this.autoImportProviderHost) == null || _a.markAsDirty();
        }
        /** @internal */ onAutoImportProviderSettingsChanged() {
            this.markAutoImportProviderAsDirty();
        }
        /** @internal */ onPackageJsonChange() {
            this.moduleSpecifierCache.clear();
            this.markAutoImportProviderAsDirty();
        }
        /** @internal */ onFileAddedOrRemoved(isSymlink) {
            this.hasAddedorRemovedFiles = true;
            if (isSymlink) this.hasAddedOrRemovedSymlinks = true;
        }
        /** @internal */ onDiscoveredSymlink() {
            this.hasAddedOrRemovedSymlinks = true;
        }
        /** @internal */ onReleaseOldSourceFile(oldSourceFile, _oldOptions, hasSourceFileByPath, newSourceFileByResolvedPath) {
            if (!newSourceFileByResolvedPath || oldSourceFile.resolvedPath === oldSourceFile.path && newSourceFileByResolvedPath.resolvedPath !== oldSourceFile.path) this.detachScriptInfoFromProject(oldSourceFile.fileName, hasSourceFileByPath);
        }
        /** @internal */ updateFromProject() {
            updateProjectIfDirty(this);
        }
        /**
   * Updates set of files that contribute to this project
   * @returns: true if set of files in the project stays the same and false - otherwise.
   */ updateGraph() {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "updateGraph", {
                name: this.projectName,
                kind: ProjectKind[this.projectKind]
            });
            this.resolutionCache.startRecordingFilesWithChangedResolutions();
            const hasNewProgram = this.updateGraphWorker();
            const hasAddedorRemovedFiles = this.hasAddedorRemovedFiles;
            this.hasAddedorRemovedFiles = false;
            this.hasAddedOrRemovedSymlinks = false;
            const changedFiles = this.resolutionCache.finishRecordingFilesWithChangedResolutions() || emptyArray2;
            for (const file of changedFiles)this.cachedUnresolvedImportsPerFile.delete(file);
            if (this.languageServiceEnabled && this.projectService.serverMode === 0 /* Semantic */  && !this.isOrphan()) {
                if (hasNewProgram || changedFiles.length) this.lastCachedUnresolvedImportsList = getUnresolvedImports(this.program, this.cachedUnresolvedImportsPerFile);
                this.enqueueInstallTypingsForProject(hasAddedorRemovedFiles);
            } else this.lastCachedUnresolvedImportsList = void 0;
            const isFirstProgramLoad = this.projectProgramVersion === 0 && hasNewProgram;
            if (hasNewProgram) this.projectProgramVersion++;
            if (hasAddedorRemovedFiles) this.markAutoImportProviderAsDirty();
            if (isFirstProgramLoad) this.getPackageJsonAutoImportProvider();
            (_b = tracing) == null || _b.pop();
            return !hasNewProgram;
        }
        /** @internal */ enqueueInstallTypingsForProject(forceRefresh) {
            const typeAcquisition = this.getTypeAcquisition();
            if (!typeAcquisition || !typeAcquisition.enable || this.projectService.typingsInstaller === nullTypingsInstaller) return;
            const entry = this.typingsCache;
            if (forceRefresh || !entry || typeAcquisitionChanged(typeAcquisition, entry.typeAcquisition) || compilerOptionsChanged(this.getCompilationSettings(), entry.compilerOptions) || unresolvedImportsChanged(this.lastCachedUnresolvedImportsList, entry.unresolvedImports)) {
                this.typingsCache = {
                    compilerOptions: this.getCompilationSettings(),
                    typeAcquisition,
                    unresolvedImports: this.lastCachedUnresolvedImportsList
                };
                this.projectService.typingsInstaller.enqueueInstallTypingsRequest(this, typeAcquisition, this.lastCachedUnresolvedImportsList);
            }
        }
        /** @internal */ updateTypingFiles(compilerOptions, typeAcquisition, unresolvedImports, newTypings) {
            this.typingsCache = {
                compilerOptions,
                typeAcquisition,
                unresolvedImports
            };
            const typingFiles = !typeAcquisition || !typeAcquisition.enable ? emptyArray2 : toSorted(newTypings);
            if (enumerateInsertsAndDeletes(typingFiles, this.typingFiles, getStringComparer(!this.useCaseSensitiveFileNames()), /*inserted*/ noop, (removed)=>this.detachScriptInfoFromProject(removed))) {
                this.typingFiles = typingFiles;
                this.resolutionCache.setFilesWithInvalidatedNonRelativeUnresolvedImports(this.cachedUnresolvedImportsPerFile);
                this.projectService.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(this);
            }
        }
        closeWatchingTypingLocations() {
            if (this.typingWatchers) clearMap(this.typingWatchers, closeFileWatcher);
            this.typingWatchers = void 0;
        }
        onTypingInstallerWatchInvoke() {
            this.typingWatchers.isInvoked = true;
            this.projectService.updateTypingsForProject({
                projectName: this.getProjectName(),
                kind: ActionInvalidate
            });
        }
        /** @internal */ watchTypingLocations(files) {
            if (!files) {
                this.typingWatchers.isInvoked = false;
                return;
            }
            if (!files.length) {
                this.closeWatchingTypingLocations();
                return;
            }
            const toRemove = new Map(this.typingWatchers);
            if (!this.typingWatchers) this.typingWatchers = /* @__PURE__ */ new Map();
            this.typingWatchers.isInvoked = false;
            const createProjectWatcher = (path, typingsWatcherType)=>{
                const canonicalPath = this.toPath(path);
                toRemove.delete(canonicalPath);
                if (!this.typingWatchers.has(canonicalPath)) {
                    const watchType = typingsWatcherType === "FileWatcher" /* FileWatcher */  ? WatchType.TypingInstallerLocationFile : WatchType.TypingInstallerLocationDirectory;
                    this.typingWatchers.set(canonicalPath, canWatchDirectoryOrFilePath(canonicalPath) ? typingsWatcherType === "FileWatcher" /* FileWatcher */  ? this.projectService.watchFactory.watchFile(path, ()=>!this.typingWatchers.isInvoked ? this.onTypingInstallerWatchInvoke() : this.writeLog(`TypingWatchers already invoked`), 2e3 /* High */ , this.projectService.getWatchOptions(this), watchType, this) : this.projectService.watchFactory.watchDirectory(path, (f)=>{
                        if (this.typingWatchers.isInvoked) return this.writeLog(`TypingWatchers already invoked`);
                        if (!fileExtensionIs(f, ".json" /* Json */ )) return this.writeLog(`Ignoring files that are not *.json`);
                        if (comparePaths(f, combinePaths(this.projectService.typingsInstaller.globalTypingsCacheLocation, "package.json"), !this.useCaseSensitiveFileNames())) return this.writeLog(`Ignoring package.json change at global typings location`);
                        this.onTypingInstallerWatchInvoke();
                    }, 1 /* Recursive */ , this.projectService.getWatchOptions(this), watchType, this) : (this.writeLog(`Skipping watcher creation at ${path}:: ${getDetailWatchInfo(watchType, this)}`), noopFileWatcher));
                }
            };
            for (const file of files){
                const basename = getBaseFileName(file);
                if (basename === "package.json" || basename === "bower.json") {
                    createProjectWatcher(file, "FileWatcher" /* FileWatcher */ );
                    continue;
                }
                if (containsPath(this.currentDirectory, file, this.currentDirectory, !this.useCaseSensitiveFileNames())) {
                    const subDirectory = file.indexOf(directorySeparator, this.currentDirectory.length + 1);
                    if (subDirectory !== -1) createProjectWatcher(file.substr(0, subDirectory), "DirectoryWatcher" /* DirectoryWatcher */ );
                    else createProjectWatcher(file, "DirectoryWatcher" /* DirectoryWatcher */ );
                    continue;
                }
                if (containsPath(this.projectService.typingsInstaller.globalTypingsCacheLocation, file, this.currentDirectory, !this.useCaseSensitiveFileNames())) {
                    createProjectWatcher(this.projectService.typingsInstaller.globalTypingsCacheLocation, "DirectoryWatcher" /* DirectoryWatcher */ );
                    continue;
                }
                createProjectWatcher(file, "DirectoryWatcher" /* DirectoryWatcher */ );
            }
            toRemove.forEach((watch, path)=>{
                watch.close();
                this.typingWatchers.delete(path);
            });
        }
        /** @internal */ getCurrentProgram() {
            return this.program;
        }
        removeExistingTypings(include) {
            if (!include.length) return include;
            const existing = getAutomaticTypeDirectiveNames(this.getCompilerOptions(), this);
            return filter(include, (i)=>!existing.includes(i));
        }
        updateGraphWorker() {
            var _a, _b;
            const oldProgram = this.languageService.getCurrentProgram();
            Debug.assert(oldProgram === this.program);
            Debug.assert(!this.isClosed(), "Called update graph worker of closed project");
            this.writeLog(`Starting updateGraphWorker: Project: ${this.getProjectName()}`);
            const start = timestamp();
            const { hasInvalidatedResolutions, hasInvalidatedLibResolutions } = this.resolutionCache.createHasInvalidatedResolutions(returnFalse, returnFalse);
            this.hasInvalidatedResolutions = hasInvalidatedResolutions;
            this.hasInvalidatedLibResolutions = hasInvalidatedLibResolutions;
            this.resolutionCache.startCachingPerDirectoryResolution();
            this.dirty = false;
            this.updateFromProjectInProgress = true;
            this.program = this.languageService.getProgram();
            this.updateFromProjectInProgress = false;
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "finishCachingPerDirectoryResolution");
            this.resolutionCache.finishCachingPerDirectoryResolution(this.program, oldProgram);
            (_b = tracing) == null || _b.pop();
            Debug.assert(oldProgram === void 0 || this.program !== void 0);
            let hasNewProgram = false;
            if (this.program && (!oldProgram || this.program !== oldProgram && this.program.structureIsReused !== 2 /* Completely */ )) {
                hasNewProgram = true;
                this.rootFilesMap.forEach((value1, path)=>{
                    var _a2;
                    const file = this.program.getSourceFileByPath(path);
                    const info = value1.info;
                    if (!file || ((_a2 = value1.info) == null ? void 0 : _a2.path) === file.resolvedPath) return;
                    value1.info = this.projectService.getScriptInfo(file.fileName);
                    Debug.assert(value1.info.isAttached(this));
                    info == null || info.detachFromProject(this);
                });
                updateMissingFilePathsWatch(this.program, this.missingFilesMap || (this.missingFilesMap = /* @__PURE__ */ new Map()), // Watch the missing files
                (missingFilePath, missingFileName)=>this.addMissingFileWatcher(missingFilePath, missingFileName));
                if (this.generatedFilesMap) {
                    const outPath = this.compilerOptions.outFile;
                    if (isGeneratedFileWatcher(this.generatedFilesMap)) {
                        if (!outPath || !this.isValidGeneratedFileWatcher(removeFileExtension(outPath) + ".d.ts" /* Dts */ , this.generatedFilesMap)) this.clearGeneratedFileWatch();
                    } else if (outPath) this.clearGeneratedFileWatch();
                    else this.generatedFilesMap.forEach((watcher, source)=>{
                        const sourceFile = this.program.getSourceFileByPath(source);
                        if (!sourceFile || sourceFile.resolvedPath !== source || !this.isValidGeneratedFileWatcher(getDeclarationEmitOutputFilePathWorker(sourceFile.fileName, this.compilerOptions, this.program), watcher)) {
                            closeFileWatcherOf(watcher);
                            this.generatedFilesMap.delete(source);
                        }
                    });
                }
                if (this.languageServiceEnabled && this.projectService.serverMode === 0 /* Semantic */ ) this.resolutionCache.updateTypeRootsWatch();
            }
            this.projectService.verifyProgram(this);
            if (this.exportMapCache && !this.exportMapCache.isEmpty()) {
                this.exportMapCache.releaseSymbols();
                if (this.hasAddedorRemovedFiles || oldProgram && !this.program.structureIsReused) this.exportMapCache.clear();
                else if (this.changedFilesForExportMapCache && oldProgram && this.program) forEachKey(this.changedFilesForExportMapCache, (fileName)=>{
                    const oldSourceFile = oldProgram.getSourceFileByPath(fileName);
                    const sourceFile = this.program.getSourceFileByPath(fileName);
                    if (!oldSourceFile || !sourceFile) {
                        this.exportMapCache.clear();
                        return true;
                    }
                    return this.exportMapCache.onFileChanged(oldSourceFile, sourceFile, !!this.getTypeAcquisition().enable);
                });
            }
            if (this.changedFilesForExportMapCache) this.changedFilesForExportMapCache.clear();
            if (this.hasAddedOrRemovedSymlinks || this.program && !this.program.structureIsReused && this.getCompilerOptions().preserveSymlinks) {
                this.symlinks = void 0;
                this.moduleSpecifierCache.clear();
            }
            const oldExternalFiles = this.externalFiles || emptyArray2;
            this.externalFiles = this.getExternalFiles();
            enumerateInsertsAndDeletes(this.externalFiles, oldExternalFiles, getStringComparer(!this.useCaseSensitiveFileNames()), // Ensure a ScriptInfo is created for new external files. This is performed indirectly
            // by the host for files in the program when the program is retrieved above but
            // the program doesn't contain external files so this must be done explicitly.
            (inserted)=>{
                const scriptInfo = this.projectService.getOrCreateScriptInfoNotOpenedByClient(inserted, this.currentDirectory, this.directoryStructureHost, /*deferredDeleteOk*/ false);
                scriptInfo == null || scriptInfo.attachToProject(this);
            }, (removed)=>this.detachScriptInfoFromProject(removed));
            const elapsed = timestamp() - start;
            this.sendPerformanceEvent("UpdateGraph", elapsed);
            this.writeLog(`Finishing updateGraphWorker: Project: ${this.getProjectName()} projectStateVersion: ${this.projectStateVersion} projectProgramVersion: ${this.projectProgramVersion} structureChanged: ${hasNewProgram}${this.program ? ` structureIsReused:: ${StructureIsReused[this.program.structureIsReused]}` : ""} Elapsed: ${elapsed}ms`);
            if (this.projectService.logger.isTestLogger) {
                if (this.program !== oldProgram) this.print(/*writeProjectFileNames*/ true, this.hasAddedorRemovedFiles, /*writeFileVersionAndText*/ true);
                else this.writeLog(`Same program as before`);
            } else if (this.hasAddedorRemovedFiles) this.print(/*writeProjectFileNames*/ true, /*writeFileExplaination*/ true, /*writeFileVersionAndText*/ false);
            else if (this.program !== oldProgram) this.writeLog(`Different program with same set of files`);
            this.projectService.verifyDocumentRegistry();
            return hasNewProgram;
        }
        /** @internal */ sendPerformanceEvent(kind, durationMs) {
            this.projectService.sendPerformanceEvent(kind, durationMs);
        }
        detachScriptInfoFromProject(uncheckedFileName, noRemoveResolution) {
            const scriptInfoToDetach = this.projectService.getScriptInfo(uncheckedFileName);
            if (scriptInfoToDetach) {
                scriptInfoToDetach.detachFromProject(this);
                if (!noRemoveResolution) this.resolutionCache.removeResolutionsOfFile(scriptInfoToDetach.path);
            }
        }
        addMissingFileWatcher(missingFilePath, missingFileName) {
            var _a;
            if (isConfiguredProject(this)) {
                const configFileExistenceInfo = this.projectService.configFileExistenceInfoCache.get(missingFilePath);
                if ((_a = configFileExistenceInfo == null ? void 0 : configFileExistenceInfo.config) == null ? void 0 : _a.projects.has(this.canonicalConfigFilePath)) return noopFileWatcher;
            }
            const fileWatcher = this.projectService.watchFactory.watchFile(getNormalizedAbsolutePath(missingFileName, this.currentDirectory), (fileName, eventKind)=>{
                if (isConfiguredProject(this)) this.getCachedDirectoryStructureHost().addOrDeleteFile(fileName, missingFilePath, eventKind);
                if (eventKind === 0 /* Created */  && this.missingFilesMap.has(missingFilePath)) {
                    this.missingFilesMap.delete(missingFilePath);
                    fileWatcher.close();
                    this.projectService.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(this);
                }
            }, 500 /* Medium */ , this.projectService.getWatchOptions(this), WatchType.MissingFile, this);
            return fileWatcher;
        }
        isWatchedMissingFile(path) {
            return !!this.missingFilesMap && this.missingFilesMap.has(path);
        }
        /** @internal */ addGeneratedFileWatch(generatedFile, sourceFile) {
            if (this.compilerOptions.outFile) {
                if (!this.generatedFilesMap) this.generatedFilesMap = this.createGeneratedFileWatcher(generatedFile);
            } else {
                const path = this.toPath(sourceFile);
                if (this.generatedFilesMap) {
                    if (isGeneratedFileWatcher(this.generatedFilesMap)) {
                        Debug.fail(`${this.projectName} Expected to not have --out watcher for generated file with options: ${JSON.stringify(this.compilerOptions)}`);
                        return;
                    }
                    if (this.generatedFilesMap.has(path)) return;
                } else this.generatedFilesMap = /* @__PURE__ */ new Map();
                this.generatedFilesMap.set(path, this.createGeneratedFileWatcher(generatedFile));
            }
        }
        createGeneratedFileWatcher(generatedFile) {
            return {
                generatedFilePath: this.toPath(generatedFile),
                watcher: this.projectService.watchFactory.watchFile(generatedFile, ()=>{
                    this.clearSourceMapperCache();
                    this.projectService.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(this);
                }, 2e3 /* High */ , this.projectService.getWatchOptions(this), WatchType.MissingGeneratedFile, this)
            };
        }
        isValidGeneratedFileWatcher(generateFile, watcher) {
            return this.toPath(generateFile) === watcher.generatedFilePath;
        }
        clearGeneratedFileWatch() {
            if (this.generatedFilesMap) {
                if (isGeneratedFileWatcher(this.generatedFilesMap)) closeFileWatcherOf(this.generatedFilesMap);
                else clearMap(this.generatedFilesMap, closeFileWatcherOf);
                this.generatedFilesMap = void 0;
            }
        }
        getScriptInfoForNormalizedPath(fileName) {
            const scriptInfo = this.projectService.getScriptInfoForPath(this.toPath(fileName));
            if (scriptInfo && !scriptInfo.isAttached(this)) return Errors.ThrowProjectDoesNotContainDocument(fileName, this);
            return scriptInfo;
        }
        getScriptInfo(uncheckedFileName) {
            return this.projectService.getScriptInfo(uncheckedFileName);
        }
        filesToString(writeProjectFileNames) {
            return this.filesToStringWorker(writeProjectFileNames, /*writeFileExplaination*/ true, /*writeFileVersionAndText*/ false);
        }
        filesToStringWorker(writeProjectFileNames, writeFileExplaination, writeFileVersionAndText) {
            if (this.initialLoadPending) return "	Files (0) InitialLoadPending\n";
            if (!this.program) return "	Files (0) NoProgram\n";
            const sourceFiles = this.program.getSourceFiles();
            let strBuilder = `	Files (${sourceFiles.length})
`;
            if (writeProjectFileNames) {
                for (const file of sourceFiles)strBuilder += `	${file.fileName}${writeFileVersionAndText ? ` ${file.version} ${JSON.stringify(file.text)}` : ""}
`;
                if (writeFileExplaination) {
                    strBuilder += "\n\n";
                    explainFiles(this.program, (s)=>strBuilder += `	${s}
`);
                }
            }
            return strBuilder;
        }
        /** @internal */ print(writeProjectFileNames, writeFileExplaination, writeFileVersionAndText) {
            var _a;
            this.writeLog(`Project '${this.projectName}' (${ProjectKind[this.projectKind]})`);
            this.writeLog(this.filesToStringWorker(writeProjectFileNames && this.projectService.logger.hasLevel(3 /* verbose */ ), writeFileExplaination && this.projectService.logger.hasLevel(3 /* verbose */ ), writeFileVersionAndText && this.projectService.logger.hasLevel(3 /* verbose */ )));
            this.writeLog("-----------------------------------------------");
            if (this.autoImportProviderHost) this.autoImportProviderHost.print(/*writeProjectFileNames*/ false, /*writeFileExplaination*/ false, /*writeFileVersionAndText*/ false);
            (_a = this.noDtsResolutionProject) == null || _a.print(/*writeProjectFileNames*/ false, /*writeFileExplaination*/ false, /*writeFileVersionAndText*/ false);
        }
        setCompilerOptions(compilerOptions) {
            var _a;
            if (compilerOptions) {
                compilerOptions.allowNonTsExtensions = true;
                const oldOptions = this.compilerOptions;
                this.compilerOptions = compilerOptions;
                this.setInternalCompilerOptionsForEmittingJsFiles();
                (_a = this.noDtsResolutionProject) == null || _a.setCompilerOptions(this.getCompilerOptionsForNoDtsResolutionProject());
                if (changesAffectModuleResolution(oldOptions, compilerOptions)) {
                    this.cachedUnresolvedImportsPerFile.clear();
                    this.lastCachedUnresolvedImportsList = void 0;
                    this.resolutionCache.onChangesAffectModuleResolution();
                    this.moduleSpecifierCache.clear();
                }
                this.markAsDirty();
            }
        }
        /** @internal */ setWatchOptions(watchOptions) {
            this.watchOptions = watchOptions;
        }
        /** @internal */ getWatchOptions() {
            return this.watchOptions;
        }
        setTypeAcquisition(newTypeAcquisition) {
            if (newTypeAcquisition) this.typeAcquisition = this.removeLocalTypingsFromTypeAcquisition(newTypeAcquisition);
        }
        getTypeAcquisition() {
            return this.typeAcquisition || {};
        }
        /** @internal */ getChangesSinceVersion(lastKnownVersion, includeProjectReferenceRedirectInfo) {
            var _a, _b;
            const includeProjectReferenceRedirectInfoIfRequested = includeProjectReferenceRedirectInfo ? (files)=>arrayFrom(files.entries(), ([fileName, isSourceOfProjectReferenceRedirect])=>({
                        fileName,
                        isSourceOfProjectReferenceRedirect
                    })) : (files)=>arrayFrom(files.keys());
            if (!this.initialLoadPending) updateProjectIfDirty(this);
            const info = {
                projectName: this.getProjectName(),
                version: this.projectProgramVersion,
                isInferred: isInferredProject(this),
                options: this.getCompilationSettings(),
                languageServiceDisabled: !this.languageServiceEnabled,
                lastFileExceededProgramSize: this.lastFileExceededProgramSize
            };
            const updatedFileNames = this.updatedFileNames;
            this.updatedFileNames = void 0;
            if (this.lastReportedFileNames && lastKnownVersion === this.lastReportedVersion) {
                if (this.projectProgramVersion === this.lastReportedVersion && !updatedFileNames) return {
                    info,
                    projectErrors: this.getGlobalProjectErrors()
                };
                const lastReportedFileNames = this.lastReportedFileNames;
                const externalFiles = ((_a = this.externalFiles) == null ? void 0 : _a.map((f)=>({
                        fileName: toNormalizedPath(f),
                        isSourceOfProjectReferenceRedirect: false
                    }))) || emptyArray2;
                const currentFiles = arrayToMap(this.getFileNamesWithRedirectInfo(!!includeProjectReferenceRedirectInfo).concat(externalFiles), (info2)=>info2.fileName, (info2)=>info2.isSourceOfProjectReferenceRedirect);
                const added = /* @__PURE__ */ new Map();
                const removed = /* @__PURE__ */ new Map();
                const updated = updatedFileNames ? arrayFrom(updatedFileNames.keys()) : [];
                const updatedRedirects = [];
                forEachEntry(currentFiles, (isSourceOfProjectReferenceRedirect, fileName)=>{
                    if (!lastReportedFileNames.has(fileName)) added.set(fileName, isSourceOfProjectReferenceRedirect);
                    else if (includeProjectReferenceRedirectInfo && isSourceOfProjectReferenceRedirect !== lastReportedFileNames.get(fileName)) updatedRedirects.push({
                        fileName,
                        isSourceOfProjectReferenceRedirect
                    });
                });
                forEachEntry(lastReportedFileNames, (isSourceOfProjectReferenceRedirect, fileName)=>{
                    if (!currentFiles.has(fileName)) removed.set(fileName, isSourceOfProjectReferenceRedirect);
                });
                this.lastReportedFileNames = currentFiles;
                this.lastReportedVersion = this.projectProgramVersion;
                return {
                    info,
                    changes: {
                        added: includeProjectReferenceRedirectInfoIfRequested(added),
                        removed: includeProjectReferenceRedirectInfoIfRequested(removed),
                        updated: includeProjectReferenceRedirectInfo ? updated.map((fileName)=>({
                                fileName,
                                isSourceOfProjectReferenceRedirect: this.isSourceOfProjectReferenceRedirect(fileName)
                            })) : updated,
                        updatedRedirects: includeProjectReferenceRedirectInfo ? updatedRedirects : void 0
                    },
                    projectErrors: this.getGlobalProjectErrors()
                };
            } else {
                const projectFileNames = this.getFileNamesWithRedirectInfo(!!includeProjectReferenceRedirectInfo);
                const externalFiles = ((_b = this.externalFiles) == null ? void 0 : _b.map((f)=>({
                        fileName: toNormalizedPath(f),
                        isSourceOfProjectReferenceRedirect: false
                    }))) || emptyArray2;
                const allFiles = projectFileNames.concat(externalFiles);
                this.lastReportedFileNames = arrayToMap(allFiles, (info2)=>info2.fileName, (info2)=>info2.isSourceOfProjectReferenceRedirect);
                this.lastReportedVersion = this.projectProgramVersion;
                return {
                    info,
                    files: includeProjectReferenceRedirectInfo ? allFiles : allFiles.map((f)=>f.fileName),
                    projectErrors: this.getGlobalProjectErrors()
                };
            }
        }
        // remove a root file from project
        removeRoot(info) {
            this.rootFilesMap.delete(info.path);
        }
        /** @internal */ isSourceOfProjectReferenceRedirect(fileName) {
            return !!this.program && this.program.isSourceOfProjectReferenceRedirect(fileName);
        }
        /** @internal */ getGlobalPluginSearchPaths() {
            return [
                ...this.projectService.pluginProbeLocations,
                // ../../.. to walk from X/node_modules/typescript/lib/tsserver.js to X/node_modules/
                combinePaths(this.projectService.getExecutingFilePath(), "../../..")
            ];
        }
        enableGlobalPlugins(options) {
            if (!this.projectService.globalPlugins.length) return;
            const host = this.projectService.host;
            if (!host.require && !host.importPlugin) {
                this.projectService.logger.info("Plugins were requested but not running in environment that supports 'require'. Nothing will be loaded");
                return;
            }
            const searchPaths = this.getGlobalPluginSearchPaths();
            for (const globalPluginName of this.projectService.globalPlugins){
                if (!globalPluginName) continue;
                if (options.plugins && options.plugins.some((p)=>p.name === globalPluginName)) continue;
                this.projectService.logger.info(`Loading global plugin ${globalPluginName}`);
                this.enablePlugin({
                    name: globalPluginName,
                    global: true
                }, searchPaths);
            }
        }
        enablePlugin(pluginConfigEntry, searchPaths) {
            this.projectService.requestEnablePlugin(this, pluginConfigEntry, searchPaths);
        }
        /** @internal */ enableProxy(pluginModuleFactory, configEntry) {
            try {
                if (typeof pluginModuleFactory !== "function") {
                    this.projectService.logger.info(`Skipped loading plugin ${configEntry.name} because it did not expose a proper factory function`);
                    return;
                }
                const info = {
                    config: configEntry,
                    project: this,
                    languageService: this.languageService,
                    languageServiceHost: this,
                    serverHost: this.projectService.host,
                    session: this.projectService.session
                };
                const pluginModule = pluginModuleFactory({
                    typescript: ts_exports2
                });
                const newLS = pluginModule.create(info);
                for (const k of Object.keys(this.languageService))if (!(k in newLS)) {
                    this.projectService.logger.info(`Plugin activation warning: Missing proxied method ${k} in created LS. Patching.`);
                    newLS[k] = this.languageService[k];
                }
                this.projectService.logger.info(`Plugin validation succeeded`);
                this.languageService = newLS;
                this.plugins.push({
                    name: configEntry.name,
                    module: pluginModule
                });
            } catch (e) {
                this.projectService.logger.info(`Plugin activation failed: ${e}`);
            }
        }
        /** @internal */ onPluginConfigurationChanged(pluginName, configuration) {
            this.plugins.filter((plugin)=>plugin.name === pluginName).forEach((plugin)=>{
                if (plugin.module.onConfigurationChanged) plugin.module.onConfigurationChanged(configuration);
            });
        }
        /** Starts a new check for diagnostics. Call this if some file has updated that would cause diagnostics to be changed. */ refreshDiagnostics() {
            this.projectService.sendProjectsUpdatedInBackgroundEvent();
        }
        /** @internal */ getPackageJsonsVisibleToFile(fileName, rootDir) {
            if (this.projectService.serverMode !== 0 /* Semantic */ ) return emptyArray2;
            return this.projectService.getPackageJsonsVisibleToFile(fileName, this, rootDir);
        }
        /** @internal */ getNearestAncestorDirectoryWithPackageJson(fileName) {
            return this.projectService.getNearestAncestorDirectoryWithPackageJson(fileName, this);
        }
        /** @internal */ getPackageJsonsForAutoImport(rootDir) {
            return this.getPackageJsonsVisibleToFile(combinePaths(this.currentDirectory, inferredTypesContainingFile), rootDir);
        }
        /** @internal */ getPackageJsonCache() {
            return this.projectService.packageJsonCache;
        }
        /** @internal */ getCachedExportInfoMap() {
            return this.exportMapCache || (this.exportMapCache = createCacheableExportInfoMap(this));
        }
        /** @internal */ clearCachedExportInfoMap() {
            var _a;
            (_a = this.exportMapCache) == null || _a.clear();
        }
        /** @internal */ getModuleSpecifierCache() {
            return this.moduleSpecifierCache;
        }
        /** @internal */ includePackageJsonAutoImports() {
            if (this.projectService.includePackageJsonAutoImports() === 0 /* Off */  || !this.languageServiceEnabled || isInsideNodeModules(this.currentDirectory) || !this.isDefaultProjectForOpenFiles()) return 0 /* Off */ ;
            return this.projectService.includePackageJsonAutoImports();
        }
        /** @internal */ getHostForAutoImportProvider() {
            var _a, _b;
            if (this.program) return {
                fileExists: this.program.fileExists,
                directoryExists: this.program.directoryExists,
                realpath: this.program.realpath || ((_a = this.projectService.host.realpath) == null ? void 0 : _a.bind(this.projectService.host)),
                getCurrentDirectory: this.getCurrentDirectory.bind(this),
                readFile: this.projectService.host.readFile.bind(this.projectService.host),
                getDirectories: this.projectService.host.getDirectories.bind(this.projectService.host),
                trace: (_b = this.projectService.host.trace) == null ? void 0 : _b.bind(this.projectService.host),
                useCaseSensitiveFileNames: this.program.useCaseSensitiveFileNames(),
                readDirectory: this.projectService.host.readDirectory.bind(this.projectService.host)
            };
            return this.projectService.host;
        }
        /** @internal */ getPackageJsonAutoImportProvider() {
            var _a, _b, _c;
            if (this.autoImportProviderHost === false) return void 0;
            if (this.projectService.serverMode !== 0 /* Semantic */ ) {
                this.autoImportProviderHost = false;
                return void 0;
            }
            if (this.autoImportProviderHost) {
                updateProjectIfDirty(this.autoImportProviderHost);
                if (this.autoImportProviderHost.isEmpty()) {
                    this.autoImportProviderHost.close();
                    this.autoImportProviderHost = void 0;
                    return void 0;
                }
                return this.autoImportProviderHost.getCurrentProgram();
            }
            const dependencySelection = this.includePackageJsonAutoImports();
            if (dependencySelection) {
                (_a = tracing) == null || _a.push(tracing.Phase.Session, "getPackageJsonAutoImportProvider");
                const start = timestamp();
                var _AutoImportProviderProject_create;
                this.autoImportProviderHost = (_AutoImportProviderProject_create = AutoImportProviderProject.create(dependencySelection, this, this.getHostForAutoImportProvider())) !== null && _AutoImportProviderProject_create !== void 0 ? _AutoImportProviderProject_create : false;
                if (this.autoImportProviderHost) {
                    updateProjectIfDirty(this.autoImportProviderHost);
                    this.sendPerformanceEvent("CreatePackageJsonAutoImportProvider", timestamp() - start);
                    (_b = tracing) == null || _b.pop();
                    return this.autoImportProviderHost.getCurrentProgram();
                }
                (_c = tracing) == null || _c.pop();
            }
        }
        isDefaultProjectForOpenFiles() {
            return !!forEachEntry(this.projectService.openFiles, (_projectRootPath, path)=>this.projectService.tryGetDefaultProjectForFile(this.projectService.getScriptInfoForPath(path)) === this);
        }
        /** @internal */ watchNodeModulesForPackageJsonChanges(directoryPath) {
            return this.projectService.watchPackageJsonsInNodeModules(directoryPath, this);
        }
        /** @internal */ getIncompleteCompletionsCache() {
            return this.projectService.getIncompleteCompletionsCache();
        }
        /** @internal */ getNoDtsResolutionProject(rootFile) {
            Debug.assert(this.projectService.serverMode === 0 /* Semantic */ );
            var _this_noDtsResolutionProject;
            (_this_noDtsResolutionProject = this.noDtsResolutionProject) !== null && _this_noDtsResolutionProject !== void 0 ? _this_noDtsResolutionProject : this.noDtsResolutionProject = new AuxiliaryProject(this);
            if (this.noDtsResolutionProject.rootFile !== rootFile) {
                this.projectService.setFileNamesOfAutoImportProviderOrAuxillaryProject(this.noDtsResolutionProject, [
                    rootFile
                ]);
                this.noDtsResolutionProject.rootFile = rootFile;
            }
            return this.noDtsResolutionProject;
        }
        /** @internal */ runWithTemporaryFileUpdate(rootFile, updatedText, cb) {
            var _a, _b, _c, _d;
            const originalProgram = this.program;
            const rootSourceFile = Debug.checkDefined((_a = this.program) == null ? void 0 : _a.getSourceFile(rootFile), "Expected file to be part of program");
            const originalText = Debug.checkDefined(rootSourceFile.getFullText());
            (_b = this.getScriptInfo(rootFile)) == null || _b.editContent(0, originalText.length, updatedText);
            this.updateGraph();
            try {
                cb(this.program, originalProgram, (_c = this.program) == null ? void 0 : _c.getSourceFile(rootFile));
            } finally{
                (_d = this.getScriptInfo(rootFile)) == null || _d.editContent(0, updatedText.length, originalText);
            }
        }
        /** @internal */ getCompilerOptionsForNoDtsResolutionProject() {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.getCompilerOptions()), {
                noDtsResolution: true,
                allowJs: true,
                maxNodeModuleJsDepth: 3,
                diagnostics: false,
                skipLibCheck: true,
                sourceMap: false,
                types: emptyArray,
                lib: emptyArray,
                noLib: true
            });
        }
        /** @internal */ constructor(projectName, projectKind, projectService, hasExplicitListOfFiles, lastFileExceededProgramSize, compilerOptions, compileOnSaveEnabled, watchOptions, directoryStructureHost, currentDirectory){
            this.projectKind = projectKind;
            this.projectService = projectService;
            this.compilerOptions = compilerOptions;
            this.compileOnSaveEnabled = compileOnSaveEnabled;
            this.watchOptions = watchOptions;
            this.rootFilesMap = /* @__PURE__ */ new Map();
            /** @internal */ this.plugins = [];
            /**
     * This is map from files to unresolved imports in it
     * Maop does not contain entries for files that do not have unresolved imports
     * This helps in containing the set of files to invalidate
     *
     * @internal
     */ this.cachedUnresolvedImportsPerFile = /* @__PURE__ */ new Map();
            this.hasAddedorRemovedFiles = false;
            this.hasAddedOrRemovedSymlinks = false;
            /**
     * Last version that was reported.
     */ this.lastReportedVersion = 0;
            /**
     * Current project's program version. (incremented everytime new program is created that is not complete reuse from the old one)
     * This property is changed in 'updateGraph' based on the set of files in program
     * @internal
     */ this.projectProgramVersion = 0;
            /**
     * Current version of the project state. It is changed when:
     * - new root file was added/removed
     * - edit happen in some file that is currently included in the project.
     * This property is different from projectStructureVersion since in most cases edits don't affect set of files in the project
     * @internal
     */ this.projectStateVersion = 0;
            /** @internal */ this.initialLoadPending = false;
            /** @internal */ this.dirty = false;
            /** @internal */ this.typingFiles = emptyArray2;
            this.moduleSpecifierCache = createModuleSpecifierCache(this);
            /** @internal */ this.createHash = maybeBind(this.projectService.host, this.projectService.host.createHash);
            /** @internal */ this.globalCacheResolutionModuleName = ts_JsTyping_exports.nonRelativeModuleNameForTypingCache;
            /** @internal */ this.updateFromProjectInProgress = false;
            projectService.logger.info(`Creating ${ProjectKind[projectKind]}Project: ${projectName}, currentDirectory: ${currentDirectory}`);
            this.projectName = projectName;
            this.directoryStructureHost = directoryStructureHost;
            this.currentDirectory = this.projectService.getNormalizedAbsolutePath(currentDirectory);
            this.getCanonicalFileName = this.projectService.toCanonicalFileName;
            this.jsDocParsingMode = this.projectService.jsDocParsingMode;
            this.cancellationToken = new ThrottledCancellationToken(this.projectService.cancellationToken, this.projectService.throttleWaitMilliseconds);
            if (!this.compilerOptions) {
                this.compilerOptions = getDefaultCompilerOptions2();
                this.compilerOptions.allowNonTsExtensions = true;
                this.compilerOptions.allowJs = true;
            } else if (hasExplicitListOfFiles || getAllowJSCompilerOption(this.compilerOptions) || this.projectService.hasDeferredExtension()) this.compilerOptions.allowNonTsExtensions = true;
            switch(projectService.serverMode){
                case 0 /* Semantic */ :
                    this.languageServiceEnabled = true;
                    break;
                case 1 /* PartialSemantic */ :
                    this.languageServiceEnabled = true;
                    this.compilerOptions.noResolve = true;
                    this.compilerOptions.types = [];
                    break;
                case 2 /* Syntactic */ :
                    this.languageServiceEnabled = false;
                    this.compilerOptions.noResolve = true;
                    this.compilerOptions.types = [];
                    break;
                default:
                    Debug.assertNever(projectService.serverMode);
            }
            this.setInternalCompilerOptionsForEmittingJsFiles();
            const host = this.projectService.host;
            if (this.projectService.logger.loggingEnabled()) this.trace = (s)=>this.writeLog(s);
            else if (host.trace) this.trace = (s)=>host.trace(s);
            this.realpath = maybeBind(host, host.realpath);
            this.preferNonRecursiveWatch = this.projectService.canUseWatchEvents || host.preferNonRecursiveWatch;
            this.resolutionCache = createResolutionCache(this, this.currentDirectory, /*logChangesWhenResolvingModule*/ true);
            this.languageService = createLanguageService(this, this.projectService.documentRegistry, this.projectService.serverMode);
            if (lastFileExceededProgramSize) this.disableLanguageService(lastFileExceededProgramSize);
            this.markAsDirty();
            if (!isBackgroundProject(this)) this.projectService.pendingEnsureProjectForOpenFiles = true;
            this.projectService.onProjectCreation(this);
        }
    };
    function getUnresolvedImports(program, cachedUnresolvedImportsPerFile) {
        var _a, _b;
        const sourceFiles = program.getSourceFiles();
        (_a = tracing) == null || _a.push(tracing.Phase.Session, "getUnresolvedImports", {
            count: sourceFiles.length
        });
        const ambientModules = program.getTypeChecker().getAmbientModules().map((mod)=>stripQuotes(mod.getName()));
        const result = sortAndDeduplicate(flatMap(sourceFiles, (sourceFile)=>extractUnresolvedImportsFromSourceFile(program, sourceFile, ambientModules, cachedUnresolvedImportsPerFile)));
        (_b = tracing) == null || _b.pop();
        return result;
    }
    function extractUnresolvedImportsFromSourceFile(program, file, ambientModules, cachedUnresolvedImportsPerFile) {
        return getOrUpdate(cachedUnresolvedImportsPerFile, file.path, ()=>{
            let unresolvedImports;
            program.forEachResolvedModule(({ resolvedModule }, name)=>{
                if ((!resolvedModule || !resolutionExtensionIsTSOrJson(resolvedModule.extension)) && !isExternalModuleNameRelative(name) && !ambientModules.some((m)=>m === name)) unresolvedImports = append(unresolvedImports, parsePackageName(name).packageName);
            }, file);
            return unresolvedImports || emptyArray2;
        });
    }
    var InferredProject2 = class extends Project2 {
        toggleJsInferredProject(isJsInferredProject) {
            if (isJsInferredProject !== this._isJsInferredProject) {
                this._isJsInferredProject = isJsInferredProject;
                this.setCompilerOptions();
            }
        }
        setCompilerOptions(options) {
            if (!options && !this.getCompilationSettings()) return;
            const newOptions = cloneCompilerOptions(options || this.getCompilationSettings());
            if (this._isJsInferredProject && typeof newOptions.maxNodeModuleJsDepth !== "number") newOptions.maxNodeModuleJsDepth = 2;
            else if (!this._isJsInferredProject) newOptions.maxNodeModuleJsDepth = void 0;
            newOptions.allowJs = true;
            super.setCompilerOptions(newOptions);
        }
        addRoot(info) {
            Debug.assert(info.isScriptOpen());
            this.projectService.startWatchingConfigFilesForInferredProjectRoot(info);
            if (!this._isJsInferredProject && info.isJavaScript()) this.toggleJsInferredProject(/*isJsInferredProject*/ true);
            else if (this.isOrphan() && this._isJsInferredProject && !info.isJavaScript()) this.toggleJsInferredProject(/*isJsInferredProject*/ false);
            super.addRoot(info);
        }
        removeRoot(info) {
            this.projectService.stopWatchingConfigFilesForScriptInfo(info);
            super.removeRoot(info);
            if (!this.isOrphan() && this._isJsInferredProject && info.isJavaScript()) {
                if (every(this.getRootScriptInfos(), (rootInfo)=>!rootInfo.isJavaScript())) this.toggleJsInferredProject(/*isJsInferredProject*/ false);
            }
        }
        /** @internal */ isOrphan() {
            return !this.hasRoots();
        }
        isProjectWithSingleRoot() {
            return !this.projectRootPath && !this.projectService.useSingleInferredProject || this.getRootScriptInfos().length === 1;
        }
        close() {
            forEach(this.getRootScriptInfos(), (info)=>this.projectService.stopWatchingConfigFilesForScriptInfo(info));
            super.close();
        }
        getTypeAcquisition() {
            return this.typeAcquisition || {
                enable: allRootFilesAreJsOrDts(this),
                include: emptyArray,
                exclude: emptyArray
            };
        }
        /** @internal */ constructor(projectService, compilerOptions, watchOptions, projectRootPath, currentDirectory, typeAcquisition){
            super(projectService.newInferredProjectName(), 0 /* Inferred */ , projectService, /*hasExplicitListOfFiles*/ false, /*lastFileExceededProgramSize*/ void 0, compilerOptions, /*compileOnSaveEnabled*/ false, watchOptions, projectService.host, currentDirectory);
            this._isJsInferredProject = false;
            this.typeAcquisition = typeAcquisition;
            this.projectRootPath = projectRootPath && projectService.toCanonicalFileName(projectRootPath);
            if (!projectRootPath && !projectService.useSingleInferredProject) this.canonicalCurrentDirectory = projectService.toCanonicalFileName(this.currentDirectory);
            this.enableGlobalPlugins(this.getCompilerOptions());
        }
    };
    var AuxiliaryProject = class extends Project2 {
        isOrphan() {
            return true;
        }
        scheduleInvalidateResolutionsOfFailedLookupLocations() {
            return;
        }
        constructor(hostProject){
            super(hostProject.projectService.newAuxiliaryProjectName(), 4 /* Auxiliary */ , hostProject.projectService, /*hasExplicitListOfFiles*/ false, /*lastFileExceededProgramSize*/ void 0, hostProject.getCompilerOptionsForNoDtsResolutionProject(), /*compileOnSaveEnabled*/ false, /*watchOptions*/ void 0, hostProject.projectService.host, hostProject.currentDirectory);
        }
    };
    var _AutoImportProviderProject = class _AutoImportProviderProject extends Project2 {
        /** @internal */ static getRootFileNames(dependencySelection, hostProject, host, compilerOptions) {
            var _a, _b;
            if (!dependencySelection) return emptyArray;
            const program = hostProject.getCurrentProgram();
            if (!program) return emptyArray;
            const start = timestamp();
            let dependencyNames;
            let rootNames;
            const rootFileName = combinePaths(hostProject.currentDirectory, inferredTypesContainingFile);
            const packageJsons = hostProject.getPackageJsonsForAutoImport(combinePaths(hostProject.currentDirectory, rootFileName));
            for (const packageJson of packageJsons){
                (_a = packageJson.dependencies) == null || _a.forEach((_, dependenyName)=>addDependency(dependenyName));
                (_b = packageJson.peerDependencies) == null || _b.forEach((_, dependencyName)=>addDependency(dependencyName));
            }
            let dependenciesAdded = 0;
            if (dependencyNames) {
                const symlinkCache = hostProject.getSymlinkCache();
                for (const name of arrayFrom(dependencyNames.keys())){
                    if (dependencySelection === 2 /* Auto */  && dependenciesAdded >= this.maxDependencies) {
                        hostProject.log(`AutoImportProviderProject: attempted to add more than ${this.maxDependencies} dependencies. Aborting.`);
                        return emptyArray;
                    }
                    const packageJson = resolvePackageNameToPackageJson(name, hostProject.currentDirectory, compilerOptions, host, program.getModuleResolutionCache());
                    if (packageJson) {
                        const entrypoints = getRootNamesFromPackageJson(packageJson, program, symlinkCache);
                        if (entrypoints) {
                            dependenciesAdded += addRootNames(entrypoints);
                            continue;
                        }
                    }
                    const done = forEach([
                        hostProject.currentDirectory,
                        hostProject.getGlobalTypingsCacheLocation()
                    ], (directory)=>{
                        if (directory) {
                            const typesPackageJson = resolvePackageNameToPackageJson(`@types/${name}`, directory, compilerOptions, host, program.getModuleResolutionCache());
                            if (typesPackageJson) {
                                const entrypoints = getRootNamesFromPackageJson(typesPackageJson, program, symlinkCache);
                                dependenciesAdded += addRootNames(entrypoints);
                                return true;
                            }
                        }
                    });
                    if (done) continue;
                    if (packageJson && compilerOptions.allowJs && compilerOptions.maxNodeModuleJsDepth) {
                        const entrypoints = getRootNamesFromPackageJson(packageJson, program, symlinkCache, /*resolveJs*/ true);
                        dependenciesAdded += addRootNames(entrypoints);
                    }
                }
            }
            const references = program.getResolvedProjectReferences();
            let referencesAddded = 0;
            if ((references == null ? void 0 : references.length) && hostProject.projectService.getHostPreferences().includeCompletionsForModuleExports) references.forEach((ref)=>{
                if (ref == null ? void 0 : ref.commandLine.options.outFile) referencesAddded += addRootNames(filterEntrypoints([
                    changeExtension(ref.commandLine.options.outFile, ".d.ts")
                ]));
                else if (ref) {
                    const getCommonSourceDirectory2 = memoize(()=>getCommonSourceDirectoryOfConfig(ref.commandLine, !hostProject.useCaseSensitiveFileNames()));
                    referencesAddded += addRootNames(filterEntrypoints(mapDefined(ref.commandLine.fileNames, (fileName)=>!isDeclarationFileName(fileName) && !fileExtensionIs(fileName, ".json" /* Json */ ) && !program.getSourceFile(fileName) ? getOutputDeclarationFileName(fileName, ref.commandLine, !hostProject.useCaseSensitiveFileNames(), getCommonSourceDirectory2) : void 0)));
                }
            });
            if (rootNames == null ? void 0 : rootNames.size) hostProject.log(`AutoImportProviderProject: found ${rootNames.size} root files in ${dependenciesAdded} dependencies ${referencesAddded} referenced projects in ${timestamp() - start} ms`);
            return rootNames ? arrayFrom(rootNames.values()) : emptyArray;
            function addRootNames(entrypoints) {
                if (!(entrypoints == null ? void 0 : entrypoints.length)) return 0;
                rootNames !== null && rootNames !== void 0 ? rootNames : rootNames = /* @__PURE__ */ new Set();
                entrypoints.forEach((entry)=>rootNames.add(entry));
                return 1;
            }
            function addDependency(dependency) {
                if (!startsWith(dependency, "@types/")) (dependencyNames || (dependencyNames = /* @__PURE__ */ new Set())).add(dependency);
            }
            function getRootNamesFromPackageJson(packageJson, program2, symlinkCache, resolveJs) {
                var _a2;
                const entrypoints = getEntrypointsFromPackageJsonInfo(packageJson, compilerOptions, host, program2.getModuleResolutionCache(), resolveJs);
                if (entrypoints) {
                    const real = (_a2 = host.realpath) == null ? void 0 : _a2.call(host, packageJson.packageDirectory);
                    const realPath2 = real ? hostProject.toPath(real) : void 0;
                    const isSymlink = realPath2 && realPath2 !== hostProject.toPath(packageJson.packageDirectory);
                    if (isSymlink) symlinkCache.setSymlinkedDirectory(packageJson.packageDirectory, {
                        real: ensureTrailingDirectorySeparator(real),
                        realPath: ensureTrailingDirectorySeparator(realPath2)
                    });
                    return filterEntrypoints(entrypoints, isSymlink ? (entrypoint)=>entrypoint.replace(packageJson.packageDirectory, real) : void 0);
                }
            }
            function filterEntrypoints(entrypoints, symlinkName) {
                return mapDefined(entrypoints, (entrypoint)=>{
                    const resolvedFileName = symlinkName ? symlinkName(entrypoint) : entrypoint;
                    if (!program.getSourceFile(resolvedFileName) && !(symlinkName && program.getSourceFile(entrypoint))) return resolvedFileName;
                });
            }
        }
        /** @internal */ static create(dependencySelection, hostProject, host) {
            if (dependencySelection === 0 /* Off */ ) return void 0;
            const compilerOptions = (0, _objectSpread._)({}, hostProject.getCompilerOptions(), this.compilerOptionsOverrides);
            const rootNames = this.getRootFileNames(dependencySelection, hostProject, host, compilerOptions);
            if (!rootNames.length) return void 0;
            return new _AutoImportProviderProject(hostProject, rootNames, compilerOptions);
        }
        /** @internal */ isEmpty() {
            return !some(this.rootFileNames);
        }
        /** @internal */ isOrphan() {
            return true;
        }
        updateGraph() {
            let rootFileNames = this.rootFileNames;
            if (!rootFileNames) rootFileNames = _AutoImportProviderProject.getRootFileNames(this.hostProject.includePackageJsonAutoImports(), this.hostProject, this.hostProject.getHostForAutoImportProvider(), this.getCompilationSettings());
            this.projectService.setFileNamesOfAutoImportProviderOrAuxillaryProject(this, rootFileNames);
            this.rootFileNames = rootFileNames;
            const oldProgram = this.getCurrentProgram();
            const hasSameSetOfFiles = super.updateGraph();
            if (oldProgram && oldProgram !== this.getCurrentProgram()) this.hostProject.clearCachedExportInfoMap();
            return hasSameSetOfFiles;
        }
        /** @internal */ scheduleInvalidateResolutionsOfFailedLookupLocations() {
            return;
        }
        hasRoots() {
            var _a;
            return !!((_a = this.rootFileNames) == null ? void 0 : _a.length);
        }
        /** @internal */ markAsDirty() {
            this.rootFileNames = void 0;
            super.markAsDirty();
        }
        getScriptFileNames() {
            return this.rootFileNames || emptyArray;
        }
        getLanguageService() {
            throw new Error("AutoImportProviderProject language service should never be used. To get the program, use `project.getCurrentProgram()`.");
        }
        /** @internal */ onAutoImportProviderSettingsChanged() {
            throw new Error("AutoImportProviderProject is an auto import provider; use `markAsDirty()` instead.");
        }
        /** @internal */ onPackageJsonChange() {
            throw new Error("package.json changes should be notified on an AutoImportProvider's host project");
        }
        getHostForAutoImportProvider() {
            throw new Error("AutoImportProviderProject cannot provide its own host; use `hostProject.getModuleResolutionHostForAutomImportProvider()` instead.");
        }
        getProjectReferences() {
            return this.hostProject.getProjectReferences();
        }
        /** @internal */ includePackageJsonAutoImports() {
            return 0 /* Off */ ;
        }
        /** @internal */ getSymlinkCache() {
            return this.hostProject.getSymlinkCache();
        }
        /** @internal */ getModuleResolutionCache() {
            var _a;
            return (_a = this.hostProject.getCurrentProgram()) == null ? void 0 : _a.getModuleResolutionCache();
        }
        /** @internal */ constructor(hostProject, initialRootNames, compilerOptions){
            super(hostProject.projectService.newAutoImportProviderProjectName(), 3 /* AutoImportProvider */ , hostProject.projectService, /*hasExplicitListOfFiles*/ false, /*lastFileExceededProgramSize*/ void 0, compilerOptions, /*compileOnSaveEnabled*/ false, hostProject.getWatchOptions(), hostProject.projectService.host, hostProject.currentDirectory);
            this.hostProject = hostProject;
            this.rootFileNames = initialRootNames;
            this.useSourceOfProjectReferenceRedirect = maybeBind(this.hostProject, this.hostProject.useSourceOfProjectReferenceRedirect);
            this.getParsedCommandLine = maybeBind(this.hostProject, this.hostProject.getParsedCommandLine);
        }
    };
    _AutoImportProviderProject.maxDependencies = 10;
    /** @internal */ _AutoImportProviderProject.compilerOptionsOverrides = {
        diagnostics: false,
        skipLibCheck: true,
        sourceMap: false,
        types: emptyArray,
        lib: emptyArray,
        noLib: true
    };
    var AutoImportProviderProject = _AutoImportProviderProject;
    var ConfiguredProject2 = class extends Project2 {
        /** @internal */ setCompilerHost(host) {
            this.compilerHost = host;
        }
        /** @internal */ getCompilerHost() {
            return this.compilerHost;
        }
        /** @internal */ useSourceOfProjectReferenceRedirect() {
            return this.languageServiceEnabled;
        }
        /** @internal */ getParsedCommandLine(fileName) {
            const configFileName = toNormalizedPath(fileName);
            const canonicalConfigFilePath = asNormalizedPath(this.projectService.toCanonicalFileName(configFileName));
            let configFileExistenceInfo = this.projectService.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            if (!configFileExistenceInfo) this.projectService.configFileExistenceInfoCache.set(canonicalConfigFilePath, configFileExistenceInfo = {
                exists: this.projectService.host.fileExists(configFileName)
            });
            this.projectService.ensureParsedConfigUptoDate(configFileName, canonicalConfigFilePath, configFileExistenceInfo, this);
            if (this.languageServiceEnabled && this.projectService.serverMode === 0 /* Semantic */ ) this.projectService.watchWildcards(configFileName, configFileExistenceInfo, this);
            return configFileExistenceInfo.exists ? configFileExistenceInfo.config.parsedCommandLine : void 0;
        }
        /** @internal */ onReleaseParsedCommandLine(fileName) {
            this.releaseParsedConfig(asNormalizedPath(this.projectService.toCanonicalFileName(toNormalizedPath(fileName))));
        }
        releaseParsedConfig(canonicalConfigFilePath) {
            this.projectService.stopWatchingWildCards(canonicalConfigFilePath, this);
            this.projectService.releaseParsedConfig(canonicalConfigFilePath, this);
        }
        /**
   * If the project has reload from disk pending, it reloads (and then updates graph as part of that) instead of just updating the graph
   * @returns: true if set of files in the project stays the same and false - otherwise.
   */ updateGraph() {
            if (this.deferredClose) return false;
            const isDirty = this.dirty;
            this.initialLoadPending = false;
            const updateLevel = this.pendingUpdateLevel;
            this.pendingUpdateLevel = 0 /* Update */ ;
            let result;
            switch(updateLevel){
                case 1 /* RootNamesAndUpdate */ :
                    this.openFileWatchTriggered.clear();
                    result = this.projectService.reloadFileNamesOfConfiguredProject(this);
                    break;
                case 2 /* Full */ :
                    this.openFileWatchTriggered.clear();
                    const reason = Debug.checkDefined(this.pendingUpdateReason);
                    this.projectService.reloadConfiguredProject(this, reason);
                    result = true;
                    break;
                default:
                    result = super.updateGraph();
            }
            this.compilerHost = void 0;
            this.projectService.sendProjectLoadingFinishEvent(this);
            this.projectService.sendProjectTelemetry(this);
            if (updateLevel === 2 /* Full */  || // Already sent event through reload
            result && // Not new program
            (!isDirty || !this.triggerFileForConfigFileDiag || this.getCurrentProgram().structureIsReused === 2 /* Completely */ )) this.triggerFileForConfigFileDiag = void 0;
            else if (!this.triggerFileForConfigFileDiag) this.projectService.sendConfigFileDiagEvent(this, /*triggerFile*/ void 0, /*force*/ false);
            return result;
        }
        /** @internal */ getCachedDirectoryStructureHost() {
            return this.directoryStructureHost;
        }
        getConfigFilePath() {
            return asNormalizedPath(this.getProjectName());
        }
        getProjectReferences() {
            return this.projectReferences;
        }
        updateReferences(refs) {
            this.projectReferences = refs;
            this.potentialProjectReferences = void 0;
        }
        /** @internal */ setPotentialProjectReference(canonicalConfigPath) {
            Debug.assert(this.initialLoadPending);
            (this.potentialProjectReferences || (this.potentialProjectReferences = /* @__PURE__ */ new Set())).add(canonicalConfigPath);
        }
        /** @internal */ getRedirectFromSourceFile(fileName) {
            const program = this.getCurrentProgram();
            return program && program.getRedirectFromSourceFile(fileName);
        }
        /** @internal */ forEachResolvedProjectReference(cb) {
            var _a;
            return (_a = this.getCurrentProgram()) == null ? void 0 : _a.forEachResolvedProjectReference(cb);
        }
        /** @internal */ enablePluginsWithOptions(options) {
            var _a;
            this.plugins.length = 0;
            if (!((_a = options.plugins) == null ? void 0 : _a.length) && !this.projectService.globalPlugins.length) return;
            const host = this.projectService.host;
            if (!host.require && !host.importPlugin) {
                this.projectService.logger.info("Plugins were requested but not running in environment that supports 'require'. Nothing will be loaded");
                return;
            }
            const searchPaths = this.getGlobalPluginSearchPaths();
            if (this.projectService.allowLocalPluginLoads) {
                const local = getDirectoryPath(this.canonicalConfigFilePath);
                this.projectService.logger.info(`Local plugin loading enabled; adding ${local} to search paths`);
                searchPaths.unshift(local);
            }
            if (options.plugins) for (const pluginConfigEntry of options.plugins)this.enablePlugin(pluginConfigEntry, searchPaths);
            return this.enableGlobalPlugins(options);
        }
        /**
   * Get the errors that dont have any file name associated
   */ getGlobalProjectErrors() {
            return filter(this.projectErrors, (diagnostic)=>!diagnostic.file) || emptyArray2;
        }
        /**
   * Get all the project errors
   */ getAllProjectErrors() {
            return this.projectErrors || emptyArray2;
        }
        setProjectErrors(projectErrors) {
            this.projectErrors = projectErrors;
        }
        close() {
            this.projectService.configFileExistenceInfoCache.forEach((_configFileExistenceInfo, canonicalConfigFilePath)=>this.releaseParsedConfig(canonicalConfigFilePath));
            this.projectErrors = void 0;
            this.openFileWatchTriggered.clear();
            this.compilerHost = void 0;
            super.close();
        }
        /** @internal */ markAsDirty() {
            if (this.deferredClose) return;
            super.markAsDirty();
        }
        /** @internal */ isOrphan() {
            return !!this.deferredClose;
        }
        getEffectiveTypeRoots() {
            return getEffectiveTypeRoots(this.getCompilationSettings(), this) || [];
        }
        /** @internal */ updateErrorOnNoInputFiles(parsedCommandLine) {
            this.parsedCommandLine = parsedCommandLine;
            updateErrorForNoInputFiles(parsedCommandLine.fileNames, this.getConfigFilePath(), this.getCompilerOptions().configFile.configFileSpecs, this.projectErrors, canJsonReportNoInputFiles(parsedCommandLine.raw));
        }
        /** @internal */ constructor(configFileName, canonicalConfigFilePath, projectService, cachedDirectoryStructureHost, pendingUpdateReason){
            super(configFileName, 1 /* Configured */ , projectService, /*hasExplicitListOfFiles*/ false, /*lastFileExceededProgramSize*/ void 0, /*compilerOptions*/ {}, /*compileOnSaveEnabled*/ false, /*watchOptions*/ void 0, cachedDirectoryStructureHost, getDirectoryPath(configFileName));
            this.canonicalConfigFilePath = canonicalConfigFilePath;
            /** @internal */ this.openFileWatchTriggered = /* @__PURE__ */ new Map();
            /** @internal */ this.initialLoadPending = true;
            /** @internal */ this.sendLoadingProjectFinish = false;
            this.pendingUpdateLevel = 2 /* Full */ ;
            this.pendingUpdateReason = pendingUpdateReason;
        }
    };
    var ExternalProject = class extends Project2 {
        updateGraph() {
            const result = super.updateGraph();
            this.projectService.sendProjectTelemetry(this);
            return result;
        }
        getExcludedFiles() {
            return this.excludedFiles;
        }
        /** @internal */ constructor(externalProjectName, projectService, compilerOptions, lastFileExceededProgramSize, compileOnSaveEnabled, projectFilePath, watchOptions){
            super(externalProjectName, 2 /* External */ , projectService, /*hasExplicitListOfFiles*/ true, lastFileExceededProgramSize, compilerOptions, compileOnSaveEnabled, watchOptions, projectService.host, getDirectoryPath(projectFilePath || normalizeSlashes(externalProjectName)));
            this.externalProjectName = externalProjectName;
            this.compileOnSaveEnabled = compileOnSaveEnabled;
            this.excludedFiles = [];
            this.enableGlobalPlugins(this.getCompilerOptions());
        }
    };
    function isInferredProject(project) {
        return project.projectKind === 0 /* Inferred */ ;
    }
    function isConfiguredProject(project) {
        return project.projectKind === 1 /* Configured */ ;
    }
    function isExternalProject(project) {
        return project.projectKind === 2 /* External */ ;
    }
    function isBackgroundProject(project) {
        return project.projectKind === 3 /* AutoImportProvider */  || project.projectKind === 4 /* Auxiliary */ ;
    }
    function isProjectDeferredClose(project) {
        return isConfiguredProject(project) && !!project.deferredClose;
    }
    // src/server/editorServices.ts
    var maxProgramSizeForNonTsFiles = 20971520;
    var maxFileSize = 4194304;
    var ProjectsUpdatedInBackgroundEvent = "projectsUpdatedInBackground";
    var ProjectLoadingStartEvent = "projectLoadingStart";
    var ProjectLoadingFinishEvent = "projectLoadingFinish";
    var LargeFileReferencedEvent = "largeFileReferenced";
    var ConfigFileDiagEvent = "configFileDiag";
    var ProjectLanguageServiceStateEvent = "projectLanguageServiceState";
    var ProjectInfoTelemetryEvent = "projectInfo";
    var OpenFileInfoTelemetryEvent = "openFileInfo";
    var CreateFileWatcherEvent = "createFileWatcher";
    var CreateDirectoryWatcherEvent = "createDirectoryWatcher";
    var CloseFileWatcherEvent = "closeFileWatcher";
    var ensureProjectForOpenFileSchedule = "*ensureProjectForOpenFiles*";
    function prepareConvertersForEnumLikeCompilerOptions(commandLineOptions) {
        const map2 = /* @__PURE__ */ new Map();
        for (const option of commandLineOptions)if (typeof option.type === "object") {
            const optionMap = option.type;
            optionMap.forEach((value1)=>{
                Debug.assert(typeof value1 === "number");
            });
            map2.set(option.name, optionMap);
        }
        return map2;
    }
    var compilerOptionConverters = prepareConvertersForEnumLikeCompilerOptions(optionDeclarations);
    var watchOptionsConverters = prepareConvertersForEnumLikeCompilerOptions(optionsForWatch);
    var indentStyle = new Map(Object.entries({
        none: 0 /* None */ ,
        block: 1 /* Block */ ,
        smart: 2 /* Smart */ 
    }));
    var defaultTypeSafeList = {
        "jquery": {
            // jquery files can have names like "jquery-1.10.2.min.js" (or "jquery.intellisense.js")
            match: /jquery(-[\d.]+)?(\.intellisense)?(\.min)?\.js$/i,
            types: [
                "jquery"
            ]
        },
        "WinJS": {
            // e.g. c:/temp/UWApp1/lib/winjs-4.0.1/js/base.js
            match: /^(.*\/winjs-[.\d]+)\/js\/base\.js$/i,
            // If the winjs/base.js file is found..
            exclude: [
                [
                    "^",
                    1,
                    "/.*"
                ]
            ],
            // ..then exclude all files under the winjs folder
            types: [
                "winjs"
            ]
        },
        "Kendo": {
            // e.g. /Kendo3/wwwroot/lib/kendo/kendo.all.min.js
            match: /^(.*\/kendo(-ui)?)\/kendo\.all(\.min)?\.js$/i,
            exclude: [
                [
                    "^",
                    1,
                    "/.*"
                ]
            ],
            types: [
                "kendo-ui"
            ]
        },
        "Office Nuget": {
            // e.g. /scripts/Office/1/excel-15.debug.js
            match: /^(.*\/office\/1)\/excel-\d+\.debug\.js$/i,
            // Office NuGet package is installed under a "1/office" folder
            exclude: [
                [
                    "^",
                    1,
                    "/.*"
                ]
            ],
            // Exclude that whole folder if the file indicated above is found in it
            types: [
                "office"
            ]
        },
        "References": {
            match: /^(.*\/_references\.js)$/i,
            exclude: [
                [
                    "^",
                    1,
                    "$"
                ]
            ]
        }
    };
    function convertFormatOptions(protocolOptions) {
        if (isString(protocolOptions.indentStyle)) {
            protocolOptions.indentStyle = indentStyle.get(protocolOptions.indentStyle.toLowerCase());
            Debug.assert(protocolOptions.indentStyle !== void 0);
        }
        return protocolOptions;
    }
    function convertCompilerOptions(protocolOptions) {
        compilerOptionConverters.forEach((mappedValues, id)=>{
            const propertyValue = protocolOptions[id];
            if (isString(propertyValue)) protocolOptions[id] = mappedValues.get(propertyValue.toLowerCase());
        });
        return protocolOptions;
    }
    function convertWatchOptions(protocolOptions, currentDirectory) {
        let watchOptions;
        let errors;
        optionsForWatch.forEach((option)=>{
            const propertyValue = protocolOptions[option.name];
            if (propertyValue === void 0) return;
            const mappedValues = watchOptionsConverters.get(option.name);
            (watchOptions || (watchOptions = {}))[option.name] = mappedValues ? isString(propertyValue) ? mappedValues.get(propertyValue.toLowerCase()) : propertyValue : convertJsonOption(option, propertyValue, currentDirectory || "", errors || (errors = []));
        });
        return watchOptions && {
            watchOptions,
            errors
        };
    }
    function convertTypeAcquisition(protocolOptions) {
        let result;
        typeAcquisitionDeclarations.forEach((option)=>{
            const propertyValue = protocolOptions[option.name];
            if (propertyValue === void 0) return;
            (result || (result = {}))[option.name] = propertyValue;
        });
        return result;
    }
    function tryConvertScriptKindName(scriptKindName) {
        return isString(scriptKindName) ? convertScriptKindName(scriptKindName) : scriptKindName;
    }
    function convertScriptKindName(scriptKindName) {
        switch(scriptKindName){
            case "JS":
                return 1 /* JS */ ;
            case "JSX":
                return 2 /* JSX */ ;
            case "TS":
                return 3 /* TS */ ;
            case "TSX":
                return 4 /* TSX */ ;
            default:
                return 0 /* Unknown */ ;
        }
    }
    function convertUserPreferences(preferences) {
        const { lazyConfiguredProjectsFromExternalProject: _ } = preferences, userPreferences = (0, _objectWithoutProperties._)(preferences, [
            "lazyConfiguredProjectsFromExternalProject"
        ]);
        return userPreferences;
    }
    var fileNamePropertyReader = {
        getFileName: (x)=>x,
        getScriptKind: (fileName, extraFileExtensions)=>{
            let result;
            if (extraFileExtensions) {
                const fileExtension = getAnyExtensionFromPath(fileName);
                if (fileExtension) some(extraFileExtensions, (info)=>{
                    if (info.extension === fileExtension) {
                        result = info.scriptKind;
                        return true;
                    }
                    return false;
                });
            }
            return result;
        },
        hasMixedContent: (fileName, extraFileExtensions)=>some(extraFileExtensions, (ext)=>ext.isMixedContent && fileExtensionIs(fileName, ext.extension))
    };
    var externalFilePropertyReader = {
        getFileName: (x)=>x.fileName,
        getScriptKind: (x)=>tryConvertScriptKindName(x.scriptKind),
        // TODO: GH#18217
        hasMixedContent: (x)=>!!x.hasMixedContent
    };
    function findProjectByName(projectName, projects) {
        for (const proj of projects){
            if (proj.getProjectName() === projectName) return proj;
        }
    }
    var nullTypingsInstaller = {
        isKnownTypesPackageName: returnFalse,
        // Should never be called because we never provide a types registry.
        installPackage: notImplemented,
        enqueueInstallTypingsRequest: noop,
        attach: noop,
        onProjectClosed: noop,
        globalTypingsCacheLocation: void 0
    };
    var noopConfigFileWatcher = {
        close: noop
    };
    function getConfigFileNameFromCache(info, cache) {
        if (!cache) return void 0;
        const configFileForOpenFile = cache.get(info.path);
        if (configFileForOpenFile === void 0) return void 0;
        if (!isAncestorConfigFileInfo(info)) return isString(configFileForOpenFile) || !configFileForOpenFile ? configFileForOpenFile : // direct result
        configFileForOpenFile.get(/*key*/ false);
        else return configFileForOpenFile && !isString(configFileForOpenFile) ? // Map with fileName as key
        configFileForOpenFile.get(info.fileName) : void 0;
    }
    function isOpenScriptInfo(infoOrFileNameOrConfig) {
        return !!infoOrFileNameOrConfig.containingProjects;
    }
    function isAncestorConfigFileInfo(infoOrFileNameOrConfig) {
        return !!infoOrFileNameOrConfig.configFileInfo;
    }
    var ConfiguredProjectLoadKind = /* @__PURE__ */ ((ConfiguredProjectLoadKind2)=>{
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["FindOptimized"] = 0] = "FindOptimized";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["Find"] = 1] = "Find";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["CreateReplayOptimized"] = 2] = "CreateReplayOptimized";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["CreateReplay"] = 3] = "CreateReplay";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["CreateOptimized"] = 4] = "CreateOptimized";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["Create"] = 5] = "Create";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["ReloadOptimized"] = 6] = "ReloadOptimized";
        ConfiguredProjectLoadKind2[ConfiguredProjectLoadKind2["Reload"] = 7] = "Reload";
        return ConfiguredProjectLoadKind2;
    })(ConfiguredProjectLoadKind || {});
    function toConfiguredProjectLoadOptimized(kind) {
        return kind - 1;
    }
    function forEachAncestorProjectLoad(info, project, cb, kind, reason, allowDeferredClosed, reloadedProjects, searchOnlyPotentialSolution, delayReloadedConfiguredProjects) {
        var _a;
        while(true){
            if (project.parsedCommandLine && (searchOnlyPotentialSolution && !project.parsedCommandLine.options.composite || // Currently disableSolutionSearching is shared for finding solution/project when
            // - loading solution for find all references
            // - trying to find default project
            project.parsedCommandLine.options.disableSolutionSearching)) return;
            const configFileName = project.projectService.getConfigFileNameForFile({
                fileName: project.getConfigFilePath(),
                path: info.path,
                configFileInfo: true,
                isForDefaultProject: !searchOnlyPotentialSolution
            }, kind <= 3 /* CreateReplay */ );
            if (!configFileName) return;
            const ancestor = project.projectService.findCreateOrReloadConfiguredProject(configFileName, kind, reason, allowDeferredClosed, !searchOnlyPotentialSolution ? info.fileName : void 0, // Config Diag event for project if its for default project
            reloadedProjects, searchOnlyPotentialSolution, // Delay load if we are searching for solution
            delayReloadedConfiguredProjects);
            if (!ancestor) return;
            if (!ancestor.project.parsedCommandLine && ((_a = project.parsedCommandLine) == null ? void 0 : _a.options.composite)) ancestor.project.setPotentialProjectReference(project.canonicalConfigFilePath);
            const result = cb(ancestor);
            if (result) return result;
            project = ancestor.project;
        }
    }
    function forEachResolvedProjectReferenceProjectLoad(project, parentConfig, cb, kind, reason, allowDeferredClosed, reloadedProjects, seenResolvedRefs) {
        const loadKind = parentConfig.options.disableReferencedProjectLoad ? 0 /* FindOptimized */  : kind;
        let children;
        return forEach(parentConfig.projectReferences, (ref)=>{
            var _a;
            const childConfigName = toNormalizedPath(resolveProjectReferencePath(ref));
            const childCanonicalConfigPath = asNormalizedPath(project.projectService.toCanonicalFileName(childConfigName));
            const seenValue = seenResolvedRefs == null ? void 0 : seenResolvedRefs.get(childCanonicalConfigPath);
            if (seenValue !== void 0 && seenValue >= loadKind) return void 0;
            const configFileExistenceInfo = project.projectService.configFileExistenceInfoCache.get(childCanonicalConfigPath);
            let childConfig = loadKind === 0 /* FindOptimized */  ? (configFileExistenceInfo == null ? void 0 : configFileExistenceInfo.exists) || ((_a = project.resolvedChildConfigs) == null ? void 0 : _a.has(childCanonicalConfigPath)) ? configFileExistenceInfo.config.parsedCommandLine : void 0 : project.getParsedCommandLine(childConfigName);
            if (childConfig && loadKind !== kind && loadKind > 2 /* CreateReplayOptimized */ ) childConfig = project.getParsedCommandLine(childConfigName);
            if (!childConfig) return void 0;
            const childProject = project.projectService.findConfiguredProjectByProjectName(childConfigName, allowDeferredClosed);
            if (loadKind === 2 /* CreateReplayOptimized */  && !configFileExistenceInfo && !childProject) return void 0;
            switch(loadKind){
                case 6 /* ReloadOptimized */ :
                    if (childProject) childProject.projectService.reloadConfiguredProjectOptimized(childProject, reason, reloadedProjects);
                // falls through
                case 4 /* CreateOptimized */ :
                    var _project_resolvedChildConfigs;
                    ((_project_resolvedChildConfigs = project.resolvedChildConfigs) !== null && _project_resolvedChildConfigs !== void 0 ? _project_resolvedChildConfigs : project.resolvedChildConfigs = /* @__PURE__ */ new Set()).add(childCanonicalConfigPath);
                // falls through
                case 2 /* CreateReplayOptimized */ :
                case 0 /* FindOptimized */ :
                    if (childProject || loadKind !== 0 /* FindOptimized */ ) {
                        const result = cb(configFileExistenceInfo !== null && configFileExistenceInfo !== void 0 ? configFileExistenceInfo : project.projectService.configFileExistenceInfoCache.get(childCanonicalConfigPath), childProject, childConfigName, reason, project, childCanonicalConfigPath);
                        if (result) return result;
                    }
                    break;
                default:
                    Debug.assertNever(loadKind);
            }
            (seenResolvedRefs !== null && seenResolvedRefs !== void 0 ? seenResolvedRefs : seenResolvedRefs = /* @__PURE__ */ new Map()).set(childCanonicalConfigPath, loadKind);
            (children !== null && children !== void 0 ? children : children = []).push(childConfig);
        }) || forEach(children, (childConfig)=>childConfig.projectReferences && forEachResolvedProjectReferenceProjectLoad(project, childConfig, cb, loadKind, reason, allowDeferredClosed, reloadedProjects, seenResolvedRefs));
    }
    function updateProjectFoundUsingFind(project, kind, triggerFile, reason, reloadedProjects) {
        let sentConfigFileDiag = false;
        let configFileExistenceInfo;
        switch(kind){
            case 2 /* CreateReplayOptimized */ :
            case 3 /* CreateReplay */ :
                if (useConfigFileExistenceInfoForOptimizedLoading(project)) configFileExistenceInfo = project.projectService.configFileExistenceInfoCache.get(project.canonicalConfigFilePath);
                break;
            case 4 /* CreateOptimized */ :
                configFileExistenceInfo = configFileExistenceInfoForOptimizedLoading(project);
                if (configFileExistenceInfo) break;
            // falls through
            case 5 /* Create */ :
                sentConfigFileDiag = updateConfiguredProject(project, triggerFile);
                break;
            case 6 /* ReloadOptimized */ :
                project.projectService.reloadConfiguredProjectOptimized(project, reason, reloadedProjects);
                configFileExistenceInfo = configFileExistenceInfoForOptimizedLoading(project);
                if (configFileExistenceInfo) break;
            // falls through
            case 7 /* Reload */ :
                sentConfigFileDiag = project.projectService.reloadConfiguredProjectClearingSemanticCache(project, reason, reloadedProjects);
                break;
            case 0 /* FindOptimized */ :
            case 1 /* Find */ :
                break;
            default:
                Debug.assertNever(kind);
        }
        return {
            project,
            sentConfigFileDiag,
            configFileExistenceInfo,
            reason
        };
    }
    function forEachPotentialProjectReference(project, cb) {
        var _ref;
        return project.initialLoadPending ? (_ref = project.potentialProjectReferences && forEachKey(project.potentialProjectReferences, cb)) !== null && _ref !== void 0 ? _ref : project.resolvedChildConfigs && forEachKey(project.resolvedChildConfigs, cb) : void 0;
    }
    function forEachAnyProjectReferenceKind(project, cb, cbProjectRef, cbPotentialProjectRef) {
        return project.getCurrentProgram() ? project.forEachResolvedProjectReference(cb) : project.initialLoadPending ? forEachPotentialProjectReference(project, cbPotentialProjectRef) : forEach(project.getProjectReferences(), cbProjectRef);
    }
    function callbackRefProject(project, cb, refPath) {
        const refProject = refPath && project.projectService.configuredProjects.get(refPath);
        return refProject && cb(refProject);
    }
    function forEachReferencedProject(project, cb) {
        return forEachAnyProjectReferenceKind(project, (resolvedRef)=>callbackRefProject(project, cb, resolvedRef.sourceFile.path), (projectRef)=>callbackRefProject(project, cb, project.toPath(resolveProjectReferencePath(projectRef))), (potentialProjectRef)=>callbackRefProject(project, cb, potentialProjectRef));
    }
    function getDetailWatchInfo(watchType, project) {
        return `${isString(project) ? `Config: ${project} ` : project ? `Project: ${project.getProjectName()} ` : ""}WatchType: ${watchType}`;
    }
    function isScriptInfoWatchedFromNodeModules(info) {
        return !info.isScriptOpen() && info.mTime !== void 0;
    }
    function updateProjectIfDirty(project) {
        project.invalidateResolutionsOfFailedLookupLocations();
        return project.dirty && !project.updateGraph();
    }
    function updateWithTriggerFile(project, triggerFile, isReload) {
        if (!isReload) {
            project.invalidateResolutionsOfFailedLookupLocations();
            if (!project.dirty) return false;
        }
        project.triggerFileForConfigFileDiag = triggerFile;
        const updateLevel = project.pendingUpdateLevel;
        project.updateGraph();
        if (!project.triggerFileForConfigFileDiag && !isReload) return updateLevel === 2 /* Full */ ;
        const sent = project.projectService.sendConfigFileDiagEvent(project, triggerFile, isReload);
        project.triggerFileForConfigFileDiag = void 0;
        return sent;
    }
    function updateConfiguredProject(project, triggerFile) {
        if (triggerFile) {
            if (updateWithTriggerFile(project, triggerFile, /*isReload*/ false)) return true;
        } else updateProjectIfDirty(project);
        return false;
    }
    function configFileExistenceInfoForOptimizedLoading(project) {
        const configFileName = toNormalizedPath(project.getConfigFilePath());
        const configFileExistenceInfo = project.projectService.ensureParsedConfigUptoDate(configFileName, project.canonicalConfigFilePath, project.projectService.configFileExistenceInfoCache.get(project.canonicalConfigFilePath), project);
        const parsedCommandLine = configFileExistenceInfo.config.parsedCommandLine;
        project.parsedCommandLine = parsedCommandLine;
        project.resolvedChildConfigs = void 0;
        project.updateReferences(parsedCommandLine.projectReferences);
        if (useConfigFileExistenceInfoForOptimizedLoading(project)) return configFileExistenceInfo;
    }
    function useConfigFileExistenceInfoForOptimizedLoading(project) {
        return !!project.parsedCommandLine && (!!project.parsedCommandLine.options.composite || // If solution, no need to load it to determine if file belongs to it
        !!isSolutionConfig(project.parsedCommandLine));
    }
    function configFileExistenceInfoForOptimizedReplay(project) {
        return useConfigFileExistenceInfoForOptimizedLoading(project) ? project.projectService.configFileExistenceInfoCache.get(project.canonicalConfigFilePath) : void 0;
    }
    function fileOpenReason(info) {
        return `Creating possible configured project for ${info.fileName} to open`;
    }
    function reloadReason(reason) {
        return `User requested reload projects: ${reason}`;
    }
    function setProjectOptionsUsed(project) {
        if (isConfiguredProject(project)) project.projectOptions = true;
    }
    function createProjectNameFactoryWithCounter(nameFactory) {
        let nextId = 1;
        return ()=>nameFactory(nextId++);
    }
    function getHostWatcherMap() {
        return {
            idToCallbacks: /* @__PURE__ */ new Map(),
            pathToId: /* @__PURE__ */ new Map()
        };
    }
    function getCanUseWatchEvents(service, canUseWatchEvents) {
        return !!canUseWatchEvents && !!service.eventHandler && !!service.session;
    }
    function createWatchFactoryHostUsingWatchEvents(service, canUseWatchEvents) {
        if (!getCanUseWatchEvents(service, canUseWatchEvents)) return void 0;
        const watchedFiles = getHostWatcherMap();
        const watchedDirectories = getHostWatcherMap();
        const watchedDirectoriesRecursive = getHostWatcherMap();
        let ids = 1;
        service.session.addProtocolHandler("watchChange" /* WatchChange */ , (req)=>{
            onWatchChange(req.arguments);
            return {
                responseRequired: false
            };
        });
        return {
            watchFile: watchFile2,
            watchDirectory,
            getCurrentDirectory: ()=>service.host.getCurrentDirectory(),
            useCaseSensitiveFileNames: service.host.useCaseSensitiveFileNames
        };
        function watchFile2(path, callback) {
            return getOrCreateFileWatcher(watchedFiles, path, callback, (id)=>({
                    eventName: CreateFileWatcherEvent,
                    data: {
                        id,
                        path
                    }
                }));
        }
        function watchDirectory(path, callback, recursive) {
            return getOrCreateFileWatcher(recursive ? watchedDirectoriesRecursive : watchedDirectories, path, callback, (id)=>({
                    eventName: CreateDirectoryWatcherEvent,
                    data: {
                        id,
                        path,
                        recursive: !!recursive,
                        // Special case node_modules as we watch it for changes to closed script infos as well
                        ignoreUpdate: !path.endsWith("/node_modules") ? true : void 0
                    }
                }));
        }
        function getOrCreateFileWatcher({ pathToId, idToCallbacks }, path, callback, event) {
            const key = service.toPath(path);
            let id = pathToId.get(key);
            if (!id) pathToId.set(key, id = ids++);
            let callbacks = idToCallbacks.get(id);
            if (!callbacks) {
                idToCallbacks.set(id, callbacks = /* @__PURE__ */ new Set());
                service.eventHandler(event(id));
            }
            callbacks.add(callback);
            return {
                close () {
                    const callbacks2 = idToCallbacks.get(id);
                    if (!(callbacks2 == null ? void 0 : callbacks2.delete(callback))) return;
                    if (callbacks2.size) return;
                    idToCallbacks.delete(id);
                    pathToId.delete(key);
                    service.eventHandler({
                        eventName: CloseFileWatcherEvent,
                        data: {
                            id
                        }
                    });
                }
            };
        }
        function onWatchChange(args) {
            if (isArray(args)) args.forEach(onWatchChangeRequestArgs);
            else onWatchChangeRequestArgs(args);
        }
        function onWatchChangeRequestArgs({ id, created, deleted, updated }) {
            onWatchEventType(id, created, 0 /* Created */ );
            onWatchEventType(id, deleted, 2 /* Deleted */ );
            onWatchEventType(id, updated, 1 /* Changed */ );
        }
        function onWatchEventType(id, paths, eventKind) {
            if (!(paths == null ? void 0 : paths.length)) return;
            forEachCallback(watchedFiles, id, paths, (callback, eventPath)=>callback(eventPath, eventKind));
            forEachCallback(watchedDirectories, id, paths, (callback, eventPath)=>callback(eventPath));
            forEachCallback(watchedDirectoriesRecursive, id, paths, (callback, eventPath)=>callback(eventPath));
        }
        function forEachCallback(hostWatcherMap, id, eventPaths, cb) {
            var _a;
            (_a = hostWatcherMap.idToCallbacks.get(id)) == null || _a.forEach((callback)=>{
                eventPaths.forEach((eventPath)=>cb(callback, normalizeSlashes(eventPath)));
            });
        }
    }
    var _ProjectService = class _ProjectService {
        toPath(fileName) {
            return toPath(fileName, this.currentDirectory, this.toCanonicalFileName);
        }
        /** @internal */ getExecutingFilePath() {
            return this.getNormalizedAbsolutePath(this.host.getExecutingFilePath());
        }
        /** @internal */ getNormalizedAbsolutePath(fileName) {
            return getNormalizedAbsolutePath(fileName, this.host.getCurrentDirectory());
        }
        /** @internal */ setDocument(key, path, sourceFile) {
            const info = Debug.checkDefined(this.getScriptInfoForPath(path));
            info.cacheSourceFile = {
                key,
                sourceFile
            };
        }
        /** @internal */ getDocument(key, path) {
            const info = this.getScriptInfoForPath(path);
            return info && info.cacheSourceFile && info.cacheSourceFile.key === key ? info.cacheSourceFile.sourceFile : void 0;
        }
        /** @internal */ ensureInferredProjectsUpToDate_TestOnly() {
            this.ensureProjectStructuresUptoDate();
        }
        /** @internal */ getCompilerOptionsForInferredProjects() {
            return this.compilerOptionsForInferredProjects;
        }
        /** @internal */ onUpdateLanguageServiceStateForProject(project, languageServiceEnabled) {
            if (!this.eventHandler) return;
            const event = {
                eventName: ProjectLanguageServiceStateEvent,
                data: {
                    project,
                    languageServiceEnabled
                }
            };
            this.eventHandler(event);
        }
        loadTypesMap() {
            try {
                const fileContent = this.host.readFile(this.typesMapLocation);
                if (fileContent === void 0) {
                    this.logger.info(`Provided types map file "${this.typesMapLocation}" doesn't exist`);
                    return;
                }
                const raw = JSON.parse(fileContent);
                for (const k of Object.keys(raw.typesMap))raw.typesMap[k].match = new RegExp(raw.typesMap[k].match, "i");
                this.safelist = raw.typesMap;
                for(const key in raw.simpleMap)if (hasProperty(raw.simpleMap, key)) this.legacySafelist.set(key, raw.simpleMap[key].toLowerCase());
            } catch (e) {
                this.logger.info(`Error loading types map: ${e}`);
                this.safelist = defaultTypeSafeList;
                this.legacySafelist.clear();
            }
        }
        // eslint-disable-line @typescript-eslint/unified-signatures
        updateTypingsForProject(response) {
            const project = this.findProject(response.projectName);
            if (!project) return;
            switch(response.kind){
                case ActionSet:
                    project.updateTypingFiles(response.compilerOptions, response.typeAcquisition, response.unresolvedImports, response.typings);
                    return;
                case ActionInvalidate:
                    project.enqueueInstallTypingsForProject(/*forceRefresh*/ true);
                    return;
            }
        }
        /** @internal */ watchTypingLocations(response) {
            var _a;
            (_a = this.findProject(response.projectName)) == null || _a.watchTypingLocations(response.files);
        }
        /** @internal */ delayEnsureProjectForOpenFiles() {
            if (!this.openFiles.size) return;
            this.pendingEnsureProjectForOpenFiles = true;
            this.throttledOperations.schedule(ensureProjectForOpenFileSchedule, /*delay*/ 2500, ()=>{
                if (this.pendingProjectUpdates.size !== 0) this.delayEnsureProjectForOpenFiles();
                else if (this.pendingEnsureProjectForOpenFiles) {
                    this.ensureProjectForOpenFiles();
                    this.sendProjectsUpdatedInBackgroundEvent();
                }
            });
        }
        delayUpdateProjectGraph(project) {
            if (isProjectDeferredClose(project)) return;
            project.markAsDirty();
            if (isBackgroundProject(project)) return;
            const projectName = project.getProjectName();
            this.pendingProjectUpdates.set(projectName, project);
            this.throttledOperations.schedule(projectName, /*delay*/ 250, ()=>{
                if (this.pendingProjectUpdates.delete(projectName)) updateProjectIfDirty(project);
            });
        }
        /** @internal */ hasPendingProjectUpdate(project) {
            return this.pendingProjectUpdates.has(project.getProjectName());
        }
        /** @internal */ sendProjectsUpdatedInBackgroundEvent() {
            if (!this.eventHandler) return;
            const event = {
                eventName: ProjectsUpdatedInBackgroundEvent,
                data: {
                    openFiles: arrayFrom(this.openFiles.keys(), (path)=>this.getScriptInfoForPath(path).fileName)
                }
            };
            this.eventHandler(event);
        }
        /** @internal */ sendLargeFileReferencedEvent(file, fileSize) {
            if (!this.eventHandler) return;
            const event = {
                eventName: LargeFileReferencedEvent,
                data: {
                    file,
                    fileSize,
                    maxFileSize
                }
            };
            this.eventHandler(event);
        }
        /** @internal */ sendProjectLoadingStartEvent(project, reason) {
            if (!this.eventHandler) return;
            project.sendLoadingProjectFinish = true;
            const event = {
                eventName: ProjectLoadingStartEvent,
                data: {
                    project,
                    reason
                }
            };
            this.eventHandler(event);
        }
        /** @internal */ sendProjectLoadingFinishEvent(project) {
            if (!this.eventHandler || !project.sendLoadingProjectFinish) return;
            project.sendLoadingProjectFinish = false;
            const event = {
                eventName: ProjectLoadingFinishEvent,
                data: {
                    project
                }
            };
            this.eventHandler(event);
        }
        /** @internal */ sendPerformanceEvent(kind, durationMs) {
            if (this.performanceEventHandler) this.performanceEventHandler({
                kind,
                durationMs
            });
        }
        /** @internal */ delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(project) {
            this.delayUpdateProjectGraph(project);
            this.delayEnsureProjectForOpenFiles();
        }
        delayUpdateProjectGraphs(projects, clearSourceMapperCache) {
            if (projects.length) {
                for (const project of projects){
                    if (clearSourceMapperCache) project.clearSourceMapperCache();
                    this.delayUpdateProjectGraph(project);
                }
                this.delayEnsureProjectForOpenFiles();
            }
        }
        setCompilerOptionsForInferredProjects(projectCompilerOptions, projectRootPath) {
            Debug.assert(projectRootPath === void 0 || this.useInferredProjectPerProjectRoot, "Setting compiler options per project root path is only supported when useInferredProjectPerProjectRoot is enabled");
            const compilerOptions = convertCompilerOptions(projectCompilerOptions);
            const watchOptions = convertWatchOptions(projectCompilerOptions, projectRootPath);
            const typeAcquisition = convertTypeAcquisition(projectCompilerOptions);
            compilerOptions.allowNonTsExtensions = true;
            const canonicalProjectRootPath = projectRootPath && this.toCanonicalFileName(projectRootPath);
            if (canonicalProjectRootPath) {
                this.compilerOptionsForInferredProjectsPerProjectRoot.set(canonicalProjectRootPath, compilerOptions);
                this.watchOptionsForInferredProjectsPerProjectRoot.set(canonicalProjectRootPath, watchOptions || false);
                this.typeAcquisitionForInferredProjectsPerProjectRoot.set(canonicalProjectRootPath, typeAcquisition);
            } else {
                this.compilerOptionsForInferredProjects = compilerOptions;
                this.watchOptionsForInferredProjects = watchOptions;
                this.typeAcquisitionForInferredProjects = typeAcquisition;
            }
            for (const project of this.inferredProjects)if (canonicalProjectRootPath ? project.projectRootPath === canonicalProjectRootPath : !project.projectRootPath || !this.compilerOptionsForInferredProjectsPerProjectRoot.has(project.projectRootPath)) {
                project.setCompilerOptions(compilerOptions);
                project.setTypeAcquisition(typeAcquisition);
                project.setWatchOptions(watchOptions == null ? void 0 : watchOptions.watchOptions);
                project.setProjectErrors(watchOptions == null ? void 0 : watchOptions.errors);
                project.compileOnSaveEnabled = compilerOptions.compileOnSave;
                project.markAsDirty();
                this.delayUpdateProjectGraph(project);
            }
            this.delayEnsureProjectForOpenFiles();
        }
        findProject(projectName) {
            if (projectName === void 0) return void 0;
            if (isInferredProjectName(projectName)) return findProjectByName(projectName, this.inferredProjects);
            return this.findExternalProjectByProjectName(projectName) || this.findConfiguredProjectByProjectName(toNormalizedPath(projectName));
        }
        /** @internal */ forEachProject(cb) {
            this.externalProjects.forEach(cb);
            this.configuredProjects.forEach(cb);
            this.inferredProjects.forEach(cb);
        }
        /** @internal */ forEachEnabledProject(cb) {
            this.forEachProject((project)=>{
                if (!project.isOrphan() && project.languageServiceEnabled) cb(project);
            });
        }
        getDefaultProjectForFile(fileName, ensureProject) {
            return ensureProject ? this.ensureDefaultProjectForFile(fileName) : this.tryGetDefaultProjectForFile(fileName);
        }
        /** @internal */ tryGetDefaultProjectForFile(fileNameOrScriptInfo) {
            const scriptInfo = isString(fileNameOrScriptInfo) ? this.getScriptInfoForNormalizedPath(fileNameOrScriptInfo) : fileNameOrScriptInfo;
            return scriptInfo && !scriptInfo.isOrphan() ? scriptInfo.getDefaultProject() : void 0;
        }
        /**
   * If there is default project calculation pending for this file,
   * then it completes that calculation so that correct default project is used for the project
   */ tryGetDefaultProjectForEnsuringConfiguredProjectForFile(fileNameOrScriptInfo) {
            var _a;
            const scriptInfo = isString(fileNameOrScriptInfo) ? this.getScriptInfoForNormalizedPath(fileNameOrScriptInfo) : fileNameOrScriptInfo;
            if (!scriptInfo) return void 0;
            if ((_a = this.pendingOpenFileProjectUpdates) == null ? void 0 : _a.delete(scriptInfo.path)) {
                this.tryFindDefaultConfiguredProjectAndLoadAncestorsForOpenScriptInfo(scriptInfo, 5 /* Create */ );
                if (scriptInfo.isOrphan()) this.assignOrphanScriptInfoToInferredProject(scriptInfo, this.openFiles.get(scriptInfo.path));
            }
            return this.tryGetDefaultProjectForFile(scriptInfo);
        }
        /** @internal */ ensureDefaultProjectForFile(fileNameOrScriptInfo) {
            return this.tryGetDefaultProjectForEnsuringConfiguredProjectForFile(fileNameOrScriptInfo) || this.doEnsureDefaultProjectForFile(fileNameOrScriptInfo);
        }
        doEnsureDefaultProjectForFile(fileNameOrScriptInfo) {
            this.ensureProjectStructuresUptoDate();
            const scriptInfo = isString(fileNameOrScriptInfo) ? this.getScriptInfoForNormalizedPath(fileNameOrScriptInfo) : fileNameOrScriptInfo;
            return scriptInfo ? scriptInfo.getDefaultProject() : (this.logErrorForScriptInfoNotFound(isString(fileNameOrScriptInfo) ? fileNameOrScriptInfo : fileNameOrScriptInfo.fileName), Errors.ThrowNoProject());
        }
        getScriptInfoEnsuringProjectsUptoDate(uncheckedFileName) {
            this.ensureProjectStructuresUptoDate();
            return this.getScriptInfo(uncheckedFileName);
        }
        /**
   * Ensures the project structures are upto date
   * This means,
   * - we go through all the projects and update them if they are dirty
   * - if updates reflect some change in structure or there was pending request to ensure projects for open files
   *   ensure that each open script info has project
   */ ensureProjectStructuresUptoDate() {
            let hasChanges = this.pendingEnsureProjectForOpenFiles;
            this.pendingProjectUpdates.clear();
            const updateGraph = (project)=>{
                hasChanges = updateProjectIfDirty(project) || hasChanges;
            };
            this.externalProjects.forEach(updateGraph);
            this.configuredProjects.forEach(updateGraph);
            this.inferredProjects.forEach(updateGraph);
            if (hasChanges) this.ensureProjectForOpenFiles();
        }
        getFormatCodeOptions(file) {
            const info = this.getScriptInfoForNormalizedPath(file);
            return info && info.getFormatCodeSettings() || this.hostConfiguration.formatCodeOptions;
        }
        getPreferences(file) {
            const info = this.getScriptInfoForNormalizedPath(file);
            return (0, _objectSpread._)({}, this.hostConfiguration.preferences, info && info.getPreferences());
        }
        getHostFormatCodeOptions() {
            return this.hostConfiguration.formatCodeOptions;
        }
        getHostPreferences() {
            return this.hostConfiguration.preferences;
        }
        onSourceFileChanged(info, eventKind) {
            Debug.assert(!info.isScriptOpen());
            if (eventKind === 2 /* Deleted */ ) this.handleDeletedFile(info, /*deferredDelete*/ true);
            else {
                if (info.deferredDelete) info.deferredDelete = void 0;
                info.delayReloadNonMixedContentFile();
                this.delayUpdateProjectGraphs(info.containingProjects, /*clearSourceMapperCache*/ false);
                this.handleSourceMapProjects(info);
            }
        }
        handleSourceMapProjects(info) {
            if (info.sourceMapFilePath) {
                if (isString(info.sourceMapFilePath)) {
                    const sourceMapFileInfo = this.getScriptInfoForPath(info.sourceMapFilePath);
                    this.delayUpdateSourceInfoProjects(sourceMapFileInfo == null ? void 0 : sourceMapFileInfo.sourceInfos);
                } else this.delayUpdateSourceInfoProjects(info.sourceMapFilePath.sourceInfos);
            }
            this.delayUpdateSourceInfoProjects(info.sourceInfos);
            if (info.declarationInfoPath) this.delayUpdateProjectsOfScriptInfoPath(info.declarationInfoPath);
        }
        delayUpdateSourceInfoProjects(sourceInfos) {
            if (sourceInfos) sourceInfos.forEach((_value, path)=>this.delayUpdateProjectsOfScriptInfoPath(path));
        }
        delayUpdateProjectsOfScriptInfoPath(path) {
            const info = this.getScriptInfoForPath(path);
            if (info) this.delayUpdateProjectGraphs(info.containingProjects, /*clearSourceMapperCache*/ true);
        }
        handleDeletedFile(info, deferredDelete) {
            Debug.assert(!info.isScriptOpen());
            this.delayUpdateProjectGraphs(info.containingProjects, /*clearSourceMapperCache*/ false);
            this.handleSourceMapProjects(info);
            info.detachAllProjects();
            if (deferredDelete) {
                info.delayReloadNonMixedContentFile();
                info.deferredDelete = true;
            } else this.deleteScriptInfo(info);
        }
        /**
   * This is to watch whenever files are added or removed to the wildcard directories
   */ watchWildcardDirectory(directory, flags, configFileName, config) {
            let watcher = this.watchFactory.watchDirectory(directory, (fileOrDirectory)=>this.onWildCardDirectoryWatcherInvoke(directory, configFileName, config, result, fileOrDirectory), flags, this.getWatchOptionsFromProjectWatchOptions(config.parsedCommandLine.watchOptions, getDirectoryPath(configFileName)), WatchType.WildcardDirectory, configFileName);
            const result = {
                packageJsonWatches: void 0,
                close () {
                    var _a;
                    if (watcher) {
                        watcher.close();
                        watcher = void 0;
                        (_a = result.packageJsonWatches) == null || _a.forEach((watcher2)=>{
                            watcher2.projects.delete(result);
                            watcher2.close();
                        });
                        result.packageJsonWatches = void 0;
                    }
                }
            };
            return result;
        }
        onWildCardDirectoryWatcherInvoke(directory, configFileName, config, wildCardWatcher, fileOrDirectory) {
            const fileOrDirectoryPath = this.toPath(fileOrDirectory);
            const fsResult = config.cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
            if (getBaseFileName(fileOrDirectoryPath) === "package.json" && !isInsideNodeModules(fileOrDirectoryPath) && (fsResult && fsResult.fileExists || !fsResult && this.host.fileExists(fileOrDirectory))) {
                const file = this.getNormalizedAbsolutePath(fileOrDirectory);
                this.logger.info(`Config: ${configFileName} Detected new package.json: ${file}`);
                this.packageJsonCache.addOrUpdate(file, fileOrDirectoryPath);
                this.watchPackageJsonFile(file, fileOrDirectoryPath, wildCardWatcher);
            }
            if (!(fsResult == null ? void 0 : fsResult.fileExists)) this.sendSourceFileChange(fileOrDirectoryPath);
            const configuredProjectForConfig = this.findConfiguredProjectByProjectName(configFileName);
            if (isIgnoredFileFromWildCardWatching({
                watchedDirPath: this.toPath(directory),
                fileOrDirectory,
                fileOrDirectoryPath,
                configFileName,
                extraFileExtensions: this.hostConfiguration.extraFileExtensions,
                currentDirectory: this.currentDirectory,
                options: config.parsedCommandLine.options,
                program: (configuredProjectForConfig == null ? void 0 : configuredProjectForConfig.getCurrentProgram()) || config.parsedCommandLine.fileNames,
                useCaseSensitiveFileNames: this.host.useCaseSensitiveFileNames,
                writeLog: (s)=>this.logger.info(s),
                toPath: (s)=>this.toPath(s),
                getScriptKind: configuredProjectForConfig ? (fileName)=>configuredProjectForConfig.getScriptKind(fileName) : void 0
            })) return;
            if (config.updateLevel !== 2 /* Full */ ) config.updateLevel = 1 /* RootNamesAndUpdate */ ;
            config.projects.forEach((watchWildcardDirectories, projectCanonicalPath)=>{
                var _a;
                if (!watchWildcardDirectories) return;
                const project = this.getConfiguredProjectByCanonicalConfigFilePath(projectCanonicalPath);
                if (!project) return;
                if (configuredProjectForConfig !== project && this.getHostPreferences().includeCompletionsForModuleExports) {
                    const path = this.toPath(configFileName);
                    if (find((_a = project.getCurrentProgram()) == null ? void 0 : _a.getResolvedProjectReferences(), (ref)=>(ref == null ? void 0 : ref.sourceFile.path) === path)) project.markAutoImportProviderAsDirty();
                }
                const updateLevel = configuredProjectForConfig === project ? 1 /* RootNamesAndUpdate */  : 0 /* Update */ ;
                if (project.pendingUpdateLevel > updateLevel) return;
                if (this.openFiles.has(fileOrDirectoryPath)) {
                    const info = Debug.checkDefined(this.getScriptInfoForPath(fileOrDirectoryPath));
                    if (info.isAttached(project)) {
                        const loadLevelToSet = Math.max(updateLevel, project.openFileWatchTriggered.get(fileOrDirectoryPath) || 0 /* Update */ );
                        project.openFileWatchTriggered.set(fileOrDirectoryPath, loadLevelToSet);
                    } else {
                        project.pendingUpdateLevel = updateLevel;
                        this.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(project);
                    }
                } else {
                    project.pendingUpdateLevel = updateLevel;
                    this.delayUpdateProjectGraphAndEnsureProjectStructureForOpenFiles(project);
                }
            });
        }
        delayUpdateProjectsFromParsedConfigOnConfigFileChange(canonicalConfigFilePath, loadReason) {
            const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            if (!(configFileExistenceInfo == null ? void 0 : configFileExistenceInfo.config)) return false;
            let scheduledAnyProjectUpdate = false;
            configFileExistenceInfo.config.updateLevel = 2 /* Full */ ;
            configFileExistenceInfo.config.cachedDirectoryStructureHost.clearCache();
            configFileExistenceInfo.config.projects.forEach((_watchWildcardDirectories, projectCanonicalPath)=>{
                var _a, _b, _c;
                const project = this.getConfiguredProjectByCanonicalConfigFilePath(projectCanonicalPath);
                if (!project) return;
                scheduledAnyProjectUpdate = true;
                if (projectCanonicalPath === canonicalConfigFilePath) {
                    if (project.initialLoadPending) return;
                    project.pendingUpdateLevel = 2 /* Full */ ;
                    project.pendingUpdateReason = loadReason;
                    this.delayUpdateProjectGraph(project);
                    project.markAutoImportProviderAsDirty();
                } else {
                    if (project.initialLoadPending) {
                        (_b = (_a = this.configFileExistenceInfoCache.get(projectCanonicalPath)) == null ? void 0 : _a.openFilesImpactedByConfigFile) == null || _b.forEach((path2)=>{
                            var _a2;
                            var _this_pendingOpenFileProjectUpdates;
                            if (!((_a2 = this.pendingOpenFileProjectUpdates) == null ? void 0 : _a2.has(path2))) ((_this_pendingOpenFileProjectUpdates = this.pendingOpenFileProjectUpdates) !== null && _this_pendingOpenFileProjectUpdates !== void 0 ? _this_pendingOpenFileProjectUpdates : this.pendingOpenFileProjectUpdates = /* @__PURE__ */ new Map()).set(path2, this.configFileForOpenFiles.get(path2));
                        });
                        return;
                    }
                    const path = this.toPath(canonicalConfigFilePath);
                    project.resolutionCache.removeResolutionsFromProjectReferenceRedirects(path);
                    this.delayUpdateProjectGraph(project);
                    if (this.getHostPreferences().includeCompletionsForModuleExports && find((_c = project.getCurrentProgram()) == null ? void 0 : _c.getResolvedProjectReferences(), (ref)=>(ref == null ? void 0 : ref.sourceFile.path) === path)) project.markAutoImportProviderAsDirty();
                }
            });
            return scheduledAnyProjectUpdate;
        }
        onConfigFileChanged(configFileName, canonicalConfigFilePath, eventKind) {
            const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            const project = this.getConfiguredProjectByCanonicalConfigFilePath(canonicalConfigFilePath);
            const wasDefferedClose = project == null ? void 0 : project.deferredClose;
            if (eventKind === 2 /* Deleted */ ) {
                configFileExistenceInfo.exists = false;
                if (project) project.deferredClose = true;
            } else {
                configFileExistenceInfo.exists = true;
                if (wasDefferedClose) {
                    project.deferredClose = void 0;
                    project.markAsDirty();
                }
            }
            this.delayUpdateProjectsFromParsedConfigOnConfigFileChange(canonicalConfigFilePath, "Change in config file detected");
            this.openFiles.forEach((_projectRootPath, path)=>{
                var _a, _b;
                const configFileForOpenFile = this.configFileForOpenFiles.get(path);
                if (!((_a = configFileExistenceInfo.openFilesImpactedByConfigFile) == null ? void 0 : _a.has(path))) return;
                this.configFileForOpenFiles.delete(path);
                const info = this.getScriptInfoForPath(path);
                const newConfigFileNameForInfo = this.getConfigFileNameForFile(info, /*findFromCacheOnly*/ false);
                if (!newConfigFileNameForInfo) return;
                var _this_pendingOpenFileProjectUpdates;
                if (!((_b = this.pendingOpenFileProjectUpdates) == null ? void 0 : _b.has(path))) ((_this_pendingOpenFileProjectUpdates = this.pendingOpenFileProjectUpdates) !== null && _this_pendingOpenFileProjectUpdates !== void 0 ? _this_pendingOpenFileProjectUpdates : this.pendingOpenFileProjectUpdates = /* @__PURE__ */ new Map()).set(path, configFileForOpenFile);
            });
            this.delayEnsureProjectForOpenFiles();
        }
        removeProject(project) {
            this.logger.info("`remove Project::");
            project.print(/*writeProjectFileNames*/ true, /*writeFileExplaination*/ true, /*writeFileVersionAndText*/ false);
            project.close();
            if (Debug.shouldAssert(1 /* Normal */ )) this.filenameToScriptInfo.forEach((info)=>Debug.assert(!info.isAttached(project), "Found script Info still attached to project", ()=>`${project.projectName}: ScriptInfos still attached: ${JSON.stringify(arrayFrom(mapDefinedIterator(this.filenameToScriptInfo.values(), (info2)=>info2.isAttached(project) ? {
                            fileName: info2.fileName,
                            projects: info2.containingProjects.map((p)=>p.projectName),
                            hasMixedContent: info2.hasMixedContent
                        } : void 0)), /*replacer*/ void 0, " ")}`));
            this.pendingProjectUpdates.delete(project.getProjectName());
            switch(project.projectKind){
                case 2 /* External */ :
                    unorderedRemoveItem(this.externalProjects, project);
                    this.projectToSizeMap.delete(project.getProjectName());
                    break;
                case 1 /* Configured */ :
                    this.configuredProjects.delete(project.canonicalConfigFilePath);
                    this.projectToSizeMap.delete(project.canonicalConfigFilePath);
                    break;
                case 0 /* Inferred */ :
                    unorderedRemoveItem(this.inferredProjects, project);
                    break;
            }
        }
        /** @internal */ assignOrphanScriptInfoToInferredProject(info, projectRootPath) {
            Debug.assert(info.isOrphan());
            const project = this.getOrCreateInferredProjectForProjectRootPathIfEnabled(info, projectRootPath) || this.getOrCreateSingleInferredProjectIfEnabled() || this.getOrCreateSingleInferredWithoutProjectRoot(info.isDynamic ? projectRootPath || this.currentDirectory : getDirectoryPath(isRootedDiskPath(info.fileName) ? info.fileName : getNormalizedAbsolutePath(info.fileName, projectRootPath ? this.getNormalizedAbsolutePath(projectRootPath) : this.currentDirectory)));
            project.addRoot(info);
            if (info.containingProjects[0] !== project) {
                orderedRemoveItem(info.containingProjects, project);
                info.containingProjects.unshift(project);
            }
            project.updateGraph();
            if (!this.useSingleInferredProject && !project.projectRootPath) for (const inferredProject of this.inferredProjects){
                if (inferredProject === project || inferredProject.isOrphan()) continue;
                const roots = inferredProject.getRootScriptInfos();
                Debug.assert(roots.length === 1 || !!inferredProject.projectRootPath);
                if (roots.length === 1 && forEach(roots[0].containingProjects, (p)=>p !== roots[0].containingProjects[0] && !p.isOrphan())) inferredProject.removeFile(roots[0], /*fileExists*/ true, /*detachFromProject*/ true);
            }
            return project;
        }
        assignOrphanScriptInfosToInferredProject() {
            this.openFiles.forEach((projectRootPath, path)=>{
                const info = this.getScriptInfoForPath(path);
                if (info.isOrphan()) this.assignOrphanScriptInfoToInferredProject(info, projectRootPath);
            });
        }
        /**
   * Remove this file from the set of open, non-configured files.
   * @param info The file that has been closed or newly configured
   */ closeOpenFile(info, skipAssignOrphanScriptInfosToInferredProject) {
            var _a;
            const fileExists = info.isDynamic ? false : this.host.fileExists(info.fileName);
            info.close(fileExists);
            this.stopWatchingConfigFilesForScriptInfo(info);
            const canonicalFileName = this.toCanonicalFileName(info.fileName);
            if (this.openFilesWithNonRootedDiskPath.get(canonicalFileName) === info) this.openFilesWithNonRootedDiskPath.delete(canonicalFileName);
            let ensureProjectsForOpenFiles = false;
            for (const p of info.containingProjects){
                if (isConfiguredProject(p)) {
                    if (info.hasMixedContent) info.registerFileUpdate();
                    const updateLevel = p.openFileWatchTriggered.get(info.path);
                    if (updateLevel !== void 0) {
                        p.openFileWatchTriggered.delete(info.path);
                        if (p.pendingUpdateLevel < updateLevel) {
                            p.pendingUpdateLevel = updateLevel;
                            p.markFileAsDirty(info.path);
                        }
                    }
                } else if (isInferredProject(p) && p.isRoot(info)) {
                    if (p.isProjectWithSingleRoot()) ensureProjectsForOpenFiles = true;
                    p.removeFile(info, fileExists, /*detachFromProject*/ true);
                }
                if (!p.languageServiceEnabled) p.markAsDirty();
            }
            this.openFiles.delete(info.path);
            this.configFileForOpenFiles.delete(info.path);
            (_a = this.pendingOpenFileProjectUpdates) == null || _a.delete(info.path);
            Debug.assert(!this.rootOfInferredProjects.has(info));
            if (!skipAssignOrphanScriptInfosToInferredProject && ensureProjectsForOpenFiles) this.assignOrphanScriptInfosToInferredProject();
            if (fileExists) this.watchClosedScriptInfo(info);
            else this.handleDeletedFile(info, /*deferredDelete*/ false);
            return ensureProjectsForOpenFiles;
        }
        deleteScriptInfo(info) {
            Debug.assert(!info.isScriptOpen());
            this.filenameToScriptInfo.delete(info.path);
            this.filenameToScriptInfoVersion.set(info.path, info.textStorage.version);
            this.stopWatchingScriptInfo(info);
            const realpath = info.getRealpathIfDifferent();
            if (realpath) this.realpathToScriptInfos.remove(realpath, info);
            info.closeSourceMapFileWatcher();
        }
        configFileExists(configFileName, canonicalConfigFilePath, info) {
            const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            let openFilesImpactedByConfigFile;
            if (this.openFiles.has(info.path) && (!isAncestorConfigFileInfo(info) || info.isForDefaultProject)) {
                var _configFileExistenceInfo_openFilesImpactedByConfigFile;
                if (configFileExistenceInfo) ((_configFileExistenceInfo_openFilesImpactedByConfigFile = configFileExistenceInfo.openFilesImpactedByConfigFile) !== null && _configFileExistenceInfo_openFilesImpactedByConfigFile !== void 0 ? _configFileExistenceInfo_openFilesImpactedByConfigFile : configFileExistenceInfo.openFilesImpactedByConfigFile = /* @__PURE__ */ new Set()).add(info.path);
                else (openFilesImpactedByConfigFile = /* @__PURE__ */ new Set()).add(info.path);
            }
            if (configFileExistenceInfo) return configFileExistenceInfo.exists;
            const exists = this.host.fileExists(configFileName);
            this.configFileExistenceInfoCache.set(canonicalConfigFilePath, {
                exists,
                openFilesImpactedByConfigFile
            });
            return exists;
        }
        createConfigFileWatcherForParsedConfig(configFileName, canonicalConfigFilePath, forProject) {
            var _a, _b;
            const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            if (!configFileExistenceInfo.watcher || configFileExistenceInfo.watcher === noopConfigFileWatcher) configFileExistenceInfo.watcher = this.watchFactory.watchFile(configFileName, (_fileName, eventKind)=>this.onConfigFileChanged(configFileName, canonicalConfigFilePath, eventKind), 2e3 /* High */ , this.getWatchOptionsFromProjectWatchOptions((_b = (_a = configFileExistenceInfo == null ? void 0 : configFileExistenceInfo.config) == null ? void 0 : _a.parsedCommandLine) == null ? void 0 : _b.watchOptions, getDirectoryPath(configFileName)), WatchType.ConfigFile, forProject);
            this.ensureConfigFileWatcherForProject(configFileExistenceInfo, forProject);
        }
        ensureConfigFileWatcherForProject(configFileExistenceInfo, forProject) {
            const projects = configFileExistenceInfo.config.projects;
            projects.set(forProject.canonicalConfigFilePath, projects.get(forProject.canonicalConfigFilePath) || false);
        }
        /** @internal */ releaseParsedConfig(canonicalConfigFilePath, forProject) {
            var _a, _b, _c;
            const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            if (!((_a = configFileExistenceInfo.config) == null ? void 0 : _a.projects.delete(forProject.canonicalConfigFilePath))) return;
            if ((_b = configFileExistenceInfo.config) == null ? void 0 : _b.projects.size) return;
            configFileExistenceInfo.config = void 0;
            clearSharedExtendedConfigFileWatcher(canonicalConfigFilePath, this.sharedExtendedConfigFileWatchers);
            Debug.checkDefined(configFileExistenceInfo.watcher);
            if ((_c = configFileExistenceInfo.openFilesImpactedByConfigFile) == null ? void 0 : _c.size) {
                if (configFileExistenceInfo.inferredProjectRoots) {
                    if (!canWatchDirectoryOrFilePath(getDirectoryPath(canonicalConfigFilePath))) {
                        configFileExistenceInfo.watcher.close();
                        configFileExistenceInfo.watcher = noopConfigFileWatcher;
                    }
                } else {
                    configFileExistenceInfo.watcher.close();
                    configFileExistenceInfo.watcher = void 0;
                }
            } else {
                configFileExistenceInfo.watcher.close();
                this.configFileExistenceInfoCache.delete(canonicalConfigFilePath);
            }
        }
        /**
   * This is called on file close or when its removed from inferred project as root,
   * so that we handle the watches and inferred project root data
   * @internal
   */ stopWatchingConfigFilesForScriptInfo(info) {
            if (this.serverMode !== 0 /* Semantic */ ) return;
            const isRootOfInferredProject = this.rootOfInferredProjects.delete(info);
            const isOpen = info.isScriptOpen();
            if (isOpen && !isRootOfInferredProject) return;
            this.forEachConfigFileLocation(info, (canonicalConfigFilePath)=>{
                var _a, _b, _c;
                const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
                if (!configFileExistenceInfo) return;
                if (isOpen) {
                    if (!((_a = configFileExistenceInfo == null ? void 0 : configFileExistenceInfo.openFilesImpactedByConfigFile) == null ? void 0 : _a.has(info.path))) return;
                } else {
                    if (!((_b = configFileExistenceInfo.openFilesImpactedByConfigFile) == null ? void 0 : _b.delete(info.path))) return;
                }
                if (isRootOfInferredProject) {
                    configFileExistenceInfo.inferredProjectRoots--;
                    if (configFileExistenceInfo.watcher && !configFileExistenceInfo.config && !configFileExistenceInfo.inferredProjectRoots) {
                        configFileExistenceInfo.watcher.close();
                        configFileExistenceInfo.watcher = void 0;
                    }
                }
                if (!((_c = configFileExistenceInfo.openFilesImpactedByConfigFile) == null ? void 0 : _c.size) && !configFileExistenceInfo.config) {
                    Debug.assert(!configFileExistenceInfo.watcher);
                    this.configFileExistenceInfoCache.delete(canonicalConfigFilePath);
                }
            });
        }
        /**
   * This is called by inferred project whenever script info is added as a root
   *
   * @internal
   */ startWatchingConfigFilesForInferredProjectRoot(info) {
            if (this.serverMode !== 0 /* Semantic */ ) return;
            Debug.assert(info.isScriptOpen());
            this.rootOfInferredProjects.add(info);
            this.forEachConfigFileLocation(info, (canonicalConfigFilePath, configFileName)=>{
                let configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
                var _configFileExistenceInfo_inferredProjectRoots;
                if (!configFileExistenceInfo) {
                    configFileExistenceInfo = {
                        exists: this.host.fileExists(configFileName),
                        inferredProjectRoots: 1
                    };
                    this.configFileExistenceInfoCache.set(canonicalConfigFilePath, configFileExistenceInfo);
                } else configFileExistenceInfo.inferredProjectRoots = ((_configFileExistenceInfo_inferredProjectRoots = configFileExistenceInfo.inferredProjectRoots) !== null && _configFileExistenceInfo_inferredProjectRoots !== void 0 ? _configFileExistenceInfo_inferredProjectRoots : 0) + 1;
                var _configFileExistenceInfo_openFilesImpactedByConfigFile;
                ((_configFileExistenceInfo_openFilesImpactedByConfigFile = configFileExistenceInfo.openFilesImpactedByConfigFile) !== null && _configFileExistenceInfo_openFilesImpactedByConfigFile !== void 0 ? _configFileExistenceInfo_openFilesImpactedByConfigFile : configFileExistenceInfo.openFilesImpactedByConfigFile = /* @__PURE__ */ new Set()).add(info.path);
                configFileExistenceInfo.watcher || (configFileExistenceInfo.watcher = canWatchDirectoryOrFilePath(getDirectoryPath(canonicalConfigFilePath)) ? this.watchFactory.watchFile(configFileName, (_filename, eventKind)=>this.onConfigFileChanged(configFileName, canonicalConfigFilePath, eventKind), 2e3 /* High */ , this.hostConfiguration.watchOptions, WatchType.ConfigFileForInferredRoot) : noopConfigFileWatcher);
            });
        }
        /**
   * This function tries to search for a tsconfig.json for the given file.
   * This is different from the method the compiler uses because
   * the compiler can assume it will always start searching in the
   * current directory (the directory in which tsc was invoked).
   * The server must start searching from the directory containing
   * the newly opened file.
   */ forEachConfigFileLocation(info, action) {
            if (this.serverMode !== 0 /* Semantic */ ) return void 0;
            Debug.assert(!isOpenScriptInfo(info) || this.openFiles.has(info.path));
            const projectRootPath = this.openFiles.get(info.path);
            const scriptInfo = Debug.checkDefined(this.getScriptInfo(info.path));
            if (scriptInfo.isDynamic) return void 0;
            let searchPath = asNormalizedPath(getDirectoryPath(info.fileName));
            const isSearchPathInProjectRoot = ()=>containsPath(projectRootPath, searchPath, this.currentDirectory, !this.host.useCaseSensitiveFileNames);
            const anySearchPathOk = !projectRootPath || !isSearchPathInProjectRoot();
            let searchTsconfig = true;
            let searchJsconfig = true;
            if (isAncestorConfigFileInfo(info)) {
                if (endsWith(info.fileName, "tsconfig.json")) searchTsconfig = false;
                else searchTsconfig = searchJsconfig = false;
            }
            do {
                const canonicalSearchPath = normalizedPathToPath(searchPath, this.currentDirectory, this.toCanonicalFileName);
                if (searchTsconfig) {
                    const tsconfigFileName = asNormalizedPath(combinePaths(searchPath, "tsconfig.json"));
                    const result = action(combinePaths(canonicalSearchPath, "tsconfig.json"), tsconfigFileName);
                    if (result) return tsconfigFileName;
                }
                if (searchJsconfig) {
                    const jsconfigFileName = asNormalizedPath(combinePaths(searchPath, "jsconfig.json"));
                    const result = action(combinePaths(canonicalSearchPath, "jsconfig.json"), jsconfigFileName);
                    if (result) return jsconfigFileName;
                }
                if (isNodeModulesDirectory(canonicalSearchPath)) break;
                const parentPath = asNormalizedPath(getDirectoryPath(searchPath));
                if (parentPath === searchPath) break;
                searchPath = parentPath;
                searchTsconfig = searchJsconfig = true;
            }while (anySearchPathOk || isSearchPathInProjectRoot());
            return void 0;
        }
        /** @internal */ findDefaultConfiguredProject(info) {
            var _a;
            return (_a = this.findDefaultConfiguredProjectWorker(info, 1 /* Find */ )) == null ? void 0 : _a.defaultProject;
        }
        /** @internal */ findDefaultConfiguredProjectWorker(info, kind) {
            return info.isScriptOpen() ? this.tryFindDefaultConfiguredProjectForOpenScriptInfo(info, kind) : void 0;
        }
        /** Get cached configFileName for scriptInfo or ancestor of open script info */ getConfigFileNameForFileFromCache(info, lookInPendingFilesForValue) {
            if (lookInPendingFilesForValue) {
                const result = getConfigFileNameFromCache(info, this.pendingOpenFileProjectUpdates);
                if (result !== void 0) return result;
            }
            return getConfigFileNameFromCache(info, this.configFileForOpenFiles);
        }
        /** Caches the configFilename for script info or ancestor of open script info */ setConfigFileNameForFileInCache(info, configFileName) {
            if (!this.openFiles.has(info.path)) return;
            const config = configFileName || false;
            if (!isAncestorConfigFileInfo(info)) this.configFileForOpenFiles.set(info.path, config);
            else {
                let configFileForOpenFile = this.configFileForOpenFiles.get(info.path);
                if (!configFileForOpenFile || isString(configFileForOpenFile)) this.configFileForOpenFiles.set(info.path, configFileForOpenFile = /* @__PURE__ */ new Map().set(false, configFileForOpenFile));
                configFileForOpenFile.set(info.fileName, config);
            }
        }
        /**
   * This function tries to search for a tsconfig.json for the given file.
   * This is different from the method the compiler uses because
   * the compiler can assume it will always start searching in the
   * current directory (the directory in which tsc was invoked).
   * The server must start searching from the directory containing
   * the newly opened file.
   * If script info is passed in, it is asserted to be open script info
   * otherwise just file name
   * when findFromCacheOnly is true only looked up in cache instead of hitting disk to figure things out
   * @internal
   */ getConfigFileNameForFile(info, findFromCacheOnly) {
            const fromCache = this.getConfigFileNameForFileFromCache(info, findFromCacheOnly);
            if (fromCache !== void 0) return fromCache || void 0;
            if (findFromCacheOnly) return void 0;
            const configFileName = this.forEachConfigFileLocation(info, (canonicalConfigFilePath, configFileName2)=>this.configFileExists(configFileName2, canonicalConfigFilePath, info));
            this.logger.info(`getConfigFileNameForFile:: File: ${info.fileName} ProjectRootPath: ${this.openFiles.get(info.path)}:: Result: ${configFileName}`);
            this.setConfigFileNameForFileInCache(info, configFileName);
            return configFileName;
        }
        printProjects() {
            if (!this.logger.hasLevel(1 /* normal */ )) return;
            this.logger.startGroup();
            this.externalProjects.forEach(printProjectWithoutFileNames);
            this.configuredProjects.forEach(printProjectWithoutFileNames);
            this.inferredProjects.forEach(printProjectWithoutFileNames);
            this.logger.info("Open files: ");
            this.openFiles.forEach((projectRootPath, path)=>{
                const info = this.getScriptInfoForPath(path);
                this.logger.info(`	FileName: ${info.fileName} ProjectRootPath: ${projectRootPath}`);
                this.logger.info(`		Projects: ${info.containingProjects.map((p)=>p.getProjectName())}`);
            });
            this.logger.endGroup();
        }
        /** @internal */ findConfiguredProjectByProjectName(configFileName, allowDeferredClosed) {
            const canonicalConfigFilePath = asNormalizedPath(this.toCanonicalFileName(configFileName));
            const result = this.getConfiguredProjectByCanonicalConfigFilePath(canonicalConfigFilePath);
            return allowDeferredClosed ? result : !(result == null ? void 0 : result.deferredClose) ? result : void 0;
        }
        getConfiguredProjectByCanonicalConfigFilePath(canonicalConfigFilePath) {
            return this.configuredProjects.get(canonicalConfigFilePath);
        }
        findExternalProjectByProjectName(projectFileName) {
            return findProjectByName(projectFileName, this.externalProjects);
        }
        /** Get a filename if the language service exceeds the maximum allowed program size; otherwise returns undefined. */ getFilenameForExceededTotalSizeLimitForNonTsFiles(name, options, fileNames, propertyReader) {
            if (options && options.disableSizeLimit || !this.host.getFileSize) return;
            let availableSpace = maxProgramSizeForNonTsFiles;
            this.projectToSizeMap.set(name, 0);
            this.projectToSizeMap.forEach((val)=>availableSpace -= val || 0);
            let totalNonTsFileSize = 0;
            for (const f of fileNames){
                const fileName = propertyReader.getFileName(f);
                if (hasTSFileExtension(fileName)) continue;
                totalNonTsFileSize += this.host.getFileSize(fileName);
                if (totalNonTsFileSize > maxProgramSizeForNonTsFiles || totalNonTsFileSize > availableSpace) {
                    const top5LargestFiles = fileNames.map((f2)=>propertyReader.getFileName(f2)).filter((name2)=>!hasTSFileExtension(name2)).map((name2)=>({
                            name: name2,
                            size: this.host.getFileSize(name2)
                        })).sort((a, b)=>b.size - a.size).slice(0, 5);
                    this.logger.info(`Non TS file size exceeded limit (${totalNonTsFileSize}). Largest files: ${top5LargestFiles.map((file)=>`${file.name}:${file.size}`).join(", ")}`);
                    return fileName;
                }
            }
            this.projectToSizeMap.set(name, totalNonTsFileSize);
        }
        createExternalProject(projectFileName, files, options, typeAcquisition, excludedFiles) {
            const compilerOptions = convertCompilerOptions(options);
            const watchOptionsAndErrors = convertWatchOptions(options, getDirectoryPath(normalizeSlashes(projectFileName)));
            const project = new ExternalProject(projectFileName, this, compilerOptions, /*lastFileExceededProgramSize*/ this.getFilenameForExceededTotalSizeLimitForNonTsFiles(projectFileName, compilerOptions, files, externalFilePropertyReader), options.compileOnSave === void 0 ? true : options.compileOnSave, /*projectFilePath*/ void 0, watchOptionsAndErrors == null ? void 0 : watchOptionsAndErrors.watchOptions);
            project.setProjectErrors(watchOptionsAndErrors == null ? void 0 : watchOptionsAndErrors.errors);
            project.excludedFiles = excludedFiles;
            this.addFilesToNonInferredProject(project, files, externalFilePropertyReader, typeAcquisition);
            this.externalProjects.push(project);
            return project;
        }
        /** @internal */ sendProjectTelemetry(project) {
            if (this.seenProjects.has(project.projectName)) {
                setProjectOptionsUsed(project);
                return;
            }
            this.seenProjects.set(project.projectName, true);
            if (!this.eventHandler || !this.host.createSHA256Hash) {
                setProjectOptionsUsed(project);
                return;
            }
            const projectOptions = isConfiguredProject(project) ? project.projectOptions : void 0;
            setProjectOptionsUsed(project);
            const data = {
                projectId: this.host.createSHA256Hash(project.projectName),
                fileStats: countEachFileTypes(project.getScriptInfos(), /*includeSizes*/ true),
                compilerOptions: convertCompilerOptionsForTelemetry(project.getCompilationSettings()),
                typeAcquisition: convertTypeAcquisition2(project.getTypeAcquisition()),
                extends: projectOptions && projectOptions.configHasExtendsProperty,
                files: projectOptions && projectOptions.configHasFilesProperty,
                include: projectOptions && projectOptions.configHasIncludeProperty,
                exclude: projectOptions && projectOptions.configHasExcludeProperty,
                compileOnSave: project.compileOnSaveEnabled,
                configFileName: configFileName(),
                projectType: project instanceof ExternalProject ? "external" : "configured",
                languageServiceEnabled: project.languageServiceEnabled,
                version
            };
            this.eventHandler({
                eventName: ProjectInfoTelemetryEvent,
                data
            });
            function configFileName() {
                if (!isConfiguredProject(project)) return "other";
                return getBaseConfigFileName(project.getConfigFilePath()) || "other";
            }
            function convertTypeAcquisition2({ enable: enable2, include, exclude }) {
                return {
                    enable: enable2,
                    include: include !== void 0 && include.length !== 0,
                    exclude: exclude !== void 0 && exclude.length !== 0
                };
            }
        }
        addFilesToNonInferredProject(project, files, propertyReader, typeAcquisition) {
            this.updateNonInferredProjectFiles(project, files, propertyReader);
            project.setTypeAcquisition(typeAcquisition);
            project.markAsDirty();
        }
        /** @internal */ createConfiguredProject(configFileName, reason) {
            var _a;
            (_a = tracing) == null || _a.instant(tracing.Phase.Session, "createConfiguredProject", {
                configFilePath: configFileName
            });
            const canonicalConfigFilePath = asNormalizedPath(this.toCanonicalFileName(configFileName));
            let configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            if (!configFileExistenceInfo) this.configFileExistenceInfoCache.set(canonicalConfigFilePath, configFileExistenceInfo = {
                exists: true
            });
            else configFileExistenceInfo.exists = true;
            if (!configFileExistenceInfo.config) configFileExistenceInfo.config = {
                cachedDirectoryStructureHost: createCachedDirectoryStructureHost(this.host, this.host.getCurrentDirectory(), this.host.useCaseSensitiveFileNames),
                projects: /* @__PURE__ */ new Map(),
                updateLevel: 2 /* Full */ 
            };
            const project = new ConfiguredProject2(configFileName, canonicalConfigFilePath, this, configFileExistenceInfo.config.cachedDirectoryStructureHost, reason);
            Debug.assert(!this.configuredProjects.has(canonicalConfigFilePath));
            this.configuredProjects.set(canonicalConfigFilePath, project);
            this.createConfigFileWatcherForParsedConfig(configFileName, canonicalConfigFilePath, project);
            return project;
        }
        /**
   * Read the config file of the project, and update the project root file names.
   */ loadConfiguredProject(project, reason) {
            var _a, _b;
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "loadConfiguredProject", {
                configFilePath: project.canonicalConfigFilePath
            });
            this.sendProjectLoadingStartEvent(project, reason);
            const configFilename = toNormalizedPath(project.getConfigFilePath());
            const configFileExistenceInfo = this.ensureParsedConfigUptoDate(configFilename, project.canonicalConfigFilePath, this.configFileExistenceInfoCache.get(project.canonicalConfigFilePath), project);
            const parsedCommandLine = configFileExistenceInfo.config.parsedCommandLine;
            Debug.assert(!!parsedCommandLine.fileNames);
            const compilerOptions = parsedCommandLine.options;
            if (!project.projectOptions) project.projectOptions = {
                configHasExtendsProperty: parsedCommandLine.raw.extends !== void 0,
                configHasFilesProperty: parsedCommandLine.raw.files !== void 0,
                configHasIncludeProperty: parsedCommandLine.raw.include !== void 0,
                configHasExcludeProperty: parsedCommandLine.raw.exclude !== void 0
            };
            project.parsedCommandLine = parsedCommandLine;
            project.setProjectErrors(parsedCommandLine.options.configFile.parseDiagnostics);
            project.updateReferences(parsedCommandLine.projectReferences);
            const lastFileExceededProgramSize = this.getFilenameForExceededTotalSizeLimitForNonTsFiles(project.canonicalConfigFilePath, compilerOptions, parsedCommandLine.fileNames, fileNamePropertyReader);
            if (lastFileExceededProgramSize) {
                project.disableLanguageService(lastFileExceededProgramSize);
                this.configFileExistenceInfoCache.forEach((_configFileExistenceInfo, canonicalConfigFilePath)=>this.stopWatchingWildCards(canonicalConfigFilePath, project));
            } else {
                project.setCompilerOptions(compilerOptions);
                project.setWatchOptions(parsedCommandLine.watchOptions);
                project.enableLanguageService();
                this.watchWildcards(configFilename, configFileExistenceInfo, project);
            }
            project.enablePluginsWithOptions(compilerOptions);
            const filesToAdd = parsedCommandLine.fileNames.concat(project.getExternalFiles(2 /* Full */ ));
            this.updateRootAndOptionsOfNonInferredProject(project, filesToAdd, fileNamePropertyReader, compilerOptions, parsedCommandLine.typeAcquisition, parsedCommandLine.compileOnSave, parsedCommandLine.watchOptions);
            (_b = tracing) == null || _b.pop();
        }
        /** @internal */ ensureParsedConfigUptoDate(configFilename, canonicalConfigFilePath, configFileExistenceInfo, forProject) {
            var _a, _b, _c;
            if (configFileExistenceInfo.config) {
                if (configFileExistenceInfo.config.updateLevel === 1 /* RootNamesAndUpdate */ ) this.reloadFileNamesOfParsedConfig(configFilename, configFileExistenceInfo.config);
                if (!configFileExistenceInfo.config.updateLevel) {
                    this.ensureConfigFileWatcherForProject(configFileExistenceInfo, forProject);
                    return configFileExistenceInfo;
                }
            }
            if (!configFileExistenceInfo.exists && configFileExistenceInfo.config) {
                configFileExistenceInfo.config.updateLevel = void 0;
                this.ensureConfigFileWatcherForProject(configFileExistenceInfo, forProject);
                return configFileExistenceInfo;
            }
            const cachedDirectoryStructureHost = ((_a = configFileExistenceInfo.config) == null ? void 0 : _a.cachedDirectoryStructureHost) || createCachedDirectoryStructureHost(this.host, this.host.getCurrentDirectory(), this.host.useCaseSensitiveFileNames);
            const configFileContent = tryReadFile(configFilename, (fileName)=>this.host.readFile(fileName));
            const configFile = parseJsonText(configFilename, isString(configFileContent) ? configFileContent : "");
            const configFileErrors = configFile.parseDiagnostics;
            if (!isString(configFileContent)) configFileErrors.push(configFileContent);
            const configDir = getDirectoryPath(configFilename);
            const parsedCommandLine = parseJsonSourceFileConfigFileContent(configFile, cachedDirectoryStructureHost, configDir, /*existingOptions*/ void 0, configFilename, /*resolutionStack*/ void 0, this.hostConfiguration.extraFileExtensions, this.extendedConfigCache);
            if (parsedCommandLine.errors.length) configFileErrors.push(...parsedCommandLine.errors);
            this.logger.info(`Config: ${configFilename} : ${JSON.stringify({
                rootNames: parsedCommandLine.fileNames,
                options: parsedCommandLine.options,
                watchOptions: parsedCommandLine.watchOptions,
                projectReferences: parsedCommandLine.projectReferences
            }, /*replacer*/ void 0, " ")}`);
            const oldCommandLine = (_b = configFileExistenceInfo.config) == null ? void 0 : _b.parsedCommandLine;
            if (!configFileExistenceInfo.config) configFileExistenceInfo.config = {
                parsedCommandLine,
                cachedDirectoryStructureHost,
                projects: /* @__PURE__ */ new Map()
            };
            else {
                configFileExistenceInfo.config.parsedCommandLine = parsedCommandLine;
                configFileExistenceInfo.config.watchedDirectoriesStale = true;
                configFileExistenceInfo.config.updateLevel = void 0;
            }
            if (!oldCommandLine && !isJsonEqual(// Old options
            this.getWatchOptionsFromProjectWatchOptions(/*projectOptions*/ void 0, configDir), // New options
            this.getWatchOptionsFromProjectWatchOptions(parsedCommandLine.watchOptions, configDir))) {
                (_c = configFileExistenceInfo.watcher) == null || _c.close();
                configFileExistenceInfo.watcher = void 0;
            }
            this.createConfigFileWatcherForParsedConfig(configFilename, canonicalConfigFilePath, forProject);
            updateSharedExtendedConfigFileWatcher(canonicalConfigFilePath, parsedCommandLine.options, this.sharedExtendedConfigFileWatchers, (extendedConfigFileName, extendedConfigFilePath)=>this.watchFactory.watchFile(extendedConfigFileName, ()=>{
                    var _a2;
                    cleanExtendedConfigCache(this.extendedConfigCache, extendedConfigFilePath, (fileName)=>this.toPath(fileName));
                    let ensureProjectsForOpenFiles = false;
                    (_a2 = this.sharedExtendedConfigFileWatchers.get(extendedConfigFilePath)) == null || _a2.projects.forEach((canonicalPath)=>{
                        ensureProjectsForOpenFiles = this.delayUpdateProjectsFromParsedConfigOnConfigFileChange(canonicalPath, `Change in extended config file ${extendedConfigFileName} detected`) || ensureProjectsForOpenFiles;
                    });
                    if (ensureProjectsForOpenFiles) this.delayEnsureProjectForOpenFiles();
                }, 2e3 /* High */ , this.hostConfiguration.watchOptions, WatchType.ExtendedConfigFile, configFilename), (fileName)=>this.toPath(fileName));
            return configFileExistenceInfo;
        }
        /** @internal */ watchWildcards(configFileName, { exists, config }, forProject) {
            config.projects.set(forProject.canonicalConfigFilePath, true);
            if (exists) {
                if (config.watchedDirectories && !config.watchedDirectoriesStale) return;
                config.watchedDirectoriesStale = false;
                updateWatchingWildcardDirectories(config.watchedDirectories || (config.watchedDirectories = /* @__PURE__ */ new Map()), config.parsedCommandLine.wildcardDirectories, // Create new directory watcher
                (directory, flags)=>this.watchWildcardDirectory(directory, flags, configFileName, config));
            } else {
                config.watchedDirectoriesStale = false;
                if (!config.watchedDirectories) return;
                clearMap(config.watchedDirectories, closeFileWatcherOf);
                config.watchedDirectories = void 0;
            }
        }
        /** @internal */ stopWatchingWildCards(canonicalConfigFilePath, forProject) {
            const configFileExistenceInfo = this.configFileExistenceInfoCache.get(canonicalConfigFilePath);
            if (!configFileExistenceInfo.config || !configFileExistenceInfo.config.projects.get(forProject.canonicalConfigFilePath)) return;
            configFileExistenceInfo.config.projects.set(forProject.canonicalConfigFilePath, false);
            if (forEachEntry(configFileExistenceInfo.config.projects, identity)) return;
            if (configFileExistenceInfo.config.watchedDirectories) {
                clearMap(configFileExistenceInfo.config.watchedDirectories, closeFileWatcherOf);
                configFileExistenceInfo.config.watchedDirectories = void 0;
            }
            configFileExistenceInfo.config.watchedDirectoriesStale = void 0;
        }
        updateNonInferredProjectFiles(project, files, propertyReader) {
            var _a;
            const projectRootFilesMap = project.getRootFilesMap();
            const newRootScriptInfoMap = /* @__PURE__ */ new Map();
            for (const f of files){
                const newRootFile = propertyReader.getFileName(f);
                const fileName = toNormalizedPath(newRootFile);
                const isDynamic = isDynamicFileName(fileName);
                let path;
                if (!isDynamic && !project.fileExists(newRootFile)) {
                    path = normalizedPathToPath(fileName, this.currentDirectory, this.toCanonicalFileName);
                    const existingValue = projectRootFilesMap.get(path);
                    if (existingValue) {
                        if (((_a = existingValue.info) == null ? void 0 : _a.path) === path) {
                            project.removeFile(existingValue.info, /*fileExists*/ false, /*detachFromProject*/ true);
                            existingValue.info = void 0;
                        }
                        existingValue.fileName = fileName;
                    } else projectRootFilesMap.set(path, {
                        fileName
                    });
                } else {
                    const scriptKind = propertyReader.getScriptKind(f, this.hostConfiguration.extraFileExtensions);
                    const hasMixedContent = propertyReader.hasMixedContent(f, this.hostConfiguration.extraFileExtensions);
                    const scriptInfo = Debug.checkDefined(this.getOrCreateScriptInfoNotOpenedByClientForNormalizedPath(fileName, project.currentDirectory, scriptKind, hasMixedContent, project.directoryStructureHost, /*deferredDeleteOk*/ false));
                    path = scriptInfo.path;
                    const existingValue = projectRootFilesMap.get(path);
                    if (!existingValue || existingValue.info !== scriptInfo) {
                        project.addRoot(scriptInfo, fileName);
                        if (scriptInfo.isScriptOpen()) this.removeRootOfInferredProjectIfNowPartOfOtherProject(scriptInfo);
                    } else existingValue.fileName = fileName;
                }
                newRootScriptInfoMap.set(path, true);
            }
            if (projectRootFilesMap.size > newRootScriptInfoMap.size) projectRootFilesMap.forEach((value1, path)=>{
                if (!newRootScriptInfoMap.has(path)) {
                    if (value1.info) project.removeFile(value1.info, project.fileExists(value1.info.fileName), /*detachFromProject*/ true);
                    else projectRootFilesMap.delete(path);
                }
            });
        }
        updateRootAndOptionsOfNonInferredProject(project, newUncheckedFiles, propertyReader, newOptions, newTypeAcquisition, compileOnSave, watchOptions) {
            project.setCompilerOptions(newOptions);
            project.setWatchOptions(watchOptions);
            if (compileOnSave !== void 0) project.compileOnSaveEnabled = compileOnSave;
            this.addFilesToNonInferredProject(project, newUncheckedFiles, propertyReader, newTypeAcquisition);
        }
        /**
   * Reload the file names from config file specs and update the project graph
   *
   * @internal
   */ reloadFileNamesOfConfiguredProject(project) {
            const config = this.reloadFileNamesOfParsedConfig(project.getConfigFilePath(), this.configFileExistenceInfoCache.get(project.canonicalConfigFilePath).config);
            project.updateErrorOnNoInputFiles(config);
            this.updateNonInferredProjectFiles(project, config.fileNames.concat(project.getExternalFiles(1 /* RootNamesAndUpdate */ )), fileNamePropertyReader);
            project.markAsDirty();
            return project.updateGraph();
        }
        reloadFileNamesOfParsedConfig(configFileName, config) {
            if (config.updateLevel === void 0) return config.parsedCommandLine;
            Debug.assert(config.updateLevel === 1 /* RootNamesAndUpdate */ );
            const configFileSpecs = config.parsedCommandLine.options.configFile.configFileSpecs;
            const fileNames = getFileNamesFromConfigSpecs(configFileSpecs, getDirectoryPath(configFileName), config.parsedCommandLine.options, config.cachedDirectoryStructureHost, this.hostConfiguration.extraFileExtensions);
            config.parsedCommandLine = (0, _objectSpreadProps._)((0, _objectSpread._)({}, config.parsedCommandLine), {
                fileNames
            });
            config.updateLevel = void 0;
            return config.parsedCommandLine;
        }
        /** @internal */ setFileNamesOfAutoImportProviderOrAuxillaryProject(project, fileNames) {
            this.updateNonInferredProjectFiles(project, fileNames, fileNamePropertyReader);
        }
        /** @internal */ reloadConfiguredProjectOptimized(project, reason, reloadedProjects) {
            if (reloadedProjects.has(project)) return;
            reloadedProjects.set(project, 6 /* ReloadOptimized */ );
            if (!project.initialLoadPending) this.setProjectForReload(project, 2 /* Full */ , reason);
        }
        /** @internal */ reloadConfiguredProjectClearingSemanticCache(project, reason, reloadedProjects) {
            if (reloadedProjects.get(project) === 7 /* Reload */ ) return false;
            reloadedProjects.set(project, 7 /* Reload */ );
            this.clearSemanticCache(project);
            this.reloadConfiguredProject(project, reloadReason(reason));
            return true;
        }
        setProjectForReload(project, updateLevel, reason) {
            if (updateLevel === 2 /* Full */ ) this.clearSemanticCache(project);
            project.pendingUpdateReason = reason && reloadReason(reason);
            project.pendingUpdateLevel = updateLevel;
        }
        /**
   * Read the config file of the project again by clearing the cache and update the project graph
   *
   * @internal
   */ reloadConfiguredProject(project, reason) {
            project.initialLoadPending = false;
            this.setProjectForReload(project, 0 /* Update */ );
            this.loadConfiguredProject(project, reason);
            var _project_triggerFileForConfigFileDiag;
            updateWithTriggerFile(project, (_project_triggerFileForConfigFileDiag = project.triggerFileForConfigFileDiag) !== null && _project_triggerFileForConfigFileDiag !== void 0 ? _project_triggerFileForConfigFileDiag : project.getConfigFilePath(), /*isReload*/ true);
        }
        clearSemanticCache(project) {
            project.originalConfiguredProjects = void 0;
            project.resolutionCache.clear();
            project.getLanguageService(/*ensureSynchronized*/ false).cleanupSemanticCache();
            project.cleanupProgram();
            project.markAsDirty();
        }
        /** @internal */ sendConfigFileDiagEvent(project, triggerFile, force) {
            if (!this.eventHandler || this.suppressDiagnosticEvents) return false;
            const diagnostics = project.getLanguageService().getCompilerOptionsDiagnostics();
            diagnostics.push(...project.getAllProjectErrors());
            var _project_configDiagDiagnosticsReported;
            if (!force && diagnostics.length === ((_project_configDiagDiagnosticsReported = project.configDiagDiagnosticsReported) !== null && _project_configDiagDiagnosticsReported !== void 0 ? _project_configDiagDiagnosticsReported : 0)) return false;
            project.configDiagDiagnosticsReported = diagnostics.length;
            this.eventHandler({
                eventName: ConfigFileDiagEvent,
                data: {
                    configFileName: project.getConfigFilePath(),
                    diagnostics,
                    triggerFile: triggerFile !== null && triggerFile !== void 0 ? triggerFile : project.getConfigFilePath()
                }
            });
            return true;
        }
        getOrCreateInferredProjectForProjectRootPathIfEnabled(info, projectRootPath) {
            if (!this.useInferredProjectPerProjectRoot || // Its a dynamic info opened without project root
            info.isDynamic && projectRootPath === void 0) return void 0;
            if (projectRootPath) {
                const canonicalProjectRootPath = this.toCanonicalFileName(projectRootPath);
                for (const project of this.inferredProjects){
                    if (project.projectRootPath === canonicalProjectRootPath) return project;
                }
                return this.createInferredProject(projectRootPath, /*isSingleInferredProject*/ false, projectRootPath);
            }
            let bestMatch;
            for (const project of this.inferredProjects){
                if (!project.projectRootPath) continue;
                if (!containsPath(project.projectRootPath, info.path, this.host.getCurrentDirectory(), !this.host.useCaseSensitiveFileNames)) continue;
                if (bestMatch && bestMatch.projectRootPath.length > project.projectRootPath.length) continue;
                bestMatch = project;
            }
            return bestMatch;
        }
        getOrCreateSingleInferredProjectIfEnabled() {
            if (!this.useSingleInferredProject) return void 0;
            if (this.inferredProjects.length > 0 && this.inferredProjects[0].projectRootPath === void 0) return this.inferredProjects[0];
            return this.createInferredProject(this.currentDirectory, /*isSingleInferredProject*/ true, /*projectRootPath*/ void 0);
        }
        getOrCreateSingleInferredWithoutProjectRoot(currentDirectory) {
            Debug.assert(!this.useSingleInferredProject);
            const expectedCurrentDirectory = this.toCanonicalFileName(this.getNormalizedAbsolutePath(currentDirectory));
            for (const inferredProject of this.inferredProjects){
                if (!inferredProject.projectRootPath && inferredProject.isOrphan() && inferredProject.canonicalCurrentDirectory === expectedCurrentDirectory) return inferredProject;
            }
            return this.createInferredProject(currentDirectory, /*isSingleInferredProject*/ false, /*projectRootPath*/ void 0);
        }
        createInferredProject(currentDirectory, isSingleInferredProject, projectRootPath) {
            const compilerOptions = projectRootPath && this.compilerOptionsForInferredProjectsPerProjectRoot.get(projectRootPath) || this.compilerOptionsForInferredProjects;
            let watchOptionsAndErrors;
            let typeAcquisition;
            if (projectRootPath) {
                watchOptionsAndErrors = this.watchOptionsForInferredProjectsPerProjectRoot.get(projectRootPath);
                typeAcquisition = this.typeAcquisitionForInferredProjectsPerProjectRoot.get(projectRootPath);
            }
            if (watchOptionsAndErrors === void 0) watchOptionsAndErrors = this.watchOptionsForInferredProjects;
            if (typeAcquisition === void 0) typeAcquisition = this.typeAcquisitionForInferredProjects;
            watchOptionsAndErrors = watchOptionsAndErrors || void 0;
            const project = new InferredProject2(this, compilerOptions, watchOptionsAndErrors == null ? void 0 : watchOptionsAndErrors.watchOptions, projectRootPath, currentDirectory, typeAcquisition);
            project.setProjectErrors(watchOptionsAndErrors == null ? void 0 : watchOptionsAndErrors.errors);
            if (isSingleInferredProject) this.inferredProjects.unshift(project);
            else this.inferredProjects.push(project);
            return project;
        }
        /** @internal */ getOrCreateScriptInfoNotOpenedByClient(uncheckedFileName, currentDirectory, hostToQueryFileExistsOn, deferredDeleteOk) {
            return this.getOrCreateScriptInfoNotOpenedByClientForNormalizedPath(toNormalizedPath(uncheckedFileName), currentDirectory, /*scriptKind*/ void 0, /*hasMixedContent*/ void 0, hostToQueryFileExistsOn, deferredDeleteOk);
        }
        getScriptInfo(uncheckedFileName) {
            return this.getScriptInfoForNormalizedPath(toNormalizedPath(uncheckedFileName));
        }
        /** @internal */ getScriptInfoOrConfig(uncheckedFileName) {
            const path = toNormalizedPath(uncheckedFileName);
            const info = this.getScriptInfoForNormalizedPath(path);
            if (info) return info;
            const configProject = this.configuredProjects.get(this.toPath(uncheckedFileName));
            return configProject && configProject.getCompilerOptions().configFile;
        }
        /** @internal */ logErrorForScriptInfoNotFound(fileName) {
            const names = arrayFrom(mapDefinedIterator(this.filenameToScriptInfo.entries(), (entry)=>entry[1].deferredDelete ? void 0 : entry), ([path, scriptInfo])=>({
                    path,
                    fileName: scriptInfo.fileName
                }));
            this.logger.msg(`Could not find file ${JSON.stringify(fileName)}.
All files are: ${JSON.stringify(names)}`, "Err" /* Err */ );
        }
        /**
   * Returns the projects that contain script info through SymLink
   * Note that this does not return projects in info.containingProjects
   *
   * @internal
   */ getSymlinkedProjects(info) {
            let projects;
            if (this.realpathToScriptInfos) {
                const realpath = info.getRealpathIfDifferent();
                if (realpath) forEach(this.realpathToScriptInfos.get(realpath), combineProjects);
                forEach(this.realpathToScriptInfos.get(info.path), combineProjects);
            }
            return projects;
            function combineProjects(toAddInfo) {
                if (toAddInfo !== info) {
                    for (const project of toAddInfo.containingProjects)if (project.languageServiceEnabled && !project.isOrphan() && !project.getCompilerOptions().preserveSymlinks && !info.isAttached(project)) {
                        if (!projects) {
                            projects = createMultiMap();
                            projects.add(toAddInfo.path, project);
                        } else if (!forEachEntry(projects, (projs, path)=>path === toAddInfo.path ? false : contains(projs, project))) projects.add(toAddInfo.path, project);
                    }
                }
            }
        }
        watchClosedScriptInfo(info) {
            Debug.assert(!info.fileWatcher);
            if (!info.isDynamicOrHasMixedContent() && (!this.globalCacheLocationDirectoryPath || !startsWith(info.path, this.globalCacheLocationDirectoryPath))) {
                const indexOfNodeModules = info.fileName.indexOf("/node_modules/");
                if (!this.host.getModifiedTime || indexOfNodeModules === -1) info.fileWatcher = this.watchFactory.watchFile(info.fileName, (_fileName, eventKind)=>this.onSourceFileChanged(info, eventKind), 500 /* Medium */ , this.hostConfiguration.watchOptions, WatchType.ClosedScriptInfo);
                else {
                    info.mTime = this.getModifiedTime(info);
                    info.fileWatcher = this.watchClosedScriptInfoInNodeModules(info.fileName.substring(0, indexOfNodeModules));
                }
            }
        }
        createNodeModulesWatcher(dir, dirPath) {
            let watcher = this.watchFactory.watchDirectory(dir, (fileOrDirectory)=>{
                var _a;
                const fileOrDirectoryPath = removeIgnoredPath(this.toPath(fileOrDirectory));
                if (!fileOrDirectoryPath) return;
                const basename = getBaseFileName(fileOrDirectoryPath);
                if (((_a = result.affectedModuleSpecifierCacheProjects) == null ? void 0 : _a.size) && (basename === "package.json" || basename === "node_modules")) result.affectedModuleSpecifierCacheProjects.forEach((project)=>{
                    var _a2;
                    (_a2 = project.getModuleSpecifierCache()) == null || _a2.clear();
                });
                if (result.refreshScriptInfoRefCount) {
                    if (dirPath === fileOrDirectoryPath) this.refreshScriptInfosInDirectory(dirPath);
                    else {
                        const info = this.filenameToScriptInfo.get(fileOrDirectoryPath);
                        if (info) {
                            if (isScriptInfoWatchedFromNodeModules(info)) this.refreshScriptInfo(info);
                        } else if (!hasExtension(fileOrDirectoryPath)) this.refreshScriptInfosInDirectory(fileOrDirectoryPath);
                    }
                }
            }, 1 /* Recursive */ , this.hostConfiguration.watchOptions, WatchType.NodeModules);
            const result = {
                refreshScriptInfoRefCount: 0,
                affectedModuleSpecifierCacheProjects: void 0,
                close: ()=>{
                    var _a;
                    if (watcher && !result.refreshScriptInfoRefCount && !((_a = result.affectedModuleSpecifierCacheProjects) == null ? void 0 : _a.size)) {
                        watcher.close();
                        watcher = void 0;
                        this.nodeModulesWatchers.delete(dirPath);
                    }
                }
            };
            this.nodeModulesWatchers.set(dirPath, result);
            return result;
        }
        /** @internal */ watchPackageJsonsInNodeModules(dir, project) {
            var _a;
            const dirPath = this.toPath(dir);
            const watcher = this.nodeModulesWatchers.get(dirPath) || this.createNodeModulesWatcher(dir, dirPath);
            Debug.assert(!((_a = watcher.affectedModuleSpecifierCacheProjects) == null ? void 0 : _a.has(project)));
            (watcher.affectedModuleSpecifierCacheProjects || (watcher.affectedModuleSpecifierCacheProjects = /* @__PURE__ */ new Set())).add(project);
            return {
                close: ()=>{
                    var _a2;
                    (_a2 = watcher.affectedModuleSpecifierCacheProjects) == null || _a2.delete(project);
                    watcher.close();
                }
            };
        }
        watchClosedScriptInfoInNodeModules(dir) {
            const watchDir = dir + "/node_modules";
            const watchDirPath = this.toPath(watchDir);
            const watcher = this.nodeModulesWatchers.get(watchDirPath) || this.createNodeModulesWatcher(watchDir, watchDirPath);
            watcher.refreshScriptInfoRefCount++;
            return {
                close: ()=>{
                    watcher.refreshScriptInfoRefCount--;
                    watcher.close();
                }
            };
        }
        getModifiedTime(info) {
            return (this.host.getModifiedTime(info.fileName) || missingFileModifiedTime).getTime();
        }
        refreshScriptInfo(info) {
            const mTime = this.getModifiedTime(info);
            if (mTime !== info.mTime) {
                const eventKind = getFileWatcherEventKind(info.mTime, mTime);
                info.mTime = mTime;
                this.onSourceFileChanged(info, eventKind);
            }
        }
        refreshScriptInfosInDirectory(dir) {
            dir = dir + directorySeparator;
            this.filenameToScriptInfo.forEach((info)=>{
                if (isScriptInfoWatchedFromNodeModules(info) && startsWith(info.path, dir)) this.refreshScriptInfo(info);
            });
        }
        stopWatchingScriptInfo(info) {
            if (info.fileWatcher) {
                info.fileWatcher.close();
                info.fileWatcher = void 0;
            }
        }
        getOrCreateScriptInfoNotOpenedByClientForNormalizedPath(fileName, currentDirectory, scriptKind, hasMixedContent, hostToQueryFileExistsOn, deferredDeleteOk) {
            if (isRootedDiskPath(fileName) || isDynamicFileName(fileName)) return this.getOrCreateScriptInfoWorker(fileName, currentDirectory, /*openedByClient*/ false, /*fileContent*/ void 0, scriptKind, !!hasMixedContent, hostToQueryFileExistsOn, deferredDeleteOk);
            const info = this.openFilesWithNonRootedDiskPath.get(this.toCanonicalFileName(fileName));
            if (info) return info;
            return void 0;
        }
        getOrCreateScriptInfoForNormalizedPath(fileName, openedByClient, fileContent, scriptKind, hasMixedContent, hostToQueryFileExistsOn) {
            return this.getOrCreateScriptInfoWorker(fileName, this.currentDirectory, openedByClient, fileContent, scriptKind, !!hasMixedContent, hostToQueryFileExistsOn, /*deferredDeleteOk*/ false);
        }
        getOrCreateScriptInfoWorker(fileName, currentDirectory, openedByClient, fileContent, scriptKind, hasMixedContent, hostToQueryFileExistsOn, deferredDeleteOk) {
            Debug.assert(fileContent === void 0 || openedByClient, "ScriptInfo needs to be opened by client to be able to set its user defined content");
            const path = normalizedPathToPath(fileName, currentDirectory, this.toCanonicalFileName);
            let info = this.filenameToScriptInfo.get(path);
            if (!info) {
                const isDynamic = isDynamicFileName(fileName);
                Debug.assert(isRootedDiskPath(fileName) || isDynamic || openedByClient, "", ()=>`${JSON.stringify({
                        fileName,
                        currentDirectory,
                        hostCurrentDirectory: this.currentDirectory,
                        openKeys: arrayFrom(this.openFilesWithNonRootedDiskPath.keys())
                    })}
Script info with non-dynamic relative file name can only be open script info or in context of host currentDirectory`);
                Debug.assert(!isRootedDiskPath(fileName) || this.currentDirectory === currentDirectory || !this.openFilesWithNonRootedDiskPath.has(this.toCanonicalFileName(fileName)), "", ()=>`${JSON.stringify({
                        fileName,
                        currentDirectory,
                        hostCurrentDirectory: this.currentDirectory,
                        openKeys: arrayFrom(this.openFilesWithNonRootedDiskPath.keys())
                    })}
Open script files with non rooted disk path opened with current directory context cannot have same canonical names`);
                Debug.assert(!isDynamic || this.currentDirectory === currentDirectory || this.useInferredProjectPerProjectRoot, "", ()=>`${JSON.stringify({
                        fileName,
                        currentDirectory,
                        hostCurrentDirectory: this.currentDirectory,
                        openKeys: arrayFrom(this.openFilesWithNonRootedDiskPath.keys())
                    })}
Dynamic files must always be opened with service's current directory or service should support inferred project per projectRootPath.`);
                if (!openedByClient && !isDynamic && !(hostToQueryFileExistsOn || this.host).fileExists(fileName)) return;
                info = new ScriptInfo(this.host, fileName, scriptKind, hasMixedContent, path, this.filenameToScriptInfoVersion.get(path));
                this.filenameToScriptInfo.set(info.path, info);
                this.filenameToScriptInfoVersion.delete(info.path);
                if (!openedByClient) this.watchClosedScriptInfo(info);
                else if (!isRootedDiskPath(fileName) && (!isDynamic || this.currentDirectory !== currentDirectory)) this.openFilesWithNonRootedDiskPath.set(this.toCanonicalFileName(fileName), info);
            } else if (info.deferredDelete) {
                Debug.assert(!info.isDynamic);
                if (!openedByClient && !(hostToQueryFileExistsOn || this.host).fileExists(fileName)) return deferredDeleteOk ? info : void 0;
                info.deferredDelete = void 0;
            }
            if (openedByClient) {
                this.stopWatchingScriptInfo(info);
                info.open(fileContent);
                if (hasMixedContent) info.registerFileUpdate();
            }
            return info;
        }
        /**
   * This gets the script info for the normalized path. If the path is not rooted disk path then the open script info with project root context is preferred
   */ getScriptInfoForNormalizedPath(fileName) {
            return !isRootedDiskPath(fileName) && this.openFilesWithNonRootedDiskPath.get(this.toCanonicalFileName(fileName)) || this.getScriptInfoForPath(normalizedPathToPath(fileName, this.currentDirectory, this.toCanonicalFileName));
        }
        getScriptInfoForPath(fileName) {
            const info = this.filenameToScriptInfo.get(fileName);
            return !info || !info.deferredDelete ? info : void 0;
        }
        /** @internal */ getDocumentPositionMapper(project, generatedFileName, sourceFileName) {
            const declarationInfo = this.getOrCreateScriptInfoNotOpenedByClient(generatedFileName, project.currentDirectory, this.host, /*deferredDeleteOk*/ false);
            if (!declarationInfo) {
                if (sourceFileName) project.addGeneratedFileWatch(generatedFileName, sourceFileName);
                return void 0;
            }
            declarationInfo.getSnapshot();
            if (isString(declarationInfo.sourceMapFilePath)) {
                const sourceMapFileInfo2 = this.getScriptInfoForPath(declarationInfo.sourceMapFilePath);
                if (sourceMapFileInfo2) {
                    sourceMapFileInfo2.getSnapshot();
                    if (sourceMapFileInfo2.documentPositionMapper !== void 0) {
                        sourceMapFileInfo2.sourceInfos = this.addSourceInfoToSourceMap(sourceFileName, project, sourceMapFileInfo2.sourceInfos);
                        return sourceMapFileInfo2.documentPositionMapper ? sourceMapFileInfo2.documentPositionMapper : void 0;
                    }
                }
                declarationInfo.sourceMapFilePath = void 0;
            } else if (declarationInfo.sourceMapFilePath) {
                declarationInfo.sourceMapFilePath.sourceInfos = this.addSourceInfoToSourceMap(sourceFileName, project, declarationInfo.sourceMapFilePath.sourceInfos);
                return void 0;
            } else if (declarationInfo.sourceMapFilePath !== void 0) return void 0;
            let sourceMapFileInfo;
            let readMapFile = (mapFileName, mapFileNameFromDts)=>{
                const mapInfo = this.getOrCreateScriptInfoNotOpenedByClient(mapFileName, project.currentDirectory, this.host, /*deferredDeleteOk*/ true);
                sourceMapFileInfo = mapInfo || mapFileNameFromDts;
                if (!mapInfo || mapInfo.deferredDelete) return void 0;
                const snap = mapInfo.getSnapshot();
                if (mapInfo.documentPositionMapper !== void 0) return mapInfo.documentPositionMapper;
                return getSnapshotText(snap);
            };
            const projectName = project.projectName;
            const documentPositionMapper = getDocumentPositionMapper({
                getCanonicalFileName: this.toCanonicalFileName,
                log: (s)=>this.logger.info(s),
                getSourceFileLike: (f)=>this.getSourceFileLike(f, projectName, declarationInfo)
            }, declarationInfo.fileName, declarationInfo.textStorage.getLineInfo(), readMapFile);
            readMapFile = void 0;
            if (sourceMapFileInfo) {
                if (!isString(sourceMapFileInfo)) {
                    declarationInfo.sourceMapFilePath = sourceMapFileInfo.path;
                    sourceMapFileInfo.declarationInfoPath = declarationInfo.path;
                    if (!sourceMapFileInfo.deferredDelete) sourceMapFileInfo.documentPositionMapper = documentPositionMapper || false;
                    sourceMapFileInfo.sourceInfos = this.addSourceInfoToSourceMap(sourceFileName, project, sourceMapFileInfo.sourceInfos);
                } else declarationInfo.sourceMapFilePath = {
                    watcher: this.addMissingSourceMapFile(project.currentDirectory === this.currentDirectory ? sourceMapFileInfo : getNormalizedAbsolutePath(sourceMapFileInfo, project.currentDirectory), declarationInfo.path),
                    sourceInfos: this.addSourceInfoToSourceMap(sourceFileName, project)
                };
            } else declarationInfo.sourceMapFilePath = false;
            return documentPositionMapper;
        }
        addSourceInfoToSourceMap(sourceFileName, project, sourceInfos) {
            if (sourceFileName) {
                const sourceInfo = this.getOrCreateScriptInfoNotOpenedByClient(sourceFileName, project.currentDirectory, project.directoryStructureHost, /*deferredDeleteOk*/ false);
                (sourceInfos || (sourceInfos = /* @__PURE__ */ new Set())).add(sourceInfo.path);
            }
            return sourceInfos;
        }
        addMissingSourceMapFile(mapFileName, declarationInfoPath) {
            const fileWatcher = this.watchFactory.watchFile(mapFileName, ()=>{
                const declarationInfo = this.getScriptInfoForPath(declarationInfoPath);
                if (declarationInfo && declarationInfo.sourceMapFilePath && !isString(declarationInfo.sourceMapFilePath)) {
                    this.delayUpdateProjectGraphs(declarationInfo.containingProjects, /*clearSourceMapperCache*/ true);
                    this.delayUpdateSourceInfoProjects(declarationInfo.sourceMapFilePath.sourceInfos);
                    declarationInfo.closeSourceMapFileWatcher();
                }
            }, 2e3 /* High */ , this.hostConfiguration.watchOptions, WatchType.MissingSourceMapFile);
            return fileWatcher;
        }
        /** @internal */ getSourceFileLike(fileName, projectNameOrProject, declarationInfo) {
            const project = projectNameOrProject.projectName ? projectNameOrProject : this.findProject(projectNameOrProject);
            if (project) {
                const path = project.toPath(fileName);
                const sourceFile = project.getSourceFile(path);
                if (sourceFile && sourceFile.resolvedPath === path) return sourceFile;
            }
            const info = this.getOrCreateScriptInfoNotOpenedByClient(fileName, (project || this).currentDirectory, project ? project.directoryStructureHost : this.host, /*deferredDeleteOk*/ false);
            if (!info) return void 0;
            if (declarationInfo && isString(declarationInfo.sourceMapFilePath) && info !== declarationInfo) {
                const sourceMapInfo = this.getScriptInfoForPath(declarationInfo.sourceMapFilePath);
                var _sourceMapInfo_sourceInfos;
                if (sourceMapInfo) ((_sourceMapInfo_sourceInfos = sourceMapInfo.sourceInfos) !== null && _sourceMapInfo_sourceInfos !== void 0 ? _sourceMapInfo_sourceInfos : sourceMapInfo.sourceInfos = /* @__PURE__ */ new Set()).add(info.path);
            }
            if (info.cacheSourceFile) return info.cacheSourceFile.sourceFile;
            if (!info.sourceFileLike) info.sourceFileLike = {
                get text () {
                    Debug.fail("shouldnt need text");
                    return "";
                },
                getLineAndCharacterOfPosition: (pos)=>{
                    const lineOffset = info.positionToLineOffset(pos);
                    return {
                        line: lineOffset.line - 1,
                        character: lineOffset.offset - 1
                    };
                },
                getPositionOfLineAndCharacter: (line, character, allowEdits)=>info.lineOffsetToPosition(line + 1, character + 1, allowEdits)
            };
            return info.sourceFileLike;
        }
        /** @internal */ setPerformanceEventHandler(performanceEventHandler) {
            this.performanceEventHandler = performanceEventHandler;
        }
        setHostConfiguration(args) {
            var _a;
            if (args.file) {
                const info = this.getScriptInfoForNormalizedPath(toNormalizedPath(args.file));
                if (info) {
                    info.setOptions(convertFormatOptions(args.formatOptions), args.preferences);
                    this.logger.info(`Host configuration update for file ${args.file}`);
                }
            } else {
                if (args.hostInfo !== void 0) {
                    this.hostConfiguration.hostInfo = args.hostInfo;
                    this.logger.info(`Host information ${args.hostInfo}`);
                }
                if (args.formatOptions) {
                    this.hostConfiguration.formatCodeOptions = (0, _objectSpread._)({}, this.hostConfiguration.formatCodeOptions, convertFormatOptions(args.formatOptions));
                    this.logger.info("Format host information updated");
                }
                if (args.preferences) {
                    const { lazyConfiguredProjectsFromExternalProject, includePackageJsonAutoImports, includeCompletionsForModuleExports } = this.hostConfiguration.preferences;
                    this.hostConfiguration.preferences = (0, _objectSpread._)({}, this.hostConfiguration.preferences, args.preferences);
                    if (lazyConfiguredProjectsFromExternalProject && !this.hostConfiguration.preferences.lazyConfiguredProjectsFromExternalProject) this.externalProjectToConfiguredProjectMap.forEach((projects)=>projects.forEach((project)=>{
                            if (!project.deferredClose && !project.isClosed() && project.pendingUpdateLevel === 2 /* Full */  && !this.hasPendingProjectUpdate(project)) project.updateGraph();
                        }));
                    if (includePackageJsonAutoImports !== args.preferences.includePackageJsonAutoImports || !!includeCompletionsForModuleExports !== !!args.preferences.includeCompletionsForModuleExports) this.forEachProject((project)=>{
                        project.onAutoImportProviderSettingsChanged();
                    });
                }
                if (args.extraFileExtensions) {
                    this.hostConfiguration.extraFileExtensions = args.extraFileExtensions;
                    this.reloadProjects();
                    this.logger.info("Host file extension mappings updated");
                }
                if (args.watchOptions) {
                    const watchOptions = (_a = convertWatchOptions(args.watchOptions)) == null ? void 0 : _a.watchOptions;
                    const substitution = handleWatchOptionsConfigDirTemplateSubstitution(watchOptions, this.currentDirectory);
                    this.hostConfiguration.watchOptions = substitution;
                    this.hostConfiguration.beforeSubstitution = substitution === watchOptions ? void 0 : watchOptions;
                    this.logger.info(`Host watch options changed to ${JSON.stringify(this.hostConfiguration.watchOptions)}, it will be take effect for next watches.`);
                }
            }
        }
        /** @internal */ getWatchOptions(project) {
            return this.getWatchOptionsFromProjectWatchOptions(project.getWatchOptions(), project.getCurrentDirectory());
        }
        getWatchOptionsFromProjectWatchOptions(projectOptions, basePath) {
            const hostWatchOptions = !this.hostConfiguration.beforeSubstitution ? this.hostConfiguration.watchOptions : handleWatchOptionsConfigDirTemplateSubstitution(this.hostConfiguration.beforeSubstitution, basePath);
            return projectOptions && hostWatchOptions ? (0, _objectSpread._)({}, hostWatchOptions, projectOptions) : projectOptions || hostWatchOptions;
        }
        closeLog() {
            this.logger.close();
        }
        sendSourceFileChange(inPath) {
            this.filenameToScriptInfo.forEach((info)=>{
                if (this.openFiles.has(info.path)) return;
                if (!info.fileWatcher) return;
                const eventKind = memoize(()=>this.host.fileExists(info.fileName) ? info.deferredDelete ? 0 /* Created */  : 1 /* Changed */  : 2 /* Deleted */ );
                if (inPath) {
                    if (isScriptInfoWatchedFromNodeModules(info) || !info.path.startsWith(inPath)) return;
                    if (eventKind() === 2 /* Deleted */  && info.deferredDelete) return;
                    this.logger.info(`Invoking sourceFileChange on ${info.fileName}:: ${eventKind()}`);
                }
                this.onSourceFileChanged(info, eventKind());
            });
        }
        /**
   * This function rebuilds the project for every file opened by the client
   * This does not reload contents of open files from disk. But we could do that if needed
   */ reloadProjects() {
            this.logger.info("reload projects.");
            this.sendSourceFileChange(/*inPath*/ void 0);
            this.pendingProjectUpdates.forEach((_project, projectName)=>{
                this.throttledOperations.cancel(projectName);
                this.pendingProjectUpdates.delete(projectName);
            });
            this.throttledOperations.cancel(ensureProjectForOpenFileSchedule);
            this.pendingOpenFileProjectUpdates = void 0;
            this.pendingEnsureProjectForOpenFiles = false;
            this.configFileExistenceInfoCache.forEach((info)=>{
                if (info.config) {
                    info.config.updateLevel = 2 /* Full */ ;
                    info.config.cachedDirectoryStructureHost.clearCache();
                }
            });
            this.configFileForOpenFiles.clear();
            this.externalProjects.forEach((project)=>{
                this.clearSemanticCache(project);
                project.updateGraph();
            });
            const reloadedConfiguredProjects = /* @__PURE__ */ new Map();
            const delayReloadedConfiguredProjects = /* @__PURE__ */ new Set();
            this.externalProjectToConfiguredProjectMap.forEach((projects, externalProjectName)=>{
                const reason = `Reloading configured project in external project: ${externalProjectName}`;
                projects.forEach((project)=>{
                    if (this.getHostPreferences().lazyConfiguredProjectsFromExternalProject) this.reloadConfiguredProjectOptimized(project, reason, reloadedConfiguredProjects);
                    else this.reloadConfiguredProjectClearingSemanticCache(project, reason, reloadedConfiguredProjects);
                });
            });
            this.openFiles.forEach((_projectRootPath, path)=>{
                const info = this.getScriptInfoForPath(path);
                if (find(info.containingProjects, isExternalProject)) return;
                this.tryFindDefaultConfiguredProjectAndLoadAncestorsForOpenScriptInfo(info, 7 /* Reload */ , reloadedConfiguredProjects, delayReloadedConfiguredProjects);
            });
            delayReloadedConfiguredProjects.forEach((p)=>reloadedConfiguredProjects.set(p, 7 /* Reload */ ));
            this.inferredProjects.forEach((project)=>this.clearSemanticCache(project));
            this.ensureProjectForOpenFiles();
            this.cleanupProjectsAndScriptInfos(reloadedConfiguredProjects, new Set(this.openFiles.keys()), new Set(this.externalProjectToConfiguredProjectMap.keys()));
            this.logger.info("After reloading projects..");
            this.printProjects();
        }
        /**
   * Remove the root of inferred project if script info is part of another project
   */ removeRootOfInferredProjectIfNowPartOfOtherProject(info) {
            Debug.assert(info.containingProjects.length > 0);
            const firstProject = info.containingProjects[0];
            if (!firstProject.isOrphan() && isInferredProject(firstProject) && firstProject.isRoot(info) && forEach(info.containingProjects, (p)=>p !== firstProject && !p.isOrphan())) firstProject.removeFile(info, /*fileExists*/ true, /*detachFromProject*/ true);
        }
        /**
   * This function is to update the project structure for every inferred project.
   * It is called on the premise that all the configured projects are
   * up to date.
   * This will go through open files and assign them to inferred project if open file is not part of any other project
   * After that all the inferred project graphs are updated
   */ ensureProjectForOpenFiles() {
            this.logger.info("Before ensureProjectForOpenFiles:");
            this.printProjects();
            const pendingOpenFileProjectUpdates = this.pendingOpenFileProjectUpdates;
            this.pendingOpenFileProjectUpdates = void 0;
            pendingOpenFileProjectUpdates == null || pendingOpenFileProjectUpdates.forEach((_config, path)=>this.tryFindDefaultConfiguredProjectAndLoadAncestorsForOpenScriptInfo(this.getScriptInfoForPath(path), 5 /* Create */ ));
            this.openFiles.forEach((projectRootPath, path)=>{
                const info = this.getScriptInfoForPath(path);
                if (info.isOrphan()) this.assignOrphanScriptInfoToInferredProject(info, projectRootPath);
                else this.removeRootOfInferredProjectIfNowPartOfOtherProject(info);
            });
            this.pendingEnsureProjectForOpenFiles = false;
            this.inferredProjects.forEach(updateProjectIfDirty);
            this.logger.info("After ensureProjectForOpenFiles:");
            this.printProjects();
        }
        /**
   * Open file whose contents is managed by the client
   * @param filename is absolute pathname
   * @param fileContent is a known version of the file content that is more up to date than the one on disk
   */ openClientFile(fileName, fileContent, scriptKind, projectRootPath) {
            return this.openClientFileWithNormalizedPath(toNormalizedPath(fileName), fileContent, scriptKind, /*hasMixedContent*/ false, projectRootPath ? toNormalizedPath(projectRootPath) : void 0);
        }
        /** @internal */ getOriginalLocationEnsuringConfiguredProject(project, location) {
            const isSourceOfProjectReferenceRedirect = project.isSourceOfProjectReferenceRedirect(location.fileName);
            const originalLocation = isSourceOfProjectReferenceRedirect ? location : project.getSourceMapper().tryGetSourcePosition(location);
            if (!originalLocation) return void 0;
            const { fileName } = originalLocation;
            const scriptInfo = this.getScriptInfo(fileName);
            if (!scriptInfo && !this.host.fileExists(fileName)) return void 0;
            const originalFileInfo = {
                fileName: toNormalizedPath(fileName),
                path: this.toPath(fileName)
            };
            const configFileName = this.getConfigFileNameForFile(originalFileInfo, /*findFromCacheOnly*/ false);
            if (!configFileName) return void 0;
            let configuredProject = this.findConfiguredProjectByProjectName(configFileName);
            if (!configuredProject) {
                if (project.getCompilerOptions().disableReferencedProjectLoad) {
                    if (isSourceOfProjectReferenceRedirect) return location;
                    return (scriptInfo == null ? void 0 : scriptInfo.containingProjects.length) ? originalLocation : location;
                }
                configuredProject = this.createConfiguredProject(configFileName, `Creating project for original file: ${originalFileInfo.fileName}${location !== originalLocation ? " for location: " + location.fileName : ""}`);
            }
            const result = this.tryFindDefaultConfiguredProjectForOpenScriptInfoOrClosedFileInfo(originalFileInfo, 5 /* Create */ , updateProjectFoundUsingFind(configuredProject, 4 /* CreateOptimized */ ), (project2)=>`Creating project referenced in solution ${project2.projectName} to find possible configured project for original file: ${originalFileInfo.fileName}${location !== originalLocation ? " for location: " + location.fileName : ""}`);
            if (!result.defaultProject) return void 0;
            if (result.defaultProject === project) return originalLocation;
            addOriginalConfiguredProject(result.defaultProject);
            const originalScriptInfo = this.getScriptInfo(fileName);
            if (!originalScriptInfo || !originalScriptInfo.containingProjects.length) return void 0;
            originalScriptInfo.containingProjects.forEach((project2)=>{
                if (isConfiguredProject(project2)) addOriginalConfiguredProject(project2);
            });
            return originalLocation;
            function addOriginalConfiguredProject(originalProject) {
                var _project_originalConfiguredProjects;
                ((_project_originalConfiguredProjects = project.originalConfiguredProjects) !== null && _project_originalConfiguredProjects !== void 0 ? _project_originalConfiguredProjects : project.originalConfiguredProjects = /* @__PURE__ */ new Set()).add(originalProject.canonicalConfigFilePath);
            }
        }
        /** @internal */ fileExists(fileName) {
            return !!this.getScriptInfoForNormalizedPath(fileName) || this.host.fileExists(fileName);
        }
        findExternalProjectContainingOpenScriptInfo(info) {
            return find(this.externalProjects, (proj)=>{
                updateProjectIfDirty(proj);
                return proj.containsScriptInfo(info);
            });
        }
        getOrCreateOpenScriptInfo(fileName, fileContent, scriptKind, hasMixedContent, projectRootPath) {
            const info = this.getOrCreateScriptInfoWorker(fileName, projectRootPath ? this.getNormalizedAbsolutePath(projectRootPath) : this.currentDirectory, /*openedByClient*/ true, fileContent, scriptKind, !!hasMixedContent, /*hostToQueryFileExistsOn*/ void 0, /*deferredDeleteOk*/ true);
            this.openFiles.set(info.path, projectRootPath);
            return info;
        }
        assignProjectToOpenedScriptInfo(info) {
            let configFileName;
            let configFileErrors;
            const project = this.findExternalProjectContainingOpenScriptInfo(info);
            let retainProjects;
            let sentConfigDiag;
            if (!project && this.serverMode === 0 /* Semantic */ ) {
                const result = this.tryFindDefaultConfiguredProjectAndLoadAncestorsForOpenScriptInfo(info, 5 /* Create */ );
                if (result) {
                    retainProjects = result.seenProjects;
                    sentConfigDiag = result.sentConfigDiag;
                    if (result.defaultProject) {
                        configFileName = result.defaultProject.getConfigFilePath();
                        configFileErrors = result.defaultProject.getAllProjectErrors();
                    }
                }
            }
            info.containingProjects.forEach(updateProjectIfDirty);
            if (info.isOrphan()) {
                retainProjects == null || retainProjects.forEach((kind, project2)=>{
                    if (kind !== 4 /* CreateOptimized */  && !sentConfigDiag.has(project2)) this.sendConfigFileDiagEvent(project2, info.fileName, /*force*/ true);
                });
                Debug.assert(this.openFiles.has(info.path));
                this.assignOrphanScriptInfoToInferredProject(info, this.openFiles.get(info.path));
            }
            Debug.assert(!info.isOrphan());
            return {
                configFileName,
                configFileErrors,
                retainProjects
            };
        }
        /**
   * Depending on kind
   * - Find the configuedProject and return it - if allowDeferredClosed is set it will find the deferredClosed project as well
   * - Create - if the project doesnt exist, it creates one as well. If not delayLoad, the project is updated (with triggerFile if passed)
   * - Reload - if the project doesnt exist, it creates one. If not delayLoad, the project is reloaded clearing semantic cache
   *  @internal
   */ findCreateOrReloadConfiguredProject(configFileName, kind, reason, allowDeferredClosed, triggerFile, reloadedProjects, delayLoad, delayReloadedConfiguredProjects, projectForConfigFile) {
            let project = projectForConfigFile !== null && projectForConfigFile !== void 0 ? projectForConfigFile : this.findConfiguredProjectByProjectName(configFileName, allowDeferredClosed);
            let sentConfigFileDiag = false;
            let configFileExistenceInfo;
            switch(kind){
                case 0 /* FindOptimized */ :
                case 1 /* Find */ :
                case 3 /* CreateReplay */ :
                    if (!project) return;
                    break;
                case 2 /* CreateReplayOptimized */ :
                    if (!project) return;
                    configFileExistenceInfo = configFileExistenceInfoForOptimizedReplay(project);
                    break;
                case 4 /* CreateOptimized */ :
                case 5 /* Create */ :
                    project !== null && project !== void 0 ? project : project = this.createConfiguredProject(configFileName, reason);
                    if (!delayLoad) ({ sentConfigFileDiag, configFileExistenceInfo } = updateProjectFoundUsingFind(project, kind, triggerFile));
                    break;
                case 6 /* ReloadOptimized */ :
                    project !== null && project !== void 0 ? project : project = this.createConfiguredProject(configFileName, reloadReason(reason));
                    project.projectService.reloadConfiguredProjectOptimized(project, reason, reloadedProjects);
                    configFileExistenceInfo = configFileExistenceInfoForOptimizedLoading(project);
                    if (configFileExistenceInfo) break;
                // falls through
                case 7 /* Reload */ :
                    project !== null && project !== void 0 ? project : project = this.createConfiguredProject(configFileName, reloadReason(reason));
                    sentConfigFileDiag = !delayReloadedConfiguredProjects && this.reloadConfiguredProjectClearingSemanticCache(project, reason, reloadedProjects);
                    if (delayReloadedConfiguredProjects && !delayReloadedConfiguredProjects.has(project) && !reloadedProjects.has(project)) {
                        this.setProjectForReload(project, 2 /* Full */ , reason);
                        delayReloadedConfiguredProjects.add(project);
                    }
                    break;
                default:
                    Debug.assertNever(kind);
            }
            return {
                project,
                sentConfigFileDiag,
                configFileExistenceInfo,
                reason
            };
        }
        /**
   * Finds the default configured project for given info
   * For any tsconfig found, it looks into that project, if not then all its references,
   * The search happens for all tsconfigs till projectRootPath
   */ tryFindDefaultConfiguredProjectForOpenScriptInfo(info, kind, allowDeferredClosed, reloadedProjects) {
            const configFileName = this.getConfigFileNameForFile(info, kind <= 3 /* CreateReplay */ );
            if (!configFileName) return;
            const optimizedKind = toConfiguredProjectLoadOptimized(kind);
            const result = this.findCreateOrReloadConfiguredProject(configFileName, optimizedKind, fileOpenReason(info), allowDeferredClosed, info.fileName, reloadedProjects);
            return result && this.tryFindDefaultConfiguredProjectForOpenScriptInfoOrClosedFileInfo(info, kind, result, (project)=>`Creating project referenced in solution ${project.projectName} to find possible configured project for ${info.fileName} to open`, allowDeferredClosed, reloadedProjects);
        }
        isMatchedByConfig(configFileName, config, info) {
            if (config.fileNames.some((rootName)=>this.toPath(rootName) === info.path)) return true;
            if (isSupportedSourceFileName(info.fileName, config.options, this.hostConfiguration.extraFileExtensions)) return false;
            const { validatedFilesSpec, validatedIncludeSpecs, validatedExcludeSpecs } = config.options.configFile.configFileSpecs;
            const basePath = toNormalizedPath(getNormalizedAbsolutePath(getDirectoryPath(configFileName), this.currentDirectory));
            if (validatedFilesSpec == null ? void 0 : validatedFilesSpec.some((fileSpec)=>this.toPath(getNormalizedAbsolutePath(fileSpec, basePath)) === info.path)) return true;
            if (!(validatedIncludeSpecs == null ? void 0 : validatedIncludeSpecs.length)) return false;
            if (matchesExcludeWorker(info.fileName, validatedExcludeSpecs, this.host.useCaseSensitiveFileNames, this.currentDirectory, basePath)) return false;
            return validatedIncludeSpecs == null ? void 0 : validatedIncludeSpecs.some((includeSpec)=>{
                const pattern = getPatternFromSpec(includeSpec, basePath, "files");
                return !!pattern && getRegexFromPattern(`(${pattern})$`, this.host.useCaseSensitiveFileNames).test(info.fileName);
            });
        }
        tryFindDefaultConfiguredProjectForOpenScriptInfoOrClosedFileInfo(info, kind, initialConfigResult, referencedProjectReason, allowDeferredClosed, reloadedProjects) {
            const infoIsOpenScriptInfo = isOpenScriptInfo(info);
            const optimizedKind = toConfiguredProjectLoadOptimized(kind);
            const seenProjects = /* @__PURE__ */ new Map();
            let seenConfigs;
            const sentConfigDiag = /* @__PURE__ */ new Set();
            let defaultProject;
            let possiblyDefault;
            let tsconfigOfDefault;
            let tsconfigOfPossiblyDefault;
            tryFindDefaultConfiguredProject(initialConfigResult);
            return {
                defaultProject: defaultProject !== null && defaultProject !== void 0 ? defaultProject : possiblyDefault,
                tsconfigProject: tsconfigOfDefault !== null && tsconfigOfDefault !== void 0 ? tsconfigOfDefault : tsconfigOfPossiblyDefault,
                sentConfigDiag,
                seenProjects,
                seenConfigs
            };
            function tryFindDefaultConfiguredProject(result) {
                var _isDefaultProjectOptimized, _ref;
                return (_ref = (_isDefaultProjectOptimized = isDefaultProjectOptimized(result, result.project)) !== null && _isDefaultProjectOptimized !== void 0 ? _isDefaultProjectOptimized : tryFindDefaultConfiguredProjectFromReferences(result.project)) !== null && _ref !== void 0 ? _ref : tryFindDefaultConfiguredProjectFromAncestor(result.project);
            }
            function isDefaultConfigFileExistenceInfo(configFileExistenceInfo, project, childConfigName, reason, tsconfigProject, canonicalConfigFilePath) {
                if (project) {
                    if (seenProjects.has(project)) return;
                    seenProjects.set(project, optimizedKind);
                } else {
                    if (seenConfigs == null ? void 0 : seenConfigs.has(canonicalConfigFilePath)) return;
                    (seenConfigs !== null && seenConfigs !== void 0 ? seenConfigs : seenConfigs = /* @__PURE__ */ new Set()).add(canonicalConfigFilePath);
                }
                if (!tsconfigProject.projectService.isMatchedByConfig(childConfigName, configFileExistenceInfo.config.parsedCommandLine, info)) {
                    if (tsconfigProject.languageServiceEnabled) tsconfigProject.projectService.watchWildcards(childConfigName, configFileExistenceInfo, tsconfigProject);
                    return;
                }
                const result = project ? updateProjectFoundUsingFind(project, kind, info.fileName, reason, reloadedProjects) : tsconfigProject.projectService.findCreateOrReloadConfiguredProject(childConfigName, kind, reason, allowDeferredClosed, info.fileName, reloadedProjects);
                if (!result) {
                    Debug.assert(kind === 3 /* CreateReplay */ );
                    return void 0;
                }
                seenProjects.set(result.project, optimizedKind);
                if (result.sentConfigFileDiag) sentConfigDiag.add(result.project);
                return isDefaultProject(result.project, tsconfigProject);
            }
            function isDefaultProject(project, tsconfigProject) {
                if (seenProjects.get(project) === kind) return;
                seenProjects.set(project, kind);
                const scriptInfo = infoIsOpenScriptInfo ? info : project.projectService.getScriptInfo(info.fileName);
                const projectWithInfo = scriptInfo && project.containsScriptInfo(scriptInfo);
                if (projectWithInfo && !project.isSourceOfProjectReferenceRedirect(scriptInfo.path)) {
                    tsconfigOfDefault = tsconfigProject;
                    return defaultProject = project;
                }
                if (!possiblyDefault && infoIsOpenScriptInfo && projectWithInfo) {
                    tsconfigOfPossiblyDefault = tsconfigProject;
                    possiblyDefault = project;
                }
            }
            function isDefaultProjectOptimized(result, tsconfigProject) {
                if (result.sentConfigFileDiag) sentConfigDiag.add(result.project);
                return result.configFileExistenceInfo ? isDefaultConfigFileExistenceInfo(result.configFileExistenceInfo, result.project, toNormalizedPath(result.project.getConfigFilePath()), result.reason, result.project, result.project.canonicalConfigFilePath) : isDefaultProject(result.project, tsconfigProject);
            }
            function tryFindDefaultConfiguredProjectFromReferences(project) {
                return project.parsedCommandLine && forEachResolvedProjectReferenceProjectLoad(project, project.parsedCommandLine, isDefaultConfigFileExistenceInfo, optimizedKind, referencedProjectReason(project), allowDeferredClosed, reloadedProjects);
            }
            function tryFindDefaultConfiguredProjectFromAncestor(project) {
                return infoIsOpenScriptInfo ? forEachAncestorProjectLoad(// If not in referenced projects, try ancestors and its references
                info, project, tryFindDefaultConfiguredProject, optimizedKind, `Creating possible configured project for ${info.fileName} to open`, allowDeferredClosed, reloadedProjects, /*searchOnlyPotentialSolution*/ false) : void 0;
            }
        }
        tryFindDefaultConfiguredProjectAndLoadAncestorsForOpenScriptInfo(info, kind, reloadedProjects, delayReloadedConfiguredProjects) {
            const allowDeferredClosed = kind === 1 /* Find */ ;
            const result = this.tryFindDefaultConfiguredProjectForOpenScriptInfo(info, kind, allowDeferredClosed, reloadedProjects);
            if (!result) return;
            const { defaultProject, tsconfigProject, seenProjects } = result;
            if (defaultProject) forEachAncestorProjectLoad(info, tsconfigProject, (ancestor)=>{
                seenProjects.set(ancestor.project, kind);
            }, kind, `Creating project possibly referencing default composite project ${defaultProject.getProjectName()} of open file ${info.fileName}`, allowDeferredClosed, reloadedProjects, /*searchOnlyPotentialSolution*/ true, delayReloadedConfiguredProjects);
            return result;
        }
        /** @internal */ loadAncestorProjectTree(forProjects) {
            forProjects !== null && forProjects !== void 0 ? forProjects : forProjects = new Set(mapDefinedIterator(this.configuredProjects.entries(), ([key, project])=>!project.initialLoadPending ? key : void 0));
            const seenProjects = /* @__PURE__ */ new Set();
            const currentConfiguredProjects = arrayFrom(this.configuredProjects.values());
            for (const project of currentConfiguredProjects){
                if (forEachPotentialProjectReference(project, (potentialRefPath)=>forProjects.has(potentialRefPath))) updateProjectIfDirty(project);
                this.ensureProjectChildren(project, forProjects, seenProjects);
            }
        }
        ensureProjectChildren(project, forProjects, seenProjects) {
            var _a;
            if (!tryAddToSet(seenProjects, project.canonicalConfigFilePath)) return;
            if (project.getCompilerOptions().disableReferencedProjectLoad) return;
            const children = (_a = project.getCurrentProgram()) == null ? void 0 : _a.getResolvedProjectReferences();
            if (!children) return;
            for (const child of children){
                if (!child) continue;
                const referencedProject = forEachResolvedProjectReference(child.references, (ref)=>forProjects.has(ref.sourceFile.path) ? ref : void 0);
                if (!referencedProject) continue;
                const configFileName = toNormalizedPath(child.sourceFile.fileName);
                var _this_findConfiguredProjectByProjectName;
                const childProject = (_this_findConfiguredProjectByProjectName = this.findConfiguredProjectByProjectName(configFileName)) !== null && _this_findConfiguredProjectByProjectName !== void 0 ? _this_findConfiguredProjectByProjectName : this.createConfiguredProject(configFileName, `Creating project referenced by : ${project.projectName} as it references project ${referencedProject.sourceFile.fileName}`);
                updateProjectIfDirty(childProject);
                this.ensureProjectChildren(childProject, forProjects, seenProjects);
            }
        }
        cleanupConfiguredProjects(toRetainConfiguredProjects, externalProjectsRetainingConfiguredProjects, openFilesWithRetainedConfiguredProject) {
            this.getOrphanConfiguredProjects(toRetainConfiguredProjects, openFilesWithRetainedConfiguredProject, externalProjectsRetainingConfiguredProjects).forEach((project)=>this.removeProject(project));
        }
        cleanupProjectsAndScriptInfos(toRetainConfiguredProjects, openFilesWithRetainedConfiguredProject, externalProjectsRetainingConfiguredProjects) {
            this.cleanupConfiguredProjects(toRetainConfiguredProjects, externalProjectsRetainingConfiguredProjects, openFilesWithRetainedConfiguredProject);
            for (const inferredProject of this.inferredProjects.slice())if (inferredProject.isOrphan()) this.removeProject(inferredProject);
            this.removeOrphanScriptInfos();
        }
        tryInvokeWildCardDirectories(info) {
            this.configFileExistenceInfoCache.forEach((configFileExistenceInfo, config)=>{
                var _a, _b;
                if (!((_a = configFileExistenceInfo.config) == null ? void 0 : _a.parsedCommandLine) || contains(configFileExistenceInfo.config.parsedCommandLine.fileNames, info.fileName, !this.host.useCaseSensitiveFileNames ? equateStringsCaseInsensitive : equateStringsCaseSensitive)) return;
                (_b = configFileExistenceInfo.config.watchedDirectories) == null || _b.forEach((watcher, directory)=>{
                    if (containsPath(directory, info.fileName, !this.host.useCaseSensitiveFileNames)) {
                        this.logger.info(`Invoking ${config}:: wildcard for open scriptInfo:: ${info.fileName}`);
                        this.onWildCardDirectoryWatcherInvoke(directory, config, configFileExistenceInfo.config, watcher.watcher, info.fileName);
                    }
                });
            });
        }
        openClientFileWithNormalizedPath(fileName, fileContent, scriptKind, hasMixedContent, projectRootPath) {
            const existing = this.getScriptInfoForPath(normalizedPathToPath(fileName, projectRootPath ? this.getNormalizedAbsolutePath(projectRootPath) : this.currentDirectory, this.toCanonicalFileName));
            const info = this.getOrCreateOpenScriptInfo(fileName, fileContent, scriptKind, hasMixedContent, projectRootPath);
            if (!existing && info && !info.isDynamic) this.tryInvokeWildCardDirectories(info);
            const _this_assignProjectToOpenedScriptInfo = this.assignProjectToOpenedScriptInfo(info), { retainProjects } = _this_assignProjectToOpenedScriptInfo, result = (0, _objectWithoutProperties._)(_this_assignProjectToOpenedScriptInfo, [
                "retainProjects"
            ]);
            this.cleanupProjectsAndScriptInfos(retainProjects, /* @__PURE__ */ new Set([
                info.path
            ]), /*externalProjectsRetainingConfiguredProjects*/ void 0);
            this.telemetryOnOpenFile(info);
            this.printProjects();
            return result;
        }
        /** @internal */ getOrphanConfiguredProjects(toRetainConfiguredProjects, openFilesWithRetainedConfiguredProject, externalProjectsRetainingConfiguredProjects) {
            const toRemoveConfiguredProjects = new Set(this.configuredProjects.values());
            const markOriginalProjectsAsUsed = (project)=>{
                if (project.originalConfiguredProjects && (isConfiguredProject(project) || !project.isOrphan())) project.originalConfiguredProjects.forEach((_value, configuredProjectPath)=>{
                    const project2 = this.getConfiguredProjectByCanonicalConfigFilePath(configuredProjectPath);
                    return project2 && retainConfiguredProject(project2);
                });
            };
            toRetainConfiguredProjects == null || toRetainConfiguredProjects.forEach((_, project)=>retainConfiguredProject(project));
            if (!toRemoveConfiguredProjects.size) return toRemoveConfiguredProjects;
            this.inferredProjects.forEach(markOriginalProjectsAsUsed);
            this.externalProjects.forEach(markOriginalProjectsAsUsed);
            this.externalProjectToConfiguredProjectMap.forEach((projects, externalProjectName)=>{
                if (!(externalProjectsRetainingConfiguredProjects == null ? void 0 : externalProjectsRetainingConfiguredProjects.has(externalProjectName))) projects.forEach(retainConfiguredProject);
            });
            if (!toRemoveConfiguredProjects.size) return toRemoveConfiguredProjects;
            forEachEntry(this.openFiles, (_projectRootPath, path)=>{
                if (openFilesWithRetainedConfiguredProject == null ? void 0 : openFilesWithRetainedConfiguredProject.has(path)) return;
                const info = this.getScriptInfoForPath(path);
                if (find(info.containingProjects, isExternalProject)) return;
                const result = this.tryFindDefaultConfiguredProjectAndLoadAncestorsForOpenScriptInfo(info, 1 /* Find */ );
                if (result == null ? void 0 : result.defaultProject) {
                    result == null || result.seenProjects.forEach((_, project)=>retainConfiguredProject(project));
                    if (!toRemoveConfiguredProjects.size) return toRemoveConfiguredProjects;
                }
            });
            if (!toRemoveConfiguredProjects.size) return toRemoveConfiguredProjects;
            forEachEntry(this.configuredProjects, (project)=>{
                if (toRemoveConfiguredProjects.has(project)) {
                    if (isPendingUpdate(project) || forEachReferencedProject(project, isRetained)) {
                        retainConfiguredProject(project);
                        if (!toRemoveConfiguredProjects.size) return toRemoveConfiguredProjects;
                    }
                }
            });
            return toRemoveConfiguredProjects;
            function isRetained(project) {
                return !toRemoveConfiguredProjects.has(project) || isPendingUpdate(project);
            }
            function isPendingUpdate(project) {
                var _a, _b;
                return (project.deferredClose || project.projectService.hasPendingProjectUpdate(project)) && !!((_b = (_a = project.projectService.configFileExistenceInfoCache.get(project.canonicalConfigFilePath)) == null ? void 0 : _a.openFilesImpactedByConfigFile) == null ? void 0 : _b.size);
            }
            function retainConfiguredProject(project) {
                if (!toRemoveConfiguredProjects.delete(project)) return;
                markOriginalProjectsAsUsed(project);
                forEachReferencedProject(project, retainConfiguredProject);
            }
        }
        removeOrphanScriptInfos() {
            const toRemoveScriptInfos = new Map(this.filenameToScriptInfo);
            this.filenameToScriptInfo.forEach((info)=>{
                if (info.deferredDelete) return;
                if (!info.isScriptOpen() && info.isOrphan() && !scriptInfoIsContainedByDeferredClosedProject(info) && !scriptInfoIsContainedByBackgroundProject(info)) {
                    if (!info.sourceMapFilePath) return;
                    let sourceInfos;
                    if (isString(info.sourceMapFilePath)) {
                        const sourceMapInfo = this.filenameToScriptInfo.get(info.sourceMapFilePath);
                        sourceInfos = sourceMapInfo == null ? void 0 : sourceMapInfo.sourceInfos;
                    } else sourceInfos = info.sourceMapFilePath.sourceInfos;
                    if (!sourceInfos) return;
                    if (!forEachKey(sourceInfos, (path)=>{
                        const info2 = this.getScriptInfoForPath(path);
                        return !!info2 && (info2.isScriptOpen() || !info2.isOrphan());
                    })) return;
                }
                toRemoveScriptInfos.delete(info.path);
                if (info.sourceMapFilePath) {
                    let sourceInfos;
                    if (isString(info.sourceMapFilePath)) {
                        const sourceMapInfo = this.filenameToScriptInfo.get(info.sourceMapFilePath);
                        if (sourceMapInfo == null ? void 0 : sourceMapInfo.deferredDelete) info.sourceMapFilePath = {
                            watcher: this.addMissingSourceMapFile(sourceMapInfo.fileName, info.path),
                            sourceInfos: sourceMapInfo.sourceInfos
                        };
                        else toRemoveScriptInfos.delete(info.sourceMapFilePath);
                        sourceInfos = sourceMapInfo == null ? void 0 : sourceMapInfo.sourceInfos;
                    } else sourceInfos = info.sourceMapFilePath.sourceInfos;
                    if (sourceInfos) sourceInfos.forEach((_value, path)=>toRemoveScriptInfos.delete(path));
                }
            });
            toRemoveScriptInfos.forEach((info)=>this.deleteScriptInfo(info));
        }
        telemetryOnOpenFile(scriptInfo) {
            if (this.serverMode !== 0 /* Semantic */  || !this.eventHandler || !scriptInfo.isJavaScript() || !addToSeen(this.allJsFilesForOpenFileTelemetry, scriptInfo.path)) return;
            const project = this.ensureDefaultProjectForFile(scriptInfo);
            if (!project.languageServiceEnabled) return;
            const sourceFile = project.getSourceFile(scriptInfo.path);
            const checkJs = !!sourceFile && !!sourceFile.checkJsDirective;
            this.eventHandler({
                eventName: OpenFileInfoTelemetryEvent,
                data: {
                    info: {
                        checkJs
                    }
                }
            });
        }
        closeClientFile(uncheckedFileName, skipAssignOrphanScriptInfosToInferredProject) {
            const info = this.getScriptInfoForNormalizedPath(toNormalizedPath(uncheckedFileName));
            const result = info ? this.closeOpenFile(info, skipAssignOrphanScriptInfosToInferredProject) : false;
            if (!skipAssignOrphanScriptInfosToInferredProject) this.printProjects();
            return result;
        }
        collectChanges(lastKnownProjectVersions, currentProjects, includeProjectReferenceRedirectInfo, result) {
            for (const proj of currentProjects){
                const knownProject = find(lastKnownProjectVersions, (p)=>p.projectName === proj.getProjectName());
                result.push(proj.getChangesSinceVersion(knownProject && knownProject.version, includeProjectReferenceRedirectInfo));
            }
        }
        /** @internal */ synchronizeProjectList(knownProjects, includeProjectReferenceRedirectInfo) {
            const files = [];
            this.collectChanges(knownProjects, this.externalProjects, includeProjectReferenceRedirectInfo, files);
            this.collectChanges(knownProjects, mapDefinedIterator(this.configuredProjects.values(), (p)=>p.deferredClose ? void 0 : p), includeProjectReferenceRedirectInfo, files);
            this.collectChanges(knownProjects, this.inferredProjects, includeProjectReferenceRedirectInfo, files);
            return files;
        }
        /** @internal */ applyChangesInOpenFiles(openFiles, changedFiles, closedFiles) {
            let existingOpenScriptInfos;
            let openScriptInfos;
            let assignOrphanScriptInfosToInferredProject = false;
            if (openFiles) for (const file of openFiles){
                (existingOpenScriptInfos !== null && existingOpenScriptInfos !== void 0 ? existingOpenScriptInfos : existingOpenScriptInfos = []).push(this.getScriptInfoForPath(normalizedPathToPath(toNormalizedPath(file.fileName), file.projectRootPath ? this.getNormalizedAbsolutePath(file.projectRootPath) : this.currentDirectory, this.toCanonicalFileName)));
                const info = this.getOrCreateOpenScriptInfo(toNormalizedPath(file.fileName), file.content, tryConvertScriptKindName(file.scriptKind), file.hasMixedContent, file.projectRootPath ? toNormalizedPath(file.projectRootPath) : void 0);
                (openScriptInfos || (openScriptInfos = [])).push(info);
            }
            if (changedFiles) for (const file of changedFiles){
                const scriptInfo = this.getScriptInfo(file.fileName);
                Debug.assert(!!scriptInfo);
                this.applyChangesToFile(scriptInfo, file.changes);
            }
            if (closedFiles) for (const file of closedFiles)assignOrphanScriptInfosToInferredProject = this.closeClientFile(file, /*skipAssignOrphanScriptInfosToInferredProject*/ true) || assignOrphanScriptInfosToInferredProject;
            let retainProjects;
            forEach(existingOpenScriptInfos, (existing, index)=>!existing && openScriptInfos[index] && !openScriptInfos[index].isDynamic ? this.tryInvokeWildCardDirectories(openScriptInfos[index]) : void 0);
            openScriptInfos == null || openScriptInfos.forEach((info)=>{
                var _a;
                return (_a = this.assignProjectToOpenedScriptInfo(info).retainProjects) == null ? void 0 : _a.forEach((kind, p)=>(retainProjects !== null && retainProjects !== void 0 ? retainProjects : retainProjects = /* @__PURE__ */ new Map()).set(p, kind));
            });
            if (assignOrphanScriptInfosToInferredProject) this.assignOrphanScriptInfosToInferredProject();
            if (openScriptInfos) {
                this.cleanupProjectsAndScriptInfos(retainProjects, new Set(openScriptInfos.map((info)=>info.path)), /*externalProjectsRetainingConfiguredProjects*/ void 0);
                openScriptInfos.forEach((info)=>this.telemetryOnOpenFile(info));
                this.printProjects();
            } else if (length(closedFiles)) this.printProjects();
        }
        /** @internal */ applyChangesToFile(scriptInfo, changes) {
            for (const change of changes)scriptInfo.editContent(change.span.start, change.span.start + change.span.length, change.newText);
        }
        // eslint-disable-line @typescript-eslint/unified-signatures
        closeExternalProject(uncheckedFileName, cleanupAfter) {
            const fileName = toNormalizedPath(uncheckedFileName);
            const projects = this.externalProjectToConfiguredProjectMap.get(fileName);
            if (projects) this.externalProjectToConfiguredProjectMap.delete(fileName);
            else {
                const externalProject = this.findExternalProjectByProjectName(uncheckedFileName);
                if (externalProject) this.removeProject(externalProject);
            }
            if (cleanupAfter) {
                this.cleanupConfiguredProjects();
                this.printProjects();
            }
        }
        openExternalProjects(projects) {
            const projectsToClose = new Set(this.externalProjects.map((p)=>p.getProjectName()));
            this.externalProjectToConfiguredProjectMap.forEach((_, externalProjectName)=>projectsToClose.add(externalProjectName));
            for (const externalProject of projects){
                this.openExternalProject(externalProject, /*cleanupAfter*/ false);
                projectsToClose.delete(externalProject.projectFileName);
            }
            projectsToClose.forEach((externalProjectName)=>this.closeExternalProject(externalProjectName, /*cleanupAfter*/ false));
            this.cleanupConfiguredProjects();
            this.printProjects();
        }
        static escapeFilenameForRegex(filename) {
            return filename.replace(this.filenameEscapeRegexp, "\\$&");
        }
        resetSafeList() {
            this.safelist = defaultTypeSafeList;
        }
        applySafeList(proj) {
            const typeAcquisition = proj.typeAcquisition;
            Debug.assert(!!typeAcquisition, "proj.typeAcquisition should be set by now");
            const result = this.applySafeListWorker(proj, proj.rootFiles, typeAcquisition);
            var _ref;
            return (_ref = result == null ? void 0 : result.excludedFiles) !== null && _ref !== void 0 ? _ref : [];
        }
        applySafeListWorker(proj, rootFiles, typeAcquisition) {
            if (typeAcquisition.enable === false || typeAcquisition.disableFilenameBasedTypeAcquisition) return void 0;
            const typeAcqInclude = typeAcquisition.include || (typeAcquisition.include = []);
            const excludeRules = [];
            const normalizedNames = rootFiles.map((f)=>normalizeSlashes(f.fileName));
            for (const name of Object.keys(this.safelist)){
                const rule2 = this.safelist[name];
                for (const root of normalizedNames)if (rule2.match.test(root)) {
                    this.logger.info(`Excluding files based on rule ${name} matching file '${root}'`);
                    if (rule2.types) {
                        for (const type of rule2.types)if (!typeAcqInclude.includes(type)) typeAcqInclude.push(type);
                    }
                    if (rule2.exclude) for (const exclude of rule2.exclude){
                        const processedRule = root.replace(rule2.match, (...groups)=>{
                            return exclude.map((groupNumberOrString)=>{
                                if (typeof groupNumberOrString === "number") {
                                    if (!isString(groups[groupNumberOrString])) {
                                        this.logger.info(`Incorrect RegExp specification in safelist rule ${name} - not enough groups`);
                                        return "\\*";
                                    }
                                    return _ProjectService.escapeFilenameForRegex(groups[groupNumberOrString]);
                                }
                                return groupNumberOrString;
                            }).join("");
                        });
                        if (!excludeRules.includes(processedRule)) excludeRules.push(processedRule);
                    }
                    else {
                        const escaped = _ProjectService.escapeFilenameForRegex(root);
                        if (!excludeRules.includes(escaped)) excludeRules.push(escaped);
                    }
                }
            }
            const excludeRegexes = excludeRules.map((e)=>new RegExp(e, "i"));
            let filesToKeep;
            let excludedFiles;
            for(let i = 0; i < rootFiles.length; i++)if (excludeRegexes.some((re)=>re.test(normalizedNames[i]))) addExcludedFile(i);
            else {
                if (typeAcquisition.enable) {
                    const baseName = getBaseFileName(toFileNameLowerCase(normalizedNames[i]));
                    if (fileExtensionIs(baseName, "js")) {
                        const inferredTypingName = removeFileExtension(baseName);
                        const cleanedTypingName = removeMinAndVersionNumbers(inferredTypingName);
                        const typeName = this.legacySafelist.get(cleanedTypingName);
                        if (typeName !== void 0) {
                            this.logger.info(`Excluded '${normalizedNames[i]}' because it matched ${cleanedTypingName} from the legacy safelist`);
                            addExcludedFile(i);
                            if (!typeAcqInclude.includes(typeName)) typeAcqInclude.push(typeName);
                            continue;
                        }
                    }
                }
                if (/^.+[.-]min\.js$/.test(normalizedNames[i])) addExcludedFile(i);
                else filesToKeep == null || filesToKeep.push(rootFiles[i]);
            }
            return excludedFiles ? {
                rootFiles: filesToKeep,
                excludedFiles
            } : void 0;
            function addExcludedFile(index) {
                if (!excludedFiles) {
                    Debug.assert(!filesToKeep);
                    filesToKeep = rootFiles.slice(0, index);
                    excludedFiles = [];
                }
                excludedFiles.push(normalizedNames[index]);
            }
        }
        // eslint-disable-line @typescript-eslint/unified-signatures
        openExternalProject(proj, cleanupAfter) {
            const existingExternalProject = this.findExternalProjectByProjectName(proj.projectFileName);
            let configuredProjects;
            let rootFiles = [];
            for (const file of proj.rootFiles){
                const normalized = toNormalizedPath(file.fileName);
                if (getBaseConfigFileName(normalized)) {
                    if (this.serverMode === 0 /* Semantic */  && this.host.fileExists(normalized)) {
                        let project = this.findConfiguredProjectByProjectName(normalized);
                        if (!project) {
                            project = this.createConfiguredProject(normalized, `Creating configured project in external project: ${proj.projectFileName}`);
                            if (!this.getHostPreferences().lazyConfiguredProjectsFromExternalProject) project.updateGraph();
                        }
                        (configuredProjects !== null && configuredProjects !== void 0 ? configuredProjects : configuredProjects = /* @__PURE__ */ new Set()).add(project);
                        Debug.assert(!project.isClosed());
                    }
                } else rootFiles.push(file);
            }
            if (configuredProjects) {
                this.externalProjectToConfiguredProjectMap.set(proj.projectFileName, configuredProjects);
                if (existingExternalProject) this.removeProject(existingExternalProject);
            } else {
                this.externalProjectToConfiguredProjectMap.delete(proj.projectFileName);
                const typeAcquisition = proj.typeAcquisition || {};
                typeAcquisition.include = typeAcquisition.include || [];
                typeAcquisition.exclude = typeAcquisition.exclude || [];
                if (typeAcquisition.enable === void 0) typeAcquisition.enable = hasNoTypeScriptSource(rootFiles.map((f)=>f.fileName));
                const excludeResult = this.applySafeListWorker(proj, rootFiles, typeAcquisition);
                var _ref;
                const excludedFiles = (_ref = excludeResult == null ? void 0 : excludeResult.excludedFiles) !== null && _ref !== void 0 ? _ref : [];
                var _ref1;
                rootFiles = (_ref1 = excludeResult == null ? void 0 : excludeResult.rootFiles) !== null && _ref1 !== void 0 ? _ref1 : rootFiles;
                if (existingExternalProject) {
                    existingExternalProject.excludedFiles = excludedFiles;
                    const compilerOptions = convertCompilerOptions(proj.options);
                    const watchOptionsAndErrors = convertWatchOptions(proj.options, existingExternalProject.getCurrentDirectory());
                    const lastFileExceededProgramSize = this.getFilenameForExceededTotalSizeLimitForNonTsFiles(proj.projectFileName, compilerOptions, rootFiles, externalFilePropertyReader);
                    if (lastFileExceededProgramSize) existingExternalProject.disableLanguageService(lastFileExceededProgramSize);
                    else existingExternalProject.enableLanguageService();
                    existingExternalProject.setProjectErrors(watchOptionsAndErrors == null ? void 0 : watchOptionsAndErrors.errors);
                    this.updateRootAndOptionsOfNonInferredProject(existingExternalProject, rootFiles, externalFilePropertyReader, compilerOptions, typeAcquisition, proj.options.compileOnSave, watchOptionsAndErrors == null ? void 0 : watchOptionsAndErrors.watchOptions);
                    existingExternalProject.updateGraph();
                } else {
                    const project = this.createExternalProject(proj.projectFileName, rootFiles, proj.options, typeAcquisition, excludedFiles);
                    project.updateGraph();
                }
            }
            if (cleanupAfter) {
                this.cleanupConfiguredProjects(configuredProjects, /* @__PURE__ */ new Set([
                    proj.projectFileName
                ]));
                this.printProjects();
            }
        }
        hasDeferredExtension() {
            for (const extension of this.hostConfiguration.extraFileExtensions){
                if (extension.scriptKind === 7 /* Deferred */ ) return true;
            }
            return false;
        }
        /**
   * Performs the initial steps of enabling a plugin by finding and instantiating the module for a plugin either asynchronously or synchronously
   * @internal
   */ requestEnablePlugin(project, pluginConfigEntry, searchPaths) {
            if (!this.host.importPlugin && !this.host.require) {
                this.logger.info("Plugins were requested but not running in environment that supports 'require'. Nothing will be loaded");
                return;
            }
            this.logger.info(`Enabling plugin ${pluginConfigEntry.name} from candidate paths: ${searchPaths.join(",")}`);
            if (!pluginConfigEntry.name || isExternalModuleNameRelative(pluginConfigEntry.name) || /[\\/]\.\.?(?:$|[\\/])/.test(pluginConfigEntry.name)) {
                this.logger.info(`Skipped loading plugin ${pluginConfigEntry.name || JSON.stringify(pluginConfigEntry)} because only package name is allowed plugin name`);
                return;
            }
            if (this.host.importPlugin) {
                const importPromise = Project2.importServicePluginAsync(pluginConfigEntry, searchPaths, this.host, (s)=>this.logger.info(s));
                var _this_pendingPluginEnablements;
                (_this_pendingPluginEnablements = this.pendingPluginEnablements) !== null && _this_pendingPluginEnablements !== void 0 ? _this_pendingPluginEnablements : this.pendingPluginEnablements = /* @__PURE__ */ new Map();
                let promises = this.pendingPluginEnablements.get(project);
                if (!promises) this.pendingPluginEnablements.set(project, promises = []);
                promises.push(importPromise);
                return;
            }
            this.endEnablePlugin(project, Project2.importServicePluginSync(pluginConfigEntry, searchPaths, this.host, (s)=>this.logger.info(s)));
        }
        /**
   * Performs the remaining steps of enabling a plugin after its module has been instantiated.
   */ endEnablePlugin(project, { pluginConfigEntry, resolvedModule, errorLogs }) {
            var _a;
            if (resolvedModule) {
                const configurationOverride = (_a = this.currentPluginConfigOverrides) == null ? void 0 : _a.get(pluginConfigEntry.name);
                if (configurationOverride) {
                    const pluginName = pluginConfigEntry.name;
                    pluginConfigEntry = configurationOverride;
                    pluginConfigEntry.name = pluginName;
                }
                project.enableProxy(resolvedModule, pluginConfigEntry);
            } else {
                forEach(errorLogs, (message)=>this.logger.info(message));
                this.logger.info(`Couldn't find ${pluginConfigEntry.name}`);
            }
        }
        /** @internal */ hasNewPluginEnablementRequests() {
            return !!this.pendingPluginEnablements;
        }
        /** @internal */ hasPendingPluginEnablements() {
            return !!this.currentPluginEnablementPromise;
        }
        /**
   * Waits for any ongoing plugin enablement requests to complete.
   *
   * @internal
   */ async waitForPendingPlugins() {
            while(this.currentPluginEnablementPromise)await this.currentPluginEnablementPromise;
        }
        /**
   * Starts enabling any requested plugins without waiting for the result.
   *
   * @internal
   */ enableRequestedPlugins() {
            if (this.pendingPluginEnablements) this.enableRequestedPluginsAsync();
        }
        async enableRequestedPluginsAsync() {
            if (this.currentPluginEnablementPromise) await this.waitForPendingPlugins();
            if (!this.pendingPluginEnablements) return;
            const entries = arrayFrom(this.pendingPluginEnablements.entries());
            this.pendingPluginEnablements = void 0;
            this.currentPluginEnablementPromise = this.enableRequestedPluginsWorker(entries);
            await this.currentPluginEnablementPromise;
        }
        async enableRequestedPluginsWorker(pendingPlugins) {
            Debug.assert(this.currentPluginEnablementPromise === void 0);
            let sendProjectsUpdatedInBackgroundEvent = false;
            await Promise.all(map(pendingPlugins, async ([project, promises])=>{
                const results = await Promise.all(promises);
                if (project.isClosed() || isProjectDeferredClose(project)) {
                    this.logger.info(`Cancelling plugin enabling for ${project.getProjectName()} as it is ${project.isClosed() ? "closed" : "deferred close"}`);
                    return;
                }
                sendProjectsUpdatedInBackgroundEvent = true;
                for (const result of results)this.endEnablePlugin(project, result);
                this.delayUpdateProjectGraph(project);
            }));
            this.currentPluginEnablementPromise = void 0;
            if (sendProjectsUpdatedInBackgroundEvent) this.sendProjectsUpdatedInBackgroundEvent();
        }
        configurePlugin(args) {
            this.forEachEnabledProject((project)=>project.onPluginConfigurationChanged(args.pluginName, args.configuration));
            this.currentPluginConfigOverrides = this.currentPluginConfigOverrides || /* @__PURE__ */ new Map();
            this.currentPluginConfigOverrides.set(args.pluginName, args.configuration);
        }
        /** @internal */ getPackageJsonsVisibleToFile(fileName, project, rootDir) {
            const packageJsonCache = this.packageJsonCache;
            const rootPath = rootDir && this.toPath(rootDir);
            const result = [];
            const processDirectory = (directory)=>{
                switch(packageJsonCache.directoryHasPackageJson(directory)){
                    // Sync and check same directory again
                    case 3 /* Maybe */ :
                        packageJsonCache.searchDirectoryAndAncestors(directory, project);
                        return processDirectory(directory);
                    // Check package.json
                    case -1 /* True */ :
                        const packageJsonFileName = combinePaths(directory, "package.json");
                        this.watchPackageJsonFile(packageJsonFileName, this.toPath(packageJsonFileName), project);
                        const info = packageJsonCache.getInDirectory(directory);
                        if (info) result.push(info);
                }
                if (rootPath && rootPath === directory) return true;
            };
            forEachAncestorDirectoryStoppingAtGlobalCache(project, getDirectoryPath(fileName), processDirectory);
            return result;
        }
        /** @internal */ getNearestAncestorDirectoryWithPackageJson(fileName, project) {
            return forEachAncestorDirectoryStoppingAtGlobalCache(project, fileName, (directory)=>{
                switch(this.packageJsonCache.directoryHasPackageJson(directory)){
                    case -1 /* True */ :
                        return directory;
                    case 0 /* False */ :
                        return void 0;
                    case 3 /* Maybe */ :
                        return this.host.fileExists(combinePaths(directory, "package.json")) ? directory : void 0;
                }
            });
        }
        watchPackageJsonFile(file, path, project) {
            Debug.assert(project !== void 0);
            var _this_packageJsonFilesMap;
            let result = ((_this_packageJsonFilesMap = this.packageJsonFilesMap) !== null && _this_packageJsonFilesMap !== void 0 ? _this_packageJsonFilesMap : this.packageJsonFilesMap = /* @__PURE__ */ new Map()).get(path);
            if (!result) {
                let watcher = this.watchFactory.watchFile(file, (fileName, eventKind)=>{
                    switch(eventKind){
                        case 0 /* Created */ :
                        case 1 /* Changed */ :
                            this.packageJsonCache.addOrUpdate(fileName, path);
                            this.onPackageJsonChange(result);
                            break;
                        case 2 /* Deleted */ :
                            this.packageJsonCache.delete(path);
                            this.onPackageJsonChange(result);
                            result.projects.clear();
                            result.close();
                    }
                }, 250 /* Low */ , this.hostConfiguration.watchOptions, WatchType.PackageJson);
                result = {
                    projects: /* @__PURE__ */ new Set(),
                    close: ()=>{
                        var _a;
                        if (result.projects.size || !watcher) return;
                        watcher.close();
                        watcher = void 0;
                        (_a = this.packageJsonFilesMap) == null || _a.delete(path);
                        this.packageJsonCache.invalidate(path);
                    }
                };
                this.packageJsonFilesMap.set(path, result);
            }
            result.projects.add(project);
            var _project_packageJsonWatches;
            ((_project_packageJsonWatches = project.packageJsonWatches) !== null && _project_packageJsonWatches !== void 0 ? _project_packageJsonWatches : project.packageJsonWatches = /* @__PURE__ */ new Set()).add(result);
        }
        onPackageJsonChange(result) {
            result.projects.forEach((project)=>{
                var _a;
                return (_a = project.onPackageJsonChange) == null ? void 0 : _a.call(project);
            });
        }
        /** @internal */ includePackageJsonAutoImports() {
            switch(this.hostConfiguration.preferences.includePackageJsonAutoImports){
                case "on":
                    return 1 /* On */ ;
                case "off":
                    return 0 /* Off */ ;
                default:
                    return 2 /* Auto */ ;
            }
        }
        /** @internal */ getIncompleteCompletionsCache() {
            return this.incompleteCompletionsCache || (this.incompleteCompletionsCache = createIncompleteCompletionsCache());
        }
        constructor(opts){
            /**
     * Container of all known scripts
     *
     * @internal
     */ this.filenameToScriptInfo = /* @__PURE__ */ new Map();
            this.nodeModulesWatchers = /* @__PURE__ */ new Map();
            /**
     * Contains all the deleted script info's version information so that
     * it does not reset when creating script info again
     * (and could have potentially collided with version where contents mismatch)
     */ this.filenameToScriptInfoVersion = /* @__PURE__ */ new Map();
            // Set of all '.js' files ever opened.
            this.allJsFilesForOpenFileTelemetry = /* @__PURE__ */ new Set();
            /**
     * maps external project file name to list of config files that were the part of this project
     */ this.externalProjectToConfiguredProjectMap = /* @__PURE__ */ new Map();
            /**
     * external projects (configuration and list of root files is not controlled by tsserver)
     */ this.externalProjects = [];
            /**
     * projects built from openFileRoots
     */ this.inferredProjects = [];
            /**
     * projects specified by a tsconfig.json file
     */ this.configuredProjects = /* @__PURE__ */ new Map();
            /** @internal */ this.newInferredProjectName = createProjectNameFactoryWithCounter(makeInferredProjectName);
            /** @internal */ this.newAutoImportProviderProjectName = createProjectNameFactoryWithCounter(makeAutoImportProviderProjectName);
            /** @internal */ this.newAuxiliaryProjectName = createProjectNameFactoryWithCounter(makeAuxiliaryProjectName);
            /**
     * Open files: with value being project root path, and key being Path of the file that is open
     */ this.openFiles = /* @__PURE__ */ new Map();
            /** Config files looked up and cached config files for open script info */ this.configFileForOpenFiles = /* @__PURE__ */ new Map();
            /** Set of open script infos that are root of inferred project */ this.rootOfInferredProjects = /* @__PURE__ */ new Set();
            /**
     * Map of open files that are opened without complete path but have projectRoot as current directory
     */ this.openFilesWithNonRootedDiskPath = /* @__PURE__ */ new Map();
            this.compilerOptionsForInferredProjectsPerProjectRoot = /* @__PURE__ */ new Map();
            this.watchOptionsForInferredProjectsPerProjectRoot = /* @__PURE__ */ new Map();
            this.typeAcquisitionForInferredProjectsPerProjectRoot = /* @__PURE__ */ new Map();
            /**
     * Project size for configured or external projects
     */ this.projectToSizeMap = /* @__PURE__ */ new Map();
            /**
     * This is a map of config file paths existence that doesnt need query to disk
     * - The entry can be present because there is inferred project that needs to watch addition of config file to directory
     *   In this case the exists could be true/false based on config file is present or not
     * - Or it is present if we have configured project open with config file at that location
     *   In this case the exists property is always true
     *
     * @internal
     */ this.configFileExistenceInfoCache = /* @__PURE__ */ new Map();
            this.safelist = defaultTypeSafeList;
            this.legacySafelist = /* @__PURE__ */ new Map();
            this.pendingProjectUpdates = /* @__PURE__ */ new Map();
            /** @internal */ this.pendingEnsureProjectForOpenFiles = false;
            /** Tracks projects that we have already sent telemetry for. */ this.seenProjects = /* @__PURE__ */ new Map();
            this.sharedExtendedConfigFileWatchers = /* @__PURE__ */ new Map();
            this.extendedConfigCache = /* @__PURE__ */ new Map();
            /** @internal */ this.baseline = noop;
            /** @internal */ this.verifyDocumentRegistry = noop;
            /** @internal */ this.verifyProgram = noop;
            /** @internal */ this.onProjectCreation = noop;
            var _a;
            this.host = opts.host;
            this.logger = opts.logger;
            this.cancellationToken = opts.cancellationToken;
            this.useSingleInferredProject = opts.useSingleInferredProject;
            this.useInferredProjectPerProjectRoot = opts.useInferredProjectPerProjectRoot;
            this.typingsInstaller = opts.typingsInstaller || nullTypingsInstaller;
            this.throttleWaitMilliseconds = opts.throttleWaitMilliseconds;
            this.eventHandler = opts.eventHandler;
            this.suppressDiagnosticEvents = opts.suppressDiagnosticEvents;
            this.globalPlugins = opts.globalPlugins || emptyArray2;
            this.pluginProbeLocations = opts.pluginProbeLocations || emptyArray2;
            this.allowLocalPluginLoads = !!opts.allowLocalPluginLoads;
            this.typesMapLocation = opts.typesMapLocation === void 0 ? combinePaths(getDirectoryPath(this.getExecutingFilePath()), "typesMap.json") : opts.typesMapLocation;
            this.session = opts.session;
            this.jsDocParsingMode = opts.jsDocParsingMode;
            if (opts.serverMode !== void 0) this.serverMode = opts.serverMode;
            else this.serverMode = 0 /* Semantic */ ;
            if (this.host.realpath) this.realpathToScriptInfos = createMultiMap();
            this.currentDirectory = toNormalizedPath(this.host.getCurrentDirectory());
            this.toCanonicalFileName = createGetCanonicalFileName(this.host.useCaseSensitiveFileNames);
            this.globalCacheLocationDirectoryPath = this.typingsInstaller.globalTypingsCacheLocation ? ensureTrailingDirectorySeparator(this.toPath(this.typingsInstaller.globalTypingsCacheLocation)) : void 0;
            this.throttledOperations = new ThrottledOperations(this.host, this.logger);
            this.logger.info(`currentDirectory:: ${this.host.getCurrentDirectory()} useCaseSensitiveFileNames:: ${this.host.useCaseSensitiveFileNames}`);
            this.logger.info(`libs Location:: ${getDirectoryPath(this.host.getExecutingFilePath())}`);
            this.logger.info(`globalTypingsCacheLocation:: ${this.typingsInstaller.globalTypingsCacheLocation}`);
            if (this.typesMapLocation) this.loadTypesMap();
            else this.logger.info("No types map provided; using the default");
            this.typingsInstaller.attach(this);
            this.hostConfiguration = {
                formatCodeOptions: getDefaultFormatCodeSettings(this.host.newLine),
                preferences: emptyOptions,
                hostInfo: "Unknown host",
                extraFileExtensions: []
            };
            this.documentRegistry = createDocumentRegistryInternal(this.host.useCaseSensitiveFileNames, this.currentDirectory, this.jsDocParsingMode, this);
            const watchLogLevel = this.logger.hasLevel(3 /* verbose */ ) ? 2 /* Verbose */  : this.logger.loggingEnabled() ? 1 /* TriggerOnly */  : 0 /* None */ ;
            const log = watchLogLevel !== 0 /* None */  ? (s)=>this.logger.info(s) : noop;
            this.packageJsonCache = createPackageJsonCache(this);
            this.watchFactory = this.serverMode !== 0 /* Semantic */  ? {
                watchFile: returnNoopFileWatcher,
                watchDirectory: returnNoopFileWatcher
            } : getWatchFactory(createWatchFactoryHostUsingWatchEvents(this, opts.canUseWatchEvents) || this.host, watchLogLevel, log, getDetailWatchInfo);
            this.canUseWatchEvents = getCanUseWatchEvents(this, opts.canUseWatchEvents);
            (_a = opts.incrementalVerifier) == null || _a.call(opts, this);
        }
    };
    /** Makes a filename safe to insert in a RegExp */ _ProjectService.filenameEscapeRegexp = /[-/\\^$*+?.()|[\]{}]/g;
    var ProjectService2 = _ProjectService;
    function createIncompleteCompletionsCache() {
        let info;
        return {
            get () {
                return info;
            },
            set (newInfo) {
                info = newInfo;
            },
            clear () {
                info = void 0;
            }
        };
    }
    function isConfigFile(config) {
        return config.kind !== void 0;
    }
    function printProjectWithoutFileNames(project) {
        project.print(/*writeProjectFileNames*/ false, /*writeFileExplaination*/ false, /*writeFileVersionAndText*/ false);
    }
    // src/server/moduleSpecifierCache.ts
    function createModuleSpecifierCache(host) {
        let containedNodeModulesWatchers;
        let cache;
        let currentKey;
        const result = {
            get (fromFileName, toFileName2, preferences, options) {
                if (!cache || currentKey !== key(fromFileName, preferences, options)) return void 0;
                return cache.get(toFileName2);
            },
            set (fromFileName, toFileName2, preferences, options, kind, modulePaths, moduleSpecifiers) {
                ensureCache(fromFileName, preferences, options).set(toFileName2, createInfo(kind, modulePaths, moduleSpecifiers, /*packageName*/ void 0, /*isBlockedByPackageJsonDependencies*/ false));
                if (moduleSpecifiers) {
                    for (const p of modulePaths)if (p.isInNodeModules) {
                        const nodeModulesPath = p.path.substring(0, p.path.indexOf(nodeModulesPathPart) + nodeModulesPathPart.length - 1);
                        const key2 = host.toPath(nodeModulesPath);
                        if (!(containedNodeModulesWatchers == null ? void 0 : containedNodeModulesWatchers.has(key2))) (containedNodeModulesWatchers || (containedNodeModulesWatchers = /* @__PURE__ */ new Map())).set(key2, host.watchNodeModulesForPackageJsonChanges(nodeModulesPath));
                    }
                }
            },
            setModulePaths (fromFileName, toFileName2, preferences, options, modulePaths) {
                const cache2 = ensureCache(fromFileName, preferences, options);
                const info = cache2.get(toFileName2);
                if (info) info.modulePaths = modulePaths;
                else cache2.set(toFileName2, createInfo(/*kind*/ void 0, modulePaths, /*moduleSpecifiers*/ void 0, /*packageName*/ void 0, /*isBlockedByPackageJsonDependencies*/ void 0));
            },
            setBlockedByPackageJsonDependencies (fromFileName, toFileName2, preferences, options, packageName, isBlockedByPackageJsonDependencies) {
                const cache2 = ensureCache(fromFileName, preferences, options);
                const info = cache2.get(toFileName2);
                if (info) {
                    info.isBlockedByPackageJsonDependencies = isBlockedByPackageJsonDependencies;
                    info.packageName = packageName;
                } else cache2.set(toFileName2, createInfo(/*kind*/ void 0, /*modulePaths*/ void 0, /*moduleSpecifiers*/ void 0, packageName, isBlockedByPackageJsonDependencies));
            },
            clear () {
                containedNodeModulesWatchers == null || containedNodeModulesWatchers.forEach(closeFileWatcher);
                cache == null || cache.clear();
                containedNodeModulesWatchers == null || containedNodeModulesWatchers.clear();
                currentKey = void 0;
            },
            count () {
                return cache ? cache.size : 0;
            }
        };
        if (Debug.isDebugging) Object.defineProperty(result, "__cache", {
            get: ()=>cache
        });
        return result;
        function ensureCache(fromFileName, preferences, options) {
            const newKey = key(fromFileName, preferences, options);
            if (cache && currentKey !== newKey) result.clear();
            currentKey = newKey;
            return cache || (cache = /* @__PURE__ */ new Map());
        }
        function key(fromFileName, preferences, options) {
            return `${fromFileName},${preferences.importModuleSpecifierEnding},${preferences.importModuleSpecifierPreference},${options.overrideImportMode}`;
        }
        function createInfo(kind, modulePaths, moduleSpecifiers, packageName, isBlockedByPackageJsonDependencies) {
            return {
                kind,
                modulePaths,
                moduleSpecifiers,
                packageName,
                isBlockedByPackageJsonDependencies
            };
        }
    }
    // src/server/packageJsonCache.ts
    function createPackageJsonCache(host) {
        const packageJsons = /* @__PURE__ */ new Map();
        const directoriesWithoutPackageJson = /* @__PURE__ */ new Map();
        return {
            addOrUpdate,
            invalidate,
            delete: (fileName)=>{
                packageJsons.delete(fileName);
                directoriesWithoutPackageJson.set(getDirectoryPath(fileName), true);
            },
            getInDirectory: (directory)=>{
                return packageJsons.get(host.toPath(combinePaths(directory, "package.json"))) || void 0;
            },
            directoryHasPackageJson: (directory)=>directoryHasPackageJson(host.toPath(directory)),
            searchDirectoryAndAncestors: (directory, project)=>{
                forEachAncestorDirectoryStoppingAtGlobalCache(project, directory, (ancestor)=>{
                    const ancestorPath = host.toPath(ancestor);
                    if (directoryHasPackageJson(ancestorPath) !== 3 /* Maybe */ ) return true;
                    const packageJsonFileName = combinePaths(ancestor, "package.json");
                    if (tryFileExists(host, packageJsonFileName)) addOrUpdate(packageJsonFileName, combinePaths(ancestorPath, "package.json"));
                    else directoriesWithoutPackageJson.set(ancestorPath, true);
                });
            }
        };
        function addOrUpdate(fileName, path) {
            const packageJsonInfo = Debug.checkDefined(createPackageJsonInfo(fileName, host.host));
            packageJsons.set(path, packageJsonInfo);
            directoriesWithoutPackageJson.delete(getDirectoryPath(path));
        }
        function invalidate(path) {
            packageJsons.delete(path);
            directoriesWithoutPackageJson.delete(getDirectoryPath(path));
        }
        function directoryHasPackageJson(directory) {
            return packageJsons.has(combinePaths(directory, "package.json")) ? -1 /* True */  : directoriesWithoutPackageJson.has(directory) ? 0 /* False */  : 3 /* Maybe */ ;
        }
    }
    // src/server/session.ts
    var nullCancellationToken = {
        isCancellationRequested: ()=>false,
        setRequest: ()=>void 0,
        resetRequest: ()=>void 0
    };
    function hrTimeToMilliseconds(time) {
        const seconds = time[0];
        const nanoseconds = time[1];
        return (1e9 * seconds + nanoseconds) / 1e6;
    }
    function isDeclarationFileInJSOnlyNonConfiguredProject(project, file) {
        if ((isInferredProject(project) || isExternalProject(project)) && project.isJsOnlyProject()) {
            const scriptInfo = project.getScriptInfoForNormalizedPath(file);
            return scriptInfo && !scriptInfo.isJavaScript();
        }
        return false;
    }
    function dtsChangeCanAffectEmit(compilationSettings) {
        return getEmitDeclarations(compilationSettings) || !!compilationSettings.emitDecoratorMetadata;
    }
    function formatDiag(fileName, project, diag2) {
        const scriptInfo = project.getScriptInfoForNormalizedPath(fileName);
        return {
            start: scriptInfo.positionToLineOffset(diag2.start),
            end: scriptInfo.positionToLineOffset(diag2.start + diag2.length),
            // TODO: GH#18217
            text: flattenDiagnosticMessageText(diag2.messageText, "\n"),
            code: diag2.code,
            category: diagnosticCategoryName(diag2),
            reportsUnnecessary: diag2.reportsUnnecessary,
            reportsDeprecated: diag2.reportsDeprecated,
            source: diag2.source,
            relatedInformation: map(diag2.relatedInformation, formatRelatedInformation)
        };
    }
    function formatRelatedInformation(info) {
        if (!info.file) return {
            message: flattenDiagnosticMessageText(info.messageText, "\n"),
            category: diagnosticCategoryName(info),
            code: info.code
        };
        return {
            span: {
                start: convertToLocation(getLineAndCharacterOfPosition(info.file, info.start)),
                end: convertToLocation(getLineAndCharacterOfPosition(info.file, info.start + info.length)),
                // TODO: GH#18217
                file: info.file.fileName
            },
            message: flattenDiagnosticMessageText(info.messageText, "\n"),
            category: diagnosticCategoryName(info),
            code: info.code
        };
    }
    function convertToLocation(lineAndCharacter) {
        return {
            line: lineAndCharacter.line + 1,
            offset: lineAndCharacter.character + 1
        };
    }
    function formatDiagnosticToProtocol(diag2, includeFileName) {
        const start = diag2.file && convertToLocation(getLineAndCharacterOfPosition(diag2.file, diag2.start));
        const end = diag2.file && convertToLocation(getLineAndCharacterOfPosition(diag2.file, diag2.start + diag2.length));
        const text = flattenDiagnosticMessageText(diag2.messageText, "\n");
        const { code, source } = diag2;
        const category = diagnosticCategoryName(diag2);
        const common = {
            start,
            end,
            text,
            code,
            category,
            reportsUnnecessary: diag2.reportsUnnecessary,
            reportsDeprecated: diag2.reportsDeprecated,
            source,
            relatedInformation: map(diag2.relatedInformation, formatRelatedInformation)
        };
        return includeFileName ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, common), {
            fileName: diag2.file && diag2.file.fileName
        }) : common;
    }
    function allEditsBeforePos(edits, pos) {
        return edits.every((edit)=>textSpanEnd(edit.span) < pos);
    }
    var CommandNames = CommandTypes;
    function formatMessage2(msg, logger, byteLength, newLine) {
        const verboseLogging = logger.hasLevel(3 /* verbose */ );
        const json = JSON.stringify(msg);
        if (verboseLogging) logger.info(`${msg.type}:${stringifyIndented(msg)}`);
        const len = byteLength(json, "utf8");
        return `Content-Length: ${1 + len}\r
\r
${json}${newLine}`;
    }
    var MultistepOperation = class {
        startNew(action) {
            this.complete();
            this.requestId = this.operationHost.getCurrentRequestId();
            this.executeAction(action);
        }
        complete() {
            if (this.requestId !== void 0) {
                this.operationHost.sendRequestCompletedEvent(this.requestId, this.performanceData);
                this.requestId = void 0;
            }
            this.setTimerHandle(void 0);
            this.setImmediateId(void 0);
            this.performanceData = void 0;
        }
        immediate(actionType, action) {
            const requestId = this.requestId;
            Debug.assert(requestId === this.operationHost.getCurrentRequestId(), "immediate: incorrect request id");
            this.setImmediateId(this.operationHost.getServerHost().setImmediate(()=>{
                this.immediateId = void 0;
                this.operationHost.executeWithRequestId(requestId, ()=>this.executeAction(action), this.performanceData);
            }, actionType));
        }
        delay(actionType, ms, action) {
            const requestId = this.requestId;
            Debug.assert(requestId === this.operationHost.getCurrentRequestId(), "delay: incorrect request id");
            this.setTimerHandle(this.operationHost.getServerHost().setTimeout(()=>{
                this.timerHandle = void 0;
                this.operationHost.executeWithRequestId(requestId, ()=>this.executeAction(action), this.performanceData);
            }, ms, actionType));
        }
        executeAction(action) {
            var _a, _b, _c, _d, _e, _f;
            let stop = false;
            try {
                if (this.operationHost.isCancellationRequested()) {
                    stop = true;
                    (_a = tracing) == null || _a.instant(tracing.Phase.Session, "stepCanceled", {
                        seq: this.requestId,
                        early: true
                    });
                } else {
                    (_b = tracing) == null || _b.push(tracing.Phase.Session, "stepAction", {
                        seq: this.requestId
                    });
                    action(this);
                    (_c = tracing) == null || _c.pop();
                }
            } catch (e) {
                (_d = tracing) == null || _d.popAll();
                stop = true;
                if (e instanceof OperationCanceledException) (_e = tracing) == null || _e.instant(tracing.Phase.Session, "stepCanceled", {
                    seq: this.requestId
                });
                else {
                    (_f = tracing) == null || _f.instant(tracing.Phase.Session, "stepError", {
                        seq: this.requestId,
                        message: e.message
                    });
                    this.operationHost.logError(e, `delayed processing of request ${this.requestId}`);
                }
            }
            this.performanceData = this.operationHost.getPerformanceData();
            if (stop || !this.hasPendingWork()) this.complete();
        }
        setTimerHandle(timerHandle) {
            if (this.timerHandle !== void 0) this.operationHost.getServerHost().clearTimeout(this.timerHandle);
            this.timerHandle = timerHandle;
        }
        setImmediateId(immediateId) {
            if (this.immediateId !== void 0) this.operationHost.getServerHost().clearImmediate(this.immediateId);
            this.immediateId = immediateId;
        }
        hasPendingWork() {
            return !!this.timerHandle || !!this.immediateId;
        }
        constructor(operationHost){
            this.operationHost = operationHost;
        }
    };
    function toEvent(eventName, body) {
        return {
            seq: 0,
            type: "event",
            event: eventName,
            body
        };
    }
    function combineProjectOutput(defaultValue, getValue, projects, action) {
        const outputs = flatMapToMutable(isArray(projects) ? projects : projects.projects, (project)=>action(project, defaultValue));
        if (!isArray(projects) && projects.symLinkedProjects) projects.symLinkedProjects.forEach((projects2, path)=>{
            const value1 = getValue(path);
            outputs.push(...flatMap(projects2, (project)=>action(project, value1)));
        });
        return deduplicate(outputs, equateValues);
    }
    function createDocumentSpanSet(useCaseSensitiveFileNames2) {
        return createSet(({ textSpan })=>textSpan.start + 100003 * textSpan.length, getDocumentSpansEqualityComparer(useCaseSensitiveFileNames2));
    }
    function getRenameLocationsWorker(projects, defaultProject, initialLocation, findInStrings, findInComments, preferences, useCaseSensitiveFileNames2) {
        const perProjectResults = getPerProjectReferences(projects, defaultProject, initialLocation, getDefinitionLocation(defaultProject, initialLocation, /*isForRename*/ true), mapDefinitionInProject, (project, position)=>project.getLanguageService().findRenameLocations(position.fileName, position.pos, findInStrings, findInComments, preferences), (renameLocation, cb)=>cb(documentSpanLocation(renameLocation)));
        if (isArray(perProjectResults)) return perProjectResults;
        const results = [];
        const seen = createDocumentSpanSet(useCaseSensitiveFileNames2);
        perProjectResults.forEach((projectResults, project)=>{
            for (const result of projectResults)if (!seen.has(result) && !getMappedLocationForProject(documentSpanLocation(result), project)) {
                results.push(result);
                seen.add(result);
            }
        });
        return results;
    }
    function getDefinitionLocation(defaultProject, initialLocation, isForRename) {
        const infos = defaultProject.getLanguageService().getDefinitionAtPosition(initialLocation.fileName, initialLocation.pos, /*searchOtherFilesOnly*/ false, /*stopAtAlias*/ isForRename);
        const info = infos && firstOrUndefined(infos);
        return info && !info.isLocal ? {
            fileName: info.fileName,
            pos: info.textSpan.start
        } : void 0;
    }
    function getReferencesWorker(projects, defaultProject, initialLocation, useCaseSensitiveFileNames2, logger) {
        var _a, _b;
        const perProjectResults = getPerProjectReferences(projects, defaultProject, initialLocation, getDefinitionLocation(defaultProject, initialLocation, /*isForRename*/ false), mapDefinitionInProject, (project, position)=>{
            logger.info(`Finding references to ${position.fileName} position ${position.pos} in project ${project.getProjectName()}`);
            return project.getLanguageService().findReferences(position.fileName, position.pos);
        }, (referencedSymbol, cb)=>{
            cb(documentSpanLocation(referencedSymbol.definition));
            for (const ref of referencedSymbol.references)cb(documentSpanLocation(ref));
        });
        if (isArray(perProjectResults)) return perProjectResults;
        const defaultProjectResults = perProjectResults.get(defaultProject);
        if (((_b = (_a = defaultProjectResults == null ? void 0 : defaultProjectResults[0]) == null ? void 0 : _a.references[0]) == null ? void 0 : _b.isDefinition) === void 0) perProjectResults.forEach((projectResults)=>{
            for (const referencedSymbol of projectResults)for (const ref of referencedSymbol.references)delete ref.isDefinition;
        });
        else {
            const knownSymbolSpans = createDocumentSpanSet(useCaseSensitiveFileNames2);
            for (const referencedSymbol of defaultProjectResults){
                for (const ref of referencedSymbol.references)if (ref.isDefinition) {
                    knownSymbolSpans.add(ref);
                    break;
                }
            }
            const updatedProjects = /* @__PURE__ */ new Set();
            while(true){
                let progress = false;
                perProjectResults.forEach((referencedSymbols, project)=>{
                    if (updatedProjects.has(project)) return;
                    const updated = project.getLanguageService().updateIsDefinitionOfReferencedSymbols(referencedSymbols, knownSymbolSpans);
                    if (updated) {
                        updatedProjects.add(project);
                        progress = true;
                    }
                });
                if (!progress) break;
            }
            perProjectResults.forEach((referencedSymbols, project)=>{
                if (updatedProjects.has(project)) return;
                for (const referencedSymbol of referencedSymbols)for (const ref of referencedSymbol.references)ref.isDefinition = false;
            });
        }
        const results = [];
        const seenRefs = createDocumentSpanSet(useCaseSensitiveFileNames2);
        perProjectResults.forEach((projectResults, project)=>{
            for (const referencedSymbol of projectResults){
                const mappedDefinitionFile = getMappedLocationForProject(documentSpanLocation(referencedSymbol.definition), project);
                const definition = mappedDefinitionFile === void 0 ? referencedSymbol.definition : (0, _objectSpreadProps._)((0, _objectSpread._)({}, referencedSymbol.definition), {
                    textSpan: createTextSpan(mappedDefinitionFile.pos, referencedSymbol.definition.textSpan.length),
                    // Why would the length be the same in the original?
                    fileName: mappedDefinitionFile.fileName,
                    contextSpan: getMappedContextSpanForProject(referencedSymbol.definition, project)
                });
                let symbolToAddTo = find(results, (o)=>documentSpansEqual(o.definition, definition, useCaseSensitiveFileNames2));
                if (!symbolToAddTo) {
                    symbolToAddTo = {
                        definition,
                        references: []
                    };
                    results.push(symbolToAddTo);
                }
                for (const ref of referencedSymbol.references)if (!seenRefs.has(ref) && !getMappedLocationForProject(documentSpanLocation(ref), project)) {
                    seenRefs.add(ref);
                    symbolToAddTo.references.push(ref);
                }
            }
        });
        return results.filter((o)=>o.references.length !== 0);
    }
    function forEachProjectInProjects(projects, path, cb) {
        for (const project of isArray(projects) ? projects : projects.projects)cb(project, path);
        if (!isArray(projects) && projects.symLinkedProjects) projects.symLinkedProjects.forEach((symlinkedProjects, symlinkedPath)=>{
            for (const project of symlinkedProjects)cb(project, symlinkedPath);
        });
    }
    function getPerProjectReferences(projects, defaultProject, initialLocation, defaultDefinition, mapDefinitionInProject2, getResultsForPosition, forPositionInResult) {
        const resultsMap = /* @__PURE__ */ new Map();
        const queue = createQueue();
        queue.enqueue({
            project: defaultProject,
            location: initialLocation
        });
        forEachProjectInProjects(projects, initialLocation.fileName, (project, path)=>{
            const location = {
                fileName: path,
                pos: initialLocation.pos
            };
            queue.enqueue({
                project,
                location
            });
        });
        const projectService = defaultProject.projectService;
        const cancellationToken = defaultProject.getCancellationToken();
        const getGeneratedDefinition = memoize(()=>defaultProject.isSourceOfProjectReferenceRedirect(defaultDefinition.fileName) ? defaultDefinition : defaultProject.getLanguageService().getSourceMapper().tryGetGeneratedPosition(defaultDefinition));
        const getSourceDefinition = memoize(()=>defaultProject.isSourceOfProjectReferenceRedirect(defaultDefinition.fileName) ? defaultDefinition : defaultProject.getLanguageService().getSourceMapper().tryGetSourcePosition(defaultDefinition));
        const searchedProjectKeys = /* @__PURE__ */ new Set();
        onCancellation: while(!queue.isEmpty()){
            while(!queue.isEmpty()){
                if (cancellationToken.isCancellationRequested()) break onCancellation;
                const { project, location } = queue.dequeue();
                if (resultsMap.has(project)) continue;
                if (isLocationProjectReferenceRedirect(project, location)) continue;
                updateProjectIfDirty(project);
                if (!project.containsFile(toNormalizedPath(location.fileName))) continue;
                const projectResults = searchPosition(project, location);
                resultsMap.set(project, projectResults !== null && projectResults !== void 0 ? projectResults : emptyArray2);
                searchedProjectKeys.add(getProjectKey(project));
            }
            if (defaultDefinition) {
                projectService.loadAncestorProjectTree(searchedProjectKeys);
                projectService.forEachEnabledProject((project)=>{
                    if (cancellationToken.isCancellationRequested()) return;
                    if (resultsMap.has(project)) return;
                    const location = mapDefinitionInProject2(defaultDefinition, project, getGeneratedDefinition, getSourceDefinition);
                    if (location) queue.enqueue({
                        project,
                        location
                    });
                });
            }
        }
        if (resultsMap.size === 1) return firstIterator(resultsMap.values());
        return resultsMap;
        function searchPosition(project, location) {
            const projectResults = getResultsForPosition(project, location);
            if (!projectResults || !forPositionInResult) return projectResults;
            for (const result of projectResults)forPositionInResult(result, (position)=>{
                const originalLocation = projectService.getOriginalLocationEnsuringConfiguredProject(project, position);
                if (!originalLocation) return;
                const originalScriptInfo = projectService.getScriptInfo(originalLocation.fileName);
                for (const project2 of originalScriptInfo.containingProjects)if (!project2.isOrphan() && !resultsMap.has(project2)) queue.enqueue({
                    project: project2,
                    location: originalLocation
                });
                const symlinkedProjectsMap = projectService.getSymlinkedProjects(originalScriptInfo);
                if (symlinkedProjectsMap) symlinkedProjectsMap.forEach((symlinkedProjects, symlinkedPath)=>{
                    for (const symlinkedProject of symlinkedProjects)if (!symlinkedProject.isOrphan() && !resultsMap.has(symlinkedProject)) queue.enqueue({
                        project: symlinkedProject,
                        location: {
                            fileName: symlinkedPath,
                            pos: originalLocation.pos
                        }
                    });
                });
            });
            return projectResults;
        }
    }
    function mapDefinitionInProjectIfFileInProject(definition, project) {
        if (project.containsFile(toNormalizedPath(definition.fileName)) && !isLocationProjectReferenceRedirect(project, definition)) return definition;
    }
    function mapDefinitionInProject(definition, project, getGeneratedDefinition, getSourceDefinition) {
        const result = mapDefinitionInProjectIfFileInProject(definition, project);
        if (result) return result;
        const generatedDefinition = getGeneratedDefinition();
        if (generatedDefinition && project.containsFile(toNormalizedPath(generatedDefinition.fileName))) return generatedDefinition;
        const sourceDefinition = getSourceDefinition();
        return sourceDefinition && project.containsFile(toNormalizedPath(sourceDefinition.fileName)) ? sourceDefinition : void 0;
    }
    function isLocationProjectReferenceRedirect(project, location) {
        if (!location) return false;
        const program = project.getLanguageService().getProgram();
        if (!program) return false;
        const sourceFile = program.getSourceFile(location.fileName);
        return !!sourceFile && sourceFile.resolvedPath !== sourceFile.path && sourceFile.resolvedPath !== project.toPath(location.fileName);
    }
    function getProjectKey(project) {
        return isConfiguredProject(project) ? project.canonicalConfigFilePath : project.getProjectName();
    }
    function documentSpanLocation({ fileName, textSpan }) {
        return {
            fileName,
            pos: textSpan.start
        };
    }
    function getMappedLocationForProject(location, project) {
        return getMappedLocation(location, project.getSourceMapper(), (p)=>project.projectService.fileExists(p));
    }
    function getMappedDocumentSpanForProject(documentSpan, project) {
        return getMappedDocumentSpan(documentSpan, project.getSourceMapper(), (p)=>project.projectService.fileExists(p));
    }
    function getMappedContextSpanForProject(documentSpan, project) {
        return getMappedContextSpan(documentSpan, project.getSourceMapper(), (p)=>project.projectService.fileExists(p));
    }
    var invalidPartialSemanticModeCommands = [
        "openExternalProject" /* OpenExternalProject */ ,
        "openExternalProjects" /* OpenExternalProjects */ ,
        "closeExternalProject" /* CloseExternalProject */ ,
        "synchronizeProjectList" /* SynchronizeProjectList */ ,
        "emit-output" /* EmitOutput */ ,
        "compileOnSaveAffectedFileList" /* CompileOnSaveAffectedFileList */ ,
        "compileOnSaveEmitFile" /* CompileOnSaveEmitFile */ ,
        "compilerOptionsDiagnostics-full" /* CompilerOptionsDiagnosticsFull */ ,
        "encodedSemanticClassifications-full" /* EncodedSemanticClassificationsFull */ ,
        "semanticDiagnosticsSync" /* SemanticDiagnosticsSync */ ,
        "suggestionDiagnosticsSync" /* SuggestionDiagnosticsSync */ ,
        "geterrForProject" /* GeterrForProject */ ,
        "reload" /* Reload */ ,
        "reloadProjects" /* ReloadProjects */ ,
        "getCodeFixes" /* GetCodeFixes */ ,
        "getCodeFixes-full" /* GetCodeFixesFull */ ,
        "getCombinedCodeFix" /* GetCombinedCodeFix */ ,
        "getCombinedCodeFix-full" /* GetCombinedCodeFixFull */ ,
        "applyCodeActionCommand" /* ApplyCodeActionCommand */ ,
        "getSupportedCodeFixes" /* GetSupportedCodeFixes */ ,
        "getApplicableRefactors" /* GetApplicableRefactors */ ,
        "getMoveToRefactoringFileSuggestions" /* GetMoveToRefactoringFileSuggestions */ ,
        "getEditsForRefactor" /* GetEditsForRefactor */ ,
        "getEditsForRefactor-full" /* GetEditsForRefactorFull */ ,
        "organizeImports" /* OrganizeImports */ ,
        "organizeImports-full" /* OrganizeImportsFull */ ,
        "getEditsForFileRename" /* GetEditsForFileRename */ ,
        "getEditsForFileRename-full" /* GetEditsForFileRenameFull */ ,
        "prepareCallHierarchy" /* PrepareCallHierarchy */ ,
        "provideCallHierarchyIncomingCalls" /* ProvideCallHierarchyIncomingCalls */ ,
        "provideCallHierarchyOutgoingCalls" /* ProvideCallHierarchyOutgoingCalls */ ,
        "getPasteEdits" /* GetPasteEdits */ ,
        "copilotRelated" /* CopilotRelated */ 
    ];
    var invalidSyntacticModeCommands = [
        ...invalidPartialSemanticModeCommands,
        "definition" /* Definition */ ,
        "definition-full" /* DefinitionFull */ ,
        "definitionAndBoundSpan" /* DefinitionAndBoundSpan */ ,
        "definitionAndBoundSpan-full" /* DefinitionAndBoundSpanFull */ ,
        "typeDefinition" /* TypeDefinition */ ,
        "implementation" /* Implementation */ ,
        "implementation-full" /* ImplementationFull */ ,
        "references" /* References */ ,
        "references-full" /* ReferencesFull */ ,
        "rename" /* Rename */ ,
        "renameLocations-full" /* RenameLocationsFull */ ,
        "rename-full" /* RenameInfoFull */ ,
        "quickinfo" /* Quickinfo */ ,
        "quickinfo-full" /* QuickinfoFull */ ,
        "completionInfo" /* CompletionInfo */ ,
        "completions" /* Completions */ ,
        "completions-full" /* CompletionsFull */ ,
        "completionEntryDetails" /* CompletionDetails */ ,
        "completionEntryDetails-full" /* CompletionDetailsFull */ ,
        "signatureHelp" /* SignatureHelp */ ,
        "signatureHelp-full" /* SignatureHelpFull */ ,
        "navto" /* Navto */ ,
        "navto-full" /* NavtoFull */ ,
        "documentHighlights" /* DocumentHighlights */ ,
        "documentHighlights-full" /* DocumentHighlightsFull */ ,
        "preparePasteEdits" /* PreparePasteEdits */ 
    ];
    var Session3 = class _Session {
        sendRequestCompletedEvent(requestId, performanceData) {
            this.event({
                request_seq: requestId,
                performanceData: performanceData && toProtocolPerformanceData(performanceData)
            }, "requestCompleted");
        }
        addPerformanceData(key, value1) {
            if (!this.performanceData) this.performanceData = {};
            var _this_performanceData_key;
            this.performanceData[key] = ((_this_performanceData_key = this.performanceData[key]) !== null && _this_performanceData_key !== void 0 ? _this_performanceData_key : 0) + value1;
        }
        addDiagnosticsPerformanceData(file, kind, duration) {
            var _a, _b;
            if (!this.performanceData) this.performanceData = {};
            let fileDiagnosticDuration = (_a = this.performanceData.diagnosticsDuration) == null ? void 0 : _a.get(file);
            var _diagnosticsDuration;
            if (!fileDiagnosticDuration) ((_diagnosticsDuration = (_b = this.performanceData).diagnosticsDuration) !== null && _diagnosticsDuration !== void 0 ? _diagnosticsDuration : _b.diagnosticsDuration = /* @__PURE__ */ new Map()).set(file, fileDiagnosticDuration = {});
            fileDiagnosticDuration[kind] = duration;
        }
        performanceEventHandler(event) {
            switch(event.kind){
                case "UpdateGraph":
                    this.addPerformanceData("updateGraphDurationMs", event.durationMs);
                    break;
                case "CreatePackageJsonAutoImportProvider":
                    this.addPerformanceData("createAutoImportProviderProgramDurationMs", event.durationMs);
                    break;
            }
        }
        defaultEventHandler(event) {
            switch(event.eventName){
                case ProjectsUpdatedInBackgroundEvent:
                    this.projectsUpdatedInBackgroundEvent(event.data.openFiles);
                    break;
                case ProjectLoadingStartEvent:
                    this.event({
                        projectName: event.data.project.getProjectName(),
                        reason: event.data.reason
                    }, event.eventName);
                    break;
                case ProjectLoadingFinishEvent:
                    this.event({
                        projectName: event.data.project.getProjectName()
                    }, event.eventName);
                    break;
                case LargeFileReferencedEvent:
                case CreateFileWatcherEvent:
                case CreateDirectoryWatcherEvent:
                case CloseFileWatcherEvent:
                    this.event(event.data, event.eventName);
                    break;
                case ConfigFileDiagEvent:
                    this.event({
                        triggerFile: event.data.triggerFile,
                        configFile: event.data.configFileName,
                        diagnostics: map(event.data.diagnostics, (diagnostic)=>formatDiagnosticToProtocol(diagnostic, /*includeFileName*/ true))
                    }, event.eventName);
                    break;
                case ProjectLanguageServiceStateEvent:
                    this.event({
                        projectName: event.data.project.getProjectName(),
                        languageServiceEnabled: event.data.languageServiceEnabled
                    }, event.eventName);
                    break;
                case ProjectInfoTelemetryEvent:
                    {
                        const eventName = "telemetry";
                        this.event({
                            telemetryEventName: event.eventName,
                            payload: event.data
                        }, eventName);
                        break;
                    }
            }
        }
        projectsUpdatedInBackgroundEvent(openFiles) {
            this.projectService.logger.info(`got projects updated in background ${openFiles}`);
            if (openFiles.length) {
                if (!this.suppressDiagnosticEvents && !this.noGetErrOnBackgroundUpdate) {
                    this.projectService.logger.info(`Queueing diagnostics update for ${openFiles}`);
                    this.errorCheck.startNew((next)=>this.updateErrorCheck(next, openFiles, 100, /*requireOpen*/ true));
                }
                this.event({
                    openFiles
                }, ProjectsUpdatedInBackgroundEvent);
            }
        }
        logError(err, cmd) {
            this.logErrorWorker(err, cmd);
        }
        logErrorWorker(err, cmd, fileRequest) {
            let msg = "Exception on executing command " + cmd;
            if (err.message) {
                msg += ":\n" + indent2(err.message);
                if (err.stack) msg += "\n" + indent2(err.stack);
            }
            if (this.logger.hasLevel(3 /* verbose */ )) {
                if (fileRequest) try {
                    const { file, project } = this.getFileAndProject(fileRequest);
                    const scriptInfo = project.getScriptInfoForNormalizedPath(file);
                    if (scriptInfo) {
                        const text = getSnapshotText(scriptInfo.getSnapshot());
                        msg += `

File text of ${fileRequest.file}:${indent2(text)}
`;
                    }
                } catch (e) {}
                if (err.ProgramFiles) {
                    msg += `

Program files: ${JSON.stringify(err.ProgramFiles)}
`;
                    msg += `

Projects::
`;
                    let counter = 0;
                    const addProjectInfo = (project)=>{
                        msg += `
Project '${project.projectName}' (${ProjectKind[project.projectKind]}) ${counter}
`;
                        msg += project.filesToString(/*writeProjectFileNames*/ true);
                        msg += "\n-----------------------------------------------\n";
                        counter++;
                    };
                    this.projectService.externalProjects.forEach(addProjectInfo);
                    this.projectService.configuredProjects.forEach(addProjectInfo);
                    this.projectService.inferredProjects.forEach(addProjectInfo);
                }
            }
            this.logger.msg(msg, "Err" /* Err */ );
        }
        send(msg) {
            if (msg.type === "event" && !this.canUseEvents) {
                if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`Session does not support events: ignored event: ${stringifyIndented(msg)}`);
                return;
            }
            this.writeMessage(msg);
        }
        writeMessage(msg) {
            const msgText = formatMessage2(msg, this.logger, this.byteLength, this.host.newLine);
            this.host.write(msgText);
        }
        event(body, eventName) {
            this.send(toEvent(eventName, body));
        }
        /** @internal */ doOutput(info, cmdName, reqSeq, success, performanceData, message) {
            const res = {
                seq: 0,
                type: "response",
                command: cmdName,
                request_seq: reqSeq,
                success,
                performanceData: performanceData && toProtocolPerformanceData(performanceData)
            };
            if (success) {
                let metadata;
                if (isArray(info)) {
                    res.body = info;
                    metadata = info.metadata;
                    delete info.metadata;
                } else if (typeof info === "object") {
                    if (info.metadata) {
                        const { metadata: infoMetadata } = info, body = (0, _objectWithoutProperties._)(info, [
                            "metadata"
                        ]);
                        res.body = body;
                        metadata = infoMetadata;
                    } else res.body = info;
                } else res.body = info;
                if (metadata) res.metadata = metadata;
            } else Debug.assert(info === void 0);
            if (message) res.message = message;
            this.send(res);
        }
        semanticCheck(file, project) {
            var _a, _b;
            const diagnosticsStartTime = timestamp();
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "semanticCheck", {
                file,
                configFilePath: project.canonicalConfigFilePath
            });
            const diags = isDeclarationFileInJSOnlyNonConfiguredProject(project, file) ? emptyArray2 : project.getLanguageService().getSemanticDiagnostics(file).filter((d)=>!!d.file);
            this.sendDiagnosticsEvent(file, project, diags, "semanticDiag", diagnosticsStartTime);
            (_b = tracing) == null || _b.pop();
        }
        syntacticCheck(file, project) {
            var _a, _b;
            const diagnosticsStartTime = timestamp();
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "syntacticCheck", {
                file,
                configFilePath: project.canonicalConfigFilePath
            });
            this.sendDiagnosticsEvent(file, project, project.getLanguageService().getSyntacticDiagnostics(file), "syntaxDiag", diagnosticsStartTime);
            (_b = tracing) == null || _b.pop();
        }
        suggestionCheck(file, project) {
            var _a, _b;
            const diagnosticsStartTime = timestamp();
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "suggestionCheck", {
                file,
                configFilePath: project.canonicalConfigFilePath
            });
            this.sendDiagnosticsEvent(file, project, project.getLanguageService().getSuggestionDiagnostics(file), "suggestionDiag", diagnosticsStartTime);
            (_b = tracing) == null || _b.pop();
        }
        regionSemanticCheck(file, project, ranges) {
            var _a, _b, _c;
            const diagnosticsStartTime = timestamp();
            (_a = tracing) == null || _a.push(tracing.Phase.Session, "regionSemanticCheck", {
                file,
                configFilePath: project.canonicalConfigFilePath
            });
            let diagnosticsResult;
            if (!this.shouldDoRegionCheck(file) || !(diagnosticsResult = project.getLanguageService().getRegionSemanticDiagnostics(file, ranges))) {
                (_b = tracing) == null || _b.pop();
                return;
            }
            this.sendDiagnosticsEvent(file, project, diagnosticsResult.diagnostics, "regionSemanticDiag", diagnosticsStartTime, diagnosticsResult.spans);
            (_c = tracing) == null || _c.pop();
            return;
        }
        // We should only do the region-based semantic check if we think it would be
        // considerably faster than a whole-file semantic check.
        /** @internal */ shouldDoRegionCheck(file) {
            var _a;
            const lineCount = (_a = this.projectService.getScriptInfoForNormalizedPath(file)) == null ? void 0 : _a.textStorage.getLineInfo().getLineCount();
            return !!(lineCount && lineCount >= this.regionDiagLineCountThreshold);
        }
        sendDiagnosticsEvent(file, project, diagnostics, kind, diagnosticsStartTime, spans) {
            try {
                const scriptInfo = Debug.checkDefined(project.getScriptInfo(file));
                const duration = timestamp() - diagnosticsStartTime;
                const body = {
                    file,
                    diagnostics: diagnostics.map((diag2)=>formatDiag(file, project, diag2)),
                    spans: spans == null ? void 0 : spans.map((span)=>toProtocolTextSpan(span, scriptInfo))
                };
                this.event(body, kind);
                this.addDiagnosticsPerformanceData(file, kind, duration);
            } catch (err) {
                this.logError(err, kind);
            }
        }
        /** It is the caller's responsibility to verify that `!this.suppressDiagnosticEvents`. */ updateErrorCheck(next, checkList, ms, requireOpen = true) {
            if (checkList.length === 0) return;
            Debug.assert(!this.suppressDiagnosticEvents);
            const seq = this.changeSeq;
            const followMs = Math.min(ms, 200);
            let index = 0;
            const goNext = ()=>{
                index++;
                if (checkList.length > index) return next.delay("checkOne", followMs, checkOne);
            };
            const doSemanticCheck = (fileName, project)=>{
                this.semanticCheck(fileName, project);
                if (this.changeSeq !== seq) return;
                if (this.getPreferences(fileName).disableSuggestions) return goNext();
                next.immediate("suggestionCheck", ()=>{
                    this.suggestionCheck(fileName, project);
                    goNext();
                });
            };
            const checkOne = ()=>{
                if (this.changeSeq !== seq) return;
                let ranges;
                let item = checkList[index];
                if (isString(item)) item = this.toPendingErrorCheck(item);
                else if ("ranges" in item) {
                    ranges = item.ranges;
                    item = this.toPendingErrorCheck(item.file);
                }
                if (!item) return goNext();
                const { fileName, project } = item;
                updateProjectIfDirty(project);
                if (!project.containsFile(fileName, requireOpen)) return;
                this.syntacticCheck(fileName, project);
                if (this.changeSeq !== seq) return;
                if (project.projectService.serverMode !== 0 /* Semantic */ ) return goNext();
                if (ranges) return next.immediate("regionSemanticCheck", ()=>{
                    const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(fileName);
                    if (scriptInfo) this.regionSemanticCheck(fileName, project, ranges.map((range)=>this.getRange((0, _objectSpread._)({
                            file: fileName
                        }, range), scriptInfo)));
                    if (this.changeSeq !== seq) return;
                    next.immediate("semanticCheck", ()=>doSemanticCheck(fileName, project));
                });
                next.immediate("semanticCheck", ()=>doSemanticCheck(fileName, project));
            };
            if (checkList.length > index && this.changeSeq === seq) next.delay("checkOne", ms, checkOne);
        }
        cleanProjects(caption, projects) {
            if (!projects) return;
            this.logger.info(`cleaning ${caption}`);
            for (const p of projects){
                p.getLanguageService(/*ensureSynchronized*/ false).cleanupSemanticCache();
                p.cleanupProgram();
            }
        }
        cleanup() {
            this.cleanProjects("inferred projects", this.projectService.inferredProjects);
            this.cleanProjects("configured projects", arrayFrom(this.projectService.configuredProjects.values()));
            this.cleanProjects("external projects", this.projectService.externalProjects);
            if (this.host.gc) {
                this.logger.info(`host.gc()`);
                this.host.gc();
            }
        }
        getEncodedSyntacticClassifications(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            return languageService.getEncodedSyntacticClassifications(file, args);
        }
        getEncodedSemanticClassifications(args) {
            const { file, project } = this.getFileAndProject(args);
            const format = args.format === "2020" ? "2020" /* TwentyTwenty */  : "original" /* Original */ ;
            return project.getLanguageService().getEncodedSemanticClassifications(file, args, format);
        }
        getProject(projectFileName) {
            return projectFileName === void 0 ? void 0 : this.projectService.findProject(projectFileName);
        }
        getConfigFileAndProject(args) {
            const project = this.getProject(args.projectFileName);
            const file = toNormalizedPath(args.file);
            return {
                configFile: project && project.hasConfigFile(file) ? file : void 0,
                project
            };
        }
        getConfigFileDiagnostics(configFile, project, includeLinePosition) {
            const projectErrors = project.getAllProjectErrors();
            const optionsErrors = project.getLanguageService().getCompilerOptionsDiagnostics();
            const diagnosticsForConfigFile = filter(concatenate(projectErrors, optionsErrors), (diagnostic)=>!!diagnostic.file && diagnostic.file.fileName === configFile);
            return includeLinePosition ? this.convertToDiagnosticsWithLinePositionFromDiagnosticFile(diagnosticsForConfigFile) : map(diagnosticsForConfigFile, (diagnostic)=>formatDiagnosticToProtocol(diagnostic, /*includeFileName*/ false));
        }
        convertToDiagnosticsWithLinePositionFromDiagnosticFile(diagnostics) {
            return diagnostics.map((d)=>({
                    message: flattenDiagnosticMessageText(d.messageText, this.host.newLine),
                    start: d.start,
                    // TODO: GH#18217
                    length: d.length,
                    // TODO: GH#18217
                    category: diagnosticCategoryName(d),
                    code: d.code,
                    source: d.source,
                    startLocation: d.file && convertToLocation(getLineAndCharacterOfPosition(d.file, d.start)),
                    // TODO: GH#18217
                    endLocation: d.file && convertToLocation(getLineAndCharacterOfPosition(d.file, d.start + d.length)),
                    // TODO: GH#18217
                    reportsUnnecessary: d.reportsUnnecessary,
                    reportsDeprecated: d.reportsDeprecated,
                    relatedInformation: map(d.relatedInformation, formatRelatedInformation)
                }));
        }
        getCompilerOptionsDiagnostics(args) {
            const project = this.getProject(args.projectFileName);
            return this.convertToDiagnosticsWithLinePosition(filter(project.getLanguageService().getCompilerOptionsDiagnostics(), (diagnostic)=>!diagnostic.file), /*scriptInfo*/ void 0);
        }
        convertToDiagnosticsWithLinePosition(diagnostics, scriptInfo) {
            return diagnostics.map((d)=>({
                    message: flattenDiagnosticMessageText(d.messageText, this.host.newLine),
                    start: d.start,
                    length: d.length,
                    category: diagnosticCategoryName(d),
                    code: d.code,
                    source: d.source,
                    startLocation: scriptInfo && scriptInfo.positionToLineOffset(d.start),
                    // TODO: GH#18217
                    endLocation: scriptInfo && scriptInfo.positionToLineOffset(d.start + d.length),
                    reportsUnnecessary: d.reportsUnnecessary,
                    reportsDeprecated: d.reportsDeprecated,
                    relatedInformation: map(d.relatedInformation, formatRelatedInformation)
                }));
        }
        getDiagnosticsWorker(args, isSemantic, selector, includeLinePosition) {
            const { project, file } = this.getFileAndProject(args);
            if (isSemantic && isDeclarationFileInJSOnlyNonConfiguredProject(project, file)) return emptyArray2;
            const scriptInfo = project.getScriptInfoForNormalizedPath(file);
            const diagnostics = selector(project, file);
            return includeLinePosition ? this.convertToDiagnosticsWithLinePosition(diagnostics, scriptInfo) : diagnostics.map((d)=>formatDiag(file, project, d));
        }
        getDefinition(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const definitions = this.mapDefinitionInfoLocations(project.getLanguageService().getDefinitionAtPosition(file, position) || emptyArray2, project);
            return simplifiedResult ? this.mapDefinitionInfo(definitions, project) : definitions.map(_Session.mapToOriginalLocation);
        }
        mapDefinitionInfoLocations(definitions, project) {
            return definitions.map((info)=>{
                const newDocumentSpan = getMappedDocumentSpanForProject(info, project);
                return !newDocumentSpan ? info : (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, newDocumentSpan), {
                    containerKind: info.containerKind,
                    containerName: info.containerName,
                    kind: info.kind,
                    name: info.name,
                    failedAliasResolution: info.failedAliasResolution
                }), info.unverified && {
                    unverified: info.unverified
                });
            });
        }
        getDefinitionAndBoundSpan(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const scriptInfo = Debug.checkDefined(project.getScriptInfo(file));
            const unmappedDefinitionAndBoundSpan = project.getLanguageService().getDefinitionAndBoundSpan(file, position);
            if (!unmappedDefinitionAndBoundSpan || !unmappedDefinitionAndBoundSpan.definitions) return {
                definitions: emptyArray2,
                textSpan: void 0
            };
            const definitions = this.mapDefinitionInfoLocations(unmappedDefinitionAndBoundSpan.definitions, project);
            const { textSpan } = unmappedDefinitionAndBoundSpan;
            if (simplifiedResult) return {
                definitions: this.mapDefinitionInfo(definitions, project),
                textSpan: toProtocolTextSpan(textSpan, scriptInfo)
            };
            return {
                definitions: definitions.map(_Session.mapToOriginalLocation),
                textSpan
            };
        }
        findSourceDefinition(args) {
            var _a;
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const unmappedDefinitions = project.getLanguageService().getDefinitionAtPosition(file, position);
            let definitions = this.mapDefinitionInfoLocations(unmappedDefinitions || emptyArray2, project).slice();
            const needsJsResolution = this.projectService.serverMode === 0 /* Semantic */  && (!some(definitions, (d)=>toNormalizedPath(d.fileName) !== file && !d.isAmbient) || some(definitions, (d)=>!!d.failedAliasResolution));
            if (needsJsResolution) {
                const definitionSet = createSet((d)=>d.textSpan.start, getDocumentSpansEqualityComparer(this.host.useCaseSensitiveFileNames));
                definitions == null || definitions.forEach((d)=>definitionSet.add(d));
                const noDtsProject = project.getNoDtsResolutionProject(file);
                const ls = noDtsProject.getLanguageService();
                const jsDefinitions = (_a = ls.getDefinitionAtPosition(file, position, /*searchOtherFilesOnly*/ true, /*stopAtAlias*/ false)) == null ? void 0 : _a.filter((d)=>toNormalizedPath(d.fileName) !== file);
                if (some(jsDefinitions)) for (const jsDefinition of jsDefinitions){
                    if (jsDefinition.unverified) {
                        const refined = tryRefineDefinition(jsDefinition, project.getLanguageService().getProgram(), ls.getProgram());
                        if (some(refined)) {
                            for (const def of refined)definitionSet.add(def);
                            continue;
                        }
                    }
                    definitionSet.add(jsDefinition);
                }
                else {
                    const ambientCandidates = definitions.filter((d)=>toNormalizedPath(d.fileName) !== file && d.isAmbient);
                    for (const candidate of some(ambientCandidates) ? ambientCandidates : getAmbientCandidatesByClimbingAccessChain()){
                        const fileNameToSearch = findImplementationFileFromDtsFileName(candidate.fileName, file, noDtsProject);
                        if (!fileNameToSearch) continue;
                        const info = this.projectService.getOrCreateScriptInfoNotOpenedByClient(fileNameToSearch, noDtsProject.currentDirectory, noDtsProject.directoryStructureHost, /*deferredDeleteOk*/ false);
                        if (!info) continue;
                        if (!noDtsProject.containsScriptInfo(info)) {
                            noDtsProject.addRoot(info);
                            noDtsProject.updateGraph();
                        }
                        const noDtsProgram = ls.getProgram();
                        const fileToSearch = Debug.checkDefined(noDtsProgram.getSourceFile(fileNameToSearch));
                        for (const match of searchForDeclaration(candidate.name, fileToSearch, noDtsProgram))definitionSet.add(match);
                    }
                }
                definitions = arrayFrom(definitionSet.values());
            }
            definitions = definitions.filter((d)=>!d.isAmbient && !d.failedAliasResolution);
            return this.mapDefinitionInfo(definitions, project);
            function findImplementationFileFromDtsFileName(fileName, resolveFromFile, auxiliaryProject) {
                var _a2, _b, _c;
                const nodeModulesPathParts = getNodeModulePathParts(fileName);
                if (nodeModulesPathParts && fileName.lastIndexOf(nodeModulesPathPart) === nodeModulesPathParts.topLevelNodeModulesIndex) {
                    const packageDirectory = fileName.substring(0, nodeModulesPathParts.packageRootIndex);
                    const packageJsonCache = (_a2 = project.getModuleResolutionCache()) == null ? void 0 : _a2.getPackageJsonInfoCache();
                    const compilerOptions = project.getCompilationSettings();
                    const packageJson = getPackageScopeForPath(getNormalizedAbsolutePath(packageDirectory, project.getCurrentDirectory()), getTemporaryModuleResolutionState(packageJsonCache, project, compilerOptions));
                    if (!packageJson) return void 0;
                    const entrypoints = getEntrypointsFromPackageJsonInfo(packageJson, {
                        moduleResolution: 2 /* Node10 */ 
                    }, project, project.getModuleResolutionCache());
                    const packageNamePathPart = fileName.substring(nodeModulesPathParts.topLevelPackageNameIndex + 1, nodeModulesPathParts.packageRootIndex);
                    const packageName = getPackageNameFromTypesPackageName(unmangleScopedPackageName(packageNamePathPart));
                    const path = project.toPath(fileName);
                    if (entrypoints && some(entrypoints, (e)=>project.toPath(e) === path)) return (_b = auxiliaryProject.resolutionCache.resolveSingleModuleNameWithoutWatching(packageName, resolveFromFile).resolvedModule) == null ? void 0 : _b.resolvedFileName;
                    else {
                        const pathToFileInPackage = fileName.substring(nodeModulesPathParts.packageRootIndex + 1);
                        const specifier = `${packageName}/${removeFileExtension(pathToFileInPackage)}`;
                        return (_c = auxiliaryProject.resolutionCache.resolveSingleModuleNameWithoutWatching(specifier, resolveFromFile).resolvedModule) == null ? void 0 : _c.resolvedFileName;
                    }
                }
                return void 0;
            }
            function getAmbientCandidatesByClimbingAccessChain() {
                const ls = project.getLanguageService();
                const program = ls.getProgram();
                const initialNode = getTouchingPropertyName(program.getSourceFile(file), position);
                if ((isStringLiteralLike(initialNode) || isIdentifier(initialNode)) && isAccessExpression(initialNode.parent)) return forEachNameInAccessChainWalkingLeft(initialNode, (nameInChain)=>{
                    var _a2;
                    if (nameInChain === initialNode) return void 0;
                    const candidates = (_a2 = ls.getDefinitionAtPosition(file, nameInChain.getStart(), /*searchOtherFilesOnly*/ true, /*stopAtAlias*/ false)) == null ? void 0 : _a2.filter((d)=>toNormalizedPath(d.fileName) !== file && d.isAmbient).map((d)=>({
                            fileName: d.fileName,
                            name: getTextOfIdentifierOrLiteral(initialNode)
                        }));
                    if (some(candidates)) return candidates;
                }) || emptyArray2;
                return emptyArray2;
            }
            function tryRefineDefinition(definition, program, noDtsProgram) {
                var _a2;
                const fileToSearch = noDtsProgram.getSourceFile(definition.fileName);
                if (!fileToSearch) return void 0;
                const initialNode = getTouchingPropertyName(program.getSourceFile(file), position);
                const symbol = program.getTypeChecker().getSymbolAtLocation(initialNode);
                const importSpecifier = symbol && getDeclarationOfKind(symbol, 277 /* ImportSpecifier */ );
                if (!importSpecifier) return void 0;
                const nameToSearch = ((_a2 = importSpecifier.propertyName) == null ? void 0 : _a2.text) || importSpecifier.name.text;
                return searchForDeclaration(nameToSearch, fileToSearch, noDtsProgram);
            }
            function searchForDeclaration(declarationName, fileToSearch, noDtsProgram) {
                const matches = ts_FindAllReferences_exports.Core.getTopMostDeclarationNamesInFile(declarationName, fileToSearch);
                return mapDefined(matches, (match)=>{
                    const symbol = noDtsProgram.getTypeChecker().getSymbolAtLocation(match);
                    const decl = getDeclarationFromName(match);
                    if (symbol && decl) return ts_GoToDefinition_exports.createDefinitionInfo(decl, noDtsProgram.getTypeChecker(), symbol, decl, /*unverified*/ true);
                });
            }
        }
        getEmitOutput(args) {
            const { file, project } = this.getFileAndProject(args);
            if (!project.shouldEmitFile(project.getScriptInfo(file))) return {
                emitSkipped: true,
                outputFiles: [],
                diagnostics: []
            };
            const result = project.getLanguageService().getEmitOutput(file);
            return args.richResponse ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, result), {
                diagnostics: args.includeLinePosition ? this.convertToDiagnosticsWithLinePositionFromDiagnosticFile(result.diagnostics) : result.diagnostics.map((d)=>formatDiagnosticToProtocol(d, /*includeFileName*/ true))
            }) : result;
        }
        mapJSDocTagInfo(tags, project, richResponse) {
            return tags ? tags.map((tag)=>{
                var _a;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, tag), {
                    text: richResponse ? this.mapDisplayParts(tag.text, project) : (_a = tag.text) == null ? void 0 : _a.map((part)=>part.text).join("")
                });
            }) : [];
        }
        mapDisplayParts(parts, project) {
            if (!parts) return [];
            return parts.map((part)=>part.kind !== "linkName" ? part : (0, _objectSpreadProps._)((0, _objectSpread._)({}, part), {
                    target: this.toFileSpan(part.target.fileName, part.target.textSpan, project)
                }));
        }
        mapSignatureHelpItems(items, project, richResponse) {
            return items.map((item)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                    documentation: this.mapDisplayParts(item.documentation, project),
                    parameters: item.parameters.map((p)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, p), {
                            documentation: this.mapDisplayParts(p.documentation, project)
                        })),
                    tags: this.mapJSDocTagInfo(item.tags, project, richResponse)
                }));
        }
        mapDefinitionInfo(definitions, project) {
            return definitions.map((def)=>(0, _objectSpread._)({}, this.toFileSpanWithContext(def.fileName, def.textSpan, def.contextSpan, project), def.unverified && {
                    unverified: def.unverified
                }));
        }
        /*
   * When we map a .d.ts location to .ts, Visual Studio gets confused because there's no associated Roslyn Document in
   * the same project which corresponds to the file. VS Code has no problem with this, and luckily we have two protocols.
   * This retains the existing behavior for the "simplified" (VS Code) protocol but stores the .d.ts location in a
   * set of additional fields, and does the reverse for VS (store the .d.ts location where
   * it used to be and stores the .ts location in the additional fields).
   */ static mapToOriginalLocation(def) {
            if (def.originalFileName) {
                Debug.assert(def.originalTextSpan !== void 0, "originalTextSpan should be present if originalFileName is");
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, def), {
                    fileName: def.originalFileName,
                    textSpan: def.originalTextSpan,
                    targetFileName: def.fileName,
                    targetTextSpan: def.textSpan,
                    contextSpan: def.originalContextSpan,
                    targetContextSpan: def.contextSpan
                });
            }
            return def;
        }
        toFileSpan(fileName, textSpan, project) {
            const ls = project.getLanguageService();
            const start = ls.toLineColumnOffset(fileName, textSpan.start);
            const end = ls.toLineColumnOffset(fileName, textSpanEnd(textSpan));
            return {
                file: fileName,
                start: {
                    line: start.line + 1,
                    offset: start.character + 1
                },
                end: {
                    line: end.line + 1,
                    offset: end.character + 1
                }
            };
        }
        toFileSpanWithContext(fileName, textSpan, contextSpan, project) {
            const fileSpan = this.toFileSpan(fileName, textSpan, project);
            const context = contextSpan && this.toFileSpan(fileName, contextSpan, project);
            return context ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, fileSpan), {
                contextStart: context.start,
                contextEnd: context.end
            }) : fileSpan;
        }
        getTypeDefinition(args) {
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const definitions = this.mapDefinitionInfoLocations(project.getLanguageService().getTypeDefinitionAtPosition(file, position) || emptyArray2, project);
            return this.mapDefinitionInfo(definitions, project);
        }
        mapImplementationLocations(implementations, project) {
            return implementations.map((info)=>{
                const newDocumentSpan = getMappedDocumentSpanForProject(info, project);
                return !newDocumentSpan ? info : (0, _objectSpreadProps._)((0, _objectSpread._)({}, newDocumentSpan), {
                    kind: info.kind,
                    displayParts: info.displayParts
                });
            });
        }
        getImplementation(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const implementations = this.mapImplementationLocations(project.getLanguageService().getImplementationAtPosition(file, position) || emptyArray2, project);
            return simplifiedResult ? implementations.map(({ fileName, textSpan, contextSpan })=>this.toFileSpanWithContext(fileName, textSpan, contextSpan, project)) : implementations.map(_Session.mapToOriginalLocation);
        }
        getSyntacticDiagnosticsSync(args) {
            const { configFile } = this.getConfigFileAndProject(args);
            if (configFile) return emptyArray2;
            return this.getDiagnosticsWorker(args, /*isSemantic*/ false, (project, file)=>project.getLanguageService().getSyntacticDiagnostics(file), !!args.includeLinePosition);
        }
        getSemanticDiagnosticsSync(args) {
            const { configFile, project } = this.getConfigFileAndProject(args);
            if (configFile) return this.getConfigFileDiagnostics(configFile, project, !!args.includeLinePosition);
            return this.getDiagnosticsWorker(args, /*isSemantic*/ true, (project2, file)=>project2.getLanguageService().getSemanticDiagnostics(file).filter((d)=>!!d.file), !!args.includeLinePosition);
        }
        getSuggestionDiagnosticsSync(args) {
            const { configFile } = this.getConfigFileAndProject(args);
            if (configFile) return emptyArray2;
            return this.getDiagnosticsWorker(args, /*isSemantic*/ true, (project, file)=>project.getLanguageService().getSuggestionDiagnostics(file), !!args.includeLinePosition);
        }
        getJsxClosingTag(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            const tag = languageService.getJsxClosingTagAtPosition(file, position);
            return tag === void 0 ? void 0 : {
                newText: tag.newText,
                caretOffset: 0
            };
        }
        getLinkedEditingRange(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            const linkedEditInfo = languageService.getLinkedEditingRangeAtPosition(file, position);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            if (scriptInfo === void 0 || linkedEditInfo === void 0) return void 0;
            return convertLinkedEditInfoToRanges(linkedEditInfo, scriptInfo);
        }
        getDocumentHighlights(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const documentHighlights = project.getLanguageService().getDocumentHighlights(file, position, args.filesToSearch);
            if (!documentHighlights) return emptyArray2;
            if (!simplifiedResult) return documentHighlights;
            return documentHighlights.map(({ fileName, highlightSpans })=>{
                const scriptInfo = project.getScriptInfo(fileName);
                return {
                    file: fileName,
                    highlightSpans: highlightSpans.map(({ textSpan, kind, contextSpan })=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, toProtocolTextSpanWithContext(textSpan, contextSpan, scriptInfo)), {
                            kind
                        }))
                };
            });
        }
        provideInlayHints(args) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const hints = project.getLanguageService().provideInlayHints(file, args, this.getPreferences(file));
            return hints.map((hint)=>{
                const { position, displayParts } = hint;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, hint), {
                    position: scriptInfo.positionToLineOffset(position),
                    displayParts: displayParts == null ? void 0 : displayParts.map(({ text, span, file: file2 })=>{
                        if (span) {
                            Debug.assertIsDefined(file2, "Target file should be defined together with its span.");
                            const scriptInfo2 = this.projectService.getScriptInfo(file2);
                            return {
                                text,
                                span: {
                                    start: scriptInfo2.positionToLineOffset(span.start),
                                    end: scriptInfo2.positionToLineOffset(span.start + span.length),
                                    file: file2
                                }
                            };
                        } else return {
                            text
                        };
                    })
                });
            });
        }
        mapCode(args) {
            var _a;
            const formatOptions = this.getHostFormatOptions();
            const preferences = this.getHostPreferences();
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const focusLocations = (_a = args.mapping.focusLocations) == null ? void 0 : _a.map((spans)=>{
                return spans.map((loc)=>{
                    const start = scriptInfo.lineOffsetToPosition(loc.start.line, loc.start.offset);
                    const end = scriptInfo.lineOffsetToPosition(loc.end.line, loc.end.offset);
                    return {
                        start,
                        length: end - start
                    };
                });
            });
            const changes = languageService.mapCode(file, args.mapping.contents, focusLocations, formatOptions, preferences);
            return this.mapTextChangesToCodeEdits(changes);
        }
        getCopilotRelatedInfo() {
            return {
                relatedFiles: []
            };
        }
        setCompilerOptionsForInferredProjects(args) {
            this.projectService.setCompilerOptionsForInferredProjects(args.options, args.projectRootPath);
        }
        getProjectInfo(args) {
            return this.getProjectInfoWorker(args.file, args.projectFileName, args.needFileNameList, args.needDefaultConfiguredProjectInfo, /*excludeConfigFiles*/ false);
        }
        getProjectInfoWorker(uncheckedFileName, projectFileName, needFileNameList, needDefaultConfiguredProjectInfo, excludeConfigFiles) {
            const { project } = this.getFileAndProjectWorker(uncheckedFileName, projectFileName);
            updateProjectIfDirty(project);
            const projectInfo = {
                configFileName: project.getProjectName(),
                languageServiceDisabled: !project.languageServiceEnabled,
                fileNames: needFileNameList ? project.getFileNames(/*excludeFilesFromExternalLibraries*/ false, excludeConfigFiles) : void 0,
                configuredProjectInfo: needDefaultConfiguredProjectInfo ? this.getDefaultConfiguredProjectInfo(uncheckedFileName) : void 0
            };
            return projectInfo;
        }
        getDefaultConfiguredProjectInfo(uncheckedFileName) {
            var _a;
            const info = this.projectService.getScriptInfo(uncheckedFileName);
            if (!info) return;
            const result = this.projectService.findDefaultConfiguredProjectWorker(info, 3 /* CreateReplay */ );
            if (!result) return void 0;
            let notMatchedByConfig;
            let notInProject;
            result.seenProjects.forEach((kind, project)=>{
                if (project !== result.defaultProject) {
                    if (kind !== 3 /* CreateReplay */ ) (notMatchedByConfig !== null && notMatchedByConfig !== void 0 ? notMatchedByConfig : notMatchedByConfig = []).push(toNormalizedPath(project.getConfigFilePath()));
                    else (notInProject !== null && notInProject !== void 0 ? notInProject : notInProject = []).push(toNormalizedPath(project.getConfigFilePath()));
                }
            });
            (_a = result.seenConfigs) == null || _a.forEach((config)=>(notMatchedByConfig !== null && notMatchedByConfig !== void 0 ? notMatchedByConfig : notMatchedByConfig = []).push(config));
            return {
                notMatchedByConfig,
                notInProject,
                defaultProject: result.defaultProject && toNormalizedPath(result.defaultProject.getConfigFilePath())
            };
        }
        getRenameInfo(args) {
            const { file, project } = this.getFileAndProject(args);
            const position = this.getPositionInFile(args, file);
            const preferences = this.getPreferences(file);
            return project.getLanguageService().getRenameInfo(file, position, preferences);
        }
        getProjects(args, getScriptInfoEnsuringProjectsUptoDate, ignoreNoProjectError) {
            let projects;
            let symLinkedProjects;
            if (args.projectFileName) {
                const project = this.getProject(args.projectFileName);
                if (project) projects = [
                    project
                ];
            } else {
                const scriptInfo = getScriptInfoEnsuringProjectsUptoDate ? this.projectService.getScriptInfoEnsuringProjectsUptoDate(args.file) : this.projectService.getScriptInfo(args.file);
                if (!scriptInfo) {
                    if (ignoreNoProjectError) return emptyArray2;
                    this.projectService.logErrorForScriptInfoNotFound(args.file);
                    return Errors.ThrowNoProject();
                } else if (!getScriptInfoEnsuringProjectsUptoDate) this.projectService.ensureDefaultProjectForFile(scriptInfo);
                projects = scriptInfo.containingProjects;
                symLinkedProjects = this.projectService.getSymlinkedProjects(scriptInfo);
            }
            projects = filter(projects, (p)=>p.languageServiceEnabled && !p.isOrphan());
            if (!ignoreNoProjectError && (!projects || !projects.length) && !symLinkedProjects) {
                var _args_file;
                this.projectService.logErrorForScriptInfoNotFound((_args_file = args.file) !== null && _args_file !== void 0 ? _args_file : args.projectFileName);
                return Errors.ThrowNoProject();
            }
            return symLinkedProjects ? {
                projects,
                symLinkedProjects
            } : projects;
        }
        getDefaultProject(args) {
            if (args.projectFileName) {
                const project = this.getProject(args.projectFileName);
                if (project) return project;
                if (!args.file) return Errors.ThrowNoProject();
            }
            const info = this.projectService.getScriptInfo(args.file);
            return info.getDefaultProject();
        }
        getRenameLocations(args, simplifiedResult) {
            const file = toNormalizedPath(args.file);
            const position = this.getPositionInFile(args, file);
            const projects = this.getProjects(args);
            const defaultProject = this.getDefaultProject(args);
            const preferences = this.getPreferences(file);
            const renameInfo = this.mapRenameInfo(defaultProject.getLanguageService().getRenameInfo(file, position, preferences), Debug.checkDefined(this.projectService.getScriptInfo(file)));
            if (!renameInfo.canRename) return simplifiedResult ? {
                info: renameInfo,
                locs: []
            } : [];
            const locations = getRenameLocationsWorker(projects, defaultProject, {
                fileName: args.file,
                pos: position
            }, !!args.findInStrings, !!args.findInComments, preferences, this.host.useCaseSensitiveFileNames);
            if (!simplifiedResult) return locations;
            return {
                info: renameInfo,
                locs: this.toSpanGroups(locations)
            };
        }
        mapRenameInfo(info, scriptInfo) {
            if (info.canRename) {
                const { canRename, fileToRename, displayName, fullDisplayName, kind, kindModifiers, triggerSpan } = info;
                return identity({
                    canRename,
                    fileToRename,
                    displayName,
                    fullDisplayName,
                    kind,
                    kindModifiers,
                    triggerSpan: toProtocolTextSpan(triggerSpan, scriptInfo)
                });
            } else return info;
        }
        toSpanGroups(locations) {
            const map2 = /* @__PURE__ */ new Map();
            for (const _ref of locations){
                let { fileName, textSpan, contextSpan, originalContextSpan: _2, originalTextSpan: _, originalFileName: _1 } = _ref, prefixSuffixText = (0, _objectWithoutProperties._)(_ref, [
                    "fileName",
                    "textSpan",
                    "contextSpan",
                    "originalContextSpan",
                    "originalTextSpan",
                    "originalFileName"
                ]);
                let group2 = map2.get(fileName);
                if (!group2) map2.set(fileName, group2 = {
                    file: fileName,
                    locs: []
                });
                const scriptInfo = Debug.checkDefined(this.projectService.getScriptInfo(fileName));
                group2.locs.push((0, _objectSpread._)({}, toProtocolTextSpanWithContext(textSpan, contextSpan, scriptInfo), prefixSuffixText));
            }
            return arrayFrom(map2.values());
        }
        getReferences(args, simplifiedResult) {
            const file = toNormalizedPath(args.file);
            const projects = this.getProjects(args);
            const position = this.getPositionInFile(args, file);
            const references = getReferencesWorker(projects, this.getDefaultProject(args), {
                fileName: args.file,
                pos: position
            }, this.host.useCaseSensitiveFileNames, this.logger);
            if (!simplifiedResult) return references;
            const preferences = this.getPreferences(file);
            const defaultProject = this.getDefaultProject(args);
            const scriptInfo = defaultProject.getScriptInfoForNormalizedPath(file);
            const nameInfo = defaultProject.getLanguageService().getQuickInfoAtPosition(file, position);
            const symbolDisplayString = nameInfo ? displayPartsToString(nameInfo.displayParts) : "";
            const nameSpan = nameInfo && nameInfo.textSpan;
            const symbolStartOffset = nameSpan ? scriptInfo.positionToLineOffset(nameSpan.start).offset : 0;
            const symbolName2 = nameSpan ? scriptInfo.getSnapshot().getText(nameSpan.start, textSpanEnd(nameSpan)) : "";
            const refs = flatMap(references, (referencedSymbol)=>{
                return referencedSymbol.references.map((entry)=>referenceEntryToReferencesResponseItem(this.projectService, entry, preferences));
            });
            return {
                refs,
                symbolName: symbolName2,
                symbolStartOffset,
                symbolDisplayString
            };
        }
        getFileReferences(args, simplifiedResult) {
            const projects = this.getProjects(args);
            const fileName = toNormalizedPath(args.file);
            const preferences = this.getPreferences(fileName);
            const initialLocation = {
                fileName,
                pos: 0
            };
            const perProjectResults = getPerProjectReferences(projects, this.getDefaultProject(args), initialLocation, initialLocation, mapDefinitionInProjectIfFileInProject, (project)=>{
                this.logger.info(`Finding references to file ${fileName} in project ${project.getProjectName()}`);
                return project.getLanguageService().getFileReferences(fileName);
            });
            let references;
            if (isArray(perProjectResults)) references = perProjectResults;
            else {
                references = [];
                const seen = createDocumentSpanSet(this.host.useCaseSensitiveFileNames);
                perProjectResults.forEach((projectOutputs)=>{
                    for (const referenceEntry of projectOutputs)if (!seen.has(referenceEntry)) {
                        references.push(referenceEntry);
                        seen.add(referenceEntry);
                    }
                });
            }
            if (!simplifiedResult) return references;
            const refs = references.map((entry)=>referenceEntryToReferencesResponseItem(this.projectService, entry, preferences));
            return {
                refs,
                symbolName: `"${args.file}"`
            };
        }
        /**
   * @param fileName is the name of the file to be opened
   * @param fileContent is a version of the file content that is known to be more up to date than the one on disk
   */ openClientFile(fileName, fileContent, scriptKind, projectRootPath) {
            this.projectService.openClientFileWithNormalizedPath(fileName, fileContent, scriptKind, /*hasMixedContent*/ false, projectRootPath);
        }
        getPosition(args, scriptInfo) {
            return args.position !== void 0 ? args.position : scriptInfo.lineOffsetToPosition(args.line, args.offset);
        }
        getPositionInFile(args, file) {
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            return this.getPosition(args, scriptInfo);
        }
        getFileAndProject(args) {
            return this.getFileAndProjectWorker(args.file, args.projectFileName);
        }
        getFileAndLanguageServiceForSyntacticOperation(args) {
            const { file, project } = this.getFileAndProject(args);
            return {
                file,
                languageService: project.getLanguageService(/*ensureSynchronized*/ false)
            };
        }
        getFileAndProjectWorker(uncheckedFileName, projectFileName) {
            const file = toNormalizedPath(uncheckedFileName);
            const project = this.getProject(projectFileName) || this.projectService.ensureDefaultProjectForFile(file);
            return {
                file,
                project
            };
        }
        getOutliningSpans(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const spans = languageService.getOutliningSpans(file);
            if (simplifiedResult) {
                const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
                return spans.map((s)=>({
                        textSpan: toProtocolTextSpan(s.textSpan, scriptInfo),
                        hintSpan: toProtocolTextSpan(s.hintSpan, scriptInfo),
                        bannerText: s.bannerText,
                        autoCollapse: s.autoCollapse,
                        kind: s.kind
                    }));
            } else return spans;
        }
        getTodoComments(args) {
            const { file, project } = this.getFileAndProject(args);
            return project.getLanguageService().getTodoComments(file, args.descriptors);
        }
        getDocCommentTemplate(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            return languageService.getDocCommentTemplateAtPosition(file, position, this.getPreferences(file), this.getFormatOptions(file));
        }
        getSpanOfEnclosingComment(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const onlyMultiLine = args.onlyMultiLine;
            const position = this.getPositionInFile(args, file);
            return languageService.getSpanOfEnclosingComment(file, position, onlyMultiLine);
        }
        getIndentation(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            const options = args.options ? convertFormatOptions(args.options) : this.getFormatOptions(file);
            const indentation = languageService.getIndentationAtPosition(file, position, options);
            return {
                position,
                indentation
            };
        }
        getBreakpointStatement(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            return languageService.getBreakpointStatementAtPosition(file, position);
        }
        getNameOrDottedNameSpan(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            return languageService.getNameOrDottedNameSpan(file, position, position);
        }
        isValidBraceCompletion(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const position = this.getPositionInFile(args, file);
            return languageService.isValidBraceCompletionAtPosition(file, position, args.openingBrace.charCodeAt(0));
        }
        getQuickInfoWorker(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const userPreferences = this.getPreferences(file);
            const quickInfo = project.getLanguageService().getQuickInfoAtPosition(file, this.getPosition(args, scriptInfo), userPreferences.maximumHoverLength, args.verbosityLevel);
            if (!quickInfo) return void 0;
            const useDisplayParts = !!userPreferences.displayPartsForJSDoc;
            if (simplifiedResult) {
                const displayString = displayPartsToString(quickInfo.displayParts);
                return {
                    kind: quickInfo.kind,
                    kindModifiers: quickInfo.kindModifiers,
                    start: scriptInfo.positionToLineOffset(quickInfo.textSpan.start),
                    end: scriptInfo.positionToLineOffset(textSpanEnd(quickInfo.textSpan)),
                    displayString,
                    documentation: useDisplayParts ? this.mapDisplayParts(quickInfo.documentation, project) : displayPartsToString(quickInfo.documentation),
                    tags: this.mapJSDocTagInfo(quickInfo.tags, project, useDisplayParts),
                    canIncreaseVerbosityLevel: quickInfo.canIncreaseVerbosityLevel
                };
            } else return useDisplayParts ? quickInfo : (0, _objectSpreadProps._)((0, _objectSpread._)({}, quickInfo), {
                tags: this.mapJSDocTagInfo(quickInfo.tags, project, /*richResponse*/ false)
            });
        }
        getFormattingEditsForRange(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const startPosition = scriptInfo.lineOffsetToPosition(args.line, args.offset);
            const endPosition = scriptInfo.lineOffsetToPosition(args.endLine, args.endOffset);
            const edits = languageService.getFormattingEditsForRange(file, startPosition, endPosition, this.getFormatOptions(file));
            if (!edits) return void 0;
            return edits.map((edit)=>this.convertTextChangeToCodeEdit(edit, scriptInfo));
        }
        getFormattingEditsForRangeFull(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const options = args.options ? convertFormatOptions(args.options) : this.getFormatOptions(file);
            return languageService.getFormattingEditsForRange(file, args.position, args.endPosition, options);
        }
        getFormattingEditsForDocumentFull(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const options = args.options ? convertFormatOptions(args.options) : this.getFormatOptions(file);
            return languageService.getFormattingEditsForDocument(file, options);
        }
        getFormattingEditsAfterKeystrokeFull(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const options = args.options ? convertFormatOptions(args.options) : this.getFormatOptions(file);
            return languageService.getFormattingEditsAfterKeystroke(file, args.position, args.key, options);
        }
        getFormattingEditsAfterKeystroke(args) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const position = scriptInfo.lineOffsetToPosition(args.line, args.offset);
            const formatOptions = this.getFormatOptions(file);
            const edits = languageService.getFormattingEditsAfterKeystroke(file, position, args.key, formatOptions);
            if (args.key === "\n" && (!edits || edits.length === 0 || allEditsBeforePos(edits, position))) {
                const { lineText, absolutePosition } = scriptInfo.textStorage.getAbsolutePositionAndLineText(args.line);
                if (lineText && lineText.search("\\S") < 0) {
                    const preferredIndent = languageService.getIndentationAtPosition(file, position, formatOptions);
                    let hasIndent = 0;
                    let i, len;
                    for(i = 0, len = lineText.length; i < len; i++){
                        if (lineText.charAt(i) === " ") hasIndent++;
                        else if (lineText.charAt(i) === "	") hasIndent += formatOptions.tabSize;
                        else break;
                    }
                    if (preferredIndent !== hasIndent) {
                        const firstNoWhiteSpacePosition = absolutePosition + i;
                        edits.push({
                            span: createTextSpanFromBounds(absolutePosition, firstNoWhiteSpacePosition),
                            newText: ts_formatting_exports.getIndentationString(preferredIndent, formatOptions)
                        });
                    }
                }
            }
            if (!edits) return void 0;
            return edits.map((edit)=>{
                return {
                    start: scriptInfo.positionToLineOffset(edit.span.start),
                    end: scriptInfo.positionToLineOffset(textSpanEnd(edit.span)),
                    newText: edit.newText ? edit.newText : ""
                };
            });
        }
        getCompletions(args, kind) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const position = this.getPosition(args, scriptInfo);
            const completions = project.getLanguageService().getCompletionsAtPosition(file, position, (0, _objectSpreadProps._)((0, _objectSpread._)({}, convertUserPreferences(this.getPreferences(file))), {
                triggerCharacter: args.triggerCharacter,
                triggerKind: args.triggerKind,
                includeExternalModuleExports: args.includeExternalModuleExports,
                includeInsertTextCompletions: args.includeInsertTextCompletions
            }), project.projectService.getFormatCodeOptions(file));
            if (completions === void 0) return void 0;
            if (kind === "completions-full" /* CompletionsFull */ ) return completions;
            const prefix = args.prefix || "";
            const entries = mapDefined(completions.entries, (entry)=>{
                if (completions.isMemberCompletion || startsWith(entry.name.toLowerCase(), prefix.toLowerCase())) {
                    const convertedSpan = entry.replacementSpan ? toProtocolTextSpan(entry.replacementSpan, scriptInfo) : void 0;
                    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, entry), {
                        replacementSpan: convertedSpan,
                        hasAction: entry.hasAction || void 0,
                        symbol: void 0
                    });
                }
            });
            if (kind === "completions" /* Completions */ ) {
                if (completions.metadata) entries.metadata = completions.metadata;
                return entries;
            }
            const res = (0, _objectSpreadProps._)((0, _objectSpread._)({}, completions), {
                optionalReplacementSpan: completions.optionalReplacementSpan && toProtocolTextSpan(completions.optionalReplacementSpan, scriptInfo),
                entries
            });
            return res;
        }
        getCompletionEntryDetails(args, fullResult) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const position = this.getPosition(args, scriptInfo);
            const formattingOptions = project.projectService.getFormatCodeOptions(file);
            const useDisplayParts = !!this.getPreferences(file).displayPartsForJSDoc;
            const result = mapDefined(args.entryNames, (entryName)=>{
                const { name, source, data } = typeof entryName === "string" ? {
                    name: entryName,
                    source: void 0,
                    data: void 0
                } : entryName;
                return project.getLanguageService().getCompletionEntryDetails(file, position, name, formattingOptions, source, this.getPreferences(file), data ? cast(data, isCompletionEntryData) : void 0);
            });
            return fullResult ? useDisplayParts ? result : result.map((details)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, details), {
                    tags: this.mapJSDocTagInfo(details.tags, project, /*richResponse*/ false)
                })) : result.map((details)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, details), {
                    codeActions: map(details.codeActions, (action)=>this.mapCodeAction(action)),
                    documentation: this.mapDisplayParts(details.documentation, project),
                    tags: this.mapJSDocTagInfo(details.tags, project, useDisplayParts)
                }));
        }
        getCompileOnSaveAffectedFileList(args) {
            const projects = this.getProjects(args, /*getScriptInfoEnsuringProjectsUptoDate*/ true, /*ignoreNoProjectError*/ true);
            const info = this.projectService.getScriptInfo(args.file);
            if (!info) return emptyArray2;
            return combineProjectOutput(info, (path)=>this.projectService.getScriptInfoForPath(path), projects, (project, info2)=>{
                if (!project.compileOnSaveEnabled || !project.languageServiceEnabled || project.isOrphan()) return void 0;
                const compilationSettings = project.getCompilationSettings();
                if (!!compilationSettings.noEmit || isDeclarationFileName(info2.fileName) && !dtsChangeCanAffectEmit(compilationSettings)) return void 0;
                return {
                    projectFileName: project.getProjectName(),
                    fileNames: project.getCompileOnSaveAffectedFileList(info2),
                    projectUsesOutFile: !!compilationSettings.outFile
                };
            });
        }
        emitFile(args) {
            const { file, project } = this.getFileAndProject(args);
            if (!project) Errors.ThrowNoProject();
            if (!project.languageServiceEnabled) return args.richResponse ? {
                emitSkipped: true,
                diagnostics: []
            } : false;
            const scriptInfo = project.getScriptInfo(file);
            const { emitSkipped, diagnostics } = project.emitFile(scriptInfo, (path, data, writeByteOrderMark)=>this.host.writeFile(path, data, writeByteOrderMark));
            return args.richResponse ? {
                emitSkipped,
                diagnostics: args.includeLinePosition ? this.convertToDiagnosticsWithLinePositionFromDiagnosticFile(diagnostics) : diagnostics.map((d)=>formatDiagnosticToProtocol(d, /*includeFileName*/ true))
            } : !emitSkipped;
        }
        getSignatureHelpItems(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const position = this.getPosition(args, scriptInfo);
            const helpItems = project.getLanguageService().getSignatureHelpItems(file, position, args);
            const useDisplayParts = !!this.getPreferences(file).displayPartsForJSDoc;
            if (helpItems && simplifiedResult) {
                const span = helpItems.applicableSpan;
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, helpItems), {
                    applicableSpan: {
                        start: scriptInfo.positionToLineOffset(span.start),
                        end: scriptInfo.positionToLineOffset(span.start + span.length)
                    },
                    items: this.mapSignatureHelpItems(helpItems.items, project, useDisplayParts)
                });
            } else if (useDisplayParts || !helpItems) return helpItems;
            else return (0, _objectSpreadProps._)((0, _objectSpread._)({}, helpItems), {
                items: helpItems.items.map((item)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                        tags: this.mapJSDocTagInfo(item.tags, project, /*richResponse*/ false)
                    }))
            });
        }
        toPendingErrorCheck(uncheckedFileName) {
            const fileName = toNormalizedPath(uncheckedFileName);
            const project = this.projectService.tryGetDefaultProjectForFile(fileName);
            return project && {
                fileName,
                project
            };
        }
        getDiagnostics(next, delay, fileArgs) {
            if (this.suppressDiagnosticEvents) return;
            if (fileArgs.length > 0) this.updateErrorCheck(next, fileArgs, delay);
        }
        change(args) {
            const scriptInfo = this.projectService.getScriptInfo(args.file);
            Debug.assert(!!scriptInfo);
            scriptInfo.textStorage.switchToScriptVersionCache();
            const start = scriptInfo.lineOffsetToPosition(args.line, args.offset);
            const end = scriptInfo.lineOffsetToPosition(args.endLine, args.endOffset);
            if (start >= 0) {
                this.changeSeq++;
                this.projectService.applyChangesToFile(scriptInfo, singleIterator({
                    span: {
                        start,
                        length: end - start
                    },
                    newText: args.insertString
                }));
            }
        }
        reload(args) {
            const file = toNormalizedPath(args.file);
            const tempFileName = args.tmpfile === void 0 ? void 0 : toNormalizedPath(args.tmpfile);
            const info = this.projectService.getScriptInfoForNormalizedPath(file);
            if (info) {
                this.changeSeq++;
                info.reloadFromFile(tempFileName);
            }
        }
        saveToTmp(fileName, tempFileName) {
            const scriptInfo = this.projectService.getScriptInfo(fileName);
            if (scriptInfo) scriptInfo.saveTo(tempFileName);
        }
        closeClientFile(fileName) {
            if (!fileName) return;
            const file = normalizePath(fileName);
            this.projectService.closeClientFile(file);
        }
        mapLocationNavigationBarItems(items, scriptInfo) {
            return map(items, (item)=>({
                    text: item.text,
                    kind: item.kind,
                    kindModifiers: item.kindModifiers,
                    spans: item.spans.map((span)=>toProtocolTextSpan(span, scriptInfo)),
                    childItems: this.mapLocationNavigationBarItems(item.childItems, scriptInfo),
                    indent: item.indent
                }));
        }
        getNavigationBarItems(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const items = languageService.getNavigationBarItems(file);
            return !items ? void 0 : simplifiedResult ? this.mapLocationNavigationBarItems(items, this.projectService.getScriptInfoForNormalizedPath(file)) : items;
        }
        toLocationNavigationTree(tree, scriptInfo) {
            return {
                text: tree.text,
                kind: tree.kind,
                kindModifiers: tree.kindModifiers,
                spans: tree.spans.map((span)=>toProtocolTextSpan(span, scriptInfo)),
                nameSpan: tree.nameSpan && toProtocolTextSpan(tree.nameSpan, scriptInfo),
                childItems: map(tree.childItems, (item)=>this.toLocationNavigationTree(item, scriptInfo))
            };
        }
        getNavigationTree(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const tree = languageService.getNavigationTree(file);
            return !tree ? void 0 : simplifiedResult ? this.toLocationNavigationTree(tree, this.projectService.getScriptInfoForNormalizedPath(file)) : tree;
        }
        getNavigateToItems(args, simplifiedResult) {
            const full = this.getFullNavigateToItems(args);
            return !simplifiedResult ? flatMap(full, ({ navigateToItems })=>navigateToItems) : flatMap(full, ({ project, navigateToItems })=>navigateToItems.map((navItem)=>{
                    const scriptInfo = project.getScriptInfo(navItem.fileName);
                    const bakedItem = {
                        name: navItem.name,
                        kind: navItem.kind,
                        kindModifiers: navItem.kindModifiers,
                        isCaseSensitive: navItem.isCaseSensitive,
                        matchKind: navItem.matchKind,
                        file: navItem.fileName,
                        start: scriptInfo.positionToLineOffset(navItem.textSpan.start),
                        end: scriptInfo.positionToLineOffset(textSpanEnd(navItem.textSpan))
                    };
                    if (navItem.kindModifiers && navItem.kindModifiers !== "") bakedItem.kindModifiers = navItem.kindModifiers;
                    if (navItem.containerName && navItem.containerName.length > 0) bakedItem.containerName = navItem.containerName;
                    if (navItem.containerKind && navItem.containerKind.length > 0) bakedItem.containerKind = navItem.containerKind;
                    return bakedItem;
                }));
        }
        getFullNavigateToItems(args) {
            const { currentFileOnly, searchValue, maxResultCount, projectFileName } = args;
            if (currentFileOnly) {
                Debug.assertIsDefined(args.file);
                const { file, project } = this.getFileAndProject(args);
                return [
                    {
                        project,
                        navigateToItems: project.getLanguageService().getNavigateToItems(searchValue, maxResultCount, file)
                    }
                ];
            }
            const preferences = this.getHostPreferences();
            const outputs = [];
            const seenItems = /* @__PURE__ */ new Map();
            if (!args.file && !projectFileName) {
                this.projectService.loadAncestorProjectTree();
                this.projectService.forEachEnabledProject((project)=>addItemsForProject(project));
            } else {
                const projects = this.getProjects(args);
                forEachProjectInProjects(projects, /*path*/ void 0, (project)=>addItemsForProject(project));
            }
            return outputs;
            function addItemsForProject(project) {
                const projectItems = project.getLanguageService().getNavigateToItems(searchValue, maxResultCount, /*fileName*/ void 0, /*excludeDts*/ project.isNonTsProject(), /*excludeLibFiles*/ preferences.excludeLibrarySymbolsInNavTo);
                const unseenItems = filter(projectItems, (item)=>tryAddSeenItem(item) && !getMappedLocationForProject(documentSpanLocation(item), project));
                if (unseenItems.length) outputs.push({
                    project,
                    navigateToItems: unseenItems
                });
            }
            function tryAddSeenItem(item) {
                const name = item.name;
                if (!seenItems.has(name)) {
                    seenItems.set(name, [
                        item
                    ]);
                    return true;
                }
                const seen = seenItems.get(name);
                for (const seenItem of seen){
                    if (navigateToItemIsEqualTo(seenItem, item)) return false;
                }
                seen.push(item);
                return true;
            }
            function navigateToItemIsEqualTo(a, b) {
                if (a === b) return true;
                if (!a || !b) return false;
                return a.containerKind === b.containerKind && a.containerName === b.containerName && a.fileName === b.fileName && a.isCaseSensitive === b.isCaseSensitive && a.kind === b.kind && a.kindModifiers === b.kindModifiers && a.matchKind === b.matchKind && a.name === b.name && a.textSpan.start === b.textSpan.start && a.textSpan.length === b.textSpan.length;
            }
        }
        getSupportedCodeFixes(args) {
            if (!args) return getSupportedCodeFixes();
            if (args.file) {
                const { file, project: project2 } = this.getFileAndProject(args);
                return project2.getLanguageService().getSupportedCodeFixes(file);
            }
            const project = this.getProject(args.projectFileName);
            if (!project) Errors.ThrowNoProject();
            return project.getLanguageService().getSupportedCodeFixes();
        }
        isLocation(locationOrSpan) {
            return locationOrSpan.line !== void 0;
        }
        extractPositionOrRange(args, scriptInfo) {
            let position;
            let textRange;
            if (this.isLocation(args)) position = getPosition(args);
            else textRange = this.getRange(args, scriptInfo);
            return Debug.checkDefined(position === void 0 ? textRange : position);
            function getPosition(loc) {
                return loc.position !== void 0 ? loc.position : scriptInfo.lineOffsetToPosition(loc.line, loc.offset);
            }
        }
        getRange(args, scriptInfo) {
            const { startPosition, endPosition } = this.getStartAndEndPosition(args, scriptInfo);
            return {
                pos: startPosition,
                end: endPosition
            };
        }
        getApplicableRefactors(args) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = project.getScriptInfoForNormalizedPath(file);
            const result = project.getLanguageService().getApplicableRefactors(file, this.extractPositionOrRange(args, scriptInfo), this.getPreferences(file), args.triggerReason, args.kind, args.includeInteractiveActions);
            return result.map((result2)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, result2), {
                    actions: result2.actions.map((action)=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, action), {
                            range: action.range ? {
                                start: convertToLocation({
                                    line: action.range.start.line,
                                    character: action.range.start.offset
                                }),
                                end: convertToLocation({
                                    line: action.range.end.line,
                                    character: action.range.end.offset
                                })
                            } : void 0
                        }))
                }));
        }
        getEditsForRefactor(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = project.getScriptInfoForNormalizedPath(file);
            const result = project.getLanguageService().getEditsForRefactor(file, this.getFormatOptions(file), this.extractPositionOrRange(args, scriptInfo), args.refactor, args.action, this.getPreferences(file), args.interactiveRefactorArguments);
            if (result === void 0) return {
                edits: []
            };
            if (simplifiedResult) {
                const { renameFilename, renameLocation, edits } = result;
                let mappedRenameLocation;
                if (renameFilename !== void 0 && renameLocation !== void 0) {
                    const renameScriptInfo = project.getScriptInfoForNormalizedPath(toNormalizedPath(renameFilename));
                    mappedRenameLocation = getLocationInNewDocument(getSnapshotText(renameScriptInfo.getSnapshot()), renameFilename, renameLocation, edits);
                }
                return {
                    renameLocation: mappedRenameLocation,
                    renameFilename,
                    edits: this.mapTextChangesToCodeEdits(edits),
                    notApplicableReason: result.notApplicableReason
                };
            }
            return result;
        }
        getMoveToRefactoringFileSuggestions(args) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = project.getScriptInfoForNormalizedPath(file);
            return project.getLanguageService().getMoveToRefactoringFileSuggestions(file, this.extractPositionOrRange(args, scriptInfo), this.getPreferences(file));
        }
        preparePasteEdits(args) {
            const { file, project } = this.getFileAndProject(args);
            return project.getLanguageService().preparePasteEditsForFile(file, args.copiedTextSpan.map((copies)=>this.getRange({
                    file,
                    startLine: copies.start.line,
                    startOffset: copies.start.offset,
                    endLine: copies.end.line,
                    endOffset: copies.end.offset
                }, this.projectService.getScriptInfoForNormalizedPath(file))));
        }
        getPasteEdits(args) {
            const { file, project } = this.getFileAndProject(args);
            if (isDynamicFileName(file)) return void 0;
            const copiedFrom = args.copiedFrom ? {
                file: args.copiedFrom.file,
                range: args.copiedFrom.spans.map((copies)=>this.getRange({
                        file: args.copiedFrom.file,
                        startLine: copies.start.line,
                        startOffset: copies.start.offset,
                        endLine: copies.end.line,
                        endOffset: copies.end.offset
                    }, project.getScriptInfoForNormalizedPath(toNormalizedPath(args.copiedFrom.file))))
            } : void 0;
            const result = project.getLanguageService().getPasteEdits({
                targetFile: file,
                pastedText: args.pastedText,
                pasteLocations: args.pasteLocations.map((paste)=>this.getRange({
                        file,
                        startLine: paste.start.line,
                        startOffset: paste.start.offset,
                        endLine: paste.end.line,
                        endOffset: paste.end.offset
                    }, project.getScriptInfoForNormalizedPath(file))),
                copiedFrom,
                preferences: this.getPreferences(file)
            }, this.getFormatOptions(file));
            return result && this.mapPasteEditsAction(result);
        }
        organizeImports(args, simplifiedResult) {
            Debug.assert(args.scope.type === "file");
            const { file, project } = this.getFileAndProject(args.scope.args);
            var _args_mode;
            const changes = project.getLanguageService().organizeImports({
                fileName: file,
                mode: (_args_mode = args.mode) !== null && _args_mode !== void 0 ? _args_mode : args.skipDestructiveCodeActions ? "SortAndCombine" /* SortAndCombine */  : void 0,
                type: "file"
            }, this.getFormatOptions(file), this.getPreferences(file));
            if (simplifiedResult) return this.mapTextChangesToCodeEdits(changes);
            else return changes;
        }
        getEditsForFileRename(args, simplifiedResult) {
            const oldPath = toNormalizedPath(args.oldFilePath);
            const newPath = toNormalizedPath(args.newFilePath);
            const formatOptions = this.getHostFormatOptions();
            const preferences = this.getHostPreferences();
            const seenFiles = /* @__PURE__ */ new Set();
            const textChanges2 = [];
            this.projectService.loadAncestorProjectTree();
            this.projectService.forEachEnabledProject((project)=>{
                const projectTextChanges = project.getLanguageService().getEditsForFileRename(oldPath, newPath, formatOptions, preferences);
                const projectFiles = [];
                for (const textChange of projectTextChanges)if (!seenFiles.has(textChange.fileName)) {
                    textChanges2.push(textChange);
                    projectFiles.push(textChange.fileName);
                }
                for (const file of projectFiles)seenFiles.add(file);
            });
            return simplifiedResult ? textChanges2.map((c)=>this.mapTextChangeToCodeEdit(c)) : textChanges2;
        }
        getCodeFixes(args, simplifiedResult) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = project.getScriptInfoForNormalizedPath(file);
            const { startPosition, endPosition } = this.getStartAndEndPosition(args, scriptInfo);
            let codeActions;
            try {
                codeActions = project.getLanguageService().getCodeFixesAtPosition(file, startPosition, endPosition, args.errorCodes, this.getFormatOptions(file), this.getPreferences(file));
            } catch (e) {
                const error2 = e instanceof Error ? e : new Error(e);
                const ls = project.getLanguageService();
                const existingDiagCodes = [
                    ...ls.getSyntacticDiagnostics(file),
                    ...ls.getSemanticDiagnostics(file),
                    ...ls.getSuggestionDiagnostics(file)
                ].filter((d)=>decodedTextSpanIntersectsWith(startPosition, endPosition - startPosition, d.start, d.length)).map((d)=>d.code);
                const badCode = args.errorCodes.find((c)=>!existingDiagCodes.includes(c));
                if (badCode !== void 0) error2.message += `
Additional information: BADCLIENT: Bad error code, ${badCode} not found in range ${startPosition}..${endPosition} (found: ${existingDiagCodes.join(", ")})`;
                throw error2;
            }
            return simplifiedResult ? codeActions.map((codeAction)=>this.mapCodeFixAction(codeAction)) : codeActions;
        }
        getCombinedCodeFix({ scope, fixId: fixId56 }, simplifiedResult) {
            Debug.assert(scope.type === "file");
            const { file, project } = this.getFileAndProject(scope.args);
            const res = project.getLanguageService().getCombinedCodeFix({
                type: "file",
                fileName: file
            }, fixId56, this.getFormatOptions(file), this.getPreferences(file));
            if (simplifiedResult) return {
                changes: this.mapTextChangesToCodeEdits(res.changes),
                commands: res.commands
            };
            else return res;
        }
        applyCodeActionCommand(args) {
            const commands = args.command;
            for (const command of toArray(commands)){
                const { file, project } = this.getFileAndProject(command);
                project.getLanguageService().applyCodeActionCommand(command, this.getFormatOptions(file)).then((_result)=>{}, (_error)=>{});
            }
            return {};
        }
        getStartAndEndPosition(args, scriptInfo) {
            let startPosition, endPosition;
            if (args.startPosition !== void 0) startPosition = args.startPosition;
            else {
                startPosition = scriptInfo.lineOffsetToPosition(args.startLine, args.startOffset);
                args.startPosition = startPosition;
            }
            if (args.endPosition !== void 0) endPosition = args.endPosition;
            else {
                endPosition = scriptInfo.lineOffsetToPosition(args.endLine, args.endOffset);
                args.endPosition = endPosition;
            }
            return {
                startPosition,
                endPosition
            };
        }
        mapCodeAction({ description: description3, changes, commands }) {
            return {
                description: description3,
                changes: this.mapTextChangesToCodeEdits(changes),
                commands
            };
        }
        mapCodeFixAction({ fixName: fixName8, description: description3, changes, commands, fixId: fixId56, fixAllDescription }) {
            return {
                fixName: fixName8,
                description: description3,
                changes: this.mapTextChangesToCodeEdits(changes),
                commands,
                fixId: fixId56,
                fixAllDescription
            };
        }
        mapPasteEditsAction({ edits, fixId: fixId56 }) {
            return {
                edits: this.mapTextChangesToCodeEdits(edits),
                fixId: fixId56
            };
        }
        mapTextChangesToCodeEdits(textChanges2) {
            return textChanges2.map((change)=>this.mapTextChangeToCodeEdit(change));
        }
        mapTextChangeToCodeEdit(textChanges2) {
            const scriptInfo = this.projectService.getScriptInfoOrConfig(textChanges2.fileName);
            if (!!textChanges2.isNewFile === !!scriptInfo) {
                if (!scriptInfo) this.projectService.logErrorForScriptInfoNotFound(textChanges2.fileName);
                Debug.fail("Expected isNewFile for (only) new files. " + JSON.stringify({
                    isNewFile: !!textChanges2.isNewFile,
                    hasScriptInfo: !!scriptInfo
                }));
            }
            return scriptInfo ? {
                fileName: textChanges2.fileName,
                textChanges: textChanges2.textChanges.map((textChange)=>convertTextChangeToCodeEdit(textChange, scriptInfo))
            } : convertNewFileTextChangeToCodeEdit(textChanges2);
        }
        convertTextChangeToCodeEdit(change, scriptInfo) {
            return {
                start: scriptInfo.positionToLineOffset(change.span.start),
                end: scriptInfo.positionToLineOffset(change.span.start + change.span.length),
                newText: change.newText ? change.newText : ""
            };
        }
        getBraceMatching(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const position = this.getPosition(args, scriptInfo);
            const spans = languageService.getBraceMatchingAtPosition(file, position);
            return !spans ? void 0 : simplifiedResult ? spans.map((span)=>toProtocolTextSpan(span, scriptInfo)) : spans;
        }
        getDiagnosticsForProject(next, delay, fileName) {
            if (this.suppressDiagnosticEvents) return;
            const { fileNames, languageServiceDisabled } = this.getProjectInfoWorker(fileName, /*projectFileName*/ void 0, /*needFileNameList*/ true, /*needDefaultConfiguredProjectInfo*/ void 0, /*excludeConfigFiles*/ true);
            if (languageServiceDisabled) return;
            const fileNamesInProject = fileNames.filter((value1)=>!value1.includes("lib.d.ts"));
            if (fileNamesInProject.length === 0) return;
            const highPriorityFiles = [];
            const mediumPriorityFiles = [];
            const lowPriorityFiles = [];
            const veryLowPriorityFiles = [];
            const normalizedFileName = toNormalizedPath(fileName);
            const project = this.projectService.ensureDefaultProjectForFile(normalizedFileName);
            for (const fileNameInProject of fileNamesInProject)if (this.getCanonicalFileName(fileNameInProject) === this.getCanonicalFileName(fileName)) highPriorityFiles.push(fileNameInProject);
            else {
                const info = this.projectService.getScriptInfo(fileNameInProject);
                if (!info.isScriptOpen()) {
                    if (isDeclarationFileName(fileNameInProject)) veryLowPriorityFiles.push(fileNameInProject);
                    else lowPriorityFiles.push(fileNameInProject);
                } else mediumPriorityFiles.push(fileNameInProject);
            }
            const sortedFiles = [
                ...highPriorityFiles,
                ...mediumPriorityFiles,
                ...lowPriorityFiles,
                ...veryLowPriorityFiles
            ];
            const checkList = sortedFiles.map((fileName2)=>({
                    fileName: fileName2,
                    project
                }));
            this.updateErrorCheck(next, checkList, delay, /*requireOpen*/ false);
        }
        configurePlugin(args) {
            this.projectService.configurePlugin(args);
        }
        getSmartSelectionRange(args, simplifiedResult) {
            const { locations } = args;
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = Debug.checkDefined(this.projectService.getScriptInfo(file));
            return map(locations, (location)=>{
                const pos = this.getPosition(location, scriptInfo);
                const selectionRange = languageService.getSmartSelectionRange(file, pos);
                return simplifiedResult ? this.mapSelectionRange(selectionRange, scriptInfo) : selectionRange;
            });
        }
        toggleLineComment(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfo(file);
            const textRange = this.getRange(args, scriptInfo);
            const textChanges2 = languageService.toggleLineComment(file, textRange);
            if (simplifiedResult) {
                const scriptInfo2 = this.projectService.getScriptInfoForNormalizedPath(file);
                return textChanges2.map((textChange)=>this.convertTextChangeToCodeEdit(textChange, scriptInfo2));
            }
            return textChanges2;
        }
        toggleMultilineComment(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const textRange = this.getRange(args, scriptInfo);
            const textChanges2 = languageService.toggleMultilineComment(file, textRange);
            if (simplifiedResult) {
                const scriptInfo2 = this.projectService.getScriptInfoForNormalizedPath(file);
                return textChanges2.map((textChange)=>this.convertTextChangeToCodeEdit(textChange, scriptInfo2));
            }
            return textChanges2;
        }
        commentSelection(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const textRange = this.getRange(args, scriptInfo);
            const textChanges2 = languageService.commentSelection(file, textRange);
            if (simplifiedResult) {
                const scriptInfo2 = this.projectService.getScriptInfoForNormalizedPath(file);
                return textChanges2.map((textChange)=>this.convertTextChangeToCodeEdit(textChange, scriptInfo2));
            }
            return textChanges2;
        }
        uncommentSelection(args, simplifiedResult) {
            const { file, languageService } = this.getFileAndLanguageServiceForSyntacticOperation(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            const textRange = this.getRange(args, scriptInfo);
            const textChanges2 = languageService.uncommentSelection(file, textRange);
            if (simplifiedResult) {
                const scriptInfo2 = this.projectService.getScriptInfoForNormalizedPath(file);
                return textChanges2.map((textChange)=>this.convertTextChangeToCodeEdit(textChange, scriptInfo2));
            }
            return textChanges2;
        }
        mapSelectionRange(selectionRange, scriptInfo) {
            const result = {
                textSpan: toProtocolTextSpan(selectionRange.textSpan, scriptInfo)
            };
            if (selectionRange.parent) result.parent = this.mapSelectionRange(selectionRange.parent, scriptInfo);
            return result;
        }
        getScriptInfoFromProjectService(file) {
            const normalizedFile = toNormalizedPath(file);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(normalizedFile);
            if (!scriptInfo) {
                this.projectService.logErrorForScriptInfoNotFound(normalizedFile);
                return Errors.ThrowNoProject();
            }
            return scriptInfo;
        }
        toProtocolCallHierarchyItem(item) {
            const scriptInfo = this.getScriptInfoFromProjectService(item.file);
            return {
                name: item.name,
                kind: item.kind,
                kindModifiers: item.kindModifiers,
                file: item.file,
                containerName: item.containerName,
                span: toProtocolTextSpan(item.span, scriptInfo),
                selectionSpan: toProtocolTextSpan(item.selectionSpan, scriptInfo)
            };
        }
        toProtocolCallHierarchyIncomingCall(incomingCall) {
            const scriptInfo = this.getScriptInfoFromProjectService(incomingCall.from.file);
            return {
                from: this.toProtocolCallHierarchyItem(incomingCall.from),
                fromSpans: incomingCall.fromSpans.map((fromSpan)=>toProtocolTextSpan(fromSpan, scriptInfo))
            };
        }
        toProtocolCallHierarchyOutgoingCall(outgoingCall, scriptInfo) {
            return {
                to: this.toProtocolCallHierarchyItem(outgoingCall.to),
                fromSpans: outgoingCall.fromSpans.map((fromSpan)=>toProtocolTextSpan(fromSpan, scriptInfo))
            };
        }
        prepareCallHierarchy(args) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.projectService.getScriptInfoForNormalizedPath(file);
            if (scriptInfo) {
                const position = this.getPosition(args, scriptInfo);
                const result = project.getLanguageService().prepareCallHierarchy(file, position);
                return result && mapOneOrMany(result, (item)=>this.toProtocolCallHierarchyItem(item));
            }
            return void 0;
        }
        provideCallHierarchyIncomingCalls(args) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.getScriptInfoFromProjectService(file);
            const incomingCalls = project.getLanguageService().provideCallHierarchyIncomingCalls(file, this.getPosition(args, scriptInfo));
            return incomingCalls.map((call)=>this.toProtocolCallHierarchyIncomingCall(call));
        }
        provideCallHierarchyOutgoingCalls(args) {
            const { file, project } = this.getFileAndProject(args);
            const scriptInfo = this.getScriptInfoFromProjectService(file);
            const outgoingCalls = project.getLanguageService().provideCallHierarchyOutgoingCalls(file, this.getPosition(args, scriptInfo));
            return outgoingCalls.map((call)=>this.toProtocolCallHierarchyOutgoingCall(call, scriptInfo));
        }
        getCanonicalFileName(fileName) {
            const name = this.host.useCaseSensitiveFileNames ? fileName : toFileNameLowerCase(fileName);
            return normalizePath(name);
        }
        exit() {}
        notRequired(request) {
            if (request) this.doOutput(/*info*/ void 0, request.command, request.seq, /*success*/ true, this.performanceData);
            return {
                responseRequired: false,
                performanceData: this.performanceData
            };
        }
        requiredResponse(response) {
            return {
                response,
                responseRequired: true,
                performanceData: this.performanceData
            };
        }
        addProtocolHandler(command, handler) {
            if (this.handlers.has(command)) throw new Error(`Protocol handler already exists for command "${command}"`);
            this.handlers.set(command, handler);
        }
        setCurrentRequest(requestId) {
            Debug.assert(this.currentRequestId === void 0);
            this.currentRequestId = requestId;
            this.cancellationToken.setRequest(requestId);
        }
        resetCurrentRequest(requestId) {
            Debug.assert(this.currentRequestId === requestId);
            this.currentRequestId = void 0;
            this.cancellationToken.resetRequest(requestId);
        }
        // eslint-disable-line @typescript-eslint/unified-signatures
        executeWithRequestId(requestId, f, perfomanceData) {
            const currentPerformanceData = this.performanceData;
            try {
                this.performanceData = perfomanceData;
                this.setCurrentRequest(requestId);
                return f();
            } finally{
                this.resetCurrentRequest(requestId);
                this.performanceData = currentPerformanceData;
            }
        }
        executeCommand(request) {
            const handler = this.handlers.get(request.command);
            if (handler) {
                const response = this.executeWithRequestId(request.seq, ()=>handler(request), /*perfomanceData*/ void 0);
                this.projectService.enableRequestedPlugins();
                return response;
            } else {
                this.logger.msg(`Unrecognized JSON command:${stringifyIndented(request)}`, "Err" /* Err */ );
                this.doOutput(/*info*/ void 0, "unknown" /* Unknown */ , request.seq, /*success*/ false, /*performanceData*/ void 0, `Unrecognized JSON command: ${request.command}`);
                return {
                    responseRequired: false
                };
            }
        }
        onMessage(message) {
            var _a, _b, _c, _d, _e, _f, _g;
            this.gcTimer.scheduleCollect();
            let start;
            const currentPerformanceData = this.performanceData;
            if (this.logger.hasLevel(2 /* requestTime */ )) {
                start = this.hrtime();
                if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`request:${indent2(this.toStringMessage(message))}`);
            }
            let request;
            let relevantFile;
            try {
                request = this.parseMessage(message);
                relevantFile = request.arguments && request.arguments.file ? request.arguments : void 0;
                (_a = tracing) == null || _a.instant(tracing.Phase.Session, "request", {
                    seq: request.seq,
                    command: request.command
                });
                (_b = tracing) == null || _b.push(tracing.Phase.Session, "executeCommand", {
                    seq: request.seq,
                    command: request.command
                }, /*separateBeginAndEnd*/ true);
                const { response, responseRequired, performanceData } = this.executeCommand(request);
                (_c = tracing) == null || _c.pop();
                if (this.logger.hasLevel(2 /* requestTime */ )) {
                    const elapsedTime = hrTimeToMilliseconds(this.hrtime(start)).toFixed(4);
                    if (responseRequired) this.logger.perftrc(`${request.seq}::${request.command}: elapsed time (in milliseconds) ${elapsedTime}`);
                    else this.logger.perftrc(`${request.seq}::${request.command}: async elapsed time (in milliseconds) ${elapsedTime}`);
                }
                (_d = tracing) == null || _d.instant(tracing.Phase.Session, "response", {
                    seq: request.seq,
                    command: request.command,
                    success: !!response
                });
                if (response) this.doOutput(response, request.command, request.seq, /*success*/ true, performanceData);
                else if (responseRequired) this.doOutput(/*info*/ void 0, request.command, request.seq, /*success*/ false, performanceData, "No content available.");
            } catch (err) {
                (_e = tracing) == null || _e.popAll();
                if (err instanceof OperationCanceledException) {
                    (_f = tracing) == null || _f.instant(tracing.Phase.Session, "commandCanceled", {
                        seq: request == null ? void 0 : request.seq,
                        command: request == null ? void 0 : request.command
                    });
                    this.doOutput({
                        canceled: true
                    }, request.command, request.seq, /*success*/ true, this.performanceData);
                    return;
                }
                this.logErrorWorker(err, this.toStringMessage(message), relevantFile);
                (_g = tracing) == null || _g.instant(tracing.Phase.Session, "commandError", {
                    seq: request == null ? void 0 : request.seq,
                    command: request == null ? void 0 : request.command,
                    message: err.message
                });
                this.doOutput(/*info*/ void 0, request ? request.command : "unknown" /* Unknown */ , request ? request.seq : 0, /*success*/ false, this.performanceData, "Error processing request. " + err.message + "\n" + err.stack);
            } finally{
                this.performanceData = currentPerformanceData;
            }
        }
        parseMessage(message) {
            return JSON.parse(message);
        }
        toStringMessage(message) {
            return message;
        }
        getFormatOptions(file) {
            return this.projectService.getFormatCodeOptions(file);
        }
        getPreferences(file) {
            return this.projectService.getPreferences(file);
        }
        getHostFormatOptions() {
            return this.projectService.getHostFormatCodeOptions();
        }
        getHostPreferences() {
            return this.projectService.getHostPreferences();
        }
        constructor(opts){
            this.changeSeq = 0;
            // Minimum number of lines for attempting to use region diagnostics for a file.
            /** @internal */ this.regionDiagLineCountThreshold = 500;
            this.handlers = new Map(Object.entries({
                // TODO(jakebailey): correctly type the handlers
                ["status" /* Status */ ]: ()=>{
                    const response = {
                        version
                    };
                    return this.requiredResponse(response);
                },
                ["openExternalProject" /* OpenExternalProject */ ]: (request)=>{
                    this.projectService.openExternalProject(request.arguments, /*cleanupAfter*/ true);
                    return this.requiredResponse(/*response*/ true);
                },
                ["openExternalProjects" /* OpenExternalProjects */ ]: (request)=>{
                    this.projectService.openExternalProjects(request.arguments.projects);
                    return this.requiredResponse(/*response*/ true);
                },
                ["closeExternalProject" /* CloseExternalProject */ ]: (request)=>{
                    this.projectService.closeExternalProject(request.arguments.projectFileName, /*cleanupAfter*/ true);
                    return this.requiredResponse(/*response*/ true);
                },
                ["synchronizeProjectList" /* SynchronizeProjectList */ ]: (request)=>{
                    const result = this.projectService.synchronizeProjectList(request.arguments.knownProjects, request.arguments.includeProjectReferenceRedirectInfo);
                    if (!result.some((p)=>p.projectErrors && p.projectErrors.length !== 0)) return this.requiredResponse(result);
                    const converted = map(result, (p)=>{
                        if (!p.projectErrors || p.projectErrors.length === 0) return p;
                        return {
                            info: p.info,
                            changes: p.changes,
                            files: p.files,
                            projectErrors: this.convertToDiagnosticsWithLinePosition(p.projectErrors, /*scriptInfo*/ void 0)
                        };
                    });
                    return this.requiredResponse(converted);
                },
                ["updateOpen" /* UpdateOpen */ ]: (request)=>{
                    this.changeSeq++;
                    this.projectService.applyChangesInOpenFiles(request.arguments.openFiles && mapIterator(request.arguments.openFiles, (file)=>({
                            fileName: file.file,
                            content: file.fileContent,
                            scriptKind: file.scriptKindName,
                            projectRootPath: file.projectRootPath
                        })), request.arguments.changedFiles && mapIterator(request.arguments.changedFiles, (file)=>({
                            fileName: file.fileName,
                            changes: mapDefinedIterator(arrayReverseIterator(file.textChanges), (change)=>{
                                const scriptInfo = Debug.checkDefined(this.projectService.getScriptInfo(file.fileName));
                                const start = scriptInfo.lineOffsetToPosition(change.start.line, change.start.offset);
                                const end = scriptInfo.lineOffsetToPosition(change.end.line, change.end.offset);
                                return start >= 0 ? {
                                    span: {
                                        start,
                                        length: end - start
                                    },
                                    newText: change.newText
                                } : void 0;
                            })
                        })), request.arguments.closedFiles);
                    return this.requiredResponse(/*response*/ true);
                },
                ["applyChangedToOpenFiles" /* ApplyChangedToOpenFiles */ ]: (request)=>{
                    this.changeSeq++;
                    this.projectService.applyChangesInOpenFiles(request.arguments.openFiles, request.arguments.changedFiles && mapIterator(request.arguments.changedFiles, (file)=>({
                            fileName: file.fileName,
                            // apply changes in reverse order
                            changes: arrayReverseIterator(file.changes)
                        })), request.arguments.closedFiles);
                    return this.requiredResponse(/*response*/ true);
                },
                ["exit" /* Exit */ ]: ()=>{
                    this.exit();
                    return this.notRequired(/*request*/ void 0);
                },
                ["definition" /* Definition */ ]: (request)=>{
                    return this.requiredResponse(this.getDefinition(request.arguments, /*simplifiedResult*/ true));
                },
                ["definition-full" /* DefinitionFull */ ]: (request)=>{
                    return this.requiredResponse(this.getDefinition(request.arguments, /*simplifiedResult*/ false));
                },
                ["definitionAndBoundSpan" /* DefinitionAndBoundSpan */ ]: (request)=>{
                    return this.requiredResponse(this.getDefinitionAndBoundSpan(request.arguments, /*simplifiedResult*/ true));
                },
                ["definitionAndBoundSpan-full" /* DefinitionAndBoundSpanFull */ ]: (request)=>{
                    return this.requiredResponse(this.getDefinitionAndBoundSpan(request.arguments, /*simplifiedResult*/ false));
                },
                ["findSourceDefinition" /* FindSourceDefinition */ ]: (request)=>{
                    return this.requiredResponse(this.findSourceDefinition(request.arguments));
                },
                ["emit-output" /* EmitOutput */ ]: (request)=>{
                    return this.requiredResponse(this.getEmitOutput(request.arguments));
                },
                ["typeDefinition" /* TypeDefinition */ ]: (request)=>{
                    return this.requiredResponse(this.getTypeDefinition(request.arguments));
                },
                ["implementation" /* Implementation */ ]: (request)=>{
                    return this.requiredResponse(this.getImplementation(request.arguments, /*simplifiedResult*/ true));
                },
                ["implementation-full" /* ImplementationFull */ ]: (request)=>{
                    return this.requiredResponse(this.getImplementation(request.arguments, /*simplifiedResult*/ false));
                },
                ["references" /* References */ ]: (request)=>{
                    return this.requiredResponse(this.getReferences(request.arguments, /*simplifiedResult*/ true));
                },
                ["references-full" /* ReferencesFull */ ]: (request)=>{
                    return this.requiredResponse(this.getReferences(request.arguments, /*simplifiedResult*/ false));
                },
                ["rename" /* Rename */ ]: (request)=>{
                    return this.requiredResponse(this.getRenameLocations(request.arguments, /*simplifiedResult*/ true));
                },
                ["renameLocations-full" /* RenameLocationsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getRenameLocations(request.arguments, /*simplifiedResult*/ false));
                },
                ["rename-full" /* RenameInfoFull */ ]: (request)=>{
                    return this.requiredResponse(this.getRenameInfo(request.arguments));
                },
                ["open" /* Open */ ]: (request)=>{
                    this.openClientFile(toNormalizedPath(request.arguments.file), request.arguments.fileContent, convertScriptKindName(request.arguments.scriptKindName), // TODO: GH#18217
                    request.arguments.projectRootPath ? toNormalizedPath(request.arguments.projectRootPath) : void 0);
                    return this.notRequired(request);
                },
                ["quickinfo" /* Quickinfo */ ]: (request)=>{
                    return this.requiredResponse(this.getQuickInfoWorker(request.arguments, /*simplifiedResult*/ true));
                },
                ["quickinfo-full" /* QuickinfoFull */ ]: (request)=>{
                    return this.requiredResponse(this.getQuickInfoWorker(request.arguments, /*simplifiedResult*/ false));
                },
                ["getOutliningSpans" /* GetOutliningSpans */ ]: (request)=>{
                    return this.requiredResponse(this.getOutliningSpans(request.arguments, /*simplifiedResult*/ true));
                },
                ["outliningSpans" /* GetOutliningSpansFull */ ]: (request)=>{
                    return this.requiredResponse(this.getOutliningSpans(request.arguments, /*simplifiedResult*/ false));
                },
                ["todoComments" /* TodoComments */ ]: (request)=>{
                    return this.requiredResponse(this.getTodoComments(request.arguments));
                },
                ["indentation" /* Indentation */ ]: (request)=>{
                    return this.requiredResponse(this.getIndentation(request.arguments));
                },
                ["nameOrDottedNameSpan" /* NameOrDottedNameSpan */ ]: (request)=>{
                    return this.requiredResponse(this.getNameOrDottedNameSpan(request.arguments));
                },
                ["breakpointStatement" /* BreakpointStatement */ ]: (request)=>{
                    return this.requiredResponse(this.getBreakpointStatement(request.arguments));
                },
                ["braceCompletion" /* BraceCompletion */ ]: (request)=>{
                    return this.requiredResponse(this.isValidBraceCompletion(request.arguments));
                },
                ["docCommentTemplate" /* DocCommentTemplate */ ]: (request)=>{
                    return this.requiredResponse(this.getDocCommentTemplate(request.arguments));
                },
                ["getSpanOfEnclosingComment" /* GetSpanOfEnclosingComment */ ]: (request)=>{
                    return this.requiredResponse(this.getSpanOfEnclosingComment(request.arguments));
                },
                ["fileReferences" /* FileReferences */ ]: (request)=>{
                    return this.requiredResponse(this.getFileReferences(request.arguments, /*simplifiedResult*/ true));
                },
                ["fileReferences-full" /* FileReferencesFull */ ]: (request)=>{
                    return this.requiredResponse(this.getFileReferences(request.arguments, /*simplifiedResult*/ false));
                },
                ["format" /* Format */ ]: (request)=>{
                    return this.requiredResponse(this.getFormattingEditsForRange(request.arguments));
                },
                ["formatonkey" /* Formatonkey */ ]: (request)=>{
                    return this.requiredResponse(this.getFormattingEditsAfterKeystroke(request.arguments));
                },
                ["format-full" /* FormatFull */ ]: (request)=>{
                    return this.requiredResponse(this.getFormattingEditsForDocumentFull(request.arguments));
                },
                ["formatonkey-full" /* FormatonkeyFull */ ]: (request)=>{
                    return this.requiredResponse(this.getFormattingEditsAfterKeystrokeFull(request.arguments));
                },
                ["formatRange-full" /* FormatRangeFull */ ]: (request)=>{
                    return this.requiredResponse(this.getFormattingEditsForRangeFull(request.arguments));
                },
                ["completionInfo" /* CompletionInfo */ ]: (request)=>{
                    return this.requiredResponse(this.getCompletions(request.arguments, "completionInfo" /* CompletionInfo */ ));
                },
                ["completions" /* Completions */ ]: (request)=>{
                    return this.requiredResponse(this.getCompletions(request.arguments, "completions" /* Completions */ ));
                },
                ["completions-full" /* CompletionsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getCompletions(request.arguments, "completions-full" /* CompletionsFull */ ));
                },
                ["completionEntryDetails" /* CompletionDetails */ ]: (request)=>{
                    return this.requiredResponse(this.getCompletionEntryDetails(request.arguments, /*fullResult*/ false));
                },
                ["completionEntryDetails-full" /* CompletionDetailsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getCompletionEntryDetails(request.arguments, /*fullResult*/ true));
                },
                ["compileOnSaveAffectedFileList" /* CompileOnSaveAffectedFileList */ ]: (request)=>{
                    return this.requiredResponse(this.getCompileOnSaveAffectedFileList(request.arguments));
                },
                ["compileOnSaveEmitFile" /* CompileOnSaveEmitFile */ ]: (request)=>{
                    return this.requiredResponse(this.emitFile(request.arguments));
                },
                ["signatureHelp" /* SignatureHelp */ ]: (request)=>{
                    return this.requiredResponse(this.getSignatureHelpItems(request.arguments, /*simplifiedResult*/ true));
                },
                ["signatureHelp-full" /* SignatureHelpFull */ ]: (request)=>{
                    return this.requiredResponse(this.getSignatureHelpItems(request.arguments, /*simplifiedResult*/ false));
                },
                ["compilerOptionsDiagnostics-full" /* CompilerOptionsDiagnosticsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getCompilerOptionsDiagnostics(request.arguments));
                },
                ["encodedSyntacticClassifications-full" /* EncodedSyntacticClassificationsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getEncodedSyntacticClassifications(request.arguments));
                },
                ["encodedSemanticClassifications-full" /* EncodedSemanticClassificationsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getEncodedSemanticClassifications(request.arguments));
                },
                ["cleanup" /* Cleanup */ ]: ()=>{
                    this.cleanup();
                    return this.requiredResponse(/*response*/ true);
                },
                ["semanticDiagnosticsSync" /* SemanticDiagnosticsSync */ ]: (request)=>{
                    return this.requiredResponse(this.getSemanticDiagnosticsSync(request.arguments));
                },
                ["syntacticDiagnosticsSync" /* SyntacticDiagnosticsSync */ ]: (request)=>{
                    return this.requiredResponse(this.getSyntacticDiagnosticsSync(request.arguments));
                },
                ["suggestionDiagnosticsSync" /* SuggestionDiagnosticsSync */ ]: (request)=>{
                    return this.requiredResponse(this.getSuggestionDiagnosticsSync(request.arguments));
                },
                ["geterr" /* Geterr */ ]: (request)=>{
                    this.errorCheck.startNew((next)=>this.getDiagnostics(next, request.arguments.delay, request.arguments.files));
                    return this.notRequired(/*request*/ void 0);
                },
                ["geterrForProject" /* GeterrForProject */ ]: (request)=>{
                    this.errorCheck.startNew((next)=>this.getDiagnosticsForProject(next, request.arguments.delay, request.arguments.file));
                    return this.notRequired(/*request*/ void 0);
                },
                ["change" /* Change */ ]: (request)=>{
                    this.change(request.arguments);
                    return this.notRequired(request);
                },
                ["configure" /* Configure */ ]: (request)=>{
                    this.projectService.setHostConfiguration(request.arguments);
                    return this.notRequired(request);
                },
                ["reload" /* Reload */ ]: (request)=>{
                    this.reload(request.arguments);
                    return this.requiredResponse({
                        reloadFinished: true
                    });
                },
                ["saveto" /* Saveto */ ]: (request)=>{
                    const savetoArgs = request.arguments;
                    this.saveToTmp(savetoArgs.file, savetoArgs.tmpfile);
                    return this.notRequired(request);
                },
                ["close" /* Close */ ]: (request)=>{
                    const closeArgs = request.arguments;
                    this.closeClientFile(closeArgs.file);
                    return this.notRequired(request);
                },
                ["navto" /* Navto */ ]: (request)=>{
                    return this.requiredResponse(this.getNavigateToItems(request.arguments, /*simplifiedResult*/ true));
                },
                ["navto-full" /* NavtoFull */ ]: (request)=>{
                    return this.requiredResponse(this.getNavigateToItems(request.arguments, /*simplifiedResult*/ false));
                },
                ["brace" /* Brace */ ]: (request)=>{
                    return this.requiredResponse(this.getBraceMatching(request.arguments, /*simplifiedResult*/ true));
                },
                ["brace-full" /* BraceFull */ ]: (request)=>{
                    return this.requiredResponse(this.getBraceMatching(request.arguments, /*simplifiedResult*/ false));
                },
                ["navbar" /* NavBar */ ]: (request)=>{
                    return this.requiredResponse(this.getNavigationBarItems(request.arguments, /*simplifiedResult*/ true));
                },
                ["navbar-full" /* NavBarFull */ ]: (request)=>{
                    return this.requiredResponse(this.getNavigationBarItems(request.arguments, /*simplifiedResult*/ false));
                },
                ["navtree" /* NavTree */ ]: (request)=>{
                    return this.requiredResponse(this.getNavigationTree(request.arguments, /*simplifiedResult*/ true));
                },
                ["navtree-full" /* NavTreeFull */ ]: (request)=>{
                    return this.requiredResponse(this.getNavigationTree(request.arguments, /*simplifiedResult*/ false));
                },
                ["documentHighlights" /* DocumentHighlights */ ]: (request)=>{
                    return this.requiredResponse(this.getDocumentHighlights(request.arguments, /*simplifiedResult*/ true));
                },
                ["documentHighlights-full" /* DocumentHighlightsFull */ ]: (request)=>{
                    return this.requiredResponse(this.getDocumentHighlights(request.arguments, /*simplifiedResult*/ false));
                },
                ["compilerOptionsForInferredProjects" /* CompilerOptionsForInferredProjects */ ]: (request)=>{
                    this.setCompilerOptionsForInferredProjects(request.arguments);
                    return this.requiredResponse(/*response*/ true);
                },
                ["projectInfo" /* ProjectInfo */ ]: (request)=>{
                    return this.requiredResponse(this.getProjectInfo(request.arguments));
                },
                ["reloadProjects" /* ReloadProjects */ ]: (request)=>{
                    this.projectService.reloadProjects();
                    return this.notRequired(request);
                },
                ["jsxClosingTag" /* JsxClosingTag */ ]: (request)=>{
                    return this.requiredResponse(this.getJsxClosingTag(request.arguments));
                },
                ["linkedEditingRange" /* LinkedEditingRange */ ]: (request)=>{
                    return this.requiredResponse(this.getLinkedEditingRange(request.arguments));
                },
                ["getCodeFixes" /* GetCodeFixes */ ]: (request)=>{
                    return this.requiredResponse(this.getCodeFixes(request.arguments, /*simplifiedResult*/ true));
                },
                ["getCodeFixes-full" /* GetCodeFixesFull */ ]: (request)=>{
                    return this.requiredResponse(this.getCodeFixes(request.arguments, /*simplifiedResult*/ false));
                },
                ["getCombinedCodeFix" /* GetCombinedCodeFix */ ]: (request)=>{
                    return this.requiredResponse(this.getCombinedCodeFix(request.arguments, /*simplifiedResult*/ true));
                },
                ["getCombinedCodeFix-full" /* GetCombinedCodeFixFull */ ]: (request)=>{
                    return this.requiredResponse(this.getCombinedCodeFix(request.arguments, /*simplifiedResult*/ false));
                },
                ["applyCodeActionCommand" /* ApplyCodeActionCommand */ ]: (request)=>{
                    return this.requiredResponse(this.applyCodeActionCommand(request.arguments));
                },
                ["getSupportedCodeFixes" /* GetSupportedCodeFixes */ ]: (request)=>{
                    return this.requiredResponse(this.getSupportedCodeFixes(request.arguments));
                },
                ["getApplicableRefactors" /* GetApplicableRefactors */ ]: (request)=>{
                    return this.requiredResponse(this.getApplicableRefactors(request.arguments));
                },
                ["getEditsForRefactor" /* GetEditsForRefactor */ ]: (request)=>{
                    return this.requiredResponse(this.getEditsForRefactor(request.arguments, /*simplifiedResult*/ true));
                },
                ["getMoveToRefactoringFileSuggestions" /* GetMoveToRefactoringFileSuggestions */ ]: (request)=>{
                    return this.requiredResponse(this.getMoveToRefactoringFileSuggestions(request.arguments));
                },
                ["preparePasteEdits" /* PreparePasteEdits */ ]: (request)=>{
                    return this.requiredResponse(this.preparePasteEdits(request.arguments));
                },
                ["getPasteEdits" /* GetPasteEdits */ ]: (request)=>{
                    return this.requiredResponse(this.getPasteEdits(request.arguments));
                },
                ["getEditsForRefactor-full" /* GetEditsForRefactorFull */ ]: (request)=>{
                    return this.requiredResponse(this.getEditsForRefactor(request.arguments, /*simplifiedResult*/ false));
                },
                ["organizeImports" /* OrganizeImports */ ]: (request)=>{
                    return this.requiredResponse(this.organizeImports(request.arguments, /*simplifiedResult*/ true));
                },
                ["organizeImports-full" /* OrganizeImportsFull */ ]: (request)=>{
                    return this.requiredResponse(this.organizeImports(request.arguments, /*simplifiedResult*/ false));
                },
                ["getEditsForFileRename" /* GetEditsForFileRename */ ]: (request)=>{
                    return this.requiredResponse(this.getEditsForFileRename(request.arguments, /*simplifiedResult*/ true));
                },
                ["getEditsForFileRename-full" /* GetEditsForFileRenameFull */ ]: (request)=>{
                    return this.requiredResponse(this.getEditsForFileRename(request.arguments, /*simplifiedResult*/ false));
                },
                ["configurePlugin" /* ConfigurePlugin */ ]: (request)=>{
                    this.configurePlugin(request.arguments);
                    return this.notRequired(request);
                },
                ["selectionRange" /* SelectionRange */ ]: (request)=>{
                    return this.requiredResponse(this.getSmartSelectionRange(request.arguments, /*simplifiedResult*/ true));
                },
                ["selectionRange-full" /* SelectionRangeFull */ ]: (request)=>{
                    return this.requiredResponse(this.getSmartSelectionRange(request.arguments, /*simplifiedResult*/ false));
                },
                ["prepareCallHierarchy" /* PrepareCallHierarchy */ ]: (request)=>{
                    return this.requiredResponse(this.prepareCallHierarchy(request.arguments));
                },
                ["provideCallHierarchyIncomingCalls" /* ProvideCallHierarchyIncomingCalls */ ]: (request)=>{
                    return this.requiredResponse(this.provideCallHierarchyIncomingCalls(request.arguments));
                },
                ["provideCallHierarchyOutgoingCalls" /* ProvideCallHierarchyOutgoingCalls */ ]: (request)=>{
                    return this.requiredResponse(this.provideCallHierarchyOutgoingCalls(request.arguments));
                },
                ["toggleLineComment" /* ToggleLineComment */ ]: (request)=>{
                    return this.requiredResponse(this.toggleLineComment(request.arguments, /*simplifiedResult*/ true));
                },
                ["toggleLineComment-full" /* ToggleLineCommentFull */ ]: (request)=>{
                    return this.requiredResponse(this.toggleLineComment(request.arguments, /*simplifiedResult*/ false));
                },
                ["toggleMultilineComment" /* ToggleMultilineComment */ ]: (request)=>{
                    return this.requiredResponse(this.toggleMultilineComment(request.arguments, /*simplifiedResult*/ true));
                },
                ["toggleMultilineComment-full" /* ToggleMultilineCommentFull */ ]: (request)=>{
                    return this.requiredResponse(this.toggleMultilineComment(request.arguments, /*simplifiedResult*/ false));
                },
                ["commentSelection" /* CommentSelection */ ]: (request)=>{
                    return this.requiredResponse(this.commentSelection(request.arguments, /*simplifiedResult*/ true));
                },
                ["commentSelection-full" /* CommentSelectionFull */ ]: (request)=>{
                    return this.requiredResponse(this.commentSelection(request.arguments, /*simplifiedResult*/ false));
                },
                ["uncommentSelection" /* UncommentSelection */ ]: (request)=>{
                    return this.requiredResponse(this.uncommentSelection(request.arguments, /*simplifiedResult*/ true));
                },
                ["uncommentSelection-full" /* UncommentSelectionFull */ ]: (request)=>{
                    return this.requiredResponse(this.uncommentSelection(request.arguments, /*simplifiedResult*/ false));
                },
                ["provideInlayHints" /* ProvideInlayHints */ ]: (request)=>{
                    return this.requiredResponse(this.provideInlayHints(request.arguments));
                },
                ["mapCode" /* MapCode */ ]: (request)=>{
                    return this.requiredResponse(this.mapCode(request.arguments));
                },
                ["copilotRelated" /* CopilotRelated */ ]: ()=>{
                    return this.requiredResponse(this.getCopilotRelatedInfo());
                }
            }));
            this.host = opts.host;
            this.cancellationToken = opts.cancellationToken;
            this.typingsInstaller = opts.typingsInstaller || nullTypingsInstaller;
            this.byteLength = opts.byteLength;
            this.hrtime = opts.hrtime;
            this.logger = opts.logger;
            this.canUseEvents = opts.canUseEvents;
            this.suppressDiagnosticEvents = opts.suppressDiagnosticEvents;
            this.noGetErrOnBackgroundUpdate = opts.noGetErrOnBackgroundUpdate;
            const { throttleWaitMilliseconds } = opts;
            this.eventHandler = this.canUseEvents ? opts.eventHandler || ((event)=>this.defaultEventHandler(event)) : void 0;
            const multistepOperationHost = {
                executeWithRequestId: (requestId, action, performanceData)=>this.executeWithRequestId(requestId, action, performanceData),
                getCurrentRequestId: ()=>this.currentRequestId,
                getPerformanceData: ()=>this.performanceData,
                getServerHost: ()=>this.host,
                logError: (err, cmd)=>this.logError(err, cmd),
                sendRequestCompletedEvent: (requestId, performanceData)=>this.sendRequestCompletedEvent(requestId, performanceData),
                isCancellationRequested: ()=>this.cancellationToken.isCancellationRequested()
            };
            this.errorCheck = new MultistepOperation(multistepOperationHost);
            const settings = {
                host: this.host,
                logger: this.logger,
                cancellationToken: this.cancellationToken,
                useSingleInferredProject: opts.useSingleInferredProject,
                useInferredProjectPerProjectRoot: opts.useInferredProjectPerProjectRoot,
                typingsInstaller: this.typingsInstaller,
                throttleWaitMilliseconds,
                eventHandler: this.eventHandler,
                suppressDiagnosticEvents: this.suppressDiagnosticEvents,
                globalPlugins: opts.globalPlugins,
                pluginProbeLocations: opts.pluginProbeLocations,
                allowLocalPluginLoads: opts.allowLocalPluginLoads,
                typesMapLocation: opts.typesMapLocation,
                serverMode: opts.serverMode,
                session: this,
                canUseWatchEvents: opts.canUseWatchEvents,
                incrementalVerifier: opts.incrementalVerifier
            };
            this.projectService = new ProjectService2(settings);
            this.projectService.setPerformanceEventHandler(this.performanceEventHandler.bind(this));
            this.gcTimer = new GcTimer(this.host, /*delay*/ 7e3, this.logger);
            switch(this.projectService.serverMode){
                case 0 /* Semantic */ :
                    break;
                case 1 /* PartialSemantic */ :
                    invalidPartialSemanticModeCommands.forEach((commandName)=>this.handlers.set(commandName, (request)=>{
                            throw new Error(`Request: ${request.command} not allowed in LanguageServiceMode.PartialSemantic`);
                        }));
                    break;
                case 2 /* Syntactic */ :
                    invalidSyntacticModeCommands.forEach((commandName)=>this.handlers.set(commandName, (request)=>{
                            throw new Error(`Request: ${request.command} not allowed in LanguageServiceMode.Syntactic`);
                        }));
                    break;
                default:
                    Debug.assertNever(this.projectService.serverMode);
            }
        }
    };
    function toProtocolPerformanceData(performanceData) {
        const diagnosticsDuration = performanceData.diagnosticsDuration && arrayFrom(performanceData.diagnosticsDuration, ([file, data])=>(0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
                file
            }));
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, performanceData), {
            diagnosticsDuration
        });
    }
    function toProtocolTextSpan(textSpan, scriptInfo) {
        return {
            start: scriptInfo.positionToLineOffset(textSpan.start),
            end: scriptInfo.positionToLineOffset(textSpanEnd(textSpan))
        };
    }
    function toProtocolTextSpanWithContext(span, contextSpan, scriptInfo) {
        const textSpan = toProtocolTextSpan(span, scriptInfo);
        const contextTextSpan = contextSpan && toProtocolTextSpan(contextSpan, scriptInfo);
        return contextTextSpan ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, textSpan), {
            contextStart: contextTextSpan.start,
            contextEnd: contextTextSpan.end
        }) : textSpan;
    }
    function convertTextChangeToCodeEdit(change, scriptInfo) {
        return {
            start: positionToLineOffset(scriptInfo, change.span.start),
            end: positionToLineOffset(scriptInfo, textSpanEnd(change.span)),
            newText: change.newText
        };
    }
    function positionToLineOffset(info, position) {
        return isConfigFile(info) ? locationFromLineAndCharacter(info.getLineAndCharacterOfPosition(position)) : info.positionToLineOffset(position);
    }
    function convertLinkedEditInfoToRanges(linkedEdit, scriptInfo) {
        const ranges = linkedEdit.ranges.map((r)=>{
            return {
                start: scriptInfo.positionToLineOffset(r.start),
                end: scriptInfo.positionToLineOffset(r.start + r.length)
            };
        });
        if (!linkedEdit.wordPattern) return {
            ranges
        };
        return {
            ranges,
            wordPattern: linkedEdit.wordPattern
        };
    }
    function locationFromLineAndCharacter(lc) {
        return {
            line: lc.line + 1,
            offset: lc.character + 1
        };
    }
    function convertNewFileTextChangeToCodeEdit(textChanges2) {
        Debug.assert(textChanges2.textChanges.length === 1);
        const change = first(textChanges2.textChanges);
        Debug.assert(change.span.start === 0 && change.span.length === 0);
        return {
            fileName: textChanges2.fileName,
            textChanges: [
                {
                    start: {
                        line: 0,
                        offset: 0
                    },
                    end: {
                        line: 0,
                        offset: 0
                    },
                    newText: change.newText
                }
            ]
        };
    }
    function getLocationInNewDocument(oldText, renameFilename, renameLocation, edits) {
        const newText = applyEdits(oldText, renameFilename, edits);
        const { line, character } = computeLineAndCharacterOfPosition(computeLineStarts(newText), renameLocation);
        return {
            line: line + 1,
            offset: character + 1
        };
    }
    function applyEdits(text, textFilename, edits) {
        for (const { fileName, textChanges: textChanges2 } of edits){
            if (fileName !== textFilename) continue;
            for(let i = textChanges2.length - 1; i >= 0; i--){
                const { newText, span: { start, length: length2 } } = textChanges2[i];
                text = text.slice(0, start) + newText + text.slice(start + length2);
            }
        }
        return text;
    }
    function referenceEntryToReferencesResponseItem(projectService, { fileName, textSpan, contextSpan, isWriteAccess: isWriteAccess2, isDefinition }, { disableLineTextInReferences }) {
        const scriptInfo = Debug.checkDefined(projectService.getScriptInfo(fileName));
        const span = toProtocolTextSpanWithContext(textSpan, contextSpan, scriptInfo);
        const lineText = disableLineTextInReferences ? void 0 : getLineText(scriptInfo, span);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            file: fileName
        }, span), {
            lineText,
            isWriteAccess: isWriteAccess2,
            isDefinition
        });
    }
    function getLineText(scriptInfo, span) {
        const lineSpan = scriptInfo.lineToTextSpan(span.start.line - 1);
        return scriptInfo.getSnapshot().getText(lineSpan.start, textSpanEnd(lineSpan)).replace(/\r|\n/g, "");
    }
    function isCompletionEntryData(data) {
        return data === void 0 || data && typeof data === "object" && typeof data.exportName === "string" && (data.fileName === void 0 || typeof data.fileName === "string") && (data.ambientModuleName === void 0 || typeof data.ambientModuleName === "string" && (data.isPackageJsonImport === void 0 || typeof data.isPackageJsonImport === "boolean"));
    }
    // src/server/scriptVersionCache.ts
    var lineCollectionCapacity = 4;
    var CharRangeSection = /* @__PURE__ */ ((CharRangeSection2)=>{
        CharRangeSection2[CharRangeSection2["PreStart"] = 0] = "PreStart";
        CharRangeSection2[CharRangeSection2["Start"] = 1] = "Start";
        CharRangeSection2[CharRangeSection2["Entire"] = 2] = "Entire";
        CharRangeSection2[CharRangeSection2["Mid"] = 3] = "Mid";
        CharRangeSection2[CharRangeSection2["End"] = 4] = "End";
        CharRangeSection2[CharRangeSection2["PostEnd"] = 5] = "PostEnd";
        return CharRangeSection2;
    })(CharRangeSection || {});
    var EditWalker = class {
        get done() {
            return false;
        }
        insertLines(insertedText, suppressTrailingText) {
            if (suppressTrailingText) this.trailingText = "";
            if (insertedText) insertedText = this.initialText + insertedText + this.trailingText;
            else insertedText = this.initialText + this.trailingText;
            const lm = LineIndex.linesFromText(insertedText);
            const lines = lm.lines;
            if (lines.length > 1 && lines[lines.length - 1] === "") lines.pop();
            let branchParent;
            let lastZeroCount;
            for(let k = this.endBranch.length - 1; k >= 0; k--){
                this.endBranch[k].updateCounts();
                if (this.endBranch[k].charCount() === 0) {
                    lastZeroCount = this.endBranch[k];
                    if (k > 0) branchParent = this.endBranch[k - 1];
                    else branchParent = this.branchNode;
                }
            }
            if (lastZeroCount) branchParent.remove(lastZeroCount);
            const leafNode = this.startPath[this.startPath.length - 1];
            if (lines.length > 0) {
                leafNode.text = lines[0];
                if (lines.length > 1) {
                    let insertedNodes = new Array(lines.length - 1);
                    let startNode2 = leafNode;
                    for(let i = 1; i < lines.length; i++)insertedNodes[i - 1] = new LineLeaf(lines[i]);
                    let pathIndex = this.startPath.length - 2;
                    while(pathIndex >= 0){
                        const insertionNode = this.startPath[pathIndex];
                        insertedNodes = insertionNode.insertAt(startNode2, insertedNodes);
                        pathIndex--;
                        startNode2 = insertionNode;
                    }
                    let insertedNodesLen = insertedNodes.length;
                    while(insertedNodesLen > 0){
                        const newRoot = new LineNode();
                        newRoot.add(this.lineIndex.root);
                        insertedNodes = newRoot.insertAt(this.lineIndex.root, insertedNodes);
                        insertedNodesLen = insertedNodes.length;
                        this.lineIndex.root = newRoot;
                    }
                    this.lineIndex.root.updateCounts();
                } else for(let j = this.startPath.length - 2; j >= 0; j--)this.startPath[j].updateCounts();
            } else {
                const insertionNode = this.startPath[this.startPath.length - 2];
                insertionNode.remove(leafNode);
                for(let j = this.startPath.length - 2; j >= 0; j--)this.startPath[j].updateCounts();
            }
            return this.lineIndex;
        }
        post(_relativeStart, _relativeLength, lineCollection) {
            if (lineCollection === this.lineCollectionAtBranch) this.state = 4 /* End */ ;
            this.stack.pop();
        }
        pre(_relativeStart, _relativeLength, lineCollection, _parent, nodeType) {
            const currentNode = this.stack[this.stack.length - 1];
            if (this.state === 2 /* Entire */  && nodeType === 1 /* Start */ ) {
                this.state = 1 /* Start */ ;
                this.branchNode = currentNode;
                this.lineCollectionAtBranch = lineCollection;
            }
            let child;
            function fresh(node) {
                if (node.isLeaf()) return new LineLeaf("");
                else return new LineNode();
            }
            switch(nodeType){
                case 0 /* PreStart */ :
                    this.goSubtree = false;
                    if (this.state !== 4 /* End */ ) currentNode.add(lineCollection);
                    break;
                case 1 /* Start */ :
                    if (this.state === 4 /* End */ ) this.goSubtree = false;
                    else {
                        child = fresh(lineCollection);
                        currentNode.add(child);
                        this.startPath.push(child);
                    }
                    break;
                case 2 /* Entire */ :
                    if (this.state !== 4 /* End */ ) {
                        child = fresh(lineCollection);
                        currentNode.add(child);
                        this.startPath.push(child);
                    } else if (!lineCollection.isLeaf()) {
                        child = fresh(lineCollection);
                        currentNode.add(child);
                        this.endBranch.push(child);
                    }
                    break;
                case 3 /* Mid */ :
                    this.goSubtree = false;
                    break;
                case 4 /* End */ :
                    if (this.state !== 4 /* End */ ) this.goSubtree = false;
                    else if (!lineCollection.isLeaf()) {
                        child = fresh(lineCollection);
                        currentNode.add(child);
                        this.endBranch.push(child);
                    }
                    break;
                case 5 /* PostEnd */ :
                    this.goSubtree = false;
                    if (this.state !== 1 /* Start */ ) currentNode.add(lineCollection);
                    break;
            }
            if (this.goSubtree) this.stack.push(child);
        }
        // just gather text from the leaves
        leaf(relativeStart, relativeLength, ll) {
            if (this.state === 1 /* Start */ ) this.initialText = ll.text.substring(0, relativeStart);
            else if (this.state === 2 /* Entire */ ) {
                this.initialText = ll.text.substring(0, relativeStart);
                this.trailingText = ll.text.substring(relativeStart + relativeLength);
            } else this.trailingText = ll.text.substring(relativeStart + relativeLength);
        }
        constructor(){
            this.goSubtree = true;
            this.lineIndex = new LineIndex();
            this.endBranch = [];
            this.state = 2 /* Entire */ ;
            this.initialText = "";
            this.trailingText = "";
            this.lineIndex.root = new LineNode();
            this.startPath = [
                this.lineIndex.root
            ];
            this.stack = [
                this.lineIndex.root
            ];
        }
    };
    var TextChange9 = class {
        getTextChangeRange() {
            return createTextChangeRange(createTextSpan(this.pos, this.deleteLen), this.insertedText ? this.insertedText.length : 0);
        }
        constructor(pos, deleteLen, insertedText){
            this.pos = pos;
            this.deleteLen = deleteLen;
            this.insertedText = insertedText;
        }
    };
    var _ScriptVersionCache = class _ScriptVersionCache {
        versionToIndex(version2) {
            if (version2 < this.minVersion || version2 > this.currentVersion) return void 0;
            return version2 % _ScriptVersionCache.maxVersions;
        }
        currentVersionToIndex() {
            return this.currentVersion % _ScriptVersionCache.maxVersions;
        }
        // REVIEW: can optimize by coalescing simple edits
        edit(pos, deleteLen, insertedText) {
            this.changes.push(new TextChange9(pos, deleteLen, insertedText));
            if (this.changes.length > _ScriptVersionCache.changeNumberThreshold || deleteLen > _ScriptVersionCache.changeLengthThreshold || insertedText && insertedText.length > _ScriptVersionCache.changeLengthThreshold) this.getSnapshot();
        }
        getSnapshot() {
            return this._getSnapshot();
        }
        _getSnapshot() {
            let snap = this.versions[this.currentVersionToIndex()];
            if (this.changes.length > 0) {
                let snapIndex = snap.index;
                for (const change of this.changes)snapIndex = snapIndex.edit(change.pos, change.deleteLen, change.insertedText);
                snap = new LineIndexSnapshot(this.currentVersion + 1, this, snapIndex, this.changes);
                this.currentVersion = snap.version;
                this.versions[this.currentVersionToIndex()] = snap;
                this.changes = [];
                if (this.currentVersion - this.minVersion >= _ScriptVersionCache.maxVersions) this.minVersion = this.currentVersion - _ScriptVersionCache.maxVersions + 1;
            }
            return snap;
        }
        getSnapshotVersion() {
            return this._getSnapshot().version;
        }
        getAbsolutePositionAndLineText(oneBasedLine) {
            return this._getSnapshot().index.lineNumberToInfo(oneBasedLine);
        }
        lineOffsetToPosition(line, column) {
            return this._getSnapshot().index.absolutePositionOfStartOfLine(line) + (column - 1);
        }
        positionToLineOffset(position) {
            return this._getSnapshot().index.positionToLineOffset(position);
        }
        lineToTextSpan(line) {
            const index = this._getSnapshot().index;
            const { lineText, absolutePosition } = index.lineNumberToInfo(line + 1);
            const len = lineText !== void 0 ? lineText.length : index.absolutePositionOfStartOfLine(line + 2) - absolutePosition;
            return createTextSpan(absolutePosition, len);
        }
        getTextChangesBetweenVersions(oldVersion, newVersion) {
            if (oldVersion < newVersion) {
                if (oldVersion >= this.minVersion) {
                    const textChangeRanges = [];
                    for(let i = oldVersion + 1; i <= newVersion; i++){
                        const snap = this.versions[this.versionToIndex(i)];
                        for (const textChange of snap.changesSincePreviousVersion)textChangeRanges.push(textChange.getTextChangeRange());
                    }
                    return collapseTextChangeRangesAcrossMultipleVersions(textChangeRanges);
                } else return void 0;
            } else return unchangedTextChangeRange;
        }
        getLineCount() {
            return this._getSnapshot().index.getLineCount();
        }
        static fromString(script) {
            const svc = new _ScriptVersionCache();
            const snap = new LineIndexSnapshot(0, svc, new LineIndex());
            svc.versions[svc.currentVersion] = snap;
            const lm = LineIndex.linesFromText(script);
            snap.index.load(lm.lines);
            return svc;
        }
        constructor(){
            this.changes = [];
            this.versions = new Array(_ScriptVersionCache.maxVersions);
            this.minVersion = 0;
            // no versions earlier than min version will maintain change history
            this.currentVersion = 0;
        }
    };
    _ScriptVersionCache.changeNumberThreshold = 8;
    _ScriptVersionCache.changeLengthThreshold = 256;
    _ScriptVersionCache.maxVersions = 8;
    var ScriptVersionCache = _ScriptVersionCache;
    var LineIndexSnapshot = class _LineIndexSnapshot {
        getText(rangeStart, rangeEnd) {
            return this.index.getText(rangeStart, rangeEnd - rangeStart);
        }
        getLength() {
            return this.index.getLength();
        }
        getChangeRange(oldSnapshot) {
            if (oldSnapshot instanceof _LineIndexSnapshot && this.cache === oldSnapshot.cache) {
                if (this.version <= oldSnapshot.version) return unchangedTextChangeRange;
                else return this.cache.getTextChangesBetweenVersions(oldSnapshot.version, this.version);
            }
        }
        constructor(version2, cache, index, changesSincePreviousVersion = emptyArray2){
            this.version = version2;
            this.cache = cache;
            this.index = index;
            this.changesSincePreviousVersion = changesSincePreviousVersion;
        }
    };
    var LineIndex = class _LineIndex {
        absolutePositionOfStartOfLine(oneBasedLine) {
            return this.lineNumberToInfo(oneBasedLine).absolutePosition;
        }
        positionToLineOffset(position) {
            const { oneBasedLine, zeroBasedColumn } = this.root.charOffsetToLineInfo(1, position);
            return {
                line: oneBasedLine,
                offset: zeroBasedColumn + 1
            };
        }
        positionToColumnAndLineText(position) {
            return this.root.charOffsetToLineInfo(1, position);
        }
        getLineCount() {
            return this.root.lineCount();
        }
        lineNumberToInfo(oneBasedLine) {
            const lineCount = this.getLineCount();
            if (oneBasedLine <= lineCount) {
                const { position, leaf } = this.root.lineNumberToInfo(oneBasedLine, 0);
                return {
                    absolutePosition: position,
                    lineText: leaf && leaf.text
                };
            } else return {
                absolutePosition: this.root.charCount(),
                lineText: void 0
            };
        }
        load(lines) {
            if (lines.length > 0) {
                const leaves = [];
                for(let i = 0; i < lines.length; i++)leaves[i] = new LineLeaf(lines[i]);
                this.root = _LineIndex.buildTreeFromBottom(leaves);
            } else this.root = new LineNode();
        }
        walk(rangeStart, rangeLength, walkFns) {
            this.root.walk(rangeStart, rangeLength, walkFns);
        }
        getText(rangeStart, rangeLength) {
            let accum = "";
            if (rangeLength > 0 && rangeStart < this.root.charCount()) this.walk(rangeStart, rangeLength, {
                goSubtree: true,
                done: false,
                leaf: (relativeStart, relativeLength, ll)=>{
                    accum = accum.concat(ll.text.substring(relativeStart, relativeStart + relativeLength));
                }
            });
            return accum;
        }
        getLength() {
            return this.root.charCount();
        }
        every(f, rangeStart, rangeEnd) {
            if (!rangeEnd) rangeEnd = this.root.charCount();
            const walkFns = {
                goSubtree: true,
                done: false,
                leaf (relativeStart, relativeLength, ll) {
                    if (!f(ll, relativeStart, relativeLength)) this.done = true;
                }
            };
            this.walk(rangeStart, rangeEnd - rangeStart, walkFns);
            return !walkFns.done;
        }
        edit(pos, deleteLength, newText) {
            if (this.root.charCount() === 0) {
                Debug.assert(deleteLength === 0);
                if (newText !== void 0) {
                    this.load(_LineIndex.linesFromText(newText).lines);
                    return this;
                }
                return void 0;
            } else {
                let checkText;
                if (this.checkEdits) {
                    const source = this.getText(0, this.root.charCount());
                    checkText = source.slice(0, pos) + newText + source.slice(pos + deleteLength);
                }
                const walker = new EditWalker();
                let suppressTrailingText = false;
                if (pos >= this.root.charCount()) {
                    pos = this.root.charCount() - 1;
                    const endString = this.getText(pos, 1);
                    if (newText) newText = endString + newText;
                    else newText = endString;
                    deleteLength = 0;
                    suppressTrailingText = true;
                } else if (deleteLength > 0) {
                    const e = pos + deleteLength;
                    const { zeroBasedColumn, lineText } = this.positionToColumnAndLineText(e);
                    if (zeroBasedColumn === 0) {
                        deleteLength += lineText.length;
                        newText = newText ? newText + lineText : lineText;
                    }
                }
                this.root.walk(pos, deleteLength, walker);
                walker.insertLines(newText, suppressTrailingText);
                if (this.checkEdits) {
                    const updatedText = walker.lineIndex.getText(0, walker.lineIndex.getLength());
                    Debug.assert(checkText === updatedText, "buffer edit mismatch");
                }
                return walker.lineIndex;
            }
        }
        static buildTreeFromBottom(nodes) {
            if (nodes.length < lineCollectionCapacity) return new LineNode(nodes);
            const interiorNodes = new Array(Math.ceil(nodes.length / lineCollectionCapacity));
            let nodeIndex = 0;
            for(let i = 0; i < interiorNodes.length; i++){
                const end = Math.min(nodeIndex + lineCollectionCapacity, nodes.length);
                interiorNodes[i] = new LineNode(nodes.slice(nodeIndex, end));
                nodeIndex = end;
            }
            return this.buildTreeFromBottom(interiorNodes);
        }
        static linesFromText(text) {
            const lineMap = computeLineStarts(text);
            if (lineMap.length === 0) return {
                lines: [],
                lineMap
            };
            const lines = new Array(lineMap.length);
            const lc = lineMap.length - 1;
            for(let lmi = 0; lmi < lc; lmi++)lines[lmi] = text.substring(lineMap[lmi], lineMap[lmi + 1]);
            const endText = text.substring(lineMap[lc]);
            if (endText.length > 0) lines[lc] = endText;
            else lines.pop();
            return {
                lines,
                lineMap
            };
        }
        constructor(){
            // set this to true to check each edit for accuracy
            this.checkEdits = false;
        }
    };
    var LineNode = class _LineNode {
        isLeaf() {
            return false;
        }
        updateCounts() {
            this.totalChars = 0;
            this.totalLines = 0;
            for (const child of this.children){
                this.totalChars += child.charCount();
                this.totalLines += child.lineCount();
            }
        }
        execWalk(rangeStart, rangeLength, walkFns, childIndex, nodeType) {
            if (walkFns.pre) walkFns.pre(rangeStart, rangeLength, this.children[childIndex], this, nodeType);
            if (walkFns.goSubtree) {
                this.children[childIndex].walk(rangeStart, rangeLength, walkFns);
                if (walkFns.post) walkFns.post(rangeStart, rangeLength, this.children[childIndex], this, nodeType);
            } else walkFns.goSubtree = true;
            return walkFns.done;
        }
        skipChild(relativeStart, relativeLength, childIndex, walkFns, nodeType) {
            if (walkFns.pre && !walkFns.done) {
                walkFns.pre(relativeStart, relativeLength, this.children[childIndex], this, nodeType);
                walkFns.goSubtree = true;
            }
        }
        walk(rangeStart, rangeLength, walkFns) {
            if (this.children.length === 0) return;
            let childIndex = 0;
            let childCharCount = this.children[childIndex].charCount();
            let adjustedStart = rangeStart;
            while(adjustedStart >= childCharCount){
                this.skipChild(adjustedStart, rangeLength, childIndex, walkFns, 0 /* PreStart */ );
                adjustedStart -= childCharCount;
                childIndex++;
                childCharCount = this.children[childIndex].charCount();
            }
            if (adjustedStart + rangeLength <= childCharCount) {
                if (this.execWalk(adjustedStart, rangeLength, walkFns, childIndex, 2 /* Entire */ )) return;
            } else {
                if (this.execWalk(adjustedStart, childCharCount - adjustedStart, walkFns, childIndex, 1 /* Start */ )) return;
                let adjustedLength = rangeLength - (childCharCount - adjustedStart);
                childIndex++;
                const child = this.children[childIndex];
                childCharCount = child.charCount();
                while(adjustedLength > childCharCount){
                    if (this.execWalk(0, childCharCount, walkFns, childIndex, 3 /* Mid */ )) return;
                    adjustedLength -= childCharCount;
                    childIndex++;
                    childCharCount = this.children[childIndex].charCount();
                }
                if (adjustedLength > 0) {
                    if (this.execWalk(0, adjustedLength, walkFns, childIndex, 4 /* End */ )) return;
                }
            }
            if (walkFns.pre) {
                const clen = this.children.length;
                if (childIndex < clen - 1) for(let ej = childIndex + 1; ej < clen; ej++)this.skipChild(0, 0, ej, walkFns, 5 /* PostEnd */ );
            }
        }
        // Input position is relative to the start of this node.
        // Output line number is absolute.
        charOffsetToLineInfo(lineNumberAccumulator, relativePosition) {
            if (this.children.length === 0) return {
                oneBasedLine: lineNumberAccumulator,
                zeroBasedColumn: relativePosition,
                lineText: void 0
            };
            for (const child of this.children)if (child.charCount() > relativePosition) {
                if (child.isLeaf()) return {
                    oneBasedLine: lineNumberAccumulator,
                    zeroBasedColumn: relativePosition,
                    lineText: child.text
                };
                else return child.charOffsetToLineInfo(lineNumberAccumulator, relativePosition);
            } else {
                relativePosition -= child.charCount();
                lineNumberAccumulator += child.lineCount();
            }
            const lineCount = this.lineCount();
            if (lineCount === 0) return {
                oneBasedLine: 1,
                zeroBasedColumn: 0,
                lineText: void 0
            };
            const leaf = Debug.checkDefined(this.lineNumberToInfo(lineCount, 0).leaf);
            return {
                oneBasedLine: lineCount,
                zeroBasedColumn: leaf.charCount(),
                lineText: void 0
            };
        }
        /**
   * Input line number is relative to the start of this node.
   * Output line number is relative to the child.
   * positionAccumulator will be an absolute position once relativeLineNumber reaches 0.
   */ lineNumberToInfo(relativeOneBasedLine, positionAccumulator) {
            for (const child of this.children){
                const childLineCount = child.lineCount();
                if (childLineCount >= relativeOneBasedLine) return child.isLeaf() ? {
                    position: positionAccumulator,
                    leaf: child
                } : child.lineNumberToInfo(relativeOneBasedLine, positionAccumulator);
                else {
                    relativeOneBasedLine -= childLineCount;
                    positionAccumulator += child.charCount();
                }
            }
            return {
                position: positionAccumulator,
                leaf: void 0
            };
        }
        splitAfter(childIndex) {
            let splitNode;
            const clen = this.children.length;
            childIndex++;
            const endLength = childIndex;
            if (childIndex < clen) {
                splitNode = new _LineNode();
                while(childIndex < clen){
                    splitNode.add(this.children[childIndex]);
                    childIndex++;
                }
                splitNode.updateCounts();
            }
            this.children.length = endLength;
            return splitNode;
        }
        remove(child) {
            const childIndex = this.findChildIndex(child);
            const clen = this.children.length;
            if (childIndex < clen - 1) for(let i = childIndex; i < clen - 1; i++)this.children[i] = this.children[i + 1];
            this.children.pop();
        }
        findChildIndex(child) {
            const childIndex = this.children.indexOf(child);
            Debug.assert(childIndex !== -1);
            return childIndex;
        }
        insertAt(child, nodes) {
            let childIndex = this.findChildIndex(child);
            const clen = this.children.length;
            const nodeCount = nodes.length;
            if (clen < lineCollectionCapacity && childIndex === clen - 1 && nodeCount === 1) {
                this.add(nodes[0]);
                this.updateCounts();
                return [];
            } else {
                const shiftNode = this.splitAfter(childIndex);
                let nodeIndex = 0;
                childIndex++;
                while(childIndex < lineCollectionCapacity && nodeIndex < nodeCount){
                    this.children[childIndex] = nodes[nodeIndex];
                    childIndex++;
                    nodeIndex++;
                }
                let splitNodes = [];
                let splitNodeCount = 0;
                if (nodeIndex < nodeCount) {
                    splitNodeCount = Math.ceil((nodeCount - nodeIndex) / lineCollectionCapacity);
                    splitNodes = new Array(splitNodeCount);
                    let splitNodeIndex = 0;
                    for(let i = 0; i < splitNodeCount; i++)splitNodes[i] = new _LineNode();
                    let splitNode = splitNodes[0];
                    while(nodeIndex < nodeCount){
                        splitNode.add(nodes[nodeIndex]);
                        nodeIndex++;
                        if (splitNode.children.length === lineCollectionCapacity) {
                            splitNodeIndex++;
                            splitNode = splitNodes[splitNodeIndex];
                        }
                    }
                    for(let i = splitNodes.length - 1; i >= 0; i--)if (splitNodes[i].children.length === 0) splitNodes.pop();
                }
                if (shiftNode) splitNodes.push(shiftNode);
                this.updateCounts();
                for(let i = 0; i < splitNodeCount; i++)splitNodes[i].updateCounts();
                return splitNodes;
            }
        }
        // assume there is room for the item; return true if more room
        add(collection) {
            this.children.push(collection);
            Debug.assert(this.children.length <= lineCollectionCapacity);
        }
        charCount() {
            return this.totalChars;
        }
        lineCount() {
            return this.totalLines;
        }
        constructor(children = []){
            this.children = children;
            this.totalChars = 0;
            this.totalLines = 0;
            if (children.length) this.updateCounts();
        }
    };
    var LineLeaf = class {
        isLeaf() {
            return true;
        }
        walk(rangeStart, rangeLength, walkFns) {
            walkFns.leaf(rangeStart, rangeLength, this);
        }
        charCount() {
            return this.text.length;
        }
        lineCount() {
            return 1;
        }
        constructor(text){
            this.text = text;
        }
    };
    // src/server/typingInstallerAdapter.ts
    var _TypingsInstallerAdapter = class _TypingsInstallerAdapter {
        isKnownTypesPackageName(name) {
            var _a;
            const validationResult = ts_JsTyping_exports.validatePackageName(name);
            if (validationResult !== ts_JsTyping_exports.NameValidationResult.Ok) return false;
            if (!this.requestedRegistry) {
                this.requestedRegistry = true;
                this.installer.send({
                    kind: "typesRegistry"
                });
            }
            return !!((_a = this.typesRegistryCache) == null ? void 0 : _a.has(name));
        }
        installPackage(options) {
            this.packageInstallId++;
            const request = (0, _objectSpreadProps._)((0, _objectSpread._)({
                kind: "installPackage"
            }, options), {
                id: this.packageInstallId
            });
            const promise = new Promise((resolve, reject)=>{
                var _this_packageInstalledPromise;
                ((_this_packageInstalledPromise = this.packageInstalledPromise) !== null && _this_packageInstalledPromise !== void 0 ? _this_packageInstalledPromise : this.packageInstalledPromise = /* @__PURE__ */ new Map()).set(this.packageInstallId, {
                    resolve,
                    reject
                });
            });
            this.installer.send(request);
            return promise;
        }
        attach(projectService) {
            this.projectService = projectService;
            this.installer = this.createInstallerProcess();
        }
        onProjectClosed(p) {
            this.installer.send({
                projectName: p.getProjectName(),
                kind: "closeProject"
            });
        }
        enqueueInstallTypingsRequest(project, typeAcquisition, unresolvedImports) {
            const request = createInstallTypingsRequest(project, typeAcquisition, unresolvedImports);
            if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`TIAdapter:: Scheduling throttled operation:${stringifyIndented(request)}`);
            if (this.activeRequestCount < this.maxActiveRequestCount) this.scheduleRequest(request);
            else {
                if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`TIAdapter:: Deferring request for: ${request.projectName}`);
                this.requestQueue.enqueue(request);
                this.requestMap.set(request.projectName, request);
            }
        }
        handleMessage(response) {
            var _a, _b;
            if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`TIAdapter:: Received response:${stringifyIndented(response)}`);
            switch(response.kind){
                case EventTypesRegistry:
                    this.typesRegistryCache = new Map(Object.entries(response.typesRegistry));
                    break;
                case ActionPackageInstalled:
                    {
                        const promise = (_a = this.packageInstalledPromise) == null ? void 0 : _a.get(response.id);
                        Debug.assertIsDefined(promise, "Should find the promise for package install");
                        (_b = this.packageInstalledPromise) == null || _b.delete(response.id);
                        if (response.success) promise.resolve({
                            successMessage: response.message
                        });
                        else promise.reject(response.message);
                        this.projectService.updateTypingsForProject(response);
                        this.event(response, "setTypings");
                        break;
                    }
                case EventInitializationFailed:
                    {
                        const body = {
                            message: response.message
                        };
                        const eventName = "typesInstallerInitializationFailed";
                        this.event(body, eventName);
                        break;
                    }
                case EventBeginInstallTypes:
                    {
                        const body = {
                            eventId: response.eventId,
                            packages: response.packagesToInstall
                        };
                        const eventName = "beginInstallTypes";
                        this.event(body, eventName);
                        break;
                    }
                case EventEndInstallTypes:
                    {
                        if (this.telemetryEnabled) {
                            const body2 = {
                                telemetryEventName: "typingsInstalled",
                                payload: {
                                    installedPackages: response.packagesToInstall.join(","),
                                    installSuccess: response.installSuccess,
                                    typingsInstallerVersion: response.typingsInstallerVersion
                                }
                            };
                            const eventName2 = "telemetry";
                            this.event(body2, eventName2);
                        }
                        const body = {
                            eventId: response.eventId,
                            packages: response.packagesToInstall,
                            success: response.installSuccess
                        };
                        const eventName = "endInstallTypes";
                        this.event(body, eventName);
                        break;
                    }
                case ActionInvalidate:
                    this.projectService.updateTypingsForProject(response);
                    break;
                case ActionSet:
                    if (this.activeRequestCount > 0) this.activeRequestCount--;
                    else Debug.fail("TIAdapter:: Received too many responses");
                    while(!this.requestQueue.isEmpty()){
                        const queuedRequest = this.requestQueue.dequeue();
                        if (this.requestMap.get(queuedRequest.projectName) === queuedRequest) {
                            this.requestMap.delete(queuedRequest.projectName);
                            this.scheduleRequest(queuedRequest);
                            break;
                        }
                        if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`TIAdapter:: Skipping defunct request for: ${queuedRequest.projectName}`);
                    }
                    this.projectService.updateTypingsForProject(response);
                    this.event(response, "setTypings");
                    break;
                case ActionWatchTypingLocations:
                    this.projectService.watchTypingLocations(response);
                    break;
                default:
                    assertType(response);
            }
        }
        scheduleRequest(request) {
            if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`TIAdapter:: Scheduling request for: ${request.projectName}`);
            this.activeRequestCount++;
            this.host.setTimeout(()=>{
                if (this.logger.hasLevel(3 /* verbose */ )) this.logger.info(`TIAdapter:: Sending request:${stringifyIndented(request)}`);
                this.installer.send(request);
            }, _TypingsInstallerAdapter.requestDelayMillis, `${request.projectName}::${request.kind}`);
        }
        constructor(telemetryEnabled, logger, host, globalTypingsCacheLocation, event, maxActiveRequestCount){
            this.telemetryEnabled = telemetryEnabled;
            this.logger = logger;
            this.host = host;
            this.globalTypingsCacheLocation = globalTypingsCacheLocation;
            this.event = event;
            this.maxActiveRequestCount = maxActiveRequestCount;
            this.activeRequestCount = 0;
            this.requestQueue = createQueue();
            this.requestMap = /* @__PURE__ */ new Map();
            // Maps project name to newest requestQueue entry for that project
            /** We will lazily request the types registry on the first call to `isKnownTypesPackageName` and store it in `typesRegistryCache`. */ this.requestedRegistry = false;
            this.packageInstallId = 0;
        }
    };
    // This number is essentially arbitrary.  Processing more than one typings request
    // at a time makes sense, but having too many in the pipe results in a hang
    // (see https://github.com/nodejs/node/issues/7657).
    // It would be preferable to base our limit on the amount of space left in the
    // buffer, but we have yet to find a way to retrieve that value.
    _TypingsInstallerAdapter.requestDelayMillis = 100;
    var TypingsInstallerAdapter = _TypingsInstallerAdapter;
    // src/typescript/_namespaces/ts.server.ts
    var ts_server_exports4 = {};
    __export(ts_server_exports4, {
        ActionInvalidate: ()=>ActionInvalidate,
        ActionPackageInstalled: ()=>ActionPackageInstalled,
        ActionSet: ()=>ActionSet,
        ActionWatchTypingLocations: ()=>ActionWatchTypingLocations,
        Arguments: ()=>Arguments,
        AutoImportProviderProject: ()=>AutoImportProviderProject,
        AuxiliaryProject: ()=>AuxiliaryProject,
        CharRangeSection: ()=>CharRangeSection,
        CloseFileWatcherEvent: ()=>CloseFileWatcherEvent,
        CommandNames: ()=>CommandNames,
        ConfigFileDiagEvent: ()=>ConfigFileDiagEvent,
        ConfiguredProject: ()=>ConfiguredProject2,
        ConfiguredProjectLoadKind: ()=>ConfiguredProjectLoadKind,
        CreateDirectoryWatcherEvent: ()=>CreateDirectoryWatcherEvent,
        CreateFileWatcherEvent: ()=>CreateFileWatcherEvent,
        Errors: ()=>Errors,
        EventBeginInstallTypes: ()=>EventBeginInstallTypes,
        EventEndInstallTypes: ()=>EventEndInstallTypes,
        EventInitializationFailed: ()=>EventInitializationFailed,
        EventTypesRegistry: ()=>EventTypesRegistry,
        ExternalProject: ()=>ExternalProject,
        GcTimer: ()=>GcTimer,
        InferredProject: ()=>InferredProject2,
        LargeFileReferencedEvent: ()=>LargeFileReferencedEvent,
        LineIndex: ()=>LineIndex,
        LineLeaf: ()=>LineLeaf,
        LineNode: ()=>LineNode,
        LogLevel: ()=>LogLevel2,
        Msg: ()=>Msg,
        OpenFileInfoTelemetryEvent: ()=>OpenFileInfoTelemetryEvent,
        Project: ()=>Project2,
        ProjectInfoTelemetryEvent: ()=>ProjectInfoTelemetryEvent,
        ProjectKind: ()=>ProjectKind,
        ProjectLanguageServiceStateEvent: ()=>ProjectLanguageServiceStateEvent,
        ProjectLoadingFinishEvent: ()=>ProjectLoadingFinishEvent,
        ProjectLoadingStartEvent: ()=>ProjectLoadingStartEvent,
        ProjectService: ()=>ProjectService2,
        ProjectsUpdatedInBackgroundEvent: ()=>ProjectsUpdatedInBackgroundEvent,
        ScriptInfo: ()=>ScriptInfo,
        ScriptVersionCache: ()=>ScriptVersionCache,
        Session: ()=>Session3,
        TextStorage: ()=>TextStorage,
        ThrottledOperations: ()=>ThrottledOperations,
        TypingsInstallerAdapter: ()=>TypingsInstallerAdapter,
        allFilesAreJsOrDts: ()=>allFilesAreJsOrDts,
        allRootFilesAreJsOrDts: ()=>allRootFilesAreJsOrDts,
        asNormalizedPath: ()=>asNormalizedPath,
        convertCompilerOptions: ()=>convertCompilerOptions,
        convertFormatOptions: ()=>convertFormatOptions,
        convertScriptKindName: ()=>convertScriptKindName,
        convertTypeAcquisition: ()=>convertTypeAcquisition,
        convertUserPreferences: ()=>convertUserPreferences,
        convertWatchOptions: ()=>convertWatchOptions,
        countEachFileTypes: ()=>countEachFileTypes,
        createInstallTypingsRequest: ()=>createInstallTypingsRequest,
        createModuleSpecifierCache: ()=>createModuleSpecifierCache,
        createNormalizedPathMap: ()=>createNormalizedPathMap,
        createPackageJsonCache: ()=>createPackageJsonCache,
        createSortedArray: ()=>createSortedArray2,
        emptyArray: ()=>emptyArray2,
        findArgument: ()=>findArgument,
        formatDiagnosticToProtocol: ()=>formatDiagnosticToProtocol,
        formatMessage: ()=>formatMessage2,
        getBaseConfigFileName: ()=>getBaseConfigFileName,
        getDetailWatchInfo: ()=>getDetailWatchInfo,
        getLocationInNewDocument: ()=>getLocationInNewDocument,
        hasArgument: ()=>hasArgument,
        hasNoTypeScriptSource: ()=>hasNoTypeScriptSource,
        indent: ()=>indent2,
        isBackgroundProject: ()=>isBackgroundProject,
        isConfigFile: ()=>isConfigFile,
        isConfiguredProject: ()=>isConfiguredProject,
        isDynamicFileName: ()=>isDynamicFileName,
        isExternalProject: ()=>isExternalProject,
        isInferredProject: ()=>isInferredProject,
        isInferredProjectName: ()=>isInferredProjectName,
        isProjectDeferredClose: ()=>isProjectDeferredClose,
        makeAutoImportProviderProjectName: ()=>makeAutoImportProviderProjectName,
        makeAuxiliaryProjectName: ()=>makeAuxiliaryProjectName,
        makeInferredProjectName: ()=>makeInferredProjectName,
        maxFileSize: ()=>maxFileSize,
        maxProgramSizeForNonTsFiles: ()=>maxProgramSizeForNonTsFiles,
        normalizedPathToPath: ()=>normalizedPathToPath,
        nowString: ()=>nowString,
        nullCancellationToken: ()=>nullCancellationToken,
        nullTypingsInstaller: ()=>nullTypingsInstaller,
        protocol: ()=>ts_server_protocol_exports,
        scriptInfoIsContainedByBackgroundProject: ()=>scriptInfoIsContainedByBackgroundProject,
        scriptInfoIsContainedByDeferredClosedProject: ()=>scriptInfoIsContainedByDeferredClosedProject,
        stringifyIndented: ()=>stringifyIndented,
        toEvent: ()=>toEvent,
        toNormalizedPath: ()=>toNormalizedPath,
        tryConvertScriptKindName: ()=>tryConvertScriptKindName,
        typingsInstaller: ()=>ts_server_typingsInstaller_exports,
        updateProjectIfDirty: ()=>updateProjectIfDirty
    });
    // src/typescript/typescript.ts
    if (typeof console !== "undefined") Debug.loggingHost = {
        log (level, s) {
            switch(level){
                case 1 /* Error */ :
                    return console.error(s);
                case 2 /* Warning */ :
                    return console.warn(s);
                case 3 /* Info */ :
                    return console.log(s);
                case 4 /* Verbose */ :
                    return console.log(s);
            }
        }
    };
})({
    get exports () {
        return ts;
    },
    set exports (v){
        ts = v;
        if (module.exports) module.exports = v;
    }
}) //# sourceMappingURL=typescript.js.map
;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@swc/helpers/_/_object_without_properties":"7R2qf","7eaeaab38355d551":"iTJmG","1db20b9c0a4ee0c9":"fxZuW","7d4ad3bc1ff7a848":"fxZuW","ab76108507da6451":"fxZuW","84a2874c38c7e5af":"fxZuW","6d5608769d2f4020":"fxZuW","b057e440c079efce":"fxZuW","e778f2031f24174f":"fxZuW","2f60673b96dc4a39":"fxZuW"}],"iTJmG":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"fxZuW":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"6zixU":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6fpUT");

},{}],"9mXTm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
var _core = require("@web-noise/core");
var _reResizable = require("re-resizable");
var _react = require("react");
var _editor = require("./Editor");
var _editorDefault = parcelHelpers.interopDefault(_editor);
var _editorConfig = require("./Script/editorConfig");
var _editorConfig1 = require("./WorkletScript/editorConfig");
const ScriptNode = (props)=>{
    const { data, id, type } = props;
    const { node } = (0, _core.useAudioNode)(id) || {};
    const { updateNodeValues, updateNodeConfig } = (0, _core.useNode)(id);
    const { expression = "" } = data.values || {};
    const { size = {
        width: 560,
        height: 320
    } } = data.config || {};
    const saveExpression = (expression)=>{
        updateNodeValues({
            expression
        });
    };
    const runExpression = (expression)=>{
        node === null || node === void 0 ? void 0 : node.setValues({
            expression
        });
    };
    const [error, setError] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (!node) return;
        const onMessage = ({ data })=>{
            const { name } = data;
            switch(name){
                case "error":
                    setError(data.error.toString());
                    break;
                case "clean-error":
                    setError(null);
                    break;
            }
        };
        node.channel.addEventListener("message", onMessage);
        return ()=>{
            node.channel.removeEventListener("message", onMessage);
        };
    }, [
        node
    ]);
    const { width, height } = size;
    return (0, _jsxRuntime.jsx)((0, _core.WNNode), (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        children: (0, _jsxRuntime.jsx)((0, _reResizable.Resizable), {
            size: {
                width,
                height
            },
            minWidth: 200,
            enable: {
                top: false,
                right: true,
                bottom: true,
                left: false,
                topRight: false,
                bottomRight: true,
                bottomLeft: false,
                topLeft: false
            },
            onResizeStop: (e, direction, ref, d)=>{
                console.log(5555);
                updateNodeConfig({
                    size: {
                        width: width + d.width,
                        height: height + d.height
                    }
                });
            },
            children: (0, _jsxRuntime.jsx)((0, _editorDefault.default), {
                value: expression,
                defaultValue: type === "workletScript" ? (0, _editorConfig1.defaultValue) : (0, _editorConfig.defaultValue),
                onExecute: (expression)=>{
                    saveExpression(expression);
                    runExpression(expression);
                },
                editorTypes: type === "workletScript" ? (0, _editorConfig1.types) : (0, _editorConfig.types),
                error: error
            })
        })
    }));
};
exports.default = ScriptNode;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","react/jsx-runtime":"g1NAx","@web-noise/core":"8EHNf","re-resizable":"7k9Hb","react":"lXMxO","./Editor":"5XS6Y","./Script/editorConfig":"cIIbX","./WorkletScript/editorConfig":"wMCxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"5XS6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _core = require("@web-noise/core");
var _react = require("react");
var _useEditor = require("./useEditor");
var _useEditorDefault = parcelHelpers.interopDefault(_useEditor);
let _ = (t)=>t, t, t1, t2, t3, t4;
// loader.config({ monaco: MonacoEditor });
const EditorWrapper = (0, _styledDefault.default).div(t || (t = _`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`));
const EditorContainer = (0, _styledDefault.default).div(t1 || (t1 = _`
  height: 100%;
  width: 100%;
`));
const Section = (0, _styledDefault.default).div(t2 || (t2 = _`
  padding: 0.4rem;
  background-color: var(--leva-colors-elevation2);
`));
const Button = (0, _styledDefault.default).button(t3 || (t3 = _`
  color: var(--leva-colors-highlight3);
  background-color: var(--leva-colors-accent2);
  cursor: pointer;
  display: block;
  outline: none;
  font-size: var(--leva-fontSizes-root);
  border: none;
  appearance: none;
  font-weight: var(--leva-fontWeights-button);
  height: var(--leva-sizes-rowHeight);
  border-radius: var(--leva-radii-sm);
  width: 100%;
  font-family: var(--leva-fonts-mono);
`));
const ErrorWrapper = (0, _styledDefault.default).div(t4 || (t4 = _`
  font-family: var(--leva-fonts-mono);
  padding: 1rem;
  display: flex;
  color: ${0};
`), ({ theme })=>theme.colors.error);
const ScriptEditor = ({ value, defaultValue, error, onUpdate, editorTypes, onExecute })=>{
    const theme = (0, _core.useTheme)();
    const { ref: editorContainerRef, value: currentValue, isFocused, editor, monaco } = (0, _useEditorDefault.default)({
        value: value || defaultValue
    });
    (0, _react.useEffect)(()=>{
        if (!editor || !monaco) return;
        editorTypes && monaco.languages.typescript.typescriptDefaults.addExtraLib(editorTypes);
    }, [
        editor,
        monaco
    ]);
    (0, _react.useEffect)(()=>{
        if (!(editor && monaco && onExecute && isFocused)) return;
        editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter, ()=>{
            onExecute(editor.getValue());
        });
    }, [
        editor,
        monaco,
        onExecute,
        isFocused
    ]);
    (0, _react.useEffect)(()=>{
        if (!onUpdate || !currentValue) return;
        onUpdate(currentValue);
    }, [
        currentValue,
        onUpdate
    ]);
    return (0, _jsxRuntime.jsxs)(EditorWrapper, {
        children: [
            (0, _jsxRuntime.jsx)(EditorContainer, {
                ref: editorContainerRef
            }),
            (0, _jsxRuntime.jsxs)(Section, {
                children: [
                    (0, _jsxRuntime.jsxs)(Button, {
                        onClick: ()=>onExecute && editor && onExecute(editor.getValue()),
                        children: [
                            "Run",
                            isFocused && " (CMD + Enter)"
                        ]
                    }),
                    error && (0, _jsxRuntime.jsx)(ErrorWrapper, {
                        theme: theme,
                        children: error
                    })
                ]
            })
        ]
    });
};
exports.default = ScriptEditor;

},{"react/jsx-runtime":"g1NAx","@emotion/styled":"2Zr0D","@web-noise/core":"8EHNf","react":"lXMxO","./useEditor":"j1ssd","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j1ssd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _loader = require("@monaco-editor/loader");
var _loaderDefault = parcelHelpers.interopDefault(_loader);
var _react = require("react");
const useEditor = ({ value })=>{
    const ref = (0, _react.useRef)(null);
    const isInitialised = (0, _react.useRef)(false);
    const [currentValue, setCurrentValue] = (0, _react.useState)(value);
    const [isFocused, setIsFocused] = (0, _react.useState)(false);
    const [currentEditor, setCurrentEditor] = (0, _react.useState)(null);
    const [currentMonaco, setCurrentMonaco] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (!ref.current) return;
        (async ()=>{
            if (isInitialised.current) return;
            isInitialised.current = true;
            (0, _loaderDefault.default).config({});
            const monaco = await (0, _loaderDefault.default).init();
            monaco.languages.typescript.typescriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.ESNext,
                module: monaco.languages.typescript.ModuleKind.ESNext,
                allowNonTsExtensions: true
            });
            monaco.languages.typescript.typescriptDefaults.setDiagnosticsOptions({
                noSemanticValidation: false,
                noSyntaxValidation: false,
                diagnosticCodesToIgnore: [
                    1375,
                    2792,
                    2451
                ]
            });
            const uri = monaco.Uri.parse("file://model-" + +new Date());
            const model = monaco.editor.createModel(value || "", "typescript", uri);
            const editor = monaco.editor.create(ref.current, {
                model,
                theme: "vs-dark",
                minimap: {
                    enabled: false
                },
                scrollbar: {
                    verticalScrollbarSize: 2,
                    horizontalScrollbarSize: 2
                },
                fontSize: 10,
                automaticLayout: true
            });
            editor.onDidChangeModelContent(()=>{
                setCurrentValue(editor.getValue());
            });
            editor.onDidFocusEditorText((e)=>{
                setIsFocused(true);
            });
            editor.onDidBlurEditorText((e)=>{
                setIsFocused(false);
            });
            setCurrentMonaco(monaco);
            setCurrentEditor(editor);
        })();
        return ()=>{
            if (!ref.current) return;
            // @ts-ignore
            ref.current.innerHTML = "";
        };
    }, [
        ref
    ]);
    return {
        editor: currentEditor,
        monaco: currentMonaco,
        ref,
        value: currentValue,
        isFocused
    };
};
exports.default = useEditor;

},{"@monaco-editor/loader":"fsmuP","react":"lXMxO","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fsmuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _indexJsDefault.default));
var _indexJs = require("./loader/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"./loader/index.js":"j0Fl7","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j0Fl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rollupPluginBabelHelpersJs = require("../_virtual/_rollupPluginBabelHelpers.js");
var _stateLocal = require("state-local");
var _stateLocalDefault = parcelHelpers.interopDefault(_stateLocal);
var _indexJs = require("../config/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../validators/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _composeJs = require("../utils/compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _deepMergeJs = require("../utils/deepMerge.js");
var _deepMergeJsDefault = parcelHelpers.interopDefault(_deepMergeJs);
var _makeCancelableJs = require("../utils/makeCancelable.js");
var _makeCancelableJsDefault = parcelHelpers.interopDefault(_makeCancelableJs);
/** the local state of the module */ var _state$create = (0, _stateLocalDefault.default).create({
    config: (0, _indexJsDefault.default),
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
}), _state$create2 = (0, _rollupPluginBabelHelpersJs.slicedToArray)(_state$create, 2), getState = _state$create2[0], setState = _state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */ function config(globalConfig) {
    var _validators$config = (0, _indexJsDefault1.default).config(globalConfig), monaco = _validators$config.monaco, config = (0, _rollupPluginBabelHelpersJs.objectWithoutProperties)(_validators$config, [
        "monaco"
    ]);
    setState(function(state) {
        return {
            config: (0, _deepMergeJsDefault.default)(state.config, config),
            monaco: monaco
        };
    });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */ function init() {
    var state = getState(function(_ref) {
        var monaco = _ref.monaco, isInitialized = _ref.isInitialized, resolve = _ref.resolve;
        return {
            monaco: monaco,
            isInitialized: isInitialized,
            resolve: resolve
        };
    });
    if (!state.isInitialized) {
        setState({
            isInitialized: true
        });
        if (state.monaco) {
            state.resolve(state.monaco);
            return (0, _makeCancelableJsDefault.default)(wrapperPromise);
        }
        if (window.monaco && window.monaco.editor) {
            storeMonacoInstance(window.monaco);
            state.resolve(window.monaco);
            return (0, _makeCancelableJsDefault.default)(wrapperPromise);
        }
        (0, _composeJsDefault.default)(injectScripts, getMonacoLoaderScript)(configureLoader);
    }
    return (0, _makeCancelableJsDefault.default)(wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */ function injectScripts(script) {
    return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */ function createScript(src) {
    var script = document.createElement('script');
    return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */ function getMonacoLoaderScript(configureLoader) {
    var state = getState(function(_ref2) {
        var config = _ref2.config, reject = _ref2.reject;
        return {
            config: config,
            reject: reject
        };
    });
    var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));
    loaderScript.onload = function() {
        return configureLoader();
    };
    loaderScript.onerror = state.reject;
    return loaderScript;
}
/**
 * configures the monaco loader
 */ function configureLoader() {
    var state = getState(function(_ref3) {
        var config = _ref3.config, resolve = _ref3.resolve, reject = _ref3.reject;
        return {
            config: config,
            resolve: resolve,
            reject: reject
        };
    });
    var require1 = window.require;
    require1.config(state.config);
    require1([
        'vs/editor/editor.main'
    ], function(monaco) {
        storeMonacoInstance(monaco);
        state.resolve(monaco);
    }, function(error) {
        state.reject(error);
    });
}
/**
 * store monaco instance in local state
 */ function storeMonacoInstance(monaco) {
    if (!getState().monaco) setState({
        monaco: monaco
    });
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */ function __getMonacoInstance() {
    return getState(function(_ref4) {
        var monaco = _ref4.monaco;
        return monaco;
    });
}
var wrapperPromise = new Promise(function(resolve, reject) {
    return setState({
        resolve: resolve,
        reject: reject
    });
});
var loader = {
    config: config,
    init: init,
    __getMonacoInstance: __getMonacoInstance
};
exports.default = loader;

},{"../_virtual/_rollupPluginBabelHelpers.js":"8jTTh","state-local":"f0aad","../config/index.js":"7ZH8O","../validators/index.js":"lTtNA","../utils/compose.js":"l60dx","../utils/deepMerge.js":"8WM0R","../utils/makeCancelable.js":"01QZp","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8jTTh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayLikeToArray", ()=>_arrayLikeToArray);
parcelHelpers.export(exports, "arrayWithHoles", ()=>_arrayWithHoles);
parcelHelpers.export(exports, "defineProperty", ()=>_defineProperty);
parcelHelpers.export(exports, "iterableToArrayLimit", ()=>_iterableToArrayLimit);
parcelHelpers.export(exports, "nonIterableRest", ()=>_nonIterableRest);
parcelHelpers.export(exports, "objectSpread2", ()=>_objectSpread2);
parcelHelpers.export(exports, "objectWithoutProperties", ()=>_objectWithoutProperties);
parcelHelpers.export(exports, "objectWithoutPropertiesLoose", ()=>_objectWithoutPropertiesLoose);
parcelHelpers.export(exports, "slicedToArray", ()=>_slicedToArray);
parcelHelpers.export(exports, "unsupportedIterableToArray", ()=>_unsupportedIterableToArray);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"f0aad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
}
function curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nextArgs[_key3] = arguments[_key3];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
function isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
function isEmpty(obj) {
    return !Object.keys(obj).length;
}
function isFunction(value) {
    return typeof value === 'function';
}
function hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
function validateChanges(initial, changes) {
    if (!isObject(changes)) errorHandler('changeType');
    if (Object.keys(changes).some(function(field) {
        return !hasOwnProperty(initial, field);
    })) errorHandler('changeField');
    return changes;
}
function validateSelector(selector) {
    if (!isFunction(selector)) errorHandler('selectorType');
}
function validateHandler(handler) {
    if (!(isFunction(handler) || isObject(handler))) errorHandler('handlerType');
    if (isObject(handler) && Object.values(handler).some(function(_handler) {
        return !isFunction(_handler);
    })) errorHandler('handlersType');
}
function validateInitial(initial) {
    if (!initial) errorHandler('initialIsRequired');
    if (!isObject(initial)) errorHandler('initialType');
    if (isEmpty(initial)) errorHandler('initialContent');
}
function throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
    initialIsRequired: 'initial state is required',
    initialType: 'initial state should be an object',
    initialContent: 'initial state shouldn\'t be an empty object',
    handlerType: 'handler should be an object or a function',
    handlersType: 'all handlers should be a functions',
    selectorType: 'selector should be a function',
    changeType: 'provided value of changes should be an object',
    changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
    "default": 'an unknown error accured in `state-local` package'
};
var errorHandler = curry(throwError)(errorMessages);
var validators = {
    changes: validateChanges,
    selector: validateSelector,
    handler: validateHandler,
    initial: validateInitial
};
function create(initial) {
    var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    validators.initial(initial);
    validators.handler(handler);
    var state = {
        current: initial
    };
    var didUpdate = curry(didStateUpdate)(state, handler);
    var update = curry(updateState)(state);
    var validate = curry(validators.changes)(initial);
    var getChanges = curry(extractChanges)(state);
    function getState() {
        var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function(state) {
            return state;
        };
        validators.selector(selector);
        return selector(state.current);
    }
    function setState(causedChanges) {
        compose(didUpdate, update, validate, getChanges)(causedChanges);
    }
    return [
        getState,
        setState
    ];
}
function extractChanges(state, causedChanges) {
    return isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}
function updateState(state, changes) {
    state.current = _objectSpread2(_objectSpread2({}, state.current), changes);
    return changes;
}
function didStateUpdate(state, handler, changes) {
    isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function(field) {
        var _handler$field;
        return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
    });
    return changes;
}
var index = {
    create: create
};
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7ZH8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var config = {
    paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.52.2/min/vs'
    }
};
exports.default = config;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"lTtNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorHandler", ()=>errorHandler);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
var _curryJs = require("../utils/curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _isObjectJs = require("../utils/isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */ function validateConfig(config) {
    if (!config) errorHandler('configIsRequired');
    if (!(0, _isObjectJsDefault.default)(config)) errorHandler('configType');
    if (config.urls) {
        informAboutDeprecation();
        return {
            paths: {
                vs: config.urls.monacoBase
            }
        };
    }
    return config;
}
/**
 * logs deprecation message
 */ function informAboutDeprecation() {
    console.warn(errorMessages.deprecation);
}
function throwError(errorMessages, type) {
    throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
    configIsRequired: 'the configuration object is required',
    configType: 'the configuration object should be an object',
    "default": 'an unknown error accured in `@monaco-editor/loader` package',
    deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var errorHandler = (0, _curryJsDefault.default)(throwError)(errorMessages);
var validators = {
    config: validateConfig
};
exports.default = validators;

},{"../utils/curry.js":"awM5U","../utils/isObject.js":"54qEM","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"awM5U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function curry(fn) {
    return function curried() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args.length >= fn.length ? fn.apply(this, args) : function() {
            for(var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nextArgs[_key2] = arguments[_key2];
            return curried.apply(_this, [].concat(args, nextArgs));
        };
    };
}
exports.default = curry;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"54qEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObject(value) {
    return ({}).toString.call(value).includes('Object');
}
exports.default = isObject;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"l60dx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var compose = function compose() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(x) {
        return fns.reduceRight(function(y, f) {
            return f(y);
        }, x);
    };
};
exports.default = compose;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"8WM0R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rollupPluginBabelHelpersJs = require("../_virtual/_rollupPluginBabelHelpers.js");
function merge(target, source) {
    Object.keys(source).forEach(function(key) {
        if (source[key] instanceof Object) {
            if (target[key]) Object.assign(source[key], merge(target[key], source[key]));
        }
    });
    return (0, _rollupPluginBabelHelpersJs.objectSpread2)((0, _rollupPluginBabelHelpersJs.objectSpread2)({}, target), source);
}
exports.default = merge;

},{"../_virtual/_rollupPluginBabelHelpers.js":"8jTTh","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"01QZp":[function(require,module,exports,__globalThis) {
// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CANCELATION_MESSAGE", ()=>CANCELATION_MESSAGE);
var CANCELATION_MESSAGE = {
    type: 'cancelation',
    msg: 'operation is manually canceled'
};
function makeCancelable(promise) {
    var hasCanceled_ = false;
    var wrappedPromise = new Promise(function(resolve, reject) {
        promise.then(function(val) {
            return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve(val);
        });
        promise["catch"](reject);
    });
    return wrappedPromise.cancel = function() {
        return hasCanceled_ = true;
    }, wrappedPromise;
}
exports.default = makeCancelable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"cIIbX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>types);
parcelHelpers.export(exports, "defaultValue", ()=>defaultValue);
const types = `
  declare const ScriptSandbox: {
    onTriggered: (fn: () => void) => void;

    onUntriggered: (fn: () => void) => void;

    inputs: [AudioWorkletNode, AudioWorkletNode, AudioWorkletNode, AudioWorkletNode];

    outputs: [AudioWorkletNode, AudioWorkletNode, AudioWorkletNode, AudioWorkletNode];

    audioContext: AudioContext;
  }
`;
const defaultValue = `const { inputs, outputs, audioContext } = ScriptSandbox;`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"wMCxO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "types", ()=>types);
parcelHelpers.export(exports, "defaultValue", ()=>defaultValue);
const K_RATE_DOC_URL = "https://developer.mozilla.org/en-US/docs/Web/API/AudioParam#k-rate";
const A_RATE_DOC_URL = "https://developer.mozilla.org/en-US/docs/Web/API/AudioParam#a-rate";
const types = `
  declare const ProcessSandbox: {
    /**
     * Returns an integer that represents the ever-increasing current sample-frame of the audio block being processed
     *
     * [**AudioWorkletGlobalScope.currentFrame**](https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletGlobalScope/currentFrame)
    */
    currentFrame: number

    /**
     * Returns a double that represents the ever-increasing context time of the audio block being processed
     *
     * [**AudioWorkletGlobalScope.currentTime**](https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletGlobalScope/currentTime)
    */
    currentTime: number

    /**
     * Returns a float that represents the sample rate of the associated [BaseAudioContext](https://developer.mozilla.org/en-US/docs/Web/API/BaseAudioContext)
     *
     * [**AudioWorkletGlobalScope.sampleRate**](https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletGlobalScope/sampleRate)
    */
    sampleRate: number

    /**
     * An array of inputs connected to the node, each item of which is, in turn, an array of channels.
     *
     * *[input0, input1]*
     *
     * [**AudioWorkletProcessor.process parameters**](https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletProcessor/process#parameters)
    */
    inputs: [Float32Array[], Float32Array[]]

    /**
     * An array of outputs that is similar to the inputs parameter in structure.
     *
     * *[output0, output1, output2, output3]*
     *
     * [**AudioWorkletProcessor.process parameters**](https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletProcessor/process#parameters)
    */
    outputs: [Float32Array[], Float32Array[], Float32Array[], Float32Array[]]

    /**
     * Worklet parameters. See the doc for more info. 
     *
     * [**AudioWorkletNode.parameters**](https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletProcessor/process#parameters)
    */
    parameters: { 
        /**
         * \`A\` input
         *
         * [**a-rate**](${A_RATE_DOC_URL})
        */
        A: Float32Array; 

        /**
         * \`B\` input
         *
         * [**a-rate**](${A_RATE_DOC_URL})
        */
        B: Float32Array; 

        /**
         * \`C\` input
         *
         * [**a-rate**](${A_RATE_DOC_URL})
        */
        C: Float32Array 

        /**
         * \`X\` input
         *
         * [**k-rate**](${K_RATE_DOC_URL})
        */
        X: Float32Array 

        /**
         * \`Y\` input
         *
         * [**k-rate**](${K_RATE_DOC_URL})
        */
        Y: Float32Array 

        /**
         * \`Z\` input
         *
         * [**k-rate**](${K_RATE_DOC_URL})
        */
        Z: Float32Array 
    }
  }

`;
const defaultValue = `const { inputs, outputs, parameters } = ProcessSandbox;`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aSq5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
var _scriptNode = require("../ScriptNode");
var _scriptNodeDefault = parcelHelpers.interopDefault(_scriptNode);
const WorkletScript = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _scriptNodeDefault.default),
    name: "Worklet Script (Audio-Rate Processor)",
    description: "Executes custom JavaScript code directly in the audio rendering thread using AudioWorklet API. Processes audio at sample rate with access to audio inputs, outputs, and both audio-rate and control-rate parameters. Ideal for implementing custom DSP algorithms and high-performance audio effects.",
    info: `# Worklet Script

A high-performance audio processor that executes custom JavaScript code in the audio rendering thread, processing audio at sample rate using the AudioWorklet API.

## Purpose

- Implement custom DSP algorithms with per-sample precision
- Create unique audio effects and synthesis techniques
- Process audio with minimal latency in the audio thread
- Build performance-critical audio processors
- Utilize both audio-rate and control-rate parameter automation

## Values

- **Expression**: JavaScript code that executes in an AudioWorkletProcessor for every 128-sample block. The code has access to the ProcessSandbox API with audio inputs/outputs, parameters, and timing information. Code is transpiled and runs continuously in the audio rendering thread with built-in error handling.

## ProcessSandbox API

The code has access to a global \`ProcessSandbox\` object with:

- **inputs**: Array of 2 Float32Array[] representing audio inputs (input0, input1), each can be multi-channel
- **outputs**: Array of 4 Float32Array[] representing audio outputs (output0-3), each can be multi-channel
- **parameters**: Object with Float32Array values for automation parameters:
  - **A, B, C**: Audio-rate (a-rate) parameters - 128 values per block for sample-accurate modulation
  - **X, Y, Z**: Control-rate (k-rate) parameters - 1 value per block for efficient control signals
- **currentFrame**: Integer sample-frame counter for the audio block being processed
- **currentTime**: Double representing the current audio context time in seconds
- **sampleRate**: Float representing the audio context sample rate (typically 44100 or 48000)

## Example

\`\`\`javascript
const { inputs, outputs, parameters } = ProcessSandbox;

// Get input and output channels
const inputL = inputs[0][0]; // Left channel of first input
const inputR = inputs[0][1]; // Right channel of first input
const outputL = outputs[0][0];
const outputR = outputs[0][1];

// Get parameters
const gain = parameters.A; // a-rate: 128 values
const mix = parameters.X[0]; // k-rate: single value per block

// Process each sample
for (let i = 0; i < inputL.length; i++) {
  // Soft clipping distortion
  const distortedL = Math.tanh(inputL[i] * 3);
  const distortedR = Math.tanh(inputR[i] * 3);
  
  // Apply gain automation
  const processedL = distortedL * gain[i];
  const processedR = distortedR * gain[i];
  
  // Mix with dry signal
  outputL[i] = inputL[i] * (1 - mix) + processedL * mix;
  outputR[i] = inputR[i] * (1 - mix) + processedR * mix;
}

// Copy processed signal to additional outputs
outputs[1][0].set(outputL);
outputs[1][1].set(outputR);
\`\`\`

## Performance Tips

- Keep code efficient: aim for < 3ms per 128-sample block
- Avoid allocations and object creation in the processing loop
- Use k-rate parameters for control signals to reduce CPU usage
- Use a-rate parameters only when sample-accurate automation is needed
- Leverage typed array operations for best performance`,
    tags: [
        "worklet",
        "dsp",
        "sample-rate",
        "audio-thread",
        "performance",
        "synthesis",
        "effects"
    ],
    portsDescription: {
        inputs: {
            input0: "First audio input (stereo)",
            input1: "Second audio input (stereo)",
            A: "Audio-rate parameter (a-rate) - 128 values per block for sample-accurate modulation",
            B: "Audio-rate parameter (a-rate) - 128 values per block for sample-accurate modulation",
            C: "Audio-rate parameter (a-rate) - 128 values per block for sample-accurate modulation",
            X: "Control-rate parameter (k-rate) - 1 value per block for efficient control signals",
            Y: "Control-rate parameter (k-rate) - 1 value per block for efficient control signals",
            Z: "Control-rate parameter (k-rate) - 1 value per block for efficient control signals"
        },
        outputs: {
            output0: "First audio output (stereo)",
            output1: "Second audio output (stereo)",
            output2: "Third audio output (stereo)",
            output3: "Fourth audio output (stereo)"
        }
    }
});
exports.default = WorkletScript;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","./base":"dCLFF","../ScriptNode":"9mXTm","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"dCLFF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const WorkletScript = {
    type: "workletScript",
    audioNode: (0, _audioNodeDefault.default),
    node: null
};
exports.default = WorkletScript;

},{"./audioNode":"j19ZC","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"j19ZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("@web-noise/core/constants");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const sciptNodeWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/scriptNodes/WorkletScript/audioNode.ts");
const scriptNode = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(sciptNodeWorklet);
    const scriptNode = new AudioWorkletNode(audioContext, "script-node-processor", {
        numberOfInputs: 2,
        numberOfOutputs: 4
    });
    scriptNode.port.start();
    const runExpression = (expression)=>{
        scriptNode.port.postMessage({
            name: "expression",
            value: expression
        });
    };
    const { expression } = (data === null || data === void 0 ? void 0 : data.values) || {};
    expression && runExpression(expression);
    const A = scriptNode.parameters.get("A");
    const B = scriptNode.parameters.get("B");
    const C = scriptNode.parameters.get("C");
    const X = scriptNode.parameters.get("X");
    const Y = scriptNode.parameters.get("Y");
    const Z = scriptNode.parameters.get("Z");
    return {
        outputs: {
            output0: {
                port: [
                    scriptNode,
                    0
                ],
                type: (0, _constants.PortType).Audio
            },
            output1: {
                port: [
                    scriptNode,
                    1
                ],
                type: (0, _constants.PortType).Audio
            },
            output2: {
                port: [
                    scriptNode,
                    2
                ],
                type: (0, _constants.PortType).Audio
            },
            output3: {
                port: [
                    scriptNode,
                    3
                ],
                type: (0, _constants.PortType).Audio
            }
        },
        inputs: {
            A: {
                port: A,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value,
                type: (0, _constants.PortType).Number
            },
            B: {
                port: B,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value,
                type: (0, _constants.PortType).Number
            },
            C: {
                port: C,
                range: [
                    C.minValue,
                    C.maxValue
                ],
                defaultValue: C.value,
                type: (0, _constants.PortType).Number
            },
            X: {
                port: X,
                range: [
                    X.minValue,
                    X.maxValue
                ],
                defaultValue: X.value,
                type: (0, _constants.PortType).Number
            },
            Y: {
                port: Y,
                range: [
                    Y.minValue,
                    Y.maxValue
                ],
                defaultValue: Y.value,
                type: (0, _constants.PortType).Number
            },
            Z: {
                port: Z,
                range: [
                    Z.minValue,
                    Z.maxValue
                ],
                defaultValue: Z.value,
                type: (0, _constants.PortType).Number
            },
            input0: {
                port: [
                    scriptNode,
                    0
                ],
                type: (0, _constants.PortType).Any
            },
            input1: {
                port: [
                    scriptNode,
                    1
                ],
                type: (0, _constants.PortType).Any
            }
        },
        channel: scriptNode.port,
        setValues: ({ expression } = {})=>expression && runExpression(expression)
    };
};
exports.default = scriptNode;

},{"@web-noise/core/constants":"36kMU","worklet:./worklet.ts":"3bvQ1","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"3bvQ1":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("ijpL5");

},{}],"8gjG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logicNodes", ()=>logicNodes);
var _notGate = require("./NotGate");
var _notGateDefault = parcelHelpers.interopDefault(_notGate);
var _andGate = require("./AndGate");
var _andGateDefault = parcelHelpers.interopDefault(_andGate);
var _orGate = require("./OrGate");
var _orGateDefault = parcelHelpers.interopDefault(_orGate);
var _norGate = require("./NorGate");
var _norGateDefault = parcelHelpers.interopDefault(_norGate);
var _nandGate = require("./NandGate");
var _nandGateDefault = parcelHelpers.interopDefault(_nandGate);
var _xorGate = require("./XorGate");
var _xorGateDefault = parcelHelpers.interopDefault(_xorGate);
var _xnorGate = require("./XnorGate");
var _xnorGateDefault = parcelHelpers.interopDefault(_xnorGate);
var _implyGate = require("./ImplyGate");
var _implyGateDefault = parcelHelpers.interopDefault(_implyGate);
var _nimplyGate = require("./NimplyGate");
var _nimplyGateDefault = parcelHelpers.interopDefault(_nimplyGate);
const logicNodes = {
    components: [
        (0, _notGateDefault.default),
        (0, _andGateDefault.default),
        (0, _orGateDefault.default),
        (0, _norGateDefault.default),
        (0, _nandGateDefault.default),
        (0, _xorGateDefault.default),
        (0, _xnorGateDefault.default),
        (0, _implyGateDefault.default),
        (0, _nimplyGateDefault.default)
    ],
    name: "Logic nodes",
    description: "A Set of logic nodes"
};
exports.default = logicNodes;

},{"./NotGate":"iFPBs","./AndGate":"fVhvD","./OrGate":"7dBgH","./NorGate":"kQz5f","./NandGate":"6aZXu","./XorGate":"6DiGj","./XnorGate":"aKMqi","./ImplyGate":"8CHey","./NimplyGate":"hKfdG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iFPBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "NOT Gate",
    description: "Logical NOT gate that inverts binary signals. Outputs 1 when input is 0, and 0 when input is 1. Essential for logic inversion, signal negation, and creating complementary control signals in modular synthesis.",
    info: `# NOT Gate

A logical NOT gate (inverter) that flips the binary state of the input signal. When the input is true (1), the output becomes false (0), and vice versa. This fundamental logic operation is crucial for creating inverse control signals and building complex logic circuits.

## Purpose

- Invert gate or trigger signals
- Create complementary control signals
- Negate boolean conditions in logic chains
- Generate opposite-phase control voltages
- Build complex logic operations from basic gates
`,
    tags: [
        "logic",
        "gate",
        "not",
        "inverter",
        "boolean"
    ],
    portsDescription: {
        inputs: {
            A: "Binary input signal to be inverted (0 or 1)"
        },
        outputs: {
            Q: "Inverted output signal (1 if input is 0, 0 if input is 1)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"g2xp4","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"g2xp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "notGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"e2qtV","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"e2qtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notGate", ()=>notGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const notGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/NotGate/audioNode.ts");
const notGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(notGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "not-gate-processor");
    const A = workletNode.parameters.get((0, _types.NotGateParameters).A);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = notGate;

},{"@web-noise/core/constants":"36kMU","./types":"gWB4a","worklet:./worklet.ts":"78Cy5","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gWB4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotGateParameters", ()=>NotGateParameters);
var NotGateParameters;
(function(NotGateParameters) {
    NotGateParameters["A"] = "A";
})(NotGateParameters || (NotGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"78Cy5":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("b9iJm");

},{}],"fVhvD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "AND Gate",
    description: "Logical AND gate that outputs 1 only when all inputs are 1. Essential for combining multiple trigger conditions, creating complex gate patterns, and implementing conditional logic in modular synthesis.",
    info: `# AND Gate

A logical AND gate that performs boolean multiplication on its inputs. The output is true (1) only when all inputs are true (1). If any input is false (0), the output becomes false (0). This fundamental logic operation is crucial for combining multiple control signals and creating complex triggering conditions.

## Purpose

- Combine multiple gate or trigger signals
- Create conditional triggers that require multiple conditions
- Implement complex rhythmic patterns by gating sequences
- Build logic circuits for generative music systems
- Synchronize multiple control signals
`,
    tags: [
        "logic",
        "gate",
        "and",
        "boolean",
        "conjunction"
    ],
    portsDescription: {
        inputs: {
            A: "First binary input signal (0 or 1)",
            B: "Second binary input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (1 only when both inputs are 1, otherwise 0)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"gpNgM","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gpNgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "andGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"jPS4a","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jPS4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "andGate", ()=>andGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const andGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/AndGate/audioNode.ts");
const andGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(andGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "and-gate-processor");
    const A = workletNode.parameters.get((0, _types.AndGateParameters).A);
    const B = workletNode.parameters.get((0, _types.AndGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = andGate;

},{"@web-noise/core/constants":"36kMU","./types":"1AiD3","worklet:./worklet.ts":"05fSD","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"1AiD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AndGateParameters", ()=>AndGateParameters);
var AndGateParameters;
(function(AndGateParameters) {
    AndGateParameters["A"] = "A";
    AndGateParameters["B"] = "B";
})(AndGateParameters || (AndGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"05fSD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("5KIib");

},{}],"7dBgH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "OR Gate",
    description: "Logical OR gate that outputs 1 when at least one input is 1. Essential for combining multiple trigger sources, creating alternative gate patterns, and implementing inclusive logic conditions in modular synthesis.",
    info: `# OR Gate

A logical OR gate that performs boolean addition on its inputs. The output is true (1) when at least one input is true (1). The output is false (0) only when all inputs are false (0). This fundamental logic operation is crucial for merging multiple control signals and creating flexible triggering conditions.

## Purpose

- Merge multiple gate or trigger signals
- Create triggers from multiple alternative sources
- Implement inclusive logic conditions
- Build flexible routing for generative music systems
- Combine rhythmic patterns from different sequences
`,
    tags: [
        "logic",
        "gate",
        "or",
        "boolean",
        "disjunction"
    ],
    portsDescription: {
        inputs: {
            A: "First binary input signal (0 or 1)",
            B: "Second binary input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (1 when at least one input is 1, otherwise 0)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"2TzeW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2TzeW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "orGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"QU9hE","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"QU9hE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orGate", ()=>orGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const orGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/OrGate/audioNode.ts");
const orGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(orGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "or-gate-processor");
    const A = workletNode.parameters.get((0, _types.OrGateParameters).A);
    const B = workletNode.parameters.get((0, _types.OrGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = orGate;

},{"@web-noise/core/constants":"36kMU","./types":"fuhuB","worklet:./worklet.ts":"622jX","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fuhuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrGateParameters", ()=>OrGateParameters);
var OrGateParameters;
(function(OrGateParameters) {
    OrGateParameters["A"] = "A";
    OrGateParameters["B"] = "B";
})(OrGateParameters || (OrGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"622jX":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("1MqyC");

},{}],"kQz5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "NOR Gate",
    description: "Logical NOR gate that outputs 1 only when all inputs are 0. Outputs 0 when at least one input is 1. A universal logic gate that can be used to construct any other logic gate, essential for inverted inclusive logic in modular synthesis.",
    info: `# NOR Gate

A logical NOR (NOT-OR) gate that inverts the output of an OR gate. The output is true (1) only when all inputs are false (0). If any input is true (1), the output becomes false (0). NOR gates are considered universal gates because any other logic gate can be constructed using only NOR gates.

## Purpose

- Create inverted merged trigger signals
- Build complex logic circuits (NOR is universal)
- Generate complementary gate patterns from multiple inputs
- Implement "neither/nor" logic conditions
- Construct other logic gates (NOT, AND, OR, NAND, XOR) from NOR gates
`,
    tags: [
        "logic",
        "gate",
        "nor",
        "boolean"
    ],
    portsDescription: {
        inputs: {
            A: "First binary input signal (0 or 1)",
            B: "Second binary input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (1 only when both inputs are 0, otherwise 0)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"fN4PN","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fN4PN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "norGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"40jHW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"40jHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "norGate", ()=>norGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const norGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/NorGate/audioNode.ts");
const norGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(norGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "nor-gate-processor");
    const A = workletNode.parameters.get((0, _types.NorGateParameters).A);
    const B = workletNode.parameters.get((0, _types.NorGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = norGate;

},{"@web-noise/core/constants":"36kMU","./types":"DkJzq","worklet:./worklet.ts":"aVV3M","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"DkJzq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NorGateParameters", ()=>NorGateParameters);
var NorGateParameters;
(function(NorGateParameters) {
    NorGateParameters["A"] = "A";
    NorGateParameters["B"] = "B";
})(NorGateParameters || (NorGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aVV3M":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7BVzX");

},{}],"6aZXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "NAND Gate",
    description: "Logical NAND gate that outputs 0 only when all inputs are 1. Outputs 1 in all other cases. A universal logic gate that can be used to construct any other logic gate, essential for complex boolean operations in modular synthesis.",
    info: `# NAND Gate

A logical NAND (NOT-AND) gate that inverts the output of an AND gate. The output is false (0) only when all inputs are true (1). In all other cases, the output is true (1). NAND gates are considered universal gates because any other logic gate can be constructed using only NAND gates.

## Purpose

- Create inverted conditional triggers
- Build complex logic circuits (NAND is universal)
- Generate complementary gate patterns from combined inputs
- Implement "not both" logic conditions
- Construct other logic gates (NOT, AND, OR, NOR, XOR) from NAND gates
`,
    tags: [
        "logic",
        "gate",
        "nand",
        "boolean"
    ],
    portsDescription: {
        inputs: {
            A: "First binary input signal (0 or 1)",
            B: "Second binary input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (0 only when both inputs are 1, otherwise 1)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"gVU1B","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"gVU1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "nandGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"ja7QG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ja7QG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nandGate", ()=>nandGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const nandGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/NandGate/audioNode.ts");
const nandGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(nandGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "nand-gate-processor");
    const A = workletNode.parameters.get((0, _types.NandGateParameters).A);
    const B = workletNode.parameters.get((0, _types.NandGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = nandGate;

},{"@web-noise/core/constants":"36kMU","./types":"eJKrr","worklet:./worklet.ts":"6ifTG","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eJKrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NandGateParameters", ()=>NandGateParameters);
var NandGateParameters;
(function(NandGateParameters) {
    NandGateParameters["A"] = "A";
    NandGateParameters["B"] = "B";
})(NandGateParameters || (NandGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"6ifTG":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("4EoLb");

},{}],"6DiGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "XOR Gate",
    description: "Logical XOR gate that outputs 1 when inputs differ. Outputs 1 when exactly one input is 1, and 0 when both inputs are the same. Essential for creating difference detection, toggle logic, and complex rhythmic patterns in modular synthesis.",
    info: `# XOR Gate

A logical XOR (exclusive OR) gate that outputs true (1) when inputs are different. The output is true (1) when exactly one input is true (1), and false (0) when both inputs are the same (both 0 or both 1). XOR gates are fundamental for detecting changes, creating toggle behaviors, and generating complex rhythmic variations.

## Purpose

- Detect differences between two gate signals
- Create alternating or toggle patterns from triggers
- Generate complex rhythmic variations by comparing sequences
- Implement change detection logic
- Build half-adder circuits for computational synthesis
`,
    tags: [
        "logic",
        "gate",
        "xor",
        "boolean",
        "exclusive"
    ],
    portsDescription: {
        inputs: {
            A: "First binary input signal (0 or 1)",
            B: "Second binary input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (1 when inputs differ, 0 when inputs are the same)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"fNp6U","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fNp6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "xorGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"eBnGa","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"eBnGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xorGate", ()=>xorGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const xorGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/XorGate/audioNode.ts");
const xorGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(xorGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "xor-gate-processor");
    const A = workletNode.parameters.get((0, _types.XorGateParameters).A);
    const B = workletNode.parameters.get((0, _types.XorGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = xorGate;

},{"@web-noise/core/constants":"36kMU","./types":"19AIW","worklet:./worklet.ts":"2lACz","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"19AIW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XorGateParameters", ()=>XorGateParameters);
var XorGateParameters;
(function(XorGateParameters) {
    XorGateParameters["A"] = "A";
    XorGateParameters["B"] = "B";
})(XorGateParameters || (XorGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"2lACz":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("2ZjHG");

},{}],"aKMqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "XNOR Gate",
    description: "Logical XNOR gate that outputs 1 when inputs are the same. Outputs 1 when both inputs are equal (both 0 or both 1), and 0 when inputs differ. Essential for creating equivalence detection, synchronization logic, and complementary patterns in modular synthesis.",
    info: `# XNOR Gate

A logical XNOR (exclusive NOR) gate that outputs true (1) when inputs are the same. The output is true (1) when both inputs are equal (both 0 or both 1), and false (0) when inputs differ. XNOR gates are fundamental for detecting equivalence, creating synchronized behaviors, and generating complementary rhythmic patterns.

## Purpose

- Detect equivalence between two gate signals
- Create synchronized or matching patterns from triggers
- Generate complementary rhythmic variations to XOR patterns
- Implement equivalence detection logic
- Build comparator circuits for computational synthesis
`,
    tags: [
        "logic",
        "gate",
        "xnor",
        "boolean",
        "biconditional"
    ],
    portsDescription: {
        inputs: {
            A: "First binary input signal (0 or 1)",
            B: "Second binary input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (1 when inputs are the same, 0 when inputs differ)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"jPvpW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"jPvpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "xnorGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"iNDJf","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"iNDJf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xnorGate", ()=>xnorGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const xnorGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/XnorGate/audioNode.ts");
const xnorGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(xnorGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "xnor-gate-processor");
    const A = workletNode.parameters.get((0, _types.XnorGateParameters).A);
    const B = workletNode.parameters.get((0, _types.XnorGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = xnorGate;

},{"@web-noise/core/constants":"36kMU","./types":"i8MbI","worklet:./worklet.ts":"ek9hy","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"i8MbI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XnorGateParameters", ()=>XnorGateParameters);
var XnorGateParameters;
(function(XnorGateParameters) {
    XnorGateParameters["A"] = "A";
    XnorGateParameters["B"] = "B";
})(XnorGateParameters || (XnorGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"ek9hy":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aKk9y");

},{}],"8CHey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "IMPLY Gate",
    description: "Logical implication gate that outputs 0 only when A is 1 and B is 0. Implements the logic 'A implies B' (A \u2192 B), outputting 1 unless the premise is true and conclusion is false. Essential for conditional logic, causality chains, and sequential triggering in modular synthesis.",
    info: `# IMPLY Gate

A logical implication gate that implements material implication (A \u{2192} B). The output is false (0) only when A is true (1) and B is false (0). In all other cases, the output is true (1). This gate represents the logical statement "if A, then B" and is fundamental for building conditional logic and causal relationships.

## Purpose

- Implement conditional logic and "if-then" relationships
- Create causality chains where one event implies another
- Build sequential triggering patterns
- Implement logical reasoning circuits
- Generate asymmetric gate patterns based on precedence
`,
    tags: [
        "logic",
        "gate",
        "imply",
        "boolean",
        "implication"
    ],
    portsDescription: {
        inputs: {
            A: "Premise input signal (0 or 1)",
            B: "Conclusion input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (0 only when A=1 and B=0, otherwise 1)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"4e7VH","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"4e7VH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "implyGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"fOeKY","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fOeKY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implyGate", ()=>implyGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const implyGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/ImplyGate/audioNode.ts");
const implyGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(implyGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "imply-gate-processor");
    const A = workletNode.parameters.get((0, _types.ImplyGateParameters).A);
    const B = workletNode.parameters.get((0, _types.ImplyGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = implyGate;

},{"@web-noise/core/constants":"36kMU","./types":"fXCJ5","worklet:./worklet.ts":"91zO9","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"fXCJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImplyGateParameters", ()=>ImplyGateParameters);
var ImplyGateParameters;
(function(ImplyGateParameters) {
    ImplyGateParameters["A"] = "A";
    ImplyGateParameters["B"] = "B";
})(ImplyGateParameters || (ImplyGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"91zO9":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("lL0Sa");

},{}],"hKfdG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@web-noise/core");
var _base = require("./base");
var _baseDefault = parcelHelpers.interopDefault(_base);
const plugin = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _baseDefault.default)), {
    node: (0, _core.WNNode),
    name: "NIMPLY Gate",
    description: "Logical non-implication gate that outputs 1 only when A is 1 and B is 0. Implements the negation of 'A implies B', outputting 1 only when the premise is true and conclusion is false. Essential for detecting failed implications, inhibit logic, and conditional suppression in modular synthesis.",
    info: `# NIMPLY Gate

A logical non-implication gate that implements the negation of material implication \xac(A \u{2192} B), which is equivalent to A \u{2227} \xacB. The output is true (1) only when A is true (1) and B is false (0). In all other cases, the output is false (0). This gate represents when an implication fails and is useful for inhibit logic and conditional blocking.

## Purpose

- Detect when implications fail (A is true but B is false)
- Implement inhibit logic where A suppresses output unless B is false
- Create conditional blocking and gating patterns
- Build exception detection circuits
- Generate asymmetric gate patterns for advanced sequencing
`,
    tags: [
        "logic",
        "gate",
        "nimply",
        "boolean",
        "non-implication"
    ],
    portsDescription: {
        inputs: {
            A: "Premise input signal (0 or 1)",
            B: "Inhibit input signal (0 or 1)"
        },
        outputs: {
            Q: "Output signal (1 only when A=1 and B=0, otherwise 0)"
        }
    }
});
exports.default = plugin;

},{"@swc/helpers/_/_object_spread":"awBF9","@swc/helpers/_/_object_spread_props":"8JkCh","@web-noise/core":"8EHNf","./base":"71GRi","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"71GRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _audioNode = require("./audioNode");
var _audioNodeDefault = parcelHelpers.interopDefault(_audioNode);
const plugin = {
    type: "nimplyGate",
    node: null,
    audioNode: (0, _audioNodeDefault.default)
};
exports.default = plugin;

},{"./audioNode":"95z2s","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"95z2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nimplyGate", ()=>nimplyGate);
var _constants = require("@web-noise/core/constants");
var _types = require("./types");
//@ts-ignore
var _workletTs = require("worklet:./worklet.ts");
var _workletTsDefault = parcelHelpers.interopDefault(_workletTs);
const nimplyGateWorklet = new URL((0, _workletTsDefault.default), "file:///packages/base-nodes/src/logicNodes/NimplyGate/audioNode.ts");
const nimplyGate = async (audioContext, data)=>{
    await audioContext.audioWorklet.addModule(nimplyGateWorklet);
    const workletNode = new AudioWorkletNode(audioContext, "nimply-gate-processor");
    const A = workletNode.parameters.get((0, _types.NimplyGateParameters).A);
    const B = workletNode.parameters.get((0, _types.NimplyGateParameters).B);
    return {
        inputs: {
            A: {
                port: A,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ],
                defaultValue: A.value
            },
            B: {
                port: B,
                type: (0, _constants.PortType).Gate,
                range: [
                    B.minValue,
                    B.maxValue
                ],
                defaultValue: B.value
            }
        },
        outputs: {
            Q: {
                port: workletNode,
                type: (0, _constants.PortType).Gate,
                range: [
                    A.minValue,
                    A.maxValue
                ]
            }
        }
    };
};
exports.default = nimplyGate;

},{"@web-noise/core/constants":"36kMU","./types":"7R2G7","worklet:./worklet.ts":"aK41V","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"7R2G7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NimplyGateParameters", ()=>NimplyGateParameters);
var NimplyGateParameters;
(function(NimplyGateParameters) {
    NimplyGateParameters["A"] = "A";
    NimplyGateParameters["B"] = "B";
})(NimplyGateParameters || (NimplyGateParameters = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"aK41V":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("7gTmg");

},{}],"4T9jk":[function() {},{}],"dbBYK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) require("f4c877097322f78b").then(({ getCLS, getFID, getFCP, getLCP, getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
exports.default = reportWebVitals;

},{"f4c877097322f78b":"hhoyW","@parcel/transformer-js/src/esmodule-helpers.js":"avJ36"}],"hhoyW":[function(require,module,exports,__globalThis) {
module.exports = require("8359f2b752bd6a6b")(module.bundle.resolve("lbS0N")).then(()=>module.bundle.root('6A0U9'));

},{"8359f2b752bd6a6b":"jPt3H"}],"jPt3H":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
var cacheLoader = require("7ed6ff764dcc7ef");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

},{"7ed6ff764dcc7ef":"gP06T"}],"gP06T":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},["kekc3","lAK0A"], "lAK0A", "parcelRequirec6d8", {}, "./", "/web-noise/")

//# sourceMappingURL=web-noise.dafc711a.js.map
